webpackJsonp([4,5],{

/***/ "+3eL":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var errorObject_1 = __webpack_require__("WhVc");
var tryCatchTarget;
function tryCatcher() {
    try {
        return tryCatchTarget.apply(this, arguments);
    }
    catch (e) {
        errorObject_1.errorObject.e = e;
        return errorObject_1.errorObject;
    }
}
function tryCatch(fn) {
    tryCatchTarget = fn;
    return tryCatcher;
}
exports.tryCatch = tryCatch;
;
//# sourceMappingURL=tryCatch.js.map

/***/ }),

/***/ "+4ur":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var OuterSubscriber_1 = __webpack_require__("wAkD");
var subscribeToResult_1 = __webpack_require__("CURp");
/**
 * Catches errors on the observable to be handled by returning a new observable or throwing an error.
 *
 * <img src="./img/catch.png" width="100%">
 *
 * @example <caption>Continues with a different Observable when there's an error</caption>
 *
 * Observable.of(1, 2, 3, 4, 5)
 *   .map(n => {
 * 	   if (n == 4) {
 * 	     throw 'four!';
 *     }
 *	   return n;
 *   })
 *   .catch(err => Observable.of('I', 'II', 'III', 'IV', 'V'))
 *   .subscribe(x => console.log(x));
 *   // 1, 2, 3, I, II, III, IV, V
 *
 * @example <caption>Retries the caught source Observable again in case of error, similar to retry() operator</caption>
 *
 * Observable.of(1, 2, 3, 4, 5)
 *   .map(n => {
 * 	   if (n === 4) {
 * 	     throw 'four!';
 *     }
 * 	   return n;
 *   })
 *   .catch((err, caught) => caught)
 *   .take(30)
 *   .subscribe(x => console.log(x));
 *   // 1, 2, 3, 1, 2, 3, ...
 *
 * @example <caption>Throws a new error when the source Observable throws an error</caption>
 *
 * Observable.of(1, 2, 3, 4, 5)
 *   .map(n => {
 *     if (n == 4) {
 *       throw 'four!';
 *     }
 *     return n;
 *   })
 *   .catch(err => {
 *     throw 'error in source. Details: ' + err;
 *   })
 *   .subscribe(
 *     x => console.log(x),
 *     err => console.log(err)
 *   );
 *   // 1, 2, 3, error in source. Details: four!
 *
 * @param {function} selector a function that takes as arguments `err`, which is the error, and `caught`, which
 *  is the source observable, in case you'd like to "retry" that observable by returning it again. Whatever observable
 *  is returned by the `selector` will be used to continue the observable chain.
 * @return {Observable} An observable that originates from either the source or the observable returned by the
 *  catch `selector` function.
 * @method catch
 * @name catch
 * @owner Observable
 */
function _catch(selector) {
    var operator = new CatchOperator(selector);
    var caught = this.lift(operator);
    return (operator.caught = caught);
}
exports._catch = _catch;
var CatchOperator = (function () {
    function CatchOperator(selector) {
        this.selector = selector;
    }
    CatchOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new CatchSubscriber(subscriber, this.selector, this.caught));
    };
    return CatchOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var CatchSubscriber = (function (_super) {
    __extends(CatchSubscriber, _super);
    function CatchSubscriber(destination, selector, caught) {
        _super.call(this, destination);
        this.selector = selector;
        this.caught = caught;
    }
    // NOTE: overriding `error` instead of `_error` because we don't want
    // to have this flag this subscriber as `isStopped`. We can mimic the
    // behavior of the RetrySubscriber (from the `retry` operator), where
    // we unsubscribe from our source chain, reset our Subscriber flags,
    // then subscribe to the selector result.
    CatchSubscriber.prototype.error = function (err) {
        if (!this.isStopped) {
            var result = void 0;
            try {
                result = this.selector(err, this.caught);
            }
            catch (err2) {
                _super.prototype.error.call(this, err2);
                return;
            }
            this._unsubscribeAndRecycle();
            this.add(subscribeToResult_1.subscribeToResult(this, result));
        }
    };
    return CatchSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=catch.js.map

/***/ }),

/***/ "+EXD":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Observable_1 = __webpack_require__("rCTf");
var subscribeToResult_1 = __webpack_require__("CURp");
var OuterSubscriber_1 = __webpack_require__("wAkD");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var DeferObservable = (function (_super) {
    __extends(DeferObservable, _super);
    function DeferObservable(observableFactory) {
        _super.call(this);
        this.observableFactory = observableFactory;
    }
    /**
     * Creates an Observable that, on subscribe, calls an Observable factory to
     * make an Observable for each new Observer.
     *
     * <span class="informal">Creates the Observable lazily, that is, only when it
     * is subscribed.
     * </span>
     *
     * <img src="./img/defer.png" width="100%">
     *
     * `defer` allows you to create the Observable only when the Observer
     * subscribes, and create a fresh Observable for each Observer. It waits until
     * an Observer subscribes to it, and then it generates an Observable,
     * typically with an Observable factory function. It does this afresh for each
     * subscriber, so although each subscriber may think it is subscribing to the
     * same Observable, in fact each subscriber gets its own individual
     * Observable.
     *
     * @example <caption>Subscribe to either an Observable of clicks or an Observable of interval, at random</caption>
     * var clicksOrInterval = Rx.Observable.defer(function () {
     *   if (Math.random() > 0.5) {
     *     return Rx.Observable.fromEvent(document, 'click');
     *   } else {
     *     return Rx.Observable.interval(1000);
     *   }
     * });
     * clicksOrInterval.subscribe(x => console.log(x));
     *
     * // Results in the following behavior:
     * // If the result of Math.random() is greater than 0.5 it will listen
     * // for clicks anywhere on the "document"; when document is clicked it
     * // will log a MouseEvent object to the console. If the result is less
     * // than 0.5 it will emit ascending numbers, one every second(1000ms).
     *
     * @see {@link create}
     *
     * @param {function(): SubscribableOrPromise} observableFactory The Observable
     * factory function to invoke for each Observer that subscribes to the output
     * Observable. May also return a Promise, which will be converted on the fly
     * to an Observable.
     * @return {Observable} An Observable whose Observers' subscriptions trigger
     * an invocation of the given Observable factory function.
     * @static true
     * @name defer
     * @owner Observable
     */
    DeferObservable.create = function (observableFactory) {
        return new DeferObservable(observableFactory);
    };
    DeferObservable.prototype._subscribe = function (subscriber) {
        return new DeferSubscriber(subscriber, this.observableFactory);
    };
    return DeferObservable;
}(Observable_1.Observable));
exports.DeferObservable = DeferObservable;
var DeferSubscriber = (function (_super) {
    __extends(DeferSubscriber, _super);
    function DeferSubscriber(destination, factory) {
        _super.call(this, destination);
        this.factory = factory;
        this.tryDefer();
    }
    DeferSubscriber.prototype.tryDefer = function () {
        try {
            this._callFactory();
        }
        catch (err) {
            this._error(err);
        }
    };
    DeferSubscriber.prototype._callFactory = function () {
        var result = this.factory();
        if (result) {
            this.add(subscribeToResult_1.subscribeToResult(this, result));
        }
    };
    return DeferSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=DeferObservable.js.map

/***/ }),

/***/ "+KN+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var bufferCount_1 = __webpack_require__("O/+v");
Observable_1.Observable.prototype.bufferCount = bufferCount_1.bufferCount;
//# sourceMappingURL=bufferCount.js.map

/***/ }),

/***/ "+Y2e":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subject_1 = __webpack_require__("EEr4");
var Subscriber_1 = __webpack_require__("mmVS");
var Observable_1 = __webpack_require__("rCTf");
var Subscription_1 = __webpack_require__("B00U");
var root_1 = __webpack_require__("VOfZ");
var ReplaySubject_1 = __webpack_require__("MQMf");
var tryCatch_1 = __webpack_require__("+3eL");
var errorObject_1 = __webpack_require__("WhVc");
var assign_1 = __webpack_require__("KLoZ");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var WebSocketSubject = (function (_super) {
    __extends(WebSocketSubject, _super);
    function WebSocketSubject(urlConfigOrSource, destination) {
        if (urlConfigOrSource instanceof Observable_1.Observable) {
            _super.call(this, destination, urlConfigOrSource);
        }
        else {
            _super.call(this);
            this.WebSocketCtor = root_1.root.WebSocket;
            this._output = new Subject_1.Subject();
            if (typeof urlConfigOrSource === 'string') {
                this.url = urlConfigOrSource;
            }
            else {
                // WARNING: config object could override important members here.
                assign_1.assign(this, urlConfigOrSource);
            }
            if (!this.WebSocketCtor) {
                throw new Error('no WebSocket constructor can be found');
            }
            this.destination = new ReplaySubject_1.ReplaySubject();
        }
    }
    WebSocketSubject.prototype.resultSelector = function (e) {
        return JSON.parse(e.data);
    };
    /**
     * Wrapper around the w3c-compatible WebSocket object provided by the browser.
     *
     * @example <caption>Wraps browser WebSocket</caption>
     *
     * let socket$ = Observable.webSocket('ws://localhost:8081');
     *
     * socket$.subscribe(
     *    (msg) => console.log('message received: ' + msg),
     *    (err) => console.log(err),
     *    () => console.log('complete')
     *  );
     *
     * socket$.next(JSON.stringify({ op: 'hello' }));
     *
     * @example <caption>Wraps WebSocket from nodejs-websocket (using node.js)</caption>
     *
     * import { w3cwebsocket } from 'websocket';
     *
     * let socket$ = Observable.webSocket({
     *   url: 'ws://localhost:8081',
     *   WebSocketCtor: w3cwebsocket
     * });
     *
     * socket$.subscribe(
     *    (msg) => console.log('message received: ' + msg),
     *    (err) => console.log(err),
     *    () => console.log('complete')
     *  );
     *
     * socket$.next(JSON.stringify({ op: 'hello' }));
     *
     * @param {string | WebSocketSubjectConfig} urlConfigOrSource the source of the websocket as an url or a structure defining the websocket object
     * @return {WebSocketSubject}
     * @static true
     * @name webSocket
     * @owner Observable
     */
    WebSocketSubject.create = function (urlConfigOrSource) {
        return new WebSocketSubject(urlConfigOrSource);
    };
    WebSocketSubject.prototype.lift = function (operator) {
        var sock = new WebSocketSubject(this, this.destination);
        sock.operator = operator;
        return sock;
    };
    WebSocketSubject.prototype._resetState = function () {
        this.socket = null;
        if (!this.source) {
            this.destination = new ReplaySubject_1.ReplaySubject();
        }
        this._output = new Subject_1.Subject();
    };
    // TODO: factor this out to be a proper Operator/Subscriber implementation and eliminate closures
    WebSocketSubject.prototype.multiplex = function (subMsg, unsubMsg, messageFilter) {
        var self = this;
        return new Observable_1.Observable(function (observer) {
            var result = tryCatch_1.tryCatch(subMsg)();
            if (result === errorObject_1.errorObject) {
                observer.error(errorObject_1.errorObject.e);
            }
            else {
                self.next(result);
            }
            var subscription = self.subscribe(function (x) {
                var result = tryCatch_1.tryCatch(messageFilter)(x);
                if (result === errorObject_1.errorObject) {
                    observer.error(errorObject_1.errorObject.e);
                }
                else if (result) {
                    observer.next(x);
                }
            }, function (err) { return observer.error(err); }, function () { return observer.complete(); });
            return function () {
                var result = tryCatch_1.tryCatch(unsubMsg)();
                if (result === errorObject_1.errorObject) {
                    observer.error(errorObject_1.errorObject.e);
                }
                else {
                    self.next(result);
                }
                subscription.unsubscribe();
            };
        });
    };
    WebSocketSubject.prototype._connectSocket = function () {
        var _this = this;
        var WebSocketCtor = this.WebSocketCtor;
        var observer = this._output;
        var socket = null;
        try {
            socket = this.protocol ?
                new WebSocketCtor(this.url, this.protocol) :
                new WebSocketCtor(this.url);
            this.socket = socket;
            if (this.binaryType) {
                this.socket.binaryType = this.binaryType;
            }
        }
        catch (e) {
            observer.error(e);
            return;
        }
        var subscription = new Subscription_1.Subscription(function () {
            _this.socket = null;
            if (socket && socket.readyState === 1) {
                socket.close();
            }
        });
        socket.onopen = function (e) {
            var openObserver = _this.openObserver;
            if (openObserver) {
                openObserver.next(e);
            }
            var queue = _this.destination;
            _this.destination = Subscriber_1.Subscriber.create(function (x) { return socket.readyState === 1 && socket.send(x); }, function (e) {
                var closingObserver = _this.closingObserver;
                if (closingObserver) {
                    closingObserver.next(undefined);
                }
                if (e && e.code) {
                    socket.close(e.code, e.reason);
                }
                else {
                    observer.error(new TypeError('WebSocketSubject.error must be called with an object with an error code, ' +
                        'and an optional reason: { code: number, reason: string }'));
                }
                _this._resetState();
            }, function () {
                var closingObserver = _this.closingObserver;
                if (closingObserver) {
                    closingObserver.next(undefined);
                }
                socket.close();
                _this._resetState();
            });
            if (queue && queue instanceof ReplaySubject_1.ReplaySubject) {
                subscription.add(queue.subscribe(_this.destination));
            }
        };
        socket.onerror = function (e) {
            _this._resetState();
            observer.error(e);
        };
        socket.onclose = function (e) {
            _this._resetState();
            var closeObserver = _this.closeObserver;
            if (closeObserver) {
                closeObserver.next(e);
            }
            if (e.wasClean) {
                observer.complete();
            }
            else {
                observer.error(e);
            }
        };
        socket.onmessage = function (e) {
            var result = tryCatch_1.tryCatch(_this.resultSelector)(e);
            if (result === errorObject_1.errorObject) {
                observer.error(errorObject_1.errorObject.e);
            }
            else {
                observer.next(result);
            }
        };
    };
    WebSocketSubject.prototype._subscribe = function (subscriber) {
        var _this = this;
        var source = this.source;
        if (source) {
            return source.subscribe(subscriber);
        }
        if (!this.socket) {
            this._connectSocket();
        }
        var subscription = new Subscription_1.Subscription();
        subscription.add(this._output.subscribe(subscriber));
        subscription.add(function () {
            var socket = _this.socket;
            if (_this._output.observers.length === 0) {
                if (socket && socket.readyState === 1) {
                    socket.close();
                }
                _this._resetState();
            }
        });
        return subscription;
    };
    WebSocketSubject.prototype.unsubscribe = function () {
        var _a = this, source = _a.source, socket = _a.socket;
        if (socket && socket.readyState === 1) {
            socket.close();
            this._resetState();
        }
        _super.prototype.unsubscribe.call(this);
        if (!source) {
            this.destination = new ReplaySubject_1.ReplaySubject();
        }
    };
    return WebSocketSubject;
}(Subject_1.AnonymousSubject));
exports.WebSocketSubject = WebSocketSubject;
//# sourceMappingURL=WebSocketSubject.js.map

/***/ }),

/***/ "+ayw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var multicast_1 = __webpack_require__("emOw");
var Subject_1 = __webpack_require__("EEr4");
function shareSubjectFactory() {
    return new Subject_1.Subject();
}
/**
 * Returns a new Observable that multicasts (shares) the original Observable. As long as there is at least one
 * Subscriber this Observable will be subscribed and emitting data. When all subscribers have unsubscribed it will
 * unsubscribe from the source Observable. Because the Observable is multicasting it makes the stream `hot`.
 * This is an alias for .publish().refCount().
 *
 * <img src="./img/share.png" width="100%">
 *
 * @return {Observable<T>} An Observable that upon connection causes the source Observable to emit items to its Observers.
 * @method share
 * @owner Observable
 */
function share() {
    return multicast_1.multicast.call(this, shareSubjectFactory).refCount();
}
exports.share = share;
;
//# sourceMappingURL=share.js.map

/***/ }),

/***/ "+i4q":
/***/ (function(module, exports) {

exports.config = {"status":true,"model":{"plazza":"true","title-en":"International Draughts","module":"checkers","maxLevel":20,"summary":"Rules for draughts as played in worldwide competitions.","thumbnail":"draughts-thumb3d.png","rules":"rules-draughts.html","description":"description.html","credits":"credits.html","js":["checkersbase-model.js","draughts-model.js"],"gameOptions":{"preventRepeat":true,"width":5,"height":10,"initial":{"a":[[0,0],[0,1],[0,2],[0,3],[0,4],[1,0],[1,1],[1,2],[1,3],[1,4],[2,0],[2,1],[2,2],[2,3],[2,4],[3,0],[3,1],[3,2],[3,3],[3,4]],"b":[[9,0],[9,1],[9,2],[9,3],[9,4],[8,0],[8,1],[8,2],[8,3],[8,4],[7,0],[7,1],[7,2],[7,3],[7,4],[6,0],[6,1],[6,2],[6,3],[6,4]]},"variant":{"mustMoveForwardStrict":true,"lastRowCrown":true,"captureLongestLine":true,"lastRowFactor":0.001,"captureInstantRemove":true},"uctTransposition":"state"},"levels":[{"label":"Fast","ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.5,"maxDuration":1,"isDefault":true},{"label":"Beginner","ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.5,"maxDuration":0.5,"maxNodes":100,"maxLoops":200},{"label":"Easy","ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.5,"maxDuration":1,"maxNodes":2500,"maxLoops":500},{"label":"Medium","ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.5,"maxDuration":2,"maxNodes":5500,"maxLoops":500},{"label":"Hard","ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.5,"maxDuration":5,"maxNodes":2000,"maxLoops":3500},{"label":"Expert","ai":"uct","c":0.8,"playoutDepth":0,"minVisitsExpand":1,"ignoreLeaf":false,"uncertaintyFactor":5,"propagateMultiVisits":false,"maxDuration":60,"maxNodes":15000,"maxLoops":8000}]},"view":{"js":["checkers-xd-view.js","draughts10-xd-view.js"],"xdView":true,"css":["checkersbase.css","draughts.css"],"title-en":"Draughts View","skins":[{"name":"classic3d","title":"3D Classic","3d":true,"camera":{"radius":24,"elevationAngle":65,"limitCamMoves":true,"distMax":30,"fov":35},"world":{"lightIntensity":0.7,"skyLightIntensity":0.5,"lightPosition":{"x":-15,"y":15,"z":0},"lightShadowDarkness":0.45,"ambientLightColor":8947848,"color":4686804,"fog":false},"preload":["image|/res/images/wood-chipboard-5.jpg","image|/res/xd-view/meshes/piecetop-bump.jpg","image|/res/xd-view/meshes/piecediff.jpg","image|/res/xd-view/meshes/piecetop-queen-mask.png","smoothedfilegeo|0|/res/xd-view/meshes/ring-target.js","smoothedfilegeo|0|/res/xd-view/meshes/piece-v2.js"]},{"name":"turtles3d","title":"3D Turtles","3d":true,"camera":{"radius":14,"elevationAngle":45,"limitCamMoves":true,"distMax":40},"world":{"lightIntensity":0,"skyLightIntensity":3,"fog":true,"color":3645658,"lightPosition":{"x":-5,"y":18,"z":5},"lightShadowDarkness":0.55,"ambientLightColor":4473924},"preload":["image|/res/images/wood-chipboard-5.jpg","image|/res/xd-view/meshes/turtle.png","image|/res/xd-view/meshes/star.png","image|/res/xd-view/meshes/rock.jpg","smoothedfilegeo|0|/res/xd-view/meshes/turtle-legs-smoothed.js","smoothedfilegeo|0|/res/xd-view/meshes/turtle-head-smoothed.js","smoothedfilegeo|0|/res/xd-view/meshes/turtle-tail-smoothed.js","smoothedfilegeo|0|/res/xd-view/meshes/turtle-hotel.js","smoothedfilegeo|0|/res/xd-view/meshes/turtle-house.js","smoothedfilegeo|0|/res/xd-view/meshes/rainbowflat.js","smoothedfilegeo|0|/res/xd-view/meshes/ring-target.js","smoothedfilegeo|0|/res/xd-view/meshes/rocksmoothed.js","smoothedfilegeo|0|/res/xd-view/meshes/turtle-fences.js"]},{"name":"classical","title":"Classic"},{"name":"wood0","title":"Wood"},{"name":"marble0","title":"Marble"},{"name":"green","title":"Green"}],"module":"checkers","preferredRatio":1,"switchable":true,"animateSelfMoves":false,"useNotation":true,"useShowMoves":true,"useAutoComplete":true,"defaultOptions":{"sounds":true,"notation":false,"moves":true,"autocomplete":true},"sounds":{"move1":"move1","move2":"move2","move3":"move3","move4":"move4","tac1":"tac1","tac2":"tac1","tac3":"tac1","promo":"promo","usermove":null},"visuals":{"600x600":["res/visuals/draughts-600x600-3d.jpg","res/visuals/draughts-600x600-2d.jpg"]}}}

/***/ }),

/***/ "+pb+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var map_1 = __webpack_require__("xAJs");
Observable_1.Observable.prototype.map = map_1.map;
//# sourceMappingURL=map.js.map

/***/ }),

/***/ "+rOJ":
/***/ (function(module, exports) {

exports.config = {"status":true,"model":{"plazza":"true","released":1404893076,"title-en":"Capablanca Chess","module":"chessbase","summary":"Chess on 10x8 (1920)","thumbnail":"capablanca-thumb.png","rules":{"en":"capablanca-rules.html"},"credits":{"en":"capablanca-credits.html"},"gameOptions":{"preventRepeat":true,"uctTransposition":"state","uctIgnoreLoop":false,"levelOptions":{"pieceValueFactor":1,"pieceValueRatioFactor":1,"posValueFactor":0.1,"averageDistKingFactor":-0.01,"castleFactor":0.1,"minorPiecesMovedFactor":0.1,"checkFactor":0.2,"endingKingFreedomFactor":0.01,"endingDistKingFactor":0.05,"distKingCornerFactor":0.1,"distPawnPromo1Factor":0.3,"distPawnPromo2Factor":0.1,"distPawnPromo3Factor":0.05}},"obsolete":false,"js":["base-model.js","grid-geo-model.js","capablanca-model.js"],"description":{"en":"capablanca-description.html"},"levels":[{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"easy","label":"Easy","maxNodes":1000},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"fast","label":"Fast [1sec]","maxDuration":1,"isDefault":true},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"medium","label":"Medium","maxNodes":10000,"maxDuration":10},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"strong","label":"Strong","maxNodes":20000,"maxDuration":15}]},"view":{"title-en":"Chessbase view","module":"chessbase","xdView":true,"css":["chessbase.css"],"preferredRatio":1,"useShowMoves":true,"useNotation":true,"useAutoComplete":true,"defaultOptions":{"sounds":true,"moves":true,"notation":false,"autocomplete":false},"skins":[{"name":"skin3d","title":"3D Classic","3d":true,"preload":["smoothedfilegeo|0|/res/ring-target.js","image|/res/images/cancel.png","image|/res/images/wikipedia.png","smoothedfilegeo|0|/res/fairy/pawn/pawn.js","image|/res/fairy/pawn/pawn-diffusemap.jpg","image|/res/fairy/pawn/pawn-normalmap.jpg","smoothedfilegeo|0|/res/fairy/knight/knight.js","image|/res/fairy/knight/knight-diffusemap.jpg","image|/res/fairy/knight/knight-normalmap.jpg","smoothedfilegeo|0|/res/fairy/bishop/bishop.js","image|/res/fairy/bishop/bishop-diffusemap.jpg","image|/res/fairy/bishop/bishop-normalmap.jpg","smoothedfilegeo|0|/res/fairy/queen/queen.js","image|/res/fairy/queen/queen-diffusemap.jpg","image|/res/fairy/queen/queen-normalmap.jpg","smoothedfilegeo|0|/res/fairy/king/king.js","image|/res/fairy/king/king-diffusemap.jpg","image|/res/fairy/king/king-normalmap.jpg","smoothedfilegeo|0|/res/fairy/rook/rook.js","image|/res/fairy/rook/rook-diffusemap.jpg","image|/res/fairy/rook/rook-normalmap.jpg","smoothedfilegeo|0|/res/fairy/cardinal/cardinal.js","image|/res/fairy/cardinal/cardinal-diffusemap.jpg","image|/res/fairy/cardinal/cardinal-normalmap.jpg","smoothedfilegeo|0|/res/fairy/marshall/marshall.js","image|/res/fairy/marshall/marshall-diffusemap.jpg","image|/res/fairy/marshall/marshall-normalmap.jpg"],"world":{"lightIntensity":1.3,"skyLightIntensity":1.2,"lightCastShadow":true,"fog":false,"color":4686804,"lightPosition":{"x":-9,"y":9,"z":9},"skyLightPosition":{"x":9,"y":9,"z":9},"lightShadowDarkness":0.55,"ambientLightColor":2236962},"camera":{"fov":45,"distMax":50,"radius":18,"elevationAngle":60,"elevationMin":0}},{"name":"skin2d","title":"2D Classic","3d":false,"preload":["image|/res/images/cancel.png","image|/res/images/whitebg.png","image|/res/fairy/wikipedia-fairy-sprites.png"]}],"animateSelfMoves":false,"switchable":true,"sounds":{"move1":"alq_move1","move2":"alq_move2","move3":"alq_move3","move4":"alq_move2","tac1":"alq_tac1","tac2":"alq_tac2","tac3":"alq_tac1","promo":"promo","usermove":null},"js":["base-view.js","grid-board-view.js","fairy-set-view.js","capablanca-view.js"],"visuals":{"600x600":["res/visuals/capablanca-600x600-3d.jpg","res/visuals/capablanca-600x600-2d.jpg"]}}}

/***/ }),

/***/ "+vPe":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var NeverObservable_1 = __webpack_require__("Q0je");
exports.never = NeverObservable_1.NeverObservable.create;
//# sourceMappingURL=never.js.map

/***/ }),

/***/ "+w3m":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__("mmVS");
var ArgumentOutOfRangeError_1 = __webpack_require__("8Z8y");
/**
 * Emits the single value at the specified `index` in a sequence of emissions
 * from the source Observable.
 *
 * <span class="informal">Emits only the i-th value, then completes.</span>
 *
 * <img src="./img/elementAt.png" width="100%">
 *
 * `elementAt` returns an Observable that emits the item at the specified
 * `index` in the source Observable, or a default value if that `index` is out
 * of range and the `default` argument is provided. If the `default` argument is
 * not given and the `index` is out of range, the output Observable will emit an
 * `ArgumentOutOfRangeError` error.
 *
 * @example <caption>Emit only the third click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.elementAt(2);
 * result.subscribe(x => console.log(x));
 *
 * // Results in:
 * // click 1 = nothing
 * // click 2 = nothing
 * // click 3 = MouseEvent object logged to console
 *
 * @see {@link first}
 * @see {@link last}
 * @see {@link skip}
 * @see {@link single}
 * @see {@link take}
 *
 * @throws {ArgumentOutOfRangeError} When using `elementAt(i)`, it delivers an
 * ArgumentOutOrRangeError to the Observer's `error` callback if `i < 0` or the
 * Observable has completed before emitting the i-th `next` notification.
 *
 * @param {number} index Is the number `i` for the i-th source emission that has
 * happened since the subscription, starting from the number `0`.
 * @param {T} [defaultValue] The default value returned for missing indices.
 * @return {Observable} An Observable that emits a single item, if it is found.
 * Otherwise, will emit the default value if given. If not, then emits an error.
 * @method elementAt
 * @owner Observable
 */
function elementAt(index, defaultValue) {
    return this.lift(new ElementAtOperator(index, defaultValue));
}
exports.elementAt = elementAt;
var ElementAtOperator = (function () {
    function ElementAtOperator(index, defaultValue) {
        this.index = index;
        this.defaultValue = defaultValue;
        if (index < 0) {
            throw new ArgumentOutOfRangeError_1.ArgumentOutOfRangeError;
        }
    }
    ElementAtOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new ElementAtSubscriber(subscriber, this.index, this.defaultValue));
    };
    return ElementAtOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var ElementAtSubscriber = (function (_super) {
    __extends(ElementAtSubscriber, _super);
    function ElementAtSubscriber(destination, index, defaultValue) {
        _super.call(this, destination);
        this.index = index;
        this.defaultValue = defaultValue;
    }
    ElementAtSubscriber.prototype._next = function (x) {
        if (this.index-- === 0) {
            this.destination.next(x);
            this.destination.complete();
        }
    };
    ElementAtSubscriber.prototype._complete = function () {
        var destination = this.destination;
        if (this.index >= 0) {
            if (typeof this.defaultValue !== 'undefined') {
                destination.next(this.defaultValue);
            }
            else {
                destination.error(new ArgumentOutOfRangeError_1.ArgumentOutOfRangeError);
            }
        }
        destination.complete();
    };
    return ElementAtSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=elementAt.js.map

/***/ }),

/***/ "/+4f":
/***/ (function(module, exports) {

exports.model=Model={Game:{},Board:{},Move:{}},function(){var t;Model.Game.cbConstants={MASK:65535,FLAG_MOVE:65536,FLAG_CAPTURE:131072,FLAG_STOP:262144,FLAG_SCREEN_CAPTURE:524288,FLAG_CAPTURE_KING:1048576,FLAG_CAPTURE_NO_KING:2097152};var e="undefined"!=typeof Int32Array;Model.Game.cbUseTypedArrays=e,Model.Game.cbTypedArray=function(t){if(e){var i=new Int32Array(t.length);return i.set(t),i}for(var r=[],a=t.length,n=0;n<a;n++)r.push(t[n]);return r},Model.Game.cbShortRangeGraph=function(t,e,i,r){var a=this;void 0===r&&(r=196608);for(var n={},s=0;s<t.boardSize;s++)n[s]=[],(!i||s in i)&&e.forEach(function(e){var o=t.Graph(s,e);null!=o&&(!i||o in i)&&n[s].push(a.cbTypedArray([o|r]))});return n},Model.Game.cbLongRangeGraph=function(t,e,i,r,a){var n=this;void 0!==r&&null!=r||(r=196608),a||(a=1/0);for(var s={},o=0;o<t.boardSize;o++)s[o]=[],(!i||o in i)&&e.forEach(function(e){for(var h=[],c=t.Graph(o,e),p=0;null!=c&&(!i||c in i)&&(h.push(c|r),++p!=a);)c=t.Graph(c,e);h.length>0&&s[o].push(n.cbTypedArray(h))});return s},Model.Game.cbNullGraph=function(t){for(var e={},i=0;i<t.boardSize;i++)e[i]=[];return e},Model.Game.cbAuthorGraph=function(t){for(var e={},i=0;i<t.boardSize;i++){e[i]=[];for(var r=0;r<t.boardSize;r++)e[i].push([2293760|r])}return e},Model.Game.cbMergeGraphs=function(t){for(var e=[],i=0;i<t.boardSize;i++){e[i]=[];for(var r=1;r<arguments.length;r++)e[i]=e[i].concat(arguments[r][i])}return e},Model.Game.cbGetThreatGraph=function(){function t(e,i){for(var r in s){var a=s[r];if(!(a.p.length<i.length+1)){for(var n=!0,o=0;o<i.length;o++)if(i[o]!=a.p[o]){n=!1;break}if(n){var h=a.p[i.length],c=e[h];void 0===c&&(c={e:{}},e[h]=c),a.p.length==i.length+1&&(c.t=a.t,c.ts=a.ts,c.tk=a.tk,delete s[r]),i.push(h),t(c.e,i),i.pop()}}}}var e=this;this.cbUseScreenCapture=!1,this.cbUseCaptureKing=!1,this.cbUseCaptureNoKing=!1;for(var i={1:[],"-1":[]},r=[],a=0;a<this.g.boardSize;a++)this.g.pTypes.forEach(function(t,i){t.graph[a].forEach(function(t){for(var n=[],s=0;s<t.length;s++){var o=t[s];1048576&o?(e.cbUseCaptureKing=!0,n.unshift({d:65535&o,a:a,tk:i})):2097152&o?(e.cbUseCaptureNoKing=!0,n.unshift({d:65535&o,a:a,tnk:i})):131072&o?n.unshift({d:65535&o,a:a,t:i}):262144&o?n.unshift({d:65535&o,a:a}):524288&o&&(e.cbUseScreenCapture=!0,n.unshift({d:65535&o,a:a,ts:i}))}n.length>0&&r.push(n)})});var n={};r.forEach(function(t){t.forEach(function(e,i){var r=n[e.d];void 0===r&&(r={},n[e.d]=r);for(var a=[],s=i+1;s<t.length;s++)a.push(t[s].d);a.push(e.a);var o=a.join(","),h=r[o];void 0===h&&(h={p:a,t:{},ts:{},tk:{}},r[o]=h),void 0!==e.t?h.t[e.t]=!0:void 0!==e.tk?h.tk[e.tk]=!0:void 0!==e.ts&&(h.ts[e.ts]=!0)})});for(var a=0;a<e.g.boardSize;a++){var s=n[a],o={};t(o,[]),i[1][a]=o,i[-1][a]=o}return i},Model.Game.InitGame=function(){var e=this;this.cbVar=t=this.cbDefine(),this.g.boardSize=this.cbVar.geometry.boardSize,this.g.pTypes=this.cbGetPieceTypes(),this.g.threatGraph=this.cbGetThreatGraph(),this.g.distGraph=this.cbVar.geometry.GetDistances(),this.cbPiecesCount=0,this.g.castleablePiecesCount={1:0,"-1":0};for(var i in t.pieceTypes){var r=t.pieceTypes[i];if(r.castle){(r.initial||[]).forEach(function(t){e.g.castleablePiecesCount[t.s]++})}r.initial&&(this.cbPiecesCount+=r.initial.length)}for(var a=[],i=0;i<this.cbPiecesCount;i++)a.push(i);var n=Object.keys(t.pieceTypes);this.zobrist=new JocGame.Zobrist({board:{type:"array",size:this.cbVar.geometry.boardSize,values:a},who:{values:["1","-1"]},type:{type:"array",size:this.cbPiecesCount,values:n}})},Model.Game.cbGetPieceTypes=function(){for(var t=[],e={},i=0;i<this.cbVar.geometry.boardSize;i++)e[i]=[];for(var r in this.cbVar.pieceTypes){var a=this.cbVar.pieceTypes[r];t[r]={graph:a.graph||e,abbrev:a.abbrev||"",value:a.isKing?100:a.value||1,isKing:!!a.isKing,castle:!!a.castle,epTarget:!!a.epTarget,epCatch:!!a.epCatch}}return t},Model.Board.Init=function(t){this.zSign=0},Model.Board.InitialPosition=function(i){var r=this;this.board=e?new Int16Array(i.g.boardSize):[];for(var a=0;a<i.g.boardSize;a++)this.board[a]=-1;if(this.kings={},this.pieces=[],this.ending={1:!1,"-1":!1},this.lastMove=null,i.cbVar.castle&&(this.castled={1:!1,"-1":!1}),this.zSign=i.zobrist.update(0,"who",-1),this.noCaptCount=0,this.mWho=1,i.mInitial)this.mWho=i.mInitial.turn||1,i.mInitial.pieces.forEach(function(t){var e={};for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i]);r.pieces.push(e)}),i.mInitial.lastMove&&(this.lastMove={f:i.mInitial.lastMove.f,t:i.mInitial.lastMove.t}),void 0!==i.mInitial.noCaptCount&&(this.noCaptCount=i.mInitial.noCaptCount),i.cbVar.castle&&i.mInitial.castle&&(this.castled={1:{k:!!i.mInitial.castle[1]&&!!i.mInitial.castle[1].k,q:!!i.mInitial.castle[1]&&!!i.mInitial.castle[1].q},"-1":{k:!!i.mInitial.castle[-1]&&!!i.mInitial.castle[-1].k,q:!!i.mInitial.castle[-1]&&!!i.mInitial.castle[-1].q}});else for(var n in i.cbVar.pieceTypes)for(var s=i.cbVar.pieceTypes[n],o=s.initial||[],h=0;h<o.length;h++){var c=o[h],p={s:c.s,t:parseInt(n),p:c.p,m:!1};this.pieces.push(p)}if(this.pieces.sort(function(t,e){if(t.s!=e.s)return e.s-t.s;var r=i.cbVar.pieceTypes[t.t].value||100,a=i.cbVar.pieceTypes[e.t].value||100;return r!=a?r-a:t.p-e.p}),this.pieces.forEach(function(t,e){t.i=e,r.board[t.p]=e,i.g.pTypes[t.t].isKing&&(r.kings[t.s]=t.p),r.zSign=i.zobrist.update(r.zSign,"board",e,t.p),r.zSign=i.zobrist.update(r.zSign,"type",t.t,e)}),i.mInitial&&i.mInitial.enPassant){var a=t.geometry.PosByName(i.mInitial.enPassant);if(a>=0){var l,v=t.geometry.C(a),f=t.geometry.R(a);l=1==i.mInitial.turn?t.geometry.POS(v,f-1):t.geometry.POS(v,f+1),this.epTarget={p:a,i:this.board[l]}}}},Model.Board.CopyFrom=function(t){if(e)this.board=new Int16Array(t.board.length),this.board.set(t.board);else{this.board=[];for(var i=t.board,r=i.length,a=0;a<r;a++)this.board.push(i[a])}this.pieces=[];for(var n=t.pieces.length,a=0;a<n;a++){var s=t.pieces[a];this.pieces.push({s:s.s,p:s.p,t:s.t,i:s.i,m:s.m})}this.kings={1:t.kings[1],"-1":t.kings[-1]},this.check=t.check,t.lastMove?this.lastMove={f:t.lastMove.f,t:t.lastMove.t,c:t.lastMove.c}:this.lastMove=null,this.ending={1:t.ending[1],"-1":t.ending[-1]},void 0!==t.castled&&(this.castled={1:t.castled[1],"-1":t.castled[-1]}),this.noCaptCount=t.noCaptCount,t.epTarget?this.epTarget={p:t.epTarget.p,i:t.epTarget.i}:this.epTarget=null,this.mWho=t.mWho,this.zSign=t.zSign},Model.Board.cbApplyCastle=function(t,e,i){var r=t.cbVar.castle[e.f+"/"+e.cg],a=r.r[r.r.length-1],n=this.pieces[this.board[e.cg]],s=r.k[r.k.length-1],o=this.pieces[this.board[e.f]];return i&&(this.zSign=t.zobrist.update(this.zSign,"board",n.i,e.cg),this.zSign=t.zobrist.update(this.zSign,"board",n.i,a),this.zSign=t.zobrist.update(this.zSign,"board",o.i,e.f),this.zSign=t.zobrist.update(this.zSign,"board",o.i,s)),n.p=a,n.m=!0,this.board[e.cg]=-1,o.p=s,o.m=!0,this.board[e.f]=-1,this.board[a]=n.i,this.board[s]=o.i,this.castled[n.s]=!0,this.kings[o.s]=s,[{i:n.i,f:a,t:-1},{i:o.i,f:s,t:e.f,kp:e.f,who:o.s,m:!1},{i:n.i,f:-1,t:e.cg,m:!1,cg:!1}]},Model.Board.cbQuickApply=function(t,e){if(void 0!==e.cg)return this.cbApplyCastle(t,e,!1);var i=[],r=this.board[e.f],a=this.pieces[r];if(null!=e.c){i.unshift({i:e.c,f:-1,t:this.pieces[e.c].p});var n=this.pieces[e.c];this.board[n.p]=-1,n.p=-1}var s=this.kings[a.s];return t.g.pTypes[a.t].isKing&&(this.kings[a.s]=e.t),i.unshift({i:r,f:e.t,t:e.f,kp:s,who:a.s,ty:a.t}),a.p=e.t,void 0!==e.pr&&(a.t=e.pr),this.board[e.f]=-1,this.board[e.t]=r,i},Model.Board.cbQuickUnapply=function(t,e){for(var i=0;i<e.length;i++){var r=e[i],a=this.pieces[r.i];r.f>=0&&(a.p=-1,this.board[r.f]=-1),r.t>=0&&(a.p=r.t,this.board[r.t]=r.i),void 0!==r.m&&(a.m=r.m),void 0!==r.kp&&(this.kings[r.who]=r.kp),void 0!=r.ty&&(a.t=r.ty),void 0!=r.cg&&(this.castled[a.s]=r.cg)}},Model.Board.ApplyMove=function(t,e){var i=this.pieces[this.board[e.f]];if(void 0!==e.cg)this.cbApplyCastle(t,e,!0);else{if(this.zSign=t.zobrist.update(this.zSign,"board",i.i,e.f),this.board[i.p]=-1,void 0!==e.pr&&(this.zSign=t.zobrist.update(this.zSign,"type",i.t,i.i),i.t=e.pr,this.zSign=t.zobrist.update(this.zSign,"type",i.t,i.i)),null!=e.c){var r=this.pieces[e.c];this.zSign=t.zobrist.update(this.zSign,"board",r.i,r.p),this.board[r.p]=-1,r.p=-1,r.m=!0,this.noCaptCount=0}else this.noCaptCount++;i.p=e.t,i.m=!0,this.board[e.t]=i.i,this.zSign=t.zobrist.update(this.zSign,"board",i.i,e.t),t.g.pTypes[i.t].isKing&&(this.kings[i.s]=e.t)}this.check=!!e.ck,this.lastMove={f:e.f,t:e.t,c:e.c},void 0!==e.ko&&(this.ending[i.s]=e.ko),void 0!==e.ept?this.epTarget={p:e.ept,i:i.i}:this.epTarget=null,this.zSign=t.zobrist.update(this.zSign,"who",-this.mWho),this.zSign=t.zobrist.update(this.zSign,"who",this.mWho)},Model.Board.Evaluate=function(i){function r(e){var i=1/0;for(var r in t.geometry.corners)i=Math.min(i,h.distGraph[n.kings[e]][r]);return i-Math.sqrt(h.boardSize)}var a="debug"==arguments[3],n=this;this.mEvaluation=0;var s,o=this.mWho,h=i.g;if(e)s={1:{count:new Uint8Array(h.pTypes.length),byType:{}},"-1":{count:new Uint8Array(h.pTypes.length),byType:{}}};else{s={1:{count:[],byType:{}},"-1":{count:[],byType:{}}};for(var c=0;c<h.pTypes.length;c++)s[1].count[c]=s[-1].count[c]=0}if(i.mOptions.preventRepeat&&i.GetRepeatOccurence(this)>2)return this.mFinished=!0,void(this.mWinner=i.cbOnPerpetual?o*i.cbOnPerpetual:JocGame.DRAW);for(var p={1:0,"-1":0},l={1:h.distGraph[this.kings[-1]],"-1":h.distGraph[this.kings[1]]},v={1:0,"-1":0},f={1:0,"-1":0},u={1:0,"-1":0},g={1:0,"-1":0},b={1:!1,"-1":!1},d=this.pieces,m=d.length,c=0;c<m;c++){var G=d[c];if(G.p>=0){var y=G.s,M=h.pTypes[G.t];M.isKing?b[y]=G.m:p[y]+=M.value,M.castle&&!G.m&&g[y]++,f[y]++,v[y]+=l[y][G.p],u[y]+=t.geometry.distEdge[G.p];var S=s[y];S.count[G.t]++;var k=S.byType;void 0===k[G.t]?k[G.t]=[G]:k[G.t].push(G)}}if(this.lastMove&&null!=this.lastMove.c){var G=this.pieces[this.board[this.lastMove.t]];p[-G.s]+=this.cbStaticExchangeEval(i,G.p,G.s,{piece:G})}var C={1:0,"-1":0},T={1:0,"-1":0},z={1:0,"-1":0};this.ending[1]&&(T[1]=(v[1]-Math.sqrt(h.boardSize))/f[1],t.geometry.corners&&(z[1]=r(1))),this.ending[-1]&&(T[-1]=(v[-1]-Math.sqrt(h.boardSize))/f[-1],t.geometry.corners&&(z[1]=r(-1)));var A={pieceValue:p[1]-p[-1],pieceValueRatio:(p[1]-p[-1])/(p[1]+p[-1]+1),posValue:u[1]-u[-1],averageDistKing:v[1]/f[1]-v[-1]/f[-1],check:this.check?-o:0,endingKingFreedom:C[1]-C[-1],endingDistKing:T[1]-T[-1],distKingCorner:z[1]-z[-1]};t.castle&&(A.castle=(this.castled[1]?1:b[1]?0:g[1]/(h.castleablePiecesCount[1]+1))-(this.castled[-1]?1:b[-1]?0:g[-1]/(h.castleablePiecesCount[-1]+1))),t.evaluate&&t.evaluate.call(this,i,A,s);var P=i.mOptions.levelOptions;for(var E in A){var w=A[E],R=P[E+"Factor"]||0,I=w*R;a&&console.log(E,"=",w,"*",R,"=>",I),this.mEvaluation+=I}a&&console.log("Evaluation",this.mEvaluation)},Model.Board.cbGeneratePseudoLegalMoves=function(t){function e(e,a){var n=t.cbVar.promote;if(!n)return void r.push(a);var s=n.call(i,t,e,a);if(null!=s)if(0==s.length)r.push(a);else if(1==s.length)a.pr=s[0],r.push(a);else for(var o=0;o<s.length;o++){var h=s[o];r.push({f:a.f,t:a.t,c:a.c,pr:h,ept:a.ept,ep:a.ep,a:a.a})}}for(var i=this,r=[],a=t.cbVar,n=this.mWho,s=!a.castle||this.check||this.castled[n]?null:[],o=-1,h=this.pieces.length,c=0;c<h;c++){var p=this.pieces[c];if(!(p.p<0||p.s!=n)){var l=t.g.pTypes[p.t];l.isKing&&(p.m?s=null:o=p),s&&l.castle&&!p.m&&s.push(p);var v,f;v=l.graph[p.p],f=v.length;for(var u=0;u<f;u++)for(var g=v[u],b=!1,d=g.length,m=null,G=0;G<d;G++){var y=g[G],M=65535&y,S=this.board[M];if(!(S<0)||l.epCatch&&this.epTarget&&this.epTarget.p==M){if(!(524288&y)){var k;k=S<0?this.pieces[this.epTarget.i]:this.pieces[S],!(k.s!=p.s&&131072&y)||1048576&y&&!t.g.pTypes[k.t].isKing||2097152&y&&t.g.pTypes[k.t].isKing||e(p,{f:p.p,t:M,c:k.i,a:l.abbrev,ep:S<0});break}if(b){var k=this.pieces[S];k.s!=p.s&&e(p,{f:p.p,t:M,c:k.i,a:l.abbrev});break}b=!0}else 65536&y&&0==b&&e(p,{f:p.p,t:M,c:null,a:l.abbrev,ept:null!=m&&l.epTarget?m:void 0});m=M}}}if(s)for(var c=0;c<s.length;c++){var C=s[c],T=t.cbVar.castle[o.p+"/"+C.p];if(T){for(var z=!0,u=0;u<T.r.length;u++){var A=T.r[u];if(this.board[A]>=0&&A!=o.p&&A!=C.p){z=!1;break}}if(z){for(var P=!0,u=0;u<T.k.length;u++){var A=T.k[u];if(this.board[A]>=0&&A!=C.p&&A!=o.p||this.cbGetAttackers(t,A,n).length>0){P=!1;break}}P&&r.push({f:o.p,t:T.k[T.k.length-1],c:null,cg:C.p})}}}return r},Model.Board.cbStaticExchangeEval=function(t,e,i,r){var a=0,n=this.cbGetSmallestAttacker(t,e,i);if(n){var s=this.mWho;this.mWho=n.s;var o=this.cbQuickApply(t,{f:n.p,t:e,c:r.piece.i}),h=t.g.pTypes[r.piece.t].value;r.piece=n,a=Math.max(0,h-this.cbStaticExchangeEval(t,e,-i,r)),this.cbQuickUnapply(t,o),this.mWho=s}return a},Model.Board.cbGetSmallestAttacker=function(t,e,i){var r=this.cbGetAttackers(t,e,i);if(0==r.length)return null;for(var a=1/0,n=null,s=r.length,o=0;o<s;o++){var h=r[o],c=t.g.pTypes[h.t].value;c<a&&(a=c,n=h)}return n},Model.Board.cbCollectAttackers=function(t,e,i,r){for(var a in e){var n=e[a],s=this.board[a];if(s<0)this.cbCollectAttackers(t,n.e,i,r);else{var o=this.pieces[s];o.s==-t&&(n.t&&o.t in n.t||r&&n.tk&&o.t in n.tk)&&i.push(o)}}},Model.Board.cbCollectAttackersScreen=function(t,e,i,r,a){for(var n in e){var s=e[n],o=this.board[n];if(o<0)this.cbCollectAttackersScreen(t,s.e,i,r,a);else{var h=this.pieces[o];!a&&h.s==-t&&(s.t&&h.t in s.t||r&&s.tk&&h.t in s.tk)?i.push(h):a?a&&h.s==-t&&s.ts&&h.t in s.ts&&i.push(h):this.cbCollectAttackersScreen(t,s.e,i,r,!0)}}},Model.Board.cbGetAttackers=function(t,e,i,r){var a=[];return t.cbUseScreenCapture?this.cbCollectAttackersScreen(i,t.g.threatGraph[i][e],a,r,!1):this.cbCollectAttackers(i,t.g.threatGraph[i][e],a,r),a},Model.Board.GenerateMoves=function(t){var e=this.cbGeneratePseudoLegalMoves(t);this.mMoves=[];for(var i=!0,r=this.kings[this.mWho],a=e.length,n=0;n<a;n++){var s=e[n],o=this.cbQuickApply(t,s);if(!(this.cbGetAttackers(t,this.kings[this.mWho],this.mWho,!0).length>0)){var h=this.cbGetAttackers(t,this.kings[-this.mWho],-this.mWho,!0).length>0;s.ck=h,this.mMoves.push(s),s.f!=r&&(i=!1)}this.cbQuickUnapply(t,o)}if(0==this.mMoves.length)this.mFinished=!0,this.mWinner=t.cbOnStaleMate?t.cbOnStaleMate*this.mWho:JocGame.DRAW,this.check&&(this.mWinner=-this.mWho);else if(this.ending[this.mWho]){if(!i)for(var n=0;n<this.mMoves.length;n++)this.mMoves[n].ko=!1}else if(!this.ending[this.mWho]&&i&&!this.check)for(var n=0;n<this.mMoves.length;n++)this.mMoves[n].ko=!0},Model.Board.GetSignature=function(){return this.zSign},Model.Move.Init=function(t){for(var e in t)t.hasOwnProperty(e)&&(this[e]=t[e])},Model.Move.Equals=function(t){return this.f==t.f&&this.t==t.t&&this.pr==t.pr},Model.Move.CopyFrom=function(t){this.Init(t)},Model.Move.ToString=function(e){var i=this;switch(e=e||"natural"){case"natural":return function(){var e;if(void 0!==i.cg?e=t.castle[i.f+"/"+i.cg].n:(e=i.a||"",e+=t.geometry.PosName(i.f),null==i.c?e+="-":e+="x",e+=t.geometry.PosName(i.t)),void 0!==i.pr){var r=t.pieceTypes[i.pr];r&&r.abbrev&&r.abbrev.length>0&&!r.silentPromo&&(e+="="+r.abbrev)}return i.ck&&(e+="+"),e}();case"engine":return function(){var e=t.geometry.PosName(i.f)+t.geometry.PosName(i.t);if(void 0!=i.pr){var r=t.pieceTypes[i.pr];r&&r.abbrev&&r.abbrev.length>0&&!r.silentPromo&&(e+=r.abbrev)}return e}();default:return"??"}},Model.Board.CompactMoveString=function(e,i,r){"function"!=typeof i.ToString&&(i=e.CreateMove(i));var a=i.ToString(),n=/^([A-Z]?)([a-z])([1-9][0-9]*)([-x])([a-z])([1-9][0-9]*)(.*?)$/.exec(a);if(!n)return a;var s=n[7];if(r||(r={}),r.value||(r.value=[]),0==r.value.length){var o=this.mMoves;this.mMoves&&0!=this.mMoves.length||this.GenerateMoves(e);for(var h=0;h<this.mMoves.length;h++){var c=this.mMoves[h];"function"!=typeof c.ToString&&(c=e.CreateMove(c)),r.value.push({str:c.ToString(),move:c})}this.mMoves=o}var p=[];if(r.value.forEach(function(t){var e=/^([A-Z]?[a-z][1-9][0-9]*[-x][a-z][1-9][0-9]*)(.*?)$/.exec(t.str);e&&t.move.t==i.t&&(t.move.a||"")==n[1]&&e[2]==s&&p.push(t.move)}),1==p.length)return""==n[1]&&"x"==n[4]?n[2]+"x"+n[5]+n[6]+n[7]:n[1]+("x"==n[4]?"x":"")+n[5]+n[6]+n[7];if(t.geometry.CompactCrit)for(var l="",h=0;;h++){var v=t.geometry.CompactCrit(i.f,h);if(null==v)return a;l+=v;for(var f=[],u=0;u<p.length;u++){var g=p[u];t.geometry.CompactCrit(g.f,h)==v&&f.push(g)}if(console.assert(f.length>0),1==f.length)return n[1]+l+("x"==n[4]?"x":"")+n[5]+n[6]+n[7];p=f}return a},Model.Board.cbIntegrity=function(t){function e(t,e){t||console.error(e)}for(var i=this,r=0;r<this.board.length;r++){var a=this.board[r];if(a>=0){var n=i.pieces[a];e(void 0!==n,"no piece at pos"),e(n.p==r,"piece has different pos")}}for(var a=0;a<this.pieces.length;a++){var n=this.pieces[a];n.p>=0&&e(i.board[n.p]==a,"board index mismatch")}},Model.Board.ExportBoardState=function(t){return t.cbVar.geometry.ExportBoardState?t.cbVar.geometry.ExportBoardState(this,t.cbVar,t.mPlayedMoves.length):"not supported"},Model.Game.Import=function(e,i){var r,a=[],n={1:{},"-1":{}},s=null,o=0;if("pjn"==e){var h={status:!1,error:"parse"},c=i.split(" ");if(6!=c.length)return console.warn("FEN should have 6 parts"),h;var p=c[0].split("/"),l=t.geometry.fenHeight||t.geometry.height;if(p.length!=l)return console.warn("FEN board should have",l,"rows, got",p.length),h;var v={};for(var f in t.pieceTypes){var u=t.pieceTypes[f],g=u.fenAbbrev||u.abbrev||"X";v[g.toUpperCase()]={s:1,t:f},v[g.toLowerCase()]={s:-1,t:f}}var b=t.geometry.FenRowPos||function(e,i){return(t.geometry.height-1-e)*t.geometry.width+i};if(p.forEach(function(e,i){for(var r=0,n=0;n<e.length;n++){var s=e.substr(n,1),o=v[s];if(void 0!==o){var c=b(i,r);r++;for(var p={s:o.s,t:o.t,p:c},l=!0,f=t.pieceTypes[p.t].initial||[],u=0;u<f.length;u++){var g=f[u];g.s==p.s&&g.p==c&&(l=!1)}p.m=l,a.push(p)}else{if(isNaN(parseInt(s)))return console.warn("FEN invalid board spec",s),h;r+=parseInt(s)}}}),a.sort(function(t,e){return e.s-t.s}),"w"==c[1])r=1;else{if("b"!=c[1])return console.warn("FEN invalid turn spec",c[1]),h;r=-1}n[1].k=c[2].indexOf("K")>=0,n[1].q=c[2].indexOf("Q")>=0,n[-1].k=c[2].indexOf("k")>=0,n[-1].q=c[2].indexOf("q")>=0,s="-"==c[3]?null:c[3];var d=parseInt(c[4]);isNaN(d)||(o=d);var m={pieces:a,turn:r,castle:n,enPassant:s,noCaptCount:o};return t.importGame&&t.importGame.call(this,m,e,i),{status:!0,initial:m}}return{status:!1,error:"unsupported"}}}(),function(){Model.Game.cbBoardGeometryHex=function(t,e){function i(t,e){for(var i=r(t),s=a(t),o=i,h=s,c=0;c<3;c++)for(var p=Math.abs(e[c]),l=0==p?0:e[c]/p,g=0;g<p;g++)h%2==v?(1==c&&l<0&&o--,2==c&&l>0&&o--):(1==c&&l>0&&o++,2==c&&l<0&&o++),1!=c&&2!=c||(h+=l),0==c&&(o+=l);if(o<0||o>=u||h<0||h>=f)return null;var t=n(o,h);return t in d?t:null}function r(t){return t%u}function a(t){return Math.floor(t/u)}function n(t,e){return e*u+t}function s(t){return void 0!==e[t]?e[t]:String.fromCharCode("a".charCodeAt(0)+r(t))+(a(t)+1)}function o(t){if(void 0!==l[t])return l[t];var e=/^([a-z])([0-9]+)$/.exec(t);return e?n(e[1].charCodeAt(0)-"a".charCodeAt(0),parseInt(e[2])-1):-1}function h(t,e){return 0==e?String.fromCharCode("a".charCodeAt(0)+r(t)):1==e?a(t)+1:null}function c(){return G}function p(e,i){var r=t[t.length-1-i][2*e];return" "==r&&(r=t[t.length-1-i][2*e+1]||" "),r}var l={};if(e)for(y in e)l[e[y]]=y;else e={};for(var v,f=t.length,u=0,g=!1,b=0,d={},m=0;m<t.length;m++)t[m].length%2==1&&t[m],t[m].length>b&&(b=t[m].length);for(var m=0;m<t.length;m++)for(;t[m].length<b;)t[m]+=" ";t.forEach(function(t,e){" "!=t[0]&&(v=e%2);var i=Math.ceil(t.length/2);i>u&&(u=i)}),t.forEach(function(e,i){(t.length-1-i)%2==1-v&&(" "==e[e.length-1]&&" "==e[e.length-2]||(g=!0));for(var r=0;r<e.length;r+=2)if(" "!=e[r]||r+1<e.length&&" "!=e[r+1]){var a=i*u+r/2;d[a]=1}});var G={};for(var y in d)G[y]={},G[y][y]=0;for(var M=[[1,0,0],[0,1,0],[0,0,1],[-1,0,0],[0,-1,0],[0,0,-1]],S=!0;S;){S=!1;for(var y in d)M.forEach(function(t){var e=i(y,t);if(null!=e){1!=G[y][e]&&(G[y][e]=1,G[e][y]=1,S=!0);for(var r in d)r!=y&&(void 0===G[e][r]&&void 0!==G[y][r]?(G[e][r]=G[y][r]+1,G[r][e]=G[y][r]+1,S=!0):void 0!==G[e][r]&&void 0!==G[y][r]&&G[e][r]>G[y][r]+1&&(G[e][r]=G[y][r]+1,G[r][e]=G[y][r]+1,S=!0))}})}var k=0,C={};for(var y in d){var T=0;for(var z in d){var A=G[y][z];T+=A*A}T>k?(C={},C[y]=1,k=T):T==k&&(C[y]=1)}for(var P={},S=!0;S;){S=!1;for(var y in d)y in P||M.forEach(function(t){var e=i(y,t);null==e?P[y]=1:e in P&&(y in P&&!(P[y]>P[e]+1)||(P[y]=P[e]+1,S=!0))})}return{boardSize:u*f,width:u,height:f,C:r,R:a,POS:n,Graph:i,PosName:s,PosByName:o,CompactCrit:h,GetDistances:c,distEdge:P,corners:C,SHIFTMOD2:v,SHIFTRIGHT:g,CellType:p,confine:d}};var t=Model.Game.cbConstants,e=[[1,0,0],[0,1,0],[0,0,1],[-1,0,0],[0,-1,0],[0,0,-1]],i=[[1,1,0],[0,1,1],[-1,0,1],[-1,-1,0],[0,-1,-1],[1,0,-1]],r=[[2,1,0],[1,2,0],[0,2,1],[0,1,2],[-1,0,2],[-2,0,1],[-2,-1,0],[-1,-2,0],[0,-2,-1],[0,-1,-2],[1,0,-2],[2,0,-1]];Model.Game.cbGLKingGraph=function(t){return this.cbShortRangeGraph(t,i.concat(e),t.confine)},Model.Game.cbGLRookGraph=function(t){return this.cbLongRangeGraph(t,e,t.confine)},Model.Game.cbGLBishopGraph=function(t){return this.cbLongRangeGraph(t,i,t.confine)},Model.Game.cbGLQueenGraph=function(t){return this.cbLongRangeGraph(t,i.concat(e),t.confine)},Model.Game.cbGLKnightGraph=function(t){return this.cbShortRangeGraph(t,r,t.confine)},Model.Game.cbGLPawnGraph=function(e,i,r){for(var a=this.cbLongRangeGraph(e,[[i,0,0]],e.confine,t.FLAG_MOVE,r),n={1:[[0,1,0],[0,0,-1]],"-1":[[0,0,1],[0,-1,0]]},s=this.cbShortRangeGraph(e,n[i],e.confine,t.FLAG_CAPTURE),o=[],h=0;h<e.boardSize;h++)o[h]=a[h].concat(s[h]);return o},Model.Game.cbBRInitialPawnGraph=function(e,i){for(var r=this.cbLongRangeGraph(e,[[0,-i,0],[0,0,-i]],e.confine,t.FLAG_MOVE,2),a=this.cbShortRangeGraph(e,[[-i,-i,0],[i,0,-i],[0,-i,-i]],e.confine,t.FLAG_CAPTURE),n=[],s=0;s<e.boardSize;s++)n[s]=r[s].concat(a[s]);return n},Model.Game.cbDVInitialPawnGraph=function(e,i){for(var r=this.cbLongRangeGraph(e,[[0,-i,0],[0,0,-i]],e.confine,t.FLAG_MOVE,2),a=this.cbShortRangeGraph(e,[[-i,-i,0],[i,0,-i]],e.confine,t.FLAG_CAPTURE),n=[],s=0;s<e.boardSize;s++)n[s]=r[s].concat(a[s]);return n},Model.Game.cbBRPawnGraph=function(e,i){for(var r=this.cbShortRangeGraph(e,[[0,-i,0],[0,0,-i]],e.confine,t.FLAG_MOVE),a=this.cbShortRangeGraph(e,[[-i,-i,0],[i,0,-i]],e.confine,t.FLAG_CAPTURE),n=[],s=0;s<e.boardSize;s++)n[s]=r[s].concat(a[s]);return n},Model.Game.cbMCPawnGraph=function(e,i,r){for(var a=this.cbLongRangeGraph(e,[[i,0,0]],e.confine,t.FLAG_MOVE,r),n=this.cbShortRangeGraph(e,[[i,0,-i],[i,i,0]],e.confine,t.FLAG_CAPTURE),s=[],o=0;o<e.boardSize;o++)s[o]=a[o].concat(n[o]);return s}}(),function(){var t={108:"a1",109:"b1",110:"c1",111:"d1",112:"e1",113:"f1",114:"g1",115:"h1",116:"i1",94:"a2",95:"b2",96:"c2",97:"d2",98:"e2",99:"f2",100:"g2",101:"h2",102:"i2",81:"a3",82:"b3",83:"c3",84:"d3",85:"e3",86:"f3",87:"g3",88:"h3",89:"i3",67:"a4",68:"b4",69:"c4",70:"d4",71:"e4",72:"f4",73:"g4",74:"h4",75:"i4",54:"a5",55:"b5",56:"c5",57:"d5",58:"e5",59:"f5",60:"g5",61:"h5",62:"i5",40:"a6",41:"b6",42:"c6",43:"d6",44:"e6",45:"f6",46:"g6",47:"h6",48:"i6",27:"a7",28:"b7",29:"c7",30:"d7",31:"e7",32:"f7",33:"g7",34:"h7",35:"i7",13:"a8",14:"b8",15:"c8",16:"d8",17:"e8",18:"f8",19:"g8",20:"h8",21:"i8",0:"a9",1:"b9",2:"c9",3:"d9",4:"e9",5:"f9",6:"g9",7:"h9",8:"i9"},e=Model.Game.cbBoardGeometryHex([". + # . + # . + #"," # . + # . + # . +","  + # . + # . + # .","   . + # . + # . + #","    # . + # . + # . +","     + # . + # . + # .","      . + # . + # . + #","       # . + # . + # . +","        + # . + # . + # ."],t),i={1:{0:1,1:1,2:1,3:1,4:1,5:1,6:1,7:1,8:1},"-1":{108:1,109:1,110:1,111:1,112:1,113:1,114:1,115:1,116:1}},r={1:{},"-1":{}},a=e.GetDistances();["1","-1"].forEach(function(t){for(var n in e.confine){var s=1/0;for(var o in i[t]){var h=a[n][o];h<s&&(r[t][n]=h,s=h)}}}),Model.Game.cbDefine=function(){return{geometry:e,pieceTypes:{0:{name:"pawn-w",aspect:"pawn",graph:this.cbBRPawnGraph(e,1,1),value:1,abbrev:"",fenAbbrev:"P",epCatch:!0},1:{name:"ipawn-w",aspect:"pawn",graph:this.cbDVInitialPawnGraph(e,1),value:1,abbrev:"",fenAbbrev:"P",initial:[{s:1,p:81},{s:1,p:82},{s:1,p:83},{s:1,p:84},{s:1,p:85},{s:1,p:86},{s:1,p:87},{s:1,p:88},{s:1,p:89}],epTarget:!0},2:{name:"pawn-b",aspect:"pawn",graph:this.cbBRPawnGraph(e,-1,1),value:1,abbrev:"",fenAbbrev:"P",epCatch:!0},3:{name:"ipawn-b",aspect:"pawn",graph:this.cbDVInitialPawnGraph(e,-1),value:1,abbrev:"",fenAbbrev:"P",initial:[{s:-1,p:27},{s:-1,p:28},{s:-1,p:29},{s:-1,p:30},{s:-1,p:31},{s:-1,p:32},{s:-1,p:33},{s:-1,p:34},{s:-1,p:35}],epTarget:!0},4:{name:"knight",graph:this.cbGLKnightGraph(e),value:2.9,abbrev:"N",initial:[{s:1,p:109},{s:1,p:115},{s:-1,p:1},{s:-1,p:7}]},5:{name:"bishop",graph:this.cbGLBishopGraph(e),value:3.1,abbrev:"B",initial:[{s:1,p:110},{s:1,p:112},{s:1,p:114},{s:-1,p:2},{s:-1,p:4},{s:-1,p:6}]},6:{name:"rook",graph:this.cbGLRookGraph(e),value:5,abbrev:"R",initial:[{s:1,p:108},{s:1,p:116},{s:-1,p:0},{s:-1,p:8}],castle:!0},7:{name:"queen",graph:this.cbGLQueenGraph(e),value:9,abbrev:"Q",initial:[{s:1,p:111},{s:-1,p:5}]},8:{name:"king",isKing:!0,graph:this.cbGLKingGraph(e),abbrev:"K",initial:[{s:1,p:113},{s:-1,p:3}]}},promote:function(t,i,r){return 1==i.t?[0]:3==i.t?[2]:0==i.t&&7==e.R(r.t)?[4,5,6,7]:2==i.t&&0==e.R(r.t)?[4,5,6,7]:[]},castle:{"98/93":{k:[97,96],r:[94,95,96,97],n:"O-O-O"},"98/101":{k:[99,100],r:[100,99],n:"O-O"},"4/9":{k:[5,6],r:[8,7,6,5],n:"O-O-O"},"4/1":{k:[3,2],r:[2,3],n:"O-O"}},evaluate:function(t,e,i){var a=i[1].count,n=i[-1].count;a[0]||a[1]||a[4]||a[5]||a[6]||a[7]||n[2]||n[3]||n[6]||n[7]||!(n[4]+n[5]<2||n[5]<2)||(this.mFinished=!0,this.mWinner=JocGame.DRAW),n[2]||n[3]||n[4]||n[5]||n[6]||n[7]||a[0]||a[1]||a[6]||a[7]||!(a[4]+a[5]<2||a[5]<2)||(this.mFinished=!0,this.mWinner=JocGame.DRAW),this.noCaptCount>=100&&(this.mFinished=!0,this.mWinner=JocGame.DRAW);var s,o=t.cbUseTypedArrays?new Int8Array(3):[0,0,0],h=i[1].byType[0];if(h){s=h.length;for(var c=0;c<s;c++){var p=r[1][h[c].p];p>0&&p<4&&o[p-1]++}}if(h=i[-1].byType[2]){s=h.length;for(var c=0;c<s;c++){var p=r[-1][h[c].p];p>0&&p<4&&o[p-1]--}}0!=o[0]&&(e.distPawnPromo1=o[0]),0!=o[1]&&(e.distPawnPromo2=o[1]),0!=o[2]&&(e.distPawnPromo3=o[2]);for(var l=0,v=4;v<=5;v++)for(var f=1;f>=-1;f-=2){var u=i[f].byType[v];if(u)for(var c=0;c<u.length;c++)u[c].m&&(l+=f)}0!=l&&(e.minorPiecesMoved=l)}}}}();

/***/ }),

/***/ "/181":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var count_1 = __webpack_require__("2jZb");
Observable_1.Observable.prototype.count = count_1.count;
//# sourceMappingURL=count.js.map

/***/ }),

/***/ "/8te":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var RangeObservable_1 = __webpack_require__("Gb0N");
exports.range = RangeObservable_1.RangeObservable.create;
//# sourceMappingURL=range.js.map

/***/ }),

/***/ "/J7H":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Observable_1 = __webpack_require__("rCTf");
var tryCatch_1 = __webpack_require__("+3eL");
var isFunction_1 = __webpack_require__("SKH6");
var errorObject_1 = __webpack_require__("WhVc");
var Subscription_1 = __webpack_require__("B00U");
var toString = Object.prototype.toString;
function isNodeStyleEventEmitter(sourceObj) {
    return !!sourceObj && typeof sourceObj.addListener === 'function' && typeof sourceObj.removeListener === 'function';
}
function isJQueryStyleEventEmitter(sourceObj) {
    return !!sourceObj && typeof sourceObj.on === 'function' && typeof sourceObj.off === 'function';
}
function isNodeList(sourceObj) {
    return !!sourceObj && toString.call(sourceObj) === '[object NodeList]';
}
function isHTMLCollection(sourceObj) {
    return !!sourceObj && toString.call(sourceObj) === '[object HTMLCollection]';
}
function isEventTarget(sourceObj) {
    return !!sourceObj && typeof sourceObj.addEventListener === 'function' && typeof sourceObj.removeEventListener === 'function';
}
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var FromEventObservable = (function (_super) {
    __extends(FromEventObservable, _super);
    function FromEventObservable(sourceObj, eventName, selector, options) {
        _super.call(this);
        this.sourceObj = sourceObj;
        this.eventName = eventName;
        this.selector = selector;
        this.options = options;
    }
    /* tslint:enable:max-line-length */
    /**
     * Creates an Observable that emits events of a specific type coming from the
     * given event target.
     *
     * <span class="informal">Creates an Observable from DOM events, or Node
     * EventEmitter events or others.</span>
     *
     * <img src="./img/fromEvent.png" width="100%">
     *
     * Creates an Observable by attaching an event listener to an "event target",
     * which may be an object with `addEventListener` and `removeEventListener`,
     * a Node.js EventEmitter, a jQuery style EventEmitter, a NodeList from the
     * DOM, or an HTMLCollection from the DOM. The event handler is attached when
     * the output Observable is subscribed, and removed when the Subscription is
     * unsubscribed.
     *
     * @example <caption>Emits clicks happening on the DOM document</caption>
     * var clicks = Rx.Observable.fromEvent(document, 'click');
     * clicks.subscribe(x => console.log(x));
     *
     * // Results in:
     * // MouseEvent object logged to console everytime a click
     * // occurs on the document.
     *
     * @see {@link from}
     * @see {@link fromEventPattern}
     *
     * @param {EventTargetLike} target The DOMElement, event target, Node.js
     * EventEmitter, NodeList or HTMLCollection to attach the event handler to.
     * @param {string} eventName The event name of interest, being emitted by the
     * `target`.
     * @param {EventListenerOptions} [options] Options to pass through to addEventListener
     * @param {SelectorMethodSignature<T>} [selector] An optional function to
     * post-process results. It takes the arguments from the event handler and
     * should return a single value.
     * @return {Observable<T>}
     * @static true
     * @name fromEvent
     * @owner Observable
     */
    FromEventObservable.create = function (target, eventName, options, selector) {
        if (isFunction_1.isFunction(options)) {
            selector = options;
            options = undefined;
        }
        return new FromEventObservable(target, eventName, selector, options);
    };
    FromEventObservable.setupSubscription = function (sourceObj, eventName, handler, subscriber, options) {
        var unsubscribe;
        if (isNodeList(sourceObj) || isHTMLCollection(sourceObj)) {
            for (var i = 0, len = sourceObj.length; i < len; i++) {
                FromEventObservable.setupSubscription(sourceObj[i], eventName, handler, subscriber, options);
            }
        }
        else if (isEventTarget(sourceObj)) {
            var source_1 = sourceObj;
            sourceObj.addEventListener(eventName, handler, options);
            unsubscribe = function () { return source_1.removeEventListener(eventName, handler); };
        }
        else if (isJQueryStyleEventEmitter(sourceObj)) {
            var source_2 = sourceObj;
            sourceObj.on(eventName, handler);
            unsubscribe = function () { return source_2.off(eventName, handler); };
        }
        else if (isNodeStyleEventEmitter(sourceObj)) {
            var source_3 = sourceObj;
            sourceObj.addListener(eventName, handler);
            unsubscribe = function () { return source_3.removeListener(eventName, handler); };
        }
        else {
            throw new TypeError('Invalid event target');
        }
        subscriber.add(new Subscription_1.Subscription(unsubscribe));
    };
    FromEventObservable.prototype._subscribe = function (subscriber) {
        var sourceObj = this.sourceObj;
        var eventName = this.eventName;
        var options = this.options;
        var selector = this.selector;
        var handler = selector ? function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i - 0] = arguments[_i];
            }
            var result = tryCatch_1.tryCatch(selector).apply(void 0, args);
            if (result === errorObject_1.errorObject) {
                subscriber.error(errorObject_1.errorObject.e);
            }
            else {
                subscriber.next(result);
            }
        } : function (e) { return subscriber.next(e); };
        FromEventObservable.setupSubscription(sourceObj, eventName, handler, subscriber, options);
    };
    return FromEventObservable;
}(Observable_1.Observable));
exports.FromEventObservable = FromEventObservable;
//# sourceMappingURL=FromEventObservable.js.map

/***/ }),

/***/ "/Owh":
/***/ (function(module, exports) {

exports.model=Model={Game:{},Board:{},Move:{}},function(){var t;Model.Game.cbConstants={MASK:65535,FLAG_MOVE:65536,FLAG_CAPTURE:131072,FLAG_STOP:262144,FLAG_SCREEN_CAPTURE:524288,FLAG_CAPTURE_KING:1048576,FLAG_CAPTURE_NO_KING:2097152};var e="undefined"!=typeof Int32Array;Model.Game.cbUseTypedArrays=e,Model.Game.cbTypedArray=function(t){if(e){var r=new Int32Array(t.length);return r.set(t),r}for(var i=[],a=t.length,n=0;n<a;n++)i.push(t[n]);return i},Model.Game.cbShortRangeGraph=function(t,e,r,i){var a=this;void 0===i&&(i=196608);for(var n={},s=0;s<t.boardSize;s++)n[s]=[],(!r||s in r)&&e.forEach(function(e){var o=t.Graph(s,e);null!=o&&(!r||o in r)&&n[s].push(a.cbTypedArray([o|i]))});return n},Model.Game.cbLongRangeGraph=function(t,e,r,i,a){var n=this;void 0!==i&&null!=i||(i=196608),a||(a=1/0);for(var s={},o=0;o<t.boardSize;o++)s[o]=[],(!r||o in r)&&e.forEach(function(e){for(var h=[],c=t.Graph(o,e),p=0;null!=c&&(!r||c in r)&&(h.push(c|i),++p!=a);)c=t.Graph(c,e);h.length>0&&s[o].push(n.cbTypedArray(h))});return s},Model.Game.cbNullGraph=function(t){for(var e={},r=0;r<t.boardSize;r++)e[r]=[];return e},Model.Game.cbAuthorGraph=function(t){for(var e={},r=0;r<t.boardSize;r++){e[r]=[];for(var i=0;i<t.boardSize;i++)e[r].push([2293760|i])}return e},Model.Game.cbMergeGraphs=function(t){for(var e=[],r=0;r<t.boardSize;r++){e[r]=[];for(var i=1;i<arguments.length;i++)e[r]=e[r].concat(arguments[i][r])}return e},Model.Game.cbGetThreatGraph=function(){function t(e,r){for(var i in s){var a=s[i];if(!(a.p.length<r.length+1)){for(var n=!0,o=0;o<r.length;o++)if(r[o]!=a.p[o]){n=!1;break}if(n){var h=a.p[r.length],c=e[h];void 0===c&&(c={e:{}},e[h]=c),a.p.length==r.length+1&&(c.t=a.t,c.ts=a.ts,c.tk=a.tk,delete s[i]),r.push(h),t(c.e,r),r.pop()}}}}var e=this;this.cbUseScreenCapture=!1,this.cbUseCaptureKing=!1,this.cbUseCaptureNoKing=!1;for(var r={1:[],"-1":[]},i=[],a=0;a<this.g.boardSize;a++)this.g.pTypes.forEach(function(t,r){t.graph[a].forEach(function(t){for(var n=[],s=0;s<t.length;s++){var o=t[s];1048576&o?(e.cbUseCaptureKing=!0,n.unshift({d:65535&o,a:a,tk:r})):2097152&o?(e.cbUseCaptureNoKing=!0,n.unshift({d:65535&o,a:a,tnk:r})):131072&o?n.unshift({d:65535&o,a:a,t:r}):262144&o?n.unshift({d:65535&o,a:a}):524288&o&&(e.cbUseScreenCapture=!0,n.unshift({d:65535&o,a:a,ts:r}))}n.length>0&&i.push(n)})});var n={};i.forEach(function(t){t.forEach(function(e,r){var i=n[e.d];void 0===i&&(i={},n[e.d]=i);for(var a=[],s=r+1;s<t.length;s++)a.push(t[s].d);a.push(e.a);var o=a.join(","),h=i[o];void 0===h&&(h={p:a,t:{},ts:{},tk:{}},i[o]=h),void 0!==e.t?h.t[e.t]=!0:void 0!==e.tk?h.tk[e.tk]=!0:void 0!==e.ts&&(h.ts[e.ts]=!0)})});for(var a=0;a<e.g.boardSize;a++){var s=n[a],o={};t(o,[]),r[1][a]=o,r[-1][a]=o}return r},Model.Game.InitGame=function(){var e=this;this.cbVar=t=this.cbDefine(),this.g.boardSize=this.cbVar.geometry.boardSize,this.g.pTypes=this.cbGetPieceTypes(),this.g.threatGraph=this.cbGetThreatGraph(),this.g.distGraph=this.cbVar.geometry.GetDistances(),this.cbPiecesCount=0,this.g.castleablePiecesCount={1:0,"-1":0};for(var r in t.pieceTypes){var i=t.pieceTypes[r];if(i.castle){(i.initial||[]).forEach(function(t){e.g.castleablePiecesCount[t.s]++})}i.initial&&(this.cbPiecesCount+=i.initial.length)}for(var a=[],r=0;r<this.cbPiecesCount;r++)a.push(r);var n=Object.keys(t.pieceTypes);this.zobrist=new JocGame.Zobrist({board:{type:"array",size:this.cbVar.geometry.boardSize,values:a},who:{values:["1","-1"]},type:{type:"array",size:this.cbPiecesCount,values:n}})},Model.Game.cbGetPieceTypes=function(){for(var t=[],e={},r=0;r<this.cbVar.geometry.boardSize;r++)e[r]=[];for(var i in this.cbVar.pieceTypes){var a=this.cbVar.pieceTypes[i];t[i]={graph:a.graph||e,abbrev:a.abbrev||"",value:a.isKing?100:a.value||1,isKing:!!a.isKing,castle:!!a.castle,epTarget:!!a.epTarget,epCatch:!!a.epCatch}}return t},Model.Board.Init=function(t){this.zSign=0},Model.Board.InitialPosition=function(r){var i=this;this.board=e?new Int16Array(r.g.boardSize):[];for(var a=0;a<r.g.boardSize;a++)this.board[a]=-1;if(this.kings={},this.pieces=[],this.ending={1:!1,"-1":!1},this.lastMove=null,r.cbVar.castle&&(this.castled={1:!1,"-1":!1}),this.zSign=r.zobrist.update(0,"who",-1),this.noCaptCount=0,this.mWho=1,r.mInitial)this.mWho=r.mInitial.turn||1,r.mInitial.pieces.forEach(function(t){var e={};for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);i.pieces.push(e)}),r.mInitial.lastMove&&(this.lastMove={f:r.mInitial.lastMove.f,t:r.mInitial.lastMove.t}),void 0!==r.mInitial.noCaptCount&&(this.noCaptCount=r.mInitial.noCaptCount),r.cbVar.castle&&r.mInitial.castle&&(this.castled={1:{k:!!r.mInitial.castle[1]&&!!r.mInitial.castle[1].k,q:!!r.mInitial.castle[1]&&!!r.mInitial.castle[1].q},"-1":{k:!!r.mInitial.castle[-1]&&!!r.mInitial.castle[-1].k,q:!!r.mInitial.castle[-1]&&!!r.mInitial.castle[-1].q}});else for(var n in r.cbVar.pieceTypes)for(var s=r.cbVar.pieceTypes[n],o=s.initial||[],h=0;h<o.length;h++){var c=o[h],p={s:c.s,t:parseInt(n),p:c.p,m:!1};this.pieces.push(p)}if(this.pieces.sort(function(t,e){if(t.s!=e.s)return e.s-t.s;var i=r.cbVar.pieceTypes[t.t].value||100,a=r.cbVar.pieceTypes[e.t].value||100;return i!=a?i-a:t.p-e.p}),this.pieces.forEach(function(t,e){t.i=e,i.board[t.p]=e,r.g.pTypes[t.t].isKing&&(i.kings[t.s]=t.p),i.zSign=r.zobrist.update(i.zSign,"board",e,t.p),i.zSign=r.zobrist.update(i.zSign,"type",t.t,e)}),r.mInitial&&r.mInitial.enPassant){var a=t.geometry.PosByName(r.mInitial.enPassant);if(a>=0){var l,u=t.geometry.C(a),v=t.geometry.R(a);l=1==r.mInitial.turn?t.geometry.POS(u,v-1):t.geometry.POS(u,v+1),this.epTarget={p:a,i:this.board[l]}}}},Model.Board.CopyFrom=function(t){if(e)this.board=new Int16Array(t.board.length),this.board.set(t.board);else{this.board=[];for(var r=t.board,i=r.length,a=0;a<i;a++)this.board.push(r[a])}this.pieces=[];for(var n=t.pieces.length,a=0;a<n;a++){var s=t.pieces[a];this.pieces.push({s:s.s,p:s.p,t:s.t,i:s.i,m:s.m})}this.kings={1:t.kings[1],"-1":t.kings[-1]},this.check=t.check,t.lastMove?this.lastMove={f:t.lastMove.f,t:t.lastMove.t,c:t.lastMove.c}:this.lastMove=null,this.ending={1:t.ending[1],"-1":t.ending[-1]},void 0!==t.castled&&(this.castled={1:t.castled[1],"-1":t.castled[-1]}),this.noCaptCount=t.noCaptCount,t.epTarget?this.epTarget={p:t.epTarget.p,i:t.epTarget.i}:this.epTarget=null,this.mWho=t.mWho,this.zSign=t.zSign},Model.Board.cbApplyCastle=function(t,e,r){var i=t.cbVar.castle[e.f+"/"+e.cg],a=i.r[i.r.length-1],n=this.pieces[this.board[e.cg]],s=i.k[i.k.length-1],o=this.pieces[this.board[e.f]];return r&&(this.zSign=t.zobrist.update(this.zSign,"board",n.i,e.cg),this.zSign=t.zobrist.update(this.zSign,"board",n.i,a),this.zSign=t.zobrist.update(this.zSign,"board",o.i,e.f),this.zSign=t.zobrist.update(this.zSign,"board",o.i,s)),n.p=a,n.m=!0,this.board[e.cg]=-1,o.p=s,o.m=!0,this.board[e.f]=-1,this.board[a]=n.i,this.board[s]=o.i,this.castled[n.s]=!0,this.kings[o.s]=s,[{i:n.i,f:a,t:-1},{i:o.i,f:s,t:e.f,kp:e.f,who:o.s,m:!1},{i:n.i,f:-1,t:e.cg,m:!1,cg:!1}]},Model.Board.cbQuickApply=function(t,e){if(void 0!==e.cg)return this.cbApplyCastle(t,e,!1);var r=[],i=this.board[e.f],a=this.pieces[i];if(null!=e.c){r.unshift({i:e.c,f:-1,t:this.pieces[e.c].p});var n=this.pieces[e.c];this.board[n.p]=-1,n.p=-1}var s=this.kings[a.s];return t.g.pTypes[a.t].isKing&&(this.kings[a.s]=e.t),r.unshift({i:i,f:e.t,t:e.f,kp:s,who:a.s,ty:a.t}),a.p=e.t,void 0!==e.pr&&(a.t=e.pr),this.board[e.f]=-1,this.board[e.t]=i,r},Model.Board.cbQuickUnapply=function(t,e){for(var r=0;r<e.length;r++){var i=e[r],a=this.pieces[i.i];i.f>=0&&(a.p=-1,this.board[i.f]=-1),i.t>=0&&(a.p=i.t,this.board[i.t]=i.i),void 0!==i.m&&(a.m=i.m),void 0!==i.kp&&(this.kings[i.who]=i.kp),void 0!=i.ty&&(a.t=i.ty),void 0!=i.cg&&(this.castled[a.s]=i.cg)}},Model.Board.ApplyMove=function(t,e){var r=this.pieces[this.board[e.f]];if(void 0!==e.cg)this.cbApplyCastle(t,e,!0);else{if(this.zSign=t.zobrist.update(this.zSign,"board",r.i,e.f),this.board[r.p]=-1,void 0!==e.pr&&(this.zSign=t.zobrist.update(this.zSign,"type",r.t,r.i),r.t=e.pr,this.zSign=t.zobrist.update(this.zSign,"type",r.t,r.i)),null!=e.c){var i=this.pieces[e.c];this.zSign=t.zobrist.update(this.zSign,"board",i.i,i.p),this.board[i.p]=-1,i.p=-1,i.m=!0,this.noCaptCount=0}else this.noCaptCount++;r.p=e.t,r.m=!0,this.board[e.t]=r.i,this.zSign=t.zobrist.update(this.zSign,"board",r.i,e.t),t.g.pTypes[r.t].isKing&&(this.kings[r.s]=e.t)}this.check=!!e.ck,this.lastMove={f:e.f,t:e.t,c:e.c},void 0!==e.ko&&(this.ending[r.s]=e.ko),void 0!==e.ept?this.epTarget={p:e.ept,i:r.i}:this.epTarget=null,this.zSign=t.zobrist.update(this.zSign,"who",-this.mWho),this.zSign=t.zobrist.update(this.zSign,"who",this.mWho)},Model.Board.Evaluate=function(r){function i(e){var r=1/0;for(var i in t.geometry.corners)r=Math.min(r,h.distGraph[n.kings[e]][i]);return r-Math.sqrt(h.boardSize)}var a="debug"==arguments[3],n=this;this.mEvaluation=0;var s,o=this.mWho,h=r.g;if(e)s={1:{count:new Uint8Array(h.pTypes.length),byType:{}},"-1":{count:new Uint8Array(h.pTypes.length),byType:{}}};else{s={1:{count:[],byType:{}},"-1":{count:[],byType:{}}};for(var c=0;c<h.pTypes.length;c++)s[1].count[c]=s[-1].count[c]=0}if(r.mOptions.preventRepeat&&r.GetRepeatOccurence(this)>2)return this.mFinished=!0,void(this.mWinner=r.cbOnPerpetual?o*r.cbOnPerpetual:JocGame.DRAW);for(var p={1:0,"-1":0},l={1:h.distGraph[this.kings[-1]],"-1":h.distGraph[this.kings[1]]},u={1:0,"-1":0},v={1:0,"-1":0},b={1:0,"-1":0},f={1:0,"-1":0},d={1:!1,"-1":!1},g=this.pieces,m=g.length,c=0;c<m;c++){var G=g[c];if(G.p>=0){var y=G.s,M=h.pTypes[G.t];M.isKing?d[y]=G.m:p[y]+=M.value,M.castle&&!G.m&&f[y]++,v[y]++,u[y]+=l[y][G.p],b[y]+=t.geometry.distEdge[G.p];var C=s[y];C.count[G.t]++;var S=C.byType;void 0===S[G.t]?S[G.t]=[G]:S[G.t].push(G)}}if(this.lastMove&&null!=this.lastMove.c){var G=this.pieces[this.board[this.lastMove.t]];p[-G.s]+=this.cbStaticExchangeEval(r,G.p,G.s,{piece:G})}var k={1:0,"-1":0},A={1:0,"-1":0},T={1:0,"-1":0};this.ending[1]&&(A[1]=(u[1]-Math.sqrt(h.boardSize))/v[1],t.geometry.corners&&(T[1]=i(1))),this.ending[-1]&&(A[-1]=(u[-1]-Math.sqrt(h.boardSize))/v[-1],t.geometry.corners&&(T[1]=i(-1)));var z={pieceValue:p[1]-p[-1],pieceValueRatio:(p[1]-p[-1])/(p[1]+p[-1]+1),posValue:b[1]-b[-1],averageDistKing:u[1]/v[1]-u[-1]/v[-1],check:this.check?-o:0,endingKingFreedom:k[1]-k[-1],endingDistKing:A[1]-A[-1],distKingCorner:T[1]-T[-1]};t.castle&&(z.castle=(this.castled[1]?1:d[1]?0:f[1]/(h.castleablePiecesCount[1]+1))-(this.castled[-1]?1:d[-1]?0:f[-1]/(h.castleablePiecesCount[-1]+1))),t.evaluate&&t.evaluate.call(this,r,z,s);var P=r.mOptions.levelOptions;for(var E in z){var w=z[E],R=P[E+"Factor"]||0,I=w*R;a&&console.log(E,"=",w,"*",R,"=>",I),this.mEvaluation+=I}a&&console.log("Evaluation",this.mEvaluation)},Model.Board.cbGeneratePseudoLegalMoves=function(t){function e(e,a){var n=t.cbVar.promote;if(!n)return void i.push(a);var s=n.call(r,t,e,a);if(null!=s)if(0==s.length)i.push(a);else if(1==s.length)a.pr=s[0],i.push(a);else for(var o=0;o<s.length;o++){var h=s[o];i.push({f:a.f,t:a.t,c:a.c,pr:h,ept:a.ept,ep:a.ep,a:a.a})}}for(var r=this,i=[],a=t.cbVar,n=this.mWho,s=!a.castle||this.check||this.castled[n]?null:[],o=-1,h=this.pieces.length,c=0;c<h;c++){var p=this.pieces[c];if(!(p.p<0||p.s!=n)){var l=t.g.pTypes[p.t];l.isKing&&(p.m?s=null:o=p),s&&l.castle&&!p.m&&s.push(p);var u,v;u=l.graph[p.p],v=u.length;for(var b=0;b<v;b++)for(var f=u[b],d=!1,g=f.length,m=null,G=0;G<g;G++){var y=f[G],M=65535&y,C=this.board[M];if(!(C<0)||l.epCatch&&this.epTarget&&this.epTarget.p==M){if(!(524288&y)){var S;S=C<0?this.pieces[this.epTarget.i]:this.pieces[C],!(S.s!=p.s&&131072&y)||1048576&y&&!t.g.pTypes[S.t].isKing||2097152&y&&t.g.pTypes[S.t].isKing||e(p,{f:p.p,t:M,c:S.i,a:l.abbrev,ep:C<0});break}if(d){var S=this.pieces[C];S.s!=p.s&&e(p,{f:p.p,t:M,c:S.i,a:l.abbrev});break}d=!0}else 65536&y&&0==d&&e(p,{f:p.p,t:M,c:null,a:l.abbrev,ept:null!=m&&l.epTarget?m:void 0});m=M}}}if(s)for(var c=0;c<s.length;c++){var k=s[c],A=t.cbVar.castle[o.p+"/"+k.p];if(A){for(var T=!0,b=0;b<A.r.length;b++){var z=A.r[b];if(this.board[z]>=0&&z!=o.p&&z!=k.p){T=!1;break}}if(T){for(var P=!0,b=0;b<A.k.length;b++){var z=A.k[b];if(this.board[z]>=0&&z!=k.p&&z!=o.p||this.cbGetAttackers(t,z,n).length>0){P=!1;break}}P&&i.push({f:o.p,t:A.k[A.k.length-1],c:null,cg:k.p})}}}return i},Model.Board.cbStaticExchangeEval=function(t,e,r,i){var a=0,n=this.cbGetSmallestAttacker(t,e,r);if(n){var s=this.mWho;this.mWho=n.s;var o=this.cbQuickApply(t,{f:n.p,t:e,c:i.piece.i}),h=t.g.pTypes[i.piece.t].value;i.piece=n,a=Math.max(0,h-this.cbStaticExchangeEval(t,e,-r,i)),this.cbQuickUnapply(t,o),this.mWho=s}return a},Model.Board.cbGetSmallestAttacker=function(t,e,r){var i=this.cbGetAttackers(t,e,r);if(0==i.length)return null;for(var a=1/0,n=null,s=i.length,o=0;o<s;o++){var h=i[o],c=t.g.pTypes[h.t].value;c<a&&(a=c,n=h)}return n},Model.Board.cbCollectAttackers=function(t,e,r,i){for(var a in e){var n=e[a],s=this.board[a];if(s<0)this.cbCollectAttackers(t,n.e,r,i);else{var o=this.pieces[s];o.s==-t&&(n.t&&o.t in n.t||i&&n.tk&&o.t in n.tk)&&r.push(o)}}},Model.Board.cbCollectAttackersScreen=function(t,e,r,i,a){for(var n in e){var s=e[n],o=this.board[n];if(o<0)this.cbCollectAttackersScreen(t,s.e,r,i,a);else{var h=this.pieces[o];!a&&h.s==-t&&(s.t&&h.t in s.t||i&&s.tk&&h.t in s.tk)?r.push(h):a?a&&h.s==-t&&s.ts&&h.t in s.ts&&r.push(h):this.cbCollectAttackersScreen(t,s.e,r,i,!0)}}},Model.Board.cbGetAttackers=function(t,e,r,i){var a=[];return t.cbUseScreenCapture?this.cbCollectAttackersScreen(r,t.g.threatGraph[r][e],a,i,!1):this.cbCollectAttackers(r,t.g.threatGraph[r][e],a,i),a},Model.Board.GenerateMoves=function(t){var e=this.cbGeneratePseudoLegalMoves(t);this.mMoves=[];for(var r=!0,i=this.kings[this.mWho],a=e.length,n=0;n<a;n++){var s=e[n],o=this.cbQuickApply(t,s);if(!(this.cbGetAttackers(t,this.kings[this.mWho],this.mWho,!0).length>0)){var h=this.cbGetAttackers(t,this.kings[-this.mWho],-this.mWho,!0).length>0;s.ck=h,this.mMoves.push(s),s.f!=i&&(r=!1)}this.cbQuickUnapply(t,o)}if(0==this.mMoves.length)this.mFinished=!0,this.mWinner=t.cbOnStaleMate?t.cbOnStaleMate*this.mWho:JocGame.DRAW,this.check&&(this.mWinner=-this.mWho);else if(this.ending[this.mWho]){if(!r)for(var n=0;n<this.mMoves.length;n++)this.mMoves[n].ko=!1}else if(!this.ending[this.mWho]&&r&&!this.check)for(var n=0;n<this.mMoves.length;n++)this.mMoves[n].ko=!0},Model.Board.GetSignature=function(){return this.zSign},Model.Move.Init=function(t){for(var e in t)t.hasOwnProperty(e)&&(this[e]=t[e])},Model.Move.Equals=function(t){return this.f==t.f&&this.t==t.t&&this.pr==t.pr},Model.Move.CopyFrom=function(t){this.Init(t)},Model.Move.ToString=function(e){var r=this;switch(e=e||"natural"){case"natural":return function(){var e;if(void 0!==r.cg?e=t.castle[r.f+"/"+r.cg].n:(e=r.a||"",e+=t.geometry.PosName(r.f),null==r.c?e+="-":e+="x",e+=t.geometry.PosName(r.t)),void 0!==r.pr){var i=t.pieceTypes[r.pr];i&&i.abbrev&&i.abbrev.length>0&&!i.silentPromo&&(e+="="+i.abbrev)}return r.ck&&(e+="+"),e}();case"engine":return function(){var e=t.geometry.PosName(r.f)+t.geometry.PosName(r.t);if(void 0!=r.pr){var i=t.pieceTypes[r.pr];i&&i.abbrev&&i.abbrev.length>0&&!i.silentPromo&&(e+=i.abbrev)}return e}();default:return"??"}},Model.Board.CompactMoveString=function(e,r,i){"function"!=typeof r.ToString&&(r=e.CreateMove(r));var a=r.ToString(),n=/^([A-Z]?)([a-z])([1-9][0-9]*)([-x])([a-z])([1-9][0-9]*)(.*?)$/.exec(a);if(!n)return a;var s=n[7];if(i||(i={}),i.value||(i.value=[]),0==i.value.length){var o=this.mMoves;this.mMoves&&0!=this.mMoves.length||this.GenerateMoves(e);for(var h=0;h<this.mMoves.length;h++){var c=this.mMoves[h];"function"!=typeof c.ToString&&(c=e.CreateMove(c)),i.value.push({str:c.ToString(),move:c})}this.mMoves=o}var p=[];if(i.value.forEach(function(t){var e=/^([A-Z]?[a-z][1-9][0-9]*[-x][a-z][1-9][0-9]*)(.*?)$/.exec(t.str);e&&t.move.t==r.t&&(t.move.a||"")==n[1]&&e[2]==s&&p.push(t.move)}),1==p.length)return""==n[1]&&"x"==n[4]?n[2]+"x"+n[5]+n[6]+n[7]:n[1]+("x"==n[4]?"x":"")+n[5]+n[6]+n[7];if(t.geometry.CompactCrit)for(var l="",h=0;;h++){var u=t.geometry.CompactCrit(r.f,h);if(null==u)return a;l+=u;for(var v=[],b=0;b<p.length;b++){var f=p[b];t.geometry.CompactCrit(f.f,h)==u&&v.push(f)}if(console.assert(v.length>0),1==v.length)return n[1]+l+("x"==n[4]?"x":"")+n[5]+n[6]+n[7];p=v}return a},Model.Board.cbIntegrity=function(t){function e(t,e){t||console.error(e)}for(var r=this,i=0;i<this.board.length;i++){var a=this.board[i];if(a>=0){var n=r.pieces[a];e(void 0!==n,"no piece at pos"),e(n.p==i,"piece has different pos")}}for(var a=0;a<this.pieces.length;a++){var n=this.pieces[a];n.p>=0&&e(r.board[n.p]==a,"board index mismatch")}},Model.Board.ExportBoardState=function(t){return t.cbVar.geometry.ExportBoardState?t.cbVar.geometry.ExportBoardState(this,t.cbVar,t.mPlayedMoves.length):"not supported"},Model.Game.Import=function(e,r){var i,a=[],n={1:{},"-1":{}},s=null,o=0;if("pjn"==e){var h={status:!1,error:"parse"},c=r.split(" ");if(6!=c.length)return console.warn("FEN should have 6 parts"),h;var p=c[0].split("/"),l=t.geometry.fenHeight||t.geometry.height;if(p.length!=l)return console.warn("FEN board should have",l,"rows, got",p.length),h;var u={};for(var v in t.pieceTypes){var b=t.pieceTypes[v],f=b.fenAbbrev||b.abbrev||"X";u[f.toUpperCase()]={s:1,t:v},u[f.toLowerCase()]={s:-1,t:v}}var d=t.geometry.FenRowPos||function(e,r){return(t.geometry.height-1-e)*t.geometry.width+r};if(p.forEach(function(e,r){for(var i=0,n=0;n<e.length;n++){var s=e.substr(n,1),o=u[s];if(void 0!==o){var c=d(r,i);i++;for(var p={s:o.s,t:o.t,p:c},l=!0,v=t.pieceTypes[p.t].initial||[],b=0;b<v.length;b++){var f=v[b];f.s==p.s&&f.p==c&&(l=!1)}p.m=l,a.push(p)}else{if(isNaN(parseInt(s)))return console.warn("FEN invalid board spec",s),h;i+=parseInt(s)}}}),a.sort(function(t,e){return e.s-t.s}),"w"==c[1])i=1;else{if("b"!=c[1])return console.warn("FEN invalid turn spec",c[1]),h;i=-1}n[1].k=c[2].indexOf("K")>=0,n[1].q=c[2].indexOf("Q")>=0,n[-1].k=c[2].indexOf("k")>=0,n[-1].q=c[2].indexOf("q")>=0,s="-"==c[3]?null:c[3];var g=parseInt(c[4]);isNaN(g)||(o=g);var m={pieces:a,turn:i,castle:n,enPassant:s,noCaptCount:o};return t.importGame&&t.importGame.call(this,m,e,r),{status:!0,initial:m}}return{status:!1,error:"unsupported"}}}(),function(){Model.Game.cbBoardGeometryGrid=function(t,e){function r(e){return e%t}function i(e){return Math.floor(e/t)}function a(e,r){return r*t+e}function n(n,s){var o=r(n),h=i(n),c=o+s[0],p=h+s[1];return c<0||c>=t||p<0||p>=e?null:a(c,p)}function s(t){return String.fromCharCode("a".charCodeAt(0)+r(t))+(i(t)+1)}function o(t){var e=/^([a-z])([0-9]+)$/.exec(t);return e?a(e[1].charCodeAt(0)-"a".charCodeAt(0),parseInt(e[2])-1):-1}function h(t,e){return 0==e?String.fromCharCode("a".charCodeAt(0)+r(t)):1==e?i(t)+1:null}function c(){for(var a=[],n=0;n<t*e;n++){var s=[];a.push(s);for(var o=0;o<t*e;o++){var h=i(n),c=r(n),p=i(o),l=r(o);s.push(Math.max(Math.abs(h-p),Math.abs(c-l)))}}return a}function p(r,i,n){for(var o=[],h=e-1;h>=0;h--){for(var c="",p=0,l=0;l<t;l++){var u=r.board[a(l,h)];if(u<0)p++;else{p>0&&(c+=p,p=0);var v=r.pieces[u],b=i.pieceTypes[v.t].fenAbbrev||i.pieceTypes[v.t].abbrev||"?";v.s==-1?c+=b.toLowerCase():c+=b.toUpperCase()}}p&&(c+=p),o.push(c)}var f=o.join("/");f+=" ",1==r.mWho?f+="w":f+="b",f+=" ";var d="";return r.castled&&(r.castled[1]===!1?d+="KQ":(r.castled[1].k&&(d+="K"),r.castled[1].q&&(d+="Q")),r.castled[-1]===!1?d+="kq":(r.castled[-1].k&&(d+="k"),r.castled[-1].q&&(d+="q"))),0==d.length&&(d="-"),f+=d,f+=" ",r.epTarget?f+=s(r.epTarget.p):f+="-",f+=" ",f+=r.noCaptCount,f+=" ",f+=Math.floor(n/2)+1}return{boardSize:t*e,width:t,height:e,C:r,R:i,POS:a,Graph:n,PosName:s,PosByName:o,CompactCrit:h,GetDistances:c,distEdge:function(){for(var a=[],n=0;n<t*e;n++){var s=r(n),o=i(n);a[n]=Math.min(s,Math.abs(t-s-1),o,Math.abs(e-o-1))}return a}(),corners:function(){var r={};return r[a(0,0)]=1,r[a(0,e-1)]=1,r[a(t-1,0)]=1,r[a(t-1,e-1)]=1,r}(),ExportBoardState:p}},Model.Game.cbPawnGraph=function(t,e,r){for(var i=this,a={},n=0;n<t.boardSize;n++)if(!r||n in r){var s=[],o=t.Graph(n,[0,e]);null!=o&&(!r||o in r)&&s.push(i.cbTypedArray([o|i.cbConstants.FLAG_MOVE])),[-1,1].forEach(function(a){var o=t.Graph(n,[a,e]);null!=o&&(!r||o in r)&&s.push(i.cbTypedArray([o|i.cbConstants.FLAG_CAPTURE]))}),a[n]=s}else a[n]=[];return a},Model.Game.cbInitialPawnGraph=function(t,e,r){for(var i=this,a={},n=0;n<t.boardSize;n++)if(!r||n in r){var s=[],o=t.Graph(n,[0,e]);if(null!=o&&(!r||o in r)){var h=[o|i.cbConstants.FLAG_MOVE],c=t.Graph(o,[0,e]);null!=c&&(!r||c in r)&&h.push(c|i.cbConstants.FLAG_MOVE),s.push(i.cbTypedArray(h))}[-1,1].forEach(function(a){var o=t.Graph(n,[a,e]);null!=o&&(!r||o in r)&&s.push(i.cbTypedArray([o|i.cbConstants.FLAG_CAPTURE]))}),a[n]=s}else a[n]=[];return a},Model.Game.cbKingGraph=function(t,e){return this.cbShortRangeGraph(t,[[-1,-1],[-1,0],[-1,1],[0,-1],[0,1],[1,-1],[1,0],[1,1]],e)},Model.Game.cbKnightGraph=function(t,e){return this.cbShortRangeGraph(t,[[2,-1],[2,1],[-2,-1],[-2,1],[-1,2],[-1,-2],[1,2],[1,-2]],e)},Model.Game.cbHorseGraph=function(t){for(var e=this,r={},i=0;i<t.boardSize;i++)r[i]=[],[[1,0,2,-1],[1,0,2,1],[-1,0,-2,-1],[-1,0,-2,1],[0,1,-1,2],[0,-1,-1,-2],[0,1,1,2],[0,-1,1,-2]].forEach(function(a){var n=t.Graph(i,[a[0],a[1]]);if(null!=n){var s=t.Graph(i,[a[2],a[3]]);null!=s&&r[i].push(e.cbTypedArray([n|e.cbConstants.FLAG_STOP,s|e.cbConstants.FLAG_MOVE|e.cbConstants.FLAG_CAPTURE]))}});return r},Model.Game.cbRookGraph=function(t,e){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0]],e)},Model.Game.cbBishopGraph=function(t,e){return this.cbLongRangeGraph(t,[[1,-1],[1,1],[-1,1],[-1,-1]],e)},Model.Game.cbQueenGraph=function(t,e){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0],[1,-1],[1,1],[-1,1],[-1,-1]],e)},Model.Game.cbXQGeneralGraph=function(t,e){for(var r=this,i={},a=0;a<t.boardSize;a++)i[a]=[],[[-1,0,!1],[0,-1,!0],[0,1,!0],[1,0,!1]].forEach(function(n){var s=[],o=t.Graph(a,n);if(null!=o&&((!e||o in e)&&s.push(o|r.cbConstants.FLAG_MOVE|r.cbConstants.FLAG_CAPTURE),n[2]))for(var h=t.Graph(o,n);null!=h;)!e||h in e?s.push(h|r.cbConstants.FLAG_CAPTURE|r.cbConstants.FLAG_CAPTURE_KING):s.push(h|r.cbConstants.FLAG_STOP),h=t.Graph(h,n);s.length>0&&i[a].push(r.cbTypedArray(s))});return i},Model.Game.cbXQSoldierGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e]])},Model.Game.cbXQPromoSoldierGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e],[-1,0],[1,0]])},Model.Game.cbXQAdvisorGraph=function(t,e){return this.cbShortRangeGraph(t,[[1,1],[-1,1],[1,-1],[-1,-1]],e)},Model.Game.cbXQCannonGraph=function(t){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0]],null,this.cbConstants.FLAG_MOVE|this.cbConstants.FLAG_SCREEN_CAPTURE)},Model.Game.cbXQElephantGraph=function(t,e){for(var r=this,i={},a=0;a<t.boardSize;a++)i[a]=[],(!e||a in e)&&[[1,1,2,2],[1,-1,2,-2],[-1,1,-2,2],[-1,-1,-2,-2]].forEach(function(n){var s=t.Graph(a,[n[0],n[1]]);if(null!=s){var o=t.Graph(a,[n[2],n[3]]);null!=o&&(!e||o in e)&&i[a].push(r.cbTypedArray([s|r.cbConstants.FLAG_STOP,o|r.cbConstants.FLAG_MOVE|r.cbConstants.FLAG_CAPTURE]))}});return i},Model.Game.cbSilverGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e],[-1,-1],[-1,1],[1,-1],[1,1]])},Model.Game.cbFersGraph=function(t,e){return this.cbShortRangeGraph(t,[[-1,-1],[-1,1],[1,-1],[1,1]])},Model.Game.cbSchleichGraph=function(t,e){return this.cbShortRangeGraph(t,[[-1,0],[1,0],[0,-1],[0,1]])},Model.Game.cbAlfilGraph=function(t,e){return this.cbShortRangeGraph(t,[[-2,-2],[-2,2],[2,2],[2,-2]])}}(),function(){for(var t=Model.Game.cbBoardGeometryGrid(10,8),e={},r=0;r<t.boardSize;r++)r>=0&&r<=1||r>=10&&r<=11||r>=20&&r<=21||r>=30&&r<=31||r>=48&&r<=49||r>=58&&r<=59||r>=68&&r<=69||r>=78&&r<=79||(e[r]=1);Model.Game.cbDefine=function(){return{geometry:t,pieceTypes:{0:{name:"pawn-w",aspect:"pawn",graph:this.cbPawnGraph(t,1,e),value:1,abbrev:"",fenAbbrev:"P",epCatch:!0},1:{name:"ipawn-w",aspect:"pawn",graph:this.cbInitialPawnGraph(t,1,e),value:1,abbrev:"",fenAbbrev:"P",initial:[{s:1,p:12},{s:1,p:13},{s:1,p:14},{s:1,p:15},{s:1,p:16},{s:1,p:17},{s:1,p:18},{s:1,p:19}],epCatch:!0,epTarget:!0},2:{name:"pawn-b",aspect:"pawn",graph:this.cbPawnGraph(t,-1,e),value:1,abbrev:"",fenAbbrev:"P",epCatch:!0},3:{name:"ipawn-b",aspect:"pawn",graph:this.cbInitialPawnGraph(t,-1,e),value:1,abbrev:"",fenAbbrev:"P",initial:[{s:-1,p:60},{s:-1,p:61},{s:-1,p:62},{s:-1,p:63},{s:-1,p:64},{s:-1,p:65},{s:-1,p:66},{s:-1,p:67}],epCatch:!0,epTarget:!0},4:{name:"knight",graph:this.cbKnightGraph(t,e),value:2.9,abbrev:"N",initial:[{s:1,p:3},{s:1,p:8},{s:-1,p:71},{s:-1,p:76}]},5:{name:"bishop",graph:this.cbBishopGraph(t,e),value:3.1,abbrev:"B",initial:[{s:1,p:4},{s:1,p:7},{s:-1,p:72},{s:-1,p:75}]},6:{name:"rook",graph:this.cbRookGraph(t,e),value:5,abbrev:"R",initial:[{s:1,p:2},{s:1,p:9},{s:-1,p:70},{s:-1,p:77}],castle:!0},7:{name:"queen",graph:this.cbQueenGraph(t,e),initial:[{s:1,p:5},{s:-1,p:74}],abbrev:"Q"},8:{name:"king",isKing:!0,graph:this.cbKingGraph(t,e),abbrev:"K",initial:[{s:1,p:6},{s:-1,p:73}]}},promote:function(e,r,i){return 1==r.t?[0]:3==r.t?[2]:0==r.t&&7==t.R(i.t)?[4,5,6,7]:2==r.t&&0==t.R(i.t)?[4,5,6,7]:[]},castle:{"6/2":{k:[5,4],r:[3,4,5],n:"O-O-O"},"6/9":{k:[7,8],r:[8,7],n:"O-O"},"73/77":{k:[74,75],r:[76,75,74],n:"O-O-O"},"73/70":{k:[72,71],r:[71,72],n:"O-O"}},evaluate:function(e,r,i){var a=i[1].count,n=i[-1].count;a[0]||a[1]||a[4]||a[5]||a[6]||a[7]||n[2]||n[3]||n[6]||n[7]||!(n[4]+n[5]<2||n[5]<2)||(this.mFinished=!0,this.mWinner=JocGame.DRAW),n[2]||n[3]||n[4]||n[5]||n[6]||n[7]||a[0]||a[1]||a[6]||a[7]||!(a[4]+a[5]<2||a[5]<2)||(this.mFinished=!0,this.mWinner=JocGame.DRAW),this.noCaptCount>=100&&(this.mFinished=!0,this.mWinner=JocGame.DRAW);var s,o=e.cbUseTypedArrays?new Int8Array(3):[0,0,0],h=t.height,c=i[1].byType[0];if(c){s=c.length;for(var p=0;p<s;p++)switch(h-t.R(c[p].p)){case 2:o[0]++;break;case 3:o[1]++;break;case 4:o[2]++}}if(c=i[-1].byType[2]){s=c.length;for(var p=0;p<s;p++)switch(t.R(c[p].p)){case 1:o[0]--;break;case 2:o[1]--;break;case 3:o[2]--}}0!=o[0]&&(r.distPawnPromo1=o[0]),0!=o[1]&&(r.distPawnPromo2=o[1]),0!=o[2]&&(r.distPawnPromo3=o[2]);for(var l=0,u=4;u<=5;u++)for(var v=1;v>=-1;v-=2){var b=i[v].byType[u];if(b)for(var p=0;p<b.length;p++)b[p].m&&(l+=v)}0!=l&&(r.minorPiecesMoved=l)}}}}();

/***/ }),

/***/ "/QhT":
/***/ (function(module, exports) {

exports.config = {"status":true,"model":{"js":["reversi-model.js"],"plazza":"true","released":1409239768,"title-en":"Annexation Cross","module":"reversi","summary":"Reversi/Othello rules on a cross-shaped board","thumbnail":"thumb-cross.png","rules":{"en":"rules-cross.html"},"credits":{"en":"credits.html"},"description":{"en":"description.html"},"gameOptions":{"preventRepeat":true,"uctTransposition":"state","levelOptions":{"stableFactor":20,"aboutStableFactor":-20,"aboutStableBorderFactor":-15,"borderFactor":5,"aboutBorderFactor":-4,"countFactor":1,"mobilityFactor":5},"width":8,"height":8,"deadCells":{"0:0":"#","0:1":"#","1:0":"#","1:1":"#","0:7":"#","0:6":"#","1:7":"#","1:6":"#","7:0":"#","7:1":"#","6:0":"#","6:1":"#","7:7":"#","7:6":"#","6:7":"#","6:6":"#"},"initial":{"1":["3:4","4:3"],"-1":["3:3","4:4"]}},"debugEval":true,"levels":[{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.65,"ignoreLeaf":false,"log":true,"uncertaintyFactor":3,"name":"easy","label":"Easy","maxNodes":1000},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.65,"ignoreLeaf":false,"log":true,"uncertaintyFactor":3,"name":"fast","label":"Fast [1sec]","maxDuration":1,"isDefault":true},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.65,"ignoreLeaf":false,"log":true,"uncertaintyFactor":3,"name":"medium","label":"Medium","maxNodes":10000,"maxDuration":10},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.65,"ignoreLeaf":false,"log":true,"uncertaintyFactor":3,"name":"strong","label":"Strong","maxNodes":20000,"maxDuration":15}]},"view":{"title-en":"Annex View","js":["reversi-xd-view.js"],"xdView":true,"useNotation":true,"useShowMoves":true,"module":"reversi","skins":[{"name":"classic3d","title":"3D Classic","3d":true,"camera":{"radius":14,"elevationAngle":45,"distMax":39.5,"distMin":10.1,"elevationMin":-89.9,"elevationMax":89.9,"limitCamMoves":true,"fov":45},"world":{"lightIntensity":0.7,"skyLightIntensity":0.3,"lightPosition":{"x":10,"y":18,"z":0},"lightShadowDarkness":0.35,"color":4686804,"ambientLightColor":5592405,"fog":false},"preload":["image|/res/xd-view/pass-dark.png","image|/res/xd-view/pass-light.png","image|/res/images/wood-chipboard-5.jpg","image|/res/xd-view/reversi-pieces-2-textures.png","image|/res/xd-view/reversi-pieces-2-textures-bump.png","smoothedfilegeo|0|/res/xd-view/ring-target.js","smoothedfilegeo|0|/res/xd-view/reversi-pieces-6.js"]},{"name":"classic2d","title":"2D Classic","preload":["image|/res/xd-view/pass-dark.png","image|/res/xd-view/pass-light.png","image|/res/xd-view/boardtexture.jpg","image|/res/xd-view/cellshadows.png","image|/res/xd-view/sprites.png","image|/res/xd-view/select-target-2d.png"]}],"visuals":{"600x600":["res/visuals/cross-600x600-3d.jpg","res/visuals/cross-600x600-2d.jpg"]}}}

/***/ }),

/***/ "/TOt":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var async_1 = __webpack_require__("CGGv");
var Subscriber_1 = __webpack_require__("mmVS");
/**
 * Ignores source values for `duration` milliseconds, then emits the most recent
 * value from the source Observable, then repeats this process.
 *
 * <span class="informal">When it sees a source values, it ignores that plus
 * the next ones for `duration` milliseconds, and then it emits the most recent
 * value from the source.</span>
 *
 * <img src="./img/auditTime.png" width="100%">
 *
 * `auditTime` is similar to `throttleTime`, but emits the last value from the
 * silenced time window, instead of the first value. `auditTime` emits the most
 * recent value from the source Observable on the output Observable as soon as
 * its internal timer becomes disabled, and ignores source values while the
 * timer is enabled. Initially, the timer is disabled. As soon as the first
 * source value arrives, the timer is enabled. After `duration` milliseconds (or
 * the time unit determined internally by the optional `scheduler`) has passed,
 * the timer is disabled, then the most recent source value is emitted on the
 * output Observable, and this process repeats for the next source value.
 * Optionally takes a {@link IScheduler} for managing timers.
 *
 * @example <caption>Emit clicks at a rate of at most one click per second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.auditTime(1000);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link audit}
 * @see {@link debounceTime}
 * @see {@link delay}
 * @see {@link sampleTime}
 * @see {@link throttleTime}
 *
 * @param {number} duration Time to wait before emitting the most recent source
 * value, measured in milliseconds or the time unit determined internally
 * by the optional `scheduler`.
 * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
 * managing the timers that handle the rate-limiting behavior.
 * @return {Observable<T>} An Observable that performs rate-limiting of
 * emissions from the source Observable.
 * @method auditTime
 * @owner Observable
 */
function auditTime(duration, scheduler) {
    if (scheduler === void 0) { scheduler = async_1.async; }
    return this.lift(new AuditTimeOperator(duration, scheduler));
}
exports.auditTime = auditTime;
var AuditTimeOperator = (function () {
    function AuditTimeOperator(duration, scheduler) {
        this.duration = duration;
        this.scheduler = scheduler;
    }
    AuditTimeOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new AuditTimeSubscriber(subscriber, this.duration, this.scheduler));
    };
    return AuditTimeOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var AuditTimeSubscriber = (function (_super) {
    __extends(AuditTimeSubscriber, _super);
    function AuditTimeSubscriber(destination, duration, scheduler) {
        _super.call(this, destination);
        this.duration = duration;
        this.scheduler = scheduler;
        this.hasValue = false;
    }
    AuditTimeSubscriber.prototype._next = function (value) {
        this.value = value;
        this.hasValue = true;
        if (!this.throttled) {
            this.add(this.throttled = this.scheduler.schedule(dispatchNext, this.duration, this));
        }
    };
    AuditTimeSubscriber.prototype.clearThrottle = function () {
        var _a = this, value = _a.value, hasValue = _a.hasValue, throttled = _a.throttled;
        if (throttled) {
            this.remove(throttled);
            this.throttled = null;
            throttled.unsubscribe();
        }
        if (hasValue) {
            this.value = null;
            this.hasValue = false;
            this.destination.next(value);
        }
    };
    return AuditTimeSubscriber;
}(Subscriber_1.Subscriber));
function dispatchNext(subscriber) {
    subscriber.clearThrottle();
}
//# sourceMappingURL=auditTime.js.map

/***/ }),

/***/ "/ZwV":
/***/ (function(module, exports) {

exports.config = {"status":true,"model":{"plazza":"true","released":1398178575,"title-en":"Micro Chess","module":"chessbase","summary":"4x5 chess variant by Glimne (1997)","thumbnail":"micro4x5-thumb.png","rules":{"en":"micro4x5-rules.html"},"credits":{"en":"micro4x5-credits.html"},"gameOptions":{"preventRepeat":true,"uctTransposition":"state","uctIgnoreLoop":false,"levelOptions":{"pieceValueFactor":1,"pieceValueRatioFactor":1,"posValueFactor":0.1,"averageDistKingFactor":-0.01,"castleFactor":0.1,"minorPiecesMovedFactor":0.1,"checkFactor":0.2,"endingKingFreedomFactor":0.01,"endingDistKingFactor":0.05,"distKingCornerFactor":0.1}},"obsolete":false,"js":["base-model.js","grid-geo-model.js","micro4x5-model.js"],"levels":[{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"easy","label":"Easy","maxNodes":1000},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"fast","label":"Fast [1sec]","maxDuration":1,"isDefault":true},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"medium","label":"Medium","maxNodes":10000,"maxDuration":10},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"strong","label":"Strong","maxNodes":20000,"maxDuration":15}],"description":{"en":"micro4x5-description.html"}},"view":{"title-en":"Chessbase view","module":"chessbase","xdView":true,"css":["chessbase.css"],"preferredRatio":1,"useShowMoves":true,"useNotation":true,"useAutoComplete":true,"defaultOptions":{"sounds":true,"moves":true,"notation":false,"autocomplete":false},"skins":[{"name":"skin3d","title":"3D Classic","3d":true,"preload":["smoothedfilegeo|0|/res/ring-target.js","image|/res/images/cancel.png","image|/res/images/wikipedia.png","smoothedfilegeo|0|/res/staunton/pawn/pawn-classic.js","image|/res/staunton/pawn/pawn-diffusemap.jpg","image|/res/staunton/pawn/pawn-normalmap.jpg","smoothedfilegeo|0|/res/staunton/knight/knight.js","image|/res/staunton/knight/knight-diffusemap.jpg","image|/res/staunton/knight/knight-normalmap.jpg","smoothedfilegeo|0|/res/staunton/bishop/bishop.js","image|/res/staunton/bishop/bishop-diffusemap.jpg","image|/res/staunton/bishop/bishop-normalmap.jpg","smoothedfilegeo|0|/res/staunton/rook/rook.js","image|/res/staunton/rook/rook-diffusemap.jpg","image|/res/staunton/rook/rook-normalmap.jpg","smoothedfilegeo|0|/res/staunton/queen/queen.js","image|/res/staunton/queen/queen-diffusemap.jpg","image|/res/staunton/queen/queen-normalmap.jpg","smoothedfilegeo|0|/res/staunton/king/king.js","image|/res/staunton/king/king-diffusemap.jpg","image|/res/staunton/king/king-normalmap.jpg"],"world":{"lightIntensity":1.3,"skyLightIntensity":1.2,"lightCastShadow":true,"fog":false,"color":4686804,"lightPosition":{"x":-9,"y":9,"z":9},"skyLightPosition":{"x":9,"y":9,"z":9},"lightShadowDarkness":0.55,"ambientLightColor":2236962},"camera":{"fov":45,"distMax":50,"radius":18,"elevationAngle":60,"elevationMin":0}},{"name":"skin2d","title":"2D Classic","3d":false,"preload":["image|/res/images/cancel.png","image|/res/images/whitebg.png","image|/res/images/wikipedia.png"]}],"animateSelfMoves":false,"switchable":true,"sounds":{"move1":"alq_move1","move2":"alq_move2","move3":"alq_move3","move4":"alq_move2","tac1":"alq_tac1","tac2":"alq_tac2","tac3":"alq_tac1","promo":"promo","usermove":null},"js":["base-view.js","grid-board-view.js","staunton-set-view.js","micro4x5-view.js"],"visuals":{"600x600":["res/visuals/micro4x5-600x600-3d.jpg","res/visuals/micro4x5-600x600-2d.jpg"]}}}

/***/ }),

/***/ "/lY3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var startWith_1 = __webpack_require__("Ji1V");
Observable_1.Observable.prototype.startWith = startWith_1.startWith;
//# sourceMappingURL=startWith.js.map

/***/ }),

/***/ "/rMs":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var concat_1 = __webpack_require__("8MUz");
Observable_1.Observable.prototype.concat = concat_1.concat;
//# sourceMappingURL=concat.js.map

/***/ }),

/***/ "09LQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__("mmVS");
var Subscription_1 = __webpack_require__("B00U");
/**
 * Returns an Observable that mirrors the source Observable, but will call a specified function when
 * the source terminates on complete or error.
 * @param {function} callback Function to be called when source terminates.
 * @return {Observable} An Observable that mirrors the source, but will call the specified function on termination.
 * @method finally
 * @owner Observable
 */
function _finally(callback) {
    return this.lift(new FinallyOperator(callback));
}
exports._finally = _finally;
var FinallyOperator = (function () {
    function FinallyOperator(callback) {
        this.callback = callback;
    }
    FinallyOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new FinallySubscriber(subscriber, this.callback));
    };
    return FinallyOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var FinallySubscriber = (function (_super) {
    __extends(FinallySubscriber, _super);
    function FinallySubscriber(destination, callback) {
        _super.call(this, destination);
        this.add(new Subscription_1.Subscription(callback));
    }
    return FinallySubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=finally.js.map

/***/ }),

/***/ "0Aw5":
/***/ (function(module, exports) {

exports.model=Model={Game:{},Board:{},Move:{}},Model.Game.InitGameInfo=function(){},Model.Game.BuildGraphCoord=function(){var i=[],t=[];this.g.Graph=i,this.g.Coord=t},Model.Game.InitGame=function(){this.BuildGraphCoord(),this.g.TripletsByPos=[];for(var i=0;i<this.g.Coord.length;i++)this.g.TripletsByPos[i]=[];for(var i in this.g.Triplets)if(this.g.Triplets.hasOwnProperty(i)){var t=this.g.Triplets[i];for(var e in t)if(t.hasOwnProperty(e)){var s=t[e];this.g.TripletsByPos[s].push(t)}}this.InitGameExtra()},Model.Game.DestroyGame=function(){},Model.Game.MillsDirections=4,Model.Game.MillsEachDirection=function(i,t){for(var e=0;e<this.MillsDirections;e++){var s=this.g.Graph[i][e];null!=s&&t(s)}},Model.Move.Init=function(i){this.f=i.f,this.t=i.t,this.c=i.c},Model.Move.CopyFrom=function(i){this.f=i.f,this.t=i.t,this.c=i.c},Model.Move.Equals=function(i){return this.t==i.t&&this.c==i.c&&this.f==i.f},Model.Move.ToString=function(){var i="";return this.f>-1&&(i+=this.f+">"),i+=this.t,this.c>-1&&(i+="x"+this.c),i},Model.Board.Init=function(i){},Model.Board.InitialPosition=function(i){var t=i.g.Coord.length,e=i.mOptions.mencount;this.board=[];for(var s=0;s<t;s++)this.board[s]=-1;this.pieces=[],this.dock={1:[],"-1":[]},this.menCount={1:0,"-1":0};for(var o=0,n=0;n<2;n++)for(var r=0==n?1:-1,h=0;h<e;h++)this.dock[r].unshift(o),this.pieces.push({s:r,a:!0,d:h,p:-1,i:o++});this.placing=!0},Model.Board.StaticGenerateMoves=function(i){if(0==i.mFullPlayedMoves.length){for(var t=[],e=0;e<i.g.Coord.length;e++)t.push({f:-1,t:e,c:-1});return t}return null},Model.Board.GenerateMoves=function(i){this.mMoves=[],this.placing?this.GeneratePlacingMoves(i):i.mOptions.canFly?this.GenerateFlyingMoves(i):this.GenerateMovingMoves(i),0==this.mMoves.length&&(this.mFinished=!0,this.menCount[JocGame.PLAYER_A]+this.menCount[JocGame.PLAYER_B]==i.g.Coord.length?this.mWinner=JocGame.DRAW:this.mWinner=-this.mWho)},Model.Board.GeneratePlacingMoves=function(i){for(var t=0;t<i.g.Coord.length;t++)if(this.board[t]==-1){var e=!0;if(void 0!==i.mLevelInfo&&i.mCurrentLevel>=0){var s=i.mLevelInfo.maxDepth-i.mCurrentLevel;if(s>=i.mLevelInfo.placingRace){e=!1;for(var o in i.g.TripletsByPos[t])if(i.g.TripletsByPos[t].hasOwnProperty(o)){for(var n=i.g.TripletsByPos[t][o],r=0,h=0,a=0,l=0;l<3;l++)this.board[n[l]]==-1?a++:this.pieces[this.board[n[l]]].s==this.mWho?r++:h++;if(2==r||1==r&&0==h||2==h){e=!0;break}}}}e&&this.GenerateCapturingMoves(i,{f:-1,t:t,c:-1})}},Model.Board.GenerateMovingMoves=function(i){$this=this;for(var t=0;t<this.pieces.length;t++){var e=this.pieces[t];e.a&&e.s==this.mWho&&i.MillsEachDirection(e.p,function(t){$this.board[t]==-1&&$this.GenerateCapturingMoves(i,{f:e.p,t:t,c:-1})})}},Model.Board.GenerateFlyingMoves=function(i){if(3!=this.menCount[this.mWho])this.GenerateMovingMoves(i);else for(var t=0;t<this.pieces.length;t++){var e=this.pieces[t];if(e.a&&e.s==this.mWho)for(var s=0;s<this.board.length;s++)this.board[s]==-1&&this.GenerateCapturingMoves(i,{f:e.p,t:s,c:-1})}},Model.Board.GenerateCapturingMoves=function(i,t){for(var e in i.g.TripletsByPos[t.t])if(i.g.TripletsByPos[t.t].hasOwnProperty(e)){for(var s=i.g.TripletsByPos[t.t][e],o=!0,n=0;n<3;n++){var r=s[n];if(r!=t.t){if(this.board[r]==-1||t.f==r){o=!1;break}var h=this.pieces[this.board[r]];if(0==h.a||h.d>-1||h.s!=this.mWho){o=!1;break}}}if(o){if(3==this.menCount[-this.mWho]&&0==this.placing)return void this.mMoves.push({f:t.f,t:t.t,c:-2});for(var a=[],n=0;n<this.pieces.length;n++){var h=this.pieces[n];if(1==h.a&&h.d==-1&&h.s==-this.mWho){var l={f:t.f,t:t.t,c:h.p};a.push(l)}}if(0==i.mOptions.poundInMill){var u={};for(var c in i.g.Triplets)if(i.g.Triplets.hasOwnProperty(c)){var f=i.g.Triplets[c];this.board[f[0]]!=-1&&this.pieces[this.board[f[0]]].s==-this.mWho&&this.board[f[1]]!=-1&&this.pieces[this.board[f[1]]].s==-this.mWho&&this.board[f[2]]!=-1&&this.pieces[this.board[f[2]]].s==-this.mWho&&(u[f[0]]=!0,u[f[1]]=!0,u[f[2]]=!0)}for(var d=[],c=0;c<a.length;c++)u[a[c].c]||d.push(a[c]);d.length>0&&(a=d)}return void(this.mMoves=this.mMoves.concat(a))}}this.mMoves.push({f:t.f,t:t.t,c:-1})},Model.Board.Evaluate=function(i,t,e){if(i.GetRepeatOccurence(this)>2)return this.mFinished=!0,void(this.mWinner=JocGame.DRAW);if(0==this.placing){if(this.menCount[JocGame.PLAYER_A]<3)return this.mFinished=!0,void(this.mWinner=JocGame.PLAYER_B);if(this.menCount[JocGame.PLAYER_B]<3)return this.mFinished=!0,void(this.mWinner=JocGame.PLAYER_A)}var s=this.menCount[JocGame.PLAYER_A]-this.menCount[JocGame.PLAYER_B],o=0,n=0;for(var r in i.g.Triplets)if(i.g.Triplets.hasOwnProperty(r)){for(var h={"-1":0,0:0,1:0},a=i.g.Triplets[r],l=0;l<3;l++){var u=a[l],c=this.board[u];if(c>-1){var f=this.pieces[c];h[f.s]++}}1==h[1]&&0==h[-1]?o++:2==h[1]&&0==h[-1]&&n++,1==h[-1]&&0==h[1]?o--:2==h[-1]&&0==h[1]&&n--}this.mEvaluation=10*s,this.mEvaluation+=1*o,this.mEvaluation+=3*n},Model.Board.ApplyMove=function(i,t){if(this.placing){var e=this.dock[this.mWho].shift(),s=this.pieces[e];s.d=-1,s.p=t.t,this.board[t.t]=e,this.lastMoveIndex=e,this.menCount[this.mWho]++,0==this.dock[JocGame.PLAYER_B].length&&(this.placing=!1)}else{var s=this.pieces[this.board[t.f]];this.board[s.p]=-1,this.board[t.t]=s.i,s.p=t.t,this.lastMoveIndex=s.i}if(t.c>-1){var e=this.board[t.c];this.board[t.c]=-1;var s=this.pieces[e];s.a=!1,this.menCount[-this.mWho]--}else t.c==-2&&this.menCount[-this.mWho]--},Model.Board.IsValidMove=function(i,t){return!0},Model.Game.InitGameExtra=function(){},Model.Game.BuildGraphCoord=function(){this.g.Graph=[[1,6,null,null],[2,4,0,null],[null,9,1,null],[4,7,null,null],[5,null,3,1],[null,8,4,null],[7,13,null,0],[null,10,6,3],[9,12,null,5],[null,15,8,2],[11,null,null,7],[12,14,10,null],[null,null,11,8],[14,null,null,6],[15,null,13,11],[null,null,14,9]],this.g.Coord=[[0,0],[0,2],[0,4],[1,1],[1,2],[1,3],[2,0],[2,1],[2,3],[2,4],[3,1],[3,2],[3,3],[4,0],[4,2],[4,4]],this.g.Triplets=[[0,1,2],[3,4,5],[10,11,12],[13,14,15],[0,6,13],[3,7,10],[5,8,12],[2,9,15]]},Model.Board.StaticGenerateMoves=function(i){if(0==i.mFullPlayedMoves.length){for(var t=[0,2,3,5,10,12,13,15],e=[],s=0;s<t.length;s++)t.push({f:-1,t:t[s],c:-1});return e}return null};

/***/ }),

/***/ "0EZR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Observable_1 = __webpack_require__("rCTf");
var tryCatch_1 = __webpack_require__("+3eL");
var errorObject_1 = __webpack_require__("WhVc");
var AsyncSubject_1 = __webpack_require__("5c/I");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var BoundCallbackObservable = (function (_super) {
    __extends(BoundCallbackObservable, _super);
    function BoundCallbackObservable(callbackFunc, selector, args, context, scheduler) {
        _super.call(this);
        this.callbackFunc = callbackFunc;
        this.selector = selector;
        this.args = args;
        this.context = context;
        this.scheduler = scheduler;
    }
    /* tslint:enable:max-line-length */
    /**
     * Converts a callback API to a function that returns an Observable.
     *
     * <span class="informal">Give it a function `f` of type `f(x, callback)` and
     * it will return a function `g` that when called as `g(x)` will output an
     * Observable.</span>
     *
     * `bindCallback` is not an operator because its input and output are not
     * Observables. The input is a function `func` with some parameters, but the
     * last parameter must be a callback function that `func` calls when it is
     * done.
     *
     * The output of `bindCallback` is a function that takes the same parameters
     * as `func`, except the last one (the callback). When the output function
     * is called with arguments, it will return an Observable. If `func` function
     * calls its callback with one argument, the Observable will emit that value.
     * If on the other hand callback is called with multiple values, resulting
     * Observable will emit an array with these arguments.
     *
     * It is very important to remember, that input function `func` is not called
     * when output function is, but rather when Observable returned by output
     * function is subscribed. This means if `func` makes AJAX request, that request
     * will be made every time someone subscribes to resulting Observable, but not before.
     *
     * Optionally, selector function can be passed to `bindObservable`. That function
     * takes the same arguments as callback, and returns value
     * that will be emitted by Observable instead of callback parameters themselves.
     * Even though by default multiple arguments passed to callback appear in the stream as array,
     * selector function will be called with arguments directly, just as callback would.
     * This means you can imagine default selector (when one is not provided explicitly)
     * as function that aggregates all its arguments into array, or simply returns first argument,
     * if there is only one.
     *
     * Last optional parameter - {@link Scheduler} - can be used to control when call
     * to `func` happens after someone subscribes to Observable, as well as when results
     * passed to callback will be emitted. By default subscription to Observable calls `func`
     * synchronously, but using `Scheduler.async` as last parameter will defer call to input function,
     * just like wrapping that call in `setTimeout` with time `0` would. So if you use async Scheduler
     * and call `subscribe` on output Observable, all function calls that are currently executing,
     * will end before `func` is invoked.
     *
     * When it comes to emitting results passed to callback, by default they are emitted
     * immediately after `func` invokes callback. In particular, if callback is called synchronously,
     * then subscription to resulting Observable will call `next` function synchronously as well.
     * If you want to defer that call, using `Scheduler.async` will, again, do the job.
     * This means that by using `Scheduler.async` you can, in a sense, ensure that `func`
     * always calls its callback asynchronously, thus avoiding terrifying Zalgo.
     *
     * Note that Observable created by output function will always emit only one value
     * and then complete right after. Even if `func` calls callback multiple times, values from
     * second and following calls will never appear in the stream. If you need to
     * listen for multiple calls, you probably want to use {@link fromEvent} or
     * {@link fromEventPattern} instead.
     *
     * If `func` depends on some context (`this` property), that context will be set
     * to the same context that output function has at call time. In particular, if `func`
     * is called as method of some object, in order to preserve proper behaviour,
     * it is recommended to set context of output function to that object as well,
     * provided `func` is not already bound.
     *
     * If input function calls its callback in "node style" (i.e. first argument to callback is
     * optional error parameter signaling whether call failed or not), {@link bindNodeCallback}
     * provides convenient error handling and probably is a better choice.
     * `bindCallback` will treat such functions without any difference and error parameter
     * (whether passed or not) will always be interpreted as regular callback argument.
     *
     *
     * @example <caption>Convert jQuery's getJSON to an Observable API</caption>
     * // Suppose we have jQuery.getJSON('/my/url', callback)
     * var getJSONAsObservable = Rx.Observable.bindCallback(jQuery.getJSON);
     * var result = getJSONAsObservable('/my/url');
     * result.subscribe(x => console.log(x), e => console.error(e));
     *
     *
     * @example <caption>Receive array of arguments passed to callback</caption>
     * someFunction((a, b, c) => {
     *   console.log(a); // 5
     *   console.log(b); // 'some string'
     *   console.log(c); // {someProperty: 'someValue'}
     * });
     *
     * const boundSomeFunction = Rx.Observable.bindCallback(someFunction);
     * boundSomeFunction().subscribe(values => {
     *   console.log(values) // [5, 'some string', {someProperty: 'someValue'}]
     * });
     *
     *
     * @example <caption>Use bindCallback with selector function</caption>
     * someFunction((a, b, c) => {
     *   console.log(a); // 'a'
     *   console.log(b); // 'b'
     *   console.log(c); // 'c'
     * });
     *
     * const boundSomeFunction = Rx.Observable.bindCallback(someFunction, (a, b, c) => a + b + c);
     * boundSomeFunction().subscribe(value => {
     *   console.log(value) // 'abc'
     * });
     *
     *
     * @example <caption>Compare behaviour with and without async Scheduler</caption>
     * function iCallMyCallbackSynchronously(cb) {
     *   cb();
     * }
     *
     * const boundSyncFn = Rx.Observable.bindCallback(iCallMyCallbackSynchronously);
     * const boundAsyncFn = Rx.Observable.bindCallback(iCallMyCallbackSynchronously, null, Rx.Scheduler.async);
     *
     * boundSyncFn().subscribe(() => console.log('I was sync!'));
     * boundAsyncFn().subscribe(() => console.log('I was async!'));
     * console.log('This happened...');
     *
     * // Logs:
     * // I was sync!
     * // This happened...
     * // I was async!
     *
     *
     * @example <caption>Use bindCallback on object method</caption>
     * const boundMethod = Rx.Observable.bindCallback(someObject.methodWithCallback);
     * boundMethod.call(someObject) // make sure methodWithCallback has access to someObject
     * .subscribe(subscriber);
     *
     *
     * @see {@link bindNodeCallback}
     * @see {@link from}
     * @see {@link fromPromise}
     *
     * @param {function} func Function with a callback as the last parameter.
     * @param {function} [selector] A function which takes the arguments from the
     * callback and maps those to a value to emit on the output Observable.
     * @param {Scheduler} [scheduler] The scheduler on which to schedule the
     * callbacks.
     * @return {function(...params: *): Observable} A function which returns the
     * Observable that delivers the same values the callback would deliver.
     * @static true
     * @name bindCallback
     * @owner Observable
     */
    BoundCallbackObservable.create = function (func, selector, scheduler) {
        if (selector === void 0) { selector = undefined; }
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i - 0] = arguments[_i];
            }
            return new BoundCallbackObservable(func, selector, args, this, scheduler);
        };
    };
    BoundCallbackObservable.prototype._subscribe = function (subscriber) {
        var callbackFunc = this.callbackFunc;
        var args = this.args;
        var scheduler = this.scheduler;
        var subject = this.subject;
        if (!scheduler) {
            if (!subject) {
                subject = this.subject = new AsyncSubject_1.AsyncSubject();
                var handler = function handlerFn() {
                    var innerArgs = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        innerArgs[_i - 0] = arguments[_i];
                    }
                    var source = handlerFn.source;
                    var selector = source.selector, subject = source.subject;
                    if (selector) {
                        var result_1 = tryCatch_1.tryCatch(selector).apply(this, innerArgs);
                        if (result_1 === errorObject_1.errorObject) {
                            subject.error(errorObject_1.errorObject.e);
                        }
                        else {
                            subject.next(result_1);
                            subject.complete();
                        }
                    }
                    else {
                        subject.next(innerArgs.length <= 1 ? innerArgs[0] : innerArgs);
                        subject.complete();
                    }
                };
                // use named function instance to avoid closure.
                handler.source = this;
                var result = tryCatch_1.tryCatch(callbackFunc).apply(this.context, args.concat(handler));
                if (result === errorObject_1.errorObject) {
                    subject.error(errorObject_1.errorObject.e);
                }
            }
            return subject.subscribe(subscriber);
        }
        else {
            return scheduler.schedule(BoundCallbackObservable.dispatch, 0, { source: this, subscriber: subscriber, context: this.context });
        }
    };
    BoundCallbackObservable.dispatch = function (state) {
        var self = this;
        var source = state.source, subscriber = state.subscriber, context = state.context;
        var callbackFunc = source.callbackFunc, args = source.args, scheduler = source.scheduler;
        var subject = source.subject;
        if (!subject) {
            subject = source.subject = new AsyncSubject_1.AsyncSubject();
            var handler = function handlerFn() {
                var innerArgs = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    innerArgs[_i - 0] = arguments[_i];
                }
                var source = handlerFn.source;
                var selector = source.selector, subject = source.subject;
                if (selector) {
                    var result_2 = tryCatch_1.tryCatch(selector).apply(this, innerArgs);
                    if (result_2 === errorObject_1.errorObject) {
                        self.add(scheduler.schedule(dispatchError, 0, { err: errorObject_1.errorObject.e, subject: subject }));
                    }
                    else {
                        self.add(scheduler.schedule(dispatchNext, 0, { value: result_2, subject: subject }));
                    }
                }
                else {
                    var value = innerArgs.length <= 1 ? innerArgs[0] : innerArgs;
                    self.add(scheduler.schedule(dispatchNext, 0, { value: value, subject: subject }));
                }
            };
            // use named function to pass values in without closure
            handler.source = source;
            var result = tryCatch_1.tryCatch(callbackFunc).apply(context, args.concat(handler));
            if (result === errorObject_1.errorObject) {
                subject.error(errorObject_1.errorObject.e);
            }
        }
        self.add(subject.subscribe(subscriber));
    };
    return BoundCallbackObservable;
}(Observable_1.Observable));
exports.BoundCallbackObservable = BoundCallbackObservable;
function dispatchNext(arg) {
    var value = arg.value, subject = arg.subject;
    subject.next(value);
    subject.complete();
}
function dispatchError(arg) {
    var err = arg.err, subject = arg.subject;
    subject.error(err);
}
//# sourceMappingURL=BoundCallbackObservable.js.map

/***/ }),

/***/ "0FhH":
/***/ (function(module, exports) {

exports.config = {"status":true,"model":{"plazza":"true","title-en":"Alea Evangelii","module":"tafl","js":["tafl-model.js"],"summary":"19x19 board (from England)","thumbnail":"thumb-alea-evangelii.png","rules":{"en":"rules-alea-evangelii.html","fr":"rules-alea-evangelii-fr.html"},"description":{"en":"description.html","fr":"description-fr.html"},"credits":{"en":"credits.html","fr":"credits-fr.html"},"gameOptions":{"preventRepeat":true,"uctTransposition":"states","levelOptions":{"attackersCountFactor":10,"defendersCountFactor":-10,"kingPathFactor":-20,"kingFreedomFactor":-0.1,"distKingFactor":-0.05},"exclude":[0,18,342,360],"attackers":1,"longMove":true,"initial":{"attackers":[2,5,13,16,38,43,51,56,95,113,97,111,344,347,358,355,304,309,317,322,247,249,265,263,64,66,68,136,174,212,148,186,224,292,294,296,82,100,118,88,108,128,242,260,278,232,252,272],"defenders":{"king":180,"soldiers":[84,86,156,194,166,204,274,276,123,141,143,159,161,163,177,179,181,183,197,199,201,217,219,237]}},"homeCatch":true,"privateHome":true,"centerDistance":9},"demoRandom":true,"visuals":["res/visuals/alea-evangelii-600x600-3d.jpg","res/visuals/alea-evangelii-600x600-2d.jpg"],"levels":[{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.65,"uncertaintyFactor":3,"useAlphaBeta":true,"name":"easy","label":"Easy","maxNodes":1000},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.65,"uncertaintyFactor":3,"useAlphaBeta":true,"name":"fast","label":"Fast [1sec]","maxDuration":1,"isDefault":true},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.65,"uncertaintyFactor":3,"useAlphaBeta":true,"name":"strong","label":"Strong","maxNodes":10000,"maxDuration":10}]},"view":{"title-en":"Tafl view","module":"tafl","js":["tafl-xd-view.js"],"xdView":true,"css":["tafl.css"],"preferredRatio":1,"switchable":true,"useShowMoves":false,"useNotation":true,"sounds":{"death1":"death1","death2":"death2","death3":"death3","move1":"move1","move3":"move3"},"defaultOptions":{"sounds":true,"moves":true,"notation":false},"skins":[{"name":"tafl3d","title":"3D Classic","3d":true,"camera":{"limitCamMoves":true,"radius":14,"rotationAngle":90,"elevationAngle":89.9,"elevationMin":2,"elevationMax":89.9},"world":{"lightIntensity":0.8,"skyLightIntensity":0.5,"lightCastShadow":false,"fog":false,"color":1118481,"lightPosition":{"x":10,"y":5,"z":0},"lightShadowDarkness":0.55,"ambientLightColor":4473924},"preload":["image|/res/xd-view/meshes/woodtoken-diffuse-black.jpg","image|/res/xd-view/meshes/woodtoken-diffuse.jpg","image|/res/images/ardriboard_bgx1024.jpg","image|/res/images/ardricellborders.png","image|/res/images/ardriblackcell.png","image|/res/images/ardrikingcell.png","image|/res/images/blackcell.png","image|/res/images/whitecell.png","smoothedfilegeo|0|/res/xd-view/meshes/taflboard.js","smoothedfilegeo|0|/res/xd-view/meshes/ring-target.js","smoothedfilegeo|0|/res/xd-view/meshes/woodtoken.js"]},{"name":"tafl2d","title":"2D Classic","3d":false,"preload":["image|/res/xd-view/meshes/ardri-sprites.png","image|/res/images/ardriboard_bgx1024.jpg","image|/res/images/ardricellborders.png","image|/res/images/ardriblackcell.png","image|/res/images/ardrikingcell.png","image|/res/images/blackcell.png","image|/res/images/whitecell.png"]}],"animateSelfMoves":false,"visuals":{"600x600":["res/visuals/alea-evangelii-600x600-3d.jpg","res/visuals/alea-evangelii-600x600-2d.jpg"]}}}

/***/ }),

/***/ "0GXu":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__("mmVS");
var EmptyObservable_1 = __webpack_require__("jBEF");
/**
 * Returns an Observable that repeats the stream of items emitted by the source Observable at most count times.
 *
 * <img src="./img/repeat.png" width="100%">
 *
 * @param {number} [count] The number of times the source Observable items are repeated, a count of 0 will yield
 * an empty Observable.
 * @return {Observable} An Observable that repeats the stream of items emitted by the source Observable at most
 * count times.
 * @method repeat
 * @owner Observable
 */
function repeat(count) {
    if (count === void 0) { count = -1; }
    if (count === 0) {
        return new EmptyObservable_1.EmptyObservable();
    }
    else if (count < 0) {
        return this.lift(new RepeatOperator(-1, this));
    }
    else {
        return this.lift(new RepeatOperator(count - 1, this));
    }
}
exports.repeat = repeat;
var RepeatOperator = (function () {
    function RepeatOperator(count, source) {
        this.count = count;
        this.source = source;
    }
    RepeatOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new RepeatSubscriber(subscriber, this.count, this.source));
    };
    return RepeatOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var RepeatSubscriber = (function (_super) {
    __extends(RepeatSubscriber, _super);
    function RepeatSubscriber(destination, count, source) {
        _super.call(this, destination);
        this.count = count;
        this.source = source;
    }
    RepeatSubscriber.prototype.complete = function () {
        if (!this.isStopped) {
            var _a = this, source = _a.source, count = _a.count;
            if (count === 0) {
                return _super.prototype.complete.call(this);
            }
            else if (count > -1) {
                this.count = count - 1;
            }
            source.subscribe(this._unsubscribeAndRecycle());
        }
    };
    return RepeatSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=repeat.js.map

/***/ }),

/***/ "0Iql":
/***/ (function(module, exports, __webpack_require__) {

var
    DamWebParser = __webpack_require__("irHR"),
    Game = __webpack_require__("WkCC").Game,
    Piece = __webpack_require__("WkCC").Piece
;

function DamWeb(position, notation) {
    this.position = position;
    this.notation = notation;
}

DamWeb.prototype.getGameCount = function(){
    return 1;
};

DamWeb.prototype.getTitle = function(numGame, pattern){
    return "";
};

DamWeb.prototype.getTitles = function(pattern){
    return [{"num":1, "title":""}];
};

DamWeb.prototype.getGame = function(numGame){
    var dw = new DamWebParser(this.position, this.notation);
    dw.parse();

    var game = new Game();

    // Position
    game.board.setPosition(Piece.PAWN_WHITE, dw.getWPList());
    game.board.setPosition(Piece.DAME_WHITE, dw.getWKList());
    game.board.setPosition(Piece.PAWN_BLACK, dw.getBPList());
    game.board.setPosition(Piece.DAME_BLACK, dw.getBKList());

    // Notation
    var moves = dw.getMoveList();
    for (var i = 0; i < moves.length; i++) {
        var iStart = moves[i][0];
        var iEnd = moves[i][1];

        if (iStart != null && iEnd != null) {
            game.addMove(iStart, iEnd);
        } else {
            break;
        }
    }

    return game;
};


module.exports = DamWeb;


/***/ }),

/***/ "0Khi":
/***/ (function(module, exports) {

exports.config = {"status":true,"model":{"plazza":"true","title-en":"Yohoho!","module":"yohoho","js":["hexbase-model.js","yohoho-model.js"],"gameOptions":{"maxLines":9,"maxCols":17,"orientation":"onACorner","boardLayout":["#.#.#.#.#.#.#.#.#",".#.#.#.#.#.#.#.#.","#.#.#.#.#.#.#.#.#",".#.#.#.#.#.#.#.#.","c.c.c.c.c.c.c.c.c",".#.#.#.#.#.#.#.#.","#.#.#.#.#.#.#.#.#",".#.#.#.#.#.#.#.#.","#.#.#.#.#.#.#.#.#"],"initial":{"a":["#.#.#.#.#.#.#.#.#",".#.#.#.#.#.#.#.#.","#.#.#.#.#.#.#.#.#",".#.#.#.#.#.#.#.#.","#.#.#.#.#.#.#.#.#",".#.#.#.#.#.#.#.#.","#.#.#.#.C.#.#.#.#",".#.#.#.#.#.#.#.#.","#.p.p.c.r.c.p.p.#"],"b":["#.p.p.c.r.c.p.p.#",".#.#.#.#.#.#.#.#.","#.#.#.#.C.#.#.#.#",".#.#.#.#.#.#.#.#.","#.#.#.#.#.#.#.#.#",".#.#.#.#.#.#.#.#.","#.#.#.#.#.#.#.#.#",".#.#.#.#.#.#.#.#.","#.#.#.#.#.#.#.#.#"]},"maxNbCellsPerMove":3,"margin":1},"levels":[{"label":"Cabin boy","potential":1000,"isDefault":true,"maxDepth":1,"moveCount":12,"calRatio":3.31},{"label":"Sailor","potential":4000,"maxDepth":5,"moveCount":15,"rowRaceLevel":1,"calRatio":25.16},{"label":"Officer","potential":20000,"maxDepth":6,"moveCount":20,"rowRaceLevel":3,"calRatio":126.18},{"label":"Captain","potential":40000,"maxDepth":8,"moveCount":25,"rowRaceLevel":4,"calRatio":130.51},{"label":"Admiral","potential":100000,"maxDepth":8,"moveCount":25,"rowRaceLevel":4,"calRatio":192.22}],"defaultLevel":2,"summary":"Sea Battle over hexagons","rules":{"en":"rules.html","fr":"rules-fr.html"},"credits":{"en":"credits.html"},"description":{"en":"description.html"},"thumbnail":"yohoho-thumb3d.png"},"view":{"title-en":"Yohoho View","module":"yohoho","js":["yohoho-xd-view.js"],"visuals":{"600x600":["res/visuals/yohoho-600x600-3d.jpg","res/visuals/yohoho-600x600-2d.jpg"]},"css":["yohoho.css"],"switchable":true,"useShowMoves":true,"useNotation":true,"animateSelfMoves":false,"sounds":{"win":"yohoho_final","loss":"yohoho_final_lose","end":"yohoho_final","assault":"yohoho_assault","yohoho1":"yohoho1","yohoho2":"yohoho2","yohoho3":"yohoho3","yohoho4":"yohoho4","move":"yohoho_moveon"},"skins":[{"name":"cartoon3d","title":"Cartoon (3D)","3d":true,"camera":{"radius":12,"limitCamMoves":true,"elevationMin":0},"world":{"lightIntensity":1,"skyLightIntensity":0,"fog":false,"fogNear":15,"fogFar":80,"fogColor":"#ffffff"},"preload":["image|/res/xd-view/meshes/baril-256.jpg","image|/res/xd-view/meshes/explosion-256.png","image|/res/xd-view/meshes/jarmada-admiral-pirate-uvs-512.jpg","image|/res/xd-view/meshes/jarmada-admiral-uvs-512.jpg","image|/res/xd-view/meshes/jarmada-admiral-voiles-pirate-uvs-512.jpg","image|/res/xd-view/meshes/jarmada-admiral-voiles-uvs-512.jpg","image|/res/xd-view/meshes/jarmada-frigate-pirate-uvs-512.jpg","image|/res/xd-view/meshes/jarmada-frigate-uvs-512.jpg","image|/res/xd-view/meshes/jarmada-gallion-pirate-uvs-512.jpg","image|/res/xd-view/meshes/jarmada-gallion-uvs-512.jpg","image|/res/xd-view/meshes/ocean-texture.jpg","image|/res/xd-view/meshes/ocean-texture2.jpg","image|/res/xd-view/meshes/palm-leaves-texture-512.png","image|/res/xd-view/meshes/wood-texture.jpg","smoothedfilegeo|0|/res/xd-view/meshes/landscape-smoothed.js","smoothedfilegeo|0|/res/xd-view/meshes/jarmada-frigate.js","smoothedfilegeo|0|/res/xd-view/meshes/jarmada-gallion.js","smoothedfilegeo|0|/res/xd-view/meshes/jarmada-rock.js","smoothedfilegeo|0|/res/xd-view/meshes/jarmada-admiral.js"]},{"name":"official","title":"Official"},{"name":"stylized","title":"Stylized"}],"boardBackgrounds":{"official":"oceanboard.jpg","officialnosound":"oceanboard.jpg","stylized":"winddirection.png","basic":"winddirection.png","stylizednosound":"winddirection.png","basicnosound":"winddirection.png"},"defaultOptions":{"sounds":true,"notation":false,"moves":true},"preferredRatio":1.1164274322169,"xdView":true}}

/***/ }),

/***/ "0S1u":
/***/ (function(module, exports) {

exports.model=Model={Game:{},Board:{},Move:{}},function(){function t(t){if(o){var e=t%s;return(t-e)/s*s+s-e}var r=s*i-t-1,n=r%s;return r-n+s-n}var s,i,o=!1;Model.Game.checkersPosToString=t,Model.Game.InitGameInfo=function(){},Model.Game.BuildGraphCoord=function(){var t=(this.mOptions.width,this.mOptions.height,[]),s=[];this.g.Graph=t,this.g.Coord=s},Model.Game.InitGame=function(){var t=this.mOptions.width,e=this.mOptions.height;if(s=t,i=e,o=this.mOptions.invertNotation||!1,this.g.compulsoryCatch=!0,this.g.canStepBack=!0,this.g.mustMoveForward=!1,this.g.mustMoveForwardStrict=!1,this.g.lastRowFreeze=!1,this.g.lastRowCrown=!1,this.g.captureLongestLine=!1,this.g.noMove="lose",this.g.kingCaptureShort=!1,this.g.kingValue=5,this.g.lastRowFactor=0,this.g.canCaptureBackward=!0,this.g.captureInstantRemove=!1,this.g.longRangeKing=!0,this.g.drawKvsK=!0,this.g.drawKvs2K=!0,this.g.whiteStarts=!0,this.g.king180deg=!1,this.mOptions.variant)for(var r in this.mOptions.variant)this.mOptions.variant.hasOwnProperty(r)&&(this.g[r]=this.mOptions.variant[r]);this.BuildGraphCoord(),this.zobrist=new JocGame.Zobrist({board:{type:"array",size:this.g.Graph.length,values:["1/0","1/1","-1/0","-1/1"]}})},Model.Game.DestroyGame=function(){},Model.Game.CheckersDirections=4,Model.Game.Checkers2WaysDirections=[0,1,1,0],Model.Game.CheckersEachDirection=function(t,s){for(var i=0;i<this.CheckersDirections;i++){var o=this.g.Graph[t][i];if(null!=o&&0==s(o,i))return}},Model.Move.Init=function(t){this.pos=[];for(var s=t.pos?Object.keys(t.pos).sort():[],i=0;i<s.length;i++)this.pos.push(t.pos[i]);this.capt=[];for(var o=t.capt?Object.keys(t.capt).sort():[],i=0;i<o.length;i++)this.capt.push(t.capt[i])},Model.Move.ToString=function(s){s=s||"natural";var i=this;switch(s){case"natural":return function(){for(var s=[t(i.pos[0]),t(i.pos[i.pos.length-1])],o="-",e=1;e<i.capt.length;e++)null!=i.capt[e]&&(o="x",i.capt.length>3&&s.push(t(i.capt[e])));return s.join(o)}();case"hub":return function(){var s="-",o=[t(i.pos[0]),t(i.pos[i.pos.length-1])];if(i.capt[1]){s="x";var e=i.capt.slice(1).map(function(s){return t(s)});e.sort(),o=o.concat(e)}return o.join(s)}();case"dxp":return function(){var s=[t(i.pos[0]),t(i.pos[i.pos.length-1])];if(i.capt[1]){s.push(i.capt.length-1);for(var o=[],e=1;e<i.capt.length;e++)o.push(t(i.capt[e]));o.sort(),s=s.concat(o)}else s.push(0);return s.map(function(t){return t<10?"0"+t:t}).join("")}();default:return"??"}},Model.Board.Init=function(t){this.zSign=0},Model.Board.InitialPosition=function(t){var s=t.mOptions.width,i=t.mOptions.height,o=t.mOptions.initial;this.board=[];for(var e=0;e<i;e++)for(var r=0;r<s;r++)this.board[e*s+r]=-1;this.pieces=[];var n=0;if(t.mInitial){this.pCount=[0,0],this.spCount=[0,0],this.kpCount=[0,0];for(var a=0;a<t.mInitial.pieces.length;a++){var h=t.mInitial.pieces[a];this.board[h.p]=a,this.pieces.push({s:h.s,p:h.p,l:-1,t:h.t,plp:h.p}),this.zSign=t.zobrist.update(this.zSign,"board",h.s+"/"+h.t,h.p);var p=-(h.s-1)/2;this.pCount[p]++,0==h.t?this.spCount[p]++:this.kpCount[p]++}}else{for(var a in o.a)if(o.a.hasOwnProperty(a)){var u=o.a[a],c=u[0]*s+u[1],h={s:JocGame.PLAYER_A,p:c,l:-1,t:0,plp:c};this.pieces.push(h),this.board[c]=n++,this.zSign=t.zobrist.update(this.zSign,"board","1/0",c)}for(var a in o.b)if(o.b.hasOwnProperty(a)){var u=o.b[a],c=u[0]*s+u[1],h={s:JocGame.PLAYER_B,p:c,l:-1,t:0,plp:c};this.pieces.push(h),this.board[c]=n++,this.zSign=t.zobrist.update(this.zSign,"board","-1/0",c)}this.pCount=[o.a.length,o.b.length],this.spCount=[o.a.length,o.b.length],this.kpCount=[o.a.length,o.b.length]}},Model.Board.GenerateMoves=function(t){try{this._GenerateMoves(t)}catch(t){}},Model.Board._GenerateMoves=function(t){function s(t){for(var s=0;s<e.pieces.length;s++){var i=e.pieces[s];i&&i.s==e.mWho&&t(s,i.p)}}function i(s,o,r,n,a){for(;;){var h=[],p=[],u=[];if(t.CheckersEachDirection(s,function(i,c){var l;0==t.g.canCaptureBackward&&(l=t.g.Coord[s][0]);var g=t.Checkers2WaysDirections[c];if(a){if(t.g.longRangeKing)for(;e.board[i]==-1||t.g.king180deg&&null!=i&&r.indexOf(i)>=0;)i=t.g.Graph[i][c];if(null!=i&&e.board[i]>=0&&e.pieces[e.board[i]].s==-e.mWho){var v=i;if(i=t.g.Graph[i][c],t.g.kingCaptureShort){if(e.board[i]==-1||i==o[0]){for(var f=!0,d=0;d<n.length;d++)if(t.g.king180deg){if(r[d]==v){f=!1;break}}else if(t.g.captureInstantRemove&&r[d]==v||0==t.g.captureInstantRemove&&r[d]==v&&n[d]==g){f=!1;break}f&&(h.push(i),p.push(v),u.push(g)),i=t.g.Graph[i][c]}}else for(;e.board[i]==-1||i==o[0];){for(var f=!0,d=0;d<n.length;d++)if(t.g.captureInstantRemove&&r[d]==v||0==t.g.captureInstantRemove&&r[d]==v&&n[d]==g){f=!1;break}f&&(h.push(i),p.push(v),u.push(g)),i=t.g.Graph[i][c]}}}else if(e.board[i]>=0&&e.pieces[e.board[i]].s==-e.mWho){var m,C;if(0==t.g.canCaptureBackward&&(m=t.g.Coord[i][0],C=!1,(e.mWho==JocGame.PLAYER_A&&m>=l||e.mWho==JocGame.PLAYER_B&&m<=l)&&(C=!0)),t.g.canCaptureBackward||1==C){var b=t.g.Graph[i][c];if(null!=b&&(e.board[b]==-1||b==o[0])){for(var f=!0,d=0;d<n.length;d++)if(t.g.captureInstantRemove&&r[d]==i||0==t.g.captureInstantRemove&&r[d]==i&&n[d]==g){f=!1;break}f&&(h.push(b),p.push(i),u.push(g))}}}return!0}),0==h.length){o.length>1&&e.mMoves.push({pos:o,capt:r});break}if(!t.g.compulsoryCatch&&o.length>1){for(var c=[],l=0;l<o.length;l++)c.push(o[l]);for(var g=[],l=0;l<r.length;l++)g.push(r[l]);e.mMoves.push({pos:c,capt:g})}if(1!=h.length){for(var l=0;l<h.length;l++){for(var c=[],v=0;v<o.length;v++)c.push(o[v]);c.push(h[l]);for(var g=[],v=0;v<r.length;v++)g.push(r[v]);g.push(p[l]);for(var f=[],v=0;v<n.length;v++)f.push(n[v]);f.push(u[l]),i(h[l],c,g,f,a)}break}s=h[0],o.push(s),r.push(p[0]),n.push(u[0])}}var o=t.mOptions.height,e=this;if(this.mMoves=[],s(function(t,s){0==e.pieces[t].t?i(s,[s],[null],[null],!1):1==e.pieces[t].t&&i(s,[s],[null],[null],!0)}),0!=t.g.compulsoryCatch&&0!=this.mMoves.length||s(function(s,i){var r;0==e.pieces[s].t?((t.g.mustMoveForward||t.g.mustMoveForwardStrict||t.lastRowFreeze)&&(r=t.g.Coord[i][0]),t.CheckersEachDirection(i,function(n,a){var h,p,u;return t.g.mustMoveForwardStrict?(h=t.g.Coord[n][0],p=!1,(e.mWho==JocGame.PLAYER_A&&h>r||e.mWho==JocGame.PLAYER_B&&h<r)&&(p=!0)):t.g.mustMoveForward&&(h=t.g.Coord[n][0],p=!0,(e.mWho==JocGame.PLAYER_A&&h<r||e.mWho==JocGame.PLAYER_B&&h>r)&&(p=!1)),t.g.lastRowFreeze&&(u=!1,(e.mWho==JocGame.PLAYER_A&&r==o-1||e.mWho==JocGame.PLAYER_B&&0==r)&&(u=!0)),e.board[n]!=-1||!t.g.canStepBack&&n==e.pieces[s].l||(0!=t.g.mustMoveForward||0!=t.g.mustMoveForwardStrict)&&1!=p||0!=t.g.lastRowFreeze&&0!=u||e.mMoves.push({pos:[i,n],capt:[null,null]}),!0})):1==e.pieces[s].t&&t.CheckersEachDirection(i,function(s,o){if(t.g.longRangeKing)for(;e.board[s]==-1;)e.mMoves.push({pos:[i,s],capt:[null,null]}),s=t.g.Graph[s][o];else e.board[s]==-1&&(e.mMoves.push({pos:[i,s],capt:[null,null]}),s=t.g.Graph[s][o]);return!0})}),0==this.mMoves.length)switch(t.g.noMove){case"count":this.mFinished=!0,this.pCount[0]<this.pCount[1]?this.mWinner=JocGame.PLAYER_B:this.pCount[1]<this.pCount[0]?this.mWinner=JocGame.PLAYER_A:this.mWinner=JocGame.DRAW;break;case"lose":this.mFinished=!0,this.mWinner=-this.mWho;break;default:this.mFinished=!0,this.mWinner=JocGame.DRAW}if(t.g.captureLongestLine){for(var r=this.mMoves,n=[],a=0,h=0;h<r.length;h++){var p=r[h];p.pos.length==a?n.push(p):p.pos.length>a&&(n=[p],a=p.pos.length)}this.mMoves=n}},Model.Board.Evaluate=function(t,s,i){if(t.mOptions.preventRepeat&&t.GetRepeatOccurence(this)>2)return this.mFinished=!0,void(this.mWinner=JocGame.DRAW);if(t.g.drawKvsK&&0==this.spCount[0]&&0==this.spCount[1]&&1==this.kpCount[0]&&1==this.kpCount[1])return this.mFinished=!0,void(this.mWinner=JocGame.DRAW);if(t.g.drawKvs2K&&0==this.spCount[0]&&0==this.spCount[1]&&this.kpCount[0]+this.kpCount[1]==3&&(1==this.kpCount[0]||2==this.kpCount[0]))return this.mFinished=!0,void(this.mWinner=JocGame.DRAW);if(0==this.pCount[1])return this.mFinished=!0,void(this.mWinner=JocGame.PLAYER_A);if(0==this.pCount[0])return this.mFinished=!0,void(this.mWinner=JocGame.PLAYER_B);if(this.mEvaluation=10*(this.spCount[0]-this.spCount[1])+10*(this.kpCount[0]-this.kpCount[1])*t.g.kingValue+this.pCount[0]/this.pCount[1]-this.pCount[1]/this.pCount[0],0!=t.g.lastRowFactor){for(var o=t.mOptions.height,e=0,r=0,n=0;n<this.pieces.length;n++){var a=this.pieces[n];a&&0==a.t&&(this.mWho==JocGame.PLAYER_A?e+=t.g.Coord[a.p][0]:r+=o-1-t.g.Coord[a.p][0])}this.mEvaluation+=(e-r)*t.g.lastRowFactor}},Model.Board.CopyFrom=function(t){this.board=[];for(var s=0;s<t.board.length;s++)this.board[s]=t.board[s];this.pieces=[];for(var s=0;s<t.pieces.length;s++){var i=t.pieces[s];this.pieces[s]=null==i?null:{s:i.s,p:i.p,l:i.l,t:i.t,plp:i.plp}}this.pCount=[t.pCount[0],t.pCount[1]],this.spCount=[t.spCount[0],t.spCount[1]],this.kpCount=[t.kpCount[0],t.kpCount[1]],this.mWho=t.mWho,this.zSign=t.zSign},Model.Board.ApplyMove=function(t,s){var i=(t.mOptions.width,t.mOptions.height),o=s.pos[0],e=this.board[o],r=this.pieces[e],n=r.s;r.l=o;var a={};this.zSign=t.zobrist.update(this.zSign,"board",r.s+"/"+r.t,r.p);for(var h=1;h<s.pos.length;h++){var p=s.pos[h];this.board[r.p]=-1,r.p=p,this.board[p]=e;var u=s.capt[h];null!=u&&(this.board[u]>=0&&(a[this.board[u]]=!0),this.board[u]=-1),o=p}this.zSign=t.zobrist.update(this.zSign,"board",r.s+"/"+r.t,p);var c=s.capt[s.capt.length-1];r.plp=c||s.pos[s.pos.length-2];for(var l in a)if(a.hasOwnProperty(l)){var g=this.pieces[l],v=(1-g.s)/2;switch(this.pCount[v]--,g.t){case 0:this.spCount[v]--;break;case 1:this.kpCount[v]--}this.zSign=t.zobrist.update(this.zSign,"board",g.s+"/"+g.t,g.p),this.pieces[l]=null}if(t.g.lastRowCrown&&0==this.pieces[e].t){var f=t.g.Coord[s.pos[s.pos.length-1]][0];if(n==JocGame.PLAYER_A&&f==i-1||n==JocGame.PLAYER_B&&0==f){var g=this.pieces[e];g.t=1;var d=(1-n)/2;this.spCount[d]--,this.kpCount[d]++,this.zSign=t.zobrist.update(this.zSign,"board",g.s+"/0",g.p),this.zSign=t.zobrist.update(this.zSign,"board",g.s+"/1",g.p)}}},Model.Board.IsValidMove=function(t,s){return!0},Model.Board.GetSignature=function(){return this.zSign},Model.Game.Import=function(t,s){function i(t,s,i){i=r-i;var o=i%n;i=i-o+n-o-1,e.push({s:t,p:i,l:-1,t:s,plp:i})}var o=1,e=[],r=this.mOptions.width*this.mOptions.height,n=this.mOptions.width;if("pjn"==t){var a=s.split(":");o="W"==a[0]?1:-1;for(var h=1;h<a.length;h++)if(0!=a[h].length)for(var p="W"==a[h].substr(0,1)?1:-1,u=a[h].substr(1).split(","),c=0;c<u.length;c++){var l=u[c],g=0;"K"==l.substr(0,1)&&(g=1,l=l.substr(1));var v=/^([0-9]+)-([0-9]+)$/.exec(l);if(v)for(var f=parseInt(v[1]);f<=parseInt(v[2]);f++)i(p,g,f);else i(p,g,parseInt(l))}return e.sort(function(t,s){return s.s-t.s}),{status:!0,initial:{pieces:e,turn:o}}}return{status:!1,error:"unsupported"}};var e=JocGame.prototype.GetBestMatchingMove;Model.Game.GetBestMatchingMove=function(t,s){var i=[],o=this;s.forEach(function(t){"function"==typeof t.ToString?i.push(t.ToString()):i.push(o.CreateMove(t).ToString())}),t=t.replace(/0([1-9])/g,"$1");var r=/^([0-9]+)[\-x]([0-9]+)([\-x][0-9]+)*$/.exec(t);if(r){var n=new RegExp("^"+r[1]+"[-x]"+r[2]+"([-x][0-9]+)*$"),a={};s.forEach(function(t,s){if(n.test(i[s])){var o=i[s],e=/^([0-9]+)x([0-9]+)x([0-9]+(x[0-9]+)*)/.exec(o);if(e){var r=e[3].split("x");r.sort(function(t,s){return parseInt(t)-parseInt(s)}),o=e[1]+"x"+e[2]+"x"+r.join("x")}a[o]=t}});var h=[];for(var p in a)a.hasOwnProperty(p)&&h.push(a[p]);h.length>0&&(s=h)}return e.call(this,t,s)},Model.Board.ExportBoardState=function(o,e){function r(t){for(var o=[],e=0;e<n.board.length;e++){var r=e%s,a=(e-r)/s,h=(i-a-1)*s+r,p=n.board[e];if(p<0)o[h]="e";else{var u=n.pieces[p],c=1==u.s?"w":t;1==u.t&&(c=c.toUpperCase()),o[h]=c}}return o.join("")}e=e||"natural";var n=this;switch(e){case"natural":case"fen":return function(){var s={},i=[];n.pieces.forEach(function(i){if(i&&null!=i.p){var o=1==i.s?"W":"B";void 0===s[o]&&(s[o]={});var e=1==i.t?"K":"";void 0===s[o][e]&&(s[o][e]={group:0==i.t,pos:[]}),s[o][e].pos.push(parseInt(t(i.p)))}});for(var o in s)if(s.hasOwnProperty(o)){var e=[];for(var r in s[o])if(s[o].hasOwnProperty(r)){var a=s[o][r];if(a.group){a.pos.sort(function(t,s){return parseInt(t)-parseInt(s)});var h=-2,p=-1,u=-1;a.pos.forEach(function(t){parseInt(t)==h+1?p=t:(p>=0?(e.push(r+u+"-"+p),p=-1):u>=0&&e.push(r+u),u=t),h=parseInt(t)}),p>=0?e.push(r+u+"-"+p):u>=0&&e.push(r+u)}else a.pos.forEach(function(t){e.push(r+t)})}i.push(o+e.join(","))}return i.join(":")}();case"dxp":return function(){return r("z")}();case"hub":return function(){return r("z")}();default:return JSON.stringify(this)}}}(),Model.Game.BuildGraphCoord=function(){for(var t=this.mOptions.width,s=this.mOptions.height,i=[],o=[],e=0;e<s;e++)for(var r=0;r<t;r++){var n=e*t+r;o[n]=[e,r],i[n]=[],e%2==0?(e<s-1?(i[n].push((e+1)*t+r),r>0?i[n].push((e+1)*t+r-1):i[n].push(null)):(i[n].push(null),i[n].push(null)),e>0?(i[n].push((e-1)*t+r),r>0?i[n].push((e-1)*t+r-1):i[n].push(null)):(i[n].push(null),i[n].push(null))):(e<s-1?(r<t-1?i[n].push((e+1)*t+r+1):i[n].push(null),i[n].push((e+1)*t+r)):(i[n].push(null),i[n].push(null)),e>0?(r<t-1?i[n].push((e-1)*t+r+1):i[n].push(null),i[n].push((e-1)*t+r)):(i[n].push(null),i[n].push(null)))}this.g.Graph=i,this.g.Coord=o};

/***/ }),

/***/ "0SFC":
/***/ (function(module, exports) {

exports.model=Model={Game:{},Board:{},Move:{}},function(){var t,s,o="undefined"!=typeof Int8Array;o?(t=function(t){return new Int8Array(t)},s=function(t){var s=new Int8Array(t.length);return s.set(t),s}):(t=function(t){for(var s=[],o=0;o<t;o++)s.push(0);return s},s=function(t){for(var s=[],o=t.length,i=0;i<o;i++)s.push(t[i]);return s}),Model.Game.isAlive=function(t,s){return this.POS(s,t)in this.g.confine},Model.Game.C=function(t){return t%this.mOptions.width},Model.Game.R=function(t){return Math.floor(t/this.mOptions.width)},Model.Game.RC=function(t){return{r:Math.floor(t/this.mOptions.width),c:t%this.mOptions.width}},Model.Game.POS=function(t,s){return s*this.mOptions.width+t},Model.Game.STR2POS=function(t){var s=/^(\d+):(\d+)$/.exec(t);if(s){var o=parseInt(s[1]),i=parseInt(s[2]);return this.POS(i,o)}return null},Model.Game.InitGame=function(){var s=this.NBCOLS=this.mOptions.width,o=this.NBROWS=this.mOptions.height;this.g.confine={},this.g.totalCount=o*s;for(var i=0;i<o;i++)for(var r=0;r<s;r++)this.g.confine[this.POS(r,i)]=1;if(this.mOptions.deadCells)for(var e in this.mOptions.deadCells){var a=this.STR2POS(e);null!=a&&(this.g.totalCount--,delete this.g.confine[a])}this.g.dirDeltaRC=[[1,-1],[1,0],[1,1],[0,1],[-1,1],[-1,0],[-1,-1],[0,-1]],this.g.Graph={};for(var i=0;i<o;i++)for(var r=0;r<s;r++){var a=this.POS(r,i);if(a in this.g.confine){for(var h=t(this.g.dirDeltaRC.length),n=0;n<this.g.dirDeltaRC.length;n++){var l=this.g.dirDeltaRC[n],v=i+l[0],d=r+l[1],u=v*s+d;v>=0&&d>=0&&v<o&&d<s&&u in this.g.confine?h[n]=u:h[n]=-1}this.g.Graph[a]=h}}this.g.corners={};for(var a in this.g.confine){for(var f=0,l=0;l<8;l++){var u=this.g.Graph[a][l];u<0&&(f|=1<<l)}15!=(15&f)&&30!=(30&f)&&60!=(60&f)&&120!=(120&f)&&240!=(240&f)&&225!=(225&f)&&195!=(195&f)&&135!=(135&f)||(this.g.corners[a]=1)}this.g.borders={};for(var a in this.g.confine)if(!(a in this.g.corners)){for(var f=0,l=0;l<8;l++){var u=this.g.Graph[a][l];u<0&&(f|=1<<l)}7!=(7&f)&&14!=(14&f)&&28!=(28&f)&&56!=(56&f)&&112!=(112&f)&&224!=(224&f)&&193!=(193&f)&&131!=(131&f)||(this.g.borders[a]=1)}this.zobrist=new JocGame.Zobrist({board:{type:"array",size:s*o,values:["1","-1"]}})},Model.Move.Init=function(t){this.row=t.row,this.col=t.col,this.pass=t.pass},Model.Move.CopyFrom=function(t){this.row=t.row,this.col=t.col,this.pass=t.pass},Model.Move.ToString=function(){return this.pass?"-":String.fromCharCode("a".charCodeAt(0)+this.col)+(this.row+1)},Model.Move.Equals=function(t){return!(!t.pass||!this.pass)||this.row==t.row&&this.col==t.col},Model.Board.Init=function(t){this.zSign=0},Model.Board.InitialPosition=function(s){this.board=t(s.mOptions.width*s.mOptions.height),this.counts=[0,0],this.freeClose={},this.passes=0,this.lastMove=null;var o=this;[1,-1].forEach(function(t){var i=(1-t)/2;s.mOptions.initial[t].forEach(function(r){o.counts[i]++;var e=s.STR2POS(r);o.board[e]=t,delete o.freeClose[e];for(var a=0;a<8;a++){var h=s.g.Graph[e][a];h<0||(o.board[h]||(o.freeClose[h]=1))}o.zSign=s.zobrist.update(o.zSign,"board",t,e)})}),this.FindMoves(s),this.stable={};for(var i in s.g.corners)this.stable[i]=3;this.aboutStable={},this.aboutBorder={},this.rvUpdateStable(s,s.g.corners),this.rvUpdateAboutBorder(s)},Model.Board.CopyFrom=function(t){this.mWho=t.mWho,this.zSign=t.zSign,this.board=s(t.board),this.counts=[t.counts[0],t.counts[1]],this.freeClose={};for(var o in t.freeClose)this.freeClose[o]=1;this.passes=t.passes,this.lastMove=null,t.lastMove?this.lastMove={row:t.lastMove.row,col:t.lastMove.col}:this.lastMove=null,this.movePoss={1:s(t.movePoss[1]),"-1":s(t.movePoss[-1])},this.stable=t.stable,this.aboutStable=t.aboutStable,this.aboutBorder=t.aboutBorder},Model.Board.GenerateMoves=function(t){this.mMoves=[];for(var s=0;s<this.movePoss[this.mWho].length;s++){var o=this.movePoss[this.mWho][s],i=t.RC(o);this.PushMove(t,{row:i.r,col:i.c})}0==this.mMoves.length&&this.PushMove(t,{pass:!0,row:-1,col:-1})},Model.Board.FindMoves=function(t){this.movePoss={1:[],"-1":[]};var s=t.g.Graph;for(var o in this.freeClose){for(var i=s[o],r=0,e=0;e<8;e++){var a=i[e];if(a>=0){var h=-this.board[a];if(h){var n=1==h?1:2;if(!(r&n)){for(!0,a=s[a][e];this.board[a]==-h;)a=s[a][e];if(a>=0&&this.board[a]==h&&(r|=n),3==r)break}}}}1&r&&this.movePoss[1].push(o),2&r&&this.movePoss[-1].push(o)}},Model.Board.ApplyMove=function(t,s){if(this.lastMove=null,s.pass)return void this.passes++;this.lastMove={row:s.row,col:s.col},this.passes=0;var o=(1-this.mWho)/2,i=1<<o;this.counts[o]++;var r=t.POS(s.col,s.row),e=t.g.Graph,a=e[r];this.board[r]=this.mWho,this.zSign=t.zobrist.update(this.zSign,"board",this.mWho,r),delete this.freeClose[r];var h=!1,n={};(this.stable[r]||0)&i&&(h=!0,n[r]=1);for(var l=0;l<8;l++){var v=a[l];v>=0&&0==this.board[v]&&(this.freeClose[v]=1);for(var d=[];v>=0&&this.board[v]==-this.mWho;)d.push(v),v=e[v][l];if(v>=0&&d.length>0&&this.board[v]==this.mWho)for(var u=d.length-1;u>=0;u--){var f=d[u];this.zSign=t.zobrist.update(this.zSign,"board",-this.mWho,f),this.zSign=t.zobrist.update(this.zSign,"board",this.mWho,f),this.board[f]=this.mWho,this.counts[o]++,this.counts[1-o]--,(this.stable[f]||0)&i&&(h=!0,n[f]=1)}}h&&this.rvUpdateStable(t,n),r in t.g.borders&&this.rvUpdateAboutBorder(t),this.FindMoves(t)},Model.Board.rvUpdateStable=function(t,s){var o=this.stable;this.stable={};for(var i in o)this.stable[i]=o[i];for(var r=!0,e=1==this.mWho?1:2,a=t.g.Graph;r;){r=!1;var h={};for(var i in s)for(var n=a[i],l=0;l<8;l++){var v=n[l];v>=0&&!((this.stable[v]||0)&e)&&(h[v]=1)}var s={};for(var i in h){for(var n=a[i],d=0,l=0;l<8;l++){var v=n[l];(v<0||this.board[v]==this.mWho&&(this.stable[v]||0)&e)&&(d|=1<<l)}15!=(15&d)&&30!=(30&d)&&60!=(60&d)&&120!=(120&d)&&240!=(240&d)&&225!=(225&d)&&195!=(195&d)&&135!=(135&d)||(this.stable[i]=(this.stable[i]||0)|e,r=!0,s[i]=1)}}this.aboutStable={};for(var i in this.stable)if(!this.board[i])for(var n=a[i],l=0;l<8;l++){var v=n[l];v>=0&&!(v in this.stable)&&(this.aboutStable[v]=(this.aboutStable[v]||0)|this.stable[i])}},Model.Board.rvUpdateAboutBorder=function(t){this.aboutBorder={};var s=t.g.Graph,o=t.g.borders;for(var i in o)if(!this.board[i])for(var r=s[i],e=0;e<8;e++){var a=r[e];!(a>=0)||a in this.stable||a in this.aboutStable||a in o||(this.aboutBorder[a]=1)}},Model.Board.Evaluate=function(t){this.mEvaluation=0;t.mOptions.width,t.mOptions.height;if(2==this.passes||this.counts[0]+this.counts[1]==t.g.totalCount||0==this.counts[0]||0==this.counts[1])return this.mFinished=!0,void(this.counts[0]>this.counts[1]?this.mWinner=JocGame.PLAYER_A:this.counts[0]<this.counts[1]?this.mWinner=JocGame.PLAYER_B:this.mWinner=JocGame.DRAW);var s=t.mOptions.levelOptions,o={},i={1:0,"-1":0},r={1:0,"-1":0},e={1:0,"-1":0},a={1:0,"-1":0},h=t.g.confine,n=t.g.borders;for(var l in h){var v=this.board[l];if(v){var d=1==v?1:2,u=1==v?2:1;(this.stable[l]||0)&d?i[v]++:(this.aboutStable[l]||0)&u?l in n?e[v]++:r[v]++:l in n&&a[v]++}}o.stable=i[1]-i[-1],o.aboutStable=r[1]-r[-1],o.aboutStableBorder=e[1]-e[-1],o.border=a[1]-a[-1],o.count=this.counts[0]-this.counts[1];var f=this.movePoss[1].length+this.movePoss[-1].length;o.mobility=f?(this.movePoss[1].length-this.movePoss[-1].length)/f:0;for(var b in o){var c=o[b],m=s[b+"Factor"]||0,g=c*m;this.mEvaluation+=g}},Model.Board.GetSignature=function(){return this.zSign}}();

/***/ }),

/***/ "0TiQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var publishLast_1 = __webpack_require__("QNuG");
Observable_1.Observable.prototype.publishLast = publishLast_1.publishLast;
//# sourceMappingURL=publishLast.js.map

/***/ }),

/***/ "0U/v":
/***/ (function(module, exports) {

exports.model=Model={Game:{},Board:{},Move:{}},Model.Game.InitGame=function(){for(var r=this,o=this.mOptions.size,e=[],t=[],i=0,a=0,n=[],s=0;s<o;s++)n.push(a),a+=(o-s)*(o-s);for(var s=0;s<o;s++)for(var p=0;p<o-s;p++)for(var u=0;u<o-s;u++){var l=i++;e[l]=[p,u,s],t[l]=[];for(var h=0;h<2;h++)for(var f=0;f<2;f++){var v=s-1,d=p+h,g=u+f;v>=0&&v<o&&d>=0&&d<o-v&&g>=0&&g<o-v?t[l].push(n[v]+d*(o-v)+g):t[l].push(null)}var c=[[0,-1],[0,1],[-1,0],[1,0]];for(var b in c){var m=c[b],v=s,d=p+m[0],g=u+m[1];v>=0&&v<o&&d>=0&&d<o-v&&g>=0&&g<o-v?t[l].push(n[v]+d*(o-v)+g):t[l].push(null)}for(var h=-1;h<1;h++)for(var f=-1;f<1;f++){var v=s+1,d=p+h,g=u+f;v>=0&&v<o&&d>=0&&d<o-v&&g>=0&&g<o-v?t[l].push(n[v]+d*(o-v)+g):t[l].push(null)}}this.g.Graph=t,this.g.Coord=e,this.g.Over=[],this.g.Beneath=[];for(var l=0;l<this.g.Graph.length;l++)this.g.Over[l]=null,this.g.Beneath[l]=null;for(var l=0;l<this.g.Graph.length;l++)for(var e=this.g.Coord[l],G=l+1;G<this.g.Graph.length;G++){var y=this.g.Coord[G];if(y[2]==e[2]+2&&y[0]==e[0]-1&&y[1]==e[1]-1){this.g.Over[l]=G,this.g.Beneath[G]=l;break}}this.g.EachDirection=function(o,e){for(var t=0;t<12;t++){var i=r.g.Graph[o][t];if(null!=i&&0==e(i,t))return}},this.g.EachDirectionDown=function(o,e){for(var t=[0,1,2,3],i=0;i<t.length;i++){var a=r.g.Graph[o][t[i]];if(null!=a&&0==e(a,t[i]))return}},this.g.EachDirectionUp=function(o,e){for(var t=[8,9,10,11],i=0;i<t.length;i++){var a=r.g.Graph[o][t[i]];if(null!=a&&0==e(a,t[i]))return}},this.g.EachDirectionFlat=function(o,e){for(var t=[4,5,6,7],i=0;i<t.length;i++){var a=r.g.Graph[o][t[i]];if(null!=a&&0==e(a,t[i]))return}},this.g.EachDirectionFlatDown=function(o,e){for(var t=[0,1,2,3,4,5,6,7],i=0;i<t.length;i++){var a=r.g.Graph[o][t[i]];if(null!=a&&0==e(a,t[i]))return}},this.g.EachDirectionFlatUp=function(o,e){for(var t=[4,5,6,7,8,9,10,11],i=0;i<t.length;i++){var a=r.g.Graph[o][t[i]];if(null!=a&&0==e(a,t[i]))return}},this.zobrist=new JocGame.Zobrist({board:{type:"array",size:this.g.Graph.length,values:[0,1]}}),this.InitGameExtra()},Model.Game.MapSameLevelDiagGraph=function(){for(var r=[0,16,25,29],o=0;o<4;o++)for(var e=0;e<4-o;e++)for(var t=0;t<4-o;t++)for(var i=r[o]+e*(4-o)+t,a=-1;a<2;a+=2)for(var n=-1;n<2;n+=2){var s=o,p=e+a,u=t+n;s>=0&&s<4&&p>=0&&p<4-s&&u>=0&&u<4-s?this.g.Graph[i].push(r[s]+p*(4-s)+u):this.g.Graph[i].push(null)}},Model.Game.InitGameExtra=function(){},Model.Game.DestroyGame=function(){this.DestroyGameExtra()},Model.Game.DestroyGameExtra=function(){},Model.Game.spUpdateZobrist=function(r,o,e,t,i,a){for(var n=0;n<o.length;n++)r=this.zobrist.update(r,"board",e,o[n]);for(var n=0;n<t.length;n++)r=this.zobrist.update(r,"board",i,t[n]);return r},Model.Move.Init=function(r){for(var o in r)r.hasOwnProperty(o)&&(this[o]=JSON.parse(JSON.stringify(r[o])))},Model.Move.ToString=function(){var r=["?","W","B","R"][this.clr],o="";switch(this.act){case"+":o+="+"+this.pos+r;break;case">":o+=this.from+">"+this.to+r}return o},Model.Board.Init=function(r){},Model.Board.InitialPosition=function(r){this.spInitialPosition(r)},Model.Board.spInitialPosition=function(r){this.board=[];for(var o=0;o<r.g.Graph.length;o++)this.board[o]=0;this.maxLayer=0,this.ballCount=[0,0,0],this.playables={},this.height=[0,0,0],this.zSign=0;for(var o=0;o<r.mOptions.size*r.mOptions.size;o++)this.playables[o]=!0},Model.Board.MakeFreeMoves=function(r){var o=[];for(var e in this.playables)o.push({act:"+",pos:e,clr:this.mWho==JocGame.PLAYER_A?1:2});return o},Model.Board.GenerateMoves=function(r){var o=this.GenerateAllMoves(r),e=r.mOptions.moveCount;0==o.length?(this.mFinished=!0,this.ballCount[1]>this.ballCount[2]?this.mWinner=JocGame.PLAYER_A:this.ballCount[1]<this.ballCount[2]?this.mWinner=JocGame.PLAYER_B:this.mWinner=JocGame.DRAW):void 0!==e&&o.length>e&&(r.ArrayShuffle(o),o.sort(function(r,o){o.nextBoard.evaluation,r.nextBoard.evaluation}),o.splice(e,o.length-e)),this.mMoves=o},Model.Board.GenerateAllMoves=function(r){return this.MakeFreeMoves(r)},Model.Board.Evaluate=function(r,o,e){this.mEvaluation=0},Model.Board.ApplyMove=function(r,o){this.spApplyMove(r,o)},Model.Board.spApplyMove=function(r,o){function e(o){delete t.playables[o],r.g.EachDirectionFlat(o,function(e,i){if(t.board[e]){var a,n;switch(i){case 4:a=7,n=10;break;case 5:a=6,n=9;break;case 6:a=4,n=8;break;case 7:a=5,n=11}var s=r.g.Graph[o][a];null!==s&&t.board[s]>0&&t.board[r.g.Graph[e][a]]&&(t.playables[r.g.Graph[o][n]]=!0)}})}var t=this;switch(o.act){case"+":this.board[o.pos]=o.clr;var i=r.g.Coord[o.pos][2];i>this.maxLayer&&(this.maxLayer=i),this.height[o.clr]+=i,this.ballCount[o.clr]++,e(o.pos);break;case">":o.down.length>0?this.playables[o.down[o.down.length-1]]=!0:this.playables[o.from]=!0;var a=o.from;for(var n in o.down){var s=o.down[n];this.height[this.board[s]]--,this.board[a]=this.board[s],a=s}this.board[a]=0,this.board[o.to]=o.clr;var i=r.g.Coord[o.to][2];this.height[o.clr]+=i,i>this.maxLayer&&(this.maxLayer=i),e(o.to)}},Model.Board.IsValidMove=function(r,o){return!0},Model.Board.ExtendMove=function(r,o){return{}},Model.Board.GetSignature=function(){return this.zSign},Model.Board.InitialPosition=function(r){this.spInitialPosition(r),this.groupMaxId=1,this.groups={},this.posGroup={},this.posFree={},this.center=0,this.moveEvaluation=0},Model.Board.GenerateAllMoves=function(r){for(var o=this.MakeFreeMoves(r),e=[],t=0;t<o.length;t++){var i=o[t],a=this.ExtendMove(r,i.pos);if(null!==a){i.nextBoard=a.board,i.remove=a.remove;var n=!1;r.mVisitedBoards&&r.mVisitedBoards[i.nextBoard.zSign]&&(n=!0),0==n&&e.push(i)}}return e},Model.Board.ExtendMove=function(r,o,e,t){function i(e){var t=p.board[e],i={side:t,p:{},pCount:1,f:{},fCount:0};i.p[e]=!0;for(var a=[e];a.length>0;){var n=a.pop();r.g.EachDirection(n,function(e,s){var u=p.board[e];if(u==t){if(e in i.p)return!0;var h=r.g.Over[e];if(null!==h&&(0!=p.board[h]||o==h))return!0;var f=G[s];if(void 0!==f){var v=r.g.Graph[n][f[0]],d=r.g.Graph[n][f[1]];if((v==o&&t==l||p.board[v]==3-t)&&(d==o&&t==l||p.board[d]==3-t))return!0}i.p[e]=!0,i.pCount++,a.push(e)}else if(0==u&&e!=o&&0==r.g.Coord[e][2]){if(e in i.f)return!0;i.f[e]=!0,i.fCount++}return!0})}return i}function a(r){var o=p.groupMaxId++;p.groups[o]=r;for(var e in r.p){p.posGroup[e];p.posGroup[e]=o}for(var t in r.f)void 0===p.posFree[t]&&(p.posFree[t]={}),p.posFree[t][o]=!0;return o}function n(r,o){var e=[];for(var t in o)e.push(t);for(var i=e[0],a=p.groups[i],n=1;n<e.length;n++){var t=e[n],s=p.groups[t];for(var u in s.p)a.p[u]=!0,p.posGroup[u]=i;a.pCount+=s.pCount;for(var l in s.f)l in a.f||(a.f[l]=!0,a.fCount++),delete p.posFree[l][t],p.posFree[l][i]=!0;delete p.groups[t]}if(r>=0){for(var l in b)l in a.f||(a.f[l]=!0,a.fCount++),void 0===p.posFree[l]&&(p.posFree[l]={}),p.posFree[l][i]=!0;a.p[r]=!0,a.pCount++,p.posGroup[r]=i}}function s(r,o,e){var t=p.groups[o];for(var i in e)i in t.f||(t.f[i]=!0,t.fCount++,void 0===p.posFree[i]&&(p.posFree[i]={}),p.posFree[i][o]=!0);t.p[r]=!0,t.pCount++,p.posGroup[r]=o}arguments.length<3&&(e=0),arguments.length<4&&(t=null),null==t&&(t=this);var p=JSON.parse(JSON.stringify({board:t.board,playables:t.playables,ballCount:t.ballCount,groups:t.groups,posFree:t.posFree,posGroup:t.posGroup,groupMaxId:t.groupMaxId,center:t.center,zSign:t.zSign,mWho:t.mWho})),u={};0==e&&(e=this.mWho==JocGame.PLAYER_A?1:2);var l=3-e,h=r.g.Coord[o],f=h[2],v={},d=0,g={},c=0,b={},m=0,G={4:[8,10],5:[9,11],6:[8,9],7:[10,11]},y={4:[0,2],5:[1,3],6:[0,1],7:[2,3]},M={},C={},F=r.g.Beneath[o];if(null!=F){var E=p.posGroup[F],B=p.groups[E];delete B.p[F],B.pCount--,p.posGroup[F]=0;var S=p.board[F],x=r.g.Coord[F][2];r.g.EachDirection(F,function(o,e){var t=p.board[o];if(r.g.Coord[o][2]==x){var i=G[e],a=r.g.Graph[F][i[0]],n=r.g.Graph[F][i[1]];if(null!=a&&p.board[a]==3-S&&null!=n||p.board[n]==3-S)return!0}return t==S&&p.posGroup[o]>0&&(C[o]=!0),!0})}f>0&&r.g.EachDirectionFlat(o,function(t,i){if(p.board[t]==e){var a=y[i],n=r.g.Graph[o][a[0]],s=r.g.Graph[o][a[1]];p.board[n]==l&&p.board[s]==l&&(p.posGroup[n]&&(C[n]=!0),p.posGroup[s]&&(C[s]=!0))}return!0});var D={};for(var z in C){var O=p.posGroup[z];D[O]=!0}for(var O in D)!function(r){var o=p.groups[r];for(var e in o.p)0!=p.posGroup[e]&&(p.posGroup[e]=-1);for(var t in o.f)delete p.posFree[t][r];delete p.groups[r]}(O);for(var z in C)p.posGroup[z]<0&&a(i(z));r.g.EachDirection(o,function(r){if(0==p.board[r])return!0;var o=p.posGroup[r];return 0==o||(p.board[r]==e?void 0===v[o]&&(v[o]=!0,d++):p.board[r]==l&&void 0===g[o]&&(g[o]=!0,c++),!0)}),0==f&&r.g.EachDirectionFlat(o,function(r){return 0==p.board[r]&&(b[r]=!0,m++),!0});var A=p.posFree[o];if(void 0!==A){for(var O in A){var B=p.groups[O];delete B.f[o],B.fCount--}delete p.posFree[o]}if(0==d){var B={side:e,p:{},pCount:1,f:b,fCount:m};B.p[o]=!0,a(B)}else if(1==d){for(var E in v);s(o,E,b)}else n(o,v);var w=!1;for(var E in p.groups)if(0!=E){var B=p.groups[E];B.side==l&&0==B.fCount&&(!function(e){var t=p.groups[e],n={},s={},l=[];for(var h in t.p)l.push({p:h,z:r.g.Coord[h][2]});l.sort(function(r,o){return o.z-r.z});for(var f=0;f<l.length;f++){var v=l[f],h=v.p,d=!1;if(r.g.EachDirectionUp(h,function(r){return!p.board[r]&&r!=o||(d=!0,!1)}),d)n[h]=!0,p.posGroup[h]=-1;else{0==v.z&&(s[h]=!0),p.board[h]=0,u[h]=!0,delete p.posGroup[h],p.ballCount[t.side]--,p.playables[h]=!0,r.g.EachDirectionUp(h,function(r){return p.playables[r]&&delete p.playables[r],!0});var g=r.g.Beneath[h];if(g)if(p.board[g]==t.side){var c=!1;if(r.g.EachDirectionDown(h,function(r){return p.board[r]!=t.side||(c=!0,!1)}),c){t.p[g]=!0,t.pCount++,p.posGroup[g]=e;for(var b={p:g,z:r.g.Coord[g][2]},m=f+1;m<l.length&&b.z<l[m].z;m++);l.splice(m,0,b)}else M[g]=!0}else M[g]=!0}}for(var G in t.f)delete p.posFree[G][e];delete p.groups[e];for(var G in s)r.g.EachDirectionFlat(G,function(r){var o=p.posGroup[r];if(void 0!==o&&o>0&&(void 0===p.posFree[G]&&(p.posFree[G]={}),void 0===p.posFree[G][o])){p.posFree[G][o]=!0;var e=p.groups[o];e.f[G]=!0,e.fCount++}return!0});for(var h in n)p.posGroup[h]==-1&&a(i(h))}(E),w=!0)}for(var z in M)if(0==p.posGroup[z]){var I=p.board[z],J={},P=0,W={},k=0,L=r.g.Coord[z][2];if(r.g.EachDirection(z,function(o,e){if(0==p.board[o])return!0;var t=p.posGroup[o];if(0==t)return!0;if(r.g.Coord[o][2]==L){var i=G[e],a=r.g.Graph[z][i[0]],n=r.g.Graph[z][i[1]];if(null!=a&&p.board[a]==3-I&&null!=n&&p.board[n]==3-I)return!0}return p.board[o]==I?void 0===J[t]&&(J[t]=!0,P++):0==p.board[o]&&0==r.g.Coord[o][2]&&(W[o]=!0,k++),!0}),0==P){var B={side:I,p:{},pCount:1,f:W,fCount:k};B.p[z]=!0;var E=a(B)}else if(1==P){for(var E in J);s(z,E,{})}else n(z,J)}if(w){var N=[];for(var E in p.groups)if(0!=E){var B=p.groups[E];B.side==e&&N.push(E)}N.sort(function(r,o){return parseInt(r)-parseInt(o)});for(var R=[],U=0;U<N.length;U++){var E=N[U],B=p.groups[E];for(var z in B.p){r.g.EachDirectionFlat(z,function(o,t){if(p.board[o]!=e)return!0;var i=p.posGroup[o];if(i!=E&&0!=i){var a=G[t],n=r.g.Graph[z][a[0]],s=r.g.Graph[z][a[1]];if(null==n||p.board[n]!=l||null==s||p.board[s]!=l){for(var u=null,h=[],f=0;f<R.length;f++){var v=R[f];if(E in v||i in v)if(u){for(var d in v)u[d]=!0;h.push(f)}else v[E]=!0,v[i]=!0,u=v}for(var f=h.length-1;f>=0;f--)R.splice(h[f],1);if(null==u){var v={};v[E]=!0,v[i]=!0,R.push(v)}}}return!0})}}for(var U=0;U<R.length;U++)n(-1,R[U])}for(var E in p.groups)if(0!=E){var B=p.groups[E];if(B.side==e&&0==B.fCount)for(var z in B.p){var H=!1;if(r.g.EachDirectionUp(z,function(r){return!(p.board[r]>0)||(H=!0,!1)}),0==H)return null}}var _=[];for(var E in p.groups){var B=p.groups[E];B.eyes=0;for(var z in B.p)_.push({p:z,z:r.g.Coord[z][2],group:B,gid:E})}_.sort(function(r,o){return o.z-r.z});for(var j={},Y={},U=0;U<_.length;U++){var V=_[U],Z=!1;r.g.EachDirectionUp(V.p,function(r){var o=j[r];return!(void 0!==o&&V.group.side&3-o)||(Z=!0,!1)}),V.pinned=Z,Y[V.p]=V,j[V.p]=Z?3:V.group.side}for(var T in p.posFree){var X=0,$=!0;r.g.EachDirectionFlat(T,function(r){if(0==p.board[r])return $=!1,!1;var o=p.posGroup[r];return 0!=X&&o!=X?($=!1,!1):(X=o,!0)}),0==X&&($=!1),$&&p.groups[X].eye++}p.relativeSecured=0,p.relativeHeight=0;var q=r.mOptions.levelOptions;for(var E in p.groups){var B=p.groups[E],K=1==B.side?1:-1,Q=q.evalSafety;B.eyes>=2?Q=q.evalSafety2eyes+Math.log(B.eyes-1)*q.evalSafetyXEyesBonus:1==B.fCount?Q=q.evalSafety1f:3==B.fCount?Q=q.evalSafety3f:B.fCount>3&&(Q=q.evalSafety3fMore+Math.log(B.fCount-3)*q.evalSafety3fMoreBonus),1==B.eyes&&(Q+=q.evalSafety1eyeBonus);for(var z in B.p){var V=Y[z],rr=Q;V.pinned&&(rr+=q.evalSafetyPinnedBonus),p.relativeSecured+=rr*K,p.relativeHeight+=V.z*K}}if(0==f){var K=1==e?1:-1,or=Math.abs(h[0]-(r.mOptions.size-1)/2)+Math.abs(h[1]-(r.mOptions.size-1)/2);p.center+=or*K*-1}p.moveEvaluation=p.relativeSecured+q.evalHeightRatio*p.relativeHeight+q.evalCenterRatio*p.center;var er=[];for(var tr in u)er.push(tr);return p.zSign=r.spUpdateZobrist(p.zSign,[o],e-1,er,2-e),{board:p,remove:er}},Model.Board.Evaluate=function(r,o,e){this.mEvaluation=this.moveEvaluation},Model.Board.CheckConsistency=function(r){for(var o=[0,0,0],e=0;e<r.g.Graph.length;e++){var t=(r.g.Coord[e],this.board[e]);if(t>0){if(void 0===this.posGroup[e])return console.error("pos",e,"side",t,"not assigned to any group"),!1;if(this.posFree[e]){var i=null;for(i in this.posFree[e]);if(null!=i)return console.error("pos",e,"side",t,"set as free for group",i),!1}o[t]++}else if(this.posGroup[e])return console.error("empty pos",e,"in posGroup"),!1;var a=r.g.Over[e];if(null!=a&&this.board[a]>0&&0!=this.posGroup[e])return console.error("buried ball",e,"does not have posGroup 0 but",this.posGroup[e]),!0}if(o[1]!=this.ballCount[1]||o[2]!=this.ballCount[2])return console.error("ball count mismatch, got",o[1],o[2],"expecting",this.ballCount[1],this.ballCount[2]),!1;for(var e in this.posGroup){if(0==this.board[e])return console.error("posGroup pos",e,"is empty"),!1;if(0!=this.posGroup[e]){if(void 0===this.groups[this.posGroup[e]])return console.error("posGroup",e,"in unknown group",this.posGroup[e]),!1;if(!(e in this.groups[this.posGroup[e]].p))return console.error("posGroup",e,"does not match group"),!1}}for(var e in this.posFree){if(0!=this.board[e])return console.error("posFree pos",e,"is not empty"),!1;for(var n in this.posFree[e]){var s=this.groups[n];if(void 0===s)return console.error("posFree pos",e,"group",n,"does not exist"),!1;if(!(e in s.f))return console.error("posFree pos",e,"group",n,"not in group freedoms"),!1}}for(var n in this.groups){var s=this.groups[n],p=0;for(var u in s.p){if(0==this.board[u])return console.error("pos",u,"in group",n,"marked as empty"),!1;if(this.board[u]!=s.side)return console.error("pos",u,"in group",n,"has wrong side"),!1;if(this.posGroup[u]!=n)return console.error("pos",u,"in group",n,"has wrong group",this.posGroup[u]),!1;p++}if(p!=s.pCount)return console.error("group",n,"count mismatch"),!1;p=0;for(var u in s.f){if(0!=this.board[u])return console.error("freedom pos",u,"in group",n,"is not empty"),!1;if(0!=r.g.Coord[u][2])return console.error("freedom pos",u,"in group",n,"not at ground level"),!1;if(void 0===this.posFree[u])return console.error("freedom pos",u,"in group",n,"not in freedoms"),!1;if(!this.posFree[u][n])return console.error("freedom pos",u,"in group",n,"is not empty for group"),!1;p++}if(p!=s.fCount)return console.error("group",n,"freedom count mismatch"),!1}return!0},Model.Board.ApplyMove=function(r,o){if(void 0===o.nextBoard){var e=this.ExtendMove(r,o.pos);e||console.log("move",o,JSON.stringify(r.mPlayedMoves)),this.CopyFrom(e.board)}else this.CopyFrom(o.nextBoard);this.spApplyMove(r,o)},Model.Board.CopyFrom=function(r){this.groupMaxId=r.groupMaxId,this.center=r.center,this.maxLayer=r.maxLayer,this.zSign=r.zSign,this.mWho=r.mWho,this.moveEvaluation=r.moveEvaluation,this.board=[],this.ballCount=[0,r.ballCount[1],r.ballCount[2]];for(var o=0;o<r.board.length;o++)this.board.push(r.board[o]);this.playables={};for(var o in r.playables)this.playables[o]=!0;this.groups={};for(var e in r.groups){var t=r.groups[e],i={side:t.side,p:{},pCount:t.pCount,f:{},fCount:t.fCount};for(var o in t.p)i.p[o]=!0;for(var o in t.f)i.f[o]=!0;this.groups[e]=i}this.posFree={};for(var o in r.posFree){var a={};for(var n in r.posFree[o])a[n]=!0;this.posFree[o]=a}this.posGroup={};for(var o in r.posGroup)this.posGroup[o]=r.posGroup[o];r.height?this.height=[0,r.height[1],r.height[2]]:this.height=[0,0,0],void 0!==r.mEvaluation&&(this.mEvaluation=r.mEvaluation),void 0!==r.mFinished&&(this.mFinished=r.mFinished),void 0!==r.mWinner&&(this.mWinner=r.mWinner)},Model.Game.Save=function(){for(var r={playedMoves:[],game:JoclyHub.modelName},o=0;o<this.mPlayedMoves.length;o++){var e=new(this.GetMoveClass())(this.mPlayedMoves[o]);delete e.nextBoard,delete e.remove,delete e.boardJSON,r.playedMoves.push(e)}var t=new Date;if(r.date=t.getFullYear()+"-"+(t.getMonth()+1)+"-"+t.getDate()+"-"+t.getHours()+"_"+t.getMinutes()+"_"+t.getSeconds(),JoclyHub.network.connected){$(".jocly-temp").remove();var i=document.createElement("form");i.setAttribute("class","jocly-temp"),i.setAttribute("style","display: none;"),i.setAttribute("method","post"),i.setAttribute("action","/jocly/save-game");var a=document.createElement("input");a.setAttribute("type","hidden"),a.setAttribute("name","data"),a.setAttribute("value",JSON.stringify(r)),i.appendChild(a),document.body.appendChild(i),i.submit()}else{var n=r.game+"-"+r.date+".joc",s="data:application/x-joc;filename="+n+","+encodeURIComponent(JSON.stringify(r));window.open(s,n)}},Model.Move.Strip=function(){if(void 0!==this.nextBoard||void 0!==this.remove){var r={};for(var o in this)this.hasOwnProperty(o)&&"nextBoard"!=o&&(r[o]=JSON.parse(JSON.stringify(this[o])));return r}return this};

/***/ }),

/***/ "0VSF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var OuterSubscriber_1 = __webpack_require__("wAkD");
var subscribeToResult_1 = __webpack_require__("CURp");
/**
 * Emits the most recently emitted value from the source Observable whenever
 * another Observable, the `notifier`, emits.
 *
 * <span class="informal">It's like {@link sampleTime}, but samples whenever
 * the `notifier` Observable emits something.</span>
 *
 * <img src="./img/sample.png" width="100%">
 *
 * Whenever the `notifier` Observable emits a value or completes, `sample`
 * looks at the source Observable and emits whichever value it has most recently
 * emitted since the previous sampling, unless the source has not emitted
 * anything since the previous sampling. The `notifier` is subscribed to as soon
 * as the output Observable is subscribed.
 *
 * @example <caption>On every click, sample the most recent "seconds" timer</caption>
 * var seconds = Rx.Observable.interval(1000);
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = seconds.sample(clicks);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link audit}
 * @see {@link debounce}
 * @see {@link sampleTime}
 * @see {@link throttle}
 *
 * @param {Observable<any>} notifier The Observable to use for sampling the
 * source Observable.
 * @return {Observable<T>} An Observable that emits the results of sampling the
 * values emitted by the source Observable whenever the notifier Observable
 * emits value or completes.
 * @method sample
 * @owner Observable
 */
function sample(notifier) {
    return this.lift(new SampleOperator(notifier));
}
exports.sample = sample;
var SampleOperator = (function () {
    function SampleOperator(notifier) {
        this.notifier = notifier;
    }
    SampleOperator.prototype.call = function (subscriber, source) {
        var sampleSubscriber = new SampleSubscriber(subscriber);
        var subscription = source.subscribe(sampleSubscriber);
        subscription.add(subscribeToResult_1.subscribeToResult(sampleSubscriber, this.notifier));
        return subscription;
    };
    return SampleOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var SampleSubscriber = (function (_super) {
    __extends(SampleSubscriber, _super);
    function SampleSubscriber() {
        _super.apply(this, arguments);
        this.hasValue = false;
    }
    SampleSubscriber.prototype._next = function (value) {
        this.value = value;
        this.hasValue = true;
    };
    SampleSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.emitValue();
    };
    SampleSubscriber.prototype.notifyComplete = function () {
        this.emitValue();
    };
    SampleSubscriber.prototype.emitValue = function () {
        if (this.hasValue) {
            this.hasValue = false;
            this.destination.next(this.value);
        }
    };
    return SampleSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=sample.js.map

/***/ }),

/***/ "0cr2":
/***/ (function(module, exports) {

exports.model=Model={Game:{},Board:{},Move:{}},function(){var t;Model.Game.cbConstants={MASK:65535,FLAG_MOVE:65536,FLAG_CAPTURE:131072,FLAG_STOP:262144,FLAG_SCREEN_CAPTURE:524288,FLAG_CAPTURE_KING:1048576,FLAG_CAPTURE_NO_KING:2097152};var e="undefined"!=typeof Int32Array;Model.Game.cbUseTypedArrays=e,Model.Game.cbTypedArray=function(t){if(e){var r=new Int32Array(t.length);return r.set(t),r}for(var i=[],a=t.length,s=0;s<a;s++)i.push(t[s]);return i},Model.Game.cbShortRangeGraph=function(t,e,r,i){var a=this;void 0===i&&(i=196608);for(var s={},n=0;n<t.boardSize;n++)s[n]=[],(!r||n in r)&&e.forEach(function(e){var o=t.Graph(n,e);null!=o&&(!r||o in r)&&s[n].push(a.cbTypedArray([o|i]))});return s},Model.Game.cbLongRangeGraph=function(t,e,r,i,a){var s=this;void 0!==i&&null!=i||(i=196608),a||(a=1/0);for(var n={},o=0;o<t.boardSize;o++)n[o]=[],(!r||o in r)&&e.forEach(function(e){for(var h=[],c=t.Graph(o,e),p=0;null!=c&&(!r||c in r)&&(h.push(c|i),++p!=a);)c=t.Graph(c,e);h.length>0&&n[o].push(s.cbTypedArray(h))});return n},Model.Game.cbNullGraph=function(t){for(var e={},r=0;r<t.boardSize;r++)e[r]=[];return e},Model.Game.cbAuthorGraph=function(t){for(var e={},r=0;r<t.boardSize;r++){e[r]=[];for(var i=0;i<t.boardSize;i++)e[r].push([2293760|i])}return e},Model.Game.cbMergeGraphs=function(t){for(var e=[],r=0;r<t.boardSize;r++){e[r]=[];for(var i=1;i<arguments.length;i++)e[r]=e[r].concat(arguments[i][r])}return e},Model.Game.cbGetThreatGraph=function(){function t(e,r){for(var i in n){var a=n[i];if(!(a.p.length<r.length+1)){for(var s=!0,o=0;o<r.length;o++)if(r[o]!=a.p[o]){s=!1;break}if(s){var h=a.p[r.length],c=e[h];void 0===c&&(c={e:{}},e[h]=c),a.p.length==r.length+1&&(c.t=a.t,c.ts=a.ts,c.tk=a.tk,delete n[i]),r.push(h),t(c.e,r),r.pop()}}}}var e=this;this.cbUseScreenCapture=!1,this.cbUseCaptureKing=!1,this.cbUseCaptureNoKing=!1;for(var r={1:[],"-1":[]},i=[],a=0;a<this.g.boardSize;a++)this.g.pTypes.forEach(function(t,r){t.graph[a].forEach(function(t){for(var s=[],n=0;n<t.length;n++){var o=t[n];1048576&o?(e.cbUseCaptureKing=!0,s.unshift({d:65535&o,a:a,tk:r})):2097152&o?(e.cbUseCaptureNoKing=!0,s.unshift({d:65535&o,a:a,tnk:r})):131072&o?s.unshift({d:65535&o,a:a,t:r}):262144&o?s.unshift({d:65535&o,a:a}):524288&o&&(e.cbUseScreenCapture=!0,s.unshift({d:65535&o,a:a,ts:r}))}s.length>0&&i.push(s)})});var s={};i.forEach(function(t){t.forEach(function(e,r){var i=s[e.d];void 0===i&&(i={},s[e.d]=i);for(var a=[],n=r+1;n<t.length;n++)a.push(t[n].d);a.push(e.a);var o=a.join(","),h=i[o];void 0===h&&(h={p:a,t:{},ts:{},tk:{}},i[o]=h),void 0!==e.t?h.t[e.t]=!0:void 0!==e.tk?h.tk[e.tk]=!0:void 0!==e.ts&&(h.ts[e.ts]=!0)})});for(var a=0;a<e.g.boardSize;a++){var n=s[a],o={};t(o,[]),r[1][a]=o,r[-1][a]=o}return r},Model.Game.InitGame=function(){var e=this;this.cbVar=t=this.cbDefine(),this.g.boardSize=this.cbVar.geometry.boardSize,this.g.pTypes=this.cbGetPieceTypes(),this.g.threatGraph=this.cbGetThreatGraph(),this.g.distGraph=this.cbVar.geometry.GetDistances(),this.cbPiecesCount=0,this.g.castleablePiecesCount={1:0,"-1":0};for(var r in t.pieceTypes){var i=t.pieceTypes[r];if(i.castle){(i.initial||[]).forEach(function(t){e.g.castleablePiecesCount[t.s]++})}i.initial&&(this.cbPiecesCount+=i.initial.length)}for(var a=[],r=0;r<this.cbPiecesCount;r++)a.push(r);var s=Object.keys(t.pieceTypes);this.zobrist=new JocGame.Zobrist({board:{type:"array",size:this.cbVar.geometry.boardSize,values:a},who:{values:["1","-1"]},type:{type:"array",size:this.cbPiecesCount,values:s}})},Model.Game.cbGetPieceTypes=function(){for(var t=[],e={},r=0;r<this.cbVar.geometry.boardSize;r++)e[r]=[];for(var i in this.cbVar.pieceTypes){var a=this.cbVar.pieceTypes[i];t[i]={graph:a.graph||e,abbrev:a.abbrev||"",value:a.isKing?100:a.value||1,isKing:!!a.isKing,castle:!!a.castle,epTarget:!!a.epTarget,epCatch:!!a.epCatch}}return t},Model.Board.Init=function(t){this.zSign=0},Model.Board.InitialPosition=function(r){var i=this;this.board=e?new Int16Array(r.g.boardSize):[];for(var a=0;a<r.g.boardSize;a++)this.board[a]=-1;if(this.kings={},this.pieces=[],this.ending={1:!1,"-1":!1},this.lastMove=null,r.cbVar.castle&&(this.castled={1:!1,"-1":!1}),this.zSign=r.zobrist.update(0,"who",-1),this.noCaptCount=0,this.mWho=1,r.mInitial)this.mWho=r.mInitial.turn||1,r.mInitial.pieces.forEach(function(t){var e={};for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);i.pieces.push(e)}),r.mInitial.lastMove&&(this.lastMove={f:r.mInitial.lastMove.f,t:r.mInitial.lastMove.t}),void 0!==r.mInitial.noCaptCount&&(this.noCaptCount=r.mInitial.noCaptCount),r.cbVar.castle&&r.mInitial.castle&&(this.castled={1:{k:!!r.mInitial.castle[1]&&!!r.mInitial.castle[1].k,q:!!r.mInitial.castle[1]&&!!r.mInitial.castle[1].q},"-1":{k:!!r.mInitial.castle[-1]&&!!r.mInitial.castle[-1].k,q:!!r.mInitial.castle[-1]&&!!r.mInitial.castle[-1].q}});else for(var s in r.cbVar.pieceTypes)for(var n=r.cbVar.pieceTypes[s],o=n.initial||[],h=0;h<o.length;h++){var c=o[h],p={s:c.s,t:parseInt(s),p:c.p,m:!1};this.pieces.push(p)}if(this.pieces.sort(function(t,e){if(t.s!=e.s)return e.s-t.s;var i=r.cbVar.pieceTypes[t.t].value||100,a=r.cbVar.pieceTypes[e.t].value||100;return i!=a?i-a:t.p-e.p}),this.pieces.forEach(function(t,e){t.i=e,i.board[t.p]=e,r.g.pTypes[t.t].isKing&&(i.kings[t.s]=t.p),i.zSign=r.zobrist.update(i.zSign,"board",e,t.p),i.zSign=r.zobrist.update(i.zSign,"type",t.t,e)}),r.mInitial&&r.mInitial.enPassant){var a=t.geometry.PosByName(r.mInitial.enPassant);if(a>=0){var l,u=t.geometry.C(a),v=t.geometry.R(a);l=1==r.mInitial.turn?t.geometry.POS(u,v-1):t.geometry.POS(u,v+1),this.epTarget={p:a,i:this.board[l]}}}},Model.Board.CopyFrom=function(t){if(e)this.board=new Int16Array(t.board.length),this.board.set(t.board);else{this.board=[];for(var r=t.board,i=r.length,a=0;a<i;a++)this.board.push(r[a])}this.pieces=[];for(var s=t.pieces.length,a=0;a<s;a++){var n=t.pieces[a];this.pieces.push({s:n.s,p:n.p,t:n.t,i:n.i,m:n.m})}this.kings={1:t.kings[1],"-1":t.kings[-1]},this.check=t.check,t.lastMove?this.lastMove={f:t.lastMove.f,t:t.lastMove.t,c:t.lastMove.c}:this.lastMove=null,this.ending={1:t.ending[1],"-1":t.ending[-1]},void 0!==t.castled&&(this.castled={1:t.castled[1],"-1":t.castled[-1]}),this.noCaptCount=t.noCaptCount,t.epTarget?this.epTarget={p:t.epTarget.p,i:t.epTarget.i}:this.epTarget=null,this.mWho=t.mWho,this.zSign=t.zSign},Model.Board.cbApplyCastle=function(t,e,r){var i=t.cbVar.castle[e.f+"/"+e.cg],a=i.r[i.r.length-1],s=this.pieces[this.board[e.cg]],n=i.k[i.k.length-1],o=this.pieces[this.board[e.f]];return r&&(this.zSign=t.zobrist.update(this.zSign,"board",s.i,e.cg),this.zSign=t.zobrist.update(this.zSign,"board",s.i,a),this.zSign=t.zobrist.update(this.zSign,"board",o.i,e.f),this.zSign=t.zobrist.update(this.zSign,"board",o.i,n)),s.p=a,s.m=!0,this.board[e.cg]=-1,o.p=n,o.m=!0,this.board[e.f]=-1,this.board[a]=s.i,this.board[n]=o.i,this.castled[s.s]=!0,this.kings[o.s]=n,[{i:s.i,f:a,t:-1},{i:o.i,f:n,t:e.f,kp:e.f,who:o.s,m:!1},{i:s.i,f:-1,t:e.cg,m:!1,cg:!1}]},Model.Board.cbQuickApply=function(t,e){if(void 0!==e.cg)return this.cbApplyCastle(t,e,!1);var r=[],i=this.board[e.f],a=this.pieces[i];if(null!=e.c){r.unshift({i:e.c,f:-1,t:this.pieces[e.c].p});var s=this.pieces[e.c];this.board[s.p]=-1,s.p=-1}var n=this.kings[a.s];return t.g.pTypes[a.t].isKing&&(this.kings[a.s]=e.t),r.unshift({i:i,f:e.t,t:e.f,kp:n,who:a.s,ty:a.t}),a.p=e.t,void 0!==e.pr&&(a.t=e.pr),this.board[e.f]=-1,this.board[e.t]=i,r},Model.Board.cbQuickUnapply=function(t,e){for(var r=0;r<e.length;r++){var i=e[r],a=this.pieces[i.i];i.f>=0&&(a.p=-1,this.board[i.f]=-1),i.t>=0&&(a.p=i.t,this.board[i.t]=i.i),void 0!==i.m&&(a.m=i.m),void 0!==i.kp&&(this.kings[i.who]=i.kp),void 0!=i.ty&&(a.t=i.ty),void 0!=i.cg&&(this.castled[a.s]=i.cg)}},Model.Board.ApplyMove=function(t,e){var r=this.pieces[this.board[e.f]];if(void 0!==e.cg)this.cbApplyCastle(t,e,!0);else{if(this.zSign=t.zobrist.update(this.zSign,"board",r.i,e.f),this.board[r.p]=-1,void 0!==e.pr&&(this.zSign=t.zobrist.update(this.zSign,"type",r.t,r.i),r.t=e.pr,this.zSign=t.zobrist.update(this.zSign,"type",r.t,r.i)),null!=e.c){var i=this.pieces[e.c];this.zSign=t.zobrist.update(this.zSign,"board",i.i,i.p),this.board[i.p]=-1,i.p=-1,i.m=!0,this.noCaptCount=0}else this.noCaptCount++;r.p=e.t,r.m=!0,this.board[e.t]=r.i,this.zSign=t.zobrist.update(this.zSign,"board",r.i,e.t),t.g.pTypes[r.t].isKing&&(this.kings[r.s]=e.t)}this.check=!!e.ck,this.lastMove={f:e.f,t:e.t,c:e.c},void 0!==e.ko&&(this.ending[r.s]=e.ko),void 0!==e.ept?this.epTarget={p:e.ept,i:r.i}:this.epTarget=null,this.zSign=t.zobrist.update(this.zSign,"who",-this.mWho),this.zSign=t.zobrist.update(this.zSign,"who",this.mWho)},Model.Board.Evaluate=function(r){function i(e){var r=1/0;for(var i in t.geometry.corners)r=Math.min(r,h.distGraph[s.kings[e]][i]);return r-Math.sqrt(h.boardSize)}var a="debug"==arguments[3],s=this;this.mEvaluation=0;var n,o=this.mWho,h=r.g;if(e)n={1:{count:new Uint8Array(h.pTypes.length),byType:{}},"-1":{count:new Uint8Array(h.pTypes.length),byType:{}}};else{n={1:{count:[],byType:{}},"-1":{count:[],byType:{}}};for(var c=0;c<h.pTypes.length;c++)n[1].count[c]=n[-1].count[c]=0}if(r.mOptions.preventRepeat&&r.GetRepeatOccurence(this)>2)return this.mFinished=!0,void(this.mWinner=r.cbOnPerpetual?o*r.cbOnPerpetual:JocGame.DRAW);for(var p={1:0,"-1":0},l={1:h.distGraph[this.kings[-1]],"-1":h.distGraph[this.kings[1]]},u={1:0,"-1":0},v={1:0,"-1":0},b={1:0,"-1":0},f={1:0,"-1":0},d={1:!1,"-1":!1},g=this.pieces,m=g.length,c=0;c<m;c++){var G=g[c];if(G.p>=0){var y=G.s,M=h.pTypes[G.t];M.isKing?d[y]=G.m:p[y]+=M.value,M.castle&&!G.m&&f[y]++,v[y]++,u[y]+=l[y][G.p],b[y]+=t.geometry.distEdge[G.p];var C=n[y];C.count[G.t]++;var k=C.byType;void 0===k[G.t]?k[G.t]=[G]:k[G.t].push(G)}}if(this.lastMove&&null!=this.lastMove.c){var G=this.pieces[this.board[this.lastMove.t]];p[-G.s]+=this.cbStaticExchangeEval(r,G.p,G.s,{piece:G})}var S={1:0,"-1":0},A={1:0,"-1":0},T={1:0,"-1":0};this.ending[1]&&(A[1]=(u[1]-Math.sqrt(h.boardSize))/v[1],t.geometry.corners&&(T[1]=i(1))),this.ending[-1]&&(A[-1]=(u[-1]-Math.sqrt(h.boardSize))/v[-1],t.geometry.corners&&(T[1]=i(-1)));var z={pieceValue:p[1]-p[-1],pieceValueRatio:(p[1]-p[-1])/(p[1]+p[-1]+1),posValue:b[1]-b[-1],averageDistKing:u[1]/v[1]-u[-1]/v[-1],check:this.check?-o:0,endingKingFreedom:S[1]-S[-1],endingDistKing:A[1]-A[-1],distKingCorner:T[1]-T[-1]};t.castle&&(z.castle=(this.castled[1]?1:d[1]?0:f[1]/(h.castleablePiecesCount[1]+1))-(this.castled[-1]?1:d[-1]?0:f[-1]/(h.castleablePiecesCount[-1]+1))),t.evaluate&&t.evaluate.call(this,r,z,n);var E=r.mOptions.levelOptions;for(var P in z){var R=z[P],I=E[P+"Factor"]||0,w=R*I;a&&console.log(P,"=",R,"*",I,"=>",w),this.mEvaluation+=w}a&&console.log("Evaluation",this.mEvaluation)},Model.Board.cbGeneratePseudoLegalMoves=function(t){function e(e,a){var s=t.cbVar.promote;if(!s)return void i.push(a);var n=s.call(r,t,e,a);if(null!=n)if(0==n.length)i.push(a);else if(1==n.length)a.pr=n[0],i.push(a);else for(var o=0;o<n.length;o++){var h=n[o];i.push({f:a.f,t:a.t,c:a.c,pr:h,ept:a.ept,ep:a.ep,a:a.a})}}for(var r=this,i=[],a=t.cbVar,s=this.mWho,n=!a.castle||this.check||this.castled[s]?null:[],o=-1,h=this.pieces.length,c=0;c<h;c++){var p=this.pieces[c];if(!(p.p<0||p.s!=s)){var l=t.g.pTypes[p.t];l.isKing&&(p.m?n=null:o=p),n&&l.castle&&!p.m&&n.push(p);var u,v;u=l.graph[p.p],v=u.length;for(var b=0;b<v;b++)for(var f=u[b],d=!1,g=f.length,m=null,G=0;G<g;G++){var y=f[G],M=65535&y,C=this.board[M];if(!(C<0)||l.epCatch&&this.epTarget&&this.epTarget.p==M){if(!(524288&y)){var k;k=C<0?this.pieces[this.epTarget.i]:this.pieces[C],!(k.s!=p.s&&131072&y)||1048576&y&&!t.g.pTypes[k.t].isKing||2097152&y&&t.g.pTypes[k.t].isKing||e(p,{f:p.p,t:M,c:k.i,a:l.abbrev,ep:C<0});break}if(d){var k=this.pieces[C];k.s!=p.s&&e(p,{f:p.p,t:M,c:k.i,a:l.abbrev});break}d=!0}else 65536&y&&0==d&&e(p,{f:p.p,t:M,c:null,a:l.abbrev,ept:null!=m&&l.epTarget?m:void 0});m=M}}}if(n)for(var c=0;c<n.length;c++){var S=n[c],A=t.cbVar.castle[o.p+"/"+S.p];if(A){for(var T=!0,b=0;b<A.r.length;b++){var z=A.r[b];if(this.board[z]>=0&&z!=o.p&&z!=S.p){T=!1;break}}if(T){for(var E=!0,b=0;b<A.k.length;b++){var z=A.k[b];if(this.board[z]>=0&&z!=S.p&&z!=o.p||this.cbGetAttackers(t,z,s).length>0){E=!1;break}}E&&i.push({f:o.p,t:A.k[A.k.length-1],c:null,cg:S.p})}}}return i},Model.Board.cbStaticExchangeEval=function(t,e,r,i){var a=0,s=this.cbGetSmallestAttacker(t,e,r);if(s){var n=this.mWho;this.mWho=s.s;var o=this.cbQuickApply(t,{f:s.p,t:e,c:i.piece.i}),h=t.g.pTypes[i.piece.t].value;i.piece=s,a=Math.max(0,h-this.cbStaticExchangeEval(t,e,-r,i)),this.cbQuickUnapply(t,o),this.mWho=n}return a},Model.Board.cbGetSmallestAttacker=function(t,e,r){var i=this.cbGetAttackers(t,e,r);if(0==i.length)return null;for(var a=1/0,s=null,n=i.length,o=0;o<n;o++){var h=i[o],c=t.g.pTypes[h.t].value;c<a&&(a=c,s=h)}return s},Model.Board.cbCollectAttackers=function(t,e,r,i){for(var a in e){var s=e[a],n=this.board[a];if(n<0)this.cbCollectAttackers(t,s.e,r,i);else{var o=this.pieces[n];o.s==-t&&(s.t&&o.t in s.t||i&&s.tk&&o.t in s.tk)&&r.push(o)}}},Model.Board.cbCollectAttackersScreen=function(t,e,r,i,a){for(var s in e){var n=e[s],o=this.board[s];if(o<0)this.cbCollectAttackersScreen(t,n.e,r,i,a);else{var h=this.pieces[o];!a&&h.s==-t&&(n.t&&h.t in n.t||i&&n.tk&&h.t in n.tk)?r.push(h):a?a&&h.s==-t&&n.ts&&h.t in n.ts&&r.push(h):this.cbCollectAttackersScreen(t,n.e,r,i,!0)}}},Model.Board.cbGetAttackers=function(t,e,r,i){var a=[];return t.cbUseScreenCapture?this.cbCollectAttackersScreen(r,t.g.threatGraph[r][e],a,i,!1):this.cbCollectAttackers(r,t.g.threatGraph[r][e],a,i),a},Model.Board.GenerateMoves=function(t){var e=this.cbGeneratePseudoLegalMoves(t);this.mMoves=[];for(var r=!0,i=this.kings[this.mWho],a=e.length,s=0;s<a;s++){var n=e[s],o=this.cbQuickApply(t,n);if(!(this.cbGetAttackers(t,this.kings[this.mWho],this.mWho,!0).length>0)){var h=this.cbGetAttackers(t,this.kings[-this.mWho],-this.mWho,!0).length>0;n.ck=h,this.mMoves.push(n),n.f!=i&&(r=!1)}this.cbQuickUnapply(t,o)}if(0==this.mMoves.length)this.mFinished=!0,this.mWinner=t.cbOnStaleMate?t.cbOnStaleMate*this.mWho:JocGame.DRAW,this.check&&(this.mWinner=-this.mWho);else if(this.ending[this.mWho]){if(!r)for(var s=0;s<this.mMoves.length;s++)this.mMoves[s].ko=!1}else if(!this.ending[this.mWho]&&r&&!this.check)for(var s=0;s<this.mMoves.length;s++)this.mMoves[s].ko=!0},Model.Board.GetSignature=function(){return this.zSign},Model.Move.Init=function(t){for(var e in t)t.hasOwnProperty(e)&&(this[e]=t[e])},Model.Move.Equals=function(t){return this.f==t.f&&this.t==t.t&&this.pr==t.pr},Model.Move.CopyFrom=function(t){this.Init(t)},Model.Move.ToString=function(e){var r=this;switch(e=e||"natural"){case"natural":return function(){var e;if(void 0!==r.cg?e=t.castle[r.f+"/"+r.cg].n:(e=r.a||"",e+=t.geometry.PosName(r.f),null==r.c?e+="-":e+="x",e+=t.geometry.PosName(r.t)),void 0!==r.pr){var i=t.pieceTypes[r.pr];i&&i.abbrev&&i.abbrev.length>0&&!i.silentPromo&&(e+="="+i.abbrev)}return r.ck&&(e+="+"),e}();case"engine":return function(){var e=t.geometry.PosName(r.f)+t.geometry.PosName(r.t);if(void 0!=r.pr){var i=t.pieceTypes[r.pr];i&&i.abbrev&&i.abbrev.length>0&&!i.silentPromo&&(e+=i.abbrev)}return e}();default:return"??"}},Model.Board.CompactMoveString=function(e,r,i){"function"!=typeof r.ToString&&(r=e.CreateMove(r));var a=r.ToString(),s=/^([A-Z]?)([a-z])([1-9][0-9]*)([-x])([a-z])([1-9][0-9]*)(.*?)$/.exec(a);if(!s)return a;var n=s[7];if(i||(i={}),i.value||(i.value=[]),0==i.value.length){var o=this.mMoves;this.mMoves&&0!=this.mMoves.length||this.GenerateMoves(e);for(var h=0;h<this.mMoves.length;h++){var c=this.mMoves[h];"function"!=typeof c.ToString&&(c=e.CreateMove(c)),i.value.push({str:c.ToString(),move:c})}this.mMoves=o}var p=[];if(i.value.forEach(function(t){var e=/^([A-Z]?[a-z][1-9][0-9]*[-x][a-z][1-9][0-9]*)(.*?)$/.exec(t.str);e&&t.move.t==r.t&&(t.move.a||"")==s[1]&&e[2]==n&&p.push(t.move)}),1==p.length)return""==s[1]&&"x"==s[4]?s[2]+"x"+s[5]+s[6]+s[7]:s[1]+("x"==s[4]?"x":"")+s[5]+s[6]+s[7];if(t.geometry.CompactCrit)for(var l="",h=0;;h++){var u=t.geometry.CompactCrit(r.f,h);if(null==u)return a;l+=u;for(var v=[],b=0;b<p.length;b++){var f=p[b];t.geometry.CompactCrit(f.f,h)==u&&v.push(f)}if(console.assert(v.length>0),1==v.length)return s[1]+l+("x"==s[4]?"x":"")+s[5]+s[6]+s[7];p=v}return a},Model.Board.cbIntegrity=function(t){function e(t,e){t||console.error(e)}for(var r=this,i=0;i<this.board.length;i++){var a=this.board[i];if(a>=0){var s=r.pieces[a];e(void 0!==s,"no piece at pos"),e(s.p==i,"piece has different pos")}}for(var a=0;a<this.pieces.length;a++){var s=this.pieces[a];s.p>=0&&e(r.board[s.p]==a,"board index mismatch")}},Model.Board.ExportBoardState=function(t){return t.cbVar.geometry.ExportBoardState?t.cbVar.geometry.ExportBoardState(this,t.cbVar,t.mPlayedMoves.length):"not supported"},Model.Game.Import=function(e,r){var i,a=[],s={1:{},"-1":{}},n=null,o=0;if("pjn"==e){var h={status:!1,error:"parse"},c=r.split(" ");if(6!=c.length)return console.warn("FEN should have 6 parts"),h;var p=c[0].split("/"),l=t.geometry.fenHeight||t.geometry.height;if(p.length!=l)return console.warn("FEN board should have",l,"rows, got",p.length),h;var u={};for(var v in t.pieceTypes){var b=t.pieceTypes[v],f=b.fenAbbrev||b.abbrev||"X";u[f.toUpperCase()]={s:1,t:v},u[f.toLowerCase()]={s:-1,t:v}}var d=t.geometry.FenRowPos||function(e,r){return(t.geometry.height-1-e)*t.geometry.width+r};if(p.forEach(function(e,r){for(var i=0,s=0;s<e.length;s++){var n=e.substr(s,1),o=u[n];if(void 0!==o){var c=d(r,i);i++;for(var p={s:o.s,t:o.t,p:c},l=!0,v=t.pieceTypes[p.t].initial||[],b=0;b<v.length;b++){var f=v[b];f.s==p.s&&f.p==c&&(l=!1)}p.m=l,a.push(p)}else{if(isNaN(parseInt(n)))return console.warn("FEN invalid board spec",n),h;i+=parseInt(n)}}}),a.sort(function(t,e){return e.s-t.s}),"w"==c[1])i=1;else{if("b"!=c[1])return console.warn("FEN invalid turn spec",c[1]),h;i=-1}s[1].k=c[2].indexOf("K")>=0,s[1].q=c[2].indexOf("Q")>=0,s[-1].k=c[2].indexOf("k")>=0,s[-1].q=c[2].indexOf("q")>=0,n="-"==c[3]?null:c[3];var g=parseInt(c[4]);isNaN(g)||(o=g);var m={pieces:a,turn:i,castle:s,enPassant:n,noCaptCount:o};return t.importGame&&t.importGame.call(this,m,e,r),{status:!0,initial:m}}return{status:!1,error:"unsupported"}}}(),function(){Model.Game.cbBoardGeometryGrid=function(t,e){function r(e){return e%t}function i(e){return Math.floor(e/t)}function a(e,r){return r*t+e}function s(s,n){var o=r(s),h=i(s),c=o+n[0],p=h+n[1];return c<0||c>=t||p<0||p>=e?null:a(c,p)}function n(t){return String.fromCharCode("a".charCodeAt(0)+r(t))+(i(t)+1)}function o(t){var e=/^([a-z])([0-9]+)$/.exec(t);return e?a(e[1].charCodeAt(0)-"a".charCodeAt(0),parseInt(e[2])-1):-1}function h(t,e){return 0==e?String.fromCharCode("a".charCodeAt(0)+r(t)):1==e?i(t)+1:null}function c(){for(var a=[],s=0;s<t*e;s++){var n=[];a.push(n);for(var o=0;o<t*e;o++){var h=i(s),c=r(s),p=i(o),l=r(o);n.push(Math.max(Math.abs(h-p),Math.abs(c-l)))}}return a}function p(r,i,s){for(var o=[],h=e-1;h>=0;h--){for(var c="",p=0,l=0;l<t;l++){var u=r.board[a(l,h)];if(u<0)p++;else{p>0&&(c+=p,p=0);var v=r.pieces[u],b=i.pieceTypes[v.t].fenAbbrev||i.pieceTypes[v.t].abbrev||"?";v.s==-1?c+=b.toLowerCase():c+=b.toUpperCase()}}p&&(c+=p),o.push(c)}var f=o.join("/");f+=" ",1==r.mWho?f+="w":f+="b",f+=" ";var d="";return r.castled&&(r.castled[1]===!1?d+="KQ":(r.castled[1].k&&(d+="K"),r.castled[1].q&&(d+="Q")),r.castled[-1]===!1?d+="kq":(r.castled[-1].k&&(d+="k"),r.castled[-1].q&&(d+="q"))),0==d.length&&(d="-"),f+=d,f+=" ",r.epTarget?f+=n(r.epTarget.p):f+="-",f+=" ",f+=r.noCaptCount,f+=" ",f+=Math.floor(s/2)+1}return{boardSize:t*e,width:t,height:e,C:r,R:i,POS:a,Graph:s,PosName:n,PosByName:o,CompactCrit:h,GetDistances:c,distEdge:function(){for(var a=[],s=0;s<t*e;s++){var n=r(s),o=i(s);a[s]=Math.min(n,Math.abs(t-n-1),o,Math.abs(e-o-1))}return a}(),corners:function(){var r={};return r[a(0,0)]=1,r[a(0,e-1)]=1,r[a(t-1,0)]=1,r[a(t-1,e-1)]=1,r}(),ExportBoardState:p}},Model.Game.cbPawnGraph=function(t,e,r){for(var i=this,a={},s=0;s<t.boardSize;s++)if(!r||s in r){var n=[],o=t.Graph(s,[0,e]);null!=o&&(!r||o in r)&&n.push(i.cbTypedArray([o|i.cbConstants.FLAG_MOVE])),[-1,1].forEach(function(a){var o=t.Graph(s,[a,e]);null!=o&&(!r||o in r)&&n.push(i.cbTypedArray([o|i.cbConstants.FLAG_CAPTURE]))}),a[s]=n}else a[s]=[];return a},Model.Game.cbInitialPawnGraph=function(t,e,r){for(var i=this,a={},s=0;s<t.boardSize;s++)if(!r||s in r){var n=[],o=t.Graph(s,[0,e]);if(null!=o&&(!r||o in r)){var h=[o|i.cbConstants.FLAG_MOVE],c=t.Graph(o,[0,e]);null!=c&&(!r||c in r)&&h.push(c|i.cbConstants.FLAG_MOVE),n.push(i.cbTypedArray(h))}[-1,1].forEach(function(a){var o=t.Graph(s,[a,e]);null!=o&&(!r||o in r)&&n.push(i.cbTypedArray([o|i.cbConstants.FLAG_CAPTURE]))}),a[s]=n}else a[s]=[];return a},Model.Game.cbKingGraph=function(t,e){return this.cbShortRangeGraph(t,[[-1,-1],[-1,0],[-1,1],[0,-1],[0,1],[1,-1],[1,0],[1,1]],e)},Model.Game.cbKnightGraph=function(t,e){return this.cbShortRangeGraph(t,[[2,-1],[2,1],[-2,-1],[-2,1],[-1,2],[-1,-2],[1,2],[1,-2]],e)},Model.Game.cbHorseGraph=function(t){for(var e=this,r={},i=0;i<t.boardSize;i++)r[i]=[],[[1,0,2,-1],[1,0,2,1],[-1,0,-2,-1],[-1,0,-2,1],[0,1,-1,2],[0,-1,-1,-2],[0,1,1,2],[0,-1,1,-2]].forEach(function(a){var s=t.Graph(i,[a[0],a[1]]);if(null!=s){var n=t.Graph(i,[a[2],a[3]]);null!=n&&r[i].push(e.cbTypedArray([s|e.cbConstants.FLAG_STOP,n|e.cbConstants.FLAG_MOVE|e.cbConstants.FLAG_CAPTURE]))}});return r},Model.Game.cbRookGraph=function(t,e){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0]],e)},Model.Game.cbBishopGraph=function(t,e){return this.cbLongRangeGraph(t,[[1,-1],[1,1],[-1,1],[-1,-1]],e)},Model.Game.cbQueenGraph=function(t,e){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0],[1,-1],[1,1],[-1,1],[-1,-1]],e)},Model.Game.cbXQGeneralGraph=function(t,e){for(var r=this,i={},a=0;a<t.boardSize;a++)i[a]=[],[[-1,0,!1],[0,-1,!0],[0,1,!0],[1,0,!1]].forEach(function(s){var n=[],o=t.Graph(a,s);if(null!=o&&((!e||o in e)&&n.push(o|r.cbConstants.FLAG_MOVE|r.cbConstants.FLAG_CAPTURE),s[2]))for(var h=t.Graph(o,s);null!=h;)!e||h in e?n.push(h|r.cbConstants.FLAG_CAPTURE|r.cbConstants.FLAG_CAPTURE_KING):n.push(h|r.cbConstants.FLAG_STOP),h=t.Graph(h,s);n.length>0&&i[a].push(r.cbTypedArray(n))});return i},Model.Game.cbXQSoldierGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e]])},Model.Game.cbXQPromoSoldierGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e],[-1,0],[1,0]])},Model.Game.cbXQAdvisorGraph=function(t,e){return this.cbShortRangeGraph(t,[[1,1],[-1,1],[1,-1],[-1,-1]],e)},Model.Game.cbXQCannonGraph=function(t){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0]],null,this.cbConstants.FLAG_MOVE|this.cbConstants.FLAG_SCREEN_CAPTURE)},Model.Game.cbXQElephantGraph=function(t,e){for(var r=this,i={},a=0;a<t.boardSize;a++)i[a]=[],(!e||a in e)&&[[1,1,2,2],[1,-1,2,-2],[-1,1,-2,2],[-1,-1,-2,-2]].forEach(function(s){var n=t.Graph(a,[s[0],s[1]]);if(null!=n){var o=t.Graph(a,[s[2],s[3]]);null!=o&&(!e||o in e)&&i[a].push(r.cbTypedArray([n|r.cbConstants.FLAG_STOP,o|r.cbConstants.FLAG_MOVE|r.cbConstants.FLAG_CAPTURE]))}});return i},Model.Game.cbSilverGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e],[-1,-1],[-1,1],[1,-1],[1,1]])},Model.Game.cbFersGraph=function(t,e){return this.cbShortRangeGraph(t,[[-1,-1],[-1,1],[1,-1],[1,1]])},Model.Game.cbSchleichGraph=function(t,e){return this.cbShortRangeGraph(t,[[-1,0],[1,0],[0,-1],[0,1]])},Model.Game.cbAlfilGraph=function(t,e){return this.cbShortRangeGraph(t,[[-2,-2],[-2,2],[2,2],[2,-2]])}}(),function(){var t=Model.Game.cbBoardGeometryGrid(8,8);Model.Game.cbDefine=function(){return{geometry:t,pieceTypes:{0:{name:"pawn-w",aspect:"mk-pawn",graph:this.cbPawnGraph(t,1),value:1,abbrev:"",fenAbbrev:"P",initial:[{s:1,p:16},{s:1,p:17},{s:1,p:18},{s:1,p:19},{s:1,p:20},{s:1,p:21},{s:1,p:22},{s:1,p:23}]},1:{name:"pawn-b",aspect:"mk-pawn",graph:this.cbPawnGraph(t,-1),value:1,abbrev:"",fenAbbrev:"P",initial:[{s:-1,p:40},{s:-1,p:41},{s:-1,p:42},{s:-1,p:43},{s:-1,p:44},{s:-1,p:45},{s:-1,p:46},{s:-1,p:47}]},2:{name:"horse",aspect:"mk-knight",graph:this.cbKnightGraph(t),value:3.5,abbrev:"N",initial:[{s:1,p:1},{s:1,p:6},{s:-1,p:57},{s:-1,p:62}]},3:{name:"khon-w",aspect:"mk-bishop",graph:this.cbSilverGraph(t,1),value:3,abbrev:"B",initial:[{s:1,p:2},{s:1,p:5}]},4:{name:"khon-b",aspect:"mk-bishop",graph:this.cbSilverGraph(t,-1),value:3,abbrev:"B",initial:[{s:-1,p:58},{s:-1,p:61}]},5:{name:"rook",aspect:"mk-rook",graph:this.cbRookGraph(t),value:5,abbrev:"R",initial:[{s:1,p:0},{s:1,p:7},{s:-1,p:56},{s:-1,p:63}],castle:!0},6:{name:"met",aspect:"mk-queen",graph:this.cbFersGraph(t),value:2,abbrev:"Q",initial:[{s:1,p:4},{s:-1,p:59}]},7:{name:"king",aspect:"mk-king",isKing:!0,graph:this.cbKingGraph(t),abbrev:"K",initial:[{s:1,p:3},{s:-1,p:60}]}},evaluate:function(t,e,r){function i(t){var e=64,i=r[t].count;2==i[5]?e=8:1==i[5]?e=16:2==i[1==t?3:4]?e=22:1==i[1==t?3:4]?e=44:2==i[2]&&(e=32),a.noCaptCount>=2*e&&(a.mFinished=!0,a.mWinner=JocGame.DRAW)}var a=this;0==r[1].count[0]&&i(-1),0==r[-1].count[1]&&i(1)},promote:function(e,r,i){return 0==r.t&&5==t.R(i.t)?[6]:1==r.t&&2==t.R(i.t)?[6]:[]}}}}();

/***/ }),

/***/ "0gHg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ReplaySubject_1 = __webpack_require__("MQMf");
var multicast_1 = __webpack_require__("emOw");
/**
 * @param bufferSize
 * @param windowTime
 * @param scheduler
 * @return {ConnectableObservable<T>}
 * @method publishReplay
 * @owner Observable
 */
function publishReplay(bufferSize, windowTime, scheduler) {
    if (bufferSize === void 0) { bufferSize = Number.POSITIVE_INFINITY; }
    if (windowTime === void 0) { windowTime = Number.POSITIVE_INFINITY; }
    return multicast_1.multicast.call(this, new ReplaySubject_1.ReplaySubject(bufferSize, windowTime, scheduler));
}
exports.publishReplay = publishReplay;
//# sourceMappingURL=publishReplay.js.map

/***/ }),

/***/ "0jLf":
/***/ (function(module, exports) {

exports.model=Model={Game:{},Board:{},Move:{}},function(){var t;Model.Game.cbConstants={MASK:65535,FLAG_MOVE:65536,FLAG_CAPTURE:131072,FLAG_STOP:262144,FLAG_SCREEN_CAPTURE:524288,FLAG_CAPTURE_KING:1048576,FLAG_CAPTURE_NO_KING:2097152};var e="undefined"!=typeof Int32Array;Model.Game.cbUseTypedArrays=e,Model.Game.cbTypedArray=function(t){if(e){var r=new Int32Array(t.length);return r.set(t),r}for(var a=[],i=t.length,s=0;s<i;s++)a.push(t[s]);return a},Model.Game.cbShortRangeGraph=function(t,e,r,a){var i=this;void 0===a&&(a=196608);for(var s={},n=0;n<t.boardSize;n++)s[n]=[],(!r||n in r)&&e.forEach(function(e){var o=t.Graph(n,e);null!=o&&(!r||o in r)&&s[n].push(i.cbTypedArray([o|a]))});return s},Model.Game.cbLongRangeGraph=function(t,e,r,a,i){var s=this;void 0!==a&&null!=a||(a=196608),i||(i=1/0);for(var n={},o=0;o<t.boardSize;o++)n[o]=[],(!r||o in r)&&e.forEach(function(e){for(var h=[],c=t.Graph(o,e),p=0;null!=c&&(!r||c in r)&&(h.push(c|a),++p!=i);)c=t.Graph(c,e);h.length>0&&n[o].push(s.cbTypedArray(h))});return n},Model.Game.cbNullGraph=function(t){for(var e={},r=0;r<t.boardSize;r++)e[r]=[];return e},Model.Game.cbAuthorGraph=function(t){for(var e={},r=0;r<t.boardSize;r++){e[r]=[];for(var a=0;a<t.boardSize;a++)e[r].push([2293760|a])}return e},Model.Game.cbMergeGraphs=function(t){for(var e=[],r=0;r<t.boardSize;r++){e[r]=[];for(var a=1;a<arguments.length;a++)e[r]=e[r].concat(arguments[a][r])}return e},Model.Game.cbGetThreatGraph=function(){function t(e,r){for(var a in n){var i=n[a];if(!(i.p.length<r.length+1)){for(var s=!0,o=0;o<r.length;o++)if(r[o]!=i.p[o]){s=!1;break}if(s){var h=i.p[r.length],c=e[h];void 0===c&&(c={e:{}},e[h]=c),i.p.length==r.length+1&&(c.t=i.t,c.ts=i.ts,c.tk=i.tk,delete n[a]),r.push(h),t(c.e,r),r.pop()}}}}var e=this;this.cbUseScreenCapture=!1,this.cbUseCaptureKing=!1,this.cbUseCaptureNoKing=!1;for(var r={1:[],"-1":[]},a=[],i=0;i<this.g.boardSize;i++)this.g.pTypes.forEach(function(t,r){t.graph[i].forEach(function(t){for(var s=[],n=0;n<t.length;n++){var o=t[n];1048576&o?(e.cbUseCaptureKing=!0,s.unshift({d:65535&o,a:i,tk:r})):2097152&o?(e.cbUseCaptureNoKing=!0,s.unshift({d:65535&o,a:i,tnk:r})):131072&o?s.unshift({d:65535&o,a:i,t:r}):262144&o?s.unshift({d:65535&o,a:i}):524288&o&&(e.cbUseScreenCapture=!0,s.unshift({d:65535&o,a:i,ts:r}))}s.length>0&&a.push(s)})});var s={};a.forEach(function(t){t.forEach(function(e,r){var a=s[e.d];void 0===a&&(a={},s[e.d]=a);for(var i=[],n=r+1;n<t.length;n++)i.push(t[n].d);i.push(e.a);var o=i.join(","),h=a[o];void 0===h&&(h={p:i,t:{},ts:{},tk:{}},a[o]=h),void 0!==e.t?h.t[e.t]=!0:void 0!==e.tk?h.tk[e.tk]=!0:void 0!==e.ts&&(h.ts[e.ts]=!0)})});for(var i=0;i<e.g.boardSize;i++){var n=s[i],o={};t(o,[]),r[1][i]=o,r[-1][i]=o}return r},Model.Game.InitGame=function(){var e=this;this.cbVar=t=this.cbDefine(),this.g.boardSize=this.cbVar.geometry.boardSize,this.g.pTypes=this.cbGetPieceTypes(),this.g.threatGraph=this.cbGetThreatGraph(),this.g.distGraph=this.cbVar.geometry.GetDistances(),this.cbPiecesCount=0,this.g.castleablePiecesCount={1:0,"-1":0};for(var r in t.pieceTypes){var a=t.pieceTypes[r];if(a.castle){(a.initial||[]).forEach(function(t){e.g.castleablePiecesCount[t.s]++})}a.initial&&(this.cbPiecesCount+=a.initial.length)}for(var i=[],r=0;r<this.cbPiecesCount;r++)i.push(r);var s=Object.keys(t.pieceTypes);this.zobrist=new JocGame.Zobrist({board:{type:"array",size:this.cbVar.geometry.boardSize,values:i},who:{values:["1","-1"]},type:{type:"array",size:this.cbPiecesCount,values:s}})},Model.Game.cbGetPieceTypes=function(){for(var t=[],e={},r=0;r<this.cbVar.geometry.boardSize;r++)e[r]=[];for(var a in this.cbVar.pieceTypes){var i=this.cbVar.pieceTypes[a];t[a]={graph:i.graph||e,abbrev:i.abbrev||"",value:i.isKing?100:i.value||1,isKing:!!i.isKing,castle:!!i.castle,epTarget:!!i.epTarget,epCatch:!!i.epCatch}}return t},Model.Board.Init=function(t){this.zSign=0},Model.Board.InitialPosition=function(r){var a=this;this.board=e?new Int16Array(r.g.boardSize):[];for(var i=0;i<r.g.boardSize;i++)this.board[i]=-1;if(this.kings={},this.pieces=[],this.ending={1:!1,"-1":!1},this.lastMove=null,r.cbVar.castle&&(this.castled={1:!1,"-1":!1}),this.zSign=r.zobrist.update(0,"who",-1),this.noCaptCount=0,this.mWho=1,r.mInitial)this.mWho=r.mInitial.turn||1,r.mInitial.pieces.forEach(function(t){var e={};for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);a.pieces.push(e)}),r.mInitial.lastMove&&(this.lastMove={f:r.mInitial.lastMove.f,t:r.mInitial.lastMove.t}),void 0!==r.mInitial.noCaptCount&&(this.noCaptCount=r.mInitial.noCaptCount),r.cbVar.castle&&r.mInitial.castle&&(this.castled={1:{k:!!r.mInitial.castle[1]&&!!r.mInitial.castle[1].k,q:!!r.mInitial.castle[1]&&!!r.mInitial.castle[1].q},"-1":{k:!!r.mInitial.castle[-1]&&!!r.mInitial.castle[-1].k,q:!!r.mInitial.castle[-1]&&!!r.mInitial.castle[-1].q}});else for(var s in r.cbVar.pieceTypes)for(var n=r.cbVar.pieceTypes[s],o=n.initial||[],h=0;h<o.length;h++){var c=o[h],p={s:c.s,t:parseInt(s),p:c.p,m:!1};this.pieces.push(p)}if(this.pieces.sort(function(t,e){if(t.s!=e.s)return e.s-t.s;var a=r.cbVar.pieceTypes[t.t].value||100,i=r.cbVar.pieceTypes[e.t].value||100;return a!=i?a-i:t.p-e.p}),this.pieces.forEach(function(t,e){t.i=e,a.board[t.p]=e,r.g.pTypes[t.t].isKing&&(a.kings[t.s]=t.p),a.zSign=r.zobrist.update(a.zSign,"board",e,t.p),a.zSign=r.zobrist.update(a.zSign,"type",t.t,e)}),r.mInitial&&r.mInitial.enPassant){var i=t.geometry.PosByName(r.mInitial.enPassant);if(i>=0){var l,u=t.geometry.C(i),v=t.geometry.R(i);l=1==r.mInitial.turn?t.geometry.POS(u,v-1):t.geometry.POS(u,v+1),this.epTarget={p:i,i:this.board[l]}}}},Model.Board.CopyFrom=function(t){if(e)this.board=new Int16Array(t.board.length),this.board.set(t.board);else{this.board=[];for(var r=t.board,a=r.length,i=0;i<a;i++)this.board.push(r[i])}this.pieces=[];for(var s=t.pieces.length,i=0;i<s;i++){var n=t.pieces[i];this.pieces.push({s:n.s,p:n.p,t:n.t,i:n.i,m:n.m})}this.kings={1:t.kings[1],"-1":t.kings[-1]},this.check=t.check,t.lastMove?this.lastMove={f:t.lastMove.f,t:t.lastMove.t,c:t.lastMove.c}:this.lastMove=null,this.ending={1:t.ending[1],"-1":t.ending[-1]},void 0!==t.castled&&(this.castled={1:t.castled[1],"-1":t.castled[-1]}),this.noCaptCount=t.noCaptCount,t.epTarget?this.epTarget={p:t.epTarget.p,i:t.epTarget.i}:this.epTarget=null,this.mWho=t.mWho,this.zSign=t.zSign},Model.Board.cbApplyCastle=function(t,e,r){var a=t.cbVar.castle[e.f+"/"+e.cg],i=a.r[a.r.length-1],s=this.pieces[this.board[e.cg]],n=a.k[a.k.length-1],o=this.pieces[this.board[e.f]];return r&&(this.zSign=t.zobrist.update(this.zSign,"board",s.i,e.cg),this.zSign=t.zobrist.update(this.zSign,"board",s.i,i),this.zSign=t.zobrist.update(this.zSign,"board",o.i,e.f),this.zSign=t.zobrist.update(this.zSign,"board",o.i,n)),s.p=i,s.m=!0,this.board[e.cg]=-1,o.p=n,o.m=!0,this.board[e.f]=-1,this.board[i]=s.i,this.board[n]=o.i,this.castled[s.s]=!0,this.kings[o.s]=n,[{i:s.i,f:i,t:-1},{i:o.i,f:n,t:e.f,kp:e.f,who:o.s,m:!1},{i:s.i,f:-1,t:e.cg,m:!1,cg:!1}]},Model.Board.cbQuickApply=function(t,e){if(void 0!==e.cg)return this.cbApplyCastle(t,e,!1);var r=[],a=this.board[e.f],i=this.pieces[a];if(null!=e.c){r.unshift({i:e.c,f:-1,t:this.pieces[e.c].p});var s=this.pieces[e.c];this.board[s.p]=-1,s.p=-1}var n=this.kings[i.s];return t.g.pTypes[i.t].isKing&&(this.kings[i.s]=e.t),r.unshift({i:a,f:e.t,t:e.f,kp:n,who:i.s,ty:i.t}),i.p=e.t,void 0!==e.pr&&(i.t=e.pr),this.board[e.f]=-1,this.board[e.t]=a,r},Model.Board.cbQuickUnapply=function(t,e){for(var r=0;r<e.length;r++){var a=e[r],i=this.pieces[a.i];a.f>=0&&(i.p=-1,this.board[a.f]=-1),a.t>=0&&(i.p=a.t,this.board[a.t]=a.i),void 0!==a.m&&(i.m=a.m),void 0!==a.kp&&(this.kings[a.who]=a.kp),void 0!=a.ty&&(i.t=a.ty),void 0!=a.cg&&(this.castled[i.s]=a.cg)}},Model.Board.ApplyMove=function(t,e){var r=this.pieces[this.board[e.f]];if(void 0!==e.cg)this.cbApplyCastle(t,e,!0);else{if(this.zSign=t.zobrist.update(this.zSign,"board",r.i,e.f),this.board[r.p]=-1,void 0!==e.pr&&(this.zSign=t.zobrist.update(this.zSign,"type",r.t,r.i),r.t=e.pr,this.zSign=t.zobrist.update(this.zSign,"type",r.t,r.i)),null!=e.c){var a=this.pieces[e.c];this.zSign=t.zobrist.update(this.zSign,"board",a.i,a.p),this.board[a.p]=-1,a.p=-1,a.m=!0,this.noCaptCount=0}else this.noCaptCount++;r.p=e.t,r.m=!0,this.board[e.t]=r.i,this.zSign=t.zobrist.update(this.zSign,"board",r.i,e.t),t.g.pTypes[r.t].isKing&&(this.kings[r.s]=e.t)}this.check=!!e.ck,this.lastMove={f:e.f,t:e.t,c:e.c},void 0!==e.ko&&(this.ending[r.s]=e.ko),void 0!==e.ept?this.epTarget={p:e.ept,i:r.i}:this.epTarget=null,this.zSign=t.zobrist.update(this.zSign,"who",-this.mWho),this.zSign=t.zobrist.update(this.zSign,"who",this.mWho)},Model.Board.Evaluate=function(r){function a(e){var r=1/0;for(var a in t.geometry.corners)r=Math.min(r,h.distGraph[s.kings[e]][a]);return r-Math.sqrt(h.boardSize)}var i="debug"==arguments[3],s=this;this.mEvaluation=0;var n,o=this.mWho,h=r.g;if(e)n={1:{count:new Uint8Array(h.pTypes.length),byType:{}},"-1":{count:new Uint8Array(h.pTypes.length),byType:{}}};else{n={1:{count:[],byType:{}},"-1":{count:[],byType:{}}};for(var c=0;c<h.pTypes.length;c++)n[1].count[c]=n[-1].count[c]=0}if(r.mOptions.preventRepeat&&r.GetRepeatOccurence(this)>2)return this.mFinished=!0,void(this.mWinner=r.cbOnPerpetual?o*r.cbOnPerpetual:JocGame.DRAW);for(var p={1:0,"-1":0},l={1:h.distGraph[this.kings[-1]],"-1":h.distGraph[this.kings[1]]},u={1:0,"-1":0},v={1:0,"-1":0},b={1:0,"-1":0},f={1:0,"-1":0},d={1:!1,"-1":!1},g=this.pieces,m=g.length,c=0;c<m;c++){var G=g[c];if(G.p>=0){var y=G.s,M=h.pTypes[G.t];M.isKing?d[y]=G.m:p[y]+=M.value,M.castle&&!G.m&&f[y]++,v[y]++,u[y]+=l[y][G.p],b[y]+=t.geometry.distEdge[G.p];var C=n[y];C.count[G.t]++;var S=C.byType;void 0===S[G.t]?S[G.t]=[G]:S[G.t].push(G)}}if(this.lastMove&&null!=this.lastMove.c){var G=this.pieces[this.board[this.lastMove.t]];p[-G.s]+=this.cbStaticExchangeEval(r,G.p,G.s,{piece:G})}var k={1:0,"-1":0},A={1:0,"-1":0},T={1:0,"-1":0};this.ending[1]&&(A[1]=(u[1]-Math.sqrt(h.boardSize))/v[1],t.geometry.corners&&(T[1]=a(1))),this.ending[-1]&&(A[-1]=(u[-1]-Math.sqrt(h.boardSize))/v[-1],t.geometry.corners&&(T[1]=a(-1)));var z={pieceValue:p[1]-p[-1],pieceValueRatio:(p[1]-p[-1])/(p[1]+p[-1]+1),posValue:b[1]-b[-1],averageDistKing:u[1]/v[1]-u[-1]/v[-1],check:this.check?-o:0,endingKingFreedom:k[1]-k[-1],endingDistKing:A[1]-A[-1],distKingCorner:T[1]-T[-1]};t.castle&&(z.castle=(this.castled[1]?1:d[1]?0:f[1]/(h.castleablePiecesCount[1]+1))-(this.castled[-1]?1:d[-1]?0:f[-1]/(h.castleablePiecesCount[-1]+1))),t.evaluate&&t.evaluate.call(this,r,z,n);var E=r.mOptions.levelOptions;for(var P in z){var w=z[P],I=E[P+"Factor"]||0,R=w*I;i&&console.log(P,"=",w,"*",I,"=>",R),this.mEvaluation+=R}i&&console.log("Evaluation",this.mEvaluation)},Model.Board.cbGeneratePseudoLegalMoves=function(t){function e(e,i){var s=t.cbVar.promote;if(!s)return void a.push(i);var n=s.call(r,t,e,i);if(null!=n)if(0==n.length)a.push(i);else if(1==n.length)i.pr=n[0],a.push(i);else for(var o=0;o<n.length;o++){var h=n[o];a.push({f:i.f,t:i.t,c:i.c,pr:h,ept:i.ept,ep:i.ep,a:i.a})}}for(var r=this,a=[],i=t.cbVar,s=this.mWho,n=!i.castle||this.check||this.castled[s]?null:[],o=-1,h=this.pieces.length,c=0;c<h;c++){var p=this.pieces[c];if(!(p.p<0||p.s!=s)){var l=t.g.pTypes[p.t];l.isKing&&(p.m?n=null:o=p),n&&l.castle&&!p.m&&n.push(p);var u,v;u=l.graph[p.p],v=u.length;for(var b=0;b<v;b++)for(var f=u[b],d=!1,g=f.length,m=null,G=0;G<g;G++){var y=f[G],M=65535&y,C=this.board[M];if(!(C<0)||l.epCatch&&this.epTarget&&this.epTarget.p==M){if(!(524288&y)){var S;S=C<0?this.pieces[this.epTarget.i]:this.pieces[C],!(S.s!=p.s&&131072&y)||1048576&y&&!t.g.pTypes[S.t].isKing||2097152&y&&t.g.pTypes[S.t].isKing||e(p,{f:p.p,t:M,c:S.i,a:l.abbrev,ep:C<0});break}if(d){var S=this.pieces[C];S.s!=p.s&&e(p,{f:p.p,t:M,c:S.i,a:l.abbrev});break}d=!0}else 65536&y&&0==d&&e(p,{f:p.p,t:M,c:null,a:l.abbrev,ept:null!=m&&l.epTarget?m:void 0});m=M}}}if(n)for(var c=0;c<n.length;c++){var k=n[c],A=t.cbVar.castle[o.p+"/"+k.p];if(A){for(var T=!0,b=0;b<A.r.length;b++){var z=A.r[b];if(this.board[z]>=0&&z!=o.p&&z!=k.p){T=!1;break}}if(T){for(var E=!0,b=0;b<A.k.length;b++){var z=A.k[b];if(this.board[z]>=0&&z!=k.p&&z!=o.p||this.cbGetAttackers(t,z,s).length>0){E=!1;break}}E&&a.push({f:o.p,t:A.k[A.k.length-1],c:null,cg:k.p})}}}return a},Model.Board.cbStaticExchangeEval=function(t,e,r,a){var i=0,s=this.cbGetSmallestAttacker(t,e,r);if(s){var n=this.mWho;this.mWho=s.s;var o=this.cbQuickApply(t,{f:s.p,t:e,c:a.piece.i}),h=t.g.pTypes[a.piece.t].value;a.piece=s,i=Math.max(0,h-this.cbStaticExchangeEval(t,e,-r,a)),this.cbQuickUnapply(t,o),this.mWho=n}return i},Model.Board.cbGetSmallestAttacker=function(t,e,r){var a=this.cbGetAttackers(t,e,r);if(0==a.length)return null;for(var i=1/0,s=null,n=a.length,o=0;o<n;o++){var h=a[o],c=t.g.pTypes[h.t].value;c<i&&(i=c,s=h)}return s},Model.Board.cbCollectAttackers=function(t,e,r,a){for(var i in e){var s=e[i],n=this.board[i];if(n<0)this.cbCollectAttackers(t,s.e,r,a);else{var o=this.pieces[n];o.s==-t&&(s.t&&o.t in s.t||a&&s.tk&&o.t in s.tk)&&r.push(o)}}},Model.Board.cbCollectAttackersScreen=function(t,e,r,a,i){for(var s in e){var n=e[s],o=this.board[s];if(o<0)this.cbCollectAttackersScreen(t,n.e,r,a,i);else{var h=this.pieces[o];!i&&h.s==-t&&(n.t&&h.t in n.t||a&&n.tk&&h.t in n.tk)?r.push(h):i?i&&h.s==-t&&n.ts&&h.t in n.ts&&r.push(h):this.cbCollectAttackersScreen(t,n.e,r,a,!0)}}},Model.Board.cbGetAttackers=function(t,e,r,a){var i=[];return t.cbUseScreenCapture?this.cbCollectAttackersScreen(r,t.g.threatGraph[r][e],i,a,!1):this.cbCollectAttackers(r,t.g.threatGraph[r][e],i,a),i},Model.Board.GenerateMoves=function(t){var e=this.cbGeneratePseudoLegalMoves(t);this.mMoves=[];for(var r=!0,a=this.kings[this.mWho],i=e.length,s=0;s<i;s++){var n=e[s],o=this.cbQuickApply(t,n);if(!(this.cbGetAttackers(t,this.kings[this.mWho],this.mWho,!0).length>0)){var h=this.cbGetAttackers(t,this.kings[-this.mWho],-this.mWho,!0).length>0;n.ck=h,this.mMoves.push(n),n.f!=a&&(r=!1)}this.cbQuickUnapply(t,o)}if(0==this.mMoves.length)this.mFinished=!0,this.mWinner=t.cbOnStaleMate?t.cbOnStaleMate*this.mWho:JocGame.DRAW,this.check&&(this.mWinner=-this.mWho);else if(this.ending[this.mWho]){if(!r)for(var s=0;s<this.mMoves.length;s++)this.mMoves[s].ko=!1}else if(!this.ending[this.mWho]&&r&&!this.check)for(var s=0;s<this.mMoves.length;s++)this.mMoves[s].ko=!0},Model.Board.GetSignature=function(){return this.zSign},Model.Move.Init=function(t){for(var e in t)t.hasOwnProperty(e)&&(this[e]=t[e])},Model.Move.Equals=function(t){return this.f==t.f&&this.t==t.t&&this.pr==t.pr},Model.Move.CopyFrom=function(t){this.Init(t)},Model.Move.ToString=function(e){var r=this;switch(e=e||"natural"){case"natural":return function(){var e;if(void 0!==r.cg?e=t.castle[r.f+"/"+r.cg].n:(e=r.a||"",e+=t.geometry.PosName(r.f),null==r.c?e+="-":e+="x",e+=t.geometry.PosName(r.t)),void 0!==r.pr){var a=t.pieceTypes[r.pr];a&&a.abbrev&&a.abbrev.length>0&&!a.silentPromo&&(e+="="+a.abbrev)}return r.ck&&(e+="+"),e}();case"engine":return function(){var e=t.geometry.PosName(r.f)+t.geometry.PosName(r.t);if(void 0!=r.pr){var a=t.pieceTypes[r.pr];a&&a.abbrev&&a.abbrev.length>0&&!a.silentPromo&&(e+=a.abbrev)}return e}();default:return"??"}},Model.Board.CompactMoveString=function(e,r,a){"function"!=typeof r.ToString&&(r=e.CreateMove(r));var i=r.ToString(),s=/^([A-Z]?)([a-z])([1-9][0-9]*)([-x])([a-z])([1-9][0-9]*)(.*?)$/.exec(i);if(!s)return i;var n=s[7];if(a||(a={}),a.value||(a.value=[]),0==a.value.length){var o=this.mMoves;this.mMoves&&0!=this.mMoves.length||this.GenerateMoves(e);for(var h=0;h<this.mMoves.length;h++){var c=this.mMoves[h];"function"!=typeof c.ToString&&(c=e.CreateMove(c)),a.value.push({str:c.ToString(),move:c})}this.mMoves=o}var p=[];if(a.value.forEach(function(t){var e=/^([A-Z]?[a-z][1-9][0-9]*[-x][a-z][1-9][0-9]*)(.*?)$/.exec(t.str);e&&t.move.t==r.t&&(t.move.a||"")==s[1]&&e[2]==n&&p.push(t.move)}),1==p.length)return""==s[1]&&"x"==s[4]?s[2]+"x"+s[5]+s[6]+s[7]:s[1]+("x"==s[4]?"x":"")+s[5]+s[6]+s[7];if(t.geometry.CompactCrit)for(var l="",h=0;;h++){var u=t.geometry.CompactCrit(r.f,h);if(null==u)return i;l+=u;for(var v=[],b=0;b<p.length;b++){var f=p[b];t.geometry.CompactCrit(f.f,h)==u&&v.push(f)}if(console.assert(v.length>0),1==v.length)return s[1]+l+("x"==s[4]?"x":"")+s[5]+s[6]+s[7];p=v}return i},Model.Board.cbIntegrity=function(t){function e(t,e){t||console.error(e)}for(var r=this,a=0;a<this.board.length;a++){var i=this.board[a];if(i>=0){var s=r.pieces[i];e(void 0!==s,"no piece at pos"),e(s.p==a,"piece has different pos")}}for(var i=0;i<this.pieces.length;i++){var s=this.pieces[i];s.p>=0&&e(r.board[s.p]==i,"board index mismatch")}},Model.Board.ExportBoardState=function(t){return t.cbVar.geometry.ExportBoardState?t.cbVar.geometry.ExportBoardState(this,t.cbVar,t.mPlayedMoves.length):"not supported"},Model.Game.Import=function(e,r){var a,i=[],s={1:{},"-1":{}},n=null,o=0;if("pjn"==e){var h={status:!1,error:"parse"},c=r.split(" ");if(6!=c.length)return console.warn("FEN should have 6 parts"),h;var p=c[0].split("/"),l=t.geometry.fenHeight||t.geometry.height;if(p.length!=l)return console.warn("FEN board should have",l,"rows, got",p.length),h;var u={};for(var v in t.pieceTypes){var b=t.pieceTypes[v],f=b.fenAbbrev||b.abbrev||"X";u[f.toUpperCase()]={s:1,t:v},u[f.toLowerCase()]={s:-1,t:v}}var d=t.geometry.FenRowPos||function(e,r){return(t.geometry.height-1-e)*t.geometry.width+r};if(p.forEach(function(e,r){for(var a=0,s=0;s<e.length;s++){var n=e.substr(s,1),o=u[n];if(void 0!==o){var c=d(r,a);a++;for(var p={s:o.s,t:o.t,p:c},l=!0,v=t.pieceTypes[p.t].initial||[],b=0;b<v.length;b++){var f=v[b];f.s==p.s&&f.p==c&&(l=!1)}p.m=l,i.push(p)}else{if(isNaN(parseInt(n)))return console.warn("FEN invalid board spec",n),h;a+=parseInt(n)}}}),i.sort(function(t,e){return e.s-t.s}),"w"==c[1])a=1;else{if("b"!=c[1])return console.warn("FEN invalid turn spec",c[1]),h;a=-1}s[1].k=c[2].indexOf("K")>=0,s[1].q=c[2].indexOf("Q")>=0,s[-1].k=c[2].indexOf("k")>=0,s[-1].q=c[2].indexOf("q")>=0,n="-"==c[3]?null:c[3];var g=parseInt(c[4]);isNaN(g)||(o=g);var m={pieces:i,turn:a,castle:s,enPassant:n,noCaptCount:o};return t.importGame&&t.importGame.call(this,m,e,r),{status:!0,initial:m}}return{status:!1,error:"unsupported"}}}(),function(){Model.Game.cbBoardGeometryGrid=function(t,e){function r(e){return e%t}function a(e){return Math.floor(e/t)}function i(e,r){return r*t+e}function s(s,n){var o=r(s),h=a(s),c=o+n[0],p=h+n[1];return c<0||c>=t||p<0||p>=e?null:i(c,p)}function n(t){return String.fromCharCode("a".charCodeAt(0)+r(t))+(a(t)+1)}function o(t){var e=/^([a-z])([0-9]+)$/.exec(t);return e?i(e[1].charCodeAt(0)-"a".charCodeAt(0),parseInt(e[2])-1):-1}function h(t,e){return 0==e?String.fromCharCode("a".charCodeAt(0)+r(t)):1==e?a(t)+1:null}function c(){for(var i=[],s=0;s<t*e;s++){var n=[];i.push(n);for(var o=0;o<t*e;o++){var h=a(s),c=r(s),p=a(o),l=r(o);n.push(Math.max(Math.abs(h-p),Math.abs(c-l)))}}return i}function p(r,a,s){for(var o=[],h=e-1;h>=0;h--){for(var c="",p=0,l=0;l<t;l++){var u=r.board[i(l,h)];if(u<0)p++;else{p>0&&(c+=p,p=0);var v=r.pieces[u],b=a.pieceTypes[v.t].fenAbbrev||a.pieceTypes[v.t].abbrev||"?";v.s==-1?c+=b.toLowerCase():c+=b.toUpperCase()}}p&&(c+=p),o.push(c)}var f=o.join("/");f+=" ",1==r.mWho?f+="w":f+="b",f+=" ";var d="";return r.castled&&(r.castled[1]===!1?d+="KQ":(r.castled[1].k&&(d+="K"),r.castled[1].q&&(d+="Q")),r.castled[-1]===!1?d+="kq":(r.castled[-1].k&&(d+="k"),r.castled[-1].q&&(d+="q"))),0==d.length&&(d="-"),f+=d,f+=" ",r.epTarget?f+=n(r.epTarget.p):f+="-",f+=" ",f+=r.noCaptCount,f+=" ",f+=Math.floor(s/2)+1}return{boardSize:t*e,width:t,height:e,C:r,R:a,POS:i,Graph:s,PosName:n,PosByName:o,CompactCrit:h,GetDistances:c,distEdge:function(){for(var i=[],s=0;s<t*e;s++){var n=r(s),o=a(s);i[s]=Math.min(n,Math.abs(t-n-1),o,Math.abs(e-o-1))}return i}(),corners:function(){var r={};return r[i(0,0)]=1,r[i(0,e-1)]=1,r[i(t-1,0)]=1,r[i(t-1,e-1)]=1,r}(),ExportBoardState:p}},Model.Game.cbPawnGraph=function(t,e,r){for(var a=this,i={},s=0;s<t.boardSize;s++)if(!r||s in r){var n=[],o=t.Graph(s,[0,e]);null!=o&&(!r||o in r)&&n.push(a.cbTypedArray([o|a.cbConstants.FLAG_MOVE])),[-1,1].forEach(function(i){var o=t.Graph(s,[i,e]);null!=o&&(!r||o in r)&&n.push(a.cbTypedArray([o|a.cbConstants.FLAG_CAPTURE]))}),i[s]=n}else i[s]=[];return i},Model.Game.cbInitialPawnGraph=function(t,e,r){for(var a=this,i={},s=0;s<t.boardSize;s++)if(!r||s in r){var n=[],o=t.Graph(s,[0,e]);if(null!=o&&(!r||o in r)){var h=[o|a.cbConstants.FLAG_MOVE],c=t.Graph(o,[0,e]);null!=c&&(!r||c in r)&&h.push(c|a.cbConstants.FLAG_MOVE),n.push(a.cbTypedArray(h))}[-1,1].forEach(function(i){var o=t.Graph(s,[i,e]);null!=o&&(!r||o in r)&&n.push(a.cbTypedArray([o|a.cbConstants.FLAG_CAPTURE]))}),i[s]=n}else i[s]=[];return i},Model.Game.cbKingGraph=function(t,e){return this.cbShortRangeGraph(t,[[-1,-1],[-1,0],[-1,1],[0,-1],[0,1],[1,-1],[1,0],[1,1]],e)},Model.Game.cbKnightGraph=function(t,e){return this.cbShortRangeGraph(t,[[2,-1],[2,1],[-2,-1],[-2,1],[-1,2],[-1,-2],[1,2],[1,-2]],e)},Model.Game.cbHorseGraph=function(t){for(var e=this,r={},a=0;a<t.boardSize;a++)r[a]=[],[[1,0,2,-1],[1,0,2,1],[-1,0,-2,-1],[-1,0,-2,1],[0,1,-1,2],[0,-1,-1,-2],[0,1,1,2],[0,-1,1,-2]].forEach(function(i){var s=t.Graph(a,[i[0],i[1]]);if(null!=s){var n=t.Graph(a,[i[2],i[3]]);null!=n&&r[a].push(e.cbTypedArray([s|e.cbConstants.FLAG_STOP,n|e.cbConstants.FLAG_MOVE|e.cbConstants.FLAG_CAPTURE]))}});return r},Model.Game.cbRookGraph=function(t,e){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0]],e)},Model.Game.cbBishopGraph=function(t,e){return this.cbLongRangeGraph(t,[[1,-1],[1,1],[-1,1],[-1,-1]],e)},Model.Game.cbQueenGraph=function(t,e){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0],[1,-1],[1,1],[-1,1],[-1,-1]],e)},Model.Game.cbXQGeneralGraph=function(t,e){for(var r=this,a={},i=0;i<t.boardSize;i++)a[i]=[],[[-1,0,!1],[0,-1,!0],[0,1,!0],[1,0,!1]].forEach(function(s){var n=[],o=t.Graph(i,s);if(null!=o&&((!e||o in e)&&n.push(o|r.cbConstants.FLAG_MOVE|r.cbConstants.FLAG_CAPTURE),s[2]))for(var h=t.Graph(o,s);null!=h;)!e||h in e?n.push(h|r.cbConstants.FLAG_CAPTURE|r.cbConstants.FLAG_CAPTURE_KING):n.push(h|r.cbConstants.FLAG_STOP),h=t.Graph(h,s);n.length>0&&a[i].push(r.cbTypedArray(n))});return a},Model.Game.cbXQSoldierGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e]])},Model.Game.cbXQPromoSoldierGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e],[-1,0],[1,0]])},Model.Game.cbXQAdvisorGraph=function(t,e){return this.cbShortRangeGraph(t,[[1,1],[-1,1],[1,-1],[-1,-1]],e)},Model.Game.cbXQCannonGraph=function(t){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0]],null,this.cbConstants.FLAG_MOVE|this.cbConstants.FLAG_SCREEN_CAPTURE)},Model.Game.cbXQElephantGraph=function(t,e){for(var r=this,a={},i=0;i<t.boardSize;i++)a[i]=[],(!e||i in e)&&[[1,1,2,2],[1,-1,2,-2],[-1,1,-2,2],[-1,-1,-2,-2]].forEach(function(s){var n=t.Graph(i,[s[0],s[1]]);if(null!=n){var o=t.Graph(i,[s[2],s[3]]);null!=o&&(!e||o in e)&&a[i].push(r.cbTypedArray([n|r.cbConstants.FLAG_STOP,o|r.cbConstants.FLAG_MOVE|r.cbConstants.FLAG_CAPTURE]))}});return a},Model.Game.cbSilverGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e],[-1,-1],[-1,1],[1,-1],[1,1]])},Model.Game.cbFersGraph=function(t,e){return this.cbShortRangeGraph(t,[[-1,-1],[-1,1],[1,-1],[1,1]])},Model.Game.cbSchleichGraph=function(t,e){return this.cbShortRangeGraph(t,[[-1,0],[1,0],[0,-1],[0,1]])},Model.Game.cbAlfilGraph=function(t,e){return this.cbShortRangeGraph(t,[[-2,-2],[-2,2],[2,2],[2,-2]])}}(),function(){var t=Model.Game.cbBoardGeometryGrid(10,8);Model.Game.cbDefine=function(){return{geometry:t,pieceTypes:{0:{name:"pawn-w",aspect:"fr-pawn",graph:this.cbPawnGraph(t,1),value:1,abbrev:"",fenAbbrev:"P",epCatch:!0},1:{name:"ipawn-w",aspect:"fr-pawn",graph:this.cbInitialPawnGraph(t,1),value:1,abbrev:"",fenAbbrev:"P",initial:[{s:1,p:10},{s:1,p:11},{s:1,p:12},{s:1,p:13},{s:1,p:14},{s:1,p:15},{s:1,p:16},{s:1,p:17},{s:1,p:18},{s:1,p:19}],epTarget:!0},2:{name:"pawn-b",aspect:"fr-pawn",graph:this.cbPawnGraph(t,-1),value:1,abbrev:"",fenAbbrev:"P",epCatch:!0},3:{name:"ipawn-b",aspect:"fr-pawn",graph:this.cbInitialPawnGraph(t,-1),value:1,abbrev:"",fenAbbrev:"P",initial:[{s:-1,p:60},{s:-1,p:61},{s:-1,p:62},{s:-1,p:63},{s:-1,p:64},{s:-1,p:65},{s:-1,p:66},{s:-1,p:67},{s:-1,p:68},{s:-1,p:69}],epTarget:!0},4:{name:"knight",aspect:"fr-knight",graph:this.cbKnightGraph(t),value:2.9,abbrev:"N",initial:[{s:1,p:2},{s:1,p:7},{s:-1,p:72},{s:-1,p:77}]},5:{name:"bishop",aspect:"fr-bishop",graph:this.cbBishopGraph(t),value:3.1,abbrev:"B",initial:[{s:1,p:3},{s:1,p:6},{s:-1,p:73},{s:-1,p:76}]},6:{name:"rook",aspect:"fr-rook",graph:this.cbRookGraph(t),value:5,abbrev:"R",initial:[{s:1,p:0},{s:1,p:9},{s:-1,p:70},{s:-1,p:79}],castle:!0},7:{name:"queen",aspect:"fr-queen",graph:this.cbQueenGraph(t),value:9,abbrev:"Q",initial:[{s:1,p:5},{s:-1,p:75}]},8:{name:"king",aspect:"fr-king",isKing:!0,graph:this.cbKingGraph(t),abbrev:"K",initial:[{s:1,p:4},{s:-1,p:74}]},10:{name:"janus",aspect:"fr-cardinal",graph:this.cbMergeGraphs(t,this.cbBishopGraph(t),this.cbKnightGraph(t)),value:6,abbrev:"J",initial:[{s:1,p:1},{s:1,p:8},{s:-1,p:71},{s:-1,p:78}]}},promote:function(e,r,a){return 1==r.t?[0]:3==r.t?[2]:0==r.t&&7==t.R(a.t)?[4,5,6,7,10]:2==r.t&&0==t.R(a.t)?[4,5,6,7,10]:[]},castle:{"4/0":{k:[3,2,1],r:[1,2],n:"O-O"},"4/9":{k:[5,6,7,8],r:[8,7],n:"O-O-O"},"74/70":{k:[73,72,71],r:[71,72],n:"O-O"},"74/79":{k:[75,76,77,78],r:[78,77],n:"O-O-O"}}}}}();

/***/ }),

/***/ "0kY5":
/***/ (function(module, exports) {

exports.model=Model={Game:{},Board:{},Move:{}},function(){var t;Model.Game.cbConstants={MASK:65535,FLAG_MOVE:65536,FLAG_CAPTURE:131072,FLAG_STOP:262144,FLAG_SCREEN_CAPTURE:524288,FLAG_CAPTURE_KING:1048576,FLAG_CAPTURE_NO_KING:2097152};var e="undefined"!=typeof Int32Array;Model.Game.cbUseTypedArrays=e,Model.Game.cbTypedArray=function(t){if(e){var i=new Int32Array(t.length);return i.set(t),i}for(var r=[],a=t.length,s=0;s<a;s++)r.push(t[s]);return r},Model.Game.cbShortRangeGraph=function(t,e,i,r){var a=this;void 0===r&&(r=196608);for(var s={},n=0;n<t.boardSize;n++)s[n]=[],(!i||n in i)&&e.forEach(function(e){var o=t.Graph(n,e);null!=o&&(!i||o in i)&&s[n].push(a.cbTypedArray([o|r]))});return s},Model.Game.cbLongRangeGraph=function(t,e,i,r,a){var s=this;void 0!==r&&null!=r||(r=196608),a||(a=1/0);for(var n={},o=0;o<t.boardSize;o++)n[o]=[],(!i||o in i)&&e.forEach(function(e){for(var h=[],p=t.Graph(o,e),c=0;null!=p&&(!i||p in i)&&(h.push(p|r),++c!=a);)p=t.Graph(p,e);h.length>0&&n[o].push(s.cbTypedArray(h))});return n},Model.Game.cbNullGraph=function(t){for(var e={},i=0;i<t.boardSize;i++)e[i]=[];return e},Model.Game.cbAuthorGraph=function(t){for(var e={},i=0;i<t.boardSize;i++){e[i]=[];for(var r=0;r<t.boardSize;r++)e[i].push([2293760|r])}return e},Model.Game.cbMergeGraphs=function(t){for(var e=[],i=0;i<t.boardSize;i++){e[i]=[];for(var r=1;r<arguments.length;r++)e[i]=e[i].concat(arguments[r][i])}return e},Model.Game.cbGetThreatGraph=function(){function t(e,i){for(var r in n){var a=n[r];if(!(a.p.length<i.length+1)){for(var s=!0,o=0;o<i.length;o++)if(i[o]!=a.p[o]){s=!1;break}if(s){var h=a.p[i.length],p=e[h];void 0===p&&(p={e:{}},e[h]=p),a.p.length==i.length+1&&(p.t=a.t,p.ts=a.ts,p.tk=a.tk,delete n[r]),i.push(h),t(p.e,i),i.pop()}}}}var e=this;this.cbUseScreenCapture=!1,this.cbUseCaptureKing=!1,this.cbUseCaptureNoKing=!1;for(var i={1:[],"-1":[]},r=[],a=0;a<this.g.boardSize;a++)this.g.pTypes.forEach(function(t,i){t.graph[a].forEach(function(t){for(var s=[],n=0;n<t.length;n++){var o=t[n];1048576&o?(e.cbUseCaptureKing=!0,s.unshift({d:65535&o,a:a,tk:i})):2097152&o?(e.cbUseCaptureNoKing=!0,s.unshift({d:65535&o,a:a,tnk:i})):131072&o?s.unshift({d:65535&o,a:a,t:i}):262144&o?s.unshift({d:65535&o,a:a}):524288&o&&(e.cbUseScreenCapture=!0,s.unshift({d:65535&o,a:a,ts:i}))}s.length>0&&r.push(s)})});var s={};r.forEach(function(t){t.forEach(function(e,i){var r=s[e.d];void 0===r&&(r={},s[e.d]=r);for(var a=[],n=i+1;n<t.length;n++)a.push(t[n].d);a.push(e.a);var o=a.join(","),h=r[o];void 0===h&&(h={p:a,t:{},ts:{},tk:{}},r[o]=h),void 0!==e.t?h.t[e.t]=!0:void 0!==e.tk?h.tk[e.tk]=!0:void 0!==e.ts&&(h.ts[e.ts]=!0)})});for(var a=0;a<e.g.boardSize;a++){var n=s[a],o={};t(o,[]),i[1][a]=o,i[-1][a]=o}return i},Model.Game.InitGame=function(){var e=this;this.cbVar=t=this.cbDefine(),this.g.boardSize=this.cbVar.geometry.boardSize,this.g.pTypes=this.cbGetPieceTypes(),this.g.threatGraph=this.cbGetThreatGraph(),this.g.distGraph=this.cbVar.geometry.GetDistances(),this.cbPiecesCount=0,this.g.castleablePiecesCount={1:0,"-1":0};for(var i in t.pieceTypes){var r=t.pieceTypes[i];if(r.castle){(r.initial||[]).forEach(function(t){e.g.castleablePiecesCount[t.s]++})}r.initial&&(this.cbPiecesCount+=r.initial.length)}for(var a=[],i=0;i<this.cbPiecesCount;i++)a.push(i);var s=Object.keys(t.pieceTypes);this.zobrist=new JocGame.Zobrist({board:{type:"array",size:this.cbVar.geometry.boardSize,values:a},who:{values:["1","-1"]},type:{type:"array",size:this.cbPiecesCount,values:s}})},Model.Game.cbGetPieceTypes=function(){for(var t=[],e={},i=0;i<this.cbVar.geometry.boardSize;i++)e[i]=[];for(var r in this.cbVar.pieceTypes){var a=this.cbVar.pieceTypes[r];t[r]={graph:a.graph||e,abbrev:a.abbrev||"",value:a.isKing?100:a.value||1,isKing:!!a.isKing,castle:!!a.castle,epTarget:!!a.epTarget,epCatch:!!a.epCatch}}return t},Model.Board.Init=function(t){this.zSign=0},Model.Board.InitialPosition=function(i){var r=this;this.board=e?new Int16Array(i.g.boardSize):[];for(var a=0;a<i.g.boardSize;a++)this.board[a]=-1;if(this.kings={},this.pieces=[],this.ending={1:!1,"-1":!1},this.lastMove=null,i.cbVar.castle&&(this.castled={1:!1,"-1":!1}),this.zSign=i.zobrist.update(0,"who",-1),this.noCaptCount=0,this.mWho=1,i.mInitial)this.mWho=i.mInitial.turn||1,i.mInitial.pieces.forEach(function(t){var e={};for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i]);r.pieces.push(e)}),i.mInitial.lastMove&&(this.lastMove={f:i.mInitial.lastMove.f,t:i.mInitial.lastMove.t}),void 0!==i.mInitial.noCaptCount&&(this.noCaptCount=i.mInitial.noCaptCount),i.cbVar.castle&&i.mInitial.castle&&(this.castled={1:{k:!!i.mInitial.castle[1]&&!!i.mInitial.castle[1].k,q:!!i.mInitial.castle[1]&&!!i.mInitial.castle[1].q},"-1":{k:!!i.mInitial.castle[-1]&&!!i.mInitial.castle[-1].k,q:!!i.mInitial.castle[-1]&&!!i.mInitial.castle[-1].q}});else for(var s in i.cbVar.pieceTypes)for(var n=i.cbVar.pieceTypes[s],o=n.initial||[],h=0;h<o.length;h++){var p=o[h],c={s:p.s,t:parseInt(s),p:p.p,m:!1};this.pieces.push(c)}if(this.pieces.sort(function(t,e){if(t.s!=e.s)return e.s-t.s;var r=i.cbVar.pieceTypes[t.t].value||100,a=i.cbVar.pieceTypes[e.t].value||100;return r!=a?r-a:t.p-e.p}),this.pieces.forEach(function(t,e){t.i=e,r.board[t.p]=e,i.g.pTypes[t.t].isKing&&(r.kings[t.s]=t.p),r.zSign=i.zobrist.update(r.zSign,"board",e,t.p),r.zSign=i.zobrist.update(r.zSign,"type",t.t,e)}),i.mInitial&&i.mInitial.enPassant){var a=t.geometry.PosByName(i.mInitial.enPassant);if(a>=0){var l,u=t.geometry.C(a),v=t.geometry.R(a);l=1==i.mInitial.turn?t.geometry.POS(u,v-1):t.geometry.POS(u,v+1),this.epTarget={p:a,i:this.board[l]}}}},Model.Board.CopyFrom=function(t){if(e)this.board=new Int16Array(t.board.length),this.board.set(t.board);else{this.board=[];for(var i=t.board,r=i.length,a=0;a<r;a++)this.board.push(i[a])}this.pieces=[];for(var s=t.pieces.length,a=0;a<s;a++){var n=t.pieces[a];this.pieces.push({s:n.s,p:n.p,t:n.t,i:n.i,m:n.m})}this.kings={1:t.kings[1],"-1":t.kings[-1]},this.check=t.check,t.lastMove?this.lastMove={f:t.lastMove.f,t:t.lastMove.t,c:t.lastMove.c}:this.lastMove=null,this.ending={1:t.ending[1],"-1":t.ending[-1]},void 0!==t.castled&&(this.castled={1:t.castled[1],"-1":t.castled[-1]}),this.noCaptCount=t.noCaptCount,t.epTarget?this.epTarget={p:t.epTarget.p,i:t.epTarget.i}:this.epTarget=null,this.mWho=t.mWho,this.zSign=t.zSign},Model.Board.cbApplyCastle=function(t,e,i){var r=t.cbVar.castle[e.f+"/"+e.cg],a=r.r[r.r.length-1],s=this.pieces[this.board[e.cg]],n=r.k[r.k.length-1],o=this.pieces[this.board[e.f]];return i&&(this.zSign=t.zobrist.update(this.zSign,"board",s.i,e.cg),this.zSign=t.zobrist.update(this.zSign,"board",s.i,a),this.zSign=t.zobrist.update(this.zSign,"board",o.i,e.f),this.zSign=t.zobrist.update(this.zSign,"board",o.i,n)),s.p=a,s.m=!0,this.board[e.cg]=-1,o.p=n,o.m=!0,this.board[e.f]=-1,this.board[a]=s.i,this.board[n]=o.i,this.castled[s.s]=!0,this.kings[o.s]=n,[{i:s.i,f:a,t:-1},{i:o.i,f:n,t:e.f,kp:e.f,who:o.s,m:!1},{i:s.i,f:-1,t:e.cg,m:!1,cg:!1}]},Model.Board.cbQuickApply=function(t,e){if(void 0!==e.cg)return this.cbApplyCastle(t,e,!1);var i=[],r=this.board[e.f],a=this.pieces[r];if(null!=e.c){i.unshift({i:e.c,f:-1,t:this.pieces[e.c].p});var s=this.pieces[e.c];this.board[s.p]=-1,s.p=-1}var n=this.kings[a.s];return t.g.pTypes[a.t].isKing&&(this.kings[a.s]=e.t),i.unshift({i:r,f:e.t,t:e.f,kp:n,who:a.s,ty:a.t}),a.p=e.t,void 0!==e.pr&&(a.t=e.pr),this.board[e.f]=-1,this.board[e.t]=r,i},Model.Board.cbQuickUnapply=function(t,e){for(var i=0;i<e.length;i++){var r=e[i],a=this.pieces[r.i];r.f>=0&&(a.p=-1,this.board[r.f]=-1),r.t>=0&&(a.p=r.t,this.board[r.t]=r.i),void 0!==r.m&&(a.m=r.m),void 0!==r.kp&&(this.kings[r.who]=r.kp),void 0!=r.ty&&(a.t=r.ty),void 0!=r.cg&&(this.castled[a.s]=r.cg)}},Model.Board.ApplyMove=function(t,e){var i=this.pieces[this.board[e.f]];if(void 0!==e.cg)this.cbApplyCastle(t,e,!0);else{if(this.zSign=t.zobrist.update(this.zSign,"board",i.i,e.f),this.board[i.p]=-1,void 0!==e.pr&&(this.zSign=t.zobrist.update(this.zSign,"type",i.t,i.i),i.t=e.pr,this.zSign=t.zobrist.update(this.zSign,"type",i.t,i.i)),null!=e.c){var r=this.pieces[e.c];this.zSign=t.zobrist.update(this.zSign,"board",r.i,r.p),this.board[r.p]=-1,r.p=-1,r.m=!0,this.noCaptCount=0}else this.noCaptCount++;i.p=e.t,i.m=!0,this.board[e.t]=i.i,this.zSign=t.zobrist.update(this.zSign,"board",i.i,e.t),t.g.pTypes[i.t].isKing&&(this.kings[i.s]=e.t)}this.check=!!e.ck,this.lastMove={f:e.f,t:e.t,c:e.c},void 0!==e.ko&&(this.ending[i.s]=e.ko),void 0!==e.ept?this.epTarget={p:e.ept,i:i.i}:this.epTarget=null,this.zSign=t.zobrist.update(this.zSign,"who",-this.mWho),this.zSign=t.zobrist.update(this.zSign,"who",this.mWho)},Model.Board.Evaluate=function(i){function r(e){var i=1/0;for(var r in t.geometry.corners)i=Math.min(i,h.distGraph[s.kings[e]][r]);return i-Math.sqrt(h.boardSize)}var a="debug"==arguments[3],s=this;this.mEvaluation=0;var n,o=this.mWho,h=i.g;if(e)n={1:{count:new Uint8Array(h.pTypes.length),byType:{}},"-1":{count:new Uint8Array(h.pTypes.length),byType:{}}};else{n={1:{count:[],byType:{}},"-1":{count:[],byType:{}}};for(var p=0;p<h.pTypes.length;p++)n[1].count[p]=n[-1].count[p]=0}if(i.mOptions.preventRepeat&&i.GetRepeatOccurence(this)>2)return this.mFinished=!0,void(this.mWinner=i.cbOnPerpetual?o*i.cbOnPerpetual:JocGame.DRAW);for(var c={1:0,"-1":0},l={1:h.distGraph[this.kings[-1]],"-1":h.distGraph[this.kings[1]]},u={1:0,"-1":0},v={1:0,"-1":0},g={1:0,"-1":0},f={1:0,"-1":0},b={1:!1,"-1":!1},d=this.pieces,m=d.length,p=0;p<m;p++){var y=d[p];if(y.p>=0){var G=y.s,M=h.pTypes[y.t];M.isKing?b[G]=y.m:c[G]+=M.value,M.castle&&!y.m&&f[G]++,v[G]++,u[G]+=l[G][y.p],g[G]+=t.geometry.distEdge[y.p];var k=n[G];k.count[y.t]++;var S=k.byType;void 0===S[y.t]?S[y.t]=[y]:S[y.t].push(y)}}if(this.lastMove&&null!=this.lastMove.c){var y=this.pieces[this.board[this.lastMove.t]];c[-y.s]+=this.cbStaticExchangeEval(i,y.p,y.s,{piece:y})}var C={1:0,"-1":0},T={1:0,"-1":0},z={1:0,"-1":0};this.ending[1]&&(T[1]=(u[1]-Math.sqrt(h.boardSize))/v[1],t.geometry.corners&&(z[1]=r(1))),this.ending[-1]&&(T[-1]=(u[-1]-Math.sqrt(h.boardSize))/v[-1],t.geometry.corners&&(z[1]=r(-1)));var A={pieceValue:c[1]-c[-1],pieceValueRatio:(c[1]-c[-1])/(c[1]+c[-1]+1),posValue:g[1]-g[-1],averageDistKing:u[1]/v[1]-u[-1]/v[-1],check:this.check?-o:0,endingKingFreedom:C[1]-C[-1],endingDistKing:T[1]-T[-1],distKingCorner:z[1]-z[-1]};t.castle&&(A.castle=(this.castled[1]?1:b[1]?0:f[1]/(h.castleablePiecesCount[1]+1))-(this.castled[-1]?1:b[-1]?0:f[-1]/(h.castleablePiecesCount[-1]+1))),t.evaluate&&t.evaluate.call(this,i,A,n);var P=i.mOptions.levelOptions;for(var R in A){var w=A[R],E=P[R+"Factor"]||0,I=w*E;a&&console.log(R,"=",w,"*",E,"=>",I),this.mEvaluation+=I}a&&console.log("Evaluation",this.mEvaluation)},Model.Board.cbGeneratePseudoLegalMoves=function(t){function e(e,a){var s=t.cbVar.promote;if(!s)return void r.push(a);var n=s.call(i,t,e,a);if(null!=n)if(0==n.length)r.push(a);else if(1==n.length)a.pr=n[0],r.push(a);else for(var o=0;o<n.length;o++){var h=n[o];r.push({f:a.f,t:a.t,c:a.c,pr:h,ept:a.ept,ep:a.ep,a:a.a})}}for(var i=this,r=[],a=t.cbVar,s=this.mWho,n=!a.castle||this.check||this.castled[s]?null:[],o=-1,h=this.pieces.length,p=0;p<h;p++){var c=this.pieces[p];if(!(c.p<0||c.s!=s)){var l=t.g.pTypes[c.t];l.isKing&&(c.m?n=null:o=c),n&&l.castle&&!c.m&&n.push(c);var u,v;u=l.graph[c.p],v=u.length;for(var g=0;g<v;g++)for(var f=u[g],b=!1,d=f.length,m=null,y=0;y<d;y++){var G=f[y],M=65535&G,k=this.board[M];if(!(k<0)||l.epCatch&&this.epTarget&&this.epTarget.p==M){if(!(524288&G)){var S;S=k<0?this.pieces[this.epTarget.i]:this.pieces[k],!(S.s!=c.s&&131072&G)||1048576&G&&!t.g.pTypes[S.t].isKing||2097152&G&&t.g.pTypes[S.t].isKing||e(c,{f:c.p,t:M,c:S.i,a:l.abbrev,ep:k<0});break}if(b){var S=this.pieces[k];S.s!=c.s&&e(c,{f:c.p,t:M,c:S.i,a:l.abbrev});break}b=!0}else 65536&G&&0==b&&e(c,{f:c.p,t:M,c:null,a:l.abbrev,ept:null!=m&&l.epTarget?m:void 0});m=M}}}if(n)for(var p=0;p<n.length;p++){var C=n[p],T=t.cbVar.castle[o.p+"/"+C.p];if(T){for(var z=!0,g=0;g<T.r.length;g++){var A=T.r[g];if(this.board[A]>=0&&A!=o.p&&A!=C.p){z=!1;break}}if(z){for(var P=!0,g=0;g<T.k.length;g++){var A=T.k[g];if(this.board[A]>=0&&A!=C.p&&A!=o.p||this.cbGetAttackers(t,A,s).length>0){P=!1;break}}P&&r.push({f:o.p,t:T.k[T.k.length-1],c:null,cg:C.p})}}}return r},Model.Board.cbStaticExchangeEval=function(t,e,i,r){var a=0,s=this.cbGetSmallestAttacker(t,e,i);if(s){var n=this.mWho;this.mWho=s.s;var o=this.cbQuickApply(t,{f:s.p,t:e,c:r.piece.i}),h=t.g.pTypes[r.piece.t].value;r.piece=s,a=Math.max(0,h-this.cbStaticExchangeEval(t,e,-i,r)),this.cbQuickUnapply(t,o),this.mWho=n}return a},Model.Board.cbGetSmallestAttacker=function(t,e,i){var r=this.cbGetAttackers(t,e,i);if(0==r.length)return null;for(var a=1/0,s=null,n=r.length,o=0;o<n;o++){var h=r[o],p=t.g.pTypes[h.t].value;p<a&&(a=p,s=h)}return s},Model.Board.cbCollectAttackers=function(t,e,i,r){for(var a in e){var s=e[a],n=this.board[a];if(n<0)this.cbCollectAttackers(t,s.e,i,r);else{var o=this.pieces[n];o.s==-t&&(s.t&&o.t in s.t||r&&s.tk&&o.t in s.tk)&&i.push(o)}}},Model.Board.cbCollectAttackersScreen=function(t,e,i,r,a){for(var s in e){var n=e[s],o=this.board[s];if(o<0)this.cbCollectAttackersScreen(t,n.e,i,r,a);else{var h=this.pieces[o];!a&&h.s==-t&&(n.t&&h.t in n.t||r&&n.tk&&h.t in n.tk)?i.push(h):a?a&&h.s==-t&&n.ts&&h.t in n.ts&&i.push(h):this.cbCollectAttackersScreen(t,n.e,i,r,!0)}}},Model.Board.cbGetAttackers=function(t,e,i,r){var a=[];return t.cbUseScreenCapture?this.cbCollectAttackersScreen(i,t.g.threatGraph[i][e],a,r,!1):this.cbCollectAttackers(i,t.g.threatGraph[i][e],a,r),a},Model.Board.GenerateMoves=function(t){var e=this.cbGeneratePseudoLegalMoves(t);this.mMoves=[];for(var i=!0,r=this.kings[this.mWho],a=e.length,s=0;s<a;s++){var n=e[s],o=this.cbQuickApply(t,n);if(!(this.cbGetAttackers(t,this.kings[this.mWho],this.mWho,!0).length>0)){var h=this.cbGetAttackers(t,this.kings[-this.mWho],-this.mWho,!0).length>0;n.ck=h,this.mMoves.push(n),n.f!=r&&(i=!1)}this.cbQuickUnapply(t,o)}if(0==this.mMoves.length)this.mFinished=!0,this.mWinner=t.cbOnStaleMate?t.cbOnStaleMate*this.mWho:JocGame.DRAW,this.check&&(this.mWinner=-this.mWho);else if(this.ending[this.mWho]){if(!i)for(var s=0;s<this.mMoves.length;s++)this.mMoves[s].ko=!1}else if(!this.ending[this.mWho]&&i&&!this.check)for(var s=0;s<this.mMoves.length;s++)this.mMoves[s].ko=!0},Model.Board.GetSignature=function(){return this.zSign},Model.Move.Init=function(t){for(var e in t)t.hasOwnProperty(e)&&(this[e]=t[e])},Model.Move.Equals=function(t){return this.f==t.f&&this.t==t.t&&this.pr==t.pr},Model.Move.CopyFrom=function(t){this.Init(t)},Model.Move.ToString=function(e){var i=this;switch(e=e||"natural"){case"natural":return function(){var e;if(void 0!==i.cg?e=t.castle[i.f+"/"+i.cg].n:(e=i.a||"",e+=t.geometry.PosName(i.f),null==i.c?e+="-":e+="x",e+=t.geometry.PosName(i.t)),void 0!==i.pr){var r=t.pieceTypes[i.pr];r&&r.abbrev&&r.abbrev.length>0&&!r.silentPromo&&(e+="="+r.abbrev)}return i.ck&&(e+="+"),e}();case"engine":return function(){var e=t.geometry.PosName(i.f)+t.geometry.PosName(i.t);if(void 0!=i.pr){var r=t.pieceTypes[i.pr];r&&r.abbrev&&r.abbrev.length>0&&!r.silentPromo&&(e+=r.abbrev)}return e}();default:return"??"}},Model.Board.CompactMoveString=function(e,i,r){"function"!=typeof i.ToString&&(i=e.CreateMove(i));var a=i.ToString(),s=/^([A-Z]?)([a-z])([1-9][0-9]*)([-x])([a-z])([1-9][0-9]*)(.*?)$/.exec(a);if(!s)return a;var n=s[7];if(r||(r={}),r.value||(r.value=[]),0==r.value.length){var o=this.mMoves;this.mMoves&&0!=this.mMoves.length||this.GenerateMoves(e);for(var h=0;h<this.mMoves.length;h++){var p=this.mMoves[h];"function"!=typeof p.ToString&&(p=e.CreateMove(p)),r.value.push({str:p.ToString(),move:p})}this.mMoves=o}var c=[];if(r.value.forEach(function(t){var e=/^([A-Z]?[a-z][1-9][0-9]*[-x][a-z][1-9][0-9]*)(.*?)$/.exec(t.str);e&&t.move.t==i.t&&(t.move.a||"")==s[1]&&e[2]==n&&c.push(t.move)}),1==c.length)return""==s[1]&&"x"==s[4]?s[2]+"x"+s[5]+s[6]+s[7]:s[1]+("x"==s[4]?"x":"")+s[5]+s[6]+s[7];if(t.geometry.CompactCrit)for(var l="",h=0;;h++){var u=t.geometry.CompactCrit(i.f,h);if(null==u)return a;l+=u;for(var v=[],g=0;g<c.length;g++){var f=c[g];t.geometry.CompactCrit(f.f,h)==u&&v.push(f)}if(console.assert(v.length>0),1==v.length)return s[1]+l+("x"==s[4]?"x":"")+s[5]+s[6]+s[7];c=v}return a},Model.Board.cbIntegrity=function(t){function e(t,e){t||console.error(e)}for(var i=this,r=0;r<this.board.length;r++){var a=this.board[r];if(a>=0){var s=i.pieces[a];e(void 0!==s,"no piece at pos"),e(s.p==r,"piece has different pos")}}for(var a=0;a<this.pieces.length;a++){var s=this.pieces[a];s.p>=0&&e(i.board[s.p]==a,"board index mismatch")}},Model.Board.ExportBoardState=function(t){return t.cbVar.geometry.ExportBoardState?t.cbVar.geometry.ExportBoardState(this,t.cbVar,t.mPlayedMoves.length):"not supported"},Model.Game.Import=function(e,i){var r,a=[],s={1:{},"-1":{}},n=null,o=0;if("pjn"==e){var h={status:!1,error:"parse"},p=i.split(" ");if(6!=p.length)return console.warn("FEN should have 6 parts"),h;var c=p[0].split("/"),l=t.geometry.fenHeight||t.geometry.height;if(c.length!=l)return console.warn("FEN board should have",l,"rows, got",c.length),h;var u={};for(var v in t.pieceTypes){var g=t.pieceTypes[v],f=g.fenAbbrev||g.abbrev||"X";u[f.toUpperCase()]={s:1,t:v},u[f.toLowerCase()]={s:-1,t:v}}var b=t.geometry.FenRowPos||function(e,i){return(t.geometry.height-1-e)*t.geometry.width+i};if(c.forEach(function(e,i){for(var r=0,s=0;s<e.length;s++){var n=e.substr(s,1),o=u[n];if(void 0!==o){var p=b(i,r);r++;for(var c={s:o.s,t:o.t,p:p},l=!0,v=t.pieceTypes[c.t].initial||[],g=0;g<v.length;g++){var f=v[g];f.s==c.s&&f.p==p&&(l=!1)}c.m=l,a.push(c)}else{if(isNaN(parseInt(n)))return console.warn("FEN invalid board spec",n),h;r+=parseInt(n)}}}),a.sort(function(t,e){return e.s-t.s}),"w"==p[1])r=1;else{if("b"!=p[1])return console.warn("FEN invalid turn spec",p[1]),h;r=-1}s[1].k=p[2].indexOf("K")>=0,s[1].q=p[2].indexOf("Q")>=0,s[-1].k=p[2].indexOf("k")>=0,s[-1].q=p[2].indexOf("q")>=0,n="-"==p[3]?null:p[3];var d=parseInt(p[4]);isNaN(d)||(o=d);var m={pieces:a,turn:r,castle:s,enPassant:n,noCaptCount:o};return t.importGame&&t.importGame.call(this,m,e,i),{status:!0,initial:m}}return{status:!1,error:"unsupported"}}}(),function(){Model.Game.cbBoardGeometryMultiplan=function(t,e,i){function r(e){return e%t}function a(i){return Math.floor(i%(t*e)/t)}function s(i){return Math.floor(i/(t*e))}function n(i,r,a){return a*t*e+r*t+i}function o(o,h){var p=r(o),c=a(o),l=s(o),u=p+h[0],v=c+h[1],g=l+h[2];return u<0||u>=t||v<0||v>=e||g<0||g>=i?null:n(u,v,g)}function h(t){return""+String.fromCharCode("A".charCodeAt(0)+s(t))+String.fromCharCode("a".charCodeAt(0)+r(t))+(a(t)+1)}function p(t){var e=/^([A-Z]+)([a-z])([0-9]+)$/.exec(t);if(!e)return-1;var i=e[1].charCodeAt(0)-"A".charCodeAt(0);return n(e[2].charCodeAt(0)-"a".charCodeAt(0),parseInt(e[3])-1,i)}function c(t,e){return 0==e?String.fromCharCode("a".charCodeAt(0)+r(t)):1==e?a(t)+1:null}function l(){for(var n=[],o=0;o<t*e*i;o++){var h=[];n.push(h);for(var p=0;p<t*e*i;p++){var c=a(o),l=r(o),u=s(o),v=a(p),g=r(p),f=s(p);h.push(Math.max(Math.abs(c-v),Math.abs(l-g),Math.abs(u-f)))}}return n}function u(t,r){var a=i-1-Math.floor(t/e);return n(r,e-1-t%e,a)}return{boardSize:t*e*i,width:t,height:e,floors:i,fenHeight:e*i,C:r,R:a,F:s,POS:n,Graph:o,PosName:h,PosByName:p,CompactCrit:c,GetDistances:l,distEdge:function(){for(var s=[],n=0;n<t*e*i;n++){var o=r(n),h=a(n);s[n]=Math.min(o,Math.abs(t-o-1),h,Math.abs(e-h-1))}return s}(),corners:function(){var r={};return r[n(0,0,0)]=1,r[n(0,e-1,0)]=1,r[n(t-1,0,0)]=1,r[n(t-1,e-1,0)]=1,r[n(0,0,i-1)]=1,r[n(0,e-1,i-1)]=1,r[n(t-1,0,i-1)]=1,r[n(t-1,e-1,i-1)]=1,r}(),FenRowPos:u}};var t=Model.Game.cbConstants,e=[[1,0,0],[-1,0,0],[0,1,0],[0,-1,0],[0,0,1],[0,0,-1]],i=[[1,1,0],[1,-1,0],[-1,1,0],[-1,-1,0],[1,0,1],[-1,0,1],[0,1,1],[0,-1,1],[1,0,-1],[-1,0,-1],[0,1,-1],[0,-1,-1]],r=[[1,1,1],[1,-1,1],[-1,1,1],[-1,-1,1],[1,1,-1],[1,-1,-1],[-1,1,-1],[-1,-1,-1]],a=[[2,1,0],[2,-1,0],[-2,1,0],[-2,-1,0],[1,2,0],[-1,2,0],[1,-2,0],[-1,-2,0],[2,0,1],[2,0,-1],[-2,0,1],[-2,0,-1],[1,0,2],[-1,0,2],[1,0,-2],[-1,0,-2],[0,1,2],[0,-1,2],[0,1,-2],[0,-1,-2],[0,2,1],[0,2,-1],[0,-2,1],[0,-2,-1]];Model.Game.cbRSKingGraph=function(t){return this.cbShortRangeGraph(t,e.concat(r,i))},Model.Game.cbRSQueenGraph=function(t){return this.cbLongRangeGraph(t,e.concat(r,i))},Model.Game.cbRSKnightGraph=function(t){return this.cbShortRangeGraph(t,a)},Model.Game.cbRSRookGraph=function(t){return this.cbLongRangeGraph(t,e)},Model.Game.cbRSBishopGraph=function(t){return this.cbLongRangeGraph(t,i)},Model.Game.cbRSUnicornGraph=function(t){return this.cbLongRangeGraph(t,r)},Model.Game.cbRSPawnGraph=function(e,i){for(var r=this.cbShortRangeGraph(e,[[0,i,0],[0,0,i]],null,t.FLAG_MOVE),a=this.cbShortRangeGraph(e,[[i,i,0],[-i,i,0],[0,i,i],[-i,0,i],[i,0,i]],null,t.FLAG_CAPTURE),s=[],n=0;n<e.boardSize;n++)s[n]=r[n].concat(a[n]);return s},Model.Game.cb3DPawnGraph=function(e,i,r){var a=this.cbLongRangeGraph(e,[[0,i,0]],null,t.FLAG_MOVE,r),s=this.cbLongRangeGraph(e,[[1,i,0],[-1,i,0],[0,i,1],[0,i,-1]],null,t.FLAG_CAPTURE,1);return this.cbMergeGraphs(e,a,s)},Model.Game.cb3DKingGraph=function(e){var i=this.cbLongRangeGraph(e,[[1,-1,0],[1,0,0],[1,1,0],[0,1,0],[0,-1,0],[-1,-1,0],[-1,0,0],[-1,1,0]],null,t.FLAG_MOVE|t.FLAG_CAPTURE,1),r=this.cbLongRangeGraph(e,[[0,0,-1],[0,1,-1],[0,-1,-1],[1,0,-1],[-1,0,-1],[0,0,1],[0,1,1],[0,-1,1],[1,0,1],[-1,0,1]],null,t.FLAG_CAPTURE,1);return this.cbMergeGraphs(e,i,r)}}(),function(){var t=Model.Game.cbBoardGeometryMultiplan(6,8,3);Model.Game.cbDefine=function(){return{geometry:t,pieceTypes:{0:{name:"king",aspect:"king",isKing:!0,graph:this.cb3DKingGraph(t),abbrev:"K",initial:[{s:1,p:50},{s:-1,p:92}]},1:{name:"queen",aspect:"queen",graph:this.cbRSQueenGraph(t),abbrev:"Q",initial:[{s:1,p:51},{s:-1,p:93}],value:9},2:{name:"rook",aspect:"rook",graph:this.cbRSRookGraph(t),value:5,abbrev:"R",initial:[{s:1,p:49},{s:1,p:52},{s:-1,p:94},{s:-1,p:91}],castle:!0},3:{name:"bishop",aspect:"bishop",graph:this.cbRSBishopGraph(t),value:3.1,abbrev:"B",initial:[{s:1,p:2},{s:1,p:3},{s:1,p:98},{s:1,p:99},{s:-1,p:45},{s:-1,p:44},{s:-1,p:141},{s:-1,p:140}]},5:{name:"knight",aspect:"knight",graph:this.cbRSKnightGraph(t),value:2.9,abbrev:"N",initial:[{s:1,p:1},{s:1,p:4},{s:1,p:97},{s:1,p:100},{s:-1,p:46},{s:-1,p:43},{s:-1,p:142},{s:-1,p:139}]},6:{name:"pawn-w",aspect:"pawn",graph:this.cb3DPawnGraph(t,1,1),value:1,abbrev:"P",epCatch:!0},7:{name:"pawn-b",aspect:"pawn",graph:this.cb3DPawnGraph(t,-1,1),value:1,abbrev:"P",epCatch:!0},8:{name:"ipawn-w",aspect:"pawn",graph:this.cb3DPawnGraph(t,1,2),value:1,abbrev:"P",initial:[{s:1,p:0},{s:1,p:7},{s:1,p:8},{s:1,p:9},{s:1,p:10},{s:1,p:5},{s:1,p:48},{s:1,p:55},{s:1,p:56},{s:1,p:57},{s:1,p:58},{s:1,p:53},{s:1,p:96},{s:1,p:103},{s:1,p:104},{s:1,p:105},{s:1,p:106},{s:1,p:101}],epTarget:!0},9:{name:"ipawn-b",aspect:"pawn",graph:this.cb3DPawnGraph(t,-1,2),value:1,abbrev:"P",initial:[{s:-1,p:47},{s:-1,p:40},{s:-1,p:39},{s:-1,p:38},{s:-1,p:37},{s:-1,p:42},{s:-1,p:95},{s:-1,p:88},{s:-1,p:87},{s:-1,p:86},{s:-1,p:85},{s:-1,p:90},{s:-1,p:143},{s:-1,p:136},{s:-1,p:135},{s:-1,p:134},{s:-1,p:133},{s:-1,p:138}],epTarget:!0}},castle:{"50/49":{k:[49],r:[50],n:"O-O"},"50/52":{k:[51],r:[51,50],n:"O-O-O"},"92/91":{k:[91],r:[92],n:"O-O"},"92/94":{k:[93],r:[93,92],n:"O-O-O"}},promote:function(e,i,r){return 8==i.t?[6]:9==i.t?[7]:6==i.t&&7==t.R(r.t)?[5,3,2,1]:7==i.t&&0==t.R(r.t)?[5,3,2,1]:[]},evaluate:function(e,i,r){r[1].count,r[-1].count;this.noCaptCount>=100&&(this.mFinished=!0,this.mWinner=JocGame.DRAW);var a,s=e.cbUseTypedArrays?new Int8Array(3):[0,0,0],n=t.height,o=r[1].byType[6];if(o){a=o.length;for(var h=0;h<a;h++)switch(n-t.R(o[h].p)){case 2:s[0]++;break;case 3:s[1]++;break;case 4:s[2]++}}if(o=r[-1].byType[7]){a=o.length;for(var h=0;h<a;h++)switch(t.R(o[h].p)){case 1:s[0]--;break;case 2:s[1]--;break;case 3:s[2]--}}0!=s[0]&&(i.distPawnPromo1=s[0]),0!=s[1]&&(i.distPawnPromo2=s[1]),0!=s[2]&&(i.distPawnPromo3=s[2]);for(var p=0,c=3;c<=5;c+=2)for(var l=1;l>=-1;l-=2){var u=r[l].byType[c];if(u)for(var h=0;h<u.length;h++)u[h].m&&(p+=l)}0!=p&&(i.minorPiecesMoved=p)}}}}();

/***/ }),

/***/ "10Gq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var retryWhen_1 = __webpack_require__("Cx8F");
Observable_1.Observable.prototype.retryWhen = retryWhen_1.retryWhen;
//# sourceMappingURL=retryWhen.js.map

/***/ }),

/***/ "16m9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var concatMapTo_1 = __webpack_require__("Yuqe");
Observable_1.Observable.prototype.concatMapTo = concatMapTo_1.concatMapTo;
//# sourceMappingURL=concatMapTo.js.map

/***/ }),

/***/ "1APj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var of_1 = __webpack_require__("lgiQ");
Observable_1.Observable.of = of_1.of;
//# sourceMappingURL=of.js.map

/***/ }),

/***/ "1Axw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__("mmVS");
var Observable_1 = __webpack_require__("rCTf");
var OuterSubscriber_1 = __webpack_require__("wAkD");
var subscribeToResult_1 = __webpack_require__("CURp");
/**
 * Delays the emission of items from the source Observable by a given time span
 * determined by the emissions of another Observable.
 *
 * <span class="informal">It's like {@link delay}, but the time span of the
 * delay duration is determined by a second Observable.</span>
 *
 * <img src="./img/delayWhen.png" width="100%">
 *
 * `delayWhen` time shifts each emitted value from the source Observable by a
 * time span determined by another Observable. When the source emits a value,
 * the `delayDurationSelector` function is called with the source value as
 * argument, and should return an Observable, called the "duration" Observable.
 * The source value is emitted on the output Observable only when the duration
 * Observable emits a value or completes.
 *
 * Optionally, `delayWhen` takes a second argument, `subscriptionDelay`, which
 * is an Observable. When `subscriptionDelay` emits its first value or
 * completes, the source Observable is subscribed to and starts behaving like
 * described in the previous paragraph. If `subscriptionDelay` is not provided,
 * `delayWhen` will subscribe to the source Observable as soon as the output
 * Observable is subscribed.
 *
 * @example <caption>Delay each click by a random amount of time, between 0 and 5 seconds</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var delayedClicks = clicks.delayWhen(event =>
 *   Rx.Observable.interval(Math.random() * 5000)
 * );
 * delayedClicks.subscribe(x => console.log(x));
 *
 * @see {@link debounce}
 * @see {@link delay}
 *
 * @param {function(value: T): Observable} delayDurationSelector A function that
 * returns an Observable for each value emitted by the source Observable, which
 * is then used to delay the emission of that item on the output Observable
 * until the Observable returned from this function emits a value.
 * @param {Observable} subscriptionDelay An Observable that triggers the
 * subscription to the source Observable once it emits any value.
 * @return {Observable} An Observable that delays the emissions of the source
 * Observable by an amount of time specified by the Observable returned by
 * `delayDurationSelector`.
 * @method delayWhen
 * @owner Observable
 */
function delayWhen(delayDurationSelector, subscriptionDelay) {
    if (subscriptionDelay) {
        return new SubscriptionDelayObservable(this, subscriptionDelay)
            .lift(new DelayWhenOperator(delayDurationSelector));
    }
    return this.lift(new DelayWhenOperator(delayDurationSelector));
}
exports.delayWhen = delayWhen;
var DelayWhenOperator = (function () {
    function DelayWhenOperator(delayDurationSelector) {
        this.delayDurationSelector = delayDurationSelector;
    }
    DelayWhenOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new DelayWhenSubscriber(subscriber, this.delayDurationSelector));
    };
    return DelayWhenOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var DelayWhenSubscriber = (function (_super) {
    __extends(DelayWhenSubscriber, _super);
    function DelayWhenSubscriber(destination, delayDurationSelector) {
        _super.call(this, destination);
        this.delayDurationSelector = delayDurationSelector;
        this.completed = false;
        this.delayNotifierSubscriptions = [];
        this.values = [];
    }
    DelayWhenSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.destination.next(outerValue);
        this.removeSubscription(innerSub);
        this.tryComplete();
    };
    DelayWhenSubscriber.prototype.notifyError = function (error, innerSub) {
        this._error(error);
    };
    DelayWhenSubscriber.prototype.notifyComplete = function (innerSub) {
        var value = this.removeSubscription(innerSub);
        if (value) {
            this.destination.next(value);
        }
        this.tryComplete();
    };
    DelayWhenSubscriber.prototype._next = function (value) {
        try {
            var delayNotifier = this.delayDurationSelector(value);
            if (delayNotifier) {
                this.tryDelay(delayNotifier, value);
            }
        }
        catch (err) {
            this.destination.error(err);
        }
    };
    DelayWhenSubscriber.prototype._complete = function () {
        this.completed = true;
        this.tryComplete();
    };
    DelayWhenSubscriber.prototype.removeSubscription = function (subscription) {
        subscription.unsubscribe();
        var subscriptionIdx = this.delayNotifierSubscriptions.indexOf(subscription);
        var value = null;
        if (subscriptionIdx !== -1) {
            value = this.values[subscriptionIdx];
            this.delayNotifierSubscriptions.splice(subscriptionIdx, 1);
            this.values.splice(subscriptionIdx, 1);
        }
        return value;
    };
    DelayWhenSubscriber.prototype.tryDelay = function (delayNotifier, value) {
        var notifierSubscription = subscribeToResult_1.subscribeToResult(this, delayNotifier, value);
        this.add(notifierSubscription);
        this.delayNotifierSubscriptions.push(notifierSubscription);
        this.values.push(value);
    };
    DelayWhenSubscriber.prototype.tryComplete = function () {
        if (this.completed && this.delayNotifierSubscriptions.length === 0) {
            this.destination.complete();
        }
    };
    return DelayWhenSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var SubscriptionDelayObservable = (function (_super) {
    __extends(SubscriptionDelayObservable, _super);
    function SubscriptionDelayObservable(source, subscriptionDelay) {
        _super.call(this);
        this.source = source;
        this.subscriptionDelay = subscriptionDelay;
    }
    SubscriptionDelayObservable.prototype._subscribe = function (subscriber) {
        this.subscriptionDelay.subscribe(new SubscriptionDelaySubscriber(subscriber, this.source));
    };
    return SubscriptionDelayObservable;
}(Observable_1.Observable));
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var SubscriptionDelaySubscriber = (function (_super) {
    __extends(SubscriptionDelaySubscriber, _super);
    function SubscriptionDelaySubscriber(parent, source) {
        _super.call(this);
        this.parent = parent;
        this.source = source;
        this.sourceSubscribed = false;
    }
    SubscriptionDelaySubscriber.prototype._next = function (unused) {
        this.subscribeToSource();
    };
    SubscriptionDelaySubscriber.prototype._error = function (err) {
        this.unsubscribe();
        this.parent.error(err);
    };
    SubscriptionDelaySubscriber.prototype._complete = function () {
        this.subscribeToSource();
    };
    SubscriptionDelaySubscriber.prototype.subscribeToSource = function () {
        if (!this.sourceSubscribed) {
            this.sourceSubscribed = true;
            this.unsubscribe();
            this.source.subscribe(this.parent);
        }
    };
    return SubscriptionDelaySubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=delayWhen.js.map

/***/ }),

/***/ "1Cj3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var AsyncScheduler_1 = __webpack_require__("9Avi");
var AsapScheduler = (function (_super) {
    __extends(AsapScheduler, _super);
    function AsapScheduler() {
        _super.apply(this, arguments);
    }
    AsapScheduler.prototype.flush = function (action) {
        this.active = true;
        this.scheduled = undefined;
        var actions = this.actions;
        var error;
        var index = -1;
        var count = actions.length;
        action = action || actions.shift();
        do {
            if (error = action.execute(action.state, action.delay)) {
                break;
            }
        } while (++index < count && (action = actions.shift()));
        this.active = false;
        if (error) {
            while (++index < count && (action = actions.shift())) {
                action.unsubscribe();
            }
            throw error;
        }
    };
    return AsapScheduler;
}(AsyncScheduler_1.AsyncScheduler));
exports.AsapScheduler = AsapScheduler;
//# sourceMappingURL=AsapScheduler.js.map

/***/ }),

/***/ "1GJ2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_animations__ = __webpack_require__("Um43");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return AnimationDriver; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AnimationEngine; });
/* unused harmony export ɵAnimation */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return AnimationStyleNormalizer; });
/* unused harmony export ɵNoopAnimationStyleNormalizer */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return WebAnimationsStyleNormalizer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return NoopAnimationDriver; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DomAnimationEngine; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return NoopAnimationEngine; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return WebAnimationsDriver; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return supportsWebAnimations; });
/* unused harmony export ɵWebAnimationsPlayer */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * @license Angular v4.1.0
 * (c) 2010-2017 Google, Inc. https://angular.io/
 * License: MIT
 */

/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @experimental
 */
var NoopAnimationDriver = (function () {
    function NoopAnimationDriver() {
    }
    NoopAnimationDriver.prototype.animate = function (element, keyframes, duration, delay, easing, previousPlayers) {
        if (previousPlayers === void 0) { previousPlayers = []; }
        return new __WEBPACK_IMPORTED_MODULE_0__angular_animations__["a" /* NoopAnimationPlayer */]();
    };
    return NoopAnimationDriver;
}());
/**
 * @experimental
 */
var AnimationDriver = (function () {
    function AnimationDriver() {
    }
    return AnimationDriver;
}());
AnimationDriver.NOOP = new NoopAnimationDriver();
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @abstract
 */
var AnimationEngine = (function () {
    function AnimationEngine() {
    }
    /**
     * @abstract
     * @param {?} trigger
     * @param {?=} name
     * @return {?}
     */
    AnimationEngine.prototype.registerTrigger = function (trigger, name) { };
    /**
     * @abstract
     * @param {?} element
     * @param {?} domFn
     * @return {?}
     */
    AnimationEngine.prototype.onInsert = function (element, domFn) { };
    /**
     * @abstract
     * @param {?} element
     * @param {?} domFn
     * @return {?}
     */
    AnimationEngine.prototype.onRemove = function (element, domFn) { };
    /**
     * @abstract
     * @param {?} element
     * @param {?} property
     * @param {?} value
     * @return {?}
     */
    AnimationEngine.prototype.setProperty = function (element, property, value) { };
    /**
     * @abstract
     * @param {?} element
     * @param {?} eventName
     * @param {?} eventPhase
     * @param {?} callback
     * @return {?}
     */
    AnimationEngine.prototype.listen = function (element, eventName, eventPhase, callback) { };
    /**
     * @abstract
     * @return {?}
     */
    AnimationEngine.prototype.flush = function () { };
    Object.defineProperty(AnimationEngine.prototype, "activePlayers", {
        /**
         * @return {?}
         */
        get: function () { throw new Error('...'); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AnimationEngine.prototype, "queuedPlayers", {
        /**
         * @return {?}
         */
        get: function () { throw new Error('...'); },
        enumerable: true,
        configurable: true
    });
    return AnimationEngine;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var ONE_SECOND = 1000;
/**
 * @param {?} exp
 * @param {?} errors
 * @return {?}
 */
function parseTimeExpression(exp, errors) {
    var /** @type {?} */ regex = /^([\.\d]+)(m?s)(?:\s+([\.\d]+)(m?s))?(?:\s+([-a-z]+(?:\(.+?\))?))?$/i;
    var /** @type {?} */ duration;
    var /** @type {?} */ delay = 0;
    var /** @type {?} */ easing = null;
    if (typeof exp === 'string') {
        var /** @type {?} */ matches = exp.match(regex);
        if (matches === null) {
            errors.push("The provided timing value \"" + exp + "\" is invalid.");
            return { duration: 0, delay: 0, easing: null };
        }
        var /** @type {?} */ durationMatch = parseFloat(matches[1]);
        var /** @type {?} */ durationUnit = matches[2];
        if (durationUnit == 's') {
            durationMatch *= ONE_SECOND;
        }
        duration = Math.floor(durationMatch);
        var /** @type {?} */ delayMatch = matches[3];
        var /** @type {?} */ delayUnit = matches[4];
        if (delayMatch != null) {
            var /** @type {?} */ delayVal = parseFloat(delayMatch);
            if (delayUnit != null && delayUnit == 's') {
                delayVal *= ONE_SECOND;
            }
            delay = Math.floor(delayVal);
        }
        var /** @type {?} */ easingVal = matches[5];
        if (easingVal) {
            easing = easingVal;
        }
    }
    else {
        duration = (exp);
    }
    return { duration: duration, delay: delay, easing: easing };
}
/**
 * @param {?} styles
 * @return {?}
 */
function normalizeStyles(styles) {
    var /** @type {?} */ normalizedStyles = {};
    if (Array.isArray(styles)) {
        styles.forEach(function (data) { return copyStyles(data, false, normalizedStyles); });
    }
    else {
        copyStyles(styles, false, normalizedStyles);
    }
    return normalizedStyles;
}
/**
 * @param {?} styles
 * @param {?} readPrototype
 * @param {?=} destination
 * @return {?}
 */
function copyStyles(styles, readPrototype, destination) {
    if (destination === void 0) { destination = {}; }
    if (readPrototype) {
        // we make use of a for-in loop so that the
        // prototypically inherited properties are
        // revealed from the backFill map
        for (var /** @type {?} */ prop in styles) {
            destination[prop] = styles[prop];
        }
    }
    else {
        Object.keys(styles).forEach(function (prop) { return destination[prop] = styles[prop]; });
    }
    return destination;
}
/**
 * @param {?} element
 * @param {?} styles
 * @return {?}
 */
function setStyles(element, styles) {
    if (element['style']) {
        Object.keys(styles).forEach(function (prop) { return element.style[prop] = styles[prop]; });
    }
}
/**
 * @param {?} element
 * @param {?} styles
 * @return {?}
 */
function eraseStyles(element, styles) {
    if (element['style']) {
        Object.keys(styles).forEach(function (prop) {
            // IE requires '' instead of null
            // see https://github.com/angular/angular/issues/7916
            element.style[prop] = '';
        });
    }
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @param {?} visitor
 * @param {?} node
 * @param {?} context
 * @return {?}
 */
function visitAnimationNode(visitor, node, context) {
    switch (node.type) {
        case 0 /* State */:
            return visitor.visitState(/** @type {?} */ (node), context);
        case 1 /* Transition */:
            return visitor.visitTransition(/** @type {?} */ (node), context);
        case 2 /* Sequence */:
            return visitor.visitSequence(/** @type {?} */ (node), context);
        case 3 /* Group */:
            return visitor.visitGroup(/** @type {?} */ (node), context);
        case 4 /* Animate */:
            return visitor.visitAnimate(/** @type {?} */ (node), context);
        case 5 /* KeyframeSequence */:
            return visitor.visitKeyframeSequence(/** @type {?} */ (node), context);
        case 6 /* Style */:
            return visitor.visitStyle(/** @type {?} */ (node), context);
        default:
            throw new Error("Unable to resolve animation metadata node #" + node.type);
    }
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var ANY_STATE = '*';
/**
 * @param {?} transitionValue
 * @param {?} errors
 * @return {?}
 */
function parseTransitionExpr(transitionValue, errors) {
    var /** @type {?} */ expressions = [];
    if (typeof transitionValue == 'string') {
        ((transitionValue))
            .split(/\s*,\s*/)
            .forEach(function (str) { return parseInnerTransitionStr(str, expressions, errors); });
    }
    else {
        expressions.push(/** @type {?} */ (transitionValue));
    }
    return expressions;
}
/**
 * @param {?} eventStr
 * @param {?} expressions
 * @param {?} errors
 * @return {?}
 */
function parseInnerTransitionStr(eventStr, expressions, errors) {
    if (eventStr[0] == ':') {
        eventStr = parseAnimationAlias(eventStr, errors);
    }
    var /** @type {?} */ match = eventStr.match(/^(\*|[-\w]+)\s*(<?[=-]>)\s*(\*|[-\w]+)$/);
    if (match == null || match.length < 4) {
        errors.push("The provided transition expression \"" + eventStr + "\" is not supported");
        return expressions;
    }
    var /** @type {?} */ fromState = match[1];
    var /** @type {?} */ separator = match[2];
    var /** @type {?} */ toState = match[3];
    expressions.push(makeLambdaFromStates(fromState, toState));
    var /** @type {?} */ isFullAnyStateExpr = fromState == ANY_STATE && toState == ANY_STATE;
    if (separator[0] == '<' && !isFullAnyStateExpr) {
        expressions.push(makeLambdaFromStates(toState, fromState));
    }
}
/**
 * @param {?} alias
 * @param {?} errors
 * @return {?}
 */
function parseAnimationAlias(alias, errors) {
    switch (alias) {
        case ':enter':
            return 'void => *';
        case ':leave':
            return '* => void';
        default:
            errors.push("The transition alias value \"" + alias + "\" is not supported");
            return '* => *';
    }
}
/**
 * @param {?} lhs
 * @param {?} rhs
 * @return {?}
 */
function makeLambdaFromStates(lhs, rhs) {
    return function (fromState, toState) {
        var /** @type {?} */ lhsMatch = lhs == ANY_STATE || lhs == fromState;
        var /** @type {?} */ rhsMatch = rhs == ANY_STATE || rhs == toState;
        return lhsMatch && rhsMatch;
    };
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @param {?} keyframes
 * @param {?} duration
 * @param {?} delay
 * @param {?} easing
 * @return {?}
 */
function createTimelineInstruction(keyframes, duration, delay, easing) {
    return {
        type: 1 /* TimelineAnimation */,
        keyframes: keyframes,
        duration: duration,
        delay: delay,
        totalTime: duration + delay, easing: easing
    };
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @param {?} ast
 * @param {?=} startingStyles
 * @param {?=} finalStyles
 * @return {?}
 */
function buildAnimationKeyframes(ast, startingStyles, finalStyles) {
    if (startingStyles === void 0) { startingStyles = {}; }
    if (finalStyles === void 0) { finalStyles = {}; }
    var /** @type {?} */ normalizedAst = Array.isArray(ast) ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_animations__["b" /* sequence */])(/** @type {?} */ (ast)) : (ast);
    return new AnimationTimelineVisitor().buildKeyframes(normalizedAst, startingStyles, finalStyles);
}
var AnimationTimelineContext = (function () {
    /**
     * @param {?} errors
     * @param {?} timelines
     * @param {?=} initialTimeline
     */
    function AnimationTimelineContext(errors, timelines, initialTimeline) {
        this.errors = errors;
        this.timelines = timelines;
        this.previousNode = ({});
        this.subContextCount = 0;
        this.currentTimeline = initialTimeline || new TimelineBuilder(0);
        timelines.push(this.currentTimeline);
    }
    /**
     * @return {?}
     */
    AnimationTimelineContext.prototype.createSubContext = function () {
        var /** @type {?} */ context = new AnimationTimelineContext(this.errors, this.timelines, this.currentTimeline.fork());
        context.previousNode = this.previousNode;
        context.currentAnimateTimings = this.currentAnimateTimings;
        this.subContextCount++;
        return context;
    };
    /**
     * @param {?=} newTime
     * @return {?}
     */
    AnimationTimelineContext.prototype.transformIntoNewTimeline = function (newTime) {
        if (newTime === void 0) { newTime = 0; }
        this.currentTimeline = this.currentTimeline.fork(newTime);
        this.timelines.push(this.currentTimeline);
        return this.currentTimeline;
    };
    /**
     * @param {?} time
     * @return {?}
     */
    AnimationTimelineContext.prototype.incrementTime = function (time) {
        this.currentTimeline.forwardTime(this.currentTimeline.duration + time);
    };
    return AnimationTimelineContext;
}());
var AnimationTimelineVisitor = (function () {
    function AnimationTimelineVisitor() {
    }
    /**
     * @param {?} ast
     * @param {?} startingStyles
     * @param {?} finalStyles
     * @return {?}
     */
    AnimationTimelineVisitor.prototype.buildKeyframes = function (ast, startingStyles, finalStyles) {
        var /** @type {?} */ context = new AnimationTimelineContext([], []);
        context.currentTimeline.setStyles(startingStyles);
        visitAnimationNode(this, ast, context);
        // this checks to see if an actual animation happened
        var /** @type {?} */ timelines = context.timelines.filter(function (timeline) { return timeline.hasStyling(); });
        if (timelines.length && Object.keys(finalStyles).length) {
            var /** @type {?} */ tl = timelines[timelines.length - 1];
            if (!tl.allowOnlyTimelineStyles()) {
                tl.setStyles(finalStyles);
            }
        }
        return timelines.length ? timelines.map(function (timeline) { return timeline.buildKeyframes(); }) :
            [createTimelineInstruction([], 0, 0, '')];
    };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    AnimationTimelineVisitor.prototype.visitState = function (ast, context) {
        // these values are not visited in this AST
    };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    AnimationTimelineVisitor.prototype.visitTransition = function (ast, context) {
        // these values are not visited in this AST
    };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    AnimationTimelineVisitor.prototype.visitSequence = function (ast, context) {
        var _this = this;
        var /** @type {?} */ subContextCount = context.subContextCount;
        if (context.previousNode.type == 6 /* Style */) {
            context.currentTimeline.forwardFrame();
            context.currentTimeline.snapshotCurrentStyles();
        }
        ast.steps.forEach(function (s) { return visitAnimationNode(_this, s, context); });
        // this means that some animation function within the sequence
        // ended up creating a sub timeline (which means the current
        // timeline cannot overlap with the contents of the sequence)
        if (context.subContextCount > subContextCount) {
            context.transformIntoNewTimeline();
        }
        context.previousNode = ast;
    };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    AnimationTimelineVisitor.prototype.visitGroup = function (ast, context) {
        var _this = this;
        var /** @type {?} */ innerTimelines = [];
        var /** @type {?} */ furthestTime = context.currentTimeline.currentTime;
        ast.steps.forEach(function (s) {
            var /** @type {?} */ innerContext = context.createSubContext();
            visitAnimationNode(_this, s, innerContext);
            furthestTime = Math.max(furthestTime, innerContext.currentTimeline.currentTime);
            innerTimelines.push(innerContext.currentTimeline);
        });
        // this operation is run after the AST loop because otherwise
        // if the parent timeline's collected styles were updated then
        // it would pass in invalid data into the new-to-be forked items
        innerTimelines.forEach(function (timeline) { return context.currentTimeline.mergeTimelineCollectedStyles(timeline); });
        context.transformIntoNewTimeline(furthestTime);
        context.previousNode = ast;
    };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    AnimationTimelineVisitor.prototype.visitAnimate = function (ast, context) {
        var /** @type {?} */ timings = ast.timings.hasOwnProperty('duration') ? (ast.timings) :
            parseTimeExpression(/** @type {?} */ (ast.timings), context.errors);
        context.currentAnimateTimings = timings;
        if (timings.delay) {
            context.incrementTime(timings.delay);
            context.currentTimeline.snapshotCurrentStyles();
        }
        var /** @type {?} */ astType = ast.styles ? ast.styles.type : -1;
        if (astType == 5 /* KeyframeSequence */) {
            this.visitKeyframeSequence(/** @type {?} */ (ast.styles), context);
        }
        else {
            var /** @type {?} */ styleAst = (ast.styles);
            if (!styleAst) {
                var /** @type {?} */ newStyleData = {};
                if (timings.easing) {
                    newStyleData['easing'] = timings.easing;
                }
                styleAst = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_animations__["c" /* style */])(newStyleData);
                ((styleAst))['treatAsEmptyStep'] = true;
            }
            context.incrementTime(timings.duration);
            if (styleAst) {
                this.visitStyle(styleAst, context);
            }
        }
        context.currentAnimateTimings = null;
        context.previousNode = ast;
    };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    AnimationTimelineVisitor.prototype.visitStyle = function (ast, context) {
        // this is a special case when a style() call is issued directly after
        // a call to animate(). If the clock is not forwarded by one frame then
        // the style() calls will be merged into the previous animate() call
        // which is incorrect.
        if (!context.currentAnimateTimings &&
            context.previousNode.type == 4 /* Animate */) {
            context.currentTimeline.forwardFrame();
        }
        var /** @type {?} */ normalizedStyles = normalizeStyles(ast.styles);
        var /** @type {?} */ easing = context.currentAnimateTimings && context.currentAnimateTimings.easing;
        this._applyStyles(normalizedStyles, easing, ((ast))['treatAsEmptyStep'] ? true : false, context);
        context.previousNode = ast;
    };
    /**
     * @param {?} styles
     * @param {?} easing
     * @param {?} treatAsEmptyStep
     * @param {?} context
     * @return {?}
     */
    AnimationTimelineVisitor.prototype._applyStyles = function (styles, easing, treatAsEmptyStep, context) {
        if (styles.hasOwnProperty('easing')) {
            easing = easing || (styles['easing']);
            delete styles['easing'];
        }
        context.currentTimeline.setStyles(styles, easing, treatAsEmptyStep);
    };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    AnimationTimelineVisitor.prototype.visitKeyframeSequence = function (ast, context) {
        var _this = this;
        var /** @type {?} */ MAX_KEYFRAME_OFFSET = 1;
        var /** @type {?} */ limit = ast.steps.length - 1;
        var /** @type {?} */ firstKeyframe = ast.steps[0];
        var /** @type {?} */ offsetGap = 0;
        var /** @type {?} */ containsOffsets = getOffset(firstKeyframe) != null;
        if (!containsOffsets) {
            offsetGap = MAX_KEYFRAME_OFFSET / limit;
        }
        var /** @type {?} */ startTime = context.currentTimeline.duration;
        var /** @type {?} */ duration = ((context.currentAnimateTimings)).duration;
        var /** @type {?} */ innerContext = context.createSubContext();
        var /** @type {?} */ innerTimeline = innerContext.currentTimeline;
        innerTimeline.easing = ((context.currentAnimateTimings)).easing;
        ast.steps.forEach(function (step, i) {
            var /** @type {?} */ normalizedStyles = normalizeStyles(step.styles);
            var /** @type {?} */ offset = containsOffsets ?
                (step.offset != null ? step.offset : parseFloat(/** @type {?} */ (normalizedStyles['offset']))) :
                (i == limit ? MAX_KEYFRAME_OFFSET : i * offsetGap);
            innerTimeline.forwardTime(offset * duration);
            _this._applyStyles(normalizedStyles, null, false, innerContext);
        });
        // this will ensure that the parent timeline gets all the styles from
        // the child even if the new timeline below is not used
        context.currentTimeline.mergeTimelineCollectedStyles(innerTimeline);
        // we do this because the window between this timeline and the sub timeline
        // should ensure that the styles within are exactly the same as they were before
        context.transformIntoNewTimeline(startTime + duration);
        context.previousNode = ast;
    };
    return AnimationTimelineVisitor;
}());
var TimelineBuilder = (function () {
    /**
     * @param {?} startTime
     * @param {?=} globalTimelineStyles
     */
    function TimelineBuilder(startTime, globalTimelineStyles) {
        this.startTime = startTime;
        this.duration = 0;
        this.easing = '';
        this._previousKeyframe = {};
        this._keyframes = new Map();
        this._styleSummary = {};
        this._backFill = {};
        this._currentEmptyStepKeyframe = null;
        this._localTimelineStyles = Object.create(this._backFill, {});
        this._globalTimelineStyles =
            globalTimelineStyles ? globalTimelineStyles : this._localTimelineStyles;
        this._loadKeyframe();
    }
    /**
     * @return {?}
     */
    TimelineBuilder.prototype.hasStyling = function () { return this._keyframes.size > 1; };
    Object.defineProperty(TimelineBuilder.prototype, "currentTime", {
        /**
         * @return {?}
         */
        get: function () { return this.startTime + this.duration; },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?=} currentTime
     * @return {?}
     */
    TimelineBuilder.prototype.fork = function (currentTime) {
        if (currentTime === void 0) { currentTime = 0; }
        return new TimelineBuilder(currentTime || this.currentTime, this._globalTimelineStyles);
    };
    /**
     * @return {?}
     */
    TimelineBuilder.prototype._loadKeyframe = function () {
        if (this._currentKeyframe) {
            this._previousKeyframe = this._currentKeyframe;
        }
        this._currentKeyframe = ((this._keyframes.get(this.duration)));
        if (!this._currentKeyframe) {
            this._currentKeyframe = Object.create(this._backFill, {});
            this._keyframes.set(this.duration, this._currentKeyframe);
        }
    };
    /**
     * @return {?}
     */
    TimelineBuilder.prototype.forwardFrame = function () {
        this.duration++;
        this._loadKeyframe();
    };
    /**
     * @param {?} time
     * @return {?}
     */
    TimelineBuilder.prototype.forwardTime = function (time) {
        this.duration = time;
        this._loadKeyframe();
    };
    /**
     * @param {?} prop
     * @param {?} value
     * @return {?}
     */
    TimelineBuilder.prototype._updateStyle = function (prop, value) {
        this._localTimelineStyles[prop] = value; /** @type {?} */
        ((this._globalTimelineStyles))[prop] = value;
        this._styleSummary[prop] = { time: this.currentTime, value: value };
    };
    /**
     * @return {?}
     */
    TimelineBuilder.prototype.allowOnlyTimelineStyles = function () { return this._currentEmptyStepKeyframe !== this._currentKeyframe; };
    /**
     * @param {?} styles
     * @param {?=} easing
     * @param {?=} treatAsEmptyStep
     * @return {?}
     */
    TimelineBuilder.prototype.setStyles = function (styles, easing, treatAsEmptyStep) {
        var _this = this;
        if (easing === void 0) { easing = null; }
        if (treatAsEmptyStep === void 0) { treatAsEmptyStep = false; }
        if (easing) {
            ((this._previousKeyframe))['easing'] = easing;
        }
        if (treatAsEmptyStep) {
            // special case for animate(duration):
            // all missing styles are filled with a `*` value then
            // if any destination styles are filled in later on the same
            // keyframe then they will override the overridden styles
            // We use `_globalTimelineStyles` here because there may be
            // styles in previous keyframes that are not present in this timeline
            Object.keys(this._globalTimelineStyles).forEach(function (prop) {
                _this._backFill[prop] = _this._globalTimelineStyles[prop] || __WEBPACK_IMPORTED_MODULE_0__angular_animations__["d" /* AUTO_STYLE */];
                _this._currentKeyframe[prop] = __WEBPACK_IMPORTED_MODULE_0__angular_animations__["d" /* AUTO_STYLE */];
            });
            this._currentEmptyStepKeyframe = this._currentKeyframe;
        }
        else {
            Object.keys(styles).forEach(function (prop) {
                if (prop !== 'offset') {
                    var /** @type {?} */ val = styles[prop];
                    _this._currentKeyframe[prop] = val;
                    if (!_this._localTimelineStyles[prop]) {
                        _this._backFill[prop] = _this._globalTimelineStyles[prop] || __WEBPACK_IMPORTED_MODULE_0__angular_animations__["d" /* AUTO_STYLE */];
                    }
                    _this._updateStyle(prop, val);
                }
            });
            Object.keys(this._localTimelineStyles).forEach(function (prop) {
                if (!_this._currentKeyframe.hasOwnProperty(prop)) {
                    _this._currentKeyframe[prop] = _this._localTimelineStyles[prop];
                }
            });
        }
    };
    /**
     * @return {?}
     */
    TimelineBuilder.prototype.snapshotCurrentStyles = function () { copyStyles(this._localTimelineStyles, false, this._currentKeyframe); };
    /**
     * @return {?}
     */
    TimelineBuilder.prototype.getFinalKeyframe = function () { return ((this._keyframes.get(this.duration))); };
    Object.defineProperty(TimelineBuilder.prototype, "properties", {
        /**
         * @return {?}
         */
        get: function () {
            var /** @type {?} */ properties = [];
            for (var /** @type {?} */ prop in this._currentKeyframe) {
                properties.push(prop);
            }
            return properties;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} timeline
     * @return {?}
     */
    TimelineBuilder.prototype.mergeTimelineCollectedStyles = function (timeline) {
        var _this = this;
        Object.keys(timeline._styleSummary).forEach(function (prop) {
            var /** @type {?} */ details0 = _this._styleSummary[prop];
            var /** @type {?} */ details1 = timeline._styleSummary[prop];
            if (!details0 || details1.time > details0.time) {
                _this._updateStyle(prop, details1.value);
            }
        });
    };
    /**
     * @return {?}
     */
    TimelineBuilder.prototype.buildKeyframes = function () {
        var _this = this;
        var /** @type {?} */ finalKeyframes = [];
        // special case for when there are only start/destination
        // styles but no actual animation animate steps...
        if (this.duration == 0) {
            var /** @type {?} */ targetKeyframe = this.getFinalKeyframe();
            var /** @type {?} */ firstKeyframe = copyStyles(targetKeyframe, true);
            firstKeyframe['offset'] = 0;
            finalKeyframes.push(firstKeyframe);
            var /** @type {?} */ lastKeyframe = copyStyles(targetKeyframe, true);
            lastKeyframe['offset'] = 1;
            finalKeyframes.push(lastKeyframe);
        }
        else {
            this._keyframes.forEach(function (keyframe, time) {
                var /** @type {?} */ finalKeyframe = copyStyles(keyframe, true);
                finalKeyframe['offset'] = time / _this.duration;
                finalKeyframes.push(finalKeyframe);
            });
        }
        return createTimelineInstruction(finalKeyframes, this.duration, this.startTime, this.easing);
    };
    return TimelineBuilder;
}());
/**
 * @param {?} ast
 * @return {?}
 */
function getOffset(ast) {
    var /** @type {?} */ offset = ast.offset;
    if (offset == null) {
        var /** @type {?} */ styles = ast.styles;
        if (Array.isArray(styles)) {
            for (var /** @type {?} */ i = 0; i < styles.length; i++) {
                var /** @type {?} */ o = (styles[i]['offset']);
                if (o != null) {
                    offset = o;
                    break;
                }
            }
        }
        else {
            offset = (styles['offset']);
        }
    }
    return ((offset));
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @param {?} triggerName
 * @param {?} fromState
 * @param {?} toState
 * @param {?} isRemovalTransition
 * @param {?} fromStyles
 * @param {?} toStyles
 * @param {?} timelines
 * @return {?}
 */
function createTransitionInstruction(triggerName, fromState, toState, isRemovalTransition, fromStyles, toStyles, timelines) {
    return {
        type: 0 /* TransitionAnimation */,
        triggerName: triggerName,
        isRemovalTransition: isRemovalTransition,
        fromState: fromState,
        fromStyles: fromStyles,
        toState: toState,
        toStyles: toStyles,
        timelines: timelines
    };
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var AnimationTransitionFactory = (function () {
    /**
     * @param {?} _triggerName
     * @param {?} ast
     * @param {?} matchFns
     * @param {?} _stateStyles
     */
    function AnimationTransitionFactory(_triggerName, ast, matchFns, _stateStyles) {
        this._triggerName = _triggerName;
        this.matchFns = matchFns;
        this._stateStyles = _stateStyles;
        var normalizedAst = Array.isArray(ast.animation) ?
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_animations__["b" /* sequence */])(ast.animation) :
            ast.animation;
        this._animationAst = normalizedAst;
    }
    /**
     * @param {?} currentState
     * @param {?} nextState
     * @return {?}
     */
    AnimationTransitionFactory.prototype.match = function (currentState, nextState) {
        if (!oneOrMoreTransitionsMatch(this.matchFns, currentState, nextState))
            return;
        var /** @type {?} */ backupStateStyles = this._stateStyles['*'] || {};
        var /** @type {?} */ currentStateStyles = this._stateStyles[currentState] || backupStateStyles;
        var /** @type {?} */ nextStateStyles = this._stateStyles[nextState] || backupStateStyles;
        var /** @type {?} */ timelines = buildAnimationKeyframes(this._animationAst, currentStateStyles, nextStateStyles);
        return createTransitionInstruction(this._triggerName, currentState, nextState, nextState === 'void', currentStateStyles, nextStateStyles, timelines);
    };
    return AnimationTransitionFactory;
}());
/**
 * @param {?} matchFns
 * @param {?} currentState
 * @param {?} nextState
 * @return {?}
 */
function oneOrMoreTransitionsMatch(matchFns, currentState, nextState) {
    return matchFns.some(function (fn) { return fn(currentState, nextState); });
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @param {?} ast
 * @return {?}
 */
function validateAnimationSequence(ast) {
    var /** @type {?} */ normalizedAst = Array.isArray(ast) ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_animations__["b" /* sequence */])(/** @type {?} */ (ast)) : (ast);
    return new AnimationValidatorVisitor().validate(normalizedAst);
}
var AnimationValidatorVisitor = (function () {
    function AnimationValidatorVisitor() {
    }
    /**
     * @param {?} ast
     * @return {?}
     */
    AnimationValidatorVisitor.prototype.validate = function (ast) {
        var /** @type {?} */ context = new AnimationValidatorContext();
        visitAnimationNode(this, ast, context);
        return context.errors;
    };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    AnimationValidatorVisitor.prototype.visitState = function (ast, context) {
        // these values are not visited in this AST
    };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    AnimationValidatorVisitor.prototype.visitTransition = function (ast, context) {
        // these values are not visited in this AST
    };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    AnimationValidatorVisitor.prototype.visitSequence = function (ast, context) {
        var _this = this;
        ast.steps.forEach(function (step) { return visitAnimationNode(_this, step, context); });
    };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    AnimationValidatorVisitor.prototype.visitGroup = function (ast, context) {
        var _this = this;
        var /** @type {?} */ currentTime = context.currentTime;
        var /** @type {?} */ furthestTime = 0;
        ast.steps.forEach(function (step) {
            context.currentTime = currentTime;
            visitAnimationNode(_this, step, context);
            furthestTime = Math.max(furthestTime, context.currentTime);
        });
        context.currentTime = furthestTime;
    };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    AnimationValidatorVisitor.prototype.visitAnimate = function (ast, context) {
        // we reassign the timings here so that they are not reparsed each
        // time an animation occurs
        context.currentAnimateTimings = ast.timings =
            parseTimeExpression(/** @type {?} */ (ast.timings), context.errors);
        var /** @type {?} */ astType = ast.styles && ast.styles.type;
        if (astType == 5 /* KeyframeSequence */) {
            this.visitKeyframeSequence(/** @type {?} */ (ast.styles), context);
        }
        else {
            context.currentTime +=
                context.currentAnimateTimings.duration + context.currentAnimateTimings.delay;
            if (astType == 6 /* Style */) {
                this.visitStyle(/** @type {?} */ (ast.styles), context);
            }
        }
        context.currentAnimateTimings = null;
    };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    AnimationValidatorVisitor.prototype.visitStyle = function (ast, context) {
        var /** @type {?} */ styleData = normalizeStyles(ast.styles);
        var /** @type {?} */ timings = context.currentAnimateTimings;
        var /** @type {?} */ endTime = context.currentTime;
        var /** @type {?} */ startTime = context.currentTime;
        if (timings && startTime > 0) {
            startTime -= timings.duration + timings.delay;
        }
        Object.keys(styleData).forEach(function (prop) {
            var /** @type {?} */ collectedEntry = context.collectedStyles[prop];
            var /** @type {?} */ updateCollectedStyle = true;
            if (collectedEntry) {
                if (startTime != endTime && startTime >= collectedEntry.startTime &&
                    endTime <= collectedEntry.endTime) {
                    context.errors.push("The CSS property \"" + prop + "\" that exists between the times of \"" + collectedEntry.startTime + "ms\" and \"" + collectedEntry.endTime + "ms\" is also being animated in a parallel animation between the times of \"" + startTime + "ms\" and \"" + endTime + "ms\"");
                    updateCollectedStyle = false;
                }
                // we always choose the smaller start time value since we
                // want to have a record of the entire animation window where
                // the style property is being animated in between
                startTime = collectedEntry.startTime;
            }
            if (updateCollectedStyle) {
                context.collectedStyles[prop] = { startTime: startTime, endTime: endTime };
            }
        });
    };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    AnimationValidatorVisitor.prototype.visitKeyframeSequence = function (ast, context) {
        var _this = this;
        var /** @type {?} */ totalKeyframesWithOffsets = 0;
        var /** @type {?} */ offsets = [];
        var /** @type {?} */ offsetsOutOfOrder = false;
        var /** @type {?} */ keyframesOutOfRange = false;
        var /** @type {?} */ previousOffset = 0;
        ast.steps.forEach(function (step) {
            var /** @type {?} */ styleData = normalizeStyles(step.styles);
            var /** @type {?} */ offset = 0;
            if (styleData.hasOwnProperty('offset')) {
                totalKeyframesWithOffsets++;
                offset = (styleData['offset']);
            }
            keyframesOutOfRange = keyframesOutOfRange || offset < 0 || offset > 1;
            offsetsOutOfOrder = offsetsOutOfOrder || offset < previousOffset;
            previousOffset = offset;
            offsets.push(offset);
        });
        if (keyframesOutOfRange) {
            context.errors.push("Please ensure that all keyframe offsets are between 0 and 1");
        }
        if (offsetsOutOfOrder) {
            context.errors.push("Please ensure that all keyframe offsets are in order");
        }
        var /** @type {?} */ length = ast.steps.length;
        var /** @type {?} */ generatedOffset = 0;
        if (totalKeyframesWithOffsets > 0 && totalKeyframesWithOffsets < length) {
            context.errors.push("Not all style() steps within the declared keyframes() contain offsets");
        }
        else if (totalKeyframesWithOffsets == 0) {
            generatedOffset = 1 / length;
        }
        var /** @type {?} */ limit = length - 1;
        var /** @type {?} */ currentTime = context.currentTime;
        var /** @type {?} */ animateDuration = ((context.currentAnimateTimings)).duration;
        ast.steps.forEach(function (step, i) {
            var /** @type {?} */ offset = generatedOffset > 0 ? (i == limit ? 1 : (generatedOffset * i)) : offsets[i];
            var /** @type {?} */ durationUpToThisFrame = offset * animateDuration;
            context.currentTime =
                currentTime + ((context.currentAnimateTimings)).delay + durationUpToThisFrame; /** @type {?} */
            ((context.currentAnimateTimings)).duration = durationUpToThisFrame;
            _this.visitStyle(step, context);
        });
    };
    return AnimationValidatorVisitor;
}());
var AnimationValidatorContext = (function () {
    function AnimationValidatorContext() {
        this.errors = [];
        this.currentTime = 0;
        this.collectedStyles = {};
    }
    return AnimationValidatorContext;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * \@experimental Animation support is experimental.
 * @param {?} name
 * @param {?} definitions
 * @return {?}
 */
function buildTrigger(name, definitions) {
    return new AnimationTriggerVisitor().buildTrigger(name, definitions);
}
/**
 * \@experimental Animation support is experimental.
 */
var AnimationTrigger = (function () {
    /**
     * @param {?} name
     * @param {?} states
     * @param {?} _transitionAsts
     */
    function AnimationTrigger(name, states, _transitionAsts) {
        var _this = this;
        this.name = name;
        this._transitionAsts = _transitionAsts;
        this.transitionFactories = [];
        this.states = {};
        Object.keys(states).forEach(function (stateName) { _this.states[stateName] = copyStyles(states[stateName], false); });
        var errors = [];
        _transitionAsts.forEach(function (ast) {
            var exprs = parseTransitionExpr(ast.expr, errors);
            var sequenceErrors = validateAnimationSequence(ast);
            if (sequenceErrors.length) {
                errors.push.apply(errors, sequenceErrors);
            }
            else {
                _this.transitionFactories.push(new AnimationTransitionFactory(_this.name, ast, exprs, states));
            }
        });
        if (errors.length) {
            var LINE_START = '\n - ';
            throw new Error("Animation parsing for the " + name + " trigger have failed:" + LINE_START + errors.join(LINE_START));
        }
    }
    /**
     * @param {?} currentState
     * @param {?} nextState
     * @return {?}
     */
    AnimationTrigger.prototype.createFallbackInstruction = function (currentState, nextState) {
        var /** @type {?} */ backupStateStyles = this.states['*'] || {};
        var /** @type {?} */ currentStateStyles = this.states[currentState] || backupStateStyles;
        var /** @type {?} */ nextStateStyles = this.states[nextState] || backupStateStyles;
        return createTransitionInstruction(this.name, currentState, nextState, nextState == 'void', currentStateStyles, nextStateStyles, []);
    };
    /**
     * @param {?} currentState
     * @param {?} nextState
     * @return {?}
     */
    AnimationTrigger.prototype.matchTransition = function (currentState, nextState) {
        for (var /** @type {?} */ i = 0; i < this.transitionFactories.length; i++) {
            var /** @type {?} */ result = this.transitionFactories[i].match(currentState, nextState);
            if (result)
                return result;
        }
        return null;
    };
    return AnimationTrigger;
}());
var AnimationTriggerContext = (function () {
    function AnimationTriggerContext() {
        this.errors = [];
        this.states = {};
        this.transitions = [];
    }
    return AnimationTriggerContext;
}());
var AnimationTriggerVisitor = (function () {
    function AnimationTriggerVisitor() {
    }
    /**
     * @param {?} name
     * @param {?} definitions
     * @return {?}
     */
    AnimationTriggerVisitor.prototype.buildTrigger = function (name, definitions) {
        var _this = this;
        var /** @type {?} */ context = new AnimationTriggerContext();
        definitions.forEach(function (def) { return visitAnimationNode(_this, def, context); });
        return new AnimationTrigger(name, context.states, context.transitions);
    };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    AnimationTriggerVisitor.prototype.visitState = function (ast, context) {
        var /** @type {?} */ styles = normalizeStyles(ast.styles.styles);
        ast.name.split(/\s*,\s*/).forEach(function (name) { context.states[name] = styles; });
    };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    AnimationTriggerVisitor.prototype.visitTransition = function (ast, context) {
        context.transitions.push(ast);
    };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    AnimationTriggerVisitor.prototype.visitSequence = function (ast, context) {
        // these values are not visited in this AST
    };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    AnimationTriggerVisitor.prototype.visitGroup = function (ast, context) {
        // these values are not visited in this AST
    };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    AnimationTriggerVisitor.prototype.visitAnimate = function (ast, context) {
        // these values are not visited in this AST
    };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    AnimationTriggerVisitor.prototype.visitStyle = function (ast, context) {
        // these values are not visited in this AST
    };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    AnimationTriggerVisitor.prototype.visitKeyframeSequence = function (ast, context) {
        // these values are not visited in this AST
    };
    return AnimationTriggerVisitor;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var MARKED_FOR_ANIMATION_CLASSNAME = 'ng-animating';
var MARKED_FOR_ANIMATION_SELECTOR = '.ng-animating';
var MARKED_FOR_REMOVAL = '$$ngRemove';
var VOID_STATE = 'void';
var DomAnimationEngine = (function () {
    /**
     * @param {?} _driver
     * @param {?} _normalizer
     */
    function DomAnimationEngine(_driver, _normalizer) {
        this._driver = _driver;
        this._normalizer = _normalizer;
        this._flaggedInserts = new Set();
        this._queuedRemovals = new Map();
        this._queuedTransitionAnimations = [];
        this._activeTransitionAnimations = new Map();
        this._activeElementAnimations = new Map();
        this._elementTriggerStates = new Map();
        this._triggers = Object.create(null);
        this._triggerListeners = new Map();
        this._pendingListenerRemovals = new Map();
    }
    Object.defineProperty(DomAnimationEngine.prototype, "queuedPlayers", {
        /**
         * @return {?}
         */
        get: function () {
            return this._queuedTransitionAnimations.map(function (q) { return q.player; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DomAnimationEngine.prototype, "activePlayers", {
        /**
         * @return {?}
         */
        get: function () {
            var /** @type {?} */ players = [];
            this._activeElementAnimations.forEach(function (activePlayers) { return players.push.apply(players, activePlayers); });
            return players;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} trigger
     * @param {?=} name
     * @return {?}
     */
    DomAnimationEngine.prototype.registerTrigger = function (trigger, name) {
        name = name || trigger.name;
        if (this._triggers[name]) {
            return;
        }
        this._triggers[name] = buildTrigger(name, trigger.definitions);
    };
    /**
     * @param {?} element
     * @param {?} domFn
     * @return {?}
     */
    DomAnimationEngine.prototype.onInsert = function (element, domFn) {
        if (element['nodeType'] == 1) {
            this._flaggedInserts.add(element);
        }
        domFn();
    };
    /**
     * @param {?} element
     * @param {?} domFn
     * @return {?}
     */
    DomAnimationEngine.prototype.onRemove = function (element, domFn) {
        var _this = this;
        if (element['nodeType'] != 1) {
            domFn();
            return;
        }
        var /** @type {?} */ lookupRef = this._elementTriggerStates.get(element);
        if (lookupRef) {
            var /** @type {?} */ possibleTriggers = Object.keys(lookupRef);
            var /** @type {?} */ hasRemoval = possibleTriggers.some(function (triggerName) {
                var /** @type {?} */ oldValue = ((lookupRef))[triggerName];
                var /** @type {?} */ instruction = _this._triggers[triggerName].matchTransition(oldValue, VOID_STATE);
                return !!instruction;
            });
            if (hasRemoval) {
                element[MARKED_FOR_REMOVAL] = true;
                this._queuedRemovals.set(element, domFn);
                return;
            }
        }
        // this means that there are no animations to take on this
        // leave operation therefore we should fire the done|start callbacks
        if (this._triggerListeners.has(element)) {
            element[MARKED_FOR_REMOVAL] = true;
            this._queuedRemovals.set(element, function () { });
        }
        this._onRemovalTransition(element).forEach(function (player) { return player.destroy(); });
        domFn();
    };
    /**
     * @param {?} element
     * @param {?} property
     * @param {?} value
     * @return {?}
     */
    DomAnimationEngine.prototype.setProperty = function (element, property, value) {
        var /** @type {?} */ trigger = this._triggers[property];
        if (!trigger) {
            throw new Error("The provided animation trigger \"" + property + "\" has not been registered!");
        }
        var /** @type {?} */ lookupRef = this._elementTriggerStates.get(element);
        if (!lookupRef) {
            this._elementTriggerStates.set(element, lookupRef = {});
        }
        var /** @type {?} */ oldValue = lookupRef.hasOwnProperty(property) ? lookupRef[property] : VOID_STATE;
        if (oldValue !== value) {
            value = normalizeTriggerValue(value);
            var /** @type {?} */ instruction = trigger.matchTransition(oldValue, value);
            if (!instruction) {
                // we do this to make sure we always have an animation player so
                // that callback operations are properly called
                instruction = trigger.createFallbackInstruction(oldValue, value);
            }
            this.animateTransition(element, instruction);
            lookupRef[property] = value;
        }
    };
    /**
     * @param {?} element
     * @param {?} eventName
     * @param {?} eventPhase
     * @param {?} callback
     * @return {?}
     */
    DomAnimationEngine.prototype.listen = function (element, eventName, eventPhase, callback) {
        var _this = this;
        if (!eventPhase) {
            throw new Error("Unable to listen on the animation trigger \"" + eventName + "\" because the provided event is undefined!");
        }
        if (!this._triggers[eventName]) {
            throw new Error("Unable to listen on the animation trigger event \"" + eventPhase + "\" because the animation trigger \"" + eventName + "\" doesn't exist!");
        }
        var /** @type {?} */ elementListeners = this._triggerListeners.get(element);
        if (!elementListeners) {
            this._triggerListeners.set(element, elementListeners = []);
        }
        validatePlayerEvent(eventName, eventPhase);
        var /** @type {?} */ tuple = ({ triggerName: eventName, phase: eventPhase, callback: callback });
        elementListeners.push(tuple);
        return function () {
            // this is queued up in the event that a removal animation is set
            // to fire on the element (the listeners need to be set during flush)
            getOrSetAsInMap(_this._pendingListenerRemovals, element, []).push(tuple);
        };
    };
    /**
     * @return {?}
     */
    DomAnimationEngine.prototype._clearPendingListenerRemovals = function () {
        var _this = this;
        this._pendingListenerRemovals.forEach(function (tuples, element) {
            var /** @type {?} */ elementListeners = _this._triggerListeners.get(element);
            if (elementListeners) {
                tuples.forEach(function (tuple) {
                    var /** @type {?} */ index = elementListeners.indexOf(tuple);
                    if (index >= 0) {
                        elementListeners.splice(index, 1);
                    }
                });
            }
        });
        this._pendingListenerRemovals.clear();
    };
    /**
     * @param {?} element
     * @return {?}
     */
    DomAnimationEngine.prototype._onRemovalTransition = function (element) {
        // when a parent animation is set to trigger a removal we want to
        // find all of the children that are currently animating and clear
        // them out by destroying each of them.
        var /** @type {?} */ elms = element.querySelectorAll(MARKED_FOR_ANIMATION_SELECTOR);
        var _loop_1 = function (i) {
            var /** @type {?} */ elm = elms[i];
            var /** @type {?} */ activePlayers = this_1._activeElementAnimations.get(elm);
            if (activePlayers) {
                activePlayers.forEach(function (player) { return player.destroy(); });
            }
            var /** @type {?} */ activeTransitions = this_1._activeTransitionAnimations.get(elm);
            if (activeTransitions) {
                Object.keys(activeTransitions).forEach(function (triggerName) {
                    var /** @type {?} */ player = activeTransitions[triggerName];
                    if (player) {
                        player.destroy();
                    }
                });
            }
        };
        var this_1 = this;
        for (var /** @type {?} */ i = 0; i < elms.length; i++) {
            _loop_1(/** @type {?} */ i);
        }
        // we make a copy of the array because the actual source array is modified
        // each time a player is finished/destroyed (the forEach loop would fail otherwise)
        return copyArray(/** @type {?} */ ((this._activeElementAnimations.get(element))));
    };
    /**
     * @param {?} element
     * @param {?} instruction
     * @return {?}
     */
    DomAnimationEngine.prototype.animateTransition = function (element, instruction) {
        var _this = this;
        var /** @type {?} */ triggerName = instruction.triggerName;
        var /** @type {?} */ previousPlayers;
        if (instruction.isRemovalTransition) {
            previousPlayers = this._onRemovalTransition(element);
        }
        else {
            previousPlayers = [];
            var /** @type {?} */ existingTransitions = this._activeTransitionAnimations.get(element);
            var /** @type {?} */ existingPlayer = existingTransitions ? existingTransitions[triggerName] : null;
            if (existingPlayer) {
                previousPlayers.push(existingPlayer);
            }
        }
        // it's important to do this step before destroying the players
        // so that the onDone callback below won't fire before this
        eraseStyles(element, instruction.fromStyles);
        // we first run this so that the previous animation player
        // data can be passed into the successive animation players
        var /** @type {?} */ totalTime = 0;
        var /** @type {?} */ players = instruction.timelines.map(function (timelineInstruction, i) {
            totalTime = Math.max(totalTime, timelineInstruction.totalTime);
            return _this._buildPlayer(element, timelineInstruction, previousPlayers, i);
        });
        previousPlayers.forEach(function (previousPlayer) { return previousPlayer.destroy(); });
        var /** @type {?} */ player = optimizeGroupPlayer(players);
        player.onDone(function () {
            player.destroy();
            var /** @type {?} */ elmTransitionMap = _this._activeTransitionAnimations.get(element);
            if (elmTransitionMap) {
                delete elmTransitionMap[triggerName];
                if (Object.keys(elmTransitionMap).length == 0) {
                    _this._activeTransitionAnimations.delete(element);
                }
            }
            deleteFromArrayMap(_this._activeElementAnimations, element, player);
            setStyles(element, instruction.toStyles);
        });
        var /** @type {?} */ elmTransitionMap = getOrSetAsInMap(this._activeTransitionAnimations, element, {});
        elmTransitionMap[triggerName] = player;
        this._queuePlayer(element, triggerName, player, makeAnimationEvent(element, triggerName, instruction.fromState, instruction.toState, null, // this will be filled in during event creation
        totalTime));
        return player;
    };
    /**
     * @param {?} element
     * @param {?} instructions
     * @param {?=} previousPlayers
     * @return {?}
     */
    DomAnimationEngine.prototype.animateTimeline = function (element, instructions, previousPlayers) {
        var _this = this;
        if (previousPlayers === void 0) { previousPlayers = []; }
        var /** @type {?} */ players = instructions.map(function (instruction, i) {
            var /** @type {?} */ player = _this._buildPlayer(element, instruction, previousPlayers, i);
            player.onDestroy(function () { deleteFromArrayMap(_this._activeElementAnimations, element, player); });
            _this._markPlayerAsActive(element, player);
            return player;
        });
        return optimizeGroupPlayer(players);
    };
    /**
     * @param {?} element
     * @param {?} instruction
     * @param {?} previousPlayers
     * @param {?=} index
     * @return {?}
     */
    DomAnimationEngine.prototype._buildPlayer = function (element, instruction, previousPlayers, index) {
        if (index === void 0) { index = 0; }
        // only the very first animation can absorb the previous styles. This
        // is here to prevent the an overlap situation where a group animation
        // absorbs previous styles multiple times for the same element.
        if (index && previousPlayers.length) {
            previousPlayers = [];
        }
        return this._driver.animate(element, this._normalizeKeyframes(instruction.keyframes), instruction.duration, instruction.delay, instruction.easing, previousPlayers);
    };
    /**
     * @param {?} keyframes
     * @return {?}
     */
    DomAnimationEngine.prototype._normalizeKeyframes = function (keyframes) {
        var _this = this;
        var /** @type {?} */ errors = [];
        var /** @type {?} */ normalizedKeyframes = [];
        keyframes.forEach(function (kf) {
            var /** @type {?} */ normalizedKeyframe = {};
            Object.keys(kf).forEach(function (prop) {
                var /** @type {?} */ normalizedProp = prop;
                var /** @type {?} */ normalizedValue = kf[prop];
                if (prop != 'offset') {
                    normalizedProp = _this._normalizer.normalizePropertyName(prop, errors);
                    normalizedValue =
                        _this._normalizer.normalizeStyleValue(prop, normalizedProp, kf[prop], errors);
                }
                normalizedKeyframe[normalizedProp] = normalizedValue;
            });
            normalizedKeyframes.push(normalizedKeyframe);
        });
        if (errors.length) {
            var /** @type {?} */ LINE_START = '\n - ';
            throw new Error("Unable to animate due to the following errors:" + LINE_START + errors.join(LINE_START));
        }
        return normalizedKeyframes;
    };
    /**
     * @param {?} element
     * @param {?} player
     * @return {?}
     */
    DomAnimationEngine.prototype._markPlayerAsActive = function (element, player) {
        var /** @type {?} */ elementAnimations = getOrSetAsInMap(this._activeElementAnimations, element, []);
        elementAnimations.push(player);
    };
    /**
     * @param {?} element
     * @param {?} triggerName
     * @param {?} player
     * @param {?} event
     * @return {?}
     */
    DomAnimationEngine.prototype._queuePlayer = function (element, triggerName, player, event) {
        var /** @type {?} */ tuple = ({ element: element, player: player, triggerName: triggerName, event: event });
        this._queuedTransitionAnimations.push(tuple);
        player.init();
        element.classList.add(MARKED_FOR_ANIMATION_CLASSNAME);
        player.onDone(function () { element.classList.remove(MARKED_FOR_ANIMATION_CLASSNAME); });
    };
    /**
     * @return {?}
     */
    DomAnimationEngine.prototype._flushQueuedAnimations = function () {
        var _loop_2 = function () {
            var _a = ((this_2._queuedTransitionAnimations.shift())), player = _a.player, element = _a.element, triggerName = _a.triggerName, event = _a.event;
            var /** @type {?} */ parent = element;
            while (parent = parent.parentNode) {
                // this means that a parent element will or will not
                // have its own animation operation which in this case
                // there's no point in even trying to do an animation
                if (parent[MARKED_FOR_REMOVAL])
                    return "continue-parentLoop";
            }
            var /** @type {?} */ listeners = this_2._triggerListeners.get(element);
            if (listeners) {
                listeners.forEach(function (tuple) {
                    if (tuple.triggerName == triggerName) {
                        listenOnPlayer(player, tuple.phase, event, tuple.callback);
                    }
                });
            }
            // if a removal exists for the given element then we need cancel
            // all the queued players so that a proper removal animation can go
            if (this_2._queuedRemovals.has(element)) {
                player.destroy();
                return "continue";
            }
            this_2._markPlayerAsActive(element, player);
            // in the event that an animation throws an error then we do
            // not want to re-run animations on any previous animations
            // if they have already been kicked off beforehand
            player.init();
            if (!player.hasStarted()) {
                player.play();
            }
        };
        var this_2 = this;
        parentLoop: while (this._queuedTransitionAnimations.length) {
            var state_1 = _loop_2();
            switch (state_1) {
                case "continue-parentLoop": continue parentLoop;
            }
        }
    };
    /**
     * @return {?}
     */
    DomAnimationEngine.prototype.flush = function () {
        var _this = this;
        var /** @type {?} */ leaveListeners = new Map();
        this._queuedRemovals.forEach(function (callback, element) {
            var /** @type {?} */ tuple = _this._pendingListenerRemovals.get(element);
            if (tuple) {
                leaveListeners.set(element, tuple);
                _this._pendingListenerRemovals.delete(element);
            }
        });
        this._clearPendingListenerRemovals();
        this._pendingListenerRemovals = leaveListeners;
        this._flushQueuedAnimations();
        var /** @type {?} */ flushAgain = false;
        this._queuedRemovals.forEach(function (callback, element) {
            // an item that was inserted/removed in the same flush means
            // that an animation should not happen anyway
            if (_this._flaggedInserts.has(element))
                return;
            var /** @type {?} */ parent = element;
            var /** @type {?} */ players = [];
            while (parent = parent.parentNode) {
                // there is no reason to even try to
                if (parent[MARKED_FOR_REMOVAL]) {
                    callback();
                    return;
                }
                var /** @type {?} */ match = _this._activeElementAnimations.get(parent);
                if (match) {
                    players.push.apply(players, match);
                    break;
                }
            }
            // the loop was unable to find an parent that is animating even
            // though this element has set to be removed, so the algorithm
            // should check to see if there are any triggers on the element
            // that are present to handle a leave animation and then setup
            // those players to facilitate the callback after done
            if (players.length == 0) {
                // this means that the element has valid state triggers
                var /** @type {?} */ stateDetails_1 = _this._elementTriggerStates.get(element);
                if (stateDetails_1) {
                    Object.keys(stateDetails_1).forEach(function (triggerName) {
                        flushAgain = true;
                        var /** @type {?} */ oldValue = stateDetails_1[triggerName];
                        var /** @type {?} */ instruction = _this._triggers[triggerName].matchTransition(oldValue, VOID_STATE);
                        if (instruction) {
                            players.push(_this.animateTransition(element, instruction));
                        }
                        else {
                            var /** @type {?} */ event = makeAnimationEvent(element, triggerName, oldValue, VOID_STATE, '', 0);
                            var /** @type {?} */ player = new __WEBPACK_IMPORTED_MODULE_0__angular_animations__["a" /* NoopAnimationPlayer */]();
                            _this._queuePlayer(element, triggerName, player, event);
                        }
                    });
                }
            }
            if (players.length) {
                optimizeGroupPlayer(players).onDone(callback);
            }
            else {
                callback();
            }
        });
        this._queuedRemovals.clear();
        this._flaggedInserts.clear();
        // this means that one or more leave animations were detected
        if (flushAgain) {
            this._flushQueuedAnimations();
            this._clearPendingListenerRemovals();
        }
    };
    return DomAnimationEngine;
}());
/**
 * @param {?} map
 * @param {?} key
 * @param {?} defaultValue
 * @return {?}
 */
function getOrSetAsInMap(map, key, defaultValue) {
    var /** @type {?} */ value = map.get(key);
    if (!value) {
        map.set(key, value = defaultValue);
    }
    return value;
}
/**
 * @param {?} map
 * @param {?} key
 * @param {?} value
 * @return {?}
 */
function deleteFromArrayMap(map, key, value) {
    var /** @type {?} */ arr = map.get(key);
    if (arr) {
        var /** @type {?} */ index = arr.indexOf(value);
        if (index >= 0) {
            arr.splice(index, 1);
            if (arr.length == 0) {
                map.delete(key);
            }
        }
    }
}
/**
 * @param {?} players
 * @return {?}
 */
function optimizeGroupPlayer(players) {
    switch (players.length) {
        case 0:
            return new __WEBPACK_IMPORTED_MODULE_0__angular_animations__["a" /* NoopAnimationPlayer */]();
        case 1:
            return players[0];
        default:
            return new __WEBPACK_IMPORTED_MODULE_0__angular_animations__["e" /* ɵAnimationGroupPlayer */](players);
    }
}
/**
 * @param {?} source
 * @return {?}
 */
function copyArray(source) {
    return source ? source.splice(0) : [];
}
/**
 * @param {?} triggerName
 * @param {?} eventName
 * @return {?}
 */
function validatePlayerEvent(triggerName, eventName) {
    switch (eventName) {
        case 'start':
        case 'done':
            return;
        default:
            throw new Error("The provided animation trigger event \"" + eventName + "\" for the animation trigger \"" + triggerName + "\" is not supported!");
    }
}
/**
 * @param {?} player
 * @param {?} eventName
 * @param {?} baseEvent
 * @param {?} callback
 * @return {?}
 */
function listenOnPlayer(player, eventName, baseEvent, callback) {
    switch (eventName) {
        case 'start':
            player.onStart(function () {
                var /** @type {?} */ event = copyAnimationEvent(baseEvent);
                event.phaseName = 'start';
                callback(event);
            });
            break;
        case 'done':
            player.onDone(function () {
                var /** @type {?} */ event = copyAnimationEvent(baseEvent);
                event.phaseName = 'done';
                callback(event);
            });
            break;
    }
}
/**
 * @param {?} e
 * @return {?}
 */
function copyAnimationEvent(e) {
    return makeAnimationEvent(e.element, e.triggerName, e.fromState, e.toState, e.phaseName, e.totalTime);
}
/**
 * @param {?} element
 * @param {?} triggerName
 * @param {?} fromState
 * @param {?} toState
 * @param {?} phaseName
 * @param {?} totalTime
 * @return {?}
 */
function makeAnimationEvent(element, triggerName, fromState, toState, phaseName, totalTime) {
    return ({ element: element, triggerName: triggerName, fromState: fromState, toState: toState, phaseName: phaseName, totalTime: totalTime });
}
/**
 * @param {?} value
 * @return {?}
 */
function normalizeTriggerValue(value) {
    switch (typeof value) {
        case 'boolean':
            return value ? '1' : '0';
        default:
            return value ? value.toString() : null;
    }
}
/**
 * \@experimental Animation support is experimental.
 * @abstract
 */
var AnimationStyleNormalizer = (function () {
    function AnimationStyleNormalizer() {
    }
    /**
     * @abstract
     * @param {?} propertyName
     * @param {?} errors
     * @return {?}
     */
    AnimationStyleNormalizer.prototype.normalizePropertyName = function (propertyName, errors) { };
    /**
     * @abstract
     * @param {?} userProvidedProperty
     * @param {?} normalizedProperty
     * @param {?} value
     * @param {?} errors
     * @return {?}
     */
    AnimationStyleNormalizer.prototype.normalizeStyleValue = function (userProvidedProperty, normalizedProperty, value, errors) { };
    return AnimationStyleNormalizer;
}());
/**
 * \@experimental Animation support is experimental.
 */
var NoopAnimationStyleNormalizer = (function () {
    function NoopAnimationStyleNormalizer() {
    }
    /**
     * @param {?} propertyName
     * @param {?} errors
     * @return {?}
     */
    NoopAnimationStyleNormalizer.prototype.normalizePropertyName = function (propertyName, errors) { return propertyName; };
    /**
     * @param {?} userProvidedProperty
     * @param {?} normalizedProperty
     * @param {?} value
     * @param {?} errors
     * @return {?}
     */
    NoopAnimationStyleNormalizer.prototype.normalizeStyleValue = function (userProvidedProperty, normalizedProperty, value, errors) {
        return (value);
    };
    return NoopAnimationStyleNormalizer;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var Animation = (function () {
    /**
     * @param {?} input
     */
    function Animation(input) {
        var ast = Array.isArray(input) ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_animations__["b" /* sequence */])(input) : input;
        var errors = validateAnimationSequence(ast);
        if (errors.length) {
            var errorMessage = "animation validation failed:\n" + errors.join("\n");
            throw new Error(errorMessage);
        }
        this._animationAst = ast;
    }
    /**
     * @param {?} startingStyles
     * @param {?} destinationStyles
     * @return {?}
     */
    Animation.prototype.buildTimelines = function (startingStyles, destinationStyles) {
        var /** @type {?} */ start = Array.isArray(startingStyles) ? normalizeStyles(startingStyles) : (startingStyles);
        var /** @type {?} */ dest = Array.isArray(destinationStyles) ? normalizeStyles(destinationStyles) : (destinationStyles);
        return buildAnimationKeyframes(this._animationAst, start, dest);
    };
    /**
     * @param {?} injector
     * @param {?} element
     * @param {?=} startingStyles
     * @param {?=} destinationStyles
     * @return {?}
     */
    Animation.prototype.create = function (injector, element, startingStyles, destinationStyles) {
        if (startingStyles === void 0) { startingStyles = {}; }
        if (destinationStyles === void 0) { destinationStyles = {}; }
        var /** @type {?} */ instructions = this.buildTimelines(startingStyles, destinationStyles);
        // note the code below is only here to make the tests happy (once the new renderer is
        // within core then the code below will interact with Renderer.transition(...))
        var /** @type {?} */ driver = injector.get(AnimationDriver);
        var /** @type {?} */ normalizer = injector.get(AnimationStyleNormalizer);
        var /** @type {?} */ engine = new DomAnimationEngine(driver, normalizer);
        return engine.animateTimeline(element, instructions);
    };
    return Animation;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var WebAnimationsStyleNormalizer = (function (_super) {
    __extends(WebAnimationsStyleNormalizer, _super);
    function WebAnimationsStyleNormalizer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @param {?} propertyName
     * @param {?} errors
     * @return {?}
     */
    WebAnimationsStyleNormalizer.prototype.normalizePropertyName = function (propertyName, errors) {
        return dashCaseToCamelCase(propertyName);
    };
    /**
     * @param {?} userProvidedProperty
     * @param {?} normalizedProperty
     * @param {?} value
     * @param {?} errors
     * @return {?}
     */
    WebAnimationsStyleNormalizer.prototype.normalizeStyleValue = function (userProvidedProperty, normalizedProperty, value, errors) {
        var /** @type {?} */ unit = '';
        var /** @type {?} */ strVal = value.toString().trim();
        if (DIMENSIONAL_PROP_MAP[normalizedProperty] && value !== 0 && value !== '0') {
            if (typeof value === 'number') {
                unit = 'px';
            }
            else {
                var /** @type {?} */ valAndSuffixMatch = value.match(/^[+-]?[\d\.]+([a-z]*)$/);
                if (valAndSuffixMatch && valAndSuffixMatch[1].length == 0) {
                    errors.push("Please provide a CSS unit value for " + userProvidedProperty + ":" + value);
                }
            }
        }
        return strVal + unit;
    };
    return WebAnimationsStyleNormalizer;
}(AnimationStyleNormalizer));
var DIMENSIONAL_PROP_MAP = makeBooleanMap('width,height,minWidth,minHeight,maxWidth,maxHeight,left,top,bottom,right,fontSize,outlineWidth,outlineOffset,paddingTop,paddingLeft,paddingBottom,paddingRight,marginTop,marginLeft,marginBottom,marginRight,borderRadius,borderWidth,borderTopWidth,borderLeftWidth,borderRightWidth,borderBottomWidth,textIndent'
    .split(','));
/**
 * @param {?} keys
 * @return {?}
 */
function makeBooleanMap(keys) {
    var /** @type {?} */ map = {};
    keys.forEach(function (key) { return map[key] = true; });
    return map;
}
var DASH_CASE_REGEXP = /-+([a-z0-9])/g;
/**
 * @param {?} input
 * @return {?}
 */
function dashCaseToCamelCase(input) {
    return input.replace(DASH_CASE_REGEXP, function () {
        var m = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            m[_i] = arguments[_i];
        }
        return m[1].toUpperCase();
    });
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var DEFAULT_STATE_VALUE = 'void';
var DEFAULT_STATE_STYLES = '*';
var NoopAnimationEngine = (function (_super) {
    __extends(NoopAnimationEngine, _super);
    function NoopAnimationEngine() {
        var _this = _super.apply(this, arguments) || this;
        _this._listeners = new Map();
        _this._changes = [];
        _this._flaggedRemovals = new Set();
        _this._onDoneFns = [];
        _this._triggerStyles = Object.create(null);
        return _this;
    }
    /**
     * @param {?} trigger
     * @param {?=} name
     * @return {?}
     */
    NoopAnimationEngine.prototype.registerTrigger = function (trigger, name) {
        name = name || trigger.name;
        if (this._triggerStyles[name]) {
            return;
        }
        var /** @type {?} */ stateMap = {};
        trigger.definitions.forEach(function (def) {
            if (def.type === 0 /* State */) {
                var /** @type {?} */ stateDef = (def);
                stateMap[stateDef.name] = normalizeStyles(stateDef.styles.styles);
            }
        });
        this._triggerStyles[name] = stateMap;
    };
    /**
     * @param {?} element
     * @param {?} domFn
     * @return {?}
     */
    NoopAnimationEngine.prototype.onInsert = function (element, domFn) { domFn(); };
    /**
     * @param {?} element
     * @param {?} domFn
     * @return {?}
     */
    NoopAnimationEngine.prototype.onRemove = function (element, domFn) {
        domFn();
        if (element['nodeType'] == 1) {
            this._flaggedRemovals.add(element);
        }
    };
    /**
     * @param {?} element
     * @param {?} property
     * @param {?} value
     * @return {?}
     */
    NoopAnimationEngine.prototype.setProperty = function (element, property, value) {
        var /** @type {?} */ storageProp = makeStorageProp(property);
        var /** @type {?} */ oldValue = element[storageProp] || DEFAULT_STATE_VALUE;
        this._changes.push(/** @type {?} */ ({ element: element, oldValue: oldValue, newValue: value, triggerName: property }));
        var /** @type {?} */ triggerStateStyles = this._triggerStyles[property] || {};
        var /** @type {?} */ fromStateStyles = triggerStateStyles[oldValue] || triggerStateStyles[DEFAULT_STATE_STYLES];
        if (fromStateStyles) {
            eraseStyles(element, fromStateStyles);
        }
        element[storageProp] = value;
        this._onDoneFns.push(function () {
            var /** @type {?} */ toStateStyles = triggerStateStyles[value] || triggerStateStyles[DEFAULT_STATE_STYLES];
            if (toStateStyles) {
                setStyles(element, toStateStyles);
            }
        });
    };
    /**
     * @param {?} element
     * @param {?} eventName
     * @param {?} eventPhase
     * @param {?} callback
     * @return {?}
     */
    NoopAnimationEngine.prototype.listen = function (element, eventName, eventPhase, callback) {
        var /** @type {?} */ listeners = this._listeners.get(element);
        if (!listeners) {
            this._listeners.set(element, listeners = []);
        }
        var /** @type {?} */ tuple = ({ triggerName: eventName, eventPhase: eventPhase, callback: callback });
        listeners.push(tuple);
        return function () { return tuple.doRemove = true; };
    };
    /**
     * @return {?}
     */
    NoopAnimationEngine.prototype.flush = function () {
        var _this = this;
        var /** @type {?} */ onStartCallbacks = [];
        var /** @type {?} */ onDoneCallbacks = [];
        /**
         * @param {?} listener
         * @param {?} data
         * @return {?}
         */
        function handleListener(listener, data) {
            var /** @type {?} */ phase = listener.eventPhase;
            var /** @type {?} */ event = makeAnimationEvent$1(data.element, data.triggerName, data.oldValue, data.newValue, phase, 0);
            if (phase == 'start') {
                onStartCallbacks.push(function () { return listener.callback(event); });
            }
            else if (phase == 'done') {
                onDoneCallbacks.push(function () { return listener.callback(event); });
            }
        }
        this._changes.forEach(function (change) {
            var /** @type {?} */ element = change.element;
            var /** @type {?} */ listeners = _this._listeners.get(element);
            if (listeners) {
                listeners.forEach(function (listener) {
                    if (listener.triggerName == change.triggerName) {
                        handleListener(listener, change);
                    }
                });
            }
        });
        // upon removal ALL the animation triggers need to get fired
        this._flaggedRemovals.forEach(function (element) {
            var /** @type {?} */ listeners = _this._listeners.get(element);
            if (listeners) {
                listeners.forEach(function (listener) {
                    var /** @type {?} */ triggerName = listener.triggerName;
                    var /** @type {?} */ storageProp = makeStorageProp(triggerName);
                    handleListener(listener, /** @type {?} */ ({
                        element: element,
                        triggerName: triggerName,
                        oldValue: element[storageProp] || DEFAULT_STATE_VALUE,
                        newValue: DEFAULT_STATE_VALUE
                    }));
                });
            }
        });
        // remove all the listeners after everything is complete
        Array.from(this._listeners.keys()).forEach(function (element) {
            var /** @type {?} */ listenersToKeep = ((_this._listeners.get(element))).filter(function (l) { return !l.doRemove; });
            if (listenersToKeep.length) {
                _this._listeners.set(element, listenersToKeep);
            }
            else {
                _this._listeners.delete(element);
            }
        });
        onStartCallbacks.forEach(function (fn) { return fn(); });
        onDoneCallbacks.forEach(function (fn) { return fn(); });
        this._flaggedRemovals.clear();
        this._changes = [];
        this._onDoneFns.forEach(function (doneFn) { return doneFn(); });
        this._onDoneFns = [];
    };
    Object.defineProperty(NoopAnimationEngine.prototype, "activePlayers", {
        /**
         * @return {?}
         */
        get: function () { return []; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NoopAnimationEngine.prototype, "queuedPlayers", {
        /**
         * @return {?}
         */
        get: function () { return []; },
        enumerable: true,
        configurable: true
    });
    return NoopAnimationEngine;
}(AnimationEngine));
/**
 * @param {?} element
 * @param {?} triggerName
 * @param {?} fromState
 * @param {?} toState
 * @param {?} phaseName
 * @param {?} totalTime
 * @return {?}
 */
function makeAnimationEvent$1(element, triggerName, fromState, toState, phaseName, totalTime) {
    return ({ element: element, triggerName: triggerName, fromState: fromState, toState: toState, phaseName: phaseName, totalTime: totalTime });
}
/**
 * @param {?} property
 * @return {?}
 */
function makeStorageProp(property) {
    return '_@_' + property;
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var WebAnimationsPlayer = (function () {
    /**
     * @param {?} element
     * @param {?} keyframes
     * @param {?} options
     * @param {?=} previousPlayers
     */
    function WebAnimationsPlayer(element, keyframes, options, previousPlayers) {
        if (previousPlayers === void 0) { previousPlayers = []; }
        var _this = this;
        this.element = element;
        this.keyframes = keyframes;
        this.options = options;
        this._onDoneFns = [];
        this._onStartFns = [];
        this._onDestroyFns = [];
        this._initialized = false;
        this._finished = false;
        this._started = false;
        this._destroyed = false;
        this.time = 0;
        this.parentPlayer = null;
        this._duration = options['duration'];
        this._delay = options['delay'] || 0;
        this.time = this._duration + this._delay;
        this.previousStyles = {};
        previousPlayers.forEach(function (player) {
            var styles = player._captureStyles();
            Object.keys(styles).forEach(function (prop) { return _this.previousStyles[prop] = styles[prop]; });
        });
    }
    /**
     * @return {?}
     */
    WebAnimationsPlayer.prototype._onFinish = function () {
        if (!this._finished) {
            this._finished = true;
            this._onDoneFns.forEach(function (fn) { return fn(); });
            this._onDoneFns = [];
        }
    };
    /**
     * @return {?}
     */
    WebAnimationsPlayer.prototype.init = function () {
        var _this = this;
        if (this._initialized)
            return;
        this._initialized = true;
        var /** @type {?} */ keyframes = this.keyframes.map(function (styles) {
            var /** @type {?} */ formattedKeyframe = {};
            Object.keys(styles).forEach(function (prop, index) {
                var /** @type {?} */ value = styles[prop];
                if (value == __WEBPACK_IMPORTED_MODULE_0__angular_animations__["d" /* AUTO_STYLE */]) {
                    value = _computeStyle(_this.element, prop);
                }
                if (value != undefined) {
                    formattedKeyframe[prop] = value;
                }
            });
            return formattedKeyframe;
        });
        var /** @type {?} */ previousStyleProps = Object.keys(this.previousStyles);
        if (previousStyleProps.length) {
            var /** @type {?} */ startingKeyframe_1 = keyframes[0];
            var /** @type {?} */ missingStyleProps_1 = [];
            previousStyleProps.forEach(function (prop) {
                if (!startingKeyframe_1.hasOwnProperty(prop)) {
                    missingStyleProps_1.push(prop);
                }
                startingKeyframe_1[prop] = _this.previousStyles[prop];
            });
            if (missingStyleProps_1.length) {
                var /** @type {?} */ self_1 = this;
                var _loop_3 = function () {
                    var /** @type {?} */ kf = keyframes[i];
                    missingStyleProps_1.forEach(function (prop) {
                        kf[prop] = _computeStyle(self_1.element, prop);
                    });
                };
                // tslint:disable-next-line
                for (var /** @type {?} */ i = 1; i < keyframes.length; i++) {
                    _loop_3();
                }
            }
        }
        this._player = this._triggerWebAnimation(this.element, keyframes, this.options);
        this._finalKeyframe =
            keyframes.length ? _copyKeyframeStyles(keyframes[keyframes.length - 1]) : {};
        // this is required so that the player doesn't start to animate right away
        this._resetDomPlayerState();
        this._player.addEventListener('finish', function () { return _this._onFinish(); });
    };
    /**
     * \@internal
     * @param {?} element
     * @param {?} keyframes
     * @param {?} options
     * @return {?}
     */
    WebAnimationsPlayer.prototype._triggerWebAnimation = function (element, keyframes, options) {
        // jscompiler doesn't seem to know animate is a native property because it's not fully
        // supported yet across common browsers (we polyfill it for Edge/Safari) [CL #143630929]
        return (element['animate'](keyframes, options));
    };
    Object.defineProperty(WebAnimationsPlayer.prototype, "domPlayer", {
        /**
         * @return {?}
         */
        get: function () { return this._player; },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} fn
     * @return {?}
     */
    WebAnimationsPlayer.prototype.onStart = function (fn) { this._onStartFns.push(fn); };
    /**
     * @param {?} fn
     * @return {?}
     */
    WebAnimationsPlayer.prototype.onDone = function (fn) { this._onDoneFns.push(fn); };
    /**
     * @param {?} fn
     * @return {?}
     */
    WebAnimationsPlayer.prototype.onDestroy = function (fn) { this._onDestroyFns.push(fn); };
    /**
     * @return {?}
     */
    WebAnimationsPlayer.prototype.play = function () {
        this.init();
        if (!this.hasStarted()) {
            this._onStartFns.forEach(function (fn) { return fn(); });
            this._onStartFns = [];
            this._started = true;
        }
        this._player.play();
    };
    /**
     * @return {?}
     */
    WebAnimationsPlayer.prototype.pause = function () {
        this.init();
        this._player.pause();
    };
    /**
     * @return {?}
     */
    WebAnimationsPlayer.prototype.finish = function () {
        this.init();
        this._onFinish();
        this._player.finish();
    };
    /**
     * @return {?}
     */
    WebAnimationsPlayer.prototype.reset = function () {
        this._resetDomPlayerState();
        this._destroyed = false;
        this._finished = false;
        this._started = false;
    };
    /**
     * @return {?}
     */
    WebAnimationsPlayer.prototype._resetDomPlayerState = function () {
        if (this._player) {
            this._player.cancel();
        }
    };
    /**
     * @return {?}
     */
    WebAnimationsPlayer.prototype.restart = function () {
        this.reset();
        this.play();
    };
    /**
     * @return {?}
     */
    WebAnimationsPlayer.prototype.hasStarted = function () { return this._started; };
    /**
     * @return {?}
     */
    WebAnimationsPlayer.prototype.destroy = function () {
        if (!this._destroyed) {
            this._resetDomPlayerState();
            this._onFinish();
            this._destroyed = true;
            this._onDestroyFns.forEach(function (fn) { return fn(); });
            this._onDestroyFns = [];
        }
    };
    /**
     * @param {?} p
     * @return {?}
     */
    WebAnimationsPlayer.prototype.setPosition = function (p) { this._player.currentTime = p * this.time; };
    /**
     * @return {?}
     */
    WebAnimationsPlayer.prototype.getPosition = function () { return this._player.currentTime / this.time; };
    /**
     * @return {?}
     */
    WebAnimationsPlayer.prototype._captureStyles = function () {
        var _this = this;
        var /** @type {?} */ styles = {};
        if (this.hasStarted()) {
            Object.keys(this._finalKeyframe).forEach(function (prop) {
                if (prop != 'offset') {
                    styles[prop] =
                        _this._finished ? _this._finalKeyframe[prop] : _computeStyle(_this.element, prop);
                }
            });
        }
        return styles;
    };
    return WebAnimationsPlayer;
}());
/**
 * @param {?} element
 * @param {?} prop
 * @return {?}
 */
function _computeStyle(element, prop) {
    return ((window.getComputedStyle(element)))[prop];
}
/**
 * @param {?} styles
 * @return {?}
 */
function _copyKeyframeStyles(styles) {
    var /** @type {?} */ newStyles = {};
    Object.keys(styles).forEach(function (prop) {
        if (prop != 'offset') {
            newStyles[prop] = styles[prop];
        }
    });
    return newStyles;
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var WebAnimationsDriver = (function () {
    function WebAnimationsDriver() {
    }
    /**
     * @param {?} element
     * @param {?} keyframes
     * @param {?} duration
     * @param {?} delay
     * @param {?} easing
     * @param {?=} previousPlayers
     * @return {?}
     */
    WebAnimationsDriver.prototype.animate = function (element, keyframes, duration, delay, easing, previousPlayers) {
        if (previousPlayers === void 0) { previousPlayers = []; }
        var /** @type {?} */ playerOptions = { 'duration': duration, 'delay': delay, 'fill': 'forwards' };
        // we check for this to avoid having a null|undefined value be present
        // for the easing (which results in an error for certain browsers #9752)
        if (easing) {
            playerOptions['easing'] = easing;
        }
        var /** @type {?} */ previousWebAnimationPlayers = (previousPlayers.filter(function (player) { return player instanceof WebAnimationsPlayer; }));
        return new WebAnimationsPlayer(element, keyframes, playerOptions, previousWebAnimationPlayers);
    };
    return WebAnimationsDriver;
}());
/**
 * @return {?}
 */
function supportsWebAnimations() {
    return typeof Element !== 'undefined' && typeof ((Element)).prototype['animate'] === 'function';
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @module
 * @description
 * Entry point for all animation APIs of the animation browser package.
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @module
 * @description
 * Entry point for all public APIs of the animation package.
 */
/**
 * Generated bundle index. Do not edit.
 */

//# sourceMappingURL=browser.es5.js.map


/***/ }),

/***/ "1KT0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var merge_1 = __webpack_require__("kkb0");
exports.merge = merge_1.mergeStatic;
//# sourceMappingURL=merge.js.map

/***/ }),

/***/ "1NVl":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var every_1 = __webpack_require__("83T1");
Observable_1.Observable.prototype.every = every_1.every;
//# sourceMappingURL=every.js.map

/***/ }),

/***/ "1Nls":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var ajax_1 = __webpack_require__("gIFM");
Observable_1.Observable.ajax = ajax_1.ajax;
//# sourceMappingURL=ajax.js.map

/***/ }),

/***/ "1VLl":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var onErrorResumeNext_1 = __webpack_require__("ASN6");
Observable_1.Observable.onErrorResumeNext = onErrorResumeNext_1.onErrorResumeNextStatic;
//# sourceMappingURL=onErrorResumeNext.js.map

/***/ }),

/***/ "1YOb":
/***/ (function(module, exports) {

exports.model=Model={Game:{},Board:{},Move:{}},function(){function t(t){if(o){var e=t%s;return(t-e)/s*s+s-e}var r=s*i-t-1,n=r%s;return r-n+s-n}var s,i,o=!1;Model.Game.checkersPosToString=t,Model.Game.InitGameInfo=function(){},Model.Game.BuildGraphCoord=function(){var t=(this.mOptions.width,this.mOptions.height,[]),s=[];this.g.Graph=t,this.g.Coord=s},Model.Game.InitGame=function(){var t=this.mOptions.width,e=this.mOptions.height;if(s=t,i=e,o=this.mOptions.invertNotation||!1,this.g.compulsoryCatch=!0,this.g.canStepBack=!0,this.g.mustMoveForward=!1,this.g.mustMoveForwardStrict=!1,this.g.lastRowFreeze=!1,this.g.lastRowCrown=!1,this.g.captureLongestLine=!1,this.g.noMove="lose",this.g.kingCaptureShort=!1,this.g.kingValue=5,this.g.lastRowFactor=0,this.g.canCaptureBackward=!0,this.g.captureInstantRemove=!1,this.g.longRangeKing=!0,this.g.drawKvsK=!0,this.g.drawKvs2K=!0,this.g.whiteStarts=!0,this.g.king180deg=!1,this.mOptions.variant)for(var r in this.mOptions.variant)this.mOptions.variant.hasOwnProperty(r)&&(this.g[r]=this.mOptions.variant[r]);this.BuildGraphCoord(),this.zobrist=new JocGame.Zobrist({board:{type:"array",size:this.g.Graph.length,values:["1/0","1/1","-1/0","-1/1"]}})},Model.Game.DestroyGame=function(){},Model.Game.CheckersDirections=4,Model.Game.Checkers2WaysDirections=[0,1,1,0],Model.Game.CheckersEachDirection=function(t,s){for(var i=0;i<this.CheckersDirections;i++){var o=this.g.Graph[t][i];if(null!=o&&0==s(o,i))return}},Model.Move.Init=function(t){this.pos=[];for(var s=t.pos?Object.keys(t.pos).sort():[],i=0;i<s.length;i++)this.pos.push(t.pos[i]);this.capt=[];for(var o=t.capt?Object.keys(t.capt).sort():[],i=0;i<o.length;i++)this.capt.push(t.capt[i])},Model.Move.ToString=function(s){s=s||"natural";var i=this;switch(s){case"natural":return function(){for(var s=[t(i.pos[0]),t(i.pos[i.pos.length-1])],o="-",e=1;e<i.capt.length;e++)null!=i.capt[e]&&(o="x",i.capt.length>3&&s.push(t(i.capt[e])));return s.join(o)}();case"hub":return function(){var s="-",o=[t(i.pos[0]),t(i.pos[i.pos.length-1])];if(i.capt[1]){s="x";var e=i.capt.slice(1).map(function(s){return t(s)});e.sort(),o=o.concat(e)}return o.join(s)}();case"dxp":return function(){var s=[t(i.pos[0]),t(i.pos[i.pos.length-1])];if(i.capt[1]){s.push(i.capt.length-1);for(var o=[],e=1;e<i.capt.length;e++)o.push(t(i.capt[e]));o.sort(),s=s.concat(o)}else s.push(0);return s.map(function(t){return t<10?"0"+t:t}).join("")}();default:return"??"}},Model.Board.Init=function(t){this.zSign=0},Model.Board.InitialPosition=function(t){var s=t.mOptions.width,i=t.mOptions.height,o=t.mOptions.initial;this.board=[];for(var e=0;e<i;e++)for(var r=0;r<s;r++)this.board[e*s+r]=-1;this.pieces=[];var n=0;if(t.mInitial){this.pCount=[0,0],this.spCount=[0,0],this.kpCount=[0,0];for(var a=0;a<t.mInitial.pieces.length;a++){var h=t.mInitial.pieces[a];this.board[h.p]=a,this.pieces.push({s:h.s,p:h.p,l:-1,t:h.t,plp:h.p}),this.zSign=t.zobrist.update(this.zSign,"board",h.s+"/"+h.t,h.p);var p=-(h.s-1)/2;this.pCount[p]++,0==h.t?this.spCount[p]++:this.kpCount[p]++}}else{for(var a in o.a)if(o.a.hasOwnProperty(a)){var u=o.a[a],c=u[0]*s+u[1],h={s:JocGame.PLAYER_A,p:c,l:-1,t:0,plp:c};this.pieces.push(h),this.board[c]=n++,this.zSign=t.zobrist.update(this.zSign,"board","1/0",c)}for(var a in o.b)if(o.b.hasOwnProperty(a)){var u=o.b[a],c=u[0]*s+u[1],h={s:JocGame.PLAYER_B,p:c,l:-1,t:0,plp:c};this.pieces.push(h),this.board[c]=n++,this.zSign=t.zobrist.update(this.zSign,"board","-1/0",c)}this.pCount=[o.a.length,o.b.length],this.spCount=[o.a.length,o.b.length],this.kpCount=[o.a.length,o.b.length]}},Model.Board.GenerateMoves=function(t){try{this._GenerateMoves(t)}catch(t){}},Model.Board._GenerateMoves=function(t){function s(t){for(var s=0;s<e.pieces.length;s++){var i=e.pieces[s];i&&i.s==e.mWho&&t(s,i.p)}}function i(s,o,r,n,a){for(;;){var h=[],p=[],u=[];if(t.CheckersEachDirection(s,function(i,c){var l;0==t.g.canCaptureBackward&&(l=t.g.Coord[s][0]);var g=t.Checkers2WaysDirections[c];if(a){if(t.g.longRangeKing)for(;e.board[i]==-1||t.g.king180deg&&null!=i&&r.indexOf(i)>=0;)i=t.g.Graph[i][c];if(null!=i&&e.board[i]>=0&&e.pieces[e.board[i]].s==-e.mWho){var v=i;if(i=t.g.Graph[i][c],t.g.kingCaptureShort){if(e.board[i]==-1||i==o[0]){for(var f=!0,d=0;d<n.length;d++)if(t.g.king180deg){if(r[d]==v){f=!1;break}}else if(t.g.captureInstantRemove&&r[d]==v||0==t.g.captureInstantRemove&&r[d]==v&&n[d]==g){f=!1;break}f&&(h.push(i),p.push(v),u.push(g)),i=t.g.Graph[i][c]}}else for(;e.board[i]==-1||i==o[0];){for(var f=!0,d=0;d<n.length;d++)if(t.g.captureInstantRemove&&r[d]==v||0==t.g.captureInstantRemove&&r[d]==v&&n[d]==g){f=!1;break}f&&(h.push(i),p.push(v),u.push(g)),i=t.g.Graph[i][c]}}}else if(e.board[i]>=0&&e.pieces[e.board[i]].s==-e.mWho){var m,C;if(0==t.g.canCaptureBackward&&(m=t.g.Coord[i][0],C=!1,(e.mWho==JocGame.PLAYER_A&&m>=l||e.mWho==JocGame.PLAYER_B&&m<=l)&&(C=!0)),t.g.canCaptureBackward||1==C){var b=t.g.Graph[i][c];if(null!=b&&(e.board[b]==-1||b==o[0])){for(var f=!0,d=0;d<n.length;d++)if(t.g.captureInstantRemove&&r[d]==i||0==t.g.captureInstantRemove&&r[d]==i&&n[d]==g){f=!1;break}f&&(h.push(b),p.push(i),u.push(g))}}}return!0}),0==h.length){o.length>1&&e.mMoves.push({pos:o,capt:r});break}if(!t.g.compulsoryCatch&&o.length>1){for(var c=[],l=0;l<o.length;l++)c.push(o[l]);for(var g=[],l=0;l<r.length;l++)g.push(r[l]);e.mMoves.push({pos:c,capt:g})}if(1!=h.length){for(var l=0;l<h.length;l++){for(var c=[],v=0;v<o.length;v++)c.push(o[v]);c.push(h[l]);for(var g=[],v=0;v<r.length;v++)g.push(r[v]);g.push(p[l]);for(var f=[],v=0;v<n.length;v++)f.push(n[v]);f.push(u[l]),i(h[l],c,g,f,a)}break}s=h[0],o.push(s),r.push(p[0]),n.push(u[0])}}var o=t.mOptions.height,e=this;if(this.mMoves=[],s(function(t,s){0==e.pieces[t].t?i(s,[s],[null],[null],!1):1==e.pieces[t].t&&i(s,[s],[null],[null],!0)}),0!=t.g.compulsoryCatch&&0!=this.mMoves.length||s(function(s,i){var r;0==e.pieces[s].t?((t.g.mustMoveForward||t.g.mustMoveForwardStrict||t.lastRowFreeze)&&(r=t.g.Coord[i][0]),t.CheckersEachDirection(i,function(n,a){var h,p,u;return t.g.mustMoveForwardStrict?(h=t.g.Coord[n][0],p=!1,(e.mWho==JocGame.PLAYER_A&&h>r||e.mWho==JocGame.PLAYER_B&&h<r)&&(p=!0)):t.g.mustMoveForward&&(h=t.g.Coord[n][0],p=!0,(e.mWho==JocGame.PLAYER_A&&h<r||e.mWho==JocGame.PLAYER_B&&h>r)&&(p=!1)),t.g.lastRowFreeze&&(u=!1,(e.mWho==JocGame.PLAYER_A&&r==o-1||e.mWho==JocGame.PLAYER_B&&0==r)&&(u=!0)),e.board[n]!=-1||!t.g.canStepBack&&n==e.pieces[s].l||(0!=t.g.mustMoveForward||0!=t.g.mustMoveForwardStrict)&&1!=p||0!=t.g.lastRowFreeze&&0!=u||e.mMoves.push({pos:[i,n],capt:[null,null]}),!0})):1==e.pieces[s].t&&t.CheckersEachDirection(i,function(s,o){if(t.g.longRangeKing)for(;e.board[s]==-1;)e.mMoves.push({pos:[i,s],capt:[null,null]}),s=t.g.Graph[s][o];else e.board[s]==-1&&(e.mMoves.push({pos:[i,s],capt:[null,null]}),s=t.g.Graph[s][o]);return!0})}),0==this.mMoves.length)switch(t.g.noMove){case"count":this.mFinished=!0,this.pCount[0]<this.pCount[1]?this.mWinner=JocGame.PLAYER_B:this.pCount[1]<this.pCount[0]?this.mWinner=JocGame.PLAYER_A:this.mWinner=JocGame.DRAW;break;case"lose":this.mFinished=!0,this.mWinner=-this.mWho;break;default:this.mFinished=!0,this.mWinner=JocGame.DRAW}if(t.g.captureLongestLine){for(var r=this.mMoves,n=[],a=0,h=0;h<r.length;h++){var p=r[h];p.pos.length==a?n.push(p):p.pos.length>a&&(n=[p],a=p.pos.length)}this.mMoves=n}},Model.Board.Evaluate=function(t,s,i){if(t.mOptions.preventRepeat&&t.GetRepeatOccurence(this)>2)return this.mFinished=!0,void(this.mWinner=JocGame.DRAW);if(t.g.drawKvsK&&0==this.spCount[0]&&0==this.spCount[1]&&1==this.kpCount[0]&&1==this.kpCount[1])return this.mFinished=!0,void(this.mWinner=JocGame.DRAW);if(t.g.drawKvs2K&&0==this.spCount[0]&&0==this.spCount[1]&&this.kpCount[0]+this.kpCount[1]==3&&(1==this.kpCount[0]||2==this.kpCount[0]))return this.mFinished=!0,void(this.mWinner=JocGame.DRAW);if(0==this.pCount[1])return this.mFinished=!0,void(this.mWinner=JocGame.PLAYER_A);if(0==this.pCount[0])return this.mFinished=!0,void(this.mWinner=JocGame.PLAYER_B);if(this.mEvaluation=10*(this.spCount[0]-this.spCount[1])+10*(this.kpCount[0]-this.kpCount[1])*t.g.kingValue+this.pCount[0]/this.pCount[1]-this.pCount[1]/this.pCount[0],0!=t.g.lastRowFactor){for(var o=t.mOptions.height,e=0,r=0,n=0;n<this.pieces.length;n++){var a=this.pieces[n];a&&0==a.t&&(this.mWho==JocGame.PLAYER_A?e+=t.g.Coord[a.p][0]:r+=o-1-t.g.Coord[a.p][0])}this.mEvaluation+=(e-r)*t.g.lastRowFactor}},Model.Board.CopyFrom=function(t){this.board=[];for(var s=0;s<t.board.length;s++)this.board[s]=t.board[s];this.pieces=[];for(var s=0;s<t.pieces.length;s++){var i=t.pieces[s];this.pieces[s]=null==i?null:{s:i.s,p:i.p,l:i.l,t:i.t,plp:i.plp}}this.pCount=[t.pCount[0],t.pCount[1]],this.spCount=[t.spCount[0],t.spCount[1]],this.kpCount=[t.kpCount[0],t.kpCount[1]],this.mWho=t.mWho,this.zSign=t.zSign},Model.Board.ApplyMove=function(t,s){var i=(t.mOptions.width,t.mOptions.height),o=s.pos[0],e=this.board[o],r=this.pieces[e],n=r.s;r.l=o;var a={};this.zSign=t.zobrist.update(this.zSign,"board",r.s+"/"+r.t,r.p);for(var h=1;h<s.pos.length;h++){var p=s.pos[h];this.board[r.p]=-1,r.p=p,this.board[p]=e;var u=s.capt[h];null!=u&&(this.board[u]>=0&&(a[this.board[u]]=!0),this.board[u]=-1),o=p}this.zSign=t.zobrist.update(this.zSign,"board",r.s+"/"+r.t,p);var c=s.capt[s.capt.length-1];r.plp=c||s.pos[s.pos.length-2];for(var l in a)if(a.hasOwnProperty(l)){var g=this.pieces[l],v=(1-g.s)/2;switch(this.pCount[v]--,g.t){case 0:this.spCount[v]--;break;case 1:this.kpCount[v]--}this.zSign=t.zobrist.update(this.zSign,"board",g.s+"/"+g.t,g.p),this.pieces[l]=null}if(t.g.lastRowCrown&&0==this.pieces[e].t){var f=t.g.Coord[s.pos[s.pos.length-1]][0];if(n==JocGame.PLAYER_A&&f==i-1||n==JocGame.PLAYER_B&&0==f){var g=this.pieces[e];g.t=1;var d=(1-n)/2;this.spCount[d]--,this.kpCount[d]++,this.zSign=t.zobrist.update(this.zSign,"board",g.s+"/0",g.p),this.zSign=t.zobrist.update(this.zSign,"board",g.s+"/1",g.p)}}},Model.Board.IsValidMove=function(t,s){return!0},Model.Board.GetSignature=function(){return this.zSign},Model.Game.Import=function(t,s){function i(t,s,i){i=r-i;var o=i%n;i=i-o+n-o-1,e.push({s:t,p:i,l:-1,t:s,plp:i})}var o=1,e=[],r=this.mOptions.width*this.mOptions.height,n=this.mOptions.width;if("pjn"==t){var a=s.split(":");o="W"==a[0]?1:-1;for(var h=1;h<a.length;h++)if(0!=a[h].length)for(var p="W"==a[h].substr(0,1)?1:-1,u=a[h].substr(1).split(","),c=0;c<u.length;c++){var l=u[c],g=0;"K"==l.substr(0,1)&&(g=1,l=l.substr(1));var v=/^([0-9]+)-([0-9]+)$/.exec(l);if(v)for(var f=parseInt(v[1]);f<=parseInt(v[2]);f++)i(p,g,f);else i(p,g,parseInt(l))}return e.sort(function(t,s){return s.s-t.s}),{status:!0,initial:{pieces:e,turn:o}}}return{status:!1,error:"unsupported"}};var e=JocGame.prototype.GetBestMatchingMove;Model.Game.GetBestMatchingMove=function(t,s){var i=[],o=this;s.forEach(function(t){"function"==typeof t.ToString?i.push(t.ToString()):i.push(o.CreateMove(t).ToString())}),t=t.replace(/0([1-9])/g,"$1");var r=/^([0-9]+)[\-x]([0-9]+)([\-x][0-9]+)*$/.exec(t);if(r){var n=new RegExp("^"+r[1]+"[-x]"+r[2]+"([-x][0-9]+)*$"),a={};s.forEach(function(t,s){if(n.test(i[s])){var o=i[s],e=/^([0-9]+)x([0-9]+)x([0-9]+(x[0-9]+)*)/.exec(o);if(e){var r=e[3].split("x");r.sort(function(t,s){return parseInt(t)-parseInt(s)}),o=e[1]+"x"+e[2]+"x"+r.join("x")}a[o]=t}});var h=[];for(var p in a)a.hasOwnProperty(p)&&h.push(a[p]);h.length>0&&(s=h)}return e.call(this,t,s)},Model.Board.ExportBoardState=function(o,e){function r(t){for(var o=[],e=0;e<n.board.length;e++){var r=e%s,a=(e-r)/s,h=(i-a-1)*s+r,p=n.board[e];if(p<0)o[h]="e";else{var u=n.pieces[p],c=1==u.s?"w":t;1==u.t&&(c=c.toUpperCase()),o[h]=c}}return o.join("")}e=e||"natural";var n=this;switch(e){case"natural":case"fen":return function(){var s={},i=[];n.pieces.forEach(function(i){if(i&&null!=i.p){var o=1==i.s?"W":"B";void 0===s[o]&&(s[o]={});var e=1==i.t?"K":"";void 0===s[o][e]&&(s[o][e]={group:0==i.t,pos:[]}),s[o][e].pos.push(parseInt(t(i.p)))}});for(var o in s)if(s.hasOwnProperty(o)){var e=[];for(var r in s[o])if(s[o].hasOwnProperty(r)){var a=s[o][r];if(a.group){a.pos.sort(function(t,s){return parseInt(t)-parseInt(s)});var h=-2,p=-1,u=-1;a.pos.forEach(function(t){parseInt(t)==h+1?p=t:(p>=0?(e.push(r+u+"-"+p),p=-1):u>=0&&e.push(r+u),u=t),h=parseInt(t)}),p>=0?e.push(r+u+"-"+p):u>=0&&e.push(r+u)}else a.pos.forEach(function(t){e.push(r+t)})}i.push(o+e.join(","))}return i.join(":")}();case"dxp":return function(){return r("z")}();case"hub":return function(){return r("z")}();default:return JSON.stringify(this)}}}(),Model.Game.BuildGraphCoord=function(){for(var t=this.mOptions.width,s=this.mOptions.height,i=[],o=[],e=0;e<s;e++)for(var r=0;r<t;r++){var n=e*t+r;o[n]=[e,r],i[n]=[],e%2==0?(e<s-1?(i[n].push((e+1)*t+r),r>0?i[n].push((e+1)*t+r-1):i[n].push(null)):(i[n].push(null),i[n].push(null)),e>0?(i[n].push((e-1)*t+r),r>0?i[n].push((e-1)*t+r-1):i[n].push(null)):(i[n].push(null),i[n].push(null))):(e<s-1?(r<t-1?i[n].push((e+1)*t+r+1):i[n].push(null),i[n].push((e+1)*t+r)):(i[n].push(null),i[n].push(null)),e>0?(r<t-1?i[n].push((e-1)*t+r+1):i[n].push(null),i[n].push((e-1)*t+r)):(i[n].push(null),i[n].push(null)))}this.g.Graph=i,this.g.Coord=o};

/***/ }),

/***/ "1ZrL":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var concat_1 = __webpack_require__("lU4I");
Observable_1.Observable.concat = concat_1.concat;
//# sourceMappingURL=concat.js.map

/***/ }),

/***/ "1hN3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscription_1 = __webpack_require__("B00U");
var tryCatch_1 = __webpack_require__("+3eL");
var errorObject_1 = __webpack_require__("WhVc");
var OuterSubscriber_1 = __webpack_require__("wAkD");
var subscribeToResult_1 = __webpack_require__("CURp");
/**
 * Buffers the source Observable values, using a factory function of closing
 * Observables to determine when to close, emit, and reset the buffer.
 *
 * <span class="informal">Collects values from the past as an array. When it
 * starts collecting values, it calls a function that returns an Observable that
 * tells when to close the buffer and restart collecting.</span>
 *
 * <img src="./img/bufferWhen.png" width="100%">
 *
 * Opens a buffer immediately, then closes the buffer when the observable
 * returned by calling `closingSelector` function emits a value. When it closes
 * the buffer, it immediately opens a new buffer and repeats the process.
 *
 * @example <caption>Emit an array of the last clicks every [1-5] random seconds</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var buffered = clicks.bufferWhen(() =>
 *   Rx.Observable.interval(1000 + Math.random() * 4000)
 * );
 * buffered.subscribe(x => console.log(x));
 *
 * @see {@link buffer}
 * @see {@link bufferCount}
 * @see {@link bufferTime}
 * @see {@link bufferToggle}
 * @see {@link windowWhen}
 *
 * @param {function(): Observable} closingSelector A function that takes no
 * arguments and returns an Observable that signals buffer closure.
 * @return {Observable<T[]>} An observable of arrays of buffered values.
 * @method bufferWhen
 * @owner Observable
 */
function bufferWhen(closingSelector) {
    return this.lift(new BufferWhenOperator(closingSelector));
}
exports.bufferWhen = bufferWhen;
var BufferWhenOperator = (function () {
    function BufferWhenOperator(closingSelector) {
        this.closingSelector = closingSelector;
    }
    BufferWhenOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new BufferWhenSubscriber(subscriber, this.closingSelector));
    };
    return BufferWhenOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var BufferWhenSubscriber = (function (_super) {
    __extends(BufferWhenSubscriber, _super);
    function BufferWhenSubscriber(destination, closingSelector) {
        _super.call(this, destination);
        this.closingSelector = closingSelector;
        this.subscribing = false;
        this.openBuffer();
    }
    BufferWhenSubscriber.prototype._next = function (value) {
        this.buffer.push(value);
    };
    BufferWhenSubscriber.prototype._complete = function () {
        var buffer = this.buffer;
        if (buffer) {
            this.destination.next(buffer);
        }
        _super.prototype._complete.call(this);
    };
    BufferWhenSubscriber.prototype._unsubscribe = function () {
        this.buffer = null;
        this.subscribing = false;
    };
    BufferWhenSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.openBuffer();
    };
    BufferWhenSubscriber.prototype.notifyComplete = function () {
        if (this.subscribing) {
            this.complete();
        }
        else {
            this.openBuffer();
        }
    };
    BufferWhenSubscriber.prototype.openBuffer = function () {
        var closingSubscription = this.closingSubscription;
        if (closingSubscription) {
            this.remove(closingSubscription);
            closingSubscription.unsubscribe();
        }
        var buffer = this.buffer;
        if (this.buffer) {
            this.destination.next(buffer);
        }
        this.buffer = [];
        var closingNotifier = tryCatch_1.tryCatch(this.closingSelector)();
        if (closingNotifier === errorObject_1.errorObject) {
            this.error(errorObject_1.errorObject.e);
        }
        else {
            closingSubscription = new Subscription_1.Subscription();
            this.closingSubscription = closingSubscription;
            this.add(closingSubscription);
            this.subscribing = true;
            closingSubscription.add(subscribeToResult_1.subscribeToResult(this, closingNotifier));
            this.subscribing = false;
        }
    };
    return BufferWhenSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=bufferWhen.js.map

/***/ }),

/***/ "1k2o":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var bindCallback_1 = __webpack_require__("33Pm");
Observable_1.Observable.bindCallback = bindCallback_1.bindCallback;
//# sourceMappingURL=bindCallback.js.map

/***/ }),

/***/ "1kxm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var FastMap = (function () {
    function FastMap() {
        this.values = {};
    }
    FastMap.prototype.delete = function (key) {
        this.values[key] = null;
        return true;
    };
    FastMap.prototype.set = function (key, value) {
        this.values[key] = value;
        return this;
    };
    FastMap.prototype.get = function (key) {
        return this.values[key];
    };
    FastMap.prototype.forEach = function (cb, thisArg) {
        var values = this.values;
        for (var key in values) {
            if (values.hasOwnProperty(key) && values[key] !== null) {
                cb.call(thisArg, values[key], key);
            }
        }
    };
    FastMap.prototype.clear = function () {
        this.values = {};
    };
    return FastMap;
}());
exports.FastMap = FastMap;
//# sourceMappingURL=FastMap.js.map

/***/ }),

/***/ "1qWN":
/***/ (function(module, exports) {

exports.config = {"status":true,"model":{"plazza":"true","released":1404997707,"title-en":"Janus Chess","module":"chessbase","summary":"Chess on 10x8 (1978)","thumbnail":"janus-thumb.png","rules":{"en":"janus-rules.html"},"credits":{"en":"janus-credits.html"},"gameOptions":{"preventRepeat":true,"uctTransposition":"state","uctIgnoreLoop":false,"levelOptions":{"pieceValueFactor":1,"pieceValueRatioFactor":1,"posValueFactor":0.1,"averageDistKingFactor":-0.01,"castleFactor":0.1,"minorPiecesMovedFactor":0.1,"checkFactor":0.2,"endingKingFreedomFactor":0.01,"endingDistKingFactor":0.05,"distKingCornerFactor":0.1,"distPawnPromo1Factor":0.3,"distPawnPromo2Factor":0.1,"distPawnPromo3Factor":0.05}},"obsolete":false,"js":["base-model.js","grid-geo-model.js","janus-model.js"],"description":{"en":"janus-description.html"},"levels":[{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"easy","label":"Easy","maxNodes":1000},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"fast","label":"Fast [1sec]","maxDuration":1,"isDefault":true},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"medium","label":"Medium","maxNodes":10000,"maxDuration":10},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"strong","label":"Strong","maxNodes":20000,"maxDuration":15}]},"view":{"title-en":"Chessbase view","module":"chessbase","xdView":true,"css":["chessbase.css"],"preferredRatio":1,"useShowMoves":true,"useNotation":true,"useAutoComplete":true,"defaultOptions":{"sounds":true,"moves":true,"notation":false,"autocomplete":false},"skins":[{"name":"skin3d","title":"3D Classic","3d":true,"preload":["smoothedfilegeo|0|/res/ring-target.js","image|/res/images/cancel.png","image|/res/images/wikipedia.png","smoothedfilegeo|0|/res/fairy/pawn/pawn.js","image|/res/fairy/pawn/pawn-diffusemap.jpg","image|/res/fairy/pawn/pawn-normalmap.jpg","smoothedfilegeo|0|/res/fairy/knight/knight.js","image|/res/fairy/knight/knight-diffusemap.jpg","image|/res/fairy/knight/knight-normalmap.jpg","smoothedfilegeo|0|/res/fairy/bishop/bishop.js","image|/res/fairy/bishop/bishop-diffusemap.jpg","image|/res/fairy/bishop/bishop-normalmap.jpg","smoothedfilegeo|0|/res/fairy/queen/queen.js","image|/res/fairy/queen/queen-diffusemap.jpg","image|/res/fairy/queen/queen-normalmap.jpg","smoothedfilegeo|0|/res/fairy/king/king.js","image|/res/fairy/king/king-diffusemap.jpg","image|/res/fairy/king/king-normalmap.jpg","smoothedfilegeo|0|/res/fairy/rook/rook.js","image|/res/fairy/rook/rook-diffusemap.jpg","image|/res/fairy/rook/rook-normalmap.jpg","smoothedfilegeo|0|/res/fairy/cardinal/cardinal.js","image|/res/fairy/cardinal/cardinal-diffusemap.jpg","image|/res/fairy/cardinal/cardinal-normalmap.jpg"],"world":{"lightIntensity":1.3,"skyLightIntensity":1.2,"lightCastShadow":true,"fog":false,"color":4686804,"lightPosition":{"x":-9,"y":9,"z":9},"skyLightPosition":{"x":9,"y":9,"z":9},"lightShadowDarkness":0.55,"ambientLightColor":2236962},"camera":{"fov":45,"distMax":50,"radius":18,"elevationAngle":60,"elevationMin":0}},{"name":"skin2d","title":"2D Classic","3d":false,"preload":["image|/res/images/cancel.png","image|/res/images/whitebg.png","image|/res/fairy/wikipedia-fairy-sprites.png"]}],"animateSelfMoves":false,"switchable":true,"sounds":{"move1":"alq_move1","move2":"alq_move2","move3":"alq_move3","move4":"alq_move2","tac1":"alq_tac1","tac2":"alq_tac2","tac3":"alq_tac1","promo":"promo","usermove":null},"js":["base-view.js","grid-board-view.js","fairy-set-view.js","capablanca-view.js"],"visuals":{"600x600":["res/visuals/janus-600x600-3d.jpg","res/visuals/janus-600x600-2d.jpg"]}}}

/***/ }),

/***/ "1r8+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.isArrayLike = (function (x) { return x && typeof x.length === 'number'; });
//# sourceMappingURL=isArrayLike.js.map

/***/ }),

/***/ "1rOO":
/***/ (function(module, exports) {

exports.model=Model={Game:{},Board:{},Move:{}},function(){var t;Model.Game.cbConstants={MASK:65535,FLAG_MOVE:65536,FLAG_CAPTURE:131072,FLAG_STOP:262144,FLAG_SCREEN_CAPTURE:524288,FLAG_CAPTURE_KING:1048576,FLAG_CAPTURE_NO_KING:2097152};var e="undefined"!=typeof Int32Array;Model.Game.cbUseTypedArrays=e,Model.Game.cbTypedArray=function(t){if(e){var r=new Int32Array(t.length);return r.set(t),r}for(var a=[],i=t.length,s=0;s<i;s++)a.push(t[s]);return a},Model.Game.cbShortRangeGraph=function(t,e,r,a){var i=this;void 0===a&&(a=196608);for(var s={},n=0;n<t.boardSize;n++)s[n]=[],(!r||n in r)&&e.forEach(function(e){var o=t.Graph(n,e);null!=o&&(!r||o in r)&&s[n].push(i.cbTypedArray([o|a]))});return s},Model.Game.cbLongRangeGraph=function(t,e,r,a,i){var s=this;void 0!==a&&null!=a||(a=196608),i||(i=1/0);for(var n={},o=0;o<t.boardSize;o++)n[o]=[],(!r||o in r)&&e.forEach(function(e){for(var h=[],p=t.Graph(o,e),c=0;null!=p&&(!r||p in r)&&(h.push(p|a),++c!=i);)p=t.Graph(p,e);h.length>0&&n[o].push(s.cbTypedArray(h))});return n},Model.Game.cbNullGraph=function(t){for(var e={},r=0;r<t.boardSize;r++)e[r]=[];return e},Model.Game.cbAuthorGraph=function(t){for(var e={},r=0;r<t.boardSize;r++){e[r]=[];for(var a=0;a<t.boardSize;a++)e[r].push([2293760|a])}return e},Model.Game.cbMergeGraphs=function(t){for(var e=[],r=0;r<t.boardSize;r++){e[r]=[];for(var a=1;a<arguments.length;a++)e[r]=e[r].concat(arguments[a][r])}return e},Model.Game.cbGetThreatGraph=function(){function t(e,r){for(var a in n){var i=n[a];if(!(i.p.length<r.length+1)){for(var s=!0,o=0;o<r.length;o++)if(r[o]!=i.p[o]){s=!1;break}if(s){var h=i.p[r.length],p=e[h];void 0===p&&(p={e:{}},e[h]=p),i.p.length==r.length+1&&(p.t=i.t,p.ts=i.ts,p.tk=i.tk,delete n[a]),r.push(h),t(p.e,r),r.pop()}}}}var e=this;this.cbUseScreenCapture=!1,this.cbUseCaptureKing=!1,this.cbUseCaptureNoKing=!1;for(var r={1:[],"-1":[]},a=[],i=0;i<this.g.boardSize;i++)this.g.pTypes.forEach(function(t,r){t.graph[i].forEach(function(t){for(var s=[],n=0;n<t.length;n++){var o=t[n];1048576&o?(e.cbUseCaptureKing=!0,s.unshift({d:65535&o,a:i,tk:r})):2097152&o?(e.cbUseCaptureNoKing=!0,s.unshift({d:65535&o,a:i,tnk:r})):131072&o?s.unshift({d:65535&o,a:i,t:r}):262144&o?s.unshift({d:65535&o,a:i}):524288&o&&(e.cbUseScreenCapture=!0,s.unshift({d:65535&o,a:i,ts:r}))}s.length>0&&a.push(s)})});var s={};a.forEach(function(t){t.forEach(function(e,r){var a=s[e.d];void 0===a&&(a={},s[e.d]=a);for(var i=[],n=r+1;n<t.length;n++)i.push(t[n].d);i.push(e.a);var o=i.join(","),h=a[o];void 0===h&&(h={p:i,t:{},ts:{},tk:{}},a[o]=h),void 0!==e.t?h.t[e.t]=!0:void 0!==e.tk?h.tk[e.tk]=!0:void 0!==e.ts&&(h.ts[e.ts]=!0)})});for(var i=0;i<e.g.boardSize;i++){var n=s[i],o={};t(o,[]),r[1][i]=o,r[-1][i]=o}return r},Model.Game.InitGame=function(){var e=this;this.cbVar=t=this.cbDefine(),this.g.boardSize=this.cbVar.geometry.boardSize,this.g.pTypes=this.cbGetPieceTypes(),this.g.threatGraph=this.cbGetThreatGraph(),this.g.distGraph=this.cbVar.geometry.GetDistances(),this.cbPiecesCount=0,this.g.castleablePiecesCount={1:0,"-1":0};for(var r in t.pieceTypes){var a=t.pieceTypes[r];if(a.castle){(a.initial||[]).forEach(function(t){e.g.castleablePiecesCount[t.s]++})}a.initial&&(this.cbPiecesCount+=a.initial.length)}for(var i=[],r=0;r<this.cbPiecesCount;r++)i.push(r);var s=Object.keys(t.pieceTypes);this.zobrist=new JocGame.Zobrist({board:{type:"array",size:this.cbVar.geometry.boardSize,values:i},who:{values:["1","-1"]},type:{type:"array",size:this.cbPiecesCount,values:s}})},Model.Game.cbGetPieceTypes=function(){for(var t=[],e={},r=0;r<this.cbVar.geometry.boardSize;r++)e[r]=[];for(var a in this.cbVar.pieceTypes){var i=this.cbVar.pieceTypes[a];t[a]={graph:i.graph||e,abbrev:i.abbrev||"",value:i.isKing?100:i.value||1,isKing:!!i.isKing,castle:!!i.castle,epTarget:!!i.epTarget,epCatch:!!i.epCatch}}return t},Model.Board.Init=function(t){this.zSign=0},Model.Board.InitialPosition=function(r){var a=this;this.board=e?new Int16Array(r.g.boardSize):[];for(var i=0;i<r.g.boardSize;i++)this.board[i]=-1;if(this.kings={},this.pieces=[],this.ending={1:!1,"-1":!1},this.lastMove=null,r.cbVar.castle&&(this.castled={1:!1,"-1":!1}),this.zSign=r.zobrist.update(0,"who",-1),this.noCaptCount=0,this.mWho=1,r.mInitial)this.mWho=r.mInitial.turn||1,r.mInitial.pieces.forEach(function(t){var e={};for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);a.pieces.push(e)}),r.mInitial.lastMove&&(this.lastMove={f:r.mInitial.lastMove.f,t:r.mInitial.lastMove.t}),void 0!==r.mInitial.noCaptCount&&(this.noCaptCount=r.mInitial.noCaptCount),r.cbVar.castle&&r.mInitial.castle&&(this.castled={1:{k:!!r.mInitial.castle[1]&&!!r.mInitial.castle[1].k,q:!!r.mInitial.castle[1]&&!!r.mInitial.castle[1].q},"-1":{k:!!r.mInitial.castle[-1]&&!!r.mInitial.castle[-1].k,q:!!r.mInitial.castle[-1]&&!!r.mInitial.castle[-1].q}});else for(var s in r.cbVar.pieceTypes)for(var n=r.cbVar.pieceTypes[s],o=n.initial||[],h=0;h<o.length;h++){var p=o[h],c={s:p.s,t:parseInt(s),p:p.p,m:!1};this.pieces.push(c)}if(this.pieces.sort(function(t,e){if(t.s!=e.s)return e.s-t.s;var a=r.cbVar.pieceTypes[t.t].value||100,i=r.cbVar.pieceTypes[e.t].value||100;return a!=i?a-i:t.p-e.p}),this.pieces.forEach(function(t,e){t.i=e,a.board[t.p]=e,r.g.pTypes[t.t].isKing&&(a.kings[t.s]=t.p),a.zSign=r.zobrist.update(a.zSign,"board",e,t.p),a.zSign=r.zobrist.update(a.zSign,"type",t.t,e)}),r.mInitial&&r.mInitial.enPassant){var i=t.geometry.PosByName(r.mInitial.enPassant);if(i>=0){var l,u=t.geometry.C(i),b=t.geometry.R(i);l=1==r.mInitial.turn?t.geometry.POS(u,b-1):t.geometry.POS(u,b+1),this.epTarget={p:i,i:this.board[l]}}}},Model.Board.CopyFrom=function(t){if(e)this.board=new Int16Array(t.board.length),this.board.set(t.board);else{this.board=[];for(var r=t.board,a=r.length,i=0;i<a;i++)this.board.push(r[i])}this.pieces=[];for(var s=t.pieces.length,i=0;i<s;i++){var n=t.pieces[i];this.pieces.push({s:n.s,p:n.p,t:n.t,i:n.i,m:n.m})}this.kings={1:t.kings[1],"-1":t.kings[-1]},this.check=t.check,t.lastMove?this.lastMove={f:t.lastMove.f,t:t.lastMove.t,c:t.lastMove.c}:this.lastMove=null,this.ending={1:t.ending[1],"-1":t.ending[-1]},void 0!==t.castled&&(this.castled={1:t.castled[1],"-1":t.castled[-1]}),this.noCaptCount=t.noCaptCount,t.epTarget?this.epTarget={p:t.epTarget.p,i:t.epTarget.i}:this.epTarget=null,this.mWho=t.mWho,this.zSign=t.zSign},Model.Board.cbApplyCastle=function(t,e,r){var a=t.cbVar.castle[e.f+"/"+e.cg],i=a.r[a.r.length-1],s=this.pieces[this.board[e.cg]],n=a.k[a.k.length-1],o=this.pieces[this.board[e.f]];return r&&(this.zSign=t.zobrist.update(this.zSign,"board",s.i,e.cg),this.zSign=t.zobrist.update(this.zSign,"board",s.i,i),this.zSign=t.zobrist.update(this.zSign,"board",o.i,e.f),this.zSign=t.zobrist.update(this.zSign,"board",o.i,n)),s.p=i,s.m=!0,this.board[e.cg]=-1,o.p=n,o.m=!0,this.board[e.f]=-1,this.board[i]=s.i,this.board[n]=o.i,this.castled[s.s]=!0,this.kings[o.s]=n,[{i:s.i,f:i,t:-1},{i:o.i,f:n,t:e.f,kp:e.f,who:o.s,m:!1},{i:s.i,f:-1,t:e.cg,m:!1,cg:!1}]},Model.Board.cbQuickApply=function(t,e){if(void 0!==e.cg)return this.cbApplyCastle(t,e,!1);var r=[],a=this.board[e.f],i=this.pieces[a];if(null!=e.c){r.unshift({i:e.c,f:-1,t:this.pieces[e.c].p});var s=this.pieces[e.c];this.board[s.p]=-1,s.p=-1}var n=this.kings[i.s];return t.g.pTypes[i.t].isKing&&(this.kings[i.s]=e.t),r.unshift({i:a,f:e.t,t:e.f,kp:n,who:i.s,ty:i.t}),i.p=e.t,void 0!==e.pr&&(i.t=e.pr),this.board[e.f]=-1,this.board[e.t]=a,r},Model.Board.cbQuickUnapply=function(t,e){for(var r=0;r<e.length;r++){var a=e[r],i=this.pieces[a.i];a.f>=0&&(i.p=-1,this.board[a.f]=-1),a.t>=0&&(i.p=a.t,this.board[a.t]=a.i),void 0!==a.m&&(i.m=a.m),void 0!==a.kp&&(this.kings[a.who]=a.kp),void 0!=a.ty&&(i.t=a.ty),void 0!=a.cg&&(this.castled[i.s]=a.cg)}},Model.Board.ApplyMove=function(t,e){var r=this.pieces[this.board[e.f]];if(void 0!==e.cg)this.cbApplyCastle(t,e,!0);else{if(this.zSign=t.zobrist.update(this.zSign,"board",r.i,e.f),this.board[r.p]=-1,void 0!==e.pr&&(this.zSign=t.zobrist.update(this.zSign,"type",r.t,r.i),r.t=e.pr,this.zSign=t.zobrist.update(this.zSign,"type",r.t,r.i)),null!=e.c){var a=this.pieces[e.c];this.zSign=t.zobrist.update(this.zSign,"board",a.i,a.p),this.board[a.p]=-1,a.p=-1,a.m=!0,this.noCaptCount=0}else this.noCaptCount++;r.p=e.t,r.m=!0,this.board[e.t]=r.i,this.zSign=t.zobrist.update(this.zSign,"board",r.i,e.t),t.g.pTypes[r.t].isKing&&(this.kings[r.s]=e.t)}this.check=!!e.ck,this.lastMove={f:e.f,t:e.t,c:e.c},void 0!==e.ko&&(this.ending[r.s]=e.ko),void 0!==e.ept?this.epTarget={p:e.ept,i:r.i}:this.epTarget=null,this.zSign=t.zobrist.update(this.zSign,"who",-this.mWho),this.zSign=t.zobrist.update(this.zSign,"who",this.mWho)},Model.Board.Evaluate=function(r){function a(e){var r=1/0;for(var a in t.geometry.corners)r=Math.min(r,h.distGraph[s.kings[e]][a]);return r-Math.sqrt(h.boardSize)}var i="debug"==arguments[3],s=this;this.mEvaluation=0;var n,o=this.mWho,h=r.g;if(e)n={1:{count:new Uint8Array(h.pTypes.length),byType:{}},"-1":{count:new Uint8Array(h.pTypes.length),byType:{}}};else{n={1:{count:[],byType:{}},"-1":{count:[],byType:{}}};for(var p=0;p<h.pTypes.length;p++)n[1].count[p]=n[-1].count[p]=0}if(r.mOptions.preventRepeat&&r.GetRepeatOccurence(this)>2)return this.mFinished=!0,void(this.mWinner=r.cbOnPerpetual?o*r.cbOnPerpetual:JocGame.DRAW);for(var c={1:0,"-1":0},l={1:h.distGraph[this.kings[-1]],"-1":h.distGraph[this.kings[1]]},u={1:0,"-1":0},b={1:0,"-1":0},v={1:0,"-1":0},f={1:0,"-1":0},g={1:!1,"-1":!1},d=this.pieces,m=d.length,p=0;p<m;p++){var G=d[p];if(G.p>=0){var y=G.s,M=h.pTypes[G.t];M.isKing?g[y]=G.m:c[y]+=M.value,M.castle&&!G.m&&f[y]++,b[y]++,u[y]+=l[y][G.p],v[y]+=t.geometry.distEdge[G.p];var C=n[y];C.count[G.t]++;var S=C.byType;void 0===S[G.t]?S[G.t]=[G]:S[G.t].push(G)}}if(this.lastMove&&null!=this.lastMove.c){var G=this.pieces[this.board[this.lastMove.t]];c[-G.s]+=this.cbStaticExchangeEval(r,G.p,G.s,{piece:G})}var k={1:0,"-1":0},A={1:0,"-1":0},T={1:0,"-1":0};this.ending[1]&&(A[1]=(u[1]-Math.sqrt(h.boardSize))/b[1],t.geometry.corners&&(T[1]=a(1))),this.ending[-1]&&(A[-1]=(u[-1]-Math.sqrt(h.boardSize))/b[-1],t.geometry.corners&&(T[1]=a(-1)));var z={pieceValue:c[1]-c[-1],pieceValueRatio:(c[1]-c[-1])/(c[1]+c[-1]+1),posValue:v[1]-v[-1],averageDistKing:u[1]/b[1]-u[-1]/b[-1],check:this.check?-o:0,endingKingFreedom:k[1]-k[-1],endingDistKing:A[1]-A[-1],distKingCorner:T[1]-T[-1]};t.castle&&(z.castle=(this.castled[1]?1:g[1]?0:f[1]/(h.castleablePiecesCount[1]+1))-(this.castled[-1]?1:g[-1]?0:f[-1]/(h.castleablePiecesCount[-1]+1))),t.evaluate&&t.evaluate.call(this,r,z,n);var E=r.mOptions.levelOptions;for(var P in z){var w=z[P],R=E[P+"Factor"]||0,I=w*R;i&&console.log(P,"=",w,"*",R,"=>",I),this.mEvaluation+=I}i&&console.log("Evaluation",this.mEvaluation)},Model.Board.cbGeneratePseudoLegalMoves=function(t){function e(e,i){var s=t.cbVar.promote;if(!s)return void a.push(i);var n=s.call(r,t,e,i);if(null!=n)if(0==n.length)a.push(i);else if(1==n.length)i.pr=n[0],a.push(i);else for(var o=0;o<n.length;o++){var h=n[o];a.push({f:i.f,t:i.t,c:i.c,pr:h,ept:i.ept,ep:i.ep,a:i.a})}}for(var r=this,a=[],i=t.cbVar,s=this.mWho,n=!i.castle||this.check||this.castled[s]?null:[],o=-1,h=this.pieces.length,p=0;p<h;p++){var c=this.pieces[p];if(!(c.p<0||c.s!=s)){var l=t.g.pTypes[c.t];l.isKing&&(c.m?n=null:o=c),n&&l.castle&&!c.m&&n.push(c);var u,b;u=l.graph[c.p],b=u.length;for(var v=0;v<b;v++)for(var f=u[v],g=!1,d=f.length,m=null,G=0;G<d;G++){var y=f[G],M=65535&y,C=this.board[M];if(!(C<0)||l.epCatch&&this.epTarget&&this.epTarget.p==M){if(!(524288&y)){var S;S=C<0?this.pieces[this.epTarget.i]:this.pieces[C],!(S.s!=c.s&&131072&y)||1048576&y&&!t.g.pTypes[S.t].isKing||2097152&y&&t.g.pTypes[S.t].isKing||e(c,{f:c.p,t:M,c:S.i,a:l.abbrev,ep:C<0});break}if(g){var S=this.pieces[C];S.s!=c.s&&e(c,{f:c.p,t:M,c:S.i,a:l.abbrev});break}g=!0}else 65536&y&&0==g&&e(c,{f:c.p,t:M,c:null,a:l.abbrev,ept:null!=m&&l.epTarget?m:void 0});m=M}}}if(n)for(var p=0;p<n.length;p++){var k=n[p],A=t.cbVar.castle[o.p+"/"+k.p];if(A){for(var T=!0,v=0;v<A.r.length;v++){var z=A.r[v];if(this.board[z]>=0&&z!=o.p&&z!=k.p){T=!1;break}}if(T){for(var E=!0,v=0;v<A.k.length;v++){var z=A.k[v];if(this.board[z]>=0&&z!=k.p&&z!=o.p||this.cbGetAttackers(t,z,s).length>0){E=!1;break}}E&&a.push({f:o.p,t:A.k[A.k.length-1],c:null,cg:k.p})}}}return a},Model.Board.cbStaticExchangeEval=function(t,e,r,a){var i=0,s=this.cbGetSmallestAttacker(t,e,r);if(s){var n=this.mWho;this.mWho=s.s;var o=this.cbQuickApply(t,{f:s.p,t:e,c:a.piece.i}),h=t.g.pTypes[a.piece.t].value;a.piece=s,i=Math.max(0,h-this.cbStaticExchangeEval(t,e,-r,a)),this.cbQuickUnapply(t,o),this.mWho=n}return i},Model.Board.cbGetSmallestAttacker=function(t,e,r){var a=this.cbGetAttackers(t,e,r);if(0==a.length)return null;for(var i=1/0,s=null,n=a.length,o=0;o<n;o++){var h=a[o],p=t.g.pTypes[h.t].value;p<i&&(i=p,s=h)}return s},Model.Board.cbCollectAttackers=function(t,e,r,a){for(var i in e){var s=e[i],n=this.board[i];if(n<0)this.cbCollectAttackers(t,s.e,r,a);else{var o=this.pieces[n];o.s==-t&&(s.t&&o.t in s.t||a&&s.tk&&o.t in s.tk)&&r.push(o)}}},Model.Board.cbCollectAttackersScreen=function(t,e,r,a,i){for(var s in e){var n=e[s],o=this.board[s];if(o<0)this.cbCollectAttackersScreen(t,n.e,r,a,i);else{var h=this.pieces[o];!i&&h.s==-t&&(n.t&&h.t in n.t||a&&n.tk&&h.t in n.tk)?r.push(h):i?i&&h.s==-t&&n.ts&&h.t in n.ts&&r.push(h):this.cbCollectAttackersScreen(t,n.e,r,a,!0)}}},Model.Board.cbGetAttackers=function(t,e,r,a){var i=[];return t.cbUseScreenCapture?this.cbCollectAttackersScreen(r,t.g.threatGraph[r][e],i,a,!1):this.cbCollectAttackers(r,t.g.threatGraph[r][e],i,a),i},Model.Board.GenerateMoves=function(t){var e=this.cbGeneratePseudoLegalMoves(t);this.mMoves=[];for(var r=!0,a=this.kings[this.mWho],i=e.length,s=0;s<i;s++){var n=e[s],o=this.cbQuickApply(t,n);if(!(this.cbGetAttackers(t,this.kings[this.mWho],this.mWho,!0).length>0)){var h=this.cbGetAttackers(t,this.kings[-this.mWho],-this.mWho,!0).length>0;n.ck=h,this.mMoves.push(n),n.f!=a&&(r=!1)}this.cbQuickUnapply(t,o)}if(0==this.mMoves.length)this.mFinished=!0,this.mWinner=t.cbOnStaleMate?t.cbOnStaleMate*this.mWho:JocGame.DRAW,this.check&&(this.mWinner=-this.mWho);else if(this.ending[this.mWho]){if(!r)for(var s=0;s<this.mMoves.length;s++)this.mMoves[s].ko=!1}else if(!this.ending[this.mWho]&&r&&!this.check)for(var s=0;s<this.mMoves.length;s++)this.mMoves[s].ko=!0},Model.Board.GetSignature=function(){return this.zSign},Model.Move.Init=function(t){for(var e in t)t.hasOwnProperty(e)&&(this[e]=t[e])},Model.Move.Equals=function(t){return this.f==t.f&&this.t==t.t&&this.pr==t.pr},Model.Move.CopyFrom=function(t){this.Init(t)},Model.Move.ToString=function(e){var r=this;switch(e=e||"natural"){case"natural":return function(){var e;if(void 0!==r.cg?e=t.castle[r.f+"/"+r.cg].n:(e=r.a||"",e+=t.geometry.PosName(r.f),null==r.c?e+="-":e+="x",e+=t.geometry.PosName(r.t)),void 0!==r.pr){var a=t.pieceTypes[r.pr];a&&a.abbrev&&a.abbrev.length>0&&!a.silentPromo&&(e+="="+a.abbrev)}return r.ck&&(e+="+"),e}();case"engine":return function(){var e=t.geometry.PosName(r.f)+t.geometry.PosName(r.t);if(void 0!=r.pr){var a=t.pieceTypes[r.pr];a&&a.abbrev&&a.abbrev.length>0&&!a.silentPromo&&(e+=a.abbrev)}return e}();default:return"??"}},Model.Board.CompactMoveString=function(e,r,a){"function"!=typeof r.ToString&&(r=e.CreateMove(r));var i=r.ToString(),s=/^([A-Z]?)([a-z])([1-9][0-9]*)([-x])([a-z])([1-9][0-9]*)(.*?)$/.exec(i);if(!s)return i;var n=s[7];if(a||(a={}),a.value||(a.value=[]),0==a.value.length){var o=this.mMoves;this.mMoves&&0!=this.mMoves.length||this.GenerateMoves(e);for(var h=0;h<this.mMoves.length;h++){var p=this.mMoves[h];"function"!=typeof p.ToString&&(p=e.CreateMove(p)),a.value.push({str:p.ToString(),move:p})}this.mMoves=o}var c=[];if(a.value.forEach(function(t){var e=/^([A-Z]?[a-z][1-9][0-9]*[-x][a-z][1-9][0-9]*)(.*?)$/.exec(t.str);e&&t.move.t==r.t&&(t.move.a||"")==s[1]&&e[2]==n&&c.push(t.move)}),1==c.length)return""==s[1]&&"x"==s[4]?s[2]+"x"+s[5]+s[6]+s[7]:s[1]+("x"==s[4]?"x":"")+s[5]+s[6]+s[7];if(t.geometry.CompactCrit)for(var l="",h=0;;h++){var u=t.geometry.CompactCrit(r.f,h);if(null==u)return i;l+=u;for(var b=[],v=0;v<c.length;v++){var f=c[v];t.geometry.CompactCrit(f.f,h)==u&&b.push(f)}if(console.assert(b.length>0),1==b.length)return s[1]+l+("x"==s[4]?"x":"")+s[5]+s[6]+s[7];c=b}return i},Model.Board.cbIntegrity=function(t){function e(t,e){t||console.error(e)}for(var r=this,a=0;a<this.board.length;a++){var i=this.board[a];if(i>=0){var s=r.pieces[i];e(void 0!==s,"no piece at pos"),e(s.p==a,"piece has different pos")}}for(var i=0;i<this.pieces.length;i++){var s=this.pieces[i];s.p>=0&&e(r.board[s.p]==i,"board index mismatch")}},Model.Board.ExportBoardState=function(t){return t.cbVar.geometry.ExportBoardState?t.cbVar.geometry.ExportBoardState(this,t.cbVar,t.mPlayedMoves.length):"not supported"},Model.Game.Import=function(e,r){var a,i=[],s={1:{},"-1":{}},n=null,o=0;if("pjn"==e){var h={status:!1,error:"parse"},p=r.split(" ");if(6!=p.length)return console.warn("FEN should have 6 parts"),h;var c=p[0].split("/"),l=t.geometry.fenHeight||t.geometry.height;if(c.length!=l)return console.warn("FEN board should have",l,"rows, got",c.length),h;var u={};for(var b in t.pieceTypes){var v=t.pieceTypes[b],f=v.fenAbbrev||v.abbrev||"X";u[f.toUpperCase()]={s:1,t:b},u[f.toLowerCase()]={s:-1,t:b}}var g=t.geometry.FenRowPos||function(e,r){return(t.geometry.height-1-e)*t.geometry.width+r};if(c.forEach(function(e,r){for(var a=0,s=0;s<e.length;s++){var n=e.substr(s,1),o=u[n];if(void 0!==o){var p=g(r,a);a++;for(var c={s:o.s,t:o.t,p:p},l=!0,b=t.pieceTypes[c.t].initial||[],v=0;v<b.length;v++){var f=b[v];f.s==c.s&&f.p==p&&(l=!1)}c.m=l,i.push(c)}else{if(isNaN(parseInt(n)))return console.warn("FEN invalid board spec",n),h;a+=parseInt(n)}}}),i.sort(function(t,e){return e.s-t.s}),"w"==p[1])a=1;else{if("b"!=p[1])return console.warn("FEN invalid turn spec",p[1]),h;a=-1}s[1].k=p[2].indexOf("K")>=0,s[1].q=p[2].indexOf("Q")>=0,s[-1].k=p[2].indexOf("k")>=0,s[-1].q=p[2].indexOf("q")>=0,n="-"==p[3]?null:p[3];var d=parseInt(p[4]);isNaN(d)||(o=d);var m={pieces:i,turn:a,castle:s,enPassant:n,noCaptCount:o};return t.importGame&&t.importGame.call(this,m,e,r),{status:!0,initial:m}}return{status:!1,error:"unsupported"}}}(),function(){Model.Game.cbBoardGeometryGrid=function(t,e){function r(e){return e%t}function a(e){return Math.floor(e/t)}function i(e,r){return r*t+e}function s(s,n){var o=r(s),h=a(s),p=o+n[0],c=h+n[1];return p<0||p>=t||c<0||c>=e?null:i(p,c)}function n(t){return String.fromCharCode("a".charCodeAt(0)+r(t))+(a(t)+1)}function o(t){var e=/^([a-z])([0-9]+)$/.exec(t);return e?i(e[1].charCodeAt(0)-"a".charCodeAt(0),parseInt(e[2])-1):-1}function h(t,e){return 0==e?String.fromCharCode("a".charCodeAt(0)+r(t)):1==e?a(t)+1:null}function p(){for(var i=[],s=0;s<t*e;s++){var n=[];i.push(n);for(var o=0;o<t*e;o++){var h=a(s),p=r(s),c=a(o),l=r(o);n.push(Math.max(Math.abs(h-c),Math.abs(p-l)))}}return i}function c(r,a,s){for(var o=[],h=e-1;h>=0;h--){for(var p="",c=0,l=0;l<t;l++){var u=r.board[i(l,h)];if(u<0)c++;else{c>0&&(p+=c,c=0);var b=r.pieces[u],v=a.pieceTypes[b.t].fenAbbrev||a.pieceTypes[b.t].abbrev||"?";b.s==-1?p+=v.toLowerCase():p+=v.toUpperCase()}}c&&(p+=c),o.push(p)}var f=o.join("/");f+=" ",1==r.mWho?f+="w":f+="b",f+=" ";var g="";return r.castled&&(r.castled[1]===!1?g+="KQ":(r.castled[1].k&&(g+="K"),r.castled[1].q&&(g+="Q")),r.castled[-1]===!1?g+="kq":(r.castled[-1].k&&(g+="k"),r.castled[-1].q&&(g+="q"))),0==g.length&&(g="-"),f+=g,f+=" ",r.epTarget?f+=n(r.epTarget.p):f+="-",f+=" ",f+=r.noCaptCount,f+=" ",f+=Math.floor(s/2)+1}return{boardSize:t*e,width:t,height:e,C:r,R:a,POS:i,Graph:s,PosName:n,PosByName:o,CompactCrit:h,GetDistances:p,distEdge:function(){for(var i=[],s=0;s<t*e;s++){var n=r(s),o=a(s);i[s]=Math.min(n,Math.abs(t-n-1),o,Math.abs(e-o-1))}return i}(),corners:function(){var r={};return r[i(0,0)]=1,r[i(0,e-1)]=1,r[i(t-1,0)]=1,r[i(t-1,e-1)]=1,r}(),ExportBoardState:c}},Model.Game.cbPawnGraph=function(t,e,r){for(var a=this,i={},s=0;s<t.boardSize;s++)if(!r||s in r){var n=[],o=t.Graph(s,[0,e]);null!=o&&(!r||o in r)&&n.push(a.cbTypedArray([o|a.cbConstants.FLAG_MOVE])),[-1,1].forEach(function(i){var o=t.Graph(s,[i,e]);null!=o&&(!r||o in r)&&n.push(a.cbTypedArray([o|a.cbConstants.FLAG_CAPTURE]))}),i[s]=n}else i[s]=[];return i},Model.Game.cbInitialPawnGraph=function(t,e,r){for(var a=this,i={},s=0;s<t.boardSize;s++)if(!r||s in r){var n=[],o=t.Graph(s,[0,e]);if(null!=o&&(!r||o in r)){var h=[o|a.cbConstants.FLAG_MOVE],p=t.Graph(o,[0,e]);null!=p&&(!r||p in r)&&h.push(p|a.cbConstants.FLAG_MOVE),n.push(a.cbTypedArray(h))}[-1,1].forEach(function(i){var o=t.Graph(s,[i,e]);null!=o&&(!r||o in r)&&n.push(a.cbTypedArray([o|a.cbConstants.FLAG_CAPTURE]))}),i[s]=n}else i[s]=[];return i},Model.Game.cbKingGraph=function(t,e){return this.cbShortRangeGraph(t,[[-1,-1],[-1,0],[-1,1],[0,-1],[0,1],[1,-1],[1,0],[1,1]],e)},Model.Game.cbKnightGraph=function(t,e){return this.cbShortRangeGraph(t,[[2,-1],[2,1],[-2,-1],[-2,1],[-1,2],[-1,-2],[1,2],[1,-2]],e)},Model.Game.cbHorseGraph=function(t){for(var e=this,r={},a=0;a<t.boardSize;a++)r[a]=[],[[1,0,2,-1],[1,0,2,1],[-1,0,-2,-1],[-1,0,-2,1],[0,1,-1,2],[0,-1,-1,-2],[0,1,1,2],[0,-1,1,-2]].forEach(function(i){var s=t.Graph(a,[i[0],i[1]]);if(null!=s){var n=t.Graph(a,[i[2],i[3]]);null!=n&&r[a].push(e.cbTypedArray([s|e.cbConstants.FLAG_STOP,n|e.cbConstants.FLAG_MOVE|e.cbConstants.FLAG_CAPTURE]))}});return r},Model.Game.cbRookGraph=function(t,e){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0]],e)},Model.Game.cbBishopGraph=function(t,e){return this.cbLongRangeGraph(t,[[1,-1],[1,1],[-1,1],[-1,-1]],e)},Model.Game.cbQueenGraph=function(t,e){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0],[1,-1],[1,1],[-1,1],[-1,-1]],e)},Model.Game.cbXQGeneralGraph=function(t,e){for(var r=this,a={},i=0;i<t.boardSize;i++)a[i]=[],[[-1,0,!1],[0,-1,!0],[0,1,!0],[1,0,!1]].forEach(function(s){var n=[],o=t.Graph(i,s);if(null!=o&&((!e||o in e)&&n.push(o|r.cbConstants.FLAG_MOVE|r.cbConstants.FLAG_CAPTURE),s[2]))for(var h=t.Graph(o,s);null!=h;)!e||h in e?n.push(h|r.cbConstants.FLAG_CAPTURE|r.cbConstants.FLAG_CAPTURE_KING):n.push(h|r.cbConstants.FLAG_STOP),h=t.Graph(h,s);n.length>0&&a[i].push(r.cbTypedArray(n))});return a},Model.Game.cbXQSoldierGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e]])},Model.Game.cbXQPromoSoldierGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e],[-1,0],[1,0]])},Model.Game.cbXQAdvisorGraph=function(t,e){return this.cbShortRangeGraph(t,[[1,1],[-1,1],[1,-1],[-1,-1]],e)},Model.Game.cbXQCannonGraph=function(t){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0]],null,this.cbConstants.FLAG_MOVE|this.cbConstants.FLAG_SCREEN_CAPTURE)},Model.Game.cbXQElephantGraph=function(t,e){for(var r=this,a={},i=0;i<t.boardSize;i++)a[i]=[],(!e||i in e)&&[[1,1,2,2],[1,-1,2,-2],[-1,1,-2,2],[-1,-1,-2,-2]].forEach(function(s){var n=t.Graph(i,[s[0],s[1]]);if(null!=n){var o=t.Graph(i,[s[2],s[3]]);null!=o&&(!e||o in e)&&a[i].push(r.cbTypedArray([n|r.cbConstants.FLAG_STOP,o|r.cbConstants.FLAG_MOVE|r.cbConstants.FLAG_CAPTURE]))}});return a},Model.Game.cbSilverGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e],[-1,-1],[-1,1],[1,-1],[1,1]])},Model.Game.cbFersGraph=function(t,e){return this.cbShortRangeGraph(t,[[-1,-1],[-1,1],[1,-1],[1,1]])},Model.Game.cbSchleichGraph=function(t,e){return this.cbShortRangeGraph(t,[[-1,0],[1,0],[0,-1],[0,1]])},Model.Game.cbAlfilGraph=function(t,e){return this.cbShortRangeGraph(t,[[-2,-2],[-2,2],[2,2],[2,-2]])}}(),function(){function t(t,r){return t.cbMergeGraphs(e,t.cbLongRangeGraph(e,[[0,r]],null,t.cbConstants.FLAG_MOVE,3),t.cbShortRangeGraph(e,[[-1,r],[1,r]],null,t.cbConstants.FLAG_CAPTURE))}var e=Model.Game.cbBoardGeometryGrid(14,10);Model.Game.cbDefine=function(){return{geometry:e,pieceTypes:{0:{name:"pawn-w",aspect:"fr-pawn",graph:this.cbPawnGraph(e,1),value:.7,abbrev:"",fenAbbrev:"P",epCatch:!0},1:{name:"ipawn-w",aspect:"fr-pawn",graph:this.cbInitialPawnGraph(e,1),value:.7,abbrev:"",fenAbbrev:"P",epTarget:!0},2:{name:"pawn-b",aspect:"fr-pawn",graph:this.cbPawnGraph(e,-1),value:.7,abbrev:"",fenAbbrev:"P",epCatch:!0},3:{name:"ipawn-b",aspect:"fr-pawn",graph:this.cbInitialPawnGraph(e,-1),value:.7,abbrev:"",fenAbbrev:"P",epTarget:!0},4:{name:"knight",aspect:"fr-knight",graph:this.cbKnightGraph(e),value:2.2,abbrev:"N",initial:[{s:1,p:2},{s:1,p:3},{s:1,p:11},{s:-1,p:128},{s:-1,p:129},{s:-1,p:137}]},5:{name:"bishop",aspect:"fr-bishop",graph:this.cbBishopGraph(e),value:3.3,abbrev:"B",initial:[{s:1,p:4},{s:1,p:5},{s:1,p:9},{s:1,p:10},{s:-1,p:130},{s:-1,p:131},{s:-1,p:135},{s:-1,p:136}]},6:{name:"rook",aspect:"fr-rook",graph:this.cbRookGraph(e),value:5,abbrev:"R",initial:[{s:1,p:0},{s:1,p:13},{s:-1,p:126},{s:-1,p:139}]},7:{name:"queen",aspect:"fr-queen",graph:this.cbQueenGraph(e),value:8.1,abbrev:"Q",initial:[{s:1,p:6},{s:-1,p:132}]},8:{name:"king",aspect:"fr-king",isKing:!0,graph:this.cbKingGraph(e),abbrev:"K",initial:[{s:1,p:7},{s:-1,p:133}]},9:{name:"concubine",aspect:"fr-marshall",graph:this.cbMergeGraphs(e,this.cbRookGraph(e),this.cbKnightGraph(e)),value:7.1,abbrev:"C",initial:[{s:1,p:8},{s:-1,p:134}]},10:{name:"crowned-rook",aspect:"fr-crowned-rook",graph:this.cbMergeGraphs(e,this.cbRookGraph(e),this.cbShortRangeGraph(e,[[-1,-1],[-1,1],[1,1],[1,-1]])),value:6.2,abbrev:"CR",initial:[{s:1,p:1},{s:1,p:12},{s:-1,p:127},{s:-1,p:138}]},11:{name:"iipawn-w",aspect:"fr-pawn",graph:t(this,1),value:1,abbrev:"",fenAbbrev:"P",initial:[{s:1,p:14},{s:1,p:15},{s:1,p:16},{s:1,p:17},{s:1,p:18},{s:1,p:19},{s:1,p:20},{s:1,p:21},{s:1,p:22},{s:1,p:23},{s:1,p:24},{s:1,p:25},{s:1,p:26},{s:1,p:27}],epTarget:!0},12:{name:"iipawn-b",aspect:"fr-pawn",graph:t(this,-1),value:1,abbrev:"",fenAbbrev:"P",initial:[{s:-1,p:112},{s:-1,p:113},{s:-1,p:114},{s:-1,p:115},{s:-1,p:116},{s:-1,p:117},{s:-1,p:118},{s:-1,p:119},{s:-1,p:120},{s:-1,p:121},{s:-1,p:122},{s:-1,p:123},{s:-1,p:124},{s:-1,p:125}],epTarget:!0}},promote:function(t,r,a){if(11==r.t||12==r.t){return 1==Math.abs(e.R(a.t)-e.R(a.f))?[11==r.t?1:3]:[11==r.t?0:2]}return 1==r.t?[0]:3==r.t?[2]:0==r.t&&9==e.R(a.t)?[4,5,6,7,9,10]:2==r.t&&0==e.R(a.t)?[4,5,6,7,9,10]:[]}}}}();

/***/ }),

/***/ "2395":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var isEmpty_1 = __webpack_require__("9TuE");
Observable_1.Observable.prototype.isEmpty = isEmpty_1.isEmpty;
//# sourceMappingURL=isEmpty.js.map

/***/ }),

/***/ "2AEF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var OuterSubscriber_1 = __webpack_require__("wAkD");
var subscribeToResult_1 = __webpack_require__("CURp");
/* tslint:enable:max-line-length */
/**
 * Projects each source value to an Observable which is merged in the output
 * Observable only if the previous projected Observable has completed.
 *
 * <span class="informal">Maps each value to an Observable, then flattens all of
 * these inner Observables using {@link exhaust}.</span>
 *
 * <img src="./img/exhaustMap.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an (so-called "inner") Observable. When it projects a source value to
 * an Observable, the output Observable begins emitting the items emitted by
 * that projected Observable. However, `exhaustMap` ignores every new projected
 * Observable if the previous projected Observable has not yet completed. Once
 * that one completes, it will accept and flatten the next projected Observable
 * and repeat this process.
 *
 * @example <caption>Run a finite timer for each click, only if there is no currently active timer</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.exhaustMap((ev) => Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link concatMap}
 * @see {@link exhaust}
 * @see {@link mergeMap}
 * @see {@link switchMap}
 *
 * @param {function(value: T, ?index: number): ObservableInput} project A function
 * that, when applied to an item emitted by the source Observable, returns an
 * Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} An Observable containing projected Observables
 * of each item of the source, ignoring projected Observables that start before
 * their preceding Observable has completed.
 * @method exhaustMap
 * @owner Observable
 */
function exhaustMap(project, resultSelector) {
    return this.lift(new SwitchFirstMapOperator(project, resultSelector));
}
exports.exhaustMap = exhaustMap;
var SwitchFirstMapOperator = (function () {
    function SwitchFirstMapOperator(project, resultSelector) {
        this.project = project;
        this.resultSelector = resultSelector;
    }
    SwitchFirstMapOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new SwitchFirstMapSubscriber(subscriber, this.project, this.resultSelector));
    };
    return SwitchFirstMapOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var SwitchFirstMapSubscriber = (function (_super) {
    __extends(SwitchFirstMapSubscriber, _super);
    function SwitchFirstMapSubscriber(destination, project, resultSelector) {
        _super.call(this, destination);
        this.project = project;
        this.resultSelector = resultSelector;
        this.hasSubscription = false;
        this.hasCompleted = false;
        this.index = 0;
    }
    SwitchFirstMapSubscriber.prototype._next = function (value) {
        if (!this.hasSubscription) {
            this.tryNext(value);
        }
    };
    SwitchFirstMapSubscriber.prototype.tryNext = function (value) {
        var index = this.index++;
        var destination = this.destination;
        try {
            var result = this.project(value, index);
            this.hasSubscription = true;
            this.add(subscribeToResult_1.subscribeToResult(this, result, value, index));
        }
        catch (err) {
            destination.error(err);
        }
    };
    SwitchFirstMapSubscriber.prototype._complete = function () {
        this.hasCompleted = true;
        if (!this.hasSubscription) {
            this.destination.complete();
        }
    };
    SwitchFirstMapSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        var _a = this, resultSelector = _a.resultSelector, destination = _a.destination;
        if (resultSelector) {
            this.trySelectResult(outerValue, innerValue, outerIndex, innerIndex);
        }
        else {
            destination.next(innerValue);
        }
    };
    SwitchFirstMapSubscriber.prototype.trySelectResult = function (outerValue, innerValue, outerIndex, innerIndex) {
        var _a = this, resultSelector = _a.resultSelector, destination = _a.destination;
        try {
            var result = resultSelector(outerValue, innerValue, outerIndex, innerIndex);
            destination.next(result);
        }
        catch (err) {
            destination.error(err);
        }
    };
    SwitchFirstMapSubscriber.prototype.notifyError = function (err) {
        this.destination.error(err);
    };
    SwitchFirstMapSubscriber.prototype.notifyComplete = function (innerSub) {
        this.remove(innerSub);
        this.hasSubscription = false;
        if (this.hasCompleted) {
            this.destination.complete();
        }
    };
    return SwitchFirstMapSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=exhaustMap.js.map

/***/ }),

/***/ "2ER/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var MapPolyfill = (function () {
    function MapPolyfill() {
        this.size = 0;
        this._values = [];
        this._keys = [];
    }
    MapPolyfill.prototype.get = function (key) {
        var i = this._keys.indexOf(key);
        return i === -1 ? undefined : this._values[i];
    };
    MapPolyfill.prototype.set = function (key, value) {
        var i = this._keys.indexOf(key);
        if (i === -1) {
            this._keys.push(key);
            this._values.push(value);
            this.size++;
        }
        else {
            this._values[i] = value;
        }
        return this;
    };
    MapPolyfill.prototype.delete = function (key) {
        var i = this._keys.indexOf(key);
        if (i === -1) {
            return false;
        }
        this._values.splice(i, 1);
        this._keys.splice(i, 1);
        this.size--;
        return true;
    };
    MapPolyfill.prototype.clear = function () {
        this._keys.length = 0;
        this._values.length = 0;
        this.size = 0;
    };
    MapPolyfill.prototype.forEach = function (cb, thisArg) {
        for (var i = 0; i < this.size; i++) {
            cb.call(thisArg, this._values[i], this._keys[i]);
        }
    };
    return MapPolyfill;
}());
exports.MapPolyfill = MapPolyfill;
//# sourceMappingURL=MapPolyfill.js.map

/***/ }),

/***/ "2Je8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("3j3K");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgLocaleLocalization", function() { return NgLocaleLocalization; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgLocalization", function() { return NgLocalization; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CommonModule", function() { return CommonModule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgClass", function() { return NgClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgFor", function() { return NgFor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgForOf", function() { return NgForOf; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgForOfContext", function() { return NgForOfContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgIf", function() { return NgIf; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgIfContext", function() { return NgIfContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgPlural", function() { return NgPlural; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgPluralCase", function() { return NgPluralCase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgStyle", function() { return NgStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgSwitch", function() { return NgSwitch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgSwitchCase", function() { return NgSwitchCase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgSwitchDefault", function() { return NgSwitchDefault; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgTemplateOutlet", function() { return NgTemplateOutlet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgComponentOutlet", function() { return NgComponentOutlet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AsyncPipe", function() { return AsyncPipe; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DatePipe", function() { return DatePipe; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I18nPluralPipe", function() { return I18nPluralPipe; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I18nSelectPipe", function() { return I18nSelectPipe; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "JsonPipe", function() { return JsonPipe; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LowerCasePipe", function() { return LowerCasePipe; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CurrencyPipe", function() { return CurrencyPipe; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DecimalPipe", function() { return DecimalPipe; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PercentPipe", function() { return PercentPipe; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SlicePipe", function() { return SlicePipe; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UpperCasePipe", function() { return UpperCasePipe; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TitleCasePipe", function() { return TitleCasePipe; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵPLATFORM_BROWSER_ID", function() { return PLATFORM_BROWSER_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵPLATFORM_SERVER_ID", function() { return PLATFORM_SERVER_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵPLATFORM_WORKER_APP_ID", function() { return PLATFORM_WORKER_APP_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵPLATFORM_WORKER_UI_ID", function() { return PLATFORM_WORKER_UI_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isPlatformBrowser", function() { return isPlatformBrowser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isPlatformServer", function() { return isPlatformServer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isPlatformWorkerApp", function() { return isPlatformWorkerApp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isPlatformWorkerUi", function() { return isPlatformWorkerUi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VERSION", function() { return VERSION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PlatformLocation", function() { return PlatformLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LOCATION_INITIALIZED", function() { return LOCATION_INITIALIZED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LocationStrategy", function() { return LocationStrategy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "APP_BASE_HREF", function() { return APP_BASE_HREF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HashLocationStrategy", function() { return HashLocationStrategy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PathLocationStrategy", function() { return PathLocationStrategy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Location", function() { return Location; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵa", function() { return COMMON_DIRECTIVES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵb", function() { return COMMON_PIPES; });
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * @license Angular v4.1.0
 * (c) 2010-2017 Google, Inc. https://angular.io/
 * License: MIT
 */

/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * This class should not be used directly by an application developer. Instead, use
 * {\@link Location}.
 *
 * `PlatformLocation` encapsulates all calls to DOM apis, which allows the Router to be platform
 * agnostic.
 * This means that we can have different implementation of `PlatformLocation` for the different
 * platforms
 * that angular supports. For example, the default `PlatformLocation` is {\@link
 * BrowserPlatformLocation},
 * however when you run your app in a WebWorker you use {\@link WebWorkerPlatformLocation}.
 *
 * The `PlatformLocation` class is used directly by all implementations of {\@link LocationStrategy}
 * when
 * they need to interact with the DOM apis like pushState, popState, etc...
 *
 * {\@link LocationStrategy} in turn is used by the {\@link Location} service which is used directly
 * by
 * the {\@link Router} in order to navigate between routes. Since all interactions between {\@link
 * Router} /
 * {\@link Location} / {\@link LocationStrategy} and DOM apis flow through the `PlatformLocation`
 * class
 * they are all platform independent.
 *
 * \@stable
 * @abstract
 */
var PlatformLocation = (function () {
    function PlatformLocation() {
    }
    /**
     * @abstract
     * @return {?}
     */
    PlatformLocation.prototype.getBaseHrefFromDOM = function () { };
    /**
     * @abstract
     * @param {?} fn
     * @return {?}
     */
    PlatformLocation.prototype.onPopState = function (fn) { };
    /**
     * @abstract
     * @param {?} fn
     * @return {?}
     */
    PlatformLocation.prototype.onHashChange = function (fn) { };
    /**
     * @abstract
     * @return {?}
     */
    PlatformLocation.prototype.pathname = function () { };
    /**
     * @abstract
     * @return {?}
     */
    PlatformLocation.prototype.search = function () { };
    /**
     * @abstract
     * @return {?}
     */
    PlatformLocation.prototype.hash = function () { };
    /**
     * @abstract
     * @param {?} state
     * @param {?} title
     * @param {?} url
     * @return {?}
     */
    PlatformLocation.prototype.replaceState = function (state, title, url) { };
    /**
     * @abstract
     * @param {?} state
     * @param {?} title
     * @param {?} url
     * @return {?}
     */
    PlatformLocation.prototype.pushState = function (state, title, url) { };
    /**
     * @abstract
     * @return {?}
     */
    PlatformLocation.prototype.forward = function () { };
    /**
     * @abstract
     * @return {?}
     */
    PlatformLocation.prototype.back = function () { };
    return PlatformLocation;
}());
/**
 * \@whatItDoes indicates when a location is initialized
 * \@experimental
 */
var LOCATION_INITIALIZED = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["InjectionToken"]('Location Initialized');
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * `LocationStrategy` is responsible for representing and reading route state
 * from the browser's URL. Angular provides two strategies:
 * {\@link HashLocationStrategy} and {\@link PathLocationStrategy}.
 *
 * This is used under the hood of the {\@link Location} service.
 *
 * Applications should use the {\@link Router} or {\@link Location} services to
 * interact with application route state.
 *
 * For instance, {\@link HashLocationStrategy} produces URLs like
 * `http://example.com#/foo`, and {\@link PathLocationStrategy} produces
 * `http://example.com/foo` as an equivalent URL.
 *
 * See these two classes for more.
 *
 * \@stable
 * @abstract
 */
var LocationStrategy = (function () {
    function LocationStrategy() {
    }
    /**
     * @abstract
     * @param {?=} includeHash
     * @return {?}
     */
    LocationStrategy.prototype.path = function (includeHash) { };
    /**
     * @abstract
     * @param {?} internal
     * @return {?}
     */
    LocationStrategy.prototype.prepareExternalUrl = function (internal) { };
    /**
     * @abstract
     * @param {?} state
     * @param {?} title
     * @param {?} url
     * @param {?} queryParams
     * @return {?}
     */
    LocationStrategy.prototype.pushState = function (state, title, url, queryParams) { };
    /**
     * @abstract
     * @param {?} state
     * @param {?} title
     * @param {?} url
     * @param {?} queryParams
     * @return {?}
     */
    LocationStrategy.prototype.replaceState = function (state, title, url, queryParams) { };
    /**
     * @abstract
     * @return {?}
     */
    LocationStrategy.prototype.forward = function () { };
    /**
     * @abstract
     * @return {?}
     */
    LocationStrategy.prototype.back = function () { };
    /**
     * @abstract
     * @param {?} fn
     * @return {?}
     */
    LocationStrategy.prototype.onPopState = function (fn) { };
    /**
     * @abstract
     * @return {?}
     */
    LocationStrategy.prototype.getBaseHref = function () { };
    return LocationStrategy;
}());
/**
 * The `APP_BASE_HREF` token represents the base href to be used with the
 * {\@link PathLocationStrategy}.
 *
 * If you're using {\@link PathLocationStrategy}, you must provide a provider to a string
 * representing the URL prefix that should be preserved when generating and recognizing
 * URLs.
 *
 * ### Example
 *
 * ```typescript
 * import {Component, NgModule} from '\@angular/core';
 * import {APP_BASE_HREF} from '\@angular/common';
 *
 * \@NgModule({
 *   providers: [{provide: APP_BASE_HREF, useValue: '/my/app'}]
 * })
 * class AppModule {}
 * ```
 *
 * \@stable
 */
var APP_BASE_HREF = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["InjectionToken"]('appBaseHref');
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * \@whatItDoes `Location` is a service that applications can use to interact with a browser's URL.
 * \@description
 * Depending on which {\@link LocationStrategy} is used, `Location` will either persist
 * to the URL's path or the URL's hash segment.
 *
 * Note: it's better to use {\@link Router#navigate} service to trigger route changes. Use
 * `Location` only if you need to interact with or create normalized URLs outside of
 * routing.
 *
 * `Location` is responsible for normalizing the URL against the application's base href.
 * A normalized URL is absolute from the URL host, includes the application's base href, and has no
 * trailing slash:
 * - `/my/app/user/123` is normalized
 * - `my/app/user/123` **is not** normalized
 * - `/my/app/user/123/` **is not** normalized
 *
 * ### Example
 * {\@example common/location/ts/path_location_component.ts region='LocationComponent'}
 * \@stable
 */
var Location = (function () {
    /**
     * @param {?} platformStrategy
     */
    function Location(platformStrategy) {
        var _this = this;
        /**
         * \@internal
         */
        this._subject = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this._platformStrategy = platformStrategy;
        var browserBaseHref = this._platformStrategy.getBaseHref();
        this._baseHref = Location.stripTrailingSlash(_stripIndexHtml(browserBaseHref));
        this._platformStrategy.onPopState(function (ev) {
            _this._subject.emit({
                'url': _this.path(true),
                'pop': true,
                'type': ev.type,
            });
        });
    }
    /**
     * @param {?=} includeHash
     * @return {?}
     */
    Location.prototype.path = function (includeHash) {
        if (includeHash === void 0) { includeHash = false; }
        return this.normalize(this._platformStrategy.path(includeHash));
    };
    /**
     * Normalizes the given path and compares to the current normalized path.
     * @param {?} path
     * @param {?=} query
     * @return {?}
     */
    Location.prototype.isCurrentPathEqualTo = function (path, query) {
        if (query === void 0) { query = ''; }
        return this.path() == this.normalize(path + Location.normalizeQueryParams(query));
    };
    /**
     * Given a string representing a URL, returns the normalized URL path without leading or
     * trailing slashes.
     * @param {?} url
     * @return {?}
     */
    Location.prototype.normalize = function (url) {
        return Location.stripTrailingSlash(_stripBaseHref(this._baseHref, _stripIndexHtml(url)));
    };
    /**
     * Given a string representing a URL, returns the platform-specific external URL path.
     * If the given URL doesn't begin with a leading slash (`'/'`), this method adds one
     * before normalizing. This method will also add a hash if `HashLocationStrategy` is
     * used, or the `APP_BASE_HREF` if the `PathLocationStrategy` is in use.
     * @param {?} url
     * @return {?}
     */
    Location.prototype.prepareExternalUrl = function (url) {
        if (url && url[0] !== '/') {
            url = '/' + url;
        }
        return this._platformStrategy.prepareExternalUrl(url);
    };
    /**
     * Changes the browsers URL to the normalized version of the given URL, and pushes a
     * new item onto the platform's history.
     * @param {?} path
     * @param {?=} query
     * @return {?}
     */
    Location.prototype.go = function (path, query) {
        if (query === void 0) { query = ''; }
        this._platformStrategy.pushState(null, '', path, query);
    };
    /**
     * Changes the browsers URL to the normalized version of the given URL, and replaces
     * the top item on the platform's history stack.
     * @param {?} path
     * @param {?=} query
     * @return {?}
     */
    Location.prototype.replaceState = function (path, query) {
        if (query === void 0) { query = ''; }
        this._platformStrategy.replaceState(null, '', path, query);
    };
    /**
     * Navigates forward in the platform's history.
     * @return {?}
     */
    Location.prototype.forward = function () { this._platformStrategy.forward(); };
    /**
     * Navigates back in the platform's history.
     * @return {?}
     */
    Location.prototype.back = function () { this._platformStrategy.back(); };
    /**
     * Subscribe to the platform's `popState` events.
     * @param {?} onNext
     * @param {?=} onThrow
     * @param {?=} onReturn
     * @return {?}
     */
    Location.prototype.subscribe = function (onNext, onThrow, onReturn) {
        return this._subject.subscribe({ next: onNext, error: onThrow, complete: onReturn });
    };
    /**
     * Given a string of url parameters, prepend with '?' if needed, otherwise return parameters as
     * is.
     * @param {?} params
     * @return {?}
     */
    Location.normalizeQueryParams = function (params) {
        return params && params[0] !== '?' ? '?' + params : params;
    };
    /**
     * Given 2 parts of a url, join them with a slash if needed.
     * @param {?} start
     * @param {?} end
     * @return {?}
     */
    Location.joinWithSlash = function (start, end) {
        if (start.length == 0) {
            return end;
        }
        if (end.length == 0) {
            return start;
        }
        var /** @type {?} */ slashes = 0;
        if (start.endsWith('/')) {
            slashes++;
        }
        if (end.startsWith('/')) {
            slashes++;
        }
        if (slashes == 2) {
            return start + end.substring(1);
        }
        if (slashes == 1) {
            return start + end;
        }
        return start + '/' + end;
    };
    /**
     * If url has a trailing slash, remove it, otherwise return url as is.
     * @param {?} url
     * @return {?}
     */
    Location.stripTrailingSlash = function (url) { return url.replace(/\/$/, ''); };
    return Location;
}());
Location.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
];
/**
 * @nocollapse
 */
Location.ctorParameters = function () { return [
    { type: LocationStrategy, },
]; };
/**
 * @param {?} baseHref
 * @param {?} url
 * @return {?}
 */
function _stripBaseHref(baseHref, url) {
    return baseHref && url.startsWith(baseHref) ? url.substring(baseHref.length) : url;
}
/**
 * @param {?} url
 * @return {?}
 */
function _stripIndexHtml(url) {
    return url.replace(/\/index.html$/, '');
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * \@whatItDoes Use URL hash for storing application location data.
 * \@description
 * `HashLocationStrategy` is a {\@link LocationStrategy} used to configure the
 * {\@link Location} service to represent its state in the
 * [hash fragment](https://en.wikipedia.org/wiki/Uniform_Resource_Locator#Syntax)
 * of the browser's URL.
 *
 * For instance, if you call `location.go('/foo')`, the browser's URL will become
 * `example.com#/foo`.
 *
 * ### Example
 *
 * {\@example common/location/ts/hash_location_component.ts region='LocationComponent'}
 *
 * \@stable
 */
var HashLocationStrategy = (function (_super) {
    __extends(HashLocationStrategy, _super);
    /**
     * @param {?} _platformLocation
     * @param {?=} _baseHref
     */
    function HashLocationStrategy(_platformLocation, _baseHref) {
        var _this = _super.call(this) || this;
        _this._platformLocation = _platformLocation;
        _this._baseHref = '';
        if (_baseHref != null) {
            _this._baseHref = _baseHref;
        }
        return _this;
    }
    /**
     * @param {?} fn
     * @return {?}
     */
    HashLocationStrategy.prototype.onPopState = function (fn) {
        this._platformLocation.onPopState(fn);
        this._platformLocation.onHashChange(fn);
    };
    /**
     * @return {?}
     */
    HashLocationStrategy.prototype.getBaseHref = function () { return this._baseHref; };
    /**
     * @param {?=} includeHash
     * @return {?}
     */
    HashLocationStrategy.prototype.path = function (includeHash) {
        if (includeHash === void 0) { includeHash = false; }
        // the hash value is always prefixed with a `#`
        // and if it is empty then it will stay empty
        var /** @type {?} */ path = this._platformLocation.hash;
        if (path == null)
            path = '#';
        return path.length > 0 ? path.substring(1) : path;
    };
    /**
     * @param {?} internal
     * @return {?}
     */
    HashLocationStrategy.prototype.prepareExternalUrl = function (internal) {
        var /** @type {?} */ url = Location.joinWithSlash(this._baseHref, internal);
        return url.length > 0 ? ('#' + url) : url;
    };
    /**
     * @param {?} state
     * @param {?} title
     * @param {?} path
     * @param {?} queryParams
     * @return {?}
     */
    HashLocationStrategy.prototype.pushState = function (state, title, path, queryParams) {
        var /** @type {?} */ url = this.prepareExternalUrl(path + Location.normalizeQueryParams(queryParams));
        if (url.length == 0) {
            url = this._platformLocation.pathname;
        }
        this._platformLocation.pushState(state, title, url);
    };
    /**
     * @param {?} state
     * @param {?} title
     * @param {?} path
     * @param {?} queryParams
     * @return {?}
     */
    HashLocationStrategy.prototype.replaceState = function (state, title, path, queryParams) {
        var /** @type {?} */ url = this.prepareExternalUrl(path + Location.normalizeQueryParams(queryParams));
        if (url.length == 0) {
            url = this._platformLocation.pathname;
        }
        this._platformLocation.replaceState(state, title, url);
    };
    /**
     * @return {?}
     */
    HashLocationStrategy.prototype.forward = function () { this._platformLocation.forward(); };
    /**
     * @return {?}
     */
    HashLocationStrategy.prototype.back = function () { this._platformLocation.back(); };
    return HashLocationStrategy;
}(LocationStrategy));
HashLocationStrategy.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
];
/**
 * @nocollapse
 */
HashLocationStrategy.ctorParameters = function () { return [
    { type: PlatformLocation, },
    { type: undefined, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [APP_BASE_HREF,] },] },
]; };
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * \@whatItDoes Use URL for storing application location data.
 * \@description
 * `PathLocationStrategy` is a {\@link LocationStrategy} used to configure the
 * {\@link Location} service to represent its state in the
 * [path](https://en.wikipedia.org/wiki/Uniform_Resource_Locator#Syntax) of the
 * browser's URL.
 *
 * If you're using `PathLocationStrategy`, you must provide a {\@link APP_BASE_HREF}
 * or add a base element to the document. This URL prefix that will be preserved
 * when generating and recognizing URLs.
 *
 * For instance, if you provide an `APP_BASE_HREF` of `'/my/app'` and call
 * `location.go('/foo')`, the browser's URL will become
 * `example.com/my/app/foo`.
 *
 * Similarly, if you add `<base href='/my/app'/>` to the document and call
 * `location.go('/foo')`, the browser's URL will become
 * `example.com/my/app/foo`.
 *
 * ### Example
 *
 * {\@example common/location/ts/path_location_component.ts region='LocationComponent'}
 *
 * \@stable
 */
var PathLocationStrategy = (function (_super) {
    __extends(PathLocationStrategy, _super);
    /**
     * @param {?} _platformLocation
     * @param {?=} href
     */
    function PathLocationStrategy(_platformLocation, href) {
        var _this = _super.call(this) || this;
        _this._platformLocation = _platformLocation;
        if (href == null) {
            href = _this._platformLocation.getBaseHrefFromDOM();
        }
        if (href == null) {
            throw new Error("No base href set. Please provide a value for the APP_BASE_HREF token or add a base element to the document.");
        }
        _this._baseHref = href;
        return _this;
    }
    /**
     * @param {?} fn
     * @return {?}
     */
    PathLocationStrategy.prototype.onPopState = function (fn) {
        this._platformLocation.onPopState(fn);
        this._platformLocation.onHashChange(fn);
    };
    /**
     * @return {?}
     */
    PathLocationStrategy.prototype.getBaseHref = function () { return this._baseHref; };
    /**
     * @param {?} internal
     * @return {?}
     */
    PathLocationStrategy.prototype.prepareExternalUrl = function (internal) {
        return Location.joinWithSlash(this._baseHref, internal);
    };
    /**
     * @param {?=} includeHash
     * @return {?}
     */
    PathLocationStrategy.prototype.path = function (includeHash) {
        if (includeHash === void 0) { includeHash = false; }
        var /** @type {?} */ pathname = this._platformLocation.pathname +
            Location.normalizeQueryParams(this._platformLocation.search);
        var /** @type {?} */ hash = this._platformLocation.hash;
        return hash && includeHash ? "" + pathname + hash : pathname;
    };
    /**
     * @param {?} state
     * @param {?} title
     * @param {?} url
     * @param {?} queryParams
     * @return {?}
     */
    PathLocationStrategy.prototype.pushState = function (state, title, url, queryParams) {
        var /** @type {?} */ externalUrl = this.prepareExternalUrl(url + Location.normalizeQueryParams(queryParams));
        this._platformLocation.pushState(state, title, externalUrl);
    };
    /**
     * @param {?} state
     * @param {?} title
     * @param {?} url
     * @param {?} queryParams
     * @return {?}
     */
    PathLocationStrategy.prototype.replaceState = function (state, title, url, queryParams) {
        var /** @type {?} */ externalUrl = this.prepareExternalUrl(url + Location.normalizeQueryParams(queryParams));
        this._platformLocation.replaceState(state, title, externalUrl);
    };
    /**
     * @return {?}
     */
    PathLocationStrategy.prototype.forward = function () { this._platformLocation.forward(); };
    /**
     * @return {?}
     */
    PathLocationStrategy.prototype.back = function () { this._platformLocation.back(); };
    return PathLocationStrategy;
}(LocationStrategy));
PathLocationStrategy.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
];
/**
 * @nocollapse
 */
PathLocationStrategy.ctorParameters = function () { return [
    { type: PlatformLocation, },
    { type: undefined, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [APP_BASE_HREF,] },] },
]; };
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * \@experimental
 * @abstract
 */
var NgLocalization = (function () {
    function NgLocalization() {
    }
    /**
     * @abstract
     * @param {?} value
     * @return {?}
     */
    NgLocalization.prototype.getPluralCategory = function (value) { };
    return NgLocalization;
}());
/**
 * Returns the plural category for a given value.
 * - "=value" when the case exists,
 * - the plural category otherwise
 *
 * \@internal
 * @param {?} value
 * @param {?} cases
 * @param {?} ngLocalization
 * @return {?}
 */
function getPluralCategory(value, cases, ngLocalization) {
    var /** @type {?} */ key = "=" + value;
    if (cases.indexOf(key) > -1) {
        return key;
    }
    key = ngLocalization.getPluralCategory(value);
    if (cases.indexOf(key) > -1) {
        return key;
    }
    if (cases.indexOf('other') > -1) {
        return 'other';
    }
    throw new Error("No plural message found for value \"" + value + "\"");
}
/**
 * Returns the plural case based on the locale
 *
 * \@experimental
 */
var NgLocaleLocalization = (function (_super) {
    __extends(NgLocaleLocalization, _super);
    /**
     * @param {?} locale
     */
    function NgLocaleLocalization(locale) {
        var _this = _super.call(this) || this;
        _this.locale = locale;
        return _this;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    NgLocaleLocalization.prototype.getPluralCategory = function (value) {
        var /** @type {?} */ plural = getPluralCase(this.locale, value);
        switch (plural) {
            case Plural.Zero:
                return 'zero';
            case Plural.One:
                return 'one';
            case Plural.Two:
                return 'two';
            case Plural.Few:
                return 'few';
            case Plural.Many:
                return 'many';
            default:
                return 'other';
        }
    };
    return NgLocaleLocalization;
}(NgLocalization));
NgLocaleLocalization.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
];
/**
 * @nocollapse
 */
NgLocaleLocalization.ctorParameters = function () { return [
    { type: undefined, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_0__angular_core__["LOCALE_ID"],] },] },
]; };
var Plural = {};
Plural.Zero = 0;
Plural.One = 1;
Plural.Two = 2;
Plural.Few = 3;
Plural.Many = 4;
Plural.Other = 5;
Plural[Plural.Zero] = "Zero";
Plural[Plural.One] = "One";
Plural[Plural.Two] = "Two";
Plural[Plural.Few] = "Few";
Plural[Plural.Many] = "Many";
Plural[Plural.Other] = "Other";
/**
 * Returns the plural case based on the locale
 *
 * \@experimental
 * @param {?} locale
 * @param {?} nLike
 * @return {?}
 */
function getPluralCase(locale, nLike) {
    // TODO(vicb): lazy compute
    if (typeof nLike === 'string') {
        nLike = parseInt(/** @type {?} */ (nLike), 10);
    }
    var /** @type {?} */ n = (nLike);
    var /** @type {?} */ nDecimal = n.toString().replace(/^[^.]*\.?/, '');
    var /** @type {?} */ i = Math.floor(Math.abs(n));
    var /** @type {?} */ v = nDecimal.length;
    var /** @type {?} */ f = parseInt(nDecimal, 10);
    var /** @type {?} */ t = parseInt(n.toString().replace(/^[^.]*\.?|0+$/g, ''), 10) || 0;
    var /** @type {?} */ lang = locale.split('-')[0].toLowerCase();
    switch (lang) {
        case 'af':
        case 'asa':
        case 'az':
        case 'bem':
        case 'bez':
        case 'bg':
        case 'brx':
        case 'ce':
        case 'cgg':
        case 'chr':
        case 'ckb':
        case 'ee':
        case 'el':
        case 'eo':
        case 'es':
        case 'eu':
        case 'fo':
        case 'fur':
        case 'gsw':
        case 'ha':
        case 'haw':
        case 'hu':
        case 'jgo':
        case 'jmc':
        case 'ka':
        case 'kk':
        case 'kkj':
        case 'kl':
        case 'ks':
        case 'ksb':
        case 'ky':
        case 'lb':
        case 'lg':
        case 'mas':
        case 'mgo':
        case 'ml':
        case 'mn':
        case 'nb':
        case 'nd':
        case 'ne':
        case 'nn':
        case 'nnh':
        case 'nyn':
        case 'om':
        case 'or':
        case 'os':
        case 'ps':
        case 'rm':
        case 'rof':
        case 'rwk':
        case 'saq':
        case 'seh':
        case 'sn':
        case 'so':
        case 'sq':
        case 'ta':
        case 'te':
        case 'teo':
        case 'tk':
        case 'tr':
        case 'ug':
        case 'uz':
        case 'vo':
        case 'vun':
        case 'wae':
        case 'xog':
            if (n === 1)
                return Plural.One;
            return Plural.Other;
        case 'agq':
        case 'bas':
        case 'cu':
        case 'dav':
        case 'dje':
        case 'dua':
        case 'dyo':
        case 'ebu':
        case 'ewo':
        case 'guz':
        case 'kam':
        case 'khq':
        case 'ki':
        case 'kln':
        case 'kok':
        case 'ksf':
        case 'lrc':
        case 'lu':
        case 'luo':
        case 'luy':
        case 'mer':
        case 'mfe':
        case 'mgh':
        case 'mua':
        case 'mzn':
        case 'nmg':
        case 'nus':
        case 'qu':
        case 'rn':
        case 'rw':
        case 'sbp':
        case 'twq':
        case 'vai':
        case 'yav':
        case 'yue':
        case 'zgh':
        case 'ak':
        case 'ln':
        case 'mg':
        case 'pa':
        case 'ti':
            if (n === Math.floor(n) && n >= 0 && n <= 1)
                return Plural.One;
            return Plural.Other;
        case 'am':
        case 'as':
        case 'bn':
        case 'fa':
        case 'gu':
        case 'hi':
        case 'kn':
        case 'mr':
        case 'zu':
            if (i === 0 || n === 1)
                return Plural.One;
            return Plural.Other;
        case 'ar':
            if (n === 0)
                return Plural.Zero;
            if (n === 1)
                return Plural.One;
            if (n === 2)
                return Plural.Two;
            if (n % 100 === Math.floor(n % 100) && n % 100 >= 3 && n % 100 <= 10)
                return Plural.Few;
            if (n % 100 === Math.floor(n % 100) && n % 100 >= 11 && n % 100 <= 99)
                return Plural.Many;
            return Plural.Other;
        case 'ast':
        case 'ca':
        case 'de':
        case 'en':
        case 'et':
        case 'fi':
        case 'fy':
        case 'gl':
        case 'it':
        case 'nl':
        case 'sv':
        case 'sw':
        case 'ur':
        case 'yi':
            if (i === 1 && v === 0)
                return Plural.One;
            return Plural.Other;
        case 'be':
            if (n % 10 === 1 && !(n % 100 === 11))
                return Plural.One;
            if (n % 10 === Math.floor(n % 10) && n % 10 >= 2 && n % 10 <= 4 &&
                !(n % 100 >= 12 && n % 100 <= 14))
                return Plural.Few;
            if (n % 10 === 0 || n % 10 === Math.floor(n % 10) && n % 10 >= 5 && n % 10 <= 9 ||
                n % 100 === Math.floor(n % 100) && n % 100 >= 11 && n % 100 <= 14)
                return Plural.Many;
            return Plural.Other;
        case 'br':
            if (n % 10 === 1 && !(n % 100 === 11 || n % 100 === 71 || n % 100 === 91))
                return Plural.One;
            if (n % 10 === 2 && !(n % 100 === 12 || n % 100 === 72 || n % 100 === 92))
                return Plural.Two;
            if (n % 10 === Math.floor(n % 10) && (n % 10 >= 3 && n % 10 <= 4 || n % 10 === 9) &&
                !(n % 100 >= 10 && n % 100 <= 19 || n % 100 >= 70 && n % 100 <= 79 ||
                    n % 100 >= 90 && n % 100 <= 99))
                return Plural.Few;
            if (!(n === 0) && n % 1e6 === 0)
                return Plural.Many;
            return Plural.Other;
        case 'bs':
        case 'hr':
        case 'sr':
            if (v === 0 && i % 10 === 1 && !(i % 100 === 11) || f % 10 === 1 && !(f % 100 === 11))
                return Plural.One;
            if (v === 0 && i % 10 === Math.floor(i % 10) && i % 10 >= 2 && i % 10 <= 4 &&
                !(i % 100 >= 12 && i % 100 <= 14) ||
                f % 10 === Math.floor(f % 10) && f % 10 >= 2 && f % 10 <= 4 &&
                    !(f % 100 >= 12 && f % 100 <= 14))
                return Plural.Few;
            return Plural.Other;
        case 'cs':
        case 'sk':
            if (i === 1 && v === 0)
                return Plural.One;
            if (i === Math.floor(i) && i >= 2 && i <= 4 && v === 0)
                return Plural.Few;
            if (!(v === 0))
                return Plural.Many;
            return Plural.Other;
        case 'cy':
            if (n === 0)
                return Plural.Zero;
            if (n === 1)
                return Plural.One;
            if (n === 2)
                return Plural.Two;
            if (n === 3)
                return Plural.Few;
            if (n === 6)
                return Plural.Many;
            return Plural.Other;
        case 'da':
            if (n === 1 || !(t === 0) && (i === 0 || i === 1))
                return Plural.One;
            return Plural.Other;
        case 'dsb':
        case 'hsb':
            if (v === 0 && i % 100 === 1 || f % 100 === 1)
                return Plural.One;
            if (v === 0 && i % 100 === 2 || f % 100 === 2)
                return Plural.Two;
            if (v === 0 && i % 100 === Math.floor(i % 100) && i % 100 >= 3 && i % 100 <= 4 ||
                f % 100 === Math.floor(f % 100) && f % 100 >= 3 && f % 100 <= 4)
                return Plural.Few;
            return Plural.Other;
        case 'ff':
        case 'fr':
        case 'hy':
        case 'kab':
            if (i === 0 || i === 1)
                return Plural.One;
            return Plural.Other;
        case 'fil':
            if (v === 0 && (i === 1 || i === 2 || i === 3) ||
                v === 0 && !(i % 10 === 4 || i % 10 === 6 || i % 10 === 9) ||
                !(v === 0) && !(f % 10 === 4 || f % 10 === 6 || f % 10 === 9))
                return Plural.One;
            return Plural.Other;
        case 'ga':
            if (n === 1)
                return Plural.One;
            if (n === 2)
                return Plural.Two;
            if (n === Math.floor(n) && n >= 3 && n <= 6)
                return Plural.Few;
            if (n === Math.floor(n) && n >= 7 && n <= 10)
                return Plural.Many;
            return Plural.Other;
        case 'gd':
            if (n === 1 || n === 11)
                return Plural.One;
            if (n === 2 || n === 12)
                return Plural.Two;
            if (n === Math.floor(n) && (n >= 3 && n <= 10 || n >= 13 && n <= 19))
                return Plural.Few;
            return Plural.Other;
        case 'gv':
            if (v === 0 && i % 10 === 1)
                return Plural.One;
            if (v === 0 && i % 10 === 2)
                return Plural.Two;
            if (v === 0 &&
                (i % 100 === 0 || i % 100 === 20 || i % 100 === 40 || i % 100 === 60 || i % 100 === 80))
                return Plural.Few;
            if (!(v === 0))
                return Plural.Many;
            return Plural.Other;
        case 'he':
            if (i === 1 && v === 0)
                return Plural.One;
            if (i === 2 && v === 0)
                return Plural.Two;
            if (v === 0 && !(n >= 0 && n <= 10) && n % 10 === 0)
                return Plural.Many;
            return Plural.Other;
        case 'is':
            if (t === 0 && i % 10 === 1 && !(i % 100 === 11) || !(t === 0))
                return Plural.One;
            return Plural.Other;
        case 'ksh':
            if (n === 0)
                return Plural.Zero;
            if (n === 1)
                return Plural.One;
            return Plural.Other;
        case 'kw':
        case 'naq':
        case 'se':
        case 'smn':
            if (n === 1)
                return Plural.One;
            if (n === 2)
                return Plural.Two;
            return Plural.Other;
        case 'lag':
            if (n === 0)
                return Plural.Zero;
            if ((i === 0 || i === 1) && !(n === 0))
                return Plural.One;
            return Plural.Other;
        case 'lt':
            if (n % 10 === 1 && !(n % 100 >= 11 && n % 100 <= 19))
                return Plural.One;
            if (n % 10 === Math.floor(n % 10) && n % 10 >= 2 && n % 10 <= 9 &&
                !(n % 100 >= 11 && n % 100 <= 19))
                return Plural.Few;
            if (!(f === 0))
                return Plural.Many;
            return Plural.Other;
        case 'lv':
        case 'prg':
            if (n % 10 === 0 || n % 100 === Math.floor(n % 100) && n % 100 >= 11 && n % 100 <= 19 ||
                v === 2 && f % 100 === Math.floor(f % 100) && f % 100 >= 11 && f % 100 <= 19)
                return Plural.Zero;
            if (n % 10 === 1 && !(n % 100 === 11) || v === 2 && f % 10 === 1 && !(f % 100 === 11) ||
                !(v === 2) && f % 10 === 1)
                return Plural.One;
            return Plural.Other;
        case 'mk':
            if (v === 0 && i % 10 === 1 || f % 10 === 1)
                return Plural.One;
            return Plural.Other;
        case 'mt':
            if (n === 1)
                return Plural.One;
            if (n === 0 || n % 100 === Math.floor(n % 100) && n % 100 >= 2 && n % 100 <= 10)
                return Plural.Few;
            if (n % 100 === Math.floor(n % 100) && n % 100 >= 11 && n % 100 <= 19)
                return Plural.Many;
            return Plural.Other;
        case 'pl':
            if (i === 1 && v === 0)
                return Plural.One;
            if (v === 0 && i % 10 === Math.floor(i % 10) && i % 10 >= 2 && i % 10 <= 4 &&
                !(i % 100 >= 12 && i % 100 <= 14))
                return Plural.Few;
            if (v === 0 && !(i === 1) && i % 10 === Math.floor(i % 10) && i % 10 >= 0 && i % 10 <= 1 ||
                v === 0 && i % 10 === Math.floor(i % 10) && i % 10 >= 5 && i % 10 <= 9 ||
                v === 0 && i % 100 === Math.floor(i % 100) && i % 100 >= 12 && i % 100 <= 14)
                return Plural.Many;
            return Plural.Other;
        case 'pt':
            if (n === Math.floor(n) && n >= 0 && n <= 2 && !(n === 2))
                return Plural.One;
            return Plural.Other;
        case 'ro':
            if (i === 1 && v === 0)
                return Plural.One;
            if (!(v === 0) || n === 0 ||
                !(n === 1) && n % 100 === Math.floor(n % 100) && n % 100 >= 1 && n % 100 <= 19)
                return Plural.Few;
            return Plural.Other;
        case 'ru':
        case 'uk':
            if (v === 0 && i % 10 === 1 && !(i % 100 === 11))
                return Plural.One;
            if (v === 0 && i % 10 === Math.floor(i % 10) && i % 10 >= 2 && i % 10 <= 4 &&
                !(i % 100 >= 12 && i % 100 <= 14))
                return Plural.Few;
            if (v === 0 && i % 10 === 0 ||
                v === 0 && i % 10 === Math.floor(i % 10) && i % 10 >= 5 && i % 10 <= 9 ||
                v === 0 && i % 100 === Math.floor(i % 100) && i % 100 >= 11 && i % 100 <= 14)
                return Plural.Many;
            return Plural.Other;
        case 'shi':
            if (i === 0 || n === 1)
                return Plural.One;
            if (n === Math.floor(n) && n >= 2 && n <= 10)
                return Plural.Few;
            return Plural.Other;
        case 'si':
            if (n === 0 || n === 1 || i === 0 && f === 1)
                return Plural.One;
            return Plural.Other;
        case 'sl':
            if (v === 0 && i % 100 === 1)
                return Plural.One;
            if (v === 0 && i % 100 === 2)
                return Plural.Two;
            if (v === 0 && i % 100 === Math.floor(i % 100) && i % 100 >= 3 && i % 100 <= 4 || !(v === 0))
                return Plural.Few;
            return Plural.Other;
        case 'tzm':
            if (n === Math.floor(n) && n >= 0 && n <= 1 || n === Math.floor(n) && n >= 11 && n <= 99)
                return Plural.One;
            return Plural.Other;
        default:
            return Plural.Other;
    }
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * \@ngModule CommonModule
 *
 * \@whatItDoes Adds and removes CSS classes on an HTML element.
 *
 * \@howToUse
 * ```
 *     <some-element [ngClass]="'first second'">...</some-element>
 *
 *     <some-element [ngClass]="['first', 'second']">...</some-element>
 *
 *     <some-element [ngClass]="{'first': true, 'second': true, 'third': false}">...</some-element>
 *
 *     <some-element [ngClass]="stringExp|arrayExp|objExp">...</some-element>
 *
 *     <some-element [ngClass]="{'class1 class2 class3' : true}">...</some-element>
 * ```
 *
 * \@description
 *
 * The CSS classes are updated as follows, depending on the type of the expression evaluation:
 * - `string` - the CSS classes listed in the string (space delimited) are added,
 * - `Array` - the CSS classes declared as Array elements are added,
 * - `Object` - keys are CSS classes that get added when the expression given in the value
 *              evaluates to a truthy value, otherwise they are removed.
 *
 * \@stable
 */
var NgClass = (function () {
    /**
     * @param {?} _iterableDiffers
     * @param {?} _keyValueDiffers
     * @param {?} _ngEl
     * @param {?} _renderer
     */
    function NgClass(_iterableDiffers, _keyValueDiffers, _ngEl, _renderer) {
        this._iterableDiffers = _iterableDiffers;
        this._keyValueDiffers = _keyValueDiffers;
        this._ngEl = _ngEl;
        this._renderer = _renderer;
        this._initialClasses = [];
    }
    Object.defineProperty(NgClass.prototype, "klass", {
        /**
         * @param {?} v
         * @return {?}
         */
        set: function (v) {
            this._applyInitialClasses(true);
            this._initialClasses = typeof v === 'string' ? v.split(/\s+/) : [];
            this._applyInitialClasses(false);
            this._applyClasses(this._rawClass, false);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgClass.prototype, "ngClass", {
        /**
         * @param {?} v
         * @return {?}
         */
        set: function (v) {
            this._cleanupClasses(this._rawClass);
            this._iterableDiffer = null;
            this._keyValueDiffer = null;
            this._rawClass = typeof v === 'string' ? v.split(/\s+/) : v;
            if (this._rawClass) {
                if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵisListLikeIterable"])(this._rawClass)) {
                    this._iterableDiffer = this._iterableDiffers.find(this._rawClass).create();
                }
                else {
                    this._keyValueDiffer = this._keyValueDiffers.find(this._rawClass).create();
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    NgClass.prototype.ngDoCheck = function () {
        if (this._iterableDiffer) {
            var /** @type {?} */ iterableChanges = this._iterableDiffer.diff(/** @type {?} */ (this._rawClass));
            if (iterableChanges) {
                this._applyIterableChanges(iterableChanges);
            }
        }
        else if (this._keyValueDiffer) {
            var /** @type {?} */ keyValueChanges = this._keyValueDiffer.diff(/** @type {?} */ (this._rawClass));
            if (keyValueChanges) {
                this._applyKeyValueChanges(keyValueChanges);
            }
        }
    };
    /**
     * @param {?} rawClassVal
     * @return {?}
     */
    NgClass.prototype._cleanupClasses = function (rawClassVal) {
        this._applyClasses(rawClassVal, true);
        this._applyInitialClasses(false);
    };
    /**
     * @param {?} changes
     * @return {?}
     */
    NgClass.prototype._applyKeyValueChanges = function (changes) {
        var _this = this;
        changes.forEachAddedItem(function (record) { return _this._toggleClass(record.key, record.currentValue); });
        changes.forEachChangedItem(function (record) { return _this._toggleClass(record.key, record.currentValue); });
        changes.forEachRemovedItem(function (record) {
            if (record.previousValue) {
                _this._toggleClass(record.key, false);
            }
        });
    };
    /**
     * @param {?} changes
     * @return {?}
     */
    NgClass.prototype._applyIterableChanges = function (changes) {
        var _this = this;
        changes.forEachAddedItem(function (record) {
            if (typeof record.item === 'string') {
                _this._toggleClass(record.item, true);
            }
            else {
                throw new Error("NgClass can only toggle CSS classes expressed as strings, got " + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵstringify"])(record.item));
            }
        });
        changes.forEachRemovedItem(function (record) { return _this._toggleClass(record.item, false); });
    };
    /**
     * @param {?} isCleanup
     * @return {?}
     */
    NgClass.prototype._applyInitialClasses = function (isCleanup) {
        var _this = this;
        this._initialClasses.forEach(function (klass) { return _this._toggleClass(klass, !isCleanup); });
    };
    /**
     * @param {?} rawClassVal
     * @param {?} isCleanup
     * @return {?}
     */
    NgClass.prototype._applyClasses = function (rawClassVal, isCleanup) {
        var _this = this;
        if (rawClassVal) {
            if (Array.isArray(rawClassVal) || rawClassVal instanceof Set) {
                ((rawClassVal)).forEach(function (klass) { return _this._toggleClass(klass, !isCleanup); });
            }
            else {
                Object.keys(rawClassVal).forEach(function (klass) {
                    if (rawClassVal[klass] != null)
                        _this._toggleClass(klass, !isCleanup);
                });
            }
        }
    };
    /**
     * @param {?} klass
     * @param {?} enabled
     * @return {?}
     */
    NgClass.prototype._toggleClass = function (klass, enabled) {
        var _this = this;
        klass = klass.trim();
        if (klass) {
            klass.split(/\s+/g).forEach(function (klass) { _this._renderer.setElementClass(_this._ngEl.nativeElement, klass, !!enabled); });
        }
    };
    return NgClass;
}());
NgClass.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{ selector: '[ngClass]' },] },
];
/**
 * @nocollapse
 */
NgClass.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["IterableDiffers"], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["KeyValueDiffers"], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
]; };
NgClass.propDecorators = {
    'klass': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['class',] },],
    'ngClass': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
};
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Instantiates a single {\@link Component} type and inserts its Host View into current View.
 * `NgComponentOutlet` provides a declarative approach for dynamic component creation.
 *
 * `NgComponentOutlet` requires a component type, if a falsy value is set the view will clear and
 * any existing component will get destroyed.
 *
 * ### Fine tune control
 *
 * You can control the component creation process by using the following optional attributes:
 *
 * * `ngComponentOutletInjector`: Optional custom {\@link Injector} that will be used as parent for
 * the Component. Defaults to the injector of the current view container.
 *
 * * `ngComponentOutletProviders`: Optional injectable objects ({\@link Provider}) that are visible
 * to the component.
 *
 * * `ngComponentOutletContent`: Optional list of projectable nodes to insert into the content
 * section of the component, if exists.
 *
 * * `ngComponentOutletNgModuleFactory`: Optional module factory to allow dynamically loading other
 * module, then load a component from that module.
 *
 * ### Syntax
 *
 * Simple
 * ```
 * <ng-container *ngComponentOutlet="componentTypeExpression"></ng-container>
 * ```
 *
 * Customized injector/content
 * ```
 * <ng-container *ngComponentOutlet="componentTypeExpression;
 *                                   injector: injectorExpression;
 *                                   content: contentNodesExpression;">
 * </ng-container>
 * ```
 *
 * Customized ngModuleFactory
 * ```
 * <ng-container *ngComponentOutlet="componentTypeExpression;
 *                                   ngModuleFactory: moduleFactory;">
 * </ng-container>
 * ```
 * # Example
 *
 * {\@example common/ngComponentOutlet/ts/module.ts region='SimpleExample'}
 *
 * A more complete example with additional options:
 *
 * {\@example common/ngComponentOutlet/ts/module.ts region='CompleteExample'}
 * A more complete example with ngModuleFactory:
 *
 * {\@example common/ngComponentOutlet/ts/module.ts region='NgModuleFactoryExample'}
 *
 * \@experimental
 */
var NgComponentOutlet = (function () {
    /**
     * @param {?} _viewContainerRef
     */
    function NgComponentOutlet(_viewContainerRef) {
        this._viewContainerRef = _viewContainerRef;
        this._componentRef = null;
        this._moduleRef = null;
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    NgComponentOutlet.prototype.ngOnChanges = function (changes) {
        this._viewContainerRef.clear();
        this._componentRef = null;
        if (this.ngComponentOutlet) {
            var /** @type {?} */ elInjector = this.ngComponentOutletInjector || this._viewContainerRef.parentInjector;
            if (changes['ngComponentOutletNgModuleFactory']) {
                if (this._moduleRef)
                    this._moduleRef.destroy();
                if (this.ngComponentOutletNgModuleFactory) {
                    var /** @type {?} */ parentModule = elInjector.get(__WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModuleRef"]);
                    this._moduleRef = this.ngComponentOutletNgModuleFactory.create(parentModule.injector);
                }
                else {
                    this._moduleRef = null;
                }
            }
            var /** @type {?} */ componentFactoryResolver = this._moduleRef ? this._moduleRef.componentFactoryResolver :
                elInjector.get(__WEBPACK_IMPORTED_MODULE_0__angular_core__["ComponentFactoryResolver"]);
            var /** @type {?} */ componentFactory = componentFactoryResolver.resolveComponentFactory(this.ngComponentOutlet);
            this._componentRef = this._viewContainerRef.createComponent(componentFactory, this._viewContainerRef.length, elInjector, this.ngComponentOutletContent);
        }
    };
    /**
     * @return {?}
     */
    NgComponentOutlet.prototype.ngOnDestroy = function () {
        if (this._moduleRef)
            this._moduleRef.destroy();
    };
    return NgComponentOutlet;
}());
NgComponentOutlet.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{ selector: '[ngComponentOutlet]' },] },
];
/**
 * @nocollapse
 */
NgComponentOutlet.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewContainerRef"], },
]; };
NgComponentOutlet.propDecorators = {
    'ngComponentOutlet': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'ngComponentOutletInjector': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'ngComponentOutletContent': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'ngComponentOutletNgModuleFactory': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
};
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * \@stable
 */
var NgForOfContext = (function () {
    /**
     * @param {?} $implicit
     * @param {?} ngForOf
     * @param {?} index
     * @param {?} count
     */
    function NgForOfContext($implicit, ngForOf, index, count) {
        this.$implicit = $implicit;
        this.ngForOf = ngForOf;
        this.index = index;
        this.count = count;
    }
    Object.defineProperty(NgForOfContext.prototype, "first", {
        /**
         * @return {?}
         */
        get: function () { return this.index === 0; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgForOfContext.prototype, "last", {
        /**
         * @return {?}
         */
        get: function () { return this.index === this.count - 1; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgForOfContext.prototype, "even", {
        /**
         * @return {?}
         */
        get: function () { return this.index % 2 === 0; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgForOfContext.prototype, "odd", {
        /**
         * @return {?}
         */
        get: function () { return !this.even; },
        enumerable: true,
        configurable: true
    });
    return NgForOfContext;
}());
/**
 * The `NgForOf` directive instantiates a template once per item from an iterable. The context
 * for each instantiated template inherits from the outer context with the given loop variable
 * set to the current item from the iterable.
 *
 * ### Local Variables
 *
 * `NgForOf` provides several exported values that can be aliased to local variables:
 *
 * - `$implicit: T`: The value of the individual items in the iterable (`ngForOf`).
 * - `ngForOf: NgIterable<T>`: The value of the iterable expression. Useful when the expression is
 * more complex then a property access, for example when using the async pipe (`userStreams |
 * async`).
 * - `index: number`: The index of the current item in the iterable.
 * - `first: boolean`: True when the item is the first item in the iterable.
 * - `last: boolean`: True when the item is the last item in the iterable.
 * - `even: boolean`: True when the item has an even index in the iterable.
 * - `odd: boolean`: True when the item has an odd index in the iterable.
 *
 * ```
 * <li *ngFor="let user of userObservable | async as users; index as i; first as isFirst">
 *    {{i}}/{{users.length}}. {{user}} <span *ngIf="isFirst">default</span>
 * </li>
 * ```
 *
 * ### Change Propagation
 *
 * When the contents of the iterator changes, `NgForOf` makes the corresponding changes to the DOM:
 *
 * * When an item is added, a new instance of the template is added to the DOM.
 * * When an item is removed, its template instance is removed from the DOM.
 * * When items are reordered, their respective templates are reordered in the DOM.
 * * Otherwise, the DOM element for that item will remain the same.
 *
 * Angular uses object identity to track insertions and deletions within the iterator and reproduce
 * those changes in the DOM. This has important implications for animations and any stateful
 * controls (such as `<input>` elements which accept user input) that are present. Inserted rows can
 * be animated in, deleted rows can be animated out, and unchanged rows retain any unsaved state
 * such as user input.
 *
 * It is possible for the identities of elements in the iterator to change while the data does not.
 * This can happen, for example, if the iterator produced from an RPC to the server, and that
 * RPC is re-run. Even if the data hasn't changed, the second response will produce objects with
 * different identities, and Angular will tear down the entire DOM and rebuild it (as if all old
 * elements were deleted and all new elements inserted). This is an expensive operation and should
 * be avoided if possible.
 *
 * To customize the default tracking algorithm, `NgForOf` supports `trackBy` option.
 * `trackBy` takes a function which has two arguments: `index` and `item`.
 * If `trackBy` is given, Angular tracks changes by the return value of the function.
 *
 * ### Syntax
 *
 * - `<li *ngFor="let item of items; index as i; trackBy: trackByFn">...</li>`
 * - `<li template="ngFor let item of items; index as i; trackBy: trackByFn">...</li>`
 *
 * With `<ng-template>` element:
 *
 * ```
 * <ng-template ngFor let-item [ngForOf]="items" let-i="index" [ngForTrackBy]="trackByFn">
 *   <li>...</li>
 * </ng-template>
 * ```
 *
 * ### Example
 *
 * See a [live demo](http://plnkr.co/edit/KVuXxDp0qinGDyo307QW?p=preview) for a more detailed
 * example.
 *
 * \@stable
 */
var NgForOf = (function () {
    /**
     * @param {?} _viewContainer
     * @param {?} _template
     * @param {?} _differs
     */
    function NgForOf(_viewContainer, _template, _differs) {
        this._viewContainer = _viewContainer;
        this._template = _template;
        this._differs = _differs;
        this._differ = null;
    }
    Object.defineProperty(NgForOf.prototype, "ngForTrackBy", {
        /**
         * @return {?}
         */
        get: function () { return this._trackByFn; },
        /**
         * @param {?} fn
         * @return {?}
         */
        set: function (fn) {
            if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["isDevMode"])() && fn != null && typeof fn !== 'function') {
                // TODO(vicb): use a log service once there is a public one available
                if ((console) && (console.warn)) {
                    console.warn("trackBy must be a function, but received " + JSON.stringify(fn) + ". " +
                        "See https://angular.io/docs/ts/latest/api/common/index/NgFor-directive.html#!#change-propagation for more information.");
                }
            }
            this._trackByFn = fn;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgForOf.prototype, "ngForTemplate", {
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            // TODO(TS2.1): make TemplateRef<Partial<NgForRowOf<T>>> once we move to TS v2.1
            // The current type is too restrictive; a template that just uses index, for example,
            // should be acceptable.
            if (value) {
                this._template = value;
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} changes
     * @return {?}
     */
    NgForOf.prototype.ngOnChanges = function (changes) {
        if ('ngForOf' in changes) {
            // React on ngForOf changes only once all inputs have been initialized
            var /** @type {?} */ value = changes['ngForOf'].currentValue;
            if (!this._differ && value) {
                try {
                    this._differ = this._differs.find(value).create(this.ngForTrackBy);
                }
                catch (e) {
                    throw new Error("Cannot find a differ supporting object '" + value + "' of type '" + getTypeNameForDebugging(value) + "'. NgFor only supports binding to Iterables such as Arrays.");
                }
            }
        }
    };
    /**
     * @return {?}
     */
    NgForOf.prototype.ngDoCheck = function () {
        if (this._differ) {
            var /** @type {?} */ changes = this._differ.diff(this.ngForOf);
            if (changes)
                this._applyChanges(changes);
        }
    };
    /**
     * @param {?} changes
     * @return {?}
     */
    NgForOf.prototype._applyChanges = function (changes) {
        var _this = this;
        var /** @type {?} */ insertTuples = [];
        changes.forEachOperation(function (item, adjustedPreviousIndex, currentIndex) {
            if (item.previousIndex == null) {
                var /** @type {?} */ view = _this._viewContainer.createEmbeddedView(_this._template, new NgForOfContext(/** @type {?} */ ((null)), _this.ngForOf, -1, -1), currentIndex);
                var /** @type {?} */ tuple = new RecordViewTuple(item, view);
                insertTuples.push(tuple);
            }
            else if (currentIndex == null) {
                _this._viewContainer.remove(adjustedPreviousIndex);
            }
            else {
                var /** @type {?} */ view = ((_this._viewContainer.get(adjustedPreviousIndex)));
                _this._viewContainer.move(view, currentIndex);
                var /** @type {?} */ tuple = new RecordViewTuple(item, /** @type {?} */ (view));
                insertTuples.push(tuple);
            }
        });
        for (var /** @type {?} */ i = 0; i < insertTuples.length; i++) {
            this._perViewChange(insertTuples[i].view, insertTuples[i].record);
        }
        for (var /** @type {?} */ i = 0, /** @type {?} */ ilen = this._viewContainer.length; i < ilen; i++) {
            var /** @type {?} */ viewRef = (this._viewContainer.get(i));
            viewRef.context.index = i;
            viewRef.context.count = ilen;
        }
        changes.forEachIdentityChange(function (record) {
            var /** @type {?} */ viewRef = (_this._viewContainer.get(record.currentIndex));
            viewRef.context.$implicit = record.item;
        });
    };
    /**
     * @param {?} view
     * @param {?} record
     * @return {?}
     */
    NgForOf.prototype._perViewChange = function (view, record) {
        view.context.$implicit = record.item;
    };
    return NgForOf;
}());
NgForOf.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{ selector: '[ngFor][ngForOf]' },] },
];
/**
 * @nocollapse
 */
NgForOf.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewContainerRef"], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["TemplateRef"], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["IterableDiffers"], },
]; };
NgForOf.propDecorators = {
    'ngForOf': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'ngForTrackBy': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'ngForTemplate': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
};
var RecordViewTuple = (function () {
    /**
     * @param {?} record
     * @param {?} view
     */
    function RecordViewTuple(record, view) {
        this.record = record;
        this.view = view;
    }
    return RecordViewTuple;
}());
/**
 * @deprecated from v4.0.0 - Use NgForOf instead.
 */
var NgFor = NgForOf;
/**
 * @param {?} type
 * @return {?}
 */
function getTypeNameForDebugging(type) {
    return type['name'] || typeof type;
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Conditionally includes a template based on the value of an `expression`.
 *
 * `ngIf` evaluates the `expression` and then renders the `then` or `else` template in its place
 * when expression is truthy or falsy respectively. Typically the:
 *  - `then` template is the inline template of `ngIf` unless bound to a different value.
 *  - `else` template is blank unless it is bound.
 *
 * # Most common usage
 *
 * The most common usage of the `ngIf` directive is to conditionally show the inline template as
 * seen in this example:
 * {\@example common/ngIf/ts/module.ts region='NgIfSimple'}
 *
 * # Showing an alternative template using `else`
 *
 * If it is necessary to display a template when the `expression` is falsy use the `else` template
 * binding as shown. Note that the `else` binding points to a `<ng-template>` labeled `#elseBlock`.
 * The template can be defined anywhere in the component view but is typically placed right after
 * `ngIf` for readability.
 *
 * {\@example common/ngIf/ts/module.ts region='NgIfElse'}
 *
 * # Using non-inlined `then` template
 *
 * Usually the `then` template is the inlined template of the `ngIf`, but it can be changed using
 * a binding (just like `else`). Because `then` and `else` are bindings, the template references can
 * change at runtime as shown in this example.
 *
 * {\@example common/ngIf/ts/module.ts region='NgIfThenElse'}
 *
 * # Storing conditional result in a variable
 *
 * A common pattern is that we need to show a set of properties from the same object. If the
 * object is undefined, then we have to use the safe-traversal-operator `?.` to guard against
 * dereferencing a `null` value. This is especially the case when waiting on async data such as
 * when using the `async` pipe as shown in folowing example:
 *
 * ```
 * Hello {{ (userStream|async)?.last }}, {{ (userStream|async)?.first }}!
 * ```
 *
 * There are several inefficiencies in the above example:
 *  - We create multiple subscriptions on `userStream`. One for each `async` pipe, or two in the
 *    example above.
 *  - We cannot display an alternative screen while waiting for the data to arrive asynchronously.
 *  - We have to use the safe-traversal-operator `?.` to access properties, which is cumbersome.
 *  - We have to place the `async` pipe in parenthesis.
 *
 * A better way to do this is to use `ngIf` and store the result of the condition in a local
 * variable as shown in the the example below:
 *
 * {\@example common/ngIf/ts/module.ts region='NgIfAs'}
 *
 * Notice that:
 *  - We use only one `async` pipe and hence only one subscription gets created.
 *  - `ngIf` stores the result of the `userStream|async` in the local variable `user`.
 *  - The local `user` can then be bound repeatedly in a more efficient way.
 *  - No need to use the safe-traversal-operator `?.` to access properties as `ngIf` will only
 *    display the data if `userStream` returns a value.
 *  - We can display an alternative template while waiting for the data.
 *
 * ### Syntax
 *
 * Simple form:
 * - `<div *ngIf="condition">...</div>`
 * - `<div template="ngIf condition">...</div>`
 * - `<ng-template [ngIf]="condition"><div>...</div></ng-template>`
 *
 * Form with an else block:
 * ```
 * <div *ngIf="condition; else elseBlock">...</div>
 * <ng-template #elseBlock>...</ng-template>
 * ```
 *
 * Form with a `then` and `else` block:
 * ```
 * <div *ngIf="condition; then thenBlock else elseBlock"></div>
 * <ng-template #thenBlock>...</ng-template>
 * <ng-template #elseBlock>...</ng-template>
 * ```
 *
 * Form with storing the value locally:
 * ```
 * <div *ngIf="condition as value; else elseBlock">{{value}}</div>
 * <ng-template #elseBlock>...</ng-template>
 * ```
 *
 * \@stable
 */
var NgIf = (function () {
    /**
     * @param {?} _viewContainer
     * @param {?} templateRef
     */
    function NgIf(_viewContainer, templateRef) {
        this._viewContainer = _viewContainer;
        this._context = new NgIfContext();
        this._thenTemplateRef = null;
        this._elseTemplateRef = null;
        this._thenViewRef = null;
        this._elseViewRef = null;
        this._thenTemplateRef = templateRef;
    }
    Object.defineProperty(NgIf.prototype, "ngIf", {
        /**
         * @param {?} condition
         * @return {?}
         */
        set: function (condition) {
            this._context.$implicit = this._context.ngIf = condition;
            this._updateView();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgIf.prototype, "ngIfThen", {
        /**
         * @param {?} templateRef
         * @return {?}
         */
        set: function (templateRef) {
            this._thenTemplateRef = templateRef;
            this._thenViewRef = null; // clear previous view if any.
            this._updateView();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgIf.prototype, "ngIfElse", {
        /**
         * @param {?} templateRef
         * @return {?}
         */
        set: function (templateRef) {
            this._elseTemplateRef = templateRef;
            this._elseViewRef = null; // clear previous view if any.
            this._updateView();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    NgIf.prototype._updateView = function () {
        if (this._context.$implicit) {
            if (!this._thenViewRef) {
                this._viewContainer.clear();
                this._elseViewRef = null;
                if (this._thenTemplateRef) {
                    this._thenViewRef =
                        this._viewContainer.createEmbeddedView(this._thenTemplateRef, this._context);
                }
            }
        }
        else {
            if (!this._elseViewRef) {
                this._viewContainer.clear();
                this._thenViewRef = null;
                if (this._elseTemplateRef) {
                    this._elseViewRef =
                        this._viewContainer.createEmbeddedView(this._elseTemplateRef, this._context);
                }
            }
        }
    };
    return NgIf;
}());
NgIf.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{ selector: '[ngIf]' },] },
];
/**
 * @nocollapse
 */
NgIf.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewContainerRef"], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["TemplateRef"], },
]; };
NgIf.propDecorators = {
    'ngIf': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'ngIfThen': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'ngIfElse': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
};
/**
 * \@stable
 */
var NgIfContext = (function () {
    function NgIfContext() {
        this.$implicit = null;
        this.ngIf = null;
    }
    return NgIfContext;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var SwitchView = (function () {
    /**
     * @param {?} _viewContainerRef
     * @param {?} _templateRef
     */
    function SwitchView(_viewContainerRef, _templateRef) {
        this._viewContainerRef = _viewContainerRef;
        this._templateRef = _templateRef;
        this._created = false;
    }
    /**
     * @return {?}
     */
    SwitchView.prototype.create = function () {
        this._created = true;
        this._viewContainerRef.createEmbeddedView(this._templateRef);
    };
    /**
     * @return {?}
     */
    SwitchView.prototype.destroy = function () {
        this._created = false;
        this._viewContainerRef.clear();
    };
    /**
     * @param {?} created
     * @return {?}
     */
    SwitchView.prototype.enforceState = function (created) {
        if (created && !this._created) {
            this.create();
        }
        else if (!created && this._created) {
            this.destroy();
        }
    };
    return SwitchView;
}());
/**
 * \@ngModule CommonModule
 *
 * \@whatItDoes Adds / removes DOM sub-trees when the nest match expressions matches the switch
 *             expression.
 *
 * \@howToUse
 * ```
 *     <container-element [ngSwitch]="switch_expression">
 *       <some-element *ngSwitchCase="match_expression_1">...</some-element>
 *       <some-element *ngSwitchCase="match_expression_2">...</some-element>
 *       <some-other-element *ngSwitchCase="match_expression_3">...</some-other-element>
 *       <ng-container *ngSwitchCase="match_expression_3">
 *         <!-- use a ng-container to group multiple root nodes -->
 *         <inner-element></inner-element>
 *         <inner-other-element></inner-other-element>
 *       </ng-container>
 *       <some-element *ngSwitchDefault>...</some-element>
 *     </container-element>
 * ```
 * \@description
 *
 * `NgSwitch` stamps out nested views when their match expression value matches the value of the
 * switch expression.
 *
 * In other words:
 * - you define a container element (where you place the directive with a switch expression on the
 * `[ngSwitch]="..."` attribute)
 * - you define inner views inside the `NgSwitch` and place a `*ngSwitchCase` attribute on the view
 * root elements.
 *
 * Elements within `NgSwitch` but outside of a `NgSwitchCase` or `NgSwitchDefault` directives will
 * be preserved at the location.
 *
 * The `ngSwitchCase` directive informs the parent `NgSwitch` of which view to display when the
 * expression is evaluated.
 * When no matching expression is found on a `ngSwitchCase` view, the `ngSwitchDefault` view is
 * stamped out.
 *
 * \@stable
 */
var NgSwitch = (function () {
    function NgSwitch() {
        this._defaultUsed = false;
        this._caseCount = 0;
        this._lastCaseCheckIndex = 0;
        this._lastCasesMatched = false;
    }
    Object.defineProperty(NgSwitch.prototype, "ngSwitch", {
        /**
         * @param {?} newValue
         * @return {?}
         */
        set: function (newValue) {
            this._ngSwitch = newValue;
            if (this._caseCount === 0) {
                this._updateDefaultCases(true);
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * \@internal
     * @return {?}
     */
    NgSwitch.prototype._addCase = function () { return this._caseCount++; };
    /**
     * \@internal
     * @param {?} view
     * @return {?}
     */
    NgSwitch.prototype._addDefault = function (view) {
        if (!this._defaultViews) {
            this._defaultViews = [];
        }
        this._defaultViews.push(view);
    };
    /**
     * \@internal
     * @param {?} value
     * @return {?}
     */
    NgSwitch.prototype._matchCase = function (value) {
        var /** @type {?} */ matched = value == this._ngSwitch;
        this._lastCasesMatched = this._lastCasesMatched || matched;
        this._lastCaseCheckIndex++;
        if (this._lastCaseCheckIndex === this._caseCount) {
            this._updateDefaultCases(!this._lastCasesMatched);
            this._lastCaseCheckIndex = 0;
            this._lastCasesMatched = false;
        }
        return matched;
    };
    /**
     * @param {?} useDefault
     * @return {?}
     */
    NgSwitch.prototype._updateDefaultCases = function (useDefault) {
        if (this._defaultViews && useDefault !== this._defaultUsed) {
            this._defaultUsed = useDefault;
            for (var /** @type {?} */ i = 0; i < this._defaultViews.length; i++) {
                var /** @type {?} */ defaultView = this._defaultViews[i];
                defaultView.enforceState(useDefault);
            }
        }
    };
    return NgSwitch;
}());
NgSwitch.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{ selector: '[ngSwitch]' },] },
];
/**
 * @nocollapse
 */
NgSwitch.ctorParameters = function () { return []; };
NgSwitch.propDecorators = {
    'ngSwitch': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
};
/**
 * \@ngModule CommonModule
 *
 * \@whatItDoes Creates a view that will be added/removed from the parent {\@link NgSwitch} when the
 *             given expression evaluate to respectively the same/different value as the switch
 *             expression.
 *
 * \@howToUse
 * ```
 * <container-element [ngSwitch]="switch_expression">
 *   <some-element *ngSwitchCase="match_expression_1">...</some-element>
 * </container-element>
 * ```
 * \@description
 *
 * Insert the sub-tree when the expression evaluates to the same value as the enclosing switch
 * expression.
 *
 * If multiple match expressions match the switch expression value, all of them are displayed.
 *
 * See {\@link NgSwitch} for more details and example.
 *
 * \@stable
 */
var NgSwitchCase = (function () {
    /**
     * @param {?} viewContainer
     * @param {?} templateRef
     * @param {?} ngSwitch
     */
    function NgSwitchCase(viewContainer, templateRef, ngSwitch) {
        this.ngSwitch = ngSwitch;
        ngSwitch._addCase();
        this._view = new SwitchView(viewContainer, templateRef);
    }
    /**
     * @return {?}
     */
    NgSwitchCase.prototype.ngDoCheck = function () { this._view.enforceState(this.ngSwitch._matchCase(this.ngSwitchCase)); };
    return NgSwitchCase;
}());
NgSwitchCase.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{ selector: '[ngSwitchCase]' },] },
];
/**
 * @nocollapse
 */
NgSwitchCase.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewContainerRef"], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["TemplateRef"], },
    { type: NgSwitch, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Host"] },] },
]; };
NgSwitchCase.propDecorators = {
    'ngSwitchCase': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
};
/**
 * \@ngModule CommonModule
 * \@whatItDoes Creates a view that is added to the parent {\@link NgSwitch} when no case expressions
 * match the
 *             switch expression.
 *
 * \@howToUse
 * ```
 * <container-element [ngSwitch]="switch_expression">
 *   <some-element *ngSwitchCase="match_expression_1">...</some-element>
 *   <some-other-element *ngSwitchDefault>...</some-other-element>
 * </container-element>
 * ```
 *
 * \@description
 *
 * Insert the sub-tree when no case expressions evaluate to the same value as the enclosing switch
 * expression.
 *
 * See {\@link NgSwitch} for more details and example.
 *
 * \@stable
 */
var NgSwitchDefault = (function () {
    /**
     * @param {?} viewContainer
     * @param {?} templateRef
     * @param {?} ngSwitch
     */
    function NgSwitchDefault(viewContainer, templateRef, ngSwitch) {
        ngSwitch._addDefault(new SwitchView(viewContainer, templateRef));
    }
    return NgSwitchDefault;
}());
NgSwitchDefault.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{ selector: '[ngSwitchDefault]' },] },
];
/**
 * @nocollapse
 */
NgSwitchDefault.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewContainerRef"], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["TemplateRef"], },
    { type: NgSwitch, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Host"] },] },
]; };
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * \@ngModule CommonModule
 *
 * \@whatItDoes Adds / removes DOM sub-trees based on a numeric value. Tailored for pluralization.
 *
 * \@howToUse
 * ```
 * <some-element [ngPlural]="value">
 *   <ng-template ngPluralCase="=0">there is nothing</ng-template>
 *   <ng-template ngPluralCase="=1">there is one</ng-template>
 *   <ng-template ngPluralCase="few">there are a few</ng-template>
 * </some-element>
 * ```
 *
 * \@description
 *
 * Displays DOM sub-trees that match the switch expression value, or failing that, DOM sub-trees
 * that match the switch expression's pluralization category.
 *
 * To use this directive you must provide a container element that sets the `[ngPlural]` attribute
 * to a switch expression. Inner elements with a `[ngPluralCase]` will display based on their
 * expression:
 * - if `[ngPluralCase]` is set to a value starting with `=`, it will only display if the value
 *   matches the switch expression exactly,
 * - otherwise, the view will be treated as a "category match", and will only display if exact
 *   value matches aren't found and the value maps to its category for the defined locale.
 *
 * See http://cldr.unicode.org/index/cldr-spec/plural-rules
 *
 * \@experimental
 */
var NgPlural = (function () {
    /**
     * @param {?} _localization
     */
    function NgPlural(_localization) {
        this._localization = _localization;
        this._caseViews = {};
    }
    Object.defineProperty(NgPlural.prototype, "ngPlural", {
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._switchValue = value;
            this._updateView();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} value
     * @param {?} switchView
     * @return {?}
     */
    NgPlural.prototype.addCase = function (value, switchView) { this._caseViews[value] = switchView; };
    /**
     * @return {?}
     */
    NgPlural.prototype._updateView = function () {
        this._clearViews();
        var /** @type {?} */ cases = Object.keys(this._caseViews);
        var /** @type {?} */ key = getPluralCategory(this._switchValue, cases, this._localization);
        this._activateView(this._caseViews[key]);
    };
    /**
     * @return {?}
     */
    NgPlural.prototype._clearViews = function () {
        if (this._activeView)
            this._activeView.destroy();
    };
    /**
     * @param {?} view
     * @return {?}
     */
    NgPlural.prototype._activateView = function (view) {
        if (view) {
            this._activeView = view;
            this._activeView.create();
        }
    };
    return NgPlural;
}());
NgPlural.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{ selector: '[ngPlural]' },] },
];
/**
 * @nocollapse
 */
NgPlural.ctorParameters = function () { return [
    { type: NgLocalization, },
]; };
NgPlural.propDecorators = {
    'ngPlural': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
};
/**
 * \@ngModule CommonModule
 *
 * \@whatItDoes Creates a view that will be added/removed from the parent {\@link NgPlural} when the
 *             given expression matches the plural expression according to CLDR rules.
 *
 * \@howToUse
 * ```
 * <some-element [ngPlural]="value">
 *   <ng-template ngPluralCase="=0">...</ng-template>
 *   <ng-template ngPluralCase="other">...</ng-template>
 * </some-element>
 * ```
 *
 * See {\@link NgPlural} for more details and example.
 *
 * \@experimental
 */
var NgPluralCase = (function () {
    /**
     * @param {?} value
     * @param {?} template
     * @param {?} viewContainer
     * @param {?} ngPlural
     */
    function NgPluralCase(value, template, viewContainer, ngPlural) {
        this.value = value;
        var isANumber = !isNaN(Number(value));
        ngPlural.addCase(isANumber ? "=" + value : value, new SwitchView(viewContainer, template));
    }
    return NgPluralCase;
}());
NgPluralCase.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{ selector: '[ngPluralCase]' },] },
];
/**
 * @nocollapse
 */
NgPluralCase.ctorParameters = function () { return [
    { type: undefined, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Attribute"], args: ['ngPluralCase',] },] },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["TemplateRef"], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewContainerRef"], },
    { type: NgPlural, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Host"] },] },
]; };
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * \@ngModule CommonModule
 *
 * \@whatItDoes Update an HTML element styles.
 *
 * \@howToUse
 * ```
 * <some-element [ngStyle]="{'font-style': styleExp}">...</some-element>
 *
 * <some-element [ngStyle]="{'max-width.px': widthExp}">...</some-element>
 *
 * <some-element [ngStyle]="objExp">...</some-element>
 * ```
 *
 * \@description
 *
 * The styles are updated according to the value of the expression evaluation:
 * - keys are style names with an optional `.<unit>` suffix (ie 'top.px', 'font-style.em'),
 * - values are the values assigned to those properties (expressed in the given unit).
 *
 * \@stable
 */
var NgStyle = (function () {
    /**
     * @param {?} _differs
     * @param {?} _ngEl
     * @param {?} _renderer
     */
    function NgStyle(_differs, _ngEl, _renderer) {
        this._differs = _differs;
        this._ngEl = _ngEl;
        this._renderer = _renderer;
    }
    Object.defineProperty(NgStyle.prototype, "ngStyle", {
        /**
         * @param {?} v
         * @return {?}
         */
        set: function (v) {
            this._ngStyle = v;
            if (!this._differ && v) {
                this._differ = this._differs.find(v).create();
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    NgStyle.prototype.ngDoCheck = function () {
        if (this._differ) {
            var /** @type {?} */ changes = this._differ.diff(this._ngStyle);
            if (changes) {
                this._applyChanges(changes);
            }
        }
    };
    /**
     * @param {?} changes
     * @return {?}
     */
    NgStyle.prototype._applyChanges = function (changes) {
        var _this = this;
        changes.forEachRemovedItem(function (record) { return _this._setStyle(record.key, null); });
        changes.forEachAddedItem(function (record) { return _this._setStyle(record.key, record.currentValue); });
        changes.forEachChangedItem(function (record) { return _this._setStyle(record.key, record.currentValue); });
    };
    /**
     * @param {?} nameAndUnit
     * @param {?} value
     * @return {?}
     */
    NgStyle.prototype._setStyle = function (nameAndUnit, value) {
        var _a = nameAndUnit.split('.'), name = _a[0], unit = _a[1];
        value = value != null && unit ? "" + value + unit : value;
        this._renderer.setElementStyle(this._ngEl.nativeElement, name, /** @type {?} */ (value));
    };
    return NgStyle;
}());
NgStyle.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{ selector: '[ngStyle]' },] },
];
/**
 * @nocollapse
 */
NgStyle.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["KeyValueDiffers"], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
]; };
NgStyle.propDecorators = {
    'ngStyle': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
};
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * \@ngModule CommonModule
 *
 * \@whatItDoes Inserts an embedded view from a prepared `TemplateRef`
 *
 * \@howToUse
 * ```
 * <ng-container *ngTemplateOutlet="templateRefExp; context: contextExp"></ng-container>
 * ```
 *
 * \@description
 *
 * You can attach a context object to the `EmbeddedViewRef` by setting `[ngTemplateOutletContext]`.
 * `[ngTemplateOutletContext]` should be an object, the object's keys will be available for binding
 * by the local template `let` declarations.
 *
 * Note: using the key `$implicit` in the context object will set it's value as default.
 *
 * # Example
 *
 * {\@example common/ngTemplateOutlet/ts/module.ts region='NgTemplateOutlet'}
 *
 * \@experimental
 */
var NgTemplateOutlet = (function () {
    /**
     * @param {?} _viewContainerRef
     */
    function NgTemplateOutlet(_viewContainerRef) {
        this._viewContainerRef = _viewContainerRef;
    }
    Object.defineProperty(NgTemplateOutlet.prototype, "ngOutletContext", {
        /**
         * @deprecated v4.0.0 - Renamed to ngTemplateOutletContext.
         * @param {?} context
         * @return {?}
         */
        set: function (context) { this.ngTemplateOutletContext = context; },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} changes
     * @return {?}
     */
    NgTemplateOutlet.prototype.ngOnChanges = function (changes) {
        if (this._viewRef) {
            this._viewContainerRef.remove(this._viewContainerRef.indexOf(this._viewRef));
        }
        if (this.ngTemplateOutlet) {
            this._viewRef = this._viewContainerRef.createEmbeddedView(this.ngTemplateOutlet, this.ngTemplateOutletContext);
        }
    };
    return NgTemplateOutlet;
}());
NgTemplateOutlet.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{ selector: '[ngTemplateOutlet]' },] },
];
/**
 * @nocollapse
 */
NgTemplateOutlet.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewContainerRef"], },
]; };
NgTemplateOutlet.propDecorators = {
    'ngTemplateOutletContext': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'ngTemplateOutlet': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'ngOutletContext': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
};
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * A collection of Angular directives that are likely to be used in each and every Angular
 * application.
 */
var COMMON_DIRECTIVES = [
    NgClass,
    NgComponentOutlet,
    NgForOf,
    NgIf,
    NgTemplateOutlet,
    NgStyle,
    NgSwitch,
    NgSwitchCase,
    NgSwitchDefault,
    NgPlural,
    NgPluralCase,
];
/**
 * A collection of deprecated directives that are no longer part of the core module.
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @param {?} type
 * @param {?} value
 * @return {?}
 */
function invalidPipeArgumentError(type, value) {
    return Error("InvalidPipeArgument: '" + value + "' for pipe '" + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵstringify"])(type) + "'");
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var ObservableStrategy = (function () {
    function ObservableStrategy() {
    }
    /**
     * @param {?} async
     * @param {?} updateLatestValue
     * @return {?}
     */
    ObservableStrategy.prototype.createSubscription = function (async, updateLatestValue) {
        return async.subscribe({ next: updateLatestValue, error: function (e) { throw e; } });
    };
    /**
     * @param {?} subscription
     * @return {?}
     */
    ObservableStrategy.prototype.dispose = function (subscription) { subscription.unsubscribe(); };
    /**
     * @param {?} subscription
     * @return {?}
     */
    ObservableStrategy.prototype.onDestroy = function (subscription) { subscription.unsubscribe(); };
    return ObservableStrategy;
}());
var PromiseStrategy = (function () {
    function PromiseStrategy() {
    }
    /**
     * @param {?} async
     * @param {?} updateLatestValue
     * @return {?}
     */
    PromiseStrategy.prototype.createSubscription = function (async, updateLatestValue) {
        return async.then(updateLatestValue, function (e) { throw e; });
    };
    /**
     * @param {?} subscription
     * @return {?}
     */
    PromiseStrategy.prototype.dispose = function (subscription) { };
    /**
     * @param {?} subscription
     * @return {?}
     */
    PromiseStrategy.prototype.onDestroy = function (subscription) { };
    return PromiseStrategy;
}());
var _promiseStrategy = new PromiseStrategy();
var _observableStrategy = new ObservableStrategy();
/**
 * \@ngModule CommonModule
 * \@whatItDoes Unwraps a value from an asynchronous primitive.
 * \@howToUse `observable_or_promise_expression | async`
 * \@description
 * The `async` pipe subscribes to an `Observable` or `Promise` and returns the latest value it has
 * emitted. When a new value is emitted, the `async` pipe marks the component to be checked for
 * changes. When the component gets destroyed, the `async` pipe unsubscribes automatically to avoid
 * potential memory leaks.
 *
 *
 * ## Examples
 *
 * This example binds a `Promise` to the view. Clicking the `Resolve` button resolves the
 * promise.
 *
 * {\@example common/pipes/ts/async_pipe.ts region='AsyncPipePromise'}
 *
 * It's also possible to use `async` with Observables. The example below binds the `time` Observable
 * to the view. The Observable continuously updates the view with the current time.
 *
 * {\@example common/pipes/ts/async_pipe.ts region='AsyncPipeObservable'}
 *
 * \@stable
 */
var AsyncPipe = (function () {
    /**
     * @param {?} _ref
     */
    function AsyncPipe(_ref) {
        this._ref = _ref;
        this._latestValue = null;
        this._latestReturnedValue = null;
        this._subscription = null;
        this._obj = null;
        this._strategy = ((null));
    }
    /**
     * @return {?}
     */
    AsyncPipe.prototype.ngOnDestroy = function () {
        if (this._subscription) {
            this._dispose();
        }
    };
    /**
     * @param {?} obj
     * @return {?}
     */
    AsyncPipe.prototype.transform = function (obj) {
        if (!this._obj) {
            if (obj) {
                this._subscribe(obj);
            }
            this._latestReturnedValue = this._latestValue;
            return this._latestValue;
        }
        if (obj !== this._obj) {
            this._dispose();
            return this.transform(/** @type {?} */ (obj));
        }
        if (this._latestValue === this._latestReturnedValue) {
            return this._latestReturnedValue;
        }
        this._latestReturnedValue = this._latestValue;
        return __WEBPACK_IMPORTED_MODULE_0__angular_core__["WrappedValue"].wrap(this._latestValue);
    };
    /**
     * @param {?} obj
     * @return {?}
     */
    AsyncPipe.prototype._subscribe = function (obj) {
        var _this = this;
        this._obj = obj;
        this._strategy = this._selectStrategy(obj);
        this._subscription = this._strategy.createSubscription(obj, function (value) { return _this._updateLatestValue(obj, value); });
    };
    /**
     * @param {?} obj
     * @return {?}
     */
    AsyncPipe.prototype._selectStrategy = function (obj) {
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵisPromise"])(obj)) {
            return _promiseStrategy;
        }
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵisObservable"])(obj)) {
            return _observableStrategy;
        }
        throw invalidPipeArgumentError(AsyncPipe, obj);
    };
    /**
     * @return {?}
     */
    AsyncPipe.prototype._dispose = function () {
        this._strategy.dispose(/** @type {?} */ ((this._subscription)));
        this._latestValue = null;
        this._latestReturnedValue = null;
        this._subscription = null;
        this._obj = null;
    };
    /**
     * @param {?} async
     * @param {?} value
     * @return {?}
     */
    AsyncPipe.prototype._updateLatestValue = function (async, value) {
        if (async === this._obj) {
            this._latestValue = value;
            this._ref.markForCheck();
        }
    };
    return AsyncPipe;
}());
AsyncPipe.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Pipe"], args: [{ name: 'async', pure: false },] },
];
/**
 * @nocollapse
 */
AsyncPipe.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectorRef"], },
]; };
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Transforms text to lowercase.
 *
 * {\@example  common/pipes/ts/lowerupper_pipe.ts region='LowerUpperPipe' }
 *
 * \@stable
 */
var LowerCasePipe = (function () {
    function LowerCasePipe() {
    }
    /**
     * @param {?} value
     * @return {?}
     */
    LowerCasePipe.prototype.transform = function (value) {
        if (!value)
            return value;
        if (typeof value !== 'string') {
            throw invalidPipeArgumentError(LowerCasePipe, value);
        }
        return value.toLowerCase();
    };
    return LowerCasePipe;
}());
LowerCasePipe.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Pipe"], args: [{ name: 'lowercase' },] },
];
/**
 * @nocollapse
 */
LowerCasePipe.ctorParameters = function () { return []; };
/**
 * Helper method to transform a single word to titlecase.
 *
 * \@stable
 * @param {?} word
 * @return {?}
 */
function titleCaseWord(word) {
    if (!word)
        return word;
    return word[0].toUpperCase() + word.substr(1).toLowerCase();
}
/**
 * Transforms text to titlecase.
 *
 * \@stable
 */
var TitleCasePipe = (function () {
    function TitleCasePipe() {
    }
    /**
     * @param {?} value
     * @return {?}
     */
    TitleCasePipe.prototype.transform = function (value) {
        if (!value)
            return value;
        if (typeof value !== 'string') {
            throw invalidPipeArgumentError(TitleCasePipe, value);
        }
        return value.split(/\b/g).map(function (word) { return titleCaseWord(word); }).join('');
    };
    return TitleCasePipe;
}());
TitleCasePipe.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Pipe"], args: [{ name: 'titlecase' },] },
];
/**
 * @nocollapse
 */
TitleCasePipe.ctorParameters = function () { return []; };
/**
 * Transforms text to uppercase.
 *
 * \@stable
 */
var UpperCasePipe = (function () {
    function UpperCasePipe() {
    }
    /**
     * @param {?} value
     * @return {?}
     */
    UpperCasePipe.prototype.transform = function (value) {
        if (!value)
            return value;
        if (typeof value !== 'string') {
            throw invalidPipeArgumentError(UpperCasePipe, value);
        }
        return value.toUpperCase();
    };
    return UpperCasePipe;
}());
UpperCasePipe.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Pipe"], args: [{ name: 'uppercase' },] },
];
/**
 * @nocollapse
 */
UpperCasePipe.ctorParameters = function () { return []; };
var NumberFormatStyle = {};
NumberFormatStyle.Decimal = 0;
NumberFormatStyle.Percent = 1;
NumberFormatStyle.Currency = 2;
NumberFormatStyle[NumberFormatStyle.Decimal] = "Decimal";
NumberFormatStyle[NumberFormatStyle.Percent] = "Percent";
NumberFormatStyle[NumberFormatStyle.Currency] = "Currency";
var NumberFormatter = (function () {
    function NumberFormatter() {
    }
    /**
     * @param {?} num
     * @param {?} locale
     * @param {?} style
     * @param {?=} __3
     * @return {?}
     */
    NumberFormatter.format = function (num, locale, style, _a) {
        var _b = _a === void 0 ? {} : _a, minimumIntegerDigits = _b.minimumIntegerDigits, minimumFractionDigits = _b.minimumFractionDigits, maximumFractionDigits = _b.maximumFractionDigits, currency = _b.currency, _c = _b.currencyAsSymbol, currencyAsSymbol = _c === void 0 ? false : _c;
        var /** @type {?} */ options = {
            minimumIntegerDigits: minimumIntegerDigits,
            minimumFractionDigits: minimumFractionDigits,
            maximumFractionDigits: maximumFractionDigits,
            style: NumberFormatStyle[style].toLowerCase()
        };
        if (style == NumberFormatStyle.Currency) {
            options.currency = typeof currency == 'string' ? currency : undefined;
            options.currencyDisplay = currencyAsSymbol ? 'symbol' : 'code';
        }
        return new Intl.NumberFormat(locale, options).format(num);
    };
    return NumberFormatter;
}());
var DATE_FORMATS_SPLIT = /((?:[^yMLdHhmsazZEwGjJ']+)|(?:'(?:[^']|'')*')|(?:E+|y+|M+|L+|d+|H+|h+|J+|j+|m+|s+|a|z|Z|G+|w+))(.*)/;
var PATTERN_ALIASES = {
    // Keys are quoted so they do not get renamed during closure compilation.
    'yMMMdjms': datePartGetterFactory(combine([
        digitCondition('year', 1),
        nameCondition('month', 3),
        digitCondition('day', 1),
        digitCondition('hour', 1),
        digitCondition('minute', 1),
        digitCondition('second', 1),
    ])),
    'yMdjm': datePartGetterFactory(combine([
        digitCondition('year', 1), digitCondition('month', 1), digitCondition('day', 1),
        digitCondition('hour', 1), digitCondition('minute', 1)
    ])),
    'yMMMMEEEEd': datePartGetterFactory(combine([
        digitCondition('year', 1), nameCondition('month', 4), nameCondition('weekday', 4),
        digitCondition('day', 1)
    ])),
    'yMMMMd': datePartGetterFactory(combine([digitCondition('year', 1), nameCondition('month', 4), digitCondition('day', 1)])),
    'yMMMd': datePartGetterFactory(combine([digitCondition('year', 1), nameCondition('month', 3), digitCondition('day', 1)])),
    'yMd': datePartGetterFactory(combine([digitCondition('year', 1), digitCondition('month', 1), digitCondition('day', 1)])),
    'jms': datePartGetterFactory(combine([digitCondition('hour', 1), digitCondition('second', 1), digitCondition('minute', 1)])),
    'jm': datePartGetterFactory(combine([digitCondition('hour', 1), digitCondition('minute', 1)]))
};
var DATE_FORMATS = {
    // Keys are quoted so they do not get renamed.
    'yyyy': datePartGetterFactory(digitCondition('year', 4)),
    'yy': datePartGetterFactory(digitCondition('year', 2)),
    'y': datePartGetterFactory(digitCondition('year', 1)),
    'MMMM': datePartGetterFactory(nameCondition('month', 4)),
    'MMM': datePartGetterFactory(nameCondition('month', 3)),
    'MM': datePartGetterFactory(digitCondition('month', 2)),
    'M': datePartGetterFactory(digitCondition('month', 1)),
    'LLLL': datePartGetterFactory(nameCondition('month', 4)),
    'L': datePartGetterFactory(nameCondition('month', 1)),
    'dd': datePartGetterFactory(digitCondition('day', 2)),
    'd': datePartGetterFactory(digitCondition('day', 1)),
    'HH': digitModifier(hourExtractor(datePartGetterFactory(hour12Modify(digitCondition('hour', 2), false)))),
    'H': hourExtractor(datePartGetterFactory(hour12Modify(digitCondition('hour', 1), false))),
    'hh': digitModifier(hourExtractor(datePartGetterFactory(hour12Modify(digitCondition('hour', 2), true)))),
    'h': hourExtractor(datePartGetterFactory(hour12Modify(digitCondition('hour', 1), true))),
    'jj': datePartGetterFactory(digitCondition('hour', 2)),
    'j': datePartGetterFactory(digitCondition('hour', 1)),
    'mm': digitModifier(datePartGetterFactory(digitCondition('minute', 2))),
    'm': datePartGetterFactory(digitCondition('minute', 1)),
    'ss': digitModifier(datePartGetterFactory(digitCondition('second', 2))),
    's': datePartGetterFactory(digitCondition('second', 1)),
    // while ISO 8601 requires fractions to be prefixed with `.` or `,`
    // we can be just safely rely on using `sss` since we currently don't support single or two digit
    // fractions
    'sss': datePartGetterFactory(digitCondition('second', 3)),
    'EEEE': datePartGetterFactory(nameCondition('weekday', 4)),
    'EEE': datePartGetterFactory(nameCondition('weekday', 3)),
    'EE': datePartGetterFactory(nameCondition('weekday', 2)),
    'E': datePartGetterFactory(nameCondition('weekday', 1)),
    'a': hourClockExtractor(datePartGetterFactory(hour12Modify(digitCondition('hour', 1), true))),
    'Z': timeZoneGetter('short'),
    'z': timeZoneGetter('long'),
    'ww': datePartGetterFactory({}),
    // first Thursday of the year. not support ?
    'w': datePartGetterFactory({}),
    // of the year not support ?
    'G': datePartGetterFactory(nameCondition('era', 1)),
    'GG': datePartGetterFactory(nameCondition('era', 2)),
    'GGG': datePartGetterFactory(nameCondition('era', 3)),
    'GGGG': datePartGetterFactory(nameCondition('era', 4))
};
/**
 * @param {?} inner
 * @return {?}
 */
function digitModifier(inner) {
    return function (date, locale) {
        var /** @type {?} */ result = inner(date, locale);
        return result.length == 1 ? '0' + result : result;
    };
}
/**
 * @param {?} inner
 * @return {?}
 */
function hourClockExtractor(inner) {
    return function (date, locale) { return inner(date, locale).split(' ')[1]; };
}
/**
 * @param {?} inner
 * @return {?}
 */
function hourExtractor(inner) {
    return function (date, locale) { return inner(date, locale).split(' ')[0]; };
}
/**
 * @param {?} date
 * @param {?} locale
 * @param {?} options
 * @return {?}
 */
function intlDateFormat(date, locale, options) {
    return new Intl.DateTimeFormat(locale, options).format(date).replace(/[\u200e\u200f]/g, '');
}
/**
 * @param {?} timezone
 * @return {?}
 */
function timeZoneGetter(timezone) {
    // To workaround `Intl` API restriction for single timezone let format with 24 hours
    var /** @type {?} */ options = { hour: '2-digit', hour12: false, timeZoneName: timezone };
    return function (date, locale) {
        var /** @type {?} */ result = intlDateFormat(date, locale, options);
        // Then extract first 3 letters that related to hours
        return result ? result.substring(3) : '';
    };
}
/**
 * @param {?} options
 * @param {?} value
 * @return {?}
 */
function hour12Modify(options, value) {
    options.hour12 = value;
    return options;
}
/**
 * @param {?} prop
 * @param {?} len
 * @return {?}
 */
function digitCondition(prop, len) {
    var /** @type {?} */ result = {};
    result[prop] = len === 2 ? '2-digit' : 'numeric';
    return result;
}
/**
 * @param {?} prop
 * @param {?} len
 * @return {?}
 */
function nameCondition(prop, len) {
    var /** @type {?} */ result = {};
    if (len < 4) {
        result[prop] = len > 1 ? 'short' : 'narrow';
    }
    else {
        result[prop] = 'long';
    }
    return result;
}
/**
 * @param {?} options
 * @return {?}
 */
function combine(options) {
    return ((Object)).assign.apply(((Object)), [{}].concat(options));
}
/**
 * @param {?} ret
 * @return {?}
 */
function datePartGetterFactory(ret) {
    return function (date, locale) { return intlDateFormat(date, locale, ret); };
}
var DATE_FORMATTER_CACHE = new Map();
/**
 * @param {?} format
 * @param {?} date
 * @param {?} locale
 * @return {?}
 */
function dateFormatter(format, date, locale) {
    var /** @type {?} */ fn = PATTERN_ALIASES[format];
    if (fn)
        return fn(date, locale);
    var /** @type {?} */ cacheKey = format;
    var /** @type {?} */ parts = DATE_FORMATTER_CACHE.get(cacheKey);
    if (!parts) {
        parts = [];
        var /** @type {?} */ match = void 0;
        DATE_FORMATS_SPLIT.exec(format);
        var /** @type {?} */ _format = format;
        while (_format) {
            match = DATE_FORMATS_SPLIT.exec(_format);
            if (match) {
                parts = parts.concat(match.slice(1));
                _format = ((parts.pop()));
            }
            else {
                parts.push(_format);
                _format = null;
            }
        }
        DATE_FORMATTER_CACHE.set(cacheKey, parts);
    }
    return parts.reduce(function (text, part) {
        var /** @type {?} */ fn = DATE_FORMATS[part];
        return text + (fn ? fn(date, locale) : partToTime(part));
    }, '');
}
/**
 * @param {?} part
 * @return {?}
 */
function partToTime(part) {
    return part === '\'\'' ? '\'' : part.replace(/(^'|'$)/g, '').replace(/''/g, '\'');
}
var DateFormatter = (function () {
    function DateFormatter() {
    }
    /**
     * @param {?} date
     * @param {?} locale
     * @param {?} pattern
     * @return {?}
     */
    DateFormatter.format = function (date, locale, pattern) {
        return dateFormatter(pattern, date, locale);
    };
    return DateFormatter;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var _NUMBER_FORMAT_REGEXP = /^(\d+)?\.((\d+)(-(\d+))?)?$/;
/**
 * @param {?} pipe
 * @param {?} locale
 * @param {?} value
 * @param {?} style
 * @param {?=} digits
 * @param {?=} currency
 * @param {?=} currencyAsSymbol
 * @return {?}
 */
function formatNumber(pipe, locale, value, style, digits, currency, currencyAsSymbol) {
    if (currency === void 0) { currency = null; }
    if (currencyAsSymbol === void 0) { currencyAsSymbol = false; }
    if (value == null)
        return null;
    // Convert strings to numbers
    value = typeof value === 'string' && isNumeric(value) ? +value : value;
    if (typeof value !== 'number') {
        throw invalidPipeArgumentError(pipe, value);
    }
    var /** @type {?} */ minInt = undefined;
    var /** @type {?} */ minFraction = undefined;
    var /** @type {?} */ maxFraction = undefined;
    if (style !== NumberFormatStyle.Currency) {
        // rely on Intl default for currency
        minInt = 1;
        minFraction = 0;
        maxFraction = 3;
    }
    if (digits) {
        var /** @type {?} */ parts = digits.match(_NUMBER_FORMAT_REGEXP);
        if (parts === null) {
            throw new Error(digits + " is not a valid digit info for number pipes");
        }
        if (parts[1] != null) {
            minInt = parseIntAutoRadix(parts[1]);
        }
        if (parts[3] != null) {
            minFraction = parseIntAutoRadix(parts[3]);
        }
        if (parts[5] != null) {
            maxFraction = parseIntAutoRadix(parts[5]);
        }
    }
    return NumberFormatter.format(/** @type {?} */ (value), locale, style, {
        minimumIntegerDigits: minInt,
        minimumFractionDigits: minFraction,
        maximumFractionDigits: maxFraction,
        currency: currency,
        currencyAsSymbol: currencyAsSymbol,
    });
}
/**
 * \@ngModule CommonModule
 * \@whatItDoes Formats a number according to locale rules.
 * \@howToUse `number_expression | number[:digitInfo]`
 *
 * Formats a number as text. Group sizing and separator and other locale-specific
 * configurations are based on the active locale.
 *
 * where `expression` is a number:
 *  - `digitInfo` is a `string` which has a following format: <br>
 *     <code>{minIntegerDigits}.{minFractionDigits}-{maxFractionDigits}</code>
 *   - `minIntegerDigits` is the minimum number of integer digits to use. Defaults to `1`.
 *   - `minFractionDigits` is the minimum number of digits after fraction. Defaults to `0`.
 *   - `maxFractionDigits` is the maximum number of digits after fraction. Defaults to `3`.
 *
 * For more information on the acceptable range for each of these numbers and other
 * details see your native internationalization library.
 *
 * WARNING: this pipe uses the Internationalization API which is not yet available in all browsers
 * and may require a polyfill. See {\@linkDocs guide/browser-support} for details.
 *
 * ### Example
 *
 * {\@example common/pipes/ts/number_pipe.ts region='NumberPipe'}
 *
 * \@stable
 */
var DecimalPipe = (function () {
    /**
     * @param {?} _locale
     */
    function DecimalPipe(_locale) {
        this._locale = _locale;
    }
    /**
     * @param {?} value
     * @param {?=} digits
     * @return {?}
     */
    DecimalPipe.prototype.transform = function (value, digits) {
        return formatNumber(DecimalPipe, this._locale, value, NumberFormatStyle.Decimal, digits);
    };
    return DecimalPipe;
}());
DecimalPipe.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Pipe"], args: [{ name: 'number' },] },
];
/**
 * @nocollapse
 */
DecimalPipe.ctorParameters = function () { return [
    { type: undefined, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_0__angular_core__["LOCALE_ID"],] },] },
]; };
/**
 * \@ngModule CommonModule
 * \@whatItDoes Formats a number as a percentage according to locale rules.
 * \@howToUse `number_expression | percent[:digitInfo]`
 *
 * \@description
 *
 * Formats a number as percentage.
 *
 * - `digitInfo` See {\@link DecimalPipe} for detailed description.
 *
 * WARNING: this pipe uses the Internationalization API which is not yet available in all browsers
 * and may require a polyfill. See {\@linkDocs guide/browser-support} for details.
 *
 * ### Example
 *
 * {\@example common/pipes/ts/number_pipe.ts region='PercentPipe'}
 *
 * \@stable
 */
var PercentPipe = (function () {
    /**
     * @param {?} _locale
     */
    function PercentPipe(_locale) {
        this._locale = _locale;
    }
    /**
     * @param {?} value
     * @param {?=} digits
     * @return {?}
     */
    PercentPipe.prototype.transform = function (value, digits) {
        return formatNumber(PercentPipe, this._locale, value, NumberFormatStyle.Percent, digits);
    };
    return PercentPipe;
}());
PercentPipe.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Pipe"], args: [{ name: 'percent' },] },
];
/**
 * @nocollapse
 */
PercentPipe.ctorParameters = function () { return [
    { type: undefined, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_0__angular_core__["LOCALE_ID"],] },] },
]; };
/**
 * \@ngModule CommonModule
 * \@whatItDoes Formats a number as currency using locale rules.
 * \@howToUse `number_expression | currency[:currencyCode[:symbolDisplay[:digitInfo]]]`
 * \@description
 *
 * Use `currency` to format a number as currency.
 *
 * - `currencyCode` is the [ISO 4217](https://en.wikipedia.org/wiki/ISO_4217) currency code, such
 *    as `USD` for the US dollar and `EUR` for the euro.
 * - `symbolDisplay` is a boolean indicating whether to use the currency symbol or code.
 *   - `true`: use symbol (e.g. `$`).
 *   - `false`(default): use code (e.g. `USD`).
 * - `digitInfo` See {\@link DecimalPipe} for detailed description.
 *
 * WARNING: this pipe uses the Internationalization API which is not yet available in all browsers
 * and may require a polyfill. See {\@linkDocs guide/browser-support} for details.
 *
 * ### Example
 *
 * {\@example common/pipes/ts/number_pipe.ts region='CurrencyPipe'}
 *
 * \@stable
 */
var CurrencyPipe = (function () {
    /**
     * @param {?} _locale
     */
    function CurrencyPipe(_locale) {
        this._locale = _locale;
    }
    /**
     * @param {?} value
     * @param {?=} currencyCode
     * @param {?=} symbolDisplay
     * @param {?=} digits
     * @return {?}
     */
    CurrencyPipe.prototype.transform = function (value, currencyCode, symbolDisplay, digits) {
        if (currencyCode === void 0) { currencyCode = 'USD'; }
        if (symbolDisplay === void 0) { symbolDisplay = false; }
        return formatNumber(CurrencyPipe, this._locale, value, NumberFormatStyle.Currency, digits, currencyCode, symbolDisplay);
    };
    return CurrencyPipe;
}());
CurrencyPipe.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Pipe"], args: [{ name: 'currency' },] },
];
/**
 * @nocollapse
 */
CurrencyPipe.ctorParameters = function () { return [
    { type: undefined, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_0__angular_core__["LOCALE_ID"],] },] },
]; };
/**
 * @param {?} text
 * @return {?}
 */
function parseIntAutoRadix(text) {
    var /** @type {?} */ result = parseInt(text);
    if (isNaN(result)) {
        throw new Error('Invalid integer literal when parsing ' + text);
    }
    return result;
}
/**
 * @param {?} value
 * @return {?}
 */
function isNumeric(value) {
    return !isNaN(value - parseFloat(value));
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var ISO8601_DATE_REGEX = /^(\d{4})-?(\d\d)-?(\d\d)(?:T(\d\d)(?::?(\d\d)(?::?(\d\d)(?:\.(\d+))?)?)?(Z|([+-])(\d\d):?(\d\d))?)?$/;
/**
 * \@ngModule CommonModule
 * \@whatItDoes Formats a date according to locale rules.
 * \@howToUse `date_expression | date[:format]`
 * \@description
 *
 * Where:
 * - `expression` is a date object or a number (milliseconds since UTC epoch) or an ISO string
 * (https://www.w3.org/TR/NOTE-datetime).
 * - `format` indicates which date/time components to include. The format can be predefined as
 *   shown below or custom as shown in the table.
 *   - `'medium'`: equivalent to `'yMMMdjms'` (e.g. `Sep 3, 2010, 12:05:08 PM` for `en-US`)
 *   - `'short'`: equivalent to `'yMdjm'` (e.g. `9/3/2010, 12:05 PM` for `en-US`)
 *   - `'fullDate'`: equivalent to `'yMMMMEEEEd'` (e.g. `Friday, September 3, 2010` for `en-US`)
 *   - `'longDate'`: equivalent to `'yMMMMd'` (e.g. `September 3, 2010` for `en-US`)
 *   - `'mediumDate'`: equivalent to `'yMMMd'` (e.g. `Sep 3, 2010` for `en-US`)
 *   - `'shortDate'`: equivalent to `'yMd'` (e.g. `9/3/2010` for `en-US`)
 *   - `'mediumTime'`: equivalent to `'jms'` (e.g. `12:05:08 PM` for `en-US`)
 *   - `'shortTime'`: equivalent to `'jm'` (e.g. `12:05 PM` for `en-US`)
 *
 *
 *  | Component | Symbol | Narrow | Short Form   | Long Form         | Numeric   | 2-digit   |
 *  |-----------|:------:|--------|--------------|-------------------|-----------|-----------|
 *  | era       |   G    | G (A)  | GGG (AD)     | GGGG (Anno Domini)| -         | -         |
 *  | year      |   y    | -      | -            | -                 | y (2015)  | yy (15)   |
 *  | month     |   M    | L (S)  | MMM (Sep)    | MMMM (September)  | M (9)     | MM (09)   |
 *  | day       |   d    | -      | -            | -                 | d (3)     | dd (03)   |
 *  | weekday   |   E    | E (S)  | EEE (Sun)    | EEEE (Sunday)     | -         | -         |
 *  | hour      |   j    | -      | -            | -                 | j (13)    | jj (13)   |
 *  | hour12    |   h    | -      | -            | -                 | h (1 PM)  | hh (01 PM)|
 *  | hour24    |   H    | -      | -            | -                 | H (13)    | HH (13)   |
 *  | minute    |   m    | -      | -            | -                 | m (5)     | mm (05)   |
 *  | second    |   s    | -      | -            | -                 | s (9)     | ss (09)   |
 *  | timezone  |   z    | -      | -            | z (Pacific Standard Time)| -  | -         |
 *  | timezone  |   Z    | -      | Z (GMT-8:00) | -                 | -         | -         |
 *  | timezone  |   a    | -      | a (PM)       | -                 | -         | -         |
 *
 * In javascript, only the components specified will be respected (not the ordering,
 * punctuations, ...) and details of the formatting will be dependent on the locale.
 *
 * Timezone of the formatted text will be the local system timezone of the end-user's machine.
 *
 * When the expression is a ISO string without time (e.g. 2016-09-19) the time zone offset is not
 * applied and the formatted text will have the same day, month and year of the expression.
 *
 * WARNINGS:
 * - this pipe is marked as pure hence it will not be re-evaluated when the input is mutated.
 *   Instead users should treat the date as an immutable object and change the reference when the
 *   pipe needs to re-run (this is to avoid reformatting the date on every change detection run
 *   which would be an expensive operation).
 * - this pipe uses the Internationalization API. Therefore it is only reliable in Chrome and Opera
 *   browsers.
 *
 * ### Examples
 *
 * Assuming `dateObj` is (year: 2015, month: 6, day: 15, hour: 21, minute: 43, second: 11)
 * in the _local_ time and locale is 'en-US':
 *
 * ```
 *     {{ dateObj | date }}               // output is 'Jun 15, 2015'
 *     {{ dateObj | date:'medium' }}      // output is 'Jun 15, 2015, 9:43:11 PM'
 *     {{ dateObj | date:'shortTime' }}   // output is '9:43 PM'
 *     {{ dateObj | date:'mmss' }}        // output is '43:11'
 * ```
 *
 * {\@example common/pipes/ts/date_pipe.ts region='DatePipe'}
 *
 * \@stable
 */
var DatePipe = (function () {
    /**
     * @param {?} _locale
     */
    function DatePipe(_locale) {
        this._locale = _locale;
    }
    /**
     * @param {?} value
     * @param {?=} pattern
     * @return {?}
     */
    DatePipe.prototype.transform = function (value, pattern) {
        if (pattern === void 0) { pattern = 'mediumDate'; }
        var /** @type {?} */ date;
        if (isBlank(value) || value !== value)
            return null;
        if (typeof value === 'string') {
            value = value.trim();
        }
        if (isDate(value)) {
            date = value;
        }
        else if (isNumeric(value)) {
            date = new Date(parseFloat(value));
        }
        else if (typeof value === 'string' && /^(\d{4}-\d{1,2}-\d{1,2})$/.test(value)) {
            /**
            * For ISO Strings without time the day, month and year must be extracted from the ISO String
            * before Date creation to avoid time offset and errors in the new Date.
            * If we only replace '-' with ',' in the ISO String ("2015,01,01"), and try to create a new
            * date, some browsers (e.g. IE 9) will throw an invalid Date error
            * If we leave the '-' ("2015-01-01") and try to create a new Date("2015-01-01") the timeoffset
            * is applied
            * Note: ISO months are 0 for January, 1 for February, ...
            */
            var _a = value.split('-').map(function (val) { return parseInt(val, 10); }), y = _a[0], m = _a[1], d = _a[2];
            date = new Date(y, m - 1, d);
        }
        else {
            date = new Date(value);
        }
        if (!isDate(date)) {
            var /** @type {?} */ match = void 0;
            if ((typeof value === 'string') && (match = value.match(ISO8601_DATE_REGEX))) {
                date = isoStringToDate(match);
            }
            else {
                throw invalidPipeArgumentError(DatePipe, value);
            }
        }
        return DateFormatter.format(date, this._locale, DatePipe._ALIASES[pattern] || pattern);
    };
    return DatePipe;
}());
/**
 * \@internal
 */
DatePipe._ALIASES = {
    'medium': 'yMMMdjms',
    'short': 'yMdjm',
    'fullDate': 'yMMMMEEEEd',
    'longDate': 'yMMMMd',
    'mediumDate': 'yMMMd',
    'shortDate': 'yMd',
    'mediumTime': 'jms',
    'shortTime': 'jm'
};
DatePipe.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Pipe"], args: [{ name: 'date', pure: true },] },
];
/**
 * @nocollapse
 */
DatePipe.ctorParameters = function () { return [
    { type: undefined, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_0__angular_core__["LOCALE_ID"],] },] },
]; };
/**
 * @param {?} obj
 * @return {?}
 */
function isBlank(obj) {
    return obj == null || obj === '';
}
/**
 * @param {?} obj
 * @return {?}
 */
function isDate(obj) {
    return obj instanceof Date && !isNaN(obj.valueOf());
}
/**
 * @param {?} match
 * @return {?}
 */
function isoStringToDate(match) {
    var /** @type {?} */ date = new Date(0);
    var /** @type {?} */ tzHour = 0;
    var /** @type {?} */ tzMin = 0;
    var /** @type {?} */ dateSetter = match[8] ? date.setUTCFullYear : date.setFullYear;
    var /** @type {?} */ timeSetter = match[8] ? date.setUTCHours : date.setHours;
    if (match[9]) {
        tzHour = toInt(match[9] + match[10]);
        tzMin = toInt(match[9] + match[11]);
    }
    dateSetter.call(date, toInt(match[1]), toInt(match[2]) - 1, toInt(match[3]));
    var /** @type {?} */ h = toInt(match[4] || '0') - tzHour;
    var /** @type {?} */ m = toInt(match[5] || '0') - tzMin;
    var /** @type {?} */ s = toInt(match[6] || '0');
    var /** @type {?} */ ms = Math.round(parseFloat('0.' + (match[7] || 0)) * 1000);
    timeSetter.call(date, h, m, s, ms);
    return date;
}
/**
 * @param {?} str
 * @return {?}
 */
function toInt(str) {
    return parseInt(str, 10);
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var _INTERPOLATION_REGEXP = /#/g;
/**
 * \@ngModule CommonModule
 * \@whatItDoes Maps a value to a string that pluralizes the value according to locale rules.
 * \@howToUse `expression | i18nPlural:mapping`
 * \@description
 *
 *  Where:
 *  - `expression` is a number.
 *  - `mapping` is an object that mimics the ICU format, see
 *    http://userguide.icu-project.org/formatparse/messages
 *
 *  ## Example
 *
 * {\@example common/pipes/ts/i18n_pipe.ts region='I18nPluralPipeComponent'}
 *
 * \@experimental
 */
var I18nPluralPipe = (function () {
    /**
     * @param {?} _localization
     */
    function I18nPluralPipe(_localization) {
        this._localization = _localization;
    }
    /**
     * @param {?} value
     * @param {?} pluralMap
     * @return {?}
     */
    I18nPluralPipe.prototype.transform = function (value, pluralMap) {
        if (value == null)
            return '';
        if (typeof pluralMap !== 'object' || pluralMap === null) {
            throw invalidPipeArgumentError(I18nPluralPipe, pluralMap);
        }
        var /** @type {?} */ key = getPluralCategory(value, Object.keys(pluralMap), this._localization);
        return pluralMap[key].replace(_INTERPOLATION_REGEXP, value.toString());
    };
    return I18nPluralPipe;
}());
I18nPluralPipe.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Pipe"], args: [{ name: 'i18nPlural', pure: true },] },
];
/**
 * @nocollapse
 */
I18nPluralPipe.ctorParameters = function () { return [
    { type: NgLocalization, },
]; };
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * \@ngModule CommonModule
 * \@whatItDoes Generic selector that displays the string that matches the current value.
 * \@howToUse `expression | i18nSelect:mapping`
 * \@description
 *
 *  Where `mapping` is an object that indicates the text that should be displayed
 *  for different values of the provided `expression`.
 *  If none of the keys of the mapping match the value of the `expression`, then the content
 *  of the `other` key is returned when present, otherwise an empty string is returned.
 *
 *  ## Example
 *
 * {\@example common/pipes/ts/i18n_pipe.ts region='I18nSelectPipeComponent'}
 *
 *  \@experimental
 */
var I18nSelectPipe = (function () {
    function I18nSelectPipe() {
    }
    /**
     * @param {?} value
     * @param {?} mapping
     * @return {?}
     */
    I18nSelectPipe.prototype.transform = function (value, mapping) {
        if (value == null)
            return '';
        if (typeof mapping !== 'object' || typeof value !== 'string') {
            throw invalidPipeArgumentError(I18nSelectPipe, mapping);
        }
        if (mapping.hasOwnProperty(value)) {
            return mapping[value];
        }
        if (mapping.hasOwnProperty('other')) {
            return mapping['other'];
        }
        return '';
    };
    return I18nSelectPipe;
}());
I18nSelectPipe.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Pipe"], args: [{ name: 'i18nSelect', pure: true },] },
];
/**
 * @nocollapse
 */
I18nSelectPipe.ctorParameters = function () { return []; };
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * \@ngModule CommonModule
 * \@whatItDoes Converts value into JSON string.
 * \@howToUse `expression | json`
 * \@description
 *
 * Converts value into string using `JSON.stringify`. Useful for debugging.
 *
 * ### Example
 * {\@example common/pipes/ts/json_pipe.ts region='JsonPipe'}
 *
 * \@stable
 */
var JsonPipe = (function () {
    function JsonPipe() {
    }
    /**
     * @param {?} value
     * @return {?}
     */
    JsonPipe.prototype.transform = function (value) { return JSON.stringify(value, null, 2); };
    return JsonPipe;
}());
JsonPipe.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Pipe"], args: [{ name: 'json', pure: false },] },
];
/**
 * @nocollapse
 */
JsonPipe.ctorParameters = function () { return []; };
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * \@ngModule CommonModule
 * \@whatItDoes Creates a new List or String containing a subset (slice) of the elements.
 * \@howToUse `array_or_string_expression | slice:start[:end]`
 * \@description
 *
 * Where the input expression is a `List` or `String`, and:
 * - `start`: The starting index of the subset to return.
 *   - **a positive integer**: return the item at `start` index and all items after
 *     in the list or string expression.
 *   - **a negative integer**: return the item at `start` index from the end and all items after
 *     in the list or string expression.
 *   - **if positive and greater than the size of the expression**: return an empty list or string.
 *   - **if negative and greater than the size of the expression**: return entire list or string.
 * - `end`: The ending index of the subset to return.
 *   - **omitted**: return all items until the end.
 *   - **if positive**: return all items before `end` index of the list or string.
 *   - **if negative**: return all items before `end` index from the end of the list or string.
 *
 * All behavior is based on the expected behavior of the JavaScript API `Array.prototype.slice()`
 * and `String.prototype.slice()`.
 *
 * When operating on a [List], the returned list is always a copy even when all
 * the elements are being returned.
 *
 * When operating on a blank value, the pipe returns the blank value.
 *
 * ## List Example
 *
 * This `ngFor` example:
 *
 * {\@example common/pipes/ts/slice_pipe.ts region='SlicePipe_list'}
 *
 * produces the following:
 *
 *     <li>b</li>
 *     <li>c</li>
 *
 * ## String Examples
 *
 * {\@example common/pipes/ts/slice_pipe.ts region='SlicePipe_string'}
 *
 * \@stable
 */
var SlicePipe = (function () {
    function SlicePipe() {
    }
    /**
     * @param {?} value
     * @param {?} start
     * @param {?=} end
     * @return {?}
     */
    SlicePipe.prototype.transform = function (value, start, end) {
        if (value == null)
            return value;
        if (!this.supports(value)) {
            throw invalidPipeArgumentError(SlicePipe, value);
        }
        return value.slice(start, end);
    };
    /**
     * @param {?} obj
     * @return {?}
     */
    SlicePipe.prototype.supports = function (obj) { return typeof obj === 'string' || Array.isArray(obj); };
    return SlicePipe;
}());
SlicePipe.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Pipe"], args: [{ name: 'slice', pure: false },] },
];
/**
 * @nocollapse
 */
SlicePipe.ctorParameters = function () { return []; };
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @module
 * @description
 * This module provides a set of common Pipes.
 */
/**
 * A collection of Angular pipes that are likely to be used in each and every application.
 */
var COMMON_PIPES = [
    AsyncPipe,
    UpperCasePipe,
    LowerCasePipe,
    JsonPipe,
    SlicePipe,
    DecimalPipe,
    PercentPipe,
    TitleCasePipe,
    CurrencyPipe,
    DatePipe,
    I18nPluralPipe,
    I18nSelectPipe,
];
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * The module that includes all the basic Angular directives like {\@link NgIf}, {\@link NgForOf}, ...
 *
 * \@stable
 */
var CommonModule = (function () {
    function CommonModule() {
    }
    return CommonModule;
}());
CommonModule.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{
                declarations: [COMMON_DIRECTIVES, COMMON_PIPES],
                exports: [COMMON_DIRECTIVES, COMMON_PIPES],
                providers: [
                    { provide: NgLocalization, useClass: NgLocaleLocalization },
                ],
            },] },
];
/**
 * @nocollapse
 */
CommonModule.ctorParameters = function () { return []; };
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var PLATFORM_BROWSER_ID = 'browser';
var PLATFORM_SERVER_ID = 'server';
var PLATFORM_WORKER_APP_ID = 'browserWorkerApp';
var PLATFORM_WORKER_UI_ID = 'browserWorkerUi';
/**
 * Returns whether a platform id represents a browser platform.
 * \@experimental
 * @param {?} platformId
 * @return {?}
 */
function isPlatformBrowser(platformId) {
    return platformId === PLATFORM_BROWSER_ID;
}
/**
 * Returns whether a platform id represents a server platform.
 * \@experimental
 * @param {?} platformId
 * @return {?}
 */
function isPlatformServer(platformId) {
    return platformId === PLATFORM_SERVER_ID;
}
/**
 * Returns whether a platform id represents a web worker app platform.
 * \@experimental
 * @param {?} platformId
 * @return {?}
 */
function isPlatformWorkerApp(platformId) {
    return platformId === PLATFORM_WORKER_APP_ID;
}
/**
 * Returns whether a platform id represents a web worker UI platform.
 * \@experimental
 * @param {?} platformId
 * @return {?}
 */
function isPlatformWorkerUi(platformId) {
    return platformId === PLATFORM_WORKER_UI_ID;
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @module
 * @description
 * Entry point for all public APIs of the common package.
 */
/**
 * \@stable
 */
var VERSION = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["Version"]('4.1.0');
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @module
 * @description
 * Entry point for all public APIs of the common package.
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @module
 * @description
 * Entry point for all public APIs of the common package.
 */
// This file only reexports content of the `src` folder. Keep it that way.
/**
 * Generated bundle index. Do not edit.
 */

//# sourceMappingURL=common.es5.js.map


/***/ }),

/***/ "2PUf":
/***/ (function(module, exports) {

exports.config = {"status":true,"model":{"plazza":"true","released":1404918051,"title-en":"Chancellor Chess","module":"chessbase","summary":"Chess on 9x9 (1887)","thumbnail":"chancellor-thumb.png","rules":{"en":"chancellor-rules.html"},"credits":{"en":"chancellor-credits.html"},"gameOptions":{"preventRepeat":true,"uctTransposition":"state","uctIgnoreLoop":false,"levelOptions":{"pieceValueFactor":1,"pieceValueRatioFactor":1,"posValueFactor":0.1,"averageDistKingFactor":-0.01,"castleFactor":0.1,"minorPiecesMovedFactor":0.1,"checkFactor":0.2,"endingKingFreedomFactor":0.01,"endingDistKingFactor":0.05,"distKingCornerFactor":0.1,"distPawnPromo1Factor":0.3,"distPawnPromo2Factor":0.1,"distPawnPromo3Factor":0.05}},"obsolete":false,"js":["base-model.js","grid-geo-model.js","chancellor-model.js"],"description":{"en":"chancellor-description.html"},"levels":[{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"easy","label":"Easy","maxNodes":1000},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"fast","label":"Fast [1sec]","maxDuration":1,"isDefault":true},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"medium","label":"Medium","maxNodes":10000,"maxDuration":10},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"strong","label":"Strong","maxNodes":20000,"maxDuration":15}]},"view":{"title-en":"Chessbase view","module":"chessbase","xdView":true,"css":["chessbase.css"],"preferredRatio":1,"useShowMoves":true,"useNotation":true,"useAutoComplete":true,"defaultOptions":{"sounds":true,"moves":true,"notation":false,"autocomplete":false},"skins":[{"name":"skin3d","title":"3D Classic","3d":true,"preload":["smoothedfilegeo|0|/res/ring-target.js","image|/res/images/cancel.png","image|/res/images/wikipedia.png","smoothedfilegeo|0|/res/fairy/pawn/pawn.js","image|/res/fairy/pawn/pawn-diffusemap.jpg","image|/res/fairy/pawn/pawn-normalmap.jpg","smoothedfilegeo|0|/res/fairy/knight/knight.js","image|/res/fairy/knight/knight-diffusemap.jpg","image|/res/fairy/knight/knight-normalmap.jpg","smoothedfilegeo|0|/res/fairy/bishop/bishop.js","image|/res/fairy/bishop/bishop-diffusemap.jpg","image|/res/fairy/bishop/bishop-normalmap.jpg","smoothedfilegeo|0|/res/fairy/queen/queen.js","image|/res/fairy/queen/queen-diffusemap.jpg","image|/res/fairy/queen/queen-normalmap.jpg","smoothedfilegeo|0|/res/fairy/king/king.js","image|/res/fairy/king/king-diffusemap.jpg","image|/res/fairy/king/king-normalmap.jpg","smoothedfilegeo|0|/res/fairy/rook/rook.js","image|/res/fairy/rook/rook-diffusemap.jpg","image|/res/fairy/rook/rook-normalmap.jpg","smoothedfilegeo|0|/res/fairy/marshall/marshall.js","image|/res/fairy/marshall/marshall-diffusemap.jpg","image|/res/fairy/marshall/marshall-normalmap.jpg"],"world":{"lightIntensity":1.3,"skyLightIntensity":1.2,"lightCastShadow":true,"fog":false,"color":4686804,"lightPosition":{"x":-9,"y":9,"z":9},"skyLightPosition":{"x":9,"y":9,"z":9},"lightShadowDarkness":0.55,"ambientLightColor":2236962},"camera":{"fov":45,"distMax":50,"radius":18,"elevationAngle":60,"elevationMin":0}},{"name":"skin2d","title":"2D Classic","3d":false,"preload":["image|/res/images/cancel.png","image|/res/images/whitebg.png","image|/res/fairy/wikipedia-fairy-sprites.png"]}],"animateSelfMoves":false,"switchable":true,"sounds":{"move1":"alq_move1","move2":"alq_move2","move3":"alq_move3","move4":"alq_move2","tac1":"alq_tac1","tac2":"alq_tac2","tac3":"alq_tac1","promo":"promo","usermove":null},"js":["base-view.js","grid-board-view.js","fairy-set-view.js","modern-view.js"],"visuals":{"600x600":["res/visuals/chancellor-600x600-3d.jpg","res/visuals/chancellor-600x600-2d.jpg"]}}}

/***/ }),

/***/ "2ene":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ActionTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StoreDevtoolActions; });
var ActionTypes = {
    PERFORM_ACTION: 'PERFORM_ACTION',
    RESET: 'RESET',
    ROLLBACK: 'ROLLBACK',
    COMMIT: 'COMMIT',
    SWEEP: 'SWEEP',
    TOGGLE_ACTION: 'TOGGLE_ACTION',
    SET_ACTIONS_ACTIVE: 'SET_ACTIONS_ACTIVE',
    JUMP_TO_STATE: 'JUMP_TO_STATE',
    IMPORT_STATE: 'IMPORT_STATE'
};
/**
* Action creators to change the History state.
*/
var StoreDevtoolActions = {
    performAction: function (action) {
        if (typeof action.type === 'undefined') {
            throw new Error('Actions may not have an undefined "type" property. ' +
                'Have you misspelled a constant?');
        }
        return { type: ActionTypes.PERFORM_ACTION, action: action, timestamp: Date.now() };
    },
    reset: function () {
        return { type: ActionTypes.RESET, timestamp: Date.now() };
    },
    rollback: function () {
        return { type: ActionTypes.ROLLBACK, timestamp: Date.now() };
    },
    commit: function () {
        return { type: ActionTypes.COMMIT, timestamp: Date.now() };
    },
    sweep: function () {
        return { type: ActionTypes.SWEEP };
    },
    toggleAction: function (id) {
        return { type: ActionTypes.TOGGLE_ACTION, id: id };
    },
    setActionsActive: function (start, end, active) {
        if (active === void 0) { active = true; }
        return { type: ActionTypes.SET_ACTIONS_ACTIVE, start: start, end: end, active: active };
    },
    jumpToState: function (index) {
        return { type: ActionTypes.JUMP_TO_STATE, index: index };
    },
    importState: function (nextLiftedState) {
        return { type: ActionTypes.IMPORT_STATE, nextLiftedState: nextLiftedState };
    }
};
//# sourceMappingURL=actions.js.map

/***/ }),

/***/ "2iB7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("3j3K");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return STORE_DEVTOOLS_CONFIG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return INITIAL_OPTIONS; });

var STORE_DEVTOOLS_CONFIG = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["OpaqueToken"]('@ngrx/devtools Options');
var INITIAL_OPTIONS = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["OpaqueToken"]('@ngrx/devtools Initial Config');
//# sourceMappingURL=config.js.map

/***/ }),

/***/ "2jZb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__("mmVS");
/**
 * Counts the number of emissions on the source and emits that number when the
 * source completes.
 *
 * <span class="informal">Tells how many values were emitted, when the source
 * completes.</span>
 *
 * <img src="./img/count.png" width="100%">
 *
 * `count` transforms an Observable that emits values into an Observable that
 * emits a single value that represents the number of values emitted by the
 * source Observable. If the source Observable terminates with an error, `count`
 * will pass this error notification along without emitting a value first. If
 * the source Observable does not terminate at all, `count` will neither emit
 * a value nor terminate. This operator takes an optional `predicate` function
 * as argument, in which case the output emission will represent the number of
 * source values that matched `true` with the `predicate`.
 *
 * @example <caption>Counts how many seconds have passed before the first click happened</caption>
 * var seconds = Rx.Observable.interval(1000);
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var secondsBeforeClick = seconds.takeUntil(clicks);
 * var result = secondsBeforeClick.count();
 * result.subscribe(x => console.log(x));
 *
 * @example <caption>Counts how many odd numbers are there between 1 and 7</caption>
 * var numbers = Rx.Observable.range(1, 7);
 * var result = numbers.count(i => i % 2 === 1);
 * result.subscribe(x => console.log(x));
 *
 * // Results in:
 * // 4
 *
 * @see {@link max}
 * @see {@link min}
 * @see {@link reduce}
 *
 * @param {function(value: T, i: number, source: Observable<T>): boolean} [predicate] A
 * boolean function to select what values are to be counted. It is provided with
 * arguments of:
 * - `value`: the value from the source Observable.
 * - `index`: the (zero-based) "index" of the value from the source Observable.
 * - `source`: the source Observable instance itself.
 * @return {Observable} An Observable of one number that represents the count as
 * described above.
 * @method count
 * @owner Observable
 */
function count(predicate) {
    return this.lift(new CountOperator(predicate, this));
}
exports.count = count;
var CountOperator = (function () {
    function CountOperator(predicate, source) {
        this.predicate = predicate;
        this.source = source;
    }
    CountOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new CountSubscriber(subscriber, this.predicate, this.source));
    };
    return CountOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var CountSubscriber = (function (_super) {
    __extends(CountSubscriber, _super);
    function CountSubscriber(destination, predicate, source) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.source = source;
        this.count = 0;
        this.index = 0;
    }
    CountSubscriber.prototype._next = function (value) {
        if (this.predicate) {
            this._tryPredicate(value);
        }
        else {
            this.count++;
        }
    };
    CountSubscriber.prototype._tryPredicate = function (value) {
        var result;
        try {
            result = this.predicate(value, this.index++, this.source);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        if (result) {
            this.count++;
        }
    };
    CountSubscriber.prototype._complete = function () {
        this.destination.next(this.count);
        this.destination.complete();
    };
    return CountSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=count.js.map

/***/ }),

/***/ "33Pm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var BoundCallbackObservable_1 = __webpack_require__("0EZR");
exports.bindCallback = BoundCallbackObservable_1.BoundCallbackObservable.create;
//# sourceMappingURL=bindCallback.js.map

/***/ }),

/***/ "35uU":
/***/ (function(module, exports) {

exports.model=Model={Game:{},Board:{},Move:{}},Model.Game.InitGameInfo=function(){},Model.Game.BuildGraphCoord=function(){var i=[],t=[];this.g.Graph=i,this.g.Coord=t},Model.Game.InitGame=function(){this.BuildGraphCoord(),this.g.TripletsByPos=[];for(var i=0;i<this.g.Coord.length;i++)this.g.TripletsByPos[i]=[];for(var i in this.g.Triplets)if(this.g.Triplets.hasOwnProperty(i)){var t=this.g.Triplets[i];for(var e in t)if(t.hasOwnProperty(e)){var s=t[e];this.g.TripletsByPos[s].push(t)}}this.InitGameExtra()},Model.Game.DestroyGame=function(){},Model.Game.MillsDirections=4,Model.Game.MillsEachDirection=function(i,t){for(var e=0;e<this.MillsDirections;e++){var s=this.g.Graph[i][e];null!=s&&t(s)}},Model.Move.Init=function(i){this.f=i.f,this.t=i.t,this.c=i.c},Model.Move.CopyFrom=function(i){this.f=i.f,this.t=i.t,this.c=i.c},Model.Move.Equals=function(i){return this.t==i.t&&this.c==i.c&&this.f==i.f},Model.Move.ToString=function(){var i="";return this.f>-1&&(i+=this.f+">"),i+=this.t,this.c>-1&&(i+="x"+this.c),i},Model.Board.Init=function(i){},Model.Board.InitialPosition=function(i){var t=i.g.Coord.length,e=i.mOptions.mencount;this.board=[];for(var s=0;s<t;s++)this.board[s]=-1;this.pieces=[],this.dock={1:[],"-1":[]},this.menCount={1:0,"-1":0};for(var o=0,r=0;r<2;r++)for(var n=0==r?1:-1,h=0;h<e;h++)this.dock[n].unshift(o),this.pieces.push({s:n,a:!0,d:h,p:-1,i:o++});this.placing=!0},Model.Board.StaticGenerateMoves=function(i){if(0==i.mFullPlayedMoves.length){for(var t=[],e=0;e<i.g.Coord.length;e++)t.push({f:-1,t:e,c:-1});return t}return null},Model.Board.GenerateMoves=function(i){this.mMoves=[],this.placing?this.GeneratePlacingMoves(i):i.mOptions.canFly?this.GenerateFlyingMoves(i):this.GenerateMovingMoves(i),0==this.mMoves.length&&(this.mFinished=!0,this.menCount[JocGame.PLAYER_A]+this.menCount[JocGame.PLAYER_B]==i.g.Coord.length?this.mWinner=JocGame.DRAW:this.mWinner=-this.mWho)},Model.Board.GeneratePlacingMoves=function(i){for(var t=0;t<i.g.Coord.length;t++)if(this.board[t]==-1){var e=!0;if(void 0!==i.mLevelInfo&&i.mCurrentLevel>=0){var s=i.mLevelInfo.maxDepth-i.mCurrentLevel;if(s>=i.mLevelInfo.placingRace){e=!1;for(var o in i.g.TripletsByPos[t])if(i.g.TripletsByPos[t].hasOwnProperty(o)){for(var r=i.g.TripletsByPos[t][o],n=0,h=0,a=0,l=0;l<3;l++)this.board[r[l]]==-1?a++:this.pieces[this.board[r[l]]].s==this.mWho?n++:h++;if(2==n||1==n&&0==h||2==h){e=!0;break}}}}e&&this.GenerateCapturingMoves(i,{f:-1,t:t,c:-1})}},Model.Board.GenerateMovingMoves=function(i){$this=this;for(var t=0;t<this.pieces.length;t++){var e=this.pieces[t];e.a&&e.s==this.mWho&&i.MillsEachDirection(e.p,function(t){$this.board[t]==-1&&$this.GenerateCapturingMoves(i,{f:e.p,t:t,c:-1})})}},Model.Board.GenerateFlyingMoves=function(i){if(3!=this.menCount[this.mWho])this.GenerateMovingMoves(i);else for(var t=0;t<this.pieces.length;t++){var e=this.pieces[t];if(e.a&&e.s==this.mWho)for(var s=0;s<this.board.length;s++)this.board[s]==-1&&this.GenerateCapturingMoves(i,{f:e.p,t:s,c:-1})}},Model.Board.GenerateCapturingMoves=function(i,t){for(var e in i.g.TripletsByPos[t.t])if(i.g.TripletsByPos[t.t].hasOwnProperty(e)){for(var s=i.g.TripletsByPos[t.t][e],o=!0,r=0;r<3;r++){var n=s[r];if(n!=t.t){if(this.board[n]==-1||t.f==n){o=!1;break}var h=this.pieces[this.board[n]];if(0==h.a||h.d>-1||h.s!=this.mWho){o=!1;break}}}if(o){if(3==this.menCount[-this.mWho]&&0==this.placing)return void this.mMoves.push({f:t.f,t:t.t,c:-2});for(var a=[],r=0;r<this.pieces.length;r++){var h=this.pieces[r];if(1==h.a&&h.d==-1&&h.s==-this.mWho){var l={f:t.f,t:t.t,c:h.p};a.push(l)}}if(0==i.mOptions.poundInMill){var c={};for(var f in i.g.Triplets)if(i.g.Triplets.hasOwnProperty(f)){var d=i.g.Triplets[f];this.board[d[0]]!=-1&&this.pieces[this.board[d[0]]].s==-this.mWho&&this.board[d[1]]!=-1&&this.pieces[this.board[d[1]]].s==-this.mWho&&this.board[d[2]]!=-1&&this.pieces[this.board[d[2]]].s==-this.mWho&&(c[d[0]]=!0,c[d[1]]=!0,c[d[2]]=!0)}for(var v=[],f=0;f<a.length;f++)c[a[f].c]||v.push(a[f]);v.length>0&&(a=v)}return void(this.mMoves=this.mMoves.concat(a))}}this.mMoves.push({f:t.f,t:t.t,c:-1})},Model.Board.Evaluate=function(i,t,e){if(i.GetRepeatOccurence(this)>2)return this.mFinished=!0,void(this.mWinner=JocGame.DRAW);if(0==this.placing){if(this.menCount[JocGame.PLAYER_A]<3)return this.mFinished=!0,void(this.mWinner=JocGame.PLAYER_B);if(this.menCount[JocGame.PLAYER_B]<3)return this.mFinished=!0,void(this.mWinner=JocGame.PLAYER_A)}var s=this.menCount[JocGame.PLAYER_A]-this.menCount[JocGame.PLAYER_B],o=0,r=0;for(var n in i.g.Triplets)if(i.g.Triplets.hasOwnProperty(n)){for(var h={"-1":0,0:0,1:0},a=i.g.Triplets[n],l=0;l<3;l++){var c=a[l],f=this.board[c];if(f>-1){var d=this.pieces[f];h[d.s]++}}1==h[1]&&0==h[-1]?o++:2==h[1]&&0==h[-1]&&r++,1==h[-1]&&0==h[1]?o--:2==h[-1]&&0==h[1]&&r--}this.mEvaluation=10*s,this.mEvaluation+=1*o,this.mEvaluation+=3*r},Model.Board.ApplyMove=function(i,t){if(this.placing){var e=this.dock[this.mWho].shift(),s=this.pieces[e];s.d=-1,s.p=t.t,this.board[t.t]=e,this.lastMoveIndex=e,this.menCount[this.mWho]++,0==this.dock[JocGame.PLAYER_B].length&&(this.placing=!1)}else{var s=this.pieces[this.board[t.f]];this.board[s.p]=-1,this.board[t.t]=s.i,s.p=t.t,this.lastMoveIndex=s.i}if(t.c>-1){var e=this.board[t.c];this.board[t.c]=-1;var s=this.pieces[e];s.a=!1,this.menCount[-this.mWho]--}else t.c==-2&&this.menCount[-this.mWho]--},Model.Board.IsValidMove=function(i,t){return!0},Model.Game.InitGameExtra=function(){},Model.Game.BuildGraphCoord=function(){this.g.Graph=[[1,9,null,3],[2,4,0,null],[null,14,1,5],[4,10,0,6],[5,7,3,1],[2,13,4,8],[7,11,null,3],[8,null,6,4],[null,12,7,5],[10,21,null,0],[11,18,9,3],[null,15,10,6],[13,17,null,8],[14,20,12,5],[null,23,13,2],[16,null,18,11],[17,19,15,null],[20,null,16,12],[19,21,15,10],[20,22,18,16],[23,17,19,13],[22,null,18,9],[23,null,21,19],[20,null,22,14]],this.g.Coord=[[0,0],[0,3],[0,6],[1,1],[1,3],[1,5],[2,2],[2,3],[2,4],[3,0],[3,1],[3,2],[3,4],[3,5],[3,6],[4,2],[4,3],[4,4],[5,1],[5,3],[5,5],[6,0],[6,3],[6,6]],this.g.Triplets=[[0,1,2],[3,4,5],[6,7,8],[9,10,11],[12,13,14],[15,16,17],[18,19,20],[21,22,23],[0,9,21],[3,10,18],[6,11,15],[1,4,7],[16,19,22],[8,12,17],[5,13,20],[2,14,23],[0,3,6],[17,20,23],[2,5,8],[15,18,21]]};

/***/ }),

/***/ "3HIY":
/***/ (function(module, exports, __webpack_require__) {

module.exports = exports = __webpack_require__("lQJ9");


/***/ }),

/***/ "3Ka+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("3j3K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ngrx_core_operator_select__ = __webpack_require__("t8yF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ngrx_core_operator_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ngrx_core_operator_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ngrx_store_devtools__ = __webpack_require__("j3uM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_observable_merge__ = __webpack_require__("1KT0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_observable_merge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_merge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_operator_map__ = __webpack_require__("xAJs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_operator_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_rxjs_operator_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions__ = __webpack_require__("prmc");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DockMonitorComponent; });






var DockMonitorComponent = (function () {
    function DockMonitorComponent(tools, actions) {
        this.state$ = __WEBPACK_IMPORTED_MODULE_1__ngrx_core_operator_select__["select"].call(tools.liftedState, function (s) { return s.monitorState; });
        this.visible$ = __WEBPACK_IMPORTED_MODULE_1__ngrx_core_operator_select__["select"].call(this.state$, function (s) { return s.visible; });
        this.position$ = __WEBPACK_IMPORTED_MODULE_1__ngrx_core_operator_select__["select"].call(this.state$, function (s) { return s.position; });
        this.size$ = __WEBPACK_IMPORTED_MODULE_1__ngrx_core_operator_select__["select"].call(this.state$, function (s) { return s.size; });
        this.toggle$ = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.changePosition$ = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.actionsSubscription = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_rxjs_observable_merge__["merge"])(__WEBPACK_IMPORTED_MODULE_4_rxjs_operator_map__["map"].call(this.toggle$, function () { return actions.toggleVisibility(); }), __WEBPACK_IMPORTED_MODULE_4_rxjs_operator_map__["map"].call(this.changePosition$, function () { return actions.changePosition(); })).subscribe(tools);
    }
    DockMonitorComponent.prototype.ngOnDestroy = function () {
        this.actionsSubscription.unsubscribe();
    };
    DockMonitorComponent.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{
                    selector: 'dock-monitor',
                    changeDetection: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectionStrategy"].OnPush,
                    template: "\n    <ngrx-commander [shortcut]=\"toggleCommand\" (command)=\"toggle$.emit($event)\"></ngrx-commander>\n    <ngrx-commander [shortcut]=\"positionCommand\" (command)=\"changePosition$.emit($event)\"></ngrx-commander>\n\n    <ngrx-dock [visible]=\"visible$ | async\" [position]=\"position$ | async\" [size]=\"size$ | async\">\n      <ng-content></ng-content>\n    </ngrx-dock>\n  "
                },] },
    ];
    /** @nocollapse */
    DockMonitorComponent.ctorParameters = [
        { type: __WEBPACK_IMPORTED_MODULE_2__ngrx_store_devtools__["b" /* StoreDevtools */], },
        { type: __WEBPACK_IMPORTED_MODULE_5__actions__["a" /* DockActions */], },
    ];
    DockMonitorComponent.propDecorators = {
        'toggleCommand': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'positionCommand': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    };
    return DockMonitorComponent;
}());
//# sourceMappingURL=dock-monitor.js.map

/***/ }),

/***/ "3Nrk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__("2ene");
/* harmony export (immutable) */ __webpack_exports__["d"] = difference;
/* harmony export (immutable) */ __webpack_exports__["c"] = unliftState;
/* unused harmony export unliftAction */
/* harmony export (immutable) */ __webpack_exports__["b"] = liftAction;
/* harmony export (immutable) */ __webpack_exports__["a"] = applyOperators;

function difference(first, second) {
    return first.filter(function (item) { return second.indexOf(item) < 0; });
}
/**
 * Provides an app's view into the state of the lifted store.
 */
function unliftState(liftedState) {
    var computedStates = liftedState.computedStates, currentStateIndex = liftedState.currentStateIndex;
    var state = computedStates[currentStateIndex].state;
    return state;
}
function unliftAction(liftedState) {
    return liftedState.actionsById[liftedState.nextActionId - 1];
}
/**
* Lifts an app's action into an action on the lifted store.
*/
function liftAction(action) {
    return __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* StoreDevtoolActions */].performAction(action);
}
function applyOperators(input$, operators) {
    return operators.reduce(function (source$, _a) {
        var operator = _a[0], args = _a.slice(1);
        return operator.apply(source$, args);
    }, input$);
}
//# sourceMappingURL=utils.js.map

/***/ }),

/***/ "3Q42":
/***/ (function(module, exports) {

exports.config = {"status":true,"model":{"plazza":"true","released":1404982805,"title-en":"Gothic Chess","module":"chessbase","summary":"Chess on 10x8 (2000)","thumbnail":"gothic-thumb.png","rules":{"en":"gothic-rules.html"},"credits":{"en":"gothic-credits.html"},"gameOptions":{"preventRepeat":true,"uctTransposition":"state","uctIgnoreLoop":false,"levelOptions":{"pieceValueFactor":1,"pieceValueRatioFactor":1,"posValueFactor":0.1,"averageDistKingFactor":-0.01,"castleFactor":0.1,"minorPiecesMovedFactor":0.1,"checkFactor":0.2,"endingKingFreedomFactor":0.01,"endingDistKingFactor":0.05,"distKingCornerFactor":0.1,"distPawnPromo1Factor":0.3,"distPawnPromo2Factor":0.1,"distPawnPromo3Factor":0.05}},"obsolete":false,"js":["base-model.js","grid-geo-model.js","gothic-model.js"],"description":{"en":"gothic-description.html"},"levels":[{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"easy","label":"Easy","maxNodes":1000},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"fast","label":"Fast [1sec]","maxDuration":1,"isDefault":true},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"medium","label":"Medium","maxNodes":10000,"maxDuration":10},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"strong","label":"Strong","maxNodes":20000,"maxDuration":15}]},"view":{"title-en":"Chessbase view","module":"chessbase","xdView":true,"css":["chessbase.css"],"preferredRatio":1,"useShowMoves":true,"useNotation":true,"useAutoComplete":true,"defaultOptions":{"sounds":true,"moves":true,"notation":false,"autocomplete":false},"skins":[{"name":"skin3d","title":"3D Classic","3d":true,"preload":["smoothedfilegeo|0|/res/ring-target.js","image|/res/images/cancel.png","image|/res/images/wikipedia.png","smoothedfilegeo|0|/res/fairy/pawn/pawn.js","image|/res/fairy/pawn/pawn-diffusemap.jpg","image|/res/fairy/pawn/pawn-normalmap.jpg","smoothedfilegeo|0|/res/fairy/knight/knight.js","image|/res/fairy/knight/knight-diffusemap.jpg","image|/res/fairy/knight/knight-normalmap.jpg","smoothedfilegeo|0|/res/fairy/bishop/bishop.js","image|/res/fairy/bishop/bishop-diffusemap.jpg","image|/res/fairy/bishop/bishop-normalmap.jpg","smoothedfilegeo|0|/res/fairy/queen/queen.js","image|/res/fairy/queen/queen-diffusemap.jpg","image|/res/fairy/queen/queen-normalmap.jpg","smoothedfilegeo|0|/res/fairy/king/king.js","image|/res/fairy/king/king-diffusemap.jpg","image|/res/fairy/king/king-normalmap.jpg","smoothedfilegeo|0|/res/fairy/rook/rook.js","image|/res/fairy/rook/rook-diffusemap.jpg","image|/res/fairy/rook/rook-normalmap.jpg","smoothedfilegeo|0|/res/fairy/cardinal/cardinal.js","image|/res/fairy/cardinal/cardinal-diffusemap.jpg","image|/res/fairy/cardinal/cardinal-normalmap.jpg","smoothedfilegeo|0|/res/fairy/marshall/marshall.js","image|/res/fairy/marshall/marshall-diffusemap.jpg","image|/res/fairy/marshall/marshall-normalmap.jpg"],"world":{"lightIntensity":1.3,"skyLightIntensity":1.2,"lightCastShadow":true,"fog":false,"color":4686804,"lightPosition":{"x":-9,"y":9,"z":9},"skyLightPosition":{"x":9,"y":9,"z":9},"lightShadowDarkness":0.55,"ambientLightColor":2236962},"camera":{"fov":45,"distMax":50,"radius":18,"elevationAngle":60,"elevationMin":0}},{"name":"skin2d","title":"2D Classic","3d":false,"preload":["image|/res/images/cancel.png","image|/res/images/whitebg.png","image|/res/fairy/wikipedia-fairy-sprites.png"]}],"animateSelfMoves":false,"switchable":true,"sounds":{"move1":"alq_move1","move2":"alq_move2","move3":"alq_move3","move4":"alq_move2","tac1":"alq_tac1","tac2":"alq_tac2","tac3":"alq_tac1","promo":"promo","usermove":null},"js":["base-view.js","grid-board-view.js","fairy-set-view.js","capablanca-view.js"],"visuals":{"600x600":["res/visuals/gothic-600x600-3d.jpg","res/visuals/gothic-600x600-2d.jpg"]}}}

/***/ }),

/***/ "3Tfs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("3j3K");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LogMonitorEntryComponent; });

var LogMonitorEntryComponent = (function () {
    function LogMonitorEntryComponent() {
        this.expandEntries = false;
        this.disabled = false;
        this.toggle = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
    }
    Object.defineProperty(LogMonitorEntryComponent.prototype, "item", {
        get: function () {
            return this._item;
        },
        set: function (value) {
            this._item = value;
            this.stateActionPair = {
                state: value.state,
                action: value.action
            };
        },
        enumerable: true,
        configurable: true
    });
    LogMonitorEntryComponent.prototype.handleToggle = function () {
        if (!this.disabled) {
            this.toggle.next({ id: this.item.actionId });
        }
    };
    LogMonitorEntryComponent.prototype.logPayload = function () {
        console.log(this.item.action);
    };
    LogMonitorEntryComponent.prototype.logState = function () {
        console.log(this.item.state);
    };
    LogMonitorEntryComponent.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{
                    selector: 'log-monitor-entry',
                    template: "\n    <div class=\"title-bar\" [ngClass]=\"{ collapsed: item.collapsed }\" (click)=\"handleToggle()\">\n      {{ item.action.type }}\n    </div>\n    <div class=\"action-bar\" *ngIf=\"!item.collapsed\">\n      <ngrx-json-tree [value]=\"stateActionPair\" [expanded]=\"expandEntries\"></ngrx-json-tree>\n    </div>\n  ",
                    styles: ["\n    :host{\n      color: #FFFFFF;\n      background-color: #4F5A65;\n      cursor: pointer;\n    }\n    .title-bar{\n      padding: 8px 0 7px 16px;\n      background-color: rgba(0,0,0,0.1);\n    }\n    .action-bar{\n      padding: 20px;\n    }\n    .collapsed{\n      text-decoration: line-through;\n      font-style: italic;\n      opacity: 0.5;\n    }\n  "]
                },] },
    ];
    /** @nocollapse */
    LogMonitorEntryComponent.ctorParameters = [];
    LogMonitorEntryComponent.propDecorators = {
        'expandEntries': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'disabled': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'item': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'toggle': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
    };
    return LogMonitorEntryComponent;
}());
//# sourceMappingURL=log-monitor-entry.js.map

/***/ }),

/***/ "3eju":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var WebSocketSubject_1 = __webpack_require__("+Y2e");
exports.webSocket = WebSocketSubject_1.WebSocketSubject.create;
//# sourceMappingURL=webSocket.js.map

/***/ }),

/***/ "3j3K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__ = __webpack_require__("rCTf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_observable_merge__ = __webpack_require__("1KT0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_observable_merge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs_observable_merge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_operator_share__ = __webpack_require__("+ayw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_operator_share___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs_operator_share__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_Subject__ = __webpack_require__("EEr4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_Subject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rxjs_Subject__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Class", function() { return Class; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createPlatform", function() { return createPlatform; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "assertPlatform", function() { return assertPlatform; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "destroyPlatform", function() { return destroyPlatform; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPlatform", function() { return getPlatform; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PlatformRef", function() { return PlatformRef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ApplicationRef", function() { return ApplicationRef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "enableProdMode", function() { return enableProdMode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isDevMode", function() { return isDevMode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createPlatformFactory", function() { return createPlatformFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgProbeToken", function() { return NgProbeToken; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "APP_ID", function() { return APP_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PACKAGE_ROOT_URL", function() { return PACKAGE_ROOT_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PLATFORM_INITIALIZER", function() { return PLATFORM_INITIALIZER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PLATFORM_ID", function() { return PLATFORM_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "APP_BOOTSTRAP_LISTENER", function() { return APP_BOOTSTRAP_LISTENER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "APP_INITIALIZER", function() { return APP_INITIALIZER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ApplicationInitStatus", function() { return ApplicationInitStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DebugElement", function() { return DebugElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DebugNode", function() { return DebugNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "asNativeElements", function() { return asNativeElements; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDebugNode", function() { return getDebugNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Testability", function() { return Testability; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TestabilityRegistry", function() { return TestabilityRegistry; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setTestabilityGetter", function() { return setTestabilityGetter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TRANSLATIONS", function() { return TRANSLATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TRANSLATIONS_FORMAT", function() { return TRANSLATIONS_FORMAT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LOCALE_ID", function() { return LOCALE_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MissingTranslationStrategy", function() { return MissingTranslationStrategy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ApplicationModule", function() { return ApplicationModule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "wtfCreateScope", function() { return wtfCreateScope; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "wtfLeave", function() { return wtfLeave; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "wtfStartTimeRange", function() { return wtfStartTimeRange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "wtfEndTimeRange", function() { return wtfEndTimeRange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Type", function() { return Type; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EventEmitter", function() { return EventEmitter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ErrorHandler", function() { return ErrorHandler; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Sanitizer", function() { return Sanitizer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SecurityContext", function() { return SecurityContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ANALYZE_FOR_ENTRY_COMPONENTS", function() { return ANALYZE_FOR_ENTRY_COMPONENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Attribute", function() { return Attribute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ContentChild", function() { return ContentChild; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ContentChildren", function() { return ContentChildren; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Query", function() { return Query; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ViewChild", function() { return ViewChild; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ViewChildren", function() { return ViewChildren; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Component", function() { return Component; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Directive", function() { return Directive; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HostBinding", function() { return HostBinding; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HostListener", function() { return HostListener; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Input", function() { return Input; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Output", function() { return Output; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Pipe", function() { return Pipe; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CUSTOM_ELEMENTS_SCHEMA", function() { return CUSTOM_ELEMENTS_SCHEMA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NO_ERRORS_SCHEMA", function() { return NO_ERRORS_SCHEMA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgModule", function() { return NgModule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ViewEncapsulation", function() { return ViewEncapsulation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Version", function() { return Version; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VERSION", function() { return VERSION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "forwardRef", function() { return forwardRef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resolveForwardRef", function() { return resolveForwardRef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Injector", function() { return Injector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ReflectiveInjector", function() { return ReflectiveInjector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ResolvedReflectiveFactory", function() { return ResolvedReflectiveFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ReflectiveKey", function() { return ReflectiveKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InjectionToken", function() { return InjectionToken; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OpaqueToken", function() { return OpaqueToken; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Inject", function() { return Inject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Optional", function() { return Optional; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Injectable", function() { return Injectable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Self", function() { return Self; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SkipSelf", function() { return SkipSelf; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Host", function() { return Host; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgZone", function() { return NgZone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RenderComponentType", function() { return RenderComponentType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Renderer", function() { return Renderer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Renderer2", function() { return Renderer2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RendererFactory2", function() { return RendererFactory2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RendererStyleFlags2", function() { return RendererStyleFlags2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RootRenderer", function() { return RootRenderer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "COMPILER_OPTIONS", function() { return COMPILER_OPTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Compiler", function() { return Compiler; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CompilerFactory", function() { return CompilerFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ModuleWithComponentFactories", function() { return ModuleWithComponentFactories; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ComponentFactory", function() { return ComponentFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ComponentRef", function() { return ComponentRef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ComponentFactoryResolver", function() { return ComponentFactoryResolver; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ElementRef", function() { return ElementRef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgModuleFactory", function() { return NgModuleFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgModuleRef", function() { return NgModuleRef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgModuleFactoryLoader", function() { return NgModuleFactoryLoader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getModuleFactory", function() { return getModuleFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "QueryList", function() { return QueryList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SystemJsNgModuleLoader", function() { return SystemJsNgModuleLoader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SystemJsNgModuleLoaderConfig", function() { return SystemJsNgModuleLoaderConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TemplateRef", function() { return TemplateRef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ViewContainerRef", function() { return ViewContainerRef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EmbeddedViewRef", function() { return EmbeddedViewRef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ViewRef", function() { return ViewRef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ChangeDetectionStrategy", function() { return ChangeDetectionStrategy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ChangeDetectorRef", function() { return ChangeDetectorRef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DefaultIterableDiffer", function() { return DefaultIterableDiffer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IterableDiffers", function() { return IterableDiffers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "KeyValueDiffers", function() { return KeyValueDiffers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SimpleChange", function() { return SimpleChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WrappedValue", function() { return WrappedValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "platformCore", function() { return platformCore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵALLOW_MULTIPLE_PLATFORMS", function() { return ALLOW_MULTIPLE_PLATFORMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵAPP_ID_RANDOM_PROVIDER", function() { return APP_ID_RANDOM_PROVIDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵValueUnwrapper", function() { return ValueUnwrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵdevModeEqual", function() { return devModeEqual; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵisListLikeIterable", function() { return isListLikeIterable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵChangeDetectorStatus", function() { return ChangeDetectorStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵisDefaultChangeDetectionStrategy", function() { return isDefaultChangeDetectionStrategy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵConsole", function() { return Console; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵERROR_COMPONENT_TYPE", function() { return ERROR_COMPONENT_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵComponentFactory", function() { return ComponentFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵCodegenComponentFactoryResolver", function() { return CodegenComponentFactoryResolver; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵLIFECYCLE_HOOKS_VALUES", function() { return LIFECYCLE_HOOKS_VALUES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵLifecycleHooks", function() { return LifecycleHooks; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵViewMetadata", function() { return ViewMetadata; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵReflector", function() { return Reflector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵreflector", function() { return reflector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵReflectionCapabilities", function() { return ReflectionCapabilities; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵReflectorReader", function() { return ReflectorReader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵRenderDebugInfo", function() { return RenderDebugInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵglobal", function() { return _global; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵlooseIdentical", function() { return looseIdentical; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵstringify", function() { return stringify; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵmakeDecorator", function() { return makeDecorator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵisObservable", function() { return isObservable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵisPromise", function() { return isPromise; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵNOT_FOUND_CHECK_ONLY_ELEMENT_INJECTOR", function() { return NOT_FOUND_CHECK_ONLY_ELEMENT_INJECTOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵNgModuleInjector", function() { return NgModuleInjector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵregisterModuleFactory", function() { return registerModuleFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵEMPTY_ARRAY", function() { return EMPTY_ARRAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵEMPTY_MAP", function() { return EMPTY_MAP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵand", function() { return anchorDef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵccf", function() { return createComponentFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵcrt", function() { return createRendererType2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵdid", function() { return directiveDef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵeld", function() { return elementDef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵelementEventFullName", function() { return elementEventFullName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵgetComponentViewDefinitionFactory", function() { return getComponentViewDefinitionFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵinlineInterpolate", function() { return inlineInterpolate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵinterpolate", function() { return interpolate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵncd", function() { return ngContentDef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵnov", function() { return nodeValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵpid", function() { return pipeDef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵprd", function() { return providerDef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵpad", function() { return pureArrayDef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵpod", function() { return pureObjectDef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵppd", function() { return purePipeDef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵqud", function() { return queryDef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵted", function() { return textDef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵunv", function() { return unwrapValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵvid", function() { return viewDef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AUTO_STYLE", function() { return AUTO_STYLE$$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "trigger", function() { return trigger$$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "animate", function() { return animate$$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "group", function() { return group$$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sequence", function() { return sequence$$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "style", function() { return style$$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "state", function() { return state$$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "keyframes", function() { return keyframes$$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "transition", function() { return transition$$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵba", function() { return animate$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵbb", function() { return group$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵbf", function() { return keyframes$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵbc", function() { return sequence$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵbe", function() { return state$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵbd", function() { return style$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵbg", function() { return transition$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵz", function() { return trigger$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵo", function() { return _initViewEngine; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵl", function() { return _iterableDiffersFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵm", function() { return _keyValueDiffersFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵn", function() { return _localeFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵf", function() { return ApplicationRef_; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵg", function() { return _appIdRandomProviderFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵh", function() { return defaultIterableDiffers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵi", function() { return defaultKeyValueDiffers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵj", function() { return DefaultIterableDifferFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵk", function() { return DefaultKeyValueDifferFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵc", function() { return ReflectiveInjector_; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵd", function() { return ReflectiveDependency; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵe", function() { return resolveReflectiveProviders; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵp", function() { return wtfEnabled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵr", function() { return createScope$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵq", function() { return detectWTF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵu", function() { return endTimeRange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵs", function() { return leave; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵt", function() { return startTimeRange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵa", function() { return makeParamDecorator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵb", function() { return makePropDecorator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵw", function() { return _def; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵx", function() { return DebugContext; });
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * @license Angular v4.1.0
 * (c) 2010-2017 Google, Inc. https://angular.io/
 * License: MIT
 */




/**
 * Creates a token that can be used in a DI Provider.
 *
 * ### Example ([live demo](http://plnkr.co/edit/Ys9ezXpj2Mnoy3Uc8KBp?p=preview))
 *
 * ```typescript
 * var t = new OpaqueToken("value");
 *
 * var injector = Injector.resolveAndCreate([
 *   {provide: t, useValue: "bindingValue"}
 * ]);
 *
 * expect(injector.get(t)).toEqual("bindingValue");
 * ```
 *
 * Using an `OpaqueToken` is preferable to using strings as tokens because of possible collisions
 * caused by multiple providers using the same string as two different tokens.
 *
 * Using an `OpaqueToken` is preferable to using an `Object` as tokens because it provides better
 * error messages.
 * @deprecated since v4.0.0 because it does not support type information, use `InjectionToken<?>`
 * instead.
 */
var OpaqueToken = (function () {
    /**
     * @param {?} _desc
     */
    function OpaqueToken(_desc) {
        this._desc = _desc;
    }
    /**
     * @return {?}
     */
    OpaqueToken.prototype.toString = function () { return "Token " + this._desc; };
    return OpaqueToken;
}());
/**
 * Creates a token that can be used in a DI Provider.
 *
 * Use an `InjectionToken` whenever the type you are injecting is not reified (does not have a
 * runtime representation) such as when injecting an interface, callable type, array or
 * parametrized type.
 *
 * `InjectionToken` is parameterized on `T` which is the type of object which will be returned by
 * the `Injector`. This provides additional level of type safety.
 *
 * ```
 * interface MyInterface {...}
 * var myInterface = injector.get(new InjectionToken<MyInterface>('SomeToken'));
 * // myInterface is inferred to be MyInterface.
 * ```
 *
 * ### Example
 *
 * {\@example core/di/ts/injector_spec.ts region='InjectionToken'}
 *
 * \@stable
 */
var InjectionToken = (function (_super) {
    __extends(InjectionToken, _super);
    /**
     * @param {?} desc
     */
    function InjectionToken(desc) {
        return _super.call(this, desc) || this;
    }
    /**
     * @return {?}
     */
    InjectionToken.prototype.toString = function () { return "InjectionToken " + this._desc; };
    return InjectionToken;
}(OpaqueToken));
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var __window = typeof window !== 'undefined' && window;
var __self = typeof self !== 'undefined' && typeof WorkerGlobalScope !== 'undefined' &&
    self instanceof WorkerGlobalScope && self;
var __global = typeof global !== 'undefined' && global;
var _global = __window || __global || __self;
var _symbolIterator = null;
/**
 * @return {?}
 */
function getSymbolIterator() {
    if (!_symbolIterator) {
        var /** @type {?} */ Symbol = _global['Symbol'];
        if (Symbol && Symbol.iterator) {
            _symbolIterator = Symbol.iterator;
        }
        else {
            // es6-shim specific logic
            var /** @type {?} */ keys = Object.getOwnPropertyNames(Map.prototype);
            for (var /** @type {?} */ i = 0; i < keys.length; ++i) {
                var /** @type {?} */ key = keys[i];
                if (key !== 'entries' && key !== 'size' &&
                    ((Map)).prototype[key] === Map.prototype['entries']) {
                    _symbolIterator = key;
                }
            }
        }
    }
    return _symbolIterator;
}
/**
 * @param {?} fn
 * @return {?}
 */
function scheduleMicroTask(fn) {
    Zone.current.scheduleMicroTask('scheduleMicrotask', fn);
}
/**
 * @param {?} a
 * @param {?} b
 * @return {?}
 */
function looseIdentical(a, b) {
    return a === b || typeof a === 'number' && typeof b === 'number' && isNaN(a) && isNaN(b);
}
/**
 * @param {?} token
 * @return {?}
 */
function stringify(token) {
    if (typeof token === 'string') {
        return token;
    }
    if (token == null) {
        return '' + token;
    }
    if (token.overriddenName) {
        return "" + token.overriddenName;
    }
    if (token.name) {
        return "" + token.name;
    }
    var /** @type {?} */ res = token.toString();
    if (res == null) {
        return '' + res;
    }
    var /** @type {?} */ newLineIndex = res.indexOf('\n');
    return newLineIndex === -1 ? res : res.substring(0, newLineIndex);
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var _nextClassId = 0;
var Reflect = _global['Reflect'];
/**
 * @param {?} annotation
 * @return {?}
 */
function extractAnnotation(annotation) {
    if (typeof annotation === 'function' && annotation.hasOwnProperty('annotation')) {
        // it is a decorator, extract annotation
        annotation = annotation.annotation;
    }
    return annotation;
}
/**
 * @param {?} fnOrArray
 * @param {?} key
 * @return {?}
 */
function applyParams(fnOrArray, key) {
    if (fnOrArray === Object || fnOrArray === String || fnOrArray === Function ||
        fnOrArray === Number || fnOrArray === Array) {
        throw new Error("Can not use native " + stringify(fnOrArray) + " as constructor");
    }
    if (typeof fnOrArray === 'function') {
        return fnOrArray;
    }
    if (Array.isArray(fnOrArray)) {
        var /** @type {?} */ annotations = (fnOrArray);
        var /** @type {?} */ annoLength = annotations.length - 1;
        var /** @type {?} */ fn = fnOrArray[annoLength];
        if (typeof fn !== 'function') {
            throw new Error("Last position of Class method array must be Function in key " + key + " was '" + stringify(fn) + "'");
        }
        if (annoLength != fn.length) {
            throw new Error("Number of annotations (" + annoLength + ") does not match number of arguments (" + fn.length + ") in the function: " + stringify(fn));
        }
        var /** @type {?} */ paramsAnnotations = [];
        for (var /** @type {?} */ i = 0, /** @type {?} */ ii = annotations.length - 1; i < ii; i++) {
            var /** @type {?} */ paramAnnotations = [];
            paramsAnnotations.push(paramAnnotations);
            var /** @type {?} */ annotation = annotations[i];
            if (Array.isArray(annotation)) {
                for (var /** @type {?} */ j = 0; j < annotation.length; j++) {
                    paramAnnotations.push(extractAnnotation(annotation[j]));
                }
            }
            else if (typeof annotation === 'function') {
                paramAnnotations.push(extractAnnotation(annotation));
            }
            else {
                paramAnnotations.push(annotation);
            }
        }
        Reflect.defineMetadata('parameters', paramsAnnotations, fn);
        return fn;
    }
    throw new Error("Only Function or Array is supported in Class definition for key '" + key + "' is '" + stringify(fnOrArray) + "'");
}
/**
 * Provides a way for expressing ES6 classes with parameter annotations in ES5.
 *
 * ## Basic Example
 *
 * ```
 * var Greeter = ng.Class({
 *   constructor: function(name) {
 *     this.name = name;
 *   },
 *
 *   greet: function() {
 *     alert('Hello ' + this.name + '!');
 *   }
 * });
 * ```
 *
 * is equivalent to ES6:
 *
 * ```
 * class Greeter {
 *   constructor(name) {
 *     this.name = name;
 *   }
 *
 *   greet() {
 *     alert('Hello ' + this.name + '!');
 *   }
 * }
 * ```
 *
 * or equivalent to ES5:
 *
 * ```
 * var Greeter = function (name) {
 *   this.name = name;
 * }
 *
 * Greeter.prototype.greet = function () {
 *   alert('Hello ' + this.name + '!');
 * }
 * ```
 *
 * ### Example with parameter annotations
 *
 * ```
 * var MyService = ng.Class({
 *   constructor: [String, [new Optional(), Service], function(name, myService) {
 *     ...
 *   }]
 * });
 * ```
 *
 * is equivalent to ES6:
 *
 * ```
 * class MyService {
 *   constructor(name: string, \@Optional() myService: Service) {
 *     ...
 *   }
 * }
 * ```
 *
 * ### Example with inheritance
 *
 * ```
 * var Shape = ng.Class({
 *   constructor: (color) {
 *     this.color = color;
 *   }
 * });
 *
 * var Square = ng.Class({
 *   extends: Shape,
 *   constructor: function(color, size) {
 *     Shape.call(this, color);
 *     this.size = size;
 *   }
 * });
 * ```
 * @suppress {globalThis}
 * \@stable
 * @param {?} clsDef
 * @return {?}
 */
function Class(clsDef) {
    var /** @type {?} */ constructor = applyParams(clsDef.hasOwnProperty('constructor') ? clsDef.constructor : undefined, 'constructor');
    var /** @type {?} */ proto = constructor.prototype;
    if (clsDef.hasOwnProperty('extends')) {
        if (typeof clsDef.extends === 'function') {
            ((constructor)).prototype = proto =
                Object.create(((clsDef.extends)).prototype);
        }
        else {
            throw new Error("Class definition 'extends' property must be a constructor function was: " + stringify(clsDef.extends));
        }
    }
    for (var /** @type {?} */ key in clsDef) {
        if (key !== 'extends' && key !== 'prototype' && clsDef.hasOwnProperty(key)) {
            proto[key] = applyParams(clsDef[key], key);
        }
    }
    if (this && this.annotations instanceof Array) {
        Reflect.defineMetadata('annotations', this.annotations, constructor);
    }
    var /** @type {?} */ constructorName = constructor['name'];
    if (!constructorName || constructorName === 'constructor') {
        ((constructor))['overriddenName'] = "class" + _nextClassId++;
    }
    return (constructor);
}
/**
 * @suppress {globalThis}
 * @param {?} name
 * @param {?} props
 * @param {?=} parentClass
 * @param {?=} chainFn
 * @return {?}
 */
function makeDecorator(name, props, parentClass, chainFn) {
    var /** @type {?} */ metaCtor = makeMetadataCtor([props]);
    /**
     * @param {?} objOrType
     * @return {?}
     */
    function DecoratorFactory(objOrType) {
        if (!(Reflect && Reflect.getOwnMetadata)) {
            throw 'reflect-metadata shim is required when using class decorators';
        }
        if (this instanceof DecoratorFactory) {
            metaCtor.call(this, objOrType);
            return this;
        }
        var /** @type {?} */ annotationInstance = new ((DecoratorFactory))(objOrType);
        var /** @type {?} */ chainAnnotation = typeof this === 'function' && Array.isArray(this.annotations) ? this.annotations : [];
        chainAnnotation.push(annotationInstance);
        var /** @type {?} */ TypeDecorator = (function TypeDecorator(cls) {
            var /** @type {?} */ annotations = Reflect.getOwnMetadata('annotations', cls) || [];
            annotations.push(annotationInstance);
            Reflect.defineMetadata('annotations', annotations, cls);
            return cls;
        });
        TypeDecorator.annotations = chainAnnotation;
        TypeDecorator.Class = Class;
        if (chainFn)
            chainFn(TypeDecorator);
        return TypeDecorator;
    }
    if (parentClass) {
        DecoratorFactory.prototype = Object.create(parentClass.prototype);
    }
    DecoratorFactory.prototype.toString = function () { return "@" + name; };
    ((DecoratorFactory)).annotationCls = DecoratorFactory;
    return DecoratorFactory;
}
/**
 * @param {?} props
 * @return {?}
 */
function makeMetadataCtor(props) {
    return function ctor() {
        var _this = this;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        props.forEach(function (prop, i) {
            var /** @type {?} */ argVal = args[i];
            if (Array.isArray(prop)) {
                // plain parameter
                _this[prop[0]] = argVal === undefined ? prop[1] : argVal;
            }
            else {
                for (var /** @type {?} */ propName in prop) {
                    _this[propName] =
                        argVal && argVal.hasOwnProperty(propName) ? argVal[propName] : prop[propName];
                }
            }
        });
    };
}
/**
 * @param {?} name
 * @param {?} props
 * @param {?=} parentClass
 * @return {?}
 */
function makeParamDecorator(name, props, parentClass) {
    var /** @type {?} */ metaCtor = makeMetadataCtor(props);
    /**
     * @param {...?} args
     * @return {?}
     */
    function ParamDecoratorFactory() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (this instanceof ParamDecoratorFactory) {
            metaCtor.apply(this, args);
            return this;
        }
        var /** @type {?} */ annotationInstance = new (((ParamDecoratorFactory)).bind.apply(((ParamDecoratorFactory)), [void 0].concat(args)))();
        ((ParamDecorator)).annotation = annotationInstance;
        return ParamDecorator;
        /**
         * @param {?} cls
         * @param {?} unusedKey
         * @param {?} index
         * @return {?}
         */
        function ParamDecorator(cls, unusedKey, index) {
            var /** @type {?} */ parameters = Reflect.getOwnMetadata('parameters', cls) || [];
            // there might be gaps if some in between parameters do not have annotations.
            // we pad with nulls.
            while (parameters.length <= index) {
                parameters.push(null);
            }
            parameters[index] = parameters[index] || []; /** @type {?} */
            ((parameters[index])).push(annotationInstance);
            Reflect.defineMetadata('parameters', parameters, cls);
            return cls;
        }
    }
    if (parentClass) {
        ParamDecoratorFactory.prototype = Object.create(parentClass.prototype);
    }
    ParamDecoratorFactory.prototype.toString = function () { return "@" + name; };
    ((ParamDecoratorFactory)).annotationCls = ParamDecoratorFactory;
    return ParamDecoratorFactory;
}
/**
 * @param {?} name
 * @param {?} props
 * @param {?=} parentClass
 * @return {?}
 */
function makePropDecorator(name, props, parentClass) {
    var /** @type {?} */ metaCtor = makeMetadataCtor(props);
    /**
     * @param {...?} args
     * @return {?}
     */
    function PropDecoratorFactory() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (this instanceof PropDecoratorFactory) {
            metaCtor.apply(this, args);
            return this;
        }
        var /** @type {?} */ decoratorInstance = new (((PropDecoratorFactory)).bind.apply(((PropDecoratorFactory)), [void 0].concat(args)))();
        return function PropDecorator(target, name) {
            var /** @type {?} */ meta = Reflect.getOwnMetadata('propMetadata', target.constructor) || {};
            meta[name] = meta.hasOwnProperty(name) && meta[name] || [];
            meta[name].unshift(decoratorInstance);
            Reflect.defineMetadata('propMetadata', meta, target.constructor);
        };
    }
    if (parentClass) {
        PropDecoratorFactory.prototype = Object.create(parentClass.prototype);
    }
    PropDecoratorFactory.prototype.toString = function () { return "@" + name; };
    ((PropDecoratorFactory)).annotationCls = PropDecoratorFactory;
    return PropDecoratorFactory;
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * This token can be used to create a virtual provider that will populate the
 * `entryComponents` fields of components and ng modules based on its `useValue`.
 * All components that are referenced in the `useValue` value (either directly
 * or in a nested array or map) will be added to the `entryComponents` property.
 *
 * ### Example
 * The following example shows how the router can populate the `entryComponents`
 * field of an NgModule based on the router configuration which refers
 * to components.
 *
 * ```typescript
 * // helper function inside the router
 * function provideRoutes(routes) {
 *   return [
 *     {provide: ROUTES, useValue: routes},
 *     {provide: ANALYZE_FOR_ENTRY_COMPONENTS, useValue: routes, multi: true}
 *   ];
 * }
 *
 * // user code
 * let routes = [
 *   {path: '/root', component: RootComp},
 *   {path: '/teams', component: TeamsComp}
 * ];
 *
 * \@NgModule({
 *   providers: [provideRoutes(routes)]
 * })
 * class ModuleWithRoutes {}
 * ```
 *
 * \@experimental
 */
var ANALYZE_FOR_ENTRY_COMPONENTS = new InjectionToken('AnalyzeForEntryComponents');
/**
 * Attribute decorator and metadata.
 *
 * \@stable
 * \@Annotation
 */
var Attribute = makeParamDecorator('Attribute', [['attributeName', undefined]]);
/**
 * Base class for query metadata.
 *
 * See {\@link ContentChildren}, {\@link ContentChild}, {\@link ViewChildren}, {\@link ViewChild} for
 * more information.
 *
 * \@stable
 * @abstract
 */
var Query = (function () {
    function Query() {
    }
    return Query;
}());
/**
 * ContentChildren decorator and metadata.
 *
 *  \@stable
 *  \@Annotation
 */
var ContentChildren = makePropDecorator('ContentChildren', [
    ['selector', undefined], {
        first: false,
        isViewQuery: false,
        descendants: false,
        read: undefined,
    }
], Query);
/**
 * ContentChild decorator and metadata.
 *
 * \@stable
 * \@Annotation
 */
var ContentChild = makePropDecorator('ContentChild', [
    ['selector', undefined], {
        first: true,
        isViewQuery: false,
        descendants: true,
        read: undefined,
    }
], Query);
/**
 * ViewChildren decorator and metadata.
 *
 * \@stable
 * \@Annotation
 */
var ViewChildren = makePropDecorator('ViewChildren', [
    ['selector', undefined], {
        first: false,
        isViewQuery: true,
        descendants: true,
        read: undefined,
    }
], Query);
/**
 * ViewChild decorator and metadata.
 *
 * \@stable
 * \@Annotation
 */
var ViewChild = makePropDecorator('ViewChild', [
    ['selector', undefined], {
        first: true,
        isViewQuery: true,
        descendants: true,
        read: undefined,
    }
], Query);
var ChangeDetectionStrategy = {};
ChangeDetectionStrategy.OnPush = 0;
ChangeDetectionStrategy.Default = 1;
ChangeDetectionStrategy[ChangeDetectionStrategy.OnPush] = "OnPush";
ChangeDetectionStrategy[ChangeDetectionStrategy.Default] = "Default";
var ChangeDetectorStatus = {};
ChangeDetectorStatus.CheckOnce = 0;
ChangeDetectorStatus.Checked = 1;
ChangeDetectorStatus.CheckAlways = 2;
ChangeDetectorStatus.Detached = 3;
ChangeDetectorStatus.Errored = 4;
ChangeDetectorStatus.Destroyed = 5;
ChangeDetectorStatus[ChangeDetectorStatus.CheckOnce] = "CheckOnce";
ChangeDetectorStatus[ChangeDetectorStatus.Checked] = "Checked";
ChangeDetectorStatus[ChangeDetectorStatus.CheckAlways] = "CheckAlways";
ChangeDetectorStatus[ChangeDetectorStatus.Detached] = "Detached";
ChangeDetectorStatus[ChangeDetectorStatus.Errored] = "Errored";
ChangeDetectorStatus[ChangeDetectorStatus.Destroyed] = "Destroyed";
/**
 * @param {?} changeDetectionStrategy
 * @return {?}
 */
function isDefaultChangeDetectionStrategy(changeDetectionStrategy) {
    return changeDetectionStrategy == null ||
        changeDetectionStrategy === ChangeDetectionStrategy.Default;
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Directive decorator and metadata.
 *
 * \@stable
 * \@Annotation
 */
var Directive = makeDecorator('Directive', {
    selector: undefined,
    inputs: undefined,
    outputs: undefined,
    host: undefined,
    providers: undefined,
    exportAs: undefined,
    queries: undefined
});
/**
 * Component decorator and metadata.
 *
 * \@stable
 * \@Annotation
 */
var Component = makeDecorator('Component', {
    selector: undefined,
    inputs: undefined,
    outputs: undefined,
    host: undefined,
    exportAs: undefined,
    moduleId: undefined,
    providers: undefined,
    viewProviders: undefined,
    changeDetection: ChangeDetectionStrategy.Default,
    queries: undefined,
    templateUrl: undefined,
    template: undefined,
    styleUrls: undefined,
    styles: undefined,
    animations: undefined,
    encapsulation: undefined,
    interpolation: undefined,
    entryComponents: undefined
}, Directive);
/**
 * Pipe decorator and metadata.
 *
 * \@stable
 * \@Annotation
 */
var Pipe = makeDecorator('Pipe', {
    name: undefined,
    pure: true,
});
/**
 * Input decorator and metadata.
 *
 * \@stable
 * \@Annotation
 */
var Input = makePropDecorator('Input', [['bindingPropertyName', undefined]]);
/**
 * Output decorator and metadata.
 *
 * \@stable
 * \@Annotation
 */
var Output = makePropDecorator('Output', [['bindingPropertyName', undefined]]);
/**
 * HostBinding decorator and metadata.
 *
 * \@stable
 * \@Annotation
 */
var HostBinding = makePropDecorator('HostBinding', [['hostPropertyName', undefined]]);
/**
 * HostListener decorator and metadata.
 *
 * \@stable
 * \@Annotation
 */
var HostListener = makePropDecorator('HostListener', [['eventName', undefined], ['args', []]]);
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Defines a schema that will allow:
 * - any non-Angular elements with a `-` in their name,
 * - any properties on elements with a `-` in their name which is the common rule for custom
 * elements.
 *
 * \@stable
 */
var CUSTOM_ELEMENTS_SCHEMA = {
    name: 'custom-elements'
};
/**
 * Defines a schema that will allow any property on any element.
 *
 * \@experimental
 */
var NO_ERRORS_SCHEMA = {
    name: 'no-errors-schema'
};
/**
 * NgModule decorator and metadata.
 *
 * \@stable
 * \@Annotation
 */
var NgModule = makeDecorator('NgModule', {
    providers: undefined,
    declarations: undefined,
    imports: undefined,
    exports: undefined,
    entryComponents: undefined,
    bootstrap: undefined,
    schemas: undefined,
    id: undefined,
});
var ViewEncapsulation = {};
ViewEncapsulation.Emulated = 0;
ViewEncapsulation.Native = 1;
ViewEncapsulation.None = 2;
ViewEncapsulation[ViewEncapsulation.Emulated] = "Emulated";
ViewEncapsulation[ViewEncapsulation.Native] = "Native";
ViewEncapsulation[ViewEncapsulation.None] = "None";
/**
 * Metadata properties available for configuring Views.
 *
 * For details on the `\@Component` annotation, see {\@link Component}.
 *
 * ### Example
 *
 * ```
 * \@Component({
 *   selector: 'greet',
 *   template: 'Hello {{name}}!',
 * })
 * class Greet {
 *   name: string;
 *
 *   constructor() {
 *     this.name = 'World';
 *   }
 * }
 * ```
 *
 * @deprecated Use Component instead.
 *
 * {\@link Component}
 */
var ViewMetadata = (function () {
    /**
     * @param {?=} __0
     */
    function ViewMetadata(_a) {
        var _b = _a === void 0 ? {} : _a, templateUrl = _b.templateUrl, template = _b.template, encapsulation = _b.encapsulation, styles = _b.styles, styleUrls = _b.styleUrls, animations = _b.animations, interpolation = _b.interpolation;
        this.templateUrl = templateUrl;
        this.template = template;
        this.styleUrls = styleUrls;
        this.styles = styles;
        this.encapsulation = encapsulation;
        this.animations = animations;
        this.interpolation = interpolation;
    }
    return ViewMetadata;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * \@whatItDoes Represents the version of Angular
 *
 * \@stable
 */
var Version = (function () {
    /**
     * @param {?} full
     */
    function Version(full) {
        this.full = full;
    }
    Object.defineProperty(Version.prototype, "major", {
        /**
         * @return {?}
         */
        get: function () { return this.full.split('.')[0]; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Version.prototype, "minor", {
        /**
         * @return {?}
         */
        get: function () { return this.full.split('.')[1]; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Version.prototype, "patch", {
        /**
         * @return {?}
         */
        get: function () { return this.full.split('.').slice(2).join('.'); },
        enumerable: true,
        configurable: true
    });
    return Version;
}());
/**
 * \@stable
 */
var VERSION = new Version('4.1.0');
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Inject decorator and metadata.
 *
 * \@stable
 * \@Annotation
 */
var Inject = makeParamDecorator('Inject', [['token', undefined]]);
/**
 * Optional decorator and metadata.
 *
 * \@stable
 * \@Annotation
 */
var Optional = makeParamDecorator('Optional', []);
/**
 * Injectable decorator and metadata.
 *
 * \@stable
 * \@Annotation
 */
var Injectable = makeDecorator('Injectable', []);
/**
 * Self decorator and metadata.
 *
 * \@stable
 * \@Annotation
 */
var Self = makeParamDecorator('Self', []);
/**
 * SkipSelf decorator and metadata.
 *
 * \@stable
 * \@Annotation
 */
var SkipSelf = makeParamDecorator('SkipSelf', []);
/**
 * Host decorator and metadata.
 *
 * \@stable
 * \@Annotation
 */
var Host = makeParamDecorator('Host', []);
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Allows to refer to references which are not yet defined.
 *
 * For instance, `forwardRef` is used when the `token` which we need to refer to for the purposes of
 * DI is declared,
 * but not yet defined. It is also used when the `token` which we use when creating a query is not
 * yet defined.
 *
 * ### Example
 * {\@example core/di/ts/forward_ref/forward_ref_spec.ts region='forward_ref'}
 * \@experimental
 * @param {?} forwardRefFn
 * @return {?}
 */
function forwardRef(forwardRefFn) {
    ((forwardRefFn)).__forward_ref__ = forwardRef;
    ((forwardRefFn)).toString = function () { return stringify(this()); };
    return (((forwardRefFn)));
}
/**
 * Lazily retrieves the reference value from a forwardRef.
 *
 * Acts as the identity function when given a non-forward-ref value.
 *
 * ### Example ([live demo](http://plnkr.co/edit/GU72mJrk1fiodChcmiDR?p=preview))
 *
 * {\@example core/di/ts/forward_ref/forward_ref_spec.ts region='resolve_forward_ref'}
 *
 * See: {\@link forwardRef}
 * \@experimental
 * @param {?} type
 * @return {?}
 */
function resolveForwardRef(type) {
    if (typeof type === 'function' && type.hasOwnProperty('__forward_ref__') &&
        type.__forward_ref__ === forwardRef) {
        return ((type))();
    }
    else {
        return type;
    }
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var _THROW_IF_NOT_FOUND = new Object();
var THROW_IF_NOT_FOUND = _THROW_IF_NOT_FOUND;
var _NullInjector = (function () {
    function _NullInjector() {
    }
    /**
     * @param {?} token
     * @param {?=} notFoundValue
     * @return {?}
     */
    _NullInjector.prototype.get = function (token, notFoundValue) {
        if (notFoundValue === void 0) { notFoundValue = _THROW_IF_NOT_FOUND; }
        if (notFoundValue === _THROW_IF_NOT_FOUND) {
            throw new Error("No provider for " + stringify(token) + "!");
        }
        return notFoundValue;
    };
    return _NullInjector;
}());
/**
 * \@whatItDoes Injector interface
 * \@howToUse
 * ```
 * const injector: Injector = ...;
 * injector.get(...);
 * ```
 *
 * \@description
 * For more details, see the {\@linkDocs guide/dependency-injection "Dependency Injection Guide"}.
 *
 * ### Example
 *
 * {\@example core/di/ts/injector_spec.ts region='Injector'}
 *
 * `Injector` returns itself when given `Injector` as a token:
 * {\@example core/di/ts/injector_spec.ts region='injectInjector'}
 *
 * \@stable
 * @abstract
 */
var Injector = (function () {
    function Injector() {
    }
    /**
     * Retrieves an instance from the injector based on the provided token.
     * If not found:
     * - Throws {\@link NoProviderError} if no `notFoundValue` that is not equal to
     * Injector.THROW_IF_NOT_FOUND is given
     * - Returns the `notFoundValue` otherwise
     * @abstract
     * @template T
     * @param {?} token
     * @param {?=} notFoundValue
     * @return {?}
     */
    Injector.prototype.get = function (token, notFoundValue) { };
    /**
     * @deprecated from v4.0.0 use Type<T> or InjectionToken<T>
     * @suppress {duplicate}
     * @abstract
     * @param {?} token
     * @param {?=} notFoundValue
     * @return {?}
     */
    Injector.prototype.get = function (token, notFoundValue) { };
    return Injector;
}());
Injector.THROW_IF_NOT_FOUND = _THROW_IF_NOT_FOUND;
Injector.NULL = new _NullInjector();
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var ERROR_COMPONENT_TYPE = 'ngComponentType';
var ERROR_DEBUG_CONTEXT = 'ngDebugContext';
var ERROR_ORIGINAL_ERROR = 'ngOriginalError';
var ERROR_LOGGER = 'ngErrorLogger';
/**
 * @param {?} error
 * @return {?}
 */
/**
 * @param {?} error
 * @return {?}
 */
function getDebugContext(error) {
    return ((error))[ERROR_DEBUG_CONTEXT];
}
/**
 * @param {?} error
 * @return {?}
 */
function getOriginalError(error) {
    return ((error))[ERROR_ORIGINAL_ERROR];
}
/**
 * @param {?} error
 * @return {?}
 */
function getErrorLogger(error) {
    return ((error))[ERROR_LOGGER] || defaultErrorLogger;
}
/**
 * @param {?} console
 * @param {...?} values
 * @return {?}
 */
function defaultErrorLogger(console) {
    var values = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        values[_i - 1] = arguments[_i];
    }
    console.error.apply(console, values);
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * \@whatItDoes Provides a hook for centralized exception handling.
 *
 * \@description
 *
 * The default implementation of `ErrorHandler` prints error messages to the `console`. To
 * intercept error handling, write a custom exception handler that replaces this default as
 * appropriate for your app.
 *
 * ### Example
 *
 * ```
 * class MyErrorHandler implements ErrorHandler {
 *   handleError(error) {
 *     // do something with the exception
 *   }
 * }
 *
 * \@NgModule({
 *   providers: [{provide: ErrorHandler, useClass: MyErrorHandler}]
 * })
 * class MyModule {}
 * ```
 *
 * \@stable
 */
var ErrorHandler = (function () {
    /**
     * @param {?=} deprecatedParameter
     */
    function ErrorHandler(
        /**
         * @deprecated since v4.0 parameter no longer has an effect, as ErrorHandler will never
         * rethrow.
         */
        deprecatedParameter) {
        /**
         * \@internal
         */
        this._console = console;
    }
    /**
     * @param {?} error
     * @return {?}
     */
    ErrorHandler.prototype.handleError = function (error) {
        var /** @type {?} */ originalError = this._findOriginalError(error);
        var /** @type {?} */ context = this._findContext(error);
        // Note: Browser consoles show the place from where console.error was called.
        // We can use this to give users additional information about the error.
        var /** @type {?} */ errorLogger = getErrorLogger(error);
        errorLogger(this._console, "ERROR", error);
        if (originalError) {
            errorLogger(this._console, "ORIGINAL ERROR", originalError);
        }
        if (context) {
            errorLogger(this._console, 'ERROR CONTEXT', context);
        }
    };
    /**
     * \@internal
     * @param {?} error
     * @return {?}
     */
    ErrorHandler.prototype._findContext = function (error) {
        if (error) {
            return getDebugContext(error) ? getDebugContext(error) :
                this._findContext(getOriginalError(error));
        }
        return null;
    };
    /**
     * \@internal
     * @param {?} error
     * @return {?}
     */
    ErrorHandler.prototype._findOriginalError = function (error) {
        var /** @type {?} */ e = getOriginalError(error);
        while (e && getOriginalError(e)) {
            e = getOriginalError(e);
        }
        return e;
    };
    return ErrorHandler;
}());
/**
 * @param {?} message
 * @param {?} originalError
 * @return {?}
 */
function wrappedError(message, originalError) {
    var /** @type {?} */ msg = message + " caused by: " + (originalError instanceof Error ? originalError.message : originalError);
    var /** @type {?} */ error = Error(msg);
    ((error))[ERROR_ORIGINAL_ERROR] = originalError;
    return error;
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @param {?} keys
 * @return {?}
 */
function findFirstClosedCycle(keys) {
    var /** @type {?} */ res = [];
    for (var /** @type {?} */ i = 0; i < keys.length; ++i) {
        if (res.indexOf(keys[i]) > -1) {
            res.push(keys[i]);
            return res;
        }
        res.push(keys[i]);
    }
    return res;
}
/**
 * @param {?} keys
 * @return {?}
 */
function constructResolvingPath(keys) {
    if (keys.length > 1) {
        var /** @type {?} */ reversed = findFirstClosedCycle(keys.slice().reverse());
        var /** @type {?} */ tokenStrs = reversed.map(function (k) { return stringify(k.token); });
        return ' (' + tokenStrs.join(' -> ') + ')';
    }
    return '';
}
/**
 * @param {?} injector
 * @param {?} key
 * @param {?} constructResolvingMessage
 * @param {?=} originalError
 * @return {?}
 */
function injectionError(injector, key, constructResolvingMessage, originalError) {
    var /** @type {?} */ error = ((originalError ? wrappedError('', originalError) : Error()));
    error.addKey = addKey;
    error.keys = [key];
    error.injectors = [injector];
    error.constructResolvingMessage = constructResolvingMessage;
    error.message = error.constructResolvingMessage();
    ((error))[ERROR_ORIGINAL_ERROR] = originalError;
    return error;
}
/**
 * @this {?}
 * @param {?} injector
 * @param {?} key
 * @return {?}
 */
function addKey(injector, key) {
    this.injectors.push(injector);
    this.keys.push(key);
    this.message = this.constructResolvingMessage();
}
/**
 * Thrown when trying to retrieve a dependency by key from {\@link Injector}, but the
 * {\@link Injector} does not have a {\@link Provider} for the given key.
 *
 * ### Example ([live demo](http://plnkr.co/edit/vq8D3FRB9aGbnWJqtEPE?p=preview))
 *
 * ```typescript
 * class A {
 *   constructor(b:B) {}
 * }
 *
 * expect(() => Injector.resolveAndCreate([A])).toThrowError();
 * ```
 * @param {?} injector
 * @param {?} key
 * @return {?}
 */
function noProviderError(injector, key) {
    return injectionError(injector, key, function () {
        var /** @type {?} */ first = stringify(this.keys[0].token);
        return "No provider for " + first + "!" + constructResolvingPath(this.keys);
    });
}
/**
 * Thrown when dependencies form a cycle.
 *
 * ### Example ([live demo](http://plnkr.co/edit/wYQdNos0Tzql3ei1EV9j?p=info))
 *
 * ```typescript
 * var injector = Injector.resolveAndCreate([
 *   {provide: "one", useFactory: (two) => "two", deps: [[new Inject("two")]]},
 *   {provide: "two", useFactory: (one) => "one", deps: [[new Inject("one")]]}
 * ]);
 *
 * expect(() => injector.get("one")).toThrowError();
 * ```
 *
 * Retrieving `A` or `B` throws a `CyclicDependencyError` as the graph above cannot be constructed.
 * @param {?} injector
 * @param {?} key
 * @return {?}
 */
function cyclicDependencyError(injector, key) {
    return injectionError(injector, key, function () {
        return "Cannot instantiate cyclic dependency!" + constructResolvingPath(this.keys);
    });
}
/**
 * Thrown when a constructing type returns with an Error.
 *
 * The `InstantiationError` class contains the original error plus the dependency graph which caused
 * this object to be instantiated.
 *
 * ### Example ([live demo](http://plnkr.co/edit/7aWYdcqTQsP0eNqEdUAf?p=preview))
 *
 * ```typescript
 * class A {
 *   constructor() {
 *     throw new Error('message');
 *   }
 * }
 *
 * var injector = Injector.resolveAndCreate([A]);
 * try {
 *   injector.get(A);
 * } catch (e) {
 *   expect(e instanceof InstantiationError).toBe(true);
 *   expect(e.originalException.message).toEqual("message");
 *   expect(e.originalStack).toBeDefined();
 * }
 * ```
 * @param {?} injector
 * @param {?} originalException
 * @param {?} originalStack
 * @param {?} key
 * @return {?}
 */
function instantiationError(injector, originalException, originalStack, key) {
    return injectionError(injector, key, function () {
        var /** @type {?} */ first = stringify(this.keys[0].token);
        return getOriginalError(this).message + ": Error during instantiation of " + first + "!" + constructResolvingPath(this.keys) + ".";
    }, originalException);
}
/**
 * Thrown when an object other then {\@link Provider} (or `Type`) is passed to {\@link Injector}
 * creation.
 *
 * ### Example ([live demo](http://plnkr.co/edit/YatCFbPAMCL0JSSQ4mvH?p=preview))
 *
 * ```typescript
 * expect(() => Injector.resolveAndCreate(["not a type"])).toThrowError();
 * ```
 * @param {?} provider
 * @return {?}
 */
function invalidProviderError(provider) {
    return Error("Invalid provider - only instances of Provider and Type are allowed, got: " + provider);
}
/**
 * Thrown when the class has no annotation information.
 *
 * Lack of annotation information prevents the {\@link Injector} from determining which dependencies
 * need to be injected into the constructor.
 *
 * ### Example ([live demo](http://plnkr.co/edit/rHnZtlNS7vJOPQ6pcVkm?p=preview))
 *
 * ```typescript
 * class A {
 *   constructor(b) {}
 * }
 *
 * expect(() => Injector.resolveAndCreate([A])).toThrowError();
 * ```
 *
 * This error is also thrown when the class not marked with {\@link Injectable} has parameter types.
 *
 * ```typescript
 * class B {}
 *
 * class A {
 *   constructor(b:B) {} // no information about the parameter types of A is available at runtime.
 * }
 *
 * expect(() => Injector.resolveAndCreate([A,B])).toThrowError();
 * ```
 * \@stable
 * @param {?} typeOrFunc
 * @param {?} params
 * @return {?}
 */
function noAnnotationError(typeOrFunc, params) {
    var /** @type {?} */ signature = [];
    for (var /** @type {?} */ i = 0, /** @type {?} */ ii = params.length; i < ii; i++) {
        var /** @type {?} */ parameter = params[i];
        if (!parameter || parameter.length == 0) {
            signature.push('?');
        }
        else {
            signature.push(parameter.map(stringify).join(' '));
        }
    }
    return Error('Cannot resolve all parameters for \'' + stringify(typeOrFunc) + '\'(' +
        signature.join(', ') + '). ' +
        'Make sure that all the parameters are decorated with Inject or have valid type annotations and that \'' +
        stringify(typeOrFunc) + '\' is decorated with Injectable.');
}
/**
 * Thrown when getting an object by index.
 *
 * ### Example ([live demo](http://plnkr.co/edit/bRs0SX2OTQiJzqvjgl8P?p=preview))
 *
 * ```typescript
 * class A {}
 *
 * var injector = Injector.resolveAndCreate([A]);
 *
 * expect(() => injector.getAt(100)).toThrowError();
 * ```
 * \@stable
 * @param {?} index
 * @return {?}
 */
function outOfBoundsError(index) {
    return Error("Index " + index + " is out-of-bounds.");
}
/**
 * Thrown when a multi provider and a regular provider are bound to the same token.
 *
 * ### Example
 *
 * ```typescript
 * expect(() => Injector.resolveAndCreate([
 *   { provide: "Strings", useValue: "string1", multi: true},
 *   { provide: "Strings", useValue: "string2", multi: false}
 * ])).toThrowError();
 * ```
 * @param {?} provider1
 * @param {?} provider2
 * @return {?}
 */
function mixingMultiProvidersWithRegularProvidersError(provider1, provider2) {
    return Error("Cannot mix multi providers and regular providers, got: " + provider1 + " " + provider2);
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * A unique object used for retrieving items from the {\@link ReflectiveInjector}.
 *
 * Keys have:
 * - a system-wide unique `id`.
 * - a `token`.
 *
 * `Key` is used internally by {\@link ReflectiveInjector} because its system-wide unique `id` allows
 * the
 * injector to store created objects in a more efficient way.
 *
 * `Key` should not be created directly. {\@link ReflectiveInjector} creates keys automatically when
 * resolving
 * providers.
 * \@experimental
 */
var ReflectiveKey = (function () {
    /**
     * Private
     * @param {?} token
     * @param {?} id
     */
    function ReflectiveKey(token, id) {
        this.token = token;
        this.id = id;
        if (!token) {
            throw new Error('Token must be defined!');
        }
    }
    Object.defineProperty(ReflectiveKey.prototype, "displayName", {
        /**
         * Returns a stringified token.
         * @return {?}
         */
        get: function () { return stringify(this.token); },
        enumerable: true,
        configurable: true
    });
    /**
     * Retrieves a `Key` for a token.
     * @param {?} token
     * @return {?}
     */
    ReflectiveKey.get = function (token) {
        return _globalKeyRegistry.get(resolveForwardRef(token));
    };
    Object.defineProperty(ReflectiveKey, "numberOfKeys", {
        /**
         * @return {?} the number of keys registered in the system.
         */
        get: function () { return _globalKeyRegistry.numberOfKeys; },
        enumerable: true,
        configurable: true
    });
    return ReflectiveKey;
}());
/**
 * \@internal
 */
var KeyRegistry = (function () {
    function KeyRegistry() {
        this._allKeys = new Map();
    }
    /**
     * @param {?} token
     * @return {?}
     */
    KeyRegistry.prototype.get = function (token) {
        if (token instanceof ReflectiveKey)
            return token;
        if (this._allKeys.has(token)) {
            return ((this._allKeys.get(token)));
        }
        var /** @type {?} */ newKey = new ReflectiveKey(token, ReflectiveKey.numberOfKeys);
        this._allKeys.set(token, newKey);
        return newKey;
    };
    Object.defineProperty(KeyRegistry.prototype, "numberOfKeys", {
        /**
         * @return {?}
         */
        get: function () { return this._allKeys.size; },
        enumerable: true,
        configurable: true
    });
    return KeyRegistry;
}());
var _globalKeyRegistry = new KeyRegistry();
/**
 * \@whatItDoes Represents a type that a Component or other object is instances of.
 *
 * \@description
 *
 * An example of a `Type` is `MyCustomComponent` class, which in JavaScript is be represented by
 * the `MyCustomComponent` constructor function.
 *
 * \@stable
 */
var Type = Function;
/**
 * @param {?} v
 * @return {?}
 */
function isType(v) {
    return typeof v === 'function';
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Attention: This regex has to hold even if the code is minified!
 */
var DELEGATE_CTOR = /^function\s+\S+\(\)\s*{[\s\S]+\.apply\(this,\s*arguments\)/;
var ReflectionCapabilities = (function () {
    /**
     * @param {?=} reflect
     */
    function ReflectionCapabilities(reflect) {
        this._reflect = reflect || _global['Reflect'];
    }
    /**
     * @return {?}
     */
    ReflectionCapabilities.prototype.isReflectionEnabled = function () { return true; };
    /**
     * @template T
     * @param {?} t
     * @return {?}
     */
    ReflectionCapabilities.prototype.factory = function (t) { return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return new (t.bind.apply(t, [void 0].concat(args)))();
    }; };
    /**
     * \@internal
     * @param {?} paramTypes
     * @param {?} paramAnnotations
     * @return {?}
     */
    ReflectionCapabilities.prototype._zipTypesAndAnnotations = function (paramTypes, paramAnnotations) {
        var /** @type {?} */ result;
        if (typeof paramTypes === 'undefined') {
            result = new Array(paramAnnotations.length);
        }
        else {
            result = new Array(paramTypes.length);
        }
        for (var /** @type {?} */ i = 0; i < result.length; i++) {
            // TS outputs Object for parameters without types, while Traceur omits
            // the annotations. For now we preserve the Traceur behavior to aid
            // migration, but this can be revisited.
            if (typeof paramTypes === 'undefined') {
                result[i] = [];
            }
            else if (paramTypes[i] != Object) {
                result[i] = [paramTypes[i]];
            }
            else {
                result[i] = [];
            }
            if (paramAnnotations && paramAnnotations[i] != null) {
                result[i] = result[i].concat(paramAnnotations[i]);
            }
        }
        return result;
    };
    /**
     * @param {?} type
     * @param {?} parentCtor
     * @return {?}
     */
    ReflectionCapabilities.prototype._ownParameters = function (type, parentCtor) {
        // If we have no decorators, we only have function.length as metadata.
        // In that case, to detect whether a child class declared an own constructor or not,
        // we need to look inside of that constructor to check whether it is
        // just calling the parent.
        // This also helps to work around for https://github.com/Microsoft/TypeScript/issues/12439
        // that sets 'design:paramtypes' to []
        // if a class inherits from another class but has no ctor declared itself.
        if (DELEGATE_CTOR.exec(type.toString())) {
            return null;
        }
        // Prefer the direct API.
        if (((type)).parameters && ((type)).parameters !== parentCtor.parameters) {
            return ((type)).parameters;
        }
        // API of tsickle for lowering decorators to properties on the class.
        var /** @type {?} */ tsickleCtorParams = ((type)).ctorParameters;
        if (tsickleCtorParams && tsickleCtorParams !== parentCtor.ctorParameters) {
            // Newer tsickle uses a function closure
            // Retain the non-function case for compatibility with older tsickle
            var /** @type {?} */ ctorParameters = typeof tsickleCtorParams === 'function' ? tsickleCtorParams() : tsickleCtorParams;
            var /** @type {?} */ paramTypes = ctorParameters.map(function (ctorParam) { return ctorParam && ctorParam.type; });
            var /** @type {?} */ paramAnnotations = ctorParameters.map(function (ctorParam) { return ctorParam && convertTsickleDecoratorIntoMetadata(ctorParam.decorators); });
            return this._zipTypesAndAnnotations(paramTypes, paramAnnotations);
        }
        // API for metadata created by invoking the decorators.
        if (this._reflect != null && this._reflect.getOwnMetadata != null) {
            var /** @type {?} */ paramAnnotations = this._reflect.getOwnMetadata('parameters', type);
            var /** @type {?} */ paramTypes = this._reflect.getOwnMetadata('design:paramtypes', type);
            if (paramTypes || paramAnnotations) {
                return this._zipTypesAndAnnotations(paramTypes, paramAnnotations);
            }
        }
        // If a class has no decorators, at least create metadata
        // based on function.length.
        // Note: We know that this is a real constructor as we checked
        // the content of the constructor above.
        return new Array(((type.length))).fill(undefined);
    };
    /**
     * @param {?} type
     * @return {?}
     */
    ReflectionCapabilities.prototype.parameters = function (type) {
        // Note: only report metadata if we have at least one class decorator
        // to stay in sync with the static reflector.
        if (!isType(type)) {
            return [];
        }
        var /** @type {?} */ parentCtor = getParentCtor(type);
        var /** @type {?} */ parameters = this._ownParameters(type, parentCtor);
        if (!parameters && parentCtor !== Object) {
            parameters = this.parameters(parentCtor);
        }
        return parameters || [];
    };
    /**
     * @param {?} typeOrFunc
     * @param {?} parentCtor
     * @return {?}
     */
    ReflectionCapabilities.prototype._ownAnnotations = function (typeOrFunc, parentCtor) {
        // Prefer the direct API.
        if (((typeOrFunc)).annotations && ((typeOrFunc)).annotations !== parentCtor.annotations) {
            var /** @type {?} */ annotations = ((typeOrFunc)).annotations;
            if (typeof annotations === 'function' && annotations.annotations) {
                annotations = annotations.annotations;
            }
            return annotations;
        }
        // API of tsickle for lowering decorators to properties on the class.
        if (((typeOrFunc)).decorators && ((typeOrFunc)).decorators !== parentCtor.decorators) {
            return convertTsickleDecoratorIntoMetadata(((typeOrFunc)).decorators);
        }
        // API for metadata created by invoking the decorators.
        if (this._reflect && this._reflect.getOwnMetadata) {
            return this._reflect.getOwnMetadata('annotations', typeOrFunc);
        }
        return null;
    };
    /**
     * @param {?} typeOrFunc
     * @return {?}
     */
    ReflectionCapabilities.prototype.annotations = function (typeOrFunc) {
        if (!isType(typeOrFunc)) {
            return [];
        }
        var /** @type {?} */ parentCtor = getParentCtor(typeOrFunc);
        var /** @type {?} */ ownAnnotations = this._ownAnnotations(typeOrFunc, parentCtor) || [];
        var /** @type {?} */ parentAnnotations = parentCtor !== Object ? this.annotations(parentCtor) : [];
        return parentAnnotations.concat(ownAnnotations);
    };
    /**
     * @param {?} typeOrFunc
     * @param {?} parentCtor
     * @return {?}
     */
    ReflectionCapabilities.prototype._ownPropMetadata = function (typeOrFunc, parentCtor) {
        // Prefer the direct API.
        if (((typeOrFunc)).propMetadata &&
            ((typeOrFunc)).propMetadata !== parentCtor.propMetadata) {
            var /** @type {?} */ propMetadata = ((typeOrFunc)).propMetadata;
            if (typeof propMetadata === 'function' && propMetadata.propMetadata) {
                propMetadata = propMetadata.propMetadata;
            }
            return propMetadata;
        }
        // API of tsickle for lowering decorators to properties on the class.
        if (((typeOrFunc)).propDecorators &&
            ((typeOrFunc)).propDecorators !== parentCtor.propDecorators) {
            var /** @type {?} */ propDecorators_1 = ((typeOrFunc)).propDecorators;
            var /** @type {?} */ propMetadata_1 = ({});
            Object.keys(propDecorators_1).forEach(function (prop) {
                propMetadata_1[prop] = convertTsickleDecoratorIntoMetadata(propDecorators_1[prop]);
            });
            return propMetadata_1;
        }
        // API for metadata created by invoking the decorators.
        if (this._reflect && this._reflect.getOwnMetadata) {
            return this._reflect.getOwnMetadata('propMetadata', typeOrFunc);
        }
        return null;
    };
    /**
     * @param {?} typeOrFunc
     * @return {?}
     */
    ReflectionCapabilities.prototype.propMetadata = function (typeOrFunc) {
        if (!isType(typeOrFunc)) {
            return {};
        }
        var /** @type {?} */ parentCtor = getParentCtor(typeOrFunc);
        var /** @type {?} */ propMetadata = {};
        if (parentCtor !== Object) {
            var /** @type {?} */ parentPropMetadata_1 = this.propMetadata(parentCtor);
            Object.keys(parentPropMetadata_1).forEach(function (propName) {
                propMetadata[propName] = parentPropMetadata_1[propName];
            });
        }
        var /** @type {?} */ ownPropMetadata = this._ownPropMetadata(typeOrFunc, parentCtor);
        if (ownPropMetadata) {
            Object.keys(ownPropMetadata).forEach(function (propName) {
                var /** @type {?} */ decorators = [];
                if (propMetadata.hasOwnProperty(propName)) {
                    decorators.push.apply(decorators, propMetadata[propName]);
                }
                decorators.push.apply(decorators, ownPropMetadata[propName]);
                propMetadata[propName] = decorators;
            });
        }
        return propMetadata;
    };
    /**
     * @param {?} type
     * @param {?} lcProperty
     * @return {?}
     */
    ReflectionCapabilities.prototype.hasLifecycleHook = function (type, lcProperty) {
        return type instanceof Type && lcProperty in type.prototype;
    };
    /**
     * @param {?} name
     * @return {?}
     */
    ReflectionCapabilities.prototype.getter = function (name) { return (new Function('o', 'return o.' + name + ';')); };
    /**
     * @param {?} name
     * @return {?}
     */
    ReflectionCapabilities.prototype.setter = function (name) {
        return (new Function('o', 'v', 'return o.' + name + ' = v;'));
    };
    /**
     * @param {?} name
     * @return {?}
     */
    ReflectionCapabilities.prototype.method = function (name) {
        var /** @type {?} */ functionBody = "if (!o." + name + ") throw new Error('\"" + name + "\" is undefined');\n        return o." + name + ".apply(o, args);";
        return (new Function('o', 'args', functionBody));
    };
    /**
     * @param {?} type
     * @return {?}
     */
    ReflectionCapabilities.prototype.importUri = function (type) {
        // StaticSymbol
        if (typeof type === 'object' && type['filePath']) {
            return type['filePath'];
        }
        // Runtime type
        return "./" + stringify(type);
    };
    /**
     * @param {?} type
     * @return {?}
     */
    ReflectionCapabilities.prototype.resourceUri = function (type) { return "./" + stringify(type); };
    /**
     * @param {?} name
     * @param {?} moduleUrl
     * @param {?} members
     * @param {?} runtime
     * @return {?}
     */
    ReflectionCapabilities.prototype.resolveIdentifier = function (name, moduleUrl, members, runtime) {
        return runtime;
    };
    /**
     * @param {?} enumIdentifier
     * @param {?} name
     * @return {?}
     */
    ReflectionCapabilities.prototype.resolveEnum = function (enumIdentifier, name) { return enumIdentifier[name]; };
    return ReflectionCapabilities;
}());
/**
 * @param {?} decoratorInvocations
 * @return {?}
 */
function convertTsickleDecoratorIntoMetadata(decoratorInvocations) {
    if (!decoratorInvocations) {
        return [];
    }
    return decoratorInvocations.map(function (decoratorInvocation) {
        var /** @type {?} */ decoratorType = decoratorInvocation.type;
        var /** @type {?} */ annotationCls = decoratorType.annotationCls;
        var /** @type {?} */ annotationArgs = decoratorInvocation.args ? decoratorInvocation.args : [];
        return new (annotationCls.bind.apply(annotationCls, [void 0].concat(annotationArgs)))();
    });
}
/**
 * @param {?} ctor
 * @return {?}
 */
function getParentCtor(ctor) {
    var /** @type {?} */ parentProto = Object.getPrototypeOf(ctor.prototype);
    var /** @type {?} */ parentCtor = parentProto ? parentProto.constructor : null;
    // Note: We always use `Object` as the null value
    // to simplify checking later on.
    return parentCtor || Object;
}
/**
 * Provides read-only access to reflection data about symbols. Used internally by Angular
 * to power dependency injection and compilation.
 * @abstract
 */
var ReflectorReader = (function () {
    function ReflectorReader() {
    }
    /**
     * @abstract
     * @param {?} typeOrFunc
     * @return {?}
     */
    ReflectorReader.prototype.parameters = function (typeOrFunc) { };
    /**
     * @abstract
     * @param {?} typeOrFunc
     * @return {?}
     */
    ReflectorReader.prototype.annotations = function (typeOrFunc) { };
    /**
     * @abstract
     * @param {?} typeOrFunc
     * @return {?}
     */
    ReflectorReader.prototype.propMetadata = function (typeOrFunc) { };
    /**
     * @abstract
     * @param {?} typeOrFunc
     * @return {?}
     */
    ReflectorReader.prototype.importUri = function (typeOrFunc) { };
    /**
     * @abstract
     * @param {?} typeOrFunc
     * @return {?}
     */
    ReflectorReader.prototype.resourceUri = function (typeOrFunc) { };
    /**
     * @abstract
     * @param {?} name
     * @param {?} moduleUrl
     * @param {?} members
     * @param {?} runtime
     * @return {?}
     */
    ReflectorReader.prototype.resolveIdentifier = function (name, moduleUrl, members, runtime) { };
    /**
     * @abstract
     * @param {?} identifier
     * @param {?} name
     * @return {?}
     */
    ReflectorReader.prototype.resolveEnum = function (identifier, name) { };
    return ReflectorReader;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Provides access to reflection data about symbols. Used internally by Angular
 * to power dependency injection and compilation.
 */
var Reflector = (function (_super) {
    __extends(Reflector, _super);
    /**
     * @param {?} reflectionCapabilities
     */
    function Reflector(reflectionCapabilities) {
        var _this = _super.call(this) || this;
        _this.reflectionCapabilities = reflectionCapabilities;
        return _this;
    }
    /**
     * @param {?} caps
     * @return {?}
     */
    Reflector.prototype.updateCapabilities = function (caps) { this.reflectionCapabilities = caps; };
    /**
     * @param {?} type
     * @return {?}
     */
    Reflector.prototype.factory = function (type) { return this.reflectionCapabilities.factory(type); };
    /**
     * @param {?} typeOrFunc
     * @return {?}
     */
    Reflector.prototype.parameters = function (typeOrFunc) {
        return this.reflectionCapabilities.parameters(typeOrFunc);
    };
    /**
     * @param {?} typeOrFunc
     * @return {?}
     */
    Reflector.prototype.annotations = function (typeOrFunc) {
        return this.reflectionCapabilities.annotations(typeOrFunc);
    };
    /**
     * @param {?} typeOrFunc
     * @return {?}
     */
    Reflector.prototype.propMetadata = function (typeOrFunc) {
        return this.reflectionCapabilities.propMetadata(typeOrFunc);
    };
    /**
     * @param {?} type
     * @param {?} lcProperty
     * @return {?}
     */
    Reflector.prototype.hasLifecycleHook = function (type, lcProperty) {
        return this.reflectionCapabilities.hasLifecycleHook(type, lcProperty);
    };
    /**
     * @param {?} name
     * @return {?}
     */
    Reflector.prototype.getter = function (name) { return this.reflectionCapabilities.getter(name); };
    /**
     * @param {?} name
     * @return {?}
     */
    Reflector.prototype.setter = function (name) { return this.reflectionCapabilities.setter(name); };
    /**
     * @param {?} name
     * @return {?}
     */
    Reflector.prototype.method = function (name) { return this.reflectionCapabilities.method(name); };
    /**
     * @param {?} type
     * @return {?}
     */
    Reflector.prototype.importUri = function (type) { return this.reflectionCapabilities.importUri(type); };
    /**
     * @param {?} type
     * @return {?}
     */
    Reflector.prototype.resourceUri = function (type) { return this.reflectionCapabilities.resourceUri(type); };
    /**
     * @param {?} name
     * @param {?} moduleUrl
     * @param {?} members
     * @param {?} runtime
     * @return {?}
     */
    Reflector.prototype.resolveIdentifier = function (name, moduleUrl, members, runtime) {
        return this.reflectionCapabilities.resolveIdentifier(name, moduleUrl, members, runtime);
    };
    /**
     * @param {?} identifier
     * @param {?} name
     * @return {?}
     */
    Reflector.prototype.resolveEnum = function (identifier, name) {
        return this.reflectionCapabilities.resolveEnum(identifier, name);
    };
    return Reflector;
}(ReflectorReader));
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * The {@link Reflector} used internally in Angular to access metadata
 * about symbols.
 */
var reflector = new Reflector(new ReflectionCapabilities());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * `Dependency` is used by the framework to extend DI.
 * This is internal to Angular and should not be used directly.
 */
var ReflectiveDependency = (function () {
    /**
     * @param {?} key
     * @param {?} optional
     * @param {?} visibility
     */
    function ReflectiveDependency(key, optional, visibility) {
        this.key = key;
        this.optional = optional;
        this.visibility = visibility;
    }
    /**
     * @param {?} key
     * @return {?}
     */
    ReflectiveDependency.fromKey = function (key) {
        return new ReflectiveDependency(key, false, null);
    };
    return ReflectiveDependency;
}());
var _EMPTY_LIST = [];
var ResolvedReflectiveProvider_ = (function () {
    /**
     * @param {?} key
     * @param {?} resolvedFactories
     * @param {?} multiProvider
     */
    function ResolvedReflectiveProvider_(key, resolvedFactories, multiProvider) {
        this.key = key;
        this.resolvedFactories = resolvedFactories;
        this.multiProvider = multiProvider;
    }
    Object.defineProperty(ResolvedReflectiveProvider_.prototype, "resolvedFactory", {
        /**
         * @return {?}
         */
        get: function () { return this.resolvedFactories[0]; },
        enumerable: true,
        configurable: true
    });
    return ResolvedReflectiveProvider_;
}());
/**
 * An internal resolved representation of a factory function created by resolving {\@link
 * Provider}.
 * \@experimental
 */
var ResolvedReflectiveFactory = (function () {
    /**
     * @param {?} factory
     * @param {?} dependencies
     */
    function ResolvedReflectiveFactory(factory, dependencies) {
        this.factory = factory;
        this.dependencies = dependencies;
    }
    return ResolvedReflectiveFactory;
}());
/**
 * Resolve a single provider.
 * @param {?} provider
 * @return {?}
 */
function resolveReflectiveFactory(provider) {
    var /** @type {?} */ factoryFn;
    var /** @type {?} */ resolvedDeps;
    if (provider.useClass) {
        var /** @type {?} */ useClass = resolveForwardRef(provider.useClass);
        factoryFn = reflector.factory(useClass);
        resolvedDeps = _dependenciesFor(useClass);
    }
    else if (provider.useExisting) {
        factoryFn = function (aliasInstance) { return aliasInstance; };
        resolvedDeps = [ReflectiveDependency.fromKey(ReflectiveKey.get(provider.useExisting))];
    }
    else if (provider.useFactory) {
        factoryFn = provider.useFactory;
        resolvedDeps = constructDependencies(provider.useFactory, provider.deps);
    }
    else {
        factoryFn = function () { return provider.useValue; };
        resolvedDeps = _EMPTY_LIST;
    }
    return new ResolvedReflectiveFactory(factoryFn, resolvedDeps);
}
/**
 * Converts the {\@link Provider} into {\@link ResolvedProvider}.
 *
 * {\@link Injector} internally only uses {\@link ResolvedProvider}, {\@link Provider} contains
 * convenience provider syntax.
 * @param {?} provider
 * @return {?}
 */
function resolveReflectiveProvider(provider) {
    return new ResolvedReflectiveProvider_(ReflectiveKey.get(provider.provide), [resolveReflectiveFactory(provider)], provider.multi || false);
}
/**
 * Resolve a list of Providers.
 * @param {?} providers
 * @return {?}
 */
function resolveReflectiveProviders(providers) {
    var /** @type {?} */ normalized = _normalizeProviders(providers, []);
    var /** @type {?} */ resolved = normalized.map(resolveReflectiveProvider);
    var /** @type {?} */ resolvedProviderMap = mergeResolvedReflectiveProviders(resolved, new Map());
    return Array.from(resolvedProviderMap.values());
}
/**
 * Merges a list of ResolvedProviders into a list where
 * each key is contained exactly once and multi providers
 * have been merged.
 * @param {?} providers
 * @param {?} normalizedProvidersMap
 * @return {?}
 */
function mergeResolvedReflectiveProviders(providers, normalizedProvidersMap) {
    for (var /** @type {?} */ i = 0; i < providers.length; i++) {
        var /** @type {?} */ provider = providers[i];
        var /** @type {?} */ existing = normalizedProvidersMap.get(provider.key.id);
        if (existing) {
            if (provider.multiProvider !== existing.multiProvider) {
                throw mixingMultiProvidersWithRegularProvidersError(existing, provider);
            }
            if (provider.multiProvider) {
                for (var /** @type {?} */ j = 0; j < provider.resolvedFactories.length; j++) {
                    existing.resolvedFactories.push(provider.resolvedFactories[j]);
                }
            }
            else {
                normalizedProvidersMap.set(provider.key.id, provider);
            }
        }
        else {
            var /** @type {?} */ resolvedProvider = void 0;
            if (provider.multiProvider) {
                resolvedProvider = new ResolvedReflectiveProvider_(provider.key, provider.resolvedFactories.slice(), provider.multiProvider);
            }
            else {
                resolvedProvider = provider;
            }
            normalizedProvidersMap.set(provider.key.id, resolvedProvider);
        }
    }
    return normalizedProvidersMap;
}
/**
 * @param {?} providers
 * @param {?} res
 * @return {?}
 */
function _normalizeProviders(providers, res) {
    providers.forEach(function (b) {
        if (b instanceof Type) {
            res.push({ provide: b, useClass: b });
        }
        else if (b && typeof b == 'object' && ((b)).provide !== undefined) {
            res.push(/** @type {?} */ (b));
        }
        else if (b instanceof Array) {
            _normalizeProviders(b, res);
        }
        else {
            throw invalidProviderError(b);
        }
    });
    return res;
}
/**
 * @param {?} typeOrFunc
 * @param {?=} dependencies
 * @return {?}
 */
function constructDependencies(typeOrFunc, dependencies) {
    if (!dependencies) {
        return _dependenciesFor(typeOrFunc);
    }
    else {
        var /** @type {?} */ params_1 = dependencies.map(function (t) { return [t]; });
        return dependencies.map(function (t) { return _extractToken(typeOrFunc, t, params_1); });
    }
}
/**
 * @param {?} typeOrFunc
 * @return {?}
 */
function _dependenciesFor(typeOrFunc) {
    var /** @type {?} */ params = reflector.parameters(typeOrFunc);
    if (!params)
        return [];
    if (params.some(function (p) { return p == null; })) {
        throw noAnnotationError(typeOrFunc, params);
    }
    return params.map(function (p) { return _extractToken(typeOrFunc, p, params); });
}
/**
 * @param {?} typeOrFunc
 * @param {?} metadata
 * @param {?} params
 * @return {?}
 */
function _extractToken(typeOrFunc, metadata, params) {
    var /** @type {?} */ token = null;
    var /** @type {?} */ optional = false;
    if (!Array.isArray(metadata)) {
        if (metadata instanceof Inject) {
            return _createDependency(metadata['token'], optional, null);
        }
        else {
            return _createDependency(metadata, optional, null);
        }
    }
    var /** @type {?} */ visibility = null;
    for (var /** @type {?} */ i = 0; i < metadata.length; ++i) {
        var /** @type {?} */ paramMetadata = metadata[i];
        if (paramMetadata instanceof Type) {
            token = paramMetadata;
        }
        else if (paramMetadata instanceof Inject) {
            token = paramMetadata['token'];
        }
        else if (paramMetadata instanceof Optional) {
            optional = true;
        }
        else if (paramMetadata instanceof Self || paramMetadata instanceof SkipSelf) {
            visibility = paramMetadata;
        }
        else if (paramMetadata instanceof InjectionToken) {
            token = paramMetadata;
        }
    }
    token = resolveForwardRef(token);
    if (token != null) {
        return _createDependency(token, optional, visibility);
    }
    else {
        throw noAnnotationError(typeOrFunc, params);
    }
}
/**
 * @param {?} token
 * @param {?} optional
 * @param {?} visibility
 * @return {?}
 */
function _createDependency(token, optional, visibility) {
    return new ReflectiveDependency(ReflectiveKey.get(token), optional, visibility);
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
// Threshold for the dynamic version
var UNDEFINED = new Object();
/**
 * A ReflectiveDependency injection container used for instantiating objects and resolving
 * dependencies.
 *
 * An `Injector` is a replacement for a `new` operator, which can automatically resolve the
 * constructor dependencies.
 *
 * In typical use, application code asks for the dependencies in the constructor and they are
 * resolved by the `Injector`.
 *
 * ### Example ([live demo](http://plnkr.co/edit/jzjec0?p=preview))
 *
 * The following example creates an `Injector` configured to create `Engine` and `Car`.
 *
 * ```typescript
 * \@Injectable()
 * class Engine {
 * }
 *
 * \@Injectable()
 * class Car {
 *   constructor(public engine:Engine) {}
 * }
 *
 * var injector = ReflectiveInjector.resolveAndCreate([Car, Engine]);
 * var car = injector.get(Car);
 * expect(car instanceof Car).toBe(true);
 * expect(car.engine instanceof Engine).toBe(true);
 * ```
 *
 * Notice, we don't use the `new` operator because we explicitly want to have the `Injector`
 * resolve all of the object's dependencies automatically.
 *
 * \@stable
 * @abstract
 */
var ReflectiveInjector = (function () {
    function ReflectiveInjector() {
    }
    /**
     * Turns an array of provider definitions into an array of resolved providers.
     *
     * A resolution is a process of flattening multiple nested arrays and converting individual
     * providers into an array of {\@link ResolvedReflectiveProvider}s.
     *
     * ### Example ([live demo](http://plnkr.co/edit/AiXTHi?p=preview))
     *
     * ```typescript
     * \@Injectable()
     * class Engine {
     * }
     *
     * \@Injectable()
     * class Car {
     *   constructor(public engine:Engine) {}
     * }
     *
     * var providers = ReflectiveInjector.resolve([Car, [[Engine]]]);
     *
     * expect(providers.length).toEqual(2);
     *
     * expect(providers[0] instanceof ResolvedReflectiveProvider).toBe(true);
     * expect(providers[0].key.displayName).toBe("Car");
     * expect(providers[0].dependencies.length).toEqual(1);
     * expect(providers[0].factory).toBeDefined();
     *
     * expect(providers[1].key.displayName).toBe("Engine");
     * });
     * ```
     *
     * See {\@link ReflectiveInjector#fromResolvedProviders} for more info.
     * @param {?} providers
     * @return {?}
     */
    ReflectiveInjector.resolve = function (providers) {
        return resolveReflectiveProviders(providers);
    };
    /**
     * Resolves an array of providers and creates an injector from those providers.
     *
     * The passed-in providers can be an array of `Type`, {\@link Provider},
     * or a recursive array of more providers.
     *
     * ### Example ([live demo](http://plnkr.co/edit/ePOccA?p=preview))
     *
     * ```typescript
     * \@Injectable()
     * class Engine {
     * }
     *
     * \@Injectable()
     * class Car {
     *   constructor(public engine:Engine) {}
     * }
     *
     * var injector = ReflectiveInjector.resolveAndCreate([Car, Engine]);
     * expect(injector.get(Car) instanceof Car).toBe(true);
     * ```
     *
     * This function is slower than the corresponding `fromResolvedProviders`
     * because it needs to resolve the passed-in providers first.
     * See {\@link Injector#resolve} and {\@link Injector#fromResolvedProviders}.
     * @param {?} providers
     * @param {?=} parent
     * @return {?}
     */
    ReflectiveInjector.resolveAndCreate = function (providers, parent) {
        var /** @type {?} */ ResolvedReflectiveProviders = ReflectiveInjector.resolve(providers);
        return ReflectiveInjector.fromResolvedProviders(ResolvedReflectiveProviders, parent);
    };
    /**
     * Creates an injector from previously resolved providers.
     *
     * This API is the recommended way to construct injectors in performance-sensitive parts.
     *
     * ### Example ([live demo](http://plnkr.co/edit/KrSMci?p=preview))
     *
     * ```typescript
     * \@Injectable()
     * class Engine {
     * }
     *
     * \@Injectable()
     * class Car {
     *   constructor(public engine:Engine) {}
     * }
     *
     * var providers = ReflectiveInjector.resolve([Car, Engine]);
     * var injector = ReflectiveInjector.fromResolvedProviders(providers);
     * expect(injector.get(Car) instanceof Car).toBe(true);
     * ```
     * \@experimental
     * @param {?} providers
     * @param {?=} parent
     * @return {?}
     */
    ReflectiveInjector.fromResolvedProviders = function (providers, parent) {
        return new ReflectiveInjector_(providers, parent);
    };
    /**
     * Parent of this injector.
     *
     * <!-- TODO: Add a link to the section of the user guide talking about hierarchical injection.
     * -->
     *
     * ### Example ([live demo](http://plnkr.co/edit/eosMGo?p=preview))
     *
     * ```typescript
     * var parent = ReflectiveInjector.resolveAndCreate([]);
     * var child = parent.resolveAndCreateChild([]);
     * expect(child.parent).toBe(parent);
     * ```
     * @abstract
     * @return {?}
     */
    ReflectiveInjector.prototype.parent = function () { };
    /**
     * Resolves an array of providers and creates a child injector from those providers.
     *
     * <!-- TODO: Add a link to the section of the user guide talking about hierarchical injection.
     * -->
     *
     * The passed-in providers can be an array of `Type`, {\@link Provider},
     * or a recursive array of more providers.
     *
     * ### Example ([live demo](http://plnkr.co/edit/opB3T4?p=preview))
     *
     * ```typescript
     * class ParentProvider {}
     * class ChildProvider {}
     *
     * var parent = ReflectiveInjector.resolveAndCreate([ParentProvider]);
     * var child = parent.resolveAndCreateChild([ChildProvider]);
     *
     * expect(child.get(ParentProvider) instanceof ParentProvider).toBe(true);
     * expect(child.get(ChildProvider) instanceof ChildProvider).toBe(true);
     * expect(child.get(ParentProvider)).toBe(parent.get(ParentProvider));
     * ```
     *
     * This function is slower than the corresponding `createChildFromResolved`
     * because it needs to resolve the passed-in providers first.
     * See {\@link Injector#resolve} and {\@link Injector#createChildFromResolved}.
     * @abstract
     * @param {?} providers
     * @return {?}
     */
    ReflectiveInjector.prototype.resolveAndCreateChild = function (providers) { };
    /**
     * Creates a child injector from previously resolved providers.
     *
     * <!-- TODO: Add a link to the section of the user guide talking about hierarchical injection.
     * -->
     *
     * This API is the recommended way to construct injectors in performance-sensitive parts.
     *
     * ### Example ([live demo](http://plnkr.co/edit/VhyfjN?p=preview))
     *
     * ```typescript
     * class ParentProvider {}
     * class ChildProvider {}
     *
     * var parentProviders = ReflectiveInjector.resolve([ParentProvider]);
     * var childProviders = ReflectiveInjector.resolve([ChildProvider]);
     *
     * var parent = ReflectiveInjector.fromResolvedProviders(parentProviders);
     * var child = parent.createChildFromResolved(childProviders);
     *
     * expect(child.get(ParentProvider) instanceof ParentProvider).toBe(true);
     * expect(child.get(ChildProvider) instanceof ChildProvider).toBe(true);
     * expect(child.get(ParentProvider)).toBe(parent.get(ParentProvider));
     * ```
     * @abstract
     * @param {?} providers
     * @return {?}
     */
    ReflectiveInjector.prototype.createChildFromResolved = function (providers) { };
    /**
     * Resolves a provider and instantiates an object in the context of the injector.
     *
     * The created object does not get cached by the injector.
     *
     * ### Example ([live demo](http://plnkr.co/edit/yvVXoB?p=preview))
     *
     * ```typescript
     * \@Injectable()
     * class Engine {
     * }
     *
     * \@Injectable()
     * class Car {
     *   constructor(public engine:Engine) {}
     * }
     *
     * var injector = ReflectiveInjector.resolveAndCreate([Engine]);
     *
     * var car = injector.resolveAndInstantiate(Car);
     * expect(car.engine).toBe(injector.get(Engine));
     * expect(car).not.toBe(injector.resolveAndInstantiate(Car));
     * ```
     * @abstract
     * @param {?} provider
     * @return {?}
     */
    ReflectiveInjector.prototype.resolveAndInstantiate = function (provider) { };
    /**
     * Instantiates an object using a resolved provider in the context of the injector.
     *
     * The created object does not get cached by the injector.
     *
     * ### Example ([live demo](http://plnkr.co/edit/ptCImQ?p=preview))
     *
     * ```typescript
     * \@Injectable()
     * class Engine {
     * }
     *
     * \@Injectable()
     * class Car {
     *   constructor(public engine:Engine) {}
     * }
     *
     * var injector = ReflectiveInjector.resolveAndCreate([Engine]);
     * var carProvider = ReflectiveInjector.resolve([Car])[0];
     * var car = injector.instantiateResolved(carProvider);
     * expect(car.engine).toBe(injector.get(Engine));
     * expect(car).not.toBe(injector.instantiateResolved(carProvider));
     * ```
     * @abstract
     * @param {?} provider
     * @return {?}
     */
    ReflectiveInjector.prototype.instantiateResolved = function (provider) { };
    /**
     * @abstract
     * @param {?} token
     * @param {?=} notFoundValue
     * @return {?}
     */
    ReflectiveInjector.prototype.get = function (token, notFoundValue) { };
    return ReflectiveInjector;
}());
var ReflectiveInjector_ = (function () {
    /**
     * Private
     * @param {?} _providers
     * @param {?=} _parent
     */
    function ReflectiveInjector_(_providers, _parent) {
        /**
         * \@internal
         */
        this._constructionCounter = 0;
        this._providers = _providers;
        this._parent = _parent || null;
        var len = _providers.length;
        this.keyIds = new Array(len);
        this.objs = new Array(len);
        for (var i = 0; i < len; i++) {
            this.keyIds[i] = _providers[i].key.id;
            this.objs[i] = UNDEFINED;
        }
    }
    /**
     * @param {?} token
     * @param {?=} notFoundValue
     * @return {?}
     */
    ReflectiveInjector_.prototype.get = function (token, notFoundValue) {
        if (notFoundValue === void 0) { notFoundValue = THROW_IF_NOT_FOUND; }
        return this._getByKey(ReflectiveKey.get(token), null, notFoundValue);
    };
    Object.defineProperty(ReflectiveInjector_.prototype, "parent", {
        /**
         * @return {?}
         */
        get: function () { return this._parent; },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} providers
     * @return {?}
     */
    ReflectiveInjector_.prototype.resolveAndCreateChild = function (providers) {
        var /** @type {?} */ ResolvedReflectiveProviders = ReflectiveInjector.resolve(providers);
        return this.createChildFromResolved(ResolvedReflectiveProviders);
    };
    /**
     * @param {?} providers
     * @return {?}
     */
    ReflectiveInjector_.prototype.createChildFromResolved = function (providers) {
        var /** @type {?} */ inj = new ReflectiveInjector_(providers);
        inj._parent = this;
        return inj;
    };
    /**
     * @param {?} provider
     * @return {?}
     */
    ReflectiveInjector_.prototype.resolveAndInstantiate = function (provider) {
        return this.instantiateResolved(ReflectiveInjector.resolve([provider])[0]);
    };
    /**
     * @param {?} provider
     * @return {?}
     */
    ReflectiveInjector_.prototype.instantiateResolved = function (provider) {
        return this._instantiateProvider(provider);
    };
    /**
     * @param {?} index
     * @return {?}
     */
    ReflectiveInjector_.prototype.getProviderAtIndex = function (index) {
        if (index < 0 || index >= this._providers.length) {
            throw outOfBoundsError(index);
        }
        return this._providers[index];
    };
    /**
     * \@internal
     * @param {?} provider
     * @return {?}
     */
    ReflectiveInjector_.prototype._new = function (provider) {
        if (this._constructionCounter++ > this._getMaxNumberOfObjects()) {
            throw cyclicDependencyError(this, provider.key);
        }
        return this._instantiateProvider(provider);
    };
    /**
     * @return {?}
     */
    ReflectiveInjector_.prototype._getMaxNumberOfObjects = function () { return this.objs.length; };
    /**
     * @param {?} provider
     * @return {?}
     */
    ReflectiveInjector_.prototype._instantiateProvider = function (provider) {
        if (provider.multiProvider) {
            var /** @type {?} */ res = new Array(provider.resolvedFactories.length);
            for (var /** @type {?} */ i = 0; i < provider.resolvedFactories.length; ++i) {
                res[i] = this._instantiate(provider, provider.resolvedFactories[i]);
            }
            return res;
        }
        else {
            return this._instantiate(provider, provider.resolvedFactories[0]);
        }
    };
    /**
     * @param {?} provider
     * @param {?} ResolvedReflectiveFactory
     * @return {?}
     */
    ReflectiveInjector_.prototype._instantiate = function (provider, ResolvedReflectiveFactory$$1) {
        var _this = this;
        var /** @type {?} */ factory = ResolvedReflectiveFactory$$1.factory;
        var /** @type {?} */ deps;
        try {
            deps =
                ResolvedReflectiveFactory$$1.dependencies.map(function (dep) { return _this._getByReflectiveDependency(dep); });
        }
        catch (e) {
            if (e.addKey) {
                e.addKey(this, provider.key);
            }
            throw e;
        }
        var /** @type {?} */ obj;
        try {
            obj = factory.apply(void 0, deps);
        }
        catch (e) {
            throw instantiationError(this, e, e.stack, provider.key);
        }
        return obj;
    };
    /**
     * @param {?} dep
     * @return {?}
     */
    ReflectiveInjector_.prototype._getByReflectiveDependency = function (dep) {
        return this._getByKey(dep.key, dep.visibility, dep.optional ? null : THROW_IF_NOT_FOUND);
    };
    /**
     * @param {?} key
     * @param {?} visibility
     * @param {?} notFoundValue
     * @return {?}
     */
    ReflectiveInjector_.prototype._getByKey = function (key, visibility, notFoundValue) {
        if (key === INJECTOR_KEY) {
            return this;
        }
        if (visibility instanceof Self) {
            return this._getByKeySelf(key, notFoundValue);
        }
        else {
            return this._getByKeyDefault(key, notFoundValue, visibility);
        }
    };
    /**
     * @param {?} keyId
     * @return {?}
     */
    ReflectiveInjector_.prototype._getObjByKeyId = function (keyId) {
        for (var /** @type {?} */ i = 0; i < this.keyIds.length; i++) {
            if (this.keyIds[i] === keyId) {
                if (this.objs[i] === UNDEFINED) {
                    this.objs[i] = this._new(this._providers[i]);
                }
                return this.objs[i];
            }
        }
        return UNDEFINED;
    };
    /**
     * \@internal
     * @param {?} key
     * @param {?} notFoundValue
     * @return {?}
     */
    ReflectiveInjector_.prototype._throwOrNull = function (key, notFoundValue) {
        if (notFoundValue !== THROW_IF_NOT_FOUND) {
            return notFoundValue;
        }
        else {
            throw noProviderError(this, key);
        }
    };
    /**
     * \@internal
     * @param {?} key
     * @param {?} notFoundValue
     * @return {?}
     */
    ReflectiveInjector_.prototype._getByKeySelf = function (key, notFoundValue) {
        var /** @type {?} */ obj = this._getObjByKeyId(key.id);
        return (obj !== UNDEFINED) ? obj : this._throwOrNull(key, notFoundValue);
    };
    /**
     * \@internal
     * @param {?} key
     * @param {?} notFoundValue
     * @param {?} visibility
     * @return {?}
     */
    ReflectiveInjector_.prototype._getByKeyDefault = function (key, notFoundValue, visibility) {
        var /** @type {?} */ inj;
        if (visibility instanceof SkipSelf) {
            inj = this._parent;
        }
        else {
            inj = this;
        }
        while (inj instanceof ReflectiveInjector_) {
            var /** @type {?} */ inj_ = (inj);
            var /** @type {?} */ obj = inj_._getObjByKeyId(key.id);
            if (obj !== UNDEFINED)
                return obj;
            inj = inj_._parent;
        }
        if (inj !== null) {
            return inj.get(key.token, notFoundValue);
        }
        else {
            return this._throwOrNull(key, notFoundValue);
        }
    };
    Object.defineProperty(ReflectiveInjector_.prototype, "displayName", {
        /**
         * @return {?}
         */
        get: function () {
            var /** @type {?} */ providers = _mapProviders(this, function (b) { return ' "' + b.key.displayName + '" '; })
                .join(', ');
            return "ReflectiveInjector(providers: [" + providers + "])";
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    ReflectiveInjector_.prototype.toString = function () { return this.displayName; };
    return ReflectiveInjector_;
}());
var INJECTOR_KEY = ReflectiveKey.get(Injector);
/**
 * @param {?} injector
 * @param {?} fn
 * @return {?}
 */
function _mapProviders(injector, fn) {
    var /** @type {?} */ res = new Array(injector._providers.length);
    for (var /** @type {?} */ i = 0; i < injector._providers.length; ++i) {
        res[i] = fn(injector.getProviderAtIndex(i));
    }
    return res;
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @module
 * @description
 * The `di` module provides dependency injection container services.
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Determine if the argument is shaped like a Promise
 * @param {?} obj
 * @return {?}
 */
function isPromise(obj) {
    // allow any Promise/A+ compliant thenable.
    // It's up to the caller to ensure that obj.then conforms to the spec
    return !!obj && typeof obj.then === 'function';
}
/**
 * Determine if the argument is an Observable
 * @param {?} obj
 * @return {?}
 */
function isObservable(obj) {
    // TODO use Symbol.observable when https://github.com/ReactiveX/rxjs/issues/2415 will be resolved
    return !!obj && typeof obj.subscribe === 'function';
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * A function that will be executed when an application is initialized.
 * \@experimental
 */
var APP_INITIALIZER = new InjectionToken('Application Initializer');
/**
 * A class that reflects the state of running {\@link APP_INITIALIZER}s.
 *
 * \@experimental
 */
var ApplicationInitStatus = (function () {
    /**
     * @param {?} appInits
     */
    function ApplicationInitStatus(appInits) {
        var _this = this;
        this._done = false;
        var asyncInitPromises = [];
        if (appInits) {
            for (var i = 0; i < appInits.length; i++) {
                var initResult = appInits[i]();
                if (isPromise(initResult)) {
                    asyncInitPromises.push(initResult);
                }
            }
        }
        this._donePromise = Promise.all(asyncInitPromises).then(function () { _this._done = true; });
        if (asyncInitPromises.length === 0) {
            this._done = true;
        }
    }
    Object.defineProperty(ApplicationInitStatus.prototype, "done", {
        /**
         * @return {?}
         */
        get: function () { return this._done; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ApplicationInitStatus.prototype, "donePromise", {
        /**
         * @return {?}
         */
        get: function () { return this._donePromise; },
        enumerable: true,
        configurable: true
    });
    return ApplicationInitStatus;
}());
ApplicationInitStatus.decorators = [
    { type: Injectable },
];
/**
 * @nocollapse
 */
ApplicationInitStatus.ctorParameters = function () { return [
    { type: Array, decorators: [{ type: Inject, args: [APP_INITIALIZER,] }, { type: Optional },] },
]; };
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * A DI Token representing a unique string id assigned to the application by Angular and used
 * primarily for prefixing application attributes and CSS styles when
 * {\@link ViewEncapsulation#Emulated} is being used.
 *
 * If you need to avoid randomly generated value to be used as an application id, you can provide
 * a custom value via a DI provider <!-- TODO: provider --> configuring the root {\@link Injector}
 * using this token.
 * \@experimental
 */
var APP_ID = new InjectionToken('AppId');
/**
 * @return {?}
 */
function _appIdRandomProviderFactory() {
    return "" + _randomChar() + _randomChar() + _randomChar();
}
/**
 * Providers that will generate a random APP_ID_TOKEN.
 * \@experimental
 */
var APP_ID_RANDOM_PROVIDER = {
    provide: APP_ID,
    useFactory: _appIdRandomProviderFactory,
    deps: [],
};
/**
 * @return {?}
 */
function _randomChar() {
    return String.fromCharCode(97 + Math.floor(Math.random() * 25));
}
/**
 * A function that will be executed when a platform is initialized.
 * \@experimental
 */
var PLATFORM_INITIALIZER = new InjectionToken('Platform Initializer');
/**
 * A token that indicates an opaque platform id.
 * \@experimental
 */
var PLATFORM_ID = new InjectionToken('Platform ID');
/**
 * All callbacks provided via this token will be called for every component that is bootstrapped.
 * Signature of the callback:
 *
 * `(componentRef: ComponentRef) => void`.
 *
 * \@experimental
 */
var APP_BOOTSTRAP_LISTENER = new InjectionToken('appBootstrapListener');
/**
 * A token which indicates the root directory of the application
 * \@experimental
 */
var PACKAGE_ROOT_URL = new InjectionToken('Application Packages Root URL');
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var Console = (function () {
    function Console() {
    }
    /**
     * @param {?} message
     * @return {?}
     */
    Console.prototype.log = function (message) {
        // tslint:disable-next-line:no-console
        console.log(message);
    };
    /**
     * @param {?} message
     * @return {?}
     */
    Console.prototype.warn = function (message) {
        // tslint:disable-next-line:no-console
        console.warn(message);
    };
    return Console;
}());
Console.decorators = [
    { type: Injectable },
];
/**
 * @nocollapse
 */
Console.ctorParameters = function () { return []; };
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Combination of NgModuleFactory and ComponentFactorys.
 *
 * \@experimental
 */
var ModuleWithComponentFactories = (function () {
    /**
     * @param {?} ngModuleFactory
     * @param {?} componentFactories
     */
    function ModuleWithComponentFactories(ngModuleFactory, componentFactories) {
        this.ngModuleFactory = ngModuleFactory;
        this.componentFactories = componentFactories;
    }
    return ModuleWithComponentFactories;
}());
/**
 * @return {?}
 */
function _throwError() {
    throw new Error("Runtime compiler is not loaded");
}
/**
 * Low-level service for running the angular compiler during runtime
 * to create {\@link ComponentFactory}s, which
 * can later be used to create and render a Component instance.
 *
 * Each `\@NgModule` provides an own `Compiler` to its injector,
 * that will use the directives/pipes of the ng module for compilation
 * of components.
 * \@stable
 */
var Compiler = (function () {
    function Compiler() {
    }
    /**
     * Compiles the given NgModule and all of its components. All templates of the components listed
     * in `entryComponents` have to be inlined.
     * @template T
     * @param {?} moduleType
     * @return {?}
     */
    Compiler.prototype.compileModuleSync = function (moduleType) { throw _throwError(); };
    /**
     * Compiles the given NgModule and all of its components
     * @template T
     * @param {?} moduleType
     * @return {?}
     */
    Compiler.prototype.compileModuleAsync = function (moduleType) { throw _throwError(); };
    /**
     * Same as {\@link compileModuleSync} but also creates ComponentFactories for all components.
     * @template T
     * @param {?} moduleType
     * @return {?}
     */
    Compiler.prototype.compileModuleAndAllComponentsSync = function (moduleType) {
        throw _throwError();
    };
    /**
     * Same as {\@link compileModuleAsync} but also creates ComponentFactories for all components.
     * @template T
     * @param {?} moduleType
     * @return {?}
     */
    Compiler.prototype.compileModuleAndAllComponentsAsync = function (moduleType) {
        throw _throwError();
    };
    /**
     * Exposes the CSS-style selectors that have been used in `ngContent` directives within
     * the template of the given component.
     * This is used by the `upgrade` library to compile the appropriate transclude content
     * in the AngularJS wrapper component.
     *
     * @deprecated since v4. Use ComponentFactory.ngContentSelectors instead.
     * @param {?} component
     * @return {?}
     */
    Compiler.prototype.getNgContentSelectors = function (component) { throw _throwError(); };
    /**
     * Clears all caches.
     * @return {?}
     */
    Compiler.prototype.clearCache = function () { };
    /**
     * Clears the cache for the given component/ngModule.
     * @param {?} type
     * @return {?}
     */
    Compiler.prototype.clearCacheFor = function (type) { };
    return Compiler;
}());
Compiler.decorators = [
    { type: Injectable },
];
/**
 * @nocollapse
 */
Compiler.ctorParameters = function () { return []; };
/**
 * Token to provide CompilerOptions in the platform injector.
 *
 * \@experimental
 */
var COMPILER_OPTIONS = new InjectionToken('compilerOptions');
/**
 * A factory for creating a Compiler
 *
 * \@experimental
 * @abstract
 */
var CompilerFactory = (function () {
    function CompilerFactory() {
    }
    /**
     * @abstract
     * @param {?=} options
     * @return {?}
     */
    CompilerFactory.prototype.createCompiler = function (options) { };
    return CompilerFactory;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Represents an instance of a Component created via a {\@link ComponentFactory}.
 *
 * `ComponentRef` provides access to the Component Instance as well other objects related to this
 * Component Instance and allows you to destroy the Component Instance via the {\@link #destroy}
 * method.
 * \@stable
 * @abstract
 */
var ComponentRef = (function () {
    function ComponentRef() {
    }
    /**
     * Location of the Host Element of this Component Instance.
     * @abstract
     * @return {?}
     */
    ComponentRef.prototype.location = function () { };
    /**
     * The injector on which the component instance exists.
     * @abstract
     * @return {?}
     */
    ComponentRef.prototype.injector = function () { };
    /**
     * The instance of the Component.
     * @abstract
     * @return {?}
     */
    ComponentRef.prototype.instance = function () { };
    /**
     * The {\@link ViewRef} of the Host View of this Component instance.
     * @abstract
     * @return {?}
     */
    ComponentRef.prototype.hostView = function () { };
    /**
     * The {\@link ChangeDetectorRef} of the Component instance.
     * @abstract
     * @return {?}
     */
    ComponentRef.prototype.changeDetectorRef = function () { };
    /**
     * The component type.
     * @abstract
     * @return {?}
     */
    ComponentRef.prototype.componentType = function () { };
    /**
     * Destroys the component instance and all of the data structures associated with it.
     * @abstract
     * @return {?}
     */
    ComponentRef.prototype.destroy = function () { };
    /**
     * Allows to register a callback that will be called when the component is destroyed.
     * @abstract
     * @param {?} callback
     * @return {?}
     */
    ComponentRef.prototype.onDestroy = function (callback) { };
    return ComponentRef;
}());
/**
 * \@stable
 * @abstract
 */
var ComponentFactory = (function () {
    function ComponentFactory() {
    }
    /**
     * @abstract
     * @return {?}
     */
    ComponentFactory.prototype.selector = function () { };
    /**
     * @abstract
     * @return {?}
     */
    ComponentFactory.prototype.componentType = function () { };
    /**
     * selector for all <ng-content> elements in the component.
     * @abstract
     * @return {?}
     */
    ComponentFactory.prototype.ngContentSelectors = function () { };
    /**
     * the inputs of the component.
     * @abstract
     * @return {?}
     */
    ComponentFactory.prototype.inputs = function () { };
    /**
     * the outputs of the component.
     * @abstract
     * @return {?}
     */
    ComponentFactory.prototype.outputs = function () { };
    /**
     * Creates a new component.
     * @abstract
     * @param {?} injector
     * @param {?=} projectableNodes
     * @param {?=} rootSelectorOrNode
     * @param {?=} ngModule
     * @return {?}
     */
    ComponentFactory.prototype.create = function (injector, projectableNodes, rootSelectorOrNode, ngModule) { };
    return ComponentFactory;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @param {?} component
 * @return {?}
 */
function noComponentFactoryError(component) {
    var /** @type {?} */ error = Error("No component factory found for " + stringify(component) + ". Did you add it to @NgModule.entryComponents?");
    ((error))[ERROR_COMPONENT] = component;
    return error;
}
var ERROR_COMPONENT = 'ngComponent';
/**
 * @param {?} error
 * @return {?}
 */
var _NullComponentFactoryResolver = (function () {
    function _NullComponentFactoryResolver() {
    }
    /**
     * @template T
     * @param {?} component
     * @return {?}
     */
    _NullComponentFactoryResolver.prototype.resolveComponentFactory = function (component) {
        throw noComponentFactoryError(component);
    };
    return _NullComponentFactoryResolver;
}());
/**
 * \@stable
 * @abstract
 */
var ComponentFactoryResolver = (function () {
    function ComponentFactoryResolver() {
    }
    /**
     * @abstract
     * @template T
     * @param {?} component
     * @return {?}
     */
    ComponentFactoryResolver.prototype.resolveComponentFactory = function (component) { };
    return ComponentFactoryResolver;
}());
ComponentFactoryResolver.NULL = new _NullComponentFactoryResolver();
var CodegenComponentFactoryResolver = (function () {
    /**
     * @param {?} factories
     * @param {?} _parent
     * @param {?} _ngModule
     */
    function CodegenComponentFactoryResolver(factories, _parent, _ngModule) {
        this._parent = _parent;
        this._ngModule = _ngModule;
        this._factories = new Map();
        for (var i = 0; i < factories.length; i++) {
            var factory = factories[i];
            this._factories.set(factory.componentType, factory);
        }
    }
    /**
     * @template T
     * @param {?} component
     * @return {?}
     */
    CodegenComponentFactoryResolver.prototype.resolveComponentFactory = function (component) {
        var /** @type {?} */ factory = this._factories.get(component) || this._parent.resolveComponentFactory(component);
        return new ComponentFactoryBoundToModule(factory, this._ngModule);
    };
    return CodegenComponentFactoryResolver;
}());
var ComponentFactoryBoundToModule = (function (_super) {
    __extends(ComponentFactoryBoundToModule, _super);
    /**
     * @param {?} factory
     * @param {?} ngModule
     */
    function ComponentFactoryBoundToModule(factory, ngModule) {
        var _this = _super.call(this) || this;
        _this.factory = factory;
        _this.ngModule = ngModule;
        return _this;
    }
    Object.defineProperty(ComponentFactoryBoundToModule.prototype, "selector", {
        /**
         * @return {?}
         */
        get: function () { return this.factory.selector; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComponentFactoryBoundToModule.prototype, "componentType", {
        /**
         * @return {?}
         */
        get: function () { return this.factory.componentType; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComponentFactoryBoundToModule.prototype, "ngContentSelectors", {
        /**
         * @return {?}
         */
        get: function () { return this.factory.ngContentSelectors; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComponentFactoryBoundToModule.prototype, "inputs", {
        /**
         * @return {?}
         */
        get: function () { return this.factory.inputs; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComponentFactoryBoundToModule.prototype, "outputs", {
        /**
         * @return {?}
         */
        get: function () { return this.factory.outputs; },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} injector
     * @param {?=} projectableNodes
     * @param {?=} rootSelectorOrNode
     * @param {?=} ngModule
     * @return {?}
     */
    ComponentFactoryBoundToModule.prototype.create = function (injector, projectableNodes, rootSelectorOrNode, ngModule) {
        return this.factory.create(injector, projectableNodes, rootSelectorOrNode, ngModule || this.ngModule);
    };
    return ComponentFactoryBoundToModule;
}(ComponentFactory));
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Represents an instance of an NgModule created via a {\@link NgModuleFactory}.
 *
 * `NgModuleRef` provides access to the NgModule Instance as well other objects related to this
 * NgModule Instance.
 *
 * \@stable
 * @abstract
 */
var NgModuleRef = (function () {
    function NgModuleRef() {
    }
    /**
     * The injector that contains all of the providers of the NgModule.
     * @abstract
     * @return {?}
     */
    NgModuleRef.prototype.injector = function () { };
    /**
     * The ComponentFactoryResolver to get hold of the ComponentFactories
     * declared in the `entryComponents` property of the module.
     * @abstract
     * @return {?}
     */
    NgModuleRef.prototype.componentFactoryResolver = function () { };
    /**
     * The NgModule instance.
     * @abstract
     * @return {?}
     */
    NgModuleRef.prototype.instance = function () { };
    /**
     * Destroys the module instance and all of the data structures associated with it.
     * @abstract
     * @return {?}
     */
    NgModuleRef.prototype.destroy = function () { };
    /**
     * Allows to register a callback that will be called when the module is destroyed.
     * @abstract
     * @param {?} callback
     * @return {?}
     */
    NgModuleRef.prototype.onDestroy = function (callback) { };
    return NgModuleRef;
}());
/**
 * \@experimental
 */
var NgModuleFactory = (function () {
    /**
     * @param {?} _injectorClass
     * @param {?} _moduleType
     */
    function NgModuleFactory(_injectorClass, _moduleType) {
        this._injectorClass = _injectorClass;
        this._moduleType = _moduleType;
    }
    Object.defineProperty(NgModuleFactory.prototype, "moduleType", {
        /**
         * @return {?}
         */
        get: function () { return this._moduleType; },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} parentInjector
     * @return {?}
     */
    NgModuleFactory.prototype.create = function (parentInjector) {
        var /** @type {?} */ instance = new this._injectorClass(parentInjector || Injector.NULL);
        instance.create();
        return instance;
    };
    return NgModuleFactory;
}());
var _UNDEFINED = new Object();
/**
 * @abstract
 */
var NgModuleInjector = (function () {
    /**
     * @param {?} parent
     * @param {?} factories
     * @param {?} bootstrapFactories
     */
    function NgModuleInjector(parent, factories, bootstrapFactories) {
        var _this = this;
        this.parent = parent;
        this._destroyListeners = [];
        this._destroyed = false;
        this.bootstrapFactories =
            bootstrapFactories.map(function (f) { return new ComponentFactoryBoundToModule(f, _this); });
        this._cmpFactoryResolver = new CodegenComponentFactoryResolver(factories, parent.get(ComponentFactoryResolver, ComponentFactoryResolver.NULL), this);
    }
    /**
     * @return {?}
     */
    NgModuleInjector.prototype.create = function () { this.instance = this.createInternal(); };
    /**
     * @abstract
     * @return {?}
     */
    NgModuleInjector.prototype.createInternal = function () { };
    /**
     * @param {?} token
     * @param {?=} notFoundValue
     * @return {?}
     */
    NgModuleInjector.prototype.get = function (token, notFoundValue) {
        if (notFoundValue === void 0) { notFoundValue = THROW_IF_NOT_FOUND; }
        if (token === Injector || token === NgModuleRef) {
            return this;
        }
        if (token === ComponentFactoryResolver) {
            return this._cmpFactoryResolver;
        }
        var /** @type {?} */ result = this.getInternal(token, _UNDEFINED);
        return result === _UNDEFINED ? this.parent.get(token, notFoundValue) : result;
    };
    /**
     * @abstract
     * @param {?} token
     * @param {?} notFoundValue
     * @return {?}
     */
    NgModuleInjector.prototype.getInternal = function (token, notFoundValue) { };
    Object.defineProperty(NgModuleInjector.prototype, "injector", {
        /**
         * @return {?}
         */
        get: function () { return this; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgModuleInjector.prototype, "componentFactoryResolver", {
        /**
         * @return {?}
         */
        get: function () { return this._cmpFactoryResolver; },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    NgModuleInjector.prototype.destroy = function () {
        if (this._destroyed) {
            throw new Error("The ng module " + stringify(this.instance.constructor) + " has already been destroyed.");
        }
        this._destroyed = true;
        this.destroyInternal();
        this._destroyListeners.forEach(function (listener) { return listener(); });
    };
    /**
     * @param {?} callback
     * @return {?}
     */
    NgModuleInjector.prototype.onDestroy = function (callback) { this._destroyListeners.push(callback); };
    /**
     * @abstract
     * @return {?}
     */
    NgModuleInjector.prototype.destroyInternal = function () { };
    return NgModuleInjector;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var trace;
var events;
/**
 * @return {?}
 */
function detectWTF() {
    var /** @type {?} */ wtf = ((_global) /** TODO #9100 */)['wtf'];
    if (wtf) {
        trace = wtf['trace'];
        if (trace) {
            events = trace['events'];
            return true;
        }
    }
    return false;
}
/**
 * @param {?} signature
 * @param {?=} flags
 * @return {?}
 */
function createScope$1(signature, flags) {
    if (flags === void 0) { flags = null; }
    return events.createScope(signature, flags);
}
/**
 * @template T
 * @param {?} scope
 * @param {?=} returnValue
 * @return {?}
 */
function leave(scope, returnValue) {
    trace.leaveScope(scope, returnValue);
    return returnValue;
}
/**
 * @param {?} rangeType
 * @param {?} action
 * @return {?}
 */
function startTimeRange(rangeType, action) {
    return trace.beginTimeRange(rangeType, action);
}
/**
 * @param {?} range
 * @return {?}
 */
function endTimeRange(range) {
    trace.endTimeRange(range);
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * True if WTF is enabled.
 */
var wtfEnabled = detectWTF();
/**
 * @param {?=} arg0
 * @param {?=} arg1
 * @return {?}
 */
function noopScope(arg0, arg1) {
    return null;
}
/**
 * Create trace scope.
 *
 * Scopes must be strictly nested and are analogous to stack frames, but
 * do not have to follow the stack frames. Instead it is recommended that they follow logical
 * nesting. You may want to use
 * [Event
 * Signatures](http://google.github.io/tracing-framework/instrumenting-code.html#custom-events)
 * as they are defined in WTF.
 *
 * Used to mark scope entry. The return value is used to leave the scope.
 *
 *     var myScope = wtfCreateScope('MyClass#myMethod(ascii someVal)');
 *
 *     someMethod() {
 *        var s = myScope('Foo'); // 'Foo' gets stored in tracing UI
 *        // DO SOME WORK HERE
 *        return wtfLeave(s, 123); // Return value 123
 *     }
 *
 * Note, adding try-finally block around the work to ensure that `wtfLeave` gets called can
 * negatively impact the performance of your application. For this reason we recommend that
 * you don't add them to ensure that `wtfLeave` gets called. In production `wtfLeave` is a noop and
 * so try-finally block has no value. When debugging perf issues, skipping `wtfLeave`, do to
 * exception, will produce incorrect trace, but presence of exception signifies logic error which
 * needs to be fixed before the app should be profiled. Add try-finally only when you expect that
 * an exception is expected during normal execution while profiling.
 *
 * \@experimental
 */
var wtfCreateScope = wtfEnabled ? createScope$1 : function (signature, flags) { return noopScope; };
/**
 * Used to mark end of Scope.
 *
 * - `scope` to end.
 * - `returnValue` (optional) to be passed to the WTF.
 *
 * Returns the `returnValue for easy chaining.
 * \@experimental
 */
var wtfLeave = wtfEnabled ? leave : function (s, r) { return r; };
/**
 * Used to mark Async start. Async are similar to scope but they don't have to be strictly nested.
 * The return value is used in the call to [endAsync]. Async ranges only work if WTF has been
 * enabled.
 *
 *     someMethod() {
 *        var s = wtfStartTimeRange('HTTP:GET', 'some.url');
 *        var future = new Future.delay(5).then((_) {
 *          wtfEndTimeRange(s);
 *        });
 *     }
 * \@experimental
 */
var wtfStartTimeRange = wtfEnabled ? startTimeRange : function (rangeType, action) { return null; };
/**
 * Ends a async time range operation.
 * [range] is the return value from [wtfStartTimeRange] Async ranges only work if WTF has been
 * enabled.
 * \@experimental
 */
var wtfEndTimeRange = wtfEnabled ? endTimeRange : function (r) { return null; };
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Use by directives and components to emit custom Events.
 *
 * ### Examples
 *
 * In the following example, `Zippy` alternatively emits `open` and `close` events when its
 * title gets clicked:
 *
 * ```
 * \@Component({
 *   selector: 'zippy',
 *   template: `
 *   <div class="zippy">
 *     <div (click)="toggle()">Toggle</div>
 *     <div [hidden]="!visible">
 *       <ng-content></ng-content>
 *     </div>
 *  </div>`})
 * export class Zippy {
 *   visible: boolean = true;
 *   \@Output() open: EventEmitter<any> = new EventEmitter();
 *   \@Output() close: EventEmitter<any> = new EventEmitter();
 *
 *   toggle() {
 *     this.visible = !this.visible;
 *     if (this.visible) {
 *       this.open.emit(null);
 *     } else {
 *       this.close.emit(null);
 *     }
 *   }
 * }
 * ```
 *
 * The events payload can be accessed by the parameter `$event` on the components output event
 * handler:
 *
 * ```
 * <zippy (open)="onOpen($event)" (close)="onClose($event)"></zippy>
 * ```
 *
 * Uses Rx.Observable but provides an adapter to make it work as specified here:
 * https://github.com/jhusain/observable-spec
 *
 * Once a reference implementation of the spec is available, switch to it.
 * \@stable
 */
var EventEmitter = (function (_super) {
    __extends(EventEmitter, _super);
    /**
     * Creates an instance of [EventEmitter], which depending on [isAsync],
     * delivers events synchronously or asynchronously.
     * @param {?=} isAsync
     */
    function EventEmitter(isAsync) {
        if (isAsync === void 0) { isAsync = false; }
        var _this = _super.call(this) || this;
        _this.__isAsync = isAsync;
        return _this;
    }
    /**
     * @param {?=} value
     * @return {?}
     */
    EventEmitter.prototype.emit = function (value) { _super.prototype.next.call(this, value); };
    /**
     * @param {?=} generatorOrNext
     * @param {?=} error
     * @param {?=} complete
     * @return {?}
     */
    EventEmitter.prototype.subscribe = function (generatorOrNext, error, complete) {
        var /** @type {?} */ schedulerFn;
        var /** @type {?} */ errorFn = function (err) { return null; };
        var /** @type {?} */ completeFn = function () { return null; };
        if (generatorOrNext && typeof generatorOrNext === 'object') {
            schedulerFn = this.__isAsync ? function (value) {
                setTimeout(function () { return generatorOrNext.next(value); });
            } : function (value) { generatorOrNext.next(value); };
            if (generatorOrNext.error) {
                errorFn = this.__isAsync ? function (err) { setTimeout(function () { return generatorOrNext.error(err); }); } :
                    function (err) { generatorOrNext.error(err); };
            }
            if (generatorOrNext.complete) {
                completeFn = this.__isAsync ? function () { setTimeout(function () { return generatorOrNext.complete(); }); } :
                    function () { generatorOrNext.complete(); };
            }
        }
        else {
            schedulerFn = this.__isAsync ? function (value) { setTimeout(function () { return generatorOrNext(value); }); } :
                function (value) { generatorOrNext(value); };
            if (error) {
                errorFn =
                    this.__isAsync ? function (err) { setTimeout(function () { return error(err); }); } : function (err) { error(err); };
            }
            if (complete) {
                completeFn =
                    this.__isAsync ? function () { setTimeout(function () { return complete(); }); } : function () { complete(); };
            }
        }
        return _super.prototype.subscribe.call(this, schedulerFn, errorFn, completeFn);
    };
    return EventEmitter;
}(__WEBPACK_IMPORTED_MODULE_3_rxjs_Subject__["Subject"]));
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * An injectable service for executing work inside or outside of the Angular zone.
 *
 * The most common use of this service is to optimize performance when starting a work consisting of
 * one or more asynchronous tasks that don't require UI updates or error handling to be handled by
 * Angular. Such tasks can be kicked off via {\@link runOutsideAngular} and if needed, these tasks
 * can reenter the Angular zone via {\@link run}.
 *
 * <!-- TODO: add/fix links to:
 *   - docs explaining zones and the use of zones in Angular and change-detection
 *   - link to runOutsideAngular/run (throughout this file!)
 *   -->
 *
 * ### Example
 *
 * ```
 * import {Component, NgZone} from '\@angular/core';
 * import {NgIf} from '\@angular/common';
 *
 * \@Component({
 *   selector: 'ng-zone-demo'.
 *   template: `
 *     <h2>Demo: NgZone</h2>
 *
 *     <p>Progress: {{progress}}%</p>
 *     <p *ngIf="progress >= 100">Done processing {{label}} of Angular zone!</p>
 *
 *     <button (click)="processWithinAngularZone()">Process within Angular zone</button>
 *     <button (click)="processOutsideOfAngularZone()">Process outside of Angular zone</button>
 *   `,
 * })
 * export class NgZoneDemo {
 *   progress: number = 0;
 *   label: string;
 *
 *   constructor(private _ngZone: NgZone) {}
 *
 *   // Loop inside the Angular zone
 *   // so the UI DOES refresh after each setTimeout cycle
 *   processWithinAngularZone() {
 *     this.label = 'inside';
 *     this.progress = 0;
 *     this._increaseProgress(() => console.log('Inside Done!'));
 *   }
 *
 *   // Loop outside of the Angular zone
 *   // so the UI DOES NOT refresh after each setTimeout cycle
 *   processOutsideOfAngularZone() {
 *     this.label = 'outside';
 *     this.progress = 0;
 *     this._ngZone.runOutsideAngular(() => {
 *       this._increaseProgress(() => {
 *       // reenter the Angular zone and display done
 *       this._ngZone.run(() => {console.log('Outside Done!') });
 *     }}));
 *   }
 *
 *   _increaseProgress(doneCallback: () => void) {
 *     this.progress += 1;
 *     console.log(`Current progress: ${this.progress}%`);
 *
 *     if (this.progress < 100) {
 *       window.setTimeout(() => this._increaseProgress(doneCallback)), 10)
 *     } else {
 *       doneCallback();
 *     }
 *   }
 * }
 * ```
 *
 * \@experimental
 */
var NgZone = (function () {
    /**
     * @param {?} __0
     */
    function NgZone(_a) {
        var _b = _a.enableLongStackTrace, enableLongStackTrace = _b === void 0 ? false : _b;
        this._hasPendingMicrotasks = false;
        this._hasPendingMacrotasks = false;
        this._isStable = true;
        this._nesting = 0;
        this._onUnstable = new EventEmitter(false);
        this._onMicrotaskEmpty = new EventEmitter(false);
        this._onStable = new EventEmitter(false);
        this._onErrorEvents = new EventEmitter(false);
        if (typeof Zone == 'undefined') {
            throw new Error('Angular requires Zone.js prolyfill.');
        }
        Zone.assertZonePatched();
        this.outer = this.inner = Zone.current;
        if (Zone['wtfZoneSpec']) {
            this.inner = this.inner.fork(Zone['wtfZoneSpec']);
        }
        if (enableLongStackTrace && Zone['longStackTraceZoneSpec']) {
            this.inner = this.inner.fork(Zone['longStackTraceZoneSpec']);
        }
        this.forkInnerZoneWithAngularBehavior();
    }
    /**
     * @return {?}
     */
    NgZone.isInAngularZone = function () { return Zone.current.get('isAngularZone') === true; };
    /**
     * @return {?}
     */
    NgZone.assertInAngularZone = function () {
        if (!NgZone.isInAngularZone()) {
            throw new Error('Expected to be in Angular Zone, but it is not!');
        }
    };
    /**
     * @return {?}
     */
    NgZone.assertNotInAngularZone = function () {
        if (NgZone.isInAngularZone()) {
            throw new Error('Expected to not be in Angular Zone, but it is!');
        }
    };
    /**
     * Executes the `fn` function synchronously within the Angular zone and returns value returned by
     * the function.
     *
     * Running functions via `run` allows you to reenter Angular zone from a task that was executed
     * outside of the Angular zone (typically started via {\@link runOutsideAngular}).
     *
     * Any future tasks or microtasks scheduled from within this function will continue executing from
     * within the Angular zone.
     *
     * If a synchronous error happens it will be rethrown and not reported via `onError`.
     * @param {?} fn
     * @return {?}
     */
    NgZone.prototype.run = function (fn) { return this.inner.run(fn); };
    /**
     * Same as `run`, except that synchronous errors are caught and forwarded via `onError` and not
     * rethrown.
     * @param {?} fn
     * @return {?}
     */
    NgZone.prototype.runGuarded = function (fn) { return this.inner.runGuarded(fn); };
    /**
     * Executes the `fn` function synchronously in Angular's parent zone and returns value returned by
     * the function.
     *
     * Running functions via `runOutsideAngular` allows you to escape Angular's zone and do work that
     * doesn't trigger Angular change-detection or is subject to Angular's error handling.
     *
     * Any future tasks or microtasks scheduled from within this function will continue executing from
     * outside of the Angular zone.
     *
     * Use {\@link run} to reenter the Angular zone and do work that updates the application model.
     * @param {?} fn
     * @return {?}
     */
    NgZone.prototype.runOutsideAngular = function (fn) { return this.outer.run(fn); };
    Object.defineProperty(NgZone.prototype, "onUnstable", {
        /**
         * Notifies when code enters Angular Zone. This gets fired first on VM Turn.
         * @return {?}
         */
        get: function () { return this._onUnstable; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgZone.prototype, "onMicrotaskEmpty", {
        /**
         * Notifies when there is no more microtasks enqueue in the current VM Turn.
         * This is a hint for Angular to do change detection, which may enqueue more microtasks.
         * For this reason this event can fire multiple times per VM Turn.
         * @return {?}
         */
        get: function () { return this._onMicrotaskEmpty; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgZone.prototype, "onStable", {
        /**
         * Notifies when the last `onMicrotaskEmpty` has run and there are no more microtasks, which
         * implies we are about to relinquish VM turn.
         * This event gets called just once.
         * @return {?}
         */
        get: function () { return this._onStable; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgZone.prototype, "onError", {
        /**
         * Notify that an error has been delivered.
         * @return {?}
         */
        get: function () { return this._onErrorEvents; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgZone.prototype, "isStable", {
        /**
         * Whether there are no outstanding microtasks or macrotasks.
         * @return {?}
         */
        get: function () { return this._isStable; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgZone.prototype, "hasPendingMicrotasks", {
        /**
         * @return {?}
         */
        get: function () { return this._hasPendingMicrotasks; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgZone.prototype, "hasPendingMacrotasks", {
        /**
         * @return {?}
         */
        get: function () { return this._hasPendingMacrotasks; },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    NgZone.prototype.checkStable = function () {
        var _this = this;
        if (this._nesting == 0 && !this._hasPendingMicrotasks && !this._isStable) {
            try {
                this._nesting++;
                this._onMicrotaskEmpty.emit(null);
            }
            finally {
                this._nesting--;
                if (!this._hasPendingMicrotasks) {
                    try {
                        this.runOutsideAngular(function () { return _this._onStable.emit(null); });
                    }
                    finally {
                        this._isStable = true;
                    }
                }
            }
        }
    };
    /**
     * @return {?}
     */
    NgZone.prototype.forkInnerZoneWithAngularBehavior = function () {
        var _this = this;
        this.inner = this.inner.fork({
            name: 'angular',
            properties: /** @type {?} */ ({ 'isAngularZone': true }),
            onInvokeTask: function (delegate, current, target, task, applyThis, applyArgs) {
                try {
                    _this.onEnter();
                    return delegate.invokeTask(target, task, applyThis, applyArgs);
                }
                finally {
                    _this.onLeave();
                }
            },
            onInvoke: function (delegate, current, target, callback, applyThis, applyArgs, source) {
                try {
                    _this.onEnter();
                    return delegate.invoke(target, callback, applyThis, applyArgs, source);
                }
                finally {
                    _this.onLeave();
                }
            },
            onHasTask: function (delegate, current, target, hasTaskState) {
                delegate.hasTask(target, hasTaskState);
                if (current === target) {
                    // We are only interested in hasTask events which originate from our zone
                    // (A child hasTask event is not interesting to us)
                    if (hasTaskState.change == 'microTask') {
                        _this.setHasMicrotask(hasTaskState.microTask);
                    }
                    else if (hasTaskState.change == 'macroTask') {
                        _this.setHasMacrotask(hasTaskState.macroTask);
                    }
                }
            },
            onHandleError: function (delegate, current, target, error) {
                delegate.handleError(target, error);
                _this.triggerError(error);
                return false;
            }
        });
    };
    /**
     * @return {?}
     */
    NgZone.prototype.onEnter = function () {
        this._nesting++;
        if (this._isStable) {
            this._isStable = false;
            this._onUnstable.emit(null);
        }
    };
    /**
     * @return {?}
     */
    NgZone.prototype.onLeave = function () {
        this._nesting--;
        this.checkStable();
    };
    /**
     * @param {?} hasMicrotasks
     * @return {?}
     */
    NgZone.prototype.setHasMicrotask = function (hasMicrotasks) {
        this._hasPendingMicrotasks = hasMicrotasks;
        this.checkStable();
    };
    /**
     * @param {?} hasMacrotasks
     * @return {?}
     */
    NgZone.prototype.setHasMacrotask = function (hasMacrotasks) { this._hasPendingMacrotasks = hasMacrotasks; };
    /**
     * @param {?} error
     * @return {?}
     */
    NgZone.prototype.triggerError = function (error) { this._onErrorEvents.emit(error); };
    return NgZone;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * The Testability service provides testing hooks that can be accessed from
 * the browser and by services such as Protractor. Each bootstrapped Angular
 * application on the page will have an instance of Testability.
 * \@experimental
 */
var Testability = (function () {
    /**
     * @param {?} _ngZone
     */
    function Testability(_ngZone) {
        this._ngZone = _ngZone;
        /**
         * \@internal
         */
        this._pendingCount = 0;
        /**
         * \@internal
         */
        this._isZoneStable = true;
        /**
         * Whether any work was done since the last 'whenStable' callback. This is
         * useful to detect if this could have potentially destabilized another
         * component while it is stabilizing.
         * \@internal
         */
        this._didWork = false;
        /**
         * \@internal
         */
        this._callbacks = [];
        this._watchAngularEvents();
    }
    /**
     * \@internal
     * @return {?}
     */
    Testability.prototype._watchAngularEvents = function () {
        var _this = this;
        this._ngZone.onUnstable.subscribe({
            next: function () {
                _this._didWork = true;
                _this._isZoneStable = false;
            }
        });
        this._ngZone.runOutsideAngular(function () {
            _this._ngZone.onStable.subscribe({
                next: function () {
                    NgZone.assertNotInAngularZone();
                    scheduleMicroTask(function () {
                        _this._isZoneStable = true;
                        _this._runCallbacksIfReady();
                    });
                }
            });
        });
    };
    /**
     * @return {?}
     */
    Testability.prototype.increasePendingRequestCount = function () {
        this._pendingCount += 1;
        this._didWork = true;
        return this._pendingCount;
    };
    /**
     * @return {?}
     */
    Testability.prototype.decreasePendingRequestCount = function () {
        this._pendingCount -= 1;
        if (this._pendingCount < 0) {
            throw new Error('pending async requests below zero');
        }
        this._runCallbacksIfReady();
        return this._pendingCount;
    };
    /**
     * @return {?}
     */
    Testability.prototype.isStable = function () {
        return this._isZoneStable && this._pendingCount == 0 && !this._ngZone.hasPendingMacrotasks;
    };
    /**
     * \@internal
     * @return {?}
     */
    Testability.prototype._runCallbacksIfReady = function () {
        var _this = this;
        if (this.isStable()) {
            // Schedules the call backs in a new frame so that it is always async.
            scheduleMicroTask(function () {
                while (_this._callbacks.length !== 0) {
                    (((_this._callbacks.pop())))(_this._didWork);
                }
                _this._didWork = false;
            });
        }
        else {
            // Not Ready
            this._didWork = true;
        }
    };
    /**
     * @param {?} callback
     * @return {?}
     */
    Testability.prototype.whenStable = function (callback) {
        this._callbacks.push(callback);
        this._runCallbacksIfReady();
    };
    /**
     * @return {?}
     */
    Testability.prototype.getPendingRequestCount = function () { return this._pendingCount; };
    /**
     * @deprecated use findProviders
     * @param {?} using
     * @param {?} provider
     * @param {?} exactMatch
     * @return {?}
     */
    Testability.prototype.findBindings = function (using, provider, exactMatch) {
        // TODO(juliemr): implement.
        return [];
    };
    /**
     * @param {?} using
     * @param {?} provider
     * @param {?} exactMatch
     * @return {?}
     */
    Testability.prototype.findProviders = function (using, provider, exactMatch) {
        // TODO(juliemr): implement.
        return [];
    };
    return Testability;
}());
Testability.decorators = [
    { type: Injectable },
];
/**
 * @nocollapse
 */
Testability.ctorParameters = function () { return [
    { type: NgZone, },
]; };
/**
 * A global registry of {\@link Testability} instances for specific elements.
 * \@experimental
 */
var TestabilityRegistry = (function () {
    function TestabilityRegistry() {
        /**
         * \@internal
         */
        this._applications = new Map();
        _testabilityGetter.addToWindow(this);
    }
    /**
     * @param {?} token
     * @param {?} testability
     * @return {?}
     */
    TestabilityRegistry.prototype.registerApplication = function (token, testability) {
        this._applications.set(token, testability);
    };
    /**
     * @param {?} elem
     * @return {?}
     */
    TestabilityRegistry.prototype.getTestability = function (elem) { return this._applications.get(elem) || null; };
    /**
     * @return {?}
     */
    TestabilityRegistry.prototype.getAllTestabilities = function () { return Array.from(this._applications.values()); };
    /**
     * @return {?}
     */
    TestabilityRegistry.prototype.getAllRootElements = function () { return Array.from(this._applications.keys()); };
    /**
     * @param {?} elem
     * @param {?=} findInAncestors
     * @return {?}
     */
    TestabilityRegistry.prototype.findTestabilityInTree = function (elem, findInAncestors) {
        if (findInAncestors === void 0) { findInAncestors = true; }
        return _testabilityGetter.findTestabilityInTree(this, elem, findInAncestors);
    };
    return TestabilityRegistry;
}());
TestabilityRegistry.decorators = [
    { type: Injectable },
];
/**
 * @nocollapse
 */
TestabilityRegistry.ctorParameters = function () { return []; };
var _NoopGetTestability = (function () {
    function _NoopGetTestability() {
    }
    /**
     * @param {?} registry
     * @return {?}
     */
    _NoopGetTestability.prototype.addToWindow = function (registry) { };
    /**
     * @param {?} registry
     * @param {?} elem
     * @param {?} findInAncestors
     * @return {?}
     */
    _NoopGetTestability.prototype.findTestabilityInTree = function (registry, elem, findInAncestors) {
        return null;
    };
    return _NoopGetTestability;
}());
/**
 * Set the {\@link GetTestability} implementation used by the Angular testing framework.
 * \@experimental
 * @param {?} getter
 * @return {?}
 */
function setTestabilityGetter(getter) {
    _testabilityGetter = getter;
}
var _testabilityGetter = new _NoopGetTestability();
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var _devMode = true;
var _runModeLocked = false;
var _platform;
var ALLOW_MULTIPLE_PLATFORMS = new InjectionToken('AllowMultipleToken');
/**
 * Disable Angular's development mode, which turns off assertions and other
 * checks within the framework.
 *
 * One important assertion this disables verifies that a change detection pass
 * does not result in additional changes to any bindings (also known as
 * unidirectional data flow).
 *
 * \@stable
 * @return {?}
 */
function enableProdMode() {
    if (_runModeLocked) {
        throw new Error('Cannot enable prod mode after platform setup.');
    }
    _devMode = false;
}
/**
 * Returns whether Angular is in development mode. After called once,
 * the value is locked and won't change any more.
 *
 * By default, this is true, unless a user calls `enableProdMode` before calling this.
 *
 * \@experimental APIs related to application bootstrap are currently under review.
 * @return {?}
 */
function isDevMode() {
    _runModeLocked = true;
    return _devMode;
}
/**
 * A token for third-party components that can register themselves with NgProbe.
 *
 * \@experimental
 */
var NgProbeToken = (function () {
    /**
     * @param {?} name
     * @param {?} token
     */
    function NgProbeToken(name, token) {
        this.name = name;
        this.token = token;
    }
    return NgProbeToken;
}());
/**
 * Creates a platform.
 * Platforms have to be eagerly created via this function.
 *
 * \@experimental APIs related to application bootstrap are currently under review.
 * @param {?} injector
 * @return {?}
 */
function createPlatform(injector) {
    if (_platform && !_platform.destroyed &&
        !_platform.injector.get(ALLOW_MULTIPLE_PLATFORMS, false)) {
        throw new Error('There can be only one platform. Destroy the previous one to create a new one.');
    }
    _platform = injector.get(PlatformRef);
    var /** @type {?} */ inits = injector.get(PLATFORM_INITIALIZER, null);
    if (inits)
        inits.forEach(function (init) { return init(); });
    return _platform;
}
/**
 * Creates a factory for a platform
 *
 * \@experimental APIs related to application bootstrap are currently under review.
 * @param {?} parentPlatformFactory
 * @param {?} name
 * @param {?=} providers
 * @return {?}
 */
function createPlatformFactory(parentPlatformFactory, name, providers) {
    if (providers === void 0) { providers = []; }
    var /** @type {?} */ marker = new InjectionToken("Platform: " + name);
    return function (extraProviders) {
        if (extraProviders === void 0) { extraProviders = []; }
        var /** @type {?} */ platform = getPlatform();
        if (!platform || platform.injector.get(ALLOW_MULTIPLE_PLATFORMS, false)) {
            if (parentPlatformFactory) {
                parentPlatformFactory(providers.concat(extraProviders).concat({ provide: marker, useValue: true }));
            }
            else {
                createPlatform(ReflectiveInjector.resolveAndCreate(providers.concat(extraProviders).concat({ provide: marker, useValue: true })));
            }
        }
        return assertPlatform(marker);
    };
}
/**
 * Checks that there currently is a platform which contains the given token as a provider.
 *
 * \@experimental APIs related to application bootstrap are currently under review.
 * @param {?} requiredToken
 * @return {?}
 */
function assertPlatform(requiredToken) {
    var /** @type {?} */ platform = getPlatform();
    if (!platform) {
        throw new Error('No platform exists!');
    }
    if (!platform.injector.get(requiredToken, null)) {
        throw new Error('A platform with a different configuration has been created. Please destroy it first.');
    }
    return platform;
}
/**
 * Destroy the existing platform.
 *
 * \@experimental APIs related to application bootstrap are currently under review.
 * @return {?}
 */
function destroyPlatform() {
    if (_platform && !_platform.destroyed) {
        _platform.destroy();
    }
}
/**
 * Returns the current platform.
 *
 * \@experimental APIs related to application bootstrap are currently under review.
 * @return {?}
 */
function getPlatform() {
    return _platform && !_platform.destroyed ? _platform : null;
}
/**
 * The Angular platform is the entry point for Angular on a web page. Each page
 * has exactly one platform, and services (such as reflection) which are common
 * to every Angular application running on the page are bound in its scope.
 *
 * A page's platform is initialized implicitly when {\@link bootstrap}() is called, or
 * explicitly by calling {\@link createPlatform}().
 *
 * \@stable
 * @abstract
 */
var PlatformRef = (function () {
    function PlatformRef() {
    }
    /**
     * Creates an instance of an `\@NgModule` for the given platform
     * for offline compilation.
     *
     * ## Simple Example
     *
     * ```typescript
     * my_module.ts:
     *
     * \@NgModule({
     *   imports: [BrowserModule]
     * })
     * class MyModule {}
     *
     * main.ts:
     * import {MyModuleNgFactory} from './my_module.ngfactory';
     * import {platformBrowser} from '\@angular/platform-browser';
     *
     * let moduleRef = platformBrowser().bootstrapModuleFactory(MyModuleNgFactory);
     * ```
     *
     * \@experimental APIs related to application bootstrap are currently under review.
     * @abstract
     * @template M
     * @param {?} moduleFactory
     * @return {?}
     */
    PlatformRef.prototype.bootstrapModuleFactory = function (moduleFactory) { };
    /**
     * Creates an instance of an `\@NgModule` for a given platform using the given runtime compiler.
     *
     * ## Simple Example
     *
     * ```typescript
     * \@NgModule({
     *   imports: [BrowserModule]
     * })
     * class MyModule {}
     *
     * let moduleRef = platformBrowser().bootstrapModule(MyModule);
     * ```
     * \@stable
     * @abstract
     * @template M
     * @param {?} moduleType
     * @param {?=} compilerOptions
     * @return {?}
     */
    PlatformRef.prototype.bootstrapModule = function (moduleType, compilerOptions) { };
    /**
     * Register a listener to be called when the platform is disposed.
     * @abstract
     * @param {?} callback
     * @return {?}
     */
    PlatformRef.prototype.onDestroy = function (callback) { };
    /**
     * Retrieve the platform {\@link Injector}, which is the parent injector for
     * every Angular application on the page and provides singleton providers.
     * @abstract
     * @return {?}
     */
    PlatformRef.prototype.injector = function () { };
    /**
     * Destroy the Angular platform and all Angular applications on the page.
     * @abstract
     * @return {?}
     */
    PlatformRef.prototype.destroy = function () { };
    /**
     * @abstract
     * @return {?}
     */
    PlatformRef.prototype.destroyed = function () { };
    return PlatformRef;
}());
/**
 * @param {?} errorHandler
 * @param {?} callback
 * @return {?}
 */
function _callAndReportToErrorHandler(errorHandler, callback) {
    try {
        var /** @type {?} */ result = callback();
        if (isPromise(result)) {
            return result.catch(function (e) {
                errorHandler.handleError(e);
                // rethrow as the exception handler might not do it
                throw e;
            });
        }
        return result;
    }
    catch (e) {
        errorHandler.handleError(e);
        // rethrow as the exception handler might not do it
        throw e;
    }
}
/**
 * workaround https://github.com/angular/tsickle/issues/350
 * @suppress {checkTypes}
 */
var PlatformRef_ = (function (_super) {
    __extends(PlatformRef_, _super);
    /**
     * @param {?} _injector
     */
    function PlatformRef_(_injector) {
        var _this = _super.call(this) || this;
        _this._injector = _injector;
        _this._modules = [];
        _this._destroyListeners = [];
        _this._destroyed = false;
        return _this;
    }
    /**
     * @param {?} callback
     * @return {?}
     */
    PlatformRef_.prototype.onDestroy = function (callback) { this._destroyListeners.push(callback); };
    Object.defineProperty(PlatformRef_.prototype, "injector", {
        /**
         * @return {?}
         */
        get: function () { return this._injector; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PlatformRef_.prototype, "destroyed", {
        /**
         * @return {?}
         */
        get: function () { return this._destroyed; },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    PlatformRef_.prototype.destroy = function () {
        if (this._destroyed) {
            throw new Error('The platform has already been destroyed!');
        }
        this._modules.slice().forEach(function (module) { return module.destroy(); });
        this._destroyListeners.forEach(function (listener) { return listener(); });
        this._destroyed = true;
    };
    /**
     * @template M
     * @param {?} moduleFactory
     * @return {?}
     */
    PlatformRef_.prototype.bootstrapModuleFactory = function (moduleFactory) {
        return this._bootstrapModuleFactoryWithZone(moduleFactory);
    };
    /**
     * @template M
     * @param {?} moduleFactory
     * @param {?=} ngZone
     * @return {?}
     */
    PlatformRef_.prototype._bootstrapModuleFactoryWithZone = function (moduleFactory, ngZone) {
        var _this = this;
        // Note: We need to create the NgZone _before_ we instantiate the module,
        // as instantiating the module creates some providers eagerly.
        // So we create a mini parent injector that just contains the new NgZone and
        // pass that as parent to the NgModuleFactory.
        if (!ngZone)
            ngZone = new NgZone({ enableLongStackTrace: isDevMode() });
        // Attention: Don't use ApplicationRef.run here,
        // as we want to be sure that all possible constructor calls are inside `ngZone.run`!
        return ngZone.run(function () {
            var /** @type {?} */ ngZoneInjector = ReflectiveInjector.resolveAndCreate([{ provide: NgZone, useValue: ngZone }], _this.injector);
            var /** @type {?} */ moduleRef = (moduleFactory.create(ngZoneInjector));
            var /** @type {?} */ exceptionHandler = moduleRef.injector.get(ErrorHandler, null);
            if (!exceptionHandler) {
                throw new Error('No ErrorHandler. Is platform module (BrowserModule) included?');
            }
            moduleRef.onDestroy(function () { return remove(_this._modules, moduleRef); }); /** @type {?} */
            ((ngZone)).onError.subscribe({ next: function (error) { exceptionHandler.handleError(error); } });
            return _callAndReportToErrorHandler(exceptionHandler, function () {
                var /** @type {?} */ initStatus = moduleRef.injector.get(ApplicationInitStatus);
                return initStatus.donePromise.then(function () {
                    _this._moduleDoBootstrap(moduleRef);
                    return moduleRef;
                });
            });
        });
    };
    /**
     * @template M
     * @param {?} moduleType
     * @param {?=} compilerOptions
     * @return {?}
     */
    PlatformRef_.prototype.bootstrapModule = function (moduleType, compilerOptions) {
        if (compilerOptions === void 0) { compilerOptions = []; }
        return this._bootstrapModuleWithZone(moduleType, compilerOptions);
    };
    /**
     * @template M
     * @param {?} moduleType
     * @param {?=} compilerOptions
     * @param {?=} ngZone
     * @return {?}
     */
    PlatformRef_.prototype._bootstrapModuleWithZone = function (moduleType, compilerOptions, ngZone) {
        var _this = this;
        if (compilerOptions === void 0) { compilerOptions = []; }
        var /** @type {?} */ compilerFactory = this.injector.get(CompilerFactory);
        var /** @type {?} */ compiler = compilerFactory.createCompiler(Array.isArray(compilerOptions) ? compilerOptions : [compilerOptions]);
        return compiler.compileModuleAsync(moduleType)
            .then(function (moduleFactory) { return _this._bootstrapModuleFactoryWithZone(moduleFactory, ngZone); });
    };
    /**
     * @param {?} moduleRef
     * @return {?}
     */
    PlatformRef_.prototype._moduleDoBootstrap = function (moduleRef) {
        var /** @type {?} */ appRef = moduleRef.injector.get(ApplicationRef);
        if (moduleRef.bootstrapFactories.length > 0) {
            moduleRef.bootstrapFactories.forEach(function (f) { return appRef.bootstrap(f); });
        }
        else if (moduleRef.instance.ngDoBootstrap) {
            moduleRef.instance.ngDoBootstrap(appRef);
        }
        else {
            throw new Error("The module " + stringify(moduleRef.instance.constructor) + " was bootstrapped, but it does not declare \"@NgModule.bootstrap\" components nor a \"ngDoBootstrap\" method. " +
                "Please define one of these.");
        }
        this._modules.push(moduleRef);
    };
    return PlatformRef_;
}(PlatformRef));
PlatformRef_.decorators = [
    { type: Injectable },
];
/**
 * @nocollapse
 */
PlatformRef_.ctorParameters = function () { return [
    { type: Injector, },
]; };
/**
 * A reference to an Angular application running on a page.
 *
 * For more about Angular applications, see the documentation for {\@link bootstrap}.
 *
 * \@stable
 * @abstract
 */
var ApplicationRef = (function () {
    function ApplicationRef() {
    }
    /**
     * Bootstrap a new component at the root level of the application.
     *
     * ### Bootstrap process
     *
     * When bootstrapping a new root component into an application, Angular mounts the
     * specified application component onto DOM elements identified by the [componentType]'s
     * selector and kicks off automatic change detection to finish initializing the component.
     *
     * ### Example
     * {\@example core/ts/platform/platform.ts region='longform'}
     * @abstract
     * @template C
     * @param {?} componentFactory
     * @return {?}
     */
    ApplicationRef.prototype.bootstrap = function (componentFactory) { };
    /**
     * Invoke this method to explicitly process change detection and its side-effects.
     *
     * In development mode, `tick()` also performs a second change detection cycle to ensure that no
     * further changes are detected. If additional changes are picked up during this second cycle,
     * bindings in the app have side-effects that cannot be resolved in a single change detection
     * pass.
     * In this case, Angular throws an error, since an Angular application can only have one change
     * detection pass during which all change detection must complete.
     * @abstract
     * @return {?}
     */
    ApplicationRef.prototype.tick = function () { };
    /**
     * Get a list of component types registered to this application.
     * This list is populated even before the component is created.
     * @abstract
     * @return {?}
     */
    ApplicationRef.prototype.componentTypes = function () { };
    /**
     * Get a list of components registered to this application.
     * @abstract
     * @return {?}
     */
    ApplicationRef.prototype.components = function () { };
    /**
     * Attaches a view so that it will be dirty checked.
     * The view will be automatically detached when it is destroyed.
     * This will throw if the view is already attached to a ViewContainer.
     * @abstract
     * @param {?} view
     * @return {?}
     */
    ApplicationRef.prototype.attachView = function (view) { };
    /**
     * Detaches a view from dirty checking again.
     * @abstract
     * @param {?} view
     * @return {?}
     */
    ApplicationRef.prototype.detachView = function (view) { };
    /**
     * Returns the number of attached views.
     * @abstract
     * @return {?}
     */
    ApplicationRef.prototype.viewCount = function () { };
    /**
     * Returns an Observable that indicates when the application is stable or unstable.
     * @abstract
     * @return {?}
     */
    ApplicationRef.prototype.isStable = function () { };
    return ApplicationRef;
}());
/**
 * workaround https://github.com/angular/tsickle/issues/350
 * @suppress {checkTypes}
 */
var ApplicationRef_ = (function (_super) {
    __extends(ApplicationRef_, _super);
    /**
     * @param {?} _zone
     * @param {?} _console
     * @param {?} _injector
     * @param {?} _exceptionHandler
     * @param {?} _componentFactoryResolver
     * @param {?} _initStatus
     */
    function ApplicationRef_(_zone, _console, _injector, _exceptionHandler, _componentFactoryResolver, _initStatus) {
        var _this = _super.call(this) || this;
        _this._zone = _zone;
        _this._console = _console;
        _this._injector = _injector;
        _this._exceptionHandler = _exceptionHandler;
        _this._componentFactoryResolver = _componentFactoryResolver;
        _this._initStatus = _initStatus;
        _this._bootstrapListeners = [];
        _this._rootComponents = [];
        _this._rootComponentTypes = [];
        _this._views = [];
        _this._runningTick = false;
        _this._enforceNoNewChanges = false;
        _this._stable = true;
        _this._enforceNoNewChanges = isDevMode();
        _this._zone.onMicrotaskEmpty.subscribe({ next: function () { _this._zone.run(function () { _this.tick(); }); } });
        var isCurrentlyStable = new __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"](function (observer) {
            _this._stable = _this._zone.isStable && !_this._zone.hasPendingMacrotasks &&
                !_this._zone.hasPendingMicrotasks;
            _this._zone.runOutsideAngular(function () {
                observer.next(_this._stable);
                observer.complete();
            });
        });
        var isStable = new __WEBPACK_IMPORTED_MODULE_0_rxjs_Observable__["Observable"](function (observer) {
            var stableSub = _this._zone.onStable.subscribe(function () {
                NgZone.assertNotInAngularZone();
                // Check whether there are no pending macro/micro tasks in the next tick
                // to allow for NgZone to update the state.
                scheduleMicroTask(function () {
                    if (!_this._stable && !_this._zone.hasPendingMacrotasks &&
                        !_this._zone.hasPendingMicrotasks) {
                        _this._stable = true;
                        observer.next(true);
                    }
                });
            });
            var unstableSub = _this._zone.onUnstable.subscribe(function () {
                NgZone.assertInAngularZone();
                if (_this._stable) {
                    _this._stable = false;
                    _this._zone.runOutsideAngular(function () { observer.next(false); });
                }
            });
            return function () {
                stableSub.unsubscribe();
                unstableSub.unsubscribe();
            };
        });
        _this._isStable = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_rxjs_observable_merge__["merge"])(isCurrentlyStable, __WEBPACK_IMPORTED_MODULE_2_rxjs_operator_share__["share"].call(isStable));
        return _this;
    }
    /**
     * @param {?} viewRef
     * @return {?}
     */
    ApplicationRef_.prototype.attachView = function (viewRef) {
        var /** @type {?} */ view = ((viewRef));
        this._views.push(view);
        view.attachToAppRef(this);
    };
    /**
     * @param {?} viewRef
     * @return {?}
     */
    ApplicationRef_.prototype.detachView = function (viewRef) {
        var /** @type {?} */ view = ((viewRef));
        remove(this._views, view);
        view.detachFromAppRef();
    };
    /**
     * @template C
     * @param {?} componentOrFactory
     * @return {?}
     */
    ApplicationRef_.prototype.bootstrap = function (componentOrFactory) {
        var _this = this;
        if (!this._initStatus.done) {
            throw new Error('Cannot bootstrap as there are still asynchronous initializers running. Bootstrap components in the `ngDoBootstrap` method of the root module.');
        }
        var /** @type {?} */ componentFactory;
        if (componentOrFactory instanceof ComponentFactory) {
            componentFactory = componentOrFactory;
        }
        else {
            componentFactory = ((this._componentFactoryResolver.resolveComponentFactory(componentOrFactory)));
        }
        this._rootComponentTypes.push(componentFactory.componentType);
        // Create a factory associated with the current module if it's not bound to some other
        var /** @type {?} */ ngModule = componentFactory instanceof ComponentFactoryBoundToModule ?
            null :
            this._injector.get(NgModuleRef);
        var /** @type {?} */ compRef = componentFactory.create(Injector.NULL, [], componentFactory.selector, ngModule);
        compRef.onDestroy(function () { _this._unloadComponent(compRef); });
        var /** @type {?} */ testability = compRef.injector.get(Testability, null);
        if (testability) {
            compRef.injector.get(TestabilityRegistry)
                .registerApplication(compRef.location.nativeElement, testability);
        }
        this._loadComponent(compRef);
        if (isDevMode()) {
            this._console.log("Angular is running in the development mode. Call enableProdMode() to enable the production mode.");
        }
        return compRef;
    };
    /**
     * @param {?} componentRef
     * @return {?}
     */
    ApplicationRef_.prototype._loadComponent = function (componentRef) {
        this.attachView(componentRef.hostView);
        this.tick();
        this._rootComponents.push(componentRef);
        // Get the listeners lazily to prevent DI cycles.
        var /** @type {?} */ listeners = this._injector.get(APP_BOOTSTRAP_LISTENER, []).concat(this._bootstrapListeners);
        listeners.forEach(function (listener) { return listener(componentRef); });
    };
    /**
     * @param {?} componentRef
     * @return {?}
     */
    ApplicationRef_.prototype._unloadComponent = function (componentRef) {
        this.detachView(componentRef.hostView);
        remove(this._rootComponents, componentRef);
    };
    /**
     * @return {?}
     */
    ApplicationRef_.prototype.tick = function () {
        if (this._runningTick) {
            throw new Error('ApplicationRef.tick is called recursively');
        }
        var /** @type {?} */ scope = ApplicationRef_._tickScope();
        try {
            this._runningTick = true;
            this._views.forEach(function (view) { return view.detectChanges(); });
            if (this._enforceNoNewChanges) {
                this._views.forEach(function (view) { return view.checkNoChanges(); });
            }
        }
        finally {
            this._runningTick = false;
            wtfLeave(scope);
        }
    };
    /**
     * @return {?}
     */
    ApplicationRef_.prototype.ngOnDestroy = function () {
        // TODO(alxhub): Dispose of the NgZone.
        this._views.slice().forEach(function (view) { return view.destroy(); });
    };
    Object.defineProperty(ApplicationRef_.prototype, "viewCount", {
        /**
         * @return {?}
         */
        get: function () { return this._views.length; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ApplicationRef_.prototype, "componentTypes", {
        /**
         * @return {?}
         */
        get: function () { return this._rootComponentTypes; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ApplicationRef_.prototype, "components", {
        /**
         * @return {?}
         */
        get: function () { return this._rootComponents; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ApplicationRef_.prototype, "isStable", {
        /**
         * @return {?}
         */
        get: function () { return this._isStable; },
        enumerable: true,
        configurable: true
    });
    return ApplicationRef_;
}(ApplicationRef));
/**
 * \@internal
 */
ApplicationRef_._tickScope = wtfCreateScope('ApplicationRef#tick()');
ApplicationRef_.decorators = [
    { type: Injectable },
];
/**
 * @nocollapse
 */
ApplicationRef_.ctorParameters = function () { return [
    { type: NgZone, },
    { type: Console, },
    { type: Injector, },
    { type: ErrorHandler, },
    { type: ComponentFactoryResolver, },
    { type: ApplicationInitStatus, },
]; };
/**
 * @template T
 * @param {?} list
 * @param {?} el
 * @return {?}
 */
function remove(list, el) {
    var /** @type {?} */ index = list.indexOf(el);
    if (index > -1) {
        list.splice(index, 1);
    }
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
// Public API for Zone
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @deprecated Use `RendererType2` (and `Renderer2`) instead.
 */
var RenderComponentType = (function () {
    /**
     * @param {?} id
     * @param {?} templateUrl
     * @param {?} slotCount
     * @param {?} encapsulation
     * @param {?} styles
     * @param {?} animations
     */
    function RenderComponentType(id, templateUrl, slotCount, encapsulation, styles, animations) {
        this.id = id;
        this.templateUrl = templateUrl;
        this.slotCount = slotCount;
        this.encapsulation = encapsulation;
        this.styles = styles;
        this.animations = animations;
    }
    return RenderComponentType;
}());
/**
 * @deprecated Debug info is handeled internally in the view engine now.
 * @abstract
 */
var RenderDebugInfo = (function () {
    function RenderDebugInfo() {
    }
    /**
     * @abstract
     * @return {?}
     */
    RenderDebugInfo.prototype.injector = function () { };
    /**
     * @abstract
     * @return {?}
     */
    RenderDebugInfo.prototype.component = function () { };
    /**
     * @abstract
     * @return {?}
     */
    RenderDebugInfo.prototype.providerTokens = function () { };
    /**
     * @abstract
     * @return {?}
     */
    RenderDebugInfo.prototype.references = function () { };
    /**
     * @abstract
     * @return {?}
     */
    RenderDebugInfo.prototype.context = function () { };
    /**
     * @abstract
     * @return {?}
     */
    RenderDebugInfo.prototype.source = function () { };
    return RenderDebugInfo;
}());
/**
 * @deprecated Use the `Renderer2` instead.
 * @abstract
 */
var Renderer = (function () {
    function Renderer() {
    }
    /**
     * @abstract
     * @param {?} selectorOrNode
     * @param {?=} debugInfo
     * @return {?}
     */
    Renderer.prototype.selectRootElement = function (selectorOrNode, debugInfo) { };
    /**
     * @abstract
     * @param {?} parentElement
     * @param {?} name
     * @param {?=} debugInfo
     * @return {?}
     */
    Renderer.prototype.createElement = function (parentElement, name, debugInfo) { };
    /**
     * @abstract
     * @param {?} hostElement
     * @return {?}
     */
    Renderer.prototype.createViewRoot = function (hostElement) { };
    /**
     * @abstract
     * @param {?} parentElement
     * @param {?=} debugInfo
     * @return {?}
     */
    Renderer.prototype.createTemplateAnchor = function (parentElement, debugInfo) { };
    /**
     * @abstract
     * @param {?} parentElement
     * @param {?} value
     * @param {?=} debugInfo
     * @return {?}
     */
    Renderer.prototype.createText = function (parentElement, value, debugInfo) { };
    /**
     * @abstract
     * @param {?} parentElement
     * @param {?} nodes
     * @return {?}
     */
    Renderer.prototype.projectNodes = function (parentElement, nodes) { };
    /**
     * @abstract
     * @param {?} node
     * @param {?} viewRootNodes
     * @return {?}
     */
    Renderer.prototype.attachViewAfter = function (node, viewRootNodes) { };
    /**
     * @abstract
     * @param {?} viewRootNodes
     * @return {?}
     */
    Renderer.prototype.detachView = function (viewRootNodes) { };
    /**
     * @abstract
     * @param {?} hostElement
     * @param {?} viewAllNodes
     * @return {?}
     */
    Renderer.prototype.destroyView = function (hostElement, viewAllNodes) { };
    /**
     * @abstract
     * @param {?} renderElement
     * @param {?} name
     * @param {?} callback
     * @return {?}
     */
    Renderer.prototype.listen = function (renderElement, name, callback) { };
    /**
     * @abstract
     * @param {?} target
     * @param {?} name
     * @param {?} callback
     * @return {?}
     */
    Renderer.prototype.listenGlobal = function (target, name, callback) { };
    /**
     * @abstract
     * @param {?} renderElement
     * @param {?} propertyName
     * @param {?} propertyValue
     * @return {?}
     */
    Renderer.prototype.setElementProperty = function (renderElement, propertyName, propertyValue) { };
    /**
     * @abstract
     * @param {?} renderElement
     * @param {?} attributeName
     * @param {?} attributeValue
     * @return {?}
     */
    Renderer.prototype.setElementAttribute = function (renderElement, attributeName, attributeValue) { };
    /**
     * Used only in debug mode to serialize property changes to dom nodes as attributes.
     * @abstract
     * @param {?} renderElement
     * @param {?} propertyName
     * @param {?} propertyValue
     * @return {?}
     */
    Renderer.prototype.setBindingDebugInfo = function (renderElement, propertyName, propertyValue) { };
    /**
     * @abstract
     * @param {?} renderElement
     * @param {?} className
     * @param {?} isAdd
     * @return {?}
     */
    Renderer.prototype.setElementClass = function (renderElement, className, isAdd) { };
    /**
     * @abstract
     * @param {?} renderElement
     * @param {?} styleName
     * @param {?} styleValue
     * @return {?}
     */
    Renderer.prototype.setElementStyle = function (renderElement, styleName, styleValue) { };
    /**
     * @abstract
     * @param {?} renderElement
     * @param {?} methodName
     * @param {?=} args
     * @return {?}
     */
    Renderer.prototype.invokeElementMethod = function (renderElement, methodName, args) { };
    /**
     * @abstract
     * @param {?} renderNode
     * @param {?} text
     * @return {?}
     */
    Renderer.prototype.setText = function (renderNode, text) { };
    /**
     * @abstract
     * @param {?} element
     * @param {?} startingStyles
     * @param {?} keyframes
     * @param {?} duration
     * @param {?} delay
     * @param {?} easing
     * @param {?=} previousPlayers
     * @return {?}
     */
    Renderer.prototype.animate = function (element, startingStyles, keyframes, duration, delay, easing, previousPlayers) { };
    return Renderer;
}());
var Renderer2Interceptor = new InjectionToken('Renderer2Interceptor');
/**
 * Injectable service that provides a low-level interface for modifying the UI.
 *
 * Use this service to bypass Angular's templating and make custom UI changes that can't be
 * expressed declaratively. For example if you need to set a property or an attribute whose name is
 * not statically known, use {\@link #setElementProperty} or {\@link #setElementAttribute}
 * respectively.
 *
 * If you are implementing a custom renderer, you must implement this interface.
 *
 * The default Renderer implementation is `DomRenderer`. Also available is `WebWorkerRenderer`.
 *
 * @deprecated Use `RendererFactory2` instead.
 * @abstract
 */
var RootRenderer = (function () {
    function RootRenderer() {
    }
    /**
     * @abstract
     * @param {?} componentType
     * @return {?}
     */
    RootRenderer.prototype.renderComponent = function (componentType) { };
    return RootRenderer;
}());
/**
 * \@experimental
 * @abstract
 */
var RendererFactory2 = (function () {
    function RendererFactory2() {
    }
    /**
     * @abstract
     * @param {?} hostElement
     * @param {?} type
     * @return {?}
     */
    RendererFactory2.prototype.createRenderer = function (hostElement, type) { };
    return RendererFactory2;
}());
var RendererStyleFlags2 = {};
RendererStyleFlags2.Important = 1;
RendererStyleFlags2.DashCase = 2;
RendererStyleFlags2[RendererStyleFlags2.Important] = "Important";
RendererStyleFlags2[RendererStyleFlags2.DashCase] = "DashCase";
/**
 * \@experimental
 * @abstract
 */
var Renderer2 = (function () {
    function Renderer2() {
    }
    /**
     * This field can be used to store arbitrary data on this renderer instance.
     * This is useful for renderers that delegate to other renderers.
     * @abstract
     * @return {?}
     */
    Renderer2.prototype.data = function () { };
    /**
     * @abstract
     * @return {?}
     */
    Renderer2.prototype.destroy = function () { };
    /**
     * @abstract
     * @param {?} name
     * @param {?=} namespace
     * @return {?}
     */
    Renderer2.prototype.createElement = function (name, namespace) { };
    /**
     * @abstract
     * @param {?} value
     * @return {?}
     */
    Renderer2.prototype.createComment = function (value) { };
    /**
     * @abstract
     * @param {?} value
     * @return {?}
     */
    Renderer2.prototype.createText = function (value) { };
    /**
     * @abstract
     * @param {?} parent
     * @param {?} newChild
     * @return {?}
     */
    Renderer2.prototype.appendChild = function (parent, newChild) { };
    /**
     * @abstract
     * @param {?} parent
     * @param {?} newChild
     * @param {?} refChild
     * @return {?}
     */
    Renderer2.prototype.insertBefore = function (parent, newChild, refChild) { };
    /**
     * @abstract
     * @param {?} parent
     * @param {?} oldChild
     * @return {?}
     */
    Renderer2.prototype.removeChild = function (parent, oldChild) { };
    /**
     * @abstract
     * @param {?} selectorOrNode
     * @return {?}
     */
    Renderer2.prototype.selectRootElement = function (selectorOrNode) { };
    /**
     * Attention: On WebWorkers, this will always return a value,
     * as we are asking for a result synchronously. I.e.
     * the caller can't rely on checking whether this is null or not.
     * @abstract
     * @param {?} node
     * @return {?}
     */
    Renderer2.prototype.parentNode = function (node) { };
    /**
     * Attention: On WebWorkers, this will always return a value,
     * as we are asking for a result synchronously. I.e.
     * the caller can't rely on checking whether this is null or not.
     * @abstract
     * @param {?} node
     * @return {?}
     */
    Renderer2.prototype.nextSibling = function (node) { };
    /**
     * @abstract
     * @param {?} el
     * @param {?} name
     * @param {?} value
     * @param {?=} namespace
     * @return {?}
     */
    Renderer2.prototype.setAttribute = function (el, name, value, namespace) { };
    /**
     * @abstract
     * @param {?} el
     * @param {?} name
     * @param {?=} namespace
     * @return {?}
     */
    Renderer2.prototype.removeAttribute = function (el, name, namespace) { };
    /**
     * @abstract
     * @param {?} el
     * @param {?} name
     * @return {?}
     */
    Renderer2.prototype.addClass = function (el, name) { };
    /**
     * @abstract
     * @param {?} el
     * @param {?} name
     * @return {?}
     */
    Renderer2.prototype.removeClass = function (el, name) { };
    /**
     * @abstract
     * @param {?} el
     * @param {?} style
     * @param {?} value
     * @param {?=} flags
     * @return {?}
     */
    Renderer2.prototype.setStyle = function (el, style, value, flags) { };
    /**
     * @abstract
     * @param {?} el
     * @param {?} style
     * @param {?=} flags
     * @return {?}
     */
    Renderer2.prototype.removeStyle = function (el, style, flags) { };
    /**
     * @abstract
     * @param {?} el
     * @param {?} name
     * @param {?} value
     * @return {?}
     */
    Renderer2.prototype.setProperty = function (el, name, value) { };
    /**
     * @abstract
     * @param {?} node
     * @param {?} value
     * @return {?}
     */
    Renderer2.prototype.setValue = function (node, value) { };
    /**
     * @abstract
     * @param {?} target
     * @param {?} eventName
     * @param {?} callback
     * @return {?}
     */
    Renderer2.prototype.listen = function (target, eventName, callback) { };
    return Renderer2;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
// Public API for render
var ElementRef = (function () {
    /**
     * @param {?} nativeElement
     */
    function ElementRef(nativeElement) {
        this.nativeElement = nativeElement;
    }
    return ElementRef;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Used to load ng module factories.
 * \@stable
 * @abstract
 */
var NgModuleFactoryLoader = (function () {
    function NgModuleFactoryLoader() {
    }
    /**
     * @abstract
     * @param {?} path
     * @return {?}
     */
    NgModuleFactoryLoader.prototype.load = function (path) { };
    return NgModuleFactoryLoader;
}());
var moduleFactories = new Map();
/**
 * Registers a loaded module. Should only be called from generated NgModuleFactory code.
 * \@experimental
 * @param {?} id
 * @param {?} factory
 * @return {?}
 */
function registerModuleFactory(id, factory) {
    var /** @type {?} */ existing = moduleFactories.get(id);
    if (existing) {
        throw new Error("Duplicate module registered for " + id + " - " + existing.moduleType.name + " vs " + factory.moduleType.name);
    }
    moduleFactories.set(id, factory);
}
/**
 * @return {?}
 */
/**
 * Returns the NgModuleFactory with the given id, if it exists and has been loaded.
 * Factories for modules that do not specify an `id` cannot be retrieved. Throws if the module
 * cannot be found.
 * \@experimental
 * @param {?} id
 * @return {?}
 */
function getModuleFactory(id) {
    var /** @type {?} */ factory = moduleFactories.get(id);
    if (!factory)
        throw new Error("No module with ID " + id + " loaded");
    return factory;
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * An unmodifiable list of items that Angular keeps up to date when the state
 * of the application changes.
 *
 * The type of object that {\@link Query} and {\@link ViewQueryMetadata} provide.
 *
 * Implements an iterable interface, therefore it can be used in both ES6
 * javascript `for (var i of items)` loops as well as in Angular templates with
 * `*ngFor="let i of myList"`.
 *
 * Changes can be observed by subscribing to the changes `Observable`.
 *
 * NOTE: In the future this class will implement an `Observable` interface.
 *
 * ### Example ([live demo](http://plnkr.co/edit/RX8sJnQYl9FWuSCWme5z?p=preview))
 * ```typescript
 * \@Component({...})
 * class Container {
 *   \@ViewChildren(Item) items:QueryList<Item>;
 * }
 * ```
 * \@stable
 */
var QueryList = (function () {
    function QueryList() {
        this._dirty = true;
        this._results = [];
        this._emitter = new EventEmitter();
    }
    Object.defineProperty(QueryList.prototype, "changes", {
        /**
         * @return {?}
         */
        get: function () { return this._emitter; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(QueryList.prototype, "length", {
        /**
         * @return {?}
         */
        get: function () { return this._results.length; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(QueryList.prototype, "first", {
        /**
         * @return {?}
         */
        get: function () { return this._results[0]; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(QueryList.prototype, "last", {
        /**
         * @return {?}
         */
        get: function () { return this._results[this.length - 1]; },
        enumerable: true,
        configurable: true
    });
    /**
     * See
     * [Array.map](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/map)
     * @template U
     * @param {?} fn
     * @return {?}
     */
    QueryList.prototype.map = function (fn) { return this._results.map(fn); };
    /**
     * See
     * [Array.filter](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/filter)
     * @param {?} fn
     * @return {?}
     */
    QueryList.prototype.filter = function (fn) {
        return this._results.filter(fn);
    };
    /**
     * See
     * [Array.find](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/find)
     * @param {?} fn
     * @return {?}
     */
    QueryList.prototype.find = function (fn) {
        return this._results.find(fn);
    };
    /**
     * See
     * [Array.reduce](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce)
     * @template U
     * @param {?} fn
     * @param {?} init
     * @return {?}
     */
    QueryList.prototype.reduce = function (fn, init) {
        return this._results.reduce(fn, init);
    };
    /**
     * See
     * [Array.forEach](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/forEach)
     * @param {?} fn
     * @return {?}
     */
    QueryList.prototype.forEach = function (fn) { this._results.forEach(fn); };
    /**
     * See
     * [Array.some](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/some)
     * @param {?} fn
     * @return {?}
     */
    QueryList.prototype.some = function (fn) {
        return this._results.some(fn);
    };
    /**
     * @return {?}
     */
    QueryList.prototype.toArray = function () { return this._results.slice(); };
    /**
     * @return {?}
     */
    QueryList.prototype[getSymbolIterator()] = function () { return ((this._results))[getSymbolIterator()](); };
    /**
     * @return {?}
     */
    QueryList.prototype.toString = function () { return this._results.toString(); };
    /**
     * @param {?} res
     * @return {?}
     */
    QueryList.prototype.reset = function (res) {
        this._results = flatten(res);
        this._dirty = false;
    };
    /**
     * @return {?}
     */
    QueryList.prototype.notifyOnChanges = function () { this._emitter.emit(this); };
    /**
     * internal
     * @return {?}
     */
    QueryList.prototype.setDirty = function () { this._dirty = true; };
    Object.defineProperty(QueryList.prototype, "dirty", {
        /**
         * internal
         * @return {?}
         */
        get: function () { return this._dirty; },
        enumerable: true,
        configurable: true
    });
    return QueryList;
}());
/**
 * @template T
 * @param {?} list
 * @return {?}
 */
function flatten(list) {
    return list.reduce(function (flat, item) {
        var /** @type {?} */ flatItem = Array.isArray(item) ? flatten(item) : item;
        return ((flat)).concat(flatItem);
    }, []);
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var _SEPARATOR = '#';
var FACTORY_CLASS_SUFFIX = 'NgFactory';
/**
 * Configuration for SystemJsNgModuleLoader.
 * token.
 *
 * \@experimental
 * @abstract
 */
var SystemJsNgModuleLoaderConfig = (function () {
    function SystemJsNgModuleLoaderConfig() {
    }
    return SystemJsNgModuleLoaderConfig;
}());
var DEFAULT_CONFIG = {
    factoryPathPrefix: '',
    factoryPathSuffix: '.ngfactory',
};
/**
 * NgModuleFactoryLoader that uses SystemJS to load NgModuleFactory
 * \@experimental
 */
var SystemJsNgModuleLoader = (function () {
    /**
     * @param {?} _compiler
     * @param {?=} config
     */
    function SystemJsNgModuleLoader(_compiler, config) {
        this._compiler = _compiler;
        this._config = config || DEFAULT_CONFIG;
    }
    /**
     * @param {?} path
     * @return {?}
     */
    SystemJsNgModuleLoader.prototype.load = function (path) {
        var /** @type {?} */ offlineMode = this._compiler instanceof Compiler;
        return offlineMode ? this.loadFactory(path) : this.loadAndCompile(path);
    };
    /**
     * @param {?} path
     * @return {?}
     */
    SystemJsNgModuleLoader.prototype.loadAndCompile = function (path) {
        var _this = this;
        var _a = path.split(_SEPARATOR), module = _a[0], exportName = _a[1];
        if (exportName === undefined) {
            exportName = 'default';
        }
        return __webpack_require__("MOVZ")(module)
            .then(function (module) { return module[exportName]; })
            .then(function (type) { return checkNotEmpty(type, module, exportName); })
            .then(function (type) { return _this._compiler.compileModuleAsync(type); });
    };
    /**
     * @param {?} path
     * @return {?}
     */
    SystemJsNgModuleLoader.prototype.loadFactory = function (path) {
        var _a = path.split(_SEPARATOR), module = _a[0], exportName = _a[1];
        var /** @type {?} */ factoryClassSuffix = FACTORY_CLASS_SUFFIX;
        if (exportName === undefined) {
            exportName = 'default';
            factoryClassSuffix = '';
        }
        return __webpack_require__("MOVZ")(this._config.factoryPathPrefix + module + this._config.factoryPathSuffix)
            .then(function (module) { return module[exportName + factoryClassSuffix]; })
            .then(function (factory) { return checkNotEmpty(factory, module, exportName); });
    };
    return SystemJsNgModuleLoader;
}());
SystemJsNgModuleLoader.decorators = [
    { type: Injectable },
];
/**
 * @nocollapse
 */
SystemJsNgModuleLoader.ctorParameters = function () { return [
    { type: Compiler, },
    { type: SystemJsNgModuleLoaderConfig, decorators: [{ type: Optional },] },
]; };
/**
 * @param {?} value
 * @param {?} modulePath
 * @param {?} exportName
 * @return {?}
 */
function checkNotEmpty(value, modulePath, exportName) {
    if (!value) {
        throw new Error("Cannot find '" + exportName + "' in '" + modulePath + "'");
    }
    return value;
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Represents an Embedded Template that can be used to instantiate Embedded Views.
 *
 * You can access a `TemplateRef`, in two ways. Via a directive placed on a `<ng-template>` element
 * (or directive prefixed with `*`) and have the `TemplateRef` for this Embedded View injected into
 * the constructor of the directive using the `TemplateRef` Token. Alternatively you can query for
 * the `TemplateRef` from a Component or a Directive via {\@link Query}.
 *
 * To instantiate Embedded Views based on a Template, use
 * {\@link ViewContainerRef#createEmbeddedView}, which will create the View and attach it to the
 * View Container.
 * \@stable
 * @abstract
 */
var TemplateRef = (function () {
    function TemplateRef() {
    }
    /**
     * @abstract
     * @return {?}
     */
    TemplateRef.prototype.elementRef = function () { };
    /**
     * @abstract
     * @param {?} context
     * @return {?}
     */
    TemplateRef.prototype.createEmbeddedView = function (context) { };
    return TemplateRef;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Represents a container where one or more Views can be attached.
 *
 * The container can contain two kinds of Views. Host Views, created by instantiating a
 * {\@link Component} via {\@link #createComponent}, and Embedded Views, created by instantiating an
 * {\@link TemplateRef Embedded Template} via {\@link #createEmbeddedView}.
 *
 * The location of the View Container within the containing View is specified by the Anchor
 * `element`. Each View Container can have only one Anchor Element and each Anchor Element can only
 * have a single View Container.
 *
 * Root elements of Views attached to this container become siblings of the Anchor Element in
 * the Rendered View.
 *
 * To access a `ViewContainerRef` of an Element, you can either place a {\@link Directive} injected
 * with `ViewContainerRef` on the Element, or you obtain it via a {\@link ViewChild} query.
 * \@stable
 * @abstract
 */
var ViewContainerRef = (function () {
    function ViewContainerRef() {
    }
    /**
     * Anchor element that specifies the location of this container in the containing View.
     * <!-- TODO: rename to anchorElement -->
     * @abstract
     * @return {?}
     */
    ViewContainerRef.prototype.element = function () { };
    /**
     * @abstract
     * @return {?}
     */
    ViewContainerRef.prototype.injector = function () { };
    /**
     * @abstract
     * @return {?}
     */
    ViewContainerRef.prototype.parentInjector = function () { };
    /**
     * Destroys all Views in this container.
     * @abstract
     * @return {?}
     */
    ViewContainerRef.prototype.clear = function () { };
    /**
     * Returns the {\@link ViewRef} for the View located in this container at the specified index.
     * @abstract
     * @param {?} index
     * @return {?}
     */
    ViewContainerRef.prototype.get = function (index) { };
    /**
     * Returns the number of Views currently attached to this container.
     * @abstract
     * @return {?}
     */
    ViewContainerRef.prototype.length = function () { };
    /**
     * Instantiates an Embedded View based on the {\@link TemplateRef `templateRef`} and inserts it
     * into this container at the specified `index`.
     *
     * If `index` is not specified, the new View will be inserted as the last View in the container.
     *
     * Returns the {\@link ViewRef} for the newly created View.
     * @abstract
     * @template C
     * @param {?} templateRef
     * @param {?=} context
     * @param {?=} index
     * @return {?}
     */
    ViewContainerRef.prototype.createEmbeddedView = function (templateRef, context, index) { };
    /**
     * Instantiates a single {\@link Component} and inserts its Host View into this container at the
     * specified `index`.
     *
     * The component is instantiated using its {\@link ComponentFactory} which can be
     * obtained via {\@link ComponentFactoryResolver#resolveComponentFactory}.
     *
     * If `index` is not specified, the new View will be inserted as the last View in the container.
     *
     * You can optionally specify the {\@link Injector} that will be used as parent for the Component.
     *
     * Returns the {\@link ComponentRef} of the Host View created for the newly instantiated Component.
     * @abstract
     * @template C
     * @param {?} componentFactory
     * @param {?=} index
     * @param {?=} injector
     * @param {?=} projectableNodes
     * @param {?=} ngModule
     * @return {?}
     */
    ViewContainerRef.prototype.createComponent = function (componentFactory, index, injector, projectableNodes, ngModule) { };
    /**
     * Inserts a View identified by a {\@link ViewRef} into the container at the specified `index`.
     *
     * If `index` is not specified, the new View will be inserted as the last View in the container.
     *
     * Returns the inserted {\@link ViewRef}.
     * @abstract
     * @param {?} viewRef
     * @param {?=} index
     * @return {?}
     */
    ViewContainerRef.prototype.insert = function (viewRef, index) { };
    /**
     * Moves a View identified by a {\@link ViewRef} into the container at the specified `index`.
     *
     * Returns the inserted {\@link ViewRef}.
     * @abstract
     * @param {?} viewRef
     * @param {?} currentIndex
     * @return {?}
     */
    ViewContainerRef.prototype.move = function (viewRef, currentIndex) { };
    /**
     * Returns the index of the View, specified via {\@link ViewRef}, within the current container or
     * `-1` if this container doesn't contain the View.
     * @abstract
     * @param {?} viewRef
     * @return {?}
     */
    ViewContainerRef.prototype.indexOf = function (viewRef) { };
    /**
     * Destroys a View attached to this container at the specified `index`.
     *
     * If `index` is not specified, the last View in the container will be removed.
     * @abstract
     * @param {?=} index
     * @return {?}
     */
    ViewContainerRef.prototype.remove = function (index) { };
    /**
     * Use along with {\@link #insert} to move a View within the current container.
     *
     * If the `index` param is omitted, the last {\@link ViewRef} is detached.
     * @abstract
     * @param {?=} index
     * @return {?}
     */
    ViewContainerRef.prototype.detach = function (index) { };
    return ViewContainerRef;
}());
/**
 * \@stable
 * @abstract
 */
var ChangeDetectorRef = (function () {
    function ChangeDetectorRef() {
    }
    /**
     * Marks all {\@link ChangeDetectionStrategy#OnPush} ancestors as to be checked.
     *
     * <!-- TODO: Add a link to a chapter on OnPush components -->
     *
     * ### Example ([live demo](http://plnkr.co/edit/GC512b?p=preview))
     *
     * ```typescript
     * \@Component({
     *   selector: 'cmp',
     *   changeDetection: ChangeDetectionStrategy.OnPush,
     *   template: `Number of ticks: {{numberOfTicks}}`
     * })
     * class Cmp {
     *   numberOfTicks = 0;
     *
     *   constructor(ref: ChangeDetectorRef) {
     *     setInterval(() => {
     *       this.numberOfTicks ++
     *       // the following is required, otherwise the view will not be updated
     *       this.ref.markForCheck();
     *     }, 1000);
     *   }
     * }
     *
     * \@Component({
     *   selector: 'app',
     *   changeDetection: ChangeDetectionStrategy.OnPush,
     *   template: `
     *     <cmp><cmp>
     *   `,
     * })
     * class App {
     * }
     * ```
     * @abstract
     * @return {?}
     */
    ChangeDetectorRef.prototype.markForCheck = function () { };
    /**
     * Detaches the change detector from the change detector tree.
     *
     * The detached change detector will not be checked until it is reattached.
     *
     * This can also be used in combination with {\@link ChangeDetectorRef#detectChanges} to implement
     * local change
     * detection checks.
     *
     * <!-- TODO: Add a link to a chapter on detach/reattach/local digest -->
     * <!-- TODO: Add a live demo once ref.detectChanges is merged into master -->
     *
     * ### Example
     *
     * The following example defines a component with a large list of readonly data.
     * Imagine the data changes constantly, many times per second. For performance reasons,
     * we want to check and update the list every five seconds. We can do that by detaching
     * the component's change detector and doing a local check every five seconds.
     *
     * ```typescript
     * class DataProvider {
     *   // in a real application the returned data will be different every time
     *   get data() {
     *     return [1,2,3,4,5];
     *   }
     * }
     *
     * \@Component({
     *   selector: 'giant-list',
     *   template: `
     *     <li *ngFor="let d of dataProvider.data">Data {{d}}</lig>
     *   `,
     * })
     * class GiantList {
     *   constructor(private ref: ChangeDetectorRef, private dataProvider:DataProvider) {
     *     ref.detach();
     *     setInterval(() => {
     *       this.ref.detectChanges();
     *     }, 5000);
     *   }
     * }
     *
     * \@Component({
     *   selector: 'app',
     *   providers: [DataProvider],
     *   template: `
     *     <giant-list><giant-list>
     *   `,
     * })
     * class App {
     * }
     * ```
     * @abstract
     * @return {?}
     */
    ChangeDetectorRef.prototype.detach = function () { };
    /**
     * Checks the change detector and its children.
     *
     * This can also be used in combination with {\@link ChangeDetectorRef#detach} to implement local
     * change detection
     * checks.
     *
     * <!-- TODO: Add a link to a chapter on detach/reattach/local digest -->
     * <!-- TODO: Add a live demo once ref.detectChanges is merged into master -->
     *
     * ### Example
     *
     * The following example defines a component with a large list of readonly data.
     * Imagine, the data changes constantly, many times per second. For performance reasons,
     * we want to check and update the list every five seconds.
     *
     * We can do that by detaching the component's change detector and doing a local change detection
     * check
     * every five seconds.
     *
     * See {\@link ChangeDetectorRef#detach} for more information.
     * @abstract
     * @return {?}
     */
    ChangeDetectorRef.prototype.detectChanges = function () { };
    /**
     * Checks the change detector and its children, and throws if any changes are detected.
     *
     * This is used in development mode to verify that running change detection doesn't introduce
     * other changes.
     * @abstract
     * @return {?}
     */
    ChangeDetectorRef.prototype.checkNoChanges = function () { };
    /**
     * Reattach the change detector to the change detector tree.
     *
     * This also marks OnPush ancestors as to be checked. This reattached change detector will be
     * checked during the next change detection run.
     *
     * <!-- TODO: Add a link to a chapter on detach/reattach/local digest -->
     *
     * ### Example ([live demo](http://plnkr.co/edit/aUhZha?p=preview))
     *
     * The following example creates a component displaying `live` data. The component will detach
     * its change detector from the main change detector tree when the component's live property
     * is set to false.
     *
     * ```typescript
     * class DataProvider {
     *   data = 1;
     *
     *   constructor() {
     *     setInterval(() => {
     *       this.data = this.data * 2;
     *     }, 500);
     *   }
     * }
     *
     * \@Component({
     *   selector: 'live-data',
     *   inputs: ['live'],
     *   template: 'Data: {{dataProvider.data}}'
     * })
     * class LiveData {
     *   constructor(private ref: ChangeDetectorRef, private dataProvider:DataProvider) {}
     *
     *   set live(value) {
     *     if (value)
     *       this.ref.reattach();
     *     else
     *       this.ref.detach();
     *   }
     * }
     *
     * \@Component({
     *   selector: 'app',
     *   providers: [DataProvider],
     *   template: `
     *     Live Update: <input type="checkbox" [(ngModel)]="live">
     *     <live-data [live]="live"><live-data>
     *   `,
     * })
     * class App {
     *   live = true;
     * }
     * ```
     * @abstract
     * @return {?}
     */
    ChangeDetectorRef.prototype.reattach = function () { };
    return ChangeDetectorRef;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * \@stable
 * @abstract
 */
var ViewRef = (function (_super) {
    __extends(ViewRef, _super);
    function ViewRef() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Destroys the view and all of the data structures associated with it.
     * @abstract
     * @return {?}
     */
    ViewRef.prototype.destroy = function () { };
    /**
     * @abstract
     * @return {?}
     */
    ViewRef.prototype.destroyed = function () { };
    /**
     * @abstract
     * @param {?} callback
     * @return {?}
     */
    ViewRef.prototype.onDestroy = function (callback) { };
    return ViewRef;
}(ChangeDetectorRef));
/**
 * Represents an Angular View.
 *
 * <!-- TODO: move the next two paragraphs to the dev guide -->
 * A View is a fundamental building block of the application UI. It is the smallest grouping of
 * Elements which are created and destroyed together.
 *
 * Properties of elements in a View can change, but the structure (number and order) of elements in
 * a View cannot. Changing the structure of Elements can only be done by inserting, moving or
 * removing nested Views via a {\@link ViewContainerRef}. Each View can contain many View Containers.
 * <!-- /TODO -->
 *
 * ### Example
 *
 * Given this template...
 *
 * ```
 * Count: {{items.length}}
 * <ul>
 *   <li *ngFor="let  item of items">{{item}}</li>
 * </ul>
 * ```
 *
 * We have two {\@link TemplateRef}s:
 *
 * Outer {\@link TemplateRef}:
 * ```
 * Count: {{items.length}}
 * <ul>
 *   <ng-template ngFor let-item [ngForOf]="items"></ng-template>
 * </ul>
 * ```
 *
 * Inner {\@link TemplateRef}:
 * ```
 *   <li>{{item}}</li>
 * ```
 *
 * Notice that the original template is broken down into two separate {\@link TemplateRef}s.
 *
 * The outer/inner {\@link TemplateRef}s are then assembled into views like so:
 *
 * ```
 * <!-- ViewRef: outer-0 -->
 * Count: 2
 * <ul>
 *   <ng-template view-container-ref></ng-template>
 *   <!-- ViewRef: inner-1 --><li>first</li><!-- /ViewRef: inner-1 -->
 *   <!-- ViewRef: inner-2 --><li>second</li><!-- /ViewRef: inner-2 -->
 * </ul>
 * <!-- /ViewRef: outer-0 -->
 * ```
 * \@experimental
 * @abstract
 */
var EmbeddedViewRef = (function (_super) {
    __extends(EmbeddedViewRef, _super);
    function EmbeddedViewRef() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @abstract
     * @return {?}
     */
    EmbeddedViewRef.prototype.context = function () { };
    /**
     * @abstract
     * @return {?}
     */
    EmbeddedViewRef.prototype.rootNodes = function () { };
    return EmbeddedViewRef;
}(ViewRef));
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
// Public API for compiler
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var EventListener = (function () {
    /**
     * @param {?} name
     * @param {?} callback
     */
    function EventListener(name, callback) {
        this.name = name;
        this.callback = callback;
    }
    ;
    return EventListener;
}());
/**
 * \@experimental All debugging apis are currently experimental.
 */
var DebugNode = (function () {
    /**
     * @param {?} nativeNode
     * @param {?} parent
     * @param {?} _debugContext
     */
    function DebugNode(nativeNode, parent, _debugContext) {
        this._debugContext = _debugContext;
        this.nativeNode = nativeNode;
        if (parent && parent instanceof DebugElement) {
            parent.addChild(this);
        }
        else {
            this.parent = null;
        }
        this.listeners = [];
    }
    Object.defineProperty(DebugNode.prototype, "injector", {
        /**
         * @return {?}
         */
        get: function () { return this._debugContext.injector; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DebugNode.prototype, "componentInstance", {
        /**
         * @return {?}
         */
        get: function () { return this._debugContext.component; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DebugNode.prototype, "context", {
        /**
         * @return {?}
         */
        get: function () { return this._debugContext.context; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DebugNode.prototype, "references", {
        /**
         * @return {?}
         */
        get: function () { return this._debugContext.references; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DebugNode.prototype, "providerTokens", {
        /**
         * @return {?}
         */
        get: function () { return this._debugContext.providerTokens; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DebugNode.prototype, "source", {
        /**
         * @deprecated since v4
         * @return {?}
         */
        get: function () { return 'Deprecated since v4'; },
        enumerable: true,
        configurable: true
    });
    return DebugNode;
}());
/**
 * \@experimental All debugging apis are currently experimental.
 */
var DebugElement = (function (_super) {
    __extends(DebugElement, _super);
    /**
     * @param {?} nativeNode
     * @param {?} parent
     * @param {?} _debugContext
     */
    function DebugElement(nativeNode, parent, _debugContext) {
        var _this = _super.call(this, nativeNode, parent, _debugContext) || this;
        _this.properties = {};
        _this.attributes = {};
        _this.classes = {};
        _this.styles = {};
        _this.childNodes = [];
        _this.nativeElement = nativeNode;
        return _this;
    }
    /**
     * @param {?} child
     * @return {?}
     */
    DebugElement.prototype.addChild = function (child) {
        if (child) {
            this.childNodes.push(child);
            child.parent = this;
        }
    };
    /**
     * @param {?} child
     * @return {?}
     */
    DebugElement.prototype.removeChild = function (child) {
        var /** @type {?} */ childIndex = this.childNodes.indexOf(child);
        if (childIndex !== -1) {
            child.parent = null;
            this.childNodes.splice(childIndex, 1);
        }
    };
    /**
     * @param {?} child
     * @param {?} newChildren
     * @return {?}
     */
    DebugElement.prototype.insertChildrenAfter = function (child, newChildren) {
        var _this = this;
        var /** @type {?} */ siblingIndex = this.childNodes.indexOf(child);
        if (siblingIndex !== -1) {
            (_a = this.childNodes).splice.apply(_a, [siblingIndex + 1, 0].concat(newChildren));
            newChildren.forEach(function (c) {
                if (c.parent) {
                    c.parent.removeChild(c);
                }
                c.parent = _this;
            });
        }
        var _a;
    };
    /**
     * @param {?} refChild
     * @param {?} newChild
     * @return {?}
     */
    DebugElement.prototype.insertBefore = function (refChild, newChild) {
        var /** @type {?} */ refIndex = this.childNodes.indexOf(refChild);
        if (refIndex === -1) {
            this.addChild(newChild);
        }
        else {
            if (newChild.parent) {
                newChild.parent.removeChild(newChild);
            }
            newChild.parent = this;
            this.childNodes.splice(refIndex, 0, newChild);
        }
    };
    /**
     * @param {?} predicate
     * @return {?}
     */
    DebugElement.prototype.query = function (predicate) {
        var /** @type {?} */ results = this.queryAll(predicate);
        return results[0] || null;
    };
    /**
     * @param {?} predicate
     * @return {?}
     */
    DebugElement.prototype.queryAll = function (predicate) {
        var /** @type {?} */ matches = [];
        _queryElementChildren(this, predicate, matches);
        return matches;
    };
    /**
     * @param {?} predicate
     * @return {?}
     */
    DebugElement.prototype.queryAllNodes = function (predicate) {
        var /** @type {?} */ matches = [];
        _queryNodeChildren(this, predicate, matches);
        return matches;
    };
    Object.defineProperty(DebugElement.prototype, "children", {
        /**
         * @return {?}
         */
        get: function () {
            return (this.childNodes.filter(function (node) { return node instanceof DebugElement; }));
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} eventName
     * @param {?} eventObj
     * @return {?}
     */
    DebugElement.prototype.triggerEventHandler = function (eventName, eventObj) {
        this.listeners.forEach(function (listener) {
            if (listener.name == eventName) {
                listener.callback(eventObj);
            }
        });
    };
    return DebugElement;
}(DebugNode));
/**
 * \@experimental
 * @param {?} debugEls
 * @return {?}
 */
function asNativeElements(debugEls) {
    return debugEls.map(function (el) { return el.nativeElement; });
}
/**
 * @param {?} element
 * @param {?} predicate
 * @param {?} matches
 * @return {?}
 */
function _queryElementChildren(element, predicate, matches) {
    element.childNodes.forEach(function (node) {
        if (node instanceof DebugElement) {
            if (predicate(node)) {
                matches.push(node);
            }
            _queryElementChildren(node, predicate, matches);
        }
    });
}
/**
 * @param {?} parentNode
 * @param {?} predicate
 * @param {?} matches
 * @return {?}
 */
function _queryNodeChildren(parentNode, predicate, matches) {
    if (parentNode instanceof DebugElement) {
        parentNode.childNodes.forEach(function (node) {
            if (predicate(node)) {
                matches.push(node);
            }
            if (node instanceof DebugElement) {
                _queryNodeChildren(node, predicate, matches);
            }
        });
    }
}
// Need to keep the nodes in a global Map so that multiple angular apps are supported.
var _nativeNodeToDebugNode = new Map();
/**
 * \@experimental
 * @param {?} nativeNode
 * @return {?}
 */
function getDebugNode(nativeNode) {
    return _nativeNodeToDebugNode.get(nativeNode) || null;
}
/**
 * @return {?}
 */
/**
 * @param {?} node
 * @return {?}
 */
function indexDebugNode(node) {
    _nativeNodeToDebugNode.set(node.nativeNode, node);
}
/**
 * @param {?} node
 * @return {?}
 */
function removeDebugNodeFromIndex(node) {
    _nativeNodeToDebugNode.delete(node.nativeNode);
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @param {?} a
 * @param {?} b
 * @return {?}
 */
function devModeEqual(a, b) {
    var /** @type {?} */ isListLikeIterableA = isListLikeIterable(a);
    var /** @type {?} */ isListLikeIterableB = isListLikeIterable(b);
    if (isListLikeIterableA && isListLikeIterableB) {
        return areIterablesEqual(a, b, devModeEqual);
    }
    else {
        var /** @type {?} */ isAObject = a && (typeof a === 'object' || typeof a === 'function');
        var /** @type {?} */ isBObject = b && (typeof b === 'object' || typeof b === 'function');
        if (!isListLikeIterableA && isAObject && !isListLikeIterableB && isBObject) {
            return true;
        }
        else {
            return looseIdentical(a, b);
        }
    }
}
/**
 * Indicates that the result of a {\@link Pipe} transformation has changed even though the
 * reference
 * has not changed.
 *
 * The wrapped value will be unwrapped by change detection, and the unwrapped value will be stored.
 *
 * Example:
 *
 * ```
 * if (this._latestValue === this._latestReturnedValue) {
 *    return this._latestReturnedValue;
 *  } else {
 *    this._latestReturnedValue = this._latestValue;
 *    return WrappedValue.wrap(this._latestValue); // this will force update
 *  }
 * ```
 * \@stable
 */
var WrappedValue = (function () {
    /**
     * @param {?} wrapped
     */
    function WrappedValue(wrapped) {
        this.wrapped = wrapped;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    WrappedValue.wrap = function (value) { return new WrappedValue(value); };
    return WrappedValue;
}());
/**
 * Helper class for unwrapping WrappedValue s
 */
var ValueUnwrapper = (function () {
    function ValueUnwrapper() {
        this.hasWrappedValue = false;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    ValueUnwrapper.prototype.unwrap = function (value) {
        if (value instanceof WrappedValue) {
            this.hasWrappedValue = true;
            return value.wrapped;
        }
        return value;
    };
    /**
     * @return {?}
     */
    ValueUnwrapper.prototype.reset = function () { this.hasWrappedValue = false; };
    return ValueUnwrapper;
}());
/**
 * Represents a basic change from a previous to a new value.
 * \@stable
 */
var SimpleChange = (function () {
    /**
     * @param {?} previousValue
     * @param {?} currentValue
     * @param {?} firstChange
     */
    function SimpleChange(previousValue, currentValue, firstChange) {
        this.previousValue = previousValue;
        this.currentValue = currentValue;
        this.firstChange = firstChange;
    }
    /**
     * Check whether the new value is the first value assigned.
     * @return {?}
     */
    SimpleChange.prototype.isFirstChange = function () { return this.firstChange; };
    return SimpleChange;
}());
/**
 * @param {?} obj
 * @return {?}
 */
function isListLikeIterable(obj) {
    if (!isJsObject(obj))
        return false;
    return Array.isArray(obj) ||
        (!(obj instanceof Map) &&
            getSymbolIterator() in obj); // JS Iterable have a Symbol.iterator prop
}
/**
 * @param {?} a
 * @param {?} b
 * @param {?} comparator
 * @return {?}
 */
function areIterablesEqual(a, b, comparator) {
    var /** @type {?} */ iterator1 = a[getSymbolIterator()]();
    var /** @type {?} */ iterator2 = b[getSymbolIterator()]();
    while (true) {
        var /** @type {?} */ item1 = iterator1.next();
        var /** @type {?} */ item2 = iterator2.next();
        if (item1.done && item2.done)
            return true;
        if (item1.done || item2.done)
            return false;
        if (!comparator(item1.value, item2.value))
            return false;
    }
}
/**
 * @param {?} obj
 * @param {?} fn
 * @return {?}
 */
function iterateListLike(obj, fn) {
    if (Array.isArray(obj)) {
        for (var /** @type {?} */ i = 0; i < obj.length; i++) {
            fn(obj[i]);
        }
    }
    else {
        var /** @type {?} */ iterator = obj[getSymbolIterator()]();
        var /** @type {?} */ item = void 0;
        while (!((item = iterator.next()).done)) {
            fn(item.value);
        }
    }
}
/**
 * @param {?} o
 * @return {?}
 */
function isJsObject(o) {
    return o !== null && (typeof o === 'function' || typeof o === 'object');
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var DefaultIterableDifferFactory = (function () {
    function DefaultIterableDifferFactory() {
    }
    /**
     * @param {?} obj
     * @return {?}
     */
    DefaultIterableDifferFactory.prototype.supports = function (obj) { return isListLikeIterable(obj); };
    /**
     * @deprecated v4.0.0 - ChangeDetectorRef is not used and is no longer a parameter
     * @template V
     * @param {?=} cdRefOrTrackBy
     * @param {?=} trackByFn
     * @return {?}
     */
    DefaultIterableDifferFactory.prototype.create = function (cdRefOrTrackBy, trackByFn) {
        return new DefaultIterableDiffer(trackByFn || (cdRefOrTrackBy));
    };
    return DefaultIterableDifferFactory;
}());
var trackByIdentity = function (index, item) { return item; };
/**
 * @deprecated v4.0.0 - Should not be part of public API.
 */
var DefaultIterableDiffer = (function () {
    /**
     * @param {?=} trackByFn
     */
    function DefaultIterableDiffer(trackByFn) {
        this._length = 0;
        this._collection = null;
        this._linkedRecords = null;
        this._unlinkedRecords = null;
        this._previousItHead = null;
        this._itHead = null;
        this._itTail = null;
        this._additionsHead = null;
        this._additionsTail = null;
        this._movesHead = null;
        this._movesTail = null;
        this._removalsHead = null;
        this._removalsTail = null;
        this._identityChangesHead = null;
        this._identityChangesTail = null;
        this._trackByFn = trackByFn || trackByIdentity;
    }
    Object.defineProperty(DefaultIterableDiffer.prototype, "collection", {
        /**
         * @return {?}
         */
        get: function () { return this._collection; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DefaultIterableDiffer.prototype, "length", {
        /**
         * @return {?}
         */
        get: function () { return this._length; },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} fn
     * @return {?}
     */
    DefaultIterableDiffer.prototype.forEachItem = function (fn) {
        var /** @type {?} */ record;
        for (record = this._itHead; record !== null; record = record._next) {
            fn(record);
        }
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    DefaultIterableDiffer.prototype.forEachOperation = function (fn) {
        var /** @type {?} */ nextIt = this._itHead;
        var /** @type {?} */ nextRemove = this._removalsHead;
        var /** @type {?} */ addRemoveOffset = 0;
        var /** @type {?} */ moveOffsets = null;
        while (nextIt || nextRemove) {
            // Figure out which is the next record to process
            // Order: remove, add, move
            var /** @type {?} */ record = !nextRemove ||
                nextIt && ((nextIt.currentIndex)) <
                    getPreviousIndex(nextRemove, addRemoveOffset, moveOffsets) ? ((nextIt)) :
                nextRemove;
            var /** @type {?} */ adjPreviousIndex = getPreviousIndex(record, addRemoveOffset, moveOffsets);
            var /** @type {?} */ currentIndex = record.currentIndex;
            // consume the item, and adjust the addRemoveOffset and update moveDistance if necessary
            if (record === nextRemove) {
                addRemoveOffset--;
                nextRemove = nextRemove._nextRemoved;
            }
            else {
                nextIt = ((nextIt))._next;
                if (record.previousIndex == null) {
                    addRemoveOffset++;
                }
                else {
                    // INVARIANT:  currentIndex < previousIndex
                    if (!moveOffsets)
                        moveOffsets = [];
                    var /** @type {?} */ localMovePreviousIndex = adjPreviousIndex - addRemoveOffset;
                    var /** @type {?} */ localCurrentIndex = ((currentIndex)) - addRemoveOffset;
                    if (localMovePreviousIndex != localCurrentIndex) {
                        for (var /** @type {?} */ i = 0; i < localMovePreviousIndex; i++) {
                            var /** @type {?} */ offset = i < moveOffsets.length ? moveOffsets[i] : (moveOffsets[i] = 0);
                            var /** @type {?} */ index = offset + i;
                            if (localCurrentIndex <= index && index < localMovePreviousIndex) {
                                moveOffsets[i] = offset + 1;
                            }
                        }
                        var /** @type {?} */ previousIndex = record.previousIndex;
                        moveOffsets[previousIndex] = localCurrentIndex - localMovePreviousIndex;
                    }
                }
            }
            if (adjPreviousIndex !== currentIndex) {
                fn(record, adjPreviousIndex, currentIndex);
            }
        }
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    DefaultIterableDiffer.prototype.forEachPreviousItem = function (fn) {
        var /** @type {?} */ record;
        for (record = this._previousItHead; record !== null; record = record._nextPrevious) {
            fn(record);
        }
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    DefaultIterableDiffer.prototype.forEachAddedItem = function (fn) {
        var /** @type {?} */ record;
        for (record = this._additionsHead; record !== null; record = record._nextAdded) {
            fn(record);
        }
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    DefaultIterableDiffer.prototype.forEachMovedItem = function (fn) {
        var /** @type {?} */ record;
        for (record = this._movesHead; record !== null; record = record._nextMoved) {
            fn(record);
        }
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    DefaultIterableDiffer.prototype.forEachRemovedItem = function (fn) {
        var /** @type {?} */ record;
        for (record = this._removalsHead; record !== null; record = record._nextRemoved) {
            fn(record);
        }
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    DefaultIterableDiffer.prototype.forEachIdentityChange = function (fn) {
        var /** @type {?} */ record;
        for (record = this._identityChangesHead; record !== null; record = record._nextIdentityChange) {
            fn(record);
        }
    };
    /**
     * @param {?} collection
     * @return {?}
     */
    DefaultIterableDiffer.prototype.diff = function (collection) {
        if (collection == null)
            collection = [];
        if (!isListLikeIterable(collection)) {
            throw new Error("Error trying to diff '" + stringify(collection) + "'. Only arrays and iterables are allowed");
        }
        if (this.check(collection)) {
            return this;
        }
        else {
            return null;
        }
    };
    /**
     * @return {?}
     */
    DefaultIterableDiffer.prototype.onDestroy = function () { };
    /**
     * @param {?} collection
     * @return {?}
     */
    DefaultIterableDiffer.prototype.check = function (collection) {
        var _this = this;
        this._reset();
        var /** @type {?} */ record = this._itHead;
        var /** @type {?} */ mayBeDirty = false;
        var /** @type {?} */ index;
        var /** @type {?} */ item;
        var /** @type {?} */ itemTrackBy;
        if (Array.isArray(collection)) {
            this._length = collection.length;
            for (var /** @type {?} */ index_1 = 0; index_1 < this._length; index_1++) {
                item = collection[index_1];
                itemTrackBy = this._trackByFn(index_1, item);
                if (record === null || !looseIdentical(record.trackById, itemTrackBy)) {
                    record = this._mismatch(record, item, itemTrackBy, index_1);
                    mayBeDirty = true;
                }
                else {
                    if (mayBeDirty) {
                        // TODO(misko): can we limit this to duplicates only?
                        record = this._verifyReinsertion(record, item, itemTrackBy, index_1);
                    }
                    if (!looseIdentical(record.item, item))
                        this._addIdentityChange(record, item);
                }
                record = record._next;
            }
        }
        else {
            index = 0;
            iterateListLike(collection, function (item) {
                itemTrackBy = _this._trackByFn(index, item);
                if (record === null || !looseIdentical(record.trackById, itemTrackBy)) {
                    record = _this._mismatch(record, item, itemTrackBy, index);
                    mayBeDirty = true;
                }
                else {
                    if (mayBeDirty) {
                        // TODO(misko): can we limit this to duplicates only?
                        record = _this._verifyReinsertion(record, item, itemTrackBy, index);
                    }
                    if (!looseIdentical(record.item, item))
                        _this._addIdentityChange(record, item);
                }
                record = record._next;
                index++;
            });
            this._length = index;
        }
        this._truncate(record);
        this._collection = collection;
        return this.isDirty;
    };
    Object.defineProperty(DefaultIterableDiffer.prototype, "isDirty", {
        /**
         * @return {?}
         */
        get: function () {
            return this._additionsHead !== null || this._movesHead !== null ||
                this._removalsHead !== null || this._identityChangesHead !== null;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Reset the state of the change objects to show no changes. This means set previousKey to
     * currentKey, and clear all of the queues (additions, moves, removals).
     * Set the previousIndexes of moved and added items to their currentIndexes
     * Reset the list of additions, moves and removals
     *
     * \@internal
     * @return {?}
     */
    DefaultIterableDiffer.prototype._reset = function () {
        if (this.isDirty) {
            var /** @type {?} */ record = void 0;
            var /** @type {?} */ nextRecord = void 0;
            for (record = this._previousItHead = this._itHead; record !== null; record = record._next) {
                record._nextPrevious = record._next;
            }
            for (record = this._additionsHead; record !== null; record = record._nextAdded) {
                record.previousIndex = record.currentIndex;
            }
            this._additionsHead = this._additionsTail = null;
            for (record = this._movesHead; record !== null; record = nextRecord) {
                record.previousIndex = record.currentIndex;
                nextRecord = record._nextMoved;
            }
            this._movesHead = this._movesTail = null;
            this._removalsHead = this._removalsTail = null;
            this._identityChangesHead = this._identityChangesTail = null;
        }
    };
    /**
     * This is the core function which handles differences between collections.
     *
     * - `record` is the record which we saw at this position last time. If null then it is a new
     *   item.
     * - `item` is the current item in the collection
     * - `index` is the position of the item in the collection
     *
     * \@internal
     * @param {?} record
     * @param {?} item
     * @param {?} itemTrackBy
     * @param {?} index
     * @return {?}
     */
    DefaultIterableDiffer.prototype._mismatch = function (record, item, itemTrackBy, index) {
        // The previous record after which we will append the current one.
        var /** @type {?} */ previousRecord;
        if (record === null) {
            previousRecord = ((this._itTail));
        }
        else {
            previousRecord = ((record._prev));
            // Remove the record from the collection since we know it does not match the item.
            this._remove(record);
        }
        // Attempt to see if we have seen the item before.
        record = this._linkedRecords === null ? null : this._linkedRecords.get(itemTrackBy, index);
        if (record !== null) {
            // We have seen this before, we need to move it forward in the collection.
            // But first we need to check if identity changed, so we can update in view if necessary
            if (!looseIdentical(record.item, item))
                this._addIdentityChange(record, item);
            this._moveAfter(record, previousRecord, index);
        }
        else {
            // Never seen it, check evicted list.
            record = this._unlinkedRecords === null ? null : this._unlinkedRecords.get(itemTrackBy, null);
            if (record !== null) {
                // It is an item which we have evicted earlier: reinsert it back into the list.
                // But first we need to check if identity changed, so we can update in view if necessary
                if (!looseIdentical(record.item, item))
                    this._addIdentityChange(record, item);
                this._reinsertAfter(record, previousRecord, index);
            }
            else {
                // It is a new item: add it.
                record =
                    this._addAfter(new IterableChangeRecord_(item, itemTrackBy), previousRecord, index);
            }
        }
        return record;
    };
    /**
     * This check is only needed if an array contains duplicates. (Short circuit of nothing dirty)
     *
     * Use case: `[a, a]` => `[b, a, a]`
     *
     * If we did not have this check then the insertion of `b` would:
     *   1) evict first `a`
     *   2) insert `b` at `0` index.
     *   3) leave `a` at index `1` as is. <-- this is wrong!
     *   3) reinsert `a` at index 2. <-- this is wrong!
     *
     * The correct behavior is:
     *   1) evict first `a`
     *   2) insert `b` at `0` index.
     *   3) reinsert `a` at index 1.
     *   3) move `a` at from `1` to `2`.
     *
     *
     * Double check that we have not evicted a duplicate item. We need to check if the item type may
     * have already been removed:
     * The insertion of b will evict the first 'a'. If we don't reinsert it now it will be reinserted
     * at the end. Which will show up as the two 'a's switching position. This is incorrect, since a
     * better way to think of it is as insert of 'b' rather then switch 'a' with 'b' and then add 'a'
     * at the end.
     *
     * \@internal
     * @param {?} record
     * @param {?} item
     * @param {?} itemTrackBy
     * @param {?} index
     * @return {?}
     */
    DefaultIterableDiffer.prototype._verifyReinsertion = function (record, item, itemTrackBy, index) {
        var /** @type {?} */ reinsertRecord = this._unlinkedRecords === null ? null : this._unlinkedRecords.get(itemTrackBy, null);
        if (reinsertRecord !== null) {
            record = this._reinsertAfter(reinsertRecord, /** @type {?} */ ((record._prev)), index);
        }
        else if (record.currentIndex != index) {
            record.currentIndex = index;
            this._addToMoves(record, index);
        }
        return record;
    };
    /**
     * Get rid of any excess {\@link IterableChangeRecord_}s from the previous collection
     *
     * - `record` The first excess {\@link IterableChangeRecord_}.
     *
     * \@internal
     * @param {?} record
     * @return {?}
     */
    DefaultIterableDiffer.prototype._truncate = function (record) {
        // Anything after that needs to be removed;
        while (record !== null) {
            var /** @type {?} */ nextRecord = record._next;
            this._addToRemovals(this._unlink(record));
            record = nextRecord;
        }
        if (this._unlinkedRecords !== null) {
            this._unlinkedRecords.clear();
        }
        if (this._additionsTail !== null) {
            this._additionsTail._nextAdded = null;
        }
        if (this._movesTail !== null) {
            this._movesTail._nextMoved = null;
        }
        if (this._itTail !== null) {
            this._itTail._next = null;
        }
        if (this._removalsTail !== null) {
            this._removalsTail._nextRemoved = null;
        }
        if (this._identityChangesTail !== null) {
            this._identityChangesTail._nextIdentityChange = null;
        }
    };
    /**
     * \@internal
     * @param {?} record
     * @param {?} prevRecord
     * @param {?} index
     * @return {?}
     */
    DefaultIterableDiffer.prototype._reinsertAfter = function (record, prevRecord, index) {
        if (this._unlinkedRecords !== null) {
            this._unlinkedRecords.remove(record);
        }
        var /** @type {?} */ prev = record._prevRemoved;
        var /** @type {?} */ next = record._nextRemoved;
        if (prev === null) {
            this._removalsHead = next;
        }
        else {
            prev._nextRemoved = next;
        }
        if (next === null) {
            this._removalsTail = prev;
        }
        else {
            next._prevRemoved = prev;
        }
        this._insertAfter(record, prevRecord, index);
        this._addToMoves(record, index);
        return record;
    };
    /**
     * \@internal
     * @param {?} record
     * @param {?} prevRecord
     * @param {?} index
     * @return {?}
     */
    DefaultIterableDiffer.prototype._moveAfter = function (record, prevRecord, index) {
        this._unlink(record);
        this._insertAfter(record, prevRecord, index);
        this._addToMoves(record, index);
        return record;
    };
    /**
     * \@internal
     * @param {?} record
     * @param {?} prevRecord
     * @param {?} index
     * @return {?}
     */
    DefaultIterableDiffer.prototype._addAfter = function (record, prevRecord, index) {
        this._insertAfter(record, prevRecord, index);
        if (this._additionsTail === null) {
            // todo(vicb)
            // assert(this._additionsHead === null);
            this._additionsTail = this._additionsHead = record;
        }
        else {
            // todo(vicb)
            // assert(_additionsTail._nextAdded === null);
            // assert(record._nextAdded === null);
            this._additionsTail = this._additionsTail._nextAdded = record;
        }
        return record;
    };
    /**
     * \@internal
     * @param {?} record
     * @param {?} prevRecord
     * @param {?} index
     * @return {?}
     */
    DefaultIterableDiffer.prototype._insertAfter = function (record, prevRecord, index) {
        // todo(vicb)
        // assert(record != prevRecord);
        // assert(record._next === null);
        // assert(record._prev === null);
        var /** @type {?} */ next = prevRecord === null ? this._itHead : prevRecord._next;
        // todo(vicb)
        // assert(next != record);
        // assert(prevRecord != record);
        record._next = next;
        record._prev = prevRecord;
        if (next === null) {
            this._itTail = record;
        }
        else {
            next._prev = record;
        }
        if (prevRecord === null) {
            this._itHead = record;
        }
        else {
            prevRecord._next = record;
        }
        if (this._linkedRecords === null) {
            this._linkedRecords = new _DuplicateMap();
        }
        this._linkedRecords.put(record);
        record.currentIndex = index;
        return record;
    };
    /**
     * \@internal
     * @param {?} record
     * @return {?}
     */
    DefaultIterableDiffer.prototype._remove = function (record) {
        return this._addToRemovals(this._unlink(record));
    };
    /**
     * \@internal
     * @param {?} record
     * @return {?}
     */
    DefaultIterableDiffer.prototype._unlink = function (record) {
        if (this._linkedRecords !== null) {
            this._linkedRecords.remove(record);
        }
        var /** @type {?} */ prev = record._prev;
        var /** @type {?} */ next = record._next;
        // todo(vicb)
        // assert((record._prev = null) === null);
        // assert((record._next = null) === null);
        if (prev === null) {
            this._itHead = next;
        }
        else {
            prev._next = next;
        }
        if (next === null) {
            this._itTail = prev;
        }
        else {
            next._prev = prev;
        }
        return record;
    };
    /**
     * \@internal
     * @param {?} record
     * @param {?} toIndex
     * @return {?}
     */
    DefaultIterableDiffer.prototype._addToMoves = function (record, toIndex) {
        // todo(vicb)
        // assert(record._nextMoved === null);
        if (record.previousIndex === toIndex) {
            return record;
        }
        if (this._movesTail === null) {
            // todo(vicb)
            // assert(_movesHead === null);
            this._movesTail = this._movesHead = record;
        }
        else {
            // todo(vicb)
            // assert(_movesTail._nextMoved === null);
            this._movesTail = this._movesTail._nextMoved = record;
        }
        return record;
    };
    /**
     * @param {?} record
     * @return {?}
     */
    DefaultIterableDiffer.prototype._addToRemovals = function (record) {
        if (this._unlinkedRecords === null) {
            this._unlinkedRecords = new _DuplicateMap();
        }
        this._unlinkedRecords.put(record);
        record.currentIndex = null;
        record._nextRemoved = null;
        if (this._removalsTail === null) {
            // todo(vicb)
            // assert(_removalsHead === null);
            this._removalsTail = this._removalsHead = record;
            record._prevRemoved = null;
        }
        else {
            // todo(vicb)
            // assert(_removalsTail._nextRemoved === null);
            // assert(record._nextRemoved === null);
            record._prevRemoved = this._removalsTail;
            this._removalsTail = this._removalsTail._nextRemoved = record;
        }
        return record;
    };
    /**
     * \@internal
     * @param {?} record
     * @param {?} item
     * @return {?}
     */
    DefaultIterableDiffer.prototype._addIdentityChange = function (record, item) {
        record.item = item;
        if (this._identityChangesTail === null) {
            this._identityChangesTail = this._identityChangesHead = record;
        }
        else {
            this._identityChangesTail = this._identityChangesTail._nextIdentityChange = record;
        }
        return record;
    };
    /**
     * @return {?}
     */
    DefaultIterableDiffer.prototype.toString = function () {
        var /** @type {?} */ list = [];
        this.forEachItem(function (record) { return list.push(record); });
        var /** @type {?} */ previous = [];
        this.forEachPreviousItem(function (record) { return previous.push(record); });
        var /** @type {?} */ additions = [];
        this.forEachAddedItem(function (record) { return additions.push(record); });
        var /** @type {?} */ moves = [];
        this.forEachMovedItem(function (record) { return moves.push(record); });
        var /** @type {?} */ removals = [];
        this.forEachRemovedItem(function (record) { return removals.push(record); });
        var /** @type {?} */ identityChanges = [];
        this.forEachIdentityChange(function (record) { return identityChanges.push(record); });
        return 'collection: ' + list.join(', ') + '\n' +
            'previous: ' + previous.join(', ') + '\n' +
            'additions: ' + additions.join(', ') + '\n' +
            'moves: ' + moves.join(', ') + '\n' +
            'removals: ' + removals.join(', ') + '\n' +
            'identityChanges: ' + identityChanges.join(', ') + '\n';
    };
    return DefaultIterableDiffer;
}());
/**
 * \@stable
 */
var IterableChangeRecord_ = (function () {
    /**
     * @param {?} item
     * @param {?} trackById
     */
    function IterableChangeRecord_(item, trackById) {
        this.item = item;
        this.trackById = trackById;
        this.currentIndex = null;
        this.previousIndex = null;
        /**
         * \@internal
         */
        this._nextPrevious = null;
        /**
         * \@internal
         */
        this._prev = null;
        /**
         * \@internal
         */
        this._next = null;
        /**
         * \@internal
         */
        this._prevDup = null;
        /**
         * \@internal
         */
        this._nextDup = null;
        /**
         * \@internal
         */
        this._prevRemoved = null;
        /**
         * \@internal
         */
        this._nextRemoved = null;
        /**
         * \@internal
         */
        this._nextAdded = null;
        /**
         * \@internal
         */
        this._nextMoved = null;
        /**
         * \@internal
         */
        this._nextIdentityChange = null;
    }
    /**
     * @return {?}
     */
    IterableChangeRecord_.prototype.toString = function () {
        return this.previousIndex === this.currentIndex ? stringify(this.item) :
            stringify(this.item) + '[' +
                stringify(this.previousIndex) + '->' + stringify(this.currentIndex) + ']';
    };
    return IterableChangeRecord_;
}());
var _DuplicateItemRecordList = (function () {
    function _DuplicateItemRecordList() {
        /**
         * \@internal
         */
        this._head = null;
        /**
         * \@internal
         */
        this._tail = null;
    }
    /**
     * Append the record to the list of duplicates.
     *
     * Note: by design all records in the list of duplicates hold the same value in record.item.
     * @param {?} record
     * @return {?}
     */
    _DuplicateItemRecordList.prototype.add = function (record) {
        if (this._head === null) {
            this._head = this._tail = record;
            record._nextDup = null;
            record._prevDup = null;
        }
        else {
            ((
            // todo(vicb)
            // assert(record.item ==  _head.item ||
            //       record.item is num && record.item.isNaN && _head.item is num && _head.item.isNaN);
            this._tail))._nextDup = record;
            record._prevDup = this._tail;
            record._nextDup = null;
            this._tail = record;
        }
    };
    /**
     * @param {?} trackById
     * @param {?} afterIndex
     * @return {?}
     */
    _DuplicateItemRecordList.prototype.get = function (trackById, afterIndex) {
        var /** @type {?} */ record;
        for (record = this._head; record !== null; record = record._nextDup) {
            if ((afterIndex === null || afterIndex < record.currentIndex) &&
                looseIdentical(record.trackById, trackById)) {
                return record;
            }
        }
        return null;
    };
    /**
     * Remove one {\@link IterableChangeRecord_} from the list of duplicates.
     *
     * Returns whether the list of duplicates is empty.
     * @param {?} record
     * @return {?}
     */
    _DuplicateItemRecordList.prototype.remove = function (record) {
        // todo(vicb)
        // assert(() {
        //  // verify that the record being removed is in the list.
        //  for (IterableChangeRecord_ cursor = _head; cursor != null; cursor = cursor._nextDup) {
        //    if (identical(cursor, record)) return true;
        //  }
        //  return false;
        //});
        var /** @type {?} */ prev = record._prevDup;
        var /** @type {?} */ next = record._nextDup;
        if (prev === null) {
            this._head = next;
        }
        else {
            prev._nextDup = next;
        }
        if (next === null) {
            this._tail = prev;
        }
        else {
            next._prevDup = prev;
        }
        return this._head === null;
    };
    return _DuplicateItemRecordList;
}());
var _DuplicateMap = (function () {
    function _DuplicateMap() {
        this.map = new Map();
    }
    /**
     * @param {?} record
     * @return {?}
     */
    _DuplicateMap.prototype.put = function (record) {
        var /** @type {?} */ key = record.trackById;
        var /** @type {?} */ duplicates = this.map.get(key);
        if (!duplicates) {
            duplicates = new _DuplicateItemRecordList();
            this.map.set(key, duplicates);
        }
        duplicates.add(record);
    };
    /**
     * Retrieve the `value` using key. Because the IterableChangeRecord_ value may be one which we
     * have already iterated over, we use the afterIndex to pretend it is not there.
     *
     * Use case: `[a, b, c, a, a]` if we are at index `3` which is the second `a` then asking if we
     * have any more `a`s needs to return the last `a` not the first or second.
     * @param {?} trackById
     * @param {?} afterIndex
     * @return {?}
     */
    _DuplicateMap.prototype.get = function (trackById, afterIndex) {
        var /** @type {?} */ key = trackById;
        var /** @type {?} */ recordList = this.map.get(key);
        return recordList ? recordList.get(trackById, afterIndex) : null;
    };
    /**
     * Removes a {\@link IterableChangeRecord_} from the list of duplicates.
     *
     * The list of duplicates also is removed from the map if it gets empty.
     * @param {?} record
     * @return {?}
     */
    _DuplicateMap.prototype.remove = function (record) {
        var /** @type {?} */ key = record.trackById;
        var /** @type {?} */ recordList = ((this.map.get(key)));
        // Remove the list of duplicates when it gets empty
        if (recordList.remove(record)) {
            this.map.delete(key);
        }
        return record;
    };
    Object.defineProperty(_DuplicateMap.prototype, "isEmpty", {
        /**
         * @return {?}
         */
        get: function () { return this.map.size === 0; },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    _DuplicateMap.prototype.clear = function () { this.map.clear(); };
    /**
     * @return {?}
     */
    _DuplicateMap.prototype.toString = function () { return '_DuplicateMap(' + stringify(this.map) + ')'; };
    return _DuplicateMap;
}());
/**
 * @param {?} item
 * @param {?} addRemoveOffset
 * @param {?} moveOffsets
 * @return {?}
 */
function getPreviousIndex(item, addRemoveOffset, moveOffsets) {
    var /** @type {?} */ previousIndex = item.previousIndex;
    if (previousIndex === null)
        return previousIndex;
    var /** @type {?} */ moveOffset = 0;
    if (moveOffsets && previousIndex < moveOffsets.length) {
        moveOffset = moveOffsets[previousIndex];
    }
    return previousIndex + addRemoveOffset + moveOffset;
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var DefaultKeyValueDifferFactory = (function () {
    function DefaultKeyValueDifferFactory() {
    }
    /**
     * @param {?} obj
     * @return {?}
     */
    DefaultKeyValueDifferFactory.prototype.supports = function (obj) { return obj instanceof Map || isJsObject(obj); };
    /**
     * @deprecated v4.0.0 - ChangeDetectorRef is not used and is no longer a parameter
     * @template K, V
     * @param {?=} cd
     * @return {?}
     */
    DefaultKeyValueDifferFactory.prototype.create = function (cd) {
        return new DefaultKeyValueDiffer();
    };
    return DefaultKeyValueDifferFactory;
}());
var DefaultKeyValueDiffer = (function () {
    function DefaultKeyValueDiffer() {
        this._records = new Map();
        this._mapHead = null;
        this._appendAfter = null;
        this._previousMapHead = null;
        this._changesHead = null;
        this._changesTail = null;
        this._additionsHead = null;
        this._additionsTail = null;
        this._removalsHead = null;
        this._removalsTail = null;
    }
    Object.defineProperty(DefaultKeyValueDiffer.prototype, "isDirty", {
        /**
         * @return {?}
         */
        get: function () {
            return this._additionsHead !== null || this._changesHead !== null ||
                this._removalsHead !== null;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} fn
     * @return {?}
     */
    DefaultKeyValueDiffer.prototype.forEachItem = function (fn) {
        var /** @type {?} */ record;
        for (record = this._mapHead; record !== null; record = record._next) {
            fn(record);
        }
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    DefaultKeyValueDiffer.prototype.forEachPreviousItem = function (fn) {
        var /** @type {?} */ record;
        for (record = this._previousMapHead; record !== null; record = record._nextPrevious) {
            fn(record);
        }
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    DefaultKeyValueDiffer.prototype.forEachChangedItem = function (fn) {
        var /** @type {?} */ record;
        for (record = this._changesHead; record !== null; record = record._nextChanged) {
            fn(record);
        }
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    DefaultKeyValueDiffer.prototype.forEachAddedItem = function (fn) {
        var /** @type {?} */ record;
        for (record = this._additionsHead; record !== null; record = record._nextAdded) {
            fn(record);
        }
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    DefaultKeyValueDiffer.prototype.forEachRemovedItem = function (fn) {
        var /** @type {?} */ record;
        for (record = this._removalsHead; record !== null; record = record._nextRemoved) {
            fn(record);
        }
    };
    /**
     * @param {?=} map
     * @return {?}
     */
    DefaultKeyValueDiffer.prototype.diff = function (map) {
        if (!map) {
            map = new Map();
        }
        else if (!(map instanceof Map || isJsObject(map))) {
            throw new Error("Error trying to diff '" + stringify(map) + "'. Only maps and objects are allowed");
        }
        return this.check(map) ? this : null;
    };
    /**
     * @return {?}
     */
    DefaultKeyValueDiffer.prototype.onDestroy = function () { };
    /**
     * Check the current state of the map vs the previous.
     * The algorithm is optimised for when the keys do no change.
     * @param {?} map
     * @return {?}
     */
    DefaultKeyValueDiffer.prototype.check = function (map) {
        var _this = this;
        this._reset();
        var /** @type {?} */ insertBefore = this._mapHead;
        this._appendAfter = null;
        this._forEach(map, function (value, key) {
            if (insertBefore && insertBefore.key === key) {
                _this._maybeAddToChanges(insertBefore, value);
                _this._appendAfter = insertBefore;
                insertBefore = insertBefore._next;
            }
            else {
                var /** @type {?} */ record = _this._getOrCreateRecordForKey(key, value);
                insertBefore = _this._insertBeforeOrAppend(insertBefore, record);
            }
        });
        // Items remaining at the end of the list have been deleted
        if (insertBefore) {
            if (insertBefore._prev) {
                insertBefore._prev._next = null;
            }
            this._removalsHead = insertBefore;
            for (var /** @type {?} */ record = insertBefore; record !== null; record = record._nextRemoved) {
                if (record === this._mapHead) {
                    this._mapHead = null;
                }
                this._records.delete(record.key);
                record._nextRemoved = record._next;
                record.previousValue = record.currentValue;
                record.currentValue = null;
                record._prev = null;
                record._next = null;
            }
        }
        // Make sure tails have no next records from previous runs
        if (this._changesTail)
            this._changesTail._nextChanged = null;
        if (this._additionsTail)
            this._additionsTail._nextAdded = null;
        return this.isDirty;
    };
    /**
     * Inserts a record before `before` or append at the end of the list when `before` is null.
     *
     * Notes:
     * - This method appends at `this._appendAfter`,
     * - This method updates `this._appendAfter`,
     * - The return value is the new value for the insertion pointer.
     * @param {?} before
     * @param {?} record
     * @return {?}
     */
    DefaultKeyValueDiffer.prototype._insertBeforeOrAppend = function (before, record) {
        if (before) {
            var /** @type {?} */ prev = before._prev;
            record._next = before;
            record._prev = prev;
            before._prev = record;
            if (prev) {
                prev._next = record;
            }
            if (before === this._mapHead) {
                this._mapHead = record;
            }
            this._appendAfter = before;
            return before;
        }
        if (this._appendAfter) {
            this._appendAfter._next = record;
            record._prev = this._appendAfter;
        }
        else {
            this._mapHead = record;
        }
        this._appendAfter = record;
        return null;
    };
    /**
     * @param {?} key
     * @param {?} value
     * @return {?}
     */
    DefaultKeyValueDiffer.prototype._getOrCreateRecordForKey = function (key, value) {
        if (this._records.has(key)) {
            var /** @type {?} */ record_1 = ((this._records.get(key)));
            this._maybeAddToChanges(record_1, value);
            var /** @type {?} */ prev = record_1._prev;
            var /** @type {?} */ next = record_1._next;
            if (prev) {
                prev._next = next;
            }
            if (next) {
                next._prev = prev;
            }
            record_1._next = null;
            record_1._prev = null;
            return record_1;
        }
        var /** @type {?} */ record = new KeyValueChangeRecord_(key);
        this._records.set(key, record);
        record.currentValue = value;
        this._addToAdditions(record);
        return record;
    };
    /**
     * \@internal
     * @return {?}
     */
    DefaultKeyValueDiffer.prototype._reset = function () {
        if (this.isDirty) {
            var /** @type {?} */ record = void 0;
            // let `_previousMapHead` contain the state of the map before the changes
            this._previousMapHead = this._mapHead;
            for (record = this._previousMapHead; record !== null; record = record._next) {
                record._nextPrevious = record._next;
            }
            // Update `record.previousValue` with the value of the item before the changes
            // We need to update all changed items (that's those which have been added and changed)
            for (record = this._changesHead; record !== null; record = record._nextChanged) {
                record.previousValue = record.currentValue;
            }
            for (record = this._additionsHead; record != null; record = record._nextAdded) {
                record.previousValue = record.currentValue;
            }
            this._changesHead = this._changesTail = null;
            this._additionsHead = this._additionsTail = null;
            this._removalsHead = null;
        }
    };
    /**
     * @param {?} record
     * @param {?} newValue
     * @return {?}
     */
    DefaultKeyValueDiffer.prototype._maybeAddToChanges = function (record, newValue) {
        if (!looseIdentical(newValue, record.currentValue)) {
            record.previousValue = record.currentValue;
            record.currentValue = newValue;
            this._addToChanges(record);
        }
    };
    /**
     * @param {?} record
     * @return {?}
     */
    DefaultKeyValueDiffer.prototype._addToAdditions = function (record) {
        if (this._additionsHead === null) {
            this._additionsHead = this._additionsTail = record;
        }
        else {
            ((this._additionsTail))._nextAdded = record;
            this._additionsTail = record;
        }
    };
    /**
     * @param {?} record
     * @return {?}
     */
    DefaultKeyValueDiffer.prototype._addToChanges = function (record) {
        if (this._changesHead === null) {
            this._changesHead = this._changesTail = record;
        }
        else {
            ((this._changesTail))._nextChanged = record;
            this._changesTail = record;
        }
    };
    /**
     * @return {?}
     */
    DefaultKeyValueDiffer.prototype.toString = function () {
        var /** @type {?} */ items = [];
        var /** @type {?} */ previous = [];
        var /** @type {?} */ changes = [];
        var /** @type {?} */ additions = [];
        var /** @type {?} */ removals = [];
        this.forEachItem(function (r) { return items.push(stringify(r)); });
        this.forEachPreviousItem(function (r) { return previous.push(stringify(r)); });
        this.forEachChangedItem(function (r) { return changes.push(stringify(r)); });
        this.forEachAddedItem(function (r) { return additions.push(stringify(r)); });
        this.forEachRemovedItem(function (r) { return removals.push(stringify(r)); });
        return 'map: ' + items.join(', ') + '\n' +
            'previous: ' + previous.join(', ') + '\n' +
            'additions: ' + additions.join(', ') + '\n' +
            'changes: ' + changes.join(', ') + '\n' +
            'removals: ' + removals.join(', ') + '\n';
    };
    /**
     * \@internal
     * @template K, V
     * @param {?} obj
     * @param {?} fn
     * @return {?}
     */
    DefaultKeyValueDiffer.prototype._forEach = function (obj, fn) {
        if (obj instanceof Map) {
            obj.forEach(fn);
        }
        else {
            Object.keys(obj).forEach(function (k) { return fn(obj[k], k); });
        }
    };
    return DefaultKeyValueDiffer;
}());
/**
 * \@stable
 */
var KeyValueChangeRecord_ = (function () {
    /**
     * @param {?} key
     */
    function KeyValueChangeRecord_(key) {
        this.key = key;
        this.previousValue = null;
        this.currentValue = null;
        /**
         * \@internal
         */
        this._nextPrevious = null;
        /**
         * \@internal
         */
        this._next = null;
        /**
         * \@internal
         */
        this._prev = null;
        /**
         * \@internal
         */
        this._nextAdded = null;
        /**
         * \@internal
         */
        this._nextRemoved = null;
        /**
         * \@internal
         */
        this._nextChanged = null;
    }
    /**
     * @return {?}
     */
    KeyValueChangeRecord_.prototype.toString = function () {
        return looseIdentical(this.previousValue, this.currentValue) ?
            stringify(this.key) :
            (stringify(this.key) + '[' + stringify(this.previousValue) + '->' +
                stringify(this.currentValue) + ']');
    };
    return KeyValueChangeRecord_;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * A repository of different iterable diffing strategies used by NgFor, NgClass, and others.
 * \@stable
 */
var IterableDiffers = (function () {
    /**
     * @param {?} factories
     */
    function IterableDiffers(factories) {
        this.factories = factories;
    }
    /**
     * @param {?} factories
     * @param {?=} parent
     * @return {?}
     */
    IterableDiffers.create = function (factories, parent) {
        if (parent != null) {
            var /** @type {?} */ copied = parent.factories.slice();
            factories = factories.concat(copied);
            return new IterableDiffers(factories);
        }
        else {
            return new IterableDiffers(factories);
        }
    };
    /**
     * Takes an array of {\@link IterableDifferFactory} and returns a provider used to extend the
     * inherited {\@link IterableDiffers} instance with the provided factories and return a new
     * {\@link IterableDiffers} instance.
     *
     * The following example shows how to extend an existing list of factories,
     * which will only be applied to the injector for this component and its children.
     * This step is all that's required to make a new {\@link IterableDiffer} available.
     *
     * ### Example
     *
     * ```
     * \@Component({
     *   viewProviders: [
     *     IterableDiffers.extend([new ImmutableListDiffer()])
     *   ]
     * })
     * ```
     * @param {?} factories
     * @return {?}
     */
    IterableDiffers.extend = function (factories) {
        return {
            provide: IterableDiffers,
            useFactory: function (parent) {
                if (!parent) {
                    // Typically would occur when calling IterableDiffers.extend inside of dependencies passed
                    // to
                    // bootstrap(), which would override default pipes instead of extending them.
                    throw new Error('Cannot extend IterableDiffers without a parent injector');
                }
                return IterableDiffers.create(factories, parent);
            },
            // Dependency technically isn't optional, but we can provide a better error message this way.
            deps: [[IterableDiffers, new SkipSelf(), new Optional()]]
        };
    };
    /**
     * @param {?} iterable
     * @return {?}
     */
    IterableDiffers.prototype.find = function (iterable) {
        var /** @type {?} */ factory = this.factories.find(function (f) { return f.supports(iterable); });
        if (factory != null) {
            return factory;
        }
        else {
            throw new Error("Cannot find a differ supporting object '" + iterable + "' of type '" + getTypeNameForDebugging(iterable) + "'");
        }
    };
    return IterableDiffers;
}());
/**
 * @param {?} type
 * @return {?}
 */
function getTypeNameForDebugging(type) {
    return type['name'] || typeof type;
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * A repository of different Map diffing strategies used by NgClass, NgStyle, and others.
 * \@stable
 */
var KeyValueDiffers = (function () {
    /**
     * @param {?} factories
     */
    function KeyValueDiffers(factories) {
        this.factories = factories;
    }
    /**
     * @template S
     * @param {?} factories
     * @param {?=} parent
     * @return {?}
     */
    KeyValueDiffers.create = function (factories, parent) {
        if (parent) {
            var /** @type {?} */ copied = parent.factories.slice();
            factories = factories.concat(copied);
        }
        return new KeyValueDiffers(factories);
    };
    /**
     * Takes an array of {\@link KeyValueDifferFactory} and returns a provider used to extend the
     * inherited {\@link KeyValueDiffers} instance with the provided factories and return a new
     * {\@link KeyValueDiffers} instance.
     *
     * The following example shows how to extend an existing list of factories,
     * which will only be applied to the injector for this component and its children.
     * This step is all that's required to make a new {\@link KeyValueDiffer} available.
     *
     * ### Example
     *
     * ```
     * \@Component({
     *   viewProviders: [
     *     KeyValueDiffers.extend([new ImmutableMapDiffer()])
     *   ]
     * })
     * ```
     * @template S
     * @param {?} factories
     * @return {?}
     */
    KeyValueDiffers.extend = function (factories) {
        return {
            provide: KeyValueDiffers,
            useFactory: function (parent) {
                if (!parent) {
                    // Typically would occur when calling KeyValueDiffers.extend inside of dependencies passed
                    // to bootstrap(), which would override default pipes instead of extending them.
                    throw new Error('Cannot extend KeyValueDiffers without a parent injector');
                }
                return KeyValueDiffers.create(factories, parent);
            },
            // Dependency technically isn't optional, but we can provide a better error message this way.
            deps: [[KeyValueDiffers, new SkipSelf(), new Optional()]]
        };
    };
    /**
     * @param {?} kv
     * @return {?}
     */
    KeyValueDiffers.prototype.find = function (kv) {
        var /** @type {?} */ factory = this.factories.find(function (f) { return f.supports(kv); });
        if (factory) {
            return factory;
        }
        throw new Error("Cannot find a differ supporting object '" + kv + "'");
    };
    return KeyValueDiffers;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Structural diffing for `Object`s and `Map`s.
 */
var keyValDiff = [new DefaultKeyValueDifferFactory()];
/**
 * Structural diffing for `Iterable` types such as `Array`s.
 */
var iterableDiff = [new DefaultIterableDifferFactory()];
var defaultIterableDiffers = new IterableDiffers(iterableDiff);
var defaultKeyValueDiffers = new KeyValueDiffers(keyValDiff);
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @module
 * @description
 * Change detection enables data binding in Angular.
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @return {?}
 */
function _reflector() {
    return reflector;
}
var _CORE_PLATFORM_PROVIDERS = [
    // Set a default platform name for platforms that don't set it explicitly.
    { provide: PLATFORM_ID, useValue: 'unknown' },
    PlatformRef_,
    { provide: PlatformRef, useExisting: PlatformRef_ },
    { provide: Reflector, useFactory: _reflector, deps: [] },
    { provide: ReflectorReader, useExisting: Reflector },
    TestabilityRegistry,
    Console,
];
/**
 * This platform has to be included in any other platform
 *
 * \@experimental
 */
var platformCore = createPlatformFactory(null, 'core', _CORE_PLATFORM_PROVIDERS);
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * \@experimental i18n support is experimental.
 */
var LOCALE_ID = new InjectionToken('LocaleId');
/**
 * \@experimental i18n support is experimental.
 */
var TRANSLATIONS = new InjectionToken('Translations');
/**
 * \@experimental i18n support is experimental.
 */
var TRANSLATIONS_FORMAT = new InjectionToken('TranslationsFormat');
var MissingTranslationStrategy = {};
MissingTranslationStrategy.Error = 0;
MissingTranslationStrategy.Warning = 1;
MissingTranslationStrategy.Ignore = 2;
MissingTranslationStrategy[MissingTranslationStrategy.Error] = "Error";
MissingTranslationStrategy[MissingTranslationStrategy.Warning] = "Warning";
MissingTranslationStrategy[MissingTranslationStrategy.Ignore] = "Ignore";
var SecurityContext = {};
SecurityContext.NONE = 0;
SecurityContext.HTML = 1;
SecurityContext.STYLE = 2;
SecurityContext.SCRIPT = 3;
SecurityContext.URL = 4;
SecurityContext.RESOURCE_URL = 5;
SecurityContext[SecurityContext.NONE] = "NONE";
SecurityContext[SecurityContext.HTML] = "HTML";
SecurityContext[SecurityContext.STYLE] = "STYLE";
SecurityContext[SecurityContext.SCRIPT] = "SCRIPT";
SecurityContext[SecurityContext.URL] = "URL";
SecurityContext[SecurityContext.RESOURCE_URL] = "RESOURCE_URL";
/**
 * Sanitizer is used by the views to sanitize potentially dangerous values.
 *
 * \@stable
 * @abstract
 */
var Sanitizer = (function () {
    function Sanitizer() {
    }
    /**
     * @abstract
     * @param {?} context
     * @param {?} value
     * @return {?}
     */
    Sanitizer.prototype.sanitize = function (context, value) { };
    return Sanitizer;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Node instance data.
 *
 * We have a separate type per NodeType to save memory
 * (TextData | ElementData | ProviderData | PureExpressionData | QueryList<any>)
 *
 * To keep our code monomorphic,
 * we prohibit using `NodeData` directly but enforce the use of accessors (`asElementData`, ...).
 * This way, no usage site can get a `NodeData` from view.nodes and then use it for different
 * purposes.
 */
/**
 * Accessor for view.nodes, enforcing that every usage site stays monomorphic.
 * @param {?} view
 * @param {?} index
 * @return {?}
 */
function asTextData(view, index) {
    return (view.nodes[index]);
}
/**
 * Accessor for view.nodes, enforcing that every usage site stays monomorphic.
 * @param {?} view
 * @param {?} index
 * @return {?}
 */
function asElementData(view, index) {
    return (view.nodes[index]);
}
/**
 * Accessor for view.nodes, enforcing that every usage site stays monomorphic.
 * @param {?} view
 * @param {?} index
 * @return {?}
 */
function asProviderData(view, index) {
    return (view.nodes[index]);
}
/**
 * Accessor for view.nodes, enforcing that every usage site stays monomorphic.
 * @param {?} view
 * @param {?} index
 * @return {?}
 */
function asPureExpressionData(view, index) {
    return (view.nodes[index]);
}
/**
 * Accessor for view.nodes, enforcing that every usage site stays monomorphic.
 * @param {?} view
 * @param {?} index
 * @return {?}
 */
function asQueryList(view, index) {
    return (view.nodes[index]);
}
/**
 * @abstract
 */
var DebugContext = (function () {
    function DebugContext() {
    }
    /**
     * @abstract
     * @return {?}
     */
    DebugContext.prototype.view = function () { };
    /**
     * @abstract
     * @return {?}
     */
    DebugContext.prototype.nodeIndex = function () { };
    /**
     * @abstract
     * @return {?}
     */
    DebugContext.prototype.injector = function () { };
    /**
     * @abstract
     * @return {?}
     */
    DebugContext.prototype.component = function () { };
    /**
     * @abstract
     * @return {?}
     */
    DebugContext.prototype.providerTokens = function () { };
    /**
     * @abstract
     * @return {?}
     */
    DebugContext.prototype.references = function () { };
    /**
     * @abstract
     * @return {?}
     */
    DebugContext.prototype.context = function () { };
    /**
     * @abstract
     * @return {?}
     */
    DebugContext.prototype.componentRenderElement = function () { };
    /**
     * @abstract
     * @return {?}
     */
    DebugContext.prototype.renderNode = function () { };
    /**
     * @abstract
     * @param {?} console
     * @param {...?} values
     * @return {?}
     */
    DebugContext.prototype.logError = function (console) {
        var values = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            values[_i - 1] = arguments[_i];
        }
    };
    return DebugContext;
}());
/**
 * This object is used to prevent cycles in the source files and to have a place where
 * debug mode can hook it. It is lazily filled when `isDevMode` is known.
 */
var Services = {
    setCurrentNode: /** @type {?} */ ((undefined)),
    createRootView: /** @type {?} */ ((undefined)),
    createEmbeddedView: /** @type {?} */ ((undefined)),
    checkAndUpdateView: /** @type {?} */ ((undefined)),
    checkNoChangesView: /** @type {?} */ ((undefined)),
    destroyView: /** @type {?} */ ((undefined)),
    resolveDep: /** @type {?} */ ((undefined)),
    createDebugContext: /** @type {?} */ ((undefined)),
    handleEvent: /** @type {?} */ ((undefined)),
    updateDirectives: /** @type {?} */ ((undefined)),
    updateRenderer: /** @type {?} */ ((undefined)),
    dirtyParentQueries: /** @type {?} */ ((undefined)),
};
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @param {?} context
 * @param {?} oldValue
 * @param {?} currValue
 * @param {?} isFirstCheck
 * @return {?}
 */
function expressionChangedAfterItHasBeenCheckedError(context, oldValue, currValue, isFirstCheck) {
    var /** @type {?} */ msg = "ExpressionChangedAfterItHasBeenCheckedError: Expression has changed after it was checked. Previous value: '" + oldValue + "'. Current value: '" + currValue + "'.";
    if (isFirstCheck) {
        msg +=
            " It seems like the view has been created after its parent and its children have been dirty checked." +
                " Has it been created in a change detection hook ?";
    }
    return viewDebugError(msg, context);
}
/**
 * @param {?} err
 * @param {?} context
 * @return {?}
 */
function viewWrappedDebugError(err, context) {
    if (!(err instanceof Error)) {
        // errors that are not Error instances don't have a stack,
        // so it is ok to wrap them into a new Error object...
        err = new Error(err.toString());
    }
    _addDebugContext(err, context);
    return err;
}
/**
 * @param {?} msg
 * @param {?} context
 * @return {?}
 */
function viewDebugError(msg, context) {
    var /** @type {?} */ err = new Error(msg);
    _addDebugContext(err, context);
    return err;
}
/**
 * @param {?} err
 * @param {?} context
 * @return {?}
 */
function _addDebugContext(err, context) {
    ((err))[ERROR_DEBUG_CONTEXT] = context;
    ((err))[ERROR_LOGGER] = context.logError.bind(context);
}
/**
 * @param {?} err
 * @return {?}
 */
function isViewDebugError(err) {
    return !!getDebugContext(err);
}
/**
 * @param {?} action
 * @return {?}
 */
function viewDestroyedError(action) {
    return new Error("ViewDestroyedError: Attempt to use a destroyed view: " + action);
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var NOOP = function () { };
var _tokenKeyCache = new Map();
/**
 * @param {?} token
 * @return {?}
 */
function tokenKey(token) {
    var /** @type {?} */ key = _tokenKeyCache.get(token);
    if (!key) {
        key = stringify(token) + '_' + _tokenKeyCache.size;
        _tokenKeyCache.set(token, key);
    }
    return key;
}
/**
 * @param {?} view
 * @param {?} nodeIdx
 * @param {?} bindingIdx
 * @param {?} value
 * @return {?}
 */
function unwrapValue(view, nodeIdx, bindingIdx, value) {
    if (value instanceof WrappedValue) {
        value = value.wrapped;
        var /** @type {?} */ globalBindingIdx = view.def.nodes[nodeIdx].bindingIndex + bindingIdx;
        var /** @type {?} */ oldValue = view.oldValues[globalBindingIdx];
        if (oldValue instanceof WrappedValue) {
            oldValue = oldValue.wrapped;
        }
        view.oldValues[globalBindingIdx] = new WrappedValue(oldValue);
    }
    return value;
}
var UNDEFINED_RENDERER_TYPE_ID = '$$undefined';
var EMPTY_RENDERER_TYPE_ID = '$$empty';
/**
 * @param {?} values
 * @return {?}
 */
function createRendererType2(values) {
    return {
        id: UNDEFINED_RENDERER_TYPE_ID,
        styles: values.styles,
        encapsulation: values.encapsulation,
        data: values.data
    };
}
var _renderCompCount = 0;
/**
 * @param {?=} type
 * @return {?}
 */
function resolveRendererType2(type) {
    if (type && type.id === UNDEFINED_RENDERER_TYPE_ID) {
        // first time we see this RendererType2. Initialize it...
        var /** @type {?} */ isFilled = ((type.encapsulation != null && type.encapsulation !== ViewEncapsulation.None) ||
            type.styles.length || Object.keys(type.data).length);
        if (isFilled) {
            type.id = "c" + _renderCompCount++;
        }
        else {
            type.id = EMPTY_RENDERER_TYPE_ID;
        }
    }
    if (type && type.id === EMPTY_RENDERER_TYPE_ID) {
        type = null;
    }
    return type || null;
}
/**
 * @param {?} view
 * @param {?} def
 * @param {?} bindingIdx
 * @param {?} value
 * @return {?}
 */
function checkBinding(view, def, bindingIdx, value) {
    var /** @type {?} */ oldValues = view.oldValues;
    if ((view.state & 1 /* FirstCheck */) ||
        !looseIdentical(oldValues[def.bindingIndex + bindingIdx], value)) {
        return true;
    }
    return false;
}
/**
 * @param {?} view
 * @param {?} def
 * @param {?} bindingIdx
 * @param {?} value
 * @return {?}
 */
function checkAndUpdateBinding(view, def, bindingIdx, value) {
    if (checkBinding(view, def, bindingIdx, value)) {
        view.oldValues[def.bindingIndex + bindingIdx] = value;
        return true;
    }
    return false;
}
/**
 * @param {?} view
 * @param {?} def
 * @param {?} bindingIdx
 * @param {?} value
 * @return {?}
 */
function checkBindingNoChanges(view, def, bindingIdx, value) {
    var /** @type {?} */ oldValue = view.oldValues[def.bindingIndex + bindingIdx];
    if ((view.state & 1 /* FirstCheck */) || !devModeEqual(oldValue, value)) {
        throw expressionChangedAfterItHasBeenCheckedError(Services.createDebugContext(view, def.index), oldValue, value, (view.state & 1 /* FirstCheck */) !== 0);
    }
}
/**
 * @param {?} view
 * @return {?}
 */
function markParentViewsForCheck(view) {
    var /** @type {?} */ currView = view;
    while (currView) {
        if (currView.def.flags & 2 /* OnPush */) {
            currView.state |= 2 /* ChecksEnabled */;
        }
        currView = currView.viewContainerParent || currView.parent;
    }
}
/**
 * @param {?} view
 * @param {?} nodeIndex
 * @param {?} eventName
 * @param {?} event
 * @return {?}
 */
function dispatchEvent(view, nodeIndex, eventName, event) {
    var /** @type {?} */ nodeDef = view.def.nodes[nodeIndex];
    var /** @type {?} */ startView = nodeDef.flags & 16777216 /* ComponentView */ ? asElementData(view, nodeIndex).componentView : view;
    markParentViewsForCheck(startView);
    return Services.handleEvent(view, nodeIndex, eventName, event);
}
/**
 * @param {?} view
 * @return {?}
 */
function declaredViewContainer(view) {
    if (view.parent) {
        var /** @type {?} */ parentView = view.parent;
        return asElementData(parentView, /** @type {?} */ ((view.parentNodeDef)).index);
    }
    return null;
}
/**
 * for component views, this is the host element.
 * for embedded views, this is the index of the parent node
 * that contains the view container.
 * @param {?} view
 * @return {?}
 */
function viewParentEl(view) {
    var /** @type {?} */ parentView = view.parent;
    if (parentView) {
        return ((view.parentNodeDef)).parent;
    }
    else {
        return null;
    }
}
/**
 * @param {?} view
 * @param {?} def
 * @return {?}
 */
function renderNode(view, def) {
    switch (def.flags & 100673535 /* Types */) {
        case 1 /* TypeElement */:
            return asElementData(view, def.index).renderElement;
        case 2 /* TypeText */:
            return asTextData(view, def.index).renderText;
    }
}
/**
 * @param {?} target
 * @param {?} name
 * @return {?}
 */
function elementEventFullName(target, name) {
    return target ? target + ":" + name : name;
}
/**
 * @param {?} view
 * @return {?}
 */
function isComponentView(view) {
    return !!view.parent && !!(((view.parentNodeDef)).flags & 16384 /* Component */);
}
/**
 * @param {?} view
 * @return {?}
 */
function isEmbeddedView(view) {
    return !!view.parent && !(((view.parentNodeDef)).flags & 16384 /* Component */);
}
/**
 * @param {?} queryId
 * @return {?}
 */
function filterQueryId(queryId) {
    return 1 << (queryId % 32);
}
/**
 * @param {?} matchedQueriesDsl
 * @return {?}
 */
function splitMatchedQueriesDsl(matchedQueriesDsl) {
    var /** @type {?} */ matchedQueries = {};
    var /** @type {?} */ matchedQueryIds = 0;
    var /** @type {?} */ references = {};
    if (matchedQueriesDsl) {
        matchedQueriesDsl.forEach(function (_a) {
            var queryId = _a[0], valueType = _a[1];
            if (typeof queryId === 'number') {
                matchedQueries[queryId] = valueType;
                matchedQueryIds |= filterQueryId(queryId);
            }
            else {
                references[queryId] = valueType;
            }
        });
    }
    return { matchedQueries: matchedQueries, references: references, matchedQueryIds: matchedQueryIds };
}
/**
 * @param {?} view
 * @param {?} renderHost
 * @param {?} def
 * @return {?}
 */
function getParentRenderElement(view, renderHost, def) {
    var /** @type {?} */ renderParent = def.renderParent;
    if (renderParent) {
        if ((renderParent.flags & 1 /* TypeElement */) === 0 ||
            (renderParent.flags & 16777216 /* ComponentView */) === 0 ||
            (((renderParent.element)).componentRendererType && ((((renderParent.element)).componentRendererType)).encapsulation ===
                ViewEncapsulation.Native)) {
            // only children of non components, or children of components with native encapsulation should
            // be attached.
            return asElementData(view, /** @type {?} */ ((def.renderParent)).index).renderElement;
        }
    }
    else {
        return renderHost;
    }
}
var VIEW_DEFINITION_CACHE = new WeakMap();
/**
 * @param {?} factory
 * @return {?}
 */
function resolveViewDefinition(factory) {
    var /** @type {?} */ value = ((VIEW_DEFINITION_CACHE.get(factory)));
    if (!value) {
        value = factory(function () { return NOOP; });
        value.factory = factory;
        VIEW_DEFINITION_CACHE.set(factory, value);
    }
    return value;
}
/**
 * @param {?} view
 * @return {?}
 */
function rootRenderNodes(view) {
    var /** @type {?} */ renderNodes = [];
    visitRootRenderNodes(view, 0 /* Collect */, undefined, undefined, renderNodes);
    return renderNodes;
}
/**
 * @param {?} view
 * @param {?} action
 * @param {?} parentNode
 * @param {?} nextSibling
 * @param {?=} target
 * @return {?}
 */
function visitRootRenderNodes(view, action, parentNode, nextSibling, target) {
    // We need to re-compute the parent node in case the nodes have been moved around manually
    if (action === 3 /* RemoveChild */) {
        parentNode = view.renderer.parentNode(renderNode(view, /** @type {?} */ ((view.def.lastRenderRootNode))));
    }
    visitSiblingRenderNodes(view, action, 0, view.def.nodes.length - 1, parentNode, nextSibling, target);
}
/**
 * @param {?} view
 * @param {?} action
 * @param {?} startIndex
 * @param {?} endIndex
 * @param {?} parentNode
 * @param {?} nextSibling
 * @param {?=} target
 * @return {?}
 */
function visitSiblingRenderNodes(view, action, startIndex, endIndex, parentNode, nextSibling, target) {
    for (var /** @type {?} */ i = startIndex; i <= endIndex; i++) {
        var /** @type {?} */ nodeDef = view.def.nodes[i];
        if (nodeDef.flags & (1 /* TypeElement */ | 2 /* TypeText */ | 4 /* TypeNgContent */)) {
            visitRenderNode(view, nodeDef, action, parentNode, nextSibling, target);
        }
        // jump to next sibling
        i += nodeDef.childCount;
    }
}
/**
 * @param {?} view
 * @param {?} ngContentIndex
 * @param {?} action
 * @param {?} parentNode
 * @param {?} nextSibling
 * @param {?=} target
 * @return {?}
 */
function visitProjectedRenderNodes(view, ngContentIndex, action, parentNode, nextSibling, target) {
    var /** @type {?} */ compView = view;
    while (compView && !isComponentView(compView)) {
        compView = compView.parent;
    }
    var /** @type {?} */ hostView = ((compView)).parent;
    var /** @type {?} */ hostElDef = viewParentEl(/** @type {?} */ ((compView)));
    var /** @type {?} */ startIndex = ((hostElDef)).index + 1;
    var /** @type {?} */ endIndex = ((hostElDef)).index + ((hostElDef)).childCount;
    for (var /** @type {?} */ i = startIndex; i <= endIndex; i++) {
        var /** @type {?} */ nodeDef = ((hostView)).def.nodes[i];
        if (nodeDef.ngContentIndex === ngContentIndex) {
            visitRenderNode(/** @type {?} */ ((hostView)), nodeDef, action, parentNode, nextSibling, target);
        }
        // jump to next sibling
        i += nodeDef.childCount;
    }
    if (!((hostView)).parent) {
        // a root view
        var /** @type {?} */ projectedNodes = view.root.projectableNodes[ngContentIndex];
        if (projectedNodes) {
            for (var /** @type {?} */ i = 0; i < projectedNodes.length; i++) {
                execRenderNodeAction(view, projectedNodes[i], action, parentNode, nextSibling, target);
            }
        }
    }
}
/**
 * @param {?} view
 * @param {?} nodeDef
 * @param {?} action
 * @param {?} parentNode
 * @param {?} nextSibling
 * @param {?=} target
 * @return {?}
 */
function visitRenderNode(view, nodeDef, action, parentNode, nextSibling, target) {
    if (nodeDef.flags & 4 /* TypeNgContent */) {
        visitProjectedRenderNodes(view, /** @type {?} */ ((nodeDef.ngContent)).index, action, parentNode, nextSibling, target);
    }
    else {
        var /** @type {?} */ rn = renderNode(view, nodeDef);
        if (action === 3 /* RemoveChild */ && (nodeDef.flags & 16777216 /* ComponentView */) &&
            (nodeDef.bindingFlags & 48 /* CatSyntheticProperty */)) {
            // Note: we might need to do both actions.
            if (nodeDef.bindingFlags & (16 /* SyntheticProperty */)) {
                execRenderNodeAction(view, rn, action, parentNode, nextSibling, target);
            }
            if (nodeDef.bindingFlags & (32 /* SyntheticHostProperty */)) {
                var /** @type {?} */ compView = asElementData(view, nodeDef.index).componentView;
                execRenderNodeAction(compView, rn, action, parentNode, nextSibling, target);
            }
        }
        else {
            execRenderNodeAction(view, rn, action, parentNode, nextSibling, target);
        }
        if (nodeDef.flags & 8388608 /* EmbeddedViews */) {
            var /** @type {?} */ embeddedViews = ((asElementData(view, nodeDef.index).viewContainer))._embeddedViews;
            for (var /** @type {?} */ k = 0; k < embeddedViews.length; k++) {
                visitRootRenderNodes(embeddedViews[k], action, parentNode, nextSibling, target);
            }
        }
        if (nodeDef.flags & 1 /* TypeElement */ && !((nodeDef.element)).name) {
            visitSiblingRenderNodes(view, action, nodeDef.index + 1, nodeDef.index + nodeDef.childCount, parentNode, nextSibling, target);
        }
    }
}
/**
 * @param {?} view
 * @param {?} renderNode
 * @param {?} action
 * @param {?} parentNode
 * @param {?} nextSibling
 * @param {?=} target
 * @return {?}
 */
function execRenderNodeAction(view, renderNode, action, parentNode, nextSibling, target) {
    var /** @type {?} */ renderer = view.renderer;
    switch (action) {
        case 1 /* AppendChild */:
            renderer.appendChild(parentNode, renderNode);
            break;
        case 2 /* InsertBefore */:
            renderer.insertBefore(parentNode, renderNode, nextSibling);
            break;
        case 3 /* RemoveChild */:
            renderer.removeChild(parentNode, renderNode);
            break;
        case 0 /* Collect */:
            ((target)).push(renderNode);
            break;
    }
}
var NS_PREFIX_RE = /^:([^:]+):(.+)$/;
/**
 * @param {?} name
 * @return {?}
 */
function splitNamespace(name) {
    if (name[0] === ':') {
        var /** @type {?} */ match = ((name.match(NS_PREFIX_RE)));
        return [match[1], match[2]];
    }
    return ['', name];
}
/**
 * @param {?} bindings
 * @return {?}
 */
function calcBindingFlags(bindings) {
    var /** @type {?} */ flags = 0;
    for (var /** @type {?} */ i = 0; i < bindings.length; i++) {
        flags |= bindings[i].flags;
    }
    return flags;
}
/**
 * @param {?} valueCount
 * @param {?} constAndInterp
 * @return {?}
 */
function interpolate(valueCount, constAndInterp) {
    var /** @type {?} */ result = '';
    for (var /** @type {?} */ i = 0; i < valueCount * 2; i = i + 2) {
        result = result + constAndInterp[i] + _toStringWithNull(constAndInterp[i + 1]);
    }
    return result + constAndInterp[valueCount * 2];
}
/**
 * @param {?} valueCount
 * @param {?} c0
 * @param {?} a1
 * @param {?} c1
 * @param {?=} a2
 * @param {?=} c2
 * @param {?=} a3
 * @param {?=} c3
 * @param {?=} a4
 * @param {?=} c4
 * @param {?=} a5
 * @param {?=} c5
 * @param {?=} a6
 * @param {?=} c6
 * @param {?=} a7
 * @param {?=} c7
 * @param {?=} a8
 * @param {?=} c8
 * @param {?=} a9
 * @param {?=} c9
 * @return {?}
 */
function inlineInterpolate(valueCount, c0, a1, c1, a2, c2, a3, c3, a4, c4, a5, c5, a6, c6, a7, c7, a8, c8, a9, c9) {
    switch (valueCount) {
        case 1:
            return c0 + _toStringWithNull(a1) + c1;
        case 2:
            return c0 + _toStringWithNull(a1) + c1 + _toStringWithNull(a2) + c2;
        case 3:
            return c0 + _toStringWithNull(a1) + c1 + _toStringWithNull(a2) + c2 + _toStringWithNull(a3) +
                c3;
        case 4:
            return c0 + _toStringWithNull(a1) + c1 + _toStringWithNull(a2) + c2 + _toStringWithNull(a3) +
                c3 + _toStringWithNull(a4) + c4;
        case 5:
            return c0 + _toStringWithNull(a1) + c1 + _toStringWithNull(a2) + c2 + _toStringWithNull(a3) +
                c3 + _toStringWithNull(a4) + c4 + _toStringWithNull(a5) + c5;
        case 6:
            return c0 + _toStringWithNull(a1) + c1 + _toStringWithNull(a2) + c2 + _toStringWithNull(a3) +
                c3 + _toStringWithNull(a4) + c4 + _toStringWithNull(a5) + c5 + _toStringWithNull(a6) + c6;
        case 7:
            return c0 + _toStringWithNull(a1) + c1 + _toStringWithNull(a2) + c2 + _toStringWithNull(a3) +
                c3 + _toStringWithNull(a4) + c4 + _toStringWithNull(a5) + c5 + _toStringWithNull(a6) +
                c6 + _toStringWithNull(a7) + c7;
        case 8:
            return c0 + _toStringWithNull(a1) + c1 + _toStringWithNull(a2) + c2 + _toStringWithNull(a3) +
                c3 + _toStringWithNull(a4) + c4 + _toStringWithNull(a5) + c5 + _toStringWithNull(a6) +
                c6 + _toStringWithNull(a7) + c7 + _toStringWithNull(a8) + c8;
        case 9:
            return c0 + _toStringWithNull(a1) + c1 + _toStringWithNull(a2) + c2 + _toStringWithNull(a3) +
                c3 + _toStringWithNull(a4) + c4 + _toStringWithNull(a5) + c5 + _toStringWithNull(a6) +
                c6 + _toStringWithNull(a7) + c7 + _toStringWithNull(a8) + c8 + _toStringWithNull(a9) + c9;
        default:
            throw new Error("Does not support more than 9 expressions");
    }
}
/**
 * @param {?} v
 * @return {?}
 */
function _toStringWithNull(v) {
    return v != null ? v.toString() : '';
}
var EMPTY_ARRAY = [];
var EMPTY_MAP = {};
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @param {?} flags
 * @param {?} matchedQueriesDsl
 * @param {?} ngContentIndex
 * @param {?} childCount
 * @param {?=} handleEvent
 * @param {?=} templateFactory
 * @return {?}
 */
function anchorDef(flags, matchedQueriesDsl, ngContentIndex, childCount, handleEvent, templateFactory) {
    flags |= 1 /* TypeElement */;
    var _a = splitMatchedQueriesDsl(matchedQueriesDsl), matchedQueries = _a.matchedQueries, references = _a.references, matchedQueryIds = _a.matchedQueryIds;
    var /** @type {?} */ template = templateFactory ? resolveViewDefinition(templateFactory) : null;
    return {
        // will bet set by the view definition
        index: -1,
        parent: null,
        renderParent: null,
        bindingIndex: -1,
        outputIndex: -1,
        // regular values
        flags: flags,
        childFlags: 0,
        directChildFlags: 0,
        childMatchedQueries: 0, matchedQueries: matchedQueries, matchedQueryIds: matchedQueryIds, references: references, ngContentIndex: ngContentIndex, childCount: childCount,
        bindings: [],
        bindingFlags: 0,
        outputs: [],
        element: {
            ns: null,
            name: null,
            attrs: null, template: template,
            componentProvider: null,
            componentView: null,
            componentRendererType: null,
            publicProviders: null,
            allProviders: null,
            handleEvent: handleEvent || NOOP
        },
        provider: null,
        text: null,
        query: null,
        ngContent: null
    };
}
/**
 * @param {?} flags
 * @param {?} matchedQueriesDsl
 * @param {?} ngContentIndex
 * @param {?} childCount
 * @param {?} namespaceAndName
 * @param {?=} fixedAttrs
 * @param {?=} bindings
 * @param {?=} outputs
 * @param {?=} handleEvent
 * @param {?=} componentView
 * @param {?=} componentRendererType
 * @return {?}
 */
function elementDef(flags, matchedQueriesDsl, ngContentIndex, childCount, namespaceAndName, fixedAttrs, bindings, outputs, handleEvent, componentView, componentRendererType) {
    if (fixedAttrs === void 0) { fixedAttrs = []; }
    if (!handleEvent) {
        handleEvent = NOOP;
    }
    var _a = splitMatchedQueriesDsl(matchedQueriesDsl), matchedQueries = _a.matchedQueries, references = _a.references, matchedQueryIds = _a.matchedQueryIds;
    var /** @type {?} */ ns = ((null));
    var /** @type {?} */ name = ((null));
    if (namespaceAndName) {
        _b = splitNamespace(namespaceAndName), ns = _b[0], name = _b[1];
    }
    bindings = bindings || [];
    var /** @type {?} */ bindingDefs = new Array(bindings.length);
    for (var /** @type {?} */ i = 0; i < bindings.length; i++) {
        var _c = bindings[i], bindingFlags = _c[0], namespaceAndName_1 = _c[1], suffixOrSecurityContext = _c[2];
        var _d = splitNamespace(namespaceAndName_1), ns_1 = _d[0], name_1 = _d[1];
        var /** @type {?} */ securityContext = ((undefined));
        var /** @type {?} */ suffix = ((undefined));
        switch (bindingFlags & 15 /* Types */) {
            case 4 /* TypeElementStyle */:
                suffix = (suffixOrSecurityContext);
                break;
            case 1 /* TypeElementAttribute */:
            case 8 /* TypeProperty */:
                securityContext = (suffixOrSecurityContext);
                break;
        }
        bindingDefs[i] =
            { flags: bindingFlags, ns: ns_1, name: name_1, nonMinifiedName: name_1, securityContext: securityContext, suffix: suffix };
    }
    outputs = outputs || [];
    var /** @type {?} */ outputDefs = new Array(outputs.length);
    for (var /** @type {?} */ i = 0; i < outputs.length; i++) {
        var _e = outputs[i], target = _e[0], eventName = _e[1];
        outputDefs[i] = {
            type: 0 /* ElementOutput */,
            target: /** @type {?} */ (target), eventName: eventName,
            propName: null
        };
    }
    fixedAttrs = fixedAttrs || [];
    var /** @type {?} */ attrs = (fixedAttrs.map(function (_a) {
        var namespaceAndName = _a[0], value = _a[1];
        var _b = splitNamespace(namespaceAndName), ns = _b[0], name = _b[1];
        return [ns, name, value];
    }));
    componentRendererType = resolveRendererType2(componentRendererType);
    if (componentView) {
        flags |= 16777216 /* ComponentView */;
    }
    flags |= 1 /* TypeElement */;
    return {
        // will bet set by the view definition
        index: -1,
        parent: null,
        renderParent: null,
        bindingIndex: -1,
        outputIndex: -1,
        // regular values
        flags: flags,
        childFlags: 0,
        directChildFlags: 0,
        childMatchedQueries: 0, matchedQueries: matchedQueries, matchedQueryIds: matchedQueryIds, references: references, ngContentIndex: ngContentIndex, childCount: childCount,
        bindings: bindingDefs,
        bindingFlags: calcBindingFlags(bindingDefs),
        outputs: outputDefs,
        element: {
            ns: ns,
            name: name,
            attrs: attrs,
            template: null,
            // will bet set by the view definition
            componentProvider: null,
            componentView: componentView || null,
            componentRendererType: componentRendererType,
            publicProviders: null,
            allProviders: null,
            handleEvent: handleEvent || NOOP,
        },
        provider: null,
        text: null,
        query: null,
        ngContent: null
    };
    var _b;
}
/**
 * @param {?} view
 * @param {?} renderHost
 * @param {?} def
 * @return {?}
 */
function createElement(view, renderHost, def) {
    var /** @type {?} */ elDef = ((def.element));
    var /** @type {?} */ rootSelectorOrNode = view.root.selectorOrNode;
    var /** @type {?} */ renderer = view.renderer;
    var /** @type {?} */ el;
    if (view.parent || !rootSelectorOrNode) {
        if (elDef.name) {
            el = renderer.createElement(elDef.name, elDef.ns);
        }
        else {
            el = renderer.createComment('');
        }
        var /** @type {?} */ parentEl = getParentRenderElement(view, renderHost, def);
        if (parentEl) {
            renderer.appendChild(parentEl, el);
        }
    }
    else {
        el = renderer.selectRootElement(rootSelectorOrNode);
    }
    if (elDef.attrs) {
        for (var /** @type {?} */ i = 0; i < elDef.attrs.length; i++) {
            var _a = elDef.attrs[i], ns = _a[0], name = _a[1], value = _a[2];
            renderer.setAttribute(el, name, value, ns);
        }
    }
    return el;
}
/**
 * @param {?} view
 * @param {?} compView
 * @param {?} def
 * @param {?} el
 * @return {?}
 */
function listenToElementOutputs(view, compView, def, el) {
    for (var /** @type {?} */ i = 0; i < def.outputs.length; i++) {
        var /** @type {?} */ output = def.outputs[i];
        var /** @type {?} */ handleEventClosure = renderEventHandlerClosure(view, def.index, elementEventFullName(output.target, output.eventName));
        var /** @type {?} */ listenTarget = output.target;
        var /** @type {?} */ listenerView = view;
        if (output.target === 'component') {
            listenTarget = null;
            listenerView = compView;
        }
        var /** @type {?} */ disposable = (listenerView.renderer.listen(listenTarget || el, output.eventName, handleEventClosure)); /** @type {?} */
        ((view.disposables))[def.outputIndex + i] = disposable;
    }
}
/**
 * @param {?} view
 * @param {?} index
 * @param {?} eventName
 * @return {?}
 */
function renderEventHandlerClosure(view, index, eventName) {
    return function (event) { return dispatchEvent(view, index, eventName, event); };
}
/**
 * @param {?} view
 * @param {?} def
 * @param {?} v0
 * @param {?} v1
 * @param {?} v2
 * @param {?} v3
 * @param {?} v4
 * @param {?} v5
 * @param {?} v6
 * @param {?} v7
 * @param {?} v8
 * @param {?} v9
 * @return {?}
 */
function checkAndUpdateElementInline(view, def, v0, v1, v2, v3, v4, v5, v6, v7, v8, v9) {
    var /** @type {?} */ bindLen = def.bindings.length;
    var /** @type {?} */ changed = false;
    if (bindLen > 0 && checkAndUpdateElementValue(view, def, 0, v0))
        changed = true;
    if (bindLen > 1 && checkAndUpdateElementValue(view, def, 1, v1))
        changed = true;
    if (bindLen > 2 && checkAndUpdateElementValue(view, def, 2, v2))
        changed = true;
    if (bindLen > 3 && checkAndUpdateElementValue(view, def, 3, v3))
        changed = true;
    if (bindLen > 4 && checkAndUpdateElementValue(view, def, 4, v4))
        changed = true;
    if (bindLen > 5 && checkAndUpdateElementValue(view, def, 5, v5))
        changed = true;
    if (bindLen > 6 && checkAndUpdateElementValue(view, def, 6, v6))
        changed = true;
    if (bindLen > 7 && checkAndUpdateElementValue(view, def, 7, v7))
        changed = true;
    if (bindLen > 8 && checkAndUpdateElementValue(view, def, 8, v8))
        changed = true;
    if (bindLen > 9 && checkAndUpdateElementValue(view, def, 9, v9))
        changed = true;
    return changed;
}
/**
 * @param {?} view
 * @param {?} def
 * @param {?} values
 * @return {?}
 */
function checkAndUpdateElementDynamic(view, def, values) {
    var /** @type {?} */ changed = false;
    for (var /** @type {?} */ i = 0; i < values.length; i++) {
        if (checkAndUpdateElementValue(view, def, i, values[i]))
            changed = true;
    }
    return changed;
}
/**
 * @param {?} view
 * @param {?} def
 * @param {?} bindingIdx
 * @param {?} value
 * @return {?}
 */
function checkAndUpdateElementValue(view, def, bindingIdx, value) {
    if (!checkAndUpdateBinding(view, def, bindingIdx, value)) {
        return false;
    }
    var /** @type {?} */ binding = def.bindings[bindingIdx];
    var /** @type {?} */ elData = asElementData(view, def.index);
    var /** @type {?} */ renderNode$$1 = elData.renderElement;
    var /** @type {?} */ name = ((binding.name));
    switch (binding.flags & 15 /* Types */) {
        case 1 /* TypeElementAttribute */:
            setElementAttribute(view, binding, renderNode$$1, binding.ns, name, value);
            break;
        case 2 /* TypeElementClass */:
            setElementClass(view, renderNode$$1, name, value);
            break;
        case 4 /* TypeElementStyle */:
            setElementStyle(view, binding, renderNode$$1, name, value);
            break;
        case 8 /* TypeProperty */:
            var /** @type {?} */ bindView = (def.flags & 16777216 /* ComponentView */ &&
                binding.flags & 32 /* SyntheticHostProperty */) ?
                elData.componentView :
                view;
            setElementProperty(bindView, binding, renderNode$$1, name, value);
            break;
    }
    return true;
}
/**
 * @param {?} view
 * @param {?} binding
 * @param {?} renderNode
 * @param {?} ns
 * @param {?} name
 * @param {?} value
 * @return {?}
 */
function setElementAttribute(view, binding, renderNode$$1, ns, name, value) {
    var /** @type {?} */ securityContext = binding.securityContext;
    var /** @type {?} */ renderValue = securityContext ? view.root.sanitizer.sanitize(securityContext, value) : value;
    renderValue = renderValue != null ? renderValue.toString() : null;
    var /** @type {?} */ renderer = view.renderer;
    if (value != null) {
        renderer.setAttribute(renderNode$$1, name, renderValue, ns);
    }
    else {
        renderer.removeAttribute(renderNode$$1, name, ns);
    }
}
/**
 * @param {?} view
 * @param {?} renderNode
 * @param {?} name
 * @param {?} value
 * @return {?}
 */
function setElementClass(view, renderNode$$1, name, value) {
    var /** @type {?} */ renderer = view.renderer;
    if (value) {
        renderer.addClass(renderNode$$1, name);
    }
    else {
        renderer.removeClass(renderNode$$1, name);
    }
}
/**
 * @param {?} view
 * @param {?} binding
 * @param {?} renderNode
 * @param {?} name
 * @param {?} value
 * @return {?}
 */
function setElementStyle(view, binding, renderNode$$1, name, value) {
    var /** @type {?} */ renderValue = view.root.sanitizer.sanitize(SecurityContext.STYLE, /** @type {?} */ (value));
    if (renderValue != null) {
        renderValue = renderValue.toString();
        var /** @type {?} */ unit = binding.suffix;
        if (unit != null) {
            renderValue = renderValue + unit;
        }
    }
    else {
        renderValue = null;
    }
    var /** @type {?} */ renderer = view.renderer;
    if (renderValue != null) {
        renderer.setStyle(renderNode$$1, name, renderValue);
    }
    else {
        renderer.removeStyle(renderNode$$1, name);
    }
}
/**
 * @param {?} view
 * @param {?} binding
 * @param {?} renderNode
 * @param {?} name
 * @param {?} value
 * @return {?}
 */
function setElementProperty(view, binding, renderNode$$1, name, value) {
    var /** @type {?} */ securityContext = binding.securityContext;
    var /** @type {?} */ renderValue = securityContext ? view.root.sanitizer.sanitize(securityContext, value) : value;
    view.renderer.setProperty(renderNode$$1, name, renderValue);
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @param {?} ngContentIndex
 * @param {?} index
 * @return {?}
 */
function ngContentDef(ngContentIndex, index) {
    return {
        // will bet set by the view definition
        index: -1,
        parent: null,
        renderParent: null,
        bindingIndex: -1,
        outputIndex: -1,
        // regular values
        flags: 4 /* TypeNgContent */,
        childFlags: 0,
        directChildFlags: 0,
        childMatchedQueries: 0,
        matchedQueries: {},
        matchedQueryIds: 0,
        references: {}, ngContentIndex: ngContentIndex,
        childCount: 0,
        bindings: [],
        bindingFlags: 0,
        outputs: [],
        element: null,
        provider: null,
        text: null,
        query: null,
        ngContent: { index: index }
    };
}
/**
 * @param {?} view
 * @param {?} renderHost
 * @param {?} def
 * @return {?}
 */
function appendNgContent(view, renderHost, def) {
    var /** @type {?} */ parentEl = getParentRenderElement(view, renderHost, def);
    if (!parentEl) {
        // Nothing to do if there is no parent element.
        return;
    }
    var /** @type {?} */ ngContentIndex = ((def.ngContent)).index;
    visitProjectedRenderNodes(view, ngContentIndex, 1 /* AppendChild */, parentEl, null, undefined);
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @param {?} parentView
 * @param {?} elementData
 * @param {?} viewIndex
 * @param {?} view
 * @return {?}
 */
function attachEmbeddedView(parentView, elementData, viewIndex, view) {
    var /** @type {?} */ embeddedViews = ((elementData.viewContainer))._embeddedViews;
    if (viewIndex === null || viewIndex === undefined) {
        viewIndex = embeddedViews.length;
    }
    view.viewContainerParent = parentView;
    addToArray(embeddedViews, /** @type {?} */ ((viewIndex)), view);
    var /** @type {?} */ dvcElementData = declaredViewContainer(view);
    if (dvcElementData && dvcElementData !== elementData) {
        var /** @type {?} */ projectedViews = dvcElementData.template._projectedViews;
        if (!projectedViews) {
            projectedViews = dvcElementData.template._projectedViews = [];
        }
        projectedViews.push(view);
    }
    Services.dirtyParentQueries(view);
    var /** @type {?} */ prevView = ((viewIndex)) > 0 ? embeddedViews[((viewIndex)) - 1] : null;
    renderAttachEmbeddedView(elementData, prevView, view);
}
/**
 * @param {?} elementData
 * @param {?=} viewIndex
 * @return {?}
 */
function detachEmbeddedView(elementData, viewIndex) {
    var /** @type {?} */ embeddedViews = ((elementData.viewContainer))._embeddedViews;
    if (viewIndex == null || viewIndex >= embeddedViews.length) {
        viewIndex = embeddedViews.length - 1;
    }
    if (viewIndex < 0) {
        return null;
    }
    var /** @type {?} */ view = embeddedViews[viewIndex];
    view.viewContainerParent = null;
    removeFromArray(embeddedViews, viewIndex);
    var /** @type {?} */ dvcElementData = declaredViewContainer(view);
    if (dvcElementData && dvcElementData !== elementData) {
        var /** @type {?} */ projectedViews = dvcElementData.template._projectedViews;
        removeFromArray(projectedViews, projectedViews.indexOf(view));
    }
    Services.dirtyParentQueries(view);
    renderDetachView(view);
    return view;
}
/**
 * @param {?} elementData
 * @param {?} oldViewIndex
 * @param {?} newViewIndex
 * @return {?}
 */
function moveEmbeddedView(elementData, oldViewIndex, newViewIndex) {
    var /** @type {?} */ embeddedViews = ((elementData.viewContainer))._embeddedViews;
    var /** @type {?} */ view = embeddedViews[oldViewIndex];
    removeFromArray(embeddedViews, oldViewIndex);
    if (newViewIndex == null) {
        newViewIndex = embeddedViews.length;
    }
    addToArray(embeddedViews, newViewIndex, view);
    // Note: Don't need to change projectedViews as the order in there
    // as always invalid...
    Services.dirtyParentQueries(view);
    renderDetachView(view);
    var /** @type {?} */ prevView = newViewIndex > 0 ? embeddedViews[newViewIndex - 1] : null;
    renderAttachEmbeddedView(elementData, prevView, view);
    return view;
}
/**
 * @param {?} elementData
 * @param {?} prevView
 * @param {?} view
 * @return {?}
 */
function renderAttachEmbeddedView(elementData, prevView, view) {
    var /** @type {?} */ prevRenderNode = prevView ? renderNode(prevView, /** @type {?} */ ((prevView.def.lastRenderRootNode))) :
        elementData.renderElement;
    var /** @type {?} */ parentNode = view.renderer.parentNode(prevRenderNode);
    var /** @type {?} */ nextSibling = view.renderer.nextSibling(prevRenderNode);
    // Note: We can't check if `nextSibling` is present, as on WebWorkers it will always be!
    // However, browsers automatically do `appendChild` when there is no `nextSibling`.
    visitRootRenderNodes(view, 2 /* InsertBefore */, parentNode, nextSibling, undefined);
}
/**
 * @param {?} view
 * @return {?}
 */
function renderDetachView(view) {
    visitRootRenderNodes(view, 3 /* RemoveChild */, null, null, undefined);
}
/**
 * @param {?} arr
 * @param {?} index
 * @param {?} value
 * @return {?}
 */
function addToArray(arr, index, value) {
    // perf: array.push is faster than array.splice!
    if (index >= arr.length) {
        arr.push(value);
    }
    else {
        arr.splice(index, 0, value);
    }
}
/**
 * @param {?} arr
 * @param {?} index
 * @return {?}
 */
function removeFromArray(arr, index) {
    // perf: array.pop is faster than array.splice!
    if (index >= arr.length - 1) {
        arr.pop();
    }
    else {
        arr.splice(index, 1);
    }
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var EMPTY_CONTEXT = new Object();
/**
 * @param {?} selector
 * @param {?} componentType
 * @param {?} viewDefFactory
 * @param {?} inputs
 * @param {?} outputs
 * @param {?} ngContentSelectors
 * @return {?}
 */
function createComponentFactory(selector, componentType, viewDefFactory, inputs, outputs, ngContentSelectors) {
    return new ComponentFactory_(selector, componentType, viewDefFactory, inputs, outputs, ngContentSelectors);
}
/**
 * @param {?} componentFactory
 * @return {?}
 */
function getComponentViewDefinitionFactory(componentFactory) {
    return ((componentFactory)).viewDefFactory;
}
var ComponentFactory_ = (function (_super) {
    __extends(ComponentFactory_, _super);
    /**
     * @param {?} selector
     * @param {?} componentType
     * @param {?} viewDefFactory
     * @param {?} _inputs
     * @param {?} _outputs
     * @param {?} ngContentSelectors
     */
    function ComponentFactory_(selector, componentType, viewDefFactory, _inputs, _outputs, ngContentSelectors) {
        var _this = 
        // Attention: this ctor is called as top level function.
        // Putting any logic in here will destroy closure tree shaking!
        _super.call(this) || this;
        _this.selector = selector;
        _this.componentType = componentType;
        _this._inputs = _inputs;
        _this._outputs = _outputs;
        _this.ngContentSelectors = ngContentSelectors;
        _this.viewDefFactory = viewDefFactory;
        return _this;
    }
    Object.defineProperty(ComponentFactory_.prototype, "inputs", {
        /**
         * @return {?}
         */
        get: function () {
            var /** @type {?} */ inputsArr = [];
            var /** @type {?} */ inputs = ((this._inputs));
            for (var /** @type {?} */ propName in inputs) {
                var /** @type {?} */ templateName = inputs[propName];
                inputsArr.push({ propName: propName, templateName: templateName });
            }
            return inputsArr;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComponentFactory_.prototype, "outputs", {
        /**
         * @return {?}
         */
        get: function () {
            var /** @type {?} */ outputsArr = [];
            for (var /** @type {?} */ propName in this._outputs) {
                var /** @type {?} */ templateName = this._outputs[propName];
                outputsArr.push({ propName: propName, templateName: templateName });
            }
            return outputsArr;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Creates a new component.
     * @param {?} injector
     * @param {?=} projectableNodes
     * @param {?=} rootSelectorOrNode
     * @param {?=} ngModule
     * @return {?}
     */
    ComponentFactory_.prototype.create = function (injector, projectableNodes, rootSelectorOrNode, ngModule) {
        if (!ngModule) {
            throw new Error('ngModule should be provided');
        }
        var /** @type {?} */ viewDef = resolveViewDefinition(this.viewDefFactory);
        var /** @type {?} */ componentNodeIndex = ((((viewDef.nodes[0].element)).componentProvider)).index;
        var /** @type {?} */ view = Services.createRootView(injector, projectableNodes || [], rootSelectorOrNode, viewDef, ngModule, EMPTY_CONTEXT);
        var /** @type {?} */ component = asProviderData(view, componentNodeIndex).instance;
        view.renderer.setAttribute(asElementData(view, 0).renderElement, 'ng-version', VERSION.full);
        return new ComponentRef_(view, new ViewRef_(view), component);
    };
    return ComponentFactory_;
}(ComponentFactory));
var ComponentRef_ = (function (_super) {
    __extends(ComponentRef_, _super);
    /**
     * @param {?} _view
     * @param {?} _viewRef
     * @param {?} _component
     */
    function ComponentRef_(_view, _viewRef, _component) {
        var _this = _super.call(this) || this;
        _this._view = _view;
        _this._viewRef = _viewRef;
        _this._component = _component;
        _this._elDef = _this._view.def.nodes[0];
        return _this;
    }
    Object.defineProperty(ComponentRef_.prototype, "location", {
        /**
         * @return {?}
         */
        get: function () {
            return new ElementRef(asElementData(this._view, this._elDef.index).renderElement);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComponentRef_.prototype, "injector", {
        /**
         * @return {?}
         */
        get: function () { return new Injector_(this._view, this._elDef); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ComponentRef_.prototype, "instance", {
        /**
         * @return {?}
         */
        get: function () { return this._component; },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(ComponentRef_.prototype, "hostView", {
        /**
         * @return {?}
         */
        get: function () { return this._viewRef; },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(ComponentRef_.prototype, "changeDetectorRef", {
        /**
         * @return {?}
         */
        get: function () { return this._viewRef; },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(ComponentRef_.prototype, "componentType", {
        /**
         * @return {?}
         */
        get: function () { return (this._component.constructor); },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    ComponentRef_.prototype.destroy = function () { this._viewRef.destroy(); };
    /**
     * @param {?} callback
     * @return {?}
     */
    ComponentRef_.prototype.onDestroy = function (callback) { this._viewRef.onDestroy(callback); };
    return ComponentRef_;
}(ComponentRef));
/**
 * @param {?} view
 * @param {?} elDef
 * @param {?} elData
 * @return {?}
 */
function createViewContainerData(view, elDef, elData) {
    return new ViewContainerRef_(view, elDef, elData);
}
var ViewContainerRef_ = (function () {
    /**
     * @param {?} _view
     * @param {?} _elDef
     * @param {?} _data
     */
    function ViewContainerRef_(_view, _elDef, _data) {
        this._view = _view;
        this._elDef = _elDef;
        this._data = _data;
        /**
         * \@internal
         */
        this._embeddedViews = [];
    }
    Object.defineProperty(ViewContainerRef_.prototype, "element", {
        /**
         * @return {?}
         */
        get: function () { return new ElementRef(this._data.renderElement); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ViewContainerRef_.prototype, "injector", {
        /**
         * @return {?}
         */
        get: function () { return new Injector_(this._view, this._elDef); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ViewContainerRef_.prototype, "parentInjector", {
        /**
         * @return {?}
         */
        get: function () {
            var /** @type {?} */ view = this._view;
            var /** @type {?} */ elDef = this._elDef.parent;
            while (!elDef && view) {
                elDef = viewParentEl(view);
                view = ((view.parent));
            }
            return view ? new Injector_(view, elDef) : new Injector_(this._view, null);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    ViewContainerRef_.prototype.clear = function () {
        var /** @type {?} */ len = this._embeddedViews.length;
        for (var /** @type {?} */ i = len - 1; i >= 0; i--) {
            var /** @type {?} */ view = ((detachEmbeddedView(this._data, i)));
            Services.destroyView(view);
        }
    };
    /**
     * @param {?} index
     * @return {?}
     */
    ViewContainerRef_.prototype.get = function (index) {
        var /** @type {?} */ view = this._embeddedViews[index];
        if (view) {
            var /** @type {?} */ ref = new ViewRef_(view);
            ref.attachToViewContainerRef(this);
            return ref;
        }
        return null;
    };
    Object.defineProperty(ViewContainerRef_.prototype, "length", {
        /**
         * @return {?}
         */
        get: function () { return this._embeddedViews.length; },
        enumerable: true,
        configurable: true
    });
    ;
    /**
     * @template C
     * @param {?} templateRef
     * @param {?=} context
     * @param {?=} index
     * @return {?}
     */
    ViewContainerRef_.prototype.createEmbeddedView = function (templateRef, context, index) {
        var /** @type {?} */ viewRef = templateRef.createEmbeddedView(context || ({}));
        this.insert(viewRef, index);
        return viewRef;
    };
    /**
     * @template C
     * @param {?} componentFactory
     * @param {?=} index
     * @param {?=} injector
     * @param {?=} projectableNodes
     * @param {?=} ngModuleRef
     * @return {?}
     */
    ViewContainerRef_.prototype.createComponent = function (componentFactory, index, injector, projectableNodes, ngModuleRef) {
        var /** @type {?} */ contextInjector = injector || this.parentInjector;
        if (!ngModuleRef && !(componentFactory instanceof ComponentFactoryBoundToModule)) {
            ngModuleRef = contextInjector.get(NgModuleRef);
        }
        var /** @type {?} */ componentRef = componentFactory.create(contextInjector, projectableNodes, undefined, ngModuleRef);
        this.insert(componentRef.hostView, index);
        return componentRef;
    };
    /**
     * @param {?} viewRef
     * @param {?=} index
     * @return {?}
     */
    ViewContainerRef_.prototype.insert = function (viewRef, index) {
        var /** @type {?} */ viewRef_ = (viewRef);
        var /** @type {?} */ viewData = viewRef_._view;
        attachEmbeddedView(this._view, this._data, index, viewData);
        viewRef_.attachToViewContainerRef(this);
        return viewRef;
    };
    /**
     * @param {?} viewRef
     * @param {?} currentIndex
     * @return {?}
     */
    ViewContainerRef_.prototype.move = function (viewRef, currentIndex) {
        var /** @type {?} */ previousIndex = this._embeddedViews.indexOf(viewRef._view);
        moveEmbeddedView(this._data, previousIndex, currentIndex);
        return viewRef;
    };
    /**
     * @param {?} viewRef
     * @return {?}
     */
    ViewContainerRef_.prototype.indexOf = function (viewRef) {
        return this._embeddedViews.indexOf(((viewRef))._view);
    };
    /**
     * @param {?=} index
     * @return {?}
     */
    ViewContainerRef_.prototype.remove = function (index) {
        var /** @type {?} */ viewData = detachEmbeddedView(this._data, index);
        if (viewData) {
            Services.destroyView(viewData);
        }
    };
    /**
     * @param {?=} index
     * @return {?}
     */
    ViewContainerRef_.prototype.detach = function (index) {
        var /** @type {?} */ view = detachEmbeddedView(this._data, index);
        return view ? new ViewRef_(view) : null;
    };
    return ViewContainerRef_;
}());
/**
 * @param {?} view
 * @return {?}
 */
function createChangeDetectorRef(view) {
    return new ViewRef_(view);
}
var ViewRef_ = (function () {
    /**
     * @param {?} _view
     */
    function ViewRef_(_view) {
        this._view = _view;
        this._viewContainerRef = null;
        this._appRef = null;
    }
    Object.defineProperty(ViewRef_.prototype, "rootNodes", {
        /**
         * @return {?}
         */
        get: function () { return rootRenderNodes(this._view); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ViewRef_.prototype, "context", {
        /**
         * @return {?}
         */
        get: function () { return this._view.context; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ViewRef_.prototype, "destroyed", {
        /**
         * @return {?}
         */
        get: function () { return (this._view.state & 8 /* Destroyed */) !== 0; },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    ViewRef_.prototype.markForCheck = function () { markParentViewsForCheck(this._view); };
    /**
     * @return {?}
     */
    ViewRef_.prototype.detach = function () { this._view.state &= ~2 /* ChecksEnabled */; };
    /**
     * @return {?}
     */
    ViewRef_.prototype.detectChanges = function () { Services.checkAndUpdateView(this._view); };
    /**
     * @return {?}
     */
    ViewRef_.prototype.checkNoChanges = function () { Services.checkNoChangesView(this._view); };
    /**
     * @return {?}
     */
    ViewRef_.prototype.reattach = function () { this._view.state |= 2 /* ChecksEnabled */; };
    /**
     * @param {?} callback
     * @return {?}
     */
    ViewRef_.prototype.onDestroy = function (callback) {
        if (!this._view.disposables) {
            this._view.disposables = [];
        }
        this._view.disposables.push(/** @type {?} */ (callback));
    };
    /**
     * @return {?}
     */
    ViewRef_.prototype.destroy = function () {
        if (this._appRef) {
            this._appRef.detachView(this);
        }
        else if (this._viewContainerRef) {
            this._viewContainerRef.detach(this._viewContainerRef.indexOf(this));
        }
        Services.destroyView(this._view);
    };
    /**
     * @return {?}
     */
    ViewRef_.prototype.detachFromAppRef = function () {
        this._appRef = null;
        renderDetachView(this._view);
        Services.dirtyParentQueries(this._view);
    };
    /**
     * @param {?} appRef
     * @return {?}
     */
    ViewRef_.prototype.attachToAppRef = function (appRef) {
        if (this._viewContainerRef) {
            throw new Error('This view is already attached to a ViewContainer!');
        }
        this._appRef = appRef;
    };
    /**
     * @param {?} vcRef
     * @return {?}
     */
    ViewRef_.prototype.attachToViewContainerRef = function (vcRef) {
        if (this._appRef) {
            throw new Error('This view is already attached directly to the ApplicationRef!');
        }
        this._viewContainerRef = vcRef;
    };
    return ViewRef_;
}());
/**
 * @param {?} view
 * @param {?} def
 * @return {?}
 */
function createTemplateData(view, def) {
    return new TemplateRef_(view, def);
}
var TemplateRef_ = (function (_super) {
    __extends(TemplateRef_, _super);
    /**
     * @param {?} _parentView
     * @param {?} _def
     */
    function TemplateRef_(_parentView, _def) {
        var _this = _super.call(this) || this;
        _this._parentView = _parentView;
        _this._def = _def;
        return _this;
    }
    /**
     * @param {?} context
     * @return {?}
     */
    TemplateRef_.prototype.createEmbeddedView = function (context) {
        return new ViewRef_(Services.createEmbeddedView(this._parentView, this._def, context));
    };
    Object.defineProperty(TemplateRef_.prototype, "elementRef", {
        /**
         * @return {?}
         */
        get: function () {
            return new ElementRef(asElementData(this._parentView, this._def.index).renderElement);
        },
        enumerable: true,
        configurable: true
    });
    return TemplateRef_;
}(TemplateRef));
/**
 * @param {?} view
 * @param {?} elDef
 * @return {?}
 */
function createInjector(view, elDef) {
    return new Injector_(view, elDef);
}
var Injector_ = (function () {
    /**
     * @param {?} view
     * @param {?} elDef
     */
    function Injector_(view, elDef) {
        this.view = view;
        this.elDef = elDef;
    }
    /**
     * @param {?} token
     * @param {?=} notFoundValue
     * @return {?}
     */
    Injector_.prototype.get = function (token, notFoundValue) {
        if (notFoundValue === void 0) { notFoundValue = Injector.THROW_IF_NOT_FOUND; }
        var /** @type {?} */ allowPrivateServices = this.elDef ? (this.elDef.flags & 16777216 /* ComponentView */) !== 0 : false;
        return Services.resolveDep(this.view, this.elDef, allowPrivateServices, { flags: 0 /* None */, token: token, tokenKey: tokenKey(token) }, notFoundValue);
    };
    return Injector_;
}());
/**
 * @param {?} view
 * @param {?} index
 * @return {?}
 */
function nodeValue(view, index) {
    var /** @type {?} */ def = view.def.nodes[index];
    if (def.flags & 1 /* TypeElement */) {
        var /** @type {?} */ elData = asElementData(view, def.index);
        return ((def.element)).template ? elData.template : elData.renderElement;
    }
    else if (def.flags & 2 /* TypeText */) {
        return asTextData(view, def.index).renderText;
    }
    else if (def.flags & (10112 /* CatProvider */ | 8 /* TypePipe */)) {
        return asProviderData(view, def.index).instance;
    }
    throw new Error("Illegal state: read nodeValue for node index " + index);
}
/**
 * @param {?} view
 * @return {?}
 */
function createRendererV1(view) {
    return new RendererAdapter(view.renderer);
}
var RendererAdapter = (function () {
    /**
     * @param {?} delegate
     */
    function RendererAdapter(delegate) {
        this.delegate = delegate;
    }
    /**
     * @param {?} selectorOrNode
     * @return {?}
     */
    RendererAdapter.prototype.selectRootElement = function (selectorOrNode) {
        return this.delegate.selectRootElement(selectorOrNode);
    };
    /**
     * @param {?} parent
     * @param {?} namespaceAndName
     * @return {?}
     */
    RendererAdapter.prototype.createElement = function (parent, namespaceAndName) {
        var _a = splitNamespace(namespaceAndName), ns = _a[0], name = _a[1];
        var /** @type {?} */ el = this.delegate.createElement(name, ns);
        if (parent) {
            this.delegate.appendChild(parent, el);
        }
        return el;
    };
    /**
     * @param {?} hostElement
     * @return {?}
     */
    RendererAdapter.prototype.createViewRoot = function (hostElement) { return hostElement; };
    /**
     * @param {?} parentElement
     * @return {?}
     */
    RendererAdapter.prototype.createTemplateAnchor = function (parentElement) {
        var /** @type {?} */ comment = this.delegate.createComment('');
        if (parentElement) {
            this.delegate.appendChild(parentElement, comment);
        }
        return comment;
    };
    /**
     * @param {?} parentElement
     * @param {?} value
     * @return {?}
     */
    RendererAdapter.prototype.createText = function (parentElement, value) {
        var /** @type {?} */ node = this.delegate.createText(value);
        if (parentElement) {
            this.delegate.appendChild(parentElement, node);
        }
        return node;
    };
    /**
     * @param {?} parentElement
     * @param {?} nodes
     * @return {?}
     */
    RendererAdapter.prototype.projectNodes = function (parentElement, nodes) {
        for (var /** @type {?} */ i = 0; i < nodes.length; i++) {
            this.delegate.appendChild(parentElement, nodes[i]);
        }
    };
    /**
     * @param {?} node
     * @param {?} viewRootNodes
     * @return {?}
     */
    RendererAdapter.prototype.attachViewAfter = function (node, viewRootNodes) {
        var /** @type {?} */ parentElement = this.delegate.parentNode(node);
        var /** @type {?} */ nextSibling = this.delegate.nextSibling(node);
        for (var /** @type {?} */ i = 0; i < viewRootNodes.length; i++) {
            this.delegate.insertBefore(parentElement, viewRootNodes[i], nextSibling);
        }
    };
    /**
     * @param {?} viewRootNodes
     * @return {?}
     */
    RendererAdapter.prototype.detachView = function (viewRootNodes) {
        for (var /** @type {?} */ i = 0; i < viewRootNodes.length; i++) {
            var /** @type {?} */ node = viewRootNodes[i];
            var /** @type {?} */ parentElement = this.delegate.parentNode(node);
            this.delegate.removeChild(parentElement, node);
        }
    };
    /**
     * @param {?} hostElement
     * @param {?} viewAllNodes
     * @return {?}
     */
    RendererAdapter.prototype.destroyView = function (hostElement, viewAllNodes) {
        for (var /** @type {?} */ i = 0; i < viewAllNodes.length; i++) {
            ((this.delegate.destroyNode))(viewAllNodes[i]);
        }
    };
    /**
     * @param {?} renderElement
     * @param {?} name
     * @param {?} callback
     * @return {?}
     */
    RendererAdapter.prototype.listen = function (renderElement, name, callback) {
        return this.delegate.listen(renderElement, name, /** @type {?} */ (callback));
    };
    /**
     * @param {?} target
     * @param {?} name
     * @param {?} callback
     * @return {?}
     */
    RendererAdapter.prototype.listenGlobal = function (target, name, callback) {
        return this.delegate.listen(target, name, /** @type {?} */ (callback));
    };
    /**
     * @param {?} renderElement
     * @param {?} propertyName
     * @param {?} propertyValue
     * @return {?}
     */
    RendererAdapter.prototype.setElementProperty = function (renderElement, propertyName, propertyValue) {
        this.delegate.setProperty(renderElement, propertyName, propertyValue);
    };
    /**
     * @param {?} renderElement
     * @param {?} namespaceAndName
     * @param {?} attributeValue
     * @return {?}
     */
    RendererAdapter.prototype.setElementAttribute = function (renderElement, namespaceAndName, attributeValue) {
        var _a = splitNamespace(namespaceAndName), ns = _a[0], name = _a[1];
        if (attributeValue != null) {
            this.delegate.setAttribute(renderElement, name, attributeValue, ns);
        }
        else {
            this.delegate.removeAttribute(renderElement, name, ns);
        }
    };
    /**
     * @param {?} renderElement
     * @param {?} propertyName
     * @param {?} propertyValue
     * @return {?}
     */
    RendererAdapter.prototype.setBindingDebugInfo = function (renderElement, propertyName, propertyValue) { };
    /**
     * @param {?} renderElement
     * @param {?} className
     * @param {?} isAdd
     * @return {?}
     */
    RendererAdapter.prototype.setElementClass = function (renderElement, className, isAdd) {
        if (isAdd) {
            this.delegate.addClass(renderElement, className);
        }
        else {
            this.delegate.removeClass(renderElement, className);
        }
    };
    /**
     * @param {?} renderElement
     * @param {?} styleName
     * @param {?} styleValue
     * @return {?}
     */
    RendererAdapter.prototype.setElementStyle = function (renderElement, styleName, styleValue) {
        if (styleValue != null) {
            this.delegate.setStyle(renderElement, styleName, styleValue);
        }
        else {
            this.delegate.removeStyle(renderElement, styleName);
        }
    };
    /**
     * @param {?} renderElement
     * @param {?} methodName
     * @param {?} args
     * @return {?}
     */
    RendererAdapter.prototype.invokeElementMethod = function (renderElement, methodName, args) {
        ((renderElement))[methodName].apply(renderElement, args);
    };
    /**
     * @param {?} renderNode
     * @param {?} text
     * @return {?}
     */
    RendererAdapter.prototype.setText = function (renderNode$$1, text) { this.delegate.setValue(renderNode$$1, text); };
    /**
     * @return {?}
     */
    RendererAdapter.prototype.animate = function () { throw new Error('Renderer.animate is no longer supported!'); };
    return RendererAdapter;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var RendererV1TokenKey = tokenKey(Renderer);
var Renderer2TokenKey = tokenKey(Renderer2);
var ElementRefTokenKey = tokenKey(ElementRef);
var ViewContainerRefTokenKey = tokenKey(ViewContainerRef);
var TemplateRefTokenKey = tokenKey(TemplateRef);
var ChangeDetectorRefTokenKey = tokenKey(ChangeDetectorRef);
var InjectorRefTokenKey = tokenKey(Injector);
var NOT_CREATED = new Object();
/**
 * @param {?} flags
 * @param {?} matchedQueries
 * @param {?} childCount
 * @param {?} ctor
 * @param {?} deps
 * @param {?=} props
 * @param {?=} outputs
 * @return {?}
 */
function directiveDef(flags, matchedQueries, childCount, ctor, deps, props, outputs) {
    var /** @type {?} */ bindings = [];
    if (props) {
        for (var /** @type {?} */ prop in props) {
            var _a = props[prop], bindingIndex = _a[0], nonMinifiedName = _a[1];
            bindings[bindingIndex] = {
                flags: 8 /* TypeProperty */,
                name: prop, nonMinifiedName: nonMinifiedName,
                ns: null,
                securityContext: null,
                suffix: null
            };
        }
    }
    var /** @type {?} */ outputDefs = [];
    if (outputs) {
        for (var /** @type {?} */ propName in outputs) {
            outputDefs.push({ type: 1 /* DirectiveOutput */, propName: propName, target: null, eventName: outputs[propName] });
        }
    }
    flags |= 8192 /* TypeDirective */;
    return _def(flags, matchedQueries, childCount, ctor, ctor, deps, bindings, outputDefs);
}
/**
 * @param {?} flags
 * @param {?} ctor
 * @param {?} deps
 * @return {?}
 */
function pipeDef(flags, ctor, deps) {
    flags |= 8 /* TypePipe */;
    return _def(flags, null, 0, ctor, ctor, deps);
}
/**
 * @param {?} flags
 * @param {?} matchedQueries
 * @param {?} token
 * @param {?} value
 * @param {?} deps
 * @return {?}
 */
function providerDef(flags, matchedQueries, token, value, deps) {
    return _def(flags, matchedQueries, 0, token, value, deps);
}
/**
 * @param {?} flags
 * @param {?} matchedQueriesDsl
 * @param {?} childCount
 * @param {?} token
 * @param {?} value
 * @param {?} deps
 * @param {?=} bindings
 * @param {?=} outputs
 * @return {?}
 */
function _def(flags, matchedQueriesDsl, childCount, token, value, deps, bindings, outputs) {
    var _a = splitMatchedQueriesDsl(matchedQueriesDsl), matchedQueries = _a.matchedQueries, references = _a.references, matchedQueryIds = _a.matchedQueryIds;
    if (!outputs) {
        outputs = [];
    }
    if (!bindings) {
        bindings = [];
    }
    var /** @type {?} */ depDefs = deps.map(function (value) {
        var /** @type {?} */ token;
        var /** @type {?} */ flags;
        if (Array.isArray(value)) {
            flags = value[0], token = value[1];
        }
        else {
            flags = 0 /* None */;
            token = value;
        }
        return { flags: flags, token: token, tokenKey: tokenKey(token) };
    });
    return {
        // will bet set by the view definition
        index: -1,
        parent: null,
        renderParent: null,
        bindingIndex: -1,
        outputIndex: -1,
        // regular values
        flags: flags,
        childFlags: 0,
        directChildFlags: 0,
        childMatchedQueries: 0, matchedQueries: matchedQueries, matchedQueryIds: matchedQueryIds, references: references,
        ngContentIndex: -1, childCount: childCount, bindings: bindings,
        bindingFlags: calcBindingFlags(bindings), outputs: outputs,
        element: null,
        provider: { token: token, tokenKey: tokenKey(token), value: value, deps: depDefs },
        text: null,
        query: null,
        ngContent: null
    };
}
/**
 * @param {?} view
 * @param {?} def
 * @return {?}
 */
function createProviderInstance(view, def) {
    return def.flags & 2048 /* LazyProvider */ ? NOT_CREATED : _createProviderInstance(view, def);
}
/**
 * @param {?} view
 * @param {?} def
 * @return {?}
 */
function createPipeInstance(view, def) {
    // deps are looked up from component.
    var /** @type {?} */ compView = view;
    while (compView.parent && !isComponentView(compView)) {
        compView = compView.parent;
    }
    // pipes can see the private services of the component
    var /** @type {?} */ allowPrivateServices = true;
    // pipes are always eager and classes!
    return createClass(/** @type {?} */ ((compView.parent)), /** @type {?} */ ((viewParentEl(compView))), allowPrivateServices, /** @type {?} */ ((def.provider)).value, /** @type {?} */ ((def.provider)).deps);
}
/**
 * @param {?} view
 * @param {?} def
 * @return {?}
 */
function createDirectiveInstance(view, def) {
    // components can see other private services, other directives can't.
    var /** @type {?} */ allowPrivateServices = (def.flags & 16384 /* Component */) > 0;
    // directives are always eager and classes!
    var /** @type {?} */ instance = createClass(view, /** @type {?} */ ((def.parent)), allowPrivateServices, /** @type {?} */ ((def.provider)).value, /** @type {?} */ ((def.provider)).deps);
    if (def.outputs.length) {
        for (var /** @type {?} */ i = 0; i < def.outputs.length; i++) {
            var /** @type {?} */ output = def.outputs[i];
            var /** @type {?} */ subscription = instance[((output.propName))].subscribe(eventHandlerClosure(view, /** @type {?} */ ((def.parent)).index, output.eventName)); /** @type {?} */
            ((view.disposables))[def.outputIndex + i] = subscription.unsubscribe.bind(subscription);
        }
    }
    return instance;
}
/**
 * @param {?} view
 * @param {?} index
 * @param {?} eventName
 * @return {?}
 */
function eventHandlerClosure(view, index, eventName) {
    return function (event) { return dispatchEvent(view, index, eventName, event); };
}
/**
 * @param {?} view
 * @param {?} def
 * @param {?} v0
 * @param {?} v1
 * @param {?} v2
 * @param {?} v3
 * @param {?} v4
 * @param {?} v5
 * @param {?} v6
 * @param {?} v7
 * @param {?} v8
 * @param {?} v9
 * @return {?}
 */
function checkAndUpdateDirectiveInline(view, def, v0, v1, v2, v3, v4, v5, v6, v7, v8, v9) {
    var /** @type {?} */ providerData = asProviderData(view, def.index);
    var /** @type {?} */ directive = providerData.instance;
    var /** @type {?} */ changed = false;
    var /** @type {?} */ changes = ((undefined));
    var /** @type {?} */ bindLen = def.bindings.length;
    if (bindLen > 0 && checkBinding(view, def, 0, v0)) {
        changed = true;
        changes = updateProp(view, providerData, def, 0, v0, changes);
    }
    if (bindLen > 1 && checkBinding(view, def, 1, v1)) {
        changed = true;
        changes = updateProp(view, providerData, def, 1, v1, changes);
    }
    if (bindLen > 2 && checkBinding(view, def, 2, v2)) {
        changed = true;
        changes = updateProp(view, providerData, def, 2, v2, changes);
    }
    if (bindLen > 3 && checkBinding(view, def, 3, v3)) {
        changed = true;
        changes = updateProp(view, providerData, def, 3, v3, changes);
    }
    if (bindLen > 4 && checkBinding(view, def, 4, v4)) {
        changed = true;
        changes = updateProp(view, providerData, def, 4, v4, changes);
    }
    if (bindLen > 5 && checkBinding(view, def, 5, v5)) {
        changed = true;
        changes = updateProp(view, providerData, def, 5, v5, changes);
    }
    if (bindLen > 6 && checkBinding(view, def, 6, v6)) {
        changed = true;
        changes = updateProp(view, providerData, def, 6, v6, changes);
    }
    if (bindLen > 7 && checkBinding(view, def, 7, v7)) {
        changed = true;
        changes = updateProp(view, providerData, def, 7, v7, changes);
    }
    if (bindLen > 8 && checkBinding(view, def, 8, v8)) {
        changed = true;
        changes = updateProp(view, providerData, def, 8, v8, changes);
    }
    if (bindLen > 9 && checkBinding(view, def, 9, v9)) {
        changed = true;
        changes = updateProp(view, providerData, def, 9, v9, changes);
    }
    if (changes) {
        directive.ngOnChanges(changes);
    }
    if ((view.state & 1 /* FirstCheck */) && (def.flags & 32768 /* OnInit */)) {
        directive.ngOnInit();
    }
    if (def.flags & 131072 /* DoCheck */) {
        directive.ngDoCheck();
    }
    return changed;
}
/**
 * @param {?} view
 * @param {?} def
 * @param {?} values
 * @return {?}
 */
function checkAndUpdateDirectiveDynamic(view, def, values) {
    var /** @type {?} */ providerData = asProviderData(view, def.index);
    var /** @type {?} */ directive = providerData.instance;
    var /** @type {?} */ changed = false;
    var /** @type {?} */ changes = ((undefined));
    for (var /** @type {?} */ i = 0; i < values.length; i++) {
        if (checkBinding(view, def, i, values[i])) {
            changed = true;
            changes = updateProp(view, providerData, def, i, values[i], changes);
        }
    }
    if (changes) {
        directive.ngOnChanges(changes);
    }
    if ((view.state & 1 /* FirstCheck */) && (def.flags & 32768 /* OnInit */)) {
        directive.ngOnInit();
    }
    if (def.flags & 131072 /* DoCheck */) {
        directive.ngDoCheck();
    }
    return changed;
}
/**
 * @param {?} view
 * @param {?} def
 * @return {?}
 */
function _createProviderInstance(view, def) {
    // private services can see other private services
    var /** @type {?} */ allowPrivateServices = (def.flags & 4096 /* PrivateProvider */) > 0;
    var /** @type {?} */ providerDef = def.provider;
    var /** @type {?} */ injectable;
    switch (def.flags & 100673535 /* Types */) {
        case 256 /* TypeClassProvider */:
            injectable = createClass(view, /** @type {?} */ ((def.parent)), allowPrivateServices, /** @type {?} */ ((providerDef)).value, /** @type {?} */ ((providerDef)).deps);
            break;
        case 512 /* TypeFactoryProvider */:
            injectable = callFactory(view, /** @type {?} */ ((def.parent)), allowPrivateServices, /** @type {?} */ ((providerDef)).value, /** @type {?} */ ((providerDef)).deps);
            break;
        case 1024 /* TypeUseExistingProvider */:
            injectable = resolveDep(view, /** @type {?} */ ((def.parent)), allowPrivateServices, /** @type {?} */ ((providerDef)).deps[0]);
            break;
        case 128 /* TypeValueProvider */:
            injectable = ((providerDef)).value;
            break;
    }
    return injectable;
}
/**
 * @param {?} view
 * @param {?} elDef
 * @param {?} allowPrivateServices
 * @param {?} ctor
 * @param {?} deps
 * @return {?}
 */
function createClass(view, elDef, allowPrivateServices, ctor, deps) {
    var /** @type {?} */ len = deps.length;
    var /** @type {?} */ injectable;
    switch (len) {
        case 0:
            injectable = new ctor();
            break;
        case 1:
            injectable = new ctor(resolveDep(view, elDef, allowPrivateServices, deps[0]));
            break;
        case 2:
            injectable = new ctor(resolveDep(view, elDef, allowPrivateServices, deps[0]), resolveDep(view, elDef, allowPrivateServices, deps[1]));
            break;
        case 3:
            injectable = new ctor(resolveDep(view, elDef, allowPrivateServices, deps[0]), resolveDep(view, elDef, allowPrivateServices, deps[1]), resolveDep(view, elDef, allowPrivateServices, deps[2]));
            break;
        default:
            var /** @type {?} */ depValues = new Array(len);
            for (var /** @type {?} */ i = 0; i < len; i++) {
                depValues[i] = resolveDep(view, elDef, allowPrivateServices, deps[i]);
            }
            injectable = new (ctor.bind.apply(ctor, [void 0].concat(depValues)))();
    }
    return injectable;
}
/**
 * @param {?} view
 * @param {?} elDef
 * @param {?} allowPrivateServices
 * @param {?} factory
 * @param {?} deps
 * @return {?}
 */
function callFactory(view, elDef, allowPrivateServices, factory, deps) {
    var /** @type {?} */ len = deps.length;
    var /** @type {?} */ injectable;
    switch (len) {
        case 0:
            injectable = factory();
            break;
        case 1:
            injectable = factory(resolveDep(view, elDef, allowPrivateServices, deps[0]));
            break;
        case 2:
            injectable = factory(resolveDep(view, elDef, allowPrivateServices, deps[0]), resolveDep(view, elDef, allowPrivateServices, deps[1]));
            break;
        case 3:
            injectable = factory(resolveDep(view, elDef, allowPrivateServices, deps[0]), resolveDep(view, elDef, allowPrivateServices, deps[1]), resolveDep(view, elDef, allowPrivateServices, deps[2]));
            break;
        default:
            var /** @type {?} */ depValues = Array(len);
            for (var /** @type {?} */ i = 0; i < len; i++) {
                depValues[i] = resolveDep(view, elDef, allowPrivateServices, deps[i]);
            }
            injectable = factory.apply(void 0, depValues);
    }
    return injectable;
}
// This default value is when checking the hierarchy for a token.
//
// It means both:
// - the token is not provided by the current injector,
// - only the element injectors should be checked (ie do not check module injectors
//
//          mod1
//         /
//       el1   mod2
//         \  /
//         el2
//
// When requesting el2.injector.get(token), we should check in the following order and return the
// first found value:
// - el2.injector.get(token, default)
// - el1.injector.get(token, NOT_FOUND_CHECK_ONLY_ELEMENT_INJECTOR) -> do not check the module
// - mod2.injector.get(token, default)
var NOT_FOUND_CHECK_ONLY_ELEMENT_INJECTOR = {};
/**
 * @param {?} view
 * @param {?} elDef
 * @param {?} allowPrivateServices
 * @param {?} depDef
 * @param {?=} notFoundValue
 * @return {?}
 */
function resolveDep(view, elDef, allowPrivateServices, depDef, notFoundValue) {
    if (notFoundValue === void 0) { notFoundValue = Injector.THROW_IF_NOT_FOUND; }
    if (depDef.flags & 8 /* Value */) {
        return depDef.token;
    }
    var /** @type {?} */ startView = view;
    if (depDef.flags & 2 /* Optional */) {
        notFoundValue = null;
    }
    var /** @type {?} */ tokenKey$$1 = depDef.tokenKey;
    if (elDef && (depDef.flags & 1 /* SkipSelf */)) {
        allowPrivateServices = false;
        elDef = ((elDef.parent));
    }
    while (view) {
        if (elDef) {
            switch (tokenKey$$1) {
                case RendererV1TokenKey: {
                    var /** @type {?} */ compView = findCompView(view, elDef, allowPrivateServices);
                    return createRendererV1(compView);
                }
                case Renderer2TokenKey: {
                    var /** @type {?} */ compView = findCompView(view, elDef, allowPrivateServices);
                    return compView.renderer;
                }
                case ElementRefTokenKey:
                    return new ElementRef(asElementData(view, elDef.index).renderElement);
                case ViewContainerRefTokenKey:
                    return asElementData(view, elDef.index).viewContainer;
                case TemplateRefTokenKey: {
                    if (((elDef.element)).template) {
                        return asElementData(view, elDef.index).template;
                    }
                    break;
                }
                case ChangeDetectorRefTokenKey: {
                    var /** @type {?} */ cdView = findCompView(view, elDef, allowPrivateServices);
                    return createChangeDetectorRef(cdView);
                }
                case InjectorRefTokenKey:
                    return createInjector(view, elDef);
                default:
                    var /** @type {?} */ providerDef_1 = (((allowPrivateServices ? ((elDef.element)).allProviders : ((elDef.element)).publicProviders)))[tokenKey$$1];
                    if (providerDef_1) {
                        var /** @type {?} */ providerData = asProviderData(view, providerDef_1.index);
                        if (providerData.instance === NOT_CREATED) {
                            providerData.instance = _createProviderInstance(view, providerDef_1);
                        }
                        return providerData.instance;
                    }
            }
        }
        allowPrivateServices = isComponentView(view);
        elDef = ((viewParentEl(view)));
        view = ((view.parent));
    }
    var /** @type {?} */ value = startView.root.injector.get(depDef.token, NOT_FOUND_CHECK_ONLY_ELEMENT_INJECTOR);
    if (value !== NOT_FOUND_CHECK_ONLY_ELEMENT_INJECTOR ||
        notFoundValue === NOT_FOUND_CHECK_ONLY_ELEMENT_INJECTOR) {
        // Return the value from the root element injector when
        // - it provides it
        //   (value !== NOT_FOUND_CHECK_ONLY_ELEMENT_INJECTOR)
        // - the module injector should not be checked
        //   (notFoundValue === NOT_FOUND_CHECK_ONLY_ELEMENT_INJECTOR)
        return value;
    }
    return startView.root.ngModule.injector.get(depDef.token, notFoundValue);
}
/**
 * @param {?} view
 * @param {?} elDef
 * @param {?} allowPrivateServices
 * @return {?}
 */
function findCompView(view, elDef, allowPrivateServices) {
    var /** @type {?} */ compView;
    if (allowPrivateServices) {
        compView = asElementData(view, elDef.index).componentView;
    }
    else {
        compView = view;
        while (compView.parent && !isComponentView(compView)) {
            compView = compView.parent;
        }
    }
    return compView;
}
/**
 * @param {?} view
 * @param {?} providerData
 * @param {?} def
 * @param {?} bindingIdx
 * @param {?} value
 * @param {?} changes
 * @return {?}
 */
function updateProp(view, providerData, def, bindingIdx, value, changes) {
    if (def.flags & 16384 /* Component */) {
        var /** @type {?} */ compView = asElementData(view, /** @type {?} */ ((def.parent)).index).componentView;
        if (compView.def.flags & 2 /* OnPush */) {
            compView.state |= 2 /* ChecksEnabled */;
        }
    }
    var /** @type {?} */ binding = def.bindings[bindingIdx];
    var /** @type {?} */ propName = ((binding.name));
    // Note: This is still safe with Closure Compiler as
    // the user passed in the property name as an object has to `providerDef`,
    // so Closure Compiler will have renamed the property correctly already.
    providerData.instance[propName] = value;
    if (def.flags & 262144 /* OnChanges */) {
        changes = changes || {};
        var /** @type {?} */ oldValue = view.oldValues[def.bindingIndex + bindingIdx];
        if (oldValue instanceof WrappedValue) {
            oldValue = oldValue.wrapped;
        }
        var /** @type {?} */ binding_1 = def.bindings[bindingIdx];
        changes[((binding_1.nonMinifiedName))] =
            new SimpleChange(oldValue, value, (view.state & 1 /* FirstCheck */) !== 0);
    }
    view.oldValues[def.bindingIndex + bindingIdx] = value;
    return changes;
}
/**
 * @param {?} view
 * @param {?} lifecycles
 * @return {?}
 */
function callLifecycleHooksChildrenFirst(view, lifecycles) {
    if (!(view.def.nodeFlags & lifecycles)) {
        return;
    }
    var /** @type {?} */ nodes = view.def.nodes;
    for (var /** @type {?} */ i = 0; i < nodes.length; i++) {
        var /** @type {?} */ nodeDef = nodes[i];
        var /** @type {?} */ parent = nodeDef.parent;
        if (!parent && nodeDef.flags & lifecycles) {
            // matching root node (e.g. a pipe)
            callProviderLifecycles(view, i, nodeDef.flags & lifecycles);
        }
        if ((nodeDef.childFlags & lifecycles) === 0) {
            // no child matches one of the lifecycles
            i += nodeDef.childCount;
        }
        while (parent && (parent.flags & 1 /* TypeElement */) &&
            i === parent.index + parent.childCount) {
            // last child of an element
            if (parent.directChildFlags & lifecycles) {
                callElementProvidersLifecycles(view, parent, lifecycles);
            }
            parent = parent.parent;
        }
    }
}
/**
 * @param {?} view
 * @param {?} elDef
 * @param {?} lifecycles
 * @return {?}
 */
function callElementProvidersLifecycles(view, elDef, lifecycles) {
    for (var /** @type {?} */ i = elDef.index + 1; i <= elDef.index + elDef.childCount; i++) {
        var /** @type {?} */ nodeDef = view.def.nodes[i];
        if (nodeDef.flags & lifecycles) {
            callProviderLifecycles(view, i, nodeDef.flags & lifecycles);
        }
        // only visit direct children
        i += nodeDef.childCount;
    }
}
/**
 * @param {?} view
 * @param {?} index
 * @param {?} lifecycles
 * @return {?}
 */
function callProviderLifecycles(view, index, lifecycles) {
    var /** @type {?} */ provider = asProviderData(view, index).instance;
    if (provider === NOT_CREATED) {
        return;
    }
    Services.setCurrentNode(view, index);
    if (lifecycles & 524288 /* AfterContentInit */) {
        provider.ngAfterContentInit();
    }
    if (lifecycles & 1048576 /* AfterContentChecked */) {
        provider.ngAfterContentChecked();
    }
    if (lifecycles & 2097152 /* AfterViewInit */) {
        provider.ngAfterViewInit();
    }
    if (lifecycles & 4194304 /* AfterViewChecked */) {
        provider.ngAfterViewChecked();
    }
    if (lifecycles & 65536 /* OnDestroy */) {
        provider.ngOnDestroy();
    }
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @param {?} argCount
 * @return {?}
 */
function purePipeDef(argCount) {
    // argCount + 1 to include the pipe as first arg
    return _pureExpressionDef(64 /* TypePurePipe */, new Array(argCount + 1));
}
/**
 * @param {?} argCount
 * @return {?}
 */
function pureArrayDef(argCount) {
    return _pureExpressionDef(16 /* TypePureArray */, new Array(argCount));
}
/**
 * @param {?} propertyNames
 * @return {?}
 */
function pureObjectDef(propertyNames) {
    return _pureExpressionDef(32 /* TypePureObject */, propertyNames);
}
/**
 * @param {?} flags
 * @param {?} propertyNames
 * @return {?}
 */
function _pureExpressionDef(flags, propertyNames) {
    var /** @type {?} */ bindings = new Array(propertyNames.length);
    for (var /** @type {?} */ i = 0; i < propertyNames.length; i++) {
        var /** @type {?} */ prop = propertyNames[i];
        bindings[i] = {
            flags: 8 /* TypeProperty */,
            name: prop,
            ns: null,
            nonMinifiedName: prop,
            securityContext: null,
            suffix: null
        };
    }
    return {
        // will bet set by the view definition
        index: -1,
        parent: null,
        renderParent: null,
        bindingIndex: -1,
        outputIndex: -1,
        // regular values
        flags: flags,
        childFlags: 0,
        directChildFlags: 0,
        childMatchedQueries: 0,
        matchedQueries: {},
        matchedQueryIds: 0,
        references: {},
        ngContentIndex: -1,
        childCount: 0, bindings: bindings,
        bindingFlags: calcBindingFlags(bindings),
        outputs: [],
        element: null,
        provider: null,
        text: null,
        query: null,
        ngContent: null
    };
}
/**
 * @param {?} view
 * @param {?} def
 * @return {?}
 */
function createPureExpression(view, def) {
    return { value: undefined };
}
/**
 * @param {?} view
 * @param {?} def
 * @param {?} v0
 * @param {?} v1
 * @param {?} v2
 * @param {?} v3
 * @param {?} v4
 * @param {?} v5
 * @param {?} v6
 * @param {?} v7
 * @param {?} v8
 * @param {?} v9
 * @return {?}
 */
function checkAndUpdatePureExpressionInline(view, def, v0, v1, v2, v3, v4, v5, v6, v7, v8, v9) {
    var /** @type {?} */ bindings = def.bindings;
    var /** @type {?} */ changed = false;
    var /** @type {?} */ bindLen = bindings.length;
    if (bindLen > 0 && checkAndUpdateBinding(view, def, 0, v0))
        changed = true;
    if (bindLen > 1 && checkAndUpdateBinding(view, def, 1, v1))
        changed = true;
    if (bindLen > 2 && checkAndUpdateBinding(view, def, 2, v2))
        changed = true;
    if (bindLen > 3 && checkAndUpdateBinding(view, def, 3, v3))
        changed = true;
    if (bindLen > 4 && checkAndUpdateBinding(view, def, 4, v4))
        changed = true;
    if (bindLen > 5 && checkAndUpdateBinding(view, def, 5, v5))
        changed = true;
    if (bindLen > 6 && checkAndUpdateBinding(view, def, 6, v6))
        changed = true;
    if (bindLen > 7 && checkAndUpdateBinding(view, def, 7, v7))
        changed = true;
    if (bindLen > 8 && checkAndUpdateBinding(view, def, 8, v8))
        changed = true;
    if (bindLen > 9 && checkAndUpdateBinding(view, def, 9, v9))
        changed = true;
    if (changed) {
        var /** @type {?} */ data = asPureExpressionData(view, def.index);
        var /** @type {?} */ value = void 0;
        switch (def.flags & 100673535 /* Types */) {
            case 16 /* TypePureArray */:
                value = new Array(bindings.length);
                if (bindLen > 0)
                    value[0] = v0;
                if (bindLen > 1)
                    value[1] = v1;
                if (bindLen > 2)
                    value[2] = v2;
                if (bindLen > 3)
                    value[3] = v3;
                if (bindLen > 4)
                    value[4] = v4;
                if (bindLen > 5)
                    value[5] = v5;
                if (bindLen > 6)
                    value[6] = v6;
                if (bindLen > 7)
                    value[7] = v7;
                if (bindLen > 8)
                    value[8] = v8;
                if (bindLen > 9)
                    value[9] = v9;
                break;
            case 32 /* TypePureObject */:
                value = {};
                if (bindLen > 0)
                    value[((bindings[0].name))] = v0;
                if (bindLen > 1)
                    value[((bindings[1].name))] = v1;
                if (bindLen > 2)
                    value[((bindings[2].name))] = v2;
                if (bindLen > 3)
                    value[((bindings[3].name))] = v3;
                if (bindLen > 4)
                    value[((bindings[4].name))] = v4;
                if (bindLen > 5)
                    value[((bindings[5].name))] = v5;
                if (bindLen > 6)
                    value[((bindings[6].name))] = v6;
                if (bindLen > 7)
                    value[((bindings[7].name))] = v7;
                if (bindLen > 8)
                    value[((bindings[8].name))] = v8;
                if (bindLen > 9)
                    value[((bindings[9].name))] = v9;
                break;
            case 64 /* TypePurePipe */:
                var /** @type {?} */ pipe = v0;
                switch (bindLen) {
                    case 1:
                        value = pipe.transform(v0);
                        break;
                    case 2:
                        value = pipe.transform(v1);
                        break;
                    case 3:
                        value = pipe.transform(v1, v2);
                        break;
                    case 4:
                        value = pipe.transform(v1, v2, v3);
                        break;
                    case 5:
                        value = pipe.transform(v1, v2, v3, v4);
                        break;
                    case 6:
                        value = pipe.transform(v1, v2, v3, v4, v5);
                        break;
                    case 7:
                        value = pipe.transform(v1, v2, v3, v4, v5, v6);
                        break;
                    case 8:
                        value = pipe.transform(v1, v2, v3, v4, v5, v6, v7);
                        break;
                    case 9:
                        value = pipe.transform(v1, v2, v3, v4, v5, v6, v7, v8);
                        break;
                    case 10:
                        value = pipe.transform(v1, v2, v3, v4, v5, v6, v7, v8, v9);
                        break;
                }
                break;
        }
        data.value = value;
    }
    return changed;
}
/**
 * @param {?} view
 * @param {?} def
 * @param {?} values
 * @return {?}
 */
function checkAndUpdatePureExpressionDynamic(view, def, values) {
    var /** @type {?} */ bindings = def.bindings;
    var /** @type {?} */ changed = false;
    for (var /** @type {?} */ i = 0; i < values.length; i++) {
        // Note: We need to loop over all values, so that
        // the old values are updates as well!
        if (checkAndUpdateBinding(view, def, i, values[i])) {
            changed = true;
        }
    }
    if (changed) {
        var /** @type {?} */ data = asPureExpressionData(view, def.index);
        var /** @type {?} */ value = void 0;
        switch (def.flags & 100673535 /* Types */) {
            case 16 /* TypePureArray */:
                value = values;
                break;
            case 32 /* TypePureObject */:
                value = {};
                for (var /** @type {?} */ i = 0; i < values.length; i++) {
                    value[((bindings[i].name))] = values[i];
                }
                break;
            case 64 /* TypePurePipe */:
                var /** @type {?} */ pipe = values[0];
                var /** @type {?} */ params = values.slice(1);
                value = pipe.transform.apply(pipe, params);
                break;
        }
        data.value = value;
    }
    return changed;
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @param {?} flags
 * @param {?} id
 * @param {?} bindings
 * @return {?}
 */
function queryDef(flags, id, bindings) {
    var /** @type {?} */ bindingDefs = [];
    for (var /** @type {?} */ propName in bindings) {
        var /** @type {?} */ bindingType = bindings[propName];
        bindingDefs.push({ propName: propName, bindingType: bindingType });
    }
    return {
        // will bet set by the view definition
        index: -1,
        parent: null,
        renderParent: null,
        bindingIndex: -1,
        outputIndex: -1,
        // regular values
        flags: flags,
        childFlags: 0,
        directChildFlags: 0,
        childMatchedQueries: 0,
        ngContentIndex: -1,
        matchedQueries: {},
        matchedQueryIds: 0,
        references: {},
        childCount: 0,
        bindings: [],
        bindingFlags: 0,
        outputs: [],
        element: null,
        provider: null,
        text: null,
        query: { id: id, filterId: filterQueryId(id), bindings: bindingDefs },
        ngContent: null
    };
}
/**
 * @return {?}
 */
function createQuery() {
    return new QueryList();
}
/**
 * @param {?} view
 * @return {?}
 */
function dirtyParentQueries(view) {
    var /** @type {?} */ queryIds = view.def.nodeMatchedQueries;
    while (view.parent && isEmbeddedView(view)) {
        var /** @type {?} */ tplDef = ((view.parentNodeDef));
        view = view.parent;
        // content queries
        var /** @type {?} */ end = tplDef.index + tplDef.childCount;
        for (var /** @type {?} */ i = 0; i <= end; i++) {
            var /** @type {?} */ nodeDef = view.def.nodes[i];
            if ((nodeDef.flags & 33554432 /* TypeContentQuery */) &&
                (nodeDef.flags & 268435456 /* DynamicQuery */) &&
                (((nodeDef.query)).filterId & queryIds) === ((nodeDef.query)).filterId) {
                asQueryList(view, i).setDirty();
            }
            if ((nodeDef.flags & 1 /* TypeElement */ && i + nodeDef.childCount < tplDef.index) ||
                !(nodeDef.childFlags & 33554432 /* TypeContentQuery */) ||
                !(nodeDef.childFlags & 268435456 /* DynamicQuery */)) {
                // skip elements that don't contain the template element or no query.
                i += nodeDef.childCount;
            }
        }
    }
    // view queries
    if (view.def.nodeFlags & 67108864 /* TypeViewQuery */) {
        for (var /** @type {?} */ i = 0; i < view.def.nodes.length; i++) {
            var /** @type {?} */ nodeDef = view.def.nodes[i];
            if ((nodeDef.flags & 67108864 /* TypeViewQuery */) && (nodeDef.flags & 268435456 /* DynamicQuery */)) {
                asQueryList(view, i).setDirty();
            }
            // only visit the root nodes
            i += nodeDef.childCount;
        }
    }
}
/**
 * @param {?} view
 * @param {?} nodeDef
 * @return {?}
 */
function checkAndUpdateQuery(view, nodeDef) {
    var /** @type {?} */ queryList = asQueryList(view, nodeDef.index);
    if (!queryList.dirty) {
        return;
    }
    var /** @type {?} */ directiveInstance;
    var /** @type {?} */ newValues = ((undefined));
    if (nodeDef.flags & 33554432 /* TypeContentQuery */) {
        var /** @type {?} */ elementDef_1 = ((((nodeDef.parent)).parent));
        newValues = calcQueryValues(view, elementDef_1.index, elementDef_1.index + elementDef_1.childCount, /** @type {?} */ ((nodeDef.query)), []);
        directiveInstance = asProviderData(view, /** @type {?} */ ((nodeDef.parent)).index).instance;
    }
    else if (nodeDef.flags & 67108864 /* TypeViewQuery */) {
        newValues = calcQueryValues(view, 0, view.def.nodes.length - 1, /** @type {?} */ ((nodeDef.query)), []);
        directiveInstance = view.component;
    }
    queryList.reset(newValues);
    var /** @type {?} */ bindings = ((nodeDef.query)).bindings;
    var /** @type {?} */ notify = false;
    for (var /** @type {?} */ i = 0; i < bindings.length; i++) {
        var /** @type {?} */ binding = bindings[i];
        var /** @type {?} */ boundValue = void 0;
        switch (binding.bindingType) {
            case 0 /* First */:
                boundValue = queryList.first;
                break;
            case 1 /* All */:
                boundValue = queryList;
                notify = true;
                break;
        }
        directiveInstance[binding.propName] = boundValue;
    }
    if (notify) {
        queryList.notifyOnChanges();
    }
}
/**
 * @param {?} view
 * @param {?} startIndex
 * @param {?} endIndex
 * @param {?} queryDef
 * @param {?} values
 * @return {?}
 */
function calcQueryValues(view, startIndex, endIndex, queryDef, values) {
    for (var /** @type {?} */ i = startIndex; i <= endIndex; i++) {
        var /** @type {?} */ nodeDef = view.def.nodes[i];
        var /** @type {?} */ valueType = nodeDef.matchedQueries[queryDef.id];
        if (valueType != null) {
            values.push(getQueryValue(view, nodeDef, valueType));
        }
        if (nodeDef.flags & 1 /* TypeElement */ && ((nodeDef.element)).template &&
            (((((nodeDef.element)).template)).nodeMatchedQueries & queryDef.filterId) ===
                queryDef.filterId) {
            // check embedded views that were attached at the place of their template.
            var /** @type {?} */ elementData = asElementData(view, i);
            if (nodeDef.flags & 8388608 /* EmbeddedViews */) {
                var /** @type {?} */ embeddedViews = ((elementData.viewContainer))._embeddedViews;
                for (var /** @type {?} */ k = 0; k < embeddedViews.length; k++) {
                    var /** @type {?} */ embeddedView = embeddedViews[k];
                    var /** @type {?} */ dvc = declaredViewContainer(embeddedView);
                    if (dvc && dvc === elementData) {
                        calcQueryValues(embeddedView, 0, embeddedView.def.nodes.length - 1, queryDef, values);
                    }
                }
            }
            var /** @type {?} */ projectedViews = elementData.template._projectedViews;
            if (projectedViews) {
                for (var /** @type {?} */ k = 0; k < projectedViews.length; k++) {
                    var /** @type {?} */ projectedView = projectedViews[k];
                    calcQueryValues(projectedView, 0, projectedView.def.nodes.length - 1, queryDef, values);
                }
            }
        }
        if ((nodeDef.childMatchedQueries & queryDef.filterId) !== queryDef.filterId) {
            // if no child matches the query, skip the children.
            i += nodeDef.childCount;
        }
    }
    return values;
}
/**
 * @param {?} view
 * @param {?} nodeDef
 * @param {?} queryValueType
 * @return {?}
 */
function getQueryValue(view, nodeDef, queryValueType) {
    if (queryValueType != null) {
        // a match
        var /** @type {?} */ value = void 0;
        switch (queryValueType) {
            case 1 /* RenderElement */:
                value = asElementData(view, nodeDef.index).renderElement;
                break;
            case 0 /* ElementRef */:
                value = new ElementRef(asElementData(view, nodeDef.index).renderElement);
                break;
            case 2 /* TemplateRef */:
                value = asElementData(view, nodeDef.index).template;
                break;
            case 3 /* ViewContainerRef */:
                value = asElementData(view, nodeDef.index).viewContainer;
                break;
            case 4 /* Provider */:
                value = asProviderData(view, nodeDef.index).instance;
                break;
        }
        return value;
    }
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @param {?} ngContentIndex
 * @param {?} constants
 * @return {?}
 */
function textDef(ngContentIndex, constants) {
    var /** @type {?} */ bindings = new Array(constants.length - 1);
    for (var /** @type {?} */ i = 1; i < constants.length; i++) {
        bindings[i - 1] = {
            flags: 8 /* TypeProperty */,
            name: null,
            ns: null,
            nonMinifiedName: null,
            securityContext: null,
            suffix: constants[i]
        };
    }
    var /** @type {?} */ flags = 2;
    return {
        // will bet set by the view definition
        index: -1,
        parent: null,
        renderParent: null,
        bindingIndex: -1,
        outputIndex: -1,
        // regular values
        flags: flags,
        childFlags: 0,
        directChildFlags: 0,
        childMatchedQueries: 0,
        matchedQueries: {},
        matchedQueryIds: 0,
        references: {}, ngContentIndex: ngContentIndex,
        childCount: 0, bindings: bindings,
        bindingFlags: calcBindingFlags(bindings),
        outputs: [],
        element: null,
        provider: null,
        text: { prefix: constants[0] },
        query: null,
        ngContent: null
    };
}
/**
 * @param {?} view
 * @param {?} renderHost
 * @param {?} def
 * @return {?}
 */
function createText(view, renderHost, def) {
    var /** @type {?} */ renderNode$$1;
    var /** @type {?} */ renderer = view.renderer;
    renderNode$$1 = renderer.createText(/** @type {?} */ ((def.text)).prefix);
    var /** @type {?} */ parentEl = getParentRenderElement(view, renderHost, def);
    if (parentEl) {
        renderer.appendChild(parentEl, renderNode$$1);
    }
    return { renderText: renderNode$$1 };
}
/**
 * @param {?} view
 * @param {?} def
 * @param {?} v0
 * @param {?} v1
 * @param {?} v2
 * @param {?} v3
 * @param {?} v4
 * @param {?} v5
 * @param {?} v6
 * @param {?} v7
 * @param {?} v8
 * @param {?} v9
 * @return {?}
 */
function checkAndUpdateTextInline(view, def, v0, v1, v2, v3, v4, v5, v6, v7, v8, v9) {
    var /** @type {?} */ changed = false;
    var /** @type {?} */ bindings = def.bindings;
    var /** @type {?} */ bindLen = bindings.length;
    if (bindLen > 0 && checkAndUpdateBinding(view, def, 0, v0))
        changed = true;
    if (bindLen > 1 && checkAndUpdateBinding(view, def, 1, v1))
        changed = true;
    if (bindLen > 2 && checkAndUpdateBinding(view, def, 2, v2))
        changed = true;
    if (bindLen > 3 && checkAndUpdateBinding(view, def, 3, v3))
        changed = true;
    if (bindLen > 4 && checkAndUpdateBinding(view, def, 4, v4))
        changed = true;
    if (bindLen > 5 && checkAndUpdateBinding(view, def, 5, v5))
        changed = true;
    if (bindLen > 6 && checkAndUpdateBinding(view, def, 6, v6))
        changed = true;
    if (bindLen > 7 && checkAndUpdateBinding(view, def, 7, v7))
        changed = true;
    if (bindLen > 8 && checkAndUpdateBinding(view, def, 8, v8))
        changed = true;
    if (bindLen > 9 && checkAndUpdateBinding(view, def, 9, v9))
        changed = true;
    if (changed) {
        var /** @type {?} */ value = ((def.text)).prefix;
        if (bindLen > 0)
            value += _addInterpolationPart(v0, bindings[0]);
        if (bindLen > 1)
            value += _addInterpolationPart(v1, bindings[1]);
        if (bindLen > 2)
            value += _addInterpolationPart(v2, bindings[2]);
        if (bindLen > 3)
            value += _addInterpolationPart(v3, bindings[3]);
        if (bindLen > 4)
            value += _addInterpolationPart(v4, bindings[4]);
        if (bindLen > 5)
            value += _addInterpolationPart(v5, bindings[5]);
        if (bindLen > 6)
            value += _addInterpolationPart(v6, bindings[6]);
        if (bindLen > 7)
            value += _addInterpolationPart(v7, bindings[7]);
        if (bindLen > 8)
            value += _addInterpolationPart(v8, bindings[8]);
        if (bindLen > 9)
            value += _addInterpolationPart(v9, bindings[9]);
        var /** @type {?} */ renderNode$$1 = asTextData(view, def.index).renderText;
        view.renderer.setValue(renderNode$$1, value);
    }
    return changed;
}
/**
 * @param {?} view
 * @param {?} def
 * @param {?} values
 * @return {?}
 */
function checkAndUpdateTextDynamic(view, def, values) {
    var /** @type {?} */ bindings = def.bindings;
    var /** @type {?} */ changed = false;
    for (var /** @type {?} */ i = 0; i < values.length; i++) {
        // Note: We need to loop over all values, so that
        // the old values are updates as well!
        if (checkAndUpdateBinding(view, def, i, values[i])) {
            changed = true;
        }
    }
    if (changed) {
        var /** @type {?} */ value = '';
        for (var /** @type {?} */ i = 0; i < values.length; i++) {
            value = value + _addInterpolationPart(values[i], bindings[i]);
        }
        value = ((def.text)).prefix + value;
        var /** @type {?} */ renderNode$$1 = asTextData(view, def.index).renderText;
        view.renderer.setValue(renderNode$$1, value);
    }
    return changed;
}
/**
 * @param {?} value
 * @param {?} binding
 * @return {?}
 */
function _addInterpolationPart(value, binding) {
    var /** @type {?} */ valueStr = value != null ? value.toString() : '';
    return valueStr + binding.suffix;
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @param {?} flags
 * @param {?} nodes
 * @param {?=} updateDirectives
 * @param {?=} updateRenderer
 * @return {?}
 */
function viewDef(flags, nodes, updateDirectives, updateRenderer) {
    // clone nodes and set auto calculated values
    var /** @type {?} */ viewBindingCount = 0;
    var /** @type {?} */ viewDisposableCount = 0;
    var /** @type {?} */ viewNodeFlags = 0;
    var /** @type {?} */ viewRootNodeFlags = 0;
    var /** @type {?} */ viewMatchedQueries = 0;
    var /** @type {?} */ currentParent = null;
    var /** @type {?} */ currentElementHasPublicProviders = false;
    var /** @type {?} */ currentElementHasPrivateProviders = false;
    var /** @type {?} */ lastRenderRootNode = null;
    for (var /** @type {?} */ i = 0; i < nodes.length; i++) {
        while (currentParent && i > currentParent.index + currentParent.childCount) {
            var /** @type {?} */ newParent = currentParent.parent;
            if (newParent) {
                newParent.childFlags |= ((currentParent.childFlags));
                newParent.childMatchedQueries |= currentParent.childMatchedQueries;
            }
            currentParent = newParent;
        }
        var /** @type {?} */ node = nodes[i];
        node.index = i;
        node.parent = currentParent;
        node.bindingIndex = viewBindingCount;
        node.outputIndex = viewDisposableCount;
        // renderParent needs to account for ng-container!
        var /** @type {?} */ currentRenderParent = void 0;
        if (currentParent && currentParent.flags & 1 /* TypeElement */ &&
            !((currentParent.element)).name) {
            currentRenderParent = currentParent.renderParent;
        }
        else {
            currentRenderParent = currentParent;
        }
        node.renderParent = currentRenderParent;
        if (node.element) {
            var /** @type {?} */ elDef = node.element;
            elDef.publicProviders =
                currentParent ? ((currentParent.element)).publicProviders : Object.create(null);
            elDef.allProviders = elDef.publicProviders;
            // Note: We assume that all providers of an element are before any child element!
            currentElementHasPublicProviders = false;
            currentElementHasPrivateProviders = false;
        }
        validateNode(currentParent, node, nodes.length);
        viewNodeFlags |= node.flags;
        viewMatchedQueries |= node.matchedQueryIds;
        if (node.element && node.element.template) {
            viewMatchedQueries |= node.element.template.nodeMatchedQueries;
        }
        if (currentParent) {
            currentParent.childFlags |= node.flags;
            currentParent.directChildFlags |= node.flags;
            currentParent.childMatchedQueries |= node.matchedQueryIds;
            if (node.element && node.element.template) {
                currentParent.childMatchedQueries |= node.element.template.nodeMatchedQueries;
            }
        }
        else {
            viewRootNodeFlags |= node.flags;
        }
        viewBindingCount += node.bindings.length;
        viewDisposableCount += node.outputs.length;
        if (!currentRenderParent && (node.flags & 3 /* CatRenderNode */)) {
            lastRenderRootNode = node;
        }
        if (node.flags & 10112 /* CatProvider */) {
            if (!currentElementHasPublicProviders) {
                currentElementHasPublicProviders = true; /** @type {?} */
                ((((
                // Use prototypical inheritance to not get O(n^2) complexity...
                currentParent)).element)).publicProviders =
                    Object.create(/** @type {?} */ ((((currentParent)).element)).publicProviders); /** @type {?} */
                ((((currentParent)).element)).allProviders = ((((currentParent)).element)).publicProviders;
            }
            var /** @type {?} */ isPrivateService = (node.flags & 4096 /* PrivateProvider */) !== 0;
            var /** @type {?} */ isComponent = (node.flags & 16384 /* Component */) !== 0;
            if (!isPrivateService || isComponent) {
                ((((((currentParent)).element)).publicProviders))[((node.provider)).tokenKey] = node;
            }
            else {
                if (!currentElementHasPrivateProviders) {
                    currentElementHasPrivateProviders = true; /** @type {?} */
                    ((((
                    // Use protoyypical inheritance to not get O(n^2) complexity...
                    currentParent)).element)).allProviders =
                        Object.create(/** @type {?} */ ((((currentParent)).element)).publicProviders);
                } /** @type {?} */
                ((((((currentParent)).element)).allProviders))[((node.provider)).tokenKey] = node;
            }
            if (isComponent) {
                ((((currentParent)).element)).componentProvider = node;
            }
        }
        if (node.childCount) {
            currentParent = node;
        }
    }
    while (currentParent) {
        var /** @type {?} */ newParent = currentParent.parent;
        if (newParent) {
            newParent.childFlags |= currentParent.childFlags;
            newParent.childMatchedQueries |= currentParent.childMatchedQueries;
        }
        currentParent = newParent;
    }
    var /** @type {?} */ handleEvent = function (view, nodeIndex, eventName, event) { return ((((nodes[nodeIndex].element)).handleEvent))(view, eventName, event); };
    return {
        // Will be filled later...
        factory: null,
        nodeFlags: viewNodeFlags,
        rootNodeFlags: viewRootNodeFlags,
        nodeMatchedQueries: viewMatchedQueries, flags: flags,
        nodes: nodes,
        updateDirectives: updateDirectives || NOOP,
        updateRenderer: updateRenderer || NOOP,
        handleEvent: handleEvent || NOOP,
        bindingCount: viewBindingCount,
        outputCount: viewDisposableCount, lastRenderRootNode: lastRenderRootNode
    };
}
/**
 * @param {?} parent
 * @param {?} node
 * @param {?} nodeCount
 * @return {?}
 */
function validateNode(parent, node, nodeCount) {
    var /** @type {?} */ template = node.element && node.element.template;
    if (template) {
        if (!template.lastRenderRootNode) {
            throw new Error("Illegal State: Embedded templates without nodes are not allowed!");
        }
        if (template.lastRenderRootNode &&
            template.lastRenderRootNode.flags & 8388608 /* EmbeddedViews */) {
            throw new Error("Illegal State: Last root node of a template can't have embedded views, at index " + node.index + "!");
        }
    }
    if (node.flags & 10112 /* CatProvider */) {
        var /** @type {?} */ parentFlags = parent ? parent.flags : 0;
        if ((parentFlags & 1 /* TypeElement */) === 0) {
            throw new Error("Illegal State: Provider/Directive nodes need to be children of elements or anchors, at index " + node.index + "!");
        }
    }
    if (node.query) {
        if (node.flags & 33554432 /* TypeContentQuery */ &&
            (!parent || (parent.flags & 8192 /* TypeDirective */) === 0)) {
            throw new Error("Illegal State: Content Query nodes need to be children of directives, at index " + node.index + "!");
        }
        if (node.flags & 67108864 /* TypeViewQuery */ && parent) {
            throw new Error("Illegal State: View Query nodes have to be top level nodes, at index " + node.index + "!");
        }
    }
    if (node.childCount) {
        var /** @type {?} */ parentEnd = parent ? parent.index + parent.childCount : nodeCount - 1;
        if (node.index <= parentEnd && node.index + node.childCount > parentEnd) {
            throw new Error("Illegal State: childCount of node leads outside of parent, at index " + node.index + "!");
        }
    }
}
/**
 * @param {?} parent
 * @param {?} anchorDef
 * @param {?=} context
 * @return {?}
 */
function createEmbeddedView(parent, anchorDef$$1, context) {
    // embedded views are seen as siblings to the anchor, so we need
    // to get the parent of the anchor and use it as parentIndex.
    var /** @type {?} */ view = createView(parent.root, parent.renderer, parent, anchorDef$$1, /** @type {?} */ ((((anchorDef$$1.element)).template)));
    initView(view, parent.component, context);
    createViewNodes(view);
    return view;
}
/**
 * @param {?} root
 * @param {?} def
 * @param {?=} context
 * @return {?}
 */
function createRootView(root, def, context) {
    var /** @type {?} */ view = createView(root, root.renderer, null, null, def);
    initView(view, context, context);
    createViewNodes(view);
    return view;
}
/**
 * @param {?} root
 * @param {?} renderer
 * @param {?} parent
 * @param {?} parentNodeDef
 * @param {?} def
 * @return {?}
 */
function createView(root, renderer, parent, parentNodeDef, def) {
    var /** @type {?} */ nodes = new Array(def.nodes.length);
    var /** @type {?} */ disposables = def.outputCount ? new Array(def.outputCount) : null;
    var /** @type {?} */ view = {
        def: def,
        parent: parent,
        viewContainerParent: null, parentNodeDef: parentNodeDef,
        context: null,
        component: null, nodes: nodes,
        state: 1 /* FirstCheck */ | 2 /* ChecksEnabled */, root: root, renderer: renderer,
        oldValues: new Array(def.bindingCount), disposables: disposables
    };
    return view;
}
/**
 * @param {?} view
 * @param {?} component
 * @param {?} context
 * @return {?}
 */
function initView(view, component, context) {
    view.component = component;
    view.context = context;
}
/**
 * @param {?} view
 * @return {?}
 */
function createViewNodes(view) {
    var /** @type {?} */ renderHost;
    if (isComponentView(view)) {
        var /** @type {?} */ hostDef = view.parentNodeDef;
        renderHost = asElementData(/** @type {?} */ ((view.parent)), /** @type {?} */ ((((hostDef)).parent)).index).renderElement;
    }
    var /** @type {?} */ def = view.def;
    var /** @type {?} */ nodes = view.nodes;
    for (var /** @type {?} */ i = 0; i < def.nodes.length; i++) {
        var /** @type {?} */ nodeDef = def.nodes[i];
        Services.setCurrentNode(view, i);
        var /** @type {?} */ nodeData = void 0;
        switch (nodeDef.flags & 100673535 /* Types */) {
            case 1 /* TypeElement */:
                var /** @type {?} */ el = (createElement(view, renderHost, nodeDef));
                var /** @type {?} */ componentView = ((undefined));
                if (nodeDef.flags & 16777216 /* ComponentView */) {
                    var /** @type {?} */ compViewDef = resolveViewDefinition(/** @type {?} */ ((((nodeDef.element)).componentView)));
                    var /** @type {?} */ rendererType = ((nodeDef.element)).componentRendererType;
                    var /** @type {?} */ compRenderer = void 0;
                    if (!rendererType) {
                        compRenderer = view.root.renderer;
                    }
                    else {
                        compRenderer = view.root.rendererFactory.createRenderer(el, rendererType);
                    }
                    componentView = createView(view.root, compRenderer, view, /** @type {?} */ ((nodeDef.element)).componentProvider, compViewDef);
                }
                listenToElementOutputs(view, componentView, nodeDef, el);
                nodeData = ({
                    renderElement: el,
                    componentView: componentView,
                    viewContainer: null,
                    template: /** @type {?} */ ((nodeDef.element)).template ? createTemplateData(view, nodeDef) : undefined
                });
                if (nodeDef.flags & 8388608 /* EmbeddedViews */) {
                    nodeData.viewContainer = createViewContainerData(view, nodeDef, nodeData);
                }
                break;
            case 2 /* TypeText */:
                nodeData = (createText(view, renderHost, nodeDef));
                break;
            case 256 /* TypeClassProvider */:
            case 512 /* TypeFactoryProvider */:
            case 1024 /* TypeUseExistingProvider */:
            case 128 /* TypeValueProvider */: {
                var /** @type {?} */ instance = createProviderInstance(view, nodeDef);
                nodeData = ({ instance: instance });
                break;
            }
            case 8 /* TypePipe */: {
                var /** @type {?} */ instance = createPipeInstance(view, nodeDef);
                nodeData = ({ instance: instance });
                break;
            }
            case 8192 /* TypeDirective */: {
                var /** @type {?} */ instance = createDirectiveInstance(view, nodeDef);
                nodeData = ({ instance: instance });
                if (nodeDef.flags & 16384 /* Component */) {
                    var /** @type {?} */ compView = asElementData(view, /** @type {?} */ ((nodeDef.parent)).index).componentView;
                    initView(compView, instance, instance);
                }
                break;
            }
            case 16 /* TypePureArray */:
            case 32 /* TypePureObject */:
            case 64 /* TypePurePipe */:
                nodeData = (createPureExpression(view, nodeDef));
                break;
            case 33554432 /* TypeContentQuery */:
            case 67108864 /* TypeViewQuery */:
                nodeData = (createQuery());
                break;
            case 4 /* TypeNgContent */:
                appendNgContent(view, renderHost, nodeDef);
                // no runtime data needed for NgContent...
                nodeData = undefined;
                break;
        }
        nodes[i] = nodeData;
    }
    // Create the ViewData.nodes of component views after we created everything else,
    // so that e.g. ng-content works
    execComponentViewsAction(view, ViewAction.CreateViewNodes);
    // fill static content and view queries
    execQueriesAction(view, 33554432 /* TypeContentQuery */ | 67108864 /* TypeViewQuery */, 134217728 /* StaticQuery */, 0 /* CheckAndUpdate */);
}
/**
 * @param {?} view
 * @return {?}
 */
function checkNoChangesView(view) {
    Services.updateDirectives(view, 1 /* CheckNoChanges */);
    execEmbeddedViewsAction(view, ViewAction.CheckNoChanges);
    Services.updateRenderer(view, 1 /* CheckNoChanges */);
    execComponentViewsAction(view, ViewAction.CheckNoChanges);
    // Note: We don't check queries for changes as we didn't do this in v2.x.
    // TODO(tbosch): investigate if we can enable the check again in v5.x with a nicer error message.
}
/**
 * @param {?} view
 * @return {?}
 */
function checkAndUpdateView(view) {
    Services.updateDirectives(view, 0 /* CheckAndUpdate */);
    execEmbeddedViewsAction(view, ViewAction.CheckAndUpdate);
    execQueriesAction(view, 33554432 /* TypeContentQuery */, 268435456 /* DynamicQuery */, 0 /* CheckAndUpdate */);
    callLifecycleHooksChildrenFirst(view, 1048576 /* AfterContentChecked */ |
        (view.state & 1 /* FirstCheck */ ? 524288 /* AfterContentInit */ : 0));
    Services.updateRenderer(view, 0 /* CheckAndUpdate */);
    execComponentViewsAction(view, ViewAction.CheckAndUpdate);
    execQueriesAction(view, 67108864 /* TypeViewQuery */, 268435456 /* DynamicQuery */, 0 /* CheckAndUpdate */);
    callLifecycleHooksChildrenFirst(view, 4194304 /* AfterViewChecked */ |
        (view.state & 1 /* FirstCheck */ ? 2097152 /* AfterViewInit */ : 0));
    if (view.def.flags & 2 /* OnPush */) {
        view.state &= ~2 /* ChecksEnabled */;
    }
    view.state &= ~1 /* FirstCheck */;
}
/**
 * @param {?} view
 * @param {?} nodeDef
 * @param {?} argStyle
 * @param {?=} v0
 * @param {?=} v1
 * @param {?=} v2
 * @param {?=} v3
 * @param {?=} v4
 * @param {?=} v5
 * @param {?=} v6
 * @param {?=} v7
 * @param {?=} v8
 * @param {?=} v9
 * @return {?}
 */
function checkAndUpdateNode(view, nodeDef, argStyle, v0, v1, v2, v3, v4, v5, v6, v7, v8, v9) {
    if (argStyle === 0 /* Inline */) {
        return checkAndUpdateNodeInline(view, nodeDef, v0, v1, v2, v3, v4, v5, v6, v7, v8, v9);
    }
    else {
        return checkAndUpdateNodeDynamic(view, nodeDef, v0);
    }
}
/**
 * @param {?} view
 * @param {?} nodeDef
 * @param {?=} v0
 * @param {?=} v1
 * @param {?=} v2
 * @param {?=} v3
 * @param {?=} v4
 * @param {?=} v5
 * @param {?=} v6
 * @param {?=} v7
 * @param {?=} v8
 * @param {?=} v9
 * @return {?}
 */
function checkAndUpdateNodeInline(view, nodeDef, v0, v1, v2, v3, v4, v5, v6, v7, v8, v9) {
    var /** @type {?} */ changed = false;
    switch (nodeDef.flags & 100673535 /* Types */) {
        case 1 /* TypeElement */:
            changed = checkAndUpdateElementInline(view, nodeDef, v0, v1, v2, v3, v4, v5, v6, v7, v8, v9);
            break;
        case 2 /* TypeText */:
            changed = checkAndUpdateTextInline(view, nodeDef, v0, v1, v2, v3, v4, v5, v6, v7, v8, v9);
            break;
        case 8192 /* TypeDirective */:
            changed =
                checkAndUpdateDirectiveInline(view, nodeDef, v0, v1, v2, v3, v4, v5, v6, v7, v8, v9);
            break;
        case 16 /* TypePureArray */:
        case 32 /* TypePureObject */:
        case 64 /* TypePurePipe */:
            changed =
                checkAndUpdatePureExpressionInline(view, nodeDef, v0, v1, v2, v3, v4, v5, v6, v7, v8, v9);
            break;
    }
    return changed;
}
/**
 * @param {?} view
 * @param {?} nodeDef
 * @param {?} values
 * @return {?}
 */
function checkAndUpdateNodeDynamic(view, nodeDef, values) {
    var /** @type {?} */ changed = false;
    switch (nodeDef.flags & 100673535 /* Types */) {
        case 1 /* TypeElement */:
            changed = checkAndUpdateElementDynamic(view, nodeDef, values);
            break;
        case 2 /* TypeText */:
            changed = checkAndUpdateTextDynamic(view, nodeDef, values);
            break;
        case 8192 /* TypeDirective */:
            changed = checkAndUpdateDirectiveDynamic(view, nodeDef, values);
            break;
        case 16 /* TypePureArray */:
        case 32 /* TypePureObject */:
        case 64 /* TypePurePipe */:
            changed = checkAndUpdatePureExpressionDynamic(view, nodeDef, values);
            break;
    }
    if (changed) {
        // Update oldValues after all bindings have been updated,
        // as a setter for a property might update other properties.
        var /** @type {?} */ bindLen = nodeDef.bindings.length;
        var /** @type {?} */ bindingStart = nodeDef.bindingIndex;
        var /** @type {?} */ oldValues = view.oldValues;
        for (var /** @type {?} */ i = 0; i < bindLen; i++) {
            oldValues[bindingStart + i] = values[i];
        }
    }
    return changed;
}
/**
 * @param {?} view
 * @param {?} nodeDef
 * @param {?} argStyle
 * @param {?=} v0
 * @param {?=} v1
 * @param {?=} v2
 * @param {?=} v3
 * @param {?=} v4
 * @param {?=} v5
 * @param {?=} v6
 * @param {?=} v7
 * @param {?=} v8
 * @param {?=} v9
 * @return {?}
 */
function checkNoChangesNode(view, nodeDef, argStyle, v0, v1, v2, v3, v4, v5, v6, v7, v8, v9) {
    if (argStyle === 0 /* Inline */) {
        checkNoChangesNodeInline(view, nodeDef, v0, v1, v2, v3, v4, v5, v6, v7, v8, v9);
    }
    else {
        checkNoChangesNodeDynamic(view, nodeDef, v0);
    }
    // Returning false is ok here as we would have thrown in case of a change.
    return false;
}
/**
 * @param {?} view
 * @param {?} nodeDef
 * @param {?} v0
 * @param {?} v1
 * @param {?} v2
 * @param {?} v3
 * @param {?} v4
 * @param {?} v5
 * @param {?} v6
 * @param {?} v7
 * @param {?} v8
 * @param {?} v9
 * @return {?}
 */
function checkNoChangesNodeInline(view, nodeDef, v0, v1, v2, v3, v4, v5, v6, v7, v8, v9) {
    var /** @type {?} */ bindLen = nodeDef.bindings.length;
    if (bindLen > 0)
        checkBindingNoChanges(view, nodeDef, 0, v0);
    if (bindLen > 1)
        checkBindingNoChanges(view, nodeDef, 1, v1);
    if (bindLen > 2)
        checkBindingNoChanges(view, nodeDef, 2, v2);
    if (bindLen > 3)
        checkBindingNoChanges(view, nodeDef, 3, v3);
    if (bindLen > 4)
        checkBindingNoChanges(view, nodeDef, 4, v4);
    if (bindLen > 5)
        checkBindingNoChanges(view, nodeDef, 5, v5);
    if (bindLen > 6)
        checkBindingNoChanges(view, nodeDef, 6, v6);
    if (bindLen > 7)
        checkBindingNoChanges(view, nodeDef, 7, v7);
    if (bindLen > 8)
        checkBindingNoChanges(view, nodeDef, 8, v8);
    if (bindLen > 9)
        checkBindingNoChanges(view, nodeDef, 9, v9);
}
/**
 * @param {?} view
 * @param {?} nodeDef
 * @param {?} values
 * @return {?}
 */
function checkNoChangesNodeDynamic(view, nodeDef, values) {
    for (var /** @type {?} */ i = 0; i < values.length; i++) {
        checkBindingNoChanges(view, nodeDef, i, values[i]);
    }
}
/**
 * @param {?} view
 * @param {?} nodeDef
 * @return {?}
 */
function checkNoChangesQuery(view, nodeDef) {
    var /** @type {?} */ queryList = asQueryList(view, nodeDef.index);
    if (queryList.dirty) {
        throw expressionChangedAfterItHasBeenCheckedError(Services.createDebugContext(view, nodeDef.index), "Query " + ((nodeDef.query)).id + " not dirty", "Query " + ((nodeDef.query)).id + " dirty", (view.state & 1 /* FirstCheck */) !== 0);
    }
}
/**
 * @param {?} view
 * @return {?}
 */
function destroyView(view) {
    if (view.state & 8 /* Destroyed */) {
        return;
    }
    execEmbeddedViewsAction(view, ViewAction.Destroy);
    execComponentViewsAction(view, ViewAction.Destroy);
    callLifecycleHooksChildrenFirst(view, 65536 /* OnDestroy */);
    if (view.disposables) {
        for (var /** @type {?} */ i = 0; i < view.disposables.length; i++) {
            view.disposables[i]();
        }
    }
    if (view.renderer.destroyNode) {
        destroyViewNodes(view);
    }
    if (isComponentView(view)) {
        view.renderer.destroy();
    }
    view.state |= 8 /* Destroyed */;
}
/**
 * @param {?} view
 * @return {?}
 */
function destroyViewNodes(view) {
    var /** @type {?} */ len = view.def.nodes.length;
    for (var /** @type {?} */ i = 0; i < len; i++) {
        var /** @type {?} */ def = view.def.nodes[i];
        if (def.flags & 1 /* TypeElement */) {
            ((view.renderer.destroyNode))(asElementData(view, i).renderElement);
        }
        else if (def.flags & 2 /* TypeText */) {
            ((view.renderer.destroyNode))(asTextData(view, i).renderText);
        }
    }
}
var ViewAction = {};
ViewAction.CreateViewNodes = 0;
ViewAction.CheckNoChanges = 1;
ViewAction.CheckAndUpdate = 2;
ViewAction.Destroy = 3;
ViewAction[ViewAction.CreateViewNodes] = "CreateViewNodes";
ViewAction[ViewAction.CheckNoChanges] = "CheckNoChanges";
ViewAction[ViewAction.CheckAndUpdate] = "CheckAndUpdate";
ViewAction[ViewAction.Destroy] = "Destroy";
/**
 * @param {?} view
 * @param {?} action
 * @return {?}
 */
function execComponentViewsAction(view, action) {
    var /** @type {?} */ def = view.def;
    if (!(def.nodeFlags & 16777216 /* ComponentView */)) {
        return;
    }
    for (var /** @type {?} */ i = 0; i < def.nodes.length; i++) {
        var /** @type {?} */ nodeDef = def.nodes[i];
        if (nodeDef.flags & 16777216 /* ComponentView */) {
            // a leaf
            callViewAction(asElementData(view, i).componentView, action);
        }
        else if ((nodeDef.childFlags & 16777216 /* ComponentView */) === 0) {
            // a parent with leafs
            // no child is a component,
            // then skip the children
            i += nodeDef.childCount;
        }
    }
}
/**
 * @param {?} view
 * @param {?} action
 * @return {?}
 */
function execEmbeddedViewsAction(view, action) {
    var /** @type {?} */ def = view.def;
    if (!(def.nodeFlags & 8388608 /* EmbeddedViews */)) {
        return;
    }
    for (var /** @type {?} */ i = 0; i < def.nodes.length; i++) {
        var /** @type {?} */ nodeDef = def.nodes[i];
        if (nodeDef.flags & 8388608 /* EmbeddedViews */) {
            // a leaf
            var /** @type {?} */ embeddedViews = ((asElementData(view, i).viewContainer))._embeddedViews;
            for (var /** @type {?} */ k = 0; k < embeddedViews.length; k++) {
                callViewAction(embeddedViews[k], action);
            }
        }
        else if ((nodeDef.childFlags & 8388608 /* EmbeddedViews */) === 0) {
            // a parent with leafs
            // no child is a component,
            // then skip the children
            i += nodeDef.childCount;
        }
    }
}
/**
 * @param {?} view
 * @param {?} action
 * @return {?}
 */
function callViewAction(view, action) {
    var /** @type {?} */ viewState = view.state;
    switch (action) {
        case ViewAction.CheckNoChanges:
            if ((viewState & 2 /* ChecksEnabled */) &&
                (viewState & (4 /* Errored */ | 8 /* Destroyed */)) === 0) {
                checkNoChangesView(view);
            }
            break;
        case ViewAction.CheckAndUpdate:
            if ((viewState & 2 /* ChecksEnabled */) &&
                (viewState & (4 /* Errored */ | 8 /* Destroyed */)) === 0) {
                checkAndUpdateView(view);
            }
            break;
        case ViewAction.Destroy:
            destroyView(view);
            break;
        case ViewAction.CreateViewNodes:
            createViewNodes(view);
            break;
    }
}
/**
 * @param {?} view
 * @param {?} queryFlags
 * @param {?} staticDynamicQueryFlag
 * @param {?} checkType
 * @return {?}
 */
function execQueriesAction(view, queryFlags, staticDynamicQueryFlag, checkType) {
    if (!(view.def.nodeFlags & queryFlags) || !(view.def.nodeFlags & staticDynamicQueryFlag)) {
        return;
    }
    var /** @type {?} */ nodeCount = view.def.nodes.length;
    for (var /** @type {?} */ i = 0; i < nodeCount; i++) {
        var /** @type {?} */ nodeDef = view.def.nodes[i];
        if ((nodeDef.flags & queryFlags) && (nodeDef.flags & staticDynamicQueryFlag)) {
            Services.setCurrentNode(view, nodeDef.index);
            switch (checkType) {
                case 0 /* CheckAndUpdate */:
                    checkAndUpdateQuery(view, nodeDef);
                    break;
                case 1 /* CheckNoChanges */:
                    checkNoChangesQuery(view, nodeDef);
                    break;
            }
        }
        if (!(nodeDef.childFlags & queryFlags) || !(nodeDef.childFlags & staticDynamicQueryFlag)) {
            // no child has a matching query
            // then skip the children
            i += nodeDef.childCount;
        }
    }
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var initialized = false;
/**
 * @return {?}
 */
function initServicesIfNeeded() {
    if (initialized) {
        return;
    }
    initialized = true;
    var /** @type {?} */ services = isDevMode() ? createDebugServices() : createProdServices();
    Services.setCurrentNode = services.setCurrentNode;
    Services.createRootView = services.createRootView;
    Services.createEmbeddedView = services.createEmbeddedView;
    Services.checkAndUpdateView = services.checkAndUpdateView;
    Services.checkNoChangesView = services.checkNoChangesView;
    Services.destroyView = services.destroyView;
    Services.resolveDep = resolveDep;
    Services.createDebugContext = services.createDebugContext;
    Services.handleEvent = services.handleEvent;
    Services.updateDirectives = services.updateDirectives;
    Services.updateRenderer = services.updateRenderer;
    Services.dirtyParentQueries = dirtyParentQueries;
}
/**
 * @return {?}
 */
function createProdServices() {
    return {
        setCurrentNode: function () { },
        createRootView: createProdRootView,
        createEmbeddedView: createEmbeddedView,
        checkAndUpdateView: checkAndUpdateView,
        checkNoChangesView: checkNoChangesView,
        destroyView: destroyView,
        createDebugContext: function (view, nodeIndex) { return new DebugContext_(view, nodeIndex); },
        handleEvent: function (view, nodeIndex, eventName, event) { return view.def.handleEvent(view, nodeIndex, eventName, event); },
        updateDirectives: function (view, checkType) { return view.def.updateDirectives(checkType === 0 /* CheckAndUpdate */ ? prodCheckAndUpdateNode :
            prodCheckNoChangesNode, view); },
        updateRenderer: function (view, checkType) { return view.def.updateRenderer(checkType === 0 /* CheckAndUpdate */ ? prodCheckAndUpdateNode :
            prodCheckNoChangesNode, view); },
    };
}
/**
 * @return {?}
 */
function createDebugServices() {
    return {
        setCurrentNode: debugSetCurrentNode,
        createRootView: debugCreateRootView,
        createEmbeddedView: debugCreateEmbeddedView,
        checkAndUpdateView: debugCheckAndUpdateView,
        checkNoChangesView: debugCheckNoChangesView,
        destroyView: debugDestroyView,
        createDebugContext: function (view, nodeIndex) { return new DebugContext_(view, nodeIndex); },
        handleEvent: debugHandleEvent,
        updateDirectives: debugUpdateDirectives,
        updateRenderer: debugUpdateRenderer
    };
}
/**
 * @param {?} elInjector
 * @param {?} projectableNodes
 * @param {?} rootSelectorOrNode
 * @param {?} def
 * @param {?} ngModule
 * @param {?=} context
 * @return {?}
 */
function createProdRootView(elInjector, projectableNodes, rootSelectorOrNode, def, ngModule, context) {
    var /** @type {?} */ rendererFactory = ngModule.injector.get(RendererFactory2);
    return createRootView(createRootData(elInjector, ngModule, rendererFactory, projectableNodes, rootSelectorOrNode), def, context);
}
/**
 * @param {?} elInjector
 * @param {?} projectableNodes
 * @param {?} rootSelectorOrNode
 * @param {?} def
 * @param {?} ngModule
 * @param {?=} context
 * @return {?}
 */
function debugCreateRootView(elInjector, projectableNodes, rootSelectorOrNode, def, ngModule, context) {
    var /** @type {?} */ rendererFactory = ngModule.injector.get(RendererFactory2);
    var /** @type {?} */ root = createRootData(elInjector, ngModule, new DebugRendererFactory2(rendererFactory), projectableNodes, rootSelectorOrNode);
    return callWithDebugContext(DebugAction.create, createRootView, null, [root, def, context]);
}
/**
 * @param {?} elInjector
 * @param {?} ngModule
 * @param {?} rendererFactory
 * @param {?} projectableNodes
 * @param {?} rootSelectorOrNode
 * @return {?}
 */
function createRootData(elInjector, ngModule, rendererFactory, projectableNodes, rootSelectorOrNode) {
    var /** @type {?} */ sanitizer = ngModule.injector.get(Sanitizer);
    var /** @type {?} */ renderer = rendererFactory.createRenderer(null, null);
    return {
        ngModule: ngModule,
        injector: elInjector, projectableNodes: projectableNodes,
        selectorOrNode: rootSelectorOrNode, sanitizer: sanitizer, rendererFactory: rendererFactory, renderer: renderer
    };
}
/**
 * @param {?} view
 * @param {?} nodeIndex
 * @param {?} argStyle
 * @param {?=} v0
 * @param {?=} v1
 * @param {?=} v2
 * @param {?=} v3
 * @param {?=} v4
 * @param {?=} v5
 * @param {?=} v6
 * @param {?=} v7
 * @param {?=} v8
 * @param {?=} v9
 * @return {?}
 */
function prodCheckAndUpdateNode(view, nodeIndex, argStyle, v0, v1, v2, v3, v4, v5, v6, v7, v8, v9) {
    var /** @type {?} */ nodeDef = view.def.nodes[nodeIndex];
    checkAndUpdateNode(view, nodeDef, argStyle, v0, v1, v2, v3, v4, v5, v6, v7, v8, v9);
    return (nodeDef.flags & 112 /* CatPureExpression */) ?
        asPureExpressionData(view, nodeIndex).value :
        undefined;
}
/**
 * @param {?} view
 * @param {?} nodeIndex
 * @param {?} argStyle
 * @param {?=} v0
 * @param {?=} v1
 * @param {?=} v2
 * @param {?=} v3
 * @param {?=} v4
 * @param {?=} v5
 * @param {?=} v6
 * @param {?=} v7
 * @param {?=} v8
 * @param {?=} v9
 * @return {?}
 */
function prodCheckNoChangesNode(view, nodeIndex, argStyle, v0, v1, v2, v3, v4, v5, v6, v7, v8, v9) {
    var /** @type {?} */ nodeDef = view.def.nodes[nodeIndex];
    checkNoChangesNode(view, nodeDef, argStyle, v0, v1, v2, v3, v4, v5, v6, v7, v8, v9);
    return (nodeDef.flags & 112 /* CatPureExpression */) ?
        asPureExpressionData(view, nodeIndex).value :
        undefined;
}
/**
 * @param {?} parent
 * @param {?} anchorDef
 * @param {?=} context
 * @return {?}
 */
function debugCreateEmbeddedView(parent, anchorDef, context) {
    return callWithDebugContext(DebugAction.create, createEmbeddedView, null, [parent, anchorDef, context]);
}
/**
 * @param {?} view
 * @return {?}
 */
function debugCheckAndUpdateView(view) {
    return callWithDebugContext(DebugAction.detectChanges, checkAndUpdateView, null, [view]);
}
/**
 * @param {?} view
 * @return {?}
 */
function debugCheckNoChangesView(view) {
    return callWithDebugContext(DebugAction.checkNoChanges, checkNoChangesView, null, [view]);
}
/**
 * @param {?} view
 * @return {?}
 */
function debugDestroyView(view) {
    return callWithDebugContext(DebugAction.destroy, destroyView, null, [view]);
}
var DebugAction = {};
DebugAction.create = 0;
DebugAction.detectChanges = 1;
DebugAction.checkNoChanges = 2;
DebugAction.destroy = 3;
DebugAction.handleEvent = 4;
DebugAction[DebugAction.create] = "create";
DebugAction[DebugAction.detectChanges] = "detectChanges";
DebugAction[DebugAction.checkNoChanges] = "checkNoChanges";
DebugAction[DebugAction.destroy] = "destroy";
DebugAction[DebugAction.handleEvent] = "handleEvent";
var _currentAction;
var _currentView;
var _currentNodeIndex;
/**
 * @param {?} view
 * @param {?} nodeIndex
 * @return {?}
 */
function debugSetCurrentNode(view, nodeIndex) {
    _currentView = view;
    _currentNodeIndex = nodeIndex;
}
/**
 * @param {?} view
 * @param {?} nodeIndex
 * @param {?} eventName
 * @param {?} event
 * @return {?}
 */
function debugHandleEvent(view, nodeIndex, eventName, event) {
    debugSetCurrentNode(view, nodeIndex);
    return callWithDebugContext(DebugAction.handleEvent, view.def.handleEvent, null, [view, nodeIndex, eventName, event]);
}
/**
 * @param {?} view
 * @param {?} checkType
 * @return {?}
 */
function debugUpdateDirectives(view, checkType) {
    if (view.state & 8 /* Destroyed */) {
        throw viewDestroyedError(DebugAction[_currentAction]);
    }
    debugSetCurrentNode(view, nextDirectiveWithBinding(view, 0));
    return view.def.updateDirectives(debugCheckDirectivesFn, view);
    /**
     * @param {?} view
     * @param {?} nodeIndex
     * @param {?} argStyle
     * @param {...?} values
     * @return {?}
     */
    function debugCheckDirectivesFn(view, nodeIndex, argStyle) {
        var values = [];
        for (var _i = 3; _i < arguments.length; _i++) {
            values[_i - 3] = arguments[_i];
        }
        var /** @type {?} */ nodeDef = view.def.nodes[nodeIndex];
        if (checkType === 0 /* CheckAndUpdate */) {
            debugCheckAndUpdateNode(view, nodeDef, argStyle, values);
        }
        else {
            debugCheckNoChangesNode(view, nodeDef, argStyle, values);
        }
        if (nodeDef.flags & 8192 /* TypeDirective */) {
            debugSetCurrentNode(view, nextDirectiveWithBinding(view, nodeIndex));
        }
        return (nodeDef.flags & 112 /* CatPureExpression */) ?
            asPureExpressionData(view, nodeDef.index).value :
            undefined;
    }
}
/**
 * @param {?} view
 * @param {?} checkType
 * @return {?}
 */
function debugUpdateRenderer(view, checkType) {
    if (view.state & 8 /* Destroyed */) {
        throw viewDestroyedError(DebugAction[_currentAction]);
    }
    debugSetCurrentNode(view, nextRenderNodeWithBinding(view, 0));
    return view.def.updateRenderer(debugCheckRenderNodeFn, view);
    /**
     * @param {?} view
     * @param {?} nodeIndex
     * @param {?} argStyle
     * @param {...?} values
     * @return {?}
     */
    function debugCheckRenderNodeFn(view, nodeIndex, argStyle) {
        var values = [];
        for (var _i = 3; _i < arguments.length; _i++) {
            values[_i - 3] = arguments[_i];
        }
        var /** @type {?} */ nodeDef = view.def.nodes[nodeIndex];
        if (checkType === 0 /* CheckAndUpdate */) {
            debugCheckAndUpdateNode(view, nodeDef, argStyle, values);
        }
        else {
            debugCheckNoChangesNode(view, nodeDef, argStyle, values);
        }
        if (nodeDef.flags & 3 /* CatRenderNode */) {
            debugSetCurrentNode(view, nextRenderNodeWithBinding(view, nodeIndex));
        }
        return (nodeDef.flags & 112 /* CatPureExpression */) ?
            asPureExpressionData(view, nodeDef.index).value :
            undefined;
    }
}
/**
 * @param {?} view
 * @param {?} nodeDef
 * @param {?} argStyle
 * @param {?} givenValues
 * @return {?}
 */
function debugCheckAndUpdateNode(view, nodeDef, argStyle, givenValues) {
    var /** @type {?} */ changed = ((checkAndUpdateNode)).apply(void 0, [view, nodeDef, argStyle].concat(givenValues));
    if (changed) {
        var /** @type {?} */ values = argStyle === 1 /* Dynamic */ ? givenValues[0] : givenValues;
        if (nodeDef.flags & 8192 /* TypeDirective */) {
            var /** @type {?} */ bindingValues = {};
            for (var /** @type {?} */ i = 0; i < nodeDef.bindings.length; i++) {
                var /** @type {?} */ binding = nodeDef.bindings[i];
                var /** @type {?} */ value = values[i];
                if (binding.flags & 8 /* TypeProperty */) {
                    bindingValues[normalizeDebugBindingName(/** @type {?} */ ((binding.nonMinifiedName)))] =
                        normalizeDebugBindingValue(value);
                }
            }
            var /** @type {?} */ elDef = ((nodeDef.parent));
            var /** @type {?} */ el = asElementData(view, elDef.index).renderElement;
            if (!((elDef.element)).name) {
                // a comment.
                view.renderer.setValue(el, "bindings=" + JSON.stringify(bindingValues, null, 2));
            }
            else {
                // a regular element.
                for (var /** @type {?} */ attr in bindingValues) {
                    var /** @type {?} */ value = bindingValues[attr];
                    if (value != null) {
                        view.renderer.setAttribute(el, attr, value);
                    }
                    else {
                        view.renderer.removeAttribute(el, attr);
                    }
                }
            }
        }
    }
}
/**
 * @param {?} view
 * @param {?} nodeDef
 * @param {?} argStyle
 * @param {?} values
 * @return {?}
 */
function debugCheckNoChangesNode(view, nodeDef, argStyle, values) {
    ((checkNoChangesNode)).apply(void 0, [view, nodeDef, argStyle].concat(values));
}
/**
 * @param {?} name
 * @return {?}
 */
function normalizeDebugBindingName(name) {
    // Attribute names with `$` (eg `x-y$`) are valid per spec, but unsupported by some browsers
    name = camelCaseToDashCase(name.replace(/[$@]/g, '_'));
    return "ng-reflect-" + name;
}
var CAMEL_CASE_REGEXP = /([A-Z])/g;
/**
 * @param {?} input
 * @return {?}
 */
function camelCaseToDashCase(input) {
    return input.replace(CAMEL_CASE_REGEXP, function () {
        var m = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            m[_i] = arguments[_i];
        }
        return '-' + m[1].toLowerCase();
    });
}
/**
 * @param {?} value
 * @return {?}
 */
function normalizeDebugBindingValue(value) {
    try {
        // Limit the size of the value as otherwise the DOM just gets polluted.
        return value != null ? value.toString().slice(0, 30) : value;
    }
    catch (e) {
        return '[ERROR] Exception while trying to serialize the value';
    }
}
/**
 * @param {?} view
 * @param {?} nodeIndex
 * @return {?}
 */
function nextDirectiveWithBinding(view, nodeIndex) {
    for (var /** @type {?} */ i = nodeIndex; i < view.def.nodes.length; i++) {
        var /** @type {?} */ nodeDef = view.def.nodes[i];
        if (nodeDef.flags & 8192 /* TypeDirective */ && nodeDef.bindings && nodeDef.bindings.length) {
            return i;
        }
    }
    return null;
}
/**
 * @param {?} view
 * @param {?} nodeIndex
 * @return {?}
 */
function nextRenderNodeWithBinding(view, nodeIndex) {
    for (var /** @type {?} */ i = nodeIndex; i < view.def.nodes.length; i++) {
        var /** @type {?} */ nodeDef = view.def.nodes[i];
        if ((nodeDef.flags & 3 /* CatRenderNode */) && nodeDef.bindings && nodeDef.bindings.length) {
            return i;
        }
    }
    return null;
}
var DebugContext_ = (function () {
    /**
     * @param {?} view
     * @param {?} nodeIndex
     */
    function DebugContext_(view, nodeIndex) {
        this.view = view;
        this.nodeIndex = nodeIndex;
        if (nodeIndex == null) {
            this.nodeIndex = nodeIndex = 0;
        }
        this.nodeDef = view.def.nodes[nodeIndex];
        var elDef = this.nodeDef;
        var elView = view;
        while (elDef && (elDef.flags & 1 /* TypeElement */) === 0) {
            elDef = elDef.parent;
        }
        if (!elDef) {
            while (!elDef && elView) {
                elDef = viewParentEl(elView);
                elView = elView.parent;
            }
        }
        this.elDef = elDef;
        this.elView = elView;
    }
    Object.defineProperty(DebugContext_.prototype, "elOrCompView", {
        /**
         * @return {?}
         */
        get: function () {
            // Has to be done lazily as we use the DebugContext also during creation of elements...
            return asElementData(this.elView, this.elDef.index).componentView || this.view;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DebugContext_.prototype, "injector", {
        /**
         * @return {?}
         */
        get: function () { return createInjector(this.elView, this.elDef); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DebugContext_.prototype, "component", {
        /**
         * @return {?}
         */
        get: function () { return this.elOrCompView.component; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DebugContext_.prototype, "context", {
        /**
         * @return {?}
         */
        get: function () { return this.elOrCompView.context; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DebugContext_.prototype, "providerTokens", {
        /**
         * @return {?}
         */
        get: function () {
            var /** @type {?} */ tokens = [];
            if (this.elDef) {
                for (var /** @type {?} */ i = this.elDef.index + 1; i <= this.elDef.index + this.elDef.childCount; i++) {
                    var /** @type {?} */ childDef = this.elView.def.nodes[i];
                    if (childDef.flags & 10112 /* CatProvider */) {
                        tokens.push(/** @type {?} */ ((childDef.provider)).token);
                    }
                    i += childDef.childCount;
                }
            }
            return tokens;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DebugContext_.prototype, "references", {
        /**
         * @return {?}
         */
        get: function () {
            var /** @type {?} */ references = {};
            if (this.elDef) {
                collectReferences(this.elView, this.elDef, references);
                for (var /** @type {?} */ i = this.elDef.index + 1; i <= this.elDef.index + this.elDef.childCount; i++) {
                    var /** @type {?} */ childDef = this.elView.def.nodes[i];
                    if (childDef.flags & 10112 /* CatProvider */) {
                        collectReferences(this.elView, childDef, references);
                    }
                    i += childDef.childCount;
                }
            }
            return references;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DebugContext_.prototype, "componentRenderElement", {
        /**
         * @return {?}
         */
        get: function () {
            var /** @type {?} */ elData = findHostElement(this.elOrCompView);
            return elData ? elData.renderElement : undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DebugContext_.prototype, "renderNode", {
        /**
         * @return {?}
         */
        get: function () {
            return this.nodeDef.flags & 2 /* TypeText */ ? renderNode(this.view, this.nodeDef) :
                renderNode(this.elView, this.elDef);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} console
     * @param {...?} values
     * @return {?}
     */
    DebugContext_.prototype.logError = function (console) {
        var values = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            values[_i - 1] = arguments[_i];
        }
        var /** @type {?} */ logViewDef;
        var /** @type {?} */ logNodeIndex;
        if (this.nodeDef.flags & 2 /* TypeText */) {
            logViewDef = this.view.def;
            logNodeIndex = this.nodeDef.index;
        }
        else {
            logViewDef = this.elView.def;
            logNodeIndex = this.elDef.index;
        }
        // Note: we only generate a log function for text and element nodes
        // to make the generated code as small as possible.
        var /** @type {?} */ renderNodeIndex = getRenderNodeIndex(logViewDef, logNodeIndex);
        var /** @type {?} */ currRenderNodeIndex = -1;
        var /** @type {?} */ nodeLogger = function () {
            currRenderNodeIndex++;
            if (currRenderNodeIndex === renderNodeIndex) {
                return (_a = console.error).bind.apply(_a, [console].concat(values));
            }
            else {
                return NOOP;
            }
            var _a;
        }; /** @type {?} */
        ((logViewDef.factory))(nodeLogger);
        if (currRenderNodeIndex < renderNodeIndex) {
            console.error('Illegal state: the ViewDefinitionFactory did not call the logger!');
            console.error.apply(console, values);
        }
    };
    return DebugContext_;
}());
/**
 * @param {?} viewDef
 * @param {?} nodeIndex
 * @return {?}
 */
function getRenderNodeIndex(viewDef$$1, nodeIndex) {
    var /** @type {?} */ renderNodeIndex = -1;
    for (var /** @type {?} */ i = 0; i <= nodeIndex; i++) {
        var /** @type {?} */ nodeDef = viewDef$$1.nodes[i];
        if (nodeDef.flags & 3 /* CatRenderNode */) {
            renderNodeIndex++;
        }
    }
    return renderNodeIndex;
}
/**
 * @param {?} view
 * @return {?}
 */
function findHostElement(view) {
    while (view && !isComponentView(view)) {
        view = ((view.parent));
    }
    if (view.parent) {
        return asElementData(view.parent, /** @type {?} */ ((viewParentEl(view))).index);
    }
    return null;
}
/**
 * @param {?} view
 * @param {?} nodeDef
 * @param {?} references
 * @return {?}
 */
function collectReferences(view, nodeDef, references) {
    for (var /** @type {?} */ refName in nodeDef.references) {
        references[refName] = getQueryValue(view, nodeDef, nodeDef.references[refName]);
    }
}
/**
 * @param {?} action
 * @param {?} fn
 * @param {?} self
 * @param {?} args
 * @return {?}
 */
function callWithDebugContext(action, fn, self, args) {
    var /** @type {?} */ oldAction = _currentAction;
    var /** @type {?} */ oldView = _currentView;
    var /** @type {?} */ oldNodeIndex = _currentNodeIndex;
    try {
        _currentAction = action;
        var /** @type {?} */ result = fn.apply(self, args);
        _currentView = oldView;
        _currentNodeIndex = oldNodeIndex;
        _currentAction = oldAction;
        return result;
    }
    catch (e) {
        if (isViewDebugError(e) || !_currentView) {
            throw e;
        }
        _currentView.state |= 4 /* Errored */;
        throw viewWrappedDebugError(e, /** @type {?} */ ((getCurrentDebugContext())));
    }
}
/**
 * @return {?}
 */
function getCurrentDebugContext() {
    return _currentView ? new DebugContext_(_currentView, _currentNodeIndex) : null;
}
var DebugRendererFactory2 = (function () {
    /**
     * @param {?} delegate
     */
    function DebugRendererFactory2(delegate) {
        this.delegate = delegate;
    }
    /**
     * @param {?} element
     * @param {?} renderData
     * @return {?}
     */
    DebugRendererFactory2.prototype.createRenderer = function (element, renderData) {
        return new DebugRenderer2(this.delegate.createRenderer(element, renderData));
    };
    return DebugRendererFactory2;
}());
var DebugRenderer2 = (function () {
    /**
     * @param {?} delegate
     */
    function DebugRenderer2(delegate) {
        this.delegate = delegate;
    }
    Object.defineProperty(DebugRenderer2.prototype, "data", {
        /**
         * @return {?}
         */
        get: function () { return this.delegate.data; },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} node
     * @return {?}
     */
    DebugRenderer2.prototype.destroyNode = function (node) {
        removeDebugNodeFromIndex(/** @type {?} */ ((getDebugNode(node))));
        if (this.delegate.destroyNode) {
            this.delegate.destroyNode(node);
        }
    };
    /**
     * @return {?}
     */
    DebugRenderer2.prototype.destroy = function () { this.delegate.destroy(); };
    /**
     * @param {?} name
     * @param {?=} namespace
     * @return {?}
     */
    DebugRenderer2.prototype.createElement = function (name, namespace) {
        var /** @type {?} */ el = this.delegate.createElement(name, namespace);
        var /** @type {?} */ debugCtx = getCurrentDebugContext();
        if (debugCtx) {
            var /** @type {?} */ debugEl = new DebugElement(el, null, debugCtx);
            debugEl.name = name;
            indexDebugNode(debugEl);
        }
        return el;
    };
    /**
     * @param {?} value
     * @return {?}
     */
    DebugRenderer2.prototype.createComment = function (value) {
        var /** @type {?} */ comment = this.delegate.createComment(value);
        var /** @type {?} */ debugCtx = getCurrentDebugContext();
        if (debugCtx) {
            indexDebugNode(new DebugNode(comment, null, debugCtx));
        }
        return comment;
    };
    /**
     * @param {?} value
     * @return {?}
     */
    DebugRenderer2.prototype.createText = function (value) {
        var /** @type {?} */ text = this.delegate.createText(value);
        var /** @type {?} */ debugCtx = getCurrentDebugContext();
        if (debugCtx) {
            indexDebugNode(new DebugNode(text, null, debugCtx));
        }
        return text;
    };
    /**
     * @param {?} parent
     * @param {?} newChild
     * @return {?}
     */
    DebugRenderer2.prototype.appendChild = function (parent, newChild) {
        var /** @type {?} */ debugEl = getDebugNode(parent);
        var /** @type {?} */ debugChildEl = getDebugNode(newChild);
        if (debugEl && debugChildEl && debugEl instanceof DebugElement) {
            debugEl.addChild(debugChildEl);
        }
        this.delegate.appendChild(parent, newChild);
    };
    /**
     * @param {?} parent
     * @param {?} newChild
     * @param {?} refChild
     * @return {?}
     */
    DebugRenderer2.prototype.insertBefore = function (parent, newChild, refChild) {
        var /** @type {?} */ debugEl = getDebugNode(parent);
        var /** @type {?} */ debugChildEl = getDebugNode(newChild);
        var /** @type {?} */ debugRefEl = ((getDebugNode(refChild)));
        if (debugEl && debugChildEl && debugEl instanceof DebugElement) {
            debugEl.insertBefore(debugRefEl, debugChildEl);
        }
        this.delegate.insertBefore(parent, newChild, refChild);
    };
    /**
     * @param {?} parent
     * @param {?} oldChild
     * @return {?}
     */
    DebugRenderer2.prototype.removeChild = function (parent, oldChild) {
        var /** @type {?} */ debugEl = getDebugNode(parent);
        var /** @type {?} */ debugChildEl = getDebugNode(oldChild);
        if (debugEl && debugChildEl && debugEl instanceof DebugElement) {
            debugEl.removeChild(debugChildEl);
        }
        this.delegate.removeChild(parent, oldChild);
    };
    /**
     * @param {?} selectorOrNode
     * @return {?}
     */
    DebugRenderer2.prototype.selectRootElement = function (selectorOrNode) {
        var /** @type {?} */ el = this.delegate.selectRootElement(selectorOrNode);
        var /** @type {?} */ debugCtx = getCurrentDebugContext();
        if (debugCtx) {
            indexDebugNode(new DebugElement(el, null, debugCtx));
        }
        return el;
    };
    /**
     * @param {?} el
     * @param {?} name
     * @param {?} value
     * @param {?=} namespace
     * @return {?}
     */
    DebugRenderer2.prototype.setAttribute = function (el, name, value, namespace) {
        var /** @type {?} */ debugEl = getDebugNode(el);
        if (debugEl && debugEl instanceof DebugElement) {
            var /** @type {?} */ fullName = namespace ? namespace + ':' + name : name;
            debugEl.attributes[fullName] = value;
        }
        this.delegate.setAttribute(el, name, value, namespace);
    };
    /**
     * @param {?} el
     * @param {?} name
     * @param {?=} namespace
     * @return {?}
     */
    DebugRenderer2.prototype.removeAttribute = function (el, name, namespace) {
        var /** @type {?} */ debugEl = getDebugNode(el);
        if (debugEl && debugEl instanceof DebugElement) {
            var /** @type {?} */ fullName = namespace ? namespace + ':' + name : name;
            debugEl.attributes[fullName] = null;
        }
        this.delegate.removeAttribute(el, name, namespace);
    };
    /**
     * @param {?} el
     * @param {?} name
     * @return {?}
     */
    DebugRenderer2.prototype.addClass = function (el, name) {
        var /** @type {?} */ debugEl = getDebugNode(el);
        if (debugEl && debugEl instanceof DebugElement) {
            debugEl.classes[name] = true;
        }
        this.delegate.addClass(el, name);
    };
    /**
     * @param {?} el
     * @param {?} name
     * @return {?}
     */
    DebugRenderer2.prototype.removeClass = function (el, name) {
        var /** @type {?} */ debugEl = getDebugNode(el);
        if (debugEl && debugEl instanceof DebugElement) {
            debugEl.classes[name] = false;
        }
        this.delegate.removeClass(el, name);
    };
    /**
     * @param {?} el
     * @param {?} style
     * @param {?} value
     * @param {?} flags
     * @return {?}
     */
    DebugRenderer2.prototype.setStyle = function (el, style, value, flags) {
        var /** @type {?} */ debugEl = getDebugNode(el);
        if (debugEl && debugEl instanceof DebugElement) {
            debugEl.styles[style] = value;
        }
        this.delegate.setStyle(el, style, value, flags);
    };
    /**
     * @param {?} el
     * @param {?} style
     * @param {?} flags
     * @return {?}
     */
    DebugRenderer2.prototype.removeStyle = function (el, style, flags) {
        var /** @type {?} */ debugEl = getDebugNode(el);
        if (debugEl && debugEl instanceof DebugElement) {
            debugEl.styles[style] = null;
        }
        this.delegate.removeStyle(el, style, flags);
    };
    /**
     * @param {?} el
     * @param {?} name
     * @param {?} value
     * @return {?}
     */
    DebugRenderer2.prototype.setProperty = function (el, name, value) {
        var /** @type {?} */ debugEl = getDebugNode(el);
        if (debugEl && debugEl instanceof DebugElement) {
            debugEl.properties[name] = value;
        }
        this.delegate.setProperty(el, name, value);
    };
    /**
     * @param {?} target
     * @param {?} eventName
     * @param {?} callback
     * @return {?}
     */
    DebugRenderer2.prototype.listen = function (target, eventName, callback) {
        if (typeof target !== 'string') {
            var /** @type {?} */ debugEl = getDebugNode(target);
            if (debugEl) {
                debugEl.listeners.push(new EventListener(eventName, callback));
            }
        }
        return this.delegate.listen(target, eventName, callback);
    };
    /**
     * @param {?} node
     * @return {?}
     */
    DebugRenderer2.prototype.parentNode = function (node) { return this.delegate.parentNode(node); };
    /**
     * @param {?} node
     * @return {?}
     */
    DebugRenderer2.prototype.nextSibling = function (node) { return this.delegate.nextSibling(node); };
    /**
     * @param {?} node
     * @param {?} value
     * @return {?}
     */
    DebugRenderer2.prototype.setValue = function (node, value) { return this.delegate.setValue(node, value); };
    return DebugRenderer2;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @return {?}
 */
function _iterableDiffersFactory() {
    return defaultIterableDiffers;
}
/**
 * @return {?}
 */
function _keyValueDiffersFactory() {
    return defaultKeyValueDiffers;
}
/**
 * @param {?=} locale
 * @return {?}
 */
function _localeFactory(locale) {
    return locale || 'en-US';
}
/**
 * @return {?}
 */
function _initViewEngine() {
    initServicesIfNeeded();
}
/**
 * This module includes the providers of \@angular/core that are needed
 * to bootstrap components via `ApplicationRef`.
 *
 * \@experimental
 */
var ApplicationModule = (function () {
    /**
     * @param {?} appRef
     */
    function ApplicationModule(appRef) {
    }
    return ApplicationModule;
}());
ApplicationModule.decorators = [
    { type: NgModule, args: [{
                providers: [
                    ApplicationRef_,
                    { provide: ApplicationRef, useExisting: ApplicationRef_ },
                    ApplicationInitStatus,
                    Compiler,
                    APP_ID_RANDOM_PROVIDER,
                    { provide: IterableDiffers, useFactory: _iterableDiffersFactory },
                    { provide: KeyValueDiffers, useFactory: _keyValueDiffersFactory },
                    {
                        provide: LOCALE_ID,
                        useFactory: _localeFactory,
                        deps: [[new Inject(LOCALE_ID), new Optional(), new SkipSelf()]]
                    },
                    { provide: APP_INITIALIZER, useValue: _initViewEngine, multi: true },
                ]
            },] },
];
/**
 * @nocollapse
 */
ApplicationModule.ctorParameters = function () { return [
    { type: ApplicationRef, },
]; };
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var LifecycleHooks = {};
LifecycleHooks.OnInit = 0;
LifecycleHooks.OnDestroy = 1;
LifecycleHooks.DoCheck = 2;
LifecycleHooks.OnChanges = 3;
LifecycleHooks.AfterContentInit = 4;
LifecycleHooks.AfterContentChecked = 5;
LifecycleHooks.AfterViewInit = 6;
LifecycleHooks.AfterViewChecked = 7;
LifecycleHooks[LifecycleHooks.OnInit] = "OnInit";
LifecycleHooks[LifecycleHooks.OnDestroy] = "OnDestroy";
LifecycleHooks[LifecycleHooks.DoCheck] = "DoCheck";
LifecycleHooks[LifecycleHooks.OnChanges] = "OnChanges";
LifecycleHooks[LifecycleHooks.AfterContentInit] = "AfterContentInit";
LifecycleHooks[LifecycleHooks.AfterContentChecked] = "AfterContentChecked";
LifecycleHooks[LifecycleHooks.AfterViewInit] = "AfterViewInit";
LifecycleHooks[LifecycleHooks.AfterViewChecked] = "AfterViewChecked";
var LIFECYCLE_HOOKS_VALUES = [
    LifecycleHooks.OnInit, LifecycleHooks.OnDestroy, LifecycleHooks.DoCheck, LifecycleHooks.OnChanges,
    LifecycleHooks.AfterContentInit, LifecycleHooks.AfterContentChecked, LifecycleHooks.AfterViewInit,
    LifecycleHooks.AfterViewChecked
];
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * \@experimental Animation support is experimental.
 */
/**
 * `trigger` is an animation-specific function that is designed to be used inside of Angular's
 * animation DSL language. If this information is new, please navigate to the {\@link
 * Component#animations-anchor component animations metadata page} to gain a better understanding of
 * how animations in Angular are used.
 *
 * `trigger` Creates an animation trigger which will a list of {\@link state state} and {\@link
 * transition transition} entries that will be evaluated when the expression bound to the trigger
 * changes.
 *
 * Triggers are registered within the component annotation data under the {\@link
 * Component#animations-anchor animations section}. An animation trigger can be placed on an element
 * within a template by referencing the name of the trigger followed by the expression value that the
 * trigger is bound to (in the form of `[\@triggerName]="expression"`.
 *
 * ### Usage
 *
 * `trigger` will create an animation trigger reference based on the provided `name` value. The
 * provided `animation` value is expected to be an array consisting of {\@link state state} and {\@link
 * transition transition} declarations.
 *
 * ```typescript
 * \@Component({
 *   selector: 'my-component',
 *   templateUrl: 'my-component-tpl.html',
 *   animations: [
 *     trigger("myAnimationTrigger", [
 *       state(...),
 *       state(...),
 *       transition(...),
 *       transition(...)
 *     ])
 *   ]
 * })
 * class MyComponent {
 *   myStatusExp = "something";
 * }
 * ```
 *
 * The template associated with this component will make use of the `myAnimationTrigger` animation
 * trigger by binding to an element within its template code.
 *
 * ```html
 * <!-- somewhere inside of my-component-tpl.html -->
 * <div [\@myAnimationTrigger]="myStatusExp">...</div>
 * tools/gulp-tasks/validate-commit-message.js ```
 *
 * {\@example core/animation/ts/dsl/animation_example.ts region='Component'}
 *
 * \@experimental Animation support is experimental.
 * @param {?} name
 * @param {?} definitions
 * @return {?}
 */
function trigger$1(name, definitions) {
    return { name: name, definitions: definitions };
}
/**
 * `animate` is an animation-specific function that is designed to be used inside of Angular's
 * animation DSL language. If this information is new, please navigate to the {\@link
 * Component#animations-anchor component animations metadata page} to gain a better understanding of
 * how animations in Angular are used.
 *
 * `animate` specifies an animation step that will apply the provided `styles` data for a given
 * amount of time based on the provided `timing` expression value. Calls to `animate` are expected
 * to be used within {\@link sequence an animation sequence}, {\@link group group}, or {\@link
 * transition transition}.
 *
 * ### Usage
 *
 * The `animate` function accepts two input parameters: `timing` and `styles`:
 *
 * - `timing` is a string based value that can be a combination of a duration with optional delay
 * and easing values. The format for the expression breaks down to `duration delay easing`
 * (therefore a value such as `1s 100ms ease-out` will be parse itself into `duration=1000,
 * delay=100, easing=ease-out`. If a numeric value is provided then that will be used as the
 * `duration` value in millisecond form.
 * - `styles` is the style input data which can either be a call to {\@link style style} or {\@link
 * keyframes keyframes}. If left empty then the styles from the destination state will be collected
 * and used (this is useful when describing an animation step that will complete an animation by
 * {\@link transition#the-final-animate-call animating to the final state}).
 *
 * ```typescript
 * // various functions for specifying timing data
 * animate(500, style(...))
 * animate("1s", style(...))
 * animate("100ms 0.5s", style(...))
 * animate("5s ease", style(...))
 * animate("5s 10ms cubic-bezier(.17,.67,.88,.1)", style(...))
 *
 * // either style() of keyframes() can be used
 * animate(500, style({ background: "red" }))
 * animate(500, keyframes([
 *   style({ background: "blue" })),
 *   style({ background: "red" }))
 * ])
 * ```
 *
 * {\@example core/animation/ts/dsl/animation_example.ts region='Component'}
 *
 * \@experimental Animation support is experimental.
 * @param {?} timings
 * @param {?=} styles
 * @return {?}
 */
function animate$1(timings, styles) {
    if (styles === void 0) { styles = null; }
    return { type: 4 /* Animate */, styles: styles, timings: timings };
}
/**
 * `group` is an animation-specific function that is designed to be used inside of Angular's
 * animation DSL language. If this information is new, please navigate to the {\@link
 * Component#animations-anchor component animations metadata page} to gain a better understanding of
 * how animations in Angular are used.
 *
 * `group` specifies a list of animation steps that are all run in parallel. Grouped animations are
 * useful when a series of styles must be animated/closed off at different statrting/ending times.
 *
 * The `group` function can either be used within a {\@link sequence sequence} or a {\@link transition
 * transition} and it will only continue to the next instruction once all of the inner animation
 * steps have completed.
 *
 * ### Usage
 *
 * The `steps` data that is passed into the `group` animation function can either consist of {\@link
 * style style} or {\@link animate animate} function calls. Each call to `style()` or `animate()`
 * within a group will be executed instantly (use {\@link keyframes keyframes} or a {\@link
 * animate#usage animate() with a delay value} to offset styles to be applied at a later time).
 *
 * ```typescript
 * group([
 *   animate("1s", { background: "black" }))
 *   animate("2s", { color: "white" }))
 * ])
 * ```
 *
 * {\@example core/animation/ts/dsl/animation_example.ts region='Component'}
 *
 * \@experimental Animation support is experimental.
 * @param {?} steps
 * @return {?}
 */
function group$1(steps) {
    return { type: 3 /* Group */, steps: steps };
}
/**
 * `sequence` is an animation-specific function that is designed to be used inside of Angular's
 * animation DSL language. If this information is new, please navigate to the {\@link
 * Component#animations-anchor component animations metadata page} to gain a better understanding of
 * how animations in Angular are used.
 *
 * `sequence` Specifies a list of animation steps that are run one by one. (`sequence` is used by
 * default when an array is passed as animation data into {\@link transition transition}.)
 *
 * The `sequence` function can either be used within a {\@link group group} or a {\@link transition
 * transition} and it will only continue to the next instruction once each of the inner animation
 * steps have completed.
 *
 * To perform animation styling in parallel with other animation steps then have a look at the
 * {\@link group group} animation function.
 *
 * ### Usage
 *
 * The `steps` data that is passed into the `sequence` animation function can either consist of
 * {\@link style style} or {\@link animate animate} function calls. A call to `style()` will apply the
 * provided styling data immediately while a call to `animate()` will apply its styling data over a
 * given time depending on its timing data.
 *
 * ```typescript
 * sequence([
 *   style({ opacity: 0 })),
 *   animate("1s", { opacity: 1 }))
 * ])
 * ```
 *
 * {\@example core/animation/ts/dsl/animation_example.ts region='Component'}
 *
 * \@experimental Animation support is experimental.
 * @param {?} steps
 * @return {?}
 */
function sequence$1(steps) {
    return { type: 2 /* Sequence */, steps: steps };
}
/**
 * `style` is an animation-specific function that is designed to be used inside of Angular's
 * animation DSL language. If this information is new, please navigate to the {\@link
 * Component#animations-anchor component animations metadata page} to gain a better understanding of
 * how animations in Angular are used.
 *
 * `style` declares a key/value object containing CSS properties/styles that can then be used for
 * {\@link state animation states}, within an {\@link sequence animation sequence}, or as styling data
 * for both {\@link animate animate} and {\@link keyframes keyframes}.
 *
 * ### Usage
 *
 * `style` takes in a key/value string map as data and expects one or more CSS property/value pairs
 * to be defined.
 *
 * ```typescript
 * // string values are used for css properties
 * style({ background: "red", color: "blue" })
 *
 * // numerical (pixel) values are also supported
 * style({ width: 100, height: 0 })
 * ```
 *
 * #### Auto-styles (using `*`)
 *
 * When an asterix (`*`) character is used as a value then it will be detected from the element
 * being animated and applied as animation data when the animation starts.
 *
 * This feature proves useful for a state depending on layout and/or environment factors; in such
 * cases the styles are calculated just before the animation starts.
 *
 * ```typescript
 * // the steps below will animate from 0 to the
 * // actual height of the element
 * style({ height: 0 }),
 * animate("1s", style({ height: "*" }))
 * ```
 *
 * {\@example core/animation/ts/dsl/animation_example.ts region='Component'}
 *
 * \@experimental Animation support is experimental.
 * @param {?} tokens
 * @return {?}
 */
function style$1(tokens) {
    return { type: 6 /* Style */, styles: tokens };
}
/**
 * `state` is an animation-specific function that is designed to be used inside of Angular's
 * animation DSL language. If this information is new, please navigate to the {\@link
 * Component#animations-anchor component animations metadata page} to gain a better understanding of
 * how animations in Angular are used.
 *
 * `state` declares an animation state within the given trigger. When a state is active within a
 * component then its associated styles will persist on the element that the trigger is attached to
 * (even when the animation ends).
 *
 * To animate between states, have a look at the animation {\@link transition transition} DSL
 * function. To register states to an animation trigger please have a look at the {\@link trigger
 * trigger} function.
 *
 * #### The `void` state
 *
 * The `void` state value is a reserved word that angular uses to determine when the element is not
 * apart of the application anymore (e.g. when an `ngIf` evaluates to false then the state of the
 * associated element is void).
 *
 * #### The `*` (default) state
 *
 * The `*` state (when styled) is a fallback state that will be used if the state that is being
 * animated is not declared within the trigger.
 *
 * ### Usage
 *
 * `state` will declare an animation state with its associated styles
 * within the given trigger.
 *
 * - `stateNameExpr` can be one or more state names separated by commas.
 * - `styles` refers to the {\@link style styling data} that will be persisted on the element once
 * the state has been reached.
 *
 * ```typescript
 * // "void" is a reserved name for a state and is used to represent
 * // the state in which an element is detached from from the application.
 * state("void", style({ height: 0 }))
 *
 * // user-defined states
 * state("closed", style({ height: 0 }))
 * state("open, visible", style({ height: "*" }))
 * ```
 *
 * {\@example core/animation/ts/dsl/animation_example.ts region='Component'}
 *
 * \@experimental Animation support is experimental.
 * @param {?} name
 * @param {?} styles
 * @return {?}
 */
function state$1(name, styles) {
    return { type: 0 /* State */, name: name, styles: styles };
}
/**
 * `keyframes` is an animation-specific function that is designed to be used inside of Angular's
 * animation DSL language. If this information is new, please navigate to the {\@link
 * Component#animations-anchor component animations metadata page} to gain a better understanding of
 * how animations in Angular are used.
 *
 * `keyframes` specifies a collection of {\@link style style} entries each optionally characterized
 * by an `offset` value.
 *
 * ### Usage
 *
 * The `keyframes` animation function is designed to be used alongside the {\@link animate animate}
 * animation function. Instead of applying animations from where they are currently to their
 * destination, keyframes can describe how each style entry is applied and at what point within the
 * animation arc (much like CSS Keyframe Animations do).
 *
 * For each `style()` entry an `offset` value can be set. Doing so allows to specifiy at what
 * percentage of the animate time the styles will be applied.
 *
 * ```typescript
 * // the provided offset values describe when each backgroundColor value is applied.
 * animate("5s", keyframes([
 *   style({ backgroundColor: "red", offset: 0 }),
 *   style({ backgroundColor: "blue", offset: 0.2 }),
 *   style({ backgroundColor: "orange", offset: 0.3 }),
 *   style({ backgroundColor: "black", offset: 1 })
 * ]))
 * ```
 *
 * Alternatively, if there are no `offset` values used within the style entries then the offsets
 * will be calculated automatically.
 *
 * ```typescript
 * animate("5s", keyframes([
 *   style({ backgroundColor: "red" }) // offset = 0
 *   style({ backgroundColor: "blue" }) // offset = 0.33
 *   style({ backgroundColor: "orange" }) // offset = 0.66
 *   style({ backgroundColor: "black" }) // offset = 1
 * ]))
 * ```
 *
 * {\@example core/animation/ts/dsl/animation_example.ts region='Component'}
 *
 * \@experimental Animation support is experimental.
 * @param {?} steps
 * @return {?}
 */
function keyframes$1(steps) {
    return { type: 5 /* KeyframeSequence */, steps: steps };
}
/**
 * `transition` is an animation-specific function that is designed to be used inside of Angular's
 * animation DSL language. If this information is new, please navigate to the {\@link
 * Component#animations-anchor component animations metadata page} to gain a better understanding of
 * how animations in Angular are used.
 *
 * `transition` declares the {\@link sequence sequence of animation steps} that will be run when the
 * provided `stateChangeExpr` value is satisfied. The `stateChangeExpr` consists of a `state1 =>
 * state2` which consists of two known states (use an asterix (`*`) to refer to a dynamic starting
 * and/or ending state).
 *
 * A function can also be provided as the `stateChangeExpr` argument for a transition and this
 * function will be executed each time a state change occurs. If the value returned within the
 * function is true then the associated animation will be run.
 *
 * Animation transitions are placed within an {\@link trigger animation trigger}. For an transition
 * to animate to a state value and persist its styles then one or more {\@link state animation
 * states} is expected to be defined.
 *
 * ### Usage
 *
 * An animation transition is kicked off the `stateChangeExpr` predicate evaluates to true based on
 * what the previous state is and what the current state has become. In other words, if a transition
 * is defined that matches the old/current state criteria then the associated animation will be
 * triggered.
 *
 * ```typescript
 * // all transition/state changes are defined within an animation trigger
 * trigger("myAnimationTrigger", [
 *   // if a state is defined then its styles will be persisted when the
 *   // animation has fully completed itself
 *   state("on", style({ background: "green" })),
 *   state("off", style({ background: "grey" })),
 *
 *   // a transition animation that will be kicked off when the state value
 *   // bound to "myAnimationTrigger" changes from "on" to "off"
 *   transition("on => off", animate(500)),
 *
 *   // it is also possible to do run the same animation for both directions
 *   transition("on <=> off", animate(500)),
 *
 *   // or to define multiple states pairs separated by commas
 *   transition("on => off, off => void", animate(500)),
 *
 *   // this is a catch-all state change for when an element is inserted into
 *   // the page and the destination state is unknown
 *   transition("void => *", [
 *     style({ opacity: 0 }),
 *     animate(500)
 *   ]),
 *
 *   // this will capture a state change between any states
 *   transition("* => *", animate("1s 0s")),
 *
 *   // you can also go full out and include a function
 *   transition((fromState, toState) => {
 *     // when `true` then it will allow the animation below to be invoked
 *     return fromState == "off" && toState == "on";
 *   }, animate("1s 0s"))
 * ])
 * ```
 *
 * The template associated with this component will make use of the `myAnimationTrigger` animation
 * trigger by binding to an element within its template code.
 *
 * ```html
 * <!-- somewhere inside of my-component-tpl.html -->
 * <div [\@myAnimationTrigger]="myStatusExp">...</div>
 * ```
 *
 * #### The final `animate` call
 *
 * If the final step within the transition steps is a call to `animate()` that **only** uses a
 * timing value with **no style data** then it will be automatically used as the final animation arc
 * for the element to animate itself to the final state. This involves an automatic mix of
 * adding/removing CSS styles so that the element will be in the exact state it should be for the
 * applied state to be presented correctly.
 *
 * ```
 * // start off by hiding the element, but make sure that it animates properly to whatever state
 * // is currently active for "myAnimationTrigger"
 * transition("void => *", [
 *   style({ opacity: 0 }),
 *   animate(500)
 * ])
 * ```
 *
 * ### Transition Aliases (`:enter` and `:leave`)
 *
 * Given that enter (insertion) and leave (removal) animations are so common, the `transition`
 * function accepts both `:enter` and `:leave` values which are aliases for the `void => *` and `*
 * => void` state changes.
 *
 * ```
 * transition(":enter", [
 *   style({ opacity: 0 }),
 *   animate(500, style({ opacity: 1 }))
 * ])
 * transition(":leave", [
 *   animate(500, style({ opacity: 0 }))
 * ])
 * ```
 *
 * {\@example core/animation/ts/dsl/animation_example.ts region='Component'}
 *
 * \@experimental Animation support is experimental.
 * @param {?} stateChangeExpr
 * @param {?} steps
 * @return {?}
 */
function transition$1(stateChangeExpr, steps) {
    return { type: 1 /* Transition */, expr: stateChangeExpr, animation: steps };
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @deprecated This symbol has moved. Please Import from \@angular/animations instead!
 */
var AUTO_STYLE$$1 = '*';
/**
 * @deprecated This symbol has moved. Please Import from \@angular/animations instead!
 * @param {?} name
 * @param {?} definitions
 * @return {?}
 */
function trigger$$1(name, definitions) {
    return trigger$1(name, definitions);
}
/**
 * @deprecated This symbol has moved. Please Import from \@angular/animations instead!
 * @param {?} timings
 * @param {?=} styles
 * @return {?}
 */
function animate$$1(timings, styles) {
    return animate$1(timings, styles);
}
/**
 * @deprecated This symbol has moved. Please Import from \@angular/animations instead!
 * @param {?} steps
 * @return {?}
 */
function group$$1(steps) {
    return group$1(steps);
}
/**
 * @deprecated This symbol has moved. Please Import from \@angular/animations instead!
 * @param {?} steps
 * @return {?}
 */
function sequence$$1(steps) {
    return sequence$1(steps);
}
/**
 * @deprecated This symbol has moved. Please Import from \@angular/animations instead!
 * @param {?} tokens
 * @return {?}
 */
function style$$1(tokens) {
    return style$1(tokens);
}
/**
 * @deprecated This symbol has moved. Please Import from \@angular/animations instead!
 * @param {?} name
 * @param {?} styles
 * @return {?}
 */
function state$$1(name, styles) {
    return state$1(name, styles);
}
/**
 * @deprecated This symbol has moved. Please Import from \@angular/animations instead!
 * @param {?} steps
 * @return {?}
 */
function keyframes$$1(steps) {
    return keyframes$1(steps);
}
/**
 * @deprecated This symbol has moved. Please Import from \@angular/animations instead!
 * @param {?} stateChangeExpr
 * @param {?} steps
 * @return {?}
 */
function transition$$1(stateChangeExpr, steps) {
    return transition$1(stateChangeExpr, steps);
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @module
 * @description
 * Entry point from which you should import all public core APIs.
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @module
 * @description
 * Entry point for all public APIs of the core package.
 */
// This file only reexports content of the `src` folder. Keep it that way.
/**
 * Generated bundle index. Do not edit.
 */

//# sourceMappingURL=core.es5.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "3xL9":
/***/ (function(module, exports) {

exports.model=Model={Game:{},Board:{},Move:{}},function(){var t;Model.Game.cbConstants={MASK:65535,FLAG_MOVE:65536,FLAG_CAPTURE:131072,FLAG_STOP:262144,FLAG_SCREEN_CAPTURE:524288,FLAG_CAPTURE_KING:1048576,FLAG_CAPTURE_NO_KING:2097152};var e="undefined"!=typeof Int32Array;Model.Game.cbUseTypedArrays=e,Model.Game.cbTypedArray=function(t){if(e){var r=new Int32Array(t.length);return r.set(t),r}for(var a=[],i=t.length,s=0;s<i;s++)a.push(t[s]);return a},Model.Game.cbShortRangeGraph=function(t,e,r,a){var i=this;void 0===a&&(a=196608);for(var s={},n=0;n<t.boardSize;n++)s[n]=[],(!r||n in r)&&e.forEach(function(e){var o=t.Graph(n,e);null!=o&&(!r||o in r)&&s[n].push(i.cbTypedArray([o|a]))});return s},Model.Game.cbLongRangeGraph=function(t,e,r,a,i){var s=this;void 0!==a&&null!=a||(a=196608),i||(i=1/0);for(var n={},o=0;o<t.boardSize;o++)n[o]=[],(!r||o in r)&&e.forEach(function(e){for(var h=[],c=t.Graph(o,e),p=0;null!=c&&(!r||c in r)&&(h.push(c|a),++p!=i);)c=t.Graph(c,e);h.length>0&&n[o].push(s.cbTypedArray(h))});return n},Model.Game.cbNullGraph=function(t){for(var e={},r=0;r<t.boardSize;r++)e[r]=[];return e},Model.Game.cbAuthorGraph=function(t){for(var e={},r=0;r<t.boardSize;r++){e[r]=[];for(var a=0;a<t.boardSize;a++)e[r].push([2293760|a])}return e},Model.Game.cbMergeGraphs=function(t){for(var e=[],r=0;r<t.boardSize;r++){e[r]=[];for(var a=1;a<arguments.length;a++)e[r]=e[r].concat(arguments[a][r])}return e},Model.Game.cbGetThreatGraph=function(){function t(e,r){for(var a in n){var i=n[a];if(!(i.p.length<r.length+1)){for(var s=!0,o=0;o<r.length;o++)if(r[o]!=i.p[o]){s=!1;break}if(s){var h=i.p[r.length],c=e[h];void 0===c&&(c={e:{}},e[h]=c),i.p.length==r.length+1&&(c.t=i.t,c.ts=i.ts,c.tk=i.tk,delete n[a]),r.push(h),t(c.e,r),r.pop()}}}}var e=this;this.cbUseScreenCapture=!1,this.cbUseCaptureKing=!1,this.cbUseCaptureNoKing=!1;for(var r={1:[],"-1":[]},a=[],i=0;i<this.g.boardSize;i++)this.g.pTypes.forEach(function(t,r){t.graph[i].forEach(function(t){for(var s=[],n=0;n<t.length;n++){var o=t[n];1048576&o?(e.cbUseCaptureKing=!0,s.unshift({d:65535&o,a:i,tk:r})):2097152&o?(e.cbUseCaptureNoKing=!0,s.unshift({d:65535&o,a:i,tnk:r})):131072&o?s.unshift({d:65535&o,a:i,t:r}):262144&o?s.unshift({d:65535&o,a:i}):524288&o&&(e.cbUseScreenCapture=!0,s.unshift({d:65535&o,a:i,ts:r}))}s.length>0&&a.push(s)})});var s={};a.forEach(function(t){t.forEach(function(e,r){var a=s[e.d];void 0===a&&(a={},s[e.d]=a);for(var i=[],n=r+1;n<t.length;n++)i.push(t[n].d);i.push(e.a);var o=i.join(","),h=a[o];void 0===h&&(h={p:i,t:{},ts:{},tk:{}},a[o]=h),void 0!==e.t?h.t[e.t]=!0:void 0!==e.tk?h.tk[e.tk]=!0:void 0!==e.ts&&(h.ts[e.ts]=!0)})});for(var i=0;i<e.g.boardSize;i++){var n=s[i],o={};t(o,[]),r[1][i]=o,r[-1][i]=o}return r},Model.Game.InitGame=function(){var e=this;this.cbVar=t=this.cbDefine(),this.g.boardSize=this.cbVar.geometry.boardSize,this.g.pTypes=this.cbGetPieceTypes(),this.g.threatGraph=this.cbGetThreatGraph(),this.g.distGraph=this.cbVar.geometry.GetDistances(),this.cbPiecesCount=0,this.g.castleablePiecesCount={1:0,"-1":0};for(var r in t.pieceTypes){var a=t.pieceTypes[r];if(a.castle){(a.initial||[]).forEach(function(t){e.g.castleablePiecesCount[t.s]++})}a.initial&&(this.cbPiecesCount+=a.initial.length)}for(var i=[],r=0;r<this.cbPiecesCount;r++)i.push(r);var s=Object.keys(t.pieceTypes);this.zobrist=new JocGame.Zobrist({board:{type:"array",size:this.cbVar.geometry.boardSize,values:i},who:{values:["1","-1"]},type:{type:"array",size:this.cbPiecesCount,values:s}})},Model.Game.cbGetPieceTypes=function(){for(var t=[],e={},r=0;r<this.cbVar.geometry.boardSize;r++)e[r]=[];for(var a in this.cbVar.pieceTypes){var i=this.cbVar.pieceTypes[a];t[a]={graph:i.graph||e,abbrev:i.abbrev||"",value:i.isKing?100:i.value||1,isKing:!!i.isKing,castle:!!i.castle,epTarget:!!i.epTarget,epCatch:!!i.epCatch}}return t},Model.Board.Init=function(t){this.zSign=0},Model.Board.InitialPosition=function(r){var a=this;this.board=e?new Int16Array(r.g.boardSize):[];for(var i=0;i<r.g.boardSize;i++)this.board[i]=-1;if(this.kings={},this.pieces=[],this.ending={1:!1,"-1":!1},this.lastMove=null,r.cbVar.castle&&(this.castled={1:!1,"-1":!1}),this.zSign=r.zobrist.update(0,"who",-1),this.noCaptCount=0,this.mWho=1,r.mInitial)this.mWho=r.mInitial.turn||1,r.mInitial.pieces.forEach(function(t){var e={};for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);a.pieces.push(e)}),r.mInitial.lastMove&&(this.lastMove={f:r.mInitial.lastMove.f,t:r.mInitial.lastMove.t}),void 0!==r.mInitial.noCaptCount&&(this.noCaptCount=r.mInitial.noCaptCount),r.cbVar.castle&&r.mInitial.castle&&(this.castled={1:{k:!!r.mInitial.castle[1]&&!!r.mInitial.castle[1].k,q:!!r.mInitial.castle[1]&&!!r.mInitial.castle[1].q},"-1":{k:!!r.mInitial.castle[-1]&&!!r.mInitial.castle[-1].k,q:!!r.mInitial.castle[-1]&&!!r.mInitial.castle[-1].q}});else for(var s in r.cbVar.pieceTypes)for(var n=r.cbVar.pieceTypes[s],o=n.initial||[],h=0;h<o.length;h++){var c=o[h],p={s:c.s,t:parseInt(s),p:c.p,m:!1};this.pieces.push(p)}if(this.pieces.sort(function(t,e){if(t.s!=e.s)return e.s-t.s;var a=r.cbVar.pieceTypes[t.t].value||100,i=r.cbVar.pieceTypes[e.t].value||100;return a!=i?a-i:t.p-e.p}),this.pieces.forEach(function(t,e){t.i=e,a.board[t.p]=e,r.g.pTypes[t.t].isKing&&(a.kings[t.s]=t.p),a.zSign=r.zobrist.update(a.zSign,"board",e,t.p),a.zSign=r.zobrist.update(a.zSign,"type",t.t,e)}),r.mInitial&&r.mInitial.enPassant){var i=t.geometry.PosByName(r.mInitial.enPassant);if(i>=0){var l,u=t.geometry.C(i),v=t.geometry.R(i);l=1==r.mInitial.turn?t.geometry.POS(u,v-1):t.geometry.POS(u,v+1),this.epTarget={p:i,i:this.board[l]}}}},Model.Board.CopyFrom=function(t){if(e)this.board=new Int16Array(t.board.length),this.board.set(t.board);else{this.board=[];for(var r=t.board,a=r.length,i=0;i<a;i++)this.board.push(r[i])}this.pieces=[];for(var s=t.pieces.length,i=0;i<s;i++){var n=t.pieces[i];this.pieces.push({s:n.s,p:n.p,t:n.t,i:n.i,m:n.m})}this.kings={1:t.kings[1],"-1":t.kings[-1]},this.check=t.check,t.lastMove?this.lastMove={f:t.lastMove.f,t:t.lastMove.t,c:t.lastMove.c}:this.lastMove=null,this.ending={1:t.ending[1],"-1":t.ending[-1]},void 0!==t.castled&&(this.castled={1:t.castled[1],"-1":t.castled[-1]}),this.noCaptCount=t.noCaptCount,t.epTarget?this.epTarget={p:t.epTarget.p,i:t.epTarget.i}:this.epTarget=null,this.mWho=t.mWho,this.zSign=t.zSign},Model.Board.cbApplyCastle=function(t,e,r){var a=t.cbVar.castle[e.f+"/"+e.cg],i=a.r[a.r.length-1],s=this.pieces[this.board[e.cg]],n=a.k[a.k.length-1],o=this.pieces[this.board[e.f]];return r&&(this.zSign=t.zobrist.update(this.zSign,"board",s.i,e.cg),this.zSign=t.zobrist.update(this.zSign,"board",s.i,i),this.zSign=t.zobrist.update(this.zSign,"board",o.i,e.f),this.zSign=t.zobrist.update(this.zSign,"board",o.i,n)),s.p=i,s.m=!0,this.board[e.cg]=-1,o.p=n,o.m=!0,this.board[e.f]=-1,this.board[i]=s.i,this.board[n]=o.i,this.castled[s.s]=!0,this.kings[o.s]=n,[{i:s.i,f:i,t:-1},{i:o.i,f:n,t:e.f,kp:e.f,who:o.s,m:!1},{i:s.i,f:-1,t:e.cg,m:!1,cg:!1}]},Model.Board.cbQuickApply=function(t,e){if(void 0!==e.cg)return this.cbApplyCastle(t,e,!1);var r=[],a=this.board[e.f],i=this.pieces[a];if(null!=e.c){r.unshift({i:e.c,f:-1,t:this.pieces[e.c].p});var s=this.pieces[e.c];this.board[s.p]=-1,s.p=-1}var n=this.kings[i.s];return t.g.pTypes[i.t].isKing&&(this.kings[i.s]=e.t),r.unshift({i:a,f:e.t,t:e.f,kp:n,who:i.s,ty:i.t}),i.p=e.t,void 0!==e.pr&&(i.t=e.pr),this.board[e.f]=-1,this.board[e.t]=a,r},Model.Board.cbQuickUnapply=function(t,e){for(var r=0;r<e.length;r++){var a=e[r],i=this.pieces[a.i];a.f>=0&&(i.p=-1,this.board[a.f]=-1),a.t>=0&&(i.p=a.t,this.board[a.t]=a.i),void 0!==a.m&&(i.m=a.m),void 0!==a.kp&&(this.kings[a.who]=a.kp),void 0!=a.ty&&(i.t=a.ty),void 0!=a.cg&&(this.castled[i.s]=a.cg)}},Model.Board.ApplyMove=function(t,e){var r=this.pieces[this.board[e.f]];if(void 0!==e.cg)this.cbApplyCastle(t,e,!0);else{if(this.zSign=t.zobrist.update(this.zSign,"board",r.i,e.f),this.board[r.p]=-1,void 0!==e.pr&&(this.zSign=t.zobrist.update(this.zSign,"type",r.t,r.i),r.t=e.pr,this.zSign=t.zobrist.update(this.zSign,"type",r.t,r.i)),null!=e.c){var a=this.pieces[e.c];this.zSign=t.zobrist.update(this.zSign,"board",a.i,a.p),this.board[a.p]=-1,a.p=-1,a.m=!0,this.noCaptCount=0}else this.noCaptCount++;r.p=e.t,r.m=!0,this.board[e.t]=r.i,this.zSign=t.zobrist.update(this.zSign,"board",r.i,e.t),t.g.pTypes[r.t].isKing&&(this.kings[r.s]=e.t)}this.check=!!e.ck,this.lastMove={f:e.f,t:e.t,c:e.c},void 0!==e.ko&&(this.ending[r.s]=e.ko),void 0!==e.ept?this.epTarget={p:e.ept,i:r.i}:this.epTarget=null,this.zSign=t.zobrist.update(this.zSign,"who",-this.mWho),this.zSign=t.zobrist.update(this.zSign,"who",this.mWho)},Model.Board.Evaluate=function(r){function a(e){var r=1/0;for(var a in t.geometry.corners)r=Math.min(r,h.distGraph[s.kings[e]][a]);return r-Math.sqrt(h.boardSize)}var i="debug"==arguments[3],s=this;this.mEvaluation=0;var n,o=this.mWho,h=r.g;if(e)n={1:{count:new Uint8Array(h.pTypes.length),byType:{}},"-1":{count:new Uint8Array(h.pTypes.length),byType:{}}};else{n={1:{count:[],byType:{}},"-1":{count:[],byType:{}}};for(var c=0;c<h.pTypes.length;c++)n[1].count[c]=n[-1].count[c]=0}if(r.mOptions.preventRepeat&&r.GetRepeatOccurence(this)>2)return this.mFinished=!0,void(this.mWinner=r.cbOnPerpetual?o*r.cbOnPerpetual:JocGame.DRAW);for(var p={1:0,"-1":0},l={1:h.distGraph[this.kings[-1]],"-1":h.distGraph[this.kings[1]]},u={1:0,"-1":0},v={1:0,"-1":0},b={1:0,"-1":0},f={1:0,"-1":0},g={1:!1,"-1":!1},d=this.pieces,m=d.length,c=0;c<m;c++){var G=d[c];if(G.p>=0){var y=G.s,M=h.pTypes[G.t];M.isKing?g[y]=G.m:p[y]+=M.value,M.castle&&!G.m&&f[y]++,v[y]++,u[y]+=l[y][G.p],b[y]+=t.geometry.distEdge[G.p];var C=n[y];C.count[G.t]++;var S=C.byType;void 0===S[G.t]?S[G.t]=[G]:S[G.t].push(G)}}if(this.lastMove&&null!=this.lastMove.c){var G=this.pieces[this.board[this.lastMove.t]];p[-G.s]+=this.cbStaticExchangeEval(r,G.p,G.s,{piece:G})}var k={1:0,"-1":0},A={1:0,"-1":0},T={1:0,"-1":0};this.ending[1]&&(A[1]=(u[1]-Math.sqrt(h.boardSize))/v[1],t.geometry.corners&&(T[1]=a(1))),this.ending[-1]&&(A[-1]=(u[-1]-Math.sqrt(h.boardSize))/v[-1],t.geometry.corners&&(T[1]=a(-1)));var z={pieceValue:p[1]-p[-1],pieceValueRatio:(p[1]-p[-1])/(p[1]+p[-1]+1),posValue:b[1]-b[-1],averageDistKing:u[1]/v[1]-u[-1]/v[-1],check:this.check?-o:0,endingKingFreedom:k[1]-k[-1],endingDistKing:A[1]-A[-1],distKingCorner:T[1]-T[-1]};t.castle&&(z.castle=(this.castled[1]?1:g[1]?0:f[1]/(h.castleablePiecesCount[1]+1))-(this.castled[-1]?1:g[-1]?0:f[-1]/(h.castleablePiecesCount[-1]+1))),t.evaluate&&t.evaluate.call(this,r,z,n);var E=r.mOptions.levelOptions;for(var P in z){var w=z[P],I=E[P+"Factor"]||0,R=w*I;i&&console.log(P,"=",w,"*",I,"=>",R),this.mEvaluation+=R}i&&console.log("Evaluation",this.mEvaluation)},Model.Board.cbGeneratePseudoLegalMoves=function(t){function e(e,i){var s=t.cbVar.promote;if(!s)return void a.push(i);var n=s.call(r,t,e,i);if(null!=n)if(0==n.length)a.push(i);else if(1==n.length)i.pr=n[0],a.push(i);else for(var o=0;o<n.length;o++){var h=n[o];a.push({f:i.f,t:i.t,c:i.c,pr:h,ept:i.ept,ep:i.ep,a:i.a})}}for(var r=this,a=[],i=t.cbVar,s=this.mWho,n=!i.castle||this.check||this.castled[s]?null:[],o=-1,h=this.pieces.length,c=0;c<h;c++){var p=this.pieces[c];if(!(p.p<0||p.s!=s)){var l=t.g.pTypes[p.t];l.isKing&&(p.m?n=null:o=p),n&&l.castle&&!p.m&&n.push(p);var u,v;u=l.graph[p.p],v=u.length;for(var b=0;b<v;b++)for(var f=u[b],g=!1,d=f.length,m=null,G=0;G<d;G++){var y=f[G],M=65535&y,C=this.board[M];if(!(C<0)||l.epCatch&&this.epTarget&&this.epTarget.p==M){if(!(524288&y)){var S;S=C<0?this.pieces[this.epTarget.i]:this.pieces[C],!(S.s!=p.s&&131072&y)||1048576&y&&!t.g.pTypes[S.t].isKing||2097152&y&&t.g.pTypes[S.t].isKing||e(p,{f:p.p,t:M,c:S.i,a:l.abbrev,ep:C<0});break}if(g){var S=this.pieces[C];S.s!=p.s&&e(p,{f:p.p,t:M,c:S.i,a:l.abbrev});break}g=!0}else 65536&y&&0==g&&e(p,{f:p.p,t:M,c:null,a:l.abbrev,ept:null!=m&&l.epTarget?m:void 0});m=M}}}if(n)for(var c=0;c<n.length;c++){var k=n[c],A=t.cbVar.castle[o.p+"/"+k.p];if(A){for(var T=!0,b=0;b<A.r.length;b++){var z=A.r[b];if(this.board[z]>=0&&z!=o.p&&z!=k.p){T=!1;break}}if(T){for(var E=!0,b=0;b<A.k.length;b++){var z=A.k[b];if(this.board[z]>=0&&z!=k.p&&z!=o.p||this.cbGetAttackers(t,z,s).length>0){E=!1;break}}E&&a.push({f:o.p,t:A.k[A.k.length-1],c:null,cg:k.p})}}}return a},Model.Board.cbStaticExchangeEval=function(t,e,r,a){var i=0,s=this.cbGetSmallestAttacker(t,e,r);if(s){var n=this.mWho;this.mWho=s.s;var o=this.cbQuickApply(t,{f:s.p,t:e,c:a.piece.i}),h=t.g.pTypes[a.piece.t].value;a.piece=s,i=Math.max(0,h-this.cbStaticExchangeEval(t,e,-r,a)),this.cbQuickUnapply(t,o),this.mWho=n}return i},Model.Board.cbGetSmallestAttacker=function(t,e,r){var a=this.cbGetAttackers(t,e,r);if(0==a.length)return null;for(var i=1/0,s=null,n=a.length,o=0;o<n;o++){var h=a[o],c=t.g.pTypes[h.t].value;c<i&&(i=c,s=h)}return s},Model.Board.cbCollectAttackers=function(t,e,r,a){for(var i in e){var s=e[i],n=this.board[i];if(n<0)this.cbCollectAttackers(t,s.e,r,a);else{var o=this.pieces[n];o.s==-t&&(s.t&&o.t in s.t||a&&s.tk&&o.t in s.tk)&&r.push(o)}}},Model.Board.cbCollectAttackersScreen=function(t,e,r,a,i){for(var s in e){var n=e[s],o=this.board[s];if(o<0)this.cbCollectAttackersScreen(t,n.e,r,a,i);else{var h=this.pieces[o];!i&&h.s==-t&&(n.t&&h.t in n.t||a&&n.tk&&h.t in n.tk)?r.push(h):i?i&&h.s==-t&&n.ts&&h.t in n.ts&&r.push(h):this.cbCollectAttackersScreen(t,n.e,r,a,!0)}}},Model.Board.cbGetAttackers=function(t,e,r,a){var i=[];return t.cbUseScreenCapture?this.cbCollectAttackersScreen(r,t.g.threatGraph[r][e],i,a,!1):this.cbCollectAttackers(r,t.g.threatGraph[r][e],i,a),i},Model.Board.GenerateMoves=function(t){var e=this.cbGeneratePseudoLegalMoves(t);this.mMoves=[];for(var r=!0,a=this.kings[this.mWho],i=e.length,s=0;s<i;s++){var n=e[s],o=this.cbQuickApply(t,n);if(!(this.cbGetAttackers(t,this.kings[this.mWho],this.mWho,!0).length>0)){var h=this.cbGetAttackers(t,this.kings[-this.mWho],-this.mWho,!0).length>0;n.ck=h,this.mMoves.push(n),n.f!=a&&(r=!1)}this.cbQuickUnapply(t,o)}if(0==this.mMoves.length)this.mFinished=!0,this.mWinner=t.cbOnStaleMate?t.cbOnStaleMate*this.mWho:JocGame.DRAW,this.check&&(this.mWinner=-this.mWho);else if(this.ending[this.mWho]){if(!r)for(var s=0;s<this.mMoves.length;s++)this.mMoves[s].ko=!1}else if(!this.ending[this.mWho]&&r&&!this.check)for(var s=0;s<this.mMoves.length;s++)this.mMoves[s].ko=!0},Model.Board.GetSignature=function(){return this.zSign},Model.Move.Init=function(t){for(var e in t)t.hasOwnProperty(e)&&(this[e]=t[e])},Model.Move.Equals=function(t){return this.f==t.f&&this.t==t.t&&this.pr==t.pr},Model.Move.CopyFrom=function(t){this.Init(t)},Model.Move.ToString=function(e){var r=this;switch(e=e||"natural"){case"natural":return function(){var e;if(void 0!==r.cg?e=t.castle[r.f+"/"+r.cg].n:(e=r.a||"",e+=t.geometry.PosName(r.f),null==r.c?e+="-":e+="x",e+=t.geometry.PosName(r.t)),void 0!==r.pr){var a=t.pieceTypes[r.pr];a&&a.abbrev&&a.abbrev.length>0&&!a.silentPromo&&(e+="="+a.abbrev)}return r.ck&&(e+="+"),e}();case"engine":return function(){var e=t.geometry.PosName(r.f)+t.geometry.PosName(r.t);if(void 0!=r.pr){var a=t.pieceTypes[r.pr];a&&a.abbrev&&a.abbrev.length>0&&!a.silentPromo&&(e+=a.abbrev)}return e}();default:return"??"}},Model.Board.CompactMoveString=function(e,r,a){"function"!=typeof r.ToString&&(r=e.CreateMove(r));var i=r.ToString(),s=/^([A-Z]?)([a-z])([1-9][0-9]*)([-x])([a-z])([1-9][0-9]*)(.*?)$/.exec(i);if(!s)return i;var n=s[7];if(a||(a={}),a.value||(a.value=[]),0==a.value.length){var o=this.mMoves;this.mMoves&&0!=this.mMoves.length||this.GenerateMoves(e);for(var h=0;h<this.mMoves.length;h++){var c=this.mMoves[h];"function"!=typeof c.ToString&&(c=e.CreateMove(c)),a.value.push({str:c.ToString(),move:c})}this.mMoves=o}var p=[];if(a.value.forEach(function(t){var e=/^([A-Z]?[a-z][1-9][0-9]*[-x][a-z][1-9][0-9]*)(.*?)$/.exec(t.str);e&&t.move.t==r.t&&(t.move.a||"")==s[1]&&e[2]==n&&p.push(t.move)}),1==p.length)return""==s[1]&&"x"==s[4]?s[2]+"x"+s[5]+s[6]+s[7]:s[1]+("x"==s[4]?"x":"")+s[5]+s[6]+s[7];if(t.geometry.CompactCrit)for(var l="",h=0;;h++){var u=t.geometry.CompactCrit(r.f,h);if(null==u)return i;l+=u;for(var v=[],b=0;b<p.length;b++){var f=p[b];t.geometry.CompactCrit(f.f,h)==u&&v.push(f)}if(console.assert(v.length>0),1==v.length)return s[1]+l+("x"==s[4]?"x":"")+s[5]+s[6]+s[7];p=v}return i},Model.Board.cbIntegrity=function(t){function e(t,e){t||console.error(e)}for(var r=this,a=0;a<this.board.length;a++){var i=this.board[a];if(i>=0){var s=r.pieces[i];e(void 0!==s,"no piece at pos"),e(s.p==a,"piece has different pos")}}for(var i=0;i<this.pieces.length;i++){var s=this.pieces[i];s.p>=0&&e(r.board[s.p]==i,"board index mismatch")}},Model.Board.ExportBoardState=function(t){return t.cbVar.geometry.ExportBoardState?t.cbVar.geometry.ExportBoardState(this,t.cbVar,t.mPlayedMoves.length):"not supported"},Model.Game.Import=function(e,r){var a,i=[],s={1:{},"-1":{}},n=null,o=0;if("pjn"==e){var h={status:!1,error:"parse"},c=r.split(" ");if(6!=c.length)return console.warn("FEN should have 6 parts"),h;var p=c[0].split("/"),l=t.geometry.fenHeight||t.geometry.height;if(p.length!=l)return console.warn("FEN board should have",l,"rows, got",p.length),h;var u={};for(var v in t.pieceTypes){var b=t.pieceTypes[v],f=b.fenAbbrev||b.abbrev||"X";u[f.toUpperCase()]={s:1,t:v},u[f.toLowerCase()]={s:-1,t:v}}var g=t.geometry.FenRowPos||function(e,r){return(t.geometry.height-1-e)*t.geometry.width+r};if(p.forEach(function(e,r){for(var a=0,s=0;s<e.length;s++){var n=e.substr(s,1),o=u[n];if(void 0!==o){var c=g(r,a);a++;for(var p={s:o.s,t:o.t,p:c},l=!0,v=t.pieceTypes[p.t].initial||[],b=0;b<v.length;b++){var f=v[b];f.s==p.s&&f.p==c&&(l=!1)}p.m=l,i.push(p)}else{if(isNaN(parseInt(n)))return console.warn("FEN invalid board spec",n),h;a+=parseInt(n)}}}),i.sort(function(t,e){return e.s-t.s}),"w"==c[1])a=1;else{if("b"!=c[1])return console.warn("FEN invalid turn spec",c[1]),h;a=-1}s[1].k=c[2].indexOf("K")>=0,s[1].q=c[2].indexOf("Q")>=0,s[-1].k=c[2].indexOf("k")>=0,s[-1].q=c[2].indexOf("q")>=0,n="-"==c[3]?null:c[3];var d=parseInt(c[4]);isNaN(d)||(o=d);var m={pieces:i,turn:a,castle:s,enPassant:n,noCaptCount:o};return t.importGame&&t.importGame.call(this,m,e,r),{status:!0,initial:m}}return{status:!1,error:"unsupported"}}}(),function(){Model.Game.cbBoardGeometryGrid=function(t,e){function r(e){return e%t}function a(e){return Math.floor(e/t)}function i(e,r){return r*t+e}function s(s,n){var o=r(s),h=a(s),c=o+n[0],p=h+n[1];return c<0||c>=t||p<0||p>=e?null:i(c,p)}function n(t){return String.fromCharCode("a".charCodeAt(0)+r(t))+(a(t)+1)}function o(t){var e=/^([a-z])([0-9]+)$/.exec(t);return e?i(e[1].charCodeAt(0)-"a".charCodeAt(0),parseInt(e[2])-1):-1}function h(t,e){return 0==e?String.fromCharCode("a".charCodeAt(0)+r(t)):1==e?a(t)+1:null}function c(){for(var i=[],s=0;s<t*e;s++){var n=[];i.push(n);for(var o=0;o<t*e;o++){var h=a(s),c=r(s),p=a(o),l=r(o);n.push(Math.max(Math.abs(h-p),Math.abs(c-l)))}}return i}function p(r,a,s){for(var o=[],h=e-1;h>=0;h--){for(var c="",p=0,l=0;l<t;l++){var u=r.board[i(l,h)];if(u<0)p++;else{p>0&&(c+=p,p=0);var v=r.pieces[u],b=a.pieceTypes[v.t].fenAbbrev||a.pieceTypes[v.t].abbrev||"?";v.s==-1?c+=b.toLowerCase():c+=b.toUpperCase()}}p&&(c+=p),o.push(c)}var f=o.join("/");f+=" ",1==r.mWho?f+="w":f+="b",f+=" ";var g="";return r.castled&&(r.castled[1]===!1?g+="KQ":(r.castled[1].k&&(g+="K"),r.castled[1].q&&(g+="Q")),r.castled[-1]===!1?g+="kq":(r.castled[-1].k&&(g+="k"),r.castled[-1].q&&(g+="q"))),0==g.length&&(g="-"),f+=g,f+=" ",r.epTarget?f+=n(r.epTarget.p):f+="-",f+=" ",f+=r.noCaptCount,f+=" ",f+=Math.floor(s/2)+1}return{boardSize:t*e,width:t,height:e,C:r,R:a,POS:i,Graph:s,PosName:n,PosByName:o,CompactCrit:h,GetDistances:c,distEdge:function(){for(var i=[],s=0;s<t*e;s++){var n=r(s),o=a(s);i[s]=Math.min(n,Math.abs(t-n-1),o,Math.abs(e-o-1))}return i}(),corners:function(){var r={};return r[i(0,0)]=1,r[i(0,e-1)]=1,r[i(t-1,0)]=1,r[i(t-1,e-1)]=1,r}(),ExportBoardState:p}},Model.Game.cbPawnGraph=function(t,e,r){for(var a=this,i={},s=0;s<t.boardSize;s++)if(!r||s in r){var n=[],o=t.Graph(s,[0,e]);null!=o&&(!r||o in r)&&n.push(a.cbTypedArray([o|a.cbConstants.FLAG_MOVE])),[-1,1].forEach(function(i){var o=t.Graph(s,[i,e]);null!=o&&(!r||o in r)&&n.push(a.cbTypedArray([o|a.cbConstants.FLAG_CAPTURE]))}),i[s]=n}else i[s]=[];return i},Model.Game.cbInitialPawnGraph=function(t,e,r){for(var a=this,i={},s=0;s<t.boardSize;s++)if(!r||s in r){var n=[],o=t.Graph(s,[0,e]);if(null!=o&&(!r||o in r)){var h=[o|a.cbConstants.FLAG_MOVE],c=t.Graph(o,[0,e]);null!=c&&(!r||c in r)&&h.push(c|a.cbConstants.FLAG_MOVE),n.push(a.cbTypedArray(h))}[-1,1].forEach(function(i){var o=t.Graph(s,[i,e]);null!=o&&(!r||o in r)&&n.push(a.cbTypedArray([o|a.cbConstants.FLAG_CAPTURE]))}),i[s]=n}else i[s]=[];return i},Model.Game.cbKingGraph=function(t,e){return this.cbShortRangeGraph(t,[[-1,-1],[-1,0],[-1,1],[0,-1],[0,1],[1,-1],[1,0],[1,1]],e)},Model.Game.cbKnightGraph=function(t,e){return this.cbShortRangeGraph(t,[[2,-1],[2,1],[-2,-1],[-2,1],[-1,2],[-1,-2],[1,2],[1,-2]],e)},Model.Game.cbHorseGraph=function(t){for(var e=this,r={},a=0;a<t.boardSize;a++)r[a]=[],[[1,0,2,-1],[1,0,2,1],[-1,0,-2,-1],[-1,0,-2,1],[0,1,-1,2],[0,-1,-1,-2],[0,1,1,2],[0,-1,1,-2]].forEach(function(i){var s=t.Graph(a,[i[0],i[1]]);if(null!=s){var n=t.Graph(a,[i[2],i[3]]);null!=n&&r[a].push(e.cbTypedArray([s|e.cbConstants.FLAG_STOP,n|e.cbConstants.FLAG_MOVE|e.cbConstants.FLAG_CAPTURE]))}});return r},Model.Game.cbRookGraph=function(t,e){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0]],e)},Model.Game.cbBishopGraph=function(t,e){return this.cbLongRangeGraph(t,[[1,-1],[1,1],[-1,1],[-1,-1]],e)},Model.Game.cbQueenGraph=function(t,e){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0],[1,-1],[1,1],[-1,1],[-1,-1]],e)},Model.Game.cbXQGeneralGraph=function(t,e){for(var r=this,a={},i=0;i<t.boardSize;i++)a[i]=[],[[-1,0,!1],[0,-1,!0],[0,1,!0],[1,0,!1]].forEach(function(s){var n=[],o=t.Graph(i,s);if(null!=o&&((!e||o in e)&&n.push(o|r.cbConstants.FLAG_MOVE|r.cbConstants.FLAG_CAPTURE),s[2]))for(var h=t.Graph(o,s);null!=h;)!e||h in e?n.push(h|r.cbConstants.FLAG_CAPTURE|r.cbConstants.FLAG_CAPTURE_KING):n.push(h|r.cbConstants.FLAG_STOP),h=t.Graph(h,s);n.length>0&&a[i].push(r.cbTypedArray(n))});return a},Model.Game.cbXQSoldierGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e]])},Model.Game.cbXQPromoSoldierGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e],[-1,0],[1,0]])},Model.Game.cbXQAdvisorGraph=function(t,e){return this.cbShortRangeGraph(t,[[1,1],[-1,1],[1,-1],[-1,-1]],e)},Model.Game.cbXQCannonGraph=function(t){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0]],null,this.cbConstants.FLAG_MOVE|this.cbConstants.FLAG_SCREEN_CAPTURE)},Model.Game.cbXQElephantGraph=function(t,e){for(var r=this,a={},i=0;i<t.boardSize;i++)a[i]=[],(!e||i in e)&&[[1,1,2,2],[1,-1,2,-2],[-1,1,-2,2],[-1,-1,-2,-2]].forEach(function(s){var n=t.Graph(i,[s[0],s[1]]);if(null!=n){var o=t.Graph(i,[s[2],s[3]]);null!=o&&(!e||o in e)&&a[i].push(r.cbTypedArray([n|r.cbConstants.FLAG_STOP,o|r.cbConstants.FLAG_MOVE|r.cbConstants.FLAG_CAPTURE]))}});return a},Model.Game.cbSilverGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e],[-1,-1],[-1,1],[1,-1],[1,1]])},Model.Game.cbFersGraph=function(t,e){return this.cbShortRangeGraph(t,[[-1,-1],[-1,1],[1,-1],[1,1]])},Model.Game.cbSchleichGraph=function(t,e){return this.cbShortRangeGraph(t,[[-1,0],[1,0],[0,-1],[0,1]])},Model.Game.cbAlfilGraph=function(t,e){return this.cbShortRangeGraph(t,[[-2,-2],[-2,2],[2,2],[2,-2]])}}(),function(){var t=Model.Game.cbBoardGeometryGrid(10,8);Model.Game.cbDefine=function(){return{geometry:t,pieceTypes:{0:{name:"pawn-w",aspect:"fr-pawn",graph:this.cbPawnGraph(t,1),value:1.2,abbrev:"",fenAbbrev:"P",epCatch:!0},1:{name:"ipawn-w",aspect:"fr-pawn",graph:this.cbInitialPawnGraph(t,1),value:1.2,abbrev:"",fenAbbrev:"P",initial:[{s:1,p:10},{s:1,p:11},{s:1,p:12},{s:1,p:13},{s:1,p:14},{s:1,p:15},{s:1,p:16},{s:1,p:17},{s:1,p:18},{s:1,p:19}],epTarget:!0},2:{name:"pawn-b",aspect:"fr-pawn",graph:this.cbPawnGraph(t,-1),value:1.2,abbrev:"",fenAbbrev:"P",epCatch:!0},3:{name:"ipawn-b",aspect:"fr-pawn",graph:this.cbInitialPawnGraph(t,-1),value:1.2,abbrev:"",fenAbbrev:"P",initial:[{s:-1,p:60},{s:-1,p:61},{s:-1,p:62},{s:-1,p:63},{s:-1,p:64},{s:-1,p:65},{s:-1,p:66},{s:-1,p:67},{s:-1,p:68},{s:-1,p:69}],epTarget:!0},4:{name:"knight",aspect:"fr-knight",graph:this.cbKnightGraph(t),value:2.8,abbrev:"N",initial:[{s:1,p:2},{s:1,p:7},{s:-1,p:72},{s:-1,p:77}]},5:{name:"bishop",aspect:"fr-bishop",graph:this.cbBishopGraph(t),value:3.4,abbrev:"B",initial:[{s:1,p:3},{s:1,p:6},{s:-1,p:73},{s:-1,p:76}]},6:{name:"rook",aspect:"fr-rook",graph:this.cbRookGraph(t),value:5,abbrev:"R",initial:[{s:1,p:0},{s:1,p:9},{s:-1,p:70},{s:-1,p:79}],castle:!0},7:{name:"queen",aspect:"fr-queen",graph:this.cbQueenGraph(t),value:8.3,abbrev:"Q",initial:[{s:1,p:5},{s:-1,p:75}]},8:{name:"king",aspect:"fr-king",isKing:!0,graph:this.cbKingGraph(t),abbrev:"K",initial:[{s:1,p:4},{s:-1,p:74}]},9:{name:"champion",aspect:"fr-marshall",graph:this.cbMergeGraphs(t,this.cbRookGraph(t),this.cbKnightGraph(t)),value:7.8,abbrev:"Ch",initial:[{s:1,p:1},{s:-1,p:71}]},10:{name:"centaur",aspect:"fr-cardinal",graph:this.cbMergeGraphs(t,this.cbBishopGraph(t),this.cbKnightGraph(t)),value:6,abbrev:"Ce",initial:[{s:1,p:8},{s:-1,p:78}]}},promote:function(e,r,a){return 1==r.t?[0]:3==r.t?[2]:0==r.t&&7==t.R(a.t)?[4,5,6,7,9,10]:2==r.t&&0==t.R(a.t)?[4,5,6,7,9,10]:[]},castle:{"4/0":{k:[3,2],r:[1,2,3],n:"O-O"},"4/9":{k:[5,6],r:[8,7,6,5],n:"O-O-O"},"74/70":{k:[73,72],r:[71,72,73],n:"O-O"},"74/79":{k:[75,76],r:[78,77,76,75],n:"O-O-O"}}}}}();

/***/ }),

/***/ "44WJ":
/***/ (function(module, exports) {

exports.config = {"status":true,"model":{"title-en":"Spline","module":"margo","js":["spbase-model.js","spline-model.js"],"summary":"Shibumi game","thumbnail":"tn-shibumi-spline.png","strings":[],"rules":{"en":"rules-spline.html","fr":"rules-spline.html"},"description":{"en":"description-spline.html","fr":"description-spline.html"},"credits":{"en":"credits-spline.html","fr":"credits-spline.html"},"demoRandom":true,"gameOptions":{"preventRepeat":true,"uctTransposition":"states","uctIgnoreLoop":true,"size":4},"plazza":"true","levels":[{"label":"Beginner","potential":1000,"isDefault":true,"maxDepth":1},{"label":"Easy","potential":2000,"maxDepth":5},{"label":"Medium","potential":6000,"maxDepth":6},{"label":"Confirmed","potential":10000,"maxDepth":8}]},"view":{"title-en":"Margo View","module":"margo","js":["spbase-xd-view.js","spline-view.js"],"xdView":true,"css":["spbase.css"],"preferredRatio":1,"useNotation":true,"defaultOptions":{"sounds":true,"moves":true,"notation":false},"skins":[{"name":"classic3d","title":"3D Classic","3d":true,"camera":{"radius":20,"elevationAngle":45,"limitCamMoves":true,"distMax":40,"distMin":10,"elevationMin":-45,"elevationMax":89.9,"enableDrag":false},"world":{"lightIntensity":0,"color":0,"fog":false,"skyLightIntensity":0.7,"skyLightPosition":{"x":0,"y":10,"z":0},"ambientLightColor":8947848},"preload":["image|/res/xd-view/meshes/grey.png","image|/res/xd-view/meshes/black.png","image|/res/xd-view/meshes/white.png","image|/res/xd-view/meshes/green.png","image|/res/xd-view/meshes/skybox/nx.jpg","image|/res/xd-view/meshes/skybox/ny.jpg","image|/res/xd-view/meshes/skybox/nz.jpg","image|/res/xd-view/meshes/skybox/px.jpg","image|/res/xd-view/meshes/skybox/py.jpg","image|/res/xd-view/meshes/skybox/pz.jpg"]},{"name":"wood","title":"Wood","preload":["image|/res/images/ball_black.png","image|/res/images/ball_white.png","image|/res/images/ball_green.png","image|/res/images/plot.png","image|/res/images/wood.png"]},{"name":"classical","title":"Classic","preload":["image|/res/images/ball_black.png","image|/res/images/ball_white.png","image|/res/images/ball_green.png","image|/res/images/plot.png"]}],"animateSelfMoves":false,"visuals":{"600x600":["res/visuals/spline-600x600-3d.jpg","res/visuals/spline-600x600-2d.jpg"]}}}

/***/ }),

/***/ "48bo":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var race_1 = __webpack_require__("Y3yw");
Observable_1.Observable.prototype.race = race_1.race;
//# sourceMappingURL=race.js.map

/***/ }),

/***/ "4Cl4":
/***/ (function(module, exports) {

exports.config = {"status":true,"model":{"plazza":"true","released":1405001496,"title-en":"Wildebeest Chess","module":"chessbase","summary":"Chess on 11x10 (1987)","thumbnail":"wildebeest-thumb.png","rules":{"en":"wildebeest-rules.html"},"credits":{"en":"wildebeest-credits.html"},"gameOptions":{"preventRepeat":true,"uctTransposition":"state","uctIgnoreLoop":false,"levelOptions":{"pieceValueFactor":1,"pieceValueRatioFactor":1,"posValueFactor":0.1,"averageDistKingFactor":-0.01,"castleFactor":0.1,"minorPiecesMovedFactor":0.1,"checkFactor":0.2,"endingKingFreedomFactor":0.01,"endingDistKingFactor":0.05,"distKingCornerFactor":0.1,"distPawnPromo1Factor":0.3,"distPawnPromo2Factor":0.1,"distPawnPromo3Factor":0.05}},"obsolete":false,"js":["base-model.js","grid-geo-model.js","wildebeest-model.js"],"description":{"en":"wildebeest-description.html"},"levels":[{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"easy","label":"Easy","maxNodes":1000},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"fast","label":"Fast [1sec]","maxDuration":1,"isDefault":true},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"medium","label":"Medium","maxNodes":10000,"maxDuration":10},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"strong","label":"Strong","maxNodes":20000,"maxDuration":15}]},"view":{"title-en":"Chessbase view","module":"chessbase","xdView":true,"css":["chessbase.css"],"preferredRatio":1,"useShowMoves":true,"useNotation":true,"useAutoComplete":true,"defaultOptions":{"sounds":true,"moves":true,"notation":false,"autocomplete":false},"skins":[{"name":"skin3d","title":"3D Classic","3d":true,"preload":["smoothedfilegeo|0|/res/ring-target.js","image|/res/images/cancel.png","image|/res/images/wikipedia.png","smoothedfilegeo|0|/res/fairy/pawn/pawn.js","image|/res/fairy/pawn/pawn-diffusemap.jpg","image|/res/fairy/pawn/pawn-normalmap.jpg","smoothedfilegeo|0|/res/fairy/knight/knight.js","image|/res/fairy/knight/knight-diffusemap.jpg","image|/res/fairy/knight/knight-normalmap.jpg","smoothedfilegeo|0|/res/fairy/bishop/bishop.js","image|/res/fairy/bishop/bishop-diffusemap.jpg","image|/res/fairy/bishop/bishop-normalmap.jpg","smoothedfilegeo|0|/res/fairy/queen/queen.js","image|/res/fairy/queen/queen-diffusemap.jpg","image|/res/fairy/queen/queen-normalmap.jpg","smoothedfilegeo|0|/res/fairy/king/king.js","image|/res/fairy/king/king-diffusemap.jpg","image|/res/fairy/king/king-normalmap.jpg","smoothedfilegeo|0|/res/fairy/rook/rook.js","image|/res/fairy/rook/rook-diffusemap.jpg","image|/res/fairy/rook/rook-normalmap.jpg","smoothedfilegeo|0|/res/fairy/camel/camel.js","image|/res/fairy/camel/camel-diffusemap.jpg","image|/res/fairy/camel/camel-normalmap.jpg","smoothedfilegeo|0|/res/fairy/dragon/dragon.js","image|/res/fairy/dragon/dragon-diffusemap.jpg","image|/res/fairy/dragon/dragon-normalmap.jpg"],"world":{"lightIntensity":1.3,"skyLightIntensity":1.2,"lightCastShadow":true,"fog":false,"color":4686804,"lightPosition":{"x":-9,"y":9,"z":9},"skyLightPosition":{"x":9,"y":9,"z":9},"lightShadowDarkness":0.55,"ambientLightColor":2236962},"camera":{"fov":45,"distMax":50,"radius":18,"elevationAngle":60,"elevationMin":0}},{"name":"skin2d","title":"2D Classic","3d":false,"preload":["image|/res/images/cancel.png","image|/res/images/whitebg.png","image|/res/fairy/wikipedia-fairy-sprites.png"]}],"animateSelfMoves":false,"switchable":true,"sounds":{"move1":"alq_move1","move2":"alq_move2","move3":"alq_move3","move4":"alq_move2","tac1":"alq_tac1","tac2":"alq_tac2","tac3":"alq_tac1","promo":"promo","usermove":null},"js":["base-view.js","grid-board-view.js","fairy-set-view.js","wildebeest-view.js"],"visuals":{"600x600":["res/visuals/wildebeest-600x600-3d.jpg","res/visuals/wildebeest-600x600-2d.jpg"]}}}

/***/ }),

/***/ "4Ie8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var publish_1 = __webpack_require__("52Ty");
Observable_1.Observable.prototype.publish = publish_1.publish;
//# sourceMappingURL=publish.js.map

/***/ }),

/***/ "4OB2":
/***/ (function(module, exports) {

exports.model=Model={Game:{},Board:{},Move:{}},Model.Game.InitGame=function(){for(var t=this,r=this.mOptions.size,a=[],i=[],o=0,e=0,n=[],s=0;s<r;s++)n.push(e),e+=(r-s)*(r-s);for(var s=0;s<r;s++)for(var h=0;h<r-s;h++)for(var l=0;l<r-s;l++){var u=o++;a[u]=[h,l,s],i[u]=[];for(var v=0;v<2;v++)for(var f=0;f<2;f++){var p=s-1,c=h+v,d=l+f;p>=0&&p<r&&c>=0&&c<r-p&&d>=0&&d<r-p?i[u].push(n[p]+c*(r-p)+d):i[u].push(null)}var g=[[0,-1],[0,1],[-1,0],[1,0]];for(var m in g){var M=g[m],p=s,c=h+M[0],d=l+M[1];p>=0&&p<r&&c>=0&&c<r-p&&d>=0&&d<r-p?i[u].push(n[p]+c*(r-p)+d):i[u].push(null)}for(var v=-1;v<1;v++)for(var f=-1;f<1;f++){var p=s+1,c=h+v,d=l+f;p>=0&&p<r&&c>=0&&c<r-p&&d>=0&&d<r-p?i[u].push(n[p]+c*(r-p)+d):i[u].push(null)}}this.g.Graph=i,this.g.Coord=a,this.g.Over=[],this.g.Beneath=[];for(var u=0;u<this.g.Graph.length;u++)this.g.Over[u]=null,this.g.Beneath[u]=null;for(var u=0;u<this.g.Graph.length;u++)for(var a=this.g.Coord[u],G=u+1;G<this.g.Graph.length;G++){var b=this.g.Coord[G];if(b[2]==a[2]+2&&b[0]==a[0]-1&&b[1]==a[1]-1){this.g.Over[u]=G,this.g.Beneath[G]=u;break}}this.g.EachDirection=function(r,a){for(var i=0;i<12;i++){var o=t.g.Graph[r][i];if(null!=o&&0==a(o,i))return}},this.g.EachDirectionDown=function(r,a){for(var i=[0,1,2,3],o=0;o<i.length;o++){var e=t.g.Graph[r][i[o]];if(null!=e&&0==a(e,i[o]))return}},this.g.EachDirectionUp=function(r,a){for(var i=[8,9,10,11],o=0;o<i.length;o++){var e=t.g.Graph[r][i[o]];if(null!=e&&0==a(e,i[o]))return}},this.g.EachDirectionFlat=function(r,a){for(var i=[4,5,6,7],o=0;o<i.length;o++){var e=t.g.Graph[r][i[o]];if(null!=e&&0==a(e,i[o]))return}},this.g.EachDirectionFlatDown=function(r,a){for(var i=[0,1,2,3,4,5,6,7],o=0;o<i.length;o++){var e=t.g.Graph[r][i[o]];if(null!=e&&0==a(e,i[o]))return}},this.g.EachDirectionFlatUp=function(r,a){for(var i=[4,5,6,7,8,9,10,11],o=0;o<i.length;o++){var e=t.g.Graph[r][i[o]];if(null!=e&&0==a(e,i[o]))return}},this.zobrist=new JocGame.Zobrist({board:{type:"array",size:this.g.Graph.length,values:[0,1]}}),this.InitGameExtra()},Model.Game.MapSameLevelDiagGraph=function(){for(var t=[0,16,25,29],r=0;r<4;r++)for(var a=0;a<4-r;a++)for(var i=0;i<4-r;i++)for(var o=t[r]+a*(4-r)+i,e=-1;e<2;e+=2)for(var n=-1;n<2;n+=2){var s=r,h=a+e,l=i+n;s>=0&&s<4&&h>=0&&h<4-s&&l>=0&&l<4-s?this.g.Graph[o].push(t[s]+h*(4-s)+l):this.g.Graph[o].push(null)}},Model.Game.InitGameExtra=function(){},Model.Game.DestroyGame=function(){this.DestroyGameExtra()},Model.Game.DestroyGameExtra=function(){},Model.Game.spUpdateZobrist=function(t,r,a,i,o,e){for(var n=0;n<r.length;n++)t=this.zobrist.update(t,"board",a,r[n]);for(var n=0;n<i.length;n++)t=this.zobrist.update(t,"board",o,i[n]);return t},Model.Move.Init=function(t){for(var r in t)t.hasOwnProperty(r)&&(this[r]=JSON.parse(JSON.stringify(t[r])))},Model.Move.ToString=function(){var t=["?","W","B","R"][this.clr],r="";switch(this.act){case"+":r+="+"+this.pos+t;break;case">":r+=this.from+">"+this.to+t}return r},Model.Board.Init=function(t){},Model.Board.InitialPosition=function(t){this.spInitialPosition(t)},Model.Board.spInitialPosition=function(t){this.board=[];for(var r=0;r<t.g.Graph.length;r++)this.board[r]=0;this.maxLayer=0,this.ballCount=[0,0,0],this.playables={},this.height=[0,0,0],this.zSign=0;for(var r=0;r<t.mOptions.size*t.mOptions.size;r++)this.playables[r]=!0},Model.Board.MakeFreeMoves=function(t){var r=[];for(var a in this.playables)r.push({act:"+",pos:a,clr:this.mWho==JocGame.PLAYER_A?1:2});return r},Model.Board.GenerateMoves=function(t){var r=this.GenerateAllMoves(t),a=t.mOptions.moveCount;0==r.length?(this.mFinished=!0,this.ballCount[1]>this.ballCount[2]?this.mWinner=JocGame.PLAYER_A:this.ballCount[1]<this.ballCount[2]?this.mWinner=JocGame.PLAYER_B:this.mWinner=JocGame.DRAW):void 0!==a&&r.length>a&&(t.ArrayShuffle(r),r.sort(function(t,r){r.nextBoard.evaluation,t.nextBoard.evaluation}),r.splice(a,r.length-a)),this.mMoves=r},Model.Board.GenerateAllMoves=function(t){return this.MakeFreeMoves(t)},Model.Board.Evaluate=function(t,r,a){this.mEvaluation=0},Model.Board.ApplyMove=function(t,r){this.spApplyMove(t,r)},Model.Board.spApplyMove=function(t,r){function a(r){delete i.playables[r],t.g.EachDirectionFlat(r,function(a,o){if(i.board[a]){var e,n;switch(o){case 4:e=7,n=10;break;case 5:e=6,n=9;break;case 6:e=4,n=8;break;case 7:e=5,n=11}var s=t.g.Graph[r][e];null!==s&&i.board[s]>0&&i.board[t.g.Graph[a][e]]&&(i.playables[t.g.Graph[r][n]]=!0)}})}var i=this;switch(r.act){case"+":this.board[r.pos]=r.clr;var o=t.g.Coord[r.pos][2];o>this.maxLayer&&(this.maxLayer=o),this.height[r.clr]+=o,this.ballCount[r.clr]++,a(r.pos);break;case">":r.down.length>0?this.playables[r.down[r.down.length-1]]=!0:this.playables[r.from]=!0;var e=r.from;for(var n in r.down){var s=r.down[n];this.height[this.board[s]]--,this.board[e]=this.board[s],e=s}this.board[e]=0,this.board[r.to]=r.clr;var o=t.g.Coord[r.to][2];this.height[r.clr]+=o,o>this.maxLayer&&(this.maxLayer=o),a(r.to)}},Model.Board.IsValidMove=function(t,r){return!0},Model.Board.ExtendMove=function(t,r){return{}},Model.Board.GetSignature=function(){return this.zSign},Model.Game.InitGameExtra=function(){this.MapSameLevelDiagGraph(),this.BuildSplineLines(),this.g.factor={completion:[[4,2,1],[4,2],[4]],count:.1,sppHeight:1}},Model.Game.BuildSplineLines=function(){for(var t=this,r=[],a=[0,16,25,29],i=0;i<4;i++)for(var o=0;o<4-i;o++)for(var e=0;e<4-i;e++){var n=a[i]+o*(4-i)+e;!function(r,a){for(var i=[7,15,5,13],o=0;o<i.length;o++){var e=t.g.Graph[r][i[o]];null!=e&&a(e,i[o])}}(n,function(a,o){for(var e=[n];null!=a;)e.push(a),a=t.g.Graph[a][o];e.length==4-i&&r.push(e)})}this.g.SplineLines=r},Model.Board.splineEvaluate=function(t,r,a){for(var i=[[0,0,0],[0,0],[0]],o=[[0,0,0],[0,0],[0]],e=0;e<t.g.SplineLines.length;e++){var n=t.g.SplineLines[e],s=t.g.Coord[n[0]][2];if(s>this.maxLayer)break;var h=0,l=0,u=0;for(var v in n){var f=n[v];if(1==this.board[f])l++;else{if(2!=this.board[f]){h++;break}u++}}if(0==h){if(0==l?(this.mFinished=!0,this.mWinner=JocGame.PLAYER_B):0==u&&(this.mFinished=!0,this.mWinner=JocGame.PLAYER_A),this.mFinished)return void(a&&(this.mWinLine=n))}else 0==l&&u>0?o[s][s-u-1]++:0==u&&l>0&&i[s][s-l-1]++}this.mEvaluation=0;for(var e=0;e<3;e++)for(var v=0;v<3-e;v++)this.mEvaluation+=(i[e][v]-o[e][v])*t.g.factor.completion[e][v];this.mEvaluation+=(this.ballCount[1]-this.ballCount[2])*t.g.factor.count},Model.Board.Evaluate=function(){this.splineEvaluate.apply(this,arguments)},Model.Board.GenerateAllMoves=function(t){var r=this.MakeFreeMoves(t),a=this.MakeSelfSinglePinMoves(t);return a.length>0&&(r=r.concat(a)),r},Model.Board.GetSingleUpBalls=function(t,r,a){var i=this,o=[],e=[];if(t.g.EachDirectionUp(r,function(t,r){return 0!=i.board[t]?(o.push(t),e.push(r)):a&&(a[t]=!0),!0}),0==o.length)return[];if(o.length>1)return null;for(var n=o[0],s=[n];null!=(n=t.g.Graph[n][e[0]]);){if(0==this.board[n])return a&&(a[n]=!0),s;s.push(n)}return s},Model.Board.MakeSelfSinglePinMoves=function(t){var r=[],a=this.mWho==JocGame.PLAYER_A?1:2;for(var i in t.g.Coord){if(t.g.Coord[i][2]>this.maxLayer)break;if(this.board[i]==a){var o={},e=this.GetSingleUpBalls(t,i,o);if(null!=e)for(var n in this.mMoves){var s=this.mMoves[n];"+"==s.act&&void 0===o[s.pos]&&r.push({act:">",from:i,to:s.pos,down:e,clr:a})}}}return r},Model.Board.Evaluate=function(t){this.splineEvaluate.apply(this,arguments),this.mEvaluation+=(this.height[1]-this.height[2])*t.g.factor.sppHeight};

/***/ }),

/***/ "4PFd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_operator_pluck__ = __webpack_require__("U9ky");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_operator_pluck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs_operator_pluck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_operator_map__ = __webpack_require__("xAJs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_operator_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs_operator_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_operator_distinctUntilChanged__ = __webpack_require__("8hgl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_operator_distinctUntilChanged___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs_operator_distinctUntilChanged__);
/* harmony export (immutable) */ __webpack_exports__["a"] = select;



function select(pathOrMapFn) {
    var paths = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        paths[_i - 1] = arguments[_i];
    }
    var mapped$;
    if (typeof pathOrMapFn === 'string') {
        mapped$ = __WEBPACK_IMPORTED_MODULE_0_rxjs_operator_pluck__["pluck"].call.apply(__WEBPACK_IMPORTED_MODULE_0_rxjs_operator_pluck__["pluck"], [this, pathOrMapFn].concat(paths));
    }
    else if (typeof pathOrMapFn === 'function') {
        mapped$ = __WEBPACK_IMPORTED_MODULE_1_rxjs_operator_map__["map"].call(this, pathOrMapFn);
    }
    else {
        throw new TypeError(("Unexpected type " + typeof pathOrMapFn + " in select operator,")
            + " expected 'string' or 'function'");
    }
    return __WEBPACK_IMPORTED_MODULE_2_rxjs_operator_distinctUntilChanged__["distinctUntilChanged"].call(mapped$);
}
//# sourceMappingURL=select.js.map

/***/ }),

/***/ "4VA+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("3j3K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_common__ = __webpack_require__("2Je8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commander__ = __webpack_require__("8zPk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__dock__ = __webpack_require__("VQzz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__dock_monitor__ = __webpack_require__("3Ka+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions__ = __webpack_require__("prmc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reducer__ = __webpack_require__("D4hj");
/* unused harmony reexport useDockMonitor */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DockMonitorModule; });






var DockMonitorModule = (function () {
    function DockMonitorModule() {
    }
    DockMonitorModule.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{
                    imports: [
                        __WEBPACK_IMPORTED_MODULE_1__angular_common__["CommonModule"]
                    ],
                    declarations: [
                        __WEBPACK_IMPORTED_MODULE_2__commander__["a" /* CommanderComponent */],
                        __WEBPACK_IMPORTED_MODULE_3__dock__["a" /* DockComponent */],
                        __WEBPACK_IMPORTED_MODULE_4__dock_monitor__["a" /* DockMonitorComponent */]
                    ],
                    providers: [
                        __WEBPACK_IMPORTED_MODULE_5__actions__["a" /* DockActions */]
                    ],
                    exports: [
                        __WEBPACK_IMPORTED_MODULE_4__dock_monitor__["a" /* DockMonitorComponent */]
                    ]
                },] },
    ];
    /** @nocollapse */
    DockMonitorModule.ctorParameters = [];
    return DockMonitorModule;
}());

//# sourceMappingURL=index.js.map

/***/ }),

/***/ "4p5j":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("3j3K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_operator_map__ = __webpack_require__("xAJs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_operator_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs_operator_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ngrx_store_devtools__ = __webpack_require__("j3uM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ngrx_core_operator_select__ = __webpack_require__("t8yF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ngrx_core_operator_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ngrx_core_operator_select__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LogMonitorComponent; });




var LogMonitorComponent = (function () {
    function LogMonitorComponent(devtools) {
        this.devtools = devtools;
        this.expandEntries = true;
        this.canRevert$ = __WEBPACK_IMPORTED_MODULE_3__ngrx_core_operator_select__["select"].call(devtools.liftedState, function (s) { return !(s.computedStates.length > 1); });
        this.canSweep$ = __WEBPACK_IMPORTED_MODULE_3__ngrx_core_operator_select__["select"].call(devtools.liftedState, function (s) { return !(s.skippedActionIds.length > 0); });
        this.canCommit$ = __WEBPACK_IMPORTED_MODULE_3__ngrx_core_operator_select__["select"].call(devtools.liftedState, function (s) { return !(s.computedStates.length > 1); });
        this.items$ = __WEBPACK_IMPORTED_MODULE_1_rxjs_operator_map__["map"].call(devtools.liftedState, function (_a) {
            var actionsById = _a.actionsById, skippedActionIds = _a.skippedActionIds, stagedActionIds = _a.stagedActionIds, computedStates = _a.computedStates;
            var actions = [];
            for (var i = 0; i < stagedActionIds.length; i++) {
                var actionId = stagedActionIds[i];
                var action = actionsById[actionId].action;
                var _b = computedStates[i], state = _b.state, error = _b.error;
                var previousState = void 0;
                if (i > 0) {
                    previousState = computedStates[i - 1].state;
                }
                actions.push({
                    key: actionId,
                    collapsed: skippedActionIds.indexOf(actionId) > -1,
                    action: action,
                    actionId: actionId,
                    state: state,
                    previousState: previousState,
                    error: error
                });
            }
            return actions;
        });
    }
    LogMonitorComponent.prototype.handleToggle = function (id) {
        this.devtools.toggleAction(id);
    };
    LogMonitorComponent.prototype.handleReset = function () {
        this.devtools.reset();
    };
    LogMonitorComponent.prototype.handleRollback = function () {
        this.devtools.rollback();
    };
    LogMonitorComponent.prototype.handleSweep = function () {
        this.devtools.sweep();
    };
    LogMonitorComponent.prototype.handleCommit = function () {
        this.devtools.commit();
    };
    LogMonitorComponent.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{
                    selector: 'log-monitor',
                    styles: ["\n    :host {\n      display: block;\n      background-color: #2A2F3A;\n      font-family: 'monaco', 'Consolas', 'Lucida Console', monospace;\n      position: relative;\n      overflow-y: hidden;\n      width: 100%;\n      height: 100%;\n      min-width: 300px;\n      direction: ltr;\n    }\n\n    .button-bar {\n      text-align: center;\n      border-bottom-width: 1px;\n      border-bottom-style: solid;\n      border-color: transparent;\n      z-index: 1;\n      display: flex;\n      flex-direction: row;\n      padding: 0 4px;\n    }\n\n    .elements {\n      position: absolute;\n      left: 0;\n      right: 0;\n      top: 38px;\n      bottom: 0;\n      overflow-x: hidden;\n      overflow-y: auto;\n    }\n  "],
                    template: "\n    <div class=\"button-bar\">\n      <log-monitor-button (action)=\"handleReset()\">\n        Reset\n      </log-monitor-button>\n\n      <log-monitor-button (action)=\"handleRollback()\">\n        Revert\n      </log-monitor-button>\n\n      <log-monitor-button (action)=\"handleSweep()\" [disabled]=\"canSweep$ | async\">\n        Sweep\n      </log-monitor-button>\n\n      <log-monitor-button (action)=\"handleCommit()\" [disabled]=\"canCommit$ | async\">\n        Commit\n      </log-monitor-button>\n    </div>\n    <div class=\"elements\">\n      <log-monitor-entry\n        *ngFor=\"let item of (items$ | async); let i = index\"\n        [item]=\"item\"\n        [disabled]=\"i === 0\"\n        [expandEntries]=\"expandEntries\"\n        (toggle)=\"handleToggle($event.id)\">\n      </log-monitor-entry>\n    </div>\n  "
                },] },
    ];
    /** @nocollapse */
    LogMonitorComponent.ctorParameters = [
        { type: __WEBPACK_IMPORTED_MODULE_2__ngrx_store_devtools__["b" /* StoreDevtools */], },
    ];
    LogMonitorComponent.propDecorators = {
        'expandEntries': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    };
    return LogMonitorComponent;
}());
//# sourceMappingURL=log-monitor.js.map

/***/ }),

/***/ "52Ty":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Subject_1 = __webpack_require__("EEr4");
var multicast_1 = __webpack_require__("emOw");
/* tslint:enable:max-line-length */
/**
 * Returns a ConnectableObservable, which is a variety of Observable that waits until its connect method is called
 * before it begins emitting items to those Observers that have subscribed to it.
 *
 * <img src="./img/publish.png" width="100%">
 *
 * @param {Function} [selector] - Optional selector function which can use the multicasted source sequence as many times
 * as needed, without causing multiple subscriptions to the source sequence.
 * Subscribers to the given source will receive all notifications of the source from the time of the subscription on.
 * @return A ConnectableObservable that upon connection causes the source Observable to emit items to its Observers.
 * @method publish
 * @owner Observable
 */
function publish(selector) {
    return selector ? multicast_1.multicast.call(this, function () { return new Subject_1.Subject(); }, selector) :
        multicast_1.multicast.call(this, new Subject_1.Subject());
}
exports.publish = publish;
//# sourceMappingURL=publish.js.map

/***/ }),

/***/ "5Voz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("3j3K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_common__ = __webpack_require__("2Je8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base_adapter__ = __webpack_require__("esTq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__media_query_breakpoints_break_point_registry__ = __webpack_require__("eZjk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__media_query_media_monitor__ = __webpack_require__("bWt6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_object_extend__ = __webpack_require__("xZ/u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__angular_platform_browser__ = __webpack_require__("Qbdm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_style_transforms__ = __webpack_require__("YEB2");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StyleDirective; });
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */








/**
 * Directive to add responsive support for ngStyle.
 *
 */
var StyleDirective = (function (_super) {
    __extends(StyleDirective, _super);
    /* tslint:enable */
    /**
     *  Constructor for the ngStyle subclass; which adds selectors and
     *  a MediaQuery Activation Adapter
     */
    function StyleDirective(monitor, _bpRegistry, _sanitizer, _differs, _ngEl, _oldRenderer, _renderer) {
        var _this = 
        // TODO: this should use Renderer2 when the NgStyle signature is switched over to it.
        _super.call(this, _differs, _ngEl, _oldRenderer) || this;
        _this.monitor = monitor;
        _this._bpRegistry = _bpRegistry;
        _this._sanitizer = _sanitizer;
        // Build adapter, `cacheInput()` interceptor, and get current inline style if any
        _this._buildAdapter(monitor, _ngEl, _renderer);
        _this._base.cacheInput('style', _ngEl.nativeElement.getAttribute("style"), true);
        return _this;
    }
    Object.defineProperty(StyleDirective.prototype, "styleBase", {
        /**
         * Intercept ngStyle assignments so we cache the default styles
         * which are merged with activated styles or used as fallbacks.
         */
        set: function (val) {
            this._base.cacheInput('style', val, true);
            this.ngStyle = this._base.inputMap['style'];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StyleDirective.prototype, "ngStyleXs", {
        /* tslint:disable */
        set: function (val) { this._base.cacheInput('styleXs', val, true); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StyleDirective.prototype, "ngStyleSm", {
        set: function (val) { this._base.cacheInput('styleSm', val, true); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(StyleDirective.prototype, "ngStyleMd", {
        set: function (val) { this._base.cacheInput('styleMd', val, true); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(StyleDirective.prototype, "ngStyleLg", {
        set: function (val) { this._base.cacheInput('styleLg', val, true); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(StyleDirective.prototype, "ngStyleXl", {
        set: function (val) { this._base.cacheInput('styleXl', val, true); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(StyleDirective.prototype, "ngStyleLtSm", {
        set: function (val) { this._base.cacheInput('styleLtSm', val, true); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(StyleDirective.prototype, "ngStyleLtMd", {
        set: function (val) { this._base.cacheInput('styleLtMd', val, true); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(StyleDirective.prototype, "ngStyleLtLg", {
        set: function (val) { this._base.cacheInput('styleLtLg', val, true); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(StyleDirective.prototype, "ngStyleLtXl", {
        set: function (val) { this._base.cacheInput('styleLtXl', val, true); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(StyleDirective.prototype, "ngStyleGtXs", {
        set: function (val) { this._base.cacheInput('styleGtXs', val, true); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(StyleDirective.prototype, "ngStyleGtSm", {
        set: function (val) { this._base.cacheInput('styleGtSm', val, true); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(StyleDirective.prototype, "ngStyleGtMd", {
        set: function (val) { this._base.cacheInput('styleGtMd', val, true); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(StyleDirective.prototype, "ngStyleGtLg", {
        set: function (val) { this._base.cacheInput('styleGtLg', val, true); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(StyleDirective.prototype, "styleXs", {
        /** Deprecated selectors */
        set: function (val) { this._base.cacheInput('styleXs', val, true); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StyleDirective.prototype, "styleSm", {
        set: function (val) { this._base.cacheInput('styleSm', val, true); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(StyleDirective.prototype, "styleMd", {
        set: function (val) { this._base.cacheInput('styleMd', val, true); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(StyleDirective.prototype, "styleLg", {
        set: function (val) { this._base.cacheInput('styleLg', val, true); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(StyleDirective.prototype, "styleXl", {
        set: function (val) { this._base.cacheInput('styleXl', val, true); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(StyleDirective.prototype, "styleLtSm", {
        set: function (val) { this._base.cacheInput('styleLtSm', val, true); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(StyleDirective.prototype, "styleLtMd", {
        set: function (val) { this._base.cacheInput('styleLtMd', val, true); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(StyleDirective.prototype, "styleLtLg", {
        set: function (val) { this._base.cacheInput('styleLtLg', val, true); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(StyleDirective.prototype, "styleLtXl", {
        set: function (val) { this._base.cacheInput('styleLtXl', val, true); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(StyleDirective.prototype, "styleGtXs", {
        set: function (val) { this._base.cacheInput('styleGtXs', val, true); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(StyleDirective.prototype, "styleGtSm", {
        set: function (val) { this._base.cacheInput('styleGtSm', val, true); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(StyleDirective.prototype, "styleGtMd", {
        set: function (val) { this._base.cacheInput('styleGtMd', val, true); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(StyleDirective.prototype, "styleGtLg", {
        set: function (val) { this._base.cacheInput('styleGtLg', val, true); },
        enumerable: true,
        configurable: true
    });
    ;
    // ******************************************************************
    // Lifecycle Hookks
    // ******************************************************************
    /**
     * For @Input changes on the current mq activation property
     */
    StyleDirective.prototype.ngOnChanges = function (changes) {
        if (this._base.activeKey in changes) {
            this._updateStyle();
        }
    };
    /**
     * For ChangeDetectionStrategy.onPush and ngOnChanges() updates
     */
    StyleDirective.prototype.ngDoCheck = function () {
        if (!this._base.hasMediaQueryListener) {
            this._configureMQListener();
        }
        _super.prototype.ngDoCheck.call(this);
    };
    StyleDirective.prototype.ngOnDestroy = function () {
        this._base.ngOnDestroy();
    };
    // ******************************************************************
    // Internal Methods
    // ******************************************************************
    /**
       * Build an mqActivation object that bridges
       * mql change events to onMediaQueryChange handlers
       */
    StyleDirective.prototype._configureMQListener = function () {
        var _this = this;
        this._base.listenForMediaQueryChanges('style', '', function (changes) {
            _this._updateStyle(changes.value);
            // trigger NgClass::_applyIterableChanges()
            _super.prototype.ngDoCheck.call(_this);
        });
    };
    // ************************************************************************
    // Private Internal Methods
    // ************************************************************************
    /**
     * Use the currently activated input property and assign to
     * `ngStyle` which does the style injections...
     */
    StyleDirective.prototype._updateStyle = function (value) {
        var style = value || this._base.queryInput("style") || '';
        if (this._base.mqActivation) {
            style = this._base.mqActivation.activatedInput;
        }
        // Delegate subsequent activity to the NgStyle logic
        this.ngStyle = style;
    };
    /**
     * Build MediaQuery Activation Adapter
     * This adapter manages listening to mediaQuery change events and identifying
     * which property value should be used for the style update
     */
    StyleDirective.prototype._buildAdapter = function (monitor, _ngEl, _renderer) {
        this._base = new __WEBPACK_IMPORTED_MODULE_2__base_adapter__["a" /* BaseFxDirectiveAdapter */]('style', monitor, _ngEl, _renderer);
        this._buildCacheInterceptor();
    };
    /**
     * Build intercept to convert raw strings to ngStyleMap
     */
    StyleDirective.prototype._buildCacheInterceptor = function () {
        var _this = this;
        var cacheInput = this._base.cacheInput.bind(this._base);
        this._base.cacheInput = function (key, source, cacheRaw, merge) {
            if (cacheRaw === void 0) { cacheRaw = false; }
            if (merge === void 0) { merge = true; }
            var styles = _this._buildStyleMap(source);
            if (merge) {
                styles = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_object_extend__["a" /* extendObject */])({}, _this._base.inputMap['style'], styles);
            }
            cacheInput(key, styles, cacheRaw);
        };
    };
    /**
     * Convert raw strings to ngStyleMap; which is required by ngStyle
     * NOTE: Raw string key-value pairs MUST be delimited by `;`
     *       Comma-delimiters are not supported due to complexities of
     *       possible style values such as `rgba(x,x,x,x)` and others
     */
    StyleDirective.prototype._buildStyleMap = function (styles) {
        var _this = this;
        var sanitizer = function (val) {
            // Always safe-guard (aka sanitize) style property values
            return _this._sanitizer.sanitize(__WEBPACK_IMPORTED_MODULE_0__angular_core__["SecurityContext"].STYLE, val);
        };
        if (styles) {
            switch (__WEBPACK_IMPORTED_MODULE_7__utils_style_transforms__["a" /* ngStyleUtils */].getType(styles)) {
                case 'string': return __WEBPACK_IMPORTED_MODULE_7__utils_style_transforms__["a" /* ngStyleUtils */].buildMapFromList(__WEBPACK_IMPORTED_MODULE_7__utils_style_transforms__["a" /* ngStyleUtils */].buildRawList(styles), sanitizer);
                case 'array': return __WEBPACK_IMPORTED_MODULE_7__utils_style_transforms__["a" /* ngStyleUtils */].buildMapFromList(styles, sanitizer);
                case 'set': return __WEBPACK_IMPORTED_MODULE_7__utils_style_transforms__["a" /* ngStyleUtils */].buildMapFromSet(styles, sanitizer);
                default: return __WEBPACK_IMPORTED_MODULE_7__utils_style_transforms__["a" /* ngStyleUtils */].buildMapFromSet(styles, sanitizer);
            }
        }
        return styles;
    };
    return StyleDirective;
}(__WEBPACK_IMPORTED_MODULE_1__angular_common__["NgStyle"]));

StyleDirective.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                selector: "\n    [style.xs], [style.sm], [style.md], [style.lg], [style.xl],\n    [style.lt-sm], [style.lt-md], [style.lt-lg], [style.lt-xl],\n    [style.gt-xs], [style.gt-sm], [style.gt-md], [style.gt-lg],\n    [ngStyle],\n    [ngStyle.xs], [ngStyle.sm], [ngStyle.lg], [ngStyle.xl],\n    [ngStyle.lt-sm], [ngStyle.lt-md], [ngStyle.lt-lg], [ngStyle.lt-xl],\n    [ngStyle.gt-xs], [ngStyle.gt-sm], [ngStyle.gt-md], [ngStyle.gt-lg]\n  "
            },] },
];
/** @nocollapse */
StyleDirective.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_4__media_query_media_monitor__["a" /* MediaMonitor */], },
    { type: __WEBPACK_IMPORTED_MODULE_3__media_query_breakpoints_break_point_registry__["a" /* BreakPointRegistry */], },
    { type: __WEBPACK_IMPORTED_MODULE_6__angular_platform_browser__["DomSanitizer"], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["KeyValueDiffers"], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer2"], },
]; };
StyleDirective.propDecorators = {
    'styleBase': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['ngStyle',] },],
    'ngStyleXs': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['ngStyle.xs',] },],
    'ngStyleSm': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['ngStyle.sm',] },],
    'ngStyleMd': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['ngStyle.md',] },],
    'ngStyleLg': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['ngStyle.lg',] },],
    'ngStyleXl': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['ngStyle.xl',] },],
    'ngStyleLtSm': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['ngStyle.lt-sm',] },],
    'ngStyleLtMd': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['ngStyle.lt-md',] },],
    'ngStyleLtLg': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['ngStyle.lt-lg',] },],
    'ngStyleLtXl': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['ngStyle.lt-xl',] },],
    'ngStyleGtXs': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['ngStyle.gt-xs',] },],
    'ngStyleGtSm': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['ngStyle.gt-sm',] },],
    'ngStyleGtMd': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['ngStyle.gt-md',] },],
    'ngStyleGtLg': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['ngStyle.gt-lg',] },],
    'styleXs': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['style.xs',] },],
    'styleSm': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['style.sm',] },],
    'styleMd': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['style.md',] },],
    'styleLg': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['style.lg',] },],
    'styleXl': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['style.xl',] },],
    'styleLtSm': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['style.lt-sm',] },],
    'styleLtMd': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['style.lt-md',] },],
    'styleLtLg': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['style.lt-lg',] },],
    'styleLtXl': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['style.lt-xl',] },],
    'styleGtXs': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['style.gt-xs',] },],
    'styleGtSm': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['style.gt-sm',] },],
    'styleGtMd': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['style.gt-md',] },],
    'styleGtLg': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['style.gt-lg',] },],
};
//# sourceMappingURL=style.js.map

/***/ }),

/***/ "5aXj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__breakpoints_data_break_points__ = __webpack_require__("fuE2");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__breakpoints_data_orientation_break_points__ = __webpack_require__("S3x0");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__breakpoints_break_points_token__ = __webpack_require__("pvzN");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__breakpoints_break_point_registry__ = __webpack_require__("eZjk");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__observable_media__ = __webpack_require__("R7bj");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__match_media__ = __webpack_require__("LuwH");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__media_change__ = __webpack_require__("PXjH");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__media_monitor__ = __webpack_require__("bWt6");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__breakpoints_break_points_provider__ = __webpack_require__("r666");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__observable_media_provider__ = __webpack_require__("pcn9");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__media_monitor_provider__ = __webpack_require__("jIkT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__module__ = __webpack_require__("OBRl");
/* unused harmony namespace reexport */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */












//# sourceMappingURL=index.js.map

/***/ }),

/***/ "5c/I":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subject_1 = __webpack_require__("EEr4");
var Subscription_1 = __webpack_require__("B00U");
/**
 * @class AsyncSubject<T>
 */
var AsyncSubject = (function (_super) {
    __extends(AsyncSubject, _super);
    function AsyncSubject() {
        _super.apply(this, arguments);
        this.value = null;
        this.hasNext = false;
        this.hasCompleted = false;
    }
    AsyncSubject.prototype._subscribe = function (subscriber) {
        if (this.hasError) {
            subscriber.error(this.thrownError);
            return Subscription_1.Subscription.EMPTY;
        }
        else if (this.hasCompleted && this.hasNext) {
            subscriber.next(this.value);
            subscriber.complete();
            return Subscription_1.Subscription.EMPTY;
        }
        return _super.prototype._subscribe.call(this, subscriber);
    };
    AsyncSubject.prototype.next = function (value) {
        if (!this.hasCompleted) {
            this.value = value;
            this.hasNext = true;
        }
    };
    AsyncSubject.prototype.error = function (error) {
        if (!this.hasCompleted) {
            _super.prototype.error.call(this, error);
        }
    };
    AsyncSubject.prototype.complete = function () {
        this.hasCompleted = true;
        if (this.hasNext) {
            _super.prototype.next.call(this, this.value);
        }
        _super.prototype.complete.call(this);
    };
    return AsyncSubject;
}(Subject_1.Subject));
exports.AsyncSubject = AsyncSubject;
//# sourceMappingURL=AsyncSubject.js.map

/***/ }),

/***/ "5nj5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var IfObservable_1 = __webpack_require__("LhE+");
exports._if = IfObservable_1.IfObservable.create;
//# sourceMappingURL=if.js.map

/***/ }),

/***/ "5oXY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_common__ = __webpack_require__("2Je8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__("3j3K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_BehaviorSubject__ = __webpack_require__("TfWX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_BehaviorSubject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs_BehaviorSubject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_Subject__ = __webpack_require__("EEr4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_Subject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rxjs_Subject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_observable_from__ = __webpack_require__("PKvP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_observable_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_rxjs_observable_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_observable_of__ = __webpack_require__("lgiQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_observable_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_rxjs_observable_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs_operator_concatMap__ = __webpack_require__("bE1M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs_operator_concatMap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_rxjs_operator_concatMap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rxjs_operator_every__ = __webpack_require__("83T1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rxjs_operator_every___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_rxjs_operator_every__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rxjs_operator_first__ = __webpack_require__("bBiI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rxjs_operator_first___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_rxjs_operator_first__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_rxjs_operator_map__ = __webpack_require__("xAJs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_rxjs_operator_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_rxjs_operator_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_rxjs_operator_mergeMap__ = __webpack_require__("XO5T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_rxjs_operator_mergeMap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_rxjs_operator_mergeMap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_rxjs_operator_reduce__ = __webpack_require__("pgP5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_rxjs_operator_reduce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_rxjs_operator_reduce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_rxjs_Observable__ = __webpack_require__("rCTf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_rxjs_Observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_rxjs_operator_catch__ = __webpack_require__("+4ur");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_rxjs_operator_catch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_rxjs_operator_catch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_rxjs_operator_concatAll__ = __webpack_require__("CfHE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_rxjs_operator_concatAll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_rxjs_operator_concatAll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_rxjs_util_EmptyError__ = __webpack_require__("F7Al");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_rxjs_util_EmptyError___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_rxjs_util_EmptyError__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_rxjs_observable_fromPromise__ = __webpack_require__("ioK+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_rxjs_observable_fromPromise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_rxjs_observable_fromPromise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_rxjs_operator_last__ = __webpack_require__("7nvF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_rxjs_operator_last___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_rxjs_operator_last__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_rxjs_operator_mergeAll__ = __webpack_require__("cbuX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_rxjs_operator_mergeAll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_rxjs_operator_mergeAll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__angular_platform_browser__ = __webpack_require__("Qbdm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_rxjs_operator_filter__ = __webpack_require__("ack3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_rxjs_operator_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_rxjs_operator_filter__);
/* unused harmony export RouterLink */
/* unused harmony export RouterLinkWithHref */
/* unused harmony export RouterLinkActive */
/* unused harmony export RouterOutlet */
/* unused harmony export NavigationCancel */
/* unused harmony export NavigationEnd */
/* unused harmony export NavigationError */
/* unused harmony export NavigationStart */
/* unused harmony export RouteConfigLoadEnd */
/* unused harmony export RouteConfigLoadStart */
/* unused harmony export RoutesRecognized */
/* unused harmony export RouteReuseStrategy */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Router; });
/* unused harmony export ROUTES */
/* unused harmony export ROUTER_CONFIGURATION */
/* unused harmony export ROUTER_INITIALIZER */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RouterModule; });
/* unused harmony export provideRoutes */
/* unused harmony export RouterOutletMap */
/* unused harmony export NoPreloading */
/* unused harmony export PreloadAllModules */
/* unused harmony export PreloadingStrategy */
/* unused harmony export RouterPreloader */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ActivatedRoute; });
/* unused harmony export ActivatedRouteSnapshot */
/* unused harmony export RouterState */
/* unused harmony export RouterStateSnapshot */
/* unused harmony export PRIMARY_OUTLET */
/* unused harmony export convertToParamMap */
/* unused harmony export UrlHandlingStrategy */
/* unused harmony export DefaultUrlSerializer */
/* unused harmony export UrlSegment */
/* unused harmony export UrlSegmentGroup */
/* unused harmony export UrlSerializer */
/* unused harmony export UrlTree */
/* unused harmony export VERSION */
/* unused harmony export ɵROUTER_PROVIDERS */
/* unused harmony export ɵflatten */
/* unused harmony export ɵa */
/* unused harmony export ɵg */
/* unused harmony export ɵh */
/* unused harmony export ɵi */
/* unused harmony export ɵd */
/* unused harmony export ɵc */
/* unused harmony export ɵj */
/* unused harmony export ɵf */
/* unused harmony export ɵb */
/* unused harmony export ɵe */
/* unused harmony export ɵk */
/* unused harmony export ɵl */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * @license Angular v4.1.0
 * (c) 2010-2017 Google, Inc. https://angular.io/
 * License: MIT
 */ 




















/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * \@whatItDoes Represents an event triggered when a navigation starts.
 *
 * \@stable
 */
var NavigationStart = (function () {
    /**
     * @param {?} id
     * @param {?} url
     */
    function NavigationStart(id, url) {
        this.id = id;
        this.url = url;
    }
    /**
     * \@docsNotRequired
     * @return {?}
     */
    NavigationStart.prototype.toString = function () { return "NavigationStart(id: " + this.id + ", url: '" + this.url + "')"; };
    return NavigationStart;
}());
/**
 * \@whatItDoes Represents an event triggered when a navigation ends successfully.
 *
 * \@stable
 */
var NavigationEnd = (function () {
    /**
     * @param {?} id
     * @param {?} url
     * @param {?} urlAfterRedirects
     */
    function NavigationEnd(id, url, urlAfterRedirects) {
        this.id = id;
        this.url = url;
        this.urlAfterRedirects = urlAfterRedirects;
    }
    /**
     * \@docsNotRequired
     * @return {?}
     */
    NavigationEnd.prototype.toString = function () {
        return "NavigationEnd(id: " + this.id + ", url: '" + this.url + "', urlAfterRedirects: '" + this.urlAfterRedirects + "')";
    };
    return NavigationEnd;
}());
/**
 * \@whatItDoes Represents an event triggered when a navigation is canceled.
 *
 * \@stable
 */
var NavigationCancel = (function () {
    /**
     * @param {?} id
     * @param {?} url
     * @param {?} reason
     */
    function NavigationCancel(id, url, reason) {
        this.id = id;
        this.url = url;
        this.reason = reason;
    }
    /**
     * \@docsNotRequired
     * @return {?}
     */
    NavigationCancel.prototype.toString = function () { return "NavigationCancel(id: " + this.id + ", url: '" + this.url + "')"; };
    return NavigationCancel;
}());
/**
 * \@whatItDoes Represents an event triggered when a navigation fails due to an unexpected error.
 *
 * \@stable
 */
var NavigationError = (function () {
    /**
     * @param {?} id
     * @param {?} url
     * @param {?} error
     */
    function NavigationError(id, url, error) {
        this.id = id;
        this.url = url;
        this.error = error;
    }
    /**
     * \@docsNotRequired
     * @return {?}
     */
    NavigationError.prototype.toString = function () {
        return "NavigationError(id: " + this.id + ", url: '" + this.url + "', error: " + this.error + ")";
    };
    return NavigationError;
}());
/**
 * \@whatItDoes Represents an event triggered when routes are recognized.
 *
 * \@stable
 */
var RoutesRecognized = (function () {
    /**
     * @param {?} id
     * @param {?} url
     * @param {?} urlAfterRedirects
     * @param {?} state
     */
    function RoutesRecognized(id, url, urlAfterRedirects, state) {
        this.id = id;
        this.url = url;
        this.urlAfterRedirects = urlAfterRedirects;
        this.state = state;
    }
    /**
     * \@docsNotRequired
     * @return {?}
     */
    RoutesRecognized.prototype.toString = function () {
        return "RoutesRecognized(id: " + this.id + ", url: '" + this.url + "', urlAfterRedirects: '" + this.urlAfterRedirects + "', state: " + this.state + ")";
    };
    return RoutesRecognized;
}());
/**
 * \@whatItDoes Represents an event triggered before lazy loading a route config.
 *
 * \@experimental
 */
var RouteConfigLoadStart = (function () {
    /**
     * @param {?} route
     */
    function RouteConfigLoadStart(route) {
        this.route = route;
    }
    /**
     * @return {?}
     */
    RouteConfigLoadStart.prototype.toString = function () { return "RouteConfigLoadStart(path: " + this.route.path + ")"; };
    return RouteConfigLoadStart;
}());
/**
 * \@whatItDoes Represents an event triggered when a route has been lazy loaded.
 *
 * \@experimental
 */
var RouteConfigLoadEnd = (function () {
    /**
     * @param {?} route
     */
    function RouteConfigLoadEnd(route) {
        this.route = route;
    }
    /**
     * @return {?}
     */
    RouteConfigLoadEnd.prototype.toString = function () { return "RouteConfigLoadEnd(path: " + this.route.path + ")"; };
    return RouteConfigLoadEnd;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * \@whatItDoes Name of the primary outlet.
 *
 * \@stable
 */
var PRIMARY_OUTLET = 'primary';
var ParamsAsMap = (function () {
    /**
     * @param {?} params
     */
    function ParamsAsMap(params) {
        this.params = params || {};
    }
    /**
     * @param {?} name
     * @return {?}
     */
    ParamsAsMap.prototype.has = function (name) { return this.params.hasOwnProperty(name); };
    /**
     * @param {?} name
     * @return {?}
     */
    ParamsAsMap.prototype.get = function (name) {
        if (this.has(name)) {
            var /** @type {?} */ v = this.params[name];
            return Array.isArray(v) ? v[0] : v;
        }
        return null;
    };
    /**
     * @param {?} name
     * @return {?}
     */
    ParamsAsMap.prototype.getAll = function (name) {
        if (this.has(name)) {
            var /** @type {?} */ v = this.params[name];
            return Array.isArray(v) ? v : [v];
        }
        return [];
    };
    Object.defineProperty(ParamsAsMap.prototype, "keys", {
        /**
         * @return {?}
         */
        get: function () { return Object.keys(this.params); },
        enumerable: true,
        configurable: true
    });
    return ParamsAsMap;
}());
/**
 * Convert a {\@link Params} instance to a {\@link ParamMap}.
 *
 * \@stable
 * @param {?} params
 * @return {?}
 */
function convertToParamMap(params) {
    return new ParamsAsMap(params);
}
var NAVIGATION_CANCELING_ERROR = 'ngNavigationCancelingError';
/**
 * @param {?} message
 * @return {?}
 */
function navigationCancelingError(message) {
    var /** @type {?} */ error = Error('NavigationCancelingError: ' + message);
    ((error))[NAVIGATION_CANCELING_ERROR] = true;
    return error;
}
/**
 * @param {?} error
 * @return {?}
 */
function isNavigationCancelingError(error) {
    return ((error))[NAVIGATION_CANCELING_ERROR];
}
/**
 * @param {?} segments
 * @param {?} segmentGroup
 * @param {?} route
 * @return {?}
 */
function defaultUrlMatcher(segments, segmentGroup, route) {
    var /** @type {?} */ parts = ((route.path)).split('/');
    if (parts.length > segments.length) {
        // The actual URL is shorter than the config, no match
        return null;
    }
    if (route.pathMatch === 'full' &&
        (segmentGroup.hasChildren() || parts.length < segments.length)) {
        // The config is longer than the actual URL but we are looking for a full match, return null
        return null;
    }
    var /** @type {?} */ posParams = {};
    // Check each config part against the actual URL
    for (var /** @type {?} */ index = 0; index < parts.length; index++) {
        var /** @type {?} */ part = parts[index];
        var /** @type {?} */ segment = segments[index];
        var /** @type {?} */ isParameter = part.startsWith(':');
        if (isParameter) {
            posParams[part.substring(1)] = segment;
        }
        else if (part !== segment.path) {
            // The actual URL part does not match the config, no match
            return null;
        }
    }
    return { consumed: segments.slice(0, parts.length), posParams: posParams };
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var LoadedRouterConfig = (function () {
    /**
     * @param {?} routes
     * @param {?} module
     */
    function LoadedRouterConfig(routes, module) {
        this.routes = routes;
        this.module = module;
    }
    return LoadedRouterConfig;
}());
/**
 * @param {?} config
 * @param {?=} parentPath
 * @return {?}
 */
function validateConfig(config, parentPath) {
    if (parentPath === void 0) { parentPath = ''; }
    // forEach doesn't iterate undefined values
    for (var /** @type {?} */ i = 0; i < config.length; i++) {
        var /** @type {?} */ route = config[i];
        var /** @type {?} */ fullPath = getFullPath(parentPath, route);
        validateNode(route, fullPath);
    }
}
/**
 * @param {?} route
 * @param {?} fullPath
 * @return {?}
 */
function validateNode(route, fullPath) {
    if (!route) {
        throw new Error("\n      Invalid configuration of route '" + fullPath + "': Encountered undefined route.\n      The reason might be an extra comma.\n\n      Example:\n      const routes: Routes = [\n        { path: '', redirectTo: '/dashboard', pathMatch: 'full' },\n        { path: 'dashboard',  component: DashboardComponent },, << two commas\n        { path: 'detail/:id', component: HeroDetailComponent }\n      ];\n    ");
    }
    if (Array.isArray(route)) {
        throw new Error("Invalid configuration of route '" + fullPath + "': Array cannot be specified");
    }
    if (!route.component && (route.outlet && route.outlet !== PRIMARY_OUTLET)) {
        throw new Error("Invalid configuration of route '" + fullPath + "': a componentless route cannot have a named outlet set");
    }
    if (route.redirectTo && route.children) {
        throw new Error("Invalid configuration of route '" + fullPath + "': redirectTo and children cannot be used together");
    }
    if (route.redirectTo && route.loadChildren) {
        throw new Error("Invalid configuration of route '" + fullPath + "': redirectTo and loadChildren cannot be used together");
    }
    if (route.children && route.loadChildren) {
        throw new Error("Invalid configuration of route '" + fullPath + "': children and loadChildren cannot be used together");
    }
    if (route.redirectTo && route.component) {
        throw new Error("Invalid configuration of route '" + fullPath + "': redirectTo and component cannot be used together");
    }
    if (route.path && route.matcher) {
        throw new Error("Invalid configuration of route '" + fullPath + "': path and matcher cannot be used together");
    }
    if (route.redirectTo === void 0 && !route.component && !route.children && !route.loadChildren) {
        throw new Error("Invalid configuration of route '" + fullPath + "'. One of the following must be provided: component, redirectTo, children or loadChildren");
    }
    if (route.path === void 0 && route.matcher === void 0) {
        throw new Error("Invalid configuration of route '" + fullPath + "': routes must have either a path or a matcher specified");
    }
    if (typeof route.path === 'string' && route.path.charAt(0) === '/') {
        throw new Error("Invalid configuration of route '" + fullPath + "': path cannot start with a slash");
    }
    if (route.path === '' && route.redirectTo !== void 0 && route.pathMatch === void 0) {
        var /** @type {?} */ exp = "The default value of 'pathMatch' is 'prefix', but often the intent is to use 'full'.";
        throw new Error("Invalid configuration of route '{path: \"" + fullPath + "\", redirectTo: \"" + route.redirectTo + "\"}': please provide 'pathMatch'. " + exp);
    }
    if (route.pathMatch !== void 0 && route.pathMatch !== 'full' && route.pathMatch !== 'prefix') {
        throw new Error("Invalid configuration of route '" + fullPath + "': pathMatch can only be set to 'prefix' or 'full'");
    }
    if (route.children) {
        validateConfig(route.children, fullPath);
    }
}
/**
 * @param {?} parentPath
 * @param {?} currentRoute
 * @return {?}
 */
function getFullPath(parentPath, currentRoute) {
    if (!currentRoute) {
        return parentPath;
    }
    if (!parentPath && !currentRoute.path) {
        return '';
    }
    else if (parentPath && !currentRoute.path) {
        return parentPath + "/";
    }
    else if (!parentPath && currentRoute.path) {
        return currentRoute.path;
    }
    else {
        return parentPath + "/" + currentRoute.path;
    }
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @param {?} a
 * @param {?} b
 * @return {?}
 */
function shallowEqualArrays(a, b) {
    if (a.length !== b.length)
        return false;
    for (var /** @type {?} */ i = 0; i < a.length; ++i) {
        if (!shallowEqual(a[i], b[i]))
            return false;
    }
    return true;
}
/**
 * @param {?} a
 * @param {?} b
 * @return {?}
 */
function shallowEqual(a, b) {
    var /** @type {?} */ k1 = Object.keys(a);
    var /** @type {?} */ k2 = Object.keys(b);
    if (k1.length != k2.length) {
        return false;
    }
    var /** @type {?} */ key;
    for (var /** @type {?} */ i = 0; i < k1.length; i++) {
        key = k1[i];
        if (a[key] !== b[key]) {
            return false;
        }
    }
    return true;
}
/**
 * @template T
 * @param {?} arr
 * @return {?}
 */
function flatten(arr) {
    return Array.prototype.concat.apply([], arr);
}
/**
 * @template T
 * @param {?} a
 * @return {?}
 */
function last$1(a) {
    return a.length > 0 ? a[a.length - 1] : null;
}
/**
 * @param {?} bools
 * @return {?}
 */
/**
 * @template K, V
 * @param {?} map
 * @param {?} callback
 * @return {?}
 */
function forEach(map$$1, callback) {
    for (var /** @type {?} */ prop in map$$1) {
        if (map$$1.hasOwnProperty(prop)) {
            callback(map$$1[prop], prop);
        }
    }
}
/**
 * @template A, B
 * @param {?} obj
 * @param {?} fn
 * @return {?}
 */
function waitForMap(obj, fn) {
    if (Object.keys(obj).length === 0) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_rxjs_observable_of__["of"])({});
    }
    var /** @type {?} */ waitHead = [];
    var /** @type {?} */ waitTail = [];
    var /** @type {?} */ res = {};
    forEach(obj, function (a, k) {
        var /** @type {?} */ mapped = __WEBPACK_IMPORTED_MODULE_9_rxjs_operator_map__["map"].call(fn(k, a), function (r) { return res[k] = r; });
        if (k === PRIMARY_OUTLET) {
            waitHead.push(mapped);
        }
        else {
            waitTail.push(mapped);
        }
    });
    var /** @type {?} */ concat$ = __WEBPACK_IMPORTED_MODULE_14_rxjs_operator_concatAll__["concatAll"].call(__WEBPACK_IMPORTED_MODULE_5_rxjs_observable_of__["of"].apply(void 0, waitHead.concat(waitTail)));
    var /** @type {?} */ last$ = __WEBPACK_IMPORTED_MODULE_17_rxjs_operator_last__["last"].call(concat$);
    return __WEBPACK_IMPORTED_MODULE_9_rxjs_operator_map__["map"].call(last$, function () { return res; });
}
/**
 * @param {?} observables
 * @return {?}
 */
function andObservables(observables) {
    var /** @type {?} */ merged$ = __WEBPACK_IMPORTED_MODULE_18_rxjs_operator_mergeAll__["mergeAll"].call(observables);
    return __WEBPACK_IMPORTED_MODULE_7_rxjs_operator_every__["every"].call(merged$, function (result) { return result === true; });
}
/**
 * @template T
 * @param {?} value
 * @return {?}
 */
function wrapIntoObservable(value) {
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵisObservable"])(value)) {
        return value;
    }
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵisPromise"])(value)) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16_rxjs_observable_fromPromise__["fromPromise"])(value);
    }
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_rxjs_observable_of__["of"])(value);
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @return {?}
 */
function createEmptyUrlTree() {
    return new UrlTree(new UrlSegmentGroup([], {}), {}, null);
}
/**
 * @param {?} container
 * @param {?} containee
 * @param {?} exact
 * @return {?}
 */
function containsTree(container, containee, exact) {
    if (exact) {
        return equalQueryParams(container.queryParams, containee.queryParams) &&
            equalSegmentGroups(container.root, containee.root);
    }
    return containsQueryParams(container.queryParams, containee.queryParams) &&
        containsSegmentGroup(container.root, containee.root);
}
/**
 * @param {?} container
 * @param {?} containee
 * @return {?}
 */
function equalQueryParams(container, containee) {
    return shallowEqual(container, containee);
}
/**
 * @param {?} container
 * @param {?} containee
 * @return {?}
 */
function equalSegmentGroups(container, containee) {
    if (!equalPath(container.segments, containee.segments))
        return false;
    if (container.numberOfChildren !== containee.numberOfChildren)
        return false;
    for (var /** @type {?} */ c in containee.children) {
        if (!container.children[c])
            return false;
        if (!equalSegmentGroups(container.children[c], containee.children[c]))
            return false;
    }
    return true;
}
/**
 * @param {?} container
 * @param {?} containee
 * @return {?}
 */
function containsQueryParams(container, containee) {
    return Object.keys(containee).length <= Object.keys(container).length &&
        Object.keys(containee).every(function (key) { return containee[key] === container[key]; });
}
/**
 * @param {?} container
 * @param {?} containee
 * @return {?}
 */
function containsSegmentGroup(container, containee) {
    return containsSegmentGroupHelper(container, containee, containee.segments);
}
/**
 * @param {?} container
 * @param {?} containee
 * @param {?} containeePaths
 * @return {?}
 */
function containsSegmentGroupHelper(container, containee, containeePaths) {
    if (container.segments.length > containeePaths.length) {
        var /** @type {?} */ current = container.segments.slice(0, containeePaths.length);
        if (!equalPath(current, containeePaths))
            return false;
        if (containee.hasChildren())
            return false;
        return true;
    }
    else if (container.segments.length === containeePaths.length) {
        if (!equalPath(container.segments, containeePaths))
            return false;
        for (var /** @type {?} */ c in containee.children) {
            if (!container.children[c])
                return false;
            if (!containsSegmentGroup(container.children[c], containee.children[c]))
                return false;
        }
        return true;
    }
    else {
        var /** @type {?} */ current = containeePaths.slice(0, container.segments.length);
        var /** @type {?} */ next = containeePaths.slice(container.segments.length);
        if (!equalPath(container.segments, current))
            return false;
        if (!container.children[PRIMARY_OUTLET])
            return false;
        return containsSegmentGroupHelper(container.children[PRIMARY_OUTLET], containee, next);
    }
}
/**
 * \@whatItDoes Represents the parsed URL.
 *
 * \@howToUse
 *
 * ```
 * \@Component({templateUrl:'template.html'})
 * class MyComponent {
 *   constructor(router: Router) {
 *     const tree: UrlTree =
 *       router.parseUrl('/team/33/(user/victor//support:help)?debug=true#fragment');
 *     const f = tree.fragment; // return 'fragment'
 *     const q = tree.queryParams; // returns {debug: 'true'}
 *     const g: UrlSegmentGroup = tree.root.children[PRIMARY_OUTLET];
 *     const s: UrlSegment[] = g.segments; // returns 2 segments 'team' and '33'
 *     g.children[PRIMARY_OUTLET].segments; // returns 2 segments 'user' and 'victor'
 *     g.children['support'].segments; // return 1 segment 'help'
 *   }
 * }
 * ```
 *
 * \@description
 *
 * Since a router state is a tree, and the URL is nothing but a serialized state, the URL is a
 * serialized tree.
 * UrlTree is a data structure that provides a lot of affordances in dealing with URLs
 *
 * \@stable
 */
var UrlTree = (function () {
    /**
     * \@internal
     * @param {?} root
     * @param {?} queryParams
     * @param {?} fragment
     */
    function UrlTree(root, queryParams, fragment) {
        this.root = root;
        this.queryParams = queryParams;
        this.fragment = fragment;
    }
    Object.defineProperty(UrlTree.prototype, "queryParamMap", {
        /**
         * @return {?}
         */
        get: function () {
            if (!this._queryParamMap) {
                this._queryParamMap = convertToParamMap(this.queryParams);
            }
            return this._queryParamMap;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * \@docsNotRequired
     * @return {?}
     */
    UrlTree.prototype.toString = function () { return DEFAULT_SERIALIZER.serialize(this); };
    return UrlTree;
}());
/**
 * \@whatItDoes Represents the parsed URL segment group.
 *
 * See {\@link UrlTree} for more information.
 *
 * \@stable
 */
var UrlSegmentGroup = (function () {
    /**
     * @param {?} segments
     * @param {?} children
     */
    function UrlSegmentGroup(segments, children) {
        var _this = this;
        this.segments = segments;
        this.children = children;
        /** The parent node in the url tree */
        this.parent = null;
        forEach(children, function (v, k) { return v.parent = _this; });
    }
    /**
     * Wether the segment has child segments
     * @return {?}
     */
    UrlSegmentGroup.prototype.hasChildren = function () { return this.numberOfChildren > 0; };
    Object.defineProperty(UrlSegmentGroup.prototype, "numberOfChildren", {
        /**
         * Number of child segments
         * @return {?}
         */
        get: function () { return Object.keys(this.children).length; },
        enumerable: true,
        configurable: true
    });
    /**
     * \@docsNotRequired
     * @return {?}
     */
    UrlSegmentGroup.prototype.toString = function () { return serializePaths(this); };
    return UrlSegmentGroup;
}());
/**
 * \@whatItDoes Represents a single URL segment.
 *
 * \@howToUse
 *
 * ```
 * \@Component({templateUrl:'template.html'})
 * class MyComponent {
 *   constructor(router: Router) {
 *     const tree: UrlTree = router.parseUrl('/team;id=33');
 *     const g: UrlSegmentGroup = tree.root.children[PRIMARY_OUTLET];
 *     const s: UrlSegment[] = g.segments;
 *     s[0].path; // returns 'team'
 *     s[0].parameters; // returns {id: 33}
 *   }
 * }
 * ```
 *
 * \@description
 *
 * A UrlSegment is a part of a URL between the two slashes. It contains a path and the matrix
 * parameters associated with the segment.
 *
 * \@stable
 */
var UrlSegment = (function () {
    /**
     * @param {?} path
     * @param {?} parameters
     */
    function UrlSegment(path, parameters) {
        this.path = path;
        this.parameters = parameters;
    }
    Object.defineProperty(UrlSegment.prototype, "parameterMap", {
        /**
         * @return {?}
         */
        get: function () {
            if (!this._parameterMap) {
                this._parameterMap = convertToParamMap(this.parameters);
            }
            return this._parameterMap;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * \@docsNotRequired
     * @return {?}
     */
    UrlSegment.prototype.toString = function () { return serializePath(this); };
    return UrlSegment;
}());
/**
 * @param {?} as
 * @param {?} bs
 * @return {?}
 */
function equalSegments(as, bs) {
    return equalPath(as, bs) && as.every(function (a, i) { return shallowEqual(a.parameters, bs[i].parameters); });
}
/**
 * @param {?} as
 * @param {?} bs
 * @return {?}
 */
function equalPath(as, bs) {
    if (as.length !== bs.length)
        return false;
    return as.every(function (a, i) { return a.path === bs[i].path; });
}
/**
 * @template T
 * @param {?} segment
 * @param {?} fn
 * @return {?}
 */
function mapChildrenIntoArray(segment, fn) {
    var /** @type {?} */ res = [];
    forEach(segment.children, function (child, childOutlet) {
        if (childOutlet === PRIMARY_OUTLET) {
            res = res.concat(fn(child, childOutlet));
        }
    });
    forEach(segment.children, function (child, childOutlet) {
        if (childOutlet !== PRIMARY_OUTLET) {
            res = res.concat(fn(child, childOutlet));
        }
    });
    return res;
}
/**
 * \@whatItDoes Serializes and deserializes a URL string into a URL tree.
 *
 * \@description The url serialization strategy is customizable. You can
 * make all URLs case insensitive by providing a custom UrlSerializer.
 *
 * See {\@link DefaultUrlSerializer} for an example of a URL serializer.
 *
 * \@stable
 * @abstract
 */
var UrlSerializer = (function () {
    function UrlSerializer() {
    }
    /**
     * Parse a url into a {\@link UrlTree}
     * @abstract
     * @param {?} url
     * @return {?}
     */
    UrlSerializer.prototype.parse = function (url) { };
    /**
     * Converts a {\@link UrlTree} into a url
     * @abstract
     * @param {?} tree
     * @return {?}
     */
    UrlSerializer.prototype.serialize = function (tree) { };
    return UrlSerializer;
}());
/**
 * \@whatItDoes A default implementation of the {\@link UrlSerializer}.
 *
 * \@description
 *
 * Example URLs:
 *
 * ```
 * /inbox/33(popup:compose)
 * /inbox/33;open=true/messages/44
 * ```
 *
 * DefaultUrlSerializer uses parentheses to serialize secondary segments (e.g., popup:compose), the
 * colon syntax to specify the outlet, and the ';parameter=value' syntax (e.g., open=true) to
 * specify route specific parameters.
 *
 * \@stable
 */
var DefaultUrlSerializer = (function () {
    function DefaultUrlSerializer() {
    }
    /**
     * Parses a url into a {\@link UrlTree}
     * @param {?} url
     * @return {?}
     */
    DefaultUrlSerializer.prototype.parse = function (url) {
        var /** @type {?} */ p = new UrlParser(url);
        return new UrlTree(p.parseRootSegment(), p.parseQueryParams(), p.parseFragment());
    };
    /**
     * Converts a {\@link UrlTree} into a url
     * @param {?} tree
     * @return {?}
     */
    DefaultUrlSerializer.prototype.serialize = function (tree) {
        var /** @type {?} */ segment = "/" + serializeSegment(tree.root, true);
        var /** @type {?} */ query = serializeQueryParams(tree.queryParams);
        var /** @type {?} */ fragment = typeof tree.fragment === "string" ? "#" + encodeURI(/** @type {?} */ ((tree.fragment))) : '';
        return "" + segment + query + fragment;
    };
    return DefaultUrlSerializer;
}());
var DEFAULT_SERIALIZER = new DefaultUrlSerializer();
/**
 * @param {?} segment
 * @return {?}
 */
function serializePaths(segment) {
    return segment.segments.map(function (p) { return serializePath(p); }).join('/');
}
/**
 * @param {?} segment
 * @param {?} root
 * @return {?}
 */
function serializeSegment(segment, root) {
    if (!segment.hasChildren()) {
        return serializePaths(segment);
    }
    if (root) {
        var /** @type {?} */ primary = segment.children[PRIMARY_OUTLET] ?
            serializeSegment(segment.children[PRIMARY_OUTLET], false) :
            '';
        var /** @type {?} */ children_1 = [];
        forEach(segment.children, function (v, k) {
            if (k !== PRIMARY_OUTLET) {
                children_1.push(k + ":" + serializeSegment(v, false));
            }
        });
        return children_1.length > 0 ? primary + "(" + children_1.join('//') + ")" : primary;
    }
    else {
        var /** @type {?} */ children = mapChildrenIntoArray(segment, function (v, k) {
            if (k === PRIMARY_OUTLET) {
                return [serializeSegment(segment.children[PRIMARY_OUTLET], false)];
            }
            return [k + ":" + serializeSegment(v, false)];
        });
        return serializePaths(segment) + "/(" + children.join('//') + ")";
    }
}
/**
 * @param {?} s
 * @return {?}
 */
function encode(s) {
    return encodeURIComponent(s);
}
/**
 * @param {?} s
 * @return {?}
 */
function decode(s) {
    return decodeURIComponent(s);
}
/**
 * @param {?} path
 * @return {?}
 */
function serializePath(path) {
    return "" + encode(path.path) + serializeParams(path.parameters);
}
/**
 * @param {?} params
 * @return {?}
 */
function serializeParams(params) {
    return Object.keys(params).map(function (key) { return ";" + encode(key) + "=" + encode(params[key]); }).join('');
}
/**
 * @param {?} params
 * @return {?}
 */
function serializeQueryParams(params) {
    var /** @type {?} */ strParams = Object.keys(params).map(function (name) {
        var /** @type {?} */ value = params[name];
        return Array.isArray(value) ? value.map(function (v) { return encode(name) + "=" + encode(v); }).join('&') :
            encode(name) + "=" + encode(value);
    });
    return strParams.length ? "?" + strParams.join("&") : '';
}
var SEGMENT_RE = /^[^\/()?;=&#]+/;
/**
 * @param {?} str
 * @return {?}
 */
function matchSegments(str) {
    var /** @type {?} */ match = str.match(SEGMENT_RE);
    return match ? match[0] : '';
}
var QUERY_PARAM_RE = /^[^=?&#]+/;
/**
 * @param {?} str
 * @return {?}
 */
function matchQueryParams(str) {
    var /** @type {?} */ match = str.match(QUERY_PARAM_RE);
    return match ? match[0] : '';
}
var QUERY_PARAM_VALUE_RE = /^[^?&#]+/;
/**
 * @param {?} str
 * @return {?}
 */
function matchUrlQueryParamValue(str) {
    var /** @type {?} */ match = str.match(QUERY_PARAM_VALUE_RE);
    return match ? match[0] : '';
}
var UrlParser = (function () {
    /**
     * @param {?} url
     */
    function UrlParser(url) {
        this.url = url;
        this.remaining = url;
    }
    /**
     * @return {?}
     */
    UrlParser.prototype.parseRootSegment = function () {
        this.consumeOptional('/');
        if (this.remaining === '' || this.peekStartsWith('?') || this.peekStartsWith('#')) {
            return new UrlSegmentGroup([], {});
        }
        // The root segment group never has segments
        return new UrlSegmentGroup([], this.parseChildren());
    };
    /**
     * @return {?}
     */
    UrlParser.prototype.parseQueryParams = function () {
        var /** @type {?} */ params = {};
        if (this.consumeOptional('?')) {
            do {
                this.parseQueryParam(params);
            } while (this.consumeOptional('&'));
        }
        return params;
    };
    /**
     * @return {?}
     */
    UrlParser.prototype.parseFragment = function () {
        return this.consumeOptional('#') ? decodeURI(this.remaining) : null;
    };
    /**
     * @return {?}
     */
    UrlParser.prototype.parseChildren = function () {
        if (this.remaining === '') {
            return {};
        }
        this.consumeOptional('/');
        var /** @type {?} */ segments = [];
        if (!this.peekStartsWith('(')) {
            segments.push(this.parseSegment());
        }
        while (this.peekStartsWith('/') && !this.peekStartsWith('//') && !this.peekStartsWith('/(')) {
            this.capture('/');
            segments.push(this.parseSegment());
        }
        var /** @type {?} */ children = {};
        if (this.peekStartsWith('/(')) {
            this.capture('/');
            children = this.parseParens(true);
        }
        var /** @type {?} */ res = {};
        if (this.peekStartsWith('(')) {
            res = this.parseParens(false);
        }
        if (segments.length > 0 || Object.keys(children).length > 0) {
            res[PRIMARY_OUTLET] = new UrlSegmentGroup(segments, children);
        }
        return res;
    };
    /**
     * @return {?}
     */
    UrlParser.prototype.parseSegment = function () {
        var /** @type {?} */ path = matchSegments(this.remaining);
        if (path === '' && this.peekStartsWith(';')) {
            throw new Error("Empty path url segment cannot have parameters: '" + this.remaining + "'.");
        }
        this.capture(path);
        return new UrlSegment(decode(path), this.parseMatrixParams());
    };
    /**
     * @return {?}
     */
    UrlParser.prototype.parseMatrixParams = function () {
        var /** @type {?} */ params = {};
        while (this.consumeOptional(';')) {
            this.parseParam(params);
        }
        return params;
    };
    /**
     * @param {?} params
     * @return {?}
     */
    UrlParser.prototype.parseParam = function (params) {
        var /** @type {?} */ key = matchSegments(this.remaining);
        if (!key) {
            return;
        }
        this.capture(key);
        var /** @type {?} */ value = '';
        if (this.consumeOptional('=')) {
            var /** @type {?} */ valueMatch = matchSegments(this.remaining);
            if (valueMatch) {
                value = valueMatch;
                this.capture(value);
            }
        }
        params[decode(key)] = decode(value);
    };
    /**
     * @param {?} params
     * @return {?}
     */
    UrlParser.prototype.parseQueryParam = function (params) {
        var /** @type {?} */ key = matchQueryParams(this.remaining);
        if (!key) {
            return;
        }
        this.capture(key);
        var /** @type {?} */ value = '';
        if (this.consumeOptional('=')) {
            var /** @type {?} */ valueMatch = matchUrlQueryParamValue(this.remaining);
            if (valueMatch) {
                value = valueMatch;
                this.capture(value);
            }
        }
        var /** @type {?} */ decodedKey = decode(key);
        var /** @type {?} */ decodedVal = decode(value);
        if (params.hasOwnProperty(decodedKey)) {
            // Append to existing values
            var /** @type {?} */ currentVal = params[decodedKey];
            if (!Array.isArray(currentVal)) {
                currentVal = [currentVal];
                params[decodedKey] = currentVal;
            }
            currentVal.push(decodedVal);
        }
        else {
            // Create a new value
            params[decodedKey] = decodedVal;
        }
    };
    /**
     * @param {?} allowPrimary
     * @return {?}
     */
    UrlParser.prototype.parseParens = function (allowPrimary) {
        var /** @type {?} */ segments = {};
        this.capture('(');
        while (!this.consumeOptional(')') && this.remaining.length > 0) {
            var /** @type {?} */ path = matchSegments(this.remaining);
            var /** @type {?} */ next = this.remaining[path.length];
            // if is is not one of these characters, then the segment was unescaped
            // or the group was not closed
            if (next !== '/' && next !== ')' && next !== ';') {
                throw new Error("Cannot parse url '" + this.url + "'");
            }
            var /** @type {?} */ outletName = ((undefined));
            if (path.indexOf(':') > -1) {
                outletName = path.substr(0, path.indexOf(':'));
                this.capture(outletName);
                this.capture(':');
            }
            else if (allowPrimary) {
                outletName = PRIMARY_OUTLET;
            }
            var /** @type {?} */ children = this.parseChildren();
            segments[outletName] = Object.keys(children).length === 1 ? children[PRIMARY_OUTLET] :
                new UrlSegmentGroup([], children);
            this.consumeOptional('//');
        }
        return segments;
    };
    /**
     * @param {?} str
     * @return {?}
     */
    UrlParser.prototype.peekStartsWith = function (str) { return this.remaining.startsWith(str); };
    /**
     * @param {?} str
     * @return {?}
     */
    UrlParser.prototype.consumeOptional = function (str) {
        if (this.peekStartsWith(str)) {
            this.remaining = this.remaining.substring(str.length);
            return true;
        }
        return false;
    };
    /**
     * @param {?} str
     * @return {?}
     */
    UrlParser.prototype.capture = function (str) {
        if (!this.consumeOptional(str)) {
            throw new Error("Expected \"" + str + "\".");
        }
    };
    return UrlParser;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var __assign$1 = (undefined && undefined.__assign) || Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s)
            if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
    }
    return t;
};
var NoMatch = (function () {
    /**
     * @param {?=} segmentGroup
     */
    function NoMatch(segmentGroup) {
        this.segmentGroup = segmentGroup || null;
    }
    return NoMatch;
}());
var AbsoluteRedirect = (function () {
    /**
     * @param {?} urlTree
     */
    function AbsoluteRedirect(urlTree) {
        this.urlTree = urlTree;
    }
    return AbsoluteRedirect;
}());
/**
 * @param {?} segmentGroup
 * @return {?}
 */
function noMatch(segmentGroup) {
    return new __WEBPACK_IMPORTED_MODULE_12_rxjs_Observable__["Observable"](function (obs) { return obs.error(new NoMatch(segmentGroup)); });
}
/**
 * @param {?} newTree
 * @return {?}
 */
function absoluteRedirect(newTree) {
    return new __WEBPACK_IMPORTED_MODULE_12_rxjs_Observable__["Observable"](function (obs) { return obs.error(new AbsoluteRedirect(newTree)); });
}
/**
 * @param {?} redirectTo
 * @return {?}
 */
function namedOutletsRedirect(redirectTo) {
    return new __WEBPACK_IMPORTED_MODULE_12_rxjs_Observable__["Observable"](function (obs) { return obs.error(new Error("Only absolute redirects can have named outlets. redirectTo: '" + redirectTo + "'")); });
}
/**
 * @param {?} route
 * @return {?}
 */
function canLoadFails(route) {
    return new __WEBPACK_IMPORTED_MODULE_12_rxjs_Observable__["Observable"](function (obs) { return obs.error(navigationCancelingError("Cannot load children because the guard of the route \"path: '" + route.path + "'\" returned false")); });
}
/**
 * Returns the `UrlTree` with the redirection applied.
 *
 * Lazy modules are loaded along the way.
 * @param {?} moduleInjector
 * @param {?} configLoader
 * @param {?} urlSerializer
 * @param {?} urlTree
 * @param {?} config
 * @return {?}
 */
function applyRedirects(moduleInjector, configLoader, urlSerializer, urlTree, config) {
    return new ApplyRedirects(moduleInjector, configLoader, urlSerializer, urlTree, config).apply();
}
var ApplyRedirects = (function () {
    /**
     * @param {?} moduleInjector
     * @param {?} configLoader
     * @param {?} urlSerializer
     * @param {?} urlTree
     * @param {?} config
     */
    function ApplyRedirects(moduleInjector, configLoader, urlSerializer, urlTree, config) {
        this.configLoader = configLoader;
        this.urlSerializer = urlSerializer;
        this.urlTree = urlTree;
        this.config = config;
        this.allowRedirects = true;
        this.ngModule = moduleInjector.get(__WEBPACK_IMPORTED_MODULE_1__angular_core__["NgModuleRef"]);
    }
    /**
     * @return {?}
     */
    ApplyRedirects.prototype.apply = function () {
        var _this = this;
        var /** @type {?} */ expanded$ = this.expandSegmentGroup(this.ngModule, this.config, this.urlTree.root, PRIMARY_OUTLET);
        var /** @type {?} */ urlTrees$ = __WEBPACK_IMPORTED_MODULE_9_rxjs_operator_map__["map"].call(expanded$, function (rootSegmentGroup) { return _this.createUrlTree(rootSegmentGroup, _this.urlTree.queryParams, /** @type {?} */ ((_this.urlTree.fragment))); });
        return __WEBPACK_IMPORTED_MODULE_13_rxjs_operator_catch__["_catch"].call(urlTrees$, function (e) {
            if (e instanceof AbsoluteRedirect) {
                // after an absolute redirect we do not apply any more redirects!
                _this.allowRedirects = false;
                // we need to run matching, so we can fetch all lazy-loaded modules
                return _this.match(e.urlTree);
            }
            if (e instanceof NoMatch) {
                throw _this.noMatchError(e);
            }
            throw e;
        });
    };
    /**
     * @param {?} tree
     * @return {?}
     */
    ApplyRedirects.prototype.match = function (tree) {
        var _this = this;
        var /** @type {?} */ expanded$ = this.expandSegmentGroup(this.ngModule, this.config, tree.root, PRIMARY_OUTLET);
        var /** @type {?} */ mapped$ = __WEBPACK_IMPORTED_MODULE_9_rxjs_operator_map__["map"].call(expanded$, function (rootSegmentGroup) { return _this.createUrlTree(rootSegmentGroup, tree.queryParams, /** @type {?} */ ((tree.fragment))); });
        return __WEBPACK_IMPORTED_MODULE_13_rxjs_operator_catch__["_catch"].call(mapped$, function (e) {
            if (e instanceof NoMatch) {
                throw _this.noMatchError(e);
            }
            throw e;
        });
    };
    /**
     * @param {?} e
     * @return {?}
     */
    ApplyRedirects.prototype.noMatchError = function (e) {
        return new Error("Cannot match any routes. URL Segment: '" + e.segmentGroup + "'");
    };
    /**
     * @param {?} rootCandidate
     * @param {?} queryParams
     * @param {?} fragment
     * @return {?}
     */
    ApplyRedirects.prototype.createUrlTree = function (rootCandidate, queryParams, fragment) {
        var /** @type {?} */ root = rootCandidate.segments.length > 0 ?
            new UrlSegmentGroup([], (_a = {}, _a[PRIMARY_OUTLET] = rootCandidate, _a)) :
            rootCandidate;
        return new UrlTree(root, queryParams, fragment);
        var _a;
    };
    /**
     * @param {?} ngModule
     * @param {?} routes
     * @param {?} segmentGroup
     * @param {?} outlet
     * @return {?}
     */
    ApplyRedirects.prototype.expandSegmentGroup = function (ngModule, routes, segmentGroup, outlet) {
        if (segmentGroup.segments.length === 0 && segmentGroup.hasChildren()) {
            return __WEBPACK_IMPORTED_MODULE_9_rxjs_operator_map__["map"].call(this.expandChildren(ngModule, routes, segmentGroup), function (children) { return new UrlSegmentGroup([], children); });
        }
        return this.expandSegment(ngModule, segmentGroup, routes, segmentGroup.segments, outlet, true);
    };
    /**
     * @param {?} ngModule
     * @param {?} routes
     * @param {?} segmentGroup
     * @return {?}
     */
    ApplyRedirects.prototype.expandChildren = function (ngModule, routes, segmentGroup) {
        var _this = this;
        return waitForMap(segmentGroup.children, function (childOutlet, child) { return _this.expandSegmentGroup(ngModule, routes, child, childOutlet); });
    };
    /**
     * @param {?} ngModule
     * @param {?} segmentGroup
     * @param {?} routes
     * @param {?} segments
     * @param {?} outlet
     * @param {?} allowRedirects
     * @return {?}
     */
    ApplyRedirects.prototype.expandSegment = function (ngModule, segmentGroup, routes, segments, outlet, allowRedirects) {
        var _this = this;
        var /** @type {?} */ routes$ = __WEBPACK_IMPORTED_MODULE_5_rxjs_observable_of__["of"].apply(void 0, routes);
        var /** @type {?} */ processedRoutes$ = __WEBPACK_IMPORTED_MODULE_9_rxjs_operator_map__["map"].call(routes$, function (r) {
            var /** @type {?} */ expanded$ = _this.expandSegmentAgainstRoute(ngModule, segmentGroup, routes, r, segments, outlet, allowRedirects);
            return __WEBPACK_IMPORTED_MODULE_13_rxjs_operator_catch__["_catch"].call(expanded$, function (e) {
                if (e instanceof NoMatch) {
                    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_rxjs_observable_of__["of"])(null);
                }
                throw e;
            });
        });
        var /** @type {?} */ concattedProcessedRoutes$ = __WEBPACK_IMPORTED_MODULE_14_rxjs_operator_concatAll__["concatAll"].call(processedRoutes$);
        var /** @type {?} */ first$ = __WEBPACK_IMPORTED_MODULE_8_rxjs_operator_first__["first"].call(concattedProcessedRoutes$, function (s) { return !!s; });
        return __WEBPACK_IMPORTED_MODULE_13_rxjs_operator_catch__["_catch"].call(first$, function (e, _) {
            if (e instanceof __WEBPACK_IMPORTED_MODULE_15_rxjs_util_EmptyError__["EmptyError"]) {
                if (_this.noLeftoversInUrl(segmentGroup, segments, outlet)) {
                    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_rxjs_observable_of__["of"])(new UrlSegmentGroup([], {}));
                }
                throw new NoMatch(segmentGroup);
            }
            throw e;
        });
    };
    /**
     * @param {?} segmentGroup
     * @param {?} segments
     * @param {?} outlet
     * @return {?}
     */
    ApplyRedirects.prototype.noLeftoversInUrl = function (segmentGroup, segments, outlet) {
        return segments.length === 0 && !segmentGroup.children[outlet];
    };
    /**
     * @param {?} ngModule
     * @param {?} segmentGroup
     * @param {?} routes
     * @param {?} route
     * @param {?} paths
     * @param {?} outlet
     * @param {?} allowRedirects
     * @return {?}
     */
    ApplyRedirects.prototype.expandSegmentAgainstRoute = function (ngModule, segmentGroup, routes, route, paths, outlet, allowRedirects) {
        if (getOutlet$1(route) !== outlet) {
            return noMatch(segmentGroup);
        }
        if (route.redirectTo === undefined) {
            return this.matchSegmentAgainstRoute(ngModule, segmentGroup, route, paths);
        }
        if (allowRedirects && this.allowRedirects) {
            return this.expandSegmentAgainstRouteUsingRedirect(ngModule, segmentGroup, routes, route, paths, outlet);
        }
        return noMatch(segmentGroup);
    };
    /**
     * @param {?} ngModule
     * @param {?} segmentGroup
     * @param {?} routes
     * @param {?} route
     * @param {?} segments
     * @param {?} outlet
     * @return {?}
     */
    ApplyRedirects.prototype.expandSegmentAgainstRouteUsingRedirect = function (ngModule, segmentGroup, routes, route, segments, outlet) {
        if (route.path === '**') {
            return this.expandWildCardWithParamsAgainstRouteUsingRedirect(ngModule, routes, route, outlet);
        }
        return this.expandRegularSegmentAgainstRouteUsingRedirect(ngModule, segmentGroup, routes, route, segments, outlet);
    };
    /**
     * @param {?} ngModule
     * @param {?} routes
     * @param {?} route
     * @param {?} outlet
     * @return {?}
     */
    ApplyRedirects.prototype.expandWildCardWithParamsAgainstRouteUsingRedirect = function (ngModule, routes, route, outlet) {
        var _this = this;
        var /** @type {?} */ newTree = this.applyRedirectCommands([], /** @type {?} */ ((route.redirectTo)), {});
        if (((route.redirectTo)).startsWith('/')) {
            return absoluteRedirect(newTree);
        }
        return __WEBPACK_IMPORTED_MODULE_10_rxjs_operator_mergeMap__["mergeMap"].call(this.lineralizeSegments(route, newTree), function (newSegments) {
            var /** @type {?} */ group = new UrlSegmentGroup(newSegments, {});
            return _this.expandSegment(ngModule, group, routes, newSegments, outlet, false);
        });
    };
    /**
     * @param {?} ngModule
     * @param {?} segmentGroup
     * @param {?} routes
     * @param {?} route
     * @param {?} segments
     * @param {?} outlet
     * @return {?}
     */
    ApplyRedirects.prototype.expandRegularSegmentAgainstRouteUsingRedirect = function (ngModule, segmentGroup, routes, route, segments, outlet) {
        var _this = this;
        var _a = match(segmentGroup, route, segments), matched = _a.matched, consumedSegments = _a.consumedSegments, lastChild = _a.lastChild, positionalParamSegments = _a.positionalParamSegments;
        if (!matched)
            return noMatch(segmentGroup);
        var /** @type {?} */ newTree = this.applyRedirectCommands(consumedSegments, /** @type {?} */ ((route.redirectTo)), /** @type {?} */ (positionalParamSegments));
        if (((route.redirectTo)).startsWith('/')) {
            return absoluteRedirect(newTree);
        }
        return __WEBPACK_IMPORTED_MODULE_10_rxjs_operator_mergeMap__["mergeMap"].call(this.lineralizeSegments(route, newTree), function (newSegments) {
            return _this.expandSegment(ngModule, segmentGroup, routes, newSegments.concat(segments.slice(lastChild)), outlet, false);
        });
    };
    /**
     * @param {?} ngModule
     * @param {?} rawSegmentGroup
     * @param {?} route
     * @param {?} segments
     * @return {?}
     */
    ApplyRedirects.prototype.matchSegmentAgainstRoute = function (ngModule, rawSegmentGroup, route, segments) {
        var _this = this;
        if (route.path === '**') {
            if (route.loadChildren) {
                return __WEBPACK_IMPORTED_MODULE_9_rxjs_operator_map__["map"].call(this.configLoader.load(ngModule.injector, route), function (cfg) {
                    route._loadedConfig = cfg;
                    return new UrlSegmentGroup(segments, {});
                });
            }
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_rxjs_observable_of__["of"])(new UrlSegmentGroup(segments, {}));
        }
        var _a = match(rawSegmentGroup, route, segments), matched = _a.matched, consumedSegments = _a.consumedSegments, lastChild = _a.lastChild;
        if (!matched)
            return noMatch(rawSegmentGroup);
        var /** @type {?} */ rawSlicedSegments = segments.slice(lastChild);
        var /** @type {?} */ childConfig$ = this.getChildConfig(ngModule, route);
        return __WEBPACK_IMPORTED_MODULE_10_rxjs_operator_mergeMap__["mergeMap"].call(childConfig$, function (routerConfig) {
            var /** @type {?} */ childModule = routerConfig.module;
            var /** @type {?} */ childConfig = routerConfig.routes;
            var _a = split(rawSegmentGroup, consumedSegments, rawSlicedSegments, childConfig), segmentGroup = _a.segmentGroup, slicedSegments = _a.slicedSegments;
            if (slicedSegments.length === 0 && segmentGroup.hasChildren()) {
                var /** @type {?} */ expanded$_1 = _this.expandChildren(childModule, childConfig, segmentGroup);
                return __WEBPACK_IMPORTED_MODULE_9_rxjs_operator_map__["map"].call(expanded$_1, function (children) { return new UrlSegmentGroup(consumedSegments, children); });
            }
            if (childConfig.length === 0 && slicedSegments.length === 0) {
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_rxjs_observable_of__["of"])(new UrlSegmentGroup(consumedSegments, {}));
            }
            var /** @type {?} */ expanded$ = _this.expandSegment(childModule, segmentGroup, childConfig, slicedSegments, PRIMARY_OUTLET, true);
            return __WEBPACK_IMPORTED_MODULE_9_rxjs_operator_map__["map"].call(expanded$, function (cs) { return new UrlSegmentGroup(consumedSegments.concat(cs.segments), cs.children); });
        });
    };
    /**
     * @param {?} ngModule
     * @param {?} route
     * @return {?}
     */
    ApplyRedirects.prototype.getChildConfig = function (ngModule, route) {
        var _this = this;
        if (route.children) {
            // The children belong to the same module
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_rxjs_observable_of__["of"])(new LoadedRouterConfig(route.children, ngModule));
        }
        if (route.loadChildren) {
            // lazy children belong to the loaded module
            if (route._loadedConfig !== undefined) {
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_rxjs_observable_of__["of"])(route._loadedConfig);
            }
            return __WEBPACK_IMPORTED_MODULE_10_rxjs_operator_mergeMap__["mergeMap"].call(runCanLoadGuard(ngModule.injector, route), function (shouldLoad) {
                if (shouldLoad) {
                    return __WEBPACK_IMPORTED_MODULE_9_rxjs_operator_map__["map"].call(_this.configLoader.load(ngModule.injector, route), function (cfg) {
                        route._loadedConfig = cfg;
                        return cfg;
                    });
                }
                return canLoadFails(route);
            });
        }
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_rxjs_observable_of__["of"])(new LoadedRouterConfig([], ngModule));
    };
    /**
     * @param {?} route
     * @param {?} urlTree
     * @return {?}
     */
    ApplyRedirects.prototype.lineralizeSegments = function (route, urlTree) {
        var /** @type {?} */ res = [];
        var /** @type {?} */ c = urlTree.root;
        while (true) {
            res = res.concat(c.segments);
            if (c.numberOfChildren === 0) {
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_rxjs_observable_of__["of"])(res);
            }
            if (c.numberOfChildren > 1 || !c.children[PRIMARY_OUTLET]) {
                return namedOutletsRedirect(/** @type {?} */ ((route.redirectTo)));
            }
            c = c.children[PRIMARY_OUTLET];
        }
    };
    /**
     * @param {?} segments
     * @param {?} redirectTo
     * @param {?} posParams
     * @return {?}
     */
    ApplyRedirects.prototype.applyRedirectCommands = function (segments, redirectTo, posParams) {
        return this.applyRedirectCreatreUrlTree(redirectTo, this.urlSerializer.parse(redirectTo), segments, posParams);
    };
    /**
     * @param {?} redirectTo
     * @param {?} urlTree
     * @param {?} segments
     * @param {?} posParams
     * @return {?}
     */
    ApplyRedirects.prototype.applyRedirectCreatreUrlTree = function (redirectTo, urlTree, segments, posParams) {
        var /** @type {?} */ newRoot = this.createSegmentGroup(redirectTo, urlTree.root, segments, posParams);
        return new UrlTree(newRoot, this.createQueryParams(urlTree.queryParams, this.urlTree.queryParams), urlTree.fragment);
    };
    /**
     * @param {?} redirectToParams
     * @param {?} actualParams
     * @return {?}
     */
    ApplyRedirects.prototype.createQueryParams = function (redirectToParams, actualParams) {
        var /** @type {?} */ res = {};
        forEach(redirectToParams, function (v, k) {
            res[k] = v.startsWith(':') ? actualParams[v.substring(1)] : v;
        });
        return res;
    };
    /**
     * @param {?} redirectTo
     * @param {?} group
     * @param {?} segments
     * @param {?} posParams
     * @return {?}
     */
    ApplyRedirects.prototype.createSegmentGroup = function (redirectTo, group, segments, posParams) {
        var _this = this;
        var /** @type {?} */ updatedSegments = this.createSegments(redirectTo, group.segments, segments, posParams);
        var /** @type {?} */ children = {};
        forEach(group.children, function (child, name) {
            children[name] = _this.createSegmentGroup(redirectTo, child, segments, posParams);
        });
        return new UrlSegmentGroup(updatedSegments, children);
    };
    /**
     * @param {?} redirectTo
     * @param {?} redirectToSegments
     * @param {?} actualSegments
     * @param {?} posParams
     * @return {?}
     */
    ApplyRedirects.prototype.createSegments = function (redirectTo, redirectToSegments, actualSegments, posParams) {
        var _this = this;
        return redirectToSegments.map(function (s) { return s.path.startsWith(':') ? _this.findPosParam(redirectTo, s, posParams) :
            _this.findOrReturn(s, actualSegments); });
    };
    /**
     * @param {?} redirectTo
     * @param {?} redirectToUrlSegment
     * @param {?} posParams
     * @return {?}
     */
    ApplyRedirects.prototype.findPosParam = function (redirectTo, redirectToUrlSegment, posParams) {
        var /** @type {?} */ pos = posParams[redirectToUrlSegment.path.substring(1)];
        if (!pos)
            throw new Error("Cannot redirect to '" + redirectTo + "'. Cannot find '" + redirectToUrlSegment.path + "'.");
        return pos;
    };
    /**
     * @param {?} redirectToUrlSegment
     * @param {?} actualSegments
     * @return {?}
     */
    ApplyRedirects.prototype.findOrReturn = function (redirectToUrlSegment, actualSegments) {
        var /** @type {?} */ idx = 0;
        for (var _i = 0, actualSegments_1 = actualSegments; _i < actualSegments_1.length; _i++) {
            var s = actualSegments_1[_i];
            if (s.path === redirectToUrlSegment.path) {
                actualSegments.splice(idx);
                return s;
            }
            idx++;
        }
        return redirectToUrlSegment;
    };
    return ApplyRedirects;
}());
/**
 * @param {?} moduleInjector
 * @param {?} route
 * @return {?}
 */
function runCanLoadGuard(moduleInjector, route) {
    var /** @type {?} */ canLoad = route.canLoad;
    if (!canLoad || canLoad.length === 0)
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_rxjs_observable_of__["of"])(true);
    var /** @type {?} */ obs = __WEBPACK_IMPORTED_MODULE_9_rxjs_operator_map__["map"].call(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_rxjs_observable_from__["from"])(canLoad), function (injectionToken) {
        var /** @type {?} */ guard = moduleInjector.get(injectionToken);
        return wrapIntoObservable(guard.canLoad ? guard.canLoad(route) : guard(route));
    });
    return andObservables(obs);
}
/**
 * @param {?} segmentGroup
 * @param {?} route
 * @param {?} segments
 * @return {?}
 */
function match(segmentGroup, route, segments) {
    if (route.path === '') {
        if ((route.pathMatch === 'full') && (segmentGroup.hasChildren() || segments.length > 0)) {
            return { matched: false, consumedSegments: [], lastChild: 0, positionalParamSegments: {} };
        }
        return { matched: true, consumedSegments: [], lastChild: 0, positionalParamSegments: {} };
    }
    var /** @type {?} */ matcher = route.matcher || defaultUrlMatcher;
    var /** @type {?} */ res = matcher(segments, segmentGroup, route);
    if (!res) {
        return {
            matched: false, consumedSegments: /** @type {?} */ ([]), lastChild: 0, positionalParamSegments: {},
        };
    }
    return {
        matched: true,
        consumedSegments: /** @type {?} */ ((res.consumed)),
        lastChild: /** @type {?} */ ((res.consumed.length)),
        positionalParamSegments: /** @type {?} */ ((res.posParams)),
    };
}
/**
 * @param {?} segmentGroup
 * @param {?} consumedSegments
 * @param {?} slicedSegments
 * @param {?} config
 * @return {?}
 */
function split(segmentGroup, consumedSegments, slicedSegments, config) {
    if (slicedSegments.length > 0 &&
        containsEmptyPathRedirectsWithNamedOutlets(segmentGroup, slicedSegments, config)) {
        var /** @type {?} */ s = new UrlSegmentGroup(consumedSegments, createChildrenForEmptySegments(config, new UrlSegmentGroup(slicedSegments, segmentGroup.children)));
        return { segmentGroup: mergeTrivialChildren(s), slicedSegments: [] };
    }
    if (slicedSegments.length === 0 &&
        containsEmptyPathRedirects(segmentGroup, slicedSegments, config)) {
        var /** @type {?} */ s = new UrlSegmentGroup(segmentGroup.segments, addEmptySegmentsToChildrenIfNeeded(segmentGroup, slicedSegments, config, segmentGroup.children));
        return { segmentGroup: mergeTrivialChildren(s), slicedSegments: slicedSegments };
    }
    return { segmentGroup: segmentGroup, slicedSegments: slicedSegments };
}
/**
 * @param {?} s
 * @return {?}
 */
function mergeTrivialChildren(s) {
    if (s.numberOfChildren === 1 && s.children[PRIMARY_OUTLET]) {
        var /** @type {?} */ c = s.children[PRIMARY_OUTLET];
        return new UrlSegmentGroup(s.segments.concat(c.segments), c.children);
    }
    return s;
}
/**
 * @param {?} segmentGroup
 * @param {?} slicedSegments
 * @param {?} routes
 * @param {?} children
 * @return {?}
 */
function addEmptySegmentsToChildrenIfNeeded(segmentGroup, slicedSegments, routes, children) {
    var /** @type {?} */ res = {};
    for (var _i = 0, routes_1 = routes; _i < routes_1.length; _i++) {
        var r = routes_1[_i];
        if (isEmptyPathRedirect(segmentGroup, slicedSegments, r) && !children[getOutlet$1(r)]) {
            res[getOutlet$1(r)] = new UrlSegmentGroup([], {});
        }
    }
    return __assign$1({}, children, res);
}
/**
 * @param {?} routes
 * @param {?} primarySegmentGroup
 * @return {?}
 */
function createChildrenForEmptySegments(routes, primarySegmentGroup) {
    var /** @type {?} */ res = {};
    res[PRIMARY_OUTLET] = primarySegmentGroup;
    for (var _i = 0, routes_2 = routes; _i < routes_2.length; _i++) {
        var r = routes_2[_i];
        if (r.path === '' && getOutlet$1(r) !== PRIMARY_OUTLET) {
            res[getOutlet$1(r)] = new UrlSegmentGroup([], {});
        }
    }
    return res;
}
/**
 * @param {?} segmentGroup
 * @param {?} segments
 * @param {?} routes
 * @return {?}
 */
function containsEmptyPathRedirectsWithNamedOutlets(segmentGroup, segments, routes) {
    return routes.some(function (r) { return isEmptyPathRedirect(segmentGroup, segments, r) && getOutlet$1(r) !== PRIMARY_OUTLET; });
}
/**
 * @param {?} segmentGroup
 * @param {?} segments
 * @param {?} routes
 * @return {?}
 */
function containsEmptyPathRedirects(segmentGroup, segments, routes) {
    return routes.some(function (r) { return isEmptyPathRedirect(segmentGroup, segments, r); });
}
/**
 * @param {?} segmentGroup
 * @param {?} segments
 * @param {?} r
 * @return {?}
 */
function isEmptyPathRedirect(segmentGroup, segments, r) {
    if ((segmentGroup.hasChildren() || segments.length > 0) && r.pathMatch === 'full') {
        return false;
    }
    return r.path === '' && r.redirectTo !== undefined;
}
/**
 * @param {?} route
 * @return {?}
 */
function getOutlet$1(route) {
    return route.outlet || PRIMARY_OUTLET;
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var Tree = (function () {
    /**
     * @param {?} root
     */
    function Tree(root) {
        this._root = root;
    }
    Object.defineProperty(Tree.prototype, "root", {
        /**
         * @return {?}
         */
        get: function () { return this._root.value; },
        enumerable: true,
        configurable: true
    });
    /**
     * \@internal
     * @param {?} t
     * @return {?}
     */
    Tree.prototype.parent = function (t) {
        var /** @type {?} */ p = this.pathFromRoot(t);
        return p.length > 1 ? p[p.length - 2] : null;
    };
    /**
     * \@internal
     * @param {?} t
     * @return {?}
     */
    Tree.prototype.children = function (t) {
        var /** @type {?} */ n = findNode(t, this._root);
        return n ? n.children.map(function (t) { return t.value; }) : [];
    };
    /**
     * \@internal
     * @param {?} t
     * @return {?}
     */
    Tree.prototype.firstChild = function (t) {
        var /** @type {?} */ n = findNode(t, this._root);
        return n && n.children.length > 0 ? n.children[0].value : null;
    };
    /**
     * \@internal
     * @param {?} t
     * @return {?}
     */
    Tree.prototype.siblings = function (t) {
        var /** @type {?} */ p = findPath(t, this._root, []);
        if (p.length < 2)
            return [];
        var /** @type {?} */ c = p[p.length - 2].children.map(function (c) { return c.value; });
        return c.filter(function (cc) { return cc !== t; });
    };
    /**
     * \@internal
     * @param {?} t
     * @return {?}
     */
    Tree.prototype.pathFromRoot = function (t) { return findPath(t, this._root, []).map(function (s) { return s.value; }); };
    return Tree;
}());
/**
 * @template T
 * @param {?} expected
 * @param {?} c
 * @return {?}
 */
function findNode(expected, c) {
    if (expected === c.value)
        return c;
    for (var _i = 0, _a = c.children; _i < _a.length; _i++) {
        var cc = _a[_i];
        var /** @type {?} */ r = findNode(expected, cc);
        if (r)
            return r;
    }
    return null;
}
/**
 * @template T
 * @param {?} expected
 * @param {?} c
 * @param {?} collected
 * @return {?}
 */
function findPath(expected, c, collected) {
    collected.push(c);
    if (expected === c.value)
        return collected;
    for (var _i = 0, _a = c.children; _i < _a.length; _i++) {
        var cc = _a[_i];
        var /** @type {?} */ cloned = collected.slice(0);
        var /** @type {?} */ r = findPath(expected, cc, cloned);
        if (r.length > 0)
            return r;
    }
    return [];
}
var TreeNode = (function () {
    /**
     * @param {?} value
     * @param {?} children
     */
    function TreeNode(value, children) {
        this.value = value;
        this.children = children;
    }
    /**
     * @return {?}
     */
    TreeNode.prototype.toString = function () { return "TreeNode(" + this.value + ")"; };
    return TreeNode;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var __assign$2 = (undefined && undefined.__assign) || Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s)
            if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
    }
    return t;
};
/**
 * \@whatItDoes Represents the state of the router.
 *
 * \@howToUse
 *
 * ```
 * \@Component({templateUrl:'template.html'})
 * class MyComponent {
 *   constructor(router: Router) {
 *     const state: RouterState = router.routerState;
 *     const root: ActivatedRoute = state.root;
 *     const child = root.firstChild;
 *     const id: Observable<string> = child.params.map(p => p.id);
 *     //...
 *   }
 * }
 * ```
 *
 * \@description
 * RouterState is a tree of activated routes. Every node in this tree knows about the "consumed" URL
 * segments, the extracted parameters, and the resolved data.
 *
 * See {\@link ActivatedRoute} for more information.
 *
 * \@stable
 */
var RouterState = (function (_super) {
    __extends(RouterState, _super);
    /**
     * \@internal
     * @param {?} root
     * @param {?} snapshot
     */
    function RouterState(root, snapshot) {
        var _this = _super.call(this, root) || this;
        _this.snapshot = snapshot;
        setRouterStateSnapshot(_this, root);
        return _this;
    }
    /**
     * @return {?}
     */
    RouterState.prototype.toString = function () { return this.snapshot.toString(); };
    return RouterState;
}(Tree));
/**
 * @param {?} urlTree
 * @param {?} rootComponent
 * @return {?}
 */
function createEmptyState(urlTree, rootComponent) {
    var /** @type {?} */ snapshot = createEmptyStateSnapshot(urlTree, rootComponent);
    var /** @type {?} */ emptyUrl = new __WEBPACK_IMPORTED_MODULE_2_rxjs_BehaviorSubject__["BehaviorSubject"]([new UrlSegment('', {})]);
    var /** @type {?} */ emptyParams = new __WEBPACK_IMPORTED_MODULE_2_rxjs_BehaviorSubject__["BehaviorSubject"]({});
    var /** @type {?} */ emptyData = new __WEBPACK_IMPORTED_MODULE_2_rxjs_BehaviorSubject__["BehaviorSubject"]({});
    var /** @type {?} */ emptyQueryParams = new __WEBPACK_IMPORTED_MODULE_2_rxjs_BehaviorSubject__["BehaviorSubject"]({});
    var /** @type {?} */ fragment = new __WEBPACK_IMPORTED_MODULE_2_rxjs_BehaviorSubject__["BehaviorSubject"]('');
    var /** @type {?} */ activated = new ActivatedRoute(emptyUrl, emptyParams, emptyQueryParams, fragment, emptyData, PRIMARY_OUTLET, rootComponent, snapshot.root);
    activated.snapshot = snapshot.root;
    return new RouterState(new TreeNode(activated, []), snapshot);
}
/**
 * @param {?} urlTree
 * @param {?} rootComponent
 * @return {?}
 */
function createEmptyStateSnapshot(urlTree, rootComponent) {
    var /** @type {?} */ emptyParams = {};
    var /** @type {?} */ emptyData = {};
    var /** @type {?} */ emptyQueryParams = {};
    var /** @type {?} */ fragment = '';
    var /** @type {?} */ activated = new ActivatedRouteSnapshot([], emptyParams, emptyQueryParams, fragment, emptyData, PRIMARY_OUTLET, rootComponent, null, urlTree.root, -1, {});
    return new RouterStateSnapshot('', new TreeNode(activated, []));
}
/**
 * \@whatItDoes Contains the information about a route associated with a component loaded in an
 * outlet.
 * An `ActivatedRoute` can also be used to traverse the router state tree.
 *
 * \@howToUse
 *
 * ```
 * \@Component({...})
 * class MyComponent {
 *   constructor(route: ActivatedRoute) {
 *     const id: Observable<string> = route.params.map(p => p.id);
 *     const url: Observable<string> = route.url.map(segments => segments.join(''));
 *     // route.data includes both `data` and `resolve`
 *     const user = route.data.map(d => d.user);
 *   }
 * }
 * ```
 *
 * \@stable
 */
var ActivatedRoute = (function () {
    /**
     * \@internal
     * @param {?} url
     * @param {?} params
     * @param {?} queryParams
     * @param {?} fragment
     * @param {?} data
     * @param {?} outlet
     * @param {?} component
     * @param {?} futureSnapshot
     */
    function ActivatedRoute(url, params, queryParams, fragment, data, outlet, component, futureSnapshot) {
        this.url = url;
        this.params = params;
        this.queryParams = queryParams;
        this.fragment = fragment;
        this.data = data;
        this.outlet = outlet;
        this.component = component;
        this._futureSnapshot = futureSnapshot;
    }
    Object.defineProperty(ActivatedRoute.prototype, "routeConfig", {
        /**
         * The configuration used to match this route
         * @return {?}
         */
        get: function () { return this._futureSnapshot.routeConfig; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ActivatedRoute.prototype, "root", {
        /**
         * The root of the router state
         * @return {?}
         */
        get: function () { return this._routerState.root; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ActivatedRoute.prototype, "parent", {
        /**
         * The parent of this route in the router state tree
         * @return {?}
         */
        get: function () { return this._routerState.parent(this); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ActivatedRoute.prototype, "firstChild", {
        /**
         * The first child of this route in the router state tree
         * @return {?}
         */
        get: function () { return this._routerState.firstChild(this); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ActivatedRoute.prototype, "children", {
        /**
         * The children of this route in the router state tree
         * @return {?}
         */
        get: function () { return this._routerState.children(this); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ActivatedRoute.prototype, "pathFromRoot", {
        /**
         * The path from the root of the router state tree to this route
         * @return {?}
         */
        get: function () { return this._routerState.pathFromRoot(this); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ActivatedRoute.prototype, "paramMap", {
        /**
         * @return {?}
         */
        get: function () {
            if (!this._paramMap) {
                this._paramMap = __WEBPACK_IMPORTED_MODULE_9_rxjs_operator_map__["map"].call(this.params, function (p) { return convertToParamMap(p); });
            }
            return this._paramMap;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ActivatedRoute.prototype, "queryParamMap", {
        /**
         * @return {?}
         */
        get: function () {
            if (!this._queryParamMap) {
                this._queryParamMap =
                    __WEBPACK_IMPORTED_MODULE_9_rxjs_operator_map__["map"].call(this.queryParams, function (p) { return convertToParamMap(p); });
            }
            return this._queryParamMap;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    ActivatedRoute.prototype.toString = function () {
        return this.snapshot ? this.snapshot.toString() : "Future(" + this._futureSnapshot + ")";
    };
    return ActivatedRoute;
}());
/**
 * \@internal
 * @param {?} route
 * @return {?}
 */
function inheritedParamsDataResolve(route) {
    var /** @type {?} */ pathToRoot = route.pathFromRoot;
    var /** @type {?} */ inhertingStartingFrom = pathToRoot.length - 1;
    while (inhertingStartingFrom >= 1) {
        var /** @type {?} */ current = pathToRoot[inhertingStartingFrom];
        var /** @type {?} */ parent = pathToRoot[inhertingStartingFrom - 1];
        // current route is an empty path => inherits its parent's params and data
        if (current.routeConfig && current.routeConfig.path === '') {
            inhertingStartingFrom--;
        }
        else if (!parent.component) {
            inhertingStartingFrom--;
        }
        else {
            break;
        }
    }
    return pathToRoot.slice(inhertingStartingFrom).reduce(function (res, curr) {
        var /** @type {?} */ params = __assign$2({}, res.params, curr.params);
        var /** @type {?} */ data = __assign$2({}, res.data, curr.data);
        var /** @type {?} */ resolve = __assign$2({}, res.resolve, curr._resolvedData);
        return { params: params, data: data, resolve: resolve };
    }, /** @type {?} */ ({ params: {}, data: {}, resolve: {} }));
}
/**
 * \@whatItDoes Contains the information about a route associated with a component loaded in an
 * outlet
 * at a particular moment in time. ActivatedRouteSnapshot can also be used to traverse the router
 * state tree.
 *
 * \@howToUse
 *
 * ```
 * \@Component({templateUrl:'./my-component.html'})
 * class MyComponent {
 *   constructor(route: ActivatedRoute) {
 *     const id: string = route.snapshot.params.id;
 *     const url: string = route.snapshot.url.join('');
 *     const user = route.snapshot.data.user;
 *   }
 * }
 * ```
 *
 * \@stable
 */
var ActivatedRouteSnapshot = (function () {
    /**
     * \@internal
     * @param {?} url
     * @param {?} params
     * @param {?} queryParams
     * @param {?} fragment
     * @param {?} data
     * @param {?} outlet
     * @param {?} component
     * @param {?} routeConfig
     * @param {?} urlSegment
     * @param {?} lastPathIndex
     * @param {?} resolve
     */
    function ActivatedRouteSnapshot(url, params, queryParams, fragment, data, outlet, component, routeConfig, urlSegment, lastPathIndex, resolve) {
        this.url = url;
        this.params = params;
        this.queryParams = queryParams;
        this.fragment = fragment;
        this.data = data;
        this.outlet = outlet;
        this.component = component;
        this._routeConfig = routeConfig;
        this._urlSegment = urlSegment;
        this._lastPathIndex = lastPathIndex;
        this._resolve = resolve;
    }
    Object.defineProperty(ActivatedRouteSnapshot.prototype, "routeConfig", {
        /**
         * The configuration used to match this route
         * @return {?}
         */
        get: function () { return this._routeConfig; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ActivatedRouteSnapshot.prototype, "root", {
        /**
         * The root of the router state
         * @return {?}
         */
        get: function () { return this._routerState.root; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ActivatedRouteSnapshot.prototype, "parent", {
        /**
         * The parent of this route in the router state tree
         * @return {?}
         */
        get: function () { return this._routerState.parent(this); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ActivatedRouteSnapshot.prototype, "firstChild", {
        /**
         * The first child of this route in the router state tree
         * @return {?}
         */
        get: function () { return this._routerState.firstChild(this); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ActivatedRouteSnapshot.prototype, "children", {
        /**
         * The children of this route in the router state tree
         * @return {?}
         */
        get: function () { return this._routerState.children(this); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ActivatedRouteSnapshot.prototype, "pathFromRoot", {
        /**
         * The path from the root of the router state tree to this route
         * @return {?}
         */
        get: function () { return this._routerState.pathFromRoot(this); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ActivatedRouteSnapshot.prototype, "paramMap", {
        /**
         * @return {?}
         */
        get: function () {
            if (!this._paramMap) {
                this._paramMap = convertToParamMap(this.params);
            }
            return this._paramMap;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ActivatedRouteSnapshot.prototype, "queryParamMap", {
        /**
         * @return {?}
         */
        get: function () {
            if (!this._queryParamMap) {
                this._queryParamMap = convertToParamMap(this.queryParams);
            }
            return this._queryParamMap;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    ActivatedRouteSnapshot.prototype.toString = function () {
        var /** @type {?} */ url = this.url.map(function (segment) { return segment.toString(); }).join('/');
        var /** @type {?} */ matched = this._routeConfig ? this._routeConfig.path : '';
        return "Route(url:'" + url + "', path:'" + matched + "')";
    };
    return ActivatedRouteSnapshot;
}());
/**
 * \@whatItDoes Represents the state of the router at a moment in time.
 *
 * \@howToUse
 *
 * ```
 * \@Component({templateUrl:'template.html'})
 * class MyComponent {
 *   constructor(router: Router) {
 *     const state: RouterState = router.routerState;
 *     const snapshot: RouterStateSnapshot = state.snapshot;
 *     const root: ActivatedRouteSnapshot = snapshot.root;
 *     const child = root.firstChild;
 *     const id: Observable<string> = child.params.map(p => p.id);
 *     //...
 *   }
 * }
 * ```
 *
 * \@description
 * RouterStateSnapshot is a tree of activated route snapshots. Every node in this tree knows about
 * the "consumed" URL segments, the extracted parameters, and the resolved data.
 *
 * \@stable
 */
var RouterStateSnapshot = (function (_super) {
    __extends(RouterStateSnapshot, _super);
    /**
     * \@internal
     * @param {?} url
     * @param {?} root
     */
    function RouterStateSnapshot(url, root) {
        var _this = _super.call(this, root) || this;
        _this.url = url;
        setRouterStateSnapshot(_this, root);
        return _this;
    }
    /**
     * @return {?}
     */
    RouterStateSnapshot.prototype.toString = function () { return serializeNode(this._root); };
    return RouterStateSnapshot;
}(Tree));
/**
 * @template U, T
 * @param {?} state
 * @param {?} node
 * @return {?}
 */
function setRouterStateSnapshot(state, node) {
    node.value._routerState = state;
    node.children.forEach(function (c) { return setRouterStateSnapshot(state, c); });
}
/**
 * @param {?} node
 * @return {?}
 */
function serializeNode(node) {
    var /** @type {?} */ c = node.children.length > 0 ? " { " + node.children.map(serializeNode).join(", ") + " } " : '';
    return "" + node.value + c;
}
/**
 * The expectation is that the activate route is created with the right set of parameters.
 * So we push new values into the observables only when they are not the initial values.
 * And we detect that by checking if the snapshot field is set.
 * @param {?} route
 * @return {?}
 */
function advanceActivatedRoute(route) {
    if (route.snapshot) {
        var /** @type {?} */ currentSnapshot = route.snapshot;
        route.snapshot = route._futureSnapshot;
        if (!shallowEqual(currentSnapshot.queryParams, route._futureSnapshot.queryParams)) {
            ((route.queryParams)).next(route._futureSnapshot.queryParams);
        }
        if (currentSnapshot.fragment !== route._futureSnapshot.fragment) {
            ((route.fragment)).next(route._futureSnapshot.fragment);
        }
        if (!shallowEqual(currentSnapshot.params, route._futureSnapshot.params)) {
            ((route.params)).next(route._futureSnapshot.params);
        }
        if (!shallowEqualArrays(currentSnapshot.url, route._futureSnapshot.url)) {
            ((route.url)).next(route._futureSnapshot.url);
        }
        if (!shallowEqual(currentSnapshot.data, route._futureSnapshot.data)) {
            ((route.data)).next(route._futureSnapshot.data);
        }
    }
    else {
        route.snapshot = route._futureSnapshot;
        // this is for resolved data
        ((route.data)).next(route._futureSnapshot.data);
    }
}
/**
 * @param {?} a
 * @param {?} b
 * @return {?}
 */
function equalParamsAndUrlSegments(a, b) {
    var /** @type {?} */ equalUrlParams = shallowEqual(a.params, b.params) && equalSegments(a.url, b.url);
    var /** @type {?} */ parentsMismatch = !a.parent !== !b.parent;
    return equalUrlParams && !parentsMismatch &&
        (!a.parent || equalParamsAndUrlSegments(a.parent, /** @type {?} */ ((b.parent))));
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @param {?} routeReuseStrategy
 * @param {?} curr
 * @param {?} prevState
 * @return {?}
 */
function createRouterState(routeReuseStrategy, curr, prevState) {
    var /** @type {?} */ root = createNode(routeReuseStrategy, curr._root, prevState ? prevState._root : undefined);
    return new RouterState(root, curr);
}
/**
 * @param {?} routeReuseStrategy
 * @param {?} curr
 * @param {?=} prevState
 * @return {?}
 */
function createNode(routeReuseStrategy, curr, prevState) {
    // reuse an activated route that is currently displayed on the screen
    if (prevState && routeReuseStrategy.shouldReuseRoute(curr.value, prevState.value.snapshot)) {
        var /** @type {?} */ value = prevState.value;
        value._futureSnapshot = curr.value;
        var /** @type {?} */ children = createOrReuseChildren(routeReuseStrategy, curr, prevState);
        return new TreeNode(value, children);
    }
    else if (routeReuseStrategy.retrieve(curr.value)) {
        var /** @type {?} */ tree_1 = ((routeReuseStrategy.retrieve(curr.value))).route;
        setFutureSnapshotsOfActivatedRoutes(curr, tree_1);
        return tree_1;
    }
    else {
        var /** @type {?} */ value = createActivatedRoute(curr.value);
        var /** @type {?} */ children = curr.children.map(function (c) { return createNode(routeReuseStrategy, c); });
        return new TreeNode(value, children);
    }
}
/**
 * @param {?} curr
 * @param {?} result
 * @return {?}
 */
function setFutureSnapshotsOfActivatedRoutes(curr, result) {
    if (curr.value.routeConfig !== result.value.routeConfig) {
        throw new Error('Cannot reattach ActivatedRouteSnapshot created from a different route');
    }
    if (curr.children.length !== result.children.length) {
        throw new Error('Cannot reattach ActivatedRouteSnapshot with a different number of children');
    }
    result.value._futureSnapshot = curr.value;
    for (var /** @type {?} */ i = 0; i < curr.children.length; ++i) {
        setFutureSnapshotsOfActivatedRoutes(curr.children[i], result.children[i]);
    }
}
/**
 * @param {?} routeReuseStrategy
 * @param {?} curr
 * @param {?} prevState
 * @return {?}
 */
function createOrReuseChildren(routeReuseStrategy, curr, prevState) {
    return curr.children.map(function (child) {
        for (var _i = 0, _a = prevState.children; _i < _a.length; _i++) {
            var p = _a[_i];
            if (routeReuseStrategy.shouldReuseRoute(p.value.snapshot, child.value)) {
                return createNode(routeReuseStrategy, child, p);
            }
        }
        return createNode(routeReuseStrategy, child);
    });
}
/**
 * @param {?} c
 * @return {?}
 */
function createActivatedRoute(c) {
    return new ActivatedRoute(new __WEBPACK_IMPORTED_MODULE_2_rxjs_BehaviorSubject__["BehaviorSubject"](c.url), new __WEBPACK_IMPORTED_MODULE_2_rxjs_BehaviorSubject__["BehaviorSubject"](c.params), new __WEBPACK_IMPORTED_MODULE_2_rxjs_BehaviorSubject__["BehaviorSubject"](c.queryParams), new __WEBPACK_IMPORTED_MODULE_2_rxjs_BehaviorSubject__["BehaviorSubject"](c.fragment), new __WEBPACK_IMPORTED_MODULE_2_rxjs_BehaviorSubject__["BehaviorSubject"](c.data), c.outlet, c.component, c);
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @param {?} route
 * @param {?} urlTree
 * @param {?} commands
 * @param {?} queryParams
 * @param {?} fragment
 * @return {?}
 */
function createUrlTree(route, urlTree, commands, queryParams, fragment) {
    if (commands.length === 0) {
        return tree(urlTree.root, urlTree.root, urlTree, queryParams, fragment);
    }
    var /** @type {?} */ nav = computeNavigation(commands);
    if (nav.toRoot()) {
        return tree(urlTree.root, new UrlSegmentGroup([], {}), urlTree, queryParams, fragment);
    }
    var /** @type {?} */ startingPosition = findStartingPosition(nav, urlTree, route);
    var /** @type {?} */ segmentGroup = startingPosition.processChildren ?
        updateSegmentGroupChildren(startingPosition.segmentGroup, startingPosition.index, nav.commands) :
        updateSegmentGroup(startingPosition.segmentGroup, startingPosition.index, nav.commands);
    return tree(startingPosition.segmentGroup, segmentGroup, urlTree, queryParams, fragment);
}
/**
 * @param {?} command
 * @return {?}
 */
function isMatrixParams(command) {
    return typeof command === 'object' && command != null && !command.outlets && !command.segmentPath;
}
/**
 * @param {?} oldSegmentGroup
 * @param {?} newSegmentGroup
 * @param {?} urlTree
 * @param {?} queryParams
 * @param {?} fragment
 * @return {?}
 */
function tree(oldSegmentGroup, newSegmentGroup, urlTree, queryParams, fragment) {
    var /** @type {?} */ qp = {};
    if (queryParams) {
        forEach(queryParams, function (value, name) {
            qp[name] = Array.isArray(value) ? value.map(function (v) { return "" + v; }) : "" + value;
        });
    }
    if (urlTree.root === oldSegmentGroup) {
        return new UrlTree(newSegmentGroup, qp, fragment);
    }
    return new UrlTree(replaceSegment(urlTree.root, oldSegmentGroup, newSegmentGroup), qp, fragment);
}
/**
 * @param {?} current
 * @param {?} oldSegment
 * @param {?} newSegment
 * @return {?}
 */
function replaceSegment(current, oldSegment, newSegment) {
    var /** @type {?} */ children = {};
    forEach(current.children, function (c, outletName) {
        if (c === oldSegment) {
            children[outletName] = newSegment;
        }
        else {
            children[outletName] = replaceSegment(c, oldSegment, newSegment);
        }
    });
    return new UrlSegmentGroup(current.segments, children);
}
var Navigation = (function () {
    /**
     * @param {?} isAbsolute
     * @param {?} numberOfDoubleDots
     * @param {?} commands
     */
    function Navigation(isAbsolute, numberOfDoubleDots, commands) {
        this.isAbsolute = isAbsolute;
        this.numberOfDoubleDots = numberOfDoubleDots;
        this.commands = commands;
        if (isAbsolute && commands.length > 0 && isMatrixParams(commands[0])) {
            throw new Error('Root segment cannot have matrix parameters');
        }
        var cmdWithOutlet = commands.find(function (c) { return typeof c === 'object' && c != null && c.outlets; });
        if (cmdWithOutlet && cmdWithOutlet !== last$1(commands)) {
            throw new Error('{outlets:{}} has to be the last command');
        }
    }
    /**
     * @return {?}
     */
    Navigation.prototype.toRoot = function () {
        return this.isAbsolute && this.commands.length === 1 && this.commands[0] == '/';
    };
    return Navigation;
}());
/**
 * Transforms commands to a normalized `Navigation`
 * @param {?} commands
 * @return {?}
 */
function computeNavigation(commands) {
    if ((typeof commands[0] === 'string') && commands.length === 1 && commands[0] === '/') {
        return new Navigation(true, 0, commands);
    }
    var /** @type {?} */ numberOfDoubleDots = 0;
    var /** @type {?} */ isAbsolute = false;
    var /** @type {?} */ res = commands.reduce(function (res, cmd, cmdIdx) {
        if (typeof cmd === 'object' && cmd != null) {
            if (cmd.outlets) {
                var /** @type {?} */ outlets_1 = {};
                forEach(cmd.outlets, function (commands, name) {
                    outlets_1[name] = typeof commands === 'string' ? commands.split('/') : commands;
                });
                return res.concat([{ outlets: outlets_1 }]);
            }
            if (cmd.segmentPath) {
                return res.concat([cmd.segmentPath]);
            }
        }
        if (!(typeof cmd === 'string')) {
            return res.concat([cmd]);
        }
        if (cmdIdx === 0) {
            cmd.split('/').forEach(function (urlPart, partIndex) {
                if (partIndex == 0 && urlPart === '.') {
                }
                else if (partIndex == 0 && urlPart === '') {
                    isAbsolute = true;
                }
                else if (urlPart === '..') {
                    numberOfDoubleDots++;
                }
                else if (urlPart != '') {
                    res.push(urlPart);
                }
            });
            return res;
        }
        return res.concat([cmd]);
    }, []);
    return new Navigation(isAbsolute, numberOfDoubleDots, res);
}
var Position = (function () {
    /**
     * @param {?} segmentGroup
     * @param {?} processChildren
     * @param {?} index
     */
    function Position(segmentGroup, processChildren, index) {
        this.segmentGroup = segmentGroup;
        this.processChildren = processChildren;
        this.index = index;
    }
    return Position;
}());
/**
 * @param {?} nav
 * @param {?} tree
 * @param {?} route
 * @return {?}
 */
function findStartingPosition(nav, tree, route) {
    if (nav.isAbsolute) {
        return new Position(tree.root, true, 0);
    }
    if (route.snapshot._lastPathIndex === -1) {
        return new Position(route.snapshot._urlSegment, true, 0);
    }
    var /** @type {?} */ modifier = isMatrixParams(nav.commands[0]) ? 0 : 1;
    var /** @type {?} */ index = route.snapshot._lastPathIndex + modifier;
    return createPositionApplyingDoubleDots(route.snapshot._urlSegment, index, nav.numberOfDoubleDots);
}
/**
 * @param {?} group
 * @param {?} index
 * @param {?} numberOfDoubleDots
 * @return {?}
 */
function createPositionApplyingDoubleDots(group, index, numberOfDoubleDots) {
    var /** @type {?} */ g = group;
    var /** @type {?} */ ci = index;
    var /** @type {?} */ dd = numberOfDoubleDots;
    while (dd > ci) {
        dd -= ci;
        g = ((g.parent));
        if (!g) {
            throw new Error('Invalid number of \'../\'');
        }
        ci = g.segments.length;
    }
    return new Position(g, false, ci - dd);
}
/**
 * @param {?} command
 * @return {?}
 */
function getPath(command) {
    if (typeof command === 'object' && command != null && command.outlets) {
        return command.outlets[PRIMARY_OUTLET];
    }
    return "" + command;
}
/**
 * @param {?} commands
 * @return {?}
 */
function getOutlets(commands) {
    if (!(typeof commands[0] === 'object'))
        return _a = {}, _a[PRIMARY_OUTLET] = commands, _a;
    if (commands[0].outlets === undefined)
        return _b = {}, _b[PRIMARY_OUTLET] = commands, _b;
    return commands[0].outlets;
    var _a, _b;
}
/**
 * @param {?} segmentGroup
 * @param {?} startIndex
 * @param {?} commands
 * @return {?}
 */
function updateSegmentGroup(segmentGroup, startIndex, commands) {
    if (!segmentGroup) {
        segmentGroup = new UrlSegmentGroup([], {});
    }
    if (segmentGroup.segments.length === 0 && segmentGroup.hasChildren()) {
        return updateSegmentGroupChildren(segmentGroup, startIndex, commands);
    }
    var /** @type {?} */ m = prefixedWith(segmentGroup, startIndex, commands);
    var /** @type {?} */ slicedCommands = commands.slice(m.commandIndex);
    if (m.match && m.pathIndex < segmentGroup.segments.length) {
        var /** @type {?} */ g = new UrlSegmentGroup(segmentGroup.segments.slice(0, m.pathIndex), {});
        g.children[PRIMARY_OUTLET] =
            new UrlSegmentGroup(segmentGroup.segments.slice(m.pathIndex), segmentGroup.children);
        return updateSegmentGroupChildren(g, 0, slicedCommands);
    }
    else if (m.match && slicedCommands.length === 0) {
        return new UrlSegmentGroup(segmentGroup.segments, {});
    }
    else if (m.match && !segmentGroup.hasChildren()) {
        return createNewSegmentGroup(segmentGroup, startIndex, commands);
    }
    else if (m.match) {
        return updateSegmentGroupChildren(segmentGroup, 0, slicedCommands);
    }
    else {
        return createNewSegmentGroup(segmentGroup, startIndex, commands);
    }
}
/**
 * @param {?} segmentGroup
 * @param {?} startIndex
 * @param {?} commands
 * @return {?}
 */
function updateSegmentGroupChildren(segmentGroup, startIndex, commands) {
    if (commands.length === 0) {
        return new UrlSegmentGroup(segmentGroup.segments, {});
    }
    else {
        var /** @type {?} */ outlets_2 = getOutlets(commands);
        var /** @type {?} */ children_2 = {};
        forEach(outlets_2, function (commands, outlet) {
            if (commands !== null) {
                children_2[outlet] = updateSegmentGroup(segmentGroup.children[outlet], startIndex, commands);
            }
        });
        forEach(segmentGroup.children, function (child, childOutlet) {
            if (outlets_2[childOutlet] === undefined) {
                children_2[childOutlet] = child;
            }
        });
        return new UrlSegmentGroup(segmentGroup.segments, children_2);
    }
}
/**
 * @param {?} segmentGroup
 * @param {?} startIndex
 * @param {?} commands
 * @return {?}
 */
function prefixedWith(segmentGroup, startIndex, commands) {
    var /** @type {?} */ currentCommandIndex = 0;
    var /** @type {?} */ currentPathIndex = startIndex;
    var /** @type {?} */ noMatch = { match: false, pathIndex: 0, commandIndex: 0 };
    while (currentPathIndex < segmentGroup.segments.length) {
        if (currentCommandIndex >= commands.length)
            return noMatch;
        var /** @type {?} */ path = segmentGroup.segments[currentPathIndex];
        var /** @type {?} */ curr = getPath(commands[currentCommandIndex]);
        var /** @type {?} */ next = currentCommandIndex < commands.length - 1 ? commands[currentCommandIndex + 1] : null;
        if (currentPathIndex > 0 && curr === undefined)
            break;
        if (curr && next && (typeof next === 'object') && next.outlets === undefined) {
            if (!compare(curr, next, path))
                return noMatch;
            currentCommandIndex += 2;
        }
        else {
            if (!compare(curr, {}, path))
                return noMatch;
            currentCommandIndex++;
        }
        currentPathIndex++;
    }
    return { match: true, pathIndex: currentPathIndex, commandIndex: currentCommandIndex };
}
/**
 * @param {?} segmentGroup
 * @param {?} startIndex
 * @param {?} commands
 * @return {?}
 */
function createNewSegmentGroup(segmentGroup, startIndex, commands) {
    var /** @type {?} */ paths = segmentGroup.segments.slice(0, startIndex);
    var /** @type {?} */ i = 0;
    while (i < commands.length) {
        if (typeof commands[i] === 'object' && commands[i].outlets !== undefined) {
            var /** @type {?} */ children = createNewSegmentChildren(commands[i].outlets);
            return new UrlSegmentGroup(paths, children);
        }
        // if we start with an object literal, we need to reuse the path part from the segment
        if (i === 0 && isMatrixParams(commands[0])) {
            var /** @type {?} */ p = segmentGroup.segments[startIndex];
            paths.push(new UrlSegment(p.path, commands[0]));
            i++;
            continue;
        }
        var /** @type {?} */ curr = getPath(commands[i]);
        var /** @type {?} */ next = (i < commands.length - 1) ? commands[i + 1] : null;
        if (curr && next && isMatrixParams(next)) {
            paths.push(new UrlSegment(curr, stringify(next)));
            i += 2;
        }
        else {
            paths.push(new UrlSegment(curr, {}));
            i++;
        }
    }
    return new UrlSegmentGroup(paths, {});
}
/**
 * @param {?} outlets
 * @return {?}
 */
function createNewSegmentChildren(outlets) {
    var /** @type {?} */ children = {};
    forEach(outlets, function (commands, outlet) {
        if (commands !== null) {
            children[outlet] = createNewSegmentGroup(new UrlSegmentGroup([], {}), 0, commands);
        }
    });
    return children;
}
/**
 * @param {?} params
 * @return {?}
 */
function stringify(params) {
    var /** @type {?} */ res = {};
    forEach(params, function (v, k) { return res[k] = "" + v; });
    return res;
}
/**
 * @param {?} path
 * @param {?} params
 * @param {?} segment
 * @return {?}
 */
function compare(path, params, segment) {
    return path == segment.path && shallowEqual(params, segment.parameters);
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var __assign$3 = (undefined && undefined.__assign) || Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s)
            if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
    }
    return t;
};
var NoMatch$1 = (function () {
    function NoMatch$1() {
    }
    return NoMatch$1;
}());
/**
 * @param {?} rootComponentType
 * @param {?} config
 * @param {?} urlTree
 * @param {?} url
 * @return {?}
 */
function recognize(rootComponentType, config, urlTree, url) {
    return new Recognizer(rootComponentType, config, urlTree, url).recognize();
}
var Recognizer = (function () {
    /**
     * @param {?} rootComponentType
     * @param {?} config
     * @param {?} urlTree
     * @param {?} url
     */
    function Recognizer(rootComponentType, config, urlTree, url) {
        this.rootComponentType = rootComponentType;
        this.config = config;
        this.urlTree = urlTree;
        this.url = url;
    }
    /**
     * @return {?}
     */
    Recognizer.prototype.recognize = function () {
        try {
            var /** @type {?} */ rootSegmentGroup = split$1(this.urlTree.root, [], [], this.config).segmentGroup;
            var /** @type {?} */ children = this.processSegmentGroup(this.config, rootSegmentGroup, PRIMARY_OUTLET);
            var /** @type {?} */ root = new ActivatedRouteSnapshot([], Object.freeze({}), Object.freeze(this.urlTree.queryParams), /** @type {?} */ ((this.urlTree.fragment)), {}, PRIMARY_OUTLET, this.rootComponentType, null, this.urlTree.root, -1, {});
            var /** @type {?} */ rootNode = new TreeNode(root, children);
            var /** @type {?} */ routeState = new RouterStateSnapshot(this.url, rootNode);
            this.inheriteParamsAndData(routeState._root);
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_rxjs_observable_of__["of"])(routeState);
        }
        catch (e) {
            return new __WEBPACK_IMPORTED_MODULE_12_rxjs_Observable__["Observable"](function (obs) { return obs.error(e); });
        }
    };
    /**
     * @param {?} routeNode
     * @return {?}
     */
    Recognizer.prototype.inheriteParamsAndData = function (routeNode) {
        var _this = this;
        var /** @type {?} */ route = routeNode.value;
        var /** @type {?} */ i = inheritedParamsDataResolve(route);
        route.params = Object.freeze(i.params);
        route.data = Object.freeze(i.data);
        routeNode.children.forEach(function (n) { return _this.inheriteParamsAndData(n); });
    };
    /**
     * @param {?} config
     * @param {?} segmentGroup
     * @param {?} outlet
     * @return {?}
     */
    Recognizer.prototype.processSegmentGroup = function (config, segmentGroup, outlet) {
        if (segmentGroup.segments.length === 0 && segmentGroup.hasChildren()) {
            return this.processChildren(config, segmentGroup);
        }
        return this.processSegment(config, segmentGroup, segmentGroup.segments, outlet);
    };
    /**
     * @param {?} config
     * @param {?} segmentGroup
     * @return {?}
     */
    Recognizer.prototype.processChildren = function (config, segmentGroup) {
        var _this = this;
        var /** @type {?} */ children = mapChildrenIntoArray(segmentGroup, function (child, childOutlet) { return _this.processSegmentGroup(config, child, childOutlet); });
        checkOutletNameUniqueness(children);
        sortActivatedRouteSnapshots(children);
        return children;
    };
    /**
     * @param {?} config
     * @param {?} segmentGroup
     * @param {?} segments
     * @param {?} outlet
     * @return {?}
     */
    Recognizer.prototype.processSegment = function (config, segmentGroup, segments, outlet) {
        for (var _i = 0, config_1 = config; _i < config_1.length; _i++) {
            var r = config_1[_i];
            try {
                return this.processSegmentAgainstRoute(r, segmentGroup, segments, outlet);
            }
            catch (e) {
                if (!(e instanceof NoMatch$1))
                    throw e;
            }
        }
        if (this.noLeftoversInUrl(segmentGroup, segments, outlet)) {
            return [];
        }
        throw new NoMatch$1();
    };
    /**
     * @param {?} segmentGroup
     * @param {?} segments
     * @param {?} outlet
     * @return {?}
     */
    Recognizer.prototype.noLeftoversInUrl = function (segmentGroup, segments, outlet) {
        return segments.length === 0 && !segmentGroup.children[outlet];
    };
    /**
     * @param {?} route
     * @param {?} rawSegment
     * @param {?} segments
     * @param {?} outlet
     * @return {?}
     */
    Recognizer.prototype.processSegmentAgainstRoute = function (route, rawSegment, segments, outlet) {
        if (route.redirectTo)
            throw new NoMatch$1();
        if ((route.outlet || PRIMARY_OUTLET) !== outlet)
            throw new NoMatch$1();
        if (route.path === '**') {
            var /** @type {?} */ params = segments.length > 0 ? ((last$1(segments))).parameters : {};
            var /** @type {?} */ snapshot_1 = new ActivatedRouteSnapshot(segments, params, Object.freeze(this.urlTree.queryParams), /** @type {?} */ ((this.urlTree.fragment)), getData(route), outlet, /** @type {?} */ ((route.component)), route, getSourceSegmentGroup(rawSegment), getPathIndexShift(rawSegment) + segments.length, getResolve(route));
            return [new TreeNode(snapshot_1, [])];
        }
        var _a = match$1(rawSegment, route, segments), consumedSegments = _a.consumedSegments, parameters = _a.parameters, lastChild = _a.lastChild;
        var /** @type {?} */ rawSlicedSegments = segments.slice(lastChild);
        var /** @type {?} */ childConfig = getChildConfig(route);
        var _b = split$1(rawSegment, consumedSegments, rawSlicedSegments, childConfig), segmentGroup = _b.segmentGroup, slicedSegments = _b.slicedSegments;
        var /** @type {?} */ snapshot = new ActivatedRouteSnapshot(consumedSegments, parameters, Object.freeze(this.urlTree.queryParams), /** @type {?} */ ((this.urlTree.fragment)), getData(route), outlet, /** @type {?} */ ((route.component)), route, getSourceSegmentGroup(rawSegment), getPathIndexShift(rawSegment) + consumedSegments.length, getResolve(route));
        if (slicedSegments.length === 0 && segmentGroup.hasChildren()) {
            var /** @type {?} */ children_3 = this.processChildren(childConfig, segmentGroup);
            return [new TreeNode(snapshot, children_3)];
        }
        if (childConfig.length === 0 && slicedSegments.length === 0) {
            return [new TreeNode(snapshot, [])];
        }
        var /** @type {?} */ children = this.processSegment(childConfig, segmentGroup, slicedSegments, PRIMARY_OUTLET);
        return [new TreeNode(snapshot, children)];
    };
    return Recognizer;
}());
/**
 * @param {?} nodes
 * @return {?}
 */
function sortActivatedRouteSnapshots(nodes) {
    nodes.sort(function (a, b) {
        if (a.value.outlet === PRIMARY_OUTLET)
            return -1;
        if (b.value.outlet === PRIMARY_OUTLET)
            return 1;
        return a.value.outlet.localeCompare(b.value.outlet);
    });
}
/**
 * @param {?} route
 * @return {?}
 */
function getChildConfig(route) {
    if (route.children) {
        return route.children;
    }
    if (route.loadChildren) {
        return ((route._loadedConfig)).routes;
    }
    return [];
}
/**
 * @param {?} segmentGroup
 * @param {?} route
 * @param {?} segments
 * @return {?}
 */
function match$1(segmentGroup, route, segments) {
    if (route.path === '') {
        if (route.pathMatch === 'full' && (segmentGroup.hasChildren() || segments.length > 0)) {
            throw new NoMatch$1();
        }
        return { consumedSegments: [], lastChild: 0, parameters: {} };
    }
    var /** @type {?} */ matcher = route.matcher || defaultUrlMatcher;
    var /** @type {?} */ res = matcher(segments, segmentGroup, route);
    if (!res)
        throw new NoMatch$1();
    var /** @type {?} */ posParams = {};
    forEach(/** @type {?} */ ((res.posParams)), function (v, k) { posParams[k] = v.path; });
    var /** @type {?} */ parameters = __assign$3({}, posParams, res.consumed[res.consumed.length - 1].parameters);
    return { consumedSegments: res.consumed, lastChild: res.consumed.length, parameters: parameters };
}
/**
 * @param {?} nodes
 * @return {?}
 */
function checkOutletNameUniqueness(nodes) {
    var /** @type {?} */ names = {};
    nodes.forEach(function (n) {
        var /** @type {?} */ routeWithSameOutletName = names[n.value.outlet];
        if (routeWithSameOutletName) {
            var /** @type {?} */ p = routeWithSameOutletName.url.map(function (s) { return s.toString(); }).join('/');
            var /** @type {?} */ c = n.value.url.map(function (s) { return s.toString(); }).join('/');
            throw new Error("Two segments cannot have the same outlet name: '" + p + "' and '" + c + "'.");
        }
        names[n.value.outlet] = n.value;
    });
}
/**
 * @param {?} segmentGroup
 * @return {?}
 */
function getSourceSegmentGroup(segmentGroup) {
    var /** @type {?} */ s = segmentGroup;
    while (s._sourceSegment) {
        s = s._sourceSegment;
    }
    return s;
}
/**
 * @param {?} segmentGroup
 * @return {?}
 */
function getPathIndexShift(segmentGroup) {
    var /** @type {?} */ s = segmentGroup;
    var /** @type {?} */ res = (s._segmentIndexShift ? s._segmentIndexShift : 0);
    while (s._sourceSegment) {
        s = s._sourceSegment;
        res += (s._segmentIndexShift ? s._segmentIndexShift : 0);
    }
    return res - 1;
}
/**
 * @param {?} segmentGroup
 * @param {?} consumedSegments
 * @param {?} slicedSegments
 * @param {?} config
 * @return {?}
 */
function split$1(segmentGroup, consumedSegments, slicedSegments, config) {
    if (slicedSegments.length > 0 &&
        containsEmptyPathMatchesWithNamedOutlets(segmentGroup, slicedSegments, config)) {
        var /** @type {?} */ s_1 = new UrlSegmentGroup(consumedSegments, createChildrenForEmptyPaths(segmentGroup, consumedSegments, config, new UrlSegmentGroup(slicedSegments, segmentGroup.children)));
        s_1._sourceSegment = segmentGroup;
        s_1._segmentIndexShift = consumedSegments.length;
        return { segmentGroup: s_1, slicedSegments: [] };
    }
    if (slicedSegments.length === 0 &&
        containsEmptyPathMatches(segmentGroup, slicedSegments, config)) {
        var /** @type {?} */ s_2 = new UrlSegmentGroup(segmentGroup.segments, addEmptyPathsToChildrenIfNeeded(segmentGroup, slicedSegments, config, segmentGroup.children));
        s_2._sourceSegment = segmentGroup;
        s_2._segmentIndexShift = consumedSegments.length;
        return { segmentGroup: s_2, slicedSegments: slicedSegments };
    }
    var /** @type {?} */ s = new UrlSegmentGroup(segmentGroup.segments, segmentGroup.children);
    s._sourceSegment = segmentGroup;
    s._segmentIndexShift = consumedSegments.length;
    return { segmentGroup: s, slicedSegments: slicedSegments };
}
/**
 * @param {?} segmentGroup
 * @param {?} slicedSegments
 * @param {?} routes
 * @param {?} children
 * @return {?}
 */
function addEmptyPathsToChildrenIfNeeded(segmentGroup, slicedSegments, routes, children) {
    var /** @type {?} */ res = {};
    for (var _i = 0, routes_3 = routes; _i < routes_3.length; _i++) {
        var r = routes_3[_i];
        if (emptyPathMatch(segmentGroup, slicedSegments, r) && !children[getOutlet$2(r)]) {
            var /** @type {?} */ s = new UrlSegmentGroup([], {});
            s._sourceSegment = segmentGroup;
            s._segmentIndexShift = segmentGroup.segments.length;
            res[getOutlet$2(r)] = s;
        }
    }
    return __assign$3({}, children, res);
}
/**
 * @param {?} segmentGroup
 * @param {?} consumedSegments
 * @param {?} routes
 * @param {?} primarySegment
 * @return {?}
 */
function createChildrenForEmptyPaths(segmentGroup, consumedSegments, routes, primarySegment) {
    var /** @type {?} */ res = {};
    res[PRIMARY_OUTLET] = primarySegment;
    primarySegment._sourceSegment = segmentGroup;
    primarySegment._segmentIndexShift = consumedSegments.length;
    for (var _i = 0, routes_4 = routes; _i < routes_4.length; _i++) {
        var r = routes_4[_i];
        if (r.path === '' && getOutlet$2(r) !== PRIMARY_OUTLET) {
            var /** @type {?} */ s = new UrlSegmentGroup([], {});
            s._sourceSegment = segmentGroup;
            s._segmentIndexShift = consumedSegments.length;
            res[getOutlet$2(r)] = s;
        }
    }
    return res;
}
/**
 * @param {?} segmentGroup
 * @param {?} slicedSegments
 * @param {?} routes
 * @return {?}
 */
function containsEmptyPathMatchesWithNamedOutlets(segmentGroup, slicedSegments, routes) {
    return routes.some(function (r) { return emptyPathMatch(segmentGroup, slicedSegments, r) && getOutlet$2(r) !== PRIMARY_OUTLET; });
}
/**
 * @param {?} segmentGroup
 * @param {?} slicedSegments
 * @param {?} routes
 * @return {?}
 */
function containsEmptyPathMatches(segmentGroup, slicedSegments, routes) {
    return routes.some(function (r) { return emptyPathMatch(segmentGroup, slicedSegments, r); });
}
/**
 * @param {?} segmentGroup
 * @param {?} slicedSegments
 * @param {?} r
 * @return {?}
 */
function emptyPathMatch(segmentGroup, slicedSegments, r) {
    if ((segmentGroup.hasChildren() || slicedSegments.length > 0) && r.pathMatch === 'full') {
        return false;
    }
    return r.path === '' && r.redirectTo === undefined;
}
/**
 * @param {?} route
 * @return {?}
 */
function getOutlet$2(route) {
    return route.outlet || PRIMARY_OUTLET;
}
/**
 * @param {?} route
 * @return {?}
 */
function getData(route) {
    return route.data || {};
}
/**
 * @param {?} route
 * @return {?}
 */
function getResolve(route) {
    return route.resolve || {};
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * \@docsNotRequired
 * \@experimental
 */
var ROUTES = new __WEBPACK_IMPORTED_MODULE_1__angular_core__["InjectionToken"]('ROUTES');
var RouterConfigLoader = (function () {
    /**
     * @param {?} loader
     * @param {?} compiler
     * @param {?=} onLoadStartListener
     * @param {?=} onLoadEndListener
     */
    function RouterConfigLoader(loader, compiler, onLoadStartListener, onLoadEndListener) {
        this.loader = loader;
        this.compiler = compiler;
        this.onLoadStartListener = onLoadStartListener;
        this.onLoadEndListener = onLoadEndListener;
    }
    /**
     * @param {?} parentInjector
     * @param {?} route
     * @return {?}
     */
    RouterConfigLoader.prototype.load = function (parentInjector, route) {
        var _this = this;
        if (this.onLoadStartListener) {
            this.onLoadStartListener(route);
        }
        var /** @type {?} */ moduleFactory$ = this.loadModuleFactory(/** @type {?} */ ((route.loadChildren)));
        return __WEBPACK_IMPORTED_MODULE_9_rxjs_operator_map__["map"].call(moduleFactory$, function (factory) {
            if (_this.onLoadEndListener) {
                _this.onLoadEndListener(route);
            }
            var /** @type {?} */ module = factory.create(parentInjector);
            return new LoadedRouterConfig(flatten(module.injector.get(ROUTES)), module);
        });
    };
    /**
     * @param {?} loadChildren
     * @return {?}
     */
    RouterConfigLoader.prototype.loadModuleFactory = function (loadChildren) {
        var _this = this;
        if (typeof loadChildren === 'string') {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16_rxjs_observable_fromPromise__["fromPromise"])(this.loader.load(loadChildren));
        }
        else {
            return __WEBPACK_IMPORTED_MODULE_10_rxjs_operator_mergeMap__["mergeMap"].call(wrapIntoObservable(loadChildren()), function (t) {
                if (t instanceof __WEBPACK_IMPORTED_MODULE_1__angular_core__["NgModuleFactory"]) {
                    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_rxjs_observable_of__["of"])(t);
                }
                else {
                    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16_rxjs_observable_fromPromise__["fromPromise"])(_this.compiler.compileModuleAsync(t));
                }
            });
        }
    };
    return RouterConfigLoader;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * \@whatItDoes Contains all the router outlets created in a component.
 *
 * \@stable
 */
var RouterOutletMap = (function () {
    function RouterOutletMap() {
        /**
         * \@internal
         */
        this._outlets = {};
    }
    /**
     * Adds an outlet to this map.
     * @param {?} name
     * @param {?} outlet
     * @return {?}
     */
    RouterOutletMap.prototype.registerOutlet = function (name, outlet) { this._outlets[name] = outlet; };
    /**
     * Removes an outlet from this map.
     * @param {?} name
     * @return {?}
     */
    RouterOutletMap.prototype.removeOutlet = function (name) { this._outlets[name] = ((undefined)); };
    return RouterOutletMap;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * \@whatItDoes Provides a way to migrate AngularJS applications to Angular.
 *
 * \@experimental
 * @abstract
 */
var UrlHandlingStrategy = (function () {
    function UrlHandlingStrategy() {
    }
    /**
     * Tells the router if this URL should be processed.
     *
     * When it returns true, the router will execute the regular navigation.
     * When it returns false, the router will set the router state to an empty state.
     * As a result, all the active components will be destroyed.
     *
     * @abstract
     * @param {?} url
     * @return {?}
     */
    UrlHandlingStrategy.prototype.shouldProcessUrl = function (url) { };
    /**
     * Extracts the part of the URL that should be handled by the router.
     * The rest of the URL will remain untouched.
     * @abstract
     * @param {?} url
     * @return {?}
     */
    UrlHandlingStrategy.prototype.extract = function (url) { };
    /**
     * Merges the URL fragment with the rest of the URL.
     * @abstract
     * @param {?} newUrlPart
     * @param {?} rawUrl
     * @return {?}
     */
    UrlHandlingStrategy.prototype.merge = function (newUrlPart, rawUrl) { };
    return UrlHandlingStrategy;
}());
/**
 * \@experimental
 */
var DefaultUrlHandlingStrategy = (function () {
    function DefaultUrlHandlingStrategy() {
    }
    /**
     * @param {?} url
     * @return {?}
     */
    DefaultUrlHandlingStrategy.prototype.shouldProcessUrl = function (url) { return true; };
    /**
     * @param {?} url
     * @return {?}
     */
    DefaultUrlHandlingStrategy.prototype.extract = function (url) { return url; };
    /**
     * @param {?} newUrlPart
     * @param {?} wholeUrl
     * @return {?}
     */
    DefaultUrlHandlingStrategy.prototype.merge = function (newUrlPart, wholeUrl) { return newUrlPart; };
    return DefaultUrlHandlingStrategy;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var __assign = (undefined && undefined.__assign) || Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s)
            if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
    }
    return t;
};
/**
 * @param {?} error
 * @return {?}
 */
function defaultErrorHandler(error) {
    throw error;
}
/**
 * \@internal
 * @param {?} snapshot
 * @return {?}
 */
function defaultRouterHook(snapshot) {
    return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_rxjs_observable_of__["of"])(null));
}
/**
 * Does not detach any subtrees. Reuses routes as long as their route config is the same.
 */
var DefaultRouteReuseStrategy = (function () {
    function DefaultRouteReuseStrategy() {
    }
    /**
     * @param {?} route
     * @return {?}
     */
    DefaultRouteReuseStrategy.prototype.shouldDetach = function (route) { return false; };
    /**
     * @param {?} route
     * @param {?} detachedTree
     * @return {?}
     */
    DefaultRouteReuseStrategy.prototype.store = function (route, detachedTree) { };
    /**
     * @param {?} route
     * @return {?}
     */
    DefaultRouteReuseStrategy.prototype.shouldAttach = function (route) { return false; };
    /**
     * @param {?} route
     * @return {?}
     */
    DefaultRouteReuseStrategy.prototype.retrieve = function (route) { return null; };
    /**
     * @param {?} future
     * @param {?} curr
     * @return {?}
     */
    DefaultRouteReuseStrategy.prototype.shouldReuseRoute = function (future, curr) {
        return future.routeConfig === curr.routeConfig;
    };
    return DefaultRouteReuseStrategy;
}());
/**
 * \@whatItDoes Provides the navigation and url manipulation capabilities.
 *
 * See {\@link Routes} for more details and examples.
 *
 * \@ngModule RouterModule
 *
 * \@stable
 */
var Router = (function () {
    /**
     * @param {?} rootComponentType
     * @param {?} urlSerializer
     * @param {?} outletMap
     * @param {?} location
     * @param {?} injector
     * @param {?} loader
     * @param {?} compiler
     * @param {?} config
     */
    function Router(rootComponentType, urlSerializer, outletMap, location, injector, loader, compiler, config) {
        var _this = this;
        this.rootComponentType = rootComponentType;
        this.urlSerializer = urlSerializer;
        this.outletMap = outletMap;
        this.location = location;
        this.config = config;
        this.navigations = new __WEBPACK_IMPORTED_MODULE_2_rxjs_BehaviorSubject__["BehaviorSubject"](/** @type {?} */ ((null)));
        this.routerEvents = new __WEBPACK_IMPORTED_MODULE_3_rxjs_Subject__["Subject"]();
        this.navigationId = 0;
        /**
         * Error handler that is invoked when a navigation errors.
         *
         * See {@link ErrorHandler} for more information.
         */
        this.errorHandler = defaultErrorHandler;
        /**
         * Indicates if at least one navigation happened.
         */
        this.navigated = false;
        /**
         * Used by RouterModule. This allows us to
         * pause the navigation either before preactivation or after it.
         * \@internal
         */
        this.hooks = {
            beforePreactivation: defaultRouterHook,
            afterPreactivation: defaultRouterHook
        };
        /**
         * Extracts and merges URLs. Used for AngularJS to Angular migrations.
         */
        this.urlHandlingStrategy = new DefaultUrlHandlingStrategy();
        this.routeReuseStrategy = new DefaultRouteReuseStrategy();
        var onLoadStart = function (r) { return _this.triggerEvent(new RouteConfigLoadStart(r)); };
        var onLoadEnd = function (r) { return _this.triggerEvent(new RouteConfigLoadEnd(r)); };
        this.ngModule = injector.get(__WEBPACK_IMPORTED_MODULE_1__angular_core__["NgModuleRef"]);
        this.resetConfig(config);
        this.currentUrlTree = createEmptyUrlTree();
        this.rawUrlTree = this.currentUrlTree;
        this.configLoader = new RouterConfigLoader(loader, compiler, onLoadStart, onLoadEnd);
        this.currentRouterState = createEmptyState(this.currentUrlTree, this.rootComponentType);
        this.processNavigations();
    }
    /**
     * \@internal
     * TODO: this should be removed once the constructor of the router made internal
     * @param {?} rootComponentType
     * @return {?}
     */
    Router.prototype.resetRootComponentType = function (rootComponentType) {
        this.rootComponentType = rootComponentType;
        // TODO: vsavkin router 4.0 should make the root component set to null
        // this will simplify the lifecycle of the router.
        this.currentRouterState.root.component = this.rootComponentType;
    };
    /**
     * Sets up the location change listener and performs the initial navigation.
     * @return {?}
     */
    Router.prototype.initialNavigation = function () {
        this.setUpLocationChangeListener();
        if (this.navigationId === 0) {
            this.navigateByUrl(this.location.path(true), { replaceUrl: true });
        }
    };
    /**
     * Sets up the location change listener.
     * @return {?}
     */
    Router.prototype.setUpLocationChangeListener = function () {
        var _this = this;
        // Zone.current.wrap is needed because of the issue with RxJS scheduler,
        // which does not work properly with zone.js in IE and Safari
        if (!this.locationSubscription) {
            this.locationSubscription = (this.location.subscribe(Zone.current.wrap(function (change) {
                var /** @type {?} */ rawUrlTree = _this.urlSerializer.parse(change['url']);
                var /** @type {?} */ source = change['type'] === 'popstate' ? 'popstate' : 'hashchange';
                setTimeout(function () { _this.scheduleNavigation(rawUrlTree, source, { replaceUrl: true }); }, 0);
            })));
        }
    };
    Object.defineProperty(Router.prototype, "routerState", {
        /**
         * The current route state
         * @return {?}
         */
        get: function () { return this.currentRouterState; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Router.prototype, "url", {
        /**
         * The current url
         * @return {?}
         */
        get: function () { return this.serializeUrl(this.currentUrlTree); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Router.prototype, "events", {
        /**
         * An observable of router events
         * @return {?}
         */
        get: function () { return this.routerEvents; },
        enumerable: true,
        configurable: true
    });
    /**
     * \@internal
     * @param {?} e
     * @return {?}
     */
    Router.prototype.triggerEvent = function (e) { this.routerEvents.next(e); };
    /**
     * Resets the configuration used for navigation and generating links.
     *
     * ### Usage
     *
     * ```
     * router.resetConfig([
     *  { path: 'team/:id', component: TeamCmp, children: [
     *    { path: 'simple', component: SimpleCmp },
     *    { path: 'user/:name', component: UserCmp }
     *  ]}
     * ]);
     * ```
     * @param {?} config
     * @return {?}
     */
    Router.prototype.resetConfig = function (config) {
        validateConfig(config);
        this.config = config;
    };
    /**
     * \@docsNotRequired
     * @return {?}
     */
    Router.prototype.ngOnDestroy = function () { this.dispose(); };
    /**
     * Disposes of the router
     * @return {?}
     */
    Router.prototype.dispose = function () {
        if (this.locationSubscription) {
            this.locationSubscription.unsubscribe();
            this.locationSubscription = ((null));
        }
    };
    /**
     * Applies an array of commands to the current url tree and creates a new url tree.
     *
     * When given an activate route, applies the given commands starting from the route.
     * When not given a route, applies the given command starting from the root.
     *
     * ### Usage
     *
     * ```
     * // create /team/33/user/11
     * router.createUrlTree(['/team', 33, 'user', 11]);
     *
     * // create /team/33;expand=true/user/11
     * router.createUrlTree(['/team', 33, {expand: true}, 'user', 11]);
     *
     * // you can collapse static segments like this (this works only with the first passed-in value):
     * router.createUrlTree(['/team/33/user', userId]);
     *
     * // If the first segment can contain slashes, and you do not want the router to split it, you
     * // can do the following:
     *
     * router.createUrlTree([{segmentPath: '/one/two'}]);
     *
     * // create /team/33/(user/11//right:chat)
     * router.createUrlTree(['/team', 33, {outlets: {primary: 'user/11', right: 'chat'}}]);
     *
     * // remove the right secondary node
     * router.createUrlTree(['/team', 33, {outlets: {primary: 'user/11', right: null}}]);
     *
     * // assuming the current url is `/team/33/user/11` and the route points to `user/11`
     *
     * // navigate to /team/33/user/11/details
     * router.createUrlTree(['details'], {relativeTo: route});
     *
     * // navigate to /team/33/user/22
     * router.createUrlTree(['../22'], {relativeTo: route});
     *
     * // navigate to /team/44/user/22
     * router.createUrlTree(['../../team/44/user/22'], {relativeTo: route});
     * ```
     * @param {?} commands
     * @param {?=} __1
     * @return {?}
     */
    Router.prototype.createUrlTree = function (commands, _a) {
        var _b = _a === void 0 ? {} : _a, relativeTo = _b.relativeTo, queryParams = _b.queryParams, fragment = _b.fragment, preserveQueryParams = _b.preserveQueryParams, queryParamsHandling = _b.queryParamsHandling, preserveFragment = _b.preserveFragment;
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["isDevMode"])() && preserveQueryParams && (console) && (console.warn)) {
            console.warn('preserveQueryParams is deprecated, use queryParamsHandling instead.');
        }
        var /** @type {?} */ a = relativeTo || this.routerState.root;
        var /** @type {?} */ f = preserveFragment ? this.currentUrlTree.fragment : fragment;
        var /** @type {?} */ q = null;
        if (queryParamsHandling) {
            switch (queryParamsHandling) {
                case 'merge':
                    q = __assign({}, this.currentUrlTree.queryParams, queryParams);
                    break;
                case 'preserve':
                    q = this.currentUrlTree.queryParams;
                    break;
                default:
                    q = queryParams || null;
            }
        }
        else {
            q = preserveQueryParams ? this.currentUrlTree.queryParams : queryParams || null;
        }
        return createUrlTree(a, this.currentUrlTree, commands, /** @type {?} */ ((q)), /** @type {?} */ ((f)));
    };
    /**
     * Navigate based on the provided url. This navigation is always absolute.
     *
     * Returns a promise that:
     * - resolves to 'true' when navigation succeeds,
     * - resolves to 'false' when navigation fails,
     * - is rejected when an error happens.
     *
     * ### Usage
     *
     * ```
     * router.navigateByUrl("/team/33/user/11");
     *
     * // Navigate without updating the URL
     * router.navigateByUrl("/team/33/user/11", { skipLocationChange: true });
     * ```
     *
     * In opposite to `navigate`, `navigateByUrl` takes a whole URL
     * and does not apply any delta to the current one.
     * @param {?} url
     * @param {?=} extras
     * @return {?}
     */
    Router.prototype.navigateByUrl = function (url, extras) {
        if (extras === void 0) { extras = { skipLocationChange: false }; }
        var /** @type {?} */ urlTree = url instanceof UrlTree ? url : this.parseUrl(url);
        var /** @type {?} */ mergedTree = this.urlHandlingStrategy.merge(urlTree, this.rawUrlTree);
        return this.scheduleNavigation(mergedTree, 'imperative', extras);
    };
    /**
     * Navigate based on the provided array of commands and a starting point.
     * If no starting route is provided, the navigation is absolute.
     *
     * Returns a promise that:
     * - resolves to 'true' when navigation succeeds,
     * - resolves to 'false' when navigation fails,
     * - is rejected when an error happens.
     *
     * ### Usage
     *
     * ```
     * router.navigate(['team', 33, 'user', 11], {relativeTo: route});
     *
     * // Navigate without updating the URL
     * router.navigate(['team', 33, 'user', 11], {relativeTo: route, skipLocationChange: true});
     * ```
     *
     * In opposite to `navigateByUrl`, `navigate` always takes a delta that is applied to the current
     * URL.
     * @param {?} commands
     * @param {?=} extras
     * @return {?}
     */
    Router.prototype.navigate = function (commands, extras) {
        if (extras === void 0) { extras = { skipLocationChange: false }; }
        validateCommands(commands);
        if (typeof extras.queryParams === 'object' && extras.queryParams !== null) {
            extras.queryParams = this.removeEmptyProps(extras.queryParams);
        }
        return this.navigateByUrl(this.createUrlTree(commands, extras), extras);
    };
    /**
     * Serializes a {\@link UrlTree} into a string
     * @param {?} url
     * @return {?}
     */
    Router.prototype.serializeUrl = function (url) { return this.urlSerializer.serialize(url); };
    /**
     * Parses a string into a {\@link UrlTree}
     * @param {?} url
     * @return {?}
     */
    Router.prototype.parseUrl = function (url) { return this.urlSerializer.parse(url); };
    /**
     * Returns whether the url is activated
     * @param {?} url
     * @param {?} exact
     * @return {?}
     */
    Router.prototype.isActive = function (url, exact) {
        if (url instanceof UrlTree) {
            return containsTree(this.currentUrlTree, url, exact);
        }
        else {
            var /** @type {?} */ urlTree = this.urlSerializer.parse(url);
            return containsTree(this.currentUrlTree, urlTree, exact);
        }
    };
    /**
     * @param {?} params
     * @return {?}
     */
    Router.prototype.removeEmptyProps = function (params) {
        return Object.keys(params).reduce(function (result, key) {
            var /** @type {?} */ value = params[key];
            if (value !== null && value !== undefined) {
                result[key] = value;
            }
            return result;
        }, {});
    };
    /**
     * @return {?}
     */
    Router.prototype.processNavigations = function () {
        var _this = this;
        __WEBPACK_IMPORTED_MODULE_6_rxjs_operator_concatMap__["concatMap"]
            .call(this.navigations, function (nav) {
            if (nav) {
                _this.executeScheduledNavigation(nav);
                // a failed navigation should not stop the router from processing
                // further navigations => the catch
                return nav.promise.catch(function () { });
            }
            else {
                return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_rxjs_observable_of__["of"])(null));
            }
        })
            .subscribe(function () { });
    };
    /**
     * @param {?} rawUrl
     * @param {?} source
     * @param {?} extras
     * @return {?}
     */
    Router.prototype.scheduleNavigation = function (rawUrl, source, extras) {
        var /** @type {?} */ lastNavigation = this.navigations.value;
        // If the user triggers a navigation imperatively (e.g., by using navigateByUrl),
        // and that navigation results in 'replaceState' that leads to the same URL,
        // we should skip those.
        if (lastNavigation && source !== 'imperative' && lastNavigation.source === 'imperative' &&
            lastNavigation.rawUrl.toString() === rawUrl.toString()) {
            return Promise.resolve(true); // return value is not used
        }
        // Because of a bug in IE and Edge, the location class fires two events (popstate and
        // hashchange) every single time. The second one should be ignored. Otherwise, the URL will
        // flicker.
        if (lastNavigation && source == 'hashchange' && lastNavigation.source === 'popstate' &&
            lastNavigation.rawUrl.toString() === rawUrl.toString()) {
            return Promise.resolve(true); // return value is not used
        }
        var /** @type {?} */ resolve = null;
        var /** @type {?} */ reject = null;
        var /** @type {?} */ promise = new Promise(function (res, rej) {
            resolve = res;
            reject = rej;
        });
        var /** @type {?} */ id = ++this.navigationId;
        this.navigations.next({ id: id, source: source, rawUrl: rawUrl, extras: extras, resolve: resolve, reject: reject, promise: promise });
        // Make sure that the error is propagated even though `processNavigations` catch
        // handler does not rethrow
        return promise.catch(function (e) { return Promise.reject(e); });
    };
    /**
     * @param {?} __0
     * @return {?}
     */
    Router.prototype.executeScheduledNavigation = function (_a) {
        var _this = this;
        var id = _a.id, rawUrl = _a.rawUrl, extras = _a.extras, resolve = _a.resolve, reject = _a.reject;
        var /** @type {?} */ url = this.urlHandlingStrategy.extract(rawUrl);
        var /** @type {?} */ urlTransition = !this.navigated || url.toString() !== this.currentUrlTree.toString();
        if (urlTransition && this.urlHandlingStrategy.shouldProcessUrl(rawUrl)) {
            this.routerEvents.next(new NavigationStart(id, this.serializeUrl(url)));
            Promise.resolve()
                .then(function (_) { return _this.runNavigate(url, rawUrl, !!extras.skipLocationChange, !!extras.replaceUrl, id, null); })
                .then(resolve, reject);
        }
        else if (urlTransition && this.rawUrlTree &&
            this.urlHandlingStrategy.shouldProcessUrl(this.rawUrlTree)) {
            this.routerEvents.next(new NavigationStart(id, this.serializeUrl(url)));
            Promise.resolve()
                .then(function (_) { return _this.runNavigate(url, rawUrl, false, false, id, createEmptyState(url, _this.rootComponentType).snapshot); })
                .then(resolve, reject);
        }
        else {
            this.rawUrlTree = rawUrl;
            resolve(null);
        }
    };
    /**
     * @param {?} url
     * @param {?} rawUrl
     * @param {?} shouldPreventPushState
     * @param {?} shouldReplaceUrl
     * @param {?} id
     * @param {?} precreatedState
     * @return {?}
     */
    Router.prototype.runNavigate = function (url, rawUrl, shouldPreventPushState, shouldReplaceUrl, id, precreatedState) {
        var _this = this;
        if (id !== this.navigationId) {
            this.location.go(this.urlSerializer.serialize(this.currentUrlTree));
            this.routerEvents.next(new NavigationCancel(id, this.serializeUrl(url), "Navigation ID " + id + " is not equal to the current navigation id " + this.navigationId));
            return Promise.resolve(false);
        }
        return new Promise(function (resolvePromise, rejectPromise) {
            // create an observable of the url and route state snapshot
            // this operation do not result in any side effects
            var /** @type {?} */ urlAndSnapshot$;
            if (!precreatedState) {
                var /** @type {?} */ moduleInjector = _this.ngModule.injector;
                var /** @type {?} */ redirectsApplied$ = applyRedirects(moduleInjector, _this.configLoader, _this.urlSerializer, url, _this.config);
                urlAndSnapshot$ = __WEBPACK_IMPORTED_MODULE_10_rxjs_operator_mergeMap__["mergeMap"].call(redirectsApplied$, function (appliedUrl) {
                    return __WEBPACK_IMPORTED_MODULE_9_rxjs_operator_map__["map"].call(recognize(_this.rootComponentType, _this.config, appliedUrl, _this.serializeUrl(appliedUrl)), function (snapshot) {
                        _this.routerEvents.next(new RoutesRecognized(id, _this.serializeUrl(url), _this.serializeUrl(appliedUrl), snapshot));
                        return { appliedUrl: appliedUrl, snapshot: snapshot };
                    });
                });
            }
            else {
                urlAndSnapshot$ = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_rxjs_observable_of__["of"])({ appliedUrl: url, snapshot: precreatedState });
            }
            var /** @type {?} */ beforePreactivationDone$ = __WEBPACK_IMPORTED_MODULE_10_rxjs_operator_mergeMap__["mergeMap"].call(urlAndSnapshot$, function (p) {
                return __WEBPACK_IMPORTED_MODULE_9_rxjs_operator_map__["map"].call(_this.hooks.beforePreactivation(p.snapshot), function () { return p; });
            });
            // run preactivation: guards and data resolvers
            var /** @type {?} */ preActivation;
            var /** @type {?} */ preactivationTraverse$ = __WEBPACK_IMPORTED_MODULE_9_rxjs_operator_map__["map"].call(beforePreactivationDone$, function (_a) {
                var appliedUrl = _a.appliedUrl, snapshot = _a.snapshot;
                var /** @type {?} */ moduleInjector = _this.ngModule.injector;
                preActivation =
                    new PreActivation(snapshot, _this.currentRouterState.snapshot, moduleInjector);
                preActivation.traverse(_this.outletMap);
                return { appliedUrl: appliedUrl, snapshot: snapshot };
            });
            var /** @type {?} */ preactivationCheckGuards$ = __WEBPACK_IMPORTED_MODULE_10_rxjs_operator_mergeMap__["mergeMap"].call(preactivationTraverse$, function (_a) {
                var appliedUrl = _a.appliedUrl, snapshot = _a.snapshot;
                if (_this.navigationId !== id)
                    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_rxjs_observable_of__["of"])(false);
                return __WEBPACK_IMPORTED_MODULE_9_rxjs_operator_map__["map"].call(preActivation.checkGuards(), function (shouldActivate) {
                    return { appliedUrl: appliedUrl, snapshot: snapshot, shouldActivate: shouldActivate };
                });
            });
            var /** @type {?} */ preactivationResolveData$ = __WEBPACK_IMPORTED_MODULE_10_rxjs_operator_mergeMap__["mergeMap"].call(preactivationCheckGuards$, function (p) {
                if (_this.navigationId !== id)
                    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_rxjs_observable_of__["of"])(false);
                if (p.shouldActivate) {
                    return __WEBPACK_IMPORTED_MODULE_9_rxjs_operator_map__["map"].call(preActivation.resolveData(), function () { return p; });
                }
                else {
                    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_rxjs_observable_of__["of"])(p);
                }
            });
            var /** @type {?} */ preactivationDone$ = __WEBPACK_IMPORTED_MODULE_10_rxjs_operator_mergeMap__["mergeMap"].call(preactivationResolveData$, function (p) {
                return __WEBPACK_IMPORTED_MODULE_9_rxjs_operator_map__["map"].call(_this.hooks.afterPreactivation(p.snapshot), function () { return p; });
            });
            // create router state
            // this operation has side effects => route state is being affected
            var /** @type {?} */ routerState$ = __WEBPACK_IMPORTED_MODULE_9_rxjs_operator_map__["map"].call(preactivationDone$, function (_a) {
                var appliedUrl = _a.appliedUrl, snapshot = _a.snapshot, shouldActivate = _a.shouldActivate;
                if (shouldActivate) {
                    var /** @type {?} */ state = createRouterState(_this.routeReuseStrategy, snapshot, _this.currentRouterState);
                    return { appliedUrl: appliedUrl, state: state, shouldActivate: shouldActivate };
                }
                else {
                    return { appliedUrl: appliedUrl, state: null, shouldActivate: shouldActivate };
                }
            });
            // applied the new router state
            // this operation has side effects
            var /** @type {?} */ navigationIsSuccessful;
            var /** @type {?} */ storedState = _this.currentRouterState;
            var /** @type {?} */ storedUrl = _this.currentUrlTree;
            routerState$
                .forEach(function (_a) {
                var appliedUrl = _a.appliedUrl, state = _a.state, shouldActivate = _a.shouldActivate;
                if (!shouldActivate || id !== _this.navigationId) {
                    navigationIsSuccessful = false;
                    return;
                }
                _this.currentUrlTree = appliedUrl;
                _this.rawUrlTree = _this.urlHandlingStrategy.merge(_this.currentUrlTree, rawUrl);
                _this.currentRouterState = state;
                if (!shouldPreventPushState) {
                    var /** @type {?} */ path = _this.urlSerializer.serialize(_this.rawUrlTree);
                    if (_this.location.isCurrentPathEqualTo(path) || shouldReplaceUrl) {
                        _this.location.replaceState(path);
                    }
                    else {
                        _this.location.go(path);
                    }
                }
                new ActivateRoutes(_this.routeReuseStrategy, state, storedState)
                    .activate(_this.outletMap);
                navigationIsSuccessful = true;
            })
                .then(function () {
                if (navigationIsSuccessful) {
                    _this.navigated = true;
                    _this.routerEvents.next(new NavigationEnd(id, _this.serializeUrl(url), _this.serializeUrl(_this.currentUrlTree)));
                    resolvePromise(true);
                }
                else {
                    _this.resetUrlToCurrentUrlTree();
                    _this.routerEvents.next(new NavigationCancel(id, _this.serializeUrl(url), ''));
                    resolvePromise(false);
                }
            }, function (e) {
                if (isNavigationCancelingError(e)) {
                    _this.resetUrlToCurrentUrlTree();
                    _this.navigated = true;
                    _this.routerEvents.next(new NavigationCancel(id, _this.serializeUrl(url), e.message));
                    resolvePromise(false);
                }
                else {
                    _this.routerEvents.next(new NavigationError(id, _this.serializeUrl(url), e));
                    try {
                        resolvePromise(_this.errorHandler(e));
                    }
                    catch (ee) {
                        rejectPromise(ee);
                    }
                }
                _this.currentRouterState = storedState;
                _this.currentUrlTree = storedUrl;
                _this.rawUrlTree = _this.urlHandlingStrategy.merge(_this.currentUrlTree, rawUrl);
                _this.location.replaceState(_this.serializeUrl(_this.rawUrlTree));
            });
        });
    };
    /**
     * @return {?}
     */
    Router.prototype.resetUrlToCurrentUrlTree = function () {
        var /** @type {?} */ path = this.urlSerializer.serialize(this.rawUrlTree);
        this.location.replaceState(path);
    };
    return Router;
}());
var CanActivate = (function () {
    /**
     * @param {?} path
     */
    function CanActivate(path) {
        this.path = path;
    }
    Object.defineProperty(CanActivate.prototype, "route", {
        /**
         * @return {?}
         */
        get: function () { return this.path[this.path.length - 1]; },
        enumerable: true,
        configurable: true
    });
    return CanActivate;
}());
var CanDeactivate = (function () {
    /**
     * @param {?} component
     * @param {?} route
     */
    function CanDeactivate(component, route) {
        this.component = component;
        this.route = route;
    }
    return CanDeactivate;
}());
var PreActivation = (function () {
    /**
     * @param {?} future
     * @param {?} curr
     * @param {?} moduleInjector
     */
    function PreActivation(future, curr, moduleInjector) {
        this.future = future;
        this.curr = curr;
        this.moduleInjector = moduleInjector;
        this.canActivateChecks = [];
        this.canDeactivateChecks = [];
    }
    /**
     * @param {?} parentOutletMap
     * @return {?}
     */
    PreActivation.prototype.traverse = function (parentOutletMap) {
        var /** @type {?} */ futureRoot = this.future._root;
        var /** @type {?} */ currRoot = this.curr ? this.curr._root : null;
        this.traverseChildRoutes(futureRoot, currRoot, parentOutletMap, [futureRoot.value]);
    };
    /**
     * @return {?}
     */
    PreActivation.prototype.checkGuards = function () {
        var _this = this;
        if (this.canDeactivateChecks.length === 0 && this.canActivateChecks.length === 0) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_rxjs_observable_of__["of"])(true);
        }
        var /** @type {?} */ canDeactivate$ = this.runCanDeactivateChecks();
        return __WEBPACK_IMPORTED_MODULE_10_rxjs_operator_mergeMap__["mergeMap"].call(canDeactivate$, function (canDeactivate) { return canDeactivate ? _this.runCanActivateChecks() : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_rxjs_observable_of__["of"])(false); });
    };
    /**
     * @return {?}
     */
    PreActivation.prototype.resolveData = function () {
        var _this = this;
        if (this.canActivateChecks.length === 0)
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_rxjs_observable_of__["of"])(null);
        var /** @type {?} */ checks$ = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_rxjs_observable_from__["from"])(this.canActivateChecks);
        var /** @type {?} */ runningChecks$ = __WEBPACK_IMPORTED_MODULE_6_rxjs_operator_concatMap__["concatMap"].call(checks$, function (check) { return _this.runResolve(check.route); });
        return __WEBPACK_IMPORTED_MODULE_11_rxjs_operator_reduce__["reduce"].call(runningChecks$, function (_, __) { return _; });
    };
    /**
     * @param {?} futureNode
     * @param {?} currNode
     * @param {?} outletMap
     * @param {?} futurePath
     * @return {?}
     */
    PreActivation.prototype.traverseChildRoutes = function (futureNode, currNode, outletMap, futurePath) {
        var _this = this;
        var /** @type {?} */ prevChildren = nodeChildrenAsMap(currNode);
        futureNode.children.forEach(function (c) {
            _this.traverseRoutes(c, prevChildren[c.value.outlet], outletMap, futurePath.concat([c.value]));
            delete prevChildren[c.value.outlet];
        });
        forEach(prevChildren, function (v, k) { return _this.deactiveRouteAndItsChildren(v, /** @type {?} */ ((outletMap))._outlets[k]); });
    };
    /**
     * @param {?} futureNode
     * @param {?} currNode
     * @param {?} parentOutletMap
     * @param {?} futurePath
     * @return {?}
     */
    PreActivation.prototype.traverseRoutes = function (futureNode, currNode, parentOutletMap, futurePath) {
        var /** @type {?} */ future = futureNode.value;
        var /** @type {?} */ curr = currNode ? currNode.value : null;
        var /** @type {?} */ outlet = parentOutletMap ? parentOutletMap._outlets[futureNode.value.outlet] : null;
        // reusing the node
        if (curr && future._routeConfig === curr._routeConfig) {
            if (this.shouldRunGuardsAndResolvers(curr, future, /** @type {?} */ ((future._routeConfig)).runGuardsAndResolvers)) {
                this.canActivateChecks.push(new CanActivate(futurePath));
                this.canDeactivateChecks.push(new CanDeactivate(/** @type {?} */ ((outlet)).component, curr));
            }
            else {
                // we need to set the data
                future.data = curr.data;
                future._resolvedData = curr._resolvedData;
            }
            // If we have a component, we need to go through an outlet.
            if (future.component) {
                this.traverseChildRoutes(futureNode, currNode, outlet ? outlet.outletMap : null, futurePath);
            }
            else {
                this.traverseChildRoutes(futureNode, currNode, parentOutletMap, futurePath);
            }
        }
        else {
            if (curr) {
                this.deactiveRouteAndItsChildren(currNode, outlet);
            }
            this.canActivateChecks.push(new CanActivate(futurePath));
            // If we have a component, we need to go through an outlet.
            if (future.component) {
                this.traverseChildRoutes(futureNode, null, outlet ? outlet.outletMap : null, futurePath);
            }
            else {
                this.traverseChildRoutes(futureNode, null, parentOutletMap, futurePath);
            }
        }
    };
    /**
     * @param {?} curr
     * @param {?} future
     * @param {?} mode
     * @return {?}
     */
    PreActivation.prototype.shouldRunGuardsAndResolvers = function (curr, future, mode) {
        switch (mode) {
            case 'always':
                return true;
            case 'paramsOrQueryParamsChange':
                return !equalParamsAndUrlSegments(curr, future) ||
                    !shallowEqual(curr.queryParams, future.queryParams);
            case 'paramsChange':
            default:
                return !equalParamsAndUrlSegments(curr, future);
        }
    };
    /**
     * @param {?} route
     * @param {?} outlet
     * @return {?}
     */
    PreActivation.prototype.deactiveRouteAndItsChildren = function (route, outlet) {
        var _this = this;
        var /** @type {?} */ prevChildren = nodeChildrenAsMap(route);
        var /** @type {?} */ r = route.value;
        forEach(prevChildren, function (v, k) {
            if (!r.component) {
                _this.deactiveRouteAndItsChildren(v, outlet);
            }
            else if (!!outlet) {
                _this.deactiveRouteAndItsChildren(v, outlet.outletMap._outlets[k]);
            }
            else {
                _this.deactiveRouteAndItsChildren(v, null);
            }
        });
        if (!r.component) {
            this.canDeactivateChecks.push(new CanDeactivate(null, r));
        }
        else if (outlet && outlet.isActivated) {
            this.canDeactivateChecks.push(new CanDeactivate(outlet.component, r));
        }
        else {
            this.canDeactivateChecks.push(new CanDeactivate(null, r));
        }
    };
    /**
     * @return {?}
     */
    PreActivation.prototype.runCanDeactivateChecks = function () {
        var _this = this;
        var /** @type {?} */ checks$ = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_rxjs_observable_from__["from"])(this.canDeactivateChecks);
        var /** @type {?} */ runningChecks$ = __WEBPACK_IMPORTED_MODULE_10_rxjs_operator_mergeMap__["mergeMap"].call(checks$, function (check) { return _this.runCanDeactivate(check.component, check.route); });
        return __WEBPACK_IMPORTED_MODULE_7_rxjs_operator_every__["every"].call(runningChecks$, function (result) { return result === true; });
    };
    /**
     * @return {?}
     */
    PreActivation.prototype.runCanActivateChecks = function () {
        var _this = this;
        var /** @type {?} */ checks$ = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_rxjs_observable_from__["from"])(this.canActivateChecks);
        var /** @type {?} */ runningChecks$ = __WEBPACK_IMPORTED_MODULE_10_rxjs_operator_mergeMap__["mergeMap"].call(checks$, function (check) { return andObservables(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_rxjs_observable_from__["from"])([_this.runCanActivateChild(check.path), _this.runCanActivate(check.route)])); });
        return __WEBPACK_IMPORTED_MODULE_7_rxjs_operator_every__["every"].call(runningChecks$, function (result) { return result === true; });
    };
    /**
     * @param {?} future
     * @return {?}
     */
    PreActivation.prototype.runCanActivate = function (future) {
        var _this = this;
        var /** @type {?} */ canActivate = future._routeConfig ? future._routeConfig.canActivate : null;
        if (!canActivate || canActivate.length === 0)
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_rxjs_observable_of__["of"])(true);
        var /** @type {?} */ obs = __WEBPACK_IMPORTED_MODULE_9_rxjs_operator_map__["map"].call(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_rxjs_observable_from__["from"])(canActivate), function (c) {
            var /** @type {?} */ guard = _this.getToken(c, future);
            var /** @type {?} */ observable;
            if (guard.canActivate) {
                observable = wrapIntoObservable(guard.canActivate(future, _this.future));
            }
            else {
                observable = wrapIntoObservable(guard(future, _this.future));
            }
            return __WEBPACK_IMPORTED_MODULE_8_rxjs_operator_first__["first"].call(observable);
        });
        return andObservables(obs);
    };
    /**
     * @param {?} path
     * @return {?}
     */
    PreActivation.prototype.runCanActivateChild = function (path) {
        var _this = this;
        var /** @type {?} */ future = path[path.length - 1];
        var /** @type {?} */ canActivateChildGuards = path.slice(0, path.length - 1)
            .reverse()
            .map(function (p) { return _this.extractCanActivateChild(p); })
            .filter(function (_) { return _ !== null; });
        return andObservables(__WEBPACK_IMPORTED_MODULE_9_rxjs_operator_map__["map"].call(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_rxjs_observable_from__["from"])(canActivateChildGuards), function (d) {
            var /** @type {?} */ obs = __WEBPACK_IMPORTED_MODULE_9_rxjs_operator_map__["map"].call(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_rxjs_observable_from__["from"])(d.guards), function (c) {
                var /** @type {?} */ guard = _this.getToken(c, d.node);
                var /** @type {?} */ observable;
                if (guard.canActivateChild) {
                    observable = wrapIntoObservable(guard.canActivateChild(future, _this.future));
                }
                else {
                    observable = wrapIntoObservable(guard(future, _this.future));
                }
                return __WEBPACK_IMPORTED_MODULE_8_rxjs_operator_first__["first"].call(observable);
            });
            return andObservables(obs);
        }));
    };
    /**
     * @param {?} p
     * @return {?}
     */
    PreActivation.prototype.extractCanActivateChild = function (p) {
        var /** @type {?} */ canActivateChild = p._routeConfig ? p._routeConfig.canActivateChild : null;
        if (!canActivateChild || canActivateChild.length === 0)
            return null;
        return { node: p, guards: canActivateChild };
    };
    /**
     * @param {?} component
     * @param {?} curr
     * @return {?}
     */
    PreActivation.prototype.runCanDeactivate = function (component, curr) {
        var _this = this;
        var /** @type {?} */ canDeactivate = curr && curr._routeConfig ? curr._routeConfig.canDeactivate : null;
        if (!canDeactivate || canDeactivate.length === 0)
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_rxjs_observable_of__["of"])(true);
        var /** @type {?} */ canDeactivate$ = __WEBPACK_IMPORTED_MODULE_10_rxjs_operator_mergeMap__["mergeMap"].call(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_rxjs_observable_from__["from"])(canDeactivate), function (c) {
            var /** @type {?} */ guard = _this.getToken(c, curr);
            var /** @type {?} */ observable;
            if (guard.canDeactivate) {
                observable =
                    wrapIntoObservable(guard.canDeactivate(component, curr, _this.curr, _this.future));
            }
            else {
                observable = wrapIntoObservable(guard(component, curr, _this.curr, _this.future));
            }
            return __WEBPACK_IMPORTED_MODULE_8_rxjs_operator_first__["first"].call(observable);
        });
        return __WEBPACK_IMPORTED_MODULE_7_rxjs_operator_every__["every"].call(canDeactivate$, function (result) { return result === true; });
    };
    /**
     * @param {?} future
     * @return {?}
     */
    PreActivation.prototype.runResolve = function (future) {
        var /** @type {?} */ resolve = future._resolve;
        return __WEBPACK_IMPORTED_MODULE_9_rxjs_operator_map__["map"].call(this.resolveNode(resolve, future), function (resolvedData) {
            future._resolvedData = resolvedData;
            future.data = __assign({}, future.data, inheritedParamsDataResolve(future).resolve);
            return null;
        });
    };
    /**
     * @param {?} resolve
     * @param {?} future
     * @return {?}
     */
    PreActivation.prototype.resolveNode = function (resolve, future) {
        var _this = this;
        return waitForMap(resolve, function (k, v) {
            var /** @type {?} */ resolver = _this.getToken(v, future);
            return resolver.resolve ? wrapIntoObservable(resolver.resolve(future, _this.future)) :
                wrapIntoObservable(resolver(future, _this.future));
        });
    };
    /**
     * @param {?} token
     * @param {?} snapshot
     * @return {?}
     */
    PreActivation.prototype.getToken = function (token, snapshot) {
        var /** @type {?} */ config = closestLoadedConfig(snapshot);
        var /** @type {?} */ injector = config ? config.module.injector : this.moduleInjector;
        return injector.get(token);
    };
    return PreActivation;
}());
var ActivateRoutes = (function () {
    /**
     * @param {?} routeReuseStrategy
     * @param {?} futureState
     * @param {?} currState
     */
    function ActivateRoutes(routeReuseStrategy, futureState, currState) {
        this.routeReuseStrategy = routeReuseStrategy;
        this.futureState = futureState;
        this.currState = currState;
    }
    /**
     * @param {?} parentOutletMap
     * @return {?}
     */
    ActivateRoutes.prototype.activate = function (parentOutletMap) {
        var /** @type {?} */ futureRoot = this.futureState._root;
        var /** @type {?} */ currRoot = this.currState ? this.currState._root : null;
        this.deactivateChildRoutes(futureRoot, currRoot, parentOutletMap);
        advanceActivatedRoute(this.futureState.root);
        this.activateChildRoutes(futureRoot, currRoot, parentOutletMap);
    };
    /**
     * @param {?} futureNode
     * @param {?} currNode
     * @param {?} outletMap
     * @return {?}
     */
    ActivateRoutes.prototype.deactivateChildRoutes = function (futureNode, currNode, outletMap) {
        var _this = this;
        var /** @type {?} */ prevChildren = nodeChildrenAsMap(currNode);
        futureNode.children.forEach(function (c) {
            _this.deactivateRoutes(c, prevChildren[c.value.outlet], outletMap);
            delete prevChildren[c.value.outlet];
        });
        forEach(prevChildren, function (v, k) { return _this.deactiveRouteAndItsChildren(v, outletMap); });
    };
    /**
     * @param {?} futureNode
     * @param {?} currNode
     * @param {?} outletMap
     * @return {?}
     */
    ActivateRoutes.prototype.activateChildRoutes = function (futureNode, currNode, outletMap) {
        var _this = this;
        var /** @type {?} */ prevChildren = nodeChildrenAsMap(currNode);
        futureNode.children.forEach(function (c) { _this.activateRoutes(c, prevChildren[c.value.outlet], outletMap); });
    };
    /**
     * @param {?} futureNode
     * @param {?} currNode
     * @param {?} parentOutletMap
     * @return {?}
     */
    ActivateRoutes.prototype.deactivateRoutes = function (futureNode, currNode, parentOutletMap) {
        var /** @type {?} */ future = futureNode.value;
        var /** @type {?} */ curr = currNode ? currNode.value : null;
        // reusing the node
        if (future === curr) {
            // If we have a normal route, we need to go through an outlet.
            if (future.component) {
                var /** @type {?} */ outlet = getOutlet(parentOutletMap, future);
                this.deactivateChildRoutes(futureNode, currNode, outlet.outletMap);
            }
            else {
                this.deactivateChildRoutes(futureNode, currNode, parentOutletMap);
            }
        }
        else {
            if (curr) {
                this.deactiveRouteAndItsChildren(currNode, parentOutletMap);
            }
        }
    };
    /**
     * @param {?} futureNode
     * @param {?} currNode
     * @param {?} parentOutletMap
     * @return {?}
     */
    ActivateRoutes.prototype.activateRoutes = function (futureNode, currNode, parentOutletMap) {
        var /** @type {?} */ future = futureNode.value;
        var /** @type {?} */ curr = currNode ? currNode.value : null;
        // reusing the node
        if (future === curr) {
            // advance the route to push the parameters
            advanceActivatedRoute(future);
            // If we have a normal route, we need to go through an outlet.
            if (future.component) {
                var /** @type {?} */ outlet = getOutlet(parentOutletMap, future);
                this.activateChildRoutes(futureNode, currNode, outlet.outletMap);
            }
            else {
                this.activateChildRoutes(futureNode, currNode, parentOutletMap);
            }
        }
        else {
            // if we have a normal route, we need to advance the route
            // and place the component into the outlet. After that recurse.
            if (future.component) {
                advanceActivatedRoute(future);
                var /** @type {?} */ outlet = getOutlet(parentOutletMap, futureNode.value);
                if (this.routeReuseStrategy.shouldAttach(future.snapshot)) {
                    var /** @type {?} */ stored = ((this.routeReuseStrategy.retrieve(future.snapshot)));
                    this.routeReuseStrategy.store(future.snapshot, null);
                    outlet.attach(stored.componentRef, stored.route.value);
                    advanceActivatedRouteNodeAndItsChildren(stored.route);
                }
                else {
                    var /** @type {?} */ outletMap = new RouterOutletMap();
                    this.placeComponentIntoOutlet(outletMap, future, outlet);
                    this.activateChildRoutes(futureNode, null, outletMap);
                }
            }
            else {
                advanceActivatedRoute(future);
                this.activateChildRoutes(futureNode, null, parentOutletMap);
            }
        }
    };
    /**
     * @param {?} outletMap
     * @param {?} future
     * @param {?} outlet
     * @return {?}
     */
    ActivateRoutes.prototype.placeComponentIntoOutlet = function (outletMap, future, outlet) {
        var /** @type {?} */ config = parentLoadedConfig(future.snapshot);
        var /** @type {?} */ cmpFactoryResolver = config ? config.module.componentFactoryResolver : null;
        outlet.activateWith(future, cmpFactoryResolver, outletMap);
    };
    /**
     * @param {?} route
     * @param {?} parentOutletMap
     * @return {?}
     */
    ActivateRoutes.prototype.deactiveRouteAndItsChildren = function (route, parentOutletMap) {
        if (this.routeReuseStrategy.shouldDetach(route.value.snapshot)) {
            this.detachAndStoreRouteSubtree(route, parentOutletMap);
        }
        else {
            this.deactiveRouteAndOutlet(route, parentOutletMap);
        }
    };
    /**
     * @param {?} route
     * @param {?} parentOutletMap
     * @return {?}
     */
    ActivateRoutes.prototype.detachAndStoreRouteSubtree = function (route, parentOutletMap) {
        var /** @type {?} */ outlet = getOutlet(parentOutletMap, route.value);
        var /** @type {?} */ componentRef = outlet.detach();
        this.routeReuseStrategy.store(route.value.snapshot, { componentRef: componentRef, route: route });
    };
    /**
     * @param {?} route
     * @param {?} parentOutletMap
     * @return {?}
     */
    ActivateRoutes.prototype.deactiveRouteAndOutlet = function (route, parentOutletMap) {
        var _this = this;
        var /** @type {?} */ prevChildren = nodeChildrenAsMap(route);
        var /** @type {?} */ outlet = null;
        // getOutlet throws when cannot find the right outlet,
        // which can happen if an outlet was in an NgIf and was removed
        try {
            outlet = getOutlet(parentOutletMap, route.value);
        }
        catch (e) {
            return;
        }
        var /** @type {?} */ childOutletMap = outlet.outletMap;
        forEach(prevChildren, function (v, k) {
            if (route.value.component) {
                _this.deactiveRouteAndItsChildren(v, childOutletMap);
            }
            else {
                _this.deactiveRouteAndItsChildren(v, parentOutletMap);
            }
        });
        if (outlet && outlet.isActivated) {
            outlet.deactivate();
        }
    };
    return ActivateRoutes;
}());
/**
 * @param {?} node
 * @return {?}
 */
function advanceActivatedRouteNodeAndItsChildren(node) {
    advanceActivatedRoute(node.value);
    node.children.forEach(advanceActivatedRouteNodeAndItsChildren);
}
/**
 * @param {?} snapshot
 * @return {?}
 */
function parentLoadedConfig(snapshot) {
    for (var /** @type {?} */ s = snapshot.parent; s; s = s.parent) {
        var /** @type {?} */ route = s._routeConfig;
        if (route && route._loadedConfig)
            return route._loadedConfig;
        if (route && route.component)
            return null;
    }
    return null;
}
/**
 * @param {?} snapshot
 * @return {?}
 */
function closestLoadedConfig(snapshot) {
    if (!snapshot)
        return null;
    for (var /** @type {?} */ s = snapshot.parent; s; s = s.parent) {
        var /** @type {?} */ route = s._routeConfig;
        if (route && route._loadedConfig)
            return route._loadedConfig;
    }
    return null;
}
/**
 * @template T
 * @param {?} node
 * @return {?}
 */
function nodeChildrenAsMap(node) {
    var /** @type {?} */ map$$1 = {};
    if (node) {
        node.children.forEach(function (child) { return map$$1[child.value.outlet] = child; });
    }
    return map$$1;
}
/**
 * @param {?} outletMap
 * @param {?} route
 * @return {?}
 */
function getOutlet(outletMap, route) {
    var /** @type {?} */ outlet = outletMap._outlets[route.outlet];
    if (!outlet) {
        var /** @type {?} */ componentName = ((route.component)).name;
        if (route.outlet === PRIMARY_OUTLET) {
            throw new Error("Cannot find primary outlet to load '" + componentName + "'");
        }
        else {
            throw new Error("Cannot find the outlet " + route.outlet + " to load '" + componentName + "'");
        }
    }
    return outlet;
}
/**
 * @param {?} commands
 * @return {?}
 */
function validateCommands(commands) {
    for (var /** @type {?} */ i = 0; i < commands.length; i++) {
        var /** @type {?} */ cmd = commands[i];
        if (cmd == null) {
            throw new Error("The requested path contains " + cmd + " segment at index " + i);
        }
    }
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * \@whatItDoes Lets you link to specific parts of your app.
 *
 * \@howToUse
 *
 * Consider the following route configuration:
 * `[{ path: 'user/:name', component: UserCmp }]`
 *
 * When linking to this `user/:name` route, you can write:
 * `<a routerLink='/user/bob'>link to user component</a>`
 *
 * \@description
 *
 * The RouterLink directives let you link to specific parts of your app.
 *
 * When the link is static, you can use the directive as follows:
 * `<a routerLink="/user/bob">link to user component</a>`
 *
 * If you use dynamic values to generate the link, you can pass an array of path
 * segments, followed by the params for each segment.
 *
 * For instance `['/team', teamId, 'user', userName, {details: true}]`
 * means that we want to generate a link to `/team/11/user/bob;details=true`.
 *
 * Multiple static segments can be merged into one
 * (e.g., `['/team/11/user', userName, {details: true}]`).
 *
 * The first segment name can be prepended with `/`, `./`, or `../`:
 * * If the first segment begins with `/`, the router will look up the route from the root of the
 *   app.
 * * If the first segment begins with `./`, or doesn't begin with a slash, the router will
 *   instead look in the children of the current activated route.
 * * And if the first segment begins with `../`, the router will go up one level.
 *
 * You can set query params and fragment as follows:
 *
 * ```
 * <a [routerLink]="['/user/bob']" [queryParams]="{debug: true}" fragment="education">
 *   link to user component
 * </a>
 * ```
 * RouterLink will use these to generate this link: `/user/bob#education?debug=true`.
 *
 * (Deprecated in v4.0.0 use `queryParamsHandling` instead) You can also tell the
 * directive to preserve the current query params and fragment:
 *
 * ```
 * <a [routerLink]="['/user/bob']" preserveQueryParams preserveFragment>
 *   link to user component
 * </a>
 * ```
 *
 * You can tell the directive to how to handle queryParams, available options are:
 *  - 'merge' merge the queryParams into the current queryParams
 *  - 'preserve' prserve the current queryParams
 *  - default / '' use the queryParams only
 *  same options for {\@link NavigationExtras.queryParamsHandling}
 *
 * ```
 * <a [routerLink]="['/user/bob']" [queryParams]="{debug: true}" queryParamsHandling="merge">
 *   link to user component
 * </a>
 * ```
 *
 * The router link directive always treats the provided input as a delta to the current url.
 *
 * For instance, if the current url is `/user/(box//aux:team)`.
 *
 * Then the following link `<a [routerLink]="['/user/jim']">Jim</a>` will generate the link
 * `/user/(jim//aux:team)`.
 *
 * \@ngModule RouterModule
 *
 * See {\@link Router.createUrlTree} for more information.
 *
 * \@stable
 */
var RouterLink = (function () {
    /**
     * @param {?} router
     * @param {?} route
     * @param {?} tabIndex
     * @param {?} renderer
     * @param {?} el
     */
    function RouterLink(router, route, tabIndex, renderer, el) {
        this.router = router;
        this.route = route;
        this.commands = [];
        if (tabIndex == null) {
            renderer.setElementAttribute(el.nativeElement, 'tabindex', '0');
        }
    }
    Object.defineProperty(RouterLink.prototype, "routerLink", {
        /**
         * @param {?} commands
         * @return {?}
         */
        set: function (commands) {
            if (commands != null) {
                this.commands = Array.isArray(commands) ? commands : [commands];
            }
            else {
                this.commands = [];
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RouterLink.prototype, "preserveQueryParams", {
        /**
         * @deprecated 4.0.0 use `queryParamsHandling` instead.
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["isDevMode"])() && (console) && (console.warn)) {
                console.warn('preserveQueryParams is deprecated!, use queryParamsHandling instead.');
            }
            this.preserve = value;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    RouterLink.prototype.onClick = function () {
        var /** @type {?} */ extras = {
            skipLocationChange: attrBoolValue(this.skipLocationChange),
            replaceUrl: attrBoolValue(this.replaceUrl),
        };
        this.router.navigateByUrl(this.urlTree, extras);
        return true;
    };
    Object.defineProperty(RouterLink.prototype, "urlTree", {
        /**
         * @return {?}
         */
        get: function () {
            return this.router.createUrlTree(this.commands, {
                relativeTo: this.route,
                queryParams: this.queryParams,
                fragment: this.fragment,
                preserveQueryParams: attrBoolValue(this.preserve),
                queryParamsHandling: this.queryParamsHandling,
                preserveFragment: attrBoolValue(this.preserveFragment),
            });
        },
        enumerable: true,
        configurable: true
    });
    return RouterLink;
}());
RouterLink.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"], args: [{ selector: ':not(a)[routerLink]' },] },
];
/**
 * @nocollapse
 */
RouterLink.ctorParameters = function () { return [
    { type: Router, },
    { type: ActivatedRoute, },
    { type: undefined, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Attribute"], args: ['tabindex',] },] },
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Renderer"], },
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["ElementRef"], },
]; };
RouterLink.propDecorators = {
    'queryParams': [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"] },],
    'fragment': [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"] },],
    'queryParamsHandling': [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"] },],
    'preserveFragment': [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"] },],
    'skipLocationChange': [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"] },],
    'replaceUrl': [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"] },],
    'routerLink': [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"] },],
    'preserveQueryParams': [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"] },],
    'onClick': [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["HostListener"], args: ['click',] },],
};
/**
 * \@whatItDoes Lets you link to specific parts of your app.
 *
 * See {\@link RouterLink} for more information.
 *
 * \@ngModule RouterModule
 *
 * \@stable
 */
var RouterLinkWithHref = (function () {
    /**
     * @param {?} router
     * @param {?} route
     * @param {?} locationStrategy
     */
    function RouterLinkWithHref(router, route, locationStrategy) {
        var _this = this;
        this.router = router;
        this.route = route;
        this.locationStrategy = locationStrategy;
        this.commands = [];
        this.subscription = router.events.subscribe(function (s) {
            if (s instanceof NavigationEnd) {
                _this.updateTargetUrlAndHref();
            }
        });
    }
    Object.defineProperty(RouterLinkWithHref.prototype, "routerLink", {
        /**
         * @param {?} commands
         * @return {?}
         */
        set: function (commands) {
            if (commands != null) {
                this.commands = Array.isArray(commands) ? commands : [commands];
            }
            else {
                this.commands = [];
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RouterLinkWithHref.prototype, "preserveQueryParams", {
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["isDevMode"])() && (console) && (console.warn)) {
                console.warn('preserveQueryParams is deprecated, use queryParamsHandling instead.');
            }
            this.preserve = value;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} changes
     * @return {?}
     */
    RouterLinkWithHref.prototype.ngOnChanges = function (changes) { this.updateTargetUrlAndHref(); };
    /**
     * @return {?}
     */
    RouterLinkWithHref.prototype.ngOnDestroy = function () { this.subscription.unsubscribe(); };
    /**
     * @param {?} button
     * @param {?} ctrlKey
     * @param {?} metaKey
     * @return {?}
     */
    RouterLinkWithHref.prototype.onClick = function (button, ctrlKey, metaKey) {
        if (button !== 0 || ctrlKey || metaKey) {
            return true;
        }
        if (typeof this.target === 'string' && this.target != '_self') {
            return true;
        }
        var /** @type {?} */ extras = {
            skipLocationChange: attrBoolValue(this.skipLocationChange),
            replaceUrl: attrBoolValue(this.replaceUrl),
        };
        this.router.navigateByUrl(this.urlTree, extras);
        return false;
    };
    /**
     * @return {?}
     */
    RouterLinkWithHref.prototype.updateTargetUrlAndHref = function () {
        this.href = this.locationStrategy.prepareExternalUrl(this.router.serializeUrl(this.urlTree));
    };
    Object.defineProperty(RouterLinkWithHref.prototype, "urlTree", {
        /**
         * @return {?}
         */
        get: function () {
            return this.router.createUrlTree(this.commands, {
                relativeTo: this.route,
                queryParams: this.queryParams,
                fragment: this.fragment,
                preserveQueryParams: attrBoolValue(this.preserve),
                queryParamsHandling: this.queryParamsHandling,
                preserveFragment: attrBoolValue(this.preserveFragment),
            });
        },
        enumerable: true,
        configurable: true
    });
    return RouterLinkWithHref;
}());
RouterLinkWithHref.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"], args: [{ selector: 'a[routerLink]' },] },
];
/**
 * @nocollapse
 */
RouterLinkWithHref.ctorParameters = function () { return [
    { type: Router, },
    { type: ActivatedRoute, },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_common__["LocationStrategy"], },
]; };
RouterLinkWithHref.propDecorators = {
    'target': [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["HostBinding"], args: ['attr.target',] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"] },],
    'queryParams': [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"] },],
    'fragment': [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"] },],
    'queryParamsHandling': [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"] },],
    'preserveFragment': [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"] },],
    'skipLocationChange': [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"] },],
    'replaceUrl': [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"] },],
    'href': [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["HostBinding"] },],
    'routerLink': [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"] },],
    'preserveQueryParams': [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"] },],
    'onClick': [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["HostListener"], args: ['click', ['$event.button', '$event.ctrlKey', '$event.metaKey'],] },],
};
/**
 * @param {?} s
 * @return {?}
 */
function attrBoolValue(s) {
    return s === '' || !!s;
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * \@whatItDoes Lets you add a CSS class to an element when the link's route becomes active.
 *
 * \@howToUse
 *
 * ```
 * <a routerLink="/user/bob" routerLinkActive="active-link">Bob</a>
 * ```
 *
 * \@description
 *
 * The RouterLinkActive directive lets you add a CSS class to an element when the link's route
 * becomes active.
 *
 * Consider the following example:
 *
 * ```
 * <a routerLink="/user/bob" routerLinkActive="active-link">Bob</a>
 * ```
 *
 * When the url is either '/user' or '/user/bob', the active-link class will
 * be added to the `a` tag. If the url changes, the class will be removed.
 *
 * You can set more than one class, as follows:
 *
 * ```
 * <a routerLink="/user/bob" routerLinkActive="class1 class2">Bob</a>
 * <a routerLink="/user/bob" [routerLinkActive]="['class1', 'class2']">Bob</a>
 * ```
 *
 * You can configure RouterLinkActive by passing `exact: true`. This will add the classes
 * only when the url matches the link exactly.
 *
 * ```
 * <a routerLink="/user/bob" routerLinkActive="active-link" [routerLinkActiveOptions]="{exact:
 * true}">Bob</a>
 * ```
 *
 * You can assign the RouterLinkActive instance to a template variable and directly check
 * the `isActive` status.
 * ```
 * <a routerLink="/user/bob" routerLinkActive #rla="routerLinkActive">
 *   Bob {{ rla.isActive ? '(already open)' : ''}}
 * </a>
 * ```
 *
 * Finally, you can apply the RouterLinkActive directive to an ancestor of a RouterLink.
 *
 * ```
 * <div routerLinkActive="active-link" [routerLinkActiveOptions]="{exact: true}">
 *   <a routerLink="/user/jim">Jim</a>
 *   <a routerLink="/user/bob">Bob</a>
 * </div>
 * ```
 *
 * This will set the active-link class on the div tag if the url is either '/user/jim' or
 * '/user/bob'.
 *
 * \@ngModule RouterModule
 *
 * \@stable
 */
var RouterLinkActive = (function () {
    /**
     * @param {?} router
     * @param {?} element
     * @param {?} renderer
     * @param {?} cdr
     */
    function RouterLinkActive(router, element, renderer, cdr) {
        var _this = this;
        this.router = router;
        this.element = element;
        this.renderer = renderer;
        this.cdr = cdr;
        this.classes = [];
        this.active = false;
        this.routerLinkActiveOptions = { exact: false };
        this.subscription = router.events.subscribe(function (s) {
            if (s instanceof NavigationEnd) {
                _this.update();
            }
        });
    }
    Object.defineProperty(RouterLinkActive.prototype, "isActive", {
        /**
         * @return {?}
         */
        get: function () { return this.active; },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    RouterLinkActive.prototype.ngAfterContentInit = function () {
        var _this = this;
        this.links.changes.subscribe(function (_) { return _this.update(); });
        this.linksWithHrefs.changes.subscribe(function (_) { return _this.update(); });
        this.update();
    };
    Object.defineProperty(RouterLinkActive.prototype, "routerLinkActive", {
        /**
         * @param {?} data
         * @return {?}
         */
        set: function (data) {
            var /** @type {?} */ classes = Array.isArray(data) ? data : data.split(' ');
            this.classes = classes.filter(function (c) { return !!c; });
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} changes
     * @return {?}
     */
    RouterLinkActive.prototype.ngOnChanges = function (changes) { this.update(); };
    /**
     * @return {?}
     */
    RouterLinkActive.prototype.ngOnDestroy = function () { this.subscription.unsubscribe(); };
    /**
     * @return {?}
     */
    RouterLinkActive.prototype.update = function () {
        var _this = this;
        if (!this.links || !this.linksWithHrefs || !this.router.navigated)
            return;
        var /** @type {?} */ hasActiveLinks = this.hasActiveLinks();
        // react only when status has changed to prevent unnecessary dom updates
        if (this.active !== hasActiveLinks) {
            this.classes.forEach(function (c) { return _this.renderer.setElementClass(_this.element.nativeElement, c, hasActiveLinks); });
            Promise.resolve(hasActiveLinks).then(function (active) { return _this.active = active; });
        }
    };
    /**
     * @param {?} router
     * @return {?}
     */
    RouterLinkActive.prototype.isLinkActive = function (router) {
        var _this = this;
        return function (link) { return router.isActive(link.urlTree, _this.routerLinkActiveOptions.exact); };
    };
    /**
     * @return {?}
     */
    RouterLinkActive.prototype.hasActiveLinks = function () {
        return this.links.some(this.isLinkActive(this.router)) ||
            this.linksWithHrefs.some(this.isLinkActive(this.router));
    };
    return RouterLinkActive;
}());
RouterLinkActive.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"], args: [{
                selector: '[routerLinkActive]',
                exportAs: 'routerLinkActive',
            },] },
];
/**
 * @nocollapse
 */
RouterLinkActive.ctorParameters = function () { return [
    { type: Router, },
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["ElementRef"], },
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Renderer"], },
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["ChangeDetectorRef"], },
]; };
RouterLinkActive.propDecorators = {
    'links': [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["ContentChildren"], args: [RouterLink, { descendants: true },] },],
    'linksWithHrefs': [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["ContentChildren"], args: [RouterLinkWithHref, { descendants: true },] },],
    'routerLinkActiveOptions': [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"] },],
    'routerLinkActive': [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Input"] },],
};
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * \@whatItDoes Acts as a placeholder that Angular dynamically fills based on the current router
 * state.
 *
 * \@howToUse
 *
 * ```
 * <router-outlet></router-outlet>
 * <router-outlet name='left'></router-outlet>
 * <router-outlet name='right'></router-outlet>
 * ```
 *
 * A router outlet will emit an activate event any time a new component is being instantiated,
 * and a deactivate event when it is being destroyed.
 *
 * ```
 * <router-outlet
 *   (activate)='onActivate($event)'
 *   (deactivate)='onDeactivate($event)'></router-outlet>
 * ```
 * \@ngModule RouterModule
 *
 * \@stable
 */
var RouterOutlet = (function () {
    /**
     * @param {?} parentOutletMap
     * @param {?} location
     * @param {?} resolver
     * @param {?} name
     */
    function RouterOutlet(parentOutletMap, location, resolver, name) {
        this.parentOutletMap = parentOutletMap;
        this.location = location;
        this.resolver = resolver;
        this.name = name;
        this.activateEvents = new __WEBPACK_IMPORTED_MODULE_1__angular_core__["EventEmitter"]();
        this.deactivateEvents = new __WEBPACK_IMPORTED_MODULE_1__angular_core__["EventEmitter"]();
        parentOutletMap.registerOutlet(name ? name : PRIMARY_OUTLET, this);
    }
    /**
     * @return {?}
     */
    RouterOutlet.prototype.ngOnDestroy = function () { this.parentOutletMap.removeOutlet(this.name ? this.name : PRIMARY_OUTLET); };
    Object.defineProperty(RouterOutlet.prototype, "locationInjector", {
        /**
         * @deprecated since v4 *
         * @return {?}
         */
        get: function () { return this.location.injector; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RouterOutlet.prototype, "locationFactoryResolver", {
        /**
         * @deprecated since v4 *
         * @return {?}
         */
        get: function () { return this.resolver; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RouterOutlet.prototype, "isActivated", {
        /**
         * @return {?}
         */
        get: function () { return !!this.activated; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RouterOutlet.prototype, "component", {
        /**
         * @return {?}
         */
        get: function () {
            if (!this.activated)
                throw new Error('Outlet is not activated');
            return this.activated.instance;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RouterOutlet.prototype, "activatedRoute", {
        /**
         * @return {?}
         */
        get: function () {
            if (!this.activated)
                throw new Error('Outlet is not activated');
            return this._activatedRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    RouterOutlet.prototype.detach = function () {
        if (!this.activated)
            throw new Error('Outlet is not activated');
        this.location.detach();
        var /** @type {?} */ r = this.activated;
        this.activated = ((null));
        this._activatedRoute = ((null));
        return r;
    };
    /**
     * @param {?} ref
     * @param {?} activatedRoute
     * @return {?}
     */
    RouterOutlet.prototype.attach = function (ref, activatedRoute) {
        this.activated = ref;
        this._activatedRoute = activatedRoute;
        this.location.insert(ref.hostView);
    };
    /**
     * @return {?}
     */
    RouterOutlet.prototype.deactivate = function () {
        if (this.activated) {
            var /** @type {?} */ c = this.component;
            this.activated.destroy();
            this.activated = ((null));
            this._activatedRoute = ((null));
            this.deactivateEvents.emit(c);
        }
    };
    /**
     * @deprecated since v4, use {\@link activateWith}
     * @param {?} activatedRoute
     * @param {?} resolver
     * @param {?} injector
     * @param {?} providers
     * @param {?} outletMap
     * @return {?}
     */
    RouterOutlet.prototype.activate = function (activatedRoute, resolver, injector, providers, outletMap) {
        if (this.isActivated) {
            throw new Error('Cannot activate an already activated outlet');
        }
        this.outletMap = outletMap;
        this._activatedRoute = activatedRoute;
        var /** @type {?} */ snapshot = activatedRoute._futureSnapshot;
        var /** @type {?} */ component = (((snapshot._routeConfig)).component);
        var /** @type {?} */ factory = ((resolver.resolveComponentFactory(component)));
        var /** @type {?} */ inj = __WEBPACK_IMPORTED_MODULE_1__angular_core__["ReflectiveInjector"].fromResolvedProviders(providers, injector);
        this.activated = this.location.createComponent(factory, this.location.length, inj, []);
        this.activated.changeDetectorRef.detectChanges();
        this.activateEvents.emit(this.activated.instance);
    };
    /**
     * @param {?} activatedRoute
     * @param {?} resolver
     * @param {?} outletMap
     * @return {?}
     */
    RouterOutlet.prototype.activateWith = function (activatedRoute, resolver, outletMap) {
        if (this.isActivated) {
            throw new Error('Cannot activate an already activated outlet');
        }
        this.outletMap = outletMap;
        this._activatedRoute = activatedRoute;
        var /** @type {?} */ snapshot = activatedRoute._futureSnapshot;
        var /** @type {?} */ component = (((snapshot._routeConfig)).component);
        resolver = resolver || this.resolver;
        var /** @type {?} */ factory = ((resolver.resolveComponentFactory(component)));
        var /** @type {?} */ injector = new OutletInjector(activatedRoute, outletMap, this.location.injector);
        this.activated = this.location.createComponent(factory, this.location.length, injector, []);
        this.activated.changeDetectorRef.detectChanges();
        this.activateEvents.emit(this.activated.instance);
    };
    return RouterOutlet;
}());
RouterOutlet.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Directive"], args: [{ selector: 'router-outlet' },] },
];
/**
 * @nocollapse
 */
RouterOutlet.ctorParameters = function () { return [
    { type: RouterOutletMap, },
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["ViewContainerRef"], },
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["ComponentFactoryResolver"], },
    { type: undefined, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Attribute"], args: ['name',] },] },
]; };
RouterOutlet.propDecorators = {
    'activateEvents': [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Output"], args: ['activate',] },],
    'deactivateEvents': [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Output"], args: ['deactivate',] },],
};
var OutletInjector = (function () {
    /**
     * @param {?} route
     * @param {?} map
     * @param {?} parent
     */
    function OutletInjector(route, map$$1, parent) {
        this.route = route;
        this.map = map$$1;
        this.parent = parent;
    }
    /**
     * @param {?} token
     * @param {?=} notFoundValue
     * @return {?}
     */
    OutletInjector.prototype.get = function (token, notFoundValue) {
        if (token === ActivatedRoute) {
            return this.route;
        }
        if (token === RouterOutletMap) {
            return this.map;
        }
        return this.parent.get(token, notFoundValue);
    };
    return OutletInjector;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * \@whatItDoes Provides a way to customize when activated routes get reused.
 *
 * \@experimental
 * @abstract
 */
var RouteReuseStrategy = (function () {
    function RouteReuseStrategy() {
    }
    /**
     * Determines if this route (and its subtree) should be detached to be reused later
     * @abstract
     * @param {?} route
     * @return {?}
     */
    RouteReuseStrategy.prototype.shouldDetach = function (route) { };
    /**
     * Stores the detached route
     * @abstract
     * @param {?} route
     * @param {?} handle
     * @return {?}
     */
    RouteReuseStrategy.prototype.store = function (route, handle) { };
    /**
     * Determines if this route (and its subtree) should be reattached
     * @abstract
     * @param {?} route
     * @return {?}
     */
    RouteReuseStrategy.prototype.shouldAttach = function (route) { };
    /**
     * Retrieves the previously stored route
     * @abstract
     * @param {?} route
     * @return {?}
     */
    RouteReuseStrategy.prototype.retrieve = function (route) { };
    /**
     * Determines if a route should be reused
     * @abstract
     * @param {?} future
     * @param {?} curr
     * @return {?}
     */
    RouteReuseStrategy.prototype.shouldReuseRoute = function (future, curr) { };
    return RouteReuseStrategy;
}());
/**
*@license
*Copyright Google Inc. All Rights Reserved.
*
*Use of this source code is governed by an MIT-style license that can be
*found in the LICENSE file at https://angular.io/license
*/
/**
 * \@whatItDoes Provides a preloading strategy.
 *
 * \@experimental
 * @abstract
 */
var PreloadingStrategy = (function () {
    function PreloadingStrategy() {
    }
    /**
     * @abstract
     * @param {?} route
     * @param {?} fn
     * @return {?}
     */
    PreloadingStrategy.prototype.preload = function (route, fn) { };
    return PreloadingStrategy;
}());
/**
 * \@whatItDoes Provides a preloading strategy that preloads all modules as quickly as possible.
 *
 * \@howToUse
 *
 * ```
 * RouteModule.forRoot(ROUTES, {preloadingStrategy: PreloadAllModules})
 * ```
 *
 * \@experimental
 */
var PreloadAllModules = (function () {
    function PreloadAllModules() {
    }
    /**
     * @param {?} route
     * @param {?} fn
     * @return {?}
     */
    PreloadAllModules.prototype.preload = function (route, fn) {
        return __WEBPACK_IMPORTED_MODULE_13_rxjs_operator_catch__["_catch"].call(fn(), function () { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_rxjs_observable_of__["of"])(null); });
    };
    return PreloadAllModules;
}());
/**
 * \@whatItDoes Provides a preloading strategy that does not preload any modules.
 *
 * \@description
 *
 * This strategy is enabled by default.
 *
 * \@experimental
 */
var NoPreloading = (function () {
    function NoPreloading() {
    }
    /**
     * @param {?} route
     * @param {?} fn
     * @return {?}
     */
    NoPreloading.prototype.preload = function (route, fn) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_rxjs_observable_of__["of"])(null); };
    return NoPreloading;
}());
/**
 * The preloader optimistically loads all router configurations to
 * make navigations into lazily-loaded sections of the application faster.
 *
 * The preloader runs in the background. When the router bootstraps, the preloader
 * starts listening to all navigation events. After every such event, the preloader
 * will check if any configurations can be loaded lazily.
 *
 * If a route is protected by `canLoad` guards, the preloaded will not load it.
 *
 * \@stable
 */
var RouterPreloader = (function () {
    /**
     * @param {?} router
     * @param {?} moduleLoader
     * @param {?} compiler
     * @param {?} injector
     * @param {?} preloadingStrategy
     */
    function RouterPreloader(router, moduleLoader, compiler, injector, preloadingStrategy) {
        this.router = router;
        this.injector = injector;
        this.preloadingStrategy = preloadingStrategy;
        var onStartLoad = function (r) { return router.triggerEvent(new RouteConfigLoadStart(r)); };
        var onEndLoad = function (r) { return router.triggerEvent(new RouteConfigLoadEnd(r)); };
        this.loader = new RouterConfigLoader(moduleLoader, compiler, onStartLoad, onEndLoad);
    }
    ;
    /**
     * @return {?}
     */
    RouterPreloader.prototype.setUpPreloading = function () {
        var _this = this;
        var /** @type {?} */ navigations$ = __WEBPACK_IMPORTED_MODULE_20_rxjs_operator_filter__["filter"].call(this.router.events, function (e) { return e instanceof NavigationEnd; });
        this.subscription = __WEBPACK_IMPORTED_MODULE_6_rxjs_operator_concatMap__["concatMap"].call(navigations$, function () { return _this.preload(); }).subscribe(function () { });
    };
    /**
     * @return {?}
     */
    RouterPreloader.prototype.preload = function () {
        var /** @type {?} */ ngModule = this.injector.get(__WEBPACK_IMPORTED_MODULE_1__angular_core__["NgModuleRef"]);
        return this.processRoutes(ngModule, this.router.config);
    };
    /**
     * @return {?}
     */
    RouterPreloader.prototype.ngOnDestroy = function () { this.subscription.unsubscribe(); };
    /**
     * @param {?} ngModule
     * @param {?} routes
     * @return {?}
     */
    RouterPreloader.prototype.processRoutes = function (ngModule, routes) {
        var /** @type {?} */ res = [];
        for (var _i = 0, routes_5 = routes; _i < routes_5.length; _i++) {
            var route = routes_5[_i];
            // we already have the config loaded, just recurse
            if (route.loadChildren && !route.canLoad && route._loadedConfig) {
                var /** @type {?} */ childConfig = route._loadedConfig;
                res.push(this.processRoutes(childConfig.module, childConfig.routes));
            }
            else if (route.loadChildren && !route.canLoad) {
                res.push(this.preloadConfig(ngModule, route));
            }
            else if (route.children) {
                res.push(this.processRoutes(ngModule, route.children));
            }
        }
        return __WEBPACK_IMPORTED_MODULE_18_rxjs_operator_mergeAll__["mergeAll"].call(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_rxjs_observable_from__["from"])(res));
    };
    /**
     * @param {?} ngModule
     * @param {?} route
     * @return {?}
     */
    RouterPreloader.prototype.preloadConfig = function (ngModule, route) {
        var _this = this;
        return this.preloadingStrategy.preload(route, function () {
            var /** @type {?} */ loaded$ = _this.loader.load(ngModule.injector, route);
            return __WEBPACK_IMPORTED_MODULE_10_rxjs_operator_mergeMap__["mergeMap"].call(loaded$, function (config) {
                route._loadedConfig = config;
                return _this.processRoutes(config.module, config.routes);
            });
        });
    };
    return RouterPreloader;
}());
RouterPreloader.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Injectable"] },
];
/**
 * @nocollapse
 */
RouterPreloader.ctorParameters = function () { return [
    { type: Router, },
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["NgModuleFactoryLoader"], },
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Compiler"], },
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Injector"], },
    { type: PreloadingStrategy, },
]; };
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * \@whatItDoes Contains a list of directives
 * \@stable
 */
var ROUTER_DIRECTIVES = [RouterOutlet, RouterLink, RouterLinkWithHref, RouterLinkActive];
/**
 * \@whatItDoes Is used in DI to configure the router.
 * \@stable
 */
var ROUTER_CONFIGURATION = new __WEBPACK_IMPORTED_MODULE_1__angular_core__["InjectionToken"]('ROUTER_CONFIGURATION');
/**
 * \@docsNotRequired
 */
var ROUTER_FORROOT_GUARD = new __WEBPACK_IMPORTED_MODULE_1__angular_core__["InjectionToken"]('ROUTER_FORROOT_GUARD');
var ROUTER_PROVIDERS = [
    __WEBPACK_IMPORTED_MODULE_0__angular_common__["Location"],
    { provide: UrlSerializer, useClass: DefaultUrlSerializer },
    {
        provide: Router,
        useFactory: setupRouter,
        deps: [
            __WEBPACK_IMPORTED_MODULE_1__angular_core__["ApplicationRef"], UrlSerializer, RouterOutletMap, __WEBPACK_IMPORTED_MODULE_0__angular_common__["Location"], __WEBPACK_IMPORTED_MODULE_1__angular_core__["Injector"], __WEBPACK_IMPORTED_MODULE_1__angular_core__["NgModuleFactoryLoader"],
            __WEBPACK_IMPORTED_MODULE_1__angular_core__["Compiler"], ROUTES, ROUTER_CONFIGURATION, [UrlHandlingStrategy, new __WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"]()],
            [RouteReuseStrategy, new __WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"]()]
        ]
    },
    RouterOutletMap,
    { provide: ActivatedRoute, useFactory: rootRoute, deps: [Router] },
    { provide: __WEBPACK_IMPORTED_MODULE_1__angular_core__["NgModuleFactoryLoader"], useClass: __WEBPACK_IMPORTED_MODULE_1__angular_core__["SystemJsNgModuleLoader"] },
    RouterPreloader,
    NoPreloading,
    PreloadAllModules,
    { provide: ROUTER_CONFIGURATION, useValue: { enableTracing: false } },
];
/**
 * @return {?}
 */
function routerNgProbeToken() {
    return new __WEBPACK_IMPORTED_MODULE_1__angular_core__["NgProbeToken"]('Router', Router);
}
/**
 * \@whatItDoes Adds router directives and providers.
 *
 * \@howToUse
 *
 * RouterModule can be imported multiple times: once per lazily-loaded bundle.
 * Since the router deals with a global shared resource--location, we cannot have
 * more than one router service active.
 *
 * That is why there are two ways to create the module: `RouterModule.forRoot` and
 * `RouterModule.forChild`.
 *
 * * `forRoot` creates a module that contains all the directives, the given routes, and the router
 *   service itself.
 * * `forChild` creates a module that contains all the directives and the given routes, but does not
 *   include the router service.
 *
 * When registered at the root, the module should be used as follows
 *
 * ```
 * \@NgModule({
 *   imports: [RouterModule.forRoot(ROUTES)]
 * })
 * class MyNgModule {}
 * ```
 *
 * For submodules and lazy loaded submodules the module should be used as follows:
 *
 * ```
 * \@NgModule({
 *   imports: [RouterModule.forChild(ROUTES)]
 * })
 * class MyNgModule {}
 * ```
 *
 * \@description
 *
 * Managing state transitions is one of the hardest parts of building applications. This is
 * especially true on the web, where you also need to ensure that the state is reflected in the URL.
 * In addition, we often want to split applications into multiple bundles and load them on demand.
 * Doing this transparently is not trivial.
 *
 * The Angular router solves these problems. Using the router, you can declaratively specify
 * application states, manage state transitions while taking care of the URL, and load bundles on
 * demand.
 *
 * [Read this developer guide](https://angular.io/docs/ts/latest/guide/router.html) to get an
 * overview of how the router should be used.
 *
 * \@stable
 */
var RouterModule = (function () {
    /**
     * @param {?} guard
     * @param {?} router
     */
    function RouterModule(guard, router) {
    }
    /**
     * Creates a module with all the router providers and directives. It also optionally sets up an
     * application listener to perform an initial navigation.
     *
     * Options:
     * * `enableTracing` makes the router log all its internal events to the console.
     * * `useHash` enables the location strategy that uses the URL fragment instead of the history
     * API.
     * * `initialNavigation` disables the initial navigation.
     * * `errorHandler` provides a custom error handler.
     * @param {?} routes
     * @param {?=} config
     * @return {?}
     */
    RouterModule.forRoot = function (routes, config) {
        return {
            ngModule: RouterModule,
            providers: [
                ROUTER_PROVIDERS,
                provideRoutes(routes),
                {
                    provide: ROUTER_FORROOT_GUARD,
                    useFactory: provideForRootGuard,
                    deps: [[Router, new __WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"](), new __WEBPACK_IMPORTED_MODULE_1__angular_core__["SkipSelf"]()]]
                },
                { provide: ROUTER_CONFIGURATION, useValue: config ? config : {} },
                {
                    provide: __WEBPACK_IMPORTED_MODULE_0__angular_common__["LocationStrategy"],
                    useFactory: provideLocationStrategy,
                    deps: [
                        __WEBPACK_IMPORTED_MODULE_0__angular_common__["PlatformLocation"], [new __WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"](__WEBPACK_IMPORTED_MODULE_0__angular_common__["APP_BASE_HREF"]), new __WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"]()], ROUTER_CONFIGURATION
                    ]
                },
                {
                    provide: PreloadingStrategy,
                    useExisting: config && config.preloadingStrategy ? config.preloadingStrategy :
                        NoPreloading
                },
                { provide: __WEBPACK_IMPORTED_MODULE_1__angular_core__["NgProbeToken"], multi: true, useFactory: routerNgProbeToken },
                provideRouterInitializer(),
            ],
        };
    };
    /**
     * Creates a module with all the router directives and a provider registering routes.
     * @param {?} routes
     * @return {?}
     */
    RouterModule.forChild = function (routes) {
        return { ngModule: RouterModule, providers: [provideRoutes(routes)] };
    };
    return RouterModule;
}());
RouterModule.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["NgModule"], args: [{ declarations: ROUTER_DIRECTIVES, exports: ROUTER_DIRECTIVES },] },
];
/**
 * @nocollapse
 */
RouterModule.ctorParameters = function () { return [
    { type: undefined, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"], args: [ROUTER_FORROOT_GUARD,] },] },
    { type: Router, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"] },] },
]; };
/**
 * @param {?} platformLocationStrategy
 * @param {?} baseHref
 * @param {?=} options
 * @return {?}
 */
function provideLocationStrategy(platformLocationStrategy, baseHref, options) {
    if (options === void 0) { options = {}; }
    return options.useHash ? new __WEBPACK_IMPORTED_MODULE_0__angular_common__["HashLocationStrategy"](platformLocationStrategy, baseHref) :
        new __WEBPACK_IMPORTED_MODULE_0__angular_common__["PathLocationStrategy"](platformLocationStrategy, baseHref);
}
/**
 * @param {?} router
 * @return {?}
 */
function provideForRootGuard(router) {
    if (router) {
        throw new Error("RouterModule.forRoot() called twice. Lazy loaded modules should use RouterModule.forChild() instead.");
    }
    return 'guarded';
}
/**
 * \@whatItDoes Registers routes.
 *
 * \@howToUse
 *
 * ```
 * \@NgModule({
 *   imports: [RouterModule.forChild(ROUTES)],
 *   providers: [provideRoutes(EXTRA_ROUTES)]
 * })
 * class MyNgModule {}
 * ```
 *
 * \@stable
 * @param {?} routes
 * @return {?}
 */
function provideRoutes(routes) {
    return [
        { provide: __WEBPACK_IMPORTED_MODULE_1__angular_core__["ANALYZE_FOR_ENTRY_COMPONENTS"], multi: true, useValue: routes },
        { provide: ROUTES, multi: true, useValue: routes },
    ];
}
/**
 * @param {?} ref
 * @param {?} urlSerializer
 * @param {?} outletMap
 * @param {?} location
 * @param {?} injector
 * @param {?} loader
 * @param {?} compiler
 * @param {?} config
 * @param {?=} opts
 * @param {?=} urlHandlingStrategy
 * @param {?=} routeReuseStrategy
 * @return {?}
 */
function setupRouter(ref, urlSerializer, outletMap, location, injector, loader, compiler, config, opts, urlHandlingStrategy, routeReuseStrategy) {
    if (opts === void 0) { opts = {}; }
    var /** @type {?} */ router = new Router(null, urlSerializer, outletMap, location, injector, loader, compiler, flatten(config));
    if (urlHandlingStrategy) {
        router.urlHandlingStrategy = urlHandlingStrategy;
    }
    if (routeReuseStrategy) {
        router.routeReuseStrategy = routeReuseStrategy;
    }
    if (opts.errorHandler) {
        router.errorHandler = opts.errorHandler;
    }
    if (opts.enableTracing) {
        var /** @type {?} */ dom_1 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19__angular_platform_browser__["ɵgetDOM"])();
        router.events.subscribe(function (e) {
            dom_1.logGroup("Router Event: " + ((e.constructor)).name);
            dom_1.log(e.toString());
            dom_1.log(e);
            dom_1.logGroupEnd();
        });
    }
    return router;
}
/**
 * @param {?} router
 * @return {?}
 */
function rootRoute(router) {
    return router.routerState.root;
}
/**
 * To initialize the router properly we need to do in two steps:
 *
 * We need to start the navigation in a APP_INITIALIZER to block the bootstrap if
 * a resolver or a guards executes asynchronously. Second, we need to actually run
 * activation in a BOOTSTRAP_LISTENER. We utilize the afterPreactivation
 * hook provided by the router to do that.
 *
 * The router navigation starts, reaches the point when preactivation is done, and then
 * pauses. It waits for the hook to be resolved. We then resolve it only in a bootstrap listener.
 */
var RouterInitializer = (function () {
    /**
     * @param {?} injector
     */
    function RouterInitializer(injector) {
        this.injector = injector;
        this.initNavigation = false;
        this.resultOfPreactivationDone = new __WEBPACK_IMPORTED_MODULE_3_rxjs_Subject__["Subject"]();
    }
    /**
     * @return {?}
     */
    RouterInitializer.prototype.appInitializer = function () {
        var _this = this;
        var /** @type {?} */ p = this.injector.get(__WEBPACK_IMPORTED_MODULE_0__angular_common__["LOCATION_INITIALIZED"], Promise.resolve(null));
        return p.then(function () {
            var /** @type {?} */ resolve = ((null));
            var /** @type {?} */ res = new Promise(function (r) { return resolve = r; });
            var /** @type {?} */ router = _this.injector.get(Router);
            var /** @type {?} */ opts = _this.injector.get(ROUTER_CONFIGURATION);
            if (_this.isLegacyDisabled(opts) || _this.isLegacyEnabled(opts)) {
                resolve(true);
            }
            else if (opts.initialNavigation === 'disabled') {
                router.setUpLocationChangeListener();
                resolve(true);
            }
            else if (opts.initialNavigation === 'enabled') {
                router.hooks.afterPreactivation = function () {
                    // only the initial navigation should be delayed
                    if (!_this.initNavigation) {
                        _this.initNavigation = true;
                        resolve(true);
                        return _this.resultOfPreactivationDone;
                    }
                    else {
                        return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_rxjs_observable_of__["of"])(null));
                    }
                };
                router.initialNavigation();
            }
            else {
                throw new Error("Invalid initialNavigation options: '" + opts.initialNavigation + "'");
            }
            return res;
        });
    };
    /**
     * @param {?} bootstrappedComponentRef
     * @return {?}
     */
    RouterInitializer.prototype.bootstrapListener = function (bootstrappedComponentRef) {
        var /** @type {?} */ opts = this.injector.get(ROUTER_CONFIGURATION);
        var /** @type {?} */ preloader = this.injector.get(RouterPreloader);
        var /** @type {?} */ router = this.injector.get(Router);
        var /** @type {?} */ ref = this.injector.get(__WEBPACK_IMPORTED_MODULE_1__angular_core__["ApplicationRef"]);
        if (bootstrappedComponentRef !== ref.components[0]) {
            return;
        }
        if (this.isLegacyEnabled(opts)) {
            router.initialNavigation();
        }
        else if (this.isLegacyDisabled(opts)) {
            router.setUpLocationChangeListener();
        }
        preloader.setUpPreloading();
        router.resetRootComponentType(ref.componentTypes[0]);
        this.resultOfPreactivationDone.next(/** @type {?} */ ((null)));
        this.resultOfPreactivationDone.complete();
    };
    /**
     * @param {?} opts
     * @return {?}
     */
    RouterInitializer.prototype.isLegacyEnabled = function (opts) {
        return opts.initialNavigation === 'legacy_enabled' || opts.initialNavigation === true ||
            opts.initialNavigation === undefined;
    };
    /**
     * @param {?} opts
     * @return {?}
     */
    RouterInitializer.prototype.isLegacyDisabled = function (opts) {
        return opts.initialNavigation === 'legacy_disabled' || opts.initialNavigation === false;
    };
    return RouterInitializer;
}());
RouterInitializer.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Injectable"] },
];
/**
 * @nocollapse
 */
RouterInitializer.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Injector"], },
]; };
/**
 * @param {?} r
 * @return {?}
 */
function getAppInitializer(r) {
    return r.appInitializer.bind(r);
}
/**
 * @param {?} r
 * @return {?}
 */
function getBootstrapListener(r) {
    return r.bootstrapListener.bind(r);
}
/**
 * A token for the router initializer that will be called after the app is bootstrapped.
 *
 * \@experimental
 */
var ROUTER_INITIALIZER = new __WEBPACK_IMPORTED_MODULE_1__angular_core__["InjectionToken"]('Router Initializer');
/**
 * @return {?}
 */
function provideRouterInitializer() {
    return [
        RouterInitializer,
        {
            provide: __WEBPACK_IMPORTED_MODULE_1__angular_core__["APP_INITIALIZER"],
            multi: true,
            useFactory: getAppInitializer,
            deps: [RouterInitializer]
        },
        { provide: ROUTER_INITIALIZER, useFactory: getBootstrapListener, deps: [RouterInitializer] },
        { provide: __WEBPACK_IMPORTED_MODULE_1__angular_core__["APP_BOOTSTRAP_LISTENER"], multi: true, useExisting: ROUTER_INITIALIZER },
    ];
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @module
 * @description
 * Entry point for all public APIs of the common package.
 */
/**
 * \@stable
 */
var VERSION = new __WEBPACK_IMPORTED_MODULE_1__angular_core__["Version"]('4.1.0');
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @module
 * @description
 * Entry point for all public APIs of the router package.
 */
// This file only reexports content of the `src` folder. Keep it that way.
/**
 * Generated bundle index. Do not edit.
 */

//# sourceMappingURL=router.es5.js.map


/***/ }),

/***/ "5pRa":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__("mmVS");
var async_1 = __webpack_require__("CGGv");
/**
 * @param scheduler
 * @return {Observable<Timestamp<any>>|WebSocketSubject<T>|Observable<T>}
 * @method timestamp
 * @owner Observable
 */
function timestamp(scheduler) {
    if (scheduler === void 0) { scheduler = async_1.async; }
    return this.lift(new TimestampOperator(scheduler));
}
exports.timestamp = timestamp;
var Timestamp = (function () {
    function Timestamp(value, timestamp) {
        this.value = value;
        this.timestamp = timestamp;
    }
    return Timestamp;
}());
exports.Timestamp = Timestamp;
;
var TimestampOperator = (function () {
    function TimestampOperator(scheduler) {
        this.scheduler = scheduler;
    }
    TimestampOperator.prototype.call = function (observer, source) {
        return source.subscribe(new TimestampSubscriber(observer, this.scheduler));
    };
    return TimestampOperator;
}());
var TimestampSubscriber = (function (_super) {
    __extends(TimestampSubscriber, _super);
    function TimestampSubscriber(destination, scheduler) {
        _super.call(this, destination);
        this.scheduler = scheduler;
    }
    TimestampSubscriber.prototype._next = function (value) {
        var now = this.scheduler.now();
        this.destination.next(new Timestamp(value, now));
    };
    return TimestampSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=timestamp.js.map

/***/ }),

/***/ "6/fX":
/***/ (function(module, exports) {

exports.model=Model={Game:{},Board:{},Move:{}},Model.Game.InitGameInfo=function(){},Model.Game.BuildGraphCoord=function(){var i=[],t=[];this.g.Graph=i,this.g.Coord=t},Model.Game.InitGame=function(){this.BuildGraphCoord(),this.g.TripletsByPos=[];for(var i=0;i<this.g.Coord.length;i++)this.g.TripletsByPos[i]=[];for(var i in this.g.Triplets)if(this.g.Triplets.hasOwnProperty(i)){var t=this.g.Triplets[i];for(var e in t)if(t.hasOwnProperty(e)){var s=t[e];this.g.TripletsByPos[s].push(t)}}this.InitGameExtra()},Model.Game.DestroyGame=function(){},Model.Game.MillsDirections=4,Model.Game.MillsEachDirection=function(i,t){for(var e=0;e<this.MillsDirections;e++){var s=this.g.Graph[i][e];null!=s&&t(s)}},Model.Move.Init=function(i){this.f=i.f,this.t=i.t,this.c=i.c},Model.Move.CopyFrom=function(i){this.f=i.f,this.t=i.t,this.c=i.c},Model.Move.Equals=function(i){return this.t==i.t&&this.c==i.c&&this.f==i.f},Model.Move.ToString=function(){var i="";return this.f>-1&&(i+=this.f+">"),i+=this.t,this.c>-1&&(i+="x"+this.c),i},Model.Board.Init=function(i){},Model.Board.InitialPosition=function(i){var t=i.g.Coord.length,e=i.mOptions.mencount;this.board=[];for(var s=0;s<t;s++)this.board[s]=-1;this.pieces=[],this.dock={1:[],"-1":[]},this.menCount={1:0,"-1":0};for(var o=0,n=0;n<2;n++)for(var r=0==n?1:-1,h=0;h<e;h++)this.dock[r].unshift(o),this.pieces.push({s:r,a:!0,d:h,p:-1,i:o++});this.placing=!0},Model.Board.StaticGenerateMoves=function(i){if(0==i.mFullPlayedMoves.length){for(var t=[],e=0;e<i.g.Coord.length;e++)t.push({f:-1,t:e,c:-1});return t}return null},Model.Board.GenerateMoves=function(i){this.mMoves=[],this.placing?this.GeneratePlacingMoves(i):i.mOptions.canFly?this.GenerateFlyingMoves(i):this.GenerateMovingMoves(i),0==this.mMoves.length&&(this.mFinished=!0,this.menCount[JocGame.PLAYER_A]+this.menCount[JocGame.PLAYER_B]==i.g.Coord.length?this.mWinner=JocGame.DRAW:this.mWinner=-this.mWho)},Model.Board.GeneratePlacingMoves=function(i){for(var t=0;t<i.g.Coord.length;t++)if(this.board[t]==-1){var e=!0;if(void 0!==i.mLevelInfo&&i.mCurrentLevel>=0){var s=i.mLevelInfo.maxDepth-i.mCurrentLevel;if(s>=i.mLevelInfo.placingRace){e=!1;for(var o in i.g.TripletsByPos[t])if(i.g.TripletsByPos[t].hasOwnProperty(o)){for(var n=i.g.TripletsByPos[t][o],r=0,h=0,a=0,l=0;l<3;l++)this.board[n[l]]==-1?a++:this.pieces[this.board[n[l]]].s==this.mWho?r++:h++;if(2==r||1==r&&0==h||2==h){e=!0;break}}}}e&&this.GenerateCapturingMoves(i,{f:-1,t:t,c:-1})}},Model.Board.GenerateMovingMoves=function(i){$this=this;for(var t=0;t<this.pieces.length;t++){var e=this.pieces[t];e.a&&e.s==this.mWho&&i.MillsEachDirection(e.p,function(t){$this.board[t]==-1&&$this.GenerateCapturingMoves(i,{f:e.p,t:t,c:-1})})}},Model.Board.GenerateFlyingMoves=function(i){if(3!=this.menCount[this.mWho])this.GenerateMovingMoves(i);else for(var t=0;t<this.pieces.length;t++){var e=this.pieces[t];if(e.a&&e.s==this.mWho)for(var s=0;s<this.board.length;s++)this.board[s]==-1&&this.GenerateCapturingMoves(i,{f:e.p,t:s,c:-1})}},Model.Board.GenerateCapturingMoves=function(i,t){for(var e in i.g.TripletsByPos[t.t])if(i.g.TripletsByPos[t.t].hasOwnProperty(e)){for(var s=i.g.TripletsByPos[t.t][e],o=!0,n=0;n<3;n++){var r=s[n];if(r!=t.t){if(this.board[r]==-1||t.f==r){o=!1;break}var h=this.pieces[this.board[r]];if(0==h.a||h.d>-1||h.s!=this.mWho){o=!1;break}}}if(o){if(3==this.menCount[-this.mWho]&&0==this.placing)return void this.mMoves.push({f:t.f,t:t.t,c:-2});for(var a=[],n=0;n<this.pieces.length;n++){var h=this.pieces[n];if(1==h.a&&h.d==-1&&h.s==-this.mWho){var l={f:t.f,t:t.t,c:h.p};a.push(l)}}if(0==i.mOptions.poundInMill){var u={};for(var c in i.g.Triplets)if(i.g.Triplets.hasOwnProperty(c)){var f=i.g.Triplets[c];this.board[f[0]]!=-1&&this.pieces[this.board[f[0]]].s==-this.mWho&&this.board[f[1]]!=-1&&this.pieces[this.board[f[1]]].s==-this.mWho&&this.board[f[2]]!=-1&&this.pieces[this.board[f[2]]].s==-this.mWho&&(u[f[0]]=!0,u[f[1]]=!0,u[f[2]]=!0)}for(var d=[],c=0;c<a.length;c++)u[a[c].c]||d.push(a[c]);d.length>0&&(a=d)}return void(this.mMoves=this.mMoves.concat(a))}}this.mMoves.push({f:t.f,t:t.t,c:-1})},Model.Board.Evaluate=function(i,t,e){if(i.GetRepeatOccurence(this)>2)return this.mFinished=!0,void(this.mWinner=JocGame.DRAW);if(0==this.placing){if(this.menCount[JocGame.PLAYER_A]<3)return this.mFinished=!0,void(this.mWinner=JocGame.PLAYER_B);if(this.menCount[JocGame.PLAYER_B]<3)return this.mFinished=!0,void(this.mWinner=JocGame.PLAYER_A)}var s=this.menCount[JocGame.PLAYER_A]-this.menCount[JocGame.PLAYER_B],o=0,n=0;for(var r in i.g.Triplets)if(i.g.Triplets.hasOwnProperty(r)){for(var h={"-1":0,0:0,1:0},a=i.g.Triplets[r],l=0;l<3;l++){var u=a[l],c=this.board[u];if(c>-1){var f=this.pieces[c];h[f.s]++}}1==h[1]&&0==h[-1]?o++:2==h[1]&&0==h[-1]&&n++,1==h[-1]&&0==h[1]?o--:2==h[-1]&&0==h[1]&&n--}this.mEvaluation=10*s,this.mEvaluation+=1*o,this.mEvaluation+=3*n},Model.Board.ApplyMove=function(i,t){if(this.placing){var e=this.dock[this.mWho].shift(),s=this.pieces[e];s.d=-1,s.p=t.t,this.board[t.t]=e,this.lastMoveIndex=e,this.menCount[this.mWho]++,0==this.dock[JocGame.PLAYER_B].length&&(this.placing=!1)}else{var s=this.pieces[this.board[t.f]];this.board[s.p]=-1,this.board[t.t]=s.i,s.p=t.t,this.lastMoveIndex=s.i}if(t.c>-1){var e=this.board[t.c];this.board[t.c]=-1;var s=this.pieces[e];s.a=!1,this.menCount[-this.mWho]--}else t.c==-2&&this.menCount[-this.mWho]--},Model.Board.IsValidMove=function(i,t){return!0},Model.Game.InitGameExtra=function(){},Model.Game.BuildGraphCoord=function(){this.g.Graph=[[1,9,null,null],[2,4,0,null],[null,14,1,null],[4,10,null,null],[5,7,3,1],[null,13,4,null],[7,11,null,null],[8,null,6,4],[null,12,7,null],[10,21,null,0],[11,18,9,3],[null,15,10,6],[13,17,null,8],[14,20,12,5],[null,23,13,2],[16,null,null,11],[17,19,15,null],[null,null,16,12],[19,null,null,10],[20,22,18,16],[null,null,19,13],[22,null,null,9],[23,null,21,19],[null,null,22,14]],this.g.Coord=[[0,0],[0,3],[0,6],[1,1],[1,3],[1,5],[2,2],[2,3],[2,4],[3,0],[3,1],[3,2],[3,4],[3,5],[3,6],[4,2],[4,3],[4,4],[5,1],[5,3],[5,5],[6,0],[6,3],[6,6]],this.g.Triplets=[[0,1,2],[3,4,5],[6,7,8],[9,10,11],[12,13,14],[15,16,17],[18,19,20],[21,22,23],[0,9,21],[3,10,18],[6,11,15],[1,4,7],[16,19,22],[8,12,17],[5,13,20],[2,14,23]]};

/***/ }),

/***/ "62z6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var INIT_ACTION = "@ngrx/store/init";
var detectDate = /(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})/;
//correctly parse dates from local storage
exports.dateReviver = function (key, value) {
    if (typeof value === 'string' && (detectDate.test(value))) {
        return new Date(value);
    }
    return value;
};
var validateStateKeys = function (keys) {
    return keys.map(function (key) {
        var attr = key;
        if (typeof key == 'object') {
            attr = Object.keys(key)[0];
        }
        if (typeof (attr) !== 'string') {
            throw new TypeError("localStorageSync Unknown Parameter Type: "
                + ("Expected type of string, got " + typeof attr));
        }
        return key;
    });
};
exports.rehydrateApplicationState = function (keys, storage) {
    return keys.reduce(function (acc, curr) {
        var key = curr;
        var reviver = exports.dateReviver;
        var deserialize = undefined;
        if (typeof key == 'object') {
            key = Object.keys(key)[0];
            // use the custom reviver function
            if (typeof curr[key] === 'function') {
                reviver = curr[key];
            }
            else {
                // use custom reviver function if available
                if (curr[key].reviver) {
                    reviver = curr[key].reviver;
                }
                // use custom serialize function if available
                if (curr[key].deserialize) {
                    deserialize = curr[key].deserialize;
                }
            }
        }
        var stateSlice = storage.getItem(key);
        if (stateSlice) {
            var raw = JSON.parse(stateSlice, reviver);
            return Object.assign({}, acc, (_a = {}, _a[key] = deserialize ? deserialize(raw) : raw, _a));
        }
        return acc;
        var _a;
    }, {});
};
exports.syncStateUpdate = function (state, keys, storage) {
    keys.forEach(function (key) {
        var stateSlice = state[key];
        var replacer = undefined;
        var space = undefined;
        if (typeof key == 'object') {
            var name_1 = Object.keys(key)[0];
            stateSlice = state[name_1];
            if (key[name_1]) {
                // use serialize function if specified.
                if (key[name_1].serialize) {
                    stateSlice = key[name_1].serialize(stateSlice);
                }
                else {
                    var filter = undefined;
                    if (key[name_1].reduce) {
                        filter = key[name_1];
                    }
                    else if (key[name_1].filter) {
                        filter = key[name_1].filter;
                    }
                    if (filter) {
                        stateSlice = filter.reduce(function (memo, attr) {
                            memo[attr] = stateSlice[attr];
                            return memo;
                        }, {});
                    }
                }
                /*
                    Replacer and space arguments to pass to JSON.stringify.
                    If these fields don't exist, undefined will be passed.
                */
                replacer = key[name_1].replacer;
                space = key[name_1].space;
            }
            key = name_1;
        }
        if (typeof (stateSlice) !== 'undefined') {
            try {
                storage.setItem(key, typeof stateSlice == 'string' ? stateSlice : JSON.stringify(stateSlice, replacer, space));
            }
            catch (e) {
                console.warn('Unable to save state to localStorage:', e);
            }
        }
    });
};
exports.localStorageSync = function (keys, rehydrate, storage) {
    if (rehydrate === void 0) { rehydrate = false; }
    if (storage === void 0) { storage = localStorage; }
    return function (reducer) {
        var stateKeys = validateStateKeys(keys);
        var rehydratedState = rehydrate ? exports.rehydrateApplicationState(stateKeys, storage) : undefined;
        return function (state, action) {
            if (state === void 0) { state = rehydratedState; }
            /*
             Handle case where state is rehydrated AND initial state is supplied.
             Any additional state supplied will override rehydrated state for the given key.
             */
            if (action.type === INIT_ACTION && rehydratedState) {
                state = Object.assign({}, state, rehydratedState);
            }
            var nextState = reducer(state, action);
            exports.syncStateUpdate(nextState, stateKeys, storage);
            return nextState;
        };
    };
};
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "69uX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var OuterSubscriber_1 = __webpack_require__("wAkD");
var subscribeToResult_1 = __webpack_require__("CURp");
var Set_1 = __webpack_require__("Ou9t");
/**
 * Returns an Observable that emits all items emitted by the source Observable that are distinct by comparison from previous items.
 *
 * If a keySelector function is provided, then it will project each value from the source observable into a new value that it will
 * check for equality with previously projected values. If a keySelector function is not provided, it will use each value from the
 * source observable directly with an equality check against previous values.
 *
 * In JavaScript runtimes that support `Set`, this operator will use a `Set` to improve performance of the distinct value checking.
 *
 * In other runtimes, this operator will use a minimal implementation of `Set` that relies on an `Array` and `indexOf` under the
 * hood, so performance will degrade as more values are checked for distinction. Even in newer browsers, a long-running `distinct`
 * use might result in memory leaks. To help alleviate this in some scenarios, an optional `flushes` parameter is also provided so
 * that the internal `Set` can be "flushed", basically clearing it of values.
 *
 * @example <caption>A simple example with numbers</caption>
 * Observable.of(1, 1, 2, 2, 2, 1, 2, 3, 4, 3, 2, 1)
 *   .distinct()
 *   .subscribe(x => console.log(x)); // 1, 2, 3, 4
 *
 * @example <caption>An example using a keySelector function</caption>
 * interface Person {
 *    age: number,
 *    name: string
 * }
 *
 * Observable.of<Person>(
 *     { age: 4, name: 'Foo'},
 *     { age: 7, name: 'Bar'},
 *     { age: 5, name: 'Foo'})
 *     .distinct((p: Person) => p.name)
 *     .subscribe(x => console.log(x));
 *
 * // displays:
 * // { age: 4, name: 'Foo' }
 * // { age: 7, name: 'Bar' }
 *
 * @see {@link distinctUntilChanged}
 * @see {@link distinctUntilKeyChanged}
 *
 * @param {function} [keySelector] Optional function to select which value you want to check as distinct.
 * @param {Observable} [flushes] Optional Observable for flushing the internal HashSet of the operator.
 * @return {Observable} An Observable that emits items from the source Observable with distinct values.
 * @method distinct
 * @owner Observable
 */
function distinct(keySelector, flushes) {
    return this.lift(new DistinctOperator(keySelector, flushes));
}
exports.distinct = distinct;
var DistinctOperator = (function () {
    function DistinctOperator(keySelector, flushes) {
        this.keySelector = keySelector;
        this.flushes = flushes;
    }
    DistinctOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new DistinctSubscriber(subscriber, this.keySelector, this.flushes));
    };
    return DistinctOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var DistinctSubscriber = (function (_super) {
    __extends(DistinctSubscriber, _super);
    function DistinctSubscriber(destination, keySelector, flushes) {
        _super.call(this, destination);
        this.keySelector = keySelector;
        this.values = new Set_1.Set();
        if (flushes) {
            this.add(subscribeToResult_1.subscribeToResult(this, flushes));
        }
    }
    DistinctSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.values.clear();
    };
    DistinctSubscriber.prototype.notifyError = function (error, innerSub) {
        this._error(error);
    };
    DistinctSubscriber.prototype._next = function (value) {
        if (this.keySelector) {
            this._useKeySelector(value);
        }
        else {
            this._finalizeNext(value, value);
        }
    };
    DistinctSubscriber.prototype._useKeySelector = function (value) {
        var key;
        var destination = this.destination;
        try {
            key = this.keySelector(value);
        }
        catch (err) {
            destination.error(err);
            return;
        }
        this._finalizeNext(key, value);
    };
    DistinctSubscriber.prototype._finalizeNext = function (key, value) {
        var values = this.values;
        if (!values.has(key)) {
            values.add(key);
            this.destination.next(value);
        }
    };
    return DistinctSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
exports.DistinctSubscriber = DistinctSubscriber;
//# sourceMappingURL=distinct.js.map

/***/ }),

/***/ "6ID/":
/***/ (function(module, exports) {

exports.config = {"status":true,"model":{"plazza":"true","title-en":"Alquerque AvdS","module":"checkers","maxLevel":20,"summary":"Alquerque rules proposal from a Draughts historian.","thumbnail":"alquerque-avds3-thumb.png","rules":"rules-alquerque-avds.html","description":"description.html","credits":"credits-avds.html","js":["checkersbase-model.js","alquerque-avds-model.js"],"gameOptions":{"preventRepeat":true,"width":5,"height":5,"initial":{"a":[[0,0],[0,1],[0,2],[0,3],[0,4],[1,0],[1,1],[1,2],[1,3],[1,4],[2,3],[2,4]],"b":[[4,0],[4,1],[4,2],[4,3],[4,4],[3,0],[3,1],[3,2],[3,3],[3,4],[2,0],[2,1]]},"variant":{"canStepBack":true,"mustMoveForward":true,"lastRowFreeze":false,"noMove":"lose","longRangeKing":true,"kingCaptureShort":false,"lastRowCrown":true,"canCaptureBackward":false}},"levels":[{"label":"Fast","ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.5,"maxDuration":1,"isDefault":true},{"label":"Beginner","ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.5,"maxDuration":0.5,"maxNodes":100,"maxLoops":200},{"label":"Easy","ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.5,"maxDuration":1,"maxNodes":2500,"maxLoops":500},{"label":"Medium","ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.5,"maxDuration":2,"maxNodes":5500,"maxLoops":500},{"label":"Hard","ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.5,"maxDuration":5,"maxNodes":2000,"maxLoops":3500},{"label":"Expert","ai":"uct","c":0.8,"playoutDepth":0,"minVisitsExpand":1,"ignoreLeaf":false,"uncertaintyFactor":5,"propagateMultiVisits":false,"maxDuration":60,"maxNodes":15000,"maxLoops":8000}]},"view":{"js":["checkers-xd-view.js","checkers-xd-view-captbreak.js","alquerque-xd-view.js"],"xdView":true,"css":["checkersbase.css","alquerque.css"],"title-en":"Alquerque Bell View","skins":[{"name":"alquerque3d","title":"3D Classic","3d":true,"camera":{"radius":20,"elevationAngle":45,"limitCamMoves":true},"world":{"lightIntensity":0.8,"color":0,"fog":false,"lightPosition":{"x":-5,"y":18,"z":5},"lightShadowDarkness":0.55,"ambientLightColor":0},"preload":["image|/res/xd-view/meshes/red.png","image|/res/xd-view/meshes/black.png","image|/res/xd-view/meshes/red-king.png","image|/res/xd-view/meshes/black-king.png","image|/res/images/alquarqueboard1.jpg","image|/res/xd-view/meshes/skybox/nx.jpg","image|/res/xd-view/meshes/skybox/ny.jpg","image|/res/xd-view/meshes/skybox/nz.jpg","image|/res/xd-view/meshes/skybox/px.jpg","image|/res/xd-view/meshes/skybox/py.jpg","image|/res/xd-view/meshes/skybox/pz.jpg","smoothedfilegeo|0|/res/xd-view/meshes/board-checkers-slot.js","smoothedfilegeo|0|/res/xd-view/meshes/board-alquerque-external-frame.js","smoothedfilegeo|0|/res/xd-view/meshes/board-checkers-triangle.js","smoothedfilegeo|0|/res/xd-view/meshes/ring-target.js"]},{"name":"2d-wood-alquerque","title":"Wood"}],"visuals":{"600x600":["res/visuals/alquerque-avds3-600x600-3d.jpg","res/visuals/alquerque-avds3-600x600-2d.jpg"]},"module":"checkers","preferredRatio":1,"switchable":true,"animateSelfMoves":false,"useNotation":true,"useShowMoves":true,"sounds":{"move1":"alq_move1","move2":"alq_move2","move3":"alq_move3","move4":"alq_move2","tac1":"alq_tac1","tac2":"alq_tac2","tac3":"alq_tac1","promo":null,"usermove":null},"defaultOptions":{"sounds":true,"notation":false,"moves":true}}}

/***/ }),

/***/ "6Ob/":
/***/ (function(module, exports) {

exports.model=Model={Game:{},Board:{},Move:{}},Model.Game.InitGameInfo=function(){},Model.Game.BuildGraphCoord=function(){var i=[],t=[];this.g.Graph=i,this.g.Coord=t},Model.Game.InitGame=function(){this.BuildGraphCoord(),this.g.TripletsByPos=[];for(var i=0;i<this.g.Coord.length;i++)this.g.TripletsByPos[i]=[];for(var i in this.g.Triplets)if(this.g.Triplets.hasOwnProperty(i)){var t=this.g.Triplets[i];for(var e in t)if(t.hasOwnProperty(e)){var s=t[e];this.g.TripletsByPos[s].push(t)}}this.InitGameExtra()},Model.Game.DestroyGame=function(){},Model.Game.MillsDirections=4,Model.Game.MillsEachDirection=function(i,t){for(var e=0;e<this.MillsDirections;e++){var s=this.g.Graph[i][e];null!=s&&t(s)}},Model.Move.Init=function(i){this.f=i.f,this.t=i.t,this.c=i.c},Model.Move.CopyFrom=function(i){this.f=i.f,this.t=i.t,this.c=i.c},Model.Move.Equals=function(i){return this.t==i.t&&this.c==i.c&&this.f==i.f},Model.Move.ToString=function(){var i="";return this.f>-1&&(i+=this.f+">"),i+=this.t,this.c>-1&&(i+="x"+this.c),i},Model.Board.Init=function(i){},Model.Board.InitialPosition=function(i){var t=i.g.Coord.length,e=i.mOptions.mencount;this.board=[];for(var s=0;s<t;s++)this.board[s]=-1;this.pieces=[],this.dock={1:[],"-1":[]},this.menCount={1:0,"-1":0};for(var o=0,n=0;n<2;n++)for(var r=0==n?1:-1,h=0;h<e;h++)this.dock[r].unshift(o),this.pieces.push({s:r,a:!0,d:h,p:-1,i:o++});this.placing=!0},Model.Board.StaticGenerateMoves=function(i){if(0==i.mFullPlayedMoves.length){for(var t=[],e=0;e<i.g.Coord.length;e++)t.push({f:-1,t:e,c:-1});return t}return null},Model.Board.GenerateMoves=function(i){this.mMoves=[],this.placing?this.GeneratePlacingMoves(i):i.mOptions.canFly?this.GenerateFlyingMoves(i):this.GenerateMovingMoves(i),0==this.mMoves.length&&(this.mFinished=!0,this.menCount[JocGame.PLAYER_A]+this.menCount[JocGame.PLAYER_B]==i.g.Coord.length?this.mWinner=JocGame.DRAW:this.mWinner=-this.mWho)},Model.Board.GeneratePlacingMoves=function(i){for(var t=0;t<i.g.Coord.length;t++)if(this.board[t]==-1){var e=!0;if(void 0!==i.mLevelInfo&&i.mCurrentLevel>=0){var s=i.mLevelInfo.maxDepth-i.mCurrentLevel;if(s>=i.mLevelInfo.placingRace){e=!1;for(var o in i.g.TripletsByPos[t])if(i.g.TripletsByPos[t].hasOwnProperty(o)){for(var n=i.g.TripletsByPos[t][o],r=0,h=0,a=0,l=0;l<3;l++)this.board[n[l]]==-1?a++:this.pieces[this.board[n[l]]].s==this.mWho?r++:h++;if(2==r||1==r&&0==h||2==h){e=!0;break}}}}e&&this.GenerateCapturingMoves(i,{f:-1,t:t,c:-1})}},Model.Board.GenerateMovingMoves=function(i){$this=this;for(var t=0;t<this.pieces.length;t++){var e=this.pieces[t];e.a&&e.s==this.mWho&&i.MillsEachDirection(e.p,function(t){$this.board[t]==-1&&$this.GenerateCapturingMoves(i,{f:e.p,t:t,c:-1})})}},Model.Board.GenerateFlyingMoves=function(i){if(3!=this.menCount[this.mWho])this.GenerateMovingMoves(i);else for(var t=0;t<this.pieces.length;t++){var e=this.pieces[t];if(e.a&&e.s==this.mWho)for(var s=0;s<this.board.length;s++)this.board[s]==-1&&this.GenerateCapturingMoves(i,{f:e.p,t:s,c:-1})}},Model.Board.GenerateCapturingMoves=function(i,t){for(var e in i.g.TripletsByPos[t.t])if(i.g.TripletsByPos[t.t].hasOwnProperty(e)){for(var s=i.g.TripletsByPos[t.t][e],o=!0,n=0;n<3;n++){var r=s[n];if(r!=t.t){if(this.board[r]==-1||t.f==r){o=!1;break}var h=this.pieces[this.board[r]];if(0==h.a||h.d>-1||h.s!=this.mWho){o=!1;break}}}if(o){if(3==this.menCount[-this.mWho]&&0==this.placing)return void this.mMoves.push({f:t.f,t:t.t,c:-2});for(var a=[],n=0;n<this.pieces.length;n++){var h=this.pieces[n];if(1==h.a&&h.d==-1&&h.s==-this.mWho){var l={f:t.f,t:t.t,c:h.p};a.push(l)}}if(0==i.mOptions.poundInMill){var u={};for(var c in i.g.Triplets)if(i.g.Triplets.hasOwnProperty(c)){var f=i.g.Triplets[c];this.board[f[0]]!=-1&&this.pieces[this.board[f[0]]].s==-this.mWho&&this.board[f[1]]!=-1&&this.pieces[this.board[f[1]]].s==-this.mWho&&this.board[f[2]]!=-1&&this.pieces[this.board[f[2]]].s==-this.mWho&&(u[f[0]]=!0,u[f[1]]=!0,u[f[2]]=!0)}for(var d=[],c=0;c<a.length;c++)u[a[c].c]||d.push(a[c]);d.length>0&&(a=d)}return void(this.mMoves=this.mMoves.concat(a))}}this.mMoves.push({f:t.f,t:t.t,c:-1})},Model.Board.Evaluate=function(i,t,e){if(i.GetRepeatOccurence(this)>2)return this.mFinished=!0,void(this.mWinner=JocGame.DRAW);if(0==this.placing){if(this.menCount[JocGame.PLAYER_A]<3)return this.mFinished=!0,void(this.mWinner=JocGame.PLAYER_B);if(this.menCount[JocGame.PLAYER_B]<3)return this.mFinished=!0,void(this.mWinner=JocGame.PLAYER_A)}var s=this.menCount[JocGame.PLAYER_A]-this.menCount[JocGame.PLAYER_B],o=0,n=0;for(var r in i.g.Triplets)if(i.g.Triplets.hasOwnProperty(r)){for(var h={"-1":0,0:0,1:0},a=i.g.Triplets[r],l=0;l<3;l++){var u=a[l],c=this.board[u];if(c>-1){var f=this.pieces[c];h[f.s]++}}1==h[1]&&0==h[-1]?o++:2==h[1]&&0==h[-1]&&n++,1==h[-1]&&0==h[1]?o--:2==h[-1]&&0==h[1]&&n--}this.mEvaluation=10*s,this.mEvaluation+=1*o,this.mEvaluation+=3*n},Model.Board.ApplyMove=function(i,t){if(this.placing){var e=this.dock[this.mWho].shift(),s=this.pieces[e];s.d=-1,s.p=t.t,this.board[t.t]=e,this.lastMoveIndex=e,this.menCount[this.mWho]++,0==this.dock[JocGame.PLAYER_B].length&&(this.placing=!1)}else{var s=this.pieces[this.board[t.f]];this.board[s.p]=-1,this.board[t.t]=s.i,s.p=t.t,this.lastMoveIndex=s.i}if(t.c>-1){var e=this.board[t.c];this.board[t.c]=-1;var s=this.pieces[e];s.a=!1,this.menCount[-this.mWho]--}else t.c==-2&&this.menCount[-this.mWho]--},Model.Board.IsValidMove=function(i,t){return!0},Model.Game.InitGameExtra=function(){},Model.Game.BuildGraphCoord=function(){this.g.Graph=[[1,9,null,null],[2,4,0,null],[null,14,1,null],[4,10,null,null],[5,7,3,1],[null,13,4,null],[7,11,null,null],[8,null,6,4],[null,12,7,null],[10,21,null,0],[11,18,9,3],[null,15,10,6],[13,17,null,8],[14,20,12,5],[null,23,13,2],[16,null,null,11],[17,19,15,null],[null,null,16,12],[19,null,null,10],[20,22,18,16],[null,null,19,13],[22,null,null,9],[23,null,21,19],[null,null,22,14]],this.g.Coord=[[0,0],[0,3],[0,6],[1,1],[1,3],[1,5],[2,2],[2,3],[2,4],[3,0],[3,1],[3,2],[3,4],[3,5],[3,6],[4,2],[4,3],[4,4],[5,1],[5,3],[5,5],[6,0],[6,3],[6,6]],this.g.Triplets=[[0,1,2],[3,4,5],[6,7,8],[9,10,11],[12,13,14],[15,16,17],[18,19,20],[21,22,23],[0,9,21],[3,10,18],[6,11,15],[1,4,7],[16,19,22],[8,12,17],[5,13,20],[2,14,23]]};

/***/ }),

/***/ "6Yye":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var catch_1 = __webpack_require__("+4ur");
Observable_1.Observable.prototype.catch = catch_1._catch;
Observable_1.Observable.prototype._catch = catch_1._catch;
//# sourceMappingURL=catch.js.map

/***/ }),

/***/ "6gFN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var mapTo_1 = __webpack_require__("9oiU");
Observable_1.Observable.prototype.mapTo = mapTo_1.mapTo;
//# sourceMappingURL=mapTo.js.map

/***/ }),

/***/ "6hPP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var sampleTime_1 = __webpack_require__("t2Bb");
Observable_1.Observable.prototype.sampleTime = sampleTime_1.sampleTime;
//# sourceMappingURL=sampleTime.js.map

/***/ }),

/***/ "6nFD":
/***/ (function(module, exports) {

exports.model=Model={Game:{},Board:{},Move:{}},function(){var t;Model.Game.cbConstants={MASK:65535,FLAG_MOVE:65536,FLAG_CAPTURE:131072,FLAG_STOP:262144,FLAG_SCREEN_CAPTURE:524288,FLAG_CAPTURE_KING:1048576,FLAG_CAPTURE_NO_KING:2097152};var e="undefined"!=typeof Int32Array;Model.Game.cbUseTypedArrays=e,Model.Game.cbTypedArray=function(t){if(e){var r=new Int32Array(t.length);return r.set(t),r}for(var a=[],i=t.length,s=0;s<i;s++)a.push(t[s]);return a},Model.Game.cbShortRangeGraph=function(t,e,r,a){var i=this;void 0===a&&(a=196608);for(var s={},n=0;n<t.boardSize;n++)s[n]=[],(!r||n in r)&&e.forEach(function(e){var o=t.Graph(n,e);null!=o&&(!r||o in r)&&s[n].push(i.cbTypedArray([o|a]))});return s},Model.Game.cbLongRangeGraph=function(t,e,r,a,i){var s=this;void 0!==a&&null!=a||(a=196608),i||(i=1/0);for(var n={},o=0;o<t.boardSize;o++)n[o]=[],(!r||o in r)&&e.forEach(function(e){for(var h=[],c=t.Graph(o,e),p=0;null!=c&&(!r||c in r)&&(h.push(c|a),++p!=i);)c=t.Graph(c,e);h.length>0&&n[o].push(s.cbTypedArray(h))});return n},Model.Game.cbNullGraph=function(t){for(var e={},r=0;r<t.boardSize;r++)e[r]=[];return e},Model.Game.cbAuthorGraph=function(t){for(var e={},r=0;r<t.boardSize;r++){e[r]=[];for(var a=0;a<t.boardSize;a++)e[r].push([2293760|a])}return e},Model.Game.cbMergeGraphs=function(t){for(var e=[],r=0;r<t.boardSize;r++){e[r]=[];for(var a=1;a<arguments.length;a++)e[r]=e[r].concat(arguments[a][r])}return e},Model.Game.cbGetThreatGraph=function(){function t(e,r){for(var a in n){var i=n[a];if(!(i.p.length<r.length+1)){for(var s=!0,o=0;o<r.length;o++)if(r[o]!=i.p[o]){s=!1;break}if(s){var h=i.p[r.length],c=e[h];void 0===c&&(c={e:{}},e[h]=c),i.p.length==r.length+1&&(c.t=i.t,c.ts=i.ts,c.tk=i.tk,delete n[a]),r.push(h),t(c.e,r),r.pop()}}}}var e=this;this.cbUseScreenCapture=!1,this.cbUseCaptureKing=!1,this.cbUseCaptureNoKing=!1;for(var r={1:[],"-1":[]},a=[],i=0;i<this.g.boardSize;i++)this.g.pTypes.forEach(function(t,r){t.graph[i].forEach(function(t){for(var s=[],n=0;n<t.length;n++){var o=t[n];1048576&o?(e.cbUseCaptureKing=!0,s.unshift({d:65535&o,a:i,tk:r})):2097152&o?(e.cbUseCaptureNoKing=!0,s.unshift({d:65535&o,a:i,tnk:r})):131072&o?s.unshift({d:65535&o,a:i,t:r}):262144&o?s.unshift({d:65535&o,a:i}):524288&o&&(e.cbUseScreenCapture=!0,s.unshift({d:65535&o,a:i,ts:r}))}s.length>0&&a.push(s)})});var s={};a.forEach(function(t){t.forEach(function(e,r){var a=s[e.d];void 0===a&&(a={},s[e.d]=a);for(var i=[],n=r+1;n<t.length;n++)i.push(t[n].d);i.push(e.a);var o=i.join(","),h=a[o];void 0===h&&(h={p:i,t:{},ts:{},tk:{}},a[o]=h),void 0!==e.t?h.t[e.t]=!0:void 0!==e.tk?h.tk[e.tk]=!0:void 0!==e.ts&&(h.ts[e.ts]=!0)})});for(var i=0;i<e.g.boardSize;i++){var n=s[i],o={};t(o,[]),r[1][i]=o,r[-1][i]=o}return r},Model.Game.InitGame=function(){var e=this;this.cbVar=t=this.cbDefine(),this.g.boardSize=this.cbVar.geometry.boardSize,this.g.pTypes=this.cbGetPieceTypes(),this.g.threatGraph=this.cbGetThreatGraph(),this.g.distGraph=this.cbVar.geometry.GetDistances(),this.cbPiecesCount=0,this.g.castleablePiecesCount={1:0,"-1":0};for(var r in t.pieceTypes){var a=t.pieceTypes[r];if(a.castle){(a.initial||[]).forEach(function(t){e.g.castleablePiecesCount[t.s]++})}a.initial&&(this.cbPiecesCount+=a.initial.length)}for(var i=[],r=0;r<this.cbPiecesCount;r++)i.push(r);var s=Object.keys(t.pieceTypes);this.zobrist=new JocGame.Zobrist({board:{type:"array",size:this.cbVar.geometry.boardSize,values:i},who:{values:["1","-1"]},type:{type:"array",size:this.cbPiecesCount,values:s}})},Model.Game.cbGetPieceTypes=function(){for(var t=[],e={},r=0;r<this.cbVar.geometry.boardSize;r++)e[r]=[];for(var a in this.cbVar.pieceTypes){var i=this.cbVar.pieceTypes[a];t[a]={graph:i.graph||e,abbrev:i.abbrev||"",value:i.isKing?100:i.value||1,isKing:!!i.isKing,castle:!!i.castle,epTarget:!!i.epTarget,epCatch:!!i.epCatch}}return t},Model.Board.Init=function(t){this.zSign=0},Model.Board.InitialPosition=function(r){var a=this;this.board=e?new Int16Array(r.g.boardSize):[];for(var i=0;i<r.g.boardSize;i++)this.board[i]=-1;if(this.kings={},this.pieces=[],this.ending={1:!1,"-1":!1},this.lastMove=null,r.cbVar.castle&&(this.castled={1:!1,"-1":!1}),this.zSign=r.zobrist.update(0,"who",-1),this.noCaptCount=0,this.mWho=1,r.mInitial)this.mWho=r.mInitial.turn||1,r.mInitial.pieces.forEach(function(t){var e={};for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);a.pieces.push(e)}),r.mInitial.lastMove&&(this.lastMove={f:r.mInitial.lastMove.f,t:r.mInitial.lastMove.t}),void 0!==r.mInitial.noCaptCount&&(this.noCaptCount=r.mInitial.noCaptCount),r.cbVar.castle&&r.mInitial.castle&&(this.castled={1:{k:!!r.mInitial.castle[1]&&!!r.mInitial.castle[1].k,q:!!r.mInitial.castle[1]&&!!r.mInitial.castle[1].q},"-1":{k:!!r.mInitial.castle[-1]&&!!r.mInitial.castle[-1].k,q:!!r.mInitial.castle[-1]&&!!r.mInitial.castle[-1].q}});else for(var s in r.cbVar.pieceTypes)for(var n=r.cbVar.pieceTypes[s],o=n.initial||[],h=0;h<o.length;h++){var c=o[h],p={s:c.s,t:parseInt(s),p:c.p,m:!1};this.pieces.push(p)}if(this.pieces.sort(function(t,e){if(t.s!=e.s)return e.s-t.s;var a=r.cbVar.pieceTypes[t.t].value||100,i=r.cbVar.pieceTypes[e.t].value||100;return a!=i?a-i:t.p-e.p}),this.pieces.forEach(function(t,e){t.i=e,a.board[t.p]=e,r.g.pTypes[t.t].isKing&&(a.kings[t.s]=t.p),a.zSign=r.zobrist.update(a.zSign,"board",e,t.p),a.zSign=r.zobrist.update(a.zSign,"type",t.t,e)}),r.mInitial&&r.mInitial.enPassant){var i=t.geometry.PosByName(r.mInitial.enPassant);if(i>=0){var l,u=t.geometry.C(i),b=t.geometry.R(i);l=1==r.mInitial.turn?t.geometry.POS(u,b-1):t.geometry.POS(u,b+1),this.epTarget={p:i,i:this.board[l]}}}},Model.Board.CopyFrom=function(t){if(e)this.board=new Int16Array(t.board.length),this.board.set(t.board);else{this.board=[];for(var r=t.board,a=r.length,i=0;i<a;i++)this.board.push(r[i])}this.pieces=[];for(var s=t.pieces.length,i=0;i<s;i++){var n=t.pieces[i];this.pieces.push({s:n.s,p:n.p,t:n.t,i:n.i,m:n.m})}this.kings={1:t.kings[1],"-1":t.kings[-1]},this.check=t.check,t.lastMove?this.lastMove={f:t.lastMove.f,t:t.lastMove.t,c:t.lastMove.c}:this.lastMove=null,this.ending={1:t.ending[1],"-1":t.ending[-1]},void 0!==t.castled&&(this.castled={1:t.castled[1],"-1":t.castled[-1]}),this.noCaptCount=t.noCaptCount,t.epTarget?this.epTarget={p:t.epTarget.p,i:t.epTarget.i}:this.epTarget=null,this.mWho=t.mWho,this.zSign=t.zSign},Model.Board.cbApplyCastle=function(t,e,r){var a=t.cbVar.castle[e.f+"/"+e.cg],i=a.r[a.r.length-1],s=this.pieces[this.board[e.cg]],n=a.k[a.k.length-1],o=this.pieces[this.board[e.f]];return r&&(this.zSign=t.zobrist.update(this.zSign,"board",s.i,e.cg),this.zSign=t.zobrist.update(this.zSign,"board",s.i,i),this.zSign=t.zobrist.update(this.zSign,"board",o.i,e.f),this.zSign=t.zobrist.update(this.zSign,"board",o.i,n)),s.p=i,s.m=!0,this.board[e.cg]=-1,o.p=n,o.m=!0,this.board[e.f]=-1,this.board[i]=s.i,this.board[n]=o.i,this.castled[s.s]=!0,this.kings[o.s]=n,[{i:s.i,f:i,t:-1},{i:o.i,f:n,t:e.f,kp:e.f,who:o.s,m:!1},{i:s.i,f:-1,t:e.cg,m:!1,cg:!1}]},Model.Board.cbQuickApply=function(t,e){if(void 0!==e.cg)return this.cbApplyCastle(t,e,!1);var r=[],a=this.board[e.f],i=this.pieces[a];if(null!=e.c){r.unshift({i:e.c,f:-1,t:this.pieces[e.c].p});var s=this.pieces[e.c];this.board[s.p]=-1,s.p=-1}var n=this.kings[i.s];return t.g.pTypes[i.t].isKing&&(this.kings[i.s]=e.t),r.unshift({i:a,f:e.t,t:e.f,kp:n,who:i.s,ty:i.t}),i.p=e.t,void 0!==e.pr&&(i.t=e.pr),this.board[e.f]=-1,this.board[e.t]=a,r},Model.Board.cbQuickUnapply=function(t,e){for(var r=0;r<e.length;r++){var a=e[r],i=this.pieces[a.i];a.f>=0&&(i.p=-1,this.board[a.f]=-1),a.t>=0&&(i.p=a.t,this.board[a.t]=a.i),void 0!==a.m&&(i.m=a.m),void 0!==a.kp&&(this.kings[a.who]=a.kp),void 0!=a.ty&&(i.t=a.ty),void 0!=a.cg&&(this.castled[i.s]=a.cg)}},Model.Board.ApplyMove=function(t,e){var r=this.pieces[this.board[e.f]];if(void 0!==e.cg)this.cbApplyCastle(t,e,!0);else{if(this.zSign=t.zobrist.update(this.zSign,"board",r.i,e.f),this.board[r.p]=-1,void 0!==e.pr&&(this.zSign=t.zobrist.update(this.zSign,"type",r.t,r.i),r.t=e.pr,this.zSign=t.zobrist.update(this.zSign,"type",r.t,r.i)),null!=e.c){var a=this.pieces[e.c];this.zSign=t.zobrist.update(this.zSign,"board",a.i,a.p),this.board[a.p]=-1,a.p=-1,a.m=!0,this.noCaptCount=0}else this.noCaptCount++;r.p=e.t,r.m=!0,this.board[e.t]=r.i,this.zSign=t.zobrist.update(this.zSign,"board",r.i,e.t),t.g.pTypes[r.t].isKing&&(this.kings[r.s]=e.t)}this.check=!!e.ck,this.lastMove={f:e.f,t:e.t,c:e.c},void 0!==e.ko&&(this.ending[r.s]=e.ko),void 0!==e.ept?this.epTarget={p:e.ept,i:r.i}:this.epTarget=null,this.zSign=t.zobrist.update(this.zSign,"who",-this.mWho),this.zSign=t.zobrist.update(this.zSign,"who",this.mWho)},Model.Board.Evaluate=function(r){function a(e){var r=1/0;for(var a in t.geometry.corners)r=Math.min(r,h.distGraph[s.kings[e]][a]);return r-Math.sqrt(h.boardSize)}var i="debug"==arguments[3],s=this;this.mEvaluation=0;var n,o=this.mWho,h=r.g;if(e)n={1:{count:new Uint8Array(h.pTypes.length),byType:{}},"-1":{count:new Uint8Array(h.pTypes.length),byType:{}}};else{n={1:{count:[],byType:{}},"-1":{count:[],byType:{}}};for(var c=0;c<h.pTypes.length;c++)n[1].count[c]=n[-1].count[c]=0}if(r.mOptions.preventRepeat&&r.GetRepeatOccurence(this)>2)return this.mFinished=!0,void(this.mWinner=r.cbOnPerpetual?o*r.cbOnPerpetual:JocGame.DRAW);for(var p={1:0,"-1":0},l={1:h.distGraph[this.kings[-1]],"-1":h.distGraph[this.kings[1]]},u={1:0,"-1":0},b={1:0,"-1":0},v={1:0,"-1":0},f={1:0,"-1":0},g={1:!1,"-1":!1},d=this.pieces,m=d.length,c=0;c<m;c++){var G=d[c];if(G.p>=0){var y=G.s,M=h.pTypes[G.t];M.isKing?g[y]=G.m:p[y]+=M.value,M.castle&&!G.m&&f[y]++,b[y]++,u[y]+=l[y][G.p],v[y]+=t.geometry.distEdge[G.p];var C=n[y];C.count[G.t]++;var S=C.byType;void 0===S[G.t]?S[G.t]=[G]:S[G.t].push(G)}}if(this.lastMove&&null!=this.lastMove.c){var G=this.pieces[this.board[this.lastMove.t]];p[-G.s]+=this.cbStaticExchangeEval(r,G.p,G.s,{piece:G})}var k={1:0,"-1":0},A={1:0,"-1":0},T={1:0,"-1":0};this.ending[1]&&(A[1]=(u[1]-Math.sqrt(h.boardSize))/b[1],t.geometry.corners&&(T[1]=a(1))),this.ending[-1]&&(A[-1]=(u[-1]-Math.sqrt(h.boardSize))/b[-1],t.geometry.corners&&(T[1]=a(-1)));var z={pieceValue:p[1]-p[-1],pieceValueRatio:(p[1]-p[-1])/(p[1]+p[-1]+1),posValue:v[1]-v[-1],averageDistKing:u[1]/b[1]-u[-1]/b[-1],check:this.check?-o:0,endingKingFreedom:k[1]-k[-1],endingDistKing:A[1]-A[-1],distKingCorner:T[1]-T[-1]};t.castle&&(z.castle=(this.castled[1]?1:g[1]?0:f[1]/(h.castleablePiecesCount[1]+1))-(this.castled[-1]?1:g[-1]?0:f[-1]/(h.castleablePiecesCount[-1]+1))),t.evaluate&&t.evaluate.call(this,r,z,n);var E=r.mOptions.levelOptions;for(var P in z){var w=z[P],I=E[P+"Factor"]||0,R=w*I;i&&console.log(P,"=",w,"*",I,"=>",R),this.mEvaluation+=R}i&&console.log("Evaluation",this.mEvaluation)},Model.Board.cbGeneratePseudoLegalMoves=function(t){function e(e,i){var s=t.cbVar.promote;if(!s)return void a.push(i);var n=s.call(r,t,e,i);if(null!=n)if(0==n.length)a.push(i);else if(1==n.length)i.pr=n[0],a.push(i);else for(var o=0;o<n.length;o++){var h=n[o];a.push({f:i.f,t:i.t,c:i.c,pr:h,ept:i.ept,ep:i.ep,a:i.a})}}for(var r=this,a=[],i=t.cbVar,s=this.mWho,n=!i.castle||this.check||this.castled[s]?null:[],o=-1,h=this.pieces.length,c=0;c<h;c++){var p=this.pieces[c];if(!(p.p<0||p.s!=s)){var l=t.g.pTypes[p.t];l.isKing&&(p.m?n=null:o=p),n&&l.castle&&!p.m&&n.push(p);var u,b;u=l.graph[p.p],b=u.length;for(var v=0;v<b;v++)for(var f=u[v],g=!1,d=f.length,m=null,G=0;G<d;G++){var y=f[G],M=65535&y,C=this.board[M];if(!(C<0)||l.epCatch&&this.epTarget&&this.epTarget.p==M){if(!(524288&y)){var S;S=C<0?this.pieces[this.epTarget.i]:this.pieces[C],!(S.s!=p.s&&131072&y)||1048576&y&&!t.g.pTypes[S.t].isKing||2097152&y&&t.g.pTypes[S.t].isKing||e(p,{f:p.p,t:M,c:S.i,a:l.abbrev,ep:C<0});break}if(g){var S=this.pieces[C];S.s!=p.s&&e(p,{f:p.p,t:M,c:S.i,a:l.abbrev});break}g=!0}else 65536&y&&0==g&&e(p,{f:p.p,t:M,c:null,a:l.abbrev,ept:null!=m&&l.epTarget?m:void 0});m=M}}}if(n)for(var c=0;c<n.length;c++){var k=n[c],A=t.cbVar.castle[o.p+"/"+k.p];if(A){for(var T=!0,v=0;v<A.r.length;v++){var z=A.r[v];if(this.board[z]>=0&&z!=o.p&&z!=k.p){T=!1;break}}if(T){for(var E=!0,v=0;v<A.k.length;v++){var z=A.k[v];if(this.board[z]>=0&&z!=k.p&&z!=o.p||this.cbGetAttackers(t,z,s).length>0){E=!1;break}}E&&a.push({f:o.p,t:A.k[A.k.length-1],c:null,cg:k.p})}}}return a},Model.Board.cbStaticExchangeEval=function(t,e,r,a){var i=0,s=this.cbGetSmallestAttacker(t,e,r);if(s){var n=this.mWho;this.mWho=s.s;var o=this.cbQuickApply(t,{f:s.p,t:e,c:a.piece.i}),h=t.g.pTypes[a.piece.t].value;a.piece=s,i=Math.max(0,h-this.cbStaticExchangeEval(t,e,-r,a)),this.cbQuickUnapply(t,o),this.mWho=n}return i},Model.Board.cbGetSmallestAttacker=function(t,e,r){var a=this.cbGetAttackers(t,e,r);if(0==a.length)return null;for(var i=1/0,s=null,n=a.length,o=0;o<n;o++){var h=a[o],c=t.g.pTypes[h.t].value;c<i&&(i=c,s=h)}return s},Model.Board.cbCollectAttackers=function(t,e,r,a){for(var i in e){var s=e[i],n=this.board[i];if(n<0)this.cbCollectAttackers(t,s.e,r,a);else{var o=this.pieces[n];o.s==-t&&(s.t&&o.t in s.t||a&&s.tk&&o.t in s.tk)&&r.push(o)}}},Model.Board.cbCollectAttackersScreen=function(t,e,r,a,i){for(var s in e){var n=e[s],o=this.board[s];if(o<0)this.cbCollectAttackersScreen(t,n.e,r,a,i);else{var h=this.pieces[o];!i&&h.s==-t&&(n.t&&h.t in n.t||a&&n.tk&&h.t in n.tk)?r.push(h):i?i&&h.s==-t&&n.ts&&h.t in n.ts&&r.push(h):this.cbCollectAttackersScreen(t,n.e,r,a,!0)}}},Model.Board.cbGetAttackers=function(t,e,r,a){var i=[];return t.cbUseScreenCapture?this.cbCollectAttackersScreen(r,t.g.threatGraph[r][e],i,a,!1):this.cbCollectAttackers(r,t.g.threatGraph[r][e],i,a),i},Model.Board.GenerateMoves=function(t){var e=this.cbGeneratePseudoLegalMoves(t);this.mMoves=[];for(var r=!0,a=this.kings[this.mWho],i=e.length,s=0;s<i;s++){var n=e[s],o=this.cbQuickApply(t,n);if(!(this.cbGetAttackers(t,this.kings[this.mWho],this.mWho,!0).length>0)){var h=this.cbGetAttackers(t,this.kings[-this.mWho],-this.mWho,!0).length>0;n.ck=h,this.mMoves.push(n),n.f!=a&&(r=!1)}this.cbQuickUnapply(t,o)}if(0==this.mMoves.length)this.mFinished=!0,this.mWinner=t.cbOnStaleMate?t.cbOnStaleMate*this.mWho:JocGame.DRAW,this.check&&(this.mWinner=-this.mWho);else if(this.ending[this.mWho]){if(!r)for(var s=0;s<this.mMoves.length;s++)this.mMoves[s].ko=!1}else if(!this.ending[this.mWho]&&r&&!this.check)for(var s=0;s<this.mMoves.length;s++)this.mMoves[s].ko=!0},Model.Board.GetSignature=function(){return this.zSign},Model.Move.Init=function(t){for(var e in t)t.hasOwnProperty(e)&&(this[e]=t[e])},Model.Move.Equals=function(t){return this.f==t.f&&this.t==t.t&&this.pr==t.pr},Model.Move.CopyFrom=function(t){this.Init(t)},Model.Move.ToString=function(e){var r=this;switch(e=e||"natural"){case"natural":return function(){var e;if(void 0!==r.cg?e=t.castle[r.f+"/"+r.cg].n:(e=r.a||"",e+=t.geometry.PosName(r.f),null==r.c?e+="-":e+="x",e+=t.geometry.PosName(r.t)),void 0!==r.pr){var a=t.pieceTypes[r.pr];a&&a.abbrev&&a.abbrev.length>0&&!a.silentPromo&&(e+="="+a.abbrev)}return r.ck&&(e+="+"),e}();case"engine":return function(){var e=t.geometry.PosName(r.f)+t.geometry.PosName(r.t);if(void 0!=r.pr){var a=t.pieceTypes[r.pr];a&&a.abbrev&&a.abbrev.length>0&&!a.silentPromo&&(e+=a.abbrev)}return e}();default:return"??"}},Model.Board.CompactMoveString=function(e,r,a){"function"!=typeof r.ToString&&(r=e.CreateMove(r));var i=r.ToString(),s=/^([A-Z]?)([a-z])([1-9][0-9]*)([-x])([a-z])([1-9][0-9]*)(.*?)$/.exec(i);if(!s)return i;var n=s[7];if(a||(a={}),a.value||(a.value=[]),0==a.value.length){var o=this.mMoves;this.mMoves&&0!=this.mMoves.length||this.GenerateMoves(e);for(var h=0;h<this.mMoves.length;h++){var c=this.mMoves[h];"function"!=typeof c.ToString&&(c=e.CreateMove(c)),a.value.push({str:c.ToString(),move:c})}this.mMoves=o}var p=[];if(a.value.forEach(function(t){var e=/^([A-Z]?[a-z][1-9][0-9]*[-x][a-z][1-9][0-9]*)(.*?)$/.exec(t.str);e&&t.move.t==r.t&&(t.move.a||"")==s[1]&&e[2]==n&&p.push(t.move)}),1==p.length)return""==s[1]&&"x"==s[4]?s[2]+"x"+s[5]+s[6]+s[7]:s[1]+("x"==s[4]?"x":"")+s[5]+s[6]+s[7];if(t.geometry.CompactCrit)for(var l="",h=0;;h++){var u=t.geometry.CompactCrit(r.f,h);if(null==u)return i;l+=u;for(var b=[],v=0;v<p.length;v++){var f=p[v];t.geometry.CompactCrit(f.f,h)==u&&b.push(f)}if(console.assert(b.length>0),1==b.length)return s[1]+l+("x"==s[4]?"x":"")+s[5]+s[6]+s[7];p=b}return i},Model.Board.cbIntegrity=function(t){function e(t,e){t||console.error(e)}for(var r=this,a=0;a<this.board.length;a++){var i=this.board[a];if(i>=0){var s=r.pieces[i];e(void 0!==s,"no piece at pos"),e(s.p==a,"piece has different pos")}}for(var i=0;i<this.pieces.length;i++){var s=this.pieces[i];s.p>=0&&e(r.board[s.p]==i,"board index mismatch")}},Model.Board.ExportBoardState=function(t){return t.cbVar.geometry.ExportBoardState?t.cbVar.geometry.ExportBoardState(this,t.cbVar,t.mPlayedMoves.length):"not supported"},Model.Game.Import=function(e,r){var a,i=[],s={1:{},"-1":{}},n=null,o=0;if("pjn"==e){var h={status:!1,error:"parse"},c=r.split(" ");if(6!=c.length)return console.warn("FEN should have 6 parts"),h;var p=c[0].split("/"),l=t.geometry.fenHeight||t.geometry.height;if(p.length!=l)return console.warn("FEN board should have",l,"rows, got",p.length),h;var u={};for(var b in t.pieceTypes){var v=t.pieceTypes[b],f=v.fenAbbrev||v.abbrev||"X";u[f.toUpperCase()]={s:1,t:b},u[f.toLowerCase()]={s:-1,t:b}}var g=t.geometry.FenRowPos||function(e,r){return(t.geometry.height-1-e)*t.geometry.width+r};if(p.forEach(function(e,r){for(var a=0,s=0;s<e.length;s++){var n=e.substr(s,1),o=u[n];if(void 0!==o){var c=g(r,a);a++;for(var p={s:o.s,t:o.t,p:c},l=!0,b=t.pieceTypes[p.t].initial||[],v=0;v<b.length;v++){var f=b[v];f.s==p.s&&f.p==c&&(l=!1)}p.m=l,i.push(p)}else{if(isNaN(parseInt(n)))return console.warn("FEN invalid board spec",n),h;a+=parseInt(n)}}}),i.sort(function(t,e){return e.s-t.s}),"w"==c[1])a=1;else{if("b"!=c[1])return console.warn("FEN invalid turn spec",c[1]),h;a=-1}s[1].k=c[2].indexOf("K")>=0,s[1].q=c[2].indexOf("Q")>=0,s[-1].k=c[2].indexOf("k")>=0,s[-1].q=c[2].indexOf("q")>=0,n="-"==c[3]?null:c[3];var d=parseInt(c[4]);isNaN(d)||(o=d);var m={pieces:i,turn:a,castle:s,enPassant:n,noCaptCount:o};return t.importGame&&t.importGame.call(this,m,e,r),{status:!0,initial:m}}return{status:!1,error:"unsupported"}}}(),function(){Model.Game.cbBoardGeometryGrid=function(t,e){function r(e){return e%t}function a(e){return Math.floor(e/t)}function i(e,r){return r*t+e}function s(s,n){var o=r(s),h=a(s),c=o+n[0],p=h+n[1];return c<0||c>=t||p<0||p>=e?null:i(c,p)}function n(t){return String.fromCharCode("a".charCodeAt(0)+r(t))+(a(t)+1)}function o(t){var e=/^([a-z])([0-9]+)$/.exec(t);return e?i(e[1].charCodeAt(0)-"a".charCodeAt(0),parseInt(e[2])-1):-1}function h(t,e){return 0==e?String.fromCharCode("a".charCodeAt(0)+r(t)):1==e?a(t)+1:null}function c(){for(var i=[],s=0;s<t*e;s++){var n=[];i.push(n);for(var o=0;o<t*e;o++){var h=a(s),c=r(s),p=a(o),l=r(o);n.push(Math.max(Math.abs(h-p),Math.abs(c-l)))}}return i}function p(r,a,s){for(var o=[],h=e-1;h>=0;h--){for(var c="",p=0,l=0;l<t;l++){var u=r.board[i(l,h)];if(u<0)p++;else{p>0&&(c+=p,p=0);var b=r.pieces[u],v=a.pieceTypes[b.t].fenAbbrev||a.pieceTypes[b.t].abbrev||"?";b.s==-1?c+=v.toLowerCase():c+=v.toUpperCase()}}p&&(c+=p),o.push(c)}var f=o.join("/");f+=" ",1==r.mWho?f+="w":f+="b",f+=" ";var g="";return r.castled&&(r.castled[1]===!1?g+="KQ":(r.castled[1].k&&(g+="K"),r.castled[1].q&&(g+="Q")),r.castled[-1]===!1?g+="kq":(r.castled[-1].k&&(g+="k"),r.castled[-1].q&&(g+="q"))),0==g.length&&(g="-"),f+=g,f+=" ",r.epTarget?f+=n(r.epTarget.p):f+="-",f+=" ",f+=r.noCaptCount,f+=" ",f+=Math.floor(s/2)+1}return{boardSize:t*e,width:t,height:e,C:r,R:a,POS:i,Graph:s,PosName:n,PosByName:o,CompactCrit:h,GetDistances:c,distEdge:function(){for(var i=[],s=0;s<t*e;s++){var n=r(s),o=a(s);i[s]=Math.min(n,Math.abs(t-n-1),o,Math.abs(e-o-1))}return i}(),corners:function(){var r={};return r[i(0,0)]=1,r[i(0,e-1)]=1,r[i(t-1,0)]=1,r[i(t-1,e-1)]=1,r}(),ExportBoardState:p}},Model.Game.cbPawnGraph=function(t,e,r){for(var a=this,i={},s=0;s<t.boardSize;s++)if(!r||s in r){var n=[],o=t.Graph(s,[0,e]);null!=o&&(!r||o in r)&&n.push(a.cbTypedArray([o|a.cbConstants.FLAG_MOVE])),[-1,1].forEach(function(i){var o=t.Graph(s,[i,e]);null!=o&&(!r||o in r)&&n.push(a.cbTypedArray([o|a.cbConstants.FLAG_CAPTURE]))}),i[s]=n}else i[s]=[];return i},Model.Game.cbInitialPawnGraph=function(t,e,r){for(var a=this,i={},s=0;s<t.boardSize;s++)if(!r||s in r){var n=[],o=t.Graph(s,[0,e]);if(null!=o&&(!r||o in r)){var h=[o|a.cbConstants.FLAG_MOVE],c=t.Graph(o,[0,e]);null!=c&&(!r||c in r)&&h.push(c|a.cbConstants.FLAG_MOVE),n.push(a.cbTypedArray(h))}[-1,1].forEach(function(i){var o=t.Graph(s,[i,e]);null!=o&&(!r||o in r)&&n.push(a.cbTypedArray([o|a.cbConstants.FLAG_CAPTURE]))}),i[s]=n}else i[s]=[];return i},Model.Game.cbKingGraph=function(t,e){return this.cbShortRangeGraph(t,[[-1,-1],[-1,0],[-1,1],[0,-1],[0,1],[1,-1],[1,0],[1,1]],e)},Model.Game.cbKnightGraph=function(t,e){return this.cbShortRangeGraph(t,[[2,-1],[2,1],[-2,-1],[-2,1],[-1,2],[-1,-2],[1,2],[1,-2]],e)},Model.Game.cbHorseGraph=function(t){for(var e=this,r={},a=0;a<t.boardSize;a++)r[a]=[],[[1,0,2,-1],[1,0,2,1],[-1,0,-2,-1],[-1,0,-2,1],[0,1,-1,2],[0,-1,-1,-2],[0,1,1,2],[0,-1,1,-2]].forEach(function(i){var s=t.Graph(a,[i[0],i[1]]);if(null!=s){var n=t.Graph(a,[i[2],i[3]]);null!=n&&r[a].push(e.cbTypedArray([s|e.cbConstants.FLAG_STOP,n|e.cbConstants.FLAG_MOVE|e.cbConstants.FLAG_CAPTURE]))}});return r},Model.Game.cbRookGraph=function(t,e){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0]],e)},Model.Game.cbBishopGraph=function(t,e){return this.cbLongRangeGraph(t,[[1,-1],[1,1],[-1,1],[-1,-1]],e)},Model.Game.cbQueenGraph=function(t,e){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0],[1,-1],[1,1],[-1,1],[-1,-1]],e)},Model.Game.cbXQGeneralGraph=function(t,e){for(var r=this,a={},i=0;i<t.boardSize;i++)a[i]=[],[[-1,0,!1],[0,-1,!0],[0,1,!0],[1,0,!1]].forEach(function(s){var n=[],o=t.Graph(i,s);if(null!=o&&((!e||o in e)&&n.push(o|r.cbConstants.FLAG_MOVE|r.cbConstants.FLAG_CAPTURE),s[2]))for(var h=t.Graph(o,s);null!=h;)!e||h in e?n.push(h|r.cbConstants.FLAG_CAPTURE|r.cbConstants.FLAG_CAPTURE_KING):n.push(h|r.cbConstants.FLAG_STOP),h=t.Graph(h,s);n.length>0&&a[i].push(r.cbTypedArray(n))});return a},Model.Game.cbXQSoldierGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e]])},Model.Game.cbXQPromoSoldierGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e],[-1,0],[1,0]])},Model.Game.cbXQAdvisorGraph=function(t,e){return this.cbShortRangeGraph(t,[[1,1],[-1,1],[1,-1],[-1,-1]],e)},Model.Game.cbXQCannonGraph=function(t){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0]],null,this.cbConstants.FLAG_MOVE|this.cbConstants.FLAG_SCREEN_CAPTURE)},Model.Game.cbXQElephantGraph=function(t,e){for(var r=this,a={},i=0;i<t.boardSize;i++)a[i]=[],(!e||i in e)&&[[1,1,2,2],[1,-1,2,-2],[-1,1,-2,2],[-1,-1,-2,-2]].forEach(function(s){var n=t.Graph(i,[s[0],s[1]]);if(null!=n){var o=t.Graph(i,[s[2],s[3]]);null!=o&&(!e||o in e)&&a[i].push(r.cbTypedArray([n|r.cbConstants.FLAG_STOP,o|r.cbConstants.FLAG_MOVE|r.cbConstants.FLAG_CAPTURE]))}});return a},Model.Game.cbSilverGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e],[-1,-1],[-1,1],[1,-1],[1,1]])},Model.Game.cbFersGraph=function(t,e){return this.cbShortRangeGraph(t,[[-1,-1],[-1,1],[1,-1],[1,1]])},Model.Game.cbSchleichGraph=function(t,e){return this.cbShortRangeGraph(t,[[-1,0],[1,0],[0,-1],[0,1]])},Model.Game.cbAlfilGraph=function(t,e){return this.cbShortRangeGraph(t,[[-2,-2],[-2,2],[2,2],[2,-2]])}}(),function(){var t=Model.Game.cbBoardGeometryGrid(10,8);Model.Game.cbDefine=function(){return{geometry:t,pieceTypes:{0:{name:"pawn-w",aspect:"fr-pawn",graph:this.cbPawnGraph(t,1),value:1,abbrev:"",fenAbbrev:"P",epCatch:!0},1:{name:"ipawn-w",aspect:"fr-pawn",graph:this.cbInitialPawnGraph(t,1),value:1,abbrev:"",fenAbbrev:"P",initial:[{s:1,p:10},{s:1,p:11},{s:1,p:12},{s:1,p:13},{s:1,p:14},{s:1,p:15},{s:1,p:16},{s:1,p:17},{s:1,p:18},{s:1,p:19}],epTarget:!0},2:{name:"pawn-b",aspect:"fr-pawn",graph:this.cbPawnGraph(t,-1),value:1,abbrev:"",fenAbbrev:"P",epCatch:!0},3:{name:"ipawn-b",aspect:"fr-pawn",graph:this.cbInitialPawnGraph(t,-1),value:1,abbrev:"",fenAbbrev:"P",initial:[{s:-1,p:60},{s:-1,p:61},{s:-1,p:62},{s:-1,p:63},{s:-1,p:64},{s:-1,p:65},{s:-1,p:66},{s:-1,p:67},{s:-1,p:68},{s:-1,p:69}],epTarget:!0},4:{name:"knight",aspect:"fr-knight",graph:this.cbKnightGraph(t),value:2.9,abbrev:"N",initial:[{s:1,p:1},{s:1,p:8},{s:-1,p:71},{s:-1,p:78}]},5:{name:"bishop",aspect:"fr-bishop",graph:this.cbBishopGraph(t),value:3.1,abbrev:"B",initial:[{s:1,p:3},{s:1,p:6},{s:-1,p:73},{s:-1,p:76}]},6:{name:"rook",aspect:"fr-rook",graph:this.cbRookGraph(t),value:5,abbrev:"R",initial:[{s:1,p:0},{s:1,p:9},{s:-1,p:70},{s:-1,p:79}],castle:!0},7:{name:"queen",aspect:"fr-queen",graph:this.cbQueenGraph(t),value:9,abbrev:"Q",initial:[{s:1,p:4},{s:-1,p:74}]},8:{name:"king",aspect:"fr-king",isKing:!0,graph:this.cbKingGraph(t),abbrev:"K",initial:[{s:1,p:5},{s:-1,p:75}]},9:{name:"chancellor",aspect:"fr-marshall",graph:this.cbMergeGraphs(t,this.cbRookGraph(t),this.cbKnightGraph(t)),value:7.8,abbrev:"C",initial:[{s:1,p:7},{s:-1,p:77}]},10:{name:"archbishop",aspect:"fr-cardinal",graph:this.cbMergeGraphs(t,this.cbBishopGraph(t),this.cbKnightGraph(t)),value:6,abbrev:"A",initial:[{s:1,p:2},{s:-1,p:72}]}},promote:function(e,r,a){return 1==r.t?[0]:3==r.t?[2]:0==r.t&&7==t.R(a.t)?[4,5,6,7,9,10]:2==r.t&&0==t.R(a.t)?[4,5,6,7,9,10]:[]},castle:{"5/0":{k:[4,3,2],r:[1,2,3],n:"O-O-O"},"5/9":{k:[6,7,8],r:[8,7],n:"O-O"},"75/70":{k:[74,73,72],r:[71,72,73],n:"O-O-O"},"75/79":{k:[76,77,78],r:[78,77],n:"O-O"}}}}}();

/***/ }),

/***/ "6s76":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var groupBy_1 = __webpack_require__("cJSH");
Observable_1.Observable.prototype.groupBy = groupBy_1.groupBy;
//# sourceMappingURL=groupBy.js.map

/***/ }),

/***/ "77/N":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var takeLast_1 = __webpack_require__("l19J");
Observable_1.Observable.prototype.takeLast = takeLast_1.takeLast;
//# sourceMappingURL=takeLast.js.map

/***/ }),

/***/ "77D1":
/***/ (function(module, exports) {

exports.config = {"status":true,"model":{"plazza":"true","title-en":"German Draughts","module":"checkers","maxLevel":20,"summary":"Checkers according to German Draughts rules.","thumbnail":"draughts8-thumb3d.png","rules":"rules-german-draughts.html","description":"description.html","credits":"credits.html","js":["checkersbase-model.js","draughts-model.js"],"gameOptions":{"preventRepeat":true,"width":4,"height":8,"initial":{"a":[[0,0],[0,1],[0,2],[0,3],[1,0],[1,1],[1,2],[1,3],[2,0],[2,1],[2,2],[2,3]],"b":[[7,0],[7,1],[7,2],[7,3],[6,0],[6,1],[6,2],[6,3],[5,0],[5,1],[5,2],[5,3]]},"variant":{"mustMoveForwardStrict":true,"lastRowCrown":true,"captureLongestLine":false,"lastRowFactor":0.001,"kingValue":4,"kingCaptureShort":false,"captureInstantRemove":true},"uctTransposition":"state"},"levels":[{"label":"Fast","ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.5,"maxDuration":1,"isDefault":true},{"label":"Beginner","ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.5,"maxDuration":0.5,"maxNodes":100,"maxLoops":200},{"label":"Easy","ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.5,"maxDuration":1,"maxNodes":2500,"maxLoops":500},{"label":"Medium","ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.5,"maxDuration":2,"maxNodes":5500,"maxLoops":500},{"label":"Hard","ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.5,"maxDuration":5,"maxNodes":2000,"maxLoops":3500},{"label":"Expert","ai":"uct","c":0.8,"playoutDepth":0,"minVisitsExpand":1,"ignoreLeaf":false,"uncertaintyFactor":5,"propagateMultiVisits":false,"maxDuration":60,"maxNodes":15000,"maxLoops":8000}]},"view":{"js":["checkers-xd-view.js","draughts8-xd-view.js"],"css":["checkersbase.css","draughts.css"],"title-en":"Draughts View","skins":[{"name":"classic3d","title":"3D Classic","3d":true,"camera":{"radius":24,"elevationAngle":65,"limitCamMoves":true,"distMax":30,"fov":35},"world":{"lightIntensity":0.7,"skyLightIntensity":0.5,"lightPosition":{"x":-15,"y":15,"z":0},"lightShadowDarkness":0.45,"ambientLightColor":8947848,"color":4686804,"fog":false},"preload":["image|/res/images/wood-chipboard-5.jpg","image|/res/xd-view/meshes/piecetop-bump.jpg","image|/res/xd-view/meshes/piecediff.jpg","image|/res/xd-view/meshes/piecetop-queen-mask.png","smoothedfilegeo|0|/res/xd-view/meshes/ring-target.js","smoothedfilegeo|0|/res/xd-view/meshes/piece-v2.js"]},{"name":"turtles3d","title":"3D Turtles","3d":true,"camera":{"radius":14,"elevationAngle":45,"limitCamMoves":true,"distMax":40},"world":{"lightIntensity":0,"skyLightIntensity":3,"fog":true,"color":3645658,"lightPosition":{"x":-5,"y":18,"z":5},"lightShadowDarkness":0.55,"ambientLightColor":4473924},"preload":["image|/res/images/wood-chipboard-5.jpg","image|/res/xd-view/meshes/turtle.png","image|/res/xd-view/meshes/star.png","image|/res/xd-view/meshes/rock.jpg","smoothedfilegeo|0|/res/xd-view/meshes/turtle-legs-smoothed.js","smoothedfilegeo|0|/res/xd-view/meshes/turtle-head-smoothed.js","smoothedfilegeo|0|/res/xd-view/meshes/turtle-tail-smoothed.js","smoothedfilegeo|0|/res/xd-view/meshes/turtle-hotel.js","smoothedfilegeo|0|/res/xd-view/meshes/turtle-house.js","smoothedfilegeo|0|/res/xd-view/meshes/rainbowflat.js","smoothedfilegeo|0|/res/xd-view/meshes/ring-target.js","smoothedfilegeo|0|/res/xd-view/meshes/rocksmoothed.js","smoothedfilegeo|0|/res/xd-view/meshes/turtle-fences.js"]},{"name":"classical","title":"Classic"},{"name":"marble0","title":"Marble"},{"name":"wood0","title":"Wood"},{"name":"green","title":"Green"}],"visuals":{"600x600":["res/visuals/german-draughts-600x600-3d.jpg","res/visuals/german-draughts-600x600-2d.jpg"]},"sounds":{"move1":"move1","move2":"move2","move3":"move3","move4":"move4","tac1":"tac1","tac2":"tac1","tac3":"tac1","promo":"promo","usermove":null},"module":"checkers","preferredRatio":1,"switchable":true,"animateSelfMoves":false,"useNotation":true,"useShowMoves":true,"defaultOptions":{"sounds":true,"notation":false,"moves":true},"xdView":true}}

/***/ }),

/***/ "7C+Y":
/***/ (function(module, exports) {

exports.config = {"status":true,"model":{"plazza":"true","released":1482940591,"title-en":"Sweet 16 Chess","module":"chessbase","summary":"A huge 16x16 Chess Variant","thumbnail":"sweet16-thumb.png","rules":{"en":"sweet16-rules.html"},"credits":{"en":"sweet16-credits.html"},"gameOptions":{"preventRepeat":true,"uctTransposition":"state","uctIgnoreLoop":false,"levelOptions":[]},"obsolete":false,"js":["base-model.js","grid-geo-model.js","sweet16-model.js"],"description":{"en":"sweet16-description.html"},"levels":[{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"easy","label":"Easy","maxNodes":1000},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"fast","label":"Fast [1sec]","maxDuration":1,"isDefault":true},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"medium","label":"Medium","maxNodes":10000,"maxDuration":10},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"strong","label":"Strong","maxNodes":20000,"maxDuration":15}]},"view":{"title-en":"Chessbase view","module":"chessbase","xdView":true,"css":["chessbase.css"],"preferredRatio":1,"useShowMoves":true,"useNotation":true,"useAutoComplete":true,"defaultOptions":{"sounds":true,"moves":true,"notation":false,"autocomplete":false},"skins":[{"name":"skin3d","title":"3D Classic","3d":true,"preload":["smoothedfilegeo|0|/res/ring-target.js","image|/res/images/cancel.png","image|/res/images/wikipedia.png","smoothedfilegeo|0|/res/staunton/pawn/pawn-classic.js","image|/res/staunton/pawn/pawn-diffusemap.jpg","image|/res/staunton/pawn/pawn-normalmap.jpg","smoothedfilegeo|0|/res/staunton/knight/knight.js","image|/res/staunton/knight/knight-diffusemap.jpg","image|/res/staunton/knight/knight-normalmap.jpg","smoothedfilegeo|0|/res/staunton/bishop/bishop.js","image|/res/staunton/bishop/bishop-diffusemap.jpg","image|/res/staunton/bishop/bishop-normalmap.jpg","smoothedfilegeo|0|/res/staunton/rook/rook.js","image|/res/staunton/rook/rook-diffusemap.jpg","image|/res/staunton/rook/rook-normalmap.jpg","smoothedfilegeo|0|/res/staunton/queen/queen.js","image|/res/staunton/queen/queen-diffusemap.jpg","image|/res/staunton/queen/queen-normalmap.jpg","smoothedfilegeo|0|/res/staunton/king/king.js","image|/res/staunton/king/king-diffusemap.jpg","image|/res/staunton/king/king-normalmap.jpg"],"world":{"lightIntensity":1.3,"skyLightIntensity":1.2,"lightCastShadow":true,"fog":false,"color":4686804,"lightPosition":{"x":-9,"y":9,"z":9},"skyLightPosition":{"x":9,"y":9,"z":9},"lightShadowDarkness":0.55,"ambientLightColor":2236962},"camera":{"fov":45,"distMax":50,"radius":18,"elevationAngle":60,"elevationMin":0}},{"name":"skin2d","title":"2D Classic","3d":false,"preload":["image|/res/images/cancel.png","image|/res/images/whitebg.png","image|/res/images/wikipedia.png"]}],"animateSelfMoves":false,"switchable":true,"sounds":{"move1":"alq_move1","move2":"alq_move2","move3":"alq_move3","move4":"alq_move2","tac1":"alq_tac1","tac2":"alq_tac2","tac3":"alq_tac1","promo":"promo","usermove":null},"js":["base-view.js","grid-board-view.js","staunton-set-view.js","sweet16-view.js"],"visuals":{"600x600":["res/visuals/sweet16-600x600-3d.jpg","res/visuals/sweet16-600x600-2d.jpg"]}}}

/***/ }),

/***/ "7FaQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var window_1 = __webpack_require__("Llwz");
Observable_1.Observable.prototype.window = window_1.window;
//# sourceMappingURL=window.js.map

/***/ }),

/***/ "7Gky":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function not(pred, thisArg) {
    function notPred() {
        return !(notPred.pred.apply(notPred.thisArg, arguments));
    }
    notPred.pred = pred;
    notPred.thisArg = thisArg;
    return notPred;
}
exports.not = not;
//# sourceMappingURL=not.js.map

/***/ }),

/***/ "7axH":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var toArray_1 = __webpack_require__("9PGs");
Observable_1.Observable.prototype.toArray = toArray_1.toArray;
//# sourceMappingURL=toArray.js.map

/***/ }),

/***/ "7bMZ":
/***/ (function(module, exports) {

exports.model=Model={Game:{},Board:{},Move:{}},function(){var t;Model.Game.cbConstants={MASK:65535,FLAG_MOVE:65536,FLAG_CAPTURE:131072,FLAG_STOP:262144,FLAG_SCREEN_CAPTURE:524288,FLAG_CAPTURE_KING:1048576,FLAG_CAPTURE_NO_KING:2097152};var e="undefined"!=typeof Int32Array;Model.Game.cbUseTypedArrays=e,Model.Game.cbTypedArray=function(t){if(e){var i=new Int32Array(t.length);return i.set(t),i}for(var r=[],a=t.length,n=0;n<a;n++)r.push(t[n]);return r},Model.Game.cbShortRangeGraph=function(t,e,i,r){var a=this;void 0===r&&(r=196608);for(var n={},s=0;s<t.boardSize;s++)n[s]=[],(!i||s in i)&&e.forEach(function(e){var o=t.Graph(s,e);null!=o&&(!i||o in i)&&n[s].push(a.cbTypedArray([o|r]))});return n},Model.Game.cbLongRangeGraph=function(t,e,i,r,a){var n=this;void 0!==r&&null!=r||(r=196608),a||(a=1/0);for(var s={},o=0;o<t.boardSize;o++)s[o]=[],(!i||o in i)&&e.forEach(function(e){for(var h=[],c=t.Graph(o,e),p=0;null!=c&&(!i||c in i)&&(h.push(c|r),++p!=a);)c=t.Graph(c,e);h.length>0&&s[o].push(n.cbTypedArray(h))});return s},Model.Game.cbNullGraph=function(t){for(var e={},i=0;i<t.boardSize;i++)e[i]=[];return e},Model.Game.cbAuthorGraph=function(t){for(var e={},i=0;i<t.boardSize;i++){e[i]=[];for(var r=0;r<t.boardSize;r++)e[i].push([2293760|r])}return e},Model.Game.cbMergeGraphs=function(t){for(var e=[],i=0;i<t.boardSize;i++){e[i]=[];for(var r=1;r<arguments.length;r++)e[i]=e[i].concat(arguments[r][i])}return e},Model.Game.cbGetThreatGraph=function(){function t(e,i){for(var r in s){var a=s[r];if(!(a.p.length<i.length+1)){for(var n=!0,o=0;o<i.length;o++)if(i[o]!=a.p[o]){n=!1;break}if(n){var h=a.p[i.length],c=e[h];void 0===c&&(c={e:{}},e[h]=c),a.p.length==i.length+1&&(c.t=a.t,c.ts=a.ts,c.tk=a.tk,delete s[r]),i.push(h),t(c.e,i),i.pop()}}}}var e=this;this.cbUseScreenCapture=!1,this.cbUseCaptureKing=!1,this.cbUseCaptureNoKing=!1;for(var i={1:[],"-1":[]},r=[],a=0;a<this.g.boardSize;a++)this.g.pTypes.forEach(function(t,i){t.graph[a].forEach(function(t){for(var n=[],s=0;s<t.length;s++){var o=t[s];1048576&o?(e.cbUseCaptureKing=!0,n.unshift({d:65535&o,a:a,tk:i})):2097152&o?(e.cbUseCaptureNoKing=!0,n.unshift({d:65535&o,a:a,tnk:i})):131072&o?n.unshift({d:65535&o,a:a,t:i}):262144&o?n.unshift({d:65535&o,a:a}):524288&o&&(e.cbUseScreenCapture=!0,n.unshift({d:65535&o,a:a,ts:i}))}n.length>0&&r.push(n)})});var n={};r.forEach(function(t){t.forEach(function(e,i){var r=n[e.d];void 0===r&&(r={},n[e.d]=r);for(var a=[],s=i+1;s<t.length;s++)a.push(t[s].d);a.push(e.a);var o=a.join(","),h=r[o];void 0===h&&(h={p:a,t:{},ts:{},tk:{}},r[o]=h),void 0!==e.t?h.t[e.t]=!0:void 0!==e.tk?h.tk[e.tk]=!0:void 0!==e.ts&&(h.ts[e.ts]=!0)})});for(var a=0;a<e.g.boardSize;a++){var s=n[a],o={};t(o,[]),i[1][a]=o,i[-1][a]=o}return i},Model.Game.InitGame=function(){var e=this;this.cbVar=t=this.cbDefine(),this.g.boardSize=this.cbVar.geometry.boardSize,this.g.pTypes=this.cbGetPieceTypes(),this.g.threatGraph=this.cbGetThreatGraph(),this.g.distGraph=this.cbVar.geometry.GetDistances(),this.cbPiecesCount=0,this.g.castleablePiecesCount={1:0,"-1":0};for(var i in t.pieceTypes){var r=t.pieceTypes[i];if(r.castle){(r.initial||[]).forEach(function(t){e.g.castleablePiecesCount[t.s]++})}r.initial&&(this.cbPiecesCount+=r.initial.length)}for(var a=[],i=0;i<this.cbPiecesCount;i++)a.push(i);var n=Object.keys(t.pieceTypes);this.zobrist=new JocGame.Zobrist({board:{type:"array",size:this.cbVar.geometry.boardSize,values:a},who:{values:["1","-1"]},type:{type:"array",size:this.cbPiecesCount,values:n}})},Model.Game.cbGetPieceTypes=function(){for(var t=[],e={},i=0;i<this.cbVar.geometry.boardSize;i++)e[i]=[];for(var r in this.cbVar.pieceTypes){var a=this.cbVar.pieceTypes[r];t[r]={graph:a.graph||e,abbrev:a.abbrev||"",value:a.isKing?100:a.value||1,isKing:!!a.isKing,castle:!!a.castle,epTarget:!!a.epTarget,epCatch:!!a.epCatch}}return t},Model.Board.Init=function(t){this.zSign=0},Model.Board.InitialPosition=function(i){var r=this;this.board=e?new Int16Array(i.g.boardSize):[];for(var a=0;a<i.g.boardSize;a++)this.board[a]=-1;if(this.kings={},this.pieces=[],this.ending={1:!1,"-1":!1},this.lastMove=null,i.cbVar.castle&&(this.castled={1:!1,"-1":!1}),this.zSign=i.zobrist.update(0,"who",-1),this.noCaptCount=0,this.mWho=1,i.mInitial)this.mWho=i.mInitial.turn||1,i.mInitial.pieces.forEach(function(t){var e={};for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i]);r.pieces.push(e)}),i.mInitial.lastMove&&(this.lastMove={f:i.mInitial.lastMove.f,t:i.mInitial.lastMove.t}),void 0!==i.mInitial.noCaptCount&&(this.noCaptCount=i.mInitial.noCaptCount),i.cbVar.castle&&i.mInitial.castle&&(this.castled={1:{k:!!i.mInitial.castle[1]&&!!i.mInitial.castle[1].k,q:!!i.mInitial.castle[1]&&!!i.mInitial.castle[1].q},"-1":{k:!!i.mInitial.castle[-1]&&!!i.mInitial.castle[-1].k,q:!!i.mInitial.castle[-1]&&!!i.mInitial.castle[-1].q}});else for(var n in i.cbVar.pieceTypes)for(var s=i.cbVar.pieceTypes[n],o=s.initial||[],h=0;h<o.length;h++){var c=o[h],p={s:c.s,t:parseInt(n),p:c.p,m:!1};this.pieces.push(p)}if(this.pieces.sort(function(t,e){if(t.s!=e.s)return e.s-t.s;var r=i.cbVar.pieceTypes[t.t].value||100,a=i.cbVar.pieceTypes[e.t].value||100;return r!=a?r-a:t.p-e.p}),this.pieces.forEach(function(t,e){t.i=e,r.board[t.p]=e,i.g.pTypes[t.t].isKing&&(r.kings[t.s]=t.p),r.zSign=i.zobrist.update(r.zSign,"board",e,t.p),r.zSign=i.zobrist.update(r.zSign,"type",t.t,e)}),i.mInitial&&i.mInitial.enPassant){var a=t.geometry.PosByName(i.mInitial.enPassant);if(a>=0){var l,u=t.geometry.C(a),v=t.geometry.R(a);l=1==i.mInitial.turn?t.geometry.POS(u,v-1):t.geometry.POS(u,v+1),this.epTarget={p:a,i:this.board[l]}}}},Model.Board.CopyFrom=function(t){if(e)this.board=new Int16Array(t.board.length),this.board.set(t.board);else{this.board=[];for(var i=t.board,r=i.length,a=0;a<r;a++)this.board.push(i[a])}this.pieces=[];for(var n=t.pieces.length,a=0;a<n;a++){var s=t.pieces[a];this.pieces.push({s:s.s,p:s.p,t:s.t,i:s.i,m:s.m})}this.kings={1:t.kings[1],"-1":t.kings[-1]},this.check=t.check,t.lastMove?this.lastMove={f:t.lastMove.f,t:t.lastMove.t,c:t.lastMove.c}:this.lastMove=null,this.ending={1:t.ending[1],"-1":t.ending[-1]},void 0!==t.castled&&(this.castled={1:t.castled[1],"-1":t.castled[-1]}),this.noCaptCount=t.noCaptCount,t.epTarget?this.epTarget={p:t.epTarget.p,i:t.epTarget.i}:this.epTarget=null,this.mWho=t.mWho,this.zSign=t.zSign},Model.Board.cbApplyCastle=function(t,e,i){var r=t.cbVar.castle[e.f+"/"+e.cg],a=r.r[r.r.length-1],n=this.pieces[this.board[e.cg]],s=r.k[r.k.length-1],o=this.pieces[this.board[e.f]];return i&&(this.zSign=t.zobrist.update(this.zSign,"board",n.i,e.cg),this.zSign=t.zobrist.update(this.zSign,"board",n.i,a),this.zSign=t.zobrist.update(this.zSign,"board",o.i,e.f),this.zSign=t.zobrist.update(this.zSign,"board",o.i,s)),n.p=a,n.m=!0,this.board[e.cg]=-1,o.p=s,o.m=!0,this.board[e.f]=-1,this.board[a]=n.i,this.board[s]=o.i,this.castled[n.s]=!0,this.kings[o.s]=s,[{i:n.i,f:a,t:-1},{i:o.i,f:s,t:e.f,kp:e.f,who:o.s,m:!1},{i:n.i,f:-1,t:e.cg,m:!1,cg:!1}]},Model.Board.cbQuickApply=function(t,e){if(void 0!==e.cg)return this.cbApplyCastle(t,e,!1);var i=[],r=this.board[e.f],a=this.pieces[r];if(null!=e.c){i.unshift({i:e.c,f:-1,t:this.pieces[e.c].p});var n=this.pieces[e.c];this.board[n.p]=-1,n.p=-1}var s=this.kings[a.s];return t.g.pTypes[a.t].isKing&&(this.kings[a.s]=e.t),i.unshift({i:r,f:e.t,t:e.f,kp:s,who:a.s,ty:a.t}),a.p=e.t,void 0!==e.pr&&(a.t=e.pr),this.board[e.f]=-1,this.board[e.t]=r,i},Model.Board.cbQuickUnapply=function(t,e){for(var i=0;i<e.length;i++){var r=e[i],a=this.pieces[r.i];r.f>=0&&(a.p=-1,this.board[r.f]=-1),r.t>=0&&(a.p=r.t,this.board[r.t]=r.i),void 0!==r.m&&(a.m=r.m),void 0!==r.kp&&(this.kings[r.who]=r.kp),void 0!=r.ty&&(a.t=r.ty),void 0!=r.cg&&(this.castled[a.s]=r.cg)}},Model.Board.ApplyMove=function(t,e){var i=this.pieces[this.board[e.f]];if(void 0!==e.cg)this.cbApplyCastle(t,e,!0);else{if(this.zSign=t.zobrist.update(this.zSign,"board",i.i,e.f),this.board[i.p]=-1,void 0!==e.pr&&(this.zSign=t.zobrist.update(this.zSign,"type",i.t,i.i),i.t=e.pr,this.zSign=t.zobrist.update(this.zSign,"type",i.t,i.i)),null!=e.c){var r=this.pieces[e.c];this.zSign=t.zobrist.update(this.zSign,"board",r.i,r.p),this.board[r.p]=-1,r.p=-1,r.m=!0,this.noCaptCount=0}else this.noCaptCount++;i.p=e.t,i.m=!0,this.board[e.t]=i.i,this.zSign=t.zobrist.update(this.zSign,"board",i.i,e.t),t.g.pTypes[i.t].isKing&&(this.kings[i.s]=e.t)}this.check=!!e.ck,this.lastMove={f:e.f,t:e.t,c:e.c},void 0!==e.ko&&(this.ending[i.s]=e.ko),void 0!==e.ept?this.epTarget={p:e.ept,i:i.i}:this.epTarget=null,this.zSign=t.zobrist.update(this.zSign,"who",-this.mWho),this.zSign=t.zobrist.update(this.zSign,"who",this.mWho)},Model.Board.Evaluate=function(i){function r(e){var i=1/0;for(var r in t.geometry.corners)i=Math.min(i,h.distGraph[n.kings[e]][r]);return i-Math.sqrt(h.boardSize)}var a="debug"==arguments[3],n=this;this.mEvaluation=0;var s,o=this.mWho,h=i.g;if(e)s={1:{count:new Uint8Array(h.pTypes.length),byType:{}},"-1":{count:new Uint8Array(h.pTypes.length),byType:{}}};else{s={1:{count:[],byType:{}},"-1":{count:[],byType:{}}};for(var c=0;c<h.pTypes.length;c++)s[1].count[c]=s[-1].count[c]=0}if(i.mOptions.preventRepeat&&i.GetRepeatOccurence(this)>2)return this.mFinished=!0,void(this.mWinner=i.cbOnPerpetual?o*i.cbOnPerpetual:JocGame.DRAW);for(var p={1:0,"-1":0},l={1:h.distGraph[this.kings[-1]],"-1":h.distGraph[this.kings[1]]},u={1:0,"-1":0},v={1:0,"-1":0},f={1:0,"-1":0},b={1:0,"-1":0},d={1:!1,"-1":!1},g=this.pieces,m=g.length,c=0;c<m;c++){var G=g[c];if(G.p>=0){var y=G.s,M=h.pTypes[G.t];M.isKing?d[y]=G.m:p[y]+=M.value,M.castle&&!G.m&&b[y]++,v[y]++,u[y]+=l[y][G.p],f[y]+=t.geometry.distEdge[G.p];var C=s[y];C.count[G.t]++;var S=C.byType;void 0===S[G.t]?S[G.t]=[G]:S[G.t].push(G)}}if(this.lastMove&&null!=this.lastMove.c){var G=this.pieces[this.board[this.lastMove.t]];p[-G.s]+=this.cbStaticExchangeEval(i,G.p,G.s,{piece:G})}var k={1:0,"-1":0},A={1:0,"-1":0},T={1:0,"-1":0};this.ending[1]&&(A[1]=(u[1]-Math.sqrt(h.boardSize))/v[1],t.geometry.corners&&(T[1]=r(1))),this.ending[-1]&&(A[-1]=(u[-1]-Math.sqrt(h.boardSize))/v[-1],t.geometry.corners&&(T[1]=r(-1)));var z={pieceValue:p[1]-p[-1],pieceValueRatio:(p[1]-p[-1])/(p[1]+p[-1]+1),posValue:f[1]-f[-1],averageDistKing:u[1]/v[1]-u[-1]/v[-1],check:this.check?-o:0,endingKingFreedom:k[1]-k[-1],endingDistKing:A[1]-A[-1],distKingCorner:T[1]-T[-1]};t.castle&&(z.castle=(this.castled[1]?1:d[1]?0:b[1]/(h.castleablePiecesCount[1]+1))-(this.castled[-1]?1:d[-1]?0:b[-1]/(h.castleablePiecesCount[-1]+1))),t.evaluate&&t.evaluate.call(this,i,z,s);var E=i.mOptions.levelOptions;for(var P in z){var R=z[P],F=E[P+"Factor"]||0,I=R*F;a&&console.log(P,"=",R,"*",F,"=>",I),this.mEvaluation+=I}a&&console.log("Evaluation",this.mEvaluation)},Model.Board.cbGeneratePseudoLegalMoves=function(t){function e(e,a){var n=t.cbVar.promote;if(!n)return void r.push(a);var s=n.call(i,t,e,a);if(null!=s)if(0==s.length)r.push(a);else if(1==s.length)a.pr=s[0],r.push(a);else for(var o=0;o<s.length;o++){var h=s[o];r.push({f:a.f,t:a.t,c:a.c,pr:h,ept:a.ept,ep:a.ep,a:a.a})}}for(var i=this,r=[],a=t.cbVar,n=this.mWho,s=!a.castle||this.check||this.castled[n]?null:[],o=-1,h=this.pieces.length,c=0;c<h;c++){var p=this.pieces[c];if(!(p.p<0||p.s!=n)){var l=t.g.pTypes[p.t];l.isKing&&(p.m?s=null:o=p),s&&l.castle&&!p.m&&s.push(p);var u,v;u=l.graph[p.p],v=u.length;for(var f=0;f<v;f++)for(var b=u[f],d=!1,g=b.length,m=null,G=0;G<g;G++){var y=b[G],M=65535&y,C=this.board[M];if(!(C<0)||l.epCatch&&this.epTarget&&this.epTarget.p==M){if(!(524288&y)){var S;S=C<0?this.pieces[this.epTarget.i]:this.pieces[C],!(S.s!=p.s&&131072&y)||1048576&y&&!t.g.pTypes[S.t].isKing||2097152&y&&t.g.pTypes[S.t].isKing||e(p,{f:p.p,t:M,c:S.i,a:l.abbrev,ep:C<0});break}if(d){var S=this.pieces[C];S.s!=p.s&&e(p,{f:p.p,t:M,c:S.i,a:l.abbrev});break}d=!0}else 65536&y&&0==d&&e(p,{f:p.p,t:M,c:null,a:l.abbrev,ept:null!=m&&l.epTarget?m:void 0});m=M}}}if(s)for(var c=0;c<s.length;c++){var k=s[c],A=t.cbVar.castle[o.p+"/"+k.p];if(A){for(var T=!0,f=0;f<A.r.length;f++){var z=A.r[f];if(this.board[z]>=0&&z!=o.p&&z!=k.p){T=!1;break}}if(T){for(var E=!0,f=0;f<A.k.length;f++){var z=A.k[f];if(this.board[z]>=0&&z!=k.p&&z!=o.p||this.cbGetAttackers(t,z,n).length>0){E=!1;break}}E&&r.push({f:o.p,t:A.k[A.k.length-1],c:null,cg:k.p})}}}return r},Model.Board.cbStaticExchangeEval=function(t,e,i,r){var a=0,n=this.cbGetSmallestAttacker(t,e,i);if(n){var s=this.mWho;this.mWho=n.s;var o=this.cbQuickApply(t,{f:n.p,t:e,c:r.piece.i}),h=t.g.pTypes[r.piece.t].value;r.piece=n,a=Math.max(0,h-this.cbStaticExchangeEval(t,e,-i,r)),this.cbQuickUnapply(t,o),this.mWho=s}return a},Model.Board.cbGetSmallestAttacker=function(t,e,i){var r=this.cbGetAttackers(t,e,i);if(0==r.length)return null;for(var a=1/0,n=null,s=r.length,o=0;o<s;o++){var h=r[o],c=t.g.pTypes[h.t].value;c<a&&(a=c,n=h)}return n},Model.Board.cbCollectAttackers=function(t,e,i,r){for(var a in e){var n=e[a],s=this.board[a];if(s<0)this.cbCollectAttackers(t,n.e,i,r);else{var o=this.pieces[s];o.s==-t&&(n.t&&o.t in n.t||r&&n.tk&&o.t in n.tk)&&i.push(o)}}},Model.Board.cbCollectAttackersScreen=function(t,e,i,r,a){for(var n in e){var s=e[n],o=this.board[n];if(o<0)this.cbCollectAttackersScreen(t,s.e,i,r,a);else{var h=this.pieces[o];!a&&h.s==-t&&(s.t&&h.t in s.t||r&&s.tk&&h.t in s.tk)?i.push(h):a?a&&h.s==-t&&s.ts&&h.t in s.ts&&i.push(h):this.cbCollectAttackersScreen(t,s.e,i,r,!0)}}},Model.Board.cbGetAttackers=function(t,e,i,r){var a=[];return t.cbUseScreenCapture?this.cbCollectAttackersScreen(i,t.g.threatGraph[i][e],a,r,!1):this.cbCollectAttackers(i,t.g.threatGraph[i][e],a,r),a},Model.Board.GenerateMoves=function(t){var e=this.cbGeneratePseudoLegalMoves(t);this.mMoves=[];for(var i=!0,r=this.kings[this.mWho],a=e.length,n=0;n<a;n++){var s=e[n],o=this.cbQuickApply(t,s);if(!(this.cbGetAttackers(t,this.kings[this.mWho],this.mWho,!0).length>0)){var h=this.cbGetAttackers(t,this.kings[-this.mWho],-this.mWho,!0).length>0;s.ck=h,this.mMoves.push(s),s.f!=r&&(i=!1)}this.cbQuickUnapply(t,o)}if(0==this.mMoves.length)this.mFinished=!0,this.mWinner=t.cbOnStaleMate?t.cbOnStaleMate*this.mWho:JocGame.DRAW,this.check&&(this.mWinner=-this.mWho);else if(this.ending[this.mWho]){if(!i)for(var n=0;n<this.mMoves.length;n++)this.mMoves[n].ko=!1}else if(!this.ending[this.mWho]&&i&&!this.check)for(var n=0;n<this.mMoves.length;n++)this.mMoves[n].ko=!0},Model.Board.GetSignature=function(){return this.zSign},Model.Move.Init=function(t){for(var e in t)t.hasOwnProperty(e)&&(this[e]=t[e])},Model.Move.Equals=function(t){return this.f==t.f&&this.t==t.t&&this.pr==t.pr},Model.Move.CopyFrom=function(t){this.Init(t)},Model.Move.ToString=function(e){var i=this;switch(e=e||"natural"){case"natural":return function(){var e;if(void 0!==i.cg?e=t.castle[i.f+"/"+i.cg].n:(e=i.a||"",e+=t.geometry.PosName(i.f),null==i.c?e+="-":e+="x",e+=t.geometry.PosName(i.t)),void 0!==i.pr){var r=t.pieceTypes[i.pr];r&&r.abbrev&&r.abbrev.length>0&&!r.silentPromo&&(e+="="+r.abbrev)}return i.ck&&(e+="+"),e}();case"engine":return function(){var e=t.geometry.PosName(i.f)+t.geometry.PosName(i.t);if(void 0!=i.pr){var r=t.pieceTypes[i.pr];r&&r.abbrev&&r.abbrev.length>0&&!r.silentPromo&&(e+=r.abbrev)}return e}();default:return"??"}},Model.Board.CompactMoveString=function(e,i,r){"function"!=typeof i.ToString&&(i=e.CreateMove(i));var a=i.ToString(),n=/^([A-Z]?)([a-z])([1-9][0-9]*)([-x])([a-z])([1-9][0-9]*)(.*?)$/.exec(a);if(!n)return a;var s=n[7];if(r||(r={}),r.value||(r.value=[]),0==r.value.length){var o=this.mMoves;this.mMoves&&0!=this.mMoves.length||this.GenerateMoves(e);for(var h=0;h<this.mMoves.length;h++){var c=this.mMoves[h];"function"!=typeof c.ToString&&(c=e.CreateMove(c)),r.value.push({str:c.ToString(),move:c})}this.mMoves=o}var p=[];if(r.value.forEach(function(t){var e=/^([A-Z]?[a-z][1-9][0-9]*[-x][a-z][1-9][0-9]*)(.*?)$/.exec(t.str);e&&t.move.t==i.t&&(t.move.a||"")==n[1]&&e[2]==s&&p.push(t.move)}),1==p.length)return""==n[1]&&"x"==n[4]?n[2]+"x"+n[5]+n[6]+n[7]:n[1]+("x"==n[4]?"x":"")+n[5]+n[6]+n[7];if(t.geometry.CompactCrit)for(var l="",h=0;;h++){var u=t.geometry.CompactCrit(i.f,h);if(null==u)return a;l+=u;for(var v=[],f=0;f<p.length;f++){var b=p[f];t.geometry.CompactCrit(b.f,h)==u&&v.push(b)}if(console.assert(v.length>0),1==v.length)return n[1]+l+("x"==n[4]?"x":"")+n[5]+n[6]+n[7];p=v}return a},Model.Board.cbIntegrity=function(t){function e(t,e){t||console.error(e)}for(var i=this,r=0;r<this.board.length;r++){var a=this.board[r];if(a>=0){var n=i.pieces[a];e(void 0!==n,"no piece at pos"),e(n.p==r,"piece has different pos")}}for(var a=0;a<this.pieces.length;a++){var n=this.pieces[a];n.p>=0&&e(i.board[n.p]==a,"board index mismatch")}},Model.Board.ExportBoardState=function(t){return t.cbVar.geometry.ExportBoardState?t.cbVar.geometry.ExportBoardState(this,t.cbVar,t.mPlayedMoves.length):"not supported"},Model.Game.Import=function(e,i){var r,a=[],n={1:{},"-1":{}},s=null,o=0;if("pjn"==e){var h={status:!1,error:"parse"},c=i.split(" ");if(6!=c.length)return console.warn("FEN should have 6 parts"),h;var p=c[0].split("/"),l=t.geometry.fenHeight||t.geometry.height;if(p.length!=l)return console.warn("FEN board should have",l,"rows, got",p.length),h;var u={};for(var v in t.pieceTypes){var f=t.pieceTypes[v],b=f.fenAbbrev||f.abbrev||"X";u[b.toUpperCase()]={s:1,t:v},u[b.toLowerCase()]={s:-1,t:v}}var d=t.geometry.FenRowPos||function(e,i){return(t.geometry.height-1-e)*t.geometry.width+i};if(p.forEach(function(e,i){for(var r=0,n=0;n<e.length;n++){var s=e.substr(n,1),o=u[s];if(void 0!==o){var c=d(i,r);r++;for(var p={s:o.s,t:o.t,p:c},l=!0,v=t.pieceTypes[p.t].initial||[],f=0;f<v.length;f++){var b=v[f];b.s==p.s&&b.p==c&&(l=!1)}p.m=l,a.push(p)}else{if(isNaN(parseInt(s)))return console.warn("FEN invalid board spec",s),h;r+=parseInt(s)}}}),a.sort(function(t,e){return e.s-t.s}),"w"==c[1])r=1;else{if("b"!=c[1])return console.warn("FEN invalid turn spec",c[1]),h;r=-1}n[1].k=c[2].indexOf("K")>=0,n[1].q=c[2].indexOf("Q")>=0,n[-1].k=c[2].indexOf("k")>=0,n[-1].q=c[2].indexOf("q")>=0,s="-"==c[3]?null:c[3];var g=parseInt(c[4]);isNaN(g)||(o=g);var m={pieces:a,turn:r,castle:n,enPassant:s,noCaptCount:o};return t.importGame&&t.importGame.call(this,m,e,i),{status:!0,initial:m}}return{status:!1,error:"unsupported"}}}(),function(){Model.Game.cbBoardGeometryCylinder=function(t,e){function i(e){return e%t}function r(e){return Math.floor(e/t)}function a(e,i){return i*t+e}function n(n,s){for(var o=i(n),h=r(n),c=o+s[0];c<0;)c+=t;c%=t;var p=h+s[1];return p<0||p>=e?null:a(c,p)}function s(t){return String.fromCharCode("a".charCodeAt(0)+i(t))+(r(t)+1)}function o(t){var e=/^([a-z])([0-9]+)$/.exec(t);return e?a(e[1].charCodeAt(0)-"a".charCodeAt(0),parseInt(e[2])-1):-1}function h(t,e){return 0==e?String.fromCharCode("a".charCodeAt(0)+i(t)):1==e?r(t)+1:null}function c(){return l}for(var p=t*e,l={},u=0;u<p;u++)l[u]={},l[u][u]=0;for(var v=[[1,-1],[1,0],[1,1],[0,-1],[0,1],[-1,-1],[-1,0],[-1,-1]],f=!0;f;){f=!1;for(var u=0;u<p;u++)v.forEach(function(t){var e=n(u,t);if(null!=e){1!=l[u][e]&&(l[u][e]=1,l[e][u]=1,f=!0);for(var i=0;i<p;i++)i!=u&&(void 0===l[e][i]&&void 0!==l[u][i]?(l[e][i]=l[u][i]+1,l[i][e]=l[u][i]+1,f=!0):void 0!==l[e][i]&&void 0!==l[u][i]&&l[e][i]>l[u][i]+1&&(l[e][i]=l[u][i]+1,l[i][e]=l[u][i]+1,f=!0))}})}for(var b={},f=!0;f;){f=!1;for(var u=0;u<p;u++)u in b||v.forEach(function(t){var e=n(u,t);null==e?b[u]=1:e in b&&(u in b&&!(b[u]>b[e]+1)||(b[u]=b[e]+1,f=!0))})}return{boardSize:p,width:t,height:e,C:i,R:r,POS:a,Graph:n,PosName:s,PosByName:o,CompactCrit:h,GetDistances:c,distEdge:b,corners:null}},Model.Game.cbPawnGraph=function(t,e){for(var i=this,r={},a=0;a<t.boardSize;a++){var n=[],s=t.Graph(a,[0,e]);null!=s&&n.push(i.cbTypedArray([s|i.cbConstants.FLAG_MOVE])),[-1,1].forEach(function(r){var s=t.Graph(a,[r,e]);null!=s&&n.push(i.cbTypedArray([s|i.cbConstants.FLAG_CAPTURE]))}),r[a]=n}return r},Model.Game.cbInitialPawnGraph=function(t,e){for(var i=this,r={},a=0;a<t.boardSize;a++){var n=[],s=t.Graph(a,[0,e]);if(null!=s){var o=[s|i.cbConstants.FLAG_MOVE],h=t.Graph(s,[0,e]);null!=h&&o.push(h|i.cbConstants.FLAG_MOVE),n.push(i.cbTypedArray(o))}[-1,1].forEach(function(r){var s=t.Graph(a,[r,e]);null!=s&&n.push(i.cbTypedArray([s|i.cbConstants.FLAG_CAPTURE]))}),r[a]=n}return r},Model.Game.cbKingGraph=function(t){return this.cbShortRangeGraph(t,[[-1,-1],[-1,0],[-1,1],[0,-1],[0,1],[1,-1],[1,0],[1,1]])},Model.Game.cbKnightGraph=function(t){return this.cbShortRangeGraph(t,[[2,-1],[2,1],[-2,-1],[-2,1],[-1,2],[-1,-2],[1,2],[1,-2]])},Model.Game.cbHorseGraph=function(t){for(var e=this,i={},r=0;r<t.boardSize;r++)i[r]=[],[[1,0,2,-1],[1,0,2,1],[-1,0,-2,-1],[-1,0,-2,1],[0,1,-1,2],[0,-1,-1,-2],[0,1,1,2],[0,-1,1,-2]].forEach(function(a){var n=t.Graph(r,[a[0],a[1]]);if(null!=n){var s=t.Graph(r,[a[2],a[3]]);null!=s&&i[r].push(e.cbTypedArray([n|e.cbConstants.FLAG_STOP,s|e.cbConstants.FLAG_MOVE|e.cbConstants.FLAG_CAPTURE]))}});return i},Model.Game.cbRookGraph=function(t){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0]])},Model.Game.cbBishopGraph=function(t){return this.cbLongRangeGraph(t,[[1,-1],[1,1],[-1,1],[-1,-1]])},Model.Game.cbQueenGraph=function(t){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0],[1,-1],[1,1],[-1,1],[-1,-1]])},Model.Game.cbXQGeneralGraph=function(t,e){for(var i=this,r={},a=0;a<t.boardSize;a++)r[a]=[],[[-1,0,!1],[0,-1,!0],[0,1,!0],[1,0,!1]].forEach(function(n){var s=[],o=t.Graph(a,n);if(null!=o&&((!e||o in e)&&s.push(o|i.cbConstants.FLAG_MOVE|i.cbConstants.FLAG_CAPTURE),n[2]))for(var h=t.Graph(o,n);null!=h;)!e||h in e?s.push(h|i.cbConstants.FLAG_CAPTURE|i.cbConstants.FLAG_CAPTURE_KING):s.push(h|i.cbConstants.FLAG_STOP),h=t.Graph(h,n);s.length>0&&r[a].push(i.cbTypedArray(s))});return r},Model.Game.cbXQSoldierGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e]])},Model.Game.cbXQPromoSoldierGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e],[-1,0],[1,0]])},Model.Game.cbXQAdvisorGraph=function(t,e){return this.cbShortRangeGraph(t,[[1,1],[-1,1],[1,-1],[-1,-1]],e)},Model.Game.cbXQCannonGraph=function(t){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0]],null,this.cbConstants.FLAG_MOVE|this.cbConstants.FLAG_SCREEN_CAPTURE)},Model.Game.cbXQElephantGraph=function(t,e){for(var i=this,r={},a=0;a<t.boardSize;a++)r[a]=[],(!e||a in e)&&[[1,1,2,2],[1,-1,2,-2],[-1,1,-2,2],[-1,-1,-2,-2]].forEach(function(n){var s=t.Graph(a,[n[0],n[1]]);if(null!=s){var o=t.Graph(a,[n[2],n[3]]);null!=o&&(!e||o in e)&&r[a].push(i.cbTypedArray([s|i.cbConstants.FLAG_STOP,o|i.cbConstants.FLAG_MOVE|i.cbConstants.FLAG_CAPTURE]))}});return r},Model.Game.cbSilverGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e],[-1,-1],[-1,1],[1,-1],[1,1]])},Model.Game.cbFersGraph=function(t,e){return this.cbShortRangeGraph(t,[[-1,-1],[-1,1],[1,-1],[1,1]])},Model.Game.cbElephantGraph=function(t,e){return this.cbShortRangeGraph(t,[[-2,-2],[-2,2],[2,-2],[2,2]])},Model.Game.cbSchleichGraph=function(t,e){return this.cbShortRangeGraph(t,[[-1,0],[1,0],[0,-1],[0,1]])},Model.Game.cbAlfilGraph=function(t,e){return this.cbShortRangeGraph(t,[[-2,-2],[-2,2],[2,2],[2,-2]])},Model.Game.cbCylinderRookGraph=function(t){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0]],null,null,Math.max(t.width,t.height)-1)},Model.Game.cbCircularPawnGraph=function(t,e,i){var r=this.cbLongRangeGraph(t,e?[[1,0]]:[[-1,0]],null,this.cbConstants.FLAG_MOVE,i),a=this.cbShortRangeGraph(t,e?[[1,1],[1,-1]]:[[-1,1],[-1,-1]],null,this.cbConstants.FLAG_CAPTURE);return this.cbMergeGraphs(t,r,a)}}(),function(){var t=Model.Game.cbBoardGeometryCylinder(16,4);Model.Game.cbDefine=function(){return{geometry:t,pieceTypes:{1:{name:"pawn-cw",aspect:"np-pawn",graph:this.cbCircularPawnGraph(t,!0,1),value:1,abbrev:"",fenAbbrev:"P",initial:[{s:1,p:5},{s:1,p:21},{s:1,p:37},{s:1,p:53},{s:-1,p:13},{s:-1,p:29},{s:-1,p:45},{s:-1,p:61}]},3:{name:"pawn-ccw",aspect:"np-pawn",graph:this.cbCircularPawnGraph(t,!1,1),value:1,abbrev:"",fenAbbrev:"P",initial:[{s:1,p:2},{s:1,p:18},{s:1,p:34},{s:1,p:50},{s:-1,p:10},{s:-1,p:26},{s:-1,p:42},{s:-1,p:58}]},4:{name:"knight",aspect:"np-knight",graph:this.cbKnightGraph(t),value:2.9,abbrev:"N",initial:[{s:1,p:20},{s:1,p:19},{s:-1,p:27},{s:-1,p:28}]},5:{name:"elephant",aspect:"np-elephant",graph:this.cbElephantGraph(t),value:2,abbrev:"B",initial:[{s:1,p:36},{s:1,p:35},{s:-1,p:43},{s:-1,p:44}]},6:{name:"rook",aspect:"np-rook",graph:this.cbCylinderRookGraph(t),value:5,abbrev:"R",initial:[{s:1,p:4},{s:1,p:3},{s:-1,p:11},{s:-1,p:12}],castle:!0},7:{name:"fers",aspect:"np-general",graph:this.cbFersGraph(t),value:2,abbrev:"Q",initial:[{s:1,p:51},{s:-1,p:60}]},8:{name:"king",aspect:"np-king",isKing:!0,graph:this.cbKingGraph(t),abbrev:"K",initial:[{s:1,p:52},{s:-1,p:59}]}},evaluate:function(t,e,i){var r=i[1].count,a=i[-1].count;r[0]||r[1]||r[4]||r[5]||r[6]||r[7]||a[2]||a[3]||a[6]||a[7]||!(a[4]+a[5]<2||a[5]<2)||(this.mFinished=!0,this.mWinner=JocGame.DRAW),a[2]||a[3]||a[4]||a[5]||a[6]||a[7]||r[0]||r[1]||r[6]||r[7]||!(r[4]+r[5]<2||r[5]<2)||(this.mFinished=!0,this.mWinner=JocGame.DRAW),this.noCaptCount>=100&&(this.mFinished=!0,this.mWinner=JocGame.DRAW);for(var n=0,s=4;s<=5;s++)for(var o=1;o>=-1;o-=2){var h=i[o].byType[s];if(h)for(var c=0;c<h.length;c++)h[c].m&&(n+=o)}0!=n&&(e.minorPiecesMoved=n)}}}}();

/***/ }),

/***/ "7g4L":
/***/ (function(module, exports) {

exports.config = {"status":true,"model":{"plazza":"true","title-en":"6 Men´s Morris","module":"mills","maxLevel":7,"summary":"An old board game","thumbnail":"mensmorris3-thumb3d.png","rules":"rules.html","description":"description.html","credits":"credits.html","js":["mills-model.js","3-men-morris-model.js"],"gameOptions":{"preventRepeat":true,"width":3,"height":3,"mencount":3,"poundInMill":false},"levels":[{"label":"Easy","maxDepth":2,"potential":100,"placingRace":1,"isDefault":true},{"label":"Medium","maxDepth":4,"potential":300,"placingRace":1},{"label":"Hard","maxDepth":8,"potential":1000,"placingRace":2}]},"view":{"js":["mills-xd-view.js","3-men-morris-view.js"],"visuals":{"600x600":["res/visuals/threemen-600x600-3d.jpg","res/visuals/threemen-600x600-2d.jpg"]},"xdView":true,"css":["mills.css","3-men-morris.css"],"title-en":"3 Men´s Morris View","module":"mills","preferredRatio":1.6666666666667,"switchable":true,"animateSelfMoves":false,"useNotation":true,"useShowMoves":true,"defaultOptions":{"sounds":true,"notation":false,"moves":true},"sounds":{"move1":"move1","move2":"move2","move3":"move3","move4":"move4","tac1":"tac1","tac2":"tac2","tac3":"tac3","capture":"promo","usermove":null},"skins":[{"name":"classic3d","title":"3D Classic","3d":true,"camera":{"radius":14,"elevationAngle":45,"distMax":39.5,"distMin":10.1,"elevationMin":-89.9,"elevationMax":89.9,"limitCamMoves":true},"world":{"lightIntensity":0.6,"skyLightIntensity":0.3,"lightPosition":{"x":0,"y":18,"z":0},"color":0,"fog":false},"preload":["image|/res/xd-view/meshes/woodcell1x512.jpg","image|/res/xd-view/meshes/piecetop-bump.jpg","image|/res/xd-view/meshes/piecediff.jpg","smoothedfilegeo|0|/res/xd-view/meshes/piece-v2.js","smoothedfilegeo|0|/res/xd-view/meshes/boardoriented.js","smoothedfilegeo|0|/res/xd-view/meshes/ring-target.js"]},{"name":"stone","title":"Stone"},{"name":"suede","title":"Suede"},{"name":"wood","title":"Wood"}]}}

/***/ }),

/***/ "7nvF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__("mmVS");
var EmptyError_1 = __webpack_require__("F7Al");
/* tslint:enable:max-line-length */
/**
 * Returns an Observable that emits only the last item emitted by the source Observable.
 * It optionally takes a predicate function as a parameter, in which case, rather than emitting
 * the last item from the source Observable, the resulting Observable will emit the last item
 * from the source Observable that satisfies the predicate.
 *
 * <img src="./img/last.png" width="100%">
 *
 * @throws {EmptyError} Delivers an EmptyError to the Observer's `error`
 * callback if the Observable completes before any `next` notification was sent.
 * @param {function} predicate - The condition any source emitted item has to satisfy.
 * @return {Observable} An Observable that emits only the last item satisfying the given condition
 * from the source, or an NoSuchElementException if no such items are emitted.
 * @throws - Throws if no items that match the predicate are emitted by the source Observable.
 * @method last
 * @owner Observable
 */
function last(predicate, resultSelector, defaultValue) {
    return this.lift(new LastOperator(predicate, resultSelector, defaultValue, this));
}
exports.last = last;
var LastOperator = (function () {
    function LastOperator(predicate, resultSelector, defaultValue, source) {
        this.predicate = predicate;
        this.resultSelector = resultSelector;
        this.defaultValue = defaultValue;
        this.source = source;
    }
    LastOperator.prototype.call = function (observer, source) {
        return source.subscribe(new LastSubscriber(observer, this.predicate, this.resultSelector, this.defaultValue, this.source));
    };
    return LastOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var LastSubscriber = (function (_super) {
    __extends(LastSubscriber, _super);
    function LastSubscriber(destination, predicate, resultSelector, defaultValue, source) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.resultSelector = resultSelector;
        this.defaultValue = defaultValue;
        this.source = source;
        this.hasValue = false;
        this.index = 0;
        if (typeof defaultValue !== 'undefined') {
            this.lastValue = defaultValue;
            this.hasValue = true;
        }
    }
    LastSubscriber.prototype._next = function (value) {
        var index = this.index++;
        if (this.predicate) {
            this._tryPredicate(value, index);
        }
        else {
            if (this.resultSelector) {
                this._tryResultSelector(value, index);
                return;
            }
            this.lastValue = value;
            this.hasValue = true;
        }
    };
    LastSubscriber.prototype._tryPredicate = function (value, index) {
        var result;
        try {
            result = this.predicate(value, index, this.source);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        if (result) {
            if (this.resultSelector) {
                this._tryResultSelector(value, index);
                return;
            }
            this.lastValue = value;
            this.hasValue = true;
        }
    };
    LastSubscriber.prototype._tryResultSelector = function (value, index) {
        var result;
        try {
            result = this.resultSelector(value, index);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        this.lastValue = result;
        this.hasValue = true;
    };
    LastSubscriber.prototype._complete = function () {
        var destination = this.destination;
        if (this.hasValue) {
            destination.next(this.lastValue);
            destination.complete();
        }
        else {
            destination.error(new EmptyError_1.EmptyError);
        }
    };
    return LastSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=last.js.map

/***/ }),

/***/ "7pOI":
/***/ (function(module, exports) {

exports.config = {"status":true,"model":{"plazza":"true","title-en":"Penguin soccer","module":"pensoc","js":["pensoc-model.js"],"gameOptions":{"levelOptions":{"distGoalFactor":12,"distBallFactor":-1,"haveBallFactor":3.2,"reachableFactor":0.1,"ballReachableFactor":3.4},"uctTransposition":"state"},"levels":[{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.63,"ignoreLeaf":false,"log":false,"uncertaintyFactor":3,"name":"baby","label":"Baby","maxNodes":2000},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.63,"ignoreLeaf":false,"log":false,"uncertaintyFactor":3,"name":"fast","label":"Fast [1sec]","maxDuration":1,"isDefault":true},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.63,"ignoreLeaf":false,"log":false,"uncertaintyFactor":3,"name":"papa","label":"Papa","maxNodes":10000},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.63,"ignoreLeaf":false,"log":false,"uncertaintyFactor":3,"name":"mama","label":"Mama","maxNodes":10000}],"defaultLevel":2,"summary":"Penguins playing soccer","rules":{"en":"rules.html","fr":"rules-fr.html"},"credits":{"en":"credits.html","fr":"credits-fr.html"},"description":{"en":"description.html","fr":"description-fr.html"},"thumbnail":"thumbnail.png","strings":[],"debugEval":true},"view":{"title-en":"Penguin Soccer View","module":"pensoc","xdView":true,"js":["pensoc-xd-view.js"],"visuals":{"600x600":["res/visuals/pensoc-600x600-3d.jpg","res/visuals/pensoc-600x600-2d.jpg"]},"css":["pensoc.css"],"preferredRatio":1.1638,"switchable":true,"useShowMoves":true,"useNotation":true,"animateSelfMoves":false,"sounds":{"turn":"turn","slide":"slide","kick":"kick","getup0":"hoha","getup1":"hehop","slide0":"ouai","slide1":"hoho1","slide2":"hoho1","slide3":"oula1","slide4":"oula2","haha":"hahaha","goout":"hehehehe"},"skins":[{"name":"3dofficial","title":"Official 3D","3d":true,"camera":{"radius":15,"limitCamMoves":true,"elevationMin":0,"rotationAngle":110},"world":{"skyLightIntensity":0.2,"skyLightPosition":{"x":24,"y":24,"z":5},"lightIntensity":0.4,"lightPosition":{"x":-12,"y":12,"z":10},"lightShadowDarkness":0.4,"fog":false,"color":0},"preload":["smoothedfilegeo|0|/res/xd-view/meshes/banquise4.js","smoothedfilegeo|0|/res/xd-view/meshes/goals3.js","smoothedfilegeo|0|/res/xd-view/meshes/arrow.js","smoothedfilegeo|0|/res/xd-view/meshes/ring-target.js","smoothedfilegeo|0|/res/xd-view/meshes/soccerball2.js","smoothedfilegeo|0|/res/xd-view/meshes/icecube1.js","smoothedfilegeo|0|/res/xd-view/meshes/iceberg-small.js","smoothedfilegeo|0|/res/xd-view/meshes/ocean.js","smoothedfilegeo|0|/res/xd-view/meshes/mama-animated.js","smoothedfilegeo|0|/res/xd-view/meshes/daddy-animated.js","smoothedfilegeo|0|/res/xd-view/meshes/baby-animated.js","map|/res/xd-view/meshes/soccer-texture2.jpg","map|/res/xd-view/meshes/mama-A-diffusex512.jpg","map|/res/xd-view/meshes/mama-B-diffusex512.jpg","map|/res/xd-view/meshes/daddy-A-diffusex512.jpg","map|/res/xd-view/meshes/daddy-B-diffusex512.jpg","map|/res/xd-view/meshes/baby-A-diffusex512.jpg","map|/res/xd-view/meshes/baby-B-diffusex512.jpg"]},{"name":"official","title":"Official 2D"}],"defaultOptions":{"sounds":true,"notation":false,"moves":true},"preloadImages":{"background":"res/images/ps-background.jpg","sprites":"res/images/ps-images.png"}}}

/***/ }),

/***/ "7rB9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ForkJoinObservable_1 = __webpack_require__("t2qv");
exports.forkJoin = ForkJoinObservable_1.ForkJoinObservable.create;
//# sourceMappingURL=forkJoin.js.map

/***/ }),

/***/ "7vj1":
/***/ (function(module, exports, __webpack_require__) {

var PDNObject = __webpack_require__("d/I2");

function PDNParser(pdnText) {
    // Tag Pair
    this._patternTagPair = /^\[\s*(\w*)\s*\"(.*?)\"\s*\]$/;

    // MoveText
    this._patternMoveText = /(?:(\d+)\.(?:\.\.|\s+\.\.\.)?)?\s*(\d+(?:[-x]\d+)+)([\!\?\*\(\)]*)\s+(?:\{([^}]*)\}){0,1}\s*(?:(\d+(?:[-x]\d+)+)([\!\?\*\(\)]*)\s+?(?:\{([^}]*)\}){0,1})?/g;

    // Game-termination :
    // " 1-0 " ; " 0-1 " ; " 1/2-1/2 " ; " * "
    // " 2-0 " ; " 0-2 " ; " 1-1 "
    // Note : no confusion with move notation because of zero square do not exist and move on contigus squares is not valid
    // idem with asterisk and move 'glyph' because of leading and trailing space.
    this._patternGameTermination = /\s([012]\-[012]|1\/2\-1\/2|\*)\s/g;

    // FEN Tag value
    this._patternFEN = /^(W|B):(W|B)((?:K?\d*)(?:,K?\d+)*?)(?::(W|B)((?:K?\d*)(?:,K?\d+)*?))?$/;

    this.pdnSourceText = null;
    this.indexes = null;

    this.setPDNText(pdnText);
}


PDNParser.prototype.setPDNText = function(pdnText) {
    this.pdnSourceText = pdnText ? pdnText : null;
    
    if (this.pdnSourceText !== null){
        this._init();
    }
};

PDNParser.prototype._init = function() {
    this.pdnSourceText = this.pdnSourceText.trim() + " "; // for regexp...
    this.indexes = this._cutPDN();
    this._parseNameOfGames();
};

PDNParser.prototype._readyToParse = function(numGame) {
    var b = true;

    if (this.pdnSourceText === null) {
        b = false;
    } else if (numGame <= 0 || numGame > this.indexes.length) {
        b = false;
    }

    return b;
};

PDNParser.prototype.parse = function(numGame) {
    var pdnObj = new PDNObject();

    if (!this._readyToParse(numGame)) {
        return pdnObj;
    }

    // ------------------
    // Parse PDN
    // ------------------
    var pdn = this._parsePDN(numGame);

    var tags  = pdn["tagPairs"];
    var moves = pdn["moveText"];
    var gameTermination = pdn["gameTermination"];

    pdnObj.setTagPairs(tags);
    pdnObj.setMoveText(moves);
    pdnObj.setGameTermination(gameTermination);

    // ------------------
    // Parse FEN
    // ------------------
    var fen = pdnObj.getTagPair("FEN");
    if (fen != "??") {
        var map = this._parseTagFEN(fen);
        if (map !== null) {
            pdnObj.setFenWP(map["WP"]);
            pdnObj.setFenBP(map["BP"]);
            pdnObj.setFenWK(map["WK"]);
            pdnObj.setFenBK(map["BK"]);
            pdnObj.setFenTurnColor(map["turnColor"]);
        }
    }

    return pdnObj;
};

PDNParser.prototype.getGameCount = function() {
    var nb = 0;
    if (this.indexes != null) {
        nb = this.indexes.length;
    }
    return nb;
};

PDNParser.prototype.isTagValueEmpty = function(value) {
    return (value == null || value == "??");
};





PDNParser.prototype._parseTagFEN = function(fen) {
    if (this.isTagValueEmpty(fen)) {
        return null;
    }

    var turnColor = "";
    var whitePawnPositions = [];
    var whiteKingPositions = [];
    var blackPawnPositions = [];
    var blackKingPositions = [];

    var m = this._patternFEN.exec(fen);
    //var m = fen.match(this._patternFEN);
    if (m != null) {
    
        // var source = m[0];
        turnColor = m[1];
        var color1 = m[2];
        var color1Position = m[3];
        var color2 = m[4];
        var color2Position = m[5];

        if (color1Position != null && color1Position != "") {
            var isWhite = (color1 == "W");
            var positions = color1Position.split(",");

            var map = this._getPawnAndKingList(positions);
            if (isWhite) {
                whitePawnPositions = map["pawn"];
                whiteKingPositions = map["king"];
            } else {
                blackPawnPositions = map["pawn"];
                blackKingPositions = map["king"];
            }
        }

        if (color2Position != null && color2Position != "") {
            var isWhite = (color2 == "W");
            var positions = color2Position.split(",");

            var map = this._getPawnAndKingList(positions);
            if (isWhite) {
                whitePawnPositions = map["pawn"];
                whiteKingPositions = map["king"];
            } else {
                blackPawnPositions = map["pawn"];
                blackKingPositions = map["king"];
            }
        }
    }

    var map = {};
    map["WP"] = whitePawnPositions;
    map["WK"] = whiteKingPositions;
    map["BP"] = blackPawnPositions;
    map["BK"] = blackKingPositions;
    map["turnColor"] = turnColor;

    return map;
};

PDNParser.prototype._getPawnAndKingList = function(positions) {
    var pawnPositions = [];
    var kingPositions = [];

    if (positions != null && positions.length > 0) {
        for (var k = 0; k < positions.length; k++) {
            var pos = positions[k];
            if (pos.length > 0) {
                var sf = pos.substring(0, 1);
                var isKing = (sf == "K");

                if (isKing) {
                    pos = pos.substring(1);
                }

                var iPos = parseInt(pos);
                if (!isNaN(iPos)){
                    if (isKing) {
                        kingPositions.push(iPos);
                    } else {
                        pawnPositions.push(iPos);
                    }
                }
            }
        }
    }

    var map = {};
    map["pawn"] = pawnPositions;
    map["king"] = kingPositions;
    return map;
};


PDNParser.prototype._cutPDN = function() {
    var liste = []; // [{string:string}]

    var idxNextGame = 0;
    var match;
    var cpt = 0;
    while ((match = this._patternGameTermination.exec(this.pdnSourceText)) !== null) {
        cpt++; if (cpt>200) break; // security
        
        var idxStart = match.index;
        var idxEnd = idxStart + match[0].length;

        var map = {};
        map["idxStartGame"] = "" + idxNextGame;
        map["idxStartGameTermination"] = "" + idxStart;
        map["idxEndGame"] = "" + idxEnd;
        liste.push(map);

        idxNextGame = idxEnd;

        //console.log(match);
        //console.log("(" + idxStart + ", " +  idxEnd + ") = '" + this.pdnSourceText.substring(idxStart, idxEnd) + "'");
    }

    return liste;
};

PDNParser.prototype._parseNameOfGames = function() {
    for (var k = 0; k < this.indexes.length; k++) {
        var h = this.indexes[k];
        var idxStart = h["idxStartGame"];
        var idxEnd   = h["idxEndGame"];

        var cText = this.pdnSourceText.substring(idxStart, idxEnd);
        cText = cText.trim() + " ";

        h["tagEvent"] = this._extractTagPairValueForKey(cText, "Event");
        h["tagDate"]  = this._extractTagPairValueForKey(cText, "Date");
        h["tagWhite"] = this._extractTagPairValueForKey(cText, "White");
        h["tagBlack"] = this._extractTagPairValueForKey(cText, "Black");
        h["tagRound"] = this._extractTagPairValueForKey(cText, "Round");
        h["tagResult"] = this._extractTagPairValueForKey(cText, "Result");
    }
};

PDNParser.prototype._extractTagPairValueForKey = function(gameText, tagPairKey) {
    var re = new RegExp("\\[\\s*" + tagPairKey + "\\s*\"(.*?)\"\\s*\\]", "i");
    var m = re.exec(gameText);

    var value = "";
    if (m != null) {
        value = m[1].trim();
    }

    if (value == "") {
        value = "??";
    }

    return value;
};

PDNParser.prototype.getTitle = function(numGame, pattern) {
    if (!this._readyToParse(numGame)) {
        return "";
    }

    if (!pattern) {
        pattern = "tagEvent (tagDate) : tagWhite - tagBlack [tagRound] - tagResult";
    }

    var h = this.indexes[numGame - 1];
    var keywords = ["tagEvent", "tagDate", "tagWhite", "tagBlack", "tagRound", "tagResult"];

    var title = pattern;
    for (var k = 0; k < keywords.length; k++) {
        var keyword = keywords[k];
        title = title.replace(keyword, h[keyword]);
    }
    return title;
};

PDNParser.prototype.getTitles = function(pattern) {
    var list = [];

    var nb = this.getGameCount();
    for (var k = 0; k < nb; k++) {
        var numGame = k + 1;
        var title = this.getTitle(numGame, pattern);
        list.push({'num':numGame, 'title':title});
    }
    return list;
};


PDNParser.prototype._parsePDN = function(numGame) {
    var m = this.indexes[numGame - 1];

    var idxStart = parseInt(m["idxStartGame"]);
    var idxEnd   = parseInt(m["idxEndGame"]);

    var cText = this.pdnSourceText.substring(idxStart, idxEnd);

    // TODO: comment before moveText section
    // TODO: endline comment "; this is an endline comment"

    // ------------------
    // TAG PAIRS
    // ------------------
    var mapTags = this._parseTagPairs(cText);

    // ------------------
    // MOVE TEXT
    // ------------------
    var idx = this._getNextIndex(mapTags);
    var lmMoves = this._parseMoveText(cText, idx);

    // Cleanup
    delete mapTags["nextIndexToParse"];

    // Deballage
    var gameTermination = null;
    if (lmMoves.length > 0) {
        var map = lmMoves[0];
        gameTermination = map["gameTermination"];
        // map["nextIndexToParse"];

        lmMoves = lmMoves.slice(1, lmMoves.length);
    }

    // ------------------
    var res = {};
    res["tagPairs"] = mapTags;
    res["moveText"] = lmMoves;
    res["gameTermination"] = gameTermination;

    return res;
};

PDNParser.prototype._parseTagPairs = function(texte) {
    var map = {};
    map["nextIndexToParse"] = "0";

    var rTexte = texte.trim();
    while (rTexte.substring(0, 1) == "[") {

        var i = rTexte.indexOf("]", 1);
        if (i == -1) {
            console.log("Erreur");
            return null;
        }

        var tag = rTexte.substring(0, i + 1);
        rTexte = rTexte.substring(i + 2).trim();

        // ---

        var m = this._patternTagPair.exec(tag);
        //var m = fen.match(this._patternFEN);
        if (m != null) {
            var key = m[1];
            var value = m[2];

            // Normalisation
            value = value.trim();
            if (key == "FEN") {
                value = value.replace(" ", "");
            }
            // --------------
            map[key] = value;

            var idx = texte.indexOf(tag);
            if (idx != -1) {
                idx = idx + tag.length;
                map["nextIndexToParse"] = "" + idx;
            }
        }

    }

    return map;
};

PDNParser.prototype._getNextIndex = function(map) {
    if (map == null) {
        return -1;
    }

    var idx = parseInt(map["nextIndexToParse"]);
    return idx;
};

PDNParser.prototype._parseMoveText = function(texte, idx) {
    var liste = [];

    var rTexte = texte.substring(idx);
    rTexte = rTexte + " "; // Pour la regexp

    // Game-termination
    this._patternGameTermination.lastIndex = 0; // Reset the starting position of the next call
    var m = this._patternGameTermination.exec(rTexte);
    //var m = rTexte.match(this._patternGameTermination);
    if (m == null) {
        console.log("Game termination not found !");
        return liste;
    }

    var idxStart = m.index;
    var idxEnd = idxStart + m[0].length;
    var gameTermination = rTexte.substring(idxStart, idxEnd).trim();

    // Metadata on list
    var idxNextGame = idx + idxEnd;
    // ---
    var moveText = rTexte.substring(0, idxStart);
    moveText = moveText.trim();
    moveText = moveText + " "; // for next regexp.

    var map = {};
    map["nextIndexToParse"] = "" + idxNextGame;
    map["gameTermination"] = gameTermination;
    map["text"] = moveText;
    liste.push(map);
    

    var cpt = 0;
    var match;
    while ((match = this._patternMoveText.exec(moveText)) !== null) {
        cpt++; if (cpt>200) break; // security
        
        var dic = [];
        dic["source"]     = match[0];
        dic["moveNumber"] = match[1];
        dic["move1"]      = this._normalize(match[2]);
        dic["glyph1"]     = this._normalize(match[3]);
        dic["comment1"]   = this._normalize(match[4]);
        dic["move2"]      = this._normalize(match[5]);
        dic["glyph2"]     = this._normalize(match[6]);
        dic["comment2"]   = this._normalize(match[7]);
        liste.push(dic);
    }

    return liste;
};

PDNParser.prototype._normalize = function(sValue) {
    if (sValue == null) {
        sValue = "";
    }
    return sValue.trim();
};





PDNParser.prototype.debugCutGames = function() {
    console.log("");
    console.log("----------------------------------------");
    console.log(" Cut Games :");
    console.log("----------------------------------------");
    if (this.indexes === null || this.indexes.length == 0) {
        console.log("Erreur...");
        return;
    }

    console.log("Nombre de parties : " + this.indexes.length);
    console.log("----------");

    for (var h = 0; h < this.indexes.length; h++) {
        var map = this.indexes[h];
        var keys = Object.keys(map);
        for (var k = 0; k < keys.length; k++) {
            var key = keys[k];
            console.log(key + " = " + map[key]);
        }
        console.log("----------");
    }


    for (var h = 0; h < this.indexes.length; h++) {
        var map = this.indexes[h];
        
        var idxStartGame = parseInt(map["idxStartGame"]);
        var idxEndGame = parseInt(map["idxEndGame"]);
        console.log(this.pdnSourceText.substring(idxStartGame, idxEndGame));
        console.log("----------");
    }

};

module.exports = PDNParser;



/***/ }),

/***/ "8/gC":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var zip_1 = __webpack_require__("RYQg");
exports.zip = zip_1.zipStatic;
//# sourceMappingURL=zip.js.map

/***/ }),

/***/ "83T1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__("mmVS");
/**
 * Returns an Observable that emits whether or not every item of the source satisfies the condition specified.
 *
 * @example <caption>A simple example emitting true if all elements are less than 5, false otherwise</caption>
 *  Observable.of(1, 2, 3, 4, 5, 6)
 *     .every(x => x < 5)
 *     .subscribe(x => console.log(x)); // -> false
 *
 * @param {function} predicate A function for determining if an item meets a specified condition.
 * @param {any} [thisArg] Optional object to use for `this` in the callback.
 * @return {Observable} An Observable of booleans that determines if all items of the source Observable meet the condition specified.
 * @method every
 * @owner Observable
 */
function every(predicate, thisArg) {
    return this.lift(new EveryOperator(predicate, thisArg, this));
}
exports.every = every;
var EveryOperator = (function () {
    function EveryOperator(predicate, thisArg, source) {
        this.predicate = predicate;
        this.thisArg = thisArg;
        this.source = source;
    }
    EveryOperator.prototype.call = function (observer, source) {
        return source.subscribe(new EverySubscriber(observer, this.predicate, this.thisArg, this.source));
    };
    return EveryOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var EverySubscriber = (function (_super) {
    __extends(EverySubscriber, _super);
    function EverySubscriber(destination, predicate, thisArg, source) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.thisArg = thisArg;
        this.source = source;
        this.index = 0;
        this.thisArg = thisArg || this;
    }
    EverySubscriber.prototype.notifyComplete = function (everyValueMatch) {
        this.destination.next(everyValueMatch);
        this.destination.complete();
    };
    EverySubscriber.prototype._next = function (value) {
        var result = false;
        try {
            result = this.predicate.call(this.thisArg, value, this.index++, this.source);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        if (!result) {
            this.notifyComplete(false);
        }
    };
    EverySubscriber.prototype._complete = function () {
        this.notifyComplete(true);
    };
    return EverySubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=every.js.map

/***/ }),

/***/ "8DDp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var async_1 = __webpack_require__("CGGv");
var isDate_1 = __webpack_require__("fuZx");
var OuterSubscriber_1 = __webpack_require__("wAkD");
var subscribeToResult_1 = __webpack_require__("CURp");
/* tslint:enable:max-line-length */
/**
 * @param due
 * @param withObservable
 * @param scheduler
 * @return {Observable<R>|WebSocketSubject<T>|Observable<T>}
 * @method timeoutWith
 * @owner Observable
 */
function timeoutWith(due, withObservable, scheduler) {
    if (scheduler === void 0) { scheduler = async_1.async; }
    var absoluteTimeout = isDate_1.isDate(due);
    var waitFor = absoluteTimeout ? (+due - scheduler.now()) : Math.abs(due);
    return this.lift(new TimeoutWithOperator(waitFor, absoluteTimeout, withObservable, scheduler));
}
exports.timeoutWith = timeoutWith;
var TimeoutWithOperator = (function () {
    function TimeoutWithOperator(waitFor, absoluteTimeout, withObservable, scheduler) {
        this.waitFor = waitFor;
        this.absoluteTimeout = absoluteTimeout;
        this.withObservable = withObservable;
        this.scheduler = scheduler;
    }
    TimeoutWithOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new TimeoutWithSubscriber(subscriber, this.absoluteTimeout, this.waitFor, this.withObservable, this.scheduler));
    };
    return TimeoutWithOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var TimeoutWithSubscriber = (function (_super) {
    __extends(TimeoutWithSubscriber, _super);
    function TimeoutWithSubscriber(destination, absoluteTimeout, waitFor, withObservable, scheduler) {
        _super.call(this, destination);
        this.absoluteTimeout = absoluteTimeout;
        this.waitFor = waitFor;
        this.withObservable = withObservable;
        this.scheduler = scheduler;
        this.action = null;
        this.scheduleTimeout();
    }
    TimeoutWithSubscriber.dispatchTimeout = function (subscriber) {
        var withObservable = subscriber.withObservable;
        subscriber._unsubscribeAndRecycle();
        subscriber.add(subscribeToResult_1.subscribeToResult(subscriber, withObservable));
    };
    TimeoutWithSubscriber.prototype.scheduleTimeout = function () {
        var action = this.action;
        if (action) {
            // Recycle the action if we've already scheduled one. All the production
            // Scheduler Actions mutate their state/delay time and return themeselves.
            // VirtualActions are immutable, so they create and return a clone. In this
            // case, we need to set the action reference to the most recent VirtualAction,
            // to ensure that's the one we clone from next time.
            this.action = action.schedule(this, this.waitFor);
        }
        else {
            this.add(this.action = this.scheduler.schedule(TimeoutWithSubscriber.dispatchTimeout, this.waitFor, this));
        }
    };
    TimeoutWithSubscriber.prototype._next = function (value) {
        if (!this.absoluteTimeout) {
            this.scheduleTimeout();
        }
        _super.prototype._next.call(this, value);
    };
    TimeoutWithSubscriber.prototype._unsubscribe = function () {
        this.action = null;
        this.scheduler = null;
        this.withObservable = null;
    };
    return TimeoutWithSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=timeoutWith.js.map

/***/ }),

/***/ "8GmM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
/**
 * Represents a push-based event or value that an {@link Observable} can emit.
 * This class is particularly useful for operators that manage notifications,
 * like {@link materialize}, {@link dematerialize}, {@link observeOn}, and
 * others. Besides wrapping the actual delivered value, it also annotates it
 * with metadata of, for instance, what type of push message it is (`next`,
 * `error`, or `complete`).
 *
 * @see {@link materialize}
 * @see {@link dematerialize}
 * @see {@link observeOn}
 *
 * @class Notification<T>
 */
var Notification = (function () {
    function Notification(kind, value, error) {
        this.kind = kind;
        this.value = value;
        this.error = error;
        this.hasValue = kind === 'N';
    }
    /**
     * Delivers to the given `observer` the value wrapped by this Notification.
     * @param {Observer} observer
     * @return
     */
    Notification.prototype.observe = function (observer) {
        switch (this.kind) {
            case 'N':
                return observer.next && observer.next(this.value);
            case 'E':
                return observer.error && observer.error(this.error);
            case 'C':
                return observer.complete && observer.complete();
        }
    };
    /**
     * Given some {@link Observer} callbacks, deliver the value represented by the
     * current Notification to the correctly corresponding callback.
     * @param {function(value: T): void} next An Observer `next` callback.
     * @param {function(err: any): void} [error] An Observer `error` callback.
     * @param {function(): void} [complete] An Observer `complete` callback.
     * @return {any}
     */
    Notification.prototype.do = function (next, error, complete) {
        var kind = this.kind;
        switch (kind) {
            case 'N':
                return next && next(this.value);
            case 'E':
                return error && error(this.error);
            case 'C':
                return complete && complete();
        }
    };
    /**
     * Takes an Observer or its individual callback functions, and calls `observe`
     * or `do` methods accordingly.
     * @param {Observer|function(value: T): void} nextOrObserver An Observer or
     * the `next` callback.
     * @param {function(err: any): void} [error] An Observer `error` callback.
     * @param {function(): void} [complete] An Observer `complete` callback.
     * @return {any}
     */
    Notification.prototype.accept = function (nextOrObserver, error, complete) {
        if (nextOrObserver && typeof nextOrObserver.next === 'function') {
            return this.observe(nextOrObserver);
        }
        else {
            return this.do(nextOrObserver, error, complete);
        }
    };
    /**
     * Returns a simple Observable that just delivers the notification represented
     * by this Notification instance.
     * @return {any}
     */
    Notification.prototype.toObservable = function () {
        var kind = this.kind;
        switch (kind) {
            case 'N':
                return Observable_1.Observable.of(this.value);
            case 'E':
                return Observable_1.Observable.throw(this.error);
            case 'C':
                return Observable_1.Observable.empty();
        }
        throw new Error('unexpected notification kind value');
    };
    /**
     * A shortcut to create a Notification instance of the type `next` from a
     * given value.
     * @param {T} value The `next` value.
     * @return {Notification<T>} The "next" Notification representing the
     * argument.
     */
    Notification.createNext = function (value) {
        if (typeof value !== 'undefined') {
            return new Notification('N', value);
        }
        return this.undefinedValueNotification;
    };
    /**
     * A shortcut to create a Notification instance of the type `error` from a
     * given error.
     * @param {any} [err] The `error` error.
     * @return {Notification<T>} The "error" Notification representing the
     * argument.
     */
    Notification.createError = function (err) {
        return new Notification('E', undefined, err);
    };
    /**
     * A shortcut to create a Notification instance of the type `complete`.
     * @return {Notification<any>} The valueless "complete" Notification.
     */
    Notification.createComplete = function () {
        return this.completeNotification;
    };
    Notification.completeNotification = new Notification('C');
    Notification.undefinedValueNotification = new Notification('N', undefined);
    return Notification;
}());
exports.Notification = Notification;
//# sourceMappingURL=Notification.js.map

/***/ }),

/***/ "8MUz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var isScheduler_1 = __webpack_require__("fWbP");
var ArrayObservable_1 = __webpack_require__("Yh8Q");
var mergeAll_1 = __webpack_require__("cbuX");
/* tslint:enable:max-line-length */
/**
 * Creates an output Observable which sequentially emits all values from every
 * given input Observable after the current Observable.
 *
 * <span class="informal">Concatenates multiple Observables together by
 * sequentially emitting their values, one Observable after the other.</span>
 *
 * <img src="./img/concat.png" width="100%">
 *
 * Joins this Observable with multiple other Observables by subscribing to them
 * one at a time, starting with the source, and merging their results into the
 * output Observable. Will wait for each Observable to complete before moving
 * on to the next.
 *
 * @example <caption>Concatenate a timer counting from 0 to 3 with a synchronous sequence from 1 to 10</caption>
 * var timer = Rx.Observable.interval(1000).take(4);
 * var sequence = Rx.Observable.range(1, 10);
 * var result = timer.concat(sequence);
 * result.subscribe(x => console.log(x));
 *
 * // results in:
 * // 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3 -immediate-> 1 ... 10
 *
 * @example <caption>Concatenate 3 Observables</caption>
 * var timer1 = Rx.Observable.interval(1000).take(10);
 * var timer2 = Rx.Observable.interval(2000).take(6);
 * var timer3 = Rx.Observable.interval(500).take(10);
 * var result = timer1.concat(timer2, timer3);
 * result.subscribe(x => console.log(x));
 *
 * // results in the following:
 * // (Prints to console sequentially)
 * // -1000ms-> 0 -1000ms-> 1 -1000ms-> ... 9
 * // -2000ms-> 0 -2000ms-> 1 -2000ms-> ... 5
 * // -500ms-> 0 -500ms-> 1 -500ms-> ... 9
 *
 * @see {@link concatAll}
 * @see {@link concatMap}
 * @see {@link concatMapTo}
 *
 * @param {ObservableInput} other An input Observable to concatenate after the source
 * Observable. More than one input Observables may be given as argument.
 * @param {Scheduler} [scheduler=null] An optional IScheduler to schedule each
 * Observable subscription on.
 * @return {Observable} All values of each passed Observable merged into a
 * single Observable, in order, in serial fashion.
 * @method concat
 * @owner Observable
 */
function concat() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i - 0] = arguments[_i];
    }
    return this.lift.call(concatStatic.apply(void 0, [this].concat(observables)));
}
exports.concat = concat;
/* tslint:enable:max-line-length */
/**
 * Creates an output Observable which sequentially emits all values from given
 * Observable and then moves on to the next.
 *
 * <span class="informal">Concatenates multiple Observables together by
 * sequentially emitting their values, one Observable after the other.</span>
 *
 * <img src="./img/concat.png" width="100%">
 *
 * `concat` joins multiple Observables together, by subscribing to them one at a time and
 * merging their results into the output Observable. You can pass either an array of
 * Observables, or put them directly as arguments. Passing an empty array will result
 * in Observable that completes immediately.
 *
 * `concat` will subscribe to first input Observable and emit all its values, without
 * changing or affecting them in any way. When that Observable completes, it will
 * subscribe to then next Observable passed and, again, emit its values. This will be
 * repeated, until the operator runs out of Observables. When last input Observable completes,
 * `concat` will complete as well. At any given moment only one Observable passed to operator
 * emits values. If you would like to emit values from passed Observables concurrently, check out
 * {@link merge} instead, especially with optional `concurrent` parameter. As a matter of fact,
 * `concat` is an equivalent of `merge` operator with `concurrent` parameter set to `1`.
 *
 * Note that if some input Observable never completes, `concat` will also never complete
 * and Observables following the one that did not complete will never be subscribed. On the other
 * hand, if some Observable simply completes immediately after it is subscribed, it will be
 * invisible for `concat`, which will just move on to the next Observable.
 *
 * If any Observable in chain errors, instead of passing control to the next Observable,
 * `concat` will error immediately as well. Observables that would be subscribed after
 * the one that emitted error, never will.
 *
 * If you pass to `concat` the same Observable many times, its stream of values
 * will be "replayed" on every subscription, which means you can repeat given Observable
 * as many times as you like. If passing the same Observable to `concat` 1000 times becomes tedious,
 * you can always use {@link repeat}.
 *
 * @example <caption>Concatenate a timer counting from 0 to 3 with a synchronous sequence from 1 to 10</caption>
 * var timer = Rx.Observable.interval(1000).take(4);
 * var sequence = Rx.Observable.range(1, 10);
 * var result = Rx.Observable.concat(timer, sequence);
 * result.subscribe(x => console.log(x));
 *
 * // results in:
 * // 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3 -immediate-> 1 ... 10
 *
 *
 * @example <caption>Concatenate an array of 3 Observables</caption>
 * var timer1 = Rx.Observable.interval(1000).take(10);
 * var timer2 = Rx.Observable.interval(2000).take(6);
 * var timer3 = Rx.Observable.interval(500).take(10);
 * var result = Rx.Observable.concat([timer1, timer2, timer3]); // note that array is passed
 * result.subscribe(x => console.log(x));
 *
 * // results in the following:
 * // (Prints to console sequentially)
 * // -1000ms-> 0 -1000ms-> 1 -1000ms-> ... 9
 * // -2000ms-> 0 -2000ms-> 1 -2000ms-> ... 5
 * // -500ms-> 0 -500ms-> 1 -500ms-> ... 9
 *
 *
 * @example <caption>Concatenate the same Observable to repeat it</caption>
 * const timer = Rx.Observable.interval(1000).take(2);
 *
 * Rx.Observable.concat(timer, timer) // concating the same Observable!
 * .subscribe(
 *   value => console.log(value),
 *   err => {},
 *   () => console.log('...and it is done!')
 * );
 *
 * // Logs:
 * // 0 after 1s
 * // 1 after 2s
 * // 0 after 3s
 * // 1 after 4s
 * // "...and it is done!" also after 4s
 *
 * @see {@link concatAll}
 * @see {@link concatMap}
 * @see {@link concatMapTo}
 *
 * @param {ObservableInput} input1 An input Observable to concatenate with others.
 * @param {ObservableInput} input2 An input Observable to concatenate with others.
 * More than one input Observables may be given as argument.
 * @param {Scheduler} [scheduler=null] An optional IScheduler to schedule each
 * Observable subscription on.
 * @return {Observable} All values of each passed Observable merged into a
 * single Observable, in order, in serial fashion.
 * @static true
 * @name concat
 * @owner Observable
 */
function concatStatic() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i - 0] = arguments[_i];
    }
    var scheduler = null;
    var args = observables;
    if (isScheduler_1.isScheduler(args[observables.length - 1])) {
        scheduler = args.pop();
    }
    if (scheduler === null && observables.length === 1 && observables[0] instanceof Observable_1.Observable) {
        return observables[0];
    }
    return new ArrayObservable_1.ArrayObservable(observables, scheduler).lift(new mergeAll_1.MergeAllOperator(1));
}
exports.concatStatic = concatStatic;
//# sourceMappingURL=concat.js.map

/***/ }),

/***/ "8T44":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subject_1 = __webpack_require__("EEr4");
var tryCatch_1 = __webpack_require__("+3eL");
var errorObject_1 = __webpack_require__("WhVc");
var OuterSubscriber_1 = __webpack_require__("wAkD");
var subscribeToResult_1 = __webpack_require__("CURp");
/**
 * Returns an Observable that mirrors the source Observable with the exception of a `complete`. If the source
 * Observable calls `complete`, this method will emit to the Observable returned from `notifier`. If that Observable
 * calls `complete` or `error`, then this method will call `complete` or `error` on the child subscription. Otherwise
 * this method will resubscribe to the source Observable.
 *
 * <img src="./img/repeatWhen.png" width="100%">
 *
 * @param {function(notifications: Observable): Observable} notifier - Receives an Observable of notifications with
 * which a user can `complete` or `error`, aborting the repetition.
 * @return {Observable} The source Observable modified with repeat logic.
 * @method repeatWhen
 * @owner Observable
 */
function repeatWhen(notifier) {
    return this.lift(new RepeatWhenOperator(notifier));
}
exports.repeatWhen = repeatWhen;
var RepeatWhenOperator = (function () {
    function RepeatWhenOperator(notifier) {
        this.notifier = notifier;
    }
    RepeatWhenOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new RepeatWhenSubscriber(subscriber, this.notifier, source));
    };
    return RepeatWhenOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var RepeatWhenSubscriber = (function (_super) {
    __extends(RepeatWhenSubscriber, _super);
    function RepeatWhenSubscriber(destination, notifier, source) {
        _super.call(this, destination);
        this.notifier = notifier;
        this.source = source;
        this.sourceIsBeingSubscribedTo = true;
    }
    RepeatWhenSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.sourceIsBeingSubscribedTo = true;
        this.source.subscribe(this);
    };
    RepeatWhenSubscriber.prototype.notifyComplete = function (innerSub) {
        if (this.sourceIsBeingSubscribedTo === false) {
            return _super.prototype.complete.call(this);
        }
    };
    RepeatWhenSubscriber.prototype.complete = function () {
        this.sourceIsBeingSubscribedTo = false;
        if (!this.isStopped) {
            if (!this.retries) {
                this.subscribeToRetries();
            }
            else if (this.retriesSubscription.closed) {
                return _super.prototype.complete.call(this);
            }
            this._unsubscribeAndRecycle();
            this.notifications.next();
        }
    };
    RepeatWhenSubscriber.prototype._unsubscribe = function () {
        var _a = this, notifications = _a.notifications, retriesSubscription = _a.retriesSubscription;
        if (notifications) {
            notifications.unsubscribe();
            this.notifications = null;
        }
        if (retriesSubscription) {
            retriesSubscription.unsubscribe();
            this.retriesSubscription = null;
        }
        this.retries = null;
    };
    RepeatWhenSubscriber.prototype._unsubscribeAndRecycle = function () {
        var _a = this, notifications = _a.notifications, retries = _a.retries, retriesSubscription = _a.retriesSubscription;
        this.notifications = null;
        this.retries = null;
        this.retriesSubscription = null;
        _super.prototype._unsubscribeAndRecycle.call(this);
        this.notifications = notifications;
        this.retries = retries;
        this.retriesSubscription = retriesSubscription;
        return this;
    };
    RepeatWhenSubscriber.prototype.subscribeToRetries = function () {
        this.notifications = new Subject_1.Subject();
        var retries = tryCatch_1.tryCatch(this.notifier)(this.notifications);
        if (retries === errorObject_1.errorObject) {
            return _super.prototype.complete.call(this);
        }
        this.retries = retries;
        this.retriesSubscription = subscribeToResult_1.subscribeToResult(this, retries);
    };
    return RepeatWhenSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=repeatWhen.js.map

/***/ }),

/***/ "8Z8y":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * An error thrown when an element was queried at a certain index of an
 * Observable, but no such index or position exists in that sequence.
 *
 * @see {@link elementAt}
 * @see {@link take}
 * @see {@link takeLast}
 *
 * @class ArgumentOutOfRangeError
 */
var ArgumentOutOfRangeError = (function (_super) {
    __extends(ArgumentOutOfRangeError, _super);
    function ArgumentOutOfRangeError() {
        var err = _super.call(this, 'argument out of range');
        this.name = err.name = 'ArgumentOutOfRangeError';
        this.stack = err.stack;
        this.message = err.message;
    }
    return ArgumentOutOfRangeError;
}(Error));
exports.ArgumentOutOfRangeError = ArgumentOutOfRangeError;
//# sourceMappingURL=ArgumentOutOfRangeError.js.map

/***/ }),

/***/ "8dXh":
/***/ (function(module, exports) {

exports.model=Model={Game:{},Board:{},Move:{}},function(){var t;Model.Game.cbConstants={MASK:65535,FLAG_MOVE:65536,FLAG_CAPTURE:131072,FLAG_STOP:262144,FLAG_SCREEN_CAPTURE:524288,FLAG_CAPTURE_KING:1048576,FLAG_CAPTURE_NO_KING:2097152};var e="undefined"!=typeof Int32Array;Model.Game.cbUseTypedArrays=e,Model.Game.cbTypedArray=function(t){if(e){var r=new Int32Array(t.length);return r.set(t),r}for(var a=[],i=t.length,s=0;s<i;s++)a.push(t[s]);return a},Model.Game.cbShortRangeGraph=function(t,e,r,a){var i=this;void 0===a&&(a=196608);for(var s={},n=0;n<t.boardSize;n++)s[n]=[],(!r||n in r)&&e.forEach(function(e){var o=t.Graph(n,e);null!=o&&(!r||o in r)&&s[n].push(i.cbTypedArray([o|a]))});return s},Model.Game.cbLongRangeGraph=function(t,e,r,a,i){var s=this;void 0!==a&&null!=a||(a=196608),i||(i=1/0);for(var n={},o=0;o<t.boardSize;o++)n[o]=[],(!r||o in r)&&e.forEach(function(e){for(var h=[],c=t.Graph(o,e),p=0;null!=c&&(!r||c in r)&&(h.push(c|a),++p!=i);)c=t.Graph(c,e);h.length>0&&n[o].push(s.cbTypedArray(h))});return n},Model.Game.cbNullGraph=function(t){for(var e={},r=0;r<t.boardSize;r++)e[r]=[];return e},Model.Game.cbAuthorGraph=function(t){for(var e={},r=0;r<t.boardSize;r++){e[r]=[];for(var a=0;a<t.boardSize;a++)e[r].push([2293760|a])}return e},Model.Game.cbMergeGraphs=function(t){for(var e=[],r=0;r<t.boardSize;r++){e[r]=[];for(var a=1;a<arguments.length;a++)e[r]=e[r].concat(arguments[a][r])}return e},Model.Game.cbGetThreatGraph=function(){function t(e,r){for(var a in n){var i=n[a];if(!(i.p.length<r.length+1)){for(var s=!0,o=0;o<r.length;o++)if(r[o]!=i.p[o]){s=!1;break}if(s){var h=i.p[r.length],c=e[h];void 0===c&&(c={e:{}},e[h]=c),i.p.length==r.length+1&&(c.t=i.t,c.ts=i.ts,c.tk=i.tk,delete n[a]),r.push(h),t(c.e,r),r.pop()}}}}var e=this;this.cbUseScreenCapture=!1,this.cbUseCaptureKing=!1,this.cbUseCaptureNoKing=!1;for(var r={1:[],"-1":[]},a=[],i=0;i<this.g.boardSize;i++)this.g.pTypes.forEach(function(t,r){t.graph[i].forEach(function(t){for(var s=[],n=0;n<t.length;n++){var o=t[n];1048576&o?(e.cbUseCaptureKing=!0,s.unshift({d:65535&o,a:i,tk:r})):2097152&o?(e.cbUseCaptureNoKing=!0,s.unshift({d:65535&o,a:i,tnk:r})):131072&o?s.unshift({d:65535&o,a:i,t:r}):262144&o?s.unshift({d:65535&o,a:i}):524288&o&&(e.cbUseScreenCapture=!0,s.unshift({d:65535&o,a:i,ts:r}))}s.length>0&&a.push(s)})});var s={};a.forEach(function(t){t.forEach(function(e,r){var a=s[e.d];void 0===a&&(a={},s[e.d]=a);for(var i=[],n=r+1;n<t.length;n++)i.push(t[n].d);i.push(e.a);var o=i.join(","),h=a[o];void 0===h&&(h={p:i,t:{},ts:{},tk:{}},a[o]=h),void 0!==e.t?h.t[e.t]=!0:void 0!==e.tk?h.tk[e.tk]=!0:void 0!==e.ts&&(h.ts[e.ts]=!0)})});for(var i=0;i<e.g.boardSize;i++){var n=s[i],o={};t(o,[]),r[1][i]=o,r[-1][i]=o}return r},Model.Game.InitGame=function(){var e=this;this.cbVar=t=this.cbDefine(),this.g.boardSize=this.cbVar.geometry.boardSize,this.g.pTypes=this.cbGetPieceTypes(),this.g.threatGraph=this.cbGetThreatGraph(),this.g.distGraph=this.cbVar.geometry.GetDistances(),this.cbPiecesCount=0,this.g.castleablePiecesCount={1:0,"-1":0};for(var r in t.pieceTypes){var a=t.pieceTypes[r];if(a.castle){(a.initial||[]).forEach(function(t){e.g.castleablePiecesCount[t.s]++})}a.initial&&(this.cbPiecesCount+=a.initial.length)}for(var i=[],r=0;r<this.cbPiecesCount;r++)i.push(r);var s=Object.keys(t.pieceTypes);this.zobrist=new JocGame.Zobrist({board:{type:"array",size:this.cbVar.geometry.boardSize,values:i},who:{values:["1","-1"]},type:{type:"array",size:this.cbPiecesCount,values:s}})},Model.Game.cbGetPieceTypes=function(){for(var t=[],e={},r=0;r<this.cbVar.geometry.boardSize;r++)e[r]=[];for(var a in this.cbVar.pieceTypes){var i=this.cbVar.pieceTypes[a];t[a]={graph:i.graph||e,abbrev:i.abbrev||"",value:i.isKing?100:i.value||1,isKing:!!i.isKing,castle:!!i.castle,epTarget:!!i.epTarget,epCatch:!!i.epCatch}}return t},Model.Board.Init=function(t){this.zSign=0},Model.Board.InitialPosition=function(r){var a=this;this.board=e?new Int16Array(r.g.boardSize):[];for(var i=0;i<r.g.boardSize;i++)this.board[i]=-1;if(this.kings={},this.pieces=[],this.ending={1:!1,"-1":!1},this.lastMove=null,r.cbVar.castle&&(this.castled={1:!1,"-1":!1}),this.zSign=r.zobrist.update(0,"who",-1),this.noCaptCount=0,this.mWho=1,r.mInitial)this.mWho=r.mInitial.turn||1,r.mInitial.pieces.forEach(function(t){var e={};for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);a.pieces.push(e)}),r.mInitial.lastMove&&(this.lastMove={f:r.mInitial.lastMove.f,t:r.mInitial.lastMove.t}),void 0!==r.mInitial.noCaptCount&&(this.noCaptCount=r.mInitial.noCaptCount),r.cbVar.castle&&r.mInitial.castle&&(this.castled={1:{k:!!r.mInitial.castle[1]&&!!r.mInitial.castle[1].k,q:!!r.mInitial.castle[1]&&!!r.mInitial.castle[1].q},"-1":{k:!!r.mInitial.castle[-1]&&!!r.mInitial.castle[-1].k,q:!!r.mInitial.castle[-1]&&!!r.mInitial.castle[-1].q}});else for(var s in r.cbVar.pieceTypes)for(var n=r.cbVar.pieceTypes[s],o=n.initial||[],h=0;h<o.length;h++){var c=o[h],p={s:c.s,t:parseInt(s),p:c.p,m:!1};this.pieces.push(p)}if(this.pieces.sort(function(t,e){if(t.s!=e.s)return e.s-t.s;var a=r.cbVar.pieceTypes[t.t].value||100,i=r.cbVar.pieceTypes[e.t].value||100;return a!=i?a-i:t.p-e.p}),this.pieces.forEach(function(t,e){t.i=e,a.board[t.p]=e,r.g.pTypes[t.t].isKing&&(a.kings[t.s]=t.p),a.zSign=r.zobrist.update(a.zSign,"board",e,t.p),a.zSign=r.zobrist.update(a.zSign,"type",t.t,e)}),r.mInitial&&r.mInitial.enPassant){var i=t.geometry.PosByName(r.mInitial.enPassant);if(i>=0){var l,u=t.geometry.C(i),v=t.geometry.R(i);l=1==r.mInitial.turn?t.geometry.POS(u,v-1):t.geometry.POS(u,v+1),this.epTarget={p:i,i:this.board[l]}}}},Model.Board.CopyFrom=function(t){if(e)this.board=new Int16Array(t.board.length),this.board.set(t.board);else{this.board=[];for(var r=t.board,a=r.length,i=0;i<a;i++)this.board.push(r[i])}this.pieces=[];for(var s=t.pieces.length,i=0;i<s;i++){var n=t.pieces[i];this.pieces.push({s:n.s,p:n.p,t:n.t,i:n.i,m:n.m})}this.kings={1:t.kings[1],"-1":t.kings[-1]},this.check=t.check,t.lastMove?this.lastMove={f:t.lastMove.f,t:t.lastMove.t,c:t.lastMove.c}:this.lastMove=null,this.ending={1:t.ending[1],"-1":t.ending[-1]},void 0!==t.castled&&(this.castled={1:t.castled[1],"-1":t.castled[-1]}),this.noCaptCount=t.noCaptCount,t.epTarget?this.epTarget={p:t.epTarget.p,i:t.epTarget.i}:this.epTarget=null,this.mWho=t.mWho,this.zSign=t.zSign},Model.Board.cbApplyCastle=function(t,e,r){var a=t.cbVar.castle[e.f+"/"+e.cg],i=a.r[a.r.length-1],s=this.pieces[this.board[e.cg]],n=a.k[a.k.length-1],o=this.pieces[this.board[e.f]];return r&&(this.zSign=t.zobrist.update(this.zSign,"board",s.i,e.cg),this.zSign=t.zobrist.update(this.zSign,"board",s.i,i),this.zSign=t.zobrist.update(this.zSign,"board",o.i,e.f),this.zSign=t.zobrist.update(this.zSign,"board",o.i,n)),s.p=i,s.m=!0,this.board[e.cg]=-1,o.p=n,o.m=!0,this.board[e.f]=-1,this.board[i]=s.i,this.board[n]=o.i,this.castled[s.s]=!0,this.kings[o.s]=n,[{i:s.i,f:i,t:-1},{i:o.i,f:n,t:e.f,kp:e.f,who:o.s,m:!1},{i:s.i,f:-1,t:e.cg,m:!1,cg:!1}]},Model.Board.cbQuickApply=function(t,e){if(void 0!==e.cg)return this.cbApplyCastle(t,e,!1);var r=[],a=this.board[e.f],i=this.pieces[a];if(null!=e.c){r.unshift({i:e.c,f:-1,t:this.pieces[e.c].p});var s=this.pieces[e.c];this.board[s.p]=-1,s.p=-1}var n=this.kings[i.s];return t.g.pTypes[i.t].isKing&&(this.kings[i.s]=e.t),r.unshift({i:a,f:e.t,t:e.f,kp:n,who:i.s,ty:i.t}),i.p=e.t,void 0!==e.pr&&(i.t=e.pr),this.board[e.f]=-1,this.board[e.t]=a,r},Model.Board.cbQuickUnapply=function(t,e){for(var r=0;r<e.length;r++){var a=e[r],i=this.pieces[a.i];a.f>=0&&(i.p=-1,this.board[a.f]=-1),a.t>=0&&(i.p=a.t,this.board[a.t]=a.i),void 0!==a.m&&(i.m=a.m),void 0!==a.kp&&(this.kings[a.who]=a.kp),void 0!=a.ty&&(i.t=a.ty),void 0!=a.cg&&(this.castled[i.s]=a.cg)}},Model.Board.ApplyMove=function(t,e){var r=this.pieces[this.board[e.f]];if(void 0!==e.cg)this.cbApplyCastle(t,e,!0);else{if(this.zSign=t.zobrist.update(this.zSign,"board",r.i,e.f),this.board[r.p]=-1,void 0!==e.pr&&(this.zSign=t.zobrist.update(this.zSign,"type",r.t,r.i),r.t=e.pr,this.zSign=t.zobrist.update(this.zSign,"type",r.t,r.i)),null!=e.c){var a=this.pieces[e.c];this.zSign=t.zobrist.update(this.zSign,"board",a.i,a.p),this.board[a.p]=-1,a.p=-1,a.m=!0,this.noCaptCount=0}else this.noCaptCount++;r.p=e.t,r.m=!0,this.board[e.t]=r.i,this.zSign=t.zobrist.update(this.zSign,"board",r.i,e.t),t.g.pTypes[r.t].isKing&&(this.kings[r.s]=e.t)}this.check=!!e.ck,this.lastMove={f:e.f,t:e.t,c:e.c},void 0!==e.ko&&(this.ending[r.s]=e.ko),void 0!==e.ept?this.epTarget={p:e.ept,i:r.i}:this.epTarget=null,this.zSign=t.zobrist.update(this.zSign,"who",-this.mWho),this.zSign=t.zobrist.update(this.zSign,"who",this.mWho)},Model.Board.Evaluate=function(r){function a(e){var r=1/0;for(var a in t.geometry.corners)r=Math.min(r,h.distGraph[s.kings[e]][a]);return r-Math.sqrt(h.boardSize)}var i="debug"==arguments[3],s=this;this.mEvaluation=0;var n,o=this.mWho,h=r.g;if(e)n={1:{count:new Uint8Array(h.pTypes.length),byType:{}},"-1":{count:new Uint8Array(h.pTypes.length),byType:{}}};else{n={1:{count:[],byType:{}},"-1":{count:[],byType:{}}};for(var c=0;c<h.pTypes.length;c++)n[1].count[c]=n[-1].count[c]=0}if(r.mOptions.preventRepeat&&r.GetRepeatOccurence(this)>2)return this.mFinished=!0,void(this.mWinner=r.cbOnPerpetual?o*r.cbOnPerpetual:JocGame.DRAW);for(var p={1:0,"-1":0},l={1:h.distGraph[this.kings[-1]],"-1":h.distGraph[this.kings[1]]},u={1:0,"-1":0},v={1:0,"-1":0},b={1:0,"-1":0},f={1:0,"-1":0},d={1:!1,"-1":!1},g=this.pieces,m=g.length,c=0;c<m;c++){var G=g[c];if(G.p>=0){var y=G.s,M=h.pTypes[G.t];M.isKing?d[y]=G.m:p[y]+=M.value,M.castle&&!G.m&&f[y]++,v[y]++,u[y]+=l[y][G.p],b[y]+=t.geometry.distEdge[G.p];var C=n[y];C.count[G.t]++;var S=C.byType;void 0===S[G.t]?S[G.t]=[G]:S[G.t].push(G)}}if(this.lastMove&&null!=this.lastMove.c){var G=this.pieces[this.board[this.lastMove.t]];p[-G.s]+=this.cbStaticExchangeEval(r,G.p,G.s,{piece:G})}var k={1:0,"-1":0},A={1:0,"-1":0},T={1:0,"-1":0};this.ending[1]&&(A[1]=(u[1]-Math.sqrt(h.boardSize))/v[1],t.geometry.corners&&(T[1]=a(1))),this.ending[-1]&&(A[-1]=(u[-1]-Math.sqrt(h.boardSize))/v[-1],t.geometry.corners&&(T[1]=a(-1)));var z={pieceValue:p[1]-p[-1],pieceValueRatio:(p[1]-p[-1])/(p[1]+p[-1]+1),posValue:b[1]-b[-1],averageDistKing:u[1]/v[1]-u[-1]/v[-1],check:this.check?-o:0,endingKingFreedom:k[1]-k[-1],endingDistKing:A[1]-A[-1],distKingCorner:T[1]-T[-1]};t.castle&&(z.castle=(this.castled[1]?1:d[1]?0:f[1]/(h.castleablePiecesCount[1]+1))-(this.castled[-1]?1:d[-1]?0:f[-1]/(h.castleablePiecesCount[-1]+1))),t.evaluate&&t.evaluate.call(this,r,z,n);var E=r.mOptions.levelOptions;for(var P in z){var w=z[P],I=E[P+"Factor"]||0,R=w*I;i&&console.log(P,"=",w,"*",I,"=>",R),this.mEvaluation+=R}i&&console.log("Evaluation",this.mEvaluation)},Model.Board.cbGeneratePseudoLegalMoves=function(t){function e(e,i){var s=t.cbVar.promote;if(!s)return void a.push(i);var n=s.call(r,t,e,i);if(null!=n)if(0==n.length)a.push(i);else if(1==n.length)i.pr=n[0],a.push(i);else for(var o=0;o<n.length;o++){var h=n[o];a.push({f:i.f,t:i.t,c:i.c,pr:h,ept:i.ept,ep:i.ep,a:i.a})}}for(var r=this,a=[],i=t.cbVar,s=this.mWho,n=!i.castle||this.check||this.castled[s]?null:[],o=-1,h=this.pieces.length,c=0;c<h;c++){var p=this.pieces[c];if(!(p.p<0||p.s!=s)){var l=t.g.pTypes[p.t];l.isKing&&(p.m?n=null:o=p),n&&l.castle&&!p.m&&n.push(p);var u,v;u=l.graph[p.p],v=u.length;for(var b=0;b<v;b++)for(var f=u[b],d=!1,g=f.length,m=null,G=0;G<g;G++){var y=f[G],M=65535&y,C=this.board[M];if(!(C<0)||l.epCatch&&this.epTarget&&this.epTarget.p==M){if(!(524288&y)){var S;S=C<0?this.pieces[this.epTarget.i]:this.pieces[C],!(S.s!=p.s&&131072&y)||1048576&y&&!t.g.pTypes[S.t].isKing||2097152&y&&t.g.pTypes[S.t].isKing||e(p,{f:p.p,t:M,c:S.i,a:l.abbrev,ep:C<0});break}if(d){var S=this.pieces[C];S.s!=p.s&&e(p,{f:p.p,t:M,c:S.i,a:l.abbrev});break}d=!0}else 65536&y&&0==d&&e(p,{f:p.p,t:M,c:null,a:l.abbrev,ept:null!=m&&l.epTarget?m:void 0});m=M}}}if(n)for(var c=0;c<n.length;c++){var k=n[c],A=t.cbVar.castle[o.p+"/"+k.p];if(A){for(var T=!0,b=0;b<A.r.length;b++){var z=A.r[b];if(this.board[z]>=0&&z!=o.p&&z!=k.p){T=!1;break}}if(T){for(var E=!0,b=0;b<A.k.length;b++){var z=A.k[b];if(this.board[z]>=0&&z!=k.p&&z!=o.p||this.cbGetAttackers(t,z,s).length>0){E=!1;break}}E&&a.push({f:o.p,t:A.k[A.k.length-1],c:null,cg:k.p})}}}return a},Model.Board.cbStaticExchangeEval=function(t,e,r,a){var i=0,s=this.cbGetSmallestAttacker(t,e,r);if(s){var n=this.mWho;this.mWho=s.s;var o=this.cbQuickApply(t,{f:s.p,t:e,c:a.piece.i}),h=t.g.pTypes[a.piece.t].value;a.piece=s,i=Math.max(0,h-this.cbStaticExchangeEval(t,e,-r,a)),this.cbQuickUnapply(t,o),this.mWho=n}return i},Model.Board.cbGetSmallestAttacker=function(t,e,r){var a=this.cbGetAttackers(t,e,r);if(0==a.length)return null;for(var i=1/0,s=null,n=a.length,o=0;o<n;o++){var h=a[o],c=t.g.pTypes[h.t].value;c<i&&(i=c,s=h)}return s},Model.Board.cbCollectAttackers=function(t,e,r,a){for(var i in e){var s=e[i],n=this.board[i];if(n<0)this.cbCollectAttackers(t,s.e,r,a);else{var o=this.pieces[n];o.s==-t&&(s.t&&o.t in s.t||a&&s.tk&&o.t in s.tk)&&r.push(o)}}},Model.Board.cbCollectAttackersScreen=function(t,e,r,a,i){for(var s in e){var n=e[s],o=this.board[s];if(o<0)this.cbCollectAttackersScreen(t,n.e,r,a,i);else{var h=this.pieces[o];!i&&h.s==-t&&(n.t&&h.t in n.t||a&&n.tk&&h.t in n.tk)?r.push(h):i?i&&h.s==-t&&n.ts&&h.t in n.ts&&r.push(h):this.cbCollectAttackersScreen(t,n.e,r,a,!0)}}},Model.Board.cbGetAttackers=function(t,e,r,a){var i=[];return t.cbUseScreenCapture?this.cbCollectAttackersScreen(r,t.g.threatGraph[r][e],i,a,!1):this.cbCollectAttackers(r,t.g.threatGraph[r][e],i,a),i},Model.Board.GenerateMoves=function(t){var e=this.cbGeneratePseudoLegalMoves(t);this.mMoves=[];for(var r=!0,a=this.kings[this.mWho],i=e.length,s=0;s<i;s++){var n=e[s],o=this.cbQuickApply(t,n);if(!(this.cbGetAttackers(t,this.kings[this.mWho],this.mWho,!0).length>0)){var h=this.cbGetAttackers(t,this.kings[-this.mWho],-this.mWho,!0).length>0;n.ck=h,this.mMoves.push(n),n.f!=a&&(r=!1)}this.cbQuickUnapply(t,o)}if(0==this.mMoves.length)this.mFinished=!0,this.mWinner=t.cbOnStaleMate?t.cbOnStaleMate*this.mWho:JocGame.DRAW,this.check&&(this.mWinner=-this.mWho);else if(this.ending[this.mWho]){if(!r)for(var s=0;s<this.mMoves.length;s++)this.mMoves[s].ko=!1}else if(!this.ending[this.mWho]&&r&&!this.check)for(var s=0;s<this.mMoves.length;s++)this.mMoves[s].ko=!0},Model.Board.GetSignature=function(){return this.zSign},Model.Move.Init=function(t){for(var e in t)t.hasOwnProperty(e)&&(this[e]=t[e])},Model.Move.Equals=function(t){return this.f==t.f&&this.t==t.t&&this.pr==t.pr},Model.Move.CopyFrom=function(t){this.Init(t)},Model.Move.ToString=function(e){var r=this;switch(e=e||"natural"){case"natural":return function(){var e;if(void 0!==r.cg?e=t.castle[r.f+"/"+r.cg].n:(e=r.a||"",e+=t.geometry.PosName(r.f),null==r.c?e+="-":e+="x",e+=t.geometry.PosName(r.t)),void 0!==r.pr){var a=t.pieceTypes[r.pr];a&&a.abbrev&&a.abbrev.length>0&&!a.silentPromo&&(e+="="+a.abbrev)}return r.ck&&(e+="+"),e}();case"engine":return function(){var e=t.geometry.PosName(r.f)+t.geometry.PosName(r.t);if(void 0!=r.pr){var a=t.pieceTypes[r.pr];a&&a.abbrev&&a.abbrev.length>0&&!a.silentPromo&&(e+=a.abbrev)}return e}();default:return"??"}},Model.Board.CompactMoveString=function(e,r,a){"function"!=typeof r.ToString&&(r=e.CreateMove(r));var i=r.ToString(),s=/^([A-Z]?)([a-z])([1-9][0-9]*)([-x])([a-z])([1-9][0-9]*)(.*?)$/.exec(i);if(!s)return i;var n=s[7];if(a||(a={}),a.value||(a.value=[]),0==a.value.length){var o=this.mMoves;this.mMoves&&0!=this.mMoves.length||this.GenerateMoves(e);for(var h=0;h<this.mMoves.length;h++){var c=this.mMoves[h];"function"!=typeof c.ToString&&(c=e.CreateMove(c)),a.value.push({str:c.ToString(),move:c})}this.mMoves=o}var p=[];if(a.value.forEach(function(t){var e=/^([A-Z]?[a-z][1-9][0-9]*[-x][a-z][1-9][0-9]*)(.*?)$/.exec(t.str);e&&t.move.t==r.t&&(t.move.a||"")==s[1]&&e[2]==n&&p.push(t.move)}),1==p.length)return""==s[1]&&"x"==s[4]?s[2]+"x"+s[5]+s[6]+s[7]:s[1]+("x"==s[4]?"x":"")+s[5]+s[6]+s[7];if(t.geometry.CompactCrit)for(var l="",h=0;;h++){var u=t.geometry.CompactCrit(r.f,h);if(null==u)return i;l+=u;for(var v=[],b=0;b<p.length;b++){var f=p[b];t.geometry.CompactCrit(f.f,h)==u&&v.push(f)}if(console.assert(v.length>0),1==v.length)return s[1]+l+("x"==s[4]?"x":"")+s[5]+s[6]+s[7];p=v}return i},Model.Board.cbIntegrity=function(t){function e(t,e){t||console.error(e)}for(var r=this,a=0;a<this.board.length;a++){var i=this.board[a];if(i>=0){var s=r.pieces[i];e(void 0!==s,"no piece at pos"),e(s.p==a,"piece has different pos")}}for(var i=0;i<this.pieces.length;i++){var s=this.pieces[i];s.p>=0&&e(r.board[s.p]==i,"board index mismatch")}},Model.Board.ExportBoardState=function(t){return t.cbVar.geometry.ExportBoardState?t.cbVar.geometry.ExportBoardState(this,t.cbVar,t.mPlayedMoves.length):"not supported"},Model.Game.Import=function(e,r){var a,i=[],s={1:{},"-1":{}},n=null,o=0;if("pjn"==e){var h={status:!1,error:"parse"},c=r.split(" ");if(6!=c.length)return console.warn("FEN should have 6 parts"),h;var p=c[0].split("/"),l=t.geometry.fenHeight||t.geometry.height;if(p.length!=l)return console.warn("FEN board should have",l,"rows, got",p.length),h;var u={};for(var v in t.pieceTypes){var b=t.pieceTypes[v],f=b.fenAbbrev||b.abbrev||"X";u[f.toUpperCase()]={s:1,t:v},u[f.toLowerCase()]={s:-1,t:v}}var d=t.geometry.FenRowPos||function(e,r){return(t.geometry.height-1-e)*t.geometry.width+r};if(p.forEach(function(e,r){for(var a=0,s=0;s<e.length;s++){var n=e.substr(s,1),o=u[n];if(void 0!==o){var c=d(r,a);a++;for(var p={s:o.s,t:o.t,p:c},l=!0,v=t.pieceTypes[p.t].initial||[],b=0;b<v.length;b++){var f=v[b];f.s==p.s&&f.p==c&&(l=!1)}p.m=l,i.push(p)}else{if(isNaN(parseInt(n)))return console.warn("FEN invalid board spec",n),h;a+=parseInt(n)}}}),i.sort(function(t,e){return e.s-t.s}),"w"==c[1])a=1;else{if("b"!=c[1])return console.warn("FEN invalid turn spec",c[1]),h;a=-1}s[1].k=c[2].indexOf("K")>=0,s[1].q=c[2].indexOf("Q")>=0,s[-1].k=c[2].indexOf("k")>=0,s[-1].q=c[2].indexOf("q")>=0,n="-"==c[3]?null:c[3];var g=parseInt(c[4]);isNaN(g)||(o=g);var m={pieces:i,turn:a,castle:s,enPassant:n,noCaptCount:o};return t.importGame&&t.importGame.call(this,m,e,r),{status:!0,initial:m}}return{status:!1,error:"unsupported"}}}(),function(){Model.Game.cbBoardGeometryGrid=function(t,e){function r(e){return e%t}function a(e){return Math.floor(e/t)}function i(e,r){return r*t+e}function s(s,n){var o=r(s),h=a(s),c=o+n[0],p=h+n[1];return c<0||c>=t||p<0||p>=e?null:i(c,p)}function n(t){return String.fromCharCode("a".charCodeAt(0)+r(t))+(a(t)+1)}function o(t){var e=/^([a-z])([0-9]+)$/.exec(t);return e?i(e[1].charCodeAt(0)-"a".charCodeAt(0),parseInt(e[2])-1):-1}function h(t,e){return 0==e?String.fromCharCode("a".charCodeAt(0)+r(t)):1==e?a(t)+1:null}function c(){for(var i=[],s=0;s<t*e;s++){var n=[];i.push(n);for(var o=0;o<t*e;o++){var h=a(s),c=r(s),p=a(o),l=r(o);n.push(Math.max(Math.abs(h-p),Math.abs(c-l)))}}return i}function p(r,a,s){for(var o=[],h=e-1;h>=0;h--){for(var c="",p=0,l=0;l<t;l++){var u=r.board[i(l,h)];if(u<0)p++;else{p>0&&(c+=p,p=0);var v=r.pieces[u],b=a.pieceTypes[v.t].fenAbbrev||a.pieceTypes[v.t].abbrev||"?";v.s==-1?c+=b.toLowerCase():c+=b.toUpperCase()}}p&&(c+=p),o.push(c)}var f=o.join("/");f+=" ",1==r.mWho?f+="w":f+="b",f+=" ";var d="";return r.castled&&(r.castled[1]===!1?d+="KQ":(r.castled[1].k&&(d+="K"),r.castled[1].q&&(d+="Q")),r.castled[-1]===!1?d+="kq":(r.castled[-1].k&&(d+="k"),r.castled[-1].q&&(d+="q"))),0==d.length&&(d="-"),f+=d,f+=" ",r.epTarget?f+=n(r.epTarget.p):f+="-",f+=" ",f+=r.noCaptCount,f+=" ",f+=Math.floor(s/2)+1}return{boardSize:t*e,width:t,height:e,C:r,R:a,POS:i,Graph:s,PosName:n,PosByName:o,CompactCrit:h,GetDistances:c,distEdge:function(){for(var i=[],s=0;s<t*e;s++){var n=r(s),o=a(s);i[s]=Math.min(n,Math.abs(t-n-1),o,Math.abs(e-o-1))}return i}(),corners:function(){var r={};return r[i(0,0)]=1,r[i(0,e-1)]=1,r[i(t-1,0)]=1,r[i(t-1,e-1)]=1,r}(),ExportBoardState:p}},Model.Game.cbPawnGraph=function(t,e,r){for(var a=this,i={},s=0;s<t.boardSize;s++)if(!r||s in r){var n=[],o=t.Graph(s,[0,e]);null!=o&&(!r||o in r)&&n.push(a.cbTypedArray([o|a.cbConstants.FLAG_MOVE])),[-1,1].forEach(function(i){var o=t.Graph(s,[i,e]);null!=o&&(!r||o in r)&&n.push(a.cbTypedArray([o|a.cbConstants.FLAG_CAPTURE]))}),i[s]=n}else i[s]=[];return i},Model.Game.cbInitialPawnGraph=function(t,e,r){for(var a=this,i={},s=0;s<t.boardSize;s++)if(!r||s in r){var n=[],o=t.Graph(s,[0,e]);if(null!=o&&(!r||o in r)){var h=[o|a.cbConstants.FLAG_MOVE],c=t.Graph(o,[0,e]);null!=c&&(!r||c in r)&&h.push(c|a.cbConstants.FLAG_MOVE),n.push(a.cbTypedArray(h))}[-1,1].forEach(function(i){var o=t.Graph(s,[i,e]);null!=o&&(!r||o in r)&&n.push(a.cbTypedArray([o|a.cbConstants.FLAG_CAPTURE]))}),i[s]=n}else i[s]=[];return i},Model.Game.cbKingGraph=function(t,e){return this.cbShortRangeGraph(t,[[-1,-1],[-1,0],[-1,1],[0,-1],[0,1],[1,-1],[1,0],[1,1]],e)},Model.Game.cbKnightGraph=function(t,e){return this.cbShortRangeGraph(t,[[2,-1],[2,1],[-2,-1],[-2,1],[-1,2],[-1,-2],[1,2],[1,-2]],e)},Model.Game.cbHorseGraph=function(t){for(var e=this,r={},a=0;a<t.boardSize;a++)r[a]=[],[[1,0,2,-1],[1,0,2,1],[-1,0,-2,-1],[-1,0,-2,1],[0,1,-1,2],[0,-1,-1,-2],[0,1,1,2],[0,-1,1,-2]].forEach(function(i){var s=t.Graph(a,[i[0],i[1]]);if(null!=s){var n=t.Graph(a,[i[2],i[3]]);null!=n&&r[a].push(e.cbTypedArray([s|e.cbConstants.FLAG_STOP,n|e.cbConstants.FLAG_MOVE|e.cbConstants.FLAG_CAPTURE]))}});return r},Model.Game.cbRookGraph=function(t,e){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0]],e)},Model.Game.cbBishopGraph=function(t,e){return this.cbLongRangeGraph(t,[[1,-1],[1,1],[-1,1],[-1,-1]],e)},Model.Game.cbQueenGraph=function(t,e){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0],[1,-1],[1,1],[-1,1],[-1,-1]],e)},Model.Game.cbXQGeneralGraph=function(t,e){for(var r=this,a={},i=0;i<t.boardSize;i++)a[i]=[],[[-1,0,!1],[0,-1,!0],[0,1,!0],[1,0,!1]].forEach(function(s){var n=[],o=t.Graph(i,s);if(null!=o&&((!e||o in e)&&n.push(o|r.cbConstants.FLAG_MOVE|r.cbConstants.FLAG_CAPTURE),s[2]))for(var h=t.Graph(o,s);null!=h;)!e||h in e?n.push(h|r.cbConstants.FLAG_CAPTURE|r.cbConstants.FLAG_CAPTURE_KING):n.push(h|r.cbConstants.FLAG_STOP),h=t.Graph(h,s);n.length>0&&a[i].push(r.cbTypedArray(n))});return a},Model.Game.cbXQSoldierGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e]])},Model.Game.cbXQPromoSoldierGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e],[-1,0],[1,0]])},Model.Game.cbXQAdvisorGraph=function(t,e){return this.cbShortRangeGraph(t,[[1,1],[-1,1],[1,-1],[-1,-1]],e)},Model.Game.cbXQCannonGraph=function(t){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0]],null,this.cbConstants.FLAG_MOVE|this.cbConstants.FLAG_SCREEN_CAPTURE)},Model.Game.cbXQElephantGraph=function(t,e){for(var r=this,a={},i=0;i<t.boardSize;i++)a[i]=[],(!e||i in e)&&[[1,1,2,2],[1,-1,2,-2],[-1,1,-2,2],[-1,-1,-2,-2]].forEach(function(s){var n=t.Graph(i,[s[0],s[1]]);if(null!=n){var o=t.Graph(i,[s[2],s[3]]);null!=o&&(!e||o in e)&&a[i].push(r.cbTypedArray([n|r.cbConstants.FLAG_STOP,o|r.cbConstants.FLAG_MOVE|r.cbConstants.FLAG_CAPTURE]))}});return a},Model.Game.cbSilverGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e],[-1,-1],[-1,1],[1,-1],[1,1]])},Model.Game.cbFersGraph=function(t,e){return this.cbShortRangeGraph(t,[[-1,-1],[-1,1],[1,-1],[1,1]])},Model.Game.cbSchleichGraph=function(t,e){return this.cbShortRangeGraph(t,[[-1,0],[1,0],[0,-1],[0,1]])},Model.Game.cbAlfilGraph=function(t,e){return this.cbShortRangeGraph(t,[[-2,-2],[-2,2],[2,2],[2,-2]])}}(),function(){for(var t=Model.Game.cbBoardGeometryGrid(10,8),e={},r=0;r<t.boardSize;r++)10!=r&&20!=r&&30!=r&&40!=r&&50!=r&&60!=r&&19!=r&&29!=r&&39!=r&&49!=r&&59!=r&&69!=r&&(e[r]=1);Model.Game.cbDefine=function(){return{geometry:t,pieceTypes:{0:{name:"pawn-w",aspect:"fr-pawn",graph:this.cbPawnGraph(t,1,e),value:1.1,abbrev:"",fenAbbrev:"P",epCatch:!0},1:{name:"ipawn-w",aspect:"fr-pawn",graph:this.cbInitialPawnGraph(t,1,e),value:1.1,abbrev:"",fenAbbrev:"P",initial:[{s:1,p:11},{s:1,p:12},{s:1,p:13},{s:1,p:14},{s:1,p:15},{s:1,p:16},{s:1,p:17},{s:1,p:18}],epTarget:!0},2:{name:"pawn-b",aspect:"fr-pawn",graph:this.cbPawnGraph(t,-1,e),value:1.1,abbrev:"",fenAbbrev:"P",epCatch:!0},3:{name:"ipawn-b",aspect:"fr-pawn",graph:this.cbInitialPawnGraph(t,-1,e),value:1.1,abbrev:"",fenAbbrev:"P",initial:[{s:-1,p:61},{s:-1,p:62},{s:-1,p:63},{s:-1,p:64},{s:-1,p:65},{s:-1,p:66},{s:-1,p:67},{s:-1,p:68}],epTarget:!0},4:{name:"knight",aspect:"fr-knight",graph:this.cbKnightGraph(t,e),value:2.9,abbrev:"N",initial:[{s:1,p:2},{s:1,p:7},{s:-1,p:72},{s:-1,p:77}]},5:{name:"bishop",aspect:"fr-bishop",graph:this.cbBishopGraph(t,e),value:3.1,abbrev:"B",initial:[{s:1,p:3},{s:1,p:6},{s:-1,p:73},{s:-1,p:76}]},6:{name:"rook",aspect:"fr-rook",graph:this.cbRookGraph(t,e),value:5,abbrev:"R",initial:[{s:1,p:1},{s:1,p:8},{s:-1,p:71},{s:-1,p:78}],castle:!0},7:{name:"queen",aspect:"fr-queen",graph:this.cbQueenGraph(t,e),value:8.7,abbrev:"Q",initial:[{s:1,p:4},{s:-1,p:74}]},8:{name:"king",aspect:"fr-king",isKing:!0,graph:this.cbKingGraph(t,e),abbrev:"K",initial:[{s:1,p:5},{s:-1,p:75}]},9:{name:"amazon",aspect:"fr-amazon",graph:this.cbMergeGraphs(t,this.cbQueenGraph(t,e),this.cbKnightGraph(t,e)),value:11.5,abbrev:"A",initial:[{s:1,p:0},{s:1,p:9},{s:-1,p:70},{s:-1,p:79}]}},promote:function(e,r,a){return 1==r.t?[0]:3==r.t?[2]:0==r.t&&7==t.R(a.t)?[4,5,6,7,9]:2==r.t&&0==t.R(a.t)?[4,5,6,7,9]:[]},castle:{"5/1":{k:[4,3],r:[2,3,4],n:"O-O-O"},"5/8":{k:[6,7],r:[7,6],n:"O-O"},"75/71":{k:[74,73],r:[72,73,74],n:"O-O-O"},"75/78":{k:[76,77],r:[77,76],n:"O-O"}}}}}();

/***/ }),

/***/ "8hgl":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__("mmVS");
var tryCatch_1 = __webpack_require__("+3eL");
var errorObject_1 = __webpack_require__("WhVc");
/* tslint:enable:max-line-length */
/**
 * Returns an Observable that emits all items emitted by the source Observable that are distinct by comparison from the previous item.
 *
 * If a comparator function is provided, then it will be called for each item to test for whether or not that value should be emitted.
 *
 * If a comparator function is not provided, an equality check is used by default.
 *
 * @example <caption>A simple example with numbers</caption>
 * Observable.of(1, 1, 2, 2, 2, 1, 1, 2, 3, 3, 4)
 *   .distinctUntilChanged()
 *   .subscribe(x => console.log(x)); // 1, 2, 1, 2, 3, 4
 *
 * @example <caption>An example using a compare function</caption>
 * interface Person {
 *    age: number,
 *    name: string
 * }
 *
 * Observable.of<Person>(
 *     { age: 4, name: 'Foo'},
 *     { age: 7, name: 'Bar'},
 *     { age: 5, name: 'Foo'})
 *     { age: 6, name: 'Foo'})
 *     .distinctUntilChanged((p: Person, q: Person) => p.name === q.name)
 *     .subscribe(x => console.log(x));
 *
 * // displays:
 * // { age: 4, name: 'Foo' }
 * // { age: 7, name: 'Bar' }
 * // { age: 5, name: 'Foo' }
 *
 * @see {@link distinct}
 * @see {@link distinctUntilKeyChanged}
 *
 * @param {function} [compare] Optional comparison function called to test if an item is distinct from the previous item in the source.
 * @return {Observable} An Observable that emits items from the source Observable with distinct values.
 * @method distinctUntilChanged
 * @owner Observable
 */
function distinctUntilChanged(compare, keySelector) {
    return this.lift(new DistinctUntilChangedOperator(compare, keySelector));
}
exports.distinctUntilChanged = distinctUntilChanged;
var DistinctUntilChangedOperator = (function () {
    function DistinctUntilChangedOperator(compare, keySelector) {
        this.compare = compare;
        this.keySelector = keySelector;
    }
    DistinctUntilChangedOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new DistinctUntilChangedSubscriber(subscriber, this.compare, this.keySelector));
    };
    return DistinctUntilChangedOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var DistinctUntilChangedSubscriber = (function (_super) {
    __extends(DistinctUntilChangedSubscriber, _super);
    function DistinctUntilChangedSubscriber(destination, compare, keySelector) {
        _super.call(this, destination);
        this.keySelector = keySelector;
        this.hasKey = false;
        if (typeof compare === 'function') {
            this.compare = compare;
        }
    }
    DistinctUntilChangedSubscriber.prototype.compare = function (x, y) {
        return x === y;
    };
    DistinctUntilChangedSubscriber.prototype._next = function (value) {
        var keySelector = this.keySelector;
        var key = value;
        if (keySelector) {
            key = tryCatch_1.tryCatch(this.keySelector)(value);
            if (key === errorObject_1.errorObject) {
                return this.destination.error(errorObject_1.errorObject.e);
            }
        }
        var result = false;
        if (this.hasKey) {
            result = tryCatch_1.tryCatch(this.compare)(this.key, key);
            if (result === errorObject_1.errorObject) {
                return this.destination.error(errorObject_1.errorObject.e);
            }
        }
        else {
            this.hasKey = true;
        }
        if (Boolean(result) === false) {
            this.key = key;
            this.destination.next(value);
        }
    };
    return DistinctUntilChangedSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=distinctUntilChanged.js.map

/***/ }),

/***/ "8szd":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var skipUntil_1 = __webpack_require__("RyDc");
Observable_1.Observable.prototype.skipUntil = skipUntil_1.skipUntil;
//# sourceMappingURL=skipUntil.js.map

/***/ }),

/***/ "8tfe":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _slicedToArray=function(){function e(e,t){var r=[],n=!0,o=!1,i=void 0;try{for(var a,s=e[Symbol.iterator]();!(n=(a=s.next()).done)&&(r.push(a.value),!t||r.length!==t);n=!0);}catch(e){o=!0,i=e}finally{try{!n&&s.return&&s.return()}finally{if(o)throw i}}return r}return function(t,r){if(Array.isArray(t))return t;if(Symbol.iterator in Object(t))return e(t,r);throw new TypeError("Invalid attempt to destructure non-iterable instance")}}();!function(){function e(e,t,r,n,o){var i=function(){this.g={}};Object.assign(i.prototype,r.Game.prototype,n.model.Game);var a=function(){};Object.assign(a.prototype,r.Board.prototype,n.model.Board),i.prototype.mBoardClass=a;var s=function(e){this.Init(e)};Object.assign(s.prototype,r.Move.prototype,n.model.Move),i.prototype.mMoveClass=s,i.prototype.config=o.config,"browser"==u&&(i.prototype.config.baseURL=SystemJS.getConfig().baseURL,i.prototype.config.view.fullPath=SystemJS.getConfig().baseURL+"games/"+t.module),i.prototype.module=t.module,i.prototype.name=e;var m={game:o.config.model.gameOptions,view:o.config.view};c[e]={gameClass:i,initArgs:m};var h=new i;return h.Init(m),h}function t(e,t){var i=c[e];if(i){return new Promise(function(e,t){var r=new i.gameClass;r.Init(i.initArgs),e(r)})}return"worker"==u?n(e,t):"node"==u?r(e,t):o(e,t)}function r(t,r){Date.now();return r=r||{},new Promise(function(r,n){var o=__webpack_require__("fWrr").games,i=o[t];if(!i)return n(new Error("Game "+t+" not found"));var a=__webpack_require__("iz9z"),s=__webpack_require__("z1UN")("./"+i.module+"/"+t+"-model.js"),m=__webpack_require__("rCAb")("./"+i.module+"/"+t+"-config.js");r(e(t,i,a,s,m))})}function n(t,r){Date.now();return r=r||{},new Promise(function(r,n){importScripts("jocly-allgames.js");var o=exports.games,i=o[t];if(!i)return n(new Error("Game "+t+" not found"));var a=exports,s=exports={};importScripts("jocly.game.js");var m=exports={};importScripts("games/"+i.module+"/"+t+"-model.js");var u=exports={};importScripts("games/"+i.module+"/"+t+"-config.js"),exports=a,r(e(t,i,s,m,u))})}function o(t,r){return r=r||{},new Promise(function(r,n){exports.listGames().then(function(o){var i=o[t];if(!i)return n(new Error("Game "+t+" not found"));var a=[SystemJS.import("jocly.game.js"),SystemJS.import("games/"+i.module+"/"+t+"-model.js"),SystemJS.import("games/"+i.module+"/"+t+"-config.js")];Promise.all(a).then(function(n){var o=_slicedToArray(n,3),a=o[0],s=o[1],m=o[2],u=e(t,i,a,s,m);r(u)},function(e){n(e)})},n)})}function i(e,t){this.gameName=e,this.game=t,this.iframe=null,this.id=++p,g[this.id]=this}function a(e){var t=e.data,r=g[t.joclyEmbeddedGameId];if(r){var n=t.replyId;if(n){var o=l[n];if(o)if(delete l[n],"error"==t.message.type){var i=new Error(t.message.error.message,t.message.error.fileName,t.message.error.lineNumber);o(i)}else o(null,t.message)}else"machine-progress"==t.message.type&&r.machineProgressListener&&r.machineProgressListener(t.message.progress)}}function s(e,t,r){var n={message:t};if(r){var o=++f;n.replyId=o,l[o]=r}try{e.iframe.contentWindow.postMessage(n,"*")}catch(e){console.error("Message",t,"could not be posted:",e)}}function m(e,t,r){return r=Array.from(r||[]),new Promise(function(n,o){s(e,{type:"method",id:e.id,methodName:t,args:r},function(e,t){e?o(e):n.apply(null,t&&t.args||[])})})}var u="browser";"undefined"==typeof WorkerGlobalScope&&"undefined"==typeof SystemJS?u="node":"undefined"!=typeof WorkerGlobalScope&&self instanceof WorkerGlobalScope&&(u="worker");var c={};exports.listGames=function(){return new Promise(function(e,t){"browser"==u||"worker"==u?SystemJS.import("jocly-allgames.js").then(function(t){var r={},n=SystemJS.getConfig().baseURL;for(var o in t.games){var i=Object.assign({},t.games[o]);i.thumbnail=n+"games/"+i.module+"/"+i.thumbnail,r[o]=i}e(r)},function(e){console.warn("Could not load Jocly games",e),t(e)}):e(__webpack_require__("fWrr").games)})},exports.createMatch=function(e){return new Promise(function(r,n){t(e).then(function(t){var n=new i(e,t);r(n)},function(e){n(e)})})},exports.getGameConfig=function(e){return new Promise(function(t,r){exports.listGames().then(function(n){var o=n[e];if(!o)return r(new Error("Game "+e+" not found"));"undefined"!=typeof SystemJS?SystemJS.import("games/"+o.module+"/"+e+"-config.js").then(function(e){e.config.view.fullPath=SystemJS.getConfig().baseURL+"games/"+o.module,t(e.config)}).catch(r):t(__webpack_require__("rCAb")("./"+o.module+"/"+e+"-config.js").config)},r)})};var h=!1,g={},f=0,l={},p=0;i.prototype.attachElement=function(e,t){if("node"==u)return Promise.reject(new Error("attachElement(): not supported in node.js"));if(!this.game||this.iframe)return Promise.reject(new Error("attachElement(): match is already attached"));t=t||{};var r=this;return new Promise(function(n,o){h||(h=!0,window.addEventListener("message",a)),r.element=e;var i=document.createElement("iframe"),m={name:"jocly-embedded-"+r.id,frameborder:0,src:SystemJS.getConfig().baseURL+"jocly.embed.html",width:"100%",height:"100%"};Object.keys(m).forEach(function(e){i.setAttribute(e,m[e])}),Object.assign(i.style,{position:"absolute",top:0,right:0,bottom:0,left:0,whiteSpace:"normal"});var u=document.createElement("div");Object.assign(u.style,{position:"relative",whiteSpace:"nowrap",width:"100%",height:"100%"}),u.appendChild(i),e.appendChild(u),r.iframe=i,i.onload=function(){s(r,{type:"init",id:r.id,gameName:r.gameName,playedMoves:r.game.mPlayedMoves,options:t},function(e,t){e?o(e):(r.game=null,n())})}})},i.prototype.detachElement=function(){if("node"==u)return Promise.reject(new Error("detachElement(): not supported in node.js"));if(this.game||!this.iframe)return Promise.reject(new Error("detachElement(): match is not attached"));var e=this;return new Promise(function(r,n){Promise.all([t(e.gameName),m(e,"getPlayedMoves")]).then(function(t){var r=_slicedToArray(t,2),n=r[0],o=r[1];return e.game=n,n.Load({playedMoves:o}),m(e,"destroy")}).then(function(){for(;e.element.firstChild;)e.element.removeChild(e.element.firstChild);delete e.element,delete e.iframe,r()}).catch(n)})},i.prototype.getTurn=function(){if(this.game){var e=this;return new Promise(function(t,r){t(e.game.GetWho())})}return m(this,"getTurn",arguments)},i.prototype.getMoveString=function(e,t){if(this.game){var r=this;return new Promise(function(n,o){n(Array.isArray(e)?e.map(function(e){return r.game.CreateMove(e).ToString(t)}):r.game.CreateMove(e).ToString(t))})}return m(this,"getMoveString",arguments)},i.prototype.pickMove=function(e){if(this.game){var t=this;return new Promise(function(r,n){t.game.mBoard.mMoves&&0!=t.game.mBoard.mMoves.length||t.game.mBoard.GenerateMoves(t.game),r(t.game.GetBestMatchingMove(e,t.game.mBoard.mMoves))})}return m(this,"pickMove",arguments)},i.prototype.playMove=function(e){if("node"==u||!this.iframe&&!this.area)return this.applyMove(e);if(this.game){var t=this;return new Promise(function(r,n){t.game.PlayMove(e).then(function(){t.game.InvertWho();var e=t.game.GetFinished();t.game.DisplayBoard(),r({finished:!!e,winner:e})}).catch(function(e){n(e)})})}return m(this,"playMove",arguments)},i.prototype.applyMove=function(e){if(this.game){var t=this;return new Promise(function(r,n){t.game.ApplyMove(e),t.game.InvertWho();var o=t.game.GetFinished();t.area&&t.game.DisplayBoard(),r({finished:!!o,winner:o})})}return m(this,"applyMove",arguments)},i.prototype.destroy=function(e){var t=this;if(this.game){return new Promise(function(e,r){t.area&&t.game.GameDestroyView(),e()})}return this.detachElement().then(function(){delete g[t.id]})},i.prototype.getPlayedMoves=function(){if(this.game){var e=this;return new Promise(function(t,r){t(Array.from(e.game.mPlayedMoves))})}return m(this,"getPlayedMoves")},i.prototype.userTurn=function(){if("node"==u)return Promise.reject(new Error("userTurn(): not supported in node.js"));if(!this.area&&!this.iframe)return Promise.reject(new Error("userTurn(): match is not attached to DOM element"));if(this.game){var e,t=function(){r.game.HumanMove=e,delete r.userTurnReject},r=this;return new Promise(function(t,n){var o;o=r.userTurnReject?r.abortUserTurn():new Promise(function(e){e()}),o.then(function(){},function(){}).then(function(){function o(e){function o(){r.game.InvertWho();var n=r.game.GetFinished();r.game.DisplayBoard(),t({move:e,finished:!!n,winner:n})}r.game.config.view.animateSelfMoves===!1?(r.game.ApplyMove(e),o()):r.game.PlayMove(e).then(o,n)}r.userTurnReject=n,e=r.game.HumanMove,r.game.HumanMove=o,r.game.HumanTurn()})}).then(function(e){return t(),e}).catch(function(e){throw t(),e})}return m(this,"userTurn")},i.prototype.abortUserTurn=function(e){if("node"==u)return Promise.reject(new Error("abortUserTurn(): not supported in node.js"));if(!this.area&&!this.iframe)return Promise.reject(new Error("abortUserTurn(): match is not attached to DOM element"));if(this.game){var t=this;if(!this.userTurnReject)return e?Promise.reject(new Error("abortUserTurn(): not in user input mode")):Promise.resolve();return new Promise(function(e,r){t.game.HumanTurnEnd();var n=t.userTurnReject;delete t.userTurnReject,n(new Error("User input aborted")),e()})}return m(this,"abortUserTurn",arguments)},i.prototype.machineSearch=function(e){var t=this;if(this.game){var r=function(){t.game.MachineMove=n,t.game.MachineProgress=o,delete t.machineSearchReject};e=Object.assign({level:t.game.config.model.levels[0],threaded:!0},e);var n,o;return new Promise(function(r,i){var a;a=t.machineSearchReject?t.abortMachineSearch():new Promise(function(e){e()}),a.then(function(){},function(){}).then(function(){function a(e){var n=e.move;delete e.move;var o=t.game.GetFinished();r({move:n,finished:!!o,winner:o})}function s(e){t.area&&window.parent.postMessage({joclyEmbeddedGameId:t.id,message:{type:"machine-progress",progress:e}},"*")}t.machineSearchReject=i,n=t.game.MachineMove,t.game.MachineMove=a,o=t.game.MachineProgress,t.game.MachineProgress=s,t.game.StartMachine(e)})}).then(function(e){return r(),e}).catch(function(e){throw r(),e})}var i=function(){delete t.machineProgressListener};return e=e||{},t.machineProgressListener=e.progress||function(){},delete e.progress,m(this,"machineSearch",[e]).then(function(e){return i(),e}).catch(function(e){throw i(),e})},i.prototype.abortMachineSearch=function(e){if(this.game){var t=this;if(!this.machineSearchReject)return e?Promise.reject(new Error("abortMachineSearch(): machine not searching")):Promise.resolve();return new Promise(function(e,r){t.game.StopThreadedMachine();var n=t.machineSearchReject;delete t.machineSearchReject,n(new Error("Machine search aborted")),e()})}return m(this,"abortMachineSearch")},i.prototype.setViewOptions=function(e){if("node"==u)return Promise.reject(new Error("setViewOptions(): not supported in node.js"));if(!this.area&&!this.iframe)return Promise.reject(new Error("setViewOptions(): match is not attached to DOM element"));if(this.game){var t=this;return new Promise(function(r,n){t.game.GameDestroyView();var o={mSkin:"skin",mNotation:"notation",mSounds:"sounds",mShowMoves:"showMoves",mAutoComplete:"autoComplete",mAnaglyph:"anaglyph"};for(var i in o)void 0!==e[o[i]]&&(t.game[i]=e[o[i]]);e.viewAs&&t.game.mViewOptions.switchable&&(t.game.mViewAs=e.viewAs),t.game.GameInitView(),t.game.DisplayBoard(),r()})}return m(this,"setViewOptions",arguments)},i.prototype.getViewOptions=function(){if(this.game){var e=this;return new Promise(function(t,r){var n={skin:e.game.mSkin,sounds:e.game.mSounds,anaglyph:e.game.mAnaglyph};e.game.mViewOptions.useNotation&&(n.notation=!!e.game.mNotation),e.game.mViewOptions.useShowMoves&&(n.showMoves=!!e.game.mShowMoves),e.game.mViewOptions.useAutoComplete&&(n.autoComplete=!!e.game.mAutoComplete),e.game.mViewOptions.switchable&&(n.viewAs=e.game.mViewAs),t(n)})}return m(this,"getViewOptions")},i.prototype.getFinished=function(){if(this.game){var e=this;return new Promise(function(t,r){var n=e.game.GetFinished();t({finished:!!n,winner:n})})}return m(this,"getFinished")},i.prototype.rollback=function(e){if(this.game){var t=this;return new Promise(function(r,n){e<0&&(e=t.game.mPlayedMoves.length+e),e=Math.max(0,Math.min(e,t.game.mPlayedMoves.length));var o=t.game.mPlayedMoves;t.game.BackTo(e,o),t.area&&t.game.DisplayBoard(),r()})}return m(this,"rollback",arguments)},i.prototype.otherPlayer=function(e){return new Promise(function(t,r){1==e?t(-1):e==-1?t(1):r(new Error("otherPlayer: invalid input"))})},i.prototype.save=function(){if(this.game){var e=this;return new Promise(function(t,r){t({playedMoves:Array.from(e.game.mPlayedMoves),initialBoard:e.game.mInitialString,game:e.gameName})})}return m(this,"save")},i.prototype.load=function(e){if(this.game){var t=this;return new Promise(function(r,n){if(e.game&&e.game!=t.gameName)return n(new Error("Trying to load "+e.game+" to "+t.gameName+" match"));t.game.Load(e),t.area&&t.game.DisplayBoard(),r()})}return m(this,"load",arguments)},i.prototype.getConfig=function(){if(this.game){var e=this;return new Promise(function(t,r){t(e.game.config)})}return m(this,"getConfig")},i.prototype.viewAs=function(e){if("node"==u)return Promise.reject(new Error("viewAs(): not supported in node.js"));if(!this.area&&!this.iframe)return Promise.reject(new Error("viewAs(): match is not attached to DOM element"));if(console.warn("Match.viewAs() is obsolete, use Match.setViewOptions() instead"),this.game){var t=this;return new Promise(function(r,n){t.game.GameDestroyView(),t.game.mViewAs=e,t.game.GameInitView(),t.game.DisplayBoard(),r()})}return m(this,"viewAs",arguments)},i.prototype.viewControl=function(e,t){if("node"==u)return Promise.reject(new Error("viewAs(): not supported in node.js"));if(!this.area&&!this.iframe)return Promise.reject(new Error("viewAs(): match is not attached to DOM element"));if(this.game){return this.game.ViewControl(e,t)}return m(this,"viewControl",arguments)},i.prototype.getPossibleMoves=function(){var e=this;if(this.game){var e=this;return new Promise(function(t,r){e.game.mBoard.mMoves&&0!=e.game.mBoard.mMoves.length||e.game.mBoard.GenerateMoves(e.game),t(e.game.mBoard.mMoves)})}return m(this,"getPossibleMoves",arguments)},i.prototype.getBoardState=function(e){var t=this;if(this.game){var t=this;return new Promise(function(r,n){r(t.game.mBoard.ExportBoardState(t.game,e))})}return m(this,"getBoardState",arguments)},i.prototype.getInitialBoardState=function(e){var t=this;if(this.game){var t=this;return new Promise(function(r,n){r(t.game.ExportInitialBoardState(e))})}return m(this,"getInitialBoardState",arguments)},i.prototype.resetView=function(e){if("node"==u)return Promise.reject(new Error("resetView(): not supported in node.js"));if(!this.area&&!this.iframe)return Promise.reject(new Error("resetView(): match is not attached to DOM element"));if(this.game){var t=this;return t.viewControl("stopAnimations").then(function(r){(r||e)&&t.game.DisplayBoard()})}return m(this,"resetView")},i.prototype.getAvailableSkins=function(){if("node"==u)return Promise.reject(new Error("resetView(): not supported in node.js"));if(this.game){var e=function(){try{return!!window.WebGLRenderingContext&&!!document.createElement("canvas").getContext("experimental-webgl")}catch(e){return!1}}();return Promise.resolve(this.game.mViewOptions.skins.filter(function(t){return e||!t["3d"]}))}return m(this,"getAvailableSkins")},exports._createInternalGame=t,exports.PLAYER_A=1,exports.PLAYER_B=-1,exports.DRAW=2}();

/***/ }),

/***/ "8zPk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("3j3K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_operator_filter__ = __webpack_require__("ack3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_operator_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs_operator_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_operator_map__ = __webpack_require__("xAJs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_operator_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs_operator_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__keycodes__ = __webpack_require__("90jt");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CommanderComponent; });




var CommanderComponent = (function () {
    function CommanderComponent() {
        var _this = this;
        this.keydown$ = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this._ignoreTags = ['INPUT', 'SELECT', 'TEXTAREA'];
        this.keydown$ = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        var filtered$ = __WEBPACK_IMPORTED_MODULE_1_rxjs_operator_filter__["filter"].call(this.keydown$, function (e) {
            if (_this._ignoreTags.indexOf(e.target.tagName) !== -1) {
                return false;
            }
            if (e.target.isContentEditable) {
                return false;
            }
            var command = _this.parseCommand(_this.shortcut);
            if (!command) {
                return false;
            }
            var charCode = e.keyCode || e.which;
            var char = String.fromCharCode(charCode);
            return command.name.toUpperCase() === char.toUpperCase() &&
                command.alt === e.altKey &&
                command.ctrl === e.ctrlKey &&
                command.meta === e.metaKey &&
                command.shift === e.shiftKey;
        });
        this.command = __WEBPACK_IMPORTED_MODULE_2_rxjs_operator_map__["map"].call(filtered$, function (e) {
            e.preventDefault();
            return { command: _this.shortcut };
        });
    }
    CommanderComponent.prototype.parseCommand = function (s) {
        var keyString = s.trim().toLowerCase();
        if (!/^(ctrl-|shift-|alt-|meta-){0,4}\w+$/.test(keyString)) {
            throw new Error('The string to parse needs to be of the format "c", "ctrl-c", "shift-ctrl-c".');
        }
        var parts = keyString.split('-');
        var key = {
            ctrl: false,
            meta: false,
            shift: false,
            alt: false
        };
        var c;
        key.name = parts.pop();
        while ((c = parts.pop())) {
            key[c] = true;
        }
        if (key.ctrl) {
            key.sequence = __WEBPACK_IMPORTED_MODULE_3__keycodes__["a" /* KEYCODES */].ctrl[key.name] || key.name;
        }
        else {
            key.sequence = __WEBPACK_IMPORTED_MODULE_3__keycodes__["a" /* KEYCODES */].nomod[key.name] || key.name;
        }
        if (key.shift && key.sequence && key.sequence.length === 1) {
            key.sequence = key.sequence.toUpperCase();
        }
        return key;
    };
    CommanderComponent.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{
                    selector: 'ngrx-commander',
                    template: '',
                    styles: [':host{ display: none }'],
                    host: {
                        '(document:keydown)': 'keydown$.emit($event)'
                    }
                },] },
    ];
    /** @nocollapse */
    CommanderComponent.ctorParameters = [];
    CommanderComponent.propDecorators = {
        'shortcut': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'command': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
    };
    return CommanderComponent;
}());
//# sourceMappingURL=commander.js.map

/***/ }),

/***/ "90jt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return KEYCODES; });
// Most of these are according to this table: http://www.ssicom.org/js/x171166.htm
// However where nodejs readline diverges, they are adjusted to conform to it
var KEYCODES = {
    nomod: {
        escape: '\u001b',
        space: ' ' // actually '\u0020'
    },
    ctrl: {
        ' ': '\u0000',
        'a': '\u0001',
        'b': '\u0002',
        'c': '\u0003',
        'd': '\u0004',
        'e': '\u0005',
        'f': '\u0006',
        'g': '\u0007',
        'h': '\u0008',
        'i': '\u0009',
        'j': '\u000a',
        'k': '\u000b',
        'm': '\u000c',
        'n': '\u000d',
        'l': '\u000e',
        'o': '\u000f',
        'p': '\u0010',
        'q': '\u0011',
        'r': '\u0012',
        's': '\u0013',
        't': '\u0014',
        'u': '\u0015',
        'v': '\u0016',
        'w': '\u0017',
        'x': '\u0018',
        'y': '\u0019',
        'z': '\u001a',
        '[': '\u001b',
        '\\': '\u001c',
        ']': '\u001d',
        '^': '\u001e',
        '_': '\u001f',
        'space': '\u0000'
    }
};
//# sourceMappingURL=keycodes.js.map

/***/ }),

/***/ "94IA":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var delay_1 = __webpack_require__("aec7");
Observable_1.Observable.prototype.delay = delay_1.delay;
//# sourceMappingURL=delay.js.map

/***/ }),

/***/ "9Avi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Scheduler_1 = __webpack_require__("cPwE");
var AsyncScheduler = (function (_super) {
    __extends(AsyncScheduler, _super);
    function AsyncScheduler() {
        _super.apply(this, arguments);
        this.actions = [];
        /**
         * A flag to indicate whether the Scheduler is currently executing a batch of
         * queued actions.
         * @type {boolean}
         */
        this.active = false;
        /**
         * An internal ID used to track the latest asynchronous task such as those
         * coming from `setTimeout`, `setInterval`, `requestAnimationFrame`, and
         * others.
         * @type {any}
         */
        this.scheduled = undefined;
    }
    AsyncScheduler.prototype.flush = function (action) {
        var actions = this.actions;
        if (this.active) {
            actions.push(action);
            return;
        }
        var error;
        this.active = true;
        do {
            if (error = action.execute(action.state, action.delay)) {
                break;
            }
        } while (action = actions.shift()); // exhaust the scheduler queue
        this.active = false;
        if (error) {
            while (action = actions.shift()) {
                action.unsubscribe();
            }
            throw error;
        }
    };
    return AsyncScheduler;
}(Scheduler_1.Scheduler));
exports.AsyncScheduler = AsyncScheduler;
//# sourceMappingURL=AsyncScheduler.js.map

/***/ }),

/***/ "9H9i":
/***/ (function(module, exports) {

exports.config = {"status":true,"model":{"plazza":"true","released":1396882578,"title-en":"Glinski Chess","module":"chessbase","summary":"Hexagonal Chess","thumbnail":"glinski-thumb.png","rules":{"en":"glinski-rules.html"},"credits":{"en":"glinski-credits.html"},"gameOptions":{"preventRepeat":true,"uctTransposition":"state","uctIgnoreLoop":false,"levelOptions":{"pieceValueFactor":1,"pieceValueRatioFactor":1,"posValueFactor":0.1,"averageDistKingFactor":-0.01,"castleFactor":0.1,"minorPiecesMovedFactor":0.1,"checkFactor":0.2,"endingKingFreedomFactor":0.01,"endingDistKingFactor":0.05,"distKingCornerFactor":0.1,"distPawnPromo1Factor":0.3,"distPawnPromo2Factor":0.1,"distPawnPromo3Factor":0.05}},"obsolete":false,"js":["base-model.js","hex-geo-model.js","glinski-model.js"],"description":{"en":"glinski-description.html"},"levels":[{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"easy","label":"Easy","maxNodes":6000},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"fast","label":"Fast [3sec]","maxDuration":3,"isDefault":true},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"medium","label":"Medium","maxNodes":30000,"maxDuration":30},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"strong","label":"Strong","maxNodes":60000,"maxDuration":45}]},"view":{"title-en":"Chessbase view","module":"chessbase","xdView":true,"css":["chessbase.css","hex.css"],"preferredRatio":0.89,"useShowMoves":true,"useNotation":true,"useAutoComplete":true,"defaultOptions":{"sounds":true,"moves":true,"notation":false,"autocomplete":false},"skins":[{"name":"skin3d","title":"3D Classic","3d":true,"preload":["smoothedfilegeo|0|/res/ring-target-hexagon.js","image|/res/images/cancel.png","image|/res/images/wikipedia.png","smoothedfilegeo|0|/res/staunton/pawn/pawn-classic.js","image|/res/staunton/pawn/pawn-diffusemap.jpg","image|/res/staunton/pawn/pawn-normalmap.jpg","smoothedfilegeo|0|/res/staunton/knight/knight.js","image|/res/staunton/knight/knight-diffusemap.jpg","image|/res/staunton/knight/knight-normalmap.jpg","smoothedfilegeo|0|/res/staunton/bishop/bishop.js","image|/res/staunton/bishop/bishop-diffusemap.jpg","image|/res/staunton/bishop/bishop-normalmap.jpg","smoothedfilegeo|0|/res/staunton/rook/rook.js","image|/res/staunton/rook/rook-diffusemap.jpg","image|/res/staunton/rook/rook-normalmap.jpg","smoothedfilegeo|0|/res/staunton/queen/queen.js","image|/res/staunton/queen/queen-diffusemap.jpg","image|/res/staunton/queen/queen-normalmap.jpg","smoothedfilegeo|0|/res/staunton/king/king.js","image|/res/staunton/king/king-diffusemap.jpg","image|/res/staunton/king/king-normalmap.jpg"],"world":{"lightIntensity":1.3,"skyLightIntensity":1.2,"lightCastShadow":true,"fog":false,"color":4686804,"lightPosition":{"x":-9,"y":9,"z":9},"skyLightPosition":{"x":9,"y":9,"z":9},"lightShadowDarkness":0.55,"ambientLightColor":2236962},"camera":{"fov":45,"distMax":50,"radius":13.5,"elevationAngle":45,"elevationMin":0,"distMin":0}},{"name":"skin2d","title":"2D Classic","3d":false,"preload":["image|/res/images/wikipedia.png","image|/res/images/whitebg.png","image|/res/images/cancel.png"]}],"animateSelfMoves":false,"switchable":true,"sounds":{"move1":"alq_move1","move2":"alq_move2","move3":"alq_move3","move4":"alq_move2","tac1":"alq_tac1","tac2":"alq_tac2","tac3":"alq_tac1","promo":"promo","usermove":null},"js":["base-view.js","hex-board-view.js","staunton-set-view.js","glinski-view.js"],"visuals":{"600x600":["res/visuals/glinski-600x600-3d.jpg","res/visuals/glinski-600x600-2d.jpg"]}}}

/***/ }),

/***/ "9JPB":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var root_1 = __webpack_require__("VOfZ");
var MapPolyfill_1 = __webpack_require__("2ER/");
exports.Map = root_1.root.Map || (function () { return MapPolyfill_1.MapPolyfill; })();
//# sourceMappingURL=Map.js.map

/***/ }),

/***/ "9PGs":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__("mmVS");
/**
 * @return {Observable<any[]>|WebSocketSubject<T>|Observable<T>}
 * @method toArray
 * @owner Observable
 */
function toArray() {
    return this.lift(new ToArrayOperator());
}
exports.toArray = toArray;
var ToArrayOperator = (function () {
    function ToArrayOperator() {
    }
    ToArrayOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new ToArraySubscriber(subscriber));
    };
    return ToArrayOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var ToArraySubscriber = (function (_super) {
    __extends(ToArraySubscriber, _super);
    function ToArraySubscriber(destination) {
        _super.call(this, destination);
        this.array = [];
    }
    ToArraySubscriber.prototype._next = function (x) {
        this.array.push(x);
    };
    ToArraySubscriber.prototype._complete = function () {
        this.destination.next(this.array);
        this.destination.complete();
    };
    return ToArraySubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=toArray.js.map

/***/ }),

/***/ "9TuE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__("mmVS");
/**
 * If the source Observable is empty it returns an Observable that emits true, otherwise it emits false.
 *
 * <img src="./img/isEmpty.png" width="100%">
 *
 * @return {Observable} An Observable that emits a Boolean.
 * @method isEmpty
 * @owner Observable
 */
function isEmpty() {
    return this.lift(new IsEmptyOperator());
}
exports.isEmpty = isEmpty;
var IsEmptyOperator = (function () {
    function IsEmptyOperator() {
    }
    IsEmptyOperator.prototype.call = function (observer, source) {
        return source.subscribe(new IsEmptySubscriber(observer));
    };
    return IsEmptyOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var IsEmptySubscriber = (function (_super) {
    __extends(IsEmptySubscriber, _super);
    function IsEmptySubscriber(destination) {
        _super.call(this, destination);
    }
    IsEmptySubscriber.prototype.notifyComplete = function (isEmpty) {
        var destination = this.destination;
        destination.next(isEmpty);
        destination.complete();
    };
    IsEmptySubscriber.prototype._next = function (value) {
        this.notifyComplete(false);
    };
    IsEmptySubscriber.prototype._complete = function () {
        this.notifyComplete(true);
    };
    return IsEmptySubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=isEmpty.js.map

/***/ }),

/***/ "9WjZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var never_1 = __webpack_require__("+vPe");
Observable_1.Observable.never = never_1.never;
//# sourceMappingURL=never.js.map

/***/ }),

/***/ "9oY/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var FromEventPatternObservable_1 = __webpack_require__("L2Hk");
exports.fromEventPattern = FromEventPatternObservable_1.FromEventPatternObservable.create;
//# sourceMappingURL=fromEventPattern.js.map

/***/ }),

/***/ "9oiU":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__("mmVS");
/**
 * Emits the given constant value on the output Observable every time the source
 * Observable emits a value.
 *
 * <span class="informal">Like {@link map}, but it maps every source value to
 * the same output value every time.</span>
 *
 * <img src="./img/mapTo.png" width="100%">
 *
 * Takes a constant `value` as argument, and emits that whenever the source
 * Observable emits a value. In other words, ignores the actual source value,
 * and simply uses the emission moment to know when to emit the given `value`.
 *
 * @example <caption>Map every every click to the string 'Hi'</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var greetings = clicks.mapTo('Hi');
 * greetings.subscribe(x => console.log(x));
 *
 * @see {@link map}
 *
 * @param {any} value The value to map each source value to.
 * @return {Observable} An Observable that emits the given `value` every time
 * the source Observable emits something.
 * @method mapTo
 * @owner Observable
 */
function mapTo(value) {
    return this.lift(new MapToOperator(value));
}
exports.mapTo = mapTo;
var MapToOperator = (function () {
    function MapToOperator(value) {
        this.value = value;
    }
    MapToOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new MapToSubscriber(subscriber, this.value));
    };
    return MapToOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var MapToSubscriber = (function (_super) {
    __extends(MapToSubscriber, _super);
    function MapToSubscriber(destination, value) {
        _super.call(this, destination);
        this.value = value;
    }
    MapToSubscriber.prototype._next = function (x) {
        this.destination.next(this.value);
    };
    return MapToSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=mapTo.js.map

/***/ }),

/***/ "9qUs":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var skip_1 = __webpack_require__("M5jZ");
Observable_1.Observable.prototype.skip = skip_1.skip;
//# sourceMappingURL=skip.js.map

/***/ }),

/***/ "9r1b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("3j3K");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StoreLogMonitorComponent; });

var StoreLogMonitorComponent = (function () {
    function StoreLogMonitorComponent() {
        this.toggleCommand = 'ctrl-h';
        this.positionCommand = 'ctrl-m';
        this.expandEntries = false;
    }
    StoreLogMonitorComponent.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{
                    selector: 'ngrx-store-log-monitor',
                    template: "\n    <dock-monitor [toggleCommand]=\"toggleCommand\" [positionCommand]=\"positionCommand\">\n      <log-monitor [expandEntries]=\"expandEntries\"></log-monitor>\n    </dock-monitor>\n  "
                },] },
    ];
    /** @nocollapse */
    StoreLogMonitorComponent.ctorParameters = [];
    StoreLogMonitorComponent.propDecorators = {
        'toggleCommand': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'positionCommand': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'expandEntries': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    };
    return StoreLogMonitorComponent;
}());
//# sourceMappingURL=store-log-monitor.js.map

/***/ }),

/***/ "A5bz":
/***/ (function(module, exports) {

exports.config = {"status":true,"model":{"plazza":"true","released":1401461778,"title-en":"Byzantine Chess","module":"chessbase","summary":"10th century circular Chess","thumbnail":"byzantine-thumb.png","rules":{"en":"byzantine-rules.html"},"credits":{"en":"byzantine-credits.html"},"gameOptions":{"preventRepeat":true,"uctTransposition":"state","uctIgnoreLoop":false,"levelOptions":{"pieceValueFactor":1,"pieceValueRatioFactor":1,"posValueFactor":0.1,"averageDistKingFactor":-0.01,"castleFactor":0.1,"minorPiecesMovedFactor":0.1,"checkFactor":0.2,"endingKingFreedomFactor":0.01,"endingDistKingFactor":0.05,"distKingCornerFactor":0.1,"distPawnPromo1Factor":0.15,"distPawnPromo2Factor":0.05,"distPawnPromo3Factor":0.025}},"obsolete":false,"js":["base-model.js","cylinder-geo-model.js","byzantine-model.js"],"description":{"en":"byzantine-description.html"},"levels":[{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"easy","label":"Easy","maxNodes":1000},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"fast","label":"Fast [1sec]","maxDuration":1,"isDefault":true},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"medium","label":"Medium","maxNodes":10000,"maxDuration":10},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"strong","label":"Strong","maxNodes":20000,"maxDuration":15}]},"view":{"title-en":"Chessbase view","module":"chessbase","xdView":true,"css":["chessbase.css","circular.css"],"preferredRatio":1,"useShowMoves":true,"useNotation":true,"useAutoComplete":true,"defaultOptions":{"sounds":true,"moves":true,"notation":false,"autocomplete":false},"skins":[{"name":"skin3d","title":"3D Classic","3d":true,"preload":["smoothedfilegeo|0|/res/ring-target.js","image|/res/images/cancel.png","smoothedfilegeo|0|/res/nishapur/pawn/pawn.js","image|/res/nishapur/pawn/pawn-diffusemap.jpg","image|/res/nishapur/pawn/pawn-normalmap.jpg","smoothedfilegeo|0|/res/nishapur/knight/knight.js","image|/res/nishapur/knight/knight-diffusemap.jpg","image|/res/nishapur/knight/knight-normalmap.jpg","smoothedfilegeo|0|/res/nishapur/elephant/elephant.js","image|/res/nishapur/elephant/elephant-diffusemap.jpg","image|/res/nishapur/elephant/elephant-normalmap.jpg","smoothedfilegeo|0|/res/nishapur/rook/rook.js","image|/res/nishapur/rook/rook-diffusemap.jpg","image|/res/nishapur/rook/rook-normalmap.jpg","smoothedfilegeo|0|/res/nishapur/general/general.js","image|/res/nishapur/general/general-diffusemap.jpg","image|/res/nishapur/general/general-normalmap.jpg","smoothedfilegeo|0|/res/nishapur/king/king.js","image|/res/nishapur/king/king-diffusemap.jpg","image|/res/nishapur/king/king-normalmap.jpg","image|/res/images/wikipedia.png","image|/res/byzantine/byzantine-board.jpg"],"world":{"lightIntensity":0.8,"skyLightIntensity":0.4,"lightCastShadow":false,"fog":false,"color":4686804,"lightPosition":{"x":-10,"y":5,"z":0},"skyLightPosition":{"x":9,"y":9,"z":9},"lightShadowDarkness":0.85,"ambientLightColor":1118481},"camera":{"fov":45,"distMax":50,"radius":14.5,"elevationAngle":45,"elevationMin":0,"distMin":0}},{"name":"skin2d","title":"2D Classic","3d":false,"preload":["image|/res/images/wikipedia.png","image|/res/byzantine/byzantine-board.jpg","image|/res/nishapur/nishapur-2d-sprites.png"]}],"animateSelfMoves":false,"switchable":true,"sounds":{"move1":"alq_move1","move2":"alq_move2","move3":"alq_move3","move4":"alq_move2","tac1":"alq_tac1","tac2":"alq_tac2","tac3":"alq_tac1","promo":"promo","usermove":null},"js":["base-view.js","circular-board-view.js","nishapur-set-view.js","byzantine-view.js"],"visuals":{"600x600":["res/visuals/byzantine-600x600-3d.jpg","res/visuals/byzantine-600x600-2d.jpg"]}}}

/***/ }),

/***/ "A5xa":
/***/ (function(module, exports) {

exports.model=Model={Game:{},Board:{},Move:{}},function(){var t,s,o="undefined"!=typeof Int8Array;o?(t=function(t){return new Int8Array(t)},s=function(t){var s=new Int8Array(t.length);return s.set(t),s}):(t=function(t){for(var s=[],o=0;o<t;o++)s.push(0);return s},s=function(t){for(var s=[],o=t.length,i=0;i<o;i++)s.push(t[i]);return s}),Model.Game.isAlive=function(t,s){return this.POS(s,t)in this.g.confine},Model.Game.C=function(t){return t%this.mOptions.width},Model.Game.R=function(t){return Math.floor(t/this.mOptions.width)},Model.Game.RC=function(t){return{r:Math.floor(t/this.mOptions.width),c:t%this.mOptions.width}},Model.Game.POS=function(t,s){return s*this.mOptions.width+t},Model.Game.STR2POS=function(t){var s=/^(\d+):(\d+)$/.exec(t);if(s){var o=parseInt(s[1]),i=parseInt(s[2]);return this.POS(i,o)}return null},Model.Game.InitGame=function(){var s=this.NBCOLS=this.mOptions.width,o=this.NBROWS=this.mOptions.height;this.g.confine={},this.g.totalCount=o*s;for(var i=0;i<o;i++)for(var r=0;r<s;r++)this.g.confine[this.POS(r,i)]=1;if(this.mOptions.deadCells)for(var e in this.mOptions.deadCells){var a=this.STR2POS(e);null!=a&&(this.g.totalCount--,delete this.g.confine[a])}this.g.dirDeltaRC=[[1,-1],[1,0],[1,1],[0,1],[-1,1],[-1,0],[-1,-1],[0,-1]],this.g.Graph={};for(var i=0;i<o;i++)for(var r=0;r<s;r++){var a=this.POS(r,i);if(a in this.g.confine){for(var h=t(this.g.dirDeltaRC.length),n=0;n<this.g.dirDeltaRC.length;n++){var l=this.g.dirDeltaRC[n],v=i+l[0],d=r+l[1],u=v*s+d;v>=0&&d>=0&&v<o&&d<s&&u in this.g.confine?h[n]=u:h[n]=-1}this.g.Graph[a]=h}}this.g.corners={};for(var a in this.g.confine){for(var f=0,l=0;l<8;l++){var u=this.g.Graph[a][l];u<0&&(f|=1<<l)}15!=(15&f)&&30!=(30&f)&&60!=(60&f)&&120!=(120&f)&&240!=(240&f)&&225!=(225&f)&&195!=(195&f)&&135!=(135&f)||(this.g.corners[a]=1)}this.g.borders={};for(var a in this.g.confine)if(!(a in this.g.corners)){for(var f=0,l=0;l<8;l++){var u=this.g.Graph[a][l];u<0&&(f|=1<<l)}7!=(7&f)&&14!=(14&f)&&28!=(28&f)&&56!=(56&f)&&112!=(112&f)&&224!=(224&f)&&193!=(193&f)&&131!=(131&f)||(this.g.borders[a]=1)}this.zobrist=new JocGame.Zobrist({board:{type:"array",size:s*o,values:["1","-1"]}})},Model.Move.Init=function(t){this.row=t.row,this.col=t.col,this.pass=t.pass},Model.Move.CopyFrom=function(t){this.row=t.row,this.col=t.col,this.pass=t.pass},Model.Move.ToString=function(){return this.pass?"-":String.fromCharCode("a".charCodeAt(0)+this.col)+(this.row+1)},Model.Move.Equals=function(t){return!(!t.pass||!this.pass)||this.row==t.row&&this.col==t.col},Model.Board.Init=function(t){this.zSign=0},Model.Board.InitialPosition=function(s){this.board=t(s.mOptions.width*s.mOptions.height),this.counts=[0,0],this.freeClose={},this.passes=0,this.lastMove=null;var o=this;[1,-1].forEach(function(t){var i=(1-t)/2;s.mOptions.initial[t].forEach(function(r){o.counts[i]++;var e=s.STR2POS(r);o.board[e]=t,delete o.freeClose[e];for(var a=0;a<8;a++){var h=s.g.Graph[e][a];h<0||(o.board[h]||(o.freeClose[h]=1))}o.zSign=s.zobrist.update(o.zSign,"board",t,e)})}),this.FindMoves(s),this.stable={};for(var i in s.g.corners)this.stable[i]=3;this.aboutStable={},this.aboutBorder={},this.rvUpdateStable(s,s.g.corners),this.rvUpdateAboutBorder(s)},Model.Board.CopyFrom=function(t){this.mWho=t.mWho,this.zSign=t.zSign,this.board=s(t.board),this.counts=[t.counts[0],t.counts[1]],this.freeClose={};for(var o in t.freeClose)this.freeClose[o]=1;this.passes=t.passes,this.lastMove=null,t.lastMove?this.lastMove={row:t.lastMove.row,col:t.lastMove.col}:this.lastMove=null,this.movePoss={1:s(t.movePoss[1]),"-1":s(t.movePoss[-1])},this.stable=t.stable,this.aboutStable=t.aboutStable,this.aboutBorder=t.aboutBorder},Model.Board.GenerateMoves=function(t){this.mMoves=[];for(var s=0;s<this.movePoss[this.mWho].length;s++){var o=this.movePoss[this.mWho][s],i=t.RC(o);this.PushMove(t,{row:i.r,col:i.c})}0==this.mMoves.length&&this.PushMove(t,{pass:!0,row:-1,col:-1})},Model.Board.FindMoves=function(t){this.movePoss={1:[],"-1":[]};var s=t.g.Graph;for(var o in this.freeClose){for(var i=s[o],r=0,e=0;e<8;e++){var a=i[e];if(a>=0){var h=-this.board[a];if(h){var n=1==h?1:2;if(!(r&n)){for(!0,a=s[a][e];this.board[a]==-h;)a=s[a][e];if(a>=0&&this.board[a]==h&&(r|=n),3==r)break}}}}1&r&&this.movePoss[1].push(o),2&r&&this.movePoss[-1].push(o)}},Model.Board.ApplyMove=function(t,s){if(this.lastMove=null,s.pass)return void this.passes++;this.lastMove={row:s.row,col:s.col},this.passes=0;var o=(1-this.mWho)/2,i=1<<o;this.counts[o]++;var r=t.POS(s.col,s.row),e=t.g.Graph,a=e[r];this.board[r]=this.mWho,this.zSign=t.zobrist.update(this.zSign,"board",this.mWho,r),delete this.freeClose[r];var h=!1,n={};(this.stable[r]||0)&i&&(h=!0,n[r]=1);for(var l=0;l<8;l++){var v=a[l];v>=0&&0==this.board[v]&&(this.freeClose[v]=1);for(var d=[];v>=0&&this.board[v]==-this.mWho;)d.push(v),v=e[v][l];if(v>=0&&d.length>0&&this.board[v]==this.mWho)for(var u=d.length-1;u>=0;u--){var f=d[u];this.zSign=t.zobrist.update(this.zSign,"board",-this.mWho,f),this.zSign=t.zobrist.update(this.zSign,"board",this.mWho,f),this.board[f]=this.mWho,this.counts[o]++,this.counts[1-o]--,(this.stable[f]||0)&i&&(h=!0,n[f]=1)}}h&&this.rvUpdateStable(t,n),r in t.g.borders&&this.rvUpdateAboutBorder(t),this.FindMoves(t)},Model.Board.rvUpdateStable=function(t,s){var o=this.stable;this.stable={};for(var i in o)this.stable[i]=o[i];for(var r=!0,e=1==this.mWho?1:2,a=t.g.Graph;r;){r=!1;var h={};for(var i in s)for(var n=a[i],l=0;l<8;l++){var v=n[l];v>=0&&!((this.stable[v]||0)&e)&&(h[v]=1)}var s={};for(var i in h){for(var n=a[i],d=0,l=0;l<8;l++){var v=n[l];(v<0||this.board[v]==this.mWho&&(this.stable[v]||0)&e)&&(d|=1<<l)}15!=(15&d)&&30!=(30&d)&&60!=(60&d)&&120!=(120&d)&&240!=(240&d)&&225!=(225&d)&&195!=(195&d)&&135!=(135&d)||(this.stable[i]=(this.stable[i]||0)|e,r=!0,s[i]=1)}}this.aboutStable={};for(var i in this.stable)if(!this.board[i])for(var n=a[i],l=0;l<8;l++){var v=n[l];v>=0&&!(v in this.stable)&&(this.aboutStable[v]=(this.aboutStable[v]||0)|this.stable[i])}},Model.Board.rvUpdateAboutBorder=function(t){this.aboutBorder={};var s=t.g.Graph,o=t.g.borders;for(var i in o)if(!this.board[i])for(var r=s[i],e=0;e<8;e++){var a=r[e];!(a>=0)||a in this.stable||a in this.aboutStable||a in o||(this.aboutBorder[a]=1)}},Model.Board.Evaluate=function(t){this.mEvaluation=0;t.mOptions.width,t.mOptions.height;if(2==this.passes||this.counts[0]+this.counts[1]==t.g.totalCount||0==this.counts[0]||0==this.counts[1])return this.mFinished=!0,void(this.counts[0]>this.counts[1]?this.mWinner=JocGame.PLAYER_A:this.counts[0]<this.counts[1]?this.mWinner=JocGame.PLAYER_B:this.mWinner=JocGame.DRAW);var s=t.mOptions.levelOptions,o={},i={1:0,"-1":0},r={1:0,"-1":0},e={1:0,"-1":0},a={1:0,"-1":0},h=t.g.confine,n=t.g.borders;for(var l in h){var v=this.board[l];if(v){var d=1==v?1:2,u=1==v?2:1;(this.stable[l]||0)&d?i[v]++:(this.aboutStable[l]||0)&u?l in n?e[v]++:r[v]++:l in n&&a[v]++}}o.stable=i[1]-i[-1],o.aboutStable=r[1]-r[-1],o.aboutStableBorder=e[1]-e[-1],o.border=a[1]-a[-1],o.count=this.counts[0]-this.counts[1];var f=this.movePoss[1].length+this.movePoss[-1].length;o.mobility=f?(this.movePoss[1].length-this.movePoss[-1].length)/f:0;for(var b in o){var c=o[b],m=s[b+"Factor"]||0,g=c*m;this.mEvaluation+=g}},Model.Board.GetSignature=function(){return this.zSign}}();

/***/ }),

/***/ "A7JX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var ArrayObservable_1 = __webpack_require__("Yh8Q");
var isArray_1 = __webpack_require__("Xajo");
var OuterSubscriber_1 = __webpack_require__("wAkD");
var subscribeToResult_1 = __webpack_require__("CURp");
var none = {};
/* tslint:enable:max-line-length */
/**
 * Combines multiple Observables to create an Observable whose values are
 * calculated from the latest values of each of its input Observables.
 *
 * <span class="informal">Whenever any input Observable emits a value, it
 * computes a formula using the latest values from all the inputs, then emits
 * the output of that formula.</span>
 *
 * <img src="./img/combineLatest.png" width="100%">
 *
 * `combineLatest` combines the values from this Observable with values from
 * Observables passed as arguments. This is done by subscribing to each
 * Observable, in order, and collecting an array of each of the most recent
 * values any time any of the input Observables emits, then either taking that
 * array and passing it as arguments to an optional `project` function and
 * emitting the return value of that, or just emitting the array of recent
 * values directly if there is no `project` function.
 *
 * @example <caption>Dynamically calculate the Body-Mass Index from an Observable of weight and one for height</caption>
 * var weight = Rx.Observable.of(70, 72, 76, 79, 75);
 * var height = Rx.Observable.of(1.76, 1.77, 1.78);
 * var bmi = weight.combineLatest(height, (w, h) => w / (h * h));
 * bmi.subscribe(x => console.log('BMI is ' + x));
 *
 * // With output to console:
 * // BMI is 24.212293388429753
 * // BMI is 23.93948099205209
 * // BMI is 23.671253629592222
 *
 * @see {@link combineAll}
 * @see {@link merge}
 * @see {@link withLatestFrom}
 *
 * @param {ObservableInput} other An input Observable to combine with the source
 * Observable. More than one input Observables may be given as argument.
 * @param {function} [project] An optional function to project the values from
 * the combined latest values into a new value on the output Observable.
 * @return {Observable} An Observable of projected values from the most recent
 * values from each input Observable, or an array of the most recent values from
 * each input Observable.
 * @method combineLatest
 * @owner Observable
 */
function combineLatest() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i - 0] = arguments[_i];
    }
    var project = null;
    if (typeof observables[observables.length - 1] === 'function') {
        project = observables.pop();
    }
    // if the first and only other argument besides the resultSelector is an array
    // assume it's been called with `combineLatest([obs1, obs2, obs3], project)`
    if (observables.length === 1 && isArray_1.isArray(observables[0])) {
        observables = observables[0].slice();
    }
    observables.unshift(this);
    return this.lift.call(new ArrayObservable_1.ArrayObservable(observables), new CombineLatestOperator(project));
}
exports.combineLatest = combineLatest;
var CombineLatestOperator = (function () {
    function CombineLatestOperator(project) {
        this.project = project;
    }
    CombineLatestOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new CombineLatestSubscriber(subscriber, this.project));
    };
    return CombineLatestOperator;
}());
exports.CombineLatestOperator = CombineLatestOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var CombineLatestSubscriber = (function (_super) {
    __extends(CombineLatestSubscriber, _super);
    function CombineLatestSubscriber(destination, project) {
        _super.call(this, destination);
        this.project = project;
        this.active = 0;
        this.values = [];
        this.observables = [];
    }
    CombineLatestSubscriber.prototype._next = function (observable) {
        this.values.push(none);
        this.observables.push(observable);
    };
    CombineLatestSubscriber.prototype._complete = function () {
        var observables = this.observables;
        var len = observables.length;
        if (len === 0) {
            this.destination.complete();
        }
        else {
            this.active = len;
            this.toRespond = len;
            for (var i = 0; i < len; i++) {
                var observable = observables[i];
                this.add(subscribeToResult_1.subscribeToResult(this, observable, observable, i));
            }
        }
    };
    CombineLatestSubscriber.prototype.notifyComplete = function (unused) {
        if ((this.active -= 1) === 0) {
            this.destination.complete();
        }
    };
    CombineLatestSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        var values = this.values;
        var oldVal = values[outerIndex];
        var toRespond = !this.toRespond
            ? 0
            : oldVal === none ? --this.toRespond : this.toRespond;
        values[outerIndex] = innerValue;
        if (toRespond === 0) {
            if (this.project) {
                this._tryProject(values);
            }
            else {
                this.destination.next(values.slice());
            }
        }
    };
    CombineLatestSubscriber.prototype._tryProject = function (values) {
        var result;
        try {
            result = this.project.apply(this, values);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return CombineLatestSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
exports.CombineLatestSubscriber = CombineLatestSubscriber;
//# sourceMappingURL=combineLatest.js.map

/***/ }),

/***/ "ADTN":
/***/ (function(module, exports) {

exports.config = {"status":true,"model":{"plazza":"true","released":1405068611,"title-en":"Kaiserspiel","module":"chessbase","summary":"Tressau, 1840","thumbnail":"kaisergame-thumb.png","rules":{"en":"kaisergame-rules.html"},"credits":{"en":"kaisergame-credits.html"},"gameOptions":{"preventRepeat":true,"uctTransposition":"state","uctIgnoreLoop":false,"levelOptions":{"pieceValueFactor":1,"pieceValueRatioFactor":1,"posValueFactor":0.1,"averageDistKingFactor":-0.01,"castleFactor":0.1,"minorPiecesMovedFactor":0.1,"checkFactor":0.2,"endingKingFreedomFactor":0.01,"endingDistKingFactor":0.05,"distKingCornerFactor":0.1,"distPawnPromo1Factor":0.3,"distPawnPromo2Factor":0.1,"distPawnPromo3Factor":0.05}},"obsolete":false,"js":["base-model.js","grid-geo-model.js","kaisergame-model.js"],"description":{"en":"kaisergame-description.html"},"levels":[{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"easy","label":"Easy","maxNodes":1000},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"fast","label":"Fast [1sec]","maxDuration":1,"isDefault":true},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"medium","label":"Medium","maxNodes":10000,"maxDuration":10},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"strong","label":"Strong","maxNodes":20000,"maxDuration":15}]},"view":{"title-en":"Chessbase view","module":"chessbase","xdView":true,"css":["chessbase.css"],"preferredRatio":1,"useShowMoves":true,"useNotation":true,"useAutoComplete":true,"defaultOptions":{"sounds":true,"moves":true,"notation":false,"autocomplete":false},"skins":[{"name":"skin3d","title":"3D Classic","3d":true,"preload":["smoothedfilegeo|0|/res/ring-target.js","image|/res/images/cancel.png","image|/res/images/wikipedia.png","smoothedfilegeo|0|/res/fairy/pawn/pawn.js","image|/res/fairy/pawn/pawn-diffusemap.jpg","image|/res/fairy/pawn/pawn-normalmap.jpg","smoothedfilegeo|0|/res/fairy/knight/knight.js","image|/res/fairy/knight/knight-diffusemap.jpg","image|/res/fairy/knight/knight-normalmap.jpg","smoothedfilegeo|0|/res/fairy/bishop/bishop.js","image|/res/fairy/bishop/bishop-diffusemap.jpg","image|/res/fairy/bishop/bishop-normalmap.jpg","smoothedfilegeo|0|/res/fairy/king/king.js","image|/res/fairy/king/king-diffusemap.jpg","image|/res/fairy/king/king-normalmap.jpg","smoothedfilegeo|0|/res/fairy/rook/rook.js","image|/res/fairy/rook/rook-diffusemap.jpg","image|/res/fairy/rook/rook-normalmap.jpg","smoothedfilegeo|0|/res/fairy/queen/queen.js","image|/res/fairy/queen/queen-diffusemap.jpg","image|/res/fairy/queen/queen-normalmap.jpg","smoothedfilegeo|0|/res/fairy/cardinal/cardinal.js","image|/res/fairy/cardinal/cardinal-diffusemap.jpg","image|/res/fairy/cardinal/cardinal-normalmap.jpg","smoothedfilegeo|0|/res/fairy/amazon/amazon.js","image|/res/fairy/amazon/amazon-diffusemap.jpg","image|/res/fairy/amazon/amazon-normalmap.jpg"],"world":{"lightIntensity":1.3,"skyLightIntensity":1.2,"lightCastShadow":true,"fog":false,"color":4686804,"lightPosition":{"x":-9,"y":9,"z":9},"skyLightPosition":{"x":9,"y":9,"z":9},"lightShadowDarkness":0.55,"ambientLightColor":2236962},"camera":{"fov":45,"distMax":50,"radius":18,"elevationAngle":60,"elevationMin":0}},{"name":"skin2d","title":"2D Classic","3d":false,"preload":["image|/res/images/cancel.png","image|/res/images/whitebg.png","image|/res/fairy/wikipedia-fairy-sprites.png"]}],"animateSelfMoves":false,"switchable":true,"sounds":{"move1":"alq_move1","move2":"alq_move2","move3":"alq_move3","move4":"alq_move2","tac1":"alq_tac1","tac2":"alq_tac2","tac3":"alq_tac1","promo":"promo","usermove":null},"js":["base-view.js","grid-board-view.js","fairy-set-view.js","grand-view.js"],"visuals":{"600x600":["res/visuals/kaisergame-600x600-3d.jpg","res/visuals/kaisergame-600x600-2d.jpg"]}}}

/***/ }),

/***/ "AGQa":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var empty_1 = __webpack_require__("vvwv");
Observable_1.Observable.empty = empty_1.empty;
//# sourceMappingURL=empty.js.map

/***/ }),

/***/ "AHvx":
/***/ (function(module, exports, __webpack_require__) {

var
    symbols = __webpack_require__("bgfr"),
    PathFinder = __webpack_require__("FjqB"),
    Move = __webpack_require__("Gjzh"),
    Piece = symbols.Piece
;

function Arbiter() {
}

Arbiter.pf = new PathFinder();

/** Crée le mouvement demandé. */
Arbiter.getMove = function(board, startingSqNum, endingSqNum, middleSquaresNum, previousColorPlayed) {
    var conf = board.conf;

    // Toutes les combinaisons de rafles
    var listRafleMovements = Arbiter.pf.getRafleMovements(board, startingSqNum);
    var existsRafle = listRafleMovements.length > 0;

    var listMovements = [];

    // Ne conserver que la/les rafles majoritaires
    if (existsRafle) {
        // console.log("CAS : RAFLE");
        listMovements = this._filterMajority(listRafleMovements);
    }
    // Aucune prise possible => on regarde les déplacements simples
    else {
        // console.log("CAS : DEPLACEMENT SIMPLE");
        listMovements = Arbiter.pf.getSimpleMovements(board, startingSqNum);
    }

    // Ne conserver que le/les mouvements qui arrivent sur la case indiquée.
    var listOK = this._filterEnding(listMovements, endingSqNum);

    // Ne conserver que le/les mouvements qui passent par les cases
    // indiquées.
    if (middleSquaresNum != null && middleSquaresNum.length > 0) {
        listOK = this._filterInter(listOK, middleSquaresNum);
    }

    // Si plusieurs mouvements sont valides, on prendra le premier.
    var move = null;
    if (listOK.length > 0) {
        move = listOK[0];

        // Enregistrer les mouvements intermédiaires précisées
        if (middleSquaresNum != null) {
            move.middleSquaresNum = middleSquaresNum;
        }

        if (listOK.length > 1) {
            console.log("Il existe des variantes pour le coup " + startingSqNum + "/" + endingSqNum);
        }
    }

    // Le mouvement demandé est irrégulier.
    if (move == null) {
        move = new Move(startingSqNum, endingSqNum);
        move.status = false;
        move.message = "Mouvement irrégulier..."; // A préciser
    }

    // Préciser s'il s'agit d'une rafle (pour la notation)
    move.isCaptured = existsRafle;

    // Préciser si la piece a été promu en dame.
    var piece = board.getPiece(startingSqNum);
    var isCrowned = (piece == Piece.PAWN_WHITE && endingSqNum >= conf['W_CROWNED'][0] && endingSqNum <= conf['W_CROWNED'][1]);
    isCrowned = isCrowned || (piece == Piece.PAWN_BLACK && endingSqNum >= conf['B_CROWNED'][0] && endingSqNum <= conf['B_CROWNED'][1]);
    move.isCrowned = isCrowned;

    // Colour which plays this movement.
    move.color = board.getColor(startingSqNum);

    // Check white play after black and vice versa.
    if (previousColorPlayed){
        if (move.color == previousColorPlayed){
            move.status = false;
            move.message = "Ce joueur a déjà joué le coup précédent...";
        }
    }

    return move;
};

/**
 * Ne conserver que le/les mouvements les plus longs. <br />
 * Note : une prise est toujours plus longue qu'un déplacement simple.
 */
Arbiter._filterMajority = function(moves) {
    var list = [];

    var lMax = this._moveMax(moves);
    for (var k = 0; k < moves.length; k++) {
        var m = moves[k];
        if (m.size() == lMax) {
            list.push(m);
        }
    }

    // Eviter les faux positifs de variantes
    list = this._filterDuplicates(list);

    return list;
};

/**
 * Retire les mouvements identiques (mêmes cases prises et même arrivée) <br/>
 * => Eviter les faux positifs de variantes...<br />
 * Exemple d'une dame avec plusieurs pts de repos possibles entre 2 prises.
 */
Arbiter._filterDuplicates = function(moves) {
    var list = []; // [Move]

    if (moves.length > 1) {
        for (var k = 0; k < moves.length; k++) {
            var m = moves[k];
            var isDuplicate = false;
            for (var j = 0; j < list.length; j++) {
                var cf = list[j];
                if (m == cf) {
                    isDuplicate = true;
                }
            }
            if (!isDuplicate) {
                list.push(m);
            }
        }
    } else {
        list = moves;
    }

    return list;
};

/** Longueur du plus long mouvement. */
Arbiter._moveMax = function(moves) {
    var lMax = -1;

    for (var k = 0; k < moves.length; k++) {
        var m = moves[k];
        if (m.size() > lMax) {
            lMax = m.size();
        }
    }
    return lMax;
};

/** Ne conserve que les mouvements qui arrivent sur la case indiquée. */
Arbiter._filterEnding = function(moves, endNum) {
    var list = []; // [Move]

    for (var k = 0; k < moves.length; k++) {
        var m = moves[k];
        if (m.endingSquareNum == endNum) {
            list.push(m);
        }
    }
    return list;
};

/**
 * Ne conserve que les mouvements qui passent par les cases intermédiaires
 * indiquées.
 * 
 * @param inters
 *            : REQUIS, non null
 */
Arbiter._filterInter = function(moves, middleSquaresNum) {
    var list = []; // [Move]

    if (moves != null) {
        // Pour chaque mouvement
        for (var k = 0; k < moves.length; k++) {
            var m = moves[k];

            var landingSquaresNum = m.landingSquaresNum;
            var allFound = true;
            var nbLanding = landingSquaresNum.length;

            var lastIdxPose = -1;

            // Pour chaque inter spécifié
            for (var j = 0; j < middleSquaresNum.length; j++) {
                var inter = middleSquaresNum[j];

                // On regarde s'il fait partie des cases sur laquelle la pièce s'est posée
                var found = false;
                for (var idxPose = 0; idxPose < nbLanding; idxPose++) {
                    // La case posée existe
                    if (inter == landingSquaresNum[idxPose]) {
                        // ET on ne l'a pas déjà prise en compte
                        if (idxPose > lastIdxPose) {
                            found = true;
                            lastIdxPose = idxPose;
                        }
                    }
                }

                if (!found) {
                    allFound = false;
                    break; // mouvement suivant
                }
            }

            if (allFound) {
                list.push(m);
            }

        }
    }
    return list;
};

module.exports = Arbiter;


/***/ }),

/***/ "AQOC":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var distinctUntilChanged_1 = __webpack_require__("8hgl");
/* tslint:enable:max-line-length */
/**
 * Returns an Observable that emits all items emitted by the source Observable that are distinct by comparison from the previous item,
 * using a property accessed by using the key provided to check if the two items are distinct.
 *
 * If a comparator function is provided, then it will be called for each item to test for whether or not that value should be emitted.
 *
 * If a comparator function is not provided, an equality check is used by default.
 *
 * @example <caption>An example comparing the name of persons</caption>
 *
 *  interface Person {
 *     age: number,
 *     name: string
 *  }
 *
 * Observable.of<Person>(
 *     { age: 4, name: 'Foo'},
 *     { age: 7, name: 'Bar'},
 *     { age: 5, name: 'Foo'},
 *     { age: 6, name: 'Foo'})
 *     .distinctUntilKeyChanged('name')
 *     .subscribe(x => console.log(x));
 *
 * // displays:
 * // { age: 4, name: 'Foo' }
 * // { age: 7, name: 'Bar' }
 * // { age: 5, name: 'Foo' }
 *
 * @example <caption>An example comparing the first letters of the name</caption>
 *
 * interface Person {
 *     age: number,
 *     name: string
 *  }
 *
 * Observable.of<Person>(
 *     { age: 4, name: 'Foo1'},
 *     { age: 7, name: 'Bar'},
 *     { age: 5, name: 'Foo2'},
 *     { age: 6, name: 'Foo3'})
 *     .distinctUntilKeyChanged('name', (x: string, y: string) => x.substring(0, 3) === y.substring(0, 3))
 *     .subscribe(x => console.log(x));
 *
 * // displays:
 * // { age: 4, name: 'Foo1' }
 * // { age: 7, name: 'Bar' }
 * // { age: 5, name: 'Foo2' }
 *
 * @see {@link distinct}
 * @see {@link distinctUntilChanged}
 *
 * @param {string} key String key for object property lookup on each item.
 * @param {function} [compare] Optional comparison function called to test if an item is distinct from the previous item in the source.
 * @return {Observable} An Observable that emits items from the source Observable with distinct values based on the key specified.
 * @method distinctUntilKeyChanged
 * @owner Observable
 */
function distinctUntilKeyChanged(key, compare) {
    return distinctUntilChanged_1.distinctUntilChanged.call(this, function (x, y) {
        if (compare) {
            return compare(x[key], y[key]);
        }
        return x[key] === y[key];
    });
}
exports.distinctUntilKeyChanged = distinctUntilKeyChanged;
//# sourceMappingURL=distinctUntilKeyChanged.js.map

/***/ }),

/***/ "ASN6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var FromObservable_1 = __webpack_require__("JkZN");
var isArray_1 = __webpack_require__("Xajo");
var OuterSubscriber_1 = __webpack_require__("wAkD");
var subscribeToResult_1 = __webpack_require__("CURp");
/* tslint:enable:max-line-length */
function onErrorResumeNext() {
    var nextSources = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        nextSources[_i - 0] = arguments[_i];
    }
    if (nextSources.length === 1 && isArray_1.isArray(nextSources[0])) {
        nextSources = nextSources[0];
    }
    return this.lift(new OnErrorResumeNextOperator(nextSources));
}
exports.onErrorResumeNext = onErrorResumeNext;
/* tslint:enable:max-line-length */
function onErrorResumeNextStatic() {
    var nextSources = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        nextSources[_i - 0] = arguments[_i];
    }
    var source = null;
    if (nextSources.length === 1 && isArray_1.isArray(nextSources[0])) {
        nextSources = nextSources[0];
    }
    source = nextSources.shift();
    return new FromObservable_1.FromObservable(source, null).lift(new OnErrorResumeNextOperator(nextSources));
}
exports.onErrorResumeNextStatic = onErrorResumeNextStatic;
var OnErrorResumeNextOperator = (function () {
    function OnErrorResumeNextOperator(nextSources) {
        this.nextSources = nextSources;
    }
    OnErrorResumeNextOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new OnErrorResumeNextSubscriber(subscriber, this.nextSources));
    };
    return OnErrorResumeNextOperator;
}());
var OnErrorResumeNextSubscriber = (function (_super) {
    __extends(OnErrorResumeNextSubscriber, _super);
    function OnErrorResumeNextSubscriber(destination, nextSources) {
        _super.call(this, destination);
        this.destination = destination;
        this.nextSources = nextSources;
    }
    OnErrorResumeNextSubscriber.prototype.notifyError = function (error, innerSub) {
        this.subscribeToNextSource();
    };
    OnErrorResumeNextSubscriber.prototype.notifyComplete = function (innerSub) {
        this.subscribeToNextSource();
    };
    OnErrorResumeNextSubscriber.prototype._error = function (err) {
        this.subscribeToNextSource();
    };
    OnErrorResumeNextSubscriber.prototype._complete = function () {
        this.subscribeToNextSource();
    };
    OnErrorResumeNextSubscriber.prototype.subscribeToNextSource = function () {
        var next = this.nextSources.shift();
        if (next) {
            this.add(subscribeToResult_1.subscribeToResult(this, next));
        }
        else {
            this.destination.complete();
        }
    };
    return OnErrorResumeNextSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=onErrorResumeNext.js.map

/***/ }),

/***/ "ASS4":
/***/ (function(module, exports) {

exports.model=Model={Game:{},Board:{},Move:{}},function(){var t;Model.Game.cbConstants={MASK:65535,FLAG_MOVE:65536,FLAG_CAPTURE:131072,FLAG_STOP:262144,FLAG_SCREEN_CAPTURE:524288,FLAG_CAPTURE_KING:1048576,FLAG_CAPTURE_NO_KING:2097152};var e="undefined"!=typeof Int32Array;Model.Game.cbUseTypedArrays=e,Model.Game.cbTypedArray=function(t){if(e){var r=new Int32Array(t.length);return r.set(t),r}for(var a=[],i=t.length,s=0;s<i;s++)a.push(t[s]);return a},Model.Game.cbShortRangeGraph=function(t,e,r,a){var i=this;void 0===a&&(a=196608);for(var s={},n=0;n<t.boardSize;n++)s[n]=[],(!r||n in r)&&e.forEach(function(e){var o=t.Graph(n,e);null!=o&&(!r||o in r)&&s[n].push(i.cbTypedArray([o|a]))});return s},Model.Game.cbLongRangeGraph=function(t,e,r,a,i){var s=this;void 0!==a&&null!=a||(a=196608),i||(i=1/0);for(var n={},o=0;o<t.boardSize;o++)n[o]=[],(!r||o in r)&&e.forEach(function(e){for(var h=[],c=t.Graph(o,e),p=0;null!=c&&(!r||c in r)&&(h.push(c|a),++p!=i);)c=t.Graph(c,e);h.length>0&&n[o].push(s.cbTypedArray(h))});return n},Model.Game.cbNullGraph=function(t){for(var e={},r=0;r<t.boardSize;r++)e[r]=[];return e},Model.Game.cbAuthorGraph=function(t){for(var e={},r=0;r<t.boardSize;r++){e[r]=[];for(var a=0;a<t.boardSize;a++)e[r].push([2293760|a])}return e},Model.Game.cbMergeGraphs=function(t){for(var e=[],r=0;r<t.boardSize;r++){e[r]=[];for(var a=1;a<arguments.length;a++)e[r]=e[r].concat(arguments[a][r])}return e},Model.Game.cbGetThreatGraph=function(){function t(e,r){for(var a in n){var i=n[a];if(!(i.p.length<r.length+1)){for(var s=!0,o=0;o<r.length;o++)if(r[o]!=i.p[o]){s=!1;break}if(s){var h=i.p[r.length],c=e[h];void 0===c&&(c={e:{}},e[h]=c),i.p.length==r.length+1&&(c.t=i.t,c.ts=i.ts,c.tk=i.tk,delete n[a]),r.push(h),t(c.e,r),r.pop()}}}}var e=this;this.cbUseScreenCapture=!1,this.cbUseCaptureKing=!1,this.cbUseCaptureNoKing=!1;for(var r={1:[],"-1":[]},a=[],i=0;i<this.g.boardSize;i++)this.g.pTypes.forEach(function(t,r){t.graph[i].forEach(function(t){for(var s=[],n=0;n<t.length;n++){var o=t[n];1048576&o?(e.cbUseCaptureKing=!0,s.unshift({d:65535&o,a:i,tk:r})):2097152&o?(e.cbUseCaptureNoKing=!0,s.unshift({d:65535&o,a:i,tnk:r})):131072&o?s.unshift({d:65535&o,a:i,t:r}):262144&o?s.unshift({d:65535&o,a:i}):524288&o&&(e.cbUseScreenCapture=!0,s.unshift({d:65535&o,a:i,ts:r}))}s.length>0&&a.push(s)})});var s={};a.forEach(function(t){t.forEach(function(e,r){var a=s[e.d];void 0===a&&(a={},s[e.d]=a);for(var i=[],n=r+1;n<t.length;n++)i.push(t[n].d);i.push(e.a);var o=i.join(","),h=a[o];void 0===h&&(h={p:i,t:{},ts:{},tk:{}},a[o]=h),void 0!==e.t?h.t[e.t]=!0:void 0!==e.tk?h.tk[e.tk]=!0:void 0!==e.ts&&(h.ts[e.ts]=!0)})});for(var i=0;i<e.g.boardSize;i++){var n=s[i],o={};t(o,[]),r[1][i]=o,r[-1][i]=o}return r},Model.Game.InitGame=function(){var e=this;this.cbVar=t=this.cbDefine(),this.g.boardSize=this.cbVar.geometry.boardSize,this.g.pTypes=this.cbGetPieceTypes(),this.g.threatGraph=this.cbGetThreatGraph(),this.g.distGraph=this.cbVar.geometry.GetDistances(),this.cbPiecesCount=0,this.g.castleablePiecesCount={1:0,"-1":0};for(var r in t.pieceTypes){var a=t.pieceTypes[r];if(a.castle){(a.initial||[]).forEach(function(t){e.g.castleablePiecesCount[t.s]++})}a.initial&&(this.cbPiecesCount+=a.initial.length)}for(var i=[],r=0;r<this.cbPiecesCount;r++)i.push(r);var s=Object.keys(t.pieceTypes);this.zobrist=new JocGame.Zobrist({board:{type:"array",size:this.cbVar.geometry.boardSize,values:i},who:{values:["1","-1"]},type:{type:"array",size:this.cbPiecesCount,values:s}})},Model.Game.cbGetPieceTypes=function(){for(var t=[],e={},r=0;r<this.cbVar.geometry.boardSize;r++)e[r]=[];for(var a in this.cbVar.pieceTypes){var i=this.cbVar.pieceTypes[a];t[a]={graph:i.graph||e,abbrev:i.abbrev||"",value:i.isKing?100:i.value||1,isKing:!!i.isKing,castle:!!i.castle,epTarget:!!i.epTarget,epCatch:!!i.epCatch}}return t},Model.Board.Init=function(t){this.zSign=0},Model.Board.InitialPosition=function(r){var a=this;this.board=e?new Int16Array(r.g.boardSize):[];for(var i=0;i<r.g.boardSize;i++)this.board[i]=-1;if(this.kings={},this.pieces=[],this.ending={1:!1,"-1":!1},this.lastMove=null,r.cbVar.castle&&(this.castled={1:!1,"-1":!1}),this.zSign=r.zobrist.update(0,"who",-1),this.noCaptCount=0,this.mWho=1,r.mInitial)this.mWho=r.mInitial.turn||1,r.mInitial.pieces.forEach(function(t){var e={};for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);a.pieces.push(e)}),r.mInitial.lastMove&&(this.lastMove={f:r.mInitial.lastMove.f,t:r.mInitial.lastMove.t}),void 0!==r.mInitial.noCaptCount&&(this.noCaptCount=r.mInitial.noCaptCount),r.cbVar.castle&&r.mInitial.castle&&(this.castled={1:{k:!!r.mInitial.castle[1]&&!!r.mInitial.castle[1].k,q:!!r.mInitial.castle[1]&&!!r.mInitial.castle[1].q},"-1":{k:!!r.mInitial.castle[-1]&&!!r.mInitial.castle[-1].k,q:!!r.mInitial.castle[-1]&&!!r.mInitial.castle[-1].q}});else for(var s in r.cbVar.pieceTypes)for(var n=r.cbVar.pieceTypes[s],o=n.initial||[],h=0;h<o.length;h++){var c=o[h],p={s:c.s,t:parseInt(s),p:c.p,m:!1};this.pieces.push(p)}if(this.pieces.sort(function(t,e){if(t.s!=e.s)return e.s-t.s;var a=r.cbVar.pieceTypes[t.t].value||100,i=r.cbVar.pieceTypes[e.t].value||100;return a!=i?a-i:t.p-e.p}),this.pieces.forEach(function(t,e){t.i=e,a.board[t.p]=e,r.g.pTypes[t.t].isKing&&(a.kings[t.s]=t.p),a.zSign=r.zobrist.update(a.zSign,"board",e,t.p),a.zSign=r.zobrist.update(a.zSign,"type",t.t,e)}),r.mInitial&&r.mInitial.enPassant){var i=t.geometry.PosByName(r.mInitial.enPassant);if(i>=0){var l,u=t.geometry.C(i),v=t.geometry.R(i);l=1==r.mInitial.turn?t.geometry.POS(u,v-1):t.geometry.POS(u,v+1),this.epTarget={p:i,i:this.board[l]}}}},Model.Board.CopyFrom=function(t){if(e)this.board=new Int16Array(t.board.length),this.board.set(t.board);else{this.board=[];for(var r=t.board,a=r.length,i=0;i<a;i++)this.board.push(r[i])}this.pieces=[];for(var s=t.pieces.length,i=0;i<s;i++){var n=t.pieces[i];this.pieces.push({s:n.s,p:n.p,t:n.t,i:n.i,m:n.m})}this.kings={1:t.kings[1],"-1":t.kings[-1]},this.check=t.check,t.lastMove?this.lastMove={f:t.lastMove.f,t:t.lastMove.t,c:t.lastMove.c}:this.lastMove=null,this.ending={1:t.ending[1],"-1":t.ending[-1]},void 0!==t.castled&&(this.castled={1:t.castled[1],"-1":t.castled[-1]}),this.noCaptCount=t.noCaptCount,t.epTarget?this.epTarget={p:t.epTarget.p,i:t.epTarget.i}:this.epTarget=null,this.mWho=t.mWho,this.zSign=t.zSign},Model.Board.cbApplyCastle=function(t,e,r){var a=t.cbVar.castle[e.f+"/"+e.cg],i=a.r[a.r.length-1],s=this.pieces[this.board[e.cg]],n=a.k[a.k.length-1],o=this.pieces[this.board[e.f]];return r&&(this.zSign=t.zobrist.update(this.zSign,"board",s.i,e.cg),this.zSign=t.zobrist.update(this.zSign,"board",s.i,i),this.zSign=t.zobrist.update(this.zSign,"board",o.i,e.f),this.zSign=t.zobrist.update(this.zSign,"board",o.i,n)),s.p=i,s.m=!0,this.board[e.cg]=-1,o.p=n,o.m=!0,this.board[e.f]=-1,this.board[i]=s.i,this.board[n]=o.i,this.castled[s.s]=!0,this.kings[o.s]=n,[{i:s.i,f:i,t:-1},{i:o.i,f:n,t:e.f,kp:e.f,who:o.s,m:!1},{i:s.i,f:-1,t:e.cg,m:!1,cg:!1}]},Model.Board.cbQuickApply=function(t,e){if(void 0!==e.cg)return this.cbApplyCastle(t,e,!1);var r=[],a=this.board[e.f],i=this.pieces[a];if(null!=e.c){r.unshift({i:e.c,f:-1,t:this.pieces[e.c].p});var s=this.pieces[e.c];this.board[s.p]=-1,s.p=-1}var n=this.kings[i.s];return t.g.pTypes[i.t].isKing&&(this.kings[i.s]=e.t),r.unshift({i:a,f:e.t,t:e.f,kp:n,who:i.s,ty:i.t}),i.p=e.t,void 0!==e.pr&&(i.t=e.pr),this.board[e.f]=-1,this.board[e.t]=a,r},Model.Board.cbQuickUnapply=function(t,e){for(var r=0;r<e.length;r++){var a=e[r],i=this.pieces[a.i];a.f>=0&&(i.p=-1,this.board[a.f]=-1),a.t>=0&&(i.p=a.t,this.board[a.t]=a.i),void 0!==a.m&&(i.m=a.m),void 0!==a.kp&&(this.kings[a.who]=a.kp),void 0!=a.ty&&(i.t=a.ty),void 0!=a.cg&&(this.castled[i.s]=a.cg)}},Model.Board.ApplyMove=function(t,e){var r=this.pieces[this.board[e.f]];if(void 0!==e.cg)this.cbApplyCastle(t,e,!0);else{if(this.zSign=t.zobrist.update(this.zSign,"board",r.i,e.f),this.board[r.p]=-1,void 0!==e.pr&&(this.zSign=t.zobrist.update(this.zSign,"type",r.t,r.i),r.t=e.pr,this.zSign=t.zobrist.update(this.zSign,"type",r.t,r.i)),null!=e.c){var a=this.pieces[e.c];this.zSign=t.zobrist.update(this.zSign,"board",a.i,a.p),this.board[a.p]=-1,a.p=-1,a.m=!0,this.noCaptCount=0}else this.noCaptCount++;r.p=e.t,r.m=!0,this.board[e.t]=r.i,this.zSign=t.zobrist.update(this.zSign,"board",r.i,e.t),t.g.pTypes[r.t].isKing&&(this.kings[r.s]=e.t)}this.check=!!e.ck,this.lastMove={f:e.f,t:e.t,c:e.c},void 0!==e.ko&&(this.ending[r.s]=e.ko),void 0!==e.ept?this.epTarget={p:e.ept,i:r.i}:this.epTarget=null,this.zSign=t.zobrist.update(this.zSign,"who",-this.mWho),this.zSign=t.zobrist.update(this.zSign,"who",this.mWho)},Model.Board.Evaluate=function(r){function a(e){var r=1/0;for(var a in t.geometry.corners)r=Math.min(r,h.distGraph[s.kings[e]][a]);return r-Math.sqrt(h.boardSize)}var i="debug"==arguments[3],s=this;this.mEvaluation=0;var n,o=this.mWho,h=r.g;if(e)n={1:{count:new Uint8Array(h.pTypes.length),byType:{}},"-1":{count:new Uint8Array(h.pTypes.length),byType:{}}};else{n={1:{count:[],byType:{}},"-1":{count:[],byType:{}}};for(var c=0;c<h.pTypes.length;c++)n[1].count[c]=n[-1].count[c]=0}if(r.mOptions.preventRepeat&&r.GetRepeatOccurence(this)>2)return this.mFinished=!0,void(this.mWinner=r.cbOnPerpetual?o*r.cbOnPerpetual:JocGame.DRAW);for(var p={1:0,"-1":0},l={1:h.distGraph[this.kings[-1]],"-1":h.distGraph[this.kings[1]]},u={1:0,"-1":0},v={1:0,"-1":0},b={1:0,"-1":0},f={1:0,"-1":0},g={1:!1,"-1":!1},d=this.pieces,m=d.length,c=0;c<m;c++){var G=d[c];if(G.p>=0){var y=G.s,M=h.pTypes[G.t];M.isKing?g[y]=G.m:p[y]+=M.value,M.castle&&!G.m&&f[y]++,v[y]++,u[y]+=l[y][G.p],b[y]+=t.geometry.distEdge[G.p];var C=n[y];C.count[G.t]++;var S=C.byType;void 0===S[G.t]?S[G.t]=[G]:S[G.t].push(G)}}if(this.lastMove&&null!=this.lastMove.c){var G=this.pieces[this.board[this.lastMove.t]];p[-G.s]+=this.cbStaticExchangeEval(r,G.p,G.s,{piece:G})}var k={1:0,"-1":0},A={1:0,"-1":0},T={1:0,"-1":0};this.ending[1]&&(A[1]=(u[1]-Math.sqrt(h.boardSize))/v[1],t.geometry.corners&&(T[1]=a(1))),this.ending[-1]&&(A[-1]=(u[-1]-Math.sqrt(h.boardSize))/v[-1],t.geometry.corners&&(T[1]=a(-1)));var z={pieceValue:p[1]-p[-1],pieceValueRatio:(p[1]-p[-1])/(p[1]+p[-1]+1),posValue:b[1]-b[-1],averageDistKing:u[1]/v[1]-u[-1]/v[-1],check:this.check?-o:0,endingKingFreedom:k[1]-k[-1],endingDistKing:A[1]-A[-1],distKingCorner:T[1]-T[-1]};t.castle&&(z.castle=(this.castled[1]?1:g[1]?0:f[1]/(h.castleablePiecesCount[1]+1))-(this.castled[-1]?1:g[-1]?0:f[-1]/(h.castleablePiecesCount[-1]+1))),t.evaluate&&t.evaluate.call(this,r,z,n);var E=r.mOptions.levelOptions;for(var P in z){var w=z[P],I=E[P+"Factor"]||0,R=w*I;i&&console.log(P,"=",w,"*",I,"=>",R),this.mEvaluation+=R}i&&console.log("Evaluation",this.mEvaluation)},Model.Board.cbGeneratePseudoLegalMoves=function(t){function e(e,i){var s=t.cbVar.promote;if(!s)return void a.push(i);var n=s.call(r,t,e,i);if(null!=n)if(0==n.length)a.push(i);else if(1==n.length)i.pr=n[0],a.push(i);else for(var o=0;o<n.length;o++){var h=n[o];a.push({f:i.f,t:i.t,c:i.c,pr:h,ept:i.ept,ep:i.ep,a:i.a})}}for(var r=this,a=[],i=t.cbVar,s=this.mWho,n=!i.castle||this.check||this.castled[s]?null:[],o=-1,h=this.pieces.length,c=0;c<h;c++){var p=this.pieces[c];if(!(p.p<0||p.s!=s)){var l=t.g.pTypes[p.t];l.isKing&&(p.m?n=null:o=p),n&&l.castle&&!p.m&&n.push(p);var u,v;u=l.graph[p.p],v=u.length;for(var b=0;b<v;b++)for(var f=u[b],g=!1,d=f.length,m=null,G=0;G<d;G++){var y=f[G],M=65535&y,C=this.board[M];if(!(C<0)||l.epCatch&&this.epTarget&&this.epTarget.p==M){if(!(524288&y)){var S;S=C<0?this.pieces[this.epTarget.i]:this.pieces[C],!(S.s!=p.s&&131072&y)||1048576&y&&!t.g.pTypes[S.t].isKing||2097152&y&&t.g.pTypes[S.t].isKing||e(p,{f:p.p,t:M,c:S.i,a:l.abbrev,ep:C<0});break}if(g){var S=this.pieces[C];S.s!=p.s&&e(p,{f:p.p,t:M,c:S.i,a:l.abbrev});break}g=!0}else 65536&y&&0==g&&e(p,{f:p.p,t:M,c:null,a:l.abbrev,ept:null!=m&&l.epTarget?m:void 0});m=M}}}if(n)for(var c=0;c<n.length;c++){var k=n[c],A=t.cbVar.castle[o.p+"/"+k.p];if(A){for(var T=!0,b=0;b<A.r.length;b++){var z=A.r[b];if(this.board[z]>=0&&z!=o.p&&z!=k.p){T=!1;break}}if(T){for(var E=!0,b=0;b<A.k.length;b++){var z=A.k[b];if(this.board[z]>=0&&z!=k.p&&z!=o.p||this.cbGetAttackers(t,z,s).length>0){E=!1;break}}E&&a.push({f:o.p,t:A.k[A.k.length-1],c:null,cg:k.p})}}}return a},Model.Board.cbStaticExchangeEval=function(t,e,r,a){var i=0,s=this.cbGetSmallestAttacker(t,e,r);if(s){var n=this.mWho;this.mWho=s.s;var o=this.cbQuickApply(t,{f:s.p,t:e,c:a.piece.i}),h=t.g.pTypes[a.piece.t].value;a.piece=s,i=Math.max(0,h-this.cbStaticExchangeEval(t,e,-r,a)),this.cbQuickUnapply(t,o),this.mWho=n}return i},Model.Board.cbGetSmallestAttacker=function(t,e,r){var a=this.cbGetAttackers(t,e,r);if(0==a.length)return null;for(var i=1/0,s=null,n=a.length,o=0;o<n;o++){var h=a[o],c=t.g.pTypes[h.t].value;c<i&&(i=c,s=h)}return s},Model.Board.cbCollectAttackers=function(t,e,r,a){for(var i in e){var s=e[i],n=this.board[i];if(n<0)this.cbCollectAttackers(t,s.e,r,a);else{var o=this.pieces[n];o.s==-t&&(s.t&&o.t in s.t||a&&s.tk&&o.t in s.tk)&&r.push(o)}}},Model.Board.cbCollectAttackersScreen=function(t,e,r,a,i){for(var s in e){var n=e[s],o=this.board[s];if(o<0)this.cbCollectAttackersScreen(t,n.e,r,a,i);else{var h=this.pieces[o];!i&&h.s==-t&&(n.t&&h.t in n.t||a&&n.tk&&h.t in n.tk)?r.push(h):i?i&&h.s==-t&&n.ts&&h.t in n.ts&&r.push(h):this.cbCollectAttackersScreen(t,n.e,r,a,!0)}}},Model.Board.cbGetAttackers=function(t,e,r,a){var i=[];return t.cbUseScreenCapture?this.cbCollectAttackersScreen(r,t.g.threatGraph[r][e],i,a,!1):this.cbCollectAttackers(r,t.g.threatGraph[r][e],i,a),i},Model.Board.GenerateMoves=function(t){var e=this.cbGeneratePseudoLegalMoves(t);this.mMoves=[];for(var r=!0,a=this.kings[this.mWho],i=e.length,s=0;s<i;s++){var n=e[s],o=this.cbQuickApply(t,n);if(!(this.cbGetAttackers(t,this.kings[this.mWho],this.mWho,!0).length>0)){var h=this.cbGetAttackers(t,this.kings[-this.mWho],-this.mWho,!0).length>0;n.ck=h,this.mMoves.push(n),n.f!=a&&(r=!1)}this.cbQuickUnapply(t,o)}if(0==this.mMoves.length)this.mFinished=!0,this.mWinner=t.cbOnStaleMate?t.cbOnStaleMate*this.mWho:JocGame.DRAW,this.check&&(this.mWinner=-this.mWho);else if(this.ending[this.mWho]){if(!r)for(var s=0;s<this.mMoves.length;s++)this.mMoves[s].ko=!1}else if(!this.ending[this.mWho]&&r&&!this.check)for(var s=0;s<this.mMoves.length;s++)this.mMoves[s].ko=!0},Model.Board.GetSignature=function(){return this.zSign},Model.Move.Init=function(t){for(var e in t)t.hasOwnProperty(e)&&(this[e]=t[e])},Model.Move.Equals=function(t){return this.f==t.f&&this.t==t.t&&this.pr==t.pr},Model.Move.CopyFrom=function(t){this.Init(t)},Model.Move.ToString=function(e){var r=this;switch(e=e||"natural"){case"natural":return function(){var e;if(void 0!==r.cg?e=t.castle[r.f+"/"+r.cg].n:(e=r.a||"",e+=t.geometry.PosName(r.f),null==r.c?e+="-":e+="x",e+=t.geometry.PosName(r.t)),void 0!==r.pr){var a=t.pieceTypes[r.pr];a&&a.abbrev&&a.abbrev.length>0&&!a.silentPromo&&(e+="="+a.abbrev)}return r.ck&&(e+="+"),e}();case"engine":return function(){var e=t.geometry.PosName(r.f)+t.geometry.PosName(r.t);if(void 0!=r.pr){var a=t.pieceTypes[r.pr];a&&a.abbrev&&a.abbrev.length>0&&!a.silentPromo&&(e+=a.abbrev)}return e}();default:return"??"}},Model.Board.CompactMoveString=function(e,r,a){"function"!=typeof r.ToString&&(r=e.CreateMove(r));var i=r.ToString(),s=/^([A-Z]?)([a-z])([1-9][0-9]*)([-x])([a-z])([1-9][0-9]*)(.*?)$/.exec(i);if(!s)return i;var n=s[7];if(a||(a={}),a.value||(a.value=[]),0==a.value.length){var o=this.mMoves;this.mMoves&&0!=this.mMoves.length||this.GenerateMoves(e);for(var h=0;h<this.mMoves.length;h++){var c=this.mMoves[h];"function"!=typeof c.ToString&&(c=e.CreateMove(c)),a.value.push({str:c.ToString(),move:c})}this.mMoves=o}var p=[];if(a.value.forEach(function(t){var e=/^([A-Z]?[a-z][1-9][0-9]*[-x][a-z][1-9][0-9]*)(.*?)$/.exec(t.str);e&&t.move.t==r.t&&(t.move.a||"")==s[1]&&e[2]==n&&p.push(t.move)}),1==p.length)return""==s[1]&&"x"==s[4]?s[2]+"x"+s[5]+s[6]+s[7]:s[1]+("x"==s[4]?"x":"")+s[5]+s[6]+s[7];if(t.geometry.CompactCrit)for(var l="",h=0;;h++){var u=t.geometry.CompactCrit(r.f,h);if(null==u)return i;l+=u;for(var v=[],b=0;b<p.length;b++){var f=p[b];t.geometry.CompactCrit(f.f,h)==u&&v.push(f)}if(console.assert(v.length>0),1==v.length)return s[1]+l+("x"==s[4]?"x":"")+s[5]+s[6]+s[7];p=v}return i},Model.Board.cbIntegrity=function(t){function e(t,e){t||console.error(e)}for(var r=this,a=0;a<this.board.length;a++){var i=this.board[a];if(i>=0){var s=r.pieces[i];e(void 0!==s,"no piece at pos"),e(s.p==a,"piece has different pos")}}for(var i=0;i<this.pieces.length;i++){var s=this.pieces[i];s.p>=0&&e(r.board[s.p]==i,"board index mismatch")}},Model.Board.ExportBoardState=function(t){return t.cbVar.geometry.ExportBoardState?t.cbVar.geometry.ExportBoardState(this,t.cbVar,t.mPlayedMoves.length):"not supported"},Model.Game.Import=function(e,r){var a,i=[],s={1:{},"-1":{}},n=null,o=0;if("pjn"==e){var h={status:!1,error:"parse"},c=r.split(" ");if(6!=c.length)return console.warn("FEN should have 6 parts"),h;var p=c[0].split("/"),l=t.geometry.fenHeight||t.geometry.height;if(p.length!=l)return console.warn("FEN board should have",l,"rows, got",p.length),h;var u={};for(var v in t.pieceTypes){var b=t.pieceTypes[v],f=b.fenAbbrev||b.abbrev||"X";u[f.toUpperCase()]={s:1,t:v},u[f.toLowerCase()]={s:-1,t:v}}var g=t.geometry.FenRowPos||function(e,r){return(t.geometry.height-1-e)*t.geometry.width+r};if(p.forEach(function(e,r){for(var a=0,s=0;s<e.length;s++){var n=e.substr(s,1),o=u[n];if(void 0!==o){var c=g(r,a);a++;for(var p={s:o.s,t:o.t,p:c},l=!0,v=t.pieceTypes[p.t].initial||[],b=0;b<v.length;b++){var f=v[b];f.s==p.s&&f.p==c&&(l=!1)}p.m=l,i.push(p)}else{if(isNaN(parseInt(n)))return console.warn("FEN invalid board spec",n),h;a+=parseInt(n)}}}),i.sort(function(t,e){return e.s-t.s}),"w"==c[1])a=1;else{if("b"!=c[1])return console.warn("FEN invalid turn spec",c[1]),h;a=-1}s[1].k=c[2].indexOf("K")>=0,s[1].q=c[2].indexOf("Q")>=0,s[-1].k=c[2].indexOf("k")>=0,s[-1].q=c[2].indexOf("q")>=0,n="-"==c[3]?null:c[3];var d=parseInt(c[4]);isNaN(d)||(o=d);var m={pieces:i,turn:a,castle:s,enPassant:n,noCaptCount:o};return t.importGame&&t.importGame.call(this,m,e,r),{status:!0,initial:m}}return{status:!1,error:"unsupported"}}}(),function(){Model.Game.cbBoardGeometryGrid=function(t,e){function r(e){return e%t}function a(e){return Math.floor(e/t)}function i(e,r){return r*t+e}function s(s,n){var o=r(s),h=a(s),c=o+n[0],p=h+n[1];return c<0||c>=t||p<0||p>=e?null:i(c,p)}function n(t){return String.fromCharCode("a".charCodeAt(0)+r(t))+(a(t)+1)}function o(t){var e=/^([a-z])([0-9]+)$/.exec(t);return e?i(e[1].charCodeAt(0)-"a".charCodeAt(0),parseInt(e[2])-1):-1}function h(t,e){return 0==e?String.fromCharCode("a".charCodeAt(0)+r(t)):1==e?a(t)+1:null}function c(){for(var i=[],s=0;s<t*e;s++){var n=[];i.push(n);for(var o=0;o<t*e;o++){var h=a(s),c=r(s),p=a(o),l=r(o);n.push(Math.max(Math.abs(h-p),Math.abs(c-l)))}}return i}function p(r,a,s){for(var o=[],h=e-1;h>=0;h--){for(var c="",p=0,l=0;l<t;l++){var u=r.board[i(l,h)];if(u<0)p++;else{p>0&&(c+=p,p=0);var v=r.pieces[u],b=a.pieceTypes[v.t].fenAbbrev||a.pieceTypes[v.t].abbrev||"?";v.s==-1?c+=b.toLowerCase():c+=b.toUpperCase()}}p&&(c+=p),o.push(c)}var f=o.join("/");f+=" ",1==r.mWho?f+="w":f+="b",f+=" ";var g="";return r.castled&&(r.castled[1]===!1?g+="KQ":(r.castled[1].k&&(g+="K"),r.castled[1].q&&(g+="Q")),r.castled[-1]===!1?g+="kq":(r.castled[-1].k&&(g+="k"),r.castled[-1].q&&(g+="q"))),0==g.length&&(g="-"),f+=g,f+=" ",r.epTarget?f+=n(r.epTarget.p):f+="-",f+=" ",f+=r.noCaptCount,f+=" ",f+=Math.floor(s/2)+1}return{boardSize:t*e,width:t,height:e,C:r,R:a,POS:i,Graph:s,PosName:n,PosByName:o,CompactCrit:h,GetDistances:c,distEdge:function(){for(var i=[],s=0;s<t*e;s++){var n=r(s),o=a(s);i[s]=Math.min(n,Math.abs(t-n-1),o,Math.abs(e-o-1))}return i}(),corners:function(){var r={};return r[i(0,0)]=1,r[i(0,e-1)]=1,r[i(t-1,0)]=1,r[i(t-1,e-1)]=1,r}(),ExportBoardState:p}},Model.Game.cbPawnGraph=function(t,e,r){for(var a=this,i={},s=0;s<t.boardSize;s++)if(!r||s in r){var n=[],o=t.Graph(s,[0,e]);null!=o&&(!r||o in r)&&n.push(a.cbTypedArray([o|a.cbConstants.FLAG_MOVE])),[-1,1].forEach(function(i){var o=t.Graph(s,[i,e]);null!=o&&(!r||o in r)&&n.push(a.cbTypedArray([o|a.cbConstants.FLAG_CAPTURE]))}),i[s]=n}else i[s]=[];return i},Model.Game.cbInitialPawnGraph=function(t,e,r){for(var a=this,i={},s=0;s<t.boardSize;s++)if(!r||s in r){var n=[],o=t.Graph(s,[0,e]);if(null!=o&&(!r||o in r)){var h=[o|a.cbConstants.FLAG_MOVE],c=t.Graph(o,[0,e]);null!=c&&(!r||c in r)&&h.push(c|a.cbConstants.FLAG_MOVE),n.push(a.cbTypedArray(h))}[-1,1].forEach(function(i){var o=t.Graph(s,[i,e]);null!=o&&(!r||o in r)&&n.push(a.cbTypedArray([o|a.cbConstants.FLAG_CAPTURE]))}),i[s]=n}else i[s]=[];return i},Model.Game.cbKingGraph=function(t,e){return this.cbShortRangeGraph(t,[[-1,-1],[-1,0],[-1,1],[0,-1],[0,1],[1,-1],[1,0],[1,1]],e)},Model.Game.cbKnightGraph=function(t,e){return this.cbShortRangeGraph(t,[[2,-1],[2,1],[-2,-1],[-2,1],[-1,2],[-1,-2],[1,2],[1,-2]],e)},Model.Game.cbHorseGraph=function(t){for(var e=this,r={},a=0;a<t.boardSize;a++)r[a]=[],[[1,0,2,-1],[1,0,2,1],[-1,0,-2,-1],[-1,0,-2,1],[0,1,-1,2],[0,-1,-1,-2],[0,1,1,2],[0,-1,1,-2]].forEach(function(i){var s=t.Graph(a,[i[0],i[1]]);if(null!=s){var n=t.Graph(a,[i[2],i[3]]);null!=n&&r[a].push(e.cbTypedArray([s|e.cbConstants.FLAG_STOP,n|e.cbConstants.FLAG_MOVE|e.cbConstants.FLAG_CAPTURE]))}});return r},Model.Game.cbRookGraph=function(t,e){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0]],e)},Model.Game.cbBishopGraph=function(t,e){return this.cbLongRangeGraph(t,[[1,-1],[1,1],[-1,1],[-1,-1]],e)},Model.Game.cbQueenGraph=function(t,e){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0],[1,-1],[1,1],[-1,1],[-1,-1]],e)},Model.Game.cbXQGeneralGraph=function(t,e){for(var r=this,a={},i=0;i<t.boardSize;i++)a[i]=[],[[-1,0,!1],[0,-1,!0],[0,1,!0],[1,0,!1]].forEach(function(s){var n=[],o=t.Graph(i,s);if(null!=o&&((!e||o in e)&&n.push(o|r.cbConstants.FLAG_MOVE|r.cbConstants.FLAG_CAPTURE),s[2]))for(var h=t.Graph(o,s);null!=h;)!e||h in e?n.push(h|r.cbConstants.FLAG_CAPTURE|r.cbConstants.FLAG_CAPTURE_KING):n.push(h|r.cbConstants.FLAG_STOP),h=t.Graph(h,s);n.length>0&&a[i].push(r.cbTypedArray(n))});return a},Model.Game.cbXQSoldierGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e]])},Model.Game.cbXQPromoSoldierGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e],[-1,0],[1,0]])},Model.Game.cbXQAdvisorGraph=function(t,e){return this.cbShortRangeGraph(t,[[1,1],[-1,1],[1,-1],[-1,-1]],e)},Model.Game.cbXQCannonGraph=function(t){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0]],null,this.cbConstants.FLAG_MOVE|this.cbConstants.FLAG_SCREEN_CAPTURE)},Model.Game.cbXQElephantGraph=function(t,e){for(var r=this,a={},i=0;i<t.boardSize;i++)a[i]=[],(!e||i in e)&&[[1,1,2,2],[1,-1,2,-2],[-1,1,-2,2],[-1,-1,-2,-2]].forEach(function(s){var n=t.Graph(i,[s[0],s[1]]);if(null!=n){var o=t.Graph(i,[s[2],s[3]]);null!=o&&(!e||o in e)&&a[i].push(r.cbTypedArray([n|r.cbConstants.FLAG_STOP,o|r.cbConstants.FLAG_MOVE|r.cbConstants.FLAG_CAPTURE]))}});return a},Model.Game.cbSilverGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e],[-1,-1],[-1,1],[1,-1],[1,1]])},Model.Game.cbFersGraph=function(t,e){return this.cbShortRangeGraph(t,[[-1,-1],[-1,1],[1,-1],[1,1]])},Model.Game.cbSchleichGraph=function(t,e){return this.cbShortRangeGraph(t,[[-1,0],[1,0],[0,-1],[0,1]])},Model.Game.cbAlfilGraph=function(t,e){return this.cbShortRangeGraph(t,[[-2,-2],[-2,2],[2,2],[2,-2]])}}(),function(){var t=Model.Game.cbBoardGeometryGrid(9,9);Model.Game.cbDefine=function(){return{geometry:t,pieceTypes:{0:{name:"pawn-w",aspect:"fr-pawn",graph:this.cbPawnGraph(t,1),value:1,abbrev:"",fenAbbrev:"P",epCatch:!0},1:{name:"ipawn-w",aspect:"fr-pawn",graph:this.cbInitialPawnGraph(t,1),value:1,abbrev:"",fenAbbrev:"P",initial:[{s:1,p:9},{s:1,p:10},{s:1,p:11},{s:1,p:12},{s:1,p:13},{s:1,p:14},{s:1,p:15},{s:1,p:16},{s:1,p:17}],epTarget:!0},2:{name:"pawn-b",aspect:"fr-pawn",graph:this.cbPawnGraph(t,-1),value:1,abbrev:"",fenAbbrev:"P",epCatch:!0},3:{name:"ipawn-b",aspect:"fr-pawn",graph:this.cbInitialPawnGraph(t,-1),value:1,abbrev:"",fenAbbrev:"P",initial:[{s:-1,p:63},{s:-1,p:64},{s:-1,p:65},{s:-1,p:66},{s:-1,p:67},{s:-1,p:68},{s:-1,p:69},{s:-1,p:70},{s:-1,p:71}],epTarget:!0},4:{name:"knight",aspect:"fr-knight",graph:this.cbKnightGraph(t),value:2.9,abbrev:"N",initial:[{s:1,p:1},{s:1,p:6},{s:-1,p:73},{s:-1,p:78}]},5:{name:"bishop",aspect:"fr-bishop",graph:this.cbBishopGraph(t),value:3.1,abbrev:"B",initial:[{s:1,p:2},{s:1,p:7},{s:-1,p:74},{s:-1,p:79}]},6:{name:"rook",aspect:"fr-rook",graph:this.cbRookGraph(t),value:5,abbrev:"R",initial:[{s:1,p:0},{s:1,p:8},{s:-1,p:72},{s:-1,p:80}],castle:!0},7:{name:"queen",aspect:"fr-queen",graph:this.cbQueenGraph(t),value:9,abbrev:"Q",initial:[{s:1,p:3},{s:-1,p:75}]},8:{name:"king",aspect:"fr-king",isKing:!0,graph:this.cbKingGraph(t),abbrev:"K",initial:[{s:1,p:4},{s:-1,p:76}]},9:{name:"chancellor",aspect:"fr-marshall",graph:this.cbMergeGraphs(t,this.cbRookGraph(t),this.cbKnightGraph(t)),value:7.8,abbrev:"C",initial:[{s:1,p:5},{s:-1,p:77}]}},promote:function(e,r,a){return 1==r.t?[0]:3==r.t?[2]:0==r.t&&8==t.R(a.t)?[4,5,6,7,9]:2==r.t&&0==t.R(a.t)?[4,5,6,7,9]:[]},castle:{"4/0":{k:[3,2],r:[1,2,3],n:"O-O-O"},"4/8":{k:[5,6],r:[7,6,5],n:"O-O"},"76/72":{k:[75,74],r:[73,74,75],n:"O-O-O"},"76/80":{k:[77,78],r:[79,78,77],n:"O-O"}}}}}();

/***/ }),

/***/ "AZSN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var OuterSubscriber_1 = __webpack_require__("wAkD");
var subscribeToResult_1 = __webpack_require__("CURp");
/**
 * Buffers the source Observable values until `closingNotifier` emits.
 *
 * <span class="informal">Collects values from the past as an array, and emits
 * that array only when another Observable emits.</span>
 *
 * <img src="./img/buffer.png" width="100%">
 *
 * Buffers the incoming Observable values until the given `closingNotifier`
 * Observable emits a value, at which point it emits the buffer on the output
 * Observable and starts a new buffer internally, awaiting the next time
 * `closingNotifier` emits.
 *
 * @example <caption>On every click, emit array of most recent interval events</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var interval = Rx.Observable.interval(1000);
 * var buffered = interval.buffer(clicks);
 * buffered.subscribe(x => console.log(x));
 *
 * @see {@link bufferCount}
 * @see {@link bufferTime}
 * @see {@link bufferToggle}
 * @see {@link bufferWhen}
 * @see {@link window}
 *
 * @param {Observable<any>} closingNotifier An Observable that signals the
 * buffer to be emitted on the output Observable.
 * @return {Observable<T[]>} An Observable of buffers, which are arrays of
 * values.
 * @method buffer
 * @owner Observable
 */
function buffer(closingNotifier) {
    return this.lift(new BufferOperator(closingNotifier));
}
exports.buffer = buffer;
var BufferOperator = (function () {
    function BufferOperator(closingNotifier) {
        this.closingNotifier = closingNotifier;
    }
    BufferOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new BufferSubscriber(subscriber, this.closingNotifier));
    };
    return BufferOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var BufferSubscriber = (function (_super) {
    __extends(BufferSubscriber, _super);
    function BufferSubscriber(destination, closingNotifier) {
        _super.call(this, destination);
        this.buffer = [];
        this.add(subscribeToResult_1.subscribeToResult(this, closingNotifier));
    }
    BufferSubscriber.prototype._next = function (value) {
        this.buffer.push(value);
    };
    BufferSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        var buffer = this.buffer;
        this.buffer = [];
        this.destination.next(buffer);
    };
    return BufferSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=buffer.js.map

/***/ }),

/***/ "Aaho":
/***/ (function(module, exports) {

exports.model=Model={Game:{},Board:{},Move:{}},Model.Game.InitGame=function(){for(var r=this,o=this.mOptions.size,e=[],t=[],i=0,a=0,n=[],s=0;s<o;s++)n.push(a),a+=(o-s)*(o-s);for(var s=0;s<o;s++)for(var p=0;p<o-s;p++)for(var u=0;u<o-s;u++){var l=i++;e[l]=[p,u,s],t[l]=[];for(var h=0;h<2;h++)for(var f=0;f<2;f++){var v=s-1,d=p+h,g=u+f;v>=0&&v<o&&d>=0&&d<o-v&&g>=0&&g<o-v?t[l].push(n[v]+d*(o-v)+g):t[l].push(null)}var c=[[0,-1],[0,1],[-1,0],[1,0]];for(var b in c){var m=c[b],v=s,d=p+m[0],g=u+m[1];v>=0&&v<o&&d>=0&&d<o-v&&g>=0&&g<o-v?t[l].push(n[v]+d*(o-v)+g):t[l].push(null)}for(var h=-1;h<1;h++)for(var f=-1;f<1;f++){var v=s+1,d=p+h,g=u+f;v>=0&&v<o&&d>=0&&d<o-v&&g>=0&&g<o-v?t[l].push(n[v]+d*(o-v)+g):t[l].push(null)}}this.g.Graph=t,this.g.Coord=e,this.g.Over=[],this.g.Beneath=[];for(var l=0;l<this.g.Graph.length;l++)this.g.Over[l]=null,this.g.Beneath[l]=null;for(var l=0;l<this.g.Graph.length;l++)for(var e=this.g.Coord[l],G=l+1;G<this.g.Graph.length;G++){var y=this.g.Coord[G];if(y[2]==e[2]+2&&y[0]==e[0]-1&&y[1]==e[1]-1){this.g.Over[l]=G,this.g.Beneath[G]=l;break}}this.g.EachDirection=function(o,e){for(var t=0;t<12;t++){var i=r.g.Graph[o][t];if(null!=i&&0==e(i,t))return}},this.g.EachDirectionDown=function(o,e){for(var t=[0,1,2,3],i=0;i<t.length;i++){var a=r.g.Graph[o][t[i]];if(null!=a&&0==e(a,t[i]))return}},this.g.EachDirectionUp=function(o,e){for(var t=[8,9,10,11],i=0;i<t.length;i++){var a=r.g.Graph[o][t[i]];if(null!=a&&0==e(a,t[i]))return}},this.g.EachDirectionFlat=function(o,e){for(var t=[4,5,6,7],i=0;i<t.length;i++){var a=r.g.Graph[o][t[i]];if(null!=a&&0==e(a,t[i]))return}},this.g.EachDirectionFlatDown=function(o,e){for(var t=[0,1,2,3,4,5,6,7],i=0;i<t.length;i++){var a=r.g.Graph[o][t[i]];if(null!=a&&0==e(a,t[i]))return}},this.g.EachDirectionFlatUp=function(o,e){for(var t=[4,5,6,7,8,9,10,11],i=0;i<t.length;i++){var a=r.g.Graph[o][t[i]];if(null!=a&&0==e(a,t[i]))return}},this.zobrist=new JocGame.Zobrist({board:{type:"array",size:this.g.Graph.length,values:[0,1]}}),this.InitGameExtra()},Model.Game.MapSameLevelDiagGraph=function(){for(var r=[0,16,25,29],o=0;o<4;o++)for(var e=0;e<4-o;e++)for(var t=0;t<4-o;t++)for(var i=r[o]+e*(4-o)+t,a=-1;a<2;a+=2)for(var n=-1;n<2;n+=2){var s=o,p=e+a,u=t+n;s>=0&&s<4&&p>=0&&p<4-s&&u>=0&&u<4-s?this.g.Graph[i].push(r[s]+p*(4-s)+u):this.g.Graph[i].push(null)}},Model.Game.InitGameExtra=function(){},Model.Game.DestroyGame=function(){this.DestroyGameExtra()},Model.Game.DestroyGameExtra=function(){},Model.Game.spUpdateZobrist=function(r,o,e,t,i,a){for(var n=0;n<o.length;n++)r=this.zobrist.update(r,"board",e,o[n]);for(var n=0;n<t.length;n++)r=this.zobrist.update(r,"board",i,t[n]);return r},Model.Move.Init=function(r){for(var o in r)r.hasOwnProperty(o)&&(this[o]=JSON.parse(JSON.stringify(r[o])))},Model.Move.ToString=function(){var r=["?","W","B","R"][this.clr],o="";switch(this.act){case"+":o+="+"+this.pos+r;break;case">":o+=this.from+">"+this.to+r}return o},Model.Board.Init=function(r){},Model.Board.InitialPosition=function(r){this.spInitialPosition(r)},Model.Board.spInitialPosition=function(r){this.board=[];for(var o=0;o<r.g.Graph.length;o++)this.board[o]=0;this.maxLayer=0,this.ballCount=[0,0,0],this.playables={},this.height=[0,0,0],this.zSign=0;for(var o=0;o<r.mOptions.size*r.mOptions.size;o++)this.playables[o]=!0},Model.Board.MakeFreeMoves=function(r){var o=[];for(var e in this.playables)o.push({act:"+",pos:e,clr:this.mWho==JocGame.PLAYER_A?1:2});return o},Model.Board.GenerateMoves=function(r){var o=this.GenerateAllMoves(r),e=r.mOptions.moveCount;0==o.length?(this.mFinished=!0,this.ballCount[1]>this.ballCount[2]?this.mWinner=JocGame.PLAYER_A:this.ballCount[1]<this.ballCount[2]?this.mWinner=JocGame.PLAYER_B:this.mWinner=JocGame.DRAW):void 0!==e&&o.length>e&&(r.ArrayShuffle(o),o.sort(function(r,o){o.nextBoard.evaluation,r.nextBoard.evaluation}),o.splice(e,o.length-e)),this.mMoves=o},Model.Board.GenerateAllMoves=function(r){return this.MakeFreeMoves(r)},Model.Board.Evaluate=function(r,o,e){this.mEvaluation=0},Model.Board.ApplyMove=function(r,o){this.spApplyMove(r,o)},Model.Board.spApplyMove=function(r,o){function e(o){delete t.playables[o],r.g.EachDirectionFlat(o,function(e,i){if(t.board[e]){var a,n;switch(i){case 4:a=7,n=10;break;case 5:a=6,n=9;break;case 6:a=4,n=8;break;case 7:a=5,n=11}var s=r.g.Graph[o][a];null!==s&&t.board[s]>0&&t.board[r.g.Graph[e][a]]&&(t.playables[r.g.Graph[o][n]]=!0)}})}var t=this;switch(o.act){case"+":this.board[o.pos]=o.clr;var i=r.g.Coord[o.pos][2];i>this.maxLayer&&(this.maxLayer=i),this.height[o.clr]+=i,this.ballCount[o.clr]++,e(o.pos);break;case">":o.down.length>0?this.playables[o.down[o.down.length-1]]=!0:this.playables[o.from]=!0;var a=o.from;for(var n in o.down){var s=o.down[n];this.height[this.board[s]]--,this.board[a]=this.board[s],a=s}this.board[a]=0,this.board[o.to]=o.clr;var i=r.g.Coord[o.to][2];this.height[o.clr]+=i,i>this.maxLayer&&(this.maxLayer=i),e(o.to)}},Model.Board.IsValidMove=function(r,o){return!0},Model.Board.ExtendMove=function(r,o){return{}},Model.Board.GetSignature=function(){return this.zSign},Model.Board.InitialPosition=function(r){this.spInitialPosition(r),this.groupMaxId=1,this.groups={},this.posGroup={},this.posFree={},this.center=0,this.moveEvaluation=0},Model.Board.GenerateAllMoves=function(r){for(var o=this.MakeFreeMoves(r),e=[],t=0;t<o.length;t++){var i=o[t],a=this.ExtendMove(r,i.pos);if(null!==a){i.nextBoard=a.board,i.remove=a.remove;var n=!1;r.mVisitedBoards&&r.mVisitedBoards[i.nextBoard.zSign]&&(n=!0),0==n&&e.push(i)}}return e},Model.Board.ExtendMove=function(r,o,e,t){function i(e){var t=p.board[e],i={side:t,p:{},pCount:1,f:{},fCount:0};i.p[e]=!0;for(var a=[e];a.length>0;){var n=a.pop();r.g.EachDirection(n,function(e,s){var u=p.board[e];if(u==t){if(e in i.p)return!0;var h=r.g.Over[e];if(null!==h&&(0!=p.board[h]||o==h))return!0;var f=G[s];if(void 0!==f){var v=r.g.Graph[n][f[0]],d=r.g.Graph[n][f[1]];if((v==o&&t==l||p.board[v]==3-t)&&(d==o&&t==l||p.board[d]==3-t))return!0}i.p[e]=!0,i.pCount++,a.push(e)}else if(0==u&&e!=o&&0==r.g.Coord[e][2]){if(e in i.f)return!0;i.f[e]=!0,i.fCount++}return!0})}return i}function a(r){var o=p.groupMaxId++;p.groups[o]=r;for(var e in r.p){p.posGroup[e];p.posGroup[e]=o}for(var t in r.f)void 0===p.posFree[t]&&(p.posFree[t]={}),p.posFree[t][o]=!0;return o}function n(r,o){var e=[];for(var t in o)e.push(t);for(var i=e[0],a=p.groups[i],n=1;n<e.length;n++){var t=e[n],s=p.groups[t];for(var u in s.p)a.p[u]=!0,p.posGroup[u]=i;a.pCount+=s.pCount;for(var l in s.f)l in a.f||(a.f[l]=!0,a.fCount++),delete p.posFree[l][t],p.posFree[l][i]=!0;delete p.groups[t]}if(r>=0){for(var l in b)l in a.f||(a.f[l]=!0,a.fCount++),void 0===p.posFree[l]&&(p.posFree[l]={}),p.posFree[l][i]=!0;a.p[r]=!0,a.pCount++,p.posGroup[r]=i}}function s(r,o,e){var t=p.groups[o];for(var i in e)i in t.f||(t.f[i]=!0,t.fCount++,void 0===p.posFree[i]&&(p.posFree[i]={}),p.posFree[i][o]=!0);t.p[r]=!0,t.pCount++,p.posGroup[r]=o}arguments.length<3&&(e=0),arguments.length<4&&(t=null),null==t&&(t=this);var p=JSON.parse(JSON.stringify({board:t.board,playables:t.playables,ballCount:t.ballCount,groups:t.groups,posFree:t.posFree,posGroup:t.posGroup,groupMaxId:t.groupMaxId,center:t.center,zSign:t.zSign,mWho:t.mWho})),u={};0==e&&(e=this.mWho==JocGame.PLAYER_A?1:2);var l=3-e,h=r.g.Coord[o],f=h[2],v={},d=0,g={},c=0,b={},m=0,G={4:[8,10],5:[9,11],6:[8,9],7:[10,11]},y={4:[0,2],5:[1,3],6:[0,1],7:[2,3]},M={},C={},F=r.g.Beneath[o];if(null!=F){var E=p.posGroup[F],B=p.groups[E];delete B.p[F],B.pCount--,p.posGroup[F]=0;var S=p.board[F],x=r.g.Coord[F][2];r.g.EachDirection(F,function(o,e){var t=p.board[o];if(r.g.Coord[o][2]==x){var i=G[e],a=r.g.Graph[F][i[0]],n=r.g.Graph[F][i[1]];if(null!=a&&p.board[a]==3-S&&null!=n||p.board[n]==3-S)return!0}return t==S&&p.posGroup[o]>0&&(C[o]=!0),!0})}f>0&&r.g.EachDirectionFlat(o,function(t,i){if(p.board[t]==e){var a=y[i],n=r.g.Graph[o][a[0]],s=r.g.Graph[o][a[1]];p.board[n]==l&&p.board[s]==l&&(p.posGroup[n]&&(C[n]=!0),p.posGroup[s]&&(C[s]=!0))}return!0});var D={};for(var z in C){var O=p.posGroup[z];D[O]=!0}for(var O in D)!function(r){var o=p.groups[r];for(var e in o.p)0!=p.posGroup[e]&&(p.posGroup[e]=-1);for(var t in o.f)delete p.posFree[t][r];delete p.groups[r]}(O);for(var z in C)p.posGroup[z]<0&&a(i(z));r.g.EachDirection(o,function(r){if(0==p.board[r])return!0;var o=p.posGroup[r];return 0==o||(p.board[r]==e?void 0===v[o]&&(v[o]=!0,d++):p.board[r]==l&&void 0===g[o]&&(g[o]=!0,c++),!0)}),0==f&&r.g.EachDirectionFlat(o,function(r){return 0==p.board[r]&&(b[r]=!0,m++),!0});var A=p.posFree[o];if(void 0!==A){for(var O in A){var B=p.groups[O];delete B.f[o],B.fCount--}delete p.posFree[o]}if(0==d){var B={side:e,p:{},pCount:1,f:b,fCount:m};B.p[o]=!0,a(B)}else if(1==d){for(var E in v);s(o,E,b)}else n(o,v);var w=!1;for(var E in p.groups)if(0!=E){var B=p.groups[E];B.side==l&&0==B.fCount&&(!function(e){var t=p.groups[e],n={},s={},l=[];for(var h in t.p)l.push({p:h,z:r.g.Coord[h][2]});l.sort(function(r,o){return o.z-r.z});for(var f=0;f<l.length;f++){var v=l[f],h=v.p,d=!1;if(r.g.EachDirectionUp(h,function(r){return!p.board[r]&&r!=o||(d=!0,!1)}),d)n[h]=!0,p.posGroup[h]=-1;else{0==v.z&&(s[h]=!0),p.board[h]=0,u[h]=!0,delete p.posGroup[h],p.ballCount[t.side]--,p.playables[h]=!0,r.g.EachDirectionUp(h,function(r){return p.playables[r]&&delete p.playables[r],!0});var g=r.g.Beneath[h];if(g)if(p.board[g]==t.side){var c=!1;if(r.g.EachDirectionDown(h,function(r){return p.board[r]!=t.side||(c=!0,!1)}),c){t.p[g]=!0,t.pCount++,p.posGroup[g]=e;for(var b={p:g,z:r.g.Coord[g][2]},m=f+1;m<l.length&&b.z<l[m].z;m++);l.splice(m,0,b)}else M[g]=!0}else M[g]=!0}}for(var G in t.f)delete p.posFree[G][e];delete p.groups[e];for(var G in s)r.g.EachDirectionFlat(G,function(r){var o=p.posGroup[r];if(void 0!==o&&o>0&&(void 0===p.posFree[G]&&(p.posFree[G]={}),void 0===p.posFree[G][o])){p.posFree[G][o]=!0;var e=p.groups[o];e.f[G]=!0,e.fCount++}return!0});for(var h in n)p.posGroup[h]==-1&&a(i(h))}(E),w=!0)}for(var z in M)if(0==p.posGroup[z]){var I=p.board[z],J={},P=0,W={},k=0,L=r.g.Coord[z][2];if(r.g.EachDirection(z,function(o,e){if(0==p.board[o])return!0;var t=p.posGroup[o];if(0==t)return!0;if(r.g.Coord[o][2]==L){var i=G[e],a=r.g.Graph[z][i[0]],n=r.g.Graph[z][i[1]];if(null!=a&&p.board[a]==3-I&&null!=n&&p.board[n]==3-I)return!0}return p.board[o]==I?void 0===J[t]&&(J[t]=!0,P++):0==p.board[o]&&0==r.g.Coord[o][2]&&(W[o]=!0,k++),!0}),0==P){var B={side:I,p:{},pCount:1,f:W,fCount:k};B.p[z]=!0;var E=a(B)}else if(1==P){for(var E in J);s(z,E,{})}else n(z,J)}if(w){var N=[];for(var E in p.groups)if(0!=E){var B=p.groups[E];B.side==e&&N.push(E)}N.sort(function(r,o){return parseInt(r)-parseInt(o)});for(var R=[],U=0;U<N.length;U++){var E=N[U],B=p.groups[E];for(var z in B.p){r.g.EachDirectionFlat(z,function(o,t){if(p.board[o]!=e)return!0;var i=p.posGroup[o];if(i!=E&&0!=i){var a=G[t],n=r.g.Graph[z][a[0]],s=r.g.Graph[z][a[1]];if(null==n||p.board[n]!=l||null==s||p.board[s]!=l){for(var u=null,h=[],f=0;f<R.length;f++){var v=R[f];if(E in v||i in v)if(u){for(var d in v)u[d]=!0;h.push(f)}else v[E]=!0,v[i]=!0,u=v}for(var f=h.length-1;f>=0;f--)R.splice(h[f],1);if(null==u){var v={};v[E]=!0,v[i]=!0,R.push(v)}}}return!0})}}for(var U=0;U<R.length;U++)n(-1,R[U])}for(var E in p.groups)if(0!=E){var B=p.groups[E];if(B.side==e&&0==B.fCount)for(var z in B.p){var H=!1;if(r.g.EachDirectionUp(z,function(r){return!(p.board[r]>0)||(H=!0,!1)}),0==H)return null}}var _=[];for(var E in p.groups){var B=p.groups[E];B.eyes=0;for(var z in B.p)_.push({p:z,z:r.g.Coord[z][2],group:B,gid:E})}_.sort(function(r,o){return o.z-r.z});for(var j={},Y={},U=0;U<_.length;U++){var V=_[U],Z=!1;r.g.EachDirectionUp(V.p,function(r){var o=j[r];return!(void 0!==o&&V.group.side&3-o)||(Z=!0,!1)}),V.pinned=Z,Y[V.p]=V,j[V.p]=Z?3:V.group.side}for(var T in p.posFree){var X=0,$=!0;r.g.EachDirectionFlat(T,function(r){if(0==p.board[r])return $=!1,!1;var o=p.posGroup[r];return 0!=X&&o!=X?($=!1,!1):(X=o,!0)}),0==X&&($=!1),$&&p.groups[X].eye++}p.relativeSecured=0,p.relativeHeight=0;var q=r.mOptions.levelOptions;for(var E in p.groups){var B=p.groups[E],K=1==B.side?1:-1,Q=q.evalSafety;B.eyes>=2?Q=q.evalSafety2eyes+Math.log(B.eyes-1)*q.evalSafetyXEyesBonus:1==B.fCount?Q=q.evalSafety1f:3==B.fCount?Q=q.evalSafety3f:B.fCount>3&&(Q=q.evalSafety3fMore+Math.log(B.fCount-3)*q.evalSafety3fMoreBonus),1==B.eyes&&(Q+=q.evalSafety1eyeBonus);for(var z in B.p){var V=Y[z],rr=Q;V.pinned&&(rr+=q.evalSafetyPinnedBonus),p.relativeSecured+=rr*K,p.relativeHeight+=V.z*K}}if(0==f){var K=1==e?1:-1,or=Math.abs(h[0]-(r.mOptions.size-1)/2)+Math.abs(h[1]-(r.mOptions.size-1)/2);p.center+=or*K*-1}p.moveEvaluation=p.relativeSecured+q.evalHeightRatio*p.relativeHeight+q.evalCenterRatio*p.center;var er=[];for(var tr in u)er.push(tr);return p.zSign=r.spUpdateZobrist(p.zSign,[o],e-1,er,2-e),{board:p,remove:er}},Model.Board.Evaluate=function(r,o,e){this.mEvaluation=this.moveEvaluation},Model.Board.CheckConsistency=function(r){for(var o=[0,0,0],e=0;e<r.g.Graph.length;e++){var t=(r.g.Coord[e],this.board[e]);if(t>0){if(void 0===this.posGroup[e])return console.error("pos",e,"side",t,"not assigned to any group"),!1;if(this.posFree[e]){var i=null;for(i in this.posFree[e]);if(null!=i)return console.error("pos",e,"side",t,"set as free for group",i),!1}o[t]++}else if(this.posGroup[e])return console.error("empty pos",e,"in posGroup"),!1;var a=r.g.Over[e];if(null!=a&&this.board[a]>0&&0!=this.posGroup[e])return console.error("buried ball",e,"does not have posGroup 0 but",this.posGroup[e]),!0}if(o[1]!=this.ballCount[1]||o[2]!=this.ballCount[2])return console.error("ball count mismatch, got",o[1],o[2],"expecting",this.ballCount[1],this.ballCount[2]),!1;for(var e in this.posGroup){if(0==this.board[e])return console.error("posGroup pos",e,"is empty"),!1;if(0!=this.posGroup[e]){if(void 0===this.groups[this.posGroup[e]])return console.error("posGroup",e,"in unknown group",this.posGroup[e]),!1;if(!(e in this.groups[this.posGroup[e]].p))return console.error("posGroup",e,"does not match group"),!1}}for(var e in this.posFree){if(0!=this.board[e])return console.error("posFree pos",e,"is not empty"),!1;for(var n in this.posFree[e]){var s=this.groups[n];if(void 0===s)return console.error("posFree pos",e,"group",n,"does not exist"),!1;if(!(e in s.f))return console.error("posFree pos",e,"group",n,"not in group freedoms"),!1}}for(var n in this.groups){var s=this.groups[n],p=0;for(var u in s.p){if(0==this.board[u])return console.error("pos",u,"in group",n,"marked as empty"),!1;if(this.board[u]!=s.side)return console.error("pos",u,"in group",n,"has wrong side"),!1;if(this.posGroup[u]!=n)return console.error("pos",u,"in group",n,"has wrong group",this.posGroup[u]),!1;p++}if(p!=s.pCount)return console.error("group",n,"count mismatch"),!1;p=0;for(var u in s.f){if(0!=this.board[u])return console.error("freedom pos",u,"in group",n,"is not empty"),!1;if(0!=r.g.Coord[u][2])return console.error("freedom pos",u,"in group",n,"not at ground level"),!1;if(void 0===this.posFree[u])return console.error("freedom pos",u,"in group",n,"not in freedoms"),!1;if(!this.posFree[u][n])return console.error("freedom pos",u,"in group",n,"is not empty for group"),!1;p++}if(p!=s.fCount)return console.error("group",n,"freedom count mismatch"),!1}return!0},Model.Board.ApplyMove=function(r,o){if(void 0===o.nextBoard){var e=this.ExtendMove(r,o.pos);e||console.log("move",o,JSON.stringify(r.mPlayedMoves)),this.CopyFrom(e.board)}else this.CopyFrom(o.nextBoard);this.spApplyMove(r,o)},Model.Board.CopyFrom=function(r){this.groupMaxId=r.groupMaxId,this.center=r.center,this.maxLayer=r.maxLayer,this.zSign=r.zSign,this.mWho=r.mWho,this.moveEvaluation=r.moveEvaluation,this.board=[],this.ballCount=[0,r.ballCount[1],r.ballCount[2]];for(var o=0;o<r.board.length;o++)this.board.push(r.board[o]);this.playables={};for(var o in r.playables)this.playables[o]=!0;this.groups={};for(var e in r.groups){var t=r.groups[e],i={side:t.side,p:{},pCount:t.pCount,f:{},fCount:t.fCount};for(var o in t.p)i.p[o]=!0;for(var o in t.f)i.f[o]=!0;this.groups[e]=i}this.posFree={};for(var o in r.posFree){var a={};for(var n in r.posFree[o])a[n]=!0;this.posFree[o]=a}this.posGroup={};for(var o in r.posGroup)this.posGroup[o]=r.posGroup[o];r.height?this.height=[0,r.height[1],r.height[2]]:this.height=[0,0,0],void 0!==r.mEvaluation&&(this.mEvaluation=r.mEvaluation),void 0!==r.mFinished&&(this.mFinished=r.mFinished),void 0!==r.mWinner&&(this.mWinner=r.mWinner)},Model.Game.Save=function(){for(var r={playedMoves:[],game:JoclyHub.modelName},o=0;o<this.mPlayedMoves.length;o++){var e=new(this.GetMoveClass())(this.mPlayedMoves[o]);delete e.nextBoard,delete e.remove,delete e.boardJSON,r.playedMoves.push(e)}var t=new Date;if(r.date=t.getFullYear()+"-"+(t.getMonth()+1)+"-"+t.getDate()+"-"+t.getHours()+"_"+t.getMinutes()+"_"+t.getSeconds(),JoclyHub.network.connected){$(".jocly-temp").remove();var i=document.createElement("form");i.setAttribute("class","jocly-temp"),i.setAttribute("style","display: none;"),i.setAttribute("method","post"),i.setAttribute("action","/jocly/save-game");var a=document.createElement("input");a.setAttribute("type","hidden"),a.setAttribute("name","data"),a.setAttribute("value",JSON.stringify(r)),i.appendChild(a),document.body.appendChild(i),i.submit()}else{var n=r.game+"-"+r.date+".joc",s="data:application/x-joc;filename="+n+","+encodeURIComponent(JSON.stringify(r));window.open(s,n)}},Model.Move.Strip=function(){if(void 0!==this.nextBoard||void 0!==this.remove){var r={};for(var o in this)this.hasOwnProperty(o)&&"nextBoard"!=o&&(r[o]=JSON.parse(JSON.stringify(this[o])));return r}return this};

/***/ }),

/***/ "AwwP":
/***/ (function(module, exports) {

exports.config = {"status":true,"model":{"plazza":"true","released":1402412178,"title-en":"Metamachy","module":"chessbase","summary":"Chess on 12x12 with fairy pieces","thumbnail":"metamachy-thumb.png","rules":{"en":"metamachy-rules.html"},"credits":{"en":"metamachy-credits.html"},"gameOptions":{"preventRepeat":true,"uctTransposition":"state","uctIgnoreLoop":false,"levelOptions":{"pieceValueFactor":1,"pieceValueRatioFactor":1,"posValueFactor":0.1,"averageDistKingFactor":-0.01,"castleFactor":0.1,"minorPiecesMovedFactor":0.1,"checkFactor":0.2,"endingKingFreedomFactor":0.01,"endingDistKingFactor":0.05,"distKingCornerFactor":0.1,"distPawnPromo1Factor":0.3,"distPawnPromo2Factor":0.1,"distPawnPromo3Factor":0.05}},"obsolete":false,"js":["base-model.js","grid-geo-model.js","metamachy-model.js"],"description":{"en":"metamachy-description.html"},"levels":[{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"easy","label":"Easy","maxNodes":6000},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"fast","label":"Fast [3sec]","maxDuration":3,"isDefault":true},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"medium","label":"Medium","maxNodes":30000,"maxDuration":30},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"strong","label":"Strong","maxNodes":60000,"maxDuration":45}]},"view":{"title-en":"Chessbase view","module":"chessbase","xdView":true,"css":["chessbase.css"],"preferredRatio":1,"useShowMoves":true,"useNotation":true,"useAutoComplete":true,"defaultOptions":{"sounds":true,"moves":true,"notation":false,"autocomplete":false},"skins":[{"name":"skin3d","title":"3D Classic","3d":true,"preload":["smoothedfilegeo|0|/res/ring-target.js","image|/res/images/cancel.png","image|/res/images/wikipedia.png","smoothedfilegeo|0|/res/fairy/pawn/pawn.js","image|/res/fairy/pawn/pawn-diffusemap.jpg","image|/res/fairy/pawn/pawn-normalmap.jpg","smoothedfilegeo|0|/res/fairy/knight/knight.js","image|/res/fairy/knight/knight-diffusemap.jpg","image|/res/fairy/knight/knight-normalmap.jpg","smoothedfilegeo|0|/res/fairy/bishop/bishop.js","image|/res/fairy/bishop/bishop-diffusemap.jpg","image|/res/fairy/bishop/bishop-normalmap.jpg","smoothedfilegeo|0|/res/fairy/queen/queen.js","image|/res/fairy/queen/queen-diffusemap.jpg","image|/res/fairy/queen/queen-normalmap.jpg","smoothedfilegeo|0|/res/fairy/king/king.js","image|/res/fairy/king/king-diffusemap.jpg","image|/res/fairy/king/king-normalmap.jpg","smoothedfilegeo|0|/res/fairy/rook/rook.js","image|/res/fairy/rook/rook-diffusemap.jpg","image|/res/fairy/rook/rook-normalmap.jpg","smoothedfilegeo|0|/res/fairy/cannon2/cannon2.js","image|/res/fairy/cannon2/cannon2-diffusemap.jpg","image|/res/fairy/cannon2/cannon2-normalmap.jpg","smoothedfilegeo|0|/res/fairy/elephant/elephant.js","image|/res/fairy/elephant/elephant-diffusemap.jpg","image|/res/fairy/elephant/elephant-normalmap.jpg","smoothedfilegeo|0|/res/fairy/admiral/admiral.js","image|/res/fairy/admiral/admiral-diffusemap.jpg","image|/res/fairy/admiral/admiral-normalmap.jpg","smoothedfilegeo|0|/res/fairy/camel/camel.js","image|/res/fairy/camel/camel-diffusemap.jpg","image|/res/fairy/camel/camel-normalmap.jpg","smoothedfilegeo|0|/res/fairy/lion/lion.js","image|/res/fairy/lion/lion-diffusemap.jpg","image|/res/fairy/lion/lion-normalmap.jpg","smoothedfilegeo|0|/res/fairy/eagle/eagle.js","image|/res/fairy/eagle/eagle-diffusemap.jpg","image|/res/fairy/eagle/eagle-normalmap.jpg"],"world":{"lightIntensity":1.3,"skyLightIntensity":1.2,"lightCastShadow":true,"fog":false,"color":4686804,"lightPosition":{"x":-9,"y":9,"z":9},"skyLightPosition":{"x":9,"y":9,"z":9},"lightShadowDarkness":0.55,"ambientLightColor":2236962},"camera":{"fov":45,"distMax":50,"radius":18,"elevationAngle":60,"elevationMin":0}},{"name":"skin2d","title":"2D Classic","3d":false,"preload":["image|/res/images/cancel.png","image|/res/images/whitebg.png","image|/res/fairy/wikipedia-fairy-sprites.png"]}],"animateSelfMoves":false,"switchable":true,"sounds":{"move1":"alq_move1","move2":"alq_move2","move3":"alq_move3","move4":"alq_move2","tac1":"alq_tac1","tac2":"alq_tac2","tac3":"alq_tac1","promo":"promo","usermove":null},"js":["base-view.js","grid-board-view.js","fairy-set-view.js","metamachy-view.js"],"visuals":{"600x600":["res/visuals/metamachy-600x600-3d.jpg","res/visuals/metamachy-600x600-2d.jpg"]}}}

/***/ }),

/***/ "B00U":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isArray_1 = __webpack_require__("Xajo");
var isObject_1 = __webpack_require__("ICpg");
var isFunction_1 = __webpack_require__("SKH6");
var tryCatch_1 = __webpack_require__("+3eL");
var errorObject_1 = __webpack_require__("WhVc");
var UnsubscriptionError_1 = __webpack_require__("GIjk");
/**
 * Represents a disposable resource, such as the execution of an Observable. A
 * Subscription has one important method, `unsubscribe`, that takes no argument
 * and just disposes the resource held by the subscription.
 *
 * Additionally, subscriptions may be grouped together through the `add()`
 * method, which will attach a child Subscription to the current Subscription.
 * When a Subscription is unsubscribed, all its children (and its grandchildren)
 * will be unsubscribed as well.
 *
 * @class Subscription
 */
var Subscription = (function () {
    /**
     * @param {function(): void} [unsubscribe] A function describing how to
     * perform the disposal of resources when the `unsubscribe` method is called.
     */
    function Subscription(unsubscribe) {
        /**
         * A flag to indicate whether this Subscription has already been unsubscribed.
         * @type {boolean}
         */
        this.closed = false;
        this._parent = null;
        this._parents = null;
        this._subscriptions = null;
        if (unsubscribe) {
            this._unsubscribe = unsubscribe;
        }
    }
    /**
     * Disposes the resources held by the subscription. May, for instance, cancel
     * an ongoing Observable execution or cancel any other type of work that
     * started when the Subscription was created.
     * @return {void}
     */
    Subscription.prototype.unsubscribe = function () {
        var hasErrors = false;
        var errors;
        if (this.closed) {
            return;
        }
        var _a = this, _parent = _a._parent, _parents = _a._parents, _unsubscribe = _a._unsubscribe, _subscriptions = _a._subscriptions;
        this.closed = true;
        this._parent = null;
        this._parents = null;
        // null out _subscriptions first so any child subscriptions that attempt
        // to remove themselves from this subscription will noop
        this._subscriptions = null;
        var index = -1;
        var len = _parents ? _parents.length : 0;
        // if this._parent is null, then so is this._parents, and we
        // don't have to remove ourselves from any parent subscriptions.
        while (_parent) {
            _parent.remove(this);
            // if this._parents is null or index >= len,
            // then _parent is set to null, and the loop exits
            _parent = ++index < len && _parents[index] || null;
        }
        if (isFunction_1.isFunction(_unsubscribe)) {
            var trial = tryCatch_1.tryCatch(_unsubscribe).call(this);
            if (trial === errorObject_1.errorObject) {
                hasErrors = true;
                errors = errors || (errorObject_1.errorObject.e instanceof UnsubscriptionError_1.UnsubscriptionError ?
                    flattenUnsubscriptionErrors(errorObject_1.errorObject.e.errors) : [errorObject_1.errorObject.e]);
            }
        }
        if (isArray_1.isArray(_subscriptions)) {
            index = -1;
            len = _subscriptions.length;
            while (++index < len) {
                var sub = _subscriptions[index];
                if (isObject_1.isObject(sub)) {
                    var trial = tryCatch_1.tryCatch(sub.unsubscribe).call(sub);
                    if (trial === errorObject_1.errorObject) {
                        hasErrors = true;
                        errors = errors || [];
                        var err = errorObject_1.errorObject.e;
                        if (err instanceof UnsubscriptionError_1.UnsubscriptionError) {
                            errors = errors.concat(flattenUnsubscriptionErrors(err.errors));
                        }
                        else {
                            errors.push(err);
                        }
                    }
                }
            }
        }
        if (hasErrors) {
            throw new UnsubscriptionError_1.UnsubscriptionError(errors);
        }
    };
    /**
     * Adds a tear down to be called during the unsubscribe() of this
     * Subscription.
     *
     * If the tear down being added is a subscription that is already
     * unsubscribed, is the same reference `add` is being called on, or is
     * `Subscription.EMPTY`, it will not be added.
     *
     * If this subscription is already in an `closed` state, the passed
     * tear down logic will be executed immediately.
     *
     * @param {TeardownLogic} teardown The additional logic to execute on
     * teardown.
     * @return {Subscription} Returns the Subscription used or created to be
     * added to the inner subscriptions list. This Subscription can be used with
     * `remove()` to remove the passed teardown logic from the inner subscriptions
     * list.
     */
    Subscription.prototype.add = function (teardown) {
        if (!teardown || (teardown === Subscription.EMPTY)) {
            return Subscription.EMPTY;
        }
        if (teardown === this) {
            return this;
        }
        var subscription = teardown;
        switch (typeof teardown) {
            case 'function':
                subscription = new Subscription(teardown);
            case 'object':
                if (subscription.closed || typeof subscription.unsubscribe !== 'function') {
                    return subscription;
                }
                else if (this.closed) {
                    subscription.unsubscribe();
                    return subscription;
                }
                else if (typeof subscription._addParent !== 'function' /* quack quack */) {
                    var tmp = subscription;
                    subscription = new Subscription();
                    subscription._subscriptions = [tmp];
                }
                break;
            default:
                throw new Error('unrecognized teardown ' + teardown + ' added to Subscription.');
        }
        var subscriptions = this._subscriptions || (this._subscriptions = []);
        subscriptions.push(subscription);
        subscription._addParent(this);
        return subscription;
    };
    /**
     * Removes a Subscription from the internal list of subscriptions that will
     * unsubscribe during the unsubscribe process of this Subscription.
     * @param {Subscription} subscription The subscription to remove.
     * @return {void}
     */
    Subscription.prototype.remove = function (subscription) {
        var subscriptions = this._subscriptions;
        if (subscriptions) {
            var subscriptionIndex = subscriptions.indexOf(subscription);
            if (subscriptionIndex !== -1) {
                subscriptions.splice(subscriptionIndex, 1);
            }
        }
    };
    Subscription.prototype._addParent = function (parent) {
        var _a = this, _parent = _a._parent, _parents = _a._parents;
        if (!_parent || _parent === parent) {
            // If we don't have a parent, or the new parent is the same as the
            // current parent, then set this._parent to the new parent.
            this._parent = parent;
        }
        else if (!_parents) {
            // If there's already one parent, but not multiple, allocate an Array to
            // store the rest of the parent Subscriptions.
            this._parents = [parent];
        }
        else if (_parents.indexOf(parent) === -1) {
            // Only add the new parent to the _parents list if it's not already there.
            _parents.push(parent);
        }
    };
    Subscription.EMPTY = (function (empty) {
        empty.closed = true;
        return empty;
    }(new Subscription()));
    return Subscription;
}());
exports.Subscription = Subscription;
function flattenUnsubscriptionErrors(errors) {
    return errors.reduce(function (errs, err) { return errs.concat((err instanceof UnsubscriptionError_1.UnsubscriptionError) ? err.errors : err); }, []);
}
//# sourceMappingURL=Subscription.js.map

/***/ }),

/***/ "B1pT":
/***/ (function(module, exports) {

exports.config = {"status":true,"model":{"plazza":"true","title-en":"De cercar la liebre","module":"hunt","js":["hunt-model.js","decercarlaliebre-model.js"],"defaultHuman":1,"gameOptions":{"preventRepeat":true,"uctTransposition":"state","uctIgnoreLoop":false,"levelOptions":{"pieceCount0":12000000,"pieceCount1":1000000,"dist20":15,"freeZone0":400,"openRisk0":200,"forkRisk0":400,"catcheeGroups0":300}},"levels":[{"ai":"uct","c":0.4,"playoutDepth":0,"minVisitsExpand":1,"ignoreLeaf":false,"uncertaintyFactor":5,"propagateMultiVisits":false,"playoutCeil":1,"log":true,"label":"Easy","isDefault":true,"maxDuration":1,"maxNodes":1500,"maxLoops":250},{"ai":"uct","c":0.4,"playoutDepth":0,"minVisitsExpand":1,"ignoreLeaf":false,"uncertaintyFactor":5,"propagateMultiVisits":false,"playoutCeil":1,"log":true,"label":"Medium","maxDuration":2,"maxNodes":2500,"maxLoops":500},{"ai":"uct","c":0.4,"playoutDepth":0,"minVisitsExpand":1,"ignoreLeaf":false,"uncertaintyFactor":5,"propagateMultiVisits":false,"playoutCeil":1,"log":true,"label":"Strong","maxDuration":5}],"defaultLevel":2,"summary":"Middle age hunt game","rules":{"en":"decercarlaliebre-rules.html","fr":"decercarlaliebre-rules-fr.html"},"credits":{"en":"decercarlaliebre-credits.html","fr":"decercarlaliebre-credits-fr.html"},"description":{"en":"decercarlaliebre-description.html","fr":"decercarlaliebre-description-fr.html"},"thumbnail":"decercarlaliebre-thumbnail.png","strings":[]},"view":{"title-en":"De cercar la liebre View","module":"hunt","js":["hunt-xd-view.js","decercarlaliebre-xd-view.js"],"visuals":{"600x600":["res/visuals/decercar-600x600-3d.jpg","res/visuals/decercar-600x600-2d.jpg"]},"xdView":true,"css":["hunt.css","decercarlaliebre.css"],"preferredRatio":1,"switchable":false,"useShowMoves":true,"useNotation":true,"animateSelfMoves":false,"skins":[{"name":"decercarlaliebre3d","title":"3D Classic","3d":true,"camera":{"radius":14,"elevationAngle":45,"limitCamMoves":true},"world":{"lightIntensity":0,"skyLightIntensity":0,"color":3355443,"fog":false,"lightPosition":{"x":-5,"y":18,"z":5},"lightShadowDarkness":0.25,"ambientLightColor":1118481},"preload":["image|/res/xd-view/meshes/liebre/hunter.jpg","image|/res/xd-view/meshes/liebre/rabbitskin4.jpg","image|/res/xd-view/meshes/liebre/liebreboardsimple.jpg","image|/res/xd-view/meshes/liebre/liebreboard.jpg","smoothedfilegeo|0|/res/xd-view/meshes/board.js","smoothedfilegeo|0|/res/xd-view/meshes/liebre/hunter2.js","smoothedfilegeo|0|/res/xd-view/meshes/liebre/liebre6.js","smoothedfilegeo|0|/res/xd-view/meshes/target.js"]},{"name":"medieval","title":"Medieval"}],"defaultOptions":{"sounds":true,"notation":false,"moves":true}}}

/***/ }),

/***/ "B2te":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var sample_1 = __webpack_require__("0VSF");
Observable_1.Observable.prototype.sample = sample_1.sample;
//# sourceMappingURL=sample.js.map

/***/ }),

/***/ "BAIq":
/***/ (function(module, exports) {

exports.config = {"status":true,"model":{"plazza":"true","released":1405068610,"title-en":"Hyderabad Decimal Chess","module":"chessbase","summary":"Shir Muhammad Khan Iman, 1797-1798","thumbnail":"hyderabad-thumb.png","rules":{"en":"hyderabad-rules.html"},"credits":{"en":"hyderabad-credits.html"},"gameOptions":{"preventRepeat":true,"uctTransposition":"state","uctIgnoreLoop":false,"levelOptions":{"pieceValueFactor":1,"pieceValueRatioFactor":1,"posValueFactor":0.1,"averageDistKingFactor":-0.01,"castleFactor":0.1,"minorPiecesMovedFactor":0.1,"checkFactor":0.2,"endingKingFreedomFactor":0.01,"endingDistKingFactor":0.05,"distKingCornerFactor":0.1,"distPawnPromo1Factor":0.3,"distPawnPromo2Factor":0.1,"distPawnPromo3Factor":0.05}},"obsolete":false,"js":["base-model.js","grid-geo-model.js","hyderabad-model.js"],"description":{"en":"hyderabad-description.html"},"levels":[{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"easy","label":"Easy","maxNodes":1000},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"fast","label":"Fast [1sec]","maxDuration":1,"isDefault":true},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"medium","label":"Medium","maxNodes":10000,"maxDuration":10},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"strong","label":"Strong","maxNodes":20000,"maxDuration":15}]},"view":{"title-en":"Chessbase view","module":"chessbase","xdView":true,"css":["chessbase.css"],"preferredRatio":1,"useShowMoves":true,"useNotation":true,"useAutoComplete":true,"defaultOptions":{"sounds":true,"moves":true,"notation":false,"autocomplete":false},"skins":[{"name":"skin3d","title":"3D Classic","3d":true,"preload":["smoothedfilegeo|0|/res/ring-target.js","image|/res/images/cancel.png","image|/res/images/wikipedia.png","smoothedfilegeo|0|/res/fairy/pawn/pawn.js","image|/res/fairy/pawn/pawn-diffusemap.jpg","image|/res/fairy/pawn/pawn-normalmap.jpg","smoothedfilegeo|0|/res/fairy/knight/knight.js","image|/res/fairy/knight/knight-diffusemap.jpg","image|/res/fairy/knight/knight-normalmap.jpg","smoothedfilegeo|0|/res/fairy/bishop/bishop.js","image|/res/fairy/bishop/bishop-diffusemap.jpg","image|/res/fairy/bishop/bishop-normalmap.jpg","smoothedfilegeo|0|/res/fairy/king/king.js","image|/res/fairy/king/king-diffusemap.jpg","image|/res/fairy/king/king-normalmap.jpg","smoothedfilegeo|0|/res/fairy/rook/rook.js","image|/res/fairy/rook/rook-diffusemap.jpg","image|/res/fairy/rook/rook-normalmap.jpg","smoothedfilegeo|0|/res/fairy/queen/queen.js","image|/res/fairy/queen/queen-diffusemap.jpg","image|/res/fairy/queen/queen-normalmap.jpg","smoothedfilegeo|0|/res/fairy/marshall/marshall.js","image|/res/fairy/marshall/marshall-diffusemap.jpg","image|/res/fairy/marshall/marshall-normalmap.jpg","smoothedfilegeo|0|/res/fairy/cardinal/cardinal.js","image|/res/fairy/cardinal/cardinal-diffusemap.jpg","image|/res/fairy/cardinal/cardinal-normalmap.jpg","smoothedfilegeo|0|/res/fairy/amazon/amazon.js","image|/res/fairy/amazon/amazon-diffusemap.jpg","image|/res/fairy/amazon/amazon-normalmap.jpg"],"world":{"lightIntensity":1.3,"skyLightIntensity":1.2,"lightCastShadow":true,"fog":false,"color":4686804,"lightPosition":{"x":-9,"y":9,"z":9},"skyLightPosition":{"x":9,"y":9,"z":9},"lightShadowDarkness":0.55,"ambientLightColor":2236962},"camera":{"fov":45,"distMax":50,"radius":18,"elevationAngle":60,"elevationMin":0}},{"name":"skin2d","title":"2D Classic","3d":false,"preload":["image|/res/images/cancel.png","image|/res/images/whitebg.png","image|/res/fairy/wikipedia-fairy-sprites.png"]}],"animateSelfMoves":false,"switchable":true,"sounds":{"move1":"alq_move1","move2":"alq_move2","move3":"alq_move3","move4":"alq_move2","tac1":"alq_tac1","tac2":"alq_tac2","tac3":"alq_tac1","promo":"promo","usermove":null},"js":["base-view.js","grid-board-view.js","fairy-set-view.js","hyderabad-view.js"],"visuals":{"600x600":["res/visuals/hyderabad-600x600-3d.jpg","res/visuals/hyderabad-600x600-2d.jpg"]}}}

/***/ }),

/***/ "BQSl":
/***/ (function(module, exports) {

exports.config = {"status":true,"model":{"plazza":"true","released":1401720878,"title-en":"Chess 960","module":"chessbase","summary":"Chess from randomized positions","thumbnail":"chess960-thumb.png","rules":{"en":"chess960-rules.html"},"credits":{"en":"chess960-credits.html"},"gameOptions":{"preventRepeat":true,"uctTransposition":"state","uctIgnoreLoop":false,"levelOptions":{"pieceValueFactor":1,"pieceValueRatioFactor":1,"posValueFactor":0.1,"averageDistKingFactor":-0.01,"castleFactor":0.1,"minorPiecesMovedFactor":0.1,"checkFactor":0.2,"endingKingFreedomFactor":0.01,"endingDistKingFactor":0.05,"distKingCornerFactor":0.1,"distPawnPromo1Factor":0.3,"distPawnPromo2Factor":0.1,"distPawnPromo3Factor":0.05}},"obsolete":false,"js":["base-model.js","grid-geo-model.js","chess960-model.js"],"description":{"en":"chess960-description.html"},"levels":[{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"easy","label":"Easy","maxNodes":1000},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"fast","label":"Fast [1sec]","maxDuration":1,"isDefault":true},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"medium","label":"Medium","maxNodes":10000,"maxDuration":10},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"strong","label":"Strong","maxNodes":20000,"maxDuration":15}]},"view":{"title-en":"Chessbase view","module":"chessbase","xdView":true,"css":["chessbase.css"],"preferredRatio":1,"useShowMoves":true,"useNotation":true,"useAutoComplete":true,"defaultOptions":{"sounds":true,"moves":true,"notation":false,"autocomplete":false},"skins":[{"name":"skin3d","title":"3D Classic","3d":true,"preload":["smoothedfilegeo|0|/res/ring-target.js","image|/res/images/cancel.png","image|/res/images/wikipedia.png","smoothedfilegeo|0|/res/staunton/pawn/pawn-classic.js","image|/res/staunton/pawn/pawn-diffusemap.jpg","image|/res/staunton/pawn/pawn-normalmap.jpg","smoothedfilegeo|0|/res/staunton/knight/knight.js","image|/res/staunton/knight/knight-diffusemap.jpg","image|/res/staunton/knight/knight-normalmap.jpg","smoothedfilegeo|0|/res/staunton/bishop/bishop.js","image|/res/staunton/bishop/bishop-diffusemap.jpg","image|/res/staunton/bishop/bishop-normalmap.jpg","smoothedfilegeo|0|/res/staunton/rook/rook.js","image|/res/staunton/rook/rook-diffusemap.jpg","image|/res/staunton/rook/rook-normalmap.jpg","smoothedfilegeo|0|/res/staunton/queen/queen.js","image|/res/staunton/queen/queen-diffusemap.jpg","image|/res/staunton/queen/queen-normalmap.jpg","smoothedfilegeo|0|/res/staunton/king/king.js","image|/res/staunton/king/king-diffusemap.jpg","image|/res/staunton/king/king-normalmap.jpg"],"world":{"lightIntensity":1.3,"skyLightIntensity":1.2,"lightCastShadow":true,"fog":false,"color":4686804,"lightPosition":{"x":-9,"y":9,"z":9},"skyLightPosition":{"x":9,"y":9,"z":9},"lightShadowDarkness":0.55,"ambientLightColor":2236962},"camera":{"fov":45,"distMax":50,"radius":18,"elevationAngle":60,"elevationMin":0}},{"name":"skin2d","title":"2D Classic","3d":false,"preload":["image|/res/images/cancel.png","image|/res/images/whitebg.png","image|/res/images/wikipedia.png"]}],"animateSelfMoves":false,"switchable":true,"sounds":{"move1":"alq_move1","move2":"alq_move2","move3":"alq_move3","move4":"alq_move2","tac1":"alq_tac1","tac2":"alq_tac2","tac3":"alq_tac1","promo":"promo","usermove":null},"js":["base-view.js","grid-board-view.js","staunton-set-view.js","chess960-view.js"],"visuals":{"600x600":["res/visuals/chess960-600x600-3d.jpg","res/visuals/chess960-600x600-2d.jpg"]}}}

/***/ }),

/***/ "BsnN":
/***/ (function(module, exports) {

exports.config = {"status":true,"model":{"plazza":"true","title-en":"Five In A Row","module":"fourinarow","js":["fiarbase-model.js"],"summary":"Variant of Four In A Row","thumbnail":"fiar-thumb.png","rules":{"en":"rules.html","fr":"rules-fr.html"},"description":{"en":"description.html","fr":"description-fr.html"},"credits":{"en":"credits.html","fr":"credits-fr.html"},"gameOptions":{"width":9,"height":6,"lines":5,"remove":false,"levelOptions":{"evalTuple1":1,"evalTuple2":2,"evalTuple3":4,"evalTuple4":8,"evalTuple5":16,"evalTuple6":32},"uctTransposition":"state","fillSides":true},"levels":[{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.55,"ignoreLeaf":false,"name":"easy","label":"Easy","maxNodes":1000,"isDefault":true},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.55,"ignoreLeaf":false,"name":"fast","label":"Fast [1sec]","maxDuration":1},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.55,"ignoreLeaf":false,"name":"strong","label":"Strong","maxNodes":10000}]},"view":{"title-en":"Four In A Row View","module":"fourinarow","js":["fiarbase-xd-view.js"],"xdView":true,"css":["fiarbase.css"],"preferredRatio":1,"useShowMoves":false,"useNotation":true,"sounds":{"sound1":"sound1","sound2":"sound2"},"defaultOptions":{"sounds":true,"moves":true,"notation":false},"skins":[{"name":"fiar3d","title":"3D Classic","3d":true,"camera":{"radius":20,"limitCamMoves":true,"rotationAngle":180,"elevationAngle":0,"elevationMin":-89,"elevationMax":89,"distMax":30},"world":{"lightIntensity":0.2,"skyLightIntensity":0.2,"lightCastShadow":false,"fog":true,"color":0,"lightPosition":{"x":10,"y":5,"z":0},"lightShadowDarkness":0.55,"ambientLightColor":2236996},"preload":["map|/res/xd-view/meshes/connect4-red-star.png","map|/res/xd-view/meshes/connect4-red.png","map|/res/xd-view/meshes/connect4-yellow-star.png","map|/res/xd-view/meshes/connect4-yellow.png","smoothedfilegeo|0|/res/xd-view/meshes/connect4cell.js","smoothedfilegeo|0|/res/xd-view/meshes/connect4cell-ring-smoothed.js","smoothedfilegeo|0|/res/xd-view/meshes/connect4-token.js","smoothedfilegeo|0|/res/xd-view/meshes/connect4cell-foot.js"]},{"name":"fiar2d","title":"2D Classic","3d":false,"preload":["image|/res/sprites2d.png"]}],"animateSelfMoves":false,"visuals":{"600x600":["res/visuals/fiveinarow-600x600-3d.jpg","res/visuals/fiveinarow-600x600-2d.jpg"]}}}

/***/ }),

/***/ "C0+T":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var AsyncScheduler_1 = __webpack_require__("9Avi");
var QueueScheduler = (function (_super) {
    __extends(QueueScheduler, _super);
    function QueueScheduler() {
        _super.apply(this, arguments);
    }
    return QueueScheduler;
}(AsyncScheduler_1.AsyncScheduler));
exports.QueueScheduler = QueueScheduler;
//# sourceMappingURL=QueueScheduler.js.map

/***/ }),

/***/ "C4lF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__("mmVS");
var noop_1 = __webpack_require__("YOd+");
/**
 * Ignores all items emitted by the source Observable and only passes calls of `complete` or `error`.
 *
 * <img src="./img/ignoreElements.png" width="100%">
 *
 * @return {Observable} An empty Observable that only calls `complete`
 * or `error`, based on which one is called by the source Observable.
 * @method ignoreElements
 * @owner Observable
 */
function ignoreElements() {
    return this.lift(new IgnoreElementsOperator());
}
exports.ignoreElements = ignoreElements;
;
var IgnoreElementsOperator = (function () {
    function IgnoreElementsOperator() {
    }
    IgnoreElementsOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new IgnoreElementsSubscriber(subscriber));
    };
    return IgnoreElementsOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var IgnoreElementsSubscriber = (function (_super) {
    __extends(IgnoreElementsSubscriber, _super);
    function IgnoreElementsSubscriber() {
        _super.apply(this, arguments);
    }
    IgnoreElementsSubscriber.prototype._next = function (unused) {
        noop_1.noop();
    };
    return IgnoreElementsSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=ignoreElements.js.map

/***/ }),

/***/ "C8PP":
/***/ (function(module, exports) {

exports.config = {"status":true,"model":{"plazza":"true","released":1401461778,"title-en":"Shatranj","module":"chessbase","summary":"Ancient Chess","thumbnail":"shatranj-thumb.png","rules":{"en":"shatranj-rules.html"},"credits":{"en":"shatranj-credits.html"},"gameOptions":{"preventRepeat":true,"uctTransposition":"state","uctIgnoreLoop":false,"levelOptions":{"pieceValueFactor":1,"pieceValueRatioFactor":1,"posValueFactor":0.1,"averageDistKingFactor":-0.01,"castleFactor":0.1,"minorPiecesMovedFactor":0.1,"checkFactor":0.2,"endingKingFreedomFactor":0.01,"endingDistKingFactor":0.05,"distKingCornerFactor":0.1,"distPawnPromo1Factor":0.15,"distPawnPromo2Factor":0.05,"distPawnPromo3Factor":0.025}},"obsolete":false,"js":["base-model.js","grid-geo-model.js","shatranj-model.js"],"description":{"en":"shatranj-description.html"},"levels":[{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"easy","label":"Easy","maxNodes":1000},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"fast","label":"Fast [1sec]","maxDuration":1,"isDefault":true},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"medium","label":"Medium","maxNodes":10000,"maxDuration":10},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"strong","label":"Strong","maxNodes":20000,"maxDuration":15}]},"view":{"title-en":"Chessbase view","module":"chessbase","xdView":true,"css":["chessbase.css"],"preferredRatio":1,"useShowMoves":true,"useNotation":true,"useAutoComplete":true,"defaultOptions":{"sounds":true,"moves":true,"notation":false,"autocomplete":false},"skins":[{"name":"skin3d","title":"3D Classic","3d":true,"preload":["smoothedfilegeo|0|/res/ring-target.js","image|/res/images/cancel.png","smoothedfilegeo|0|/res/nishapur/pawn/pawn.js","image|/res/nishapur/pawn/pawn-diffusemap.jpg","image|/res/nishapur/pawn/pawn-normalmap.jpg","smoothedfilegeo|0|/res/nishapur/knight/knight.js","image|/res/nishapur/knight/knight-diffusemap.jpg","image|/res/nishapur/knight/knight-normalmap.jpg","smoothedfilegeo|0|/res/nishapur/elephant/elephant.js","image|/res/nishapur/elephant/elephant-diffusemap.jpg","image|/res/nishapur/elephant/elephant-normalmap.jpg","smoothedfilegeo|0|/res/nishapur/rook/rook.js","image|/res/nishapur/rook/rook-diffusemap.jpg","image|/res/nishapur/rook/rook-normalmap.jpg","smoothedfilegeo|0|/res/nishapur/general/general.js","image|/res/nishapur/general/general-diffusemap.jpg","image|/res/nishapur/general/general-normalmap.jpg","smoothedfilegeo|0|/res/nishapur/king/king.js","image|/res/nishapur/king/king-diffusemap.jpg","image|/res/nishapur/king/king-normalmap.jpg","image|/res/images/wikipedia.png","image|/res/images/wood-chipboard-2.jpg"],"world":{"lightIntensity":0.8,"skyLightIntensity":0.4,"lightCastShadow":false,"fog":false,"color":4686804,"lightPosition":{"x":-10,"y":5,"z":0},"skyLightPosition":{"x":9,"y":9,"z":9},"lightShadowDarkness":0.85,"ambientLightColor":1118481},"camera":{"fov":45,"distMax":50,"radius":18,"elevationAngle":60,"elevationMin":0}},{"name":"skin2d","title":"2D Classic","3d":false,"preload":["image|/res/images/cancel.png","image|/res/images/whitebg.png","image|/res/images/wikipedia.png","image|/res/images/wood-chipboard-2.jpg","image|/res/nishapur/nishapur-2d-sprites.png"]}],"animateSelfMoves":false,"switchable":true,"sounds":{"move1":"alq_move1","move2":"alq_move2","move3":"alq_move3","move4":"alq_move2","tac1":"alq_tac1","tac2":"alq_tac2","tac3":"alq_tac1","promo":"promo","usermove":null},"js":["base-view.js","grid-board-view.js","shatranj-board-view.js","nishapur-set-view.js","shatranj-view.js"],"visuals":{"600x600":["res/visuals/shatranj-600x600-3d.jpg","res/visuals/shatranj-600x600-2d.jpg"]}}}

/***/ }),

/***/ "C9pF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("3j3K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base__ = __webpack_require__("TwGT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__media_query_media_monitor__ = __webpack_require__("bWt6");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FlexOrderDirective; });
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */



/**
 * 'flex-order' flexbox styling directive
 * Configures the positional ordering of the element in a sorted layout container
 * @see https://css-tricks.com/almanac/properties/o/order/
 */
var FlexOrderDirective = (function (_super) {
    __extends(FlexOrderDirective, _super);
    /* tslint:enable */
    function FlexOrderDirective(monitor, elRef, renderer) {
        return _super.call(this, monitor, elRef, renderer) || this;
    }
    Object.defineProperty(FlexOrderDirective.prototype, "order", {
        /* tslint:disable */
        set: function (val) { this._cacheInput('order', val); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FlexOrderDirective.prototype, "orderXs", {
        set: function (val) { this._cacheInput('orderXs', val); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FlexOrderDirective.prototype, "orderSm", {
        set: function (val) { this._cacheInput('orderSm', val); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(FlexOrderDirective.prototype, "orderMd", {
        set: function (val) { this._cacheInput('orderMd', val); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(FlexOrderDirective.prototype, "orderLg", {
        set: function (val) { this._cacheInput('orderLg', val); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(FlexOrderDirective.prototype, "orderXl", {
        set: function (val) { this._cacheInput('orderXl', val); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(FlexOrderDirective.prototype, "orderGtXs", {
        set: function (val) { this._cacheInput('orderGtXs', val); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(FlexOrderDirective.prototype, "orderGtSm", {
        set: function (val) { this._cacheInput('orderGtSm', val); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(FlexOrderDirective.prototype, "orderGtMd", {
        set: function (val) { this._cacheInput('orderGtMd', val); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(FlexOrderDirective.prototype, "orderGtLg", {
        set: function (val) { this._cacheInput('orderGtLg', val); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(FlexOrderDirective.prototype, "orderLtSm", {
        set: function (val) { this._cacheInput('orderLtSm', val); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(FlexOrderDirective.prototype, "orderLtMd", {
        set: function (val) { this._cacheInput('orderLtMd', val); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(FlexOrderDirective.prototype, "orderLtLg", {
        set: function (val) { this._cacheInput('orderLtLg', val); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(FlexOrderDirective.prototype, "orderLtXl", {
        set: function (val) { this._cacheInput('orderLtXl', val); },
        enumerable: true,
        configurable: true
    });
    ;
    // *********************************************
    // Lifecycle Methods
    // *********************************************
    /**
     * For @Input changes on the current mq activation property, see onMediaQueryChanges()
     */
    FlexOrderDirective.prototype.ngOnChanges = function (changes) {
        if (changes['order'] != null || this._mqActivation) {
            this._updateWithValue();
        }
    };
    /**
     * After the initial onChanges, build an mqActivation object that bridges
     * mql change events to onMediaQueryChange handlers
     */
    FlexOrderDirective.prototype.ngOnInit = function () {
        var _this = this;
        this._listenForMediaQueryChanges('order', '0', function (changes) {
            _this._updateWithValue(changes.value);
        });
        this._updateWithValue();
    };
    // *********************************************
    // Protected methods
    // *********************************************
    FlexOrderDirective.prototype._updateWithValue = function (value) {
        value = value || this._queryInput("order") || '0';
        if (this._mqActivation) {
            value = this._mqActivation.activatedInput;
        }
        this._applyStyleToElement(this._buildCSS(value));
    };
    FlexOrderDirective.prototype._buildCSS = function (value) {
        value = parseInt(value, 10);
        return { order: isNaN(value) ? 0 : value };
    };
    return FlexOrderDirective;
}(__WEBPACK_IMPORTED_MODULE_1__base__["a" /* BaseFxDirective */]));

FlexOrderDirective.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{ selector: "\n  [fxFlexOrder],\n  [fxFlexOrder.xs], [fxFlexOrder.sm], [fxFlexOrder.md], [fxFlexOrder.lg], [fxFlexOrder.xl],\n  [fxFlexOrder.lt-sm], [fxFlexOrder.lt-md], [fxFlexOrder.lt-lg], [fxFlexOrder.lt-xl],\n  [fxFlexOrder.gt-xs], [fxFlexOrder.gt-sm], [fxFlexOrder.gt-md], [fxFlexOrder.gt-lg]\n" },] },
];
/** @nocollapse */
FlexOrderDirective.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_2__media_query_media_monitor__["a" /* MediaMonitor */], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer2"], },
]; };
FlexOrderDirective.propDecorators = {
    'order': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxFlexOrder',] },],
    'orderXs': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxFlexOrder.xs',] },],
    'orderSm': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxFlexOrder.sm',] },],
    'orderMd': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxFlexOrder.md',] },],
    'orderLg': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxFlexOrder.lg',] },],
    'orderXl': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxFlexOrder.xl',] },],
    'orderGtXs': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxFlexOrder.gt-xs',] },],
    'orderGtSm': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxFlexOrder.gt-sm',] },],
    'orderGtMd': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxFlexOrder.gt-md',] },],
    'orderGtLg': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxFlexOrder.gt-lg',] },],
    'orderLtSm': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxFlexOrder.lt-sm',] },],
    'orderLtMd': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxFlexOrder.lt-md',] },],
    'orderLtLg': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxFlexOrder.lt-lg',] },],
    'orderLtXl': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxFlexOrder.lt-xl',] },],
};
//# sourceMappingURL=flex-order.js.map

/***/ }),

/***/ "CGDc":
/***/ (function(module, exports, __webpack_require__) {

module.exports = exports = __webpack_require__("7vj1");


/***/ }),

/***/ "CGGv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var AsyncAction_1 = __webpack_require__("cwzr");
var AsyncScheduler_1 = __webpack_require__("9Avi");
/**
 *
 * Async Scheduler
 *
 * <span class="informal">Schedule task as if you used setTimeout(task, duration)</span>
 *
 * `async` scheduler schedules tasks asynchronously, by putting them on the JavaScript
 * event loop queue. It is best used to delay tasks in time or to schedule tasks repeating
 * in intervals.
 *
 * If you just want to "defer" task, that is to perform it right after currently
 * executing synchronous code ends (commonly achieved by `setTimeout(deferredTask, 0)`),
 * better choice will be the {@link asap} scheduler.
 *
 * @example <caption>Use async scheduler to delay task</caption>
 * const task = () => console.log('it works!');
 *
 * Rx.Scheduler.async.schedule(task, 2000);
 *
 * // After 2 seconds logs:
 * // "it works!"
 *
 *
 * @example <caption>Use async scheduler to repeat task in intervals</caption>
 * function task(state) {
 *   console.log(state);
 *   this.schedule(state + 1, 1000); // `this` references currently executing Action,
 *                                   // which we reschedule with new state and delay
 * }
 *
 * Rx.Scheduler.async.schedule(task, 3000, 0);
 *
 * // Logs:
 * // 0 after 3s
 * // 1 after 4s
 * // 2 after 5s
 * // 3 after 6s
 *
 * @static true
 * @name async
 * @owner Scheduler
 */
exports.async = new AsyncScheduler_1.AsyncScheduler(AsyncAction_1.AsyncAction);
//# sourceMappingURL=async.js.map

/***/ }),

/***/ "CGpv":
/***/ (function(module, exports) {

exports.model=Model={Game:{},Board:{},Move:{}},function(){var t;Model.Game.cbConstants={MASK:65535,FLAG_MOVE:65536,FLAG_CAPTURE:131072,FLAG_STOP:262144,FLAG_SCREEN_CAPTURE:524288,FLAG_CAPTURE_KING:1048576,FLAG_CAPTURE_NO_KING:2097152};var e="undefined"!=typeof Int32Array;Model.Game.cbUseTypedArrays=e,Model.Game.cbTypedArray=function(t){if(e){var r=new Int32Array(t.length);return r.set(t),r}for(var a=[],i=t.length,s=0;s<i;s++)a.push(t[s]);return a},Model.Game.cbShortRangeGraph=function(t,e,r,a){var i=this;void 0===a&&(a=196608);for(var s={},n=0;n<t.boardSize;n++)s[n]=[],(!r||n in r)&&e.forEach(function(e){var o=t.Graph(n,e);null!=o&&(!r||o in r)&&s[n].push(i.cbTypedArray([o|a]))});return s},Model.Game.cbLongRangeGraph=function(t,e,r,a,i){var s=this;void 0!==a&&null!=a||(a=196608),i||(i=1/0);for(var n={},o=0;o<t.boardSize;o++)n[o]=[],(!r||o in r)&&e.forEach(function(e){for(var h=[],p=t.Graph(o,e),c=0;null!=p&&(!r||p in r)&&(h.push(p|a),++c!=i);)p=t.Graph(p,e);h.length>0&&n[o].push(s.cbTypedArray(h))});return n},Model.Game.cbNullGraph=function(t){for(var e={},r=0;r<t.boardSize;r++)e[r]=[];return e},Model.Game.cbAuthorGraph=function(t){for(var e={},r=0;r<t.boardSize;r++){e[r]=[];for(var a=0;a<t.boardSize;a++)e[r].push([2293760|a])}return e},Model.Game.cbMergeGraphs=function(t){for(var e=[],r=0;r<t.boardSize;r++){e[r]=[];for(var a=1;a<arguments.length;a++)e[r]=e[r].concat(arguments[a][r])}return e},Model.Game.cbGetThreatGraph=function(){function t(e,r){for(var a in n){var i=n[a];if(!(i.p.length<r.length+1)){for(var s=!0,o=0;o<r.length;o++)if(r[o]!=i.p[o]){s=!1;break}if(s){var h=i.p[r.length],p=e[h];void 0===p&&(p={e:{}},e[h]=p),i.p.length==r.length+1&&(p.t=i.t,p.ts=i.ts,p.tk=i.tk,delete n[a]),r.push(h),t(p.e,r),r.pop()}}}}var e=this;this.cbUseScreenCapture=!1,this.cbUseCaptureKing=!1,this.cbUseCaptureNoKing=!1;for(var r={1:[],"-1":[]},a=[],i=0;i<this.g.boardSize;i++)this.g.pTypes.forEach(function(t,r){t.graph[i].forEach(function(t){for(var s=[],n=0;n<t.length;n++){var o=t[n];1048576&o?(e.cbUseCaptureKing=!0,s.unshift({d:65535&o,a:i,tk:r})):2097152&o?(e.cbUseCaptureNoKing=!0,s.unshift({d:65535&o,a:i,tnk:r})):131072&o?s.unshift({d:65535&o,a:i,t:r}):262144&o?s.unshift({d:65535&o,a:i}):524288&o&&(e.cbUseScreenCapture=!0,s.unshift({d:65535&o,a:i,ts:r}))}s.length>0&&a.push(s)})});var s={};a.forEach(function(t){t.forEach(function(e,r){var a=s[e.d];void 0===a&&(a={},s[e.d]=a);for(var i=[],n=r+1;n<t.length;n++)i.push(t[n].d);i.push(e.a);var o=i.join(","),h=a[o];void 0===h&&(h={p:i,t:{},ts:{},tk:{}},a[o]=h),void 0!==e.t?h.t[e.t]=!0:void 0!==e.tk?h.tk[e.tk]=!0:void 0!==e.ts&&(h.ts[e.ts]=!0)})});for(var i=0;i<e.g.boardSize;i++){var n=s[i],o={};t(o,[]),r[1][i]=o,r[-1][i]=o}return r},Model.Game.InitGame=function(){var e=this;this.cbVar=t=this.cbDefine(),this.g.boardSize=this.cbVar.geometry.boardSize,this.g.pTypes=this.cbGetPieceTypes(),this.g.threatGraph=this.cbGetThreatGraph(),this.g.distGraph=this.cbVar.geometry.GetDistances(),this.cbPiecesCount=0,this.g.castleablePiecesCount={1:0,"-1":0};for(var r in t.pieceTypes){var a=t.pieceTypes[r];if(a.castle){(a.initial||[]).forEach(function(t){e.g.castleablePiecesCount[t.s]++})}a.initial&&(this.cbPiecesCount+=a.initial.length)}for(var i=[],r=0;r<this.cbPiecesCount;r++)i.push(r);var s=Object.keys(t.pieceTypes);this.zobrist=new JocGame.Zobrist({board:{type:"array",size:this.cbVar.geometry.boardSize,values:i},who:{values:["1","-1"]},type:{type:"array",size:this.cbPiecesCount,values:s}})},Model.Game.cbGetPieceTypes=function(){for(var t=[],e={},r=0;r<this.cbVar.geometry.boardSize;r++)e[r]=[];for(var a in this.cbVar.pieceTypes){var i=this.cbVar.pieceTypes[a];t[a]={graph:i.graph||e,abbrev:i.abbrev||"",value:i.isKing?100:i.value||1,isKing:!!i.isKing,castle:!!i.castle,epTarget:!!i.epTarget,epCatch:!!i.epCatch}}return t},Model.Board.Init=function(t){this.zSign=0},Model.Board.InitialPosition=function(r){var a=this;this.board=e?new Int16Array(r.g.boardSize):[];for(var i=0;i<r.g.boardSize;i++)this.board[i]=-1;if(this.kings={},this.pieces=[],this.ending={1:!1,"-1":!1},this.lastMove=null,r.cbVar.castle&&(this.castled={1:!1,"-1":!1}),this.zSign=r.zobrist.update(0,"who",-1),this.noCaptCount=0,this.mWho=1,r.mInitial)this.mWho=r.mInitial.turn||1,r.mInitial.pieces.forEach(function(t){var e={};for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);a.pieces.push(e)}),r.mInitial.lastMove&&(this.lastMove={f:r.mInitial.lastMove.f,t:r.mInitial.lastMove.t}),void 0!==r.mInitial.noCaptCount&&(this.noCaptCount=r.mInitial.noCaptCount),r.cbVar.castle&&r.mInitial.castle&&(this.castled={1:{k:!!r.mInitial.castle[1]&&!!r.mInitial.castle[1].k,q:!!r.mInitial.castle[1]&&!!r.mInitial.castle[1].q},"-1":{k:!!r.mInitial.castle[-1]&&!!r.mInitial.castle[-1].k,q:!!r.mInitial.castle[-1]&&!!r.mInitial.castle[-1].q}});else for(var s in r.cbVar.pieceTypes)for(var n=r.cbVar.pieceTypes[s],o=n.initial||[],h=0;h<o.length;h++){var p=o[h],c={s:p.s,t:parseInt(s),p:p.p,m:!1};this.pieces.push(c)}if(this.pieces.sort(function(t,e){if(t.s!=e.s)return e.s-t.s;var a=r.cbVar.pieceTypes[t.t].value||100,i=r.cbVar.pieceTypes[e.t].value||100;return a!=i?a-i:t.p-e.p}),this.pieces.forEach(function(t,e){t.i=e,a.board[t.p]=e,r.g.pTypes[t.t].isKing&&(a.kings[t.s]=t.p),a.zSign=r.zobrist.update(a.zSign,"board",e,t.p),a.zSign=r.zobrist.update(a.zSign,"type",t.t,e)}),r.mInitial&&r.mInitial.enPassant){var i=t.geometry.PosByName(r.mInitial.enPassant);if(i>=0){var l,u=t.geometry.C(i),b=t.geometry.R(i);l=1==r.mInitial.turn?t.geometry.POS(u,b-1):t.geometry.POS(u,b+1),this.epTarget={p:i,i:this.board[l]}}}},Model.Board.CopyFrom=function(t){if(e)this.board=new Int16Array(t.board.length),this.board.set(t.board);else{this.board=[];for(var r=t.board,a=r.length,i=0;i<a;i++)this.board.push(r[i])}this.pieces=[];for(var s=t.pieces.length,i=0;i<s;i++){var n=t.pieces[i];this.pieces.push({s:n.s,p:n.p,t:n.t,i:n.i,m:n.m})}this.kings={1:t.kings[1],"-1":t.kings[-1]},this.check=t.check,t.lastMove?this.lastMove={f:t.lastMove.f,t:t.lastMove.t,c:t.lastMove.c}:this.lastMove=null,this.ending={1:t.ending[1],"-1":t.ending[-1]},void 0!==t.castled&&(this.castled={1:t.castled[1],"-1":t.castled[-1]}),this.noCaptCount=t.noCaptCount,t.epTarget?this.epTarget={p:t.epTarget.p,i:t.epTarget.i}:this.epTarget=null,this.mWho=t.mWho,this.zSign=t.zSign},Model.Board.cbApplyCastle=function(t,e,r){var a=t.cbVar.castle[e.f+"/"+e.cg],i=a.r[a.r.length-1],s=this.pieces[this.board[e.cg]],n=a.k[a.k.length-1],o=this.pieces[this.board[e.f]];return r&&(this.zSign=t.zobrist.update(this.zSign,"board",s.i,e.cg),this.zSign=t.zobrist.update(this.zSign,"board",s.i,i),this.zSign=t.zobrist.update(this.zSign,"board",o.i,e.f),this.zSign=t.zobrist.update(this.zSign,"board",o.i,n)),s.p=i,s.m=!0,this.board[e.cg]=-1,o.p=n,o.m=!0,this.board[e.f]=-1,this.board[i]=s.i,this.board[n]=o.i,this.castled[s.s]=!0,this.kings[o.s]=n,[{i:s.i,f:i,t:-1},{i:o.i,f:n,t:e.f,kp:e.f,who:o.s,m:!1},{i:s.i,f:-1,t:e.cg,m:!1,cg:!1}]},Model.Board.cbQuickApply=function(t,e){if(void 0!==e.cg)return this.cbApplyCastle(t,e,!1);var r=[],a=this.board[e.f],i=this.pieces[a];if(null!=e.c){r.unshift({i:e.c,f:-1,t:this.pieces[e.c].p});var s=this.pieces[e.c];this.board[s.p]=-1,s.p=-1}var n=this.kings[i.s];return t.g.pTypes[i.t].isKing&&(this.kings[i.s]=e.t),r.unshift({i:a,f:e.t,t:e.f,kp:n,who:i.s,ty:i.t}),i.p=e.t,void 0!==e.pr&&(i.t=e.pr),this.board[e.f]=-1,this.board[e.t]=a,r},Model.Board.cbQuickUnapply=function(t,e){for(var r=0;r<e.length;r++){var a=e[r],i=this.pieces[a.i];a.f>=0&&(i.p=-1,this.board[a.f]=-1),a.t>=0&&(i.p=a.t,this.board[a.t]=a.i),void 0!==a.m&&(i.m=a.m),void 0!==a.kp&&(this.kings[a.who]=a.kp),void 0!=a.ty&&(i.t=a.ty),void 0!=a.cg&&(this.castled[i.s]=a.cg)}},Model.Board.ApplyMove=function(t,e){var r=this.pieces[this.board[e.f]];if(void 0!==e.cg)this.cbApplyCastle(t,e,!0);else{if(this.zSign=t.zobrist.update(this.zSign,"board",r.i,e.f),this.board[r.p]=-1,void 0!==e.pr&&(this.zSign=t.zobrist.update(this.zSign,"type",r.t,r.i),r.t=e.pr,this.zSign=t.zobrist.update(this.zSign,"type",r.t,r.i)),null!=e.c){var a=this.pieces[e.c];this.zSign=t.zobrist.update(this.zSign,"board",a.i,a.p),this.board[a.p]=-1,a.p=-1,a.m=!0,this.noCaptCount=0}else this.noCaptCount++;r.p=e.t,r.m=!0,this.board[e.t]=r.i,this.zSign=t.zobrist.update(this.zSign,"board",r.i,e.t),t.g.pTypes[r.t].isKing&&(this.kings[r.s]=e.t)}this.check=!!e.ck,this.lastMove={f:e.f,t:e.t,c:e.c},void 0!==e.ko&&(this.ending[r.s]=e.ko),void 0!==e.ept?this.epTarget={p:e.ept,i:r.i}:this.epTarget=null,this.zSign=t.zobrist.update(this.zSign,"who",-this.mWho),this.zSign=t.zobrist.update(this.zSign,"who",this.mWho)},Model.Board.Evaluate=function(r){function a(e){var r=1/0;for(var a in t.geometry.corners)r=Math.min(r,h.distGraph[s.kings[e]][a]);return r-Math.sqrt(h.boardSize)}var i="debug"==arguments[3],s=this;this.mEvaluation=0;var n,o=this.mWho,h=r.g;if(e)n={1:{count:new Uint8Array(h.pTypes.length),byType:{}},"-1":{count:new Uint8Array(h.pTypes.length),byType:{}}};else{n={1:{count:[],byType:{}},"-1":{count:[],byType:{}}};for(var p=0;p<h.pTypes.length;p++)n[1].count[p]=n[-1].count[p]=0}if(r.mOptions.preventRepeat&&r.GetRepeatOccurence(this)>2)return this.mFinished=!0,void(this.mWinner=r.cbOnPerpetual?o*r.cbOnPerpetual:JocGame.DRAW);for(var c={1:0,"-1":0},l={1:h.distGraph[this.kings[-1]],"-1":h.distGraph[this.kings[1]]},u={1:0,"-1":0},b={1:0,"-1":0},v={1:0,"-1":0},f={1:0,"-1":0},g={1:!1,"-1":!1},d=this.pieces,m=d.length,p=0;p<m;p++){var G=d[p];if(G.p>=0){var y=G.s,M=h.pTypes[G.t];M.isKing?g[y]=G.m:c[y]+=M.value,M.castle&&!G.m&&f[y]++,b[y]++,u[y]+=l[y][G.p],v[y]+=t.geometry.distEdge[G.p];var C=n[y];C.count[G.t]++;var S=C.byType;void 0===S[G.t]?S[G.t]=[G]:S[G.t].push(G)}}if(this.lastMove&&null!=this.lastMove.c){var G=this.pieces[this.board[this.lastMove.t]];c[-G.s]+=this.cbStaticExchangeEval(r,G.p,G.s,{piece:G})}var k={1:0,"-1":0},A={1:0,"-1":0},T={1:0,"-1":0};this.ending[1]&&(A[1]=(u[1]-Math.sqrt(h.boardSize))/b[1],t.geometry.corners&&(T[1]=a(1))),this.ending[-1]&&(A[-1]=(u[-1]-Math.sqrt(h.boardSize))/b[-1],t.geometry.corners&&(T[1]=a(-1)));var z={pieceValue:c[1]-c[-1],pieceValueRatio:(c[1]-c[-1])/(c[1]+c[-1]+1),posValue:v[1]-v[-1],averageDistKing:u[1]/b[1]-u[-1]/b[-1],check:this.check?-o:0,endingKingFreedom:k[1]-k[-1],endingDistKing:A[1]-A[-1],distKingCorner:T[1]-T[-1]};t.castle&&(z.castle=(this.castled[1]?1:g[1]?0:f[1]/(h.castleablePiecesCount[1]+1))-(this.castled[-1]?1:g[-1]?0:f[-1]/(h.castleablePiecesCount[-1]+1))),t.evaluate&&t.evaluate.call(this,r,z,n);var E=r.mOptions.levelOptions;for(var P in z){var w=z[P],R=E[P+"Factor"]||0,I=w*R;i&&console.log(P,"=",w,"*",R,"=>",I),this.mEvaluation+=I}i&&console.log("Evaluation",this.mEvaluation)},Model.Board.cbGeneratePseudoLegalMoves=function(t){function e(e,i){var s=t.cbVar.promote;if(!s)return void a.push(i);var n=s.call(r,t,e,i);if(null!=n)if(0==n.length)a.push(i);else if(1==n.length)i.pr=n[0],a.push(i);else for(var o=0;o<n.length;o++){var h=n[o];a.push({f:i.f,t:i.t,c:i.c,pr:h,ept:i.ept,ep:i.ep,a:i.a})}}for(var r=this,a=[],i=t.cbVar,s=this.mWho,n=!i.castle||this.check||this.castled[s]?null:[],o=-1,h=this.pieces.length,p=0;p<h;p++){var c=this.pieces[p];if(!(c.p<0||c.s!=s)){var l=t.g.pTypes[c.t];l.isKing&&(c.m?n=null:o=c),n&&l.castle&&!c.m&&n.push(c);var u,b;u=l.graph[c.p],b=u.length;for(var v=0;v<b;v++)for(var f=u[v],g=!1,d=f.length,m=null,G=0;G<d;G++){var y=f[G],M=65535&y,C=this.board[M];if(!(C<0)||l.epCatch&&this.epTarget&&this.epTarget.p==M){if(!(524288&y)){var S;S=C<0?this.pieces[this.epTarget.i]:this.pieces[C],!(S.s!=c.s&&131072&y)||1048576&y&&!t.g.pTypes[S.t].isKing||2097152&y&&t.g.pTypes[S.t].isKing||e(c,{f:c.p,t:M,c:S.i,a:l.abbrev,ep:C<0});break}if(g){var S=this.pieces[C];S.s!=c.s&&e(c,{f:c.p,t:M,c:S.i,a:l.abbrev});break}g=!0}else 65536&y&&0==g&&e(c,{f:c.p,t:M,c:null,a:l.abbrev,ept:null!=m&&l.epTarget?m:void 0});m=M}}}if(n)for(var p=0;p<n.length;p++){var k=n[p],A=t.cbVar.castle[o.p+"/"+k.p];if(A){for(var T=!0,v=0;v<A.r.length;v++){var z=A.r[v];if(this.board[z]>=0&&z!=o.p&&z!=k.p){T=!1;break}}if(T){for(var E=!0,v=0;v<A.k.length;v++){var z=A.k[v];if(this.board[z]>=0&&z!=k.p&&z!=o.p||this.cbGetAttackers(t,z,s).length>0){E=!1;break}}E&&a.push({f:o.p,t:A.k[A.k.length-1],c:null,cg:k.p})}}}return a},Model.Board.cbStaticExchangeEval=function(t,e,r,a){var i=0,s=this.cbGetSmallestAttacker(t,e,r);if(s){var n=this.mWho;this.mWho=s.s;var o=this.cbQuickApply(t,{f:s.p,t:e,c:a.piece.i}),h=t.g.pTypes[a.piece.t].value;a.piece=s,i=Math.max(0,h-this.cbStaticExchangeEval(t,e,-r,a)),this.cbQuickUnapply(t,o),this.mWho=n}return i},Model.Board.cbGetSmallestAttacker=function(t,e,r){var a=this.cbGetAttackers(t,e,r);if(0==a.length)return null;for(var i=1/0,s=null,n=a.length,o=0;o<n;o++){var h=a[o],p=t.g.pTypes[h.t].value;p<i&&(i=p,s=h)}return s},Model.Board.cbCollectAttackers=function(t,e,r,a){for(var i in e){var s=e[i],n=this.board[i];if(n<0)this.cbCollectAttackers(t,s.e,r,a);else{var o=this.pieces[n];o.s==-t&&(s.t&&o.t in s.t||a&&s.tk&&o.t in s.tk)&&r.push(o)}}},Model.Board.cbCollectAttackersScreen=function(t,e,r,a,i){for(var s in e){var n=e[s],o=this.board[s];if(o<0)this.cbCollectAttackersScreen(t,n.e,r,a,i);else{var h=this.pieces[o];!i&&h.s==-t&&(n.t&&h.t in n.t||a&&n.tk&&h.t in n.tk)?r.push(h):i?i&&h.s==-t&&n.ts&&h.t in n.ts&&r.push(h):this.cbCollectAttackersScreen(t,n.e,r,a,!0)}}},Model.Board.cbGetAttackers=function(t,e,r,a){var i=[];return t.cbUseScreenCapture?this.cbCollectAttackersScreen(r,t.g.threatGraph[r][e],i,a,!1):this.cbCollectAttackers(r,t.g.threatGraph[r][e],i,a),i},Model.Board.GenerateMoves=function(t){var e=this.cbGeneratePseudoLegalMoves(t);this.mMoves=[];for(var r=!0,a=this.kings[this.mWho],i=e.length,s=0;s<i;s++){var n=e[s],o=this.cbQuickApply(t,n);if(!(this.cbGetAttackers(t,this.kings[this.mWho],this.mWho,!0).length>0)){var h=this.cbGetAttackers(t,this.kings[-this.mWho],-this.mWho,!0).length>0;n.ck=h,this.mMoves.push(n),n.f!=a&&(r=!1)}this.cbQuickUnapply(t,o)}if(0==this.mMoves.length)this.mFinished=!0,this.mWinner=t.cbOnStaleMate?t.cbOnStaleMate*this.mWho:JocGame.DRAW,this.check&&(this.mWinner=-this.mWho);else if(this.ending[this.mWho]){if(!r)for(var s=0;s<this.mMoves.length;s++)this.mMoves[s].ko=!1}else if(!this.ending[this.mWho]&&r&&!this.check)for(var s=0;s<this.mMoves.length;s++)this.mMoves[s].ko=!0},Model.Board.GetSignature=function(){return this.zSign},Model.Move.Init=function(t){for(var e in t)t.hasOwnProperty(e)&&(this[e]=t[e])},Model.Move.Equals=function(t){return this.f==t.f&&this.t==t.t&&this.pr==t.pr},Model.Move.CopyFrom=function(t){this.Init(t)},Model.Move.ToString=function(e){var r=this;switch(e=e||"natural"){case"natural":return function(){var e;if(void 0!==r.cg?e=t.castle[r.f+"/"+r.cg].n:(e=r.a||"",e+=t.geometry.PosName(r.f),null==r.c?e+="-":e+="x",e+=t.geometry.PosName(r.t)),void 0!==r.pr){var a=t.pieceTypes[r.pr];a&&a.abbrev&&a.abbrev.length>0&&!a.silentPromo&&(e+="="+a.abbrev)}return r.ck&&(e+="+"),e}();case"engine":return function(){var e=t.geometry.PosName(r.f)+t.geometry.PosName(r.t);if(void 0!=r.pr){var a=t.pieceTypes[r.pr];a&&a.abbrev&&a.abbrev.length>0&&!a.silentPromo&&(e+=a.abbrev)}return e}();default:return"??"}},Model.Board.CompactMoveString=function(e,r,a){"function"!=typeof r.ToString&&(r=e.CreateMove(r));var i=r.ToString(),s=/^([A-Z]?)([a-z])([1-9][0-9]*)([-x])([a-z])([1-9][0-9]*)(.*?)$/.exec(i);if(!s)return i;var n=s[7];if(a||(a={}),a.value||(a.value=[]),0==a.value.length){var o=this.mMoves;this.mMoves&&0!=this.mMoves.length||this.GenerateMoves(e);for(var h=0;h<this.mMoves.length;h++){var p=this.mMoves[h];"function"!=typeof p.ToString&&(p=e.CreateMove(p)),a.value.push({str:p.ToString(),move:p})}this.mMoves=o}var c=[];if(a.value.forEach(function(t){var e=/^([A-Z]?[a-z][1-9][0-9]*[-x][a-z][1-9][0-9]*)(.*?)$/.exec(t.str);e&&t.move.t==r.t&&(t.move.a||"")==s[1]&&e[2]==n&&c.push(t.move)}),1==c.length)return""==s[1]&&"x"==s[4]?s[2]+"x"+s[5]+s[6]+s[7]:s[1]+("x"==s[4]?"x":"")+s[5]+s[6]+s[7];if(t.geometry.CompactCrit)for(var l="",h=0;;h++){var u=t.geometry.CompactCrit(r.f,h);if(null==u)return i;l+=u;for(var b=[],v=0;v<c.length;v++){var f=c[v];t.geometry.CompactCrit(f.f,h)==u&&b.push(f)}if(console.assert(b.length>0),1==b.length)return s[1]+l+("x"==s[4]?"x":"")+s[5]+s[6]+s[7];c=b}return i},Model.Board.cbIntegrity=function(t){function e(t,e){t||console.error(e)}for(var r=this,a=0;a<this.board.length;a++){var i=this.board[a];if(i>=0){var s=r.pieces[i];e(void 0!==s,"no piece at pos"),e(s.p==a,"piece has different pos")}}for(var i=0;i<this.pieces.length;i++){var s=this.pieces[i];s.p>=0&&e(r.board[s.p]==i,"board index mismatch")}},Model.Board.ExportBoardState=function(t){return t.cbVar.geometry.ExportBoardState?t.cbVar.geometry.ExportBoardState(this,t.cbVar,t.mPlayedMoves.length):"not supported"},Model.Game.Import=function(e,r){var a,i=[],s={1:{},"-1":{}},n=null,o=0;if("pjn"==e){var h={status:!1,error:"parse"},p=r.split(" ");if(6!=p.length)return console.warn("FEN should have 6 parts"),h;var c=p[0].split("/"),l=t.geometry.fenHeight||t.geometry.height;if(c.length!=l)return console.warn("FEN board should have",l,"rows, got",c.length),h;var u={};for(var b in t.pieceTypes){var v=t.pieceTypes[b],f=v.fenAbbrev||v.abbrev||"X";u[f.toUpperCase()]={s:1,t:b},u[f.toLowerCase()]={s:-1,t:b}}var g=t.geometry.FenRowPos||function(e,r){return(t.geometry.height-1-e)*t.geometry.width+r};if(c.forEach(function(e,r){for(var a=0,s=0;s<e.length;s++){var n=e.substr(s,1),o=u[n];if(void 0!==o){var p=g(r,a);a++;for(var c={s:o.s,t:o.t,p:p},l=!0,b=t.pieceTypes[c.t].initial||[],v=0;v<b.length;v++){var f=b[v];f.s==c.s&&f.p==p&&(l=!1)}c.m=l,i.push(c)}else{if(isNaN(parseInt(n)))return console.warn("FEN invalid board spec",n),h;a+=parseInt(n)}}}),i.sort(function(t,e){return e.s-t.s}),"w"==p[1])a=1;else{if("b"!=p[1])return console.warn("FEN invalid turn spec",p[1]),h;a=-1}s[1].k=p[2].indexOf("K")>=0,s[1].q=p[2].indexOf("Q")>=0,s[-1].k=p[2].indexOf("k")>=0,s[-1].q=p[2].indexOf("q")>=0,n="-"==p[3]?null:p[3];var d=parseInt(p[4]);isNaN(d)||(o=d);var m={pieces:i,turn:a,castle:s,enPassant:n,noCaptCount:o};return t.importGame&&t.importGame.call(this,m,e,r),{status:!0,initial:m}}return{status:!1,error:"unsupported"}}}(),function(){Model.Game.cbBoardGeometryGrid=function(t,e){function r(e){return e%t}function a(e){return Math.floor(e/t)}function i(e,r){return r*t+e}function s(s,n){var o=r(s),h=a(s),p=o+n[0],c=h+n[1];return p<0||p>=t||c<0||c>=e?null:i(p,c)}function n(t){return String.fromCharCode("a".charCodeAt(0)+r(t))+(a(t)+1)}function o(t){var e=/^([a-z])([0-9]+)$/.exec(t);return e?i(e[1].charCodeAt(0)-"a".charCodeAt(0),parseInt(e[2])-1):-1}function h(t,e){return 0==e?String.fromCharCode("a".charCodeAt(0)+r(t)):1==e?a(t)+1:null}function p(){for(var i=[],s=0;s<t*e;s++){var n=[];i.push(n);for(var o=0;o<t*e;o++){var h=a(s),p=r(s),c=a(o),l=r(o);n.push(Math.max(Math.abs(h-c),Math.abs(p-l)))}}return i}function c(r,a,s){for(var o=[],h=e-1;h>=0;h--){for(var p="",c=0,l=0;l<t;l++){var u=r.board[i(l,h)];if(u<0)c++;else{c>0&&(p+=c,c=0);var b=r.pieces[u],v=a.pieceTypes[b.t].fenAbbrev||a.pieceTypes[b.t].abbrev||"?";b.s==-1?p+=v.toLowerCase():p+=v.toUpperCase()}}c&&(p+=c),o.push(p)}var f=o.join("/");f+=" ",1==r.mWho?f+="w":f+="b",f+=" ";var g="";return r.castled&&(r.castled[1]===!1?g+="KQ":(r.castled[1].k&&(g+="K"),r.castled[1].q&&(g+="Q")),r.castled[-1]===!1?g+="kq":(r.castled[-1].k&&(g+="k"),r.castled[-1].q&&(g+="q"))),0==g.length&&(g="-"),f+=g,f+=" ",r.epTarget?f+=n(r.epTarget.p):f+="-",f+=" ",f+=r.noCaptCount,f+=" ",f+=Math.floor(s/2)+1}return{boardSize:t*e,width:t,height:e,C:r,R:a,POS:i,Graph:s,PosName:n,PosByName:o,CompactCrit:h,GetDistances:p,distEdge:function(){for(var i=[],s=0;s<t*e;s++){var n=r(s),o=a(s);i[s]=Math.min(n,Math.abs(t-n-1),o,Math.abs(e-o-1))}return i}(),corners:function(){var r={};return r[i(0,0)]=1,r[i(0,e-1)]=1,r[i(t-1,0)]=1,r[i(t-1,e-1)]=1,r}(),ExportBoardState:c}},Model.Game.cbPawnGraph=function(t,e,r){for(var a=this,i={},s=0;s<t.boardSize;s++)if(!r||s in r){var n=[],o=t.Graph(s,[0,e]);null!=o&&(!r||o in r)&&n.push(a.cbTypedArray([o|a.cbConstants.FLAG_MOVE])),[-1,1].forEach(function(i){var o=t.Graph(s,[i,e]);null!=o&&(!r||o in r)&&n.push(a.cbTypedArray([o|a.cbConstants.FLAG_CAPTURE]))}),i[s]=n}else i[s]=[];return i},Model.Game.cbInitialPawnGraph=function(t,e,r){for(var a=this,i={},s=0;s<t.boardSize;s++)if(!r||s in r){var n=[],o=t.Graph(s,[0,e]);if(null!=o&&(!r||o in r)){var h=[o|a.cbConstants.FLAG_MOVE],p=t.Graph(o,[0,e]);null!=p&&(!r||p in r)&&h.push(p|a.cbConstants.FLAG_MOVE),n.push(a.cbTypedArray(h))}[-1,1].forEach(function(i){var o=t.Graph(s,[i,e]);null!=o&&(!r||o in r)&&n.push(a.cbTypedArray([o|a.cbConstants.FLAG_CAPTURE]))}),i[s]=n}else i[s]=[];return i},Model.Game.cbKingGraph=function(t,e){return this.cbShortRangeGraph(t,[[-1,-1],[-1,0],[-1,1],[0,-1],[0,1],[1,-1],[1,0],[1,1]],e)},Model.Game.cbKnightGraph=function(t,e){return this.cbShortRangeGraph(t,[[2,-1],[2,1],[-2,-1],[-2,1],[-1,2],[-1,-2],[1,2],[1,-2]],e)},Model.Game.cbHorseGraph=function(t){for(var e=this,r={},a=0;a<t.boardSize;a++)r[a]=[],[[1,0,2,-1],[1,0,2,1],[-1,0,-2,-1],[-1,0,-2,1],[0,1,-1,2],[0,-1,-1,-2],[0,1,1,2],[0,-1,1,-2]].forEach(function(i){var s=t.Graph(a,[i[0],i[1]]);if(null!=s){var n=t.Graph(a,[i[2],i[3]]);null!=n&&r[a].push(e.cbTypedArray([s|e.cbConstants.FLAG_STOP,n|e.cbConstants.FLAG_MOVE|e.cbConstants.FLAG_CAPTURE]))}});return r},Model.Game.cbRookGraph=function(t,e){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0]],e)},Model.Game.cbBishopGraph=function(t,e){return this.cbLongRangeGraph(t,[[1,-1],[1,1],[-1,1],[-1,-1]],e)},Model.Game.cbQueenGraph=function(t,e){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0],[1,-1],[1,1],[-1,1],[-1,-1]],e)},Model.Game.cbXQGeneralGraph=function(t,e){for(var r=this,a={},i=0;i<t.boardSize;i++)a[i]=[],[[-1,0,!1],[0,-1,!0],[0,1,!0],[1,0,!1]].forEach(function(s){var n=[],o=t.Graph(i,s);if(null!=o&&((!e||o in e)&&n.push(o|r.cbConstants.FLAG_MOVE|r.cbConstants.FLAG_CAPTURE),s[2]))for(var h=t.Graph(o,s);null!=h;)!e||h in e?n.push(h|r.cbConstants.FLAG_CAPTURE|r.cbConstants.FLAG_CAPTURE_KING):n.push(h|r.cbConstants.FLAG_STOP),h=t.Graph(h,s);n.length>0&&a[i].push(r.cbTypedArray(n))});return a},Model.Game.cbXQSoldierGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e]])},Model.Game.cbXQPromoSoldierGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e],[-1,0],[1,0]])},Model.Game.cbXQAdvisorGraph=function(t,e){return this.cbShortRangeGraph(t,[[1,1],[-1,1],[1,-1],[-1,-1]],e)},Model.Game.cbXQCannonGraph=function(t){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0]],null,this.cbConstants.FLAG_MOVE|this.cbConstants.FLAG_SCREEN_CAPTURE)},Model.Game.cbXQElephantGraph=function(t,e){for(var r=this,a={},i=0;i<t.boardSize;i++)a[i]=[],(!e||i in e)&&[[1,1,2,2],[1,-1,2,-2],[-1,1,-2,2],[-1,-1,-2,-2]].forEach(function(s){var n=t.Graph(i,[s[0],s[1]]);if(null!=n){var o=t.Graph(i,[s[2],s[3]]);null!=o&&(!e||o in e)&&a[i].push(r.cbTypedArray([n|r.cbConstants.FLAG_STOP,o|r.cbConstants.FLAG_MOVE|r.cbConstants.FLAG_CAPTURE]))}});return a},Model.Game.cbSilverGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e],[-1,-1],[-1,1],[1,-1],[1,1]])},Model.Game.cbFersGraph=function(t,e){return this.cbShortRangeGraph(t,[[-1,-1],[-1,1],[1,-1],[1,1]])},Model.Game.cbSchleichGraph=function(t,e){return this.cbShortRangeGraph(t,[[-1,0],[1,0],[0,-1],[0,1]])},Model.Game.cbAlfilGraph=function(t,e){return this.cbShortRangeGraph(t,[[-2,-2],[-2,2],[2,2],[2,-2]])}}(),function(){function t(t,r){return t.cbMergeGraphs(e,t.cbLongRangeGraph(e,[[0,r]],null,t.cbConstants.FLAG_MOVE,3),t.cbShortRangeGraph(e,[[-1,r],[1,r]],null,t.cbConstants.FLAG_CAPTURE))}var e=Model.Game.cbBoardGeometryGrid(11,11);Model.Game.cbDefine=function(){return{geometry:e,pieceTypes:{0:{name:"pawn-w",aspect:"fr-pawn",graph:this.cbPawnGraph(e,1),value:1,abbrev:"",fenAbbrev:"P",epCatch:!0},1:{name:"ipawn-w",aspect:"fr-pawn",graph:this.cbInitialPawnGraph(e,1),value:1,abbrev:"",fenAbbrev:"P",epTarget:!0},2:{name:"pawn-b",aspect:"fr-pawn",graph:this.cbPawnGraph(e,-1),value:1,abbrev:"",fenAbbrev:"P",epCatch:!0},3:{name:"ipawn-b",aspect:"fr-pawn",graph:this.cbInitialPawnGraph(e,-1),value:1,abbrev:"",fenAbbrev:"P",epTarget:!0},4:{name:"knight",aspect:"fr-knight",graph:this.cbKnightGraph(e),value:2.9,abbrev:"N",initial:[{s:1,p:2},{s:1,p:9},{s:-1,p:112},{s:-1,p:119}]},5:{name:"bishop",aspect:"fr-bishop",graph:this.cbBishopGraph(e),value:3.1,abbrev:"B",initial:[{s:1,p:1},{s:1,p:8},{s:-1,p:111},{s:-1,p:118}]},6:{name:"rook",aspect:"fr-rook",graph:this.cbRookGraph(e),value:5,abbrev:"R",initial:[{s:1,p:0},{s:1,p:10},{s:-1,p:110},{s:-1,p:120}],castle:!0},7:{name:"queen",aspect:"fr-queen",graph:this.cbQueenGraph(e),value:9,abbrev:"Q",initial:[{s:1,p:6},{s:-1,p:116}]},8:{name:"king",aspect:"fr-king",isKing:!0,graph:this.cbKingGraph(e),abbrev:"K",initial:[{s:1,p:5},{s:-1,p:115}]},9:{name:"commander",aspect:"fr-amazon",graph:this.cbMergeGraphs(e,this.cbQueenGraph(e),this.cbKnightGraph(e)),value:12,abbrev:"C",initial:[{s:1,p:4},{s:-1,p:114}]},10:{name:"adjutant",aspect:"fr-cardinal",graph:this.cbMergeGraphs(e,this.cbBishopGraph(e),this.cbKnightGraph(e)),value:6,abbrev:"A",initial:[{s:1,p:7},{s:-1,p:117}]},11:{name:"marshall",aspect:"fr-marshall",graph:this.cbMergeGraphs(e,this.cbRookGraph(e),this.cbKnightGraph(e)),value:7.5,abbrev:"M",initial:[{s:1,p:3},{s:-1,p:113}]},12:{name:"iipawn-w",aspect:"fr-pawn",graph:t(this,1),value:1,abbrev:"",fenAbbrev:"P",initial:[{s:1,p:11},{s:1,p:12},{s:1,p:13},{s:1,p:14},{s:1,p:15},{s:1,p:16},{s:1,p:17},{s:1,p:18},{s:1,p:19},{s:1,p:20},{s:1,p:21}],epTarget:!0},13:{name:"iipawn-b",aspect:"fr-pawn",graph:t(this,-1),value:1,abbrev:"",fenAbbrev:"P",initial:[{s:-1,p:99},{s:-1,p:100},{s:-1,p:101},{s:-1,p:102},{s:-1,p:103},{s:-1,p:104},{s:-1,p:105},{s:-1,p:106},{s:-1,p:107},{s:-1,p:108},{s:-1,p:109}],epTarget:!0}},promote:function(t,r,a){if(12==r.t||13==r.t){return 1==Math.abs(e.R(a.t)-e.R(a.f))?[12==r.t?1:3]:[12==r.t?0:2]}if(1==r.t)return[0];if(3==r.t)return[2];var i=e.R(a.t);if(0==r.t&&10==e.R(a.t)||2==r.t&&0==e.R(a.t)){for(var s={4:1,5:1,6:1,7:1,9:1,10:1,11:1},n={},o=0;o<this.pieces.length;o++){var h=this.pieces[o];h.s==r.s&&h.p<0&&h.t in s&&(n[h.t]=1)}var p=[];for(var c in n)p.push(c);if(0!=i&&10!=i)p.unshift(r.t);else if(0==p.length)return null;return p}return[]},castle:{"5/0":{k:[4,3,2,1],r:[1,2,3,4],n:"O-O"},"5/10":{k:[6,7,8,9],r:[9,8,7,6],n:"O-O-O"},"115/110":{k:[114,113,112,111],r:[111,112,113,114],n:"O-O"},"115/120":{k:[116,117,118,119],r:[119,118,117,116],n:"O-O-O"}}}}}();

/***/ }),

/***/ "CMrU":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var concatAll_1 = __webpack_require__("CfHE");
Observable_1.Observable.prototype.concatAll = concatAll_1.concatAll;
//# sourceMappingURL=concatAll.js.map

/***/ }),

/***/ "CToi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var max_1 = __webpack_require__("ZvZx");
Observable_1.Observable.prototype.max = max_1.max;
//# sourceMappingURL=max.js.map

/***/ }),

/***/ "CURp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var root_1 = __webpack_require__("VOfZ");
var isArrayLike_1 = __webpack_require__("1r8+");
var isPromise_1 = __webpack_require__("aQl7");
var isObject_1 = __webpack_require__("ICpg");
var Observable_1 = __webpack_require__("rCTf");
var iterator_1 = __webpack_require__("cdmN");
var InnerSubscriber_1 = __webpack_require__("QqRK");
var observable_1 = __webpack_require__("mbVC");
function subscribeToResult(outerSubscriber, result, outerValue, outerIndex) {
    var destination = new InnerSubscriber_1.InnerSubscriber(outerSubscriber, outerValue, outerIndex);
    if (destination.closed) {
        return null;
    }
    if (result instanceof Observable_1.Observable) {
        if (result._isScalar) {
            destination.next(result.value);
            destination.complete();
            return null;
        }
        else {
            return result.subscribe(destination);
        }
    }
    else if (isArrayLike_1.isArrayLike(result)) {
        for (var i = 0, len = result.length; i < len && !destination.closed; i++) {
            destination.next(result[i]);
        }
        if (!destination.closed) {
            destination.complete();
        }
    }
    else if (isPromise_1.isPromise(result)) {
        result.then(function (value) {
            if (!destination.closed) {
                destination.next(value);
                destination.complete();
            }
        }, function (err) { return destination.error(err); })
            .then(null, function (err) {
            // Escaping the Promise trap: globally throw unhandled errors
            root_1.root.setTimeout(function () { throw err; });
        });
        return destination;
    }
    else if (result && typeof result[iterator_1.iterator] === 'function') {
        var iterator = result[iterator_1.iterator]();
        do {
            var item = iterator.next();
            if (item.done) {
                destination.complete();
                break;
            }
            destination.next(item.value);
            if (destination.closed) {
                break;
            }
        } while (true);
    }
    else if (result && typeof result[observable_1.observable] === 'function') {
        var obs = result[observable_1.observable]();
        if (typeof obs.subscribe !== 'function') {
            destination.error(new TypeError('Provided object does not correctly implement Symbol.observable'));
        }
        else {
            return obs.subscribe(new InnerSubscriber_1.InnerSubscriber(outerSubscriber, outerValue, outerIndex));
        }
    }
    else {
        var value = isObject_1.isObject(result) ? 'an invalid object' : "'" + result + "'";
        var msg = ("You provided " + value + " where a stream was expected.")
            + ' You can provide an Observable, Promise, Array, or Iterable.';
        destination.error(new TypeError(msg));
    }
    return null;
}
exports.subscribeToResult = subscribeToResult;
//# sourceMappingURL=subscribeToResult.js.map

/***/ }),

/***/ "CYDS":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var auditTime_1 = __webpack_require__("/TOt");
Observable_1.Observable.prototype.auditTime = auditTime_1.auditTime;
//# sourceMappingURL=auditTime.js.map

/***/ }),

/***/ "CfHE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var mergeAll_1 = __webpack_require__("cbuX");
/* tslint:enable:max-line-length */
/**
 * Converts a higher-order Observable into a first-order Observable by
 * concatenating the inner Observables in order.
 *
 * <span class="informal">Flattens an Observable-of-Observables by putting one
 * inner Observable after the other.</span>
 *
 * <img src="./img/concatAll.png" width="100%">
 *
 * Joins every Observable emitted by the source (a higher-order Observable), in
 * a serial fashion. It subscribes to each inner Observable only after the
 * previous inner Observable has completed, and merges all of their values into
 * the returned observable.
 *
 * __Warning:__ If the source Observable emits Observables quickly and
 * endlessly, and the inner Observables it emits generally complete slower than
 * the source emits, you can run into memory issues as the incoming Observables
 * collect in an unbounded buffer.
 *
 * Note: `concatAll` is equivalent to `mergeAll` with concurrency parameter set
 * to `1`.
 *
 * @example <caption>For each click event, tick every second from 0 to 3, with no concurrency</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map(ev => Rx.Observable.interval(1000).take(4));
 * var firstOrder = higherOrder.concatAll();
 * firstOrder.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // (results are not concurrent)
 * // For every click on the "document" it will emit values 0 to 3 spaced
 * // on a 1000ms interval
 * // one click = 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3
 *
 * @see {@link combineAll}
 * @see {@link concat}
 * @see {@link concatMap}
 * @see {@link concatMapTo}
 * @see {@link exhaust}
 * @see {@link mergeAll}
 * @see {@link switch}
 * @see {@link zipAll}
 *
 * @return {Observable} An Observable emitting values from all the inner
 * Observables concatenated.
 * @method concatAll
 * @owner Observable
 */
function concatAll() {
    return this.lift(new mergeAll_1.MergeAllOperator(1));
}
exports.concatAll = concatAll;
//# sourceMappingURL=concatAll.js.map

/***/ }),

/***/ "Cr1h":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Observable_1 = __webpack_require__("rCTf");
var Subscription_1 = __webpack_require__("B00U");
var SubscriptionLoggable_1 = __webpack_require__("y9a2");
var applyMixins_1 = __webpack_require__("g28B");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var ColdObservable = (function (_super) {
    __extends(ColdObservable, _super);
    function ColdObservable(messages, scheduler) {
        _super.call(this, function (subscriber) {
            var observable = this;
            var index = observable.logSubscribedFrame();
            subscriber.add(new Subscription_1.Subscription(function () {
                observable.logUnsubscribedFrame(index);
            }));
            observable.scheduleMessages(subscriber);
            return subscriber;
        });
        this.messages = messages;
        this.subscriptions = [];
        this.scheduler = scheduler;
    }
    ColdObservable.prototype.scheduleMessages = function (subscriber) {
        var messagesLength = this.messages.length;
        for (var i = 0; i < messagesLength; i++) {
            var message = this.messages[i];
            subscriber.add(this.scheduler.schedule(function (_a) {
                var message = _a.message, subscriber = _a.subscriber;
                message.notification.observe(subscriber);
            }, message.frame, { message: message, subscriber: subscriber }));
        }
    };
    return ColdObservable;
}(Observable_1.Observable));
exports.ColdObservable = ColdObservable;
applyMixins_1.applyMixins(ColdObservable, [SubscriptionLoggable_1.SubscriptionLoggable]);
//# sourceMappingURL=ColdObservable.js.map

/***/ }),

/***/ "Cx8F":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subject_1 = __webpack_require__("EEr4");
var tryCatch_1 = __webpack_require__("+3eL");
var errorObject_1 = __webpack_require__("WhVc");
var OuterSubscriber_1 = __webpack_require__("wAkD");
var subscribeToResult_1 = __webpack_require__("CURp");
/**
 * Returns an Observable that mirrors the source Observable with the exception of an `error`. If the source Observable
 * calls `error`, this method will emit the Throwable that caused the error to the Observable returned from `notifier`.
 * If that Observable calls `complete` or `error` then this method will call `complete` or `error` on the child
 * subscription. Otherwise this method will resubscribe to the source Observable.
 *
 * <img src="./img/retryWhen.png" width="100%">
 *
 * @param {function(errors: Observable): Observable} notifier - Receives an Observable of notifications with which a
 * user can `complete` or `error`, aborting the retry.
 * @return {Observable} The source Observable modified with retry logic.
 * @method retryWhen
 * @owner Observable
 */
function retryWhen(notifier) {
    return this.lift(new RetryWhenOperator(notifier, this));
}
exports.retryWhen = retryWhen;
var RetryWhenOperator = (function () {
    function RetryWhenOperator(notifier, source) {
        this.notifier = notifier;
        this.source = source;
    }
    RetryWhenOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new RetryWhenSubscriber(subscriber, this.notifier, this.source));
    };
    return RetryWhenOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var RetryWhenSubscriber = (function (_super) {
    __extends(RetryWhenSubscriber, _super);
    function RetryWhenSubscriber(destination, notifier, source) {
        _super.call(this, destination);
        this.notifier = notifier;
        this.source = source;
    }
    RetryWhenSubscriber.prototype.error = function (err) {
        if (!this.isStopped) {
            var errors = this.errors;
            var retries = this.retries;
            var retriesSubscription = this.retriesSubscription;
            if (!retries) {
                errors = new Subject_1.Subject();
                retries = tryCatch_1.tryCatch(this.notifier)(errors);
                if (retries === errorObject_1.errorObject) {
                    return _super.prototype.error.call(this, errorObject_1.errorObject.e);
                }
                retriesSubscription = subscribeToResult_1.subscribeToResult(this, retries);
            }
            else {
                this.errors = null;
                this.retriesSubscription = null;
            }
            this._unsubscribeAndRecycle();
            this.errors = errors;
            this.retries = retries;
            this.retriesSubscription = retriesSubscription;
            errors.next(err);
        }
    };
    RetryWhenSubscriber.prototype._unsubscribe = function () {
        var _a = this, errors = _a.errors, retriesSubscription = _a.retriesSubscription;
        if (errors) {
            errors.unsubscribe();
            this.errors = null;
        }
        if (retriesSubscription) {
            retriesSubscription.unsubscribe();
            this.retriesSubscription = null;
        }
        this.retries = null;
    };
    RetryWhenSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        var _a = this, errors = _a.errors, retries = _a.retries, retriesSubscription = _a.retriesSubscription;
        this.errors = null;
        this.retries = null;
        this.retriesSubscription = null;
        this._unsubscribeAndRecycle();
        this.errors = errors;
        this.retries = retries;
        this.retriesSubscription = retriesSubscription;
        this.source.subscribe(this);
    };
    return RetryWhenSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=retryWhen.js.map

/***/ }),

/***/ "D4hj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ngrx_store__ = __webpack_require__("WWmu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions__ = __webpack_require__("prmc");
/* unused harmony export POSITIONS */
/* unused harmony export useDockMonitor */


var POSITIONS = ['left', 'top', 'right', 'bottom'];
function useDockMonitor(_options) {
    if (_options === void 0) { _options = {}; }
    var options = Object.assign({
        position: 'right',
        visible: true,
        size: 0.3
    }, _options);
    function position(state, action) {
        if (state === void 0) { state = options.position; }
        return (action.type === __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* DockActions */].CHANGE_POSITION) ?
            POSITIONS[(POSITIONS.indexOf(state) + 1) % POSITIONS.length] :
            state;
    }
    function size(state, action) {
        if (state === void 0) { state = options.size; }
        return (action.type === __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* DockActions */].CHANGE_SIZE) ?
            action.size :
            state;
    }
    function visible(state, action) {
        if (state === void 0) { state = options.visible; }
        return (action.type === __WEBPACK_IMPORTED_MODULE_1__actions__["a" /* DockActions */].TOGGLE_VISIBILITY) ?
            !state :
            state;
    }
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__ngrx_store__["a" /* combineReducers */])({
        position: position,
        visible: visible,
        size: size
    });
}
//# sourceMappingURL=reducer.js.map

/***/ }),

/***/ "DB2G":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var async_1 = __webpack_require__("CGGv");
var Subscriber_1 = __webpack_require__("mmVS");
var isScheduler_1 = __webpack_require__("fWbP");
/* tslint:enable:max-line-length */
/**
 * Buffers the source Observable values for a specific time period.
 *
 * <span class="informal">Collects values from the past as an array, and emits
 * those arrays periodically in time.</span>
 *
 * <img src="./img/bufferTime.png" width="100%">
 *
 * Buffers values from the source for a specific time duration `bufferTimeSpan`.
 * Unless the optional argument `bufferCreationInterval` is given, it emits and
 * resets the buffer every `bufferTimeSpan` milliseconds. If
 * `bufferCreationInterval` is given, this operator opens the buffer every
 * `bufferCreationInterval` milliseconds and closes (emits and resets) the
 * buffer every `bufferTimeSpan` milliseconds. When the optional argument
 * `maxBufferSize` is specified, the buffer will be closed either after
 * `bufferTimeSpan` milliseconds or when it contains `maxBufferSize` elements.
 *
 * @example <caption>Every second, emit an array of the recent click events</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var buffered = clicks.bufferTime(1000);
 * buffered.subscribe(x => console.log(x));
 *
 * @example <caption>Every 5 seconds, emit the click events from the next 2 seconds</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var buffered = clicks.bufferTime(2000, 5000);
 * buffered.subscribe(x => console.log(x));
 *
 * @see {@link buffer}
 * @see {@link bufferCount}
 * @see {@link bufferToggle}
 * @see {@link bufferWhen}
 * @see {@link windowTime}
 *
 * @param {number} bufferTimeSpan The amount of time to fill each buffer array.
 * @param {number} [bufferCreationInterval] The interval at which to start new
 * buffers.
 * @param {number} [maxBufferSize] The maximum buffer size.
 * @param {Scheduler} [scheduler=async] The scheduler on which to schedule the
 * intervals that determine buffer boundaries.
 * @return {Observable<T[]>} An observable of arrays of buffered values.
 * @method bufferTime
 * @owner Observable
 */
function bufferTime(bufferTimeSpan) {
    var length = arguments.length;
    var scheduler = async_1.async;
    if (isScheduler_1.isScheduler(arguments[arguments.length - 1])) {
        scheduler = arguments[arguments.length - 1];
        length--;
    }
    var bufferCreationInterval = null;
    if (length >= 2) {
        bufferCreationInterval = arguments[1];
    }
    var maxBufferSize = Number.POSITIVE_INFINITY;
    if (length >= 3) {
        maxBufferSize = arguments[2];
    }
    return this.lift(new BufferTimeOperator(bufferTimeSpan, bufferCreationInterval, maxBufferSize, scheduler));
}
exports.bufferTime = bufferTime;
var BufferTimeOperator = (function () {
    function BufferTimeOperator(bufferTimeSpan, bufferCreationInterval, maxBufferSize, scheduler) {
        this.bufferTimeSpan = bufferTimeSpan;
        this.bufferCreationInterval = bufferCreationInterval;
        this.maxBufferSize = maxBufferSize;
        this.scheduler = scheduler;
    }
    BufferTimeOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new BufferTimeSubscriber(subscriber, this.bufferTimeSpan, this.bufferCreationInterval, this.maxBufferSize, this.scheduler));
    };
    return BufferTimeOperator;
}());
var Context = (function () {
    function Context() {
        this.buffer = [];
    }
    return Context;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var BufferTimeSubscriber = (function (_super) {
    __extends(BufferTimeSubscriber, _super);
    function BufferTimeSubscriber(destination, bufferTimeSpan, bufferCreationInterval, maxBufferSize, scheduler) {
        _super.call(this, destination);
        this.bufferTimeSpan = bufferTimeSpan;
        this.bufferCreationInterval = bufferCreationInterval;
        this.maxBufferSize = maxBufferSize;
        this.scheduler = scheduler;
        this.contexts = [];
        var context = this.openContext();
        this.timespanOnly = bufferCreationInterval == null || bufferCreationInterval < 0;
        if (this.timespanOnly) {
            var timeSpanOnlyState = { subscriber: this, context: context, bufferTimeSpan: bufferTimeSpan };
            this.add(context.closeAction = scheduler.schedule(dispatchBufferTimeSpanOnly, bufferTimeSpan, timeSpanOnlyState));
        }
        else {
            var closeState = { subscriber: this, context: context };
            var creationState = { bufferTimeSpan: bufferTimeSpan, bufferCreationInterval: bufferCreationInterval, subscriber: this, scheduler: scheduler };
            this.add(context.closeAction = scheduler.schedule(dispatchBufferClose, bufferTimeSpan, closeState));
            this.add(scheduler.schedule(dispatchBufferCreation, bufferCreationInterval, creationState));
        }
    }
    BufferTimeSubscriber.prototype._next = function (value) {
        var contexts = this.contexts;
        var len = contexts.length;
        var filledBufferContext;
        for (var i = 0; i < len; i++) {
            var context = contexts[i];
            var buffer = context.buffer;
            buffer.push(value);
            if (buffer.length == this.maxBufferSize) {
                filledBufferContext = context;
            }
        }
        if (filledBufferContext) {
            this.onBufferFull(filledBufferContext);
        }
    };
    BufferTimeSubscriber.prototype._error = function (err) {
        this.contexts.length = 0;
        _super.prototype._error.call(this, err);
    };
    BufferTimeSubscriber.prototype._complete = function () {
        var _a = this, contexts = _a.contexts, destination = _a.destination;
        while (contexts.length > 0) {
            var context = contexts.shift();
            destination.next(context.buffer);
        }
        _super.prototype._complete.call(this);
    };
    BufferTimeSubscriber.prototype._unsubscribe = function () {
        this.contexts = null;
    };
    BufferTimeSubscriber.prototype.onBufferFull = function (context) {
        this.closeContext(context);
        var closeAction = context.closeAction;
        closeAction.unsubscribe();
        this.remove(closeAction);
        if (!this.closed && this.timespanOnly) {
            context = this.openContext();
            var bufferTimeSpan = this.bufferTimeSpan;
            var timeSpanOnlyState = { subscriber: this, context: context, bufferTimeSpan: bufferTimeSpan };
            this.add(context.closeAction = this.scheduler.schedule(dispatchBufferTimeSpanOnly, bufferTimeSpan, timeSpanOnlyState));
        }
    };
    BufferTimeSubscriber.prototype.openContext = function () {
        var context = new Context();
        this.contexts.push(context);
        return context;
    };
    BufferTimeSubscriber.prototype.closeContext = function (context) {
        this.destination.next(context.buffer);
        var contexts = this.contexts;
        var spliceIndex = contexts ? contexts.indexOf(context) : -1;
        if (spliceIndex >= 0) {
            contexts.splice(contexts.indexOf(context), 1);
        }
    };
    return BufferTimeSubscriber;
}(Subscriber_1.Subscriber));
function dispatchBufferTimeSpanOnly(state) {
    var subscriber = state.subscriber;
    var prevContext = state.context;
    if (prevContext) {
        subscriber.closeContext(prevContext);
    }
    if (!subscriber.closed) {
        state.context = subscriber.openContext();
        state.context.closeAction = this.schedule(state, state.bufferTimeSpan);
    }
}
function dispatchBufferCreation(state) {
    var bufferCreationInterval = state.bufferCreationInterval, bufferTimeSpan = state.bufferTimeSpan, subscriber = state.subscriber, scheduler = state.scheduler;
    var context = subscriber.openContext();
    var action = this;
    if (!subscriber.closed) {
        subscriber.add(context.closeAction = scheduler.schedule(dispatchBufferClose, bufferTimeSpan, { subscriber: subscriber, context: context }));
        action.schedule(state, bufferCreationInterval);
    }
}
function dispatchBufferClose(arg) {
    var subscriber = arg.subscriber, context = arg.context;
    subscriber.closeContext(context);
}
//# sourceMappingURL=bufferTime.js.map

/***/ }),

/***/ "DOCK":
/***/ (function(module, exports) {

exports.model=Model={Game:{},Board:{},Move:{}},function(){var t;Model.Game.cbConstants={MASK:65535,FLAG_MOVE:65536,FLAG_CAPTURE:131072,FLAG_STOP:262144,FLAG_SCREEN_CAPTURE:524288,FLAG_CAPTURE_KING:1048576,FLAG_CAPTURE_NO_KING:2097152};var e="undefined"!=typeof Int32Array;Model.Game.cbUseTypedArrays=e,Model.Game.cbTypedArray=function(t){if(e){var r=new Int32Array(t.length);return r.set(t),r}for(var a=[],i=t.length,n=0;n<i;n++)a.push(t[n]);return a},Model.Game.cbShortRangeGraph=function(t,e,r,a){var i=this;void 0===a&&(a=196608);for(var n={},s=0;s<t.boardSize;s++)n[s]=[],(!r||s in r)&&e.forEach(function(e){var o=t.Graph(s,e);null!=o&&(!r||o in r)&&n[s].push(i.cbTypedArray([o|a]))});return n},Model.Game.cbLongRangeGraph=function(t,e,r,a,i){var n=this;void 0!==a&&null!=a||(a=196608),i||(i=1/0);for(var s={},o=0;o<t.boardSize;o++)s[o]=[],(!r||o in r)&&e.forEach(function(e){for(var h=[],c=t.Graph(o,e),p=0;null!=c&&(!r||c in r)&&(h.push(c|a),++p!=i);)c=t.Graph(c,e);h.length>0&&s[o].push(n.cbTypedArray(h))});return s},Model.Game.cbNullGraph=function(t){for(var e={},r=0;r<t.boardSize;r++)e[r]=[];return e},Model.Game.cbAuthorGraph=function(t){for(var e={},r=0;r<t.boardSize;r++){e[r]=[];for(var a=0;a<t.boardSize;a++)e[r].push([2293760|a])}return e},Model.Game.cbMergeGraphs=function(t){for(var e=[],r=0;r<t.boardSize;r++){e[r]=[];for(var a=1;a<arguments.length;a++)e[r]=e[r].concat(arguments[a][r])}return e},Model.Game.cbGetThreatGraph=function(){function t(e,r){for(var a in s){var i=s[a];if(!(i.p.length<r.length+1)){for(var n=!0,o=0;o<r.length;o++)if(r[o]!=i.p[o]){n=!1;break}if(n){var h=i.p[r.length],c=e[h];void 0===c&&(c={e:{}},e[h]=c),i.p.length==r.length+1&&(c.t=i.t,c.ts=i.ts,c.tk=i.tk,delete s[a]),r.push(h),t(c.e,r),r.pop()}}}}var e=this;this.cbUseScreenCapture=!1,this.cbUseCaptureKing=!1,this.cbUseCaptureNoKing=!1;for(var r={1:[],"-1":[]},a=[],i=0;i<this.g.boardSize;i++)this.g.pTypes.forEach(function(t,r){t.graph[i].forEach(function(t){for(var n=[],s=0;s<t.length;s++){var o=t[s];1048576&o?(e.cbUseCaptureKing=!0,n.unshift({d:65535&o,a:i,tk:r})):2097152&o?(e.cbUseCaptureNoKing=!0,n.unshift({d:65535&o,a:i,tnk:r})):131072&o?n.unshift({d:65535&o,a:i,t:r}):262144&o?n.unshift({d:65535&o,a:i}):524288&o&&(e.cbUseScreenCapture=!0,n.unshift({d:65535&o,a:i,ts:r}))}n.length>0&&a.push(n)})});var n={};a.forEach(function(t){t.forEach(function(e,r){var a=n[e.d];void 0===a&&(a={},n[e.d]=a);for(var i=[],s=r+1;s<t.length;s++)i.push(t[s].d);i.push(e.a);var o=i.join(","),h=a[o];void 0===h&&(h={p:i,t:{},ts:{},tk:{}},a[o]=h),void 0!==e.t?h.t[e.t]=!0:void 0!==e.tk?h.tk[e.tk]=!0:void 0!==e.ts&&(h.ts[e.ts]=!0)})});for(var i=0;i<e.g.boardSize;i++){var s=n[i],o={};t(o,[]),r[1][i]=o,r[-1][i]=o}return r},Model.Game.InitGame=function(){var e=this;this.cbVar=t=this.cbDefine(),this.g.boardSize=this.cbVar.geometry.boardSize,this.g.pTypes=this.cbGetPieceTypes(),this.g.threatGraph=this.cbGetThreatGraph(),this.g.distGraph=this.cbVar.geometry.GetDistances(),this.cbPiecesCount=0,this.g.castleablePiecesCount={1:0,"-1":0};for(var r in t.pieceTypes){var a=t.pieceTypes[r];if(a.castle){(a.initial||[]).forEach(function(t){e.g.castleablePiecesCount[t.s]++})}a.initial&&(this.cbPiecesCount+=a.initial.length)}for(var i=[],r=0;r<this.cbPiecesCount;r++)i.push(r);var n=Object.keys(t.pieceTypes);this.zobrist=new JocGame.Zobrist({board:{type:"array",size:this.cbVar.geometry.boardSize,values:i},who:{values:["1","-1"]},type:{type:"array",size:this.cbPiecesCount,values:n}})},Model.Game.cbGetPieceTypes=function(){for(var t=[],e={},r=0;r<this.cbVar.geometry.boardSize;r++)e[r]=[];for(var a in this.cbVar.pieceTypes){var i=this.cbVar.pieceTypes[a];t[a]={graph:i.graph||e,abbrev:i.abbrev||"",value:i.isKing?100:i.value||1,isKing:!!i.isKing,castle:!!i.castle,epTarget:!!i.epTarget,epCatch:!!i.epCatch}}return t},Model.Board.Init=function(t){this.zSign=0},Model.Board.InitialPosition=function(r){var a=this;this.board=e?new Int16Array(r.g.boardSize):[];for(var i=0;i<r.g.boardSize;i++)this.board[i]=-1;if(this.kings={},this.pieces=[],this.ending={1:!1,"-1":!1},this.lastMove=null,r.cbVar.castle&&(this.castled={1:!1,"-1":!1}),this.zSign=r.zobrist.update(0,"who",-1),this.noCaptCount=0,this.mWho=1,r.mInitial)this.mWho=r.mInitial.turn||1,r.mInitial.pieces.forEach(function(t){var e={};for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);a.pieces.push(e)}),r.mInitial.lastMove&&(this.lastMove={f:r.mInitial.lastMove.f,t:r.mInitial.lastMove.t}),void 0!==r.mInitial.noCaptCount&&(this.noCaptCount=r.mInitial.noCaptCount),r.cbVar.castle&&r.mInitial.castle&&(this.castled={1:{k:!!r.mInitial.castle[1]&&!!r.mInitial.castle[1].k,q:!!r.mInitial.castle[1]&&!!r.mInitial.castle[1].q},"-1":{k:!!r.mInitial.castle[-1]&&!!r.mInitial.castle[-1].k,q:!!r.mInitial.castle[-1]&&!!r.mInitial.castle[-1].q}});else for(var n in r.cbVar.pieceTypes)for(var s=r.cbVar.pieceTypes[n],o=s.initial||[],h=0;h<o.length;h++){var c=o[h],p={s:c.s,t:parseInt(n),p:c.p,m:!1};this.pieces.push(p)}if(this.pieces.sort(function(t,e){if(t.s!=e.s)return e.s-t.s;var a=r.cbVar.pieceTypes[t.t].value||100,i=r.cbVar.pieceTypes[e.t].value||100;return a!=i?a-i:t.p-e.p}),this.pieces.forEach(function(t,e){t.i=e,a.board[t.p]=e,r.g.pTypes[t.t].isKing&&(a.kings[t.s]=t.p),a.zSign=r.zobrist.update(a.zSign,"board",e,t.p),a.zSign=r.zobrist.update(a.zSign,"type",t.t,e)}),r.mInitial&&r.mInitial.enPassant){var i=t.geometry.PosByName(r.mInitial.enPassant);if(i>=0){var l,u=t.geometry.C(i),b=t.geometry.R(i);l=1==r.mInitial.turn?t.geometry.POS(u,b-1):t.geometry.POS(u,b+1),this.epTarget={p:i,i:this.board[l]}}}},Model.Board.CopyFrom=function(t){if(e)this.board=new Int16Array(t.board.length),this.board.set(t.board);else{this.board=[];for(var r=t.board,a=r.length,i=0;i<a;i++)this.board.push(r[i])}this.pieces=[];for(var n=t.pieces.length,i=0;i<n;i++){var s=t.pieces[i];this.pieces.push({s:s.s,p:s.p,t:s.t,i:s.i,m:s.m})}this.kings={1:t.kings[1],"-1":t.kings[-1]},this.check=t.check,t.lastMove?this.lastMove={f:t.lastMove.f,t:t.lastMove.t,c:t.lastMove.c}:this.lastMove=null,this.ending={1:t.ending[1],"-1":t.ending[-1]},void 0!==t.castled&&(this.castled={1:t.castled[1],"-1":t.castled[-1]}),this.noCaptCount=t.noCaptCount,t.epTarget?this.epTarget={p:t.epTarget.p,i:t.epTarget.i}:this.epTarget=null,this.mWho=t.mWho,this.zSign=t.zSign},Model.Board.cbApplyCastle=function(t,e,r){var a=t.cbVar.castle[e.f+"/"+e.cg],i=a.r[a.r.length-1],n=this.pieces[this.board[e.cg]],s=a.k[a.k.length-1],o=this.pieces[this.board[e.f]];return r&&(this.zSign=t.zobrist.update(this.zSign,"board",n.i,e.cg),this.zSign=t.zobrist.update(this.zSign,"board",n.i,i),this.zSign=t.zobrist.update(this.zSign,"board",o.i,e.f),this.zSign=t.zobrist.update(this.zSign,"board",o.i,s)),n.p=i,n.m=!0,this.board[e.cg]=-1,o.p=s,o.m=!0,this.board[e.f]=-1,this.board[i]=n.i,this.board[s]=o.i,this.castled[n.s]=!0,this.kings[o.s]=s,[{i:n.i,f:i,t:-1},{i:o.i,f:s,t:e.f,kp:e.f,who:o.s,m:!1},{i:n.i,f:-1,t:e.cg,m:!1,cg:!1}]},Model.Board.cbQuickApply=function(t,e){if(void 0!==e.cg)return this.cbApplyCastle(t,e,!1);var r=[],a=this.board[e.f],i=this.pieces[a];if(null!=e.c){r.unshift({i:e.c,f:-1,t:this.pieces[e.c].p});var n=this.pieces[e.c];this.board[n.p]=-1,n.p=-1}var s=this.kings[i.s];return t.g.pTypes[i.t].isKing&&(this.kings[i.s]=e.t),r.unshift({i:a,f:e.t,t:e.f,kp:s,who:i.s,ty:i.t}),i.p=e.t,void 0!==e.pr&&(i.t=e.pr),this.board[e.f]=-1,this.board[e.t]=a,r},Model.Board.cbQuickUnapply=function(t,e){for(var r=0;r<e.length;r++){var a=e[r],i=this.pieces[a.i];a.f>=0&&(i.p=-1,this.board[a.f]=-1),a.t>=0&&(i.p=a.t,this.board[a.t]=a.i),void 0!==a.m&&(i.m=a.m),void 0!==a.kp&&(this.kings[a.who]=a.kp),void 0!=a.ty&&(i.t=a.ty),void 0!=a.cg&&(this.castled[i.s]=a.cg)}},Model.Board.ApplyMove=function(t,e){var r=this.pieces[this.board[e.f]];if(void 0!==e.cg)this.cbApplyCastle(t,e,!0);else{if(this.zSign=t.zobrist.update(this.zSign,"board",r.i,e.f),this.board[r.p]=-1,void 0!==e.pr&&(this.zSign=t.zobrist.update(this.zSign,"type",r.t,r.i),r.t=e.pr,this.zSign=t.zobrist.update(this.zSign,"type",r.t,r.i)),null!=e.c){var a=this.pieces[e.c];this.zSign=t.zobrist.update(this.zSign,"board",a.i,a.p),this.board[a.p]=-1,a.p=-1,a.m=!0,this.noCaptCount=0}else this.noCaptCount++;r.p=e.t,r.m=!0,this.board[e.t]=r.i,this.zSign=t.zobrist.update(this.zSign,"board",r.i,e.t),t.g.pTypes[r.t].isKing&&(this.kings[r.s]=e.t)}this.check=!!e.ck,this.lastMove={f:e.f,t:e.t,c:e.c},void 0!==e.ko&&(this.ending[r.s]=e.ko),void 0!==e.ept?this.epTarget={p:e.ept,i:r.i}:this.epTarget=null,this.zSign=t.zobrist.update(this.zSign,"who",-this.mWho),this.zSign=t.zobrist.update(this.zSign,"who",this.mWho)},Model.Board.Evaluate=function(r){function a(e){var r=1/0;for(var a in t.geometry.corners)r=Math.min(r,h.distGraph[n.kings[e]][a]);return r-Math.sqrt(h.boardSize)}var i="debug"==arguments[3],n=this;this.mEvaluation=0;var s,o=this.mWho,h=r.g;if(e)s={1:{count:new Uint8Array(h.pTypes.length),byType:{}},"-1":{count:new Uint8Array(h.pTypes.length),byType:{}}};else{s={1:{count:[],byType:{}},"-1":{count:[],byType:{}}};for(var c=0;c<h.pTypes.length;c++)s[1].count[c]=s[-1].count[c]=0}if(r.mOptions.preventRepeat&&r.GetRepeatOccurence(this)>2)return this.mFinished=!0,void(this.mWinner=r.cbOnPerpetual?o*r.cbOnPerpetual:JocGame.DRAW);for(var p={1:0,"-1":0},l={1:h.distGraph[this.kings[-1]],"-1":h.distGraph[this.kings[1]]},u={1:0,"-1":0},b={1:0,"-1":0},v={1:0,"-1":0},f={1:0,"-1":0},g={1:!1,"-1":!1},d=this.pieces,m=d.length,c=0;c<m;c++){var G=d[c];if(G.p>=0){var y=G.s,M=h.pTypes[G.t];M.isKing?g[y]=G.m:p[y]+=M.value,M.castle&&!G.m&&f[y]++,b[y]++,u[y]+=l[y][G.p],v[y]+=t.geometry.distEdge[G.p];var C=s[y];C.count[G.t]++;var S=C.byType;void 0===S[G.t]?S[G.t]=[G]:S[G.t].push(G)}}if(this.lastMove&&null!=this.lastMove.c){var G=this.pieces[this.board[this.lastMove.t]];p[-G.s]+=this.cbStaticExchangeEval(r,G.p,G.s,{piece:G})}var k={1:0,"-1":0},A={1:0,"-1":0},T={1:0,"-1":0};this.ending[1]&&(A[1]=(u[1]-Math.sqrt(h.boardSize))/b[1],t.geometry.corners&&(T[1]=a(1))),this.ending[-1]&&(A[-1]=(u[-1]-Math.sqrt(h.boardSize))/b[-1],t.geometry.corners&&(T[1]=a(-1)));var z={pieceValue:p[1]-p[-1],pieceValueRatio:(p[1]-p[-1])/(p[1]+p[-1]+1),posValue:v[1]-v[-1],averageDistKing:u[1]/b[1]-u[-1]/b[-1],check:this.check?-o:0,endingKingFreedom:k[1]-k[-1],endingDistKing:A[1]-A[-1],distKingCorner:T[1]-T[-1]};t.castle&&(z.castle=(this.castled[1]?1:g[1]?0:f[1]/(h.castleablePiecesCount[1]+1))-(this.castled[-1]?1:g[-1]?0:f[-1]/(h.castleablePiecesCount[-1]+1))),t.evaluate&&t.evaluate.call(this,r,z,s);var E=r.mOptions.levelOptions;for(var P in z){var w=z[P],R=E[P+"Factor"]||0,I=w*R;i&&console.log(P,"=",w,"*",R,"=>",I),this.mEvaluation+=I}i&&console.log("Evaluation",this.mEvaluation)},Model.Board.cbGeneratePseudoLegalMoves=function(t){function e(e,i){var n=t.cbVar.promote;if(!n)return void a.push(i);var s=n.call(r,t,e,i);if(null!=s)if(0==s.length)a.push(i);else if(1==s.length)i.pr=s[0],a.push(i);else for(var o=0;o<s.length;o++){var h=s[o];a.push({f:i.f,t:i.t,c:i.c,pr:h,ept:i.ept,ep:i.ep,a:i.a})}}for(var r=this,a=[],i=t.cbVar,n=this.mWho,s=!i.castle||this.check||this.castled[n]?null:[],o=-1,h=this.pieces.length,c=0;c<h;c++){var p=this.pieces[c];if(!(p.p<0||p.s!=n)){var l=t.g.pTypes[p.t];l.isKing&&(p.m?s=null:o=p),s&&l.castle&&!p.m&&s.push(p);var u,b;u=l.graph[p.p],b=u.length;for(var v=0;v<b;v++)for(var f=u[v],g=!1,d=f.length,m=null,G=0;G<d;G++){var y=f[G],M=65535&y,C=this.board[M];if(!(C<0)||l.epCatch&&this.epTarget&&this.epTarget.p==M){if(!(524288&y)){var S;S=C<0?this.pieces[this.epTarget.i]:this.pieces[C],!(S.s!=p.s&&131072&y)||1048576&y&&!t.g.pTypes[S.t].isKing||2097152&y&&t.g.pTypes[S.t].isKing||e(p,{f:p.p,t:M,c:S.i,a:l.abbrev,ep:C<0});break}if(g){var S=this.pieces[C];S.s!=p.s&&e(p,{f:p.p,t:M,c:S.i,a:l.abbrev});break}g=!0}else 65536&y&&0==g&&e(p,{f:p.p,t:M,c:null,a:l.abbrev,ept:null!=m&&l.epTarget?m:void 0});m=M}}}if(s)for(var c=0;c<s.length;c++){var k=s[c],A=t.cbVar.castle[o.p+"/"+k.p];if(A){for(var T=!0,v=0;v<A.r.length;v++){var z=A.r[v];if(this.board[z]>=0&&z!=o.p&&z!=k.p){T=!1;break}}if(T){for(var E=!0,v=0;v<A.k.length;v++){var z=A.k[v];if(this.board[z]>=0&&z!=k.p&&z!=o.p||this.cbGetAttackers(t,z,n).length>0){E=!1;break}}E&&a.push({f:o.p,t:A.k[A.k.length-1],c:null,cg:k.p})}}}return a},Model.Board.cbStaticExchangeEval=function(t,e,r,a){var i=0,n=this.cbGetSmallestAttacker(t,e,r);if(n){var s=this.mWho;this.mWho=n.s;var o=this.cbQuickApply(t,{f:n.p,t:e,c:a.piece.i}),h=t.g.pTypes[a.piece.t].value;a.piece=n,i=Math.max(0,h-this.cbStaticExchangeEval(t,e,-r,a)),this.cbQuickUnapply(t,o),this.mWho=s}return i},Model.Board.cbGetSmallestAttacker=function(t,e,r){var a=this.cbGetAttackers(t,e,r);if(0==a.length)return null;for(var i=1/0,n=null,s=a.length,o=0;o<s;o++){var h=a[o],c=t.g.pTypes[h.t].value;c<i&&(i=c,n=h)}return n},Model.Board.cbCollectAttackers=function(t,e,r,a){for(var i in e){var n=e[i],s=this.board[i];if(s<0)this.cbCollectAttackers(t,n.e,r,a);else{var o=this.pieces[s];o.s==-t&&(n.t&&o.t in n.t||a&&n.tk&&o.t in n.tk)&&r.push(o)}}},Model.Board.cbCollectAttackersScreen=function(t,e,r,a,i){for(var n in e){var s=e[n],o=this.board[n];if(o<0)this.cbCollectAttackersScreen(t,s.e,r,a,i);else{var h=this.pieces[o];!i&&h.s==-t&&(s.t&&h.t in s.t||a&&s.tk&&h.t in s.tk)?r.push(h):i?i&&h.s==-t&&s.ts&&h.t in s.ts&&r.push(h):this.cbCollectAttackersScreen(t,s.e,r,a,!0)}}},Model.Board.cbGetAttackers=function(t,e,r,a){var i=[];return t.cbUseScreenCapture?this.cbCollectAttackersScreen(r,t.g.threatGraph[r][e],i,a,!1):this.cbCollectAttackers(r,t.g.threatGraph[r][e],i,a),i},Model.Board.GenerateMoves=function(t){var e=this.cbGeneratePseudoLegalMoves(t);this.mMoves=[];for(var r=!0,a=this.kings[this.mWho],i=e.length,n=0;n<i;n++){var s=e[n],o=this.cbQuickApply(t,s);if(!(this.cbGetAttackers(t,this.kings[this.mWho],this.mWho,!0).length>0)){var h=this.cbGetAttackers(t,this.kings[-this.mWho],-this.mWho,!0).length>0;s.ck=h,this.mMoves.push(s),s.f!=a&&(r=!1)}this.cbQuickUnapply(t,o)}if(0==this.mMoves.length)this.mFinished=!0,this.mWinner=t.cbOnStaleMate?t.cbOnStaleMate*this.mWho:JocGame.DRAW,this.check&&(this.mWinner=-this.mWho);else if(this.ending[this.mWho]){if(!r)for(var n=0;n<this.mMoves.length;n++)this.mMoves[n].ko=!1}else if(!this.ending[this.mWho]&&r&&!this.check)for(var n=0;n<this.mMoves.length;n++)this.mMoves[n].ko=!0},Model.Board.GetSignature=function(){return this.zSign},Model.Move.Init=function(t){for(var e in t)t.hasOwnProperty(e)&&(this[e]=t[e])},Model.Move.Equals=function(t){return this.f==t.f&&this.t==t.t&&this.pr==t.pr},Model.Move.CopyFrom=function(t){this.Init(t)},Model.Move.ToString=function(e){var r=this;switch(e=e||"natural"){case"natural":return function(){var e;if(void 0!==r.cg?e=t.castle[r.f+"/"+r.cg].n:(e=r.a||"",e+=t.geometry.PosName(r.f),null==r.c?e+="-":e+="x",e+=t.geometry.PosName(r.t)),void 0!==r.pr){var a=t.pieceTypes[r.pr];a&&a.abbrev&&a.abbrev.length>0&&!a.silentPromo&&(e+="="+a.abbrev)}return r.ck&&(e+="+"),e}();case"engine":return function(){var e=t.geometry.PosName(r.f)+t.geometry.PosName(r.t);if(void 0!=r.pr){var a=t.pieceTypes[r.pr];a&&a.abbrev&&a.abbrev.length>0&&!a.silentPromo&&(e+=a.abbrev)}return e}();default:return"??"}},Model.Board.CompactMoveString=function(e,r,a){"function"!=typeof r.ToString&&(r=e.CreateMove(r));var i=r.ToString(),n=/^([A-Z]?)([a-z])([1-9][0-9]*)([-x])([a-z])([1-9][0-9]*)(.*?)$/.exec(i);if(!n)return i;var s=n[7];if(a||(a={}),a.value||(a.value=[]),0==a.value.length){var o=this.mMoves;this.mMoves&&0!=this.mMoves.length||this.GenerateMoves(e);for(var h=0;h<this.mMoves.length;h++){var c=this.mMoves[h];"function"!=typeof c.ToString&&(c=e.CreateMove(c)),a.value.push({str:c.ToString(),move:c})}this.mMoves=o}var p=[];if(a.value.forEach(function(t){var e=/^([A-Z]?[a-z][1-9][0-9]*[-x][a-z][1-9][0-9]*)(.*?)$/.exec(t.str);e&&t.move.t==r.t&&(t.move.a||"")==n[1]&&e[2]==s&&p.push(t.move)}),1==p.length)return""==n[1]&&"x"==n[4]?n[2]+"x"+n[5]+n[6]+n[7]:n[1]+("x"==n[4]?"x":"")+n[5]+n[6]+n[7];if(t.geometry.CompactCrit)for(var l="",h=0;;h++){var u=t.geometry.CompactCrit(r.f,h);if(null==u)return i;l+=u;for(var b=[],v=0;v<p.length;v++){var f=p[v];t.geometry.CompactCrit(f.f,h)==u&&b.push(f)}if(console.assert(b.length>0),1==b.length)return n[1]+l+("x"==n[4]?"x":"")+n[5]+n[6]+n[7];p=b}return i},Model.Board.cbIntegrity=function(t){function e(t,e){t||console.error(e)}for(var r=this,a=0;a<this.board.length;a++){var i=this.board[a];if(i>=0){var n=r.pieces[i];e(void 0!==n,"no piece at pos"),e(n.p==a,"piece has different pos")}}for(var i=0;i<this.pieces.length;i++){var n=this.pieces[i];n.p>=0&&e(r.board[n.p]==i,"board index mismatch")}},Model.Board.ExportBoardState=function(t){return t.cbVar.geometry.ExportBoardState?t.cbVar.geometry.ExportBoardState(this,t.cbVar,t.mPlayedMoves.length):"not supported"},Model.Game.Import=function(e,r){var a,i=[],n={1:{},"-1":{}},s=null,o=0;if("pjn"==e){var h={status:!1,error:"parse"},c=r.split(" ");if(6!=c.length)return console.warn("FEN should have 6 parts"),h;var p=c[0].split("/"),l=t.geometry.fenHeight||t.geometry.height;if(p.length!=l)return console.warn("FEN board should have",l,"rows, got",p.length),h;var u={};for(var b in t.pieceTypes){var v=t.pieceTypes[b],f=v.fenAbbrev||v.abbrev||"X";u[f.toUpperCase()]={s:1,t:b},u[f.toLowerCase()]={s:-1,t:b}}var g=t.geometry.FenRowPos||function(e,r){return(t.geometry.height-1-e)*t.geometry.width+r};if(p.forEach(function(e,r){for(var a=0,n=0;n<e.length;n++){var s=e.substr(n,1),o=u[s];if(void 0!==o){var c=g(r,a);a++;for(var p={s:o.s,t:o.t,p:c},l=!0,b=t.pieceTypes[p.t].initial||[],v=0;v<b.length;v++){var f=b[v];f.s==p.s&&f.p==c&&(l=!1)}p.m=l,i.push(p)}else{if(isNaN(parseInt(s)))return console.warn("FEN invalid board spec",s),h;a+=parseInt(s)}}}),i.sort(function(t,e){return e.s-t.s}),"w"==c[1])a=1;else{if("b"!=c[1])return console.warn("FEN invalid turn spec",c[1]),h;a=-1}n[1].k=c[2].indexOf("K")>=0,n[1].q=c[2].indexOf("Q")>=0,n[-1].k=c[2].indexOf("k")>=0,n[-1].q=c[2].indexOf("q")>=0,s="-"==c[3]?null:c[3];var d=parseInt(c[4]);isNaN(d)||(o=d);var m={pieces:i,turn:a,castle:n,enPassant:s,noCaptCount:o};return t.importGame&&t.importGame.call(this,m,e,r),{status:!0,initial:m}}return{status:!1,error:"unsupported"}}}(),function(){Model.Game.cbBoardGeometryGrid=function(t,e){function r(e){return e%t}function a(e){return Math.floor(e/t)}function i(e,r){return r*t+e}function n(n,s){var o=r(n),h=a(n),c=o+s[0],p=h+s[1];return c<0||c>=t||p<0||p>=e?null:i(c,p)}function s(t){return String.fromCharCode("a".charCodeAt(0)+r(t))+(a(t)+1)}function o(t){var e=/^([a-z])([0-9]+)$/.exec(t);return e?i(e[1].charCodeAt(0)-"a".charCodeAt(0),parseInt(e[2])-1):-1}function h(t,e){return 0==e?String.fromCharCode("a".charCodeAt(0)+r(t)):1==e?a(t)+1:null}function c(){for(var i=[],n=0;n<t*e;n++){var s=[];i.push(s);for(var o=0;o<t*e;o++){var h=a(n),c=r(n),p=a(o),l=r(o);s.push(Math.max(Math.abs(h-p),Math.abs(c-l)))}}return i}function p(r,a,n){for(var o=[],h=e-1;h>=0;h--){for(var c="",p=0,l=0;l<t;l++){var u=r.board[i(l,h)];if(u<0)p++;else{p>0&&(c+=p,p=0);var b=r.pieces[u],v=a.pieceTypes[b.t].fenAbbrev||a.pieceTypes[b.t].abbrev||"?";b.s==-1?c+=v.toLowerCase():c+=v.toUpperCase()}}p&&(c+=p),o.push(c)}var f=o.join("/");f+=" ",1==r.mWho?f+="w":f+="b",f+=" ";var g="";return r.castled&&(r.castled[1]===!1?g+="KQ":(r.castled[1].k&&(g+="K"),r.castled[1].q&&(g+="Q")),r.castled[-1]===!1?g+="kq":(r.castled[-1].k&&(g+="k"),r.castled[-1].q&&(g+="q"))),0==g.length&&(g="-"),f+=g,f+=" ",r.epTarget?f+=s(r.epTarget.p):f+="-",f+=" ",f+=r.noCaptCount,f+=" ",f+=Math.floor(n/2)+1}return{boardSize:t*e,width:t,height:e,C:r,R:a,POS:i,Graph:n,PosName:s,PosByName:o,CompactCrit:h,GetDistances:c,distEdge:function(){for(var i=[],n=0;n<t*e;n++){var s=r(n),o=a(n);i[n]=Math.min(s,Math.abs(t-s-1),o,Math.abs(e-o-1))}return i}(),corners:function(){var r={};return r[i(0,0)]=1,r[i(0,e-1)]=1,r[i(t-1,0)]=1,r[i(t-1,e-1)]=1,r}(),ExportBoardState:p}},Model.Game.cbPawnGraph=function(t,e,r){for(var a=this,i={},n=0;n<t.boardSize;n++)if(!r||n in r){var s=[],o=t.Graph(n,[0,e]);null!=o&&(!r||o in r)&&s.push(a.cbTypedArray([o|a.cbConstants.FLAG_MOVE])),[-1,1].forEach(function(i){var o=t.Graph(n,[i,e]);null!=o&&(!r||o in r)&&s.push(a.cbTypedArray([o|a.cbConstants.FLAG_CAPTURE]))}),i[n]=s}else i[n]=[];return i},Model.Game.cbInitialPawnGraph=function(t,e,r){for(var a=this,i={},n=0;n<t.boardSize;n++)if(!r||n in r){var s=[],o=t.Graph(n,[0,e]);if(null!=o&&(!r||o in r)){var h=[o|a.cbConstants.FLAG_MOVE],c=t.Graph(o,[0,e]);null!=c&&(!r||c in r)&&h.push(c|a.cbConstants.FLAG_MOVE),s.push(a.cbTypedArray(h))}[-1,1].forEach(function(i){var o=t.Graph(n,[i,e]);null!=o&&(!r||o in r)&&s.push(a.cbTypedArray([o|a.cbConstants.FLAG_CAPTURE]))}),i[n]=s}else i[n]=[];return i},Model.Game.cbKingGraph=function(t,e){return this.cbShortRangeGraph(t,[[-1,-1],[-1,0],[-1,1],[0,-1],[0,1],[1,-1],[1,0],[1,1]],e)},Model.Game.cbKnightGraph=function(t,e){return this.cbShortRangeGraph(t,[[2,-1],[2,1],[-2,-1],[-2,1],[-1,2],[-1,-2],[1,2],[1,-2]],e)},Model.Game.cbHorseGraph=function(t){for(var e=this,r={},a=0;a<t.boardSize;a++)r[a]=[],[[1,0,2,-1],[1,0,2,1],[-1,0,-2,-1],[-1,0,-2,1],[0,1,-1,2],[0,-1,-1,-2],[0,1,1,2],[0,-1,1,-2]].forEach(function(i){var n=t.Graph(a,[i[0],i[1]]);if(null!=n){var s=t.Graph(a,[i[2],i[3]]);null!=s&&r[a].push(e.cbTypedArray([n|e.cbConstants.FLAG_STOP,s|e.cbConstants.FLAG_MOVE|e.cbConstants.FLAG_CAPTURE]))}});return r},Model.Game.cbRookGraph=function(t,e){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0]],e)},Model.Game.cbBishopGraph=function(t,e){return this.cbLongRangeGraph(t,[[1,-1],[1,1],[-1,1],[-1,-1]],e)},Model.Game.cbQueenGraph=function(t,e){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0],[1,-1],[1,1],[-1,1],[-1,-1]],e)},Model.Game.cbXQGeneralGraph=function(t,e){for(var r=this,a={},i=0;i<t.boardSize;i++)a[i]=[],[[-1,0,!1],[0,-1,!0],[0,1,!0],[1,0,!1]].forEach(function(n){var s=[],o=t.Graph(i,n);if(null!=o&&((!e||o in e)&&s.push(o|r.cbConstants.FLAG_MOVE|r.cbConstants.FLAG_CAPTURE),n[2]))for(var h=t.Graph(o,n);null!=h;)!e||h in e?s.push(h|r.cbConstants.FLAG_CAPTURE|r.cbConstants.FLAG_CAPTURE_KING):s.push(h|r.cbConstants.FLAG_STOP),h=t.Graph(h,n);s.length>0&&a[i].push(r.cbTypedArray(s))});return a},Model.Game.cbXQSoldierGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e]])},Model.Game.cbXQPromoSoldierGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e],[-1,0],[1,0]])},Model.Game.cbXQAdvisorGraph=function(t,e){return this.cbShortRangeGraph(t,[[1,1],[-1,1],[1,-1],[-1,-1]],e)},Model.Game.cbXQCannonGraph=function(t){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0]],null,this.cbConstants.FLAG_MOVE|this.cbConstants.FLAG_SCREEN_CAPTURE)},Model.Game.cbXQElephantGraph=function(t,e){for(var r=this,a={},i=0;i<t.boardSize;i++)a[i]=[],(!e||i in e)&&[[1,1,2,2],[1,-1,2,-2],[-1,1,-2,2],[-1,-1,-2,-2]].forEach(function(n){var s=t.Graph(i,[n[0],n[1]]);if(null!=s){var o=t.Graph(i,[n[2],n[3]]);null!=o&&(!e||o in e)&&a[i].push(r.cbTypedArray([s|r.cbConstants.FLAG_STOP,o|r.cbConstants.FLAG_MOVE|r.cbConstants.FLAG_CAPTURE]))}});return a},Model.Game.cbSilverGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e],[-1,-1],[-1,1],[1,-1],[1,1]])},Model.Game.cbFersGraph=function(t,e){return this.cbShortRangeGraph(t,[[-1,-1],[-1,1],[1,-1],[1,1]])},Model.Game.cbSchleichGraph=function(t,e){return this.cbShortRangeGraph(t,[[-1,0],[1,0],[0,-1],[0,1]])},Model.Game.cbAlfilGraph=function(t,e){return this.cbShortRangeGraph(t,[[-2,-2],[-2,2],[2,2],[2,-2]])}}(),function(){function t(t,r){return t.cbMergeGraphs(e,t.cbLongRangeGraph(e,[[0,r]],null,t.cbConstants.FLAG_MOVE,3),t.cbShortRangeGraph(e,[[-1,r],[1,r]],null,t.cbConstants.FLAG_CAPTURE))}var e=Model.Game.cbBoardGeometryGrid(10,10);Model.Game.cbDefine=function(){return{geometry:e,pieceTypes:{0:{name:"pawn-w",aspect:"fr-pawn",graph:this.cbPawnGraph(e,1),value:1,abbrev:"",fenAbbrev:"P",epCatch:!0},1:{name:"ipawn-w",aspect:"fr-pawn",graph:this.cbInitialPawnGraph(e,1),value:1,abbrev:"",fenAbbrev:"P",epTarget:!0},2:{name:"pawn-b",aspect:"fr-pawn",graph:this.cbPawnGraph(e,-1),value:1,abbrev:"",fenAbbrev:"P",epCatch:!0},3:{name:"ipawn-b",aspect:"fr-pawn",graph:this.cbInitialPawnGraph(e,-1),value:1,abbrev:"",fenAbbrev:"P",epTarget:!0},4:{name:"knight",aspect:"fr-knight",graph:this.cbKnightGraph(e),value:2.9,abbrev:"N",initial:[{s:1,p:1},{s:1,p:8},{s:-1,p:91},{s:-1,p:98}]},5:{name:"bishop",aspect:"fr-bishop",graph:this.cbBishopGraph(e),value:3.1,abbrev:"B",initial:[{s:1,p:2},{s:1,p:7},{s:-1,p:92},{s:-1,p:97}]},6:{name:"rook",aspect:"fr-rook",graph:this.cbRookGraph(e),value:5,abbrev:"R",initial:[{s:1,p:0},{s:1,p:9},{s:-1,p:90},{s:-1,p:99}],castle:!0},7:{name:"queen",aspect:"fr-queen",graph:this.cbQueenGraph(e),value:9,abbrev:"Q",initial:[{s:1,p:5},{s:-1,p:95}]},8:{name:"king",aspect:"fr-king",isKing:!0,graph:this.cbKingGraph(e),abbrev:"K",initial:[{s:1,p:4},{s:-1,p:94}]},9:{name:"commander",aspect:"fr-amazon",graph:this.cbMergeGraphs(e,this.cbQueenGraph(e),this.cbKnightGraph(e)),value:12,abbrev:"C",initial:[{s:1,p:3},{s:-1,p:93}]},10:{name:"adjutant",aspect:"fr-cardinal",graph:this.cbMergeGraphs(e,this.cbBishopGraph(e),this.cbKnightGraph(e)),value:6,abbrev:"A",initial:[{s:1,p:6},{s:-1,p:96}]},11:{name:"iipawn-w",aspect:"fr-pawn",graph:t(this,1),value:1,abbrev:"",fenAbbrev:"P",initial:[{s:1,p:10},{s:1,p:11},{s:1,p:12},{s:1,p:13},{s:1,p:14},{s:1,p:15},{s:1,p:16},{s:1,p:17},{s:1,p:18},{s:1,p:19}],epTarget:!0},12:{name:"iipawn-b",aspect:"fr-pawn",graph:t(this,-1),value:1,abbrev:"",fenAbbrev:"P",initial:[{s:-1,p:80},{s:-1,p:81},{s:-1,p:82},{s:-1,p:83},{s:-1,p:84},{s:-1,p:85},{s:-1,p:86},{s:-1,p:87},{s:-1,p:88},{s:-1,p:89}],epTarget:!0}},promote:function(t,r,a){if(11==r.t||12==r.t){return 1==Math.abs(e.R(a.t)-e.R(a.f))?[11==r.t?1:3]:[11==r.t?0:2]}if(1==r.t)return[0];if(3==r.t)return[2];var i=e.R(a.t);if(0==r.t&&9==e.R(a.t)||2==r.t&&0==e.R(a.t)){for(var n={4:1,5:1,6:1,7:1,9:1,10:1},s={},o=0;o<this.pieces.length;o++){var h=this.pieces[o];h.s==r.s&&h.p<0&&h.t in n&&(s[h.t]=1)}var c=[];for(var p in s)c.push(p);if(0!=i&&9!=i)c.unshift(r.t);else if(0==c.length)return null;return c}return[]},castle:{"4/0":{k:[3,2,1],r:[1,2,3],n:"O-O"},"4/9":{k:[5,6,7,8],r:[8,7,6,5],n:"O-O-O"},"94/90":{k:[93,92,91],r:[91,92,93],n:"O-O"},"94/99":{k:[95,96,97,98],r:[98,97,96,95],n:"O-O-O"}}}}}();

/***/ }),

/***/ "DZp3":
/***/ (function(module, exports) {

exports.model=Model={Game:{},Board:{},Move:{}},function(){var t;Model.Game.cbConstants={MASK:65535,FLAG_MOVE:65536,FLAG_CAPTURE:131072,FLAG_STOP:262144,FLAG_SCREEN_CAPTURE:524288,FLAG_CAPTURE_KING:1048576,FLAG_CAPTURE_NO_KING:2097152};var e="undefined"!=typeof Int32Array;Model.Game.cbUseTypedArrays=e,Model.Game.cbTypedArray=function(t){if(e){var r=new Int32Array(t.length);return r.set(t),r}for(var i=[],a=t.length,n=0;n<a;n++)i.push(t[n]);return i},Model.Game.cbShortRangeGraph=function(t,e,r,i){var a=this;void 0===i&&(i=196608);for(var n={},s=0;s<t.boardSize;s++)n[s]=[],(!r||s in r)&&e.forEach(function(e){var o=t.Graph(s,e);null!=o&&(!r||o in r)&&n[s].push(a.cbTypedArray([o|i]))});return n},Model.Game.cbLongRangeGraph=function(t,e,r,i,a){var n=this;void 0!==i&&null!=i||(i=196608),a||(a=1/0);for(var s={},o=0;o<t.boardSize;o++)s[o]=[],(!r||o in r)&&e.forEach(function(e){for(var h=[],p=t.Graph(o,e),c=0;null!=p&&(!r||p in r)&&(h.push(p|i),++c!=a);)p=t.Graph(p,e);h.length>0&&s[o].push(n.cbTypedArray(h))});return s},Model.Game.cbNullGraph=function(t){for(var e={},r=0;r<t.boardSize;r++)e[r]=[];return e},Model.Game.cbAuthorGraph=function(t){for(var e={},r=0;r<t.boardSize;r++){e[r]=[];for(var i=0;i<t.boardSize;i++)e[r].push([2293760|i])}return e},Model.Game.cbMergeGraphs=function(t){for(var e=[],r=0;r<t.boardSize;r++){e[r]=[];for(var i=1;i<arguments.length;i++)e[r]=e[r].concat(arguments[i][r])}return e},Model.Game.cbGetThreatGraph=function(){function t(e,r){for(var i in s){var a=s[i];if(!(a.p.length<r.length+1)){for(var n=!0,o=0;o<r.length;o++)if(r[o]!=a.p[o]){n=!1;break}if(n){var h=a.p[r.length],p=e[h];void 0===p&&(p={e:{}},e[h]=p),a.p.length==r.length+1&&(p.t=a.t,p.ts=a.ts,p.tk=a.tk,delete s[i]),r.push(h),t(p.e,r),r.pop()}}}}var e=this;this.cbUseScreenCapture=!1,this.cbUseCaptureKing=!1,this.cbUseCaptureNoKing=!1;for(var r={1:[],"-1":[]},i=[],a=0;a<this.g.boardSize;a++)this.g.pTypes.forEach(function(t,r){t.graph[a].forEach(function(t){for(var n=[],s=0;s<t.length;s++){var o=t[s];1048576&o?(e.cbUseCaptureKing=!0,n.unshift({d:65535&o,a:a,tk:r})):2097152&o?(e.cbUseCaptureNoKing=!0,n.unshift({d:65535&o,a:a,tnk:r})):131072&o?n.unshift({d:65535&o,a:a,t:r}):262144&o?n.unshift({d:65535&o,a:a}):524288&o&&(e.cbUseScreenCapture=!0,n.unshift({d:65535&o,a:a,ts:r}))}n.length>0&&i.push(n)})});var n={};i.forEach(function(t){t.forEach(function(e,r){var i=n[e.d];void 0===i&&(i={},n[e.d]=i);for(var a=[],s=r+1;s<t.length;s++)a.push(t[s].d);a.push(e.a);var o=a.join(","),h=i[o];void 0===h&&(h={p:a,t:{},ts:{},tk:{}},i[o]=h),void 0!==e.t?h.t[e.t]=!0:void 0!==e.tk?h.tk[e.tk]=!0:void 0!==e.ts&&(h.ts[e.ts]=!0)})});for(var a=0;a<e.g.boardSize;a++){var s=n[a],o={};t(o,[]),r[1][a]=o,r[-1][a]=o}return r},Model.Game.InitGame=function(){var e=this;this.cbVar=t=this.cbDefine(),this.g.boardSize=this.cbVar.geometry.boardSize,this.g.pTypes=this.cbGetPieceTypes(),this.g.threatGraph=this.cbGetThreatGraph(),this.g.distGraph=this.cbVar.geometry.GetDistances(),this.cbPiecesCount=0,this.g.castleablePiecesCount={1:0,"-1":0};for(var r in t.pieceTypes){var i=t.pieceTypes[r];if(i.castle){(i.initial||[]).forEach(function(t){e.g.castleablePiecesCount[t.s]++})}i.initial&&(this.cbPiecesCount+=i.initial.length)}for(var a=[],r=0;r<this.cbPiecesCount;r++)a.push(r);var n=Object.keys(t.pieceTypes);this.zobrist=new JocGame.Zobrist({board:{type:"array",size:this.cbVar.geometry.boardSize,values:a},who:{values:["1","-1"]},type:{type:"array",size:this.cbPiecesCount,values:n}})},Model.Game.cbGetPieceTypes=function(){for(var t=[],e={},r=0;r<this.cbVar.geometry.boardSize;r++)e[r]=[];for(var i in this.cbVar.pieceTypes){var a=this.cbVar.pieceTypes[i];t[i]={graph:a.graph||e,abbrev:a.abbrev||"",value:a.isKing?100:a.value||1,isKing:!!a.isKing,castle:!!a.castle,epTarget:!!a.epTarget,epCatch:!!a.epCatch}}return t},Model.Board.Init=function(t){this.zSign=0},Model.Board.InitialPosition=function(r){var i=this;this.board=e?new Int16Array(r.g.boardSize):[];for(var a=0;a<r.g.boardSize;a++)this.board[a]=-1;if(this.kings={},this.pieces=[],this.ending={1:!1,"-1":!1},this.lastMove=null,r.cbVar.castle&&(this.castled={1:!1,"-1":!1}),this.zSign=r.zobrist.update(0,"who",-1),this.noCaptCount=0,this.mWho=1,r.mInitial)this.mWho=r.mInitial.turn||1,r.mInitial.pieces.forEach(function(t){var e={};for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);i.pieces.push(e)}),r.mInitial.lastMove&&(this.lastMove={f:r.mInitial.lastMove.f,t:r.mInitial.lastMove.t}),void 0!==r.mInitial.noCaptCount&&(this.noCaptCount=r.mInitial.noCaptCount),r.cbVar.castle&&r.mInitial.castle&&(this.castled={1:{k:!!r.mInitial.castle[1]&&!!r.mInitial.castle[1].k,q:!!r.mInitial.castle[1]&&!!r.mInitial.castle[1].q},"-1":{k:!!r.mInitial.castle[-1]&&!!r.mInitial.castle[-1].k,q:!!r.mInitial.castle[-1]&&!!r.mInitial.castle[-1].q}});else for(var n in r.cbVar.pieceTypes)for(var s=r.cbVar.pieceTypes[n],o=s.initial||[],h=0;h<o.length;h++){var p=o[h],c={s:p.s,t:parseInt(n),p:p.p,m:!1};this.pieces.push(c)}if(this.pieces.sort(function(t,e){if(t.s!=e.s)return e.s-t.s;var i=r.cbVar.pieceTypes[t.t].value||100,a=r.cbVar.pieceTypes[e.t].value||100;return i!=a?i-a:t.p-e.p}),this.pieces.forEach(function(t,e){t.i=e,i.board[t.p]=e,r.g.pTypes[t.t].isKing&&(i.kings[t.s]=t.p),i.zSign=r.zobrist.update(i.zSign,"board",e,t.p),i.zSign=r.zobrist.update(i.zSign,"type",t.t,e)}),r.mInitial&&r.mInitial.enPassant){var a=t.geometry.PosByName(r.mInitial.enPassant);if(a>=0){var l,u=t.geometry.C(a),v=t.geometry.R(a);l=1==r.mInitial.turn?t.geometry.POS(u,v-1):t.geometry.POS(u,v+1),this.epTarget={p:a,i:this.board[l]}}}},Model.Board.CopyFrom=function(t){if(e)this.board=new Int16Array(t.board.length),this.board.set(t.board);else{this.board=[];for(var r=t.board,i=r.length,a=0;a<i;a++)this.board.push(r[a])}this.pieces=[];for(var n=t.pieces.length,a=0;a<n;a++){var s=t.pieces[a];this.pieces.push({s:s.s,p:s.p,t:s.t,i:s.i,m:s.m})}this.kings={1:t.kings[1],"-1":t.kings[-1]},this.check=t.check,t.lastMove?this.lastMove={f:t.lastMove.f,t:t.lastMove.t,c:t.lastMove.c}:this.lastMove=null,this.ending={1:t.ending[1],"-1":t.ending[-1]},void 0!==t.castled&&(this.castled={1:t.castled[1],"-1":t.castled[-1]}),this.noCaptCount=t.noCaptCount,t.epTarget?this.epTarget={p:t.epTarget.p,i:t.epTarget.i}:this.epTarget=null,this.mWho=t.mWho,this.zSign=t.zSign},Model.Board.cbApplyCastle=function(t,e,r){var i=t.cbVar.castle[e.f+"/"+e.cg],a=i.r[i.r.length-1],n=this.pieces[this.board[e.cg]],s=i.k[i.k.length-1],o=this.pieces[this.board[e.f]];return r&&(this.zSign=t.zobrist.update(this.zSign,"board",n.i,e.cg),this.zSign=t.zobrist.update(this.zSign,"board",n.i,a),this.zSign=t.zobrist.update(this.zSign,"board",o.i,e.f),this.zSign=t.zobrist.update(this.zSign,"board",o.i,s)),n.p=a,n.m=!0,this.board[e.cg]=-1,o.p=s,o.m=!0,this.board[e.f]=-1,this.board[a]=n.i,this.board[s]=o.i,this.castled[n.s]=!0,this.kings[o.s]=s,[{i:n.i,f:a,t:-1},{i:o.i,f:s,t:e.f,kp:e.f,who:o.s,m:!1},{i:n.i,f:-1,t:e.cg,m:!1,cg:!1}]},Model.Board.cbQuickApply=function(t,e){if(void 0!==e.cg)return this.cbApplyCastle(t,e,!1);var r=[],i=this.board[e.f],a=this.pieces[i];if(null!=e.c){r.unshift({i:e.c,f:-1,t:this.pieces[e.c].p});var n=this.pieces[e.c];this.board[n.p]=-1,n.p=-1}var s=this.kings[a.s];return t.g.pTypes[a.t].isKing&&(this.kings[a.s]=e.t),r.unshift({i:i,f:e.t,t:e.f,kp:s,who:a.s,ty:a.t}),a.p=e.t,void 0!==e.pr&&(a.t=e.pr),this.board[e.f]=-1,this.board[e.t]=i,r},Model.Board.cbQuickUnapply=function(t,e){for(var r=0;r<e.length;r++){var i=e[r],a=this.pieces[i.i];i.f>=0&&(a.p=-1,this.board[i.f]=-1),i.t>=0&&(a.p=i.t,this.board[i.t]=i.i),void 0!==i.m&&(a.m=i.m),void 0!==i.kp&&(this.kings[i.who]=i.kp),void 0!=i.ty&&(a.t=i.ty),void 0!=i.cg&&(this.castled[a.s]=i.cg)}},Model.Board.ApplyMove=function(t,e){var r=this.pieces[this.board[e.f]];if(void 0!==e.cg)this.cbApplyCastle(t,e,!0);else{if(this.zSign=t.zobrist.update(this.zSign,"board",r.i,e.f),this.board[r.p]=-1,void 0!==e.pr&&(this.zSign=t.zobrist.update(this.zSign,"type",r.t,r.i),r.t=e.pr,this.zSign=t.zobrist.update(this.zSign,"type",r.t,r.i)),null!=e.c){var i=this.pieces[e.c];this.zSign=t.zobrist.update(this.zSign,"board",i.i,i.p),this.board[i.p]=-1,i.p=-1,i.m=!0,this.noCaptCount=0}else this.noCaptCount++;r.p=e.t,r.m=!0,this.board[e.t]=r.i,this.zSign=t.zobrist.update(this.zSign,"board",r.i,e.t),t.g.pTypes[r.t].isKing&&(this.kings[r.s]=e.t)}this.check=!!e.ck,this.lastMove={f:e.f,t:e.t,c:e.c},void 0!==e.ko&&(this.ending[r.s]=e.ko),void 0!==e.ept?this.epTarget={p:e.ept,i:r.i}:this.epTarget=null,this.zSign=t.zobrist.update(this.zSign,"who",-this.mWho),this.zSign=t.zobrist.update(this.zSign,"who",this.mWho)},Model.Board.Evaluate=function(r){function i(e){var r=1/0;for(var i in t.geometry.corners)r=Math.min(r,h.distGraph[n.kings[e]][i]);return r-Math.sqrt(h.boardSize)}var a="debug"==arguments[3],n=this;this.mEvaluation=0;var s,o=this.mWho,h=r.g;if(e)s={1:{count:new Uint8Array(h.pTypes.length),byType:{}},"-1":{count:new Uint8Array(h.pTypes.length),byType:{}}};else{s={1:{count:[],byType:{}},"-1":{count:[],byType:{}}};for(var p=0;p<h.pTypes.length;p++)s[1].count[p]=s[-1].count[p]=0}if(r.mOptions.preventRepeat&&r.GetRepeatOccurence(this)>2)return this.mFinished=!0,void(this.mWinner=r.cbOnPerpetual?o*r.cbOnPerpetual:JocGame.DRAW);for(var c={1:0,"-1":0},l={1:h.distGraph[this.kings[-1]],"-1":h.distGraph[this.kings[1]]},u={1:0,"-1":0},v={1:0,"-1":0},f={1:0,"-1":0},d={1:0,"-1":0},b={1:!1,"-1":!1},g=this.pieces,O=g.length,p=0;p<O;p++){var m=g[p];if(m.p>=0){var k=m.s,G=h.pTypes[m.t];G.isKing?b[k]=m.m:c[k]+=G.value,G.castle&&!m.m&&d[k]++,v[k]++,u[k]+=l[k][m.p],f[k]+=t.geometry.distEdge[m.p];var M=s[k];M.count[m.t]++;var y=M.byType;void 0===y[m.t]?y[m.t]=[m]:y[m.t].push(m)}}if(this.lastMove&&null!=this.lastMove.c){var m=this.pieces[this.board[this.lastMove.t]];c[-m.s]+=this.cbStaticExchangeEval(r,m.p,m.s,{piece:m})}var S={1:0,"-1":0},C={1:0,"-1":0},A={1:0,"-1":0};this.ending[1]&&(C[1]=(u[1]-Math.sqrt(h.boardSize))/v[1],t.geometry.corners&&(A[1]=i(1))),this.ending[-1]&&(C[-1]=(u[-1]-Math.sqrt(h.boardSize))/v[-1],t.geometry.corners&&(A[1]=i(-1)));var T={pieceValue:c[1]-c[-1],pieceValueRatio:(c[1]-c[-1])/(c[1]+c[-1]+1),posValue:f[1]-f[-1],averageDistKing:u[1]/v[1]-u[-1]/v[-1],check:this.check?-o:0,endingKingFreedom:S[1]-S[-1],endingDistKing:C[1]-C[-1],distKingCorner:A[1]-A[-1]};t.castle&&(T.castle=(this.castled[1]?1:b[1]?0:d[1]/(h.castleablePiecesCount[1]+1))-(this.castled[-1]?1:b[-1]?0:d[-1]/(h.castleablePiecesCount[-1]+1))),t.evaluate&&t.evaluate.call(this,r,T,s);var z=r.mOptions.levelOptions;for(var E in T){var P=T[E],w=z[E+"Factor"]||0,R=P*w;a&&console.log(E,"=",P,"*",w,"=>",R),this.mEvaluation+=R}a&&console.log("Evaluation",this.mEvaluation)},Model.Board.cbGeneratePseudoLegalMoves=function(t){function e(e,a){var n=t.cbVar.promote;if(!n)return void i.push(a);var s=n.call(r,t,e,a);if(null!=s)if(0==s.length)i.push(a);else if(1==s.length)a.pr=s[0],i.push(a);else for(var o=0;o<s.length;o++){var h=s[o];i.push({f:a.f,t:a.t,c:a.c,pr:h,ept:a.ept,ep:a.ep,a:a.a})}}for(var r=this,i=[],a=t.cbVar,n=this.mWho,s=!a.castle||this.check||this.castled[n]?null:[],o=-1,h=this.pieces.length,p=0;p<h;p++){var c=this.pieces[p];if(!(c.p<0||c.s!=n)){var l=t.g.pTypes[c.t];l.isKing&&(c.m?s=null:o=c),s&&l.castle&&!c.m&&s.push(c);var u,v;u=l.graph[c.p],v=u.length;for(var f=0;f<v;f++)for(var d=u[f],b=!1,g=d.length,O=null,m=0;m<g;m++){var k=d[m],G=65535&k,M=this.board[G];if(!(M<0)||l.epCatch&&this.epTarget&&this.epTarget.p==G){if(!(524288&k)){var y;y=M<0?this.pieces[this.epTarget.i]:this.pieces[M],!(y.s!=c.s&&131072&k)||1048576&k&&!t.g.pTypes[y.t].isKing||2097152&k&&t.g.pTypes[y.t].isKing||e(c,{f:c.p,t:G,c:y.i,a:l.abbrev,ep:M<0});break}if(b){var y=this.pieces[M];y.s!=c.s&&e(c,{f:c.p,t:G,c:y.i,a:l.abbrev});break}b=!0}else 65536&k&&0==b&&e(c,{f:c.p,t:G,c:null,a:l.abbrev,ept:null!=O&&l.epTarget?O:void 0});O=G}}}if(s)for(var p=0;p<s.length;p++){var S=s[p],C=t.cbVar.castle[o.p+"/"+S.p];if(C){for(var A=!0,f=0;f<C.r.length;f++){var T=C.r[f];if(this.board[T]>=0&&T!=o.p&&T!=S.p){A=!1;break}}if(A){for(var z=!0,f=0;f<C.k.length;f++){var T=C.k[f];if(this.board[T]>=0&&T!=S.p&&T!=o.p||this.cbGetAttackers(t,T,n).length>0){z=!1;break}}z&&i.push({f:o.p,t:C.k[C.k.length-1],c:null,cg:S.p})}}}return i},Model.Board.cbStaticExchangeEval=function(t,e,r,i){var a=0,n=this.cbGetSmallestAttacker(t,e,r);if(n){var s=this.mWho;this.mWho=n.s;var o=this.cbQuickApply(t,{f:n.p,t:e,c:i.piece.i}),h=t.g.pTypes[i.piece.t].value;i.piece=n,a=Math.max(0,h-this.cbStaticExchangeEval(t,e,-r,i)),this.cbQuickUnapply(t,o),this.mWho=s}return a},Model.Board.cbGetSmallestAttacker=function(t,e,r){var i=this.cbGetAttackers(t,e,r);if(0==i.length)return null;for(var a=1/0,n=null,s=i.length,o=0;o<s;o++){var h=i[o],p=t.g.pTypes[h.t].value;p<a&&(a=p,n=h)}return n},Model.Board.cbCollectAttackers=function(t,e,r,i){for(var a in e){var n=e[a],s=this.board[a];if(s<0)this.cbCollectAttackers(t,n.e,r,i);else{var o=this.pieces[s];o.s==-t&&(n.t&&o.t in n.t||i&&n.tk&&o.t in n.tk)&&r.push(o)}}},Model.Board.cbCollectAttackersScreen=function(t,e,r,i,a){for(var n in e){var s=e[n],o=this.board[n];if(o<0)this.cbCollectAttackersScreen(t,s.e,r,i,a);else{var h=this.pieces[o];!a&&h.s==-t&&(s.t&&h.t in s.t||i&&s.tk&&h.t in s.tk)?r.push(h):a?a&&h.s==-t&&s.ts&&h.t in s.ts&&r.push(h):this.cbCollectAttackersScreen(t,s.e,r,i,!0)}}},Model.Board.cbGetAttackers=function(t,e,r,i){var a=[];return t.cbUseScreenCapture?this.cbCollectAttackersScreen(r,t.g.threatGraph[r][e],a,i,!1):this.cbCollectAttackers(r,t.g.threatGraph[r][e],a,i),a},Model.Board.GenerateMoves=function(t){var e=this.cbGeneratePseudoLegalMoves(t);this.mMoves=[];for(var r=!0,i=this.kings[this.mWho],a=e.length,n=0;n<a;n++){var s=e[n],o=this.cbQuickApply(t,s);if(!(this.cbGetAttackers(t,this.kings[this.mWho],this.mWho,!0).length>0)){var h=this.cbGetAttackers(t,this.kings[-this.mWho],-this.mWho,!0).length>0;s.ck=h,this.mMoves.push(s),s.f!=i&&(r=!1)}this.cbQuickUnapply(t,o)}if(0==this.mMoves.length)this.mFinished=!0,this.mWinner=t.cbOnStaleMate?t.cbOnStaleMate*this.mWho:JocGame.DRAW,this.check&&(this.mWinner=-this.mWho);else if(this.ending[this.mWho]){if(!r)for(var n=0;n<this.mMoves.length;n++)this.mMoves[n].ko=!1}else if(!this.ending[this.mWho]&&r&&!this.check)for(var n=0;n<this.mMoves.length;n++)this.mMoves[n].ko=!0},Model.Board.GetSignature=function(){return this.zSign},Model.Move.Init=function(t){for(var e in t)t.hasOwnProperty(e)&&(this[e]=t[e])},Model.Move.Equals=function(t){return this.f==t.f&&this.t==t.t&&this.pr==t.pr},Model.Move.CopyFrom=function(t){this.Init(t)},Model.Move.ToString=function(e){var r=this;switch(e=e||"natural"){case"natural":return function(){var e;if(void 0!==r.cg?e=t.castle[r.f+"/"+r.cg].n:(e=r.a||"",e+=t.geometry.PosName(r.f),null==r.c?e+="-":e+="x",e+=t.geometry.PosName(r.t)),void 0!==r.pr){var i=t.pieceTypes[r.pr];i&&i.abbrev&&i.abbrev.length>0&&!i.silentPromo&&(e+="="+i.abbrev)}return r.ck&&(e+="+"),e}();case"engine":return function(){var e=t.geometry.PosName(r.f)+t.geometry.PosName(r.t);if(void 0!=r.pr){var i=t.pieceTypes[r.pr];i&&i.abbrev&&i.abbrev.length>0&&!i.silentPromo&&(e+=i.abbrev)}return e}();default:return"??"}},Model.Board.CompactMoveString=function(e,r,i){"function"!=typeof r.ToString&&(r=e.CreateMove(r));var a=r.ToString(),n=/^([A-Z]?)([a-z])([1-9][0-9]*)([-x])([a-z])([1-9][0-9]*)(.*?)$/.exec(a);if(!n)return a;var s=n[7];if(i||(i={}),i.value||(i.value=[]),0==i.value.length){var o=this.mMoves;this.mMoves&&0!=this.mMoves.length||this.GenerateMoves(e);for(var h=0;h<this.mMoves.length;h++){var p=this.mMoves[h];"function"!=typeof p.ToString&&(p=e.CreateMove(p)),i.value.push({str:p.ToString(),move:p})}this.mMoves=o}var c=[];if(i.value.forEach(function(t){var e=/^([A-Z]?[a-z][1-9][0-9]*[-x][a-z][1-9][0-9]*)(.*?)$/.exec(t.str);e&&t.move.t==r.t&&(t.move.a||"")==n[1]&&e[2]==s&&c.push(t.move)}),1==c.length)return""==n[1]&&"x"==n[4]?n[2]+"x"+n[5]+n[6]+n[7]:n[1]+("x"==n[4]?"x":"")+n[5]+n[6]+n[7];if(t.geometry.CompactCrit)for(var l="",h=0;;h++){var u=t.geometry.CompactCrit(r.f,h);if(null==u)return a;l+=u;for(var v=[],f=0;f<c.length;f++){var d=c[f];t.geometry.CompactCrit(d.f,h)==u&&v.push(d)}if(console.assert(v.length>0),1==v.length)return n[1]+l+("x"==n[4]?"x":"")+n[5]+n[6]+n[7];c=v}return a},Model.Board.cbIntegrity=function(t){function e(t,e){t||console.error(e)}for(var r=this,i=0;i<this.board.length;i++){var a=this.board[i];if(a>=0){var n=r.pieces[a];e(void 0!==n,"no piece at pos"),e(n.p==i,"piece has different pos")}}for(var a=0;a<this.pieces.length;a++){var n=this.pieces[a];n.p>=0&&e(r.board[n.p]==a,"board index mismatch")}},Model.Board.ExportBoardState=function(t){return t.cbVar.geometry.ExportBoardState?t.cbVar.geometry.ExportBoardState(this,t.cbVar,t.mPlayedMoves.length):"not supported"},Model.Game.Import=function(e,r){var i,a=[],n={1:{},"-1":{}},s=null,o=0;if("pjn"==e){var h={status:!1,error:"parse"},p=r.split(" ");if(6!=p.length)return console.warn("FEN should have 6 parts"),h;var c=p[0].split("/"),l=t.geometry.fenHeight||t.geometry.height;if(c.length!=l)return console.warn("FEN board should have",l,"rows, got",c.length),h;var u={};for(var v in t.pieceTypes){var f=t.pieceTypes[v],d=f.fenAbbrev||f.abbrev||"X";u[d.toUpperCase()]={s:1,t:v},u[d.toLowerCase()]={s:-1,t:v}}var b=t.geometry.FenRowPos||function(e,r){return(t.geometry.height-1-e)*t.geometry.width+r};if(c.forEach(function(e,r){for(var i=0,n=0;n<e.length;n++){var s=e.substr(n,1),o=u[s];if(void 0!==o){var p=b(r,i);i++;for(var c={s:o.s,t:o.t,p:p},l=!0,v=t.pieceTypes[c.t].initial||[],f=0;f<v.length;f++){var d=v[f];d.s==c.s&&d.p==p&&(l=!1)}c.m=l,a.push(c)}else{if(isNaN(parseInt(s)))return console.warn("FEN invalid board spec",s),h;i+=parseInt(s)}}}),a.sort(function(t,e){return e.s-t.s}),"w"==p[1])i=1;else{if("b"!=p[1])return console.warn("FEN invalid turn spec",p[1]),h;i=-1}n[1].k=p[2].indexOf("K")>=0,n[1].q=p[2].indexOf("Q")>=0,n[-1].k=p[2].indexOf("k")>=0,n[-1].q=p[2].indexOf("q")>=0,s="-"==p[3]?null:p[3];var g=parseInt(p[4]);isNaN(g)||(o=g);var O={pieces:a,turn:i,castle:n,enPassant:s,noCaptCount:o};return t.importGame&&t.importGame.call(this,O,e,r),{status:!0,initial:O}}return{status:!1,error:"unsupported"}}}(),function(){Model.Game.cbBoardGeometryGrid=function(t,e){function r(e){return e%t}function i(e){return Math.floor(e/t)}function a(e,r){return r*t+e}function n(n,s){var o=r(n),h=i(n),p=o+s[0],c=h+s[1];return p<0||p>=t||c<0||c>=e?null:a(p,c)}function s(t){return String.fromCharCode("a".charCodeAt(0)+r(t))+(i(t)+1)}function o(t){var e=/^([a-z])([0-9]+)$/.exec(t);return e?a(e[1].charCodeAt(0)-"a".charCodeAt(0),parseInt(e[2])-1):-1}function h(t,e){return 0==e?String.fromCharCode("a".charCodeAt(0)+r(t)):1==e?i(t)+1:null}function p(){for(var a=[],n=0;n<t*e;n++){var s=[];a.push(s);for(var o=0;o<t*e;o++){var h=i(n),p=r(n),c=i(o),l=r(o);s.push(Math.max(Math.abs(h-c),Math.abs(p-l)))}}return a}function c(r,i,n){for(var o=[],h=e-1;h>=0;h--){for(var p="",c=0,l=0;l<t;l++){var u=r.board[a(l,h)];if(u<0)c++;else{c>0&&(p+=c,c=0);var v=r.pieces[u],f=i.pieceTypes[v.t].fenAbbrev||i.pieceTypes[v.t].abbrev||"?";v.s==-1?p+=f.toLowerCase():p+=f.toUpperCase()}}c&&(p+=c),o.push(p)}var d=o.join("/");d+=" ",1==r.mWho?d+="w":d+="b",d+=" ";var b="";return r.castled&&(r.castled[1]===!1?b+="KQ":(r.castled[1].k&&(b+="K"),r.castled[1].q&&(b+="Q")),r.castled[-1]===!1?b+="kq":(r.castled[-1].k&&(b+="k"),r.castled[-1].q&&(b+="q"))),0==b.length&&(b="-"),d+=b,d+=" ",r.epTarget?d+=s(r.epTarget.p):d+="-",d+=" ",d+=r.noCaptCount,d+=" ",d+=Math.floor(n/2)+1}return{boardSize:t*e,width:t,height:e,C:r,R:i,POS:a,Graph:n,PosName:s,PosByName:o,CompactCrit:h,GetDistances:p,distEdge:function(){for(var a=[],n=0;n<t*e;n++){var s=r(n),o=i(n);a[n]=Math.min(s,Math.abs(t-s-1),o,Math.abs(e-o-1))}return a}(),corners:function(){var r={};return r[a(0,0)]=1,r[a(0,e-1)]=1,r[a(t-1,0)]=1,r[a(t-1,e-1)]=1,r}(),ExportBoardState:c}},Model.Game.cbPawnGraph=function(t,e,r){for(var i=this,a={},n=0;n<t.boardSize;n++)if(!r||n in r){var s=[],o=t.Graph(n,[0,e]);null!=o&&(!r||o in r)&&s.push(i.cbTypedArray([o|i.cbConstants.FLAG_MOVE])),[-1,1].forEach(function(a){var o=t.Graph(n,[a,e]);null!=o&&(!r||o in r)&&s.push(i.cbTypedArray([o|i.cbConstants.FLAG_CAPTURE]))}),a[n]=s}else a[n]=[];return a},Model.Game.cbInitialPawnGraph=function(t,e,r){for(var i=this,a={},n=0;n<t.boardSize;n++)if(!r||n in r){var s=[],o=t.Graph(n,[0,e]);if(null!=o&&(!r||o in r)){var h=[o|i.cbConstants.FLAG_MOVE],p=t.Graph(o,[0,e]);null!=p&&(!r||p in r)&&h.push(p|i.cbConstants.FLAG_MOVE),s.push(i.cbTypedArray(h))}[-1,1].forEach(function(a){var o=t.Graph(n,[a,e]);null!=o&&(!r||o in r)&&s.push(i.cbTypedArray([o|i.cbConstants.FLAG_CAPTURE]))}),a[n]=s}else a[n]=[];return a},Model.Game.cbKingGraph=function(t,e){return this.cbShortRangeGraph(t,[[-1,-1],[-1,0],[-1,1],[0,-1],[0,1],[1,-1],[1,0],[1,1]],e)},Model.Game.cbKnightGraph=function(t,e){return this.cbShortRangeGraph(t,[[2,-1],[2,1],[-2,-1],[-2,1],[-1,2],[-1,-2],[1,2],[1,-2]],e)},Model.Game.cbHorseGraph=function(t){for(var e=this,r={},i=0;i<t.boardSize;i++)r[i]=[],[[1,0,2,-1],[1,0,2,1],[-1,0,-2,-1],[-1,0,-2,1],[0,1,-1,2],[0,-1,-1,-2],[0,1,1,2],[0,-1,1,-2]].forEach(function(a){var n=t.Graph(i,[a[0],a[1]]);if(null!=n){var s=t.Graph(i,[a[2],a[3]]);null!=s&&r[i].push(e.cbTypedArray([n|e.cbConstants.FLAG_STOP,s|e.cbConstants.FLAG_MOVE|e.cbConstants.FLAG_CAPTURE]))}});return r},Model.Game.cbRookGraph=function(t,e){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0]],e)},Model.Game.cbBishopGraph=function(t,e){return this.cbLongRangeGraph(t,[[1,-1],[1,1],[-1,1],[-1,-1]],e)},Model.Game.cbQueenGraph=function(t,e){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0],[1,-1],[1,1],[-1,1],[-1,-1]],e)},Model.Game.cbXQGeneralGraph=function(t,e){for(var r=this,i={},a=0;a<t.boardSize;a++)i[a]=[],[[-1,0,!1],[0,-1,!0],[0,1,!0],[1,0,!1]].forEach(function(n){var s=[],o=t.Graph(a,n);if(null!=o&&((!e||o in e)&&s.push(o|r.cbConstants.FLAG_MOVE|r.cbConstants.FLAG_CAPTURE),n[2]))for(var h=t.Graph(o,n);null!=h;)!e||h in e?s.push(h|r.cbConstants.FLAG_CAPTURE|r.cbConstants.FLAG_CAPTURE_KING):s.push(h|r.cbConstants.FLAG_STOP),h=t.Graph(h,n);s.length>0&&i[a].push(r.cbTypedArray(s))});return i},Model.Game.cbXQSoldierGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e]])},Model.Game.cbXQPromoSoldierGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e],[-1,0],[1,0]])},Model.Game.cbXQAdvisorGraph=function(t,e){return this.cbShortRangeGraph(t,[[1,1],[-1,1],[1,-1],[-1,-1]],e)},Model.Game.cbXQCannonGraph=function(t){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0]],null,this.cbConstants.FLAG_MOVE|this.cbConstants.FLAG_SCREEN_CAPTURE)},Model.Game.cbXQElephantGraph=function(t,e){for(var r=this,i={},a=0;a<t.boardSize;a++)i[a]=[],(!e||a in e)&&[[1,1,2,2],[1,-1,2,-2],[-1,1,-2,2],[-1,-1,-2,-2]].forEach(function(n){var s=t.Graph(a,[n[0],n[1]]);if(null!=s){var o=t.Graph(a,[n[2],n[3]]);null!=o&&(!e||o in e)&&i[a].push(r.cbTypedArray([s|r.cbConstants.FLAG_STOP,o|r.cbConstants.FLAG_MOVE|r.cbConstants.FLAG_CAPTURE]))}});return i},Model.Game.cbSilverGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e],[-1,-1],[-1,1],[1,-1],[1,1]])},Model.Game.cbFersGraph=function(t,e){return this.cbShortRangeGraph(t,[[-1,-1],[-1,1],[1,-1],[1,1]])},Model.Game.cbSchleichGraph=function(t,e){return this.cbShortRangeGraph(t,[[-1,0],[1,0],[0,-1],[0,1]])},Model.Game.cbAlfilGraph=function(t,e){return this.cbShortRangeGraph(t,[[-2,-2],[-2,2],[2,2],[2,-2]])}}(),function(){var t=Model.Game.cbBoardGeometryGrid(8,8);Model.Game.cbDefine=function(){return{geometry:t,pieceTypes:{0:{name:"pawn-w",aspect:"pawn",graph:this.cbPawnGraph(t,1),value:1,abbrev:"",fenAbbrev:"P",epCatch:!0},1:{name:"ipawn-w",aspect:"pawn",graph:this.cbInitialPawnGraph(t,1),value:1,abbrev:"",fenAbbrev:"P",initial:[{s:1,p:8},{s:1,p:9},{s:1,p:10},{s:1,p:11},{s:1,p:12},{s:1,p:13},{s:1,p:14},{s:1,p:15}],epTarget:!0},2:{name:"pawn-b",aspect:"pawn",graph:this.cbPawnGraph(t,-1),value:1,abbrev:"",fenAbbrev:"P",epCatch:!0},3:{name:"ipawn-b",aspect:"pawn",graph:this.cbInitialPawnGraph(t,-1),value:1,abbrev:"",fenAbbrev:"P",initial:[{s:-1,p:48},{s:-1,p:49},{s:-1,p:50},{s:-1,p:51},{s:-1,p:52},{s:-1,p:53},{s:-1,p:54},{s:-1,p:55}],epTarget:!0},4:{name:"knight",graph:this.cbKnightGraph(t),value:2.9,abbrev:"N",initial:[{s:1,p:1},{s:1,p:6},{s:-1,p:57},{s:-1,p:62}]},5:{name:"bishop",graph:this.cbBishopGraph(t),value:3.1,abbrev:"B",initial:[{s:1,p:2},{s:1,p:5},{s:-1,p:58},{s:-1,p:61}]},6:{name:"rook",graph:this.cbRookGraph(t),value:5,abbrev:"R",initial:[{s:1,p:0},{s:1,p:7},{s:-1,p:56},{s:-1,p:63}],castle:!0},7:{name:"queen",graph:this.cbQueenGraph(t),value:9,abbrev:"Q",initial:[{s:1,p:3},{s:-1,p:59}]},8:{name:"king",isKing:!0,graph:this.cbKingGraph(t),abbrev:"K",initial:[{s:1,p:4},{s:-1,p:60}]}},promote:function(e,r,i){return 1==r.t?[0]:3==r.t?[2]:0==r.t&&7==t.R(i.t)?[4,5,6,7]:2==r.t&&0==t.R(i.t)?[4,5,6,7]:[]},castle:{"1/0":{k:[2],r:[1,2,3],n:"O-O-O"},"2/0":{k:[2],r:[1,2,3],n:"O-O-O"},"3/0":{k:[2],r:[1,2,3],n:"O-O-O"},"4/0":{k:[3,2],r:[1,2,3],n:"O-O-O"},"5/0":{k:[4,3,2],r:[1,2,3],n:"O-O-O"},"6/0":{k:[5,4,3,2],r:[1,2,3],n:"O-O-O"},"2/1":{k:[2],r:[2,3],n:"O-O-O"},"3/1":{k:[2],r:[2,3],n:"O-O-O"},"4/1":{k:[3,2],r:[2,3],n:"O-O-O"},"5/1":{k:[4,3,2],r:[2,3],n:"O-O-O"},"6/1":{k:[5,4,3,2],r:[2,3],n:"O-O-O"},"3/2":{k:[2],r:[3],n:"O-O-O"},"4/2":{k:[3,2],r:[3],n:"O-O-O"},"5/2":{k:[4,3,2],r:[3],n:"O-O-O"},"6/2":{k:[5,4,3,2],r:[3],n:"O-O-O"},"4/3":{k:[3,2],r:[3],n:"O-O-O"},"5/3":{k:[4,3,2],r:[3],n:"O-O-O"},"6/3":{k:[5,4,3,2],r:[3],n:"O-O-O"},"5/4":{k:[4,3,2],r:[3],n:"O-O-O"},"6/4":{k:[5,4,3,2],r:[3],n:"O-O-O"},"6/5":{k:[5,4,3,2],r:[4,3],n:"O-O-O"},"1/7":{k:[2,3,4,5,6],r:[6,5],n:"O-O"},"2/7":{k:[3,4,5,6],r:[6,5],n:"O-O"},"3/7":{k:[4,5,6],r:[6,5],n:"O-O"},"4/7":{k:[5,6],r:[6,5],n:"O-O"},"5/7":{k:[6],r:[6,5],n:"O-O"},"6/7":{k:[6],r:[6,5],n:"O-O"},"1/6":{k:[2,3,4,5,6],r:[5],n:"O-O"},"2/6":{k:[3,4,5,6],r:[5],n:"O-O"},"3/6":{k:[4,5,6],r:[5],n:"O-O"},"4/6":{k:[5,6],r:[5],n:"O-O"},"5/6":{k:[6],r:[5],n:"O-O"},"1/5":{k:[2,3,4,5,6],r:[5],n:"O-O"},"2/5":{k:[3,4,5,6],r:[5],n:"O-O"},"3/5":{k:[4,5,6],r:[5],n:"O-O"},"4/5":{k:[5,6],r:[5],n:"O-O"},"1/4":{k:[2,3,4,5,6],r:[5],n:"O-O"},"2/4":{k:[3,4,5,6],r:[5],n:"O-O"},"3/4":{k:[4,5,6],r:[5],n:"O-O"},"1/3":{k:[2,3,4,5,6],r:[4,5],n:"O-O"},"2/3":{k:[3,4,5,6],r:[4,5],n:"O-O"},"1/2":{k:[2,3,4,5,6],r:[3,4,5],n:"O-O"},"57/56":{k:[58],r:[57,58,59],n:"O-O-O"},"58/56":{k:[58],r:[57,58,59],n:"O-O-O"},"59/56":{k:[58],r:[57,58,59],n:"O-O-O"},"60/56":{k:[59,58],r:[57,58,59],n:"O-O-O"},"61/56":{k:[60,59,58],r:[57,58,59],n:"O-O-O"},"62/56":{k:[61,60,59,58],r:[57,58,59],n:"O-O-O"},"58/57":{k:[58],r:[58,59],n:"O-O-O"},"59/57":{k:[58],r:[58,59],n:"O-O-O"},"60/57":{k:[59,58],r:[58,59],n:"O-O-O"},"61/57":{k:[60,59,58],r:[58,59],n:"O-O-O"},"62/57":{k:[61,60,59,58],r:[58,59],n:"O-O-O"},"59/58":{k:[58],r:[59],n:"O-O-O"},"60/58":{k:[59,58],r:[59],n:"O-O-O"},"61/58":{k:[60,59,58],r:[59],n:"O-O-O"},"62/58":{k:[61,60,59,58],r:[59],n:"O-O-O"},"60/59":{k:[59,58],r:[59],n:"O-O-O"},"61/59":{k:[60,59,58],r:[59],n:"O-O-O"},"62/59":{k:[61,60,59,58],r:[59],n:"O-O-O"},"61/60":{k:[60,59,58],r:[59],n:"O-O-O"},"62/60":{k:[61,60,59,58],r:[59],n:"O-O-O"},"62/61":{k:[61,60,59,58],r:[60,59],n:"O-O-O"},"57/63":{k:[58,59,60,61,62],r:[62,61],n:"O-O"},"58/63":{k:[59,60,61,62],r:[62,61],n:"O-O"},"59/63":{k:[60,61,62],r:[62,61],n:"O-O"},"60/63":{k:[61,62],r:[62,61],n:"O-O"},"61/63":{k:[62],r:[62,61],n:"O-O"},"62/63":{k:[62],r:[62,61],n:"O-O"},"57/62":{k:[58,59,60,61,62],r:[61],n:"O-O"},"58/62":{k:[59,60,61,62],r:[61],n:"O-O"},"59/62":{k:[60,61,62],r:[61],n:"O-O"},"60/62":{k:[61,62],r:[61],n:"O-O"},"61/62":{k:[62],r:[61],n:"O-O"},"57/61":{k:[58,59,60,61,62],r:[61],n:"O-O"},"58/61":{k:[59,60,61,62],r:[61],n:"O-O"},"59/61":{k:[60,61,62],r:[61],n:"O-O"},"60/61":{k:[61,62],r:[61],n:"O-O"},"57/60":{k:[58,59,60,61,62],r:[61],n:"O-O"},"58/60":{k:[59,60,61,62],r:[61],n:"O-O"},"59/60":{k:[60,61,62],r:[61],n:"O-O"},"57/59":{k:[58,59,60,61,62],r:[60,61],n:"O-O"},"58/59":{k:[59,60,61,62],r:[60,61],n:"O-O"},"57/58":{k:[58,59,60,61,62],r:[59,60,61],n:"O-O"}},evaluate:function(e,r,i){var a=i[1].count,n=i[-1].count;a[0]||a[1]||a[4]||a[5]||a[6]||a[7]||n[2]||n[3]||n[6]||n[7]||!(n[4]+n[5]<2||n[5]<2)||(this.mFinished=!0,this.mWinner=JocGame.DRAW),n[2]||n[3]||n[4]||n[5]||n[6]||n[7]||a[0]||a[1]||a[6]||a[7]||!(a[4]+a[5]<2||a[5]<2)||(this.mFinished=!0,this.mWinner=JocGame.DRAW),this.noCaptCount>=100&&(this.mFinished=!0,this.mWinner=JocGame.DRAW);var s,o=e.cbUseTypedArrays?new Int8Array(3):[0,0,0],h=t.height,p=i[1].byType[0];if(p){s=p.length;for(var c=0;c<s;c++)switch(h-t.R(p[c].p)){case 2:o[0]++;break;case 3:o[1]++;break;case 4:o[2]++}}if(p=i[-1].byType[2]){s=p.length;for(var c=0;c<s;c++)switch(t.R(p[c].p)){case 1:o[0]--;break;case 2:o[1]--;break;case 3:o[2]--}}0!=o[0]&&(r.distPawnPromo1=o[0]),0!=o[1]&&(r.distPawnPromo2=o[1]),0!=o[2]&&(r.distPawnPromo3=o[2]);for(var l=0,u=4;u<=5;u++)for(var v=1;v>=-1;v-=2){var f=i[v].byType[u];if(f)for(var c=0;c<f.length;c++)f[c].m&&(l+=v)}0!=l&&(r.minorPiecesMoved=l)}}};var e=Model.Board.GenerateMoves;Model.Board.GenerateMoves=function(t){if(void 0===this.setupState)return void(this.mMoves=[{}]);if("setup"!=this.setupState)e.apply(this,arguments);else{this.mMoves=[];for(var r=0;r<960;r++)this.mMoves.push({setup:r})}};var r=Model.Board.CopyFrom;Model.Board.CopyFrom=function(t){r.apply(this,arguments),this.setupState=t.setupState};var i=Model.Board.Evaluate;Model.Board.Evaluate=function(t){void 0!==this.setupState&&"setup"!=this.setupState&&i.apply(this,arguments)};var a=Model.Board.ApplyMove;Model.Board.ApplyMove=function(t,e){if(void 0===this.setupState)this.setupState="setup";else if("setup"==this.setupState){var r=this,i={1:{},"-1":{}};this.pieces.forEach(function(e,a){if(e.t>=4){r.zSign=t.zobrist.update(r.zSign,"board",a,e.p),r.board[e.p]=-1,e.p=-1;var n=t.g.pTypes[e.t];void 0===i[e.s][n.abbrev]&&(i[e.s][n.abbrev]=[]),i[e.s][n.abbrev].push(e.i)}});var n=t.c960Gen(e.setup);n.forEach(function(e,a){["1","-1"].forEach(function(n){var s=i[n][e].shift(),o=r.pieces[s],h=a+("-1"==n?56:0);r.board[h]=s,o.p=h,r.zSign=t.zobrist.update(r.zSign,"board",s,h),"K"==e&&(r.kings[o.s]=h)})}),this.setupState="done"}else a.apply(this,arguments)};var n=Model.Move.ToString;Model.Move.ToString=function(){return void 0===this.f?void 0===this.setup?"--":"#"+this.setup:n.apply(this,arguments)};var s=Model.Board.CompactMoveString;Model.Board.CompactMoveString=function(t,e,r){return"function"!=typeof e.ToString&&(e=t.CreateMove(e)),void 0===this.setupState||"setup"==this.setupState?e.ToString():s.apply(this,arguments)},Model.Board.StaticGenerateMoves=function(t){return"setup"==this.setupState?[t.CreateMove({setup:Math.floor(960*Math.random())})]:null},Model.Game.c960Gen=function(t){function e(e){h/=e;var r=Math.floor(t/h);return t%=h,r}function r(t,e){s[e]=t,o.splice(o.indexOf(e),1)}var i,a,n,s=[],o=[0,1,2,3,4,5,6,7],h=960;return void 0===t?t=Math.floor(960*Math.random()):t%=960,i=2*e(4),a=2*e(4)+1,r("B",i),r("B",a),r("Q",o[e(6)]),n=[[0,1],[0,2],[0,3],[0,4],[1,2],[1,3],[1,4],[2,3],[2,4],[3,4]][e(10)],r("N",o[n[1]]),r("N",o[n[0]]),r("R",o[0]),r("K",o[0]),r("R",o[0]),s}}();

/***/ }),

/***/ "Dc2k":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var root_1 = __webpack_require__("VOfZ");
var tryCatch_1 = __webpack_require__("+3eL");
var errorObject_1 = __webpack_require__("WhVc");
var Observable_1 = __webpack_require__("rCTf");
var Subscriber_1 = __webpack_require__("mmVS");
var map_1 = __webpack_require__("xAJs");
function getCORSRequest() {
    if (root_1.root.XMLHttpRequest) {
        return new root_1.root.XMLHttpRequest();
    }
    else if (!!root_1.root.XDomainRequest) {
        return new root_1.root.XDomainRequest();
    }
    else {
        throw new Error('CORS is not supported by your browser');
    }
}
function getXMLHttpRequest() {
    if (root_1.root.XMLHttpRequest) {
        return new root_1.root.XMLHttpRequest();
    }
    else {
        var progId = void 0;
        try {
            var progIds = ['Msxml2.XMLHTTP', 'Microsoft.XMLHTTP', 'Msxml2.XMLHTTP.4.0'];
            for (var i = 0; i < 3; i++) {
                try {
                    progId = progIds[i];
                    if (new root_1.root.ActiveXObject(progId)) {
                        break;
                    }
                }
                catch (e) {
                }
            }
            return new root_1.root.ActiveXObject(progId);
        }
        catch (e) {
            throw new Error('XMLHttpRequest is not supported by your browser');
        }
    }
}
function ajaxGet(url, headers) {
    if (headers === void 0) { headers = null; }
    return new AjaxObservable({ method: 'GET', url: url, headers: headers });
}
exports.ajaxGet = ajaxGet;
;
function ajaxPost(url, body, headers) {
    return new AjaxObservable({ method: 'POST', url: url, body: body, headers: headers });
}
exports.ajaxPost = ajaxPost;
;
function ajaxDelete(url, headers) {
    return new AjaxObservable({ method: 'DELETE', url: url, headers: headers });
}
exports.ajaxDelete = ajaxDelete;
;
function ajaxPut(url, body, headers) {
    return new AjaxObservable({ method: 'PUT', url: url, body: body, headers: headers });
}
exports.ajaxPut = ajaxPut;
;
function ajaxPatch(url, body, headers) {
    return new AjaxObservable({ method: 'PATCH', url: url, body: body, headers: headers });
}
exports.ajaxPatch = ajaxPatch;
;
function ajaxGetJSON(url, headers) {
    return new AjaxObservable({ method: 'GET', url: url, responseType: 'json', headers: headers })
        .lift(new map_1.MapOperator(function (x, index) { return x.response; }, null));
}
exports.ajaxGetJSON = ajaxGetJSON;
;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var AjaxObservable = (function (_super) {
    __extends(AjaxObservable, _super);
    function AjaxObservable(urlOrRequest) {
        _super.call(this);
        var request = {
            async: true,
            createXHR: function () {
                return this.crossDomain ? getCORSRequest.call(this) : getXMLHttpRequest();
            },
            crossDomain: false,
            withCredentials: false,
            headers: {},
            method: 'GET',
            responseType: 'json',
            timeout: 0
        };
        if (typeof urlOrRequest === 'string') {
            request.url = urlOrRequest;
        }
        else {
            for (var prop in urlOrRequest) {
                if (urlOrRequest.hasOwnProperty(prop)) {
                    request[prop] = urlOrRequest[prop];
                }
            }
        }
        this.request = request;
    }
    AjaxObservable.prototype._subscribe = function (subscriber) {
        return new AjaxSubscriber(subscriber, this.request);
    };
    /**
     * Creates an observable for an Ajax request with either a request object with
     * url, headers, etc or a string for a URL.
     *
     * @example
     * source = Rx.Observable.ajax('/products');
     * source = Rx.Observable.ajax({ url: 'products', method: 'GET' });
     *
     * @param {string|Object} request Can be one of the following:
     *   A string of the URL to make the Ajax call.
     *   An object with the following properties
     *   - url: URL of the request
     *   - body: The body of the request
     *   - method: Method of the request, such as GET, POST, PUT, PATCH, DELETE
     *   - async: Whether the request is async
     *   - headers: Optional headers
     *   - crossDomain: true if a cross domain request, else false
     *   - createXHR: a function to override if you need to use an alternate
     *   XMLHttpRequest implementation.
     *   - resultSelector: a function to use to alter the output value type of
     *   the Observable. Gets {@link AjaxResponse} as an argument.
     * @return {Observable} An observable sequence containing the XMLHttpRequest.
     * @static true
     * @name ajax
     * @owner Observable
    */
    AjaxObservable.create = (function () {
        var create = function (urlOrRequest) {
            return new AjaxObservable(urlOrRequest);
        };
        create.get = ajaxGet;
        create.post = ajaxPost;
        create.delete = ajaxDelete;
        create.put = ajaxPut;
        create.patch = ajaxPatch;
        create.getJSON = ajaxGetJSON;
        return create;
    })();
    return AjaxObservable;
}(Observable_1.Observable));
exports.AjaxObservable = AjaxObservable;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var AjaxSubscriber = (function (_super) {
    __extends(AjaxSubscriber, _super);
    function AjaxSubscriber(destination, request) {
        _super.call(this, destination);
        this.request = request;
        this.done = false;
        var headers = request.headers = request.headers || {};
        // force CORS if requested
        if (!request.crossDomain && !headers['X-Requested-With']) {
            headers['X-Requested-With'] = 'XMLHttpRequest';
        }
        // ensure content type is set
        if (!('Content-Type' in headers) && !(root_1.root.FormData && request.body instanceof root_1.root.FormData) && typeof request.body !== 'undefined') {
            headers['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8';
        }
        // properly serialize body
        request.body = this.serializeBody(request.body, request.headers['Content-Type']);
        this.send();
    }
    AjaxSubscriber.prototype.next = function (e) {
        this.done = true;
        var _a = this, xhr = _a.xhr, request = _a.request, destination = _a.destination;
        var response = new AjaxResponse(e, xhr, request);
        destination.next(response);
    };
    AjaxSubscriber.prototype.send = function () {
        var _a = this, request = _a.request, _b = _a.request, user = _b.user, method = _b.method, url = _b.url, async = _b.async, password = _b.password, headers = _b.headers, body = _b.body;
        var createXHR = request.createXHR;
        var xhr = tryCatch_1.tryCatch(createXHR).call(request);
        if (xhr === errorObject_1.errorObject) {
            this.error(errorObject_1.errorObject.e);
        }
        else {
            this.xhr = xhr;
            // set up the events before open XHR
            // https://developer.mozilla.org/en/docs/Web/API/XMLHttpRequest/Using_XMLHttpRequest
            // You need to add the event listeners before calling open() on the request.
            // Otherwise the progress events will not fire.
            this.setupEvents(xhr, request);
            // open XHR
            var result = void 0;
            if (user) {
                result = tryCatch_1.tryCatch(xhr.open).call(xhr, method, url, async, user, password);
            }
            else {
                result = tryCatch_1.tryCatch(xhr.open).call(xhr, method, url, async);
            }
            if (result === errorObject_1.errorObject) {
                this.error(errorObject_1.errorObject.e);
                return null;
            }
            // timeout, responseType and withCredentials can be set once the XHR is open
            xhr.timeout = request.timeout;
            xhr.responseType = request.responseType;
            if ('withCredentials' in xhr) {
                xhr.withCredentials = !!request.withCredentials;
            }
            // set headers
            this.setHeaders(xhr, headers);
            // finally send the request
            result = body ? tryCatch_1.tryCatch(xhr.send).call(xhr, body) : tryCatch_1.tryCatch(xhr.send).call(xhr);
            if (result === errorObject_1.errorObject) {
                this.error(errorObject_1.errorObject.e);
                return null;
            }
        }
        return xhr;
    };
    AjaxSubscriber.prototype.serializeBody = function (body, contentType) {
        if (!body || typeof body === 'string') {
            return body;
        }
        else if (root_1.root.FormData && body instanceof root_1.root.FormData) {
            return body;
        }
        if (contentType) {
            var splitIndex = contentType.indexOf(';');
            if (splitIndex !== -1) {
                contentType = contentType.substring(0, splitIndex);
            }
        }
        switch (contentType) {
            case 'application/x-www-form-urlencoded':
                return Object.keys(body).map(function (key) { return (encodeURI(key) + "=" + encodeURI(body[key])); }).join('&');
            case 'application/json':
                return JSON.stringify(body);
            default:
                return body;
        }
    };
    AjaxSubscriber.prototype.setHeaders = function (xhr, headers) {
        for (var key in headers) {
            if (headers.hasOwnProperty(key)) {
                xhr.setRequestHeader(key, headers[key]);
            }
        }
    };
    AjaxSubscriber.prototype.setupEvents = function (xhr, request) {
        var progressSubscriber = request.progressSubscriber;
        function xhrTimeout(e) {
            var _a = xhrTimeout, subscriber = _a.subscriber, progressSubscriber = _a.progressSubscriber, request = _a.request;
            if (progressSubscriber) {
                progressSubscriber.error(e);
            }
            subscriber.error(new AjaxTimeoutError(this, request)); //TODO: Make betterer.
        }
        ;
        xhr.ontimeout = xhrTimeout;
        xhrTimeout.request = request;
        xhrTimeout.subscriber = this;
        xhrTimeout.progressSubscriber = progressSubscriber;
        if (xhr.upload && 'withCredentials' in xhr) {
            if (progressSubscriber) {
                var xhrProgress_1;
                xhrProgress_1 = function (e) {
                    var progressSubscriber = xhrProgress_1.progressSubscriber;
                    progressSubscriber.next(e);
                };
                if (root_1.root.XDomainRequest) {
                    xhr.onprogress = xhrProgress_1;
                }
                else {
                    xhr.upload.onprogress = xhrProgress_1;
                }
                xhrProgress_1.progressSubscriber = progressSubscriber;
            }
            var xhrError_1;
            xhrError_1 = function (e) {
                var _a = xhrError_1, progressSubscriber = _a.progressSubscriber, subscriber = _a.subscriber, request = _a.request;
                if (progressSubscriber) {
                    progressSubscriber.error(e);
                }
                subscriber.error(new AjaxError('ajax error', this, request));
            };
            xhr.onerror = xhrError_1;
            xhrError_1.request = request;
            xhrError_1.subscriber = this;
            xhrError_1.progressSubscriber = progressSubscriber;
        }
        function xhrReadyStateChange(e) {
            var _a = xhrReadyStateChange, subscriber = _a.subscriber, progressSubscriber = _a.progressSubscriber, request = _a.request;
            if (this.readyState === 4) {
                // normalize IE9 bug (http://bugs.jquery.com/ticket/1450)
                var status_1 = this.status === 1223 ? 204 : this.status;
                var response = (this.responseType === 'text' ? (this.response || this.responseText) : this.response);
                // fix status code when it is 0 (0 status is undocumented).
                // Occurs when accessing file resources or on Android 4.1 stock browser
                // while retrieving files from application cache.
                if (status_1 === 0) {
                    status_1 = response ? 200 : 0;
                }
                if (200 <= status_1 && status_1 < 300) {
                    if (progressSubscriber) {
                        progressSubscriber.complete();
                    }
                    subscriber.next(e);
                    subscriber.complete();
                }
                else {
                    if (progressSubscriber) {
                        progressSubscriber.error(e);
                    }
                    subscriber.error(new AjaxError('ajax error ' + status_1, this, request));
                }
            }
        }
        ;
        xhr.onreadystatechange = xhrReadyStateChange;
        xhrReadyStateChange.subscriber = this;
        xhrReadyStateChange.progressSubscriber = progressSubscriber;
        xhrReadyStateChange.request = request;
    };
    AjaxSubscriber.prototype.unsubscribe = function () {
        var _a = this, done = _a.done, xhr = _a.xhr;
        if (!done && xhr && xhr.readyState !== 4 && typeof xhr.abort === 'function') {
            xhr.abort();
        }
        _super.prototype.unsubscribe.call(this);
    };
    return AjaxSubscriber;
}(Subscriber_1.Subscriber));
exports.AjaxSubscriber = AjaxSubscriber;
/**
 * A normalized AJAX response.
 *
 * @see {@link ajax}
 *
 * @class AjaxResponse
 */
var AjaxResponse = (function () {
    function AjaxResponse(originalEvent, xhr, request) {
        this.originalEvent = originalEvent;
        this.xhr = xhr;
        this.request = request;
        this.status = xhr.status;
        this.responseType = xhr.responseType || request.responseType;
        switch (this.responseType) {
            case 'json':
                if ('response' in xhr) {
                    //IE does not support json as responseType, parse it internally
                    this.response = xhr.responseType ? xhr.response : JSON.parse(xhr.response || xhr.responseText || 'null');
                }
                else {
                    this.response = JSON.parse(xhr.responseText || 'null');
                }
                break;
            case 'xml':
                this.response = xhr.responseXML;
                break;
            case 'text':
            default:
                this.response = ('response' in xhr) ? xhr.response : xhr.responseText;
                break;
        }
    }
    return AjaxResponse;
}());
exports.AjaxResponse = AjaxResponse;
/**
 * A normalized AJAX error.
 *
 * @see {@link ajax}
 *
 * @class AjaxError
 */
var AjaxError = (function (_super) {
    __extends(AjaxError, _super);
    function AjaxError(message, xhr, request) {
        _super.call(this, message);
        this.message = message;
        this.xhr = xhr;
        this.request = request;
        this.status = xhr.status;
    }
    return AjaxError;
}(Error));
exports.AjaxError = AjaxError;
/**
 * @see {@link ajax}
 *
 * @class AjaxTimeoutError
 */
var AjaxTimeoutError = (function (_super) {
    __extends(AjaxTimeoutError, _super);
    function AjaxTimeoutError(xhr, request) {
        _super.call(this, 'ajax timeout', xhr, request);
    }
    return AjaxTimeoutError;
}(AjaxError));
exports.AjaxTimeoutError = AjaxTimeoutError;
//# sourceMappingURL=AjaxObservable.js.map

/***/ }),

/***/ "Di9Q":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var bufferTime_1 = __webpack_require__("DB2G");
Observable_1.Observable.prototype.bufferTime = bufferTime_1.bufferTime;
//# sourceMappingURL=bufferTime.js.map

/***/ }),

/***/ "Dkzu":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Observable_1 = __webpack_require__("rCTf");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var ErrorObservable = (function (_super) {
    __extends(ErrorObservable, _super);
    function ErrorObservable(error, scheduler) {
        _super.call(this);
        this.error = error;
        this.scheduler = scheduler;
    }
    /**
     * Creates an Observable that emits no items to the Observer and immediately
     * emits an error notification.
     *
     * <span class="informal">Just emits 'error', and nothing else.
     * </span>
     *
     * <img src="./img/throw.png" width="100%">
     *
     * This static operator is useful for creating a simple Observable that only
     * emits the error notification. It can be used for composing with other
     * Observables, such as in a {@link mergeMap}.
     *
     * @example <caption>Emit the number 7, then emit an error.</caption>
     * var result = Rx.Observable.throw(new Error('oops!')).startWith(7);
     * result.subscribe(x => console.log(x), e => console.error(e));
     *
     * @example <caption>Map and flatten numbers to the sequence 'a', 'b', 'c', but throw an error for 13</caption>
     * var interval = Rx.Observable.interval(1000);
     * var result = interval.mergeMap(x =>
     *   x === 13 ?
     *     Rx.Observable.throw('Thirteens are bad') :
     *     Rx.Observable.of('a', 'b', 'c')
     * );
     * result.subscribe(x => console.log(x), e => console.error(e));
     *
     * @see {@link create}
     * @see {@link empty}
     * @see {@link never}
     * @see {@link of}
     *
     * @param {any} error The particular Error to pass to the error notification.
     * @param {Scheduler} [scheduler] A {@link IScheduler} to use for scheduling
     * the emission of the error notification.
     * @return {Observable} An error Observable: emits only the error notification
     * using the given error argument.
     * @static true
     * @name throw
     * @owner Observable
     */
    ErrorObservable.create = function (error, scheduler) {
        return new ErrorObservable(error, scheduler);
    };
    ErrorObservable.dispatch = function (arg) {
        var error = arg.error, subscriber = arg.subscriber;
        subscriber.error(error);
    };
    ErrorObservable.prototype._subscribe = function (subscriber) {
        var error = this.error;
        var scheduler = this.scheduler;
        if (scheduler) {
            return scheduler.schedule(ErrorObservable.dispatch, 0, {
                error: error, subscriber: subscriber
            });
        }
        else {
            subscriber.error(error);
        }
    };
    return ErrorObservable;
}(Observable_1.Observable));
exports.ErrorObservable = ErrorObservable;
//# sourceMappingURL=ErrorObservable.js.map

/***/ }),

/***/ "Dpdt":
/***/ (function(module, exports) {

exports.config = {"status":true,"model":{"plazza":"true","released":1389887778,"title-en":"Chess","module":"chessbase","summary":"Regular Orthodox Classic Western Chess","thumbnail":"knight-thumbnail.png","rules":{"en":"rules.html","fr":"rules-fr.html"},"credits":{"en":"credits.html","fr":"credits-fr.html"},"gameOptions":{"preventRepeat":true,"uctTransposition":"state","uctIgnoreLoop":false,"levelOptions":{"pieceValueFactor":1,"pieceValueRatioFactor":1,"posValueFactor":0.1,"averageDistKingFactor":-0.01,"castleFactor":0.1,"minorPiecesMovedFactor":0.1,"checkFactor":0.2,"endingKingFreedomFactor":0.01,"endingDistKingFactor":0.05,"distKingCornerFactor":0.1,"distPawnPromo1Factor":0.3,"distPawnPromo2Factor":0.1,"distPawnPromo3Factor":0.05}},"js":["base-model.js","grid-geo-model.js","classic-model.js","classic-db.min.js"],"levels":[{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"easy","label":"Easy","maxNodes":1000},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"fast","label":"Fast [1sec]","maxDuration":1,"isDefault":true},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"medium","label":"Medium","maxNodes":10000,"maxDuration":10},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"strong","label":"Strong","maxNodes":20000,"maxDuration":15}]},"view":{"title-en":"Chessbase view","module":"chessbase","xdView":true,"css":["chessbase.css"],"preferredRatio":1,"useShowMoves":true,"useNotation":true,"useAutoComplete":true,"defaultOptions":{"sounds":true,"moves":true,"notation":false,"autocomplete":false},"skins":[{"name":"skin3d","title":"3D Classic","3d":true,"preload":["smoothedfilegeo|0|/res/ring-target.js","image|/res/images/cancel.png","image|/res/images/wikipedia.png","smoothedfilegeo|0|/res/staunton/pawn/pawn-classic.js","image|/res/staunton/pawn/pawn-diffusemap.jpg","image|/res/staunton/pawn/pawn-normalmap.jpg","smoothedfilegeo|0|/res/staunton/knight/knight.js","image|/res/staunton/knight/knight-diffusemap.jpg","image|/res/staunton/knight/knight-normalmap.jpg","smoothedfilegeo|0|/res/staunton/bishop/bishop.js","image|/res/staunton/bishop/bishop-diffusemap.jpg","image|/res/staunton/bishop/bishop-normalmap.jpg","smoothedfilegeo|0|/res/staunton/rook/rook.js","image|/res/staunton/rook/rook-diffusemap.jpg","image|/res/staunton/rook/rook-normalmap.jpg","smoothedfilegeo|0|/res/staunton/queen/queen.js","image|/res/staunton/queen/queen-diffusemap.jpg","image|/res/staunton/queen/queen-normalmap.jpg","smoothedfilegeo|0|/res/staunton/king/king.js","image|/res/staunton/king/king-diffusemap.jpg","image|/res/staunton/king/king-normalmap.jpg"],"world":{"lightIntensity":1.3,"skyLightIntensity":1.2,"lightCastShadow":true,"fog":false,"color":4686804,"lightPosition":{"x":-9,"y":9,"z":9},"skyLightPosition":{"x":9,"y":9,"z":9},"lightShadowDarkness":0.55,"ambientLightColor":2236962},"camera":{"fov":45,"distMax":50,"radius":18,"elevationAngle":60,"elevationMin":0}},{"name":"skin3dflat","title":"3D Flat","3d":true,"preload":["smoothedfilegeo|0|/res/ring-target.js","image|/res/images/cancel.png","image|/res/images/wikipedia.png","image|/res/extruded/wood.jpg","image|/res/extruded/wikipedia-pieces-diffuse-white.jpg","image|/res/extruded/wikipedia-pieces-diffuse-black.jpg","smoothedfilegeo|0|/res/extruded/flat3dpieces-king.js","smoothedfilegeo|0|/res/extruded/flat3dpieces-queen.js","smoothedfilegeo|0|/res/extruded/flat3dpieces-pawn.js","smoothedfilegeo|0|/res/extruded/flat3dpieces-rook.js","smoothedfilegeo|0|/res/extruded/flat3dpieces-knight.js","smoothedfilegeo|0|/res/extruded/flat3dpieces-bishop.js"],"world":{"lightIntensity":1.3,"skyLightIntensity":1.2,"lightCastShadow":true,"fog":false,"color":4686804,"lightPosition":{"x":-9,"y":9,"z":9},"skyLightPosition":{"x":9,"y":9,"z":9},"lightShadowDarkness":0.55,"ambientLightColor":2236962},"camera":{"fov":45,"distMax":50,"radius":18,"elevationAngle":89,"elevationMin":0}},{"name":"skin2dfull","title":"2D Classic","3d":false,"preload":["image|/res/images/cancel.png","image|/res/images/whitebg.png","image|/res/images/wikipedia.png"]},{"name":"skin2dwood","title":"2D Wood","3d":false,"preload":["image|/res/images/cancel.png","image|/res/images/whitebg.png","image|/res/images/wikipedia.png","image|/res/images/woodenpieces2d2.png","image|/res/images/wood.jpg"]}],"animateSelfMoves":false,"switchable":true,"sounds":{"move1":"alq_move1","move2":"alq_move2","move3":"alq_move3","move4":"alq_move2","tac1":"alq_tac1","tac2":"alq_tac2","tac3":"alq_tac1","promo":"promo","usermove":null},"js":["base-view.js","grid-board-view.js","staunton-set-view.js","extruded-set-view.js","classic-view.js"],"visuals":{"600x600":["res/visuals/classic-chess-600x600-3d.jpg","res/visuals/classic-chess-600x600-2d.jpg"]}}}

/***/ }),

/***/ "DuR2":
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ "DxXK":
/***/ (function(module, exports) {

exports.config = {"status":true,"model":{"title-en":"Spline+","module":"margo","js":["spbase-model.js","spline-model.js","splineplus-model.js"],"summary":"Shibumi game","thumbnail":"tn-shibumi-spline-plus.png","strings":[],"rules":{"en":"rules-splineplus.html","fr":"rules-splineplus.html"},"description":{"en":"description-splineplus.html","fr":"description-splineplus.html"},"credits":{"en":"credits-splineplus.html","fr":"credits-splineplus.html"},"demoRandom":true,"gameOptions":{"preventRepeat":true,"uctTransposition":"states","uctIgnoreLoop":true,"size":4},"plazza":"true","levels":[{"potential":1000,"isDefault":true,"maxDepth":1},{"label":"Easy","potential":2000,"maxDepth":5},{"label":"Medium","potential":6000,"maxDepth":6},{"potential":20000,"maxDepth":8}]},"view":{"title-en":"Margo View","module":"margo","js":["spbase-xd-view.js","spline-view.js"],"xdView":true,"css":["spbase.css"],"preferredRatio":1,"useNotation":true,"defaultOptions":{"sounds":true,"moves":true,"notation":false},"skins":[{"name":"classic3d","title":"3D Classic","3d":true,"camera":{"radius":20,"elevationAngle":45,"limitCamMoves":true,"distMax":40,"distMin":10,"elevationMin":-45,"elevationMax":89.9,"enableDrag":false},"world":{"lightIntensity":0,"color":0,"fog":false,"skyLightIntensity":0.7,"skyLightPosition":{"x":0,"y":10,"z":0},"ambientLightColor":8947848},"preload":["image|/res/xd-view/meshes/grey.png","image|/res/xd-view/meshes/black.png","image|/res/xd-view/meshes/white.png","image|/res/xd-view/meshes/green.png","image|/res/xd-view/meshes/skybox/nx.jpg","image|/res/xd-view/meshes/skybox/ny.jpg","image|/res/xd-view/meshes/skybox/nz.jpg","image|/res/xd-view/meshes/skybox/px.jpg","image|/res/xd-view/meshes/skybox/py.jpg","image|/res/xd-view/meshes/skybox/pz.jpg"]},{"name":"wood","title":"Wood","preload":["image|/res/images/ball_black.png","image|/res/images/ball_white.png","image|/res/images/ball_green.png","image|/res/images/plot.png","image|/res/images/wood.png"]},{"name":"classical","title":"Classic","preload":["image|/res/images/ball_black.png","image|/res/images/ball_white.png","image|/res/images/ball_green.png","image|/res/images/plot.png"]}],"animateSelfMoves":false,"visuals":{"600x600":["res/visuals/splineplus-600x600-3d.jpg","res/visuals/splineplus-600x600-2d.jpg"]}}}

/***/ }),

/***/ "DzMp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DeferObservable_1 = __webpack_require__("+EXD");
exports.defer = DeferObservable_1.DeferObservable.create;
//# sourceMappingURL=defer.js.map

/***/ }),

/***/ "E/WS":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var async_1 = __webpack_require__("CGGv");
var isDate_1 = __webpack_require__("fuZx");
var Subscriber_1 = __webpack_require__("mmVS");
var TimeoutError_1 = __webpack_require__("cmqr");
/**
 * @param {number} due
 * @param {Scheduler} [scheduler]
 * @return {Observable<R>|WebSocketSubject<T>|Observable<T>}
 * @method timeout
 * @owner Observable
 */
function timeout(due, scheduler) {
    if (scheduler === void 0) { scheduler = async_1.async; }
    var absoluteTimeout = isDate_1.isDate(due);
    var waitFor = absoluteTimeout ? (+due - scheduler.now()) : Math.abs(due);
    return this.lift(new TimeoutOperator(waitFor, absoluteTimeout, scheduler, new TimeoutError_1.TimeoutError()));
}
exports.timeout = timeout;
var TimeoutOperator = (function () {
    function TimeoutOperator(waitFor, absoluteTimeout, scheduler, errorInstance) {
        this.waitFor = waitFor;
        this.absoluteTimeout = absoluteTimeout;
        this.scheduler = scheduler;
        this.errorInstance = errorInstance;
    }
    TimeoutOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new TimeoutSubscriber(subscriber, this.absoluteTimeout, this.waitFor, this.scheduler, this.errorInstance));
    };
    return TimeoutOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var TimeoutSubscriber = (function (_super) {
    __extends(TimeoutSubscriber, _super);
    function TimeoutSubscriber(destination, absoluteTimeout, waitFor, scheduler, errorInstance) {
        _super.call(this, destination);
        this.absoluteTimeout = absoluteTimeout;
        this.waitFor = waitFor;
        this.scheduler = scheduler;
        this.errorInstance = errorInstance;
        this.action = null;
        this.scheduleTimeout();
    }
    TimeoutSubscriber.dispatchTimeout = function (subscriber) {
        subscriber.error(subscriber.errorInstance);
    };
    TimeoutSubscriber.prototype.scheduleTimeout = function () {
        var action = this.action;
        if (action) {
            // Recycle the action if we've already scheduled one. All the production
            // Scheduler Actions mutate their state/delay time and return themeselves.
            // VirtualActions are immutable, so they create and return a clone. In this
            // case, we need to set the action reference to the most recent VirtualAction,
            // to ensure that's the one we clone from next time.
            this.action = action.schedule(this, this.waitFor);
        }
        else {
            this.add(this.action = this.scheduler.schedule(TimeoutSubscriber.dispatchTimeout, this.waitFor, this));
        }
    };
    TimeoutSubscriber.prototype._next = function (value) {
        if (!this.absoluteTimeout) {
            this.scheduleTimeout();
        }
        _super.prototype._next.call(this, value);
    };
    TimeoutSubscriber.prototype._unsubscribe = function () {
        this.action = null;
        this.scheduler = null;
        this.errorInstance = null;
    };
    return TimeoutSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=timeout.js.map

/***/ }),

/***/ "E7Yq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var fromEvent_1 = __webpack_require__("TIy+");
Observable_1.Observable.fromEvent = fromEvent_1.fromEvent;
//# sourceMappingURL=fromEvent.js.map

/***/ }),

/***/ "EEr4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Observable_1 = __webpack_require__("rCTf");
var Subscriber_1 = __webpack_require__("mmVS");
var Subscription_1 = __webpack_require__("B00U");
var ObjectUnsubscribedError_1 = __webpack_require__("IZVw");
var SubjectSubscription_1 = __webpack_require__("ZJf8");
var rxSubscriber_1 = __webpack_require__("r8ZY");
/**
 * @class SubjectSubscriber<T>
 */
var SubjectSubscriber = (function (_super) {
    __extends(SubjectSubscriber, _super);
    function SubjectSubscriber(destination) {
        _super.call(this, destination);
        this.destination = destination;
    }
    return SubjectSubscriber;
}(Subscriber_1.Subscriber));
exports.SubjectSubscriber = SubjectSubscriber;
/**
 * @class Subject<T>
 */
var Subject = (function (_super) {
    __extends(Subject, _super);
    function Subject() {
        _super.call(this);
        this.observers = [];
        this.closed = false;
        this.isStopped = false;
        this.hasError = false;
        this.thrownError = null;
    }
    Subject.prototype[rxSubscriber_1.rxSubscriber] = function () {
        return new SubjectSubscriber(this);
    };
    Subject.prototype.lift = function (operator) {
        var subject = new AnonymousSubject(this, this);
        subject.operator = operator;
        return subject;
    };
    Subject.prototype.next = function (value) {
        if (this.closed) {
            throw new ObjectUnsubscribedError_1.ObjectUnsubscribedError();
        }
        if (!this.isStopped) {
            var observers = this.observers;
            var len = observers.length;
            var copy = observers.slice();
            for (var i = 0; i < len; i++) {
                copy[i].next(value);
            }
        }
    };
    Subject.prototype.error = function (err) {
        if (this.closed) {
            throw new ObjectUnsubscribedError_1.ObjectUnsubscribedError();
        }
        this.hasError = true;
        this.thrownError = err;
        this.isStopped = true;
        var observers = this.observers;
        var len = observers.length;
        var copy = observers.slice();
        for (var i = 0; i < len; i++) {
            copy[i].error(err);
        }
        this.observers.length = 0;
    };
    Subject.prototype.complete = function () {
        if (this.closed) {
            throw new ObjectUnsubscribedError_1.ObjectUnsubscribedError();
        }
        this.isStopped = true;
        var observers = this.observers;
        var len = observers.length;
        var copy = observers.slice();
        for (var i = 0; i < len; i++) {
            copy[i].complete();
        }
        this.observers.length = 0;
    };
    Subject.prototype.unsubscribe = function () {
        this.isStopped = true;
        this.closed = true;
        this.observers = null;
    };
    Subject.prototype._trySubscribe = function (subscriber) {
        if (this.closed) {
            throw new ObjectUnsubscribedError_1.ObjectUnsubscribedError();
        }
        else {
            return _super.prototype._trySubscribe.call(this, subscriber);
        }
    };
    Subject.prototype._subscribe = function (subscriber) {
        if (this.closed) {
            throw new ObjectUnsubscribedError_1.ObjectUnsubscribedError();
        }
        else if (this.hasError) {
            subscriber.error(this.thrownError);
            return Subscription_1.Subscription.EMPTY;
        }
        else if (this.isStopped) {
            subscriber.complete();
            return Subscription_1.Subscription.EMPTY;
        }
        else {
            this.observers.push(subscriber);
            return new SubjectSubscription_1.SubjectSubscription(this, subscriber);
        }
    };
    Subject.prototype.asObservable = function () {
        var observable = new Observable_1.Observable();
        observable.source = this;
        return observable;
    };
    Subject.create = function (destination, source) {
        return new AnonymousSubject(destination, source);
    };
    return Subject;
}(Observable_1.Observable));
exports.Subject = Subject;
/**
 * @class AnonymousSubject<T>
 */
var AnonymousSubject = (function (_super) {
    __extends(AnonymousSubject, _super);
    function AnonymousSubject(destination, source) {
        _super.call(this);
        this.destination = destination;
        this.source = source;
    }
    AnonymousSubject.prototype.next = function (value) {
        var destination = this.destination;
        if (destination && destination.next) {
            destination.next(value);
        }
    };
    AnonymousSubject.prototype.error = function (err) {
        var destination = this.destination;
        if (destination && destination.error) {
            this.destination.error(err);
        }
    };
    AnonymousSubject.prototype.complete = function () {
        var destination = this.destination;
        if (destination && destination.complete) {
            this.destination.complete();
        }
    };
    AnonymousSubject.prototype._subscribe = function (subscriber) {
        var source = this.source;
        if (source) {
            return this.source.subscribe(subscriber);
        }
        else {
            return Subscription_1.Subscription.EMPTY;
        }
    };
    return AnonymousSubject;
}(Subject));
exports.AnonymousSubject = AnonymousSubject;
//# sourceMappingURL=Subject.js.map

/***/ }),

/***/ "EFqf":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * marked - a markdown parser
 * Copyright (c) 2011-2014, Christopher Jeffrey. (MIT Licensed)
 * https://github.com/chjj/marked
 */

;(function() {

/**
 * Block-Level Grammar
 */

var block = {
  newline: /^\n+/,
  code: /^( {4}[^\n]+\n*)+/,
  fences: noop,
  hr: /^( *[-*_]){3,} *(?:\n+|$)/,
  heading: /^ *(#{1,6}) *([^\n]+?) *#* *(?:\n+|$)/,
  nptable: noop,
  lheading: /^([^\n]+)\n *(=|-){2,} *(?:\n+|$)/,
  blockquote: /^( *>[^\n]+(\n(?!def)[^\n]+)*\n*)+/,
  list: /^( *)(bull) [\s\S]+?(?:hr|def|\n{2,}(?! )(?!\1bull )\n*|\s*$)/,
  html: /^ *(?:comment *(?:\n|\s*$)|closed *(?:\n{2,}|\s*$)|closing *(?:\n{2,}|\s*$))/,
  def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +["(]([^\n]+)[")])? *(?:\n+|$)/,
  table: noop,
  paragraph: /^((?:[^\n]+\n?(?!hr|heading|lheading|blockquote|tag|def))+)\n*/,
  text: /^[^\n]+/
};

block.bullet = /(?:[*+-]|\d+\.)/;
block.item = /^( *)(bull) [^\n]*(?:\n(?!\1bull )[^\n]*)*/;
block.item = replace(block.item, 'gm')
  (/bull/g, block.bullet)
  ();

block.list = replace(block.list)
  (/bull/g, block.bullet)
  ('hr', '\\n+(?=\\1?(?:[-*_] *){3,}(?:\\n+|$))')
  ('def', '\\n+(?=' + block.def.source + ')')
  ();

block.blockquote = replace(block.blockquote)
  ('def', block.def)
  ();

block._tag = '(?!(?:'
  + 'a|em|strong|small|s|cite|q|dfn|abbr|data|time|code'
  + '|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo'
  + '|span|br|wbr|ins|del|img)\\b)\\w+(?!:/|[^\\w\\s@]*@)\\b';

block.html = replace(block.html)
  ('comment', /<!--[\s\S]*?-->/)
  ('closed', /<(tag)[\s\S]+?<\/\1>/)
  ('closing', /<tag(?:"[^"]*"|'[^']*'|[^'">])*?>/)
  (/tag/g, block._tag)
  ();

block.paragraph = replace(block.paragraph)
  ('hr', block.hr)
  ('heading', block.heading)
  ('lheading', block.lheading)
  ('blockquote', block.blockquote)
  ('tag', '<' + block._tag)
  ('def', block.def)
  ();

/**
 * Normal Block Grammar
 */

block.normal = merge({}, block);

/**
 * GFM Block Grammar
 */

block.gfm = merge({}, block.normal, {
  fences: /^ *(`{3,}|~{3,})[ \.]*(\S+)? *\n([\s\S]*?)\s*\1 *(?:\n+|$)/,
  paragraph: /^/,
  heading: /^ *(#{1,6}) +([^\n]+?) *#* *(?:\n+|$)/
});

block.gfm.paragraph = replace(block.paragraph)
  ('(?!', '(?!'
    + block.gfm.fences.source.replace('\\1', '\\2') + '|'
    + block.list.source.replace('\\1', '\\3') + '|')
  ();

/**
 * GFM + Tables Block Grammar
 */

block.tables = merge({}, block.gfm, {
  nptable: /^ *(\S.*\|.*)\n *([-:]+ *\|[-| :]*)\n((?:.*\|.*(?:\n|$))*)\n*/,
  table: /^ *\|(.+)\n *\|( *[-:]+[-| :]*)\n((?: *\|.*(?:\n|$))*)\n*/
});

/**
 * Block Lexer
 */

function Lexer(options) {
  this.tokens = [];
  this.tokens.links = {};
  this.options = options || marked.defaults;
  this.rules = block.normal;

  if (this.options.gfm) {
    if (this.options.tables) {
      this.rules = block.tables;
    } else {
      this.rules = block.gfm;
    }
  }
}

/**
 * Expose Block Rules
 */

Lexer.rules = block;

/**
 * Static Lex Method
 */

Lexer.lex = function(src, options) {
  var lexer = new Lexer(options);
  return lexer.lex(src);
};

/**
 * Preprocessing
 */

Lexer.prototype.lex = function(src) {
  src = src
    .replace(/\r\n|\r/g, '\n')
    .replace(/\t/g, '    ')
    .replace(/\u00a0/g, ' ')
    .replace(/\u2424/g, '\n');

  return this.token(src, true);
};

/**
 * Lexing
 */

Lexer.prototype.token = function(src, top, bq) {
  var src = src.replace(/^ +$/gm, '')
    , next
    , loose
    , cap
    , bull
    , b
    , item
    , space
    , i
    , l;

  while (src) {
    // newline
    if (cap = this.rules.newline.exec(src)) {
      src = src.substring(cap[0].length);
      if (cap[0].length > 1) {
        this.tokens.push({
          type: 'space'
        });
      }
    }

    // code
    if (cap = this.rules.code.exec(src)) {
      src = src.substring(cap[0].length);
      cap = cap[0].replace(/^ {4}/gm, '');
      this.tokens.push({
        type: 'code',
        text: !this.options.pedantic
          ? cap.replace(/\n+$/, '')
          : cap
      });
      continue;
    }

    // fences (gfm)
    if (cap = this.rules.fences.exec(src)) {
      src = src.substring(cap[0].length);
      this.tokens.push({
        type: 'code',
        lang: cap[2],
        text: cap[3] || ''
      });
      continue;
    }

    // heading
    if (cap = this.rules.heading.exec(src)) {
      src = src.substring(cap[0].length);
      this.tokens.push({
        type: 'heading',
        depth: cap[1].length,
        text: cap[2]
      });
      continue;
    }

    // table no leading pipe (gfm)
    if (top && (cap = this.rules.nptable.exec(src))) {
      src = src.substring(cap[0].length);

      item = {
        type: 'table',
        header: cap[1].replace(/^ *| *\| *$/g, '').split(/ *\| */),
        align: cap[2].replace(/^ *|\| *$/g, '').split(/ *\| */),
        cells: cap[3].replace(/\n$/, '').split('\n')
      };

      for (i = 0; i < item.align.length; i++) {
        if (/^ *-+: *$/.test(item.align[i])) {
          item.align[i] = 'right';
        } else if (/^ *:-+: *$/.test(item.align[i])) {
          item.align[i] = 'center';
        } else if (/^ *:-+ *$/.test(item.align[i])) {
          item.align[i] = 'left';
        } else {
          item.align[i] = null;
        }
      }

      for (i = 0; i < item.cells.length; i++) {
        item.cells[i] = item.cells[i].split(/ *\| */);
      }

      this.tokens.push(item);

      continue;
    }

    // lheading
    if (cap = this.rules.lheading.exec(src)) {
      src = src.substring(cap[0].length);
      this.tokens.push({
        type: 'heading',
        depth: cap[2] === '=' ? 1 : 2,
        text: cap[1]
      });
      continue;
    }

    // hr
    if (cap = this.rules.hr.exec(src)) {
      src = src.substring(cap[0].length);
      this.tokens.push({
        type: 'hr'
      });
      continue;
    }

    // blockquote
    if (cap = this.rules.blockquote.exec(src)) {
      src = src.substring(cap[0].length);

      this.tokens.push({
        type: 'blockquote_start'
      });

      cap = cap[0].replace(/^ *> ?/gm, '');

      // Pass `top` to keep the current
      // "toplevel" state. This is exactly
      // how markdown.pl works.
      this.token(cap, top, true);

      this.tokens.push({
        type: 'blockquote_end'
      });

      continue;
    }

    // list
    if (cap = this.rules.list.exec(src)) {
      src = src.substring(cap[0].length);
      bull = cap[2];

      this.tokens.push({
        type: 'list_start',
        ordered: bull.length > 1
      });

      // Get each top-level item.
      cap = cap[0].match(this.rules.item);

      next = false;
      l = cap.length;
      i = 0;

      for (; i < l; i++) {
        item = cap[i];

        // Remove the list item's bullet
        // so it is seen as the next token.
        space = item.length;
        item = item.replace(/^ *([*+-]|\d+\.) +/, '');

        // Outdent whatever the
        // list item contains. Hacky.
        if (~item.indexOf('\n ')) {
          space -= item.length;
          item = !this.options.pedantic
            ? item.replace(new RegExp('^ {1,' + space + '}', 'gm'), '')
            : item.replace(/^ {1,4}/gm, '');
        }

        // Determine whether the next list item belongs here.
        // Backpedal if it does not belong in this list.
        if (this.options.smartLists && i !== l - 1) {
          b = block.bullet.exec(cap[i + 1])[0];
          if (bull !== b && !(bull.length > 1 && b.length > 1)) {
            src = cap.slice(i + 1).join('\n') + src;
            i = l - 1;
          }
        }

        // Determine whether item is loose or not.
        // Use: /(^|\n)(?! )[^\n]+\n\n(?!\s*$)/
        // for discount behavior.
        loose = next || /\n\n(?!\s*$)/.test(item);
        if (i !== l - 1) {
          next = item.charAt(item.length - 1) === '\n';
          if (!loose) loose = next;
        }

        this.tokens.push({
          type: loose
            ? 'loose_item_start'
            : 'list_item_start'
        });

        // Recurse.
        this.token(item, false, bq);

        this.tokens.push({
          type: 'list_item_end'
        });
      }

      this.tokens.push({
        type: 'list_end'
      });

      continue;
    }

    // html
    if (cap = this.rules.html.exec(src)) {
      src = src.substring(cap[0].length);
      this.tokens.push({
        type: this.options.sanitize
          ? 'paragraph'
          : 'html',
        pre: !this.options.sanitizer
          && (cap[1] === 'pre' || cap[1] === 'script' || cap[1] === 'style'),
        text: cap[0]
      });
      continue;
    }

    // def
    if ((!bq && top) && (cap = this.rules.def.exec(src))) {
      src = src.substring(cap[0].length);
      this.tokens.links[cap[1].toLowerCase()] = {
        href: cap[2],
        title: cap[3]
      };
      continue;
    }

    // table (gfm)
    if (top && (cap = this.rules.table.exec(src))) {
      src = src.substring(cap[0].length);

      item = {
        type: 'table',
        header: cap[1].replace(/^ *| *\| *$/g, '').split(/ *\| */),
        align: cap[2].replace(/^ *|\| *$/g, '').split(/ *\| */),
        cells: cap[3].replace(/(?: *\| *)?\n$/, '').split('\n')
      };

      for (i = 0; i < item.align.length; i++) {
        if (/^ *-+: *$/.test(item.align[i])) {
          item.align[i] = 'right';
        } else if (/^ *:-+: *$/.test(item.align[i])) {
          item.align[i] = 'center';
        } else if (/^ *:-+ *$/.test(item.align[i])) {
          item.align[i] = 'left';
        } else {
          item.align[i] = null;
        }
      }

      for (i = 0; i < item.cells.length; i++) {
        item.cells[i] = item.cells[i]
          .replace(/^ *\| *| *\| *$/g, '')
          .split(/ *\| */);
      }

      this.tokens.push(item);

      continue;
    }

    // top-level paragraph
    if (top && (cap = this.rules.paragraph.exec(src))) {
      src = src.substring(cap[0].length);
      this.tokens.push({
        type: 'paragraph',
        text: cap[1].charAt(cap[1].length - 1) === '\n'
          ? cap[1].slice(0, -1)
          : cap[1]
      });
      continue;
    }

    // text
    if (cap = this.rules.text.exec(src)) {
      // Top-level should never reach here.
      src = src.substring(cap[0].length);
      this.tokens.push({
        type: 'text',
        text: cap[0]
      });
      continue;
    }

    if (src) {
      throw new
        Error('Infinite loop on byte: ' + src.charCodeAt(0));
    }
  }

  return this.tokens;
};

/**
 * Inline-Level Grammar
 */

var inline = {
  escape: /^\\([\\`*{}\[\]()#+\-.!_>])/,
  autolink: /^<([^ >]+(@|:\/)[^ >]+)>/,
  url: noop,
  tag: /^<!--[\s\S]*?-->|^<\/?\w+(?:"[^"]*"|'[^']*'|[^'">])*?>/,
  link: /^!?\[(inside)\]\(href\)/,
  reflink: /^!?\[(inside)\]\s*\[([^\]]*)\]/,
  nolink: /^!?\[((?:\[[^\]]*\]|[^\[\]])*)\]/,
  strong: /^__([\s\S]+?)__(?!_)|^\*\*([\s\S]+?)\*\*(?!\*)/,
  em: /^\b_((?:[^_]|__)+?)_\b|^\*((?:\*\*|[\s\S])+?)\*(?!\*)/,
  code: /^(`+)\s*([\s\S]*?[^`])\s*\1(?!`)/,
  br: /^ {2,}\n(?!\s*$)/,
  del: noop,
  text: /^[\s\S]+?(?=[\\<!\[_*`]| {2,}\n|$)/
};

inline._inside = /(?:\[[^\]]*\]|[^\[\]]|\](?=[^\[]*\]))*/;
inline._href = /\s*<?([\s\S]*?)>?(?:\s+['"]([\s\S]*?)['"])?\s*/;

inline.link = replace(inline.link)
  ('inside', inline._inside)
  ('href', inline._href)
  ();

inline.reflink = replace(inline.reflink)
  ('inside', inline._inside)
  ();

/**
 * Normal Inline Grammar
 */

inline.normal = merge({}, inline);

/**
 * Pedantic Inline Grammar
 */

inline.pedantic = merge({}, inline.normal, {
  strong: /^__(?=\S)([\s\S]*?\S)__(?!_)|^\*\*(?=\S)([\s\S]*?\S)\*\*(?!\*)/,
  em: /^_(?=\S)([\s\S]*?\S)_(?!_)|^\*(?=\S)([\s\S]*?\S)\*(?!\*)/
});

/**
 * GFM Inline Grammar
 */

inline.gfm = merge({}, inline.normal, {
  escape: replace(inline.escape)('])', '~|])')(),
  url: /^(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/,
  del: /^~~(?=\S)([\s\S]*?\S)~~/,
  text: replace(inline.text)
    (']|', '~]|')
    ('|', '|https?://|')
    ()
});

/**
 * GFM + Line Breaks Inline Grammar
 */

inline.breaks = merge({}, inline.gfm, {
  br: replace(inline.br)('{2,}', '*')(),
  text: replace(inline.gfm.text)('{2,}', '*')()
});

/**
 * Inline Lexer & Compiler
 */

function InlineLexer(links, options) {
  this.options = options || marked.defaults;
  this.links = links;
  this.rules = inline.normal;
  this.renderer = this.options.renderer || new Renderer;
  this.renderer.options = this.options;

  if (!this.links) {
    throw new
      Error('Tokens array requires a `links` property.');
  }

  if (this.options.gfm) {
    if (this.options.breaks) {
      this.rules = inline.breaks;
    } else {
      this.rules = inline.gfm;
    }
  } else if (this.options.pedantic) {
    this.rules = inline.pedantic;
  }
}

/**
 * Expose Inline Rules
 */

InlineLexer.rules = inline;

/**
 * Static Lexing/Compiling Method
 */

InlineLexer.output = function(src, links, options) {
  var inline = new InlineLexer(links, options);
  return inline.output(src);
};

/**
 * Lexing/Compiling
 */

InlineLexer.prototype.output = function(src) {
  var out = ''
    , link
    , text
    , href
    , cap;

  while (src) {
    // escape
    if (cap = this.rules.escape.exec(src)) {
      src = src.substring(cap[0].length);
      out += cap[1];
      continue;
    }

    // autolink
    if (cap = this.rules.autolink.exec(src)) {
      src = src.substring(cap[0].length);
      if (cap[2] === '@') {
        text = cap[1].charAt(6) === ':'
          ? this.mangle(cap[1].substring(7))
          : this.mangle(cap[1]);
        href = this.mangle('mailto:') + text;
      } else {
        text = escape(cap[1]);
        href = text;
      }
      out += this.renderer.link(href, null, text);
      continue;
    }

    // url (gfm)
    if (!this.inLink && (cap = this.rules.url.exec(src))) {
      src = src.substring(cap[0].length);
      text = escape(cap[1]);
      href = text;
      out += this.renderer.link(href, null, text);
      continue;
    }

    // tag
    if (cap = this.rules.tag.exec(src)) {
      if (!this.inLink && /^<a /i.test(cap[0])) {
        this.inLink = true;
      } else if (this.inLink && /^<\/a>/i.test(cap[0])) {
        this.inLink = false;
      }
      src = src.substring(cap[0].length);
      out += this.options.sanitize
        ? this.options.sanitizer
          ? this.options.sanitizer(cap[0])
          : escape(cap[0])
        : cap[0]
      continue;
    }

    // link
    if (cap = this.rules.link.exec(src)) {
      src = src.substring(cap[0].length);
      this.inLink = true;
      out += this.outputLink(cap, {
        href: cap[2],
        title: cap[3]
      });
      this.inLink = false;
      continue;
    }

    // reflink, nolink
    if ((cap = this.rules.reflink.exec(src))
        || (cap = this.rules.nolink.exec(src))) {
      src = src.substring(cap[0].length);
      link = (cap[2] || cap[1]).replace(/\s+/g, ' ');
      link = this.links[link.toLowerCase()];
      if (!link || !link.href) {
        out += cap[0].charAt(0);
        src = cap[0].substring(1) + src;
        continue;
      }
      this.inLink = true;
      out += this.outputLink(cap, link);
      this.inLink = false;
      continue;
    }

    // strong
    if (cap = this.rules.strong.exec(src)) {
      src = src.substring(cap[0].length);
      out += this.renderer.strong(this.output(cap[2] || cap[1]));
      continue;
    }

    // em
    if (cap = this.rules.em.exec(src)) {
      src = src.substring(cap[0].length);
      out += this.renderer.em(this.output(cap[2] || cap[1]));
      continue;
    }

    // code
    if (cap = this.rules.code.exec(src)) {
      src = src.substring(cap[0].length);
      out += this.renderer.codespan(escape(cap[2], true));
      continue;
    }

    // br
    if (cap = this.rules.br.exec(src)) {
      src = src.substring(cap[0].length);
      out += this.renderer.br();
      continue;
    }

    // del (gfm)
    if (cap = this.rules.del.exec(src)) {
      src = src.substring(cap[0].length);
      out += this.renderer.del(this.output(cap[1]));
      continue;
    }

    // text
    if (cap = this.rules.text.exec(src)) {
      src = src.substring(cap[0].length);
      out += this.renderer.text(escape(this.smartypants(cap[0])));
      continue;
    }

    if (src) {
      throw new
        Error('Infinite loop on byte: ' + src.charCodeAt(0));
    }
  }

  return out;
};

/**
 * Compile Link
 */

InlineLexer.prototype.outputLink = function(cap, link) {
  var href = escape(link.href)
    , title = link.title ? escape(link.title) : null;

  return cap[0].charAt(0) !== '!'
    ? this.renderer.link(href, title, this.output(cap[1]))
    : this.renderer.image(href, title, escape(cap[1]));
};

/**
 * Smartypants Transformations
 */

InlineLexer.prototype.smartypants = function(text) {
  if (!this.options.smartypants) return text;
  return text
    // em-dashes
    .replace(/---/g, '\u2014')
    // en-dashes
    .replace(/--/g, '\u2013')
    // opening singles
    .replace(/(^|[-\u2014/(\[{"\s])'/g, '$1\u2018')
    // closing singles & apostrophes
    .replace(/'/g, '\u2019')
    // opening doubles
    .replace(/(^|[-\u2014/(\[{\u2018\s])"/g, '$1\u201c')
    // closing doubles
    .replace(/"/g, '\u201d')
    // ellipses
    .replace(/\.{3}/g, '\u2026');
};

/**
 * Mangle Links
 */

InlineLexer.prototype.mangle = function(text) {
  if (!this.options.mangle) return text;
  var out = ''
    , l = text.length
    , i = 0
    , ch;

  for (; i < l; i++) {
    ch = text.charCodeAt(i);
    if (Math.random() > 0.5) {
      ch = 'x' + ch.toString(16);
    }
    out += '&#' + ch + ';';
  }

  return out;
};

/**
 * Renderer
 */

function Renderer(options) {
  this.options = options || {};
}

Renderer.prototype.code = function(code, lang, escaped) {
  if (this.options.highlight) {
    var out = this.options.highlight(code, lang);
    if (out != null && out !== code) {
      escaped = true;
      code = out;
    }
  }

  if (!lang) {
    return '<pre><code>'
      + (escaped ? code : escape(code, true))
      + '\n</code></pre>';
  }

  return '<pre><code class="'
    + this.options.langPrefix
    + escape(lang, true)
    + '">'
    + (escaped ? code : escape(code, true))
    + '\n</code></pre>\n';
};

Renderer.prototype.blockquote = function(quote) {
  return '<blockquote>\n' + quote + '</blockquote>\n';
};

Renderer.prototype.html = function(html) {
  return html;
};

Renderer.prototype.heading = function(text, level, raw) {
  return '<h'
    + level
    + ' id="'
    + this.options.headerPrefix
    + raw.toLowerCase().replace(/[^\w]+/g, '-')
    + '">'
    + text
    + '</h'
    + level
    + '>\n';
};

Renderer.prototype.hr = function() {
  return this.options.xhtml ? '<hr/>\n' : '<hr>\n';
};

Renderer.prototype.list = function(body, ordered) {
  var type = ordered ? 'ol' : 'ul';
  return '<' + type + '>\n' + body + '</' + type + '>\n';
};

Renderer.prototype.listitem = function(text) {
  return '<li>' + text + '</li>\n';
};

Renderer.prototype.paragraph = function(text) {
  return '<p>' + text + '</p>\n';
};

Renderer.prototype.table = function(header, body) {
  return '<table>\n'
    + '<thead>\n'
    + header
    + '</thead>\n'
    + '<tbody>\n'
    + body
    + '</tbody>\n'
    + '</table>\n';
};

Renderer.prototype.tablerow = function(content) {
  return '<tr>\n' + content + '</tr>\n';
};

Renderer.prototype.tablecell = function(content, flags) {
  var type = flags.header ? 'th' : 'td';
  var tag = flags.align
    ? '<' + type + ' style="text-align:' + flags.align + '">'
    : '<' + type + '>';
  return tag + content + '</' + type + '>\n';
};

// span level renderer
Renderer.prototype.strong = function(text) {
  return '<strong>' + text + '</strong>';
};

Renderer.prototype.em = function(text) {
  return '<em>' + text + '</em>';
};

Renderer.prototype.codespan = function(text) {
  return '<code>' + text + '</code>';
};

Renderer.prototype.br = function() {
  return this.options.xhtml ? '<br/>' : '<br>';
};

Renderer.prototype.del = function(text) {
  return '<del>' + text + '</del>';
};

Renderer.prototype.link = function(href, title, text) {
  if (this.options.sanitize) {
    try {
      var prot = decodeURIComponent(unescape(href))
        .replace(/[^\w:]/g, '')
        .toLowerCase();
    } catch (e) {
      return '';
    }
    if (prot.indexOf('javascript:') === 0 || prot.indexOf('vbscript:') === 0) {
      return '';
    }
  }
  var out = '<a href="' + href + '"';
  if (title) {
    out += ' title="' + title + '"';
  }
  out += '>' + text + '</a>';
  return out;
};

Renderer.prototype.image = function(href, title, text) {
  var out = '<img src="' + href + '" alt="' + text + '"';
  if (title) {
    out += ' title="' + title + '"';
  }
  out += this.options.xhtml ? '/>' : '>';
  return out;
};

Renderer.prototype.text = function(text) {
  return text;
};

/**
 * Parsing & Compiling
 */

function Parser(options) {
  this.tokens = [];
  this.token = null;
  this.options = options || marked.defaults;
  this.options.renderer = this.options.renderer || new Renderer;
  this.renderer = this.options.renderer;
  this.renderer.options = this.options;
}

/**
 * Static Parse Method
 */

Parser.parse = function(src, options, renderer) {
  var parser = new Parser(options, renderer);
  return parser.parse(src);
};

/**
 * Parse Loop
 */

Parser.prototype.parse = function(src) {
  this.inline = new InlineLexer(src.links, this.options, this.renderer);
  this.tokens = src.reverse();

  var out = '';
  while (this.next()) {
    out += this.tok();
  }

  return out;
};

/**
 * Next Token
 */

Parser.prototype.next = function() {
  return this.token = this.tokens.pop();
};

/**
 * Preview Next Token
 */

Parser.prototype.peek = function() {
  return this.tokens[this.tokens.length - 1] || 0;
};

/**
 * Parse Text Tokens
 */

Parser.prototype.parseText = function() {
  var body = this.token.text;

  while (this.peek().type === 'text') {
    body += '\n' + this.next().text;
  }

  return this.inline.output(body);
};

/**
 * Parse Current Token
 */

Parser.prototype.tok = function() {
  switch (this.token.type) {
    case 'space': {
      return '';
    }
    case 'hr': {
      return this.renderer.hr();
    }
    case 'heading': {
      return this.renderer.heading(
        this.inline.output(this.token.text),
        this.token.depth,
        this.token.text);
    }
    case 'code': {
      return this.renderer.code(this.token.text,
        this.token.lang,
        this.token.escaped);
    }
    case 'table': {
      var header = ''
        , body = ''
        , i
        , row
        , cell
        , flags
        , j;

      // header
      cell = '';
      for (i = 0; i < this.token.header.length; i++) {
        flags = { header: true, align: this.token.align[i] };
        cell += this.renderer.tablecell(
          this.inline.output(this.token.header[i]),
          { header: true, align: this.token.align[i] }
        );
      }
      header += this.renderer.tablerow(cell);

      for (i = 0; i < this.token.cells.length; i++) {
        row = this.token.cells[i];

        cell = '';
        for (j = 0; j < row.length; j++) {
          cell += this.renderer.tablecell(
            this.inline.output(row[j]),
            { header: false, align: this.token.align[j] }
          );
        }

        body += this.renderer.tablerow(cell);
      }
      return this.renderer.table(header, body);
    }
    case 'blockquote_start': {
      var body = '';

      while (this.next().type !== 'blockquote_end') {
        body += this.tok();
      }

      return this.renderer.blockquote(body);
    }
    case 'list_start': {
      var body = ''
        , ordered = this.token.ordered;

      while (this.next().type !== 'list_end') {
        body += this.tok();
      }

      return this.renderer.list(body, ordered);
    }
    case 'list_item_start': {
      var body = '';

      while (this.next().type !== 'list_item_end') {
        body += this.token.type === 'text'
          ? this.parseText()
          : this.tok();
      }

      return this.renderer.listitem(body);
    }
    case 'loose_item_start': {
      var body = '';

      while (this.next().type !== 'list_item_end') {
        body += this.tok();
      }

      return this.renderer.listitem(body);
    }
    case 'html': {
      var html = !this.token.pre && !this.options.pedantic
        ? this.inline.output(this.token.text)
        : this.token.text;
      return this.renderer.html(html);
    }
    case 'paragraph': {
      return this.renderer.paragraph(this.inline.output(this.token.text));
    }
    case 'text': {
      return this.renderer.paragraph(this.parseText());
    }
  }
};

/**
 * Helpers
 */

function escape(html, encode) {
  return html
    .replace(!encode ? /&(?!#?\w+;)/g : /&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

function unescape(html) {
	// explicitly match decimal, hex, and named HTML entities 
  return html.replace(/&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/g, function(_, n) {
    n = n.toLowerCase();
    if (n === 'colon') return ':';
    if (n.charAt(0) === '#') {
      return n.charAt(1) === 'x'
        ? String.fromCharCode(parseInt(n.substring(2), 16))
        : String.fromCharCode(+n.substring(1));
    }
    return '';
  });
}

function replace(regex, opt) {
  regex = regex.source;
  opt = opt || '';
  return function self(name, val) {
    if (!name) return new RegExp(regex, opt);
    val = val.source || val;
    val = val.replace(/(^|[^\[])\^/g, '$1');
    regex = regex.replace(name, val);
    return self;
  };
}

function noop() {}
noop.exec = noop;

function merge(obj) {
  var i = 1
    , target
    , key;

  for (; i < arguments.length; i++) {
    target = arguments[i];
    for (key in target) {
      if (Object.prototype.hasOwnProperty.call(target, key)) {
        obj[key] = target[key];
      }
    }
  }

  return obj;
}


/**
 * Marked
 */

function marked(src, opt, callback) {
  if (callback || typeof opt === 'function') {
    if (!callback) {
      callback = opt;
      opt = null;
    }

    opt = merge({}, marked.defaults, opt || {});

    var highlight = opt.highlight
      , tokens
      , pending
      , i = 0;

    try {
      tokens = Lexer.lex(src, opt)
    } catch (e) {
      return callback(e);
    }

    pending = tokens.length;

    var done = function(err) {
      if (err) {
        opt.highlight = highlight;
        return callback(err);
      }

      var out;

      try {
        out = Parser.parse(tokens, opt);
      } catch (e) {
        err = e;
      }

      opt.highlight = highlight;

      return err
        ? callback(err)
        : callback(null, out);
    };

    if (!highlight || highlight.length < 3) {
      return done();
    }

    delete opt.highlight;

    if (!pending) return done();

    for (; i < tokens.length; i++) {
      (function(token) {
        if (token.type !== 'code') {
          return --pending || done();
        }
        return highlight(token.text, token.lang, function(err, code) {
          if (err) return done(err);
          if (code == null || code === token.text) {
            return --pending || done();
          }
          token.text = code;
          token.escaped = true;
          --pending || done();
        });
      })(tokens[i]);
    }

    return;
  }
  try {
    if (opt) opt = merge({}, marked.defaults, opt);
    return Parser.parse(Lexer.lex(src, opt), opt);
  } catch (e) {
    e.message += '\nPlease report this to https://github.com/chjj/marked.';
    if ((opt || marked.defaults).silent) {
      return '<p>An error occured:</p><pre>'
        + escape(e.message + '', true)
        + '</pre>';
    }
    throw e;
  }
}

/**
 * Options
 */

marked.options =
marked.setOptions = function(opt) {
  merge(marked.defaults, opt);
  return marked;
};

marked.defaults = {
  gfm: true,
  tables: true,
  breaks: false,
  pedantic: false,
  sanitize: false,
  sanitizer: null,
  mangle: true,
  smartLists: false,
  silent: false,
  highlight: null,
  langPrefix: 'lang-',
  smartypants: false,
  headerPrefix: '',
  renderer: new Renderer,
  xhtml: false
};

/**
 * Expose
 */

marked.Parser = Parser;
marked.parser = Parser.parse;

marked.Renderer = Renderer;

marked.Lexer = Lexer;
marked.lexer = Lexer.lex;

marked.InlineLexer = InlineLexer;
marked.inlineLexer = InlineLexer.output;

marked.parse = marked;

if (true) {
  module.exports = marked;
} else if (typeof define === 'function' && define.amd) {
  define(function() { return marked; });
} else {
  this.marked = marked;
}

}).call(function() {
  return this || (typeof window !== 'undefined' ? window : global);
}());

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("DuR2")))

/***/ }),

/***/ "EGMK":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var merge_1 = __webpack_require__("kkb0");
Observable_1.Observable.prototype.merge = merge_1.merge;
//# sourceMappingURL=merge.js.map

/***/ }),

/***/ "EKta":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function placeHoldersCount (b64) {
  var len = b64.length
  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // the number of equal signs (place holders)
  // if there are two placeholders, than the two characters before it
  // represent one byte
  // if there is only one, then the three characters before it represent 2 bytes
  // this is just a cheap hack to not do indexOf twice
  return b64[len - 2] === '=' ? 2 : b64[len - 1] === '=' ? 1 : 0
}

function byteLength (b64) {
  // base64 is 4/3 + up to two characters of the original data
  return b64.length * 3 / 4 - placeHoldersCount(b64)
}

function toByteArray (b64) {
  var i, j, l, tmp, placeHolders, arr
  var len = b64.length
  placeHolders = placeHoldersCount(b64)

  arr = new Arr(len * 3 / 4 - placeHolders)

  // if there are placeholders, only get up to the last complete 4 chars
  l = placeHolders > 0 ? len - 4 : len

  var L = 0

  for (i = 0, j = 0; i < l; i += 4, j += 3) {
    tmp = (revLookup[b64.charCodeAt(i)] << 18) | (revLookup[b64.charCodeAt(i + 1)] << 12) | (revLookup[b64.charCodeAt(i + 2)] << 6) | revLookup[b64.charCodeAt(i + 3)]
    arr[L++] = (tmp >> 16) & 0xFF
    arr[L++] = (tmp >> 8) & 0xFF
    arr[L++] = tmp & 0xFF
  }

  if (placeHolders === 2) {
    tmp = (revLookup[b64.charCodeAt(i)] << 2) | (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[L++] = tmp & 0xFF
  } else if (placeHolders === 1) {
    tmp = (revLookup[b64.charCodeAt(i)] << 10) | (revLookup[b64.charCodeAt(i + 1)] << 4) | (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[L++] = (tmp >> 8) & 0xFF
    arr[L++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp = (uint8[i] << 16) + (uint8[i + 1] << 8) + (uint8[i + 2])
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var output = ''
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    output += lookup[tmp >> 2]
    output += lookup[(tmp << 4) & 0x3F]
    output += '=='
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + (uint8[len - 1])
    output += lookup[tmp >> 10]
    output += lookup[(tmp >> 4) & 0x3F]
    output += lookup[(tmp << 2) & 0x3F]
    output += '='
  }

  parts.push(output)

  return parts.join('')
}


/***/ }),

/***/ "ENML":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var range_1 = __webpack_require__("/8te");
Observable_1.Observable.range = range_1.range;
//# sourceMappingURL=range.js.map

/***/ }),

/***/ "EnA3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var do_1 = __webpack_require__("Rewd");
Observable_1.Observable.prototype.do = do_1._do;
Observable_1.Observable.prototype._do = do_1._do;
//# sourceMappingURL=do.js.map

/***/ }),

/***/ "EoAl":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var takeWhile_1 = __webpack_require__("KuCq");
Observable_1.Observable.prototype.takeWhile = takeWhile_1.takeWhile;
//# sourceMappingURL=takeWhile.js.map

/***/ }),

/***/ "Eqij":
/***/ (function(module, exports) {

exports.model=Model={Game:{},Board:{},Move:{}},function(){function t(t){if(o){var e=t%s;return(t-e)/s*s+s-e}var r=s*i-t-1,n=r%s;return r-n+s-n}var s,i,o=!1;Model.Game.checkersPosToString=t,Model.Game.InitGameInfo=function(){},Model.Game.BuildGraphCoord=function(){var t=(this.mOptions.width,this.mOptions.height,[]),s=[];this.g.Graph=t,this.g.Coord=s},Model.Game.InitGame=function(){var t=this.mOptions.width,e=this.mOptions.height;if(s=t,i=e,o=this.mOptions.invertNotation||!1,this.g.compulsoryCatch=!0,this.g.canStepBack=!0,this.g.mustMoveForward=!1,this.g.mustMoveForwardStrict=!1,this.g.lastRowFreeze=!1,this.g.lastRowCrown=!1,this.g.captureLongestLine=!1,this.g.noMove="lose",this.g.kingCaptureShort=!1,this.g.kingValue=5,this.g.lastRowFactor=0,this.g.canCaptureBackward=!0,this.g.captureInstantRemove=!1,this.g.longRangeKing=!0,this.g.drawKvsK=!0,this.g.drawKvs2K=!0,this.g.whiteStarts=!0,this.g.king180deg=!1,this.mOptions.variant)for(var r in this.mOptions.variant)this.mOptions.variant.hasOwnProperty(r)&&(this.g[r]=this.mOptions.variant[r]);this.BuildGraphCoord(),this.zobrist=new JocGame.Zobrist({board:{type:"array",size:this.g.Graph.length,values:["1/0","1/1","-1/0","-1/1"]}})},Model.Game.DestroyGame=function(){},Model.Game.CheckersDirections=4,Model.Game.Checkers2WaysDirections=[0,1,1,0],Model.Game.CheckersEachDirection=function(t,s){for(var i=0;i<this.CheckersDirections;i++){var o=this.g.Graph[t][i];if(null!=o&&0==s(o,i))return}},Model.Move.Init=function(t){this.pos=[];for(var s=t.pos?Object.keys(t.pos).sort():[],i=0;i<s.length;i++)this.pos.push(t.pos[i]);this.capt=[];for(var o=t.capt?Object.keys(t.capt).sort():[],i=0;i<o.length;i++)this.capt.push(t.capt[i])},Model.Move.ToString=function(s){s=s||"natural";var i=this;switch(s){case"natural":return function(){for(var s=[t(i.pos[0]),t(i.pos[i.pos.length-1])],o="-",e=1;e<i.capt.length;e++)null!=i.capt[e]&&(o="x",i.capt.length>3&&s.push(t(i.capt[e])));return s.join(o)}();case"hub":return function(){var s="-",o=[t(i.pos[0]),t(i.pos[i.pos.length-1])];if(i.capt[1]){s="x";var e=i.capt.slice(1).map(function(s){return t(s)});e.sort(),o=o.concat(e)}return o.join(s)}();case"dxp":return function(){var s=[t(i.pos[0]),t(i.pos[i.pos.length-1])];if(i.capt[1]){s.push(i.capt.length-1);for(var o=[],e=1;e<i.capt.length;e++)o.push(t(i.capt[e]));o.sort(),s=s.concat(o)}else s.push(0);return s.map(function(t){return t<10?"0"+t:t}).join("")}();default:return"??"}},Model.Board.Init=function(t){this.zSign=0},Model.Board.InitialPosition=function(t){var s=t.mOptions.width,i=t.mOptions.height,o=t.mOptions.initial;this.board=[];for(var e=0;e<i;e++)for(var r=0;r<s;r++)this.board[e*s+r]=-1;this.pieces=[];var n=0;if(t.mInitial){this.pCount=[0,0],this.spCount=[0,0],this.kpCount=[0,0];for(var a=0;a<t.mInitial.pieces.length;a++){var h=t.mInitial.pieces[a];this.board[h.p]=a,this.pieces.push({s:h.s,p:h.p,l:-1,t:h.t,plp:h.p}),this.zSign=t.zobrist.update(this.zSign,"board",h.s+"/"+h.t,h.p);var p=-(h.s-1)/2;this.pCount[p]++,0==h.t?this.spCount[p]++:this.kpCount[p]++}}else{for(var a in o.a)if(o.a.hasOwnProperty(a)){var u=o.a[a],c=u[0]*s+u[1],h={s:JocGame.PLAYER_A,p:c,l:-1,t:0,plp:c};this.pieces.push(h),this.board[c]=n++,this.zSign=t.zobrist.update(this.zSign,"board","1/0",c)}for(var a in o.b)if(o.b.hasOwnProperty(a)){var u=o.b[a],c=u[0]*s+u[1],h={s:JocGame.PLAYER_B,p:c,l:-1,t:0,plp:c};this.pieces.push(h),this.board[c]=n++,this.zSign=t.zobrist.update(this.zSign,"board","-1/0",c)}this.pCount=[o.a.length,o.b.length],this.spCount=[o.a.length,o.b.length],this.kpCount=[o.a.length,o.b.length]}},Model.Board.GenerateMoves=function(t){try{this._GenerateMoves(t)}catch(t){}},Model.Board._GenerateMoves=function(t){function s(t){for(var s=0;s<e.pieces.length;s++){var i=e.pieces[s];i&&i.s==e.mWho&&t(s,i.p)}}function i(s,o,r,n,a){for(;;){var h=[],p=[],u=[];if(t.CheckersEachDirection(s,function(i,c){var l;0==t.g.canCaptureBackward&&(l=t.g.Coord[s][0]);var g=t.Checkers2WaysDirections[c];if(a){if(t.g.longRangeKing)for(;e.board[i]==-1||t.g.king180deg&&null!=i&&r.indexOf(i)>=0;)i=t.g.Graph[i][c];if(null!=i&&e.board[i]>=0&&e.pieces[e.board[i]].s==-e.mWho){var v=i;if(i=t.g.Graph[i][c],t.g.kingCaptureShort){if(e.board[i]==-1||i==o[0]){for(var f=!0,d=0;d<n.length;d++)if(t.g.king180deg){if(r[d]==v){f=!1;break}}else if(t.g.captureInstantRemove&&r[d]==v||0==t.g.captureInstantRemove&&r[d]==v&&n[d]==g){f=!1;break}f&&(h.push(i),p.push(v),u.push(g)),i=t.g.Graph[i][c]}}else for(;e.board[i]==-1||i==o[0];){for(var f=!0,d=0;d<n.length;d++)if(t.g.captureInstantRemove&&r[d]==v||0==t.g.captureInstantRemove&&r[d]==v&&n[d]==g){f=!1;break}f&&(h.push(i),p.push(v),u.push(g)),i=t.g.Graph[i][c]}}}else if(e.board[i]>=0&&e.pieces[e.board[i]].s==-e.mWho){var m,C;if(0==t.g.canCaptureBackward&&(m=t.g.Coord[i][0],C=!1,(e.mWho==JocGame.PLAYER_A&&m>=l||e.mWho==JocGame.PLAYER_B&&m<=l)&&(C=!0)),t.g.canCaptureBackward||1==C){var b=t.g.Graph[i][c];if(null!=b&&(e.board[b]==-1||b==o[0])){for(var f=!0,d=0;d<n.length;d++)if(t.g.captureInstantRemove&&r[d]==i||0==t.g.captureInstantRemove&&r[d]==i&&n[d]==g){f=!1;break}f&&(h.push(b),p.push(i),u.push(g))}}}return!0}),0==h.length){o.length>1&&e.mMoves.push({pos:o,capt:r});break}if(!t.g.compulsoryCatch&&o.length>1){for(var c=[],l=0;l<o.length;l++)c.push(o[l]);for(var g=[],l=0;l<r.length;l++)g.push(r[l]);e.mMoves.push({pos:c,capt:g})}if(1!=h.length){for(var l=0;l<h.length;l++){for(var c=[],v=0;v<o.length;v++)c.push(o[v]);c.push(h[l]);for(var g=[],v=0;v<r.length;v++)g.push(r[v]);g.push(p[l]);for(var f=[],v=0;v<n.length;v++)f.push(n[v]);f.push(u[l]),i(h[l],c,g,f,a)}break}s=h[0],o.push(s),r.push(p[0]),n.push(u[0])}}var o=t.mOptions.height,e=this;if(this.mMoves=[],s(function(t,s){0==e.pieces[t].t?i(s,[s],[null],[null],!1):1==e.pieces[t].t&&i(s,[s],[null],[null],!0)}),0!=t.g.compulsoryCatch&&0!=this.mMoves.length||s(function(s,i){var r;0==e.pieces[s].t?((t.g.mustMoveForward||t.g.mustMoveForwardStrict||t.lastRowFreeze)&&(r=t.g.Coord[i][0]),t.CheckersEachDirection(i,function(n,a){var h,p,u;return t.g.mustMoveForwardStrict?(h=t.g.Coord[n][0],p=!1,(e.mWho==JocGame.PLAYER_A&&h>r||e.mWho==JocGame.PLAYER_B&&h<r)&&(p=!0)):t.g.mustMoveForward&&(h=t.g.Coord[n][0],p=!0,(e.mWho==JocGame.PLAYER_A&&h<r||e.mWho==JocGame.PLAYER_B&&h>r)&&(p=!1)),t.g.lastRowFreeze&&(u=!1,(e.mWho==JocGame.PLAYER_A&&r==o-1||e.mWho==JocGame.PLAYER_B&&0==r)&&(u=!0)),e.board[n]!=-1||!t.g.canStepBack&&n==e.pieces[s].l||(0!=t.g.mustMoveForward||0!=t.g.mustMoveForwardStrict)&&1!=p||0!=t.g.lastRowFreeze&&0!=u||e.mMoves.push({pos:[i,n],capt:[null,null]}),!0})):1==e.pieces[s].t&&t.CheckersEachDirection(i,function(s,o){if(t.g.longRangeKing)for(;e.board[s]==-1;)e.mMoves.push({pos:[i,s],capt:[null,null]}),s=t.g.Graph[s][o];else e.board[s]==-1&&(e.mMoves.push({pos:[i,s],capt:[null,null]}),s=t.g.Graph[s][o]);return!0})}),0==this.mMoves.length)switch(t.g.noMove){case"count":this.mFinished=!0,this.pCount[0]<this.pCount[1]?this.mWinner=JocGame.PLAYER_B:this.pCount[1]<this.pCount[0]?this.mWinner=JocGame.PLAYER_A:this.mWinner=JocGame.DRAW;break;case"lose":this.mFinished=!0,this.mWinner=-this.mWho;break;default:this.mFinished=!0,this.mWinner=JocGame.DRAW}if(t.g.captureLongestLine){for(var r=this.mMoves,n=[],a=0,h=0;h<r.length;h++){var p=r[h];p.pos.length==a?n.push(p):p.pos.length>a&&(n=[p],a=p.pos.length)}this.mMoves=n}},Model.Board.Evaluate=function(t,s,i){if(t.mOptions.preventRepeat&&t.GetRepeatOccurence(this)>2)return this.mFinished=!0,void(this.mWinner=JocGame.DRAW);if(t.g.drawKvsK&&0==this.spCount[0]&&0==this.spCount[1]&&1==this.kpCount[0]&&1==this.kpCount[1])return this.mFinished=!0,void(this.mWinner=JocGame.DRAW);if(t.g.drawKvs2K&&0==this.spCount[0]&&0==this.spCount[1]&&this.kpCount[0]+this.kpCount[1]==3&&(1==this.kpCount[0]||2==this.kpCount[0]))return this.mFinished=!0,void(this.mWinner=JocGame.DRAW);if(0==this.pCount[1])return this.mFinished=!0,void(this.mWinner=JocGame.PLAYER_A);if(0==this.pCount[0])return this.mFinished=!0,void(this.mWinner=JocGame.PLAYER_B);if(this.mEvaluation=10*(this.spCount[0]-this.spCount[1])+10*(this.kpCount[0]-this.kpCount[1])*t.g.kingValue+this.pCount[0]/this.pCount[1]-this.pCount[1]/this.pCount[0],0!=t.g.lastRowFactor){for(var o=t.mOptions.height,e=0,r=0,n=0;n<this.pieces.length;n++){var a=this.pieces[n];a&&0==a.t&&(this.mWho==JocGame.PLAYER_A?e+=t.g.Coord[a.p][0]:r+=o-1-t.g.Coord[a.p][0])}this.mEvaluation+=(e-r)*t.g.lastRowFactor}},Model.Board.CopyFrom=function(t){this.board=[];for(var s=0;s<t.board.length;s++)this.board[s]=t.board[s];this.pieces=[];for(var s=0;s<t.pieces.length;s++){var i=t.pieces[s];this.pieces[s]=null==i?null:{s:i.s,p:i.p,l:i.l,t:i.t,plp:i.plp}}this.pCount=[t.pCount[0],t.pCount[1]],this.spCount=[t.spCount[0],t.spCount[1]],this.kpCount=[t.kpCount[0],t.kpCount[1]],this.mWho=t.mWho,this.zSign=t.zSign},Model.Board.ApplyMove=function(t,s){var i=(t.mOptions.width,t.mOptions.height),o=s.pos[0],e=this.board[o],r=this.pieces[e],n=r.s;r.l=o;var a={};this.zSign=t.zobrist.update(this.zSign,"board",r.s+"/"+r.t,r.p);for(var h=1;h<s.pos.length;h++){var p=s.pos[h];this.board[r.p]=-1,r.p=p,this.board[p]=e;var u=s.capt[h];null!=u&&(this.board[u]>=0&&(a[this.board[u]]=!0),this.board[u]=-1),o=p}this.zSign=t.zobrist.update(this.zSign,"board",r.s+"/"+r.t,p);var c=s.capt[s.capt.length-1];r.plp=c||s.pos[s.pos.length-2];for(var l in a)if(a.hasOwnProperty(l)){var g=this.pieces[l],v=(1-g.s)/2;switch(this.pCount[v]--,g.t){case 0:this.spCount[v]--;break;case 1:this.kpCount[v]--}this.zSign=t.zobrist.update(this.zSign,"board",g.s+"/"+g.t,g.p),this.pieces[l]=null}if(t.g.lastRowCrown&&0==this.pieces[e].t){var f=t.g.Coord[s.pos[s.pos.length-1]][0];if(n==JocGame.PLAYER_A&&f==i-1||n==JocGame.PLAYER_B&&0==f){var g=this.pieces[e];g.t=1;var d=(1-n)/2;this.spCount[d]--,this.kpCount[d]++,this.zSign=t.zobrist.update(this.zSign,"board",g.s+"/0",g.p),this.zSign=t.zobrist.update(this.zSign,"board",g.s+"/1",g.p)}}},Model.Board.IsValidMove=function(t,s){return!0},Model.Board.GetSignature=function(){return this.zSign},Model.Game.Import=function(t,s){function i(t,s,i){i=r-i;var o=i%n;i=i-o+n-o-1,e.push({s:t,p:i,l:-1,t:s,plp:i})}var o=1,e=[],r=this.mOptions.width*this.mOptions.height,n=this.mOptions.width;if("pjn"==t){var a=s.split(":");o="W"==a[0]?1:-1;for(var h=1;h<a.length;h++)if(0!=a[h].length)for(var p="W"==a[h].substr(0,1)?1:-1,u=a[h].substr(1).split(","),c=0;c<u.length;c++){var l=u[c],g=0;"K"==l.substr(0,1)&&(g=1,l=l.substr(1));var v=/^([0-9]+)-([0-9]+)$/.exec(l);if(v)for(var f=parseInt(v[1]);f<=parseInt(v[2]);f++)i(p,g,f);else i(p,g,parseInt(l))}return e.sort(function(t,s){return s.s-t.s}),{status:!0,initial:{pieces:e,turn:o}}}return{status:!1,error:"unsupported"}};var e=JocGame.prototype.GetBestMatchingMove;Model.Game.GetBestMatchingMove=function(t,s){var i=[],o=this;s.forEach(function(t){"function"==typeof t.ToString?i.push(t.ToString()):i.push(o.CreateMove(t).ToString())}),t=t.replace(/0([1-9])/g,"$1");var r=/^([0-9]+)[\-x]([0-9]+)([\-x][0-9]+)*$/.exec(t);if(r){var n=new RegExp("^"+r[1]+"[-x]"+r[2]+"([-x][0-9]+)*$"),a={};s.forEach(function(t,s){if(n.test(i[s])){var o=i[s],e=/^([0-9]+)x([0-9]+)x([0-9]+(x[0-9]+)*)/.exec(o);if(e){var r=e[3].split("x");r.sort(function(t,s){return parseInt(t)-parseInt(s)}),o=e[1]+"x"+e[2]+"x"+r.join("x")}a[o]=t}});var h=[];for(var p in a)a.hasOwnProperty(p)&&h.push(a[p]);h.length>0&&(s=h)}return e.call(this,t,s)},Model.Board.ExportBoardState=function(o,e){function r(t){for(var o=[],e=0;e<n.board.length;e++){var r=e%s,a=(e-r)/s,h=(i-a-1)*s+r,p=n.board[e];if(p<0)o[h]="e";else{var u=n.pieces[p],c=1==u.s?"w":t;1==u.t&&(c=c.toUpperCase()),o[h]=c}}return o.join("")}e=e||"natural";var n=this;switch(e){case"natural":case"fen":return function(){var s={},i=[];n.pieces.forEach(function(i){if(i&&null!=i.p){var o=1==i.s?"W":"B";void 0===s[o]&&(s[o]={});var e=1==i.t?"K":"";void 0===s[o][e]&&(s[o][e]={group:0==i.t,pos:[]}),s[o][e].pos.push(parseInt(t(i.p)))}});for(var o in s)if(s.hasOwnProperty(o)){var e=[];for(var r in s[o])if(s[o].hasOwnProperty(r)){var a=s[o][r];if(a.group){a.pos.sort(function(t,s){return parseInt(t)-parseInt(s)});var h=-2,p=-1,u=-1;a.pos.forEach(function(t){parseInt(t)==h+1?p=t:(p>=0?(e.push(r+u+"-"+p),p=-1):u>=0&&e.push(r+u),u=t),h=parseInt(t)}),p>=0?e.push(r+u+"-"+p):u>=0&&e.push(r+u)}else a.pos.forEach(function(t){e.push(r+t)})}i.push(o+e.join(","))}return i.join(":")}();case"dxp":return function(){return r("z")}();case"hub":return function(){return r("z")}();default:return JSON.stringify(this)}}}(),Model.Game.BuildGraphCoord=function(){for(var t=this.mOptions.width,s=this.mOptions.height,i=[],o=[],e=0;e<s;e++)for(var r=0;r<t;r++){var n=e*t+r;o[n]=[e,r],i[n]=[],e%2==0?(e<s-1?(i[n].push((e+1)*t+r),r>0?i[n].push((e+1)*t+r-1):i[n].push(null)):(i[n].push(null),i[n].push(null)),e>0?(i[n].push((e-1)*t+r),r>0?i[n].push((e-1)*t+r-1):i[n].push(null)):(i[n].push(null),i[n].push(null))):(e<s-1?(r<t-1?i[n].push((e+1)*t+r+1):i[n].push(null),i[n].push((e+1)*t+r)):(i[n].push(null),i[n].push(null)),e>0?(r<t-1?i[n].push((e-1)*t+r+1):i[n].push(null),i[n].push((e-1)*t+r)):(i[n].push(null),i[n].push(null)))}this.g.Graph=i,this.g.Coord=o};

/***/ }),

/***/ "EuP9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__("EKta")
var ieee754 = __webpack_require__("ujcs")
var isArray = __webpack_require__("sOR5")

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("DuR2")))

/***/ }),

/***/ "Ey09":
/***/ (function(module, exports) {

exports.config = {"status":true,"model":{"plazza":"true","released":1404999946,"title-en":"Modern Chess","module":"chessbase","summary":"Chess on 9x9 (1968)","thumbnail":"modern-thumb.png","rules":{"en":"modern-rules.html"},"credits":{"en":"modern-credits.html"},"gameOptions":{"preventRepeat":true,"uctTransposition":"state","uctIgnoreLoop":false,"levelOptions":{"pieceValueFactor":1,"pieceValueRatioFactor":1,"posValueFactor":0.1,"averageDistKingFactor":-0.01,"castleFactor":0.1,"minorPiecesMovedFactor":0.1,"checkFactor":0.2,"endingKingFreedomFactor":0.01,"endingDistKingFactor":0.05,"distKingCornerFactor":0.1,"distPawnPromo1Factor":0.3,"distPawnPromo2Factor":0.1,"distPawnPromo3Factor":0.05}},"obsolete":false,"js":["base-model.js","grid-geo-model.js","modern-model.js"],"description":{"en":"modern-description.html"},"levels":[{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"easy","label":"Easy","maxNodes":1000},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"fast","label":"Fast [1sec]","maxDuration":1,"isDefault":true},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"medium","label":"Medium","maxNodes":10000,"maxDuration":10},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"strong","label":"Strong","maxNodes":20000,"maxDuration":15}]},"view":{"title-en":"Chessbase view","module":"chessbase","xdView":true,"css":["chessbase.css"],"preferredRatio":1,"useShowMoves":true,"useNotation":true,"useAutoComplete":true,"defaultOptions":{"sounds":true,"moves":true,"notation":false,"autocomplete":false},"skins":[{"name":"skin3d","title":"3D Classic","3d":true,"preload":["smoothedfilegeo|0|/res/ring-target.js","image|/res/images/cancel.png","image|/res/images/wikipedia.png","smoothedfilegeo|0|/res/fairy/pawn/pawn.js","image|/res/fairy/pawn/pawn-diffusemap.jpg","image|/res/fairy/pawn/pawn-normalmap.jpg","smoothedfilegeo|0|/res/fairy/knight/knight.js","image|/res/fairy/knight/knight-diffusemap.jpg","image|/res/fairy/knight/knight-normalmap.jpg","smoothedfilegeo|0|/res/fairy/bishop/bishop.js","image|/res/fairy/bishop/bishop-diffusemap.jpg","image|/res/fairy/bishop/bishop-normalmap.jpg","smoothedfilegeo|0|/res/fairy/queen/queen.js","image|/res/fairy/queen/queen-diffusemap.jpg","image|/res/fairy/queen/queen-normalmap.jpg","smoothedfilegeo|0|/res/fairy/king/king.js","image|/res/fairy/king/king-diffusemap.jpg","image|/res/fairy/king/king-normalmap.jpg","smoothedfilegeo|0|/res/fairy/rook/rook.js","image|/res/fairy/rook/rook-diffusemap.jpg","image|/res/fairy/rook/rook-normalmap.jpg","smoothedfilegeo|0|/res/fairy/cardinal/cardinal.js","image|/res/fairy/cardinal/cardinal-diffusemap.jpg","image|/res/fairy/cardinal/cardinal-normalmap.jpg"],"world":{"lightIntensity":1.3,"skyLightIntensity":1.2,"lightCastShadow":true,"fog":false,"color":4686804,"lightPosition":{"x":-9,"y":9,"z":9},"skyLightPosition":{"x":9,"y":9,"z":9},"lightShadowDarkness":0.55,"ambientLightColor":2236962},"camera":{"fov":45,"distMax":50,"radius":18,"elevationAngle":60,"elevationMin":0}},{"name":"skin2d","title":"2D Classic","3d":false,"preload":["image|/res/images/cancel.png","image|/res/images/whitebg.png","image|/res/fairy/wikipedia-fairy-sprites.png"]}],"animateSelfMoves":false,"switchable":true,"sounds":{"move1":"alq_move1","move2":"alq_move2","move3":"alq_move3","move4":"alq_move2","tac1":"alq_tac1","tac2":"alq_tac2","tac3":"alq_tac1","promo":"promo","usermove":null},"js":["base-view.js","grid-board-view.js","fairy-set-view.js","modern-view.js"],"visuals":{"600x600":["res/visuals/modern-600x600-3d.jpg","res/visuals/modern-600x600-2d.jpg"]}}}

/***/ }),

/***/ "F428":
/***/ (function(module, exports) {

exports.model=Model={Game:{},Board:{},Move:{}},function(){var t,s,o="undefined"!=typeof Int8Array;o?(t=function(t){return new Int8Array(t)},s=function(t){var s=new Int8Array(t.length);return s.set(t),s}):(t=function(t){for(var s=[],o=0;o<t;o++)s.push(0);return s},s=function(t){for(var s=[],o=t.length,i=0;i<o;i++)s.push(t[i]);return s}),Model.Game.isAlive=function(t,s){return this.POS(s,t)in this.g.confine},Model.Game.C=function(t){return t%this.mOptions.width},Model.Game.R=function(t){return Math.floor(t/this.mOptions.width)},Model.Game.RC=function(t){return{r:Math.floor(t/this.mOptions.width),c:t%this.mOptions.width}},Model.Game.POS=function(t,s){return s*this.mOptions.width+t},Model.Game.STR2POS=function(t){var s=/^(\d+):(\d+)$/.exec(t);if(s){var o=parseInt(s[1]),i=parseInt(s[2]);return this.POS(i,o)}return null},Model.Game.InitGame=function(){var s=this.NBCOLS=this.mOptions.width,o=this.NBROWS=this.mOptions.height;this.g.confine={},this.g.totalCount=o*s;for(var i=0;i<o;i++)for(var r=0;r<s;r++)this.g.confine[this.POS(r,i)]=1;if(this.mOptions.deadCells)for(var e in this.mOptions.deadCells){var a=this.STR2POS(e);null!=a&&(this.g.totalCount--,delete this.g.confine[a])}this.g.dirDeltaRC=[[1,-1],[1,0],[1,1],[0,1],[-1,1],[-1,0],[-1,-1],[0,-1]],this.g.Graph={};for(var i=0;i<o;i++)for(var r=0;r<s;r++){var a=this.POS(r,i);if(a in this.g.confine){for(var h=t(this.g.dirDeltaRC.length),n=0;n<this.g.dirDeltaRC.length;n++){var l=this.g.dirDeltaRC[n],v=i+l[0],d=r+l[1],u=v*s+d;v>=0&&d>=0&&v<o&&d<s&&u in this.g.confine?h[n]=u:h[n]=-1}this.g.Graph[a]=h}}this.g.corners={};for(var a in this.g.confine){for(var f=0,l=0;l<8;l++){var u=this.g.Graph[a][l];u<0&&(f|=1<<l)}15!=(15&f)&&30!=(30&f)&&60!=(60&f)&&120!=(120&f)&&240!=(240&f)&&225!=(225&f)&&195!=(195&f)&&135!=(135&f)||(this.g.corners[a]=1)}this.g.borders={};for(var a in this.g.confine)if(!(a in this.g.corners)){for(var f=0,l=0;l<8;l++){var u=this.g.Graph[a][l];u<0&&(f|=1<<l)}7!=(7&f)&&14!=(14&f)&&28!=(28&f)&&56!=(56&f)&&112!=(112&f)&&224!=(224&f)&&193!=(193&f)&&131!=(131&f)||(this.g.borders[a]=1)}this.zobrist=new JocGame.Zobrist({board:{type:"array",size:s*o,values:["1","-1"]}})},Model.Move.Init=function(t){this.row=t.row,this.col=t.col,this.pass=t.pass},Model.Move.CopyFrom=function(t){this.row=t.row,this.col=t.col,this.pass=t.pass},Model.Move.ToString=function(){return this.pass?"-":String.fromCharCode("a".charCodeAt(0)+this.col)+(this.row+1)},Model.Move.Equals=function(t){return!(!t.pass||!this.pass)||this.row==t.row&&this.col==t.col},Model.Board.Init=function(t){this.zSign=0},Model.Board.InitialPosition=function(s){this.board=t(s.mOptions.width*s.mOptions.height),this.counts=[0,0],this.freeClose={},this.passes=0,this.lastMove=null;var o=this;[1,-1].forEach(function(t){var i=(1-t)/2;s.mOptions.initial[t].forEach(function(r){o.counts[i]++;var e=s.STR2POS(r);o.board[e]=t,delete o.freeClose[e];for(var a=0;a<8;a++){var h=s.g.Graph[e][a];h<0||(o.board[h]||(o.freeClose[h]=1))}o.zSign=s.zobrist.update(o.zSign,"board",t,e)})}),this.FindMoves(s),this.stable={};for(var i in s.g.corners)this.stable[i]=3;this.aboutStable={},this.aboutBorder={},this.rvUpdateStable(s,s.g.corners),this.rvUpdateAboutBorder(s)},Model.Board.CopyFrom=function(t){this.mWho=t.mWho,this.zSign=t.zSign,this.board=s(t.board),this.counts=[t.counts[0],t.counts[1]],this.freeClose={};for(var o in t.freeClose)this.freeClose[o]=1;this.passes=t.passes,this.lastMove=null,t.lastMove?this.lastMove={row:t.lastMove.row,col:t.lastMove.col}:this.lastMove=null,this.movePoss={1:s(t.movePoss[1]),"-1":s(t.movePoss[-1])},this.stable=t.stable,this.aboutStable=t.aboutStable,this.aboutBorder=t.aboutBorder},Model.Board.GenerateMoves=function(t){this.mMoves=[];for(var s=0;s<this.movePoss[this.mWho].length;s++){var o=this.movePoss[this.mWho][s],i=t.RC(o);this.PushMove(t,{row:i.r,col:i.c})}0==this.mMoves.length&&this.PushMove(t,{pass:!0,row:-1,col:-1})},Model.Board.FindMoves=function(t){this.movePoss={1:[],"-1":[]};var s=t.g.Graph;for(var o in this.freeClose){for(var i=s[o],r=0,e=0;e<8;e++){var a=i[e];if(a>=0){var h=-this.board[a];if(h){var n=1==h?1:2;if(!(r&n)){for(!0,a=s[a][e];this.board[a]==-h;)a=s[a][e];if(a>=0&&this.board[a]==h&&(r|=n),3==r)break}}}}1&r&&this.movePoss[1].push(o),2&r&&this.movePoss[-1].push(o)}},Model.Board.ApplyMove=function(t,s){if(this.lastMove=null,s.pass)return void this.passes++;this.lastMove={row:s.row,col:s.col},this.passes=0;var o=(1-this.mWho)/2,i=1<<o;this.counts[o]++;var r=t.POS(s.col,s.row),e=t.g.Graph,a=e[r];this.board[r]=this.mWho,this.zSign=t.zobrist.update(this.zSign,"board",this.mWho,r),delete this.freeClose[r];var h=!1,n={};(this.stable[r]||0)&i&&(h=!0,n[r]=1);for(var l=0;l<8;l++){var v=a[l];v>=0&&0==this.board[v]&&(this.freeClose[v]=1);for(var d=[];v>=0&&this.board[v]==-this.mWho;)d.push(v),v=e[v][l];if(v>=0&&d.length>0&&this.board[v]==this.mWho)for(var u=d.length-1;u>=0;u--){var f=d[u];this.zSign=t.zobrist.update(this.zSign,"board",-this.mWho,f),this.zSign=t.zobrist.update(this.zSign,"board",this.mWho,f),this.board[f]=this.mWho,this.counts[o]++,this.counts[1-o]--,(this.stable[f]||0)&i&&(h=!0,n[f]=1)}}h&&this.rvUpdateStable(t,n),r in t.g.borders&&this.rvUpdateAboutBorder(t),this.FindMoves(t)},Model.Board.rvUpdateStable=function(t,s){var o=this.stable;this.stable={};for(var i in o)this.stable[i]=o[i];for(var r=!0,e=1==this.mWho?1:2,a=t.g.Graph;r;){r=!1;var h={};for(var i in s)for(var n=a[i],l=0;l<8;l++){var v=n[l];v>=0&&!((this.stable[v]||0)&e)&&(h[v]=1)}var s={};for(var i in h){for(var n=a[i],d=0,l=0;l<8;l++){var v=n[l];(v<0||this.board[v]==this.mWho&&(this.stable[v]||0)&e)&&(d|=1<<l)}15!=(15&d)&&30!=(30&d)&&60!=(60&d)&&120!=(120&d)&&240!=(240&d)&&225!=(225&d)&&195!=(195&d)&&135!=(135&d)||(this.stable[i]=(this.stable[i]||0)|e,r=!0,s[i]=1)}}this.aboutStable={};for(var i in this.stable)if(!this.board[i])for(var n=a[i],l=0;l<8;l++){var v=n[l];v>=0&&!(v in this.stable)&&(this.aboutStable[v]=(this.aboutStable[v]||0)|this.stable[i])}},Model.Board.rvUpdateAboutBorder=function(t){this.aboutBorder={};var s=t.g.Graph,o=t.g.borders;for(var i in o)if(!this.board[i])for(var r=s[i],e=0;e<8;e++){var a=r[e];!(a>=0)||a in this.stable||a in this.aboutStable||a in o||(this.aboutBorder[a]=1)}},Model.Board.Evaluate=function(t){this.mEvaluation=0;t.mOptions.width,t.mOptions.height;if(2==this.passes||this.counts[0]+this.counts[1]==t.g.totalCount||0==this.counts[0]||0==this.counts[1])return this.mFinished=!0,void(this.counts[0]>this.counts[1]?this.mWinner=JocGame.PLAYER_A:this.counts[0]<this.counts[1]?this.mWinner=JocGame.PLAYER_B:this.mWinner=JocGame.DRAW);var s=t.mOptions.levelOptions,o={},i={1:0,"-1":0},r={1:0,"-1":0},e={1:0,"-1":0},a={1:0,"-1":0},h=t.g.confine,n=t.g.borders;for(var l in h){var v=this.board[l];if(v){var d=1==v?1:2,u=1==v?2:1;(this.stable[l]||0)&d?i[v]++:(this.aboutStable[l]||0)&u?l in n?e[v]++:r[v]++:l in n&&a[v]++}}o.stable=i[1]-i[-1],o.aboutStable=r[1]-r[-1],o.aboutStableBorder=e[1]-e[-1],o.border=a[1]-a[-1],o.count=this.counts[0]-this.counts[1];var f=this.movePoss[1].length+this.movePoss[-1].length;o.mobility=f?(this.movePoss[1].length-this.movePoss[-1].length)/f:0;for(var b in o){var c=o[b],m=s[b+"Factor"]||0,g=c*m;this.mEvaluation+=g}},Model.Board.GetSignature=function(){return this.zSign}}();

/***/ }),

/***/ "F7Al":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * An error thrown when an Observable or a sequence was queried but has no
 * elements.
 *
 * @see {@link first}
 * @see {@link last}
 * @see {@link single}
 *
 * @class EmptyError
 */
var EmptyError = (function (_super) {
    __extends(EmptyError, _super);
    function EmptyError() {
        var err = _super.call(this, 'no elements in sequence');
        this.name = err.name = 'EmptyError';
        this.stack = err.stack;
        this.message = err.message;
    }
    return EmptyError;
}(Error));
exports.EmptyError = EmptyError;
//# sourceMappingURL=EmptyError.js.map

/***/ }),

/***/ "F9Zs":
/***/ (function(module, exports) {

exports.model=Model={Game:{},Board:{},Move:{}},function(){function t(t){if(o){var e=t%s;return(t-e)/s*s+s-e}var r=s*i-t-1,n=r%s;return r-n+s-n}var s,i,o=!1;Model.Game.checkersPosToString=t,Model.Game.InitGameInfo=function(){},Model.Game.BuildGraphCoord=function(){var t=(this.mOptions.width,this.mOptions.height,[]),s=[];this.g.Graph=t,this.g.Coord=s},Model.Game.InitGame=function(){var t=this.mOptions.width,e=this.mOptions.height;if(s=t,i=e,o=this.mOptions.invertNotation||!1,this.g.compulsoryCatch=!0,this.g.canStepBack=!0,this.g.mustMoveForward=!1,this.g.mustMoveForwardStrict=!1,this.g.lastRowFreeze=!1,this.g.lastRowCrown=!1,this.g.captureLongestLine=!1,this.g.noMove="lose",this.g.kingCaptureShort=!1,this.g.kingValue=5,this.g.lastRowFactor=0,this.g.canCaptureBackward=!0,this.g.captureInstantRemove=!1,this.g.longRangeKing=!0,this.g.drawKvsK=!0,this.g.drawKvs2K=!0,this.g.whiteStarts=!0,this.g.king180deg=!1,this.mOptions.variant)for(var r in this.mOptions.variant)this.mOptions.variant.hasOwnProperty(r)&&(this.g[r]=this.mOptions.variant[r]);this.BuildGraphCoord(),this.zobrist=new JocGame.Zobrist({board:{type:"array",size:this.g.Graph.length,values:["1/0","1/1","-1/0","-1/1"]}})},Model.Game.DestroyGame=function(){},Model.Game.CheckersDirections=4,Model.Game.Checkers2WaysDirections=[0,1,1,0],Model.Game.CheckersEachDirection=function(t,s){for(var i=0;i<this.CheckersDirections;i++){var o=this.g.Graph[t][i];if(null!=o&&0==s(o,i))return}},Model.Move.Init=function(t){this.pos=[];for(var s=t.pos?Object.keys(t.pos).sort():[],i=0;i<s.length;i++)this.pos.push(t.pos[i]);this.capt=[];for(var o=t.capt?Object.keys(t.capt).sort():[],i=0;i<o.length;i++)this.capt.push(t.capt[i])},Model.Move.ToString=function(s){s=s||"natural";var i=this;switch(s){case"natural":return function(){for(var s=[t(i.pos[0]),t(i.pos[i.pos.length-1])],o="-",e=1;e<i.capt.length;e++)null!=i.capt[e]&&(o="x",i.capt.length>3&&s.push(t(i.capt[e])));return s.join(o)}();case"hub":return function(){var s="-",o=[t(i.pos[0]),t(i.pos[i.pos.length-1])];if(i.capt[1]){s="x";var e=i.capt.slice(1).map(function(s){return t(s)});e.sort(),o=o.concat(e)}return o.join(s)}();case"dxp":return function(){var s=[t(i.pos[0]),t(i.pos[i.pos.length-1])];if(i.capt[1]){s.push(i.capt.length-1);for(var o=[],e=1;e<i.capt.length;e++)o.push(t(i.capt[e]));o.sort(),s=s.concat(o)}else s.push(0);return s.map(function(t){return t<10?"0"+t:t}).join("")}();default:return"??"}},Model.Board.Init=function(t){this.zSign=0},Model.Board.InitialPosition=function(t){var s=t.mOptions.width,i=t.mOptions.height,o=t.mOptions.initial;this.board=[];for(var e=0;e<i;e++)for(var r=0;r<s;r++)this.board[e*s+r]=-1;this.pieces=[];var n=0;if(t.mInitial){this.pCount=[0,0],this.spCount=[0,0],this.kpCount=[0,0];for(var a=0;a<t.mInitial.pieces.length;a++){var h=t.mInitial.pieces[a];this.board[h.p]=a,this.pieces.push({s:h.s,p:h.p,l:-1,t:h.t,plp:h.p}),this.zSign=t.zobrist.update(this.zSign,"board",h.s+"/"+h.t,h.p);var p=-(h.s-1)/2;this.pCount[p]++,0==h.t?this.spCount[p]++:this.kpCount[p]++}}else{for(var a in o.a)if(o.a.hasOwnProperty(a)){var u=o.a[a],c=u[0]*s+u[1],h={s:JocGame.PLAYER_A,p:c,l:-1,t:0,plp:c};this.pieces.push(h),this.board[c]=n++,this.zSign=t.zobrist.update(this.zSign,"board","1/0",c)}for(var a in o.b)if(o.b.hasOwnProperty(a)){var u=o.b[a],c=u[0]*s+u[1],h={s:JocGame.PLAYER_B,p:c,l:-1,t:0,plp:c};this.pieces.push(h),this.board[c]=n++,this.zSign=t.zobrist.update(this.zSign,"board","-1/0",c)}this.pCount=[o.a.length,o.b.length],this.spCount=[o.a.length,o.b.length],this.kpCount=[o.a.length,o.b.length]}},Model.Board.GenerateMoves=function(t){try{this._GenerateMoves(t)}catch(t){}},Model.Board._GenerateMoves=function(t){function s(t){for(var s=0;s<e.pieces.length;s++){var i=e.pieces[s];i&&i.s==e.mWho&&t(s,i.p)}}function i(s,o,r,n,a){for(;;){var h=[],p=[],u=[];if(t.CheckersEachDirection(s,function(i,c){var l;0==t.g.canCaptureBackward&&(l=t.g.Coord[s][0]);var g=t.Checkers2WaysDirections[c];if(a){if(t.g.longRangeKing)for(;e.board[i]==-1||t.g.king180deg&&null!=i&&r.indexOf(i)>=0;)i=t.g.Graph[i][c];if(null!=i&&e.board[i]>=0&&e.pieces[e.board[i]].s==-e.mWho){var v=i;if(i=t.g.Graph[i][c],t.g.kingCaptureShort){if(e.board[i]==-1||i==o[0]){for(var f=!0,d=0;d<n.length;d++)if(t.g.king180deg){if(r[d]==v){f=!1;break}}else if(t.g.captureInstantRemove&&r[d]==v||0==t.g.captureInstantRemove&&r[d]==v&&n[d]==g){f=!1;break}f&&(h.push(i),p.push(v),u.push(g)),i=t.g.Graph[i][c]}}else for(;e.board[i]==-1||i==o[0];){for(var f=!0,d=0;d<n.length;d++)if(t.g.captureInstantRemove&&r[d]==v||0==t.g.captureInstantRemove&&r[d]==v&&n[d]==g){f=!1;break}f&&(h.push(i),p.push(v),u.push(g)),i=t.g.Graph[i][c]}}}else if(e.board[i]>=0&&e.pieces[e.board[i]].s==-e.mWho){var m,C;if(0==t.g.canCaptureBackward&&(m=t.g.Coord[i][0],C=!1,(e.mWho==JocGame.PLAYER_A&&m>=l||e.mWho==JocGame.PLAYER_B&&m<=l)&&(C=!0)),t.g.canCaptureBackward||1==C){var b=t.g.Graph[i][c];if(null!=b&&(e.board[b]==-1||b==o[0])){for(var f=!0,d=0;d<n.length;d++)if(t.g.captureInstantRemove&&r[d]==i||0==t.g.captureInstantRemove&&r[d]==i&&n[d]==g){f=!1;break}f&&(h.push(b),p.push(i),u.push(g))}}}return!0}),0==h.length){o.length>1&&e.mMoves.push({pos:o,capt:r});break}if(!t.g.compulsoryCatch&&o.length>1){for(var c=[],l=0;l<o.length;l++)c.push(o[l]);for(var g=[],l=0;l<r.length;l++)g.push(r[l]);e.mMoves.push({pos:c,capt:g})}if(1!=h.length){for(var l=0;l<h.length;l++){for(var c=[],v=0;v<o.length;v++)c.push(o[v]);c.push(h[l]);for(var g=[],v=0;v<r.length;v++)g.push(r[v]);g.push(p[l]);for(var f=[],v=0;v<n.length;v++)f.push(n[v]);f.push(u[l]),i(h[l],c,g,f,a)}break}s=h[0],o.push(s),r.push(p[0]),n.push(u[0])}}var o=t.mOptions.height,e=this;if(this.mMoves=[],s(function(t,s){0==e.pieces[t].t?i(s,[s],[null],[null],!1):1==e.pieces[t].t&&i(s,[s],[null],[null],!0)}),0!=t.g.compulsoryCatch&&0!=this.mMoves.length||s(function(s,i){var r;0==e.pieces[s].t?((t.g.mustMoveForward||t.g.mustMoveForwardStrict||t.lastRowFreeze)&&(r=t.g.Coord[i][0]),t.CheckersEachDirection(i,function(n,a){var h,p,u;return t.g.mustMoveForwardStrict?(h=t.g.Coord[n][0],p=!1,(e.mWho==JocGame.PLAYER_A&&h>r||e.mWho==JocGame.PLAYER_B&&h<r)&&(p=!0)):t.g.mustMoveForward&&(h=t.g.Coord[n][0],p=!0,(e.mWho==JocGame.PLAYER_A&&h<r||e.mWho==JocGame.PLAYER_B&&h>r)&&(p=!1)),t.g.lastRowFreeze&&(u=!1,(e.mWho==JocGame.PLAYER_A&&r==o-1||e.mWho==JocGame.PLAYER_B&&0==r)&&(u=!0)),e.board[n]!=-1||!t.g.canStepBack&&n==e.pieces[s].l||(0!=t.g.mustMoveForward||0!=t.g.mustMoveForwardStrict)&&1!=p||0!=t.g.lastRowFreeze&&0!=u||e.mMoves.push({pos:[i,n],capt:[null,null]}),!0})):1==e.pieces[s].t&&t.CheckersEachDirection(i,function(s,o){if(t.g.longRangeKing)for(;e.board[s]==-1;)e.mMoves.push({pos:[i,s],capt:[null,null]}),s=t.g.Graph[s][o];else e.board[s]==-1&&(e.mMoves.push({pos:[i,s],capt:[null,null]}),s=t.g.Graph[s][o]);return!0})}),0==this.mMoves.length)switch(t.g.noMove){case"count":this.mFinished=!0,this.pCount[0]<this.pCount[1]?this.mWinner=JocGame.PLAYER_B:this.pCount[1]<this.pCount[0]?this.mWinner=JocGame.PLAYER_A:this.mWinner=JocGame.DRAW;break;case"lose":this.mFinished=!0,this.mWinner=-this.mWho;break;default:this.mFinished=!0,this.mWinner=JocGame.DRAW}if(t.g.captureLongestLine){for(var r=this.mMoves,n=[],a=0,h=0;h<r.length;h++){var p=r[h];p.pos.length==a?n.push(p):p.pos.length>a&&(n=[p],a=p.pos.length)}this.mMoves=n}},Model.Board.Evaluate=function(t,s,i){if(t.mOptions.preventRepeat&&t.GetRepeatOccurence(this)>2)return this.mFinished=!0,void(this.mWinner=JocGame.DRAW);if(t.g.drawKvsK&&0==this.spCount[0]&&0==this.spCount[1]&&1==this.kpCount[0]&&1==this.kpCount[1])return this.mFinished=!0,void(this.mWinner=JocGame.DRAW);if(t.g.drawKvs2K&&0==this.spCount[0]&&0==this.spCount[1]&&this.kpCount[0]+this.kpCount[1]==3&&(1==this.kpCount[0]||2==this.kpCount[0]))return this.mFinished=!0,void(this.mWinner=JocGame.DRAW);if(0==this.pCount[1])return this.mFinished=!0,void(this.mWinner=JocGame.PLAYER_A);if(0==this.pCount[0])return this.mFinished=!0,void(this.mWinner=JocGame.PLAYER_B);if(this.mEvaluation=10*(this.spCount[0]-this.spCount[1])+10*(this.kpCount[0]-this.kpCount[1])*t.g.kingValue+this.pCount[0]/this.pCount[1]-this.pCount[1]/this.pCount[0],0!=t.g.lastRowFactor){for(var o=t.mOptions.height,e=0,r=0,n=0;n<this.pieces.length;n++){var a=this.pieces[n];a&&0==a.t&&(this.mWho==JocGame.PLAYER_A?e+=t.g.Coord[a.p][0]:r+=o-1-t.g.Coord[a.p][0])}this.mEvaluation+=(e-r)*t.g.lastRowFactor}},Model.Board.CopyFrom=function(t){this.board=[];for(var s=0;s<t.board.length;s++)this.board[s]=t.board[s];this.pieces=[];for(var s=0;s<t.pieces.length;s++){var i=t.pieces[s];this.pieces[s]=null==i?null:{s:i.s,p:i.p,l:i.l,t:i.t,plp:i.plp}}this.pCount=[t.pCount[0],t.pCount[1]],this.spCount=[t.spCount[0],t.spCount[1]],this.kpCount=[t.kpCount[0],t.kpCount[1]],this.mWho=t.mWho,this.zSign=t.zSign},Model.Board.ApplyMove=function(t,s){var i=(t.mOptions.width,t.mOptions.height),o=s.pos[0],e=this.board[o],r=this.pieces[e],n=r.s;r.l=o;var a={};this.zSign=t.zobrist.update(this.zSign,"board",r.s+"/"+r.t,r.p);for(var h=1;h<s.pos.length;h++){var p=s.pos[h];this.board[r.p]=-1,r.p=p,this.board[p]=e;var u=s.capt[h];null!=u&&(this.board[u]>=0&&(a[this.board[u]]=!0),this.board[u]=-1),o=p}this.zSign=t.zobrist.update(this.zSign,"board",r.s+"/"+r.t,p);var c=s.capt[s.capt.length-1];r.plp=c||s.pos[s.pos.length-2];for(var l in a)if(a.hasOwnProperty(l)){var g=this.pieces[l],v=(1-g.s)/2;switch(this.pCount[v]--,g.t){case 0:this.spCount[v]--;break;case 1:this.kpCount[v]--}this.zSign=t.zobrist.update(this.zSign,"board",g.s+"/"+g.t,g.p),this.pieces[l]=null}if(t.g.lastRowCrown&&0==this.pieces[e].t){var f=t.g.Coord[s.pos[s.pos.length-1]][0];if(n==JocGame.PLAYER_A&&f==i-1||n==JocGame.PLAYER_B&&0==f){var g=this.pieces[e];g.t=1;var d=(1-n)/2;this.spCount[d]--,this.kpCount[d]++,this.zSign=t.zobrist.update(this.zSign,"board",g.s+"/0",g.p),this.zSign=t.zobrist.update(this.zSign,"board",g.s+"/1",g.p)}}},Model.Board.IsValidMove=function(t,s){return!0},Model.Board.GetSignature=function(){return this.zSign},Model.Game.Import=function(t,s){function i(t,s,i){i=r-i;var o=i%n;i=i-o+n-o-1,e.push({s:t,p:i,l:-1,t:s,plp:i})}var o=1,e=[],r=this.mOptions.width*this.mOptions.height,n=this.mOptions.width;if("pjn"==t){var a=s.split(":");o="W"==a[0]?1:-1;for(var h=1;h<a.length;h++)if(0!=a[h].length)for(var p="W"==a[h].substr(0,1)?1:-1,u=a[h].substr(1).split(","),c=0;c<u.length;c++){var l=u[c],g=0;"K"==l.substr(0,1)&&(g=1,l=l.substr(1));var v=/^([0-9]+)-([0-9]+)$/.exec(l);if(v)for(var f=parseInt(v[1]);f<=parseInt(v[2]);f++)i(p,g,f);else i(p,g,parseInt(l))}return e.sort(function(t,s){return s.s-t.s}),{status:!0,initial:{pieces:e,turn:o}}}return{status:!1,error:"unsupported"}};var e=JocGame.prototype.GetBestMatchingMove;Model.Game.GetBestMatchingMove=function(t,s){var i=[],o=this;s.forEach(function(t){"function"==typeof t.ToString?i.push(t.ToString()):i.push(o.CreateMove(t).ToString())}),t=t.replace(/0([1-9])/g,"$1");var r=/^([0-9]+)[\-x]([0-9]+)([\-x][0-9]+)*$/.exec(t);if(r){var n=new RegExp("^"+r[1]+"[-x]"+r[2]+"([-x][0-9]+)*$"),a={};s.forEach(function(t,s){if(n.test(i[s])){var o=i[s],e=/^([0-9]+)x([0-9]+)x([0-9]+(x[0-9]+)*)/.exec(o);if(e){var r=e[3].split("x");r.sort(function(t,s){return parseInt(t)-parseInt(s)}),o=e[1]+"x"+e[2]+"x"+r.join("x")}a[o]=t}});var h=[];for(var p in a)a.hasOwnProperty(p)&&h.push(a[p]);h.length>0&&(s=h)}return e.call(this,t,s)},Model.Board.ExportBoardState=function(o,e){function r(t){for(var o=[],e=0;e<n.board.length;e++){var r=e%s,a=(e-r)/s,h=(i-a-1)*s+r,p=n.board[e];if(p<0)o[h]="e";else{var u=n.pieces[p],c=1==u.s?"w":t;1==u.t&&(c=c.toUpperCase()),o[h]=c}}return o.join("")}e=e||"natural";var n=this;switch(e){case"natural":case"fen":return function(){var s={},i=[];n.pieces.forEach(function(i){if(i&&null!=i.p){var o=1==i.s?"W":"B";void 0===s[o]&&(s[o]={});var e=1==i.t?"K":"";void 0===s[o][e]&&(s[o][e]={group:0==i.t,pos:[]}),s[o][e].pos.push(parseInt(t(i.p)))}});for(var o in s)if(s.hasOwnProperty(o)){var e=[];for(var r in s[o])if(s[o].hasOwnProperty(r)){var a=s[o][r];if(a.group){a.pos.sort(function(t,s){return parseInt(t)-parseInt(s)});var h=-2,p=-1,u=-1;a.pos.forEach(function(t){parseInt(t)==h+1?p=t:(p>=0?(e.push(r+u+"-"+p),p=-1):u>=0&&e.push(r+u),u=t),h=parseInt(t)}),p>=0?e.push(r+u+"-"+p):u>=0&&e.push(r+u)}else a.pos.forEach(function(t){e.push(r+t)})}i.push(o+e.join(","))}return i.join(":")}();case"dxp":return function(){return r("z")}();case"hub":return function(){return r("z")}();default:return JSON.stringify(this)}}}(),Model.Game.CheckersDirections=8,Model.Game.Checkers2WaysDirections=[0,1,2,3,3,2,1,0],Model.Game.BuildGraphCoord=function(){for(var t=this.mOptions.width,s=this.mOptions.height,i=[],o=[],e=0;e<s;e++)for(var r=0;r<t;r++){var n=e*t+r;o[n]=[e,r],i[n]=[];for(var a=-1;a<2;a++)for(var h=-1;h<2;h++)0==a&&0==h||(e+a<s&&e+a>=0&&r+h<t&&r+h>=0&&Math.abs(a)!=Math.abs(h)?i[n].push((e+a)*t+r+h):i[n].push(null))}this.g.Graph=i,this.g.Coord=o};

/***/ }),

/***/ "FA5e":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Observable_1 = __webpack_require__("rCTf");
var ScalarObservable_1 = __webpack_require__("RRVv");
var EmptyObservable_1 = __webpack_require__("jBEF");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var ArrayLikeObservable = (function (_super) {
    __extends(ArrayLikeObservable, _super);
    function ArrayLikeObservable(arrayLike, scheduler) {
        _super.call(this);
        this.arrayLike = arrayLike;
        this.scheduler = scheduler;
        if (!scheduler && arrayLike.length === 1) {
            this._isScalar = true;
            this.value = arrayLike[0];
        }
    }
    ArrayLikeObservable.create = function (arrayLike, scheduler) {
        var length = arrayLike.length;
        if (length === 0) {
            return new EmptyObservable_1.EmptyObservable();
        }
        else if (length === 1) {
            return new ScalarObservable_1.ScalarObservable(arrayLike[0], scheduler);
        }
        else {
            return new ArrayLikeObservable(arrayLike, scheduler);
        }
    };
    ArrayLikeObservable.dispatch = function (state) {
        var arrayLike = state.arrayLike, index = state.index, length = state.length, subscriber = state.subscriber;
        if (subscriber.closed) {
            return;
        }
        if (index >= length) {
            subscriber.complete();
            return;
        }
        subscriber.next(arrayLike[index]);
        state.index = index + 1;
        this.schedule(state);
    };
    ArrayLikeObservable.prototype._subscribe = function (subscriber) {
        var index = 0;
        var _a = this, arrayLike = _a.arrayLike, scheduler = _a.scheduler;
        var length = arrayLike.length;
        if (scheduler) {
            return scheduler.schedule(ArrayLikeObservable.dispatch, 0, {
                arrayLike: arrayLike, index: index, length: length, subscriber: subscriber
            });
        }
        else {
            for (var i = 0; i < length && !subscriber.closed; i++) {
                subscriber.next(arrayLike[i]);
            }
            subscriber.complete();
        }
    };
    return ArrayLikeObservable;
}(Observable_1.Observable));
exports.ArrayLikeObservable = ArrayLikeObservable;
//# sourceMappingURL=ArrayLikeObservable.js.map

/***/ }),

/***/ "FE8a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var delayWhen_1 = __webpack_require__("1Axw");
Observable_1.Observable.prototype.delayWhen = delayWhen_1.delayWhen;
//# sourceMappingURL=delayWhen.js.map

/***/ }),

/***/ "FT6u":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var reduce_1 = __webpack_require__("pgP5");
/**
 * The Min operator operates on an Observable that emits numbers (or items that can be compared with a provided function),
 * and when source Observable completes it emits a single item: the item with the smallest value.
 *
 * <img src="./img/min.png" width="100%">
 *
 * @example <caption>Get the minimal value of a series of numbers</caption>
 * Rx.Observable.of(5, 4, 7, 2, 8)
 *   .min()
 *   .subscribe(x => console.log(x)); // -> 2
 *
 * @example <caption>Use a comparer function to get the minimal item</caption>
 * interface Person {
 *   age: number,
 *   name: string
 * }
 * Observable.of<Person>({age: 7, name: 'Foo'},
 *                       {age: 5, name: 'Bar'},
 *                       {age: 9, name: 'Beer'})
 *           .min<Person>( (a: Person, b: Person) => a.age < b.age ? -1 : 1)
 *           .subscribe((x: Person) => console.log(x.name)); // -> 'Bar'
 * }
 *
 * @see {@link max}
 *
 * @param {Function} [comparer] - Optional comparer function that it will use instead of its default to compare the
 * value of two items.
 * @return {Observable<R>} An Observable that emits item with the smallest value.
 * @method min
 * @owner Observable
 */
function min(comparer) {
    var min = (typeof comparer === 'function')
        ? function (x, y) { return comparer(x, y) < 0 ? x : y; }
        : function (x, y) { return x < y ? x : y; };
    return this.lift(new reduce_1.ReduceOperator(min));
}
exports.min = min;
//# sourceMappingURL=min.js.map

/***/ }),

/***/ "FU29":
/***/ (function(module, exports) {

exports.model=Model={Game:{},Board:{},Move:{}},function(){var t;Model.Game.cbConstants={MASK:65535,FLAG_MOVE:65536,FLAG_CAPTURE:131072,FLAG_STOP:262144,FLAG_SCREEN_CAPTURE:524288,FLAG_CAPTURE_KING:1048576,FLAG_CAPTURE_NO_KING:2097152};var e="undefined"!=typeof Int32Array;Model.Game.cbUseTypedArrays=e,Model.Game.cbTypedArray=function(t){if(e){var r=new Int32Array(t.length);return r.set(t),r}for(var a=[],i=t.length,s=0;s<i;s++)a.push(t[s]);return a},Model.Game.cbShortRangeGraph=function(t,e,r,a){var i=this;void 0===a&&(a=196608);for(var s={},n=0;n<t.boardSize;n++)s[n]=[],(!r||n in r)&&e.forEach(function(e){var o=t.Graph(n,e);null!=o&&(!r||o in r)&&s[n].push(i.cbTypedArray([o|a]))});return s},Model.Game.cbLongRangeGraph=function(t,e,r,a,i){var s=this;void 0!==a&&null!=a||(a=196608),i||(i=1/0);for(var n={},o=0;o<t.boardSize;o++)n[o]=[],(!r||o in r)&&e.forEach(function(e){for(var h=[],c=t.Graph(o,e),p=0;null!=c&&(!r||c in r)&&(h.push(c|a),++p!=i);)c=t.Graph(c,e);h.length>0&&n[o].push(s.cbTypedArray(h))});return n},Model.Game.cbNullGraph=function(t){for(var e={},r=0;r<t.boardSize;r++)e[r]=[];return e},Model.Game.cbAuthorGraph=function(t){for(var e={},r=0;r<t.boardSize;r++){e[r]=[];for(var a=0;a<t.boardSize;a++)e[r].push([2293760|a])}return e},Model.Game.cbMergeGraphs=function(t){for(var e=[],r=0;r<t.boardSize;r++){e[r]=[];for(var a=1;a<arguments.length;a++)e[r]=e[r].concat(arguments[a][r])}return e},Model.Game.cbGetThreatGraph=function(){function t(e,r){for(var a in n){var i=n[a];if(!(i.p.length<r.length+1)){for(var s=!0,o=0;o<r.length;o++)if(r[o]!=i.p[o]){s=!1;break}if(s){var h=i.p[r.length],c=e[h];void 0===c&&(c={e:{}},e[h]=c),i.p.length==r.length+1&&(c.t=i.t,c.ts=i.ts,c.tk=i.tk,delete n[a]),r.push(h),t(c.e,r),r.pop()}}}}var e=this;this.cbUseScreenCapture=!1,this.cbUseCaptureKing=!1,this.cbUseCaptureNoKing=!1;for(var r={1:[],"-1":[]},a=[],i=0;i<this.g.boardSize;i++)this.g.pTypes.forEach(function(t,r){t.graph[i].forEach(function(t){for(var s=[],n=0;n<t.length;n++){var o=t[n];1048576&o?(e.cbUseCaptureKing=!0,s.unshift({d:65535&o,a:i,tk:r})):2097152&o?(e.cbUseCaptureNoKing=!0,s.unshift({d:65535&o,a:i,tnk:r})):131072&o?s.unshift({d:65535&o,a:i,t:r}):262144&o?s.unshift({d:65535&o,a:i}):524288&o&&(e.cbUseScreenCapture=!0,s.unshift({d:65535&o,a:i,ts:r}))}s.length>0&&a.push(s)})});var s={};a.forEach(function(t){t.forEach(function(e,r){var a=s[e.d];void 0===a&&(a={},s[e.d]=a);for(var i=[],n=r+1;n<t.length;n++)i.push(t[n].d);i.push(e.a);var o=i.join(","),h=a[o];void 0===h&&(h={p:i,t:{},ts:{},tk:{}},a[o]=h),void 0!==e.t?h.t[e.t]=!0:void 0!==e.tk?h.tk[e.tk]=!0:void 0!==e.ts&&(h.ts[e.ts]=!0)})});for(var i=0;i<e.g.boardSize;i++){var n=s[i],o={};t(o,[]),r[1][i]=o,r[-1][i]=o}return r},Model.Game.InitGame=function(){var e=this;this.cbVar=t=this.cbDefine(),this.g.boardSize=this.cbVar.geometry.boardSize,this.g.pTypes=this.cbGetPieceTypes(),this.g.threatGraph=this.cbGetThreatGraph(),this.g.distGraph=this.cbVar.geometry.GetDistances(),this.cbPiecesCount=0,this.g.castleablePiecesCount={1:0,"-1":0};for(var r in t.pieceTypes){var a=t.pieceTypes[r];if(a.castle){(a.initial||[]).forEach(function(t){e.g.castleablePiecesCount[t.s]++})}a.initial&&(this.cbPiecesCount+=a.initial.length)}for(var i=[],r=0;r<this.cbPiecesCount;r++)i.push(r);var s=Object.keys(t.pieceTypes);this.zobrist=new JocGame.Zobrist({board:{type:"array",size:this.cbVar.geometry.boardSize,values:i},who:{values:["1","-1"]},type:{type:"array",size:this.cbPiecesCount,values:s}})},Model.Game.cbGetPieceTypes=function(){for(var t=[],e={},r=0;r<this.cbVar.geometry.boardSize;r++)e[r]=[];for(var a in this.cbVar.pieceTypes){var i=this.cbVar.pieceTypes[a];t[a]={graph:i.graph||e,abbrev:i.abbrev||"",value:i.isKing?100:i.value||1,isKing:!!i.isKing,castle:!!i.castle,epTarget:!!i.epTarget,epCatch:!!i.epCatch}}return t},Model.Board.Init=function(t){this.zSign=0},Model.Board.InitialPosition=function(r){var a=this;this.board=e?new Int16Array(r.g.boardSize):[];for(var i=0;i<r.g.boardSize;i++)this.board[i]=-1;if(this.kings={},this.pieces=[],this.ending={1:!1,"-1":!1},this.lastMove=null,r.cbVar.castle&&(this.castled={1:!1,"-1":!1}),this.zSign=r.zobrist.update(0,"who",-1),this.noCaptCount=0,this.mWho=1,r.mInitial)this.mWho=r.mInitial.turn||1,r.mInitial.pieces.forEach(function(t){var e={};for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);a.pieces.push(e)}),r.mInitial.lastMove&&(this.lastMove={f:r.mInitial.lastMove.f,t:r.mInitial.lastMove.t}),void 0!==r.mInitial.noCaptCount&&(this.noCaptCount=r.mInitial.noCaptCount),r.cbVar.castle&&r.mInitial.castle&&(this.castled={1:{k:!!r.mInitial.castle[1]&&!!r.mInitial.castle[1].k,q:!!r.mInitial.castle[1]&&!!r.mInitial.castle[1].q},"-1":{k:!!r.mInitial.castle[-1]&&!!r.mInitial.castle[-1].k,q:!!r.mInitial.castle[-1]&&!!r.mInitial.castle[-1].q}});else for(var s in r.cbVar.pieceTypes)for(var n=r.cbVar.pieceTypes[s],o=n.initial||[],h=0;h<o.length;h++){var c=o[h],p={s:c.s,t:parseInt(s),p:c.p,m:!1};this.pieces.push(p)}if(this.pieces.sort(function(t,e){if(t.s!=e.s)return e.s-t.s;var a=r.cbVar.pieceTypes[t.t].value||100,i=r.cbVar.pieceTypes[e.t].value||100;return a!=i?a-i:t.p-e.p}),this.pieces.forEach(function(t,e){t.i=e,a.board[t.p]=e,r.g.pTypes[t.t].isKing&&(a.kings[t.s]=t.p),a.zSign=r.zobrist.update(a.zSign,"board",e,t.p),a.zSign=r.zobrist.update(a.zSign,"type",t.t,e)}),r.mInitial&&r.mInitial.enPassant){var i=t.geometry.PosByName(r.mInitial.enPassant);if(i>=0){var l,u=t.geometry.C(i),v=t.geometry.R(i);l=1==r.mInitial.turn?t.geometry.POS(u,v-1):t.geometry.POS(u,v+1),this.epTarget={p:i,i:this.board[l]}}}},Model.Board.CopyFrom=function(t){if(e)this.board=new Int16Array(t.board.length),this.board.set(t.board);else{this.board=[];for(var r=t.board,a=r.length,i=0;i<a;i++)this.board.push(r[i])}this.pieces=[];for(var s=t.pieces.length,i=0;i<s;i++){var n=t.pieces[i];this.pieces.push({s:n.s,p:n.p,t:n.t,i:n.i,m:n.m})}this.kings={1:t.kings[1],"-1":t.kings[-1]},this.check=t.check,t.lastMove?this.lastMove={f:t.lastMove.f,t:t.lastMove.t,c:t.lastMove.c}:this.lastMove=null,this.ending={1:t.ending[1],"-1":t.ending[-1]},void 0!==t.castled&&(this.castled={1:t.castled[1],"-1":t.castled[-1]}),this.noCaptCount=t.noCaptCount,t.epTarget?this.epTarget={p:t.epTarget.p,i:t.epTarget.i}:this.epTarget=null,this.mWho=t.mWho,this.zSign=t.zSign},Model.Board.cbApplyCastle=function(t,e,r){var a=t.cbVar.castle[e.f+"/"+e.cg],i=a.r[a.r.length-1],s=this.pieces[this.board[e.cg]],n=a.k[a.k.length-1],o=this.pieces[this.board[e.f]];return r&&(this.zSign=t.zobrist.update(this.zSign,"board",s.i,e.cg),this.zSign=t.zobrist.update(this.zSign,"board",s.i,i),this.zSign=t.zobrist.update(this.zSign,"board",o.i,e.f),this.zSign=t.zobrist.update(this.zSign,"board",o.i,n)),s.p=i,s.m=!0,this.board[e.cg]=-1,o.p=n,o.m=!0,this.board[e.f]=-1,this.board[i]=s.i,this.board[n]=o.i,this.castled[s.s]=!0,this.kings[o.s]=n,[{i:s.i,f:i,t:-1},{i:o.i,f:n,t:e.f,kp:e.f,who:o.s,m:!1},{i:s.i,f:-1,t:e.cg,m:!1,cg:!1}]},Model.Board.cbQuickApply=function(t,e){if(void 0!==e.cg)return this.cbApplyCastle(t,e,!1);var r=[],a=this.board[e.f],i=this.pieces[a];if(null!=e.c){r.unshift({i:e.c,f:-1,t:this.pieces[e.c].p});var s=this.pieces[e.c];this.board[s.p]=-1,s.p=-1}var n=this.kings[i.s];return t.g.pTypes[i.t].isKing&&(this.kings[i.s]=e.t),r.unshift({i:a,f:e.t,t:e.f,kp:n,who:i.s,ty:i.t}),i.p=e.t,void 0!==e.pr&&(i.t=e.pr),this.board[e.f]=-1,this.board[e.t]=a,r},Model.Board.cbQuickUnapply=function(t,e){for(var r=0;r<e.length;r++){var a=e[r],i=this.pieces[a.i];a.f>=0&&(i.p=-1,this.board[a.f]=-1),a.t>=0&&(i.p=a.t,this.board[a.t]=a.i),void 0!==a.m&&(i.m=a.m),void 0!==a.kp&&(this.kings[a.who]=a.kp),void 0!=a.ty&&(i.t=a.ty),void 0!=a.cg&&(this.castled[i.s]=a.cg)}},Model.Board.ApplyMove=function(t,e){var r=this.pieces[this.board[e.f]];if(void 0!==e.cg)this.cbApplyCastle(t,e,!0);else{if(this.zSign=t.zobrist.update(this.zSign,"board",r.i,e.f),this.board[r.p]=-1,void 0!==e.pr&&(this.zSign=t.zobrist.update(this.zSign,"type",r.t,r.i),r.t=e.pr,this.zSign=t.zobrist.update(this.zSign,"type",r.t,r.i)),null!=e.c){var a=this.pieces[e.c];this.zSign=t.zobrist.update(this.zSign,"board",a.i,a.p),this.board[a.p]=-1,a.p=-1,a.m=!0,this.noCaptCount=0}else this.noCaptCount++;r.p=e.t,r.m=!0,this.board[e.t]=r.i,this.zSign=t.zobrist.update(this.zSign,"board",r.i,e.t),t.g.pTypes[r.t].isKing&&(this.kings[r.s]=e.t)}this.check=!!e.ck,this.lastMove={f:e.f,t:e.t,c:e.c},void 0!==e.ko&&(this.ending[r.s]=e.ko),void 0!==e.ept?this.epTarget={p:e.ept,i:r.i}:this.epTarget=null,this.zSign=t.zobrist.update(this.zSign,"who",-this.mWho),this.zSign=t.zobrist.update(this.zSign,"who",this.mWho)},Model.Board.Evaluate=function(r){function a(e){var r=1/0;for(var a in t.geometry.corners)r=Math.min(r,h.distGraph[s.kings[e]][a]);return r-Math.sqrt(h.boardSize)}var i="debug"==arguments[3],s=this;this.mEvaluation=0;var n,o=this.mWho,h=r.g;if(e)n={1:{count:new Uint8Array(h.pTypes.length),byType:{}},"-1":{count:new Uint8Array(h.pTypes.length),byType:{}}};else{n={1:{count:[],byType:{}},"-1":{count:[],byType:{}}};for(var c=0;c<h.pTypes.length;c++)n[1].count[c]=n[-1].count[c]=0}if(r.mOptions.preventRepeat&&r.GetRepeatOccurence(this)>2)return this.mFinished=!0,void(this.mWinner=r.cbOnPerpetual?o*r.cbOnPerpetual:JocGame.DRAW);for(var p={1:0,"-1":0},l={1:h.distGraph[this.kings[-1]],"-1":h.distGraph[this.kings[1]]},u={1:0,"-1":0},v={1:0,"-1":0},b={1:0,"-1":0},f={1:0,"-1":0},d={1:!1,"-1":!1},g=this.pieces,m=g.length,c=0;c<m;c++){var G=g[c];if(G.p>=0){var y=G.s,M=h.pTypes[G.t];M.isKing?d[y]=G.m:p[y]+=M.value,M.castle&&!G.m&&f[y]++,v[y]++,u[y]+=l[y][G.p],b[y]+=t.geometry.distEdge[G.p];var C=n[y];C.count[G.t]++;var S=C.byType;void 0===S[G.t]?S[G.t]=[G]:S[G.t].push(G)}}if(this.lastMove&&null!=this.lastMove.c){var G=this.pieces[this.board[this.lastMove.t]];p[-G.s]+=this.cbStaticExchangeEval(r,G.p,G.s,{piece:G})}var k={1:0,"-1":0},A={1:0,"-1":0},T={1:0,"-1":0};this.ending[1]&&(A[1]=(u[1]-Math.sqrt(h.boardSize))/v[1],t.geometry.corners&&(T[1]=a(1))),this.ending[-1]&&(A[-1]=(u[-1]-Math.sqrt(h.boardSize))/v[-1],t.geometry.corners&&(T[1]=a(-1)));var z={pieceValue:p[1]-p[-1],pieceValueRatio:(p[1]-p[-1])/(p[1]+p[-1]+1),posValue:b[1]-b[-1],averageDistKing:u[1]/v[1]-u[-1]/v[-1],check:this.check?-o:0,endingKingFreedom:k[1]-k[-1],endingDistKing:A[1]-A[-1],distKingCorner:T[1]-T[-1]};t.castle&&(z.castle=(this.castled[1]?1:d[1]?0:f[1]/(h.castleablePiecesCount[1]+1))-(this.castled[-1]?1:d[-1]?0:f[-1]/(h.castleablePiecesCount[-1]+1))),t.evaluate&&t.evaluate.call(this,r,z,n);var E=r.mOptions.levelOptions;for(var P in z){var w=z[P],I=E[P+"Factor"]||0,R=w*I;i&&console.log(P,"=",w,"*",I,"=>",R),this.mEvaluation+=R}i&&console.log("Evaluation",this.mEvaluation)},Model.Board.cbGeneratePseudoLegalMoves=function(t){function e(e,i){var s=t.cbVar.promote;if(!s)return void a.push(i);var n=s.call(r,t,e,i);if(null!=n)if(0==n.length)a.push(i);else if(1==n.length)i.pr=n[0],a.push(i);else for(var o=0;o<n.length;o++){var h=n[o];a.push({f:i.f,t:i.t,c:i.c,pr:h,ept:i.ept,ep:i.ep,a:i.a})}}for(var r=this,a=[],i=t.cbVar,s=this.mWho,n=!i.castle||this.check||this.castled[s]?null:[],o=-1,h=this.pieces.length,c=0;c<h;c++){var p=this.pieces[c];if(!(p.p<0||p.s!=s)){var l=t.g.pTypes[p.t];l.isKing&&(p.m?n=null:o=p),n&&l.castle&&!p.m&&n.push(p);var u,v;u=l.graph[p.p],v=u.length;for(var b=0;b<v;b++)for(var f=u[b],d=!1,g=f.length,m=null,G=0;G<g;G++){var y=f[G],M=65535&y,C=this.board[M];if(!(C<0)||l.epCatch&&this.epTarget&&this.epTarget.p==M){if(!(524288&y)){var S;S=C<0?this.pieces[this.epTarget.i]:this.pieces[C],!(S.s!=p.s&&131072&y)||1048576&y&&!t.g.pTypes[S.t].isKing||2097152&y&&t.g.pTypes[S.t].isKing||e(p,{f:p.p,t:M,c:S.i,a:l.abbrev,ep:C<0});break}if(d){var S=this.pieces[C];S.s!=p.s&&e(p,{f:p.p,t:M,c:S.i,a:l.abbrev});break}d=!0}else 65536&y&&0==d&&e(p,{f:p.p,t:M,c:null,a:l.abbrev,ept:null!=m&&l.epTarget?m:void 0});m=M}}}if(n)for(var c=0;c<n.length;c++){var k=n[c],A=t.cbVar.castle[o.p+"/"+k.p];if(A){for(var T=!0,b=0;b<A.r.length;b++){var z=A.r[b];if(this.board[z]>=0&&z!=o.p&&z!=k.p){T=!1;break}}if(T){for(var E=!0,b=0;b<A.k.length;b++){var z=A.k[b];if(this.board[z]>=0&&z!=k.p&&z!=o.p||this.cbGetAttackers(t,z,s).length>0){E=!1;break}}E&&a.push({f:o.p,t:A.k[A.k.length-1],c:null,cg:k.p})}}}return a},Model.Board.cbStaticExchangeEval=function(t,e,r,a){var i=0,s=this.cbGetSmallestAttacker(t,e,r);if(s){var n=this.mWho;this.mWho=s.s;var o=this.cbQuickApply(t,{f:s.p,t:e,c:a.piece.i}),h=t.g.pTypes[a.piece.t].value;a.piece=s,i=Math.max(0,h-this.cbStaticExchangeEval(t,e,-r,a)),this.cbQuickUnapply(t,o),this.mWho=n}return i},Model.Board.cbGetSmallestAttacker=function(t,e,r){var a=this.cbGetAttackers(t,e,r);if(0==a.length)return null;for(var i=1/0,s=null,n=a.length,o=0;o<n;o++){var h=a[o],c=t.g.pTypes[h.t].value;c<i&&(i=c,s=h)}return s},Model.Board.cbCollectAttackers=function(t,e,r,a){for(var i in e){var s=e[i],n=this.board[i];if(n<0)this.cbCollectAttackers(t,s.e,r,a);else{var o=this.pieces[n];o.s==-t&&(s.t&&o.t in s.t||a&&s.tk&&o.t in s.tk)&&r.push(o)}}},Model.Board.cbCollectAttackersScreen=function(t,e,r,a,i){for(var s in e){var n=e[s],o=this.board[s];if(o<0)this.cbCollectAttackersScreen(t,n.e,r,a,i);else{var h=this.pieces[o];!i&&h.s==-t&&(n.t&&h.t in n.t||a&&n.tk&&h.t in n.tk)?r.push(h):i?i&&h.s==-t&&n.ts&&h.t in n.ts&&r.push(h):this.cbCollectAttackersScreen(t,n.e,r,a,!0)}}},Model.Board.cbGetAttackers=function(t,e,r,a){var i=[];return t.cbUseScreenCapture?this.cbCollectAttackersScreen(r,t.g.threatGraph[r][e],i,a,!1):this.cbCollectAttackers(r,t.g.threatGraph[r][e],i,a),i},Model.Board.GenerateMoves=function(t){var e=this.cbGeneratePseudoLegalMoves(t);this.mMoves=[];for(var r=!0,a=this.kings[this.mWho],i=e.length,s=0;s<i;s++){var n=e[s],o=this.cbQuickApply(t,n);if(!(this.cbGetAttackers(t,this.kings[this.mWho],this.mWho,!0).length>0)){var h=this.cbGetAttackers(t,this.kings[-this.mWho],-this.mWho,!0).length>0;n.ck=h,this.mMoves.push(n),n.f!=a&&(r=!1)}this.cbQuickUnapply(t,o)}if(0==this.mMoves.length)this.mFinished=!0,this.mWinner=t.cbOnStaleMate?t.cbOnStaleMate*this.mWho:JocGame.DRAW,this.check&&(this.mWinner=-this.mWho);else if(this.ending[this.mWho]){if(!r)for(var s=0;s<this.mMoves.length;s++)this.mMoves[s].ko=!1}else if(!this.ending[this.mWho]&&r&&!this.check)for(var s=0;s<this.mMoves.length;s++)this.mMoves[s].ko=!0},Model.Board.GetSignature=function(){return this.zSign},Model.Move.Init=function(t){for(var e in t)t.hasOwnProperty(e)&&(this[e]=t[e])},Model.Move.Equals=function(t){return this.f==t.f&&this.t==t.t&&this.pr==t.pr},Model.Move.CopyFrom=function(t){this.Init(t)},Model.Move.ToString=function(e){var r=this;switch(e=e||"natural"){case"natural":return function(){var e;if(void 0!==r.cg?e=t.castle[r.f+"/"+r.cg].n:(e=r.a||"",e+=t.geometry.PosName(r.f),null==r.c?e+="-":e+="x",e+=t.geometry.PosName(r.t)),void 0!==r.pr){var a=t.pieceTypes[r.pr];a&&a.abbrev&&a.abbrev.length>0&&!a.silentPromo&&(e+="="+a.abbrev)}return r.ck&&(e+="+"),e}();case"engine":return function(){var e=t.geometry.PosName(r.f)+t.geometry.PosName(r.t);if(void 0!=r.pr){var a=t.pieceTypes[r.pr];a&&a.abbrev&&a.abbrev.length>0&&!a.silentPromo&&(e+=a.abbrev)}return e}();default:return"??"}},Model.Board.CompactMoveString=function(e,r,a){"function"!=typeof r.ToString&&(r=e.CreateMove(r));var i=r.ToString(),s=/^([A-Z]?)([a-z])([1-9][0-9]*)([-x])([a-z])([1-9][0-9]*)(.*?)$/.exec(i);if(!s)return i;var n=s[7];if(a||(a={}),a.value||(a.value=[]),0==a.value.length){var o=this.mMoves;this.mMoves&&0!=this.mMoves.length||this.GenerateMoves(e);for(var h=0;h<this.mMoves.length;h++){var c=this.mMoves[h];"function"!=typeof c.ToString&&(c=e.CreateMove(c)),a.value.push({str:c.ToString(),move:c})}this.mMoves=o}var p=[];if(a.value.forEach(function(t){var e=/^([A-Z]?[a-z][1-9][0-9]*[-x][a-z][1-9][0-9]*)(.*?)$/.exec(t.str);e&&t.move.t==r.t&&(t.move.a||"")==s[1]&&e[2]==n&&p.push(t.move)}),1==p.length)return""==s[1]&&"x"==s[4]?s[2]+"x"+s[5]+s[6]+s[7]:s[1]+("x"==s[4]?"x":"")+s[5]+s[6]+s[7];if(t.geometry.CompactCrit)for(var l="",h=0;;h++){var u=t.geometry.CompactCrit(r.f,h);if(null==u)return i;l+=u;for(var v=[],b=0;b<p.length;b++){var f=p[b];t.geometry.CompactCrit(f.f,h)==u&&v.push(f)}if(console.assert(v.length>0),1==v.length)return s[1]+l+("x"==s[4]?"x":"")+s[5]+s[6]+s[7];p=v}return i},Model.Board.cbIntegrity=function(t){function e(t,e){t||console.error(e)}for(var r=this,a=0;a<this.board.length;a++){var i=this.board[a];if(i>=0){var s=r.pieces[i];e(void 0!==s,"no piece at pos"),e(s.p==a,"piece has different pos")}}for(var i=0;i<this.pieces.length;i++){var s=this.pieces[i];s.p>=0&&e(r.board[s.p]==i,"board index mismatch")}},Model.Board.ExportBoardState=function(t){return t.cbVar.geometry.ExportBoardState?t.cbVar.geometry.ExportBoardState(this,t.cbVar,t.mPlayedMoves.length):"not supported"},Model.Game.Import=function(e,r){var a,i=[],s={1:{},"-1":{}},n=null,o=0;if("pjn"==e){var h={status:!1,error:"parse"},c=r.split(" ");if(6!=c.length)return console.warn("FEN should have 6 parts"),h;var p=c[0].split("/"),l=t.geometry.fenHeight||t.geometry.height;if(p.length!=l)return console.warn("FEN board should have",l,"rows, got",p.length),h;var u={};for(var v in t.pieceTypes){var b=t.pieceTypes[v],f=b.fenAbbrev||b.abbrev||"X";u[f.toUpperCase()]={s:1,t:v},u[f.toLowerCase()]={s:-1,t:v}}var d=t.geometry.FenRowPos||function(e,r){return(t.geometry.height-1-e)*t.geometry.width+r};if(p.forEach(function(e,r){for(var a=0,s=0;s<e.length;s++){var n=e.substr(s,1),o=u[n];if(void 0!==o){var c=d(r,a);a++;for(var p={s:o.s,t:o.t,p:c},l=!0,v=t.pieceTypes[p.t].initial||[],b=0;b<v.length;b++){var f=v[b];f.s==p.s&&f.p==c&&(l=!1)}p.m=l,i.push(p)}else{if(isNaN(parseInt(n)))return console.warn("FEN invalid board spec",n),h;a+=parseInt(n)}}}),i.sort(function(t,e){return e.s-t.s}),"w"==c[1])a=1;else{if("b"!=c[1])return console.warn("FEN invalid turn spec",c[1]),h;a=-1}s[1].k=c[2].indexOf("K")>=0,s[1].q=c[2].indexOf("Q")>=0,s[-1].k=c[2].indexOf("k")>=0,s[-1].q=c[2].indexOf("q")>=0,n="-"==c[3]?null:c[3];var g=parseInt(c[4]);isNaN(g)||(o=g);var m={pieces:i,turn:a,castle:s,enPassant:n,noCaptCount:o};return t.importGame&&t.importGame.call(this,m,e,r),{status:!0,initial:m}}return{status:!1,error:"unsupported"}}}(),function(){Model.Game.cbBoardGeometryGrid=function(t,e){function r(e){return e%t}function a(e){return Math.floor(e/t)}function i(e,r){return r*t+e}function s(s,n){var o=r(s),h=a(s),c=o+n[0],p=h+n[1];return c<0||c>=t||p<0||p>=e?null:i(c,p)}function n(t){return String.fromCharCode("a".charCodeAt(0)+r(t))+(a(t)+1)}function o(t){var e=/^([a-z])([0-9]+)$/.exec(t);return e?i(e[1].charCodeAt(0)-"a".charCodeAt(0),parseInt(e[2])-1):-1}function h(t,e){return 0==e?String.fromCharCode("a".charCodeAt(0)+r(t)):1==e?a(t)+1:null}function c(){for(var i=[],s=0;s<t*e;s++){var n=[];i.push(n);for(var o=0;o<t*e;o++){var h=a(s),c=r(s),p=a(o),l=r(o);n.push(Math.max(Math.abs(h-p),Math.abs(c-l)))}}return i}function p(r,a,s){for(var o=[],h=e-1;h>=0;h--){for(var c="",p=0,l=0;l<t;l++){var u=r.board[i(l,h)];if(u<0)p++;else{p>0&&(c+=p,p=0);var v=r.pieces[u],b=a.pieceTypes[v.t].fenAbbrev||a.pieceTypes[v.t].abbrev||"?";v.s==-1?c+=b.toLowerCase():c+=b.toUpperCase()}}p&&(c+=p),o.push(c)}var f=o.join("/");f+=" ",1==r.mWho?f+="w":f+="b",f+=" ";var d="";return r.castled&&(r.castled[1]===!1?d+="KQ":(r.castled[1].k&&(d+="K"),r.castled[1].q&&(d+="Q")),r.castled[-1]===!1?d+="kq":(r.castled[-1].k&&(d+="k"),r.castled[-1].q&&(d+="q"))),0==d.length&&(d="-"),f+=d,f+=" ",r.epTarget?f+=n(r.epTarget.p):f+="-",f+=" ",f+=r.noCaptCount,f+=" ",f+=Math.floor(s/2)+1}return{boardSize:t*e,width:t,height:e,C:r,R:a,POS:i,Graph:s,PosName:n,PosByName:o,CompactCrit:h,GetDistances:c,distEdge:function(){for(var i=[],s=0;s<t*e;s++){var n=r(s),o=a(s);i[s]=Math.min(n,Math.abs(t-n-1),o,Math.abs(e-o-1))}return i}(),corners:function(){var r={};return r[i(0,0)]=1,r[i(0,e-1)]=1,r[i(t-1,0)]=1,r[i(t-1,e-1)]=1,r}(),ExportBoardState:p}},Model.Game.cbPawnGraph=function(t,e,r){for(var a=this,i={},s=0;s<t.boardSize;s++)if(!r||s in r){var n=[],o=t.Graph(s,[0,e]);null!=o&&(!r||o in r)&&n.push(a.cbTypedArray([o|a.cbConstants.FLAG_MOVE])),[-1,1].forEach(function(i){var o=t.Graph(s,[i,e]);null!=o&&(!r||o in r)&&n.push(a.cbTypedArray([o|a.cbConstants.FLAG_CAPTURE]))}),i[s]=n}else i[s]=[];return i},Model.Game.cbInitialPawnGraph=function(t,e,r){for(var a=this,i={},s=0;s<t.boardSize;s++)if(!r||s in r){var n=[],o=t.Graph(s,[0,e]);if(null!=o&&(!r||o in r)){var h=[o|a.cbConstants.FLAG_MOVE],c=t.Graph(o,[0,e]);null!=c&&(!r||c in r)&&h.push(c|a.cbConstants.FLAG_MOVE),n.push(a.cbTypedArray(h))}[-1,1].forEach(function(i){var o=t.Graph(s,[i,e]);null!=o&&(!r||o in r)&&n.push(a.cbTypedArray([o|a.cbConstants.FLAG_CAPTURE]))}),i[s]=n}else i[s]=[];return i},Model.Game.cbKingGraph=function(t,e){return this.cbShortRangeGraph(t,[[-1,-1],[-1,0],[-1,1],[0,-1],[0,1],[1,-1],[1,0],[1,1]],e)},Model.Game.cbKnightGraph=function(t,e){return this.cbShortRangeGraph(t,[[2,-1],[2,1],[-2,-1],[-2,1],[-1,2],[-1,-2],[1,2],[1,-2]],e)},Model.Game.cbHorseGraph=function(t){for(var e=this,r={},a=0;a<t.boardSize;a++)r[a]=[],[[1,0,2,-1],[1,0,2,1],[-1,0,-2,-1],[-1,0,-2,1],[0,1,-1,2],[0,-1,-1,-2],[0,1,1,2],[0,-1,1,-2]].forEach(function(i){var s=t.Graph(a,[i[0],i[1]]);if(null!=s){var n=t.Graph(a,[i[2],i[3]]);null!=n&&r[a].push(e.cbTypedArray([s|e.cbConstants.FLAG_STOP,n|e.cbConstants.FLAG_MOVE|e.cbConstants.FLAG_CAPTURE]))}});return r},Model.Game.cbRookGraph=function(t,e){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0]],e)},Model.Game.cbBishopGraph=function(t,e){return this.cbLongRangeGraph(t,[[1,-1],[1,1],[-1,1],[-1,-1]],e)},Model.Game.cbQueenGraph=function(t,e){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0],[1,-1],[1,1],[-1,1],[-1,-1]],e)},Model.Game.cbXQGeneralGraph=function(t,e){for(var r=this,a={},i=0;i<t.boardSize;i++)a[i]=[],[[-1,0,!1],[0,-1,!0],[0,1,!0],[1,0,!1]].forEach(function(s){var n=[],o=t.Graph(i,s);if(null!=o&&((!e||o in e)&&n.push(o|r.cbConstants.FLAG_MOVE|r.cbConstants.FLAG_CAPTURE),s[2]))for(var h=t.Graph(o,s);null!=h;)!e||h in e?n.push(h|r.cbConstants.FLAG_CAPTURE|r.cbConstants.FLAG_CAPTURE_KING):n.push(h|r.cbConstants.FLAG_STOP),h=t.Graph(h,s);n.length>0&&a[i].push(r.cbTypedArray(n))});return a},Model.Game.cbXQSoldierGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e]])},Model.Game.cbXQPromoSoldierGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e],[-1,0],[1,0]])},Model.Game.cbXQAdvisorGraph=function(t,e){return this.cbShortRangeGraph(t,[[1,1],[-1,1],[1,-1],[-1,-1]],e)},Model.Game.cbXQCannonGraph=function(t){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0]],null,this.cbConstants.FLAG_MOVE|this.cbConstants.FLAG_SCREEN_CAPTURE)},Model.Game.cbXQElephantGraph=function(t,e){for(var r=this,a={},i=0;i<t.boardSize;i++)a[i]=[],(!e||i in e)&&[[1,1,2,2],[1,-1,2,-2],[-1,1,-2,2],[-1,-1,-2,-2]].forEach(function(s){var n=t.Graph(i,[s[0],s[1]]);if(null!=n){var o=t.Graph(i,[s[2],s[3]]);null!=o&&(!e||o in e)&&a[i].push(r.cbTypedArray([n|r.cbConstants.FLAG_STOP,o|r.cbConstants.FLAG_MOVE|r.cbConstants.FLAG_CAPTURE]))}});return a},Model.Game.cbSilverGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e],[-1,-1],[-1,1],[1,-1],[1,1]])},Model.Game.cbFersGraph=function(t,e){return this.cbShortRangeGraph(t,[[-1,-1],[-1,1],[1,-1],[1,1]])},Model.Game.cbSchleichGraph=function(t,e){return this.cbShortRangeGraph(t,[[-1,0],[1,0],[0,-1],[0,1]])},Model.Game.cbAlfilGraph=function(t,e){return this.cbShortRangeGraph(t,[[-2,-2],[-2,2],[2,2],[2,-2]])}}(),function(){var t=Model.Game.cbBoardGeometryGrid(8,8);Model.Game.cbDefine=function(){return{geometry:t,pieceTypes:{0:{name:"pawn-w",aspect:"fr-pawn",graph:this.cbPawnGraph(t,1),value:1,abbrev:"",fenAbbrev:"P",epCatch:!0},1:{name:"ipawn-w",aspect:"fr-pawn",graph:this.cbInitialPawnGraph(t,1),value:1,abbrev:"",fenAbbrev:"P",initial:[{s:1,p:8},{s:1,p:9},{s:1,p:10},{s:1,p:11},{s:1,p:12},{s:1,p:13},{s:1,p:14},{s:1,p:15}],epTarget:!0},2:{name:"pawn-b",aspect:"fr-pawn",graph:this.cbPawnGraph(t,-1),value:1,abbrev:"",fenAbbrev:"P",epCatch:!0},3:{name:"ipawn-b",aspect:"fr-pawn",graph:this.cbInitialPawnGraph(t,-1),value:1,abbrev:"",fenAbbrev:"P",initial:[{s:-1,p:48},{s:-1,p:49},{s:-1,p:50},{s:-1,p:51},{s:-1,p:52},{s:-1,p:53},{s:-1,p:54},{s:-1,p:55}],epTarget:!0},4:{name:"knight",aspect:"fr-knight",graph:this.cbKnightGraph(t),value:2.9,abbrev:"N",initial:[{s:1,p:1},{s:1,p:6},{s:-1,p:57},{s:-1,p:62}]},5:{name:"bishop",aspect:"fr-bishop",graph:this.cbBishopGraph(t),value:3.1,abbrev:"B",initial:[{s:1,p:2},{s:1,p:5},{s:-1,p:58},{s:-1,p:61}]},6:{name:"rook",aspect:"fr-rook",graph:this.cbRookGraph(t),value:5,abbrev:"R",initial:[{s:1,p:0},{s:1,p:7},{s:-1,p:56},{s:-1,p:63}],castle:!0},7:{name:"amazon",aspect:"fr-amazon",graph:this.cbMergeGraphs(t,this.cbQueenGraph(t),this.cbKnightGraph(t)),value:12,abbrev:"A",initial:[{s:1,p:3},{s:-1,p:59}]},8:{name:"king",aspect:"fr-king",isKing:!0,graph:this.cbKingGraph(t),abbrev:"K",initial:[{s:1,p:4},{s:-1,p:60}]}},promote:function(e,r,a){return 1==r.t?[0]:3==r.t?[2]:0==r.t&&7==t.R(a.t)?[4,5,6,7]:2==r.t&&0==t.R(a.t)?[4,5,6,7]:[]},castle:{"4/0":{k:[3,2],r:[1,2,3],n:"O-O-O"},"4/7":{k:[5,6],r:[6,5],n:"O-O"},"60/56":{k:[59,58],r:[57,58,59],n:"O-O-O"},"60/63":{k:[61,62],r:[62,61],n:"O-O"}}}}}();

/***/ }),

/***/ "FZ+f":
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function() {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		var result = [];
		for(var i = 0; i < this.length; i++) {
			var item = this[i];
			if(item[2]) {
				result.push("@media " + item[2] + "{" + item[1] + "}");
			} else {
				result.push(item[1]);
			}
		}
		return result.join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};


/***/ }),

/***/ "Ffu+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__("mmVS");
/**
 * Groups pairs of consecutive emissions together and emits them as an array of
 * two values.
 *
 * <span class="informal">Puts the current value and previous value together as
 * an array, and emits that.</span>
 *
 * <img src="./img/pairwise.png" width="100%">
 *
 * The Nth emission from the source Observable will cause the output Observable
 * to emit an array [(N-1)th, Nth] of the previous and the current value, as a
 * pair. For this reason, `pairwise` emits on the second and subsequent
 * emissions from the source Observable, but not on the first emission, because
 * there is no previous value in that case.
 *
 * @example <caption>On every click (starting from the second), emit the relative distance to the previous click</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var pairs = clicks.pairwise();
 * var distance = pairs.map(pair => {
 *   var x0 = pair[0].clientX;
 *   var y0 = pair[0].clientY;
 *   var x1 = pair[1].clientX;
 *   var y1 = pair[1].clientY;
 *   return Math.sqrt(Math.pow(x0 - x1, 2) + Math.pow(y0 - y1, 2));
 * });
 * distance.subscribe(x => console.log(x));
 *
 * @see {@link buffer}
 * @see {@link bufferCount}
 *
 * @return {Observable<Array<T>>} An Observable of pairs (as arrays) of
 * consecutive values from the source Observable.
 * @method pairwise
 * @owner Observable
 */
function pairwise() {
    return this.lift(new PairwiseOperator());
}
exports.pairwise = pairwise;
var PairwiseOperator = (function () {
    function PairwiseOperator() {
    }
    PairwiseOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new PairwiseSubscriber(subscriber));
    };
    return PairwiseOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var PairwiseSubscriber = (function (_super) {
    __extends(PairwiseSubscriber, _super);
    function PairwiseSubscriber(destination) {
        _super.call(this, destination);
        this.hasPrev = false;
    }
    PairwiseSubscriber.prototype._next = function (value) {
        if (this.hasPrev) {
            this.destination.next([this.prev, value]);
        }
        else {
            this.hasPrev = true;
        }
        this.prev = value;
    };
    return PairwiseSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=pairwise.js.map

/***/ }),

/***/ "FjqB":
/***/ (function(module, exports, __webpack_require__) {

var
    symbols = __webpack_require__("bgfr"),
    DraughtBoard =  __webpack_require__("ks7d"),
    Square = __webpack_require__("n9JH"),
    Diagonal =  __webpack_require__("W9Dn"),
    RafleItem = __webpack_require__("bAB1"),
    Move = __webpack_require__("Gjzh"),
    NTree = __webpack_require__("oiow"),
    Piece = symbols.Piece
;


function PathFinder() {
}

PathFinder.prototype.getSimpleMovements = function(board, startingSquareNum) {
    var moves = []; // [Move]

    // Récupération des 2 diagonales
    var diagoGD = this._getDiagonalGD(board, startingSquareNum);
    var diagoTT = this._getDiagonalTT(board, startingSquareNum);

    // Déplacements simples (observés sur chacune des 2 diagonales)
    var list = diagoGD.getSimpleMovements(startingSquareNum);
    list = list.concat(diagoTT.getSimpleMovements(startingSquareNum));

    for (var k = 0; k < list.length; k++) {
        var endingSquareNum = list[k];
        var move = new Move(startingSquareNum, endingSquareNum);
        moves.push(move);
    }

    return moves;
};

PathFinder.prototype.getRafleMovements = function(board, startingSquareNum) {
    var tree = this.getTreeRafles(board, startingSquareNum); // NTree<RafleItem>
    return this._treeToMovements(board, tree);
};

PathFinder.prototype._treeToMovements = function(board, tree) {
    var lists = tree.traverse(); // [[RafleItem]]

    var moves = []; // [Move]

    for (var k = 0; k < lists.length; k++) {
        var list = lists[k];

        // First item is not a capture but the starting point.
        // (It still exists even if there is no capture)
        if (list.length > 1) {
            var riStart = list[0];
            var riEnd = list[list.length - 1];

            var nStart = riStart.endingSquareNum;
            var nEnd = riEnd.endingSquareNum;
            var move = new Move(nStart, nEnd);

            for (var j = 0; j < list.length; j++) {
                var ri = list[j];

                // Starting square is not considered as a landing square
                // unlike the final square (it can be the same).
                if (ri.endingSquareNum != nStart || j != 0){
                    move.addLandingSquareNum(ri.endingSquareNum);
                }
                if (ri.capturedSquareNum != null) {
                    var capturedSq = new Square(ri.capturedSquareNum, board.getPiece(ri.capturedSquareNum));
                    move.addCapturedSquare(capturedSq);
                }
            }
            moves.push(move);
        }
    }
    return moves;
};

PathFinder.prototype.getTreeRafles = function(board, startingSquareNum) {
    var ri = new RafleItem(startingSquareNum);

    var ntreeRoot = new NTree();
    ntreeRoot.setItem(ri);

    this.buildRafles(this._cloneDraughtBoard(board), ntreeRoot, []);

    return ntreeRoot;
};

PathFinder.prototype.buildRafles = function(board, node, numSquaresPrevCaptured) {
    // board.debugDraughtBoard();

    var ri = node.getItem();
    var numSquareNewStart = ri.getNumber();
    // console.log("");
    // console.log("buildRafles(" + numSquareNewStart + ", [" + numSquaresPrevCaptured + "])");

    // Récupération des 2 diagonales
    var diagoGD = this._getDiagonalGD(board, numSquareNewStart);
    var diagoTT = this._getDiagonalTT(board, numSquareNewStart);

    // debug
    // console.log(diagoGD);
    // console.log(diagoTT);
    // ---

    // Liste des prises unitaires (observées sur chacune des 2 diagonales)
    var list = diagoGD.getRaflesItem(numSquareNewStart, numSquaresPrevCaptured);
    list = list.concat(diagoTT.getRaflesItem(numSquareNewStart, numSquaresPrevCaptured));

    // debug
    // var sri = "";
    // for (var k = 0; k < list.length; k++) {
    //     var riTmp = list[k];
    //     sri += riTmp.toString() + "-";
    // }
    // console.log("Arrivées possibles : " + sri);
    // ---

    // Ajout de ces rafles simples dans l'arbre.
    node.setChildren(list);

    // Recommencer recursivement sur les rafles filles.
    var childrenNodes = node.getChildrenNodes();
    for (var k = 0; k < childrenNodes.length; k++) {
        var nf = childrenNodes[k];
        var r = nf.getItem();

        // On met à jour la liste des cases déjà prises.
        var lcdp = numSquaresPrevCaptured.slice(0);
        lcdp.push(r.capturedSquareNum);
        // ---

        // On deplace le pion avant de poursuivre
        // (sans retirer la pièce prise).
        var diag = this._cloneDraughtBoard(board);
        var numStart = ri.getNumber();
        var numEnd = r.endingSquareNum;
        var startSq = diag.getSquare(numStart);
        var piece = startSq.piece;
        diag.getSquare(numStart).piece = Piece.EMPTY;
        diag.getSquare(numEnd).piece = piece;

        // ---
        this.buildRafles(diag, nf, lcdp);
    }
    return this;
};

PathFinder.prototype.displayTreePaths = function(tree) {
    var lists = tree.traverse(); // [[RafleItem]]

    console.log("Nombre de mouvements : " + lists.length);
    for (var k = 0; k < lists.length; k++) {
        var list = lists[k];
        var s = "";
        for (var j = 0; j < list.length; j++) {
            var ri = list[j];
            s += " > " + ri.endingSquareNum + "[" + ri.capturedSquareNum + "]";
        }
        console.log(s);
    }
};

/** Retourne la diagonaleGD contenant une case donnée. */
PathFinder.prototype._getDiagonalGD = function(board, number) {
    var diag = [];
    loop:
    for (var i = 0; i < board.conf['DIAGONALS_GD'].length; i++) {
        var diagonal = board.conf['DIAGONALS_GD'][i];
        for (var j = 0; j < diagonal.length; j++) {
            if (diagonal[j] === number) {
                diag = diagonal;
                break loop;
            }
        }
    }

    var diago = new Diagonal(true);
    for (var i = 0; i < diag.length; i++) {
        var c = board.getSquare(diag[i]);
        diago.addCase(c);
    }

    return diago;
};

/** Retourne la diagonaleTT contenant une case donnée. */
PathFinder.prototype._getDiagonalTT = function(board, number) {
    var diag = [];
    loop:
    for (var i = 0; i < board.conf['DIAGONALS_TT'].length; i++) {
        var diagonal = board.conf['DIAGONALS_TT'][i];
        for (var j = 0; j < diagonal.length; j++) {
            if (diagonal[j] === number) {
                diag = diagonal;
                break loop;
            }
        }
    }

    var diago = new Diagonal(false);
    for (var i = 0; i < diag.length; i++) {
        var c = board.getSquare(diag[i]);
        diago.addCase(c);
    }

    return diago;
};

PathFinder.prototype._cloneDraughtBoard = function(board) {
    var d = new DraughtBoard();

    for (var k = 0; k < board.getSquares().length; k++) {
        var c = board.getSquare(k + 1);
        d.setPiece(c.piece, c.number);
    }

    return d;
};

module.exports = PathFinder;


/***/ }),

/***/ "Fks5":
/***/ (function(module, exports) {

exports.config = {"status":true,"model":{"plazza":"true","released":1401720978,"title-en":"Cylinder Chess","module":"chessbase","summary":"Cylinder Chess","thumbnail":"cylinder-thumb.png","rules":{"en":"cylinder-rules.html"},"credits":{"en":"cylinder-credits.html"},"gameOptions":{"preventRepeat":true,"uctTransposition":"state","uctIgnoreLoop":false,"levelOptions":{"pieceValueFactor":1,"pieceValueRatioFactor":1,"posValueFactor":0.1,"averageDistKingFactor":-0.01,"castleFactor":0.1,"minorPiecesMovedFactor":0.1,"checkFactor":0.2,"endingKingFreedomFactor":0.01,"endingDistKingFactor":0.05,"distKingCornerFactor":0.1,"distPawnPromo1Factor":0.3,"distPawnPromo2Factor":0.1,"distPawnPromo3Factor":0.05}},"obsolete":false,"js":["base-model.js","cylinder-geo-model.js","cylinder-model.js"],"description":{"en":"cylinder-description.html"},"levels":[{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"easy","label":"Easy","maxNodes":1000},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"fast","label":"Fast [1sec]","maxDuration":1,"isDefault":true},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"medium","label":"Medium","maxNodes":10000,"maxDuration":10},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"strong","label":"Strong","maxNodes":20000,"maxDuration":15}]},"view":{"title-en":"Chessbase view","module":"chessbase","xdView":true,"css":["chessbase.css"],"preferredRatio":1,"useShowMoves":true,"useNotation":true,"useAutoComplete":true,"defaultOptions":{"sounds":true,"moves":true,"notation":false,"autocomplete":false},"skins":[{"name":"skin3d","title":"3D Classic","3d":true,"preload":[],"world":{"lightIntensity":1,"skyLightIntensity":1,"lightCastShadow":false,"fog":false,"color":4686804,"lightPosition":{"x":10,"y":15,"z":0},"skyLightPosition":{"x":9,"y":9,"z":9},"lightShadowDarkness":0.55,"ambientLightColor":16777215},"camera":{"fov":45,"distMax":200,"radius":18,"elevationAngle":0,"elevationMin":-89,"rotationAngle":-90,"target":[0,0,0],"targetBounds":[3000,3000,6000]}},{"name":"skin2d","title":"2D Classic","3d":false,"preload":["image|/res/images/wikipedia.png","image|/res/images/cancel.png","image|/res/images/whitebg.png"]}],"animateSelfMoves":false,"switchable":true,"sounds":{"move1":"alq_move1","move2":"alq_move2","move3":"alq_move3","move4":"alq_move2","tac1":"alq_tac1","tac2":"alq_tac2","tac3":"alq_tac1","promo":"promo","usermove":null},"js":["base-view.js","grid-board-view.js","cylinder-board-view.js","staunton-set-view.js","cylinder-view.js"],"visuals":{"600x600":["res/visuals/cylinder-600x600-3d.jpg","res/visuals/cylinder-600x600-2d.jpg"]}}}

/***/ }),

/***/ "Fzro":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("3j3K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__ = __webpack_require__("rCTf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_platform_browser__ = __webpack_require__("Qbdm");
/* unused harmony export BrowserXhr */
/* unused harmony export JSONPBackend */
/* unused harmony export JSONPConnection */
/* unused harmony export CookieXSRFStrategy */
/* unused harmony export XHRBackend */
/* unused harmony export XHRConnection */
/* unused harmony export BaseRequestOptions */
/* unused harmony export RequestOptions */
/* unused harmony export BaseResponseOptions */
/* unused harmony export ResponseOptions */
/* unused harmony export ReadyState */
/* unused harmony export RequestMethod */
/* unused harmony export ResponseContentType */
/* unused harmony export ResponseType */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Headers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Http; });
/* unused harmony export Jsonp */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return HttpModule; });
/* unused harmony export JsonpModule */
/* unused harmony export Connection */
/* unused harmony export ConnectionBackend */
/* unused harmony export XSRFStrategy */
/* unused harmony export Request */
/* unused harmony export Response */
/* unused harmony export QueryEncoder */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return URLSearchParams; });
/* unused harmony export VERSION */
/* unused harmony export ɵg */
/* unused harmony export ɵa */
/* unused harmony export ɵf */
/* unused harmony export ɵb */
/* unused harmony export ɵc */
/* unused harmony export ɵd */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * @license Angular v4.1.0
 * (c) 2010-2017 Google, Inc. https://angular.io/
 * License: MIT
 */



/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * A backend for http that uses the `XMLHttpRequest` browser API.
 *
 * Take care not to evaluate this in non-browser contexts.
 *
 * \@experimental
 */
var BrowserXhr = (function () {
    function BrowserXhr() {
    }
    /**
     * @return {?}
     */
    BrowserXhr.prototype.build = function () { return ((new XMLHttpRequest())); };
    return BrowserXhr;
}());
BrowserXhr.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
];
/**
 * @nocollapse
 */
BrowserXhr.ctorParameters = function () { return []; };
var RequestMethod = {};
RequestMethod.Get = 0;
RequestMethod.Post = 1;
RequestMethod.Put = 2;
RequestMethod.Delete = 3;
RequestMethod.Options = 4;
RequestMethod.Head = 5;
RequestMethod.Patch = 6;
RequestMethod[RequestMethod.Get] = "Get";
RequestMethod[RequestMethod.Post] = "Post";
RequestMethod[RequestMethod.Put] = "Put";
RequestMethod[RequestMethod.Delete] = "Delete";
RequestMethod[RequestMethod.Options] = "Options";
RequestMethod[RequestMethod.Head] = "Head";
RequestMethod[RequestMethod.Patch] = "Patch";
var ReadyState = {};
ReadyState.Unsent = 0;
ReadyState.Open = 1;
ReadyState.HeadersReceived = 2;
ReadyState.Loading = 3;
ReadyState.Done = 4;
ReadyState.Cancelled = 5;
ReadyState[ReadyState.Unsent] = "Unsent";
ReadyState[ReadyState.Open] = "Open";
ReadyState[ReadyState.HeadersReceived] = "HeadersReceived";
ReadyState[ReadyState.Loading] = "Loading";
ReadyState[ReadyState.Done] = "Done";
ReadyState[ReadyState.Cancelled] = "Cancelled";
var ResponseType = {};
ResponseType.Basic = 0;
ResponseType.Cors = 1;
ResponseType.Default = 2;
ResponseType.Error = 3;
ResponseType.Opaque = 4;
ResponseType[ResponseType.Basic] = "Basic";
ResponseType[ResponseType.Cors] = "Cors";
ResponseType[ResponseType.Default] = "Default";
ResponseType[ResponseType.Error] = "Error";
ResponseType[ResponseType.Opaque] = "Opaque";
var ContentType = {};
ContentType.NONE = 0;
ContentType.JSON = 1;
ContentType.FORM = 2;
ContentType.FORM_DATA = 3;
ContentType.TEXT = 4;
ContentType.BLOB = 5;
ContentType.ARRAY_BUFFER = 6;
ContentType[ContentType.NONE] = "NONE";
ContentType[ContentType.JSON] = "JSON";
ContentType[ContentType.FORM] = "FORM";
ContentType[ContentType.FORM_DATA] = "FORM_DATA";
ContentType[ContentType.TEXT] = "TEXT";
ContentType[ContentType.BLOB] = "BLOB";
ContentType[ContentType.ARRAY_BUFFER] = "ARRAY_BUFFER";
var ResponseContentType = {};
ResponseContentType.Text = 0;
ResponseContentType.Json = 1;
ResponseContentType.ArrayBuffer = 2;
ResponseContentType.Blob = 3;
ResponseContentType[ResponseContentType.Text] = "Text";
ResponseContentType[ResponseContentType.Json] = "Json";
ResponseContentType[ResponseContentType.ArrayBuffer] = "ArrayBuffer";
ResponseContentType[ResponseContentType.Blob] = "Blob";
/**
 * Polyfill for [Headers](https://developer.mozilla.org/en-US/docs/Web/API/Headers/Headers), as
 * specified in the [Fetch Spec](https://fetch.spec.whatwg.org/#headers-class).
 *
 * The only known difference between this `Headers` implementation and the spec is the
 * lack of an `entries` method.
 *
 * ### Example
 *
 * ```
 * import {Headers} from '\@angular/http';
 *
 * var firstHeaders = new Headers();
 * firstHeaders.append('Content-Type', 'image/jpeg');
 * console.log(firstHeaders.get('Content-Type')) //'image/jpeg'
 *
 * // Create headers from Plain Old JavaScript Object
 * var secondHeaders = new Headers({
 *   'X-My-Custom-Header': 'Angular'
 * });
 * console.log(secondHeaders.get('X-My-Custom-Header')); //'Angular'
 *
 * var thirdHeaders = new Headers(secondHeaders);
 * console.log(thirdHeaders.get('X-My-Custom-Header')); //'Angular'
 * ```
 *
 * \@experimental
 */
var Headers = (function () {
    /**
     * @param {?=} headers
     */
    function Headers(headers) {
        var _this = this;
        /**
         * \@internal header names are lower case
         */
        this._headers = new Map();
        /**
         * \@internal map lower case names to actual names
         */
        this._normalizedNames = new Map();
        if (!headers) {
            return;
        }
        if (headers instanceof Headers) {
            headers.forEach(function (values, name) {
                values.forEach(function (value) { return _this.append(name, value); });
            });
            return;
        }
        Object.keys(headers).forEach(function (name) {
            var values = Array.isArray(headers[name]) ? headers[name] : [headers[name]];
            _this.delete(name);
            values.forEach(function (value) { return _this.append(name, value); });
        });
    }
    /**
     * Returns a new Headers instance from the given DOMString of Response Headers
     * @param {?} headersString
     * @return {?}
     */
    Headers.fromResponseHeaderString = function (headersString) {
        var /** @type {?} */ headers = new Headers();
        headersString.split('\n').forEach(function (line) {
            var /** @type {?} */ index = line.indexOf(':');
            if (index > 0) {
                var /** @type {?} */ name = line.slice(0, index);
                var /** @type {?} */ value = line.slice(index + 1).trim();
                headers.set(name, value);
            }
        });
        return headers;
    };
    /**
     * Appends a header to existing list of header values for a given header name.
     * @param {?} name
     * @param {?} value
     * @return {?}
     */
    Headers.prototype.append = function (name, value) {
        var /** @type {?} */ values = this.getAll(name);
        if (values === null) {
            this.set(name, value);
        }
        else {
            values.push(value);
        }
    };
    /**
     * Deletes all header values for the given name.
     * @param {?} name
     * @return {?}
     */
    Headers.prototype.delete = function (name) {
        var /** @type {?} */ lcName = name.toLowerCase();
        this._normalizedNames.delete(lcName);
        this._headers.delete(lcName);
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    Headers.prototype.forEach = function (fn) {
        var _this = this;
        this._headers.forEach(function (values, lcName) { return fn(values, _this._normalizedNames.get(lcName), _this._headers); });
    };
    /**
     * Returns first header that matches given name.
     * @param {?} name
     * @return {?}
     */
    Headers.prototype.get = function (name) {
        var /** @type {?} */ values = this.getAll(name);
        if (values === null) {
            return null;
        }
        return values.length > 0 ? values[0] : null;
    };
    /**
     * Checks for existence of header by given name.
     * @param {?} name
     * @return {?}
     */
    Headers.prototype.has = function (name) { return this._headers.has(name.toLowerCase()); };
    /**
     * Returns the names of the headers
     * @return {?}
     */
    Headers.prototype.keys = function () { return Array.from(this._normalizedNames.values()); };
    /**
     * Sets or overrides header value for given name.
     * @param {?} name
     * @param {?} value
     * @return {?}
     */
    Headers.prototype.set = function (name, value) {
        if (Array.isArray(value)) {
            if (value.length) {
                this._headers.set(name.toLowerCase(), [value.join(',')]);
            }
        }
        else {
            this._headers.set(name.toLowerCase(), [value]);
        }
        this.mayBeSetNormalizedName(name);
    };
    /**
     * Returns values of all headers.
     * @return {?}
     */
    Headers.prototype.values = function () { return Array.from(this._headers.values()); };
    /**
     * @return {?}
     */
    Headers.prototype.toJSON = function () {
        var _this = this;
        var /** @type {?} */ serialized = {};
        this._headers.forEach(function (values, name) {
            var /** @type {?} */ split = [];
            values.forEach(function (v) { return split.push.apply(split, v.split(',')); });
            serialized[((_this._normalizedNames.get(name)))] = split;
        });
        return serialized;
    };
    /**
     * Returns list of header values for a given name.
     * @param {?} name
     * @return {?}
     */
    Headers.prototype.getAll = function (name) {
        return this.has(name) ? this._headers.get(name.toLowerCase()) || null : null;
    };
    /**
     * This method is not implemented.
     * @return {?}
     */
    Headers.prototype.entries = function () { throw new Error('"entries" method is not implemented on Headers class'); };
    /**
     * @param {?} name
     * @return {?}
     */
    Headers.prototype.mayBeSetNormalizedName = function (name) {
        var /** @type {?} */ lcName = name.toLowerCase();
        if (!this._normalizedNames.has(lcName)) {
            this._normalizedNames.set(lcName, name);
        }
    };
    return Headers;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Creates a response options object to be optionally provided when instantiating a
 * {\@link Response}.
 *
 * This class is based on the `ResponseInit` description in the [Fetch
 * Spec](https://fetch.spec.whatwg.org/#responseinit).
 *
 * All values are null by default. Typical defaults can be found in the
 * {\@link BaseResponseOptions} class, which sub-classes `ResponseOptions`.
 *
 * This class may be used in tests to build {\@link Response Responses} for
 * mock responses (see {\@link MockBackend}).
 *
 * ### Example ([live demo](http://plnkr.co/edit/P9Jkk8e8cz6NVzbcxEsD?p=preview))
 *
 * ```typescript
 * import {ResponseOptions, Response} from '\@angular/http';
 *
 * var options = new ResponseOptions({
 *   body: '{"name":"Jeff"}'
 * });
 * var res = new Response(options);
 *
 * console.log('res.json():', res.json()); // Object {name: "Jeff"}
 * ```
 *
 * \@experimental
 */
var ResponseOptions = (function () {
    /**
     * @param {?=} __0
     */
    function ResponseOptions(_a) {
        var _b = _a === void 0 ? {} : _a, body = _b.body, status = _b.status, headers = _b.headers, statusText = _b.statusText, type = _b.type, url = _b.url;
        this.body = body != null ? body : null;
        this.status = status != null ? status : null;
        this.headers = headers != null ? headers : null;
        this.statusText = statusText != null ? statusText : null;
        this.type = type != null ? type : null;
        this.url = url != null ? url : null;
    }
    /**
     * Creates a copy of the `ResponseOptions` instance, using the optional input as values to
     * override
     * existing values. This method will not change the values of the instance on which it is being
     * called.
     *
     * This may be useful when sharing a base `ResponseOptions` object inside tests,
     * where certain properties may change from test to test.
     *
     * ### Example ([live demo](http://plnkr.co/edit/1lXquqFfgduTFBWjNoRE?p=preview))
     *
     * ```typescript
     * import {ResponseOptions, Response} from '\@angular/http';
     *
     * var options = new ResponseOptions({
     *   body: {name: 'Jeff'}
     * });
     * var res = new Response(options.merge({
     *   url: 'https://google.com'
     * }));
     * console.log('options.url:', options.url); // null
     * console.log('res.json():', res.json()); // Object {name: "Jeff"}
     * console.log('res.url:', res.url); // https://google.com
     * ```
     * @param {?=} options
     * @return {?}
     */
    ResponseOptions.prototype.merge = function (options) {
        return new ResponseOptions({
            body: options && options.body != null ? options.body : this.body,
            status: options && options.status != null ? options.status : this.status,
            headers: options && options.headers != null ? options.headers : this.headers,
            statusText: options && options.statusText != null ? options.statusText : this.statusText,
            type: options && options.type != null ? options.type : this.type,
            url: options && options.url != null ? options.url : this.url,
        });
    };
    return ResponseOptions;
}());
/**
 * Subclass of {\@link ResponseOptions}, with default values.
 *
 * Default values:
 *  * status: 200
 *  * headers: empty {\@link Headers} object
 *
 * This class could be extended and bound to the {\@link ResponseOptions} class
 * when configuring an {\@link Injector}, in order to override the default options
 * used by {\@link Http} to create {\@link Response Responses}.
 *
 * ### Example ([live demo](http://plnkr.co/edit/qv8DLT?p=preview))
 *
 * ```typescript
 * import {provide} from '\@angular/core';
 * import {bootstrap} from '\@angular/platform-browser/browser';
 * import {HTTP_PROVIDERS, Headers, Http, BaseResponseOptions, ResponseOptions} from
 * '\@angular/http';
 * import {App} from './myapp';
 *
 * class MyOptions extends BaseResponseOptions {
 *   headers:Headers = new Headers({network: 'github'});
 * }
 *
 * bootstrap(App, [HTTP_PROVIDERS, {provide: ResponseOptions, useClass: MyOptions}]);
 * ```
 *
 * The options could also be extended when manually creating a {\@link Response}
 * object.
 *
 * ### Example ([live demo](http://plnkr.co/edit/VngosOWiaExEtbstDoix?p=preview))
 *
 * ```
 * import {BaseResponseOptions, Response} from '\@angular/http';
 *
 * var options = new BaseResponseOptions();
 * var res = new Response(options.merge({
 *   body: 'Angular',
 *   headers: new Headers({framework: 'angular'})
 * }));
 * console.log('res.headers.get("framework"):', res.headers.get('framework')); // angular
 * console.log('res.text():', res.text()); // Angular;
 * ```
 *
 * \@experimental
 */
var BaseResponseOptions = (function (_super) {
    __extends(BaseResponseOptions, _super);
    function BaseResponseOptions() {
        return _super.call(this, { status: 200, statusText: 'Ok', type: ResponseType.Default, headers: new Headers() }) || this;
    }
    return BaseResponseOptions;
}(ResponseOptions));
BaseResponseOptions.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
];
/**
 * @nocollapse
 */
BaseResponseOptions.ctorParameters = function () { return []; };
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Abstract class from which real backends are derived.
 *
 * The primary purpose of a `ConnectionBackend` is to create new connections to fulfill a given
 * {\@link Request}.
 *
 * \@experimental
 * @abstract
 */
var ConnectionBackend = (function () {
    function ConnectionBackend() {
    }
    /**
     * @abstract
     * @param {?} request
     * @return {?}
     */
    ConnectionBackend.prototype.createConnection = function (request) { };
    return ConnectionBackend;
}());
/**
 * Abstract class from which real connections are derived.
 *
 * \@experimental
 * @abstract
 */
var Connection = (function () {
    function Connection() {
    }
    return Connection;
}());
/**
 * An XSRFStrategy configures XSRF protection (e.g. via headers) on an HTTP request.
 *
 * \@experimental
 * @abstract
 */
var XSRFStrategy = (function () {
    function XSRFStrategy() {
    }
    /**
     * @abstract
     * @param {?} req
     * @return {?}
     */
    XSRFStrategy.prototype.configureRequest = function (req) { };
    return XSRFStrategy;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @param {?} method
 * @return {?}
 */
function normalizeMethodName(method) {
    if (typeof method !== 'string')
        return method;
    switch (method.toUpperCase()) {
        case 'GET':
            return RequestMethod.Get;
        case 'POST':
            return RequestMethod.Post;
        case 'PUT':
            return RequestMethod.Put;
        case 'DELETE':
            return RequestMethod.Delete;
        case 'OPTIONS':
            return RequestMethod.Options;
        case 'HEAD':
            return RequestMethod.Head;
        case 'PATCH':
            return RequestMethod.Patch;
    }
    throw new Error("Invalid request method. The method \"" + method + "\" is not supported.");
}
var isSuccess = function (status) { return (status >= 200 && status < 300); };
/**
 * @param {?} xhr
 * @return {?}
 */
function getResponseURL(xhr) {
    if ('responseURL' in xhr) {
        return xhr.responseURL;
    }
    if (/^X-Request-URL:/m.test(xhr.getAllResponseHeaders())) {
        return xhr.getResponseHeader('X-Request-URL');
    }
    return null;
}
/**
 * @param {?} input
 * @return {?}
 */
function stringToArrayBuffer(input) {
    var /** @type {?} */ view = new Uint16Array(input.length);
    for (var /** @type {?} */ i = 0, /** @type {?} */ strLen = input.length; i < strLen; i++) {
        view[i] = input.charCodeAt(i);
    }
    return view.buffer;
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 * @param {?=} rawParams
 * @return {?}
 */
function paramParser(rawParams) {
    if (rawParams === void 0) { rawParams = ''; }
    var /** @type {?} */ map = new Map();
    if (rawParams.length > 0) {
        var /** @type {?} */ params = rawParams.split('&');
        params.forEach(function (param) {
            var /** @type {?} */ eqIdx = param.indexOf('=');
            var _a = eqIdx == -1 ? [param, ''] : [param.slice(0, eqIdx), param.slice(eqIdx + 1)], key = _a[0], val = _a[1];
            var /** @type {?} */ list = map.get(key) || [];
            list.push(val);
            map.set(key, list);
        });
    }
    return map;
}
/**
 * \@experimental
 *
 */
var QueryEncoder = (function () {
    function QueryEncoder() {
    }
    /**
     * @param {?} k
     * @return {?}
     */
    QueryEncoder.prototype.encodeKey = function (k) { return standardEncoding(k); };
    /**
     * @param {?} v
     * @return {?}
     */
    QueryEncoder.prototype.encodeValue = function (v) { return standardEncoding(v); };
    return QueryEncoder;
}());
/**
 * @param {?} v
 * @return {?}
 */
function standardEncoding(v) {
    return encodeURIComponent(v)
        .replace(/%40/gi, '@')
        .replace(/%3A/gi, ':')
        .replace(/%24/gi, '$')
        .replace(/%2C/gi, ',')
        .replace(/%3B/gi, ';')
        .replace(/%2B/gi, '+')
        .replace(/%3D/gi, '=')
        .replace(/%3F/gi, '?')
        .replace(/%2F/gi, '/');
}
/**
 * Map-like representation of url search parameters, based on
 * [URLSearchParams](https://url.spec.whatwg.org/#urlsearchparams) in the url living standard,
 * with several extensions for merging URLSearchParams objects:
 *   - setAll()
 *   - appendAll()
 *   - replaceAll()
 *
 * This class accepts an optional second parameter of ${\@link QueryEncoder},
 * which is used to serialize parameters before making a request. By default,
 * `QueryEncoder` encodes keys and values of parameters using `encodeURIComponent`,
 * and then un-encodes certain characters that are allowed to be part of the query
 * according to IETF RFC 3986: https://tools.ietf.org/html/rfc3986.
 *
 * These are the characters that are not encoded: `! $ \' ( ) * + , ; A 9 - . _ ~ ? /`
 *
 * If the set of allowed query characters is not acceptable for a particular backend,
 * `QueryEncoder` can be subclassed and provided as the 2nd argument to URLSearchParams.
 *
 * ```
 * import {URLSearchParams, QueryEncoder} from '\@angular/http';
 * class MyQueryEncoder extends QueryEncoder {
 *   encodeKey(k: string): string {
 *     return myEncodingFunction(k);
 *   }
 *
 *   encodeValue(v: string): string {
 *     return myEncodingFunction(v);
 *   }
 * }
 *
 * let params = new URLSearchParams('', new MyQueryEncoder());
 * ```
 * \@experimental
 */
var URLSearchParams = (function () {
    /**
     * @param {?=} rawParams
     * @param {?=} queryEncoder
     */
    function URLSearchParams(rawParams, queryEncoder) {
        if (rawParams === void 0) { rawParams = ''; }
        if (queryEncoder === void 0) { queryEncoder = new QueryEncoder(); }
        this.rawParams = rawParams;
        this.queryEncoder = queryEncoder;
        this.paramsMap = paramParser(rawParams);
    }
    /**
     * @return {?}
     */
    URLSearchParams.prototype.clone = function () {
        var /** @type {?} */ clone = new URLSearchParams('', this.queryEncoder);
        clone.appendAll(this);
        return clone;
    };
    /**
     * @param {?} param
     * @return {?}
     */
    URLSearchParams.prototype.has = function (param) { return this.paramsMap.has(param); };
    /**
     * @param {?} param
     * @return {?}
     */
    URLSearchParams.prototype.get = function (param) {
        var /** @type {?} */ storedParam = this.paramsMap.get(param);
        return Array.isArray(storedParam) ? storedParam[0] : null;
    };
    /**
     * @param {?} param
     * @return {?}
     */
    URLSearchParams.prototype.getAll = function (param) { return this.paramsMap.get(param) || []; };
    /**
     * @param {?} param
     * @param {?} val
     * @return {?}
     */
    URLSearchParams.prototype.set = function (param, val) {
        if (val === void 0 || val === null) {
            this.delete(param);
            return;
        }
        var /** @type {?} */ list = this.paramsMap.get(param) || [];
        list.length = 0;
        list.push(val);
        this.paramsMap.set(param, list);
    };
    /**
     * @param {?} searchParams
     * @return {?}
     */
    URLSearchParams.prototype.setAll = function (searchParams) {
        var _this = this;
        searchParams.paramsMap.forEach(function (value, param) {
            var /** @type {?} */ list = _this.paramsMap.get(param) || [];
            list.length = 0;
            list.push(value[0]);
            _this.paramsMap.set(param, list);
        });
    };
    /**
     * @param {?} param
     * @param {?} val
     * @return {?}
     */
    URLSearchParams.prototype.append = function (param, val) {
        if (val === void 0 || val === null)
            return;
        var /** @type {?} */ list = this.paramsMap.get(param) || [];
        list.push(val);
        this.paramsMap.set(param, list);
    };
    /**
     * @param {?} searchParams
     * @return {?}
     */
    URLSearchParams.prototype.appendAll = function (searchParams) {
        var _this = this;
        searchParams.paramsMap.forEach(function (value, param) {
            var /** @type {?} */ list = _this.paramsMap.get(param) || [];
            for (var /** @type {?} */ i = 0; i < value.length; ++i) {
                list.push(value[i]);
            }
            _this.paramsMap.set(param, list);
        });
    };
    /**
     * @param {?} searchParams
     * @return {?}
     */
    URLSearchParams.prototype.replaceAll = function (searchParams) {
        var _this = this;
        searchParams.paramsMap.forEach(function (value, param) {
            var /** @type {?} */ list = _this.paramsMap.get(param) || [];
            list.length = 0;
            for (var /** @type {?} */ i = 0; i < value.length; ++i) {
                list.push(value[i]);
            }
            _this.paramsMap.set(param, list);
        });
    };
    /**
     * @return {?}
     */
    URLSearchParams.prototype.toString = function () {
        var _this = this;
        var /** @type {?} */ paramsList = [];
        this.paramsMap.forEach(function (values, k) {
            values.forEach(function (v) { return paramsList.push(_this.queryEncoder.encodeKey(k) + '=' + _this.queryEncoder.encodeValue(v)); });
        });
        return paramsList.join('&');
    };
    /**
     * @param {?} param
     * @return {?}
     */
    URLSearchParams.prototype.delete = function (param) { this.paramsMap.delete(param); };
    return URLSearchParams;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * HTTP request body used by both {\@link Request} and {\@link Response}
 * https://fetch.spec.whatwg.org/#body
 * @abstract
 */
var Body = (function () {
    function Body() {
    }
    /**
     * Attempts to return body as parsed `JSON` object, or raises an exception.
     * @return {?}
     */
    Body.prototype.json = function () {
        if (typeof this._body === 'string') {
            return JSON.parse(/** @type {?} */ (this._body));
        }
        if (this._body instanceof ArrayBuffer) {
            return JSON.parse(this.text());
        }
        return this._body;
    };
    /**
     * Returns the body as a string, presuming `toString()` can be called on the response body.
     * @return {?}
     */
    Body.prototype.text = function () {
        if (this._body instanceof URLSearchParams) {
            return this._body.toString();
        }
        if (this._body instanceof ArrayBuffer) {
            return String.fromCharCode.apply(null, new Uint16Array(/** @type {?} */ (this._body)));
        }
        if (this._body == null) {
            return '';
        }
        if (typeof this._body === 'object') {
            return JSON.stringify(this._body, null, 2);
        }
        return this._body.toString();
    };
    /**
     * Return the body as an ArrayBuffer
     * @return {?}
     */
    Body.prototype.arrayBuffer = function () {
        if (this._body instanceof ArrayBuffer) {
            return (this._body);
        }
        return stringToArrayBuffer(this.text());
    };
    /**
     * Returns the request's body as a Blob, assuming that body exists.
     * @return {?}
     */
    Body.prototype.blob = function () {
        if (this._body instanceof Blob) {
            return (this._body);
        }
        if (this._body instanceof ArrayBuffer) {
            return new Blob([this._body]);
        }
        throw new Error('The request body isn\'t either a blob or an array buffer');
    };
    return Body;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Creates `Response` instances from provided values.
 *
 * Though this object isn't
 * usually instantiated by end-users, it is the primary object interacted with when it comes time to
 * add data to a view.
 *
 * ### Example
 *
 * ```
 * http.request('my-friends.txt').subscribe(response => this.friends = response.text());
 * ```
 *
 * The Response's interface is inspired by the Response constructor defined in the [Fetch
 * Spec](https://fetch.spec.whatwg.org/#response-class), but is considered a static value whose body
 * can be accessed many times. There are other differences in the implementation, but this is the
 * most significant.
 *
 * \@experimental
 */
var Response = (function (_super) {
    __extends(Response, _super);
    /**
     * @param {?} responseOptions
     */
    function Response(responseOptions) {
        var _this = _super.call(this) || this;
        _this._body = responseOptions.body;
        _this.status = responseOptions.status;
        _this.ok = (_this.status >= 200 && _this.status <= 299);
        _this.statusText = responseOptions.statusText;
        _this.headers = responseOptions.headers;
        _this.type = responseOptions.type;
        _this.url = responseOptions.url;
        return _this;
    }
    /**
     * @return {?}
     */
    Response.prototype.toString = function () {
        return "Response with status: " + this.status + " " + this.statusText + " for URL: " + this.url;
    };
    return Response;
}(Body));
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var _nextRequestId = 0;
var JSONP_HOME = '__ng_jsonp__';
var _jsonpConnections = null;
/**
 * @return {?}
 */
function _getJsonpConnections() {
    var /** @type {?} */ w = typeof window == 'object' ? window : {};
    if (_jsonpConnections === null) {
        _jsonpConnections = w[JSONP_HOME] = {};
    }
    return _jsonpConnections;
}
var BrowserJsonp = (function () {
    function BrowserJsonp() {
    }
    /**
     * @param {?} url
     * @return {?}
     */
    BrowserJsonp.prototype.build = function (url) {
        var /** @type {?} */ node = document.createElement('script');
        node.src = url;
        return node;
    };
    /**
     * @return {?}
     */
    BrowserJsonp.prototype.nextRequestID = function () { return "__req" + _nextRequestId++; };
    /**
     * @param {?} id
     * @return {?}
     */
    BrowserJsonp.prototype.requestCallback = function (id) { return JSONP_HOME + "." + id + ".finished"; };
    /**
     * @param {?} id
     * @param {?} connection
     * @return {?}
     */
    BrowserJsonp.prototype.exposeConnection = function (id, connection) {
        var /** @type {?} */ connections = _getJsonpConnections();
        connections[id] = connection;
    };
    /**
     * @param {?} id
     * @return {?}
     */
    BrowserJsonp.prototype.removeConnection = function (id) {
        var /** @type {?} */ connections = _getJsonpConnections();
        connections[id] = null;
    };
    /**
     * @param {?} node
     * @return {?}
     */
    BrowserJsonp.prototype.send = function (node) { document.body.appendChild(/** @type {?} */ ((node))); };
    /**
     * @param {?} node
     * @return {?}
     */
    BrowserJsonp.prototype.cleanup = function (node) {
        if (node.parentNode) {
            node.parentNode.removeChild(/** @type {?} */ ((node)));
        }
    };
    return BrowserJsonp;
}());
BrowserJsonp.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
];
/**
 * @nocollapse
 */
BrowserJsonp.ctorParameters = function () { return []; };
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var JSONP_ERR_NO_CALLBACK = 'JSONP injected script did not invoke callback.';
var JSONP_ERR_WRONG_METHOD = 'JSONP requests must use GET request method.';
/**
 * Abstract base class for an in-flight JSONP request.
 *
 * \@experimental
 * @abstract
 */
var JSONPConnection = (function () {
    function JSONPConnection() {
    }
    /**
     * Callback called when the JSONP request completes, to notify the application
     * of the new data.
     * @abstract
     * @param {?=} data
     * @return {?}
     */
    JSONPConnection.prototype.finished = function (data) { };
    return JSONPConnection;
}());
var JSONPConnection_ = (function (_super) {
    __extends(JSONPConnection_, _super);
    /**
     * @param {?} req
     * @param {?} _dom
     * @param {?=} baseResponseOptions
     */
    function JSONPConnection_(req, _dom, baseResponseOptions) {
        var _this = _super.call(this) || this;
        _this._dom = _dom;
        _this.baseResponseOptions = baseResponseOptions;
        _this._finished = false;
        if (req.method !== RequestMethod.Get) {
            throw new TypeError(JSONP_ERR_WRONG_METHOD);
        }
        _this.request = req;
        _this.response = new __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"](function (responseObserver) {
            _this.readyState = ReadyState.Loading;
            var id = _this._id = _dom.nextRequestID();
            _dom.exposeConnection(id, _this);
            // Workaround Dart
            // url = url.replace(/=JSONP_CALLBACK(&|$)/, `generated method`);
            var callback = _dom.requestCallback(_this._id);
            var url = req.url;
            if (url.indexOf('=JSONP_CALLBACK&') > -1) {
                url = url.replace('=JSONP_CALLBACK&', "=" + callback + "&");
            }
            else if (url.lastIndexOf('=JSONP_CALLBACK') === url.length - '=JSONP_CALLBACK'.length) {
                url = url.substring(0, url.length - '=JSONP_CALLBACK'.length) + ("=" + callback);
            }
            var script = _this._script = _dom.build(url);
            var onLoad = function (event) {
                if (_this.readyState === ReadyState.Cancelled)
                    return;
                _this.readyState = ReadyState.Done;
                _dom.cleanup(script);
                if (!_this._finished) {
                    var responseOptions_1 = new ResponseOptions({ body: JSONP_ERR_NO_CALLBACK, type: ResponseType.Error, url: url });
                    if (baseResponseOptions) {
                        responseOptions_1 = baseResponseOptions.merge(responseOptions_1);
                    }
                    responseObserver.error(new Response(responseOptions_1));
                    return;
                }
                var responseOptions = new ResponseOptions({ body: _this._responseData, url: url });
                if (_this.baseResponseOptions) {
                    responseOptions = _this.baseResponseOptions.merge(responseOptions);
                }
                responseObserver.next(new Response(responseOptions));
                responseObserver.complete();
            };
            var onError = function (error) {
                if (_this.readyState === ReadyState.Cancelled)
                    return;
                _this.readyState = ReadyState.Done;
                _dom.cleanup(script);
                var responseOptions = new ResponseOptions({ body: error.message, type: ResponseType.Error });
                if (baseResponseOptions) {
                    responseOptions = baseResponseOptions.merge(responseOptions);
                }
                responseObserver.error(new Response(responseOptions));
            };
            script.addEventListener('load', onLoad);
            script.addEventListener('error', onError);
            _dom.send(script);
            return function () {
                _this.readyState = ReadyState.Cancelled;
                script.removeEventListener('load', onLoad);
                script.removeEventListener('error', onError);
                _this._dom.cleanup(script);
            };
        });
        return _this;
    }
    /**
     * @param {?=} data
     * @return {?}
     */
    JSONPConnection_.prototype.finished = function (data) {
        // Don't leak connections
        this._finished = true;
        this._dom.removeConnection(this._id);
        if (this.readyState === ReadyState.Cancelled)
            return;
        this._responseData = data;
    };
    return JSONPConnection_;
}(JSONPConnection));
/**
 * A {\@link ConnectionBackend} that uses the JSONP strategy of making requests.
 *
 * \@experimental
 * @abstract
 */
var JSONPBackend = (function (_super) {
    __extends(JSONPBackend, _super);
    function JSONPBackend() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return JSONPBackend;
}(ConnectionBackend));
var JSONPBackend_ = (function (_super) {
    __extends(JSONPBackend_, _super);
    /**
     * @param {?} _browserJSONP
     * @param {?} _baseResponseOptions
     */
    function JSONPBackend_(_browserJSONP, _baseResponseOptions) {
        var _this = _super.call(this) || this;
        _this._browserJSONP = _browserJSONP;
        _this._baseResponseOptions = _baseResponseOptions;
        return _this;
    }
    /**
     * @param {?} request
     * @return {?}
     */
    JSONPBackend_.prototype.createConnection = function (request) {
        return new JSONPConnection_(request, this._browserJSONP, this._baseResponseOptions);
    };
    return JSONPBackend_;
}(JSONPBackend));
JSONPBackend_.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
];
/**
 * @nocollapse
 */
JSONPBackend_.ctorParameters = function () { return [
    { type: BrowserJsonp, },
    { type: ResponseOptions, },
]; };
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var XSSI_PREFIX = /^\)\]\}',?\n/;
/**
 * Creates connections using `XMLHttpRequest`. Given a fully-qualified
 * request, an `XHRConnection` will immediately create an `XMLHttpRequest` object and send the
 * request.
 *
 * This class would typically not be created or interacted with directly inside applications, though
 * the {\@link MockConnection} may be interacted with in tests.
 *
 * \@experimental
 */
var XHRConnection = (function () {
    /**
     * @param {?} req
     * @param {?} browserXHR
     * @param {?=} baseResponseOptions
     */
    function XHRConnection(req, browserXHR, baseResponseOptions) {
        var _this = this;
        this.request = req;
        this.response = new __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"](function (responseObserver) {
            var _xhr = browserXHR.build();
            _xhr.open(RequestMethod[req.method].toUpperCase(), req.url);
            if (req.withCredentials != null) {
                _xhr.withCredentials = req.withCredentials;
            }
            // load event handler
            var onLoad = function () {
                // normalize IE9 bug (http://bugs.jquery.com/ticket/1450)
                var status = _xhr.status === 1223 ? 204 : _xhr.status;
                var body = null;
                // HTTP 204 means no content
                if (status !== 204) {
                    // responseText is the old-school way of retrieving response (supported by IE8 & 9)
                    // response/responseType properties were introduced in ResourceLoader Level2 spec
                    // (supported by IE10)
                    body = (typeof _xhr.response === 'undefined') ? _xhr.responseText : _xhr.response;
                    // Implicitly strip a potential XSSI prefix.
                    if (typeof body === 'string') {
                        body = body.replace(XSSI_PREFIX, '');
                    }
                }
                // fix status code when it is 0 (0 status is undocumented).
                // Occurs when accessing file resources or on Android 4.1 stock browser
                // while retrieving files from application cache.
                if (status === 0) {
                    status = body ? 200 : 0;
                }
                var headers = Headers.fromResponseHeaderString(_xhr.getAllResponseHeaders());
                // IE 9 does not provide the way to get URL of response
                var url = getResponseURL(_xhr) || req.url;
                var statusText = _xhr.statusText || 'OK';
                var responseOptions = new ResponseOptions({ body: body, status: status, headers: headers, statusText: statusText, url: url });
                if (baseResponseOptions != null) {
                    responseOptions = baseResponseOptions.merge(responseOptions);
                }
                var response = new Response(responseOptions);
                response.ok = isSuccess(status);
                if (response.ok) {
                    responseObserver.next(response);
                    // TODO(gdi2290): defer complete if array buffer until done
                    responseObserver.complete();
                    return;
                }
                responseObserver.error(response);
            };
            // error event handler
            var onError = function (err) {
                var responseOptions = new ResponseOptions({
                    body: err,
                    type: ResponseType.Error,
                    status: _xhr.status,
                    statusText: _xhr.statusText,
                });
                if (baseResponseOptions != null) {
                    responseOptions = baseResponseOptions.merge(responseOptions);
                }
                responseObserver.error(new Response(responseOptions));
            };
            _this.setDetectedContentType(req, _xhr);
            if (req.headers == null) {
                req.headers = new Headers();
            }
            if (!req.headers.has('Accept')) {
                req.headers.append('Accept', 'application/json, text/plain, */*');
            }
            req.headers.forEach(function (values, name) { return _xhr.setRequestHeader(name, values.join(',')); });
            // Select the correct buffer type to store the response
            if (req.responseType != null && _xhr.responseType != null) {
                switch (req.responseType) {
                    case ResponseContentType.ArrayBuffer:
                        _xhr.responseType = 'arraybuffer';
                        break;
                    case ResponseContentType.Json:
                        _xhr.responseType = 'json';
                        break;
                    case ResponseContentType.Text:
                        _xhr.responseType = 'text';
                        break;
                    case ResponseContentType.Blob:
                        _xhr.responseType = 'blob';
                        break;
                    default:
                        throw new Error('The selected responseType is not supported');
                }
            }
            _xhr.addEventListener('load', onLoad);
            _xhr.addEventListener('error', onError);
            _xhr.send(_this.request.getBody());
            return function () {
                _xhr.removeEventListener('load', onLoad);
                _xhr.removeEventListener('error', onError);
                _xhr.abort();
            };
        });
    }
    /**
     * @param {?} req
     * @param {?} _xhr
     * @return {?}
     */
    XHRConnection.prototype.setDetectedContentType = function (req /** TODO Request */, _xhr /** XMLHttpRequest */) {
        // Skip if a custom Content-Type header is provided
        if (req.headers != null && req.headers.get('Content-Type') != null) {
            return;
        }
        // Set the detected content type
        switch (req.contentType) {
            case ContentType.NONE:
                break;
            case ContentType.JSON:
                _xhr.setRequestHeader('content-type', 'application/json');
                break;
            case ContentType.FORM:
                _xhr.setRequestHeader('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
                break;
            case ContentType.TEXT:
                _xhr.setRequestHeader('content-type', 'text/plain');
                break;
            case ContentType.BLOB:
                var /** @type {?} */ blob = req.blob();
                if (blob.type) {
                    _xhr.setRequestHeader('content-type', blob.type);
                }
                break;
        }
    };
    return XHRConnection;
}());
/**
 * `XSRFConfiguration` sets up Cross Site Request Forgery (XSRF) protection for the application
 * using a cookie. See https://www.owasp.org/index.php/Cross-Site_Request_Forgery_(CSRF)
 * for more information on XSRF.
 *
 * Applications can configure custom cookie and header names by binding an instance of this class
 * with different `cookieName` and `headerName` values. See the main HTTP documentation for more
 * details.
 *
 * \@experimental
 */
var CookieXSRFStrategy = (function () {
    /**
     * @param {?=} _cookieName
     * @param {?=} _headerName
     */
    function CookieXSRFStrategy(_cookieName, _headerName) {
        if (_cookieName === void 0) { _cookieName = 'XSRF-TOKEN'; }
        if (_headerName === void 0) { _headerName = 'X-XSRF-TOKEN'; }
        this._cookieName = _cookieName;
        this._headerName = _headerName;
    }
    /**
     * @param {?} req
     * @return {?}
     */
    CookieXSRFStrategy.prototype.configureRequest = function (req) {
        var /** @type {?} */ xsrfToken = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__angular_platform_browser__["ɵgetDOM"])().getCookie(this._cookieName);
        if (xsrfToken) {
            req.headers.set(this._headerName, xsrfToken);
        }
    };
    return CookieXSRFStrategy;
}());
/**
 * Creates {\@link XHRConnection} instances.
 *
 * This class would typically not be used by end users, but could be
 * overridden if a different backend implementation should be used,
 * such as in a node backend.
 *
 * ### Example
 *
 * ```
 * import {Http, MyNodeBackend, HTTP_PROVIDERS, BaseRequestOptions} from '\@angular/http';
 * \@Component({
 *   viewProviders: [
 *     HTTP_PROVIDERS,
 *     {provide: Http, useFactory: (backend, options) => {
 *       return new Http(backend, options);
 *     }, deps: [MyNodeBackend, BaseRequestOptions]}]
 * })
 * class MyComponent {
 *   constructor(http:Http) {
 *     http.request('people.json').subscribe(res => this.people = res.json());
 *   }
 * }
 * ```
 * \@experimental
 */
var XHRBackend = (function () {
    /**
     * @param {?} _browserXHR
     * @param {?} _baseResponseOptions
     * @param {?} _xsrfStrategy
     */
    function XHRBackend(_browserXHR, _baseResponseOptions, _xsrfStrategy) {
        this._browserXHR = _browserXHR;
        this._baseResponseOptions = _baseResponseOptions;
        this._xsrfStrategy = _xsrfStrategy;
    }
    /**
     * @param {?} request
     * @return {?}
     */
    XHRBackend.prototype.createConnection = function (request) {
        this._xsrfStrategy.configureRequest(request);
        return new XHRConnection(request, this._browserXHR, this._baseResponseOptions);
    };
    return XHRBackend;
}());
XHRBackend.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
];
/**
 * @nocollapse
 */
XHRBackend.ctorParameters = function () { return [
    { type: BrowserXhr, },
    { type: ResponseOptions, },
    { type: XSRFStrategy, },
]; };
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Creates a request options object to be optionally provided when instantiating a
 * {\@link Request}.
 *
 * This class is based on the `RequestInit` description in the [Fetch
 * Spec](https://fetch.spec.whatwg.org/#requestinit).
 *
 * All values are null by default. Typical defaults can be found in the {\@link BaseRequestOptions}
 * class, which sub-classes `RequestOptions`.
 *
 * ```typescript
 * import {RequestOptions, Request, RequestMethod} from '\@angular/http';
 *
 * const options = new RequestOptions({
 *   method: RequestMethod.Post,
 *   url: 'https://google.com'
 * });
 * const req = new Request(options);
 * console.log('req.method:', RequestMethod[req.method]); // Post
 * console.log('options.url:', options.url); // https://google.com
 * ```
 *
 * \@experimental
 */
var RequestOptions = (function () {
    /**
     * @param {?=} __0
     */
    function RequestOptions(_a) {
        var _b = _a === void 0 ? {} : _a, method = _b.method, headers = _b.headers, body = _b.body, url = _b.url, search = _b.search, params = _b.params, withCredentials = _b.withCredentials, responseType = _b.responseType;
        this.method = method != null ? normalizeMethodName(method) : null;
        this.headers = headers != null ? headers : null;
        this.body = body != null ? body : null;
        this.url = url != null ? url : null;
        this.params = this._mergeSearchParams(params || search);
        this.withCredentials = withCredentials != null ? withCredentials : null;
        this.responseType = responseType != null ? responseType : null;
    }
    Object.defineProperty(RequestOptions.prototype, "search", {
        /**
         * @deprecated from 4.0.0. Use params instead.
         * @return {?}
         */
        get: function () { return this.params; },
        /**
         * @deprecated from 4.0.0. Use params instead.
         * @param {?} params
         * @return {?}
         */
        set: function (params) { this.params = params; },
        enumerable: true,
        configurable: true
    });
    /**
     * Creates a copy of the `RequestOptions` instance, using the optional input as values to override
     * existing values. This method will not change the values of the instance on which it is being
     * called.
     *
     * Note that `headers` and `search` will override existing values completely if present in
     * the `options` object. If these values should be merged, it should be done prior to calling
     * `merge` on the `RequestOptions` instance.
     *
     * ```typescript
     * import {RequestOptions, Request, RequestMethod} from '\@angular/http';
     *
     * const options = new RequestOptions({
     *   method: RequestMethod.Post
     * });
     * const req = new Request(options.merge({
     *   url: 'https://google.com'
     * }));
     * console.log('req.method:', RequestMethod[req.method]); // Post
     * console.log('options.url:', options.url); // null
     * console.log('req.url:', req.url); // https://google.com
     * ```
     * @param {?=} options
     * @return {?}
     */
    RequestOptions.prototype.merge = function (options) {
        return new RequestOptions({
            method: options && options.method != null ? options.method : this.method,
            headers: options && options.headers != null ? options.headers : new Headers(this.headers),
            body: options && options.body != null ? options.body : this.body,
            url: options && options.url != null ? options.url : this.url,
            params: options && this._mergeSearchParams(options.params || options.search),
            withCredentials: options && options.withCredentials != null ? options.withCredentials :
                this.withCredentials,
            responseType: options && options.responseType != null ? options.responseType :
                this.responseType
        });
    };
    /**
     * @param {?=} params
     * @return {?}
     */
    RequestOptions.prototype._mergeSearchParams = function (params) {
        if (!params)
            return this.params;
        if (params instanceof URLSearchParams) {
            return params.clone();
        }
        if (typeof params === 'string') {
            return new URLSearchParams(params);
        }
        return this._parseParams(params);
    };
    /**
     * @param {?=} objParams
     * @return {?}
     */
    RequestOptions.prototype._parseParams = function (objParams) {
        var _this = this;
        if (objParams === void 0) { objParams = {}; }
        var /** @type {?} */ params = new URLSearchParams();
        Object.keys(objParams).forEach(function (key) {
            var /** @type {?} */ value = objParams[key];
            if (Array.isArray(value)) {
                value.forEach(function (item) { return _this._appendParam(key, item, params); });
            }
            else {
                _this._appendParam(key, value, params);
            }
        });
        return params;
    };
    /**
     * @param {?} key
     * @param {?} value
     * @param {?} params
     * @return {?}
     */
    RequestOptions.prototype._appendParam = function (key, value, params) {
        if (typeof value !== 'string') {
            value = JSON.stringify(value);
        }
        params.append(key, value);
    };
    return RequestOptions;
}());
/**
 * Subclass of {\@link RequestOptions}, with default values.
 *
 * Default values:
 *  * method: {\@link RequestMethod RequestMethod.Get}
 *  * headers: empty {\@link Headers} object
 *
 * This class could be extended and bound to the {\@link RequestOptions} class
 * when configuring an {\@link Injector}, in order to override the default options
 * used by {\@link Http} to create and send {\@link Request Requests}.
 *
 * ```typescript
 * import {BaseRequestOptions, RequestOptions} from '\@angular/http';
 *
 * class MyOptions extends BaseRequestOptions {
 *   search: string = 'coreTeam=true';
 * }
 *
 * {provide: RequestOptions, useClass: MyOptions};
 * ```
 *
 * The options could also be extended when manually creating a {\@link Request}
 * object.
 *
 * ```
 * import {BaseRequestOptions, Request, RequestMethod} from '\@angular/http';
 *
 * const options = new BaseRequestOptions();
 * const req = new Request(options.merge({
 *   method: RequestMethod.Post,
 *   url: 'https://google.com'
 * }));
 * console.log('req.method:', RequestMethod[req.method]); // Post
 * console.log('options.url:', options.url); // null
 * console.log('req.url:', req.url); // https://google.com
 * ```
 *
 * \@experimental
 */
var BaseRequestOptions = (function (_super) {
    __extends(BaseRequestOptions, _super);
    function BaseRequestOptions() {
        return _super.call(this, { method: RequestMethod.Get, headers: new Headers() }) || this;
    }
    return BaseRequestOptions;
}(RequestOptions));
BaseRequestOptions.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
];
/**
 * @nocollapse
 */
BaseRequestOptions.ctorParameters = function () { return []; };
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Creates `Request` instances from provided values.
 *
 * The Request's interface is inspired by the Request constructor defined in the [Fetch
 * Spec](https://fetch.spec.whatwg.org/#request-class),
 * but is considered a static value whose body can be accessed many times. There are other
 * differences in the implementation, but this is the most significant.
 *
 * `Request` instances are typically created by higher-level classes, like {\@link Http} and
 * {\@link Jsonp}, but it may occasionally be useful to explicitly create `Request` instances.
 * One such example is when creating services that wrap higher-level services, like {\@link Http},
 * where it may be useful to generate a `Request` with arbitrary headers and search params.
 *
 * ```typescript
 * import {Injectable, Injector} from '\@angular/core';
 * import {HTTP_PROVIDERS, Http, Request, RequestMethod} from '\@angular/http';
 *
 * \@Injectable()
 * class AutoAuthenticator {
 *   constructor(public http:Http) {}
 *   request(url:string) {
 *     return this.http.request(new Request({
 *       method: RequestMethod.Get,
 *       url: url,
 *       search: 'password=123'
 *     }));
 *   }
 * }
 *
 * var injector = Injector.resolveAndCreate([HTTP_PROVIDERS, AutoAuthenticator]);
 * var authenticator = injector.get(AutoAuthenticator);
 * authenticator.request('people.json').subscribe(res => {
 *   //URL should have included '?password=123'
 *   console.log('people', res.json());
 * });
 * ```
 *
 * \@experimental
 */
var Request = (function (_super) {
    __extends(Request, _super);
    /**
     * @param {?} requestOptions
     */
    function Request(requestOptions) {
        var _this = _super.call(this) || this;
        // TODO: assert that url is present
        var url = requestOptions.url;
        _this.url = requestOptions.url;
        if (requestOptions.params) {
            var params = requestOptions.params.toString();
            if (params.length > 0) {
                var prefix = '?';
                if (_this.url.indexOf('?') != -1) {
                    prefix = (_this.url[_this.url.length - 1] == '&') ? '' : '&';
                }
                // TODO: just delete search-query-looking string in url?
                _this.url = url + prefix + params;
            }
        }
        _this._body = requestOptions.body;
        _this.method = normalizeMethodName(requestOptions.method);
        // TODO(jeffbcross): implement behavior
        // Defaults to 'omit', consistent with browser
        _this.headers = new Headers(requestOptions.headers);
        _this.contentType = _this.detectContentType();
        _this.withCredentials = requestOptions.withCredentials;
        _this.responseType = requestOptions.responseType;
        return _this;
    }
    /**
     * Returns the content type enum based on header options.
     * @return {?}
     */
    Request.prototype.detectContentType = function () {
        switch (this.headers.get('content-type')) {
            case 'application/json':
                return ContentType.JSON;
            case 'application/x-www-form-urlencoded':
                return ContentType.FORM;
            case 'multipart/form-data':
                return ContentType.FORM_DATA;
            case 'text/plain':
            case 'text/html':
                return ContentType.TEXT;
            case 'application/octet-stream':
                return this._body instanceof ArrayBuffer$1 ? ContentType.ARRAY_BUFFER : ContentType.BLOB;
            default:
                return this.detectContentTypeFromBody();
        }
    };
    /**
     * Returns the content type of request's body based on its type.
     * @return {?}
     */
    Request.prototype.detectContentTypeFromBody = function () {
        if (this._body == null) {
            return ContentType.NONE;
        }
        else if (this._body instanceof URLSearchParams) {
            return ContentType.FORM;
        }
        else if (this._body instanceof FormData) {
            return ContentType.FORM_DATA;
        }
        else if (this._body instanceof Blob$1) {
            return ContentType.BLOB;
        }
        else if (this._body instanceof ArrayBuffer$1) {
            return ContentType.ARRAY_BUFFER;
        }
        else if (this._body && typeof this._body === 'object') {
            return ContentType.JSON;
        }
        else {
            return ContentType.TEXT;
        }
    };
    /**
     * Returns the request's body according to its type. If body is undefined, return
     * null.
     * @return {?}
     */
    Request.prototype.getBody = function () {
        switch (this.contentType) {
            case ContentType.JSON:
                return this.text();
            case ContentType.FORM:
                return this.text();
            case ContentType.FORM_DATA:
                return this._body;
            case ContentType.TEXT:
                return this.text();
            case ContentType.BLOB:
                return this.blob();
            case ContentType.ARRAY_BUFFER:
                return this.arrayBuffer();
            default:
                return null;
        }
    };
    return Request;
}(Body));
var noop = function () { };
var w = typeof window == 'object' ? window : noop;
var FormData = ((w) /** TODO #9100 */)['FormData'] || noop;
var Blob$1 = ((w) /** TODO #9100 */)['Blob'] || noop;
var ArrayBuffer$1 = ((w) /** TODO #9100 */)['ArrayBuffer'] || noop;
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @param {?} backend
 * @param {?} request
 * @return {?}
 */
function httpRequest(backend, request) {
    return backend.createConnection(request).response;
}
/**
 * @param {?} defaultOpts
 * @param {?} providedOpts
 * @param {?} method
 * @param {?} url
 * @return {?}
 */
function mergeOptions(defaultOpts, providedOpts, method, url) {
    var /** @type {?} */ newOptions = defaultOpts;
    if (providedOpts) {
        // Hack so Dart can used named parameters
        return (newOptions.merge(new RequestOptions({
            method: providedOpts.method || method,
            url: providedOpts.url || url,
            search: providedOpts.search,
            params: providedOpts.params,
            headers: providedOpts.headers,
            body: providedOpts.body,
            withCredentials: providedOpts.withCredentials,
            responseType: providedOpts.responseType
        })));
    }
    return (newOptions.merge(new RequestOptions({ method: method, url: url })));
}
/**
 * Performs http requests using `XMLHttpRequest` as the default backend.
 *
 * `Http` is available as an injectable class, with methods to perform http requests. Calling
 * `request` returns an `Observable` which will emit a single {\@link Response} when a
 * response is received.
 *
 * ### Example
 *
 * ```typescript
 * import {Http, HTTP_PROVIDERS} from '\@angular/http';
 * import 'rxjs/add/operator/map'
 * \@Component({
 *   selector: 'http-app',
 *   viewProviders: [HTTP_PROVIDERS],
 *   templateUrl: 'people.html'
 * })
 * class PeopleComponent {
 *   constructor(http: Http) {
 *     http.get('people.json')
 *       // Call map on the response observable to get the parsed people object
 *       .map(res => res.json())
 *       // Subscribe to the observable to get the parsed people object and attach it to the
 *       // component
 *       .subscribe(people => this.people = people);
 *   }
 * }
 * ```
 *
 *
 * ### Example
 *
 * ```
 * http.get('people.json').subscribe((res:Response) => this.people = res.json());
 * ```
 *
 * The default construct used to perform requests, `XMLHttpRequest`, is abstracted as a "Backend" (
 * {\@link XHRBackend} in this case), which could be mocked with dependency injection by replacing
 * the {\@link XHRBackend} provider, as in the following example:
 *
 * ### Example
 *
 * ```typescript
 * import {BaseRequestOptions, Http} from '\@angular/http';
 * import {MockBackend} from '\@angular/http/testing';
 * var injector = Injector.resolveAndCreate([
 *   BaseRequestOptions,
 *   MockBackend,
 *   {provide: Http, useFactory:
 *       function(backend, defaultOptions) {
 *         return new Http(backend, defaultOptions);
 *       },
 *       deps: [MockBackend, BaseRequestOptions]}
 * ]);
 * var http = injector.get(Http);
 * http.get('request-from-mock-backend.json').subscribe((res:Response) => doSomething(res));
 * ```
 *
 * \@experimental
 */
var Http = (function () {
    /**
     * @param {?} _backend
     * @param {?} _defaultOptions
     */
    function Http(_backend, _defaultOptions) {
        this._backend = _backend;
        this._defaultOptions = _defaultOptions;
    }
    /**
     * Performs any type of http request. First argument is required, and can either be a url or
     * a {\@link Request} instance. If the first argument is a url, an optional {\@link RequestOptions}
     * object can be provided as the 2nd argument. The options object will be merged with the values
     * of {\@link BaseRequestOptions} before performing the request.
     * @param {?} url
     * @param {?=} options
     * @return {?}
     */
    Http.prototype.request = function (url, options) {
        var /** @type {?} */ responseObservable;
        if (typeof url === 'string') {
            responseObservable = httpRequest(this._backend, new Request(mergeOptions(this._defaultOptions, options, RequestMethod.Get, /** @type {?} */ (url))));
        }
        else if (url instanceof Request) {
            responseObservable = httpRequest(this._backend, url);
        }
        else {
            throw new Error('First argument must be a url string or Request instance.');
        }
        return responseObservable;
    };
    /**
     * Performs a request with `get` http method.
     * @param {?} url
     * @param {?=} options
     * @return {?}
     */
    Http.prototype.get = function (url, options) {
        return this.request(new Request(mergeOptions(this._defaultOptions, options, RequestMethod.Get, url)));
    };
    /**
     * Performs a request with `post` http method.
     * @param {?} url
     * @param {?} body
     * @param {?=} options
     * @return {?}
     */
    Http.prototype.post = function (url, body, options) {
        return this.request(new Request(mergeOptions(this._defaultOptions.merge(new RequestOptions({ body: body })), options, RequestMethod.Post, url)));
    };
    /**
     * Performs a request with `put` http method.
     * @param {?} url
     * @param {?} body
     * @param {?=} options
     * @return {?}
     */
    Http.prototype.put = function (url, body, options) {
        return this.request(new Request(mergeOptions(this._defaultOptions.merge(new RequestOptions({ body: body })), options, RequestMethod.Put, url)));
    };
    /**
     * Performs a request with `delete` http method.
     * @param {?} url
     * @param {?=} options
     * @return {?}
     */
    Http.prototype.delete = function (url, options) {
        return this.request(new Request(mergeOptions(this._defaultOptions, options, RequestMethod.Delete, url)));
    };
    /**
     * Performs a request with `patch` http method.
     * @param {?} url
     * @param {?} body
     * @param {?=} options
     * @return {?}
     */
    Http.prototype.patch = function (url, body, options) {
        return this.request(new Request(mergeOptions(this._defaultOptions.merge(new RequestOptions({ body: body })), options, RequestMethod.Patch, url)));
    };
    /**
     * Performs a request with `head` http method.
     * @param {?} url
     * @param {?=} options
     * @return {?}
     */
    Http.prototype.head = function (url, options) {
        return this.request(new Request(mergeOptions(this._defaultOptions, options, RequestMethod.Head, url)));
    };
    /**
     * Performs a request with `options` http method.
     * @param {?} url
     * @param {?=} options
     * @return {?}
     */
    Http.prototype.options = function (url, options) {
        return this.request(new Request(mergeOptions(this._defaultOptions, options, RequestMethod.Options, url)));
    };
    return Http;
}());
Http.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
];
/**
 * @nocollapse
 */
Http.ctorParameters = function () { return [
    { type: ConnectionBackend, },
    { type: RequestOptions, },
]; };
/**
 * \@experimental
 */
var Jsonp = (function (_super) {
    __extends(Jsonp, _super);
    /**
     * @param {?} backend
     * @param {?} defaultOptions
     */
    function Jsonp(backend, defaultOptions) {
        return _super.call(this, backend, defaultOptions) || this;
    }
    /**
     * Performs any type of http request. First argument is required, and can either be a url or
     * a {\@link Request} instance. If the first argument is a url, an optional {\@link RequestOptions}
     * object can be provided as the 2nd argument. The options object will be merged with the values
     * of {\@link BaseRequestOptions} before performing the request.
     *
     * \@security Regular XHR is the safest alternative to JSONP for most applications, and is
     * supported by all current browsers. Because JSONP creates a `<script>` element with
     * contents retrieved from a remote source, attacker-controlled data introduced by an untrusted
     * source could expose your application to XSS risks. Data exposed by JSONP may also be
     * readable by malicious third-party websites. In addition, JSONP introduces potential risk for
     * future security issues (e.g. content sniffing).  For more detail, see the
     * [Security Guide](http://g.co/ng/security).
     * @param {?} url
     * @param {?=} options
     * @return {?}
     */
    Jsonp.prototype.request = function (url, options) {
        var /** @type {?} */ responseObservable;
        if (typeof url === 'string') {
            url =
                new Request(mergeOptions(this._defaultOptions, options, RequestMethod.Get, /** @type {?} */ (url)));
        }
        if (url instanceof Request) {
            if (url.method !== RequestMethod.Get) {
                throw new Error('JSONP requests must use GET request method.');
            }
            responseObservable = httpRequest(this._backend, url);
        }
        else {
            throw new Error('First argument must be a url string or Request instance.');
        }
        return responseObservable;
    };
    return Jsonp;
}(Http));
Jsonp.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
];
/**
 * @nocollapse
 */
Jsonp.ctorParameters = function () { return [
    { type: ConnectionBackend, },
    { type: RequestOptions, },
]; };
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @module
 * @description
 * The http module provides services to perform http requests. To get started, see the {@link Http}
 * class.
 */
/**
 * @return {?}
 */
function _createDefaultCookieXSRFStrategy() {
    return new CookieXSRFStrategy();
}
/**
 * @param {?} xhrBackend
 * @param {?} requestOptions
 * @return {?}
 */
function httpFactory(xhrBackend, requestOptions) {
    return new Http(xhrBackend, requestOptions);
}
/**
 * @param {?} jsonpBackend
 * @param {?} requestOptions
 * @return {?}
 */
function jsonpFactory(jsonpBackend, requestOptions) {
    return new Jsonp(jsonpBackend, requestOptions);
}
/**
 * The module that includes http's providers
 *
 * \@experimental
 */
var HttpModule = (function () {
    function HttpModule() {
    }
    return HttpModule;
}());
HttpModule.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{
                providers: [
                    // TODO(pascal): use factory type annotations once supported in DI
                    // issue: https://github.com/angular/angular/issues/3183
                    { provide: Http, useFactory: httpFactory, deps: [XHRBackend, RequestOptions] },
                    BrowserXhr,
                    { provide: RequestOptions, useClass: BaseRequestOptions },
                    { provide: ResponseOptions, useClass: BaseResponseOptions },
                    XHRBackend,
                    { provide: XSRFStrategy, useFactory: _createDefaultCookieXSRFStrategy },
                ],
            },] },
];
/**
 * @nocollapse
 */
HttpModule.ctorParameters = function () { return []; };
/**
 * The module that includes jsonp's providers
 *
 * \@experimental
 */
var JsonpModule = (function () {
    function JsonpModule() {
    }
    return JsonpModule;
}());
JsonpModule.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{
                providers: [
                    // TODO(pascal): use factory type annotations once supported in DI
                    // issue: https://github.com/angular/angular/issues/3183
                    { provide: Jsonp, useFactory: jsonpFactory, deps: [JSONPBackend, RequestOptions] },
                    BrowserJsonp,
                    { provide: RequestOptions, useClass: BaseRequestOptions },
                    { provide: ResponseOptions, useClass: BaseResponseOptions },
                    { provide: JSONPBackend, useClass: JSONPBackend_ },
                ],
            },] },
];
/**
 * @nocollapse
 */
JsonpModule.ctorParameters = function () { return []; };
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @module
 * @description
 * Entry point for all public APIs of the common package.
 */
/**
 * \@stable
 */
var VERSION = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["Version"]('4.1.0');
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @module
 * @description
 * Entry point for all public APIs of the http package.
 */
// This file only reexports content of the `src` folder. Keep it that way.
/**
 * Generated bundle index. Do not edit.
 */

//# sourceMappingURL=http.es5.js.map


/***/ }),

/***/ "G+Bn":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("YhcC");
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__("fjbf")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../css-loader/index.js!./draughtsboard.css", function() {
			var newContent = require("!!../css-loader/index.js!./draughtsboard.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "GIjk":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * An error thrown when one or more errors have occurred during the
 * `unsubscribe` of a {@link Subscription}.
 */
var UnsubscriptionError = (function (_super) {
    __extends(UnsubscriptionError, _super);
    function UnsubscriptionError(errors) {
        _super.call(this);
        this.errors = errors;
        var err = Error.call(this, errors ?
            errors.length + " errors occurred during unsubscription:\n  " + errors.map(function (err, i) { return ((i + 1) + ") " + err.toString()); }).join('\n  ') : '');
        this.name = err.name = 'UnsubscriptionError';
        this.stack = err.stack;
        this.message = err.message;
    }
    return UnsubscriptionError;
}(Error));
exports.UnsubscriptionError = UnsubscriptionError;
//# sourceMappingURL=UnsubscriptionError.js.map

/***/ }),

/***/ "GR1s":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var OuterSubscriber_1 = __webpack_require__("wAkD");
var subscribeToResult_1 = __webpack_require__("CURp");
/**
 * Converts a higher-order Observable into a first-order Observable by dropping
 * inner Observables while the previous inner Observable has not yet completed.
 *
 * <span class="informal">Flattens an Observable-of-Observables by dropping the
 * next inner Observables while the current inner is still executing.</span>
 *
 * <img src="./img/exhaust.png" width="100%">
 *
 * `exhaust` subscribes to an Observable that emits Observables, also known as a
 * higher-order Observable. Each time it observes one of these emitted inner
 * Observables, the output Observable begins emitting the items emitted by that
 * inner Observable. So far, it behaves like {@link mergeAll}. However,
 * `exhaust` ignores every new inner Observable if the previous Observable has
 * not yet completed. Once that one completes, it will accept and flatten the
 * next inner Observable and repeat this process.
 *
 * @example <caption>Run a finite timer for each click, only if there is no currently active timer</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000));
 * var result = higherOrder.exhaust();
 * result.subscribe(x => console.log(x));
 *
 * @see {@link combineAll}
 * @see {@link concatAll}
 * @see {@link switch}
 * @see {@link mergeAll}
 * @see {@link exhaustMap}
 * @see {@link zipAll}
 *
 * @return {Observable} An Observable that takes a source of Observables and propagates the first observable
 * exclusively until it completes before subscribing to the next.
 * @method exhaust
 * @owner Observable
 */
function exhaust() {
    return this.lift(new SwitchFirstOperator());
}
exports.exhaust = exhaust;
var SwitchFirstOperator = (function () {
    function SwitchFirstOperator() {
    }
    SwitchFirstOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new SwitchFirstSubscriber(subscriber));
    };
    return SwitchFirstOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var SwitchFirstSubscriber = (function (_super) {
    __extends(SwitchFirstSubscriber, _super);
    function SwitchFirstSubscriber(destination) {
        _super.call(this, destination);
        this.hasCompleted = false;
        this.hasSubscription = false;
    }
    SwitchFirstSubscriber.prototype._next = function (value) {
        if (!this.hasSubscription) {
            this.hasSubscription = true;
            this.add(subscribeToResult_1.subscribeToResult(this, value));
        }
    };
    SwitchFirstSubscriber.prototype._complete = function () {
        this.hasCompleted = true;
        if (!this.hasSubscription) {
            this.destination.complete();
        }
    };
    SwitchFirstSubscriber.prototype.notifyComplete = function (innerSub) {
        this.remove(innerSub);
        this.hasSubscription = false;
        if (this.hasCompleted) {
            this.destination.complete();
        }
    };
    return SwitchFirstSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=exhaust.js.map

/***/ }),

/***/ "GWBc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("3j3K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base__ = __webpack_require__("TwGT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__media_query_media_monitor__ = __webpack_require__("bWt6");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FlexAlignDirective; });
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */



/**
 * 'flex-align' flexbox styling directive
 * Allows element-specific overrides for cross-axis alignments in a layout container
 * @see https://css-tricks.com/almanac/properties/a/align-self/
 */
var FlexAlignDirective = (function (_super) {
    __extends(FlexAlignDirective, _super);
    /* tslint:enable */
    function FlexAlignDirective(monitor, elRef, renderer) {
        return _super.call(this, monitor, elRef, renderer) || this;
    }
    Object.defineProperty(FlexAlignDirective.prototype, "align", {
        /* tslint:disable */
        set: function (val) { this._cacheInput('align', val); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(FlexAlignDirective.prototype, "alignXs", {
        set: function (val) { this._cacheInput('alignXs', val); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(FlexAlignDirective.prototype, "alignSm", {
        set: function (val) { this._cacheInput('alignSm', val); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(FlexAlignDirective.prototype, "alignMd", {
        set: function (val) { this._cacheInput('alignMd', val); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(FlexAlignDirective.prototype, "alignLg", {
        set: function (val) { this._cacheInput('alignLg', val); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(FlexAlignDirective.prototype, "alignXl", {
        set: function (val) { this._cacheInput('alignXl', val); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(FlexAlignDirective.prototype, "alignLtSm", {
        set: function (val) { this._cacheInput('alignLtSm', val); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(FlexAlignDirective.prototype, "alignLtMd", {
        set: function (val) { this._cacheInput('alignLtMd', val); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(FlexAlignDirective.prototype, "alignLtLg", {
        set: function (val) { this._cacheInput('alignLtLg', val); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(FlexAlignDirective.prototype, "alignLtXl", {
        set: function (val) { this._cacheInput('alignLtXl', val); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(FlexAlignDirective.prototype, "alignGtXs", {
        set: function (val) { this._cacheInput('alignGtXs', val); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(FlexAlignDirective.prototype, "alignGtSm", {
        set: function (val) { this._cacheInput('alignGtSm', val); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(FlexAlignDirective.prototype, "alignGtMd", {
        set: function (val) { this._cacheInput('alignGtMd', val); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(FlexAlignDirective.prototype, "alignGtLg", {
        set: function (val) { this._cacheInput('alignGtLg', val); },
        enumerable: true,
        configurable: true
    });
    ;
    // *********************************************
    // Lifecycle Methods
    // *********************************************
    /**
     * For @Input changes on the current mq activation property, see onMediaQueryChanges()
     */
    FlexAlignDirective.prototype.ngOnChanges = function (changes) {
        if (changes['align'] != null || this._mqActivation) {
            this._updateWithValue();
        }
    };
    /**
     * After the initial onChanges, build an mqActivation object that bridges
     * mql change events to onMediaQueryChange handlers
     */
    FlexAlignDirective.prototype.ngOnInit = function () {
        var _this = this;
        this._listenForMediaQueryChanges('align', 'stretch', function (changes) {
            _this._updateWithValue(changes.value);
        });
        this._updateWithValue();
    };
    // *********************************************
    // Protected methods
    // *********************************************
    FlexAlignDirective.prototype._updateWithValue = function (value) {
        value = value || this._queryInput("align") || 'stretch';
        if (this._mqActivation) {
            value = this._mqActivation.activatedInput;
        }
        this._applyStyleToElement(this._buildCSS(value));
    };
    FlexAlignDirective.prototype._buildCSS = function (align) {
        var css = {};
        // Cross-axis
        switch (align) {
            case 'start':
                css['align-self'] = 'flex-start';
                break;
            case 'end':
                css['align-self'] = 'flex-end';
                break;
            default:
                css['align-self'] = align;
                break;
        }
        return css;
    };
    return FlexAlignDirective;
}(__WEBPACK_IMPORTED_MODULE_1__base__["a" /* BaseFxDirective */]));

FlexAlignDirective.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                selector: "\n  [fxFlexAlign],\n  [fxFlexAlign.xs], [fxFlexAlign.sm], [fxFlexAlign.md], [fxFlexAlign.lg], [fxFlexAlign.xl],\n  [fxFlexAlign.lt-sm], [fxFlexAlign.lt-md], [fxFlexAlign.lt-lg], [fxFlexAlign.lt-xl],\n  [fxFlexAlign.gt-xs], [fxFlexAlign.gt-sm], [fxFlexAlign.gt-md], [fxFlexAlign.gt-lg]\n"
            },] },
];
/** @nocollapse */
FlexAlignDirective.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_2__media_query_media_monitor__["a" /* MediaMonitor */], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer2"], },
]; };
FlexAlignDirective.propDecorators = {
    'align': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxFlexAlign',] },],
    'alignXs': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxFlexAlign.xs',] },],
    'alignSm': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxFlexAlign.sm',] },],
    'alignMd': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxFlexAlign.md',] },],
    'alignLg': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxFlexAlign.lg',] },],
    'alignXl': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxFlexAlign.xl',] },],
    'alignLtSm': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxFlexAlign.lt-sm',] },],
    'alignLtMd': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxFlexAlign.lt-md',] },],
    'alignLtLg': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxFlexAlign.lt-lg',] },],
    'alignLtXl': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxFlexAlign.lt-xl',] },],
    'alignGtXs': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxFlexAlign.gt-xs',] },],
    'alignGtSm': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxFlexAlign.gt-sm',] },],
    'alignGtMd': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxFlexAlign.gt-md',] },],
    'alignGtLg': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxFlexAlign.gt-lg',] },],
};
//# sourceMappingURL=flex-align.js.map

/***/ }),

/***/ "GZqV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__("mmVS");
/* tslint:enable:max-line-length */
/**
 * Emits only the first value emitted by the source Observable that meets some
 * condition.
 *
 * <span class="informal">Finds the first value that passes some test and emits
 * that.</span>
 *
 * <img src="./img/find.png" width="100%">
 *
 * `find` searches for the first item in the source Observable that matches the
 * specified condition embodied by the `predicate`, and returns the first
 * occurrence in the source. Unlike {@link first}, the `predicate` is required
 * in `find`, and does not emit an error if a valid value is not found.
 *
 * @example <caption>Find and emit the first click that happens on a DIV element</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.find(ev => ev.target.tagName === 'DIV');
 * result.subscribe(x => console.log(x));
 *
 * @see {@link filter}
 * @see {@link first}
 * @see {@link findIndex}
 * @see {@link take}
 *
 * @param {function(value: T, index: number, source: Observable<T>): boolean} predicate
 * A function called with each item to test for condition matching.
 * @param {any} [thisArg] An optional argument to determine the value of `this`
 * in the `predicate` function.
 * @return {Observable<T>} An Observable of the first item that matches the
 * condition.
 * @method find
 * @owner Observable
 */
function find(predicate, thisArg) {
    if (typeof predicate !== 'function') {
        throw new TypeError('predicate is not a function');
    }
    return this.lift(new FindValueOperator(predicate, this, false, thisArg));
}
exports.find = find;
var FindValueOperator = (function () {
    function FindValueOperator(predicate, source, yieldIndex, thisArg) {
        this.predicate = predicate;
        this.source = source;
        this.yieldIndex = yieldIndex;
        this.thisArg = thisArg;
    }
    FindValueOperator.prototype.call = function (observer, source) {
        return source.subscribe(new FindValueSubscriber(observer, this.predicate, this.source, this.yieldIndex, this.thisArg));
    };
    return FindValueOperator;
}());
exports.FindValueOperator = FindValueOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var FindValueSubscriber = (function (_super) {
    __extends(FindValueSubscriber, _super);
    function FindValueSubscriber(destination, predicate, source, yieldIndex, thisArg) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.source = source;
        this.yieldIndex = yieldIndex;
        this.thisArg = thisArg;
        this.index = 0;
    }
    FindValueSubscriber.prototype.notifyComplete = function (value) {
        var destination = this.destination;
        destination.next(value);
        destination.complete();
    };
    FindValueSubscriber.prototype._next = function (value) {
        var _a = this, predicate = _a.predicate, thisArg = _a.thisArg;
        var index = this.index++;
        try {
            var result = predicate.call(thisArg || this, value, index, this.source);
            if (result) {
                this.notifyComplete(this.yieldIndex ? index : value);
            }
        }
        catch (err) {
            this.destination.error(err);
        }
    };
    FindValueSubscriber.prototype._complete = function () {
        this.notifyComplete(this.yieldIndex ? -1 : undefined);
    };
    return FindValueSubscriber;
}(Subscriber_1.Subscriber));
exports.FindValueSubscriber = FindValueSubscriber;
//# sourceMappingURL=find.js.map

/***/ }),

/***/ "Gb0N":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Observable_1 = __webpack_require__("rCTf");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var RangeObservable = (function (_super) {
    __extends(RangeObservable, _super);
    function RangeObservable(start, count, scheduler) {
        _super.call(this);
        this.start = start;
        this._count = count;
        this.scheduler = scheduler;
    }
    /**
     * Creates an Observable that emits a sequence of numbers within a specified
     * range.
     *
     * <span class="informal">Emits a sequence of numbers in a range.</span>
     *
     * <img src="./img/range.png" width="100%">
     *
     * `range` operator emits a range of sequential integers, in order, where you
     * select the `start` of the range and its `length`. By default, uses no
     * IScheduler and just delivers the notifications synchronously, but may use
     * an optional IScheduler to regulate those deliveries.
     *
     * @example <caption>Emits the numbers 1 to 10</caption>
     * var numbers = Rx.Observable.range(1, 10);
     * numbers.subscribe(x => console.log(x));
     *
     * @see {@link timer}
     * @see {@link interval}
     *
     * @param {number} [start=0] The value of the first integer in the sequence.
     * @param {number} [count=0] The number of sequential integers to generate.
     * @param {Scheduler} [scheduler] A {@link IScheduler} to use for scheduling
     * the emissions of the notifications.
     * @return {Observable} An Observable of numbers that emits a finite range of
     * sequential integers.
     * @static true
     * @name range
     * @owner Observable
     */
    RangeObservable.create = function (start, count, scheduler) {
        if (start === void 0) { start = 0; }
        if (count === void 0) { count = 0; }
        return new RangeObservable(start, count, scheduler);
    };
    RangeObservable.dispatch = function (state) {
        var start = state.start, index = state.index, count = state.count, subscriber = state.subscriber;
        if (index >= count) {
            subscriber.complete();
            return;
        }
        subscriber.next(start);
        if (subscriber.closed) {
            return;
        }
        state.index = index + 1;
        state.start = start + 1;
        this.schedule(state);
    };
    RangeObservable.prototype._subscribe = function (subscriber) {
        var index = 0;
        var start = this.start;
        var count = this._count;
        var scheduler = this.scheduler;
        if (scheduler) {
            return scheduler.schedule(RangeObservable.dispatch, 0, {
                index: index, count: count, start: start, subscriber: subscriber
            });
        }
        else {
            do {
                if (index++ >= count) {
                    subscriber.complete();
                    break;
                }
                subscriber.next(start++);
                if (subscriber.closed) {
                    break;
                }
            } while (true);
        }
    };
    return RangeObservable;
}(Observable_1.Observable));
exports.RangeObservable = RangeObservable;
//# sourceMappingURL=RangeObservable.js.map

/***/ }),

/***/ "GcOx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var debounce_1 = __webpack_require__("cjT5");
Observable_1.Observable.prototype.debounce = debounce_1.debounce;
//# sourceMappingURL=debounce.js.map

/***/ }),

/***/ "Gjzh":
/***/ (function(module, exports, __webpack_require__) {

var
    symbols = __webpack_require__("bgfr"),
    Color = symbols.Color
;

function Move(startNum, endNum) {
    this.startingSquareNum = startNum;
    this.endingSquareNum = endNum;
    this.middleSquaresNum = []; // [int]

    this.color = Color.NONE;
    this.isCaptured = false;
    this.isCrowned = false;

    this.landingSquaresNum = [];  // [int]
    this.capturedSquares = []; // [Square]

    this.status = true;
    this.message = "";
}

Move.prototype.addLandingSquareNum = function(squareNum) {
    this.landingSquaresNum.push(squareNum);
    return this;
};
Move.prototype.addCapturedSquare = function(square) {
    this.capturedSquares.push(square);
    return this;
};

Move.prototype.size = function() {
    return this.capturedSquares.length + this.landingSquaresNum.length;
};

Move.prototype.getLandingSquaresNum = function() {
    return this.landingSquaresNum;
};

Move.prototype.getCapturedSquaresNum = function() {
    var list = [];
    for (var k = 0; k < this.capturedSquares.length; k++){
        list.push(this.capturedSquares[k].number);
    }
    return list;
};


Move.prototype.toString = function() {
    var tmp = "";
    var nb = this.landingSquaresNum.length;
    for (var i = 0; i < nb; i++) {
        if (tmp !== "") {
            tmp += ", ";
        }
        tmp += this.landingSquaresNum[i];
    }

    var tmp2 = "";
    for (var i = 0; i < this.capturedSquares.length; i++) {
        if (tmp2 !== "") {
            tmp2 += ", ";
        }
        tmp2 += this.capturedSquares[i].number;
    }

    var sep = "-";
    if (this.isCaptured) {
        sep = "x";
    }

    var s = "" + this.startingSquareNum;
    if (this.middleSquaresNum.length > 0) {
        s += sep + "(" + this.middleSquaresNum + ")";
    }
    s += sep + this.endingSquareNum;
    s += " : Pose(" + tmp + ")";
    s += " - Pris(" + tmp2 + ")";
    s += " - Statut(" + this.status + ")";
    return s;
};

Move.prototype.getNotation = function() {
    var sep = this.isCaptured ? "x" : "-";

    var s = "";
    s += this.startingSquareNum;

    if (this.middleSquaresNum.length > 0) {
        s += sep;
        s += this.middleSquaresNum;
    }

    s += sep;
    s += this.endingSquareNum;
    return s;
};

/*
 * Vrai si
 * <ul>
 * <li>Même case de départ</li>
 * <li>Même case d'arrivée</li>
 * <li>Mêmes cases prises</li>
 * </ul>
 */
Move.prototype.equals = function(move) {
    var isEqual = true;

    isEqual = isEqual && (this.startingSquareNum == move.startingSquareNum);
    isEqual = isEqual && (this.endingSquareNum == move.endingSquareNum);

    if (isEqual) {
        var lc = this.capturedSquares;
        var lc2 = move.capturedSquares;

        isEqual = isEqual && (lc.length == lc2.length);
        if (isEqual) {
            for (var i = 0; i < lc.length; i++) {
                var found = false;
                for (var j = 0; j < lc2.length; j++) {
                    if (lc[i].number == lc2[j].number && lc[i].piece == lc2[j].piece) {
                        found = true;
                    }
                }
                if (!found) {
                    isEqual = false;
                    break;
                }
            }
        }
    }

    return isEqual;
};

module.exports = Move;


/***/ }),

/***/ "Gvdl":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* tslint:disable:no-unused-variable */
// Subject imported before Observable to bypass circular dependency issue since
// Subject extends Observable and Observable references Subject in it's
// definition
var Subject_1 = __webpack_require__("EEr4");
exports.Subject = Subject_1.Subject;
exports.AnonymousSubject = Subject_1.AnonymousSubject;
/* tslint:enable:no-unused-variable */
var Observable_1 = __webpack_require__("rCTf");
exports.Observable = Observable_1.Observable;
// statics
/* tslint:disable:no-use-before-declare */
__webpack_require__("1k2o");
__webpack_require__("U85J");
__webpack_require__("XlOA");
__webpack_require__("1ZrL");
__webpack_require__("zO2v");
__webpack_require__("AGQa");
__webpack_require__("iJMh");
__webpack_require__("S35O");
__webpack_require__("E7Yq");
__webpack_require__("LHw1");
__webpack_require__("c3t5");
__webpack_require__("f1gJ");
__webpack_require__("iUY6");
__webpack_require__("SUuD");
__webpack_require__("fICK");
__webpack_require__("O8p4");
__webpack_require__("9WjZ");
__webpack_require__("1APj");
__webpack_require__("1VLl");
__webpack_require__("g0nL");
__webpack_require__("ENML");
__webpack_require__("vQ+N");
__webpack_require__("h0qH");
__webpack_require__("jdeX");
__webpack_require__("iod1");
//dom
__webpack_require__("1Nls");
__webpack_require__("lh/Z");
//operators
__webpack_require__("nsuO");
__webpack_require__("+KN+");
__webpack_require__("Di9Q");
__webpack_require__("jDQW");
__webpack_require__("Whbc");
__webpack_require__("6Yye");
__webpack_require__("k27J");
__webpack_require__("qp8k");
__webpack_require__("/rMs");
__webpack_require__("CMrU");
__webpack_require__("jvbR");
__webpack_require__("16m9");
__webpack_require__("/181");
__webpack_require__("zC23");
__webpack_require__("GcOx");
__webpack_require__("aV5h");
__webpack_require__("NJh0");
__webpack_require__("94IA");
__webpack_require__("FE8a");
__webpack_require__("qhgQ");
__webpack_require__("q3ik");
__webpack_require__("tYwL");
__webpack_require__("EnA3");
__webpack_require__("Yfq7");
__webpack_require__("SSeX");
__webpack_require__("sT3i");
__webpack_require__("Mvzr");
__webpack_require__("wUn1");
__webpack_require__("tDJK");
__webpack_require__("hs6U");
__webpack_require__("W1/H");
__webpack_require__("okk1");
__webpack_require__("6s76");
__webpack_require__("LppN");
__webpack_require__("2395");
__webpack_require__("qcjU");
__webpack_require__("CYDS");
__webpack_require__("JJSU");
__webpack_require__("KRCp");
__webpack_require__("1NVl");
__webpack_require__("+pb+");
__webpack_require__("6gFN");
__webpack_require__("Ye9U");
__webpack_require__("CToi");
__webpack_require__("EGMK");
__webpack_require__("JPC0");
__webpack_require__("HcJ8");
__webpack_require__("VfeM");
__webpack_require__("SGWz");
__webpack_require__("Rxv9");
__webpack_require__("j7ye");
__webpack_require__("p1Um");
__webpack_require__("rLWm");
__webpack_require__("iIfT");
__webpack_require__("adqA");
__webpack_require__("xOQQ");
__webpack_require__("4Ie8");
__webpack_require__("nDCe");
__webpack_require__("PvYY");
__webpack_require__("0TiQ");
__webpack_require__("48bo");
__webpack_require__("UNGF");
__webpack_require__("XZ4o");
__webpack_require__("y6Vm");
__webpack_require__("y3IE");
__webpack_require__("10Gq");
__webpack_require__("B2te");
__webpack_require__("6hPP");
__webpack_require__("zJQZ");
__webpack_require__("UFi/");
__webpack_require__("WQmy");
__webpack_require__("JQ6u");
__webpack_require__("9qUs");
__webpack_require__("8szd");
__webpack_require__("VaQ6");
__webpack_require__("/lY3");
__webpack_require__("oHQS");
__webpack_require__("UyzR");
__webpack_require__("uCY4");
__webpack_require__("tuHt");
__webpack_require__("hzF8");
__webpack_require__("77/N");
__webpack_require__("T3fU");
__webpack_require__("EoAl");
__webpack_require__("PMZt");
__webpack_require__("jF50");
__webpack_require__("XKof");
__webpack_require__("cDAr");
__webpack_require__("a0Ch");
__webpack_require__("voL5");
__webpack_require__("7axH");
__webpack_require__("eErF");
__webpack_require__("7FaQ");
__webpack_require__("q4U+");
__webpack_require__("PwiB");
__webpack_require__("xFXl");
__webpack_require__("gDzJ");
__webpack_require__("fiy1");
__webpack_require__("ixac");
__webpack_require__("tQRI");
/* tslint:disable:no-unused-variable */
var Subscription_1 = __webpack_require__("B00U");
exports.Subscription = Subscription_1.Subscription;
var Subscriber_1 = __webpack_require__("mmVS");
exports.Subscriber = Subscriber_1.Subscriber;
var AsyncSubject_1 = __webpack_require__("5c/I");
exports.AsyncSubject = AsyncSubject_1.AsyncSubject;
var ReplaySubject_1 = __webpack_require__("MQMf");
exports.ReplaySubject = ReplaySubject_1.ReplaySubject;
var BehaviorSubject_1 = __webpack_require__("TfWX");
exports.BehaviorSubject = BehaviorSubject_1.BehaviorSubject;
var ConnectableObservable_1 = __webpack_require__("sIYO");
exports.ConnectableObservable = ConnectableObservable_1.ConnectableObservable;
var Notification_1 = __webpack_require__("8GmM");
exports.Notification = Notification_1.Notification;
var EmptyError_1 = __webpack_require__("F7Al");
exports.EmptyError = EmptyError_1.EmptyError;
var ArgumentOutOfRangeError_1 = __webpack_require__("8Z8y");
exports.ArgumentOutOfRangeError = ArgumentOutOfRangeError_1.ArgumentOutOfRangeError;
var ObjectUnsubscribedError_1 = __webpack_require__("IZVw");
exports.ObjectUnsubscribedError = ObjectUnsubscribedError_1.ObjectUnsubscribedError;
var TimeoutError_1 = __webpack_require__("cmqr");
exports.TimeoutError = TimeoutError_1.TimeoutError;
var UnsubscriptionError_1 = __webpack_require__("GIjk");
exports.UnsubscriptionError = UnsubscriptionError_1.UnsubscriptionError;
var timeInterval_1 = __webpack_require__("sVus");
exports.TimeInterval = timeInterval_1.TimeInterval;
var timestamp_1 = __webpack_require__("5pRa");
exports.Timestamp = timestamp_1.Timestamp;
var TestScheduler_1 = __webpack_require__("u1gx");
exports.TestScheduler = TestScheduler_1.TestScheduler;
var VirtualTimeScheduler_1 = __webpack_require__("q0UB");
exports.VirtualTimeScheduler = VirtualTimeScheduler_1.VirtualTimeScheduler;
var AjaxObservable_1 = __webpack_require__("Dc2k");
exports.AjaxResponse = AjaxObservable_1.AjaxResponse;
exports.AjaxError = AjaxObservable_1.AjaxError;
exports.AjaxTimeoutError = AjaxObservable_1.AjaxTimeoutError;
var asap_1 = __webpack_require__("Uqs8");
var async_1 = __webpack_require__("CGGv");
var queue_1 = __webpack_require__("RA5l");
var animationFrame_1 = __webpack_require__("HwIK");
var rxSubscriber_1 = __webpack_require__("r8ZY");
var iterator_1 = __webpack_require__("cdmN");
var observable_1 = __webpack_require__("mbVC");
/* tslint:enable:no-unused-variable */
/**
 * @typedef {Object} Rx.Scheduler
 * @property {Scheduler} queue Schedules on a queue in the current event frame
 * (trampoline scheduler). Use this for iteration operations.
 * @property {Scheduler} asap Schedules on the micro task queue, which uses the
 * fastest transport mechanism available, either Node.js' `process.nextTick()`
 * or Web Worker MessageChannel or setTimeout or others. Use this for
 * asynchronous conversions.
 * @property {Scheduler} async Schedules work with `setInterval`. Use this for
 * time-based operations.
 * @property {Scheduler} animationFrame Schedules work with `requestAnimationFrame`.
 * Use this for synchronizing with the platform's painting
 */
var Scheduler = {
    asap: asap_1.asap,
    queue: queue_1.queue,
    animationFrame: animationFrame_1.animationFrame,
    async: async_1.async
};
exports.Scheduler = Scheduler;
/**
 * @typedef {Object} Rx.Symbol
 * @property {Symbol|string} rxSubscriber A symbol to use as a property name to
 * retrieve an "Rx safe" Observer from an object. "Rx safety" can be defined as
 * an object that has all of the traits of an Rx Subscriber, including the
 * ability to add and remove subscriptions to the subscription chain and
 * guarantees involving event triggering (can't "next" after unsubscription,
 * etc).
 * @property {Symbol|string} observable A symbol to use as a property name to
 * retrieve an Observable as defined by the [ECMAScript "Observable" spec](https://github.com/zenparsing/es-observable).
 * @property {Symbol|string} iterator The ES6 symbol to use as a property name
 * to retrieve an iterator from an object.
 */
var Symbol = {
    rxSubscriber: rxSubscriber_1.rxSubscriber,
    observable: observable_1.observable,
    iterator: iterator_1.iterator
};
exports.Symbol = Symbol;
//# sourceMappingURL=Rx.js.map

/***/ }),

/***/ "H43Q":
/***/ (function(module, exports) {

exports.config = {"status":true,"model":{"plazza":"true","released":1405068614,"title-en":"Tutti-Frutti Chess","module":"chessbase","summary":"Ralph Betza et Philip Cohen, 1978-79","thumbnail":"tutti-frutti-thumb.png","rules":{"en":"tutti-frutti-rules.html"},"credits":{"en":"tutti-frutti-credits.html"},"gameOptions":{"preventRepeat":true,"uctTransposition":"state","uctIgnoreLoop":false,"levelOptions":{"pieceValueFactor":1,"pieceValueRatioFactor":1,"posValueFactor":0.1,"averageDistKingFactor":-0.01,"castleFactor":0.1,"minorPiecesMovedFactor":0.1,"checkFactor":0.2,"endingKingFreedomFactor":0.01,"endingDistKingFactor":0.05,"distKingCornerFactor":0.1,"distPawnPromo1Factor":0.3,"distPawnPromo2Factor":0.1,"distPawnPromo3Factor":0.05}},"obsolete":false,"js":["base-model.js","grid-geo-model.js","tutti-frutti-model.js"],"description":{"en":"tutti-frutti-description.html"},"levels":[{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"easy","label":"Easy","maxNodes":1000},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"fast","label":"Fast [1sec]","maxDuration":1,"isDefault":true},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"medium","label":"Medium","maxNodes":10000,"maxDuration":10},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"strong","label":"Strong","maxNodes":20000,"maxDuration":15}]},"view":{"title-en":"Chessbase view","module":"chessbase","xdView":true,"css":["chessbase.css"],"preferredRatio":1,"useShowMoves":true,"useNotation":true,"useAutoComplete":true,"defaultOptions":{"sounds":true,"moves":true,"notation":false,"autocomplete":false},"skins":[{"name":"skin3d","title":"3D Classic","3d":true,"preload":["smoothedfilegeo|0|/res/ring-target.js","image|/res/images/cancel.png","image|/res/images/wikipedia.png","smoothedfilegeo|0|/res/fairy/pawn/pawn.js","image|/res/fairy/pawn/pawn-diffusemap.jpg","image|/res/fairy/pawn/pawn-normalmap.jpg","smoothedfilegeo|0|/res/fairy/knight/knight.js","image|/res/fairy/knight/knight-diffusemap.jpg","image|/res/fairy/knight/knight-normalmap.jpg","smoothedfilegeo|0|/res/fairy/bishop/bishop.js","image|/res/fairy/bishop/bishop-diffusemap.jpg","image|/res/fairy/bishop/bishop-normalmap.jpg","smoothedfilegeo|0|/res/fairy/king/king.js","image|/res/fairy/king/king-diffusemap.jpg","image|/res/fairy/king/king-normalmap.jpg","smoothedfilegeo|0|/res/fairy/rook/rook.js","image|/res/fairy/rook/rook-diffusemap.jpg","image|/res/fairy/rook/rook-normalmap.jpg","smoothedfilegeo|0|/res/fairy/queen/queen.js","image|/res/fairy/queen/queen-diffusemap.jpg","image|/res/fairy/queen/queen-normalmap.jpg","smoothedfilegeo|0|/res/fairy/amazon/amazon.js","image|/res/fairy/amazon/amazon-diffusemap.jpg","image|/res/fairy/amazon/amazon-normalmap.jpg","smoothedfilegeo|0|/res/fairy/marshall/marshall.js","image|/res/fairy/marshall/marshall-diffusemap.jpg","image|/res/fairy/marshall/marshall-normalmap.jpg","smoothedfilegeo|0|/res/fairy/cardinal/cardinal.js","image|/res/fairy/cardinal/cardinal-diffusemap.jpg","image|/res/fairy/cardinal/cardinal-normalmap.jpg"],"world":{"lightIntensity":1.3,"skyLightIntensity":1.2,"lightCastShadow":true,"fog":false,"color":4686804,"lightPosition":{"x":-9,"y":9,"z":9},"skyLightPosition":{"x":9,"y":9,"z":9},"lightShadowDarkness":0.55,"ambientLightColor":2236962},"camera":{"fov":45,"distMax":50,"radius":18,"elevationAngle":60,"elevationMin":0}},{"name":"skin2d","title":"2D Classic","3d":false,"preload":["image|/res/images/cancel.png","image|/res/images/whitebg.png","image|/res/fairy/wikipedia-fairy-sprites.png"]}],"animateSelfMoves":false,"switchable":true,"sounds":{"move1":"alq_move1","move2":"alq_move2","move3":"alq_move3","move4":"alq_move2","tac1":"alq_tac1","tac2":"alq_tac2","tac3":"alq_tac1","promo":"promo","usermove":null},"js":["base-view.js","grid-board-view.js","fairy-set-view.js","tutti-frutti-view.js"],"visuals":{"600x600":["res/visuals/tutti-frutti-600x600-3d.jpg","res/visuals/tutti-frutti-600x600-2d.jpg"]}}}

/***/ }),

/***/ "HIo7":
/***/ (function(module, exports) {

exports.config = {"status":true,"model":{"plazza":"true","released":1403535377,"title-en":"Romanchenko's Chess","module":"chessbase","summary":"Shifted 8x8 chess variant by V. Romanchenko","thumbnail":"romanchenko-thumb.png","rules":{"en":"romanchenko-rules.html"},"credits":{"en":"romanchenko-credits.html"},"gameOptions":{"preventRepeat":true,"uctTransposition":"state","uctIgnoreLoop":false,"levelOptions":{"pieceValueFactor":1,"pieceValueRatioFactor":1,"posValueFactor":0.1,"averageDistKingFactor":-0.01,"castleFactor":0.1,"minorPiecesMovedFactor":0.1,"checkFactor":0.2,"endingKingFreedomFactor":0.01,"endingDistKingFactor":0.05,"distKingCornerFactor":0.1}},"obsolete":false,"js":["base-model.js","grid-geo-model.js","romanchenko-model.js"],"levels":[{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"easy","label":"Easy","maxNodes":1000},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"fast","label":"Fast [1sec]","maxDuration":1,"isDefault":true},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"medium","label":"Medium","maxNodes":10000,"maxDuration":10},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"strong","label":"Strong","maxNodes":20000,"maxDuration":15}],"description":{"en":"romanchenko-description.html"}},"view":{"title-en":"Chessbase view","module":"chessbase","xdView":true,"css":["chessbase.css"],"preferredRatio":1,"useShowMoves":true,"useNotation":true,"useAutoComplete":true,"defaultOptions":{"sounds":true,"moves":true,"notation":false,"autocomplete":false},"skins":[{"name":"skin3d","title":"3D Classic","3d":true,"preload":["smoothedfilegeo|0|/res/ring-target.js","image|/res/images/cancel.png","image|/res/images/wikipedia.png","smoothedfilegeo|0|/res/staunton/pawn/pawn-classic.js","image|/res/staunton/pawn/pawn-diffusemap.jpg","image|/res/staunton/pawn/pawn-normalmap.jpg","smoothedfilegeo|0|/res/staunton/knight/knight.js","image|/res/staunton/knight/knight-diffusemap.jpg","image|/res/staunton/knight/knight-normalmap.jpg","smoothedfilegeo|0|/res/staunton/bishop/bishop.js","image|/res/staunton/bishop/bishop-diffusemap.jpg","image|/res/staunton/bishop/bishop-normalmap.jpg","smoothedfilegeo|0|/res/staunton/rook/rook.js","image|/res/staunton/rook/rook-diffusemap.jpg","image|/res/staunton/rook/rook-normalmap.jpg","smoothedfilegeo|0|/res/staunton/queen/queen.js","image|/res/staunton/queen/queen-diffusemap.jpg","image|/res/staunton/queen/queen-normalmap.jpg","smoothedfilegeo|0|/res/staunton/king/king.js","image|/res/staunton/king/king-diffusemap.jpg","image|/res/staunton/king/king-normalmap.jpg"],"world":{"lightIntensity":1.3,"skyLightIntensity":1.2,"lightCastShadow":true,"fog":false,"color":4686804,"lightPosition":{"x":-9,"y":9,"z":9},"skyLightPosition":{"x":9,"y":9,"z":9},"lightShadowDarkness":0.55,"ambientLightColor":2236962},"camera":{"fov":45,"distMax":50,"radius":18,"elevationAngle":60,"elevationMin":0}},{"name":"skin2d","title":"2D Classic","3d":false,"preload":["image|/res/images/cancel.png","image|/res/images/whitebg.png","image|/res/images/wikipedia.png"]}],"animateSelfMoves":false,"switchable":true,"sounds":{"move1":"alq_move1","move2":"alq_move2","move3":"alq_move3","move4":"alq_move2","tac1":"alq_tac1","tac2":"alq_tac2","tac3":"alq_tac1","promo":"promo","usermove":null},"js":["base-view.js","grid-board-view.js","staunton-set-view.js","romanchenko-view.js"],"visuals":{"600x600":["res/visuals/romanchenko-600x600-3d.jpg","res/visuals/romanchenko-600x600-2d.jpg"]}}}

/***/ }),

/***/ "HWPX":
/***/ (function(module, exports) {

exports.config = {"status":true,"model":{"plazza":"true","released":1398178573,"title-en":"Malett Chess","module":"chessbase","summary":"5x5 chess variant by Jeff Malett","thumbnail":"malett-thumb.png","rules":{"en":"malett-rules.html"},"credits":{"en":"malett-credits.html"},"gameOptions":{"preventRepeat":true,"uctTransposition":"state","uctIgnoreLoop":false,"levelOptions":{"pieceValueFactor":1,"pieceValueRatioFactor":1,"posValueFactor":0.1,"averageDistKingFactor":-0.01,"castleFactor":0.1,"minorPiecesMovedFactor":0.1,"checkFactor":0.2,"endingKingFreedomFactor":0.01,"endingDistKingFactor":0.05,"distKingCornerFactor":0.1}},"obsolete":false,"js":["base-model.js","grid-geo-model.js","malett-model.js"],"levels":[{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"easy","label":"Easy","maxNodes":1000},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"fast","label":"Fast [1sec]","maxDuration":1,"isDefault":true},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"medium","label":"Medium","maxNodes":10000,"maxDuration":10},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"strong","label":"Strong","maxNodes":20000,"maxDuration":15}],"description":{"en":"malett-description.html"}},"view":{"title-en":"Chessbase view","module":"chessbase","xdView":true,"css":["chessbase.css"],"preferredRatio":1,"useShowMoves":true,"useNotation":true,"useAutoComplete":true,"defaultOptions":{"sounds":true,"moves":true,"notation":false,"autocomplete":false},"skins":[{"name":"skin3d","title":"3D Classic","3d":true,"preload":["smoothedfilegeo|0|/res/ring-target.js","image|/res/images/cancel.png","image|/res/images/wikipedia.png","smoothedfilegeo|0|/res/staunton/pawn/pawn-classic.js","image|/res/staunton/pawn/pawn-diffusemap.jpg","image|/res/staunton/pawn/pawn-normalmap.jpg","smoothedfilegeo|0|/res/staunton/knight/knight.js","image|/res/staunton/knight/knight-diffusemap.jpg","image|/res/staunton/knight/knight-normalmap.jpg","smoothedfilegeo|0|/res/staunton/bishop/bishop.js","image|/res/staunton/bishop/bishop-diffusemap.jpg","image|/res/staunton/bishop/bishop-normalmap.jpg","smoothedfilegeo|0|/res/staunton/rook/rook.js","image|/res/staunton/rook/rook-diffusemap.jpg","image|/res/staunton/rook/rook-normalmap.jpg","smoothedfilegeo|0|/res/staunton/queen/queen.js","image|/res/staunton/queen/queen-diffusemap.jpg","image|/res/staunton/queen/queen-normalmap.jpg","smoothedfilegeo|0|/res/staunton/king/king.js","image|/res/staunton/king/king-diffusemap.jpg","image|/res/staunton/king/king-normalmap.jpg"],"world":{"lightIntensity":1.3,"skyLightIntensity":1.2,"lightCastShadow":true,"fog":false,"color":4686804,"lightPosition":{"x":-9,"y":9,"z":9},"skyLightPosition":{"x":9,"y":9,"z":9},"lightShadowDarkness":0.55,"ambientLightColor":2236962},"camera":{"fov":45,"distMax":50,"radius":18,"elevationAngle":60,"elevationMin":0}},{"name":"skin2d","title":"2D Classic","3d":false,"preload":["image|/res/images/cancel.png","image|/res/images/whitebg.png","image|/res/images/wikipedia.png"]}],"animateSelfMoves":false,"switchable":true,"sounds":{"move1":"alq_move1","move2":"alq_move2","move3":"alq_move3","move4":"alq_move2","tac1":"alq_tac1","tac2":"alq_tac2","tac3":"alq_tac1","promo":"promo","usermove":null},"js":["base-view.js","grid-board-view.js","staunton-set-view.js","malett-view.js"],"visuals":{"600x600":["res/visuals/malett-600x600-3d.jpg","res/visuals/malett-600x600-2d.jpg"]}}}

/***/ }),

/***/ "HZzI":
/***/ (function(module, exports, __webpack_require__) {

var
    symbols = __webpack_require__("bgfr"),
    DraughtBoard = __webpack_require__("ks7d"),
    Arbiter = __webpack_require__("AHvx"),
    Color = symbols.Color
;

function Game(boardSize) {
    this.board = new DraughtBoard(boardSize);
    this.moves = []; // [Move]
    this.index = -1;
}

Game.prototype.hasMove = function() {
    return (this.moves.length > 0);
};

/**
 * Définition des mouvements
 *
 * @param startNum
 *            Numéro de la case de départ (REQUIS)
 * @param endNum
 *            Numéro de la case d'arrivée (REQUIS)
 * @param middleSquaresNum
 *            Liste des cases intermédiaires (Facultatif)
 */
Game.prototype.addMove = function(startNum, endNum, middleSquaresNum) {
    middleSquaresNum = middleSquaresNum ? middleSquaresNum : null;

    if (!this._hasError()) {

        // Positionner le damier
        this.end();

        // Remember previous color played.
        var iLast = this._getLastIndex();
        var previousColorPlayed = null;
        if (iLast > -1){
            previousColorPlayed = this.moves[iLast].color;
        }

        var m = Arbiter.getMove(this.board, startNum, endNum, middleSquaresNum, previousColorPlayed);

        this.moves.push(m);
    } else {
        console.log("addMove(" + startNum + ", " + endNum + ") : ERROR");
    }
    return this;
};



/**
 * Exemples : <br />
 * Prise : 24x22 ou 24x33x22 ou 24x13x...x22 <br />
 * Déplacement : 24-29
 * */
Game.prototype.addMoveTxt = function(move) {
    if (move != null) {

        move = move.toLowerCase();
        move = move.replace(" ", "");

        var sep = "";
        if (move.indexOf("-") > -1) {
            sep = "-";
        } else if (move.indexOf("x") > -1) {
            sep = "x";
        }

        if (sep != "") {
            var list = move.split(sep);
            var nb = list.length;
            if (nb > 1) {
                var error = false;
                var iStart = parseInt(list[0], 10);
                var iEnd = parseInt(list[nb - 1], 10);
                var iInters = [];

                if (iStart === null || iEnd === null) {
                    error = true;
                } else {
                    if (nb > 2) {
                        for (var i = 1; i <= nb - 2; i++) {
                            var inter = parseInt(list[i], 10);
                            if (inter != null) {
                                iInters.push(inter);
                            } else {
                                error = true;
                            }
                        }
                    }
                }
                if (!error) {
                    this.addMove(iStart, iEnd, iInters);
                } else {
                    console.log("addMove: ERREUR (4)");
                }

            } else {
                console.log("addMove: ERREUR (3)");
            }
        } else {
            console.log("addMove: ERREUR (2)");
        }

    } else {
        console.log("addMove: ERREUR (1)");
    }
    return this;
};

Game.prototype._getStatusNextIndex = function() {
    var status = true;
    if (this.index < this._getLastIndex()) {
        var m = this.moves[this.index + 1];
        status = m.status;
    }
    return status;
};

Game.prototype._getStatusPrevIndex = function() {
    var status = true;
    if (this.index > 0) {
        var m = this.moves[this.index - 1];
        status = m.status;
    }
    return status;
};

Game.prototype.hasNext = function() {
    return this._getStatusNextIndex() && this.index < this._getLastIndex();
};

Game.prototype.hasPrev = function() {
    return this._getStatusPrevIndex() && this.index > -1;
};

Game.prototype.getCurrentMove = function() {
    var m = null;
    if (this.index > -1){
        m = this.moves[this.index];
    }
    return m;
};

Game.prototype.getNextMove = function() {
    var m = null;
    if (this.hasNext()) {
        m = this.moves[this.index + 1];
    }
    return m;
};

Game.prototype.getPrevMove = function() {
    var m = null;
    if (this.hasPrev()) {
        m = this.moves[this.index - 1];
    }
    return m;
};

Game.prototype.next = function() {
    var isOk = true;
    if (isOk = this.hasNext()) {
        this.index++;
        var m = this.moves[this.index];
        if (m.status) {
            this.board.applyMove(m);
        } else {
            this.index--;
        }
    }
    return isOk;
};

Game.prototype.prev = function() {
    var isOk = true;
    if (isOk = this.hasPrev()) {
        var m = this.moves[this.index];
        if (m.status) {
            this.board.applyMoveRev(m);
            this.index--;
        }
    }
    return isOk;
}

Game.prototype.start = function() {
    this._setIndex(-1);
    return this;
};

Game.prototype.end = function() {
    this._setIndex(this._getLastIndex());
    return this;
};

/** Position initiale = 0 ; Premier coup = 1. */
Game.prototype.setCursor = function(position) {
    this._setIndex(position - 1);
    return this;
};

/** Position initiale = -1 ; premier coup = 0 */
Game.prototype._setIndex = function(idx) {
    idx = this._constrainIndex(idx);

    var isOk = true;
    if (this.index < idx) {
        while (isOk && (this.index < idx)) {
            isOk = this.next();
        }
    } else if (this.index > idx) {
        while (isOk && (this.index > idx)) {
            isOk = this.prev();
        }
    }
    return this;
};

Game.prototype._getLastIndex = function() {
    return this.moves.length - 1;
};

Game.prototype._constrainIndex = function(idx) {
    if (idx < 0) {
        idx = -1;
    } else if (idx > this._getLastIndex()) {
        idx = this._getLastIndex();
    }

    return idx;
};

Game.prototype._hasError = function() {
    var err = false;
    for (var k = 0; k < this.moves.length; k++) {
        var m = this.moves[k];
        if (!m.status) {
            err = true;
            break;
        }
    }
    return err;
};


// [{'number':1,
//   'white':{'move':'32x26', 'current':false},
//   'black':{'move':'32x26', 'current':false}}]
Game.prototype.getNotation = function(){
    var list = [];

    if (this.moves.length > 0){

        // is first move a black move ?
        var m = this.moves[0];
        var notation = m.getNotation();
        var shift = 0;
        if (m.color == Color.BLACK){
            var mapb = {};
            mapb['position'] = 1;
            mapb['move'] = notation;
            mapb['current'] = (0 == this.index);

            var map = {};
            map['black'] = mapb;
            map['number'] = 1;
            list.push(map);
            shift = 1;
        }

        var map = null;
        for (var k = 0 + shift; k < this.moves.length; k++) {
            var m = this.moves[k];
            var notation = m.getNotation();
            var cpt = ~~((k + shift)/2) + 1; // 1, 1, 2, 2, 3, 3

            if (m.color == Color.WHITE){
                mapw = {};
                mapw['position'] = k + 1;
                mapw['move'] = notation;
                mapw['current'] = (k == this.index);

                map = {};
                map['number'] = cpt;
                map['white'] = mapw;
            } else if (m.color == Color.BLACK){
                mapb = {};
                mapb['position'] = k + 1;
                mapb['move'] = notation;
                mapb['current'] = (k == this.index);
                map['black'] = mapb;

                list.push(map);
                map = null; // see after loop
            }
        }

        // is last move a white move ?
        if (map !== null){
            list.push(map);
        }
    }

    return list;
}


Game.prototype.debug = function() {
    console.log("Etat courant de la partie :");

    var s = "";
    for (var k = 0; k < this.moves.length; k++) {
        var m = this.moves[k];
        if (k == this.index) {
            s += "[" + m.getNotation() + "] ; ";
        } else {
            s += m.getNotation() + " ; ";
        }
    }
    console.log(s);
    this.board.debugDraughtBoard();
    console.log("");
};

Game.prototype.debugFull = function() {
    this.start();
    this.debug();

    while (this.hasNext()) {
        this.next();
        this.debug();
    }
};

module.exports = Game;


/***/ }),

/***/ "Ha1/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Subscriber__ = __webpack_require__("mmVS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Subscriber___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs_Subscriber__);
/* unused harmony export leaveZone */
/* unused harmony export LeaveZoneOperator */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

function leaveZone(zone) {
    return this.lift(new LeaveZoneOperator(zone));
}
var LeaveZoneOperator = (function () {
    function LeaveZoneOperator(_zone) {
        this._zone = _zone;
    }
    LeaveZoneOperator.prototype.call = function (subscriber, source) {
        return source._subscribe(new LeaveZoneSubscriber(subscriber, this._zone));
    };
    return LeaveZoneOperator;
}());
var LeaveZoneSubscriber = (function (_super) {
    __extends(LeaveZoneSubscriber, _super);
    function LeaveZoneSubscriber(destination, _zone) {
        _super.call(this, destination);
        this._zone = _zone;
    }
    LeaveZoneSubscriber.prototype._next = function (value) {
        var _this = this;
        this._zone.runOutsideAngular(function () { return _this.destination.next(value); });
    };
    return LeaveZoneSubscriber;
}(__WEBPACK_IMPORTED_MODULE_0_rxjs_Subscriber__["Subscriber"]));
//# sourceMappingURL=leaveZone.js.map

/***/ }),

/***/ "HbHJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("3j3K");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LogMonitorButtonComponent; });

var LogMonitorButtonComponent = (function () {
    function LogMonitorButtonComponent() {
        this.action = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
    }
    LogMonitorButtonComponent.prototype.handleAction = function ($event) {
        if (!this.disabled) {
            this.action.next({});
        }
        $event.stopPropagation();
        return false;
    };
    LogMonitorButtonComponent.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{
                    selector: 'log-monitor-button',
                    template: "\n    <ng-content></ng-content>\n  ",
                    styles: ["\n    :host{\n      flex-grow: 1;\n      display: inline-block;\n      font-family: 'monaco', 'Consolas', 'Lucida Console', monospace;\n      cursor: pointer;\n      font-weight: bold;\n      border-radius: 3px;\n      padding: 4px 8px;\n      margin: 5px 3px 5px 3px;\n      font-size: 0.8em;\n      color: white;\n      text-decoration: none;\n      background-color: #4F5A65;\n    }\n\n    :host.disabled{\n      opacity: 0.2;\n      cursor: text;\n      background-color: transparent;\n    }\n  "]
                },] },
    ];
    /** @nocollapse */
    LogMonitorButtonComponent.ctorParameters = [];
    LogMonitorButtonComponent.propDecorators = {
        'disabled': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["HostBinding"], args: ['class.disabled',] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'action': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
        'handleAction': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["HostListener"], args: ['click', ['$event'],] },],
    };
    return LogMonitorButtonComponent;
}());
//# sourceMappingURL=log-monitor-button.js.map

/***/ }),

/***/ "HcJ8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var mergeMap_1 = __webpack_require__("XO5T");
Observable_1.Observable.prototype.mergeMap = mergeMap_1.mergeMap;
Observable_1.Observable.prototype.flatMap = mergeMap_1.mergeMap;
//# sourceMappingURL=mergeMap.js.map

/***/ }),

/***/ "Hp9E":
/***/ (function(module, exports) {

exports.model=Model={Game:{},Board:{},Move:{}},Model.Game.InitGame=function(){for(var t=this.mOptions.width,i=this.mOptions.height,s=this.mOptions.lines,o=[[-1,-1],[0,-1],[1,-1],[-1,0]],h=[],e=0;e<i;e++)for(var r=0;r<t;r++)for(var n=0;n<o.length;n++){var l,a=o[n][0],p=o[n][1],d=[];for(l=0;l<s;l++){var u;if(u=this.mOptions.torus?(e+p*l)*t+(r+a*l+t)%t:(e+p*l)*t+r+a*l,this.mOptions.torus&&(e+p*l<0||e+p*l>=i))break;if(!this.mOptions.torus&&(r+a*l<0||r+a*l>=t||e+p*l<0||e+p*l>=i))break;d.push(u)}l==s&&h.push(d)}this.g.TuplesList=h;for(var m={},l=0;l<h.length;l++)for(var d=h[l],v=0;v<d.length;v++){var u=d[v];void 0===m[u]&&(m[u]=[]),m[u].push(d)}this.g.Tuples=m,this.zobrist=new JocGame.Zobrist({board:{type:"array",size:this.mOptions.width*this.mOptions.height,values:["1","-1"]}})},Model.Move.Init=function(t){this.op=t.op,this.col=t.col},Model.Move.CopyFrom=function(t){this.Init(t)},Model.Move.ToString=function(){var t="";switch(this.op){case"+":t+="+";break;case"-":t+="-";break;default:t+="?"}return t+=String.fromCharCode(65+this.col)},Model.Board.Init=function(t){this.zSign=0},Model.Board.InitialPosition=function(t){this.board=[];for(var i=t.mOptions.width,s=t.mOptions.height,o=0;o<s;o++)for(var h=0;h<i;h++)this.board.push(0);this.tuples={};for(var e=1;e<=t.mOptions.lines;e++)this.tuples[e]=0,this.tuples[-e]=0;this.cols=[];for(var h=0;h<i;h++)this.cols.push(0);if(t.mOptions.fillSides)for(var e=0;e<s;e++){var r=e*i,n=e%2?-1:1,l=0;this.board[r]=n,this.cols[l]++,this.tuples[n]++,this.zSign=t.zobrist.update(this.zSign,"board",n,r);var r=e*i+i-1,n=e%2?1:-1,l=i-1;this.board[r]=n,this.cols[l]++,this.tuples[n]++,this.zSign=t.zobrist.update(this.zSign,"board",n,r)}},Model.Board.GenerateMoves=function(t){for(var i=[],s=t.mOptions.height,o=0;o<t.mOptions.width;o++)this.cols[o]<s&&i.push({op:"+",col:o});if(t.mOptions.remove)for(var o=0;o<t.mOptions.width;o++)this.board[o]==this.mWho&&i.push({op:"-",col:o});this.mMoves=i,0==i.length&&(this.mFinished=!0,this.mWinner=JocGame.DRAW)},Model.Board.Evaluate=function(t){if(this.mEvaluation=0,this.mWinner=0,t.mOptions.preventRepeat&&t.GetRepeatOccurence(this)>2)return this.mFinished=!0,void(this.mWinner=JocGame.DRAW);if(this.tuples[t.mOptions.lines]>0&&(this.mFinished=!0,this.mWinner=1),this.tuples[-t.mOptions.lines]>0)return this.mFinished=!0,void(this.mWinner?this.mWinner=JocGame.DRAW:this.mWinner=-1);if(!this.mFinished)for(var i=t.mOptions.levelOptions,s=1;s<t.mOptions.lines;s++)this.mEvaluation+=this.tuples[s]*i["evalTuple"+s],this.mEvaluation-=this.tuples[-s]*i["evalTuple"+s]},Model.Board.ApplyMove=function(t,i){if("+"==i.op){for(var s=i.col,o=this.cols[s],h=o*t.mOptions.width+s,e=0;e<t.g.Tuples[h].length;e++){for(var r=t.g.Tuples[h][e],n={1:0,0:0,"-1":0},l=0;l<r.length;l++)n[this.board[r[l]]]++;n[1]>0&&0==n[-1]?this.tuples[n[1]]--:n[-1]>0&&0==n[1]&&this.tuples[-n[-1]]--,n[this.mWho]++,n[1]>0&&0==n[-1]?this.tuples[n[1]]++:n[-1]>0&&0==n[1]&&this.tuples[-n[-1]]++}this.board[h]=this.mWho,this.cols[s]++,this.zSign=t.zobrist.update(this.zSign,"board",this.mWho,h)}else if("-"==i.op){for(var o=0;o<this.cols[i.col];o++)for(var h=o*t.mOptions.width+i.col,e=0;e<t.g.Tuples[h].length;e++){for(var r=t.g.Tuples[h][e],n={1:0,0:0,"-1":0},l=0;l<r.length;l++)n[this.board[r[l]]]++;n[1]>0&&0==n[-1]?this.tuples[n[1]]--:n[-1]>0&&0==n[1]&&this.tuples[-n[-1]]--}for(var e=0;e<this.cols[i.col];e++){var h=e*t.mOptions.width+i.col,a=h+t.mOptions.width,p=0;a<this.board.length&&(p=this.board[a]),this.zSign=t.zobrist.update(this.zSign,"board",this.board[h],h),p&&(this.zSign=t.zobrist.update(this.zSign,"board",p,h)),this.board[h]=p}this.cols[i.col]--;for(var o=0;o<this.cols[i.col];o++)for(var h=o*t.mOptions.width+i.col,e=0;e<t.g.Tuples[h].length;e++){for(var r=t.g.Tuples[h][e],n={1:0,0:0,"-1":0},l=0;l<r.length;l++)n[this.board[r[l]]]++;n[1]>0&&0==n[-1]?this.tuples[n[1]]++:n[-1]>0&&0==n[1]&&this.tuples[-n[-1]]++}}else console.error("Invalid move",i)},Model.Board.CopyFrom=function(t){this.tuples={};for(var i in t.tuples)this.tuples[i]=t.tuples[i];this.board=[];for(var s=0;s<t.board.length;s++)this.board.push(t.board[s]);this.cols=[];for(var o=0;o<t.cols.length;o++)this.cols.push(t.cols[o]);this.mWho=t.mWho,this.zSign=t.zSign},Model.Board.GetSignature=function(){return this.zSign};

/***/ }),

/***/ "HwIK":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var AnimationFrameAction_1 = __webpack_require__("gi2R");
var AnimationFrameScheduler_1 = __webpack_require__("ww7A");
/**
 *
 * Animation Frame Scheduler
 *
 * <span class="informal">Perform task when `window.requestAnimationFrame` would fire</span>
 *
 * When `animationFrame` scheduler is used with delay, it will fall back to {@link async} scheduler
 * behaviour.
 *
 * Without delay, `animationFrame` scheduler can be used to create smooth browser animations.
 * It makes sure scheduled task will happen just before next browser content repaint,
 * thus performing animations as efficiently as possible.
 *
 * @example <caption>Schedule div height animation</caption>
 * const div = document.querySelector('.some-div');
 *
 * Rx.Scheduler.schedule(function(height) {
 *   div.style.height = height + "px";
 *
 *   this.schedule(height + 1);  // `this` references currently executing Action,
 *                               // which we reschedule with new state
 * }, 0, 0);
 *
 * // You will see .some-div element growing in height
 *
 *
 * @static true
 * @name animationFrame
 * @owner Scheduler
 */
exports.animationFrame = new AnimationFrameScheduler_1.AnimationFrameScheduler(AnimationFrameAction_1.AnimationFrameAction);
//# sourceMappingURL=animationFrame.js.map

/***/ }),

/***/ "I4Dk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export compose */
var compose = function () {
    var functions = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        functions[_i - 0] = arguments[_i];
    }
    return function (arg) {
        if (functions.length === 0) {
            return arg;
        }
        var last = functions[functions.length - 1];
        var rest = functions.slice(0, -1);
        return rest.reduceRight(function (composed, fn) { return fn(composed); }, last(arg));
    };
};
//# sourceMappingURL=compose.js.map

/***/ }),

/***/ "IBkQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subject_1 = __webpack_require__("EEr4");
var Subscription_1 = __webpack_require__("B00U");
var SubscriptionLoggable_1 = __webpack_require__("y9a2");
var applyMixins_1 = __webpack_require__("g28B");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var HotObservable = (function (_super) {
    __extends(HotObservable, _super);
    function HotObservable(messages, scheduler) {
        _super.call(this);
        this.messages = messages;
        this.subscriptions = [];
        this.scheduler = scheduler;
    }
    HotObservable.prototype._subscribe = function (subscriber) {
        var subject = this;
        var index = subject.logSubscribedFrame();
        subscriber.add(new Subscription_1.Subscription(function () {
            subject.logUnsubscribedFrame(index);
        }));
        return _super.prototype._subscribe.call(this, subscriber);
    };
    HotObservable.prototype.setup = function () {
        var subject = this;
        var messagesLength = subject.messages.length;
        /* tslint:disable:no-var-keyword */
        for (var i = 0; i < messagesLength; i++) {
            (function () {
                var message = subject.messages[i];
                /* tslint:enable */
                subject.scheduler.schedule(function () { message.notification.observe(subject); }, message.frame);
            })();
        }
    };
    return HotObservable;
}(Subject_1.Subject));
exports.HotObservable = HotObservable;
applyMixins_1.applyMixins(HotObservable, [SubscriptionLoggable_1.SubscriptionLoggable]);
//# sourceMappingURL=HotObservable.js.map

/***/ }),

/***/ "ICpg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function isObject(x) {
    return x != null && typeof x === 'object';
}
exports.isObject = isObject;
//# sourceMappingURL=isObject.js.map

/***/ }),

/***/ "IZVw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * An error thrown when an action is invalid because the object has been
 * unsubscribed.
 *
 * @see {@link Subject}
 * @see {@link BehaviorSubject}
 *
 * @class ObjectUnsubscribedError
 */
var ObjectUnsubscribedError = (function (_super) {
    __extends(ObjectUnsubscribedError, _super);
    function ObjectUnsubscribedError() {
        var err = _super.call(this, 'object unsubscribed');
        this.name = err.name = 'ObjectUnsubscribedError';
        this.stack = err.stack;
        this.message = err.message;
    }
    return ObjectUnsubscribedError;
}(Error));
exports.ObjectUnsubscribedError = ObjectUnsubscribedError;
//# sourceMappingURL=ObjectUnsubscribedError.js.map

/***/ }),

/***/ "IfEN":
/***/ (function(module, exports) {

exports.model=Model={Game:{},Board:{},Move:{}},function(){var t;Model.Game.cbConstants={MASK:65535,FLAG_MOVE:65536,FLAG_CAPTURE:131072,FLAG_STOP:262144,FLAG_SCREEN_CAPTURE:524288,FLAG_CAPTURE_KING:1048576,FLAG_CAPTURE_NO_KING:2097152};var e="undefined"!=typeof Int32Array;Model.Game.cbUseTypedArrays=e,Model.Game.cbTypedArray=function(t){if(e){var r=new Int32Array(t.length);return r.set(t),r}for(var i=[],a=t.length,n=0;n<a;n++)i.push(t[n]);return i},Model.Game.cbShortRangeGraph=function(t,e,r,i){var a=this;void 0===i&&(i=196608);for(var n={},s=0;s<t.boardSize;s++)n[s]=[],(!r||s in r)&&e.forEach(function(e){var o=t.Graph(s,e);null!=o&&(!r||o in r)&&n[s].push(a.cbTypedArray([o|i]))});return n},Model.Game.cbLongRangeGraph=function(t,e,r,i,a){var n=this;void 0!==i&&null!=i||(i=196608),a||(a=1/0);for(var s={},o=0;o<t.boardSize;o++)s[o]=[],(!r||o in r)&&e.forEach(function(e){for(var h=[],c=t.Graph(o,e),p=0;null!=c&&(!r||c in r)&&(h.push(c|i),++p!=a);)c=t.Graph(c,e);h.length>0&&s[o].push(n.cbTypedArray(h))});return s},Model.Game.cbNullGraph=function(t){for(var e={},r=0;r<t.boardSize;r++)e[r]=[];return e},Model.Game.cbAuthorGraph=function(t){for(var e={},r=0;r<t.boardSize;r++){e[r]=[];for(var i=0;i<t.boardSize;i++)e[r].push([2293760|i])}return e},Model.Game.cbMergeGraphs=function(t){for(var e=[],r=0;r<t.boardSize;r++){e[r]=[];for(var i=1;i<arguments.length;i++)e[r]=e[r].concat(arguments[i][r])}return e},Model.Game.cbGetThreatGraph=function(){function t(e,r){for(var i in s){var a=s[i];if(!(a.p.length<r.length+1)){for(var n=!0,o=0;o<r.length;o++)if(r[o]!=a.p[o]){n=!1;break}if(n){var h=a.p[r.length],c=e[h];void 0===c&&(c={e:{}},e[h]=c),a.p.length==r.length+1&&(c.t=a.t,c.ts=a.ts,c.tk=a.tk,delete s[i]),r.push(h),t(c.e,r),r.pop()}}}}var e=this;this.cbUseScreenCapture=!1,this.cbUseCaptureKing=!1,this.cbUseCaptureNoKing=!1;for(var r={1:[],"-1":[]},i=[],a=0;a<this.g.boardSize;a++)this.g.pTypes.forEach(function(t,r){t.graph[a].forEach(function(t){for(var n=[],s=0;s<t.length;s++){var o=t[s];1048576&o?(e.cbUseCaptureKing=!0,n.unshift({d:65535&o,a:a,tk:r})):2097152&o?(e.cbUseCaptureNoKing=!0,n.unshift({d:65535&o,a:a,tnk:r})):131072&o?n.unshift({d:65535&o,a:a,t:r}):262144&o?n.unshift({d:65535&o,a:a}):524288&o&&(e.cbUseScreenCapture=!0,n.unshift({d:65535&o,a:a,ts:r}))}n.length>0&&i.push(n)})});var n={};i.forEach(function(t){t.forEach(function(e,r){var i=n[e.d];void 0===i&&(i={},n[e.d]=i);for(var a=[],s=r+1;s<t.length;s++)a.push(t[s].d);a.push(e.a);var o=a.join(","),h=i[o];void 0===h&&(h={p:a,t:{},ts:{},tk:{}},i[o]=h),void 0!==e.t?h.t[e.t]=!0:void 0!==e.tk?h.tk[e.tk]=!0:void 0!==e.ts&&(h.ts[e.ts]=!0)})});for(var a=0;a<e.g.boardSize;a++){var s=n[a],o={};t(o,[]),r[1][a]=o,r[-1][a]=o}return r},Model.Game.InitGame=function(){var e=this;this.cbVar=t=this.cbDefine(),this.g.boardSize=this.cbVar.geometry.boardSize,this.g.pTypes=this.cbGetPieceTypes(),this.g.threatGraph=this.cbGetThreatGraph(),this.g.distGraph=this.cbVar.geometry.GetDistances(),this.cbPiecesCount=0,this.g.castleablePiecesCount={1:0,"-1":0};for(var r in t.pieceTypes){var i=t.pieceTypes[r];if(i.castle){(i.initial||[]).forEach(function(t){e.g.castleablePiecesCount[t.s]++})}i.initial&&(this.cbPiecesCount+=i.initial.length)}for(var a=[],r=0;r<this.cbPiecesCount;r++)a.push(r);var n=Object.keys(t.pieceTypes);this.zobrist=new JocGame.Zobrist({board:{type:"array",size:this.cbVar.geometry.boardSize,values:a},who:{values:["1","-1"]},type:{type:"array",size:this.cbPiecesCount,values:n}})},Model.Game.cbGetPieceTypes=function(){for(var t=[],e={},r=0;r<this.cbVar.geometry.boardSize;r++)e[r]=[];for(var i in this.cbVar.pieceTypes){var a=this.cbVar.pieceTypes[i];t[i]={graph:a.graph||e,abbrev:a.abbrev||"",value:a.isKing?100:a.value||1,isKing:!!a.isKing,castle:!!a.castle,epTarget:!!a.epTarget,epCatch:!!a.epCatch}}return t},Model.Board.Init=function(t){this.zSign=0},Model.Board.InitialPosition=function(r){var i=this;this.board=e?new Int16Array(r.g.boardSize):[];for(var a=0;a<r.g.boardSize;a++)this.board[a]=-1;if(this.kings={},this.pieces=[],this.ending={1:!1,"-1":!1},this.lastMove=null,r.cbVar.castle&&(this.castled={1:!1,"-1":!1}),this.zSign=r.zobrist.update(0,"who",-1),this.noCaptCount=0,this.mWho=1,r.mInitial)this.mWho=r.mInitial.turn||1,r.mInitial.pieces.forEach(function(t){var e={};for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);i.pieces.push(e)}),r.mInitial.lastMove&&(this.lastMove={f:r.mInitial.lastMove.f,t:r.mInitial.lastMove.t}),void 0!==r.mInitial.noCaptCount&&(this.noCaptCount=r.mInitial.noCaptCount),r.cbVar.castle&&r.mInitial.castle&&(this.castled={1:{k:!!r.mInitial.castle[1]&&!!r.mInitial.castle[1].k,q:!!r.mInitial.castle[1]&&!!r.mInitial.castle[1].q},"-1":{k:!!r.mInitial.castle[-1]&&!!r.mInitial.castle[-1].k,q:!!r.mInitial.castle[-1]&&!!r.mInitial.castle[-1].q}});else for(var n in r.cbVar.pieceTypes)for(var s=r.cbVar.pieceTypes[n],o=s.initial||[],h=0;h<o.length;h++){var c=o[h],p={s:c.s,t:parseInt(n),p:c.p,m:!1};this.pieces.push(p)}if(this.pieces.sort(function(t,e){if(t.s!=e.s)return e.s-t.s;var i=r.cbVar.pieceTypes[t.t].value||100,a=r.cbVar.pieceTypes[e.t].value||100;return i!=a?i-a:t.p-e.p}),this.pieces.forEach(function(t,e){t.i=e,i.board[t.p]=e,r.g.pTypes[t.t].isKing&&(i.kings[t.s]=t.p),i.zSign=r.zobrist.update(i.zSign,"board",e,t.p),i.zSign=r.zobrist.update(i.zSign,"type",t.t,e)}),r.mInitial&&r.mInitial.enPassant){var a=t.geometry.PosByName(r.mInitial.enPassant);if(a>=0){var l,u=t.geometry.C(a),v=t.geometry.R(a);l=1==r.mInitial.turn?t.geometry.POS(u,v-1):t.geometry.POS(u,v+1),this.epTarget={p:a,i:this.board[l]}}}},Model.Board.CopyFrom=function(t){if(e)this.board=new Int16Array(t.board.length),this.board.set(t.board);else{this.board=[];for(var r=t.board,i=r.length,a=0;a<i;a++)this.board.push(r[a])}this.pieces=[];for(var n=t.pieces.length,a=0;a<n;a++){var s=t.pieces[a];this.pieces.push({s:s.s,p:s.p,t:s.t,i:s.i,m:s.m})}this.kings={1:t.kings[1],"-1":t.kings[-1]},this.check=t.check,t.lastMove?this.lastMove={f:t.lastMove.f,t:t.lastMove.t,c:t.lastMove.c}:this.lastMove=null,this.ending={1:t.ending[1],"-1":t.ending[-1]},void 0!==t.castled&&(this.castled={1:t.castled[1],"-1":t.castled[-1]}),this.noCaptCount=t.noCaptCount,t.epTarget?this.epTarget={p:t.epTarget.p,i:t.epTarget.i}:this.epTarget=null,this.mWho=t.mWho,this.zSign=t.zSign},Model.Board.cbApplyCastle=function(t,e,r){var i=t.cbVar.castle[e.f+"/"+e.cg],a=i.r[i.r.length-1],n=this.pieces[this.board[e.cg]],s=i.k[i.k.length-1],o=this.pieces[this.board[e.f]];return r&&(this.zSign=t.zobrist.update(this.zSign,"board",n.i,e.cg),this.zSign=t.zobrist.update(this.zSign,"board",n.i,a),this.zSign=t.zobrist.update(this.zSign,"board",o.i,e.f),this.zSign=t.zobrist.update(this.zSign,"board",o.i,s)),n.p=a,n.m=!0,this.board[e.cg]=-1,o.p=s,o.m=!0,this.board[e.f]=-1,this.board[a]=n.i,this.board[s]=o.i,this.castled[n.s]=!0,this.kings[o.s]=s,[{i:n.i,f:a,t:-1},{i:o.i,f:s,t:e.f,kp:e.f,who:o.s,m:!1},{i:n.i,f:-1,t:e.cg,m:!1,cg:!1}]},Model.Board.cbQuickApply=function(t,e){if(void 0!==e.cg)return this.cbApplyCastle(t,e,!1);var r=[],i=this.board[e.f],a=this.pieces[i];if(null!=e.c){r.unshift({i:e.c,f:-1,t:this.pieces[e.c].p});var n=this.pieces[e.c];this.board[n.p]=-1,n.p=-1}var s=this.kings[a.s];return t.g.pTypes[a.t].isKing&&(this.kings[a.s]=e.t),r.unshift({i:i,f:e.t,t:e.f,kp:s,who:a.s,ty:a.t}),a.p=e.t,void 0!==e.pr&&(a.t=e.pr),this.board[e.f]=-1,this.board[e.t]=i,r},Model.Board.cbQuickUnapply=function(t,e){for(var r=0;r<e.length;r++){var i=e[r],a=this.pieces[i.i];i.f>=0&&(a.p=-1,this.board[i.f]=-1),i.t>=0&&(a.p=i.t,this.board[i.t]=i.i),void 0!==i.m&&(a.m=i.m),void 0!==i.kp&&(this.kings[i.who]=i.kp),void 0!=i.ty&&(a.t=i.ty),void 0!=i.cg&&(this.castled[a.s]=i.cg)}},Model.Board.ApplyMove=function(t,e){var r=this.pieces[this.board[e.f]];if(void 0!==e.cg)this.cbApplyCastle(t,e,!0);else{if(this.zSign=t.zobrist.update(this.zSign,"board",r.i,e.f),this.board[r.p]=-1,void 0!==e.pr&&(this.zSign=t.zobrist.update(this.zSign,"type",r.t,r.i),r.t=e.pr,this.zSign=t.zobrist.update(this.zSign,"type",r.t,r.i)),null!=e.c){var i=this.pieces[e.c];this.zSign=t.zobrist.update(this.zSign,"board",i.i,i.p),this.board[i.p]=-1,i.p=-1,i.m=!0,this.noCaptCount=0}else this.noCaptCount++;r.p=e.t,r.m=!0,this.board[e.t]=r.i,this.zSign=t.zobrist.update(this.zSign,"board",r.i,e.t),t.g.pTypes[r.t].isKing&&(this.kings[r.s]=e.t)}this.check=!!e.ck,this.lastMove={f:e.f,t:e.t,c:e.c},void 0!==e.ko&&(this.ending[r.s]=e.ko),void 0!==e.ept?this.epTarget={p:e.ept,i:r.i}:this.epTarget=null,this.zSign=t.zobrist.update(this.zSign,"who",-this.mWho),this.zSign=t.zobrist.update(this.zSign,"who",this.mWho)},Model.Board.Evaluate=function(r){function i(e){var r=1/0;for(var i in t.geometry.corners)r=Math.min(r,h.distGraph[n.kings[e]][i]);return r-Math.sqrt(h.boardSize)}var a="debug"==arguments[3],n=this;this.mEvaluation=0;var s,o=this.mWho,h=r.g;if(e)s={1:{count:new Uint8Array(h.pTypes.length),byType:{}},"-1":{count:new Uint8Array(h.pTypes.length),byType:{}}};else{s={1:{count:[],byType:{}},"-1":{count:[],byType:{}}};for(var c=0;c<h.pTypes.length;c++)s[1].count[c]=s[-1].count[c]=0}if(r.mOptions.preventRepeat&&r.GetRepeatOccurence(this)>2)return this.mFinished=!0,void(this.mWinner=r.cbOnPerpetual?o*r.cbOnPerpetual:JocGame.DRAW);for(var p={1:0,"-1":0},l={1:h.distGraph[this.kings[-1]],"-1":h.distGraph[this.kings[1]]},u={1:0,"-1":0},v={1:0,"-1":0},b={1:0,"-1":0},f={1:0,"-1":0},d={1:!1,"-1":!1},g=this.pieces,m=g.length,c=0;c<m;c++){var G=g[c];if(G.p>=0){var y=G.s,M=h.pTypes[G.t];M.isKing?d[y]=G.m:p[y]+=M.value,M.castle&&!G.m&&f[y]++,v[y]++,u[y]+=l[y][G.p],b[y]+=t.geometry.distEdge[G.p];var C=s[y];C.count[G.t]++;var S=C.byType;void 0===S[G.t]?S[G.t]=[G]:S[G.t].push(G)}}if(this.lastMove&&null!=this.lastMove.c){var G=this.pieces[this.board[this.lastMove.t]];p[-G.s]+=this.cbStaticExchangeEval(r,G.p,G.s,{piece:G})}var k={1:0,"-1":0},A={1:0,"-1":0},T={1:0,"-1":0};this.ending[1]&&(A[1]=(u[1]-Math.sqrt(h.boardSize))/v[1],t.geometry.corners&&(T[1]=i(1))),this.ending[-1]&&(A[-1]=(u[-1]-Math.sqrt(h.boardSize))/v[-1],t.geometry.corners&&(T[1]=i(-1)));var z={pieceValue:p[1]-p[-1],pieceValueRatio:(p[1]-p[-1])/(p[1]+p[-1]+1),posValue:b[1]-b[-1],averageDistKing:u[1]/v[1]-u[-1]/v[-1],check:this.check?-o:0,endingKingFreedom:k[1]-k[-1],endingDistKing:A[1]-A[-1],distKingCorner:T[1]-T[-1]};t.castle&&(z.castle=(this.castled[1]?1:d[1]?0:f[1]/(h.castleablePiecesCount[1]+1))-(this.castled[-1]?1:d[-1]?0:f[-1]/(h.castleablePiecesCount[-1]+1))),t.evaluate&&t.evaluate.call(this,r,z,s);var P=r.mOptions.levelOptions;for(var E in z){var w=z[E],R=P[E+"Factor"]||0,I=w*R;a&&console.log(E,"=",w,"*",R,"=>",I),this.mEvaluation+=I}a&&console.log("Evaluation",this.mEvaluation)},Model.Board.cbGeneratePseudoLegalMoves=function(t){function e(e,a){var n=t.cbVar.promote;if(!n)return void i.push(a);var s=n.call(r,t,e,a);if(null!=s)if(0==s.length)i.push(a);else if(1==s.length)a.pr=s[0],i.push(a);else for(var o=0;o<s.length;o++){var h=s[o];i.push({f:a.f,t:a.t,c:a.c,pr:h,ept:a.ept,ep:a.ep,a:a.a})}}for(var r=this,i=[],a=t.cbVar,n=this.mWho,s=!a.castle||this.check||this.castled[n]?null:[],o=-1,h=this.pieces.length,c=0;c<h;c++){var p=this.pieces[c];if(!(p.p<0||p.s!=n)){var l=t.g.pTypes[p.t];l.isKing&&(p.m?s=null:o=p),s&&l.castle&&!p.m&&s.push(p);var u,v;u=l.graph[p.p],v=u.length;for(var b=0;b<v;b++)for(var f=u[b],d=!1,g=f.length,m=null,G=0;G<g;G++){var y=f[G],M=65535&y,C=this.board[M];if(!(C<0)||l.epCatch&&this.epTarget&&this.epTarget.p==M){if(!(524288&y)){var S;S=C<0?this.pieces[this.epTarget.i]:this.pieces[C],!(S.s!=p.s&&131072&y)||1048576&y&&!t.g.pTypes[S.t].isKing||2097152&y&&t.g.pTypes[S.t].isKing||e(p,{f:p.p,t:M,c:S.i,a:l.abbrev,ep:C<0});break}if(d){var S=this.pieces[C];S.s!=p.s&&e(p,{f:p.p,t:M,c:S.i,a:l.abbrev});break}d=!0}else 65536&y&&0==d&&e(p,{f:p.p,t:M,c:null,a:l.abbrev,ept:null!=m&&l.epTarget?m:void 0});m=M}}}if(s)for(var c=0;c<s.length;c++){var k=s[c],A=t.cbVar.castle[o.p+"/"+k.p];if(A){for(var T=!0,b=0;b<A.r.length;b++){var z=A.r[b];if(this.board[z]>=0&&z!=o.p&&z!=k.p){T=!1;break}}if(T){for(var P=!0,b=0;b<A.k.length;b++){var z=A.k[b];if(this.board[z]>=0&&z!=k.p&&z!=o.p||this.cbGetAttackers(t,z,n).length>0){P=!1;break}}P&&i.push({f:o.p,t:A.k[A.k.length-1],c:null,cg:k.p})}}}return i},Model.Board.cbStaticExchangeEval=function(t,e,r,i){var a=0,n=this.cbGetSmallestAttacker(t,e,r);if(n){var s=this.mWho;this.mWho=n.s;var o=this.cbQuickApply(t,{f:n.p,t:e,c:i.piece.i}),h=t.g.pTypes[i.piece.t].value;i.piece=n,a=Math.max(0,h-this.cbStaticExchangeEval(t,e,-r,i)),this.cbQuickUnapply(t,o),this.mWho=s}return a},Model.Board.cbGetSmallestAttacker=function(t,e,r){var i=this.cbGetAttackers(t,e,r);if(0==i.length)return null;for(var a=1/0,n=null,s=i.length,o=0;o<s;o++){var h=i[o],c=t.g.pTypes[h.t].value;c<a&&(a=c,n=h)}return n},Model.Board.cbCollectAttackers=function(t,e,r,i){for(var a in e){var n=e[a],s=this.board[a];if(s<0)this.cbCollectAttackers(t,n.e,r,i);else{var o=this.pieces[s];o.s==-t&&(n.t&&o.t in n.t||i&&n.tk&&o.t in n.tk)&&r.push(o)}}},Model.Board.cbCollectAttackersScreen=function(t,e,r,i,a){for(var n in e){var s=e[n],o=this.board[n];if(o<0)this.cbCollectAttackersScreen(t,s.e,r,i,a);else{var h=this.pieces[o];!a&&h.s==-t&&(s.t&&h.t in s.t||i&&s.tk&&h.t in s.tk)?r.push(h):a?a&&h.s==-t&&s.ts&&h.t in s.ts&&r.push(h):this.cbCollectAttackersScreen(t,s.e,r,i,!0)}}},Model.Board.cbGetAttackers=function(t,e,r,i){var a=[];return t.cbUseScreenCapture?this.cbCollectAttackersScreen(r,t.g.threatGraph[r][e],a,i,!1):this.cbCollectAttackers(r,t.g.threatGraph[r][e],a,i),a},Model.Board.GenerateMoves=function(t){var e=this.cbGeneratePseudoLegalMoves(t);this.mMoves=[];for(var r=!0,i=this.kings[this.mWho],a=e.length,n=0;n<a;n++){var s=e[n],o=this.cbQuickApply(t,s);if(!(this.cbGetAttackers(t,this.kings[this.mWho],this.mWho,!0).length>0)){var h=this.cbGetAttackers(t,this.kings[-this.mWho],-this.mWho,!0).length>0;s.ck=h,this.mMoves.push(s),s.f!=i&&(r=!1)}this.cbQuickUnapply(t,o)}if(0==this.mMoves.length)this.mFinished=!0,this.mWinner=t.cbOnStaleMate?t.cbOnStaleMate*this.mWho:JocGame.DRAW,this.check&&(this.mWinner=-this.mWho);else if(this.ending[this.mWho]){if(!r)for(var n=0;n<this.mMoves.length;n++)this.mMoves[n].ko=!1}else if(!this.ending[this.mWho]&&r&&!this.check)for(var n=0;n<this.mMoves.length;n++)this.mMoves[n].ko=!0},Model.Board.GetSignature=function(){return this.zSign},Model.Move.Init=function(t){for(var e in t)t.hasOwnProperty(e)&&(this[e]=t[e])},Model.Move.Equals=function(t){return this.f==t.f&&this.t==t.t&&this.pr==t.pr},Model.Move.CopyFrom=function(t){this.Init(t)},Model.Move.ToString=function(e){var r=this;switch(e=e||"natural"){case"natural":return function(){var e;if(void 0!==r.cg?e=t.castle[r.f+"/"+r.cg].n:(e=r.a||"",e+=t.geometry.PosName(r.f),null==r.c?e+="-":e+="x",e+=t.geometry.PosName(r.t)),void 0!==r.pr){var i=t.pieceTypes[r.pr];i&&i.abbrev&&i.abbrev.length>0&&!i.silentPromo&&(e+="="+i.abbrev)}return r.ck&&(e+="+"),e}();case"engine":return function(){var e=t.geometry.PosName(r.f)+t.geometry.PosName(r.t);if(void 0!=r.pr){var i=t.pieceTypes[r.pr];i&&i.abbrev&&i.abbrev.length>0&&!i.silentPromo&&(e+=i.abbrev)}return e}();default:return"??"}},Model.Board.CompactMoveString=function(e,r,i){"function"!=typeof r.ToString&&(r=e.CreateMove(r));var a=r.ToString(),n=/^([A-Z]?)([a-z])([1-9][0-9]*)([-x])([a-z])([1-9][0-9]*)(.*?)$/.exec(a);if(!n)return a;var s=n[7];if(i||(i={}),i.value||(i.value=[]),0==i.value.length){var o=this.mMoves;this.mMoves&&0!=this.mMoves.length||this.GenerateMoves(e);for(var h=0;h<this.mMoves.length;h++){var c=this.mMoves[h];"function"!=typeof c.ToString&&(c=e.CreateMove(c)),i.value.push({str:c.ToString(),move:c})}this.mMoves=o}var p=[];if(i.value.forEach(function(t){var e=/^([A-Z]?[a-z][1-9][0-9]*[-x][a-z][1-9][0-9]*)(.*?)$/.exec(t.str);e&&t.move.t==r.t&&(t.move.a||"")==n[1]&&e[2]==s&&p.push(t.move)}),1==p.length)return""==n[1]&&"x"==n[4]?n[2]+"x"+n[5]+n[6]+n[7]:n[1]+("x"==n[4]?"x":"")+n[5]+n[6]+n[7];if(t.geometry.CompactCrit)for(var l="",h=0;;h++){var u=t.geometry.CompactCrit(r.f,h);if(null==u)return a;l+=u;for(var v=[],b=0;b<p.length;b++){var f=p[b];t.geometry.CompactCrit(f.f,h)==u&&v.push(f)}if(console.assert(v.length>0),1==v.length)return n[1]+l+("x"==n[4]?"x":"")+n[5]+n[6]+n[7];p=v}return a},Model.Board.cbIntegrity=function(t){function e(t,e){t||console.error(e)}for(var r=this,i=0;i<this.board.length;i++){var a=this.board[i];if(a>=0){var n=r.pieces[a];e(void 0!==n,"no piece at pos"),e(n.p==i,"piece has different pos")}}for(var a=0;a<this.pieces.length;a++){var n=this.pieces[a];n.p>=0&&e(r.board[n.p]==a,"board index mismatch")}},Model.Board.ExportBoardState=function(t){return t.cbVar.geometry.ExportBoardState?t.cbVar.geometry.ExportBoardState(this,t.cbVar,t.mPlayedMoves.length):"not supported"},Model.Game.Import=function(e,r){var i,a=[],n={1:{},"-1":{}},s=null,o=0;if("pjn"==e){var h={status:!1,error:"parse"},c=r.split(" ");if(6!=c.length)return console.warn("FEN should have 6 parts"),h;var p=c[0].split("/"),l=t.geometry.fenHeight||t.geometry.height;if(p.length!=l)return console.warn("FEN board should have",l,"rows, got",p.length),h;var u={};for(var v in t.pieceTypes){var b=t.pieceTypes[v],f=b.fenAbbrev||b.abbrev||"X";u[f.toUpperCase()]={s:1,t:v},u[f.toLowerCase()]={s:-1,t:v}}var d=t.geometry.FenRowPos||function(e,r){return(t.geometry.height-1-e)*t.geometry.width+r};if(p.forEach(function(e,r){for(var i=0,n=0;n<e.length;n++){var s=e.substr(n,1),o=u[s];if(void 0!==o){var c=d(r,i);i++;for(var p={s:o.s,t:o.t,p:c},l=!0,v=t.pieceTypes[p.t].initial||[],b=0;b<v.length;b++){var f=v[b];f.s==p.s&&f.p==c&&(l=!1)}p.m=l,a.push(p)}else{if(isNaN(parseInt(s)))return console.warn("FEN invalid board spec",s),h;i+=parseInt(s)}}}),a.sort(function(t,e){return e.s-t.s}),"w"==c[1])i=1;else{if("b"!=c[1])return console.warn("FEN invalid turn spec",c[1]),h;i=-1}n[1].k=c[2].indexOf("K")>=0,n[1].q=c[2].indexOf("Q")>=0,n[-1].k=c[2].indexOf("k")>=0,n[-1].q=c[2].indexOf("q")>=0,s="-"==c[3]?null:c[3];var g=parseInt(c[4]);isNaN(g)||(o=g);var m={pieces:a,turn:i,castle:n,enPassant:s,noCaptCount:o};return t.importGame&&t.importGame.call(this,m,e,r),{status:!0,initial:m}}return{status:!1,error:"unsupported"}}}(),function(){Model.Game.cbBoardGeometryGrid=function(t,e){function r(e){return e%t}function i(e){return Math.floor(e/t)}function a(e,r){return r*t+e}function n(n,s){var o=r(n),h=i(n),c=o+s[0],p=h+s[1];return c<0||c>=t||p<0||p>=e?null:a(c,p)}function s(t){return String.fromCharCode("a".charCodeAt(0)+r(t))+(i(t)+1)}function o(t){var e=/^([a-z])([0-9]+)$/.exec(t);return e?a(e[1].charCodeAt(0)-"a".charCodeAt(0),parseInt(e[2])-1):-1}function h(t,e){return 0==e?String.fromCharCode("a".charCodeAt(0)+r(t)):1==e?i(t)+1:null}function c(){for(var a=[],n=0;n<t*e;n++){var s=[];a.push(s);for(var o=0;o<t*e;o++){var h=i(n),c=r(n),p=i(o),l=r(o);s.push(Math.max(Math.abs(h-p),Math.abs(c-l)))}}return a}function p(r,i,n){for(var o=[],h=e-1;h>=0;h--){for(var c="",p=0,l=0;l<t;l++){var u=r.board[a(l,h)];if(u<0)p++;else{p>0&&(c+=p,p=0);var v=r.pieces[u],b=i.pieceTypes[v.t].fenAbbrev||i.pieceTypes[v.t].abbrev||"?";v.s==-1?c+=b.toLowerCase():c+=b.toUpperCase()}}p&&(c+=p),o.push(c)}var f=o.join("/");f+=" ",1==r.mWho?f+="w":f+="b",f+=" ";var d="";return r.castled&&(r.castled[1]===!1?d+="KQ":(r.castled[1].k&&(d+="K"),r.castled[1].q&&(d+="Q")),r.castled[-1]===!1?d+="kq":(r.castled[-1].k&&(d+="k"),r.castled[-1].q&&(d+="q"))),0==d.length&&(d="-"),f+=d,f+=" ",r.epTarget?f+=s(r.epTarget.p):f+="-",f+=" ",f+=r.noCaptCount,f+=" ",f+=Math.floor(n/2)+1}return{boardSize:t*e,width:t,height:e,C:r,R:i,POS:a,Graph:n,PosName:s,PosByName:o,CompactCrit:h,GetDistances:c,distEdge:function(){for(var a=[],n=0;n<t*e;n++){var s=r(n),o=i(n);a[n]=Math.min(s,Math.abs(t-s-1),o,Math.abs(e-o-1))}return a}(),corners:function(){var r={};return r[a(0,0)]=1,r[a(0,e-1)]=1,r[a(t-1,0)]=1,r[a(t-1,e-1)]=1,r}(),ExportBoardState:p}},Model.Game.cbPawnGraph=function(t,e,r){for(var i=this,a={},n=0;n<t.boardSize;n++)if(!r||n in r){var s=[],o=t.Graph(n,[0,e]);null!=o&&(!r||o in r)&&s.push(i.cbTypedArray([o|i.cbConstants.FLAG_MOVE])),[-1,1].forEach(function(a){var o=t.Graph(n,[a,e]);null!=o&&(!r||o in r)&&s.push(i.cbTypedArray([o|i.cbConstants.FLAG_CAPTURE]))}),a[n]=s}else a[n]=[];return a},Model.Game.cbInitialPawnGraph=function(t,e,r){for(var i=this,a={},n=0;n<t.boardSize;n++)if(!r||n in r){var s=[],o=t.Graph(n,[0,e]);if(null!=o&&(!r||o in r)){var h=[o|i.cbConstants.FLAG_MOVE],c=t.Graph(o,[0,e]);null!=c&&(!r||c in r)&&h.push(c|i.cbConstants.FLAG_MOVE),s.push(i.cbTypedArray(h))}[-1,1].forEach(function(a){var o=t.Graph(n,[a,e]);null!=o&&(!r||o in r)&&s.push(i.cbTypedArray([o|i.cbConstants.FLAG_CAPTURE]))}),a[n]=s}else a[n]=[];return a},Model.Game.cbKingGraph=function(t,e){return this.cbShortRangeGraph(t,[[-1,-1],[-1,0],[-1,1],[0,-1],[0,1],[1,-1],[1,0],[1,1]],e)},Model.Game.cbKnightGraph=function(t,e){return this.cbShortRangeGraph(t,[[2,-1],[2,1],[-2,-1],[-2,1],[-1,2],[-1,-2],[1,2],[1,-2]],e)},Model.Game.cbHorseGraph=function(t){for(var e=this,r={},i=0;i<t.boardSize;i++)r[i]=[],[[1,0,2,-1],[1,0,2,1],[-1,0,-2,-1],[-1,0,-2,1],[0,1,-1,2],[0,-1,-1,-2],[0,1,1,2],[0,-1,1,-2]].forEach(function(a){var n=t.Graph(i,[a[0],a[1]]);if(null!=n){var s=t.Graph(i,[a[2],a[3]]);null!=s&&r[i].push(e.cbTypedArray([n|e.cbConstants.FLAG_STOP,s|e.cbConstants.FLAG_MOVE|e.cbConstants.FLAG_CAPTURE]))}});return r},Model.Game.cbRookGraph=function(t,e){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0]],e)},Model.Game.cbBishopGraph=function(t,e){return this.cbLongRangeGraph(t,[[1,-1],[1,1],[-1,1],[-1,-1]],e)},Model.Game.cbQueenGraph=function(t,e){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0],[1,-1],[1,1],[-1,1],[-1,-1]],e)},Model.Game.cbXQGeneralGraph=function(t,e){for(var r=this,i={},a=0;a<t.boardSize;a++)i[a]=[],[[-1,0,!1],[0,-1,!0],[0,1,!0],[1,0,!1]].forEach(function(n){var s=[],o=t.Graph(a,n);if(null!=o&&((!e||o in e)&&s.push(o|r.cbConstants.FLAG_MOVE|r.cbConstants.FLAG_CAPTURE),n[2]))for(var h=t.Graph(o,n);null!=h;)!e||h in e?s.push(h|r.cbConstants.FLAG_CAPTURE|r.cbConstants.FLAG_CAPTURE_KING):s.push(h|r.cbConstants.FLAG_STOP),h=t.Graph(h,n);s.length>0&&i[a].push(r.cbTypedArray(s))});return i},Model.Game.cbXQSoldierGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e]])},Model.Game.cbXQPromoSoldierGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e],[-1,0],[1,0]])},Model.Game.cbXQAdvisorGraph=function(t,e){return this.cbShortRangeGraph(t,[[1,1],[-1,1],[1,-1],[-1,-1]],e)},Model.Game.cbXQCannonGraph=function(t){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0]],null,this.cbConstants.FLAG_MOVE|this.cbConstants.FLAG_SCREEN_CAPTURE)},Model.Game.cbXQElephantGraph=function(t,e){for(var r=this,i={},a=0;a<t.boardSize;a++)i[a]=[],(!e||a in e)&&[[1,1,2,2],[1,-1,2,-2],[-1,1,-2,2],[-1,-1,-2,-2]].forEach(function(n){var s=t.Graph(a,[n[0],n[1]]);if(null!=s){var o=t.Graph(a,[n[2],n[3]]);null!=o&&(!e||o in e)&&i[a].push(r.cbTypedArray([s|r.cbConstants.FLAG_STOP,o|r.cbConstants.FLAG_MOVE|r.cbConstants.FLAG_CAPTURE]))}});return i},Model.Game.cbSilverGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e],[-1,-1],[-1,1],[1,-1],[1,1]])},Model.Game.cbFersGraph=function(t,e){return this.cbShortRangeGraph(t,[[-1,-1],[-1,1],[1,-1],[1,1]])},Model.Game.cbSchleichGraph=function(t,e){return this.cbShortRangeGraph(t,[[-1,0],[1,0],[0,-1],[0,1]])},Model.Game.cbAlfilGraph=function(t,e){return this.cbShortRangeGraph(t,[[-2,-2],[-2,2],[2,2],[2,-2]])}}(),function(){var t=Model.Game.cbBoardGeometryGrid(5,6);Model.Game.cbDefine=function(){return{geometry:t,pieceTypes:{0:{name:"pawn-w",aspect:"pawn",graph:this.cbPawnGraph(t,1),value:1,abbrev:"",fenAbbrev:"P",epCatch:!0},1:{name:"ipawn-w",aspect:"pawn",graph:this.cbInitialPawnGraph(t,1),value:1,abbrev:"",fenAbbrev:"P",initial:[{s:1,p:5},{s:1,p:6},{s:1,p:7},{s:1,p:8},{s:1,p:9}],epCatch:!0,epTarget:!0},2:{name:"pawn-b",aspect:"pawn",graph:this.cbPawnGraph(t,-1),value:1,abbrev:"",fenAbbrev:"P",epCatch:!0},3:{name:"ipawn-b",aspect:"pawn",graph:this.cbInitialPawnGraph(t,-1),value:1,abbrev:"",fenAbbrev:"P",initial:[{s:-1,p:20},{s:-1,p:21},{s:-1,p:22},{s:-1,p:23},{s:-1,p:24}],epCatch:!0,epTarget:!0},4:{name:"knight",graph:this.cbKnightGraph(t),value:2.9,abbrev:"N",initial:[{s:1,p:1},{s:-1,p:26}]},5:{name:"bishop",graph:this.cbBishopGraph(t),value:3.1,abbrev:"B",initial:[{s:1,p:2},{s:-1,p:27}]},6:{name:"rook",graph:this.cbRookGraph(t),value:5,abbrev:"R",initial:[{s:1,p:0},{s:-1,p:25}],castle:!0},7:{name:"queen",graph:this.cbQueenGraph(t),value:9,abbrev:"Q",initial:[{s:1,p:3},{s:-1,p:28}]},8:{name:"king",isKing:!0,graph:this.cbKingGraph(t),abbrev:"K",initial:[{s:1,p:4},{s:-1,p:29}]}},promote:function(e,r,i){return 1==r.t?[0]:3==r.t?[2]:0==r.t&&5==t.R(i.t)?[4,5,6,7]:2==r.t&&0==t.R(i.t)?[4,5,6,7]:[]},castle:{"4/0":{k:[3,2],r:[1,2,3],n:"O-O"},"29/25":{k:[28,27],r:[26,27,28],n:"O-O"}},evaluate:function(e,r,i){var a=i[1].count,n=i[-1].count;a[0]||a[1]||a[4]||a[5]||a[6]||a[7]||n[2]||n[3]||n[6]||n[7]||!(n[4]+n[5]<2||n[5]<2)||(this.mFinished=!0,this.mWinner=JocGame.DRAW),n[2]||n[3]||n[4]||n[5]||n[6]||n[7]||a[0]||a[1]||a[6]||a[7]||!(a[4]+a[5]<2||a[5]<2)||(this.mFinished=!0,this.mWinner=JocGame.DRAW),this.noCaptCount>=100&&(this.mFinished=!0,this.mWinner=JocGame.DRAW);var s,o=e.cbUseTypedArrays?new Int8Array(3):[0,0,0],h=t.height,c=i[1].byType[0];if(c){s=c.length;for(var p=0;p<s;p++)switch(h-t.R(c[p].p)){case 2:o[0]++;break;case 3:o[1]++;break;case 4:o[2]++}}if(c=i[-1].byType[2]){s=c.length;for(var p=0;p<s;p++)switch(t.R(c[p].p)){case 1:o[0]--;break;case 2:o[1]--;break;case 3:o[2]--}}0!=o[0]&&(r.distPawnPromo1=o[0]),0!=o[1]&&(r.distPawnPromo2=o[1]),0!=o[2]&&(r.distPawnPromo3=o[2]);for(var l=0,u=4;u<=5;u++)for(var v=1;v>=-1;v-=2){var b=i[v].byType[u];if(b)for(var p=0;p<b.length;p++)b[p].m&&(l+=v)}0!=l&&(r.minorPiecesMoved=l)}}}}();

/***/ }),

/***/ "Imsy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subject_1 = __webpack_require__("EEr4");
var tryCatch_1 = __webpack_require__("+3eL");
var errorObject_1 = __webpack_require__("WhVc");
var OuterSubscriber_1 = __webpack_require__("wAkD");
var subscribeToResult_1 = __webpack_require__("CURp");
/**
 * Branch out the source Observable values as a nested Observable using a
 * factory function of closing Observables to determine when to start a new
 * window.
 *
 * <span class="informal">It's like {@link bufferWhen}, but emits a nested
 * Observable instead of an array.</span>
 *
 * <img src="./img/windowWhen.png" width="100%">
 *
 * Returns an Observable that emits windows of items it collects from the source
 * Observable. The output Observable emits connected, non-overlapping windows.
 * It emits the current window and opens a new one whenever the Observable
 * produced by the specified `closingSelector` function emits an item. The first
 * window is opened immediately when subscribing to the output Observable.
 *
 * @example <caption>Emit only the first two clicks events in every window of [1-5] random seconds</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks
 *   .windowWhen(() => Rx.Observable.interval(1000 + Math.random() * 4000))
 *   .map(win => win.take(2)) // each window has at most 2 emissions
 *   .mergeAll(); // flatten the Observable-of-Observables
 * result.subscribe(x => console.log(x));
 *
 * @see {@link window}
 * @see {@link windowCount}
 * @see {@link windowTime}
 * @see {@link windowToggle}
 * @see {@link bufferWhen}
 *
 * @param {function(): Observable} closingSelector A function that takes no
 * arguments and returns an Observable that signals (on either `next` or
 * `complete`) when to close the previous window and start a new one.
 * @return {Observable<Observable<T>>} An observable of windows, which in turn
 * are Observables.
 * @method windowWhen
 * @owner Observable
 */
function windowWhen(closingSelector) {
    return this.lift(new WindowOperator(closingSelector));
}
exports.windowWhen = windowWhen;
var WindowOperator = (function () {
    function WindowOperator(closingSelector) {
        this.closingSelector = closingSelector;
    }
    WindowOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new WindowSubscriber(subscriber, this.closingSelector));
    };
    return WindowOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var WindowSubscriber = (function (_super) {
    __extends(WindowSubscriber, _super);
    function WindowSubscriber(destination, closingSelector) {
        _super.call(this, destination);
        this.destination = destination;
        this.closingSelector = closingSelector;
        this.openWindow();
    }
    WindowSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.openWindow(innerSub);
    };
    WindowSubscriber.prototype.notifyError = function (error, innerSub) {
        this._error(error);
    };
    WindowSubscriber.prototype.notifyComplete = function (innerSub) {
        this.openWindow(innerSub);
    };
    WindowSubscriber.prototype._next = function (value) {
        this.window.next(value);
    };
    WindowSubscriber.prototype._error = function (err) {
        this.window.error(err);
        this.destination.error(err);
        this.unsubscribeClosingNotification();
    };
    WindowSubscriber.prototype._complete = function () {
        this.window.complete();
        this.destination.complete();
        this.unsubscribeClosingNotification();
    };
    WindowSubscriber.prototype.unsubscribeClosingNotification = function () {
        if (this.closingNotification) {
            this.closingNotification.unsubscribe();
        }
    };
    WindowSubscriber.prototype.openWindow = function (innerSub) {
        if (innerSub === void 0) { innerSub = null; }
        if (innerSub) {
            this.remove(innerSub);
            innerSub.unsubscribe();
        }
        var prevWindow = this.window;
        if (prevWindow) {
            prevWindow.complete();
        }
        var window = this.window = new Subject_1.Subject();
        this.destination.next(window);
        var closingNotifier = tryCatch_1.tryCatch(this.closingSelector)();
        if (closingNotifier === errorObject_1.errorObject) {
            var err = errorObject_1.errorObject.e;
            this.destination.error(err);
            this.window.error(err);
        }
        else {
            this.add(this.closingNotification = subscribeToResult_1.subscribeToResult(this, closingNotifier));
        }
    };
    return WindowSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=windowWhen.js.map

/***/ }),

/***/ "IwGk":
/***/ (function(module, exports) {

exports.config = {"status":true,"model":{"plazza":"true","released":1405068607,"title-en":"Amazon Chess","module":"chessbase","summary":"18th century, Russia","thumbnail":"amazon-thumb.png","rules":{"en":"amazon-rules.html"},"credits":{"en":"amazon-credits.html"},"gameOptions":{"preventRepeat":true,"uctTransposition":"state","uctIgnoreLoop":false,"levelOptions":{"pieceValueFactor":1,"pieceValueRatioFactor":1,"posValueFactor":0.1,"averageDistKingFactor":-0.01,"castleFactor":0.1,"minorPiecesMovedFactor":0.1,"checkFactor":0.2,"endingKingFreedomFactor":0.01,"endingDistKingFactor":0.05,"distKingCornerFactor":0.1,"distPawnPromo1Factor":0.3,"distPawnPromo2Factor":0.1,"distPawnPromo3Factor":0.05}},"obsolete":false,"js":["base-model.js","grid-geo-model.js","amazon-model.js"],"levels":[{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"easy","label":"Easy","maxNodes":1000},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"fast","label":"Fast [1sec]","maxDuration":1,"isDefault":true},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"medium","label":"Medium","maxNodes":10000,"maxDuration":10},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"strong","label":"Strong","maxNodes":20000,"maxDuration":15}],"description":{"en":"amazon-description.html"}},"view":{"title-en":"Chessbase view","module":"chessbase","xdView":true,"css":["chessbase.css"],"preferredRatio":1,"useShowMoves":true,"useNotation":true,"useAutoComplete":true,"defaultOptions":{"sounds":true,"moves":true,"notation":false,"autocomplete":false},"skins":[{"name":"skin3d","title":"3D Classic","3d":true,"preload":["smoothedfilegeo|0|/res/ring-target.js","image|/res/images/cancel.png","image|/res/images/wikipedia.png","smoothedfilegeo|0|/res/fairy/pawn/pawn.js","image|/res/fairy/pawn/pawn-diffusemap.jpg","image|/res/fairy/pawn/pawn-normalmap.jpg","smoothedfilegeo|0|/res/fairy/knight/knight.js","image|/res/fairy/knight/knight-diffusemap.jpg","image|/res/fairy/knight/knight-normalmap.jpg","smoothedfilegeo|0|/res/fairy/bishop/bishop.js","image|/res/fairy/bishop/bishop-diffusemap.jpg","image|/res/fairy/bishop/bishop-normalmap.jpg","smoothedfilegeo|0|/res/fairy/king/king.js","image|/res/fairy/king/king-diffusemap.jpg","image|/res/fairy/king/king-normalmap.jpg","smoothedfilegeo|0|/res/fairy/rook/rook.js","image|/res/fairy/rook/rook-diffusemap.jpg","image|/res/fairy/rook/rook-normalmap.jpg","smoothedfilegeo|0|/res/fairy/amazon/amazon.js","image|/res/fairy/amazon/amazon-diffusemap.jpg","image|/res/fairy/amazon/amazon-normalmap.jpg"],"world":{"lightIntensity":1.3,"skyLightIntensity":1.2,"lightCastShadow":true,"fog":false,"color":4686804,"lightPosition":{"x":-9,"y":9,"z":9},"skyLightPosition":{"x":9,"y":9,"z":9},"lightShadowDarkness":0.55,"ambientLightColor":2236962},"camera":{"fov":45,"distMax":50,"radius":18,"elevationAngle":60,"elevationMin":0}},{"name":"skin2d","title":"2D Classic","3d":false,"preload":["image|/res/images/cancel.png","image|/res/images/whitebg.png","image|/res/fairy/wikipedia-fairy-sprites.png"]}],"animateSelfMoves":false,"switchable":true,"sounds":{"move1":"alq_move1","move2":"alq_move2","move3":"alq_move3","move4":"alq_move2","tac1":"alq_tac1","tac2":"alq_tac2","tac3":"alq_tac1","promo":"promo","usermove":null},"js":["base-view.js","grid-board-view.js","fairy-set-view.js","amazon-view.js"],"visuals":{"600x600":["res/visuals/amazon-600x600-3d.jpg","res/visuals/amazon-600x600-2d.jpg"]}}}

/***/ }),

/***/ "JGxh":
/***/ (function(module, exports) {

exports.config = {"status":true,"model":{"plazza":"true","released":1403535378,"title-en":"Shafran Chess","module":"chessbase","summary":"Hexagonal Chess","thumbnail":"shafran-thumb.png","rules":{"en":"shafran-rules.html"},"credits":{"en":"shafran-credits.html"},"gameOptions":{"preventRepeat":true,"uctTransposition":"state","uctIgnoreLoop":false,"levelOptions":{"pieceValueFactor":1,"pieceValueRatioFactor":1,"posValueFactor":0.1,"averageDistKingFactor":-0.01,"castleFactor":0.1,"minorPiecesMovedFactor":0.1,"checkFactor":0.2,"endingKingFreedomFactor":0.01,"endingDistKingFactor":0.05,"distKingCornerFactor":0.1,"distPawnPromo1Factor":0.3,"distPawnPromo2Factor":0.1,"distPawnPromo3Factor":0.05}},"obsolete":false,"js":["base-model.js","hex-geo-model.js","shafran-model.js"],"description":{"en":"shafran-description.html"},"levels":[{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"easy","label":"Easy","maxNodes":6000},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"fast","label":"Fast [3sec]","maxDuration":3,"isDefault":true},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"medium","label":"Medium","maxNodes":30000,"maxDuration":30},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"strong","label":"Strong","maxNodes":60000,"maxDuration":45}]},"view":{"title-en":"Chessbase view","module":"chessbase","xdView":true,"css":["chessbase.css","hex.css"],"preferredRatio":1,"useShowMoves":true,"useNotation":true,"useAutoComplete":true,"defaultOptions":{"sounds":true,"moves":true,"notation":false,"autocomplete":false},"skins":[{"name":"skin3d","title":"3D Classic","3d":true,"preload":["smoothedfilegeo|0|/res/ring-target-cylinder-v3.js","image|/res/images/cancel.png","image|/res/images/wikipedia.png","smoothedfilegeo|0|/res/staunton/pawn/pawn-classic.js","image|/res/staunton/pawn/pawn-diffusemap.jpg","image|/res/staunton/pawn/pawn-normalmap.jpg","smoothedfilegeo|0|/res/staunton/knight/knight.js","image|/res/staunton/knight/knight-diffusemap.jpg","image|/res/staunton/knight/knight-normalmap.jpg","smoothedfilegeo|0|/res/staunton/bishop/bishop.js","image|/res/staunton/bishop/bishop-diffusemap.jpg","image|/res/staunton/bishop/bishop-normalmap.jpg","smoothedfilegeo|0|/res/staunton/rook/rook.js","image|/res/staunton/rook/rook-diffusemap.jpg","image|/res/staunton/rook/rook-normalmap.jpg","smoothedfilegeo|0|/res/staunton/queen/queen.js","image|/res/staunton/queen/queen-diffusemap.jpg","image|/res/staunton/queen/queen-normalmap.jpg","smoothedfilegeo|0|/res/staunton/king/king.js","image|/res/staunton/king/king-diffusemap.jpg","image|/res/staunton/king/king-normalmap.jpg"],"world":{"lightIntensity":1.3,"skyLightIntensity":1.2,"lightCastShadow":true,"fog":false,"color":4686804,"lightPosition":{"x":-9,"y":9,"z":9},"skyLightPosition":{"x":9,"y":9,"z":9},"lightShadowDarkness":0.55,"ambientLightColor":2236962},"camera":{"fov":45,"distMax":50,"radius":13.5,"elevationAngle":45,"elevationMin":0,"distMin":0}},{"name":"skin2d","title":"2D Classic","3d":false,"preload":["image|/res/images/wikipedia.png","image|/res/images/whitebg.png","image|/res/images/cancel.png"]}],"animateSelfMoves":false,"switchable":true,"sounds":{"move1":"alq_move1","move2":"alq_move2","move3":"alq_move3","move4":"alq_move2","tac1":"alq_tac1","tac2":"alq_tac2","tac3":"alq_tac1","promo":"promo","usermove":null},"js":["base-view.js","hex-board-view.js","staunton-set-view.js","shafran-view.js"],"visuals":{"600x600":["res/visuals/shafran-600x600-3d.jpg","res/visuals/shafran-600x600-2d.jpg"]}}}

/***/ }),

/***/ "JJSU":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var last_1 = __webpack_require__("7nvF");
Observable_1.Observable.prototype.last = last_1.last;
//# sourceMappingURL=last.js.map

/***/ }),

/***/ "JL3s":
/***/ (function(module, exports) {

exports.model=Model={Game:{},Board:{},Move:{}},function(){var t;Model.Game.cbConstants={MASK:65535,FLAG_MOVE:65536,FLAG_CAPTURE:131072,FLAG_STOP:262144,FLAG_SCREEN_CAPTURE:524288,FLAG_CAPTURE_KING:1048576,FLAG_CAPTURE_NO_KING:2097152};var e="undefined"!=typeof Int32Array;Model.Game.cbUseTypedArrays=e,Model.Game.cbTypedArray=function(t){if(e){var i=new Int32Array(t.length);return i.set(t),i}for(var r=[],a=t.length,n=0;n<a;n++)r.push(t[n]);return r},Model.Game.cbShortRangeGraph=function(t,e,i,r){var a=this;void 0===r&&(r=196608);for(var n={},s=0;s<t.boardSize;s++)n[s]=[],(!i||s in i)&&e.forEach(function(e){var o=t.Graph(s,e);null!=o&&(!i||o in i)&&n[s].push(a.cbTypedArray([o|r]))});return n},Model.Game.cbLongRangeGraph=function(t,e,i,r,a){var n=this;void 0!==r&&null!=r||(r=196608),a||(a=1/0);for(var s={},o=0;o<t.boardSize;o++)s[o]=[],(!i||o in i)&&e.forEach(function(e){for(var h=[],c=t.Graph(o,e),p=0;null!=c&&(!i||c in i)&&(h.push(c|r),++p!=a);)c=t.Graph(c,e);h.length>0&&s[o].push(n.cbTypedArray(h))});return s},Model.Game.cbNullGraph=function(t){for(var e={},i=0;i<t.boardSize;i++)e[i]=[];return e},Model.Game.cbAuthorGraph=function(t){for(var e={},i=0;i<t.boardSize;i++){e[i]=[];for(var r=0;r<t.boardSize;r++)e[i].push([2293760|r])}return e},Model.Game.cbMergeGraphs=function(t){for(var e=[],i=0;i<t.boardSize;i++){e[i]=[];for(var r=1;r<arguments.length;r++)e[i]=e[i].concat(arguments[r][i])}return e},Model.Game.cbGetThreatGraph=function(){function t(e,i){for(var r in s){var a=s[r];if(!(a.p.length<i.length+1)){for(var n=!0,o=0;o<i.length;o++)if(i[o]!=a.p[o]){n=!1;break}if(n){var h=a.p[i.length],c=e[h];void 0===c&&(c={e:{}},e[h]=c),a.p.length==i.length+1&&(c.t=a.t,c.ts=a.ts,c.tk=a.tk,delete s[r]),i.push(h),t(c.e,i),i.pop()}}}}var e=this;this.cbUseScreenCapture=!1,this.cbUseCaptureKing=!1,this.cbUseCaptureNoKing=!1;for(var i={1:[],"-1":[]},r=[],a=0;a<this.g.boardSize;a++)this.g.pTypes.forEach(function(t,i){t.graph[a].forEach(function(t){for(var n=[],s=0;s<t.length;s++){var o=t[s];1048576&o?(e.cbUseCaptureKing=!0,n.unshift({d:65535&o,a:a,tk:i})):2097152&o?(e.cbUseCaptureNoKing=!0,n.unshift({d:65535&o,a:a,tnk:i})):131072&o?n.unshift({d:65535&o,a:a,t:i}):262144&o?n.unshift({d:65535&o,a:a}):524288&o&&(e.cbUseScreenCapture=!0,n.unshift({d:65535&o,a:a,ts:i}))}n.length>0&&r.push(n)})});var n={};r.forEach(function(t){t.forEach(function(e,i){var r=n[e.d];void 0===r&&(r={},n[e.d]=r);for(var a=[],s=i+1;s<t.length;s++)a.push(t[s].d);a.push(e.a);var o=a.join(","),h=r[o];void 0===h&&(h={p:a,t:{},ts:{},tk:{}},r[o]=h),void 0!==e.t?h.t[e.t]=!0:void 0!==e.tk?h.tk[e.tk]=!0:void 0!==e.ts&&(h.ts[e.ts]=!0)})});for(var a=0;a<e.g.boardSize;a++){var s=n[a],o={};t(o,[]),i[1][a]=o,i[-1][a]=o}return i},Model.Game.InitGame=function(){var e=this;this.cbVar=t=this.cbDefine(),this.g.boardSize=this.cbVar.geometry.boardSize,this.g.pTypes=this.cbGetPieceTypes(),this.g.threatGraph=this.cbGetThreatGraph(),this.g.distGraph=this.cbVar.geometry.GetDistances(),this.cbPiecesCount=0,this.g.castleablePiecesCount={1:0,"-1":0};for(var i in t.pieceTypes){var r=t.pieceTypes[i];if(r.castle){(r.initial||[]).forEach(function(t){e.g.castleablePiecesCount[t.s]++})}r.initial&&(this.cbPiecesCount+=r.initial.length)}for(var a=[],i=0;i<this.cbPiecesCount;i++)a.push(i);var n=Object.keys(t.pieceTypes);this.zobrist=new JocGame.Zobrist({board:{type:"array",size:this.cbVar.geometry.boardSize,values:a},who:{values:["1","-1"]},type:{type:"array",size:this.cbPiecesCount,values:n}})},Model.Game.cbGetPieceTypes=function(){for(var t=[],e={},i=0;i<this.cbVar.geometry.boardSize;i++)e[i]=[];for(var r in this.cbVar.pieceTypes){var a=this.cbVar.pieceTypes[r];t[r]={graph:a.graph||e,abbrev:a.abbrev||"",value:a.isKing?100:a.value||1,isKing:!!a.isKing,castle:!!a.castle,epTarget:!!a.epTarget,epCatch:!!a.epCatch}}return t},Model.Board.Init=function(t){this.zSign=0},Model.Board.InitialPosition=function(i){var r=this;this.board=e?new Int16Array(i.g.boardSize):[];for(var a=0;a<i.g.boardSize;a++)this.board[a]=-1;if(this.kings={},this.pieces=[],this.ending={1:!1,"-1":!1},this.lastMove=null,i.cbVar.castle&&(this.castled={1:!1,"-1":!1}),this.zSign=i.zobrist.update(0,"who",-1),this.noCaptCount=0,this.mWho=1,i.mInitial)this.mWho=i.mInitial.turn||1,i.mInitial.pieces.forEach(function(t){var e={};for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i]);r.pieces.push(e)}),i.mInitial.lastMove&&(this.lastMove={f:i.mInitial.lastMove.f,t:i.mInitial.lastMove.t}),void 0!==i.mInitial.noCaptCount&&(this.noCaptCount=i.mInitial.noCaptCount),i.cbVar.castle&&i.mInitial.castle&&(this.castled={1:{k:!!i.mInitial.castle[1]&&!!i.mInitial.castle[1].k,q:!!i.mInitial.castle[1]&&!!i.mInitial.castle[1].q},"-1":{k:!!i.mInitial.castle[-1]&&!!i.mInitial.castle[-1].k,q:!!i.mInitial.castle[-1]&&!!i.mInitial.castle[-1].q}});else for(var n in i.cbVar.pieceTypes)for(var s=i.cbVar.pieceTypes[n],o=s.initial||[],h=0;h<o.length;h++){var c=o[h],p={s:c.s,t:parseInt(n),p:c.p,m:!1};this.pieces.push(p)}if(this.pieces.sort(function(t,e){if(t.s!=e.s)return e.s-t.s;var r=i.cbVar.pieceTypes[t.t].value||100,a=i.cbVar.pieceTypes[e.t].value||100;return r!=a?r-a:t.p-e.p}),this.pieces.forEach(function(t,e){t.i=e,r.board[t.p]=e,i.g.pTypes[t.t].isKing&&(r.kings[t.s]=t.p),r.zSign=i.zobrist.update(r.zSign,"board",e,t.p),r.zSign=i.zobrist.update(r.zSign,"type",t.t,e)}),i.mInitial&&i.mInitial.enPassant){var a=t.geometry.PosByName(i.mInitial.enPassant);if(a>=0){var l,v=t.geometry.C(a),f=t.geometry.R(a);l=1==i.mInitial.turn?t.geometry.POS(v,f-1):t.geometry.POS(v,f+1),this.epTarget={p:a,i:this.board[l]}}}},Model.Board.CopyFrom=function(t){if(e)this.board=new Int16Array(t.board.length),this.board.set(t.board);else{this.board=[];for(var i=t.board,r=i.length,a=0;a<r;a++)this.board.push(i[a])}this.pieces=[];for(var n=t.pieces.length,a=0;a<n;a++){var s=t.pieces[a];this.pieces.push({s:s.s,p:s.p,t:s.t,i:s.i,m:s.m})}this.kings={1:t.kings[1],"-1":t.kings[-1]},this.check=t.check,t.lastMove?this.lastMove={f:t.lastMove.f,t:t.lastMove.t,c:t.lastMove.c}:this.lastMove=null,this.ending={1:t.ending[1],"-1":t.ending[-1]},void 0!==t.castled&&(this.castled={1:t.castled[1],"-1":t.castled[-1]}),this.noCaptCount=t.noCaptCount,t.epTarget?this.epTarget={p:t.epTarget.p,i:t.epTarget.i}:this.epTarget=null,this.mWho=t.mWho,this.zSign=t.zSign},Model.Board.cbApplyCastle=function(t,e,i){var r=t.cbVar.castle[e.f+"/"+e.cg],a=r.r[r.r.length-1],n=this.pieces[this.board[e.cg]],s=r.k[r.k.length-1],o=this.pieces[this.board[e.f]];return i&&(this.zSign=t.zobrist.update(this.zSign,"board",n.i,e.cg),this.zSign=t.zobrist.update(this.zSign,"board",n.i,a),this.zSign=t.zobrist.update(this.zSign,"board",o.i,e.f),this.zSign=t.zobrist.update(this.zSign,"board",o.i,s)),n.p=a,n.m=!0,this.board[e.cg]=-1,o.p=s,o.m=!0,this.board[e.f]=-1,this.board[a]=n.i,this.board[s]=o.i,this.castled[n.s]=!0,this.kings[o.s]=s,[{i:n.i,f:a,t:-1},{i:o.i,f:s,t:e.f,kp:e.f,who:o.s,m:!1},{i:n.i,f:-1,t:e.cg,m:!1,cg:!1}]},Model.Board.cbQuickApply=function(t,e){if(void 0!==e.cg)return this.cbApplyCastle(t,e,!1);var i=[],r=this.board[e.f],a=this.pieces[r];if(null!=e.c){i.unshift({i:e.c,f:-1,t:this.pieces[e.c].p});var n=this.pieces[e.c];this.board[n.p]=-1,n.p=-1}var s=this.kings[a.s];return t.g.pTypes[a.t].isKing&&(this.kings[a.s]=e.t),i.unshift({i:r,f:e.t,t:e.f,kp:s,who:a.s,ty:a.t}),a.p=e.t,void 0!==e.pr&&(a.t=e.pr),this.board[e.f]=-1,this.board[e.t]=r,i},Model.Board.cbQuickUnapply=function(t,e){for(var i=0;i<e.length;i++){var r=e[i],a=this.pieces[r.i];r.f>=0&&(a.p=-1,this.board[r.f]=-1),r.t>=0&&(a.p=r.t,this.board[r.t]=r.i),void 0!==r.m&&(a.m=r.m),void 0!==r.kp&&(this.kings[r.who]=r.kp),void 0!=r.ty&&(a.t=r.ty),void 0!=r.cg&&(this.castled[a.s]=r.cg)}},Model.Board.ApplyMove=function(t,e){var i=this.pieces[this.board[e.f]];if(void 0!==e.cg)this.cbApplyCastle(t,e,!0);else{if(this.zSign=t.zobrist.update(this.zSign,"board",i.i,e.f),this.board[i.p]=-1,void 0!==e.pr&&(this.zSign=t.zobrist.update(this.zSign,"type",i.t,i.i),i.t=e.pr,this.zSign=t.zobrist.update(this.zSign,"type",i.t,i.i)),null!=e.c){var r=this.pieces[e.c];this.zSign=t.zobrist.update(this.zSign,"board",r.i,r.p),this.board[r.p]=-1,r.p=-1,r.m=!0,this.noCaptCount=0}else this.noCaptCount++;i.p=e.t,i.m=!0,this.board[e.t]=i.i,this.zSign=t.zobrist.update(this.zSign,"board",i.i,e.t),t.g.pTypes[i.t].isKing&&(this.kings[i.s]=e.t)}this.check=!!e.ck,this.lastMove={f:e.f,t:e.t,c:e.c},void 0!==e.ko&&(this.ending[i.s]=e.ko),void 0!==e.ept?this.epTarget={p:e.ept,i:i.i}:this.epTarget=null,this.zSign=t.zobrist.update(this.zSign,"who",-this.mWho),this.zSign=t.zobrist.update(this.zSign,"who",this.mWho)},Model.Board.Evaluate=function(i){function r(e){var i=1/0;for(var r in t.geometry.corners)i=Math.min(i,h.distGraph[n.kings[e]][r]);return i-Math.sqrt(h.boardSize)}var a="debug"==arguments[3],n=this;this.mEvaluation=0;var s,o=this.mWho,h=i.g;if(e)s={1:{count:new Uint8Array(h.pTypes.length),byType:{}},"-1":{count:new Uint8Array(h.pTypes.length),byType:{}}};else{s={1:{count:[],byType:{}},"-1":{count:[],byType:{}}};for(var c=0;c<h.pTypes.length;c++)s[1].count[c]=s[-1].count[c]=0}if(i.mOptions.preventRepeat&&i.GetRepeatOccurence(this)>2)return this.mFinished=!0,void(this.mWinner=i.cbOnPerpetual?o*i.cbOnPerpetual:JocGame.DRAW);for(var p={1:0,"-1":0},l={1:h.distGraph[this.kings[-1]],"-1":h.distGraph[this.kings[1]]},v={1:0,"-1":0},f={1:0,"-1":0},u={1:0,"-1":0},g={1:0,"-1":0},b={1:!1,"-1":!1},d=this.pieces,m=d.length,c=0;c<m;c++){var G=d[c];if(G.p>=0){var y=G.s,M=h.pTypes[G.t];M.isKing?b[y]=G.m:p[y]+=M.value,M.castle&&!G.m&&g[y]++,f[y]++,v[y]+=l[y][G.p],u[y]+=t.geometry.distEdge[G.p];var k=s[y];k.count[G.t]++;var S=k.byType;void 0===S[G.t]?S[G.t]=[G]:S[G.t].push(G)}}if(this.lastMove&&null!=this.lastMove.c){var G=this.pieces[this.board[this.lastMove.t]];p[-G.s]+=this.cbStaticExchangeEval(i,G.p,G.s,{piece:G})}var C={1:0,"-1":0},T={1:0,"-1":0},z={1:0,"-1":0};this.ending[1]&&(T[1]=(v[1]-Math.sqrt(h.boardSize))/f[1],t.geometry.corners&&(z[1]=r(1))),this.ending[-1]&&(T[-1]=(v[-1]-Math.sqrt(h.boardSize))/f[-1],t.geometry.corners&&(z[1]=r(-1)));var A={pieceValue:p[1]-p[-1],pieceValueRatio:(p[1]-p[-1])/(p[1]+p[-1]+1),posValue:u[1]-u[-1],averageDistKing:v[1]/f[1]-v[-1]/f[-1],check:this.check?-o:0,endingKingFreedom:C[1]-C[-1],endingDistKing:T[1]-T[-1],distKingCorner:z[1]-z[-1]};t.castle&&(A.castle=(this.castled[1]?1:b[1]?0:g[1]/(h.castleablePiecesCount[1]+1))-(this.castled[-1]?1:b[-1]?0:g[-1]/(h.castleablePiecesCount[-1]+1))),t.evaluate&&t.evaluate.call(this,i,A,s);var P=i.mOptions.levelOptions;for(var E in A){var w=A[E],I=P[E+"Factor"]||0,R=w*I;a&&console.log(E,"=",w,"*",I,"=>",R),this.mEvaluation+=R}a&&console.log("Evaluation",this.mEvaluation)},Model.Board.cbGeneratePseudoLegalMoves=function(t){function e(e,a){var n=t.cbVar.promote;if(!n)return void r.push(a);var s=n.call(i,t,e,a);if(null!=s)if(0==s.length)r.push(a);else if(1==s.length)a.pr=s[0],r.push(a);else for(var o=0;o<s.length;o++){var h=s[o];r.push({f:a.f,t:a.t,c:a.c,pr:h,ept:a.ept,ep:a.ep,a:a.a})}}for(var i=this,r=[],a=t.cbVar,n=this.mWho,s=!a.castle||this.check||this.castled[n]?null:[],o=-1,h=this.pieces.length,c=0;c<h;c++){var p=this.pieces[c];if(!(p.p<0||p.s!=n)){var l=t.g.pTypes[p.t];l.isKing&&(p.m?s=null:o=p),s&&l.castle&&!p.m&&s.push(p);var v,f;v=l.graph[p.p],f=v.length;for(var u=0;u<f;u++)for(var g=v[u],b=!1,d=g.length,m=null,G=0;G<d;G++){var y=g[G],M=65535&y,k=this.board[M];if(!(k<0)||l.epCatch&&this.epTarget&&this.epTarget.p==M){if(!(524288&y)){var S;S=k<0?this.pieces[this.epTarget.i]:this.pieces[k],!(S.s!=p.s&&131072&y)||1048576&y&&!t.g.pTypes[S.t].isKing||2097152&y&&t.g.pTypes[S.t].isKing||e(p,{f:p.p,t:M,c:S.i,a:l.abbrev,ep:k<0});break}if(b){var S=this.pieces[k];S.s!=p.s&&e(p,{f:p.p,t:M,c:S.i,a:l.abbrev});break}b=!0}else 65536&y&&0==b&&e(p,{f:p.p,t:M,c:null,a:l.abbrev,ept:null!=m&&l.epTarget?m:void 0});m=M}}}if(s)for(var c=0;c<s.length;c++){var C=s[c],T=t.cbVar.castle[o.p+"/"+C.p];if(T){for(var z=!0,u=0;u<T.r.length;u++){var A=T.r[u];if(this.board[A]>=0&&A!=o.p&&A!=C.p){z=!1;break}}if(z){for(var P=!0,u=0;u<T.k.length;u++){var A=T.k[u];if(this.board[A]>=0&&A!=C.p&&A!=o.p||this.cbGetAttackers(t,A,n).length>0){P=!1;break}}P&&r.push({f:o.p,t:T.k[T.k.length-1],c:null,cg:C.p})}}}return r},Model.Board.cbStaticExchangeEval=function(t,e,i,r){var a=0,n=this.cbGetSmallestAttacker(t,e,i);if(n){var s=this.mWho;this.mWho=n.s;var o=this.cbQuickApply(t,{f:n.p,t:e,c:r.piece.i}),h=t.g.pTypes[r.piece.t].value;r.piece=n,a=Math.max(0,h-this.cbStaticExchangeEval(t,e,-i,r)),this.cbQuickUnapply(t,o),this.mWho=s}return a},Model.Board.cbGetSmallestAttacker=function(t,e,i){var r=this.cbGetAttackers(t,e,i);if(0==r.length)return null;for(var a=1/0,n=null,s=r.length,o=0;o<s;o++){var h=r[o],c=t.g.pTypes[h.t].value;c<a&&(a=c,n=h)}return n},Model.Board.cbCollectAttackers=function(t,e,i,r){for(var a in e){var n=e[a],s=this.board[a];if(s<0)this.cbCollectAttackers(t,n.e,i,r);else{var o=this.pieces[s];o.s==-t&&(n.t&&o.t in n.t||r&&n.tk&&o.t in n.tk)&&i.push(o)}}},Model.Board.cbCollectAttackersScreen=function(t,e,i,r,a){for(var n in e){var s=e[n],o=this.board[n];if(o<0)this.cbCollectAttackersScreen(t,s.e,i,r,a);else{var h=this.pieces[o];!a&&h.s==-t&&(s.t&&h.t in s.t||r&&s.tk&&h.t in s.tk)?i.push(h):a?a&&h.s==-t&&s.ts&&h.t in s.ts&&i.push(h):this.cbCollectAttackersScreen(t,s.e,i,r,!0)}}},Model.Board.cbGetAttackers=function(t,e,i,r){var a=[];return t.cbUseScreenCapture?this.cbCollectAttackersScreen(i,t.g.threatGraph[i][e],a,r,!1):this.cbCollectAttackers(i,t.g.threatGraph[i][e],a,r),a},Model.Board.GenerateMoves=function(t){var e=this.cbGeneratePseudoLegalMoves(t);this.mMoves=[];for(var i=!0,r=this.kings[this.mWho],a=e.length,n=0;n<a;n++){var s=e[n],o=this.cbQuickApply(t,s);if(!(this.cbGetAttackers(t,this.kings[this.mWho],this.mWho,!0).length>0)){var h=this.cbGetAttackers(t,this.kings[-this.mWho],-this.mWho,!0).length>0;s.ck=h,this.mMoves.push(s),s.f!=r&&(i=!1)}this.cbQuickUnapply(t,o)}if(0==this.mMoves.length)this.mFinished=!0,this.mWinner=t.cbOnStaleMate?t.cbOnStaleMate*this.mWho:JocGame.DRAW,this.check&&(this.mWinner=-this.mWho);else if(this.ending[this.mWho]){if(!i)for(var n=0;n<this.mMoves.length;n++)this.mMoves[n].ko=!1}else if(!this.ending[this.mWho]&&i&&!this.check)for(var n=0;n<this.mMoves.length;n++)this.mMoves[n].ko=!0},Model.Board.GetSignature=function(){return this.zSign},Model.Move.Init=function(t){for(var e in t)t.hasOwnProperty(e)&&(this[e]=t[e])},Model.Move.Equals=function(t){return this.f==t.f&&this.t==t.t&&this.pr==t.pr},Model.Move.CopyFrom=function(t){this.Init(t)},Model.Move.ToString=function(e){var i=this;switch(e=e||"natural"){case"natural":return function(){var e;if(void 0!==i.cg?e=t.castle[i.f+"/"+i.cg].n:(e=i.a||"",e+=t.geometry.PosName(i.f),null==i.c?e+="-":e+="x",e+=t.geometry.PosName(i.t)),void 0!==i.pr){var r=t.pieceTypes[i.pr];r&&r.abbrev&&r.abbrev.length>0&&!r.silentPromo&&(e+="="+r.abbrev)}return i.ck&&(e+="+"),e}();case"engine":return function(){var e=t.geometry.PosName(i.f)+t.geometry.PosName(i.t);if(void 0!=i.pr){var r=t.pieceTypes[i.pr];r&&r.abbrev&&r.abbrev.length>0&&!r.silentPromo&&(e+=r.abbrev)}return e}();default:return"??"}},Model.Board.CompactMoveString=function(e,i,r){"function"!=typeof i.ToString&&(i=e.CreateMove(i));var a=i.ToString(),n=/^([A-Z]?)([a-z])([1-9][0-9]*)([-x])([a-z])([1-9][0-9]*)(.*?)$/.exec(a);if(!n)return a;var s=n[7];if(r||(r={}),r.value||(r.value=[]),0==r.value.length){var o=this.mMoves;this.mMoves&&0!=this.mMoves.length||this.GenerateMoves(e);for(var h=0;h<this.mMoves.length;h++){var c=this.mMoves[h];"function"!=typeof c.ToString&&(c=e.CreateMove(c)),r.value.push({str:c.ToString(),move:c})}this.mMoves=o}var p=[];if(r.value.forEach(function(t){var e=/^([A-Z]?[a-z][1-9][0-9]*[-x][a-z][1-9][0-9]*)(.*?)$/.exec(t.str);e&&t.move.t==i.t&&(t.move.a||"")==n[1]&&e[2]==s&&p.push(t.move)}),1==p.length)return""==n[1]&&"x"==n[4]?n[2]+"x"+n[5]+n[6]+n[7]:n[1]+("x"==n[4]?"x":"")+n[5]+n[6]+n[7];if(t.geometry.CompactCrit)for(var l="",h=0;;h++){var v=t.geometry.CompactCrit(i.f,h);if(null==v)return a;l+=v;for(var f=[],u=0;u<p.length;u++){var g=p[u];t.geometry.CompactCrit(g.f,h)==v&&f.push(g)}if(console.assert(f.length>0),1==f.length)return n[1]+l+("x"==n[4]?"x":"")+n[5]+n[6]+n[7];p=f}return a},Model.Board.cbIntegrity=function(t){function e(t,e){t||console.error(e)}for(var i=this,r=0;r<this.board.length;r++){var a=this.board[r];if(a>=0){var n=i.pieces[a];e(void 0!==n,"no piece at pos"),e(n.p==r,"piece has different pos")}}for(var a=0;a<this.pieces.length;a++){var n=this.pieces[a];n.p>=0&&e(i.board[n.p]==a,"board index mismatch")}},Model.Board.ExportBoardState=function(t){return t.cbVar.geometry.ExportBoardState?t.cbVar.geometry.ExportBoardState(this,t.cbVar,t.mPlayedMoves.length):"not supported"},Model.Game.Import=function(e,i){var r,a=[],n={1:{},"-1":{}},s=null,o=0;if("pjn"==e){var h={status:!1,error:"parse"},c=i.split(" ");if(6!=c.length)return console.warn("FEN should have 6 parts"),h;var p=c[0].split("/"),l=t.geometry.fenHeight||t.geometry.height;if(p.length!=l)return console.warn("FEN board should have",l,"rows, got",p.length),h;var v={};for(var f in t.pieceTypes){var u=t.pieceTypes[f],g=u.fenAbbrev||u.abbrev||"X";v[g.toUpperCase()]={s:1,t:f},v[g.toLowerCase()]={s:-1,t:f}}var b=t.geometry.FenRowPos||function(e,i){return(t.geometry.height-1-e)*t.geometry.width+i};if(p.forEach(function(e,i){for(var r=0,n=0;n<e.length;n++){var s=e.substr(n,1),o=v[s];if(void 0!==o){var c=b(i,r);r++;for(var p={s:o.s,t:o.t,p:c},l=!0,f=t.pieceTypes[p.t].initial||[],u=0;u<f.length;u++){var g=f[u];g.s==p.s&&g.p==c&&(l=!1)}p.m=l,a.push(p)}else{if(isNaN(parseInt(s)))return console.warn("FEN invalid board spec",s),h;r+=parseInt(s)}}}),a.sort(function(t,e){return e.s-t.s}),"w"==c[1])r=1;else{if("b"!=c[1])return console.warn("FEN invalid turn spec",c[1]),h;r=-1}n[1].k=c[2].indexOf("K")>=0,n[1].q=c[2].indexOf("Q")>=0,n[-1].k=c[2].indexOf("k")>=0,n[-1].q=c[2].indexOf("q")>=0,s="-"==c[3]?null:c[3];var d=parseInt(c[4]);isNaN(d)||(o=d);var m={pieces:a,turn:r,castle:n,enPassant:s,noCaptCount:o};return t.importGame&&t.importGame.call(this,m,e,i),{status:!0,initial:m}}return{status:!1,error:"unsupported"}}}(),function(){Model.Game.cbBoardGeometryHex=function(t,e){function i(t,e){for(var i=r(t),s=a(t),o=i,h=s,c=0;c<3;c++)for(var p=Math.abs(e[c]),l=0==p?0:e[c]/p,g=0;g<p;g++)h%2==v?(1==c&&l<0&&o--,2==c&&l>0&&o--):(1==c&&l>0&&o++,2==c&&l<0&&o++),1!=c&&2!=c||(h+=l),0==c&&(o+=l);if(o<0||o>=u||h<0||h>=f)return null;var t=n(o,h);return t in d?t:null}function r(t){return t%u}function a(t){return Math.floor(t/u)}function n(t,e){return e*u+t}function s(t){return void 0!==e[t]?e[t]:String.fromCharCode("a".charCodeAt(0)+r(t))+(a(t)+1)}function o(t){if(void 0!==l[t])return l[t];var e=/^([a-z])([0-9]+)$/.exec(t);return e?n(e[1].charCodeAt(0)-"a".charCodeAt(0),parseInt(e[2])-1):-1}function h(t,e){return 0==e?String.fromCharCode("a".charCodeAt(0)+r(t)):1==e?a(t)+1:null}function c(){return G}function p(e,i){var r=t[t.length-1-i][2*e];return" "==r&&(r=t[t.length-1-i][2*e+1]||" "),r}var l={};if(e)for(y in e)l[e[y]]=y;else e={};for(var v,f=t.length,u=0,g=!1,b=0,d={},m=0;m<t.length;m++)t[m].length%2==1&&t[m],t[m].length>b&&(b=t[m].length);for(var m=0;m<t.length;m++)for(;t[m].length<b;)t[m]+=" ";t.forEach(function(t,e){" "!=t[0]&&(v=e%2);var i=Math.ceil(t.length/2);i>u&&(u=i)}),t.forEach(function(e,i){(t.length-1-i)%2==1-v&&(" "==e[e.length-1]&&" "==e[e.length-2]||(g=!0));for(var r=0;r<e.length;r+=2)if(" "!=e[r]||r+1<e.length&&" "!=e[r+1]){var a=i*u+r/2;d[a]=1}});var G={};for(var y in d)G[y]={},G[y][y]=0;for(var M=[[1,0,0],[0,1,0],[0,0,1],[-1,0,0],[0,-1,0],[0,0,-1]],k=!0;k;){k=!1;for(var y in d)M.forEach(function(t){var e=i(y,t);if(null!=e){1!=G[y][e]&&(G[y][e]=1,G[e][y]=1,k=!0);for(var r in d)r!=y&&(void 0===G[e][r]&&void 0!==G[y][r]?(G[e][r]=G[y][r]+1,G[r][e]=G[y][r]+1,k=!0):void 0!==G[e][r]&&void 0!==G[y][r]&&G[e][r]>G[y][r]+1&&(G[e][r]=G[y][r]+1,G[r][e]=G[y][r]+1,k=!0))}})}var S=0,C={};for(var y in d){var T=0;for(var z in d){var A=G[y][z];T+=A*A}T>S?(C={},C[y]=1,S=T):T==S&&(C[y]=1)}for(var P={},k=!0;k;){k=!1;for(var y in d)y in P||M.forEach(function(t){var e=i(y,t);null==e?P[y]=1:e in P&&(y in P&&!(P[y]>P[e]+1)||(P[y]=P[e]+1,k=!0))})}return{boardSize:u*f,width:u,height:f,C:r,R:a,POS:n,Graph:i,PosName:s,PosByName:o,CompactCrit:h,GetDistances:c,distEdge:P,corners:C,SHIFTMOD2:v,SHIFTRIGHT:g,CellType:p,confine:d}};var t=Model.Game.cbConstants,e=[[1,0,0],[0,1,0],[0,0,1],[-1,0,0],[0,-1,0],[0,0,-1]],i=[[1,1,0],[0,1,1],[-1,0,1],[-1,-1,0],[0,-1,-1],[1,0,-1]],r=[[2,1,0],[1,2,0],[0,2,1],[0,1,2],[-1,0,2],[-2,0,1],[-2,-1,0],[-1,-2,0],[0,-2,-1],[0,-1,-2],[1,0,-2],[2,0,-1]];Model.Game.cbGLKingGraph=function(t){return this.cbShortRangeGraph(t,i.concat(e),t.confine)},Model.Game.cbGLRookGraph=function(t){return this.cbLongRangeGraph(t,e,t.confine)},Model.Game.cbGLBishopGraph=function(t){return this.cbLongRangeGraph(t,i,t.confine)},Model.Game.cbGLQueenGraph=function(t){return this.cbLongRangeGraph(t,i.concat(e),t.confine)},Model.Game.cbGLKnightGraph=function(t){return this.cbShortRangeGraph(t,r,t.confine)},Model.Game.cbGLPawnGraph=function(e,i,r){for(var a=this.cbLongRangeGraph(e,[[i,0,0]],e.confine,t.FLAG_MOVE,r),n={1:[[0,1,0],[0,0,-1]],"-1":[[0,0,1],[0,-1,0]]},s=this.cbShortRangeGraph(e,n[i],e.confine,t.FLAG_CAPTURE),o=[],h=0;h<e.boardSize;h++)o[h]=a[h].concat(s[h]);return o},Model.Game.cbBRInitialPawnGraph=function(e,i){for(var r=this.cbLongRangeGraph(e,[[0,-i,0],[0,0,-i]],e.confine,t.FLAG_MOVE,2),a=this.cbShortRangeGraph(e,[[-i,-i,0],[i,0,-i],[0,-i,-i]],e.confine,t.FLAG_CAPTURE),n=[],s=0;s<e.boardSize;s++)n[s]=r[s].concat(a[s]);return n},Model.Game.cbDVInitialPawnGraph=function(e,i){for(var r=this.cbLongRangeGraph(e,[[0,-i,0],[0,0,-i]],e.confine,t.FLAG_MOVE,2),a=this.cbShortRangeGraph(e,[[-i,-i,0],[i,0,-i]],e.confine,t.FLAG_CAPTURE),n=[],s=0;s<e.boardSize;s++)n[s]=r[s].concat(a[s]);return n},Model.Game.cbBRPawnGraph=function(e,i){for(var r=this.cbShortRangeGraph(e,[[0,-i,0],[0,0,-i]],e.confine,t.FLAG_MOVE),a=this.cbShortRangeGraph(e,[[-i,-i,0],[i,0,-i]],e.confine,t.FLAG_CAPTURE),n=[],s=0;s<e.boardSize;s++)n[s]=r[s].concat(a[s]);return n},Model.Game.cbMCPawnGraph=function(e,i,r){for(var a=this.cbLongRangeGraph(e,[[i,0,0]],e.confine,t.FLAG_MOVE,r),n=this.cbShortRangeGraph(e,[[i,0,-i],[i,i,0]],e.confine,t.FLAG_CAPTURE),s=[],o=0;o<e.boardSize;o++)s[o]=a[o].concat(n[o]);return s}}(),function(){var t={2:"a1",13:"b1",23:"c1",34:"d1",44:"e1",55:"f1",66:"g1",78:"h1",89:"i1",101:"k1",112:"l1",3:"a2",14:"b2",24:"c2",35:"d2",45:"e2",56:"f2",67:"g2",79:"h2",90:"i2",102:"k2",113:"l2",4:"a3",15:"b3",25:"c3",36:"d3",46:"e3",57:"f3",68:"g3",80:"h3",91:"i3",103:"k3",114:"l3",5:"a4",16:"b4",26:"c4",37:"d4",47:"e4",58:"f4",69:"g4",81:"h4",92:"i4",104:"k4",115:"l4",6:"a5",17:"b5",27:"c5",38:"d5",48:"e5",59:"f5",70:"g5",82:"h5",93:"i5",105:"k5",116:"l5",7:"a6",18:"b6",28:"c6",39:"d6",49:"e6",60:"f6",71:"g6",83:"h6",94:"i6",106:"k6",117:"l6",19:"b7",29:"c7",40:"d7",50:"e7",61:"f7",72:"g7",84:"h7",95:"i7",107:"k7",30:"c8",41:"d8",51:"e8",62:"f8",73:"g8",85:"h8",96:"i8",42:"d9",52:"e9",63:"f9",74:"g9",86:"h9",53:"e10",64:"f10",75:"g10",65:"f11"},e=Model.Game.cbBoardGeometryHex(["     # + . # + .      ","    + . # + . # +     ","   . # + . # + . #    ","  # + . # + . # + .   "," + . # + . # + . # +  ",". # + . # + . # + . # "," + . # + . # + . # +  ","  # + . # + . # + .   ","   . # + . # + . #    ","    + . # + . # +     ","     # + . # + .      "],t),i={1:{7:1,19:1,30:1,53:1,65:1,73:1,86:1,96:1,107:1,117:1},"-1":{2:1,13:1,23:1,34:1,44:1,55:1,66:1,78:1,89:1,101:1,112:1}},r={1:{},"-1":{}},a=e.GetDistances();["1","-1"].forEach(function(t){for(var n in e.confine){var s=1/0;for(var o in i[t]){var h=a[n][o];h<s&&(r[t][n]=h,s=h)}}}),Model.Game.cbDefine=function(){return{geometry:e,pieceTypes:{0:{name:"pawn-w",aspect:"pawn",graph:this.cbMCPawnGraph(e,1,1),value:1,abbrev:"",fenAbbrev:"P",initial:[{s:1,p:58}],epCatch:!0},1:{name:"ipawn-w",aspect:"pawn",graph:this.cbMCPawnGraph(e,1,2),value:1,abbrev:"",fenAbbrev:"P",initial:[{s:1,p:23},{s:1,p:35},{s:1,p:46},{s:1,p:68},{s:1,p:79},{s:1,p:89}],epTarget:!0},2:{name:"pawn-b",aspect:"pawn",graph:this.cbMCPawnGraph(e,-1,1),value:1,abbrev:"",fenAbbrev:"P",initial:[{s:-1,p:62}],epCatch:!0},3:{name:"ipawn-b",aspect:"pawn",graph:this.cbMCPawnGraph(e,-1,2),value:1,abbrev:"",fenAbbrev:"P",initial:[{s:-1,p:30},{s:-1,p:41},{s:-1,p:51},{s:-1,p:73},{s:-1,p:85},{s:-1,p:96}],epTarget:!0},4:{name:"knight",graph:this.cbGLKnightGraph(e),value:2.9,abbrev:"N",initial:[{s:1,p:45},{s:1,p:67},{s:-1,p:52},{s:-1,p:74}]},5:{name:"bishop",graph:this.cbGLBishopGraph(e),value:3.1,abbrev:"B",initial:[{s:1,p:55},{s:1,p:56},{s:1,p:57},{s:-1,p:65},{s:-1,p:64},{s:-1,p:63}]},6:{name:"rook",graph:this.cbGLRookGraph(e),value:5,abbrev:"R",initial:[{s:1,p:34},{s:1,p:78},{s:-1,p:42},{s:-1,p:86}],castle:!0},7:{name:"queen",graph:this.cbGLQueenGraph(e),value:9,abbrev:"Q",initial:[{s:1,p:44},{s:-1,p:53}]},8:{name:"king",isKing:!0,graph:this.cbGLKingGraph(e),abbrev:"K",initial:[{s:1,p:66},{s:-1,p:75}]}},promote:function(t,e,r){return 1==e.t?[0]:3==e.t?[2]:0==e.t&&r.t in i[1]?[4,5,6,7]:2==e.t&&r.t in i[-1]?[4,5,6,7]:[]},evaluate:function(t,e,i){var a=i[1].count,n=i[-1].count;a[0]||a[1]||a[4]||a[5]||a[6]||a[7]||n[2]||n[3]||n[6]||n[7]||!(n[4]+n[5]<2||n[5]<2)||(this.mFinished=!0,this.mWinner=JocGame.DRAW),n[2]||n[3]||n[4]||n[5]||n[6]||n[7]||a[0]||a[1]||a[6]||a[7]||!(a[4]+a[5]<2||a[5]<2)||(this.mFinished=!0,this.mWinner=JocGame.DRAW),this.noCaptCount>=100&&(this.mFinished=!0,this.mWinner=JocGame.DRAW);var s,o=t.cbUseTypedArrays?new Int8Array(3):[0,0,0],h=i[1].byType[0];if(h){s=h.length;for(var c=0;c<s;c++){var p=r[1][h[c].p];p>0&&p<4&&o[p-1]++}}if(h=i[-1].byType[2]){s=h.length;for(var c=0;c<s;c++){var p=r[-1][h[c].p];p>0&&p<4&&o[p-1]--}}0!=o[0]&&(e.distPawnPromo1=o[0]),0!=o[1]&&(e.distPawnPromo2=o[1]),0!=o[2]&&(e.distPawnPromo3=o[2]);for(var l=0,v=4;v<=5;v++)for(var f=1;f>=-1;f-=2){var u=i[f].byType[v];if(u)for(var c=0;c<u.length;c++)u[c].m&&(l+=f)}0!=l&&(e.minorPiecesMoved=l)}}}}();

/***/ }),

/***/ "JPC0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var mergeAll_1 = __webpack_require__("cbuX");
Observable_1.Observable.prototype.mergeAll = mergeAll_1.mergeAll;
//# sourceMappingURL=mergeAll.js.map

/***/ }),

/***/ "JQ6u":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var single_1 = __webpack_require__("p5++");
Observable_1.Observable.prototype.single = single_1.single;
//# sourceMappingURL=single.js.map

/***/ }),

/***/ "JUgO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("3j3K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_common__ = __webpack_require__("2Je8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__json_tree_index__ = __webpack_require__("d5KB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__log_monitor__ = __webpack_require__("4p5j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__log_monitor_button__ = __webpack_require__("HbHJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__log_monitor_entry__ = __webpack_require__("3Tfs");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LogMonitorModule; });






var LogMonitorModule = (function () {
    function LogMonitorModule() {
    }
    LogMonitorModule.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{
                    imports: [
                        __WEBPACK_IMPORTED_MODULE_1__angular_common__["CommonModule"],
                        __WEBPACK_IMPORTED_MODULE_2__json_tree_index__["a" /* JsonTreeModule */]
                    ],
                    declarations: [
                        __WEBPACK_IMPORTED_MODULE_3__log_monitor__["a" /* LogMonitorComponent */],
                        __WEBPACK_IMPORTED_MODULE_4__log_monitor_button__["a" /* LogMonitorButtonComponent */],
                        __WEBPACK_IMPORTED_MODULE_5__log_monitor_entry__["a" /* LogMonitorEntryComponent */]
                    ],
                    exports: [
                        __WEBPACK_IMPORTED_MODULE_3__log_monitor__["a" /* LogMonitorComponent */]
                    ]
                },] },
    ];
    /** @nocollapse */
    LogMonitorModule.ctorParameters = [];
    return LogMonitorModule;
}());
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "JVjn":
/***/ (function(module, exports) {

exports.config = {"status":true,"model":{"plazza":"true","released":1402066578,"title-en":"Raumschach","module":"chessbase","summary":"5x5x5 Chess","thumbnail":"raumschach-thumb.png","rules":{"en":"raumschach-rules.html"},"credits":{"en":"raumschach-credits.html"},"gameOptions":{"preventRepeat":true,"uctTransposition":"state","uctIgnoreLoop":false,"levelOptions":{"pieceValueFactor":1,"pieceValueRatioFactor":1,"posValueFactor":0.1,"averageDistKingFactor":-0.01,"castleFactor":0.1,"minorPiecesMovedFactor":0.1,"checkFactor":0.2,"endingKingFreedomFactor":0.01,"endingDistKingFactor":0.05,"distKingCornerFactor":0.1,"distPawnPromo1Factor":0.3,"distPawnPromo2Factor":0.1,"distPawnPromo3Factor":0.05}},"obsolete":false,"js":["base-model.js","multiplan-geo-model.js","raumschach-model.js"],"description":{"en":"raumschach-description.html"},"levels":[{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"easy","label":"Easy","maxNodes":4000},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"fast","label":"Fast [2sec]","maxDuration":2,"isDefault":true},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"medium","label":"Medium","maxNodes":20000,"maxDuration":20},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"strong","label":"Strong","maxNodes":40000,"maxDuration":30}]},"view":{"title-en":"Chessbase view","module":"chessbase","xdView":true,"css":["chessbase.css"],"preferredRatio":1.1,"useShowMoves":true,"useNotation":true,"useAutoComplete":true,"defaultOptions":{"sounds":true,"moves":true,"notation":false,"autocomplete":false},"skins":[{"name":"skin3d","title":"3D Classic","3d":true,"preload":["smoothedfilegeo|0|/res/ring-target.js","image|/res/images/cancel.png","image|/res/images/wikipedia.png","smoothedfilegeo|0|/res/fairy/pawn/pawn.js","image|/res/fairy/pawn/pawn-diffusemap.jpg","image|/res/fairy/pawn/pawn-normalmap.jpg","smoothedfilegeo|0|/res/fairy/knight/knight.js","image|/res/fairy/knight/knight-diffusemap.jpg","image|/res/fairy/knight/knight-normalmap.jpg","smoothedfilegeo|0|/res/fairy/bishop/bishop.js","image|/res/fairy/bishop/bishop-diffusemap.jpg","image|/res/fairy/bishop/bishop-normalmap.jpg","smoothedfilegeo|0|/res/fairy/queen/queen.js","image|/res/fairy/queen/queen-diffusemap.jpg","image|/res/fairy/queen/queen-normalmap.jpg","smoothedfilegeo|0|/res/fairy/king/king.js","image|/res/fairy/king/king-diffusemap.jpg","image|/res/fairy/king/king-normalmap.jpg","smoothedfilegeo|0|/res/fairy/rook/rook.js","image|/res/fairy/rook/rook-diffusemap.jpg","image|/res/fairy/rook/rook-normalmap.jpg","smoothedfilegeo|0|/res/fairy/unicorn/unicorn.js","image|/res/fairy/unicorn/unicorn-diffusemap.jpg","image|/res/fairy/unicorn/unicorn-normalmap.jpg"],"world":{"lightIntensity":1,"skyLightIntensity":0.5,"lightCastShadow":false,"fog":false,"color":4686804,"lightPosition":{"x":-9,"y":9,"z":9},"skyLightPosition":{"x":9,"y":9,"z":9},"lightShadowDarkness":0.55,"ambientLightColor":16777215},"camera":{"fov":45,"distMax":200,"radius":24,"elevationAngle":40,"elevationMin":-89,"rotationAngle":150,"target":[0,0,5000],"targetBounds":[3000,3000,6000]}},{"name":"skin2d","title":"2D Classic","3d":false,"preload":["image|/res/images/wikipedia.png","image|/res/images/cancel.png","image|/res/images/whitebg.png"]}],"animateSelfMoves":false,"switchable":true,"sounds":{"move1":"alq_move1","move2":"alq_move2","move3":"alq_move3","move4":"alq_move2","tac1":"alq_tac1","tac2":"alq_tac2","tac3":"alq_tac1","promo":"promo","usermove":null},"js":["base-view.js","multiplan-board-view.js","fairy-set-view.js","raumschach-view.js"],"visuals":{"600x600":["res/visuals/raumschach-600x600-3d.jpg","res/visuals/raumschach-600x600-2d.jpg"]}}}

/***/ }),

/***/ "Ji1B":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__("mmVS");
var Notification_1 = __webpack_require__("8GmM");
/**
 * @see {@link Notification}
 *
 * @param scheduler
 * @param delay
 * @return {Observable<R>|WebSocketSubject<T>|Observable<T>}
 * @method observeOn
 * @owner Observable
 */
function observeOn(scheduler, delay) {
    if (delay === void 0) { delay = 0; }
    return this.lift(new ObserveOnOperator(scheduler, delay));
}
exports.observeOn = observeOn;
var ObserveOnOperator = (function () {
    function ObserveOnOperator(scheduler, delay) {
        if (delay === void 0) { delay = 0; }
        this.scheduler = scheduler;
        this.delay = delay;
    }
    ObserveOnOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new ObserveOnSubscriber(subscriber, this.scheduler, this.delay));
    };
    return ObserveOnOperator;
}());
exports.ObserveOnOperator = ObserveOnOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var ObserveOnSubscriber = (function (_super) {
    __extends(ObserveOnSubscriber, _super);
    function ObserveOnSubscriber(destination, scheduler, delay) {
        if (delay === void 0) { delay = 0; }
        _super.call(this, destination);
        this.scheduler = scheduler;
        this.delay = delay;
    }
    ObserveOnSubscriber.dispatch = function (arg) {
        var notification = arg.notification, destination = arg.destination;
        notification.observe(destination);
        this.unsubscribe();
    };
    ObserveOnSubscriber.prototype.scheduleMessage = function (notification) {
        this.add(this.scheduler.schedule(ObserveOnSubscriber.dispatch, this.delay, new ObserveOnMessage(notification, this.destination)));
    };
    ObserveOnSubscriber.prototype._next = function (value) {
        this.scheduleMessage(Notification_1.Notification.createNext(value));
    };
    ObserveOnSubscriber.prototype._error = function (err) {
        this.scheduleMessage(Notification_1.Notification.createError(err));
    };
    ObserveOnSubscriber.prototype._complete = function () {
        this.scheduleMessage(Notification_1.Notification.createComplete());
    };
    return ObserveOnSubscriber;
}(Subscriber_1.Subscriber));
exports.ObserveOnSubscriber = ObserveOnSubscriber;
var ObserveOnMessage = (function () {
    function ObserveOnMessage(notification, destination) {
        this.notification = notification;
        this.destination = destination;
    }
    return ObserveOnMessage;
}());
exports.ObserveOnMessage = ObserveOnMessage;
//# sourceMappingURL=observeOn.js.map

/***/ }),

/***/ "Ji1V":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ArrayObservable_1 = __webpack_require__("Yh8Q");
var ScalarObservable_1 = __webpack_require__("RRVv");
var EmptyObservable_1 = __webpack_require__("jBEF");
var concat_1 = __webpack_require__("8MUz");
var isScheduler_1 = __webpack_require__("fWbP");
/* tslint:enable:max-line-length */
/**
 * Returns an Observable that emits the items you specify as arguments before it begins to emit
 * items emitted by the source Observable.
 *
 * <img src="./img/startWith.png" width="100%">
 *
 * @param {...T} values - Items you want the modified Observable to emit first.
 * @param {Scheduler} [scheduler] - A {@link IScheduler} to use for scheduling
 * the emissions of the `next` notifications.
 * @return {Observable} An Observable that emits the items in the specified Iterable and then emits the items
 * emitted by the source Observable.
 * @method startWith
 * @owner Observable
 */
function startWith() {
    var array = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        array[_i - 0] = arguments[_i];
    }
    var scheduler = array[array.length - 1];
    if (isScheduler_1.isScheduler(scheduler)) {
        array.pop();
    }
    else {
        scheduler = null;
    }
    var len = array.length;
    if (len === 1) {
        return concat_1.concatStatic(new ScalarObservable_1.ScalarObservable(array[0], scheduler), this);
    }
    else if (len > 1) {
        return concat_1.concatStatic(new ArrayObservable_1.ArrayObservable(array, scheduler), this);
    }
    else {
        return concat_1.concatStatic(new EmptyObservable_1.EmptyObservable(scheduler), this);
    }
}
exports.startWith = startWith;
//# sourceMappingURL=startWith.js.map

/***/ }),

/***/ "JkZN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var isArray_1 = __webpack_require__("Xajo");
var isArrayLike_1 = __webpack_require__("1r8+");
var isPromise_1 = __webpack_require__("aQl7");
var PromiseObservable_1 = __webpack_require__("hYBY");
var IteratorObservable_1 = __webpack_require__("U15Z");
var ArrayObservable_1 = __webpack_require__("Yh8Q");
var ArrayLikeObservable_1 = __webpack_require__("FA5e");
var iterator_1 = __webpack_require__("cdmN");
var Observable_1 = __webpack_require__("rCTf");
var observeOn_1 = __webpack_require__("Ji1B");
var observable_1 = __webpack_require__("mbVC");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var FromObservable = (function (_super) {
    __extends(FromObservable, _super);
    function FromObservable(ish, scheduler) {
        _super.call(this, null);
        this.ish = ish;
        this.scheduler = scheduler;
    }
    /**
     * Creates an Observable from an Array, an array-like object, a Promise, an
     * iterable object, or an Observable-like object.
     *
     * <span class="informal">Converts almost anything to an Observable.</span>
     *
     * <img src="./img/from.png" width="100%">
     *
     * Convert various other objects and data types into Observables. `from`
     * converts a Promise or an array-like or an
     * [iterable](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#iterable)
     * object into an Observable that emits the items in that promise or array or
     * iterable. A String, in this context, is treated as an array of characters.
     * Observable-like objects (contains a function named with the ES2015 Symbol
     * for Observable) can also be converted through this operator.
     *
     * @example <caption>Converts an array to an Observable</caption>
     * var array = [10, 20, 30];
     * var result = Rx.Observable.from(array);
     * result.subscribe(x => console.log(x));
     *
     * // Results in the following:
     * // 10 20 30
     *
     * @example <caption>Convert an infinite iterable (from a generator) to an Observable</caption>
     * function* generateDoubles(seed) {
     *   var i = seed;
     *   while (true) {
     *     yield i;
     *     i = 2 * i; // double it
     *   }
     * }
     *
     * var iterator = generateDoubles(3);
     * var result = Rx.Observable.from(iterator).take(10);
     * result.subscribe(x => console.log(x));
     *
     * // Results in the following:
     * // 3 6 12 24 48 96 192 384 768 1536
     *
     * @see {@link create}
     * @see {@link fromEvent}
     * @see {@link fromEventPattern}
     * @see {@link fromPromise}
     *
     * @param {ObservableInput<T>} ish A subscribable object, a Promise, an
     * Observable-like, an Array, an iterable or an array-like object to be
     * converted.
     * @param {Scheduler} [scheduler] The scheduler on which to schedule the
     * emissions of values.
     * @return {Observable<T>} The Observable whose values are originally from the
     * input object that was converted.
     * @static true
     * @name from
     * @owner Observable
     */
    FromObservable.create = function (ish, scheduler) {
        if (ish != null) {
            if (typeof ish[observable_1.observable] === 'function') {
                if (ish instanceof Observable_1.Observable && !scheduler) {
                    return ish;
                }
                return new FromObservable(ish, scheduler);
            }
            else if (isArray_1.isArray(ish)) {
                return new ArrayObservable_1.ArrayObservable(ish, scheduler);
            }
            else if (isPromise_1.isPromise(ish)) {
                return new PromiseObservable_1.PromiseObservable(ish, scheduler);
            }
            else if (typeof ish[iterator_1.iterator] === 'function' || typeof ish === 'string') {
                return new IteratorObservable_1.IteratorObservable(ish, scheduler);
            }
            else if (isArrayLike_1.isArrayLike(ish)) {
                return new ArrayLikeObservable_1.ArrayLikeObservable(ish, scheduler);
            }
        }
        throw new TypeError((ish !== null && typeof ish || ish) + ' is not observable');
    };
    FromObservable.prototype._subscribe = function (subscriber) {
        var ish = this.ish;
        var scheduler = this.scheduler;
        if (scheduler == null) {
            return ish[observable_1.observable]().subscribe(subscriber);
        }
        else {
            return ish[observable_1.observable]().subscribe(new observeOn_1.ObserveOnSubscriber(subscriber, scheduler, 0));
        }
    };
    return FromObservable;
}(Observable_1.Observable));
exports.FromObservable = FromObservable;
//# sourceMappingURL=FromObservable.js.map

/***/ }),

/***/ "KKz1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__("mmVS");
var async_1 = __webpack_require__("CGGv");
/**
 * Emits a value from the source Observable, then ignores subsequent source
 * values for `duration` milliseconds, then repeats this process.
 *
 * <span class="informal">Lets a value pass, then ignores source values for the
 * next `duration` milliseconds.</span>
 *
 * <img src="./img/throttleTime.png" width="100%">
 *
 * `throttleTime` emits the source Observable values on the output Observable
 * when its internal timer is disabled, and ignores source values when the timer
 * is enabled. Initially, the timer is disabled. As soon as the first source
 * value arrives, it is forwarded to the output Observable, and then the timer
 * is enabled. After `duration` milliseconds (or the time unit determined
 * internally by the optional `scheduler`) has passed, the timer is disabled,
 * and this process repeats for the next source value. Optionally takes a
 * {@link IScheduler} for managing timers.
 *
 * @example <caption>Emit clicks at a rate of at most one click per second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.throttleTime(1000);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link auditTime}
 * @see {@link debounceTime}
 * @see {@link delay}
 * @see {@link sampleTime}
 * @see {@link throttle}
 *
 * @param {number} duration Time to wait before emitting another value after
 * emitting the last value, measured in milliseconds or the time unit determined
 * internally by the optional `scheduler`.
 * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
 * managing the timers that handle the sampling.
 * @return {Observable<T>} An Observable that performs the throttle operation to
 * limit the rate of emissions from the source.
 * @method throttleTime
 * @owner Observable
 */
function throttleTime(duration, scheduler) {
    if (scheduler === void 0) { scheduler = async_1.async; }
    return this.lift(new ThrottleTimeOperator(duration, scheduler));
}
exports.throttleTime = throttleTime;
var ThrottleTimeOperator = (function () {
    function ThrottleTimeOperator(duration, scheduler) {
        this.duration = duration;
        this.scheduler = scheduler;
    }
    ThrottleTimeOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new ThrottleTimeSubscriber(subscriber, this.duration, this.scheduler));
    };
    return ThrottleTimeOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var ThrottleTimeSubscriber = (function (_super) {
    __extends(ThrottleTimeSubscriber, _super);
    function ThrottleTimeSubscriber(destination, duration, scheduler) {
        _super.call(this, destination);
        this.duration = duration;
        this.scheduler = scheduler;
    }
    ThrottleTimeSubscriber.prototype._next = function (value) {
        if (!this.throttled) {
            this.add(this.throttled = this.scheduler.schedule(dispatchNext, this.duration, { subscriber: this }));
            this.destination.next(value);
        }
    };
    ThrottleTimeSubscriber.prototype.clearThrottle = function () {
        var throttled = this.throttled;
        if (throttled) {
            throttled.unsubscribe();
            this.remove(throttled);
            this.throttled = null;
        }
    };
    return ThrottleTimeSubscriber;
}(Subscriber_1.Subscriber));
function dispatchNext(arg) {
    var subscriber = arg.subscriber;
    subscriber.clearThrottle();
}
//# sourceMappingURL=throttleTime.js.map

/***/ }),

/***/ "KLoZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var root_1 = __webpack_require__("VOfZ");
function assignImpl(target) {
    var sources = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        sources[_i - 1] = arguments[_i];
    }
    var len = sources.length;
    for (var i = 0; i < len; i++) {
        var source = sources[i];
        for (var k in source) {
            if (source.hasOwnProperty(k)) {
                target[k] = source[k];
            }
        }
    }
    return target;
}
exports.assignImpl = assignImpl;
;
function getAssign(root) {
    return root.Object.assign || assignImpl;
}
exports.getAssign = getAssign;
exports.assign = getAssign(root_1.root);
//# sourceMappingURL=assign.js.map

/***/ }),

/***/ "KN8t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("3j3K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_platform_browser__ = __webpack_require__("Qbdm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_animations_browser__ = __webpack_require__("1GJ2");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BrowserAnimationsModule; });
/* unused harmony export NoopAnimationsModule */
/* unused harmony export ɵAnimationRenderer */
/* unused harmony export ɵAnimationRendererFactory */
/* unused harmony export ɵe */
/* unused harmony export ɵf */
/* unused harmony export ɵa */
/* unused harmony export ɵc */
/* unused harmony export ɵd */
/* unused harmony export ɵb */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * @license Angular v4.1.0
 * (c) 2010-2017 Google, Inc. https://angular.io/
 * License: MIT
 */



/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var AnimationRendererFactory = (function () {
    /**
     * @param {?} delegate
     * @param {?} _engine
     * @param {?} _zone
     */
    function AnimationRendererFactory(delegate, _engine, _zone) {
        this.delegate = delegate;
        this._engine = _engine;
        this._zone = _zone;
    }
    /**
     * @param {?} hostElement
     * @param {?} type
     * @return {?}
     */
    AnimationRendererFactory.prototype.createRenderer = function (hostElement, type) {
        var _this = this;
        var /** @type {?} */ delegate = this.delegate.createRenderer(hostElement, type);
        if (!hostElement || !type || !type.data || !type.data['animation'])
            return delegate;
        var /** @type {?} */ namespaceId = type.id;
        var /** @type {?} */ animationTriggers = (type.data['animation']);
        animationTriggers.forEach(function (trigger) { return _this._engine.registerTrigger(trigger, namespaceify(namespaceId, trigger.name)); });
        return new AnimationRenderer(delegate, this._engine, this._zone, namespaceId);
    };
    return AnimationRendererFactory;
}());
AnimationRendererFactory.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
];
/**
 * @nocollapse
 */
AnimationRendererFactory.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["RendererFactory2"], },
    { type: __WEBPACK_IMPORTED_MODULE_2__angular_animations_browser__["a" /* ɵAnimationEngine */], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgZone"], },
]; };
var AnimationRenderer = (function () {
    /**
     * @param {?} delegate
     * @param {?} _engine
     * @param {?} _zone
     * @param {?} _namespaceId
     */
    function AnimationRenderer(delegate, _engine, _zone, _namespaceId) {
        this.delegate = delegate;
        this._engine = _engine;
        this._zone = _zone;
        this._namespaceId = _namespaceId;
        this.destroyNode = null;
        this._flushPromise = null;
        this.destroyNode = this.delegate.destroyNode ? function (n) { return delegate.destroyNode(n); } : null;
    }
    Object.defineProperty(AnimationRenderer.prototype, "data", {
        /**
         * @return {?}
         */
        get: function () { return this.delegate.data; },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    AnimationRenderer.prototype.destroy = function () { this.delegate.destroy(); };
    /**
     * @param {?} name
     * @param {?=} namespace
     * @return {?}
     */
    AnimationRenderer.prototype.createElement = function (name, namespace) {
        return this.delegate.createElement(name, namespace);
    };
    /**
     * @param {?} value
     * @return {?}
     */
    AnimationRenderer.prototype.createComment = function (value) { return this.delegate.createComment(value); };
    /**
     * @param {?} value
     * @return {?}
     */
    AnimationRenderer.prototype.createText = function (value) { return this.delegate.createText(value); };
    /**
     * @param {?} selectorOrNode
     * @return {?}
     */
    AnimationRenderer.prototype.selectRootElement = function (selectorOrNode) {
        return this.delegate.selectRootElement(selectorOrNode);
    };
    /**
     * @param {?} node
     * @return {?}
     */
    AnimationRenderer.prototype.parentNode = function (node) { return this.delegate.parentNode(node); };
    /**
     * @param {?} node
     * @return {?}
     */
    AnimationRenderer.prototype.nextSibling = function (node) { return this.delegate.nextSibling(node); };
    /**
     * @param {?} el
     * @param {?} name
     * @param {?} value
     * @param {?=} namespace
     * @return {?}
     */
    AnimationRenderer.prototype.setAttribute = function (el, name, value, namespace) {
        this.delegate.setAttribute(el, name, value, namespace);
    };
    /**
     * @param {?} el
     * @param {?} name
     * @param {?=} namespace
     * @return {?}
     */
    AnimationRenderer.prototype.removeAttribute = function (el, name, namespace) {
        this.delegate.removeAttribute(el, name, namespace);
    };
    /**
     * @param {?} el
     * @param {?} name
     * @return {?}
     */
    AnimationRenderer.prototype.addClass = function (el, name) { this.delegate.addClass(el, name); };
    /**
     * @param {?} el
     * @param {?} name
     * @return {?}
     */
    AnimationRenderer.prototype.removeClass = function (el, name) { this.delegate.removeClass(el, name); };
    /**
     * @param {?} el
     * @param {?} style
     * @param {?} value
     * @param {?} flags
     * @return {?}
     */
    AnimationRenderer.prototype.setStyle = function (el, style, value, flags) {
        this.delegate.setStyle(el, style, value, flags);
    };
    /**
     * @param {?} el
     * @param {?} style
     * @param {?} flags
     * @return {?}
     */
    AnimationRenderer.prototype.removeStyle = function (el, style, flags) {
        this.delegate.removeStyle(el, style, flags);
    };
    /**
     * @param {?} node
     * @param {?} value
     * @return {?}
     */
    AnimationRenderer.prototype.setValue = function (node, value) { this.delegate.setValue(node, value); };
    /**
     * @param {?} parent
     * @param {?} newChild
     * @return {?}
     */
    AnimationRenderer.prototype.appendChild = function (parent, newChild) {
        var _this = this;
        this._engine.onInsert(newChild, function () { return _this.delegate.appendChild(parent, newChild); });
        this._queueFlush();
    };
    /**
     * @param {?} parent
     * @param {?} newChild
     * @param {?} refChild
     * @return {?}
     */
    AnimationRenderer.prototype.insertBefore = function (parent, newChild, refChild) {
        var _this = this;
        this._engine.onInsert(newChild, function () { return _this.delegate.insertBefore(parent, newChild, refChild); });
        this._queueFlush();
    };
    /**
     * @param {?} parent
     * @param {?} oldChild
     * @return {?}
     */
    AnimationRenderer.prototype.removeChild = function (parent, oldChild) {
        var _this = this;
        this._engine.onRemove(oldChild, function () {
            // Note: if an component element has a leave animation, and the component
            // a host leave animation, the view engine will call `removeChild` for the parent
            // component renderer as well as for the child component renderer.
            // Therefore, we need to check if we already removed the element.
            if (_this.delegate.parentNode(oldChild)) {
                _this.delegate.removeChild(parent, oldChild);
            }
        });
        this._queueFlush();
    };
    /**
     * @param {?} el
     * @param {?} name
     * @param {?} value
     * @return {?}
     */
    AnimationRenderer.prototype.setProperty = function (el, name, value) {
        if (name.charAt(0) == '@') {
            this._engine.setProperty(el, namespaceify(this._namespaceId, name.substr(1)), value);
            this._queueFlush();
        }
        else {
            this.delegate.setProperty(el, name, value);
        }
    };
    /**
     * @param {?} target
     * @param {?} eventName
     * @param {?} callback
     * @return {?}
     */
    AnimationRenderer.prototype.listen = function (target, eventName, callback) {
        var _this = this;
        if (eventName.charAt(0) == '@') {
            var /** @type {?} */ element = resolveElementFromTarget(target);
            var _a = parseTriggerCallbackName(eventName.substr(1)), name = _a[0], phase = _a[1];
            return this._engine.listen(element, namespaceify(this._namespaceId, name), phase, function (event) {
                var /** @type {?} */ e = (event);
                if (e.triggerName) {
                    e.triggerName = deNamespaceify(_this._namespaceId, e.triggerName);
                }
                _this._zone.run(function () { return callback(event); });
            });
        }
        return this.delegate.listen(target, eventName, callback);
    };
    /**
     * @return {?}
     */
    AnimationRenderer.prototype._queueFlush = function () {
        var _this = this;
        if (!this._flushPromise) {
            this._zone.runOutsideAngular(function () {
                _this._flushPromise = Promise.resolve(null).then(function () {
                    _this._flushPromise = ((null));
                    _this._engine.flush();
                });
            });
        }
    };
    return AnimationRenderer;
}());
/**
 * @param {?} target
 * @return {?}
 */
function resolveElementFromTarget(target) {
    switch (target) {
        case 'body':
            return document.body;
        case 'document':
            return document;
        case 'window':
            return window;
        default:
            return target;
    }
}
/**
 * @param {?} triggerName
 * @return {?}
 */
function parseTriggerCallbackName(triggerName) {
    var /** @type {?} */ dotIndex = triggerName.indexOf('.');
    var /** @type {?} */ trigger = triggerName.substring(0, dotIndex);
    var /** @type {?} */ phase = triggerName.substr(dotIndex + 1);
    return [trigger, phase];
}
/**
 * @param {?} namespaceId
 * @param {?} value
 * @return {?}
 */
function namespaceify(namespaceId, value) {
    return namespaceId + "#" + value;
}
/**
 * @param {?} namespaceId
 * @param {?} value
 * @return {?}
 */
function deNamespaceify(namespaceId, value) {
    return value.replace(namespaceId + '#', '');
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var InjectableAnimationEngine = (function (_super) {
    __extends(InjectableAnimationEngine, _super);
    /**
     * @param {?} driver
     * @param {?} normalizer
     */
    function InjectableAnimationEngine(driver, normalizer) {
        return _super.call(this, driver, normalizer) || this;
    }
    return InjectableAnimationEngine;
}(__WEBPACK_IMPORTED_MODULE_2__angular_animations_browser__["b" /* ɵDomAnimationEngine */]));
InjectableAnimationEngine.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
];
/**
 * @nocollapse
 */
InjectableAnimationEngine.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_2__angular_animations_browser__["c" /* AnimationDriver */], },
    { type: __WEBPACK_IMPORTED_MODULE_2__angular_animations_browser__["d" /* ɵAnimationStyleNormalizer */], },
]; };
/**
 * @return {?}
 */
function instantiateSupportedAnimationDriver() {
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__angular_animations_browser__["e" /* ɵsupportsWebAnimations */])()) {
        return new __WEBPACK_IMPORTED_MODULE_2__angular_animations_browser__["f" /* ɵWebAnimationsDriver */]();
    }
    return new __WEBPACK_IMPORTED_MODULE_2__angular_animations_browser__["g" /* ɵNoopAnimationDriver */]();
}
/**
 * @return {?}
 */
function instantiateDefaultStyleNormalizer() {
    return new __WEBPACK_IMPORTED_MODULE_2__angular_animations_browser__["h" /* ɵWebAnimationsStyleNormalizer */]();
}
/**
 * @param {?} renderer
 * @param {?} engine
 * @param {?} zone
 * @return {?}
 */
function instantiateRendererFactory(renderer, engine, zone) {
    return new AnimationRendererFactory(renderer, engine, zone);
}
/**
 * Separate providers from the actual module so that we can do a local modification in Google3 to
 * include them in the BrowserModule.
 */
var BROWSER_ANIMATIONS_PROVIDERS = [
    { provide: __WEBPACK_IMPORTED_MODULE_2__angular_animations_browser__["c" /* AnimationDriver */], useFactory: instantiateSupportedAnimationDriver },
    { provide: __WEBPACK_IMPORTED_MODULE_2__angular_animations_browser__["d" /* ɵAnimationStyleNormalizer */], useFactory: instantiateDefaultStyleNormalizer },
    { provide: __WEBPACK_IMPORTED_MODULE_2__angular_animations_browser__["a" /* ɵAnimationEngine */], useClass: InjectableAnimationEngine }, {
        provide: __WEBPACK_IMPORTED_MODULE_0__angular_core__["RendererFactory2"],
        useFactory: instantiateRendererFactory,
        deps: [__WEBPACK_IMPORTED_MODULE_1__angular_platform_browser__["ɵDomRendererFactory2"], __WEBPACK_IMPORTED_MODULE_2__angular_animations_browser__["a" /* ɵAnimationEngine */], __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgZone"]]
    }
];
/**
 * Separate providers from the actual module so that we can do a local modification in Google3 to
 * include them in the BrowserTestingModule.
 */
var BROWSER_NOOP_ANIMATIONS_PROVIDERS = [
    { provide: __WEBPACK_IMPORTED_MODULE_2__angular_animations_browser__["a" /* ɵAnimationEngine */], useClass: __WEBPACK_IMPORTED_MODULE_2__angular_animations_browser__["i" /* ɵNoopAnimationEngine */] }, {
        provide: __WEBPACK_IMPORTED_MODULE_0__angular_core__["RendererFactory2"],
        useFactory: instantiateRendererFactory,
        deps: [__WEBPACK_IMPORTED_MODULE_1__angular_platform_browser__["ɵDomRendererFactory2"], __WEBPACK_IMPORTED_MODULE_2__angular_animations_browser__["a" /* ɵAnimationEngine */], __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgZone"]]
    }
];
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * \@experimental Animation support is experimental.
 */
var BrowserAnimationsModule = (function () {
    function BrowserAnimationsModule() {
    }
    return BrowserAnimationsModule;
}());
BrowserAnimationsModule.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{
                imports: [__WEBPACK_IMPORTED_MODULE_1__angular_platform_browser__["BrowserModule"]],
                providers: BROWSER_ANIMATIONS_PROVIDERS,
            },] },
];
/**
 * @nocollapse
 */
BrowserAnimationsModule.ctorParameters = function () { return []; };
/**
 * \@experimental Animation support is experimental.
 */
var NoopAnimationsModule = (function () {
    function NoopAnimationsModule() {
    }
    return NoopAnimationsModule;
}());
NoopAnimationsModule.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{
                imports: [__WEBPACK_IMPORTED_MODULE_1__angular_platform_browser__["BrowserModule"]],
                providers: BROWSER_NOOP_ANIMATIONS_PROVIDERS,
            },] },
];
/**
 * @nocollapse
 */
NoopAnimationsModule.ctorParameters = function () { return []; };
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @module
 * @description
 * Entry point for all animation APIs of the animation browser package.
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @module
 * @description
 * Entry point for all public APIs of the animation package.
 */
/**
 * Generated bundle index. Do not edit.
 */

//# sourceMappingURL=animations.es5.js.map


/***/ }),

/***/ "KR5E":
/***/ (function(module, exports) {

exports.config = {"status":true,"model":{"js":["reversi-model.js"],"plazza":"true","released":1409239768,"title-en":"Annexation Turn-Over","module":"reversi","summary":"Reversi/Othello rules on a 10x10 octogonal-shaped board","thumbnail":"thumb-turnover.png","rules":{"en":"rules-turnover.html"},"credits":{"en":"credits.html"},"description":{"en":"description.html"},"gameOptions":{"preventRepeat":true,"uctTransposition":"state","levelOptions":{"stableFactor":20,"aboutStableFactor":-20,"aboutStableBorderFactor":-15,"borderFactor":5,"aboutBorderFactor":-4,"countFactor":1,"mobilityFactor":5},"width":10,"height":10,"deadCells":{"0:0":"#","0:1":"#","0:2":"#","1:0":"#","1:1":"#","2:0":"#","7:0":"#","8:0":"#","8:1":"#","9:0":"#","9:1":"#","9:2":"#","0:7":"#","0:8":"#","0:9":"#","1:8":"#","1:9":"#","2:9":"#","7:9":"#","8:8":"#","8:9":"#","9:7":"#","9:8":"#","9:9":"#"},"initial":{"1":["4:5","5:4"],"-1":["5:5","4:4"]}},"debugEval":true,"levels":[{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.65,"ignoreLeaf":false,"log":true,"uncertaintyFactor":3,"name":"easy","label":"Easy","maxNodes":1000},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.65,"ignoreLeaf":false,"log":true,"uncertaintyFactor":3,"name":"fast","label":"Fast [1sec]","maxDuration":1,"isDefault":true},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.65,"ignoreLeaf":false,"log":true,"uncertaintyFactor":3,"name":"medium","label":"Medium","maxNodes":10000,"maxDuration":10},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.65,"ignoreLeaf":false,"log":true,"uncertaintyFactor":3,"name":"strong","label":"Strong","maxNodes":20000,"maxDuration":15}]},"view":{"title-en":"Annex View","js":["reversi-xd-view.js"],"xdView":true,"useNotation":true,"useShowMoves":true,"module":"reversi","skins":[{"name":"classic3d","title":"3D Classic","3d":true,"camera":{"radius":14,"elevationAngle":45,"distMax":39.5,"distMin":10.1,"elevationMin":-89.9,"elevationMax":89.9,"limitCamMoves":true,"fov":45},"world":{"lightIntensity":0.7,"skyLightIntensity":0.3,"lightPosition":{"x":10,"y":18,"z":0},"lightShadowDarkness":0.35,"color":4686804,"ambientLightColor":5592405,"fog":false},"preload":["image|/res/xd-view/pass-dark.png","image|/res/xd-view/pass-light.png","image|/res/images/wood-chipboard-5.jpg","image|/res/xd-view/reversi-pieces-2-textures.png","image|/res/xd-view/reversi-pieces-2-textures-bump.png","smoothedfilegeo|0|/res/xd-view/ring-target.js","smoothedfilegeo|0|/res/xd-view/reversi-pieces-6.js"]},{"name":"classic2d","title":"2D Classic","preload":["image|/res/xd-view/pass-dark.png","image|/res/xd-view/pass-light.png","image|/res/xd-view/boardtexture.jpg","image|/res/xd-view/cellshadows.png","image|/res/xd-view/sprites.png","image|/res/xd-view/select-target-2d.png"]}],"visuals":{"600x600":["res/visuals/turnover-600x600-3d.jpg","res/visuals/turnover-600x600-2d.jpg"]}}}

/***/ }),

/***/ "KRCp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var let_1 = __webpack_require__("sb+e");
Observable_1.Observable.prototype.let = let_1.letProto;
Observable_1.Observable.prototype.letBind = let_1.letProto;
//# sourceMappingURL=let.js.map

/***/ }),

/***/ "KjKy":
/***/ (function(module, exports) {

exports.config = {"status":true,"model":{"js":["reversi-model.js"],"plazza":"true","released":1409239768,"title-en":"Annexation 6","module":"reversi","summary":"Reversi/Othello rules on a 6x6 board","thumbnail":"thumb-reversi6.png","rules":{"en":"rules-reversi6.html"},"credits":{"en":"credits.html"},"description":{"en":"description.html"},"gameOptions":{"preventRepeat":true,"uctTransposition":"state","levelOptions":{"stableFactor":20,"aboutStableFactor":-20,"aboutStableBorderFactor":-15,"borderFactor":5,"aboutBorderFactor":-4,"countFactor":1,"mobilityFactor":5},"width":6,"height":6,"initial":{"1":["2:3","3:2"],"-1":["2:2","3:3"]}},"debugEval":true,"levels":[{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.65,"ignoreLeaf":false,"log":true,"uncertaintyFactor":3,"name":"easy","label":"Easy","maxNodes":1000},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.65,"ignoreLeaf":false,"log":true,"uncertaintyFactor":3,"name":"fast","label":"Fast [1sec]","maxDuration":1,"isDefault":true},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.65,"ignoreLeaf":false,"log":true,"uncertaintyFactor":3,"name":"medium","label":"Medium","maxNodes":10000,"maxDuration":10},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.65,"ignoreLeaf":false,"log":true,"uncertaintyFactor":3,"name":"strong","label":"Strong","maxNodes":20000,"maxDuration":15}]},"view":{"title-en":"Annex View","js":["reversi-xd-view.js"],"xdView":true,"useNotation":true,"useShowMoves":true,"module":"reversi","skins":[{"name":"classic3d","title":"3D Classic","3d":true,"camera":{"radius":14,"elevationAngle":45,"distMax":39.5,"distMin":10.1,"elevationMin":-89.9,"elevationMax":89.9,"limitCamMoves":true,"fov":45},"world":{"lightIntensity":0.7,"skyLightIntensity":0.3,"lightPosition":{"x":10,"y":18,"z":0},"lightShadowDarkness":0.35,"color":4686804,"ambientLightColor":5592405,"fog":false},"preload":["image|/res/xd-view/pass-dark.png","image|/res/xd-view/pass-light.png","image|/res/images/wood-chipboard-5.jpg","image|/res/xd-view/reversi-pieces-2-textures.png","image|/res/xd-view/reversi-pieces-2-textures-bump.png","smoothedfilegeo|0|/res/xd-view/ring-target.js","smoothedfilegeo|0|/res/xd-view/reversi-pieces-6.js"]},{"name":"classic2d","title":"2D Classic","preload":["image|/res/xd-view/pass-dark.png","image|/res/xd-view/pass-light.png","image|/res/xd-view/boardtexture.jpg","image|/res/xd-view/cellshadows.png","image|/res/xd-view/sprites.png","image|/res/xd-view/select-target-2d.png"]}],"visuals":{"600x600":["res/visuals/reversi6-600x600-3d.jpg","res/visuals/reversi6-600x600-2d.jpg"]}}}

/***/ }),

/***/ "KmfD":
/***/ (function(module, exports) {

exports.model=Model={Game:{},Board:{},Move:{}},function(){var t;Model.Game.cbConstants={MASK:65535,FLAG_MOVE:65536,FLAG_CAPTURE:131072,FLAG_STOP:262144,FLAG_SCREEN_CAPTURE:524288,FLAG_CAPTURE_KING:1048576,FLAG_CAPTURE_NO_KING:2097152};var e="undefined"!=typeof Int32Array;Model.Game.cbUseTypedArrays=e,Model.Game.cbTypedArray=function(t){if(e){var r=new Int32Array(t.length);return r.set(t),r}for(var a=[],i=t.length,n=0;n<i;n++)a.push(t[n]);return a},Model.Game.cbShortRangeGraph=function(t,e,r,a){var i=this;void 0===a&&(a=196608);for(var n={},s=0;s<t.boardSize;s++)n[s]=[],(!r||s in r)&&e.forEach(function(e){var o=t.Graph(s,e);null!=o&&(!r||o in r)&&n[s].push(i.cbTypedArray([o|a]))});return n},Model.Game.cbLongRangeGraph=function(t,e,r,a,i){var n=this;void 0!==a&&null!=a||(a=196608),i||(i=1/0);for(var s={},o=0;o<t.boardSize;o++)s[o]=[],(!r||o in r)&&e.forEach(function(e){for(var h=[],c=t.Graph(o,e),p=0;null!=c&&(!r||c in r)&&(h.push(c|a),++p!=i);)c=t.Graph(c,e);h.length>0&&s[o].push(n.cbTypedArray(h))});return s},Model.Game.cbNullGraph=function(t){for(var e={},r=0;r<t.boardSize;r++)e[r]=[];return e},Model.Game.cbAuthorGraph=function(t){for(var e={},r=0;r<t.boardSize;r++){e[r]=[];for(var a=0;a<t.boardSize;a++)e[r].push([2293760|a])}return e},Model.Game.cbMergeGraphs=function(t){for(var e=[],r=0;r<t.boardSize;r++){e[r]=[];for(var a=1;a<arguments.length;a++)e[r]=e[r].concat(arguments[a][r])}return e},Model.Game.cbGetThreatGraph=function(){function t(e,r){for(var a in s){var i=s[a];if(!(i.p.length<r.length+1)){for(var n=!0,o=0;o<r.length;o++)if(r[o]!=i.p[o]){n=!1;break}if(n){var h=i.p[r.length],c=e[h];void 0===c&&(c={e:{}},e[h]=c),i.p.length==r.length+1&&(c.t=i.t,c.ts=i.ts,c.tk=i.tk,delete s[a]),r.push(h),t(c.e,r),r.pop()}}}}var e=this;this.cbUseScreenCapture=!1,this.cbUseCaptureKing=!1,this.cbUseCaptureNoKing=!1;for(var r={1:[],"-1":[]},a=[],i=0;i<this.g.boardSize;i++)this.g.pTypes.forEach(function(t,r){t.graph[i].forEach(function(t){for(var n=[],s=0;s<t.length;s++){var o=t[s];1048576&o?(e.cbUseCaptureKing=!0,n.unshift({d:65535&o,a:i,tk:r})):2097152&o?(e.cbUseCaptureNoKing=!0,n.unshift({d:65535&o,a:i,tnk:r})):131072&o?n.unshift({d:65535&o,a:i,t:r}):262144&o?n.unshift({d:65535&o,a:i}):524288&o&&(e.cbUseScreenCapture=!0,n.unshift({d:65535&o,a:i,ts:r}))}n.length>0&&a.push(n)})});var n={};a.forEach(function(t){t.forEach(function(e,r){var a=n[e.d];void 0===a&&(a={},n[e.d]=a);for(var i=[],s=r+1;s<t.length;s++)i.push(t[s].d);i.push(e.a);var o=i.join(","),h=a[o];void 0===h&&(h={p:i,t:{},ts:{},tk:{}},a[o]=h),void 0!==e.t?h.t[e.t]=!0:void 0!==e.tk?h.tk[e.tk]=!0:void 0!==e.ts&&(h.ts[e.ts]=!0)})});for(var i=0;i<e.g.boardSize;i++){var s=n[i],o={};t(o,[]),r[1][i]=o,r[-1][i]=o}return r},Model.Game.InitGame=function(){var e=this;this.cbVar=t=this.cbDefine(),this.g.boardSize=this.cbVar.geometry.boardSize,this.g.pTypes=this.cbGetPieceTypes(),this.g.threatGraph=this.cbGetThreatGraph(),this.g.distGraph=this.cbVar.geometry.GetDistances(),this.cbPiecesCount=0,this.g.castleablePiecesCount={1:0,"-1":0};for(var r in t.pieceTypes){var a=t.pieceTypes[r];if(a.castle){(a.initial||[]).forEach(function(t){e.g.castleablePiecesCount[t.s]++})}a.initial&&(this.cbPiecesCount+=a.initial.length)}for(var i=[],r=0;r<this.cbPiecesCount;r++)i.push(r);var n=Object.keys(t.pieceTypes);this.zobrist=new JocGame.Zobrist({board:{type:"array",size:this.cbVar.geometry.boardSize,values:i},who:{values:["1","-1"]},type:{type:"array",size:this.cbPiecesCount,values:n}})},Model.Game.cbGetPieceTypes=function(){for(var t=[],e={},r=0;r<this.cbVar.geometry.boardSize;r++)e[r]=[];for(var a in this.cbVar.pieceTypes){var i=this.cbVar.pieceTypes[a];t[a]={graph:i.graph||e,abbrev:i.abbrev||"",value:i.isKing?100:i.value||1,isKing:!!i.isKing,castle:!!i.castle,epTarget:!!i.epTarget,epCatch:!!i.epCatch}}return t},Model.Board.Init=function(t){this.zSign=0},Model.Board.InitialPosition=function(r){var a=this;this.board=e?new Int16Array(r.g.boardSize):[];for(var i=0;i<r.g.boardSize;i++)this.board[i]=-1;if(this.kings={},this.pieces=[],this.ending={1:!1,"-1":!1},this.lastMove=null,r.cbVar.castle&&(this.castled={1:!1,"-1":!1}),this.zSign=r.zobrist.update(0,"who",-1),this.noCaptCount=0,this.mWho=1,r.mInitial)this.mWho=r.mInitial.turn||1,r.mInitial.pieces.forEach(function(t){var e={};for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);a.pieces.push(e)}),r.mInitial.lastMove&&(this.lastMove={f:r.mInitial.lastMove.f,t:r.mInitial.lastMove.t}),void 0!==r.mInitial.noCaptCount&&(this.noCaptCount=r.mInitial.noCaptCount),r.cbVar.castle&&r.mInitial.castle&&(this.castled={1:{k:!!r.mInitial.castle[1]&&!!r.mInitial.castle[1].k,q:!!r.mInitial.castle[1]&&!!r.mInitial.castle[1].q},"-1":{k:!!r.mInitial.castle[-1]&&!!r.mInitial.castle[-1].k,q:!!r.mInitial.castle[-1]&&!!r.mInitial.castle[-1].q}});else for(var n in r.cbVar.pieceTypes)for(var s=r.cbVar.pieceTypes[n],o=s.initial||[],h=0;h<o.length;h++){var c=o[h],p={s:c.s,t:parseInt(n),p:c.p,m:!1};this.pieces.push(p)}if(this.pieces.sort(function(t,e){if(t.s!=e.s)return e.s-t.s;var a=r.cbVar.pieceTypes[t.t].value||100,i=r.cbVar.pieceTypes[e.t].value||100;return a!=i?a-i:t.p-e.p}),this.pieces.forEach(function(t,e){t.i=e,a.board[t.p]=e,r.g.pTypes[t.t].isKing&&(a.kings[t.s]=t.p),a.zSign=r.zobrist.update(a.zSign,"board",e,t.p),a.zSign=r.zobrist.update(a.zSign,"type",t.t,e)}),r.mInitial&&r.mInitial.enPassant){var i=t.geometry.PosByName(r.mInitial.enPassant);if(i>=0){var l,u=t.geometry.C(i),v=t.geometry.R(i);l=1==r.mInitial.turn?t.geometry.POS(u,v-1):t.geometry.POS(u,v+1),this.epTarget={p:i,i:this.board[l]}}}},Model.Board.CopyFrom=function(t){if(e)this.board=new Int16Array(t.board.length),this.board.set(t.board);else{this.board=[];for(var r=t.board,a=r.length,i=0;i<a;i++)this.board.push(r[i])}this.pieces=[];for(var n=t.pieces.length,i=0;i<n;i++){var s=t.pieces[i];this.pieces.push({s:s.s,p:s.p,t:s.t,i:s.i,m:s.m})}this.kings={1:t.kings[1],"-1":t.kings[-1]},this.check=t.check,t.lastMove?this.lastMove={f:t.lastMove.f,t:t.lastMove.t,c:t.lastMove.c}:this.lastMove=null,this.ending={1:t.ending[1],"-1":t.ending[-1]},void 0!==t.castled&&(this.castled={1:t.castled[1],"-1":t.castled[-1]}),this.noCaptCount=t.noCaptCount,t.epTarget?this.epTarget={p:t.epTarget.p,i:t.epTarget.i}:this.epTarget=null,this.mWho=t.mWho,this.zSign=t.zSign},Model.Board.cbApplyCastle=function(t,e,r){var a=t.cbVar.castle[e.f+"/"+e.cg],i=a.r[a.r.length-1],n=this.pieces[this.board[e.cg]],s=a.k[a.k.length-1],o=this.pieces[this.board[e.f]];return r&&(this.zSign=t.zobrist.update(this.zSign,"board",n.i,e.cg),this.zSign=t.zobrist.update(this.zSign,"board",n.i,i),this.zSign=t.zobrist.update(this.zSign,"board",o.i,e.f),this.zSign=t.zobrist.update(this.zSign,"board",o.i,s)),n.p=i,n.m=!0,this.board[e.cg]=-1,o.p=s,o.m=!0,this.board[e.f]=-1,this.board[i]=n.i,this.board[s]=o.i,this.castled[n.s]=!0,this.kings[o.s]=s,[{i:n.i,f:i,t:-1},{i:o.i,f:s,t:e.f,kp:e.f,who:o.s,m:!1},{i:n.i,f:-1,t:e.cg,m:!1,cg:!1}]},Model.Board.cbQuickApply=function(t,e){if(void 0!==e.cg)return this.cbApplyCastle(t,e,!1);var r=[],a=this.board[e.f],i=this.pieces[a];if(null!=e.c){r.unshift({i:e.c,f:-1,t:this.pieces[e.c].p});var n=this.pieces[e.c];this.board[n.p]=-1,n.p=-1}var s=this.kings[i.s];return t.g.pTypes[i.t].isKing&&(this.kings[i.s]=e.t),r.unshift({i:a,f:e.t,t:e.f,kp:s,who:i.s,ty:i.t}),i.p=e.t,void 0!==e.pr&&(i.t=e.pr),this.board[e.f]=-1,this.board[e.t]=a,r},Model.Board.cbQuickUnapply=function(t,e){for(var r=0;r<e.length;r++){var a=e[r],i=this.pieces[a.i];a.f>=0&&(i.p=-1,this.board[a.f]=-1),a.t>=0&&(i.p=a.t,this.board[a.t]=a.i),void 0!==a.m&&(i.m=a.m),void 0!==a.kp&&(this.kings[a.who]=a.kp),void 0!=a.ty&&(i.t=a.ty),void 0!=a.cg&&(this.castled[i.s]=a.cg)}},Model.Board.ApplyMove=function(t,e){var r=this.pieces[this.board[e.f]];if(void 0!==e.cg)this.cbApplyCastle(t,e,!0);else{if(this.zSign=t.zobrist.update(this.zSign,"board",r.i,e.f),this.board[r.p]=-1,void 0!==e.pr&&(this.zSign=t.zobrist.update(this.zSign,"type",r.t,r.i),r.t=e.pr,this.zSign=t.zobrist.update(this.zSign,"type",r.t,r.i)),null!=e.c){var a=this.pieces[e.c];this.zSign=t.zobrist.update(this.zSign,"board",a.i,a.p),this.board[a.p]=-1,a.p=-1,a.m=!0,this.noCaptCount=0}else this.noCaptCount++;r.p=e.t,r.m=!0,this.board[e.t]=r.i,this.zSign=t.zobrist.update(this.zSign,"board",r.i,e.t),t.g.pTypes[r.t].isKing&&(this.kings[r.s]=e.t)}this.check=!!e.ck,this.lastMove={f:e.f,t:e.t,c:e.c},void 0!==e.ko&&(this.ending[r.s]=e.ko),void 0!==e.ept?this.epTarget={p:e.ept,i:r.i}:this.epTarget=null,this.zSign=t.zobrist.update(this.zSign,"who",-this.mWho),this.zSign=t.zobrist.update(this.zSign,"who",this.mWho)},Model.Board.Evaluate=function(r){function a(e){var r=1/0;for(var a in t.geometry.corners)r=Math.min(r,h.distGraph[n.kings[e]][a]);return r-Math.sqrt(h.boardSize)}var i="debug"==arguments[3],n=this;this.mEvaluation=0;var s,o=this.mWho,h=r.g;if(e)s={1:{count:new Uint8Array(h.pTypes.length),byType:{}},"-1":{count:new Uint8Array(h.pTypes.length),byType:{}}};else{s={1:{count:[],byType:{}},"-1":{count:[],byType:{}}};for(var c=0;c<h.pTypes.length;c++)s[1].count[c]=s[-1].count[c]=0}if(r.mOptions.preventRepeat&&r.GetRepeatOccurence(this)>2)return this.mFinished=!0,void(this.mWinner=r.cbOnPerpetual?o*r.cbOnPerpetual:JocGame.DRAW);for(var p={1:0,"-1":0},l={1:h.distGraph[this.kings[-1]],"-1":h.distGraph[this.kings[1]]},u={1:0,"-1":0},v={1:0,"-1":0},b={1:0,"-1":0},f={1:0,"-1":0},g={1:!1,"-1":!1},d=this.pieces,m=d.length,c=0;c<m;c++){var G=d[c];if(G.p>=0){var y=G.s,M=h.pTypes[G.t];M.isKing?g[y]=G.m:p[y]+=M.value,M.castle&&!G.m&&f[y]++,v[y]++,u[y]+=l[y][G.p],b[y]+=t.geometry.distEdge[G.p];var C=s[y];C.count[G.t]++;var S=C.byType;void 0===S[G.t]?S[G.t]=[G]:S[G.t].push(G)}}if(this.lastMove&&null!=this.lastMove.c){var G=this.pieces[this.board[this.lastMove.t]];p[-G.s]+=this.cbStaticExchangeEval(r,G.p,G.s,{piece:G})}var k={1:0,"-1":0},A={1:0,"-1":0},T={1:0,"-1":0};this.ending[1]&&(A[1]=(u[1]-Math.sqrt(h.boardSize))/v[1],t.geometry.corners&&(T[1]=a(1))),this.ending[-1]&&(A[-1]=(u[-1]-Math.sqrt(h.boardSize))/v[-1],t.geometry.corners&&(T[1]=a(-1)));var z={pieceValue:p[1]-p[-1],pieceValueRatio:(p[1]-p[-1])/(p[1]+p[-1]+1),posValue:b[1]-b[-1],averageDistKing:u[1]/v[1]-u[-1]/v[-1],check:this.check?-o:0,endingKingFreedom:k[1]-k[-1],endingDistKing:A[1]-A[-1],distKingCorner:T[1]-T[-1]};t.castle&&(z.castle=(this.castled[1]?1:g[1]?0:f[1]/(h.castleablePiecesCount[1]+1))-(this.castled[-1]?1:g[-1]?0:f[-1]/(h.castleablePiecesCount[-1]+1))),t.evaluate&&t.evaluate.call(this,r,z,s);var E=r.mOptions.levelOptions;for(var P in z){var w=z[P],I=E[P+"Factor"]||0,R=w*I;i&&console.log(P,"=",w,"*",I,"=>",R),this.mEvaluation+=R}i&&console.log("Evaluation",this.mEvaluation)},Model.Board.cbGeneratePseudoLegalMoves=function(t){function e(e,i){var n=t.cbVar.promote;if(!n)return void a.push(i);var s=n.call(r,t,e,i);if(null!=s)if(0==s.length)a.push(i);else if(1==s.length)i.pr=s[0],a.push(i);else for(var o=0;o<s.length;o++){var h=s[o];a.push({f:i.f,t:i.t,c:i.c,pr:h,ept:i.ept,ep:i.ep,a:i.a})}}for(var r=this,a=[],i=t.cbVar,n=this.mWho,s=!i.castle||this.check||this.castled[n]?null:[],o=-1,h=this.pieces.length,c=0;c<h;c++){var p=this.pieces[c];if(!(p.p<0||p.s!=n)){var l=t.g.pTypes[p.t];l.isKing&&(p.m?s=null:o=p),s&&l.castle&&!p.m&&s.push(p);var u,v;u=l.graph[p.p],v=u.length;for(var b=0;b<v;b++)for(var f=u[b],g=!1,d=f.length,m=null,G=0;G<d;G++){var y=f[G],M=65535&y,C=this.board[M];if(!(C<0)||l.epCatch&&this.epTarget&&this.epTarget.p==M){if(!(524288&y)){var S;S=C<0?this.pieces[this.epTarget.i]:this.pieces[C],!(S.s!=p.s&&131072&y)||1048576&y&&!t.g.pTypes[S.t].isKing||2097152&y&&t.g.pTypes[S.t].isKing||e(p,{f:p.p,t:M,c:S.i,a:l.abbrev,ep:C<0});break}if(g){var S=this.pieces[C];S.s!=p.s&&e(p,{f:p.p,t:M,c:S.i,a:l.abbrev});break}g=!0}else 65536&y&&0==g&&e(p,{f:p.p,t:M,c:null,a:l.abbrev,ept:null!=m&&l.epTarget?m:void 0});m=M}}}if(s)for(var c=0;c<s.length;c++){var k=s[c],A=t.cbVar.castle[o.p+"/"+k.p];if(A){for(var T=!0,b=0;b<A.r.length;b++){var z=A.r[b];if(this.board[z]>=0&&z!=o.p&&z!=k.p){T=!1;break}}if(T){for(var E=!0,b=0;b<A.k.length;b++){var z=A.k[b];if(this.board[z]>=0&&z!=k.p&&z!=o.p||this.cbGetAttackers(t,z,n).length>0){E=!1;break}}E&&a.push({f:o.p,t:A.k[A.k.length-1],c:null,cg:k.p})}}}return a},Model.Board.cbStaticExchangeEval=function(t,e,r,a){var i=0,n=this.cbGetSmallestAttacker(t,e,r);if(n){var s=this.mWho;this.mWho=n.s;var o=this.cbQuickApply(t,{f:n.p,t:e,c:a.piece.i}),h=t.g.pTypes[a.piece.t].value;a.piece=n,i=Math.max(0,h-this.cbStaticExchangeEval(t,e,-r,a)),this.cbQuickUnapply(t,o),this.mWho=s}return i},Model.Board.cbGetSmallestAttacker=function(t,e,r){var a=this.cbGetAttackers(t,e,r);if(0==a.length)return null;for(var i=1/0,n=null,s=a.length,o=0;o<s;o++){var h=a[o],c=t.g.pTypes[h.t].value;c<i&&(i=c,n=h)}return n},Model.Board.cbCollectAttackers=function(t,e,r,a){for(var i in e){var n=e[i],s=this.board[i];if(s<0)this.cbCollectAttackers(t,n.e,r,a);else{var o=this.pieces[s];o.s==-t&&(n.t&&o.t in n.t||a&&n.tk&&o.t in n.tk)&&r.push(o)}}},Model.Board.cbCollectAttackersScreen=function(t,e,r,a,i){for(var n in e){var s=e[n],o=this.board[n];if(o<0)this.cbCollectAttackersScreen(t,s.e,r,a,i);else{var h=this.pieces[o];!i&&h.s==-t&&(s.t&&h.t in s.t||a&&s.tk&&h.t in s.tk)?r.push(h):i?i&&h.s==-t&&s.ts&&h.t in s.ts&&r.push(h):this.cbCollectAttackersScreen(t,s.e,r,a,!0)}}},Model.Board.cbGetAttackers=function(t,e,r,a){var i=[];return t.cbUseScreenCapture?this.cbCollectAttackersScreen(r,t.g.threatGraph[r][e],i,a,!1):this.cbCollectAttackers(r,t.g.threatGraph[r][e],i,a),i},Model.Board.GenerateMoves=function(t){var e=this.cbGeneratePseudoLegalMoves(t);this.mMoves=[];for(var r=!0,a=this.kings[this.mWho],i=e.length,n=0;n<i;n++){var s=e[n],o=this.cbQuickApply(t,s);if(!(this.cbGetAttackers(t,this.kings[this.mWho],this.mWho,!0).length>0)){var h=this.cbGetAttackers(t,this.kings[-this.mWho],-this.mWho,!0).length>0;s.ck=h,this.mMoves.push(s),s.f!=a&&(r=!1)}this.cbQuickUnapply(t,o)}if(0==this.mMoves.length)this.mFinished=!0,this.mWinner=t.cbOnStaleMate?t.cbOnStaleMate*this.mWho:JocGame.DRAW,this.check&&(this.mWinner=-this.mWho);else if(this.ending[this.mWho]){if(!r)for(var n=0;n<this.mMoves.length;n++)this.mMoves[n].ko=!1}else if(!this.ending[this.mWho]&&r&&!this.check)for(var n=0;n<this.mMoves.length;n++)this.mMoves[n].ko=!0},Model.Board.GetSignature=function(){return this.zSign},Model.Move.Init=function(t){for(var e in t)t.hasOwnProperty(e)&&(this[e]=t[e])},Model.Move.Equals=function(t){return this.f==t.f&&this.t==t.t&&this.pr==t.pr},Model.Move.CopyFrom=function(t){this.Init(t)},Model.Move.ToString=function(e){var r=this;switch(e=e||"natural"){case"natural":return function(){var e;if(void 0!==r.cg?e=t.castle[r.f+"/"+r.cg].n:(e=r.a||"",e+=t.geometry.PosName(r.f),null==r.c?e+="-":e+="x",e+=t.geometry.PosName(r.t)),void 0!==r.pr){var a=t.pieceTypes[r.pr];a&&a.abbrev&&a.abbrev.length>0&&!a.silentPromo&&(e+="="+a.abbrev)}return r.ck&&(e+="+"),e}();case"engine":return function(){var e=t.geometry.PosName(r.f)+t.geometry.PosName(r.t);if(void 0!=r.pr){var a=t.pieceTypes[r.pr];a&&a.abbrev&&a.abbrev.length>0&&!a.silentPromo&&(e+=a.abbrev)}return e}();default:return"??"}},Model.Board.CompactMoveString=function(e,r,a){"function"!=typeof r.ToString&&(r=e.CreateMove(r));var i=r.ToString(),n=/^([A-Z]?)([a-z])([1-9][0-9]*)([-x])([a-z])([1-9][0-9]*)(.*?)$/.exec(i);if(!n)return i;var s=n[7];if(a||(a={}),a.value||(a.value=[]),0==a.value.length){var o=this.mMoves;this.mMoves&&0!=this.mMoves.length||this.GenerateMoves(e);for(var h=0;h<this.mMoves.length;h++){var c=this.mMoves[h];"function"!=typeof c.ToString&&(c=e.CreateMove(c)),a.value.push({str:c.ToString(),move:c})}this.mMoves=o}var p=[];if(a.value.forEach(function(t){var e=/^([A-Z]?[a-z][1-9][0-9]*[-x][a-z][1-9][0-9]*)(.*?)$/.exec(t.str);e&&t.move.t==r.t&&(t.move.a||"")==n[1]&&e[2]==s&&p.push(t.move)}),1==p.length)return""==n[1]&&"x"==n[4]?n[2]+"x"+n[5]+n[6]+n[7]:n[1]+("x"==n[4]?"x":"")+n[5]+n[6]+n[7];if(t.geometry.CompactCrit)for(var l="",h=0;;h++){var u=t.geometry.CompactCrit(r.f,h);if(null==u)return i;l+=u;for(var v=[],b=0;b<p.length;b++){var f=p[b];t.geometry.CompactCrit(f.f,h)==u&&v.push(f)}if(console.assert(v.length>0),1==v.length)return n[1]+l+("x"==n[4]?"x":"")+n[5]+n[6]+n[7];p=v}return i},Model.Board.cbIntegrity=function(t){function e(t,e){t||console.error(e)}for(var r=this,a=0;a<this.board.length;a++){var i=this.board[a];if(i>=0){var n=r.pieces[i];e(void 0!==n,"no piece at pos"),e(n.p==a,"piece has different pos")}}for(var i=0;i<this.pieces.length;i++){var n=this.pieces[i];n.p>=0&&e(r.board[n.p]==i,"board index mismatch")}},Model.Board.ExportBoardState=function(t){return t.cbVar.geometry.ExportBoardState?t.cbVar.geometry.ExportBoardState(this,t.cbVar,t.mPlayedMoves.length):"not supported"},Model.Game.Import=function(e,r){var a,i=[],n={1:{},"-1":{}},s=null,o=0;if("pjn"==e){var h={status:!1,error:"parse"},c=r.split(" ");if(6!=c.length)return console.warn("FEN should have 6 parts"),h;var p=c[0].split("/"),l=t.geometry.fenHeight||t.geometry.height;if(p.length!=l)return console.warn("FEN board should have",l,"rows, got",p.length),h;var u={};for(var v in t.pieceTypes){var b=t.pieceTypes[v],f=b.fenAbbrev||b.abbrev||"X";u[f.toUpperCase()]={s:1,t:v},u[f.toLowerCase()]={s:-1,t:v}}var g=t.geometry.FenRowPos||function(e,r){return(t.geometry.height-1-e)*t.geometry.width+r};if(p.forEach(function(e,r){for(var a=0,n=0;n<e.length;n++){var s=e.substr(n,1),o=u[s];if(void 0!==o){var c=g(r,a);a++;for(var p={s:o.s,t:o.t,p:c},l=!0,v=t.pieceTypes[p.t].initial||[],b=0;b<v.length;b++){var f=v[b];f.s==p.s&&f.p==c&&(l=!1)}p.m=l,i.push(p)}else{if(isNaN(parseInt(s)))return console.warn("FEN invalid board spec",s),h;a+=parseInt(s)}}}),i.sort(function(t,e){return e.s-t.s}),"w"==c[1])a=1;else{if("b"!=c[1])return console.warn("FEN invalid turn spec",c[1]),h;a=-1}n[1].k=c[2].indexOf("K")>=0,n[1].q=c[2].indexOf("Q")>=0,n[-1].k=c[2].indexOf("k")>=0,n[-1].q=c[2].indexOf("q")>=0,s="-"==c[3]?null:c[3];var d=parseInt(c[4]);isNaN(d)||(o=d);var m={pieces:i,turn:a,castle:n,enPassant:s,noCaptCount:o};return t.importGame&&t.importGame.call(this,m,e,r),{status:!0,initial:m}}return{status:!1,error:"unsupported"}}}(),function(){Model.Game.cbBoardGeometryGrid=function(t,e){function r(e){return e%t}function a(e){return Math.floor(e/t)}function i(e,r){return r*t+e}function n(n,s){var o=r(n),h=a(n),c=o+s[0],p=h+s[1];return c<0||c>=t||p<0||p>=e?null:i(c,p)}function s(t){return String.fromCharCode("a".charCodeAt(0)+r(t))+(a(t)+1)}function o(t){var e=/^([a-z])([0-9]+)$/.exec(t);return e?i(e[1].charCodeAt(0)-"a".charCodeAt(0),parseInt(e[2])-1):-1}function h(t,e){return 0==e?String.fromCharCode("a".charCodeAt(0)+r(t)):1==e?a(t)+1:null}function c(){for(var i=[],n=0;n<t*e;n++){var s=[];i.push(s);for(var o=0;o<t*e;o++){var h=a(n),c=r(n),p=a(o),l=r(o);s.push(Math.max(Math.abs(h-p),Math.abs(c-l)))}}return i}function p(r,a,n){for(var o=[],h=e-1;h>=0;h--){for(var c="",p=0,l=0;l<t;l++){var u=r.board[i(l,h)];if(u<0)p++;else{p>0&&(c+=p,p=0);var v=r.pieces[u],b=a.pieceTypes[v.t].fenAbbrev||a.pieceTypes[v.t].abbrev||"?";v.s==-1?c+=b.toLowerCase():c+=b.toUpperCase()}}p&&(c+=p),o.push(c)}var f=o.join("/");f+=" ",1==r.mWho?f+="w":f+="b",f+=" ";var g="";return r.castled&&(r.castled[1]===!1?g+="KQ":(r.castled[1].k&&(g+="K"),r.castled[1].q&&(g+="Q")),r.castled[-1]===!1?g+="kq":(r.castled[-1].k&&(g+="k"),r.castled[-1].q&&(g+="q"))),0==g.length&&(g="-"),f+=g,f+=" ",r.epTarget?f+=s(r.epTarget.p):f+="-",f+=" ",f+=r.noCaptCount,f+=" ",f+=Math.floor(n/2)+1}return{boardSize:t*e,width:t,height:e,C:r,R:a,POS:i,Graph:n,PosName:s,PosByName:o,CompactCrit:h,GetDistances:c,distEdge:function(){for(var i=[],n=0;n<t*e;n++){var s=r(n),o=a(n);i[n]=Math.min(s,Math.abs(t-s-1),o,Math.abs(e-o-1))}return i}(),corners:function(){var r={};return r[i(0,0)]=1,r[i(0,e-1)]=1,r[i(t-1,0)]=1,r[i(t-1,e-1)]=1,r}(),ExportBoardState:p}},Model.Game.cbPawnGraph=function(t,e,r){for(var a=this,i={},n=0;n<t.boardSize;n++)if(!r||n in r){var s=[],o=t.Graph(n,[0,e]);null!=o&&(!r||o in r)&&s.push(a.cbTypedArray([o|a.cbConstants.FLAG_MOVE])),[-1,1].forEach(function(i){var o=t.Graph(n,[i,e]);null!=o&&(!r||o in r)&&s.push(a.cbTypedArray([o|a.cbConstants.FLAG_CAPTURE]))}),i[n]=s}else i[n]=[];return i},Model.Game.cbInitialPawnGraph=function(t,e,r){for(var a=this,i={},n=0;n<t.boardSize;n++)if(!r||n in r){var s=[],o=t.Graph(n,[0,e]);if(null!=o&&(!r||o in r)){var h=[o|a.cbConstants.FLAG_MOVE],c=t.Graph(o,[0,e]);null!=c&&(!r||c in r)&&h.push(c|a.cbConstants.FLAG_MOVE),s.push(a.cbTypedArray(h))}[-1,1].forEach(function(i){var o=t.Graph(n,[i,e]);null!=o&&(!r||o in r)&&s.push(a.cbTypedArray([o|a.cbConstants.FLAG_CAPTURE]))}),i[n]=s}else i[n]=[];return i},Model.Game.cbKingGraph=function(t,e){return this.cbShortRangeGraph(t,[[-1,-1],[-1,0],[-1,1],[0,-1],[0,1],[1,-1],[1,0],[1,1]],e)},Model.Game.cbKnightGraph=function(t,e){return this.cbShortRangeGraph(t,[[2,-1],[2,1],[-2,-1],[-2,1],[-1,2],[-1,-2],[1,2],[1,-2]],e)},Model.Game.cbHorseGraph=function(t){for(var e=this,r={},a=0;a<t.boardSize;a++)r[a]=[],[[1,0,2,-1],[1,0,2,1],[-1,0,-2,-1],[-1,0,-2,1],[0,1,-1,2],[0,-1,-1,-2],[0,1,1,2],[0,-1,1,-2]].forEach(function(i){var n=t.Graph(a,[i[0],i[1]]);if(null!=n){var s=t.Graph(a,[i[2],i[3]]);null!=s&&r[a].push(e.cbTypedArray([n|e.cbConstants.FLAG_STOP,s|e.cbConstants.FLAG_MOVE|e.cbConstants.FLAG_CAPTURE]))}});return r},Model.Game.cbRookGraph=function(t,e){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0]],e)},Model.Game.cbBishopGraph=function(t,e){return this.cbLongRangeGraph(t,[[1,-1],[1,1],[-1,1],[-1,-1]],e)},Model.Game.cbQueenGraph=function(t,e){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0],[1,-1],[1,1],[-1,1],[-1,-1]],e)},Model.Game.cbXQGeneralGraph=function(t,e){for(var r=this,a={},i=0;i<t.boardSize;i++)a[i]=[],[[-1,0,!1],[0,-1,!0],[0,1,!0],[1,0,!1]].forEach(function(n){var s=[],o=t.Graph(i,n);if(null!=o&&((!e||o in e)&&s.push(o|r.cbConstants.FLAG_MOVE|r.cbConstants.FLAG_CAPTURE),n[2]))for(var h=t.Graph(o,n);null!=h;)!e||h in e?s.push(h|r.cbConstants.FLAG_CAPTURE|r.cbConstants.FLAG_CAPTURE_KING):s.push(h|r.cbConstants.FLAG_STOP),h=t.Graph(h,n);s.length>0&&a[i].push(r.cbTypedArray(s))});return a},Model.Game.cbXQSoldierGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e]])},Model.Game.cbXQPromoSoldierGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e],[-1,0],[1,0]])},Model.Game.cbXQAdvisorGraph=function(t,e){return this.cbShortRangeGraph(t,[[1,1],[-1,1],[1,-1],[-1,-1]],e)},Model.Game.cbXQCannonGraph=function(t){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0]],null,this.cbConstants.FLAG_MOVE|this.cbConstants.FLAG_SCREEN_CAPTURE)},Model.Game.cbXQElephantGraph=function(t,e){for(var r=this,a={},i=0;i<t.boardSize;i++)a[i]=[],(!e||i in e)&&[[1,1,2,2],[1,-1,2,-2],[-1,1,-2,2],[-1,-1,-2,-2]].forEach(function(n){var s=t.Graph(i,[n[0],n[1]]);if(null!=s){var o=t.Graph(i,[n[2],n[3]]);null!=o&&(!e||o in e)&&a[i].push(r.cbTypedArray([s|r.cbConstants.FLAG_STOP,o|r.cbConstants.FLAG_MOVE|r.cbConstants.FLAG_CAPTURE]))}});return a},Model.Game.cbSilverGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e],[-1,-1],[-1,1],[1,-1],[1,1]])},Model.Game.cbFersGraph=function(t,e){return this.cbShortRangeGraph(t,[[-1,-1],[-1,1],[1,-1],[1,1]])},Model.Game.cbSchleichGraph=function(t,e){return this.cbShortRangeGraph(t,[[-1,0],[1,0],[0,-1],[0,1]])},Model.Game.cbAlfilGraph=function(t,e){return this.cbShortRangeGraph(t,[[-2,-2],[-2,2],[2,2],[2,-2]])}}(),function(){var t=Model.Game.cbBoardGeometryGrid(10,10);Model.Game.cbDefine=function(){var e=this.cbShortRangeGraph(t,[[-1,-1],[-1,1],[1,-1],[1,1],[-2,-2],[-2,2],[2,-2],[2,2]]);return{geometry:t,pieceTypes:{0:{name:"pawn-w",aspect:"fr-pawn",graph:this.cbPawnGraph(t,1),value:.9,abbrev:"",fenAbbrev:"P",initial:[],epCatch:!0},1:{name:"pawn-b",aspect:"fr-pawn",graph:this.cbPawnGraph(t,-1),value:.9,abbrev:"",fenAbbrev:"P",initial:[],epCatch:!0},2:{name:"ipawn-w",aspect:"fr-pawn",graph:this.cbInitialPawnGraph(t,1),value:.9,abbrev:"",fenAbbrev:"P",initial:[{s:1,p:20},{s:1,p:21},{s:1,p:22},{s:1,p:23},{s:1,p:24},{s:1,p:25},{s:1,p:26},{s:1,p:27},{s:1,p:28},{s:1,p:29}],epTarget:!0},3:{name:"ipawn-b",aspect:"fr-pawn",graph:this.cbInitialPawnGraph(t,-1),value:.9,abbrev:"",fenAbbrev:"P",initial:[{s:-1,p:70},{s:-1,p:71},{s:-1,p:72},{s:-1,p:73},{s:-1,p:74},{s:-1,p:75},{s:-1,p:76},{s:-1,p:77},{s:-1,p:78},{s:-1,p:79}],epTarget:!0},4:{name:"knight",aspect:"fr-knight",graph:this.cbKnightGraph(t),value:2.7,abbrev:"N",initial:[{s:1,p:12},{s:1,p:17},{s:-1,p:82},{s:-1,p:87}]},5:{name:"bishop",aspect:"fr-bishop",graph:this.cbBishopGraph(t),value:3.2,abbrev:"B",initial:[{s:1,p:13},{s:1,p:16},{s:-1,p:83},{s:-1,p:86}]},6:{name:"rook",aspect:"fr-rook",graph:this.cbRookGraph(t),value:5,abbrev:"R",initial:[{s:1,p:11},{s:1,p:18},{s:-1,p:81},{s:-1,p:88}],castle:!0},7:{name:"queen",aspect:"fr-queen",graph:this.cbQueenGraph(t),value:8,abbrev:"Q",initial:[{s:1,p:14},{s:-1,p:84}]},8:{name:"king",aspect:"fr-king",isKing:!0,graph:this.cbKingGraph(t),abbrev:"K",initial:[{s:1,p:15},{s:-1,p:85}]},9:{name:"elephant",aspect:"fr-elephant",graph:e,value:2.6,abbrev:"E",initial:[{s:1,p:10},{s:1,p:19},{s:-1,p:80},{s:-1,p:89}]},10:{name:"cannon",aspect:"fr-cannon2",graph:this.cbXQCannonGraph(t),value:4.9,abbrev:"C",initial:[{s:1,p:0},{s:1,p:9},{s:-1,p:90},{s:-1,p:99}]}},castle:{"15/11":{k:[14,13],r:[12,13,14],n:"O-O-O"},"15/18":{k:[16,17],r:[17,16],n:"O-O"},"85/81":{k:[84,83],r:[82,83,84],n:"O-O-O"},"85/88":{k:[86,87],r:[87,86],n:"O-O"}},promote:function(e,r,a){return 2==r.t?[0]:3==r.t?[1]:0==r.t&&9==t.R(a.t)?[4,5,6,7,9,10]:1==r.t&&0==t.R(a.t)?[4,5,6,7,9,10]:[]}}}}();

/***/ }),

/***/ "Kpad":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("3j3K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__("hFwN");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return JsonNodeComponent; });


var JsonNodeComponent = (function () {
    function JsonNodeComponent() {
        this.expanded = false;
    }
    Object.defineProperty(JsonNodeComponent.prototype, "value", {
        set: function (value) {
            this.label = __WEBPACK_IMPORTED_MODULE_1__types__["b" /* getLabelFor */](value);
            this.type = __WEBPACK_IMPORTED_MODULE_1__types__["c" /* getTypeOf */](value);
            if (this.type === __WEBPACK_IMPORTED_MODULE_1__types__["d" /* KNOWN */].Array || this.type === __WEBPACK_IMPORTED_MODULE_1__types__["d" /* KNOWN */].Object || this.type === __WEBPACK_IMPORTED_MODULE_1__types__["d" /* KNOWN */].Iterable) {
                this.children = __WEBPACK_IMPORTED_MODULE_1__types__["a" /* getChildrenFor */](value);
            }
            else {
                this.children = null;
            }
        },
        enumerable: true,
        configurable: true
    });
    JsonNodeComponent.prototype.toggle = function () {
        if (this.children) {
            this.expanded = !this.expanded;
        }
    };
    JsonNodeComponent.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{
                    selector: 'ngrx-json-node',
                    styles: ["\n    :host {\n      display: block;\n      padding: 2px 2px 2px 20px;\n      position: relative;\n      color: #70AFCD;\n      font-family: 'monaco', 'Consolas', 'Lucida Console', monospace;\n    }\n    .expanded-indicator {\n      position: absolute;\n      top: 7px;\n      left: 5px;\n      font-size: 10px;\n      transition: transform 200ms;\n    }\n\n    .expanded .expanded-indicator {\n      transform: rotate(90deg);\n    }\n\n    .node-key::after {\n      content: ': ';\n      display: inline;\n    }\n\n    .expanded .node-label {\n      color: #BABBBD !important;\n    }\n\n    .node-label {\n      color: #9AC05C;\n    }\n\n    .node-label.array, .node-label.null, .node-label.iterable {\n      color: #D182C0;\n    }\n\n    .node-label.number, .node-label.undefined, .node-label.boolean {\n      color: #F86936;\n    }\n  "],
                    template: "\n    <div (click)=\"toggle()\" [class.expanded]=\"expanded\">\n      <span class=\"expanded-indicator\" *ngIf=\"children\">\u25B6</span>\n      <span class=\"node-key\">{{ key }}</span>\n      <span class=\"node-label\" [ngClass]=\"type\">{{ label }}</span>\n    </div>\n    <div class=\"child-nodes\" *ngIf=\"children && expanded\">\n      <ngrx-json-node *ngFor=\"let child of children\" [value]=\"child.value\" [key]=\"child.key\"></ngrx-json-node>\n    </div>\n  "
                },] },
    ];
    /** @nocollapse */
    JsonNodeComponent.ctorParameters = [];
    JsonNodeComponent.propDecorators = {
        'key': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'expanded': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'value': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    };
    return JsonNodeComponent;
}());
//# sourceMappingURL=json-node.js.map

/***/ }),

/***/ "KuCq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__("mmVS");
/**
 * Emits values emitted by the source Observable so long as each value satisfies
 * the given `predicate`, and then completes as soon as this `predicate` is not
 * satisfied.
 *
 * <span class="informal">Takes values from the source only while they pass the
 * condition given. When the first value does not satisfy, it completes.</span>
 *
 * <img src="./img/takeWhile.png" width="100%">
 *
 * `takeWhile` subscribes and begins mirroring the source Observable. Each value
 * emitted on the source is given to the `predicate` function which returns a
 * boolean, representing a condition to be satisfied by the source values. The
 * output Observable emits the source values until such time as the `predicate`
 * returns false, at which point `takeWhile` stops mirroring the source
 * Observable and completes the output Observable.
 *
 * @example <caption>Emit click events only while the clientX property is greater than 200</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.takeWhile(ev => ev.clientX > 200);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link take}
 * @see {@link takeLast}
 * @see {@link takeUntil}
 * @see {@link skip}
 *
 * @param {function(value: T, index: number): boolean} predicate A function that
 * evaluates a value emitted by the source Observable and returns a boolean.
 * Also takes the (zero-based) index as the second argument.
 * @return {Observable<T>} An Observable that emits the values from the source
 * Observable so long as each value satisfies the condition defined by the
 * `predicate`, then completes.
 * @method takeWhile
 * @owner Observable
 */
function takeWhile(predicate) {
    return this.lift(new TakeWhileOperator(predicate));
}
exports.takeWhile = takeWhile;
var TakeWhileOperator = (function () {
    function TakeWhileOperator(predicate) {
        this.predicate = predicate;
    }
    TakeWhileOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new TakeWhileSubscriber(subscriber, this.predicate));
    };
    return TakeWhileOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var TakeWhileSubscriber = (function (_super) {
    __extends(TakeWhileSubscriber, _super);
    function TakeWhileSubscriber(destination, predicate) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.index = 0;
    }
    TakeWhileSubscriber.prototype._next = function (value) {
        var destination = this.destination;
        var result;
        try {
            result = this.predicate(value, this.index++);
        }
        catch (err) {
            destination.error(err);
            return;
        }
        this.nextOrComplete(value, result);
    };
    TakeWhileSubscriber.prototype.nextOrComplete = function (value, predicateResult) {
        var destination = this.destination;
        if (Boolean(predicateResult)) {
            destination.next(value);
        }
        else {
            destination.complete();
        }
    };
    return TakeWhileSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=takeWhile.js.map

/***/ }),

/***/ "KvXC":
/***/ (function(module, exports) {

exports.model=Model={Game:{},Board:{},Move:{}},function(){var t;Model.Game.cbConstants={MASK:65535,FLAG_MOVE:65536,FLAG_CAPTURE:131072,FLAG_STOP:262144,FLAG_SCREEN_CAPTURE:524288,FLAG_CAPTURE_KING:1048576,FLAG_CAPTURE_NO_KING:2097152};var e="undefined"!=typeof Int32Array;Model.Game.cbUseTypedArrays=e,Model.Game.cbTypedArray=function(t){if(e){var r=new Int32Array(t.length);return r.set(t),r}for(var i=[],a=t.length,s=0;s<a;s++)i.push(t[s]);return i},Model.Game.cbShortRangeGraph=function(t,e,r,i){var a=this;void 0===i&&(i=196608);for(var s={},n=0;n<t.boardSize;n++)s[n]=[],(!r||n in r)&&e.forEach(function(e){var o=t.Graph(n,e);null!=o&&(!r||o in r)&&s[n].push(a.cbTypedArray([o|i]))});return s},Model.Game.cbLongRangeGraph=function(t,e,r,i,a){var s=this;void 0!==i&&null!=i||(i=196608),a||(a=1/0);for(var n={},o=0;o<t.boardSize;o++)n[o]=[],(!r||o in r)&&e.forEach(function(e){for(var h=[],c=t.Graph(o,e),p=0;null!=c&&(!r||c in r)&&(h.push(c|i),++p!=a);)c=t.Graph(c,e);h.length>0&&n[o].push(s.cbTypedArray(h))});return n},Model.Game.cbNullGraph=function(t){for(var e={},r=0;r<t.boardSize;r++)e[r]=[];return e},Model.Game.cbAuthorGraph=function(t){for(var e={},r=0;r<t.boardSize;r++){e[r]=[];for(var i=0;i<t.boardSize;i++)e[r].push([2293760|i])}return e},Model.Game.cbMergeGraphs=function(t){for(var e=[],r=0;r<t.boardSize;r++){e[r]=[];for(var i=1;i<arguments.length;i++)e[r]=e[r].concat(arguments[i][r])}return e},Model.Game.cbGetThreatGraph=function(){function t(e,r){for(var i in n){var a=n[i];if(!(a.p.length<r.length+1)){for(var s=!0,o=0;o<r.length;o++)if(r[o]!=a.p[o]){s=!1;break}if(s){var h=a.p[r.length],c=e[h];void 0===c&&(c={e:{}},e[h]=c),a.p.length==r.length+1&&(c.t=a.t,c.ts=a.ts,c.tk=a.tk,delete n[i]),r.push(h),t(c.e,r),r.pop()}}}}var e=this;this.cbUseScreenCapture=!1,this.cbUseCaptureKing=!1,this.cbUseCaptureNoKing=!1;for(var r={1:[],"-1":[]},i=[],a=0;a<this.g.boardSize;a++)this.g.pTypes.forEach(function(t,r){t.graph[a].forEach(function(t){for(var s=[],n=0;n<t.length;n++){var o=t[n];1048576&o?(e.cbUseCaptureKing=!0,s.unshift({d:65535&o,a:a,tk:r})):2097152&o?(e.cbUseCaptureNoKing=!0,s.unshift({d:65535&o,a:a,tnk:r})):131072&o?s.unshift({d:65535&o,a:a,t:r}):262144&o?s.unshift({d:65535&o,a:a}):524288&o&&(e.cbUseScreenCapture=!0,s.unshift({d:65535&o,a:a,ts:r}))}s.length>0&&i.push(s)})});var s={};i.forEach(function(t){t.forEach(function(e,r){var i=s[e.d];void 0===i&&(i={},s[e.d]=i);for(var a=[],n=r+1;n<t.length;n++)a.push(t[n].d);a.push(e.a);var o=a.join(","),h=i[o];void 0===h&&(h={p:a,t:{},ts:{},tk:{}},i[o]=h),void 0!==e.t?h.t[e.t]=!0:void 0!==e.tk?h.tk[e.tk]=!0:void 0!==e.ts&&(h.ts[e.ts]=!0)})});for(var a=0;a<e.g.boardSize;a++){var n=s[a],o={};t(o,[]),r[1][a]=o,r[-1][a]=o}return r},Model.Game.InitGame=function(){var e=this;this.cbVar=t=this.cbDefine(),this.g.boardSize=this.cbVar.geometry.boardSize,this.g.pTypes=this.cbGetPieceTypes(),this.g.threatGraph=this.cbGetThreatGraph(),this.g.distGraph=this.cbVar.geometry.GetDistances(),this.cbPiecesCount=0,this.g.castleablePiecesCount={1:0,"-1":0};for(var r in t.pieceTypes){var i=t.pieceTypes[r];if(i.castle){(i.initial||[]).forEach(function(t){e.g.castleablePiecesCount[t.s]++})}i.initial&&(this.cbPiecesCount+=i.initial.length)}for(var a=[],r=0;r<this.cbPiecesCount;r++)a.push(r);var s=Object.keys(t.pieceTypes);this.zobrist=new JocGame.Zobrist({board:{type:"array",size:this.cbVar.geometry.boardSize,values:a},who:{values:["1","-1"]},type:{type:"array",size:this.cbPiecesCount,values:s}})},Model.Game.cbGetPieceTypes=function(){for(var t=[],e={},r=0;r<this.cbVar.geometry.boardSize;r++)e[r]=[];for(var i in this.cbVar.pieceTypes){var a=this.cbVar.pieceTypes[i];t[i]={graph:a.graph||e,abbrev:a.abbrev||"",value:a.isKing?100:a.value||1,isKing:!!a.isKing,castle:!!a.castle,epTarget:!!a.epTarget,epCatch:!!a.epCatch}}return t},Model.Board.Init=function(t){this.zSign=0},Model.Board.InitialPosition=function(r){var i=this;this.board=e?new Int16Array(r.g.boardSize):[];for(var a=0;a<r.g.boardSize;a++)this.board[a]=-1;if(this.kings={},this.pieces=[],this.ending={1:!1,"-1":!1},this.lastMove=null,r.cbVar.castle&&(this.castled={1:!1,"-1":!1}),this.zSign=r.zobrist.update(0,"who",-1),this.noCaptCount=0,this.mWho=1,r.mInitial)this.mWho=r.mInitial.turn||1,r.mInitial.pieces.forEach(function(t){var e={};for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);i.pieces.push(e)}),r.mInitial.lastMove&&(this.lastMove={f:r.mInitial.lastMove.f,t:r.mInitial.lastMove.t}),void 0!==r.mInitial.noCaptCount&&(this.noCaptCount=r.mInitial.noCaptCount),r.cbVar.castle&&r.mInitial.castle&&(this.castled={1:{k:!!r.mInitial.castle[1]&&!!r.mInitial.castle[1].k,q:!!r.mInitial.castle[1]&&!!r.mInitial.castle[1].q},"-1":{k:!!r.mInitial.castle[-1]&&!!r.mInitial.castle[-1].k,q:!!r.mInitial.castle[-1]&&!!r.mInitial.castle[-1].q}});else for(var s in r.cbVar.pieceTypes)for(var n=r.cbVar.pieceTypes[s],o=n.initial||[],h=0;h<o.length;h++){var c=o[h],p={s:c.s,t:parseInt(s),p:c.p,m:!1};this.pieces.push(p)}if(this.pieces.sort(function(t,e){if(t.s!=e.s)return e.s-t.s;var i=r.cbVar.pieceTypes[t.t].value||100,a=r.cbVar.pieceTypes[e.t].value||100;return i!=a?i-a:t.p-e.p}),this.pieces.forEach(function(t,e){t.i=e,i.board[t.p]=e,r.g.pTypes[t.t].isKing&&(i.kings[t.s]=t.p),i.zSign=r.zobrist.update(i.zSign,"board",e,t.p),i.zSign=r.zobrist.update(i.zSign,"type",t.t,e)}),r.mInitial&&r.mInitial.enPassant){var a=t.geometry.PosByName(r.mInitial.enPassant);if(a>=0){var l,u=t.geometry.C(a),v=t.geometry.R(a);l=1==r.mInitial.turn?t.geometry.POS(u,v-1):t.geometry.POS(u,v+1),this.epTarget={p:a,i:this.board[l]}}}},Model.Board.CopyFrom=function(t){if(e)this.board=new Int16Array(t.board.length),this.board.set(t.board);else{this.board=[];for(var r=t.board,i=r.length,a=0;a<i;a++)this.board.push(r[a])}this.pieces=[];for(var s=t.pieces.length,a=0;a<s;a++){var n=t.pieces[a];this.pieces.push({s:n.s,p:n.p,t:n.t,i:n.i,m:n.m})}this.kings={1:t.kings[1],"-1":t.kings[-1]},this.check=t.check,t.lastMove?this.lastMove={f:t.lastMove.f,t:t.lastMove.t,c:t.lastMove.c}:this.lastMove=null,this.ending={1:t.ending[1],"-1":t.ending[-1]},void 0!==t.castled&&(this.castled={1:t.castled[1],"-1":t.castled[-1]}),this.noCaptCount=t.noCaptCount,t.epTarget?this.epTarget={p:t.epTarget.p,i:t.epTarget.i}:this.epTarget=null,this.mWho=t.mWho,this.zSign=t.zSign},Model.Board.cbApplyCastle=function(t,e,r){var i=t.cbVar.castle[e.f+"/"+e.cg],a=i.r[i.r.length-1],s=this.pieces[this.board[e.cg]],n=i.k[i.k.length-1],o=this.pieces[this.board[e.f]];return r&&(this.zSign=t.zobrist.update(this.zSign,"board",s.i,e.cg),this.zSign=t.zobrist.update(this.zSign,"board",s.i,a),this.zSign=t.zobrist.update(this.zSign,"board",o.i,e.f),this.zSign=t.zobrist.update(this.zSign,"board",o.i,n)),s.p=a,s.m=!0,this.board[e.cg]=-1,o.p=n,o.m=!0,this.board[e.f]=-1,this.board[a]=s.i,this.board[n]=o.i,this.castled[s.s]=!0,this.kings[o.s]=n,[{i:s.i,f:a,t:-1},{i:o.i,f:n,t:e.f,kp:e.f,who:o.s,m:!1},{i:s.i,f:-1,t:e.cg,m:!1,cg:!1}]},Model.Board.cbQuickApply=function(t,e){if(void 0!==e.cg)return this.cbApplyCastle(t,e,!1);var r=[],i=this.board[e.f],a=this.pieces[i];if(null!=e.c){r.unshift({i:e.c,f:-1,t:this.pieces[e.c].p});var s=this.pieces[e.c];this.board[s.p]=-1,s.p=-1}var n=this.kings[a.s];return t.g.pTypes[a.t].isKing&&(this.kings[a.s]=e.t),r.unshift({i:i,f:e.t,t:e.f,kp:n,who:a.s,ty:a.t}),a.p=e.t,void 0!==e.pr&&(a.t=e.pr),this.board[e.f]=-1,this.board[e.t]=i,r},Model.Board.cbQuickUnapply=function(t,e){for(var r=0;r<e.length;r++){var i=e[r],a=this.pieces[i.i];i.f>=0&&(a.p=-1,this.board[i.f]=-1),i.t>=0&&(a.p=i.t,this.board[i.t]=i.i),void 0!==i.m&&(a.m=i.m),void 0!==i.kp&&(this.kings[i.who]=i.kp),void 0!=i.ty&&(a.t=i.ty),void 0!=i.cg&&(this.castled[a.s]=i.cg)}},Model.Board.ApplyMove=function(t,e){var r=this.pieces[this.board[e.f]];if(void 0!==e.cg)this.cbApplyCastle(t,e,!0);else{if(this.zSign=t.zobrist.update(this.zSign,"board",r.i,e.f),this.board[r.p]=-1,void 0!==e.pr&&(this.zSign=t.zobrist.update(this.zSign,"type",r.t,r.i),r.t=e.pr,this.zSign=t.zobrist.update(this.zSign,"type",r.t,r.i)),null!=e.c){var i=this.pieces[e.c];this.zSign=t.zobrist.update(this.zSign,"board",i.i,i.p),this.board[i.p]=-1,i.p=-1,i.m=!0,this.noCaptCount=0}else this.noCaptCount++;r.p=e.t,r.m=!0,this.board[e.t]=r.i,this.zSign=t.zobrist.update(this.zSign,"board",r.i,e.t),t.g.pTypes[r.t].isKing&&(this.kings[r.s]=e.t)}this.check=!!e.ck,this.lastMove={f:e.f,t:e.t,c:e.c},void 0!==e.ko&&(this.ending[r.s]=e.ko),void 0!==e.ept?this.epTarget={p:e.ept,i:r.i}:this.epTarget=null,this.zSign=t.zobrist.update(this.zSign,"who",-this.mWho),this.zSign=t.zobrist.update(this.zSign,"who",this.mWho)},Model.Board.Evaluate=function(r){function i(e){var r=1/0;for(var i in t.geometry.corners)r=Math.min(r,h.distGraph[s.kings[e]][i]);return r-Math.sqrt(h.boardSize)}var a="debug"==arguments[3],s=this;this.mEvaluation=0;var n,o=this.mWho,h=r.g;if(e)n={1:{count:new Uint8Array(h.pTypes.length),byType:{}},"-1":{count:new Uint8Array(h.pTypes.length),byType:{}}};else{n={1:{count:[],byType:{}},"-1":{count:[],byType:{}}};for(var c=0;c<h.pTypes.length;c++)n[1].count[c]=n[-1].count[c]=0}if(r.mOptions.preventRepeat&&r.GetRepeatOccurence(this)>2)return this.mFinished=!0,void(this.mWinner=r.cbOnPerpetual?o*r.cbOnPerpetual:JocGame.DRAW);for(var p={1:0,"-1":0},l={1:h.distGraph[this.kings[-1]],"-1":h.distGraph[this.kings[1]]},u={1:0,"-1":0},v={1:0,"-1":0},f={1:0,"-1":0},b={1:0,"-1":0},d={1:!1,"-1":!1},g=this.pieces,m=g.length,c=0;c<m;c++){var G=g[c];if(G.p>=0){var y=G.s,M=h.pTypes[G.t];M.isKing?d[y]=G.m:p[y]+=M.value,M.castle&&!G.m&&b[y]++,v[y]++,u[y]+=l[y][G.p],f[y]+=t.geometry.distEdge[G.p];var C=n[y];C.count[G.t]++;var S=C.byType;void 0===S[G.t]?S[G.t]=[G]:S[G.t].push(G)}}if(this.lastMove&&null!=this.lastMove.c){var G=this.pieces[this.board[this.lastMove.t]];p[-G.s]+=this.cbStaticExchangeEval(r,G.p,G.s,{piece:G})}var k={1:0,"-1":0},A={1:0,"-1":0},T={1:0,"-1":0};this.ending[1]&&(A[1]=(u[1]-Math.sqrt(h.boardSize))/v[1],t.geometry.corners&&(T[1]=i(1))),this.ending[-1]&&(A[-1]=(u[-1]-Math.sqrt(h.boardSize))/v[-1],t.geometry.corners&&(T[1]=i(-1)));var z={pieceValue:p[1]-p[-1],pieceValueRatio:(p[1]-p[-1])/(p[1]+p[-1]+1),posValue:f[1]-f[-1],averageDistKing:u[1]/v[1]-u[-1]/v[-1],check:this.check?-o:0,endingKingFreedom:k[1]-k[-1],endingDistKing:A[1]-A[-1],distKingCorner:T[1]-T[-1]};t.castle&&(z.castle=(this.castled[1]?1:d[1]?0:b[1]/(h.castleablePiecesCount[1]+1))-(this.castled[-1]?1:d[-1]?0:b[-1]/(h.castleablePiecesCount[-1]+1))),t.evaluate&&t.evaluate.call(this,r,z,n);var E=r.mOptions.levelOptions;for(var P in z){var R=z[P],w=E[P+"Factor"]||0,I=R*w;a&&console.log(P,"=",R,"*",w,"=>",I),this.mEvaluation+=I}a&&console.log("Evaluation",this.mEvaluation)},Model.Board.cbGeneratePseudoLegalMoves=function(t){function e(e,a){var s=t.cbVar.promote;if(!s)return void i.push(a);var n=s.call(r,t,e,a);if(null!=n)if(0==n.length)i.push(a);else if(1==n.length)a.pr=n[0],i.push(a);else for(var o=0;o<n.length;o++){var h=n[o];i.push({f:a.f,t:a.t,c:a.c,pr:h,ept:a.ept,ep:a.ep,a:a.a})}}for(var r=this,i=[],a=t.cbVar,s=this.mWho,n=!a.castle||this.check||this.castled[s]?null:[],o=-1,h=this.pieces.length,c=0;c<h;c++){var p=this.pieces[c];if(!(p.p<0||p.s!=s)){var l=t.g.pTypes[p.t];l.isKing&&(p.m?n=null:o=p),n&&l.castle&&!p.m&&n.push(p);var u,v;u=l.graph[p.p],v=u.length;for(var f=0;f<v;f++)for(var b=u[f],d=!1,g=b.length,m=null,G=0;G<g;G++){var y=b[G],M=65535&y,C=this.board[M];if(!(C<0)||l.epCatch&&this.epTarget&&this.epTarget.p==M){if(!(524288&y)){var S;S=C<0?this.pieces[this.epTarget.i]:this.pieces[C],!(S.s!=p.s&&131072&y)||1048576&y&&!t.g.pTypes[S.t].isKing||2097152&y&&t.g.pTypes[S.t].isKing||e(p,{f:p.p,t:M,c:S.i,a:l.abbrev,ep:C<0});break}if(d){var S=this.pieces[C];S.s!=p.s&&e(p,{f:p.p,t:M,c:S.i,a:l.abbrev});break}d=!0}else 65536&y&&0==d&&e(p,{f:p.p,t:M,c:null,a:l.abbrev,ept:null!=m&&l.epTarget?m:void 0});m=M}}}if(n)for(var c=0;c<n.length;c++){var k=n[c],A=t.cbVar.castle[o.p+"/"+k.p];if(A){for(var T=!0,f=0;f<A.r.length;f++){var z=A.r[f];if(this.board[z]>=0&&z!=o.p&&z!=k.p){T=!1;break}}if(T){for(var E=!0,f=0;f<A.k.length;f++){var z=A.k[f];if(this.board[z]>=0&&z!=k.p&&z!=o.p||this.cbGetAttackers(t,z,s).length>0){E=!1;break}}E&&i.push({f:o.p,t:A.k[A.k.length-1],c:null,cg:k.p})}}}return i},Model.Board.cbStaticExchangeEval=function(t,e,r,i){var a=0,s=this.cbGetSmallestAttacker(t,e,r);if(s){var n=this.mWho;this.mWho=s.s;var o=this.cbQuickApply(t,{f:s.p,t:e,c:i.piece.i}),h=t.g.pTypes[i.piece.t].value;i.piece=s,a=Math.max(0,h-this.cbStaticExchangeEval(t,e,-r,i)),this.cbQuickUnapply(t,o),this.mWho=n}return a},Model.Board.cbGetSmallestAttacker=function(t,e,r){var i=this.cbGetAttackers(t,e,r);if(0==i.length)return null;for(var a=1/0,s=null,n=i.length,o=0;o<n;o++){var h=i[o],c=t.g.pTypes[h.t].value;c<a&&(a=c,s=h)}return s},Model.Board.cbCollectAttackers=function(t,e,r,i){for(var a in e){var s=e[a],n=this.board[a];if(n<0)this.cbCollectAttackers(t,s.e,r,i);else{var o=this.pieces[n];o.s==-t&&(s.t&&o.t in s.t||i&&s.tk&&o.t in s.tk)&&r.push(o)}}},Model.Board.cbCollectAttackersScreen=function(t,e,r,i,a){for(var s in e){var n=e[s],o=this.board[s];if(o<0)this.cbCollectAttackersScreen(t,n.e,r,i,a);else{var h=this.pieces[o];!a&&h.s==-t&&(n.t&&h.t in n.t||i&&n.tk&&h.t in n.tk)?r.push(h):a?a&&h.s==-t&&n.ts&&h.t in n.ts&&r.push(h):this.cbCollectAttackersScreen(t,n.e,r,i,!0)}}},Model.Board.cbGetAttackers=function(t,e,r,i){var a=[];return t.cbUseScreenCapture?this.cbCollectAttackersScreen(r,t.g.threatGraph[r][e],a,i,!1):this.cbCollectAttackers(r,t.g.threatGraph[r][e],a,i),a},Model.Board.GenerateMoves=function(t){var e=this.cbGeneratePseudoLegalMoves(t);this.mMoves=[];for(var r=!0,i=this.kings[this.mWho],a=e.length,s=0;s<a;s++){var n=e[s],o=this.cbQuickApply(t,n);if(!(this.cbGetAttackers(t,this.kings[this.mWho],this.mWho,!0).length>0)){var h=this.cbGetAttackers(t,this.kings[-this.mWho],-this.mWho,!0).length>0;n.ck=h,this.mMoves.push(n),n.f!=i&&(r=!1)}this.cbQuickUnapply(t,o)}if(0==this.mMoves.length)this.mFinished=!0,this.mWinner=t.cbOnStaleMate?t.cbOnStaleMate*this.mWho:JocGame.DRAW,this.check&&(this.mWinner=-this.mWho);else if(this.ending[this.mWho]){if(!r)for(var s=0;s<this.mMoves.length;s++)this.mMoves[s].ko=!1}else if(!this.ending[this.mWho]&&r&&!this.check)for(var s=0;s<this.mMoves.length;s++)this.mMoves[s].ko=!0},Model.Board.GetSignature=function(){return this.zSign},Model.Move.Init=function(t){for(var e in t)t.hasOwnProperty(e)&&(this[e]=t[e])},Model.Move.Equals=function(t){return this.f==t.f&&this.t==t.t&&this.pr==t.pr},Model.Move.CopyFrom=function(t){this.Init(t)},Model.Move.ToString=function(e){var r=this;switch(e=e||"natural"){case"natural":return function(){var e;if(void 0!==r.cg?e=t.castle[r.f+"/"+r.cg].n:(e=r.a||"",e+=t.geometry.PosName(r.f),null==r.c?e+="-":e+="x",e+=t.geometry.PosName(r.t)),void 0!==r.pr){var i=t.pieceTypes[r.pr];i&&i.abbrev&&i.abbrev.length>0&&!i.silentPromo&&(e+="="+i.abbrev)}return r.ck&&(e+="+"),e}();case"engine":return function(){var e=t.geometry.PosName(r.f)+t.geometry.PosName(r.t);if(void 0!=r.pr){var i=t.pieceTypes[r.pr];i&&i.abbrev&&i.abbrev.length>0&&!i.silentPromo&&(e+=i.abbrev)}return e}();default:return"??"}},Model.Board.CompactMoveString=function(e,r,i){"function"!=typeof r.ToString&&(r=e.CreateMove(r));var a=r.ToString(),s=/^([A-Z]?)([a-z])([1-9][0-9]*)([-x])([a-z])([1-9][0-9]*)(.*?)$/.exec(a);if(!s)return a;var n=s[7];if(i||(i={}),i.value||(i.value=[]),0==i.value.length){var o=this.mMoves;this.mMoves&&0!=this.mMoves.length||this.GenerateMoves(e);for(var h=0;h<this.mMoves.length;h++){var c=this.mMoves[h];"function"!=typeof c.ToString&&(c=e.CreateMove(c)),i.value.push({str:c.ToString(),move:c})}this.mMoves=o}var p=[];if(i.value.forEach(function(t){var e=/^([A-Z]?[a-z][1-9][0-9]*[-x][a-z][1-9][0-9]*)(.*?)$/.exec(t.str);e&&t.move.t==r.t&&(t.move.a||"")==s[1]&&e[2]==n&&p.push(t.move)}),1==p.length)return""==s[1]&&"x"==s[4]?s[2]+"x"+s[5]+s[6]+s[7]:s[1]+("x"==s[4]?"x":"")+s[5]+s[6]+s[7];if(t.geometry.CompactCrit)for(var l="",h=0;;h++){var u=t.geometry.CompactCrit(r.f,h);if(null==u)return a;l+=u;for(var v=[],f=0;f<p.length;f++){var b=p[f];t.geometry.CompactCrit(b.f,h)==u&&v.push(b)}if(console.assert(v.length>0),1==v.length)return s[1]+l+("x"==s[4]?"x":"")+s[5]+s[6]+s[7];p=v}return a},Model.Board.cbIntegrity=function(t){function e(t,e){t||console.error(e)}for(var r=this,i=0;i<this.board.length;i++){var a=this.board[i];if(a>=0){var s=r.pieces[a];e(void 0!==s,"no piece at pos"),e(s.p==i,"piece has different pos")}}for(var a=0;a<this.pieces.length;a++){var s=this.pieces[a];s.p>=0&&e(r.board[s.p]==a,"board index mismatch")}},Model.Board.ExportBoardState=function(t){return t.cbVar.geometry.ExportBoardState?t.cbVar.geometry.ExportBoardState(this,t.cbVar,t.mPlayedMoves.length):"not supported"},Model.Game.Import=function(e,r){var i,a=[],s={1:{},"-1":{}},n=null,o=0;if("pjn"==e){var h={status:!1,error:"parse"},c=r.split(" ");if(6!=c.length)return console.warn("FEN should have 6 parts"),h;var p=c[0].split("/"),l=t.geometry.fenHeight||t.geometry.height;if(p.length!=l)return console.warn("FEN board should have",l,"rows, got",p.length),h;var u={};for(var v in t.pieceTypes){var f=t.pieceTypes[v],b=f.fenAbbrev||f.abbrev||"X";u[b.toUpperCase()]={s:1,t:v},u[b.toLowerCase()]={s:-1,t:v}}var d=t.geometry.FenRowPos||function(e,r){return(t.geometry.height-1-e)*t.geometry.width+r};if(p.forEach(function(e,r){for(var i=0,s=0;s<e.length;s++){var n=e.substr(s,1),o=u[n];if(void 0!==o){var c=d(r,i);i++;for(var p={s:o.s,t:o.t,p:c},l=!0,v=t.pieceTypes[p.t].initial||[],f=0;f<v.length;f++){var b=v[f];b.s==p.s&&b.p==c&&(l=!1)}p.m=l,a.push(p)}else{if(isNaN(parseInt(n)))return console.warn("FEN invalid board spec",n),h;i+=parseInt(n)}}}),a.sort(function(t,e){return e.s-t.s}),"w"==c[1])i=1;else{if("b"!=c[1])return console.warn("FEN invalid turn spec",c[1]),h;i=-1}s[1].k=c[2].indexOf("K")>=0,s[1].q=c[2].indexOf("Q")>=0,s[-1].k=c[2].indexOf("k")>=0,s[-1].q=c[2].indexOf("q")>=0,n="-"==c[3]?null:c[3];var g=parseInt(c[4]);isNaN(g)||(o=g);var m={pieces:a,turn:i,castle:s,enPassant:n,noCaptCount:o};return t.importGame&&t.importGame.call(this,m,e,r),{status:!0,initial:m}}return{status:!1,error:"unsupported"}}}(),function(){Model.Game.cbBoardGeometryGrid=function(t,e){function r(e){return e%t}function i(e){return Math.floor(e/t)}function a(e,r){return r*t+e}function s(s,n){var o=r(s),h=i(s),c=o+n[0],p=h+n[1];return c<0||c>=t||p<0||p>=e?null:a(c,p)}function n(t){return String.fromCharCode("a".charCodeAt(0)+r(t))+(i(t)+1)}function o(t){var e=/^([a-z])([0-9]+)$/.exec(t);return e?a(e[1].charCodeAt(0)-"a".charCodeAt(0),parseInt(e[2])-1):-1}function h(t,e){return 0==e?String.fromCharCode("a".charCodeAt(0)+r(t)):1==e?i(t)+1:null}function c(){for(var a=[],s=0;s<t*e;s++){var n=[];a.push(n);for(var o=0;o<t*e;o++){var h=i(s),c=r(s),p=i(o),l=r(o);n.push(Math.max(Math.abs(h-p),Math.abs(c-l)))}}return a}function p(r,i,s){for(var o=[],h=e-1;h>=0;h--){for(var c="",p=0,l=0;l<t;l++){var u=r.board[a(l,h)];if(u<0)p++;else{p>0&&(c+=p,p=0);var v=r.pieces[u],f=i.pieceTypes[v.t].fenAbbrev||i.pieceTypes[v.t].abbrev||"?";v.s==-1?c+=f.toLowerCase():c+=f.toUpperCase()}}p&&(c+=p),o.push(c)}var b=o.join("/");b+=" ",1==r.mWho?b+="w":b+="b",b+=" ";var d="";return r.castled&&(r.castled[1]===!1?d+="KQ":(r.castled[1].k&&(d+="K"),r.castled[1].q&&(d+="Q")),r.castled[-1]===!1?d+="kq":(r.castled[-1].k&&(d+="k"),r.castled[-1].q&&(d+="q"))),0==d.length&&(d="-"),b+=d,b+=" ",r.epTarget?b+=n(r.epTarget.p):b+="-",b+=" ",b+=r.noCaptCount,b+=" ",b+=Math.floor(s/2)+1}return{boardSize:t*e,width:t,height:e,C:r,R:i,POS:a,Graph:s,PosName:n,PosByName:o,CompactCrit:h,GetDistances:c,distEdge:function(){for(var a=[],s=0;s<t*e;s++){var n=r(s),o=i(s);a[s]=Math.min(n,Math.abs(t-n-1),o,Math.abs(e-o-1))}return a}(),corners:function(){var r={};return r[a(0,0)]=1,r[a(0,e-1)]=1,r[a(t-1,0)]=1,r[a(t-1,e-1)]=1,r}(),ExportBoardState:p}},Model.Game.cbPawnGraph=function(t,e,r){for(var i=this,a={},s=0;s<t.boardSize;s++)if(!r||s in r){var n=[],o=t.Graph(s,[0,e]);null!=o&&(!r||o in r)&&n.push(i.cbTypedArray([o|i.cbConstants.FLAG_MOVE])),[-1,1].forEach(function(a){var o=t.Graph(s,[a,e]);null!=o&&(!r||o in r)&&n.push(i.cbTypedArray([o|i.cbConstants.FLAG_CAPTURE]))}),a[s]=n}else a[s]=[];return a},Model.Game.cbInitialPawnGraph=function(t,e,r){for(var i=this,a={},s=0;s<t.boardSize;s++)if(!r||s in r){var n=[],o=t.Graph(s,[0,e]);if(null!=o&&(!r||o in r)){var h=[o|i.cbConstants.FLAG_MOVE],c=t.Graph(o,[0,e]);null!=c&&(!r||c in r)&&h.push(c|i.cbConstants.FLAG_MOVE),n.push(i.cbTypedArray(h))}[-1,1].forEach(function(a){var o=t.Graph(s,[a,e]);null!=o&&(!r||o in r)&&n.push(i.cbTypedArray([o|i.cbConstants.FLAG_CAPTURE]))}),a[s]=n}else a[s]=[];return a},Model.Game.cbKingGraph=function(t,e){return this.cbShortRangeGraph(t,[[-1,-1],[-1,0],[-1,1],[0,-1],[0,1],[1,-1],[1,0],[1,1]],e)},Model.Game.cbKnightGraph=function(t,e){return this.cbShortRangeGraph(t,[[2,-1],[2,1],[-2,-1],[-2,1],[-1,2],[-1,-2],[1,2],[1,-2]],e)},Model.Game.cbHorseGraph=function(t){for(var e=this,r={},i=0;i<t.boardSize;i++)r[i]=[],[[1,0,2,-1],[1,0,2,1],[-1,0,-2,-1],[-1,0,-2,1],[0,1,-1,2],[0,-1,-1,-2],[0,1,1,2],[0,-1,1,-2]].forEach(function(a){var s=t.Graph(i,[a[0],a[1]]);if(null!=s){var n=t.Graph(i,[a[2],a[3]]);null!=n&&r[i].push(e.cbTypedArray([s|e.cbConstants.FLAG_STOP,n|e.cbConstants.FLAG_MOVE|e.cbConstants.FLAG_CAPTURE]))}});return r},Model.Game.cbRookGraph=function(t,e){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0]],e)},Model.Game.cbBishopGraph=function(t,e){return this.cbLongRangeGraph(t,[[1,-1],[1,1],[-1,1],[-1,-1]],e)},Model.Game.cbQueenGraph=function(t,e){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0],[1,-1],[1,1],[-1,1],[-1,-1]],e)},Model.Game.cbXQGeneralGraph=function(t,e){for(var r=this,i={},a=0;a<t.boardSize;a++)i[a]=[],[[-1,0,!1],[0,-1,!0],[0,1,!0],[1,0,!1]].forEach(function(s){var n=[],o=t.Graph(a,s);if(null!=o&&((!e||o in e)&&n.push(o|r.cbConstants.FLAG_MOVE|r.cbConstants.FLAG_CAPTURE),s[2]))for(var h=t.Graph(o,s);null!=h;)!e||h in e?n.push(h|r.cbConstants.FLAG_CAPTURE|r.cbConstants.FLAG_CAPTURE_KING):n.push(h|r.cbConstants.FLAG_STOP),h=t.Graph(h,s);n.length>0&&i[a].push(r.cbTypedArray(n))});return i},Model.Game.cbXQSoldierGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e]])},Model.Game.cbXQPromoSoldierGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e],[-1,0],[1,0]])},Model.Game.cbXQAdvisorGraph=function(t,e){return this.cbShortRangeGraph(t,[[1,1],[-1,1],[1,-1],[-1,-1]],e)},Model.Game.cbXQCannonGraph=function(t){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0]],null,this.cbConstants.FLAG_MOVE|this.cbConstants.FLAG_SCREEN_CAPTURE)},Model.Game.cbXQElephantGraph=function(t,e){for(var r=this,i={},a=0;a<t.boardSize;a++)i[a]=[],(!e||a in e)&&[[1,1,2,2],[1,-1,2,-2],[-1,1,-2,2],[-1,-1,-2,-2]].forEach(function(s){var n=t.Graph(a,[s[0],s[1]]);if(null!=n){var o=t.Graph(a,[s[2],s[3]]);null!=o&&(!e||o in e)&&i[a].push(r.cbTypedArray([n|r.cbConstants.FLAG_STOP,o|r.cbConstants.FLAG_MOVE|r.cbConstants.FLAG_CAPTURE]))}});return i},Model.Game.cbSilverGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e],[-1,-1],[-1,1],[1,-1],[1,1]])},Model.Game.cbFersGraph=function(t,e){return this.cbShortRangeGraph(t,[[-1,-1],[-1,1],[1,-1],[1,1]])},Model.Game.cbSchleichGraph=function(t,e){return this.cbShortRangeGraph(t,[[-1,0],[1,0],[0,-1],[0,1]])},Model.Game.cbAlfilGraph=function(t,e){return this.cbShortRangeGraph(t,[[-2,-2],[-2,2],[2,2],[2,-2]])}}(),function(){var t=Model.Game.cbBoardGeometryGrid(8,8);Model.Game.cbDefine=function(){var e=this.cbShortRangeGraph(t,[[-2,-2],[-2,2],[2,-2],[2,2]]);return{geometry:t,pieceTypes:{0:{name:"pawn-w",aspect:"np-pawn",graph:this.cbPawnGraph(t,1),value:1,abbrev:"",fenAbbrev:"P",epCatch:!1,initial:[{s:1,p:8},{s:1,p:9},{s:1,p:10},{s:1,p:11},{s:1,p:12},{s:1,p:13},{s:1,p:14},{s:1,p:15}]},2:{name:"pawn-b",aspect:"np-pawn",graph:this.cbPawnGraph(t,-1),value:1,abbrev:"",fenAbbrev:"P",initial:[{s:-1,p:48},{s:-1,p:49},{s:-1,p:50},{s:-1,p:51},{s:-1,p:52},{s:-1,p:53},{s:-1,p:54},{s:-1,p:55}],epCatch:!1},4:{name:"knight",aspect:"np-knight",graph:this.cbKnightGraph(t),value:3.5,abbrev:"N",initial:[{s:1,p:1},{s:1,p:6},{s:-1,p:57},{s:-1,p:62}]},5:{name:"elephant",aspect:"np-elephant",graph:e,value:2.5,abbrev:"E",initial:[{s:1,p:2},{s:1,p:5},{s:-1,p:58},{s:-1,p:61}]},6:{name:"rook",aspect:"np-rook",graph:this.cbRookGraph(t),value:5,abbrev:"R",initial:[{s:1,p:0},{s:1,p:7},{s:-1,p:56},{s:-1,p:63}],castle:!1},7:{name:"general",aspect:"np-general",graph:this.cbFersGraph(t),value:2,abbrev:"G",initial:[{s:1,p:4},{s:-1,p:60}]},8:{name:"king",aspect:"np-king",isKing:!0,graph:this.cbKingGraph(t),abbrev:"K",initial:[{s:1,p:3},{s:-1,p:59}]}},promote:function(e,r,i){return 0==r.t&&7==t.R(i.t)?[7]:2==r.t&&0==t.R(i.t)?[7]:[]},evaluate:function(e,r,i){var a=i[1].count,s=i[-1].count;a[0]||a[1]||a[4]||a[5]||a[6]||a[7]||s[2]||s[3]||s[6]||s[7]||!(s[4]+s[5]<2||s[5]<2)||(this.mFinished=!0,this.mWinner=JocGame.PLAYER_B),s[2]||s[3]||s[4]||s[5]||s[6]||s[7]||a[0]||a[1]||a[6]||a[7]||!(a[4]+a[5]<2||a[5]<2)||(this.mFinished=!0,this.mWinner=JocGame.PLAYER_A),this.noCaptCount>=100&&(this.mFinished=!0,this.mWinner=JocGame.DRAW);var n,o=e.cbUseTypedArrays?new Int8Array(3):[0,0,0],h=t.height,c=i[1].byType[0];if(c){n=c.length;for(var p=0;p<n;p++)switch(h-t.R(c[p].p)){case 2:o[0]++;break;case 3:o[1]++;break;case 4:o[2]++}}if(c=i[-1].byType[2]){n=c.length;for(var p=0;p<n;p++)switch(t.R(c[p].p)){case 1:o[0]--;break;case 2:o[1]--;break;case 3:o[2]--}}0!=o[0]&&(r.distPawnPromo1=o[0]),0!=o[1]&&(r.distPawnPromo2=o[1]),0!=o[2]&&(r.distPawnPromo3=o[2]);for(var l=0,u=4;u<=5;u++)for(var v=1;v>=-1;v-=2){var f=i[v].byType[u];if(f)for(var p=0;p<f.length;p++)f[p].m&&(l+=v)}0!=l&&(r.minorPiecesMoved=l)}}}}();

/***/ }),

/***/ "L2Hk":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var isFunction_1 = __webpack_require__("SKH6");
var Observable_1 = __webpack_require__("rCTf");
var Subscription_1 = __webpack_require__("B00U");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var FromEventPatternObservable = (function (_super) {
    __extends(FromEventPatternObservable, _super);
    function FromEventPatternObservable(addHandler, removeHandler, selector) {
        _super.call(this);
        this.addHandler = addHandler;
        this.removeHandler = removeHandler;
        this.selector = selector;
    }
    /**
     * Creates an Observable from an API based on addHandler/removeHandler
     * functions.
     *
     * <span class="informal">Converts any addHandler/removeHandler API to an
     * Observable.</span>
     *
     * <img src="./img/fromEventPattern.png" width="100%">
     *
     * Creates an Observable by using the `addHandler` and `removeHandler`
     * functions to add and remove the handlers, with an optional selector
     * function to project the event arguments to a result. The `addHandler` is
     * called when the output Observable is subscribed, and `removeHandler` is
     * called when the Subscription is unsubscribed.
     *
     * @example <caption>Emits clicks happening on the DOM document</caption>
     * function addClickHandler(handler) {
     *   document.addEventListener('click', handler);
     * }
     *
     * function removeClickHandler(handler) {
     *   document.removeEventListener('click', handler);
     * }
     *
     * var clicks = Rx.Observable.fromEventPattern(
     *   addClickHandler,
     *   removeClickHandler
     * );
     * clicks.subscribe(x => console.log(x));
     *
     * @see {@link from}
     * @see {@link fromEvent}
     *
     * @param {function(handler: Function): any} addHandler A function that takes
     * a `handler` function as argument and attaches it somehow to the actual
     * source of events.
     * @param {function(handler: Function, signal?: any): void} [removeHandler] An optional function that
     * takes a `handler` function as argument and removes it in case it was
     * previously attached using `addHandler`. if addHandler returns signal to teardown when remove,
     * removeHandler function will forward it.
     * @param {function(...args: any): T} [selector] An optional function to
     * post-process results. It takes the arguments from the event handler and
     * should return a single value.
     * @return {Observable<T>}
     * @static true
     * @name fromEventPattern
     * @owner Observable
     */
    FromEventPatternObservable.create = function (addHandler, removeHandler, selector) {
        return new FromEventPatternObservable(addHandler, removeHandler, selector);
    };
    FromEventPatternObservable.prototype._subscribe = function (subscriber) {
        var _this = this;
        var removeHandler = this.removeHandler;
        var handler = !!this.selector ? function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i - 0] = arguments[_i];
            }
            _this._callSelector(subscriber, args);
        } : function (e) { subscriber.next(e); };
        var retValue = this._callAddHandler(handler, subscriber);
        if (!isFunction_1.isFunction(removeHandler)) {
            return;
        }
        subscriber.add(new Subscription_1.Subscription(function () {
            //TODO: determine whether or not to forward to error handler
            removeHandler(handler, retValue);
        }));
    };
    FromEventPatternObservable.prototype._callSelector = function (subscriber, args) {
        try {
            var result = this.selector.apply(this, args);
            subscriber.next(result);
        }
        catch (e) {
            subscriber.error(e);
        }
    };
    FromEventPatternObservable.prototype._callAddHandler = function (handler, errorSubscriber) {
        try {
            return this.addHandler(handler) || null;
        }
        catch (e) {
            errorSubscriber.error(e);
        }
    };
    return FromEventPatternObservable;
}(Observable_1.Observable));
exports.FromEventPatternObservable = FromEventPatternObservable;
//# sourceMappingURL=FromEventPatternObservable.js.map

/***/ }),

/***/ "L3nt":
/***/ (function(module, exports) {

exports.config = {"status":true,"model":{"plazza":"true","title-en":"Brazilian Draughts","module":"checkers","maxLevel":20,"summary":"Same as international checkers on a 8x8 board.","thumbnail":"draughts8-thumb3d.png","rules":"rules-brazilian-draughts.html","description":"description.html","credits":"credits.html","js":["checkersbase-model.js","draughts-model.js"],"gameOptions":{"preventRepeat":true,"width":4,"height":8,"initial":{"a":[[0,0],[0,1],[0,2],[0,3],[1,0],[1,1],[1,2],[1,3],[2,0],[2,1],[2,2],[2,3]],"b":[[7,0],[7,1],[7,2],[7,3],[6,0],[6,1],[6,2],[6,3],[5,0],[5,1],[5,2],[5,3]]},"variant":{"mustMoveForwardStrict":true,"lastRowCrown":true,"captureLongestLine":true,"lastRowFactor":0.001},"uctTransposition":"state"},"levels":[{"label":"Fast","ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.5,"maxDuration":1,"isDefault":true},{"label":"Beginner","ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.5,"maxDuration":0.5,"maxNodes":100,"maxLoops":200},{"label":"Easy","ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.5,"maxDuration":1,"maxNodes":2500,"maxLoops":500},{"label":"Medium","ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.5,"maxDuration":2,"maxNodes":5500,"maxLoops":500},{"label":"Hard","ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.5,"maxDuration":5,"maxNodes":2000,"maxLoops":3500},{"label":"Expert","ai":"uct","c":0.8,"playoutDepth":0,"minVisitsExpand":1,"ignoreLeaf":false,"uncertaintyFactor":5,"propagateMultiVisits":false,"maxDuration":60,"maxNodes":15000,"maxLoops":8000}]},"view":{"js":["checkers-xd-view.js","draughts8-xd-view.js"],"css":["checkersbase.css","draughts.css"],"title-en":"Draughts View","skins":[{"name":"classic3d","title":"3D Classic","3d":true,"camera":{"radius":24,"elevationAngle":65,"limitCamMoves":true,"distMax":30,"fov":35},"world":{"lightIntensity":0.7,"skyLightIntensity":0.5,"lightPosition":{"x":-15,"y":15,"z":0},"lightShadowDarkness":0.45,"ambientLightColor":8947848,"color":4686804,"fog":false},"preload":["image|/res/images/wood-chipboard-5.jpg","image|/res/xd-view/meshes/piecetop-bump.jpg","image|/res/xd-view/meshes/piecediff.jpg","image|/res/xd-view/meshes/piecetop-queen-mask.png","smoothedfilegeo|0|/res/xd-view/meshes/ring-target.js","smoothedfilegeo|0|/res/xd-view/meshes/piece-v2.js"]},{"name":"turtles3d","title":"3D Turtles","3d":true,"camera":{"radius":14,"elevationAngle":45,"limitCamMoves":true,"distMax":40},"world":{"lightIntensity":0,"skyLightIntensity":3,"fog":true,"color":3645658,"lightPosition":{"x":-5,"y":18,"z":5},"lightShadowDarkness":0.55,"ambientLightColor":4473924},"preload":["image|/res/images/wood-chipboard-5.jpg","image|/res/xd-view/meshes/turtle.png","image|/res/xd-view/meshes/star.png","image|/res/xd-view/meshes/rock.jpg","smoothedfilegeo|0|/res/xd-view/meshes/turtle-legs-smoothed.js","smoothedfilegeo|0|/res/xd-view/meshes/turtle-head-smoothed.js","smoothedfilegeo|0|/res/xd-view/meshes/turtle-tail-smoothed.js","smoothedfilegeo|0|/res/xd-view/meshes/turtle-hotel.js","smoothedfilegeo|0|/res/xd-view/meshes/turtle-house.js","smoothedfilegeo|0|/res/xd-view/meshes/rainbowflat.js","smoothedfilegeo|0|/res/xd-view/meshes/ring-target.js","smoothedfilegeo|0|/res/xd-view/meshes/rocksmoothed.js","smoothedfilegeo|0|/res/xd-view/meshes/turtle-fences.js"]},{"name":"classical","title":"Classic"},{"name":"marble0","title":"Marble"},{"name":"wood0","title":"Wood"},{"name":"green","title":"Green"}],"visuals":{"600x600":["res/visuals/brazilian-draughts-600x600-3d.jpg","res/visuals/brazilian-draughts-600x600-2d.jpg"]},"sounds":{"move1":"move1","move2":"move2","move3":"move3","move4":"move4","tac1":"tac1","tac2":"tac1","tac3":"tac1","promo":"promo","usermove":null},"module":"checkers","preferredRatio":1,"switchable":true,"animateSelfMoves":false,"useNotation":true,"useShowMoves":true,"defaultOptions":{"sounds":true,"notation":false,"moves":true},"xdView":true}}

/***/ }),

/***/ "L5US":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_base__ = __webpack_require__("TwGT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_base_adapter__ = __webpack_require__("esTq");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__responsive_responsive_activation__ = __webpack_require__("VDSN");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__module__ = __webpack_require__("rl5v");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__module__["a"]; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */




//# sourceMappingURL=index.js.map

/***/ }),

/***/ "LC74":
/***/ (function(module, exports) {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    ctor.prototype = Object.create(superCtor.prototype, {
      constructor: {
        value: ctor,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    var TempCtor = function () {}
    TempCtor.prototype = superCtor.prototype
    ctor.prototype = new TempCtor()
    ctor.prototype.constructor = ctor
  }
}


/***/ }),

/***/ "LHw1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var fromEventPattern_1 = __webpack_require__("9oY/");
Observable_1.Observable.fromEventPattern = fromEventPattern_1.fromEventPattern;
//# sourceMappingURL=fromEventPattern.js.map

/***/ }),

/***/ "Lc4l":
/***/ (function(module, exports) {

exports.config = {"status":true,"model":{"js":["reversi-model.js"],"plazza":"true","released":1409239768,"title-en":"Annexation 10","module":"reversi","summary":"Reversi/Othello rules on a 10x10 board","thumbnail":"thumb-reversi10.png","rules":{"en":"rules-reversi10.html"},"credits":{"en":"credits.html"},"description":{"en":"description.html"},"gameOptions":{"preventRepeat":true,"uctTransposition":"state","levelOptions":{"stableFactor":20,"aboutStableFactor":-20,"aboutStableBorderFactor":-15,"borderFactor":5,"aboutBorderFactor":-4,"countFactor":1,"mobilityFactor":5},"width":10,"height":10,"initial":{"1":["4:5","5:4"],"-1":["5:5","4:4"]}},"debugEval":true,"levels":[{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.65,"ignoreLeaf":false,"log":true,"uncertaintyFactor":3,"name":"easy","label":"Easy","maxNodes":1000},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.65,"ignoreLeaf":false,"log":true,"uncertaintyFactor":3,"name":"fast","label":"Fast [1sec]","maxDuration":1,"isDefault":true},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.65,"ignoreLeaf":false,"log":true,"uncertaintyFactor":3,"name":"medium","label":"Medium","maxNodes":10000,"maxDuration":10},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.65,"ignoreLeaf":false,"log":true,"uncertaintyFactor":3,"name":"strong","label":"Strong","maxNodes":20000,"maxDuration":15}]},"view":{"title-en":"Annex View","js":["reversi-xd-view.js"],"xdView":true,"useNotation":true,"useShowMoves":true,"module":"reversi","skins":[{"name":"classic3d","title":"3D Classic","3d":true,"camera":{"radius":14,"elevationAngle":45,"distMax":39.5,"distMin":10.1,"elevationMin":-89.9,"elevationMax":89.9,"limitCamMoves":true,"fov":45},"world":{"lightIntensity":0.7,"skyLightIntensity":0.3,"lightPosition":{"x":10,"y":18,"z":0},"lightShadowDarkness":0.35,"color":4686804,"ambientLightColor":5592405,"fog":false},"preload":["image|/res/xd-view/pass-dark.png","image|/res/xd-view/pass-light.png","image|/res/images/wood-chipboard-5.jpg","image|/res/xd-view/reversi-pieces-2-textures.png","image|/res/xd-view/reversi-pieces-2-textures-bump.png","smoothedfilegeo|0|/res/xd-view/ring-target.js","smoothedfilegeo|0|/res/xd-view/reversi-pieces-6.js"]},{"name":"classic2d","title":"2D Classic","preload":["image|/res/xd-view/pass-dark.png","image|/res/xd-view/pass-light.png","image|/res/xd-view/boardtexture.jpg","image|/res/xd-view/cellshadows.png","image|/res/xd-view/sprites.png","image|/res/xd-view/select-target-2d.png"]}],"visuals":{"600x600":["res/visuals/reversi10-600x600-3d.jpg","res/visuals/reversi10-600x600-2d.jpg"]}}}

/***/ }),

/***/ "Lgq0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("3j3K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base__ = __webpack_require__("TwGT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__media_query_media_monitor__ = __webpack_require__("bWt6");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FlexOffsetDirective; });
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */



/**
 * 'flex-offset' flexbox styling directive
 * Configures the 'margin-left' of the element in a layout container
 */
var FlexOffsetDirective = (function (_super) {
    __extends(FlexOffsetDirective, _super);
    /* tslint:enable */
    function FlexOffsetDirective(monitor, elRef, renderer) {
        return _super.call(this, monitor, elRef, renderer) || this;
    }
    Object.defineProperty(FlexOffsetDirective.prototype, "offset", {
        /* tslint:disable */
        set: function (val) { this._cacheInput('offset', val); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FlexOffsetDirective.prototype, "offsetXs", {
        set: function (val) { this._cacheInput('offsetXs', val); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FlexOffsetDirective.prototype, "offsetSm", {
        set: function (val) { this._cacheInput('offsetSm', val); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(FlexOffsetDirective.prototype, "offsetMd", {
        set: function (val) { this._cacheInput('offsetMd', val); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(FlexOffsetDirective.prototype, "offsetLg", {
        set: function (val) { this._cacheInput('offsetLg', val); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(FlexOffsetDirective.prototype, "offsetXl", {
        set: function (val) { this._cacheInput('offsetXl', val); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(FlexOffsetDirective.prototype, "offsetLtSm", {
        set: function (val) { this._cacheInput('offsetLtSm', val); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(FlexOffsetDirective.prototype, "offsetLtMd", {
        set: function (val) { this._cacheInput('offsetLtMd', val); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(FlexOffsetDirective.prototype, "offsetLtLg", {
        set: function (val) { this._cacheInput('offsetLtLg', val); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(FlexOffsetDirective.prototype, "offsetLtXl", {
        set: function (val) { this._cacheInput('offsetLtXl', val); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(FlexOffsetDirective.prototype, "offsetGtXs", {
        set: function (val) { this._cacheInput('offsetGtXs', val); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(FlexOffsetDirective.prototype, "offsetGtSm", {
        set: function (val) { this._cacheInput('offsetGtSm', val); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(FlexOffsetDirective.prototype, "offsetGtMd", {
        set: function (val) { this._cacheInput('offsetGtMd', val); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(FlexOffsetDirective.prototype, "offsetGtLg", {
        set: function (val) { this._cacheInput('offsetGtLg', val); },
        enumerable: true,
        configurable: true
    });
    ;
    // *********************************************
    // Lifecycle Methods
    // *********************************************
    /**
     * For @Input changes on the current mq activation property, see onMediaQueryChanges()
     */
    FlexOffsetDirective.prototype.ngOnChanges = function (changes) {
        if (changes['offset'] != null || this._mqActivation) {
            this._updateWithValue();
        }
    };
    /**
     * After the initial onChanges, build an mqActivation object that bridges
     * mql change events to onMediaQueryChange handlers
     */
    FlexOffsetDirective.prototype.ngOnInit = function () {
        var _this = this;
        this._listenForMediaQueryChanges('offset', 0, function (changes) {
            _this._updateWithValue(changes.value);
        });
    };
    // *********************************************
    // Protected methods
    // *********************************************
    FlexOffsetDirective.prototype._updateWithValue = function (value) {
        value = value || this._queryInput("offset") || 0;
        if (this._mqActivation) {
            value = this._mqActivation.activatedInput;
        }
        this._applyStyleToElement(this._buildCSS(value));
    };
    FlexOffsetDirective.prototype._buildCSS = function (offset) {
        var isPercent = String(offset).indexOf('%') > -1;
        var isPx = String(offset).indexOf('px') > -1;
        if (!isPx && !isPercent && !isNaN(offset)) {
            offset = offset + '%';
        }
        return { 'margin-left': "" + offset };
    };
    return FlexOffsetDirective;
}(__WEBPACK_IMPORTED_MODULE_1__base__["a" /* BaseFxDirective */]));

FlexOffsetDirective.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{ selector: "\n  [fxFlexOffset],\n  [fxFlexOffset.xs], [fxFlexOffset.sm], [fxFlexOffset.md], [fxFlexOffset.lg], [fxFlexOffset.xl],\n  [fxFlexOffset.lt-sm], [fxFlexOffset.lt-md], [fxFlexOffset.lt-lg], [fxFlexOffset.lt-xl],\n  [fxFlexOffset.gt-xs], [fxFlexOffset.gt-sm], [fxFlexOffset.gt-md], [fxFlexOffset.gt-lg]\n" },] },
];
/** @nocollapse */
FlexOffsetDirective.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_2__media_query_media_monitor__["a" /* MediaMonitor */], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer2"], },
]; };
FlexOffsetDirective.propDecorators = {
    'offset': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxFlexOffset',] },],
    'offsetXs': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxFlexOffset.xs',] },],
    'offsetSm': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxFlexOffset.sm',] },],
    'offsetMd': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxFlexOffset.md',] },],
    'offsetLg': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxFlexOffset.lg',] },],
    'offsetXl': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxFlexOffset.xl',] },],
    'offsetLtSm': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxFlexOffset.lt-sm',] },],
    'offsetLtMd': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxFlexOffset.lt-md',] },],
    'offsetLtLg': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxFlexOffset.lt-lg',] },],
    'offsetLtXl': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxFlexOffset.lt-xl',] },],
    'offsetGtXs': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxFlexOffset.gt-xs',] },],
    'offsetGtSm': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxFlexOffset.gt-sm',] },],
    'offsetGtMd': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxFlexOffset.gt-md',] },],
    'offsetGtLg': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxFlexOffset.gt-lg',] },],
};
//# sourceMappingURL=flex-offset.js.map

/***/ }),

/***/ "LhE+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Observable_1 = __webpack_require__("rCTf");
var subscribeToResult_1 = __webpack_require__("CURp");
var OuterSubscriber_1 = __webpack_require__("wAkD");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var IfObservable = (function (_super) {
    __extends(IfObservable, _super);
    function IfObservable(condition, thenSource, elseSource) {
        _super.call(this);
        this.condition = condition;
        this.thenSource = thenSource;
        this.elseSource = elseSource;
    }
    IfObservable.create = function (condition, thenSource, elseSource) {
        return new IfObservable(condition, thenSource, elseSource);
    };
    IfObservable.prototype._subscribe = function (subscriber) {
        var _a = this, condition = _a.condition, thenSource = _a.thenSource, elseSource = _a.elseSource;
        return new IfSubscriber(subscriber, condition, thenSource, elseSource);
    };
    return IfObservable;
}(Observable_1.Observable));
exports.IfObservable = IfObservable;
var IfSubscriber = (function (_super) {
    __extends(IfSubscriber, _super);
    function IfSubscriber(destination, condition, thenSource, elseSource) {
        _super.call(this, destination);
        this.condition = condition;
        this.thenSource = thenSource;
        this.elseSource = elseSource;
        this.tryIf();
    }
    IfSubscriber.prototype.tryIf = function () {
        var _a = this, condition = _a.condition, thenSource = _a.thenSource, elseSource = _a.elseSource;
        var result;
        try {
            result = condition();
            var source = result ? thenSource : elseSource;
            if (source) {
                this.add(subscribeToResult_1.subscribeToResult(this, source));
            }
            else {
                this._complete();
            }
        }
        catch (err) {
            this._error(err);
        }
    };
    return IfSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=IfObservable.js.map

/***/ }),

/***/ "Llwz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subject_1 = __webpack_require__("EEr4");
var OuterSubscriber_1 = __webpack_require__("wAkD");
var subscribeToResult_1 = __webpack_require__("CURp");
/**
 * Branch out the source Observable values as a nested Observable whenever
 * `windowBoundaries` emits.
 *
 * <span class="informal">It's like {@link buffer}, but emits a nested Observable
 * instead of an array.</span>
 *
 * <img src="./img/window.png" width="100%">
 *
 * Returns an Observable that emits windows of items it collects from the source
 * Observable. The output Observable emits connected, non-overlapping
 * windows. It emits the current window and opens a new one whenever the
 * Observable `windowBoundaries` emits an item. Because each window is an
 * Observable, the output is a higher-order Observable.
 *
 * @example <caption>In every window of 1 second each, emit at most 2 click events</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var interval = Rx.Observable.interval(1000);
 * var result = clicks.window(interval)
 *   .map(win => win.take(2)) // each window has at most 2 emissions
 *   .mergeAll(); // flatten the Observable-of-Observables
 * result.subscribe(x => console.log(x));
 *
 * @see {@link windowCount}
 * @see {@link windowTime}
 * @see {@link windowToggle}
 * @see {@link windowWhen}
 * @see {@link buffer}
 *
 * @param {Observable<any>} windowBoundaries An Observable that completes the
 * previous window and starts a new window.
 * @return {Observable<Observable<T>>} An Observable of windows, which are
 * Observables emitting values of the source Observable.
 * @method window
 * @owner Observable
 */
function window(windowBoundaries) {
    return this.lift(new WindowOperator(windowBoundaries));
}
exports.window = window;
var WindowOperator = (function () {
    function WindowOperator(windowBoundaries) {
        this.windowBoundaries = windowBoundaries;
    }
    WindowOperator.prototype.call = function (subscriber, source) {
        var windowSubscriber = new WindowSubscriber(subscriber);
        var sourceSubscription = source.subscribe(windowSubscriber);
        if (!sourceSubscription.closed) {
            windowSubscriber.add(subscribeToResult_1.subscribeToResult(windowSubscriber, this.windowBoundaries));
        }
        return sourceSubscription;
    };
    return WindowOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var WindowSubscriber = (function (_super) {
    __extends(WindowSubscriber, _super);
    function WindowSubscriber(destination) {
        _super.call(this, destination);
        this.window = new Subject_1.Subject();
        destination.next(this.window);
    }
    WindowSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.openWindow();
    };
    WindowSubscriber.prototype.notifyError = function (error, innerSub) {
        this._error(error);
    };
    WindowSubscriber.prototype.notifyComplete = function (innerSub) {
        this._complete();
    };
    WindowSubscriber.prototype._next = function (value) {
        this.window.next(value);
    };
    WindowSubscriber.prototype._error = function (err) {
        this.window.error(err);
        this.destination.error(err);
    };
    WindowSubscriber.prototype._complete = function () {
        this.window.complete();
        this.destination.complete();
    };
    WindowSubscriber.prototype._unsubscribe = function () {
        this.window = null;
    };
    WindowSubscriber.prototype.openWindow = function () {
        var prevWindow = this.window;
        if (prevWindow) {
            prevWindow.complete();
        }
        var destination = this.destination;
        var newWindow = this.window = new Subject_1.Subject();
        destination.next(newWindow);
    };
    return WindowSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=window.js.map

/***/ }),

/***/ "LppN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var ignoreElements_1 = __webpack_require__("C4lF");
Observable_1.Observable.prototype.ignoreElements = ignoreElements_1.ignoreElements;
//# sourceMappingURL=ignoreElements.js.map

/***/ }),

/***/ "LuwH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("3j3K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_BehaviorSubject__ = __webpack_require__("TfWX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_BehaviorSubject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs_BehaviorSubject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_add_operator_filter__ = __webpack_require__("wUn1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_add_operator_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs_add_operator_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_add_operator_map__ = __webpack_require__("+pb+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_add_operator_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rxjs_add_operator_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__media_change__ = __webpack_require__("PXjH");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MatchMedia; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


// RxJS Operators used by the classes...



/**
 * MediaMonitor configures listeners to mediaQuery changes and publishes an Observable facade to
 * convert mediaQuery change callbacks to subscriber notifications. These notifications will be
 * performed within the ng Zone to trigger change detections and component updates.
 *
 * NOTE: both mediaQuery activations and de-activations are announced in notifications
 */
var MatchMedia = (function () {
    function MatchMedia(_zone) {
        this._zone = _zone;
        this._registry = new Map();
        this._source = new __WEBPACK_IMPORTED_MODULE_1_rxjs_BehaviorSubject__["BehaviorSubject"](new __WEBPACK_IMPORTED_MODULE_4__media_change__["a" /* MediaChange */](true));
        this._observable$ = this._source.asObservable();
    }
    /**
     * For the specified mediaQuery?
     */
    MatchMedia.prototype.isActive = function (mediaQuery) {
        if (this._registry.has(mediaQuery)) {
            var mql = this._registry.get(mediaQuery);
            return mql.matches;
        }
        return false;
    };
    /**
     * External observers can watch for all (or a specific) mql changes.
     * Typically used by the MediaQueryAdaptor; optionally available to components
     * who wish to use the MediaMonitor as mediaMonitor$ observable service.
     *
     * NOTE: if a mediaQuery is not specified, then ALL mediaQuery activations will
     *       be announced.
     */
    MatchMedia.prototype.observe = function (mediaQuery) {
        this.registerQuery(mediaQuery);
        return this._observable$.filter(function (change) {
            return mediaQuery ? (change.mediaQuery === mediaQuery) : true;
        });
    };
    /**
     * Based on the BreakPointRegistry provider, register internal listeners for each unique
     * mediaQuery. Each listener emits specific MediaChange data to observers
     */
    MatchMedia.prototype.registerQuery = function (mediaQuery) {
        var _this = this;
        if (mediaQuery) {
            var mql = this._registry.get(mediaQuery);
            var onMQLEvent = function (e) {
                _this._zone.run(function () {
                    var change = new __WEBPACK_IMPORTED_MODULE_4__media_change__["a" /* MediaChange */](e.matches, mediaQuery);
                    _this._source.next(change);
                });
            };
            if (!mql) {
                mql = this._buildMQL(mediaQuery);
                mql.addListener(onMQLEvent);
                this._registry.set(mediaQuery, mql);
            }
            if (mql.matches) {
                onMQLEvent(mql); // Announce activate range for initial subscribers
            }
        }
    };
    /**
     * Call window.matchMedia() to build a MediaQueryList; which
     * supports 0..n listeners for activation/deactivation
     */
    MatchMedia.prototype._buildMQL = function (query) {
        prepareQueryCSS(query);
        var canListen = !!window.matchMedia('all').addListener;
        return canListen ? window.matchMedia(query) : {
            matches: query === 'all' || query === '',
            media: query,
            addListener: function () {
            },
            removeListener: function () {
            }
        };
    };
    return MatchMedia;
}());

MatchMedia.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
];
/** @nocollapse */
MatchMedia.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgZone"], },
]; };
/**
 * Private global registry for all dynamically-created, injected style tags
 * @see prepare(query)
 */
var ALL_STYLES = {};
/**
 * For Webkit engines that only trigger the MediaQueryListListener
 * when there is at least one CSS selector for the respective media query.
 *
 * @param query string The mediaQuery used to create a faux CSS selector
 *
 */
function prepareQueryCSS(query) {
    if (!ALL_STYLES[query]) {
        try {
            var style = document.createElement('style');
            style.setAttribute('type', 'text/css');
            if (!style['styleSheet']) {
                var cssText = "@media " + query + " {.fx-query-test{ }}";
                style.appendChild(document.createTextNode(cssText));
            }
            document.getElementsByTagName('head')[0].appendChild(style);
            // Store in private global registry
            ALL_STYLES[query] = style;
        }
        catch (e) {
            console.error(e);
        }
    }
}
//# sourceMappingURL=match-media.js.map

/***/ }),

/***/ "M2FH":
/***/ (function(module, exports) {

exports.config = {"status":true,"model":{"plazza":"true","released":1405068609,"title-en":"Gustav III Chess","module":"chessbase","summary":"Gustav Johan Billberg, 1839","thumbnail":"gustav3-thumb.png","rules":{"en":"gustav3-rules.html"},"credits":{"en":"gustav3-credits.html"},"gameOptions":{"preventRepeat":true,"uctTransposition":"state","uctIgnoreLoop":false,"levelOptions":{"pieceValueFactor":1,"pieceValueRatioFactor":1,"posValueFactor":0.1,"averageDistKingFactor":-0.01,"castleFactor":0.1,"minorPiecesMovedFactor":0.1,"checkFactor":0.2,"endingKingFreedomFactor":0.01,"endingDistKingFactor":0.05,"distKingCornerFactor":0.1,"distPawnPromo1Factor":0.3,"distPawnPromo2Factor":0.1,"distPawnPromo3Factor":0.05}},"obsolete":false,"js":["base-model.js","grid-geo-model.js","gustav3-model.js"],"description":{"en":"gustav3-description.html"},"levels":[{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"easy","label":"Easy","maxNodes":1000},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"fast","label":"Fast [1sec]","maxDuration":1,"isDefault":true},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"medium","label":"Medium","maxNodes":10000,"maxDuration":10},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"strong","label":"Strong","maxNodes":20000,"maxDuration":15}]},"view":{"title-en":"Chessbase view","module":"chessbase","xdView":true,"css":["chessbase.css"],"preferredRatio":1,"useShowMoves":true,"useNotation":true,"useAutoComplete":true,"defaultOptions":{"sounds":true,"moves":true,"notation":false,"autocomplete":false},"skins":[{"name":"skin3d","title":"3D Classic","3d":true,"preload":["smoothedfilegeo|0|/res/ring-target.js","image|/res/images/cancel.png","image|/res/images/wikipedia.png","smoothedfilegeo|0|/res/fairy/pawn/pawn.js","image|/res/fairy/pawn/pawn-diffusemap.jpg","image|/res/fairy/pawn/pawn-normalmap.jpg","smoothedfilegeo|0|/res/fairy/knight/knight.js","image|/res/fairy/knight/knight-diffusemap.jpg","image|/res/fairy/knight/knight-normalmap.jpg","smoothedfilegeo|0|/res/fairy/bishop/bishop.js","image|/res/fairy/bishop/bishop-diffusemap.jpg","image|/res/fairy/bishop/bishop-normalmap.jpg","smoothedfilegeo|0|/res/fairy/king/king.js","image|/res/fairy/king/king-diffusemap.jpg","image|/res/fairy/king/king-normalmap.jpg","smoothedfilegeo|0|/res/fairy/rook/rook.js","image|/res/fairy/rook/rook-diffusemap.jpg","image|/res/fairy/rook/rook-normalmap.jpg","smoothedfilegeo|0|/res/fairy/queen/queen.js","image|/res/fairy/queen/queen-diffusemap.jpg","image|/res/fairy/queen/queen-normalmap.jpg","smoothedfilegeo|0|/res/fairy/amazon/amazon.js","image|/res/fairy/amazon/amazon-diffusemap.jpg","image|/res/fairy/amazon/amazon-normalmap.jpg"],"world":{"lightIntensity":1.3,"skyLightIntensity":1.2,"lightCastShadow":true,"fog":false,"color":4686804,"lightPosition":{"x":-9,"y":9,"z":9},"skyLightPosition":{"x":9,"y":9,"z":9},"lightShadowDarkness":0.55,"ambientLightColor":2236962},"camera":{"fov":45,"distMax":50,"radius":18,"elevationAngle":60,"elevationMin":0}},{"name":"skin2d","title":"2D Classic","3d":false,"preload":["image|/res/images/cancel.png","image|/res/images/whitebg.png","image|/res/fairy/wikipedia-fairy-sprites.png"]}],"animateSelfMoves":false,"switchable":true,"sounds":{"move1":"alq_move1","move2":"alq_move2","move3":"alq_move3","move4":"alq_move2","tac1":"alq_tac1","tac2":"alq_tac2","tac3":"alq_tac1","promo":"promo","usermove":null},"js":["base-view.js","grid-board-view.js","fairy-set-view.js","gustav3-view.js"],"visuals":{"600x600":["res/visuals/gustav3-600x600-3d.jpg","res/visuals/gustav3-600x600-2d.jpg"]}}}

/***/ }),

/***/ "M5jZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__("mmVS");
/**
 * Returns an Observable that skips the first `count` items emitted by the source Observable.
 *
 * <img src="./img/skip.png" width="100%">
 *
 * @param {Number} count - The number of times, items emitted by source Observable should be skipped.
 * @return {Observable} An Observable that skips values emitted by the source Observable.
 *
 * @method skip
 * @owner Observable
 */
function skip(count) {
    return this.lift(new SkipOperator(count));
}
exports.skip = skip;
var SkipOperator = (function () {
    function SkipOperator(total) {
        this.total = total;
    }
    SkipOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new SkipSubscriber(subscriber, this.total));
    };
    return SkipOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var SkipSubscriber = (function (_super) {
    __extends(SkipSubscriber, _super);
    function SkipSubscriber(destination, total) {
        _super.call(this, destination);
        this.total = total;
        this.count = 0;
    }
    SkipSubscriber.prototype._next = function (x) {
        if (++this.count > this.total) {
            this.destination.next(x);
        }
    };
    return SkipSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=skip.js.map

/***/ }),

/***/ "MQMf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subject_1 = __webpack_require__("EEr4");
var queue_1 = __webpack_require__("RA5l");
var Subscription_1 = __webpack_require__("B00U");
var observeOn_1 = __webpack_require__("Ji1B");
var ObjectUnsubscribedError_1 = __webpack_require__("IZVw");
var SubjectSubscription_1 = __webpack_require__("ZJf8");
/**
 * @class ReplaySubject<T>
 */
var ReplaySubject = (function (_super) {
    __extends(ReplaySubject, _super);
    function ReplaySubject(bufferSize, windowTime, scheduler) {
        if (bufferSize === void 0) { bufferSize = Number.POSITIVE_INFINITY; }
        if (windowTime === void 0) { windowTime = Number.POSITIVE_INFINITY; }
        _super.call(this);
        this.scheduler = scheduler;
        this._events = [];
        this._bufferSize = bufferSize < 1 ? 1 : bufferSize;
        this._windowTime = windowTime < 1 ? 1 : windowTime;
    }
    ReplaySubject.prototype.next = function (value) {
        var now = this._getNow();
        this._events.push(new ReplayEvent(now, value));
        this._trimBufferThenGetEvents();
        _super.prototype.next.call(this, value);
    };
    ReplaySubject.prototype._subscribe = function (subscriber) {
        var _events = this._trimBufferThenGetEvents();
        var scheduler = this.scheduler;
        var subscription;
        if (this.closed) {
            throw new ObjectUnsubscribedError_1.ObjectUnsubscribedError();
        }
        else if (this.hasError) {
            subscription = Subscription_1.Subscription.EMPTY;
        }
        else if (this.isStopped) {
            subscription = Subscription_1.Subscription.EMPTY;
        }
        else {
            this.observers.push(subscriber);
            subscription = new SubjectSubscription_1.SubjectSubscription(this, subscriber);
        }
        if (scheduler) {
            subscriber.add(subscriber = new observeOn_1.ObserveOnSubscriber(subscriber, scheduler));
        }
        var len = _events.length;
        for (var i = 0; i < len && !subscriber.closed; i++) {
            subscriber.next(_events[i].value);
        }
        if (this.hasError) {
            subscriber.error(this.thrownError);
        }
        else if (this.isStopped) {
            subscriber.complete();
        }
        return subscription;
    };
    ReplaySubject.prototype._getNow = function () {
        return (this.scheduler || queue_1.queue).now();
    };
    ReplaySubject.prototype._trimBufferThenGetEvents = function () {
        var now = this._getNow();
        var _bufferSize = this._bufferSize;
        var _windowTime = this._windowTime;
        var _events = this._events;
        var eventsCount = _events.length;
        var spliceCount = 0;
        // Trim events that fall out of the time window.
        // Start at the front of the list. Break early once
        // we encounter an event that falls within the window.
        while (spliceCount < eventsCount) {
            if ((now - _events[spliceCount].time) < _windowTime) {
                break;
            }
            spliceCount++;
        }
        if (eventsCount > _bufferSize) {
            spliceCount = Math.max(spliceCount, eventsCount - _bufferSize);
        }
        if (spliceCount > 0) {
            _events.splice(0, spliceCount);
        }
        return _events;
    };
    return ReplaySubject;
}(Subject_1.Subject));
exports.ReplaySubject = ReplaySubject;
var ReplayEvent = (function () {
    function ReplayEvent(time, value) {
        this.time = time;
        this.value = value;
    }
    return ReplayEvent;
}());
//# sourceMappingURL=ReplaySubject.js.map

/***/ }),

/***/ "MeZ0":
/***/ (function(module, exports) {

exports.model=Model={Game:{},Board:{},Move:{}},function(){var t,s,o="undefined"!=typeof Int8Array;o?(t=function(t){return new Int8Array(t)},s=function(t){var s=new Int8Array(t.length);return s.set(t),s}):(t=function(t){for(var s=[],o=0;o<t;o++)s.push(0);return s},s=function(t){for(var s=[],o=t.length,i=0;i<o;i++)s.push(t[i]);return s}),Model.Game.isAlive=function(t,s){return this.POS(s,t)in this.g.confine},Model.Game.C=function(t){return t%this.mOptions.width},Model.Game.R=function(t){return Math.floor(t/this.mOptions.width)},Model.Game.RC=function(t){return{r:Math.floor(t/this.mOptions.width),c:t%this.mOptions.width}},Model.Game.POS=function(t,s){return s*this.mOptions.width+t},Model.Game.STR2POS=function(t){var s=/^(\d+):(\d+)$/.exec(t);if(s){var o=parseInt(s[1]),i=parseInt(s[2]);return this.POS(i,o)}return null},Model.Game.InitGame=function(){var s=this.NBCOLS=this.mOptions.width,o=this.NBROWS=this.mOptions.height;this.g.confine={},this.g.totalCount=o*s;for(var i=0;i<o;i++)for(var r=0;r<s;r++)this.g.confine[this.POS(r,i)]=1;if(this.mOptions.deadCells)for(var e in this.mOptions.deadCells){var a=this.STR2POS(e);null!=a&&(this.g.totalCount--,delete this.g.confine[a])}this.g.dirDeltaRC=[[1,-1],[1,0],[1,1],[0,1],[-1,1],[-1,0],[-1,-1],[0,-1]],this.g.Graph={};for(var i=0;i<o;i++)for(var r=0;r<s;r++){var a=this.POS(r,i);if(a in this.g.confine){for(var h=t(this.g.dirDeltaRC.length),n=0;n<this.g.dirDeltaRC.length;n++){var l=this.g.dirDeltaRC[n],v=i+l[0],d=r+l[1],u=v*s+d;v>=0&&d>=0&&v<o&&d<s&&u in this.g.confine?h[n]=u:h[n]=-1}this.g.Graph[a]=h}}this.g.corners={};for(var a in this.g.confine){for(var f=0,l=0;l<8;l++){var u=this.g.Graph[a][l];u<0&&(f|=1<<l)}15!=(15&f)&&30!=(30&f)&&60!=(60&f)&&120!=(120&f)&&240!=(240&f)&&225!=(225&f)&&195!=(195&f)&&135!=(135&f)||(this.g.corners[a]=1)}this.g.borders={};for(var a in this.g.confine)if(!(a in this.g.corners)){for(var f=0,l=0;l<8;l++){var u=this.g.Graph[a][l];u<0&&(f|=1<<l)}7!=(7&f)&&14!=(14&f)&&28!=(28&f)&&56!=(56&f)&&112!=(112&f)&&224!=(224&f)&&193!=(193&f)&&131!=(131&f)||(this.g.borders[a]=1)}this.zobrist=new JocGame.Zobrist({board:{type:"array",size:s*o,values:["1","-1"]}})},Model.Move.Init=function(t){this.row=t.row,this.col=t.col,this.pass=t.pass},Model.Move.CopyFrom=function(t){this.row=t.row,this.col=t.col,this.pass=t.pass},Model.Move.ToString=function(){return this.pass?"-":String.fromCharCode("a".charCodeAt(0)+this.col)+(this.row+1)},Model.Move.Equals=function(t){return!(!t.pass||!this.pass)||this.row==t.row&&this.col==t.col},Model.Board.Init=function(t){this.zSign=0},Model.Board.InitialPosition=function(s){this.board=t(s.mOptions.width*s.mOptions.height),this.counts=[0,0],this.freeClose={},this.passes=0,this.lastMove=null;var o=this;[1,-1].forEach(function(t){var i=(1-t)/2;s.mOptions.initial[t].forEach(function(r){o.counts[i]++;var e=s.STR2POS(r);o.board[e]=t,delete o.freeClose[e];for(var a=0;a<8;a++){var h=s.g.Graph[e][a];h<0||(o.board[h]||(o.freeClose[h]=1))}o.zSign=s.zobrist.update(o.zSign,"board",t,e)})}),this.FindMoves(s),this.stable={};for(var i in s.g.corners)this.stable[i]=3;this.aboutStable={},this.aboutBorder={},this.rvUpdateStable(s,s.g.corners),this.rvUpdateAboutBorder(s)},Model.Board.CopyFrom=function(t){this.mWho=t.mWho,this.zSign=t.zSign,this.board=s(t.board),this.counts=[t.counts[0],t.counts[1]],this.freeClose={};for(var o in t.freeClose)this.freeClose[o]=1;this.passes=t.passes,this.lastMove=null,t.lastMove?this.lastMove={row:t.lastMove.row,col:t.lastMove.col}:this.lastMove=null,this.movePoss={1:s(t.movePoss[1]),"-1":s(t.movePoss[-1])},this.stable=t.stable,this.aboutStable=t.aboutStable,this.aboutBorder=t.aboutBorder},Model.Board.GenerateMoves=function(t){this.mMoves=[];for(var s=0;s<this.movePoss[this.mWho].length;s++){var o=this.movePoss[this.mWho][s],i=t.RC(o);this.PushMove(t,{row:i.r,col:i.c})}0==this.mMoves.length&&this.PushMove(t,{pass:!0,row:-1,col:-1})},Model.Board.FindMoves=function(t){this.movePoss={1:[],"-1":[]};var s=t.g.Graph;for(var o in this.freeClose){for(var i=s[o],r=0,e=0;e<8;e++){var a=i[e];if(a>=0){var h=-this.board[a];if(h){var n=1==h?1:2;if(!(r&n)){for(!0,a=s[a][e];this.board[a]==-h;)a=s[a][e];if(a>=0&&this.board[a]==h&&(r|=n),3==r)break}}}}1&r&&this.movePoss[1].push(o),2&r&&this.movePoss[-1].push(o)}},Model.Board.ApplyMove=function(t,s){if(this.lastMove=null,s.pass)return void this.passes++;this.lastMove={row:s.row,col:s.col},this.passes=0;var o=(1-this.mWho)/2,i=1<<o;this.counts[o]++;var r=t.POS(s.col,s.row),e=t.g.Graph,a=e[r];this.board[r]=this.mWho,this.zSign=t.zobrist.update(this.zSign,"board",this.mWho,r),delete this.freeClose[r];var h=!1,n={};(this.stable[r]||0)&i&&(h=!0,n[r]=1);for(var l=0;l<8;l++){var v=a[l];v>=0&&0==this.board[v]&&(this.freeClose[v]=1);for(var d=[];v>=0&&this.board[v]==-this.mWho;)d.push(v),v=e[v][l];if(v>=0&&d.length>0&&this.board[v]==this.mWho)for(var u=d.length-1;u>=0;u--){var f=d[u];this.zSign=t.zobrist.update(this.zSign,"board",-this.mWho,f),this.zSign=t.zobrist.update(this.zSign,"board",this.mWho,f),this.board[f]=this.mWho,this.counts[o]++,this.counts[1-o]--,(this.stable[f]||0)&i&&(h=!0,n[f]=1)}}h&&this.rvUpdateStable(t,n),r in t.g.borders&&this.rvUpdateAboutBorder(t),this.FindMoves(t)},Model.Board.rvUpdateStable=function(t,s){var o=this.stable;this.stable={};for(var i in o)this.stable[i]=o[i];for(var r=!0,e=1==this.mWho?1:2,a=t.g.Graph;r;){r=!1;var h={};for(var i in s)for(var n=a[i],l=0;l<8;l++){var v=n[l];v>=0&&!((this.stable[v]||0)&e)&&(h[v]=1)}var s={};for(var i in h){for(var n=a[i],d=0,l=0;l<8;l++){var v=n[l];(v<0||this.board[v]==this.mWho&&(this.stable[v]||0)&e)&&(d|=1<<l)}15!=(15&d)&&30!=(30&d)&&60!=(60&d)&&120!=(120&d)&&240!=(240&d)&&225!=(225&d)&&195!=(195&d)&&135!=(135&d)||(this.stable[i]=(this.stable[i]||0)|e,r=!0,s[i]=1)}}this.aboutStable={};for(var i in this.stable)if(!this.board[i])for(var n=a[i],l=0;l<8;l++){var v=n[l];v>=0&&!(v in this.stable)&&(this.aboutStable[v]=(this.aboutStable[v]||0)|this.stable[i])}},Model.Board.rvUpdateAboutBorder=function(t){this.aboutBorder={};var s=t.g.Graph,o=t.g.borders;for(var i in o)if(!this.board[i])for(var r=s[i],e=0;e<8;e++){var a=r[e];!(a>=0)||a in this.stable||a in this.aboutStable||a in o||(this.aboutBorder[a]=1)}},Model.Board.Evaluate=function(t){this.mEvaluation=0;t.mOptions.width,t.mOptions.height;if(2==this.passes||this.counts[0]+this.counts[1]==t.g.totalCount||0==this.counts[0]||0==this.counts[1])return this.mFinished=!0,void(this.counts[0]>this.counts[1]?this.mWinner=JocGame.PLAYER_A:this.counts[0]<this.counts[1]?this.mWinner=JocGame.PLAYER_B:this.mWinner=JocGame.DRAW);var s=t.mOptions.levelOptions,o={},i={1:0,"-1":0},r={1:0,"-1":0},e={1:0,"-1":0},a={1:0,"-1":0},h=t.g.confine,n=t.g.borders;for(var l in h){var v=this.board[l];if(v){var d=1==v?1:2,u=1==v?2:1;(this.stable[l]||0)&d?i[v]++:(this.aboutStable[l]||0)&u?l in n?e[v]++:r[v]++:l in n&&a[v]++}}o.stable=i[1]-i[-1],o.aboutStable=r[1]-r[-1],o.aboutStableBorder=e[1]-e[-1],o.border=a[1]-a[-1],o.count=this.counts[0]-this.counts[1];var f=this.movePoss[1].length+this.movePoss[-1].length;o.mobility=f?(this.movePoss[1].length-this.movePoss[-1].length)/f:0;for(var b in o){var c=o[b],m=s[b+"Factor"]||0,g=c*m;this.mEvaluation+=g}},Model.Board.GetSignature=function(){return this.zSign}}();

/***/ }),

/***/ "MjDH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("3j3K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__ = __webpack_require__("rCTf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_observable_empty__ = __webpack_require__("vvwv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_observable_empty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs_observable_empty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_operator_filter__ = __webpack_require__("ack3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_operator_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rxjs_operator_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_operator_map__ = __webpack_require__("xAJs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_operator_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_rxjs_operator_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_operator_share__ = __webpack_require__("+ayw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_operator_share___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_rxjs_operator_share__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs_operator_switchMap__ = __webpack_require__("VEfc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs_operator_switchMap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_rxjs_operator_switchMap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rxjs_operator_takeUntil__ = __webpack_require__("q+cp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rxjs_operator_takeUntil___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_rxjs_operator_takeUntil__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils__ = __webpack_require__("3Nrk");
/* unused harmony export ExtensionActionTypes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return REDUX_DEVTOOLS_EXTENSION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DevtoolsExtension; });









var ExtensionActionTypes = {
    START: 'START',
    DISPATCH: 'DISPATCH',
    STOP: 'STOP',
    ACTION: 'ACTION'
};
var REDUX_DEVTOOLS_EXTENSION = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["OpaqueToken"]('Redux Devtools Extension');
var DevtoolsExtension = (function () {
    function DevtoolsExtension(devtoolsExtension) {
        this.instanceId = "ngrx-store-" + Date.now();
        this.devtoolsExtension = devtoolsExtension;
        this.createActionStreams();
    }
    DevtoolsExtension.prototype.notify = function (action, state) {
        if (!this.devtoolsExtension) {
            return;
        }
        this.devtoolsExtension.send(null, state, false, this.instanceId);
    };
    DevtoolsExtension.prototype.createChangesObservable = function () {
        var _this = this;
        if (!this.devtoolsExtension) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_rxjs_observable_empty__["empty"])();
        }
        return new __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"](function (subscriber) {
            var connection = _this.devtoolsExtension.connect({ instanceId: _this.instanceId });
            connection.subscribe(function (change) { return subscriber.next(change); });
            return connection.unsubscribe;
        });
    };
    DevtoolsExtension.prototype.createActionStreams = function () {
        var _this = this;
        // Listens to all changes based on our instanceId
        var changes$ = __WEBPACK_IMPORTED_MODULE_5_rxjs_operator_share__["share"].call(this.createChangesObservable());
        // Listen for the start action
        var start$ = __WEBPACK_IMPORTED_MODULE_3_rxjs_operator_filter__["filter"].call(changes$, function (change) { return change.type === ExtensionActionTypes.START; });
        // Listen for the stop action
        var stop$ = __WEBPACK_IMPORTED_MODULE_3_rxjs_operator_filter__["filter"].call(changes$, function (change) { return change.type === ExtensionActionTypes.STOP; });
        // Listen for lifted actions
        var liftedActions$ = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils__["a" /* applyOperators */])(changes$, [
            [__WEBPACK_IMPORTED_MODULE_3_rxjs_operator_filter__["filter"], function (change) { return change.type === ExtensionActionTypes.DISPATCH; }],
            [__WEBPACK_IMPORTED_MODULE_4_rxjs_operator_map__["map"], function (change) { return _this.unwrapAction(change.payload); }]
        ]);
        // Listen for unlifted actions
        var actions$ = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils__["a" /* applyOperators */])(changes$, [
            [__WEBPACK_IMPORTED_MODULE_3_rxjs_operator_filter__["filter"], function (change) { return change.type === ExtensionActionTypes.ACTION; }],
            [__WEBPACK_IMPORTED_MODULE_4_rxjs_operator_map__["map"], function (change) { return _this.unwrapAction(change.payload); }]
        ]);
        var actionsUntilStop$ = __WEBPACK_IMPORTED_MODULE_7_rxjs_operator_takeUntil__["takeUntil"].call(actions$, stop$);
        var liftedUntilStop$ = __WEBPACK_IMPORTED_MODULE_7_rxjs_operator_takeUntil__["takeUntil"].call(liftedActions$, stop$);
        // Only take the action sources between the start/stop events
        this.actions$ = __WEBPACK_IMPORTED_MODULE_6_rxjs_operator_switchMap__["switchMap"].call(start$, function () { return actionsUntilStop$; });
        this.liftedActions$ = __WEBPACK_IMPORTED_MODULE_6_rxjs_operator_switchMap__["switchMap"].call(start$, function () { return liftedUntilStop$; });
    };
    DevtoolsExtension.prototype.unwrapAction = function (action) {
        return typeof action === 'string' ? eval("(" + action + ")") : action;
    };
    return DevtoolsExtension;
}());

DevtoolsExtension.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
];
/** @nocollapse */
DevtoolsExtension.ctorParameters = function () { return [
    { type: undefined, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [REDUX_DEVTOOLS_EXTENSION,] },] },
]; };
//# sourceMappingURL=extension.js.map

/***/ }),

/***/ "Mqdq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscription_1 = __webpack_require__("B00U");
var subscribeToResult_1 = __webpack_require__("CURp");
var OuterSubscriber_1 = __webpack_require__("wAkD");
/**
 * Buffers the source Observable values starting from an emission from
 * `openings` and ending when the output of `closingSelector` emits.
 *
 * <span class="informal">Collects values from the past as an array. Starts
 * collecting only when `opening` emits, and calls the `closingSelector`
 * function to get an Observable that tells when to close the buffer.</span>
 *
 * <img src="./img/bufferToggle.png" width="100%">
 *
 * Buffers values from the source by opening the buffer via signals from an
 * Observable provided to `openings`, and closing and sending the buffers when
 * a Subscribable or Promise returned by the `closingSelector` function emits.
 *
 * @example <caption>Every other second, emit the click events from the next 500ms</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var openings = Rx.Observable.interval(1000);
 * var buffered = clicks.bufferToggle(openings, i =>
 *   i % 2 ? Rx.Observable.interval(500) : Rx.Observable.empty()
 * );
 * buffered.subscribe(x => console.log(x));
 *
 * @see {@link buffer}
 * @see {@link bufferCount}
 * @see {@link bufferTime}
 * @see {@link bufferWhen}
 * @see {@link windowToggle}
 *
 * @param {SubscribableOrPromise<O>} openings A Subscribable or Promise of notifications to start new
 * buffers.
 * @param {function(value: O): SubscribableOrPromise} closingSelector A function that takes
 * the value emitted by the `openings` observable and returns a Subscribable or Promise,
 * which, when it emits, signals that the associated buffer should be emitted
 * and cleared.
 * @return {Observable<T[]>} An observable of arrays of buffered values.
 * @method bufferToggle
 * @owner Observable
 */
function bufferToggle(openings, closingSelector) {
    return this.lift(new BufferToggleOperator(openings, closingSelector));
}
exports.bufferToggle = bufferToggle;
var BufferToggleOperator = (function () {
    function BufferToggleOperator(openings, closingSelector) {
        this.openings = openings;
        this.closingSelector = closingSelector;
    }
    BufferToggleOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new BufferToggleSubscriber(subscriber, this.openings, this.closingSelector));
    };
    return BufferToggleOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var BufferToggleSubscriber = (function (_super) {
    __extends(BufferToggleSubscriber, _super);
    function BufferToggleSubscriber(destination, openings, closingSelector) {
        _super.call(this, destination);
        this.openings = openings;
        this.closingSelector = closingSelector;
        this.contexts = [];
        this.add(subscribeToResult_1.subscribeToResult(this, openings));
    }
    BufferToggleSubscriber.prototype._next = function (value) {
        var contexts = this.contexts;
        var len = contexts.length;
        for (var i = 0; i < len; i++) {
            contexts[i].buffer.push(value);
        }
    };
    BufferToggleSubscriber.prototype._error = function (err) {
        var contexts = this.contexts;
        while (contexts.length > 0) {
            var context = contexts.shift();
            context.subscription.unsubscribe();
            context.buffer = null;
            context.subscription = null;
        }
        this.contexts = null;
        _super.prototype._error.call(this, err);
    };
    BufferToggleSubscriber.prototype._complete = function () {
        var contexts = this.contexts;
        while (contexts.length > 0) {
            var context = contexts.shift();
            this.destination.next(context.buffer);
            context.subscription.unsubscribe();
            context.buffer = null;
            context.subscription = null;
        }
        this.contexts = null;
        _super.prototype._complete.call(this);
    };
    BufferToggleSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        outerValue ? this.closeBuffer(outerValue) : this.openBuffer(innerValue);
    };
    BufferToggleSubscriber.prototype.notifyComplete = function (innerSub) {
        this.closeBuffer(innerSub.context);
    };
    BufferToggleSubscriber.prototype.openBuffer = function (value) {
        try {
            var closingSelector = this.closingSelector;
            var closingNotifier = closingSelector.call(this, value);
            if (closingNotifier) {
                this.trySubscribe(closingNotifier);
            }
        }
        catch (err) {
            this._error(err);
        }
    };
    BufferToggleSubscriber.prototype.closeBuffer = function (context) {
        var contexts = this.contexts;
        if (contexts && context) {
            var buffer = context.buffer, subscription = context.subscription;
            this.destination.next(buffer);
            contexts.splice(contexts.indexOf(context), 1);
            this.remove(subscription);
            subscription.unsubscribe();
        }
    };
    BufferToggleSubscriber.prototype.trySubscribe = function (closingNotifier) {
        var contexts = this.contexts;
        var buffer = [];
        var subscription = new Subscription_1.Subscription();
        var context = { buffer: buffer, subscription: subscription };
        contexts.push(context);
        var innerSubscription = subscribeToResult_1.subscribeToResult(this, closingNotifier, context);
        if (!innerSubscription || innerSubscription.closed) {
            this.closeBuffer(context);
        }
        else {
            innerSubscription.context = context;
            this.add(innerSubscription);
            subscription.add(innerSubscription);
        }
    };
    return BufferToggleSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=bufferToggle.js.map

/***/ }),

/***/ "Mrf4":
/***/ (function(module, exports) {

function DamWebParser(position, notation) {
    this.wpList = [];
    this.wkList = [];
    this.bpList = [];
    this.bkList = [];
    this.moveList = [];

    this.textPosition = "";
    this.textNotation = "";

    this.setPosition(position);
    this.setNotation(notation);
}

DamWebParser.prototype.setPosition = function(position) {
    this.textPosition = position ? position : "";
};

DamWebParser.prototype.setNotation = function(notation) {
    this.textNotation = notation ? notation : "";
};

DamWebParser.prototype.getWPList = function() { return this.wpList; };

DamWebParser.prototype.getWKList = function() { return this.wkList; };

DamWebParser.prototype.getBPList = function() { return this.bpList; };

DamWebParser.prototype.getBKList = function() { return this.bkList; };

DamWebParser.prototype.getMoveList = function() { return this.moveList; };




DamWebParser.prototype.parse = function() {
    var wp = DamWebParser._getPositionWP(this.textPosition);
    var wk = DamWebParser._getPositionWK(this.textPosition);
    var bp = DamWebParser._getPositionBP(this.textPosition);
    var bk = DamWebParser._getPositionBK(this.textPosition);


    this.wpList = DamWebParser._positionToList(wp);
    this.wkList = DamWebParser._positionToList(wk);
    this.bpList = DamWebParser._positionToList(bp);
    this.bkList = DamWebParser._positionToList(bk);


    if (this.textNotation) {
        var l = this.textNotation.length;
        var nb = l / 4;

        for (var i = 0; i < nb; i++) {
            var sMove = this.textNotation.substring(4 * i, 4 * i + 4);
            var iStart = parseInt(sMove.substring(0, 2), 10) || null;
            var iEnd = parseInt(sMove.substring(2), 10) || null;

            if (iStart != null && iEnd != null) {
                this.moveList.push([iStart, iEnd]);
            } else {
                break;
            }
        }
    }
};


DamWebParser._positionToList = function(s) {
    var list = [];

    if (s) {
        var l = s.length;
        var nb = l / 2;

        for (var i = 0; i < nb; i++) {
            var sNum = s.substring(2 * i, 2 * i + 2);
            var num = parseInt(sNum, 10) || null;
            if (num != null) {
                list.push(num);
            }
        }
    }

    return list;
};

DamWebParser._getPositionWP = function(text) {
    var pattern = /[BW]M.*?WP(.*?)(?:WK|BP|BK|$).*/;
    return this._extractSubString(text, pattern);
};

DamWebParser._getPositionBP = function(text) {
    var pattern = /[BW]M.*?BP(.*?)(?:WP|WK|BK|$).*/;
    return this._extractSubString(text, pattern);
};

DamWebParser._getPositionWK = function(text) {
    var pattern = /[BW]M.*?WK(.*?)(?:WP|BP|BK|$).*/;
    return this._extractSubString(text, pattern);
};

DamWebParser._getPositionBK = function(text) {
    var pattern = /[BW]M.*?BK(.*?)(?:WP|BP|WK|$).*/;
    return this._extractSubString(text, pattern);
};

DamWebParser._extractSubString = function(text, pattern) {
    var s = "";

    var m = text.match(pattern);
    if (m && m.length > 1) {
        s = m[1];
    }
    return s;
};

module.exports = DamWebParser;


/***/ }),

/***/ "Mvzr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var elementAt_1 = __webpack_require__("+w3m");
Observable_1.Observable.prototype.elementAt = elementAt_1.elementAt;
//# sourceMappingURL=elementAt.js.map

/***/ }),

/***/ "NJh0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var defaultIfEmpty_1 = __webpack_require__("RJ4+");
Observable_1.Observable.prototype.defaultIfEmpty = defaultIfEmpty_1.defaultIfEmpty;
//# sourceMappingURL=defaultIfEmpty.js.map

/***/ }),

/***/ "NPiC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_operator_withLatestFrom__ = __webpack_require__("u2wr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_operator_withLatestFrom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs_operator_withLatestFrom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_operator_scan__ = __webpack_require__("td8d");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_operator_scan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs_operator_scan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_operator_observeOn__ = __webpack_require__("Ji1B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_operator_observeOn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs_operator_observeOn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_scheduler_queue__ = __webpack_require__("RA5l");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_scheduler_queue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rxjs_scheduler_queue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_BehaviorSubject__ = __webpack_require__("TfWX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_BehaviorSubject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_rxjs_BehaviorSubject__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return State; });
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





var State = (function (_super) {
    __extends(State, _super);
    function State(_initialState, action$, reducer$) {
        var _this = _super.call(this, _initialState) || this;
        var actionInQueue$ = __WEBPACK_IMPORTED_MODULE_2_rxjs_operator_observeOn__["observeOn"].call(action$, __WEBPACK_IMPORTED_MODULE_3_rxjs_scheduler_queue__["queue"]);
        var actionAndReducer$ = __WEBPACK_IMPORTED_MODULE_0_rxjs_operator_withLatestFrom__["withLatestFrom"].call(actionInQueue$, reducer$);
        var state$ = __WEBPACK_IMPORTED_MODULE_1_rxjs_operator_scan__["scan"].call(actionAndReducer$, function (state, _a) {
            var action = _a[0], reducer = _a[1];
            return reducer(state, action);
        }, _initialState);
        state$.subscribe(function (value) { return _this.next(value); });
        return _this;
    }
    return State;
}(__WEBPACK_IMPORTED_MODULE_4_rxjs_BehaviorSubject__["BehaviorSubject"]));

//# sourceMappingURL=state.js.map

/***/ }),

/***/ "NVOs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("3j3K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_observable_forkJoin__ = __webpack_require__("7rB9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_observable_forkJoin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs_observable_forkJoin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_observable_fromPromise__ = __webpack_require__("ioK+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_observable_fromPromise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs_observable_fromPromise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_operator_map__ = __webpack_require__("xAJs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_operator_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rxjs_operator_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__angular_platform_browser__ = __webpack_require__("Qbdm");
/* unused harmony export AbstractControlDirective */
/* unused harmony export AbstractFormGroupDirective */
/* unused harmony export CheckboxControlValueAccessor */
/* unused harmony export ControlContainer */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return NG_VALUE_ACCESSOR; });
/* unused harmony export COMPOSITION_BUFFER_MODE */
/* unused harmony export DefaultValueAccessor */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return NgControl; });
/* unused harmony export NgControlStatus */
/* unused harmony export NgControlStatusGroup */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return NgForm; });
/* unused harmony export NgModel */
/* unused harmony export NgModelGroup */
/* unused harmony export RadioControlValueAccessor */
/* unused harmony export FormControlDirective */
/* unused harmony export FormControlName */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return FormGroupDirective; });
/* unused harmony export FormArrayName */
/* unused harmony export FormGroupName */
/* unused harmony export NgSelectOption */
/* unused harmony export SelectControlValueAccessor */
/* unused harmony export SelectMultipleControlValueAccessor */
/* unused harmony export CheckboxRequiredValidator */
/* unused harmony export EmailValidator */
/* unused harmony export MaxLengthValidator */
/* unused harmony export MinLengthValidator */
/* unused harmony export PatternValidator */
/* unused harmony export RequiredValidator */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FormBuilder; });
/* unused harmony export AbstractControl */
/* unused harmony export FormArray */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FormControl; });
/* unused harmony export FormGroup */
/* unused harmony export NG_ASYNC_VALIDATORS */
/* unused harmony export NG_VALIDATORS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return Validators; });
/* unused harmony export VERSION */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FormsModule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return ReactiveFormsModule; });
/* unused harmony export ɵba */
/* unused harmony export ɵz */
/* unused harmony export ɵx */
/* unused harmony export ɵy */
/* unused harmony export ɵa */
/* unused harmony export ɵb */
/* unused harmony export ɵc */
/* unused harmony export ɵd */
/* unused harmony export ɵe */
/* unused harmony export ɵf */
/* unused harmony export ɵg */
/* unused harmony export ɵbf */
/* unused harmony export ɵbb */
/* unused harmony export ɵbc */
/* unused harmony export ɵh */
/* unused harmony export ɵi */
/* unused harmony export ɵbd */
/* unused harmony export ɵbe */
/* unused harmony export ɵj */
/* unused harmony export ɵk */
/* unused harmony export ɵl */
/* unused harmony export ɵn */
/* unused harmony export ɵm */
/* unused harmony export ɵo */
/* unused harmony export ɵq */
/* unused harmony export ɵp */
/* unused harmony export ɵs */
/* unused harmony export ɵt */
/* unused harmony export ɵv */
/* unused harmony export ɵu */
/* unused harmony export ɵw */
/* unused harmony export ɵr */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * @license Angular v4.1.0
 * (c) 2010-2017 Google, Inc. https://angular.io/
 * License: MIT
 */





/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Base class for control directives.
 *
 * Only used internally in the forms module.
 *
 * \@stable
 * @abstract
 */
var AbstractControlDirective = (function () {
    function AbstractControlDirective() {
    }
    /**
     * @abstract
     * @return {?}
     */
    AbstractControlDirective.prototype.control = function () { };
    Object.defineProperty(AbstractControlDirective.prototype, "value", {
        /**
         * @return {?}
         */
        get: function () { return this.control ? this.control.value : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "valid", {
        /**
         * @return {?}
         */
        get: function () { return this.control ? this.control.valid : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "invalid", {
        /**
         * @return {?}
         */
        get: function () { return this.control ? this.control.invalid : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "pending", {
        /**
         * @return {?}
         */
        get: function () { return this.control ? this.control.pending : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "errors", {
        /**
         * @return {?}
         */
        get: function () { return this.control ? this.control.errors : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "pristine", {
        /**
         * @return {?}
         */
        get: function () { return this.control ? this.control.pristine : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "dirty", {
        /**
         * @return {?}
         */
        get: function () { return this.control ? this.control.dirty : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "touched", {
        /**
         * @return {?}
         */
        get: function () { return this.control ? this.control.touched : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "untouched", {
        /**
         * @return {?}
         */
        get: function () { return this.control ? this.control.untouched : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "disabled", {
        /**
         * @return {?}
         */
        get: function () { return this.control ? this.control.disabled : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "enabled", {
        /**
         * @return {?}
         */
        get: function () { return this.control ? this.control.enabled : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "statusChanges", {
        /**
         * @return {?}
         */
        get: function () {
            return this.control ? this.control.statusChanges : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "valueChanges", {
        /**
         * @return {?}
         */
        get: function () {
            return this.control ? this.control.valueChanges : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlDirective.prototype, "path", {
        /**
         * @return {?}
         */
        get: function () { return null; },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?=} value
     * @return {?}
     */
    AbstractControlDirective.prototype.reset = function (value) {
        if (value === void 0) { value = undefined; }
        if (this.control)
            this.control.reset(value);
    };
    /**
     * @param {?} errorCode
     * @param {?=} path
     * @return {?}
     */
    AbstractControlDirective.prototype.hasError = function (errorCode, path) {
        return this.control ? this.control.hasError(errorCode, path) : false;
    };
    /**
     * @param {?} errorCode
     * @param {?=} path
     * @return {?}
     */
    AbstractControlDirective.prototype.getError = function (errorCode, path) {
        return this.control ? this.control.getError(errorCode, path) : null;
    };
    return AbstractControlDirective;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * A directive that contains multiple {\@link NgControl}s.
 *
 * Only used by the forms module.
 *
 * \@stable
 * @abstract
 */
var ControlContainer = (function (_super) {
    __extends(ControlContainer, _super);
    function ControlContainer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(ControlContainer.prototype, "formDirective", {
        /**
         * Get the form to which this container belongs.
         * @return {?}
         */
        get: function () { return null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ControlContainer.prototype, "path", {
        /**
         * Get the path to this container.
         * @return {?}
         */
        get: function () { return null; },
        enumerable: true,
        configurable: true
    });
    return ControlContainer;
}(AbstractControlDirective));
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var __assign = (undefined && undefined.__assign) || Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s)
            if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
    }
    return t;
};
/**
 * @param {?} value
 * @return {?}
 */
function isEmptyInputValue(value) {
    // we don't check for string here so it also works with arrays
    return value == null || value.length === 0;
}
/**
 * Providers for validators to be used for {\@link FormControl}s in a form.
 *
 * Provide this using `multi: true` to add validators.
 *
 * ### Example
 *
 * {\@example core/forms/ts/ng_validators/ng_validators.ts region='ng_validators'}
 * \@stable
 */
var NG_VALIDATORS = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["InjectionToken"]('NgValidators');
/**
 * Providers for asynchronous validators to be used for {\@link FormControl}s
 * in a form.
 *
 * Provide this using `multi: true` to add validators.
 *
 * See {\@link NG_VALIDATORS} for more details.
 *
 * \@stable
 */
var NG_ASYNC_VALIDATORS = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["InjectionToken"]('NgAsyncValidators');
var EMAIL_REGEXP = /^(?=.{1,254}$)(?=.{1,64}@)[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+(\.[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+)*@[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?(\.[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?)*$/;
/**
 * Provides a set of validators used by form controls.
 *
 * A validator is a function that processes a {\@link FormControl} or collection of
 * controls and returns a map of errors. A null map means that validation has passed.
 *
 * ### Example
 *
 * ```typescript
 * var loginControl = new FormControl("", Validators.required)
 * ```
 *
 * \@stable
 */
var Validators = (function () {
    function Validators() {
    }
    /**
     * Validator that requires controls to have a non-empty value.
     * @param {?} control
     * @return {?}
     */
    Validators.required = function (control) {
        return isEmptyInputValue(control.value) ? { 'required': true } : null;
    };
    /**
     * Validator that requires control value to be true.
     * @param {?} control
     * @return {?}
     */
    Validators.requiredTrue = function (control) {
        return control.value === true ? null : { 'required': true };
    };
    /**
     * Validator that performs email validation.
     * @param {?} control
     * @return {?}
     */
    Validators.email = function (control) {
        return EMAIL_REGEXP.test(control.value) ? null : { 'email': true };
    };
    /**
     * Validator that requires controls to have a value of a minimum length.
     * @param {?} minLength
     * @return {?}
     */
    Validators.minLength = function (minLength) {
        return function (control) {
            if (isEmptyInputValue(control.value)) {
                return null; // don't validate empty values to allow optional controls
            }
            var /** @type {?} */ length = control.value ? control.value.length : 0;
            return length < minLength ?
                { 'minlength': { 'requiredLength': minLength, 'actualLength': length } } :
                null;
        };
    };
    /**
     * Validator that requires controls to have a value of a maximum length.
     * @param {?} maxLength
     * @return {?}
     */
    Validators.maxLength = function (maxLength) {
        return function (control) {
            var /** @type {?} */ length = control.value ? control.value.length : 0;
            return length > maxLength ?
                { 'maxlength': { 'requiredLength': maxLength, 'actualLength': length } } :
                null;
        };
    };
    /**
     * Validator that requires a control to match a regex to its value.
     * @param {?} pattern
     * @return {?}
     */
    Validators.pattern = function (pattern) {
        if (!pattern)
            return Validators.nullValidator;
        var /** @type {?} */ regex;
        var /** @type {?} */ regexStr;
        if (typeof pattern === 'string') {
            regexStr = "^" + pattern + "$";
            regex = new RegExp(regexStr);
        }
        else {
            regexStr = pattern.toString();
            regex = pattern;
        }
        return function (control) {
            if (isEmptyInputValue(control.value)) {
                return null; // don't validate empty values to allow optional controls
            }
            var /** @type {?} */ value = control.value;
            return regex.test(value) ? null :
                { 'pattern': { 'requiredPattern': regexStr, 'actualValue': value } };
        };
    };
    /**
     * No-op validator.
     * @param {?} c
     * @return {?}
     */
    Validators.nullValidator = function (c) { return null; };
    /**
     * @param {?} validators
     * @return {?}
     */
    Validators.compose = function (validators) {
        if (!validators)
            return null;
        var /** @type {?} */ presentValidators = (validators.filter(isPresent));
        if (presentValidators.length == 0)
            return null;
        return function (control) {
            return _mergeErrors(_executeValidators(control, presentValidators));
        };
    };
    /**
     * @param {?} validators
     * @return {?}
     */
    Validators.composeAsync = function (validators) {
        if (!validators)
            return null;
        var /** @type {?} */ presentValidators = (validators.filter(isPresent));
        if (presentValidators.length == 0)
            return null;
        return function (control) {
            var /** @type {?} */ observables = _executeAsyncValidators(control, presentValidators).map(toObservable);
            return __WEBPACK_IMPORTED_MODULE_3_rxjs_operator_map__["map"].call(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_rxjs_observable_forkJoin__["forkJoin"])(observables), _mergeErrors);
        };
    };
    return Validators;
}());
/**
 * @param {?} o
 * @return {?}
 */
function isPresent(o) {
    return o != null;
}
/**
 * @param {?} r
 * @return {?}
 */
function toObservable(r) {
    var /** @type {?} */ obs = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵisPromise"])(r) ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_rxjs_observable_fromPromise__["fromPromise"])(r) : r;
    if (!(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵisObservable"])(obs))) {
        throw new Error("Expected validator to return Promise or Observable.");
    }
    return obs;
}
/**
 * @param {?} control
 * @param {?} validators
 * @return {?}
 */
function _executeValidators(control, validators) {
    return validators.map(function (v) { return v(control); });
}
/**
 * @param {?} control
 * @param {?} validators
 * @return {?}
 */
function _executeAsyncValidators(control, validators) {
    return validators.map(function (v) { return v(control); });
}
/**
 * @param {?} arrayOfErrors
 * @return {?}
 */
function _mergeErrors(arrayOfErrors) {
    var /** @type {?} */ res = arrayOfErrors.reduce(function (res, errors) {
        return errors != null ? __assign({}, /** @type {?} */ ((res)), errors) : ((res));
    }, {});
    return Object.keys(res).length === 0 ? null : res;
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Used to provide a {\@link ControlValueAccessor} for form controls.
 *
 * See {\@link DefaultValueAccessor} for how to implement one.
 * \@stable
 */
var NG_VALUE_ACCESSOR = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["InjectionToken"]('NgValueAccessor');
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var CHECKBOX_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return CheckboxControlValueAccessor; }),
    multi: true,
};
/**
 * The accessor for writing a value and listening to changes on a checkbox input element.
 *
 *  ### Example
 *  ```
 *  <input type="checkbox" name="rememberLogin" ngModel>
 *  ```
 *
 *  \@stable
 */
var CheckboxControlValueAccessor = (function () {
    /**
     * @param {?} _renderer
     * @param {?} _elementRef
     */
    function CheckboxControlValueAccessor(_renderer, _elementRef) {
        this._renderer = _renderer;
        this._elementRef = _elementRef;
        this.onChange = function (_) { };
        this.onTouched = function () { };
    }
    /**
     * @param {?} value
     * @return {?}
     */
    CheckboxControlValueAccessor.prototype.writeValue = function (value) {
        this._renderer.setElementProperty(this._elementRef.nativeElement, 'checked', value);
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    CheckboxControlValueAccessor.prototype.registerOnChange = function (fn) { this.onChange = fn; };
    /**
     * @param {?} fn
     * @return {?}
     */
    CheckboxControlValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    CheckboxControlValueAccessor.prototype.setDisabledState = function (isDisabled) {
        this._renderer.setElementProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
    };
    return CheckboxControlValueAccessor;
}());
CheckboxControlValueAccessor.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                selector: 'input[type=checkbox][formControlName],input[type=checkbox][formControl],input[type=checkbox][ngModel]',
                host: { '(change)': 'onChange($event.target.checked)', '(blur)': 'onTouched()' },
                providers: [CHECKBOX_VALUE_ACCESSOR]
            },] },
];
/**
 * @nocollapse
 */
CheckboxControlValueAccessor.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
]; };
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var DEFAULT_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return DefaultValueAccessor; }),
    multi: true
};
/**
 * We must check whether the agent is Android because composition events
 * behave differently between iOS and Android.
 * @return {?}
 */
function _isAndroid() {
    var /** @type {?} */ userAgent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__angular_platform_browser__["ɵgetDOM"])() ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__angular_platform_browser__["ɵgetDOM"])().getUserAgent() : '';
    return /android (\d+)/.test(userAgent.toLowerCase());
}
/**
 * Turn this mode on if you want form directives to buffer IME input until compositionend
 * \@experimental
 */
var COMPOSITION_BUFFER_MODE = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["InjectionToken"]('CompositionEventMode');
/**
 * The default accessor for writing a value and listening to changes that is used by the
 * {\@link NgModel}, {\@link FormControlDirective}, and {\@link FormControlName} directives.
 *
 *  ### Example
 *  ```
 *  <input type="text" name="searchQuery" ngModel>
 *  ```
 *
 *  \@stable
 */
var DefaultValueAccessor = (function () {
    /**
     * @param {?} _renderer
     * @param {?} _elementRef
     * @param {?} _compositionMode
     */
    function DefaultValueAccessor(_renderer, _elementRef, _compositionMode) {
        this._renderer = _renderer;
        this._elementRef = _elementRef;
        this._compositionMode = _compositionMode;
        this.onChange = function (_) { };
        this.onTouched = function () { };
        this._composing = false;
        if (this._compositionMode == null) {
            this._compositionMode = !_isAndroid();
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    DefaultValueAccessor.prototype.writeValue = function (value) {
        var /** @type {?} */ normalizedValue = value == null ? '' : value;
        this._renderer.setElementProperty(this._elementRef.nativeElement, 'value', normalizedValue);
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    DefaultValueAccessor.prototype.registerOnChange = function (fn) { this.onChange = fn; };
    /**
     * @param {?} fn
     * @return {?}
     */
    DefaultValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    DefaultValueAccessor.prototype.setDisabledState = function (isDisabled) {
        this._renderer.setElementProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
    };
    /**
     * @param {?} value
     * @return {?}
     */
    DefaultValueAccessor.prototype._handleInput = function (value) {
        if (!this._compositionMode || (this._compositionMode && !this._composing)) {
            this.onChange(value);
        }
    };
    /**
     * @return {?}
     */
    DefaultValueAccessor.prototype._compositionStart = function () { this._composing = true; };
    /**
     * @param {?} value
     * @return {?}
     */
    DefaultValueAccessor.prototype._compositionEnd = function (value) {
        this._composing = false;
        this._compositionMode && this.onChange(value);
    };
    return DefaultValueAccessor;
}());
DefaultValueAccessor.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                selector: 'input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]',
                // TODO: vsavkin replace the above selector with the one below it once
                // https://github.com/angular/angular/issues/3011 is implemented
                // selector: '[ngModel],[formControl],[formControlName]',
                host: {
                    '(input)': '_handleInput($event.target.value)',
                    '(blur)': 'onTouched()',
                    '(compositionstart)': '_compositionStart()',
                    '(compositionend)': '_compositionEnd($event.target.value)'
                },
                providers: [DEFAULT_VALUE_ACCESSOR]
            },] },
];
/**
 * @nocollapse
 */
DefaultValueAccessor.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
    { type: undefined, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [COMPOSITION_BUFFER_MODE,] },] },
]; };
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @param {?} validator
 * @return {?}
 */
function normalizeValidator(validator) {
    if (((validator)).validate) {
        return function (c) { return ((validator)).validate(c); };
    }
    else {
        return (validator);
    }
}
/**
 * @param {?} validator
 * @return {?}
 */
function normalizeAsyncValidator(validator) {
    if (((validator)).validate) {
        return function (c) { return ((validator)).validate(c); };
    }
    else {
        return (validator);
    }
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var NUMBER_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return NumberValueAccessor; }),
    multi: true
};
/**
 * The accessor for writing a number value and listening to changes that is used by the
 * {\@link NgModel}, {\@link FormControlDirective}, and {\@link FormControlName} directives.
 *
 *  ### Example
 *  ```
 *  <input type="number" [(ngModel)]="age">
 *  ```
 */
var NumberValueAccessor = (function () {
    /**
     * @param {?} _renderer
     * @param {?} _elementRef
     */
    function NumberValueAccessor(_renderer, _elementRef) {
        this._renderer = _renderer;
        this._elementRef = _elementRef;
        this.onChange = function (_) { };
        this.onTouched = function () { };
    }
    /**
     * @param {?} value
     * @return {?}
     */
    NumberValueAccessor.prototype.writeValue = function (value) {
        // The value needs to be normalized for IE9, otherwise it is set to 'null' when null
        var /** @type {?} */ normalizedValue = value == null ? '' : value;
        this._renderer.setElementProperty(this._elementRef.nativeElement, 'value', normalizedValue);
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    NumberValueAccessor.prototype.registerOnChange = function (fn) {
        this.onChange = function (value) { fn(value == '' ? null : parseFloat(value)); };
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    NumberValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    NumberValueAccessor.prototype.setDisabledState = function (isDisabled) {
        this._renderer.setElementProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
    };
    return NumberValueAccessor;
}());
NumberValueAccessor.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                selector: 'input[type=number][formControlName],input[type=number][formControl],input[type=number][ngModel]',
                host: {
                    '(change)': 'onChange($event.target.value)',
                    '(input)': 'onChange($event.target.value)',
                    '(blur)': 'onTouched()'
                },
                providers: [NUMBER_VALUE_ACCESSOR]
            },] },
];
/**
 * @nocollapse
 */
NumberValueAccessor.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
]; };
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @return {?}
 */
function unimplemented() {
    throw new Error('unimplemented');
}
/**
 * A base class that all control directive extend.
 * It binds a {\@link FormControl} object to a DOM element.
 *
 * Used internally by Angular forms.
 *
 * \@stable
 * @abstract
 */
var NgControl = (function (_super) {
    __extends(NgControl, _super);
    function NgControl() {
        var _this = _super.apply(this, arguments) || this;
        /**
         * \@internal
         */
        _this._parent = null;
        _this.name = null;
        _this.valueAccessor = null;
        /**
         * \@internal
         */
        _this._rawValidators = [];
        /**
         * \@internal
         */
        _this._rawAsyncValidators = [];
        return _this;
    }
    Object.defineProperty(NgControl.prototype, "validator", {
        /**
         * @return {?}
         */
        get: function () { return (unimplemented()); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgControl.prototype, "asyncValidator", {
        /**
         * @return {?}
         */
        get: function () { return (unimplemented()); },
        enumerable: true,
        configurable: true
    });
    /**
     * @abstract
     * @param {?} newValue
     * @return {?}
     */
    NgControl.prototype.viewToModelUpdate = function (newValue) { };
    return NgControl;
}(AbstractControlDirective));
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var RADIO_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return RadioControlValueAccessor; }),
    multi: true
};
/**
 * Internal class used by Angular to uncheck radio buttons with the matching name.
 */
var RadioControlRegistry = (function () {
    function RadioControlRegistry() {
        this._accessors = [];
    }
    /**
     * @param {?} control
     * @param {?} accessor
     * @return {?}
     */
    RadioControlRegistry.prototype.add = function (control, accessor) {
        this._accessors.push([control, accessor]);
    };
    /**
     * @param {?} accessor
     * @return {?}
     */
    RadioControlRegistry.prototype.remove = function (accessor) {
        for (var /** @type {?} */ i = this._accessors.length - 1; i >= 0; --i) {
            if (this._accessors[i][1] === accessor) {
                this._accessors.splice(i, 1);
                return;
            }
        }
    };
    /**
     * @param {?} accessor
     * @return {?}
     */
    RadioControlRegistry.prototype.select = function (accessor) {
        var _this = this;
        this._accessors.forEach(function (c) {
            if (_this._isSameGroup(c, accessor) && c[1] !== accessor) {
                c[1].fireUncheck(accessor.value);
            }
        });
    };
    /**
     * @param {?} controlPair
     * @param {?} accessor
     * @return {?}
     */
    RadioControlRegistry.prototype._isSameGroup = function (controlPair, accessor) {
        if (!controlPair[0].control)
            return false;
        return controlPair[0]._parent === accessor._control._parent &&
            controlPair[1].name === accessor.name;
    };
    return RadioControlRegistry;
}());
RadioControlRegistry.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
];
/**
 * @nocollapse
 */
RadioControlRegistry.ctorParameters = function () { return []; };
/**
 * \@whatItDoes Writes radio control values and listens to radio control changes.
 *
 * Used by {\@link NgModel}, {\@link FormControlDirective}, and {\@link FormControlName}
 * to keep the view synced with the {\@link FormControl} model.
 *
 * \@howToUse
 *
 * If you have imported the {\@link FormsModule} or the {\@link ReactiveFormsModule}, this
 * value accessor will be active on any radio control that has a form directive. You do
 * **not** need to add a special selector to activate it.
 *
 * ### How to use radio buttons with form directives
 *
 * To use radio buttons in a template-driven form, you'll want to ensure that radio buttons
 * in the same group have the same `name` attribute.  Radio buttons with different `name`
 * attributes do not affect each other.
 *
 * {\@example forms/ts/radioButtons/radio_button_example.ts region='TemplateDriven'}
 *
 * When using radio buttons in a reactive form, radio buttons in the same group should have the
 * same `formControlName`. You can also add a `name` attribute, but it's optional.
 *
 * {\@example forms/ts/reactiveRadioButtons/reactive_radio_button_example.ts region='Reactive'}
 *
 *  * **npm package**: `\@angular/forms`
 *
 *  \@stable
 */
var RadioControlValueAccessor = (function () {
    /**
     * @param {?} _renderer
     * @param {?} _elementRef
     * @param {?} _registry
     * @param {?} _injector
     */
    function RadioControlValueAccessor(_renderer, _elementRef, _registry, _injector) {
        this._renderer = _renderer;
        this._elementRef = _elementRef;
        this._registry = _registry;
        this._injector = _injector;
        this.onChange = function () { };
        this.onTouched = function () { };
    }
    /**
     * @return {?}
     */
    RadioControlValueAccessor.prototype.ngOnInit = function () {
        this._control = this._injector.get(NgControl);
        this._checkName();
        this._registry.add(this._control, this);
    };
    /**
     * @return {?}
     */
    RadioControlValueAccessor.prototype.ngOnDestroy = function () { this._registry.remove(this); };
    /**
     * @param {?} value
     * @return {?}
     */
    RadioControlValueAccessor.prototype.writeValue = function (value) {
        this._state = value === this.value;
        this._renderer.setElementProperty(this._elementRef.nativeElement, 'checked', this._state);
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    RadioControlValueAccessor.prototype.registerOnChange = function (fn) {
        var _this = this;
        this._fn = fn;
        this.onChange = function () {
            fn(_this.value);
            _this._registry.select(_this);
        };
    };
    /**
     * @param {?} value
     * @return {?}
     */
    RadioControlValueAccessor.prototype.fireUncheck = function (value) { this.writeValue(value); };
    /**
     * @param {?} fn
     * @return {?}
     */
    RadioControlValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    RadioControlValueAccessor.prototype.setDisabledState = function (isDisabled) {
        this._renderer.setElementProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
    };
    /**
     * @return {?}
     */
    RadioControlValueAccessor.prototype._checkName = function () {
        if (this.name && this.formControlName && this.name !== this.formControlName) {
            this._throwNameError();
        }
        if (!this.name && this.formControlName)
            this.name = this.formControlName;
    };
    /**
     * @return {?}
     */
    RadioControlValueAccessor.prototype._throwNameError = function () {
        throw new Error("\n      If you define both a name and a formControlName attribute on your radio button, their values\n      must match. Ex: <input type=\"radio\" formControlName=\"food\" name=\"food\">\n    ");
    };
    return RadioControlValueAccessor;
}());
RadioControlValueAccessor.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                selector: 'input[type=radio][formControlName],input[type=radio][formControl],input[type=radio][ngModel]',
                host: { '(change)': 'onChange()', '(blur)': 'onTouched()' },
                providers: [RADIO_VALUE_ACCESSOR]
            },] },
];
/**
 * @nocollapse
 */
RadioControlValueAccessor.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
    { type: RadioControlRegistry, },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injector"], },
]; };
RadioControlValueAccessor.propDecorators = {
    'name': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'formControlName': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'value': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
};
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var RANGE_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return RangeValueAccessor; }),
    multi: true
};
/**
 * The accessor for writing a range value and listening to changes that is used by the
 * {\@link NgModel}, {\@link FormControlDirective}, and {\@link FormControlName} directives.
 *
 *  ### Example
 *  ```
 *  <input type="range" [(ngModel)]="age" >
 *  ```
 */
var RangeValueAccessor = (function () {
    /**
     * @param {?} _renderer
     * @param {?} _elementRef
     */
    function RangeValueAccessor(_renderer, _elementRef) {
        this._renderer = _renderer;
        this._elementRef = _elementRef;
        this.onChange = function (_) { };
        this.onTouched = function () { };
    }
    /**
     * @param {?} value
     * @return {?}
     */
    RangeValueAccessor.prototype.writeValue = function (value) {
        this._renderer.setElementProperty(this._elementRef.nativeElement, 'value', parseFloat(value));
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    RangeValueAccessor.prototype.registerOnChange = function (fn) {
        this.onChange = function (value) { fn(value == '' ? null : parseFloat(value)); };
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    RangeValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    RangeValueAccessor.prototype.setDisabledState = function (isDisabled) {
        this._renderer.setElementProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
    };
    return RangeValueAccessor;
}());
RangeValueAccessor.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                selector: 'input[type=range][formControlName],input[type=range][formControl],input[type=range][ngModel]',
                host: {
                    '(change)': 'onChange($event.target.value)',
                    '(input)': 'onChange($event.target.value)',
                    '(blur)': 'onTouched()'
                },
                providers: [RANGE_VALUE_ACCESSOR]
            },] },
];
/**
 * @nocollapse
 */
RangeValueAccessor.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
]; };
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var SELECT_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return SelectControlValueAccessor; }),
    multi: true
};
/**
 * @param {?} id
 * @param {?} value
 * @return {?}
 */
function _buildValueString(id, value) {
    if (id == null)
        return "" + value;
    if (value && typeof value === 'object')
        value = 'Object';
    return (id + ": " + value).slice(0, 50);
}
/**
 * @param {?} valueString
 * @return {?}
 */
function _extractId(valueString) {
    return valueString.split(':')[0];
}
/**
 * \@whatItDoes Writes values and listens to changes on a select element.
 *
 * Used by {\@link NgModel}, {\@link FormControlDirective}, and {\@link FormControlName}
 * to keep the view synced with the {\@link FormControl} model.
 *
 * \@howToUse
 *
 * If you have imported the {\@link FormsModule} or the {\@link ReactiveFormsModule}, this
 * value accessor will be active on any select control that has a form directive. You do
 * **not** need to add a special selector to activate it.
 *
 * ### How to use select controls with form directives
 *
 * To use a select in a template-driven form, simply add an `ngModel` and a `name`
 * attribute to the main `<select>` tag.
 *
 * If your option values are simple strings, you can bind to the normal `value` property
 * on the option.  If your option values happen to be objects (and you'd like to save the
 * selection in your form as an object), use `ngValue` instead:
 *
 * {\@example forms/ts/selectControl/select_control_example.ts region='Component'}
 *
 * In reactive forms, you'll also want to add your form directive (`formControlName` or
 * `formControl`) on the main `<select>` tag. Like in the former example, you have the
 * choice of binding to the  `value` or `ngValue` property on the select's options.
 *
 * {\@example forms/ts/reactiveSelectControl/reactive_select_control_example.ts region='Component'}
 *
 * ### Caveat: Option selection
 *
 * Angular uses object identity to select option. It's possible for the identities of items
 * to change while the data does not. This can happen, for example, if the items are produced
 * from an RPC to the server, and that RPC is re-run. Even if the data hasn't changed, the
 * second response will produce objects with different identities.
 *
 * To customize the default option comparison algorithm, `<select>` supports `compareWith` input.
 * `compareWith` takes a **function** which has two arguments: `option1` and `option2`.
 * If `compareWith` is given, Angular selects option by the return value of the function.
 *
 * #### Syntax
 *
 * ```
 * <select [compareWith]="compareFn"  [(ngModel)]="selectedCountries">
 *     <option *ngFor="let country of countries" [ngValue]="country">
 *         {{country.name}}
 *     </option>
 * </select>
 *
 * compareFn(c1: Country, c2: Country): boolean {
 *     return c1 && c2 ? c1.id === c2.id : c1 === c2;
 * }
 * ```
 *
 * Note: We listen to the 'change' event because 'input' events aren't fired
 * for selects in Firefox and IE:
 * https://bugzilla.mozilla.org/show_bug.cgi?id=1024350
 * https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/4660045/
 *
 * * **npm package**: `\@angular/forms`
 *
 * \@stable
 */
var SelectControlValueAccessor = (function () {
    /**
     * @param {?} _renderer
     * @param {?} _elementRef
     */
    function SelectControlValueAccessor(_renderer, _elementRef) {
        this._renderer = _renderer;
        this._elementRef = _elementRef;
        /**
         * \@internal
         */
        this._optionMap = new Map();
        /**
         * \@internal
         */
        this._idCounter = 0;
        this.onChange = function (_) { };
        this.onTouched = function () { };
        this._compareWith = __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵlooseIdentical"];
    }
    Object.defineProperty(SelectControlValueAccessor.prototype, "compareWith", {
        /**
         * @param {?} fn
         * @return {?}
         */
        set: function (fn) {
            if (typeof fn !== 'function') {
                throw new Error("compareWith must be a function, but received " + JSON.stringify(fn));
            }
            this._compareWith = fn;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} value
     * @return {?}
     */
    SelectControlValueAccessor.prototype.writeValue = function (value) {
        this.value = value;
        var /** @type {?} */ id = this._getOptionId(value);
        if (id == null) {
            this._renderer.setElementProperty(this._elementRef.nativeElement, 'selectedIndex', -1);
        }
        var /** @type {?} */ valueString = _buildValueString(id, value);
        this._renderer.setElementProperty(this._elementRef.nativeElement, 'value', valueString);
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    SelectControlValueAccessor.prototype.registerOnChange = function (fn) {
        var _this = this;
        this.onChange = function (valueString) {
            _this.value = valueString;
            fn(_this._getOptionValue(valueString));
        };
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    SelectControlValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    SelectControlValueAccessor.prototype.setDisabledState = function (isDisabled) {
        this._renderer.setElementProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
    };
    /**
     * \@internal
     * @return {?}
     */
    SelectControlValueAccessor.prototype._registerOption = function () { return (this._idCounter++).toString(); };
    /**
     * \@internal
     * @param {?} value
     * @return {?}
     */
    SelectControlValueAccessor.prototype._getOptionId = function (value) {
        for (var _i = 0, _a = Array.from(this._optionMap.keys()); _i < _a.length; _i++) {
            var id = _a[_i];
            if (this._compareWith(this._optionMap.get(id), value))
                return id;
        }
        return null;
    };
    /**
     * \@internal
     * @param {?} valueString
     * @return {?}
     */
    SelectControlValueAccessor.prototype._getOptionValue = function (valueString) {
        var /** @type {?} */ id = _extractId(valueString);
        return this._optionMap.has(id) ? this._optionMap.get(id) : valueString;
    };
    return SelectControlValueAccessor;
}());
SelectControlValueAccessor.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                selector: 'select:not([multiple])[formControlName],select:not([multiple])[formControl],select:not([multiple])[ngModel]',
                host: { '(change)': 'onChange($event.target.value)', '(blur)': 'onTouched()' },
                providers: [SELECT_VALUE_ACCESSOR]
            },] },
];
/**
 * @nocollapse
 */
SelectControlValueAccessor.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
]; };
SelectControlValueAccessor.propDecorators = {
    'compareWith': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
};
/**
 * \@whatItDoes Marks `<option>` as dynamic, so Angular can be notified when options change.
 *
 * \@howToUse
 *
 * See docs for {\@link SelectControlValueAccessor} for usage examples.
 *
 * \@stable
 */
var NgSelectOption = (function () {
    /**
     * @param {?} _element
     * @param {?} _renderer
     * @param {?} _select
     */
    function NgSelectOption(_element, _renderer, _select) {
        this._element = _element;
        this._renderer = _renderer;
        this._select = _select;
        if (this._select)
            this.id = this._select._registerOption();
    }
    Object.defineProperty(NgSelectOption.prototype, "ngValue", {
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            if (this._select == null)
                return;
            this._select._optionMap.set(this.id, value);
            this._setElementValue(_buildValueString(this.id, value));
            this._select.writeValue(this._select.value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgSelectOption.prototype, "value", {
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._setElementValue(value);
            if (this._select)
                this._select.writeValue(this._select.value);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * \@internal
     * @param {?} value
     * @return {?}
     */
    NgSelectOption.prototype._setElementValue = function (value) {
        this._renderer.setElementProperty(this._element.nativeElement, 'value', value);
    };
    /**
     * @return {?}
     */
    NgSelectOption.prototype.ngOnDestroy = function () {
        if (this._select) {
            this._select._optionMap.delete(this.id);
            this._select.writeValue(this._select.value);
        }
    };
    return NgSelectOption;
}());
NgSelectOption.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{ selector: 'option' },] },
];
/**
 * @nocollapse
 */
NgSelectOption.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
    { type: SelectControlValueAccessor, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Host"] },] },
]; };
NgSelectOption.propDecorators = {
    'ngValue': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['ngValue',] },],
    'value': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['value',] },],
};
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var SELECT_MULTIPLE_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return SelectMultipleControlValueAccessor; }),
    multi: true
};
/**
 * @param {?} id
 * @param {?} value
 * @return {?}
 */
function _buildValueString$1(id, value) {
    if (id == null)
        return "" + value;
    if (typeof value === 'string')
        value = "'" + value + "'";
    if (value && typeof value === 'object')
        value = 'Object';
    return (id + ": " + value).slice(0, 50);
}
/**
 * @param {?} valueString
 * @return {?}
 */
function _extractId$1(valueString) {
    return valueString.split(':')[0];
}
/**
 * The accessor for writing a value and listening to changes on a select element.
 *
 *  ### Caveat: Options selection
 *
 * Angular uses object identity to select options. It's possible for the identities of items
 * to change while the data does not. This can happen, for example, if the items are produced
 * from an RPC to the server, and that RPC is re-run. Even if the data hasn't changed, the
 * second response will produce objects with different identities.
 *
 * To customize the default option comparison algorithm, `<select multiple>` supports `compareWith`
 * input. `compareWith` takes a **function** which has two arguments: `option1` and `option2`.
 * If `compareWith` is given, Angular selects options by the return value of the function.
 *
 * #### Syntax
 *
 * ```
 * <select multiple [compareWith]="compareFn"  [(ngModel)]="selectedCountries">
 *     <option *ngFor="let country of countries" [ngValue]="country">
 *         {{country.name}}
 *     </option>
 * </select>
 *
 * compareFn(c1: Country, c2: Country): boolean {
 *     return c1 && c2 ? c1.id === c2.id : c1 === c2;
 * }
 * ```
 *
 * \@stable
 */
var SelectMultipleControlValueAccessor = (function () {
    /**
     * @param {?} _renderer
     * @param {?} _elementRef
     */
    function SelectMultipleControlValueAccessor(_renderer, _elementRef) {
        this._renderer = _renderer;
        this._elementRef = _elementRef;
        /**
         * \@internal
         */
        this._optionMap = new Map();
        /**
         * \@internal
         */
        this._idCounter = 0;
        this.onChange = function (_) { };
        this.onTouched = function () { };
        this._compareWith = __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵlooseIdentical"];
    }
    Object.defineProperty(SelectMultipleControlValueAccessor.prototype, "compareWith", {
        /**
         * @param {?} fn
         * @return {?}
         */
        set: function (fn) {
            if (typeof fn !== 'function') {
                throw new Error("compareWith must be a function, but received " + JSON.stringify(fn));
            }
            this._compareWith = fn;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} value
     * @return {?}
     */
    SelectMultipleControlValueAccessor.prototype.writeValue = function (value) {
        var _this = this;
        this.value = value;
        var /** @type {?} */ optionSelectedStateSetter;
        if (Array.isArray(value)) {
            // convert values to ids
            var /** @type {?} */ ids_1 = value.map(function (v) { return _this._getOptionId(v); });
            optionSelectedStateSetter = function (opt, o) { opt._setSelected(ids_1.indexOf(o.toString()) > -1); };
        }
        else {
            optionSelectedStateSetter = function (opt, o) { opt._setSelected(false); };
        }
        this._optionMap.forEach(optionSelectedStateSetter);
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    SelectMultipleControlValueAccessor.prototype.registerOnChange = function (fn) {
        var _this = this;
        this.onChange = function (_) {
            var /** @type {?} */ selected = [];
            if (_.hasOwnProperty('selectedOptions')) {
                var /** @type {?} */ options = _.selectedOptions;
                for (var /** @type {?} */ i = 0; i < options.length; i++) {
                    var /** @type {?} */ opt = options.item(i);
                    var /** @type {?} */ val = _this._getOptionValue(opt.value);
                    selected.push(val);
                }
            }
            else {
                var /** @type {?} */ options = (_.options);
                for (var /** @type {?} */ i = 0; i < options.length; i++) {
                    var /** @type {?} */ opt = options.item(i);
                    if (opt.selected) {
                        var /** @type {?} */ val = _this._getOptionValue(opt.value);
                        selected.push(val);
                    }
                }
            }
            _this.value = selected;
            fn(selected);
        };
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    SelectMultipleControlValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    SelectMultipleControlValueAccessor.prototype.setDisabledState = function (isDisabled) {
        this._renderer.setElementProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
    };
    /**
     * \@internal
     * @param {?} value
     * @return {?}
     */
    SelectMultipleControlValueAccessor.prototype._registerOption = function (value) {
        var /** @type {?} */ id = (this._idCounter++).toString();
        this._optionMap.set(id, value);
        return id;
    };
    /**
     * \@internal
     * @param {?} value
     * @return {?}
     */
    SelectMultipleControlValueAccessor.prototype._getOptionId = function (value) {
        for (var _i = 0, _a = Array.from(this._optionMap.keys()); _i < _a.length; _i++) {
            var id = _a[_i];
            if (this._compareWith(/** @type {?} */ ((this._optionMap.get(id)))._value, value))
                return id;
        }
        return null;
    };
    /**
     * \@internal
     * @param {?} valueString
     * @return {?}
     */
    SelectMultipleControlValueAccessor.prototype._getOptionValue = function (valueString) {
        var /** @type {?} */ id = _extractId$1(valueString);
        return this._optionMap.has(id) ? ((this._optionMap.get(id)))._value : valueString;
    };
    return SelectMultipleControlValueAccessor;
}());
SelectMultipleControlValueAccessor.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                selector: 'select[multiple][formControlName],select[multiple][formControl],select[multiple][ngModel]',
                host: { '(change)': 'onChange($event.target)', '(blur)': 'onTouched()' },
                providers: [SELECT_MULTIPLE_VALUE_ACCESSOR]
            },] },
];
/**
 * @nocollapse
 */
SelectMultipleControlValueAccessor.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
]; };
SelectMultipleControlValueAccessor.propDecorators = {
    'compareWith': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
};
/**
 * Marks `<option>` as dynamic, so Angular can be notified when options change.
 *
 * ### Example
 *
 * ```
 * <select multiple name="city" ngModel>
 *   <option *ngFor="let c of cities" [value]="c"></option>
 * </select>
 * ```
 */
var NgSelectMultipleOption = (function () {
    /**
     * @param {?} _element
     * @param {?} _renderer
     * @param {?} _select
     */
    function NgSelectMultipleOption(_element, _renderer, _select) {
        this._element = _element;
        this._renderer = _renderer;
        this._select = _select;
        if (this._select) {
            this.id = this._select._registerOption(this);
        }
    }
    Object.defineProperty(NgSelectMultipleOption.prototype, "ngValue", {
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            if (this._select == null)
                return;
            this._value = value;
            this._setElementValue(_buildValueString$1(this.id, value));
            this._select.writeValue(this._select.value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgSelectMultipleOption.prototype, "value", {
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            if (this._select) {
                this._value = value;
                this._setElementValue(_buildValueString$1(this.id, value));
                this._select.writeValue(this._select.value);
            }
            else {
                this._setElementValue(value);
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * \@internal
     * @param {?} value
     * @return {?}
     */
    NgSelectMultipleOption.prototype._setElementValue = function (value) {
        this._renderer.setElementProperty(this._element.nativeElement, 'value', value);
    };
    /**
     * \@internal
     * @param {?} selected
     * @return {?}
     */
    NgSelectMultipleOption.prototype._setSelected = function (selected) {
        this._renderer.setElementProperty(this._element.nativeElement, 'selected', selected);
    };
    /**
     * @return {?}
     */
    NgSelectMultipleOption.prototype.ngOnDestroy = function () {
        if (this._select) {
            this._select._optionMap.delete(this.id);
            this._select.writeValue(this._select.value);
        }
    };
    return NgSelectMultipleOption;
}());
NgSelectMultipleOption.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{ selector: 'option' },] },
];
/**
 * @nocollapse
 */
NgSelectMultipleOption.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
    { type: SelectMultipleControlValueAccessor, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Host"] },] },
]; };
NgSelectMultipleOption.propDecorators = {
    'ngValue': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['ngValue',] },],
    'value': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['value',] },],
};
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @param {?} name
 * @param {?} parent
 * @return {?}
 */
function controlPath(name, parent) {
    return ((parent.path)).concat([name]);
}
/**
 * @param {?} control
 * @param {?} dir
 * @return {?}
 */
function setUpControl(control, dir) {
    if (!control)
        _throwError(dir, 'Cannot find control with');
    if (!dir.valueAccessor)
        _throwError(dir, 'No value accessor for form control with');
    control.validator = Validators.compose([/** @type {?} */ ((control.validator)), dir.validator]);
    control.asyncValidator = Validators.composeAsync([/** @type {?} */ ((control.asyncValidator)), dir.asyncValidator]); /** @type {?} */
    ((dir.valueAccessor)).writeValue(control.value); /** @type {?} */
    ((
    // view -> model
    dir.valueAccessor)).registerOnChange(function (newValue) {
        dir.viewToModelUpdate(newValue);
        control.markAsDirty();
        control.setValue(newValue, { emitModelToViewChange: false });
    }); /** @type {?} */
    ((
    // touched
    dir.valueAccessor)).registerOnTouched(function () { return control.markAsTouched(); });
    control.registerOnChange(function (newValue, emitModelEvent) {
        ((
        // control -> view
        dir.valueAccessor)).writeValue(newValue);
        // control -> ngModel
        if (emitModelEvent)
            dir.viewToModelUpdate(newValue);
    });
    if (((dir.valueAccessor)).setDisabledState) {
        control.registerOnDisabledChange(function (isDisabled) { /** @type {?} */ ((((dir.valueAccessor)).setDisabledState))(isDisabled); });
    }
    // re-run validation when validator binding changes, e.g. minlength=3 -> minlength=4
    dir._rawValidators.forEach(function (validator) {
        if (((validator)).registerOnValidatorChange)
            ((((validator)).registerOnValidatorChange))(function () { return control.updateValueAndValidity(); });
    });
    dir._rawAsyncValidators.forEach(function (validator) {
        if (((validator)).registerOnValidatorChange)
            ((((validator)).registerOnValidatorChange))(function () { return control.updateValueAndValidity(); });
    });
}
/**
 * @param {?} control
 * @param {?} dir
 * @return {?}
 */
function cleanUpControl(control, dir) {
    ((dir.valueAccessor)).registerOnChange(function () { return _noControlError(dir); }); /** @type {?} */
    ((dir.valueAccessor)).registerOnTouched(function () { return _noControlError(dir); });
    dir._rawValidators.forEach(function (validator) {
        if (validator.registerOnValidatorChange) {
            validator.registerOnValidatorChange(null);
        }
    });
    dir._rawAsyncValidators.forEach(function (validator) {
        if (validator.registerOnValidatorChange) {
            validator.registerOnValidatorChange(null);
        }
    });
    if (control)
        control._clearChangeFns();
}
/**
 * @param {?} control
 * @param {?} dir
 * @return {?}
 */
function setUpFormContainer(control, dir) {
    if (control == null)
        _throwError(dir, 'Cannot find control with');
    control.validator = Validators.compose([control.validator, dir.validator]);
    control.asyncValidator = Validators.composeAsync([control.asyncValidator, dir.asyncValidator]);
}
/**
 * @param {?} dir
 * @return {?}
 */
function _noControlError(dir) {
    return _throwError(dir, 'There is no FormControl instance attached to form control element with');
}
/**
 * @param {?} dir
 * @param {?} message
 * @return {?}
 */
function _throwError(dir, message) {
    var /** @type {?} */ messageEnd;
    if (((dir.path)).length > 1) {
        messageEnd = "path: '" + ((dir.path)).join(' -> ') + "'";
    }
    else if (((dir.path))[0]) {
        messageEnd = "name: '" + dir.path + "'";
    }
    else {
        messageEnd = 'unspecified name attribute';
    }
    throw new Error(message + " " + messageEnd);
}
/**
 * @param {?} validators
 * @return {?}
 */
function composeValidators(validators) {
    return validators != null ? Validators.compose(validators.map(normalizeValidator)) : null;
}
/**
 * @param {?} validators
 * @return {?}
 */
function composeAsyncValidators(validators) {
    return validators != null ? Validators.composeAsync(validators.map(normalizeAsyncValidator)) :
        null;
}
/**
 * @param {?} changes
 * @param {?} viewModel
 * @return {?}
 */
function isPropertyUpdated(changes, viewModel) {
    if (!changes.hasOwnProperty('model'))
        return false;
    var /** @type {?} */ change = changes['model'];
    if (change.isFirstChange())
        return true;
    return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵlooseIdentical"])(viewModel, change.currentValue);
}
var BUILTIN_ACCESSORS = [
    CheckboxControlValueAccessor,
    RangeValueAccessor,
    NumberValueAccessor,
    SelectControlValueAccessor,
    SelectMultipleControlValueAccessor,
    RadioControlValueAccessor,
];
/**
 * @param {?} valueAccessor
 * @return {?}
 */
function isBuiltInAccessor(valueAccessor) {
    return BUILTIN_ACCESSORS.some(function (a) { return valueAccessor.constructor === a; });
}
/**
 * @param {?} dir
 * @param {?} valueAccessors
 * @return {?}
 */
function selectValueAccessor(dir, valueAccessors) {
    if (!valueAccessors)
        return null;
    var /** @type {?} */ defaultAccessor = undefined;
    var /** @type {?} */ builtinAccessor = undefined;
    var /** @type {?} */ customAccessor = undefined;
    valueAccessors.forEach(function (v) {
        if (v.constructor === DefaultValueAccessor) {
            defaultAccessor = v;
        }
        else if (isBuiltInAccessor(v)) {
            if (builtinAccessor)
                _throwError(dir, 'More than one built-in value accessor matches form control with');
            builtinAccessor = v;
        }
        else {
            if (customAccessor)
                _throwError(dir, 'More than one custom value accessor matches form control with');
            customAccessor = v;
        }
    });
    if (customAccessor)
        return customAccessor;
    if (builtinAccessor)
        return builtinAccessor;
    if (defaultAccessor)
        return defaultAccessor;
    _throwError(dir, 'No valid value accessor for form control with');
    return null;
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * This is a base class for code shared between {\@link NgModelGroup} and {\@link FormGroupName}.
 *
 * \@stable
 */
var AbstractFormGroupDirective = (function (_super) {
    __extends(AbstractFormGroupDirective, _super);
    function AbstractFormGroupDirective() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @return {?}
     */
    AbstractFormGroupDirective.prototype.ngOnInit = function () {
        this._checkParentType(); /** @type {?} */
        ((this.formDirective)).addFormGroup(this);
    };
    /**
     * @return {?}
     */
    AbstractFormGroupDirective.prototype.ngOnDestroy = function () {
        if (this.formDirective) {
            this.formDirective.removeFormGroup(this);
        }
    };
    Object.defineProperty(AbstractFormGroupDirective.prototype, "control", {
        /**
         * Get the {\@link FormGroup} backing this binding.
         * @return {?}
         */
        get: function () { return ((this.formDirective)).getFormGroup(this); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractFormGroupDirective.prototype, "path", {
        /**
         * Get the path to this control group.
         * @return {?}
         */
        get: function () { return controlPath(this.name, this._parent); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractFormGroupDirective.prototype, "formDirective", {
        /**
         * Get the {\@link Form} to which this group belongs.
         * @return {?}
         */
        get: function () { return this._parent ? this._parent.formDirective : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractFormGroupDirective.prototype, "validator", {
        /**
         * @return {?}
         */
        get: function () { return composeValidators(this._validators); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractFormGroupDirective.prototype, "asyncValidator", {
        /**
         * @return {?}
         */
        get: function () {
            return composeAsyncValidators(this._asyncValidators);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * \@internal
     * @return {?}
     */
    AbstractFormGroupDirective.prototype._checkParentType = function () { };
    return AbstractFormGroupDirective;
}(ControlContainer));
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var AbstractControlStatus = (function () {
    /**
     * @param {?} cd
     */
    function AbstractControlStatus(cd) {
        this._cd = cd;
    }
    Object.defineProperty(AbstractControlStatus.prototype, "ngClassUntouched", {
        /**
         * @return {?}
         */
        get: function () { return this._cd.control ? this._cd.control.untouched : false; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlStatus.prototype, "ngClassTouched", {
        /**
         * @return {?}
         */
        get: function () { return this._cd.control ? this._cd.control.touched : false; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlStatus.prototype, "ngClassPristine", {
        /**
         * @return {?}
         */
        get: function () { return this._cd.control ? this._cd.control.pristine : false; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlStatus.prototype, "ngClassDirty", {
        /**
         * @return {?}
         */
        get: function () { return this._cd.control ? this._cd.control.dirty : false; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlStatus.prototype, "ngClassValid", {
        /**
         * @return {?}
         */
        get: function () { return this._cd.control ? this._cd.control.valid : false; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlStatus.prototype, "ngClassInvalid", {
        /**
         * @return {?}
         */
        get: function () { return this._cd.control ? this._cd.control.invalid : false; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControlStatus.prototype, "ngClassPending", {
        /**
         * @return {?}
         */
        get: function () { return this._cd.control ? this._cd.control.pending : false; },
        enumerable: true,
        configurable: true
    });
    return AbstractControlStatus;
}());
var ngControlStatusHost = {
    '[class.ng-untouched]': 'ngClassUntouched',
    '[class.ng-touched]': 'ngClassTouched',
    '[class.ng-pristine]': 'ngClassPristine',
    '[class.ng-dirty]': 'ngClassDirty',
    '[class.ng-valid]': 'ngClassValid',
    '[class.ng-invalid]': 'ngClassInvalid',
    '[class.ng-pending]': 'ngClassPending',
};
/**
 * Directive automatically applied to Angular form controls that sets CSS classes
 * based on control status (valid/invalid/dirty/etc).
 *
 * \@stable
 */
var NgControlStatus = (function (_super) {
    __extends(NgControlStatus, _super);
    /**
     * @param {?} cd
     */
    function NgControlStatus(cd) {
        return _super.call(this, cd) || this;
    }
    return NgControlStatus;
}(AbstractControlStatus));
NgControlStatus.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{ selector: '[formControlName],[ngModel],[formControl]', host: ngControlStatusHost },] },
];
/**
 * @nocollapse
 */
NgControlStatus.ctorParameters = function () { return [
    { type: NgControl, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] },] },
]; };
/**
 * Directive automatically applied to Angular form groups that sets CSS classes
 * based on control status (valid/invalid/dirty/etc).
 *
 * \@stable
 */
var NgControlStatusGroup = (function (_super) {
    __extends(NgControlStatusGroup, _super);
    /**
     * @param {?} cd
     */
    function NgControlStatusGroup(cd) {
        return _super.call(this, cd) || this;
    }
    return NgControlStatusGroup;
}(AbstractControlStatus));
NgControlStatusGroup.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                selector: '[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]',
                host: ngControlStatusHost
            },] },
];
/**
 * @nocollapse
 */
NgControlStatusGroup.ctorParameters = function () { return [
    { type: ControlContainer, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] },] },
]; };
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Indicates that a FormControl is valid, i.e. that no errors exist in the input value.
 */
var VALID = 'VALID';
/**
 * Indicates that a FormControl is invalid, i.e. that an error exists in the input value.
 */
var INVALID = 'INVALID';
/**
 * Indicates that a FormControl is pending, i.e. that async validation is occurring and
 * errors are not yet available for the input value.
 */
var PENDING = 'PENDING';
/**
 * Indicates that a FormControl is disabled, i.e. that the control is exempt from ancestor
 * calculations of validity or value.
 */
var DISABLED = 'DISABLED';
/**
 * @param {?} control
 * @param {?} path
 * @param {?} delimiter
 * @return {?}
 */
function _find(control, path, delimiter) {
    if (path == null)
        return null;
    if (!(path instanceof Array)) {
        path = ((path)).split(delimiter);
    }
    if (path instanceof Array && (path.length === 0))
        return null;
    return ((path)).reduce(function (v, name) {
        if (v instanceof FormGroup) {
            return v.controls[name] || null;
        }
        if (v instanceof FormArray) {
            return v.at(/** @type {?} */ (name)) || null;
        }
        return null;
    }, control);
}
/**
 * @param {?=} validator
 * @return {?}
 */
function coerceToValidator(validator) {
    return Array.isArray(validator) ? composeValidators(validator) : validator || null;
}
/**
 * @param {?=} asyncValidator
 * @return {?}
 */
function coerceToAsyncValidator(asyncValidator) {
    return Array.isArray(asyncValidator) ? composeAsyncValidators(asyncValidator) :
        asyncValidator || null;
}
/**
 * \@whatItDoes This is the base class for {\@link FormControl}, {\@link FormGroup}, and
 * {\@link FormArray}.
 *
 * It provides some of the shared behavior that all controls and groups of controls have, like
 * running validators, calculating status, and resetting state. It also defines the properties
 * that are shared between all sub-classes, like `value`, `valid`, and `dirty`. It shouldn't be
 * instantiated directly.
 *
 * \@stable
 * @abstract
 */
var AbstractControl = (function () {
    /**
     * @param {?} validator
     * @param {?} asyncValidator
     */
    function AbstractControl(validator, asyncValidator) {
        this.validator = validator;
        this.asyncValidator = asyncValidator;
        /**
         * \@internal
         */
        this._onCollectionChange = function () { };
        this._pristine = true;
        this._touched = false;
        /**
         * \@internal
         */
        this._onDisabledChange = [];
    }
    Object.defineProperty(AbstractControl.prototype, "value", {
        /**
         * The value of the control.
         * @return {?}
         */
        get: function () { return this._value; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "parent", {
        /**
         * The parent control.
         * @return {?}
         */
        get: function () { return this._parent; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "status", {
        /**
         * The validation status of the control. There are four possible
         * validation statuses:
         *
         * * **VALID**:  control has passed all validation checks
         * * **INVALID**: control has failed at least one validation check
         * * **PENDING**: control is in the midst of conducting a validation check
         * * **DISABLED**: control is exempt from validation checks
         *
         * These statuses are mutually exclusive, so a control cannot be
         * both valid AND invalid or invalid AND disabled.
         * @return {?}
         */
        get: function () { return this._status; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "valid", {
        /**
         * A control is `valid` when its `status === VALID`.
         *
         * In order to have this status, the control must have passed all its
         * validation checks.
         * @return {?}
         */
        get: function () { return this._status === VALID; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "invalid", {
        /**
         * A control is `invalid` when its `status === INVALID`.
         *
         * In order to have this status, the control must have failed
         * at least one of its validation checks.
         * @return {?}
         */
        get: function () { return this._status === INVALID; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "pending", {
        /**
         * A control is `pending` when its `status === PENDING`.
         *
         * In order to have this status, the control must be in the
         * middle of conducting a validation check.
         * @return {?}
         */
        get: function () { return this._status == PENDING; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "disabled", {
        /**
         * A control is `disabled` when its `status === DISABLED`.
         *
         * Disabled controls are exempt from validation checks and
         * are not included in the aggregate value of their ancestor
         * controls.
         * @return {?}
         */
        get: function () { return this._status === DISABLED; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "enabled", {
        /**
         * A control is `enabled` as long as its `status !== DISABLED`.
         *
         * In other words, it has a status of `VALID`, `INVALID`, or
         * `PENDING`.
         * @return {?}
         */
        get: function () { return this._status !== DISABLED; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "errors", {
        /**
         * Returns any errors generated by failing validation. If there
         * are no errors, it will return null.
         * @return {?}
         */
        get: function () { return this._errors; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "pristine", {
        /**
         * A control is `pristine` if the user has not yet changed
         * the value in the UI.
         *
         * Note that programmatic changes to a control's value will
         * *not* mark it dirty.
         * @return {?}
         */
        get: function () { return this._pristine; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "dirty", {
        /**
         * A control is `dirty` if the user has changed the value
         * in the UI.
         *
         * Note that programmatic changes to a control's value will
         * *not* mark it dirty.
         * @return {?}
         */
        get: function () { return !this.pristine; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "touched", {
        /**
         * A control is marked `touched` once the user has triggered
         * a `blur` event on it.
         * @return {?}
         */
        get: function () { return this._touched; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "untouched", {
        /**
         * A control is `untouched` if the user has not yet triggered
         * a `blur` event on it.
         * @return {?}
         */
        get: function () { return !this._touched; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "valueChanges", {
        /**
         * Emits an event every time the value of the control changes, in
         * the UI or programmatically.
         * @return {?}
         */
        get: function () { return this._valueChanges; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractControl.prototype, "statusChanges", {
        /**
         * Emits an event every time the validation status of the control
         * is re-calculated.
         * @return {?}
         */
        get: function () { return this._statusChanges; },
        enumerable: true,
        configurable: true
    });
    /**
     * Sets the synchronous validators that are active on this control.  Calling
     * this will overwrite any existing sync validators.
     * @param {?} newValidator
     * @return {?}
     */
    AbstractControl.prototype.setValidators = function (newValidator) {
        this.validator = coerceToValidator(newValidator);
    };
    /**
     * Sets the async validators that are active on this control. Calling this
     * will overwrite any existing async validators.
     * @param {?} newValidator
     * @return {?}
     */
    AbstractControl.prototype.setAsyncValidators = function (newValidator) {
        this.asyncValidator = coerceToAsyncValidator(newValidator);
    };
    /**
     * Empties out the sync validator list.
     * @return {?}
     */
    AbstractControl.prototype.clearValidators = function () { this.validator = null; };
    /**
     * Empties out the async validator list.
     * @return {?}
     */
    AbstractControl.prototype.clearAsyncValidators = function () { this.asyncValidator = null; };
    /**
     * Marks the control as `touched`.
     *
     * This will also mark all direct ancestors as `touched` to maintain
     * the model.
     * @param {?=} __0
     * @return {?}
     */
    AbstractControl.prototype.markAsTouched = function (_a) {
        var onlySelf = (_a === void 0 ? {} : _a).onlySelf;
        this._touched = true;
        if (this._parent && !onlySelf) {
            this._parent.markAsTouched({ onlySelf: onlySelf });
        }
    };
    /**
     * Marks the control as `untouched`.
     *
     * If the control has any children, it will also mark all children as `untouched`
     * to maintain the model, and re-calculate the `touched` status of all parent
     * controls.
     * @param {?=} __0
     * @return {?}
     */
    AbstractControl.prototype.markAsUntouched = function (_a) {
        var onlySelf = (_a === void 0 ? {} : _a).onlySelf;
        this._touched = false;
        this._forEachChild(function (control) { control.markAsUntouched({ onlySelf: true }); });
        if (this._parent && !onlySelf) {
            this._parent._updateTouched({ onlySelf: onlySelf });
        }
    };
    /**
     * Marks the control as `dirty`.
     *
     * This will also mark all direct ancestors as `dirty` to maintain
     * the model.
     * @param {?=} __0
     * @return {?}
     */
    AbstractControl.prototype.markAsDirty = function (_a) {
        var onlySelf = (_a === void 0 ? {} : _a).onlySelf;
        this._pristine = false;
        if (this._parent && !onlySelf) {
            this._parent.markAsDirty({ onlySelf: onlySelf });
        }
    };
    /**
     * Marks the control as `pristine`.
     *
     * If the control has any children, it will also mark all children as `pristine`
     * to maintain the model, and re-calculate the `pristine` status of all parent
     * controls.
     * @param {?=} __0
     * @return {?}
     */
    AbstractControl.prototype.markAsPristine = function (_a) {
        var onlySelf = (_a === void 0 ? {} : _a).onlySelf;
        this._pristine = true;
        this._forEachChild(function (control) { control.markAsPristine({ onlySelf: true }); });
        if (this._parent && !onlySelf) {
            this._parent._updatePristine({ onlySelf: onlySelf });
        }
    };
    /**
     * Marks the control as `pending`.
     * @param {?=} __0
     * @return {?}
     */
    AbstractControl.prototype.markAsPending = function (_a) {
        var onlySelf = (_a === void 0 ? {} : _a).onlySelf;
        this._status = PENDING;
        if (this._parent && !onlySelf) {
            this._parent.markAsPending({ onlySelf: onlySelf });
        }
    };
    /**
     * Disables the control. This means the control will be exempt from validation checks and
     * excluded from the aggregate value of any parent. Its status is `DISABLED`.
     *
     * If the control has children, all children will be disabled to maintain the model.
     * @param {?=} __0
     * @return {?}
     */
    AbstractControl.prototype.disable = function (_a) {
        var _b = _a === void 0 ? {} : _a, onlySelf = _b.onlySelf, emitEvent = _b.emitEvent;
        this._status = DISABLED;
        this._errors = null;
        this._forEachChild(function (control) { control.disable({ onlySelf: true }); });
        this._updateValue();
        if (emitEvent !== false) {
            this._valueChanges.emit(this._value);
            this._statusChanges.emit(this._status);
        }
        this._updateAncestors(!!onlySelf);
        this._onDisabledChange.forEach(function (changeFn) { return changeFn(true); });
    };
    /**
     * Enables the control. This means the control will be included in validation checks and
     * the aggregate value of its parent. Its status is re-calculated based on its value and
     * its validators.
     *
     * If the control has children, all children will be enabled.
     * @param {?=} __0
     * @return {?}
     */
    AbstractControl.prototype.enable = function (_a) {
        var _b = _a === void 0 ? {} : _a, onlySelf = _b.onlySelf, emitEvent = _b.emitEvent;
        this._status = VALID;
        this._forEachChild(function (control) { control.enable({ onlySelf: true }); });
        this.updateValueAndValidity({ onlySelf: true, emitEvent: emitEvent });
        this._updateAncestors(!!onlySelf);
        this._onDisabledChange.forEach(function (changeFn) { return changeFn(false); });
    };
    /**
     * @param {?} onlySelf
     * @return {?}
     */
    AbstractControl.prototype._updateAncestors = function (onlySelf) {
        if (this._parent && !onlySelf) {
            this._parent.updateValueAndValidity();
            this._parent._updatePristine();
            this._parent._updateTouched();
        }
    };
    /**
     * @param {?} parent
     * @return {?}
     */
    AbstractControl.prototype.setParent = function (parent) { this._parent = parent; };
    /**
     * Sets the value of the control. Abstract method (implemented in sub-classes).
     * @abstract
     * @param {?} value
     * @param {?=} options
     * @return {?}
     */
    AbstractControl.prototype.setValue = function (value, options) { };
    /**
     * Patches the value of the control. Abstract method (implemented in sub-classes).
     * @abstract
     * @param {?} value
     * @param {?=} options
     * @return {?}
     */
    AbstractControl.prototype.patchValue = function (value, options) { };
    /**
     * Resets the control. Abstract method (implemented in sub-classes).
     * @abstract
     * @param {?=} value
     * @param {?=} options
     * @return {?}
     */
    AbstractControl.prototype.reset = function (value, options) { };
    /**
     * Re-calculates the value and validation status of the control.
     *
     * By default, it will also update the value and validity of its ancestors.
     * @param {?=} __0
     * @return {?}
     */
    AbstractControl.prototype.updateValueAndValidity = function (_a) {
        var _b = _a === void 0 ? {} : _a, onlySelf = _b.onlySelf, emitEvent = _b.emitEvent;
        this._setInitialStatus();
        this._updateValue();
        if (this.enabled) {
            this._cancelExistingSubscription();
            this._errors = this._runValidator();
            this._status = this._calculateStatus();
            if (this._status === VALID || this._status === PENDING) {
                this._runAsyncValidator(emitEvent);
            }
        }
        if (emitEvent !== false) {
            this._valueChanges.emit(this._value);
            this._statusChanges.emit(this._status);
        }
        if (this._parent && !onlySelf) {
            this._parent.updateValueAndValidity({ onlySelf: onlySelf, emitEvent: emitEvent });
        }
    };
    /**
     * \@internal
     * @param {?=} __0
     * @return {?}
     */
    AbstractControl.prototype._updateTreeValidity = function (_a) {
        var emitEvent = (_a === void 0 ? { emitEvent: true } : _a).emitEvent;
        this._forEachChild(function (ctrl) { return ctrl._updateTreeValidity({ emitEvent: emitEvent }); });
        this.updateValueAndValidity({ onlySelf: true, emitEvent: emitEvent });
    };
    /**
     * @return {?}
     */
    AbstractControl.prototype._setInitialStatus = function () { this._status = this._allControlsDisabled() ? DISABLED : VALID; };
    /**
     * @return {?}
     */
    AbstractControl.prototype._runValidator = function () {
        return this.validator ? this.validator(this) : null;
    };
    /**
     * @param {?=} emitEvent
     * @return {?}
     */
    AbstractControl.prototype._runAsyncValidator = function (emitEvent) {
        var _this = this;
        if (this.asyncValidator) {
            this._status = PENDING;
            var /** @type {?} */ obs = toObservable(this.asyncValidator(this));
            this._asyncValidationSubscription =
                obs.subscribe(function (errors) { return _this.setErrors(errors, { emitEvent: emitEvent }); });
        }
    };
    /**
     * @return {?}
     */
    AbstractControl.prototype._cancelExistingSubscription = function () {
        if (this._asyncValidationSubscription) {
            this._asyncValidationSubscription.unsubscribe();
        }
    };
    /**
     * Sets errors on a form control.
     *
     * This is used when validations are run manually by the user, rather than automatically.
     *
     * Calling `setErrors` will also update the validity of the parent control.
     *
     * ### Example
     *
     * ```
     * const login = new FormControl("someLogin");
     * login.setErrors({
     *   "notUnique": true
     * });
     *
     * expect(login.valid).toEqual(false);
     * expect(login.errors).toEqual({"notUnique": true});
     *
     * login.setValue("someOtherLogin");
     *
     * expect(login.valid).toEqual(true);
     * ```
     * @param {?} errors
     * @param {?=} __1
     * @return {?}
     */
    AbstractControl.prototype.setErrors = function (errors, _a) {
        var emitEvent = (_a === void 0 ? {} : _a).emitEvent;
        this._errors = errors;
        this._updateControlsErrors(emitEvent !== false);
    };
    /**
     * Retrieves a child control given the control's name or path.
     *
     * Paths can be passed in as an array or a string delimited by a dot.
     *
     * To get a control nested within a `person` sub-group:
     *
     * * `this.form.get('person.name');`
     *
     * -OR-
     *
     * * `this.form.get(['person', 'name']);`
     * @param {?} path
     * @return {?}
     */
    AbstractControl.prototype.get = function (path) { return _find(this, path, '.'); };
    /**
     * Returns true if the control with the given path has the error specified. Otherwise
     * returns null or undefined.
     *
     * If no path is given, it checks for the error on the present control.
     * @param {?} errorCode
     * @param {?=} path
     * @return {?}
     */
    AbstractControl.prototype.getError = function (errorCode, path) {
        var /** @type {?} */ control = path ? this.get(path) : this;
        return control && control._errors ? control._errors[errorCode] : null;
    };
    /**
     * Returns true if the control with the given path has the error specified. Otherwise
     * returns false.
     *
     * If no path is given, it checks for the error on the present control.
     * @param {?} errorCode
     * @param {?=} path
     * @return {?}
     */
    AbstractControl.prototype.hasError = function (errorCode, path) { return !!this.getError(errorCode, path); };
    Object.defineProperty(AbstractControl.prototype, "root", {
        /**
         * Retrieves the top-level ancestor of this control.
         * @return {?}
         */
        get: function () {
            var /** @type {?} */ x = this;
            while (x._parent) {
                x = x._parent;
            }
            return x;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * \@internal
     * @param {?} emitEvent
     * @return {?}
     */
    AbstractControl.prototype._updateControlsErrors = function (emitEvent) {
        this._status = this._calculateStatus();
        if (emitEvent) {
            this._statusChanges.emit(this._status);
        }
        if (this._parent) {
            this._parent._updateControlsErrors(emitEvent);
        }
    };
    /**
     * \@internal
     * @return {?}
     */
    AbstractControl.prototype._initObservables = function () {
        this._valueChanges = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this._statusChanges = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
    };
    /**
     * @return {?}
     */
    AbstractControl.prototype._calculateStatus = function () {
        if (this._allControlsDisabled())
            return DISABLED;
        if (this._errors)
            return INVALID;
        if (this._anyControlsHaveStatus(PENDING))
            return PENDING;
        if (this._anyControlsHaveStatus(INVALID))
            return INVALID;
        return VALID;
    };
    /**
     * \@internal
     * @abstract
     * @return {?}
     */
    AbstractControl.prototype._updateValue = function () { };
    /**
     * \@internal
     * @abstract
     * @param {?} cb
     * @return {?}
     */
    AbstractControl.prototype._forEachChild = function (cb) { };
    /**
     * \@internal
     * @abstract
     * @param {?} condition
     * @return {?}
     */
    AbstractControl.prototype._anyControls = function (condition) { };
    /**
     * \@internal
     * @abstract
     * @return {?}
     */
    AbstractControl.prototype._allControlsDisabled = function () { };
    /**
     * \@internal
     * @param {?} status
     * @return {?}
     */
    AbstractControl.prototype._anyControlsHaveStatus = function (status) {
        return this._anyControls(function (control) { return control.status === status; });
    };
    /**
     * \@internal
     * @return {?}
     */
    AbstractControl.prototype._anyControlsDirty = function () {
        return this._anyControls(function (control) { return control.dirty; });
    };
    /**
     * \@internal
     * @return {?}
     */
    AbstractControl.prototype._anyControlsTouched = function () {
        return this._anyControls(function (control) { return control.touched; });
    };
    /**
     * \@internal
     * @param {?=} __0
     * @return {?}
     */
    AbstractControl.prototype._updatePristine = function (_a) {
        var onlySelf = (_a === void 0 ? {} : _a).onlySelf;
        this._pristine = !this._anyControlsDirty();
        if (this._parent && !onlySelf) {
            this._parent._updatePristine({ onlySelf: onlySelf });
        }
    };
    /**
     * \@internal
     * @param {?=} __0
     * @return {?}
     */
    AbstractControl.prototype._updateTouched = function (_a) {
        var onlySelf = (_a === void 0 ? {} : _a).onlySelf;
        this._touched = this._anyControlsTouched();
        if (this._parent && !onlySelf) {
            this._parent._updateTouched({ onlySelf: onlySelf });
        }
    };
    /**
     * \@internal
     * @param {?} formState
     * @return {?}
     */
    AbstractControl.prototype._isBoxedValue = function (formState) {
        return typeof formState === 'object' && formState !== null &&
            Object.keys(formState).length === 2 && 'value' in formState && 'disabled' in formState;
    };
    /**
     * \@internal
     * @param {?} fn
     * @return {?}
     */
    AbstractControl.prototype._registerOnCollectionChange = function (fn) { this._onCollectionChange = fn; };
    return AbstractControl;
}());
/**
 * \@whatItDoes Tracks the value and validation status of an individual form control.
 *
 * It is one of the three fundamental building blocks of Angular forms, along with
 * {\@link FormGroup} and {\@link FormArray}.
 *
 * \@howToUse
 *
 * When instantiating a {\@link FormControl}, you can pass in an initial value as the
 * first argument. Example:
 *
 * ```ts
 * const ctrl = new FormControl('some value');
 * console.log(ctrl.value);     // 'some value'
 * ```
 *
 * You can also initialize the control with a form state object on instantiation,
 * which includes both the value and whether or not the control is disabled.
 * You can't use the value key without the disabled key; both are required
 * to use this way of initialization.
 *
 * ```ts
 * const ctrl = new FormControl({value: 'n/a', disabled: true});
 * console.log(ctrl.value);     // 'n/a'
 * console.log(ctrl.status);   // 'DISABLED'
 * ```
 *
 * To include a sync validator (or an array of sync validators) with the control,
 * pass it in as the second argument. Async validators are also supported, but
 * have to be passed in separately as the third arg.
 *
 * ```ts
 * const ctrl = new FormControl('', Validators.required);
 * console.log(ctrl.value);     // ''
 * console.log(ctrl.status);   // 'INVALID'
 * ```
 *
 * See its superclass, {\@link AbstractControl}, for more properties and methods.
 *
 * * **npm package**: `\@angular/forms`
 *
 * \@stable
 */
var FormControl = (function (_super) {
    __extends(FormControl, _super);
    /**
     * @param {?=} formState
     * @param {?=} validator
     * @param {?=} asyncValidator
     */
    function FormControl(formState, validator, asyncValidator) {
        if (formState === void 0) { formState = null; }
        var _this = _super.call(this, coerceToValidator(validator), coerceToAsyncValidator(asyncValidator)) || this;
        /**
         * \@internal
         */
        _this._onChange = [];
        _this._applyFormState(formState);
        _this.updateValueAndValidity({ onlySelf: true, emitEvent: false });
        _this._initObservables();
        return _this;
    }
    /**
     * Set the value of the form control to `value`.
     *
     * If `onlySelf` is `true`, this change will only affect the validation of this `FormControl`
     * and not its parent component. This defaults to false.
     *
     * If `emitEvent` is `true`, this
     * change will cause a `valueChanges` event on the `FormControl` to be emitted. This defaults
     * to true (as it falls through to `updateValueAndValidity`).
     *
     * If `emitModelToViewChange` is `true`, the view will be notified about the new value
     * via an `onChange` event. This is the default behavior if `emitModelToViewChange` is not
     * specified.
     *
     * If `emitViewToModelChange` is `true`, an ngModelChange event will be fired to update the
     * model.  This is the default behavior if `emitViewToModelChange` is not specified.
     * @param {?} value
     * @param {?=} __1
     * @return {?}
     */
    FormControl.prototype.setValue = function (value, _a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, onlySelf = _b.onlySelf, emitEvent = _b.emitEvent, emitModelToViewChange = _b.emitModelToViewChange, emitViewToModelChange = _b.emitViewToModelChange;
        this._value = value;
        if (this._onChange.length && emitModelToViewChange !== false) {
            this._onChange.forEach(function (changeFn) { return changeFn(_this._value, emitViewToModelChange !== false); });
        }
        this.updateValueAndValidity({ onlySelf: onlySelf, emitEvent: emitEvent });
    };
    /**
     * Patches the value of a control.
     *
     * This function is functionally the same as {\@link FormControl.setValue} at this level.
     * It exists for symmetry with {\@link FormGroup.patchValue} on `FormGroups` and `FormArrays`,
     * where it does behave differently.
     * @param {?} value
     * @param {?=} options
     * @return {?}
     */
    FormControl.prototype.patchValue = function (value, options) {
        if (options === void 0) { options = {}; }
        this.setValue(value, options);
    };
    /**
     * Resets the form control. This means by default:
     *
     * * it is marked as `pristine`
     * * it is marked as `untouched`
     * * value is set to null
     *
     * You can also reset to a specific form state by passing through a standalone
     * value or a form state object that contains both a value and a disabled state
     * (these are the only two properties that cannot be calculated).
     *
     * Ex:
     *
     * ```ts
     * this.control.reset('Nancy');
     *
     * console.log(this.control.value);  // 'Nancy'
     * ```
     *
     * OR
     *
     * ```
     * this.control.reset({value: 'Nancy', disabled: true});
     *
     * console.log(this.control.value);  // 'Nancy'
     * console.log(this.control.status);  // 'DISABLED'
     * ```
     * @param {?=} formState
     * @param {?=} __1
     * @return {?}
     */
    FormControl.prototype.reset = function (formState, _a) {
        if (formState === void 0) { formState = null; }
        var _b = _a === void 0 ? {} : _a, onlySelf = _b.onlySelf, emitEvent = _b.emitEvent;
        this._applyFormState(formState);
        this.markAsPristine({ onlySelf: onlySelf });
        this.markAsUntouched({ onlySelf: onlySelf });
        this.setValue(this._value, { onlySelf: onlySelf, emitEvent: emitEvent });
    };
    /**
     * \@internal
     * @return {?}
     */
    FormControl.prototype._updateValue = function () { };
    /**
     * \@internal
     * @param {?} condition
     * @return {?}
     */
    FormControl.prototype._anyControls = function (condition) { return false; };
    /**
     * \@internal
     * @return {?}
     */
    FormControl.prototype._allControlsDisabled = function () { return this.disabled; };
    /**
     * Register a listener for change events.
     * @param {?} fn
     * @return {?}
     */
    FormControl.prototype.registerOnChange = function (fn) { this._onChange.push(fn); };
    /**
     * \@internal
     * @return {?}
     */
    FormControl.prototype._clearChangeFns = function () {
        this._onChange = [];
        this._onDisabledChange = [];
        this._onCollectionChange = function () { };
    };
    /**
     * Register a listener for disabled events.
     * @param {?} fn
     * @return {?}
     */
    FormControl.prototype.registerOnDisabledChange = function (fn) {
        this._onDisabledChange.push(fn);
    };
    /**
     * \@internal
     * @param {?} cb
     * @return {?}
     */
    FormControl.prototype._forEachChild = function (cb) { };
    /**
     * @param {?} formState
     * @return {?}
     */
    FormControl.prototype._applyFormState = function (formState) {
        if (this._isBoxedValue(formState)) {
            this._value = formState.value;
            formState.disabled ? this.disable({ onlySelf: true, emitEvent: false }) :
                this.enable({ onlySelf: true, emitEvent: false });
        }
        else {
            this._value = formState;
        }
    };
    return FormControl;
}(AbstractControl));
/**
 * \@whatItDoes Tracks the value and validity state of a group of {\@link FormControl}
 * instances.
 *
 * A `FormGroup` aggregates the values of each child {\@link FormControl} into one object,
 * with each control name as the key.  It calculates its status by reducing the statuses
 * of its children. For example, if one of the controls in a group is invalid, the entire
 * group becomes invalid.
 *
 * `FormGroup` is one of the three fundamental building blocks used to define forms in Angular,
 * along with {\@link FormControl} and {\@link FormArray}.
 *
 * \@howToUse
 *
 * When instantiating a {\@link FormGroup}, pass in a collection of child controls as the first
 * argument. The key for each child will be the name under which it is registered.
 *
 * ### Example
 *
 * ```
 * const form = new FormGroup({
 *   first: new FormControl('Nancy', Validators.minLength(2)),
 *   last: new FormControl('Drew'),
 * });
 *
 * console.log(form.value);   // {first: 'Nancy', last; 'Drew'}
 * console.log(form.status);  // 'VALID'
 * ```
 *
 * You can also include group-level validators as the second arg, or group-level async
 * validators as the third arg. These come in handy when you want to perform validation
 * that considers the value of more than one child control.
 *
 * ### Example
 *
 * ```
 * const form = new FormGroup({
 *   password: new FormControl('', Validators.minLength(2)),
 *   passwordConfirm: new FormControl('', Validators.minLength(2)),
 * }, passwordMatchValidator);
 *
 *
 * function passwordMatchValidator(g: FormGroup) {
 *    return g.get('password').value === g.get('passwordConfirm').value
 *       ? null : {'mismatch': true};
 * }
 * ```
 *
 * * **npm package**: `\@angular/forms`
 *
 * \@stable
 */
var FormGroup = (function (_super) {
    __extends(FormGroup, _super);
    /**
     * @param {?} controls
     * @param {?=} validator
     * @param {?=} asyncValidator
     */
    function FormGroup(controls, validator, asyncValidator) {
        var _this = _super.call(this, validator || null, asyncValidator || null) || this;
        _this.controls = controls;
        _this._initObservables();
        _this._setUpControls();
        _this.updateValueAndValidity({ onlySelf: true, emitEvent: false });
        return _this;
    }
    /**
     * Registers a control with the group's list of controls.
     *
     * This method does not update value or validity of the control, so for
     * most cases you'll want to use {\@link FormGroup.addControl} instead.
     * @param {?} name
     * @param {?} control
     * @return {?}
     */
    FormGroup.prototype.registerControl = function (name, control) {
        if (this.controls[name])
            return this.controls[name];
        this.controls[name] = control;
        control.setParent(this);
        control._registerOnCollectionChange(this._onCollectionChange);
        return control;
    };
    /**
     * Add a control to this group.
     * @param {?} name
     * @param {?} control
     * @return {?}
     */
    FormGroup.prototype.addControl = function (name, control) {
        this.registerControl(name, control);
        this.updateValueAndValidity();
        this._onCollectionChange();
    };
    /**
     * Remove a control from this group.
     * @param {?} name
     * @return {?}
     */
    FormGroup.prototype.removeControl = function (name) {
        if (this.controls[name])
            this.controls[name]._registerOnCollectionChange(function () { });
        delete (this.controls[name]);
        this.updateValueAndValidity();
        this._onCollectionChange();
    };
    /**
     * Replace an existing control.
     * @param {?} name
     * @param {?} control
     * @return {?}
     */
    FormGroup.prototype.setControl = function (name, control) {
        if (this.controls[name])
            this.controls[name]._registerOnCollectionChange(function () { });
        delete (this.controls[name]);
        if (control)
            this.registerControl(name, control);
        this.updateValueAndValidity();
        this._onCollectionChange();
    };
    /**
     * Check whether there is an enabled control with the given name in the group.
     *
     * It will return false for disabled controls. If you'd like to check for
     * existence in the group only, use {\@link AbstractControl.get} instead.
     * @param {?} controlName
     * @return {?}
     */
    FormGroup.prototype.contains = function (controlName) {
        return this.controls.hasOwnProperty(controlName) && this.controls[controlName].enabled;
    };
    /**
     *  Sets the value of the {\@link FormGroup}. It accepts an object that matches
     *  the structure of the group, with control names as keys.
     *
     * This method performs strict checks, so it will throw an error if you try
     * to set the value of a control that doesn't exist or if you exclude the
     * value of a control.
     *
     *  ### Example
     *
     *  ```
     *  const form = new FormGroup({
     *     first: new FormControl(),
     *     last: new FormControl()
     *  });
     *  console.log(form.value);   // {first: null, last: null}
     *
     *  form.setValue({first: 'Nancy', last: 'Drew'});
     *  console.log(form.value);   // {first: 'Nancy', last: 'Drew'}
     *
     *  ```
     * @param {?} value
     * @param {?=} __1
     * @return {?}
     */
    FormGroup.prototype.setValue = function (value, _a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, onlySelf = _b.onlySelf, emitEvent = _b.emitEvent;
        this._checkAllValuesPresent(value);
        Object.keys(value).forEach(function (name) {
            _this._throwIfControlMissing(name);
            _this.controls[name].setValue(value[name], { onlySelf: true, emitEvent: emitEvent });
        });
        this.updateValueAndValidity({ onlySelf: onlySelf, emitEvent: emitEvent });
    };
    /**
     *  Patches the value of the {\@link FormGroup}. It accepts an object with control
     *  names as keys, and will do its best to match the values to the correct controls
     *  in the group.
     *
     *  It accepts both super-sets and sub-sets of the group without throwing an error.
     *
     *  ### Example
     *
     *  ```
     *  const form = new FormGroup({
     *     first: new FormControl(),
     *     last: new FormControl()
     *  });
     *  console.log(form.value);   // {first: null, last: null}
     *
     *  form.patchValue({first: 'Nancy'});
     *  console.log(form.value);   // {first: 'Nancy', last: null}
     *
     *  ```
     * @param {?} value
     * @param {?=} __1
     * @return {?}
     */
    FormGroup.prototype.patchValue = function (value, _a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, onlySelf = _b.onlySelf, emitEvent = _b.emitEvent;
        Object.keys(value).forEach(function (name) {
            if (_this.controls[name]) {
                _this.controls[name].patchValue(value[name], { onlySelf: true, emitEvent: emitEvent });
            }
        });
        this.updateValueAndValidity({ onlySelf: onlySelf, emitEvent: emitEvent });
    };
    /**
     * Resets the {\@link FormGroup}. This means by default:
     *
     * * The group and all descendants are marked `pristine`
     * * The group and all descendants are marked `untouched`
     * * The value of all descendants will be null or null maps
     *
     * You can also reset to a specific form state by passing in a map of states
     * that matches the structure of your form, with control names as keys. The state
     * can be a standalone value or a form state object with both a value and a disabled
     * status.
     *
     * ### Example
     *
     * ```ts
     * this.form.reset({first: 'name', last: 'last name'});
     *
     * console.log(this.form.value);  // {first: 'name', last: 'last name'}
     * ```
     *
     * - OR -
     *
     * ```
     * this.form.reset({
     *   first: {value: 'name', disabled: true},
     *   last: 'last'
     * });
     *
     * console.log(this.form.value);  // {first: 'name', last: 'last name'}
     * console.log(this.form.get('first').status);  // 'DISABLED'
     * ```
     * @param {?=} value
     * @param {?=} __1
     * @return {?}
     */
    FormGroup.prototype.reset = function (value, _a) {
        if (value === void 0) { value = {}; }
        var _b = _a === void 0 ? {} : _a, onlySelf = _b.onlySelf, emitEvent = _b.emitEvent;
        this._forEachChild(function (control, name) {
            control.reset(value[name], { onlySelf: true, emitEvent: emitEvent });
        });
        this.updateValueAndValidity({ onlySelf: onlySelf, emitEvent: emitEvent });
        this._updatePristine({ onlySelf: onlySelf });
        this._updateTouched({ onlySelf: onlySelf });
    };
    /**
     * The aggregate value of the {\@link FormGroup}, including any disabled controls.
     *
     * If you'd like to include all values regardless of disabled status, use this method.
     * Otherwise, the `value` property is the best way to get the value of the group.
     * @return {?}
     */
    FormGroup.prototype.getRawValue = function () {
        return this._reduceChildren({}, function (acc, control, name) {
            acc[name] = control instanceof FormControl ? control.value : ((control)).getRawValue();
            return acc;
        });
    };
    /**
     * \@internal
     * @param {?} name
     * @return {?}
     */
    FormGroup.prototype._throwIfControlMissing = function (name) {
        if (!Object.keys(this.controls).length) {
            throw new Error("\n        There are no form controls registered with this group yet.  If you're using ngModel,\n        you may want to check next tick (e.g. use setTimeout).\n      ");
        }
        if (!this.controls[name]) {
            throw new Error("Cannot find form control with name: " + name + ".");
        }
    };
    /**
     * \@internal
     * @param {?} cb
     * @return {?}
     */
    FormGroup.prototype._forEachChild = function (cb) {
        var _this = this;
        Object.keys(this.controls).forEach(function (k) { return cb(_this.controls[k], k); });
    };
    /**
     * \@internal
     * @return {?}
     */
    FormGroup.prototype._setUpControls = function () {
        var _this = this;
        this._forEachChild(function (control) {
            control.setParent(_this);
            control._registerOnCollectionChange(_this._onCollectionChange);
        });
    };
    /**
     * \@internal
     * @return {?}
     */
    FormGroup.prototype._updateValue = function () { this._value = this._reduceValue(); };
    /**
     * \@internal
     * @param {?} condition
     * @return {?}
     */
    FormGroup.prototype._anyControls = function (condition) {
        var _this = this;
        var /** @type {?} */ res = false;
        this._forEachChild(function (control, name) {
            res = res || (_this.contains(name) && condition(control));
        });
        return res;
    };
    /**
     * \@internal
     * @return {?}
     */
    FormGroup.prototype._reduceValue = function () {
        var _this = this;
        return this._reduceChildren({}, function (acc, control, name) {
            if (control.enabled || _this.disabled) {
                acc[name] = control.value;
            }
            return acc;
        });
    };
    /**
     * \@internal
     * @param {?} initValue
     * @param {?} fn
     * @return {?}
     */
    FormGroup.prototype._reduceChildren = function (initValue, fn) {
        var /** @type {?} */ res = initValue;
        this._forEachChild(function (control, name) { res = fn(res, control, name); });
        return res;
    };
    /**
     * \@internal
     * @return {?}
     */
    FormGroup.prototype._allControlsDisabled = function () {
        for (var _i = 0, _a = Object.keys(this.controls); _i < _a.length; _i++) {
            var controlName = _a[_i];
            if (this.controls[controlName].enabled) {
                return false;
            }
        }
        return Object.keys(this.controls).length > 0 || this.disabled;
    };
    /**
     * \@internal
     * @param {?} value
     * @return {?}
     */
    FormGroup.prototype._checkAllValuesPresent = function (value) {
        this._forEachChild(function (control, name) {
            if (value[name] === undefined) {
                throw new Error("Must supply a value for form control with name: '" + name + "'.");
            }
        });
    };
    return FormGroup;
}(AbstractControl));
/**
 * \@whatItDoes Tracks the value and validity state of an array of {\@link FormControl},
 * {\@link FormGroup} or {\@link FormArray} instances.
 *
 * A `FormArray` aggregates the values of each child {\@link FormControl} into an array.
 * It calculates its status by reducing the statuses of its children. For example, if one of
 * the controls in a `FormArray` is invalid, the entire array becomes invalid.
 *
 * `FormArray` is one of the three fundamental building blocks used to define forms in Angular,
 * along with {\@link FormControl} and {\@link FormGroup}.
 *
 * \@howToUse
 *
 * When instantiating a {\@link FormArray}, pass in an array of child controls as the first
 * argument.
 *
 * ### Example
 *
 * ```
 * const arr = new FormArray([
 *   new FormControl('Nancy', Validators.minLength(2)),
 *   new FormControl('Drew'),
 * ]);
 *
 * console.log(arr.value);   // ['Nancy', 'Drew']
 * console.log(arr.status);  // 'VALID'
 * ```
 *
 * You can also include array-level validators as the second arg, or array-level async
 * validators as the third arg. These come in handy when you want to perform validation
 * that considers the value of more than one child control.
 *
 * ### Adding or removing controls
 *
 * To change the controls in the array, use the `push`, `insert`, or `removeAt` methods
 * in `FormArray` itself. These methods ensure the controls are properly tracked in the
 * form's hierarchy. Do not modify the array of `AbstractControl`s used to instantiate
 * the `FormArray` directly, as that will result in strange and unexpected behavior such
 * as broken change detection.
 *
 * * **npm package**: `\@angular/forms`
 *
 * \@stable
 */
var FormArray = (function (_super) {
    __extends(FormArray, _super);
    /**
     * @param {?} controls
     * @param {?=} validator
     * @param {?=} asyncValidator
     */
    function FormArray(controls, validator, asyncValidator) {
        var _this = _super.call(this, validator || null, asyncValidator || null) || this;
        _this.controls = controls;
        _this._initObservables();
        _this._setUpControls();
        _this.updateValueAndValidity({ onlySelf: true, emitEvent: false });
        return _this;
    }
    /**
     * Get the {\@link AbstractControl} at the given `index` in the array.
     * @param {?} index
     * @return {?}
     */
    FormArray.prototype.at = function (index) { return this.controls[index]; };
    /**
     * Insert a new {\@link AbstractControl} at the end of the array.
     * @param {?} control
     * @return {?}
     */
    FormArray.prototype.push = function (control) {
        this.controls.push(control);
        this._registerControl(control);
        this.updateValueAndValidity();
        this._onCollectionChange();
    };
    /**
     * Insert a new {\@link AbstractControl} at the given `index` in the array.
     * @param {?} index
     * @param {?} control
     * @return {?}
     */
    FormArray.prototype.insert = function (index, control) {
        this.controls.splice(index, 0, control);
        this._registerControl(control);
        this.updateValueAndValidity();
        this._onCollectionChange();
    };
    /**
     * Remove the control at the given `index` in the array.
     * @param {?} index
     * @return {?}
     */
    FormArray.prototype.removeAt = function (index) {
        if (this.controls[index])
            this.controls[index]._registerOnCollectionChange(function () { });
        this.controls.splice(index, 1);
        this.updateValueAndValidity();
        this._onCollectionChange();
    };
    /**
     * Replace an existing control.
     * @param {?} index
     * @param {?} control
     * @return {?}
     */
    FormArray.prototype.setControl = function (index, control) {
        if (this.controls[index])
            this.controls[index]._registerOnCollectionChange(function () { });
        this.controls.splice(index, 1);
        if (control) {
            this.controls.splice(index, 0, control);
            this._registerControl(control);
        }
        this.updateValueAndValidity();
        this._onCollectionChange();
    };
    Object.defineProperty(FormArray.prototype, "length", {
        /**
         * Length of the control array.
         * @return {?}
         */
        get: function () { return this.controls.length; },
        enumerable: true,
        configurable: true
    });
    /**
     *  Sets the value of the {\@link FormArray}. It accepts an array that matches
     *  the structure of the control.
     *
     * This method performs strict checks, so it will throw an error if you try
     * to set the value of a control that doesn't exist or if you exclude the
     * value of a control.
     *
     *  ### Example
     *
     *  ```
     *  const arr = new FormArray([
     *     new FormControl(),
     *     new FormControl()
     *  ]);
     *  console.log(arr.value);   // [null, null]
     *
     *  arr.setValue(['Nancy', 'Drew']);
     *  console.log(arr.value);   // ['Nancy', 'Drew']
     *  ```
     * @param {?} value
     * @param {?=} __1
     * @return {?}
     */
    FormArray.prototype.setValue = function (value, _a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, onlySelf = _b.onlySelf, emitEvent = _b.emitEvent;
        this._checkAllValuesPresent(value);
        value.forEach(function (newValue, index) {
            _this._throwIfControlMissing(index);
            _this.at(index).setValue(newValue, { onlySelf: true, emitEvent: emitEvent });
        });
        this.updateValueAndValidity({ onlySelf: onlySelf, emitEvent: emitEvent });
    };
    /**
     *  Patches the value of the {\@link FormArray}. It accepts an array that matches the
     *  structure of the control, and will do its best to match the values to the correct
     *  controls in the group.
     *
     *  It accepts both super-sets and sub-sets of the array without throwing an error.
     *
     *  ### Example
     *
     *  ```
     *  const arr = new FormArray([
     *     new FormControl(),
     *     new FormControl()
     *  ]);
     *  console.log(arr.value);   // [null, null]
     *
     *  arr.patchValue(['Nancy']);
     *  console.log(arr.value);   // ['Nancy', null]
     *  ```
     * @param {?} value
     * @param {?=} __1
     * @return {?}
     */
    FormArray.prototype.patchValue = function (value, _a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, onlySelf = _b.onlySelf, emitEvent = _b.emitEvent;
        value.forEach(function (newValue, index) {
            if (_this.at(index)) {
                _this.at(index).patchValue(newValue, { onlySelf: true, emitEvent: emitEvent });
            }
        });
        this.updateValueAndValidity({ onlySelf: onlySelf, emitEvent: emitEvent });
    };
    /**
     * Resets the {\@link FormArray}. This means by default:
     *
     * * The array and all descendants are marked `pristine`
     * * The array and all descendants are marked `untouched`
     * * The value of all descendants will be null or null maps
     *
     * You can also reset to a specific form state by passing in an array of states
     * that matches the structure of the control. The state can be a standalone value
     * or a form state object with both a value and a disabled status.
     *
     * ### Example
     *
     * ```ts
     * this.arr.reset(['name', 'last name']);
     *
     * console.log(this.arr.value);  // ['name', 'last name']
     * ```
     *
     * - OR -
     *
     * ```
     * this.arr.reset([
     *   {value: 'name', disabled: true},
     *   'last'
     * ]);
     *
     * console.log(this.arr.value);  // ['name', 'last name']
     * console.log(this.arr.get(0).status);  // 'DISABLED'
     * ```
     * @param {?=} value
     * @param {?=} __1
     * @return {?}
     */
    FormArray.prototype.reset = function (value, _a) {
        if (value === void 0) { value = []; }
        var _b = _a === void 0 ? {} : _a, onlySelf = _b.onlySelf, emitEvent = _b.emitEvent;
        this._forEachChild(function (control, index) {
            control.reset(value[index], { onlySelf: true, emitEvent: emitEvent });
        });
        this.updateValueAndValidity({ onlySelf: onlySelf, emitEvent: emitEvent });
        this._updatePristine({ onlySelf: onlySelf });
        this._updateTouched({ onlySelf: onlySelf });
    };
    /**
     * The aggregate value of the array, including any disabled controls.
     *
     * If you'd like to include all values regardless of disabled status, use this method.
     * Otherwise, the `value` property is the best way to get the value of the array.
     * @return {?}
     */
    FormArray.prototype.getRawValue = function () {
        return this.controls.map(function (control) {
            return control instanceof FormControl ? control.value : ((control)).getRawValue();
        });
    };
    /**
     * \@internal
     * @param {?} index
     * @return {?}
     */
    FormArray.prototype._throwIfControlMissing = function (index) {
        if (!this.controls.length) {
            throw new Error("\n        There are no form controls registered with this array yet.  If you're using ngModel,\n        you may want to check next tick (e.g. use setTimeout).\n      ");
        }
        if (!this.at(index)) {
            throw new Error("Cannot find form control at index " + index);
        }
    };
    /**
     * \@internal
     * @param {?} cb
     * @return {?}
     */
    FormArray.prototype._forEachChild = function (cb) {
        this.controls.forEach(function (control, index) { cb(control, index); });
    };
    /**
     * \@internal
     * @return {?}
     */
    FormArray.prototype._updateValue = function () {
        var _this = this;
        this._value = this.controls.filter(function (control) { return control.enabled || _this.disabled; })
            .map(function (control) { return control.value; });
    };
    /**
     * \@internal
     * @param {?} condition
     * @return {?}
     */
    FormArray.prototype._anyControls = function (condition) {
        return this.controls.some(function (control) { return control.enabled && condition(control); });
    };
    /**
     * \@internal
     * @return {?}
     */
    FormArray.prototype._setUpControls = function () {
        var _this = this;
        this._forEachChild(function (control) { return _this._registerControl(control); });
    };
    /**
     * \@internal
     * @param {?} value
     * @return {?}
     */
    FormArray.prototype._checkAllValuesPresent = function (value) {
        this._forEachChild(function (control, i) {
            if (value[i] === undefined) {
                throw new Error("Must supply a value for form control at index: " + i + ".");
            }
        });
    };
    /**
     * \@internal
     * @return {?}
     */
    FormArray.prototype._allControlsDisabled = function () {
        for (var _i = 0, _a = this.controls; _i < _a.length; _i++) {
            var control = _a[_i];
            if (control.enabled)
                return false;
        }
        return this.controls.length > 0 || this.disabled;
    };
    /**
     * @param {?} control
     * @return {?}
     */
    FormArray.prototype._registerControl = function (control) {
        control.setParent(this);
        control._registerOnCollectionChange(this._onCollectionChange);
    };
    return FormArray;
}(AbstractControl));
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var formDirectiveProvider = {
    provide: ControlContainer,
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return NgForm; })
};
var resolvedPromise = Promise.resolve(null);
/**
 * \@whatItDoes Creates a top-level {\@link FormGroup} instance and binds it to a form
 * to track aggregate form value and validation status.
 *
 * \@howToUse
 *
 * As soon as you import the `FormsModule`, this directive becomes active by default on
 * all `<form>` tags.  You don't need to add a special selector.
 *
 * You can export the directive into a local template variable using `ngForm` as the key
 * (ex: `#myForm="ngForm"`). This is optional, but useful.  Many properties from the underlying
 * {\@link FormGroup} instance are duplicated on the directive itself, so a reference to it
 * will give you access to the aggregate value and validity status of the form, as well as
 * user interaction properties like `dirty` and `touched`.
 *
 * To register child controls with the form, you'll want to use {\@link NgModel} with a
 * `name` attribute.  You can also use {\@link NgModelGroup} if you'd like to create
 * sub-groups within the form.
 *
 * You can listen to the directive's `ngSubmit` event to be notified when the user has
 * triggered a form submission. The `ngSubmit` event will be emitted with the original form
 * submission event.
 *
 * {\@example forms/ts/simpleForm/simple_form_example.ts region='Component'}
 *
 * * **npm package**: `\@angular/forms`
 *
 * * **NgModule**: `FormsModule`
 *
 *  \@stable
 */
var NgForm = (function (_super) {
    __extends(NgForm, _super);
    /**
     * @param {?} validators
     * @param {?} asyncValidators
     */
    function NgForm(validators, asyncValidators) {
        var _this = _super.call(this) || this;
        _this._submitted = false;
        _this.ngSubmit = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        _this.form =
            new FormGroup({}, composeValidators(validators), composeAsyncValidators(asyncValidators));
        return _this;
    }
    Object.defineProperty(NgForm.prototype, "submitted", {
        /**
         * @return {?}
         */
        get: function () { return this._submitted; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgForm.prototype, "formDirective", {
        /**
         * @return {?}
         */
        get: function () { return this; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgForm.prototype, "control", {
        /**
         * @return {?}
         */
        get: function () { return this.form; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgForm.prototype, "path", {
        /**
         * @return {?}
         */
        get: function () { return []; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgForm.prototype, "controls", {
        /**
         * @return {?}
         */
        get: function () { return this.form.controls; },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} dir
     * @return {?}
     */
    NgForm.prototype.addControl = function (dir) {
        var _this = this;
        resolvedPromise.then(function () {
            var /** @type {?} */ container = _this._findContainer(dir.path);
            dir._control = (container.registerControl(dir.name, dir.control));
            setUpControl(dir.control, dir);
            dir.control.updateValueAndValidity({ emitEvent: false });
        });
    };
    /**
     * @param {?} dir
     * @return {?}
     */
    NgForm.prototype.getControl = function (dir) { return (this.form.get(dir.path)); };
    /**
     * @param {?} dir
     * @return {?}
     */
    NgForm.prototype.removeControl = function (dir) {
        var _this = this;
        resolvedPromise.then(function () {
            var /** @type {?} */ container = _this._findContainer(dir.path);
            if (container) {
                container.removeControl(dir.name);
            }
        });
    };
    /**
     * @param {?} dir
     * @return {?}
     */
    NgForm.prototype.addFormGroup = function (dir) {
        var _this = this;
        resolvedPromise.then(function () {
            var /** @type {?} */ container = _this._findContainer(dir.path);
            var /** @type {?} */ group = new FormGroup({});
            setUpFormContainer(group, dir);
            container.registerControl(dir.name, group);
            group.updateValueAndValidity({ emitEvent: false });
        });
    };
    /**
     * @param {?} dir
     * @return {?}
     */
    NgForm.prototype.removeFormGroup = function (dir) {
        var _this = this;
        resolvedPromise.then(function () {
            var /** @type {?} */ container = _this._findContainer(dir.path);
            if (container) {
                container.removeControl(dir.name);
            }
        });
    };
    /**
     * @param {?} dir
     * @return {?}
     */
    NgForm.prototype.getFormGroup = function (dir) { return (this.form.get(dir.path)); };
    /**
     * @param {?} dir
     * @param {?} value
     * @return {?}
     */
    NgForm.prototype.updateModel = function (dir, value) {
        var _this = this;
        resolvedPromise.then(function () {
            var /** @type {?} */ ctrl = (_this.form.get(/** @type {?} */ ((dir.path))));
            ctrl.setValue(value);
        });
    };
    /**
     * @param {?} value
     * @return {?}
     */
    NgForm.prototype.setValue = function (value) { this.control.setValue(value); };
    /**
     * @param {?} $event
     * @return {?}
     */
    NgForm.prototype.onSubmit = function ($event) {
        this._submitted = true;
        this.ngSubmit.emit($event);
        return false;
    };
    /**
     * @return {?}
     */
    NgForm.prototype.onReset = function () { this.resetForm(); };
    /**
     * @param {?=} value
     * @return {?}
     */
    NgForm.prototype.resetForm = function (value) {
        if (value === void 0) { value = undefined; }
        this.form.reset(value);
        this._submitted = false;
    };
    /**
     * \@internal
     * @param {?} path
     * @return {?}
     */
    NgForm.prototype._findContainer = function (path) {
        path.pop();
        return path.length ? (this.form.get(path)) : this.form;
    };
    return NgForm;
}(ControlContainer));
NgForm.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                selector: 'form:not([ngNoForm]):not([formGroup]),ngForm,[ngForm]',
                providers: [formDirectiveProvider],
                host: { '(submit)': 'onSubmit($event)', '(reset)': 'onReset()' },
                outputs: ['ngSubmit'],
                exportAs: 'ngForm'
            },] },
];
/**
 * @nocollapse
 */
NgForm.ctorParameters = function () { return [
    { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [NG_VALIDATORS,] },] },
    { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [NG_ASYNC_VALIDATORS,] },] },
]; };
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var FormErrorExamples = {
    formControlName: "\n    <div [formGroup]=\"myGroup\">\n      <input formControlName=\"firstName\">\n    </div>\n\n    In your class:\n\n    this.myGroup = new FormGroup({\n       firstName: new FormControl()\n    });",
    formGroupName: "\n    <div [formGroup]=\"myGroup\">\n       <div formGroupName=\"person\">\n          <input formControlName=\"firstName\">\n       </div>\n    </div>\n\n    In your class:\n\n    this.myGroup = new FormGroup({\n       person: new FormGroup({ firstName: new FormControl() })\n    });",
    formArrayName: "\n    <div [formGroup]=\"myGroup\">\n      <div formArrayName=\"cities\">\n        <div *ngFor=\"let city of cityArray.controls; index as i\">\n          <input [formControlName]=\"i\">\n        </div>\n      </div>\n    </div>\n\n    In your class:\n\n    this.cityArray = new FormArray([new FormControl('SF')]);\n    this.myGroup = new FormGroup({\n      cities: this.cityArray\n    });",
    ngModelGroup: "\n    <form>\n       <div ngModelGroup=\"person\">\n          <input [(ngModel)]=\"person.name\" name=\"firstName\">\n       </div>\n    </form>",
    ngModelWithFormGroup: "\n    <div [formGroup]=\"myGroup\">\n       <input formControlName=\"firstName\">\n       <input [(ngModel)]=\"showMoreControls\" [ngModelOptions]=\"{standalone: true}\">\n    </div>\n  "
};
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var TemplateDrivenErrors = (function () {
    function TemplateDrivenErrors() {
    }
    /**
     * @return {?}
     */
    TemplateDrivenErrors.modelParentException = function () {
        throw new Error("\n      ngModel cannot be used to register form controls with a parent formGroup directive.  Try using\n      formGroup's partner directive \"formControlName\" instead.  Example:\n\n      " + FormErrorExamples.formControlName + "\n\n      Or, if you'd like to avoid registering this form control, indicate that it's standalone in ngModelOptions:\n\n      Example:\n\n      " + FormErrorExamples.ngModelWithFormGroup);
    };
    /**
     * @return {?}
     */
    TemplateDrivenErrors.formGroupNameException = function () {
        throw new Error("\n      ngModel cannot be used to register form controls with a parent formGroupName or formArrayName directive.\n\n      Option 1: Use formControlName instead of ngModel (reactive strategy):\n\n      " + FormErrorExamples.formGroupName + "\n\n      Option 2:  Update ngModel's parent be ngModelGroup (template-driven strategy):\n\n      " + FormErrorExamples.ngModelGroup);
    };
    /**
     * @return {?}
     */
    TemplateDrivenErrors.missingNameException = function () {
        throw new Error("If ngModel is used within a form tag, either the name attribute must be set or the form\n      control must be defined as 'standalone' in ngModelOptions.\n\n      Example 1: <input [(ngModel)]=\"person.firstName\" name=\"first\">\n      Example 2: <input [(ngModel)]=\"person.firstName\" [ngModelOptions]=\"{standalone: true}\">");
    };
    /**
     * @return {?}
     */
    TemplateDrivenErrors.modelGroupParentException = function () {
        throw new Error("\n      ngModelGroup cannot be used with a parent formGroup directive.\n\n      Option 1: Use formGroupName instead of ngModelGroup (reactive strategy):\n\n      " + FormErrorExamples.formGroupName + "\n\n      Option 2:  Use a regular form tag instead of the formGroup directive (template-driven strategy):\n\n      " + FormErrorExamples.ngModelGroup);
    };
    return TemplateDrivenErrors;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var modelGroupProvider = {
    provide: ControlContainer,
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return NgModelGroup; })
};
/**
 * \@whatItDoes Creates and binds a {\@link FormGroup} instance to a DOM element.
 *
 * \@howToUse
 *
 * This directive can only be used as a child of {\@link NgForm} (or in other words,
 * within `<form>` tags).
 *
 * Use this directive if you'd like to create a sub-group within a form. This can
 * come in handy if you want to validate a sub-group of your form separately from
 * the rest of your form, or if some values in your domain model make more sense to
 * consume together in a nested object.
 *
 * Pass in the name you'd like this sub-group to have and it will become the key
 * for the sub-group in the form's full value. You can also export the directive into
 * a local template variable using `ngModelGroup` (ex: `#myGroup="ngModelGroup"`).
 *
 * {\@example forms/ts/ngModelGroup/ng_model_group_example.ts region='Component'}
 *
 * * **npm package**: `\@angular/forms`
 *
 * * **NgModule**: `FormsModule`
 *
 * \@stable
 */
var NgModelGroup = (function (_super) {
    __extends(NgModelGroup, _super);
    /**
     * @param {?} parent
     * @param {?} validators
     * @param {?} asyncValidators
     */
    function NgModelGroup(parent, validators, asyncValidators) {
        var _this = _super.call(this) || this;
        _this._parent = parent;
        _this._validators = validators;
        _this._asyncValidators = asyncValidators;
        return _this;
    }
    /**
     * \@internal
     * @return {?}
     */
    NgModelGroup.prototype._checkParentType = function () {
        if (!(this._parent instanceof NgModelGroup) && !(this._parent instanceof NgForm)) {
            TemplateDrivenErrors.modelGroupParentException();
        }
    };
    return NgModelGroup;
}(AbstractFormGroupDirective));
NgModelGroup.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{ selector: '[ngModelGroup]', providers: [modelGroupProvider], exportAs: 'ngModelGroup' },] },
];
/**
 * @nocollapse
 */
NgModelGroup.ctorParameters = function () { return [
    { type: ControlContainer, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Host"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["SkipSelf"] },] },
    { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [NG_VALIDATORS,] },] },
    { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [NG_ASYNC_VALIDATORS,] },] },
]; };
NgModelGroup.propDecorators = {
    'name': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['ngModelGroup',] },],
};
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var formControlBinding = {
    provide: NgControl,
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return NgModel; })
};
/**
 * `ngModel` forces an additional change detection run when its inputs change:
 * E.g.:
 * ```
 * <div>{{myModel.valid}}</div>
 * <input [(ngModel)]="myValue" #myModel="ngModel">
 * ```
 * I.e. `ngModel` can export itself on the element and then be used in the template.
 * Normally, this would result in expressions before the `input` that use the exported directive
 * to have and old value as they have been
 * dirty checked before. As this is a very common case for `ngModel`, we added this second change
 * detection run.
 *
 * Notes:
 * - this is just one extra run no matter how many `ngModel` have been changed.
 * - this is a general problem when using `exportAs` for directives!
 */
var resolvedPromise$1 = Promise.resolve(null);
/**
 * \@whatItDoes Creates a {\@link FormControl} instance from a domain model and binds it
 * to a form control element.
 *
 * The {\@link FormControl} instance will track the value, user interaction, and
 * validation status of the control and keep the view synced with the model. If used
 * within a parent form, the directive will also register itself with the form as a child
 * control.
 *
 * \@howToUse
 *
 * This directive can be used by itself or as part of a larger form. All you need is the
 * `ngModel` selector to activate it.
 *
 * It accepts a domain model as an optional {\@link \@Input}. If you have a one-way binding
 * to `ngModel` with `[]` syntax, changing the value of the domain model in the component
 * class will set the value in the view. If you have a two-way binding with `[()]` syntax
 * (also known as 'banana-box syntax'), the value in the UI will always be synced back to
 * the domain model in your class as well.
 *
 * If you wish to inspect the properties of the associated {\@link FormControl} (like
 * validity state), you can also export the directive into a local template variable using
 * `ngModel` as the key (ex: `#myVar="ngModel"`). You can then access the control using the
 * directive's `control` property, but most properties you'll need (like `valid` and `dirty`)
 * will fall through to the control anyway, so you can access them directly. You can see a
 * full list of properties directly available in {\@link AbstractControlDirective}.
 *
 * The following is an example of a simple standalone control using `ngModel`:
 *
 * {\@example forms/ts/simpleNgModel/simple_ng_model_example.ts region='Component'}
 *
 * When using the `ngModel` within `<form>` tags, you'll also need to supply a `name` attribute
 * so that the control can be registered with the parent form under that name.
 *
 * It's worth noting that in the context of a parent form, you often can skip one-way or
 * two-way binding because the parent form will sync the value for you. You can access
 * its properties by exporting it into a local template variable using `ngForm` (ex:
 * `#f="ngForm"`). Then you can pass it where it needs to go on submit.
 *
 * If you do need to populate initial values into your form, using a one-way binding for
 * `ngModel` tends to be sufficient as long as you use the exported form's value rather
 * than the domain model's value on submit.
 *
 * Take a look at an example of using `ngModel` within a form:
 *
 * {\@example forms/ts/simpleForm/simple_form_example.ts region='Component'}
 *
 * To see `ngModel` examples with different form control types, see:
 *
 * * Radio buttons: {\@link RadioControlValueAccessor}
 * * Selects: {\@link SelectControlValueAccessor}
 *
 * **npm package**: `\@angular/forms`
 *
 * **NgModule**: `FormsModule`
 *
 *  \@stable
 */
var NgModel = (function (_super) {
    __extends(NgModel, _super);
    /**
     * @param {?} parent
     * @param {?} validators
     * @param {?} asyncValidators
     * @param {?} valueAccessors
     */
    function NgModel(parent, validators, asyncValidators, valueAccessors) {
        var _this = _super.call(this) || this;
        /**
         * \@internal
         */
        _this._control = new FormControl();
        /**
         * \@internal
         */
        _this._registered = false;
        _this.update = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        _this._parent = parent;
        _this._rawValidators = validators || [];
        _this._rawAsyncValidators = asyncValidators || [];
        _this.valueAccessor = selectValueAccessor(_this, valueAccessors);
        return _this;
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    NgModel.prototype.ngOnChanges = function (changes) {
        this._checkForErrors();
        if (!this._registered)
            this._setUpControl();
        if ('isDisabled' in changes) {
            this._updateDisabled(changes);
        }
        if (isPropertyUpdated(changes, this.viewModel)) {
            this._updateValue(this.model);
            this.viewModel = this.model;
        }
    };
    /**
     * @return {?}
     */
    NgModel.prototype.ngOnDestroy = function () { this.formDirective && this.formDirective.removeControl(this); };
    Object.defineProperty(NgModel.prototype, "control", {
        /**
         * @return {?}
         */
        get: function () { return this._control; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgModel.prototype, "path", {
        /**
         * @return {?}
         */
        get: function () {
            return this._parent ? controlPath(this.name, this._parent) : [this.name];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgModel.prototype, "formDirective", {
        /**
         * @return {?}
         */
        get: function () { return this._parent ? this._parent.formDirective : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgModel.prototype, "validator", {
        /**
         * @return {?}
         */
        get: function () { return composeValidators(this._rawValidators); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NgModel.prototype, "asyncValidator", {
        /**
         * @return {?}
         */
        get: function () {
            return composeAsyncValidators(this._rawAsyncValidators);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} newValue
     * @return {?}
     */
    NgModel.prototype.viewToModelUpdate = function (newValue) {
        this.viewModel = newValue;
        this.update.emit(newValue);
    };
    /**
     * @return {?}
     */
    NgModel.prototype._setUpControl = function () {
        this._isStandalone() ? this._setUpStandalone() :
            this.formDirective.addControl(this);
        this._registered = true;
    };
    /**
     * @return {?}
     */
    NgModel.prototype._isStandalone = function () {
        return !this._parent || !!(this.options && this.options.standalone);
    };
    /**
     * @return {?}
     */
    NgModel.prototype._setUpStandalone = function () {
        setUpControl(this._control, this);
        this._control.updateValueAndValidity({ emitEvent: false });
    };
    /**
     * @return {?}
     */
    NgModel.prototype._checkForErrors = function () {
        if (!this._isStandalone()) {
            this._checkParentType();
        }
        this._checkName();
    };
    /**
     * @return {?}
     */
    NgModel.prototype._checkParentType = function () {
        if (!(this._parent instanceof NgModelGroup) &&
            this._parent instanceof AbstractFormGroupDirective) {
            TemplateDrivenErrors.formGroupNameException();
        }
        else if (!(this._parent instanceof NgModelGroup) && !(this._parent instanceof NgForm)) {
            TemplateDrivenErrors.modelParentException();
        }
    };
    /**
     * @return {?}
     */
    NgModel.prototype._checkName = function () {
        if (this.options && this.options.name)
            this.name = this.options.name;
        if (!this._isStandalone() && !this.name) {
            TemplateDrivenErrors.missingNameException();
        }
    };
    /**
     * @param {?} value
     * @return {?}
     */
    NgModel.prototype._updateValue = function (value) {
        var _this = this;
        resolvedPromise$1.then(function () { _this.control.setValue(value, { emitViewToModelChange: false }); });
    };
    /**
     * @param {?} changes
     * @return {?}
     */
    NgModel.prototype._updateDisabled = function (changes) {
        var _this = this;
        var /** @type {?} */ disabledValue = changes['isDisabled'].currentValue;
        var /** @type {?} */ isDisabled = disabledValue === '' || (disabledValue && disabledValue !== 'false');
        resolvedPromise$1.then(function () {
            if (isDisabled && !_this.control.disabled) {
                _this.control.disable();
            }
            else if (!isDisabled && _this.control.disabled) {
                _this.control.enable();
            }
        });
    };
    return NgModel;
}(NgControl));
NgModel.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                selector: '[ngModel]:not([formControlName]):not([formControl])',
                providers: [formControlBinding],
                exportAs: 'ngModel'
            },] },
];
/**
 * @nocollapse
 */
NgModel.ctorParameters = function () { return [
    { type: ControlContainer, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Host"] },] },
    { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [NG_VALIDATORS,] },] },
    { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [NG_ASYNC_VALIDATORS,] },] },
    { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [NG_VALUE_ACCESSOR,] },] },
]; };
NgModel.propDecorators = {
    'name': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'isDisabled': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['disabled',] },],
    'model': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['ngModel',] },],
    'options': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['ngModelOptions',] },],
    'update': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"], args: ['ngModelChange',] },],
};
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var ReactiveErrors = (function () {
    function ReactiveErrors() {
    }
    /**
     * @return {?}
     */
    ReactiveErrors.controlParentException = function () {
        throw new Error("formControlName must be used with a parent formGroup directive.  You'll want to add a formGroup\n       directive and pass it an existing FormGroup instance (you can create one in your class).\n\n      Example:\n\n      " + FormErrorExamples.formControlName);
    };
    /**
     * @return {?}
     */
    ReactiveErrors.ngModelGroupException = function () {
        throw new Error("formControlName cannot be used with an ngModelGroup parent. It is only compatible with parents\n       that also have a \"form\" prefix: formGroupName, formArrayName, or formGroup.\n\n       Option 1:  Update the parent to be formGroupName (reactive form strategy)\n\n        " + FormErrorExamples.formGroupName + "\n\n        Option 2: Use ngModel instead of formControlName (template-driven strategy)\n\n        " + FormErrorExamples.ngModelGroup);
    };
    /**
     * @return {?}
     */
    ReactiveErrors.missingFormException = function () {
        throw new Error("formGroup expects a FormGroup instance. Please pass one in.\n\n       Example:\n\n       " + FormErrorExamples.formControlName);
    };
    /**
     * @return {?}
     */
    ReactiveErrors.groupParentException = function () {
        throw new Error("formGroupName must be used with a parent formGroup directive.  You'll want to add a formGroup\n      directive and pass it an existing FormGroup instance (you can create one in your class).\n\n      Example:\n\n      " + FormErrorExamples.formGroupName);
    };
    /**
     * @return {?}
     */
    ReactiveErrors.arrayParentException = function () {
        throw new Error("formArrayName must be used with a parent formGroup directive.  You'll want to add a formGroup\n       directive and pass it an existing FormGroup instance (you can create one in your class).\n\n        Example:\n\n        " + FormErrorExamples.formArrayName);
    };
    /**
     * @return {?}
     */
    ReactiveErrors.disabledAttrWarning = function () {
        console.warn("\n      It looks like you're using the disabled attribute with a reactive form directive. If you set disabled to true\n      when you set up this control in your component class, the disabled attribute will actually be set in the DOM for\n      you. We recommend using this approach to avoid 'changed after checked' errors.\n       \n      Example: \n      form = new FormGroup({\n        first: new FormControl({value: 'Nancy', disabled: true}, Validators.required),\n        last: new FormControl('Drew', Validators.required)\n      });\n    ");
    };
    return ReactiveErrors;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var formControlBinding$1 = {
    provide: NgControl,
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return FormControlDirective; })
};
/**
 * \@whatItDoes Syncs a standalone {\@link FormControl} instance to a form control element.
 *
 * In other words, this directive ensures that any values written to the {\@link FormControl}
 * instance programmatically will be written to the DOM element (model -> view). Conversely,
 * any values written to the DOM element through user input will be reflected in the
 * {\@link FormControl} instance (view -> model).
 *
 * \@howToUse
 *
 * Use this directive if you'd like to create and manage a {\@link FormControl} instance directly.
 * Simply create a {\@link FormControl}, save it to your component class, and pass it into the
 * {\@link FormControlDirective}.
 *
 * This directive is designed to be used as a standalone control.  Unlike {\@link FormControlName},
 * it does not require that your {\@link FormControl} instance be part of any parent
 * {\@link FormGroup}, and it won't be registered to any {\@link FormGroupDirective} that
 * exists above it.
 *
 * **Get the value**: the `value` property is always synced and available on the
 * {\@link FormControl} instance. See a full list of available properties in
 * {\@link AbstractControl}.
 *
 * **Set the value**: You can pass in an initial value when instantiating the {\@link FormControl},
 * or you can set it programmatically later using {\@link AbstractControl.setValue} or
 * {\@link AbstractControl.patchValue}.
 *
 * **Listen to value**: If you want to listen to changes in the value of the control, you can
 * subscribe to the {\@link AbstractControl.valueChanges} event.  You can also listen to
 * {\@link AbstractControl.statusChanges} to be notified when the validation status is
 * re-calculated.
 *
 * ### Example
 *
 * {\@example forms/ts/simpleFormControl/simple_form_control_example.ts region='Component'}
 *
 * * **npm package**: `\@angular/forms`
 *
 * * **NgModule**: `ReactiveFormsModule`
 *
 *  \@stable
 */
var FormControlDirective = (function (_super) {
    __extends(FormControlDirective, _super);
    /**
     * @param {?} validators
     * @param {?} asyncValidators
     * @param {?} valueAccessors
     */
    function FormControlDirective(validators, asyncValidators, valueAccessors) {
        var _this = _super.call(this) || this;
        _this.update = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        _this._rawValidators = validators || [];
        _this._rawAsyncValidators = asyncValidators || [];
        _this.valueAccessor = selectValueAccessor(_this, valueAccessors);
        return _this;
    }
    Object.defineProperty(FormControlDirective.prototype, "isDisabled", {
        /**
         * @param {?} isDisabled
         * @return {?}
         */
        set: function (isDisabled) { ReactiveErrors.disabledAttrWarning(); },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} changes
     * @return {?}
     */
    FormControlDirective.prototype.ngOnChanges = function (changes) {
        if (this._isControlChanged(changes)) {
            setUpControl(this.form, this);
            if (this.control.disabled && ((this.valueAccessor)).setDisabledState) {
                ((((this.valueAccessor)).setDisabledState))(true);
            }
            this.form.updateValueAndValidity({ emitEvent: false });
        }
        if (isPropertyUpdated(changes, this.viewModel)) {
            this.form.setValue(this.model);
            this.viewModel = this.model;
        }
    };
    Object.defineProperty(FormControlDirective.prototype, "path", {
        /**
         * @return {?}
         */
        get: function () { return []; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormControlDirective.prototype, "validator", {
        /**
         * @return {?}
         */
        get: function () { return composeValidators(this._rawValidators); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormControlDirective.prototype, "asyncValidator", {
        /**
         * @return {?}
         */
        get: function () {
            return composeAsyncValidators(this._rawAsyncValidators);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormControlDirective.prototype, "control", {
        /**
         * @return {?}
         */
        get: function () { return this.form; },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} newValue
     * @return {?}
     */
    FormControlDirective.prototype.viewToModelUpdate = function (newValue) {
        this.viewModel = newValue;
        this.update.emit(newValue);
    };
    /**
     * @param {?} changes
     * @return {?}
     */
    FormControlDirective.prototype._isControlChanged = function (changes) {
        return changes.hasOwnProperty('form');
    };
    return FormControlDirective;
}(NgControl));
FormControlDirective.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{ selector: '[formControl]', providers: [formControlBinding$1], exportAs: 'ngForm' },] },
];
/**
 * @nocollapse
 */
FormControlDirective.ctorParameters = function () { return [
    { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [NG_VALIDATORS,] },] },
    { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [NG_ASYNC_VALIDATORS,] },] },
    { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [NG_VALUE_ACCESSOR,] },] },
]; };
FormControlDirective.propDecorators = {
    'form': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['formControl',] },],
    'model': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['ngModel',] },],
    'update': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"], args: ['ngModelChange',] },],
    'isDisabled': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['disabled',] },],
};
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var formDirectiveProvider$1 = {
    provide: ControlContainer,
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return FormGroupDirective; })
};
/**
 * \@whatItDoes Binds an existing {\@link FormGroup} to a DOM element.
 *
 * \@howToUse
 *
 * This directive accepts an existing {\@link FormGroup} instance. It will then use this
 * {\@link FormGroup} instance to match any child {\@link FormControl}, {\@link FormGroup},
 * and {\@link FormArray} instances to child {\@link FormControlName}, {\@link FormGroupName},
 * and {\@link FormArrayName} directives.
 *
 * **Set value**: You can set the form's initial value when instantiating the
 * {\@link FormGroup}, or you can set it programmatically later using the {\@link FormGroup}'s
 * {\@link AbstractControl.setValue} or {\@link AbstractControl.patchValue} methods.
 *
 * **Listen to value**: If you want to listen to changes in the value of the form, you can subscribe
 * to the {\@link FormGroup}'s {\@link AbstractControl.valueChanges} event.  You can also listen to
 * its {\@link AbstractControl.statusChanges} event to be notified when the validation status is
 * re-calculated.
 *
 * Furthermore, you can listen to the directive's `ngSubmit` event to be notified when the user has
 * triggered a form submission. The `ngSubmit` event will be emitted with the original form
 * submission event.
 *
 * ### Example
 *
 * In this example, we create form controls for first name and last name.
 *
 * {\@example forms/ts/simpleFormGroup/simple_form_group_example.ts region='Component'}
 *
 * **npm package**: `\@angular/forms`
 *
 * **NgModule**: {\@link ReactiveFormsModule}
 *
 *  \@stable
 */
var FormGroupDirective = (function (_super) {
    __extends(FormGroupDirective, _super);
    /**
     * @param {?} _validators
     * @param {?} _asyncValidators
     */
    function FormGroupDirective(_validators, _asyncValidators) {
        var _this = _super.call(this) || this;
        _this._validators = _validators;
        _this._asyncValidators = _asyncValidators;
        _this._submitted = false;
        _this.directives = [];
        _this.form = ((null));
        _this.ngSubmit = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        return _this;
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    FormGroupDirective.prototype.ngOnChanges = function (changes) {
        this._checkFormPresent();
        if (changes.hasOwnProperty('form')) {
            this._updateValidators();
            this._updateDomValue();
            this._updateRegistrations();
        }
    };
    Object.defineProperty(FormGroupDirective.prototype, "submitted", {
        /**
         * @return {?}
         */
        get: function () { return this._submitted; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormGroupDirective.prototype, "formDirective", {
        /**
         * @return {?}
         */
        get: function () { return this; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormGroupDirective.prototype, "control", {
        /**
         * @return {?}
         */
        get: function () { return this.form; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormGroupDirective.prototype, "path", {
        /**
         * @return {?}
         */
        get: function () { return []; },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} dir
     * @return {?}
     */
    FormGroupDirective.prototype.addControl = function (dir) {
        var /** @type {?} */ ctrl = this.form.get(dir.path);
        setUpControl(ctrl, dir);
        ctrl.updateValueAndValidity({ emitEvent: false });
        this.directives.push(dir);
        return ctrl;
    };
    /**
     * @param {?} dir
     * @return {?}
     */
    FormGroupDirective.prototype.getControl = function (dir) { return (this.form.get(dir.path)); };
    /**
     * @param {?} dir
     * @return {?}
     */
    FormGroupDirective.prototype.removeControl = function (dir) { remove(this.directives, dir); };
    /**
     * @param {?} dir
     * @return {?}
     */
    FormGroupDirective.prototype.addFormGroup = function (dir) {
        var /** @type {?} */ ctrl = this.form.get(dir.path);
        setUpFormContainer(ctrl, dir);
        ctrl.updateValueAndValidity({ emitEvent: false });
    };
    /**
     * @param {?} dir
     * @return {?}
     */
    FormGroupDirective.prototype.removeFormGroup = function (dir) { };
    /**
     * @param {?} dir
     * @return {?}
     */
    FormGroupDirective.prototype.getFormGroup = function (dir) { return (this.form.get(dir.path)); };
    /**
     * @param {?} dir
     * @return {?}
     */
    FormGroupDirective.prototype.addFormArray = function (dir) {
        var /** @type {?} */ ctrl = this.form.get(dir.path);
        setUpFormContainer(ctrl, dir);
        ctrl.updateValueAndValidity({ emitEvent: false });
    };
    /**
     * @param {?} dir
     * @return {?}
     */
    FormGroupDirective.prototype.removeFormArray = function (dir) { };
    /**
     * @param {?} dir
     * @return {?}
     */
    FormGroupDirective.prototype.getFormArray = function (dir) { return (this.form.get(dir.path)); };
    /**
     * @param {?} dir
     * @param {?} value
     * @return {?}
     */
    FormGroupDirective.prototype.updateModel = function (dir, value) {
        var /** @type {?} */ ctrl = (this.form.get(dir.path));
        ctrl.setValue(value);
    };
    /**
     * @param {?} $event
     * @return {?}
     */
    FormGroupDirective.prototype.onSubmit = function ($event) {
        this._submitted = true;
        this.ngSubmit.emit($event);
        return false;
    };
    /**
     * @return {?}
     */
    FormGroupDirective.prototype.onReset = function () { this.resetForm(); };
    /**
     * @param {?=} value
     * @return {?}
     */
    FormGroupDirective.prototype.resetForm = function (value) {
        if (value === void 0) { value = undefined; }
        this.form.reset(value);
        this._submitted = false;
    };
    /**
     * \@internal
     * @return {?}
     */
    FormGroupDirective.prototype._updateDomValue = function () {
        var _this = this;
        this.directives.forEach(function (dir) {
            var /** @type {?} */ newCtrl = _this.form.get(dir.path);
            if (dir._control !== newCtrl) {
                cleanUpControl(dir._control, dir);
                if (newCtrl)
                    setUpControl(newCtrl, dir);
                dir._control = newCtrl;
            }
        });
        this.form._updateTreeValidity({ emitEvent: false });
    };
    /**
     * @return {?}
     */
    FormGroupDirective.prototype._updateRegistrations = function () {
        var _this = this;
        this.form._registerOnCollectionChange(function () { return _this._updateDomValue(); });
        if (this._oldForm)
            this._oldForm._registerOnCollectionChange(function () { });
        this._oldForm = this.form;
    };
    /**
     * @return {?}
     */
    FormGroupDirective.prototype._updateValidators = function () {
        var /** @type {?} */ sync = composeValidators(this._validators);
        this.form.validator = Validators.compose([/** @type {?} */ ((this.form.validator)), /** @type {?} */ ((sync))]);
        var /** @type {?} */ async = composeAsyncValidators(this._asyncValidators);
        this.form.asyncValidator = Validators.composeAsync([/** @type {?} */ ((this.form.asyncValidator)), /** @type {?} */ ((async))]);
    };
    /**
     * @return {?}
     */
    FormGroupDirective.prototype._checkFormPresent = function () {
        if (!this.form) {
            ReactiveErrors.missingFormException();
        }
    };
    return FormGroupDirective;
}(ControlContainer));
FormGroupDirective.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                selector: '[formGroup]',
                providers: [formDirectiveProvider$1],
                host: { '(submit)': 'onSubmit($event)', '(reset)': 'onReset()' },
                exportAs: 'ngForm'
            },] },
];
/**
 * @nocollapse
 */
FormGroupDirective.ctorParameters = function () { return [
    { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [NG_VALIDATORS,] },] },
    { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [NG_ASYNC_VALIDATORS,] },] },
]; };
FormGroupDirective.propDecorators = {
    'form': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['formGroup',] },],
    'ngSubmit': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
};
/**
 * @template T
 * @param {?} list
 * @param {?} el
 * @return {?}
 */
function remove(list, el) {
    var /** @type {?} */ index = list.indexOf(el);
    if (index > -1) {
        list.splice(index, 1);
    }
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var formGroupNameProvider = {
    provide: ControlContainer,
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return FormGroupName; })
};
/**
 * \@whatItDoes Syncs a nested {\@link FormGroup} to a DOM element.
 *
 * \@howToUse
 *
 * This directive can only be used with a parent {\@link FormGroupDirective} (selector:
 * `[formGroup]`).
 *
 * It accepts the string name of the nested {\@link FormGroup} you want to link, and
 * will look for a {\@link FormGroup} registered with that name in the parent
 * {\@link FormGroup} instance you passed into {\@link FormGroupDirective}.
 *
 * Nested form groups can come in handy when you want to validate a sub-group of a
 * form separately from the rest or when you'd like to group the values of certain
 * controls into their own nested object.
 *
 * **Access the group**: You can access the associated {\@link FormGroup} using the
 * {\@link AbstractControl.get} method. Ex: `this.form.get('name')`.
 *
 * You can also access individual controls within the group using dot syntax.
 * Ex: `this.form.get('name.first')`
 *
 * **Get the value**: the `value` property is always synced and available on the
 * {\@link FormGroup}. See a full list of available properties in {\@link AbstractControl}.
 *
 * **Set the value**: You can set an initial value for each child control when instantiating
 * the {\@link FormGroup}, or you can set it programmatically later using
 * {\@link AbstractControl.setValue} or {\@link AbstractControl.patchValue}.
 *
 * **Listen to value**: If you want to listen to changes in the value of the group, you can
 * subscribe to the {\@link AbstractControl.valueChanges} event.  You can also listen to
 * {\@link AbstractControl.statusChanges} to be notified when the validation status is
 * re-calculated.
 *
 * ### Example
 *
 * {\@example forms/ts/nestedFormGroup/nested_form_group_example.ts region='Component'}
 *
 * * **npm package**: `\@angular/forms`
 *
 * * **NgModule**: `ReactiveFormsModule`
 *
 * \@stable
 */
var FormGroupName = (function (_super) {
    __extends(FormGroupName, _super);
    /**
     * @param {?} parent
     * @param {?} validators
     * @param {?} asyncValidators
     */
    function FormGroupName(parent, validators, asyncValidators) {
        var _this = _super.call(this) || this;
        _this._parent = parent;
        _this._validators = validators;
        _this._asyncValidators = asyncValidators;
        return _this;
    }
    /**
     * \@internal
     * @return {?}
     */
    FormGroupName.prototype._checkParentType = function () {
        if (_hasInvalidParent(this._parent)) {
            ReactiveErrors.groupParentException();
        }
    };
    return FormGroupName;
}(AbstractFormGroupDirective));
FormGroupName.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{ selector: '[formGroupName]', providers: [formGroupNameProvider] },] },
];
/**
 * @nocollapse
 */
FormGroupName.ctorParameters = function () { return [
    { type: ControlContainer, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Host"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["SkipSelf"] },] },
    { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [NG_VALIDATORS,] },] },
    { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [NG_ASYNC_VALIDATORS,] },] },
]; };
FormGroupName.propDecorators = {
    'name': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['formGroupName',] },],
};
var formArrayNameProvider = {
    provide: ControlContainer,
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return FormArrayName; })
};
/**
 * \@whatItDoes Syncs a nested {\@link FormArray} to a DOM element.
 *
 * \@howToUse
 *
 * This directive is designed to be used with a parent {\@link FormGroupDirective} (selector:
 * `[formGroup]`).
 *
 * It accepts the string name of the nested {\@link FormArray} you want to link, and
 * will look for a {\@link FormArray} registered with that name in the parent
 * {\@link FormGroup} instance you passed into {\@link FormGroupDirective}.
 *
 * Nested form arrays can come in handy when you have a group of form controls but
 * you're not sure how many there will be. Form arrays allow you to create new
 * form controls dynamically.
 *
 * **Access the array**: You can access the associated {\@link FormArray} using the
 * {\@link AbstractControl.get} method on the parent {\@link FormGroup}.
 * Ex: `this.form.get('cities')`.
 *
 * **Get the value**: the `value` property is always synced and available on the
 * {\@link FormArray}. See a full list of available properties in {\@link AbstractControl}.
 *
 * **Set the value**: You can set an initial value for each child control when instantiating
 * the {\@link FormArray}, or you can set the value programmatically later using the
 * {\@link FormArray}'s {\@link AbstractControl.setValue} or {\@link AbstractControl.patchValue}
 * methods.
 *
 * **Listen to value**: If you want to listen to changes in the value of the array, you can
 * subscribe to the {\@link FormArray}'s {\@link AbstractControl.valueChanges} event.  You can also
 * listen to its {\@link AbstractControl.statusChanges} event to be notified when the validation
 * status is re-calculated.
 *
 * **Add new controls**: You can add new controls to the {\@link FormArray} dynamically by
 * calling its {\@link FormArray.push} method.
 *  Ex: `this.form.get('cities').push(new FormControl());`
 *
 * ### Example
 *
 * {\@example forms/ts/nestedFormArray/nested_form_array_example.ts region='Component'}
 *
 * * **npm package**: `\@angular/forms`
 *
 * * **NgModule**: `ReactiveFormsModule`
 *
 * \@stable
 */
var FormArrayName = (function (_super) {
    __extends(FormArrayName, _super);
    /**
     * @param {?} parent
     * @param {?} validators
     * @param {?} asyncValidators
     */
    function FormArrayName(parent, validators, asyncValidators) {
        var _this = _super.call(this) || this;
        _this._parent = parent;
        _this._validators = validators;
        _this._asyncValidators = asyncValidators;
        return _this;
    }
    /**
     * @return {?}
     */
    FormArrayName.prototype.ngOnInit = function () {
        this._checkParentType(); /** @type {?} */
        ((this.formDirective)).addFormArray(this);
    };
    /**
     * @return {?}
     */
    FormArrayName.prototype.ngOnDestroy = function () {
        if (this.formDirective) {
            this.formDirective.removeFormArray(this);
        }
    };
    Object.defineProperty(FormArrayName.prototype, "control", {
        /**
         * @return {?}
         */
        get: function () { return ((this.formDirective)).getFormArray(this); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormArrayName.prototype, "formDirective", {
        /**
         * @return {?}
         */
        get: function () {
            return this._parent ? (this._parent.formDirective) : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormArrayName.prototype, "path", {
        /**
         * @return {?}
         */
        get: function () { return controlPath(this.name, this._parent); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormArrayName.prototype, "validator", {
        /**
         * @return {?}
         */
        get: function () { return composeValidators(this._validators); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormArrayName.prototype, "asyncValidator", {
        /**
         * @return {?}
         */
        get: function () {
            return composeAsyncValidators(this._asyncValidators);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    FormArrayName.prototype._checkParentType = function () {
        if (_hasInvalidParent(this._parent)) {
            ReactiveErrors.arrayParentException();
        }
    };
    return FormArrayName;
}(ControlContainer));
FormArrayName.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{ selector: '[formArrayName]', providers: [formArrayNameProvider] },] },
];
/**
 * @nocollapse
 */
FormArrayName.ctorParameters = function () { return [
    { type: ControlContainer, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Host"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["SkipSelf"] },] },
    { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [NG_VALIDATORS,] },] },
    { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [NG_ASYNC_VALIDATORS,] },] },
]; };
FormArrayName.propDecorators = {
    'name': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['formArrayName',] },],
};
/**
 * @param {?} parent
 * @return {?}
 */
function _hasInvalidParent(parent) {
    return !(parent instanceof FormGroupName) && !(parent instanceof FormGroupDirective) &&
        !(parent instanceof FormArrayName);
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var controlNameBinding = {
    provide: NgControl,
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return FormControlName; })
};
/**
 * \@whatItDoes Syncs a {\@link FormControl} in an existing {\@link FormGroup} to a form control
 * element by name.
 *
 * In other words, this directive ensures that any values written to the {\@link FormControl}
 * instance programmatically will be written to the DOM element (model -> view). Conversely,
 * any values written to the DOM element through user input will be reflected in the
 * {\@link FormControl} instance (view -> model).
 *
 * \@howToUse
 *
 * This directive is designed to be used with a parent {\@link FormGroupDirective} (selector:
 * `[formGroup]`).
 *
 * It accepts the string name of the {\@link FormControl} instance you want to
 * link, and will look for a {\@link FormControl} registered with that name in the
 * closest {\@link FormGroup} or {\@link FormArray} above it.
 *
 * **Access the control**: You can access the {\@link FormControl} associated with
 * this directive by using the {\@link AbstractControl.get} method.
 * Ex: `this.form.get('first');`
 *
 * **Get value**: the `value` property is always synced and available on the {\@link FormControl}.
 * See a full list of available properties in {\@link AbstractControl}.
 *
 *  **Set value**: You can set an initial value for the control when instantiating the
 *  {\@link FormControl}, or you can set it programmatically later using
 *  {\@link AbstractControl.setValue} or {\@link AbstractControl.patchValue}.
 *
 * **Listen to value**: If you want to listen to changes in the value of the control, you can
 * subscribe to the {\@link AbstractControl.valueChanges} event.  You can also listen to
 * {\@link AbstractControl.statusChanges} to be notified when the validation status is
 * re-calculated.
 *
 * ### Example
 *
 * In this example, we create form controls for first name and last name.
 *
 * {\@example forms/ts/simpleFormGroup/simple_form_group_example.ts region='Component'}
 *
 * To see `formControlName` examples with different form control types, see:
 *
 * * Radio buttons: {\@link RadioControlValueAccessor}
 * * Selects: {\@link SelectControlValueAccessor}
 *
 * **npm package**: `\@angular/forms`
 *
 * **NgModule**: {\@link ReactiveFormsModule}
 *
 *  \@stable
 */
var FormControlName = (function (_super) {
    __extends(FormControlName, _super);
    /**
     * @param {?} parent
     * @param {?} validators
     * @param {?} asyncValidators
     * @param {?} valueAccessors
     */
    function FormControlName(parent, validators, asyncValidators, valueAccessors) {
        var _this = _super.call(this) || this;
        _this._added = false;
        _this.update = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        _this._parent = parent;
        _this._rawValidators = validators || [];
        _this._rawAsyncValidators = asyncValidators || [];
        _this.valueAccessor = selectValueAccessor(_this, valueAccessors);
        return _this;
    }
    Object.defineProperty(FormControlName.prototype, "isDisabled", {
        /**
         * @param {?} isDisabled
         * @return {?}
         */
        set: function (isDisabled) { ReactiveErrors.disabledAttrWarning(); },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} changes
     * @return {?}
     */
    FormControlName.prototype.ngOnChanges = function (changes) {
        if (!this._added)
            this._setUpControl();
        if (isPropertyUpdated(changes, this.viewModel)) {
            this.viewModel = this.model;
            this.formDirective.updateModel(this, this.model);
        }
    };
    /**
     * @return {?}
     */
    FormControlName.prototype.ngOnDestroy = function () {
        if (this.formDirective) {
            this.formDirective.removeControl(this);
        }
    };
    /**
     * @param {?} newValue
     * @return {?}
     */
    FormControlName.prototype.viewToModelUpdate = function (newValue) {
        this.viewModel = newValue;
        this.update.emit(newValue);
    };
    Object.defineProperty(FormControlName.prototype, "path", {
        /**
         * @return {?}
         */
        get: function () { return controlPath(this.name, /** @type {?} */ ((this._parent))); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormControlName.prototype, "formDirective", {
        /**
         * @return {?}
         */
        get: function () { return this._parent ? this._parent.formDirective : null; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormControlName.prototype, "validator", {
        /**
         * @return {?}
         */
        get: function () { return composeValidators(this._rawValidators); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormControlName.prototype, "asyncValidator", {
        /**
         * @return {?}
         */
        get: function () {
            return ((composeAsyncValidators(this._rawAsyncValidators)));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FormControlName.prototype, "control", {
        /**
         * @return {?}
         */
        get: function () { return this._control; },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    FormControlName.prototype._checkParentType = function () {
        if (!(this._parent instanceof FormGroupName) &&
            this._parent instanceof AbstractFormGroupDirective) {
            ReactiveErrors.ngModelGroupException();
        }
        else if (!(this._parent instanceof FormGroupName) && !(this._parent instanceof FormGroupDirective) &&
            !(this._parent instanceof FormArrayName)) {
            ReactiveErrors.controlParentException();
        }
    };
    /**
     * @return {?}
     */
    FormControlName.prototype._setUpControl = function () {
        this._checkParentType();
        this._control = this.formDirective.addControl(this);
        if (this.control.disabled && ((this.valueAccessor)).setDisabledState) {
            ((((this.valueAccessor)).setDisabledState))(true);
        }
        this._added = true;
    };
    return FormControlName;
}(NgControl));
FormControlName.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{ selector: '[formControlName]', providers: [controlNameBinding] },] },
];
/**
 * @nocollapse
 */
FormControlName.ctorParameters = function () { return [
    { type: ControlContainer, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Host"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["SkipSelf"] },] },
    { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [NG_VALIDATORS,] },] },
    { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [NG_ASYNC_VALIDATORS,] },] },
    { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [NG_VALUE_ACCESSOR,] },] },
]; };
FormControlName.propDecorators = {
    'name': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['formControlName',] },],
    'model': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['ngModel',] },],
    'update': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"], args: ['ngModelChange',] },],
    'isDisabled': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['disabled',] },],
};
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var REQUIRED_VALIDATOR = {
    provide: NG_VALIDATORS,
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return RequiredValidator; }),
    multi: true
};
var CHECKBOX_REQUIRED_VALIDATOR = {
    provide: NG_VALIDATORS,
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return CheckboxRequiredValidator; }),
    multi: true
};
/**
 * A Directive that adds the `required` validator to any controls marked with the
 * `required` attribute, via the {\@link NG_VALIDATORS} binding.
 *
 * ### Example
 *
 * ```
 * <input name="fullName" ngModel required>
 * ```
 *
 * \@stable
 */
var RequiredValidator = (function () {
    function RequiredValidator() {
    }
    Object.defineProperty(RequiredValidator.prototype, "required", {
        /**
         * @return {?}
         */
        get: function () { return this._required; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._required = value != null && value !== false && "" + value !== 'false';
            if (this._onChange)
                this._onChange();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} c
     * @return {?}
     */
    RequiredValidator.prototype.validate = function (c) {
        return this.required ? Validators.required(c) : null;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    RequiredValidator.prototype.registerOnValidatorChange = function (fn) { this._onChange = fn; };
    return RequiredValidator;
}());
RequiredValidator.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                selector: ':not([type=checkbox])[required][formControlName],:not([type=checkbox])[required][formControl],:not([type=checkbox])[required][ngModel]',
                providers: [REQUIRED_VALIDATOR],
                host: { '[attr.required]': 'required ? "" : null' }
            },] },
];
/**
 * @nocollapse
 */
RequiredValidator.ctorParameters = function () { return []; };
RequiredValidator.propDecorators = {
    'required': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
};
/**
 * A Directive that adds the `required` validator to checkbox controls marked with the
 * `required` attribute, via the {\@link NG_VALIDATORS} binding.
 *
 * ### Example
 *
 * ```
 * <input type="checkbox" name="active" ngModel required>
 * ```
 *
 * \@experimental
 */
var CheckboxRequiredValidator = (function (_super) {
    __extends(CheckboxRequiredValidator, _super);
    function CheckboxRequiredValidator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @param {?} c
     * @return {?}
     */
    CheckboxRequiredValidator.prototype.validate = function (c) {
        return this.required ? Validators.requiredTrue(c) : null;
    };
    return CheckboxRequiredValidator;
}(RequiredValidator));
CheckboxRequiredValidator.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                selector: 'input[type=checkbox][required][formControlName],input[type=checkbox][required][formControl],input[type=checkbox][required][ngModel]',
                providers: [CHECKBOX_REQUIRED_VALIDATOR],
                host: { '[attr.required]': 'required ? "" : null' }
            },] },
];
/**
 * @nocollapse
 */
CheckboxRequiredValidator.ctorParameters = function () { return []; };
/**
 * Provider which adds {@link EmailValidator} to {@link NG_VALIDATORS}.
 */
var EMAIL_VALIDATOR = {
    provide: NG_VALIDATORS,
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return EmailValidator; }),
    multi: true
};
/**
 * A Directive that adds the `email` validator to controls marked with the
 * `email` attribute, via the {\@link NG_VALIDATORS} binding.
 *
 * ### Example
 *
 * ```
 * <input type="email" name="email" ngModel email>
 * <input type="email" name="email" ngModel email="true">
 * <input type="email" name="email" ngModel [email]="true">
 * ```
 *
 * \@experimental
 */
var EmailValidator = (function () {
    function EmailValidator() {
    }
    Object.defineProperty(EmailValidator.prototype, "email", {
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._enabled = value === '' || value === true || value === 'true';
            if (this._onChange)
                this._onChange();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} c
     * @return {?}
     */
    EmailValidator.prototype.validate = function (c) {
        return this._enabled ? Validators.email(c) : null;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    EmailValidator.prototype.registerOnValidatorChange = function (fn) { this._onChange = fn; };
    return EmailValidator;
}());
EmailValidator.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                selector: '[email][formControlName],[email][formControl],[email][ngModel]',
                providers: [EMAIL_VALIDATOR]
            },] },
];
/**
 * @nocollapse
 */
EmailValidator.ctorParameters = function () { return []; };
EmailValidator.propDecorators = {
    'email': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
};
/**
 * Provider which adds {@link MinLengthValidator} to {@link NG_VALIDATORS}.
 *
 * ## Example:
 *
 * {@example common/forms/ts/validators/validators.ts region='min'}
 */
var MIN_LENGTH_VALIDATOR = {
    provide: NG_VALIDATORS,
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return MinLengthValidator; }),
    multi: true
};
/**
 * A directive which installs the {\@link MinLengthValidator} for any `formControlName`,
 * `formControl`, or control with `ngModel` that also has a `minlength` attribute.
 *
 * \@stable
 */
var MinLengthValidator = (function () {
    function MinLengthValidator() {
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    MinLengthValidator.prototype.ngOnChanges = function (changes) {
        if ('minlength' in changes) {
            this._createValidator();
            if (this._onChange)
                this._onChange();
        }
    };
    /**
     * @param {?} c
     * @return {?}
     */
    MinLengthValidator.prototype.validate = function (c) {
        return this.minlength == null ? null : this._validator(c);
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    MinLengthValidator.prototype.registerOnValidatorChange = function (fn) { this._onChange = fn; };
    /**
     * @return {?}
     */
    MinLengthValidator.prototype._createValidator = function () {
        this._validator = Validators.minLength(parseInt(this.minlength, 10));
    };
    return MinLengthValidator;
}());
MinLengthValidator.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                selector: '[minlength][formControlName],[minlength][formControl],[minlength][ngModel]',
                providers: [MIN_LENGTH_VALIDATOR],
                host: { '[attr.minlength]': 'minlength ? minlength : null' }
            },] },
];
/**
 * @nocollapse
 */
MinLengthValidator.ctorParameters = function () { return []; };
MinLengthValidator.propDecorators = {
    'minlength': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
};
/**
 * Provider which adds {@link MaxLengthValidator} to {@link NG_VALIDATORS}.
 *
 * ## Example:
 *
 * {@example common/forms/ts/validators/validators.ts region='max'}
 */
var MAX_LENGTH_VALIDATOR = {
    provide: NG_VALIDATORS,
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return MaxLengthValidator; }),
    multi: true
};
/**
 * A directive which installs the {\@link MaxLengthValidator} for any `formControlName,
 * `formControl`,
 * or control with `ngModel` that also has a `maxlength` attribute.
 *
 * \@stable
 */
var MaxLengthValidator = (function () {
    function MaxLengthValidator() {
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    MaxLengthValidator.prototype.ngOnChanges = function (changes) {
        if ('maxlength' in changes) {
            this._createValidator();
            if (this._onChange)
                this._onChange();
        }
    };
    /**
     * @param {?} c
     * @return {?}
     */
    MaxLengthValidator.prototype.validate = function (c) {
        return this.maxlength != null ? this._validator(c) : null;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    MaxLengthValidator.prototype.registerOnValidatorChange = function (fn) { this._onChange = fn; };
    /**
     * @return {?}
     */
    MaxLengthValidator.prototype._createValidator = function () {
        this._validator = Validators.maxLength(parseInt(this.maxlength, 10));
    };
    return MaxLengthValidator;
}());
MaxLengthValidator.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                selector: '[maxlength][formControlName],[maxlength][formControl],[maxlength][ngModel]',
                providers: [MAX_LENGTH_VALIDATOR],
                host: { '[attr.maxlength]': 'maxlength ? maxlength : null' }
            },] },
];
/**
 * @nocollapse
 */
MaxLengthValidator.ctorParameters = function () { return []; };
MaxLengthValidator.propDecorators = {
    'maxlength': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
};
var PATTERN_VALIDATOR = {
    provide: NG_VALIDATORS,
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return PatternValidator; }),
    multi: true
};
/**
 * A Directive that adds the `pattern` validator to any controls marked with the
 * `pattern` attribute, via the {\@link NG_VALIDATORS} binding. Uses attribute value
 * as the regex to validate Control value against.  Follows pattern attribute
 * semantics; i.e. regex must match entire Control value.
 *
 * ### Example
 *
 * ```
 * <input [name]="fullName" pattern="[a-zA-Z ]*" ngModel>
 * ```
 * \@stable
 */
var PatternValidator = (function () {
    function PatternValidator() {
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    PatternValidator.prototype.ngOnChanges = function (changes) {
        if ('pattern' in changes) {
            this._createValidator();
            if (this._onChange)
                this._onChange();
        }
    };
    /**
     * @param {?} c
     * @return {?}
     */
    PatternValidator.prototype.validate = function (c) { return this._validator(c); };
    /**
     * @param {?} fn
     * @return {?}
     */
    PatternValidator.prototype.registerOnValidatorChange = function (fn) { this._onChange = fn; };
    /**
     * @return {?}
     */
    PatternValidator.prototype._createValidator = function () { this._validator = Validators.pattern(this.pattern); };
    return PatternValidator;
}());
PatternValidator.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                selector: '[pattern][formControlName],[pattern][formControl],[pattern][ngModel]',
                providers: [PATTERN_VALIDATOR],
                host: { '[attr.pattern]': 'pattern ? pattern : null' }
            },] },
];
/**
 * @nocollapse
 */
PatternValidator.ctorParameters = function () { return []; };
PatternValidator.propDecorators = {
    'pattern': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
};
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * \@whatItDoes Creates an {\@link AbstractControl} from a user-specified configuration.
 *
 * It is essentially syntactic sugar that shortens the `new FormGroup()`,
 * `new FormControl()`, and `new FormArray()` boilerplate that can build up in larger
 * forms.
 *
 * \@howToUse
 *
 * To use, inject `FormBuilder` into your component class. You can then call its methods
 * directly.
 *
 * {\@example forms/ts/formBuilder/form_builder_example.ts region='Component'}
 *
 *  * **npm package**: `\@angular/forms`
 *
 *  * **NgModule**: {\@link ReactiveFormsModule}
 *
 * \@stable
 */
var FormBuilder = (function () {
    function FormBuilder() {
    }
    /**
     * Construct a new {\@link FormGroup} with the given map of configuration.
     * Valid keys for the `extra` parameter map are `validator` and `asyncValidator`.
     *
     * See the {\@link FormGroup} constructor for more details.
     * @param {?} controlsConfig
     * @param {?=} extra
     * @return {?}
     */
    FormBuilder.prototype.group = function (controlsConfig, extra) {
        if (extra === void 0) { extra = null; }
        var /** @type {?} */ controls = this._reduceControls(controlsConfig);
        var /** @type {?} */ validator = extra != null ? extra['validator'] : null;
        var /** @type {?} */ asyncValidator = extra != null ? extra['asyncValidator'] : null;
        return new FormGroup(controls, validator, asyncValidator);
    };
    /**
     * Construct a new {\@link FormControl} with the given `formState`,`validator`, and
     * `asyncValidator`.
     *
     * `formState` can either be a standalone value for the form control or an object
     * that contains both a value and a disabled status.
     *
     * @param {?} formState
     * @param {?=} validator
     * @param {?=} asyncValidator
     * @return {?}
     */
    FormBuilder.prototype.control = function (formState, validator, asyncValidator) {
        return new FormControl(formState, validator, asyncValidator);
    };
    /**
     * Construct a {\@link FormArray} from the given `controlsConfig` array of
     * configuration, with the given optional `validator` and `asyncValidator`.
     * @param {?} controlsConfig
     * @param {?=} validator
     * @param {?=} asyncValidator
     * @return {?}
     */
    FormBuilder.prototype.array = function (controlsConfig, validator, asyncValidator) {
        var _this = this;
        var /** @type {?} */ controls = controlsConfig.map(function (c) { return _this._createControl(c); });
        return new FormArray(controls, validator, asyncValidator);
    };
    /**
     * \@internal
     * @param {?} controlsConfig
     * @return {?}
     */
    FormBuilder.prototype._reduceControls = function (controlsConfig) {
        var _this = this;
        var /** @type {?} */ controls = {};
        Object.keys(controlsConfig).forEach(function (controlName) {
            controls[controlName] = _this._createControl(controlsConfig[controlName]);
        });
        return controls;
    };
    /**
     * \@internal
     * @param {?} controlConfig
     * @return {?}
     */
    FormBuilder.prototype._createControl = function (controlConfig) {
        if (controlConfig instanceof FormControl || controlConfig instanceof FormGroup ||
            controlConfig instanceof FormArray) {
            return controlConfig;
        }
        else if (Array.isArray(controlConfig)) {
            var /** @type {?} */ value = controlConfig[0];
            var /** @type {?} */ validator = controlConfig.length > 1 ? controlConfig[1] : null;
            var /** @type {?} */ asyncValidator = controlConfig.length > 2 ? controlConfig[2] : null;
            return this.control(value, validator, asyncValidator);
        }
        else {
            return this.control(controlConfig);
        }
    };
    return FormBuilder;
}());
FormBuilder.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
];
/**
 * @nocollapse
 */
FormBuilder.ctorParameters = function () { return []; };
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @module
 * @description
 * Entry point for all public APIs of the common package.
 */
/**
 * \@stable
 */
var VERSION = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["Version"]('4.1.0');
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * \@whatItDoes Adds `novalidate` attribute to all forms by default.
 *
 * `novalidate` is used to disable browser's native form validation.
 *
 * If you want to use native validation with Angular forms, just add `ngNativeValidate` attribute:
 *
 * ```
 * <form ngNativeValidate></form>
 * ```
 *
 * \@experimental
 */
var NgNoValidate = (function () {
    function NgNoValidate() {
    }
    return NgNoValidate;
}());
NgNoValidate.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                selector: 'form:not([ngNoForm]):not([ngNativeValidate])',
                host: { 'novalidate': '' },
            },] },
];
/**
 * @nocollapse
 */
NgNoValidate.ctorParameters = function () { return []; };
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var SHARED_FORM_DIRECTIVES = [
    NgNoValidate,
    NgSelectOption,
    NgSelectMultipleOption,
    DefaultValueAccessor,
    NumberValueAccessor,
    RangeValueAccessor,
    CheckboxControlValueAccessor,
    SelectControlValueAccessor,
    SelectMultipleControlValueAccessor,
    RadioControlValueAccessor,
    NgControlStatus,
    NgControlStatusGroup,
    RequiredValidator,
    MinLengthValidator,
    MaxLengthValidator,
    PatternValidator,
    CheckboxRequiredValidator,
    EmailValidator,
];
var TEMPLATE_DRIVEN_DIRECTIVES = [NgModel, NgModelGroup, NgForm];
var REACTIVE_DRIVEN_DIRECTIVES = [FormControlDirective, FormGroupDirective, FormControlName, FormGroupName, FormArrayName];
/**
 * Internal module used for sharing directives between FormsModule and ReactiveFormsModule
 */
var InternalFormsSharedModule = (function () {
    function InternalFormsSharedModule() {
    }
    return InternalFormsSharedModule;
}());
InternalFormsSharedModule.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{
                declarations: SHARED_FORM_DIRECTIVES,
                exports: SHARED_FORM_DIRECTIVES,
            },] },
];
/**
 * @nocollapse
 */
InternalFormsSharedModule.ctorParameters = function () { return []; };
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * The ng module for forms.
 * \@stable
 */
var FormsModule = (function () {
    function FormsModule() {
    }
    return FormsModule;
}());
FormsModule.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{
                declarations: TEMPLATE_DRIVEN_DIRECTIVES,
                providers: [RadioControlRegistry],
                exports: [InternalFormsSharedModule, TEMPLATE_DRIVEN_DIRECTIVES]
            },] },
];
/**
 * @nocollapse
 */
FormsModule.ctorParameters = function () { return []; };
/**
 * The ng module for reactive forms.
 * \@stable
 */
var ReactiveFormsModule = (function () {
    function ReactiveFormsModule() {
    }
    return ReactiveFormsModule;
}());
ReactiveFormsModule.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{
                declarations: [REACTIVE_DRIVEN_DIRECTIVES],
                providers: [FormBuilder, RadioControlRegistry],
                exports: [InternalFormsSharedModule, REACTIVE_DRIVEN_DIRECTIVES]
            },] },
];
/**
 * @nocollapse
 */
ReactiveFormsModule.ctorParameters = function () { return []; };
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @module
 * @description
 * This module is used for handling user input, by defining and building a {@link FormGroup} that
 * consists of {@link FormControl} objects, and mapping them onto the DOM. {@link FormControl}
 * objects can then be used to read information from the form DOM elements.
 *
 * Forms providers are not included in default providers; you must import these providers
 * explicitly.
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @module
 * @description
 * Entry point for all public APIs of the forms package.
 */
// This file only reexports content of the `src` folder. Keep it that way.
/**
 * Generated bundle index. Do not edit.
 */

//# sourceMappingURL=forms.es5.js.map


/***/ }),

/***/ "NgUg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Observable_1 = __webpack_require__("rCTf");
function dispatch(state) {
    var obj = state.obj, keys = state.keys, length = state.length, index = state.index, subscriber = state.subscriber;
    if (index === length) {
        subscriber.complete();
        return;
    }
    var key = keys[index];
    subscriber.next([key, obj[key]]);
    state.index = index + 1;
    this.schedule(state);
}
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var PairsObservable = (function (_super) {
    __extends(PairsObservable, _super);
    function PairsObservable(obj, scheduler) {
        _super.call(this);
        this.obj = obj;
        this.scheduler = scheduler;
        this.keys = Object.keys(obj);
    }
    /**
     * Convert an object into an observable sequence of [key, value] pairs
     * using an optional IScheduler to enumerate the object.
     *
     * @example <caption>Converts a javascript object to an Observable</caption>
     * var obj = {
     *   foo: 42,
     *   bar: 56,
     *   baz: 78
     * };
     *
     * var source = Rx.Observable.pairs(obj);
     *
     * var subscription = source.subscribe(
     *   function (x) {
     *     console.log('Next: %s', x);
     *   },
     *   function (err) {
     *     console.log('Error: %s', err);
     *   },
     *   function () {
     *     console.log('Completed');
     *   });
     *
     * @param {Object} obj The object to inspect and turn into an
     * Observable sequence.
     * @param {Scheduler} [scheduler] An optional IScheduler to run the
     * enumeration of the input sequence on.
     * @returns {(Observable<Array<string | T>>)} An observable sequence of
     * [key, value] pairs from the object.
     */
    PairsObservable.create = function (obj, scheduler) {
        return new PairsObservable(obj, scheduler);
    };
    PairsObservable.prototype._subscribe = function (subscriber) {
        var _a = this, keys = _a.keys, scheduler = _a.scheduler;
        var length = keys.length;
        if (scheduler) {
            return scheduler.schedule(dispatch, 0, {
                obj: this.obj, keys: keys, length: length, index: 0, subscriber: subscriber
            });
        }
        else {
            for (var idx = 0; idx < length; idx++) {
                var key = keys[idx];
                subscriber.next([key, this.obj[key]]);
            }
            subscriber.complete();
        }
    };
    return PairsObservable;
}(Observable_1.Observable));
exports.PairsObservable = PairsObservable;
//# sourceMappingURL=PairsObservable.js.map

/***/ }),

/***/ "NqEB":
/***/ (function(module, exports) {

exports.config = {"status":true,"model":{"plazza":"true","title-en":"Hnefatafl","module":"tafl","js":["tafl-model.js"],"summary":"11x11 board (from Scandinavia)","thumbnail":"thumb-tafl-hnefatafl.png","rules":{"en":"rules-tafl-hnefatafl.html","fr":"rules-tafl-hnefatafl-fr.html"},"description":{"en":"description.html","fr":"description-fr.html"},"credits":{"en":"credits.html","fr":"credits-fr.html"},"gameOptions":{"preventRepeat":true,"uctTransposition":"states","levelOptions":{"attackersCountFactor":10,"defendersCountFactor":-10,"kingPathFactor":-20,"kingFreedomFactor":-0.1,"distKingFactor":-0.05},"exclude":[0,10,110,120],"attackers":1,"longMove":true,"initial":{"attackers":[3,4,5,6,7,16,33,44,55,66,77,56,43,54,65,76,87,64,113,114,115,116,117,104],"defenders":{"king":60,"soldiers":[38,48,49,50,58,59,61,62,70,71,72,82]}},"homeCatch":true,"privateHome":true,"centerDistance":5},"demoRandom":true,"visuals":["res/visuals/hnefatafl-600x600-3d.jpg","res/visuals/hnefatafl-600x600-2d.jpg"],"levels":[{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.65,"uncertaintyFactor":3,"useAlphaBeta":true,"name":"easy","label":"Easy","maxNodes":1000},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.65,"uncertaintyFactor":3,"useAlphaBeta":true,"name":"fast","label":"Fast [1sec]","maxDuration":1,"isDefault":true},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.65,"uncertaintyFactor":3,"useAlphaBeta":true,"name":"strong","label":"Strong","maxNodes":10000,"maxDuration":10}]},"view":{"title-en":"Tafl view","module":"tafl","js":["tafl-xd-view.js"],"xdView":true,"css":["tafl.css"],"preferredRatio":1,"switchable":true,"useShowMoves":false,"useNotation":true,"sounds":{"death1":"death1","death2":"death2","death3":"death3","move1":"move1","move3":"move3"},"defaultOptions":{"sounds":true,"moves":true,"notation":false},"skins":[{"name":"tafl3d","title":"3D Classic","3d":true,"camera":{"limitCamMoves":true,"radius":14,"rotationAngle":90,"elevationAngle":89.9,"elevationMin":2,"elevationMax":89.9},"world":{"lightIntensity":0.8,"skyLightIntensity":0.5,"lightCastShadow":false,"fog":false,"color":1118481,"lightPosition":{"x":10,"y":5,"z":0},"lightShadowDarkness":0.55,"ambientLightColor":4473924},"preload":["image|/res/xd-view/meshes/woodtoken-diffuse-black.jpg","image|/res/xd-view/meshes/woodtoken-diffuse.jpg","image|/res/images/ardriboard_bgx1024.jpg","image|/res/images/ardricellborders.png","image|/res/images/ardriblackcell.png","image|/res/images/ardrikingcell.png","image|/res/images/blackcell.png","image|/res/images/whitecell.png","smoothedfilegeo|0|/res/xd-view/meshes/taflboard.js","smoothedfilegeo|0|/res/xd-view/meshes/ring-target.js","smoothedfilegeo|0|/res/xd-view/meshes/woodtoken.js"]},{"name":"tafl2d","title":"2D Classic","3d":false,"preload":["image|/res/xd-view/meshes/ardri-sprites.png","image|/res/images/ardriboard_bgx1024.jpg","image|/res/images/ardricellborders.png","image|/res/images/ardriblackcell.png","image|/res/images/ardrikingcell.png","image|/res/images/blackcell.png","image|/res/images/whitecell.png"]}],"animateSelfMoves":false,"visuals":{"600x600":["res/visuals/hnefatafl-600x600-3d.jpg","res/visuals/hnefatafl-600x600-2d.jpg"]}}}

/***/ }),

/***/ "O/+v":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__("mmVS");
/**
 * Buffers the source Observable values until the size hits the maximum
 * `bufferSize` given.
 *
 * <span class="informal">Collects values from the past as an array, and emits
 * that array only when its size reaches `bufferSize`.</span>
 *
 * <img src="./img/bufferCount.png" width="100%">
 *
 * Buffers a number of values from the source Observable by `bufferSize` then
 * emits the buffer and clears it, and starts a new buffer each
 * `startBufferEvery` values. If `startBufferEvery` is not provided or is
 * `null`, then new buffers are started immediately at the start of the source
 * and when each buffer closes and is emitted.
 *
 * @example <caption>Emit the last two click events as an array</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var buffered = clicks.bufferCount(2);
 * buffered.subscribe(x => console.log(x));
 *
 * @example <caption>On every click, emit the last two click events as an array</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var buffered = clicks.bufferCount(2, 1);
 * buffered.subscribe(x => console.log(x));
 *
 * @see {@link buffer}
 * @see {@link bufferTime}
 * @see {@link bufferToggle}
 * @see {@link bufferWhen}
 * @see {@link pairwise}
 * @see {@link windowCount}
 *
 * @param {number} bufferSize The maximum size of the buffer emitted.
 * @param {number} [startBufferEvery] Interval at which to start a new buffer.
 * For example if `startBufferEvery` is `2`, then a new buffer will be started
 * on every other value from the source. A new buffer is started at the
 * beginning of the source by default.
 * @return {Observable<T[]>} An Observable of arrays of buffered values.
 * @method bufferCount
 * @owner Observable
 */
function bufferCount(bufferSize, startBufferEvery) {
    if (startBufferEvery === void 0) { startBufferEvery = null; }
    return this.lift(new BufferCountOperator(bufferSize, startBufferEvery));
}
exports.bufferCount = bufferCount;
var BufferCountOperator = (function () {
    function BufferCountOperator(bufferSize, startBufferEvery) {
        this.bufferSize = bufferSize;
        this.startBufferEvery = startBufferEvery;
        if (!startBufferEvery || bufferSize === startBufferEvery) {
            this.subscriberClass = BufferCountSubscriber;
        }
        else {
            this.subscriberClass = BufferSkipCountSubscriber;
        }
    }
    BufferCountOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new this.subscriberClass(subscriber, this.bufferSize, this.startBufferEvery));
    };
    return BufferCountOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var BufferCountSubscriber = (function (_super) {
    __extends(BufferCountSubscriber, _super);
    function BufferCountSubscriber(destination, bufferSize) {
        _super.call(this, destination);
        this.bufferSize = bufferSize;
        this.buffer = [];
    }
    BufferCountSubscriber.prototype._next = function (value) {
        var buffer = this.buffer;
        buffer.push(value);
        if (buffer.length == this.bufferSize) {
            this.destination.next(buffer);
            this.buffer = [];
        }
    };
    BufferCountSubscriber.prototype._complete = function () {
        var buffer = this.buffer;
        if (buffer.length > 0) {
            this.destination.next(buffer);
        }
        _super.prototype._complete.call(this);
    };
    return BufferCountSubscriber;
}(Subscriber_1.Subscriber));
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var BufferSkipCountSubscriber = (function (_super) {
    __extends(BufferSkipCountSubscriber, _super);
    function BufferSkipCountSubscriber(destination, bufferSize, startBufferEvery) {
        _super.call(this, destination);
        this.bufferSize = bufferSize;
        this.startBufferEvery = startBufferEvery;
        this.buffers = [];
        this.count = 0;
    }
    BufferSkipCountSubscriber.prototype._next = function (value) {
        var _a = this, bufferSize = _a.bufferSize, startBufferEvery = _a.startBufferEvery, buffers = _a.buffers, count = _a.count;
        this.count++;
        if (count % startBufferEvery === 0) {
            buffers.push([]);
        }
        for (var i = buffers.length; i--;) {
            var buffer = buffers[i];
            buffer.push(value);
            if (buffer.length === bufferSize) {
                buffers.splice(i, 1);
                this.destination.next(buffer);
            }
        }
    };
    BufferSkipCountSubscriber.prototype._complete = function () {
        var _a = this, buffers = _a.buffers, destination = _a.destination;
        while (buffers.length > 0) {
            var buffer = buffers.shift();
            if (buffer.length > 0) {
                destination.next(buffer);
            }
        }
        _super.prototype._complete.call(this);
    };
    return BufferSkipCountSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=bufferCount.js.map

/***/ }),

/***/ "O61y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_compiler__ = __webpack_require__("Uk0N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__("3j3K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_common__ = __webpack_require__("2Je8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__angular_platform_browser__ = __webpack_require__("Qbdm");
/* unused harmony export RESOURCE_CACHE_PROVIDER */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return platformBrowserDynamic; });
/* unused harmony export VERSION */
/* unused harmony export ɵINTERNAL_BROWSER_DYNAMIC_PLATFORM_PROVIDERS */
/* unused harmony export ɵResourceLoaderImpl */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * @license Angular v4.1.0
 * (c) 2010-2017 Google, Inc. https://angular.io/
 * License: MIT
 */




/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var ResourceLoaderImpl = (function (_super) {
    __extends(ResourceLoaderImpl, _super);
    function ResourceLoaderImpl() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ResourceLoaderImpl.prototype.get = function (url) {
        var resolve;
        var reject;
        var promise = new Promise(function (res, rej) {
            resolve = res;
            reject = rej;
        });
        var xhr = new XMLHttpRequest();
        xhr.open('GET', url, true);
        xhr.responseType = 'text';
        xhr.onload = function () {
            // responseText is the old-school way of retrieving response (supported by IE8 & 9)
            // response/responseType properties were introduced in ResourceLoader Level2 spec (supported
            // by IE10)
            var response = xhr.response || xhr.responseText;
            // normalize IE9 bug (http://bugs.jquery.com/ticket/1450)
            var status = xhr.status === 1223 ? 204 : xhr.status;
            // fix status code when it is 0 (0 status is undocumented).
            // Occurs when accessing file resources or on Android 4.1 stock browser
            // while retrieving files from application cache.
            if (status === 0) {
                status = response ? 200 : 0;
            }
            if (200 <= status && status <= 300) {
                resolve(response);
            }
            else {
                reject("Failed to load " + url);
            }
        };
        xhr.onerror = function () { reject("Failed to load " + url); };
        xhr.send();
        return promise;
    };
    return ResourceLoaderImpl;
}(__WEBPACK_IMPORTED_MODULE_0__angular_compiler__["a" /* ResourceLoader */]));
ResourceLoaderImpl.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Injectable"] },
];
/** @nocollapse */
ResourceLoaderImpl.ctorParameters = function () { return []; };
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var INTERNAL_BROWSER_DYNAMIC_PLATFORM_PROVIDERS = [
    __WEBPACK_IMPORTED_MODULE_3__angular_platform_browser__["ɵINTERNAL_BROWSER_PLATFORM_PROVIDERS"],
    {
        provide: __WEBPACK_IMPORTED_MODULE_1__angular_core__["COMPILER_OPTIONS"],
        useValue: { providers: [{ provide: __WEBPACK_IMPORTED_MODULE_0__angular_compiler__["a" /* ResourceLoader */], useClass: ResourceLoaderImpl }] },
        multi: true
    },
    { provide: __WEBPACK_IMPORTED_MODULE_1__angular_core__["PLATFORM_ID"], useValue: __WEBPACK_IMPORTED_MODULE_2__angular_common__["ɵPLATFORM_BROWSER_ID"] },
];
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * An implementation of ResourceLoader that uses a template cache to avoid doing an actual
 * ResourceLoader.
 *
 * The template cache needs to be built and loaded into window.$templateCache
 * via a separate mechanism.
 */
var CachedResourceLoader = (function (_super) {
    __extends(CachedResourceLoader, _super);
    function CachedResourceLoader() {
        var _this = _super.call(this) || this;
        _this._cache = __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵglobal"].$templateCache;
        if (_this._cache == null) {
            throw new Error('CachedResourceLoader: Template cache was not found in $templateCache.');
        }
        return _this;
    }
    CachedResourceLoader.prototype.get = function (url) {
        if (this._cache.hasOwnProperty(url)) {
            return Promise.resolve(this._cache[url]);
        }
        else {
            return Promise.reject('CachedResourceLoader: Did not find cached template for ' + url);
        }
    };
    return CachedResourceLoader;
}(__WEBPACK_IMPORTED_MODULE_0__angular_compiler__["a" /* ResourceLoader */]));
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @module
 * @description
 * Entry point for all public APIs of the common package.
 */
/**
 * @stable
 */
var VERSION = new __WEBPACK_IMPORTED_MODULE_1__angular_core__["Version"]('4.1.0');
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @experimental
 */
var RESOURCE_CACHE_PROVIDER = [{ provide: __WEBPACK_IMPORTED_MODULE_0__angular_compiler__["a" /* ResourceLoader */], useClass: CachedResourceLoader }];
/**
 * @stable
 */
var platformBrowserDynamic = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["createPlatformFactory"])(__WEBPACK_IMPORTED_MODULE_0__angular_compiler__["b" /* platformCoreDynamic */], 'browserDynamic', INTERNAL_BROWSER_DYNAMIC_PLATFORM_PROVIDERS);
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @module
 * @description
 * Entry point for all public APIs of the platform-browser-dynamic package.
 */
// This file only reexports content of the `src` folder. Keep it that way.

//# sourceMappingURL=platform-browser-dynamic.es5.js.map


/***/ }),

/***/ "O8p4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var race_1 = __webpack_require__("Y3yw");
Observable_1.Observable.race = race_1.raceStatic;
//# sourceMappingURL=race.js.map

/***/ }),

/***/ "OBRl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("3j3K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__match_media__ = __webpack_require__("LuwH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__media_monitor__ = __webpack_require__("bWt6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__observable_media_provider__ = __webpack_require__("pcn9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__breakpoints_break_points_provider__ = __webpack_require__("r666");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__breakpoints_break_point_registry__ = __webpack_require__("eZjk");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MediaQueriesModule; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */






/**
 * *****************************************************************
 * Define module for the MediaQuery API
 * *****************************************************************
 */
var MediaQueriesModule = (function () {
    function MediaQueriesModule() {
    }
    return MediaQueriesModule;
}());

MediaQueriesModule.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{
                providers: [
                    __WEBPACK_IMPORTED_MODULE_4__breakpoints_break_points_provider__["a" /* DEFAULT_BREAKPOINTS_PROVIDER */],
                    __WEBPACK_IMPORTED_MODULE_5__breakpoints_break_point_registry__["a" /* BreakPointRegistry */],
                    __WEBPACK_IMPORTED_MODULE_1__match_media__["a" /* MatchMedia */],
                    __WEBPACK_IMPORTED_MODULE_2__media_monitor__["a" /* MediaMonitor */],
                    __WEBPACK_IMPORTED_MODULE_3__observable_media_provider__["a" /* OBSERVABLE_MEDIA_PROVIDER */] // easy subscription injectable `media$` matchMedia observable
                ]
            },] },
];
/** @nocollapse */
MediaQueriesModule.ctorParameters = function () { return []; };
//# sourceMappingURL=_module.js.map

/***/ }),

/***/ "OErT":
/***/ (function(module, exports) {

exports.config = {"status":true,"model":{"js":["reversi-model.js"],"plazza":"true","released":1409239768,"title-en":"Annexation Cross 10","module":"reversi","summary":"Reversi/Othello rules on a 10x10 cross-shaped board","thumbnail":"thumb-cross10.png","rules":{"en":"rules-cross10.html"},"credits":{"en":"credits.html"},"description":{"en":"description.html"},"gameOptions":{"preventRepeat":true,"uctTransposition":"state","levelOptions":{"stableFactor":20,"aboutStableFactor":-20,"aboutStableBorderFactor":-15,"borderFactor":5,"aboutBorderFactor":-4,"countFactor":1,"mobilityFactor":5},"width":10,"height":10,"deadCells":{"0:0":"#","0:1":"#","0:2":"#","1:0":"#","1:1":"#","1:2":"#","2:0":"#","2:1":"#","2:2":"#","7:0":"#","7:1":"#","7:2":"#","8:0":"#","8:1":"#","8:2":"#","9:0":"#","9:1":"#","9:2":"#","0:7":"#","0:8":"#","0:9":"#","1:7":"#","1:8":"#","1:9":"#","2:7":"#","2:8":"#","2:9":"#","7:7":"#","7:8":"#","7:9":"#","8:7":"#","8:8":"#","8:9":"#","9:7":"#","9:8":"#","9:9":"#"},"initial":{"1":["4:5","5:4"],"-1":["5:5","4:4"]}},"debugEval":true,"levels":[{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.65,"ignoreLeaf":false,"log":true,"uncertaintyFactor":3,"name":"easy","label":"Easy","maxNodes":1000},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.65,"ignoreLeaf":false,"log":true,"uncertaintyFactor":3,"name":"fast","label":"Fast [1sec]","maxDuration":1,"isDefault":true},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.65,"ignoreLeaf":false,"log":true,"uncertaintyFactor":3,"name":"medium","label":"Medium","maxNodes":10000,"maxDuration":10},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.65,"ignoreLeaf":false,"log":true,"uncertaintyFactor":3,"name":"strong","label":"Strong","maxNodes":20000,"maxDuration":15}]},"view":{"title-en":"Annex View","js":["reversi-xd-view.js"],"xdView":true,"useNotation":true,"useShowMoves":true,"module":"reversi","skins":[{"name":"classic3d","title":"3D Classic","3d":true,"camera":{"radius":14,"elevationAngle":45,"distMax":39.5,"distMin":10.1,"elevationMin":-89.9,"elevationMax":89.9,"limitCamMoves":true,"fov":45},"world":{"lightIntensity":0.7,"skyLightIntensity":0.3,"lightPosition":{"x":10,"y":18,"z":0},"lightShadowDarkness":0.35,"color":4686804,"ambientLightColor":5592405,"fog":false},"preload":["image|/res/xd-view/pass-dark.png","image|/res/xd-view/pass-light.png","image|/res/images/wood-chipboard-5.jpg","image|/res/xd-view/reversi-pieces-2-textures.png","image|/res/xd-view/reversi-pieces-2-textures-bump.png","smoothedfilegeo|0|/res/xd-view/ring-target.js","smoothedfilegeo|0|/res/xd-view/reversi-pieces-6.js"]},{"name":"classic2d","title":"2D Classic","preload":["image|/res/xd-view/pass-dark.png","image|/res/xd-view/pass-light.png","image|/res/xd-view/boardtexture.jpg","image|/res/xd-view/cellshadows.png","image|/res/xd-view/sprites.png","image|/res/xd-view/select-target-2d.png"]}],"visuals":{"600x600":["res/visuals/cross10-600x600-3d.jpg","res/visuals/cross10-600x600-2d.jpg"]}}}

/***/ }),

/***/ "OLzJ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var root_1 = __webpack_require__("VOfZ");
var RequestAnimationFrameDefinition = (function () {
    function RequestAnimationFrameDefinition(root) {
        if (root.requestAnimationFrame) {
            this.cancelAnimationFrame = root.cancelAnimationFrame.bind(root);
            this.requestAnimationFrame = root.requestAnimationFrame.bind(root);
        }
        else if (root.mozRequestAnimationFrame) {
            this.cancelAnimationFrame = root.mozCancelAnimationFrame.bind(root);
            this.requestAnimationFrame = root.mozRequestAnimationFrame.bind(root);
        }
        else if (root.webkitRequestAnimationFrame) {
            this.cancelAnimationFrame = root.webkitCancelAnimationFrame.bind(root);
            this.requestAnimationFrame = root.webkitRequestAnimationFrame.bind(root);
        }
        else if (root.msRequestAnimationFrame) {
            this.cancelAnimationFrame = root.msCancelAnimationFrame.bind(root);
            this.requestAnimationFrame = root.msRequestAnimationFrame.bind(root);
        }
        else if (root.oRequestAnimationFrame) {
            this.cancelAnimationFrame = root.oCancelAnimationFrame.bind(root);
            this.requestAnimationFrame = root.oRequestAnimationFrame.bind(root);
        }
        else {
            this.cancelAnimationFrame = root.clearTimeout.bind(root);
            this.requestAnimationFrame = function (cb) { return root.setTimeout(cb, 1000 / 60); };
        }
    }
    return RequestAnimationFrameDefinition;
}());
exports.RequestAnimationFrameDefinition = RequestAnimationFrameDefinition;
exports.AnimationFrame = new RequestAnimationFrameDefinition(root_1.root);
//# sourceMappingURL=AnimationFrame.js.map

/***/ }),

/***/ "OMJi":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var formatRegExp = /%[sdj%]/g;
exports.format = function(f) {
  if (!isString(f)) {
    var objects = [];
    for (var i = 0; i < arguments.length; i++) {
      objects.push(inspect(arguments[i]));
    }
    return objects.join(' ');
  }

  var i = 1;
  var args = arguments;
  var len = args.length;
  var str = String(f).replace(formatRegExp, function(x) {
    if (x === '%%') return '%';
    if (i >= len) return x;
    switch (x) {
      case '%s': return String(args[i++]);
      case '%d': return Number(args[i++]);
      case '%j':
        try {
          return JSON.stringify(args[i++]);
        } catch (_) {
          return '[Circular]';
        }
      default:
        return x;
    }
  });
  for (var x = args[i]; i < len; x = args[++i]) {
    if (isNull(x) || !isObject(x)) {
      str += ' ' + x;
    } else {
      str += ' ' + inspect(x);
    }
  }
  return str;
};


// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
exports.deprecate = function(fn, msg) {
  // Allow for deprecating things in the process of starting up.
  if (isUndefined(global.process)) {
    return function() {
      return exports.deprecate(fn, msg).apply(this, arguments);
    };
  }

  if (process.noDeprecation === true) {
    return fn;
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (process.throwDeprecation) {
        throw new Error(msg);
      } else if (process.traceDeprecation) {
        console.trace(msg);
      } else {
        console.error(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
};


var debugs = {};
var debugEnviron;
exports.debuglog = function(set) {
  if (isUndefined(debugEnviron))
    debugEnviron = process.env.NODE_DEBUG || '';
  set = set.toUpperCase();
  if (!debugs[set]) {
    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
      var pid = process.pid;
      debugs[set] = function() {
        var msg = exports.format.apply(exports, arguments);
        console.error('%s %d: %s', set, pid, msg);
      };
    } else {
      debugs[set] = function() {};
    }
  }
  return debugs[set];
};


/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */
/* legacy: obj, showHidden, depth, colors*/
function inspect(obj, opts) {
  // default options
  var ctx = {
    seen: [],
    stylize: stylizeNoColor
  };
  // legacy...
  if (arguments.length >= 3) ctx.depth = arguments[2];
  if (arguments.length >= 4) ctx.colors = arguments[3];
  if (isBoolean(opts)) {
    // legacy...
    ctx.showHidden = opts;
  } else if (opts) {
    // got an "options" object
    exports._extend(ctx, opts);
  }
  // set default options
  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
  if (isUndefined(ctx.depth)) ctx.depth = 2;
  if (isUndefined(ctx.colors)) ctx.colors = false;
  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
  if (ctx.colors) ctx.stylize = stylizeWithColor;
  return formatValue(ctx, obj, ctx.depth);
}
exports.inspect = inspect;


// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
inspect.colors = {
  'bold' : [1, 22],
  'italic' : [3, 23],
  'underline' : [4, 24],
  'inverse' : [7, 27],
  'white' : [37, 39],
  'grey' : [90, 39],
  'black' : [30, 39],
  'blue' : [34, 39],
  'cyan' : [36, 39],
  'green' : [32, 39],
  'magenta' : [35, 39],
  'red' : [31, 39],
  'yellow' : [33, 39]
};

// Don't use 'blue' not visible on cmd.exe
inspect.styles = {
  'special': 'cyan',
  'number': 'yellow',
  'boolean': 'yellow',
  'undefined': 'grey',
  'null': 'bold',
  'string': 'green',
  'date': 'magenta',
  // "name": intentionally not styling
  'regexp': 'red'
};


function stylizeWithColor(str, styleType) {
  var style = inspect.styles[styleType];

  if (style) {
    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
           '\u001b[' + inspect.colors[style][1] + 'm';
  } else {
    return str;
  }
}


function stylizeNoColor(str, styleType) {
  return str;
}


function arrayToHash(array) {
  var hash = {};

  array.forEach(function(val, idx) {
    hash[val] = true;
  });

  return hash;
}


function formatValue(ctx, value, recurseTimes) {
  // Provide a hook for user-specified inspect functions.
  // Check that value is an object with an inspect function on it
  if (ctx.customInspect &&
      value &&
      isFunction(value.inspect) &&
      // Filter out the util module, it's inspect function is special
      value.inspect !== exports.inspect &&
      // Also filter out any prototype objects using the circular check.
      !(value.constructor && value.constructor.prototype === value)) {
    var ret = value.inspect(recurseTimes, ctx);
    if (!isString(ret)) {
      ret = formatValue(ctx, ret, recurseTimes);
    }
    return ret;
  }

  // Primitive types cannot have properties
  var primitive = formatPrimitive(ctx, value);
  if (primitive) {
    return primitive;
  }

  // Look up the keys of the object.
  var keys = Object.keys(value);
  var visibleKeys = arrayToHash(keys);

  if (ctx.showHidden) {
    keys = Object.getOwnPropertyNames(value);
  }

  // IE doesn't make error fields non-enumerable
  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
  if (isError(value)
      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
    return formatError(value);
  }

  // Some type of object without properties can be shortcutted.
  if (keys.length === 0) {
    if (isFunction(value)) {
      var name = value.name ? ': ' + value.name : '';
      return ctx.stylize('[Function' + name + ']', 'special');
    }
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    }
    if (isDate(value)) {
      return ctx.stylize(Date.prototype.toString.call(value), 'date');
    }
    if (isError(value)) {
      return formatError(value);
    }
  }

  var base = '', array = false, braces = ['{', '}'];

  // Make Array say that they are Array
  if (isArray(value)) {
    array = true;
    braces = ['[', ']'];
  }

  // Make functions say that they are functions
  if (isFunction(value)) {
    var n = value.name ? ': ' + value.name : '';
    base = ' [Function' + n + ']';
  }

  // Make RegExps say that they are RegExps
  if (isRegExp(value)) {
    base = ' ' + RegExp.prototype.toString.call(value);
  }

  // Make dates with properties first say the date
  if (isDate(value)) {
    base = ' ' + Date.prototype.toUTCString.call(value);
  }

  // Make error with message first say the error
  if (isError(value)) {
    base = ' ' + formatError(value);
  }

  if (keys.length === 0 && (!array || value.length == 0)) {
    return braces[0] + base + braces[1];
  }

  if (recurseTimes < 0) {
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    } else {
      return ctx.stylize('[Object]', 'special');
    }
  }

  ctx.seen.push(value);

  var output;
  if (array) {
    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
  } else {
    output = keys.map(function(key) {
      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
  }

  ctx.seen.pop();

  return reduceToSingleString(output, base, braces);
}


function formatPrimitive(ctx, value) {
  if (isUndefined(value))
    return ctx.stylize('undefined', 'undefined');
  if (isString(value)) {
    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
                                             .replace(/'/g, "\\'")
                                             .replace(/\\"/g, '"') + '\'';
    return ctx.stylize(simple, 'string');
  }
  if (isNumber(value))
    return ctx.stylize('' + value, 'number');
  if (isBoolean(value))
    return ctx.stylize('' + value, 'boolean');
  // For some reason typeof null is "object", so special case here.
  if (isNull(value))
    return ctx.stylize('null', 'null');
}


function formatError(value) {
  return '[' + Error.prototype.toString.call(value) + ']';
}


function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
  var output = [];
  for (var i = 0, l = value.length; i < l; ++i) {
    if (hasOwnProperty(value, String(i))) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          String(i), true));
    } else {
      output.push('');
    }
  }
  keys.forEach(function(key) {
    if (!key.match(/^\d+$/)) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          key, true));
    }
  });
  return output;
}


function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
  var name, str, desc;
  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
  if (desc.get) {
    if (desc.set) {
      str = ctx.stylize('[Getter/Setter]', 'special');
    } else {
      str = ctx.stylize('[Getter]', 'special');
    }
  } else {
    if (desc.set) {
      str = ctx.stylize('[Setter]', 'special');
    }
  }
  if (!hasOwnProperty(visibleKeys, key)) {
    name = '[' + key + ']';
  }
  if (!str) {
    if (ctx.seen.indexOf(desc.value) < 0) {
      if (isNull(recurseTimes)) {
        str = formatValue(ctx, desc.value, null);
      } else {
        str = formatValue(ctx, desc.value, recurseTimes - 1);
      }
      if (str.indexOf('\n') > -1) {
        if (array) {
          str = str.split('\n').map(function(line) {
            return '  ' + line;
          }).join('\n').substr(2);
        } else {
          str = '\n' + str.split('\n').map(function(line) {
            return '   ' + line;
          }).join('\n');
        }
      }
    } else {
      str = ctx.stylize('[Circular]', 'special');
    }
  }
  if (isUndefined(name)) {
    if (array && key.match(/^\d+$/)) {
      return str;
    }
    name = JSON.stringify('' + key);
    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
      name = name.substr(1, name.length - 2);
      name = ctx.stylize(name, 'name');
    } else {
      name = name.replace(/'/g, "\\'")
                 .replace(/\\"/g, '"')
                 .replace(/(^"|"$)/g, "'");
      name = ctx.stylize(name, 'string');
    }
  }

  return name + ': ' + str;
}


function reduceToSingleString(output, base, braces) {
  var numLinesEst = 0;
  var length = output.reduce(function(prev, cur) {
    numLinesEst++;
    if (cur.indexOf('\n') >= 0) numLinesEst++;
    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
  }, 0);

  if (length > 60) {
    return braces[0] +
           (base === '' ? '' : base + '\n ') +
           ' ' +
           output.join(',\n  ') +
           ' ' +
           braces[1];
  }

  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}


// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
function isArray(ar) {
  return Array.isArray(ar);
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return isObject(re) && objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return isObject(d) && objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return isObject(e) &&
      (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = __webpack_require__("fC4T");

function objectToString(o) {
  return Object.prototype.toString.call(o);
}


function pad(n) {
  return n < 10 ? '0' + n.toString(10) : n.toString(10);
}


var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
              'Oct', 'Nov', 'Dec'];

// 26 Feb 16:19:34
function timestamp() {
  var d = new Date();
  var time = [pad(d.getHours()),
              pad(d.getMinutes()),
              pad(d.getSeconds())].join(':');
  return [d.getDate(), months[d.getMonth()], time].join(' ');
}


// log is just a thin wrapper to console.log that prepends a timestamp
exports.log = function() {
  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
};


/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */
exports.inherits = __webpack_require__("LC74");

exports._extend = function(origin, add) {
  // Don't do anything if add isn't an object
  if (!add || !isObject(add)) return origin;

  var keys = Object.keys(add);
  var i = keys.length;
  while (i--) {
    origin[keys[i]] = add[keys[i]];
  }
  return origin;
};

function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("DuR2"), __webpack_require__("W2nU")))

/***/ }),

/***/ "OP7f":
/***/ (function(module, exports) {

exports.config = {"status":true,"model":{"plazza":"true","title-en":"Turkish Draughts","module":"checkers","maxLevel":20,"summary":"A 8x8 checkers on straight lines.","thumbnail":"turkish-thumb3d.png","rules":"rules-turkish-draughts.html","description":"description.html","credits":"credits-turkish-draughts.html","js":["checkersbase-model.js","turkish-model.js"],"gameOptions":{"preventRepeat":true,"width":8,"height":8,"initial":{"a":[[1,0],[1,1],[1,2],[1,3],[1,4],[1,5],[1,6],[1,7],[2,0],[2,1],[2,2],[2,3],[2,4],[2,5],[2,6],[2,7]],"b":[[6,0],[6,1],[6,2],[6,3],[6,4],[6,5],[6,6],[6,7],[5,0],[5,1],[5,2],[5,3],[5,4],[5,5],[5,6],[5,7]]},"variant":{"lastRowCrown":true,"mustMoveForward":true,"kingCaptureShort":false,"captureInstantRemove":true,"captureLongestLine":true,"canCaptureBackward":false},"uctTransposition":"state"},"levels":[{"label":"Fast","ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.5,"maxDuration":1,"isDefault":true},{"label":"Beginner","ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.5,"maxDuration":0.5,"maxNodes":100,"maxLoops":200},{"label":"Easy","ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.5,"maxDuration":1,"maxNodes":2500,"maxLoops":500},{"label":"Medium","ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.5,"maxDuration":2,"maxNodes":5500,"maxLoops":500},{"label":"Hard","ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.5,"maxDuration":5,"maxNodes":2000,"maxLoops":3500},{"label":"Expert","ai":"uct","c":0.8,"playoutDepth":0,"minVisitsExpand":1,"ignoreLeaf":false,"uncertaintyFactor":5,"propagateMultiVisits":false,"maxDuration":60,"maxNodes":15000,"maxLoops":8000}]},"view":{"js":["checkers-xd-view.js","turkish-xd-view.js"],"visuals":{"600x600":["res/visuals/turkish-draughts-600x600-3d.jpg","res/visuals/turkish-draughts-600x600-2d.jpg"]},"xdView":true,"css":["checkersbase.css","turkish.css"],"title-en":"Turkish Draughts View","module":"checkers","preferredRatio":1,"skins":[{"name":"turkish3d","title":"3D Classic","3d":true,"camera":{"radius":14,"elevationAngle":45,"limitCamMoves":true},"world":{"lightIntensity":0.8,"color":0,"fog":false,"lightPosition":{"x":-10,"y":18,"z":0},"ambientLightColor":0},"preload":["image|/res/images/wood-chipboard-5.jpg","smoothedfilegeo|0|/res/xd-view/meshes/ring-target.js","smoothedfilegeo|0|/res/xd-view/meshes/turkish.js","smoothedfilegeo|0|/res/xd-view/meshes/turkish-queen.js"]},{"name":"green","title":"Green"},{"name":"wood0","title":"Wood"},{"name":"marble0","title":"Marble"},{"name":"classical","title":"Classic"}],"sounds":{"move1":"move1","move2":"move2","move3":"move3","move4":"move4","tac1":"tac1","tac2":"tac1","tac3":"tac1","promo":"promo","usermove":null},"switchable":true,"animateSelfMoves":false,"useNotation":true,"useShowMoves":true,"defaultOptions":{"sounds":true,"notation":false,"moves":true}}}

/***/ }),

/***/ "OQqQ":
/***/ (function(module, exports) {

exports.config = {"status":true,"model":{"plazza":"true","released":1396536978,"title-en":"Shako","module":"chessbase","summary":"10x10 Chess","thumbnail":"shako-thumb.png","rules":{"en":"shako-rules.html","fr":"shako-rules-fr.html"},"credits":{"en":"shako-credits.html","fr":"shako-credits-fr.html"},"gameOptions":{"preventRepeat":true,"uctTransposition":"state","uctIgnoreLoop":false,"levelOptions":{"pieceValueFactor":1,"pieceValueRatioFactor":1,"posValueFactor":0.1,"averageDistKingFactor":-0.01,"castleFactor":0.1,"minorPiecesMovedFactor":0.1,"checkFactor":0.2,"endingKingFreedomFactor":0.01,"endingDistKingFactor":0.05,"distKingCornerFactor":0.1}},"js":["base-model.js","grid-geo-model.js","shako-model.js"],"description":{"en":"shako-description.html","fr":"shako-description-fr.html"},"levels":[{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"easy","label":"Easy","maxNodes":6000},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"fast","label":"Fast [3sec]","maxDuration":3,"isDefault":true},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"medium","label":"Medium","maxNodes":30000,"maxDuration":30},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"strong","label":"Strong","maxNodes":60000,"maxDuration":45}]},"view":{"title-en":"Chessbase view","module":"chessbase","xdView":true,"css":["chessbase.css"],"preferredRatio":1,"useShowMoves":true,"useNotation":true,"useAutoComplete":true,"defaultOptions":{"sounds":true,"moves":true,"notation":false,"autocomplete":false},"skins":[{"name":"skin3d","title":"3D Classic","3d":true,"preload":["smoothedfilegeo|0|/res/ring-target.js","image|/res/images/cancel.png","image|/res/images/wikipedia.png"],"world":{"lightIntensity":1.3,"skyLightIntensity":1.2,"lightCastShadow":true,"fog":false,"color":4686804,"lightPosition":{"x":-9,"y":9,"z":9},"skyLightPosition":{"x":9,"y":9,"z":9},"lightShadowDarkness":0.55,"ambientLightColor":2236962},"camera":{"fov":45,"distMax":50,"radius":18,"elevationAngle":60,"elevationMin":0}},{"name":"skin2d","title":"2D Classic","3d":false,"preload":["image|/res/images/cancel.png","image|/res/images/whitebg.png","image|/res/images/wikipedia.png"]}],"animateSelfMoves":false,"switchable":true,"sounds":{"move1":"alq_move1","move2":"alq_move2","move3":"alq_move3","move4":"alq_move2","tac1":"alq_tac1","tac2":"alq_tac2","tac3":"alq_tac1","promo":"promo","usermove":null},"js":["base-view.js","grid-board-view.js","fairy-set-view.js","shako-view.js"],"visuals":{"600x600":["res/visuals/shako-600x600-3d.jpg","res/visuals/shako-600x600-2d.jpg"]}}}

/***/ }),

/***/ "Oa+j":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__("mmVS");
/**
 * Converts an Observable of {@link Notification} objects into the emissions
 * that they represent.
 *
 * <span class="informal">Unwraps {@link Notification} objects as actual `next`,
 * `error` and `complete` emissions. The opposite of {@link materialize}.</span>
 *
 * <img src="./img/dematerialize.png" width="100%">
 *
 * `dematerialize` is assumed to operate an Observable that only emits
 * {@link Notification} objects as `next` emissions, and does not emit any
 * `error`. Such Observable is the output of a `materialize` operation. Those
 * notifications are then unwrapped using the metadata they contain, and emitted
 * as `next`, `error`, and `complete` on the output Observable.
 *
 * Use this operator in conjunction with {@link materialize}.
 *
 * @example <caption>Convert an Observable of Notifications to an actual Observable</caption>
 * var notifA = new Rx.Notification('N', 'A');
 * var notifB = new Rx.Notification('N', 'B');
 * var notifE = new Rx.Notification('E', void 0,
 *   new TypeError('x.toUpperCase is not a function')
 * );
 * var materialized = Rx.Observable.of(notifA, notifB, notifE);
 * var upperCase = materialized.dematerialize();
 * upperCase.subscribe(x => console.log(x), e => console.error(e));
 *
 * // Results in:
 * // A
 * // B
 * // TypeError: x.toUpperCase is not a function
 *
 * @see {@link Notification}
 * @see {@link materialize}
 *
 * @return {Observable} An Observable that emits items and notifications
 * embedded in Notification objects emitted by the source Observable.
 * @method dematerialize
 * @owner Observable
 */
function dematerialize() {
    return this.lift(new DeMaterializeOperator());
}
exports.dematerialize = dematerialize;
var DeMaterializeOperator = (function () {
    function DeMaterializeOperator() {
    }
    DeMaterializeOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new DeMaterializeSubscriber(subscriber));
    };
    return DeMaterializeOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var DeMaterializeSubscriber = (function (_super) {
    __extends(DeMaterializeSubscriber, _super);
    function DeMaterializeSubscriber(destination) {
        _super.call(this, destination);
    }
    DeMaterializeSubscriber.prototype._next = function (value) {
        value.observe(this.destination);
    };
    return DeMaterializeSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=dematerialize.js.map

/***/ }),

/***/ "Ou9t":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var root_1 = __webpack_require__("VOfZ");
function minimalSetImpl() {
    // THIS IS NOT a full impl of Set, this is just the minimum
    // bits of functionality we need for this library.
    return (function () {
        function MinimalSet() {
            this._values = [];
        }
        MinimalSet.prototype.add = function (value) {
            if (!this.has(value)) {
                this._values.push(value);
            }
        };
        MinimalSet.prototype.has = function (value) {
            return this._values.indexOf(value) !== -1;
        };
        Object.defineProperty(MinimalSet.prototype, "size", {
            get: function () {
                return this._values.length;
            },
            enumerable: true,
            configurable: true
        });
        MinimalSet.prototype.clear = function () {
            this._values.length = 0;
        };
        return MinimalSet;
    }());
}
exports.minimalSetImpl = minimalSetImpl;
exports.Set = root_1.root.Set || minimalSetImpl();
//# sourceMappingURL=Set.js.map

/***/ }),

/***/ "P3oE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isArray_1 = __webpack_require__("Xajo");
function isNumeric(val) {
    // parseFloat NaNs numeric-cast false positives (null|true|false|"")
    // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
    // subtraction forces infinities to NaN
    // adding 1 corrects loss of precision from parseFloat (#15100)
    return !isArray_1.isArray(val) && (val - parseFloat(val) + 1) >= 0;
}
exports.isNumeric = isNumeric;
;
//# sourceMappingURL=isNumeric.js.map

/***/ }),

/***/ "PKvP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var FromObservable_1 = __webpack_require__("JkZN");
exports.from = FromObservable_1.FromObservable.create;
//# sourceMappingURL=from.js.map

/***/ }),

/***/ "PMZt":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var throttle_1 = __webpack_require__("u/VN");
Observable_1.Observable.prototype.throttle = throttle_1.throttle;
//# sourceMappingURL=throttle.js.map

/***/ }),

/***/ "PN3d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var BehaviorSubject_1 = __webpack_require__("TfWX");
var multicast_1 = __webpack_require__("emOw");
/**
 * @param value
 * @return {ConnectableObservable<T>}
 * @method publishBehavior
 * @owner Observable
 */
function publishBehavior(value) {
    return multicast_1.multicast.call(this, new BehaviorSubject_1.BehaviorSubject(value));
}
exports.publishBehavior = publishBehavior;
//# sourceMappingURL=publishBehavior.js.map

/***/ }),

/***/ "POFt":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__("mmVS");
var ArgumentOutOfRangeError_1 = __webpack_require__("8Z8y");
var EmptyObservable_1 = __webpack_require__("jBEF");
/**
 * Emits only the first `count` values emitted by the source Observable.
 *
 * <span class="informal">Takes the first `count` values from the source, then
 * completes.</span>
 *
 * <img src="./img/take.png" width="100%">
 *
 * `take` returns an Observable that emits only the first `count` values emitted
 * by the source Observable. If the source emits fewer than `count` values then
 * all of its values are emitted. After that, it completes, regardless if the
 * source completes.
 *
 * @example <caption>Take the first 5 seconds of an infinite 1-second interval Observable</caption>
 * var interval = Rx.Observable.interval(1000);
 * var five = interval.take(5);
 * five.subscribe(x => console.log(x));
 *
 * @see {@link takeLast}
 * @see {@link takeUntil}
 * @see {@link takeWhile}
 * @see {@link skip}
 *
 * @throws {ArgumentOutOfRangeError} When using `take(i)`, it delivers an
 * ArgumentOutOrRangeError to the Observer's `error` callback if `i < 0`.
 *
 * @param {number} count The maximum number of `next` values to emit.
 * @return {Observable<T>} An Observable that emits only the first `count`
 * values emitted by the source Observable, or all of the values from the source
 * if the source emits fewer than `count` values.
 * @method take
 * @owner Observable
 */
function take(count) {
    if (count === 0) {
        return new EmptyObservable_1.EmptyObservable();
    }
    else {
        return this.lift(new TakeOperator(count));
    }
}
exports.take = take;
var TakeOperator = (function () {
    function TakeOperator(total) {
        this.total = total;
        if (this.total < 0) {
            throw new ArgumentOutOfRangeError_1.ArgumentOutOfRangeError;
        }
    }
    TakeOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new TakeSubscriber(subscriber, this.total));
    };
    return TakeOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var TakeSubscriber = (function (_super) {
    __extends(TakeSubscriber, _super);
    function TakeSubscriber(destination, total) {
        _super.call(this, destination);
        this.total = total;
        this.count = 0;
    }
    TakeSubscriber.prototype._next = function (value) {
        var total = this.total;
        var count = ++this.count;
        if (count <= total) {
            this.destination.next(value);
            if (count === total) {
                this.destination.complete();
                this.unsubscribe();
            }
        }
    };
    return TakeSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=take.js.map

/***/ }),

/***/ "PPle":
/***/ (function(module, exports) {

exports.config = {"status":true,"model":{"plazza":"true","released":1398790818,"title-en":"Brusky Chess","module":"chessbase","summary":"Hexagonal Chess","thumbnail":"brusky-thumb.png","rules":{"en":"brusky-rules.html"},"credits":{"en":"brusky-credits.html"},"gameOptions":{"preventRepeat":true,"uctTransposition":"state","uctIgnoreLoop":false,"levelOptions":{"pieceValueFactor":1,"pieceValueRatioFactor":1,"posValueFactor":0.1,"averageDistKingFactor":-0.01,"castleFactor":0.1,"minorPiecesMovedFactor":0.1,"checkFactor":0.2,"endingKingFreedomFactor":0.01,"endingDistKingFactor":0.05,"distKingCornerFactor":0.1,"distPawnPromo1Factor":0.3,"distPawnPromo2Factor":0.1,"distPawnPromo3Factor":0.05}},"obsolete":false,"js":["base-model.js","hex-geo-model.js","brusky-model.js"],"description":{"en":"brusky-description.html"},"levels":[{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"easy","label":"Easy","maxNodes":6000},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"fast","label":"Fast [3sec]","maxDuration":3,"isDefault":true},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"medium","label":"Medium","maxNodes":30000,"maxDuration":30},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"strong","label":"Strong","maxNodes":60000,"maxDuration":45}]},"view":{"title-en":"Chessbase view","module":"chessbase","xdView":true,"css":["chessbase.css","hex.css"],"preferredRatio":1.7,"useShowMoves":true,"useNotation":true,"useAutoComplete":true,"defaultOptions":{"sounds":true,"moves":true,"notation":false,"autocomplete":false},"skins":[{"name":"skin3d","title":"3D Classic","3d":true,"preload":[],"world":{"lightIntensity":1.3,"skyLightIntensity":1.2,"lightCastShadow":true,"fog":false,"color":4686804,"lightPosition":{"x":-9,"y":9,"z":9},"skyLightPosition":{"x":9,"y":9,"z":9},"lightShadowDarkness":0.55,"ambientLightColor":2236962},"camera":{"fov":45,"distMax":50,"radius":13.5,"elevationAngle":45,"elevationMin":0,"distMin":0}},{"name":"skin2d","title":"2D Classic","3d":false,"preload":["image|/res/images/wikipedia.png","image|/res/images/whitebg.png","image|/res/images/cancel.png"]}],"animateSelfMoves":false,"switchable":true,"sounds":{"move1":"alq_move1","move2":"alq_move2","move3":"alq_move3","move4":"alq_move2","tac1":"alq_tac1","tac2":"alq_tac2","tac3":"alq_tac1","promo":"promo","usermove":null},"js":["base-view.js","hex-board-view.js","staunton-set-view.js","brusky-view.js"],"visuals":{"600x600":["res/visuals/brusky-600x600-3d.jpg","res/visuals/brusky-600x600-2d.jpg"]}}}

/***/ }),

/***/ "PXjH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MediaChange; });
/**
 * Class instances emitted [to observers] for each mql notification
 */
var MediaChange = (function () {
    function MediaChange(matches, // Is the mq currently activated
        mediaQuery, // e.g.   (min-width: 600px) and (max-width: 959px)
        mqAlias, // e.g.   gt-sm, md, gt-lg
        suffix // e.g.   GtSM, Md, GtLg
    ) {
        if (matches === void 0) { matches = false; }
        if (mediaQuery === void 0) { mediaQuery = 'all'; }
        if (mqAlias === void 0) { mqAlias = ''; }
        if (suffix === void 0) { suffix = ''; } // e.g.   GtSM, Md, GtLg
        this.matches = matches;
        this.mediaQuery = mediaQuery;
        this.mqAlias = mqAlias;
        this.suffix = suffix; // e.g.   GtSM, Md, GtLg
    }
    MediaChange.prototype.clone = function () {
        return new MediaChange(this.matches, this.mediaQuery, this.mqAlias, this.suffix);
    };
    return MediaChange;
}());

//# sourceMappingURL=media-change.js.map

/***/ }),

/***/ "PYcI":
/***/ (function(module, exports) {

exports.config = {"status":true,"model":{"plazza":"true","title-en":"Ardri","module":"tafl","js":["tafl-model.js"],"summary":"7x7 board (from Scotland)","thumbnail":"thumb-tafl-ardri.png","rules":{"en":"rules-tafl-ardri.html","fr":"rules-tafl-ardri-fr.html"},"description":{"en":"description.html","fr":"description-fr.html"},"credits":{"en":"credits.html","fr":"credits-fr.html"},"gameOptions":{"preventRepeat":true,"uctTransposition":"states","levelOptions":{"attackersCountFactor":10,"defendersCountFactor":-10,"kingPathFactor":-20,"kingFreedomFactor":-0.1,"distKingFactor":-0.05},"exclude":[0,6,42,48],"attackers":-1,"longMove":false,"initial":{"attackers":[2,3,4,10,14,21,28,22,20,27,34,26,44,45,46,38],"defenders":{"king":24,"soldiers":[16,17,18,23,25,30,31,32]}},"homeCatch":true,"privateHome":true,"centerDistance":3},"demoRandom":true,"visuals":["res/visuals/ardri-600x600-3d.jpg","res/visuals/ardri-600x600-2d.jpg"],"levels":[{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.65,"uncertaintyFactor":3,"useAlphaBeta":true,"name":"easy","label":"Easy","maxNodes":1000},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.65,"uncertaintyFactor":3,"useAlphaBeta":true,"name":"fast","label":"Fast [1sec]","maxDuration":1,"isDefault":true},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.65,"uncertaintyFactor":3,"useAlphaBeta":true,"name":"strong","label":"Strong","maxNodes":10000,"maxDuration":10}]},"view":{"title-en":"Tafl view","module":"tafl","js":["tafl-xd-view.js"],"xdView":true,"css":["tafl.css"],"preferredRatio":1,"switchable":true,"useShowMoves":false,"useNotation":true,"sounds":{"death1":"death1","death2":"death2","death3":"death3","move1":"move1","move3":"move3"},"defaultOptions":{"sounds":true,"moves":true,"notation":false},"skins":[{"name":"tafl3d","title":"3D Classic","3d":true,"camera":{"limitCamMoves":true,"radius":14,"rotationAngle":90,"elevationAngle":89.9,"elevationMin":2,"elevationMax":89.9},"world":{"lightIntensity":0.8,"skyLightIntensity":0.5,"lightCastShadow":false,"fog":false,"color":1118481,"lightPosition":{"x":10,"y":5,"z":0},"lightShadowDarkness":0.55,"ambientLightColor":4473924},"preload":["image|/res/xd-view/meshes/woodtoken-diffuse-black.jpg","image|/res/xd-view/meshes/woodtoken-diffuse.jpg","image|/res/images/ardriboard_bgx1024.jpg","image|/res/images/ardricellborders.png","image|/res/images/ardriblackcell.png","image|/res/images/ardrikingcell.png","image|/res/images/blackcell.png","image|/res/images/whitecell.png","smoothedfilegeo|0|/res/xd-view/meshes/taflboard.js","smoothedfilegeo|0|/res/xd-view/meshes/ring-target.js","smoothedfilegeo|0|/res/xd-view/meshes/woodtoken.js"]},{"name":"tafl2d","title":"2D Classic","3d":false,"preload":["image|/res/xd-view/meshes/ardri-sprites.png","image|/res/images/ardriboard_bgx1024.jpg","image|/res/images/ardricellborders.png","image|/res/images/ardriblackcell.png","image|/res/images/ardrikingcell.png","image|/res/images/blackcell.png","image|/res/images/whitecell.png"]}],"animateSelfMoves":false,"visuals":{"600x600":["res/visuals/ardri-600x600-3d.jpg","res/visuals/ardri-600x600-2d.jpg"]}}}

/***/ }),

/***/ "PutI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var AsyncAction_1 = __webpack_require__("cwzr");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var QueueAction = (function (_super) {
    __extends(QueueAction, _super);
    function QueueAction(scheduler, work) {
        _super.call(this, scheduler, work);
        this.scheduler = scheduler;
        this.work = work;
    }
    QueueAction.prototype.schedule = function (state, delay) {
        if (delay === void 0) { delay = 0; }
        if (delay > 0) {
            return _super.prototype.schedule.call(this, state, delay);
        }
        this.delay = delay;
        this.state = state;
        this.scheduler.flush(this);
        return this;
    };
    QueueAction.prototype.execute = function (state, delay) {
        return (delay > 0 || this.closed) ?
            _super.prototype.execute.call(this, state, delay) :
            this._execute(state, delay);
    };
    QueueAction.prototype.requestAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) { delay = 0; }
        // If delay exists and is greater than 0, or if the delay is null (the
        // action wasn't rescheduled) but was originally scheduled as an async
        // action, then recycle as an async action.
        if ((delay !== null && delay > 0) || (delay === null && this.delay > 0)) {
            return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
        }
        // Otherwise flush the scheduler starting with this action.
        return scheduler.flush(this);
    };
    return QueueAction;
}(AsyncAction_1.AsyncAction));
exports.QueueAction = QueueAction;
//# sourceMappingURL=QueueAction.js.map

/***/ }),

/***/ "PvYY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var publishReplay_1 = __webpack_require__("0gHg");
Observable_1.Observable.prototype.publishReplay = publishReplay_1.publishReplay;
//# sourceMappingURL=publishReplay.js.map

/***/ }),

/***/ "PwiB":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var windowTime_1 = __webpack_require__("sKQ8");
Observable_1.Observable.prototype.windowTime = windowTime_1.windowTime;
//# sourceMappingURL=windowTime.js.map

/***/ }),

/***/ "Pzlm":
/***/ (function(module, exports) {

exports.config = {"status":true,"model":{"plazza":"true","title-en":"12 Men´s Morris Fly","module":"mills","maxLevel":7,"summary":"An old board game","thumbnail":"mensmorris12-thumb3d.png","rules":"rules.html","description":"description.html","credits":"credits.html","js":["mills-model.js","12-men-morris-model.js"],"gameOptions":{"preventRepeat":true,"width":7,"height":7,"mencount":12,"canFly":true},"levels":[{"label":"Easy","maxDepth":2,"potential":100,"placingRace":1,"isDefault":true},{"label":"Medium","maxDepth":4,"potential":300,"placingRace":1},{"label":"Hard","maxDepth":8,"potential":1000,"placingRace":2}]},"view":{"js":["mills-xd-view.js","12-men-morris-view.js"],"visuals":{"600x600":["res/visuals/twelvemen-600x600-3d.jpg","res/visuals/twelvemen-600x600-2d.jpg"]},"xdView":true,"css":["mills.css","12-men-morris.css"],"title-en":"12 Men´s Morris View","module":"mills","preferredRatio":1.2857142857143,"switchable":true,"animateSelfMoves":false,"useNotation":true,"useShowMoves":true,"defaultOptions":{"sounds":true,"notation":false,"moves":true},"sounds":{"move1":"move1","move2":"move2","move3":"move3","move4":"move4","tac1":"tac1","tac2":"tac2","tac3":"tac3","capture":"promo","usermove":null},"skins":[{"name":"classic3d","title":"3D Classic","3d":true,"camera":{"radius":14,"elevationAngle":45,"distMax":39.5,"distMin":10.1,"elevationMin":-89.9,"elevationMax":89.9,"limitCamMoves":true},"world":{"lightIntensity":0.6,"skyLightIntensity":0.3,"lightPosition":{"x":0,"y":18,"z":0},"color":0,"fog":false},"preload":["image|/res/xd-view/meshes/woodcell1x512.jpg","image|/res/xd-view/meshes/piecetop-bump.jpg","image|/res/xd-view/meshes/piecediff.jpg","smoothedfilegeo|0|/res/xd-view/meshes/piece-v2.js","smoothedfilegeo|0|/res/xd-view/meshes/boardoriented.js","smoothedfilegeo|0|/res/xd-view/meshes/ring-target.js"]},{"name":"stone","title":"Stone"},{"name":"suede","title":"Suede"},{"name":"wood","title":"Wood"}]}}

/***/ }),

/***/ "Q0je":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Observable_1 = __webpack_require__("rCTf");
var noop_1 = __webpack_require__("YOd+");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var NeverObservable = (function (_super) {
    __extends(NeverObservable, _super);
    function NeverObservable() {
        _super.call(this);
    }
    /**
     * Creates an Observable that emits no items to the Observer.
     *
     * <span class="informal">An Observable that never emits anything.</span>
     *
     * <img src="./img/never.png" width="100%">
     *
     * This static operator is useful for creating a simple Observable that emits
     * neither values nor errors nor the completion notification. It can be used
     * for testing purposes or for composing with other Observables. Please not
     * that by never emitting a complete notification, this Observable keeps the
     * subscription from being disposed automatically. Subscriptions need to be
     * manually disposed.
     *
     * @example <caption>Emit the number 7, then never emit anything else (not even complete).</caption>
     * function info() {
     *   console.log('Will not be called');
     * }
     * var result = Rx.Observable.never().startWith(7);
     * result.subscribe(x => console.log(x), info, info);
     *
     * @see {@link create}
     * @see {@link empty}
     * @see {@link of}
     * @see {@link throw}
     *
     * @return {Observable} A "never" Observable: never emits anything.
     * @static true
     * @name never
     * @owner Observable
     */
    NeverObservable.create = function () {
        return new NeverObservable();
    };
    NeverObservable.prototype._subscribe = function (subscriber) {
        noop_1.noop();
    };
    return NeverObservable;
}(Observable_1.Observable));
exports.NeverObservable = NeverObservable;
//# sourceMappingURL=NeverObservable.js.map

/***/ }),

/***/ "QIAk":
/***/ (function(module, exports) {

exports.model=Model={Game:{},Board:{},Move:{}},function(){var t;Model.Game.cbConstants={MASK:65535,FLAG_MOVE:65536,FLAG_CAPTURE:131072,FLAG_STOP:262144,FLAG_SCREEN_CAPTURE:524288,FLAG_CAPTURE_KING:1048576,FLAG_CAPTURE_NO_KING:2097152};var e="undefined"!=typeof Int32Array;Model.Game.cbUseTypedArrays=e,Model.Game.cbTypedArray=function(t){if(e){var r=new Int32Array(t.length);return r.set(t),r}for(var i=[],a=t.length,s=0;s<a;s++)i.push(t[s]);return i},Model.Game.cbShortRangeGraph=function(t,e,r,i){var a=this;void 0===i&&(i=196608);for(var s={},n=0;n<t.boardSize;n++)s[n]=[],(!r||n in r)&&e.forEach(function(e){var o=t.Graph(n,e);null!=o&&(!r||o in r)&&s[n].push(a.cbTypedArray([o|i]))});return s},Model.Game.cbLongRangeGraph=function(t,e,r,i,a){var s=this;void 0!==i&&null!=i||(i=196608),a||(a=1/0);for(var n={},o=0;o<t.boardSize;o++)n[o]=[],(!r||o in r)&&e.forEach(function(e){for(var h=[],p=t.Graph(o,e),c=0;null!=p&&(!r||p in r)&&(h.push(p|i),++c!=a);)p=t.Graph(p,e);h.length>0&&n[o].push(s.cbTypedArray(h))});return n},Model.Game.cbNullGraph=function(t){for(var e={},r=0;r<t.boardSize;r++)e[r]=[];return e},Model.Game.cbAuthorGraph=function(t){for(var e={},r=0;r<t.boardSize;r++){e[r]=[];for(var i=0;i<t.boardSize;i++)e[r].push([2293760|i])}return e},Model.Game.cbMergeGraphs=function(t){for(var e=[],r=0;r<t.boardSize;r++){e[r]=[];for(var i=1;i<arguments.length;i++)e[r]=e[r].concat(arguments[i][r])}return e},Model.Game.cbGetThreatGraph=function(){function t(e,r){for(var i in n){var a=n[i];if(!(a.p.length<r.length+1)){for(var s=!0,o=0;o<r.length;o++)if(r[o]!=a.p[o]){s=!1;break}if(s){var h=a.p[r.length],p=e[h];void 0===p&&(p={e:{}},e[h]=p),a.p.length==r.length+1&&(p.t=a.t,p.ts=a.ts,p.tk=a.tk,delete n[i]),r.push(h),t(p.e,r),r.pop()}}}}var e=this;this.cbUseScreenCapture=!1,this.cbUseCaptureKing=!1,this.cbUseCaptureNoKing=!1;for(var r={1:[],"-1":[]},i=[],a=0;a<this.g.boardSize;a++)this.g.pTypes.forEach(function(t,r){t.graph[a].forEach(function(t){for(var s=[],n=0;n<t.length;n++){var o=t[n];1048576&o?(e.cbUseCaptureKing=!0,s.unshift({d:65535&o,a:a,tk:r})):2097152&o?(e.cbUseCaptureNoKing=!0,s.unshift({d:65535&o,a:a,tnk:r})):131072&o?s.unshift({d:65535&o,a:a,t:r}):262144&o?s.unshift({d:65535&o,a:a}):524288&o&&(e.cbUseScreenCapture=!0,s.unshift({d:65535&o,a:a,ts:r}))}s.length>0&&i.push(s)})});var s={};i.forEach(function(t){t.forEach(function(e,r){var i=s[e.d];void 0===i&&(i={},s[e.d]=i);for(var a=[],n=r+1;n<t.length;n++)a.push(t[n].d);a.push(e.a);var o=a.join(","),h=i[o];void 0===h&&(h={p:a,t:{},ts:{},tk:{}},i[o]=h),void 0!==e.t?h.t[e.t]=!0:void 0!==e.tk?h.tk[e.tk]=!0:void 0!==e.ts&&(h.ts[e.ts]=!0)})});for(var a=0;a<e.g.boardSize;a++){var n=s[a],o={};t(o,[]),r[1][a]=o,r[-1][a]=o}return r},Model.Game.InitGame=function(){var e=this;this.cbVar=t=this.cbDefine(),this.g.boardSize=this.cbVar.geometry.boardSize,this.g.pTypes=this.cbGetPieceTypes(),this.g.threatGraph=this.cbGetThreatGraph(),this.g.distGraph=this.cbVar.geometry.GetDistances(),this.cbPiecesCount=0,this.g.castleablePiecesCount={1:0,"-1":0};for(var r in t.pieceTypes){var i=t.pieceTypes[r];if(i.castle){(i.initial||[]).forEach(function(t){e.g.castleablePiecesCount[t.s]++})}i.initial&&(this.cbPiecesCount+=i.initial.length)}for(var a=[],r=0;r<this.cbPiecesCount;r++)a.push(r);var s=Object.keys(t.pieceTypes);this.zobrist=new JocGame.Zobrist({board:{type:"array",size:this.cbVar.geometry.boardSize,values:a},who:{values:["1","-1"]},type:{type:"array",size:this.cbPiecesCount,values:s}})},Model.Game.cbGetPieceTypes=function(){for(var t=[],e={},r=0;r<this.cbVar.geometry.boardSize;r++)e[r]=[];for(var i in this.cbVar.pieceTypes){var a=this.cbVar.pieceTypes[i];t[i]={graph:a.graph||e,abbrev:a.abbrev||"",value:a.isKing?100:a.value||1,isKing:!!a.isKing,castle:!!a.castle,epTarget:!!a.epTarget,epCatch:!!a.epCatch}}return t},Model.Board.Init=function(t){this.zSign=0},Model.Board.InitialPosition=function(r){var i=this;this.board=e?new Int16Array(r.g.boardSize):[];for(var a=0;a<r.g.boardSize;a++)this.board[a]=-1;if(this.kings={},this.pieces=[],this.ending={1:!1,"-1":!1},this.lastMove=null,r.cbVar.castle&&(this.castled={1:!1,"-1":!1}),this.zSign=r.zobrist.update(0,"who",-1),this.noCaptCount=0,this.mWho=1,r.mInitial)this.mWho=r.mInitial.turn||1,r.mInitial.pieces.forEach(function(t){var e={};for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);i.pieces.push(e)}),r.mInitial.lastMove&&(this.lastMove={f:r.mInitial.lastMove.f,t:r.mInitial.lastMove.t}),void 0!==r.mInitial.noCaptCount&&(this.noCaptCount=r.mInitial.noCaptCount),r.cbVar.castle&&r.mInitial.castle&&(this.castled={1:{k:!!r.mInitial.castle[1]&&!!r.mInitial.castle[1].k,q:!!r.mInitial.castle[1]&&!!r.mInitial.castle[1].q},"-1":{k:!!r.mInitial.castle[-1]&&!!r.mInitial.castle[-1].k,q:!!r.mInitial.castle[-1]&&!!r.mInitial.castle[-1].q}});else for(var s in r.cbVar.pieceTypes)for(var n=r.cbVar.pieceTypes[s],o=n.initial||[],h=0;h<o.length;h++){var p=o[h],c={s:p.s,t:parseInt(s),p:p.p,m:!1};this.pieces.push(c)}if(this.pieces.sort(function(t,e){if(t.s!=e.s)return e.s-t.s;var i=r.cbVar.pieceTypes[t.t].value||100,a=r.cbVar.pieceTypes[e.t].value||100;return i!=a?i-a:t.p-e.p}),this.pieces.forEach(function(t,e){t.i=e,i.board[t.p]=e,r.g.pTypes[t.t].isKing&&(i.kings[t.s]=t.p),i.zSign=r.zobrist.update(i.zSign,"board",e,t.p),i.zSign=r.zobrist.update(i.zSign,"type",t.t,e)}),r.mInitial&&r.mInitial.enPassant){var a=t.geometry.PosByName(r.mInitial.enPassant);if(a>=0){var l,u=t.geometry.C(a),v=t.geometry.R(a);l=1==r.mInitial.turn?t.geometry.POS(u,v-1):t.geometry.POS(u,v+1),this.epTarget={p:a,i:this.board[l]}}}},Model.Board.CopyFrom=function(t){if(e)this.board=new Int16Array(t.board.length),this.board.set(t.board);else{this.board=[];for(var r=t.board,i=r.length,a=0;a<i;a++)this.board.push(r[a])}this.pieces=[];for(var s=t.pieces.length,a=0;a<s;a++){var n=t.pieces[a];this.pieces.push({s:n.s,p:n.p,t:n.t,i:n.i,m:n.m})}this.kings={1:t.kings[1],"-1":t.kings[-1]},this.check=t.check,t.lastMove?this.lastMove={f:t.lastMove.f,t:t.lastMove.t,c:t.lastMove.c}:this.lastMove=null,this.ending={1:t.ending[1],"-1":t.ending[-1]},void 0!==t.castled&&(this.castled={1:t.castled[1],"-1":t.castled[-1]}),this.noCaptCount=t.noCaptCount,t.epTarget?this.epTarget={p:t.epTarget.p,i:t.epTarget.i}:this.epTarget=null,this.mWho=t.mWho,this.zSign=t.zSign},Model.Board.cbApplyCastle=function(t,e,r){var i=t.cbVar.castle[e.f+"/"+e.cg],a=i.r[i.r.length-1],s=this.pieces[this.board[e.cg]],n=i.k[i.k.length-1],o=this.pieces[this.board[e.f]];return r&&(this.zSign=t.zobrist.update(this.zSign,"board",s.i,e.cg),this.zSign=t.zobrist.update(this.zSign,"board",s.i,a),this.zSign=t.zobrist.update(this.zSign,"board",o.i,e.f),this.zSign=t.zobrist.update(this.zSign,"board",o.i,n)),s.p=a,s.m=!0,this.board[e.cg]=-1,o.p=n,o.m=!0,this.board[e.f]=-1,this.board[a]=s.i,this.board[n]=o.i,this.castled[s.s]=!0,this.kings[o.s]=n,[{i:s.i,f:a,t:-1},{i:o.i,f:n,t:e.f,kp:e.f,who:o.s,m:!1},{i:s.i,f:-1,t:e.cg,m:!1,cg:!1}]},Model.Board.cbQuickApply=function(t,e){if(void 0!==e.cg)return this.cbApplyCastle(t,e,!1);var r=[],i=this.board[e.f],a=this.pieces[i];if(null!=e.c){r.unshift({i:e.c,f:-1,t:this.pieces[e.c].p});var s=this.pieces[e.c];this.board[s.p]=-1,s.p=-1}var n=this.kings[a.s];return t.g.pTypes[a.t].isKing&&(this.kings[a.s]=e.t),r.unshift({i:i,f:e.t,t:e.f,kp:n,who:a.s,ty:a.t}),a.p=e.t,void 0!==e.pr&&(a.t=e.pr),this.board[e.f]=-1,this.board[e.t]=i,r},Model.Board.cbQuickUnapply=function(t,e){for(var r=0;r<e.length;r++){var i=e[r],a=this.pieces[i.i];i.f>=0&&(a.p=-1,this.board[i.f]=-1),i.t>=0&&(a.p=i.t,this.board[i.t]=i.i),void 0!==i.m&&(a.m=i.m),void 0!==i.kp&&(this.kings[i.who]=i.kp),void 0!=i.ty&&(a.t=i.ty),void 0!=i.cg&&(this.castled[a.s]=i.cg)}},Model.Board.ApplyMove=function(t,e){var r=this.pieces[this.board[e.f]];if(void 0!==e.cg)this.cbApplyCastle(t,e,!0);else{if(this.zSign=t.zobrist.update(this.zSign,"board",r.i,e.f),this.board[r.p]=-1,void 0!==e.pr&&(this.zSign=t.zobrist.update(this.zSign,"type",r.t,r.i),r.t=e.pr,this.zSign=t.zobrist.update(this.zSign,"type",r.t,r.i)),null!=e.c){var i=this.pieces[e.c];this.zSign=t.zobrist.update(this.zSign,"board",i.i,i.p),this.board[i.p]=-1,i.p=-1,i.m=!0,this.noCaptCount=0}else this.noCaptCount++;r.p=e.t,r.m=!0,this.board[e.t]=r.i,this.zSign=t.zobrist.update(this.zSign,"board",r.i,e.t),t.g.pTypes[r.t].isKing&&(this.kings[r.s]=e.t)}this.check=!!e.ck,this.lastMove={f:e.f,t:e.t,c:e.c},void 0!==e.ko&&(this.ending[r.s]=e.ko),void 0!==e.ept?this.epTarget={p:e.ept,i:r.i}:this.epTarget=null,this.zSign=t.zobrist.update(this.zSign,"who",-this.mWho),this.zSign=t.zobrist.update(this.zSign,"who",this.mWho)},Model.Board.Evaluate=function(r){function i(e){var r=1/0;for(var i in t.geometry.corners)r=Math.min(r,h.distGraph[s.kings[e]][i]);return r-Math.sqrt(h.boardSize)}var a="debug"==arguments[3],s=this;this.mEvaluation=0;var n,o=this.mWho,h=r.g;if(e)n={1:{count:new Uint8Array(h.pTypes.length),byType:{}},"-1":{count:new Uint8Array(h.pTypes.length),byType:{}}};else{n={1:{count:[],byType:{}},"-1":{count:[],byType:{}}};for(var p=0;p<h.pTypes.length;p++)n[1].count[p]=n[-1].count[p]=0}if(r.mOptions.preventRepeat&&r.GetRepeatOccurence(this)>2)return this.mFinished=!0,void(this.mWinner=r.cbOnPerpetual?o*r.cbOnPerpetual:JocGame.DRAW);for(var c={1:0,"-1":0},l={1:h.distGraph[this.kings[-1]],"-1":h.distGraph[this.kings[1]]},u={1:0,"-1":0},v={1:0,"-1":0},b={1:0,"-1":0},f={1:0,"-1":0},d={1:!1,"-1":!1},g=this.pieces,m=g.length,p=0;p<m;p++){var G=g[p];if(G.p>=0){var y=G.s,M=h.pTypes[G.t];M.isKing?d[y]=G.m:c[y]+=M.value,M.castle&&!G.m&&f[y]++,v[y]++,u[y]+=l[y][G.p],b[y]+=t.geometry.distEdge[G.p];var C=n[y];C.count[G.t]++;var S=C.byType;void 0===S[G.t]?S[G.t]=[G]:S[G.t].push(G)}}if(this.lastMove&&null!=this.lastMove.c){var G=this.pieces[this.board[this.lastMove.t]];c[-G.s]+=this.cbStaticExchangeEval(r,G.p,G.s,{piece:G})}var k={1:0,"-1":0},A={1:0,"-1":0},T={1:0,"-1":0};this.ending[1]&&(A[1]=(u[1]-Math.sqrt(h.boardSize))/v[1],t.geometry.corners&&(T[1]=i(1))),this.ending[-1]&&(A[-1]=(u[-1]-Math.sqrt(h.boardSize))/v[-1],t.geometry.corners&&(T[1]=i(-1)));var z={pieceValue:c[1]-c[-1],pieceValueRatio:(c[1]-c[-1])/(c[1]+c[-1]+1),posValue:b[1]-b[-1],averageDistKing:u[1]/v[1]-u[-1]/v[-1],check:this.check?-o:0,endingKingFreedom:k[1]-k[-1],endingDistKing:A[1]-A[-1],distKingCorner:T[1]-T[-1]};t.castle&&(z.castle=(this.castled[1]?1:d[1]?0:f[1]/(h.castleablePiecesCount[1]+1))-(this.castled[-1]?1:d[-1]?0:f[-1]/(h.castleablePiecesCount[-1]+1))),t.evaluate&&t.evaluate.call(this,r,z,n);var P=r.mOptions.levelOptions;for(var E in z){var R=z[E],w=P[E+"Factor"]||0,I=R*w;a&&console.log(E,"=",R,"*",w,"=>",I),this.mEvaluation+=I}a&&console.log("Evaluation",this.mEvaluation)},Model.Board.cbGeneratePseudoLegalMoves=function(t){function e(e,a){var s=t.cbVar.promote;if(!s)return void i.push(a);var n=s.call(r,t,e,a);if(null!=n)if(0==n.length)i.push(a);else if(1==n.length)a.pr=n[0],i.push(a);else for(var o=0;o<n.length;o++){var h=n[o];i.push({f:a.f,t:a.t,c:a.c,pr:h,ept:a.ept,ep:a.ep,a:a.a})}}for(var r=this,i=[],a=t.cbVar,s=this.mWho,n=!a.castle||this.check||this.castled[s]?null:[],o=-1,h=this.pieces.length,p=0;p<h;p++){var c=this.pieces[p];if(!(c.p<0||c.s!=s)){var l=t.g.pTypes[c.t];l.isKing&&(c.m?n=null:o=c),n&&l.castle&&!c.m&&n.push(c);var u,v;u=l.graph[c.p],v=u.length;for(var b=0;b<v;b++)for(var f=u[b],d=!1,g=f.length,m=null,G=0;G<g;G++){var y=f[G],M=65535&y,C=this.board[M];if(!(C<0)||l.epCatch&&this.epTarget&&this.epTarget.p==M){if(!(524288&y)){var S;S=C<0?this.pieces[this.epTarget.i]:this.pieces[C],!(S.s!=c.s&&131072&y)||1048576&y&&!t.g.pTypes[S.t].isKing||2097152&y&&t.g.pTypes[S.t].isKing||e(c,{f:c.p,t:M,c:S.i,a:l.abbrev,ep:C<0});break}if(d){var S=this.pieces[C];S.s!=c.s&&e(c,{f:c.p,t:M,c:S.i,a:l.abbrev});break}d=!0}else 65536&y&&0==d&&e(c,{f:c.p,t:M,c:null,a:l.abbrev,ept:null!=m&&l.epTarget?m:void 0});m=M}}}if(n)for(var p=0;p<n.length;p++){var k=n[p],A=t.cbVar.castle[o.p+"/"+k.p];if(A){for(var T=!0,b=0;b<A.r.length;b++){var z=A.r[b];if(this.board[z]>=0&&z!=o.p&&z!=k.p){T=!1;break}}if(T){for(var P=!0,b=0;b<A.k.length;b++){var z=A.k[b];if(this.board[z]>=0&&z!=k.p&&z!=o.p||this.cbGetAttackers(t,z,s).length>0){P=!1;break}}P&&i.push({f:o.p,t:A.k[A.k.length-1],c:null,cg:k.p})}}}return i},Model.Board.cbStaticExchangeEval=function(t,e,r,i){var a=0,s=this.cbGetSmallestAttacker(t,e,r);if(s){var n=this.mWho;this.mWho=s.s;var o=this.cbQuickApply(t,{f:s.p,t:e,c:i.piece.i}),h=t.g.pTypes[i.piece.t].value;i.piece=s,a=Math.max(0,h-this.cbStaticExchangeEval(t,e,-r,i)),this.cbQuickUnapply(t,o),this.mWho=n}return a},Model.Board.cbGetSmallestAttacker=function(t,e,r){var i=this.cbGetAttackers(t,e,r);if(0==i.length)return null;for(var a=1/0,s=null,n=i.length,o=0;o<n;o++){var h=i[o],p=t.g.pTypes[h.t].value;p<a&&(a=p,s=h)}return s},Model.Board.cbCollectAttackers=function(t,e,r,i){for(var a in e){var s=e[a],n=this.board[a];if(n<0)this.cbCollectAttackers(t,s.e,r,i);else{var o=this.pieces[n];o.s==-t&&(s.t&&o.t in s.t||i&&s.tk&&o.t in s.tk)&&r.push(o)}}},Model.Board.cbCollectAttackersScreen=function(t,e,r,i,a){for(var s in e){var n=e[s],o=this.board[s];if(o<0)this.cbCollectAttackersScreen(t,n.e,r,i,a);else{var h=this.pieces[o];!a&&h.s==-t&&(n.t&&h.t in n.t||i&&n.tk&&h.t in n.tk)?r.push(h):a?a&&h.s==-t&&n.ts&&h.t in n.ts&&r.push(h):this.cbCollectAttackersScreen(t,n.e,r,i,!0)}}},Model.Board.cbGetAttackers=function(t,e,r,i){var a=[];return t.cbUseScreenCapture?this.cbCollectAttackersScreen(r,t.g.threatGraph[r][e],a,i,!1):this.cbCollectAttackers(r,t.g.threatGraph[r][e],a,i),a},Model.Board.GenerateMoves=function(t){var e=this.cbGeneratePseudoLegalMoves(t);this.mMoves=[];for(var r=!0,i=this.kings[this.mWho],a=e.length,s=0;s<a;s++){var n=e[s],o=this.cbQuickApply(t,n);if(!(this.cbGetAttackers(t,this.kings[this.mWho],this.mWho,!0).length>0)){var h=this.cbGetAttackers(t,this.kings[-this.mWho],-this.mWho,!0).length>0;n.ck=h,this.mMoves.push(n),n.f!=i&&(r=!1)}this.cbQuickUnapply(t,o)}if(0==this.mMoves.length)this.mFinished=!0,this.mWinner=t.cbOnStaleMate?t.cbOnStaleMate*this.mWho:JocGame.DRAW,this.check&&(this.mWinner=-this.mWho);else if(this.ending[this.mWho]){if(!r)for(var s=0;s<this.mMoves.length;s++)this.mMoves[s].ko=!1}else if(!this.ending[this.mWho]&&r&&!this.check)for(var s=0;s<this.mMoves.length;s++)this.mMoves[s].ko=!0},Model.Board.GetSignature=function(){return this.zSign},Model.Move.Init=function(t){for(var e in t)t.hasOwnProperty(e)&&(this[e]=t[e])},Model.Move.Equals=function(t){return this.f==t.f&&this.t==t.t&&this.pr==t.pr},Model.Move.CopyFrom=function(t){this.Init(t)},Model.Move.ToString=function(e){var r=this;switch(e=e||"natural"){case"natural":return function(){var e;if(void 0!==r.cg?e=t.castle[r.f+"/"+r.cg].n:(e=r.a||"",e+=t.geometry.PosName(r.f),null==r.c?e+="-":e+="x",e+=t.geometry.PosName(r.t)),void 0!==r.pr){var i=t.pieceTypes[r.pr];i&&i.abbrev&&i.abbrev.length>0&&!i.silentPromo&&(e+="="+i.abbrev)}return r.ck&&(e+="+"),e}();case"engine":return function(){var e=t.geometry.PosName(r.f)+t.geometry.PosName(r.t);if(void 0!=r.pr){var i=t.pieceTypes[r.pr];i&&i.abbrev&&i.abbrev.length>0&&!i.silentPromo&&(e+=i.abbrev)}return e}();default:return"??"}},Model.Board.CompactMoveString=function(e,r,i){"function"!=typeof r.ToString&&(r=e.CreateMove(r));var a=r.ToString(),s=/^([A-Z]?)([a-z])([1-9][0-9]*)([-x])([a-z])([1-9][0-9]*)(.*?)$/.exec(a);if(!s)return a;var n=s[7];if(i||(i={}),i.value||(i.value=[]),0==i.value.length){var o=this.mMoves;this.mMoves&&0!=this.mMoves.length||this.GenerateMoves(e);for(var h=0;h<this.mMoves.length;h++){var p=this.mMoves[h];"function"!=typeof p.ToString&&(p=e.CreateMove(p)),i.value.push({str:p.ToString(),move:p})}this.mMoves=o}var c=[];if(i.value.forEach(function(t){var e=/^([A-Z]?[a-z][1-9][0-9]*[-x][a-z][1-9][0-9]*)(.*?)$/.exec(t.str);e&&t.move.t==r.t&&(t.move.a||"")==s[1]&&e[2]==n&&c.push(t.move)}),1==c.length)return""==s[1]&&"x"==s[4]?s[2]+"x"+s[5]+s[6]+s[7]:s[1]+("x"==s[4]?"x":"")+s[5]+s[6]+s[7];if(t.geometry.CompactCrit)for(var l="",h=0;;h++){var u=t.geometry.CompactCrit(r.f,h);if(null==u)return a;l+=u;for(var v=[],b=0;b<c.length;b++){var f=c[b];t.geometry.CompactCrit(f.f,h)==u&&v.push(f)}if(console.assert(v.length>0),1==v.length)return s[1]+l+("x"==s[4]?"x":"")+s[5]+s[6]+s[7];c=v}return a},Model.Board.cbIntegrity=function(t){function e(t,e){t||console.error(e)}for(var r=this,i=0;i<this.board.length;i++){var a=this.board[i];if(a>=0){var s=r.pieces[a];e(void 0!==s,"no piece at pos"),e(s.p==i,"piece has different pos")}}for(var a=0;a<this.pieces.length;a++){var s=this.pieces[a];s.p>=0&&e(r.board[s.p]==a,"board index mismatch")}},Model.Board.ExportBoardState=function(t){return t.cbVar.geometry.ExportBoardState?t.cbVar.geometry.ExportBoardState(this,t.cbVar,t.mPlayedMoves.length):"not supported"},Model.Game.Import=function(e,r){var i,a=[],s={1:{},"-1":{}},n=null,o=0;if("pjn"==e){var h={status:!1,error:"parse"},p=r.split(" ");if(6!=p.length)return console.warn("FEN should have 6 parts"),h;var c=p[0].split("/"),l=t.geometry.fenHeight||t.geometry.height;if(c.length!=l)return console.warn("FEN board should have",l,"rows, got",c.length),h;var u={};for(var v in t.pieceTypes){var b=t.pieceTypes[v],f=b.fenAbbrev||b.abbrev||"X";u[f.toUpperCase()]={s:1,t:v},u[f.toLowerCase()]={s:-1,t:v}}var d=t.geometry.FenRowPos||function(e,r){return(t.geometry.height-1-e)*t.geometry.width+r};if(c.forEach(function(e,r){for(var i=0,s=0;s<e.length;s++){var n=e.substr(s,1),o=u[n];if(void 0!==o){var p=d(r,i);i++;for(var c={s:o.s,t:o.t,p:p},l=!0,v=t.pieceTypes[c.t].initial||[],b=0;b<v.length;b++){var f=v[b];f.s==c.s&&f.p==p&&(l=!1)}c.m=l,a.push(c)}else{if(isNaN(parseInt(n)))return console.warn("FEN invalid board spec",n),h;i+=parseInt(n)}}}),a.sort(function(t,e){return e.s-t.s}),"w"==p[1])i=1;else{if("b"!=p[1])return console.warn("FEN invalid turn spec",p[1]),h;i=-1}s[1].k=p[2].indexOf("K")>=0,s[1].q=p[2].indexOf("Q")>=0,s[-1].k=p[2].indexOf("k")>=0,s[-1].q=p[2].indexOf("q")>=0,n="-"==p[3]?null:p[3];var g=parseInt(p[4]);isNaN(g)||(o=g);var m={pieces:a,turn:i,castle:s,enPassant:n,noCaptCount:o};return t.importGame&&t.importGame.call(this,m,e,r),{status:!0,initial:m}}return{status:!1,error:"unsupported"}}}(),function(){Model.Game.cbBoardGeometryGrid=function(t,e){function r(e){return e%t}function i(e){return Math.floor(e/t)}function a(e,r){return r*t+e}function s(s,n){var o=r(s),h=i(s),p=o+n[0],c=h+n[1];return p<0||p>=t||c<0||c>=e?null:a(p,c)}function n(t){return String.fromCharCode("a".charCodeAt(0)+r(t))+(i(t)+1)}function o(t){var e=/^([a-z])([0-9]+)$/.exec(t);return e?a(e[1].charCodeAt(0)-"a".charCodeAt(0),parseInt(e[2])-1):-1}function h(t,e){return 0==e?String.fromCharCode("a".charCodeAt(0)+r(t)):1==e?i(t)+1:null}function p(){for(var a=[],s=0;s<t*e;s++){var n=[];a.push(n);for(var o=0;o<t*e;o++){var h=i(s),p=r(s),c=i(o),l=r(o);n.push(Math.max(Math.abs(h-c),Math.abs(p-l)))}}return a}function c(r,i,s){for(var o=[],h=e-1;h>=0;h--){for(var p="",c=0,l=0;l<t;l++){var u=r.board[a(l,h)];if(u<0)c++;else{c>0&&(p+=c,c=0);var v=r.pieces[u],b=i.pieceTypes[v.t].fenAbbrev||i.pieceTypes[v.t].abbrev||"?";v.s==-1?p+=b.toLowerCase():p+=b.toUpperCase()}}c&&(p+=c),o.push(p)}var f=o.join("/");f+=" ",1==r.mWho?f+="w":f+="b",f+=" ";var d="";return r.castled&&(r.castled[1]===!1?d+="KQ":(r.castled[1].k&&(d+="K"),r.castled[1].q&&(d+="Q")),r.castled[-1]===!1?d+="kq":(r.castled[-1].k&&(d+="k"),r.castled[-1].q&&(d+="q"))),0==d.length&&(d="-"),f+=d,f+=" ",r.epTarget?f+=n(r.epTarget.p):f+="-",f+=" ",f+=r.noCaptCount,f+=" ",f+=Math.floor(s/2)+1}return{boardSize:t*e,width:t,height:e,C:r,R:i,POS:a,Graph:s,PosName:n,PosByName:o,CompactCrit:h,GetDistances:p,distEdge:function(){for(var a=[],s=0;s<t*e;s++){var n=r(s),o=i(s);a[s]=Math.min(n,Math.abs(t-n-1),o,Math.abs(e-o-1))}return a}(),corners:function(){var r={};return r[a(0,0)]=1,r[a(0,e-1)]=1,r[a(t-1,0)]=1,r[a(t-1,e-1)]=1,r}(),ExportBoardState:c}},Model.Game.cbPawnGraph=function(t,e,r){for(var i=this,a={},s=0;s<t.boardSize;s++)if(!r||s in r){var n=[],o=t.Graph(s,[0,e]);null!=o&&(!r||o in r)&&n.push(i.cbTypedArray([o|i.cbConstants.FLAG_MOVE])),[-1,1].forEach(function(a){var o=t.Graph(s,[a,e]);null!=o&&(!r||o in r)&&n.push(i.cbTypedArray([o|i.cbConstants.FLAG_CAPTURE]))}),a[s]=n}else a[s]=[];return a},Model.Game.cbInitialPawnGraph=function(t,e,r){for(var i=this,a={},s=0;s<t.boardSize;s++)if(!r||s in r){var n=[],o=t.Graph(s,[0,e]);if(null!=o&&(!r||o in r)){var h=[o|i.cbConstants.FLAG_MOVE],p=t.Graph(o,[0,e]);null!=p&&(!r||p in r)&&h.push(p|i.cbConstants.FLAG_MOVE),n.push(i.cbTypedArray(h))}[-1,1].forEach(function(a){var o=t.Graph(s,[a,e]);null!=o&&(!r||o in r)&&n.push(i.cbTypedArray([o|i.cbConstants.FLAG_CAPTURE]))}),a[s]=n}else a[s]=[];return a},Model.Game.cbKingGraph=function(t,e){return this.cbShortRangeGraph(t,[[-1,-1],[-1,0],[-1,1],[0,-1],[0,1],[1,-1],[1,0],[1,1]],e)},Model.Game.cbKnightGraph=function(t,e){return this.cbShortRangeGraph(t,[[2,-1],[2,1],[-2,-1],[-2,1],[-1,2],[-1,-2],[1,2],[1,-2]],e)},Model.Game.cbHorseGraph=function(t){for(var e=this,r={},i=0;i<t.boardSize;i++)r[i]=[],[[1,0,2,-1],[1,0,2,1],[-1,0,-2,-1],[-1,0,-2,1],[0,1,-1,2],[0,-1,-1,-2],[0,1,1,2],[0,-1,1,-2]].forEach(function(a){var s=t.Graph(i,[a[0],a[1]]);if(null!=s){var n=t.Graph(i,[a[2],a[3]]);null!=n&&r[i].push(e.cbTypedArray([s|e.cbConstants.FLAG_STOP,n|e.cbConstants.FLAG_MOVE|e.cbConstants.FLAG_CAPTURE]))}});return r},Model.Game.cbRookGraph=function(t,e){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0]],e)},Model.Game.cbBishopGraph=function(t,e){return this.cbLongRangeGraph(t,[[1,-1],[1,1],[-1,1],[-1,-1]],e)},Model.Game.cbQueenGraph=function(t,e){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0],[1,-1],[1,1],[-1,1],[-1,-1]],e)},Model.Game.cbXQGeneralGraph=function(t,e){for(var r=this,i={},a=0;a<t.boardSize;a++)i[a]=[],[[-1,0,!1],[0,-1,!0],[0,1,!0],[1,0,!1]].forEach(function(s){var n=[],o=t.Graph(a,s);if(null!=o&&((!e||o in e)&&n.push(o|r.cbConstants.FLAG_MOVE|r.cbConstants.FLAG_CAPTURE),s[2]))for(var h=t.Graph(o,s);null!=h;)!e||h in e?n.push(h|r.cbConstants.FLAG_CAPTURE|r.cbConstants.FLAG_CAPTURE_KING):n.push(h|r.cbConstants.FLAG_STOP),h=t.Graph(h,s);n.length>0&&i[a].push(r.cbTypedArray(n))});return i},Model.Game.cbXQSoldierGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e]])},Model.Game.cbXQPromoSoldierGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e],[-1,0],[1,0]])},Model.Game.cbXQAdvisorGraph=function(t,e){return this.cbShortRangeGraph(t,[[1,1],[-1,1],[1,-1],[-1,-1]],e)},Model.Game.cbXQCannonGraph=function(t){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0]],null,this.cbConstants.FLAG_MOVE|this.cbConstants.FLAG_SCREEN_CAPTURE)},Model.Game.cbXQElephantGraph=function(t,e){for(var r=this,i={},a=0;a<t.boardSize;a++)i[a]=[],(!e||a in e)&&[[1,1,2,2],[1,-1,2,-2],[-1,1,-2,2],[-1,-1,-2,-2]].forEach(function(s){var n=t.Graph(a,[s[0],s[1]]);if(null!=n){var o=t.Graph(a,[s[2],s[3]]);null!=o&&(!e||o in e)&&i[a].push(r.cbTypedArray([n|r.cbConstants.FLAG_STOP,o|r.cbConstants.FLAG_MOVE|r.cbConstants.FLAG_CAPTURE]))}});return i},Model.Game.cbSilverGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e],[-1,-1],[-1,1],[1,-1],[1,1]])},Model.Game.cbFersGraph=function(t,e){return this.cbShortRangeGraph(t,[[-1,-1],[-1,1],[1,-1],[1,1]])},Model.Game.cbSchleichGraph=function(t,e){return this.cbShortRangeGraph(t,[[-1,0],[1,0],[0,-1],[0,1]])},Model.Game.cbAlfilGraph=function(t,e){return this.cbShortRangeGraph(t,[[-2,-2],[-2,2],[2,2],[2,-2]])}}(),function(){var t=Model.Game.cbBoardGeometryGrid(16,16);Model.Game.cbDefine=function(){return{geometry:t,pieceTypes:{0:{name:"pawn-w",aspect:"pawn",graph:this.cbPawnGraph(t,1),value:1,abbrev:"",fenAbbrev:"P",epCatch:!0,initial:[{s:1,p:39},{s:1,p:40}]},1:{name:"ipawn-w",aspect:"pawn",graph:this.cbInitialPawnGraph(t,1),value:1,abbrev:"",fenAbbrev:"P",initial:[{s:1,p:16},{s:1,p:17},{s:1,p:18},{s:1,p:19},{s:1,p:20},{s:1,p:21},{s:1,p:22},{s:1,p:25},{s:1,p:26},{s:1,p:27},{s:1,p:28},{s:1,p:29},{s:1,p:30},{s:1,p:31}],epTarget:!0},2:{name:"pawn-b",aspect:"pawn",graph:this.cbPawnGraph(t,-1),value:1,abbrev:"",fenAbbrev:"P",epCatch:!0,initial:[{s:-1,p:215},{s:-1,p:216}]},3:{name:"ipawn-b",aspect:"pawn",graph:this.cbInitialPawnGraph(t,-1),value:1,abbrev:"",fenAbbrev:"P",initial:[{s:-1,p:224},{s:-1,p:225},{s:-1,p:226},{s:-1,p:227},{s:-1,p:228},{s:-1,p:229},{s:-1,p:230},{s:-1,p:233},{s:-1,p:234},{s:-1,p:235},{s:-1,p:236},{s:-1,p:237},{s:-1,p:238},{s:-1,p:239}],epTarget:!0},4:{name:"knight",graph:this.cbKnightGraph(t),value:2.9,abbrev:"N",initial:[{s:1,p:1},{s:1,p:6},{s:1,p:9},{s:1,p:14},{s:1,p:23},{s:1,p:24},{s:-1,p:231},{s:-1,p:232},{s:-1,p:241},{s:-1,p:246},{s:-1,p:249},{s:-1,p:254}]},5:{name:"bishop",graph:this.cbBishopGraph(t),value:3.1,abbrev:"B",initial:[{s:1,p:2},{s:1,p:5},{s:1,p:10},{s:1,p:13},{s:-1,p:242},{s:-1,p:245},{s:-1,p:250},{s:-1,p:253}]},6:{name:"rook",graph:this.cbRookGraph(t),value:5,abbrev:"R",initial:[{s:1,p:0},{s:1,p:4},{s:1,p:11},{s:1,p:15},{s:-1,p:240},{s:-1,p:244},{s:-1,p:251},{s:-1,p:255}],castle:!0},7:{name:"queen",graph:this.cbQueenGraph(t),value:9,abbrev:"Q",initial:[{s:1,p:7},{s:-1,p:247}]},8:{name:"king",isKing:!0,graph:this.cbKingGraph(t),abbrev:"K",initial:[{s:1,p:8},{s:-1,p:248}]}},promote:function(e,r,i){return 1==r.t?[0]:3==r.t?[2]:0==r.t&&15==t.R(i.t)?[4,5,6,7]:2==r.t&&0==t.R(i.t)?[4,5,6,7]:[]},castle:{"8/4":{k:[7,6],r:[5,6,7],n:"O-O-O"},"8/11":{k:[9,10],r:[10,9],n:"O-O"},"248/244":{k:[247,246],r:[245,246,247],n:"O-O-O"},"248/251":{k:[249,250],r:[250,249],n:"O-O"}},evaluate:function(e,r,i){var a=i[1].count,s=i[-1].count;a[0]||a[1]||a[4]||a[5]||a[6]||a[7]||s[2]||s[3]||s[6]||s[7]||!(s[4]+s[5]<2||s[5]<2)||(this.mFinished=!0,this.mWinner=JocGame.DRAW),s[2]||s[3]||s[4]||s[5]||s[6]||s[7]||a[0]||a[1]||a[6]||a[7]||!(a[4]+a[5]<2||a[5]<2)||(this.mFinished=!0,this.mWinner=JocGame.DRAW),this.noCaptCount>=100&&(this.mFinished=!0,this.mWinner=JocGame.DRAW);var n,o=e.cbUseTypedArrays?new Int8Array(3):[0,0,0],h=t.height,p=i[1].byType[0];if(p){n=p.length;for(var c=0;c<n;c++)switch(h-t.R(p[c].p)){case 2:o[0]++;break;case 3:o[1]++;break;case 4:o[2]++}}if(p=i[-1].byType[2]){n=p.length;for(var c=0;c<n;c++)switch(t.R(p[c].p)){case 1:o[0]--;break;case 2:o[1]--;break;case 3:o[2]--}}0!=o[0]&&(r.distPawnPromo1=o[0]),0!=o[1]&&(r.distPawnPromo2=o[1]),0!=o[2]&&(r.distPawnPromo3=o[2]);for(var l=0,u=4;u<=5;u++)for(var v=1;v>=-1;v-=2){var b=i[v].byType[u];if(b)for(var c=0;c<b.length;c++)b[c].m&&(l+=v)}0!=l&&(r.minorPiecesMoved=l)},importGame:function(e,r,i){return e.pieces.forEach(function(e){1==e.s&&1==t.R(e.p)&&0==e.t&&(e.t=1,e.m=!1),1==e.s&&1!=t.R(e.p)&&1==e.t&&(e.t=0,e.m=!0),e.s==-1&&t.R(e.p)==t.height-2&&2==e.t&&(e.t=3,e.m=!1),e.s==-1&&t.R(e.p)!=t.height-2&&3==e.t&&(e.t=2,e.m=!0)}),!0}}}}();

/***/ }),

/***/ "QNuG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var AsyncSubject_1 = __webpack_require__("5c/I");
var multicast_1 = __webpack_require__("emOw");
/**
 * @return {ConnectableObservable<T>}
 * @method publishLast
 * @owner Observable
 */
function publishLast() {
    return multicast_1.multicast.call(this, new AsyncSubject_1.AsyncSubject());
}
exports.publishLast = publishLast;
//# sourceMappingURL=publishLast.js.map

/***/ }),

/***/ "Qbdm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_common__ = __webpack_require__("2Je8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_core__ = __webpack_require__("3j3K");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BrowserModule", function() { return BrowserModule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "platformBrowser", function() { return platformBrowser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Meta", function() { return Meta; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Title", function() { return Title; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "disableDebugTools", function() { return disableDebugTools; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "enableDebugTools", function() { return enableDebugTools; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "By", function() { return By; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NgProbeToken", function() { return NgProbeToken$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DOCUMENT", function() { return DOCUMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EVENT_MANAGER_PLUGINS", function() { return EVENT_MANAGER_PLUGINS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EventManager", function() { return EventManager; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HAMMER_GESTURE_CONFIG", function() { return HAMMER_GESTURE_CONFIG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HammerGestureConfig", function() { return HammerGestureConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DomSanitizer", function() { return DomSanitizer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VERSION", function() { return VERSION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵBROWSER_SANITIZATION_PROVIDERS", function() { return BROWSER_SANITIZATION_PROVIDERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵINTERNAL_BROWSER_PLATFORM_PROVIDERS", function() { return INTERNAL_BROWSER_PLATFORM_PROVIDERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵinitDomAdapter", function() { return initDomAdapter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵBrowserDomAdapter", function() { return BrowserDomAdapter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵsetValueOnPath", function() { return setValueOnPath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵBrowserPlatformLocation", function() { return BrowserPlatformLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵTRANSITION_ID", function() { return TRANSITION_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵBrowserGetTestability", function() { return BrowserGetTestability; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵELEMENT_PROBE_PROVIDERS", function() { return ELEMENT_PROBE_PROVIDERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵDomAdapter", function() { return DomAdapter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵgetDOM", function() { return getDOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵsetRootDomAdapter", function() { return setRootDomAdapter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵDomRendererFactory2", function() { return DomRendererFactory2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵNAMESPACE_URIS", function() { return NAMESPACE_URIS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵflattenStyles", function() { return flattenStyles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵshimContentAttribute", function() { return shimContentAttribute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵshimHostAttribute", function() { return shimHostAttribute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵDomEventsPlugin", function() { return DomEventsPlugin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵHammerGesturesPlugin", function() { return HammerGesturesPlugin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵKeyEventsPlugin", function() { return KeyEventsPlugin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵDomSharedStylesHost", function() { return DomSharedStylesHost; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵSharedStylesHost", function() { return SharedStylesHost; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵb", function() { return _document; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵa", function() { return errorHandler; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵh", function() { return GenericBrowserDomAdapter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵg", function() { return SERVER_TRANSITION_PROVIDERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵf", function() { return bootstrapListenerFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵc", function() { return _createNgProbe; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵd", function() { return EventManagerPlugin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ɵe", function() { return DomSanitizerImpl; });
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * @license Angular v4.1.0
 * (c) 2010-2017 Google, Inc. https://angular.io/
 * License: MIT
 */


/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var _DOM = ((null));
/**
 * @return {?}
 */
function getDOM() {
    return _DOM;
}
/**
 * @param {?} adapter
 * @return {?}
 */
/**
 * @param {?} adapter
 * @return {?}
 */
function setRootDomAdapter(adapter) {
    if (!_DOM) {
        _DOM = adapter;
    }
}
/**
 * Provides DOM operations in an environment-agnostic way.
 *
 * \@security Tread carefully! Interacting with the DOM directly is dangerous and
 * can introduce XSS risks.
 * @abstract
 */
var DomAdapter = (function () {
    function DomAdapter() {
        this.resourceLoaderType = ((null));
    }
    /**
     * @abstract
     * @param {?} element
     * @param {?} name
     * @return {?}
     */
    DomAdapter.prototype.hasProperty = function (element, name) { };
    /**
     * @abstract
     * @param {?} el
     * @param {?} name
     * @param {?} value
     * @return {?}
     */
    DomAdapter.prototype.setProperty = function (el, name, value) { };
    /**
     * @abstract
     * @param {?} el
     * @param {?} name
     * @return {?}
     */
    DomAdapter.prototype.getProperty = function (el, name) { };
    /**
     * @abstract
     * @param {?} el
     * @param {?} methodName
     * @param {?} args
     * @return {?}
     */
    DomAdapter.prototype.invoke = function (el, methodName, args) { };
    /**
     * @abstract
     * @param {?} error
     * @return {?}
     */
    DomAdapter.prototype.logError = function (error) { };
    /**
     * @abstract
     * @param {?} error
     * @return {?}
     */
    DomAdapter.prototype.log = function (error) { };
    /**
     * @abstract
     * @param {?} error
     * @return {?}
     */
    DomAdapter.prototype.logGroup = function (error) { };
    /**
     * @abstract
     * @return {?}
     */
    DomAdapter.prototype.logGroupEnd = function () { };
    Object.defineProperty(DomAdapter.prototype, "attrToPropMap", {
        /**
         * Maps attribute names to their corresponding property names for cases
         * where attribute name doesn't match property name.
         * @return {?}
         */
        get: function () { return this._attrToPropMap; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this._attrToPropMap = value; },
        enumerable: true,
        configurable: true
    });
    ;
    ;
    /**
     * @abstract
     * @param {?} nodeA
     * @param {?} nodeB
     * @return {?}
     */
    DomAdapter.prototype.contains = function (nodeA, nodeB) { };
    /**
     * @abstract
     * @param {?} templateHtml
     * @return {?}
     */
    DomAdapter.prototype.parse = function (templateHtml) { };
    /**
     * @abstract
     * @param {?} el
     * @param {?} selector
     * @return {?}
     */
    DomAdapter.prototype.querySelector = function (el, selector) { };
    /**
     * @abstract
     * @param {?} el
     * @param {?} selector
     * @return {?}
     */
    DomAdapter.prototype.querySelectorAll = function (el, selector) { };
    /**
     * @abstract
     * @param {?} el
     * @param {?} evt
     * @param {?} listener
     * @return {?}
     */
    DomAdapter.prototype.on = function (el, evt, listener) { };
    /**
     * @abstract
     * @param {?} el
     * @param {?} evt
     * @param {?} listener
     * @return {?}
     */
    DomAdapter.prototype.onAndCancel = function (el, evt, listener) { };
    /**
     * @abstract
     * @param {?} el
     * @param {?} evt
     * @return {?}
     */
    DomAdapter.prototype.dispatchEvent = function (el, evt) { };
    /**
     * @abstract
     * @param {?} eventType
     * @return {?}
     */
    DomAdapter.prototype.createMouseEvent = function (eventType) { };
    /**
     * @abstract
     * @param {?} eventType
     * @return {?}
     */
    DomAdapter.prototype.createEvent = function (eventType) { };
    /**
     * @abstract
     * @param {?} evt
     * @return {?}
     */
    DomAdapter.prototype.preventDefault = function (evt) { };
    /**
     * @abstract
     * @param {?} evt
     * @return {?}
     */
    DomAdapter.prototype.isPrevented = function (evt) { };
    /**
     * @abstract
     * @param {?} el
     * @return {?}
     */
    DomAdapter.prototype.getInnerHTML = function (el) { };
    /**
     * Returns content if el is a <template> element, null otherwise.
     * @abstract
     * @param {?} el
     * @return {?}
     */
    DomAdapter.prototype.getTemplateContent = function (el) { };
    /**
     * @abstract
     * @param {?} el
     * @return {?}
     */
    DomAdapter.prototype.getOuterHTML = function (el) { };
    /**
     * @abstract
     * @param {?} node
     * @return {?}
     */
    DomAdapter.prototype.nodeName = function (node) { };
    /**
     * @abstract
     * @param {?} node
     * @return {?}
     */
    DomAdapter.prototype.nodeValue = function (node) { };
    /**
     * @abstract
     * @param {?} node
     * @return {?}
     */
    DomAdapter.prototype.type = function (node) { };
    /**
     * @abstract
     * @param {?} node
     * @return {?}
     */
    DomAdapter.prototype.content = function (node) { };
    /**
     * @abstract
     * @param {?} el
     * @return {?}
     */
    DomAdapter.prototype.firstChild = function (el) { };
    /**
     * @abstract
     * @param {?} el
     * @return {?}
     */
    DomAdapter.prototype.nextSibling = function (el) { };
    /**
     * @abstract
     * @param {?} el
     * @return {?}
     */
    DomAdapter.prototype.parentElement = function (el) { };
    /**
     * @abstract
     * @param {?} el
     * @return {?}
     */
    DomAdapter.prototype.childNodes = function (el) { };
    /**
     * @abstract
     * @param {?} el
     * @return {?}
     */
    DomAdapter.prototype.childNodesAsList = function (el) { };
    /**
     * @abstract
     * @param {?} el
     * @return {?}
     */
    DomAdapter.prototype.clearNodes = function (el) { };
    /**
     * @abstract
     * @param {?} el
     * @param {?} node
     * @return {?}
     */
    DomAdapter.prototype.appendChild = function (el, node) { };
    /**
     * @abstract
     * @param {?} el
     * @param {?} node
     * @return {?}
     */
    DomAdapter.prototype.removeChild = function (el, node) { };
    /**
     * @abstract
     * @param {?} el
     * @param {?} newNode
     * @param {?} oldNode
     * @return {?}
     */
    DomAdapter.prototype.replaceChild = function (el, newNode, oldNode) { };
    /**
     * @abstract
     * @param {?} el
     * @return {?}
     */
    DomAdapter.prototype.remove = function (el) { };
    /**
     * @abstract
     * @param {?} parent
     * @param {?} ref
     * @param {?} node
     * @return {?}
     */
    DomAdapter.prototype.insertBefore = function (parent, ref, node) { };
    /**
     * @abstract
     * @param {?} parent
     * @param {?} ref
     * @param {?} nodes
     * @return {?}
     */
    DomAdapter.prototype.insertAllBefore = function (parent, ref, nodes) { };
    /**
     * @abstract
     * @param {?} parent
     * @param {?} el
     * @param {?} node
     * @return {?}
     */
    DomAdapter.prototype.insertAfter = function (parent, el, node) { };
    /**
     * @abstract
     * @param {?} el
     * @param {?} value
     * @return {?}
     */
    DomAdapter.prototype.setInnerHTML = function (el, value) { };
    /**
     * @abstract
     * @param {?} el
     * @return {?}
     */
    DomAdapter.prototype.getText = function (el) { };
    /**
     * @abstract
     * @param {?} el
     * @param {?} value
     * @return {?}
     */
    DomAdapter.prototype.setText = function (el, value) { };
    /**
     * @abstract
     * @param {?} el
     * @return {?}
     */
    DomAdapter.prototype.getValue = function (el) { };
    /**
     * @abstract
     * @param {?} el
     * @param {?} value
     * @return {?}
     */
    DomAdapter.prototype.setValue = function (el, value) { };
    /**
     * @abstract
     * @param {?} el
     * @return {?}
     */
    DomAdapter.prototype.getChecked = function (el) { };
    /**
     * @abstract
     * @param {?} el
     * @param {?} value
     * @return {?}
     */
    DomAdapter.prototype.setChecked = function (el, value) { };
    /**
     * @abstract
     * @param {?} text
     * @return {?}
     */
    DomAdapter.prototype.createComment = function (text) { };
    /**
     * @abstract
     * @param {?} html
     * @return {?}
     */
    DomAdapter.prototype.createTemplate = function (html) { };
    /**
     * @abstract
     * @param {?} tagName
     * @param {?=} doc
     * @return {?}
     */
    DomAdapter.prototype.createElement = function (tagName, doc) { };
    /**
     * @abstract
     * @param {?} ns
     * @param {?} tagName
     * @param {?=} doc
     * @return {?}
     */
    DomAdapter.prototype.createElementNS = function (ns, tagName, doc) { };
    /**
     * @abstract
     * @param {?} text
     * @param {?=} doc
     * @return {?}
     */
    DomAdapter.prototype.createTextNode = function (text, doc) { };
    /**
     * @abstract
     * @param {?} attrName
     * @param {?} attrValue
     * @param {?=} doc
     * @return {?}
     */
    DomAdapter.prototype.createScriptTag = function (attrName, attrValue, doc) { };
    /**
     * @abstract
     * @param {?} css
     * @param {?=} doc
     * @return {?}
     */
    DomAdapter.prototype.createStyleElement = function (css, doc) { };
    /**
     * @abstract
     * @param {?} el
     * @return {?}
     */
    DomAdapter.prototype.createShadowRoot = function (el) { };
    /**
     * @abstract
     * @param {?} el
     * @return {?}
     */
    DomAdapter.prototype.getShadowRoot = function (el) { };
    /**
     * @abstract
     * @param {?} el
     * @return {?}
     */
    DomAdapter.prototype.getHost = function (el) { };
    /**
     * @abstract
     * @param {?} el
     * @return {?}
     */
    DomAdapter.prototype.getDistributedNodes = function (el) { };
    /**
     * @abstract
     * @param {?} node
     * @return {?}
     */
    DomAdapter.prototype.clone /*<T extends Node>*/ = function (node) { };
    /**
     * @abstract
     * @param {?} element
     * @param {?} name
     * @return {?}
     */
    DomAdapter.prototype.getElementsByClassName = function (element, name) { };
    /**
     * @abstract
     * @param {?} element
     * @param {?} name
     * @return {?}
     */
    DomAdapter.prototype.getElementsByTagName = function (element, name) { };
    /**
     * @abstract
     * @param {?} element
     * @return {?}
     */
    DomAdapter.prototype.classList = function (element) { };
    /**
     * @abstract
     * @param {?} element
     * @param {?} className
     * @return {?}
     */
    DomAdapter.prototype.addClass = function (element, className) { };
    /**
     * @abstract
     * @param {?} element
     * @param {?} className
     * @return {?}
     */
    DomAdapter.prototype.removeClass = function (element, className) { };
    /**
     * @abstract
     * @param {?} element
     * @param {?} className
     * @return {?}
     */
    DomAdapter.prototype.hasClass = function (element, className) { };
    /**
     * @abstract
     * @param {?} element
     * @param {?} styleName
     * @param {?} styleValue
     * @return {?}
     */
    DomAdapter.prototype.setStyle = function (element, styleName, styleValue) { };
    /**
     * @abstract
     * @param {?} element
     * @param {?} styleName
     * @return {?}
     */
    DomAdapter.prototype.removeStyle = function (element, styleName) { };
    /**
     * @abstract
     * @param {?} element
     * @param {?} styleName
     * @return {?}
     */
    DomAdapter.prototype.getStyle = function (element, styleName) { };
    /**
     * @abstract
     * @param {?} element
     * @param {?} styleName
     * @param {?=} styleValue
     * @return {?}
     */
    DomAdapter.prototype.hasStyle = function (element, styleName, styleValue) { };
    /**
     * @abstract
     * @param {?} element
     * @return {?}
     */
    DomAdapter.prototype.tagName = function (element) { };
    /**
     * @abstract
     * @param {?} element
     * @return {?}
     */
    DomAdapter.prototype.attributeMap = function (element) { };
    /**
     * @abstract
     * @param {?} element
     * @param {?} attribute
     * @return {?}
     */
    DomAdapter.prototype.hasAttribute = function (element, attribute) { };
    /**
     * @abstract
     * @param {?} element
     * @param {?} ns
     * @param {?} attribute
     * @return {?}
     */
    DomAdapter.prototype.hasAttributeNS = function (element, ns, attribute) { };
    /**
     * @abstract
     * @param {?} element
     * @param {?} attribute
     * @return {?}
     */
    DomAdapter.prototype.getAttribute = function (element, attribute) { };
    /**
     * @abstract
     * @param {?} element
     * @param {?} ns
     * @param {?} attribute
     * @return {?}
     */
    DomAdapter.prototype.getAttributeNS = function (element, ns, attribute) { };
    /**
     * @abstract
     * @param {?} element
     * @param {?} name
     * @param {?} value
     * @return {?}
     */
    DomAdapter.prototype.setAttribute = function (element, name, value) { };
    /**
     * @abstract
     * @param {?} element
     * @param {?} ns
     * @param {?} name
     * @param {?} value
     * @return {?}
     */
    DomAdapter.prototype.setAttributeNS = function (element, ns, name, value) { };
    /**
     * @abstract
     * @param {?} element
     * @param {?} attribute
     * @return {?}
     */
    DomAdapter.prototype.removeAttribute = function (element, attribute) { };
    /**
     * @abstract
     * @param {?} element
     * @param {?} ns
     * @param {?} attribute
     * @return {?}
     */
    DomAdapter.prototype.removeAttributeNS = function (element, ns, attribute) { };
    /**
     * @abstract
     * @param {?} el
     * @return {?}
     */
    DomAdapter.prototype.templateAwareRoot = function (el) { };
    /**
     * @abstract
     * @return {?}
     */
    DomAdapter.prototype.createHtmlDocument = function () { };
    /**
     * @abstract
     * @param {?} el
     * @return {?}
     */
    DomAdapter.prototype.getBoundingClientRect = function (el) { };
    /**
     * @abstract
     * @param {?} doc
     * @return {?}
     */
    DomAdapter.prototype.getTitle = function (doc) { };
    /**
     * @abstract
     * @param {?} doc
     * @param {?} newTitle
     * @return {?}
     */
    DomAdapter.prototype.setTitle = function (doc, newTitle) { };
    /**
     * @abstract
     * @param {?} n
     * @param {?} selector
     * @return {?}
     */
    DomAdapter.prototype.elementMatches = function (n, selector) { };
    /**
     * @abstract
     * @param {?} el
     * @return {?}
     */
    DomAdapter.prototype.isTemplateElement = function (el) { };
    /**
     * @abstract
     * @param {?} node
     * @return {?}
     */
    DomAdapter.prototype.isTextNode = function (node) { };
    /**
     * @abstract
     * @param {?} node
     * @return {?}
     */
    DomAdapter.prototype.isCommentNode = function (node) { };
    /**
     * @abstract
     * @param {?} node
     * @return {?}
     */
    DomAdapter.prototype.isElementNode = function (node) { };
    /**
     * @abstract
     * @param {?} node
     * @return {?}
     */
    DomAdapter.prototype.hasShadowRoot = function (node) { };
    /**
     * @abstract
     * @param {?} node
     * @return {?}
     */
    DomAdapter.prototype.isShadowRoot = function (node) { };
    /**
     * @abstract
     * @param {?} node
     * @return {?}
     */
    DomAdapter.prototype.importIntoDoc /*<T extends Node>*/ = function (node) { };
    /**
     * @abstract
     * @param {?} node
     * @return {?}
     */
    DomAdapter.prototype.adoptNode /*<T extends Node>*/ = function (node) { };
    /**
     * @abstract
     * @param {?} element
     * @return {?}
     */
    DomAdapter.prototype.getHref = function (element) { };
    /**
     * @abstract
     * @param {?} event
     * @return {?}
     */
    DomAdapter.prototype.getEventKey = function (event) { };
    /**
     * @abstract
     * @param {?} element
     * @param {?} baseUrl
     * @param {?} href
     * @return {?}
     */
    DomAdapter.prototype.resolveAndSetHref = function (element, baseUrl, href) { };
    /**
     * @abstract
     * @return {?}
     */
    DomAdapter.prototype.supportsDOMEvents = function () { };
    /**
     * @abstract
     * @return {?}
     */
    DomAdapter.prototype.supportsNativeShadowDOM = function () { };
    /**
     * @abstract
     * @param {?} doc
     * @param {?} target
     * @return {?}
     */
    DomAdapter.prototype.getGlobalEventTarget = function (doc, target) { };
    /**
     * @abstract
     * @return {?}
     */
    DomAdapter.prototype.getHistory = function () { };
    /**
     * @abstract
     * @return {?}
     */
    DomAdapter.prototype.getLocation = function () { };
    /**
     * @abstract
     * @param {?} doc
     * @return {?}
     */
    DomAdapter.prototype.getBaseHref = function (doc) { };
    /**
     * @abstract
     * @return {?}
     */
    DomAdapter.prototype.resetBaseElement = function () { };
    /**
     * @abstract
     * @return {?}
     */
    DomAdapter.prototype.getUserAgent = function () { };
    /**
     * @abstract
     * @param {?} element
     * @param {?} name
     * @param {?} value
     * @return {?}
     */
    DomAdapter.prototype.setData = function (element, name, value) { };
    /**
     * @abstract
     * @param {?} element
     * @return {?}
     */
    DomAdapter.prototype.getComputedStyle = function (element) { };
    /**
     * @abstract
     * @param {?} element
     * @param {?} name
     * @return {?}
     */
    DomAdapter.prototype.getData = function (element, name) { };
    /**
     * @abstract
     * @param {?} name
     * @param {?} value
     * @return {?}
     */
    DomAdapter.prototype.setGlobalVar = function (name, value) { };
    /**
     * @abstract
     * @return {?}
     */
    DomAdapter.prototype.supportsWebAnimation = function () { };
    /**
     * @abstract
     * @return {?}
     */
    DomAdapter.prototype.performanceNow = function () { };
    /**
     * @abstract
     * @return {?}
     */
    DomAdapter.prototype.getAnimationPrefix = function () { };
    /**
     * @abstract
     * @return {?}
     */
    DomAdapter.prototype.getTransitionEnd = function () { };
    /**
     * @abstract
     * @return {?}
     */
    DomAdapter.prototype.supportsAnimation = function () { };
    /**
     * @abstract
     * @return {?}
     */
    DomAdapter.prototype.supportsCookies = function () { };
    /**
     * @abstract
     * @param {?} name
     * @return {?}
     */
    DomAdapter.prototype.getCookie = function (name) { };
    /**
     * @abstract
     * @param {?} name
     * @param {?} value
     * @return {?}
     */
    DomAdapter.prototype.setCookie = function (name, value) { };
    return DomAdapter;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Provides DOM operations in any browser environment.
 *
 * \@security Tread carefully! Interacting with the DOM directly is dangerous and
 * can introduce XSS risks.
 * @abstract
 */
var GenericBrowserDomAdapter = (function (_super) {
    __extends(GenericBrowserDomAdapter, _super);
    function GenericBrowserDomAdapter() {
        var _this = _super.call(this) || this;
        _this._animationPrefix = null;
        _this._transitionEnd = null;
        try {
            var element_1 = _this.createElement('div', document);
            if (_this.getStyle(element_1, 'animationName') != null) {
                _this._animationPrefix = '';
            }
            else {
                var domPrefixes = ['Webkit', 'Moz', 'O', 'ms'];
                for (var i = 0; i < domPrefixes.length; i++) {
                    if (_this.getStyle(element_1, domPrefixes[i] + 'AnimationName') != null) {
                        _this._animationPrefix = '-' + domPrefixes[i].toLowerCase() + '-';
                        break;
                    }
                }
            }
            var transEndEventNames_1 = {
                WebkitTransition: 'webkitTransitionEnd',
                MozTransition: 'transitionend',
                OTransition: 'oTransitionEnd otransitionend',
                transition: 'transitionend'
            };
            Object.keys(transEndEventNames_1).forEach(function (key) {
                if (_this.getStyle(element_1, key) != null) {
                    _this._transitionEnd = transEndEventNames_1[key];
                }
            });
        }
        catch (e) {
            _this._animationPrefix = null;
            _this._transitionEnd = null;
        }
        return _this;
    }
    /**
     * @param {?} el
     * @return {?}
     */
    GenericBrowserDomAdapter.prototype.getDistributedNodes = function (el) { return ((el)).getDistributedNodes(); };
    /**
     * @param {?} el
     * @param {?} baseUrl
     * @param {?} href
     * @return {?}
     */
    GenericBrowserDomAdapter.prototype.resolveAndSetHref = function (el, baseUrl, href) {
        el.href = href == null ? baseUrl : baseUrl + '/../' + href;
    };
    /**
     * @return {?}
     */
    GenericBrowserDomAdapter.prototype.supportsDOMEvents = function () { return true; };
    /**
     * @return {?}
     */
    GenericBrowserDomAdapter.prototype.supportsNativeShadowDOM = function () {
        return typeof ((document.body)).createShadowRoot === 'function';
    };
    /**
     * @return {?}
     */
    GenericBrowserDomAdapter.prototype.getAnimationPrefix = function () { return this._animationPrefix ? this._animationPrefix : ''; };
    /**
     * @return {?}
     */
    GenericBrowserDomAdapter.prototype.getTransitionEnd = function () { return this._transitionEnd ? this._transitionEnd : ''; };
    /**
     * @return {?}
     */
    GenericBrowserDomAdapter.prototype.supportsAnimation = function () {
        return this._animationPrefix != null && this._transitionEnd != null;
    };
    return GenericBrowserDomAdapter;
}(DomAdapter));
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var _attrToPropMap = {
    'class': 'className',
    'innerHtml': 'innerHTML',
    'readonly': 'readOnly',
    'tabindex': 'tabIndex',
};
var DOM_KEY_LOCATION_NUMPAD = 3;
// Map to convert some key or keyIdentifier values to what will be returned by getEventKey
var _keyMap = {
    // The following values are here for cross-browser compatibility and to match the W3C standard
    // cf http://www.w3.org/TR/DOM-Level-3-Events-key/
    '\b': 'Backspace',
    '\t': 'Tab',
    '\x7F': 'Delete',
    '\x1B': 'Escape',
    'Del': 'Delete',
    'Esc': 'Escape',
    'Left': 'ArrowLeft',
    'Right': 'ArrowRight',
    'Up': 'ArrowUp',
    'Down': 'ArrowDown',
    'Menu': 'ContextMenu',
    'Scroll': 'ScrollLock',
    'Win': 'OS'
};
// There is a bug in Chrome for numeric keypad keys:
// https://code.google.com/p/chromium/issues/detail?id=155654
// 1, 2, 3 ... are reported as A, B, C ...
var _chromeNumKeyPadMap = {
    'A': '1',
    'B': '2',
    'C': '3',
    'D': '4',
    'E': '5',
    'F': '6',
    'G': '7',
    'H': '8',
    'I': '9',
    'J': '*',
    'K': '+',
    'M': '-',
    'N': '.',
    'O': '/',
    '\x60': '0',
    '\x90': 'NumLock'
};
var nodeContains;
if (__WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵglobal"]['Node']) {
    nodeContains = __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵglobal"]['Node'].prototype.contains || function (node) {
        return !!(this.compareDocumentPosition(node) & 16);
    };
}
var BrowserDomAdapter = (function (_super) {
    __extends(BrowserDomAdapter, _super);
    function BrowserDomAdapter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @param {?} templateHtml
     * @return {?}
     */
    BrowserDomAdapter.prototype.parse = function (templateHtml) { throw new Error('parse not implemented'); };
    /**
     * @return {?}
     */
    BrowserDomAdapter.makeCurrent = function () { setRootDomAdapter(new BrowserDomAdapter()); };
    /**
     * @param {?} element
     * @param {?} name
     * @return {?}
     */
    BrowserDomAdapter.prototype.hasProperty = function (element, name) { return name in element; };
    /**
     * @param {?} el
     * @param {?} name
     * @param {?} value
     * @return {?}
     */
    BrowserDomAdapter.prototype.setProperty = function (el, name, value) { ((el))[name] = value; };
    /**
     * @param {?} el
     * @param {?} name
     * @return {?}
     */
    BrowserDomAdapter.prototype.getProperty = function (el, name) { return ((el))[name]; };
    /**
     * @param {?} el
     * @param {?} methodName
     * @param {?} args
     * @return {?}
     */
    BrowserDomAdapter.prototype.invoke = function (el, methodName, args) { ((el))[methodName].apply(((el)), args); };
    /**
     * @param {?} error
     * @return {?}
     */
    BrowserDomAdapter.prototype.logError = function (error) {
        if (window.console) {
            if (console.error) {
                console.error(error);
            }
            else {
                console.log(error);
            }
        }
    };
    /**
     * @param {?} error
     * @return {?}
     */
    BrowserDomAdapter.prototype.log = function (error) {
        if (window.console) {
            window.console.log && window.console.log(error);
        }
    };
    /**
     * @param {?} error
     * @return {?}
     */
    BrowserDomAdapter.prototype.logGroup = function (error) {
        if (window.console) {
            window.console.group && window.console.group(error);
        }
    };
    /**
     * @return {?}
     */
    BrowserDomAdapter.prototype.logGroupEnd = function () {
        if (window.console) {
            window.console.groupEnd && window.console.groupEnd();
        }
    };
    Object.defineProperty(BrowserDomAdapter.prototype, "attrToPropMap", {
        /**
         * @return {?}
         */
        get: function () { return _attrToPropMap; },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} nodeA
     * @param {?} nodeB
     * @return {?}
     */
    BrowserDomAdapter.prototype.contains = function (nodeA, nodeB) { return nodeContains.call(nodeA, nodeB); };
    /**
     * @param {?} el
     * @param {?} selector
     * @return {?}
     */
    BrowserDomAdapter.prototype.querySelector = function (el, selector) { return el.querySelector(selector); };
    /**
     * @param {?} el
     * @param {?} selector
     * @return {?}
     */
    BrowserDomAdapter.prototype.querySelectorAll = function (el, selector) { return el.querySelectorAll(selector); };
    /**
     * @param {?} el
     * @param {?} evt
     * @param {?} listener
     * @return {?}
     */
    BrowserDomAdapter.prototype.on = function (el, evt, listener) { el.addEventListener(evt, listener, false); };
    /**
     * @param {?} el
     * @param {?} evt
     * @param {?} listener
     * @return {?}
     */
    BrowserDomAdapter.prototype.onAndCancel = function (el, evt, listener) {
        el.addEventListener(evt, listener, false);
        // Needed to follow Dart's subscription semantic, until fix of
        // https://code.google.com/p/dart/issues/detail?id=17406
        return function () { el.removeEventListener(evt, listener, false); };
    };
    /**
     * @param {?} el
     * @param {?} evt
     * @return {?}
     */
    BrowserDomAdapter.prototype.dispatchEvent = function (el, evt) { el.dispatchEvent(evt); };
    /**
     * @param {?} eventType
     * @return {?}
     */
    BrowserDomAdapter.prototype.createMouseEvent = function (eventType) {
        var /** @type {?} */ evt = document.createEvent('MouseEvent');
        evt.initEvent(eventType, true, true);
        return evt;
    };
    /**
     * @param {?} eventType
     * @return {?}
     */
    BrowserDomAdapter.prototype.createEvent = function (eventType) {
        var /** @type {?} */ evt = document.createEvent('Event');
        evt.initEvent(eventType, true, true);
        return evt;
    };
    /**
     * @param {?} evt
     * @return {?}
     */
    BrowserDomAdapter.prototype.preventDefault = function (evt) {
        evt.preventDefault();
        evt.returnValue = false;
    };
    /**
     * @param {?} evt
     * @return {?}
     */
    BrowserDomAdapter.prototype.isPrevented = function (evt) {
        return evt.defaultPrevented || evt.returnValue != null && !evt.returnValue;
    };
    /**
     * @param {?} el
     * @return {?}
     */
    BrowserDomAdapter.prototype.getInnerHTML = function (el) { return el.innerHTML; };
    /**
     * @param {?} el
     * @return {?}
     */
    BrowserDomAdapter.prototype.getTemplateContent = function (el) {
        return 'content' in el && el instanceof HTMLTemplateElement ? el.content : null;
    };
    /**
     * @param {?} el
     * @return {?}
     */
    BrowserDomAdapter.prototype.getOuterHTML = function (el) { return el.outerHTML; };
    /**
     * @param {?} node
     * @return {?}
     */
    BrowserDomAdapter.prototype.nodeName = function (node) { return node.nodeName; };
    /**
     * @param {?} node
     * @return {?}
     */
    BrowserDomAdapter.prototype.nodeValue = function (node) { return node.nodeValue; };
    /**
     * @param {?} node
     * @return {?}
     */
    BrowserDomAdapter.prototype.type = function (node) { return node.type; };
    /**
     * @param {?} node
     * @return {?}
     */
    BrowserDomAdapter.prototype.content = function (node) {
        if (this.hasProperty(node, 'content')) {
            return ((node)).content;
        }
        else {
            return node;
        }
    };
    /**
     * @param {?} el
     * @return {?}
     */
    BrowserDomAdapter.prototype.firstChild = function (el) { return el.firstChild; };
    /**
     * @param {?} el
     * @return {?}
     */
    BrowserDomAdapter.prototype.nextSibling = function (el) { return el.nextSibling; };
    /**
     * @param {?} el
     * @return {?}
     */
    BrowserDomAdapter.prototype.parentElement = function (el) { return el.parentNode; };
    /**
     * @param {?} el
     * @return {?}
     */
    BrowserDomAdapter.prototype.childNodes = function (el) { return el.childNodes; };
    /**
     * @param {?} el
     * @return {?}
     */
    BrowserDomAdapter.prototype.childNodesAsList = function (el) {
        var /** @type {?} */ childNodes = el.childNodes;
        var /** @type {?} */ res = new Array(childNodes.length);
        for (var /** @type {?} */ i = 0; i < childNodes.length; i++) {
            res[i] = childNodes[i];
        }
        return res;
    };
    /**
     * @param {?} el
     * @return {?}
     */
    BrowserDomAdapter.prototype.clearNodes = function (el) {
        while (el.firstChild) {
            el.removeChild(el.firstChild);
        }
    };
    /**
     * @param {?} el
     * @param {?} node
     * @return {?}
     */
    BrowserDomAdapter.prototype.appendChild = function (el, node) { el.appendChild(node); };
    /**
     * @param {?} el
     * @param {?} node
     * @return {?}
     */
    BrowserDomAdapter.prototype.removeChild = function (el, node) { el.removeChild(node); };
    /**
     * @param {?} el
     * @param {?} newChild
     * @param {?} oldChild
     * @return {?}
     */
    BrowserDomAdapter.prototype.replaceChild = function (el, newChild, oldChild) { el.replaceChild(newChild, oldChild); };
    /**
     * @param {?} node
     * @return {?}
     */
    BrowserDomAdapter.prototype.remove = function (node) {
        if (node.parentNode) {
            node.parentNode.removeChild(node);
        }
        return node;
    };
    /**
     * @param {?} parent
     * @param {?} ref
     * @param {?} node
     * @return {?}
     */
    BrowserDomAdapter.prototype.insertBefore = function (parent, ref, node) { parent.insertBefore(node, ref); };
    /**
     * @param {?} parent
     * @param {?} ref
     * @param {?} nodes
     * @return {?}
     */
    BrowserDomAdapter.prototype.insertAllBefore = function (parent, ref, nodes) {
        nodes.forEach(function (n) { return parent.insertBefore(n, ref); });
    };
    /**
     * @param {?} parent
     * @param {?} ref
     * @param {?} node
     * @return {?}
     */
    BrowserDomAdapter.prototype.insertAfter = function (parent, ref, node) { parent.insertBefore(node, ref.nextSibling); };
    /**
     * @param {?} el
     * @param {?} value
     * @return {?}
     */
    BrowserDomAdapter.prototype.setInnerHTML = function (el, value) { el.innerHTML = value; };
    /**
     * @param {?} el
     * @return {?}
     */
    BrowserDomAdapter.prototype.getText = function (el) { return el.textContent; };
    /**
     * @param {?} el
     * @param {?} value
     * @return {?}
     */
    BrowserDomAdapter.prototype.setText = function (el, value) { el.textContent = value; };
    /**
     * @param {?} el
     * @return {?}
     */
    BrowserDomAdapter.prototype.getValue = function (el) { return el.value; };
    /**
     * @param {?} el
     * @param {?} value
     * @return {?}
     */
    BrowserDomAdapter.prototype.setValue = function (el, value) { el.value = value; };
    /**
     * @param {?} el
     * @return {?}
     */
    BrowserDomAdapter.prototype.getChecked = function (el) { return el.checked; };
    /**
     * @param {?} el
     * @param {?} value
     * @return {?}
     */
    BrowserDomAdapter.prototype.setChecked = function (el, value) { el.checked = value; };
    /**
     * @param {?} text
     * @return {?}
     */
    BrowserDomAdapter.prototype.createComment = function (text) { return document.createComment(text); };
    /**
     * @param {?} html
     * @return {?}
     */
    BrowserDomAdapter.prototype.createTemplate = function (html) {
        var /** @type {?} */ t = document.createElement('template');
        t.innerHTML = html;
        return t;
    };
    /**
     * @param {?} tagName
     * @param {?=} doc
     * @return {?}
     */
    BrowserDomAdapter.prototype.createElement = function (tagName, doc) {
        if (doc === void 0) { doc = document; }
        return doc.createElement(tagName);
    };
    /**
     * @param {?} ns
     * @param {?} tagName
     * @param {?=} doc
     * @return {?}
     */
    BrowserDomAdapter.prototype.createElementNS = function (ns, tagName, doc) {
        if (doc === void 0) { doc = document; }
        return doc.createElementNS(ns, tagName);
    };
    /**
     * @param {?} text
     * @param {?=} doc
     * @return {?}
     */
    BrowserDomAdapter.prototype.createTextNode = function (text, doc) {
        if (doc === void 0) { doc = document; }
        return doc.createTextNode(text);
    };
    /**
     * @param {?} attrName
     * @param {?} attrValue
     * @param {?=} doc
     * @return {?}
     */
    BrowserDomAdapter.prototype.createScriptTag = function (attrName, attrValue, doc) {
        if (doc === void 0) { doc = document; }
        var /** @type {?} */ el = (doc.createElement('SCRIPT'));
        el.setAttribute(attrName, attrValue);
        return el;
    };
    /**
     * @param {?} css
     * @param {?=} doc
     * @return {?}
     */
    BrowserDomAdapter.prototype.createStyleElement = function (css, doc) {
        if (doc === void 0) { doc = document; }
        var /** @type {?} */ style = (doc.createElement('style'));
        this.appendChild(style, this.createTextNode(css));
        return style;
    };
    /**
     * @param {?} el
     * @return {?}
     */
    BrowserDomAdapter.prototype.createShadowRoot = function (el) { return ((el)).createShadowRoot(); };
    /**
     * @param {?} el
     * @return {?}
     */
    BrowserDomAdapter.prototype.getShadowRoot = function (el) { return ((el)).shadowRoot; };
    /**
     * @param {?} el
     * @return {?}
     */
    BrowserDomAdapter.prototype.getHost = function (el) { return ((el)).host; };
    /**
     * @param {?} node
     * @return {?}
     */
    BrowserDomAdapter.prototype.clone = function (node) { return node.cloneNode(true); };
    /**
     * @param {?} element
     * @param {?} name
     * @return {?}
     */
    BrowserDomAdapter.prototype.getElementsByClassName = function (element, name) {
        return element.getElementsByClassName(name);
    };
    /**
     * @param {?} element
     * @param {?} name
     * @return {?}
     */
    BrowserDomAdapter.prototype.getElementsByTagName = function (element, name) {
        return element.getElementsByTagName(name);
    };
    /**
     * @param {?} element
     * @return {?}
     */
    BrowserDomAdapter.prototype.classList = function (element) { return Array.prototype.slice.call(element.classList, 0); };
    /**
     * @param {?} element
     * @param {?} className
     * @return {?}
     */
    BrowserDomAdapter.prototype.addClass = function (element, className) { element.classList.add(className); };
    /**
     * @param {?} element
     * @param {?} className
     * @return {?}
     */
    BrowserDomAdapter.prototype.removeClass = function (element, className) { element.classList.remove(className); };
    /**
     * @param {?} element
     * @param {?} className
     * @return {?}
     */
    BrowserDomAdapter.prototype.hasClass = function (element, className) {
        return element.classList.contains(className);
    };
    /**
     * @param {?} element
     * @param {?} styleName
     * @param {?} styleValue
     * @return {?}
     */
    BrowserDomAdapter.prototype.setStyle = function (element, styleName, styleValue) {
        element.style[styleName] = styleValue;
    };
    /**
     * @param {?} element
     * @param {?} stylename
     * @return {?}
     */
    BrowserDomAdapter.prototype.removeStyle = function (element, stylename) {
        // IE requires '' instead of null
        // see https://github.com/angular/angular/issues/7916
        element.style[stylename] = '';
    };
    /**
     * @param {?} element
     * @param {?} stylename
     * @return {?}
     */
    BrowserDomAdapter.prototype.getStyle = function (element, stylename) { return element.style[stylename]; };
    /**
     * @param {?} element
     * @param {?} styleName
     * @param {?=} styleValue
     * @return {?}
     */
    BrowserDomAdapter.prototype.hasStyle = function (element, styleName, styleValue) {
        var /** @type {?} */ value = this.getStyle(element, styleName) || '';
        return styleValue ? value == styleValue : value.length > 0;
    };
    /**
     * @param {?} element
     * @return {?}
     */
    BrowserDomAdapter.prototype.tagName = function (element) { return element.tagName; };
    /**
     * @param {?} element
     * @return {?}
     */
    BrowserDomAdapter.prototype.attributeMap = function (element) {
        var /** @type {?} */ res = new Map();
        var /** @type {?} */ elAttrs = element.attributes;
        for (var /** @type {?} */ i = 0; i < elAttrs.length; i++) {
            var /** @type {?} */ attrib = elAttrs[i];
            res.set(attrib.name, attrib.value);
        }
        return res;
    };
    /**
     * @param {?} element
     * @param {?} attribute
     * @return {?}
     */
    BrowserDomAdapter.prototype.hasAttribute = function (element, attribute) {
        return element.hasAttribute(attribute);
    };
    /**
     * @param {?} element
     * @param {?} ns
     * @param {?} attribute
     * @return {?}
     */
    BrowserDomAdapter.prototype.hasAttributeNS = function (element, ns, attribute) {
        return element.hasAttributeNS(ns, attribute);
    };
    /**
     * @param {?} element
     * @param {?} attribute
     * @return {?}
     */
    BrowserDomAdapter.prototype.getAttribute = function (element, attribute) {
        return element.getAttribute(attribute);
    };
    /**
     * @param {?} element
     * @param {?} ns
     * @param {?} name
     * @return {?}
     */
    BrowserDomAdapter.prototype.getAttributeNS = function (element, ns, name) {
        return element.getAttributeNS(ns, name);
    };
    /**
     * @param {?} element
     * @param {?} name
     * @param {?} value
     * @return {?}
     */
    BrowserDomAdapter.prototype.setAttribute = function (element, name, value) { element.setAttribute(name, value); };
    /**
     * @param {?} element
     * @param {?} ns
     * @param {?} name
     * @param {?} value
     * @return {?}
     */
    BrowserDomAdapter.prototype.setAttributeNS = function (element, ns, name, value) {
        element.setAttributeNS(ns, name, value);
    };
    /**
     * @param {?} element
     * @param {?} attribute
     * @return {?}
     */
    BrowserDomAdapter.prototype.removeAttribute = function (element, attribute) { element.removeAttribute(attribute); };
    /**
     * @param {?} element
     * @param {?} ns
     * @param {?} name
     * @return {?}
     */
    BrowserDomAdapter.prototype.removeAttributeNS = function (element, ns, name) {
        element.removeAttributeNS(ns, name);
    };
    /**
     * @param {?} el
     * @return {?}
     */
    BrowserDomAdapter.prototype.templateAwareRoot = function (el) { return this.isTemplateElement(el) ? this.content(el) : el; };
    /**
     * @return {?}
     */
    BrowserDomAdapter.prototype.createHtmlDocument = function () {
        return document.implementation.createHTMLDocument('fakeTitle');
    };
    /**
     * @param {?} el
     * @return {?}
     */
    BrowserDomAdapter.prototype.getBoundingClientRect = function (el) {
        try {
            return el.getBoundingClientRect();
        }
        catch (e) {
            return { top: 0, bottom: 0, left: 0, right: 0, width: 0, height: 0 };
        }
    };
    /**
     * @param {?} doc
     * @return {?}
     */
    BrowserDomAdapter.prototype.getTitle = function (doc) { return document.title; };
    /**
     * @param {?} doc
     * @param {?} newTitle
     * @return {?}
     */
    BrowserDomAdapter.prototype.setTitle = function (doc, newTitle) { document.title = newTitle || ''; };
    /**
     * @param {?} n
     * @param {?} selector
     * @return {?}
     */
    BrowserDomAdapter.prototype.elementMatches = function (n, selector) {
        if (n instanceof HTMLElement) {
            return n.matches && n.matches(selector) ||
                n.msMatchesSelector && n.msMatchesSelector(selector) ||
                n.webkitMatchesSelector && n.webkitMatchesSelector(selector);
        }
        return false;
    };
    /**
     * @param {?} el
     * @return {?}
     */
    BrowserDomAdapter.prototype.isTemplateElement = function (el) {
        return el instanceof HTMLElement && el.nodeName == 'TEMPLATE';
    };
    /**
     * @param {?} node
     * @return {?}
     */
    BrowserDomAdapter.prototype.isTextNode = function (node) { return node.nodeType === Node.TEXT_NODE; };
    /**
     * @param {?} node
     * @return {?}
     */
    BrowserDomAdapter.prototype.isCommentNode = function (node) { return node.nodeType === Node.COMMENT_NODE; };
    /**
     * @param {?} node
     * @return {?}
     */
    BrowserDomAdapter.prototype.isElementNode = function (node) { return node.nodeType === Node.ELEMENT_NODE; };
    /**
     * @param {?} node
     * @return {?}
     */
    BrowserDomAdapter.prototype.hasShadowRoot = function (node) {
        return node.shadowRoot != null && node instanceof HTMLElement;
    };
    /**
     * @param {?} node
     * @return {?}
     */
    BrowserDomAdapter.prototype.isShadowRoot = function (node) { return node instanceof DocumentFragment; };
    /**
     * @param {?} node
     * @return {?}
     */
    BrowserDomAdapter.prototype.importIntoDoc = function (node) { return document.importNode(this.templateAwareRoot(node), true); };
    /**
     * @param {?} node
     * @return {?}
     */
    BrowserDomAdapter.prototype.adoptNode = function (node) { return document.adoptNode(node); };
    /**
     * @param {?} el
     * @return {?}
     */
    BrowserDomAdapter.prototype.getHref = function (el) { return ((el)).href; };
    /**
     * @param {?} event
     * @return {?}
     */
    BrowserDomAdapter.prototype.getEventKey = function (event) {
        var /** @type {?} */ key = event.key;
        if (key == null) {
            key = event.keyIdentifier;
            // keyIdentifier is defined in the old draft of DOM Level 3 Events implemented by Chrome and
            // Safari cf
            // http://www.w3.org/TR/2007/WD-DOM-Level-3-Events-20071221/events.html#Events-KeyboardEvents-Interfaces
            if (key == null) {
                return 'Unidentified';
            }
            if (key.startsWith('U+')) {
                key = String.fromCharCode(parseInt(key.substring(2), 16));
                if (event.location === DOM_KEY_LOCATION_NUMPAD && _chromeNumKeyPadMap.hasOwnProperty(key)) {
                    // There is a bug in Chrome for numeric keypad keys:
                    // https://code.google.com/p/chromium/issues/detail?id=155654
                    // 1, 2, 3 ... are reported as A, B, C ...
                    key = ((_chromeNumKeyPadMap))[key];
                }
            }
        }
        return _keyMap[key] || key;
    };
    /**
     * @param {?} doc
     * @param {?} target
     * @return {?}
     */
    BrowserDomAdapter.prototype.getGlobalEventTarget = function (doc, target) {
        if (target === 'window') {
            return window;
        }
        if (target === 'document') {
            return document;
        }
        if (target === 'body') {
            return document.body;
        }
        return null;
    };
    /**
     * @return {?}
     */
    BrowserDomAdapter.prototype.getHistory = function () { return window.history; };
    /**
     * @return {?}
     */
    BrowserDomAdapter.prototype.getLocation = function () { return window.location; };
    /**
     * @param {?} doc
     * @return {?}
     */
    BrowserDomAdapter.prototype.getBaseHref = function (doc) {
        var /** @type {?} */ href = getBaseElementHref();
        return href == null ? null : relativePath(href);
    };
    /**
     * @return {?}
     */
    BrowserDomAdapter.prototype.resetBaseElement = function () { baseElement = null; };
    /**
     * @return {?}
     */
    BrowserDomAdapter.prototype.getUserAgent = function () { return window.navigator.userAgent; };
    /**
     * @param {?} element
     * @param {?} name
     * @param {?} value
     * @return {?}
     */
    BrowserDomAdapter.prototype.setData = function (element, name, value) {
        this.setAttribute(element, 'data-' + name, value);
    };
    /**
     * @param {?} element
     * @param {?} name
     * @return {?}
     */
    BrowserDomAdapter.prototype.getData = function (element, name) {
        return this.getAttribute(element, 'data-' + name);
    };
    /**
     * @param {?} element
     * @return {?}
     */
    BrowserDomAdapter.prototype.getComputedStyle = function (element) { return getComputedStyle(element); };
    /**
     * @param {?} path
     * @param {?} value
     * @return {?}
     */
    BrowserDomAdapter.prototype.setGlobalVar = function (path, value) { setValueOnPath(__WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵglobal"], path, value); };
    /**
     * @return {?}
     */
    BrowserDomAdapter.prototype.supportsWebAnimation = function () {
        return typeof ((Element)).prototype['animate'] === 'function';
    };
    /**
     * @return {?}
     */
    BrowserDomAdapter.prototype.performanceNow = function () {
        // performance.now() is not available in all browsers, see
        // http://caniuse.com/#search=performance.now
        return window.performance && window.performance.now ? window.performance.now() :
            new Date().getTime();
    };
    /**
     * @return {?}
     */
    BrowserDomAdapter.prototype.supportsCookies = function () { return true; };
    /**
     * @param {?} name
     * @return {?}
     */
    BrowserDomAdapter.prototype.getCookie = function (name) { return parseCookieValue(document.cookie, name); };
    /**
     * @param {?} name
     * @param {?} value
     * @return {?}
     */
    BrowserDomAdapter.prototype.setCookie = function (name, value) {
        // document.cookie is magical, assigning into it assigns/overrides one cookie value, but does
        // not clear other cookies.
        document.cookie = encodeURIComponent(name) + '=' + encodeURIComponent(value);
    };
    return BrowserDomAdapter;
}(GenericBrowserDomAdapter));
var baseElement = null;
/**
 * @return {?}
 */
function getBaseElementHref() {
    if (!baseElement) {
        baseElement = ((document.querySelector('base')));
        if (!baseElement) {
            return null;
        }
    }
    return baseElement.getAttribute('href');
}
// based on urlUtils.js in AngularJS 1
var urlParsingNode;
/**
 * @param {?} url
 * @return {?}
 */
function relativePath(url) {
    if (!urlParsingNode) {
        urlParsingNode = document.createElement('a');
    }
    urlParsingNode.setAttribute('href', url);
    return (urlParsingNode.pathname.charAt(0) === '/') ? urlParsingNode.pathname :
        '/' + urlParsingNode.pathname;
}
/**
 * @param {?} cookieStr
 * @param {?} name
 * @return {?}
 */
function parseCookieValue(cookieStr, name) {
    name = encodeURIComponent(name);
    for (var _i = 0, _a = cookieStr.split(';'); _i < _a.length; _i++) {
        var cookie = _a[_i];
        var /** @type {?} */ eqIndex = cookie.indexOf('=');
        var _b = eqIndex == -1 ? [cookie, ''] : [cookie.slice(0, eqIndex), cookie.slice(eqIndex + 1)], cookieName = _b[0], cookieValue = _b[1];
        if (cookieName.trim() === name) {
            return decodeURIComponent(cookieValue);
        }
    }
    return null;
}
/**
 * @param {?} global
 * @param {?} path
 * @param {?} value
 * @return {?}
 */
function setValueOnPath(global, path, value) {
    var /** @type {?} */ parts = path.split('.');
    var /** @type {?} */ obj = global;
    while (parts.length > 1) {
        var /** @type {?} */ name = ((parts.shift()));
        if (obj.hasOwnProperty(name) && obj[name] != null) {
            obj = obj[name];
        }
        else {
            obj = obj[name] = {};
        }
    }
    if (obj === undefined || obj === null) {
        obj = {};
    }
    obj[((parts.shift()))] = value;
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * A DI Token representing the main rendering context. In a browser this is the DOM Document.
 *
 * Note: Document might not be available in the Application Context when Application and Rendering
 * Contexts are not the same (e.g. when running the application into a Web Worker).
 *
 * \@stable
 */
var DOCUMENT = new __WEBPACK_IMPORTED_MODULE_1__angular_core__["InjectionToken"]('DocumentToken');
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 * @return {?}
 */
function supportsState() {
    return !!window.history.pushState;
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * `PlatformLocation` encapsulates all of the direct calls to platform APIs.
 * This class should not be used directly by an application developer. Instead, use
 * {\@link Location}.
 */
var BrowserPlatformLocation = (function (_super) {
    __extends(BrowserPlatformLocation, _super);
    /**
     * @param {?} _doc
     */
    function BrowserPlatformLocation(_doc) {
        var _this = _super.call(this) || this;
        _this._doc = _doc;
        _this._init();
        return _this;
    }
    /**
     * \@internal
     * @return {?}
     */
    BrowserPlatformLocation.prototype._init = function () {
        this._location = getDOM().getLocation();
        this._history = getDOM().getHistory();
    };
    Object.defineProperty(BrowserPlatformLocation.prototype, "location", {
        /**
         * @return {?}
         */
        get: function () { return this._location; },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    BrowserPlatformLocation.prototype.getBaseHrefFromDOM = function () { return ((getDOM().getBaseHref(this._doc))); };
    /**
     * @param {?} fn
     * @return {?}
     */
    BrowserPlatformLocation.prototype.onPopState = function (fn) {
        getDOM().getGlobalEventTarget(this._doc, 'window').addEventListener('popstate', fn, false);
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    BrowserPlatformLocation.prototype.onHashChange = function (fn) {
        getDOM().getGlobalEventTarget(this._doc, 'window').addEventListener('hashchange', fn, false);
    };
    Object.defineProperty(BrowserPlatformLocation.prototype, "pathname", {
        /**
         * @return {?}
         */
        get: function () { return this._location.pathname; },
        /**
         * @param {?} newPath
         * @return {?}
         */
        set: function (newPath) { this._location.pathname = newPath; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BrowserPlatformLocation.prototype, "search", {
        /**
         * @return {?}
         */
        get: function () { return this._location.search; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BrowserPlatformLocation.prototype, "hash", {
        /**
         * @return {?}
         */
        get: function () { return this._location.hash; },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} state
     * @param {?} title
     * @param {?} url
     * @return {?}
     */
    BrowserPlatformLocation.prototype.pushState = function (state, title, url) {
        if (supportsState()) {
            this._history.pushState(state, title, url);
        }
        else {
            this._location.hash = url;
        }
    };
    /**
     * @param {?} state
     * @param {?} title
     * @param {?} url
     * @return {?}
     */
    BrowserPlatformLocation.prototype.replaceState = function (state, title, url) {
        if (supportsState()) {
            this._history.replaceState(state, title, url);
        }
        else {
            this._location.hash = url;
        }
    };
    /**
     * @return {?}
     */
    BrowserPlatformLocation.prototype.forward = function () { this._history.forward(); };
    /**
     * @return {?}
     */
    BrowserPlatformLocation.prototype.back = function () { this._history.back(); };
    return BrowserPlatformLocation;
}(__WEBPACK_IMPORTED_MODULE_0__angular_common__["PlatformLocation"]));
BrowserPlatformLocation.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Injectable"] },
];
/**
 * @nocollapse
 */
BrowserPlatformLocation.ctorParameters = function () { return [
    { type: undefined, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"], args: [DOCUMENT,] },] },
]; };
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * A service that can be used to get and add meta tags.
 *
 * \@experimental
 */
var Meta = (function () {
    /**
     * @param {?} _doc
     */
    function Meta(_doc) {
        this._doc = _doc;
        this._dom = getDOM();
    }
    /**
     * @param {?} tag
     * @param {?=} forceCreation
     * @return {?}
     */
    Meta.prototype.addTag = function (tag, forceCreation) {
        if (forceCreation === void 0) { forceCreation = false; }
        if (!tag)
            return null;
        return this._getOrCreateElement(tag, forceCreation);
    };
    /**
     * @param {?} tags
     * @param {?=} forceCreation
     * @return {?}
     */
    Meta.prototype.addTags = function (tags, forceCreation) {
        var _this = this;
        if (forceCreation === void 0) { forceCreation = false; }
        if (!tags)
            return [];
        return tags.reduce(function (result, tag) {
            if (tag) {
                result.push(_this._getOrCreateElement(tag, forceCreation));
            }
            return result;
        }, []);
    };
    /**
     * @param {?} attrSelector
     * @return {?}
     */
    Meta.prototype.getTag = function (attrSelector) {
        if (!attrSelector)
            return null;
        return this._dom.querySelector(this._doc, "meta[" + attrSelector + "]");
    };
    /**
     * @param {?} attrSelector
     * @return {?}
     */
    Meta.prototype.getTags = function (attrSelector) {
        if (!attrSelector)
            return [];
        var /** @type {?} */ list /*NodeList*/ = this._dom.querySelectorAll(this._doc, "meta[" + attrSelector + "]");
        return list ? [].slice.call(list) : [];
    };
    /**
     * @param {?} tag
     * @param {?=} selector
     * @return {?}
     */
    Meta.prototype.updateTag = function (tag, selector) {
        if (!tag)
            return null;
        selector = selector || this._parseSelector(tag);
        var /** @type {?} */ meta = ((this.getTag(selector)));
        if (meta) {
            return this._setMetaElementAttributes(tag, meta);
        }
        return this._getOrCreateElement(tag, true);
    };
    /**
     * @param {?} attrSelector
     * @return {?}
     */
    Meta.prototype.removeTag = function (attrSelector) { this.removeTagElement(/** @type {?} */ ((this.getTag(attrSelector)))); };
    /**
     * @param {?} meta
     * @return {?}
     */
    Meta.prototype.removeTagElement = function (meta) {
        if (meta) {
            this._dom.remove(meta);
        }
    };
    /**
     * @param {?} meta
     * @param {?=} forceCreation
     * @return {?}
     */
    Meta.prototype._getOrCreateElement = function (meta, forceCreation) {
        if (forceCreation === void 0) { forceCreation = false; }
        if (!forceCreation) {
            var /** @type {?} */ selector = this._parseSelector(meta);
            var /** @type {?} */ elem = ((this.getTag(selector)));
            // It's allowed to have multiple elements with the same name so it's not enough to
            // just check that element with the same name already present on the page. We also need to
            // check if element has tag attributes
            if (elem && this._containsAttributes(meta, elem))
                return elem;
        }
        var /** @type {?} */ element = (this._dom.createElement('meta'));
        this._setMetaElementAttributes(meta, element);
        var /** @type {?} */ head = this._dom.getElementsByTagName(this._doc, 'head')[0];
        this._dom.appendChild(head, element);
        return element;
    };
    /**
     * @param {?} tag
     * @param {?} el
     * @return {?}
     */
    Meta.prototype._setMetaElementAttributes = function (tag, el) {
        var _this = this;
        Object.keys(tag).forEach(function (prop) { return _this._dom.setAttribute(el, prop, tag[prop]); });
        return el;
    };
    /**
     * @param {?} tag
     * @return {?}
     */
    Meta.prototype._parseSelector = function (tag) {
        var /** @type {?} */ attr = tag.name ? 'name' : 'property';
        return attr + "=\"" + tag[attr] + "\"";
    };
    /**
     * @param {?} tag
     * @param {?} elem
     * @return {?}
     */
    Meta.prototype._containsAttributes = function (tag, elem) {
        var _this = this;
        return Object.keys(tag).every(function (key) { return _this._dom.getAttribute(elem, key) === tag[key]; });
    };
    return Meta;
}());
Meta.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Injectable"] },
];
/**
 * @nocollapse
 */
Meta.ctorParameters = function () { return [
    { type: undefined, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"], args: [DOCUMENT,] },] },
]; };
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * An id that identifies a particular application being bootstrapped, that should
 * match across the client/server boundary.
 */
var TRANSITION_ID = new __WEBPACK_IMPORTED_MODULE_1__angular_core__["InjectionToken"]('TRANSITION_ID');
/**
 * @param {?} transitionId
 * @param {?} document
 * @return {?}
 */
function bootstrapListenerFactory(transitionId, document) {
    var /** @type {?} */ factory = function () {
        var /** @type {?} */ dom = getDOM();
        var /** @type {?} */ styles = Array.prototype.slice.apply(dom.querySelectorAll(document, "style[ng-transition]"));
        styles.filter(function (el) { return dom.getAttribute(el, 'ng-transition') === transitionId; })
            .forEach(function (el) { return dom.remove(el); });
    };
    return factory;
}
var SERVER_TRANSITION_PROVIDERS = [
    {
        provide: __WEBPACK_IMPORTED_MODULE_1__angular_core__["APP_INITIALIZER"],
        useFactory: bootstrapListenerFactory,
        deps: [TRANSITION_ID, DOCUMENT],
        multi: true
    },
];
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var BrowserGetTestability = (function () {
    function BrowserGetTestability() {
    }
    /**
     * @return {?}
     */
    BrowserGetTestability.init = function () { __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["setTestabilityGetter"])(new BrowserGetTestability()); };
    /**
     * @param {?} registry
     * @return {?}
     */
    BrowserGetTestability.prototype.addToWindow = function (registry) {
        __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵglobal"]['getAngularTestability'] = function (elem, findInAncestors) {
            if (findInAncestors === void 0) { findInAncestors = true; }
            var /** @type {?} */ testability = registry.findTestabilityInTree(elem, findInAncestors);
            if (testability == null) {
                throw new Error('Could not find testability for element.');
            }
            return testability;
        };
        __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵglobal"]['getAllAngularTestabilities'] = function () { return registry.getAllTestabilities(); };
        __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵglobal"]['getAllAngularRootElements'] = function () { return registry.getAllRootElements(); };
        var /** @type {?} */ whenAllStable = function (callback /** TODO #9100 */) {
            var /** @type {?} */ testabilities = __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵglobal"]['getAllAngularTestabilities']();
            var /** @type {?} */ count = testabilities.length;
            var /** @type {?} */ didWork = false;
            var /** @type {?} */ decrement = function (didWork_ /** TODO #9100 */) {
                didWork = didWork || didWork_;
                count--;
                if (count == 0) {
                    callback(didWork);
                }
            };
            testabilities.forEach(function (testability /** TODO #9100 */) {
                testability.whenStable(decrement);
            });
        };
        if (!__WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵglobal"]['frameworkStabilizers']) {
            __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵglobal"]['frameworkStabilizers'] = [];
        }
        __WEBPACK_IMPORTED_MODULE_1__angular_core__["ɵglobal"]['frameworkStabilizers'].push(whenAllStable);
    };
    /**
     * @param {?} registry
     * @param {?} elem
     * @param {?} findInAncestors
     * @return {?}
     */
    BrowserGetTestability.prototype.findTestabilityInTree = function (registry, elem, findInAncestors) {
        if (elem == null) {
            return null;
        }
        var /** @type {?} */ t = registry.getTestability(elem);
        if (t != null) {
            return t;
        }
        else if (!findInAncestors) {
            return null;
        }
        if (getDOM().isShadowRoot(elem)) {
            return this.findTestabilityInTree(registry, getDOM().getHost(elem), true);
        }
        return this.findTestabilityInTree(registry, getDOM().parentElement(elem), true);
    };
    return BrowserGetTestability;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * A service that can be used to get and set the title of a current HTML document.
 *
 * Since an Angular application can't be bootstrapped on the entire HTML document (`<html>` tag)
 * it is not possible to bind to the `text` property of the `HTMLTitleElement` elements
 * (representing the `<title>` tag). Instead, this service can be used to set and get the current
 * title value.
 *
 * \@experimental
 */
var Title = (function () {
    /**
     * @param {?} _doc
     */
    function Title(_doc) {
        this._doc = _doc;
    }
    /**
     * Get the title of the current HTML document.
     * @return {?}
     */
    Title.prototype.getTitle = function () { return getDOM().getTitle(this._doc); };
    /**
     * Set the title of the current HTML document.
     * @param {?} newTitle
     * @return {?}
     */
    Title.prototype.setTitle = function (newTitle) { getDOM().setTitle(this._doc, newTitle); };
    return Title;
}());
Title.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Injectable"] },
];
/**
 * @nocollapse
 */
Title.ctorParameters = function () { return [
    { type: undefined, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"], args: [DOCUMENT,] },] },
]; };
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var __assign = (undefined && undefined.__assign) || Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s)
            if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
    }
    return t;
};
var CORE_TOKENS = {
    'ApplicationRef': __WEBPACK_IMPORTED_MODULE_1__angular_core__["ApplicationRef"],
    'NgZone': __WEBPACK_IMPORTED_MODULE_1__angular_core__["NgZone"],
};
var INSPECT_GLOBAL_NAME = 'ng.probe';
var CORE_TOKENS_GLOBAL_NAME = 'ng.coreTokens';
/**
 * Returns a {\@link DebugElement} for the given native DOM element, or
 * null if the given native element does not have an Angular view associated
 * with it.
 * @param {?} element
 * @return {?}
 */
function inspectNativeElement(element) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["getDebugNode"])(element);
}
/**
 * Deprecated. Use the one from '\@angular/core'.
 * @deprecated
 */
var NgProbeToken$1 = (function () {
    /**
     * @param {?} name
     * @param {?} token
     */
    function NgProbeToken$1(name, token) {
        this.name = name;
        this.token = token;
    }
    return NgProbeToken$1;
}());
/**
 * @param {?} extraTokens
 * @param {?} coreTokens
 * @return {?}
 */
function _createNgProbe(extraTokens, coreTokens) {
    var /** @type {?} */ tokens = (extraTokens || []).concat(coreTokens || []);
    getDOM().setGlobalVar(INSPECT_GLOBAL_NAME, inspectNativeElement);
    getDOM().setGlobalVar(CORE_TOKENS_GLOBAL_NAME, __assign({}, CORE_TOKENS, _ngProbeTokensToMap(tokens || [])));
    return function () { return inspectNativeElement; };
}
/**
 * @param {?} tokens
 * @return {?}
 */
function _ngProbeTokensToMap(tokens) {
    return tokens.reduce(function (prev, t) { return (prev[t.name] = t.token, prev); }, {});
}
/**
 * Providers which support debugging Angular applications (e.g. via `ng.probe`).
 */
var ELEMENT_PROBE_PROVIDERS = [
    {
        provide: __WEBPACK_IMPORTED_MODULE_1__angular_core__["APP_INITIALIZER"],
        useFactory: _createNgProbe,
        deps: [
            [NgProbeToken$1, new __WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"]()],
            [__WEBPACK_IMPORTED_MODULE_1__angular_core__["NgProbeToken"], new __WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"]()],
        ],
        multi: true,
    },
];
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * \@stable
 */
var EVENT_MANAGER_PLUGINS = new __WEBPACK_IMPORTED_MODULE_1__angular_core__["InjectionToken"]('EventManagerPlugins');
/**
 * \@stable
 */
var EventManager = (function () {
    /**
     * @param {?} plugins
     * @param {?} _zone
     */
    function EventManager(plugins, _zone) {
        var _this = this;
        this._zone = _zone;
        this._eventNameToPlugin = new Map();
        plugins.forEach(function (p) { return p.manager = _this; });
        this._plugins = plugins.slice().reverse();
    }
    /**
     * @param {?} element
     * @param {?} eventName
     * @param {?} handler
     * @return {?}
     */
    EventManager.prototype.addEventListener = function (element, eventName, handler) {
        var /** @type {?} */ plugin = this._findPluginFor(eventName);
        return plugin.addEventListener(element, eventName, handler);
    };
    /**
     * @param {?} target
     * @param {?} eventName
     * @param {?} handler
     * @return {?}
     */
    EventManager.prototype.addGlobalEventListener = function (target, eventName, handler) {
        var /** @type {?} */ plugin = this._findPluginFor(eventName);
        return plugin.addGlobalEventListener(target, eventName, handler);
    };
    /**
     * @return {?}
     */
    EventManager.prototype.getZone = function () { return this._zone; };
    /**
     * \@internal
     * @param {?} eventName
     * @return {?}
     */
    EventManager.prototype._findPluginFor = function (eventName) {
        var /** @type {?} */ plugin = this._eventNameToPlugin.get(eventName);
        if (plugin) {
            return plugin;
        }
        var /** @type {?} */ plugins = this._plugins;
        for (var /** @type {?} */ i = 0; i < plugins.length; i++) {
            var /** @type {?} */ plugin_1 = plugins[i];
            if (plugin_1.supports(eventName)) {
                this._eventNameToPlugin.set(eventName, plugin_1);
                return plugin_1;
            }
        }
        throw new Error("No event manager plugin found for event " + eventName);
    };
    return EventManager;
}());
EventManager.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Injectable"] },
];
/**
 * @nocollapse
 */
EventManager.ctorParameters = function () { return [
    { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"], args: [EVENT_MANAGER_PLUGINS,] },] },
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["NgZone"], },
]; };
/**
 * @abstract
 */
var EventManagerPlugin = (function () {
    /**
     * @param {?} _doc
     */
    function EventManagerPlugin(_doc) {
        this._doc = _doc;
    }
    /**
     * @abstract
     * @param {?} eventName
     * @return {?}
     */
    EventManagerPlugin.prototype.supports = function (eventName) { };
    /**
     * @abstract
     * @param {?} element
     * @param {?} eventName
     * @param {?} handler
     * @return {?}
     */
    EventManagerPlugin.prototype.addEventListener = function (element, eventName, handler) { };
    /**
     * @param {?} element
     * @param {?} eventName
     * @param {?} handler
     * @return {?}
     */
    EventManagerPlugin.prototype.addGlobalEventListener = function (element, eventName, handler) {
        var /** @type {?} */ target = getDOM().getGlobalEventTarget(this._doc, element);
        if (!target) {
            throw new Error("Unsupported event target " + target + " for event " + eventName);
        }
        return this.addEventListener(target, eventName, handler);
    };
    ;
    return EventManagerPlugin;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var SharedStylesHost = (function () {
    function SharedStylesHost() {
        /**
         * \@internal
         */
        this._stylesSet = new Set();
    }
    /**
     * @param {?} styles
     * @return {?}
     */
    SharedStylesHost.prototype.addStyles = function (styles) {
        var _this = this;
        var /** @type {?} */ additions = new Set();
        styles.forEach(function (style) {
            if (!_this._stylesSet.has(style)) {
                _this._stylesSet.add(style);
                additions.add(style);
            }
        });
        this.onStylesAdded(additions);
    };
    /**
     * @param {?} additions
     * @return {?}
     */
    SharedStylesHost.prototype.onStylesAdded = function (additions) { };
    /**
     * @return {?}
     */
    SharedStylesHost.prototype.getAllStyles = function () { return Array.from(this._stylesSet); };
    return SharedStylesHost;
}());
SharedStylesHost.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Injectable"] },
];
/**
 * @nocollapse
 */
SharedStylesHost.ctorParameters = function () { return []; };
var DomSharedStylesHost = (function (_super) {
    __extends(DomSharedStylesHost, _super);
    /**
     * @param {?} _doc
     */
    function DomSharedStylesHost(_doc) {
        var _this = _super.call(this) || this;
        _this._doc = _doc;
        _this._hostNodes = new Set();
        _this._styleNodes = new Set();
        _this._hostNodes.add(_doc.head);
        return _this;
    }
    /**
     * @param {?} styles
     * @param {?} host
     * @return {?}
     */
    DomSharedStylesHost.prototype._addStylesToHost = function (styles, host) {
        var _this = this;
        styles.forEach(function (style) {
            var /** @type {?} */ styleEl = _this._doc.createElement('style');
            styleEl.textContent = style;
            _this._styleNodes.add(host.appendChild(styleEl));
        });
    };
    /**
     * @param {?} hostNode
     * @return {?}
     */
    DomSharedStylesHost.prototype.addHost = function (hostNode) {
        this._addStylesToHost(this._stylesSet, hostNode);
        this._hostNodes.add(hostNode);
    };
    /**
     * @param {?} hostNode
     * @return {?}
     */
    DomSharedStylesHost.prototype.removeHost = function (hostNode) { this._hostNodes.delete(hostNode); };
    /**
     * @param {?} additions
     * @return {?}
     */
    DomSharedStylesHost.prototype.onStylesAdded = function (additions) {
        var _this = this;
        this._hostNodes.forEach(function (hostNode) { return _this._addStylesToHost(additions, hostNode); });
    };
    /**
     * @return {?}
     */
    DomSharedStylesHost.prototype.ngOnDestroy = function () { this._styleNodes.forEach(function (styleNode) { return getDOM().remove(styleNode); }); };
    return DomSharedStylesHost;
}(SharedStylesHost));
DomSharedStylesHost.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Injectable"] },
];
/**
 * @nocollapse
 */
DomSharedStylesHost.ctorParameters = function () { return [
    { type: undefined, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"], args: [DOCUMENT,] },] },
]; };
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var NAMESPACE_URIS = {
    'svg': 'http://www.w3.org/2000/svg',
    'xhtml': 'http://www.w3.org/1999/xhtml',
    'xlink': 'http://www.w3.org/1999/xlink',
    'xml': 'http://www.w3.org/XML/1998/namespace',
    'xmlns': 'http://www.w3.org/2000/xmlns/',
};
var COMPONENT_REGEX = /%COMP%/g;
var COMPONENT_VARIABLE = '%COMP%';
var HOST_ATTR = "_nghost-" + COMPONENT_VARIABLE;
var CONTENT_ATTR = "_ngcontent-" + COMPONENT_VARIABLE;
/**
 * @param {?} componentShortId
 * @return {?}
 */
function shimContentAttribute(componentShortId) {
    return CONTENT_ATTR.replace(COMPONENT_REGEX, componentShortId);
}
/**
 * @param {?} componentShortId
 * @return {?}
 */
function shimHostAttribute(componentShortId) {
    return HOST_ATTR.replace(COMPONENT_REGEX, componentShortId);
}
/**
 * @param {?} compId
 * @param {?} styles
 * @param {?} target
 * @return {?}
 */
function flattenStyles(compId, styles, target) {
    for (var /** @type {?} */ i = 0; i < styles.length; i++) {
        var /** @type {?} */ style = styles[i];
        if (Array.isArray(style)) {
            flattenStyles(compId, style, target);
        }
        else {
            style = style.replace(COMPONENT_REGEX, compId);
            target.push(style);
        }
    }
    return target;
}
/**
 * @param {?} eventHandler
 * @return {?}
 */
function decoratePreventDefault(eventHandler) {
    return function (event) {
        var /** @type {?} */ allowDefaultBehavior = eventHandler(event);
        if (allowDefaultBehavior === false) {
            // TODO(tbosch): move preventDefault into event plugins...
            event.preventDefault();
            event.returnValue = false;
        }
    };
}
var DomRendererFactory2 = (function () {
    /**
     * @param {?} eventManager
     * @param {?} sharedStylesHost
     */
    function DomRendererFactory2(eventManager, sharedStylesHost) {
        this.eventManager = eventManager;
        this.sharedStylesHost = sharedStylesHost;
        this.rendererByCompId = new Map();
        this.defaultRenderer = new DefaultDomRenderer2(eventManager);
    }
    ;
    /**
     * @param {?} element
     * @param {?} type
     * @return {?}
     */
    DomRendererFactory2.prototype.createRenderer = function (element, type) {
        if (!element || !type) {
            return this.defaultRenderer;
        }
        switch (type.encapsulation) {
            case __WEBPACK_IMPORTED_MODULE_1__angular_core__["ViewEncapsulation"].Emulated: {
                var /** @type {?} */ renderer = this.rendererByCompId.get(type.id);
                if (!renderer) {
                    renderer =
                        new EmulatedEncapsulationDomRenderer2(this.eventManager, this.sharedStylesHost, type);
                    this.rendererByCompId.set(type.id, renderer);
                }
                ((renderer)).applyToHost(element);
                return renderer;
            }
            case __WEBPACK_IMPORTED_MODULE_1__angular_core__["ViewEncapsulation"].Native:
                return new ShadowDomRenderer(this.eventManager, this.sharedStylesHost, element, type);
            default: {
                if (!this.rendererByCompId.has(type.id)) {
                    var /** @type {?} */ styles = flattenStyles(type.id, type.styles, []);
                    this.sharedStylesHost.addStyles(styles);
                    this.rendererByCompId.set(type.id, this.defaultRenderer);
                }
                return this.defaultRenderer;
            }
        }
    };
    return DomRendererFactory2;
}());
DomRendererFactory2.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Injectable"] },
];
/**
 * @nocollapse
 */
DomRendererFactory2.ctorParameters = function () { return [
    { type: EventManager, },
    { type: DomSharedStylesHost, },
]; };
var DefaultDomRenderer2 = (function () {
    /**
     * @param {?} eventManager
     */
    function DefaultDomRenderer2(eventManager) {
        this.eventManager = eventManager;
        this.data = Object.create(null);
    }
    /**
     * @return {?}
     */
    DefaultDomRenderer2.prototype.destroy = function () { };
    /**
     * @param {?} name
     * @param {?=} namespace
     * @return {?}
     */
    DefaultDomRenderer2.prototype.createElement = function (name, namespace) {
        if (namespace) {
            return document.createElementNS(NAMESPACE_URIS[namespace], name);
        }
        return document.createElement(name);
    };
    /**
     * @param {?} value
     * @return {?}
     */
    DefaultDomRenderer2.prototype.createComment = function (value) { return document.createComment(value); };
    /**
     * @param {?} value
     * @return {?}
     */
    DefaultDomRenderer2.prototype.createText = function (value) { return document.createTextNode(value); };
    /**
     * @param {?} parent
     * @param {?} newChild
     * @return {?}
     */
    DefaultDomRenderer2.prototype.appendChild = function (parent, newChild) { parent.appendChild(newChild); };
    /**
     * @param {?} parent
     * @param {?} newChild
     * @param {?} refChild
     * @return {?}
     */
    DefaultDomRenderer2.prototype.insertBefore = function (parent, newChild, refChild) {
        if (parent) {
            parent.insertBefore(newChild, refChild);
        }
    };
    /**
     * @param {?} parent
     * @param {?} oldChild
     * @return {?}
     */
    DefaultDomRenderer2.prototype.removeChild = function (parent, oldChild) {
        if (parent) {
            parent.removeChild(oldChild);
        }
    };
    /**
     * @param {?} selectorOrNode
     * @return {?}
     */
    DefaultDomRenderer2.prototype.selectRootElement = function (selectorOrNode) {
        var /** @type {?} */ el = typeof selectorOrNode === 'string' ? document.querySelector(selectorOrNode) :
            selectorOrNode;
        if (!el) {
            throw new Error("The selector \"" + selectorOrNode + "\" did not match any elements");
        }
        el.textContent = '';
        return el;
    };
    /**
     * @param {?} node
     * @return {?}
     */
    DefaultDomRenderer2.prototype.parentNode = function (node) { return node.parentNode; };
    /**
     * @param {?} node
     * @return {?}
     */
    DefaultDomRenderer2.prototype.nextSibling = function (node) { return node.nextSibling; };
    /**
     * @param {?} el
     * @param {?} name
     * @param {?} value
     * @param {?=} namespace
     * @return {?}
     */
    DefaultDomRenderer2.prototype.setAttribute = function (el, name, value, namespace) {
        if (namespace) {
            name = namespace + ":" + name;
            var /** @type {?} */ namespaceUri = NAMESPACE_URIS[namespace];
            if (namespaceUri) {
                el.setAttributeNS(namespaceUri, name, value);
            }
            else {
                el.setAttribute(name, value);
            }
        }
        else {
            el.setAttribute(name, value);
        }
    };
    /**
     * @param {?} el
     * @param {?} name
     * @param {?=} namespace
     * @return {?}
     */
    DefaultDomRenderer2.prototype.removeAttribute = function (el, name, namespace) {
        if (namespace) {
            var /** @type {?} */ namespaceUri = NAMESPACE_URIS[namespace];
            if (namespaceUri) {
                el.removeAttributeNS(namespaceUri, name);
            }
            else {
                el.removeAttribute(namespace + ":" + name);
            }
        }
        else {
            el.removeAttribute(name);
        }
    };
    /**
     * @param {?} el
     * @param {?} name
     * @return {?}
     */
    DefaultDomRenderer2.prototype.addClass = function (el, name) { el.classList.add(name); };
    /**
     * @param {?} el
     * @param {?} name
     * @return {?}
     */
    DefaultDomRenderer2.prototype.removeClass = function (el, name) { el.classList.remove(name); };
    /**
     * @param {?} el
     * @param {?} style
     * @param {?} value
     * @param {?} flags
     * @return {?}
     */
    DefaultDomRenderer2.prototype.setStyle = function (el, style, value, flags) {
        if (flags & __WEBPACK_IMPORTED_MODULE_1__angular_core__["RendererStyleFlags2"].DashCase) {
            el.style.setProperty(style, value, !!(flags & __WEBPACK_IMPORTED_MODULE_1__angular_core__["RendererStyleFlags2"].Important) ? 'important' : '');
        }
        else {
            el.style[style] = value;
        }
    };
    /**
     * @param {?} el
     * @param {?} style
     * @param {?} flags
     * @return {?}
     */
    DefaultDomRenderer2.prototype.removeStyle = function (el, style, flags) {
        if (flags & __WEBPACK_IMPORTED_MODULE_1__angular_core__["RendererStyleFlags2"].DashCase) {
            el.style.removeProperty(style);
        }
        else {
            // IE requires '' instead of null
            // see https://github.com/angular/angular/issues/7916
            el.style[style] = '';
        }
    };
    /**
     * @param {?} el
     * @param {?} name
     * @param {?} value
     * @return {?}
     */
    DefaultDomRenderer2.prototype.setProperty = function (el, name, value) {
        checkNoSyntheticProp(name, 'property');
        el[name] = value;
    };
    /**
     * @param {?} node
     * @param {?} value
     * @return {?}
     */
    DefaultDomRenderer2.prototype.setValue = function (node, value) { node.nodeValue = value; };
    /**
     * @param {?} target
     * @param {?} event
     * @param {?} callback
     * @return {?}
     */
    DefaultDomRenderer2.prototype.listen = function (target, event, callback) {
        checkNoSyntheticProp(event, 'listener');
        if (typeof target === 'string') {
            return (this.eventManager.addGlobalEventListener(target, event, decoratePreventDefault(callback)));
        }
        return ((this.eventManager.addEventListener(target, event, decoratePreventDefault(callback))));
    };
    return DefaultDomRenderer2;
}());
var AT_CHARCODE = '@'.charCodeAt(0);
/**
 * @param {?} name
 * @param {?} nameKind
 * @return {?}
 */
function checkNoSyntheticProp(name, nameKind) {
    if (name.charCodeAt(0) === AT_CHARCODE) {
        throw new Error("Found the synthetic " + nameKind + " " + name + ". Please include either \"BrowserAnimationsModule\" or \"NoopAnimationsModule\" in your application.");
    }
}
var EmulatedEncapsulationDomRenderer2 = (function (_super) {
    __extends(EmulatedEncapsulationDomRenderer2, _super);
    /**
     * @param {?} eventManager
     * @param {?} sharedStylesHost
     * @param {?} component
     */
    function EmulatedEncapsulationDomRenderer2(eventManager, sharedStylesHost, component) {
        var _this = _super.call(this, eventManager) || this;
        _this.component = component;
        var styles = flattenStyles(component.id, component.styles, []);
        sharedStylesHost.addStyles(styles);
        _this.contentAttr = shimContentAttribute(component.id);
        _this.hostAttr = shimHostAttribute(component.id);
        return _this;
    }
    /**
     * @param {?} element
     * @return {?}
     */
    EmulatedEncapsulationDomRenderer2.prototype.applyToHost = function (element) { _super.prototype.setAttribute.call(this, element, this.hostAttr, ''); };
    /**
     * @param {?} parent
     * @param {?} name
     * @return {?}
     */
    EmulatedEncapsulationDomRenderer2.prototype.createElement = function (parent, name) {
        var /** @type {?} */ el = _super.prototype.createElement.call(this, parent, name);
        _super.prototype.setAttribute.call(this, el, this.contentAttr, '');
        return el;
    };
    return EmulatedEncapsulationDomRenderer2;
}(DefaultDomRenderer2));
var ShadowDomRenderer = (function (_super) {
    __extends(ShadowDomRenderer, _super);
    /**
     * @param {?} eventManager
     * @param {?} sharedStylesHost
     * @param {?} hostEl
     * @param {?} component
     */
    function ShadowDomRenderer(eventManager, sharedStylesHost, hostEl, component) {
        var _this = _super.call(this, eventManager) || this;
        _this.sharedStylesHost = sharedStylesHost;
        _this.hostEl = hostEl;
        _this.component = component;
        _this.shadowRoot = hostEl.createShadowRoot();
        _this.sharedStylesHost.addHost(_this.shadowRoot);
        var styles = flattenStyles(component.id, component.styles, []);
        for (var i = 0; i < styles.length; i++) {
            var styleEl = document.createElement('style');
            styleEl.textContent = styles[i];
            _this.shadowRoot.appendChild(styleEl);
        }
        return _this;
    }
    /**
     * @param {?} node
     * @return {?}
     */
    ShadowDomRenderer.prototype.nodeOrShadowRoot = function (node) { return node === this.hostEl ? this.shadowRoot : node; };
    /**
     * @return {?}
     */
    ShadowDomRenderer.prototype.destroy = function () { this.sharedStylesHost.removeHost(this.shadowRoot); };
    /**
     * @param {?} parent
     * @param {?} newChild
     * @return {?}
     */
    ShadowDomRenderer.prototype.appendChild = function (parent, newChild) {
        return _super.prototype.appendChild.call(this, this.nodeOrShadowRoot(parent), newChild);
    };
    /**
     * @param {?} parent
     * @param {?} newChild
     * @param {?} refChild
     * @return {?}
     */
    ShadowDomRenderer.prototype.insertBefore = function (parent, newChild, refChild) {
        return _super.prototype.insertBefore.call(this, this.nodeOrShadowRoot(parent), newChild, refChild);
    };
    /**
     * @param {?} parent
     * @param {?} oldChild
     * @return {?}
     */
    ShadowDomRenderer.prototype.removeChild = function (parent, oldChild) {
        return _super.prototype.removeChild.call(this, this.nodeOrShadowRoot(parent), oldChild);
    };
    /**
     * @param {?} node
     * @return {?}
     */
    ShadowDomRenderer.prototype.parentNode = function (node) {
        return this.nodeOrShadowRoot(_super.prototype.parentNode.call(this, this.nodeOrShadowRoot(node)));
    };
    return ShadowDomRenderer;
}(DefaultDomRenderer2));
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var DomEventsPlugin = (function (_super) {
    __extends(DomEventsPlugin, _super);
    /**
     * @param {?} doc
     */
    function DomEventsPlugin(doc) {
        return _super.call(this, doc) || this;
    }
    /**
     * @param {?} eventName
     * @return {?}
     */
    DomEventsPlugin.prototype.supports = function (eventName) { return true; };
    /**
     * @param {?} element
     * @param {?} eventName
     * @param {?} handler
     * @return {?}
     */
    DomEventsPlugin.prototype.addEventListener = function (element, eventName, handler) {
        element.addEventListener(eventName, /** @type {?} */ (handler), false);
        return function () { return element.removeEventListener(eventName, /** @type {?} */ (handler), false); };
    };
    return DomEventsPlugin;
}(EventManagerPlugin));
DomEventsPlugin.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Injectable"] },
];
/**
 * @nocollapse
 */
DomEventsPlugin.ctorParameters = function () { return [
    { type: undefined, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"], args: [DOCUMENT,] },] },
]; };
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var EVENT_NAMES = {
    // pan
    'pan': true,
    'panstart': true,
    'panmove': true,
    'panend': true,
    'pancancel': true,
    'panleft': true,
    'panright': true,
    'panup': true,
    'pandown': true,
    // pinch
    'pinch': true,
    'pinchstart': true,
    'pinchmove': true,
    'pinchend': true,
    'pinchcancel': true,
    'pinchin': true,
    'pinchout': true,
    // press
    'press': true,
    'pressup': true,
    // rotate
    'rotate': true,
    'rotatestart': true,
    'rotatemove': true,
    'rotateend': true,
    'rotatecancel': true,
    // swipe
    'swipe': true,
    'swipeleft': true,
    'swiperight': true,
    'swipeup': true,
    'swipedown': true,
    // tap
    'tap': true,
};
/**
 * A DI token that you can use to provide{\@link HammerGestureConfig} to Angular. Use it to configure
 * Hammer gestures.
 *
 * \@experimental
 */
var HAMMER_GESTURE_CONFIG = new __WEBPACK_IMPORTED_MODULE_1__angular_core__["InjectionToken"]('HammerGestureConfig');
/**
 * \@experimental
 */
var HammerGestureConfig = (function () {
    function HammerGestureConfig() {
        this.events = [];
        this.overrides = {};
    }
    /**
     * @param {?} element
     * @return {?}
     */
    HammerGestureConfig.prototype.buildHammer = function (element) {
        var /** @type {?} */ mc = new Hammer(element);
        mc.get('pinch').set({ enable: true });
        mc.get('rotate').set({ enable: true });
        for (var /** @type {?} */ eventName in this.overrides) {
            mc.get(eventName).set(this.overrides[eventName]);
        }
        return mc;
    };
    return HammerGestureConfig;
}());
HammerGestureConfig.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Injectable"] },
];
/**
 * @nocollapse
 */
HammerGestureConfig.ctorParameters = function () { return []; };
var HammerGesturesPlugin = (function (_super) {
    __extends(HammerGesturesPlugin, _super);
    /**
     * @param {?} doc
     * @param {?} _config
     */
    function HammerGesturesPlugin(doc, _config) {
        var _this = _super.call(this, doc) || this;
        _this._config = _config;
        return _this;
    }
    /**
     * @param {?} eventName
     * @return {?}
     */
    HammerGesturesPlugin.prototype.supports = function (eventName) {
        if (!EVENT_NAMES.hasOwnProperty(eventName.toLowerCase()) && !this.isCustomEvent(eventName)) {
            return false;
        }
        if (!((window)).Hammer) {
            throw new Error("Hammer.js is not loaded, can not bind " + eventName + " event");
        }
        return true;
    };
    /**
     * @param {?} element
     * @param {?} eventName
     * @param {?} handler
     * @return {?}
     */
    HammerGesturesPlugin.prototype.addEventListener = function (element, eventName, handler) {
        var _this = this;
        var /** @type {?} */ zone = this.manager.getZone();
        eventName = eventName.toLowerCase();
        return zone.runOutsideAngular(function () {
            // Creating the manager bind events, must be done outside of angular
            var /** @type {?} */ mc = _this._config.buildHammer(element);
            var /** @type {?} */ callback = function (eventObj) {
                zone.runGuarded(function () { handler(eventObj); });
            };
            mc.on(eventName, callback);
            return function () { return mc.off(eventName, callback); };
        });
    };
    /**
     * @param {?} eventName
     * @return {?}
     */
    HammerGesturesPlugin.prototype.isCustomEvent = function (eventName) { return this._config.events.indexOf(eventName) > -1; };
    return HammerGesturesPlugin;
}(EventManagerPlugin));
HammerGesturesPlugin.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Injectable"] },
];
/**
 * @nocollapse
 */
HammerGesturesPlugin.ctorParameters = function () { return [
    { type: undefined, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"], args: [DOCUMENT,] },] },
    { type: HammerGestureConfig, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"], args: [HAMMER_GESTURE_CONFIG,] },] },
]; };
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var MODIFIER_KEYS = ['alt', 'control', 'meta', 'shift'];
var MODIFIER_KEY_GETTERS = {
    'alt': function (event) { return event.altKey; },
    'control': function (event) { return event.ctrlKey; },
    'meta': function (event) { return event.metaKey; },
    'shift': function (event) { return event.shiftKey; }
};
/**
 * \@experimental
 */
var KeyEventsPlugin = (function (_super) {
    __extends(KeyEventsPlugin, _super);
    /**
     * @param {?} doc
     */
    function KeyEventsPlugin(doc) {
        return _super.call(this, doc) || this;
    }
    /**
     * @param {?} eventName
     * @return {?}
     */
    KeyEventsPlugin.prototype.supports = function (eventName) { return KeyEventsPlugin.parseEventName(eventName) != null; };
    /**
     * @param {?} element
     * @param {?} eventName
     * @param {?} handler
     * @return {?}
     */
    KeyEventsPlugin.prototype.addEventListener = function (element, eventName, handler) {
        var /** @type {?} */ parsedEvent = ((KeyEventsPlugin.parseEventName(eventName)));
        var /** @type {?} */ outsideHandler = KeyEventsPlugin.eventCallback(parsedEvent['fullKey'], handler, this.manager.getZone());
        return this.manager.getZone().runOutsideAngular(function () {
            return getDOM().onAndCancel(element, parsedEvent['domEventName'], outsideHandler);
        });
    };
    /**
     * @param {?} eventName
     * @return {?}
     */
    KeyEventsPlugin.parseEventName = function (eventName) {
        var /** @type {?} */ parts = eventName.toLowerCase().split('.');
        var /** @type {?} */ domEventName = parts.shift();
        if ((parts.length === 0) || !(domEventName === 'keydown' || domEventName === 'keyup')) {
            return null;
        }
        var /** @type {?} */ key = KeyEventsPlugin._normalizeKey(/** @type {?} */ ((parts.pop())));
        var /** @type {?} */ fullKey = '';
        MODIFIER_KEYS.forEach(function (modifierName) {
            var /** @type {?} */ index = parts.indexOf(modifierName);
            if (index > -1) {
                parts.splice(index, 1);
                fullKey += modifierName + '.';
            }
        });
        fullKey += key;
        if (parts.length != 0 || key.length === 0) {
            // returning null instead of throwing to let another plugin process the event
            return null;
        }
        var /** @type {?} */ result = {};
        result['domEventName'] = domEventName;
        result['fullKey'] = fullKey;
        return result;
    };
    /**
     * @param {?} event
     * @return {?}
     */
    KeyEventsPlugin.getEventFullKey = function (event) {
        var /** @type {?} */ fullKey = '';
        var /** @type {?} */ key = getDOM().getEventKey(event);
        key = key.toLowerCase();
        if (key === ' ') {
            key = 'space'; // for readability
        }
        else if (key === '.') {
            key = 'dot'; // because '.' is used as a separator in event names
        }
        MODIFIER_KEYS.forEach(function (modifierName) {
            if (modifierName != key) {
                var /** @type {?} */ modifierGetter = MODIFIER_KEY_GETTERS[modifierName];
                if (modifierGetter(event)) {
                    fullKey += modifierName + '.';
                }
            }
        });
        fullKey += key;
        return fullKey;
    };
    /**
     * @param {?} fullKey
     * @param {?} handler
     * @param {?} zone
     * @return {?}
     */
    KeyEventsPlugin.eventCallback = function (fullKey, handler, zone) {
        return function (event /** TODO #9100 */) {
            if (KeyEventsPlugin.getEventFullKey(event) === fullKey) {
                zone.runGuarded(function () { return handler(event); });
            }
        };
    };
    /**
     * \@internal
     * @param {?} keyName
     * @return {?}
     */
    KeyEventsPlugin._normalizeKey = function (keyName) {
        // TODO: switch to a Map if the mapping grows too much
        switch (keyName) {
            case 'esc':
                return 'escape';
            default:
                return keyName;
        }
    };
    return KeyEventsPlugin;
}(EventManagerPlugin));
KeyEventsPlugin.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Injectable"] },
];
/**
 * @nocollapse
 */
KeyEventsPlugin.ctorParameters = function () { return [
    { type: undefined, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"], args: [DOCUMENT,] },] },
]; };
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * A pattern that recognizes a commonly useful subset of URLs that are safe.
 *
 * This regular expression matches a subset of URLs that will not cause script
 * execution if used in URL context within a HTML document. Specifically, this
 * regular expression matches if (comment from here on and regex copied from
 * Soy's EscapingConventions):
 * (1) Either a protocol in a whitelist (http, https, mailto or ftp).
 * (2) or no protocol.  A protocol must be followed by a colon. The below
 *     allows that by allowing colons only after one of the characters [/?#].
 *     A colon after a hash (#) must be in the fragment.
 *     Otherwise, a colon after a (?) must be in a query.
 *     Otherwise, a colon after a single solidus (/) must be in a path.
 *     Otherwise, a colon after a double solidus (//) must be in the authority
 *     (before port).
 *
 * The pattern disallows &, used in HTML entity declarations before
 * one of the characters in [/?#]. This disallows HTML entities used in the
 * protocol name, which should never happen, e.g. "h&#116;tp" for "http".
 * It also disallows HTML entities in the first path part of a relative path,
 * e.g. "foo&lt;bar/baz".  Our existing escaping functions should not produce
 * that. More importantly, it disallows masking of a colon,
 * e.g. "javascript&#58;...".
 *
 * This regular expression was taken from the Closure sanitization library.
 */
var SAFE_URL_PATTERN = /^(?:(?:https?|mailto|ftp|tel|file):|[^&:/?#]*(?:[/?#]|$))/gi;
/** A pattern that matches safe data URLs. Only matches image, video and audio types. */
var DATA_URL_PATTERN = /^data:(?:image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp)|video\/(?:mpeg|mp4|ogg|webm)|audio\/(?:mp3|oga|ogg|opus));base64,[a-z0-9+\/]+=*$/i;
/**
 * @param {?} url
 * @return {?}
 */
function sanitizeUrl(url) {
    url = String(url);
    if (url.match(SAFE_URL_PATTERN) || url.match(DATA_URL_PATTERN))
        return url;
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["isDevMode"])()) {
        getDOM().log("WARNING: sanitizing unsafe URL value " + url + " (see http://g.co/ng/security#xss)");
    }
    return 'unsafe:' + url;
}
/**
 * @param {?} srcset
 * @return {?}
 */
function sanitizeSrcset(srcset) {
    srcset = String(srcset);
    return srcset.split(',').map(function (srcset) { return sanitizeUrl(srcset.trim()); }).join(', ');
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/** A <body> element that can be safely used to parse untrusted HTML. Lazily initialized below. */
var inertElement = null;
/** Lazily initialized to make sure the DOM adapter gets set before use. */
var DOM = ((null));
/**
 * Returns an HTML element that is guaranteed to not execute code when creating elements in it.
 * @return {?}
 */
function getInertElement() {
    if (inertElement)
        return inertElement;
    DOM = getDOM();
    // Prefer using <template> element if supported.
    var /** @type {?} */ templateEl = DOM.createElement('template');
    if ('content' in templateEl)
        return templateEl;
    var /** @type {?} */ doc = DOM.createHtmlDocument();
    inertElement = DOM.querySelector(doc, 'body');
    if (inertElement == null) {
        // usually there should be only one body element in the document, but IE doesn't have any, so we
        // need to create one.
        var /** @type {?} */ html = DOM.createElement('html', doc);
        inertElement = DOM.createElement('body', doc);
        DOM.appendChild(html, inertElement);
        DOM.appendChild(doc, html);
    }
    return inertElement;
}
/**
 * @param {?} tags
 * @return {?}
 */
function tagSet(tags) {
    var /** @type {?} */ res = {};
    for (var _i = 0, _a = tags.split(','); _i < _a.length; _i++) {
        var t = _a[_i];
        res[t] = true;
    }
    return res;
}
/**
 * @param {...?} sets
 * @return {?}
 */
function merge() {
    var sets = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        sets[_i] = arguments[_i];
    }
    var /** @type {?} */ res = {};
    for (var _a = 0, sets_1 = sets; _a < sets_1.length; _a++) {
        var s = sets_1[_a];
        for (var /** @type {?} */ v in s) {
            if (s.hasOwnProperty(v))
                res[v] = true;
        }
    }
    return res;
}
// Good source of info about elements and attributes
// http://dev.w3.org/html5/spec/Overview.html#semantics
// http://simon.html5.org/html-elements
// Safe Void Elements - HTML5
// http://dev.w3.org/html5/spec/Overview.html#void-elements
var VOID_ELEMENTS = tagSet('area,br,col,hr,img,wbr');
// Elements that you can, intentionally, leave open (and which close themselves)
// http://dev.w3.org/html5/spec/Overview.html#optional-tags
var OPTIONAL_END_TAG_BLOCK_ELEMENTS = tagSet('colgroup,dd,dt,li,p,tbody,td,tfoot,th,thead,tr');
var OPTIONAL_END_TAG_INLINE_ELEMENTS = tagSet('rp,rt');
var OPTIONAL_END_TAG_ELEMENTS = merge(OPTIONAL_END_TAG_INLINE_ELEMENTS, OPTIONAL_END_TAG_BLOCK_ELEMENTS);
// Safe Block Elements - HTML5
var BLOCK_ELEMENTS = merge(OPTIONAL_END_TAG_BLOCK_ELEMENTS, tagSet('address,article,' +
    'aside,blockquote,caption,center,del,details,dialog,dir,div,dl,figure,figcaption,footer,h1,h2,h3,h4,h5,' +
    'h6,header,hgroup,hr,ins,main,map,menu,nav,ol,pre,section,summary,table,ul'));
// Inline Elements - HTML5
var INLINE_ELEMENTS = merge(OPTIONAL_END_TAG_INLINE_ELEMENTS, tagSet('a,abbr,acronym,audio,b,' +
    'bdi,bdo,big,br,cite,code,del,dfn,em,font,i,img,ins,kbd,label,map,mark,picture,q,ruby,rp,rt,s,' +
    'samp,small,source,span,strike,strong,sub,sup,time,track,tt,u,var,video'));
var VALID_ELEMENTS = merge(VOID_ELEMENTS, BLOCK_ELEMENTS, INLINE_ELEMENTS, OPTIONAL_END_TAG_ELEMENTS);
// Attributes that have href and hence need to be sanitized
var URI_ATTRS = tagSet('background,cite,href,itemtype,longdesc,poster,src,xlink:href');
// Attributes that have special href set hence need to be sanitized
var SRCSET_ATTRS = tagSet('srcset');
var HTML_ATTRS = tagSet('abbr,accesskey,align,alt,autoplay,axis,bgcolor,border,cellpadding,cellspacing,class,clear,color,cols,colspan,' +
    'compact,controls,coords,datetime,default,dir,download,face,headers,height,hidden,hreflang,hspace,' +
    'ismap,itemscope,itemprop,kind,label,lang,language,loop,media,muted,nohref,nowrap,open,preload,rel,rev,role,rows,rowspan,rules,' +
    'scope,scrolling,shape,size,sizes,span,srclang,start,summary,tabindex,target,title,translate,type,usemap,' +
    'valign,value,vspace,width');
// NB: This currently conciously doesn't support SVG. SVG sanitization has had several security
// issues in the past, so it seems safer to leave it out if possible. If support for binding SVG via
// innerHTML is required, SVG attributes should be added here.
// NB: Sanitization does not allow <form> elements or other active elements (<button> etc). Those
// can be sanitized, but they increase security surface area without a legitimate use case, so they
// are left out here.
var VALID_ATTRS = merge(URI_ATTRS, SRCSET_ATTRS, HTML_ATTRS);
/**
 * SanitizingHtmlSerializer serializes a DOM fragment, stripping out any unsafe elements and unsafe
 * attributes.
 */
var SanitizingHtmlSerializer = (function () {
    function SanitizingHtmlSerializer() {
        this.sanitizedSomething = false;
        this.buf = [];
    }
    /**
     * @param {?} el
     * @return {?}
     */
    SanitizingHtmlSerializer.prototype.sanitizeChildren = function (el) {
        // This cannot use a TreeWalker, as it has to run on Angular's various DOM adapters.
        // However this code never accesses properties off of `document` before deleting its contents
        // again, so it shouldn't be vulnerable to DOM clobbering.
        var /** @type {?} */ current = ((el.firstChild));
        while (current) {
            if (DOM.isElementNode(current)) {
                this.startElement(/** @type {?} */ (current));
            }
            else if (DOM.isTextNode(current)) {
                this.chars(/** @type {?} */ ((DOM.nodeValue(current))));
            }
            else {
                // Strip non-element, non-text nodes.
                this.sanitizedSomething = true;
            }
            if (DOM.firstChild(current)) {
                current = ((DOM.firstChild(current)));
                continue;
            }
            while (current) {
                // Leaving the element. Walk up and to the right, closing tags as we go.
                if (DOM.isElementNode(current)) {
                    this.endElement(/** @type {?} */ (current));
                }
                var /** @type {?} */ next = checkClobberedElement(current, /** @type {?} */ ((DOM.nextSibling(current))));
                if (next) {
                    current = next;
                    break;
                }
                current = checkClobberedElement(current, /** @type {?} */ ((DOM.parentElement(current))));
            }
        }
        return this.buf.join('');
    };
    /**
     * @param {?} element
     * @return {?}
     */
    SanitizingHtmlSerializer.prototype.startElement = function (element) {
        var _this = this;
        var /** @type {?} */ tagName = DOM.nodeName(element).toLowerCase();
        if (!VALID_ELEMENTS.hasOwnProperty(tagName)) {
            this.sanitizedSomething = true;
            return;
        }
        this.buf.push('<');
        this.buf.push(tagName);
        DOM.attributeMap(element).forEach(function (value, attrName) {
            var /** @type {?} */ lower = attrName.toLowerCase();
            if (!VALID_ATTRS.hasOwnProperty(lower)) {
                _this.sanitizedSomething = true;
                return;
            }
            // TODO(martinprobst): Special case image URIs for data:image/...
            if (URI_ATTRS[lower])
                value = sanitizeUrl(value);
            if (SRCSET_ATTRS[lower])
                value = sanitizeSrcset(value);
            _this.buf.push(' ');
            _this.buf.push(attrName);
            _this.buf.push('="');
            _this.buf.push(encodeEntities(value));
            _this.buf.push('"');
        });
        this.buf.push('>');
    };
    /**
     * @param {?} current
     * @return {?}
     */
    SanitizingHtmlSerializer.prototype.endElement = function (current) {
        var /** @type {?} */ tagName = DOM.nodeName(current).toLowerCase();
        if (VALID_ELEMENTS.hasOwnProperty(tagName) && !VOID_ELEMENTS.hasOwnProperty(tagName)) {
            this.buf.push('</');
            this.buf.push(tagName);
            this.buf.push('>');
        }
    };
    /**
     * @param {?} chars
     * @return {?}
     */
    SanitizingHtmlSerializer.prototype.chars = function (chars) { this.buf.push(encodeEntities(chars)); };
    return SanitizingHtmlSerializer;
}());
/**
 * @param {?} node
 * @param {?} nextNode
 * @return {?}
 */
function checkClobberedElement(node, nextNode) {
    if (nextNode && DOM.contains(node, nextNode)) {
        throw new Error("Failed to sanitize html because the element is clobbered: " + DOM.getOuterHTML(node));
    }
    return nextNode;
}
// Regular Expressions for parsing tags and attributes
var SURROGATE_PAIR_REGEXP = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
// ! to ~ is the ASCII range.
var NON_ALPHANUMERIC_REGEXP = /([^\#-~ |!])/g;
/**
 * Escapes all potentially dangerous characters, so that the
 * resulting string can be safely inserted into attribute or
 * element text.
 * @param {?} value
 * @return {?}
 */
function encodeEntities(value) {
    return value.replace(/&/g, '&amp;')
        .replace(SURROGATE_PAIR_REGEXP, function (match) {
        var /** @type {?} */ hi = match.charCodeAt(0);
        var /** @type {?} */ low = match.charCodeAt(1);
        return '&#' + (((hi - 0xD800) * 0x400) + (low - 0xDC00) + 0x10000) + ';';
    })
        .replace(NON_ALPHANUMERIC_REGEXP, function (match) { return '&#' + match.charCodeAt(0) + ';'; })
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
}
/**
 * When IE9-11 comes across an unknown namespaced attribute e.g. 'xlink:foo' it adds 'xmlns:ns1'
 * attribute to declare ns1 namespace and prefixes the attribute with 'ns1' (e.g. 'ns1:xlink:foo').
 *
 * This is undesirable since we don't want to allow any of these custom attributes. This method
 * strips them all.
 * @param {?} el
 * @return {?}
 */
function stripCustomNsAttrs(el) {
    DOM.attributeMap(el).forEach(function (_, attrName) {
        if (attrName === 'xmlns:ns1' || attrName.indexOf('ns1:') === 0) {
            DOM.removeAttribute(el, attrName);
        }
    });
    for (var _i = 0, _a = DOM.childNodesAsList(el); _i < _a.length; _i++) {
        var n = _a[_i];
        if (DOM.isElementNode(n))
            stripCustomNsAttrs(/** @type {?} */ (n));
    }
}
/**
 * Sanitizes the given unsafe, untrusted HTML fragment, and returns HTML text that is safe to add to
 * the DOM in a browser environment.
 * @param {?} defaultDoc
 * @param {?} unsafeHtmlInput
 * @return {?}
 */
function sanitizeHtml(defaultDoc, unsafeHtmlInput) {
    try {
        var /** @type {?} */ containerEl = getInertElement();
        // Make sure unsafeHtml is actually a string (TypeScript types are not enforced at runtime).
        var /** @type {?} */ unsafeHtml = unsafeHtmlInput ? String(unsafeHtmlInput) : '';
        // mXSS protection. Repeatedly parse the document to make sure it stabilizes, so that a browser
        // trying to auto-correct incorrect HTML cannot cause formerly inert HTML to become dangerous.
        var /** @type {?} */ mXSSAttempts = 5;
        var /** @type {?} */ parsedHtml = unsafeHtml;
        do {
            if (mXSSAttempts === 0) {
                throw new Error('Failed to sanitize html because the input is unstable');
            }
            mXSSAttempts--;
            unsafeHtml = parsedHtml;
            DOM.setInnerHTML(containerEl, unsafeHtml);
            if (defaultDoc.documentMode) {
                // strip custom-namespaced attributes on IE<=11
                stripCustomNsAttrs(containerEl);
            }
            parsedHtml = DOM.getInnerHTML(containerEl);
        } while (unsafeHtml !== parsedHtml);
        var /** @type {?} */ sanitizer = new SanitizingHtmlSerializer();
        var /** @type {?} */ safeHtml = sanitizer.sanitizeChildren(DOM.getTemplateContent(containerEl) || containerEl);
        // Clear out the body element.
        var /** @type {?} */ parent = DOM.getTemplateContent(containerEl) || containerEl;
        for (var _i = 0, _a = DOM.childNodesAsList(parent); _i < _a.length; _i++) {
            var child = _a[_i];
            DOM.removeChild(parent, child);
        }
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["isDevMode"])() && sanitizer.sanitizedSomething) {
            DOM.log('WARNING: sanitizing HTML stripped some content (see http://g.co/ng/security#xss).');
        }
        return safeHtml;
    }
    catch (e) {
        // In case anything goes wrong, clear out inertElement to reset the entire DOM structure.
        inertElement = null;
        throw e;
    }
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Regular expression for safe style values.
 *
 * Quotes (" and ') are allowed, but a check must be done elsewhere to ensure they're balanced.
 *
 * ',' allows multiple values to be assigned to the same property (e.g. background-attachment or
 * font-family) and hence could allow multiple values to get injected, but that should pose no risk
 * of XSS.
 *
 * The function expression checks only for XSS safety, not for CSS validity.
 *
 * This regular expression was taken from the Closure sanitization library, and augmented for
 * transformation values.
 */
var VALUES = '[-,."\'%_!# a-zA-Z0-9]+';
var TRANSFORMATION_FNS = '(?:matrix|translate|scale|rotate|skew|perspective)(?:X|Y|3d)?';
var COLOR_FNS = '(?:rgb|hsl)a?';
var GRADIENTS = '(?:repeating-)?(?:linear|radial)-gradient';
var CSS3_FNS = '(?:calc|attr)';
var FN_ARGS = '\\([-0-9.%, #a-zA-Z]+\\)';
var SAFE_STYLE_VALUE = new RegExp("^(" + VALUES + "|" +
    ("(?:" + TRANSFORMATION_FNS + "|" + COLOR_FNS + "|" + GRADIENTS + "|" + CSS3_FNS + ")") +
    (FN_ARGS + ")$"), 'g');
/**
 * Matches a `url(...)` value with an arbitrary argument as long as it does
 * not contain parentheses.
 *
 * The URL value still needs to be sanitized separately.
 *
 * `url(...)` values are a very common use case, e.g. for `background-image`. With carefully crafted
 * CSS style rules, it is possible to construct an information leak with `url` values in CSS, e.g.
 * by observing whether scroll bars are displayed, or character ranges used by a font face
 * definition.
 *
 * Angular only allows binding CSS values (as opposed to entire CSS rules), so it is unlikely that
 * binding a URL value without further cooperation from the page will cause an information leak, and
 * if so, it is just a leak, not a full blown XSS vulnerability.
 *
 * Given the common use case, low likelihood of attack vector, and low impact of an attack, this
 * code is permissive and allows URLs that sanitize otherwise.
 */
var URL_RE = /^url\(([^)]+)\)$/;
/**
 * Checks that quotes (" and ') are properly balanced inside a string. Assumes
 * that neither escape (\) nor any other character that could result in
 * breaking out of a string parsing context are allowed;
 * see http://www.w3.org/TR/css3-syntax/#string-token-diagram.
 *
 * This code was taken from the Closure sanitization library.
 * @param {?} value
 * @return {?}
 */
function hasBalancedQuotes(value) {
    var /** @type {?} */ outsideSingle = true;
    var /** @type {?} */ outsideDouble = true;
    for (var /** @type {?} */ i = 0; i < value.length; i++) {
        var /** @type {?} */ c = value.charAt(i);
        if (c === '\'' && outsideDouble) {
            outsideSingle = !outsideSingle;
        }
        else if (c === '"' && outsideSingle) {
            outsideDouble = !outsideDouble;
        }
    }
    return outsideSingle && outsideDouble;
}
/**
 * Sanitizes the given untrusted CSS style property value (i.e. not an entire object, just a single
 * value) and returns a value that is safe to use in a browser environment.
 * @param {?} value
 * @return {?}
 */
function sanitizeStyle(value) {
    value = String(value).trim(); // Make sure it's actually a string.
    if (!value)
        return '';
    // Single url(...) values are supported, but only for URLs that sanitize cleanly. See above for
    // reasoning behind this.
    var /** @type {?} */ urlMatch = value.match(URL_RE);
    if ((urlMatch && sanitizeUrl(urlMatch[1]) === urlMatch[1]) ||
        value.match(SAFE_STYLE_VALUE) && hasBalancedQuotes(value)) {
        return value; // Safe style values.
    }
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["isDevMode"])()) {
        getDOM().log("WARNING: sanitizing unsafe style value " + value + " (see http://g.co/ng/security#xss).");
    }
    return 'unsafe';
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * DomSanitizer helps preventing Cross Site Scripting Security bugs (XSS) by sanitizing
 * values to be safe to use in the different DOM contexts.
 *
 * For example, when binding a URL in an `<a [href]="someValue">` hyperlink, `someValue` will be
 * sanitized so that an attacker cannot inject e.g. a `javascript:` URL that would execute code on
 * the website.
 *
 * In specific situations, it might be necessary to disable sanitization, for example if the
 * application genuinely needs to produce a `javascript:` style link with a dynamic value in it.
 * Users can bypass security by constructing a value with one of the `bypassSecurityTrust...`
 * methods, and then binding to that value from the template.
 *
 * These situations should be very rare, and extraordinary care must be taken to avoid creating a
 * Cross Site Scripting (XSS) security bug!
 *
 * When using `bypassSecurityTrust...`, make sure to call the method as early as possible and as
 * close as possible to the source of the value, to make it easy to verify no security bug is
 * created by its use.
 *
 * It is not required (and not recommended) to bypass security if the value is safe, e.g. a URL that
 * does not start with a suspicious protocol, or an HTML snippet that does not contain dangerous
 * code. The sanitizer leaves safe values intact.
 *
 * \@security Calling any of the `bypassSecurityTrust...` APIs disables Angular's built-in
 * sanitization for the value passed in. Carefully check and audit all values and code paths going
 * into this call. Make sure any user data is appropriately escaped for this security context.
 * For more detail, see the [Security Guide](http://g.co/ng/security).
 *
 * \@stable
 * @abstract
 */
var DomSanitizer = (function () {
    function DomSanitizer() {
    }
    /**
     * Sanitizes a value for use in the given SecurityContext.
     *
     * If value is trusted for the context, this method will unwrap the contained safe value and use
     * it directly. Otherwise, value will be sanitized to be safe in the given context, for example
     * by replacing URLs that have an unsafe protocol part (such as `javascript:`). The implementation
     * is responsible to make sure that the value can definitely be safely used in the given context.
     * @abstract
     * @param {?} context
     * @param {?} value
     * @return {?}
     */
    DomSanitizer.prototype.sanitize = function (context, value) { };
    /**
     * Bypass security and trust the given value to be safe HTML. Only use this when the bound HTML
     * is unsafe (e.g. contains `<script>` tags) and the code should be executed. The sanitizer will
     * leave safe HTML intact, so in most situations this method should not be used.
     *
     * **WARNING:** calling this method with untrusted user data exposes your application to XSS
     * security risks!
     * @abstract
     * @param {?} value
     * @return {?}
     */
    DomSanitizer.prototype.bypassSecurityTrustHtml = function (value) { };
    /**
     * Bypass security and trust the given value to be safe style value (CSS).
     *
     * **WARNING:** calling this method with untrusted user data exposes your application to XSS
     * security risks!
     * @abstract
     * @param {?} value
     * @return {?}
     */
    DomSanitizer.prototype.bypassSecurityTrustStyle = function (value) { };
    /**
     * Bypass security and trust the given value to be safe JavaScript.
     *
     * **WARNING:** calling this method with untrusted user data exposes your application to XSS
     * security risks!
     * @abstract
     * @param {?} value
     * @return {?}
     */
    DomSanitizer.prototype.bypassSecurityTrustScript = function (value) { };
    /**
     * Bypass security and trust the given value to be a safe style URL, i.e. a value that can be used
     * in hyperlinks or `<img src>`.
     *
     * **WARNING:** calling this method with untrusted user data exposes your application to XSS
     * security risks!
     * @abstract
     * @param {?} value
     * @return {?}
     */
    DomSanitizer.prototype.bypassSecurityTrustUrl = function (value) { };
    /**
     * Bypass security and trust the given value to be a safe resource URL, i.e. a location that may
     * be used to load executable code from, like `<script src>`, or `<iframe src>`.
     *
     * **WARNING:** calling this method with untrusted user data exposes your application to XSS
     * security risks!
     * @abstract
     * @param {?} value
     * @return {?}
     */
    DomSanitizer.prototype.bypassSecurityTrustResourceUrl = function (value) { };
    return DomSanitizer;
}());
var DomSanitizerImpl = (function (_super) {
    __extends(DomSanitizerImpl, _super);
    /**
     * @param {?} _doc
     */
    function DomSanitizerImpl(_doc) {
        var _this = _super.call(this) || this;
        _this._doc = _doc;
        return _this;
    }
    /**
     * @param {?} ctx
     * @param {?} value
     * @return {?}
     */
    DomSanitizerImpl.prototype.sanitize = function (ctx, value) {
        if (value == null)
            return null;
        switch (ctx) {
            case __WEBPACK_IMPORTED_MODULE_1__angular_core__["SecurityContext"].NONE:
                return (value);
            case __WEBPACK_IMPORTED_MODULE_1__angular_core__["SecurityContext"].HTML:
                if (value instanceof SafeHtmlImpl)
                    return value.changingThisBreaksApplicationSecurity;
                this.checkNotSafeValue(value, 'HTML');
                return sanitizeHtml(this._doc, String(value));
            case __WEBPACK_IMPORTED_MODULE_1__angular_core__["SecurityContext"].STYLE:
                if (value instanceof SafeStyleImpl)
                    return value.changingThisBreaksApplicationSecurity;
                this.checkNotSafeValue(value, 'Style');
                return sanitizeStyle(/** @type {?} */ (value));
            case __WEBPACK_IMPORTED_MODULE_1__angular_core__["SecurityContext"].SCRIPT:
                if (value instanceof SafeScriptImpl)
                    return value.changingThisBreaksApplicationSecurity;
                this.checkNotSafeValue(value, 'Script');
                throw new Error('unsafe value used in a script context');
            case __WEBPACK_IMPORTED_MODULE_1__angular_core__["SecurityContext"].URL:
                if (value instanceof SafeResourceUrlImpl || value instanceof SafeUrlImpl) {
                    // Allow resource URLs in URL contexts, they are strictly more trusted.
                    return value.changingThisBreaksApplicationSecurity;
                }
                this.checkNotSafeValue(value, 'URL');
                return sanitizeUrl(String(value));
            case __WEBPACK_IMPORTED_MODULE_1__angular_core__["SecurityContext"].RESOURCE_URL:
                if (value instanceof SafeResourceUrlImpl) {
                    return value.changingThisBreaksApplicationSecurity;
                }
                this.checkNotSafeValue(value, 'ResourceURL');
                throw new Error('unsafe value used in a resource URL context (see http://g.co/ng/security#xss)');
            default:
                throw new Error("Unexpected SecurityContext " + ctx + " (see http://g.co/ng/security#xss)");
        }
    };
    /**
     * @param {?} value
     * @param {?} expectedType
     * @return {?}
     */
    DomSanitizerImpl.prototype.checkNotSafeValue = function (value, expectedType) {
        if (value instanceof SafeValueImpl) {
            throw new Error("Required a safe " + expectedType + ", got a " + value.getTypeName() + " " +
                "(see http://g.co/ng/security#xss)");
        }
    };
    /**
     * @param {?} value
     * @return {?}
     */
    DomSanitizerImpl.prototype.bypassSecurityTrustHtml = function (value) { return new SafeHtmlImpl(value); };
    /**
     * @param {?} value
     * @return {?}
     */
    DomSanitizerImpl.prototype.bypassSecurityTrustStyle = function (value) { return new SafeStyleImpl(value); };
    /**
     * @param {?} value
     * @return {?}
     */
    DomSanitizerImpl.prototype.bypassSecurityTrustScript = function (value) { return new SafeScriptImpl(value); };
    /**
     * @param {?} value
     * @return {?}
     */
    DomSanitizerImpl.prototype.bypassSecurityTrustUrl = function (value) { return new SafeUrlImpl(value); };
    /**
     * @param {?} value
     * @return {?}
     */
    DomSanitizerImpl.prototype.bypassSecurityTrustResourceUrl = function (value) {
        return new SafeResourceUrlImpl(value);
    };
    return DomSanitizerImpl;
}(DomSanitizer));
DomSanitizerImpl.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Injectable"] },
];
/**
 * @nocollapse
 */
DomSanitizerImpl.ctorParameters = function () { return [
    { type: undefined, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Inject"], args: [DOCUMENT,] },] },
]; };
/**
 * @abstract
 */
var SafeValueImpl = (function () {
    /**
     * @param {?} changingThisBreaksApplicationSecurity
     */
    function SafeValueImpl(changingThisBreaksApplicationSecurity) {
        this.changingThisBreaksApplicationSecurity = changingThisBreaksApplicationSecurity;
        // empty
    }
    /**
     * @abstract
     * @return {?}
     */
    SafeValueImpl.prototype.getTypeName = function () { };
    /**
     * @return {?}
     */
    SafeValueImpl.prototype.toString = function () {
        return "SafeValue must use [property]=binding: " + this.changingThisBreaksApplicationSecurity +
            " (see http://g.co/ng/security#xss)";
    };
    return SafeValueImpl;
}());
var SafeHtmlImpl = (function (_super) {
    __extends(SafeHtmlImpl, _super);
    function SafeHtmlImpl() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @return {?}
     */
    SafeHtmlImpl.prototype.getTypeName = function () { return 'HTML'; };
    return SafeHtmlImpl;
}(SafeValueImpl));
var SafeStyleImpl = (function (_super) {
    __extends(SafeStyleImpl, _super);
    function SafeStyleImpl() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @return {?}
     */
    SafeStyleImpl.prototype.getTypeName = function () { return 'Style'; };
    return SafeStyleImpl;
}(SafeValueImpl));
var SafeScriptImpl = (function (_super) {
    __extends(SafeScriptImpl, _super);
    function SafeScriptImpl() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @return {?}
     */
    SafeScriptImpl.prototype.getTypeName = function () { return 'Script'; };
    return SafeScriptImpl;
}(SafeValueImpl));
var SafeUrlImpl = (function (_super) {
    __extends(SafeUrlImpl, _super);
    function SafeUrlImpl() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @return {?}
     */
    SafeUrlImpl.prototype.getTypeName = function () { return 'URL'; };
    return SafeUrlImpl;
}(SafeValueImpl));
var SafeResourceUrlImpl = (function (_super) {
    __extends(SafeResourceUrlImpl, _super);
    function SafeResourceUrlImpl() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @return {?}
     */
    SafeResourceUrlImpl.prototype.getTypeName = function () { return 'ResourceURL'; };
    return SafeResourceUrlImpl;
}(SafeValueImpl));
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var INTERNAL_BROWSER_PLATFORM_PROVIDERS = [
    { provide: __WEBPACK_IMPORTED_MODULE_1__angular_core__["PLATFORM_ID"], useValue: __WEBPACK_IMPORTED_MODULE_0__angular_common__["ɵPLATFORM_BROWSER_ID"] },
    { provide: __WEBPACK_IMPORTED_MODULE_1__angular_core__["PLATFORM_INITIALIZER"], useValue: initDomAdapter, multi: true },
    { provide: __WEBPACK_IMPORTED_MODULE_0__angular_common__["PlatformLocation"], useClass: BrowserPlatformLocation },
    { provide: DOCUMENT, useFactory: _document, deps: [] },
];
/**
 * \@security Replacing built-in sanitization providers exposes the application to XSS risks.
 * Attacker-controlled data introduced by an unsanitized provider could expose your
 * application to XSS risks. For more detail, see the [Security Guide](http://g.co/ng/security).
 * \@experimental
 */
var BROWSER_SANITIZATION_PROVIDERS = [
    { provide: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Sanitizer"], useExisting: DomSanitizer },
    { provide: DomSanitizer, useClass: DomSanitizerImpl },
];
/**
 * \@stable
 */
var platformBrowser = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__angular_core__["createPlatformFactory"])(__WEBPACK_IMPORTED_MODULE_1__angular_core__["platformCore"], 'browser', INTERNAL_BROWSER_PLATFORM_PROVIDERS);
/**
 * @return {?}
 */
function initDomAdapter() {
    BrowserDomAdapter.makeCurrent();
    BrowserGetTestability.init();
}
/**
 * @return {?}
 */
function errorHandler() {
    return new __WEBPACK_IMPORTED_MODULE_1__angular_core__["ErrorHandler"]();
}
/**
 * @return {?}
 */
function _document() {
    return document;
}
/**
 * The ng module for the browser.
 *
 * \@stable
 */
var BrowserModule = (function () {
    /**
     * @param {?} parentModule
     */
    function BrowserModule(parentModule) {
        if (parentModule) {
            throw new Error("BrowserModule has already been loaded. If you need access to common directives such as NgIf and NgFor from a lazy loaded module, import CommonModule instead.");
        }
    }
    /**
     * Configures a browser-based application to transition from a server-rendered app, if
     * one is present on the page. The specified parameters must include an application id,
     * which must match between the client and server applications.
     *
     * \@experimental
     * @param {?} params
     * @return {?}
     */
    BrowserModule.withServerTransition = function (params) {
        return {
            ngModule: BrowserModule,
            providers: [
                { provide: __WEBPACK_IMPORTED_MODULE_1__angular_core__["APP_ID"], useValue: params.appId },
                { provide: TRANSITION_ID, useExisting: __WEBPACK_IMPORTED_MODULE_1__angular_core__["APP_ID"] },
                SERVER_TRANSITION_PROVIDERS,
            ],
        };
    };
    return BrowserModule;
}());
BrowserModule.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["NgModule"], args: [{
                providers: [
                    BROWSER_SANITIZATION_PROVIDERS,
                    { provide: __WEBPACK_IMPORTED_MODULE_1__angular_core__["ErrorHandler"], useFactory: errorHandler, deps: [] },
                    { provide: EVENT_MANAGER_PLUGINS, useClass: DomEventsPlugin, multi: true },
                    { provide: EVENT_MANAGER_PLUGINS, useClass: KeyEventsPlugin, multi: true },
                    { provide: EVENT_MANAGER_PLUGINS, useClass: HammerGesturesPlugin, multi: true },
                    { provide: HAMMER_GESTURE_CONFIG, useClass: HammerGestureConfig },
                    DomRendererFactory2,
                    { provide: __WEBPACK_IMPORTED_MODULE_1__angular_core__["RendererFactory2"], useExisting: DomRendererFactory2 },
                    { provide: SharedStylesHost, useExisting: DomSharedStylesHost },
                    DomSharedStylesHost,
                    __WEBPACK_IMPORTED_MODULE_1__angular_core__["Testability"],
                    EventManager,
                    ELEMENT_PROBE_PROVIDERS,
                    Meta,
                    Title,
                ],
                exports: [__WEBPACK_IMPORTED_MODULE_0__angular_common__["CommonModule"], __WEBPACK_IMPORTED_MODULE_1__angular_core__["ApplicationModule"]]
            },] },
];
/**
 * @nocollapse
 */
BrowserModule.ctorParameters = function () { return [
    { type: BrowserModule, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_1__angular_core__["SkipSelf"] },] },
]; };
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var win = typeof window !== 'undefined' && window || {};
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var ChangeDetectionPerfRecord = (function () {
    /**
     * @param {?} msPerTick
     * @param {?} numTicks
     */
    function ChangeDetectionPerfRecord(msPerTick, numTicks) {
        this.msPerTick = msPerTick;
        this.numTicks = numTicks;
    }
    return ChangeDetectionPerfRecord;
}());
/**
 * Entry point for all Angular profiling-related debug tools. This object
 * corresponds to the `ng.profiler` in the dev console.
 */
var AngularProfiler = (function () {
    /**
     * @param {?} ref
     */
    function AngularProfiler(ref) {
        this.appRef = ref.injector.get(__WEBPACK_IMPORTED_MODULE_1__angular_core__["ApplicationRef"]);
    }
    /**
     * Exercises change detection in a loop and then prints the average amount of
     * time in milliseconds how long a single round of change detection takes for
     * the current state of the UI. It runs a minimum of 5 rounds for a minimum
     * of 500 milliseconds.
     *
     * Optionally, a user may pass a `config` parameter containing a map of
     * options. Supported options are:
     *
     * `record` (boolean) - causes the profiler to record a CPU profile while
     * it exercises the change detector. Example:
     *
     * ```
     * ng.profiler.timeChangeDetection({record: true})
     * ```
     * @param {?} config
     * @return {?}
     */
    AngularProfiler.prototype.timeChangeDetection = function (config) {
        var /** @type {?} */ record = config && config['record'];
        var /** @type {?} */ profileName = 'Change Detection';
        // Profiler is not available in Android browsers, nor in IE 9 without dev tools opened
        var /** @type {?} */ isProfilerAvailable = win.console.profile != null;
        if (record && isProfilerAvailable) {
            win.console.profile(profileName);
        }
        var /** @type {?} */ start = getDOM().performanceNow();
        var /** @type {?} */ numTicks = 0;
        while (numTicks < 5 || (getDOM().performanceNow() - start) < 500) {
            this.appRef.tick();
            numTicks++;
        }
        var /** @type {?} */ end = getDOM().performanceNow();
        if (record && isProfilerAvailable) {
            // need to cast to <any> because type checker thinks there's no argument
            // while in fact there is:
            //
            // https://developer.mozilla.org/en-US/docs/Web/API/Console/profileEnd
            ((win.console.profileEnd))(profileName);
        }
        var /** @type {?} */ msPerTick = (end - start) / numTicks;
        win.console.log("ran " + numTicks + " change detection cycles");
        win.console.log(msPerTick.toFixed(2) + " ms per check");
        return new ChangeDetectionPerfRecord(msPerTick, numTicks);
    };
    return AngularProfiler;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var PROFILER_GLOBAL_NAME = 'ng.profiler';
/**
 * Enabled Angular debug tools that are accessible via your browser's
 * developer console.
 *
 * Usage:
 *
 * 1. Open developer console (e.g. in Chrome Ctrl + Shift + j)
 * 1. Type `ng.` (usually the console will show auto-complete suggestion)
 * 1. Try the change detection profiler `ng.profiler.timeChangeDetection()`
 *    then hit Enter.
 *
 * \@experimental All debugging apis are currently experimental.
 * @template T
 * @param {?} ref
 * @return {?}
 */
function enableDebugTools(ref) {
    getDOM().setGlobalVar(PROFILER_GLOBAL_NAME, new AngularProfiler(ref));
    return ref;
}
/**
 * Disables Angular tools.
 *
 * \@experimental All debugging apis are currently experimental.
 * @return {?}
 */
function disableDebugTools() {
    getDOM().setGlobalVar(PROFILER_GLOBAL_NAME, null);
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Predicates for use with {\@link DebugElement}'s query functions.
 *
 * \@experimental All debugging apis are currently experimental.
 */
var By = (function () {
    function By() {
    }
    /**
     * Match all elements.
     *
     * ## Example
     *
     * {\@example platform-browser/dom/debug/ts/by/by.ts region='by_all'}
     * @return {?}
     */
    By.all = function () { return function (debugElement) { return true; }; };
    /**
     * Match elements by the given CSS selector.
     *
     * ## Example
     *
     * {\@example platform-browser/dom/debug/ts/by/by.ts region='by_css'}
     * @param {?} selector
     * @return {?}
     */
    By.css = function (selector) {
        return function (debugElement) {
            return debugElement.nativeElement != null ?
                getDOM().elementMatches(debugElement.nativeElement, selector) :
                false;
        };
    };
    /**
     * Match elements that have the given directive present.
     *
     * ## Example
     *
     * {\@example platform-browser/dom/debug/ts/by/by.ts region='by_directive'}
     * @param {?} type
     * @return {?}
     */
    By.directive = function (type) {
        return function (debugElement) { return ((debugElement.providerTokens)).indexOf(type) !== -1; };
    };
    return By;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @module
 * @description
 * Entry point for all public APIs of the common package.
 */
/**
 * \@stable
 */
var VERSION = new __WEBPACK_IMPORTED_MODULE_1__angular_core__["Version"]('4.1.0');
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @module
 * @description
 * Entry point for all public APIs of the platform-browser package.
 */
// This file only reexports content of the `src` folder. Keep it that way.
/**
 * Generated bundle index. Do not edit.
 */

//# sourceMappingURL=platform-browser.es5.js.map


/***/ }),

/***/ "QqRK":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__("mmVS");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var InnerSubscriber = (function (_super) {
    __extends(InnerSubscriber, _super);
    function InnerSubscriber(parent, outerValue, outerIndex) {
        _super.call(this);
        this.parent = parent;
        this.outerValue = outerValue;
        this.outerIndex = outerIndex;
        this.index = 0;
    }
    InnerSubscriber.prototype._next = function (value) {
        this.parent.notifyNext(this.outerValue, value, this.outerIndex, this.index++, this);
    };
    InnerSubscriber.prototype._error = function (error) {
        this.parent.notifyError(error, this);
        this.unsubscribe();
    };
    InnerSubscriber.prototype._complete = function () {
        this.parent.notifyComplete(this);
        this.unsubscribe();
    };
    return InnerSubscriber;
}(Subscriber_1.Subscriber));
exports.InnerSubscriber = InnerSubscriber;
//# sourceMappingURL=InnerSubscriber.js.map

/***/ }),

/***/ "Qqkx":
/***/ (function(module, exports) {

exports.config = {"status":true,"model":{"plazza":"true","released":1405068612,"title-en":"Sultanspiel","module":"chessbase","summary":"Tressau, 1840","thumbnail":"sultangame-thumb.png","rules":{"en":"sultangame-rules.html"},"credits":{"en":"sultangame-credits.html"},"gameOptions":{"preventRepeat":true,"uctTransposition":"state","uctIgnoreLoop":false,"levelOptions":{"pieceValueFactor":1,"pieceValueRatioFactor":1,"posValueFactor":0.1,"averageDistKingFactor":-0.01,"castleFactor":0.1,"minorPiecesMovedFactor":0.1,"checkFactor":0.2,"endingKingFreedomFactor":0.01,"endingDistKingFactor":0.05,"distKingCornerFactor":0.1,"distPawnPromo1Factor":0.3,"distPawnPromo2Factor":0.1,"distPawnPromo3Factor":0.05}},"obsolete":false,"js":["base-model.js","grid-geo-model.js","sultangame-model.js"],"description":{"en":"sultangame-description.html"},"levels":[{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"easy","label":"Easy","maxNodes":1000},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"fast","label":"Fast [1sec]","maxDuration":1,"isDefault":true},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"medium","label":"Medium","maxNodes":10000,"maxDuration":10},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"strong","label":"Strong","maxNodes":20000,"maxDuration":15}]},"view":{"title-en":"Chessbase view","module":"chessbase","xdView":true,"css":["chessbase.css"],"preferredRatio":1,"useShowMoves":true,"useNotation":true,"useAutoComplete":true,"defaultOptions":{"sounds":true,"moves":true,"notation":false,"autocomplete":false},"skins":[{"name":"skin3d","title":"3D Classic","3d":true,"preload":["smoothedfilegeo|0|/res/ring-target.js","image|/res/images/cancel.png","image|/res/images/wikipedia.png","smoothedfilegeo|0|/res/fairy/pawn/pawn.js","image|/res/fairy/pawn/pawn-diffusemap.jpg","image|/res/fairy/pawn/pawn-normalmap.jpg","smoothedfilegeo|0|/res/fairy/knight/knight.js","image|/res/fairy/knight/knight-diffusemap.jpg","image|/res/fairy/knight/knight-normalmap.jpg","smoothedfilegeo|0|/res/fairy/bishop/bishop.js","image|/res/fairy/bishop/bishop-diffusemap.jpg","image|/res/fairy/bishop/bishop-normalmap.jpg","smoothedfilegeo|0|/res/fairy/king/king.js","image|/res/fairy/king/king-diffusemap.jpg","image|/res/fairy/king/king-normalmap.jpg","smoothedfilegeo|0|/res/fairy/rook/rook.js","image|/res/fairy/rook/rook-diffusemap.jpg","image|/res/fairy/rook/rook-normalmap.jpg","smoothedfilegeo|0|/res/fairy/queen/queen.js","image|/res/fairy/queen/queen-diffusemap.jpg","image|/res/fairy/queen/queen-normalmap.jpg","smoothedfilegeo|0|/res/fairy/cardinal/cardinal.js","image|/res/fairy/cardinal/cardinal-diffusemap.jpg","image|/res/fairy/cardinal/cardinal-normalmap.jpg","smoothedfilegeo|0|/res/fairy/marshall/marshall.js","image|/res/fairy/marshall/marshall-diffusemap.jpg","image|/res/fairy/marshall/marshall-normalmap.jpg","smoothedfilegeo|0|/res/fairy/amazon/amazon.js","image|/res/fairy/amazon/amazon-diffusemap.jpg","image|/res/fairy/amazon/amazon-normalmap.jpg"],"world":{"lightIntensity":1.3,"skyLightIntensity":1.2,"lightCastShadow":true,"fog":false,"color":4686804,"lightPosition":{"x":-9,"y":9,"z":9},"skyLightPosition":{"x":9,"y":9,"z":9},"lightShadowDarkness":0.55,"ambientLightColor":2236962},"camera":{"fov":45,"distMax":50,"radius":18,"elevationAngle":60,"elevationMin":0}},{"name":"skin2d","title":"2D Classic","3d":false,"preload":["image|/res/images/cancel.png","image|/res/images/whitebg.png","image|/res/fairy/wikipedia-fairy-sprites.png"]}],"animateSelfMoves":false,"switchable":true,"sounds":{"move1":"alq_move1","move2":"alq_move2","move3":"alq_move3","move4":"alq_move2","tac1":"alq_tac1","tac2":"alq_tac2","tac3":"alq_tac1","promo":"promo","usermove":null},"js":["base-view.js","grid-board-view.js","fairy-set-view.js","sultangame-view.js"],"visuals":{"600x600":["res/visuals/sultangame-600x600-3d.jpg","res/visuals/sultangame-600x600-2d.jpg"]}}}

/***/ }),

/***/ "Qt4r":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Observable_1 = __webpack_require__("rCTf");
var isScheduler_1 = __webpack_require__("fWbP");
var selfSelector = function (value) { return value; };
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var GenerateObservable = (function (_super) {
    __extends(GenerateObservable, _super);
    function GenerateObservable(initialState, condition, iterate, resultSelector, scheduler) {
        _super.call(this);
        this.initialState = initialState;
        this.condition = condition;
        this.iterate = iterate;
        this.resultSelector = resultSelector;
        this.scheduler = scheduler;
    }
    GenerateObservable.create = function (initialStateOrOptions, condition, iterate, resultSelectorOrObservable, scheduler) {
        if (arguments.length == 1) {
            return new GenerateObservable(initialStateOrOptions.initialState, initialStateOrOptions.condition, initialStateOrOptions.iterate, initialStateOrOptions.resultSelector || selfSelector, initialStateOrOptions.scheduler);
        }
        if (resultSelectorOrObservable === undefined || isScheduler_1.isScheduler(resultSelectorOrObservable)) {
            return new GenerateObservable(initialStateOrOptions, condition, iterate, selfSelector, resultSelectorOrObservable);
        }
        return new GenerateObservable(initialStateOrOptions, condition, iterate, resultSelectorOrObservable, scheduler);
    };
    GenerateObservable.prototype._subscribe = function (subscriber) {
        var state = this.initialState;
        if (this.scheduler) {
            return this.scheduler.schedule(GenerateObservable.dispatch, 0, {
                subscriber: subscriber,
                iterate: this.iterate,
                condition: this.condition,
                resultSelector: this.resultSelector,
                state: state });
        }
        var _a = this, condition = _a.condition, resultSelector = _a.resultSelector, iterate = _a.iterate;
        do {
            if (condition) {
                var conditionResult = void 0;
                try {
                    conditionResult = condition(state);
                }
                catch (err) {
                    subscriber.error(err);
                    return;
                }
                if (!conditionResult) {
                    subscriber.complete();
                    break;
                }
            }
            var value = void 0;
            try {
                value = resultSelector(state);
            }
            catch (err) {
                subscriber.error(err);
                return;
            }
            subscriber.next(value);
            if (subscriber.closed) {
                break;
            }
            try {
                state = iterate(state);
            }
            catch (err) {
                subscriber.error(err);
                return;
            }
        } while (true);
    };
    GenerateObservable.dispatch = function (state) {
        var subscriber = state.subscriber, condition = state.condition;
        if (subscriber.closed) {
            return;
        }
        if (state.needIterate) {
            try {
                state.state = state.iterate(state.state);
            }
            catch (err) {
                subscriber.error(err);
                return;
            }
        }
        else {
            state.needIterate = true;
        }
        if (condition) {
            var conditionResult = void 0;
            try {
                conditionResult = condition(state.state);
            }
            catch (err) {
                subscriber.error(err);
                return;
            }
            if (!conditionResult) {
                subscriber.complete();
                return;
            }
            if (subscriber.closed) {
                return;
            }
        }
        var value;
        try {
            value = state.resultSelector(state.state);
        }
        catch (err) {
            subscriber.error(err);
            return;
        }
        if (subscriber.closed) {
            return;
        }
        subscriber.next(value);
        if (subscriber.closed) {
            return;
        }
        return this.schedule(state);
    };
    return GenerateObservable;
}(Observable_1.Observable));
exports.GenerateObservable = GenerateObservable;
//# sourceMappingURL=GenerateObservable.js.map

/***/ }),

/***/ "Qy2n":
/***/ (function(module, exports) {

exports.config = {"status":true,"model":{"plazza":"true","released":1397055378,"title-en":"Modern Circular Chess","module":"chessbase","summary":"Chess on a ring","thumbnail":"circular-thumb.png","rules":{"en":"circular-rules.html"},"credits":{"en":"circular-credits.html"},"gameOptions":{"preventRepeat":true,"uctTransposition":"state","uctIgnoreLoop":false,"levelOptions":{"pieceValueFactor":1,"pieceValueRatioFactor":1,"posValueFactor":0.1,"averageDistKingFactor":-0.01,"castleFactor":0.1,"minorPiecesMovedFactor":0.1,"checkFactor":0.2,"endingKingFreedomFactor":0.01,"endingDistKingFactor":0.05,"distKingCornerFactor":0.1,"distPawnPromo1Factor":0.3,"distPawnPromo2Factor":0.1,"distPawnPromo3Factor":0.05}},"obsolete":false,"js":["base-model.js","cylinder-geo-model.js","circular-model.js"],"description":{"en":"circular-description.html"},"levels":[{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"easy","label":"Easy","maxNodes":1000},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"fast","label":"Fast [1sec]","maxDuration":1,"isDefault":true},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"medium","label":"Medium","maxNodes":10000,"maxDuration":10},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"strong","label":"Strong","maxNodes":20000,"maxDuration":15}]},"view":{"title-en":"Chessbase view","module":"chessbase","xdView":true,"css":["chessbase.css","circular.css"],"preferredRatio":1,"useShowMoves":true,"useNotation":true,"useAutoComplete":true,"defaultOptions":{"sounds":true,"moves":true,"notation":false,"autocomplete":false},"skins":[{"name":"skin3d","title":"3D Classic","3d":true,"preload":["smoothedfilegeo|0|/res/ring-target-cylinder-v3.js","image|/res/images/cancel.png","image|/res/images/wikipedia.png","smoothedfilegeo|0|/res/staunton/pawn/pawn-classic.js","image|/res/staunton/pawn/pawn-diffusemap.jpg","image|/res/staunton/pawn/pawn-normalmap.jpg","smoothedfilegeo|0|/res/staunton/knight/knight.js","image|/res/staunton/knight/knight-diffusemap.jpg","image|/res/staunton/knight/knight-normalmap.jpg","smoothedfilegeo|0|/res/staunton/bishop/bishop.js","image|/res/staunton/bishop/bishop-diffusemap.jpg","image|/res/staunton/bishop/bishop-normalmap.jpg","smoothedfilegeo|0|/res/staunton/rook/rook.js","image|/res/staunton/rook/rook-diffusemap.jpg","image|/res/staunton/rook/rook-normalmap.jpg","smoothedfilegeo|0|/res/staunton/queen/queen.js","image|/res/staunton/queen/queen-diffusemap.jpg","image|/res/staunton/queen/queen-normalmap.jpg","smoothedfilegeo|0|/res/staunton/king/king.js","image|/res/staunton/king/king-diffusemap.jpg","image|/res/staunton/king/king-normalmap.jpg"],"world":{"lightIntensity":1.3,"skyLightIntensity":1.2,"lightCastShadow":true,"fog":false,"color":4686804,"lightPosition":{"x":-9,"y":9,"z":9},"skyLightPosition":{"x":9,"y":9,"z":9},"lightShadowDarkness":0.55,"ambientLightColor":2236962},"camera":{"fov":45,"distMax":50,"radius":14.5,"elevationAngle":45,"elevationMin":0,"distMin":0}},{"name":"skin2d","title":"2D Classic","3d":false,"preload":["image|/res/images/wikipedia.png","image|/res/images/whitebg.png","image|/res/images/cancel.png"]}],"animateSelfMoves":false,"switchable":true,"sounds":{"move1":"alq_move1","move2":"alq_move2","move3":"alq_move3","move4":"alq_move2","tac1":"alq_tac1","tac2":"alq_tac2","tac3":"alq_tac1","promo":"promo","usermove":null},"js":["base-view.js","circular-board-view.js","staunton-set-view.js","circular-view.js"],"visuals":{"600x600":["res/visuals/circular-600x600-3d.jpg","res/visuals/circular-600x600-2d.jpg"]}}}

/***/ }),

/***/ "Qy3m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__object_extend__ = __webpack_require__("xZ/u");
/* harmony export (immutable) */ __webpack_exports__["b"] = validateSuffixes;
/* harmony export (immutable) */ __webpack_exports__["a"] = mergeByAlias;
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

var ALIAS_DELIMITERS = /(\.|-|_)/g;
function firstUpperCase(part) {
    var first = part.length > 0 ? part.charAt(0) : "";
    var remainder = (part.length > 1) ? part.slice(1) : "";
    return first.toUpperCase() + remainder;
}
/**
 * Converts snake-case to SnakeCase.
 * @param name Text to UpperCamelCase
 */
function camelCase(name) {
    return name
        .replace(ALIAS_DELIMITERS, "|")
        .split("|")
        .map(firstUpperCase)
        .join("");
}
/**
 * For each breakpoint, ensure that a Suffix is defined;
 * fallback to UpperCamelCase the unique Alias value
 */
function validateSuffixes(list) {
    list.forEach(function (bp) {
        if (!bp.suffix || bp.suffix === "") {
            bp.suffix = camelCase(bp.alias); // create Suffix value based on alias
            bp.overlapping = bp.overlapping || false; // ensure default value
        }
    });
    return list;
}
/**
 * Merge a custom breakpoint list with the default list based on unique alias values
 *  - Items are added if the alias is not in the default list
 *  - Items are merged with the custom override if the alias exists in the default list
 */
function mergeByAlias(defaults, custom) {
    if (custom === void 0) { custom = []; }
    var merged = defaults.map(function (bp) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__object_extend__["a" /* extendObject */])({}, bp); });
    var findByAlias = function (alias) { return merged.reduce(function (result, bp) {
        return result || ((bp.alias === alias) ? bp : null);
    }, null); };
    // Merge custom breakpoints
    custom.forEach(function (bp) {
        var target = findByAlias(bp.alias);
        if (target) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__object_extend__["a" /* extendObject */])(target, bp);
        }
        else {
            merged.push(bp);
        }
    });
    return validateSuffixes(merged);
}
//# sourceMappingURL=breakpoint-tools.js.map

/***/ }),

/***/ "Qz0w":
/***/ (function(module, exports) {

exports.model=Model={Game:{},Board:{},Move:{}},function(){var e;Model.Game.cbConstants={MASK:65535,FLAG_MOVE:65536,FLAG_CAPTURE:131072,FLAG_STOP:262144,FLAG_SCREEN_CAPTURE:524288,FLAG_CAPTURE_KING:1048576,FLAG_CAPTURE_NO_KING:2097152};var m="undefined"!=typeof Int32Array;Model.Game.cbUseTypedArrays=m,Model.Game.cbTypedArray=function(e){if(m){var d=new Int32Array(e.length);return d.set(e),d}for(var c=[],f=e.length,g=0;g<f;g++)c.push(e[g]);return c},Model.Game.cbShortRangeGraph=function(e,m,d,c){var f=this;void 0===c&&(c=196608);for(var g={},N=0;N<e.boardSize;N++)g[N]=[],(!d||N in d)&&m.forEach(function(m){var b=e.Graph(N,m);null!=b&&(!d||b in d)&&g[N].push(f.cbTypedArray([b|c]))});return g},Model.Game.cbLongRangeGraph=function(e,m,d,c,f){var g=this;void 0!==c&&null!=c||(c=196608),f||(f=1/0);for(var N={},b=0;b<e.boardSize;b++)N[b]=[],(!d||b in d)&&m.forEach(function(m){for(var B=[],a=e.Graph(b,m),x=0;null!=a&&(!d||a in d)&&(B.push(a|c),++x!=f);)a=e.Graph(a,m);B.length>0&&N[b].push(g.cbTypedArray(B))});return N},Model.Game.cbNullGraph=function(e){for(var m={},d=0;d<e.boardSize;d++)m[d]=[];return m},Model.Game.cbAuthorGraph=function(e){for(var m={},d=0;d<e.boardSize;d++){m[d]=[];for(var c=0;c<e.boardSize;c++)m[d].push([2293760|c])}return m},Model.Game.cbMergeGraphs=function(e){for(var m=[],d=0;d<e.boardSize;d++){m[d]=[];for(var c=1;c<arguments.length;c++)m[d]=m[d].concat(arguments[c][d])}return m},Model.Game.cbGetThreatGraph=function(){function e(m,d){for(var c in N){var f=N[c];if(!(f.p.length<d.length+1)){for(var g=!0,b=0;b<d.length;b++)if(d[b]!=f.p[b]){g=!1;break}if(g){var B=f.p[d.length],a=m[B];void 0===a&&(a={e:{}},m[B]=a),f.p.length==d.length+1&&(a.t=f.t,a.ts=f.ts,a.tk=f.tk,delete N[c]),d.push(B),e(a.e,d),d.pop()}}}}var m=this;this.cbUseScreenCapture=!1,this.cbUseCaptureKing=!1,this.cbUseCaptureNoKing=!1;for(var d={1:[],"-1":[]},c=[],f=0;f<this.g.boardSize;f++)this.g.pTypes.forEach(function(e,d){e.graph[f].forEach(function(e){for(var g=[],N=0;N<e.length;N++){var b=e[N];1048576&b?(m.cbUseCaptureKing=!0,g.unshift({d:65535&b,a:f,tk:d})):2097152&b?(m.cbUseCaptureNoKing=!0,g.unshift({d:65535&b,a:f,tnk:d})):131072&b?g.unshift({d:65535&b,a:f,t:d}):262144&b?g.unshift({d:65535&b,a:f}):524288&b&&(m.cbUseScreenCapture=!0,g.unshift({d:65535&b,a:f,ts:d}))}g.length>0&&c.push(g)})});var g={};c.forEach(function(e){e.forEach(function(m,d){var c=g[m.d];void 0===c&&(c={},g[m.d]=c);for(var f=[],N=d+1;N<e.length;N++)f.push(e[N].d);f.push(m.a);var b=f.join(","),B=c[b];void 0===B&&(B={p:f,t:{},ts:{},tk:{}},c[b]=B),void 0!==m.t?B.t[m.t]=!0:void 0!==m.tk?B.tk[m.tk]=!0:void 0!==m.ts&&(B.ts[m.ts]=!0)})});for(var f=0;f<m.g.boardSize;f++){var N=g[f],b={};e(b,[]),d[1][f]=b,d[-1][f]=b}return d},Model.Game.InitGame=function(){var m=this;this.cbVar=e=this.cbDefine(),this.g.boardSize=this.cbVar.geometry.boardSize,this.g.pTypes=this.cbGetPieceTypes(),this.g.threatGraph=this.cbGetThreatGraph(),this.g.distGraph=this.cbVar.geometry.GetDistances(),this.cbPiecesCount=0,this.g.castleablePiecesCount={1:0,"-1":0};for(var d in e.pieceTypes){var c=e.pieceTypes[d];if(c.castle){(c.initial||[]).forEach(function(e){m.g.castleablePiecesCount[e.s]++})}c.initial&&(this.cbPiecesCount+=c.initial.length)}for(var f=[],d=0;d<this.cbPiecesCount;d++)f.push(d);var g=Object.keys(e.pieceTypes);this.zobrist=new JocGame.Zobrist({board:{type:"array",size:this.cbVar.geometry.boardSize,values:f},who:{values:["1","-1"]},type:{type:"array",size:this.cbPiecesCount,values:g}})},Model.Game.cbGetPieceTypes=function(){for(var e=[],m={},d=0;d<this.cbVar.geometry.boardSize;d++)m[d]=[];for(var c in this.cbVar.pieceTypes){var f=this.cbVar.pieceTypes[c];e[c]={graph:f.graph||m,abbrev:f.abbrev||"",value:f.isKing?100:f.value||1,isKing:!!f.isKing,castle:!!f.castle,epTarget:!!f.epTarget,epCatch:!!f.epCatch}}return e},Model.Board.Init=function(e){this.zSign=0},Model.Board.InitialPosition=function(d){var c=this;this.board=m?new Int16Array(d.g.boardSize):[];for(var f=0;f<d.g.boardSize;f++)this.board[f]=-1;if(this.kings={},this.pieces=[],this.ending={1:!1,"-1":!1},this.lastMove=null,d.cbVar.castle&&(this.castled={1:!1,"-1":!1}),this.zSign=d.zobrist.update(0,"who",-1),this.noCaptCount=0,this.mWho=1,d.mInitial)this.mWho=d.mInitial.turn||1,d.mInitial.pieces.forEach(function(e){var m={};for(var d in e)e.hasOwnProperty(d)&&(m[d]=e[d]);c.pieces.push(m)}),d.mInitial.lastMove&&(this.lastMove={f:d.mInitial.lastMove.f,t:d.mInitial.lastMove.t}),void 0!==d.mInitial.noCaptCount&&(this.noCaptCount=d.mInitial.noCaptCount),d.cbVar.castle&&d.mInitial.castle&&(this.castled={1:{k:!!d.mInitial.castle[1]&&!!d.mInitial.castle[1].k,q:!!d.mInitial.castle[1]&&!!d.mInitial.castle[1].q},"-1":{k:!!d.mInitial.castle[-1]&&!!d.mInitial.castle[-1].k,q:!!d.mInitial.castle[-1]&&!!d.mInitial.castle[-1].q}});else for(var g in d.cbVar.pieceTypes)for(var N=d.cbVar.pieceTypes[g],b=N.initial||[],B=0;B<b.length;B++){var a=b[B],x={s:a.s,t:parseInt(g),p:a.p,m:!1};this.pieces.push(x)}if(this.pieces.sort(function(e,m){if(e.s!=m.s)return m.s-e.s;var c=d.cbVar.pieceTypes[e.t].value||100,f=d.cbVar.pieceTypes[m.t].value||100;return c!=f?c-f:e.p-m.p}),this.pieces.forEach(function(e,m){e.i=m,c.board[e.p]=m,d.g.pTypes[e.t].isKing&&(c.kings[e.s]=e.p),c.zSign=d.zobrist.update(c.zSign,"board",m,e.p),c.zSign=d.zobrist.update(c.zSign,"type",e.t,m)}),d.mInitial&&d.mInitial.enPassant){var f=e.geometry.PosByName(d.mInitial.enPassant);if(f>=0){var h,t=e.geometry.C(f),r=e.geometry.R(f);h=1==d.mInitial.turn?e.geometry.POS(t,r-1):e.geometry.POS(t,r+1),this.epTarget={p:f,i:this.board[h]}}}},Model.Board.CopyFrom=function(e){if(m)this.board=new Int16Array(e.board.length),this.board.set(e.board);else{this.board=[];for(var d=e.board,c=d.length,f=0;f<c;f++)this.board.push(d[f])}this.pieces=[];for(var g=e.pieces.length,f=0;f<g;f++){var N=e.pieces[f];this.pieces.push({s:N.s,p:N.p,t:N.t,i:N.i,m:N.m})}this.kings={1:e.kings[1],"-1":e.kings[-1]},this.check=e.check,e.lastMove?this.lastMove={f:e.lastMove.f,t:e.lastMove.t,c:e.lastMove.c}:this.lastMove=null,this.ending={1:e.ending[1],"-1":e.ending[-1]},void 0!==e.castled&&(this.castled={1:e.castled[1],"-1":e.castled[-1]}),this.noCaptCount=e.noCaptCount,e.epTarget?this.epTarget={p:e.epTarget.p,i:e.epTarget.i}:this.epTarget=null,this.mWho=e.mWho,this.zSign=e.zSign},Model.Board.cbApplyCastle=function(e,m,d){var c=e.cbVar.castle[m.f+"/"+m.cg],f=c.r[c.r.length-1],g=this.pieces[this.board[m.cg]],N=c.k[c.k.length-1],b=this.pieces[this.board[m.f]];return d&&(this.zSign=e.zobrist.update(this.zSign,"board",g.i,m.cg),this.zSign=e.zobrist.update(this.zSign,"board",g.i,f),this.zSign=e.zobrist.update(this.zSign,"board",b.i,m.f),this.zSign=e.zobrist.update(this.zSign,"board",b.i,N)),g.p=f,g.m=!0,this.board[m.cg]=-1,b.p=N,b.m=!0,this.board[m.f]=-1,this.board[f]=g.i,this.board[N]=b.i,this.castled[g.s]=!0,this.kings[b.s]=N,[{i:g.i,f:f,t:-1},{i:b.i,f:N,t:m.f,kp:m.f,who:b.s,m:!1},{i:g.i,f:-1,t:m.cg,m:!1,cg:!1}]},Model.Board.cbQuickApply=function(e,m){if(void 0!==m.cg)return this.cbApplyCastle(e,m,!1);var d=[],c=this.board[m.f],f=this.pieces[c];if(null!=m.c){d.unshift({i:m.c,f:-1,t:this.pieces[m.c].p});var g=this.pieces[m.c];this.board[g.p]=-1,g.p=-1}var N=this.kings[f.s];return e.g.pTypes[f.t].isKing&&(this.kings[f.s]=m.t),d.unshift({i:c,f:m.t,t:m.f,kp:N,who:f.s,ty:f.t}),f.p=m.t,void 0!==m.pr&&(f.t=m.pr),this.board[m.f]=-1,this.board[m.t]=c,d},Model.Board.cbQuickUnapply=function(e,m){for(var d=0;d<m.length;d++){var c=m[d],f=this.pieces[c.i];c.f>=0&&(f.p=-1,this.board[c.f]=-1),c.t>=0&&(f.p=c.t,this.board[c.t]=c.i),void 0!==c.m&&(f.m=c.m),void 0!==c.kp&&(this.kings[c.who]=c.kp),void 0!=c.ty&&(f.t=c.ty),void 0!=c.cg&&(this.castled[f.s]=c.cg)}},Model.Board.ApplyMove=function(e,m){var d=this.pieces[this.board[m.f]];if(void 0!==m.cg)this.cbApplyCastle(e,m,!0);else{if(this.zSign=e.zobrist.update(this.zSign,"board",d.i,m.f),this.board[d.p]=-1,void 0!==m.pr&&(this.zSign=e.zobrist.update(this.zSign,"type",d.t,d.i),d.t=m.pr,this.zSign=e.zobrist.update(this.zSign,"type",d.t,d.i)),null!=m.c){var c=this.pieces[m.c];this.zSign=e.zobrist.update(this.zSign,"board",c.i,c.p),this.board[c.p]=-1,c.p=-1,c.m=!0,this.noCaptCount=0}else this.noCaptCount++;d.p=m.t,d.m=!0,this.board[m.t]=d.i,this.zSign=e.zobrist.update(this.zSign,"board",d.i,m.t),e.g.pTypes[d.t].isKing&&(this.kings[d.s]=m.t)}this.check=!!m.ck,this.lastMove={f:m.f,t:m.t,c:m.c},void 0!==m.ko&&(this.ending[d.s]=m.ko),void 0!==m.ept?this.epTarget={p:m.ept,i:d.i}:this.epTarget=null,this.zSign=e.zobrist.update(this.zSign,"who",-this.mWho),this.zSign=e.zobrist.update(this.zSign,"who",this.mWho)},Model.Board.Evaluate=function(d){function c(m){var d=1/0;for(var c in e.geometry.corners)d=Math.min(d,B.distGraph[g.kings[m]][c]);return d-Math.sqrt(B.boardSize)}var f="debug"==arguments[3],g=this;this.mEvaluation=0;var N,b=this.mWho,B=d.g;if(m)N={1:{count:new Uint8Array(B.pTypes.length),byType:{}},"-1":{count:new Uint8Array(B.pTypes.length),byType:{}}};else{N={1:{count:[],byType:{}},"-1":{count:[],byType:{}}};for(var a=0;a<B.pTypes.length;a++)N[1].count[a]=N[-1].count[a]=0}if(d.mOptions.preventRepeat&&d.GetRepeatOccurence(this)>2)return this.mFinished=!0,void(this.mWinner=d.cbOnPerpetual?b*d.cbOnPerpetual:JocGame.DRAW);for(var x={1:0,"-1":0},h={1:B.distGraph[this.kings[-1]],"-1":B.distGraph[this.kings[1]]},t={1:0,"-1":0},r={1:0,"-1":0},i={1:0,"-1":0},O={1:0,"-1":0},s={1:!1,"-1":!1},n=this.pieces,o=n.length,a=0;a<o;a++){var Q=n[a];if(Q.p>=0){var p=Q.s,l=B.pTypes[Q.t];l.isKing?s[p]=Q.m:x[p]+=l.value,l.castle&&!Q.m&&O[p]++,r[p]++,t[p]+=h[p][Q.p],i[p]+=e.geometry.distEdge[Q.p];var u=N[p];u.count[Q.t]++;var R=u.byType;void 0===R[Q.t]?R[Q.t]=[Q]:R[Q.t].push(Q)}}if(this.lastMove&&null!=this.lastMove.c){var Q=this.pieces[this.board[this.lastMove.t]];x[-Q.s]+=this.cbStaticExchangeEval(d,Q.p,Q.s,{piece:Q})}var v={1:0,"-1":0},G={1:0,"-1":0},y={1:0,"-1":0};this.ending[1]&&(G[1]=(t[1]-Math.sqrt(B.boardSize))/r[1],e.geometry.corners&&(y[1]=c(1))),this.ending[-1]&&(G[-1]=(t[-1]-Math.sqrt(B.boardSize))/r[-1],e.geometry.corners&&(y[1]=c(-1)));var M={pieceValue:x[1]-x[-1],pieceValueRatio:(x[1]-x[-1])/(x[1]+x[-1]+1),posValue:i[1]-i[-1],averageDistKing:t[1]/r[1]-t[-1]/r[-1],check:this.check?-b:0,endingKingFreedom:v[1]-v[-1],endingDistKing:G[1]-G[-1],distKingCorner:y[1]-y[-1]};e.castle&&(M.castle=(this.castled[1]?1:s[1]?0:O[1]/(B.castleablePiecesCount[1]+1))-(this.castled[-1]?1:s[-1]?0:O[-1]/(B.castleablePiecesCount[-1]+1))),e.evaluate&&e.evaluate.call(this,d,M,N);var K=d.mOptions.levelOptions;for(var C in M){var S=M[C],k=K[C+"Factor"]||0,A=S*k;f&&console.log(C,"=",S,"*",k,"=>",A),this.mEvaluation+=A}f&&console.log("Evaluation",this.mEvaluation)},Model.Board.cbGeneratePseudoLegalMoves=function(e){function m(m,f){var g=e.cbVar.promote;if(!g)return void c.push(f);var N=g.call(d,e,m,f);if(null!=N)if(0==N.length)c.push(f);else if(1==N.length)f.pr=N[0],c.push(f);else for(var b=0;b<N.length;b++){var B=N[b];c.push({f:f.f,t:f.t,c:f.c,pr:B,ept:f.ept,ep:f.ep,a:f.a})}}for(var d=this,c=[],f=e.cbVar,g=this.mWho,N=!f.castle||this.check||this.castled[g]?null:[],b=-1,B=this.pieces.length,a=0;a<B;a++){var x=this.pieces[a];if(!(x.p<0||x.s!=g)){var h=e.g.pTypes[x.t];h.isKing&&(x.m?N=null:b=x),N&&h.castle&&!x.m&&N.push(x);var t,r;t=h.graph[x.p],r=t.length;for(var i=0;i<r;i++)for(var O=t[i],s=!1,n=O.length,o=null,Q=0;Q<n;Q++){var p=O[Q],l=65535&p,u=this.board[l];if(!(u<0)||h.epCatch&&this.epTarget&&this.epTarget.p==l){if(!(524288&p)){var R;R=u<0?this.pieces[this.epTarget.i]:this.pieces[u],!(R.s!=x.s&&131072&p)||1048576&p&&!e.g.pTypes[R.t].isKing||2097152&p&&e.g.pTypes[R.t].isKing||m(x,{f:x.p,t:l,c:R.i,a:h.abbrev,ep:u<0});break}if(s){var R=this.pieces[u];R.s!=x.s&&m(x,{f:x.p,t:l,c:R.i,a:h.abbrev});break}s=!0}else 65536&p&&0==s&&m(x,{f:x.p,t:l,c:null,a:h.abbrev,ept:null!=o&&h.epTarget?o:void 0});o=l}}}if(N)for(var a=0;a<N.length;a++){var v=N[a],G=e.cbVar.castle[b.p+"/"+v.p];if(G){for(var y=!0,i=0;i<G.r.length;i++){var M=G.r[i];if(this.board[M]>=0&&M!=b.p&&M!=v.p){y=!1;break}}if(y){for(var K=!0,i=0;i<G.k.length;i++){var M=G.k[i];if(this.board[M]>=0&&M!=v.p&&M!=b.p||this.cbGetAttackers(e,M,g).length>0){K=!1;break}}K&&c.push({f:b.p,t:G.k[G.k.length-1],c:null,cg:v.p})}}}return c},Model.Board.cbStaticExchangeEval=function(e,m,d,c){var f=0,g=this.cbGetSmallestAttacker(e,m,d);if(g){var N=this.mWho;this.mWho=g.s;var b=this.cbQuickApply(e,{f:g.p,t:m,c:c.piece.i}),B=e.g.pTypes[c.piece.t].value;c.piece=g,f=Math.max(0,B-this.cbStaticExchangeEval(e,m,-d,c)),this.cbQuickUnapply(e,b),this.mWho=N}return f},Model.Board.cbGetSmallestAttacker=function(e,m,d){var c=this.cbGetAttackers(e,m,d);if(0==c.length)return null;for(var f=1/0,g=null,N=c.length,b=0;b<N;b++){var B=c[b],a=e.g.pTypes[B.t].value;a<f&&(f=a,g=B)}return g},Model.Board.cbCollectAttackers=function(e,m,d,c){for(var f in m){var g=m[f],N=this.board[f];if(N<0)this.cbCollectAttackers(e,g.e,d,c);else{var b=this.pieces[N];b.s==-e&&(g.t&&b.t in g.t||c&&g.tk&&b.t in g.tk)&&d.push(b)}}},Model.Board.cbCollectAttackersScreen=function(e,m,d,c,f){for(var g in m){var N=m[g],b=this.board[g];if(b<0)this.cbCollectAttackersScreen(e,N.e,d,c,f);else{var B=this.pieces[b];!f&&B.s==-e&&(N.t&&B.t in N.t||c&&N.tk&&B.t in N.tk)?d.push(B):f?f&&B.s==-e&&N.ts&&B.t in N.ts&&d.push(B):this.cbCollectAttackersScreen(e,N.e,d,c,!0)}}},Model.Board.cbGetAttackers=function(e,m,d,c){var f=[];return e.cbUseScreenCapture?this.cbCollectAttackersScreen(d,e.g.threatGraph[d][m],f,c,!1):this.cbCollectAttackers(d,e.g.threatGraph[d][m],f,c),f},Model.Board.GenerateMoves=function(e){var m=this.cbGeneratePseudoLegalMoves(e);this.mMoves=[];for(var d=!0,c=this.kings[this.mWho],f=m.length,g=0;g<f;g++){var N=m[g],b=this.cbQuickApply(e,N);if(!(this.cbGetAttackers(e,this.kings[this.mWho],this.mWho,!0).length>0)){var B=this.cbGetAttackers(e,this.kings[-this.mWho],-this.mWho,!0).length>0;N.ck=B,this.mMoves.push(N),N.f!=c&&(d=!1)}this.cbQuickUnapply(e,b)}if(0==this.mMoves.length)this.mFinished=!0,this.mWinner=e.cbOnStaleMate?e.cbOnStaleMate*this.mWho:JocGame.DRAW,this.check&&(this.mWinner=-this.mWho);else if(this.ending[this.mWho]){if(!d)for(var g=0;g<this.mMoves.length;g++)this.mMoves[g].ko=!1}else if(!this.ending[this.mWho]&&d&&!this.check)for(var g=0;g<this.mMoves.length;g++)this.mMoves[g].ko=!0},Model.Board.GetSignature=function(){return this.zSign},Model.Move.Init=function(e){for(var m in e)e.hasOwnProperty(m)&&(this[m]=e[m])},Model.Move.Equals=function(e){return this.f==e.f&&this.t==e.t&&this.pr==e.pr},Model.Move.CopyFrom=function(e){this.Init(e)},Model.Move.ToString=function(m){var d=this;switch(m=m||"natural"){case"natural":return function(){var m;if(void 0!==d.cg?m=e.castle[d.f+"/"+d.cg].n:(m=d.a||"",m+=e.geometry.PosName(d.f),null==d.c?m+="-":m+="x",m+=e.geometry.PosName(d.t)),void 0!==d.pr){var c=e.pieceTypes[d.pr];c&&c.abbrev&&c.abbrev.length>0&&!c.silentPromo&&(m+="="+c.abbrev)}return d.ck&&(m+="+"),m}();case"engine":return function(){var m=e.geometry.PosName(d.f)+e.geometry.PosName(d.t);if(void 0!=d.pr){var c=e.pieceTypes[d.pr];c&&c.abbrev&&c.abbrev.length>0&&!c.silentPromo&&(m+=c.abbrev)}return m}();default:return"??"}},Model.Board.CompactMoveString=function(m,d,c){"function"!=typeof d.ToString&&(d=m.CreateMove(d));var f=d.ToString(),g=/^([A-Z]?)([a-z])([1-9][0-9]*)([-x])([a-z])([1-9][0-9]*)(.*?)$/.exec(f);if(!g)return f;var N=g[7];if(c||(c={}),c.value||(c.value=[]),0==c.value.length){var b=this.mMoves;this.mMoves&&0!=this.mMoves.length||this.GenerateMoves(m);for(var B=0;B<this.mMoves.length;B++){var a=this.mMoves[B];"function"!=typeof a.ToString&&(a=m.CreateMove(a)),c.value.push({str:a.ToString(),move:a})}this.mMoves=b}var x=[];if(c.value.forEach(function(e){var m=/^([A-Z]?[a-z][1-9][0-9]*[-x][a-z][1-9][0-9]*)(.*?)$/.exec(e.str);m&&e.move.t==d.t&&(e.move.a||"")==g[1]&&m[2]==N&&x.push(e.move)}),1==x.length)return""==g[1]&&"x"==g[4]?g[2]+"x"+g[5]+g[6]+g[7]:g[1]+("x"==g[4]?"x":"")+g[5]+g[6]+g[7];if(e.geometry.CompactCrit)for(var h="",B=0;;B++){var t=e.geometry.CompactCrit(d.f,B);if(null==t)return f;h+=t;for(var r=[],i=0;i<x.length;i++){var O=x[i];e.geometry.CompactCrit(O.f,B)==t&&r.push(O)}if(console.assert(r.length>0),1==r.length)return g[1]+h+("x"==g[4]?"x":"")+g[5]+g[6]+g[7];x=r}return f},Model.Board.cbIntegrity=function(e){function m(e,m){e||console.error(m)}for(var d=this,c=0;c<this.board.length;c++){var f=this.board[c];if(f>=0){var g=d.pieces[f];m(void 0!==g,"no piece at pos"),m(g.p==c,"piece has different pos")}}for(var f=0;f<this.pieces.length;f++){var g=this.pieces[f];g.p>=0&&m(d.board[g.p]==f,"board index mismatch")}},Model.Board.ExportBoardState=function(e){return e.cbVar.geometry.ExportBoardState?e.cbVar.geometry.ExportBoardState(this,e.cbVar,e.mPlayedMoves.length):"not supported"},Model.Game.Import=function(m,d){var c,f=[],g={1:{},"-1":{}},N=null,b=0;if("pjn"==m){var B={status:!1,error:"parse"},a=d.split(" ");if(6!=a.length)return console.warn("FEN should have 6 parts"),B;var x=a[0].split("/"),h=e.geometry.fenHeight||e.geometry.height;if(x.length!=h)return console.warn("FEN board should have",h,"rows, got",x.length),B;var t={};for(var r in e.pieceTypes){var i=e.pieceTypes[r],O=i.fenAbbrev||i.abbrev||"X";t[O.toUpperCase()]={s:1,t:r},t[O.toLowerCase()]={s:-1,t:r}}var s=e.geometry.FenRowPos||function(m,d){return(e.geometry.height-1-m)*e.geometry.width+d};if(x.forEach(function(m,d){for(var c=0,g=0;g<m.length;g++){var N=m.substr(g,1),b=t[N];if(void 0!==b){var a=s(d,c);c++;for(var x={s:b.s,t:b.t,p:a},h=!0,r=e.pieceTypes[x.t].initial||[],i=0;i<r.length;i++){var O=r[i];O.s==x.s&&O.p==a&&(h=!1)}x.m=h,f.push(x)}else{if(isNaN(parseInt(N)))return console.warn("FEN invalid board spec",N),B;c+=parseInt(N)}}}),f.sort(function(e,m){return m.s-e.s}),"w"==a[1])c=1;else{if("b"!=a[1])return console.warn("FEN invalid turn spec",a[1]),B;c=-1}g[1].k=a[2].indexOf("K")>=0,g[1].q=a[2].indexOf("Q")>=0,g[-1].k=a[2].indexOf("k")>=0,g[-1].q=a[2].indexOf("q")>=0,N="-"==a[3]?null:a[3];var n=parseInt(a[4]);isNaN(n)||(b=n);var o={pieces:f,turn:c,castle:g,enPassant:N,noCaptCount:b};return e.importGame&&e.importGame.call(this,o,m,d),{status:!0,initial:o}}return{status:!1,error:"unsupported"}}}(),function(){Model.Game.cbBoardGeometryGrid=function(e,m){function d(m){return m%e}function c(m){return Math.floor(m/e)}function f(m,d){return d*e+m}function g(g,N){var b=d(g),B=c(g),a=b+N[0],x=B+N[1];return a<0||a>=e||x<0||x>=m?null:f(a,x)}function N(e){return String.fromCharCode("a".charCodeAt(0)+d(e))+(c(e)+1)}function b(e){var m=/^([a-z])([0-9]+)$/.exec(e);return m?f(m[1].charCodeAt(0)-"a".charCodeAt(0),parseInt(m[2])-1):-1}function B(e,m){return 0==m?String.fromCharCode("a".charCodeAt(0)+d(e)):1==m?c(e)+1:null}function a(){for(var f=[],g=0;g<e*m;g++){var N=[];f.push(N);for(var b=0;b<e*m;b++){var B=c(g),a=d(g),x=c(b),h=d(b);N.push(Math.max(Math.abs(B-x),Math.abs(a-h)))}}return f}function x(d,c,g){for(var b=[],B=m-1;B>=0;B--){for(var a="",x=0,h=0;h<e;h++){var t=d.board[f(h,B)];if(t<0)x++;else{x>0&&(a+=x,x=0);var r=d.pieces[t],i=c.pieceTypes[r.t].fenAbbrev||c.pieceTypes[r.t].abbrev||"?";r.s==-1?a+=i.toLowerCase():a+=i.toUpperCase()}}x&&(a+=x),b.push(a)}var O=b.join("/");O+=" ",1==d.mWho?O+="w":O+="b",O+=" ";var s="";return d.castled&&(d.castled[1]===!1?s+="KQ":(d.castled[1].k&&(s+="K"),d.castled[1].q&&(s+="Q")),d.castled[-1]===!1?s+="kq":(d.castled[-1].k&&(s+="k"),d.castled[-1].q&&(s+="q"))),0==s.length&&(s="-"),O+=s,O+=" ",d.epTarget?O+=N(d.epTarget.p):O+="-",O+=" ",O+=d.noCaptCount,O+=" ",O+=Math.floor(g/2)+1}return{boardSize:e*m,width:e,height:m,C:d,R:c,POS:f,Graph:g,PosName:N,PosByName:b,CompactCrit:B,GetDistances:a,distEdge:function(){for(var f=[],g=0;g<e*m;g++){var N=d(g),b=c(g);f[g]=Math.min(N,Math.abs(e-N-1),b,Math.abs(m-b-1))}return f}(),corners:function(){var d={};return d[f(0,0)]=1,d[f(0,m-1)]=1,d[f(e-1,0)]=1,d[f(e-1,m-1)]=1,d}(),ExportBoardState:x}},Model.Game.cbPawnGraph=function(e,m,d){for(var c=this,f={},g=0;g<e.boardSize;g++)if(!d||g in d){var N=[],b=e.Graph(g,[0,m]);null!=b&&(!d||b in d)&&N.push(c.cbTypedArray([b|c.cbConstants.FLAG_MOVE])),[-1,1].forEach(function(f){var b=e.Graph(g,[f,m]);null!=b&&(!d||b in d)&&N.push(c.cbTypedArray([b|c.cbConstants.FLAG_CAPTURE]))}),f[g]=N}else f[g]=[];return f},Model.Game.cbInitialPawnGraph=function(e,m,d){for(var c=this,f={},g=0;g<e.boardSize;g++)if(!d||g in d){var N=[],b=e.Graph(g,[0,m]);if(null!=b&&(!d||b in d)){var B=[b|c.cbConstants.FLAG_MOVE],a=e.Graph(b,[0,m]);null!=a&&(!d||a in d)&&B.push(a|c.cbConstants.FLAG_MOVE),N.push(c.cbTypedArray(B))}[-1,1].forEach(function(f){var b=e.Graph(g,[f,m]);null!=b&&(!d||b in d)&&N.push(c.cbTypedArray([b|c.cbConstants.FLAG_CAPTURE]))}),f[g]=N}else f[g]=[];return f},Model.Game.cbKingGraph=function(e,m){return this.cbShortRangeGraph(e,[[-1,-1],[-1,0],[-1,1],[0,-1],[0,1],[1,-1],[1,0],[1,1]],m)},Model.Game.cbKnightGraph=function(e,m){return this.cbShortRangeGraph(e,[[2,-1],[2,1],[-2,-1],[-2,1],[-1,2],[-1,-2],[1,2],[1,-2]],m)},Model.Game.cbHorseGraph=function(e){for(var m=this,d={},c=0;c<e.boardSize;c++)d[c]=[],[[1,0,2,-1],[1,0,2,1],[-1,0,-2,-1],[-1,0,-2,1],[0,1,-1,2],[0,-1,-1,-2],[0,1,1,2],[0,-1,1,-2]].forEach(function(f){var g=e.Graph(c,[f[0],f[1]]);if(null!=g){var N=e.Graph(c,[f[2],f[3]]);null!=N&&d[c].push(m.cbTypedArray([g|m.cbConstants.FLAG_STOP,N|m.cbConstants.FLAG_MOVE|m.cbConstants.FLAG_CAPTURE]))}});return d},Model.Game.cbRookGraph=function(e,m){return this.cbLongRangeGraph(e,[[0,-1],[0,1],[-1,0],[1,0]],m)},Model.Game.cbBishopGraph=function(e,m){return this.cbLongRangeGraph(e,[[1,-1],[1,1],[-1,1],[-1,-1]],m)},Model.Game.cbQueenGraph=function(e,m){return this.cbLongRangeGraph(e,[[0,-1],[0,1],[-1,0],[1,0],[1,-1],[1,1],[-1,1],[-1,-1]],m)},Model.Game.cbXQGeneralGraph=function(e,m){for(var d=this,c={},f=0;f<e.boardSize;f++)c[f]=[],[[-1,0,!1],[0,-1,!0],[0,1,!0],[1,0,!1]].forEach(function(g){var N=[],b=e.Graph(f,g);if(null!=b&&((!m||b in m)&&N.push(b|d.cbConstants.FLAG_MOVE|d.cbConstants.FLAG_CAPTURE),g[2]))for(var B=e.Graph(b,g);null!=B;)!m||B in m?N.push(B|d.cbConstants.FLAG_CAPTURE|d.cbConstants.FLAG_CAPTURE_KING):N.push(B|d.cbConstants.FLAG_STOP),B=e.Graph(B,g);N.length>0&&c[f].push(d.cbTypedArray(N))});return c},Model.Game.cbXQSoldierGraph=function(e,m){return this.cbShortRangeGraph(e,[[0,m]])},Model.Game.cbXQPromoSoldierGraph=function(e,m){return this.cbShortRangeGraph(e,[[0,m],[-1,0],[1,0]])},Model.Game.cbXQAdvisorGraph=function(e,m){return this.cbShortRangeGraph(e,[[1,1],[-1,1],[1,-1],[-1,-1]],m)},Model.Game.cbXQCannonGraph=function(e){return this.cbLongRangeGraph(e,[[0,-1],[0,1],[-1,0],[1,0]],null,this.cbConstants.FLAG_MOVE|this.cbConstants.FLAG_SCREEN_CAPTURE)},Model.Game.cbXQElephantGraph=function(e,m){for(var d=this,c={},f=0;f<e.boardSize;f++)c[f]=[],(!m||f in m)&&[[1,1,2,2],[1,-1,2,-2],[-1,1,-2,2],[-1,-1,-2,-2]].forEach(function(g){var N=e.Graph(f,[g[0],g[1]]);if(null!=N){var b=e.Graph(f,[g[2],g[3]]);null!=b&&(!m||b in m)&&c[f].push(d.cbTypedArray([N|d.cbConstants.FLAG_STOP,b|d.cbConstants.FLAG_MOVE|d.cbConstants.FLAG_CAPTURE]))}});return c},Model.Game.cbSilverGraph=function(e,m){return this.cbShortRangeGraph(e,[[0,m],[-1,-1],[-1,1],[1,-1],[1,1]])},Model.Game.cbFersGraph=function(e,m){return this.cbShortRangeGraph(e,[[-1,-1],[-1,1],[1,-1],[1,1]])},Model.Game.cbSchleichGraph=function(e,m){return this.cbShortRangeGraph(e,[[-1,0],[1,0],[0,-1],[0,1]])},Model.Game.cbAlfilGraph=function(e,m){return this.cbShortRangeGraph(e,[[-2,-2],[-2,2],[2,2],[2,-2]])}}(),function(){var e=Model.Game.cbBoardGeometryGrid(8,8);Model.Game.cbDefine=function(){return{geometry:e,pieceTypes:{0:{name:"pawn-w",aspect:"pawn",graph:this.cbPawnGraph(e,1),value:1,abbrev:"",fenAbbrev:"P",epCatch:!0},1:{name:"ipawn-w",aspect:"pawn",graph:this.cbInitialPawnGraph(e,1),value:1,abbrev:"",fenAbbrev:"P",initial:[{s:1,p:8},{s:1,p:9},{s:1,p:10},{s:1,p:11},{s:1,p:12},{s:1,p:13},{s:1,p:14},{s:1,p:15}],epTarget:!0},2:{name:"pawn-b",aspect:"pawn",graph:this.cbPawnGraph(e,-1),value:1,abbrev:"",fenAbbrev:"P",epCatch:!0},3:{name:"ipawn-b",aspect:"pawn",graph:this.cbInitialPawnGraph(e,-1),value:1,abbrev:"",fenAbbrev:"P",initial:[{s:-1,p:48},{s:-1,p:49},{s:-1,p:50},{s:-1,p:51},{s:-1,p:52},{s:-1,p:53},{s:-1,p:54},{s:-1,p:55}],epTarget:!0},4:{name:"knight",graph:this.cbKnightGraph(e),value:2.9,abbrev:"N",initial:[{s:1,p:1},{s:1,p:6},{s:-1,p:57},{s:-1,p:62}]},5:{name:"bishop",graph:this.cbBishopGraph(e),value:3.1,abbrev:"B",initial:[{s:1,p:2},{s:1,p:5},{s:-1,p:58},{s:-1,p:61}]},6:{name:"rook",graph:this.cbRookGraph(e),value:5,abbrev:"R",initial:[{s:1,p:0},{s:1,p:7},{s:-1,p:56},{s:-1,p:63}],castle:!0},7:{name:"queen",graph:this.cbQueenGraph(e),value:9,abbrev:"Q",initial:[{s:1,p:3},{s:-1,p:59}]},8:{name:"king",isKing:!0,graph:this.cbKingGraph(e),abbrev:"K",initial:[{s:1,p:4},{s:-1,p:60}]}},promote:function(m,d,c){return 1==d.t?[0]:3==d.t?[2]:0==d.t&&7==e.R(c.t)?[4,5,6,7]:2==d.t&&0==e.R(c.t)?[4,5,6,7]:[]},castle:{"4/0":{k:[3,2],r:[1,2,3],n:"O-O-O"},"4/7":{k:[5,6],r:[6,5],n:"O-O"},"60/56":{k:[59,58],r:[57,58,59],n:"O-O-O"},"60/63":{k:[61,62],r:[62,61],n:"O-O"}},evaluate:function(m,d,c){var f=c[1].count,g=c[-1].count;f[0]||f[1]||f[4]||f[5]||f[6]||f[7]||g[2]||g[3]||g[6]||g[7]||!(g[4]+g[5]<2||g[5]<2)||(this.mFinished=!0,this.mWinner=JocGame.DRAW),g[2]||g[3]||g[4]||g[5]||g[6]||g[7]||f[0]||f[1]||f[6]||f[7]||!(f[4]+f[5]<2||f[5]<2)||(this.mFinished=!0,this.mWinner=JocGame.DRAW),this.noCaptCount>=100&&(this.mFinished=!0,this.mWinner=JocGame.DRAW);var N,b=m.cbUseTypedArrays?new Int8Array(3):[0,0,0],B=e.height,a=c[1].byType[0];if(a){N=a.length;for(var x=0;x<N;x++)switch(B-e.R(a[x].p)){case 2:b[0]++;break;case 3:b[1]++;break;case 4:b[2]++}}if(a=c[-1].byType[2]){N=a.length;for(var x=0;x<N;x++)switch(e.R(a[x].p)){case 1:b[0]--;break;case 2:b[1]--;break;case 3:b[2]--}}0!=b[0]&&(d.distPawnPromo1=b[0]),0!=b[1]&&(d.distPawnPromo2=b[1]),0!=b[2]&&(d.distPawnPromo3=b[2]);for(var h=0,t=4;t<=5;t++)for(var r=1;r>=-1;r-=2){var i=c[r].byType[t];if(i)for(var x=0;x<i.length;x++)i[x].m&&(h+=r)}0!=h&&(d.minorPiecesMoved=h)},importGame:function(m,d,c){return m.pieces.forEach(function(m){1!=m.s||2!=m.t&&3!=m.t||(m.t=0),m.s!=-1||0!=m.t&&1!=m.t||(m.t=2),1==m.s&&1==e.R(m.p)&&0==m.t&&(m.t=1,m.m=!1),1==m.s&&1!=e.R(m.p)&&1==m.t&&(m.t=0,m.m=!0),m.s==-1&&e.R(m.p)==e.height-2&&2==m.t&&(m.t=3,m.m=!1),m.s==-1&&e.R(m.p)!=e.height-2&&3==m.t&&(m.t=2,m.m=!0)}),!0}}}}(),Model.Board.StaticGenerateMoves=function(e){return this.PickMoveFromDatabase(e,this.MoveDatabase)},Model.Board.MoveDatabase={"1#1797724988":[{m:"Nb1-c3",e:10},{m:"e2-e4",e:10},{m:"g2-g4",e:10},{m:"b2-b4",e:10},{m:"g2-g3",e:10},{m:"c2-c4",e:10},{m:"d2-d4",e:10},{m:"b2-b3",e:10},{m:"h2-h3",e:10},{m:"e2-e3",e:10},{m:"Ng1-f3",e:10},{m:"f2-f4",e:10}],"-1#-627366358":[{m:"e7-e5",e:9.95},{m:"d7-d5",e:9.95},{m:"c7-c5",e:9.95}],"1#-1178155266":[{m:"Ng1-f3",e:9.643},{m:"d2-d4",e:9.643},{m:"Ng1-h3",e:9.643}],"-1#1095100183":[{m:"Nb8-c6",e:9.545}],"1#-103347125":[{m:"d2-d4",e:9.444},{m:"g2-g3",e:9.444}],"-1#100050475":[{m:"e5xd4",e:9.412}],"1#-1366682164":[{m:"Nf3xd4",e:9.412}],"-1#-1847118610":[{m:"Ng8-f6",e:9.412}],"1#376037791":[{m:"Bc1-g5",e:8.571}],"-1#-68028796":[{m:"Bf8-c5",e:8.571},{m:"Bf8-b4",e:8.571}],"1#456225943":[{m:"e2-e3",e:6.667}],"-1#-1516717928":[{m:"h7-h6",e:6.667}],"1#-256180312":[{m:"Bg5-h4",e:5}],"-1#1070504597":[{m:"O-O",e:5}],"1#-1680254996":[{m:"Nd4-f5",e:5}],"-1#-1968458460":[{m:"d7-d5",e:5}],"1#-1438566953":[{m:"Qd1-f3",e:5}],"-1#-1444132740":[{m:"Bc8xf5",e:5}],"1#309484406":[{m:"Qf3xf5",e:5}],"-1#-444998483":[{m:"Bc5-b4",e:5}],"1#435915958":[{m:"Bf1-d3",e:5}],"-1#762257964":[{m:"Qd8-d7",e:5}],"1#-288610464":[{m:"O-O-O",e:5}],"-1#-1197208814":[{m:"Qd7xf5",e:5}],"1#233238642":[{m:"Bd3xf5",e:5}],"-1#-224241527":[{m:"Bb4xc3",e:5}],"1#971373681":[{m:"b2xc3",e:5}],"-1#-41457698":[{m:"Nc6-e7",e:5}],"1#1841979963":[{m:"Bf5-d3",e:5}],"-1#924551491":[{m:"c7-c6",e:5}],"1#1072979205":[{m:"f2-f3",e:5}],"-1#-1443195989":[{m:"Rf8-e8",e:5}],"1#-278600341":[{m:"g2-g4",e:5}],"-1#1066864257":[{m:"Nf6-d7",e:5}],"1#-2129875503":[{m:"Bh4-g3",e:5}],"-1#-60226989":[{m:"Ne7-g6",e:5}],"1#280731433":[{m:"Rh1-e1",e:5}],"-1#1716617115":[{m:"Ng6-e5",e:5}],"1#-1715149800":[{m:"Bd3-e2",e:5}],"-1#519548211":[],"1#-1745442757":[{m:"Qd1-d3",e:5}],"-1#1868718982":[{m:"O-O",e:5}],"1#-881479937":[{m:"Nd4xc6",e:5}],"-1#-509294010":[{m:"b7xc6",e:5}],"1#-435628674":[{m:"Qd3-d4",e:5}],"-1#-1996535672":[{m:"Bb4-e7",e:5}],"1#214924040":[{m:"O-O-O",e:5}],"-1#1520916346":[{m:"c6-c5",e:5}],"1#-768541879":[{m:"Qd4-a4",e:5}],"-1#-2037466281":[{m:"d7-d6",e:5}],"1#-1063416464":[{m:"e2-e4",e:5}],"-1#-2040856051":[{m:"Bc8-d7",e:5}],"1#1453544974":[{m:"Qa4-a5",e:5}],"-1#148648476":[{m:"Nf6xe4",e:5}],"1#659336171":[{m:"Bg5xe7",e:5}],"-1#144477537":[{m:"Qd8xe7",e:5}],"1#-1529799119":[{m:"Nc3xe4",e:5}],"-1#-429125424":[{m:"Qe7xe4",e:5}],"1#1241760643":[{m:"Qa5xc7",e:5}],"-1#678201907":[{m:"Bd7-f5",e:5}],"1#-430920568":[{m:"Bf1-d3",e:5}],"-1#-758906350":[{m:"Qe4-f4+",e:5}],"1#685424463":[{m:"Kc1-b1",e:5}],"-1#-231494799":[{m:"Rf8-c8",e:5}],"1#438768357":[{m:"Qc7-a5",e:5}],"-1#-1083484004":[{m:"Bf5-e6",e:5}],"1#-623564381":[{m:"Qa5-d2",e:5}],"-1#911875075":[{m:"Qf4-f6",e:5}],"1#-2051721233":[{m:"c2-c3",e:5}],"-1#1809250134":[{m:"Ra8-b8",e:5}],"1#904915397":[],"-1#1380056130":[{m:"d7-d5",e:5}],"1#1923841201":[{m:"d2-d3",e:5}],"-1#1567167008":[{m:"Ng8-f6",e:6.667}],"1#-622344367":[{m:"Bf1-g2",e:5}],"-1#-1786598908":[{m:"Bf8-e7",e:6.667}],"1#233851788":[{m:"O-O",e:6.667}],"-1#397257336":[{m:"O-O",e:8}],"1#-1279629567":[{m:"Bc1-g5",e:6.667}],"-1#1579315226":[{m:"d5-d4",e:9.167},{m:"Bc8-e6",e:9.167},{m:"h7-h6",e:9.167}],"1#-764809585":[{m:"Bg5xf6",e:6.667}],"-1#316751874":[{m:"Be7xf6",e:5}],"1#770122191":[{m:"Nc3-e4",e:5}],"-1#1292598941":[{m:"Bf6-e7",e:5}],"1#1267362826":[{m:"c2-c3",e:5}],"-1#-1511412557":[{m:"Bc8-e6",e:7.5}],"1#-560746700":[{m:"Qd1-c2",e:7.5}],"-1#1328236768":[{m:"a7-a5",e:7.5}],"1#1878680807":[{m:"a2-a4",e:6.667}],"-1#-1316336906":[{m:"Ra8-a6",e:6.667}],"1#877948000":[{m:"Ne4-d2",e:6.667}],"-1#889506169":[{m:"f7-f5",e:6.667}],"1#-1553053615":[{m:"Ra1-c1",e:6.667}],"-1#-1058717990":[{m:"Ra6-b6",e:6.667}],"1#257160907":[{m:"Rf1-e1",e:6.667}],"-1#6768547":[{m:"Be7-f6",e:6.667}],"1#115758388":[{m:"e2-e3",e:6.667}],"-1#-1202742981":[{m:"d4xe3",e:6.667}],"1#-442857807":[{m:"Re1xe3",e:6.667}],"-1#-2004517840":[{m:"Be6-f7",e:6.667}],"1#2139310358":[{m:"h2-h4",e:6.667}],"-1#-1006354022":[{m:"Rf8-e8",e:6.667}],"1#-2103822502":[{m:"Rc1-e1",e:6.667}],"-1#-191580542":[{m:"h7-h6",e:6.667}],"1#626553757":[{m:"e2-e4",e:8.889}],"-1#1671363808":[{m:"d5-d4",e:8.75}],"1#-271228299":[{m:"Nc3-e2",e:8.75}],"-1#-1190281030":[{m:"Nf6-d7",e:8.75},{m:"h7-h6",e:8.75}],"1#127296490":[{m:"Bg5-d2",e:8}],"-1#-1222277341":[{m:"Nd7-c5",e:8},{m:"a7-a5",e:8}],"1#778446119":[{m:"b2-b4",e:5}],"-1#1376813284":[{m:"Nc5-d7",e:5}],"1#-883744032":[{m:"b4-b5",e:5}],"1#-1745573084":[{m:"c2-c3",e:7.5}],"-1#2039966621":[{m:"d4xc3",e:7.5},{m:"Nd7-c5",e:7.5}],"1#-522925671":[{m:"c3xd4",e:5}],"1#-332429430":[{m:"Bg5-d2",e:6.667}],"-1#1553752899":[{m:"Qd8-d7",e:6.667},{m:"Qd8-d6",e:6.667}],"1#-1623235057":[{m:"b2-b4",e:5}],"-1#-481705012":[{m:"a7-a6",e:5}],"1#-563799297":[{m:"Qd1-b1",e:5}],"1#427231113":[{m:"Nf3-e1",e:5}],"-1#-64564995":[{m:"Nf6-d7",e:5}],"1#1119712173":[{m:"f2-f4",e:5}],"-1#1056955693":[{m:"f7-f5",e:5}],"1#184563498":[{m:"Bg5xf6",e:5}],"-1#-880240217":[{m:"Be7xf6",e:5}],"1#-191956886":[{m:"e2-e4",e:5}],"-1#-1303873769":[{m:"d5-d4",e:5}],"1#1040443778":[{m:"Nc3-d5",e:5}],"-1#2030001278":[{m:"Bc8-e6",e:5}],"1#59072505":[{m:"Rf1-e1",e:5}],"-1#212987537":[{m:"Rf8-e8",e:5}],"1#1244633169":[{m:"c2-c3",e:5}],"-1#-1538500376":[{m:"d4xc3",e:5}],"1#-271722694":[{m:"Nd5xf6+",e:5}],"-1#990292749":[{m:"Qd8xf6",e:5}],"1#969888380":[{m:"b2xc3",e:5}],"-1#-1459690031":[{m:"Ra8-d8",e:5}],"1#-1203889231":[{m:"Qd1-c2",e:5}],"-1#696712293":[{m:"Rd8-d6",e:5}],"1#363937546":[{m:"Nf3-d2",e:5}],"-1#334346982":[{m:"Re8-d8",e:5}],"1#-1538236624":[{m:"Re1-e3",e:5}],"-1#-1961814844":[{m:"h6-h5",e:5}],"1#-1930622660":[{m:"h2-h4",e:5}],"-1#929694128":[],"-1#1172794526":[{m:"e5xd4",e:7.5}],"1#-291774599":[{m:"Qd1xd4",e:7.5}],"-1#-1794135764":[{m:"Ng8-f6",e:7.5}],"1#310475869":[{m:"g2-g4",
e:6.667}],"-1#-1032677449":[{m:"Nb8-c6",e:5}],"1#2061532395":[{m:"Qd4-e3+",e:5}],"-1#-959274792":[{m:"Bf8-e7",e:5}],"1#1587560784":[{m:"g4-g5",e:5}],"-1#1750157833":[{m:"Nf6-g4",e:5}],"1#1475940798":[{m:"Qe3-e4",e:5}],"-1#805540132":[{m:"Nc6-b4",e:5}],"1#561624512":[{m:"Nc3-d5",e:5}],"-1#1736769596":[{m:"Nb4xd5",e:5}],"1#1357912945":[{m:"Qe4xd5",e:5}],"-1#1708604331":[{m:"d7-d6",e:5}],"1#600051084":[{m:"f2-f4",e:5}],"-1#1602659084":[{m:"c7-c6",e:5}],"1#1466529610":[{m:"Qd5-d4",e:5}],"-1#1965189833":[{m:"h7-h6",e:5}],"1#536882681":[{m:"Qd4xg7",e:5}],"-1#922345049":[{m:"Ke8-d7",e:5}],"1#2018337905":[{m:"Ng1-f3",e:5}],"-1#-2133965416":[{m:"Kd7-c7",e:5}],"1#1623368985":[{m:"Qg7xf7",e:5}],"-1#-364944353":[{m:"h6xg5",e:5}],"1#1350994361":[{m:"f4xg5",e:5}],"-1#-1472145284":[{m:"Rh8-f8",e:5}],"1#1643657737":[{m:"Qf7-b3",e:5}],"-1#846835866":[{m:"Bc8-f5",e:5}],"1#1559776917":[{m:"Rh1-g1",e:5}],"-1#802330917":[{m:"Qd8-d7",e:5}],"1#-328098711":[{m:"Bc1-d2",e:5}],"-1#-1054874868":[{m:"Ra8-e8",e:5}],"1#1828427456":[{m:"h2-h3",e:5}],"-1#1954254878":[{m:"Ng4-e5",e:5}],"1#-161661641":[{m:"Nf3xe5",e:5}],"-1#-692263532":[{m:"d6xe5",e:5}],"1#-706638920":[{m:"O-O-O",e:5}],"-1#-2088130614":[],"-1#1157569630":[{m:"Ng8-f6",e:5}],"1#-1015953105":[{m:"d2-d4",e:5}],"-1#1062232911":[{m:"e5xd4",e:5}],"1#-1809002328":[{m:"Qd1xd4",e:5}],"-1#-273111299":[{m:"Nb8-c6",e:5}],"1#1462390177":[{m:"Qd4-a4",e:5}],"-1#60034495":[{m:"Bf8-b4",e:5}],"1#1871926016":[{m:"Bc1-d2",e:5}],"-1#1123888229":[{m:"d7-d5",e:5}],"1#1645718678":[{m:"a2-a3",e:5}],"-1#1973845839":[{m:"Bb4xc3",e:5}],"1#-1092494409":[{m:"Bd2xc3",e:5}],"-1#-488461488":[{m:"Bc8xh3",e:5}],"1#-887421311":[{m:"g2xh3",e:5}],"-1#-1945355053":[{m:"Nf6-e4",e:5}],"1#-943571472":[{m:"Bf1-g2",e:5}],"-1#-2002300763":[{m:"Ne4xc3",e:5}],"1#36647291":[{m:"b2xc3",e:5}],"-1#1659965287":[{m:"g7-g5",e:5}],"1#-1683373625":[{m:"O-O",e:5}],"-1#-2114707405":[{m:"O-O",e:5}],"1#635694410":[{m:"Qa4-b5",e:5}],"-1#-1613080406":[{m:"Ra8-b8",e:5}],"1#-1042069959":[{m:"Qb5xd5",e:5}],"-1#48121224":[{m:"Qd8-f6",e:5}],"1#-1375582714":[{m:"Qd5-f3",e:5}],"-1#1774386386":[{m:"Qf6xf3",e:5}],"1#-227002453":[{m:"Bg2xf3",e:5}],"-1#589093787":[{m:"Nc6-e5",e:5}],"1#-1609115513":[{m:"Kg1-g2",e:5}],"-1#-434889833":[{m:"b7-b6",e:5}],"1#-1299002235":[{m:"Rf1-d1",e:5}],"-1#-724755499":[{m:"Rf8-d8",e:5}],"1#1437271156":[{m:"h3-h4",e:5}],"-1#-117277059":[{m:"Kg8-f8",e:5}],"1#-395925216":[{m:"Rd1-d4",e:5}],"-1#1705750187":[{m:"b6-b5",e:5}],"1#383902453":[],"1#-93215015":[{m:"Ng1-f3",e:9.865},{m:"e2-e4",e:9.865}],"-1#49448752":[{m:"d7-d5",e:9.667},{m:"Ng8-f6",e:9}],"1#1233774674":[{m:"e2-e4",e:8.75},{m:"d2-d4",e:8.75}],"-1#256861999":[{m:"d5-d4",e:8},{m:"d5xe4",e:8}],"1#-2096825926":[],"1#1273949501":[{m:"Nc3xe4",e:5}],"-1#1950992338":[{m:"Qd8-a5",e:5}],"1#-531724091":[{m:"Bf1-c4",e:5}],"-1#1478993025":[{m:"e7-e6",e:5}],"1#265407828":[{m:"Qd1-e2",e:5}],"-1#-929225464":[{m:"Bf8-e7",e:5}],"1#1357890688":[{m:"O-O",e:5}],"-1#1253188980":[{m:"Ng8-f6",e:5}],"1#-851644411":[{m:"d2-d4",e:5}],"-1#824007269":[{m:"c5xd4",e:5}],"1#52758120":[{m:"Nf3xd4",e:5}],"-1#-127878028":[{m:"O-O",e:5}],"1#1551331597":[{m:"Bc1-g5",e:5}],"-1#-1309710826":[{m:"Qa5-d8",e:5}],"1#635971841":[{m:"Ra1-d1",e:5}],"-1#1061162754":[{m:"Nf6xe4",e:5}],"1#27733810":[{m:"Nd4-c6",e:5}],"-1#-1830494609":[{m:"Ne4-c3",e:5}],"1#1641913524":[{m:"b2xc3",e:5}],"-1#17015464":[{m:"Nb8xc6",e:5}],"1#-289425564":[{m:"Rd1xd8",e:5}],"-1#-1228406026":[{m:"Rf8xd8",e:5}],"1#481979490":[{m:"Bg5xe7",e:5}],"-1#862604008":[{m:"Nc6xe7",e:5}],"1#1128544149":[{m:"Bc4-d3",e:5}],"-1#-1073989124":[{m:"Ne7-d5",e:5}],"1#1518848013":[{m:"Qe2-e4",e:5}],"-1#-799003981":[{m:"Nd5-f6",e:5}],"1#-981173738":[{m:"Qe4-h4",e:5}],"-1#1507205770":[{m:"h7-h6",e:5}],"1#217343418":[{m:"f2-f4",e:5}],"-1#1891027770":[{m:"h6-h5",e:5}],"1#2001393346":[{m:"Rf1-f3",e:5}],"-1#688383850":[],"-1#-1247264206":[{m:"Ng8-f6",e:7.5},{m:"c5xd4",e:7.5}],"1#841389891":[{m:"Bc1-g5",e:6.667}],"-1#-541163432":[{m:"Nf6-e4",e:6.667}],"1#-1804566149":[{m:"Bg5-d2",e:6.667}],"-1#616785330":[{m:"c5xd4",e:5}],"1#385563071":[{m:"Nf3xd4",e:5}],"-1#-306281565":[{m:"Ne4xd2",e:5}],"1#-1031020040":[{m:"Qd1xd2",e:5}],"-1#-1612579719":[{m:"e7-e5",e:5}],"1#-54780755":[{m:"Nd4-b3",e:5}],"-1#1147010763":[{m:"d5-d4",e:5}],"1#-938057634":[{m:"Nc3-e4",e:5}],"-1#-1459994868":[{m:"f7-f5",e:5}],"1#1049673252":[{m:"Ne4-g3",e:5}],"-1#-1834500915":[{m:"Nb8-c6",e:5}],"1#708138897":[{m:"e2-e3",e:5}],"-1#-1801675874":[{m:"d4xe3",e:5}],"1#-917928940":[{m:"Qd2xd8+",e:5}],"-1#-178787115":[{m:"Ke8xd8",e:5}],"1#-535253843":[{m:"f2xe3",e:5}],"-1#-1216128823":[{m:"Bf8-b4+",e:5}],"1#-612104586":[{m:"c2-c3",e:5}],"-1#904382159":[{m:"Bb4-e7",e:5}],"1#-1311247025":[{m:"Bf1-c4",e:5}],"-1#163502347":[{m:"e5-e4",e:5}],"1#-1805706012":[{m:"Nb3-d4",e:5}],"-1#750714498":[{m:"Nc6-e5",e:5}],"1#-1347093090":[{m:"Nd4-e6+",e:5}],"-1#1278455089":[{m:"Bc8xe6",e:5}],"1#279179732":[{m:"Bc4xe6",e:5}],"-1#-674205097":[{m:"g7-g6",e:5}],"1#-832684462":[{m:"Ke1-e2",e:5}],"-1#-1753139586":[{m:"Kd8-c7",e:5}],"1#-652811872":[{m:"Rh1-d1",e:5}],"-1#-963156182":[{m:"Ne5-d3",e:5}],"1#95297837":[],"1#-2020598209":[{m:"Qd1xd4",e:5}],"-1#942469972":[{m:"Ng8-f6",e:5}],"1#-1079892443":[{m:"e2-e4",e:5}],"-1#-110843560":[{m:"Nb8-c6",e:5}],"1#1106657796":[{m:"Bf1-b5",e:5}],"-1#-1278467402":[{m:"Bc8-d7",e:5}],"1#1664382645":[{m:"Bb5xc6",e:5}],"-1#-1768598076":[{m:"Bd7xc6",e:5}],"1#-39774689":[{m:"e4xd5",e:5}],"-1#-1587135113":[{m:"Nf6xd5",e:5}],"1#1536355330":[{m:"Nf3-e5",e:5}],"-1#-551084520":[{m:"Nd5xc3",e:5}],"1#-1081496924":[{m:"Ne5xc6",e:5}],"-1#-1691812309":[{m:"Qd8-d5",e:5}],"1#-725257433":[{m:"Qd4xd5",e:5}],"-1#1443357133":[{m:"Nc3xd5",e:5}],"1#-1321858045":[{m:"Nc6-e5",e:5}],"-1#69173967":[{m:"Nd5-b4",e:5}],"1#1235192099":[{m:"Ke1-d1",e:5}],"-1#525640341":[{m:"f7-f6",e:5}],"1#995288899":[{m:"Bc1-d2",e:5}],"-1#373069862":[{m:"e7-e6",e:5}],"1#1103819251":[{m:"c2-c3",e:5}],"-1#-1347866294":[{m:"Nb4-d5",e:5}],"1#-500614490":[{m:"Ne5-d3",e:5}],"-1#1355213201":[{m:"Ra8-c8",e:5}],"1#-1193907139":[{m:"Rh1-e1",e:5}],"-1#-834892657":[{m:"Ke8-f7",e:5}],"1#1413923503":[{m:"Re1-e4",e:5}],"-1#1551812934":[{m:"Bf8-e7",e:5}],"1#-1005836082":[{m:"c3-c4",e:5}],"-1#-1855118863":[{m:"Nd5-b6",e:5}],"1#-1494562097":[{m:"b2-b3",e:5}],"-1#-1972183692":[{m:"Nb6-d7",e:5}],"1#-1095266136":[],"1#-2055450047":[{m:"d2-d3",e:8.889}],"-1#-1430373168":[{m:"Bc8-g4",e:5}],"1#-1731681579":[{m:"g2-g3",e:5}],"-1#861819612":[{m:"d5-d4",e:5}],"1#-1089090487":[{m:"Nc3-e4",e:5}],"-1#-537292005":[{m:"Nf6xe4",e:5}],"1#-518081749":[{m:"d3xe4",e:5}],"-1#1581734030":[{m:"Bg4xf3",e:5}],"1#267778779":[{m:"e2xf3",e:5}],"-1#-1363999361":[{m:"e7-e5",e:5}],"1#-839981653":[{m:"Bf1-c4",e:5}],"-1#1971833327":[{m:"Nb8-d7",e:5}],"1#-1501881264":[{m:"f3-f4",e:5}],"-1#-1973616477":[{m:"Bf8-c5",e:5}],"1#1788707504":[{m:"Bc1-d2",e:5}],"-1#1207172565":[{m:"Qd8-f6",e:5}],"1#-349176229":[{m:"Qd1-e2",e:5}],"-1#744691207":[{m:"O-O-O",e:5}],"1#-626964028":[{m:"O-O-O",e:5}],"-1#-1932958282":[{m:"Rh8-e8",e:5}],"1#1940553140":[{m:"Rh1-e1",e:5}],"-1#88120582":[{m:"e5xf4",e:5}],"1#-1604294583":[{m:"g3xf4",e:5}],"-1#571898182":[{m:"g7-g6",e:5}],"1#999830851":[{m:"Qe2-d3",e:5}],"-1#1946524181":[{m:"Kc8-b8",e:5}],"1#-1261513865":[{m:"e4-e5",e:5}],"-1#326985496":[{m:"Qf6-g7",e:5}],"1#1381384167":[{m:"Qd3-b3",e:5}],"-1#-1371862237":[{m:"f7-f6",e:5}],"1#-1975693579":[{m:"Bc4-f7",e:5}],"-1#-1922763535":[{m:"Re8-e7",e:5}],"1#-1150573283":[{m:"e5-e6",e:5}],"-1#-1998856232":[{m:"Bc5-d6",e:5}],"1#-708149397":[{m:"c2-c3",e:5}],"-1#1000980434":[],"-1#-1128846940":[{m:"d5xe4",e:9.895},{m:"d5-d4",e:9.895}],"1#-132734026":[{m:"Nc3xe4",e:9.737}],"-1#-944666279":[{m:"Ng8-f6",e:9.737},{m:"e7-e5",e:9.737},{m:"Nb8-d7",e:9.737}],"1#1077894184":[{m:"Ne4xf6+",e:8.333}],"-1#-224602284":[{m:"g7xf6",e:8}],"1#-77100936":[],"1#-1528010355":[{m:"Bf1-c4",e:8.571},{m:"Ng1-f3",e:8.571}],"-1#478496201":[{m:"Nb8-c6",e:8.333}],"1#-1541951851":[{m:"d2-d3",e:8}],"-1#-1948925948":[{m:"Bf8-e7",e:6.667}],"1#329720204":[{m:"Ng1-f3",e:6.667}],"-1#-349962139":[{m:"Ng8-f6",e:7.5}],"1#1823134996":[{m:"h2-h3",e:7.5}],"-1#1948963786":[{m:"Nf6xe4",e:5}],"1#1255011322":[{m:"d3xe4",e:5}],"-1#-174843809":[{m:"Qd8xd1+",e:5}],"1#211198335":[{m:"Ke1xd1",e:5}],"-1#1783192951":[{m:"Be7-c5",e:5}],"1#1656664667":[{m:"c2-c3",e:5}],"-1#-1931644190":[{m:"Bc5xf2",e:5}],"1#-1490791292":[{m:"Rh1-f1",e:5}],"-1#-1363179031":[{m:"Bf2-b6",e:5}],"1#-1841442692":[{m:"b2-b4",e:5}],"-1#-297044545":[{m:"f7-f6",e:5}],"1#-900910999":[{m:"Nf3-h4",e:5}],"-1#2097213052":[{m:"Nc6-e7",e:5}],"1#-313660519":[{m:"Kd1-c2",e:5}],"-1#1550796900":[{m:"Ng8-f6",e:5}],"1#-605971179":[{m:"Ne4xf6+",e:5}],"-1#1765938793":[{m:"Qd8xf6",e:5}],"1#1804332824":[{m:"Qd1-e2",e:5}],"-1#-1396242620":[{m:"Nb8-c6",e:5}],"1#341175320":[{m:"d2-d4",e:5}],"-1#-395032968":[{m:"Bc8-g4",e:5}],"1#-637347715":[{m:"d4xe5",e:5}],"-1#-1599986384":[{m:"Qf6-f5",e:5}],"1#919268335":[{m:"Bc1-d2",e:5}],"-1#463770762":[{m:"Bg4xf3",e:5}],"1#1242969823":[{m:"Qe2xf3",e:5}],"-1#2072069831":[{m:"Qf5xf3",e:5}],"1#102158294":[{m:"g2xf3",e:5}],"-1#-1074813141":[{m:"Nc6xe5",e:5}],"1#1888175668":[{m:"O-O-O",e:5}],"-1#652438086":[{m:"O-O-O",e:5}],"1#-803129979":[{m:"Bf1-h3+",e:5}],"-1#-1677270271":[{m:"Kc8-b8",e:5}],"1#1556982371":[{m:"f3-f4",e:5}],"1#340614374":[{m:"Bf1-c4",e:9.231},{m:"d2-d4",e:9.231}],"-1#-1406898014":[{m:"Ng8-f6",e:7.5}],"1#732603859":[{m:"Ne4xf6+",e:5}],"-1#-1727451473":[{m:"Nd7xf6",e:5}],"1#1017138690":[{m:"Ng1-f3",e:5}],"-1#-1004310549":[{m:"e7-e6",e:5}],"1#-1814755778":[{m:"Qd1-e2",e:5}],"-1#1419374178":[{m:"c7-c5",e:5}],"1#534937856":[{m:"a2-a4",e:5}],"-1#-1047351535":[{m:"Bf8-e7",e:5}],"1#1507872409":[{m:"Nf3-e5",e:5}],"-1#-581583741":[{m:"O-O",e:5}],"1#2034397690":[{m:"O-O",e:5}],"-1#1663012878":[{m:"Qd8-d4",e:5}],"1#-1669615971":[{m:"Rf1-e1",e:5}],"-1#-1823531019":[{m:"Be7-d6",e:5}],"1#-1225990947":[{m:"Ne5-f3",e:5}],"-1#844705479":[{m:"Qd4-g4",e:5}],"1#-1129428241":[{m:"h2-h3",e:5}],"-1#-1540469711":[{m:"Qg4-h5",e:5}],"1#-1246148518":[{m:"Nf3-e5",e:5}],"-1#-395512186":[{m:"Ng8-f6",e:9}],"1#1877091319":[{m:"Ne4xf6+",e:9}],"-1#-582899573":[{m:"Nd7xf6",e:8.571}],"1#2028521510":[{m:"Ng1-f3",e:8.571}],"-1#-2140411441":[{m:"Bc8-g4",e:8.571},{m:"Bc8-f5",e:8.571}],"1#-1306691638":[],"1#-286648384":[{m:"c2-c3",e:8.333}],"-1#9033593":[{m:"e7-e6",e:8.333}],"1#1467989676":[{m:"Nf3-e5",e:8.333}],"-1#-741716810":[{m:"Bf8-e7",e:8.333}],"1#1270394174":[{m:"Qd1-b3",e:8.333}],"-1#1057283824":[{m:"Qd8-c8",e:8.333}],"1#-101707846":[{m:"Bf1-e2",e:8.333}],"1#821868337":[{m:"Nc3-e2",e:9.655}],"-1#1713640958":[{m:"c7-c5",e:9.655},{m:"e7-e5",e:9.655}],"1#761232028":[{m:"Ne2-g3",e:9.091},{m:"f2-f4",e:9.091}],"-1#-1218673176":[{m:"Nb8-c6",e:8.889}],"1#265186996":[{m:"Ng1-f3",e:8.75},{m:"Bf1-c4",e:8.75}],"-1#-145928355":[{m:"a7-a6",e:8.333},{m:"g7-g6",e:8.333}],"1#-899574162":[{m:"a2-a4",e:6.667}],"-1#336705663":[{m:"h7-h5",e:5}],"1#915041792":[{m:"h2-h4",e:5}],"-1#-1928501620":[{m:"Ng8-f6",e:5}],"1#176403453":[{m:"d2-d3",e:5}],"-1#625073516":[{m:"e7-e5",e:5}],"1#-289209512":[{m:"Bf1-b5",e:6.667}],"-1#486106090":[{m:"Qd8-b6",e:5}],"1#-2038718568":[{m:"a2-a4",e:5}],"-1#1477161353":[{m:"Bf8-g7",e:5}],"1#1445106107":[{m:"O-O",e:5}],"-1#1283420239":[{m:"e7-e5",e:5}],"-1#-1213775120":[{m:"Ng8-f6",e:6.667}],"1#808032129":[{m:"d2-d3",e:5}],"-1#535558416":[{m:"h7-h5",e:5}],"1#1030762351":[{m:"h2-h4",e:5}],"-1#-2030622749":[{m:"Bc8-g4",e:5}],"1#-1266566682":[{m:"Ng1-e2",e:5}],"-1#726619161":[{m:"b7-b5",e:5}],"1#2093368290":[{m:"Bc4-b3",e:5}],"-1#-1238898961":[{m:"g7-g6",e:5}],"1#-1347835158":[{m:"a2-a4",e:5}],"-1#1910080763":[{m:"a7-a6",e:5}],"1#1291148744":[{m:"Bc1-g5",e:5}],"-1#-1586672941":[{m:"Bf8-g7",e:5}],"-1#1360909340":[{m:"Nb8-c6",e:8.333}],"1#-376488128":[{m:"Ng1-f3",e:8}],"-1#286006953":[{m:"Ng8-f6",e:7.5}],"1#-1769813032":[{m:"d2-d3",e:7.5}],"-1#-1186945719":[{m:"Bc8-g4",e:7.5},{m:"g7-g6",e:7.5}],"1#-1959380148":[{m:"Ne2-g1",e:6.667}],"-1#-1972243045":[{m:"e7-e5",e:6.667}],"1#-382986929":[{m:"h2-h3",e:6.667}],"-1#-240381039":[{m:"Bg4xf3",e:6.667}],"1#-1608601148":[{m:"Ng1xf3",e:6.667}],"-1#1067195942":[{m:"e5xf4",e:6.667}],"1#403206628":[{m:"Bc1xf4",e:6.667}],"-1#1096090717":[{m:"Bf8-d6",e:6.667}],"1#-1933465014":[{m:"Qd1-d2",e:6.667},{m:"g2-g3",e:6.667}],"-1#-51581523":[{m:"Qd8-c7",e:5}],"-1#660036163":[{m:"O-O",e:5}],"1#-1597052596":[{m:"h2-h3",e:5}],"-1#-1202786414":[{m:"Bf8-g7",e:5}],"1#-1234710624":[{m:"g2-g4",e:5}],"-1#1720984650":[{m:"c5-c4",e:5}],"1#2048134870":[{m:"Bf1-g2",e:5}],"-1#896623491":[{m:"c4xd3",e:5}],"1#-991123000":[{m:"c2xd3",e:5}],"-1#2129932403":[{m:"h7-h5",e:5}],"1#1550837260":[{m:"g4-g5",e:5}],"-1#1788800341":[{m:"Nf6-d7",e:5}],"1#-737849851":[{m:"O-O",e:5}],"-1#-833048591":[{m:"Nd7-c5",e:5}],"1#1461390837":[{m:"b2-b3",e:5}],"1#91878698":[{m:"Ng1-f3",e:9.375},{m:"d2-d3",e:9.375}],"-1#-33893181":[{m:"Bf8-d6",e:7.5}],"1#812546772":[{m:"Ne2-g3",e:6.667}],"-1#-1435662944":[{m:"Ng8-f6",e:6.667}],"1#769872081":[{m:"Bf1-c4",e:6.667}],"-1#-1786086251":[{m:"O-O",e:6.667}],"1#832418284":[{m:"O-O",e:6.667}],"-1#734023704":[{m:"c7-c5",e:6.667}],"1#1622884218":[{m:"d2-d3",e:6.667}],"-1#1333350891":[{m:"Nb8-c6",e:6.667}],"1#-135546185":[{m:"a2-a4",e:6.667}],"-1#698061990":[{m:"Bc8-e6",e:6.667}],"1#1390516001":[{m:"Bc4xe6",e:5}],"-1#-1785588574":[{m:"f7xe6",e:5}],"1#644233824":[{m:"Nf3-d2",e:5}],"-1#540721036":[{m:"Nc6-e7",e:5}],"1#-1334330775":[{m:"Nd2-c4",e:5}],"-1#-1597391646":[{m:"Ne7-g6",e:5}],"1#1276846488":[{m:"Ng3-h5",e:5}],"-1#553242848":[{m:"Bd6-c7",e:5}],"1#-1138186745":[{m:"g2-g3",e:5}],"-1#398349838":[{m:"Kg8-h8",e:5}],"1#-866692679":[{m:"Nh5xf6",e:5}],"-1#-1105122988":[{m:"g7xf6",e:5}],"1#-1210419592":[{m:"Bc1-h6",e:5}],"-1#862175388":[{m:"Rf8-f7",e:5}],"1#373724451":[{m:"f2-f4",e:5}],"-1#1778662307":[{m:"e5xf4",e:5}],"1#1301304417":[{m:"g3xf4",e:5}],"-1#-806992530":[{m:"f6-f5",e:5}],"1#1781876554":[{m:"e4-e5",e:5}],"-1#-1144120355":[{m:"Qd8-d7",e:5}],"-1#716938171":[{m:"g7-g6",e:8.571}],"1#859166654":[{m:"g2-g3",e:5}],"-1#-1734137929":[{m:"Bf8-g7",e:5}],"1#-1769339003":[{m:"Bf1-g2",e:5}],"-1#-638620976":[{m:"Ng8-e7",e:5}],"1#807730520":[{m:"f2-f4",e:5}],"-1#1281774552":[{m:"c7-c5",e:5}],"1#119356602":[{m:"Ng1-h3",e:5}],"-1#-98245094":[{m:"Nb8-c6",e:5}],"1#1119227206":[{m:"Nh3-f2",e:5}],"-1#-424750832":[{m:"O-O",e:5}],"1#1119427689":[{m:"h2-h4",e:5}],"-1#-113371931":[{m:"h7-h5",e:5}],"1#-609893734":[{m:"O-O",e:5}],"-1#-1040702610":[{m:"Bc8-e6",e:5}],"1#-1165877015":[{m:"f4xe5",e:5}],"-1#-126961174":[{m:"Nc6xe5",e:5}],"1#1917493164":[{m:"Ne2-f4",e:5}],"-1#91762157":[{m:"Be6-d7",e:5}],"1#-557844770":[{m:"c2-c4",e:5}],"-1#368620527":[{m:"Bd7-g4",e:5}],"1#-2026637986":[{m:"Qd1-c2",e:5}],"-1#378213002":[{m:"Qd8-d6",e:5}],"1#1398830656":[{m:"Kg1-h1",e:5}],"-1#-1728538364":[{m:"Bg7-h6",e:5}],"1#-1697381037":[{m:"Bc1-d2",e:5}],"-1#-1212515786":[{m:"Kg8-g7",e:5}],"1#-2136220644":[{m:"a2-a3",e:5}],"-1#-1759899707":[{m:"a7-a5",e:5}],"1#-1211423806":[{m:"b2-b3",e:5}],"1#-1847572152":[{m:"Ng1-f3",e:9.818}],"-1#1768122529":[{m:"Nb8-c6",e:9.667},{m:"d7-d5",e:9.667}],"1#-772701187":[{m:"g2-g3",e:9.474}],"-1#2053600244":[{m:"g7-g6",e:8}],"1#1676230641":[{m:"Bf1-g2",e:8}],"-1#747393700":[{m:"Bf8-g7",e:5}],"1#581268118":[{m:"O-O",e:5}],"-1#955814754":[{m:"e7-e5",e:5}],"1#1537569718":[{m:"d2-d3",e:5}],"-1#1952914727":[],"-1#769758273":[{m:"b7-b5",e:10},{m:"c7-c5",e:10},{m:"c7-c6",e:10},{m:"g7-g6",e:10},{m:"e7-e5",e:10},{m:"e7-e6",e:10},{m:"b7-b6",e:10},{m:"Nb8-c6",e:10},{m:"d7-d6",e:10},{m:"d7-d5",e:10},{m:"Ng8-f6",e:10}],"1#2053669818":[{m:"e2-e4",e:9.756}],"-1#-2042025510":[{m:"Bc8-b7",e:9.706}],"1#495197310":[{m:"Nb1-d2",e:9.643},{m:"Bf1xb5",e:9.643},{m:"Bf1-d3",e:9.643}],"-1#-846931165":[{m:"a7-a6",e:9.091},{m:"Ng8-f6",e:9.091}],"1#-257424880":[{m:"Ng1-f3",e:8.889}],"-1#137044985":[{m:"e7-e6",e:8.75},{m:"Ng8-f6",e:8.75}],"1#1608337964":[{m:"Bf1-d3",e:8.75}],"-1#1800004790":[{m:"c7-c5",e:8.75}],"1#540183508":[{m:"d4xc5",e:8.571},{m:"c2-c3",e:8.571}],"-1#518043749":[{m:"Bf8xc5",e:6.667}],"1#-1420795299":[{m:"O-O",e:6.667}],"-1#-1324514391":[{m:"Ng8-e7",e:6.667},{m:"Nb8-c6",e:6.667}],"1#1489376289":[{m:"a2-a4",e:5}],"1#161442037":[{m:"Nd2-b3",e:5}],"-1#-833533075":[{m:"d7-d6",e:8}],"1#-2008908470":[{m:"O-O",e:7.5}],"-1#-1843422018":[{m:"Nb8-d7",e:7.5}],"1#1105414401":[{m:"Rf1-e1",e:6.667},{m:"a2-a4",e:6.667}],"-1#1322776681":[{m:"Bf8-e7",e:5}],"-1#-1617729776":[{m:"c5-c4",e:5}],"1#-1884948856":[{m:"Bf1-d3",e:5}],"-1#-1154394094":[{m:"e7-e6",e:5}],"1#-322489913":[{m:"O-O",e:5}],"-1#-157626317":[{m:"c7-c5",e:5}],"1#-1109278895":[{m:"c2-c3",e:5}],"-1#1401061352":[{m:"Bf8-e7",e:6.667}],"1#-873423264":[{m:"d4xc5",e:5}],"-1#-182276655":[{m:"Be7xc5",e:5}],"1#-1465574698":[{m:"e4-e5",e:5}],"-1#2036221505":[{m:"Nf6-d5",e:5}],"1#-997768205":[{m:"Nd2-e4",e:5}],"-1#-975706390":[{m:"Bc5-e7",e:5}],"1#-853538362":[{m:"a2-a4",e:5}],"-1#324020183":[{m:"Nb8-c6",e:5}],"1#-1413297013":[{m:"Ne4-d6+",e:5}],"-1#-116078007":[{m:"Be7xd6",e:5}],"1#-1962040825":[{m:"e5xd6",e:5}],"-1#1433780025":[{m:"Qd8-b8",e:5}],"1#1242173010":[{m:"e4-e5",e:6.667},{m:"c2-c4",e:6.667}],"-1#-1678683451":[{m:"Nf6-d5",e:5}],"1#640178039":[{m:"Ng1-f3",e:5}],"-1#-559188322":[{m:"a7-a6",e:5}],"1#-477646931":[{m:"a2-a4",e:5}],"-1#1039630780":[{m:"b5-b4",e:5}],"1#-1531269860":[{m:"Bf1-d3",e:5}],"-1#-1876032634":[{m:"e7-e6",e:5}],"1#-942118317":[{m:"Nd2-e4",e:5}],"-1#-964112566":[{m:"Bf8-e7",e:5}],"1#1593454274":[{m:"Nf3-g5",e:5}],"-1#-2125640861":[{m:"c7-c6",e:5}],"1#-1985831131":[{m:"c4xb5",e:5}],"-1#-2010135427":[{m:"c6xb5",e:5}],"1#-1323691077":[{m:"Nb1-d2",e:7.5}],"-1#-2054243039":[{m:"e7-e6",e:8},{m:"Qd8-b6",e:8},{m:"Nb8-c6",e:8}],"1#-763833100":[{m:"Ng1-f3",e:5}],"-1#721155357":[{m:"a7-a6",e:5}],"1#399977518":[{m:"O-O",e:5}],"-1#227200474":[{m:"Bf8-e7",e:5}],"1#520896851":[{m:"Ng1-f3",e:6.667}],"-1#-410033990":[{m:"e7-e6",e:6.667}],"1#-1334245009":[{m:"O-O",e:6.667},{m:"Qd1-e2",e:6.667}],"1#1025267325":[{m:"Ng1-e2",e:5}],"-1#-1563247742":[{m:"Qd8-b6",e:5}],"1#944785392":[{m:"O-O",e:5}],"-1#571319812":[{m:"Nc6xd4",e:5}],"1#74382163":[{m:"Ne2xd4",e:5}],"-1#-1281455966":[{m:"Bb7xe4",e:8.333}],"1#-872401618":[{m:"Ng1-f3",e:8.333}],"-1#881005767":[{m:"c7-c6",e:8.333},{m:"e7-e6",e:8.333}],"1#1013760129":[{m:"Bb5-a4",e:6.667},{m:"Bb5-d3",e:6.667}],"-1#-798782653":[{m:"Qd8-a5+",e:5}],"1#1147454548":[{m:"Nb1-c3",e:5}],"-1#-170329790":[{m:"Ng8-f6",e:5}],"1#1918250035":[{m:"O-O",e:5}],"-1#1745604039":[{m:"Be4-g6",e:5}],"1#1956210951":[{m:"Nf3-e5",e:5}],"-1#-265512163":[{m:"e7-e6",e:5}],"1#-1478823224":[{m:"Qd1-f3",e:5}],"-1#-1535668381":[{m:"Bf8-b4",e:5}],"1#-932130340":[{m:"Ba4-b3",e:5}],"-1#-1970830818":[],"1#1668644114":[{m:"O-O",e:6.667}],"-1#2032704742":[{m:"Ng8-f6",e:8.571}],"1#-22656617":[{m:"Bb5-e2",e:9},{m:"c2-c4",e:9}],"-1#-1086599532":[{m:"Bf8-e7",e:5}],"1#659107612":[{m:"c2-c4",e:5}],"-1#-334599635":[{m:"O-O",e:5}],"1#1209640788":[{m:"Nb1-c3",e:5}],"-1#-106587582":[{m:"Be4-b7",e:5}],"1#-496648422":[{m:"Bc1-f4",e:5}],"-1#-680650440":[{m:"d7-d6",e:5}],"1#-1854066913":[{m:"Qd1-c2",e:5}],"-1#12961995":[{m:"Nb8-d7",e:5}],"1#-751231628":[{m:"b2-b4",e:5}],"-1#-1353729865":[{m:"h7-h6",e:5}],"1#-93454457":[{m:"Rf1-e1",e:5}],"-1#-178696465":[{m:"Rf8-e8",e:5}],"1#-1278789585":[{m:"Ra1-d1",e:5}],"-1#-1452335572":[{m:"Be7-f8",e:5}],"-1#903941286":[{m:"Bf8-e7",e:8.75}],"1#-1382814418":[{m:"Bb5-a4",e:8.75},{m:"Nb1-c3",e:8.75}],"-1#1100785388":[{m:"O-O",e:5}],"1#-443847787":[{m:"Nb1-c3",e:5}],"-1#1412912771":[{m:"Be4-b7",e:5}],"1#1341617115":[{m:"Ba4-c2",e:8},{m:"d4-d5",e:8}],"-1#-847668548":[{m:"d7-d6",e:7.5}],"-1#472895544":[{m:"Be4-b7",e:8.571}],"1#133166432":[{m:"h2-h3",e:8.571},{m:"Bb5-a4",e:8.571},{m:"Qd1-e2",e:8.571},{m:"Rf1-e1",e:8.571}],"-1#527430590":[{m:"O-O",e:5}],"-1#688960228":[{m:"e7-e6",e:8.889}],"1#2129058609":[{m:"Qd1-e2",e:8.571},{m:"Ng1-f3",e:8.571}],"-1#-1180028051":[{m:"c7-c5",e:6.667}],"1#-221160433":[{m:"d4xc5",e:5}],"-1#-872190018":[{m:"b5-b4",e:5}],"1#1431192350":[{m:"Bc1-e3",e:5}],"-1#383321819":[{m:"Qd8-c7",e:5}],"1#1505819631":[{m:"Nb1-d2",e:5}],"-1#-1983890254":[{m:"Bf8xc5",e:5}],"1#1014032010":[{m:"Be3xc5",e:5}],"-1#2006360265":[{m:"Qc7xc5",e:5}],"1#932857243":[{m:"Qe2-g4",e:5}],"-1#-1907949236":[{m:"Ke8-f8",e:5}],"1#-225642211":[{m:"Ng1-e2",e:5}],"-1#1833047266":[{m:"Nb8-c6",e:5}],"1#-707723330":[{m:"O-O",e:5}],"-1#-812835254":[{m:"Ng8-f6",e:5}],"1#1208208187":[{m:"Qg4-g3",e:5}],"-1#1140262471":[{m:"Nc6-e5",e:5}],"1#-1057159845":[{m:"a2-a3",e:5}],"-1#-682830206":[{m:"Nf6-h5",e:5}],"1#-1103355503":[{m:"Qg3-h3",e:5}],"-1#12280173":[{m:"g7-g6",e:5}],"-1#-2040137000":[{m:"a7-a6",e:8.333},{m:"c7-c5",e:8.333}],"1#-1152834581":[{m:"Qd1-e2",e:8.571}],"-1#2080754615":[{m:"Ng8-f6",e:6.667}],"1#-74768698":[{m:"Nb1-d2",e:8.571}],"-1#730585499":[{m:"d7-d6",e:5}],"1#1838739388":[{m:"a2-a4",e:5}],"-1#-1276591699":[{m:"b5-b4",e:5}],"1#715517197":[{m:"Nd2-c4",e:5}],"-1#-2021850837":[{m:"a6-a5",e:5}],"1#-356157272":[{m:"e4-e5",e:5}],"1#-853633606":[{m:"c2-c3",e:7.5}],"-1#595416323":[{m:"a7-a6",e:7.5}],"1#508660784":[{m:"O-O",e:9.167}],"-1#67923396":[{m:"Ng8-f6",e:9.091}],"1#-2088585035":[{m:"Rf1-e1",e:9.091},{m:"Qd1-e2",e:9.091},{m:"Bc1-g5",e:9.091},{m:"e4-e5",e:9.091}],"-1#-1934226979":[{m:"Bf8-e7",e:8.571}],"-1#1383719970":[{m:"Nf6-d5",e:5}],"1#1721432867":[{m:"Ng1-f3",e:10},{m:"c2-c4",e:10},{m:"g2-g3",e:10},{m:"c2-c3",e:10},{m:"Nb1-c3",e:10},{m:"b2-b3",e:10},{m:"d2-d4",e:10},{m:"d2-d3",e:10},{m:"Ng1-e2",e:10},{m:"b2-b4",e:10},{m:"f2-f4",e:10}],"-1#-1642472758":[{m:"g7-g6",e:10},{m:"Nb8-c6",e:10},{m:"Ng8-f6",e:10},{m:"Qd8-c7",e:10},{m:"a7-a6",e:10},{m:"f7-f5",e:10},{m:"e7-e6",e:10},{m:"b7-b6",e:10},{m:"d7-d6",e:10}],"1#-2020108593":[{m:"c2-c3",e:9.973},{m:"Bf1-c4",e:9.973}],"1#646656406":[{m:"d2-d4",e:9.999},{m:"c2-c4",e:9.999}],"1#429330363":[{m:"Nb1-c3",e:9.953},{m:"e4-e5",e:9.953}],"-1#-1473563987":[{m:"Nb8-c6",e:9.844}],"1#-788518914":[{m:"c2-c3",e:9.444},{m:"Nb1-c3",e:9.444},{m:"c2-c4",e:9.444}],"1#-1556806663":[{m:"c2-c4",e:9.956},{m:"g2-g3",e:9.956}],"1#141777890":[{m:"e4xf5",e:5}],"-1#1717810977":[{m:"Ng8-h6",e:5}],"1#-907037921":[{m:"d2-d3",e:9.999},{m:"c2-c4",e:9.999}],"1#-895545896":[{m:"d2-d4",e:9.333}],"-1#918464440":[{m:"c5xd4",e:9.167}],"1#-670372627":[{m:"Nb1-c3",e:10},{m:"Bf1-e2",e:10}],"-1#-1377976814":[{m:"Nb8-c6",e:9.898}],"1#357520718":[{m:"Ng1-e2",e:9.878},{m:"g2-g3",e:9.878},{m:"Nb1-c3",e:9.878}],"-1#-1971210063":[{m:"g7-g6",e:9.333}],"1#-1827670860":[{m:"d2-d3",e:8.571}],"-1#-1127376347":[{m:"Bf8-g7",e:5}],"-1#-1093032633":[{m:"g7-g6",e:9}],"1#-1487410878":[{m:"Bf1-g2",e:8.571}],"-1#-399342569":[{m:"Bf8-g7",e:8.571}],"-1#-1527551912":[{m:"e7-e6",e:9.811},{m:"d7-d6",e:9.811}],"1#-488612225":[{m:"g2-g3",e:8}],"-1#-854848726":[{m:"Nb8-c6",e:9.919},{m:"e7-e6",e:9.919},{m:"d7-d5",e:9.919},{m:"g7-g6",e:9.919}],"1#1973346422":[{m:"Bf1-g2",e:9.808}],"-1#989564195":[{m:"Ng8-f6",e:9.839},{m:"Nb8-c6",e:8.75}],"1#-1694866689":[{m:"Bf1-g2",e:8.75}],"-1#-710996054":[{m:"Nb8-c6",e:8.75}],"1#-303658023":[{m:"d2-d3",e:9.783},{m:"e4xd5",e:9.783}],"1#-729659601":[{m:"e2-e4",e:9.565}],"-1#-1679349126":[{m:"Bf8-g7",e:9.524}],"1#-1781659064":[{m:"f2-f4",e:9.737},{m:"Ng1-e2",e:9.737},{m:"c2-c3",e:9.737},{m:"d2-d3",e:9.737}],"-1#-376658744":[{m:"b7-b5",e:9.231}],"1#-1106922701":[{m:"Ng1-f3",e:5}],"-1#1183224538":[{m:"Bc8-b7",e:5}],"1#-582244482":[{m:"d2-d3",e:5}],"-1#-225850897":[{m:"e7-e6",e:5}],"1#-1518362566":[{m:"O-O",e:5}],"-1#-1088273970":[{m:"d7-d5",e:5}],"1#-1614233283":[{m:"e4xd5",e:5}],"-1#-1022367147":[{m:"e6xd5",e:5}],"1#-57753195":[{m:"f4-f5",e:5}],"-1#-1947149256":[{m:"Nb8-c6",e:5}],"1#862074724":[{m:"Nb1-c3",e:5}],"-1#-2099377550":[{m:"b5-b4",e:5}],"1#462628562":[{m:"Nc3-a4",e:5}],"-1#637742878":[{m:"Qd8-a5",e:5}],"1#-1308336119":[{m:"c2-c3",e:5}],"-1#1550295216":[{m:"Nc6-e7",e:5}],"1#-869620395":[{m:"f5xg6",e:5}],"-1#-1911052938":[{m:"h7xg6",e:5}],"1#-1687414896":[{m:"d3-d4",e:5}],"-1#952786902":[{m:"c5xd4",e:5}],"1#183632859":[{m:"c3xb4",e:5}],"-1#1077638803":[{m:"Qa5xb4",e:5}],"-1#167831479":[{m:"Nb8-c6",e:8.889}],"1#-1299051285":[{m:"O-O",e:9.643},{m:"Ng1-e2",e:8}],"-1#-1462768353":[{m:"e7-e6",e:9.444},{m:"Ng8-f6",e:9.444},{m:"d7-d6",e:9.444}],"1#-13007670":[{m:"c2-c4",e:8.333},{m:"c2-c3",e:8.333}],"-1#880722427":[{m:"a7-a6",e:7.5}],"1#156375240":[{m:"Nb1-c3",e:5}],"-1#291128435":[{m:"d7-d5",e:6.667}],"1#833668224":[{m:"e4xd5",e:5}],"1#792803438":[{m:"f2-f4",e:6.667}],"-1#1392744174":[{m:"O-O",e:6.667}],"1#-149660777":[{m:"d2-d3",e:6.667}],"-1#-657050362":[{m:"d7-d5",e:5}],"1#-130238987":[{m:"e4-e5",e:5}],"-1#700967266":[{m:"Nf6-d7",e:5}],"1#-287515848":[{m:"c2-c3",e:9.333},{m:"Nb1-c3",e:9.333}],"-1#12524417":[{m:"e7-e5",e:9.231}],"1#1675819861":[{m:"d2-d3",e:9.091}],"-1#1600185902":[{m:"e7-e5",e:9.545}],"-1#1559350354":[{m:"e7-e5",e:9.167}],"1#1068248198":[{m:"d2-d3",e:8.889}],"-1#275661335":[{m:"Ng8-e7",e:8.571},{m:"d7-d6",e:8.571}],"1#-106572385":[{m:"O-O",e:8.333},{m:"Bc1-e3",e:8.333}],"-1#-470272917":[{m:"O-O",e:6.667}],"1#1206909202":[{m:"a2-a3",e:6.667},{m:"Bc1-e3",e:6.667}],"-1#-1171091366":[{m:"d7-d6",e:6.667}],"1#-64903555":[{m:"O-O",e:6.667},{m:"d3-d4",e:6.667}],"1#1451062320":[{m:"a2-a3",e:5}],"-1#1103931369":[{m:"Ng8-e7",e:5}],"1#-1475923871":[{m:"b2-b4",e:5}],"-1#-730753630":[{m:"O-O",e:5}],"1#1885755611":[{m:"Bc1-e3",e:5}],"-1#871439646":[{m:"Bc8-e6",e:5}],"1#1217076889":[{m:"b4-b5",e:5}],"-1#1468879976":[{m:"Nc6-b8",e:5}],"1#-283132108":[{m:"Nb1-d2",e:5}],"-1#2074987249":[{m:"Nb8-c6",e:8}],"1#-1019272787":[{m:"Ng1-e2",e:8}],"-1#-1173592871":[{m:"d7-d6",e:9.912},{m:"Nb8-c6",e:9.912}],"1#-65056002":[{m:"f2-f4",e:8.889}],"-1#-2141324162":[{m:"Nb8-c6",e:8.889}],"1#953095970":[{m:"Ng1-f3",e:9.931},{m:"Ng1-e2",e:9.931},{m:"Ng1-h3",e:9.931}],"-1#-1068747061":[{m:"Ng8-h6",e:9.932},{m:"h7-h5",e:9.932}],"-1#-1493042467":[{m:"e7-e5",e:6.667}],"1#-1000596983":[{m:"O-O",e:6.667}],"-1#-973681278":[{m:"Bc8xh3",e:7.5}],"1#-334536621":[{m:"Bg2xh3",e:5}],"1#43945861":[{m:"f2-f4",e:9.95},{m:"c2-c3",e:9.95},{m:"c2-c4",e:9.95},{m:"Nb1-d2",e:9.95},{m:"Ng1-e2",e:9.95}],"-1#2128355589":[{m:"h7-h5",e:9.947}],"-1#-318943428":[{m:"e7-e5",e:9.231}],"-1#-908473676":[{m:"d7-d6",e:7.5}],"-1#-761378600":[{m:"d7-d6",e:8.333}],"-1#-1655676294":[{m:"d7-d6",e:8.333}],"-1#-1996932198":[{m:"e7-e6",e:9.997},{m:"Ng8-f6",e:9.997},{m:"d7-d6",e:9.997},{m:"g7-g6",e:9.997},{m:"b7-b6",e:9.997},{m:"Qd8-a5",e:9.997},{m:"d7-d5",e:9.997},{m:"e7-e5",e:9.997},{m:"Nb8-c6",e:9.997}],"1#-823521859":[{m:"d2-d4",e:9.974}],"1#-1854441569":[{m:"d2-d4",e:9.828}],"1#-595596152":[{m:"d2-d4",e:9.818}],"1#-341517490":[{m:"Bf1-c4",e:9.944}],"-1#-685324747":[{m:"Nb8-c6",e:9.996},{m:"a7-a6",e:9.996},{m:"d7-d6",e:9.996},{m:"e7-e6",e:9.996},{m:"g7-g6",e:9.996}],"1#1874079081":[{m:"Ng1-e2",e:9.995},{m:"g2-g3",e:9.995}],"1#-368435450":[{m:"g2-g3",e:9.811}],"-1#1100803855":[{m:"b7-b5",e:9.6}],"1#-1858736110":[{m:"Ng1-e2",e:9.963},{m:"f2-f4",e:9.963}],"1#-2133807136":[{m:"Ng1-f3",e:9.975}],"1#-827815376":[{m:"d2-d4",e:9.828}],"-1#1241705624":[{m:"e7-e5",e:9.921},{m:"d7-d5",e:9.921},{m:"d7-d6",e:9.921},{m:"Nb8-c6",e:9.921},{m:"e7-e6",e:9.921},{m:"b7-b6",e:9.921}],"1#694094924":[{m:"Bc1-b2",e:9.286}],"-1#1024814685":[{m:"Nb8-c6",e:9.286}],"1#1793617003":[{m:"e4xd5",e:6.667}],"-1#909068035":[{m:"Qd8xd5",e:6.667}],"1#202496703":[{m:"Bc1-b2",e:9.677}],"1#-225441852":[{m:"Bc1-b2",e:9.804}],"1#502564173":[{m:"Bc1-b2",e:8.889}],"1#511982474":[{m:"Bc1-b2",e:9.412}],"-1#-1698999997":[{m:"c5xd4",e:9.956}],"1#-1467806386":[{m:"c2-c3",e:9.955},{m:"Ng1-f3",e:9.955}],"-1#1189137911":[{m:"d4-d3",e:9.949},{m:"d4xc3",e:9.949}],"1#1244050908":[{m:"c3-c4",e:9.524}],"1#1982244867":[{m:"Nb1xc3",e:9.918},{m:"Bf1-c4",e:9.918}],"-1#1342188711":[{m:"e7-e5",e:9.545}],"1#861785203":[{m:"c2-c3",e:8.571}],"-1#-583136054":[{m:"d4xc3",e:8.75}],"1#-302487234":[{m:"Nb1xc3",e:8.571}],"-1#-576428519":[{m:"d7-d6",e:8.571}],"-1#1230542258":[{m:"Nb8-c6",e:9.97},{m:"Ng8-f6",e:9.97},{m:"d7-d5",e:9.97},{m:"c7-c5",e:9.984},{m:"g7-g6",e:9.97}],"1#-238387474":[{m:"g2-g3",e:9.945}],"-1#1516015335":[{m:"d7-d5",e:9.922}],"1#-824819517":[{m:"f2-f4",e:8.571}],"-1#-1298862525":[{m:"Nb8-c6",e:6.667}],"1#1773278529":[{m:"e4xd5",e:8.75},{m:"Nb1-d2",e:8.75}],"1#514784359":[{m:"f2-f4",e:9.925}],"1#1356257719":[{m:"g2-g3",e:9.907}],"-1#-79681090":[{m:"Bf8-g7",e:9.904}],"-1#-111929636":[{m:"d7-d6",e:9.917},{m:"e7-e5",e:9.917},{m:"e7-e6",e:9.917},{m:"g7-g6",e:9.917},{m:"a7-a6",e:9.917},{m:"Ng8-f6",e:9.917}],"1#-1085857541":[{m:"g2-g3",e:9.778}],"1#-1710623224":[{m:"Ne2-c3",e:5}],"1#-1365082359":[{m:"d2-d4",e:9.333}],"1#-522560807":[{m:"d2-d4",e:8.333}],"1#-998715409":[{m:"Nb1-c3",e:7.5}],"1#2128266157":[{m:"Nb1-c3",e:9.091}],"-1#-815333701":[{m:"e7-e5",e:9.167}],"-1#451698400":[{m:"d7-d5",e:9.73},{m:"c5xb4",e:9.73}],"1#973528595":[{m:"e4xd5",e:5}],"-1#1723987323":[{m:"Qd8xd5",e:5}],"1#1845603504":[{m:"Nb1-c3",e:5}],"-1#-541224538":[{m:"Qd5-e6+",e:5}],"1#-1289262144":[{m:"Bf1-e2",e:5}],"1#583951985":[{m:"c2-c4",e:9.688},{m:"a2-a3",e:9.688}],"-1#-376888512":[{m:"e7-e5",e:7.5}],"1#-1965767788":[{m:"Bc1-b2",e:6.667}],"-1#897562024":[{m:"b4xa3",e:9.5},{m:"d7-d5",e:9.5}],"-1#450385315":[{m:"Ng8-f6",e:9.962},{m:"e7-e6",e:9.962},{m:"Nb8-c6",e:9.962},{m:"d7-d5",e:9.962},{m:"d7-d6",e:9.962},{m:"g7-g6",e:9.962}],"1#-1655275310":[{m:"Nb1-c3",e:6.667}],"1#1294875766":[{m:"Ng1-f3",e:9.792}],"1#-1572159745":[{m:"d2-d3",e:9.831}],"1#976409936":[{m:"e4xd5",e:9.896}],"1#1556833156":[{m:"Ng1-f3",e:9.5}],"-1#-1538768275":[{m:"g7-g6",e:9.474}],"1#55974310":[{m:"e2-e4",e:8.571}],"-1#-69912497":[{m:"Nb8-c6",e:9.706},{m:"Bf8-g7",e:9.706}],"1#1128780563":[{m:"Bf1-b5",e:9.722},{m:"c2-c3",e:9.722},{m:"d2-d3",e:9.722}],"-1#-1317162079":[{m:"Bf8-g7",e:9},{m:"d7-d6",e:9}],"1#-1084976237":[{m:"Bb5xc6",e:8.333}],"-1#1257615586":[{m:"d7xc6",e:8}],"1#-143751802":[{m:"O-O",e:8}],"-1#-315399054":[{m:"Bf8-g7",e:6.667}],"1#-484817856":[{m:"Bb5xc6+",e:6.667}],"-1#-1390144598":[{m:"d7-d5",e:8.889}],"1#-1915841703":[{m:"e4-e5",e:8.889}],"-1#1547030478":[{m:"Bc8-g4",e:8.889}],"1#1849905611":[{m:"h2-h3",e:8.571}],"-1#1992513301":[{m:"Bg4xf3",e:8.571}],"1#661779776":[{m:"Qd1xf3",e:8.571}],"-1#-1578114637":[{m:"e7-e6",e:8.571}],"-1#1820704130":[{m:"Bf8-g7",e:9.63}],"1#1655479728":[{m:"Nb1-c3",e:9.643},{m:"c2-c3",e:9.643},{m:"Bf1-e2",e:9.643}],"-1#-753885018":[{m:"a7-a6",e:8.889}],"-1#-1932567287":[{m:"d7-d6",e:8.571}],"-1#-1588660554":[{m:"e7-e6",e:9.091}],"1#-168028035":[{m:"d2-d3",e:9.474},{m:"c2-c3",e:9.474}],"-1#-633440532":[{m:"d7-d6",e:8}],"1#-1674755893":[{m:"Bg2xc6",e:9.167},{m:"g2-g3",e:9.167},{m:"e2-e3",e:9.167},{m:"Qa4xc4",e:9.167}],"-1#-724341155":[{m:"Qd7xc6",e:5}],"-1#935047362":[{m:"Nb8-c6",e:7.5}],"-1#579112132":[{m:"Nc6-b4",e:5}],"1#872327200":[{m:"Qa4xd7+",e:5}],"-1#460226732":[{m:"Nc6xd4",e:8.571}],"1#1024318971":[{m:"O-O",e:8.571}],"-1#463460548":[{m:"d7-d5",e:8.75}],"1#997546039":[{m:"e4-e5",e:8.333}],"-1#-359791456":[{m:"Nb8-c6",e:8.333}],"1#1377628156":[{m:"d2-d4",e:8}],"-1#-1371716196":[{m:"c5xd4",e:7.5}],"1#-1677387375":[{m:"c3xd4",e:7.5},{m:"Nf3xd4",e:7.5}],"-1#-1694047243":[{m:"Bc8-g4",e:6.667}],"1#-1452245520":[{m:"Bf1-b5",e:6.667}],"-1#1732289421":[{m:"Ng8-h6",e:5}],"1#-271086126":[{m:"Bf1-b5",e:5}],"1#621690887":[{m:"c2-c4",e:9.999},{m:"Ng1-e2",e:9.999},{m:"b2-b3",e:9.999},{m:"d2-d3",e:9.999},{m:"Nb1-c3",e:9.999},{m:"d2-d4",e:9.999}],"-1#-297204426":[{m:"e7-e5",e:9.979},{m:"e7-e6",e:9.979},{m:"d7-d5",e:9.979}],"1#-1928010270":[{m:"d2-d4",e:9.844},{m:"Ng1-f3",e:9.844}],"-1#1899319170":[{m:"d7-d6",e:7.5},{m:"Bf8-b4+",e:7.5}],"1#489820477":[{m:"Bc1-d2",e:5}],"-1#1972880395":[{m:"d7-d6",e:9.828},{m:"Ng8-f6",e:9.828}],"1#-1178637085":[{m:"d2-d4",e:9.444},{m:"Ng1-f3",e:9.444},{m:"Nb1-c3",e:9.444}],"-1#1168033411":[{m:"d7-d5",e:8.333}],"-1#1094470922":[{m:"d7-d5",e:8}],"1#1641467385":[{m:"c4xd5",e:8}],"-1#134435317":[{m:"d7-d5",e:8.889}],"1#-828144187":[{m:"e4xd5",e:9.975}],"-1#-1838895443":[{m:"c6xd5",e:9.97}],"1#1469298142":[{m:"c4xd5",e:9.969}],"-1#-1062693281":[{m:"Qd8xd5",e:9.963},{m:"Ng8-f6",e:9.963}],"1#-633542007":[{m:"Nb1-c3",e:9.73}],"-1#-1161777672":[{m:"d7-d5",e:9.091}],"1#-1708511989":[{m:"e4-e5",e:9.091}],"-1#1272017308":[{m:"c6-c5",e:9.091}],"1#2013283855":[{m:"d2-d4",e:9}],"-1#-2078151569":[{m:"Nb8-c6",e:9},{
m:"e7-e6",e:9}],"1#1018365747":[{m:"c2-c3",e:8.75}],"-1#-758069366":[{m:"Bc8-f5",e:8.75}],"1#-1135527547":[{m:"Ne2-g3",e:8.333}],"-1#-892650201":[{m:"Bf5-g6",e:6.667}],"1#1217461155":[{m:"h2-h4",e:5}],"-1#-216534225":[{m:"h7-h6",e:5}],"1#-1506429921":[{m:"h4-h5",e:5}],"-1#-1531312218":[{m:"Bg6-h7",e:5}],"1#-378482743":[{m:"Bf1-d3",e:5}],"1#-740850246":[{m:"Nb1-d2",e:6.667}],"-1#64439015":[{m:"Nb8-c6",e:5}],"1#-1153062469":[{m:"c2-c3",e:5}],"-1#1428580610":[{m:"Ng8-e7",e:6.667}],"1#-1125253494":[{m:"Nd2-f3",e:5}],"-1#-1870680477":[{m:"Bc8-d7",e:5}],"1#1082653280":[{m:"h2-h4",e:5}],"-1#-83823892":[{m:"c5xd4",e:5}],"-1#160847804":[{m:"d7-d5",e:6.667}],"1#696047439":[{m:"Bc1-b2",e:6.667}],"-1#1026995550":[{m:"d5xe4",e:6.667}],"1#2039955276":[{m:"Ng1-e2",e:6.667}],"-1#-430320973":[{m:"Bc8-f5",e:6.667}],"1#-1999098692":[{m:"Ne2-g3",e:5}],"-1#-29218786":[{m:"e7-e6",e:5}],"1#-1447804469":[{m:"Nb1-c3",e:5}],"-1#403209437":[{m:"Ng8-f6",e:5}],"1#-1618564692":[{m:"Qd1-e2",e:5}],"-1#1489650160":[{m:"Qd8-a5",e:5}],"1#-858976537":[{m:"Ng3xf5",e:5}],"-1#-264893210":[{m:"Qa5xf5",e:5}],"1#-1952816219":[{m:"g2-g3",e:5}],"-1#537695148":[{m:"Bf8-c5",e:5}],"1#-1060367937":[{m:"Bf1-g2",e:5}],"-1#-1884717846":[{m:"Nb8-d7",e:5}],"1#1549117781":[{m:"Nc3xe4",e:5}],"-1#1676837818":[{m:"Bc5-e7",e:5}],"1#1795517590":[{m:"O-O-O",e:5}],"-1#1030570212":[{m:"O-O",e:5}],"1#-1720021603":[{m:"Kc1-b1",e:5}],"-1#1133746595":[{m:"a7-a5",e:5}],"-1#181153430":[{m:"d7-d5",e:9.96},{m:"e7-e5",e:9.96}],"1#707178085":[{m:"Nb1-d2",e:9.954},{m:"Qd1-e2",e:9.954}],"-1#-98145992":[{m:"Nb8-d7",e:9.953},{m:"Qd8-c7",e:9.953},{m:"g7-g6",e:9.953},{m:"Ng8-f6",e:9.953},{m:"d5xe4",e:9.953}],"-1#-311802311":[{m:"d5xe4",e:6.667}],"1#-1446261717":[{m:"d3xe4",e:5}],"-1#1804075904":[{m:"e7-e5",e:5}],"1#148235092":[{m:"Ng1-f3",e:5}],"1#1771163202":[{m:"Ng1-f3",e:9.565},{m:"g2-g3",e:9.565}],"-1#-1861029973":[{m:"d7-d6",e:9.524}],"1#-687744628":[{m:"Nb1-d2",e:9.5},{m:"g2-g3",e:9.5},{m:"d3-d4",e:9.5}],"-1#-1039712693":[{m:"g7-g6",e:5}],"1#-611749298":[{m:"d3-d4",e:5}],"-1#2016360968":[{m:"Ng8-f6",e:5}],"1#-6164615":[{m:"Nb1-c3",e:5}],"-1#-1800241903":[{m:"d7-d5",e:9.974}],"1#-1269236254":[{m:"Qd1-f3",e:9.974},{m:"f2-f4",e:9.974},{m:"Ng1-f3",e:9.974}],"-1#-1208647607":[{m:"d5-d4",e:9.615},{m:"Ng8-f6",e:9.615},{m:"e7-e6",e:9.615},{m:"d5xe4",e:9.615}],"1#-536614500":[{m:"d2-d4",e:6.667}],"1#-212596133":[{m:"Nc3xe4",e:9.333}],"-1#-937798814":[{m:"d5xe4",e:9.231}],"1#-1933846160":[{m:"Nc3xe4",e:8.889}],"-1#-1289948257":[{m:"g7-g6",e:8.889},{m:"Nb8-d7",e:8.889},{m:"Ng8-f6",e:8.889}],"1#-1433223270":[{m:"Ng1-f3",e:5}],"-1#1289477131":[{m:"g7-g6",e:9.973},{m:"d5xe4",e:9.973},{m:"Ng8-f6",e:9.973},{m:"d5-d4",e:9.973},{m:"Bc8-g4",e:9.973}],"1#2125283854":[{m:"h2-h3",e:9.963}],"-1#-651171225":[{m:"d7-d5",e:9.998}],"1#-104502636":[{m:"e4-e5",e:9.998},{m:"f2-f3",e:9.998},{m:"Nb1-d2",e:9.998},{m:"e4xd5",e:9.998},{m:"Nb1-c3",e:9.998}],"-1#675165699":[{m:"c6-c5",e:9.991},{m:"Bc8-f5",e:9.991},{m:"Nb8-a6",e:9.991}],"-1#1875616826":[{m:"d5xe4",e:9.923},{m:"e7-e6",e:9.923},{m:"e7-e5",e:9.923}],"-1#700820937":[{m:"g7-g6",e:9.993},{m:"d5xe4",e:9.993}],"1#810279372":[{m:"c2-c3",e:9.63}],"1#1835280347":[{m:"Nc3xe4",e:9.992}],"-1#-1526578692":[{m:"c6xd5",e:9.994}],"1#1626692239":[{m:"Ng1-f3",e:9.994},{m:"c2-c4",e:9.994}],"-1#1215911810":[{m:"g7-g6",e:9.992},{m:"d5xe4",e:9.992}],"1#215539088":[{m:"Nc3xe4",e:9.992}],"1#879745092":[{m:"Nb1-c3",e:9.996},{m:"d2-d4",e:9.996},{m:"h2-h4",e:9.996},{m:"f2-f4",e:9.996}],"-1#-2049710766":[{m:"Bf8-g7",e:9.808}],"1#-1946499744":[{m:"Bf1-c4",e:9.773},{m:"h2-h4",e:9.773},{m:"f2-f4",e:9.773}],"-1#865331492":[{m:"e7-e6",e:8.571}],"1#1684373745":[{m:"d2-d4",e:7.5}],"-1#-1740363119":[{m:"Ng8-e7",e:6.667}],"1#1905245465":[{m:"Ng1-f3",e:6.667}],"-1#-1995662096":[{m:"d7-d6",e:5}],"1#-820008233":[{m:"h2-h4",e:7.5}],"-1#1956160091":[{m:"h7-h6",e:5}],"1#565896555":[{m:"Bc1-f4",e:5}],"-1#347161417":[{m:"a7-a6",e:5}],"1#698194554":[{m:"e4-e5",e:5}],"-1#813551084":[{m:"c7-c5",e:8},{m:"h7-h5",e:8}],"1#2064032398":[],"1#317070227":[{m:"Bf1-c4",e:7.5},{m:"d2-d4",e:7.5}],"-1#-1433454633":[{m:"c7-c5",e:5}],"-1#-288902669":[{m:"c7-c6",e:8}],"-1#-138908704":[{m:"c7-c6",e:9.167}],"1#-11026522":[{m:"Qd1-f3",e:8.75}],"-1#-50675187":[{m:"d7-d5",e:7.5}],"1#-602914050":[{m:"d2-d3",e:7.5}],"-1#-204329873":[{m:"Ng8-f6",e:7.5}],"1#1952250142":[{m:"h2-h3",e:7.5}],"-1#1826422720":[{m:"e7-e5",e:7.5}],"1#260120340":[{m:"f4-f5",e:7.5}],"-1#2029978297":[{m:"g6xf5",e:7.5}],"1#-1135742003":[{m:"e4xf5",e:7.5}],"-1#-934383068":[{m:"g7-g6",e:9.998},{m:"c7-c6",e:9.996},{m:"Bf8-g7",e:9.996}],"1#-1906490365":[{m:"c2-c3",e:9.981},{m:"c2-c4",e:9.981},{m:"g2-g3",e:9.981},{m:"f2-f4",e:9.981},{m:"Ng1-f3",e:9.981},{m:"Bc1-e3",e:9.981},{m:"Bf1-c4",e:9.981},{m:"Nb1-c3",e:9.981}],"-1#1614709946":[{m:"Ng8-f6",e:9.524}],"1#-407875125":[{m:"Qd1-c2",e:9},{m:"c2-c3",e:9.896},{m:"Nb1-d2",e:9}],"-1#1980282399":[{m:"Bf8-g7",e:5}],"-1#-752550063":[{m:"Bf8-g7",e:9.868},{m:"e7-e5",e:9.868}],"-1#934319766":[{m:"Bf8-g7",e:6.667}],"1#966375076":[{m:"Bf1-d3",e:6.667}],"-1#1159332146":[{m:"e7-e5",e:9.861}],"1#642245094":[{m:"Ng1-f3",e:9.444},{m:"d4xe5",e:9.444},{m:"Nb1-c3",e:9.444}],"-1#-557531121":[{m:"Nb8-d7",e:8.889},{m:"Bc8-g4",e:8.889}],"-1#1558650027":[{m:"d6xe5",e:5}],"1#-2120848273":[{m:"Qd1xd8+",e:5}],"-1#-1745101584":[{m:"e5xd4",e:9.375}],"-1#634106890":[{m:"Ng8-f6",e:9.722},{m:"b7-b6",e:9.722},{m:"d7-d6",e:9.333}],"1#-1572511365":[{m:"Bf1-g2",e:9.091}],"-1#-316666834":[{m:"Ng8-f6",e:9.783}],"1#-485938148":[{m:"Ng1-e2",e:9.844},{m:"Nb1-c3",e:9.844},{m:"Nb1-d2",e:9.844}],"-1#2093466083":[{m:"O-O",e:9.677},{m:"Nb8-c6",e:9.677}],"1#-657453926":[{m:"O-O",e:9.643}],"1#-1001051457":[{m:"Nb1-c3",e:5}],"-1#1387598090":[{m:"O-O",e:9.958}],"1#-157098893":[{m:"Ng1-f3",e:9.958},{m:"Ng1-e2",e:9.958},{m:"h2-h3",e:9.958}],"-1#856288065":[{m:"O-O",e:5}],"1#-1759631816":[{m:"Ng1-f3",e:5}],"-1#1872562129":[{m:"Bc8-g4",e:6.667}],"1#1575721428":[{m:"c2-c3",e:5}],"1#1900897048":[{m:"Bf1-g2",e:8.333}],"-1#1042812493":[{m:"Bc8-b7",e:8.333}],"1#-1511703575":[{m:"c2-c4",e:8.333}],"1#736269368":[{m:"Bf1-g2",e:9.643}],"-1#1686632813":[{m:"Ng8-f6",e:9.783},{m:"Nb8-c6",e:9.783},{m:"c7-c5",e:9.783}],"1#-602598863":[{m:"Ng1-e2",e:9.231},{m:"d4-d5",e:9.231}],"-1#1138491342":[{m:"e7-e5",e:9.167},{m:"Bc8-g4",e:9.167}],"1#545660698":[{m:"d4xe5",e:9.231},{m:"Bc1-e3",e:9.231}],"1#1907188171":[],"-1#650437307":[{m:"Nc6-e5",e:5}],"1#-1513168473":[{m:"h2-h3",e:5}],"-1#-1118902407":[{m:"c7-c6",e:5}],"1#-1247726785":[{m:"Ng1-e2",e:5}],"-1#711974592":[{m:"c6xd5",e:5}],"1#-2028517950":[{m:"e4xd5",e:5}],"-1#-604261657":[{m:"Ng8-f6",e:5}],"1#805082639":[{m:"d4xc5",e:9},{m:"c2-c3",e:9}],"-1#288269758":[{m:"Qd8-a5+",e:8.571}],"1#-2060850519":[{m:"c2-c3",e:8.571},{m:"Bc1-d2",e:8.571}],"-1#1800022544":[{m:"Qa5xc5",e:8}],"1#-138408866":[{m:"Bc1-e3",e:8.333},{m:"Ng1-e2",e:8.333}],"-1#-1471703604":[{m:"Qa5xc5",e:5}],"1#885896066":[{m:"Nb1-c3",e:5}],"-1#-1046522186":[{m:"Qd8-c7",e:6.667},{m:"c5xd4",e:6.667}],"1#-1903776894":[{m:"d4xc5",e:6.667}],"-1#-1336633293":[{m:"Qa5xc5",e:8}],"1#-207156549":[{m:"c3xd4",e:5}],"-1#-190517025":[{m:"Nb8-c6",e:5}],"1#1278614403":[{m:"Ng1-e2",e:5}],"-1#-232789373":[{m:"Ng8-f6",e:9.444},{m:"d6-d5",e:9.444}],"1#1972453362":[{m:"e4-e5",e:8.571}],"-1#-1536531611":[{m:"d6xe5",e:7.5}],"1#-258623146":[{m:"f4xe5",e:7.5}],"1#-459026208":[{m:"e4-e5",e:5}],"-1#894995575":[{m:"h7-h5",e:5}],"1#398678536":[{m:"Ng1-f3",e:5}],"-1#1994286570":[{m:"g7-g6",e:9}],"1#-246370149":[{m:"Bf1-c4",e:9.667},{m:"c2-c3",e:9.667},{m:"e4-e5",e:9.667},{m:"Bf1-d3",e:9.667}],"-1#1228512479":[{m:"c7-c6",e:7.5}],"1#1104562329":[{m:"Bc4-b3",e:7.5}],"-1#-1959268972":[{m:"Bf8-g7",e:7.5}],"1#-2061578842":[{m:"Nb1-d2",e:9.333}],"-1#523464738":[{m:"Bf8-g7",e:8}],"1#286937104":[{m:"Qd1-c2",e:9.907},{m:"Bf1-d3",e:9.907}],"-1#548137996":[{m:"d6xe5",e:5}],"1#1951675967":[{m:"Nf3xe5",e:5}],"-1#2025031501":[{m:"Bf8-g7",e:5}],"1#1989846911":[{m:"Bf1-c4",e:5}],"-1#-977003007":[{m:"Bf8-g7",e:9.444}],"1#-873644493":[{m:"O-O",e:9.565}],"-1#-776937529":[{m:"O-O",e:9.375}],"1#1973883582":[{m:"Rf1-e1",e:9.375}],"-1#-842399290":[{m:"Bf8-g7",e:9}],"1#-1008524812":[{m:"Qd1-d2",e:9.63}],"-1#-1278319085":[{m:"c7-c6",e:9},{m:"c7-c5",e:9}],"1#-1155419563":[{m:"c2-c4",e:6.667}],"-1#1885796196":[{m:"a7-a6",e:5}],"1#-122353295":[{m:"c2-c3",e:6.667}],"-1#909404231":[{m:"Ng8-f6",e:9.231}],"1#-1313161930":[{m:"Qd1-e2",e:8.571}],"-1#1995855210":[{m:"Nb8-c6",e:8.333},{m:"Bf8-g7",e:8.333}],"1#-832258506":[{m:"Ng1-f3",e:5}],"-1#921149407":[{m:"Bc8-g4",e:5}],"1#2027910488":[{m:"Ng1-f3",e:8}],"-1#-2141432655":[{m:"O-O",e:9.859}],"-1#1071741205":[{m:"a7-a6",e:9.968},{m:"c7-c6",e:9.968},{m:"Bf8-g7",e:9.968}],"1#47030310":[{m:"Bc1-e3",e:9.286}],"-1#1096476131":[{m:"b7-b5",e:8.75}],"1#923708755":[{m:"f2-f4",e:9.877}],"1#835213607":[{m:"h2-h3",e:9.991}],"1#-1063147934":[{m:"c2-c4",e:9.915},{m:"Ng1-f3",e:9.915}],"-1#199680851":[{m:"d7-d5",e:9.545}],"1#722232224":[{m:"e4-e5",e:8.75}],"-1#-84459721":[{m:"Bf8-g7",e:6.667}],"1#-186769659":[{m:"Nb1-c3",e:6.667}],"-1#1164059155":[{m:"Ng8-h6",e:6.667}],"1#-839578548":[{m:"h2-h4",e:6.667}],"-1#1987183808":[{m:"Bc8-e6",e:5}],"-1#941787019":[{m:"d7-d5",e:9.6}],"1#415762296":[{m:"e4-e5",e:9}],"-1#-919381009":[{m:"Bc8-g4",e:6.667}],"1#-79313430":[{m:"h2-h3",e:5}],"-1#-473578700":[{m:"Bg4xf3",e:5}],"1#-1300799135":[{m:"Qd1xf3",e:5}],"-1#887715218":[{m:"e7-e6",e:5}],"1#-966307306":[{m:"Bc1-e3",e:9.995},{m:"Nb1-c3",e:9.995},{m:"c2-c3",e:9.995},{m:"e2-e4",e:9.688},{m:"f2-f4",e:9.995},{m:"Bf1-e2",e:9.995},{m:"Bf1-c4",e:9.995},{m:"h2-h4",e:9.995},{m:"Ng1-f3",e:9.995}],"-1#-2047862829":[{m:"Bf8-g7",e:9}],"-1#2010869504":[{m:"Bf8-g7",e:9.968}],"-1#1844552223":[{m:"d7-d6",e:9.333},{m:"c7-c5",e:9.333},{m:"d7-d5",e:9.333}],"1#646630781":[{m:"d4xc5",e:7.5}],"-1#408485580":[{m:"Nb8-a6",e:6.667},{m:"Qd8-a5+",e:6.667}],"1#1145262110":[{m:"Bf1-g2",e:5}],"-1#187055435":[{m:"Na6xc5",e:6.667}],"1#-594825599":[{m:"Nb1-c3",e:6.667}],"-1#1832358807":[{m:"d7-d6",e:5}],"1#723822000":[{m:"Ng1-e2",e:5}],"-1#-1259714481":[{m:"Ng8-f6",e:6.667}],"1#862231870":[{m:"a2-a4",e:7.5}],"-1#-317410513":[{m:"Bc8-d7",e:5}],"1#1038935852":[{m:"Bc1-e3",e:5}],"-1#2122031849":[{m:"Bd7-c6",e:5}],"1#-1085342745":[{m:"f2-f3",e:5}],"-1#692073801":[{m:"b7-b6",e:5}],"1#2110186075":[{m:"a4-a5",e:5}],"-1#-1770376800":[{m:"O-O",e:5}],"1#846068953":[{m:"Ne2-d4",e:5}],"-1#-134234812":[{m:"Bc6-b7",e:5}],"1#2113897965":[{m:"b2-b4",e:5}],"-1#25763886":[{m:"Nc5-e6",e:5}],"1#1040575452":[{m:"a5-a6",e:5}],"-1#2090310679":[{m:"Bb7-c8",e:5}],"1#-1939885605":[{m:"Bc1-d2",e:5}],"-1#-1590571330":[{m:"Qa5xc5",e:5}],"1#1035725040":[{m:"Nb1-c3",e:5}],"-1#-1945643546":[{m:"Ng8-f6",e:5}],"1#193527959":[{m:"Bf1-g2",e:5}],"-1#1156345282":[{m:"Nb8-c6",e:5}],"1#-58816866":[{m:"Ng1-e2",e:5}],"-1#1672506209":[{m:"Nc6-e5",e:5}],"1#-524654467":[{m:"Bd2-e3",e:5}],"-1#-33104278":[{m:"Qc5-a5",e:5}],"1#939302927":[{m:"O-O",e:5}],"-1#765542907":[{m:"d7-d6",e:5}],"1#1806858204":[{m:"h2-h3",e:5}],"-1#1932685570":[{m:"O-O",e:5}],"1#-685392773":[{m:"b2-b3",e:5}],"-1#-71455808":[{m:"Ra8-b8",e:5}],"1#-1518029485":[{m:"a2-a4",e:5}],"-1#2079628098":[{m:"a7-a6",e:5}],"1#1188577905":[{m:"Be3-d2",e:5}],"1#1293624044":[{m:"e4-e5",e:8},{m:"e4xd5",e:8}],"-1#-1663009157":[{m:"c7-c5",e:6.667}],"1#-677703399":[{m:"c2-c3",e:6.667}],"-1#972607904":[{m:"Nb8-c6",e:6.667}],"1#-2123744516":[{m:"Bf1-g2",e:6.667}],"-1#-837855319":[{m:"f7-f6",e:6.667},{m:"Bc8-f5",e:6.667}],"1#-368504193":[{m:"f2-f4",e:5}],"-1#-1773421313":[{m:"Bc8-f5",e:5}],"1#-120962320":[{m:"Ng1-e2",e:5}],"-1#1728360207":[{m:"e7-e6",e:5}],"1#821216986":[{m:"O-O",e:5}],"-1#716121902":[{m:"h7-h5",e:5}],"1#137687377":[{m:"h2-h3",e:5}],"1#-1601263194":[{m:"a2-a3",e:5}],"-1#-1220576641":[{m:"Qd8-a5",e:5}],"1#590886248":[{m:"Ng1-e2",e:5}],"-1#-1124673385":[{m:"c5xd4",e:5}],"1#-1899068262":[{m:"b2-b4",e:5}],"-1#-222813863":[{m:"Qa5-a6",e:5}],"1#-812154436":[{m:"c3xd4",e:5}],"-1#299633028":[{m:"Qd8xd5",e:6.667}],"1#421285967":[{m:"Ng1-f3",e:6.667}],"-1#-509644378":[{m:"Bc8-g4",e:6.667}],"1#-739643485":[{m:"Bf1-g2",e:5}],"-1#-1668513034":[{m:"c7-c6",e:5}],"1#-1805429072":[{m:"Bc1-e3",e:5}],"-1#-671870091":[{m:"Ng8-f6",e:5}],"1#1350223364":[{m:"Nb1-d2",e:5}],"-1#-2139487911":[{m:"Qd5-a5",e:5}],"1#735399925":[{m:"c2-c4",e:5}],"-1#-527299900":[{m:"O-O",e:5}],"1#1149618109":[{m:"Qd1-b3",e:5}],"-1#809088115":[{m:"Nb8-d7",e:5}],"1#-473603636":[{m:"O-O",e:5}],"-1#-107446216":[{m:"Nd7-b6",e:5}],"1#1601081157":[{m:"a2-a4",e:5}],"-1#-2128699052":[{m:"Rf8-e8",e:5}],"1#-947857516":[{m:"Rf1-e1",e:5}],"-1#-927701252":[{m:"h7-h6",e:5}],"1#-1651105332":[{m:"Be3-f4",e:5}],"-1#-1171915626":[{m:"d7-d6",e:9.855}],"-1#92616976":[{m:"d7-d6",e:8.571}],"-1#2114879058":[{m:"c7-c5",e:9.412}],"-1#2111855258":[{m:"c7-c5",e:9}],"-1#1055159295":[{m:"c7-c6",e:9.979}],"-1#-1880567608":[{m:"h7-h6",e:9.333},{m:"h7-h5",e:9.333},{m:"d7-d5",e:9.333}],"1#-624257032":[{m:"d2-d4",e:6.667}],"-1#652950936":[{m:"d7-d6",e:6.667}],"1#1626868671":[{m:"Bc1-e3",e:6.667}],"-1#594497146":[{m:"Bf8-g7",e:6.667}],"1#759590472":[{m:"Nb1-c3",e:6.667}],"-1#-1661316258":[{m:"c7-c6",e:6.667}],"1#-1810528488":[{m:"Qd1-d2",e:6.667},{m:"a2-a4",e:6.667}],"-1#-466042625":[{m:"Qd8-a5",e:5}],"1#1883213800":[{m:"Ng1-e2",e:5}],"-1#1248176393":[{m:"Ng8-f6",e:5}],"1#-1384970569":[{m:"Bf1-c4",e:8.571},{m:"d2-d4",e:8.571}],"-1#354036467":[{m:"Ng8-f6",e:8}],"1#-1835729022":[{m:"Nb1-c3",e:8}],"-1#589873812":[{m:"d7-d6",e:8},{m:"c7-c6",e:8}],"1#734467794":[{m:"e4-e5",e:7.5}],"-1#1364372695":[{m:"d7-d6",e:6.667}],"1#390175472":[{m:"Ng1-h3",e:5}],"-1#-361217968":[{m:"Ng8-f6",e:5}],"1#1844876577":[{m:"Nh3-g5",e:5}],"1#-1358802885":[{m:"e4xd5",e:7.5}],"-1#-205161645":[{m:"Qd8xd5",e:6.667}],"1#-83549544":[{m:"Nb1-c3",e:6.667}],"-1#1253646222":[{m:"Qd5-a5",e:6.667}],"1#-518631134":[{m:"h4-h5",e:6.667}],"-1#-476454245":[{m:"Bf8-g7",e:6.667}],"1#-307182935":[{m:"Bf1-c4",e:6.667}],"-1#1440345837":[{m:"Nb8-c6",e:6.667}],"1#-313850447":[{m:"d2-d3",e:6.667},{m:"Ng1-e2",e:6.667}],"-1#1210939076":[{m:"Bf8-g7",e:9.6}],"1#1174689526":[{m:"Ng1-f3",e:9.444}],"-1#-1098418401":[{m:"d7-d6",e:9.583}],"1#-124501704":[{m:"Bf1-e2",e:9.63},{m:"Nb1-c3",e:9.63}],"-1#997599806":[{m:"Ng8-f6",e:7.5}],"1#-1124532401":[{m:"d2-d3",e:5}],"-1#-1824878114":[{m:"c7-c6",e:5}],"1#-1680521832":[{m:"c2-c3",e:5}],"-1#1974895905":[{m:"Nb8-d7",e:6.667}],"1#-1505079138":[{m:"O-O",e:5}],"-1#-1139297942":[{m:"e7-e5",e:5}],"1#-548777538":[{m:"Kg1-h1",e:5}],"-1#349355770":[{m:"O-O",e:5}],"1#-1329237117":[{m:"a2-a4",e:5}],"-1#1857379730":[{m:"Qd8-e7",e:5}],"1#580630106":[{m:"Nb1-a3",e:5}],"-1#1825617653":[{m:"e5xf4",e:5}],"1#1262803255":[{m:"Bc1xf4",e:5}],"-1#1227389998":[{m:"Nb8-c6",e:9.545},{m:"c7-c6",e:9.545},{m:"Ng8-f6",e:9.545}],"1#-239429774":[{m:"Bf1-b5",e:8}],"-1#58783680":[{m:"Ng8-f6",e:8}],"1#-2079448399":[{m:"O-O",e:8}],"-1#-1638677691":[{m:"O-O",e:8}],"1#1103603816":[{m:"g2-g3",e:6.667}],"-1#-363767711":[{m:"e7-e5",e:6.667}],"1#-1995654987":[{m:"Bf1-g2",e:6.667},{m:"d2-d3",e:6.667}],"1#-827938465":[{m:"Bf1-c4",e:9.286},{m:"g2-g3",e:9.286}],"-1#1993311515":[{m:"c7-c6",e:8.75}],"-1#1697667414":[{m:"O-O",e:7.5}],"1#1320973461":[{m:"d2-d3",e:10},{m:"a2-a3",e:10},{m:"b2-b3",e:10},{m:"c2-c3",e:10},{m:"f2-f4",e:10},{m:"Bf1-c4",e:10},{m:"Bf1-b5",e:10},{m:"Ng1-e2",e:10},{m:"Ng1-f3",e:10},{m:"g2-g3",e:10},{m:"Nb1-c3",e:10},{m:"d2-d4",e:10}],"-1#1635654148":[{m:"d7-d5",e:9.333},{m:"e7-e5",e:9.8},{m:"Bf8-c5",e:9.333},{m:"Nb8-c6",e:9.333},{m:"e7-e5",e:9.96}],"1#1100258039":[{m:"e4xd5",e:8}],"-1#492024223":[{m:"Ng8-f6",e:8}],"1#-420425867":[{m:"Ng1-f3",e:9.583},{m:"f2-f4",e:9.583}],"-1#-1699585547":[{m:"e7-e5",e:6.667}],"1#572557993":[{m:"Ng1-f3",e:7.5}],"1#-2118215657":[{m:"Ng1-f3",e:5}],"-1#2034088446":[{m:"d7-d6",e:5}],"1#-638783144":[{m:"Nb1-c3",e:8.75}],"-1#1750125646":[{m:"Bf8-c5",e:8}],"-1#1494067020":[{m:"Ng8-f6",e:8.75}],"1#-561810883":[{m:"Nb1-c3",e:8.75}],"-1#1866420011":[{m:"Nb8-c6",e:8.571}],"1#-676486025":[{m:"Ng1-f3",e:8.571}],"-1#791578014":[{m:"g7-g6",e:9.524},{m:"Bf8-c5",e:9.524},{m:"d7-d5",e:9.524},{m:"Bf8-e7",e:9.524}],"1#916507035":[{m:"Bf1-c4",e:8}],"1#264504685":[{m:"Bf1-b5",e:8}],"1#-1218681834":[{m:"d2-d4",e:8.75}],"-1#1646551854":[{m:"Ng8-f6",e:7.5}],"1#-441797025":[],"-1#-1595952084":[{m:"d7-d5",e:7.5},{m:"Ng8-f6",e:7.5}],"1#-2143996705":[{m:"Ng1-f3",e:6.667},{m:"Qd1-h5",e:6.667}],"-1#2025198902":[{m:"d5xe4",e:5}],"-1#548289344":[{m:"Bf8-d6",e:5}],"1#659644765":[],"-1#855562773":[{m:"Nb8-c6",e:9.994},{m:"d7-d6",e:9.994},{m:"Ng8-f6",e:9.994},{m:"Qd8-h4+",e:9.994},{m:"d7-d5",e:9.994},{m:"e5xf4",e:9.994},{m:"Bf8-c5",e:9.994},{m:"Qd8-f6",e:9.994}],"1#-1972620983":[{m:"Ng1-f3",e:9.583}],"1#359314903":[{m:"Bf1-e2",e:9.991}],"1#-767666170":[{m:"Nb1-c3",e:9.943}],"-1#-153790255":[{m:"Qd8-f6",e:9.983},{m:"f7-f5",e:9.983},{m:"c7-c6",e:9.983},{m:"b7-b5",e:9.983},{m:"d7-d6",e:9.983},{m:"Nb8-c6",e:9.983},{m:"Bf8-c5",e:9.983},{m:"Ng8-f6",e:9.983}],"1#1313321869":[{m:"Nb1-c3",e:9.75}],"1#370531010":[{m:"Ng1-f3",e:9.722}],"1#1901825440":[{m:"Qd1-e2",e:9.979}],"-1#-1132063705":[{m:"Ng8-f6",e:8.75},{m:"c7-c6",e:8.75}],"1#990429526":[{m:"d2-d4",e:7.5}],"-1#-953586890":[{m:"c7-c6",e:6.667}],"1#-809058448":[{m:"d4xe5",e:6.667}],"-1#-1251589571":[{m:"Nf6xe4",e:6.667}],"1#-1268137887":[],"-1#-781018774":[{m:"Ng8-f6",e:9.231},{m:"Bf8-c5",e:9.231},{m:"Nb8-c6",e:9.231}],"1#1459375131":[{m:"f2-f4",e:8.75},{m:"Nb1-c3",e:8.75}],"1#833756025":[{m:"c2-c3",e:5}],"-1#-539894848":[{m:"Nb8-c6",e:5}],"1#1732456604":[{m:"d2-d4",e:5}],"1#1776316982":[{m:"Nb1-c3",e:8},{m:"f2-f4",e:8}],"-1#362994870":[{m:"e5xf4",e:6.667}],"-1#-1237363332":[{m:"Qd8-f6",e:10},{m:"c7-c6",e:10},{m:"Nb8-c6",e:10},{m:"d7-d5",e:10},{m:"f7-f5",e:10},{m:"Ng8-f6",e:10},{m:"d7-d6",e:10},{m:"Qd8-e7",e:10},{m:"f7-f6",e:10}],"1#246267424":[{m:"c2-c4",e:10}],"1#833716237":[{m:"Nb1-c3",e:9.997}],"-1#-450198372":[{m:"Nb8-c6",e:9.091},{m:"Ng8-f6",e:9.091},{m:"f7-f5",e:9.091}],"1#1572368320":[],"1#1654936045":[{m:"e2-e4",e:9.6}],"-1#767638712":[{m:"Bf8-c5",e:8.75},{m:"Ng8-f6",e:6.667}],"1#-855523669":[{m:"Ng1-e2",e:8.333}],"-1#1389318996":[],"1#-1789667356":[{m:"Nb1-c3",e:7.5}],"-1#619703026":[{m:"Bf8-c5",e:9.231},{m:"g7-g6",e:9.231}],"1#-1003525919":[{m:"Ng1-f3",e:9.919},{m:"Ng1-e2",e:9.919},{m:"d2-d3",e:9.919}],"-1#1017923848":[{m:"d7-d6",e:9.878},{m:"O-O",e:9.878}],"1#2059370287":[{m:"d2-d3",e:9.868}],"1#-1732541327":[{m:"O-O",e:8.889}],"-1#1541506334":[{m:"d7-d6",e:9.821},{m:"O-O",e:9.821},{m:"h7-h5",e:9.821},{m:"a7-a6",e:9.821}],"-1#-336787856":[{m:"a7-a6",e:9.714},{m:"O-O",e:9.714},{m:"d7-d6",e:9.714}],"1#-691937469":[{m:"f2-f4",e:8.571}],"1#1341836041":[{m:"h2-h3",e:7.5}],"1#1029809911":[{m:"d2-d3",e:5}],"-1#312723558":[{m:"Bf8-g7",e:5}],"1#478865492":[{m:"f2-f4",e:5}],"-1#1623738068":[{m:"d7-d6",e:5}],"1#651915507":[{m:"Ng1-f3",e:5}],"-1#-564637414":[],"1#1933575604":[{m:"e4xf5",e:5}],"-1#491841911":[{m:"Ng8-f6",e:5}],"-1#-16758397":[{m:"f7-f5",e:9.993},{m:"Bf8-c5",e:9.993},{m:"Ng8-f6",e:9.993},{m:"d7-d6",e:9.993},{m:"g7-g6",e:9.993},{m:"Nb8-c6",e:9.993},{m:"Bf8-b4",e:9.993}],"1#2022612210":[{m:"g2-g3",e:9.991}],"1#-1189904476":[{m:"Bf1-c4",e:9.444}],"1#-426900090":[{m:"d2-d4",e:5}],"1#-1828251844":[{m:"Ng1-f3",e:7.5}],"-1#-1298276619":[{m:"e5xd4",e:9.976},{m:"e7-e5",e:9.941},{m:"g7-g6",e:9.976}],"1#434203922":[{m:"c2-c3",e:9.975},{m:"Bf1-c4",e:9.975},{m:"f2-f4",e:9.975},{m:"Ng1-f3",e:9.975}],"1#168768937":[{m:"d4-d5",e:9.859},{m:"d4xe5",e:9.859}],"-1#-253835997":[{m:"Nc6-e7",e:9.63}],"1#1620295878":[{m:"Ng1-f3",e:9.63},{m:"Bc1-e3",e:9.63},{m:"e2-e4",e:9.722}],"-1#-1743724241":[{m:"d7-d6",e:8.889}],"-1#587498755":[{m:"f7-f5",e:5}],"-1#-1412135433":[{m:"d7-d6",e:9.655}],"-1#1890568420":[{m:"Nc6xe5",e:9.667}],"1#-1077204485":[{m:"f2-f4",e:9.667},{m:"Ng1-f3",e:9.667},{m:"Nb1-c3",e:9.667}],"-1#-1014397061":[{m:"Ne5-g6",e:9}],"-1#1195902994":[{m:"Bf8-b4+",e:9.375}],"1#-1424780560":[{m:"d4xe5",e:7.5}],"-1#-776769603":[],"1#2048392596":[{m:"d2-d4",e:9.999},{m:"g2-g3",e:9.999},{m:"b2-b3",e:9.999},{m:"Nb1-c3",e:9.999},{m:"Bf1-b5",e:9.999},{m:"d2-d3",e:9.999},{m:"Qd1-e2",e:9.999},{m:"e4-e5",e:9.999},{m:"Ng1-f3",e:9.999},{m:"c2-c4",e:9.999}],"-1#-2043258892":[{m:"d7-d5",e:9.999}],"1#-1495476473":[{m:"Nb1-d2",e:9.999},{m:"e4xd5",e:9.999},{m:"Bf1-d3",e:9.999},{m:"Bc1-e3",e:9.999},{m:"e4-e5",e:9.999},{m:"Nb1-c3",e:9.999}],"-1#1994133594":[{m:"a7-a6",e:9.997}],"-1#-98829201":[{m:"e6xd5",e:9.988}],"-1#-1840744035":[{m:"d5xe4",e:9.231},{m:"Ng8-f6",e:9.231}],"-1#-448032062":[{m:"d5xe4",e:9.091}],"-1#1999080336":[{m:"Bc8-d7",e:9.993}],"-1#392227345":[{m:"Nb8-c6",e:9.999}],"-1#-780071523":[{m:"d7-d5",e:9.375}],"1#-244609682":[{m:"e4xd5",e:9.333},{m:"Bf1-g2",e:9.333}],"-1#-1381194234":[{m:"e6xd5",e:8}],"1#-1842508346":[{m:"Bf1-g2",e:7.5}],"-1#-582426477":[{m:"Ng8-f6",e:7.5}],"1#1522939362":[{m:"d2-d3",e:7.5}],"-1#1963219827":[{m:"Bf8-d6",e:5}],"-1#-1106321349":[{m:"d5xe4",e:8.889},{m:"Ng8-f6",e:8.889}],"1#-89167319":[{m:"Bg2xe4",e:5}],"-1#197485630":[{m:"Ng8-f6",e:5}],"1#964703562":[{m:"Nb1-c3",e:8.75}],"-1#1452272175":[{m:"b7-b6",e:9.722},{m:"d7-d5",e:9.722}],"1#34159933":[{m:"Bc1-b2",e:5}],"-1#373514028":[{m:"Bc8-b7",e:5}],"1#-1920046456":[{m:"Nb1-c3",e:5}],"-1#1009932190":[{m:"c7-c5",e:5}],"1#2001287420":[{m:"Ng1-f3",e:8.889}],"-1#-1882580715":[{m:"a7-a6",e:9.565}],"1#1986357980":[{m:"Bc1-b2",e:9.714}],"-1#1647249613":[{m:"Ng8-f6",e:9.697},{m:"d5xe4",e:9.697}],"1#-442376772":[{m:"e4xd5",e:9.444}],"1#646873823":[{m:"Nb1-c3",e:9.375}],"-1#-877936510":[{m:"d7-d5",e:9.821}],"1#-348045199":[{m:"f2-f4",e:9.839},{m:"Nb1-c3",e:9.945}],"-1#-1761349903":[{m:"d5xe4",e:7.5}],"1#-744332061":[{m:"Nc3xe4",e:7.5}],"-1#-335196660":[{m:"c7-c5",e:7.5},{m:"Ng8-f6",e:7.5}],"1#-1484906130":[{m:"Ng1-f3",e:9.231}],"1#1804311421":[{m:"Ne4xf6+",e:6.667},{m:"Ne4-g3",e:6.667}],"-1#331506072":[{m:"d5-d4",e:9.918},{m:"Bf8-b4",e:9.918},{m:"Ng8-f6",e:9.918}],"1#-1618346227":[{m:"Nc3-e2",e:9.444}],"1#2143633191":[{m:"a2-a3",e:9.091},{m:"e4-e5",e:9.091}],"1#-1806912279":[{m:"e4xd5",e:9.885}],"-1#-2010276570":[{m:"c7-c6",e:5}],"1#-2134750880":[{m:"Bb5-a4",e:5}],"-1#1825374882":[{m:"d7-d5",e:5}],"1#1277657681":[{m:"Qd1-e2",e:5}],"-1#-1955894771":[{m:"Qd8-a5",e:5}],"1#527181082":[{m:"Ba4-b3",e:5}],"-1#60033940":[{m:"Ng8-f6",e:5}],"1#-2078613787":[{m:"e4-e5",e:5}],"-1#1440842354":[{m:"Nf6-d7",e:5}],"1#-344317662":[{m:"c2-c3",e:5}],"-1#85582235":[{m:"c6-c5",e:5}],"1#919131656":[{m:"d2-d3",e:5}],"-1#420133017":[{m:"Nb8-c6",e:5}],"-1#1440060165":[{m:"b7-b6",e:9.984},{m:"c7-c5",e:9.984},{m:"d7-d5",e:9.984},{m:"Nb8-c6",e:9.984},{m:"b7-b5",e:9.984}],"1#22234135":[{m:"g2-g3",e:9.091}],"1#1967068150":[{m:"Qd1-e2",e:9.98},{m:"Nb1-d2",e:9.98}],"1#-314083239":[{m:"Ng1-f3",e:9.167}],"-1#365189552":[{m:"e6-e5",e:9.091}],"1#39617790":[{m:"d3-d4",e:8}],"-1#-1577399112":[{m:"Bc8-b7",e:5}],"-1#-1118104120":[{m:"Nb8-c6",e:9.917},{m:"e6-e5",e:9.917},{m:"c7-c5",e:9.917},{m:"Ng8-f6",e:9.917},{m:"Bf8-e7",e:9.917}],"1#97123988":[{m:"g2-g3",e:8.571},{m:"Qe2-e3",e:8.571}],"1#-105574274":[{m:"Nb1-c3",e:8.333},{m:"Ng1-f3",e:8.333}],"1#-165643606":[{m:"g2-g3",e:9.875}],"1#987087033":[{m:"e4-e5",e:7.5}],"-1#-349266898":[{m:"Nf6-g8",e:6.667}],"1#623506496":[{m:"b2-b3",e:9.375}],"-1#-1410555645":[{m:"d7-d6",e:8.75}],"1#-302016732":[{m:"e5xd6",e:8.333}],"-1#537905023":[{m:"Bf8xd6",e:8.571}],"1#-54091672":[{m:"d2-d4",e:8.571}],"-1#15141384":[{m:"Ng8-f6",e:8.571},{m:"Nb8-c6",e:8.571}],"1#-2023104647":[{m:"Ng1-f3",e:6.667}],"-1#2146107024":[{m:"Nb8-d7",e:6.667},{m:"b7-b6",e:6.667}],"1#-1200234156":[{m:"Ng1-f3",e:5}],"-1#1089913021":[{m:"Ng8-e7",e:5}],"1#-1455597771":[{m:"Bf1-d3",e:5}],"-1#-1649804881":[{m:"e6-e5",e:5}],"-1#-2104173443":[{m:"d7-d5",e:9.949}],"1#-1568777074":[{m:"Nb1-c3",e:9.945},{m:"e4-e5",e:9.945}],"-1#1938096153":[{m:"c7-c5",e:9.872},{m:"d5-d4",e:9.872}],"1#956198779":[{m:"b2-b4",e:9.861},{m:"g2-g3",e:9.861}],"1#-3236212":[{m:"d2-d3",e:5}],"-1#-804458467":[{m:"c7-c5",e:5}],"1#-1686659201":[{m:"g2-g3",e:5}],"-1#-1320109915":[{m:"d7-d5",e:9.818}],"1#-1850066858":[{m:"e4xd5",e:9.722}],"-1#-847441090":[{m:"e6xd5",e:9.655}],"1#-218351362":[{m:"c4xd5",e:9.655},{m:"d2-d4",e:9.655}],"-1#-1243452099":[{m:"Ng8-f6",e:9.167}],"1#845985868":[{m:"Nb1-c3",e:9},{m:"Bf1-b5+",e:9},{m:"Bf1-c4",e:9}],"-1#249402014":[{m:"Ng8-f6",e:9.873},{m:"Bf8-b4+",e:9.873}],"1#-1991030801":[{m:"Nb1-c3",e:9.828}],"1#1658506273":[{m:"Nb1-c3",e:9.167}],"1#2036810579":[{m:"Nb1-c3",e:9.919},{m:"d2-d4",e:9.919}],"-1#-925139387":[{m:"Bc8-b7",e:7.5}],"1#1393970145":[{m:"f2-f4",e:7.5}],"-1#794092897":[{m:"e7-e6",e:5}],"1#2023918772":[{m:"Ng1-f3",e:5}],"-1#-2145276579":[{m:"d7-d5",e:5}],"1#-1597297234":[{m:"d2-d3",e:5}],"-1#-1895218369":[{m:"d5xe4",e:5}],"1#-878130899":[{m:"d3xe4",e:5}],"-1#166397574":[{m:"Qd8xd1+",e:5}],"1#-253116506":[{m:"Ke1xd1",e:5}],"-1#-1774828626":[{m:"Ng8-f6",e:5}],"1#297309919":[{m:"Bf1-b5+",e:5}],"-1#-477956499":[{m:"Nb8-c6",e:5}],"1#1527782705":[{m:"a2-a3",e:5}],"-1#1285672680":[{m:"O-O-O+",e:5}],"1#-1167879893":[{m:"Bb5-d3",e:5}],"-1#210293684":[{m:"h7-h6",e:5}],"1#1504351364":[{m:"Rh1-e1",e:5}],"-1#792753206":[{m:"Bf8-e7",e:5}],"1#-1221421634":[{m:"Kd1-e2",e:5}],"-1#-933021037":[{m:"Nf6-d7",e:5}],"1#1996003779":[],"-1#-2058950349":[{m:"Bc8-b7",e:9.928}],"1#512482455":[{m:"f2-f3",e:9.919},{m:"Nb1-c3",e:9.919},{m:"d4-d5",e:9.919},{m:"Bf1-d3",e:9.919}],"-1#-2004544967":[{m:"e7-e6",e:7.5}],"1#-546079764":[{m:"Bc1-e3",e:7.5}],"-1#-1662763479":[{m:"Ng8-f6",e:6.667}],"1#459991896":[{m:"c2-c4",e:5}],"-1#-802312599":[{m:"c7-c5",e:5}],"1#-1688813301":[{m:"d4-d5",e:5}],"-1#1636249985":[{m:"Bf8-d6",e:5}],"1#-1408000106":[{m:"Nb1-c3",e:5}],"-1#498049664":[{m:"Bd6-e5",e:5}],"1#-239857665":[{m:"Bf1-d3",e:5}],"-1#-987717275":[{m:"e6xd5",e:5}],"1#-1842476332":[{m:"c4xd5",e:5}],"-1#-718250217":[{m:"O-O",e:5}],"1#1898418798":[{m:"Ng1-e2",e:5}],"-1#-286687343":[{m:"Rf8-e8",e:5}],"1#-1468593839":[{m:"Qd1-d2",e:5}],"-1#-1355292287":[{m:"e7-e6",e:9.737}],"1#-121534380":[{m:"Ng1-f3",e:9.762},{m:"a2-a3",e:9.762}],"-1#4368829":[{m:"d7-d6",e:9.615},{m:"Bf8-b4",e:9.615}],"1#1179754394":[{m:"Bf1-d3",e:5}],"-1#1925525760":[{m:"Nb8-d7",e:5}],"1#-1590041409":[{m:"Qd1-e2",e:5}],"1#1816524546":[{m:"Bf1-d3",e:9.412}],"-1#1490114968":[{m:"Ng8-f6",e:9.444}],"-1#-277849203":[{m:"Ng8-f6",e:9.231}],"1#1761513212":[{m:"Bc1-g5",e:8.75},{m:"e4-e5",e:8.75}],"-1#-2056873497":[{m:"Bf8-e7",e:5}],"1#487880815":[{m:"Bf1-d3",e:5}],"-1#-1190800789":[{m:"Nf6-e4",e:5}],"1#-221523128":[{m:"Nc3xe4",e:5}],"-1#-463852515":[{m:"e7-e6",e:6.667}],"1#-1280555576":[{m:"d5xe6",e:6.667}],"-1#885439435":[{m:"f7xe6",e:6.667}],"1#1757526579":[{m:"Nb1-c3",e:6.667}],"-1#-646084827":[{m:"Bf8-b4",e:6.667}],"1#-1250240102":[{m:"Bc1-d2",e:6.667}],"-1#-1743476993":[{m:"Ng8-f6",e:6.667}],"1#530215822":[{m:"Bf1-d3",e:6.667},{m:"e4-e5",e:6.667}],"-1#722394388":[{m:"O-O",e:5}],"1#-1894182803":[{m:"Qd1-e2",e:5}],"-1#1213593649":[{m:"d7-d5",e:5}],"-1#-832491751":[{m:"Bb4xc3",e:5}],"1#86412257":[{m:"Bd2xc3",e:5}],"-1#1495661318":[{m:"Nf6-e4",e:5}],"1#317454885":[],"-1#706703885":[{m:"Ng8-f6",e:9.873},{m:"f7-f5",e:9.873},{m:"e7-e6",e:9.873}],"1#-1382963332":[{m:"Nb1-d2",e:9.524}],"-1#2106679329":[{m:"c7-c5",e:8.75}],"1#921308995":[{m:"d4xc5",e:5}],"-1#137903346":[{m:"b6xc5",e:5}],"1#-1133120731":[{m:"e4xf5",e:8}],"-1#-765124634":[{m:"Bb7xg2",e:8}],"1#-1707799624":[{m:"Qd1-h5+",e:8}],"-1#984482855":[{m:"g7-g6",e:8}],"1#589318178":[{m:"f5xg6",e:8}],"1#2112429016":[{m:"Ng1-f3",e:9.846},{m:"c2-c4",e:9.846},{m:"Ng1-e2",e:9.846}],"-1#-500697561":[{m:"c7-c5",e:8}],"1#-1787592931":[{m:"Ng1-f3",e:9.976},{m:"Nb1-c3",e:9.976},{m:"d2-d4",e:9.976}],"-1#1844469492":[{m:"d7-d6",e:9.956},{m:"g7-g6",e:9.956}],"1#736323795":[{m:"Nb1-c3",e:9.925},{m:"d2-d4",e:9.925}],"-1#-1705028155":[{m:"Bc8-g4",e:8.333}],"1#-1473655872":[{m:"h2-h3",e:6.667}],"-1#-1331049186":[{m:"Bg4xf3",e:5}],"1#-518295733":[{m:"Qd1xf3",e:5}],"-1#1736801208":[{m:"e7-e6",e:5}],"1#812847725":[{m:"Bf1-b5",e:5}],"-1#-1035373857":[{m:"Qd8-f6",e:5}],"1#1855287633":[{m:"Qf3-e3",e:5}],"-1#925633077":[{m:"Ng8-e7",e:5}],"1#-555246147":[{m:"g2-g4",e:5}],"-1#-675102029":[{m:"Ng8-f6",e:9.926}],"1#1347164098":[{m:"Nb1-d2",e:9.914},{m:"d4-d5",e:9.914},{m:"Nb1-c3",e:9.914},{m:"Bf1-b5",e:9.914},{m:"c2-c3",e:9.914}],"-1#-2142449505":[{m:"Bc8-g4",e:8.571}],"1#-1304801638":[{m:"Bf1-b5",e:8.75},{m:"c2-c3",e:8.75}],"-1#-1432492216":[{m:"Nc6-e5",e:8.75}],"-1#-504354092":[{m:"a7-a6",e:9.897}],"-1#-1569294480":[{m:"a7-a6",e:5}],"-1#-1104160901":[{m:"e7-e5",e:9.091}],"1#1954419441":[{m:"d2-d4",e:9}],"-1#-2006992751":[{m:"Bf8-g7",e:8.889}],"1#-2039048029":[{m:"d4-d5",e:8.571},{m:"Nb1-c3",e:8.571}],"-1#2091345961":[{m:"Nc6-e5",e:7.5}],"1#-5412043":[{m:"Nf3xe5",e:7.5}],"-1#835027808":[{m:"Bg7xe5",e:7.5}],"1#-1943970607":[{m:"Nb1-d2",e:7.5},{m:"Nb1-c3",e:7.5}],"-1#1545706380":[{m:"d7-d6",e:5}],"1#439528875":[{m:"Bf1-d3",e:5}],"-1#1033724359":[{m:"d7-d6",e:5}],"1#2072926176":[{m:"Bc1-e3",e:5}],"-1#936027573":[{m:"d7-d6",e:8}],"1#1910084498":[{m:"h2-h3",e:8.889},{m:"Bc1-e3",e:8.889}],"-1#1767478604":[{m:"Ng8-f6",e:8.333}],"1#-287883203":[{m:"Bc1-g5",e:8.75}],"-1#55531302":[{m:"O-O",e:8.333}],"1#-1487365537":[{m:"Qd1-d2",e:7.5}],"-1#844027479":[{m:"Ng8-f6",e:6.667},{m:"Bc8-g4",e:6.667}],"1#-1245707482":[{m:"Qd1-d2",e:7.5}],"-1#617562635":[{m:"d7-d6",e:9.583}],"1#1658614828":[{m:"f2-f4",e:7.5}],"-1#513727148":[{m:"Ng8-f6",e:6.667}],"1#-1727000611":[{m:"d2-d4",e:6.667}],"-1#1697752509":[{m:"e7-e5",e:6.667}],"1#107758953":[{m:"Ng1-f3",e:6.667}],"-1#-17865600":[{m:"Bc8-g4",e:7.5}],"1#-862324091":[{m:"Bf1-b5",e:6.667}],"-1#1050909239":[{m:"Nf6-d7",e:5}],"1#-2143798937":[{m:"Bb5xc6",e:5}],"-1#1972967958":[{m:"b7xc6",e:5}],"1#-1894063765":[{m:"O-O",e:5}],"-1#-1790508897":[{m:"Bf8-e7",e:5}],"1#221634839":[{m:"Nc3-e2",e:5}],"-1#1542276056":[{m:"O-O",e:5}],"1#-356703":[{m:"Qd1-d3",e:5}],"-1#124667164":[{m:"Rf8-e8",e:5}],"1#1106260956":[{m:"d4xe5",e:5}],"-1#995151505":[{m:"d6xe5",e:5}],"1#-433996203":[{m:"f4-f5",e:5}],"-1#-1856003080":[{m:"Nd7-f6",e:5}],"1#801374376":[{m:"Qd3-c4",e:5}],"-1#590514744":[{m:"Ra8-b8",e:5}],"1#2097910955":[{m:"a2-a3",e:5}],"-1#1790592882":[{m:"Bg4xf3",e:5}],"1#990438695":[{m:"g2xf3",e:5}],"-1#-98615488":[{m:"Nf6-h5",e:5}],"1#-1821390765":[{m:"Bc1-e3",e:5}],"-1#-789017194":[{m:"Rb8xb2",e:5}],"1#1395257675":[{m:"Rf1-d1",e:5}],"-1#896935451":[{m:"Qd8-a8",e:5}],"1#-346502339":[{m:"Rd1-d7",e:5}],"-1#-594788406":[],"-1#1767036285":[{m:"e7-e5",e:9.941},{m:"d7-d6",e:9.941},{m:"d7-d5",e:9.941}],"1#792847194":[{m:"f2-f4",e:9.545},{m:"Bc1-g5",e:9.545}],"-1#1392725466":[{m:"d6-d5",e:6.667}],"1#1170175929":[{m:"e4-e5",e:5}],"-1#-1807471826":[{m:"h7-h5",e:5}],"1#-1226834607":[{m:"Bc1-e3",e:5}],"-1#-179783532":[{m:"Bc8-g4",e:5}],"1#-952228207":[{m:"Ng1-f3",e:5}],"-1#-1025903551":[{m:"h7-h6",e:5}],"1#-1745112207":[{m:"Bg5-h4",e:5}],"-1#1485821516":[{m:"g7-g5",e:5}],"1#-1579738900":[{m:"Bh4-g3",e:5}],"-1#-592267410":[{m:"Bf8-g7",e:5}],"1#-761555108":[{m:"c2-c3",e:5}],"1#1236817294":[{m:"Nb1-c3",e:9.881},{m:"e4-e5",e:9.881}],"-1#-133928808":[{m:"Ng8-f6",e:9.756},{m:"d5xe4",e:9.756},{m:"e7-e5",e:9.756}],"1#2139799017":[{m:"e4-e5",e:9.474}],"-1#-1368268418":[{m:"Nf6-d7",e:9.474}],"1#-1129979254":[{m:"d4-d5",e:9.333}],"-1#1182011904":[{m:"Nc6-e5",e:9.333}],"1#-1688631220":[{m:"Bf1-b5",e:9.167}],"-1#-1740437223":[{m:"Bc8-f5",e:9.744}],"1#-154994922":[{m:"c2-c3",e:9.722}],"-1#413218735":[{m:"e7-e6",e:9.5},{m:"f7-f6",e:9.5},{m:"Qd8-d7",e:9.5}],"1#-620612893":[{m:"Ng1-e2",e:7.5}],"1#1811063398":[{m:"d2-d4",e:9.998}],"-1#-1747777530":[{m:"g7-g6",e:9.998},{m:"Ng8-f6",e:9.998}],"1#274586999":[{m:"Bf1-d3",e:9.997},{m:"Nb1-d2",e:9.997},{m:"f2-f3",e:9.997},{m:"Nb1-c3",e:9.997},{m:"Ng1-f3",e:9.997}],"-1#617182189":[{m:"c7-c5",e:9.945},{m:"g7-g6",e:9.945},{m:"e7-e5",e:9.945}],"1#1873943695":[{m:"d4-d5",e:7.5}],"-1#-1788613627":[{m:"c5-c4",e:5}],"1#-1981561191":[{m:"Bd3xc4",e:5}],"1#1028079592":[{m:"c2-c3",e:9.896}],"1#1200919353":[{m:"d4-d5",e:9.873},{m:"Ng1-f3",e:9.873},{m:"Ng1-e2",e:9.873},{m:"c2-c3",e:9.873}],"-1#-1067640278":[{m:"Nb8-c6",e:9.792},{m:"e7-e5",e:9.792},{m:"g7-g6",e:9.792}],"1#2026893686":[{m:"Nb1-d2",e:9.914}],"1#-1560216834":[{m:"c2-c3",e:8.571}],"-1#1298348615":[{m:"Nb8-d7",e:7.5}],"1#-1633685512":[{m:"Ng1-f3",
e:5}],"1#-640461265":[{m:"Ng1-f3",e:9.756}],"-1#558921670":[{m:"Bf8-g7",e:9.744}],"1#796481524":[{m:"Bf1-c4",e:9.783}],"-1#-2041375783":[{m:"e7-e5",e:9.922},{m:"Nb8-d7",e:9.922},{m:"c7-c6",e:9.922},{m:"d6-d5",e:9.922},{m:"c7-c5",e:9.922},{m:"e7-e6",e:9.922},{m:"g7-g6",e:9.922}],"1#-452005107":[{m:"d4xe5",e:9.762}],"1#1437582950":[{m:"Bc1-e3",e:9.091}],"1#-1900230753":[{m:"c2-c4",e:9.167}],"1#-1863374406":[{m:"Nb1-c3",e:9.615}],"1#-777684468":[{m:"Bc1-e3",e:8.571}],"1#-1612881956":[{m:"Bc1-e3",e:9.545}],"-1#-1579032479":[{m:"c7-c6",e:9.997},{m:"e7-e5",e:9.997},{m:"g7-g6",e:9.997},{m:"c7-c5",e:9.997},{m:"Nb8-d7",e:9.997}],"1#-1458686937":[{m:"Bf1-e2",e:9.983},{m:"f2-f4",e:9.983}],"1#-1027866443":[{m:"d4xe5",e:9.962}],"1#-1200640924":[{m:"h2-h3",e:9.996}],"1#-358969597":[{m:"d4xc5",e:5}],"-1#-733430606":[{m:"Qd8-a5",e:5}],"1#1914516958":[{m:"g2-g3",e:9.938},{m:"Bf1-c4",e:9.938}],"-1#-388039522":[{m:"g7-g6",e:9}],"1#218830002":[{m:"e2-e4",e:9.865},{m:"e4xd5",e:9.995}],"-1#1372340186":[{m:"Ng8-f6",e:9.994},{m:"Qd8xd5",e:9.994}],"1#-700257621":[{m:"Nb1-c3",e:9.988},{m:"Ng1-f3",e:9.988},{m:"Bf1-b5+",e:9.988},{m:"d2-d4",e:9.988},{m:"c2-c4",e:9.988}],"-1#1744754621":[{m:"Nf6xd5",e:9.934},{m:"Nc6-a5",e:9.934}],"1#-1660287288":[{m:"Qd1-f3",e:9.931},{m:"g2-g3",e:9.931},{m:"Nc3xd5",e:9.931},{m:"Bf1-c4",e:9.931},{m:"Ng1-f3",e:9.931}],"1#2014213017":[{m:"Nc3-d5",e:5}],"-1#1056097893":[{m:"b7-b5",e:5}],"1#1769722270":[],"-1#784452418":[{m:"Nf6xd5",e:9.882}],"1#-734717385":[{m:"g2-g3",e:9.833}],"-1#2141448766":[{m:"g7-g6",e:6.667}],"1#1714267707":[{m:"Bf1-g2",e:6.667}],"-1#692636526":[{m:"Bf8-g7",e:6.667}],"1#660728668":[{m:"O-O",e:7.5}],"-1#1027345064":[{m:"O-O",e:6.667}],"1#-1725184047":[{m:"d2-d4",e:6.667}],"-1#1695182257":[{m:"c7-c5",e:8.889},{m:"Bc8-g4",e:8.889},{m:"Nb8-c6",e:8.889}],"1#779158227":[{m:"d4xc5",e:7.5}],"1#1467806644":[{m:"h2-h3",e:5}],"-1#611879449":[{m:"Nb8-d7",e:9.909},{m:"Bc8-d7",e:9.909}],"1#-142319706":[{m:"c2-c4",e:9.091}],"-1#1019419287":[{m:"a7-a6",e:8.333}],"1#32490404":[{m:"Bb5-a4",e:8},{m:"Bb5xd7+",e:8}],"-1#-522010691":[{m:"Qd8xd7",e:7.5}],"1#-192881126":[{m:"Bb5-c4",e:9.901},{m:"Bb5-e2",e:9.901},{m:"Bb5xd7+",e:9.901}],"-1#-829022629":[{m:"c7-c6",e:9.811}],"-1#-1256367847":[{m:"Nf6xd5",e:9.762}],"-1#-410450178":[{m:"Qd8xd7",e:8.333}],"-1#711147723":[{m:"Nf6xd5",e:9.979},{m:"Bc8-g4",e:9.979}],"1#-795373122":[{m:"g2-g3",e:9.969},{m:"c2-c4",e:9.969},{m:"Ng1-f3",e:9.969}],"-1#466670735":[{m:"Nd5-b6",e:9.939}],"-1#672444503":[{m:"Bc8-f5",e:9.95}],"1#404086478":[{m:"f2-f3",e:9.931},{m:"Bf1-e2",e:9.931},{m:"Bf1-b5+",e:9.931},{m:"Ng1-f3",e:9.931}],"-1#-1910828960":[{m:"Bg4-f5",e:9.688}],"-1#-526975193":[{m:"Qd8xd5",e:9.762}],"-1#486911898":[{m:"e7-e6",e:9.926},{m:"c7-c6",e:9.926}],"1#1257489999":[{m:"d5xe6",e:9.848},{m:"Nb1-c3",e:9.848}],"-1#1315067802":[{m:"Bc8xe6",e:9.811}],"1#-772296757":[{m:"d2-d4",e:9.811}],"-1#-78644391":[{m:"e6xd5",e:7.5}],"1#-993079143":[{m:"Nb1-c3",e:9.828}],"1#367688668":[{m:"Qd1-a4",e:9.868},{m:"d5xc6",e:9.868}],"-1#-684233335":[{m:"Bc8-d7",e:6.667}],"-1#796137660":[{m:"Nb8xc6",e:9.706}],"1#1733672050":[{m:"d2-d3",e:9.706}],"1#1493984785":[{m:"Nb1-c3",e:9.99},{m:"Ng1-f3",e:9.99}],"-1#-391095545":[{m:"Qd5-d8",e:9.989},{m:"Qd5-a5",e:9.989},{m:"Qd5-d6",e:9.989}],"1#-1487022581":[{m:"d2-d4",e:9.811}],"-1#1534884971":[{m:"g7-g6",e:9.792},{m:"Ng8-f6",e:9.792}],"1#1123168366":[{m:"Bf1-c4",e:9}],"-1#-90498006":[{m:"Bf8-g7",e:8}],"1#-189645800":[{m:"Bc1-f4",e:8}],"1#-588076774":[{m:"h2-h3",e:9.714},{m:"Bc1-g5",e:9.714},{m:"Ng1-f3",e:9.714},{m:"Bf1-c4",e:9.714}],"1#1126110635":[{m:"Ng1-f3",e:9.987},{m:"Bf1-c4",e:9.987},{m:"d2-d4",e:9.987},{m:"g2-g3",e:9.987}],"-1#-1147390910":[{m:"c7-c6",e:9.878}],"-1#-76138001":[{m:"Ng8-f6",e:9.75}],"1#2096688286":[{m:"d2-d3",e:9.655}],"-1#-1086406709":[{m:"e7-e5",e:9.983},{m:"Ng8-f6",e:9.983}],"-1#-393615966":[{m:"Ng8-f6",e:9.565}],"1#1862742227":[{m:"Bf1-g2",e:9.286}],"1#-1829552522":[{m:"d2-d4",e:9.907}],"-1#1859294230":[{m:"Ng8-f6",e:9.884}],"1#-379829913":[{m:"Ng1-f3",e:9.872}],"-1#299851918":[{m:"Bc8-g4",e:9.833},{m:"a7-a6",e:9.833}],"1#598343307":[{m:"h2-h3",e:8}],"-1#992606293":[{m:"Bg4-h5",e:7.5}],"1#754170301":[{m:"Bf1-c4",e:9.821},{m:"Nf3xd4",e:9.821},{m:"Bc1-e3",e:9.821}],"-1#-1584445448":[{m:"Bc8-g4",e:9.677}],"1#-1812342275":[{m:"Bf1-e2",e:9.375}],"-1#1343992571":[{m:"Nb8-c6",e:9.375}],"1#-393651801":[{m:"h2-h3",e:9.333}],"-1#-267821191":[{m:"Bg4xf3",e:7.5}],"1#-1581515476":[{m:"Be2xf3",e:7.5}],"-1#-2068404779":[{m:"Qd5-e6+",e:7.5}],"1#-399745101":[{m:"Qd1-e2",e:7.5}],"-1#794867695":[{m:"Qe6xe2+",e:7.5}],"1#25957705":[{m:"Bf3xe2",e:7.5}],"-1#-768148655":[{m:"O-O-O",e:7.5}],"1#620012690":[{m:"b2-b3",e:5}],"-1#141341481":[{m:"g7-g6",e:5}],"1#300089132":[{m:"Bc1-b2",e:5}],"-1#94936381":[{m:"Nc6-d4",e:5}],"1#-2030180127":[{m:"Bb2xd4",e:5}],"-1#-2046245708":[{m:"Rd8xd4",e:5}],"1#521534717":[{m:"Nb1-a3",e:5}],"-1#1365179474":[{m:"Bf8-h6",e:5}],"1#756993152":[{m:"Na3-c4",e:5}],"-1#512616276":[{m:"Ng8-f6",e:5}],"1#-1727843803":[{m:"c2-c3",e:5}],"-1#2002842268":[{m:"Rd4-d8",e:5}],"1#-1123156235":[{m:"Be2-f3",e:5}],"-1#489934676":[{m:"Nf6-d5",e:5}],"1#-1595225370":[{m:"Bf3xd5",e:5}],"-1#33365253":[{m:"Rd8xd5",e:5}],"1#-1258921636":[{m:"O-O-O",e:5}],"-1#-492942034":[{m:"b7-b5",e:5}],"1#-1256760619":[{m:"Nc4-e3",e:5}],"-1#-1378645203":[{m:"Rd5-d3",e:5}],"1#-182056229":[{m:"Ne3-g4",e:5}],"-1#-200042409":[{m:"Bh6-g5",e:5}],"1#-1435549392":[{m:"Nb1-c3",e:9.996},{m:"Ng1-f3",e:9.996},{m:"Bf1-c4",e:9.996},{m:"e4-e5",e:9.996},{m:"d2-d3",e:9.996}],"-1#466844710":[{m:"d7-d5",e:9.971},{m:"d7-d6",e:9.971},{m:"Nb8-c6",e:9.971}],"1#993656021":[{m:"e4-e5",e:9.965},{m:"Nb1-c3",e:9.988}],"-1#-356343742":[{m:"Nf6-d7",e:9.942},{m:"Nf6-e4",e:9.942},{m:"d5-d4",e:9.942}],"1#1415119634":[{m:"e5-e6",e:9.773}],"1#-1593007775":[{m:"Ng1-f3",e:9.884}],"1#1720270551":[{m:"Nc3-e2",e:9.756}],"1#1572882945":[{m:"g2-g3",e:9.744}],"-1#-162088440":[{m:"c7-c6",e:9.167}],"1#-21402034":[{m:"Bf1-g2",e:5}],"-1#-1310981349":[{m:"Nb8-d7",e:5}],"1#1646319268":[{m:"f2-f4",e:5}],"-1#509769764":[{m:"e7-e5",e:5}],"1#2101319920":[{m:"d2-d3",e:5}],"-1#1392375393":[{m:"e5xf4",e:5}],"1#-1555982470":[{m:"d2-d4",e:8.571},{m:"Bf1-b5",e:8.571}],"-1#1600142618":[{m:"Ng8-f6",e:9.756}],"-1#1367078856":[{m:"e7-e5",e:5}],"1#841357084":[{m:"f2-f4",e:5}],"-1#1315223964":[{m:"d7-d6",e:5}],"-1#1391223001":[{m:"e7-e6",e:8},{m:"Nf6xe4",e:8}],"1#85592332":[{m:"b2-b3",e:5}],"-1#696393399":[{m:"d7-d5",e:5}],"1#157851204":[{m:"e4xd5",e:5}],"-1#1437578540":[{m:"e6xd5",e:5}],"1#1781440236":[{m:"Bf1-b5+",e:5}],"-1#-1743454626":[{m:"Bc8-d7",e:5}],"1#1223469661":[{m:"Bb5xd7+",e:5}],"-1#1541763769":[{m:"Nf6xd7",e:5}],"1#817736375":[{m:"O-O",e:5}],"-1#719342403":[{m:"Bf8-d6",e:5}],"1#-411769516":[{m:"d2-d4",e:5}],"-1#458575668":[{m:"c7-c5",e:5}],"1#1345200214":[{m:"Nb1-c3",e:5}],"1#2105342254":[],"-1#302411124":[{m:"Nf6xe4",e:8.571},{m:"b7-b5",e:8.571}],"1#1033303171":[{m:"Bc4xf7+",e:5}],"-1#-1971830011":[{m:"Ke8xf7",e:5}],"1#-1153804393":[{m:"Qd1-h5+",e:5}],"-1#463558664":[{m:"Kf7-g8",e:5}],"1#-327927516":[{m:"Qh5-d5+",e:5}],"-1#-2004684348":[{m:"e7-e6",e:5}],"1#-546007023":[{m:"Qd5xe4",e:5}],"-1#78022792":[{m:"d7-d5",e:5}],"1#608962683":[{m:"Qe4-e2",e:5}],"-1#-1364464955":[{m:"c7-c5",e:5}],"1#-439319129":[{m:"Ng1-f3",e:5}],"-1#492020814":[{m:"Nb8-c6",e:5}],"1#-1514057966":[{m:"d2-d3",e:5}],"1#1167030927":[{m:"Bc4-b3",e:7.5}],"-1#-1888559230":[{m:"c7-c5",e:7.5},{m:"Bc8-b7",e:7.5}],"1#-1005211424":[{m:"e4-e5",e:5}],"-1#367979639":[{m:"c5-c4",e:5}],"1#158254827":[{m:"e5xf6",e:5}],"-1#-520641914":[{m:"g7xf6",e:5}],"1#50297692":[{m:"Qd1-f3",e:5}],"1#346286630":[{m:"d2-d3",e:6.667}],"-1#996246711":[{m:"c7-c5",e:6.667}],"1#1880812501":[{m:"Ng1-f3",e:6.667}],"-1#-2003187140":[{m:"e7-e6",e:6.667}],"1#-546331671":[{m:"e4-e5",e:6.667}],"-1#2073304487":[{m:"Nf6-e4",e:9.995},{m:"Nf6-d5",e:9.995},{m:"Nf6-g8",e:9.995}],"1#811211908":[{m:"d2-d4",e:8},{m:"d2-d3",e:8}],"-1#-864307484":[{m:"f7-f6",e:7.5}],"1#-394398926":[{m:"Bf1-d3",e:7.5}],"-1#-588685912":[{m:"d7-d5",e:7.5}],"-1#530084373":[{m:"Ne4-c5",e:5}],"1#1938715234":[{m:"d3-d4",e:5}],"-1#-802670044":[{m:"Nc5-e6",e:5}],"1#-968026091":[{m:"Nb1-c3",e:9.995},{m:"b2-b3",e:9.995},{m:"d2-d4",e:9.995},{m:"Ng1-f3",e:9.995},{m:"c2-c4",e:9.995},{m:"g2-g3",e:9.995},{m:"Bf1-c4",e:9.995}],"-1#980202101":[{m:"d7-d6",e:9.994}],"1#-65353514":[{m:"d2-d4",e:9.167}],"-1#3891894":[{m:"d7-d6",e:9},{m:"d7-d5",e:9}],"1#1177048209":[{m:"e5xd6",e:8.75},{m:"Ng1-f3",e:8.75}],"1#550625861":[{m:"Bf1-d3",e:6.667}],"-1#340085983":[{m:"c7-c5",e:6.667}],"1#1597907901":[{m:"d4xc5",e:6.667}],"-1#-2052247647":[{m:"e7-e5",e:9.8},{m:"Nb8-c6",e:9.8},{m:"g7-g6",e:9.8},{m:"d7-d6",e:9.8},{m:"d7-d5",e:9.8}],"1#1027589373":[{m:"f2-f4",e:7.5}],"-1#1098738301":[{m:"e7-e6",e:6.667},{m:"e7-e5",e:6.667}],"1#378209192":[{m:"Ng1-f3",e:5}],"1#-1675402332":[{m:"g2-g3",e:5}],"-1#934646701":[{m:"Bf8-g7",e:5}],"1#966570911":[{m:"Bf1-g2",e:5}],"-1#1996086986":[{m:"d7-d6",e:5}],"1#820701421":[{m:"f2-f4",e:5}],"1#-1010951802":[{m:"f2-f4",e:6.667}],"-1#-1073957114":[{m:"c7-c5",e:8}],"1#-192423836":[{m:"Ng1-f3",e:8}],"-1#201652621":[{m:"Nb8-c6",e:6.667}],"1#-1522028718":[{m:"Nb1-d2",e:9.474}],"-1#1967613967":[{m:"e7-e5",e:9.412},{m:"e7-e6",e:9.412},{m:"c7-c5",e:9.412}],"1#1044121453":[{m:"Ng1-f3",e:7.5}],"-1#-1143672618":[{m:"e7-e5",e:9.444},{m:"d7-d5",e:9.444}],"1#-662106110":[{m:"Bf1-g2",e:8.571},{m:"c2-c4",e:8.571}],"-1#-1746109097":[{m:"h7-h5",e:8.333}],"1#-1250448600":[{m:"g4xh5",e:6.667}],"-1#-25675364":[{m:"Qd8-g5",e:5}],"1#-580508125":[{m:"Bg2-f3",e:5}],"-1#-237039151":[{m:"Qg5-h4",e:5}],"1#71280264":[{m:"Nb1-c3",e:5}],"-1#-1249666146":[{m:"Ng8-f6",e:5}],"1#839732975":[{m:"e2-e4",e:5}],"-1#1959510418":[{m:"Bf8-c5",e:5}],"1#-1811201151":[{m:"d2-d4",e:5}],"-1#1747642849":[{m:"Bc5xd4",e:5}],"1#-266740908":[{m:"Qd1-e2",e:5}],"-1#928330504":[{m:"Bd4xc3+",e:5}],"1#1033231829":[{m:"b2xc3",e:5}],"-1#-101235078":[{m:"Nf6xh5",e:5}],"1#1090494236":[],"-1#332289331":[],"1#-1690406875":[{m:"h2-h3",e:9.167},{m:"Bf1-g2",e:9.167}],"-1#-2084669701":[{m:"e7-e5",e:8}],"1#-521955793":[{m:"Bf1-g2",e:6.667}],"-1#-1350108294":[{m:"c7-c5",e:6.667},{m:"c7-c6",e:6.667}],"1#-453143528":[{m:"e2-e3",e:5}],"-1#1515477015":[{m:"Nb8-c6",e:5}],"1#-490294453":[{m:"Ng1-e2",e:5}],"-1#2097700532":[{m:"Bc8-e6",e:5}],"1#108158259":[{m:"Ne2-g3",e:5}],"-1#1894275473":[{m:"Bf8-d6",e:5}],"1#-1115883642":[{m:"d2-d3",e:5}],"-1#-1833002729":[{m:"Qd8-d7",e:5}],"1#1360895067":[{m:"Nb1-c3",e:5}],"-1#-526278323":[{m:"Ng8-e7",e:5}],"1#157955781":[{m:"Ng3-h5",e:5}],"-1#-932085405":[{m:"O-O",e:5}],"1#1818643482":[{m:"e3-e4",e:5}],"-1#-464747553":[{m:"d5-d4",e:5}],"1#1745296714":[{m:"Nc3-d5",e:5}],"-1#788244662":[{m:"Kg8-h8",e:5}],"1#-183324927":[{m:"Nd5-f6",e:5}],"-1#2021331700":[{m:"g7xf6",e:5}],"1#1904233944":[{m:"Qd1-f3",e:5}],"-1#1915564147":[{m:"f6-f5",e:5}],"1#-671206825":[{m:"Nh5-f6",e:5}],"-1#-1262423820":[{m:"Qd7-d8",e:5}],"1#2003039672":[{m:"g4-g5",e:5}],"-1#1100152545":[{m:"Ne7-g8",e:5}],"1#-1470535319":[{m:"Nf6xh7",e:5}],"-1#-2053624859":[{m:"f5-f4",e:5}],"1#1107609813":[{m:"Qf3-h5",e:5}],"-1#-1854458282":[{m:"Kh8-g7",e:5}],"1#231349116":[{m:"Nh7-f6",e:5}],"-1#1001723054":[{m:"Rf8-e8",e:5}],"1#2099995246":[{m:"Qh5-h7+",e:5}],"-1#104648337":[{m:"Kg7-f8",e:5}],"1#1342976849":[{m:"Qh7xg8+",e:5}],"-1#2091267472":[{m:"Kf8-e7",e:5}],"1#1947553489":[],"1#-1486278852":[{m:"d2-d4",e:7.5}],"-1#1531479388":[{m:"e5-e4",e:7.5}],"1#-961986381":[{m:"c2-c4",e:6.667}],"-1#233702786":[{m:"Nb8-a6",e:6.667}],"1#1375054672":[{m:"Nb1-c3",e:5}],"-1#-532048314":[{m:"Na6-c7",e:5}],"1#90046891":[{m:"f2-f3",e:5}],"-1#-1823420667":[{m:"f7-f5",e:5}],"1#87707181":[{m:"c4xd5",e:5}],"-1#-1842695711":[{m:"c6xd5",e:5}],"1#1166643087":[{m:"Qd1-b3",e:5}],"-1#825621569":[{m:"Bf8-d6",e:5}],"1#-56536490":[{m:"Ke1-f1",e:5}],"-1#343074409":[{m:"Ng8-e7",e:5}],"1#-38178335":[{m:"g4-g5",e:5}],"-1#-884442440":[{m:"Ra8-b8",e:5}],"1#-1787730901":[{m:"h3-h4",e:5}],"-1#1177806542":[{m:"b7-b5",e:5}],"1#297464117":[{m:"Ng1-h3",e:5}],"-1#-326947947":[{m:"Bc8-d7",e:5}],"1#1014726550":[{m:"Bc1-f4",e:5}],"-1#158390708":[{m:"Bd7-c6",e:5}],"1#-934969158":[{m:"e2-e3",e:5}],"-1#1995197621":[{m:"Nc7-e6",e:5}],"1#782949195":[{m:"Nc3-e2",e:5}],"-1#2020768132":[{m:"Ne7-g6",e:5}],"1#-1576311960":[{m:"Ra1-c1",e:5}],"-1#-1048570397":[{m:"Rb8-b6",e:5}],"1#-707664393":[{m:"Rc1xc6",e:5}],"-1#1823523001":[{m:"Rb6xc6",e:5}],"1#-1132544892":[{m:"Qb3xd5",e:5}],"-1#58015668":[{m:"Qd8-d7",e:5}],"1#-1059702024":[{m:"f3xe4",e:5}],"-1#-1485116961":[{m:"f5xe4",e:5}],"1#-1483939865":[],"-1#-732226192":[{m:"c7-c6",e:8.333}],"1#-592131786":[{m:"e2-e4",e:8},{m:"h2-h3",e:8}],"-1#-1703786933":[{m:"d5xe4",e:5}],"1#-556544935":[{m:"Nb1-c3",e:5}],"-1#1869607247":[{m:"Ng8-f6",e:5}],"1#-387898306":[{m:"h2-h3",e:5}],"-1#-262069536":[],"-1#-1003171864":[{m:"h7-h5",e:8.333}],"1#-424732265":[{m:"g4-g5",e:7.5}],"-1#-799141170":[{m:"e7-e5",e:7.5},{m:"h5-h4",e:7.5}],"1#-1291587046":[{m:"d2-d4",e:5}],"-1#1327650938":[{m:"e5-e4",e:5}],"1#-758932075":[{m:"f2-f3",e:5}],"-1#1154306875":[{m:"f7-f5",e:5}],"1#-760753645":[{m:"g5xf6",e:5}],"-1#1427816456":[{m:"Ng8xf6",e:5}],"1#-1063001306":[],"1#1196015894":[{m:"e2-e4",e:5}],"-1#26168939":[{m:"d5xe4",e:5}],"1#1160692857":[{m:"Nb1-c3",e:5}],"-1#-191694481":[{m:"Qd8-a5",e:5}],"1#1620424312":[{m:"Nc3xe4",e:5}],"-1#1597152407":[{m:"Bc8-f5",e:5}],"1#833839768":[{m:"Ne4-c3",e:5}],"-1#1365196234":[{m:"e7-e6",e:5}],"1#111760415":[{m:"Bg2-e4",e:5}],"-1#-1467469899":[{m:"Nb8-d7",e:5}],"1#2071263754":[{m:"Qd1-e2",e:5}],"-1#-1137175978":[{m:"Bf8-b4",e:5}],"1#-801157911":[{m:"Be4xf5",e:5}],"-1#-1309002059":[{m:"Qa5xf5",e:5}],"1#1694776803":[{m:"Nc3-e4",e:5}],"-1#99115697":[{m:"O-O-O",e:5}],"1#-215335566":[{m:"a2-a3",e:5}],"-1#-459542869":[{m:"Bb4-f8",e:5}],"1#-2002997228":[{m:"d2-d3",e:5}],"-1#-1486954875":[{m:"Kc8-b8",e:5}],"1#1737856999":[{m:"Bc1-d2",e:5}],"-1#1258023042":[{m:"Ng8-e7",e:5}],"1#-1557102838":[{m:"Ng1-f3",e:5}],"-1#1538481891":[{m:"Ne7-g6",e:5}],"1#-2117450737":[{m:"O-O-O",e:5}],"-1#-677222275":[{m:"Nd7-b6",e:5}],"1#1901356800":[{m:"Ne4-c3",e:5}],"-1#297285714":[{m:"Bf8-c5",e:5}],"1#-243746239":[{m:"Rd1-g1",e:5}],"-1#-1111891891":[{m:"Nb6-d5",e:5}],"1#85403079":[{m:"Rg1-g4",e:5}],"-1#660846637":[],"-1#391233279":[{m:"e7-e5",e:9.905},{m:"Ng8-f6",e:9.905},{m:"c7-c6",e:9.905}],"1#1946967595":[{m:"a2-a3",e:9.737},{m:"Bc1-b2",e:9.737}],"-1#1673367026":[{m:"d7-d5",e:9.091},{m:"a7-a5",e:9.091},{m:"c7-c5",e:9.091}],"1#1129778433":[{m:"e2-e3",e:8.75}],"-1#-33636082":[{m:"Ng8-f6",e:7.5}],"1#2054165631":[{m:"Bc1-b2",e:7.5}],"-1#1849325166":[{m:"Bf8-d6",e:7.5},{m:"Qd8-d6",e:7.5}],"1#-1548822407":[{m:"c2-c4",e:6.667}],"-1#1760140616":[{m:"c7-c6",e:6.667}],"1#1611024654":[{m:"Ng1-f3",e:6.667}],"-1#-1736087321":[{m:"Qd8-e7",e:5}],"1#-726957265":[{m:"Nb1-c3",e:6.667}],"-1#1696054841":[{m:"d5-d4",e:5}],"1#-379838292":[{m:"Nc3-e2",e:5}],"-1#-1081834909":[{m:"Bc8-g4",e:5}],"1#-1913512858":[{m:"e3xd4",e:5}],"-1#1899447700":[{m:"Bg4xf3",e:5}],"1#545646529":[{m:"g2xf3",e:5}],"-1#-510509658":[{m:"e5xd4",e:5}],"1#211177927":[{m:"Bb2xd4",e:5}],"-1#-615268940":[{m:"a7-a5",e:5}],"1#-75329101":[{m:"c4-c5",e:5}],"-1#1445680778":[{m:"Bd6-e5",e:5}],"1#-1171194891":[{m:"Bd4xe5",e:5}],"-1#1728531458":[{m:"Qe7xe5",e:5}],"1#-1238827379":[{m:"d2-d4",e:5}],"-1#1242125549":[{m:"Qe5-e6",e:5}],"1#-1662596958":[{m:"b4xa5",e:5}],"-1#61842954":[{m:"O-O",e:5}],"1#-1481086093":[{m:"Qd1-d2",e:5}],"-1#-678089580":[{m:"Rf8-e8",e:5}],"1#-1861526956":[{m:"Ra1-b1",e:5}],"-1#1611672342":[{m:"Re8-e7",e:5}],"1#1444903674":[{m:"Rh1-g1",e:5}],"-1#624274762":[{m:"Nb8-d7",e:5}],"1#-154568459":[{m:"Rg1-g3",e:5}],"-1#-1718547101":[{m:"Nf6-h5",e:5}],"1#-253625744":[{m:"Rg3-g5",e:5}],"-1#2091715846":[{m:"h7-h6",e:5}],"1#697256502":[{m:"Rg5-g1",e:5}],"-1#-1159838623":[],"1#735122084":[{m:"d2-d3",e:6.667}],"-1#68385845":[{m:"Nb8-d7",e:6.667}],"1#-672159350":[{m:"Ng1-f3",e:6.667}],"-1#795641955":[{m:"c7-c6",e:6.667}],"1#662920229":[{m:"Bf1-e2",e:6.667}],"-1#-463390941":[{m:"g7-g6",e:6.667}],"1#-34637018":[{m:"c2-c4",e:6.667}],"-1#916995607":[{m:"Bf8-g7",e:6.667}],"1#947985957":[{m:"c4xd5",e:6.667}],"-1#-1349393943":[{m:"c6xd5",e:6.667}],"1#2016599943":[{m:"O-O",e:6.667}],"-1#1651457651":[{m:"O-O",e:6.667}],"1#-965151990":[{m:"Nb1-c3",e:6.667}],"-1#2009386524":[{m:"a7-a6",e:6.667}],"1#1256724271":[{m:"Ra1-c1",e:6.667}],"-1#694378916":[{m:"b7-b6",e:6.667}],"1#2112206518":[{m:"Qd1-c2",e:6.667}],"-1#-329428638":[{m:"Bc8-b7",e:6.667}],"1#2005951686":[{m:"h2-h3",e:6.667}],"-1#1863344664":[{m:"d5-d4",e:6.667}],"1#1226174137":[{m:"Nc3-e4",e:6.667},{m:"Nc3-d1",e:6.667}],"-1#704229867":[{m:"Bb7xe4",e:5}],"1#1192277408":[{m:"d3xe4",e:5}],"-1#-632240124":[{m:"d4xe3",e:5}],"1#668926946":[{m:"f2xe3",e:5}],"-1#2054942099":[{m:"b6-b5",e:5}],"1#154247629":[{m:"Rf1-d1",e:5}],"-1#1869510301":[{m:"Qd6-b6",e:5}],"1#-1069391214":[],"-1#-1744802344":[{m:"Ra8-c8",e:5}],"1#1880156276":[{m:"Qc2-b1",e:5}],"-1#-1803294937":[{m:"Nf6-d5",e:5}],"1#693822101":[{m:"Rf1-e1",e:5}],"-1#644764669":[{m:"d4xe3",e:5}],"1#-605972453":[{m:"f2xe3",e:5}],"-1#-2042268054":[{m:"b6-b5",e:5}],"1#-183551436":[{m:"Be2-f1",e:5}],"-1#921522482":[{m:"Nd7-b6",e:5}],"1#-1877254577":[{m:"Nf3-d2",e:5}],"1#1131192821":[{m:"Bc1-b2",e:5}],"-1#1462158308":[{m:"e5-e4",e:5}],"1#-892926453":[{m:"c2-c4",e:5}],"-1#25183034":[{m:"Ng8-f6",e:5}],"1#-2045864373":[{m:"Qd1-b3",e:5}],"-1#-223156859":[{m:"Nb8-a6",e:5}],"1#-1364636841":[{m:"b4xa5",e:5}],"-1#836773375":[{m:"Na6-c5",e:5}],"1#-1287786978":[{m:"Qb3-c2",e:5}],"-1#645723827":[{m:"d7-d6",e:5}],"1#1617936532":[{m:"e2-e3",e:5}],"-1#-557445989":[{m:"Bc8-f5",e:5}],"1#-1337462124":[{m:"Ng1-f3",e:5}],"-1#1220858749":[{m:"Bf5-d7",e:5}],"1#-2030504506":[{m:"Nf3-d4",e:5}],"-1#606566477":[{m:"Bd7-a4",e:5}],"1#1439687222":[{m:"Qc2-c3",e:5}],"-1#-1054997984":[{m:"Nf6-g4",e:5}],"1#-21603945":[],"1#684122768":[{m:"Bc1-b2",e:6.667}],"-1#1015840897":[{m:"e5-e4",e:6.667}],"1#-1586674322":[{m:"e2-e3",e:6.667}],"-1#532973921":[{m:"Ng8-f6",e:6.667}],"1#-1739957232":[{m:"b4xc5",e:6.667}],"-1#686772186":[{m:"Bf8xc5",e:6.667}],"1#2112043897":[{m:"Bb2xf6",e:6.667}],"-1#1153032446":[{m:"Qd8xf6",e:6.667}],"1#-773681110":[{m:"Nb1-c3",e:6.667}],"-1#1616817468":[{m:"Qf6-e5",e:6.667}],"1#1231014176":[{m:"Bf1-c4",e:6.667}],"-1#-248060572":[{m:"Nb8-c6",e:6.667}],"1#1235488312":[{m:"Ng1-e2",e:6.667}],"-1#-697637945":[{m:"b7-b6",e:6.667}],"1#-2098449195":[{m:"Ne2-f4",e:6.667},{m:"Bc4-d5",e:6.667}],"-1#131451788":[{m:"Nc6-a5",e:5}],"1#405106600":[{m:"Bc4-d5",e:5}],"-1#-964421827":[{m:"Bc8-b7",e:5}],"1#1565074073":[{m:"Qd1-h5",e:5}],"-1#-36557562":[],"-1#1548569664":[{m:"f7-f5",e:5}],"1#-903361176":[{m:"O-O",e:5}],"-1#-797299556":[{m:"Bc5-d6",e:5}],"1#-1922331601":[{m:"Ne2-g3",e:5}],"-1#-68056947":[{m:"Bc8-a6",e:5}],"1#999189454":[{m:"f2-f4",e:5}],"-1#1204602190":[{m:"Qe5-f6",e:5}],"1#1858969938":[{m:"Ng3-e2",e:5}],"-1#408397296":[{m:"Ra8-c8",e:5}],"1#-263774116":[{m:"g2-g4",e:5}],"-1#548719542":[{m:"Nc6-e7",e:5}],"1#-1325805997":[{m:"Bd5-b3",e:5}],"-1#-721641604":[{m:"Qf6-g6",e:5}],"1#-1532988007":[{m:"Rf1-f2",e:5}],"-1#-41867950":[{m:"f5xg4",e:5}],"1#807662003":[{m:"Ne2-g3",e:5}],"-1#1186592017":[{m:"Rc8xc3",e:5}],"1#1346215793":[{m:"d2xc3",e:5}],"-1#-2062134349":[{m:"Bd6-c5",e:5}],"1#-670567680":[{m:"Qd1-d2",e:5}],"-1#-1473596185":[],"-1#1615215674":[{m:"Bf8xb4",e:9.655}],"1#-943930130":[{m:"Bb2xe5",e:9.412}],"-1#635057587":[{m:"Ng8-f6",e:9.375}],"1#-1571495742":[{m:"Ng1-f3",e:9.375},{m:"c2-c4",e:9.375}],"-1#1524089131":[{m:"Nb8-c6",e:8.571}],"1#-498783625":[{m:"Be5-b2",e:7.5}],"-1#-476159912":[{m:"d7-d5",e:6.667}],"1#-1015750485":[{m:"g2-g3",e:6.667}],"-1#1759645858":[{m:"O-O",e:5}],"1#-856302117":[{m:"Bf1-g2",e:5}],"-1#-2087669618":[{m:"Rf8-e8",e:5}],"1#-988887474":[{m:"O-O",e:5}],"-1#-548198470":[{m:"Bc8-f5",e:5}],"1#-1311581771":[{m:"a2-a3",e:5}],"-1#-1503458708":[{m:"Bb4-c5",e:5}],"1#1524718199":[{m:"d2-d4",e:5}],"-1#-1497305065":[{m:"Bc5-f8",e:5}],"1#1174434308":[{m:"Nb1-d2",e:5}],"-1#-1778338471":[{m:"Nc6-a5",e:5}],"1#-1980755587":[{m:"Rf1-e1",e:5}],"-1#-2033934315":[{m:"h7-h6",e:5}],"1#-739842267":[{m:"c2-c4",e:5}],"-1#413245972":[{m:"d5xc4",e:5}],"1#1798585117":[{m:"Nf3-e5",e:5}],"-1#-276707065":[{m:"Bf5-e6",e:5}],"1#-1975535560":[{m:"Ra1-c1",e:5}],"-1#-374026573":[{m:"c7-c6",e:5}],"1#-514123019":[{m:"Nd2xc4",e:5}],"-1#-41983540":[{m:"Na5xc4",e:5}],"1#-1532736782":[{m:"Ne5xc4",e:5}],"-1#283855197":[{m:"Be6-d5",e:5}],"1#647180365":[{m:"f2-f3",e:5}],"-1#-1331822877":[{m:"Bd5xc4",e:5}],"1#252491911":[{m:"Rc1xc4",e:5}],"-1#204667463":[{m:"Re8-e3",e:5}],"1#-2074736816":[{m:"Bb2-c1",e:5}],"-1#-1877187263":[{m:"Nf6-d5",e:5}],"1#767910131":[],"-1#1762895347":[{m:"Nb8-c6",e:8.75},{m:"O-O",e:8.75}],"1#-780054865":[{m:"Be5-b2",e:6.667}],"-1#-799406976":[{m:"O-O",e:6.667}],"1#1951255033":[{m:"e2-e3",e:6.667}],"-1#-891025930":[{m:"d7-d5",e:5}],"1#-368147195":[{m:"Ng1-f3",e:5}],"-1#311272684":[{m:"Rf8-e8",e:5}],"1#1410585132":[{m:"c4xd5",e:7.5}],"-1#-1023201824":[{m:"Qd8xd5",e:7.5},{m:"Nf6xd5",e:7.5}],"1#-644394698":[{m:"Bf1-e2",e:5}],"-1#443890224":[{m:"Bc8-f5",e:5}],"1#1962198079":[{m:"a2-a3",e:5}],"-1#1665472486":[{m:"Bb4-a5",e:5}],"1#-569173055":[{m:"O-O",e:5}],"-1#-1001457099":[{m:"Ra8-d8",e:5}],"1#-728890283":[{m:"d2-d4",e:5}],"-1#682602037":[{m:"Nf6-e4",e:5}],"1#1667346198":[{m:"Qd1-c1",e:5}],"-1#-1892030388":[{m:"Qd5-d6",e:5}],"1#-176517827":[{m:"Rf1-d1",e:5}],"-1#-1826268563":[{m:"Bf5-e6",e:5}],"1#-157602990":[{m:"Nb1-d2",e:5}],"-1#647752719":[{m:"Be6-d5",e:5}],"1#283350303":[{m:"Nd2-c4",e:5}],"-1#-1120175815":[{m:"Qd6-h6",e:5}],"1#792305132":[{m:"Nf3-e5",e:5}],"-1#-1416859658":[{m:"Nc6xe5",e:5}],"1#-1161523199":[{m:"d4xe5",e:5}],"-1#1761922161":[{m:"Ba5-b6",e:5}],"1#2142728235":[{m:"Nc4xb6",e:5}],"-1#-1193291639":[{m:"c7xb6",e:5}],"1#1059256621":[{m:"Be2-f3",e:5}],"-1#-1625503604":[{m:"Qh6-g6",e:5}],"1#-466604721":[],"1#732158344":[{m:"Bf1-e2",e:6.667}],"-1#-398347634":[{m:"Bb4-d6",e:6.667}],"1#966250129":[{m:"O-O",e:5}],"-1#600452965":[{m:"Nc6-e5",e:5}],"1#-1598018439":[{m:"Nb1-c3",e:5}],"-1#293343599":[{m:"Nd5xc3",e:5}],"1#1909630419":[{m:"Bb2xc3",e:5}],"-1#-1337365005":[{m:"Bc8-f5",e:5}],"1#-557280260":[{m:"Nf3-d4",e:5}],"-1#2081889911":[{m:"Bf5-d3",e:5}],"1#-1737286894":[{m:"f2-f4",e:5}],"-1#-466504302":[{m:"Bd3xe2",e:5}],"1#857378119":[{m:"Qd1xe2",e:5}],"-1#-29895138":[{m:"Ne5-g6",e:5}],"1#27413917":[{m:"Ra1-b1",e:5}],"-1#-256295713":[{m:"Ra8-b8",e:5}],"1#-1367334324":[{m:"Qe2-f3",e:5}],"-1#438582028":[{m:"c7-c6",e:5}],"1#315354954":[{m:"Qf3-h5",e:5}],"-1#-1044901431":[{m:"Bd6-e7",e:5}],"1#-467938591":[{m:"f4-f5",e:5}],"-1#-1822044340":[{m:"Ng6-f8",e:5}],"1#-104190812":[{m:"Qh5-g4",e:5}],"-1#666931120":[],"1#-855349110":[{m:"e2-e3",e:8.333}],"-1#1940759685":[{m:"Rf8-e8",e:8.333},{m:"d7-d5",e:8.333}],"1#892588613":[{m:"Ng1-f3",e:6.667}],"-1#-844041300":[{m:"Bb4-f8",e:5}],"1#-1581798125":[{m:"Bf1-e2",e:5}],"-1#1649788437":[{m:"g7-g6",e:5}],"1#2077985296":[{m:"O-O",e:5}],"-1#1636199396":[{m:"Bf8-g7",e:5}],"1#1873759190":[{m:"Be5-b2",e:5}],"-1#1853096441":[{m:"c7-c5",e:5}],"1#621768347":[{m:"Nb1-c3",e:5}],"-1#-1800186995":[{m:"Nb8-c6",e:5}],"1#740407505":[{m:"Ra1-b1",e:5}],"-1#-583349869":[{m:"d7-d5",e:5}],"1#-36681376":[{m:"Nc3xd5",e:5}],"-1#-1260578992":[{m:"Nf6xd5",e:5}],"1#1514002783":[{m:"c4xd5",e:5}],"-1#379230333":[{m:"Qd8xd5",e:5}],"1#202302635":[{m:"Bb2xg7",e:5}],"-1#290242333":[{m:"Kg8xg7",e:5}],"1#-1692030941":[{m:"d2-d4",e:5}],"-1#1728315971":[{m:"c5xd4",e:5}],"1#1430019662":[{m:"Nf3xd4",e:5}],"-1#-1367743406":[{m:"Nc6xd4",e:5}],"1#-1727786252":[{m:"e3xd4",e:5}],"-1#-591602073":[{m:"Bc8-f5",e:5}],"1#-1304616856":[{m:"Be2-f3",e:5}],"-1#302191049":[{m:"Bf5-e4",e:5}],"1#-57671878":[{m:"Bf3xe4",e:5}],"-1#236648551":[{m:"Re8xe4",e:5}],"1#96111289":[{m:"Qd1-b3",e:5}],"-1#1896282487":[{m:"Qd5xb3",e:5}],"1#1397171318":[{m:"Ng1-f3",e:7.5}],"-1#-1413216865":[{m:"Rf8-e8",e:7.5},{m:"c7-c5",e:7.5},{m:"Bb4-e7",e:7.5}],"1#-312839329":[{m:"Be5-b2",e:5}],"-1#-327075472":[{m:"Rf8-e8",e:5}],"1#-524326147":[{m:"c4xd5",e:5}],"-1#2007995697":[{m:"Nf6xd5",e:5}],"1#-1626381991":[{m:"Bf1-e2",e:5}],"-1#1559038559":[{m:"Nb8-c6",e:5}],"1#-461381373":[{m:"Be5-b2",e:5}],"-1#-442193108":[{m:"Bc8-g4",e:5}],"1#-674089687":[{m:"O-O",e:5}],"-1#-846211875":[{m:"Qd8-e7",e:5}],"1#-2120138987":[{m:"Qd1-c2",e:5}],"1#804533791":[{m:"Be5-b2",e:5}],"-1#774863920":[{m:"c7-c5",e:5}],"1#1700008786":[{m:"Bf1-e2",e:5}],"-1#-1497991084":[{m:"Nb8-c6",e:5}],"1#505713416":[{m:"c4xd5",e:5}],"-1#-1993052988":[{m:"Nf6xd5",e:5}],"1#1637128364":[{m:"O-O",e:5}],"-1#2076801368":[{m:"Be7-f6",e:5}],"1#-1864406130":[{m:"Ng1-f3",e:9.333},{m:"Bc1-b2",e:9.333}],"-1#1750878823":[{m:"e7-e6",e:9.167},{m:"g7-g6",e:9.167}],"1#1068114866":[{m:"a2-a3",e:8}],"-1#672919659":[{m:"b7-b6",e:8},{m:"a7-a5",e:8}],"1#2090674041":[{m:"c2-c4",e:6.667}],"-1#-1210424760":[{m:"c7-c5",e:5}],"1#-56554198":[{m:"b4-b5",e:5}],"-1#-475576357":[{m:"a7-a6",e:5}],"1#-561275160":[{m:"d2-d3",e:5}],"-1#-246812551":[{m:"d7-d5",e:5}],"1#-777817974":[{m:"Nb1-d2",e:5}],"-1#27506647":[{m:"Bc8-b7",e:5}],"1#-1704033677":[{m:"Bc1-b2",e:5}],"-1#-1910185886":[{m:"a6xb5",e:5}],"1#-977581108":[{m:"c4xb5",e:5}],"-1#2124709048":[{m:"Nb8-d7",e:5}],"1#-1386698489":[{m:"g2-g3",e:5}],"-1#114186510":[{m:"Bf8-e7",e:5}],"1#-1631799162":[{m:"Bf1-g2",e:5}],"-1#-774253101":[{m:"O-O",e:5}],"1#1976441002":[{m:"O-O",e:5}],"-1#1871968606":[{m:"Nf6-e8",e:5}],"1#-996823157":[{m:"e2-e3",e:5}],"-1#2050777988":[{m:"Ne8-d6",e:5}],"1#-1993890187":[{m:"a3-a4",e:5}],"-1#816043786":[{m:"Be7-f6",e:5}],"1#908248477":[{m:"d3-d4",e:5}],"-1#-1786475045":[{m:"Rf8-e8",e:5}],"1#-753206501":[{m:"Nf3-e5",e:5}],"-1#1471088897":[{m:"Bf6xe5",e:5}],"1#181700906":[{m:"d4xe5",e:5}],"-1#1964506784":[{m:"Nd6-f5",e:5}],"1#598544375":[{m:"Qd1-h5",e:5}],"-1#-2093612952":[{m:"Ra8-a7",e:5}],"1#574273271":[{m:"Nd2-f3",e:5}],"-1#245949982":[{m:"Qd8-e7",e:5}],"1#1116081622":[{m:"g3-g4",e:5}],"-1#1235655298":[{m:"Nf5-h6",e:5}],"1#1209533407":[],"1#147512428":[{m:"b4-b5",e:5}],"-1#399283869":[{m:"d7-d5",e:5}],"1#925242990":[{m:"e2-e3",e:5}],"-1#-1987061151":[{m:"c7-c5",e:5}],"1#-1024150269":[{m:"c2-c4",e:5}],"-1#162787378":[{m:"Nb8-d7",e:5}],"1#-632347251":[{m:"d2-d3",e:5}],"-1#-175289572":[{m:"Bf8-d6",e:5}],"1#941221131":[{m:"Nb1-d2",e:5}],"-1#-401005994":[{m:"O-O",e:5}],"1#1276047151":[{m:"Bc1-b2",e:5}],"-1#1480887614":[{m:"b7-b6",e:5}],"1#214063660":[{m:"g2-g3",e:5}],"-1#-1487623643":[{m:"Bc8-b7",e:5}],"1#1016700801":[{m:"Bf1-g2",e:5}],"-1#1945957076":[{m:"Qd8-e7",e:5}],"1#1070733596":[{m:"O-O",e:5}],"-1#630192360":[{m:"Ra8-d8",e:5}],"1#894371464":[{m:"Rf1-e1",e:5}],"-1#981186528":[{m:"Nf6-g4",e:5}],"1#97774679":[{m:"Qd1-c2",e:5}],"-1#-1804924029":[{m:"f7-f5",e:5}],"1#33655467":[{m:"Ra1-d1",e:5}],"-1#413772968":[{m:"Bd6-b8",e:5}],"1#2080263880":[{m:"Qc2-b3",e:5}],"-1#-289450395":[{m:"Kg8-h8",e:5}],"1#894849490":[{m:"h2-h3",e:5}],"-1#769021708":[{m:"Ng4-f6",e:5}],"1#310250683":[{m:"a3-a4",e:5}],"-1#-1409647164":[{m:"e6-e5",e:5}],"1#-283871118":[{m:"c4xd5",e:5}],"-1#2013562814":[{m:"Bb7xd5",e:5}],"1#-72205993":[{m:"Nd2-c4",e:5}],"-1#1449842033":[{m:"Bb8-c7",e:5}],"1#-643183295":[],"1#1909589602":[{m:"a2-a3",e:8.333}],"-1#1717818811":[{m:"Bf8-g7",e:6.667},{m:"d7-d5",e:6.667}],"1#1749742985":[{m:"Bc1-b2",e:5}],"-1#2080413592":[{m:"O-O",e:5}],"1#-669558047":[{m:"c2-c4",e:5}],"-1#324018128":[{m:"d7-d6",e:5}],"1#1430465015":[{m:"d2-d3",e:5}],"-1#2055292774":[{m:"e7-e5",e:5}],"1#433891250":[{m:"Nb1-d2",e:5}],"-1#-908304145":[{m:"Qd8-e7",e:5}],"1#-2047702233":[{m:"g2-g3",e:5}],"-1#778337070":[{m:"c7-c6",e:5}],"1#646688616":[{m:"Bf1-g2",e:5}],"-1#1777254973":[{m:"Nf6-h5",e:5}],"1#10368302":[{m:"O-O",e:5}],"-1#449041626":[{m:"f7-f5",e:5}],"1#-1935059470":[{m:"e2-e4",e:5}],"-1#-898639217":[{m:"f5-f4",e:5}],"1#-1801008149":[{m:"d3-d4",e:5}],"-1#922780589":[{m:"c6-c5",e:5}],"1#80852030":[{m:"d4xe5",e:5}],"-1#2121353587":[{m:"d6xe5",e:5}],"1#-1560266313":[{m:"b4xc5",e:5}],"-1#329591421":[{m:"Nb8-c6",e:5}],"1#-1422409439":[{m:"Nd2-b3",e:5}],"-1#468663377":[{m:"Bc8-e6",e:5}],"1#1620393942":[{m:"Qd1-c2",e:5}],"-1#-248653822":[{m:"g6-g5",e:5}],"1#1639896592":[{m:"Rf1-d1",e:5}],"-1#132186432":[{m:"g5-g4",e:5}],"1#640969310":[{m:"Nf3-e1",e:5}],"-1#-1016742614":[{m:"f4-f3",e:5}],"1#1274661951":[{m:"Bg2-f1",e:5}],"-1#77373802":[{m:"Nh5-f6",e:5}],"1#1844205177":[{m:"Rd1-d6",e:5}],"-1#1648217516":[{m:"Be6-f7",e:5}],"1#-1791231862":[],"1#1183405384":[{m:"Bc1-b2",e:5}],"-1#1388525401":[],"-1#-2070607457":[{m:"e7-e6",e:9.286}],"1#-748462006":[{m:"b4-b5",e:9.333}],"-1#-865785157":[{m:"Bf8-e7",e:9}],"1#1410845491":[{m:"Ng1-f3",e:8}],"-1#-1399526694":[{m:"O-O",e:6.667}],"1#142813091":[{m:"e2-e3",e:6.667}],"-1#-1238701140":[{m:"b7-b6",e:8}],"1#-492028738":[{m:"Bf1-e2",e:6.667},{m:"d2-d4",e:6.667}],"-1#558782392":[{m:"Bc8-b7",e:5}],"1#-1165794788":[{m:"O-O",e:5}],"-1#-1596029976":[{m:"d7-d5",e:5}],"1#-2144074981":[{m:"d2-d3",e:5}],"-1#-1342804598":[{m:"c7-c5",e:5}],"1#-460520728":[{m:"Nb1-d2",e:5}],"-1#881706421":[{m:"Nb8-d7",e:5}],"1#-412020726":[{m:"c2-c4",e:5}],"-1#741758267":[{m:"Be7-d6",e:5}],"1#160798227":[{m:"Rf1-e1",e:5}],"-1#111224699":[{m:"Qd8-c7",e:5}],"1#1236851279":[{m:"Be2-f1",e:5}],"-1#-1973767863":[{m:"d5xc4",e:5}],"1#-103864256":[{m:"Nd2xc4",e:5}],"-1#-437562503":[{m:"Bb7xf3",e:5}],"1#501373581":[{m:"g2xf3",e:5}],"-1#-587890454":[{m:"Bd6xh2+",e:5}],"1#-2108883336":[{m:"Kg1-h1",e:5}],"-1#1238634812":[{m:"Bh2-e5",e:5}],"1#-1321463528":[{m:"Nc4xe5",e:5}],"-1#-2001548045":[{m:"Nd7xe5",e:5}],"1#375585225":[{m:"f3-f4",e:5}],"-1#401635435":[{m:"Ne5-g6",e:5}],"1#-395975704":[{m:"Qd1-f3",e:5}],"-1#-339173821":[{m:"Ra8-d8",e:5}],"1#-83337181":[{m:"Bf1-e2",e:5}],"-1#954862373":[{m:"Rd8-d5",e:5}],"1#-14553249":[{m:"Qf3-h3",e:5}],"-1#930001919":[{m:"Rf8-d8",e:5}],"1#-1240945570":[],"-1#512595678":[{m:"Bc8-b7",e:5}],"1#-2059361414":[{m:"Bf1-d3",e:5}],"-1#-1311502880":[{m:"c7-c5",e:5}],"1#-89169278":[{m:"O-O",e:5}],"-1#-520977546":[{m:"d7-d6",e:5}],"1#-1495157423":[{m:"d4xc5",e:5}],"-1#-1741453600":[{m:"b6xc5",e:5}],"1#1104168002":[{m:"c2-c4",e:5}],"-1#-1969815181":[{m:"Nb8-d7",e:5}],"1#1500239052":[{m:"Nb1-d2",e:5}],"-1#-1989471343":[{m:"d6-d5",e:5}],"1#-1613288974":[{m:"a2-a4",e:5}],"-1#1101465571":[{m:"Qd8-c7",e:5}],"1#247397079":[{m:"Qd1-c2",e:5}],"-1#-1626989309":[{m:"Be7-d6",e:5}],"1#-1163534805":[{m:"h2-h3",e:5}],"-1#-1574577931":[{m:"Ra8-c8",e:5}],"1#1245011289":[{m:"Rf1-d1",e:5}],"-1#745179657":[{m:"Nd7-e5",e:5}],"1#-1005668362":[{m:"Nf3xe5",e:5}],"-1#174481315":[{m:"Bd6xe5",e:5}],"1#1950289463":[{m:"Nd2-f3",e:5}],"-1#1487757022":[{m:"Be5xb2",e:5}],"1#1294921132":[{m:"Qc2xb2",e:5}],"-1#-1578377405":[{m:"d5-d4",e:5}],"1#765477334":[{m:"e3xd4",e:5}],"-1#-781903836":[{m:"Bb7xf3",e:5}],"1#389367669":[{m:"g2xf3",e:5}],"-1#-702374638":[{m:"Qc7-f4",e:5}],"1#-2046277564":[{m:"Bd3-e2",e:5}],"-1#20644207":[{m:"Qf4-h4",e:5}],"1#-1196225188":[{m:"d4xc5",e:5}],"-1#1272847974":[{m:"Rc8xc5",e:5}],"1#-1313272487":[{m:"Qb2-d4",e:5}],"-1#-1061620573":[{m:"Qh4-g5+",e:5}],"1#894977018":[{m:"Kg1-h2",e:5}],"-1#832872273":[],"1#532572857":[{m:"Bc1-b2",e:9.333}],"-1#200542376":[{m:"Qd8-b6",e:8.571},{m:"d7-d5",e:8.571}],"1#-1854475046":[{m:"a2-a3",e:6.667}],"-1#-2033768701":[{m:"a7-a5",e:6.667}],"1#-1508504828":[{m:"c2-c4",e:6.667}],"-1#1834044981":[{m:"d7-d6",e:6.667}],"1#725776402":[{m:"Nb1-c3",e:5}],"-1#-1694612220":[{m:"Ng8-f6",e:5}],"1#493916277":[{m:"b4-b5",e:5}],"-1#41343620":[{m:"g7-g6",e:5}],"1#469276289":[{m:"Ra1-b1",e:5}],"-1#-354162749":[{m:"Qb6-d8",e:5}],"1#1885412273":[{m:"g2-g3",e:5}],"-1#-604509256":[{m:"Bf8-g7",e:5}],"1#-706819190":[{m:"Bf1-g2",e:5}],"-1#-1698978081":[{m:"O-O",e:5}],"1#1051487142":[{m:"Ng1-f3",e:5}],"-1#-969979313":[{m:"d6-d5",e:5}],"1#-795643860":[{m:"b5xc6",e:5}],"-1#-2100702162":[{m:"b7xc6",e:5}],"1#-1448146532":[{m:"O-O",e:5}],"-1#-1275926424":[{m:"Bc8-a6",e:5}],"1#1938623275":[{m:"c4xd5",e:5}],"-1#-459410201":[{m:"c6xd5",e:5}],"1#141214261":[{m:"d2-d3",e:5}],"-1#665365668":[{m:"Nb8-c6",e:5}],"1#-1623570440":[{m:"Qd1-a4",e:5}],"-1#1575440813":[{m:"Ra8-c8",e:5}],"1#-1242049535":[{m:"Rf1-c1",e:5}],"-1#501883052":[{m:"e7-e6",e:5}],"1#1243367801":[{m:"Nc3-d1",e:5}],"-1#-1693857256":[{m:"Qd8-d7",e:5}],"1#1487589204":[{m:"Bb2-c3",e:5}],"-1#941398187":[{
m:"h7-h6",e:5}],"1#1832837019":[{m:"Bc3xa5",e:5}],"-1#-1838061296":[{m:"Nc6xa5",e:5}],"1#521272911":[{m:"Qa4xa5",e:5}],"-1#-1756813526":[{m:"Rc8xc1",e:5}],"1#389047220":[],"1#723421275":[{m:"e2-e3",e:6.667}],"-1#-1783151532":[{m:"Qd8-b6",e:8.75}],"1#255178790":[{m:"a2-a3",e:6.667}],"-1#411331583":[{m:"a7-a5",e:6.667}],"1#945113080":[{m:"Bb2-d4",e:6.667}],"-1#1914832674":[{m:"Qb6-c7",e:5}],"1#-671315245":[{m:"f2-f4",e:5}],"-1#-1413602221":[{m:"a5xb4",e:5}],"1#1131299318":[{m:"a3xb4",e:5}],"-1#-1852805395":[{m:"Ra8xa1",e:5}],"1#-1960125275":[{m:"Bd4xa1",e:5}],"-1#2082284169":[{m:"Nb8-d7",e:5}],"1#-1344145610":[{m:"Ng1-f3",e:5}],"-1#1466095327":[{m:"Ng8-f6",e:5}],"1#-789838930":[{m:"Qd1-c1",e:5}],"-1#1018447092":[{m:"e7-e6",e:5}],"1#1799499041":[{m:"Qc1-b2",e:5}],"-1#272451965":[{m:"b7-b5",e:5}],"1#1203003014":[{m:"Bf1-e2",e:5}],"-1#-2074724992":[{m:"Bf8-e7",e:5}],"1#472175624":[{m:"Nb1-c3",e:5}],"-1#-1382487778":[{m:"O-O",e:5}],"1#160375911":[{m:"Nc3-d1",e:5}],"-1#-660953338":[{m:"Qc7-a7",e:5}],"1#487375183":[{m:"Qb2-b1",e:5}],"-1#-1891268999":[{m:"Bc8-b7",e:5}],"1#344503261":[{m:"Ba1-d4",e:5}],"-1#-1345809065":[{m:"Qa7-a3",e:5}],"1#-89673299":[{m:"c2-c3",e:5}],"-1#348418324":[{m:"Nf6-e4",e:5}],"1#1594519607":[{m:"O-O",e:5}],"-1#1163366851":[{m:"f7-f5",e:5}],"1#-750972693":[{m:"Nd1-f2",e:5}],"-1#-140441809":[{m:"Rf8-a8",e:5}],"1#2036333610":[{m:"Nf2xe4",e:5}],"-1#-831822226":[{m:"f5xe4",e:5}],"1#-1875757235":[],"-1#-1062081739":[{m:"c7-c5",e:9.988},{m:"e7-e5",e:9.988},{m:"g7-g6",e:9.988},{m:"d7-d5",e:9.988}],"1#-1949662121":[{m:"Bf1-g2",e:9.882}],"-1#-995104510":[{m:"e7-e5",e:9.867},{m:"g7-g6",e:9.867}],"1#-1477309994":[{m:"c2-c4",e:5}],"-1#1823821031":[{m:"Nb8-c6",e:7.5}],"1#-735598661":[{m:"Nb1-c3",e:8}],"-1#1704696493":[{m:"g7-g6",e:9.091},{m:"f7-f5",e:9.091},{m:"d7-d6",e:9.091}],"1#2081805992":[{m:"d2-d3",e:8}],"-1#1406646329":[{m:"Bf8-g7",e:5}],"1#1576966155":[{m:"a2-a3",e:8},{m:"e2-e3",e:8}],"-1#1246710738":[{m:"Ng8-e7",e:5}],"1#-1551573926":[{m:"Ra1-b1",e:5}],"-1#1386196248":[{m:"a7-a5",e:5}],"1#1917747487":[{m:"e2-e3",e:5}],"-1#-857256688":[{m:"O-O",e:5}],"1#1760591977":[{m:"Ng1-e2",e:5}],"-1#-146903658":[{m:"d7-d6",e:5}],"1#-1322427471":[{m:"O-O",e:9.091},{m:"Nc3-d5",e:9.091},{m:"Bc1-d2",e:9.091}],"-1#-1418675643":[{m:"Bc8-e6",e:9.286},{m:"Ra8-b8",e:9.286}],"1#-804603454":[{m:"Nc3-d5",e:7.5}],"-1#-1762259906":[{m:"Ra8-b8",e:7.5}],"1#-179723050":[{m:"Qd1-a4",e:9.167},{m:"f2-f4",e:9.167}],"-1#-137236915":[{m:"Ne7xd5",e:5}],"1#2004116155":[{m:"c4xd5",e:5}],"-1#1003692953":[{m:"Nc6-e7",e:5}],"1#-1415698820":[{m:"b2-b4",e:5}],"-1#-672627777":[{m:"a5xb4",e:5}],"1#1060693530":[{m:"a3xb4",e:5}],"-1#-305739519":[{m:"b7-b6",e:5}],"-1#-1673321260":[{m:"Ra8-b8",e:8}],"1#-1032177081":[{m:"O-O",e:8}],"-1#-668476493":[{m:"Bc8-e6",e:8.75}],"1#-1554130892":[{m:"e3-e4",e:8.75},{m:"Qd1-b3",e:8.75}],"-1#-673076230":[{m:"Nc6-a7",e:5}],"-1#-480816124":[{m:"Ng8-e7",e:6.667}],"1#178045836":[{m:"Ng1-e2",e:6.667}],"-1#-1789776269":[{m:"d7-d6",e:9.5},{m:"O-O",e:9.5}],"1#-750708652":[{m:"O-O",e:9.444},{m:"Ra1-b1",e:9.444},{m:"a2-a3",e:9.444}],"-1#-920847968":[{m:"d7-d6",e:8.75}],"1#1829450969":[{m:"Ra1-b1",e:8.889},{m:"a2-a3",e:8.889}],"-1#-1676655205":[{m:"Bc8-e6",e:5}],"1#-412465636":[{m:"Nc3-d5",e:5}],"-1#-1583942688":[{m:"Ra8-b8",e:8}],"1#-5247629":[{m:"Ne2-c3",e:8}],"-1#1114885273":[{m:"a7-a6",e:8}],"1#2136937898":[{m:"b2-b3",e:8}],"-1#2059069184":[{m:"a7-a5",e:9},{m:"Bc8-e6",e:9}],"1#1517013767":[{m:"b2-b3",e:7.5}],"1#29418631":[{m:"Nc3-d5",e:7.5}],"-1#1195135355":[{m:"Qd8-d7",e:7.5}],"-1#576350486":[{m:"Bc8-e6",e:7.5}],"1#1495296657":[{m:"Nc3-d5",e:7.5}],"-1#534568813":[{m:"O-O",e:7.5}],"1#-1144319468":[{m:"Nc3-d5",e:5}],"-1#-990852211":[{m:"Bc8-e6",e:9.231},{m:"O-O",e:9.231}],"1#1625753332":[{m:"a2-a3",e:8.889}],"1#826663690":[{m:"O-O",e:7.5}],"-1#722993918":[{m:"d7-d6",e:8.75}],"1#-202302587":[{m:"e2-e3",e:5}],"-1#1297667978":[{m:"Ng8-f6",e:5}],"1#-891944197":[{m:"Ng1-e2",e:5}],"-1#1427697412":[{m:"Bf8-e7",e:5}],"1#-848687476":[{m:"d2-d4",e:5}],"-1#827041004":[{m:"d7-d6",e:5}],"1#2002293451":[{m:"d4xc5",e:5}],"-1#1233822074":[{m:"d6xc5",e:5}],"1#-457974637":[{m:"Bg2xc6+",e:5}],"-1#-1404177915":[{m:"b7xc6",e:5}],"1#1456343416":[{m:"Qd1xd8+",e:5}],"-1#1790487273":[{m:"Ke8xd8",e:5}],"1#2146953873":[{m:"b2-b3",e:5}],"-1#1399848234":[{m:"e5-e4",e:5}],"1#-829540155":[{m:"Nc3-a4",e:5}],"-1#-216125175":[{m:"Bc8-e6",e:5}],"1#-2006699378":[{m:"Bc1-b2",e:5}],"-1#-1674686305":[{m:"Kd8-e8",e:5}],"1#2080497128":[{m:"Ne2-f4",e:5}],"-1#-113761615":[{m:"Be6-f7",e:5}],"1#238950295":[{m:"h2-h4",e:5}],"-1#-1246159077":[{m:"Rh8-g8",e:5}],"1#-2027189134":[{m:"Bb2xf6",e:5}],"-1#-1099868171":[{m:"Be7xf6",e:5}],"1#-2122893768":[{m:"Ra1-d1",e:5}],"-1#-1679880133":[{m:"Bf6-e7",e:5}],"1#-1654783316":[{m:"f2-f3",e:5}],"-1#189844482":[{m:"e4xf3",e:5}],"1#1292272770":[{m:"Ke1-f2",e:5}],"-1#-2142108341":[{m:"Ra8-d8",e:5}],"1#-1869415637":[{m:"Nf4-d3",e:5}],"-1#1153231177":[{m:"h7-h6",e:5}],"1#295612025":[],"1#596159626":[{m:"a2-a3",e:8.333}],"-1#876183379":[{m:"g7-g6",e:8.333},{m:"a7-a5",e:8.333}],"1#766980950":[{m:"b2-b4",e:8}],"-1#1371641493":[{m:"Bf8-g7",e:8},{m:"c5xb4",e:8}],"1#1609086631":[{m:"Ra1-b1",e:9.286}],"-1#-1359755291":[{m:"Ng8-e7",e:9.333}],"1#1194872941":[{m:"e2-e3",e:9.375},{m:"Ng1-f3",e:9.375},{m:"d2-d3",e:9.375}],"-1#-107897758":[{m:"O-O",e:8.571},{m:"a7-a6",e:8.571}],"-1#-1078234748":[{m:"O-O",e:5}],"1#464305405":[{m:"O-O",e:5}],"-1#32595209":[{m:"h7-h6",e:8.75}],"-1#1761230588":[{m:"O-O",e:8.889}],"1#-856820859":[{m:"b4xc5",e:8.889},{m:"e2-e3",e:8.889}],"1#1776528900":[{m:"a3xb4",e:5}],"-1#-1324009009":[{m:"Nc6xb4",e:5}],"1#1261415900":[{m:"Qd1-a4+",e:5}],"-1#-1980580983":[{m:"Nb4-c6",e:5}],"1#-1735876755":[{m:"Bg2xc6+",e:5}],"-1#-797527557":[{m:"b7xc6",e:5}],"1#720718470":[{m:"Qa4xc6+",e:5}],"-1#213215187":[{m:"Bc8-d7",e:5}],"1#-598920240":[{m:"Qc6-b7",e:5}],"-1#-839647059":[{m:"Ra8-c8",e:5}],"1#635733249":[{m:"Ra1xa7",e:5}],"-1#670981584":[{m:"Rc8xc4",e:5}],"1#137176240":[{m:"Ng1-f3",e:5}],"-1#-257030823":[],"1#350770004":[],"1#-584997625":[{m:"c2-c3",e:9.565},{m:"e2-e4",e:9.565}],"-1#859989438":[{m:"Bf8-g7",e:6.667}],"1#1030440332":[{m:"d2-d4",e:6.667}],"-1#-1052053524":[{m:"Qd8-c7",e:9.231},{m:"c5xd4",e:9.231},{m:"d7-d6",e:9.231},{m:"Qd8-a5",e:9.231}],"1#-1907158312":[{m:"Nb1-a3",e:5}],"-1#-1072164233":[{m:"Ng8-f6",e:5}],"1#1201063686":[{m:"e2-e4",e:5}],"-1#22038651":[{m:"d7-d6",e:5}],"1#1195605596":[{m:"Ng1-e2",e:5}],"-1#-661810269":[{m:"O-O",e:5}],"1#2090491610":[{m:"O-O",e:5}],"-1#1724366638":[{m:"Nb8-c6",e:5}],"1#-564833166":[{m:"d4-d5",e:5}],"-1#612672760":[{m:"Nc6-e5",e:5}],"1#-1483823132":[{m:"f2-f4",e:5}],"-1#-607385244":[{m:"Ne5-d7",e:5}],"1#866661531":[{m:"c3-c4",e:5}],"-1#1724464548":[{m:"a7-a6",e:5}],"1#1541792919":[{m:"Ne2-c3",e:5}],"-1#-432421507":[{m:"Ra8-b8",e:5}],"1#-1207903250":[{m:"Rf1-e1",e:5}],"-1#-1221301626":[{m:"b7-b5",e:5}],"1#-524452483":[{m:"c4xb5",e:5}],"-1#-516938203":[{m:"c5-c4",e:5}],"1#-38794055":[{m:"e4-e5",e:5}],"-1#743133230":[{m:"d6xe5",e:5}],"1#2025097757":[{m:"f4xe5",e:5}],"1#-210586655":[{m:"c3xd4",e:7.5}],"-1#-193902203":[{m:"Qd8-b6",e:7.5}],"1#1861465591":[{m:"Ng1-f3",e:5}],"-1#-1771006946":[{m:"Nb8-c6",e:5}],"1#786595650":[{m:"d4-d5",e:8.333},{m:"e2-e3",e:8.333},{m:"Nb1-c3",e:8.333}],"-1#-1107578994":[{m:"Nc6-d4",e:5}],"1#1051646546":[{m:"O-O",e:5}],"-1#619920294":[{m:"Nd4xf3+",e:5}],"1#1863059601":[{m:"e2xf3",e:5}],"-1#1559482148":[{m:"Bg7xb2",e:5}],"1#2134620710":[{m:"Bc1xb2",e:5}],"-1#-1874087091":[{m:"Qb6-a6",e:7.5}],"1#-1545494323":[{m:"Nb1-c3",e:6.667}],"-1#308125147":[{m:"Ng8-f6",e:6.667}],"1#-1781315414":[{m:"Bg2-f1",e:6.667}],"-1#-625596929":[{m:"Qa6-a5",e:5}],"-1#-1621212588":[{m:"Nc6xd4",e:5}],"1#-1439786455":[{m:"Nf3xd4",e:5}],"-1#1114864429":[{m:"Qb6xd4",e:5}],"1#-470239743":[{m:"Qd1-b3",e:5}],"-1#-1757100593":[{m:"Ng8-f6",e:5}],"1#-2024154677":[{m:"d4xc5",e:5}],"-1#-1182012806":[{m:"d6xc5",e:5}],"1#347248531":[{m:"Qd1xd8+",e:5}],"-1#683947010":[{m:"Ke8xd8",e:5}],"1#1032549498":[{m:"e2-e4",e:5}],"-1#2068708103":[{m:"Nb8-c6",e:5}],"1#-1008791461":[{m:"Ng1-e2",e:5}],"-1#1544682916":[{m:"b7-b6",e:5}],"1#144124598":[{m:"O-O",e:5}],"-1#315280194":[{m:"Bc8-a6",e:5}],"1#-759879679":[{m:"Rf1-d1+",e:5}],"-1#-1259667631":[{m:"Kd8-c7",e:5}],"1#-92460913":[{m:"Ne2-f4",e:5}],"-1#2135218134":[{m:"e7-e6",e:5}],"1#682802691":[{m:"a2-a4",e:5}],"-1#-155021294":[{m:"Ng8-f6",e:5}],"1#1900823907":[{m:"Nb1-a3",e:5}],"-1#1057441228":[{m:"Ra8-d8",e:5}],"1#801618860":[{m:"Rd1-e1",e:5}],"-1#921260323":[{m:"Ba6-b7",e:5}],"1#488508275":[{m:"Na3-b5+",e:5}],"-1#2058762833":[{m:"Kc7-b8",e:5}],"1#-221804487":[{m:"Nf4-d5",e:5}],"1#1431150843":[{m:"d4xc5",e:8.333},{m:"Ng1-f3",e:8.333}],"-1#1805620042":[{m:"Qa5xc5",e:6.667}],"1#-149572348":[{m:"Bc1-e3",e:6.667}],"-1#-1266487103":[{m:"Qc5-c7",e:6.667}],"1#-1503249273":[{m:"Qd1-d2",e:6.667},{m:"Ng1-f3",e:6.667}],"-1#-699696288":[{m:"Nb8-c6",e:5}],"1#1859751996":[{m:"Nb1-a3",e:5}],"-1#1592073582":[{m:"Ng8-f6",e:5}],"1#-647247841":[{m:"Nb1-a3",e:5}],"-1#-1759459152":[{m:"Nb8-c6",e:5}],"-1#-1378975470":[{m:"c5xd4",e:6.667}],"1#-1611211489":[{m:"Nf3xd4",e:6.667}],"-1#1689478915":[{m:"Ng8-f6",e:6.667}],"1#-482495886":[{m:"O-O",e:5}],"-1#-111127674":[{m:"O-O",e:5}],"1#1568120575":[{m:"Nb1-d2",e:5}],"-1#-1921558110":[{m:"Nb8-c6",e:5}],"1#904246014":[{m:"Nd2-b3",e:5}],"-1#-2059579506":[{m:"Qa5-a6",e:5}],"1#-1206718613":[{m:"a2-a4",e:5}],"1#-1544811551":[{m:"Bf1-g2",e:9.909}],"-1#-326539596":[{m:"f7-f5",e:9.853},{m:"Nb8-c6",e:9.853},{m:"Ng8-f6",e:9.853},{m:"e7-e5",e:9.963}],"1#2061756316":[{m:"d2-d4",e:5}],"-1#-2034086404":[{m:"e5xd4",e:5}],"1#767491611":[{m:"Qd1xd4",e:5}],"-1#1445627982":[{m:"Nb8-c6",e:5}],"1#-289905902":[{m:"Qd4-d1",e:5}],"-1#144620014":[{m:"Ng8-f6",e:5}],"1#-1894749025":[{m:"c2-c4",e:5}],"-1#1146562990":[{m:"Bf8-b4+",e:8.333},{m:"Nc6-e5",e:8.333}],"1#676362001":[{m:"Bc1-d2",e:8}],"-1#87951476":[{m:"Bb4xd2+",e:7.5},{m:"Qd8-e7",e:7.5},{m:"Bb4-c5",e:7.5}],"1#-963764820":[{m:"Nb1xd2",e:5}],"-1#772687474":[{m:"d7-d5",e:5}],"1#249874049":[{m:"Ng1-h3",e:5}],"-1#-203613151":[{m:"O-O",e:5}],"1#1472909656":[{m:"Nh3-f4",e:5}],"-1#-1341908642":[],"1#1225843644":[{m:"a2-a3",e:5}],"-1#1587621989":[{m:"Bb4xd2+",e:5}],"1#-1659820611":[{m:"Nb1xd2",e:5}],"-1#1972469347":[{m:"O-O",e:5}],"1#-779701478":[{m:"Ng1-f3",e:5}],"-1#688231155":[{m:"f5-f4",e:5}],"1#2009891735":[{m:"O-O",e:5}],"-1#1838244451":[{m:"f4xg3",e:5}],"1#1237733532":[{m:"h2xg3",e:5}],"-1#-1141877508":[{m:"d7-d6",e:5}],"1#-35429669":[{m:"Nd2-b3",e:5}],"-1#1295753131":[{m:"Qe7-f7",e:5}],"1#1256630780":[{m:"Ra1-c1",e:5}],"-1#695066487":[{m:"Qf7-h5",e:5}],"1#43670584":[{m:"Nb3-d4",e:5}],"-1#-1816555996":[{m:"Bc8-h3",e:5}],"1#-105097105":[],"1#-950195534":[{m:"Qd1-c2",e:5}],"-1#1457900902":[{m:"Bf8-c5",e:5}],"1#-1239068811":[{m:"Ng1-f3",e:5}],"-1#1319530140":[{m:"d7-d6",e:5}],"1#146102459":[{m:"O-O",e:5}],"-1#317241679":[{m:"O-O",e:5}],"1#-1224772554":[{m:"Nb1-c3",e:5}],"-1#121850144":[{m:"c7-c6",e:5}],"1#262970726":[],"1#1411091944":[{m:"c2-c4",e:9.375},{m:"d2-d3",e:9.375},{m:"e2-e4",e:9.375}],"-1#-1621309223":[],"-1#2077877113":[{m:"g7-g6",e:8}],"1#1649913724":[{m:"Ng1-f3",e:7.5},{m:"e2-e4",e:7.5}],"-1#-1697345899":[{m:"Bf8-g7",e:6.667}],"1#-1795314009":[{m:"O-O",e:8.333}],"-1#-1902096557":[{m:"d7-d6",e:7.5}],"1#-927762060":[{m:"O-O",e:7.5}],"-1#-1904871927":[{m:"Ng8-e7",e:8}],"1#1740530049":[{m:"Nb1-d2",e:7.5},{m:"c2-c3",e:7.5}],"-1#-1212242212":[{m:"O-O",e:6.667}],"1#329870245":[{m:"c2-c3",e:6.667}],"-1#-37049572":[{m:"h7-h6",e:6.667}],"1#-1461130196":[{m:"b2-b4",e:6.667},{m:"Rf1-e1",e:6.667}],"-1#-727823889":[{m:"a7-a6",e:5}],"1#-374173476":[],"-1#-1478730428":[{m:"f7-f5",e:5}],"1#834067564":[{m:"e4xf5",e:5}],"-1#1604726959":[{m:"Bc8xf5",e:5}],"1#-475263323":[{m:"Nd2-c4",e:5}],"-1#1316283011":[{m:"Qd8-e8",e:5}],"1#-557461043":[{m:"Nf3-h4",e:5}],"-1#1770524632":[{m:"Bf5-d7",e:5}],"1#-1481365149":[{m:"f2-f4",e:5}],"-1#-1981963976":[{m:"O-O",e:5}],"1#768240705":[{m:"b2-b4",e:5}],"-1#1371326850":[{m:"a7-a6",e:5}],"1#1821380785":[{m:"a2-a4",e:5}],"-1#-1293926752":[{m:"h7-h6",e:5}],"1#-406685296":[{m:"Bc1-a3",e:5}],"-1#629315742":[{m:"b7-b5",e:5}],"1#1913360229":[{m:"c3-c4",e:5}],"-1#661292634":[{m:"b5xc4",e:5}],"1#1104035959":[{m:"d3xc4",e:5}],"-1#-1939028404":[{m:"Bc8-e6",e:5}],"1#-149502517":[{m:"Nf3-d2",e:5}],"-1#-246792153":[{m:"f7-f5",e:5}],"1#1730199823":[{m:"b4-b5",e:5}],"-1#2015792126":[{m:"Nc6-d4",e:5}],"1#-76284382":[{m:"e4xf5",e:5}],"-1#-1788669215":[{m:"Be6xf5",e:5}],"1#576103387":[{m:"Nd2-e4",e:5}],"-1#1687324528":[{m:"a6xb5",e:5}],"1#789392606":[{m:"a4xb5",e:5}],"-1#-103597317":[{m:"Qd8-d7",e:5}],"-1#613490689":[{m:"Bf8-g7",e:5}],"1#716701747":[{m:"Nb1-c3",e:5}],"-1#-1694221019":[{m:"Ng8-e7",e:9.286},{m:"d7-d6",e:9.286}],"1#1926212269":[{m:"f2-f4",e:5}],"-1#244122669":[{m:"e5xf4",e:5}],"1#689531887":[{m:"Bc1xf4",e:5}],"-1#1883512406":[{m:"O-O",e:5}],"1#-732703953":[{m:"Ng1-f3",e:5}],"-1#751891142":[{m:"d7-d5",e:5}],"1#-585692414":[{m:"f2-f4",e:9.231},{m:"Ng1-e2",e:9.231},{m:"Bc1-e3",e:9.231}],"-1#-1588222590":[{m:"Nc6-d4",e:8.75}],"-1#1121576701":[{m:"Ng8-e7",e:6.667}],"-1#-1635758393":[{m:"Bc8-e6",e:7.5}],"-1#316474005":[{m:"Ng8-f6",e:6.667}],"1#1795666885":[{m:"Ng1-f3",e:9.6},{m:"e2-e4",e:9.6},{m:"d2-d3",e:9.6}],"-1#-1820028372":[{m:"e5-e4",e:8}],"1#241522627":[{m:"Nf3-d4",e:8}],"-1#-1397040568":[{m:"c7-c5",e:8}],"1#-406735574":[{m:"Nd4-b3",e:8}],"-1#1595955020":[{m:"c5-c4",e:8}],"1#1134591440":[{m:"Nb3-d4",e:8}],"-1#-79585354":[{m:"Bf8-c5",e:8}],"1#461446565":[{m:"c2-c3",e:8}],"-1#-169681636":[{m:"O-O",e:8},{m:"Nb8-c6",e:8}],"1#1375015013":[{m:"O-O",e:5}],"-1#1269363089":[{m:"d7-d5",e:5}],"1#1799516514":[{m:"b2-b3",e:5}],"-1#1205495513":[{m:"c4xb3",e:5}],"1#-804918632":[{m:"a2xb3",e:5}],"-1#313808942":[{m:"Nb8-c6",e:5}],"1#-1440304270":[{m:"Nd4xc6",e:5}],"-1#-2131241013":[{m:"b7xc6",e:5}],"1#-2024027917":[{m:"Bc1-a3",e:5}],"-1#1159408125":[{m:"Bc5xa3",e:5}],"1#1890500328":[{m:"Nb1xa3",e:5}],"-1#-1819680050":[{m:"Qd8-b6",e:5}],"1#151723708":[{m:"b3-b4",e:5}],"1#1299199552":[{m:"d2-d3",e:7.5},{m:"Nd4xc6",e:7.5}],"-1#1655855313":[{m:"e4xd3",e:5}],"1#1940558866":[{m:"O-O",e:5}],"-1#1777825254":[{m:"d3xe2",e:5}],"1#-1383910478":[{m:"Qd1xe2+",e:5}],"-1#75092824":[{m:"Qd8-e7",e:5}],"1#1213675664":[{m:"Qe2xc4",e:5}],"-1#1738625785":[{m:"d7xc6",e:6.667}],"1#1019438215":[{m:"b2-b3",e:6.667}],"-1#274428732":[{m:"c4xb3",e:6.667}],"1#-2021326979":[{m:"a2xb3",e:6.667}],"-1#1161121227":[{m:"Bc8-f5",e:6.667}],"-1#1153817940":[{m:"Bf8-c5",e:9}],"1#-1543151801":[{m:"Ng1-f3",e:6.667}],"-1#1552318126":[{m:"Nb8-c6",e:6.667}],"1#-468412942":[{m:"O-O",e:8}],"-1#-28740602":[{m:"d7-d6",e:6.667}],"1#-1202044383":[{m:"Bc1-g5",e:6.667}],"-1#1438799162":[{m:"h7-h6",e:5}],"1#14684682":[{m:"Bg5xf6",e:5}],"-1#-1066877817":[{m:"Qd8xf6",e:5}],"1#1429458003":[{m:"Nb1-c3",e:5}],"-1#-460328635":[{m:"Qf6-d8",e:5}],"1#1213461195":[{m:"Nc3-d5",e:5}],"-1#246368055":[{m:"Nc6-e7",e:5}],"1#-1629338926":[{m:"c2-c4",e:5}],"-1#1436878819":[{m:"Ne7xd5",e:5}],"1#-471384657":[{m:"c4xd5",e:5}],"-1#-1214101409":[{m:"O-O",e:5}],"1#330663206":[{m:"Ra1-c1",e:5}],"-1#1883173805":[{m:"Qd8-e7",e:5}],"1#1007687781":[{m:"Nf3-d2",e:5}],"-1#978099593":[{m:"Bc8-g4",e:5}],"1#138019724":[{m:"Rc1-c4",e:5}],"-1#2043094887":[{m:"f7-f5",e:5}],"1#-273832369":[{m:"b2-b4",e:5}],"-1#-1814363252":[{m:"Bc5-b6",e:5}],"1#-994253846":[{m:"Nd2-b3",e:5}],"-1#-656537109":[{m:"Rf8-f7",e:5}],"1#-33858476":[{m:"a2-a4",e:5}],"-1#596341317":[{m:"a7-a6",e:5}],"1#514304886":[{m:"a4-a5",e:5}],"-1#-182749043":[{m:"Bb6-a7",e:5}],"1#-709850478":[{m:"h2-h3",e:5}],"-1#-852456372":[{m:"Bg4-h5",e:5}],"1#-433741209":[{m:"Qd1-d2",e:5}],"-1#-1777801856":[{m:"g7-g5",e:5}],"1#1867524896":[],"1#-865868217":[{m:"d2-d3",e:9.885},{m:"b2-b3",e:9.885},{m:"c2-c3",e:9.885},{m:"Ng1-f3",e:9.885},{m:"c2-c4",e:9.885}],"-1#-475952938":[{m:"Bc8-e6",e:9.836},{m:"e7-e5",e:9.888},{m:"Ng8-f6",e:9.836},{m:"c7-c5",e:9.836},{m:"f7-f5",e:9.836},{m:"Nb8-c6",e:9.836},{m:"Bf8-d6",e:9.836}],"1#-1730442415":[{m:"Ng1-f3",e:7.5}],"-1#1616423608":[{m:"f7-f6",e:6.667}],"1#1147072366":[{m:"c2-c3",e:6.667}],"1#-347186032":[{m:"Nb1-d2",e:9.821},{m:"Ng1-f3",e:9.821},{m:"b2-b3",e:9.821}],"-1#995007437":[{m:"e7-e5",e:9.583}],"1#-1128247620":[{m:"e2-e4",e:9.474},{m:"Ng1-f3",e:9.474}],"-1#332234105":[{m:"Nb8-d7",e:9.8},{m:"Qd8-c7",e:9.8},{m:"Bf8-d6",e:9.8}],"-1#-942257365":[{m:"Ng8-f6",e:5}],"1#1079549530":[{m:"Bc1-b2",e:5}],"-1#1410530379":[{m:"Nb8-d7",e:5}],"1#1680825767":[{m:"c2-c4",e:9.73},{m:"Bc1-g5",e:9.73}],"1#-1462048844":[{m:"e2-e4",e:8.571},{m:"Nb1-c3",e:8.571}],"-1#426171042":[{m:"Bc8-e6",e:7.5}],"1#1976240638":[{m:"Nb1-d2",e:5}],"-1#-1513369949":[{m:"Ng8-f6",e:5}],"1#1530094474":[{m:"c2-c4",e:9.474},{m:"Nb1-d2",e:9.474}],"1#775235265":[{m:"c2-c4",e:5}],"-1#-445488144":[{m:"d5-d4",e:5}],"-1#-520359428":[{m:"Ng8-f6",e:6.667}],"1#1735730317":[{m:"Bc1-b2",e:6.667}],"-1#1933526684":[{m:"Bf8-d6",e:6.667}],"1#-1096030069":[{m:"d2-d3",e:5}],"-1#-1855355366":[{m:"O-O",e:5}],"1#897469283":[{m:"e2-e3",e:5}],"-1#-1948809364":[{m:"c7-c5",e:5}],"1#-1062410226":[{m:"c2-c4",e:5}],"-1#199994687":[{m:"d5-d4",e:5}],"1#-2019544150":[{m:"e3-e4",e:5}],"-1#260766831":[{m:"Nb8-c6",e:5}],"1#-1223157965":[{m:"Ng1-f3",e:5}],"-1#1335572186":[{m:"a7-a6",e:5}],"1#1924657129":[{m:"a2-a3",e:5}],"-1#1694907440":[{m:"Ra8-b8",e:5}],"1#993993379":[{m:"O-O",e:5}],"-1#560120663":[{m:"Bc8-g4",e:5}],"1#320101714":[{m:"Kg1-h1",e:5}],"-1#-661868010":[{m:"g7-g6",e:5}],"1#-1056768493":[{m:"Qd1-e1",e:5}],"-1#-370762189":[{m:"Qd8-c7",e:5}],"-1#570435326":[{m:"Ng8-f6",e:6.667}],"1#-1517358193":[{m:"d2-d4",e:7.5}],"-1#1504664047":[{m:"Nb8-d7",e:7.5}],"1#-1974236080":[{m:"Ng1-h3",e:6.667}],"-1#2003457776":[{m:"Bf8-e7",e:5}],"1#-283592840":[{m:"O-O",e:5}],"-1#-180005236":[{m:"O-O",e:5}],"1#1364368373":[{m:"Nb1-d2",e:5}],"-1#-2125308760":[{m:"Rf8-e8",e:5}],"1#-942921112":[{m:"d4xe5",e:5}],"-1#-1116940507":[{m:"Nd7xe5",e:5}],"1#426117337":[{m:"Nh3-f4",e:5}],"-1#-22495009":[{m:"c7-c6",e:5}],"1#-163113831":[{m:"Nd2-b3",e:5}],"-1#1184885225":[{m:"Be7-f8",e:5}],"1#-554891167":[{m:"Qd1-c2",e:5}],"-1#1331031989":[{m:"Ne5-c4",e:5}],"1#1406471071":[{m:"Nb3-d4",e:5}],"-1#-1024009853":[{m:"h7-h6",e:5}],"1#-1747673421":[{m:"b2-b3",e:5}],"-1#-1152612088":[{m:"Nc4-d6",e:5}],"-1#887146414":[{m:"Nb8-c6",e:8.571}],"1#-1938674446":[{m:"d2-d3",e:9.836},{m:"O-O",e:9.836}],"-1#-1548729757":[{m:"Bc8-e6",e:9.855},{m:"Ng8-f6",e:9.855},{m:"f7-f5",e:9.855},{m:"Bc8-g4",e:9.855},{m:"g7-g6",e:9.855}],"1#-657833500":[{m:"O-O",e:6.667}],"1#608081682":[{m:"O-O",e:9.846}],"1#-1849238426":[{m:"h2-h3",e:6.667}],"1#-1170338202":[{m:"c2-c4",e:7.5}],"-1#-1775252218":[{m:"e5-e4",e:8.333}],"1#198052073":[{m:"Nf3-e1",e:7.5}],"-1#-291512419":[{m:"f7-f5",e:7.5}],"1#2029346485":[{m:"d2-d3",e:5}],"-1#1463234596":[{m:"Bc8-e6",e:5}],"1#743256995":[{m:"c2-c4",e:5}],"-1#-418744686":[{m:"d5xc4",e:5}],"1#-1801457765":[{m:"Nb1-c3",e:5}],"-1#623104653":[{m:"Ng8-f6",e:5}],"1#-1565718532":[{m:"Bc1-g5",e:5}],"-1#119841654":[{m:"d5xc4",e:9.545},{m:"d5-d4",e:9.545},{m:"e7-e5",e:9.697}],"1#1957771903":[{m:"Qd1-a4+",e:7.5}],"-1#-1234424790":[{m:"c7-c6",e:7.5}],"1#-1098647444":[{m:"Qa4xc4",e:8}],"-1#968898571":[{m:"Ng8-f6",e:8},{m:"Bf8-e7",e:8}],"1#-1102123654":[{m:"d2-d3",e:5}],"-1#-1853062165":[{m:"Bc8-e6",e:5}],"1#-1582114429":[{m:"Ng1-f3",e:5}],"-1#1496447082":[{m:"Bc8-e6",e:5}],"1#-1955643933":[{m:"d2-d3",e:8.889},{m:"e2-e3",e:8.889}],"-1#-1532144782":[{m:"Ng8-f6",e:8.571}],"1#589530627":[{m:"Ng1-f3",e:5}],"-1#-610228246":[{m:"Nb8-c6",e:5}],"1#1664240822":[{m:"O-O",e:9.6}],"-1#902230508":[{m:"Nb8-c6",e:5}],"1#-1923867984":[{m:"e3xd4",e:5}],"-1#1905345346":[{m:"Qd8xd4",e:5}],"1#264992560":[{m:"Qd1-a4",e:9.615},{m:"c4xd5",e:9.615}],"-1#-854171291":[{m:"d5-d4",e:6.667},{m:"c7-c6",e:7.5}],"1#1096679408":[{m:"d2-d3",e:5}],"-1#1855951201":[{m:"Bf8-d6",e:5}],"1#-1559543946":[{m:"Ng1-f3",e:5}],"-1#1535647391":[{m:"Nb8-d7",e:5}],"1#-2005611744":[{m:"O-O",e:5}],"-1#-1842795820":[{m:"a7-a5",e:5}],"-1#-1730443012":[{m:"c6xd5",e:9.545}],"1#1333311122":[{m:"d2-d4",e:9.545},{m:"Qd1-b3",e:9.545},{m:"Ng1-f3",e:9.545}],"-1#-1286005518":[{m:"e5-e4",e:9.333}],"-1#1002751324":[{m:"Ng8-f6",e:7.5}],"1#-1135996883":[{m:"Nb1-c3",e:7.5}],"-1#-1208248453":[{m:"Nb8-c6",e:7.5}],"1#-650139856":[{m:"Bf1-g2",e:9.929},{m:"d2-d4",e:9.929},{m:"e2-e4",e:9.929}],"-1#-1772434843":[{m:"Bf8-g7",e:9.924}],"1#-1737233833":[{m:"e2-e4",e:9.922},{m:"d2-d4",e:9.922},{m:"d2-d3",e:9.922},{m:"f2-f4",e:9.922},{m:"c2-c4",e:9.922}],"-1#-558537430":[{m:"e7-e5",e:9.737},{m:"Bf8-g7",e:9.524}],"1#-1108834818":[{m:"Ng1-e2",e:9.091},{m:"f2-f4",e:9.091}],"-1#572942337":[{m:"Nb8-c6",e:8.889},{m:"Ng8-e7",e:8.889},{m:"Ng8-f6",e:8.889}],"1#-1699445923":[{m:"c2-c3",e:5}],"-1#1960264676":[{m:"d7-d6",e:5}],"1#851736003":[{m:"d2-d4",e:5}],"1#-873594999":[{m:"f2-f4",e:6.667}],"-1#-1213247223":[{m:"d7-d6",e:5}],"1#-1515668112":[{m:"d2-d4",e:8.571}],"-1#1502156560":[{m:"e5xd4",e:8.571}],"-1#-1045812354":[{m:"d7-d6",e:6.667}],"1#-2017911463":[{m:"Ng1-f3",e:6.667}],"-1#2134523056":[{m:"Nb8-c6",e:7.5}],"1#-945235988":[{m:"O-O",e:6.667}],"-1#-571132392":[{m:"Ng8-e7",e:6.667}],"1#876519824":[{m:"f4xe5",e:6.667},{m:"d2-d3",e:6.667}],"-1#1993488531":[{m:"d6xe5",e:5}],"-1#469552897":[{m:"O-O",e:5}],"1#-1075117448":[{m:"c2-c3",e:5}],"-1#1683111991":[{m:"d7-d6",e:9.825},{m:"c7-c5",e:9.825}],"1#574715408":[{m:"Bf1-g2",e:9.643}],"1#791228245":[{m:"d2-d4",e:6.667},{m:"d4-d5",e:9.375}],"-1#-705110049":[{m:"d7-d6",e:8}],"1#-1813255688":[{m:"c2-c4",e:8}],"-1#1487711433":[{m:"b7-b5",e:7.5}],"1#254130994":[{m:"c4xb5",e:5}],"-1#245948522":[{m:"a7-a6",e:5}],"1#864303449":[{m:"b5xa6",e:5}],"-1#-855171573":[{m:"Bc8xa6",e:5}],"1#1784529719":[{m:"h2-h4",e:5}],"-1#-774190149":[{m:"Ng8-f6",e:5}],"-1#-1213102906":[{m:"d7-d5",e:8.889},{m:"e7-e5",e:8.889}],"1#-1755642827":[{m:"Nb1-d2",e:8.571}],"-1#1197196136":[{m:"d5-d4",e:7.5}],"1#-888119811":[{m:"e2-e4",e:5}],"-1#-1915301248":[{m:"d4xe3",e:5}],"1#678203000":[{m:"f2xe3",e:5}],"-1#2146925084":[{m:"c7-c5",e:5}],"1#881595774":[{m:"Nd2-c4",e:5}],"-1#-1722484392":[{m:"Nb8-c6",e:5}],"1#566628868":[{m:"Ng1-f3",e:5}],"-1#-649776147":[{m:"Bc8-e6",e:5}],"1#-1572917142":[{m:"Nf3-g5",e:5}],"1#-722705390":[{m:"e2-e4",e:7.5}],"-1#-1842680977":[{m:"Ng8-e7",e:7.5}],"1#2078375143":[{m:"Nb1-c3",e:7.5}],"-1#-899857935":[{m:"O-O",e:5}],"1#1850379400":[{m:"Bc1-e3",e:5}],"-1#769509709":[{m:"c7-c6",e:5}],"1#624041227":[{m:"Qd1-d2",e:5}],"-1#1428118252":[{m:"d7-d5",e:5}],"1#1979046431":[{m:"e4xd5",e:5}],"-1#691204471":[{m:"c6xd5",e:5}],"1#-322573820":[{m:"Be3-h6",e:5}],"-1#1538168210":[{m:"Nb8-c6",e:5}],"-1#-466533161":[],"-1#1395961702":[{m:"Ng8-f6",e:9.929},{m:"Nb8-c6",e:9.929}],"1#-725976553":[{m:"e2-e4",e:9.919},{m:"Ng1-f3",e:9.919}],"-1#-1837304470":[{m:"c7-c5",e:8}],"1#-653813240":[{m:"Ng1-e2",e:5}],"-1#1187608567":[{m:"Nb8-c6",e:5}],"1#-27550549":[{m:"O-O",e:5}],"-1#-469336737":[{m:"O-O",e:5}],"1#1074901030":[{m:"d2-d3",e:5}],"-1#741956606":[{m:"d7-d6",e:9.967},{m:"O-O",e:9.967}],"1#1781165529":[{m:"d2-d4",e:9.73}],"-1#-1777612871":[{m:"O-O",e:9.922}],"1#-2010212729":[{m:"d2-d4",e:9.962},{m:"O-O",e:9.962}],"1#-341425094":[{m:"Nb1-c3",e:6.667}],"-1#1511684396":[{m:"d7-d6",e:8},{m:"a7-a6",e:8}],"1#470372107":[{m:"d2-d3",e:9.091}],"-1#868950426":[{m:"f7-f5",e:8.333},{m:"Bc8-d7",e:8.333}],"1#-1516134222":[{m:"e2-e3",e:5}],"-1#453536957":[{m:"Ng8-f6",e:5}],"1#-1668892212":[{m:"Ng1-e2",e:5}],"-1#55071795":[{m:"O-O",e:5}],"1#-483166823":[{m:"Bc1-d2",e:8},{m:"Ra1-b1",e:8}],"-1#-832763140":[{m:"Qd8-c8",e:7.5}],"-1#304612571":[{m:"Qd8-c8",e:5}],"1#1731633183":[{m:"d2-d3",e:5}],"-1#1224003214":[{m:"Ra8-b8",e:5}],"1#382586909":[{m:"e2-e3",e:5}],"-1#-1469834222":[{m:"b7-b5",e:5}],"1#-1242135":[{m:"Ng1-e2",e:5}],"-1#1612965398":[{m:"h7-h5",e:5}],"1#1119367273":[{m:"h2-h3",e:5}],"-1#1513633463":[{m:"b5xc4",e:5}],"1#1016918170":[{m:"d3xc4",e:5}],"-1#-247564639":[{m:"Bc8-b7",e:5}],"1#1794327301":[{m:"O-O",e:5}],"-1#1890493169":[{m:"h5-h4",e:5}],"-1#622726480":[{m:"Bf8-g7",e:9.706}],"1#725036386":[{m:"e2-e4",e:9.688}],"-1#-1611061171":[{m:"d7-d5",e:7.5}],"1#-1089230658":[{m:"e4xd5",e:5}],"-1#-472611882":[{m:"Qd8xd5",e:5}],"1#-350954979":[{m:"Ng1-f3",e:5}],"-1#328727540":[{m:"Bc8-g4",e:5}],"1#568419825":[{m:"Bf1-e2",e:5}],"-1#-503116041":[{m:"Nb8-c6",e:5}],"1#1519510955":[{m:"h2-h3",e:5}],"-1#1108468597":[{m:"Bg4xf3",e:5}],"1#329466144":[{m:"Be2xf3",e:5}],"-1#917379545":[{m:"Qd5-e5+",e:5}],"1#-56691897":[{m:"Ke1-f1",e:5}],"-1#340608888":[{m:"Nc6-d4",e:5}],"1#-1760021852":[{m:"Bf3-g2",e:5}],"-1#-1147075242":[{m:"O-O-O",e:5}],"1#1298356885":[{m:"Nb1-a3",e:5}],"-1#52976186":[{m:"Qe5-f6",e:5}],"1#707345958":[{m:"d2-d3",e:5}],"-1#99307703":[{m:"e7-e5",e:5}],"1#1723248739":[{m:"Qd1-g4+",e:5}],"-1#1751289951":[{m:"Qf6-f5",e:5}],"1#-32874880":[{m:"Qg4xf5+",e:5}],"-1#1064067769":[{m:"Nd4xf5",e:5}],"1#-831285072":[{m:"Na3-c4",e:5}],"-1#-35605660":[{m:"Bf8-g7",e:5}],"1#-204893354":[{m:"Bc1-d2",e:5}],"-1#-559420365":[{m:"Nf5-d4",e:5}],"1#1676485959":[{m:"Ra1-c1",e:5}],"-1#6706124":[{m:"Ng8-e7",e:5}],"1#-374487996":[{m:"a2-a4",e:5}],"-1#937290325":[{m:"Ne7-d5",e:5}],"1#-465457890":[{m:"Nc4-a5",e:5}],"-1#-1717469225":[{m:"c7-c6",e:5}],"1#-1857115247":[{m:"b2-b4",e:5}],"-1#-315093422":[{m:"b7-b6",e:5}],"1#-1178674880":[{m:"Na5-c4",e:5}],"-1#-1000469623":[{m:"Rh8-e8",e:5}],"1#993858443":[],"1#-530879546":[{m:"Bf1-g2",e:9.97}],"-1#-1354889581":[{m:"c7-c5",e:9.963},{m:"e7-e5",e:9.963},{m:"Ng8-f6",e:9.963},{m:"c7-c6",e:9.963}],"1#-465212943":[{m:"d2-d3",e:9.333}],"-1#-880343200":[{m:"Nb8-c6",e:8.333}],"1#1930816572":[{m:"Nb1-d2",e:8.75},{m:"f2-f4",e:8.75}],"-1#-1558893727":[{m:"e7-e5",e:8},{m:"e7-e6",e:8}],"1#-1068971083":[{m:"e2-e4",e:7.5}],"-1#-2037496632":[{m:"Ng8-e7",e:8},{m:"d5-d4",e:8},{m:"Ng8-f6",e:8}],"1#1866847040":[{m:"Ng1-f3",e:5}],"-1#-1748569431":[{m:"d5-d4",e:5}],"1#462253116":[{m:"Nd2-c4",e:5}],"-1#-1235910630":[{m:"f7-f6",e:5}],"1#-1840003636":[{m:"a2-a4",e:5}],"-1#1277422557":[{m:"Bc8-e6",e:5}],"1#928639066":[{m:"O-O",e:5}],"1#180738653":[{m:"Ng1-h3",e:6.667}],"-1#-134479619":[{m:"Bf8-d6",e:5}],"1#979939050":[{m:"O-O",e:5}],"-1#540364574":[{m:"Ng8-e7",e:5}],"1#-906045290":[{m:"c2-c4",e:5}],"-1#45718951":[{m:"Qd8-c7",e:5}],"1#1302356115":[{m:"a2-a3",e:5}],"1#16814521":[{m:"Ng1-f3",e:9.286},{m:"e4xd5",e:9.286},{m:"Ng1-e2",e:9.286}],"-1#-108810160":[{m:"Bf8-e7",e:9.286},{m:"g7-g6",e:9.286}],"-1#1573370577":[{m:"Nf6xd5",e:5}],"-1#-1630634938":[{m:"Bf8-e7",e:7.5}],"1#-186432844":[{m:"e2-e4",e:6.667}],"-1#-1306145335":[{m:"g7-g6",e:9.667},{m:"Ng8-f6",e:9.667}],"1#-1414823476":[{m:"f2-f4",e:9.286},{m:"h2-h4",e:9.286}],"-1#-672583860":[{m:"Bf8-g7",e:6.667}],"1#-641724546":[{m:"Ng1-f3",e:6.667}],"-1#558050967":[{m:"Ng8-e7",e:7.5}],"1#-930563809":[{m:"O-O",e:8}],"-1#-757770005":[{m:"b7-b6",e:8}],"-1#271354176":[{m:"Ng8-f6",e:5}],"1#-1750967247":[{m:"Ng1-h3",e:5}],"-1#1788577425":[{m:"Bf8-g7",e:5}],"1#1689429667":[{m:"Nh3-f4",e:5}],"-1#-2088997211":[{m:"h7-h6",e:5}],"1#900405432":[{m:"Ng1-h3",e:9.615},{m:"f2-f4",e:9.615},{m:"Ng1-e2",e:9.615}],"-1#-929906152":[{m:"Bf8-e7",e:5}],"1#1356866448":[{m:"O-O",e:5}],"-1#1240053304":[{m:"d5xe4",e:5}],"1#222837802":[{m:"d3xe4",e:5}],"-1#-821300351":[{m:"b7-b6",e:5}],"-1#-1436158649":[{m:"Bf8-e7",e:6.667}],"1#840373455":[{m:"O-O",e:7.5}],"-1#676001083":[{m:"O-O",e:6.667}],"-1#257376956":[{m:"Ng8-f6",e:6.667}],"1#-1999005747":[{m:"Ng1-f3",e:6.667}],"-1#1884993060":[{m:"g7-g6",e:8.571}],"1#1775565345":[{m:"O-O",e:8.571}],"-1#1938365397":[{m:"Bf8-g7",e:8.75}],"1#2107653095":[{m:"Nb1-c3",e:9.5},{m:"Nb1-a3",e:9.5}],"-1#-870578447":[{m:"O-O",e:9.231},{m:"d5-d4",e:9.231}],"1#1745603464":[{m:"e2-e4",e:6.667}],"-1#785204469":[{m:"d5xe4",e:5}],"1#1785515751":[{m:"d3xe4",e:5}],"-1#-1473314484":[{m:"Qd8xd1",e:5}],"1#1361950828":[{m:"Rf1xd1",e:5}],"-1#124172418":[{m:"e7-e5",e:5}],"1#1681610838":[{m:"Nc3-d5",e:5}],"-1#583527850":[{m:"Bc8-g4",e:5}],"1#280064943":[{m:"Nd5xf6+",e:5}],"-1#-2080238979":[{m:"Bg7xf6",e:5}],"1#-1160954961":[{m:"c2-c3",e:5}],"1#1079482468":[{m:"Nc3-a4",e:9.091}],"-1#2110230952":[{m:"Nf6-d7",e:9},{m:"Qd8-d6",e:9}],"1#-1017367816":[{m:"Nf3-g5",e:8.889}],"-1#426238900":[{m:"Qd8-c7",e:5}],"1#1451105920":[{m:"c2-c4",e:5}],"-1#-1657185359":[{m:"e7-e6",e:5}],"1#942470498":[{m:"e2-e4",e:5}],"-1#2129295903":[{m:"d4xe3",e:5}],"1#-615504153":[{m:"Bc1xe3",e:5}],"-1#871054152":[{m:"O-O",e:5}],"1#-1745029583":[{m:"Kg1-h1",e:5}],"-1#1550063989":[{m:"b7-b6",e:5}],"1#149081703":[{m:"c2-c3",e:5}],"-1#-427749666":[{m:"Bc8-b7",e:5}],"1#2102147962":[{m:"Qd1-a4",e:5}],"-1#-1081004753":[{m:"a7-a6",e:5}],"1#-2101480420":[{m:"e2-e4",e:5}],"-1#-998540447":[{m:"b6-b5",e:5}],"1#-1221511361":[{m:"Qa4-c2",e:5}],"-1#-1810806263":[{m:"e7-e5",e:5}],"1#-145970467":[{m:"f4-f5",e:5}],"-1#-2144159888":[{m:"c5-c4",e:5}],"1#-1666015764":[{m:"d3xc4",e:5}],"-1#1947772355":[{m:"d5xe4",e:5}],"1#817442769":[{m:"Nf3-h4",e:5}],"-1#-2013990460":[{m:"b5-b4",e:5}],"1#515497316":[{m:"c3xb4",e:5}],"-1#1416669228":[{m:"Qd8-b6",e:5}],"1#-822979490":[{m:"Qc2-c3",e:5}],"-1#1512289352":[{m:"Rf8-d8",e:5}],"1#-616190999":[{m:"Bc1-g5",e:5}],"-1#920501490":[{m:"Rd8-d3",e:5}],"1#1489042029":[{m:"Qc3-e1",e:5}],"1#682677218":[{m:"d2-d3",e:9.907},{m:"c2-c4",e:9.907}],"-1#124960115":[{m:"Bc8-f5",e:9.737},{m:"g7-g6",e:9.737},{m:"Bc8-g4",e:9.737},{m:"e7-e6",e:9.737}],"1#1777550204":[{m:"Nb1-d2",e:6.667}],"-1#-1175223263":[{m:"e7-e6",e:5}],"1#-301601292":[{m:"e2-e4",e:5}],"-1#-1463590263":[{m:"Bf5-g6",e:5}],"1#714646541":[{m:"Qd1-e2",e:5}],"-1#-304853935":[{m:"Bf8-e7",e:5}],"1#1973857753":[{m:"Ng1-f3",e:5}],"-1#-1926919120":[{m:"Bg6-h5",e:5}],"1#148473890":[{m:"h2-h3",e:5}],"-1#274304764":[{m:"Bh5xf3",e:5}],"1#448499253":[{m:"Nd2xf3",e:5}],"-1#-1290094716":[{m:"c7-c6",e:5}],"1#-1141546046":[{m:"O-O",e:5}],"1#519893366":[{m:"c2-c4",e:8.75},{m:"Nb1-d2",e:8.75}],"-1#-709118905":[{m:"Bf8-g7",e:6.667}],"1#-611150731":[{m:"c4xd5",e:6.667},{m:"Ng1-f3",e:6.667}],"-1#1283615673":[{m:"Nf6xd5",e:5}],"-1#588363164":[{m:"O-O",e:5}],"-1#-822331861":[{m:"Bf8-g7",e:5}],"1#-1059776999":[{m:"e2-e4",e:6.667}],"-1#-2045535900":[{m:"e7-e5",e:5}],"1#-447841872":[{m:"Ng1-f3",e:5}],"-1#499996761":[{m:"Nb8-c6",e:5}],"1#889463670":[{m:"h2-h3",e:5}],"-1#763635112":[{m:"Bg4-h5",e:5}],"1#110168963":[{m:"c2-c4",e:5}],"-1#-841593166":[{m:"c7-c6",e:5}],"1#-986080524":[{m:"Qd1-b3",e:5}],"-1#-1316624070":[{m:"Qd8-c8",e:5}],"1#2003908720":[{m:"c4xd5",e:5}],"-1#-530462788":[{m:"c6xd5",e:5}],"1#935524818":[{m:"Nb1-c3",e:5}],"-1#-2038512444":[{m:"e7-e6",e:5}],"1#-779571951":[{m:"g3-g4",e:5}],"-1#-626509243":[{m:"Bh5-g6",e:5}],"1#1350882470":[{m:"e2-e4",e:8.333},{m:"f2-f4",e:8.333}],"-1#373447643":[{m:"d5xe4",e:5}],"1#1390662089":[{m:"d3xe4",e:5}],"-1#-1868554654":[{m:"Qd8xd1+",e:5}],"1#1772267330":[{m:"Ke1xd1",e:5}],"-1#259873610":[{m:"Bf8-c5",e:5}],"-1#751204902":[],"-1#-470313261":[{m:"c7-c5",e:8.333},{m:"d5xc4",e:8.333}],"1#-1467156047":[{m:"c4xd5",e:9.444},{m:"d2-d3",e:9.444}],"-1#1067189885":[{m:"Nf6xd5",e:9.091}],"1#-683871723":[{m:"d2-d4",e:9.091}],"-1#723343477":[{m:"c5xd4",e:5}],"1#421856376":[{m:"Qd1xd4",e:5}],"-1#-1499862765":[{m:"e7-e6",e:5}],"1#-244350778":[{m:"Ng1-f3",e:5}],"-1#166502703":[{m:"Nb8-c6",e:5}],"1#-1317123469":[{m:"Qd4-a4",e:5}],"-1#-440399251":[{m:"Bc8-d7",e:5}],"1#892886638":[{m:"O-O",e:5}],"-1#795197338":[{m:"Bf8-e7",e:5}],"1#-1223205358":[{m:"Nb1-c3",e:5}],"-1#111895300":[{m:"Nd5xc3",e:5}],"1#1711658936":[{m:"b2xc3",e:5}],"-1#-2024892640":[{m:"d5xc4",e:5}],"1#-186970583":[{m:"Qd1-a4+",e:5}],"-1#906369148":[{m:"Bc8-d7",e:5}],"1#-419541889":[{m:"Qa4xc4",e:5}],"-1#1639812120":[{m:"Bd7-c6",e:5}],"1#-1601645290":[{m:"Ng1-f3",e:5}],"-1#1477178623":[{m:"e7-e6",e:5}],"1#268279082":[{m:"O-O",e:5}],"-1#362839262":[{m:"Nb8-d7",e:5}],"1#-967005855":[{m:"b2-b3",e:5}],"-1#-356204838":[{m:"Bf8-e7",e:5}],"1#1924554578":[{m:"Bc1-b2",e:5}],"-1#1727806787":[{m:"O-O",e:6.667}],"1#-1024724934":[{m:"Nb1-d2",e:6.667}],"1#-1872621606":[{m:"Qd1-a4+",e:5}],"-1#1388255631":[{m:"c7-c6",e:5}],"1#1515245001":[{m:"Qa4xc4",e:5}],"-1#-585953874":[{m:"Bc8-f5",e:5}],"1#-1282215007":[{m:"d2-d3",e:5}],"-1#-1672438480":[{m:"Nb8-d7",e:5}],"1#1336690831":[{m:"Ng1-f3",e:5}],"-1#-1221629594":[],"1#-1479421227":[{m:"b2-b3",e:9.922},{m:"d2-d3",e:9.922
},{m:"c2-c4",e:9.922}],"-1#-1958099602":[{m:"Bc8-g4",e:7.5}],"1#-1187030165":[{m:"Bc1-b2",e:5}],"-1#-1384826502":[{m:"Nb8-d7",e:8.889},{m:"e7-e6",e:8.889}],"1#2122968261":[{m:"Ng1-f3",e:8.889},{m:"h2-h3",e:8.889}],"-1#-2046112468":[{m:"Bg4xf3",e:9.8},{m:"Qd8-c7",e:9.8},{m:"e7-e6",e:9.8},{m:"Ng8-f6",e:9.8},{m:"f7-f6",e:9.8}],"1#-675778695":[{m:"Bg2xf3",e:5}],"1#-921489384":[{m:"d2-d4",e:7.5}],"1#-1576236806":[{m:"c2-c4",e:6.667}],"-1#1711925787":[{m:"Bg4-h5",e:6.667}],"1#1293730864":[{m:"Ng1-f3",e:6.667}],"-1#-1247812135":[{m:"Ng8-f6",e:6.667}],"1#839987368":[{m:"O-O",e:6.667},{m:"d2-d3",e:6.667}],"-1#676122972":[{m:"e7-e6",e:5}],"1#2142943369":[{m:"d2-d3",e:6.667}],"-1#500391481":[{m:"e7-e6",e:5}],"1#-92057425":[{m:"h2-h3",e:6.667}],"-1#-503097743":[{m:"Bg4-h5",e:6.667}],"1#-921274278":[{m:"d2-d3",e:6.667}],"-1#-422308149":[{m:"Ng8-f6",e:5}],"1#1633338298":[{m:"Nb1-d2",e:5}],"-1#-1319500569":[{m:"Nb8-d7",e:5}],"1#1655099736":[{m:"g3-g4",e:5}],"-1#1770407436":[{m:"Bh5-g6",e:5}],"1#-327532002":[{m:"e2-e3",e:5}],"-1#1389596177":[{m:"h7-h5",e:5}],"1#1883789422":[{m:"g4-g5",e:5}],"-1#1186550583":[{m:"Nf6-g8",e:5}],"1#-1053325754":[{m:"h3-h4",e:5}],"-1#309658787":[{m:"f7-f6",e:5}],"1#913523061":[{m:"Bg2-h3",e:5}],"-1#1165260307":[{m:"Qd8-e7",e:5}],"1#156933595":[{m:"f2-f4",e:5}],"-1#1964520283":[{m:"Bg6-f5",e:5}],"-1#-2011972540":[{m:"e7-e5",e:9.888},{m:"Bc8-g4",e:9.888},{m:"Ng8-f6",e:9.888}],"1#-1167777215":[{m:"h2-h3",e:9.5},{m:"Ng1-f3",e:9.5},{m:"Nb1-d2",e:9.5}],"-1#-1562041185":[{m:"Bg4-h5",e:7.5}],"1#-1980757324":[{m:"f2-f4",e:7.5}],"-1#-172841932":[{m:"e7-e6",e:6.667}],"-1#1122370472":[{m:"Nb8-d7",e:9.667}],"1#-1860512233":[{m:"h2-h3",e:9.63},{m:"Nb1-d2",e:9.63},{m:"b2-b3",e:9.63}],"-1#1785062684":[{m:"Nb8-d7",e:8.889},{m:"e7-e5",e:8.889}],"1#-1181142877":[{m:"h2-h3",e:6.667}],"1#261974325":[{m:"Nb1-d2",e:9.688},{m:"Nb1-c3",e:9.688}],"-1#-543314328":[{m:"e7-e5",e:9.583},{m:"a7-a5",e:9.583},{m:"Bc8-f5",e:9.583}],"1#-11763089":[{m:"e2-e4",e:5}],"1#-1323544473":[{m:"e2-e4",e:6.667}],"-1#-1105112029":[{m:"e7-e5",e:5}],"1#-579029769":[{m:"Ng1-f3",e:6.667}],"-1#637506846":[{m:"Bf8-d6",e:5}],"1#-395625719":[{m:"e2-e4",e:8.333}],"-1#-1364347788":[{m:"O-O",e:8.333}],"-1#1821808612":[{m:"Ng8-f6",e:9.697},{m:"e7-e5",e:9.697}],"1#-350731627":[{m:"Qd1-a4",e:9.767},{m:"Qd1-c2",e:9.767},{m:"b2-b3",e:9.767},{m:"c4xd5",e:9.767}],"-1#700798144":[{m:"e7-e6",e:6.667}],"1#2117287189":[{m:"Ng1-f3",e:6.667}],"-1#-2035278596":[{m:"Bf8-e7",e:6.667}],"-1#2057348417":[{m:"Bc8-g4",e:8.889},{m:"g7-g6",e:8.889}],"1#1221999428":[{m:"h2-h3",e:6.667}],"1#1664018756":[{m:"b2-b3",e:7.5}],"-1#-947890898":[{m:"a7-a5",e:6.667}],"1#-414090967":[{m:"Ng1-f3",e:6.667}],"-1#533878976":[{m:"Bc8-f5",e:7.5},{m:"a5-a4",e:7.5}],"-1#2080947545":[{m:"c6xd5",e:9.091}],"1#-1414823113":[{m:"Ng1-f3",e:9.091}],"-1#1395172062":[{m:"Nb8-c6",e:9.231}],"1#-340113022":[{m:"d2-d4",e:9.167}],"-1#-1604297203":[{m:"d7-d6",e:9.999},{m:"c7-c5",e:9.999},{m:"e7-e5",e:9.999},{m:"e7-e6",e:9.999},{m:"b7-b6",e:9.999},{m:"Ng8-f6",e:9.999},{m:"Nb8-a6",e:9.999},{m:"c7-c6",e:9.999},{m:"g7-g6",e:9.999},{m:"Nb8-c6",e:9.999},{m:"f7-f5",e:9.999},{m:"g7-g5",e:9.999}],"1#-428644310":[{m:"Nb1-c3",e:9.818},{m:"c2-c4",e:9.958}],"-1#1473205564":[{m:"g7-g6",e:9.73},{m:"Nb8-d7",e:9.73}],"1#1312889145":[{m:"g2-g3",e:9.091}],"-1#-438834896":[{m:"Bf8-g7",e:8.75}],"1#-335623934":[{m:"Bf1-g2",e:9.688}],"-1#-1533303721":[{m:"c7-c5",e:9.811},{m:"f7-f5",e:9.811},{m:"Ng8-f6",e:9.811},{m:"c7-c6",e:9.811},{m:"d7-d6",e:8}],"1#-270480587":[{m:"a2-a3",e:8.333}],"-1#-128902932":[{m:"Nb8-c6",e:5}],"1#1086583728":[{m:"Ra1-b1",e:9.767},{m:"e2-e3",e:9.767},{m:"Ng1-f3",e:9.767}],"-1#-1311210766":[{m:"Qd8-a5",e:9.63}],"-1#-1203711399":[{m:"Ra8-b8",e:8.75}],"1#854664575":[{m:"e2-e3",e:8}],"-1#-1940330128":[{m:"c7-c6",e:5}],"1#-2068366026":[{m:"Ng1-e2",e:5}],"-1#460968137":[{m:"Ng8-h6",e:5}],"1#-1813053802":[{m:"O-O",e:5}],"-1#-1984749726":[{m:"e7-e5",e:5}],"1#-353435722":[{m:"d2-d4",e:5}],"1#588607782":[{m:"d2-d3",e:9.841},{m:"e2-e4",e:9.841},{m:"e2-e3",e:9.841}],"-1#215424951":[{m:"Nb8-d7",e:8.889}],"-1#1708392027":[{m:"e7-e5",e:9.783}],"1#-1401655279":[{m:"d2-d3",e:6.667}],"-1#-2085216640":[{m:"Ng8-f6",e:5}],"1#70831089":[{m:"e2-e4",e:5}],"-1#1123959948":[{m:"a7-a6",e:5}],"1#2144509375":[{m:"Ng1-e2",e:5}],"-1#-535007168":[{m:"b7-b5",e:5}],"1#-2076999549":[{m:"g2-g3",e:5}],"-1#799371402":[{m:"g7-g6",e:5}],"1#908803215":[{m:"Bf1-g2",e:5}],"-1#2035175898":[{m:"Bf8-g7",e:5}],"1#2003268072":[{m:"d2-d3",e:5}],"-1#1487216505":[{m:"e7-e5",e:5}],"1#1006174125":[{m:"e2-e4",e:5}],"-1#2101244112":[{m:"Ng8-e7",e:5}],"1#-1795823784":[{m:"Ng1-e2",e:6.667}],"-1#188418727":[{m:"O-O",e:6.667}],"1#-1356019746":[{m:"O-O",e:7.5},{m:"Bc1-e3",e:7.5}],"-1#-1250875862":[{m:"c7-c6",e:6.667}],"1#-1113656724":[{m:"Bc1-e3",e:7.5}],"-1#-32917591":[{m:"Nd7-f6",e:8}],"1#-172675589":[{m:"h2-h3",e:6.667}],"-1#-315282651":[{m:"Bc8-e6",e:6.667}],"1#-1773197150":[{m:"f2-f4",e:6.667}],"-1#-368212446":[{m:"Nf6-h5",e:6.667}],"1#1811956503":[{m:"Qd1-d2",e:5}],"-1#472712432":[{m:"e5xf4",e:5}],"1#1002007346":[{m:"g3xf4",e:5}],"-1#-1177585091":[{m:"Qd8-d7",e:5}],"1#2053930865":[{m:"Kg1-h2",e:5}],"-1#2123408346":[{m:"d6-d5",e:5}],"1#1747753401":[],"-1#-323255781":[{m:"c7-c6",e:6.667},{m:"f7-f5",e:6.667}],"1#-464234915":[{m:"Bc1-e3",e:7.5}],"1#2060518195":[{m:"O-O",e:5}],"-1#1619845831":[{m:"Nd7-f6",e:8},{m:"Nd7-c5",e:8}],"1#1798338709":[{m:"h2-h3",e:7.5}],"1#1840665163":[{m:"Ra1-c1",e:5}],"-1#519064003":[{m:"e7-e5",e:9.5},{m:"Bc8-g4",e:9.5}],"1#2108533015":[{m:"g2-g3",e:9}],"-1#-700753634":[{m:"g7-g6",e:7.5}],"1#-810216165":[{m:"Bf1-g2",e:7.5}],"-1#-2133821362":[{m:"Bf8-g7",e:6.667}],"1#-1896261508":[{m:"d2-d4",e:8.889}],"-1#1926820380":[{m:"Nb8-c6",e:8}],"1#-901113536":[{m:"d4xe5",e:8.75},{m:"Bc1-e3",e:8.75},{m:"d4-d5",e:8.75},{m:"e2-e3",e:8.75},{m:"Bc1-g5",e:8.75}],"-1#-1326783475":[{m:"d6xe5",e:6.667}],"1#1838912713":[{m:"O-O",e:6.667}],"-1#2009494845":[{m:"Qd8xd1",e:5}],"1#-1899705315":[{m:"Rf1xd1",e:5}],"-1#-1981981563":[{m:"e5-e4",e:5}],"1#339515754":[{m:"Nf3-g5",e:5}],"-1#-838383578":[{m:"f7-f5",e:5}],"1#1483589902":[{m:"O-O",e:5}],"-1#1110452474":[{m:"Ng8-f6",e:5}],"-1#815524298":[{m:"Nc6-e7",e:6.667}],"1#-1596527569":[{m:"Nb1-c3",e:6.667}],"-1#292213049":[{m:"f7-f5",e:8}],"1#-2030022639":[{m:"O-O",e:6.667}],"-1#-1654803995":[{m:"Ng8-f6",e:5}],"-1#1961088335":[{m:"f7-f5",e:5}],"1#-494316441":[{m:"Nb1-c3",e:5}],"-1#1396009329":[{m:"Ng8-f6",e:5}],"1#-725894144":[],"-1#668077659":[{m:"f7-f6",e:5}],"1#64244621":[{m:"Bg5-e3",e:5}],"-1#-576809500":[{m:"e5-e4",e:5}],"1#1082085387":[{m:"Nf3-g1",e:5}],"-1#-1191415326":[{m:"f6-f5",e:5}],"1#747034566":[{m:"Qd1-b3",e:8}],"-1#1480238088":[{m:"Qd8-c8",e:7.5}],"1#-1630636734":[{m:"d2-d4",e:6.667}],"-1#1659887394":[{m:"Nb8-d7",e:6.667}],"1#-1324152163":[{m:"g2-g3",e:8}],"-1#444988052":[{m:"e7-e5",e:6.667}],"1#2044205632":[{m:"Bf1-g2",e:8}],"-1#918386453":[{m:"c7-c6",e:7.5}],"1#1045603155":[{m:"O-O",e:7.5}],"-1#604979879":[{m:"Bf8-e7",e:7.5}],"1#-1132616913":[{m:"Qb3-e3",e:7.5},{m:"Rf1-d1",e:7.5}],"-1#-1831479762":[{m:"f7-f6",e:5}],"1#-1227648008":[{m:"Nb1-c3",e:5}],"-1#124759790":[{m:"Ng8-h6",e:5}],"1#-1879539535":[{m:"d4-d5",e:5}],"-1#1965649979":[{m:"Nd7-b6",e:5}],"1#-740327610":[{m:"Qe3-d3",e:5}],"-1#1902096948":[{m:"Nh6-f7",e:5}],"1#1693787099":[{m:"e2-e4",e:5}],"-1#573811878":[{m:"g7-g5",e:5}],"1#-613719546":[{m:"Bc1-e3",e:5}],"-1#-1728305213":[{m:"h7-h5",e:5}],"-1#-635276161":[{m:"Ng8-f6",e:6.667}],"1#1571594510":[{m:"Nb1-c3",e:6.667}],"-1#-334455784":[{m:"O-O",e:6.667}],"1#1208439137":[{m:"Qb3-c2",e:6.667},{m:"Bc1-e3",e:6.667}],"-1#-582596148":[{m:"Rf8-e8",e:5}],"1#-1680326900":[{m:"b2-b3",e:5}],"-1#-1220532041":[{m:"Be7-f8",e:5}],"-1#193991844":[{m:"Rf8-e8",e:5}],"1#1292788324":[{m:"Ra1-c1",e:5}],"-1#780473583":[{m:"e5xd4",e:5}],"1#-350539409":[{m:"Nb1-c3",e:9.998},{m:"b2-b3",e:9.998},{m:"Ng1-f3",e:9.998},{m:"g2-g3",e:9.998}],"-1#1520897145":[{m:"g7-g6",e:9.996},{m:"e7-e5",e:9.996},{m:"Ng8-f6",e:9.996},{m:"Nb8-c6",e:9.996},{m:"b7-b6",e:9.996}],"1#1126776956":[{m:"g2-g3",e:9.884},{m:"d2-d4",e:9.884}],"-1#-390090635":[{m:"c7-c5",e:9.932}],"1#-426340281":[{m:"e2-e3",e:9.897},{m:"Bf1-g2",e:9.897}],"-1#1480547400":[{m:"Nb8-c6",e:5}],"1#-525486316":[{m:"Bf1-g2",e:6.667}],"-1#-1345791423":[{m:"e7-e5",e:9.94},{m:"Ng8-h6",e:9.94}],"-1#-1443627758":[{m:"Ng8-f6",e:9.938},{m:"e7-e6",e:9.938},{m:"Nb8-c6",e:9.938}],"1#779954275":[{m:"d2-d3",e:9.756}],"-1#-1089934820":[{m:"c5xd4",e:8.571}],"1#-1926187503":[{m:"Qd1xd4",e:8.571}],"1#972745901":[{m:"e2-e3",e:8.333}],"-1#-2024595294":[{m:"Nb8-c6",e:7.5}],"1#1069665278":[{m:"Ng1-f3",e:8.333}],"-1#-951916009":[{m:"f7-f5",e:9.6},{m:"Ng8-f6",e:9.6}],"1#-584460024":[{m:"g2-g3",e:9.991},{m:"e2-e4",e:9.991},{m:"Ng1-f3",e:9.991}],"-1#1992239361":[{m:"g7-g6",e:9.953}],"-1#631961825":[{m:"g7-g6",e:9.992}],"1#-499783899":[{m:"e2-e3",e:9.994},{m:"Ng1-f3",e:9.994},{m:"g2-g3",e:9.994}],"-1#448186060":[{m:"Nc6-d4",e:9.982}],"-1#1235425068":[{m:"e7-e5",e:9.993}],"1#237099883":[{m:"Ng1-f3",e:9.756},{m:"e2-e4",e:9.756},{m:"d2-d4",e:9.756},{m:"e2-e3",e:9.756}],"-1#-1333258396":[{m:"Bc8-b7",e:8.571}],"-1#-947706156":[{m:"Ng8-f6",e:9.545},{m:"e7-e5",e:9.545},{m:"Nb8-c6",e:9.545}],"1#1074656165":[{m:"Bc1-b2",e:8.889}],"-1#1413976500":[{m:"b7-b6",e:8.889},{m:"g7-g6",e:8.889}],"1#12666534":[{m:"Bb2xf6",e:5}],"-1#966499617":[{m:"g7xf6",e:5}],"1#-1477293144":[{m:"g2-g3",e:5}],"1#1305075121":[{m:"Bb2xf6",e:6.667}],"-1#1955792438":[{m:"e7xf6",e:6.667}],"1#-1765144786":[{m:"Nb1-c3",e:6.667}],"-1#662059576":[{m:"Bf8-g7",e:6.667}],"1#-1528904192":[{m:"Bc1-b2",e:8.75}],"-1#-1332435951":[{m:"d7-d6",e:8.571},{m:"Nb8-c6",e:8.571}],"1#-158887370":[{m:"Ng1-f3",e:5}],"-1#235189215":[{m:"f7-f5",e:5}],"1#-1737608457":[{m:"g2-g3",e:5}],"-1#871940862":[{m:"Bf8-e7",e:5}],"1#134631245":[{m:"g2-g3",e:9},{m:"e2-e3",e:9}],"-1#-1230011582":[{m:"g7-g6",e:8.75}],"1#2131873160":[{m:"Bc1-b2",e:8.571}],"-1#1801170841":[{m:"Ng8-f6",e:8.75}],"1#-321553688":[{m:"g2-g3",e:7.5},{m:"c2-c4",e:8.75}],"-1#1195608801":[{m:"d7-d5",e:5}],"1#1739131410":[{m:"c4xd5",e:5}],"-1#-256248354":[{m:"Nf6xd5",e:8.333},{m:"Rb8-a8",e:8.333}],"1#-1367282867":[{m:"Qa6-b7",e:8}],"-1#341203713":[{m:"d7-d5",e:8}],"1#884792306":[{m:"c4xd5",e:5}],"-1#-1548999618":[{m:"Nf6xd5",e:5}],"1#1259130966":[{m:"e2-e3",e:8},{m:"a2-a3",e:8}],"-1#328732806":[{m:"b7-b6",e:9.996},{m:"Nb8-c6",e:9.996},{m:"d7-d6",e:9.996},{m:"e7-e6",e:9.996},{m:"g7-g6",e:9.996},{m:"Ng8-f6",e:9.996},{m:"h7-h6",e:9.996}],"1#1193199508":[{m:"g2-g3",e:9.792},{m:"e2-e3",e:9.792},{m:"Ng1-f3",e:9.756}],"1#-1425343526":[{m:"g2-g3",e:9.974},{m:"e2-e3",e:9.974},{m:"b2-b3",e:9.974},{m:"d2-d4",e:9.974}],"1#1435182753":[{m:"b2-b3",e:8.571},{m:"d2-d4",e:8.571}],"-1#2031300890":[{m:"g7-g6",e:8}],"-1#-1448440639":[{m:"c5xd4",e:7.5}],"1#1148090707":[{m:"c2-c4",e:9.889}],"-1#-1202728141":[{m:"c5xd4",e:9.565}],"1#-1971876034":[{m:"Nf3xd4",e:9.444}],"-1#1899115810":[{m:"a7-a6",e:9.444},{m:"b7-b6",e:9.444}],"1#1277094929":[{m:"g2-g3",e:8}],"-1#-410510312":[{m:"Qd8-c7",e:6.667}],"1#-1466834644":[{m:"Qd1-d3",e:6.667}],"-1#1342515857":[{m:"b7-b5",e:5}],"1#126631274":[{m:"Nb1-a3",e:5}],"-1#1237794245":[{m:"Bc8-b7",e:5}],"1#-771094431":[{m:"Nd4-f3",e:5}],"-1#1893041642":[{m:"Bf8-b4+",e:5}],"1#632611376":[{m:"Nd4-b5",e:6.667}],"-1#-784059974":[{m:"d7-d6",e:6.667}],"1#-1755904099":[{m:"Bc1-f4",e:6.667}],"-1#-1570987585":[{m:"e6-e5",e:6.667}],"1#-424500215":[{m:"Qd1-d5",e:6.667}],"-1#1385885633":[{m:"a7-a6",e:6.667}],"1#1874212594":[{m:"Qd5xa8",e:6.667}],"1#169237635":[{m:"d2-d4",e:9.947},{m:"g2-g3",e:9.947}],"-1#-164104477":[{m:"c5xd4",e:9.891}],"1#-1810446857":[{m:"d2-d3",e:9.996},{m:"g2-g3",e:9.996},{m:"b2-b3",e:9.996},{m:"d2-d4",e:9.996}],"1#1186617270":[{m:"d2-d4",e:5}],"-1#-1164182058":[{m:"g7-g5",e:5}],"1#1136866166":[{m:"d4xc5",e:5}],"-1#1083031910":[{m:"d7-d5",e:9.911},{m:"g7-g6",e:9.911},{m:"Nb8-c6",e:9.911},{m:"g7-g5",e:9.911}],"1#1617379733":[{m:"c4xd5",e:6.667}],"-1#-143147431":[{m:"Qd8xd5",e:6.667}],"1#-303840625":[{m:"Ng1-f3",e:6.667}],"-1#358671206":[{m:"Nb8-c6",e:6.667}],"1#-1376647110":[{m:"Bf1-g2",e:6.667}],"-1#-493394577":[{m:"Bc8-g4",e:6.667}],"1#-790496406":[{m:"h2-h3",e:6.667}],"1#1493405027":[{m:"d2-d4",e:9.796},{m:"Bf1-g2",e:9.796}],"-1#-1524488445":[{m:"c5xd4",e:8.75}],"1#-1759872242":[{m:"Qd1xd4",e:8.75}],"-1#375840822":[{m:"Bf8-g7",e:9.804}],"1#407879684":[{m:"Bf1-g2",e:9.897}],"1#-132175302":[{m:"Bf1-g2",e:9.783}],"-1#-1216723089":[{m:"Nb8-c6",e:7.5},{m:"b7-b6",e:9.828},{m:"g7-g6",e:9.828}],"1#-469987203":[{m:"e2-e3",e:5}],"-1#1565875314":[{m:"Bc8-b7",e:5}],"1#-1359738006":[{m:"e2-e3",e:9.792}],"1#-1177219130":[{m:"Nb1-c3",e:5}],"-1#141112016":[{m:"d7-d6",e:5}],"1#1316619511":[{m:"d2-d4",e:5}],"-1#-1302614377":[{m:"c5xd4",e:5}],"1#-2140933478":[{m:"Qd1xd4",e:5}],"-1#1071587313":[{m:"f7-f6",e:5}],"1#467229223":[{m:"b2-b3",e:5}],"1#-1019363623":[{m:"d2-d3",e:9.998},{m:"e2-e3",e:9.998},{m:"Nb1-c3",e:9.998},{m:"e2-e4",e:9.998},{m:"Qd1-c2",e:9.998},{m:"g2-g3",e:9.998},{m:"Ng1-f3",e:9.998},{m:"h2-h4",e:9.998},{m:"a2-a3",e:9.998},{m:"b2-b3",e:9.998}],"-1#-318779320":[{m:"Ng8-f6",e:9.091},{m:"f7-f5",e:9.091}],"1#1802569017":[{m:"Ng1-f3",e:8}],"-1#-1812847408":[{m:"Bf8-b4+",e:8}],"1#-689553":[{m:"Nb1-d2",e:5}],"-1#804633906":[{m:"Qd8-e7",e:5}],"1#1675319034":[{m:"e2-e3",e:5}],"1#2056606048":[{m:"g2-g3",e:6.667}],"-1#-788291223":[{m:"Ng8-f6",e:6.667}],"1#1452110872":[{m:"Bf1-g2",e:6.667}],"-1#434641229":[{m:"g7-g6",e:8.75},{m:"Bf8-b4+",e:8.75}],"-1#2106880726":[{m:"Ng8-f6",e:9.091}],"1#-98916441":[{m:"a2-a3",e:8.75}],"-1#-307530626":[{m:"g7-g6",e:7.5},{m:"c7-c6",e:7.5}],"1#-198887301":[{m:"Nb1-c3",e:5}],"-1#1167656301":[{m:"Bf8-g7",e:5}],"1#1269835103":[{m:"Ng1-f3",e:5}],"-1#-1288502090":[{m:"Qd8-e7",e:5}],"1#-448487368":[{m:"Ng1-f3",e:6.667}],"-1#499614161":[{m:"e5-e4",e:6.667}],"1#-2144975810":[{m:"Nf3-d4",e:6.667}],"-1#586795445":[{m:"g7-g6",e:6.667}],"-1#1921090511":[{m:"Bf8-b4",e:9.998},{m:"g7-g6",e:9.998},{m:"Nb8-c6",e:9.998},{m:"Ng8-f6",e:9.998},{m:"f7-f5",e:9.998},{m:"d7-d6",e:9.998}],"1#512154992":[{m:"g2-g3",e:9.971}],"1#1796198346":[{m:"Ng1-f3",e:9.808}],"1#-904697709":[{m:"e2-e3",e:9.997}],"1#-183544130":[{m:"e2-e4",e:9.992}],"1#-454360345":[{m:"g2-g3",e:9.839}],"1#882030056":[{m:"Ng1-f3",e:9.984}],"-1#-2047135324":[{m:"Bf8-c5",e:8.889}],"1#1698411447":[{m:"Nb1-c3",e:6.667}],"-1#-729313631":[{m:"d7-d6",e:5}],"1#-1835747194":[{m:"g2-g3",e:5}],"-1#956450959":[{m:"Nb8-c6",e:5}],"1#-2121227309":[{m:"Bf1-g2",e:5}],"-1#-822751610":[{m:"f7-f5",e:5}],"1#1486835630":[{m:"d2-d3",e:5}],"-1#2002592063":[{m:"Ng8-f6",e:5}],"1#-254544818":[{m:"Ng1-h3",e:5}],"-1#233451246":[{m:"O-O",e:5}],"1#-1442978921":[{m:"O-O",e:5}],"-1#1384470797":[{m:"d7-d6",e:5}],"1#345403178":[{m:"Ng1-f3",e:5}],"-1#-334147901":[{m:"f7-f5",e:5}],"1#2055196651":[{m:"d2-d4",e:5}],"-1#-2040633973":[{m:"e5-e4",e:5}],"1#465543268":[{m:"Nf3-g5",e:5}],"-1#-1048284888":[{m:"c7-c6",e:5}],"1#-915692178":[{m:"Nb1-c3",e:5}],"-1#2027395192":[{m:"Ng8-f6",e:5}],"1#-10924791":[{m:"d4-d5",e:5}],"-1#92847491":[{m:"Bf8-e7",e:5}],"1#-1644536821":[],"-1#1756057296":[{m:"h7-h5",e:9.983},{m:"f7-f5",e:9.983},{m:"c7-c6",e:9.983},{m:"g7-g6",e:9.983},{m:"d7-d5",e:9.983},{m:"Ng8-f6",e:9.983},{m:"d7-d6",e:9.983}],"1#1244698799":[{m:"Ng1-f3",e:7.5}],"1#1615108758":[{m:"d2-d4",e:9.844}],"1#1898250965":[{m:"d2-d4",e:9.737}],"1#-282747999":[{m:"Bf1-g2",e:9.969}],"1#783841527":[{m:"Nb1-c3",e:9.688}],"-1#1002348336":[{m:"e5-e4",e:9.667},{m:"Nb8-c6",e:9.667}],"1#-1503700257":[{m:"Nf3-d4",e:9.444}],"-1#75552596":[{m:"Ng8-f6",e:9.444},{m:"Nb8-c6",e:9.444},{m:"c7-c5",e:9.444}],"1#1341896758":[{m:"Nd4-c2",e:5}],"1#-2094238612":[{m:"d2-d4",e:9.412},{m:"g2-g3",e:9.412}],"-1#2131615244":[{m:"e5xd4",e:5}],"-1#683312229":[{m:"e5-e4",e:8.333}],"1#-1252310646":[{m:"Nf3-h4",e:8.333}],"-1#2025502293":[{m:"Nb8-c6",e:5}],"1#-1071096567":[{m:"e2-e3",e:5}],"-1#2122420486":[{m:"Ng8-f6",e:5}],"1#-116439945":[{m:"a2-a3",e:5}],"-1#-289499218":[{m:"d7-d5",e:5}],"1#-833349795":[{m:"c4xd5",e:5}],"-1#1497688209":[{m:"Nf6xd5",e:5}],"1#-1310450439":[{m:"Qd1-c2",e:5}],"-1#542964525":[{m:"Bf8-d6",e:5}],"1#-305638086":[{m:"Ng1-f3",e:5}],"-1#357266643":[{m:"Qd8-e7",e:5}],"1#1499832091":[{m:"d2-d3",e:5}],"-1#-728994560":[{m:"d7-d6",e:8.571}],"1#-1835050201":[{m:"Nb1-c3",e:7.5}],"-1#589522481":[{m:"g7-g6",e:7.5}],"1#984427060":[{m:"e2-e3",e:7.5}],"-1#-2080053701":[{m:"Bf8-g7",e:7.5}],"1#-1976711671":[{m:"Ng1-f3",e:7.5}],"-1#1924065248":[{m:"Ng8-h6",e:7.5},{m:"f7-f5",e:7.5}],"1#-96876097":[{m:"Bf1-e2",e:6.667},{m:"d2-d4",e:6.667}],"1#-456890680":[],"-1#-274355870":[{m:"Nb8-c6",e:9}],"1#1463239230":[{m:"c2-c4",e:9.946}],"-1#1132273711":[{m:"g7-g6",e:9.767},{m:"Ng8-f6",e:9.767}],"1#1525902378":[{m:"Ng1-f3",e:8.571}],"-1#-1569698365":[{m:"Bf8-g7",e:5}],"1#-1403425295":[{m:"e2-e3",e:5}],"-1#317759998":[{m:"d7-d6",e:5}],"1#-990644898":[{m:"Ng1-f3",e:9.697},{m:"e2-e3",e:9.697},{m:"Nb1-c3",e:9.697},{m:"g2-g3",e:9.697}],"-1#1968162888":[{m:"d7-d5",e:8}],"1#-141150248":[{m:"Ng1-f3",e:9.994},{m:"g2-g3",e:9.994},{m:"Nb1-c3",e:9.994}],"-1#253040177":[{m:"d7-d5",e:9.992},{m:"Ng8-f6",e:9.992}],"1#805279426":[{m:"g2-g3",e:9.992},{m:"b2-b3",e:9.992}],"-1#-2073467189":[{m:"c7-c6",e:9.989},{m:"b7-b6",e:9.989},{m:"Ng8-f6",e:9.989},{m:"c7-c5",e:9.989},{m:"d5xc4",e:9.989}],"1#-1937329523":[{m:"Bf1-g2",e:9.722}],"1#-789597735":[{m:"Bf1-g2",e:5}],"1#65516474":[{m:"Bf1-g2",e:9.99}],"1#-134414398":[{m:"Bf1-g2",e:9.783}],"-1#57115001":[{m:"d5-d4",e:9.936},{m:"Ng8-f6",e:9.936},{m:"Bf8-e7",e:9.936},{m:"a7-a5",e:9.936},{m:"c7-c5",e:9.936}],"1#-1892933652":[{m:"e2-e3",e:8.333}],"1#-2065083384":[{m:"d2-d3",e:9.917}],"1#-1693097743":[{m:"Bc1-b2",e:9.5}],"1#1209855515":[{m:"g2-g3",e:9.286}],"1#-2003057856":[{m:"b2-b3",e:9.986},{m:"e2-e3",e:9.986},{m:"g2-g3",e:9.986}],"-1#-1543252741":[{m:"b7-b6",e:9.706},{m:"c7-c5",e:9.706}],"1#-259718167":[{m:"Bc1-b2",e:9.333}],"-1#-456171016":[{m:"Ng8-f6",e:9}],"1#2130859100":[{m:"e2-e3",e:9.545},{m:"g2-g3",e:9.545}],"-1#-1045718957":[{m:"d7-d5",e:9.583},{m:"Bf8-e7",e:9.583}],"1#1507424731":[{m:"Bf1-e2",e:9.286}],"-1#-728456107":[{m:"Bb7xf3",e:6.667}],"1#748531105":[{m:"e2xf3",e:6.667}],"-1#-1915006459":[{m:"c7-c5",e:6.667}],"1#-277300327":[{m:"Bc1-b2",e:9.5}],"-1#-80553592":[{m:"Bf8-e7",e:9.545}],"-1#909250383":[{m:"d7-d5",e:9}],"1#383291324":[{m:"b2-b3",e:9.722}],"-1#977311751":[{m:"Bf8-d6",e:9.643},{m:"Bf8-e7",e:9.643}],"1#-137087472":[{m:"e2-e3",e:9}],"-1#588067657":[{m:"a7-a6",e:9.972},{m:"b7-b6",e:9.972}],"1#505539194":[{m:"Bf1-g2",e:9.706},{m:"Qd1-a4",e:9.706}],"1#2005656667":[{m:"Bf1-g2",e:9.911}],"-1#955156750":[{m:"Bc8-b7",e:9.912}],"-1#1543555025":[{m:"d7-d5",e:9.947}],"1#2095728418":[{m:"Bf1-g2",e:9.939},{m:"c4xd5",e:9.939}],"-1#865020535":[{m:"g7-g6",e:9.931},{m:"Ng8-f6",e:9.931},{m:"c7-c6",e:9.931},{m:"d5xc4",e:9.931}],"1#704734834":[{m:"Qd1-b3",e:9.767},{m:"d2-d4",e:9.767},{m:"Ng1-f3",e:9.767}],"-1#-763213925":[{m:"Bf8-g7",e:9.796}],"1#-1274937594":[{m:"b2-b3",e:9.894}],"-1#-1734743875":[{m:"d5xc4",e:8.333}],"1#-351505996":[{m:"b3xc4",e:5}],"-1#-1145172559":[{m:"Qd8-d4",e:5}],"1#996212273":[{m:"d2-d4",e:9.474},{m:"Qd1-c2",e:9.474}],"-1#-952019887":[{m:"f7-f5",e:8}],"-1#-1428678171":[{m:"c6-c5",e:8.571}],"1#1075491710":[{m:"Nb1-a3",e:9.667},{m:"Qd1-a4+",e:9.667}],"-1#240235473":[{m:"Bf8xa3",e:8.571}],"-1#-2100845269":[{m:"Nb8-d7",e:9.545}],"-1#-335890194":[{m:"e6xd5",e:7.5}],"1#-969951693":[{m:"Bf1-g2",e:7.5}],"-1#-1991582874":[{m:"Ng8-f6",e:6.667}],"1#247729687":[{m:"Ng1-f3",e:8.571}],"-1#-163106818":[{m:"Bf8-e7",e:8}],"1#1849020022":[{m:"O-O",e:8},{m:"d2-d3",e:8}],"-1#1952984962":[{m:"O-O",e:7.5}],"1#-796925189":[{m:"d2-d3",e:9.167},{m:"d2-d4",e:9.167},{m:"b2-b3",e:9.167}],"-1#-4354966":[{m:"c7-c5",e:8},{m:"c7-c6",e:8}],"1#-1262034168":[{m:"Nb1-d2",e:7.5}],"-1#1690707029":[{m:"Nb8-c6",e:5}],"1#-145598420":[{m:"Nb1-d2",e:7.5}],"-1#744376475":[{m:"h7-h6",e:8.571}],"-1#-51907264":[{m:"a7-a5",e:6.667}],"-1#1106747623":[{m:"O-O",e:5}],"1#-438276706":[{m:"d2-d3",e:9.167}],"-1#1177160398":[{m:"Bf8-b4",e:9.968},{m:"f7-f5",e:9.968},{m:"d7-d5",e:9.968}],"1#707613809":[{m:"e2-e4",e:9.783},{m:"g2-g3",e:9.783},{m:"Qd1-c2",e:9.783},{m:"Ng1-f3",e:9.783},{m:"Qd1-b3",e:9.783}],"-1#1827396364":[{m:"c7-c5",e:9.091},{m:"Ng8-e7",e:9.091}],"-1#-2118409096":[{m:"Bb4xc3",e:7.5},{m:"Ng8-e7",e:7.5}],"-1#-1147817051":[{m:"c7-c5",e:9.474},{m:"b7-b6",e:9.474}],"-1#-760318568":[{m:"d7-d5",e:6.667}],"-1#1586571199":[{m:"Bb4-a5",e:9.167}],"1#-801076250":[{m:"e2-e4",e:9.286}],"-1#-1769601893":[{m:"f5xe4",e:7.5}],"1#-643240833":[{m:"Nc3xe4",e:7.5}],"-1#1257338639":[{m:"Ng8-f6",e:7.5}],"1#-847273346":[{m:"Bf1-d3",e:7.5},{m:"Ne4xf6+",e:7.5}],"-1#-102036252":[{m:"Nb8-c6",e:5}],"1#1098508216":[{m:"Ng1-f3",e:5}],"-1#-1174747567":[{m:"g7-g6",e:5}],"1#-1602975148":[{m:"Ne4xf6+",e:5}],"-1#2145134850":[{m:"Qd8xf6",e:5}],"1#2098581619":[{m:"Ng1-f3",e:5}],"-1#-2053705318":[{m:"Nb8-c6",e:5}],"1#1723894333":[{m:"d2-d4",e:9.952},{m:"c4xd5",e:9.952}],"-1#-1696522147":[{m:"c7-c6",e:9.999},{m:"Bf8-e7",e:9.999},{m:"Bf8-b4",e:9.999},{m:"c7-c5",e:9.999},{m:"Ng8-f6",e:9.999}],"-1#-237996559":[{m:"e6xd5",e:9.73}],"1#-603620564":[{m:"d2-d4",e:9.73}],"-1#539283788":[{m:"Bf8-e7",e:9.863},{m:"c7-c6",e:9.863}],"1#-1202310972":[{m:"Bc1-f4",e:9.953}],"1#684393738":[{m:"Qd1-c2",e:9.91}],"1#-186218209":[{m:"d2-d4",e:9.951},{m:"e2-e4",e:9.951},{m:"b2-b3",e:9.951},{m:"c2-c4",e:9.825},{m:"Nb1-c3",e:9.951}],"-1#147268479":[{m:"Bc8-b7",e:9.815},{m:"c7-c5",e:9.815}],"1#-1828055333":[{m:"Nb1-c3",e:9.667},{m:"Bc1-g5",e:9.667}],"-1#582364109":[{m:"e7-e6",e:9.643}],"1#1967145496":[{m:"e2-e3",e:9.897},{m:"Ng1-f3",e:9.897},{m:"a2-a3",e:9.897}],"-1#-873886185":[{m:"f7-f5",e:9.091}],"1#1568870207":[{m:"Ng1-e2",e:8.889}],"-1#-1035083072":[{m:"Ng8-f6",e:6.667}],"-1#-1916574735":[{m:"Bf8-b4",e:9.643}],"1#-507232946":[{m:"Qd1-b3",e:9.63},{m:"Qd1-c2",e:9.63}],"-1#1887230618":[{m:"c7-c5",e:8}],"-1#1659998657":[{m:"Ng8-f6",e:9.882},{m:"f7-f5",e:9.882}],"1#-191164183":[{m:"Ng1-h3",e:9.851}],"-1#2123497920":[{m:"h7-h6",e:8.571},{m:"Ng8-f6",e:8.571},{m:"f7-f6",e:8.571}],"1#732972784":[{m:"Bg5-h4",e:5}],"-1#-456907827":[{m:"Ng8-f6",e:5}],"1#1665857212":[{m:"Nb1-c3",e:5}],"1#-115551055":[{m:"Bg5xf6",e:6.667}],"-1#966031932":[{m:"e7xf6",e:6.667}],"1#-607290588":[{m:"Nb1-c3",e:6.667}],"-1#1785808434":[{m:"Bf8-b4",e:6.667}],"1#1519666198":[{m:"Bg5-d2",e:7.5}],"-1#-366501665":[{m:"e7-e6",e:6.667}],"1#-1110324982":[{m:"Ng1-f3",e:6.667}],"-1#1163061475":[{m:"f6-f5",e:6.667}],"1#1136413725":[{m:"d4-d5",e:5}],"-1#-1183990633":[{m:"d7-d6",e:5}],"1#-8484176":[{m:"Ng1-f3",e:5}],"-1#134064985":[{m:"Ng8-f6",e:5}],"1#-2139914712":[{m:"Nb1-c3",e:5}],"-1#835666750":[{m:"g7-g6",e:5}],"1#675352379":[{m:"e2-e4",e:5}],"-1#1854373958":[{m:"Bf8-g7",e:5}],"1#1622057076":[{m:"Bf1-e2",e:5}],"-1#-1555248270":[{m:"O-O",e:5}],"1#123405835":[{m:"Bc1-g5",e:5}],"-1#-356314864":[{m:"Bc8-g4",e:5}],"1#-659189995":[{m:"O-O",e:5}],"-1#-1024954655":[{m:"Bg4xf3",e:5}],"1#-1822765900":[{m:"Be2xf3",e:5}],"-1#-1235774387":[{m:"Nb8-d7",e:5}],"1#1705722354":[{m:"Qd1-d2",e:5}],"-1#361104917":[],"-1#-1306524062":[{m:"Bc8-b7",e:9.744}],"1#703411142":[{m:"Nb1-c3",e:9.744}],"-1#-1739518256":[{m:"e7-e6",e:9.89}],"1#-811112699":[{m:"Ng1-f3",e:9.9},{m:"d2-d3",e:9.9},{m:"g2-g3",e:9.9},{m:"b2-b3",e:9.9}],"-1#925124332":[{m:"Bf8-b4",e:9.851},{m:"c7-c5",e:9.851}],"1#1529026643":[{m:"d2-d3",e:9.825},{m:"Bf1-d3",e:9.825},{m:"Qd1-b3",e:9.825}],"-1#1960933058":[{m:"Ng8-e7",e:8}],"1#-1658134198":[{m:"Bf1-e2",e:8}],"1#2086611342":[{m:"d2-d4",e:9.474},{m:"Bf1-d3",e:9.474}],"-1#-2139192338":[{m:"c5xd4",e:8.889}],"-1#-530249324":[{m:"Bf8-b4",e:8.333},{m:"c7-c5",e:8.333}],"1#-1939712213":[{m:"d2-d3",e:9.825}],"1#-1424070922":[{m:"g2-g3",e:5}],"-1#8951551":[{m:"Ng8-f6",e:5}],"1#-2029632626":[{m:"Bf1-g2",e:5}],"-1#-933024037":[{m:"Bf8-e7",e:5}],"-1#1680971532":[{m:"Bf8-b4",e:9.333}],"1#137808307":[{m:"Ng1-e2",e:8.889}],"-1#-1745345460":[{m:"f7-f5",e:8.889}],"1#26387812":[{m:"Bf1-g2",e:8.889}],"-1#1324861489":[{m:"f5xe4",e:8.889},{m:"Ng8-f6",e:8.889}],"1#31006933":[{m:"Nc3xe4",e:8}],"1#-914809536":[{m:"f2-f3",e:8}],"-1#1601688558":[{m:"f5xe4",e:6.667}],"-1#-482381634":[{m:"Ng8-f6",e:5}],"1#1689363919":[{m:"e4-e5",e:5}],"-1#-1253377704":[{m:"Nf6-e4",e:5}],"1#-24840069":[{m:"Nc3xe4",e:5}],"-1#-1137052006":[{m:"Bb7xe4",e:5}],"1#-758058287":[{m:"Bc1-b2",e:5}],"-1#-962948928":[{m:"Nb8-c6",e:5}],"1#2114485148":[{m:"h2-h4",e:5}],"-1#-662790492":[{m:"Bc8-b7",e:9.286}],"1#1135848192":[{m:"Bc1-b2",e:9.231}],"-1#1475987729":[{m:"Ng8-f6",e:9.286},{m:"e7-e6",e:9.286}],"1#-797500320":[{m:"Ng1-f3",e:8}],"-1#687095177":[{m:"g7-g6",e:8}],"1#830108044":[{m:"e2-e3",e:8}],"-1#-1881948797":[{m:"Bf8-g7",e:7.5}],"1#-2114282063":[{m:"Bf1-e2",e:7.5}],"-1#1108932279":[{m:"c7-c5",e:7.5}],"1#157522389":[{m:"O-O",e:8}],"-1#322861089":[{m:"O-O",e:8}],"1#-1222003368":[{m:"d2-d3",e:9.231},{m:"a2-a3",e:9.231},{m:"Nb1-c3",e:9.231}],"-1#-1729373239":[{m:"Nb8-c6",e:8}],"1#544813205":[{m:"d2-d3",e:6.667},{m:"Rf1-e1",e:8}],"-1#-1600625023":[{m:"Nb8-c6",e:5}],"1#403344861":[{m:"d2-d3",e:6.667}],"-1#110463054":[{m:"e7-e6",e:8.333},{m:"Nb8-c6",e:8.333},{m:"Nb8-a6",e:8.333}],"1#1024196":[{m:"Ng1-f3",e:8.889}],"-1#-125009619":[{m:"f7-f5",e:9},{m:"Ng8-f6",e:9}],"1#1860567045":[{m:"g2-g3",e:6.667}],"-1#-982454260":[{m:"Ng8-f6",e:6.667}],"1#1123951997":[{m:"Bc1-b2",e:5}],"-1#228280360":[{m:"Bf8-e7",e:8},{m:"g7-g6",e:8}],"1#-1779848800":[{m:"d2-d3",e:6.667}],"-1#-1171536079":[{m:"O-O",e:5}],"1#507251272":[{m:"Nb1-d2",e:5}],"-1#-834876139":[{m:"Qd8-e8",e:5}],"1#1586363995":[{m:"Qd1-c2",e:5}],"1#336921645":[{m:"O-O",e:5}],"-1#239658457":[{m:"Bf8-g7",e:5}],"1#6407659":[{m:"Nb1-c3",e:5}],"-1#-1310852867":[{m:"O-O",e:5}],"1#365573508":[{m:"d2-d3",e:5}],"-1#207988982":[{m:"Bc8-b7",e:9.756}],"1#-1750557358":[{m:"Nb1-c3",e:9.75},{m:"g2-g3",e:9.75}],"-1#638885956":[{m:"e7-e6",e:9.444}],"1#1910688145":[{m:"g2-g3",e:9.444}],"-1#-629917288":[{m:"Bf8-b4",e:8.333}],"1#-1233950937":[{m:"Bf1-g2",e:6.667}],"-1#-115996046":[{m:"Bb4xc3",e:6.667}],"1#844213898":[{m:"b2xc3",e:5}],"-1#-164416219":[{m:"Ng8-e7",e:5}],"1#536388269":[{m:"O-O",e:5}],"-1#94716761":[{m:"O-O",e:5}],"1#-1582133728":[{m:"a2-a4",e:5}],"-1#2143461425":[{m:"Nb8-c6",e:5}],"1#-951039123":[{m:"d2-d3",e:5}],"-1#-393075204":[{m:"Nc6-a5",e:5}],"1#-144539176":[{m:"e2-e4",e:5}],"-1#-1314648411":[{m:"f7-f5",e:5}],"1#667848589":[{m:"e4xf5",e:5}],"-1#1239311182":[{m:"Ne7xf5",e:5}],"1#-71859263":[{m:"Bc1-f4",e:5}],"-1#-826530333":[{m:"Nf5-e7",e:5}],"1#-1369569943":[{m:"Bf4-e3",e:5}],"-1#-1467520455":[{m:"Ne7-g6",e:5}],"1#1929277653":[{m:"Nf3-g5",e:5}],"-1#-1463443047":[{m:"Bb7xg2",e:5}],"1#-1576006370":[{m:"Qd1-h5",e:5}],"-1#42664577":[{m:"h7-h6",e:5}],"1#1470711217":[{m:"Qh5xg6",e:5}],"-1#-1312727941":[{m:"h6xg5",e:5}],"1#-1963246026":[{m:"Be3xg5",e:5}],"-1#1148364697":[{m:"Bg2-e4",e:5}],"1#235573217":[{m:"d3xe4",e:5}],"-1#-1823804859":[{m:"Qd8-e8",e:5}],"1#66830603":[{m:"Qg6xe8",e:5}],"-1#1729323507":[{m:"Ra8xe8",e:5}],"1#481131376":[{m:"Ra1-d1",e:5}],"-1#101014899":[{m:"d7-d6",e:5}],"1#1075211092":[],"-1#1010724187":[{m:"Bb7xf3",e:9.655}],"1#-1003002705":[{m:"e2xf3",e:9.474}],"-1#1701944075":[{m:"c7-c5",e:9.474}],"1#772469865":[{m:"d2-d4",e:9.474}],"-1#-768909815":[{m:"c5xd4",e:9.375},{m:"Nb8-c6",e:9.375},{m:"e7-e6",e:9.375}],"1#-535625212":[{m:"Qd1xd4",e:9.167}],"-1#1605365615":[{m:"Nb8-c6",e:9.167}],"1#-415431629":[{m:"Qd4-d2",e:9.167},{m:"Qd4-d1",e:9.167}],"-1#24319391":[{m:"e7-e6",e:8}],"1#1451588682":[{m:"Nb1-c3",e:7.5}],"-1#-415678116":[{m:"Ra8-c8",e:7.5}],"-1#18603727":[{m:"g7-g6",e:8.333},{m:"e7-e6",e:8.333}],"1#412455626":[{m:"h2-h4",e:7.5}],"1#1790555477":[{m:"d4-d5",e:7.5}],"-1#-1872214561":[{m:"Nc6-d4",e:7.5}],"1#322777091":[{m:"Bc1-e3",e:7.5}],"-1#1353348550":[{m:"Nd4-f5",e:7.5}],"1#-304038734":[{m:"Be3-d2",e:7.5},{m:"Nb1-c3",e:7.5}],"-1#-212071771":[{m:"g7-g6",e:6.667}],"1#-355318112":[{m:"Bd2-c3",e:6.667}],"-1#1549566372":[{m:"g7-g6",e:5}],"1#1171443105":[{m:"Bf1-h3",e:5}],"1#-2049099812":[{m:"Nb1-c3",e:5}],"-1#878774986":[{m:"Nb8-c6",e:5}],"1#-1930174058":[{m:"d4-d5",e:5}],"-1#1981944092":[{m:"Nc6-d4",e:5}],"1#-176724800":[{m:"Bc1-e3",e:5}],"-1#-1226825467":[{m:"Nd4-f5",e:5}],"1#195750001":[{m:"Bf1-h3",e:5}],"-1#1200439029":[{m:"Ng8-h6",e:5}],"1#-820375382":[{m:"Qd1-a4",e:5}],"-1#231147263":[{m:"g7-g6",e:5}],"-1#1163572233":[{m:"Bc8-b7",e:9.882}],"1#-560496211":[{m:"Nb1-c3",e:9.744},{m:"a2-a3",e:9.865}],"-1#-920235404":[{m:"e7-e6",e:5}],"1#-1630520415":[{m:"Ng1-f3",e:5}],"-1#1716722248":[{m:"f7-f5",e:5}],"1#-264660128":[{m:"g2-g3",e:5}],"-1#1538222953":[{m:"Ng8-f6",e:5}],"1#-601768424":[{m:"Bf1-g2",e:5}],"-1#-1824206003":[{m:"Bf8-e7",e:5}],"1#188101317":[{m:"O-O",e:5}],"-1#292279089":[{m:"O-O",e:5}],"1#-1250156984":[{m:"d2-d3",e:5}],"-1#-1698795303":[{m:"Nb8-c6",e:5}],"1#573348741":[{m:"Qd1-c2",e:5}],"-1#-1282114479":[{m:"Qd8-e8",e:5}],"1#589647647":[{m:"e2-e4",e:5}],"-1#1709424738":[{m:"f5xe4",e:5}],"1#718088326":[{m:"Nc3xe4",e:5}],"-1#-1181436938":[{m:"Nf6xe4",e:5}],"1#-2022468666":[{m:"d3xe4",e:5}],"-1#942307427":[{m:"Qe8-h5",e:5}],"1#-1193633462":[],"1#669944700":[{m:"g2-g3",e:9.996},{m:"Nb1-c3",e:9.996},{m:"Ng1-f3",e:9.996}],"-1#-1938261131":[{m:"c7-c5",e:9.95},{m:"c7-c6",e:9.95},{m:"g7-g6",e:9.95},{m:"d7-d5",e:9.95},{m:"e7-e6",e:9.95}],"1#-956099561":[{m:"Bf1-g2",e:9.722}],"-1#-2006550206":[{m:"c7-c5",e:8.333}],"1#-2070433997":[{m:"b2-b3",e:9.773},{m:"Qd1-a4",e:9.773}],"-1#-1475364728":[{m:"e7-e5",e:8}],"1#-883795876":[{m:"Bc1-b2",e:6.667}],"-1#-552060339":[{m:"Bf8-c5",e:6.667}],"1#1071167582":[{m:"Ng1-f3",e:6.667}],"-1#1179302246":[{m:"g7-g6",e:5}],"1#1606743395":[{m:"Bf1-g2",e:5}],"-1#279025718":[{m:"Bf8-g7",e:5}],"1#512276484":[{m:"e2-e4",e:5}],"-1#1481521017":[{m:"O-O",e:5}],"1#-1779026064":[{m:"Bf1-g2",e:9.889}],"-1#-627877339":[{m:"Ng8-f6",e:9.929}],"1#-1399653498":[{m:"c4xd5",e:8.333}],"-1#998376522":[{m:"Nf6xd5",e:8.333}],"1#-752685022":[{m:"Bf1-g2",e:8}],"-1#-1673028233":[{m:"g7-g6",e:6.667}],"1#-2050371214":[{m:"Qd1-a4+",e:8.75}],"-1#1192544039":[{m:"c7-c6",e:5}],"1#1341854561":[{m:"Qa4-d4",e:5}],"-1#457528191":[{m:"f7-f6",e:5}],"1#1061361321":[{m:"Nb1-c3",e:5}],"-1#-1895879745":[{m:"e7-e5",e:5}],"1#-611446112":[{m:"Bf1-g2",e:9.796}],"-1#-1796505611":[{m:"c7-c5",e:9.792}],"1#-544206697":[{m:"Ng1-f3",e:9.231}],"-1#655569278":[{m:"d7-d5",e:9.744},{m:"Bf8-e7",e:9.744},{m:"a7-a6",e:9.744},{m:"Nb8-c6",e:9.744},{m:"Qd8-c7",e:9.744}],"1#133804429":[{m:"O-O",e:9.787}],"1#440395853":[{m:"Nb1-c3",e:7.5}],"-1#-1772964246":[{m:"c7-c6",e:9.995},{m:"g7-g6",e:9.995},{m:"Ng8-f6",e:9.412},{m:"d7-d5",e:9.995},{m:"e7-e6",e:9.995}],"1#-1631755732":[{m:"e2-e4",e:9.677}],"-1#-662966959":[{m:"e7-e5",e:9.6},{m:"d7-d5",e:9.6}],"1#-1155134075":[{m:"Ng1-f3",e:9.474},{m:"f2-f4",e:9.474}],"-1#1134898284":[{m:"Bf8-b4",e:9.474}],"1#-124686942":[{m:"e4-e5",e:9},{m:"c4xd5",e:9}],"-1#694825269":[{m:"Nf6-e4",e:6.667}],"1#-1881343377":[{m:"e2-e4",e:9.98},{m:"g2-g3",e:9.98},{m:"Ng1-f3",e:9.98}],"-1#-921012974":[{m:"d7-d6",e:9.934},{m:"e7-e5",e:9.934}],"-1#608832102":[{m:"c7-c6",e:9.964},{m:"Ng8-f6",e:9.932}],"1#711141972":[{m:"Bf1-g2",e:9.967}],"-1#1694910209":[{m:"O-O",e:9.975},{m:"Ng8-f6",e:9.811}],"1#-1055815048":[{m:"d2-d3",e:9.971},{m:"Ng1-f3",e:9.971},{m:"e2-e4",e:9.971},{m:"d2-d4",e:9.971},{m:"e2-e3",e:9.971}],"-1#965913489":[{m:"d7-d6",e:9.946}],"-1#2002770822":[{m:"d7-d5",e:9.982}],"1#1471503221":[{m:"Qd1-a4+",e:9.923}],"1#784358710":[{m:"d2-d4",e:9.091}],"-1#-756943018":[{m:"e7-e5",e:9.667}],"1#-1313073278":[{m:"d4-d5",e:9.643}],"-1#1265493768":[{m:"Nc6-e7",e:9.583},{m:"Nc6-b8",e:9.583}],"1#-618601747":[{m:"g2-g3",e:9.615},{m:"h2-h4",e:9.615},{m:"e2-e4",e:9.615}],"-1#1890980580":[{m:"d7-d6",e:7.5}],"1#916792515":[{m:"e2-e4",e:6.667},{m:"Bf1-g2",e:6.667}],"-1#1885580222":[{m:"g7-g6",e:5}],"1#1777199035":[{m:"h2-h4",e:5}],"-1#2042644886":[{m:"g7-g6",e:5}],"1#1615725971":[{m:"e2-e4",e:5}],"-1#646482670":[{m:"Bf8-g7",e:5}],"-1#1621617249":[{m:"Ne7-g8",e:8.75},{m:"g7-g6",e:8.75},{m:"Ne7-f5",e:8.75}],"1#-1445220517":[{m:"a2-a3",e:7.5}],"-1#-1100317566":[{m:"Bf8-c5",e:5}],"1#2032772708":[{m:"Bc1-g5",e:5}],"-1#-1800294017":[{m:"Ne7-f5",e:5}],"1#-822783188":[{m:"Qd1-d3",e:7.5}],"-1#912365713":[{m:"g7-g6",e:7.5}],
"-1#-1645843056":[{m:"Ne7-g6",e:9.375}],"1#1899294954":[{m:"Ng1-f3",e:9.5},{m:"Bc1-e3",e:9.5},{m:"h2-h4",e:9.5}],"-1#-1984442109":[{m:"Bf8-b4",e:7.5}],"1#-441413700":[{m:"Qd1-c2",e:7.5}],"-1#849589551":[{m:"Bf8-b4",e:8.75}],"-1#-894175130":[{m:"Bf8-b4",e:7.5}],"1#-1498110247":[{m:"Qd1-b3",e:6.667}],"1#-201388972":[{m:"a2-a3",e:6.667}],"-1#-464593011":[{m:"a7-a5",e:5}],"1#-996150390":[{m:"Ng1-f3",e:5}],"-1#1008521827":[{m:"d7-d6",e:5}],"1#2047861828":[{m:"e2-e4",e:5}],"-1#1019833145":[{m:"Bf8-e7",e:5}],"1#-1531213135":[{m:"Nf3-d2",e:5}],"-1#-1561915555":[{m:"O-O",e:5}],"1#116441636":[{m:"Bf1-e2",e:5}],"-1#-988632798":[{m:"Nb8-d7",e:5}],"1#384728221":[{m:"Ra1-b1",e:5}],"-1#-403370529":[{m:"Nf6-e8",e:5}],"1#1291016970":[{m:"g2-g3",e:5}],"-1#-412767485":[{m:"Be7-g5",e:5}],"1#-1092259211":[{m:"h2-h4",e:5}],"-1#90340089":[{m:"Bg5-h6",e:5}],"1#-1194298667":[{m:"Ke1-f1",e:5}],"-1#1342424810":[{m:"Nd7-b6",e:5}],"1#-151664233":[{m:"g3-g4",e:5}],"-1#-36348221":[{m:"Bh6-f4",e:5}],"1#887139018":[{m:"Kf1-g2",e:5}],"-1#-105746997":[{m:"a5-a4",e:5}],"1#41678747":[{m:"Nd2-f1",e:5}],"-1#1823196981":[{m:"Bf4xc1",e:5}],"1#-1057424280":[{m:"Rb1xc1",e:5}],"-1#-2125324271":[{m:"Ne8-f6",e:5}],"1#710178500":[],"1#-1229441383":[{m:"c4xd5",e:9.979}],"-1#564709717":[{m:"Nf6xd5",e:9.979}],"1#-922206915":[{m:"e2-e4",e:9.979},{m:"Ng1-f3",e:9.979},{m:"g2-g3",e:9.979}],"-1#-1882279360":[{m:"Nd5xc3",e:8.333}],"1#-278919428":[{m:"d2xc3",e:8}],"-1#831200468":[{m:"g7-g6",e:9.965}],"-1#1654574388":[{m:"g7-g6",e:9.947}],"1#2064679217":[{m:"Bf1-g2",e:9.944}],"1#-1046159425":[{m:"Ng1-f3",e:9.986},{m:"e2-e4",e:9.986}],"-1#958922326":[{m:"b7-b6",e:9.983},{m:"Bf8-b4",e:9.983}],"1#1839278404":[{m:"g2-g3",e:9.844}],"1#1428201705":[{m:"a2-a3",e:9.972}],"-1#-2023599934":[{m:"d7-d5",e:9.971},{m:"c7-c5",e:9.971},{m:"Bf8-b4",e:9.971}],"-1#-546461035":[{m:"a7-a6",e:9.996},{m:"g7-g6",e:9.996},{m:"d7-d6",e:9.996},{m:"b7-b6",e:9.996},{m:"d7-d5",e:9.996},{m:"c7-c6",e:9.996}],"1#-499027034":[{m:"g2-g3",e:6.667}],"-1#1238860719":[{m:"b7-b5",e:6.667}],"1#509514836":[{m:"b2-b3",e:6.667}],"-1#851870703":[{m:"Bc8-b7",e:6.667}],"1#-1458850229":[{m:"Bf1-g2",e:6.667}],"-1#-428942562":[{m:"c7-c5",e:6.667}],"1#-958142832":[{m:"b2-b4",e:9.99},{m:"g2-g3",e:9.99},{m:"b2-b3",e:9.99}],"-1#-1164623021":[{m:"c7-c5",e:9.828}],"-1#1836390041":[{m:"Bf8-g7",e:9.964}],"-1#-360976085":[{m:"Bf8-g7",e:9.828}],"1#-1719755598":[{m:"g2-g3",e:9.877}],"-1#854092987":[{m:"c7-c5",e:9.565},{m:"c7-c6",e:9.565},{m:"Bc8-g4",e:9.565}],"1#2039677913":[{m:"Bf1-g2",e:6.667}],"1#973584637":[{m:"d2-d4",e:8.571}],"1#-1947501177":[{m:"d2-d3",e:9.929},{m:"b2-b4",e:9.929},{m:"g2-g3",e:9.929}],"-1#-1540812010":[{m:"Bc8-b7",e:8}],"-1#-140650428":[{m:"Bc8-b7",e:5}],"-1#545099150":[{m:"Bc8-a6",e:9.9}],"1#-7919002":[{m:"c4xd5",e:9.333}],"-1#1754781098":[{m:"Nf6xd5",e:9.167}],"1#-2143870526":[{m:"b2-b3",e:9.167},{m:"e2-e4",e:9.167}],"-1#-1397803399":[{m:"c7-c5",e:5}],"-1#-957239617":[],"1#-679313709":[{m:"g2-g3",e:9.936},{m:"Qd1-a4",e:9.936},{m:"b2-b3",e:9.936}],"-1#2081722074":[{m:"Qd8-a5",e:9.811}],"-1#358574214":[{m:"g7-g6",e:5}],"-1#-82155160":[{m:"Ng8-f6",e:9.968}],"1#-58986273":[{m:"g2-g3",e:5}],"-1#1475150038":[{m:"g7-g6",e:5}],"1#1315130579":[{m:"Bf1-g2",e:5}],"-1#17179014":[{m:"Bf8-g7",e:5}],"1#254738868":[{m:"Nb1-c3",e:5}],"-1#-1097646942":[{m:"e7-e5",e:5}],"1#-573645706":[{m:"d2-d3",e:5}],"-1#-234048793":[{m:"Na6-c5",e:5}],"1#1892776198":[{m:"e2-e3",e:5}],"-1#-830950135":[{m:"Nc5-e6",e:5}],"1#-235634949":[{m:"Ng1-e2",e:5}],"-1#1849332484":[{m:"h7-h5",e:5}],"1#1285637499":[{m:"h2-h4",e:5}],"-1#-148484617":[{m:"Ng8-e7",e:5}],"1#518904447":[{m:"Nc3-d5",e:5}],"-1#1477537667":[{m:"Ne7xd5",e:5}],"1#-659233931":[{m:"c4xd5",e:5}],"-1#-1810652585":[{m:"Ne6-c5",e:5}],"1#-1415616091":[{m:"d3-d4",e:5}],"-1#137961955":[{m:"e5xd4",e:5}],"1#-1555721724":[{m:"e3xd4",e:5}],"-1#835559089":[{m:"Nc5-a6",e:5}],"1#-1290775216":[{m:"Bc1-g5",e:5}],"-1#1585988171":[{m:"f7-f6",e:5}],"1#2056128413":[{m:"Bg5-e3",e:5}],"-1#-1530603020":[],"1#-1466987957":[{m:"Ng1-f3",e:9.99},{m:"Qd1-a4",e:9.99},{m:"b2-b3",e:9.99},{m:"d2-d3",e:9.99},{m:"g2-g3",e:9.99}],"-1#1343007650":[{m:"d7-d5",e:9.987}],"1#1894132561":[{m:"e2-e3",e:9.989},{m:"Qd1-b3",e:9.989},{m:"Qd1-a4",e:9.989},{m:"g2-g3",e:9.989},{m:"b2-b3",e:9.989}],"-1#-833624226":[{m:"Bc8-f5",e:9.941},{m:"Ng8-f6",e:9.941},{m:"Bc8-g4",e:9.941}],"1#-63342245":[{m:"c4xd5",e:7.5}],"-1#73029791":[{m:"e7-e6",e:7.5}],"1#1403793738":[{m:"g2-g3",e:6.667}],"-1#-130367165":[{m:"f7-f5",e:5}],"1#1850753131":[{m:"Bf1-g2",e:5}],"-1#-1304740604":[{m:"e7-e6",e:6.667},{m:"Nb8-d7",e:6.667}],"1#-439528239":[{m:"g2-g3",e:5}],"1#1640491195":[{m:"c4xd5",e:5}],"-1#-613360808":[{m:"Ng8-f6",e:9.971},{m:"d5xc4",e:9.971},{m:"g7-g6",e:9.971},{m:"Bc8-g4",e:9.971}],"-1#1551777002":[{m:"f7-f6",e:9.968},{m:"Ng8-f6",e:9.968},{m:"Bc8-g4",e:9.968}],"-1#1783798814":[{m:"g7-g6",e:7.5}],"1#1943851035":[{m:"Ng1-f3",e:6.667}],"-1#-1956646414":[{m:"Bf8-g7",e:6.667}],"1#-2055810624":[{m:"g2-g3",e:6.667}],"-1#786440649":[{m:"e7-e5",e:6.667}],"1#1304281373":[{m:"Nb1-c3",e:6.667}],"-1#-66978805":[{m:"Ng8-e7",e:6.667}],"1#365587331":[{m:"h2-h4",e:6.667}],"-1#-1370660081":[{m:"h7-h6",e:6.667},{m:"f7-f5",e:6.667}],"1#-76602305":[{m:"c4-c5",e:5}],"-1#1455874822":[{m:"f7-f5",e:5}],"1#-1062444498":[{m:"e2-e4",e:5}],"-1#-2039812781":[{m:"d7-d5",e:5}],"1#-1501532768":[{m:"c5xd6",e:5}],"-1#-569722523":[{m:"Qd8xd6",e:5}],"1#-51491598":[{m:"e4xf5",e:6.667}],"-1#-1828806607":[{m:"g6xf5",e:5}],"1#942137895":[],"-1#-2078827024":[{m:"d7-d5",e:9.444},{m:"e7-e5",e:9.444}],"1#-1526915837":[{m:"Bc1-b2",e:9.333}],"-1#-1330151662":[{m:"Bc8-g4",e:9.231}],"1#-2101223145":[{m:"h2-h3",e:8.571},{m:"d2-d4",e:8.571}],"-1#-1706956855":[{m:"Bg4-h5",e:6.667}],"1#-1319843358":[{m:"d2-d3",e:6.667}],"-1#-1634293901":[{m:"Nb8-d7",e:6.667}],"1#1298821836":[{m:"Nb1-d2",e:6.667}],"-1#2128628599":[{m:"e7-e6",e:6.667}],"1#689316514":[{m:"Nb1-d2",e:6.667}],"-1#-115939841":[{m:"Ng8-f6",e:6.667}],"1#2123903118":[{m:"h2-h3",e:6.667}],"1#-414548700":[{m:"Bc1-b2",e:6.667}],"-1#-218095819":[{m:"d7-d6",e:6.667}],"1#-1257035502":[{m:"g2-g3",e:6.667}],"-1#512088347":[{m:"Ng8-f6",e:6.667}],"1#-1727329174":[{m:"Bf1-g2",e:6.667}],"-1#-697409217":[{m:"Bf8-e7",e:8}],"1#1310490807":[{m:"d2-d3",e:6.667}],"-1#1641999910":[{m:"O-O",e:6.667}],"1#-976673953":[{m:"Ng1-f3",e:6.667}],"-1#1028260534":[{m:"Rf8-e8",e:6.667}],"1#2077521014":[{m:"O-O",e:6.667}],"-1#-2024938278":[{m:"e7-e5",e:6.667}],"1#-468712434":[{m:"Ng1-f3",e:6.667}],"-1#479405543":[{m:"Ng8-f6",e:6.667}],"1#-1692536682":[{m:"Nb1-c3",e:6.667}],"-1#715246976":[{m:"d7-d6",e:7.5}],"1#1823669159":[{m:"g2-g3",e:6.667}],"-1#-953939026":[{m:"Nb8-d7",e:6.667}],"1#349756945":[{m:"Bf1-g2",e:6.667}],"-1#1539158852":[{m:"Bf8-e7",e:6.667}],"1#-1009823028":[{m:"O-O",e:6.667}],"-1#-644697288":[{m:"O-O",e:8}],"1#2105900609":[{m:"Ra1-b1",e:8.889},{m:"b2-b3",e:8.889}],"-1#-1935798525":[{m:"h7-h6",e:8},{m:"d6-d5",e:8}],"1#-641972173":[{m:"b2-b4",e:5}],"-1#-1513427472":[{m:"d6-d5",e:5}],"1#-1709034144":[{m:"b2-b4",e:7.5},{m:"c4xd5",e:7.5}],"-1#1360882170":[{m:"Rf8-e8",e:6.667}],"1#394469178":[{m:"Bc1-b2",e:6.667}],"-1#63536427":[{m:"Be7-f8",e:6.667}],"1#-1682203485":[{m:"Ra1-c1",e:6.667}],"-1#-131012056":[{m:"a7-a6",e:6.667}],"1#-988007653":[{m:"Qd1-c2",e:6.667}],"-1#52001346":[{m:"d7-d5",e:9.706},{m:"c7-c6",e:9.95}],"1#603191985":[{m:"c2-c4",e:9.922}],"1#-1175580152":[{m:"e2-e4",e:9.983},{m:"Nb1-c3",e:9.983}],"-1#-14115467":[{m:"Nb8-c6",e:9.892},{m:"c7-c5",e:9.892},{m:"e7-e5",e:9.892}],"1#1203402281":[{m:"d2-d4",e:5}],"-1#-1147413431":[{m:"e7-e5",e:5}],"1#-658096995":[{m:"d4xe5",e:5}],"-1#-1570324016":[{m:"Nc6xe5",e:5}],"1#1828856015":[{m:"Nb1-c3",e:6.667},{m:"Ng1-f3",e:6.667}],"-1#-591520295":[{m:"Bf8-c5",e:6.667}],"1#1014931402":[{m:"Bf1-e2",e:5}],"-1#-6490932":[{m:"Ng8-f6",e:5}],"1#2014454205":[{m:"Bc1-g5",e:5}],"-1#-1786104154":[{m:"h7-h6",e:5}],"1#-1062702698":[{m:"Bg5-h4",e:5}],"-1#266081451":[{m:"g6-g5",e:5}],"1#-1622205767":[{m:"Bh4-g3",e:5}],"-1#-500517573":[{m:"Qd8-e7",e:5}],"1#-1375445261":[{m:"Ng1-f3",e:5}],"-1#-1786707674":[{m:"Bf8-g7",e:5}],"1#-1683480300":[{m:"Nf3-d4",e:6.667}],"-1#964144287":[{m:"d7-d6",e:5}],"1#2137299640":[{m:"Nb1-c3",e:5}],"-1#-824662098":[{m:"Ng8-e7",e:5}],"1#655568934":[{m:"Bf1-e2",e:5}],"-1#-453944544":[{m:"Ne7-c6",e:5}],"1#1235333523":[{m:"Bc1-e3",e:5}],"-1#171373654":[{m:"h7-h5",e:5}],"1#682435113":[{m:"Nd4xc6",e:5}],"1#-1269566953":[{m:"Ng1-f3",e:9.286}],"-1#1288754174":[{m:"Qd8-a5",e:9.762}],"1#-656958231":[{m:"Nb1-c3",e:6.667}],"-1#1768661503":[{m:"Bf8-g7",e:6.667}],"1#1732411853":[{m:"d2-d4",e:6.667}],"-1#-1687999571":[{m:"Nb8-c6",e:9.767},{m:"d7-d6",e:9.767},{m:"Ng8-f6",e:9.767}],"1#603046129":[{m:"d4-d5",e:9.091}],"-1#-652201861":[{m:"Nc6-d4",e:9}],"1#1517634983":[{m:"Bc1-d2",e:9}],"-1#1998273218":[{m:"d7-d6",e:8.889},{m:"Nd4xf3+",e:8.889}],"1#-579854966":[{m:"Bf1-e2",e:9.5},{m:"Qd1-d3",e:9.5},{m:"d4-d5",e:9.5},{m:"Ra1-b1",e:9.5}],"1#485359324":[{m:"Bc1-d2",e:9.5},{m:"Bf1-d3",e:9.5}],"-1#830702009":[{m:"c5xd4",e:9.231}],"-1#679039046":[{m:"c5xd4",e:8.75}],"1#-1670021727":[{m:"Ng1-f3",e:9.783},{m:"Ng1-e2",e:9.783},{m:"d2-d4",e:9.783}],"-1#1693867080":[{m:"d7-d6",e:9.615},{m:"Bf8-g7",e:9.615}],"1#585460335":[{m:"Ng1-f3",e:9.444}],"1#1793031290":[{m:"d2-d4",e:9.643},{m:"Nb1-c3",e:9.643}],"-1#62623838":[{m:"d7-d6",e:5}],"1#1168680569":[{m:"Nb1-c3",e:5}],"-1#-199976081":[{m:"f7-f5",e:5}],"1#1652431431":[{m:"d2-d4",e:5}],"-1#-1637896153":[{m:"Nb8-c6",e:5}],"-1#1616172993":[{m:"Bf8-b4+",e:9.5},{m:"Ng8-f6",e:9.5}],"1#206801278":[{m:"Bc1-d2",e:5}],"-1#557708827":[{m:"Bb4xd2+",e:5}],"1#-405142864":[{m:"d4xe5",e:9.474},{m:"Ng1-f3",e:9.474}],"-1#139603742":[{m:"Bf8-g7",e:9.961}],"1#108728108":[{m:"Ng1-f3",e:9.956},{m:"g2-g3",e:9.956}],"-1#-17289531":[{m:"e7-e5",e:9.873},{m:"c7-c5",e:9.873}],"1#-1650078191":[{m:"d2-d4",e:9.412},{m:"e2-e3",e:9.412}],"-1#1636066417":[{m:"e5xd4",e:9.231},{m:"Nb8-c6",e:9.231},{m:"d7-d6",e:9.231}],"1#-889661546":[{m:"Nf3xd4",e:9},{m:"Bc1-g5",e:9}],"1#-652832979":[{m:"d4-d5",e:5}],"1#664228438":[{m:"d4-d5",e:9.896}],"-1#587989534":[{m:"Ng8-e7",e:5}],"1#-892889706":[{m:"d2-d4",e:5}],"-1#921059318":[{m:"e5xd4",e:5}],"1#-1650815983":[{m:"Nf3xd4",e:5}],"-1#-1560826573":[{m:"O-O",e:5}],"1#115368010":[{m:"Bf1-e2",e:5}],"1#-1249689177":[{m:"e2-e3",e:9.857}],"-1#187338152":[{m:"Ng8-f6",e:9}],"1#-1935386407":[{m:"a2-a3",e:9.091}],"-1#-1693086976":[{m:"Nb8-c6",e:5}],"1#596074588":[{m:"Ra1-b1",e:5}],"-1#-761523938":[{m:"d7-d5",e:5}],"1#-227110419":[{m:"c4xd5",e:5}],"-1#1701211681":[{m:"Nf6xd5",e:5}],"1#-1916364215":[{m:"Bf1-c4",e:5}],"-1#900707853":[{m:"Nd5-b6",e:5}],"1#36199731":[{m:"Bc4-b5",e:5}],"-1#943627634":[{m:"O-O",e:5}],"1#-1675014133":[{m:"O-O",e:5}],"-1#-2039172609":[{m:"Qd8-c7",e:5}],"-1#-1376911579":[{m:"Nb8-c6",e:9.932},{m:"Ng8-f6",e:9.932},{m:"c7-c5",e:9.932},{m:"Bf8-g7",e:8.75}],"1#360649849":[{m:"Nb1-c3",e:6.667}],"1#418559313":[{m:"Nb1-c3",e:9.565},{m:"g2-g3",e:9.565}],"-1#-1454471097":[{m:"Ng8-f6",e:9.412}],"-1#-1285274280":[{m:"Nc6-e5",e:8.333}],"1#812533316":[{m:"e2-e4",e:5}],"-1#1990773049":[{m:"e7-e6",e:5}],"1#559849708":[{m:"d2-d4",e:5}],"-1#-578876788":[{m:"Ne5-g6",e:5}],"1#585797903":[{m:"Bf1-g2",e:5}],"-1#1838152794":[{m:"e6-e5",e:5}],"1#694286828":[{m:"Ng1-e2",e:5}],"-1#-1230040045":[{m:"Bf8-b4+",e:5}],"1#-626505044":[{m:"Nb1-c3",e:5}],"-1#1796503482":[{m:"Ng8-f6",e:5}],"1#-325410101":[{m:"O-O",e:5}],"-1#-154713281":[{m:"O-O",e:5}],"1#1389399622":[{m:"d4xe5",e:5}],"-1#678458123":[{m:"Ng6xe5",e:5}],"1#-1685386613":[{m:"Nc3-d5",e:5}],"-1#-579354761":[{m:"Nf6xd5",e:5}],"1#865563000":[{m:"c4xd5",e:5}],"-1#2133864538":[{m:"Bb4-c5",e:5}],"1#-2085461951":[{m:"h2-h3",e:5}],"-1#-1691195745":[{m:"Qd8-f6",e:5}],"1#938370321":[{m:"Kg1-h1",e:5}],"-1#-59340203":[{m:"d7-d6",e:5}],"1#-1167737742":[{m:"f2-f4",e:5}],"-1#-970517774":[{m:"Ne5-g4",e:5}],"1#1714162316":[{m:"Qd1-e1",e:5}],"-1#1321757356":[{m:"Rf8-e8",e:5}],"1#139861100":[{m:"Ne2-g1",e:5}],"-1#-1751584365":[{m:"Bc8-f5",e:5}],"1#-115798116":[],"1#906682149":[{m:"b2-b3",e:9.969},{m:"Nb1-c3",e:9.969},{m:"Ng1-f3",e:9.969},{m:"g2-g3",e:9.969},{m:"e2-e4",e:9.969}],"-1#445827230":[{m:"e7-e5",e:9.412}],"1#2043619402":[{m:"Bc1-b2",e:9.091}],"-1#1837451867":[{m:"d7-d6",e:9.091},{m:"Nb8-c6",e:9.091}],"1#731282556":[{m:"g2-g3",e:9.231}],"-1#-2147447691":[{m:"Ng8-f6",e:9}],"1#126769412":[{m:"Bf1-g2",e:8.889}],"-1#1223373905":[{m:"g7-g6",e:8.889},{m:"Bf8-e7",e:8.889}],"1#1365604436":[{m:"e2-e3",e:8.571},{m:"d2-d4",e:8.571}],"1#-795224615":[{m:"e2-e3",e:6.667}],"-1#1848646102":[{m:"O-O",e:6.667}],"1#-903359313":[{m:"Ng1-e2",e:6.667}],"1#-719871737":[{m:"e2-e3",e:8.75},{m:"g2-g3",e:8.75}],"-1#1807641864":[{m:"Ng8-f6",e:7.5}],"1#-332351367":[{m:"Ng1-f3",e:7.5},{m:"a2-a3",e:7.5}],"-1#347314576":[{m:"d7-d6",e:5}],"-1#2122404110":[{m:"d7-d5",e:8},{m:"Ng8-f6",e:8}],"1#1584124413":[{m:"Bf1-g2",e:5}],"-1#286178472":[{m:"d5-d4",e:5}],"1#-116423553":[{m:"Bf1-g2",e:7.5}],"-1#-2018057677":[{m:"Ng8-f6",e:9.875}],"1#3684162":[{m:"g2-g3",e:9.87},{m:"Ng1-f3",e:9.87}],"-1#-1414609077":[{m:"d7-d6",e:9.804},{m:"e7-e6",e:9.804}],"1#-306318996":[{m:"Bf1-g2",e:9.231}],"-1#-1562862535":[{m:"c7-c6",e:9.444},{m:"e7-e5",e:9.444}],"1#-1439217537":[{m:"e2-e4",e:6.667}],"1#-1048216339":[{m:"d2-d4",e:9.949}],"1#-61296994":[{m:"Bf1-g2",e:9.375}],"-1#-1287797813":[{m:"Bf8-e7",e:9.474}],"1#726606403":[{m:"d2-d4",e:9.091},{m:"d2-d3",e:9.091}],"-1#-121956693":[{m:"g7-g6",e:9.583}],"1#-516597074":[{m:"d2-d3",e:9.412}],"-1#-822660033":[{m:"Bf8-g7",e:8.889}],"1#-1059187699":[{m:"e2-e4",e:8.889}],"-1#-2045207696":[{m:"d7-d6",e:8.75}],"1#-1072976553":[{m:"e4xf5",e:8.75}],"-1#-1373945452":[{m:"Bc8xf5",e:8.333}],"1#303136670":[{m:"d3-d4",e:8.333}],"-1#-1313392680":[{m:"O-O",e:8}],"1#362871457":[{m:"Bf1-d3",e:8},{m:"Bf1-e2",e:8}],"-1#-829817140":[{m:"b7-b6",e:9.836}],"1#-1710282274":[{m:"g2-g3",e:6.667}],"-1#832166359":[{m:"Bc8-b7",e:6.667}],"1#-1437275021":[{m:"Bf1-g2",e:6.667}],"-1#-449740506":[{m:"e7-e6",e:6.667}],"1#-1295521549":[{m:"b2-b3",e:9.091},{m:"O-O",e:9.091}],"-1#-1637875896":[{m:"Ng8-f6",e:5}],"1#433138233":[{m:"Bc1-b2",e:5}],"-1#-1466300153":[{m:"Ng8-f6",e:8.889}],"1#789896310":[{m:"d2-d4",e:8.75}],"-1#-751471082":[{m:"Bf8-e7",e:9.6}],"1#1262983070":[{m:"d4-d5",e:9.375},{m:"Nb1-c3",e:9.375}],"-1#-1315543276":[{m:"O-O",e:7.5}],"1#360819309":[{m:"Nf3-d4",e:7.5}],"-1#-84170104":[{m:"O-O",e:8.889}],"1#1592551409":[{m:"d4-d5",e:8.75}],"-1#-1650708692":[{m:"Ng8-f6",e:9.938}],"1#437451357":[{m:"Bf1-g2",e:9.935}],"-1#1433900808":[{m:"e7-e5",e:9.935},{m:"g7-g6",e:9.935},{m:"e7-e6",e:9.935}],"1#908752860":[{m:"d2-d4",e:9.6},{m:"b2-b3",e:9.6},{m:"Ng1-f3",e:9.6},{m:"Bf1-g2",e:6.667},{m:"e2-e3",e:9.6}],"-1#447897703":[{m:"Nb8-c6",e:5}],"1#1291442957":[{m:"Ng1-h3",e:9.875},{m:"Nb1-c3",e:9.875},{m:"b2-b3",e:9.875}],"-1#-1312816723":[{m:"e7-e5",e:5}],"-1#-45750757":[{m:"Bf8-g7",e:9.895}],"-1#1617022134":[{m:"c7-c6",e:6.667}],"1#1754142960":[{m:"Bc1-b2",e:5}],"1#42073821":[{m:"e2-e3",e:9.859},{m:"Ng1-f3",e:9.859},{m:"b2-b3",e:9.859}],"-1#-1138216238":[{m:"d7-d5",e:6.667}],"-1#-100475084":[{m:"d7-d5",e:9.896},{m:"Bf8-e7",e:9.896}],"-1#773450086":[{m:"d7-d5",e:8.571}],"-1#1892438104":[{m:"f5xe4",e:8.571},{m:"d7-d6",e:8.571}],"1#1071823036":[{m:"Nb1-c3",e:8}],"-1#-1906408022":[{m:"Ng8-f6",e:5}],"1#164647131":[{m:"d2-d3",e:5}],"-1#638729802":[{m:"d7-d6",e:6.667}],"1#1610680429":[{m:"d3xe4",e:5}],"-1#247232089":[{m:"e7-e5",e:5}],"1#1843500685":[{m:"f2-f4",e:5}],"-1#295909389":[{m:"e5xf4",e:5}],"1#909596623":[{m:"Bc1xf4",e:5}],"-1#1869226614":[{m:"Bf8-e7",e:5}],"1#-149371906":[{m:"Ng1-f3",e:5}],"1#920610431":[{m:"Ng1-f3",e:6.667},{m:"e4xf5",e:6.667}],"-1#-832813162":[{m:"f5xe4",e:5}],"1#-2123190414":[{m:"Nf3-g5",e:5}],"-1#1531543102":[{m:"e7-e5",e:5}],"1#940875498":[{m:"d2-d3",e:5}],"-1#399962235":[{m:"Bf8-e7",e:5}],"-1#1489996476":[{m:"Bc8xf5",e:5}],"1#-456805194":[{m:"d2-d4",e:5}],"-1#417603286":[{m:"g7-g6",e:5}],"1#23745235":[{m:"g2-g4",e:5}],"-1#-778454727":[{m:"Bf5-e4",e:5}],"1#1496879277":[{m:"d2-d4",e:8}],"-1#-1525073203":[{m:"Bf8-g7",e:8}],"1#-1422910721":[{m:"Nb1-c3",e:8},{m:"Bc1xg5",e:8}],"-1#445392873":[{m:"h7-h6",e:6.667}],"1#1336828121":[{m:"e2-e4",e:5}],"-1#157872036":[{m:"d7-d6",e:5}],"1#1333516675":[{m:"Bc1-e3",e:6.667}],"-1#216833094":[{m:"Nb8-c6",e:6.667}],"1#-1266780390":[{m:"Ng1-e2",e:6.667}],"-1#732994277":[{m:"Ng8-f6",e:5}],"1#-1405202540":[{m:"f2-f3",e:5}],"-1#976257338":[{m:"a7-a6",e:5}],"1#119298057":[{m:"Qd1-d2",e:5}],"-1#1999708142":[{m:"Ra8-b8",e:5}],"1#688390525":[{m:"Ne2-c1",e:5}],"-1#-1591661446":[{m:"Bc8-d7",e:5}],"1#1910077561":[{m:"Nc1-b3",e:5}],"-1#-2071726459":[{m:"e7-e6",e:5}],"1#-747266224":[{m:"O-O-O",e:5}],"-1#-2061651166":[{m:"b7-b6",e:5}],"1#-778345424":[{m:"Kc1-b1",e:5}],"-1#192049166":[{m:"Nf6-h5",e:5}],"1#1644332829":[{m:"g2-g3",e:5}],"-1#-913017068":[{m:"e6-e5",e:5}],"1#-1921355102":[{m:"Bf1-e2",e:5}],"-1#1318590884":[],"-1#-322299544":[{m:"c7-c5",e:5}],"1#-1481542134":[],"-1#-1761169060":[{m:"e7-e6",e:10},{m:"c7-c5",e:10},{m:"g7-g6",e:10},{m:"b7-b6",e:10},{m:"c7-c6",e:10},{m:"Nb8-c6",e:10},{m:"d7-d5",e:10},{m:"Ng8-f6",e:10},{m:"b7-b5",e:10},{m:"h7-h6",e:10},{m:"f7-f5",e:10},{m:"d7-d6",e:10}],"1#-1057957751":[{m:"c2-c4",e:9.994},{m:"g2-g3",e:9.994},{m:"Ng1-f3",e:9.994}],"-1#196582840":[{m:"b7-b6",e:9.992},{m:"Bf8-b4+",e:9.992}],"1#1597065898":[{m:"d4-d5",e:9.966},{m:"Nb1-c3",e:9.966},{m:"e2-e4",e:9.966},{m:"a2-a3",e:9.966},{m:"Ng1-f3",e:9.966}],"-1#-1511998944":[{m:"Ng8-f6",e:9.375},{m:"Bc8-a6",e:9.375},{m:"Bc8-b7",e:9.375}],"-1#-292718660":[{m:"e7-e6",e:9.643},{m:"Bf8-b4",e:9.881}],"1#-2104874749":[{m:"Qd1-b3",e:9.867},{m:"e2-e4",e:9.867}],"-1#435668439":[{m:"Bc8-b7",e:9.908}],"1#-2110066573":[{m:"c2-c4",e:9.846},{m:"Nb1-c3",e:9.908}],"-1#1216387443":[{m:"f7-f5",e:9.836},{m:"c7-c5",e:9.836},{m:"g7-g6",e:9.836}],"-1#-1481479357":[{m:"Bc8-b7",e:9.75}],"1#1014980327":[{m:"g2-g3",e:9.767},{m:"a2-a3",e:9.767}],"1#1739637511":[{m:"Nb1-d2",e:9.968},{m:"Nb1-c3",e:9.968},{m:"Bc1-d2",e:9.968}],"-1#-1213201318":[{m:"f7-f5",e:9.722},{m:"c7-c5",e:9.722},{m:"d7-d5",e:9.722},{m:"Ng8-f6",e:9.722}],"1#-1755675479":[{m:"e2-e3",e:9}],"1#809423147":[{m:"g2-g3",e:8.889}],"-1#-703791599":[{m:"c7-c5",e:9.886},{m:"f7-f5",e:9.886},{m:"Bf8-b4",e:9.881},{m:"Bb4xc3+",e:9.886}],"1#-1653108365":[{m:"d4-d5",e:9}],"-1#1256111202":[{m:"Qd8-e7",e:9.948},{m:"Bb4xd2+",e:9.948},{m:"a7-a5",e:9.948}],"1#116414378":[{m:"g2-g3",e:9.744}],"1#-1989236294":[{m:"Qd1xd2",e:9.73}],"1#1779404901":[{m:"Nb1-c3",e:9.915}],"-1#1801857152":[{m:"d7-d5",e:9.808},{m:"c7-c5",e:9.808}],"1#1267509363":[{m:"Bf1-g2",e:8.571}],"-1#82429222":[{m:"g7-g6",e:8.333}],"1#493324579":[{m:"Ng1-f3",e:5}],"-1#-437999414":[{m:"Bf8-g7",e:6.667}],"1#-338851592":[{m:"d2-d4",e:9.091}],"-1#-242194164":[{m:"Nb8-c6",e:8.889},{m:"Ng8-e7",e:8.889}],"1#1224901200":[{m:"Bc1-f4",e:8},{m:"c2-c3",e:8},{m:"b2-b3",e:8}],"-1#2080973938":[{m:"h7-h6",e:5}],"-1#-1486798103":[{m:"Ng8-e7",e:6.667}],"1#1319818593":[{m:"Nb1-d2",e:6.667}],"-1#1704629739":[{m:"Ng8-e7",e:5}],"1#-1940848029":[{m:"Bc1-b2",e:5}],"1#408682116":[{m:"c2-c3",e:8.75},{m:"Nb1-c3",e:8.75},{m:"Nb1-d2",e:8.75}],"-1#-164086211":[{m:"O-O",e:6.667}],"-1#-1444428910":[{m:"b7-b6",e:6.667}],"-1#-933545511":[{m:"O-O",e:7.5}],"1#1816982688":[{m:"e2-e4",e:6.667}],"1#538789858":[{m:"Ng1-f3",e:9.63}],"-1#-660707829":[{m:"Nb8-c6",e:9.737},{m:"b7-b6",e:9.737},{m:"Qd8-a5+",e:9.737},{m:"c5xd4",e:9.737},{m:"b7-b5",e:9.737}],"1#1611435351":[{m:"Bf1-g2",e:8.75}],"-1#795467778":[{m:"Qd8-b6",e:8.571},{m:"c5xd4",e:8.571}],"1#-1944538855":[{m:"Bf1-g2",e:9.333},{m:"d4-d5",e:9.333}],"-1#1992901011":[{m:"Ng8-f6",e:8.571}],"1#1285105948":[{m:"c2-c3",e:8.571},{m:"Nb1-c3",e:8.571},{m:"Nb1-d2",e:8.571}],"1#-358204922":[{m:"Nf3xd4",e:8},{m:"Bf1-g2",e:8}],"-1#300122138":[{m:"a7-a6",e:7.5}],"1#-1894288912":[{m:"Bf1-g2",e:6.667}],"-1#-1066263387":[{m:"Bc8-b7",e:6.667}],"1#1539254529":[{m:"c2-c3",e:6.667}],"-1#947124576":[{m:"b7-b5",e:9.975},{m:"e7-e6",e:9.545}],"1#1878716059":[{m:"e2-e4",e:8.333},{m:"e2-e3",e:8.333}],"-1#691823078":[{m:"Bc8-b7",e:6.667}],"1#-1292807102":[{m:"Nb1-d2",e:6.667}],"-1#1659999007":[{m:"e7-e6",e:8.75}],"-1#-783080812":[{m:"a7-a6",e:7.5}],"1#-327156825":[{m:"c2-c4",e:7.5}],"-1#658030230":[{m:"b5xc4",e:7.5}],"1#1100773563":[{m:"Bf1xc4",e:7.5}],"-1#250184550":[{m:"Bc8-b7",e:7.5}],"1#-1792756030":[{m:"Nb1-c3",e:7.5}],"-1#613977044":[{m:"Ng8-f6",e:7.5}],"1#-1558815067":[{m:"O-O",e:8}],"-1#-1186218159":[{m:"d7-d5",e:8.333}],"1#-1717485662":[{m:"Bc4-b3",e:8.333},{m:"Qd1-b3",e:8.333},{m:"Bc4-e2",e:8.333}],"-1#1396742831":[{m:"c7-c5",e:5}],"1#406582733":[{m:"Bb3-a4+",e:5}],"-1#79944515":[{m:"Nb8-d7",e:5}],"1#-683733252":[],"-1#-316846996":[{m:"Ra8-a7",e:5}],"1#1276246771":[],"-1#-1838156713":[{m:"c7-c5",e:6.667}],"1#-652960971":[{m:"b2-b3",e:6.667},{m:"Qd1-b3",e:6.667}],"-1#-175338354":[{m:"c5xd4",e:5}],"1#-944451453":[{m:"e3xd4",e:5}],"-1#-1381439237":[],"1#1929942530":[{m:"e2-e3",e:9.889},{m:"Ng1-f3",e:9.63},{m:"c2-c4",e:9.889}],"-1#-845063667":[{m:"d7-d5",e:9.744}],"1#-313795842":[{m:"Bf1-d3",e:9.6}],"-1#-639667100":[{m:"Nb8-c6",e:5}],"1#1632476984":[{m:"O-O",e:5}],"-1#2064678604":[{m:"Ng8-f6",e:5}],"1#-56710211":[{m:"Nb1-c3",e:9.889},{m:"Nb1-d2",e:9.889},{m:"c2-c3",e:9.889},{m:"b2-b3",e:9.889}],"-1#1294112427":[{m:"Bf8-e7",e:6.667}],"1#-716146909":[{m:"d4xc5",e:5}],"-1#-343784302":[{m:"Be7xc5",e:5}],"-1#748580064":[{m:"c5-c4",e:9.844},{m:"Bf8-e7",e:9.844}],"-1#318597892":[{m:"Qd8-c7",e:9},{m:"Bf8-d6",e:9}],"1#-546716397":[{m:"Nb1-d2",e:8}],"-1#-804865018":[{m:"Bf8-e7",e:9.808},{m:"Qd8-c7",e:9.808},{m:"Bf8-d6",e:9.808}],"1#-595730882":[{m:"Ng1-f3",e:9.991},{m:"d4xc5",e:9.991},{m:"d4-d5",e:9.991}],"-1#620691415":[{m:"e7-e6",e:9.545}],"-1#-491786865":[{m:"Qd8-a5+",e:9.697},{m:"Nb8-a6",e:9.697},{m:"e7-e6",e:9.697}],"1#1990763160":[{m:"Nb1-c3",e:6.667}],"-1#-954949746":[{m:"Ng8-f6",e:6.667},{m:"Qa5xc5",e:6.667}],"1#1083853567":[{m:"Bc1-e3",e:7.5}],"-1#51187514":[{m:"Nf6-g4",e:5}],"1#1017468045":[{m:"Be3-d2",e:5}],"-1#572121754":[{m:"Qa5xc5",e:5}],"1#-1097612076":[{m:"Ng1-h3",e:5}],"1#1537128896":[{m:"e2-e4",e:5}],"-1#492320445":[{m:"d7-d6",e:5}],"1#1531642010":[{m:"Bc1-e3",e:7.5}],"-1#417088863":[{m:"Qc5-a5",e:6.667}],"1#-786023622":[{m:"Qd1-d5",e:5}],"1#-1095482531":[{m:"Ng1-f3",e:9.091}],"-1#1178034868":[{m:"Na6xc5",e:6.667}],"1#-1852116610":[{m:"e2-e3",e:5}],"-1#791887217":[{m:"Ng8-f6",e:5}],"1#-1463949312":[{m:"c2-c4",e:5}],"-1#1677372721":[{m:"g7-g6",e:5}],"1#2054480180":[{m:"b2-b3",e:5}],"-1#1458370191":[{m:"Bf8-g7",e:5}],"1#1489360573":[{m:"Bc1-b2",e:5}],"-1#1284486316":[{m:"O-O",e:5}],"1#-392660523":[{m:"Bf1-e2",e:5}],"-1#729420499":[{m:"d7-d6",e:5}],"1#1835607284":[{m:"O-O",e:5}],"1#-1252424614":[{m:"Nb1-c3",e:9.444}],"-1#82164044":[{m:"Ng8-f6",e:9.333},{m:"Bf8xc5",e:9.333},{m:"Qd8-a5",e:9.333}],"1#-2090111939":[{m:"e2-e4",e:7.5}],"-1#-978459840":[{m:"Qd8-a5",e:7.5}],"1#1370139735":[{m:"Bf1-d3",e:7.5}],"-1#1698562765":[{m:"Bf8xc5",e:7.5},{m:"Nb8-a6",e:7.5}],"1#-795944715":[{m:"Ng1-f3",e:5}],"1#958770207":[{m:"Ng1-f3",e:5}],"-1#-1046049290":[{m:"Na6xc5",e:5}],"1#-1319804044":[{m:"Nc3-e4",e:9.231}],"-1#-776389594":[{m:"Bc5-b4+",e:9.231},{m:"d7-d5",e:9.231},{m:"Ng8-f6",e:9.231}],"1#-1864173989":[{m:"Bc1-d2",e:5}],"-1#-1114863298":[{m:"Qa5xc5",e:5}],"1#554086256":[{m:"e2-e4",e:5}],"-1#1740644365":[{m:"Ng8-f6",e:5}],"1#-531696260":[{m:"Bf1-d3",e:5}],"-1#648818356":[{m:"e7-e6",e:9.99},{m:"Ng8-f6",e:9.99},{m:"g7-g6",e:9.99},{m:"e7-e5",e:9.99},{m:"f7-f5",e:9.99}],"1#1901741921":[{m:"Nb1-c3",e:9.89},{m:"c2-c4",e:9.89},{m:"e2-e4",e:9.89}],"-1#-1058637193":[{m:"e6xd5",e:9},{m:"a7-a6",e:9}],"-1#-1172503984":[{m:"e6xd5",e:9.91}],"-1#933021724":[{m:"e6xd5",e:9.737}],"1#-1591542843":[{m:"Nb1-c3",e:9.981},{m:"Ng1-f3",e:9.981}],"-1#278841043":[{m:"g7-g6",e:9.859}],"1#152079062":[{m:"e2-e4",e:9.796}],"-1#1339426219":[{m:"d7-d6",e:9.787}],"1#163918732":[{m:"Bc1-f4",e:9.831}],"-1#1503779372":[{m:"g7-g6",e:9.985},{m:"e7-e6",e:9.985}],"1#1059218097":[{m:"g2-g3",e:9.908},{m:"e2-e4",e:9.908},{m:"c2-c4",e:9.908}],"-1#-1800105288":[{m:"Bf8-g7",e:6.667}],"-1#2045046220":[{m:"Bf8-g7",e:9.89}],"-1#-194697344":[{m:"Bf8-g7",e:9.412}],"1#-95680590":[{m:"d4-d5",e:9.901}],"-1#1274034852":[{m:"e7-e5",e:9.884}],"1#1173474912":[{m:"d5xe6",e:9.944},{m:"e2-e4",e:9.944}],"-1#-164578974":[{m:"f7xe6",e:6.667}],"1#-1439188838":[{m:"e2-e4",e:6.667}],"-1#-319735833":[{m:"Nb8-c6",e:6.667}],"-1#53952797":[{m:"d7-d6",e:9.929}],"1#1160017722":[{m:"f2-f4",e:9.927},{m:"c2-c4",e:9.927}],"1#-1329156196":[{m:"g2-g3",e:9.697},{m:"Nb1-c3",e:9.697},{m:"c2-c4",e:9.697},{m:"e2-e4",e:9.697}],"-1#458252181":[{m:"d7-d6",e:9}],"-1#24810122":[{m:"Ng8-f6",e:8.75}],"-1#2072111789":[{m:"d7-d6",e:8.571}],"-1#-167763743":[{m:"f5xe4",e:8.571}],"1#-1903624871":[{m:"c2-c3",e:9.989},{m:"c2-c4",e:9.989}],"-1#1626029536":[{m:"Bf8-g7",e:9.474}],"1#1858215378":[{m:"Bc1-g5",e:9.444},{m:"e2-e3",e:9.444}],"-1#-2091250999":[{m:"Ng8-f6",e:9.375}],"1#81059768":[{m:"e2-e3",e:9.756},{m:"Nb1-d2",e:9.756}],"-1#-1166208073":[{m:"d7-d6",e:8}],"1#-59890288":[{m:"Bf1-d3",e:8}],"-1#-923104502":[{m:"Nb8-d7",e:8}],"1#453402293":[{m:"Nb1-d2",e:8}],"-1#-888759832":[{m:"O-O",e:8},{m:"c7-c6",e:8}],"1#1863406737":[{m:"Ng1-e2",e:5}],"-1#-253773458":[{m:"e7-e5",e:5}],"1#-1820173894":[{m:"O-O",e:5}],"-1#-1981826994":[{m:"h7-h6",e:5}],"1#-1008120402":[{m:"Bg5-h4",e:7.5}],"-1#211626131":[{m:"Qd8-c7",e:5}],"1#1132778919":[{m:"Ng1-e2",e:5}],"-1#-599115688":[{m:"O-O",e:5}],"-1#-724297499":[{m:"O-O",e:9.73},{m:"d7-d5",e:9.73},{m:"h7-h6",e:9.73}],"1#1891882396":[{m:"e2-e4",e:9.286}],"-1#906320609":[{m:"d7-d6",e:9}],"1#1880517830":[{m:"Bf1-c4",e:9.231},{m:"f2-f4",e:9.231}],"1#-197224426":[{m:"e2-e3",e:9.474}],"-1#1251431449":[{m:"O-O",e:9.474}],"1#-293562016":[{m:"Bf1-d3",e:9.375}],"1#-2114560043":[{m:"Bg5-h4",e:6.667}],"-1#1317157608":[{m:"d7-d5",e:6.667},{m:"d7-d6",e:6.667}],"1#1852357147":[{m:"e2-e3",e:5}],"-1#-798240291":[{m:"d7-d5",e:6.667}],"1#-259960530":[{m:"Nb1-d2",e:5}],"-1#545363571":[{m:"Ng8-f6",e:5}],"1#-1492172030":[{m:"f2-f4",e:5}],"-1#-615649918":[{m:"c7-c5",e:5}],"1#-1875475744":[{m:"Bf1-d3",e:5}],"-1#-1532875654":[{m:"O-O",e:5}],"1#11919619":[{m:"Ng1-f3",e:5}],"-1#-130629398":[{m:"b7-b6",e:6.667}],"1#-1397745672":[{m:"Nf3-e5",e:6.667}],"-1#671475170":[{m:"c5xd4",e:6.667}],"1#440252911":[{m:"e3xd4",e:5}],"-1#1285369444":[{m:"Bc8-a6",e:5}],"1#-1931293401":[{m:"Bd3-c2",e:5}],"-1#1418210589":[{m:"e7-e6",e:5}],"1#58606792":[{m:"Qd1-f3",e:5}],"-1#13842787":[{m:"Nf6-d7",e:5}],"1#-1102538189":[{m:"h2-h4",e:5}],"-1#97489599":[{m:"Nd7xe5",e:5}],"1#-1801962598":[{m:"f4xe5",e:5}],"-1#-1851968686":[{m:"f7-f6",e:5}],"1#-1248102780":[{m:"Qf3-g3",e:5}],"-1#-1290344849":[{m:"f6xe5",e:5}],"1#-1491732563":[{m:"d4xe5",e:5}],"-1#-2038792041":[{m:"Qd8-c7",e:5}],"1#-916226653":[{m:"Nd2-f3",e:5}],"-1#-437179062":[{m:"Qc7-c4",e:5}],"1#-63481404":[{m:"Bc2-d1",e:5}],"-1#955782439":[{m:"Nb8-d7",e:5}],"1#-352010088":[{m:"Bc1-e3",e:5}],"-1#1171241064":[{m:"Bf8-g7",e:9.982}],"1#1273403482":[{m:"g2-g3",e:9.98},{m:"e2-e4",e:9.98},{m:"Nb1-c3",e:9.98},{m:"Ng1-f3",e:9.98}],"-1#-529504173":[{m:"c7-c5",e:9.167}],"1#-1425340623":[{m:"d4-d5",e:8.333}],"-1#1373304763":[{m:"Qd8-a5+",e:8.333}],"1#-975325012":[{m:"Bc1-d2",e:6.667}],"-1#-390871095":[{m:"Qa5-b6",e:5}],"1#-1770784741":[{m:"Nb1-c3",e:5}],"-1#667927821":[{m:"Qb6xb2",e:5}],"1#-1226938384":[{m:"Ra1-c1",e:5}],"-1#-715845253":[{m:"d7-d6",e:5}],"1#-1824118948":[{m:"Nc3-b5",e:5}],"-1#186198983":[{m:"Nb8-a6",e:5}],"1#1459782933":[{m:"Qd1-a4",e:5}],"-1#-1780509888":[{m:"Bc8-d7",e:5}],"1#1160234819":[{m:"Rc1-c2",e:6.667}],"-1#116996785":[{m:"Qb2-e5",e:6.667}],"-1#220206887":[{m:"d7-d6",e:9.962},{m:"Nb8-c6",e:9.962}],"1#1261641984":[{m:"Bc1-e3",e:9.959}],"-1#144991429":[{m:"Ng8-f6",e:8.333}],"1#-1893027404":[{m:"f2-f3",e:8}],"-1#421822234":[{m:"Nb8-c6",e:8.889},{m:"O-O",e:8.889}],"1#-1120685469":[{m:"Ng1-e2",e:9}],"1#-1246561157":[{m:"d4-d5",e:9.545},{m:"Ng1-e2",e:9.545},{m:"Ng1-f3",e:9.545}],"-1#1331891441":[{m:"Nc6-d4",e:6.667}],"-1#712774020":[{m:"e7-e5",e:8}],"1#1226961232":[{m:"Bc1-e3",e:8}],"-1#1295113618":[{m:"d7-d6",e:8.75}],"-1#-94722740":[{m:"f7-f5",e:9.964},{m:"c7-c5",e:9.964}],"1#1815094372":[{m:"h2-h4",e:7.5}],"-1#-675861272":[{m:"c7-c5",e:5}],"1#-1664334966":[{m:"d4-d5",e:5}],"-1#1713222400":[{m:"Ng8-f6",e:6.667}],"1#-510433679":[{m:"g2-g3",e:5}],"-1#1241880184":[{m:"d7-d6",e:5}],"1#-1323185618":[{m:"d4-d5",e:9.901},{m:"d4xc5",e:9.901},{m:"Ng1-f3",e:9.901}],"-1#-1879836257":[{m:"Nb8-a6",e:7.5}],"-1#1235413959":[{m:"Ng8-f6",e:9.762}],"-1#-1285178957":[{m:"c7-c5",e:9.966}],"1#-132196655":[{m:"e2-e4",e:9.925},{m:"d4-d5",e:9.925},{m:"g2-g3",e:9.925},{m:"d4xc5",e:9.925}],"-1#-1093117524":[{m:"Nb8-c6",e:9.929},{m:"Qd8-a5+",e:9.929},{m:"Qd8-b6",e:9.929}],"-1#47130203":[{m:"b7-b5",e:9.615},{m:"f7-f5",e:9.615}],"-1#1401431768":[{m:"c5xd4",e:9.231},{m:"Ng8-h6",e:9.231}],"-1#-959650464":[{m:"Nb8-a6",e:5}],"1#-1697166414":[{m:"e2-e3",e:5}],"-1#612272061":[{m:"Na6xc5",e:5}],"1#-1014995378":[{m:"Ng1-f3",e:9.844},{m:"d2-d4",e:9.951}],"-1#990070695":[{m:"Bc8-b7",e:9.375}],"1#-1597083133":[{m:"g2-g3",e:9.286}],"-1#190349834":[{m:"Bb7xf3",e:8.571}],"1#-212759554":[{m:"e2xf3",e:6.667}],"-1#1377268826":[{m:"d7-d5",e:6.667}],"1#1929245865":[{m:"f3-f4",e:6.667}],"-1#1591470170":[{m:"e7-e6",e:5}],"1#153977231":[{m:"Bf1-g2",e:5}],"-1#1179184346":[{m:"c7-c6",e:5}],"1#1319581852":[{m:"O-O",e:5}],"-1#1425725800":[{m:"Bf8-d6",e:5}],"1#-1720813697":[{m:"f4-f5",e:5}],"-1#1630415580":[{m:"e6xf5",e:5}],"1#-65829361":[{m:"c2-c4",e:5}],"-1#928301886":[{m:"d5xc4",e:5}],"1#1153522231":[{m:"d4-d5",e:5}],"-1#-1106203971":[{m:"Ng8-e7",e:5}],"1#1473985845":[{m:"d5xc6",e:5}],"-1#372031286":[{m:"Nb8xc6",e:5}],"1#1307278058":[{m:"Qd1-a4",e:5}],"-1#-1892258625":[{m:"Qd8-c8",e:5}],"1#1237499381":[{m:"Bc1-g5",e:5}],"-1#-1537561874":[{m:"f7-f6",e:5}],"1#-2141393096":[{m:"Bg5-e3",e:5}],"-1#1578512721":[{m:"Ra8-b8",e:5}],"1#3092418":[{m:"Nb1-c3",e:5}],"-1#-1315761452":[{m:"a7-a6",e:5}],"1#-1933587481":[{m:"Qa4xc4",e:5}],"-1#201067392":[{m:"Nc6-e5",e:5}],"1#-1997141860":[{m:"Qc4-b3",e:5}],"-1#136854143":[{m:"Qc8-c4",e:5}],"1#-1744608625":[{m:"Rf1-d1",e:5}],"-1#-27478561":[{m:"Bd6-b4",e:5}],"1#797624768":[{m:"Qb3-a4+",e:5}],"-1#-374464276":[{m:"b6-b5",e:5}],"1#-1696305998":[{m:"Qa4xa6",e:5}],"-1#-349318195":[],"1#-1612094182":[{m:"c2-c4",e:9.885},{m:"g2-g3",e:9.885}],"-1#1420697643":[{m:"b7-b5",e:9.926}],"1#52901840":[{m:"c4-c5",e:8.333},{m:"c4xb5",e:8.333}],"-1#-1366363927":[{m:"d7-d6",e:5}],"1#-392313138":[{m:"c5xd6",e:5}],"-1#-152132385":[{m:"e7xd6",e:5}],"1#1894112348":[{m:"e2-e4",e:5}],"-1#908284705":[{m:"Ng8-f6",e:5}],"1#-1314027952":[{m:"Bf1-d3",e:5}],"-1#-2059851574":[{m:"Qd8-b6",e:5}],"1#532403384":[{m:"Ng1-f3",e:5}],"-1#-415697583":[{m:"Bc8-g4",e:5}],"1#-716281004":[{m:"Bc1-e3",e:5}],"-1#-1764151663":[{m:"d6-d5",e:5}],"1#1485263261":[{m:"e4xd5",e:5}],"-1#-733032198":[{m:"Nf6xd5",e:5}],"1#783942031":[{m:"O-O",e:5}],"-1#887611515":[{m:"Bf8-e7",e:5}],"1#-1399520781":[{m:"Nb1-c3",e:5}],"-1#489241829":[{m:"Nd5xe3",e:5}],"1#-1427652896":[{m:"f2xe3",e:5}],"-1#-1838120968":[{m:"Nb8-d7",e:5}],"1#1099737671":[{m:"Qd1-c2",e:5}],"-1#-801878637":[{m:"g7-g6",e:5}],"1#-910556778":[{m:"a2-a4",e:5}],"-1#399126407":[{m:"b5xa4",e:5}],"1#-839550356":[{m:"Bd3-c4",e:5}],"-1#827159557":[{m:"O-O",e:5}],"1#-1789216388":[{m:"h2-h3",e:5}],"-1#-1915043934":[{m:"Bg4xf3",e:5}],"1#-597156361":[{m:"Rf1xf3",e:5}],"-1#118899975":[{m:"Kg8-g7",e:5}],"1#805823277":[{m:"Ra1-f1",e:5}],"-1#-1935093393":[{m:"f7-f5",e:5}],"-1#44723336":[{m:"c6xb5",e:8}],"1#1000323918":[{m:"Qd1-b3",e:8},{m:"e2-e4",e:8}],"-1#1327745152":[{m:"a7-a6",e:5}],"1#1913590195":[{m:"a2-a4",e:5}],"-1#-1400946782":[{m:"b5xa4",e:5}],"1#544356263":[{m:"Ra1xa4",e:5}],"-1#1144344652":[{m:"e7-e6",e:5}],"1#331561369":[{m:"e2-e4",e:5}],"-1#1426437860":[{m:"a6-a5",e:5}],"1#951963495":[{m:"Nb1-c3",e:5}],"-1#-1996361103":[{m:"Nb8-c6",e:5}],"1#831723821":[{m:"Ng1-f3",e:5}],"-1#-921683772":[{m:"Ra8-b8",e:5}],"1#-1758910889":[{m:"Qb3-d1",e:5}],"-1#-476752487":[{m:"Ng8-f6",e:5}],"1#1679524072":[{m:"e4-e5",e:5}],"-1#2102998067":[{m:"Ng8-f6",e:7.5}],"1#-86515390":[{m:"Bf1-d3",e:7.5}],"-1#-834449448":[{m:"Bc8-b7",e:7.5}],"1#1435400828":[{m:"Nb1-d2",
e:7.5}],"-1#880776467":[{m:"d7-d5",e:5}],"1#345314784":[{m:"Bf1-g2",e:6.667}],"-1#1542486197":[{m:"Ng8-f6",e:6.667}],"1#-595677756":[{m:"Nb1-d2",e:9.474}],"-1#209611417":[{m:"e7-e5",e:6.667}],"1#1864600141":[{m:"d4xe5",e:5}],"-1#360937216":[{m:"Nf6-g4",e:5}],"1#707472567":[{m:"Ng1-f3",e:5}],"-1#-760738466":[{m:"Bf8-c5",e:5}],"1#845713229":[{m:"e2-e3",e:5}],"-1#-1933491390":[{m:"Nb8-d7",e:5}],"1#1597871869":[{m:"c2-c4",e:5}],"-1#-1803889716":[{m:"Nd7xe5",e:5}],"1#812649520":[{m:"Nf3xe5",e:5}],"-1#-31923099":[{m:"Ng4xe5",e:5}],"1#-293816921":[{m:"c4xd5",e:5}],"-1#2037140075":[{m:"O-O",e:5}],"1#-579107054":[{m:"O-O",e:5}],"-1#-953784602":[{m:"c6xd5",e:5}],"1#277174408":[{m:"Nd2-b3",e:5}],"-1#-1604475400":[{m:"Bc5-b6",e:5}],"1#-147176034":[{m:"Nb3-d4",e:5}],"-1#1712953218":[{m:"Bc8-g4",e:5}],"1#1416563079":[{m:"f2-f3",e:5}],"-1#-1033779415":[{m:"Bg4-d7",e:5}],"1#1353351576":[{m:"b2-b3",e:5}],"-1#2083690019":[{m:"Qd8-f6",e:5}],"1#-789670483":[{m:"Bc1-b2",e:5}],"-1#-995821636":[{m:"Rf8-e8",e:5}],"1#-2110094980":[{m:"Qd1-d2",e:5}],"-1#-233322853":[{m:"h7-h5",e:5}],"1#-796127004":[{m:"Ra1-d1",e:5}],"-1#-903596313":[{m:"Qf6-h6",e:5}],"1#-1324239498":[{m:"h2-h3",e:5}],"-1#-1450069080":[{m:"Qh6-g6",e:5}],"1#-759343509":[{m:"f3-f4",e:5}],"-1#1219803890":[{m:"Ne5-c6",e:5}],"1#909108262":[],"1#798251520":[{m:"Bc1-g5",e:9.934},{m:"d2-d4",e:9.853},{m:"d4-d5",e:9.934},{m:"d2-d4",e:9.976},{m:"c2-c4",e:9.934}],"-1#-1039381221":[{m:"h7-h6",e:8},{m:"f7-f6",e:8}],"1#-1758590421":[{m:"Bg5-h4",e:6.667}],"-1#1482321686":[{m:"Ng8-f6",e:6.667}],"1#-539706777":[{m:"e2-e3",e:5}],"-1#1635612264":[{m:"e7-e5",e:5}],"1#35690172":[{m:"d4xe5",e:5}],"-1#2021682161":[{m:"Nc6xe5",e:5}],"1#-1209758994":[{m:"Ng1-f3",e:5}],"-1#1332194055":[{m:"Ne5xf3+",e:5}],"1#80211696":[{m:"Qd1xf3",e:5}],"-1#283165202":[{m:"Bf8-e7",e:5}],"1#-2003688550":[{m:"Nb1-c3",e:5}],"-1#959323788":[{m:"d7-d5",e:5}],"1#432316031":[{m:"h2-h3",e:5}],"-1#21272737":[{m:"c7-c6",e:5}],"1#162221287":[{m:"Bf1-d3",e:5}],"-1#1027596925":[{m:"Qd8-a5",e:5}],"1#-1455903382":[{m:"a2-a3",e:5}],"-1#-1098285389":[{m:"Qa5-b6",e:5}],"1#-1068940959":[{m:"b2-b4",e:5}],"-1#-1136663390":[{m:"a7-a5",e:5}],"1#-435550003":[{m:"Bg5-h4",e:5}],"-1#696151536":[{m:"Ng8-h6",e:5}],"1#-1578548305":[{m:"e2-e4",e:5}],"-1#-416297774":[{m:"d7-d5",e:5}],"1#-943371231":[{m:"Nb1-c3",e:5}],"-1#1987670327":[{m:"d5xe4",e:5}],"1#853080869":[{m:"d4-d5",e:5}],"-1#-938931281":[{m:"Nc6-e5",e:5}],"1#1258490035":[{m:"Bh4-g3",e:5}],"-1#912697137":[{m:"Bc8-f5",e:5}],"1#1491556670":[{m:"Bg3xe5",e:5}],"-1#1478670059":[{m:"f6xe5",e:5}],"1#1574157478":[{m:"Bf1-b5+",e:5}],"-1#-1343628268":[{m:"Ke8-f7",e:5}],"1#898863668":[{m:"Ng1-h3",e:5}],"-1#-928364396":[{m:"Kf7-g8",e:5}],"1#1065298360":[{m:"Nh3-g5",e:5}],"-1#-520223811":[{m:"e7-e6",e:5}],"1#-1224185240":[{m:"Ng5xe6",e:5}],"-1#-686326807":[{m:"Ng8-f6",e:9.9},{m:"d7-d5",e:9.9},{m:"d7-d6",e:9.9}],"1#1352248984":[{m:"g2-g3",e:8},{m:"c2-c4",e:8}],"-1#-82878831":[{m:"d7-d6",e:6.667}],"1#-1122211658":[{m:"Bf1-g2",e:7.5}],"-1#-226949661":[{m:"e7-e5",e:7.5}],"1#-1859853001":[{m:"c2-c4",e:5}],"-1#1516478470":[{m:"Bc8-g4",e:6.667}],"1#1746222595":[{m:"d4-d5",e:6.667}],"-1#-1832595831":[{m:"Nc6-e7",e:5}],"1#42584940":[{m:"Nb1-c3",e:5}],"-1#-1288309126":[{m:"g7-g6",e:5}],"1#-1430537601":[{m:"h2-h3",e:5}],"-1#-1304707935":[{m:"Bg4-d7",e:5}],"1#552663568":[{m:"O-O",e:5}],"-1#984423396":[{m:"Bf8-g7",e:5}],"1#881081302":[{m:"e2-e4",e:5}],"-1#1916974251":[{m:"O-O",e:5}],"1#-699041326":[{m:"c4-c5",e:6.667},{m:"Nf3-e1",e:6.667}],"-1#2080161515":[{m:"Nf6-e8",e:5}],"1#-788862914":[{m:"c5xd6",e:5}],"-1#-829846993":[],"-1#855944870":[{m:"Nf6-e8",e:5}],"1#-1744635789":[{m:"Ne1-d3",e:5}],"-1#1258884650":[{m:"f7-f5",e:5}],"-1#-1679889495":[{m:"e7-e6",e:9.87},{m:"d7-d6",e:9.87}],"1#-869760388":[{m:"Bc1-g5",e:9.885},{m:"g2-g3",e:9.885},{m:"Nb1-c3",e:9.885}],"-1#565220711":[{m:"h7-h6",e:8}],"1#1955779159":[{m:"Bg5xf6",e:6.667}],"-1#-1273332518":[{m:"Qd8xf6",e:6.667}],"-1#1740534389":[{m:"Bf8-b4+",e:9.333}],"1#196685002":[{m:"Bc1-d2",e:8.889}],"-1#2106900330":[{m:"Bf8-b4",e:9.787}],"1#294904277":[{m:"Qd1-c2",e:9.773},{m:"e2-e3",e:9.773}],"1#-573710962":[{m:"Nb1-c3",e:9.231}],"-1#1819402392":[{m:"Bc8-f5",e:9}],"1#49290903":[{m:"d4-d5",e:5}],"-1#-131994083":[{m:"Nc6-e5",e:5}],"1#2066476289":[{m:"Nf3-d4",e:5}],"-1#-638295926":[{m:"g7-g6",e:5}],"1#-1065735025":[{m:"Nd4xf5",e:5}],"-1#1334406065":[{m:"g6xf5",e:5}],"1#-2128253626":[{m:"Qd1-c2",e:5}],"-1#278760082":[{m:"Qd8-d7",e:5}],"1#-750874658":[{m:"e2-e3",e:5}],"-1#1838629841":[{m:"Bf8-g7",e:5}],"1#-134350054":[{m:"g2-g3",e:9.942},{m:"Bc1-g5",e:9.942},{m:"c2-c4",e:9.942},{m:"e2-e3",e:9.942},{m:"Bc1-f4",e:9.942}],"-1#1550519059":[{m:"g7-g6",e:9.828},{m:"Bc8-f5",e:9.828}],"1#1172653846":[{m:"Bf1-g2",e:7.5}],"-1#176171587":[{m:"Bf8-g7",e:7.5}],"1#78187121":[{m:"O-O",e:7.5}],"1#854258972":[{m:"Bf1-g2",e:9.375}],"-1#2106562633":[{m:"Qd8-d7",e:9.643},{m:"Ng8-f6",e:9.643},{m:"Nc6-b4",e:9.643}],"-1#442887169":[{m:"Bc8-g4",e:8.75}],"1#672363012":[{m:"Nb1-d2",e:8.571},{m:"e2-e3",e:8.571}],"-1#-132926119":[{m:"f7-f6",e:7.5}],"1#-602541937":[{m:"Bg5-h4",e:5}],"-1#325162418":[{m:"Qd8-d7",e:5}],"1#-792555266":[{m:"h2-h3",e:5}],"-1#-1766146549":[{m:"f7-f6",e:6.667},{m:"Qd8-d7",e:6.667}],"1#1427749703":[{m:"Nb1-d2",e:5}],"-1#1018871339":[{m:"Bc8-g4",e:9.886},{m:"e7-e5",e:9.886}],"1#248258606":[{m:"c4xd5",e:9.839},{m:"Nb1-c3",e:9.839},{m:"Qd1-a4",e:9.839}],"1#1608998655":[{m:"Nf3xe5",e:9.524},{m:"e2-e3",e:9.524},{m:"d4xe5",e:9.524},{m:"c4xd5",e:9.524}],"-1#1230255893":[{m:"Bc8-f5",e:9.333}],"1#668322074":[{m:"Bf1-b5",e:7.5}],"-1#-705713752":[{m:"e7-e6",e:5}],"1#-2112241539":[{m:"Nf3-e5",e:5}],"-1#111948391":[{m:"Ng8-e7",e:5}],"1#-278419985":[{m:"g2-g4",e:5}],"-1#1066683909":[{m:"Bf5-e4",e:5}],"1#-786915082":[{m:"f2-f3",e:5}],"-1#1192652376":[{m:"Be4-g6",e:5}],"-1#-1024041672":[{m:"Bc8-f5",e:9.844},{m:"Bc8-g4",e:9.844}],"1#-1401445577":[{m:"e2-e3",e:8.889}],"-1#316567352":[{m:"e7-e6",e:8.571}],"1#1160251117":[{m:"Bf1-e2",e:8}],"1#-259996867":[{m:"e2-e3",e:9.796}],"-1#1311313714":[{m:"e7-e6",e:9.762}],"1#434071271":[{m:"Nb1-d2",e:9.756},{m:"Bf1-e2",e:9.756}],"1#-1861988914":[{m:"d4-d5",e:9.667},{m:"g2-g3",e:9.667}],"-1#1809169732":[{m:"Nc6-e5",e:8.571}],"1#-387989928":[{m:"Nf3xe5",e:8.571}],"-1#649549325":[{m:"d6xe5",e:8.571}],"1#636106785":[{m:"e2-e4",e:8.571}],"-1#1663874908":[{m:"e7-e6",e:8.333}],"1#886759049":[{m:"Bf1-b5+",e:5}],"-1#-958349765":[{m:"Bc8-d7",e:5}],"1#370731576":[{m:"Bb5xd7+",e:5}],"-1#85013212":[{m:"Qd8xd7",e:5}],"1#326192334":[{m:"d5xe6",e:5}],"-1#-1810124083":[{m:"Qd7xe6",e:5}],"1#2069157018":[{m:"Qd1-e2",e:5}],"-1#-1139262266":[{m:"c7-c6",e:5}],"1#-1258821504":[{m:"O-O",e:5}],"-1#-1364588172":[{m:"Ng8-f6",e:5}],"1#690281477":[{m:"Bc1-g5",e:5}],"-1#-994260194":[{m:"h7-h6",e:5}],"1#-1851880402":[{m:"Bg5xf6",e:5}],"-1#1360405155":[{m:"Qe6xf6",e:5}],"1#-415619811":[{m:"Rf1-d1",e:5}],"-1#-2124025267":[{m:"Bf8-c5",e:5}],"1#1638232158":[{m:"c2-c3",e:5}],"-1#-1882803993":[{m:"O-O",e:5}],"1#735149470":[{m:"Nb1-d2",e:5}],"-1#-70141245":[{m:"Rf8-d8",e:5}],"-1#982695367":[{m:"Bc8-g4",e:7.5}],"1#149169090":[{m:"Bf1-g2",e:6.667}],"-1#1199656599":[{m:"e7-e5",e:6.667}],"1#618442307":[{m:"d4-d5",e:6.667}],"-1#-569549111":[{m:"Nc6-e7",e:6.667}],"1#1312840492":[{m:"c2-c4",e:5}],"-1#-2063131107":[{m:"c7-c5",e:5}],"1#-830705281":[{m:"d5xc6",e:5}],"-1#-870365096":[{m:"Ne7xc6",e:5}],"1#-1090034883":[{m:"Nb1-c3",e:5}],"-1#247160363":[{m:"Ng8-f6",e:5}],"1#-1992979622":[{m:"O-O",e:5}],"-1#-1821873490":[{m:"Bf8-e7",e:5}],"1#186288934":[{m:"Bc1-g5",e:5}],"-1#-427647939":[{m:"O-O",e:5}],"1#1117081924":[{m:"Qd1-d2",e:5}],"-1#850925219":[{m:"Qd8-d7",e:5}],"1#-249883665":[{m:"Rf1-d1",e:5}],"-1#-1757100865":[{m:"Rf8-d8",e:5}],"1#371383070":[{m:"Ra1-c1",e:5}],"-1#1974054293":[{m:"Ra8-c8",e:5}],"1#-1648809927":[{m:"b2-b3",e:5}],"-1#-1323221118":[{m:"h7-h6",e:5}],"1#-469534542":[{m:"Bg5xf6",e:5}],"-1#-716854646":[{m:"Nc6-e5",e:9.63}],"1#1448061334":[{m:"e2-e4",e:9.615},{m:"f2-f4",e:9.615}],"-1#277423851":[{m:"e7-e6",e:9.286}],"1#1199525694":[{m:"Nb1-c3",e:9.167},{m:"Qd1-d4",e:9.167}],"-1#-154963416":[{m:"e6xd5",e:8}],"1#-1580344935":[{m:"e4xd5",e:7.5}],"-1#755259646":[{m:"Bf8-b4",e:7.5},{m:"Ng8-f6",e:7.5},{m:"Bf8-c5",e:7.5}],"1#1090717249":[{m:"Qd1-d4",e:5}],"1#-1433760369":[],"1#-842736915":[{m:"Nc3-e4",e:5}],"-1#-1587964478":[{m:"Qd8-f6",e:6.667}],"1#226858572":[{m:"f2-f4",e:5}],"-1#1908881612":[{m:"Ne5-g6",e:5}],"1#-1907186865":[{m:"e4-e5",e:5}],"-1#1604976600":[{m:"Qf6-e7",e:5}],"1#-820077783":[{m:"Nb1-c3",e:5}],"-1#2124588607":[{m:"Qe7-b4",e:5}],"1#65654702":[{m:"Qd4-d2",e:5}],"-1#-441983486":[{m:"a7-a6",e:5}],"-1#705496854":[{m:"Ne5-g6",e:9.167}],"1#-711418731":[{m:"e2-e4",e:9.167}],"-1#-1822551064":[{m:"e7-e6",e:9.231}],"1#-995591619":[{m:"d5xe6",e:9.375},{m:"Ng1-f3",e:9.375}],"-1#1136821310":[{m:"f7xe6",e:9.333},{m:"d7xe6",e:9.333}],"1#533038534":[{m:"Ng1-f3",e:9.091}],"-1#-414800849":[{m:"Bf8-c5",e:9.091}],"1#1811100233":[{m:"Bf1-d3",e:8},{m:"Qd1xd8+",e:8}],"-1#1600625875":[{m:"Bf8-c5",e:6.667}],"-1#1009474516":[{m:"e6xd5",e:5}],"1#1797648485":[{m:"Qd1xd5",e:5}],"-1#15923822":[],"-1#-455925967":[{m:"d7-d6",e:9.767},{m:"e7-e5",e:9.767}],"1#-1564464874":[{m:"d4-d5",e:6.667}],"-1#1477564828":[{m:"Nc6-e5",e:5}],"1#-618931584":[{m:"Nb1-c3",e:5}],"-1#1789388694":[{m:"Ng8-f6",e:5}],"1#-316067097":[{m:"e2-e4",e:5}],"-1#-1410351718":[{m:"e7-e6",e:5}],"1#-65416113":[{m:"f2-f4",e:5}],"-1#-2141488433":[{m:"Ne5-g6",e:5}],"1#2144264524":[{m:"Ng1-f3",e:5}],"-1#-2024947547":[{m:"Bf8-e7",e:5}],"1#524230957":[{m:"Bf1-d3",e:5}],"-1#732663735":[{m:"O-O",e:5}],"1#-1883487538":[{m:"O-O",e:5}],"-1#-1780374726":[{m:"e6xd5",e:5}],"1#-1024522101":[{m:"c4xd5",e:5}],"-1#-2047779512":[{m:"c7-c6",e:5}],"1#-1927378674":[{m:"d5xc6",e:5}],"-1#2135929493":[{m:"b7xc6",e:5}],"1#98918729":[{m:"f4-f5",e:5}],"-1#1922792676":[{m:"Ng6-e5",e:5}],"1#-2020671515":[{m:"d4-d5",e:9.756},{m:"d4xe5",e:9.756}],"-1#2103381871":[{m:"Nc6-e7",e:9.73}],"1#-317584758":[{m:"e2-e4",e:9.722},{m:"g2-g3",e:9.722},{m:"Nb1-c3",e:9.722}],"-1#1183120003":[{m:"Ne7-g6",e:7.5}],"1#-1437177863":[{m:"Bf1-g2",e:6.667}],"-1#1554921372":[{m:"Nc6-e7",e:9.583},{m:"Ne7-g6",e:9.286}],"-1#-47316312":[{m:"Nc6xe5",e:6.667}],"1#843768759":[{m:"e2-e4",e:6.667}],"-1#1955359946":[{m:"Nc6xe5",e:5}],"1#-1209257553":[{m:"Bc1-f4",e:10},{m:"c2-c4",e:10},{m:"e2-e3",e:10},{m:"Bc1-g5",e:10},{m:"d2-d4",e:9.997},{m:"Nb1-c3",e:10}],"-1#-2098751603":[{m:"Ng8-f6",e:9.841},{m:"c7-c6",e:9.841}],"1#90784508":[{m:"e2-e3",e:9.773}],"-1#-1145008397":[{m:"c7-c5",e:9.756},{m:"g7-g6",e:9.756}],"1#-256122479":[{m:"c2-c3",e:9.545}],"-1#517480744":[{m:"Nb8-c6",e:9.524},{m:"Qd8-b6",e:9.524}],"1#-1505047948":[{m:"Bf1-d3",e:9.524}],"1#-1571896586":[{m:"h2-h3",e:7.5}],"-1#-1160854488":[{m:"Bf8-g7",e:5}],"1#-1259871206":[{m:"Ng1-f3",e:5}],"-1#1281672691":[{m:"c7-c5",e:9.412}],"1#-1979169845":[{m:"e2-e3",e:8.333}],"-1#883003332":[{m:"Qd8-b6",e:8.333}],"1#-1373408330":[{m:"b2-b3",e:8.333}],"-1#-2101648371":[{m:"Ng8-f6",e:6.667}],"1#87404924":[{m:"Bf1-d3",e:5}],"-1#832643046":[{m:"Bc8-g4",e:5}],"1#64455139":[{m:"Ng1-e2",e:5}],"-1#-1676055524":[{m:"Nb8-d7",e:5}],"1#1340455331":[{m:"O-O",e:5}],"-1#1438144599":[{m:"e7-e6",e:5}],"1#38678914":[{m:"c2-c4",e:5}],"-1#-922127181":[{m:"Bf8-e7",e:5}],"-1#2091611294":[{m:"Ng8-f6",e:10},{m:"c7-c6",e:10},{m:"Nb8-c6",e:10},{m:"d5xc4",e:10},{m:"c7-c5",e:10},{m:"Bc8-f5",e:10},{m:"e7-e5",e:10},{m:"e7-e6",e:10}],"1#-81419793":[{m:"c4xd5",e:9.688}],"-1#1815436835":[{m:"Nf6xd5",e:9.565}],"1#1950654680":[{m:"Bc1-f4",e:9.998},{m:"Nb1-d2",e:9.998}],"1#-1002856510":[{m:"c4xd5",e:9.953},{m:"e2-e3",e:9.953}],"1#255782295":[{m:"Nb1-c3",e:9.997},{m:"Ng1-f3",e:9.997}],"1#936385532":[{m:"e2-e3",e:9.583},{m:"c4xd5",e:9.583}],"1#304777873":[{m:"Ng1-f3",e:9.934},{m:"Qd1-b3",e:9.934}],"1#536253514":[{m:"d4xe5",e:9.891}],"-1#1700161799":[{m:"d5-d4",e:9.881}],"1#727522635":[{m:"Ng1-f3",e:9.999},{m:"d2-d4",e:9.952}],"-1#155581856":[{m:"Ng8-f6",e:9.744}],"1#-1899288367":[{m:"f2-f4",e:9.697}],"-1#-225868207":[{m:"c7-c5",e:9.091},{m:"Bc8-f5",e:9.091}],"1#-1175262925":[{m:"c2-c3",e:7.5}],"-1#1469131146":[{m:"e7-e6",e:7.5}],"1#6766687":[{m:"Nb1-d2",e:5}],"-1#-798521598":[{m:"Nb8-c6",e:5}],"1#1760914526":[{m:"Bf1-d3",e:5}],"-1#1549910724":[{m:"Qd8-c7",e:8.571}],"1#326647792":[{m:"Nd2-f3",e:6.667}],"-1#1072328473":[{m:"Nf6-e4",e:5}],"1#1948544570":[{m:"Nf3-e5",e:5}],"-1#708722347":[{m:"c5xd4",e:5}],"1#403071654":[{m:"Bd3xe4",e:5}],"-1#-276329616":[{m:"Nc6xe5",e:5}],"1#439976105":[{m:"f4xe5",e:5}],"-1#-239748969":[{m:"d5xe4",e:5}],"1#604401756":[{m:"e3xd4",e:5}],"-1#1923540951":[{m:"f7-f5",e:5}],"1#-1677166498":[{m:"Ng1-f3",e:8.571}],"-1#1686854071":[{m:"e7-e6",e:8.333}],"1#863842402":[{m:"Bf1-d3",e:8.333},{m:"Bf1-e2",e:8.333}],"-1#132751096":[{m:"c7-c5",e:7.5}],"1#1284698522":[{m:"c2-c3",e:5}],"-1#-1561251549":[{m:"Nb8-c6",e:5}],"1#442751615":[{m:"O-O",e:5}],"-1#4078475":[{m:"Bf8-d6",e:5}],"1#-844458596":[{m:"Nf3-e5",e:5}],"-1#-257991836":[{m:"Bf8-e7",e:6.667}],"1#1760410348":[{m:"O-O",e:5}],"-1#1924160280":[{m:"O-O",e:5}],"1#-693660063":[{m:"Nb1-d2",e:5}],"-1#111628604":[{m:"c7-c5",e:5}],"-1#1517561524":[{m:"f7-f6",e:9.967},{m:"c7-c6",e:9.967},{m:"c7-c5",e:9.967},{m:"Ng8-f6",e:9.967},{m:"h7-h6",e:9.967}],"1#2121425762":[{m:"Bg5-h4",e:9.73},{m:"Bg5-f4",e:9.73}],"-1#-1325005217":[{m:"Ng8-h6",e:9.412}],"-1#-693870868":[{m:"Nb8-c6",e:9.5}],"1#1385951986":[{m:"e2-e3",e:9.778},{m:"Nb1-c3",e:9.778}],"-1#-332251395":[{m:"Ng8-f6",e:9.6}],"-1#-483930140":[{m:"c7-c6",e:8.571}],"1#-1918488085":[{m:"Qd1-d2",e:8.75},{m:"e2-e3",e:8.75}],"-1#-41191924":[{m:"Nb8-d7",e:8.333}],"1#779592627":[{m:"f2-f3",e:8.333}],"-1#-1200001763":[{m:"Ng8-f6",e:8.333}],"1#1073199212":[{m:"g2-g4",e:8.889}],"-1#856686052":[{m:"Qd8-b6",e:6.667}],"1#-1450376810":[{m:"Ra1-b1",e:6.667}],"-1#1486254292":[{m:"e7-e6",e:5}],"1#257956097":[{m:"Bf1-d3",e:5}],"1#286214614":[{m:"e2-e4",e:8.75},{m:"e2-e3",e:8.75},{m:"Nb1-c3",e:8.75}],"-1#-1598851904":[{m:"h7-h6",e:6.667}],"1#-570756155":[{m:"Nb1-d2",e:9.961},{m:"e2-e3",e:9.961},{m:"Bg5xf6",e:9.961}],"-1#234501272":[{m:"Nb8-d7",e:9.667}],"1#257319300":[{m:"Bg5-h4",e:9.844}],"-1#-1071512391":[{m:"g7-g6",e:9.836},{m:"c7-c6",e:9.836},{m:"c7-c5",e:9.836}],"-1#1332678726":[{m:"c7-c6",e:9.996},{m:"a7-a6",e:9.996},{m:"Ng8-f6",e:9.996},{m:"g7-g6",e:9.996},{m:"Bc8-f5",e:9.996},{m:"c7-c5",e:9.996},{m:"Bc8-g4",e:9.996},{m:"e7-e6",e:9.996},{m:"d7-d5",e:9.9}],"1#1199621120":[{m:"Bc1-g5",e:9.973},{m:"Bc1-f4",e:9.973},{m:"e2-e3",e:9.973}],"1#1917045109":[{m:"Bc1-g5",e:8.75}],"-1#-1612980626":[{m:"h7-h6",e:5}],"1#-889611938":[{m:"Bg5-h4",e:5}],"1#-924728009":[{m:"c2-c4",e:9.995},{m:"e2-e3",e:9.995}],"1#1457609795":[{m:"g2-g3",e:9.885}],"-1#-42488758":[{m:"Bf8-g7",e:9.884}],"1#-211907464":[{m:"Bf1-g2",e:9.884}],"1#569306697":[{m:"e2-e3",e:9.913},{m:"Ng1-f3",e:9.934}],"1#68452132":[{m:"c2-c4",e:9.954},{m:"d4xc5",e:9.954}],"1#2098826819":[{m:"Nf3-e5",e:9.565},{m:"e2-e3",e:9.565}],"-1#-106136487":[{m:"Bg4-f5",e:9.333}],"1#412711315":[{m:"Bc1-f4",e:9.969},{m:"Bc1-g5",e:9.969},{m:"g2-g3",e:9.969}],"-1#105909433":[{m:"Bc8-f5",e:9.865},{m:"Ng8-f6",e:9.865}],"1#1758589622":[{m:"Bc1-g5",e:9.167}],"-1#-2058754643":[{m:"c7-c6",e:8.571}],"1#-2116101688":[{m:"e2-e4",e:9.969},{m:"Bc1-g5",e:9.969}],"-1#-954706251":[{m:"d5xe4",e:9.75}],"1#-2084971353":[{m:"f2-f3",e:9.783}],"-1#364319241":[{m:"e4xf3",e:9.804}],"1#-519426576":[{m:"Ng1xf3",e:9.688}],"-1#-263446184":[{m:"Bc8-g4",e:9.677}],"-1#1816579795":[{m:"Bc8-f5",e:9.962},{m:"g7-g6",e:9.962},{m:"Nb8-d7",e:9.962},{m:"c7-c5",e:9.962}],"1#277373997":[{m:"e2-e3",e:10},{m:"f2-f4",e:10},{m:"Bc1-f4",e:10},{m:"b2-b3",e:10},{m:"Bc1-g5",e:10},{m:"c2-c3",e:10},{m:"g2-g3",e:10},{m:"c2-c4",e:10},{m:"Nb1-c3",e:10},{m:"Ng1-f3",e:10}],"-1#-1373525982":[{m:"g7-g6",e:9.828}],"1#-1213209561":[{m:"Bf1-d3",e:9.565}],"-1#-2093266243":[{m:"Bf8-g7",e:9.091}],"1#-1928172913":[{m:"f2-f4",e:8.571}],"-1#-246365169":[{m:"d7-d6",e:8.571}],"1#-1220283864":[{m:"Ng1-f3",e:8}],"-1#1338037185":[{m:"O-O",e:9}],"1#-338223432":[{m:"O-O",e:8.333}],"-1#-242548916":[{m:"Nb8-c6",e:8.333}],"1#1226314768":[{m:"Nb1-c3",e:8.333}],"-1#-123459322":[{m:"Bc8-g4",e:5}],"1#-892160253":[{m:"a2-a3",e:5}],"-1#1825229485":[{m:"d7-d5",e:9}],"1#1277184606":[{m:"f2-f4",e:9.697}],"-1#629391887":[{m:"e7-e6",e:9.583}],"1#1920314330":[{m:"e2-e3",e:8.889}],"-1#-857970731":[{m:"b7-b6",e:8.571}],"1#-1738886969":[{m:"Nb1-d2",e:6.667}],"-1#1213888410":[{m:"d7-d5",e:6.667}],"1#1756428137":[{m:"Ng1-f3",e:5}],"-1#-1875650944":[{m:"Bf8-d6",e:6.667}],"1#1571256471":[{m:"Nf3-e5",e:5}],"-1#-653096307":[{m:"O-O",e:5}],"1#2097498100":[{m:"Bf1-d3",e:5}],"-1#1234299246":[{m:"Bc8-a6",e:5}],"1#-1980888531":[{m:"c2-c4",e:5}],"-1#1007711126":[{m:"c7-c5",e:5}],"1#2003508468":[{m:"e2-e3",e:5}],"-1#-909979397":[{m:"c5xd4",e:6.667}],"1#-67465994":[{m:"e3xd4",e:5}],"-1#-1386603651":[{m:"Nb8-c6",e:5}],"1#365490209":[{m:"Bf1-e2",e:5}],"-1#-701850841":[{m:"g7-g6",e:5}],"1#-811280606":[{m:"Ng1-f3",e:5}],"-1#925365963":[{m:"d7-d5",e:5}],"1#399341112":[{m:"O-O",e:5}],"-1#227579852":[{m:"Bf8-g7",e:5}],"1#62502910":[{m:"Bc1-b2",e:5}],"-1#-49253578":[{m:"g7-g6",e:9.99},{m:"d7-d6",e:9.99},{m:"c7-c6",e:9.99},{m:"Nf6-e4",e:9.99},{m:"c7-c5",e:9.99},{m:"e7-e6",e:9.99}],"1#-459391181":[{m:"Nb1-c3",e:9.884}],"1#-1157413615":[{m:"Ng1-f3",e:9.6}],"1#-167794832":[{m:"c2-c3",e:9.474}],"-1#463235017":[{m:"Nf6-e4",e:8.333}],"1#-1226935787":[{m:"Bg5-h4",e:9.971}],"1#-1234494380":[{m:"Nb1-c3",e:9.949}],"1#-1427760413":[{m:"e2-e3",e:9.952}],"-1#-18111340":[{m:"d7-d5",e:9.903},{m:"g7-g6",e:9.903},{m:"Ng8-f6",e:9},{m:"b7-b6",e:9.903},{m:"e7-e6",e:9.903},{m:"c7-c6",e:9.903}],"1#-570350489":[{m:"Bc1-f4",e:9.545}],"1#-412751727":[{m:"Bc1-g5",e:9.677}],"1#-1191669069":[{m:"Ng1-f3",e:8.889},{m:"Bc1-g5",e:8.889}],"-1#1081848666":[{m:"Nb8-d7",e:8.333}],"1#-1819842843":[{m:"Nb1-d2",e:7.5}],"-1#1132962232":[{m:"e7-e5",e:6.667}],"-1#1432389032":[{m:"Nb8-d7",e:8.571}],"1#-2036576233":[{m:"Nb1-d2",e:8.571}],"-1#1453102922":[{m:"h7-h6",e:8.571}],"1#-1435667578":[{m:"Bc1-g5",e:9}],"1#-1457664703":[{m:"Bc1-g5",e:9.792}],"1#-167481134":[{m:"c2-c3",e:9.474}],"-1#-1155623900":[{m:"d7-d6",e:9.935},{m:"g7-g6",e:9.935},{m:"d7-d5",e:9.935},{m:"c7-c5",e:9.935}],"1#-49438205":[{m:"Bf1-g2",e:9.545}],"-1#-1301754026":[{m:"e7-e5",e:9.524},{m:"c7-c6",e:9.524}],"1#-785043582":[{m:"d4xe5",e:8.889}],"-1#-1416244529":[{m:"d6xe5",e:8.889}],"1#-1165550832":[{m:"c2-c4",e:6.667}],"-1#1908432417":[{m:"Nb8-d7",e:5}],"1#-1567565791":[{m:"Bf1-g2",e:9.811}],"-1#-302664332":[{m:"Bf8-g7",e:9.828}],"1#-472083130":[{m:"Nb1-c3",e:9.821}],"1#-1678502697":[{m:"Bf1-g2",e:9.75},{m:"c2-c4",e:9.75}],"-1#1353929190":[{m:"c7-c6",e:8.333}],"1#-261751994":[{m:"Ng1-f3",e:9.811},{m:"c2-c3",e:9.811}],"-1#-607182564":[{m:"e7-e6",e:10},{m:"g7-g6",e:10},{m:"c7-c5",e:10},{m:"e7-e5",e:10},{m:"Nb8-c6",e:10},{m:"d7-d6",e:10},{m:"a7-a6",e:10},{m:"b7-b6",e:10},{m:"c7-c6",e:10}],"1#-1198341688":[{m:"g2-g3",e:9.975}],"1#-421267409":[{m:"Qd1-c2",e:9.756}],"1#-752814758":[{m:"Bc1-f4",e:9.889}],"-1#-1590404805":[{m:"c7-c5",e:9.969},{m:"Ng8-f6",e:9.865}],"1#-363907495":[{m:"d4xc5",e:9.375}],"-1#-727906840":[{m:"Ng8-f6",e:9.333}],"-1#-401914428":[{m:"b7-b6",e:9.999},{m:"c7-c5",e:9.999},{m:"g7-g6",e:9.999},{m:"e7-e6",e:9.999},{m:"b7-b5",e:9.999},{m:"Ng8-f6",e:9.996}],"1#-1131572522":[{m:"e2-e3",e:9.919},{m:"g2-g3",e:9.919}],"1#-1552930138":[{m:"Ng1-f3",e:9.981}],"1#-242939455":[{m:"Bc1-g5",e:9.997}],"1#-1073927151":[{m:"g2-g3",e:9.996}],"1#-1081978305":[{m:"g2-g3",e:9.944}],"1#-1064327513":[{m:"e2-e4",e:9.756},{m:"Ng1-f3",e:9.756}],"-1#940345166":[{m:"Bc8-b7",e:8.571}],"1#-1547586838":[{m:"Bc1-f4",e:8.571}],"-1#-1765141304":[{m:"Ng8-f6",e:5}],"1#289718713":[{m:"e2-e3",e:6.667}],"-1#-1343418954":[{m:"a7-a6",e:6.667}],"1#-1832790907":[{m:"a2-a4",e:6.667}],"-1#1286732436":[{m:"b5-b4",e:5}],"1#-704850380":[{m:"c2-c4",e:5}],"-1#515609349":[{m:"b4xc3",e:5}],"1#-680147045":[{m:"Nb1xc3",e:5}],"-1#-675864656":[{m:"e7-e6",e:5}],"1#-2143193499":[{m:"Bf1-d3",e:5}],"-1#-1261053697":[{m:"c7-c5",e:5}],"1#-5326947":[{m:"e3-e4",e:5}],"-1#2005170264":[{m:"c5xd4",e:5}],"1#1169957973":[{m:"Nf3xd4",e:5}],"-1#-1090937271":[{m:"Nb8-c6",e:5}],"1#107705621":[{m:"Nd4xc6",e:5}],"-1#750391724":[{m:"Bb7xc6",e:5}],"1#-241903723":[{m:"O-O",e:5}],"-1#-339134879":[{m:"Bf8-e7",e:5}],"1#1941690345":[{m:"Qd1-e2",e:5}],"-1#-1258864715":[],"1#-1037765012":[{m:"e2-e4",e:8.75}],"-1#-2065532655":[{m:"a7-a6",e:8.333}],"1#-1177640926":[{m:"f2-f4",e:6.667}],"-1#-980676958":[{m:"c7-c5",e:5}],"1#-1896390208":[{m:"d4-d5",e:5}],"-1#1948684618":[{m:"d7-d6",e:5}],"1#842377069":[{m:"c2-c4",e:5}],"-1#-109911460":[{m:"g7-g5",e:5}],"1#2764028":[{m:"f4xg5",e:5}],"-1#1112354419":[{m:"h6xg5",e:5}],"1#-171867477":[{m:"Bc1xg5",e:5}],"-1#144364150":[{m:"Bf8-g7",e:5}],"1#112456260":[{m:"Nb1-c3",e:5}],"-1#-1223700654":[{m:"Nb8-d7",e:5}],"1#1693653741":[{m:"Ng1-f3",e:5}],"-1#-1670366460":[{m:"Ng8-f6",e:5}],"1#469692021":[{m:"e4-e5",e:5}],"-1#-905596190":[{m:"d6xe5",e:5}],"1#-1627756335":[{m:"Bf1-d3",e:5}],"-1#-1435580853":[{m:"b7-b5",e:5}],"1#-35139152":[{m:"O-O",e:5}],"-1#-407228348":[{m:"b5xc4",e:5}],"1#-2128677271":[{m:"Bd3xc4",e:5}],"-1#-1967509607":[{m:"e5-e4",e:5}],"1#770086395":[{m:"Nf3-d2",e:5}],"-1#733614103":[{m:"Qd8-b6",e:5}],"1#-1321669531":[{m:"Qd1-e2",e:5}],"-1#1987314745":[{m:"Qb6xb2",e:5}],"1#-412768572":[{m:"Ra1-c1",e:5}],"-1#-2064723889":[{m:"Nf6-g4",e:5}],"1#-1153004552":[{m:"Qe2xg4",e:5}],"-1#1420608520":[{m:"Bg7xc3",e:5}],"1#-37413251":[{m:"Qg4xe4",e:5}],"-1#-504282850":[{m:"Nd7-f6",e:5}],"1#-363996340":[{m:"Bg5xf6",e:5}],"-1#-1709566972":[{m:"Bc3xf6",e:5}],"1#-1880420281":[{m:"Nd2-f3",e:5}],"-1#-1984457301":[],"1#23867508":[{m:"Bc1-f4",e:9.997},{m:"g2-g4",e:9.997},{m:"Qd1-d3",e:9.997},{m:"e2-e4",e:9.997},{m:"e2-e3",e:9.997},{m:"Nb1-c3",e:9.997},{m:"Bc1-g5",e:9.997},{m:"h2-h4",e:9.997},{m:"h2-h3",e:9.997},{m:"c2-c3",e:9.997},{m:"g2-g3",e:9.997},{m:"d2-d4",e:9.968},{m:"c2-c4",e:9.997}],"-1#879203926":[{m:"Ng8-f6",e:9.167}],"1#-1276558553":[{m:"e2-e3",e:9.091}],"-1#222334760":[{m:"g7-g6",e:9.091},{m:"b7-b6",e:9.091},{m:"d7-d6",e:9.091},{m:"e7-e6",e:9.091}],"1#349094701":[{m:"h2-h4",e:7.5}],"1#1506170938":[{m:"Bf1-d3",e:6.667}],"1#1263778063":[{m:"Nb1-c3",e:6.667}],"1#1521936125":[{m:"Bf1-d3",e:8}],"-1#-778052706":[{m:"f5xg4",e:9.091}],"1#473763711":[{m:"h2-h3",e:9.091},{m:"Bc1-f4",e:9.091},{m:"e2-e4",e:9.091}],"-1#79497633":[{m:"d7-d5",e:8}],"1#609716562":[{m:"h3xg4",e:6.667}],"-1#691448157":[{m:"Ng8-f6",e:6.667}],"1#-1363641300":[{m:"h2-h3",e:6.667}],"-1#1526431746":[{m:"e7-e5",e:8},{m:"d7-d6",e:8}],"-1#-101123127":[{m:"d7-d6",e:9},{m:"e7-e6",e:9},{m:"d7-d5",e:9}],"1#-1075065362":[{m:"e2-e4",e:6.667}],"-1#-114474349":[{m:"f5xe4",e:5}],"1#-1374776804":[{m:"Nb1-d2",e:6.667}],"-1#2114868545":[{m:"d7-d5",e:5}],"1#-653100230":[{m:"Ng1-f3",e:8.333}],"-1#563174099":[{m:"Ng8-f6",e:5}],"-1#1202372361":[{m:"f5xe4",e:9.851}],"1#142890989":[{m:"Nb1-c3",e:9.848}],"-1#-1187484933":[{m:"Ng8-f6",e:9.848}],"1#1052163978":[{m:"f2-f3",e:9.857},{m:"g2-g4",e:9.857},{m:"Bc1-g5",e:9.857}],"-1#-1464307420":[{m:"d7-d5",e:9.231}],"-1#-297446304":[{m:"h7-h6",e:8.889}],"-1#-751916911":[{m:"Nb8-c6",e:9.8}],"-1#-1077543813":[{m:"Ng8-f6",e:8}],"1#944449802":[{m:"Bf1-d3",e:8}],"-1#215975824":[{m:"e7-e6",e:6.667}],"1#1529474629":[{m:"c2-c4",e:6.667}],"-1#-1871795340":[{m:"b7-b6",e:7.5},{m:"d7-d5",e:7.5}],"1#-991396762":[{m:"Ng1-e2",e:6.667}],"-1#1529254297":[{m:"Bc8-b7",e:6.667}],"1#-1333515385":[{m:"Nb1-c3",e:5}],"-1#20453009":[{m:"c7-c6",e:9.333}],"-1#-1328542366":[{m:"g7-g6",e:9.936},{m:"Ng8-f6",e:9.936},{m:"e7-e6",e:9.936},{m:"d7-d5",e:9.936}],"1#-1453440665":[{m:"e2-e4",e:7.5}],"1#928962579":[{m:"Bc1-g5",e:9.865}],"-1#-624505080":[{m:"Nf6-e4",e:9.853}],"1#-416914249":[{m:"e2-e4",e:7.5}],"-1#-1579095094":[{m:"f5xe4",e:5}],"1#-1875210863":[{m:"e2-e4",e:9.875}],"-1#-319543441":[{m:"g7-g6",e:9.946},{m:"d7-d6",e:9.946},{m:"c7-c5",e:9.946},{m:"c7-c6",e:9.946},{m:"Ng8-f6",e:9.946},{m:"h7-h6",e:9.946}],"1#-467930327":[{m:"c2-c3",e:9.688}],"1#1803219486":[{m:"Bg5xf6",e:9.474}],"1#-1177132961":[{m:"Bg5-h4",e:9.767}],"-1#-1158989576":[{m:"e7-e6",e:5}],"1#-316845779":[{m:"Bc1-g5",e:5}],"-1#8734262":[{m:"Bf8-e7",e:5}],"1#-1728600130":[{m:"Ng1-f3",e:5}],"-1#1618249303":[{m:"Ng8-f6",e:5}],"1#-403025114":[{m:"Nb1-d2",e:5}],"-1#939168891":[{m:"Nf6-e4",e:5}],"1#2083820888":[{m:"Bg5xe7",e:5}],"-1#1407497170":[{m:"Qd8xe7",e:5}],"1#-5693310":[{m:"e2-e3",e:5}],"-1#434910890":[{m:"Ng8-f6",e:9.167},{m:"d7-d6",e:9.167}],"1#-1637686309":[{m:"g2-g4",e:8}],"-1#1318127665":[{m:"f5xg4",e:8}],"1#-2093753136":[{m:"h3xg4",e:7.5}],"-1#1674946699":[{m:"Nf6xg4",e:7.5}],"1#1610547341":[{m:"Bc1-f4",e:8.75}],"-1#1794418351":[{m:"g7-g6",e:5}],"1#1937435306":[{m:"e2-e3",e:5}],"-1#-841800027":[{m:"Bf8-g7",e:5}],"-1#-284167987":[{m:"Ng8-f6",e:6.667}],"1#1753294268":[{m:"Bc1-g5",e:6.667}],"-1#-2061946201":[{m:"e7-e6",e:6.667}],"1#-756065422":[{m:"Nb1-d2",e:6.667},{m:"e2-e3",e:6.667}],"-1#49257519":[{m:"d7-d5",e:5}],"1#570760412":[{m:"e2-e4",e:5}],"-1#1816565629":[{m:"b7-b6",e:5}],"1#952123503":[{m:"Nb1-d2",e:5}],"-1#-390035662":[{m:"Bc8-b7",e:5}],"-1#-1426407299":[{m:"Ng8-f6",e:9.981}],"1#762582284":[{m:"Bf1-g2",e:9.978}],"-1#1645312089":[{m:"d7-d6",e:9.978},{m:"e7-e6",e:9.978},{m:"g7-g6",e:9.978}],"1#604130942":[{m:"Ng1-f3",e:9.75}],"1#904335756":[{m:"Nb1-d2",e:9.899},{m:"c2-c3",e:9.899}],"1#2074031196":[{m:"b2-b3",e:9.97},{m:"Ng1-h3",e:9.97}],"-1#-101772899":[{m:"Ng8-f6",e:9.968},{m:"e7-e6",e:9.968},{m:"f7-f5",e:9.99},{m:"g7-g6",e:9.968}],"1#2120336620":[{m:"Bc1-g5",e:9.953},{m:"h2-h3",e:9.953},{m:"Nb1-c3",e:9.953},{m:"g2-g3",e:9.953},{m:"Bc1-f4",e:9.953},{m:"b2-b3",e:9.953}],"-1#-705219355":[{m:"b7-b6",e:9.905}],"-1#1265263310":[{m:"g7-g6",e:9.286}],"1#-1374062520":[{m:"Bc1-f4",e:9.932},{m:"d4-d5",e:9.932},{m:"h2-h3",e:9.932},{m:"e2-e4",e:9.932},{m:"c2-c4",e:9.932},{m:"Bc1-g5",e:9.932},{m:"g2-g3",e:9.932}],"-1#-387975371":[{m:"f5xe4",e:6.667}],"-1#1132556115":[{m:"Bf8-e7",e:9.333}],"1#-1073993798":[{m:"Nb1-c3",e:9.697}],"-1#239082156":[{m:"d6-d5",e:9.167},{m:"Ng8-f6",e:9.167}],"1#419176655":[{m:"Bc1-f4",e:5}],"-1#771196653":[{m:"Ng8-f6",e:5}],"1#-1434889316":[{m:"e2-e3",e:5}],"-1#349216659":[{m:"e7-e6",e:5}],"1#1126626886":[{m:"Bf1-e2",e:5}],"-1#-2134598336":[{m:"Bf8-d6",e:5}],"1#1297101655":[{m:"O-O",e:5}],"-1#1460523683":[{m:"O-O",e:5}],"1#-216391718":[{m:"Nc3-b5",e:5}],"1#-1982935075":[{m:"Bc1-g5",e:9.091}],"-1#1683413190":[{m:"c7-c6",e:9.091},{m:"Nb8-d7",e:9.091}],"1#1824066688":[{m:"Bg5xf6",e:5}],"-1#-1406033395":[{m:"e7xf6",e:5}],"1#1315480341":[{m:"e2-e3",e:5}],"1#-1213592199":[{m:"e2-e3",e:8.333},{m:"Qd1-d3",e:8.333}],"-1#151241078":[{m:"g7-g6",e:6.667}],"1#-530489960":[{m:"Nb1-c3",e:9.73},{m:"h2-h4",e:9.73}],"-1#1373462670":[{m:"Bf8-g7",e:6.667}],"1#1609842876":[{m:"e2-e4",e:5}],"-1#422760385":[{m:"f5xe4",e:5}],"-1#1541821716":[{m:"Ng8-f6",e:8.889}],"1#-597131163":[{m:"h4-h5",e:8.571}],"-1#-555273252":[{m:"Nf6xh5",e:8.571}],"-1#-903121595":[{m:"c7-c6",e:9.996},{m:"Ng8-f6",e:9.996},{m:"g7-g6",e:9.996},{m:"e7-e6",e:9.996}],"1#-1027301117":[{m:"Nb1-c3",e:8.333}],"1#1302700084":[{m:"Ng1-f3",e:9.995},{m:"g2-g3",e:9.995}],"1#-744146624":[{m:"g2-g3",e:9.697}],"1#-1646453616":[{m:"Nb1-c3",e:9.966},{m:"c2-c4",e:9.932}],"1#-787118213":[{m:"d2-d4",e:9.998},{m:"e2-e3",e:9.995},{m:"Nb1-c3",e:9.995},{m:"d2-d4",e:9.958},{m:"Bc1-f4",e:9.995},{m:"g2-g3",e:9.995},{m:"Bc1-g5",e:9.995},{m:"c2-c4",e:9.995},{m:"c2-c3",e:9.995}],"-1#1874611060":[{m:"g7-g6",e:8.333}],"1#1982990193":[{m:"c2-c4",e:7.5}],"-1#-1116388800":[{m:"Bf8-g7",e:7.5}],"1#-1285791118":[{m:"Nb1-c3",e:7.5}],"-1#48258916":[{m:"Nb8-d7",e:8}],"1#-786658597":[{m:"g2-g3",e:7.5}],"-1#2055895762":[{m:"e7-e5",e:7.5}],"1#433560070":[{m:"Bf1-g2",e:8}],"-1#1454569299":[{m:"Ng8-h6",e:9.167},{m:"Ng8-e7",e:9.167}],"1#-567944948":[{m:"Ng1-e2",e:8.333}],"-1#1105933555":[{m:"O-O",e:8.333}],"1#-436405878":[{m:"O-O",e:8.333}],"-1#-6219650":[{m:"f7-f5",e:8.333}],"1#-1082564389":[{m:"Ng1-e2",e:8.571}],"-1#548900132":[{m:"h7-h5",e:8.571},{m:"O-O",e:8.571}],"-1#1621736045":[{m:"g7-g6",e:8.75}],"1#2032662120":[{m:"h2-h4",e:8}],"-1#-1029636380":[{m:"Bf8-g7",e:6.667}],"1#-863379754":[{m:"h4-h5",e:6.667}],"-1#-838439569":[{m:"Nb8-c6",e:6.667}],"1#1989445171":[{m:"Ng1-f3",e:6.667}],"-1#-1911052326":[{m:"e7-e5",e:6.667}],"1#-313899250":[{m:"h5-h6",e:6.667}],"-1#-1405715680":[{m:"Bg7-f6",e:6.667}],"1#1022142477":[{m:"d4-d5",e:6.667}],"-1#-969058169":[{m:"Nc6-b8",e:6.667}],"1#2125444059":[{m:"e2-e4",e:6.667}],"-1#946420902":[{m:"Bf6-e7",e:6.667}],"1#1055403569":[{m:"Bf1-b5+",e:6.667}],"-1#-858632573":[{m:"Nb8-d7",e:6.667}],"1#523148092":[{m:"g2-g4",e:6.667},{m:"Bc1-e3",e:6.667}],"-1#697738898":[{m:"Bc8-g4",e:9.99},{m:"g7-g6",e:9.99},{m:"f7-f5",e:9.99}],"1#467679383":[{m:"c2-c4",e:9.979},{m:"e2-e4",e:9.979}],"-1#-794329690":[{m:"e7-e5",e:9.963},{m:"Bg4xf3",e:9.963},{m:"c7-c6",e:9.963},{m:"Nb8-d7",e:9.963},{m:"Nb8-c6",e:9.963},{m:"Ng8-f6",e:9.963}],"1#-1275421326":[{m:"Nb1-c3",e:8}],"1#-666326560":[{m:"d4-d5",e:9.524}],"1#56338457":[{m:"g2-g3",e:9.94}],"1#1748342522":[{m:"Nb1-c3",e:7.5}],"-1#1562818538":[{m:"e7-e6",e:9.936},{m:"Ng8-f6",e:9.936}],"1#181460543":[{m:"h2-h3",e:6.667}],"-1#307288289":[{m:"Bg4-h5",e:6.667}],"1#960886474":[{m:"c2-c4",e:6.667}],"-1#-234703877":[{m:"Nb8-d7",e:6.667},{m:"Ng8-f6",e:6.667}],"1#-626498917":[{m:"Bf1-d3",e:9.929},{m:"Nb1-d2",e:9.929},{m:"Nb1-c3",e:9.929},{m:"h2-h3",e:9.929}],"1#806939287":[{m:"c2-c3",e:9.969},{m:"Bc1-g5",e:9.969},{m:"Bc1-f4",e:9.969},{m:"g2-g3",e:9.969},{m:"c2-c4",e:9.969}],"-1#-562353618":[{m:"Bf8-g7",e:7.5}],"1#-799929828":[{m:"Bc1-g5",e:9.091}],"-1#1036655879":[{m:"Ng8-f6",e:9.231}],"-1#-578749044":[{m:"h7-h6",e:8.75},{m:"Bf8-g7",e:8.75}],"1#-743842370":[{m:"Bc1-g5",e:9.091}],"-1#85150901":[{m:"Bf8-g7",e:8.571}],"1#188378247":[{m:"c2-c3",e:9},{m:"e2-e3",e:9}],"-1#-447108034":[{m:"Nb8-d7",e:6.667}],"-1#-1685185890":[{m:"Bc8-f5",e:9.804},{m:"c7-c5",e:9.804},{m:"Bf8-g7",e:9.804}],"1#-789219844":[{m:"d4-d5",e:5}],"-1#-77615194":[{m:"Bc8-g4",e:9.959},{m:"Bf8-g7",e:9.959},{m:"f7-f5",e:9.959}],"-1#-467787431":[{m:"Ng8-f6",e:6.667}],"1#1670444072":[{m:"e2-e3",e:8.333}],"-1#-583452633":[{m:"c7-c5",e:5}],"1#-1774037179":[{m:"c2-c3",e:5}],"-1#2015467516":[{m:"Qd8-b6",e:5}],"1#-492606578":[{m:"Qd1-b3",e:5}],"-1#-1776347072":[{m:"Qb6xb3",e:5}],"1#-660118671":[{m:"a2xb3",e:5}],"-1#-585419076":[{m:"Nf6-h5",e:5}],"1#-1268006481":[{m:"Bf4-g5",e:5}],"-1#482212897":[{m:"h7-h6",e:5}],"1#1235204881":[{m:"Bg5-h4",e:5}],"-1#-2031362516":[{m:"g7-g5",e:5}],"1#2142441612":[{m:"Bf1-e2",e:5}],"-1#-1135510646":[{m:"Nh5-g7",e:5}],"1#-854875531":[{m:"Bh4-g3",e:5}],"-1#-1334964745":[{m:"c5xd4",e:5}],"-1#2055436146":[{m:"e7-e5",e:9.831},{m:"d7-d6",e:9.935}],"1#434018214":[{m:"d4xe5",e:9.167},{m:"Bf1-g2",e:9.167}],"-1#1669229291":[{m:"d6xe5",e:8.75}],"1#-1106306513":[{m:"Qd1xd8+",e:8.75}],"-1#-2105951810":[{m:"Ke8xd8",e:8.75}],"-1#1455160051":[{m:"e5xd4",e:7.5}],"1#-37271276":[{m:"Qd1xd4",e:7.5}],"-1#-2041364671":[{m:"Ng8-f6",e:6.667}],"-1#1015910496":[{m:"g7-g6",e:9.643},{m:"Nb8-d7",e:9.643},{m:"f7-f6",e:9.643},{m:"h7-h6",e:9.643}],"1#621010021":[{m:"e2-e4",e:8.333},{m:"c2-c4",e:8.333}],"-1#-297494188":[{m:"Bf8-g7",e:5}],"1#-277789217":[{m:"c2-c4",e:8.333},{m:"e2-e4",e:8.333}],"-1#-1447572830":[{m:"Ng8-f6",e:5}],"1#411817398":[{m:"Bg5-h4",e:6.667}],"-1#-671108981":[{m:"e7-e5",e:6.667}],"1#-1264431009":[{m:"e2-e4",e:6.667}],"1#1773131600":[{m:"Bg5-h4",e:9.091}],"-1#-1495551379":[{m:"g7-g5",e:9.091},{m:"g7-g6",e:9.091},{m:"c7-c5",e:9.091}],"-1#441631306":[{m:"g7-g6",e:9.987},{m:"e7-e5",e:9.987}],"1#64785999":[{m:"Nb1-c3",e:9.981}],"-1#-1302285479":[{m:"e7-e5",e:9.981},{m:"Bf8-g7",e:9.981}],"1#-784510067":[{m:"d4xe5",e:9},{m:"Nb1-c3",e:9.444}],"1#-1136028821":[{m:"e2-e4",e:9.984},{m:"Bc1-g5",e:9.984},{m:"g2-g3",e:9.984}],"1#2031035038":[{m:"Ng1-f3",e:9.951},{m:"g2-g3",e:9.951},{m:"e2-e3",e:9.951},{m:"d4xe5",e:9.951},{m:"d4-d5",e:9.951},{m:"Nb1-c3",e:9.951}],"-1#-761671017":[{m:"e5xd4",e:6.667}],"-1#-945361263":[{m:"g7-g6",e:9.333}],"-1#1064716226":[{m:"Ng8-f6",e:9},{m:"g7-g6",e:9}],"1#653790151":[{m:"Bc1-g5",e:7.5},{m:"c2-c3",e:9.981}],"-1#-882893604":[{m:"f7-f5",e:8}],"1#1560976884":[{m:"e2-e3",e:5}],
"-1#-475835909":[{m:"Ng8-h6",e:5}],"1#1798602660":[{m:"Bf1-c4",e:5}],"-1#-748858400":[{m:"c7-c6",e:5}],"1#-609056858":[{m:"Nb1-d2",e:5}],"-1#1203702919":[{m:"c7-c5",e:9.981},{m:"d7-d6",e:9.981},{m:"d7-d5",e:9.981},{m:"b7-b5",e:9.981},{m:"f7-f5",e:9.981},{m:"Ng8-f6",e:9.981},{m:"e7-e5",e:9.981},{m:"b7-b6",e:9.981}],"1#214197221":[{m:"Bc1-b2",e:9.545}],"-1#411959796":[{m:"Nb8-c6",e:9.474}],"1#-1608717656":[{m:"e2-e3",e:9.412}],"-1#515188391":[{m:"d7-d5",e:9.167},{m:"Ng8-f6",e:9.167},{m:"d7-d6",e:9.167}],"1#1046455892":[{m:"d2-d4",e:9.412},{m:"Bf1-b5",e:9.412}],"-1#-1031926732":[{m:"c5xd4",e:5}],"1#-263827399":[{m:"e3xd4",e:5}],"-1#-1494825038":[{m:"Ng8-f6",e:5}],"1#560468675":[{m:"Ng1-f3",e:5}],"-1#-638897366":[{m:"Bc8-g4",e:6.667}],"1#-341988049":[{m:"Bf1-e2",e:5}],"-1#679462441":[{m:"e7-e6",e:5}],"1#2139729916":[{m:"O-O",e:5}],"-1#1708412424":[{m:"Bf8-d6",e:5}],"1#-1472143329":[{m:"Nf3-e5",e:5}],"-1#754258437":[{m:"Bg4xe2",e:5}],"1#856212232":[{m:"Qd1xe2",e:5}],"-1#-31090607":[{m:"Ra8-c8",e:5}],"1#372579837":[{m:"c2-c4",e:5}],"-1#-579708724":[{m:"O-O",e:5}],"1#2036700597":[{m:"Nb1-d2",e:5}],"-1#-1452977432":[{m:"Qd8-a5",e:5}],"1#1029840383":[{m:"a2-a3",e:5}],"-1#718523942":[{m:"Qa5-a6",e:5}],"1#402419395":[{m:"Rf1-e1",e:5}],"-1#415817643":[{m:"d5xc4",e:5}],"1#1801275042":[{m:"b3xc4",e:5}],"-1#1005533863":[{m:"Nc6-a5",e:5}],"1#606051971":[{m:"f2-f4",e:5}],"-1#1482502147":[{m:"Bd6xe5",e:5}],"1#637821335":[{m:"f4xe5",e:5}],"-1#1636528723":[{m:"Nf6-d7",e:5}],"1#-552546045":[{m:"Ra1-c1",e:5}],"-1#-1130649720":[{m:"Nd7-b6",e:5}],"1#-2007045548":[{m:"c4-c5",e:5}],"-1#-865745178":[{m:"Bc8-d7",e:8.571}],"1#480088805":[{m:"Ng1-f3",e:6.667}],"-1#-467750132":[{m:"f7-f6",e:6.667}],"1#-1072105766":[{m:"O-O",e:5}],"-1#-633006290":[{m:"a7-a6",e:5}],"1#-412496355":[{m:"Bb5xc6",e:5}],"-1#315157868":[{m:"Bd7xc6",e:5}],"1#2046602935":[{m:"d2-d4",e:5}],"-1#-2049112873":[{m:"e7-e6",e:5}],"1#-768905982":[{m:"Nb1-d2",e:5}],"-1#36416095":[{m:"Ng8-h6",e:5}],"1#-1967356928":[{m:"Rf1-e1",e:5}],"-1#-2054671000":[{m:"Nh6-f7",e:5}],"1#-1876777849":[{m:"e3-e4",e:5}],"-1#403204930":[{m:"c5xd4",e:5}],"1#707802959":[{m:"Nf3xd4",e:5}],"-1#-780825261":[{m:"e6-e5",e:5}],"1#-1784968987":[{m:"c2-c4",e:5}],"-1#1591528916":[{m:"d5xe4",e:5}],"1#444417990":[{m:"Nd4xc6",e:5}],"-1#414608600":[{m:"b7xc6",e:5}],"1#521827296":[{m:"Nd2xe4",e:5}],"-1#1090626372":[{m:"Bf8-b4",e:5}],"1#755432955":[{m:"Bb2-c3",e:5}],"-1#1303423492":[{m:"Bb4xc3",e:5}],"1#-1698242801":[{m:"Ne4xc3",e:5}],"-1#-4474319":[{m:"Qd8xd1",e:5}],"1#112788241":[{m:"Ra1xd1",e:5}],"-1#738587308":[{m:"Ke8-e7",e:5}],"1#674823435":[{m:"Nc3-a4",e:5}],"-1#363394247":[{m:"Rh8-d8",e:5}],"1#-1724124202":[{m:"Ng1-f3",e:7.5}],"-1#1639502399":[],"1#1487278208":[{m:"Ng1-f3",e:6.667},{m:"g2-g3",e:6.667}],"-1#-1608175255":[{m:"e7-e5",e:7.5}],"1#-1015492163":[{m:"d2-d4",e:7.5},{m:"c2-c4",e:7.5}],"-1#1062829021":[{m:"c5xd4",e:5}],"1#224470992":[{m:"e3xd4",e:5}],"-1#1539420251":[{m:"e5-e4",e:5}],"1#-970951244":[{m:"Nf3-d2",e:5}],"-1#-1065553832":[{m:"d6-d5",e:5}],"1#-692008389":[{m:"Bf1-e2",e:5}],"-1#354591037":[{m:"f7-f5",e:5}],"1#-2092425195":[{m:"c2-c4",e:5}],"-1#1208968484":[{m:"Ng8-f6",e:5}],"1#-813584299":[{m:"Nb1-c3",e:5}],"-1#2117963075":[{m:"Bc8-e6",e:5}],"1#88575684":[{m:"O-O",e:5}],"-1#521826096":[{m:"Nc6xd4",e:5}],"1#2130832865":[{m:"Nc3xd5",e:5}],"-1#138384524":[{m:"g7-g6",e:5}],"1#296867977":[{m:"d2-d4",e:5}],"-1#-309300503":[{m:"e5xd4",e:5}],"1#1189921038":[{m:"e3xd4",e:5}],"-1#-731591237":[{m:"Bf8-g7",e:5}],"1#-632427127":[{m:"Bb2-c3",e:5}],"-1#-1157907850":[{m:"Ng8-f6",e:5}],"1#1031106311":[{m:"d4-d5",e:5}],"-1#-380387206":[{m:"Nc6-e7",e:5}],"1#2032059807":[{m:"Bf1-d3",e:5}],"-1#1300916997":[{m:"O-O",e:5}],"1#-375544196":[{m:"O-O",e:5}],"-1#-205502584":[{m:"b7-b5",e:5}],"1#-1538699149":[{m:"Qd1-c2",e:5}],"-1#-214900599":[{m:"e7-e5",e:5}],"1#-1871904675":[{m:"Bf1-g2",e:5}],"-1#-553095928":[{m:"f7-f5",e:5}],"1#1231219744":[{m:"Ng1-e2",e:5}],"-1#-693370401":[{m:"Ng8-f6",e:5}],"1#1361237166":[{m:"O-O",e:5}],"-1#1266627930":[{m:"Bf8-e7",e:5}],"1#-754068270":[{m:"d2-d4",e:5}],"-1#791445170":[{m:"c5xd4",e:5}],"1#487858879":[{m:"e3xd4",e:5}],"-1#1270134068":[{m:"e5-e4",e:5}],"1#-699043621":[{m:"d4-d5",e:5}],"-1#41148326":[{m:"Nc6-e5",e:5}],"1#-2122720070":[{m:"f2-f3",e:5}],"-1#393679380":[{m:"e4xf3",e:5}],"1#1361140372":[{m:"Bg2xf3",e:5}],"-1#2011476169":[{m:"Ne5xf3+",e:5}],"1#757260589":[{m:"Rf1xf3",e:5}],"-1#1692762572":[{m:"O-O",e:5}],"1#-1057862475":[{m:"Ne2-f4",e:5}],"-1#1170977772":[{m:"Nf6-e4",e:5}],"1#235254479":[{m:"Nf4-h5",e:5}],"-1#1019084434":[{m:"Rf8-f7",e:5}],"1#429435693":[{m:"Nb1-c3",e:5}],"-1#-1473997253":[{m:"Ne4-g5",e:5}],"1#-1049736829":[{m:"Rf3-f1",e:5}],"-1#-1625065429":[{m:"g7-g6",e:5}],"1#-2035469266":[{m:"Nh5-f4",e:5}],"-1#-1273661325":[{m:"Be7-f6",e:5}],"1#-1298896156":[{m:"Ra1-b1",e:5}],"-1#1133452198":[{m:"Bc8-d7",e:5}],"1#28064416":[{m:"Bc1-b2",e:8.333}],"-1#367417521":[{m:"Nb8-d7",e:8.333}],"1#-971338482":[{m:"g2-g3",e:7.5}],"-1#1837923591":[{m:"Ng8-f6",e:5}],"1#-368924554":[{m:"Bf1-g2",e:5}],"-1#-1519925981":[{m:"c7-c6",e:5}],"1#-1383591579":[{m:"e2-e4",e:5}],"-1#-347169256":[{m:"e7-e5",e:5}],"1#-2011988276":[{m:"Ng1-e2",e:5}],"-1#400397107":[{m:"Bf8-e7",e:5}],"1#-1884327237":[{m:"O-O",e:5}],"-1#-1779264689":[{m:"O-O",e:5}],"1#837115446":[{m:"d2-d4",e:5}],"-1#-842730410":[{m:"Rf8-e8",e:5}],"1#-1957002602":[{m:"Rf1-e1",e:5}],"-1#-2073152514":[{m:"Qd8-c7",e:5}],"1#-881340726":[{m:"Nb1-c3",e:5}],"-1#2060186588":[{m:"b7-b5",e:5}],"1#759358503":[{m:"Qd1-d2",e:5}],"-1#1567597504":[{m:"Bc8-b7",e:5}],"1#-962423196":[{m:"Nc3-d1",e:5}],"-1#397874437":[{m:"Ra8-d8",e:5}],"1#125299557":[{m:"Nd1-e3",e:5}],"-1#46313361":[{m:"Be7-f8",e:5}],"1#-1699721703":[{m:"Ne3-f5",e:5}],"-1#-1752036602":[],"1#1733659764":[{m:"Bc1-b2",e:9.915}],"-1#1931472485":[{m:"c7-c6",e:9.901},{m:"c7-c5",e:9.901},{m:"Bc8-g4",e:9.901},{m:"Ng8-f6",e:9.901},{m:"e7-e6",e:9.901},{m:"Bc8-f5",e:9.901}],"1#2079341091":[{m:"g2-g3",e:8.75},{m:"e2-e3",e:8.75}],"-1#-798569942":[{m:"Ng8-f6",e:7.5},{m:"Bc8-g4",e:7.5}],"1#1474830171":[{m:"Bf1-g2",e:5}],"-1#411922958":[{m:"Bc8-f5",e:5}],"1#1980533761":[{m:"d2-d3",e:5}],"-1#1506730640":[{m:"e7-e6",e:5}],"1#238586693":[{m:"Nb1-d2",e:5}],"-1#-566735848":[{m:"Bf8-c5",e:5}],"1#1056493067":[{m:"h2-h3",e:5}],"-1#645449941":[{m:"h7-h6",e:5}],"1#-502246353":[{m:"Ng1-f3",e:8.889},{m:"Bc1-b2",e:5}],"-1#445871558":[{m:"Bg4xf3",e:7.5}],"1#1260509075":[{m:"e2xf3",e:7.5}],"-1#-362338249":[{m:"Nb8-d7",e:7.5},{m:"e7-e6",e:7.5}],"1#966524296":[{m:"f3-f4",e:6.667}],"1#-1114553886":[{m:"Bf1-g2",e:5}],"-1#-983960020":[{m:"Bc8-f5",e:6.667}],"1#-1411905501":[{m:"Ng1-f3",e:6.667}],"-1#1398483402":[{m:"e7-e6",e:6.667}],"1#78463007":[{m:"c2-c4",e:6.667}],"-1#-806746834":[{m:"Nb8-d7",e:8.333}],"1#471257233":[{m:"Bf1-e2",e:5}],"-1#-537609321":[{m:"h7-h6",e:5}],"1#-1965622105":[{m:"O-O",e:5}],"-1#-1869931181":[{m:"Ng8-f6",e:6.667}],"1#386254882":[{m:"d2-d3",e:8.571},{m:"Nb1-c3",e:8.571}],"-1#952608435":[{m:"Bf8-e7",e:8}],"-1#-1497762508":[{m:"Bf8-d6",e:6.667}],"1#1798134563":[{m:"c4xd5",e:5}],"1#946110727":[{m:"e2-e3",e:9.63},{m:"Ng1-f3",e:9.63}],"-1#-2033365752":[{m:"a7-a6",e:9.565},{m:"d7-d5",e:9.167}],"1#-1142844357":[{m:"f2-f4",e:8.333},{m:"Ng1-f3",e:8.333}],"-1#-945603909":[],"-1#1130542546":[{m:"Nb8-c6",e:8.889}],"1#-68133234":[{m:"g2-g3",e:9.5},{m:"Bf1-e2",e:9.5},{m:"d2-d4",e:9.5},{m:"c2-c4",e:9.5}],"-1#-1058561810":[{m:"f7-f6",e:9.286}],"1#-454957768":[{m:"e2-e4",e:8.75},{m:"e2-e3",e:8.75}],"-1#-1574475195":[{m:"d5xe4",e:6.667}],"1#-427368361":[{m:"Nf3-h4",e:6.667}],"-1#1372274242":[{m:"Ng8-h6",e:6.667}],"1#-648277987":[{m:"Qd1-h5+",e:6.667}],"-1#2043092866":[{m:"g7-g6",e:5}],"1#1615418247":[{m:"Qh5xc5",e:5}],"-1#1514678583":[{m:"e7-e5",e:8}],"1#957729251":[{m:"d2-d4",e:8}],"-1#-986422397":[{m:"c5xd4",e:8}],"1#-150192242":[{m:"e3xd4",e:8}],"-1#-1582520315":[{m:"e5-e4",e:8}],"1#1097429088":[{m:"Qd1-c1",e:9.73},{m:"Ng1-f3",e:9.73},{m:"d2-d3",e:9.73},{m:"h2-h3",e:9.73},{m:"g2-g3",e:9.73},{m:"f2-f3",e:9.73}],"-1#-1389283526":[{m:"Nb8-d7",e:5}],"1#2127422085":[{m:"e2-e3",e:5}],"-1#-1067176310":[{m:"e7-e5",e:5}],"1#-1556492706":[{m:"Ng1-e2",e:5}],"-1#1022829473":[{m:"Ng8-f6",e:5}],"-1#-1175826039":[{m:"Ng8-f6",e:9.844},{m:"Nb8-d7",e:9.844},{m:"Bg4xf3",e:9.844}],"1#1046775032":[{m:"e2-e3",e:9.615}],"-1#1856708337":[{m:"Nb8-c6",e:5}],"1#-700844627":[{m:"h2-h3",e:5}],"-1#-826674317":[{m:"Bg4-h5",e:5}],"1#-441655976":[{m:"g2-g4",e:6.667}],"-1#895432370":[{m:"Bh5-g6",e:5}],"-1#1508472510":[{m:"Bg4-h5",e:9.333}],"1#1929140373":[{m:"Ng1-f3",e:9.333},{m:"d2-d3",e:9.333}],"-1#1564358148":[{m:"Bg4-h5",e:5}],"-1#-352354199":[{m:"Bc8-g4",e:7.5}],"-1#-681066802":[{m:"Bg4-h5",e:8}],"1#-59600667":[{m:"Ng1-h3",e:6.667}],"-1#21711429":[{m:"e7-e6",e:6.667}],"1#1455235984":[{m:"Nh3-f4",e:5}],"1#-191808748":[{m:"e2-e3",e:9.677}],"-1#1245247259":[{m:"g7-g6",e:9.688},{m:"c7-c6",e:9.688}],"1#1404484382":[{m:"Ng1-f3",e:9.231},{m:"f2-f4",e:9.231}],"-1#-1422550281":[],"-1#804525470":[],"1#1121395549":[{m:"f2-f4",e:6.667}],"-1#1049988573":[{m:"Bc8-g4",e:5}],"1#216208344":[{m:"Bf1-e2",e:5}],"-1#-821987106":[{m:"Bg4xe2",e:5}],"1#-788747821":[{m:"Qd1xe2",e:5}],"-1#500298378":[{m:"e7-e6",e:5}],"1#1244109663":[{m:"Ng1-f3",e:5}],"-1#-1297827146":[{m:"Bf8-e7",e:5}],"1#718691134":[{m:"d2-d3",e:5}],"-1#85210543":[{m:"c6-c5",e:5}],"1#918880828":[{m:"Nb1-d2",e:5}],"-1#-423246495":[{m:"Nb8-c6",e:5}],"1#1582771773":[{m:"Nf3-e5",e:5}],"-1#-622666713":[{m:"Nc6xe5",e:5}],"1#619284400":[{m:"Ng1-f3",e:8.333}],"-1#-596990375":[{m:"d7-d5",e:8.75}],"1#1541698344":[{m:"e2-e3",e:9.737},{m:"g2-g3",e:9.737},{m:"d2-d4",e:9.737},{m:"c2-c4",e:9.737}],"-1#-447889625":[{m:"Nb8-d7",e:9.63},{m:"a7-a5",e:9.63}],"1#917596824":[{m:"Bf1-e2",e:8}],"-1#-179109474":[{m:"b7-b6",e:7.5},{m:"c7-c5",e:7.5}],"1#-1579821428":[{m:"O-O",e:6.667}],"-1#-1148700808":[{m:"Bc8-b7",e:6.667}],"1#541393628":[{m:"c2-c4",e:6.667}],"-1#-352172051":[{m:"d5xc4",e:8.889},{m:"Bf8-d6",e:8.889},{m:"Bf8-e7",e:8.889}],"1#-1104646404":[],"1#-979594464":[{m:"a2-a3",e:5}],"-1#-768786183":[{m:"a5-a4",e:5}],"1#702864041":[{m:"b3-b4",e:5}],"-1#156230758":[{m:"Bf8-e7",e:5}],"1#-1858271762":[{m:"Bf1-e2",e:5}],"-1#1390374632":[{m:"Nb8-d7",e:5}],"1#-2128364713":[{m:"O-O",e:5}],"-1#-1686218077":[{m:"O-O",e:5}],"1#1063884762":[{m:"c2-c4",e:5}],"-1#-198257941":[{m:"c7-c5",e:5}],"1#-1084899959":[{m:"d2-d3",e:5}],"-1#-1869098216":[{m:"d5xc4",e:5}],"1#-486389231":[{m:"d3xc4",e:5}],"-1#1749060780":[{m:"c5xb4",e:5}],"-1#-260930783":[{m:"Bf8-e7",e:8.333}],"1#1744855721":[{m:"Bf1-g2",e:6.667}],"-1#660934652":[{m:"O-O",e:7.5}],"1#-2089631099":[{m:"O-O",e:8}],"-1#-1724963983":[{m:"c7-c5",e:8.889}],"1#-766227437":[{m:"e2-e3",e:8}],"-1#1828552732":[{m:"Nb8-c6",e:6.667}],"1#-730895552":[{m:"d2-d4",e:5}],"-1#676249888":[{m:"c5xd4",e:8.333}],"1#443981101":[{m:"e3xd4",e:5}],"-1#1289095846":[{m:"Bc8-d7",e:5}],"1#-1674682715":[{m:"Nb1-d2",e:5}],"-1#1278122488":[{m:"Ra8-c8",e:5}],"1#-1539433388":[],"-1#-1480206008":[{m:"c7-c5",e:6.667},{m:"Bf8-e7",e:6.667}],"1#-323045846":[],"1#1068972224":[{m:"e2-e3",e:5}],"-1#-2128677681":[{m:"O-O",e:7.5}],"1#621361590":[{m:"Bf1-d3",e:6.667}],"-1#295540524":[{m:"Nf6-e4",e:7.5},{m:"b7-b6",e:7.5}],"1#1515427343":[{m:"O-O",e:5}],"-1#1074690043":[{m:"Nb8-d7",e:5}],"1#-1812815292":[{m:"c2-c4",e:5}],"-1#1488316277":[{m:"f7-f5",e:5}],"1#-824220067":[{m:"c4xd5",e:5}],"1#1159413822":[{m:"Nb1-d2",e:6.667}],"-1#-1793357981":[{m:"a7-a5",e:6.667}],"1#-1245009052":[{m:"a2-a3",e:5}],"-1#-1568966467":[{m:"c7-c5",e:5}],"-1#-1868351975":[{m:"g7-g6",e:9.891},{m:"c7-c5",e:9.891},{m:"c7-c6",e:9.891},{m:"Bf8-d6",e:9.891},{m:"Nb8-d7",e:9.891},{m:"Bf8-e7",e:9.891},{m:"a7-a5",e:9.891}],"1#-1993508324":[{m:"g2-g3",e:5}],"-1#582715925":[{m:"Bf8-g7",e:5}],"1#747809319":[{m:"Bf1-g2",e:5}],"-1#1677182834":[{m:"O-O",e:8.333}],"1#-606578309":[{m:"e2-e3",e:9.667},{m:"g2-g3",e:9.667},{m:"c4xd5",e:9.667}],"1#-1739791777":[{m:"e2-e3",e:8.571}],"-1#652553808":[{m:"Nb8-d7",e:9}],"1#-182846481":[{m:"d2-d4",e:9.167}],"1#1563924494":[{m:"e2-e3",e:9},{m:"g2-g3",e:9}],"-1#-157194233":[{m:"O-O",e:8.75}],"1#1130357670":[{m:"g2-g3",e:6.667},{m:"e2-e3",e:6.667}],"-1#-34197591":[{m:"Bf8-d6",e:5}],"1#147969937":[{m:"e2-e3",e:9.778},{m:"c4xd5",e:9.778}],"-1#-1233642594":[{m:"O-O",e:9.688}],"-1#-1614731171":[{m:"e6xd5",e:9.167}],"1#-1334699490":[{m:"Nb1-c3",e:9},{m:"e2-e3",e:9}],"-1#30287624":[{m:"c7-c6",e:7.5}],"1#496898154":[{m:"g2-g3",e:8.571}],"-1#-1240932253":[{m:"e7-e6",e:7.5}],"1#-503412298":[{m:"Bf1-g2",e:7.5}],"-1#-1365515037":[{m:"Ng8-f6",e:7.5}],"1#689254802":[{m:"d2-d3",e:8}],"-1#114777859":[{m:"h7-h6",e:7.5}],"1#1408571443":[{m:"Nb1-d2",e:5}],"-1#-2081038482":[{m:"Bf8-e7",e:5}],"1#461848294":[{m:"e2-e4",e:7.5}],"-1#1564586395":[{m:"Bf5-h7",e:6.667}],"1#-493538361":[{m:"e4-e5",e:6.667}],"-1#862875472":[{m:"Nf6-d7",e:5}],"1#-1913271296":[{m:"Ng1-h3",e:5}],"-1#1892423328":[{m:"c7-c5",e:5}],"1#1001880002":[{m:"O-O",e:5}],"-1#569022518":[{m:"Nb8-c6",e:5}],"1#-1720159382":[{m:"f2-f4",e:5}],"-1#-449126934":[{m:"Qd8-c7",e:5}],"1#-1440538402":[{m:"Nh3-f2",e:5}],"-1#238812296":[{m:"O-O-O",e:5}],"1#-117857461":[{m:"a2-a3",e:5}],"-1#-280465262":[{m:"f7-f6",e:5}],"1#-884067004":[{m:"e5xf6",e:5}],"-1#568422741":[{m:"Be7xf6",e:5}],"1#1652957131":[{m:"Bb2xf6",e:5}],"-1#463788457":[{m:"Nd7xf6",e:5}],"1#-1665660509":[{m:"b3-b4",e:5}],"-1#-1139591316":[{m:"e6-e5",e:5}],"1#-117624102":[{m:"f4xe5",e:5}],"-1#-1173247015":[{m:"Nc6xe5",e:5}],"1#808816031":[{m:"b4xc5",e:5}],"-1#-2138005931":[{m:"Qc7xc5",e:5}],"1#271981436":[{m:"Bc1-b2",e:7.5},{m:"e2-e3",e:7.5}],"-1#75266413":[{m:"Bc8-b7",e:5}],"1#-1615770423":[{m:"Ng1-f3",e:5}],"-1#1731357984":[{m:"Ng8-f6",e:5}],"1#-524502959":[{m:"e2-e3",e:5}],"-1#1578464350":[{m:"a7-a6",e:5}],"1#1664724333":[{m:"Bf1-e2",e:5}],"-1#-1596209557":[{m:"e7-e6",e:5}],"1#-148000834":[{m:"O-O",e:5}],"-1#-311407030":[{m:"Bf8-e7",e:5}],"1#1963110338":[{m:"d2-d3",e:5}],"-1#1522581843":[{m:"d7-d5",e:5}],"1#2049589664":[{m:"Nb1-d2",e:5}],"-1#-1440053507":[{m:"Nb8-d7",e:5}],"1#2044089154":[{m:"Rf1-e1",e:5}],"-1#1994580522":[{m:"b5-b4",e:5}],"1#-273690998":[],"-1#-1365256333":[{m:"Bc8-b7",e:5}],"1#894624471":[{m:"Ng1-f3",e:5}],"-1#-841891010":[{m:"a7-a6",e:5}],"1#-251848179":[{m:"Bc1-b2",e:5}],"-1#-457738212":[{m:"e7-e6",e:5}],"1#-1287581239":[{m:"c2-c4",e:5}],"-1#2013680888":[{m:"b5-b4",e:5}],"1#-515147688":[{m:"d2-d4",e:5}],"-1#493539896":[{m:"Ng8-f6",e:5}],"1#-1696331959":[{m:"Nb1-d2",e:5}],"-1#1256505364":[{m:"Bf8-e7",e:5}],"1#-761912932":[{m:"Bf1-d3",e:5}],"-1#-436039930":[{m:"O-O",e:5}],"1#1108689535":[{m:"Qd1-c2",e:5}],"-1#-743594581":[{m:"d7-d6",e:5}],"1#-1782672500":[{m:"e3-e4",e:5}],"-1#496262217":[{m:"Nb8-d7",e:5}],"1#-832009738":[{m:"O-O",e:5}],"-1#-734697470":[{m:"Nf6-h5",e:5}],"1#-1119510767":[{m:"Rf1-e1",e:5}],"-1#-1301205383":[{m:"Nh5-f4",e:5}],"1#755298636":[{m:"Bd3-f1",e:5}],"-1#428892118":[{m:"Nf4-g6",e:5}],"1#1537814501":[{m:"g2-g3",e:5}],"-1#-264249364":[],"1#-774533713":[{m:"Bc1-b2",e:8.333}],"-1#-979374146":[{m:"Ng8-f6",e:7.5}],"1#1108425423":[{m:"d2-d3",e:6.667}],"-1#1842566238":[{m:"d7-d6",e:5}],"1#734028409":[{m:"e2-e4",e:5}],"-1#1829170436":[{m:"e7-e5",e:5}],"1#240848336":[{m:"e4xf5",e:5}],"-1#1615585555":[{m:"Bc8xf5",e:5}],"1#-599662823":[{m:"Ng1-e2",e:5}],"-1#1133458150":[{m:"Nb8-c6",e:5}],"1#-81929798":[{m:"d3-d4",e:5}],"-1#1488687612":[{m:"Bf8-e7",e:5}],"1#-1060540300":[{m:"Ne2-g3",e:5}],"-1#-1236044586":[{m:"Bf5-g6",e:5}],"1#872985170":[{m:"h2-h4",e:5}],"-1#-1886405922":[{m:"h7-h6",e:5}],"1#-626131474":[{m:"h4-h5",e:5}],"-1#-668840361":[{m:"Bg6-h7",e:5}],"1#-1779923400":[],"1#-1070474762":[{m:"Bc1-b2",e:9.846}],"-1#-730088473":[{m:"e7-e6",e:9.844},{m:"g7-g6",e:9.844}],"1#-2087857614":[{m:"Ng1-f3",e:9}],"-1#2064577499":[{m:"d7-d5",e:8.75}],"1#-839518238":[{m:"f2-f4",e:9.756},{m:"c2-c4",e:9.756},{m:"g2-g3",e:9.756},{m:"e2-e4",e:9.756},{m:"Bc1-b2",e:9.859},{m:"Bb2xf6",e:9.756}],"-1#-1313384094":[{m:"Bf8-g7",e:9}],"1#-1080133296":[{m:"Bc1-b2",e:8.571}],"-1#1193105593":[{m:"O-O",e:9.333},{m:"c7-c5",e:9.333}],"1#-485845568":[{m:"e2-e3",e:8.75}],"-1#1570986447":[{m:"d7-d6",e:8.571}],"1#464547816":[{m:"Bf1-e2",e:8.889}],"-1#-665713426":[{m:"Nb8-c6",e:8}],"1#1623257010":[{m:"O-O",e:6.667}],"-1#2057113158":[{m:"a7-a6",e:6.667}],"1#1202837365":[{m:"c2-c4",e:5}],"-1#-1929997756":[{m:"e7-e5",e:5}],"1#-273976688":[{m:"f4xe5",e:5}],"-1#-1387795565":[{m:"Nf6-g4",e:5}],"1#-1829785564":[{m:"h2-h3",e:5}],"-1#-1972390150":[{m:"Ng4xe5",e:5}],"1#23543433":[{m:"d2-d4",e:5}],"-1#-45706007":[{m:"Ne5xf3+",e:5}],"1#-507271373":[{m:"Be2xf3",e:5}],"-1#-270827264":[{m:"Qd8-g5",e:5}],"1#-859464001":[{m:"Kg1-h1",e:5}],"-1#123564539":[{m:"Qg5xe3",e:5}],"1#-721064643":[{m:"Bf3xc6",e:5}],"-1#-1056442130":[{m:"b7xc6",e:5}],"1#998507411":[{m:"Rf1-e1",e:5}],"-1#883995387":[{m:"Qe3-f2",e:5}],"1#1943787270":[{m:"Qd1-d2",e:5}],"-1#66490593":[{m:"Qf2-h4",e:5}],"1#-15432411":[{m:"Re1-e2",e:5}],"-1#-861714437":[{m:"Bc8-g4",e:5}],"1#-19539458":[{m:"Qd2-e1",e:5}],"-1#-698781042":[{m:"Qh4xe1+",e:5}],"1#2069089345":[{m:"Re2xe1",e:5}],"-1#-1566074177":[{m:"Bg4-f5",e:5}],"1#-1911196158":[{m:"Nb1-d2",e:5}],"1#208025563":[],"-1#112374483":[{m:"Bf8-g7",e:8.571}],"1#144413409":[{m:"Ng1-f3",e:8.571}],"-1#-266816760":[{m:"d7-d6",e:9.855},{m:"O-O",e:9.855},{m:"b7-b6",e:9.855}],"1#-1240758993":[{m:"g2-g3",e:9.412}],"-1#496858406":[{m:"e7-e5",e:9.091}],"1#2126550514":[{m:"Bf1-g2",e:8.889}],"-1#832960679":[{m:"O-O",e:9.286}],"1#1410301553":[{m:"e2-e3",e:9.773},{m:"g2-g3",e:9.773}],"-1#-358174082":[{m:"d7-d6",e:9.286}],"-1#-6713736":[{m:"b7-b6",e:9.677},{m:"d7-d6",e:9.677}],"1#-1533123558":[{m:"d2-d4",e:5}],"-1#1488965242":[{m:"O-O",e:5}],"1#-56098045":[{m:"e2-e3",e:5}],"-1#1107414796":[{m:"Bc8-b7",e:5}],"-1#1717766123":[{m:"Bf8-g7",e:9.167}],"1#1749690329":[{m:"Bf1-g2",e:9.167}],"-1#657410700":[{m:"d7-d6",e:9.167},{m:"O-O",e:9.167}],"1#1631354027":[{m:"d2-d4",e:8.333}],"-1#-1658988853":[{m:"c7-c5",e:8.333}],"1#-697910871":[{m:"d4xc5",e:8.333},{m:"d4-d5",e:8.333}],"-1#-390821352":[{m:"Qd8-a5+",e:8}],"-1#750209315":[{m:"O-O",e:5}],"1#-2002746278":[{m:"Ng1-h3",e:5}],"1#-2093447179":[{m:"Ng1-f3",e:8.333},{m:"f2-f4",e:8.333}],"-1#2075895324":[{m:"c7-c5",e:9.902}],"1#817940862":[{m:"O-O",e:9.286}],"-1#-8771211":[{m:"d7-d6",e:5}],"1#-1184293038":[{m:"Ng1-f3",e:5}],"-1#1105870523":[{m:"e7-e5",e:5}],"-1#-1959561057":[{m:"Bf8-g7",e:9.231},{m:"d7-d6",e:9.231}],"1#-2061870931":[{m:"g2-g3",e:8.333},{m:"e4-e5",e:8.333}],"-1#780970148":[{m:"e7-e5",e:7.5}],"1#1305561200":[{m:"Bf1-g2",e:6.667}],"-1#45360421":[{m:"Nb8-c6",e:6.667}],"-1#1424032826":[{m:"Nf6-d5",e:6.667}],"1#-382205560":[{m:"d2-d4",e:6.667},{m:"Ng1-f3",e:6.667}],"1#-853520712":[{m:"f2-f4",e:8.75},{m:"g2-g3",e:8.75}],"-1#-1318920136":[],"-1#1723252401":[{m:"Bf8-g7",e:8.571}],"1#1755291267":[{m:"Bf1-g2",e:8.75}],"-1#670757846":[{m:"O-O",e:8.75}],"-1#896980491":[{m:"Bf8-g7",e:9.867}],"1#996144697":[{m:"g2-g3",e:9.865},{m:"d2-d4",e:9.865},{m:"e2-e3",e:9.865}],"-1#-1865873872":[{m:"a7-a5",e:9.942},{m:"d7-d5",e:9.942},{m:"d7-d6",e:9.942},{m:"b7-b6",e:9.942},{m:"O-O",e:9.942}],"1#-1340593609":[{m:"Bf1-g2",e:7.5}],"1#-1339849021":[{m:"Bf1-g2",e:9.444}],"1#-690343913":[{m:"Bf1-g2",e:9.697}],"1#-1001402078":[{m:"Bf1-g2",e:8.75}],"1#887016265":[{m:"Ng1-f3",e:8.333}],"-1#-948020135":[{m:"d7-d6",e:9.375}],"1#-2123535746":[{m:"Nb1-d2",e:9.091}],"-1#1366142243":[{m:"Nb8-d7",e:8}],"1#-2104395620":[{m:"e2-e4",e:6.667}],"-1#-1000867871":[{m:"e7-e5",e:6.667}],"1#-1492510923":[{m:"d4xe5",e:5}],"-1#-576001416":[{m:"Nf6-g4",e:5}],"1#-503139889":[],"-1#-2047460810":[{m:"O-O",e:9.677}],"1#568457039":[{m:"Bf1-e2",e:9.524}],"-1#-503079863":[{m:"c7-c5",e:9.474},{m:"d7-d6",e:9.474}],"1#-1451691221":[{m:"O-O",e:9}],"-1#-1289415969":[{m:"Nb8-c6",e:8.889}],"1#196606339":[{m:"d2-d4",e:8.333}],"-1#-141143069":[{m:"c5xd4",e:6.667}],"1#-1542411666":[{m:"d2-d4",e:9.091},{m:"O-O",e:9.091}],"-1#1479606286":[{m:"Nb8-d7",e:9.333}],"-1#-1102230630":[{m:"e7-e5",e:8.333}],"-1#-189846427":[{m:"e7xf6",e:8.333}],"1#385232253":[{m:"g2-g3",e:8.333}],"-1#-1117725324":[{m:"f6-f5",e:6.667},{m:"Bf8-g7",e:6.667}],"1#2130618933":[{m:"c2-c4",e:5}],"-1#-1246105852":[{m:"d7-d5",e:5}],"1#-1789693961":[{m:"c4xd5",e:5}],"-1#37982267":[{m:"Qd8xd5",e:5}],"1#416804077":[{m:"Ng1-f3",e:5}],"-1#-531313404":[{m:"Bf8-g7",e:5}],"1#-293737162":[{m:"Nb1-c3",e:5}],"1#-1286996666":[{m:"e2-e3",e:5}],"-1#232796489":[{m:"f6-f5",e:5}],"1#-830585336":[{m:"d2-d4",e:5}],"-1#845147240":[{m:"d7-d6",e:5}],"1#1951193679":[{m:"Bf1-g2",e:5}],"-1#992589594":[{m:"Nb8-d7",e:5}],"1#-388668763":[{m:"Ng1-e2",e:5}],"1#618851411":[{m:"Bc1-b2",e:9.966},{m:"g2-g3",e:9.966}],"-1#816352834":[{m:"Nb8-c6",e:9.965},{m:"d7-d6",e:9.965}],"1#-2009438946":[{m:"e2-e3",e:9.946},{m:"c2-c4",e:9.946},{m:"g2-g3",e:9.946},{m:"e2-e4",e:9.946},{m:"Ng1-f3",e:9.946}],"-1#915646737":[{m:"Bf8-c5",e:9.925},{m:"d7-d5",e:9.925},{m:"Ng8-f6",e:9.925},{m:"Nb8-c6",e:9.756}],"1#-699192574":[{m:"Bf1-b5",e:5}],"-1#610880432":[{m:"Qd8-e7",e:5}],"1#377039330":[{m:"Bf1-b5",e:9.778},{m:"Ng1-f3",e:9.778}],"1#-1323467680":[{m:"Bf1-b5",e:9.8},{m:"e2-e3",e:9.697}],"1#1887477558":[{m:"Bf1-b5",e:9.706},{m:"f2-f4",e:9.706},{m:"Ng1-f3",e:9.706},{m:"c2-c4",e:9.706}],"-1#598512919":[{m:"g7-g6",e:9}],"1#975362322":[{m:"Bf1-g2",e:8.333}],"-1#1967633479":[{m:"Bf8-g7",e:8}],"1#2070844533":[{m:"c2-c4",e:8}],"-1#-1339436732":[{m:"d7-d6",e:8.75}],"1#-163911837":[{m:"Nb1-c3",e:9.231}],"-1#1200020085":[{m:"f7-f5",e:9.231},{m:"Ng8-f6",e:9.231},{m:"Bc8-e6",e:9.231}],"1#-773039267":[{m:"e2-e3",e:8.571}],"-1#-822285725":[{m:"Ng8-f6",e:6.667}],"1#1232224018":[{m:"Nb1-c3",e:5}],"-1#-120716796":[{m:"Bf8-c5",e:5}],"1#403603479":[{m:"Bf1-c4",e:5}],"-1#-1603818413":[],"-1#1891190007":[{m:"e5-e4",e:8.571},{m:"d7-d6",e:8.571}],"1#-312966888":[{m:"Nf3-d4",e:7.5}],"-1#1334250643":[{m:"Ng8-f6",e:7.5},{m:"Nc6xd4",e:7.5}],"1#-938878494":[{m:"e2-e3",e:6.667}],"1#917140176":[{m:"d2-d4",e:7.5}],"-1#-896804688":[{m:"e5-e4",e:6.667}],"1#1466572127":[{m:"d4-d5",e:5}],"-1#-1380192811":[{m:"e4xf3",e:5}],"1#-1087779679":[{m:"d5xc6",e:5}],"1#1992013925":[{m:"c2-c4",e:9.905},{m:"d2-d4",e:9.905},{m:"e2-e3",e:9.905},{m:"g2-g3",e:9.905}],"-1#-1107493548":[{m:"g7-g6",e:9.333},{m:"Nb8-c6",e:9.333},{m:"Bc8-g4",e:9.333},{m:"d7-d6",e:9.091},{m:"Ng8-f6",e:9.333}],"1#-1535987375":[{m:"g2-g3",e:8.333}],"1#91100680":[{m:"Nb1-c3",e:8.571}],"1#-1886756015":[{m:"g2-g3",e:5}],"1#980559909":[{m:"g2-g3",e:5}],"-1#-1847273428":[],"-1#-1969614331":[{m:"e5xd4",e:9}],"1#568762850":[{m:"Qd1xd4",e:7.5}],"-1#1517475767":[{m:"Nb8-c6",e:7.5}],"1#-488620821":[{m:"Qd4-d2",e:7.5}],"-1#78523719":[{m:"Ng8-f6",e:7.5}],"1#-2094991306":[{m:"Nb1-c3",e:7.5}],"-1#849134880":[{m:"d6-d5",e:7.5}],"1#606142275":[{m:"e2-e3",e:6.667},{m:"O-O-O",e:6.667}],"-1#-1702284468":[{m:"Bf8-b4",e:5}],"-1#1917375281":[{m:"Bc8-e6",e:5}],"-1#-938314646":[{m:"d7-d6",e:5},{m:"f7-f5",e:9.756},{m:"Nb8-c6",e:9.756}],"1#1335664923":[{m:"c2-c4",e:9.706},{m:"d2-d3",e:9.706},{m:"Ng1-e2",e:9.706},{m:"g2-g3",e:9.706},{m:"d2-d4",e:9.706}],"-1#-2065963990":[{m:"g7-g6",e:9.375}],"1#-1655330769":[{m:"Ng1-f3",e:9.286}],"-1#1708558790":[{m:"Bf8-g7",e:9.231}],"1#1811917300":[{m:"Bf1-e2",e:9.231},{m:"d2-d4",e:9.231}],"-1#-1474444558":[{m:"O-O",e:8.333}],"1#201985931":[{m:"O-O",e:9}],"-1#374861439":[{m:"e5-e4",e:9},{m:"Nb8-d7",e:9}],"1#-1950995568":[{m:"Nf3-d4",e:5}],"-1#694789659":[{m:"c7-c5",e:5}],"1#1645398393":[{m:"Nd4-b5",e:5}],"1#-978633792":[{m:"d2-d4",e:8.333},{m:"d2-d3",e:8.333}],"-1#965382560":[{m:"e5-e4",e:6.667}],"-1#-1747057772":[{m:"e5-e4",e:8.333},{m:"e5xd4",e:8.333}],"1#171951739":[{m:"Nf3-d2",e:7.5}],"-1#207831959":[{m:"O-O",e:8}],"1#-1468756242":[{m:"Nb1-c3",e:8}],"-1#432583672":[{m:"Rf8-e8",e:8}],"1#1017294963":[{m:"Nf3xd4",e:6.667}],"-1#63934801":[{m:"O-O",e:6.667}],"1#-1478992856":[{m:"Bf1-e2",e:6.667}],"-1#1681536814":[{m:"Rf8-e8",e:7.5}],"-1#1616826250":[{m:"g7-g6",e:6.667}],"1#2043708303":[{m:"g2-g3",e:6.667}],"-1#-767134842":[{m:"Bc8-g4",e:5}],"1#-533664381":[{m:"f2-f3",e:5}],"-1#1983783725":[{m:"Bg4-e6",e:5}],"1#1333211672":[{m:"Bf1-g2",e:5}],"-1#1204045":[{m:"c7-c6",e:5}],"1#150833931":[{m:"Ng1-e2",e:5}],"-1#-1758238988":[{m:"h7-h5",e:5}],"1#-1247235957":[{m:"h2-h3",e:5}],"-1#-1389840811":[{m:"Bf8-h6",e:5}],"1#-781678969":[{m:"Qd1-d2",e:5}],"-1#-1589264032":[{m:"Nb8-d7",e:5}],"1#1924732127":[{m:"f3-f4",e:5}],"-1#-391055290":[{m:"Qd8-c7",e:5}],"1#-1482095246":[{m:"c2-c4",e:5}],"-1#1827553347":[{m:"O-O-O",e:5}],"1#-1708384384":[{m:"Nb1-c3",e:5}],"-1#730866326":[{m:"Kc8-b8",e:5}],"1#-346330124":[{m:"O-O-O",e:5}],"-1#-1120712826":[{m:"d6-d5",e:5}],"1#-1416659483":[{m:"c4xd5",e:5}],"-1#1017086505":[{m:"Nf6xd5",e:5}],"1#-734038463":[{m:"Nc3xd5",e:5}],"-1#-799912732":[{m:"Bc8-f5",e:8.889},{m:"g7-g6",e:8.889}],"1#-1093422357":[{m:"f2-f4",e:8}],"-1#-1030677397":[{m:"Nb8-c6",e:8}],"1#2047080247":[{m:"Ne2-g3",e:8}],"-1#211415957":[{m:"Bf5-g4",e:8}],"1#539696936":[{m:"Bf1-e2",e:8}],"-1#-473336786":[{m:"h7-h5",e:8},{m:"Bg4xe2",e:8}],"1#-1051549103":[{m:"O-O",e:7.5}],"-1#-619756635":[{m:"Bg4xe2",e:7.5}],"1#-63658717":[{m:"Qd1xe2",e:5}],"-1#823787130":[{m:"g7-g6",e:5}],"1#681030271":[],"1#-908328735":[{m:"f2-f4",e:8}],"-1#-1247891871":[{m:"Bf8-g7",e:8},{m:"Nb8-c6",e:8},{m:"Nb8-d7",e:8}],"1#-1145598381":[{m:"f4xe5",e:5}],"-1#-111470768":[{m:"Nf6-g4",e:5}],"1#218907965":[{m:"f4xe5",e:6.667}],"-1#1340136510":[{m:"Nc6xe5",e:5}],"1#-976946568":[{m:"Ne2-f4",e:5}],"1#1717730270":[],"-1#-469085934":[{m:"Bc8-d7",e:5}],"1#888276241":[{m:"Bf1-g2",e:5}],"-1#2073520196":[{m:"Bd7-c6",e:5}],"1#-1163775670":[{m:"Ng1-f3",e:5}],"-1#1109463203":[{m:"Bf8-e7",e:5}],"1#-632032981":[{m:"O-O",e:5}],"-1#-1072820001":[{m:"O-O",e:5}],"1#1679416742":[{m:"c2-c4",e:5}],"-1#-1352755049":[{m:"b7-b5",e:5}],"1#-120090772":[{m:"d2-d4",e:5}],"-1#83240204":[{m:"e5xd4",e:5}],"1#-1349871893":[{m:"e3xd4",e:5}],"-1#1023580766":[{m:"b5xc4",e:5}],"1#1537629299":[{m:"b3xc4",e:5}],"-1#1307861232":[{m:"Nb8-a6",e:5}],"1#300928546":[{m:"d4-d5",e:5}],"-1#-976658081":[{m:"Bc6-d7",e:5}],"1#83638353":[{m:"Nb1-d2",e:5}],"-1#-721617140":[{m:"Na6-c5",e:5}],"1#1445016813":[{m:"Bb2-d4",e:5}],"-1#475427895":[{m:"Bd7-a4",e:5}],"1#1841229388":[{m:"Qd1-c1",e:5}],"-1#-2115589866":[{m:"Nf6-d7",e:5}],"1#1065159238":[{m:"Qc1-a3",e:5}],"-1#-1279456389":[{m:"e5-e4",e:8.333},{m:"Nb8-d7",e:8.333}],"1#777834132":[{m:"d4-d5",e:5}],"-1#-728941026":[{m:"c7-c6",e:5}],"1#-597497256":[{m:"c2-c4",e:5}],"-1#388345705":[{m:"c6xd5",e:5}],"1#-1168296853":[{m:"c4xd5",e:5}],"-1#761665514":[{m:"Bf8-e7",e:5}],"1#-1256917406":[{m:"Nb1-c3",e:5}],"-1#78170996":[{m:"O-O",e:5}],"1#-1598093811":[{m:"Ng1-e2",e:5}],"-1#1064430578":[{m:"Bc8-f5",e:5}],"1#1374688765":[{m:"Ne2-g3",e:5}],"1#1614929604":[{m:"Ng1-f3",e:7.5}],"-1#-1732051155":[{m:"Qd8-e7",e:7.5},{m:"e5-e4",e:7.5}],"1#-722725659":[{m:"Bf1-e2",e:5}],"-1#386826211":[{m:"e5-e4",e:5}],"1#-1964000756":[{m:"Nf3-d2",e:5}],"-1#-1934409760":[{m:"g7-g6",e:5}],"1#86194882":[{m:"Nf3-d2",e:6.667}],"-1#58703662":[{m:"d6-d5",e:6.667}],"1#365135181":[{m:"c2-c4",e:7.5}],"-1#-561725316":[{m:"c7-c6",e:7.5}],"1#1584985410":[{m:"d2-d4",e:7.5}],"-1#-1571201246":[{m:"e5-e4",e:7.5}],"1#1069062861":[{m:"c2-c4",e:7.5},{m:"d4-d5",e:7.5}],"-1#-584234900":[{m:"g7-g6",e:9.762},{m:"Ng8-f6",e:9.762},{m:"Nb8-c6",e:9.762},{m:"f7-f5",e:9.762}],"1#-995949463":[{m:"Bf1-g2",e:8.889}],"-1#-1949931204":[{m:"Bf8-g7",e:8.333}],"1#1520672029":[{m:"Bf1-g2",e:9.6}],"-1#365359176":[{m:"Bf8-e7",e:9.6}],"1#1707057968":[],"1#1262995780":[{m:"g2-g3",e:9.231}],"-1#-1888215974":[{m:"d7-d5",e:6.667}],"1#-1348559703":[{m:"Bc1-b2",e:6.667}],"-1#-1143669064":[{m:"f7-f6",e:5}],"1#-1613579410":[],"1#322558869":[{m:"Bc1-b2",e:9.333}],"-1#125024644":[{m:"Bc8-b7",e:9.333}],"1#-1665233888":[{m:"Ng1-f3",e:9.333},{m:"e2-e3",e:9.333},{m:"f2-f4",e:9.333}],"-1#1681763785":[{m:"Ng8-f6",e:7.5}],"1#-474777416":[{m:"g2-g3",e:6.667}],"-1#1210419377":[{m:"e7-e6",e:5}],"1#533979492":[{m:"Bf1-g2",e:6.667}],"-1#1354140721":[{m:"Bf8-e7",e:6.667}],"1#-926650951":[{m:"O-O",e:5}],"-1#-761689011":[{m:"O-O",e:8.75},{m:"c7-c5",e:8.75}],"1#1989034292":[{m:"c2-c4",e:8.571},{m:"d2-d3",e:8.571}],"-1#-1110899707":[{m:"c7-c5",e:9.756},{m:"Qd8-c8",e:9.756}],"1#-156079257":[{m:"e2-e3",e:9.744}],"-1#1209771880":[{m:"Nb8-c6",e:9.5},{m:"a7-a6",e:9.5},{m:"d7-d6",e:9.5}],"1#-259437516":[{m:"Nb1-c3",e:8}],"1#235442511":[{m:"d2-d4",e:8.75}],"1#2067649871":[{m:"Nb1-c3",e:5}],"-1#-897456039":[{m:"d7-d6",e:5}],"1#-1936531842":[{m:"Ra1-c1",e:5}],"-1#-283531019":[{m:"Nb8-d7",e:5}],"1#1021672778":[{m:"d2-d4",e:5}],"-1#1498165157":[{m:"d7-d5",e:6.667}],"1#2040966998":[{m:"Nb1-d2",e:7.5}],"-1#-1448712181":[{m:"Nb8-d7",e:7.5},{m:"c7-c5",e:7.5}],"1#2052767156":[{m:"e2-e3",e:5}],"-1#-990678597":[{m:"c7-c5",e:5}],"1#-1886904615":[],"1#-488831127":[{m:"e2-e3",e:7.5},{m:"Rf1-e1",e:7.5}],"-1#1551158118":[{m:"Nb8-c6",e:7.5}],"-1#-303450623":[{m:"Nb8-c6",e:5}],"1#1434148189":[{m:"e2-e4",e:5}],"1#-1713183953":[{m:"d2-d3",e:6.667}],"-1#-1239380546":[{m:"d7-d6",e:5}],"1#-265045095":[{m:"c2-c4",e:5}],"-1#997523112":[{m:"O-O",e:5}],"1#-1620888623":[{m:"Nb1-c3",e:7.5}],"-1#786370247":[{m:"a7-a6",e:8}],"1#334747636":[{m:"e2-e3",e:7.5}],"-1#-1386603525":[{m:"Nb8-d7",e:6.667}],"1#2124860996":[{m:"Qd1-e2",e:6.667}],"-1#-1175837160":[{m:"Ra8-b8",e:6.667}],"1#-405587829":[{m:"d3-d4",e:6.667}],"-1#1148547277":[{m:"c5xd4",e:5}],"1#1984769216":[{m:"e3xd4",e:5}],"-1#552450891":[{m:"Rf8-e8",e:5}],"1#1718865291":[{m:"Ra1-d1",e:5}],"-1#2094787464":[{m:"Be7-f8",e:5}],"1#-458683904":[{m:"Rf1-e1",e:5}],"-1#-341984408":[{m:"Qd8-c7",e:5}],"1#-1534835108":[{m:"h2-h3",e:5}],"-1#-1140572030":[{m:"Rb8-c8",e:5}],"1#2053658378":[{m:"Qe2-d3",e:5}],"-1#905312348":[{m:"Qc7-b8",e:5}],"1#1065684845":[{m:"d4-d5",e:5}],"-1#-341598192":[{m:"e6-e5",e:5}],"1#-1353865818":[{m:"Nf3-g5",e:5}],"-1#1970697450":[{m:"Bb7-a8",e:5}],"1#-559122934":[{m:"Rd1-c1",e:5}],"-1#-674584011":[{m:"g7-g6",e:5}],"-1#571949103":[{m:"e7-e6",e:9.091},{m:"f7-f5",e:9.091}],"1#1977690618":[{m:"f2-f4",e:8.75},{m:"Ng1-f3",e:8.75}],"-1#161711994":[{m:"Ng8-f6",e:8}],"1#-1909632501":[{m:"Ng1-f3",e:6.667}],"-1#1991144418":[{m:"Bf8-e7",e:6.667}],"1#-287534486":[{m:"Bf1-e2",e:6.667},{m:"Nb1-c3",e:6.667}],"-1#759101804":[{m:"O-O",e:5}],"1#-1993788395":[{m:"O-O",e:5}],"-1#-1821059615":[{m:"c7-c5",e:5}],"1#-670057853":[{m:"d2-d3",e:5}],"-1#1600171900":[{m:"O-O",e:5}],"1#-76062203":[{m:"Bf1-d3",e:5}],"-1#-807154529":[{m:"d7-d6",e:5}],"1#-1980695880":[{m:"O-O",e:5}],"-1#-1817371828":[{m:"Nb8-d7",e:5}],"-1#-1922955245":[{m:"Ng8-f6",e:7.5}],"1#183295330":[{m:"Bf1-e2",e:8.333}],"-1#-921782684":[{m:"Bf8-e7",e:7.5}],"1#1367103468":[{m:"O-O",e:7.5}],"-1#1260500504":[{m:"O-O",e:7.5}],"1#-281642143":[{m:"d2-d4",e:7.5}],"-1#320327937":[{m:"c7-c5",e:6.667},{m:"d7-d5",e:6.667}],"1#1483521635":[{m:"d4xc5",e:7.5}],"-1#1723764178":[{m:"Be7xc5",e:5}],"1#993606357":[{m:"Nb1-d2",e:5}],"1#872239602":[{m:"Nb1-d2",e:5}],"-1#-469920081":[{m:"Nb8-d7",e:5}],"1#805389072":[{m:"c2-c4",e:5}],"1#-1266827001":[{m:"Bf1-e2",e:6.667}],"-1#2006952449":[{m:"Bb7xg2",e:6.667},{m:"Ng8-f6",e:6.667}],"1#1070579295":[{m:"Be2-h5+",e:5}],"-1#731759063":[{m:"g7-g6",e:5}],"1#840142290":[{m:"Bh5-f3",e:5}],"-1#-163950772":[],"1#-267288720":[{m:"Bb2xf6",e:5}],"-1#-917789449":[{m:"e7xf6",e:5}],"1#722642415":[{m:"Be2-f3",e:5}],"-1#-1960012722":[{m:"Nb8-c6",e:5}],"1#868122386":[{m:"Ng1-e2",e:5}],"-1#-1401908499":[{m:"g7-g6",e:5}],"1#-1241587992":[{m:"c2-c4",e:5}],"-1#2126093273":[{m:"Bf8-d6",e:5}],"1#-1288882738":[{m:"Nb1-c3",e:5}],"-1#43059416":[{m:"O-O",e:5}],"1#-1501117023":[{m:"a2-a3",e:5}],"-1#-1321789832":[{m:"Rf8-e8",e:5}],"1#-139894600":[{m:"b3-b4",e:5}],"-1#-687710601":[{m:"Qd8-c8",e:5}],"-1#-520346976":[{m:"Ng8-f6",e:5}],"1#1735587793":[],"-1#1940332002":[{m:"d7-d5",e:9.375},{m:"e7-e5",e:9.375}],"1#1397595409":[{m:"b2-b4",e:8.571}],"-1#792410322":[{m:"e7-e5",e:5}],"1#1281808390":[{m:"a2-a3",e:5}],"-1#1540819935":[{m:"Bf8-d6",e:5}],"1#-1773951544":[{m:"e2-e3",e:5}],"-1#686451143":[{m:"Nb8-d7",e:5}],"1#-82396040":[{m:"c2-c4",e:5}],"-1#810678601":[{m:"d5xc4",e:5}],"1#1136943168":[{m:"Bf1xc4",e:5}],"-1#1246878491":[{m:"a7-a5",e:5}],"1#1786836764":[{m:"b4-b5",e:5}],"-1#1971764717":[{m:"Ng8-f6",e:5}],"1#-234329956":[{m:"Nb1-c3",e:5}],"-1#1135891850":[{m:"O-O",e:5}],"1#-408708877":[{m:"Qd1-c2",
e:5}],"-1#1981513511":[{m:"Nd7-c5",e:5}],"1#2065813419":[{m:"Ng1-e2",e:5}],"-1#-454090156":[{m:"e5-e4",e:5}],"1#2031019963":[{m:"Ne2-d4",e:5}],"-1#-1130584538":[{m:"Bd6-e5",e:5}],"1#1351027545":[{m:"Nc3-e2",e:5}],"-1#106932630":[{m:"Nc5-d3+",e:5}],"1#540566242":[{m:"Bc4xd3",e:5}],"-1#622967924":[{m:"e4xd3",e:5}],"1#305492498":[{m:"Qc2xd3",e:5}],"-1#315460840":[{m:"c7-c5",e:5}],"1#1505158026":[{m:"b5xc6",e:5}],"-1#1215888556":[{m:"b7xc6",e:5}],"1#1662918942":[{m:"Qd3-c2",e:5}],"-1#2054652352":[{m:"Bc8-a6",e:5}],"1#-1173855613":[{m:"Bc1-b2",e:5}],"-1#-1371406190":[{m:"Ra8-b8",e:5}],"1#-260366847":[{m:"Bb2-c3",e:5}],"-1#-1865594370":[{m:"Qd8-d5",e:5}],"1#-551500558":[{m:"f2-f3",e:5}],"-1#1227754076":[{m:"Rf8-e8",e:5}],"1#263224476":[{m:"e3-e4",e:5}],"-1#-2019904679":[{m:"Qd5-d7",e:5}],"1#2073147310":[],"1#284884278":[{m:"a2-a3",e:8.571}],"-1#122367727":[{m:"d7-d5",e:8.571}],"1#664907292":[{m:"d2-d3",e:8.571},{m:"c2-c4",e:8.571}],"-1#140755085":[{m:"c7-c6",e:7.5},{m:"c7-c5",e:7.5}],"1#9180363":[{m:"Ng1-f3",e:5}],"-1#-133221086":[{m:"Bf8-d6",e:5}],"1#899390261":[{m:"c2-c4",e:5}],"-1#-19079676":[{m:"Ng8-f6",e:5}],"1#2035420021":[{m:"Nb1-c3",e:5}],"-1#-923912605":[{m:"d5-d4",e:5}],"1#1151707382":[{m:"Nc3-e4",e:5}],"-1#608827300":[{m:"Nf6xe4",e:5}],"1#447666068":[{m:"d3xe4",e:5}],"-1#-1510523855":[{m:"a7-a5",e:5}],"1#-2061103050":[{m:"e2-e3",e:5}],"-1#999283769":[{m:"d4xe3",e:5}],"1#1717224371":[{m:"Bc1xe3",e:5}],"-1#1737701123":[{m:"Qd8-e7",e:5}],"1#733863115":[{m:"Bf1-e2",e:5}],"-1#-396380211":[{m:"a5-a4",e:5}],"1#328609181":[{m:"Qd1-c2",e:5}],"-1#-2110862775":[{m:"Nb8-d7",e:5}],"1#1372725238":[{m:"O-O",e:5}],"-1#1267727874":[{m:"Bd6-c5",e:5}],"1#379477681":[{m:"Ra1-d1",e:5}],"-1#204896434":[{m:"Bc5xe3",e:5}],"1#1584689918":[{m:"f2xe3",e:5}],"-1#16601844":[{m:"Nd7-c5",e:5}],"1#231203448":[{m:"Kg1-h2",e:5}],"-1#154877651":[{m:"Bc8-e6",e:5}],"1#1916878164":[{m:"Qc2-c3",e:5}],"-1#-426713790":[{m:"f7-f6",e:5}],"1#-1030317932":[{m:"Be2-d3",e:5}],"-1#1168495039":[{m:"Qe7-c7",e:5}],"1#920079348":[{m:"Nf3-h4",e:5}],"-1#-2120575519":[{m:"Qc7-a5",e:5}],"1#717335413":[{m:"Qc3-c2",e:5}],"-1#-1106228381":[{m:"O-O-O",e:5}],"1#1221727392":[],"1#1125691375":[{m:"g2-g4",e:6.667}],"-1#-1813298171":[{m:"Nb8-c6",e:6.667}],"1#729395033":[{m:"Bf1-g2",e:6.667},{m:"Ng1-f3",e:6.667}],"-1#1679606284":[{m:"Ng8-e7",e:5}],"1#-1915267708":[{m:"Nb1-c3",e:5}],"-1#1013672082":[{m:"d5-d4",e:5}],"1#-1340017145":[{m:"Nc3-e4",e:5}],"-1#-791893675":[{m:"Ne7-g6",e:5}],"1#179680185":[{m:"Ng1-f3",e:5}],"-1#-231304624":[{m:"Bf8-e7",e:5}],"1#1782871000":[{m:"g4-g5",e:5}],"-1#1555396737":[{m:"f7-f5",e:5}],"1#-891291223":[{m:"g5xf6",e:5}],"-1#1298328498":[{m:"g7xf6",e:5}],"1#-121915330":[{m:"h3-h4",e:5}],"-1#737753819":[{m:"Rh8-g8",e:5}],"1#426486194":[{m:"c2-c4",e:5}],"-1#-768807805":[{m:"Bc8-e6",e:5}],"1#-1453920508":[{m:"Qd1-a4",e:5}],"-1#1804335441":[{m:"Qd8-a5+",e:5}],"1#-7555514":[{m:"Qa4xa5",e:5}],"-1#-628056282":[{m:"Nc6xa5",e:5}],"1#2142250430":[{m:"Ra1-b1",e:5}],"-1#-1901374212":[{m:"Na5-b3",e:5}],"1#-400705318":[{m:"Bc1-h6",e:5}],"-1#1822690878":[{m:"Ng6-h8",e:5}],"1#-2064764873":[{m:"Bg2-f1",e:5}],"-1#-880059038":[{m:"Nh8-f7",e:5}],"1#-1924247105":[{m:"Bh6-c1",e:5}],"-1#167241563":[{m:"Ra8-b8",e:5}],"1#1473182152":[{m:"Nf3-d2",e:5}],"-1#1368554532":[{m:"Nb3xc1",e:5}],"1#-733796444":[{m:"Rb1xc1",e:5}],"-1#245084384":[{m:"b7-b5",e:5}],"1#1494394651":[],"-1#-738554192":[{m:"Ng8-e7",e:5}],"1#976296248":[{m:"Nb1-c3",e:5}],"-1#-1953684434":[{m:"f7-f6",e:5}],"1#-1349819912":[{m:"Rh1-g1",e:5}],"-1#-593381816":[{m:"Bc8-e6",e:5}],"1#-1478773297":[{m:"e2-e4",e:5}],"-1#-518178126":[{m:"Qd8-d7",e:5}],"1#582893566":[{m:"Nf3-h4",e:5}],"-1#-1779179029":[{m:"d5xe4",e:5}],"1#-783127559":[{m:"Nc3xe4",e:5}],"-1#-285916906":[{m:"Ne7-g6",e:5}],"1#881613818":[{m:"Nh4xg6",e:5}],"-1#-919105357":[{m:"h7xg6",e:5}],"1#-1972978191":[{m:"c2-c3",e:5}],"-1#1678081352":[{m:"O-O-O",e:5}],"1#-1832443253":[{m:"Bc1-e3",e:5}],"-1#-783259826":[{m:"b7-b6",e:5}],"1#-2049527716":[{m:"b2-b4",e:5}],"-1#-106949217":[{m:"f6-f5",e:5}],"1#998858198":[{m:"Ne4-g5",e:5}],"-1#258762046":[{m:"Be6-d5",e:5}],"1#957619246":[{m:"g4xf5",e:5}],"-1#-466429205":[{m:"g6xf5",e:5}],"1#192369919":[{m:"Qd1-a4",e:5}],"-1#-911588694":[{m:"Nc6-b8",e:5}],"1#1899538934":[{m:"Qa4-c2",e:5}],"-1#1377359040":[{m:"Qd7-c7",e:5}],"1#-1360551921":[{m:"b4-b5",e:5}],"-1#-1310594306":[{m:"g7-g6",e:5}],"1#-1469077765":[{m:"c3-c4",e:5}],"-1#-49369148":[{m:"Bd5-g8",e:5}],"1#-615154766":[],"-1#-320410835":[{m:"d5-d4",e:7.5},{m:"c7-c6",e:7.5}],"1#1621980600":[{m:"d2-d3",e:5}],"-1#1332681513":[{m:"a7-a5",e:5}],"1#1874736942":[{m:"g2-g4",e:5}],"-1#-1085416252":[{m:"Nb8-c6",e:5}],"1#132069272":[{m:"Bf1-g2",e:5}],"-1#1220172493":[{m:"Ng8-e7",e:5}],"1#-1586377403":[{m:"Nb1-d2",e:5}],"-1#1903233560":[{m:"Ne7-g6",e:5}],"1#-1425534732":[{m:"Bg2-e4",e:5}],"-1#86600542":[{m:"Bf8-e7",e:5}],"1#-1654945066":[{m:"Ng1-f3",e:5}],"-1#1708698431":[{m:"Bc8-d7",e:5}],"1#-1256128708":[{m:"Nd2-f1",e:5}],"-1#-1622602575":[{m:"Ng6-h4",e:5}],"1#-103938070":[{m:"Nf3xh4",e:5}],"-1#-2048764266":[{m:"Be7xh4",e:5}],"1#1595418935":[{m:"Nf1-g3",e:5}],"-1#-669614774":[{m:"g7-g6",e:5}],"1#-1046990513":[{m:"Rh1-g1",e:5}],"-1#-1296898305":[{m:"Bh4-g5",e:5}],"1#-533259141":[{m:"Bc1-d2",e:5}],"-1#-849779938":[{m:"O-O",e:5}],"1#1766764135":[{m:"Qd1-c1",e:5}],"-1#-2062096067":[{m:"Bg5xd2+",e:5}],"1#-1693051373":[{m:"Qc1xd2",e:5}],"-1#1336280730":[{m:"Qd8-h4",e:5}],"1#-383966517":[{m:"Ng3-h5",e:5}],"-1#-2046831693":[{m:"Kg8-h8",e:5}],"1#1578554372":[{m:"Qd2-h6",e:5}],"-1#892882248":[{m:"Rf8-g8",e:5}],"1#-1101549341":[{m:"O-O-O",e:5}],"-1#-398484335":[{m:"Nc6-e7",e:5}],"1#2020776308":[{m:"f2-f4",e:5}],"-1#70268916":[{m:"Bd7-c6",e:5}],"1#-989499654":[{m:"f4-f5",e:5}],"-1#-1300532393":[{m:"Bc6xe4",e:5}],"1#-1498269668":[{m:"d3xe4",e:5}],"-1#1005733304":[{m:"g6xh5",e:5}],"1#1171891070":[{m:"f5-f6",e:5}],"-1#1228465807":[{m:"Rg8-g6",e:5}],"1#-200260288":[],"1#-469155989":[{m:"c4xd5",e:6.667},{m:"Qd1-c2",e:6.667}],"-1#1931067559":[{m:"c6xd5",e:5}],"1#-1531248951":[{m:"g2-g4",e:5}],"-1#1950946595":[{m:"Ng8-e7",e:5}],"1#-1652391253":[{m:"d2-d3",e:5}],"-1#-1304368070":[{m:"Nb8-c6",e:5}],"1#181536614":[{m:"Nb1-c3",e:5}],"-1#-1150403984":[{m:"g7-g6",e:5}],"1#-1562347915":[{m:"Ng1-f3",e:5}],"-1#1516459932":[{m:"Bf8-g7",e:5}],"1#1414166446":[{m:"g4-g5",e:5}],"-1#1656454391":[{m:"Bc8-e6",e:5}],"1#432111472":[{m:"Bf1-g2",e:5}],"-1#1453593125":[{m:"Qd8-d7",e:5}],"1#-1794697367":[{m:"Bc1-d2",e:5}],"-1#-1201051636":[{m:"Nc6-d4",e:5}],"1#993795536":[{m:"Ra1-c1",e:5}],"-1#1488415579":[{m:"Ra8-c8",e:5}],"1#-1331171593":[{m:"e2-e3",e:5}],"-1#235807480":[{m:"Nd4-c6",e:5}],"1#-1923393756":[{m:"b2-b4",e:5}],"-1#-248646937":[{m:"b7-b6",e:5}],"1#-1515510283":[{m:"h3-h4",e:5}],"-1#1995024144":[{m:"Be6-g4",e:5}],"1#1335932453":[{m:"b4-b5",e:5}],"-1#1353120980":[{m:"Nc6-a5",e:5}],"1#1331058928":[{m:"Qd1-a4",e:5}],"-1#-1920250203":[{m:"O-O",e:5}],"1#698123228":[{m:"h4-h5",e:5}],"-1#722677861":[{m:"Rf8-d8",e:5}],"1#-1435160636":[{m:"h5xg6",e:5}],"-1#-1296890929":[{m:"h7xg6",e:5}],"1#1379211668":[{m:"Rh1-h4",e:5}],"-1#1852507038":[{m:"Bg4-e6",e:5}],"1#1461850795":[],"-1#1974589631":[{m:"Bc8-e6",e:5}],"1#248240952":[{m:"Ng1-f3",e:5}],"-1#-162989359":[{m:"Nb8-d7",e:5}],"1#632565614":[{m:"e2-e3",e:5}],"-1#-1692540063":[{m:"d5xc4",e:5}],"1#-393708952":[{m:"Bf1xc4",e:5}],"-1#-518143693":[{m:"Be6xc4",e:5}],"1#-1262149680":[{m:"Qc2xc4",e:5}],"-1#-1545806078":[{m:"Ng8-f6",e:5}],"1#609356403":[{m:"Nb1-c3",e:5}],"-1#-1779550363":[{m:"Bf8-d6",e:5}],"1#1484429682":[{m:"g2-g4",e:5}],"-1#-2004258152":[{m:"Nd7-b6",e:5}],"1#780107237":[{m:"Qc4-b3",e:5}],"-1#-1365160186":[{m:"Qd8-e7",e:5}],"1#-493902642":[{m:"Nf3-g5",e:5}],"-1#951350658":[{m:"h7-h5",e:5}],"1#439329789":[{m:"g4xh5",e:5}],"-1#1361064265":[{m:"Rh8xh5",e:5}],"1#-1316616428":[{m:"h3-h4",e:5}],"-1#1657046513":[{m:"Nb6-d5",e:5}],"1#-630570885":[{m:"d2-d3",e:5}],"-1#-173527318":[{m:"Nd5xc3",e:5}],"1#1728404949":[{m:"b2xc3",e:5}],"-1#-314929000":[{m:"e5-e4",e:5}],"1#1893422455":[{m:"d3-d4",e:5}],"-1#-746775247":[{m:"Nf6-h7",e:5}],"1#425861273":[{m:"Ng5xh7",e:5}],"-1#-447467890":[{m:"Rh5xh7",e:5}],"1#831465325":[{m:"Ra1-b1",e:5}],"-1#-1064020433":[{m:"O-O-O",e:5}],"1#911608300":[{m:"d4-d5",e:5}],"-1#-863504026":[{m:"c6xd5",e:5}],"1#1644126820":[],"-1#-712059085":[{m:"Ng8-f6",e:9.792},{m:"g7-g6",e:9.792},{m:"e7-e5",e:9.792}],"1#1375732290":[{m:"c2-c4",e:9.474},{m:"b2-b3",e:9.474}],"-1#-1723381901":[{m:"c7-c5",e:6.667}],"1#-767809519":[],"-1#2123896313":[{m:"e7-e5",e:8},{m:"g7-g6",e:8}],"1#499512621":[{m:"Bc1-b2",e:5}],"-1#160405308":[{m:"d7-d6",e:5}],"1#1729518076":[{m:"Bc1-b2",e:5}],"-1#1935424493":[{m:"Bf8-g7",e:6.667}],"1#2104826847":[{m:"d2-d4",e:6.667}],"-1#-2125155905":[{m:"c7-c5",e:5}],"1#-902832419":[{m:"Ng1-f3",e:5}],"-1#850198324":[{m:"O-O",e:8.75}],"1#-1766116787":[{m:"Bf1-d3",e:8}],"-1#-1573937961":[{m:"c5xd4",e:7.5},{m:"b7-b6",e:7.5}],"1#-1877491494":[{m:"e3xd4",e:5}],"-1#-961063087":[{m:"Nf6-d5",e:5}],"1#2070827747":[{m:"O-O",e:5}],"-1#1630778135":[{m:"Nd5-f4",e:5}],"1#720346755":[{m:"Rf1-e1",e:5}],"-1#635121643":[{m:"Nf4xd3",e:5}],"1#765912785":[{m:"Qd1xd3",e:5}],"-1#302805567":[{m:"d7-d6",e:5}],"1#1411335192":[{m:"c2-c4",e:5}],"-1#-1621622487":[{m:"Nb8-c6",e:5}],"1#667609717":[{m:"h2-h3",e:5}],"-1#1061874859":[{m:"d6-d5",e:5}],"1#704042696":[],"1#-156677179":[{m:"Nb1-d2",e:5}],"-1#648645784":[{m:"Bc8-b7",e:6.667}],"1#-1117472452":[{m:"O-O",e:5}],"-1#-1489413944":[{m:"d7-d6",e:6.667}],"1#-517312785":[{m:"c2-c4",e:6.667}],"-1#711797726":[{m:"e7-e6",e:5}],"1#2107326987":[{m:"Rf1-e1",e:7.5},{m:"Qd1-c2",e:7.5}],"-1#1924133731":[{m:"Nb8-d7",e:5}],"1#-1588386084":[{m:"a2-a3",e:5}],"-1#-1226640123":[{m:"d6-d5",e:5}],"1#-1604399258":[{m:"Qd1-e2",e:5}],"-1#1729242938":[{m:"Rf8-e8",e:5}],"1#562844154":[{m:"Ra1-c1",e:5}],"-1#1107765105":[{m:"Nf6-e4",e:5}],"1#164177490":[{m:"Nd2-f1",e:5}],"-1#597743071":[{m:"Qd8-e7",e:5}],"1#1871592983":[{m:"c4xd5",e:5}],"-1#-123813413":[{m:"Bb7xd5",e:5}],"1#2066251570":[{m:"Bd3-c4",e:5}],"-1#-2020576933":[{m:"Bd5xc4",e:5}],"1#-1804248545":[{m:"Qe2xc4",e:5}],"-1#-711420603":[{m:"Ra8-c8",e:5}],"1#1032327401":[{m:"Rc1-c2",e:5}],"-1#2119626011":[{m:"Ne4-d6",e:5}],"1#1837465372":[{m:"Qc4-e2",e:5}],"-1#1588319853":[{m:"c5xd4",e:5}],"1#1821608544":[{m:"e3xd4",e:5}],"-1#976428523":[{m:"Rc8xc2",e:5}],"1#1874649931":[],"-1#-333208097":[{m:"Nb8-c6",e:5}],"1#1420906115":[{m:"Bb2-c3",e:5}],"-1#872880508":[{m:"Nc6-b4",e:5}],"1#628964760":[{m:"Bc3xb4",e:5}],"-1#1898862509":[{m:"c5xb4",e:5}],"1#133902695":[{m:"Nd2-e4",e:5}],"-1#111907966":[{m:"Ra8-c8",e:5}],"1#-289730094":[{m:"Ne4xf6+",e:5}],"-1#1545116334":[{m:"Qd8xf6",e:5}],"1#1590780895":[{m:"Qc2-e2",e:5}],"-1#2019614944":[{m:"e6-e5",e:5}],"1#1015997782":[],"1#-872375498":[{m:"f2-f4",e:8.75}],"-1#-1337838154":[{m:"Bf8-g7",e:7.5}],"1#-1100278396":[{m:"Ng1-f3",e:7.5}],"-1#1189622893":[{m:"Ng8-f6",e:8.333},{m:"d7-d6",e:8.333},{m:"c7-c5",e:8.333}],"1#-1050222308":[{m:"Bf1-e2",e:8}],"-1#42240538":[{m:"O-O",e:8}],"1#-1500297373":[{m:"d2-d3",e:6.667}],"-1#-1991169550":[{m:"d7-d5",e:5}],"1#-1447319295":[],"1#16450122":[{m:"Bf1-e2",e:5}],"-1#-1021744820":[{m:"e7-e5",e:5}],"1#-1606121064":[{m:"d2-d3",e:5}],"-1#-1886984439":[{m:"e5xf4",e:5}],"1#-1475180341":[{m:"e3xf4",e:5}],"-1#1925061968":[{m:"Ng8-e7",e:5}],"1#-1686795560":[{m:"O-O",e:5}],"-1#-2128057556":[{m:"O-O",e:5}],"1#624928341":[{m:"Nb1-a3",e:5}],"-1#1802807034":[{m:"c7-c5",e:5}],"1#537905560":[{m:"c2-c3",e:5}],"-1#-831780575":[{m:"Nb8-c6",e:5}],"1#1996415613":[{m:"Kg1-h1",e:5}],"-1#-1117385415":[{m:"d6-d5",e:5}],"1#-1411762342":[{m:"Na3-c2",e:5}],"-1#-613294409":[{m:"d5-d4",e:5}],"1#1463435298":[{m:"c3-c4",e:5}],"-1#39536925":[{m:"Rf8-e8",e:5}],"1#1153777629":[{m:"Nf3-g5",e:5}],"-1#-1627459951":[{m:"Ne7-f5",e:5}],"1#-31666661":[{m:"Ng5-e4",e:5}],"-1#1690287632":[{m:"b7-b6",e:5}],"1#809068802":[{m:"Be2-f3",e:5}],"-1#-1878566749":[{m:"Bc8-b7",e:5}],"1#197815559":[{m:"g2-g3",e:5}],"-1#-1604543218":[{m:"Nf5-e3",e:5}],"1#-1703696557":[{m:"Bc1xe3",e:5}],"-1#-189372769":[{m:"d4xe3",e:5}],"1#198016298":[{m:"Qd1-e2",e:5}],"-1#-863922826":[{m:"Bg7xb2",e:5}],"1#-280371084":[{m:"Ra1-b1",e:5}],"-1#508727606":[{m:"Bb2-d4",e:5}],"1#-1629929140":[{m:"g3-g4",e:5}],"-1#-1778788840":[{m:"Kg8-h8",e:5}],"1#1309725103":[],"1#227760911":[{m:"Bf1-e2",e:8}],"-1#-831442935":[{m:"Ng8-f6",e:7.5}],"1#1241507192":[{m:"O-O",e:8}],"-1#1403126924":[{m:"O-O",e:8}],"1#-139081227":[{m:"a2-a4",e:7.5}],"-1#700835812":[{m:"Nb8-c6",e:5}],"1#-1856566088":[{m:"d2-d3",e:5}],"-1#-1097506263":[{m:"d7-d5",e:5}],"1#-1635786022":[],"1#-1227671577":[{m:"d2-d4",e:8.889}],"-1#1257414023":[{m:"Nb8-c6",e:7.5}],"1#-228559141":[{m:"Ng1-f3",e:6.667}],"-1#182671154":[{m:"e5-e4",e:6.667}],"1#-1761439011":[{m:"Nf3-d2",e:6.667}],"-1#-1856104655":[{m:"f7-f5",e:6.667}],"1#120886809":[{m:"c2-c4",e:5}],"-1#-864824536":[{m:"Ng8-f6",e:5}],"1#1274873433":[{m:"Nb1-c3",e:5}],"-1#-96388273":[{m:"d7-d6",e:9.231},{m:"Bf8-b4",e:9.231},{m:"g7-g6",e:9.231}],"1#-1135473304":[{m:"Bf1-e2",e:7.5},{m:"f2-f3",e:7.5}],"-1#2142266990":[{m:"g7-g6",e:5}],"1#1715350123":[{m:"O-O",e:5}],"-1#2086914975":[{m:"Bf8-g7",e:5}],"1#1917512621":[{m:"f2-f3",e:7.5},{m:"b2-b4",e:7.5}],"-1#-465296125":[{m:"e4xf3",e:5}],"1#-1575850621":[{m:"Be2xf3",e:5}],"-1#139493773":[{m:"O-O",e:5}],"1#-1404613388":[{m:"Ra1-b1",e:6.667},{m:"Rf1-e1",e:6.667}],"-1#1566326198":[{m:"g6-g5",e:5}],"1#-842058844":[{m:"g2-g3",e:5}],"-1#1717158829":[{m:"Nc6-e7",e:5}],"1#-166410680":[{m:"Bf3-g2",e:5}],"-1#-626134598":[{m:"Ne7-g6",e:5}],"1#914320576":[{m:"Nd2-f3",e:5}],"-1#807659820":[{m:"h7-h6",e:5}],"1#1694608924":[],"-1#-1552679524":[{m:"Kg8-h8",e:5}],"1#2023422507":[{m:"Ra1-b1",e:5}],"-1#-1987998871":[{m:"f5-f4",e:5}],"1#-683107827":[],"-1#238833262":[{m:"O-O",e:6.667}],"1#-1439988969":[{m:"b4-b5",e:6.667}],"-1#-1255290394":[{m:"Nc6-e7",e:6.667}],"1#627100675":[{m:"a2-a4",e:6.667}],"-1#-82779630":[{m:"h7-h6",e:7.5},{m:"g6-g5",e:7.5}],"1#-1372412638":[{m:"a4-a5",e:5}],"-1#1166964441":[],"1#1803807744":[{m:"f2-f3",e:6.667}],"-1#-41082194":[{m:"e4xf3",e:5}],"1#-1143248338":[{m:"Nd2xf3",e:5}],"-1#-1208274323":[{m:"h7-h6",e:5}],"1#-489065123":[{m:"Kg1-h1",e:5}],"-1#692165145":[{m:"Ne7-g6",e:5}],"1#-980220061":[{m:"Be2-d3",e:5}],"-1#1117802056":[{m:"Qd8-e7",e:5}],"1#244229504":[{m:"Qd1-c2",e:5}],"-1#-1623834028":[{m:"Nf6-e8",e:5}],"1#875566209":[{m:"Bc1-d2",e:5}],"-1#425618404":[{m:"c7-c6",e:5}],"1#296861602":[{m:"Ra1-e1",e:5}],"-1#1953612870":[{m:"Qe7-f7",e:5}],"1#1940714001":[{m:"e3-e4",e:5}],"-1#-75088428":[{m:"f5-f4",e:5}],"1#-1521537872":[{m:"e4-e5",e:5}],"-1#710722502":[{m:"e4xf3",e:6.667}],"1#1812630342":[{m:"Nd2xf3",e:6.667}],"-1#1613419269":[{m:"g7-g6",e:6.667}],"1#2040831744":[{m:"b2-b4",e:6.667}],"-1#97663683":[{m:"Bf8-g7",e:6.667}],"1#201005809":[{m:"Qd1-b3",e:6.667},{m:"b4-b5",e:6.667}],"-1#2135386431":[{m:"O-O",e:5}],"1#-615472058":[{m:"Bf1-e2",e:5}],"-1#414371648":[{m:"Kg8-h8",e:5}],"1#-1017394953":[{m:"O-O",e:5}],"-1#-653907709":[{m:"Nc6-e7",e:5}],"1#1229663462":[{m:"Bc1-d2",e:5}],"-1#1680167811":[{m:"Bc8-e6",e:5}],"1#526340100":[{m:"d4-d5",e:5}],"-1#-443637618":[{m:"Be6-g8",e:5}],"1#-2048360097":[],"-1#352145408":[{m:"Nc6-e7",e:5}],"1#-2068818459":[{m:"Bf1-d3",e:5}],"-1#-1339753601":[{m:"O-O",e:5}],"1#338900486":[{m:"O-O",e:5}],"-1#242145266":[{m:"Kg8-h8",e:5}],"1#-712519611":[{m:"Qd1-c2",e:5}],"-1#1144993681":[{m:"Bc8-e6",e:5}],"1#1061499926":[],"1#-1773771280":[{m:"Bf1-e2",e:6.667}],"-1#1436815094":[{m:"Bb4xc3",e:5}],"1#-1629246962":[{m:"b2xc3",e:5}],"-1#1518416289":[{m:"d7-d6",e:5}],"1#479332230":[{m:"Ra1-b1",e:5}],"-1#-309758268":[{m:"O-O",e:5}],"1#1235139517":[{m:"O-O",e:5}],"-1#1405311561":[{m:"b7-b6",e:5}],"1#121998683":[{m:"c4-c5",e:5}],"-1#-1427355038":[{m:"d6xc5",e:5}],"1#848579907":[{m:"Bc1-a3",e:5}],"-1#-254497715":[{m:"Rf8-e8",e:5}],"1#-1236608371":[{m:"Be2-b5",e:5}],"-1#-136880754":[{m:"Bc8-d7",e:5}],"1#657394061":[{m:"Qd1-b3+",e:5}],"-1#1402174019":[{m:"Kg8-h8",e:5}],"1#-2005238284":[{m:"Nd2-c4",e:5}],"-1#-1731953793":[{m:"c5xd4",e:5}],"1#1598870208":[{m:"c3xd4",e:5}],"-1#-1598688846":[{m:"a7-a6",e:5}],"1#-1650907007":[],"1#-472942774":[{m:"Bf1-e2",e:8.571},{m:"a2-a3",e:8.571}],"-1#539827276":[{m:"Bf8-g7",e:7.5}],"1#772029566":[{m:"O-O",e:7.5}],"-1#878304650":[{m:"O-O",e:7.5}],"1#-1873932045":[{m:"f2-f3",e:7.5}],"-1#104914525":[{m:"e4xf3",e:6.667},{m:"Bg7-h6",e:6.667}],"1#1075222237":[{m:"Nd2xf3",e:5}],"-1#1278660254":[{m:"d7-d6",e:5}],"1#170260665":[{m:"Ra1-b1",e:5}],"-1#-79787525":[{m:"Qd8-e7",e:5}],"1#-1223663053":[{m:"Rf1-e1",e:5}],"-1#-1205546149":[{m:"Bc8-d7",e:5}],"1#1759283032":[{m:"b2-b4",e:5}],"-1#346694299":[{m:"Ra8-e8",e:5}],"1#-1186048169":[],"1#74203658":[{m:"Nd2-b3",e:5}],"-1#403613707":[{m:"Qd8-e7",e:5}],"1#1411400643":[{m:"f3-f4",e:5}],"-1#-836128934":[{m:"d7-d5",e:5}],"1#-289198167":[{m:"c4xd5",e:5}],"-1#2043924581":[{m:"Nc6-b4",e:5}],"1#1755968641":[],"-1#-193026925":[{m:"Bf8-g7",e:7.5}],"1#-94927711":[{m:"b2-b4",e:7.5}],"-1#-2044649118":[{m:"O-O",e:7.5}],"1#574024731":[{m:"g2-g3",e:7.5},{m:"Bf1-e2",e:7.5}],"-1#-1985995758":[{m:"d7-d6",e:6.667},{m:"d7-d5",e:6.667}],"1#-810341835":[{m:"Nd2-b3",e:5}],"-1#-741228492":[{m:"Qd8-e7",e:5}],"1#-1610667012":[{m:"Qd1-c2",e:5}],"-1#239586344":[{m:"Nc6-d8",e:5}],"1#1961667899":[{m:"a3-a4",e:5}],"-1#-848765884":[{m:"Nd8-f7",e:5}],"1#1971820659":[{m:"Bc1-a3",e:5}],"-1#-1211664003":[{m:"Bc8-d7",e:5}],"1#1732193662":[{m:"O-O-O",e:5}],"-1#827785484":[{m:"c7-c6",e:5}],"1#968414538":[{m:"h2-h3",e:5}],"-1#557372308":[{m:"b7-b6",e:5}],"1#1975387270":[],"1#-1454727967":[{m:"Nd2-b3",e:5}],"-1#-1255639328":[{m:"b7-b6",e:5}],"1#-508648974":[{m:"Bc1-d2",e:5}],"-1#-859775337":[{m:"Nc6-e7",e:5}],"1#1552800626":[{m:"c4-c5",e:5}],"-1#-249291701":[{m:"g6-g5",e:5}],"1#1639387737":[{m:"h2-h4",e:5}],"-1#-634381611":[{m:"h7-h6",e:5}],"1#-1894621723":[{m:"h4xg5",e:5}],"-1#1775045748":[{m:"h6xg5",e:5}],"1#-1609639629":[{m:"f2-f4",e:5}],"-1#-598968397":[],"-1#-506165475":[{m:"d7-d5",e:5}],"1#-1052899346":[{m:"Bc1-b2",e:5}],"-1#-713792001":[{m:"Nc6-e7",e:5}],"1#1161388058":[{m:"g2-g3",e:5}],"-1#-290484205":[{m:"c7-c6",e:5}],"1#-431995819":[{m:"b4-b5",e:5}],"-1#-112849244":[{m:"Kg8-h8",e:5}],"1#581896467":[{m:"a3-a4",e:5}],"-1#-1691649940":[{m:"Bc8-e6",e:5}],"1#-531530773":[{m:"Bb2-a3",e:5}],"-1#1176400963":[{m:"Rf8-e8",e:5}],"1#8389251":[{m:"Ra1-b1",e:5}],"-1#-241470527":[{m:"f5-f4",e:5}],"1#-1353555291":[{m:"g3xf4",e:5}],"-1#-948042425":[{m:"Ne7-f5",e:5}],"1#1764539402":[{m:"b5xc6",e:5}],"-1#997595144":[{m:"b7xc6",e:5}],"1#269534650":[{m:"c4-c5",e:5}],"-1#-1111948669":[{m:"Nf5-h4",e:5}],"1#-577061389":[{m:"Nd2-b3",e:5}],"-1#-1040689166":[{m:"Re8-f8",e:5}],"1#-2023349966":[{m:"Ke1-d2",e:5}],"-1#-728454950":[{m:"Bg7-h6",e:5}],"1#-692570995":[],"-1#-1817953579":[{m:"d7-d5",e:9.999},{m:"b7-b6",e:9.999},{m:"d7-d6",e:9.999},{m:"Nb8-c6",e:9.999},{m:"b7-b5",e:9.999},{m:"e7-e6",e:9.999},{m:"g7-g6",e:9.999},{m:"f7-f5",e:9.999},{m:"Ng8-f6",e:9.999},{m:"c7-c5",e:9.999}],"1#-1286686170":[{m:"d2-d4",e:9.997},{m:"b2-b3",e:9.997},{m:"g2-g3",e:9.997},{m:"d2-d3",e:9.997},{m:"c2-c4",e:9.997}],"-1#-1613320803":[{m:"Ng8-f6",e:9.957},{m:"Bc8-g4",e:9.957},{m:"c7-c5",e:9.957}],"1#408451308":[{m:"Bc1-b2",e:9.894}],"-1#202513149":[{m:"Bc8-f5",e:9.892},{m:"c7-c5",e:9.892},{m:"d7-d5",e:8.75},{m:"Ng8-f6",e:9.844}],"1#1653859570":[{m:"e2-e3",e:9.474}],"1#1198093727":[],"1#-1382009960":[{m:"Nf3-e5",e:9.889},{m:"Ng1-f3",e:9.73},{m:"e2-e3",e:9.889},{m:"d2-d4",e:9.889}],"-1#689291650":[{m:"Bg4-h5",e:6.667}],"-1#319422359":[{m:"e7-e5",e:9.6}],"1#1884561219":[{m:"h2-h3",e:8.889}],"-1#1367448056":[{m:"Nb8-d7",e:6.667},{m:"e7-e6",e:6.667}],"1#-726809857":[{m:"e2-e3",e:9.878},{m:"Ng1-f3",e:9.63}],"-1#1778650864":[{m:"Nb8-c6",e:9.861},{m:"Ng8-f6",e:9.861},{m:"Bc8-f5",e:9.861}],"1#-761862740":[{m:"Bc1-b2",e:9.677}],"1#-309666943":[{m:"Bc1-b2",e:9.767}],"1#75886847":[{m:"Bf1-b5+",e:5}],"-1#-155217843":[{m:"Nb8-d7",e:5}],"-1#416827951":[{m:"c7-c5",e:9.995},{m:"d7-d5",e:9.808},{m:"Ng8-f6",e:9.995},{m:"Bc8-g4",e:9.995},{m:"Bc8-f5",e:9.995},{m:"c7-c6",e:9.995},{m:"g7-g6",e:9.995},{m:"Nb8-c6",e:9.995},{m:"b7-b6",e:9.995}],"1#1403200845":[{m:"Bf1-g2",e:9.98},{m:"c2-c4",e:9.98}],"1#1328423930":[{m:"Bf1-g2",e:9.767}],"-1#4935343":[{m:"g7-g6",e:9.787},{m:"Bf8-d6",e:9.787},{m:"f7-f5",e:9.787},{m:"c7-c5",e:9.787}],"1#432341674":[{m:"O-O",e:8.571}],"-1#60351326":[{m:"Bf8-g7",e:8.571}],"1#229753708":[{m:"d2-d3",e:9.091},{m:"c2-c4",e:9.091},{m:"d2-d4",e:9.091}],"-1#578006525":[{m:"Ng8-e7",e:8}],"1#-877118859":[{m:"Nb1-c3",e:8},{m:"e2-e4",e:8}],"-1#2047084387":[{m:"c7-c5",e:5}],"1#830433281":[{m:"Bc1-g5",e:5}],"-1#-588808422":[{m:"Nb8-c6",e:5}],"1#1685427270":[{m:"Qd1-c1",e:5}],"-1#-2010262756":[{m:"h7-h6",e:5}],"1#-586181588":[{m:"Bg5-d2",e:5}],"-1#-1921075960":[{m:"b7-b6",e:6.667},{m:"d5xe4",e:6.667}],"1#-638033382":[{m:"Nb1-d2",e:5}],"-1#167290183":[{m:"Bc8-b7",e:5}],"1#-908116198":[{m:"d3xe4",e:5}],"-1#194834609":[{m:"Qd8xd1",e:5}],"-1#-956922275":[{m:"Ng8-e7",e:9.767}],"1#792531413":[{m:"d2-d4",e:9.756},{m:"c4xd5",e:9.756}],"-1#-753091659":[{m:"O-O",e:9.778},{m:"Nb8-c6",e:9.778}],"1#1997240012":[{m:"Nb1-d2",e:9.333},{m:"Qd1-c2",e:9.333}],"1#1804488937":[{m:"c4xd5",e:9.688},{m:"e2-e3",e:9.688}],"-1#-1204949479":[{m:"e6xd5",e:8}],"1#-1778851644":[{m:"d2-d3",e:8}],"-1#-1170567595":[{m:"Nb8-c6",e:8}],"1#44590345":[{m:"Nb1-c3",e:8}],"-1#-1290512353":[{m:"O-O",e:8}],"1#386110822":[{m:"Qd1-a4",e:8}],"1#-840965960":[{m:"O-O",e:8.333}],"-1#-679345844":[{m:"Ng8-e7",e:8.333}],"1#1045010116":[{m:"c2-c4",e:6.667}],"-1#-183577611":[{m:"c7-c6",e:5}],"1#-35584077":[{m:"Qd1-c2",e:5}],"-1#1817829479":[{m:"e6-e5",e:5}],"1#683140561":[{m:"d2-d3",e:5}],"-1#125143872":[{m:"a7-a6",e:5}],"1#978932339":[{m:"b2-b3",e:5}],"-1#381765064":[{m:"f7-f6",e:5}],"1#851902494":[{m:"Nb1-d2",e:5}],"-1#-490223805":[{m:"Bc8-e6",e:5}],"1#-1715616572":[{m:"e2-e4",e:5}],"-1#-545567815":[{m:"O-O",e:5}],"1#2070709952":[{m:"d3-d4",e:5}],"-1#-657797498":[{m:"Nb8-d7",e:5}],"1#188095289":[{m:"Bc1-b2",e:5}],"-1#528251176":[{m:"d5xe4",e:5}],"1#1541272378":[{m:"Nd2xe4",e:5}],"-1#96871326":[{m:"Be6-f5",e:5}],"1#1618498209":[{m:"d4xe5",e:5}],"-1#450408428":[{m:"Nd7xe5",e:5}],"1#-1093505008":[{m:"Nf3-d4",e:5}],"-1#470678939":[{m:"Bf5-g4",e:5}],"1#817828134":[{m:"h2-h3",e:5}],"-1#675223544":[{m:"c6-c5",e:5}],"1#468590699":[{m:"h3xg4",e:5}],"-1#669132423":[{m:"c5xd4",e:5}],"1#80007547":[{m:"Bb2xd4",e:5}],"-1#388605494":[{m:"Bd6-c7",e:5}],"1#-1946627887":[{m:"Ra1-d1",e:5}],"-1#-1856964910":[{m:"Qd8-c8",e:5}],"1#1470375832":[{m:"Bd4-c5",e:5}],"-1#645510683":[],"1#-1776169081":[{m:"O-O",e:8.333}],"-1#-1938018701":[{m:"Ng8-f6",e:6.667}],"1#200473346":[{m:"d2-d3",e:9.091}],"-1#607163795":[{m:"c7-c5",e:9.167},{m:"Nb8-c6",e:9.167},{m:"Bf8-c5",e:9.167},{m:"c7-c6",e:9.167}],"1#1867250417":[{m:"c2-c4",e:5}],"-1#-1542668352":[{m:"d5-d4",e:5}],"1#675750229":[{m:"e2-e3",e:5}],"-1#-1762726566":[{m:"d4xe3",e:5}],"1#-885263664":[{m:"Bc1xe3",e:5}],"-1#-890108320":[{m:"Nf6-g4",e:5}],"1#-178627113":[{m:"Be3-g5",e:5}],"-1#722502590":[{m:"Bf8-e7",e:5}],"1#-1667072305":[{m:"c2-c4",e:5}],"-1#1474640894":[{m:"d5xc4",e:5}],"1#611361527":[{m:"d3xc4",e:5}],"-1#-1355652022":[{m:"Qd8xd1",e:5}],"1#1446042986":[{m:"Rf1xd1",e:5}],"-1#8117636":[{m:"e6-e5",e:5}],"1#1150670898":[{m:"Nb1-c3",e:5}],"-1#-181803740":[{m:"e5-e4",e:5}],"1#-990898304":[{m:"c2-c4",e:6.667},{m:"Nb1-d2",e:6.667}],"-1#263672497":[{m:"O-O",e:5}],"1#-1415536696":[{m:"Qd1-c2",e:5}],"-1#974682140":[{m:"d5-d4",e:5}],"-1#351326429":[{m:"O-O",e:5}],"1#-1327030876":[{m:"c2-c3",e:5}],"1#752828885":[{m:"c2-c4",e:8.889}],"-1#-409467676":[{m:"Bf8-e7",e:9.545},{m:"Bf8-d6",e:9.545}],"1#2146100588":[{m:"Qd1-c2",e:8},{m:"b2-b3",e:8}],"1#705473267":[{m:"Nb1-c3",e:9.375},{m:"b2-b3",e:9.375}],"1#1261445581":[{m:"O-O",e:9.545},{m:"d2-d3",e:9.545}],"-1#1366147129":[{m:"Nb8-d7",e:9}],"1#-2104420986":[{m:"d2-d3",e:6.667},{m:"d2-d4",e:6.667}],"-1#-1387037929":[{m:"b7-b6",e:5}],"1#-103437307":[{m:"e2-e4",e:5}],"-1#-1089264776":[{m:"Bc8-b7",e:5}],"1#618534620":[{m:"e4xd5",e:5}],"-1#2014920116":[{m:"Bb7xd5",e:5}],"1#-369383872":[{m:"Nb1-c3",e:5}],"-1#1481087830":[{m:"Bd5-c6",e:5}],"-1#2125512678":[{m:"Ng8-f6",e:5}],"1#-113349993":[{m:"Nb1-d2",e:8},{m:"c2-c4",e:8}],"-1#691973578":[{m:"b7-b6",e:5}],"1#2109242072":[{m:"c2-c4",e:5}],"-1#846802854":[{m:"d5xc4",e:8}],"1#1106032303":[{m:"Nb1-a3",e:9.444}],"-1#262649344":[{m:"c5xd4",e:9.412}],"-1#1693601628":[{m:"b7-b6",e:9.091}],"1#812947534":[{m:"Nb1-d2",e:8.75}],"-1#-529244397":[{m:"Ng8-f6",e:8.75}],"1#1744472674":[{m:"e2-e4",e:8.75}],"-1#557581599":[{m:"d5xe4",e:9.231}],"1#1704824589":[{m:"d3xe4",e:8.75}],"-1#-1478606682":[{m:"Bc8-a6",e:8.75}],"1#1738646501":[{m:"e4-e5",e:8.75}],"-1#-1072556150":[{m:"Nf6-d5",e:8.75}],"1#2110460472":[{m:"c2-c4",e:8.75}],"-1#-1232316663":[{m:"Nd5-b4",e:8.75}],"1#-83075867":[{m:"O-O",e:8.75}],"-1#-514736879":[{m:"Ba6-b7",e:8.75}],"1#-895031487":[{m:"b2-b3",e:8.75}],"-1#-432082694":[{m:"Nb8-c6",e:8.75},{m:"Nb4-d3",e:8.75},{m:"Qd8-c7",e:8.75}],"1#-1457058354":[{m:"Bc1-b2",e:5}],"1#-1621713058":[{m:"Bf1-g2",e:9.988}],"-1#-801902069":[{m:"c7-c6",e:9.989},{m:"Nb8-d7",e:9.989}],"1#716100650":[{m:"Nf3-e5",e:9.942},{m:"Bf1-g2",e:9.942}],"1#1985590304":[{m:"Bf1-g2",e:9.63}],"-1#960289141":[{m:"Nb8-c6",e:9.615},{m:"c7-c6",e:9.615}],"1#272080489":[{m:"b2-b3",e:9.973},{m:"Bf1-g2",e:9.973}],"-1#1599271740":[{m:"Bc8-g4",e:9.973}],"1#22414890":[{m:"c2-c4",e:9.902},{m:"Bf1-g2",e:9.902}],"-1#1311992703":[{m:"Bf8-g7",e:9.889}],"1#-1605721741":[{m:"Bf1-g2",e:9.885}],"-1#-282080218":[{m:"Nb8-c6",e:8.571}],"1#1281269053":[{m:"c2-c4",e:7.5}],"-1#-2028349428":[{m:"d5xc4",e:5}],"-1#-1668492105":[{m:"c7-c5",e:9.643},{m:"Ng8-f6",e:9.643}],"1#-671630379":[{m:"Nb1-d2",e:8.889},{m:"e2-e4",e:8.889}],"-1#133659784":[{m:"c7-c5",e:8.889}],"1#-2139510279":[{m:"g2-g3",e:8.571}],"-1#737106416":[{m:"Bc8-f5",e:7.5}],"1#1164879871":[{m:"Nf3-h4",e:7.5}],"-1#-232556054":[{m:"Bf5-d7",e:7.5}],"1#1008688977":[{m:"Bf1-g2",e:7.5}],"-1#1937388036":[{m:"Bd7-c6",e:7.5}],"1#-1303418102":[{m:"e2-e4",e:7.5}],"-1#-192289673":[{m:"e7-e6",e:7.5}],"-1#-1859046232":[{m:"d5xe4",e:7.5}],"1#-711934278":[{m:"d3xe4",e:7.5}],"-1#399733009":[{m:"Qd8xd1+",e:7.5}],"1#-288241615":[{m:"Ke1xd1",e:7.5}],"-1#-2012335047":[{m:"b7-b6",e:7.5}],"1#-595008725":[{m:"Bf1-b5+",e:7.5}],"1#453116358":[{m:"Nb1-d2",e:9.474}],"-1#-889010533":[{m:"c7-c5",e:8.889},{m:"Nb8-c6",e:8.889}],"1#1938828743":[{m:"e2-e4",e:7.5}],"-1#894870202":[{m:"e7-e5",e:7.5}],"1#1443578478":[{m:"c2-c3",e:9.744},{m:"g2-g3",e:9.744}],"-1#-1201110313":[{m:"g7-g6",e:9.939},{m:"Bf8-e7",e:9.939}],"-1#-39996825":[{m:"Bf8-c5",e:9.75},{m:"Bc8-g4",e:9.75}],"-1#2013921047":[{m:"d5-d4",e:9.985},{m:"d5xc4",e:9.985}],"1#-196976254":[{m:"g2-g3",e:9.956},{m:"a2-a3",e:9.956},{m:"b2-b4",e:9.956},{m:"e2-e3",e:9.956}],"-1#1607766411":[{m:"g7-g6",e:9.902},{m:"Nb8-c6",e:9.902},{m:"c7-c5",e:9.902}],"-1#-470568357":[{m:"a7-a5",e:8},{m:"Bc8-g4",e:8}],"1#-779801506":[{m:"Qd1-b3",e:5}],"-1#-2009807807":[{m:"g7-g6",e:9.853},{m:"f7-f6",e:9.853}],"-1#1256959373":[{m:"Nb8-c6",e:9.8},{m:"c7-c5",e:9.8}],"1#-226933039":[{m:"e3xd4",e:9.697}],"1#194799134":[{m:"g2-g3",e:9.913},{m:"Qd1-a4+",e:9.913},{m:"e2-e4",e:9.913},{m:"Nb1-a3",e:9.913},{m:"e2-e3",e:9.913}],"-1#-1609918953":[{m:"c7-c5",e:9.286},{m:"g7-g6",e:9.286}],"-1#-918458293":[{m:"Nb8-c6",e:9.63},{m:"Nb8-d7",e:9.63}],"-1#1297803619":[{m:"c7-c5",e:8.333}],"1#102860289":[{m:"Bf1xc4",e:7.5}],"-1#1171744433":[{m:"g7-g6",e:9.737}],"-1#-1254774255":[{m:"Bc8-e6",e:9.706},{m:"Ng8-f6",e:9.706}],"1#-954012217":[{m:"g2-g3",e:9.825},{m:"c2-c4",e:9.825}],"-1#1823743438":[{m:"Bc8-b7",e:9.737}],"1#-143054742":[{m:"Bf1-g2",e:9.73}],"-1#-1206106817":[{m:"e7-e6",e:9.73},{m:"e7-e5",e:9.73}],"1#-269865750":[{m:"c2-c4",e:9.474}],"-1#615344603":[{m:"g7-g5",e:9.545}],"1#-571103365":[{m:"Nb1-c3",e:7.5}],"-1#1816762989":[{m:"g5-g4",e:5}],"1#1302131059":[{m:"Nf3-h4",e:5}],"-1#-86954138":[{m:"Bb7xg2",e:5}],"1#-268139551":[{m:"Nh4xg2",e:5}],"-1#1793245661":[{m:"Bf8-g7",e:5}],"1#1691083247":[{m:"d2-d3",e:5}],"-1#1258917758":[{m:"Nb8-c6",e:5}],"1#-207920094":[{m:"Bc1-d2",e:5}],"-1#-554362041":[{m:"h7-h5",e:5}],"1#-59847368":[{m:"h2-h3",e:5}],"-1#-454112282":[{m:"Qd8-c8",e:5}],"1#572136108":[{m:"Qd1-a4",e:5}],"-1#-523825927":[{m:"Qc8-b7",e:5}],"1#-715126388":[{m:"O-O-O",e:5}],"-1#-2096617986":[{m:"Nc6-d4",e:5}],"1#6115362":[{m:"Ng2-e3",e:5}],"-1#-2137746017":[{m:"a7-a6",e:5}],"1#-1111995220":[{m:"Ne3-c2",e:5}],"-1#-1748099954":[{m:"b6-b5",e:5}],"1#-461090608":[{m:"c4xb5",e:5}],"-1#-452392056":[{m:"a6xb5",e:5}],"1#-1709339929":[{m:"Qa4-b4",e:5}],"-1#133601703":[{m:"Qb7-c8",e:5}],"1#844209362":[{m:"Nc3-e4",e:5}],"-1#1388168064":[{m:"Nd4xe2+",e:5}],"1#-194101400":[{m:"Kc1-b1",e:5}],"-1#780610390":[{m:"Ng8-e7",e:5}],"1#-951272226":[{m:"h3xg4",e:5}],"-1#-1027306261":[{m:"Ne7-c6",e:5}],"1#1871996504":[{m:"Qb4-c5",e:5}],"-1#2055646444":[{m:"Qc8-a6",e:5}],"1#358257236":[],"1#-616454677":[{m:"O-O",e:8.571}],"-1#-1055112161":[{m:"e5-e4",e:6.667}],"1#1560117744":[{m:"Nf3-d4",e:6.667}],"-1#-31323013":[{m:"c7-c5",e:6.667}],"1#-1252433127":[{m:"Nd4-b3",e:6.667}],"-1#230195583":[{m:"d7-d5",e:6.667}],"1#760349068":[{m:"d2-d3",e:6.667}],"-1#43020061":[{m:"Ng8-f6",e:6.667}],"1#-2061583764":[{m:"d3xe4",e:6.667}],"-1#370143824":[{m:"Nf6xe4",e:6.667}],"1#-967235160":[{m:"c2-c4",e:6.667}],"-1#220097689":[{m:"d5xc4",e:6.667}],"1#2123101584":[{m:"Nb3-d2",e:6.667},{m:"Qd1xd8+",e:6.667}],"-1#1659445137":[{m:"Ne4-d6",e:5}],"1#1899662742":[{m:"e2-e4",e:5}],"-1#939262699":[{m:"Nd6-b5",e:5}],"1#1267765313":[{m:"Nd2xc4",e:5}],"-1#-355335723":[{m:"Qd8xd1",e:5}],"1#332445941":[{m:"Rf1xd1",e:5}],"-1#1167833115":[{m:"Nb8-c6",e:5}],"1#-49720505":[{m:"Nb1-c3",e:5}],"-1#1286958673":[{m:"Nc6-d4",e:5}],"1#-807396467":[{m:"Nc3xb5",e:5}],"-1#441533960":[{m:"Nd4xb5",e:5}],"-1#1123898881":[{m:"Ke8xd8",e:5}],"1#1471288953":[{m:"Nb3-d2",e:5}],"-1#1271987320":[{m:"Ne4-d6",e:5}],"1#1476619903":[{m:"Bg2xb7",e:5}],"-1#679252801":[{m:"Nd6xb7",e:5}],"1#403600471":[{m:"Nd2xc4",e:5}],"-1#-1186142781":[],"1#-709423886":[{m:"c2-c4",e:9.958},{m:"d2-d4",e:9.958},{m:"g2-g3",e:9.958}],"-1#2116156667":[{m:"e7-e5",e:9.63}],"1#494672943":[{m:"Bf1-g2",e:9.524},{m:"d2-d3",e:9.524}],"-1#1377399162":[{m:"g7-g5",e:9.091},{m:"f7-f5",e:9.091}],"1#-1421754406":[{m:"d2-d4",e:5}],"-1#1465914810":[{m:"g5-g4",e:5}],"1#1991605924":[{m:"Nf3-h4",e:5}],"-1#-1040670543":[{m:"Nb8-c6",e:5}],"1#2037009389":[{m:"d4xe5",e:5}],"-1#63616672":[{m:"d6xe5",e:5}],"1#-558119324":[{m:"Bg2xc6+",e:5}],"-1#-1773803278":[{m:"b7xc6",e:5}],"1#1824920463":[{m:"Qd1xd8+",e:5}],"-1#1353756702":[{m:"Ke8xd8",e:5}],"1#1174401126":[{m:"e2-e4",e:5}],"-1#54099739":[{m:"Bf8-d6",e:5}],"1#-827469556":[{m:"Nb1-d2",e:5}],"-1#514659921":[{m:"Ng8-e7",e:5}],"1#-144277031":[{m:"Nd2-c4",e:5}],"-1#1522429439":[{m:"Bc8-e6",e:5}],"1#-999034798":[{m:"c2-c4",e:8.889},{m:"O-O",e:8.889}],"-1#255112547":[{m:"Ng8-f6",e:7.5}],"1#-2001051630":[{m:"Nb1-c3",e:8.333},{m:"c2-c4",e:8.333}],"-1#956718340":[{m:"g7-g6",e:9.444},{m:"Bf8-e7",e:9.444},{m:"c7-c6",e:9.444}],"1#837388610":[{m:"O-O",e:8}],"-1#-1830321690":[{m:"Bf8-e7",e:8.571},{m:"g7-g6",e:8.571}],"1#177561710":[{m:"Nb1-c3",e:6.667}],"1#-1956000285":[{m:"Nb1-c3",e:8}],"-1#987099381":[{m:"Bf8-g7",e:8.889}],"-1#-567406170":[{m:"Ng8-f6",e:8.333}],"1#1503708375":[{m:"c2-c4",e:8.333}],"-1#851342014":[{m:"f7-f5",e:8.889}],"1#-1529547882":[{m:"c2-c4",e:8}],"-1#1871951527":[{m:"Nb8-a6",e:5}],"1#864557173":[{m:"Nb1-c3",e:5}],"-1#-2110511773":[{m:"c7-c6",e:5}],"1#-1965297371":[{m:"Bf1-g2",e:5}],"-1#-977363856":[{m:"Ng8-f6",e:5}],"1#1110460673":[{m:"O-O",e:6.667}],"-1#1483581685":[{m:"Bf8-e7",e:6.667}],"1#-1071691395":[{m:"Ra1-b1",e:6.667}],"-1#822360127":[{m:"O-O",e:5}],"1#-1793854138":[{m:"b2-b4",e:6.667}],"-1#-379236219":[{m:"Na6-c7",e:6.667}],"1#208848744":[{m:"b4-b5",e:5}],"-1#326405529":[{m:"c6-c5",e:5}],"1#547731978":[{m:"Bc1-b2",e:5}],"-1#888133659":[{m:"Nc7-e6",e:5}],"1#1823035365":[{m:"e2-e3",e:5}],"-1#-771718166":[{m:"Qd8-e8",e:5}],"1#1118941348":[{m:"Nf3-h4",e:5}],"-1#-168005967":[{m:"Nf6-h5",e:5}],"1#-1668507230":[{m:"Bg2-f3",e:5}],"-1#-1338659248":[{m:"g7-g6",e:5}],"1#-1447304619":[{m:"Bf3xh5",e:5}],"-1#1836943176":[{m:"g6xh5",e:5}],"1#1695705968":[{m:"Nc3-d5",e:5}],
"-1#602857100":[{m:"f5-f4",e:5}],"1#2099761128":[{m:"Kg1-h1",e:5}],"-1#-1228988244":[{m:"Be7-d8",e:5}],"1#-916080818":[{m:"e3xf4",e:5}],"-1#-107785160":[{m:"Bd8xh4",e:5}],"1#754331852":[{m:"g3xh4",e:5}],"-1#-229870679":[{m:"Ne6xf4",e:5}],"1#-2086803118":[{m:"Qd1-f3",e:5}],"1#725012873":[{m:"d2-d4",e:9.853}],"1#-1003672274":[{m:"e2-e4",e:9.655},{m:"g2-g3",e:9.655},{m:"c2-c3",e:9.655},{m:"e2-e3",e:9.655}],"-1#-2098486701":[{m:"Bc8-b7",e:9.167},{m:"a7-a6",e:9.167}],"1#421959671":[{m:"Bf1xb5",e:9}],"-1#-1220803797":[{m:"Bb7xe4",e:8.75}],"1#-928858457":[{m:"O-O",e:8.75}],"-1#-755015853":[{m:"e7-e6",e:8.75}],"1#-2062993786":[{m:"O-O",e:6.667}],"1#-1077445792":[{m:"d2-d4",e:7.5}],"-1#1139200256":[{m:"Bc8-b7",e:8.75}],"1#-668212060":[{m:"Ng1-f3",e:8.889},{m:"e4-e5",e:8.571}],"-1#164673587":[{m:"e7-e6",e:5}],"1#1579602406":[{m:"c2-c4",e:5}],"-1#-1788767017":[{m:"b5xc4",e:5}],"1#-205171974":[{m:"Bf1xc4",e:5}],"-1#-1129273049":[{m:"Ng8-e7",e:5}],"1#1434140335":[{m:"Nb1-c3",e:5}],"-1#-456719431":[{m:"d7-d5",e:5}],"1#-1003650230":[{m:"e5xd6",e:5}],"-1#1864656325":[{m:"c7xd6",e:5}],"1#-1925779219":[{m:"d4-d5",e:5}],"-1#2011627623":[{m:"e6-e5",e:5}],"1#856229329":[{m:"Qd1-b3",e:5}],"-1#1203074591":[{m:"Qd8-d7",e:5}],"1#-2078903469":[{m:"a2-a4",e:5}],"-1#1874582823":[{m:"Bc8-b7",e:9}],"1#-193533821":[{m:"Bf1-g2",e:9}],"-1#-1156348458":[{m:"e7-e6",e:9},{m:"c7-c5",e:9}],"1#-320476157":[{m:"O-O",e:9},{m:"a2-a4",e:9},{m:"b2-b3",e:9}],"-1#-155709961":[{m:"c7-c5",e:8.75}],"1#-1111268715":[{m:"d2-d3",e:7.5}],"-1#-1845425148":[{m:"d7-d6",e:6.667}],"1#-737002973":[{m:"e2-e4",e:6.667}],"-1#-1831553698":[{m:"Bf8-e7",e:8}],"-1#848675346":[{m:"b5-b4",e:5}],"1#-1411846478":[{m:"O-O",e:5}],"-1#-1316679866":[{m:"Ng8-f6",e:5}],"1#906746423":[{m:"d2-d4",e:8.333},{m:"d2-d3",e:8.333}],"-1#-1065485384":[{m:"Ng8-f6",e:5}],"1#1207119561":[{m:"c2-c4",e:5}],"-1#-1934332936":[{m:"a7-a6",e:5}],"1#-1315392821":[{m:"Nb1-c3",e:9}],"1#-261559628":[{m:"O-O",e:5}],"-1#-365622464":[{m:"d7-d6",e:5}],"1#-1406780057":[{m:"d2-d4",e:5}],"-1#1342674695":[{m:"c5xd4",e:5}],"1#1648347914":[{m:"Nf3xd4",e:5}],"-1#-1720028906":[{m:"Bb7xg2",e:5}],"1#-1817191023":[{m:"Kg1xg2",e:5}],"-1#-271024644":[{m:"Qd8-b6",e:5}],"1#1968865678":[{m:"Qd1-d3",e:5}],"-1#-1915860429":[{m:"Qb6-b7+",e:5}],"1#-467705218":[{m:"f2-f3",e:5}],"-1#1913760976":[{m:"a7-a6",e:5}],"1#1329427939":[{m:"a2-a4",e:5}],"-1#-1857201166":[{m:"b5-b4",e:5}],"1#134248274":[{m:"c2-c3",e:5}],"-1#-429672469":[{m:"b4xc3",e:5}],"1#176776957":[{m:"Nb1xc3",e:5}],"-1#709815703":[{m:"e7-e6",e:6.667}],"1#2109244482":[{m:"g2-g3",e:5}],"-1#-701598645":[{m:"Bc8-b7",e:5}],"1#1306739183":[{m:"Bf1-g2",e:5}],"-1#42347706":[{m:"Ng8-f6",e:5}],"1#-2063009333":[{m:"O-O",e:6.667}],"-1#-1621813185":[{m:"Bf8-e7",e:8},{m:"c7-c5",e:8}],"1#120060343":[{m:"d2-d3",e:6.667}],"-1#686135078":[{m:"d7-d6",e:6.667}],"1#1861656833":[{m:"a2-a4",e:5}],"-1#-1333358832":[{m:"a7-a6",e:5}],"1#-1918216669":[{m:"a4xb5",e:5}],"-1#-505009110":[{m:"a6xb5",e:5}],"1#-107516207":[{m:"Ra1xa8",e:5}],"-1#-665219562":[{m:"Bb7xa8",e:5}],"1#75499231":[{m:"Qd1-b3",e:5}],"-1#1883010321":[{m:"Ba8xf3",e:5}],"1#1403712178":[{m:"Bg2xf3",e:5}],"-1#-98522088":[{m:"c7-c6",e:5}],"1#-221284258":[{m:"Qb3-a2",e:5}],"-1#-904687632":[{m:"O-O",e:5}],"1#1845772937":[{m:"Bc1-e3",e:5}],"1#-735152291":[{m:"Qd1-b3",e:6.667}],"-1#-1601043309":[{m:"Bb7-c6",e:5}],"1#714226746":[{m:"d2-d3",e:5}],"-1#89150123":[{m:"d7-d6",e:5}],"1#1128490124":[{m:"Bc1-g5",e:5}],"-1#-1361349737":[{m:"Bf8-e7",e:5}],"1#917082655":[{m:"Nf3-d2",e:5}],"-1#821368819":[{m:"Bc6xg2",e:5}],"1#-1067118742":[{m:"Kg1xg2",e:5}],"-1#-1139626233":[{m:"a7-a6",e:5}],"1#-2126612940":[{m:"Bg5xf6",e:5}],"-1#1102502073":[{m:"Be7xf6",e:5}],"1#2125511028":[{m:"a2-a4",e:5}],"-1#-1597991067":[{m:"Nb8-d7",e:5}],"1#1933329114":[{m:"a4xb5",e:5}],"-1#2055528737":[{m:"a7-a6",e:6.667}],"1#1202206738":[{m:"d2-d4",e:6.667},{m:"a2-a4",e:6.667}],"-1#-1148611982":[{m:"Bc8-b7",e:5}],"1#541370326":[{m:"c2-c4",e:8}],"-1#-352066841":[{m:"b5xc4",e:5}],"1#-1918425910":[{m:"Bf1xc4",e:5}],"-1#-1026367721":[{m:"Ng8-f6",e:5}],"1#1163659878":[{m:"Nb1-c3",e:5}],"-1#-186632336":[{m:"Ng8-f6",e:7.5}],"-1#-1713891837":[{m:"b5-b4",e:5}],"1#9779875":[{m:"c2-c4",e:5}],"-1#-875397230":[{m:"Ng8-f6",e:5}],"1#1281141475":[{m:"d2-d4",e:5}],"-1#-1333985149":[{m:"Bc8-b7",e:6.667}],"1#732968231":[{m:"b2-b3",e:5}],"-1#120070812":[{m:"c7-c5",e:5}],"1#1280527870":[{m:"Bf1-d3",e:5}],"-1#2026365796":[{m:"g7-g6",e:5}],"1#1632218977":[{m:"Bc1-b2",e:5}],"-1#1963183472":[{m:"Bf8-g7",e:5}],"1#2066410818":[{m:"Nb1-d2",e:5}],"-1#-1423300065":[{m:"O-O",e:5}],"1#255715174":[{m:"O-O",e:5}],"-1#358614674":[{m:"e7-e6",e:5}],"1#1117155143":[{m:"d4xc5",e:5}],"-1#2084855030":[{m:"a6-a5",e:5}],"1#301737333":[{m:"e3-e4",e:5}],"1#-1001237760":[{m:"g2-g3",e:9.931}],"-1#1875157769":[{m:"d7-d5",e:9.808}],"1#-1976928560":[{m:"g2-g3",e:9.975}],"-1#566003417":[{m:"Bf8-g7",e:9.89}],"1#798336747":[{m:"Bf1-g2",e:9.884}],"-1#1626393534":[{m:"e7-e5",e:9.828},{m:"c7-c5",e:9.828}],"1#61680490":[{m:"e2-e4",e:9.545},{m:"O-O",e:9.545}],"-1#1164682263":[{m:"Nb8-c6",e:7.5}],"1#-33992885":[{m:"d2-d3",e:7.5}],"-1#-767876646":[{m:"d7-d6",e:7.5}],"1#-1809311747":[{m:"O-O",e:7.5}],"-1#435210910":[{m:"c7-c5",e:8.571},{m:"Nb8-c6",e:8.571}],"1#1384883708":[],"1#-1587404350":[{m:"c2-c3",e:5}],"-1#1325523323":[{m:"Ng8-f6",e:5}],"1#-930139126":[{m:"d2-d4",e:5}],"-1#883859050":[{m:"e5-e4",e:5}],"1#-1454417019":[{m:"Nf3-g5",e:5}],"-1#1937017545":[{m:"d7-d5",e:5}],"1#1402866234":[{m:"f2-f3",e:5}],"-1#-980368236":[{m:"h7-h6",e:5}],"1#-1867349084":[{m:"Ng5-h3",e:5}],"-1#1328785825":[{m:"O-O",e:5}],"1#-349936424":[{m:"Nb1-a3",e:5}],"-1#-1519426441":[{m:"Rf8-e8",e:5}],"1#-470740297":[{m:"Na3-c2",e:5}],"-1#-1822753958":[{m:"Nc6-e7",e:5}],"1#51904191":[{m:"Bc1-f4",e:5}],"-1#907827357":[{m:"Ne7-f5",e:5}],"1#-1739660848":[{m:"Bf4-e5",e:5}],"1#730571996":[{m:"d2-d4",e:9.87},{m:"O-O",e:9.87}],"-1#-676720964":[{m:"c5xd4",e:9.444}],"1#-443395407":[{m:"Nf3xd4",e:9.412}],"-1#517466285":[{m:"Nb8-c6",e:9.412}],"1#-1505426447":[{m:"Nd4-b3",e:9.706},{m:"Nd4xc6",e:9.706}],"-1#514122135":[{m:"Ng8-f6",e:9.286},{m:"d7-d6",e:9.286}],"1#-1725287194":[{m:"Nb1-c3",e:8.889}],"-1#680921584":[{m:"O-O",e:8.889}],"1#-1937652599":[{m:"O-O",e:8.75}],"-1#-1763957379":[{m:"d7-d6",e:8.889}],"1#-791735462":[{m:"h2-h3",e:9.091}],"-1#-934341244":[{m:"Ra8-b8",e:8}],"1#-1770648809":[{m:"Bc1-e3",e:5}],"1#1488443312":[{m:"O-O",e:8.333}],"-1#1122645572":[{m:"Bc8-e6",e:8.333}],"1#965752259":[{m:"Nb1-c3",e:8}],"-1#-2010380075":[{m:"Bg7xc3",e:8}],"1#558224032":[{m:"b2xc3",e:8}],"-1#-450410225":[{m:"Qd8-d7",e:8}],"-1#-1936431288":[{m:"b7xc6",e:9.412}],"1#-1959233424":[{m:"O-O",e:9.412}],"-1#-1855612540":[{m:"Bc8-a6",e:9.333},{m:"Ra8-b8",e:9.333}],"1#1360689863":[{m:"Nb1-d2",e:6.667}],"-1#-2128953958":[{m:"Ng8-f6",e:6.667}],"1#110389483":[{m:"c2-c4",e:6.667}],"-1#-841798182":[{m:"Qd8-a5",e:5}],"1#1507091149":[{m:"a2-a3",e:5}],"-1#1315287316":[{m:"O-O",e:5}],"1#-816019689":[{m:"Nb1-d2",e:9.167}],"-1#526139466":[{m:"Ng8-f6",e:9}],"1#-1731029701":[{m:"Nd2-b3",e:9}],"-1#671770699":[{m:"Qd8-c7",e:8.889},{m:"O-O",e:8.889}],"1#-1944214222":[{m:"Bc1-d2",e:6.667}],"-1#836125992":[{m:"Nb8-c6",e:9.808},{m:"d7-d6",e:9.808}],"1#-1991987596":[{m:"c2-c3",e:9.88}],"-1#1730637517":[{m:"e7-e5",e:9.615},{m:"Qd8-b6",e:9.615}],"1#75140633":[{m:"d2-d3",e:9.565},{m:"d2-d4",e:9.565},{m:"e2-e4",e:9.565}],"-1#733536392":[{m:"Ng8-e7",e:9.231}],"-1#-128244615":[{m:"c5xd4",e:8.889}],"1#-899450764":[{m:"c3xd4",e:8.75}],"-1#1119617380":[{m:"Ng8-e7",e:8.571}],"1#-39480641":[{m:"d2-d3",e:5}],"-1#-764937170":[{m:"e7-e5",e:5}],"1#-1321591558":[{m:"c3-c4",e:5}],"-1#-463792699":[{m:"Ng8-e7",e:5}],"1#227574349":[{m:"Nb1-c3",e:5}],"-1#-1137918117":[{m:"d7-d6",e:5}],"1#-96499332":[{m:"Nf3-e1",e:5}],"1#2009428751":[{m:"d2-d4",e:6.667}],"-1#-1947936401":[{m:"c5xd4",e:8}],"1#-1176730270":[{m:"Nf3xd4",e:8}],"-1#1117339518":[{m:"Qd8-b6",e:8}],"1#-669269236":[{m:"Nd4-b3",e:7.5},{m:"c2-c3",e:7.5}],"-1#1627005290":[{m:"Qb6-c7",e:6.667},{m:"Ng8-f6",e:6.667}],"1#-987452261":[{m:"Nb1-c3",e:5}],"-1#1956155789":[{m:"Bg7xc3",e:5}],"1#-411765733":[{m:"c2-c4",e:5}],"-1#741585194":[],"-1#913834933":[{m:"Ng8-f6",e:5}],"1#-1309223228":[{m:"Qd1-b3",e:5}],"-1#-984963830":[{m:"Nb8-d7",e:5}],"1#381055157":[{m:"Qb3xb6",e:5}],"-1#-472824631":[{m:"Nd7xb6",e:5}],"1#-1754751254":[{m:"a2-a4",e:5}],"1#97434621":[{m:"d2-d4",e:9.968},{m:"e2-e4",e:9.968},{m:"g2-g3",e:9.968},{m:"d2-d3",e:9.968},{m:"b2-b3",e:9.968}],"-1#1124611200":[{m:"f5xe4",e:9.744}],"1#203873380":[{m:"Nf3-g5",e:9.737}],"-1#-702739160":[{m:"d7-d5",e:9.737},{m:"e7-e5",e:9.737},{m:"Ng8-f6",e:9.737}],"1#-151548453":[{m:"d2-d3",e:9}],"-1#-650779830":[{m:"Qd8-d6",e:9}],"1#-1663137920":[{m:"d3xe4",e:9},{m:"Nb1-c3",e:9}],"-1#-228329036":[{m:"h7-h6",e:7.5}],"1#-1488863612":[{m:"Qd1-h5+",e:7.5}],"-1#761445014":[{m:"h7-h6",e:8.571},{m:"e4-e3",e:8.571}],"1#-1799999957":[{m:"Bc1xe3",e:5}],"1#-1254035972":[{m:"d2-d3",e:9.333},{m:"d2-d4",e:9.333}],"-1#-1702722707":[{m:"Ng8-f6",e:9.286},{m:"e4-e3",e:9.286}],"1#592844752":[{m:"Bc1xe3",e:9}],"-1#1231112092":[{m:"e5xd4",e:5}],"1#-501353349":[{m:"Ng5xe4",e:5}],"-1#-1962196910":[{m:"Nb8-c6",e:5}],"1#1368643673":[{m:"d2-d3",e:9.231}],"-1#2119284424":[],"-1#-1369945100":[{m:"Ng8-f6",e:9.918}],"1#701931141":[{m:"Bf1-g2",e:9.914}],"-1#1723069392":[{m:"e7-e6",e:9.912},{m:"g7-g6",e:9.912}],"1#826644997":[{m:"d2-d3",e:9.783},{m:"d2-d4",e:9.783},{m:"b2-b3",e:9.783}],"-1#512226452":[{m:"d7-d5",e:9.333},{m:"Bf8-e7",e:9.333}],"1#1047360615":[{m:"d2-d3",e:9.091}],"1#-2030758628":[{m:"O-O",e:8}],"-1#-849072027":[{m:"Bf8-e7",e:9.909},{m:"Bf8-b4+",e:9.909},{m:"d7-d5",e:9.909}],"-1#501059006":[{m:"Bf8-e7",e:8.571},{m:"d7-d5",e:8.571}],"1#1027018061":[{m:"c2-c4",e:5}],"1#2134753237":[{m:"c2-c4",e:9.848},{m:"b2-b4",e:9.848},{m:"d2-d4",e:9.848},{m:"d2-d3",e:9.848},{m:"b2-b3",e:9.848},{m:"c2-c3",e:9.848}],"-1#-1267008796":[{m:"Bf8-g7",e:9.706}],"1#-1168909610":[{m:"O-O",e:9.706}],"-1#55253526":[{m:"Bf8-g7",e:8}],"-1#-2095311435":[{m:"Bf8-g7",e:9.946}],"-1#1358942532":[{m:"Bf8-g7",e:8.571}],"-1#1403365486":[{m:"Bf8-g7",e:8.889}],"-1#-1856077972":[{m:"Bf8-g7",e:8}],"-1#705484140":[{m:"Nb8-c6",e:9.545},{m:"Ng8-f6",e:9.545}],"1#-1835123152":[{m:"e2-e4",e:5}],"-1#-732384947":[{m:"e7-e5",e:5}],"1#-1224388199":[{m:"Nb1-c3",e:9.444},{m:"g2-g3",e:9.444}],"-1#112815247":[{m:"Ng8-f6",e:7.5}],"1#-2127054338":[{m:"e4xf5",e:6.667}],"-1#-282634947":[{m:"d7-d5",e:5}],"1#-808593970":[{m:"d3-d4",e:5}],"-1#1818992008":[{m:"e5xd4",e:5}],"-1#479437200":[{m:"Ng8-f6",e:9.333}],"1#-1692568351":[{m:"e4xf5",e:9.333}],"-1#-183658462":[{m:"Bf8-c5",e:9.333}],"1#365763121":[{m:"Nb1-c3",e:9.333}],"-1#-1536088281":[{m:"d7-d6",e:9.333}],"1#-1383989219":[{m:"e2-e4",e:9.167},{m:"Nb1-d2",e:9.167},{m:"Bc1-g5",e:9.167}],"-1#-347828384":[{m:"d7-d6",e:8.571}],"1#-1386759865":[{m:"e4-e5",e:7.5}],"-1#2091705808":[{m:"d6xe5",e:6.667}],"1#676544483":[{m:"Nf3xe5",e:6.667}],"-1#2105722688":[{m:"d7-d5",e:6.667}],"1#1567115187":[{m:"e2-e4",e:6.667}],"-1#464439502":[{m:"d5xe4",e:6.667}],"1#1594835676":[{m:"d3xe4",e:6.667}],"-1#1075451654":[{m:"d7-d5",e:5}],"1#1626380277":[{m:"Bg5xf6",e:5}],"-1#-1602733704":[{m:"e7xf6",e:5}],"1#1109473376":[{m:"g2-g3",e:5}],"-1#693546054":[{m:"Ng8-f6",e:9.6},{m:"d7-d6",e:9.6}],"1#-1361544905":[{m:"Bc1-b2",e:9.375}],"-1#-1164829914":[{m:"g7-g6",e:9.333}],"1#-1558423773":[{m:"Bb2xf6",e:8}],"-1#-1706652508":[{m:"e7xf6",e:6.667}],"1#2015333820":[{m:"g2-g3",e:6.667}],"-1#-745964107":[{m:"d7-d5",e:6.667}],"1#-211550906":[{m:"Bf1-g2",e:6.667}],"-1#-1140420589":[{m:"c7-c6",e:6.667},{m:"Nb8-c6",e:6.667}],"1#-1259781035":[{m:"O-O",e:5}],"-1#-1363892831":[{m:"Bc8-e6",e:5}],"1#76839759":[{m:"d2-d4",e:5}],"-1#-122302161":[{m:"Bc8-e6",e:5}],"1#-2083532120":[{m:"O-O",e:5}],"1#1866832481":[{m:"d2-d4",e:8.75}],"-1#-1822150655":[{m:"g7-g6",e:8.889}],"1#-1964344316":[{m:"Bc1-b2",e:8}],"-1#-1633673707":[{m:"Bf8-g7",e:7.5}],"1#-1870053849":[{m:"Nb1-d2",e:6.667}],"-1#1082784122":[{m:"Ng8-f6",e:5}],"1#-955831285":[{m:"g2-g3",e:8.333},{m:"e2-e3",e:8.333}],"-1#1821498370":[{m:"c7-c6",e:5}],"1#1685981252":[{m:"Bf1-g2",e:5}],"-1#723215633":[{m:"O-O",e:5}],"-1#2041503748":[{m:"O-O",e:7.5}],"1#-575066755":[{m:"Bf1-e2",e:8}],"-1#509298299":[{m:"Nb8-c6",e:6.667}],"1#338358180":[{m:"Ng1-f3",e:9.333},{m:"g2-g3",e:9.997},{m:"b2-b3",e:9.997}],"-1#-1078190163":[{m:"d7-d6",e:9.991},{m:"c7-c5",e:9.991},{m:"b7-b6",e:9.991},{m:"b7-b5",e:9.991},{m:"g7-g6",e:9.991}],"1#-105961078":[{m:"Bf1-g2",e:9.583}],"-1#-1228258081":[{m:"e7-e5",e:9},{m:"c7-c6",e:9}],"1#-711482357":[{m:"O-O",e:8.571}],"-1#-808827393":[{m:"Bf8-e7",e:6.667}],"1#1471718519":[{m:"d2-d3",e:6.667}],"-1#2021313254":[{m:"O-O",e:8.333}],"1#-596834401":[{m:"c2-c4",e:8.333},{m:"e2-e4",e:8.333}],"1#-1104834407":[{m:"c2-c4",e:7.5}],"-1#1969411496":[{m:"Bc8-g4",e:8}],"1#1192512429":[{m:"Nb1-c3",e:6.667},{m:"O-O",e:6.667}],"-1#-156731717":[{m:"Nb8-d7",e:5}],"-1#1565108825":[{m:"Nb8-d7",e:5}],"1#-188256049":[{m:"Bf1-g2",e:9.815}],"-1#-1147003494":[{m:"Nb8-c6",e:9.792},{m:"g7-g6",e:9.792}],"1#53540550":[{m:"O-O",e:9.655}],"-1#426579762":[{m:"d7-d5",e:9.444}],"1#965187521":[{m:"d2-d4",e:9.841},{m:"d2-d3",e:9.841},{m:"c2-c4",e:9.841}],"1#-1574153825":[{m:"d2-d3",e:9.333}],"-1#-1913766130":[{m:"Bf8-g7",e:8}],"1#-2084102340":[{m:"O-O",e:8.75}],"-1#-1717895480":[{m:"d7-d6",e:9.375}],"1#-544618257":[{m:"e2-e4",e:8}],"1#-348469057":[{m:"Bf1-g2",e:9.933}],"-1#-1537235478":[{m:"Bc8-b7",e:9.932}],"1#1066569806":[{m:"b2-b3",e:9.934},{m:"O-O",e:9.934}],"-1#319457269":[{m:"d7-d6",e:8.889}],"1#1427747282":[{m:"c2-c4",e:8.571},{m:"d2-d4",e:8.571}],"-1#-1637944093":[{m:"e7-e5",e:8.333}],"-1#-1455940686":[{m:"e7-e5",e:5}],"1#-899286170":[{m:"d4xe5",e:5}],"-1#634352058":[{m:"d7-d5",e:9.922},{m:"c7-c5",e:9.922},{m:"e7-e6",e:9.922},{m:"g7-g6",e:9.922}],"1#1916344431":[{m:"c2-c4",e:9.886}],"1#-399177642":[{m:"a2-a4",e:9.916},{m:"Nb1-a3",e:9.916},{m:"Bf1-g2",e:9.916},{m:"c2-c3",e:9.916}],"-1#910501447":[{m:"b5-b4",e:8.75}],"1#-1358427417":[{m:"Bf1-g2",e:8.75}],"-1#-529700942":[{m:"Bc8-b7",e:8.75}],"-1#-1501689607":[{m:"b5-b4",e:8.333},{m:"a7-a6",e:8.333}],"1#1060316249":[{m:"Na3-c4",e:5}],"-1#-1487903485":[{m:"Bc8-b7",e:9.904}],"1#1016942759":[{m:"O-O",e:9.906},{m:"Nb1-a3",e:9.906}],"-1#106350831":[{m:"Bc8-b7",e:6.667}],"1#-1650721461":[{m:"a2-a4",e:6.667}],"1#-1506651224":[{m:"b2-b4",e:9.982},{m:"Bf1-g2",e:9.982},{m:"b2-b3",e:9.982}],"-1#-633014677":[{m:"a7-a5",e:9.73},{m:"b7-b6",e:9.73},{m:"Bf8-g7",e:9.73}],"1#-90842516":[{m:"b4-b5",e:8}],"-1#-380158211":[{m:"Bf8-g7",e:9.972}],"1#-411164977":[{m:"O-O",e:9.972}],"-1#-47972549":[{m:"O-O",e:9.966}],"1#1496592962":[{m:"d2-d3",e:9.962}],"-1#-1968552941":[{m:"Bf8-g7",e:9.93}],"1#-2071763935":[{m:"g2-g3",e:9.865}],"-1#951253023":[{m:"g7-g6",e:9.927},{m:"d7-d6",e:9.927}],"1#557626394":[{m:"Bc1-b2",e:9.859}],"1#2124533304":[{m:"g2-g3",e:9.375}],"-1#-717799887":[{m:"e7-e5",e:7.5}],"1#-1234510107":[{m:"Bf1-g2",e:7.5},{m:"c2-c4",e:7.5}],"-1#-116411472":[{m:"e5-e4",e:5}],"1#1693349471":[{m:"Nf3-g5",e:5}],"-1#-1093294317":[{m:"d6-d5",e:5}],"1#-1469473424":[{m:"d2-d3",e:5}],"-1#-2018774047":[{m:"h7-h6",e:5}],"1#-762727215":[{m:"Ng5-h3",e:5}],"-1#218668756":[{m:"Bc8-f5",e:5}],"1#1669947611":[{m:"Nh3-f4",e:5}],"-1#-2075678499":[{m:"Nb8-c6",e:5}],"1#1020609409":[{m:"O-O",e:5}],"-1#646488693":[{m:"Bf8-e7",e:5}],"1#-1090894851":[{m:"Bc1-b2",e:5}],"-1#-1431297556":[{m:"O-O",e:5}],"1#245886101":[],"-1#2100141012":[],"1#-656452169":[{m:"b2-b3",e:9.992},{m:"e2-e3",e:9.992},{m:"Ng1-f3",e:10},{m:"c2-c3",e:9.992},{m:"g2-g3",e:9.992}],"-1#-196656628":[{m:"Ng8-f6",e:9.808},{m:"d7-d6",e:9.808}],"1#1942591357":[{m:"Bc1-b2",e:9.583}],"-1#1736701292":[{m:"Nb8-c6",e:9.545},{m:"e7-e6",e:9.545}],"1#-552526288":[{m:"c2-c4",e:8.75}],"1#813014201":[{m:"e2-e3",e:9.167}],"-1#-1898164042":[{m:"Bf8-e7",e:9.286}],"1#380547390":[{m:"d2-d4",e:8.889}],"-1#-359720098":[{m:"c5xd4",e:5}],"1#-659077293":[{m:"e3xd4",e:5}],"-1#-1911041832":[{m:"O-O",e:5}],"1#-1303088085":[{m:"Bc1-b2",e:9}],"-1#-1507977670":[{m:"e7-e5",e:8.571},{m:"Nb8-c6",e:8.571}],"1#-985401618":[{m:"d2-d3",e:8},{m:"e2-e3",e:8}],"-1#-360605569":[{m:"Nb8-c6",e:5}],"1#1377006371":[{m:"g2-g3",e:5}],"-1#2078948065":[{m:"e7-e5",e:7.5}],"1#512556390":[{m:"d2-d4",e:9}],"-1#-491956474":[{m:"c5xd4",e:8.333}],"1#-795538677":[{m:"Nf3xd4",e:8.333}],"-1#735097111":[{m:"e7-e5",e:8.333}],"1#1217221059":[{m:"Nd4xc6",e:6.667}],"-1#1650210170":[{m:"b7xc6",e:6.667}],"-1#1719048632":[{m:"d7-d5",e:9.565}],"1#1184635211":[{m:"d2-d4",e:8.333}],"-1#-1161972949":[],"-1#918328590":[{m:"d7-d5",e:9.444}],"1#374740477":[{m:"d2-d4",e:9}],"-1#-361250915":[{m:"Nb8-c6",e:9.565}],"1#1390761153":[{m:"d4xc5",e:9}],"-1#1815570288":[{m:"a7-a5",e:6.667}],"1#1290161015":[{m:"e2-e4",e:5}],"-1#169919498":[{m:"e7-e6",e:5}],"1#1574350303":[{m:"e4xd5",e:5}],"-1#17925815":[{m:"e6xd5",e:5}],"1#1049668983":[{m:"Bc1-e3",e:5}],"-1#2097670322":[{m:"Ng8-f6",e:5}],"1#-91669053":[{m:"Bf1-b5",e:5}],"-1#145972593":[{m:"Bc8-d7",e:5}],"1#-666171022":[{m:"O-O",e:5}],"-1#-1038686074":[{m:"Bf8-e7",e:5}],"1#1516505358":[{m:"Nb1-d2",e:5}],"-1#-1973105069":[{m:"O-O",e:5}],"1#779289386":[{m:"Qd1-a4",e:5}],"-1#-324135553":[{m:"Nf6-e8",e:5}],"1#1202209706":[{m:"Nf3-d4",e:5}],"-1#-445133279":[{m:"Qd8-c8",e:5}],"1#595795819":[{m:"Rf1-e1",e:5}],"-1#750235139":[{m:"Ne8-f6",e:5}],"1#-2018379562":[{m:"Nd2-b3",e:5}],"-1#929629606":[{m:"Rf8-e8",e:5}],"1#1912042342":[{m:"f2-f3",e:5}],"-1#-403063352":[{m:"Be7-f8",e:5}],"1#2139839552":[{m:"Be3-f4",e:5}],"-1#2035430160":[{m:"h7-h6",e:5}],"1#745567264":[{m:"Kg1-f1",e:5}],"-1#1934206398":[{m:"b7-b6",e:9.977},{m:"Nb8-c6",e:9.977},{m:"c7-c5",e:9.991},{m:"g7-g6",e:9.977}],"1#667906732":[{m:"e2-e4",e:9.773},{m:"Bf1-g2",e:9.773}],"-1#1628044753":[{m:"Bc8-b7",e:9}],"1#-87766923":[{m:"Nb1-c3",e:9},{m:"d2-d3",e:9}],"-1#1266218339":[{m:"Ng8-f6",e:8.333}],"-1#1755979769":[{m:"Bc8-b7",e:9.714}],"1#-211342755":[{m:"O-O",e:9.783},{m:"c2-c3",e:9.783}],"1#-874819870":[{m:"Bf1-g2",e:9.965},{m:"d2-d4",e:9.965}],"-1#-2067913801":[{m:"g7-g6",e:9.961}],"1#-1657770062":[{m:"O-O",e:9.955},{m:"c2-c3",e:9.955}],"-1#939189378":[{m:"c5xd4",e:9.615}],"1#96647311":[{m:"Nf3xd4",e:9.545}],"-1#-24706413":[{m:"Qd8-b6",e:9.545},{m:"d7-d5",e:9.545}],"1#1791486395":[{m:"c2-c3",e:9.863},{m:"d2-d4",e:9.863},{m:"Bf1-g2",e:9.863}],"-1#-2069616382":[{m:"Bf8-g7",e:8.75}],"1#-1970468560":[{m:"d2-d4",e:8.75}],"-1#-1763294245":[{m:"c5xd4",e:8}],"1#-1528946730":[{m:"Nf3xd4",e:7.5}],"-1#631407854":[{m:"c7-c5",e:9.828}],"-1#392541628":[{m:"d7-d6",e:9.976},{m:"d7-d5",e:9.976},{m:"e7-e5",e:9.976},{m:"c7-c5",e:9.976},{m:"Ng8-f6",e:9.976}],"1#1366721435":[{m:"d2-d4",e:8.889}],"-1#-1386796549":[{m:"d6-d5",e:8}],"1#-1142221928":[{m:"Ng1-f3",e:5}],"-1#1130902129":[{m:"g7-g6",e:5}],"1#1525055092":[{m:"e2-e3",e:5}],"-1#-464539013":[{m:"Bf8-g7",e:5}],"1#-362376631":[{m:"Bf1-d3",e:5}],"-1#-554550061":[{m:"Ng8-f6",e:5}],"1#1501358498":[{m:"O-O",e:5}],"-1#1126238294":[{m:"Bc8-f5",e:5}],"1#765523545":[{m:"c2-c4",e:5}],"-1#-421022872":[{m:"e7-e6",e:5}],"1#-1324229955":[{m:"Bd3-e2",e:5}],"-1#908235670":[{m:"Bf5xb1",e:5}],"1#1465839859":[{m:"Ra1xb1",e:5}],"-1#-1920694078":[{m:"c7-c6",e:5}],"1#-2056561532":[{m:"b2-b4",e:5}],"-1#-115476153":[{m:"a7-a6",e:5}],"1#-1003413388":[{m:"a2-a4",e:5}],"-1#440471141":[{m:"O-O",e:5}],"1#-1101610212":[{m:"Qd1-b3",e:5}],"-1#-890588974":[{m:"Nb8-d7",e:5}],"1#420898157":[{m:"Bc1-d2",e:5}],"-1#880286216":[{m:"Nf6-g4",e:5}],"1#198197695":[{m:"Rf1-c1",e:5}],"-1#-1546799854":[{m:"Rf8-e8",e:5}],"1#-447495214":[{m:"Be2-d3",e:5}],"-1#1650494201":[{m:"f7-f5",e:5}],"1#-200668207":[{m:"b4-b5",e:5}],"-1#-351518432":[{m:"a6xb5",e:5}],"1#-1600918898":[{m:"c4xb5",e:5}],"-1#462216698":[{m:"c6xb5",e:5}],"1#582552124":[{m:"Bd3xb5",e:5}],"-1#-1336791620":[{m:"Ng4-f6",e:5}],"1#-1879411189":[{m:"Qb3-c2",e:5}],"-1#448491174":[{m:"Bg7-f8",e:5}],"1#345132692":[{m:"Qc2-c7",e:5}],"-1#-863953463":[{m:"Re8-e7",e:5}],"1#-91337691":[],"1#932132175":[{m:"b2-b3",e:9.953},{m:"Ng1-f3",e:9.953}],"-1#454501108":[{m:"Bc8-g4",e:9.375}],"1#694271217":[{m:"Bc1-b2",e:6.667}],"-1#1026285280":[{m:"Nb8-c6",e:6.667}],"1#-2051459652":[{m:"g2-g3",e:6.667}],"-1#774882741":[{m:"e7-e5",e:6.667}],"1#1299326305":[{m:"f4xe5",e:6.667}],"-1#262061154":[{m:"f7-f6",e:6.667}],"1#731445684":[{m:"Bf1-h3",e:6.667}],"-1#1740582704":[{m:"Bg4xh3",e:6.667}],"1#1192722333":[{m:"e5xf6",e:6.667}],"-1#-2026505749":[{m:"Ng8xf6",e:6.667}],"1#-1558249638":[{m:"Ng1xh3",e:6.667}],"-1#-455693603":[{m:"Bf8-c5",e:6.667}],"1#68561102":[{m:"d2-d4",e:6.667},{m:"e2-e3",e:6.667}],"-1#-130579794":[{m:"Bc5-d6",e:5}],"1#-1524227555":[{m:"O-O",e:5}],"-1#-1082407959":[{m:"O-O",e:5}],"1#460066448":[],"-1#-1161829183":[{m:"d5-d4",e:5}],"1#921991764":[{m:"e3-e4",e:5}],"-1#-1092700783":[{m:"O-O",e:5}],"1#449411304":[{m:"d2-d3",e:5}],"-1#889919097":[{m:"Bc5-b4+",e:5}],"1#-913750430":[{m:"Nb1-d2",e:5}],"-1#428441919":[{m:"Nf6-d5",e:5}],"1#-1538227059":[{m:"Qd1-h5",e:5}],"-1#80448274":[{m:"Nd5-e3",e:5}],"1#-1919232370":[{m:"Ke1-e2",e:5}],"-1#-733618526":[{m:"g7-g6",e:5}],"1#-842296665":[{m:"Qh5-h6",e:5}],"-1#1985168275":[{m:"Qd8-d7",e:5}],"1#-1242544417":[{m:"Qh6-h4",e:5}],"-1#2131413514":[{m:"Bb4xd2",e:5}],"1#-387960234":[{m:"Ke2xd2",e:5}],"-1#-1442274394":[{m:"Nc6-e5",e:5}],"1#688038074":[{m:"Nh3-g5",e:5}],"-1#-159151425":[{m:"Rf8-f2+",e:5}],"1#-542378985":[{m:"Kd2-c1",e:5}],"-1#-1063684210":[{m:"Ne5xd3+",e:5}],"1#1970658803":[{m:"Kc1-b1",e:5}],"-1#-1348679219":[{m:"Nd3xb2",e:5}],"1#-1786727127":[],"-1#-821291866":[{m:"Nb8-c6",e:9.946},{m:"g7-g6",e:9.946},{m:"Ng8-f6",e:9.946},{m:"Bc8-g4",e:9.946}],"1#2006908922":[{m:"g2-g3",e:9.286}],"-1#-603451405":[{m:"Bc8-g4",e:8.75},{m:"h7-h6",e:8.75}],"1#-293694986":[{m:"Bf1-g2",e:8.571}],"-1#-1592001373":[{m:"g7-g6",e:8.333},{m:"Bg4xf3",e:8.333},{m:"Ng8-f6",e:8.333}],"1#-1198149466":[{m:"O-O",e:5}],"-1#-1563930286":[{m:"Bf8-g7",e:5}],"1#-1394511520":[{m:"Nb1-c3",e:5}],"-1#492653686":[{m:"Qd8-d7",e:5}],"1#-553760454":[{m:"d2-d3",e:5}],"1#-257335562":[{m:"Bg2xf3",e:6.667}],"-1#1495466076":[{m:"e7-e5",e:6.667}],"1#981393544":[{m:"f4xe5",e:6.667}],"-1#2022865291":[{m:"Nc6xe5",e:6.667}],"1#647309778":[{m:"d2-d4",e:5}],"-1#-625704014":[{m:"e7-e6",e:5}],"1#-1924994457":[{m:"Bc1-e3",e:5}],"-1#-824856670":[{m:"Bg4xf3",e:5}],"1#-1993717565":[{m:"d2-d4",e:5}],"-1#1963713187":[{m:"g7-g5",e:5}],"1#-1940706301":[{m:"Bf1-g2",e:5}],"-1#-1019854506":[{m:"Bc8-f5",e:5}],"1#-1380466855":[{m:"c2-c3",e:5}],"-1#1137999840":[{m:"Qd8-d7",e:5}],"1#-2139653460":[{m:"Nf3-e5",e:5}],"-1#79857846":[{m:"Nc6xe5",e:5}],"1#361396033":[{m:"d4xe5",e:5}],"-1#-968217807":[{m:"g5xf4",e:5}],"1#1389143677":[{m:"Bc1xf4",e:5}],"-1#-245588300":[{m:"e7-e6",e:5}],"1#-1498744991":[{m:"e2-e4",e:5}],"-1#-529762276":[{m:"Bf5xe4",e:5}],"1#1790840379":[{m:"Bg2xe4",e:5}],"-1#-992497117":[{m:"d5xe4",e:5}],"1#291797736":[{m:"Qd1xd7+",e:5}],"-1#-389816090":[{m:"Ke8xd7",e:5}],"1#-696100701":[{m:"e2-e3",e:9.844},{m:"g2-g3",e:9.844}],"-1#1747686572":[],"-1#2098505898":[{m:"Bf8-g7",e:9.796}],"1#1933412504":[{m:"Bf1-g2",e:9.783}],"-1#1012458957":[{m:"c7-c6",e:9.796},{m:"c7-c5",e:9.796},{m:"Ng8-h6",e:9.796},{m:"Ng8-f6",e:9.796}],"1#884421003":[{m:"d2-d3",e:9.167}],"-1#460676890":[{m:"Ng8-h6",e:7.5},{m:"Qd8-b6",e:7.5}],"1#-2114477208":[{m:"c2-c3",e:6.667}],"1#1998817967":[{m:"O-O",e:9.524}],"-1#1837001563":[{m:"Ng8-h6",e:9.474},{m:"Nb8-c6",e:9.474}],"1#-705921017":[{m:"d2-d3",e:9.474}],"1#-1261450350":[{m:"d2-d3",e:8.571}],"-1#-1693604605":[{m:"d5-d4",e:8}],"1#390478742":[{m:"Nb1-d2",e:5}],"1#-1143590724":[{m:"O-O",e:9.792},{m:"d2-d3",e:9.792}],"-1#-1810604499":[{m:"b7-b6",e:8.75}],"1#1216528855":[{m:"g2-g3",e:9.881},{m:"e2-e3",e:9.881},{m:"b2-b3",e:9.881}],"-1#-485215778":[{m:"c7-c6",e:9.744},{m:"g7-g6",e:9.744}],"1#-335813224":[{m:"Bf1-g2",e:6.667}],"-1#-1533114163":[{m:"Bc8-g4",e:8}],"1#-1763174712":[{m:"d2-d4",e:6.667}],"-1#1791605928":[{m:"e7-e6",e:5}],"1#1027593597":[{m:"Bc1-e3",e:5}],"1#-90538533":[{m:"Bf1-g2",e:9.655}],"-1#-1241575282":[{m:"Ng8-f6",e:9.796}],"-1#-164950568":[{m:"g7-g6",e:9.756}],"1#-274382371":[{m:"Bf1-e2",e:9.583},{m:"d2-d4",e:9.583},{m:"b2-b3",e:9.583},{m:"c2-c4",e:9.583}],"-1#742861531":[{m:"Bf8-g7",e:8.75}],"1#577637097":[{m:"c2-c4",e:9}],"-1#327478205":[{m:"Bf8-g7",e:8.571}],"1#497929103":[{m:"Bf1-d3",e:8.75}],"-1#-1019390362":[{m:"Bf8-g7",e:8.75}],"1#-854297004":[{m:"Bc1-b2",e:8.75}],"-1#618792172":[{m:"Bf8-g7",e:7.5}],"-1#1679480428":[{m:"c7-c5",e:9.167}],"1#794933518":[{m:"e2-e3",e:8}],"-1#-1849133823":[{m:"e7-e6",e:8.889}],"1#-969007916":[{m:"Bc1-b2",e:8}],"-1#-764117307":[{m:"Bf8-e7",e:8.889}],"1#1241947981":[{m:"Nf3-e5",e:8.571}],"-1#-827101865":[{m:"Nb8-d7",e:6.667}],"1#491763944":[{m:"Bf1-d3",e:6.667}],"-1#702223986":[{m:"O-O",e:6.667}],"1#-1915954421":[{m:"O-O",e:6.667}],"-1#-1752089857":[{m:"g7-g6",e:6.667}],"1#-42300765":[{m:"e2-e3",e:8.889}],"-1#1137919660":[{m:"Nb8-d7",e:8.75}],"1#-1875930349":[{m:"Bf1-e2",e:8.333}],"-1#1406007317":[{m:"Ng8-f6",e:5}],"1#-733794972":[{m:"d2-d4",e:7.5}],"-1#677545732":[{m:"e7-e6",e:6.667}],"1#2140466897":[{m:"O-O",e:6.667}],"-1#1707675429":[{m:"c7-c5",e:5}],"1#783441991":[{m:"Nb1-c3",e:5}],"-1#-1626448559":[{m:"Bf8-d6",e:5}],"1#1385886534":[{m:"a2-a4",e:5}],"-1#-1930764969":[{m:"O-O",e:5}],"1#687673390":[{m:"h2-h3",e:5}],"-1#813504240":[{m:"Bg4xf3",e:5}],"1#1641002149":[{m:"Be2xf3",e:5}],"-1#1153625180":[{m:"a7-a6",e:5}],"1#2045654383":[{m:"g2-g3",e:5}],"-1#-763837082":[{m:"Qd8-c7",e:5}],"1#-1654572974":[{m:"Bc1-d2",e:5}],"-1#-1341176009":[{m:"Ra8-c8",e:5}],"1#1478476443":[{m:"Kg1-h2",e:5}],"-1#1558388272":[{m:"Nd7-b6",e:5}],"1#-99282611":[{m:"Ra1-a2",e:5}],"-1#-965862815":[{m:"c5xd4",e:5}],"1#-195672468":[{m:"e3xd4",e:5}],"-1#-1560882713":[{m:"Bd6-b4",e:5}],"1#1931521528":[{m:"Rf1-f2",e:5}],"-1#704773427":[{m:"Qc7-c4",e:5}],"1#868714941":[{m:"Qd1-e2",e:5}],"-1#-192192031":[{m:"Bb4xc3",e:5}],"1#1070384409":[{m:"Qe2xc4",e:5}],"-1#-987993344":[{m:"Rc8xc4",e:5}],"1#-2063444261":[{m:"Bd2xc3",e:5}],"-1#-654236100":[{m:"Rf8-c8",e:5}],"1#823500712":[{m:"Bc3-a5",e:5}],"-1#-1435434143":[],"1#1949848936":[{m:"f4xe5",e:9.767},{m:"d2-d3",e:9.767}],"-1#919915627":[{m:"d7-d6",e:9.655}],"1#1892153932":[{m:"e5xd6",e:9.655}],"-1#-740897137":[{m:"Bf8xd6",e:9.583}],"1#-1389322066":[{m:"Ng1-f3",e:9.565}],"-1#1437827399":[{m:"g7-g5",e:9.545}],"1#-1393864729":[{m:"d2-d4",e:9.412},{m:"g2-g3",e:9.412}],"-1#1355474311":[{m:"g5-g4",e:8}],"1#1897893529":[{m:"Nf3-e5",e:8}],"-1#-173376381":[{m:"Bd6xe5",e:8}],"1#-1946997481":[{m:"d4xe5",e:7.5}],"-1#-198157667":[{m:"Qd8xd1+",e:7.5}],"1#221438909":[{m:"Ke1xd1",e:7.5}],"-1#1810702261":[{m:"Nb8-c6",e:7.5}],"1#-746588951":[{m:"Bc1-f4",e:7.5}],"-1#-428584245":[{m:"Ng8-e7",e:6.667}],"1#264226115":[{m:"e2-e3",e:5}],"-1#-1323955892":[{m:"Bc8-f5",e:5}],"1#-543688893":[{m:"Bf1-b5",e:5}],"-1#766351345":[{m:"O-O-O+",e:5}],"1#-613431246":[{m:"Kd1-c1",e:5}],"-1#-1050351115":[{m:"Ne7-g6",e:5}],"1#454947609":[{m:"Bb5xc6",e:5}],"-1#-289615768":[{m:"b7xc6",e:5}],"1#339684117":[{m:"Nb1-c3",e:5}],"-1#-1518135805":[{m:"Rd8-e8",e:5}],"1#1759645976":[{m:"b2-b3",e:5}],"-1#1148847779":[{m:"Ng6xe5",e:5}],"1#27675179":[{m:"Kc1-b2",e:5}],"-1#-2106782350":[{m:"Re8-e6",e:5}],"1#69470305":[{m:"Rh1-f1",e:5}],"-1#230675724":[{m:"Bf5-g6",e:5}],"1#-1880878200":[{m:"Ra1-d1",e:5}],"-1#-1790167669":[{m:"Rh8-e8",e:5}],"1#1781476745":[{m:"Rd1-d4",e:5}],"-1#-1908046341":[{m:"Ne5-d7",e:5}],"1#-1924083659":[{m:"Rf1-d1",e:5}],"-1#-351336603":[{m:"Nd7-b6",e:5}],"1#-540390727":[],"-1#125681646":[{m:"g5-g4",e:9.231}],"1#648598768":[{m:"Nf3-h4",e:9}],"-1#-1847260443":[{m:"Ng8-e7",e:9}],"1#2016320877":[{m:"d2-d4",e:9},{m:"e2-e4",e:9}],"-1#-2079377651":[{m:"Ne7-g6",e:8.571}],"1#1584803297":[{m:"Nh4xg6",e:8.571},{m:"Nh4-g2",e:8.571}],"-1#-1546787160":[{m:"h7xg6",e:8}],"1#-526595094":[{m:"Qd1-d3",e:8}],"-1#403177559":[{m:"Nb8-c6",e:8}],"1#-1600460021":[{m:"c2-c3",e:8}],"-1#1324952498":[{m:"Bc8-f5",e:8}],"1#544789949":[{m:"e2-e4",e:7.5}],"-1#1723751104":[{m:"Qd8-e7",e:7.5}],"1#714125576":[{m:"Bf1-g2",e:7.5}],"-1#1710611549":[{m:"O-O-O",e:8}],"1#-1825078370":[{m:"O-O",e:8}],"-1#-1989516694":[{m:"Nc6-e5",e:6.667}],"1#174088566":[{m:"Qd3-e3",e:6.667},{m:"Qd3-d1",e:6.667}],"-1#-1461670908":[{m:"Bf5-d7",e:5}],"1#1725729471":[{m:"Qe3-g5",e:5}],"-1#-218846517":[{m:"Ne5-f3+",e:5}],"-1#-18543456":[{m:"Nb8-c6",e:6.667}],"1#1182263292":[{m:"c2-c3",e:5}],"-1#-1475074235":[{m:"Qd8-e7",e:5}],"1#-465908595":[{m:"Bc1-h6",e:5}],"-1#1619229289":[{m:"f7-f5",e:5}],"1#-152437951":[{m:"Qd1-c1",e:5}],"-1#447855643":[{m:"Bc8-d7",e:5}],"1#-901126120":[{m:"Qc1-e3",e:5}],"-1#2080745869":[{m:"O-O-O",e:5}],"1#-1966606770":[{m:"Qe3xe7",e:5}],"-1#-216523105":[{m:"Nc6xe7",e:5}],"1#-1243349883":[{m:"e2-e3",e:5}],"-1#189411466":[{m:"c7-c5",e:5}],"1#1076977640":[{m:"Nb1-d2",e:5}],"-1#-1875797835":[{m:"Bd7-c6",e:5}],"1#1359266235":[{m:"Nd2-c4",e:5}],"-1#1055396368":[{m:"f7-f5",e:6.667}],"1#-1467837640":[{m:"e4xf5",e:5}],"-1#-963477509":[{m:"Ne7xf5",e:5}],"1#1962647412":[{m:"Qd1-e2+",e:5}],"-1#-1279822040":[{m:"Ke8-f7",e:5}],"1#701315336":[{m:"Qe2-f2",e:5}],"-1#1465194007":[{m:"Qd8-f6",e:5}],"1#-74902119":[{m:"Bf1-c4+",e:5}],"-1#1138768349":[{m:"Kf7-g7",e:5}],"1#-211717524":[{m:"O-O",e:5}],"-1#-381906024":[{m:"Rh8-f8",e:5}],"1#545550829":[{m:"Nh4xf5+",e:5}],"-1#1130164824":[{m:"Bc8xf5",e:5}],"1#-121446062":[{m:"d2-d4",e:5}],"-1#82004786":[{m:"Nb8-c6",e:5}],"1#-1133404050":[{m:"c2-c3",e:5}],"-1#1376936151":[{m:"Qf6-g6",e:5}],"1#575572530":[{m:"Bc1-f4",e:5}],"-1#390409232":[{m:"Bd6xf4",e:5}],"1#665287330":[{m:"g3xf4",e:5}],"-1#-1146925520":[{m:"Rf8-f6",e:5}],"1#-686721690":[{m:"Nb1-d2",e:5}],"-1#118600251":[{m:"Bf5-d3",e:5}],"1#-478824610":[{m:"Bc4xd3",e:5}],"-1#359503123":[{m:"Qg6xd3",e:5}],"1#-309810978":[{m:"Ra1-e1",e:5}],"-1#-2008493254":[{m:"Ra8-f8",e:5}],"1#1272936378":[],"-1#1543126009":[{m:"e5xf4",e:8.333}],"1#2087605307":[{m:"Bc1xf4",e:6.667}],"-1#624107906":[{m:"d7-d5",e:6.667}],"1#98148721":[{m:"Ng1-f3",e:5}],"-1#-44400488":[{m:"Ng8-f6",e:5}],"1#2060735977":[{m:"Qd1-d2",e:5}],"-1#184095246":[{m:"c7-c5",e:5}],"1#1099070828":[{m:"e2-e4",e:5}],"-1#121958929":[{m:"Nb8-c6",e:5}],"1#-1076487859":[{m:"Nb1-c3",e:5}],"-1#241837147":[{m:"Bc8-e6",e:5}],"1#1963993052":[{m:"Bf1-e2",e:5}],"-1#-1225634598":[{m:"Bf8-e7",e:5}],"1#780184914":[{m:"O-O",e:5}],"-1#886918310":[{m:"O-O",e:5}],"1#-1865776673":[{m:"e4-e5",e:5}],"-1#1093786952":[{m:"Nf6-e8",e:5}],"1#-365458531":[{m:"Ra1-e1",e:5}],"-1#-1879576455":[{m:"Ne8-c7",e:5}],"1#-1823910681":[{m:"Be2-d1",e:5}],"-1#148877589":[{m:"d5-d4",e:5}],"1#-2070663296":[{m:"Nc3-e4",e:5}],"-1#-461868846":[{m:"Nc7-d5",e:5}],"1#-300316885":[{m:"a2-a3",e:5}],"-1#-106408718":[{m:"Be6-f5",e:5}],"1#-1676270131":[{m:"Rf1-f2",e:5}],"-1#-986221306":[{m:"Bf5-g6",e:5}],"1#1198306178":[{m:"g2-g4",e:5}],"-1#-1751164824":[{m:"Qd8-d7",e:5}],"1#1413242148":[{m:"Rf2-g2",e:5}],"-1#1471690063":[{m:"Ra8-d8",e:5}],"1#1199098671":[{m:"h2-h4",e:5}],"-1#-50347101":[{m:"Bg6xe4",e:5}],"1#-1790687632":[{m:"Re1xe4",e:5}],"-1#1901640717":[{m:"f7-f5",e:5}],"1#-416137947":[],"1#1545525982":[{m:"b2-b3",e:9.722},{m:"Ng1-f3",e:9.722}],"-1#1887882597":[{m:"Nb8-c6",e:7.5}],"1#-938203591":[{m:"Bc1-b2",e:6.667}],"-1#-597801944":[{m:"Ng8-f6",e:7.5}],"1#1540395353":[{m:"e2-e3",e:7.5}],"-1#-445031082":[{m:"g7-g6",e:6.667}],"1#-50917037":[{m:"g2-g4",e:6.667},{m:"Ng1-f3",e:6.667}],"-1#738523833":[{m:"Bf8-g7",e:5}],"1#573430411":[{m:"Bf1-g2",e:5}],"-1#1833482206":[{m:"d7-d5",e:5}],"1#1302476589":[{m:"g4-g5",e:5}],"-1#2069052532":[{m:"Nf6-h5",e:5}],"1#304335719":[{m:"Nb1-c3",e:5}],"-1#-1549797775":[{m:"Bc8-f5",e:5}],"1#-853669762":[{m:"Ra1-c1",e:5}],"-1#-1365934347":[{m:"d5-d4",e:5}],"1#585031776":[{m:"Nc3-a4",e:5}],"-1#525265324":[{m:"O-O",e:5}],"1#-1151785771":[{m:"Ng1-e2",e:5}],"-1#613927210":[{m:"e7-e5",e:5}],"1#1204431358":[{m:"Ne2-g3",e:5}],"-1#827338076":[{m:"e5xf4",e:5}],"1#381960862":[{m:"Ng3xf5",e:5}],"-1#708788383":[{m:"Qd8xg5",e:5}],"1#1148063606":[{m:"Bg2xc6",e:5}],"-1#210772448":[{m:"g6xf5",e:5}],"1#-1036245225":[{m:"Bc6xb7",e:5}],"-1#1171494303":[{m:"Ra8-e8",e:5}],"1#-398991277":[{m:"Qd1-f3",e:5}],"-1#-342188552":[{m:"f4xe3",e:5}],"1#-1938574312":[{m:"Ke1-f1",e:5}],"-1#1688207399":[{m:"e3xd2",e:5}],"1#-938429448":[{m:"Rc1-d1",e:5}],"-1#-1049202745":[{m:"Re8-e3",
e:5}],"1#-397308489":[{m:"Qf3-f2",e:5}],"-1#1378367327":[{m:"Rf8-e8",e:5}],"1#347488671":[{m:"Qf2xd2",e:5}],"-1#-863800556":[{m:"Re8-e4",e:5}],"1#846191559":[],"-1#74723514":[{m:"Bf8-g7",e:6.667}],"1#173871240":[{m:"Bf1-e2",e:6.667}],"-1#-910197874":[{m:"O-O",e:6.667}],"1#1839773431":[{m:"O-O",e:8}],"-1#2012567299":[{m:"d7-d6",e:8}],"1#837181732":[{m:"a2-a4",e:8}],"-1#-275361995":[{m:"e7-e5",e:5}],"1#-1932808223":[{m:"f4xe5",e:5}],"-1#-836290846":[{m:"Nf6-g4",e:5}],"1#-242258603":[{m:"Nb1-a3",e:5}],"-1#-1077645830":[{m:"d6-d5",e:5}],"1#-1451731047":[{m:"Ra1-b1",e:5}],"-1#1482893019":[{m:"Qd8-e7",e:5}],"1#340643091":[{m:"c2-c4",e:5}],"-1#-552957918":[{m:"Bc8-e6",e:5}],"1#-1536128091":[{m:"c4xd5",e:5}],"-1#861959273":[{m:"Be6xd5",e:5}],"1#1348598947":[{m:"e5-e6",e:5}],"-1#336563819":[{m:"Bd5xe6",e:5}],"1#527576158":[{m:"Bb2xg7",e:5}],"-1#36730856":[{m:"Kg8xg7",e:5}],"1#-2007408426":[{m:"Na3-c4",e:5}],"-1#-1144370430":[{m:"Be6-f5",e:5}],"1#-562808259":[{m:"Rb1-c1",e:5}],"-1#1017229635":[{m:"Ra8-d8",e:5}],"1#744574755":[{m:"h2-h3",e:5}],"-1#887179773":[{m:"Ng4-f6",e:5}],"1#189338186":[{m:"Qd1-e1",e:5}],"-1#598569578":[{m:"Bf5-d3",e:5}],"1#-943098097":[{m:"Be2xd3",e:5}],"-1#1247416832":[{m:"Rd8xd3",e:5}],"1#-168290844":[],"-1#-1533150409":[{m:"g7-g6",e:9.655},{m:"Nb8-c6",e:9.655},{m:"d7-d5",e:9.655}],"1#-1122781390":[{m:"e2-e4",e:8.571}],"1#470749291":[{m:"g2-g3",e:9.5},{m:"e2-e3",e:9.5},{m:"d2-d3",e:9.5}],"-1#-1214652318":[{m:"g7-g6",e:8.571}],"1#-1374180249":[{m:"Bf1-g2",e:6.667}],"-1#-512573134":[{m:"Bf8-g7",e:8.333}],"1#-279191296":[{m:"O-O",e:9.231}],"-1#-184155916":[{m:"d7-d6",e:9.091}],"1#-1290455341":[{m:"d2-d3",e:8.333}],"-1#-1663608766":[{m:"e7-e5",e:7.5}],"1#-7685994":[{m:"e2-e4",e:5}],"-1#-1186187285":[{m:"e5xf4",e:9.762},{m:"Ng8-e7",e:9.762}],"1#-1629988823":[{m:"g3xf4",e:5}],"-1#481184038":[{m:"Ng8-e7",e:5}],"1#-177873234":[{m:"c2-c3",e:5}],"1#1351065699":[{m:"Nb1-c3",e:9.756},{m:"f4-f5",e:9.756},{m:"c2-c3",e:9.756}],"-1#-1566122908":[{m:"g7-g6",e:8.333}],"1#-1154969503":[{m:"Bf1-b5",e:8}],"-1#1225978067":[{m:"Bf8-g7",e:6.667}],"1#1195102433":[{m:"O-O",e:6.667}],"-1#1566978325":[{m:"d7-d6",e:5}],"1#460654386":[{m:"Bb5xc6+",e:5}],"-1#-288086973":[{m:"b7xc6",e:5}],"1#341303102":[{m:"d2-d3",e:5}],"-1#999666095":[{m:"f7-f5",e:6.667}],"1#-1375784825":[{m:"Nb1-d2",e:5}],"-1#2113927130":[{m:"Ng8-h6",e:5}],"1#-177677947":[{m:"Ra1-b1",e:5}],"-1#74688711":[{m:"O-O",e:5}],"1#-1604033090":[{m:"b2-b3",e:5}],"-1#-1929612795":[{m:"e7-e5",e:5}],"1#-274623791":[{m:"f4xe5",e:5}],"-1#869105402":[{m:"g7-g6",e:5}],"1#709047039":[{m:"g2-g3",e:5}],"-1#-2116697354":[{m:"e7-e6",e:5}],"1#-702305501":[{m:"Bf1-g2",e:5}],"-1#-1723414922":[{m:"Bf8-g7",e:5}],"1#-1754274236":[{m:"O-O",e:6.667}],"-1#-1926101072":[{m:"Ng8-e7",e:5}],"1#1694076984":[{m:"c2-c3",e:5}],"-1#-1969598335":[{m:"O-O",e:5}],"1#781032952":[{m:"e2-e4",e:5}],"-1#1749750405":[{m:"d7-d6",e:9.667},{m:"b7-b6",e:9.667},{m:"d7-d5",e:9.667}],"1#777528482":[{m:"Bc1-e3",e:9.881}],"1#1020118423":[{m:"Bc1-e3",e:9}],"1#1218548342":[{m:"e4-e5",e:8.333}],"1#-2072544316":[],"1#-1863622451":[{m:"Ng1-f3",e:9.836}],"-1#1751662884":[{m:"g7-g6",e:9.783},{m:"d7-d6",e:9.783}],"1#1910902049":[{m:"c2-c4",e:9.697},{m:"b2-b3",e:9.697},{m:"g2-g3",e:9.697}],"-1#-1163835376":[{m:"Bf8-g7",e:5}],"1#-1266128862":[{m:"Nb1-c3",e:5}],"-1#87315764":[{m:"c7-c5",e:5}],"1#1313815126":[{m:"e2-e4",e:5}],"-1#143242539":[{m:"Nb8-c6",e:5}],"1#-1340383625":[{m:"g2-g3",e:5}],"-1#462270078":[{m:"d7-d6",e:5}],"1#1570674777":[{m:"Bf1-g2",e:5}],"-1#318502156":[{m:"Bc8-g4",e:5}],"1#546138889":[{m:"h2-h3",e:5}],"-1#940404183":[{m:"Bg4xf3",e:5}],"1#1774178178":[{m:"Qd1xf3",e:5}],"-1#-282993807":[{m:"Nc6-d4",e:5}],"1#1819586221":[{m:"Qf3-d3",e:5}],"-1#-418868212":[{m:"O-O",e:5}],"1#1126127989":[{m:"O-O",e:5}],"-1#1497544833":[{m:"Ra8-b8",e:5}],"1#125543954":[{m:"Ra1-b1",e:5}],"-1#-161425584":[{m:"Nf6-d7",e:5}],"1#1224438784":[{m:"Kg1-h2",e:5}],"-1#1275570347":[{m:"a7-a6",e:5}],"1#1898672536":[{m:"b2-b3",e:5}],"-1#1572038179":[{m:"b7-b5",e:5}],"1#171602392":[{m:"c4xb5",e:5}],"-1#196553344":[{m:"a6xb5",e:5}],"1#1956883439":[{m:"b3-b4",e:5}],"-1#1409848608":[{m:"c5xb4",e:5}],"1#1814736305":[{m:"Rb1xb4",e:5}],"-1#-664098026":[{m:"Nd7-c5",e:5}],"1#1093208338":[{m:"Qd3-b1",e:5}],"-1#-862574040":[{m:"Nc5-a6",e:5}],"1#-1737265490":[{m:"Rb4-b2",e:5}],"-1#-2026344252":[{m:"b5-b4",e:5}],"1#646709514":[{m:"Nc3-d5",e:5}],"-1#1617999094":[{m:"Nd4-e2",e:5}],"1#95802479":[{m:"Rb2-b3",e:5}],"-1#1887118470":[{m:"Ne2-d4",e:5}],"1#364790815":[],"-1#1568545434":[{m:"Bf8-g7",e:8.571}],"1#1398225576":[{m:"Bc1-b2",e:8.571}],"-1#-630129368":[{m:"Bf8-g7",e:9.5}],"1#-732308198":[{m:"Bf1-g2",e:9.474}],"-1#-1690521521":[{m:"O-O",e:9.524}],"1#1059814710":[{m:"d2-d3",e:9.474}],"-1#283710375":[{m:"d7-d6",e:8},{m:"d7-d5",e:8}],"1#1459234176":[{m:"e2-e4",e:7.5}],"-1#272411389":[{m:"e7-e5",e:8.333},{m:"c7-c6",e:8.333}],"1#1935755817":[{m:"f4xe5",e:6.667},{m:"O-O",e:6.667}],"-1#831378218":[{m:"d6xe5",e:5}],"1#-1447271241":[{m:"O-O",e:5}],"-1#-1277065917":[{m:"Nb8-c6",e:5}],"1#192114207":[{m:"Nb1-c3",e:5}],"-1#1765583837":[{m:"e5xf4",e:5}],"1#1319683103":[{m:"g3xf4",e:5}],"-1#-857811696":[{m:"d6-d5",e:5}],"1#-631050381":[{m:"Nb1-c3",e:5}],"1#416513723":[{m:"O-O",e:5}],"-1#42901327":[{m:"e7-e5",e:5}],"1#1641250715":[{m:"Nb1-c3",e:5}],"-1#-798014835":[{m:"Qd8-e7",e:5}],"1#-1673418427":[{m:"Qd1-e1",e:5}],"-1#-1264203419":[{m:"Nb8-a6",e:5}],"1#-390174793":[{m:"h2-h3",e:5}],"-1#-264347287":[{m:"Nf6-e8",e:5}],"1#1530410940":[{m:"g3-g4",e:5}],"-1#1343791336":[{m:"e5xf4",e:5}],"1#805540692":[],"1#779843331":[{m:"b2-b3",e:8}],"-1#48455864":[{m:"e7-e5",e:5}],"1#1639874668":[{m:"e2-e3",e:5}],"-1#-552121245":[{m:"e5-e4",e:5}],"1#1123453324":[{m:"Nf3-d4",e:5}],"-1#-534182905":[{m:"c7-c5",e:5}],"1#-1420661915":[{m:"Bf1-b5+",e:5}],"-1#1499990999":[{m:"Ke8-e7",e:5}],"1#1565852784":[{m:"Nd4-f3",e:5}],"-1#-7697925":[{m:"e4xf3",e:5}],"1#-317151089":[{m:"Qd1xf3",e:5}],"-1#-456587125":[{m:"a7-a6",e:5}],"1#-639249992":[{m:"Bb5-d3",e:5}],"-1#1863226151":[{m:"Nb8-c6",e:5}],"1#-677611397":[{m:"Bc1-b2",e:5}],"-1#-1009378710":[{m:"Ke7-d7",e:5}],"1#-115727534":[{m:"g2-g4",e:5}],"-1#703187128":[{m:"Kd7-c7",e:5}],"1#-907728839":[{m:"g4-g5",e:5}],"-1#-15457440":[{m:"Nf6-e8",e:5}],"1#1410495925":[{m:"Nb1-c3",e:5}],"-1#-441562973":[{m:"Nc6-b4",e:5}],"1#-187405241":[{m:"Bd3-e4",e:5}],"-1#553964578":[{m:"f7-f5",e:5}],"1#-1217506038":[{m:"Be4-d3",e:5}],"-1#1656679791":[{m:"Nb4xd3+",e:5}],"1#1663984207":[{m:"c2xd3",e:5}],"-1#93251584":[{m:"Bc8-d7",e:5}],"1#-713638909":[{m:"d3-d4",e:5}],"-1#-91362311":[{m:"c5xd4",e:5}],"1#-609864994":[{m:"Nc3-d5+",e:5}],"-1#-1655011550":[{m:"Kc7-b8",e:5}],"1#355153226":[{m:"Ra1-c1",e:5}],"-1#1990214593":[{m:"d4xe3",e:5}],"1#-1959819225":[{m:"Qf3xe3",e:5}],"-1#-1695066077":[{m:"Bd7-c6",e:5}],"1#1539440941":[]};

/***/ }),

/***/ "R7bj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("3j3K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_add_operator_map__ = __webpack_require__("+pb+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_add_operator_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs_add_operator_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_add_operator_filter__ = __webpack_require__("wUn1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_add_operator_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs_add_operator_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__breakpoints_break_point_registry__ = __webpack_require__("eZjk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__match_media__ = __webpack_require__("LuwH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_add_alias__ = __webpack_require__("WeUy");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ObservableMedia; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MediaService; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */






/**
 * Base class for MediaService and pseudo-token for
 */
var ObservableMedia = (function () {
    function ObservableMedia() {
    }
    return ObservableMedia;
}());

/**
 * Class internalizes a MatchMedia service and exposes an Subscribable and Observable interface.

 * This an Observable with that exposes a feature to subscribe to mediaQuery
 * changes and a validator method (`isActive(<alias>)`) to test if a mediaQuery (or alias) is
 * currently active.
 *
 * !! Only mediaChange activations (not de-activations) are announced by the ObservableMedia
 *
 * This class uses the BreakPoint Registry to inject alias information into the raw MediaChange
 * notification. For custom mediaQuery notifications, alias information will not be injected and
 * those fields will be ''.
 *
 * !! This is not an actual Observable. It is a wrapper of an Observable used to publish additional
 * methods like `isActive(<alias>). To access the Observable and use RxJS operators, use
 * `.asObservable()` with syntax like media.asObservable().map(....).
 *
 *  @usage
 *
 *  // RxJS
 *  import 'rxjs/add/operator/filter';
 *  import { ObservableMedia } from '@angular/flex-layout';
 *
 *  @Component({ ... })
 *  export class AppComponent {
 *    status : string = '';
 *
 *    constructor(  media:ObservableMedia ) {
 *      let onChange = (change:MediaChange) => {
 *        this.status = change ? `'${change.mqAlias}' = (${change.mediaQuery})` : "";
 *      };
 *
 *      // Subscribe directly or access observable to use filter/map operators
 *      // e.g.
 *      //      media.subscribe(onChange);
 *
 *      media.asObservable()
 *        .filter((change:MediaChange) => true)   // silly noop filter
 *        .subscribe(onChange);
 *    }
 *  }
 */
var MediaService = (function () {
    function MediaService(mediaWatcher, breakpoints) {
        this.mediaWatcher = mediaWatcher;
        this.breakpoints = breakpoints;
        /**
         * Should we announce gt-<xxx> breakpoint activations ?
         */
        this.filterOverlaps = true;
        this.observable$ = this._buildObservable();
        this._registerBreakPoints();
    }
    /**
     * Test if specified query/alias is active.
     */
    MediaService.prototype.isActive = function (alias) {
        var query = this._toMediaQuery(alias);
        return this.mediaWatcher.isActive(query);
    };
    ;
    /**
     * Proxy to the Observable subscribe method
     */
    MediaService.prototype.subscribe = function (next, error, complete) {
        return this.observable$.subscribe(next, error, complete);
    };
    ;
    /**
     * Access to observable for use with operators like
     * .filter(), .map(), etc.
     */
    MediaService.prototype.asObservable = function () {
        return this.observable$;
    };
    // ************************************************
    // Internal Methods
    // ************************************************
    /**
     * Register all the mediaQueries registered in the BreakPointRegistry
     * This is needed so subscribers can be auto-notified of all standard, registered
     * mediaQuery activations
     */
    MediaService.prototype._registerBreakPoints = function () {
        var _this = this;
        this.breakpoints.items.forEach(function (bp) {
            _this.mediaWatcher.registerQuery(bp.mediaQuery);
            return bp;
        });
    };
    /**
     * Prepare internal observable
     * NOTE: the raw MediaChange events [from MatchMedia] do not contain important alias information
     * these must be injected into the MediaChange
     */
    MediaService.prototype._buildObservable = function () {
        var _this = this;
        var self = this;
        // Only pass/announce activations (not de-activations)
        // Inject associated (if any) alias information into the MediaChange event
        // Exclude mediaQuery activations for overlapping mQs. List bounded mQ ranges only
        var activationsOnly = function (change) {
            return change.matches === true;
        };
        var addAliasInformation = function (change) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_add_alias__["a" /* mergeAlias */])(change, _this._findByQuery(change.mediaQuery));
        };
        var excludeOverlaps = function (change) {
            var bp = _this.breakpoints.findByQuery(change.mediaQuery);
            return !bp ? true : !(self.filterOverlaps && bp.overlapping);
        };
        return this.mediaWatcher.observe()
            .filter(activationsOnly)
            .map(addAliasInformation)
            .filter(excludeOverlaps);
    };
    /**
     * Breakpoint locator by alias
     */
    MediaService.prototype._findByAlias = function (alias) {
        return this.breakpoints.findByAlias(alias);
    };
    /**
     * Breakpoint locator by mediaQuery
     */
    MediaService.prototype._findByQuery = function (query) {
        return this.breakpoints.findByQuery(query);
    };
    ;
    /**
     * Find associated breakpoint (if any)
     */
    MediaService.prototype._toMediaQuery = function (query) {
        var bp = this._findByAlias(query) || this._findByQuery(query);
        return bp ? bp.mediaQuery : query;
    };
    ;
    return MediaService;
}());

MediaService.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
];
/** @nocollapse */
MediaService.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_4__match_media__["a" /* MatchMedia */], },
    { type: __WEBPACK_IMPORTED_MODULE_3__breakpoints_break_point_registry__["a" /* BreakPointRegistry */], },
]; };
//# sourceMappingURL=observable-media.js.map

/***/ }),

/***/ "RA5l":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var QueueAction_1 = __webpack_require__("PutI");
var QueueScheduler_1 = __webpack_require__("C0+T");
/**
 *
 * Queue Scheduler
 *
 * <span class="informal">Put every next task on a queue, instead of executing it immediately</span>
 *
 * `queue` scheduler, when used with delay, behaves the same as {@link async} scheduler.
 *
 * When used without delay, it schedules given task synchronously - executes it right when
 * it is scheduled. However when called recursively, that is when inside the scheduled task,
 * another task is scheduled with queue scheduler, instead of executing immediately as well,
 * that task will be put on a queue and wait for current one to finish.
 *
 * This means that when you execute task with `queue` scheduler, you are sure it will end
 * before any other task scheduled with that scheduler will start.
 *
 * @examples <caption>Schedule recursively first, then do something</caption>
 *
 * Rx.Scheduler.queue.schedule(() => {
 *   Rx.Scheduler.queue.schedule(() => console.log('second')); // will not happen now, but will be put on a queue
 *
 *   console.log('first');
 * });
 *
 * // Logs:
 * // "first"
 * // "second"
 *
 *
 * @example <caption>Reschedule itself recursively</caption>
 *
 * Rx.Scheduler.queue.schedule(function(state) {
 *   if (state !== 0) {
 *     console.log('before', state);
 *     this.schedule(state - 1); // `this` references currently executing Action,
 *                               // which we reschedule with new state
 *     console.log('after', state);
 *   }
 * }, 0, 3);
 *
 * // In scheduler that runs recursively, you would expect:
 * // "before", 3
 * // "before", 2
 * // "before", 1
 * // "after", 1
 * // "after", 2
 * // "after", 3
 *
 * // But with queue it logs:
 * // "before", 3
 * // "after", 3
 * // "before", 2
 * // "after", 2
 * // "before", 1
 * // "after", 1
 *
 *
 * @static true
 * @name queue
 * @owner Scheduler
 */
exports.queue = new QueueScheduler_1.QueueScheduler(QueueAction_1.QueueAction);
//# sourceMappingURL=queue.js.map

/***/ }),

/***/ "RJ4+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__("mmVS");
/* tslint:enable:max-line-length */
/**
 * Emits a given value if the source Observable completes without emitting any
 * `next` value, otherwise mirrors the source Observable.
 *
 * <span class="informal">If the source Observable turns out to be empty, then
 * this operator will emit a default value.</span>
 *
 * <img src="./img/defaultIfEmpty.png" width="100%">
 *
 * `defaultIfEmpty` emits the values emitted by the source Observable or a
 * specified default value if the source Observable is empty (completes without
 * having emitted any `next` value).
 *
 * @example <caption>If no clicks happen in 5 seconds, then emit "no clicks"</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var clicksBeforeFive = clicks.takeUntil(Rx.Observable.interval(5000));
 * var result = clicksBeforeFive.defaultIfEmpty('no clicks');
 * result.subscribe(x => console.log(x));
 *
 * @see {@link empty}
 * @see {@link last}
 *
 * @param {any} [defaultValue=null] The default value used if the source
 * Observable is empty.
 * @return {Observable} An Observable that emits either the specified
 * `defaultValue` if the source Observable emits no items, or the values emitted
 * by the source Observable.
 * @method defaultIfEmpty
 * @owner Observable
 */
function defaultIfEmpty(defaultValue) {
    if (defaultValue === void 0) { defaultValue = null; }
    return this.lift(new DefaultIfEmptyOperator(defaultValue));
}
exports.defaultIfEmpty = defaultIfEmpty;
var DefaultIfEmptyOperator = (function () {
    function DefaultIfEmptyOperator(defaultValue) {
        this.defaultValue = defaultValue;
    }
    DefaultIfEmptyOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new DefaultIfEmptySubscriber(subscriber, this.defaultValue));
    };
    return DefaultIfEmptyOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var DefaultIfEmptySubscriber = (function (_super) {
    __extends(DefaultIfEmptySubscriber, _super);
    function DefaultIfEmptySubscriber(destination, defaultValue) {
        _super.call(this, destination);
        this.defaultValue = defaultValue;
        this.isEmpty = true;
    }
    DefaultIfEmptySubscriber.prototype._next = function (value) {
        this.isEmpty = false;
        this.destination.next(value);
    };
    DefaultIfEmptySubscriber.prototype._complete = function () {
        if (this.isEmpty) {
            this.destination.next(this.defaultValue);
        }
        this.destination.complete();
    };
    return DefaultIfEmptySubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=defaultIfEmpty.js.map

/***/ }),

/***/ "RRVv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Observable_1 = __webpack_require__("rCTf");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var ScalarObservable = (function (_super) {
    __extends(ScalarObservable, _super);
    function ScalarObservable(value, scheduler) {
        _super.call(this);
        this.value = value;
        this.scheduler = scheduler;
        this._isScalar = true;
        if (scheduler) {
            this._isScalar = false;
        }
    }
    ScalarObservable.create = function (value, scheduler) {
        return new ScalarObservable(value, scheduler);
    };
    ScalarObservable.dispatch = function (state) {
        var done = state.done, value = state.value, subscriber = state.subscriber;
        if (done) {
            subscriber.complete();
            return;
        }
        subscriber.next(value);
        if (subscriber.closed) {
            return;
        }
        state.done = true;
        this.schedule(state);
    };
    ScalarObservable.prototype._subscribe = function (subscriber) {
        var value = this.value;
        var scheduler = this.scheduler;
        if (scheduler) {
            return scheduler.schedule(ScalarObservable.dispatch, 0, {
                done: false, value: value, subscriber: subscriber
            });
        }
        else {
            subscriber.next(value);
            if (!subscriber.closed) {
                subscriber.complete();
            }
        }
    };
    return ScalarObservable;
}(Observable_1.Observable));
exports.ScalarObservable = ScalarObservable;
//# sourceMappingURL=ScalarObservable.js.map

/***/ }),

/***/ "RSMh":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Observable_1 = __webpack_require__("rCTf");
var subscribeToResult_1 = __webpack_require__("CURp");
var OuterSubscriber_1 = __webpack_require__("wAkD");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var UsingObservable = (function (_super) {
    __extends(UsingObservable, _super);
    function UsingObservable(resourceFactory, observableFactory) {
        _super.call(this);
        this.resourceFactory = resourceFactory;
        this.observableFactory = observableFactory;
    }
    UsingObservable.create = function (resourceFactory, observableFactory) {
        return new UsingObservable(resourceFactory, observableFactory);
    };
    UsingObservable.prototype._subscribe = function (subscriber) {
        var _a = this, resourceFactory = _a.resourceFactory, observableFactory = _a.observableFactory;
        var resource;
        try {
            resource = resourceFactory();
            return new UsingSubscriber(subscriber, resource, observableFactory);
        }
        catch (err) {
            subscriber.error(err);
        }
    };
    return UsingObservable;
}(Observable_1.Observable));
exports.UsingObservable = UsingObservable;
var UsingSubscriber = (function (_super) {
    __extends(UsingSubscriber, _super);
    function UsingSubscriber(destination, resource, observableFactory) {
        _super.call(this, destination);
        this.resource = resource;
        this.observableFactory = observableFactory;
        destination.add(resource);
        this.tryUse();
    }
    UsingSubscriber.prototype.tryUse = function () {
        try {
            var source = this.observableFactory.call(this, this.resource);
            if (source) {
                this.add(subscribeToResult_1.subscribeToResult(this, source));
            }
        }
        catch (err) {
            this._error(err);
        }
    };
    return UsingSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=UsingObservable.js.map

/***/ }),

/***/ "RSW+":
/***/ (function(module, exports) {

exports.model=Model={Game:{},Board:{},Move:{}},function(){var t;Model.Game.cbConstants={MASK:65535,FLAG_MOVE:65536,FLAG_CAPTURE:131072,FLAG_STOP:262144,FLAG_SCREEN_CAPTURE:524288,FLAG_CAPTURE_KING:1048576,FLAG_CAPTURE_NO_KING:2097152};var e="undefined"!=typeof Int32Array;Model.Game.cbUseTypedArrays=e,Model.Game.cbTypedArray=function(t){if(e){var i=new Int32Array(t.length);return i.set(t),i}for(var r=[],a=t.length,n=0;n<a;n++)r.push(t[n]);return r},Model.Game.cbShortRangeGraph=function(t,e,i,r){var a=this;void 0===r&&(r=196608);for(var n={},s=0;s<t.boardSize;s++)n[s]=[],(!i||s in i)&&e.forEach(function(e){var o=t.Graph(s,e);null!=o&&(!i||o in i)&&n[s].push(a.cbTypedArray([o|r]))});return n},Model.Game.cbLongRangeGraph=function(t,e,i,r,a){var n=this;void 0!==r&&null!=r||(r=196608),a||(a=1/0);for(var s={},o=0;o<t.boardSize;o++)s[o]=[],(!i||o in i)&&e.forEach(function(e){for(var h=[],c=t.Graph(o,e),p=0;null!=c&&(!i||c in i)&&(h.push(c|r),++p!=a);)c=t.Graph(c,e);h.length>0&&s[o].push(n.cbTypedArray(h))});return s},Model.Game.cbNullGraph=function(t){for(var e={},i=0;i<t.boardSize;i++)e[i]=[];return e},Model.Game.cbAuthorGraph=function(t){for(var e={},i=0;i<t.boardSize;i++){e[i]=[];for(var r=0;r<t.boardSize;r++)e[i].push([2293760|r])}return e},Model.Game.cbMergeGraphs=function(t){for(var e=[],i=0;i<t.boardSize;i++){e[i]=[];for(var r=1;r<arguments.length;r++)e[i]=e[i].concat(arguments[r][i])}return e},Model.Game.cbGetThreatGraph=function(){function t(e,i){for(var r in s){var a=s[r];if(!(a.p.length<i.length+1)){for(var n=!0,o=0;o<i.length;o++)if(i[o]!=a.p[o]){n=!1;break}if(n){var h=a.p[i.length],c=e[h];void 0===c&&(c={e:{}},e[h]=c),a.p.length==i.length+1&&(c.t=a.t,c.ts=a.ts,c.tk=a.tk,delete s[r]),i.push(h),t(c.e,i),i.pop()}}}}var e=this;this.cbUseScreenCapture=!1,this.cbUseCaptureKing=!1,this.cbUseCaptureNoKing=!1;for(var i={1:[],"-1":[]},r=[],a=0;a<this.g.boardSize;a++)this.g.pTypes.forEach(function(t,i){t.graph[a].forEach(function(t){for(var n=[],s=0;s<t.length;s++){var o=t[s];1048576&o?(e.cbUseCaptureKing=!0,n.unshift({d:65535&o,a:a,tk:i})):2097152&o?(e.cbUseCaptureNoKing=!0,n.unshift({d:65535&o,a:a,tnk:i})):131072&o?n.unshift({d:65535&o,a:a,t:i}):262144&o?n.unshift({d:65535&o,a:a}):524288&o&&(e.cbUseScreenCapture=!0,n.unshift({d:65535&o,a:a,ts:i}))}n.length>0&&r.push(n)})});var n={};r.forEach(function(t){t.forEach(function(e,i){var r=n[e.d];void 0===r&&(r={},n[e.d]=r);for(var a=[],s=i+1;s<t.length;s++)a.push(t[s].d);a.push(e.a);var o=a.join(","),h=r[o];void 0===h&&(h={p:a,t:{},ts:{},tk:{}},r[o]=h),void 0!==e.t?h.t[e.t]=!0:void 0!==e.tk?h.tk[e.tk]=!0:void 0!==e.ts&&(h.ts[e.ts]=!0)})});for(var a=0;a<e.g.boardSize;a++){var s=n[a],o={};t(o,[]),i[1][a]=o,i[-1][a]=o}return i},Model.Game.InitGame=function(){var e=this;this.cbVar=t=this.cbDefine(),this.g.boardSize=this.cbVar.geometry.boardSize,this.g.pTypes=this.cbGetPieceTypes(),this.g.threatGraph=this.cbGetThreatGraph(),this.g.distGraph=this.cbVar.geometry.GetDistances(),this.cbPiecesCount=0,this.g.castleablePiecesCount={1:0,"-1":0};for(var i in t.pieceTypes){var r=t.pieceTypes[i];if(r.castle){(r.initial||[]).forEach(function(t){e.g.castleablePiecesCount[t.s]++})}r.initial&&(this.cbPiecesCount+=r.initial.length)}for(var a=[],i=0;i<this.cbPiecesCount;i++)a.push(i);var n=Object.keys(t.pieceTypes);this.zobrist=new JocGame.Zobrist({board:{type:"array",size:this.cbVar.geometry.boardSize,values:a},who:{values:["1","-1"]},type:{type:"array",size:this.cbPiecesCount,values:n}})},Model.Game.cbGetPieceTypes=function(){for(var t=[],e={},i=0;i<this.cbVar.geometry.boardSize;i++)e[i]=[];for(var r in this.cbVar.pieceTypes){var a=this.cbVar.pieceTypes[r];t[r]={graph:a.graph||e,abbrev:a.abbrev||"",value:a.isKing?100:a.value||1,isKing:!!a.isKing,castle:!!a.castle,epTarget:!!a.epTarget,epCatch:!!a.epCatch}}return t},Model.Board.Init=function(t){this.zSign=0},Model.Board.InitialPosition=function(i){var r=this;this.board=e?new Int16Array(i.g.boardSize):[];for(var a=0;a<i.g.boardSize;a++)this.board[a]=-1;if(this.kings={},this.pieces=[],this.ending={1:!1,"-1":!1},this.lastMove=null,i.cbVar.castle&&(this.castled={1:!1,"-1":!1}),this.zSign=i.zobrist.update(0,"who",-1),this.noCaptCount=0,this.mWho=1,i.mInitial)this.mWho=i.mInitial.turn||1,i.mInitial.pieces.forEach(function(t){var e={};for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i]);r.pieces.push(e)}),i.mInitial.lastMove&&(this.lastMove={f:i.mInitial.lastMove.f,t:i.mInitial.lastMove.t}),void 0!==i.mInitial.noCaptCount&&(this.noCaptCount=i.mInitial.noCaptCount),i.cbVar.castle&&i.mInitial.castle&&(this.castled={1:{k:!!i.mInitial.castle[1]&&!!i.mInitial.castle[1].k,q:!!i.mInitial.castle[1]&&!!i.mInitial.castle[1].q},"-1":{k:!!i.mInitial.castle[-1]&&!!i.mInitial.castle[-1].k,q:!!i.mInitial.castle[-1]&&!!i.mInitial.castle[-1].q}});else for(var n in i.cbVar.pieceTypes)for(var s=i.cbVar.pieceTypes[n],o=s.initial||[],h=0;h<o.length;h++){var c=o[h],p={s:c.s,t:parseInt(n),p:c.p,m:!1};this.pieces.push(p)}if(this.pieces.sort(function(t,e){if(t.s!=e.s)return e.s-t.s;var r=i.cbVar.pieceTypes[t.t].value||100,a=i.cbVar.pieceTypes[e.t].value||100;return r!=a?r-a:t.p-e.p}),this.pieces.forEach(function(t,e){t.i=e,r.board[t.p]=e,i.g.pTypes[t.t].isKing&&(r.kings[t.s]=t.p),r.zSign=i.zobrist.update(r.zSign,"board",e,t.p),r.zSign=i.zobrist.update(r.zSign,"type",t.t,e)}),i.mInitial&&i.mInitial.enPassant){var a=t.geometry.PosByName(i.mInitial.enPassant);if(a>=0){var l,v=t.geometry.C(a),f=t.geometry.R(a);l=1==i.mInitial.turn?t.geometry.POS(v,f-1):t.geometry.POS(v,f+1),this.epTarget={p:a,i:this.board[l]}}}},Model.Board.CopyFrom=function(t){if(e)this.board=new Int16Array(t.board.length),this.board.set(t.board);else{this.board=[];for(var i=t.board,r=i.length,a=0;a<r;a++)this.board.push(i[a])}this.pieces=[];for(var n=t.pieces.length,a=0;a<n;a++){var s=t.pieces[a];this.pieces.push({s:s.s,p:s.p,t:s.t,i:s.i,m:s.m})}this.kings={1:t.kings[1],"-1":t.kings[-1]},this.check=t.check,t.lastMove?this.lastMove={f:t.lastMove.f,t:t.lastMove.t,c:t.lastMove.c}:this.lastMove=null,this.ending={1:t.ending[1],"-1":t.ending[-1]},void 0!==t.castled&&(this.castled={1:t.castled[1],"-1":t.castled[-1]}),this.noCaptCount=t.noCaptCount,t.epTarget?this.epTarget={p:t.epTarget.p,i:t.epTarget.i}:this.epTarget=null,this.mWho=t.mWho,this.zSign=t.zSign},Model.Board.cbApplyCastle=function(t,e,i){var r=t.cbVar.castle[e.f+"/"+e.cg],a=r.r[r.r.length-1],n=this.pieces[this.board[e.cg]],s=r.k[r.k.length-1],o=this.pieces[this.board[e.f]];return i&&(this.zSign=t.zobrist.update(this.zSign,"board",n.i,e.cg),this.zSign=t.zobrist.update(this.zSign,"board",n.i,a),this.zSign=t.zobrist.update(this.zSign,"board",o.i,e.f),this.zSign=t.zobrist.update(this.zSign,"board",o.i,s)),n.p=a,n.m=!0,this.board[e.cg]=-1,o.p=s,o.m=!0,this.board[e.f]=-1,this.board[a]=n.i,this.board[s]=o.i,this.castled[n.s]=!0,this.kings[o.s]=s,[{i:n.i,f:a,t:-1},{i:o.i,f:s,t:e.f,kp:e.f,who:o.s,m:!1},{i:n.i,f:-1,t:e.cg,m:!1,cg:!1}]},Model.Board.cbQuickApply=function(t,e){if(void 0!==e.cg)return this.cbApplyCastle(t,e,!1);var i=[],r=this.board[e.f],a=this.pieces[r];if(null!=e.c){i.unshift({i:e.c,f:-1,t:this.pieces[e.c].p});var n=this.pieces[e.c];this.board[n.p]=-1,n.p=-1}var s=this.kings[a.s];return t.g.pTypes[a.t].isKing&&(this.kings[a.s]=e.t),i.unshift({i:r,f:e.t,t:e.f,kp:s,who:a.s,ty:a.t}),a.p=e.t,void 0!==e.pr&&(a.t=e.pr),this.board[e.f]=-1,this.board[e.t]=r,i},Model.Board.cbQuickUnapply=function(t,e){for(var i=0;i<e.length;i++){var r=e[i],a=this.pieces[r.i];r.f>=0&&(a.p=-1,this.board[r.f]=-1),r.t>=0&&(a.p=r.t,this.board[r.t]=r.i),void 0!==r.m&&(a.m=r.m),void 0!==r.kp&&(this.kings[r.who]=r.kp),void 0!=r.ty&&(a.t=r.ty),void 0!=r.cg&&(this.castled[a.s]=r.cg)}},Model.Board.ApplyMove=function(t,e){var i=this.pieces[this.board[e.f]];if(void 0!==e.cg)this.cbApplyCastle(t,e,!0);else{if(this.zSign=t.zobrist.update(this.zSign,"board",i.i,e.f),this.board[i.p]=-1,void 0!==e.pr&&(this.zSign=t.zobrist.update(this.zSign,"type",i.t,i.i),i.t=e.pr,this.zSign=t.zobrist.update(this.zSign,"type",i.t,i.i)),null!=e.c){var r=this.pieces[e.c];this.zSign=t.zobrist.update(this.zSign,"board",r.i,r.p),this.board[r.p]=-1,r.p=-1,r.m=!0,this.noCaptCount=0}else this.noCaptCount++;i.p=e.t,i.m=!0,this.board[e.t]=i.i,this.zSign=t.zobrist.update(this.zSign,"board",i.i,e.t),t.g.pTypes[i.t].isKing&&(this.kings[i.s]=e.t)}this.check=!!e.ck,this.lastMove={f:e.f,t:e.t,c:e.c},void 0!==e.ko&&(this.ending[i.s]=e.ko),void 0!==e.ept?this.epTarget={p:e.ept,i:i.i}:this.epTarget=null,this.zSign=t.zobrist.update(this.zSign,"who",-this.mWho),this.zSign=t.zobrist.update(this.zSign,"who",this.mWho)},Model.Board.Evaluate=function(i){function r(e){var i=1/0;for(var r in t.geometry.corners)i=Math.min(i,h.distGraph[n.kings[e]][r]);return i-Math.sqrt(h.boardSize)}var a="debug"==arguments[3],n=this;this.mEvaluation=0;var s,o=this.mWho,h=i.g;if(e)s={1:{count:new Uint8Array(h.pTypes.length),byType:{}},"-1":{count:new Uint8Array(h.pTypes.length),byType:{}}};else{s={1:{count:[],byType:{}},"-1":{count:[],byType:{}}};for(var c=0;c<h.pTypes.length;c++)s[1].count[c]=s[-1].count[c]=0}if(i.mOptions.preventRepeat&&i.GetRepeatOccurence(this)>2)return this.mFinished=!0,void(this.mWinner=i.cbOnPerpetual?o*i.cbOnPerpetual:JocGame.DRAW);for(var p={1:0,"-1":0},l={1:h.distGraph[this.kings[-1]],"-1":h.distGraph[this.kings[1]]},v={1:0,"-1":0},f={1:0,"-1":0},u={1:0,"-1":0},g={1:0,"-1":0},b={1:!1,"-1":!1},d=this.pieces,m=d.length,c=0;c<m;c++){var G=d[c];if(G.p>=0){var y=G.s,M=h.pTypes[G.t];M.isKing?b[y]=G.m:p[y]+=M.value,M.castle&&!G.m&&g[y]++,f[y]++,v[y]+=l[y][G.p],u[y]+=t.geometry.distEdge[G.p];var k=s[y];k.count[G.t]++;var S=k.byType;void 0===S[G.t]?S[G.t]=[G]:S[G.t].push(G)}}if(this.lastMove&&null!=this.lastMove.c){var G=this.pieces[this.board[this.lastMove.t]];p[-G.s]+=this.cbStaticExchangeEval(i,G.p,G.s,{piece:G})}var C={1:0,"-1":0},T={1:0,"-1":0},z={1:0,"-1":0};this.ending[1]&&(T[1]=(v[1]-Math.sqrt(h.boardSize))/f[1],t.geometry.corners&&(z[1]=r(1))),this.ending[-1]&&(T[-1]=(v[-1]-Math.sqrt(h.boardSize))/f[-1],t.geometry.corners&&(z[1]=r(-1)));var A={pieceValue:p[1]-p[-1],pieceValueRatio:(p[1]-p[-1])/(p[1]+p[-1]+1),posValue:u[1]-u[-1],averageDistKing:v[1]/f[1]-v[-1]/f[-1],check:this.check?-o:0,endingKingFreedom:C[1]-C[-1],endingDistKing:T[1]-T[-1],distKingCorner:z[1]-z[-1]};t.castle&&(A.castle=(this.castled[1]?1:b[1]?0:g[1]/(h.castleablePiecesCount[1]+1))-(this.castled[-1]?1:b[-1]?0:g[-1]/(h.castleablePiecesCount[-1]+1))),t.evaluate&&t.evaluate.call(this,i,A,s);var P=i.mOptions.levelOptions;for(var E in A){var R=A[E],w=P[E+"Factor"]||0,I=R*w;a&&console.log(E,"=",R,"*",w,"=>",I),this.mEvaluation+=I}a&&console.log("Evaluation",this.mEvaluation)},Model.Board.cbGeneratePseudoLegalMoves=function(t){function e(e,a){var n=t.cbVar.promote;if(!n)return void r.push(a);var s=n.call(i,t,e,a);if(null!=s)if(0==s.length)r.push(a);else if(1==s.length)a.pr=s[0],r.push(a);else for(var o=0;o<s.length;o++){var h=s[o];r.push({f:a.f,t:a.t,c:a.c,pr:h,ept:a.ept,ep:a.ep,a:a.a})}}for(var i=this,r=[],a=t.cbVar,n=this.mWho,s=!a.castle||this.check||this.castled[n]?null:[],o=-1,h=this.pieces.length,c=0;c<h;c++){var p=this.pieces[c];if(!(p.p<0||p.s!=n)){var l=t.g.pTypes[p.t];l.isKing&&(p.m?s=null:o=p),s&&l.castle&&!p.m&&s.push(p);var v,f;v=l.graph[p.p],f=v.length;for(var u=0;u<f;u++)for(var g=v[u],b=!1,d=g.length,m=null,G=0;G<d;G++){var y=g[G],M=65535&y,k=this.board[M];if(!(k<0)||l.epCatch&&this.epTarget&&this.epTarget.p==M){if(!(524288&y)){var S;S=k<0?this.pieces[this.epTarget.i]:this.pieces[k],!(S.s!=p.s&&131072&y)||1048576&y&&!t.g.pTypes[S.t].isKing||2097152&y&&t.g.pTypes[S.t].isKing||e(p,{f:p.p,t:M,c:S.i,a:l.abbrev,ep:k<0});break}if(b){var S=this.pieces[k];S.s!=p.s&&e(p,{f:p.p,t:M,c:S.i,a:l.abbrev});break}b=!0}else 65536&y&&0==b&&e(p,{f:p.p,t:M,c:null,a:l.abbrev,ept:null!=m&&l.epTarget?m:void 0});m=M}}}if(s)for(var c=0;c<s.length;c++){var C=s[c],T=t.cbVar.castle[o.p+"/"+C.p];if(T){for(var z=!0,u=0;u<T.r.length;u++){var A=T.r[u];if(this.board[A]>=0&&A!=o.p&&A!=C.p){z=!1;break}}if(z){for(var P=!0,u=0;u<T.k.length;u++){var A=T.k[u];if(this.board[A]>=0&&A!=C.p&&A!=o.p||this.cbGetAttackers(t,A,n).length>0){P=!1;break}}P&&r.push({f:o.p,t:T.k[T.k.length-1],c:null,cg:C.p})}}}return r},Model.Board.cbStaticExchangeEval=function(t,e,i,r){var a=0,n=this.cbGetSmallestAttacker(t,e,i);if(n){var s=this.mWho;this.mWho=n.s;var o=this.cbQuickApply(t,{f:n.p,t:e,c:r.piece.i}),h=t.g.pTypes[r.piece.t].value;r.piece=n,a=Math.max(0,h-this.cbStaticExchangeEval(t,e,-i,r)),this.cbQuickUnapply(t,o),this.mWho=s}return a},Model.Board.cbGetSmallestAttacker=function(t,e,i){var r=this.cbGetAttackers(t,e,i);if(0==r.length)return null;for(var a=1/0,n=null,s=r.length,o=0;o<s;o++){var h=r[o],c=t.g.pTypes[h.t].value;c<a&&(a=c,n=h)}return n},Model.Board.cbCollectAttackers=function(t,e,i,r){for(var a in e){var n=e[a],s=this.board[a];if(s<0)this.cbCollectAttackers(t,n.e,i,r);else{var o=this.pieces[s];o.s==-t&&(n.t&&o.t in n.t||r&&n.tk&&o.t in n.tk)&&i.push(o)}}},Model.Board.cbCollectAttackersScreen=function(t,e,i,r,a){for(var n in e){var s=e[n],o=this.board[n];if(o<0)this.cbCollectAttackersScreen(t,s.e,i,r,a);else{var h=this.pieces[o];!a&&h.s==-t&&(s.t&&h.t in s.t||r&&s.tk&&h.t in s.tk)?i.push(h):a?a&&h.s==-t&&s.ts&&h.t in s.ts&&i.push(h):this.cbCollectAttackersScreen(t,s.e,i,r,!0)}}},Model.Board.cbGetAttackers=function(t,e,i,r){var a=[];return t.cbUseScreenCapture?this.cbCollectAttackersScreen(i,t.g.threatGraph[i][e],a,r,!1):this.cbCollectAttackers(i,t.g.threatGraph[i][e],a,r),a},Model.Board.GenerateMoves=function(t){var e=this.cbGeneratePseudoLegalMoves(t);this.mMoves=[];for(var i=!0,r=this.kings[this.mWho],a=e.length,n=0;n<a;n++){var s=e[n],o=this.cbQuickApply(t,s);if(!(this.cbGetAttackers(t,this.kings[this.mWho],this.mWho,!0).length>0)){var h=this.cbGetAttackers(t,this.kings[-this.mWho],-this.mWho,!0).length>0;s.ck=h,this.mMoves.push(s),s.f!=r&&(i=!1)}this.cbQuickUnapply(t,o)}if(0==this.mMoves.length)this.mFinished=!0,this.mWinner=t.cbOnStaleMate?t.cbOnStaleMate*this.mWho:JocGame.DRAW,this.check&&(this.mWinner=-this.mWho);else if(this.ending[this.mWho]){if(!i)for(var n=0;n<this.mMoves.length;n++)this.mMoves[n].ko=!1}else if(!this.ending[this.mWho]&&i&&!this.check)for(var n=0;n<this.mMoves.length;n++)this.mMoves[n].ko=!0},Model.Board.GetSignature=function(){return this.zSign},Model.Move.Init=function(t){for(var e in t)t.hasOwnProperty(e)&&(this[e]=t[e])},Model.Move.Equals=function(t){return this.f==t.f&&this.t==t.t&&this.pr==t.pr},Model.Move.CopyFrom=function(t){this.Init(t)},Model.Move.ToString=function(e){var i=this;switch(e=e||"natural"){case"natural":return function(){var e;if(void 0!==i.cg?e=t.castle[i.f+"/"+i.cg].n:(e=i.a||"",e+=t.geometry.PosName(i.f),null==i.c?e+="-":e+="x",e+=t.geometry.PosName(i.t)),void 0!==i.pr){var r=t.pieceTypes[i.pr];r&&r.abbrev&&r.abbrev.length>0&&!r.silentPromo&&(e+="="+r.abbrev)}return i.ck&&(e+="+"),e}();case"engine":return function(){var e=t.geometry.PosName(i.f)+t.geometry.PosName(i.t);if(void 0!=i.pr){var r=t.pieceTypes[i.pr];r&&r.abbrev&&r.abbrev.length>0&&!r.silentPromo&&(e+=r.abbrev)}return e}();default:return"??"}},Model.Board.CompactMoveString=function(e,i,r){"function"!=typeof i.ToString&&(i=e.CreateMove(i));var a=i.ToString(),n=/^([A-Z]?)([a-z])([1-9][0-9]*)([-x])([a-z])([1-9][0-9]*)(.*?)$/.exec(a);if(!n)return a;var s=n[7];if(r||(r={}),r.value||(r.value=[]),0==r.value.length){var o=this.mMoves;this.mMoves&&0!=this.mMoves.length||this.GenerateMoves(e);for(var h=0;h<this.mMoves.length;h++){var c=this.mMoves[h];"function"!=typeof c.ToString&&(c=e.CreateMove(c)),r.value.push({str:c.ToString(),move:c})}this.mMoves=o}var p=[];if(r.value.forEach(function(t){var e=/^([A-Z]?[a-z][1-9][0-9]*[-x][a-z][1-9][0-9]*)(.*?)$/.exec(t.str);e&&t.move.t==i.t&&(t.move.a||"")==n[1]&&e[2]==s&&p.push(t.move)}),1==p.length)return""==n[1]&&"x"==n[4]?n[2]+"x"+n[5]+n[6]+n[7]:n[1]+("x"==n[4]?"x":"")+n[5]+n[6]+n[7];if(t.geometry.CompactCrit)for(var l="",h=0;;h++){var v=t.geometry.CompactCrit(i.f,h);if(null==v)return a;l+=v;for(var f=[],u=0;u<p.length;u++){var g=p[u];t.geometry.CompactCrit(g.f,h)==v&&f.push(g)}if(console.assert(f.length>0),1==f.length)return n[1]+l+("x"==n[4]?"x":"")+n[5]+n[6]+n[7];p=f}return a},Model.Board.cbIntegrity=function(t){function e(t,e){t||console.error(e)}for(var i=this,r=0;r<this.board.length;r++){var a=this.board[r];if(a>=0){var n=i.pieces[a];e(void 0!==n,"no piece at pos"),e(n.p==r,"piece has different pos")}}for(var a=0;a<this.pieces.length;a++){var n=this.pieces[a];n.p>=0&&e(i.board[n.p]==a,"board index mismatch")}},Model.Board.ExportBoardState=function(t){return t.cbVar.geometry.ExportBoardState?t.cbVar.geometry.ExportBoardState(this,t.cbVar,t.mPlayedMoves.length):"not supported"},Model.Game.Import=function(e,i){var r,a=[],n={1:{},"-1":{}},s=null,o=0;if("pjn"==e){var h={status:!1,error:"parse"},c=i.split(" ");if(6!=c.length)return console.warn("FEN should have 6 parts"),h;var p=c[0].split("/"),l=t.geometry.fenHeight||t.geometry.height;if(p.length!=l)return console.warn("FEN board should have",l,"rows, got",p.length),h;var v={};for(var f in t.pieceTypes){var u=t.pieceTypes[f],g=u.fenAbbrev||u.abbrev||"X";v[g.toUpperCase()]={s:1,t:f},v[g.toLowerCase()]={s:-1,t:f}}var b=t.geometry.FenRowPos||function(e,i){return(t.geometry.height-1-e)*t.geometry.width+i};if(p.forEach(function(e,i){for(var r=0,n=0;n<e.length;n++){var s=e.substr(n,1),o=v[s];if(void 0!==o){var c=b(i,r);r++;for(var p={s:o.s,t:o.t,p:c},l=!0,f=t.pieceTypes[p.t].initial||[],u=0;u<f.length;u++){var g=f[u];g.s==p.s&&g.p==c&&(l=!1)}p.m=l,a.push(p)}else{if(isNaN(parseInt(s)))return console.warn("FEN invalid board spec",s),h;r+=parseInt(s)}}}),a.sort(function(t,e){return e.s-t.s}),"w"==c[1])r=1;else{if("b"!=c[1])return console.warn("FEN invalid turn spec",c[1]),h;r=-1}n[1].k=c[2].indexOf("K")>=0,n[1].q=c[2].indexOf("Q")>=0,n[-1].k=c[2].indexOf("k")>=0,n[-1].q=c[2].indexOf("q")>=0,s="-"==c[3]?null:c[3];var d=parseInt(c[4]);isNaN(d)||(o=d);var m={pieces:a,turn:r,castle:n,enPassant:s,noCaptCount:o};return t.importGame&&t.importGame.call(this,m,e,i),{status:!0,initial:m}}return{status:!1,error:"unsupported"}}}(),function(){Model.Game.cbBoardGeometryHex=function(t,e){function i(t,e){for(var i=r(t),s=a(t),o=i,h=s,c=0;c<3;c++)for(var p=Math.abs(e[c]),l=0==p?0:e[c]/p,g=0;g<p;g++)h%2==v?(1==c&&l<0&&o--,2==c&&l>0&&o--):(1==c&&l>0&&o++,2==c&&l<0&&o++),1!=c&&2!=c||(h+=l),0==c&&(o+=l);if(o<0||o>=u||h<0||h>=f)return null;var t=n(o,h);return t in d?t:null}function r(t){return t%u}function a(t){return Math.floor(t/u)}function n(t,e){return e*u+t}function s(t){return void 0!==e[t]?e[t]:String.fromCharCode("a".charCodeAt(0)+r(t))+(a(t)+1)}function o(t){if(void 0!==l[t])return l[t];var e=/^([a-z])([0-9]+)$/.exec(t);return e?n(e[1].charCodeAt(0)-"a".charCodeAt(0),parseInt(e[2])-1):-1}function h(t,e){return 0==e?String.fromCharCode("a".charCodeAt(0)+r(t)):1==e?a(t)+1:null}function c(){return G}function p(e,i){var r=t[t.length-1-i][2*e];return" "==r&&(r=t[t.length-1-i][2*e+1]||" "),r}var l={};if(e)for(y in e)l[e[y]]=y;else e={};for(var v,f=t.length,u=0,g=!1,b=0,d={},m=0;m<t.length;m++)t[m].length%2==1&&t[m],t[m].length>b&&(b=t[m].length);for(var m=0;m<t.length;m++)for(;t[m].length<b;)t[m]+=" ";t.forEach(function(t,e){" "!=t[0]&&(v=e%2);var i=Math.ceil(t.length/2);i>u&&(u=i)}),t.forEach(function(e,i){(t.length-1-i)%2==1-v&&(" "==e[e.length-1]&&" "==e[e.length-2]||(g=!0));for(var r=0;r<e.length;r+=2)if(" "!=e[r]||r+1<e.length&&" "!=e[r+1]){var a=i*u+r/2;d[a]=1}});var G={};for(var y in d)G[y]={},G[y][y]=0;for(var M=[[1,0,0],[0,1,0],[0,0,1],[-1,0,0],[0,-1,0],[0,0,-1]],k=!0;k;){k=!1;for(var y in d)M.forEach(function(t){var e=i(y,t);if(null!=e){1!=G[y][e]&&(G[y][e]=1,G[e][y]=1,k=!0);for(var r in d)r!=y&&(void 0===G[e][r]&&void 0!==G[y][r]?(G[e][r]=G[y][r]+1,G[r][e]=G[y][r]+1,k=!0):void 0!==G[e][r]&&void 0!==G[y][r]&&G[e][r]>G[y][r]+1&&(G[e][r]=G[y][r]+1,G[r][e]=G[y][r]+1,k=!0))}})}var S=0,C={};for(var y in d){var T=0;for(var z in d){var A=G[y][z];T+=A*A}T>S?(C={},C[y]=1,S=T):T==S&&(C[y]=1)}for(var P={},k=!0;k;){k=!1;for(var y in d)y in P||M.forEach(function(t){var e=i(y,t);null==e?P[y]=1:e in P&&(y in P&&!(P[y]>P[e]+1)||(P[y]=P[e]+1,k=!0))})}return{boardSize:u*f,width:u,height:f,C:r,R:a,POS:n,Graph:i,PosName:s,PosByName:o,CompactCrit:h,GetDistances:c,distEdge:P,corners:C,SHIFTMOD2:v,SHIFTRIGHT:g,CellType:p,confine:d}};var t=Model.Game.cbConstants,e=[[1,0,0],[0,1,0],[0,0,1],[-1,0,0],[0,-1,0],[0,0,-1]],i=[[1,1,0],[0,1,1],[-1,0,1],[-1,-1,0],[0,-1,-1],[1,0,-1]],r=[[2,1,0],[1,2,0],[0,2,1],[0,1,2],[-1,0,2],[-2,0,1],[-2,-1,0],[-1,-2,0],[0,-2,-1],[0,-1,-2],[1,0,-2],[2,0,-1]];Model.Game.cbGLKingGraph=function(t){return this.cbShortRangeGraph(t,i.concat(e),t.confine)},Model.Game.cbGLRookGraph=function(t){return this.cbLongRangeGraph(t,e,t.confine)},Model.Game.cbGLBishopGraph=function(t){return this.cbLongRangeGraph(t,i,t.confine)},Model.Game.cbGLQueenGraph=function(t){return this.cbLongRangeGraph(t,i.concat(e),t.confine)},Model.Game.cbGLKnightGraph=function(t){return this.cbShortRangeGraph(t,r,t.confine)},Model.Game.cbGLPawnGraph=function(e,i,r){for(var a=this.cbLongRangeGraph(e,[[i,0,0]],e.confine,t.FLAG_MOVE,r),n={1:[[0,1,0],[0,0,-1]],"-1":[[0,0,1],[0,-1,0]]},s=this.cbShortRangeGraph(e,n[i],e.confine,t.FLAG_CAPTURE),o=[],h=0;h<e.boardSize;h++)o[h]=a[h].concat(s[h]);return o},Model.Game.cbBRInitialPawnGraph=function(e,i){for(var r=this.cbLongRangeGraph(e,[[0,-i,0],[0,0,-i]],e.confine,t.FLAG_MOVE,2),a=this.cbShortRangeGraph(e,[[-i,-i,0],[i,0,-i],[0,-i,-i]],e.confine,t.FLAG_CAPTURE),n=[],s=0;s<e.boardSize;s++)n[s]=r[s].concat(a[s]);return n},Model.Game.cbDVInitialPawnGraph=function(e,i){for(var r=this.cbLongRangeGraph(e,[[0,-i,0],[0,0,-i]],e.confine,t.FLAG_MOVE,2),a=this.cbShortRangeGraph(e,[[-i,-i,0],[i,0,-i]],e.confine,t.FLAG_CAPTURE),n=[],s=0;s<e.boardSize;s++)n[s]=r[s].concat(a[s]);return n},Model.Game.cbBRPawnGraph=function(e,i){for(var r=this.cbShortRangeGraph(e,[[0,-i,0],[0,0,-i]],e.confine,t.FLAG_MOVE),a=this.cbShortRangeGraph(e,[[-i,-i,0],[i,0,-i]],e.confine,t.FLAG_CAPTURE),n=[],s=0;s<e.boardSize;s++)n[s]=r[s].concat(a[s]);return n},Model.Game.cbMCPawnGraph=function(e,i,r){for(var a=this.cbLongRangeGraph(e,[[i,0,0]],e.confine,t.FLAG_MOVE,r),n=this.cbShortRangeGraph(e,[[i,0,-i],[i,i,0]],e.confine,t.FLAG_CAPTURE),s=[],o=0;o<e.boardSize;o++)s[o]=a[o].concat(n[o]);return s}}(),function(){var t={93:"a1",94:"b1",95:"c1",96:"d1",97:"e1",98:"f1",99:"g1",100:"h1",101:"i1",79:"a2",80:"b2",81:"c2",82:"d2",83:"e2",84:"f2",85:"g2",86:"h2",87:"i2",88:"j2",66:"a3",67:"b3",68:"c3",69:"d3",70:"e3",71:"f3",72:"g3",73:"h3",74:"i3",75:"j3",76:"k3",52:"a4",53:"b4",54:"c4",55:"d4",56:"e4",57:"f4",58:"g4",59:"h4",60:"i4",61:"j4",62:"k4",63:"l4",39:"a5",40:"b5",41:"c5",42:"d5",43:"e5",44:"f5",45:"g5",46:"h5",47:"i5",48:"j5",49:"k5",50:"l5",26:"b6",27:"c6",28:"d6",29:"e6",30:"f6",31:"g6",32:"h6",33:"i6",34:"j6",35:"k6",36:"l6",14:"c7",15:"d7",16:"e7",17:"f7",18:"g7",19:"h7",20:"i7",21:"j7",22:"k7",23:"l7",1:"d8",2:"e8",3:"f8",4:"g8",5:"h8",6:"i8",7:"j8",8:"k8",9:"l8"},e=Model.Game.cbBoardGeometryHex(["   # . + # . + # . +     ","  . + # . + # . + # .    "," + # . + # . + # . + #   ","# . + # . + # . + # . +  "," + # . + # . + # . + # . ","  . + # . + # . + # . +  ","   # . + # . + # . + #   ","    + # . + # . + # .    "],t),i={1:{1:1,2:1,3:1,4:1,5:1,6:1,7:1,8:1,9:1},"-1":{93:1,94:1,95:1,96:1,97:1,98:1,99:1,100:1,101:1}},r={1:{},"-1":{}},a=e.GetDistances();["1","-1"].forEach(function(t){for(var n in e.confine){var s=1/0;for(var o in i[t]){var h=a[n][o];h<s&&(r[t][n]=h,s=h)}}}),Model.Game.cbDefine=function(){return{geometry:e,pieceTypes:{0:{name:"pawn-w",aspect:"pawn",graph:this.cbBRPawnGraph(e,1,1),value:1,abbrev:"",fenAbbrev:"P",epCatch:!0},1:{name:"ipawn-w",aspect:"pawn",graph:this.cbBRInitialPawnGraph(e,1),value:1,abbrev:"",fenAbbrev:"P",initial:[{s:1,p:79},{s:1,p:80},{s:1,p:81},{s:1,p:82},{s:1,p:83},{s:1,p:84},{s:1,p:85},{s:1,p:86},{s:1,p:87},{s:1,p:88}],epTarget:!0},2:{name:"pawn-b",aspect:"pawn",graph:this.cbBRPawnGraph(e,-1,1),value:1,abbrev:"",fenAbbrev:"P",epCatch:!0},3:{name:"ipawn-b",aspect:"pawn",graph:this.cbBRInitialPawnGraph(e,-1),value:1,abbrev:"",fenAbbrev:"P",initial:[{s:-1,p:14},{s:-1,p:15},{s:-1,p:16},{s:-1,p:17},{s:-1,p:18},{s:-1,p:19},{s:-1,p:20},{s:-1,p:21},{s:-1,p:22},{s:-1,p:23}],epTarget:!0},4:{name:"knight",graph:this.cbGLKnightGraph(e),value:2.9,abbrev:"N",initial:[{s:1,p:94},{s:1,p:100},{s:-1,p:2},{s:-1,p:8}]},5:{name:"bishop",graph:this.cbGLBishopGraph(e),value:3.1,abbrev:"B",initial:[{s:1,p:95},{s:1,p:97},{s:1,p:99},{s:-1,p:3},{s:-1,p:5},{s:-1,p:7}]},6:{name:"rook",graph:this.cbGLRookGraph(e),value:5,abbrev:"R",initial:[{s:1,p:93},{s:1,p:101},{s:-1,p:1},{s:-1,p:9}],castle:!0},7:{name:"queen",graph:this.cbGLQueenGraph(e),value:9,abbrev:"Q",initial:[{s:1,p:96},{s:-1,p:6}]},8:{name:"king",isKing:!0,graph:this.cbGLKingGraph(e),abbrev:"K",initial:[{s:1,p:98},{s:-1,p:4}]}},promote:function(t,i,r){return 1==i.t?[0]:3==i.t?[2]:0==i.t&&7==e.R(r.t)?[4,5,6,7]:2==i.t&&0==e.R(r.t)?[4,5,6,7]:[]},castle:{"98/93":{k:[97,96],r:[94,95,96,97],n:"O-O-O"},"98/101":{k:[99,100],r:[100,99],n:"O-O"},"4/9":{k:[5,6],r:[8,7,6,5],n:"O-O-O"},"4/1":{k:[3,2],r:[2,3],n:"O-O"}},evaluate:function(t,e,i){var a=i[1].count,n=i[-1].count;a[0]||a[1]||a[4]||a[5]||a[6]||a[7]||n[2]||n[3]||n[6]||n[7]||!(n[4]+n[5]<2||n[5]<2)||(this.mFinished=!0,this.mWinner=JocGame.DRAW),n[2]||n[3]||n[4]||n[5]||n[6]||n[7]||a[0]||a[1]||a[6]||a[7]||!(a[4]+a[5]<2||a[5]<2)||(this.mFinished=!0,this.mWinner=JocGame.DRAW),this.noCaptCount>=100&&(this.mFinished=!0,this.mWinner=JocGame.DRAW);var s,o=t.cbUseTypedArrays?new Int8Array(3):[0,0,0],h=i[1].byType[0];if(h){s=h.length;for(var c=0;c<s;c++){var p=r[1][h[c].p];p>0&&p<4&&o[p-1]++}}if(h=i[-1].byType[2]){s=h.length;for(var c=0;c<s;c++){var p=r[-1][h[c].p];p>0&&p<4&&o[p-1]--}}0!=o[0]&&(e.distPawnPromo1=o[0]),0!=o[1]&&(e.distPawnPromo2=o[1]),0!=o[2]&&(e.distPawnPromo3=o[2]);for(var l=0,v=4;v<=5;v++)for(var f=1;f>=-1;f-=2){var u=i[f].byType[v];if(u)for(var c=0;c<u.length;c++)u[c].m&&(l+=f)}0!=l&&(e.minorPiecesMoved=l)}}}}();

/***/ }),

/***/ "RYQg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var ArrayObservable_1 = __webpack_require__("Yh8Q");
var isArray_1 = __webpack_require__("Xajo");
var Subscriber_1 = __webpack_require__("mmVS");
var OuterSubscriber_1 = __webpack_require__("wAkD");
var subscribeToResult_1 = __webpack_require__("CURp");
var iterator_1 = __webpack_require__("cdmN");
/* tslint:enable:max-line-length */
/**
 * @param observables
 * @return {Observable<R>}
 * @method zip
 * @owner Observable
 */
function zipProto() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i - 0] = arguments[_i];
    }
    return this.lift.call(zipStatic.apply(void 0, [this].concat(observables)));
}
exports.zipProto = zipProto;
/* tslint:enable:max-line-length */
/**
 * Combines multiple Observables to create an Observable whose values are calculated from the values, in order, of each
 * of its input Observables.
 *
 * If the latest parameter is a function, this function is used to compute the created value from the input values.
 * Otherwise, an array of the input values is returned.
 *
 * @example <caption>Combine age and name from different sources</caption>
 *
 * let age$ = Observable.of<number>(27, 25, 29);
 * let name$ = Observable.of<string>('Foo', 'Bar', 'Beer');
 * let isDev$ = Observable.of<boolean>(true, true, false);
 *
 * Observable
 *     .zip(age$,
 *          name$,
 *          isDev$,
 *          (age: number, name: string, isDev: boolean) => ({ age, name, isDev }))
 *     .subscribe(x => console.log(x));
 *
 * // outputs
 * // { age: 27, name: 'Foo', isDev: true }
 * // { age: 25, name: 'Bar', isDev: true }
 * // { age: 29, name: 'Beer', isDev: false }
 *
 * @param observables
 * @return {Observable<R>}
 * @static true
 * @name zip
 * @owner Observable
 */
function zipStatic() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i - 0] = arguments[_i];
    }
    var project = observables[observables.length - 1];
    if (typeof project === 'function') {
        observables.pop();
    }
    return new ArrayObservable_1.ArrayObservable(observables).lift(new ZipOperator(project));
}
exports.zipStatic = zipStatic;
var ZipOperator = (function () {
    function ZipOperator(project) {
        this.project = project;
    }
    ZipOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new ZipSubscriber(subscriber, this.project));
    };
    return ZipOperator;
}());
exports.ZipOperator = ZipOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var ZipSubscriber = (function (_super) {
    __extends(ZipSubscriber, _super);
    function ZipSubscriber(destination, project, values) {
        if (values === void 0) { values = Object.create(null); }
        _super.call(this, destination);
        this.iterators = [];
        this.active = 0;
        this.project = (typeof project === 'function') ? project : null;
        this.values = values;
    }
    ZipSubscriber.prototype._next = function (value) {
        var iterators = this.iterators;
        if (isArray_1.isArray(value)) {
            iterators.push(new StaticArrayIterator(value));
        }
        else if (typeof value[iterator_1.iterator] === 'function') {
            iterators.push(new StaticIterator(value[iterator_1.iterator]()));
        }
        else {
            iterators.push(new ZipBufferIterator(this.destination, this, value));
        }
    };
    ZipSubscriber.prototype._complete = function () {
        var iterators = this.iterators;
        var len = iterators.length;
        if (len === 0) {
            this.destination.complete();
            return;
        }
        this.active = len;
        for (var i = 0; i < len; i++) {
            var iterator = iterators[i];
            if (iterator.stillUnsubscribed) {
                this.add(iterator.subscribe(iterator, i));
            }
            else {
                this.active--; // not an observable
            }
        }
    };
    ZipSubscriber.prototype.notifyInactive = function () {
        this.active--;
        if (this.active === 0) {
            this.destination.complete();
        }
    };
    ZipSubscriber.prototype.checkIterators = function () {
        var iterators = this.iterators;
        var len = iterators.length;
        var destination = this.destination;
        // abort if not all of them have values
        for (var i = 0; i < len; i++) {
            var iterator = iterators[i];
            if (typeof iterator.hasValue === 'function' && !iterator.hasValue()) {
                return;
            }
        }
        var shouldComplete = false;
        var args = [];
        for (var i = 0; i < len; i++) {
            var iterator = iterators[i];
            var result = iterator.next();
            // check to see if it's completed now that you've gotten
            // the next value.
            if (iterator.hasCompleted()) {
                shouldComplete = true;
            }
            if (result.done) {
                destination.complete();
                return;
            }
            args.push(result.value);
        }
        if (this.project) {
            this._tryProject(args);
        }
        else {
            destination.next(args);
        }
        if (shouldComplete) {
            destination.complete();
        }
    };
    ZipSubscriber.prototype._tryProject = function (args) {
        var result;
        try {
            result = this.project.apply(this, args);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return ZipSubscriber;
}(Subscriber_1.Subscriber));
exports.ZipSubscriber = ZipSubscriber;
var StaticIterator = (function () {
    function StaticIterator(iterator) {
        this.iterator = iterator;
        this.nextResult = iterator.next();
    }
    StaticIterator.prototype.hasValue = function () {
        return true;
    };
    StaticIterator.prototype.next = function () {
        var result = this.nextResult;
        this.nextResult = this.iterator.next();
        return result;
    };
    StaticIterator.prototype.hasCompleted = function () {
        var nextResult = this.nextResult;
        return nextResult && nextResult.done;
    };
    return StaticIterator;
}());
var StaticArrayIterator = (function () {
    function StaticArrayIterator(array) {
        this.array = array;
        this.index = 0;
        this.length = 0;
        this.length = array.length;
    }
    StaticArrayIterator.prototype[iterator_1.iterator] = function () {
        return this;
    };
    StaticArrayIterator.prototype.next = function (value) {
        var i = this.index++;
        var array = this.array;
        return i < this.length ? { value: array[i], done: false } : { value: null, done: true };
    };
    StaticArrayIterator.prototype.hasValue = function () {
        return this.array.length > this.index;
    };
    StaticArrayIterator.prototype.hasCompleted = function () {
        return this.array.length === this.index;
    };
    return StaticArrayIterator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var ZipBufferIterator = (function (_super) {
    __extends(ZipBufferIterator, _super);
    function ZipBufferIterator(destination, parent, observable) {
        _super.call(this, destination);
        this.parent = parent;
        this.observable = observable;
        this.stillUnsubscribed = true;
        this.buffer = [];
        this.isComplete = false;
    }
    ZipBufferIterator.prototype[iterator_1.iterator] = function () {
        return this;
    };
    // NOTE: there is actually a name collision here with Subscriber.next and Iterator.next
    //    this is legit because `next()` will never be called by a subscription in this case.
    ZipBufferIterator.prototype.next = function () {
        var buffer = this.buffer;
        if (buffer.length === 0 && this.isComplete) {
            return { value: null, done: true };
        }
        else {
            return { value: buffer.shift(), done: false };
        }
    };
    ZipBufferIterator.prototype.hasValue = function () {
        return this.buffer.length > 0;
    };
    ZipBufferIterator.prototype.hasCompleted = function () {
        return this.buffer.length === 0 && this.isComplete;
    };
    ZipBufferIterator.prototype.notifyComplete = function () {
        if (this.buffer.length > 0) {
            this.isComplete = true;
            this.parent.notifyInactive();
        }
        else {
            this.destination.complete();
        }
    };
    ZipBufferIterator.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.buffer.push(innerValue);
        this.parent.checkIterators();
    };
    ZipBufferIterator.prototype.subscribe = function (value, index) {
        return subscribeToResult_1.subscribeToResult(this, this.observable, this, index);
    };
    return ZipBufferIterator;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=zip.js.map

/***/ }),

/***/ "Rewd":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__("mmVS");
/* tslint:enable:max-line-length */
/**
 * Perform a side effect for every emission on the source Observable, but return
 * an Observable that is identical to the source.
 *
 * <span class="informal">Intercepts each emission on the source and runs a
 * function, but returns an output which is identical to the source.</span>
 *
 * <img src="./img/do.png" width="100%">
 *
 * Returns a mirrored Observable of the source Observable, but modified so that
 * the provided Observer is called to perform a side effect for every value,
 * error, and completion emitted by the source. Any errors that are thrown in
 * the aforementioned Observer or handlers are safely sent down the error path
 * of the output Observable.
 *
 * This operator is useful for debugging your Observables for the correct values
 * or performing other side effects.
 *
 * Note: this is different to a `subscribe` on the Observable. If the Observable
 * returned by `do` is not subscribed, the side effects specified by the
 * Observer will never happen. `do` therefore simply spies on existing
 * execution, it does not trigger an execution to happen like `subscribe` does.
 *
 * @example <caption>Map every every click to the clientX position of that click, while also logging the click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var positions = clicks
 *   .do(ev => console.log(ev))
 *   .map(ev => ev.clientX);
 * positions.subscribe(x => console.log(x));
 *
 * @see {@link map}
 * @see {@link subscribe}
 *
 * @param {Observer|function} [nextOrObserver] A normal Observer object or a
 * callback for `next`.
 * @param {function} [error] Callback for errors in the source.
 * @param {function} [complete] Callback for the completion of the source.
 * @return {Observable} An Observable identical to the source, but runs the
 * specified Observer or callback(s) for each item.
 * @method do
 * @name do
 * @owner Observable
 */
function _do(nextOrObserver, error, complete) {
    return this.lift(new DoOperator(nextOrObserver, error, complete));
}
exports._do = _do;
var DoOperator = (function () {
    function DoOperator(nextOrObserver, error, complete) {
        this.nextOrObserver = nextOrObserver;
        this.error = error;
        this.complete = complete;
    }
    DoOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new DoSubscriber(subscriber, this.nextOrObserver, this.error, this.complete));
    };
    return DoOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var DoSubscriber = (function (_super) {
    __extends(DoSubscriber, _super);
    function DoSubscriber(destination, nextOrObserver, error, complete) {
        _super.call(this, destination);
        var safeSubscriber = new Subscriber_1.Subscriber(nextOrObserver, error, complete);
        safeSubscriber.syncErrorThrowable = true;
        this.add(safeSubscriber);
        this.safeSubscriber = safeSubscriber;
    }
    DoSubscriber.prototype._next = function (value) {
        var safeSubscriber = this.safeSubscriber;
        safeSubscriber.next(value);
        if (safeSubscriber.syncErrorThrown) {
            this.destination.error(safeSubscriber.syncErrorValue);
        }
        else {
            this.destination.next(value);
        }
    };
    DoSubscriber.prototype._error = function (err) {
        var safeSubscriber = this.safeSubscriber;
        safeSubscriber.error(err);
        if (safeSubscriber.syncErrorThrown) {
            this.destination.error(safeSubscriber.syncErrorValue);
        }
        else {
            this.destination.error(err);
        }
    };
    DoSubscriber.prototype._complete = function () {
        var safeSubscriber = this.safeSubscriber;
        safeSubscriber.complete();
        if (safeSubscriber.syncErrorThrown) {
            this.destination.error(safeSubscriber.syncErrorValue);
        }
        else {
            this.destination.complete();
        }
    };
    return DoSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=do.js.map

/***/ }),

/***/ "Rxv9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var min_1 = __webpack_require__("FT6u");
Observable_1.Observable.prototype.min = min_1.min;
//# sourceMappingURL=min.js.map

/***/ }),

/***/ "RyDc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var OuterSubscriber_1 = __webpack_require__("wAkD");
var subscribeToResult_1 = __webpack_require__("CURp");
/**
 * Returns an Observable that skips items emitted by the source Observable until a second Observable emits an item.
 *
 * <img src="./img/skipUntil.png" width="100%">
 *
 * @param {Observable} notifier - The second Observable that has to emit an item before the source Observable's elements begin to
 * be mirrored by the resulting Observable.
 * @return {Observable<T>} An Observable that skips items from the source Observable until the second Observable emits
 * an item, then emits the remaining items.
 * @method skipUntil
 * @owner Observable
 */
function skipUntil(notifier) {
    return this.lift(new SkipUntilOperator(notifier));
}
exports.skipUntil = skipUntil;
var SkipUntilOperator = (function () {
    function SkipUntilOperator(notifier) {
        this.notifier = notifier;
    }
    SkipUntilOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new SkipUntilSubscriber(subscriber, this.notifier));
    };
    return SkipUntilOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var SkipUntilSubscriber = (function (_super) {
    __extends(SkipUntilSubscriber, _super);
    function SkipUntilSubscriber(destination, notifier) {
        _super.call(this, destination);
        this.hasValue = false;
        this.isInnerStopped = false;
        this.add(subscribeToResult_1.subscribeToResult(this, notifier));
    }
    SkipUntilSubscriber.prototype._next = function (value) {
        if (this.hasValue) {
            _super.prototype._next.call(this, value);
        }
    };
    SkipUntilSubscriber.prototype._complete = function () {
        if (this.isInnerStopped) {
            _super.prototype._complete.call(this);
        }
        else {
            this.unsubscribe();
        }
    };
    SkipUntilSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.hasValue = true;
    };
    SkipUntilSubscriber.prototype.notifyComplete = function () {
        this.isInnerStopped = true;
        if (this.isStopped) {
            _super.prototype._complete.call(this);
        }
    };
    return SkipUntilSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=skipUntil.js.map

/***/ }),

/***/ "S2zP":
/***/ (function(module, exports) {

exports.config = {"status":true,"model":{"title-en":"Margo 5","module":"margo","js":["spbase-model.js","margo-model.js"],"summary":"Margo game","thumbnail":"tn-margo5.png","strings":[],"rules":{"en":"rules.html","fr":"rules-fr.html"},"description":{"en":"description.html","fr":"description-fr.html"},"credits":{"en":"credits.html","fr":"credits-fr.html"},"demoRandom":true,"gameOptions":{"preventRepeat":true,"uctTransposition":"states","uctIgnoreLoop":true,"size":5,"levelOptions":{"evalSafety":11.750749731517,"evalSafety2eyes":22.177834740058,"evalSafetyXEyesBonus":1.7649150399344,"evalSafety1f":9.3661218573064,"evalSafety3f":27.890795686826,"evalSafety3fMore":33.941637893389,"evalSafety3fMoreBonus":0.9758058890196,"evalSafety1eyeBonus":7.4647745586541,"evalSafetyPinnedBonus":0.5745794638283,"evalHeightRatio":1.8008592868854,"evalCenterRatio":0.12634283054723}},"plazza":"true","levels":[{"label":"Fast (1sec)","maxDuration":1,"isDefault":true,"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0,"ignoreLeaf":false,"uncertaintyFactor":0},{"label":"Beginner","maxDuration":1,"maxNodes":250,"maxLoops":50,"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0,"ignoreLeaf":false,"uncertaintyFactor":0},{"label":"Easy","maxDuration":2,"maxNodes":500,"maxLoops":100,"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0,"ignoreLeaf":false,"uncertaintyFactor":0},{"label":"Medium","maxDuration":4,"maxNodes":2500,"maxLoops":200,"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0,"ignoreLeaf":false,"uncertaintyFactor":0},{"label":"Confirmed","maxDuration":8,"maxNodes":5000,"maxLoops":500,"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0,"ignoreLeaf":false,"uncertaintyFactor":0},{"label":"Slow (10sec)","maxDuration":10,"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0,"ignoreLeaf":false,"uncertaintyFactor":0}]},"view":{"title-en":"Margo View","module":"margo","js":["spbase-xd-view.js"],"xdView":true,"css":["spbase.css"],"preferredRatio":1,"useNotation":true,"defaultOptions":{"sounds":true,"moves":true,"notation":false},"skins":[{"name":"classic3d","title":"3D Classic","3d":true,"camera":{"radius":20,"elevationAngle":45,"limitCamMoves":true,"distMax":40,"distMin":10,"elevationMin":-45,"elevationMax":89.9,"enableDrag":false},"world":{"lightIntensity":0,"color":0,"fog":false,"skyLightIntensity":0.7,"skyLightPosition":{"x":0,"y":10,"z":0},"ambientLightColor":8947848},"preload":["image|/res/xd-view/meshes/grey.png","image|/res/xd-view/meshes/black.png","image|/res/xd-view/meshes/white.png","image|/res/xd-view/meshes/green.png","image|/res/xd-view/meshes/skybox/nx.jpg","image|/res/xd-view/meshes/skybox/ny.jpg","image|/res/xd-view/meshes/skybox/nz.jpg","image|/res/xd-view/meshes/skybox/px.jpg","image|/res/xd-view/meshes/skybox/py.jpg","image|/res/xd-view/meshes/skybox/pz.jpg"]},{"name":"wood","title":"Wood","preload":["image|/res/images/ball_black.png","image|/res/images/ball_white.png","image|/res/images/ball_green.png","image|/res/images/plot.png","image|/res/images/wood.png"]},{"name":"classical","title":"Classic","preload":["image|/res/images/ball_black.png","image|/res/images/ball_white.png","image|/res/images/ball_green.png","image|/res/images/plot.png"]}],"animateSelfMoves":false,"visuals":{"600x600":["res/visuals/margo5-600x600-3d.jpg","res/visuals/margo5-600x600-2d.jpg"]}}}

/***/ }),

/***/ "S35O":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var from_1 = __webpack_require__("PKvP");
Observable_1.Observable.from = from_1.from;
//# sourceMappingURL=from.js.map

/***/ }),

/***/ "S3x0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ScreenTypes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ORIENTATION_BREAKPOINTS; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/* tslint:disable */
var HANDSET_PORTRAIT = '(orientations: portrait) and (max-width: 599px)';
var HANDSET_LANDSCAPE = '(orientations: landscape) and (max-width: 959px)';
var TABLET_LANDSCAPE = '(orientations: landscape) and (min-width: 960px) and (max-width: 1279px)';
var TABLET_PORTRAIT = '(orientations: portrait) and (min-width: 600px) and (max-width: 839px)';
var WEB_PORTRAIT = '(orientations: portrait) and (min-width: 840px)';
var WEB_LANDSCAPE = '(orientations: landscape) and (min-width: 1280px)';
var ScreenTypes = {
    'HANDSET': HANDSET_PORTRAIT + ", " + HANDSET_LANDSCAPE,
    'TABLET': TABLET_PORTRAIT + " , " + TABLET_LANDSCAPE,
    'WEB': WEB_PORTRAIT + ", " + WEB_LANDSCAPE + " ",
    'HANDSET_PORTRAIT': "" + HANDSET_PORTRAIT,
    'TABLET_PORTRAIT': TABLET_PORTRAIT + " ",
    'WEB_PORTRAIT': "" + WEB_PORTRAIT,
    'HANDSET_LANDSCAPE': HANDSET_LANDSCAPE + "]",
    'TABLET_LANDSCAPE': "" + TABLET_LANDSCAPE,
    'WEB_LANDSCAPE': "" + WEB_LANDSCAPE
};
/**
 * Extended Breakpoints for handset/tablets with landscape or portrait orientations
 */
var ORIENTATION_BREAKPOINTS = [
    { 'alias': 'handset', 'mediaQuery': ScreenTypes.HANDSET },
    { 'alias': 'handset.landscape', 'mediaQuery': ScreenTypes.HANDSET_LANDSCAPE },
    { 'alias': 'handset.portrait', 'mediaQuery': ScreenTypes.HANDSET_PORTRAIT },
    { 'alias': 'tablet', 'mediaQuery': ScreenTypes.TABLET },
    { 'alias': 'tablet.landscape', 'mediaQuery': ScreenTypes.TABLET },
    { 'alias': 'tablet.portrait', 'mediaQuery': ScreenTypes.TABLET_PORTRAIT },
    { 'alias': 'web', 'mediaQuery': ScreenTypes.WEB, overlapping: true },
    { 'alias': 'web.landscape', 'mediaQuery': ScreenTypes.WEB_LANDSCAPE, overlapping: true },
    { 'alias': 'web.portrait', 'mediaQuery': ScreenTypes.WEB_PORTRAIT, overlapping: true }
];
//# sourceMappingURL=orientation-break-points.js.map

/***/ }),

/***/ "SDFq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var OuterSubscriber_1 = __webpack_require__("wAkD");
var subscribeToResult_1 = __webpack_require__("CURp");
/* tslint:enable:max-line-length */
/**
 * Projects each source value to the same Observable which is flattened multiple
 * times with {@link switch} in the output Observable.
 *
 * <span class="informal">It's like {@link switchMap}, but maps each value
 * always to the same inner Observable.</span>
 *
 * <img src="./img/switchMapTo.png" width="100%">
 *
 * Maps each source value to the given Observable `innerObservable` regardless
 * of the source value, and then flattens those resulting Observables into one
 * single Observable, which is the output Observable. The output Observables
 * emits values only from the most recently emitted instance of
 * `innerObservable`.
 *
 * @example <caption>Rerun an interval Observable on every click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.switchMapTo(Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link concatMapTo}
 * @see {@link switch}
 * @see {@link switchMap}
 * @see {@link mergeMapTo}
 *
 * @param {ObservableInput} innerObservable An Observable to replace each value from
 * the source Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} An Observable that emits items from the given
 * `innerObservable` (and optionally transformed through `resultSelector`) every
 * time a value is emitted on the source Observable, and taking only the values
 * from the most recently projected inner Observable.
 * @method switchMapTo
 * @owner Observable
 */
function switchMapTo(innerObservable, resultSelector) {
    return this.lift(new SwitchMapToOperator(innerObservable, resultSelector));
}
exports.switchMapTo = switchMapTo;
var SwitchMapToOperator = (function () {
    function SwitchMapToOperator(observable, resultSelector) {
        this.observable = observable;
        this.resultSelector = resultSelector;
    }
    SwitchMapToOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new SwitchMapToSubscriber(subscriber, this.observable, this.resultSelector));
    };
    return SwitchMapToOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var SwitchMapToSubscriber = (function (_super) {
    __extends(SwitchMapToSubscriber, _super);
    function SwitchMapToSubscriber(destination, inner, resultSelector) {
        _super.call(this, destination);
        this.inner = inner;
        this.resultSelector = resultSelector;
        this.index = 0;
    }
    SwitchMapToSubscriber.prototype._next = function (value) {
        var innerSubscription = this.innerSubscription;
        if (innerSubscription) {
            innerSubscription.unsubscribe();
        }
        this.add(this.innerSubscription = subscribeToResult_1.subscribeToResult(this, this.inner, value, this.index++));
    };
    SwitchMapToSubscriber.prototype._complete = function () {
        var innerSubscription = this.innerSubscription;
        if (!innerSubscription || innerSubscription.closed) {
            _super.prototype._complete.call(this);
        }
    };
    SwitchMapToSubscriber.prototype._unsubscribe = function () {
        this.innerSubscription = null;
    };
    SwitchMapToSubscriber.prototype.notifyComplete = function (innerSub) {
        this.remove(innerSub);
        this.innerSubscription = null;
        if (this.isStopped) {
            _super.prototype._complete.call(this);
        }
    };
    SwitchMapToSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        var _a = this, resultSelector = _a.resultSelector, destination = _a.destination;
        if (resultSelector) {
            this.tryResultSelector(outerValue, innerValue, outerIndex, innerIndex);
        }
        else {
            destination.next(innerValue);
        }
    };
    SwitchMapToSubscriber.prototype.tryResultSelector = function (outerValue, innerValue, outerIndex, innerIndex) {
        var _a = this, resultSelector = _a.resultSelector, destination = _a.destination;
        var result;
        try {
            result = resultSelector(outerValue, innerValue, outerIndex, innerIndex);
        }
        catch (err) {
            destination.error(err);
            return;
        }
        destination.next(result);
    };
    return SwitchMapToSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=switchMapTo.js.map

/***/ }),

/***/ "SGWz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var mergeScan_1 = __webpack_require__("UELl");
Observable_1.Observable.prototype.mergeScan = mergeScan_1.mergeScan;
//# sourceMappingURL=mergeScan.js.map

/***/ }),

/***/ "SKH6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function isFunction(x) {
    return typeof x === 'function';
}
exports.isFunction = isFunction;
//# sourceMappingURL=isFunction.js.map

/***/ }),

/***/ "SSeX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var exhaustMap_1 = __webpack_require__("2AEF");
Observable_1.Observable.prototype.exhaustMap = exhaustMap_1.exhaustMap;
//# sourceMappingURL=exhaustMap.js.map

/***/ }),

/***/ "SUuD":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var interval_1 = __webpack_require__("rpzr");
Observable_1.Observable.interval = interval_1.interval;
//# sourceMappingURL=interval.js.map

/***/ }),

/***/ "Sciq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = applyCssPrefixes;
/* unused harmony export toAlignContentValue */
/* unused harmony export toBoxValue */
/* unused harmony export toBoxOrient */
/* unused harmony export toBoxDirection */
/* unused harmony export toBoxOrdinal */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/** Applies CSS prefixes to appropriate style keys.*/
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */ function applyCssPrefixes(target) {
    for (var key in target) {
        var value = target[key];
        switch (key) {
            case 'display':
                target['display'] = value;
                // also need 'display : -webkit-box' and 'display : -ms-flexbox;'
                break;
            case 'flex':
                target['-ms-flex'] = value;
                target['-webkit-box-flex'] = value.split(" ")[0];
                break;
            case 'flex-direction':
                value = value || "row";
                target['flex-direction'] = value;
                target['-ms-flex-direction'] = value;
                target['-webkit-box-orient'] = toBoxOrient(value);
                target['-webkit-box-direction'] = toBoxDirection(value);
                break;
            case 'flex-wrap':
                target['-ms-flex-wrap'] = value;
                break;
            case 'order':
                if (isNaN(value)) {
                    value = "0";
                }
                target['order'] = value;
                target['-ms-flex-order'] = value;
                target['-webkit-box-ordinal-group'] = toBoxOrdinal(value);
                break;
            case 'justify-content':
                target['-ms-flex-pack'] = toBoxValue(value);
                target['-webkit-box-pack'] = toBoxValue(value);
                break;
            case 'align-items':
                target['-ms-flex-align'] = toBoxValue(value);
                target['-webkit-box-align'] = toBoxValue(value);
                break;
            case 'align-self':
                target['-ms-flex-item-align'] = toBoxValue(value);
                break;
            case 'align-content':
                target['-ms-align-content'] = toAlignContentValue(value);
                target['-ms-flex-line-pack'] = toAlignContentValue(value);
                break;
        }
    }
    return target;
}
function toAlignContentValue(value) {
    switch (value) {
        case "space-between":
            return "justify";
        case "space-around":
            return "distribute";
        default:
            return toBoxValue(value);
    }
}
/** Convert flex values flex-start, flex-end to start, end. */
function toBoxValue(value) {
    if (value === void 0) { value = ""; }
    return (value == 'flex-start') ? 'start' : ((value == 'flex-end') ? 'end' : value);
}
/** Convert flex Direction to Box orientations */
function toBoxOrient(flexDirection) {
    if (flexDirection === void 0) { flexDirection = 'row'; }
    return flexDirection.indexOf('column') === -1 ? 'horizontal' : 'vertical';
}
/** Convert flex Direction to Box direction type */
function toBoxDirection(flexDirection) {
    if (flexDirection === void 0) { flexDirection = 'row'; }
    return flexDirection.indexOf('reverse') !== -1 ? 'reverse' : 'normal';
}
/** Convert flex order to Box ordinal group */
function toBoxOrdinal(order) {
    if (order === void 0) { order = '0'; }
    var value = order ? parseInt(order) + 1 : 1;
    return isNaN(value) ? "0" : value.toString();
}
//# sourceMappingURL=auto-prefixer.js.map

/***/ }),

/***/ "Si5Q":
/***/ (function(module, exports) {

exports.model=Model={Game:{},Board:{},Move:{}},function(){function t(t){if(o){var e=t%s;return(t-e)/s*s+s-e}var r=s*i-t-1,n=r%s;return r-n+s-n}var s,i,o=!1;Model.Game.checkersPosToString=t,Model.Game.InitGameInfo=function(){},Model.Game.BuildGraphCoord=function(){var t=(this.mOptions.width,this.mOptions.height,[]),s=[];this.g.Graph=t,this.g.Coord=s},Model.Game.InitGame=function(){var t=this.mOptions.width,e=this.mOptions.height;if(s=t,i=e,o=this.mOptions.invertNotation||!1,this.g.compulsoryCatch=!0,this.g.canStepBack=!0,this.g.mustMoveForward=!1,this.g.mustMoveForwardStrict=!1,this.g.lastRowFreeze=!1,this.g.lastRowCrown=!1,this.g.captureLongestLine=!1,this.g.noMove="lose",this.g.kingCaptureShort=!1,this.g.kingValue=5,this.g.lastRowFactor=0,this.g.canCaptureBackward=!0,this.g.captureInstantRemove=!1,this.g.longRangeKing=!0,this.g.drawKvsK=!0,this.g.drawKvs2K=!0,this.g.whiteStarts=!0,this.g.king180deg=!1,this.mOptions.variant)for(var r in this.mOptions.variant)this.mOptions.variant.hasOwnProperty(r)&&(this.g[r]=this.mOptions.variant[r]);this.BuildGraphCoord(),this.zobrist=new JocGame.Zobrist({board:{type:"array",size:this.g.Graph.length,values:["1/0","1/1","-1/0","-1/1"]}})},Model.Game.DestroyGame=function(){},Model.Game.CheckersDirections=4,Model.Game.Checkers2WaysDirections=[0,1,1,0],Model.Game.CheckersEachDirection=function(t,s){for(var i=0;i<this.CheckersDirections;i++){var o=this.g.Graph[t][i];if(null!=o&&0==s(o,i))return}},Model.Move.Init=function(t){this.pos=[];for(var s=t.pos?Object.keys(t.pos).sort():[],i=0;i<s.length;i++)this.pos.push(t.pos[i]);this.capt=[];for(var o=t.capt?Object.keys(t.capt).sort():[],i=0;i<o.length;i++)this.capt.push(t.capt[i])},Model.Move.ToString=function(s){s=s||"natural";var i=this;switch(s){case"natural":return function(){for(var s=[t(i.pos[0]),t(i.pos[i.pos.length-1])],o="-",e=1;e<i.capt.length;e++)null!=i.capt[e]&&(o="x",i.capt.length>3&&s.push(t(i.capt[e])));return s.join(o)}();case"hub":return function(){var s="-",o=[t(i.pos[0]),t(i.pos[i.pos.length-1])];if(i.capt[1]){s="x";var e=i.capt.slice(1).map(function(s){return t(s)});e.sort(),o=o.concat(e)}return o.join(s)}();case"dxp":return function(){var s=[t(i.pos[0]),t(i.pos[i.pos.length-1])];if(i.capt[1]){s.push(i.capt.length-1);for(var o=[],e=1;e<i.capt.length;e++)o.push(t(i.capt[e]));o.sort(),s=s.concat(o)}else s.push(0);return s.map(function(t){return t<10?"0"+t:t}).join("")}();default:return"??"}},Model.Board.Init=function(t){this.zSign=0},Model.Board.InitialPosition=function(t){var s=t.mOptions.width,i=t.mOptions.height,o=t.mOptions.initial;this.board=[];for(var e=0;e<i;e++)for(var r=0;r<s;r++)this.board[e*s+r]=-1;this.pieces=[];var n=0;if(t.mInitial){this.pCount=[0,0],this.spCount=[0,0],this.kpCount=[0,0];for(var a=0;a<t.mInitial.pieces.length;a++){var h=t.mInitial.pieces[a];this.board[h.p]=a,this.pieces.push({s:h.s,p:h.p,l:-1,t:h.t,plp:h.p}),this.zSign=t.zobrist.update(this.zSign,"board",h.s+"/"+h.t,h.p);var p=-(h.s-1)/2;this.pCount[p]++,0==h.t?this.spCount[p]++:this.kpCount[p]++}}else{for(var a in o.a)if(o.a.hasOwnProperty(a)){var u=o.a[a],c=u[0]*s+u[1],h={s:JocGame.PLAYER_A,p:c,l:-1,t:0,plp:c};this.pieces.push(h),this.board[c]=n++,this.zSign=t.zobrist.update(this.zSign,"board","1/0",c)}for(var a in o.b)if(o.b.hasOwnProperty(a)){var u=o.b[a],c=u[0]*s+u[1],h={s:JocGame.PLAYER_B,p:c,l:-1,t:0,plp:c};this.pieces.push(h),this.board[c]=n++,this.zSign=t.zobrist.update(this.zSign,"board","-1/0",c)}this.pCount=[o.a.length,o.b.length],this.spCount=[o.a.length,o.b.length],this.kpCount=[o.a.length,o.b.length]}},Model.Board.GenerateMoves=function(t){try{this._GenerateMoves(t)}catch(t){}},Model.Board._GenerateMoves=function(t){function s(t){for(var s=0;s<e.pieces.length;s++){var i=e.pieces[s];i&&i.s==e.mWho&&t(s,i.p)}}function i(s,o,r,n,a){for(;;){var h=[],p=[],u=[];if(t.CheckersEachDirection(s,function(i,c){var l;0==t.g.canCaptureBackward&&(l=t.g.Coord[s][0]);var g=t.Checkers2WaysDirections[c];if(a){if(t.g.longRangeKing)for(;e.board[i]==-1||t.g.king180deg&&null!=i&&r.indexOf(i)>=0;)i=t.g.Graph[i][c];if(null!=i&&e.board[i]>=0&&e.pieces[e.board[i]].s==-e.mWho){var v=i;if(i=t.g.Graph[i][c],t.g.kingCaptureShort){if(e.board[i]==-1||i==o[0]){for(var f=!0,d=0;d<n.length;d++)if(t.g.king180deg){if(r[d]==v){f=!1;break}}else if(t.g.captureInstantRemove&&r[d]==v||0==t.g.captureInstantRemove&&r[d]==v&&n[d]==g){f=!1;break}f&&(h.push(i),p.push(v),u.push(g)),i=t.g.Graph[i][c]}}else for(;e.board[i]==-1||i==o[0];){for(var f=!0,d=0;d<n.length;d++)if(t.g.captureInstantRemove&&r[d]==v||0==t.g.captureInstantRemove&&r[d]==v&&n[d]==g){f=!1;break}f&&(h.push(i),p.push(v),u.push(g)),i=t.g.Graph[i][c]}}}else if(e.board[i]>=0&&e.pieces[e.board[i]].s==-e.mWho){var m,C;if(0==t.g.canCaptureBackward&&(m=t.g.Coord[i][0],C=!1,(e.mWho==JocGame.PLAYER_A&&m>=l||e.mWho==JocGame.PLAYER_B&&m<=l)&&(C=!0)),t.g.canCaptureBackward||1==C){var b=t.g.Graph[i][c];if(null!=b&&(e.board[b]==-1||b==o[0])){for(var f=!0,d=0;d<n.length;d++)if(t.g.captureInstantRemove&&r[d]==i||0==t.g.captureInstantRemove&&r[d]==i&&n[d]==g){f=!1;break}f&&(h.push(b),p.push(i),u.push(g))}}}return!0}),0==h.length){o.length>1&&e.mMoves.push({pos:o,capt:r});break}if(!t.g.compulsoryCatch&&o.length>1){for(var c=[],l=0;l<o.length;l++)c.push(o[l]);for(var g=[],l=0;l<r.length;l++)g.push(r[l]);e.mMoves.push({pos:c,capt:g})}if(1!=h.length){for(var l=0;l<h.length;l++){for(var c=[],v=0;v<o.length;v++)c.push(o[v]);c.push(h[l]);for(var g=[],v=0;v<r.length;v++)g.push(r[v]);g.push(p[l]);for(var f=[],v=0;v<n.length;v++)f.push(n[v]);f.push(u[l]),i(h[l],c,g,f,a)}break}s=h[0],o.push(s),r.push(p[0]),n.push(u[0])}}var o=t.mOptions.height,e=this;if(this.mMoves=[],s(function(t,s){0==e.pieces[t].t?i(s,[s],[null],[null],!1):1==e.pieces[t].t&&i(s,[s],[null],[null],!0)}),0!=t.g.compulsoryCatch&&0!=this.mMoves.length||s(function(s,i){var r;0==e.pieces[s].t?((t.g.mustMoveForward||t.g.mustMoveForwardStrict||t.lastRowFreeze)&&(r=t.g.Coord[i][0]),t.CheckersEachDirection(i,function(n,a){var h,p,u;return t.g.mustMoveForwardStrict?(h=t.g.Coord[n][0],p=!1,(e.mWho==JocGame.PLAYER_A&&h>r||e.mWho==JocGame.PLAYER_B&&h<r)&&(p=!0)):t.g.mustMoveForward&&(h=t.g.Coord[n][0],p=!0,(e.mWho==JocGame.PLAYER_A&&h<r||e.mWho==JocGame.PLAYER_B&&h>r)&&(p=!1)),t.g.lastRowFreeze&&(u=!1,(e.mWho==JocGame.PLAYER_A&&r==o-1||e.mWho==JocGame.PLAYER_B&&0==r)&&(u=!0)),e.board[n]!=-1||!t.g.canStepBack&&n==e.pieces[s].l||(0!=t.g.mustMoveForward||0!=t.g.mustMoveForwardStrict)&&1!=p||0!=t.g.lastRowFreeze&&0!=u||e.mMoves.push({pos:[i,n],capt:[null,null]}),!0})):1==e.pieces[s].t&&t.CheckersEachDirection(i,function(s,o){if(t.g.longRangeKing)for(;e.board[s]==-1;)e.mMoves.push({pos:[i,s],capt:[null,null]}),s=t.g.Graph[s][o];else e.board[s]==-1&&(e.mMoves.push({pos:[i,s],capt:[null,null]}),s=t.g.Graph[s][o]);return!0})}),0==this.mMoves.length)switch(t.g.noMove){case"count":this.mFinished=!0,this.pCount[0]<this.pCount[1]?this.mWinner=JocGame.PLAYER_B:this.pCount[1]<this.pCount[0]?this.mWinner=JocGame.PLAYER_A:this.mWinner=JocGame.DRAW;break;case"lose":this.mFinished=!0,this.mWinner=-this.mWho;break;default:this.mFinished=!0,this.mWinner=JocGame.DRAW}if(t.g.captureLongestLine){for(var r=this.mMoves,n=[],a=0,h=0;h<r.length;h++){var p=r[h];p.pos.length==a?n.push(p):p.pos.length>a&&(n=[p],a=p.pos.length)}this.mMoves=n}},Model.Board.Evaluate=function(t,s,i){if(t.mOptions.preventRepeat&&t.GetRepeatOccurence(this)>2)return this.mFinished=!0,void(this.mWinner=JocGame.DRAW);if(t.g.drawKvsK&&0==this.spCount[0]&&0==this.spCount[1]&&1==this.kpCount[0]&&1==this.kpCount[1])return this.mFinished=!0,void(this.mWinner=JocGame.DRAW);if(t.g.drawKvs2K&&0==this.spCount[0]&&0==this.spCount[1]&&this.kpCount[0]+this.kpCount[1]==3&&(1==this.kpCount[0]||2==this.kpCount[0]))return this.mFinished=!0,void(this.mWinner=JocGame.DRAW);if(0==this.pCount[1])return this.mFinished=!0,void(this.mWinner=JocGame.PLAYER_A);if(0==this.pCount[0])return this.mFinished=!0,void(this.mWinner=JocGame.PLAYER_B);if(this.mEvaluation=10*(this.spCount[0]-this.spCount[1])+10*(this.kpCount[0]-this.kpCount[1])*t.g.kingValue+this.pCount[0]/this.pCount[1]-this.pCount[1]/this.pCount[0],0!=t.g.lastRowFactor){for(var o=t.mOptions.height,e=0,r=0,n=0;n<this.pieces.length;n++){var a=this.pieces[n];a&&0==a.t&&(this.mWho==JocGame.PLAYER_A?e+=t.g.Coord[a.p][0]:r+=o-1-t.g.Coord[a.p][0])}this.mEvaluation+=(e-r)*t.g.lastRowFactor}},Model.Board.CopyFrom=function(t){this.board=[];for(var s=0;s<t.board.length;s++)this.board[s]=t.board[s];this.pieces=[];for(var s=0;s<t.pieces.length;s++){var i=t.pieces[s];this.pieces[s]=null==i?null:{s:i.s,p:i.p,l:i.l,t:i.t,plp:i.plp}}this.pCount=[t.pCount[0],t.pCount[1]],this.spCount=[t.spCount[0],t.spCount[1]],this.kpCount=[t.kpCount[0],t.kpCount[1]],this.mWho=t.mWho,this.zSign=t.zSign},Model.Board.ApplyMove=function(t,s){var i=(t.mOptions.width,t.mOptions.height),o=s.pos[0],e=this.board[o],r=this.pieces[e],n=r.s;r.l=o;var a={};this.zSign=t.zobrist.update(this.zSign,"board",r.s+"/"+r.t,r.p);for(var h=1;h<s.pos.length;h++){var p=s.pos[h];this.board[r.p]=-1,r.p=p,this.board[p]=e;var u=s.capt[h];null!=u&&(this.board[u]>=0&&(a[this.board[u]]=!0),this.board[u]=-1),o=p}this.zSign=t.zobrist.update(this.zSign,"board",r.s+"/"+r.t,p);var c=s.capt[s.capt.length-1];r.plp=c||s.pos[s.pos.length-2];for(var l in a)if(a.hasOwnProperty(l)){var g=this.pieces[l],v=(1-g.s)/2;switch(this.pCount[v]--,g.t){case 0:this.spCount[v]--;break;case 1:this.kpCount[v]--}this.zSign=t.zobrist.update(this.zSign,"board",g.s+"/"+g.t,g.p),this.pieces[l]=null}if(t.g.lastRowCrown&&0==this.pieces[e].t){var f=t.g.Coord[s.pos[s.pos.length-1]][0];if(n==JocGame.PLAYER_A&&f==i-1||n==JocGame.PLAYER_B&&0==f){var g=this.pieces[e];g.t=1;var d=(1-n)/2;this.spCount[d]--,this.kpCount[d]++,this.zSign=t.zobrist.update(this.zSign,"board",g.s+"/0",g.p),this.zSign=t.zobrist.update(this.zSign,"board",g.s+"/1",g.p)}}},Model.Board.IsValidMove=function(t,s){return!0},Model.Board.GetSignature=function(){return this.zSign},Model.Game.Import=function(t,s){function i(t,s,i){i=r-i;var o=i%n;i=i-o+n-o-1,e.push({s:t,p:i,l:-1,t:s,plp:i})}var o=1,e=[],r=this.mOptions.width*this.mOptions.height,n=this.mOptions.width;if("pjn"==t){var a=s.split(":");o="W"==a[0]?1:-1;for(var h=1;h<a.length;h++)if(0!=a[h].length)for(var p="W"==a[h].substr(0,1)?1:-1,u=a[h].substr(1).split(","),c=0;c<u.length;c++){var l=u[c],g=0;"K"==l.substr(0,1)&&(g=1,l=l.substr(1));var v=/^([0-9]+)-([0-9]+)$/.exec(l);if(v)for(var f=parseInt(v[1]);f<=parseInt(v[2]);f++)i(p,g,f);else i(p,g,parseInt(l))}return e.sort(function(t,s){return s.s-t.s}),{status:!0,initial:{pieces:e,turn:o}}}return{status:!1,error:"unsupported"}};var e=JocGame.prototype.GetBestMatchingMove;Model.Game.GetBestMatchingMove=function(t,s){var i=[],o=this;s.forEach(function(t){"function"==typeof t.ToString?i.push(t.ToString()):i.push(o.CreateMove(t).ToString())}),t=t.replace(/0([1-9])/g,"$1");var r=/^([0-9]+)[\-x]([0-9]+)([\-x][0-9]+)*$/.exec(t);if(r){var n=new RegExp("^"+r[1]+"[-x]"+r[2]+"([-x][0-9]+)*$"),a={};s.forEach(function(t,s){if(n.test(i[s])){var o=i[s],e=/^([0-9]+)x([0-9]+)x([0-9]+(x[0-9]+)*)/.exec(o);if(e){var r=e[3].split("x");r.sort(function(t,s){return parseInt(t)-parseInt(s)}),o=e[1]+"x"+e[2]+"x"+r.join("x")}a[o]=t}});var h=[];for(var p in a)a.hasOwnProperty(p)&&h.push(a[p]);h.length>0&&(s=h)}return e.call(this,t,s)},Model.Board.ExportBoardState=function(o,e){function r(t){for(var o=[],e=0;e<n.board.length;e++){var r=e%s,a=(e-r)/s,h=(i-a-1)*s+r,p=n.board[e];if(p<0)o[h]="e";else{var u=n.pieces[p],c=1==u.s?"w":t;1==u.t&&(c=c.toUpperCase()),o[h]=c}}return o.join("")}e=e||"natural";var n=this;switch(e){case"natural":case"fen":return function(){var s={},i=[];n.pieces.forEach(function(i){if(i&&null!=i.p){var o=1==i.s?"W":"B";void 0===s[o]&&(s[o]={});var e=1==i.t?"K":"";void 0===s[o][e]&&(s[o][e]={group:0==i.t,pos:[]}),s[o][e].pos.push(parseInt(t(i.p)))}});for(var o in s)if(s.hasOwnProperty(o)){var e=[];for(var r in s[o])if(s[o].hasOwnProperty(r)){var a=s[o][r];if(a.group){a.pos.sort(function(t,s){return parseInt(t)-parseInt(s)});var h=-2,p=-1,u=-1;a.pos.forEach(function(t){parseInt(t)==h+1?p=t:(p>=0?(e.push(r+u+"-"+p),p=-1):u>=0&&e.push(r+u),u=t),h=parseInt(t)}),p>=0?e.push(r+u+"-"+p):u>=0&&e.push(r+u)}else a.pos.forEach(function(t){e.push(r+t)})}i.push(o+e.join(","))}return i.join(":")}();case"dxp":return function(){return r("z")}();case"hub":return function(){return r("z")}();default:return JSON.stringify(this)}}}(),Model.Game.BuildGraphCoord=function(){for(var t=this.mOptions.width,s=this.mOptions.height,i=[],o=[],e=0;e<s;e++)for(var r=0;r<t;r++){var n=e*t+r;o[n]=[e,r],i[n]=[],e%2==0?(e<s-1?(i[n].push((e+1)*t+r),r>0?i[n].push((e+1)*t+r-1):i[n].push(null)):(i[n].push(null),i[n].push(null)),e>0?(i[n].push((e-1)*t+r),r>0?i[n].push((e-1)*t+r-1):i[n].push(null)):(i[n].push(null),i[n].push(null))):(e<s-1?(r<t-1?i[n].push((e+1)*t+r+1):i[n].push(null),i[n].push((e+1)*t+r)):(i[n].push(null),i[n].push(null)),e>0?(r<t-1?i[n].push((e-1)*t+r+1):i[n].push(null),i[n].push((e-1)*t+r)):(i[n].push(null),i[n].push(null)))}this.g.Graph=i,this.g.Coord=o};

/***/ }),

/***/ "SudU":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var SubscribeOnObservable_1 = __webpack_require__("ftJA");
/**
 * Asynchronously subscribes Observers to this Observable on the specified IScheduler.
 *
 * <img src="./img/subscribeOn.png" width="100%">
 *
 * @param {Scheduler} scheduler - The IScheduler to perform subscription actions on.
 * @return {Observable<T>} The source Observable modified so that its subscriptions happen on the specified IScheduler.
 .
 * @method subscribeOn
 * @owner Observable
 */
function subscribeOn(scheduler, delay) {
    if (delay === void 0) { delay = 0; }
    return this.lift(new SubscribeOnOperator(scheduler, delay));
}
exports.subscribeOn = subscribeOn;
var SubscribeOnOperator = (function () {
    function SubscribeOnOperator(scheduler, delay) {
        this.scheduler = scheduler;
        this.delay = delay;
    }
    SubscribeOnOperator.prototype.call = function (subscriber, source) {
        return new SubscribeOnObservable_1.SubscribeOnObservable(source, this.delay, this.scheduler).subscribe(subscriber);
    };
    return SubscribeOnOperator;
}());
//# sourceMappingURL=subscribeOn.js.map

/***/ }),

/***/ "Sxsi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("3j3K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_BehaviorSubject__ = __webpack_require__("TfWX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_BehaviorSubject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs_BehaviorSubject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base__ = __webpack_require__("TwGT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__media_query_media_monitor__ = __webpack_require__("bWt6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_layout_validator__ = __webpack_require__("eKS0");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LayoutDirective; });
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */





/**
 * 'layout' flexbox styling directive
 * Defines the positioning flow direction for the child elements: row or column
 * Optional values: column or row (default)
 * @see https://css-tricks.com/almanac/properties/f/flex-direction/
 *
 */
var LayoutDirective = (function (_super) {
    __extends(LayoutDirective, _super);
    /* tslint:enable */
    /**
     *
     */
    function LayoutDirective(monitor, elRef, renderer) {
        var _this = _super.call(this, monitor, elRef, renderer) || this;
        _this._announcer = new __WEBPACK_IMPORTED_MODULE_1_rxjs_BehaviorSubject__["BehaviorSubject"]("row");
        _this.layout$ = _this._announcer.asObservable();
        return _this;
    }
    Object.defineProperty(LayoutDirective.prototype, "layout", {
        /* tslint:disable */
        set: function (val) { this._cacheInput("layout", val); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(LayoutDirective.prototype, "layoutXs", {
        set: function (val) { this._cacheInput('layoutXs', val); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(LayoutDirective.prototype, "layoutSm", {
        set: function (val) { this._cacheInput('layoutSm', val); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(LayoutDirective.prototype, "layoutMd", {
        set: function (val) { this._cacheInput('layoutMd', val); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(LayoutDirective.prototype, "layoutLg", {
        set: function (val) { this._cacheInput('layoutLg', val); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(LayoutDirective.prototype, "layoutXl", {
        set: function (val) { this._cacheInput('layoutXl', val); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(LayoutDirective.prototype, "layoutGtXs", {
        set: function (val) { this._cacheInput('layoutGtXs', val); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(LayoutDirective.prototype, "layoutGtSm", {
        set: function (val) { this._cacheInput('layoutGtSm', val); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(LayoutDirective.prototype, "layoutGtMd", {
        set: function (val) { this._cacheInput('layoutGtMd', val); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(LayoutDirective.prototype, "layoutGtLg", {
        set: function (val) { this._cacheInput('layoutGtLg', val); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(LayoutDirective.prototype, "layoutLtSm", {
        set: function (val) { this._cacheInput('layoutLtSm', val); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(LayoutDirective.prototype, "layoutLtMd", {
        set: function (val) { this._cacheInput('layoutLtMd', val); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(LayoutDirective.prototype, "layoutLtLg", {
        set: function (val) { this._cacheInput('layoutLtLg', val); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(LayoutDirective.prototype, "layoutLtXl", {
        set: function (val) { this._cacheInput('layoutLtXl', val); },
        enumerable: true,
        configurable: true
    });
    ;
    // *********************************************
    // Lifecycle Methods
    // *********************************************
    /**
     * On changes to any @Input properties...
     * Default to use the non-responsive Input value ('fxLayout')
     * Then conditionally override with the mq-activated Input's current value
     */
    LayoutDirective.prototype.ngOnChanges = function (changes) {
        if (changes['layout'] != null || this._mqActivation) {
            this._updateWithDirection();
        }
    };
    /**
     * After the initial onChanges, build an mqActivation object that bridges
     * mql change events to onMediaQueryChange handlers
     */
    LayoutDirective.prototype.ngOnInit = function () {
        var _this = this;
        this._listenForMediaQueryChanges('layout', 'row', function (changes) {
            _this._updateWithDirection(changes.value);
        });
        this._updateWithDirection();
    };
    // *********************************************
    // Protected methods
    // *********************************************
    /**
     * Validate the direction value and then update the host's inline flexbox styles
     */
    LayoutDirective.prototype._updateWithDirection = function (value) {
        value = value || this._queryInput("layout") || 'row';
        if (this._mqActivation) {
            value = this._mqActivation.activatedInput;
        }
        // Update styles and announce to subscribers the *new* direction
        var css = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_layout_validator__["a" /* buildLayoutCSS */])(value);
        this._applyStyleToElement(css);
        this._announcer.next(css['flex-direction']);
    };
    return LayoutDirective;
}(__WEBPACK_IMPORTED_MODULE_2__base__["a" /* BaseFxDirective */]));

LayoutDirective.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{ selector: "\n  [fxLayout],\n  [fxLayout.xs], [fxLayout.sm], [fxLayout.md], [fxLayout.lg], [fxLayout.xl],\n  [fxLayout.lt-sm], [fxLayout.lt-md], [fxLayout.lt-lg], [fxLayout.lt-xl],\n  [fxLayout.gt-xs], [fxLayout.gt-sm], [fxLayout.gt-md], [fxLayout.gt-lg]\n" },] },
];
/** @nocollapse */
LayoutDirective.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_3__media_query_media_monitor__["a" /* MediaMonitor */], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer2"], },
]; };
LayoutDirective.propDecorators = {
    'layout': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxLayout',] },],
    'layoutXs': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxLayout.xs',] },],
    'layoutSm': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxLayout.sm',] },],
    'layoutMd': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxLayout.md',] },],
    'layoutLg': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxLayout.lg',] },],
    'layoutXl': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxLayout.xl',] },],
    'layoutGtXs': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxLayout.gt-xs',] },],
    'layoutGtSm': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxLayout.gt-sm',] },],
    'layoutGtMd': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxLayout.gt-md',] },],
    'layoutGtLg': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxLayout.gt-lg',] },],
    'layoutLtSm': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxLayout.lt-sm',] },],
    'layoutLtMd': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxLayout.lt-md',] },],
    'layoutLtLg': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxLayout.lt-lg',] },],
    'layoutLtXl': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxLayout.lt-xl',] },],
};
//# sourceMappingURL=layout.js.map

/***/ }),

/***/ "T3fU":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var takeUntil_1 = __webpack_require__("q+cp");
Observable_1.Observable.prototype.takeUntil = takeUntil_1.takeUntil;
//# sourceMappingURL=takeUntil.js.map

/***/ }),

/***/ "T4uc":
/***/ (function(module, exports) {

exports.model=Model={Game:{},Board:{},Move:{}},function(){function t(t){if(o){var e=t%s;return(t-e)/s*s+s-e}var r=s*i-t-1,n=r%s;return r-n+s-n}var s,i,o=!1;Model.Game.checkersPosToString=t,Model.Game.InitGameInfo=function(){},Model.Game.BuildGraphCoord=function(){var t=(this.mOptions.width,this.mOptions.height,[]),s=[];this.g.Graph=t,this.g.Coord=s},Model.Game.InitGame=function(){var t=this.mOptions.width,e=this.mOptions.height;if(s=t,i=e,o=this.mOptions.invertNotation||!1,this.g.compulsoryCatch=!0,this.g.canStepBack=!0,this.g.mustMoveForward=!1,this.g.mustMoveForwardStrict=!1,this.g.lastRowFreeze=!1,this.g.lastRowCrown=!1,this.g.captureLongestLine=!1,this.g.noMove="lose",this.g.kingCaptureShort=!1,this.g.kingValue=5,this.g.lastRowFactor=0,this.g.canCaptureBackward=!0,this.g.captureInstantRemove=!1,this.g.longRangeKing=!0,this.g.drawKvsK=!0,this.g.drawKvs2K=!0,this.g.whiteStarts=!0,this.g.king180deg=!1,this.mOptions.variant)for(var r in this.mOptions.variant)this.mOptions.variant.hasOwnProperty(r)&&(this.g[r]=this.mOptions.variant[r]);this.BuildGraphCoord(),this.zobrist=new JocGame.Zobrist({board:{type:"array",size:this.g.Graph.length,values:["1/0","1/1","-1/0","-1/1"]}})},Model.Game.DestroyGame=function(){},Model.Game.CheckersDirections=4,Model.Game.Checkers2WaysDirections=[0,1,1,0],Model.Game.CheckersEachDirection=function(t,s){for(var i=0;i<this.CheckersDirections;i++){var o=this.g.Graph[t][i];if(null!=o&&0==s(o,i))return}},Model.Move.Init=function(t){this.pos=[];for(var s=t.pos?Object.keys(t.pos).sort():[],i=0;i<s.length;i++)this.pos.push(t.pos[i]);this.capt=[];for(var o=t.capt?Object.keys(t.capt).sort():[],i=0;i<o.length;i++)this.capt.push(t.capt[i])},Model.Move.ToString=function(s){s=s||"natural";var i=this;switch(s){case"natural":return function(){for(var s=[t(i.pos[0]),t(i.pos[i.pos.length-1])],o="-",e=1;e<i.capt.length;e++)null!=i.capt[e]&&(o="x",i.capt.length>3&&s.push(t(i.capt[e])));return s.join(o)}();case"hub":return function(){var s="-",o=[t(i.pos[0]),t(i.pos[i.pos.length-1])];if(i.capt[1]){s="x";var e=i.capt.slice(1).map(function(s){return t(s)});e.sort(),o=o.concat(e)}return o.join(s)}();case"dxp":return function(){var s=[t(i.pos[0]),t(i.pos[i.pos.length-1])];if(i.capt[1]){s.push(i.capt.length-1);for(var o=[],e=1;e<i.capt.length;e++)o.push(t(i.capt[e]));o.sort(),s=s.concat(o)}else s.push(0);return s.map(function(t){return t<10?"0"+t:t}).join("")}();default:return"??"}},Model.Board.Init=function(t){this.zSign=0},Model.Board.InitialPosition=function(t){var s=t.mOptions.width,i=t.mOptions.height,o=t.mOptions.initial;this.board=[];for(var e=0;e<i;e++)for(var r=0;r<s;r++)this.board[e*s+r]=-1;this.pieces=[];var n=0;if(t.mInitial){this.pCount=[0,0],this.spCount=[0,0],this.kpCount=[0,0];for(var a=0;a<t.mInitial.pieces.length;a++){var h=t.mInitial.pieces[a];this.board[h.p]=a,this.pieces.push({s:h.s,p:h.p,l:-1,t:h.t,plp:h.p}),this.zSign=t.zobrist.update(this.zSign,"board",h.s+"/"+h.t,h.p);var p=-(h.s-1)/2;this.pCount[p]++,0==h.t?this.spCount[p]++:this.kpCount[p]++}}else{for(var a in o.a)if(o.a.hasOwnProperty(a)){var u=o.a[a],c=u[0]*s+u[1],h={s:JocGame.PLAYER_A,p:c,l:-1,t:0,plp:c};this.pieces.push(h),this.board[c]=n++,this.zSign=t.zobrist.update(this.zSign,"board","1/0",c)}for(var a in o.b)if(o.b.hasOwnProperty(a)){var u=o.b[a],c=u[0]*s+u[1],h={s:JocGame.PLAYER_B,p:c,l:-1,t:0,plp:c};this.pieces.push(h),this.board[c]=n++,this.zSign=t.zobrist.update(this.zSign,"board","-1/0",c)}this.pCount=[o.a.length,o.b.length],this.spCount=[o.a.length,o.b.length],this.kpCount=[o.a.length,o.b.length]}},Model.Board.GenerateMoves=function(t){try{this._GenerateMoves(t)}catch(t){}},Model.Board._GenerateMoves=function(t){function s(t){for(var s=0;s<e.pieces.length;s++){var i=e.pieces[s];i&&i.s==e.mWho&&t(s,i.p)}}function i(s,o,r,n,a){for(;;){var h=[],p=[],u=[];if(t.CheckersEachDirection(s,function(i,c){var l;0==t.g.canCaptureBackward&&(l=t.g.Coord[s][0]);var g=t.Checkers2WaysDirections[c];if(a){if(t.g.longRangeKing)for(;e.board[i]==-1||t.g.king180deg&&null!=i&&r.indexOf(i)>=0;)i=t.g.Graph[i][c];if(null!=i&&e.board[i]>=0&&e.pieces[e.board[i]].s==-e.mWho){var v=i;if(i=t.g.Graph[i][c],t.g.kingCaptureShort){if(e.board[i]==-1||i==o[0]){for(var f=!0,d=0;d<n.length;d++)if(t.g.king180deg){if(r[d]==v){f=!1;break}}else if(t.g.captureInstantRemove&&r[d]==v||0==t.g.captureInstantRemove&&r[d]==v&&n[d]==g){f=!1;break}f&&(h.push(i),p.push(v),u.push(g)),i=t.g.Graph[i][c]}}else for(;e.board[i]==-1||i==o[0];){for(var f=!0,d=0;d<n.length;d++)if(t.g.captureInstantRemove&&r[d]==v||0==t.g.captureInstantRemove&&r[d]==v&&n[d]==g){f=!1;break}f&&(h.push(i),p.push(v),u.push(g)),i=t.g.Graph[i][c]}}}else if(e.board[i]>=0&&e.pieces[e.board[i]].s==-e.mWho){var m,C;if(0==t.g.canCaptureBackward&&(m=t.g.Coord[i][0],C=!1,(e.mWho==JocGame.PLAYER_A&&m>=l||e.mWho==JocGame.PLAYER_B&&m<=l)&&(C=!0)),t.g.canCaptureBackward||1==C){var b=t.g.Graph[i][c];if(null!=b&&(e.board[b]==-1||b==o[0])){for(var f=!0,d=0;d<n.length;d++)if(t.g.captureInstantRemove&&r[d]==i||0==t.g.captureInstantRemove&&r[d]==i&&n[d]==g){f=!1;break}f&&(h.push(b),p.push(i),u.push(g))}}}return!0}),0==h.length){o.length>1&&e.mMoves.push({pos:o,capt:r});break}if(!t.g.compulsoryCatch&&o.length>1){for(var c=[],l=0;l<o.length;l++)c.push(o[l]);for(var g=[],l=0;l<r.length;l++)g.push(r[l]);e.mMoves.push({pos:c,capt:g})}if(1!=h.length){for(var l=0;l<h.length;l++){for(var c=[],v=0;v<o.length;v++)c.push(o[v]);c.push(h[l]);for(var g=[],v=0;v<r.length;v++)g.push(r[v]);g.push(p[l]);for(var f=[],v=0;v<n.length;v++)f.push(n[v]);f.push(u[l]),i(h[l],c,g,f,a)}break}s=h[0],o.push(s),r.push(p[0]),n.push(u[0])}}var o=t.mOptions.height,e=this;if(this.mMoves=[],s(function(t,s){0==e.pieces[t].t?i(s,[s],[null],[null],!1):1==e.pieces[t].t&&i(s,[s],[null],[null],!0)}),0!=t.g.compulsoryCatch&&0!=this.mMoves.length||s(function(s,i){var r;0==e.pieces[s].t?((t.g.mustMoveForward||t.g.mustMoveForwardStrict||t.lastRowFreeze)&&(r=t.g.Coord[i][0]),t.CheckersEachDirection(i,function(n,a){var h,p,u;return t.g.mustMoveForwardStrict?(h=t.g.Coord[n][0],p=!1,(e.mWho==JocGame.PLAYER_A&&h>r||e.mWho==JocGame.PLAYER_B&&h<r)&&(p=!0)):t.g.mustMoveForward&&(h=t.g.Coord[n][0],p=!0,(e.mWho==JocGame.PLAYER_A&&h<r||e.mWho==JocGame.PLAYER_B&&h>r)&&(p=!1)),t.g.lastRowFreeze&&(u=!1,(e.mWho==JocGame.PLAYER_A&&r==o-1||e.mWho==JocGame.PLAYER_B&&0==r)&&(u=!0)),e.board[n]!=-1||!t.g.canStepBack&&n==e.pieces[s].l||(0!=t.g.mustMoveForward||0!=t.g.mustMoveForwardStrict)&&1!=p||0!=t.g.lastRowFreeze&&0!=u||e.mMoves.push({pos:[i,n],capt:[null,null]}),!0})):1==e.pieces[s].t&&t.CheckersEachDirection(i,function(s,o){if(t.g.longRangeKing)for(;e.board[s]==-1;)e.mMoves.push({pos:[i,s],capt:[null,null]}),s=t.g.Graph[s][o];else e.board[s]==-1&&(e.mMoves.push({pos:[i,s],capt:[null,null]}),s=t.g.Graph[s][o]);return!0})}),0==this.mMoves.length)switch(t.g.noMove){case"count":this.mFinished=!0,this.pCount[0]<this.pCount[1]?this.mWinner=JocGame.PLAYER_B:this.pCount[1]<this.pCount[0]?this.mWinner=JocGame.PLAYER_A:this.mWinner=JocGame.DRAW;break;case"lose":this.mFinished=!0,this.mWinner=-this.mWho;break;default:this.mFinished=!0,this.mWinner=JocGame.DRAW}if(t.g.captureLongestLine){for(var r=this.mMoves,n=[],a=0,h=0;h<r.length;h++){var p=r[h];p.pos.length==a?n.push(p):p.pos.length>a&&(n=[p],a=p.pos.length)}this.mMoves=n}},Model.Board.Evaluate=function(t,s,i){if(t.mOptions.preventRepeat&&t.GetRepeatOccurence(this)>2)return this.mFinished=!0,void(this.mWinner=JocGame.DRAW);if(t.g.drawKvsK&&0==this.spCount[0]&&0==this.spCount[1]&&1==this.kpCount[0]&&1==this.kpCount[1])return this.mFinished=!0,void(this.mWinner=JocGame.DRAW);if(t.g.drawKvs2K&&0==this.spCount[0]&&0==this.spCount[1]&&this.kpCount[0]+this.kpCount[1]==3&&(1==this.kpCount[0]||2==this.kpCount[0]))return this.mFinished=!0,void(this.mWinner=JocGame.DRAW);if(0==this.pCount[1])return this.mFinished=!0,void(this.mWinner=JocGame.PLAYER_A);if(0==this.pCount[0])return this.mFinished=!0,void(this.mWinner=JocGame.PLAYER_B);if(this.mEvaluation=10*(this.spCount[0]-this.spCount[1])+10*(this.kpCount[0]-this.kpCount[1])*t.g.kingValue+this.pCount[0]/this.pCount[1]-this.pCount[1]/this.pCount[0],0!=t.g.lastRowFactor){for(var o=t.mOptions.height,e=0,r=0,n=0;n<this.pieces.length;n++){var a=this.pieces[n];a&&0==a.t&&(this.mWho==JocGame.PLAYER_A?e+=t.g.Coord[a.p][0]:r+=o-1-t.g.Coord[a.p][0])}this.mEvaluation+=(e-r)*t.g.lastRowFactor}},Model.Board.CopyFrom=function(t){this.board=[];for(var s=0;s<t.board.length;s++)this.board[s]=t.board[s];this.pieces=[];for(var s=0;s<t.pieces.length;s++){var i=t.pieces[s];this.pieces[s]=null==i?null:{s:i.s,p:i.p,l:i.l,t:i.t,plp:i.plp}}this.pCount=[t.pCount[0],t.pCount[1]],this.spCount=[t.spCount[0],t.spCount[1]],this.kpCount=[t.kpCount[0],t.kpCount[1]],this.mWho=t.mWho,this.zSign=t.zSign},Model.Board.ApplyMove=function(t,s){var i=(t.mOptions.width,t.mOptions.height),o=s.pos[0],e=this.board[o],r=this.pieces[e],n=r.s;r.l=o;var a={};this.zSign=t.zobrist.update(this.zSign,"board",r.s+"/"+r.t,r.p);for(var h=1;h<s.pos.length;h++){var p=s.pos[h];this.board[r.p]=-1,r.p=p,this.board[p]=e;var u=s.capt[h];null!=u&&(this.board[u]>=0&&(a[this.board[u]]=!0),this.board[u]=-1),o=p}this.zSign=t.zobrist.update(this.zSign,"board",r.s+"/"+r.t,p);var c=s.capt[s.capt.length-1];r.plp=c||s.pos[s.pos.length-2];for(var l in a)if(a.hasOwnProperty(l)){var g=this.pieces[l],v=(1-g.s)/2;switch(this.pCount[v]--,g.t){case 0:this.spCount[v]--;break;case 1:this.kpCount[v]--}this.zSign=t.zobrist.update(this.zSign,"board",g.s+"/"+g.t,g.p),this.pieces[l]=null}if(t.g.lastRowCrown&&0==this.pieces[e].t){var f=t.g.Coord[s.pos[s.pos.length-1]][0];if(n==JocGame.PLAYER_A&&f==i-1||n==JocGame.PLAYER_B&&0==f){var g=this.pieces[e];g.t=1;var d=(1-n)/2;this.spCount[d]--,this.kpCount[d]++,this.zSign=t.zobrist.update(this.zSign,"board",g.s+"/0",g.p),this.zSign=t.zobrist.update(this.zSign,"board",g.s+"/1",g.p)}}},Model.Board.IsValidMove=function(t,s){return!0},Model.Board.GetSignature=function(){return this.zSign},Model.Game.Import=function(t,s){function i(t,s,i){i=r-i;var o=i%n;i=i-o+n-o-1,e.push({s:t,p:i,l:-1,t:s,plp:i})}var o=1,e=[],r=this.mOptions.width*this.mOptions.height,n=this.mOptions.width;if("pjn"==t){var a=s.split(":");o="W"==a[0]?1:-1;for(var h=1;h<a.length;h++)if(0!=a[h].length)for(var p="W"==a[h].substr(0,1)?1:-1,u=a[h].substr(1).split(","),c=0;c<u.length;c++){var l=u[c],g=0;"K"==l.substr(0,1)&&(g=1,l=l.substr(1));var v=/^([0-9]+)-([0-9]+)$/.exec(l);if(v)for(var f=parseInt(v[1]);f<=parseInt(v[2]);f++)i(p,g,f);else i(p,g,parseInt(l))}return e.sort(function(t,s){return s.s-t.s}),{status:!0,initial:{pieces:e,turn:o}}}return{status:!1,error:"unsupported"}};var e=JocGame.prototype.GetBestMatchingMove;Model.Game.GetBestMatchingMove=function(t,s){var i=[],o=this;s.forEach(function(t){"function"==typeof t.ToString?i.push(t.ToString()):i.push(o.CreateMove(t).ToString())}),t=t.replace(/0([1-9])/g,"$1");var r=/^([0-9]+)[\-x]([0-9]+)([\-x][0-9]+)*$/.exec(t);if(r){var n=new RegExp("^"+r[1]+"[-x]"+r[2]+"([-x][0-9]+)*$"),a={};s.forEach(function(t,s){if(n.test(i[s])){var o=i[s],e=/^([0-9]+)x([0-9]+)x([0-9]+(x[0-9]+)*)/.exec(o);if(e){var r=e[3].split("x");r.sort(function(t,s){return parseInt(t)-parseInt(s)}),o=e[1]+"x"+e[2]+"x"+r.join("x")}a[o]=t}});var h=[];for(var p in a)a.hasOwnProperty(p)&&h.push(a[p]);h.length>0&&(s=h)}return e.call(this,t,s)},Model.Board.ExportBoardState=function(o,e){function r(t){for(var o=[],e=0;e<n.board.length;e++){var r=e%s,a=(e-r)/s,h=(i-a-1)*s+r,p=n.board[e];if(p<0)o[h]="e";else{var u=n.pieces[p],c=1==u.s?"w":t;1==u.t&&(c=c.toUpperCase()),o[h]=c}}return o.join("")}e=e||"natural";var n=this;switch(e){case"natural":case"fen":return function(){var s={},i=[];n.pieces.forEach(function(i){if(i&&null!=i.p){var o=1==i.s?"W":"B";void 0===s[o]&&(s[o]={});var e=1==i.t?"K":"";void 0===s[o][e]&&(s[o][e]={group:0==i.t,pos:[]}),s[o][e].pos.push(parseInt(t(i.p)))}});for(var o in s)if(s.hasOwnProperty(o)){var e=[];for(var r in s[o])if(s[o].hasOwnProperty(r)){var a=s[o][r];if(a.group){a.pos.sort(function(t,s){return parseInt(t)-parseInt(s)});var h=-2,p=-1,u=-1;a.pos.forEach(function(t){parseInt(t)==h+1?p=t:(p>=0?(e.push(r+u+"-"+p),p=-1):u>=0&&e.push(r+u),u=t),h=parseInt(t)}),p>=0?e.push(r+u+"-"+p):u>=0&&e.push(r+u)}else a.pos.forEach(function(t){e.push(r+t)})}i.push(o+e.join(","))}return i.join(":")}();case"dxp":return function(){return r("z")}();case"hub":return function(){return r("z")}();default:return JSON.stringify(this)}}}(),Model.Game.CheckersDirections=8,Model.Game.Checkers2WaysDirections=[0,0,1,1,2,3,3,2],Model.Game.BuildGraphCoord=function(){for(var t=this.mOptions.width,s=this.mOptions.height,i=[],o=[],e=0;e<s;e++)for(var r=0;r<t;r++){var n=e*t+r;if(o[n]=[e,r],i[n]=[],e>0?i[n].push((e-1)*t+r):i[n].push(null),e<s-1?i[n].push((e+1)*t+r):i[n].push(null),r>0?i[n].push(e*t+r-1):i[n].push(null),r<t-1?i[n].push(e*t+r+1):i[n].push(null),e%2==r%2)for(var a=-1;a<2;a+=2)for(var h=-1;h<2;h+=2)e+a<s&&e+a>=0&&r+h<t&&r+h>=0?i[n].push((e+a)*t+r+h):i[n].push(null);else i[n].push(null),i[n].push(null),i[n].push(null),i[n].push(null)}this.g.Graph=i,this.g.Coord=o};

/***/ }),

/***/ "T5WN":
/***/ (function(module, exports) {

exports.config = {"status":true,"model":{"plazza":"true","title-en":"English Draughts","module":"checkers","maxLevel":20,"summary":"A popular version of checkers on a 8x8 board.","thumbnail":"draughts8-thumb3d.png","rules":"rules-brit-checkers.html","description":"description.html","credits":"credits.html","js":["checkersbase-model.js","draughts-model.js"],"gameOptions":{"preventRepeat":true,"width":4,"height":8,"initial":{"a":[[0,0],[0,1],[0,2],[0,3],[1,0],[1,1],[1,2],[1,3],[2,0],[2,1],[2,2],[2,3]],"b":[[7,0],[7,1],[7,2],[7,3],[6,0],[6,1],[6,2],[6,3],[5,0],[5,1],[5,2],[5,3]]},"variant":{"mustMoveForwardStrict":true,"lastRowCrown":true,"captureLongestLine":true,"longRangeKing":false,"kingCaptureShort":true,"lastRowFactor":0.001,"kingValue":2,"whiteStarts":false,"canCaptureBackward":false},"invertNotation":true,"uctTransposition":"state"},"levels":[{"label":"Fast","ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.5,"maxDuration":1,"isDefault":true},{"label":"Beginner","ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.5,"maxDuration":0.5,"maxNodes":100,"maxLoops":200},{"label":"Easy","ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.5,"maxDuration":1,"maxNodes":2500,"maxLoops":500},{"label":"Medium","ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.5,"maxDuration":2,"maxNodes":5500,"maxLoops":500},{"label":"Hard","ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.5,"maxDuration":5,"maxNodes":2000,"maxLoops":3500},{"label":"Expert","ai":"uct","c":0.8,"playoutDepth":0,"minVisitsExpand":1,"ignoreLeaf":false,"uncertaintyFactor":5,"propagateMultiVisits":false,"maxDuration":60,"maxNodes":15000,"maxLoops":8000}]},"view":{"js":["checkers-xd-view.js","draughts8-xd-view.js"],"css":["checkersbase.css","draughts.css"],"title-en":"Draughts View","skins":[{"name":"classic3d","title":"3D Classic","3d":true,"camera":{"radius":24,"elevationAngle":65,"limitCamMoves":true,"distMax":30,"fov":35},"world":{"lightIntensity":0.7,"skyLightIntensity":0.5,"lightPosition":{"x":-15,"y":15,"z":0},"lightShadowDarkness":0.45,"ambientLightColor":8947848,"color":4686804,"fog":false},"preload":["image|/res/images/wood-chipboard-5.jpg","image|/res/xd-view/meshes/piecetop-bump.jpg","image|/res/xd-view/meshes/piecediff.jpg","image|/res/xd-view/meshes/piecetop-queen-mask.png","smoothedfilegeo|0|/res/xd-view/meshes/ring-target.js","smoothedfilegeo|0|/res/xd-view/meshes/piece-v2.js"]},{"name":"turtles3d","title":"3D Turtles","3d":true,"camera":{"radius":14,"elevationAngle":45,"limitCamMoves":true,"distMax":40},"world":{"lightIntensity":0,"skyLightIntensity":3,"fog":true,"color":3645658,"lightPosition":{"x":-5,"y":18,"z":5},"lightShadowDarkness":0.55,"ambientLightColor":4473924},"preload":["image|/res/images/wood-chipboard-5.jpg","image|/res/xd-view/meshes/turtle.png","image|/res/xd-view/meshes/star.png","image|/res/xd-view/meshes/rock.jpg","smoothedfilegeo|0|/res/xd-view/meshes/turtle-legs-smoothed.js","smoothedfilegeo|0|/res/xd-view/meshes/turtle-head-smoothed.js","smoothedfilegeo|0|/res/xd-view/meshes/turtle-tail-smoothed.js","smoothedfilegeo|0|/res/xd-view/meshes/turtle-hotel.js","smoothedfilegeo|0|/res/xd-view/meshes/turtle-house.js","smoothedfilegeo|0|/res/xd-view/meshes/rainbowflat.js","smoothedfilegeo|0|/res/xd-view/meshes/ring-target.js","smoothedfilegeo|0|/res/xd-view/meshes/rocksmoothed.js","smoothedfilegeo|0|/res/xd-view/meshes/turtle-fences.js"]},{"name":"classical","title":"Classic"},{"name":"marble0","title":"Marble"},{"name":"wood0","title":"Wood"},{"name":"green","title":"Green"}],"visuals":{"600x600":["res/visuals/english-draughts-600x600-3d.jpg","res/visuals/english-draughts-600x600-2d.jpg"]},"sounds":{"move1":"move1","move2":"move2","move3":"move3","move4":"move4","tac1":"tac1","tac2":"tac1","tac3":"tac1","promo":"promo","usermove":null},"module":"checkers","preferredRatio":1,"switchable":true,"animateSelfMoves":false,"useNotation":true,"useShowMoves":true,"defaultOptions":{"sounds":true,"notation":false,"moves":true},"xdView":true}}

/***/ }),

/***/ "TIy+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var FromEventObservable_1 = __webpack_require__("/J7H");
exports.fromEvent = FromEventObservable_1.FromEventObservable.create;
//# sourceMappingURL=fromEvent.js.map

/***/ }),

/***/ "TL2s":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Immediate_1 = __webpack_require__("kcyo");
var AsyncAction_1 = __webpack_require__("cwzr");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var AsapAction = (function (_super) {
    __extends(AsapAction, _super);
    function AsapAction(scheduler, work) {
        _super.call(this, scheduler, work);
        this.scheduler = scheduler;
        this.work = work;
    }
    AsapAction.prototype.requestAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) { delay = 0; }
        // If delay is greater than 0, request as an async action.
        if (delay !== null && delay > 0) {
            return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
        }
        // Push the action to the end of the scheduler queue.
        scheduler.actions.push(this);
        // If a microtask has already been scheduled, don't schedule another
        // one. If a microtask hasn't been scheduled yet, schedule one now. Return
        // the current scheduled microtask id.
        return scheduler.scheduled || (scheduler.scheduled = Immediate_1.Immediate.setImmediate(scheduler.flush.bind(scheduler, null)));
    };
    AsapAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) { delay = 0; }
        // If delay exists and is greater than 0, or if the delay is null (the
        // action wasn't rescheduled) but was originally scheduled as an async
        // action, then recycle as an async action.
        if ((delay !== null && delay > 0) || (delay === null && this.delay > 0)) {
            return _super.prototype.recycleAsyncId.call(this, scheduler, id, delay);
        }
        // If the scheduler queue is empty, cancel the requested microtask and
        // set the scheduled flag to undefined so the next AsapAction will schedule
        // its own.
        if (scheduler.actions.length === 0) {
            Immediate_1.Immediate.clearImmediate(id);
            scheduler.scheduled = undefined;
        }
        // Return undefined so the action knows to request a new async id if it's rescheduled.
        return undefined;
    };
    return AsapAction;
}(AsyncAction_1.AsyncAction));
exports.AsapAction = AsapAction;
//# sourceMappingURL=AsapAction.js.map

/***/ }),

/***/ "TfWX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subject_1 = __webpack_require__("EEr4");
var ObjectUnsubscribedError_1 = __webpack_require__("IZVw");
/**
 * @class BehaviorSubject<T>
 */
var BehaviorSubject = (function (_super) {
    __extends(BehaviorSubject, _super);
    function BehaviorSubject(_value) {
        _super.call(this);
        this._value = _value;
    }
    Object.defineProperty(BehaviorSubject.prototype, "value", {
        get: function () {
            return this.getValue();
        },
        enumerable: true,
        configurable: true
    });
    BehaviorSubject.prototype._subscribe = function (subscriber) {
        var subscription = _super.prototype._subscribe.call(this, subscriber);
        if (subscription && !subscription.closed) {
            subscriber.next(this._value);
        }
        return subscription;
    };
    BehaviorSubject.prototype.getValue = function () {
        if (this.hasError) {
            throw this.thrownError;
        }
        else if (this.closed) {
            throw new ObjectUnsubscribedError_1.ObjectUnsubscribedError();
        }
        else {
            return this._value;
        }
    };
    BehaviorSubject.prototype.next = function (value) {
        _super.prototype.next.call(this, this._value = value);
    };
    return BehaviorSubject;
}(Subject_1.Subject));
exports.BehaviorSubject = BehaviorSubject;
//# sourceMappingURL=BehaviorSubject.js.map

/***/ }),

/***/ "TwGT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_auto_prefixer__ = __webpack_require__("Sciq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_layout_validator__ = __webpack_require__("eKS0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__responsive_responsive_activation__ = __webpack_require__("VDSN");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BaseFxDirective; });



/** Abstract base class for the Layout API styling directives. */
var BaseFxDirective = (function () {
    /**
     *
     */
    function BaseFxDirective(_mediaMonitor, _elementRef, _renderer) {
        this._mediaMonitor = _mediaMonitor;
        this._elementRef = _elementRef;
        this._renderer = _renderer;
        /**
         *  Dictionary of input keys with associated values
         */
        this._inputMap = {};
        this._display = this._getDisplayStyle();
    }
    Object.defineProperty(BaseFxDirective.prototype, "hasMediaQueryListener", {
        get: function () {
            return !!this._mqActivation;
        },
        enumerable: true,
        configurable: true
    });
    // *********************************************
    // Accessor Methods
    // *********************************************
    /**
     * Access the current value (if any) of the @Input property.
     */
    BaseFxDirective.prototype._queryInput = function (key) {
        return this._inputMap[key];
    };
    // *********************************************
    // Lifecycle Methods
    // *********************************************
    BaseFxDirective.prototype.ngOnDestroy = function () {
        if (this._mqActivation) {
            this._mqActivation.destroy();
        }
        this._mediaMonitor = null;
    };
    // *********************************************
    // Protected Methods
    // *********************************************
    /**
     * Was the directive's default selector used ?
     * If not, use the fallback value!
     */
    BaseFxDirective.prototype._getDefaultVal = function (key, fallbackVal) {
        var val = this._queryInput(key);
        var hasDefaultVal = (val !== undefined && val !== null);
        return (hasDefaultVal && val !== '') ? val : fallbackVal;
    };
    /**
     * Quick accessor to the current HTMLElement's `display` style
     * Note: this allows use to preserve the original style
     * and optional restore it when the mediaQueries deactivate
     */
    BaseFxDirective.prototype._getDisplayStyle = function (source) {
        var element = source || this._elementRef.nativeElement;
        var value = element.style['display'] || getComputedStyle(element)['display'];
        return value.trim();
    };
    BaseFxDirective.prototype._getFlowDirection = function (target, addIfMissing) {
        if (addIfMissing === void 0) { addIfMissing = false; }
        var value = "";
        if (target) {
            var directionKeys_1 = Object.keys(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_auto_prefixer__["a" /* applyCssPrefixes */])({ 'flex-direction': '' }));
            var findDirection = function (styles) { return directionKeys_1.reduce(function (direction, key) {
                return direction || styles[key];
            }, null); };
            var immediateValue = findDirection(target['style']);
            value = immediateValue || findDirection(getComputedStyle(target));
            if (!immediateValue && addIfMissing) {
                value = value || 'row';
                this._applyStyleToElements(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_layout_validator__["a" /* buildLayoutCSS */])(value), [target]);
            }
        }
        return value ? value.trim() : "row";
    };
    /**
     * Applies styles given via string pair or object map to the directive element.
     */
    BaseFxDirective.prototype._applyStyleToElement = function (style, value, nativeElement) {
        var _this = this;
        var styles = {};
        var element = nativeElement || this._elementRef.nativeElement;
        if (typeof style === 'string') {
            styles[style] = value;
            style = styles;
        }
        styles = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_auto_prefixer__["a" /* applyCssPrefixes */])(style);
        // Iterate all properties in hashMap and set styles
        Object.keys(styles).forEach(function (key) {
            _this._renderer.setStyle(element, key, styles[key]);
        });
    };
    /**
     * Applies styles given via string pair or object map to the directive element.
     */
    BaseFxDirective.prototype._applyStyleToElements = function (style, elements) {
        var _this = this;
        var styles = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_auto_prefixer__["a" /* applyCssPrefixes */])(style);
        Object.keys(styles).forEach(function (key) {
            elements.forEach(function (el) { return _this._renderer.setStyle(el, key, styles[key]); });
        });
    };
    /**
     *  Save the property value; which may be a complex object.
     *  Complex objects support property chains
     */
    BaseFxDirective.prototype._cacheInput = function (key, source) {
        if (typeof source === 'object') {
            for (var prop in source) {
                this._inputMap[prop] = source[prop];
            }
        }
        else {
            this._inputMap[key] = source;
        }
    };
    /**
     *  Build a ResponsiveActivation object used to manage subscriptions to mediaChange notifications
     *  and intelligent lookup of the directive's property value that corresponds to that mediaQuery
     *  (or closest match).
     */
    BaseFxDirective.prototype._listenForMediaQueryChanges = function (key, defaultValue, onMediaQueryChange) {
        if (!this._mqActivation) {
            var keyOptions = new __WEBPACK_IMPORTED_MODULE_2__responsive_responsive_activation__["a" /* KeyOptions */](key, defaultValue, this._inputMap);
            this._mqActivation = new __WEBPACK_IMPORTED_MODULE_2__responsive_responsive_activation__["b" /* ResponsiveActivation */](keyOptions, this._mediaMonitor, function (change) { return onMediaQueryChange(change); });
        }
        return this._mqActivation;
    };
    Object.defineProperty(BaseFxDirective.prototype, "childrenNodes", {
        /**
         * Special accessor to query for all child 'element' nodes regardless of type, class, etc.
         */
        get: function () {
            var obj = this._elementRef.nativeElement.childNodes;
            var buffer = [];
            // iterate backwards ensuring that length is an UInt32
            for (var i = obj.length; i--;) {
                buffer[i] = obj[i];
            }
            return buffer;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Fast validator for presence of attribute on the host element
     */
    BaseFxDirective.prototype.hasKeyValue = function (key) {
        return this._mqActivation.hasKeyValue(key);
    };
    return BaseFxDirective;
}());

//# sourceMappingURL=base.js.map

/***/ }),

/***/ "U15Z":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var root_1 = __webpack_require__("VOfZ");
var Observable_1 = __webpack_require__("rCTf");
var iterator_1 = __webpack_require__("cdmN");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var IteratorObservable = (function (_super) {
    __extends(IteratorObservable, _super);
    function IteratorObservable(iterator, scheduler) {
        _super.call(this);
        this.scheduler = scheduler;
        if (iterator == null) {
            throw new Error('iterator cannot be null.');
        }
        this.iterator = getIterator(iterator);
    }
    IteratorObservable.create = function (iterator, scheduler) {
        return new IteratorObservable(iterator, scheduler);
    };
    IteratorObservable.dispatch = function (state) {
        var index = state.index, hasError = state.hasError, iterator = state.iterator, subscriber = state.subscriber;
        if (hasError) {
            subscriber.error(state.error);
            return;
        }
        var result = iterator.next();
        if (result.done) {
            subscriber.complete();
            return;
        }
        subscriber.next(result.value);
        state.index = index + 1;
        if (subscriber.closed) {
            if (typeof iterator.return === 'function') {
                iterator.return();
            }
            return;
        }
        this.schedule(state);
    };
    IteratorObservable.prototype._subscribe = function (subscriber) {
        var index = 0;
        var _a = this, iterator = _a.iterator, scheduler = _a.scheduler;
        if (scheduler) {
            return scheduler.schedule(IteratorObservable.dispatch, 0, {
                index: index, iterator: iterator, subscriber: subscriber
            });
        }
        else {
            do {
                var result = iterator.next();
                if (result.done) {
                    subscriber.complete();
                    break;
                }
                else {
                    subscriber.next(result.value);
                }
                if (subscriber.closed) {
                    if (typeof iterator.return === 'function') {
                        iterator.return();
                    }
                    break;
                }
            } while (true);
        }
    };
    return IteratorObservable;
}(Observable_1.Observable));
exports.IteratorObservable = IteratorObservable;
var StringIterator = (function () {
    function StringIterator(str, idx, len) {
        if (idx === void 0) { idx = 0; }
        if (len === void 0) { len = str.length; }
        this.str = str;
        this.idx = idx;
        this.len = len;
    }
    StringIterator.prototype[iterator_1.iterator] = function () { return (this); };
    StringIterator.prototype.next = function () {
        return this.idx < this.len ? {
            done: false,
            value: this.str.charAt(this.idx++)
        } : {
            done: true,
            value: undefined
        };
    };
    return StringIterator;
}());
var ArrayIterator = (function () {
    function ArrayIterator(arr, idx, len) {
        if (idx === void 0) { idx = 0; }
        if (len === void 0) { len = toLength(arr); }
        this.arr = arr;
        this.idx = idx;
        this.len = len;
    }
    ArrayIterator.prototype[iterator_1.iterator] = function () { return this; };
    ArrayIterator.prototype.next = function () {
        return this.idx < this.len ? {
            done: false,
            value: this.arr[this.idx++]
        } : {
            done: true,
            value: undefined
        };
    };
    return ArrayIterator;
}());
function getIterator(obj) {
    var i = obj[iterator_1.iterator];
    if (!i && typeof obj === 'string') {
        return new StringIterator(obj);
    }
    if (!i && obj.length !== undefined) {
        return new ArrayIterator(obj);
    }
    if (!i) {
        throw new TypeError('object is not iterable');
    }
    return obj[iterator_1.iterator]();
}
var maxSafeInteger = Math.pow(2, 53) - 1;
function toLength(o) {
    var len = +o.length;
    if (isNaN(len)) {
        return 0;
    }
    if (len === 0 || !numberIsFinite(len)) {
        return len;
    }
    len = sign(len) * Math.floor(Math.abs(len));
    if (len <= 0) {
        return 0;
    }
    if (len > maxSafeInteger) {
        return maxSafeInteger;
    }
    return len;
}
function numberIsFinite(value) {
    return typeof value === 'number' && root_1.root.isFinite(value);
}
function sign(value) {
    var valueAsNumber = +value;
    if (valueAsNumber === 0) {
        return valueAsNumber;
    }
    if (isNaN(valueAsNumber)) {
        return valueAsNumber;
    }
    return valueAsNumber < 0 ? -1 : 1;
}
//# sourceMappingURL=IteratorObservable.js.map

/***/ }),

/***/ "U85J":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var bindNodeCallback_1 = __webpack_require__("b1Ba");
Observable_1.Observable.bindNodeCallback = bindNodeCallback_1.bindNodeCallback;
//# sourceMappingURL=bindNodeCallback.js.map

/***/ }),

/***/ "U9ky":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var map_1 = __webpack_require__("xAJs");
/**
 * Maps each source value (an object) to its specified nested property.
 *
 * <span class="informal">Like {@link map}, but meant only for picking one of
 * the nested properties of every emitted object.</span>
 *
 * <img src="./img/pluck.png" width="100%">
 *
 * Given a list of strings describing a path to an object property, retrieves
 * the value of a specified nested property from all values in the source
 * Observable. If a property can't be resolved, it will return `undefined` for
 * that value.
 *
 * @example <caption>Map every every click to the tagName of the clicked target element</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var tagNames = clicks.pluck('target', 'tagName');
 * tagNames.subscribe(x => console.log(x));
 *
 * @see {@link map}
 *
 * @param {...string} properties The nested properties to pluck from each source
 * value (an object).
 * @return {Observable} A new Observable of property values from the source values.
 * @method pluck
 * @owner Observable
 */
function pluck() {
    var properties = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        properties[_i - 0] = arguments[_i];
    }
    var length = properties.length;
    if (length === 0) {
        throw new Error('list of properties cannot be empty.');
    }
    return map_1.map.call(this, plucker(properties, length));
}
exports.pluck = pluck;
function plucker(props, length) {
    var mapper = function (x) {
        var currentProp = x;
        for (var i = 0; i < length; i++) {
            var p = currentProp[props[i]];
            if (typeof p !== 'undefined') {
                currentProp = p;
            }
            else {
                return undefined;
            }
        }
        return currentProp;
    };
    return mapper;
}
//# sourceMappingURL=pluck.js.map

/***/ }),

/***/ "UELl":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var tryCatch_1 = __webpack_require__("+3eL");
var errorObject_1 = __webpack_require__("WhVc");
var subscribeToResult_1 = __webpack_require__("CURp");
var OuterSubscriber_1 = __webpack_require__("wAkD");
/**
 * Applies an accumulator function over the source Observable where the
 * accumulator function itself returns an Observable, then each intermediate
 * Observable returned is merged into the output Observable.
 *
 * <span class="informal">It's like {@link scan}, but the Observables returned
 * by the accumulator are merged into the outer Observable.</span>
 *
 * @example <caption>Count the number of click events</caption>
 * const click$ = Rx.Observable.fromEvent(document, 'click');
 * const one$ = click$.mapTo(1);
 * const seed = 0;
 * const count$ = one$.mergeScan((acc, one) => Rx.Observable.of(acc + one), seed);
 * count$.subscribe(x => console.log(x));
 *
 * // Results:
 * 1
 * 2
 * 3
 * 4
 * // ...and so on for each click
 *
 * @param {function(acc: R, value: T): Observable<R>} accumulator
 * The accumulator function called on each source value.
 * @param seed The initial accumulation value.
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of
 * input Observables being subscribed to concurrently.
 * @return {Observable<R>} An observable of the accumulated values.
 * @method mergeScan
 * @owner Observable
 */
function mergeScan(accumulator, seed, concurrent) {
    if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
    return this.lift(new MergeScanOperator(accumulator, seed, concurrent));
}
exports.mergeScan = mergeScan;
var MergeScanOperator = (function () {
    function MergeScanOperator(accumulator, seed, concurrent) {
        this.accumulator = accumulator;
        this.seed = seed;
        this.concurrent = concurrent;
    }
    MergeScanOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new MergeScanSubscriber(subscriber, this.accumulator, this.seed, this.concurrent));
    };
    return MergeScanOperator;
}());
exports.MergeScanOperator = MergeScanOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var MergeScanSubscriber = (function (_super) {
    __extends(MergeScanSubscriber, _super);
    function MergeScanSubscriber(destination, accumulator, acc, concurrent) {
        _super.call(this, destination);
        this.accumulator = accumulator;
        this.acc = acc;
        this.concurrent = concurrent;
        this.hasValue = false;
        this.hasCompleted = false;
        this.buffer = [];
        this.active = 0;
        this.index = 0;
    }
    MergeScanSubscriber.prototype._next = function (value) {
        if (this.active < this.concurrent) {
            var index = this.index++;
            var ish = tryCatch_1.tryCatch(this.accumulator)(this.acc, value);
            var destination = this.destination;
            if (ish === errorObject_1.errorObject) {
                destination.error(errorObject_1.errorObject.e);
            }
            else {
                this.active++;
                this._innerSub(ish, value, index);
            }
        }
        else {
            this.buffer.push(value);
        }
    };
    MergeScanSubscriber.prototype._innerSub = function (ish, value, index) {
        this.add(subscribeToResult_1.subscribeToResult(this, ish, value, index));
    };
    MergeScanSubscriber.prototype._complete = function () {
        this.hasCompleted = true;
        if (this.active === 0 && this.buffer.length === 0) {
            if (this.hasValue === false) {
                this.destination.next(this.acc);
            }
            this.destination.complete();
        }
    };
    MergeScanSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        var destination = this.destination;
        this.acc = innerValue;
        this.hasValue = true;
        destination.next(innerValue);
    };
    MergeScanSubscriber.prototype.notifyComplete = function (innerSub) {
        var buffer = this.buffer;
        this.remove(innerSub);
        this.active--;
        if (buffer.length > 0) {
            this._next(buffer.shift());
        }
        else if (this.active === 0 && this.hasCompleted) {
            if (this.hasValue === false) {
                this.destination.next(this.acc);
            }
            this.destination.complete();
        }
    };
    return MergeScanSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
exports.MergeScanSubscriber = MergeScanSubscriber;
//# sourceMappingURL=mergeScan.js.map

/***/ }),

/***/ "UFi/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var sequenceEqual_1 = __webpack_require__("xYP1");
Observable_1.Observable.prototype.sequenceEqual = sequenceEqual_1.sequenceEqual;
//# sourceMappingURL=sequenceEqual.js.map

/***/ }),

/***/ "UKiz":
/***/ (function(module, exports) {

exports.model=Model={Game:{},Board:{},Move:{}},function(){var t;Model.Game.cbConstants={MASK:65535,FLAG_MOVE:65536,FLAG_CAPTURE:131072,FLAG_STOP:262144,FLAG_SCREEN_CAPTURE:524288,FLAG_CAPTURE_KING:1048576,FLAG_CAPTURE_NO_KING:2097152};var e="undefined"!=typeof Int32Array;Model.Game.cbUseTypedArrays=e,Model.Game.cbTypedArray=function(t){if(e){var i=new Int32Array(t.length);return i.set(t),i}for(var r=[],a=t.length,n=0;n<a;n++)r.push(t[n]);return r},Model.Game.cbShortRangeGraph=function(t,e,i,r){var a=this;void 0===r&&(r=196608);for(var n={},s=0;s<t.boardSize;s++)n[s]=[],(!i||s in i)&&e.forEach(function(e){var o=t.Graph(s,e);null!=o&&(!i||o in i)&&n[s].push(a.cbTypedArray([o|r]))});return n},Model.Game.cbLongRangeGraph=function(t,e,i,r,a){var n=this;void 0!==r&&null!=r||(r=196608),a||(a=1/0);for(var s={},o=0;o<t.boardSize;o++)s[o]=[],(!i||o in i)&&e.forEach(function(e){for(var h=[],c=t.Graph(o,e),p=0;null!=c&&(!i||c in i)&&(h.push(c|r),++p!=a);)c=t.Graph(c,e);h.length>0&&s[o].push(n.cbTypedArray(h))});return s},Model.Game.cbNullGraph=function(t){for(var e={},i=0;i<t.boardSize;i++)e[i]=[];return e},Model.Game.cbAuthorGraph=function(t){for(var e={},i=0;i<t.boardSize;i++){e[i]=[];for(var r=0;r<t.boardSize;r++)e[i].push([2293760|r])}return e},Model.Game.cbMergeGraphs=function(t){for(var e=[],i=0;i<t.boardSize;i++){e[i]=[];for(var r=1;r<arguments.length;r++)e[i]=e[i].concat(arguments[r][i])}return e},Model.Game.cbGetThreatGraph=function(){function t(e,i){for(var r in s){var a=s[r];if(!(a.p.length<i.length+1)){for(var n=!0,o=0;o<i.length;o++)if(i[o]!=a.p[o]){n=!1;break}if(n){var h=a.p[i.length],c=e[h];void 0===c&&(c={e:{}},e[h]=c),a.p.length==i.length+1&&(c.t=a.t,c.ts=a.ts,c.tk=a.tk,delete s[r]),i.push(h),t(c.e,i),i.pop()}}}}var e=this;this.cbUseScreenCapture=!1,this.cbUseCaptureKing=!1,this.cbUseCaptureNoKing=!1;for(var i={1:[],"-1":[]},r=[],a=0;a<this.g.boardSize;a++)this.g.pTypes.forEach(function(t,i){t.graph[a].forEach(function(t){for(var n=[],s=0;s<t.length;s++){var o=t[s];1048576&o?(e.cbUseCaptureKing=!0,n.unshift({d:65535&o,a:a,tk:i})):2097152&o?(e.cbUseCaptureNoKing=!0,n.unshift({d:65535&o,a:a,tnk:i})):131072&o?n.unshift({d:65535&o,a:a,t:i}):262144&o?n.unshift({d:65535&o,a:a}):524288&o&&(e.cbUseScreenCapture=!0,n.unshift({d:65535&o,a:a,ts:i}))}n.length>0&&r.push(n)})});var n={};r.forEach(function(t){t.forEach(function(e,i){var r=n[e.d];void 0===r&&(r={},n[e.d]=r);for(var a=[],s=i+1;s<t.length;s++)a.push(t[s].d);a.push(e.a);var o=a.join(","),h=r[o];void 0===h&&(h={p:a,t:{},ts:{},tk:{}},r[o]=h),void 0!==e.t?h.t[e.t]=!0:void 0!==e.tk?h.tk[e.tk]=!0:void 0!==e.ts&&(h.ts[e.ts]=!0)})});for(var a=0;a<e.g.boardSize;a++){var s=n[a],o={};t(o,[]),i[1][a]=o,i[-1][a]=o}return i},Model.Game.InitGame=function(){var e=this;this.cbVar=t=this.cbDefine(),this.g.boardSize=this.cbVar.geometry.boardSize,this.g.pTypes=this.cbGetPieceTypes(),this.g.threatGraph=this.cbGetThreatGraph(),this.g.distGraph=this.cbVar.geometry.GetDistances(),this.cbPiecesCount=0,this.g.castleablePiecesCount={1:0,"-1":0};for(var i in t.pieceTypes){var r=t.pieceTypes[i];if(r.castle){(r.initial||[]).forEach(function(t){e.g.castleablePiecesCount[t.s]++})}r.initial&&(this.cbPiecesCount+=r.initial.length)}for(var a=[],i=0;i<this.cbPiecesCount;i++)a.push(i);var n=Object.keys(t.pieceTypes);this.zobrist=new JocGame.Zobrist({board:{type:"array",size:this.cbVar.geometry.boardSize,values:a},who:{values:["1","-1"]},type:{type:"array",size:this.cbPiecesCount,values:n}})},Model.Game.cbGetPieceTypes=function(){for(var t=[],e={},i=0;i<this.cbVar.geometry.boardSize;i++)e[i]=[];for(var r in this.cbVar.pieceTypes){var a=this.cbVar.pieceTypes[r];t[r]={graph:a.graph||e,abbrev:a.abbrev||"",value:a.isKing?100:a.value||1,isKing:!!a.isKing,castle:!!a.castle,epTarget:!!a.epTarget,epCatch:!!a.epCatch}}return t},Model.Board.Init=function(t){this.zSign=0},Model.Board.InitialPosition=function(i){var r=this;this.board=e?new Int16Array(i.g.boardSize):[];for(var a=0;a<i.g.boardSize;a++)this.board[a]=-1;if(this.kings={},this.pieces=[],this.ending={1:!1,"-1":!1},this.lastMove=null,i.cbVar.castle&&(this.castled={1:!1,"-1":!1}),this.zSign=i.zobrist.update(0,"who",-1),this.noCaptCount=0,this.mWho=1,i.mInitial)this.mWho=i.mInitial.turn||1,i.mInitial.pieces.forEach(function(t){var e={};for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i]);r.pieces.push(e)}),i.mInitial.lastMove&&(this.lastMove={f:i.mInitial.lastMove.f,t:i.mInitial.lastMove.t}),void 0!==i.mInitial.noCaptCount&&(this.noCaptCount=i.mInitial.noCaptCount),i.cbVar.castle&&i.mInitial.castle&&(this.castled={1:{k:!!i.mInitial.castle[1]&&!!i.mInitial.castle[1].k,q:!!i.mInitial.castle[1]&&!!i.mInitial.castle[1].q},"-1":{k:!!i.mInitial.castle[-1]&&!!i.mInitial.castle[-1].k,q:!!i.mInitial.castle[-1]&&!!i.mInitial.castle[-1].q}});else for(var n in i.cbVar.pieceTypes)for(var s=i.cbVar.pieceTypes[n],o=s.initial||[],h=0;h<o.length;h++){var c=o[h],p={s:c.s,t:parseInt(n),p:c.p,m:!1};this.pieces.push(p)}if(this.pieces.sort(function(t,e){if(t.s!=e.s)return e.s-t.s;var r=i.cbVar.pieceTypes[t.t].value||100,a=i.cbVar.pieceTypes[e.t].value||100;return r!=a?r-a:t.p-e.p}),this.pieces.forEach(function(t,e){t.i=e,r.board[t.p]=e,i.g.pTypes[t.t].isKing&&(r.kings[t.s]=t.p),r.zSign=i.zobrist.update(r.zSign,"board",e,t.p),r.zSign=i.zobrist.update(r.zSign,"type",t.t,e)}),i.mInitial&&i.mInitial.enPassant){var a=t.geometry.PosByName(i.mInitial.enPassant);if(a>=0){var l,v=t.geometry.C(a),f=t.geometry.R(a);l=1==i.mInitial.turn?t.geometry.POS(v,f-1):t.geometry.POS(v,f+1),this.epTarget={p:a,i:this.board[l]}}}},Model.Board.CopyFrom=function(t){if(e)this.board=new Int16Array(t.board.length),this.board.set(t.board);else{this.board=[];for(var i=t.board,r=i.length,a=0;a<r;a++)this.board.push(i[a])}this.pieces=[];for(var n=t.pieces.length,a=0;a<n;a++){var s=t.pieces[a];this.pieces.push({s:s.s,p:s.p,t:s.t,i:s.i,m:s.m})}this.kings={1:t.kings[1],"-1":t.kings[-1]},this.check=t.check,t.lastMove?this.lastMove={f:t.lastMove.f,t:t.lastMove.t,c:t.lastMove.c}:this.lastMove=null,this.ending={1:t.ending[1],"-1":t.ending[-1]},void 0!==t.castled&&(this.castled={1:t.castled[1],"-1":t.castled[-1]}),this.noCaptCount=t.noCaptCount,t.epTarget?this.epTarget={p:t.epTarget.p,i:t.epTarget.i}:this.epTarget=null,this.mWho=t.mWho,this.zSign=t.zSign},Model.Board.cbApplyCastle=function(t,e,i){var r=t.cbVar.castle[e.f+"/"+e.cg],a=r.r[r.r.length-1],n=this.pieces[this.board[e.cg]],s=r.k[r.k.length-1],o=this.pieces[this.board[e.f]];return i&&(this.zSign=t.zobrist.update(this.zSign,"board",n.i,e.cg),this.zSign=t.zobrist.update(this.zSign,"board",n.i,a),this.zSign=t.zobrist.update(this.zSign,"board",o.i,e.f),this.zSign=t.zobrist.update(this.zSign,"board",o.i,s)),n.p=a,n.m=!0,this.board[e.cg]=-1,o.p=s,o.m=!0,this.board[e.f]=-1,this.board[a]=n.i,this.board[s]=o.i,this.castled[n.s]=!0,this.kings[o.s]=s,[{i:n.i,f:a,t:-1},{i:o.i,f:s,t:e.f,kp:e.f,who:o.s,m:!1},{i:n.i,f:-1,t:e.cg,m:!1,cg:!1}]},Model.Board.cbQuickApply=function(t,e){if(void 0!==e.cg)return this.cbApplyCastle(t,e,!1);var i=[],r=this.board[e.f],a=this.pieces[r];if(null!=e.c){i.unshift({i:e.c,f:-1,t:this.pieces[e.c].p});var n=this.pieces[e.c];this.board[n.p]=-1,n.p=-1}var s=this.kings[a.s];return t.g.pTypes[a.t].isKing&&(this.kings[a.s]=e.t),i.unshift({i:r,f:e.t,t:e.f,kp:s,who:a.s,ty:a.t}),a.p=e.t,void 0!==e.pr&&(a.t=e.pr),this.board[e.f]=-1,this.board[e.t]=r,i},Model.Board.cbQuickUnapply=function(t,e){for(var i=0;i<e.length;i++){var r=e[i],a=this.pieces[r.i];r.f>=0&&(a.p=-1,this.board[r.f]=-1),r.t>=0&&(a.p=r.t,this.board[r.t]=r.i),void 0!==r.m&&(a.m=r.m),void 0!==r.kp&&(this.kings[r.who]=r.kp),void 0!=r.ty&&(a.t=r.ty),void 0!=r.cg&&(this.castled[a.s]=r.cg)}},Model.Board.ApplyMove=function(t,e){var i=this.pieces[this.board[e.f]];if(void 0!==e.cg)this.cbApplyCastle(t,e,!0);else{if(this.zSign=t.zobrist.update(this.zSign,"board",i.i,e.f),this.board[i.p]=-1,void 0!==e.pr&&(this.zSign=t.zobrist.update(this.zSign,"type",i.t,i.i),i.t=e.pr,this.zSign=t.zobrist.update(this.zSign,"type",i.t,i.i)),null!=e.c){var r=this.pieces[e.c];this.zSign=t.zobrist.update(this.zSign,"board",r.i,r.p),this.board[r.p]=-1,r.p=-1,r.m=!0,this.noCaptCount=0}else this.noCaptCount++;i.p=e.t,i.m=!0,this.board[e.t]=i.i,this.zSign=t.zobrist.update(this.zSign,"board",i.i,e.t),t.g.pTypes[i.t].isKing&&(this.kings[i.s]=e.t)}this.check=!!e.ck,this.lastMove={f:e.f,t:e.t,c:e.c},void 0!==e.ko&&(this.ending[i.s]=e.ko),void 0!==e.ept?this.epTarget={p:e.ept,i:i.i}:this.epTarget=null,this.zSign=t.zobrist.update(this.zSign,"who",-this.mWho),this.zSign=t.zobrist.update(this.zSign,"who",this.mWho)},Model.Board.Evaluate=function(i){function r(e){var i=1/0;for(var r in t.geometry.corners)i=Math.min(i,h.distGraph[n.kings[e]][r]);return i-Math.sqrt(h.boardSize)}var a="debug"==arguments[3],n=this;this.mEvaluation=0;var s,o=this.mWho,h=i.g;if(e)s={1:{count:new Uint8Array(h.pTypes.length),byType:{}},"-1":{count:new Uint8Array(h.pTypes.length),byType:{}}};else{s={1:{count:[],byType:{}},"-1":{count:[],byType:{}}};for(var c=0;c<h.pTypes.length;c++)s[1].count[c]=s[-1].count[c]=0}if(i.mOptions.preventRepeat&&i.GetRepeatOccurence(this)>2)return this.mFinished=!0,void(this.mWinner=i.cbOnPerpetual?o*i.cbOnPerpetual:JocGame.DRAW);for(var p={1:0,"-1":0},l={1:h.distGraph[this.kings[-1]],"-1":h.distGraph[this.kings[1]]},v={1:0,"-1":0},f={1:0,"-1":0},u={1:0,"-1":0},g={1:0,"-1":0},b={1:!1,"-1":!1},d=this.pieces,m=d.length,c=0;c<m;c++){var G=d[c];if(G.p>=0){var y=G.s,M=h.pTypes[G.t];M.isKing?b[y]=G.m:p[y]+=M.value,M.castle&&!G.m&&g[y]++,f[y]++,v[y]+=l[y][G.p],u[y]+=t.geometry.distEdge[G.p];var k=s[y];k.count[G.t]++;var S=k.byType;void 0===S[G.t]?S[G.t]=[G]:S[G.t].push(G)}}if(this.lastMove&&null!=this.lastMove.c){var G=this.pieces[this.board[this.lastMove.t]];p[-G.s]+=this.cbStaticExchangeEval(i,G.p,G.s,{piece:G})}var C={1:0,"-1":0},z={1:0,"-1":0},T={1:0,"-1":0};this.ending[1]&&(z[1]=(v[1]-Math.sqrt(h.boardSize))/f[1],t.geometry.corners&&(T[1]=r(1))),this.ending[-1]&&(z[-1]=(v[-1]-Math.sqrt(h.boardSize))/f[-1],t.geometry.corners&&(T[1]=r(-1)));var A={pieceValue:p[1]-p[-1],pieceValueRatio:(p[1]-p[-1])/(p[1]+p[-1]+1),posValue:u[1]-u[-1],averageDistKing:v[1]/f[1]-v[-1]/f[-1],check:this.check?-o:0,endingKingFreedom:C[1]-C[-1],endingDistKing:z[1]-z[-1],distKingCorner:T[1]-T[-1]};t.castle&&(A.castle=(this.castled[1]?1:b[1]?0:g[1]/(h.castleablePiecesCount[1]+1))-(this.castled[-1]?1:b[-1]?0:g[-1]/(h.castleablePiecesCount[-1]+1))),t.evaluate&&t.evaluate.call(this,i,A,s);var P=i.mOptions.levelOptions;for(var w in A){var E=A[w],R=P[w+"Factor"]||0,I=E*R;a&&console.log(w,"=",E,"*",R,"=>",I),this.mEvaluation+=I}a&&console.log("Evaluation",this.mEvaluation)},Model.Board.cbGeneratePseudoLegalMoves=function(t){function e(e,a){var n=t.cbVar.promote;if(!n)return void r.push(a);var s=n.call(i,t,e,a);if(null!=s)if(0==s.length)r.push(a);else if(1==s.length)a.pr=s[0],r.push(a);else for(var o=0;o<s.length;o++){var h=s[o];r.push({f:a.f,t:a.t,c:a.c,pr:h,ept:a.ept,ep:a.ep,a:a.a})}}for(var i=this,r=[],a=t.cbVar,n=this.mWho,s=!a.castle||this.check||this.castled[n]?null:[],o=-1,h=this.pieces.length,c=0;c<h;c++){var p=this.pieces[c];if(!(p.p<0||p.s!=n)){var l=t.g.pTypes[p.t];l.isKing&&(p.m?s=null:o=p),s&&l.castle&&!p.m&&s.push(p);var v,f;v=l.graph[p.p],f=v.length;for(var u=0;u<f;u++)for(var g=v[u],b=!1,d=g.length,m=null,G=0;G<d;G++){var y=g[G],M=65535&y,k=this.board[M];if(!(k<0)||l.epCatch&&this.epTarget&&this.epTarget.p==M){if(!(524288&y)){var S;S=k<0?this.pieces[this.epTarget.i]:this.pieces[k],!(S.s!=p.s&&131072&y)||1048576&y&&!t.g.pTypes[S.t].isKing||2097152&y&&t.g.pTypes[S.t].isKing||e(p,{f:p.p,t:M,c:S.i,a:l.abbrev,ep:k<0});break}if(b){var S=this.pieces[k];S.s!=p.s&&e(p,{f:p.p,t:M,c:S.i,a:l.abbrev});break}b=!0}else 65536&y&&0==b&&e(p,{f:p.p,t:M,c:null,a:l.abbrev,ept:null!=m&&l.epTarget?m:void 0});m=M}}}if(s)for(var c=0;c<s.length;c++){var C=s[c],z=t.cbVar.castle[o.p+"/"+C.p];if(z){for(var T=!0,u=0;u<z.r.length;u++){var A=z.r[u];if(this.board[A]>=0&&A!=o.p&&A!=C.p){T=!1;break}}if(T){for(var P=!0,u=0;u<z.k.length;u++){var A=z.k[u];if(this.board[A]>=0&&A!=C.p&&A!=o.p||this.cbGetAttackers(t,A,n).length>0){P=!1;break}}P&&r.push({f:o.p,t:z.k[z.k.length-1],c:null,cg:C.p})}}}return r},Model.Board.cbStaticExchangeEval=function(t,e,i,r){var a=0,n=this.cbGetSmallestAttacker(t,e,i);if(n){var s=this.mWho;this.mWho=n.s;var o=this.cbQuickApply(t,{f:n.p,t:e,c:r.piece.i}),h=t.g.pTypes[r.piece.t].value;r.piece=n,a=Math.max(0,h-this.cbStaticExchangeEval(t,e,-i,r)),this.cbQuickUnapply(t,o),this.mWho=s}return a},Model.Board.cbGetSmallestAttacker=function(t,e,i){var r=this.cbGetAttackers(t,e,i);if(0==r.length)return null;for(var a=1/0,n=null,s=r.length,o=0;o<s;o++){var h=r[o],c=t.g.pTypes[h.t].value;c<a&&(a=c,n=h)}return n},Model.Board.cbCollectAttackers=function(t,e,i,r){for(var a in e){var n=e[a],s=this.board[a];if(s<0)this.cbCollectAttackers(t,n.e,i,r);else{var o=this.pieces[s];o.s==-t&&(n.t&&o.t in n.t||r&&n.tk&&o.t in n.tk)&&i.push(o)}}},Model.Board.cbCollectAttackersScreen=function(t,e,i,r,a){for(var n in e){var s=e[n],o=this.board[n];if(o<0)this.cbCollectAttackersScreen(t,s.e,i,r,a);else{var h=this.pieces[o];!a&&h.s==-t&&(s.t&&h.t in s.t||r&&s.tk&&h.t in s.tk)?i.push(h):a?a&&h.s==-t&&s.ts&&h.t in s.ts&&i.push(h):this.cbCollectAttackersScreen(t,s.e,i,r,!0)}}},Model.Board.cbGetAttackers=function(t,e,i,r){var a=[];return t.cbUseScreenCapture?this.cbCollectAttackersScreen(i,t.g.threatGraph[i][e],a,r,!1):this.cbCollectAttackers(i,t.g.threatGraph[i][e],a,r),a},Model.Board.GenerateMoves=function(t){var e=this.cbGeneratePseudoLegalMoves(t);this.mMoves=[];for(var i=!0,r=this.kings[this.mWho],a=e.length,n=0;n<a;n++){var s=e[n],o=this.cbQuickApply(t,s);if(!(this.cbGetAttackers(t,this.kings[this.mWho],this.mWho,!0).length>0)){var h=this.cbGetAttackers(t,this.kings[-this.mWho],-this.mWho,!0).length>0;s.ck=h,this.mMoves.push(s),s.f!=r&&(i=!1)}this.cbQuickUnapply(t,o)}if(0==this.mMoves.length)this.mFinished=!0,this.mWinner=t.cbOnStaleMate?t.cbOnStaleMate*this.mWho:JocGame.DRAW,this.check&&(this.mWinner=-this.mWho);else if(this.ending[this.mWho]){if(!i)for(var n=0;n<this.mMoves.length;n++)this.mMoves[n].ko=!1}else if(!this.ending[this.mWho]&&i&&!this.check)for(var n=0;n<this.mMoves.length;n++)this.mMoves[n].ko=!0},Model.Board.GetSignature=function(){return this.zSign},Model.Move.Init=function(t){for(var e in t)t.hasOwnProperty(e)&&(this[e]=t[e])},Model.Move.Equals=function(t){return this.f==t.f&&this.t==t.t&&this.pr==t.pr},Model.Move.CopyFrom=function(t){this.Init(t)},Model.Move.ToString=function(e){var i=this;switch(e=e||"natural"){case"natural":return function(){var e;if(void 0!==i.cg?e=t.castle[i.f+"/"+i.cg].n:(e=i.a||"",e+=t.geometry.PosName(i.f),null==i.c?e+="-":e+="x",e+=t.geometry.PosName(i.t)),void 0!==i.pr){var r=t.pieceTypes[i.pr];r&&r.abbrev&&r.abbrev.length>0&&!r.silentPromo&&(e+="="+r.abbrev)}return i.ck&&(e+="+"),e}();case"engine":return function(){var e=t.geometry.PosName(i.f)+t.geometry.PosName(i.t);if(void 0!=i.pr){var r=t.pieceTypes[i.pr];r&&r.abbrev&&r.abbrev.length>0&&!r.silentPromo&&(e+=r.abbrev)}return e}();default:return"??"}},Model.Board.CompactMoveString=function(e,i,r){"function"!=typeof i.ToString&&(i=e.CreateMove(i));var a=i.ToString(),n=/^([A-Z]?)([a-z])([1-9][0-9]*)([-x])([a-z])([1-9][0-9]*)(.*?)$/.exec(a);if(!n)return a;var s=n[7];if(r||(r={}),r.value||(r.value=[]),0==r.value.length){var o=this.mMoves;this.mMoves&&0!=this.mMoves.length||this.GenerateMoves(e);for(var h=0;h<this.mMoves.length;h++){var c=this.mMoves[h];"function"!=typeof c.ToString&&(c=e.CreateMove(c)),r.value.push({str:c.ToString(),move:c})}this.mMoves=o}var p=[];if(r.value.forEach(function(t){var e=/^([A-Z]?[a-z][1-9][0-9]*[-x][a-z][1-9][0-9]*)(.*?)$/.exec(t.str);e&&t.move.t==i.t&&(t.move.a||"")==n[1]&&e[2]==s&&p.push(t.move)}),1==p.length)return""==n[1]&&"x"==n[4]?n[2]+"x"+n[5]+n[6]+n[7]:n[1]+("x"==n[4]?"x":"")+n[5]+n[6]+n[7];if(t.geometry.CompactCrit)for(var l="",h=0;;h++){var v=t.geometry.CompactCrit(i.f,h);if(null==v)return a;l+=v;for(var f=[],u=0;u<p.length;u++){var g=p[u];t.geometry.CompactCrit(g.f,h)==v&&f.push(g)}if(console.assert(f.length>0),1==f.length)return n[1]+l+("x"==n[4]?"x":"")+n[5]+n[6]+n[7];p=f}return a},Model.Board.cbIntegrity=function(t){function e(t,e){t||console.error(e)}for(var i=this,r=0;r<this.board.length;r++){var a=this.board[r];if(a>=0){var n=i.pieces[a];e(void 0!==n,"no piece at pos"),e(n.p==r,"piece has different pos")}}for(var a=0;a<this.pieces.length;a++){var n=this.pieces[a];n.p>=0&&e(i.board[n.p]==a,"board index mismatch")}},Model.Board.ExportBoardState=function(t){return t.cbVar.geometry.ExportBoardState?t.cbVar.geometry.ExportBoardState(this,t.cbVar,t.mPlayedMoves.length):"not supported"},Model.Game.Import=function(e,i){var r,a=[],n={1:{},"-1":{}},s=null,o=0;if("pjn"==e){var h={status:!1,error:"parse"},c=i.split(" ");if(6!=c.length)return console.warn("FEN should have 6 parts"),h;var p=c[0].split("/"),l=t.geometry.fenHeight||t.geometry.height;if(p.length!=l)return console.warn("FEN board should have",l,"rows, got",p.length),h;var v={};for(var f in t.pieceTypes){var u=t.pieceTypes[f],g=u.fenAbbrev||u.abbrev||"X";v[g.toUpperCase()]={s:1,t:f},v[g.toLowerCase()]={s:-1,t:f}}var b=t.geometry.FenRowPos||function(e,i){return(t.geometry.height-1-e)*t.geometry.width+i};if(p.forEach(function(e,i){for(var r=0,n=0;n<e.length;n++){var s=e.substr(n,1),o=v[s];if(void 0!==o){var c=b(i,r);r++;for(var p={s:o.s,t:o.t,p:c},l=!0,f=t.pieceTypes[p.t].initial||[],u=0;u<f.length;u++){var g=f[u];g.s==p.s&&g.p==c&&(l=!1)}p.m=l,a.push(p)}else{if(isNaN(parseInt(s)))return console.warn("FEN invalid board spec",s),h;r+=parseInt(s)}}}),a.sort(function(t,e){return e.s-t.s}),"w"==c[1])r=1;else{if("b"!=c[1])return console.warn("FEN invalid turn spec",c[1]),h;r=-1}n[1].k=c[2].indexOf("K")>=0,n[1].q=c[2].indexOf("Q")>=0,n[-1].k=c[2].indexOf("k")>=0,n[-1].q=c[2].indexOf("q")>=0,s="-"==c[3]?null:c[3];var d=parseInt(c[4]);isNaN(d)||(o=d);var m={pieces:a,turn:r,castle:n,enPassant:s,noCaptCount:o};return t.importGame&&t.importGame.call(this,m,e,i),{status:!0,initial:m}}return{status:!1,error:"unsupported"}}}(),function(){Model.Game.cbBoardGeometryHex=function(t,e){function i(t,e){for(var i=r(t),s=a(t),o=i,h=s,c=0;c<3;c++)for(var p=Math.abs(e[c]),l=0==p?0:e[c]/p,g=0;g<p;g++)h%2==v?(1==c&&l<0&&o--,2==c&&l>0&&o--):(1==c&&l>0&&o++,2==c&&l<0&&o++),1!=c&&2!=c||(h+=l),0==c&&(o+=l);if(o<0||o>=u||h<0||h>=f)return null;var t=n(o,h);return t in d?t:null}function r(t){return t%u}function a(t){return Math.floor(t/u)}function n(t,e){return e*u+t}function s(t){return void 0!==e[t]?e[t]:String.fromCharCode("a".charCodeAt(0)+r(t))+(a(t)+1)}function o(t){if(void 0!==l[t])return l[t];var e=/^([a-z])([0-9]+)$/.exec(t);return e?n(e[1].charCodeAt(0)-"a".charCodeAt(0),parseInt(e[2])-1):-1}function h(t,e){return 0==e?String.fromCharCode("a".charCodeAt(0)+r(t)):1==e?a(t)+1:null}function c(){return G}function p(e,i){var r=t[t.length-1-i][2*e];return" "==r&&(r=t[t.length-1-i][2*e+1]||" "),r}var l={};if(e)for(y in e)l[e[y]]=y;else e={};for(var v,f=t.length,u=0,g=!1,b=0,d={},m=0;m<t.length;m++)t[m].length%2==1&&t[m],t[m].length>b&&(b=t[m].length);for(var m=0;m<t.length;m++)for(;t[m].length<b;)t[m]+=" ";t.forEach(function(t,e){" "!=t[0]&&(v=e%2);var i=Math.ceil(t.length/2);i>u&&(u=i)}),t.forEach(function(e,i){(t.length-1-i)%2==1-v&&(" "==e[e.length-1]&&" "==e[e.length-2]||(g=!0));for(var r=0;r<e.length;r+=2)if(" "!=e[r]||r+1<e.length&&" "!=e[r+1]){var a=i*u+r/2;d[a]=1}});var G={};for(var y in d)G[y]={},G[y][y]=0;for(var M=[[1,0,0],[0,1,0],[0,0,1],[-1,0,0],[0,-1,0],[0,0,-1]],k=!0;k;){k=!1;for(var y in d)M.forEach(function(t){var e=i(y,t);if(null!=e){1!=G[y][e]&&(G[y][e]=1,G[e][y]=1,k=!0);for(var r in d)r!=y&&(void 0===G[e][r]&&void 0!==G[y][r]?(G[e][r]=G[y][r]+1,G[r][e]=G[y][r]+1,k=!0):void 0!==G[e][r]&&void 0!==G[y][r]&&G[e][r]>G[y][r]+1&&(G[e][r]=G[y][r]+1,G[r][e]=G[y][r]+1,k=!0))}})}var S=0,C={};for(var y in d){var z=0;for(var T in d){var A=G[y][T];z+=A*A}z>S?(C={},C[y]=1,S=z):z==S&&(C[y]=1)}for(var P={},k=!0;k;){k=!1;for(var y in d)y in P||M.forEach(function(t){var e=i(y,t);null==e?P[y]=1:e in P&&(y in P&&!(P[y]>P[e]+1)||(P[y]=P[e]+1,k=!0))})}return{boardSize:u*f,width:u,height:f,C:r,R:a,POS:n,Graph:i,PosName:s,PosByName:o,CompactCrit:h,GetDistances:c,distEdge:P,corners:C,SHIFTMOD2:v,SHIFTRIGHT:g,CellType:p,confine:d}};var t=Model.Game.cbConstants,e=[[1,0,0],[0,1,0],[0,0,1],[-1,0,0],[0,-1,0],[0,0,-1]],i=[[1,1,0],[0,1,1],[-1,0,1],[-1,-1,0],[0,-1,-1],[1,0,-1]],r=[[2,1,0],[1,2,0],[0,2,1],[0,1,2],[-1,0,2],[-2,0,1],[-2,-1,0],[-1,-2,0],[0,-2,-1],[0,-1,-2],[1,0,-2],[2,0,-1]];Model.Game.cbGLKingGraph=function(t){return this.cbShortRangeGraph(t,i.concat(e),t.confine)},Model.Game.cbGLRookGraph=function(t){return this.cbLongRangeGraph(t,e,t.confine)},Model.Game.cbGLBishopGraph=function(t){return this.cbLongRangeGraph(t,i,t.confine)},Model.Game.cbGLQueenGraph=function(t){return this.cbLongRangeGraph(t,i.concat(e),t.confine)},Model.Game.cbGLKnightGraph=function(t){return this.cbShortRangeGraph(t,r,t.confine)},Model.Game.cbGLPawnGraph=function(e,i,r){for(var a=this.cbLongRangeGraph(e,[[i,0,0]],e.confine,t.FLAG_MOVE,r),n={1:[[0,1,0],[0,0,-1]],"-1":[[0,0,1],[0,-1,0]]},s=this.cbShortRangeGraph(e,n[i],e.confine,t.FLAG_CAPTURE),o=[],h=0;h<e.boardSize;h++)o[h]=a[h].concat(s[h]);return o},Model.Game.cbBRInitialPawnGraph=function(e,i){for(var r=this.cbLongRangeGraph(e,[[0,-i,0],[0,0,-i]],e.confine,t.FLAG_MOVE,2),a=this.cbShortRangeGraph(e,[[-i,-i,0],[i,0,-i],[0,-i,-i]],e.confine,t.FLAG_CAPTURE),n=[],s=0;s<e.boardSize;s++)n[s]=r[s].concat(a[s]);return n},Model.Game.cbDVInitialPawnGraph=function(e,i){for(var r=this.cbLongRangeGraph(e,[[0,-i,0],[0,0,-i]],e.confine,t.FLAG_MOVE,2),a=this.cbShortRangeGraph(e,[[-i,-i,0],[i,0,-i]],e.confine,t.FLAG_CAPTURE),n=[],s=0;s<e.boardSize;s++)n[s]=r[s].concat(a[s]);return n},Model.Game.cbBRPawnGraph=function(e,i){for(var r=this.cbShortRangeGraph(e,[[0,-i,0],[0,0,-i]],e.confine,t.FLAG_MOVE),a=this.cbShortRangeGraph(e,[[-i,-i,0],[i,0,-i]],e.confine,t.FLAG_CAPTURE),n=[],s=0;s<e.boardSize;s++)n[s]=r[s].concat(a[s]);return n},Model.Game.cbMCPawnGraph=function(e,i,r){for(var a=this.cbLongRangeGraph(e,[[i,0,0]],e.confine,t.FLAG_MOVE,r),n=this.cbShortRangeGraph(e,[[i,0,-i],[i,i,0]],e.confine,t.FLAG_CAPTURE),s=[],o=0;o<e.boardSize;o++)s[o]=a[o].concat(n[o]);return s}}(),function(){var t={2:"a1",11:"b1",21:"c1",30:"d1",40:"e1",3:"a2",12:"b2",22:"c2",31:"d2",41:"e2",50:"f2",4:"a3",13:"b3",23:"c3",32:"d3",42:"e3",51:"f3",61:"g3",5:"a4",14:"b4",24:"c4",33:"d4",43:"e4",52:"f4",62:"g4",71:"h4",6:"a5",15:"b5",25:"c5",34:"d5",44:"e5",53:"f5",63:"g5",72:"h5",82:"i5",7:"a6",16:"b6",26:"c6",35:"d6",45:"e6",54:"f6",64:"g6",73:"h6",83:"i6",17:"b7",27:"c7",36:"d7",46:"e7",55:"f7",65:"g7",74:"h7",84:"i7",28:"c8",37:"d8",47:"e8",56:"f8",66:"g8",75:"h8",85:"i8",38:"d9",48:"e9",57:"f9",67:"g9",76:"h9",86:"i9",49:"e10",58:"f10",68:"g10",77:"h10",87:"i10",65:"f11"},e=Model.Game.cbBoardGeometryHex(["    # . + # . +     ","   . + # . + # .    ","  + # . + # . + #   "," # . + # . + # . +  ",". + # . + # . + # . "," # . + # . + # . +  ","  + # . + # . + #   ","   . + # . + # .    ","    # . + # . +     "],t),i={1:{7:1,17:1,28:1,38:1,49:1,58:1,68:1,77:1,87:1},"-1":{2:1,11:1,21:1,30:1,40:1,50:1,61:1,71:1,82:1}},r={1:{},"-1":{}},a=e.GetDistances();["1","-1"].forEach(function(t){for(var n in e.confine){var s=1/0;for(var o in i[t]){var h=a[n][o];h<s&&(r[t][n]=h,s=h)}}}),Model.Game.cbDefine=function(){return{geometry:e,pieceTypes:{0:{name:"pawn-w",aspect:"pawn",graph:this.cbMCPawnGraph(e,1,1),value:1,abbrev:"",fenAbbrev:"P",initial:[{s:1,p:3},{s:1,p:83}],epCatch:!0},1:{name:"ipawn-w",aspect:"pawn",graph:this.cbMCPawnGraph(e,1,2),value:1,abbrev:"",fenAbbrev:"P",initial:[{s:1,p:12},{s:1,p:22},{s:1,p:62},{s:1,p:72}],epTarget:!0},2:{name:"pawn-b",aspect:"pawn",graph:this.cbMCPawnGraph(e,-1,1),value:1,abbrev:"",fenAbbrev:"P",initial:[{s:-1,p:6},{s:-1,p:86}],epCatch:!0},3:{name:"ipawn-b",aspect:"pawn",graph:this.cbMCPawnGraph(e,-1,2),value:1,abbrev:"",fenAbbrev:"P",initial:[{s:-1,p:16},{s:-1,p:27},{s:-1,p:76},{s:-1,p:67}],epTarget:!0},4:{name:"knight",graph:this.cbGLKnightGraph(e),value:2.9,abbrev:"N",initial:[{s:1,p:11},{s:1,p:61},{s:-1,p:28},{s:-1,p:77}]},5:{name:"bishop",graph:this.cbGLBishopGraph(e),value:3.1,abbrev:"B",initial:[{s:1,p:21},{s:1,p:50},{s:1,p:71},{s:-1,p:17},{s:-1,p:38},{s:-1,p:68}]},6:{name:"rook",graph:this.cbGLRookGraph(e),value:5,abbrev:"R",initial:[{s:1,p:2},{s:1,p:82},{s:-1,p:7},{s:-1,p:87}],castle:!0},7:{name:"queen",graph:this.cbGLQueenGraph(e),value:9,abbrev:"Q",initial:[{s:1,p:30},{s:-1,p:58}]},8:{name:"king",isKing:!0,graph:this.cbGLKingGraph(e),abbrev:"K",initial:[{s:1,p:40},{s:-1,p:49}]},9:{name:"icpawn-w",aspect:"pawn",graph:this.cbMCPawnGraph(e,1,3),value:1,abbrev:"",fenAbbrev:"P",initial:[{s:1,p:31},{s:1,p:41},{s:1,p:51}],epTarget:!0},10:{name:"icpawn-b",aspect:"pawn",graph:this.cbMCPawnGraph(e,-1,3),value:1,abbrev:"",fenAbbrev:"P",initial:[{s:-1,p:37},{s:-1,p:48},{s:-1,p:57}],epTarget:!0}},castle:{"40/2":{k:[30,21],r:[11,21,30],Xn:"O-O"},"40/82":{k:[50,61],r:[71,61,50],Xn:"O-O"},"49/87":{k:[58,68],r:[77,68,58],n:"O-O"},"49/7":{k:[38,28],r:[17,28,38],n:"O-O"}},promote:function(t,e,r){return 1==e.t||9==e.t?[0]:3==e.t||10==e.t?[2]:0==e.t&&r.t in i[1]?[4,5,6,7]:2==e.t&&r.t in i[-1]?[4,5,6,7]:[]},evaluate:function(t,e,i){var a=i[1].count,n=i[-1].count;a[0]||a[1]||a[4]||a[5]||a[6]||a[7]||n[2]||n[3]||n[6]||n[7]||!(n[4]+n[5]<2||n[5]<2)||(this.mFinished=!0,this.mWinner=JocGame.DRAW),n[2]||n[3]||n[4]||n[5]||n[6]||n[7]||a[0]||a[1]||a[6]||a[7]||!(a[4]+a[5]<2||a[5]<2)||(this.mFinished=!0,this.mWinner=JocGame.DRAW),this.noCaptCount>=100&&(this.mFinished=!0,this.mWinner=JocGame.DRAW);var s,o=t.cbUseTypedArrays?new Int8Array(3):[0,0,0],h=i[1].byType[0];if(h){s=h.length;for(var c=0;c<s;c++){var p=r[1][h[c].p];p>0&&p<4&&o[p-1]++}}if(h=i[-1].byType[2]){s=h.length;for(var c=0;c<s;c++){var p=r[-1][h[c].p];p>0&&p<4&&o[p-1]--}}0!=o[0]&&(e.distPawnPromo1=o[0]),0!=o[1]&&(e.distPawnPromo2=o[1]),0!=o[2]&&(e.distPawnPromo3=o[2]);for(var l=0,v=4;v<=5;v++)for(var f=1;f>=-1;f-=2){var u=i[f].byType[v];if(u)for(var c=0;c<u.length;c++)u[c].m&&(l+=f)}0!=l&&(e.minorPiecesMoved=l)}}};var n={2:{k:[11],r:[11,21]},82:{k:[71],r:[61]},87:{k:[77],r:[68]},7:{k:[17],r:[28]}},s=Model.Board.GenerateMoves;Model.Board.GenerateMoves=function(t){if(s.apply(this,arguments),!this.castled[this.mWho])for(var e=0;e<this.mMoves.length;e++){var i=this.mMoves[e],r=n[i.cg];if(r){var a=this.board[i.f],o=this.pieces[a];this.board[i.f]=-1,this.board[r.k[0]]=a,o.p=r.k[0];var h=this.cbGetAttackers(t,o.p,this.mWho,!0).length>0;if(!h){var c=this.board[i.cg],p=this.pieces[c];this.board[i.cg]=-1,this.board[r.r[0]]=c,p.p=r.r[0];var l=this.cbGetAttackers(t,this.kings[-this.mWho],-this.mWho,!0).length>0;this.mMoves.push({f:i.f,t:r.k[0],c:null,ck:l,a:"K"}),this.board[r.r[0]]=-1,this.board[i.cg]=c,p.p=i.cg}this.board[r.k[0]]=-1,this.board[i.f]=a,o.p=i.f}}},Model.Game.wbExtraCastleRook={11:{r0:2,r:21},71:{r0:82,r:61},17:{r0:7,r:28},77:{r0:87,r:68}};var o=Model.Board.ApplyMove;Model.Board.ApplyMove=function(t,e){if("K"==e.a&&!this.castled[this.mWho]&&void 0===e.cg){if(3==t.g.distGraph[e.t][e.f]){var i=this.pieces[this.board[e.f]];this.board[e.f]=-1,this.zSign=t.zobrist.update(this.zSign,"board",i.i,e.f),this.board[e.t]=i.i,this.zSign=t.zobrist.update(this.zSign,"board",i.i,e.t),i.p=e.t,this.kings[this.mWho]=i.p;var r=t.wbExtraCastleRook[e.t],a=this.pieces[this.board[r.r0]];return this.board[r.r0]=-1,this.zSign=t.zobrist.update(this.zSign,"board",a.i,r.r0),this.board[r.r]=a.i,this.zSign=t.zobrist.update(this.zSign,"board",a.i,r.r),a.p=r.r,this.check=!!e.ck,void(this.castled[this.mWho]=!0)}}o.apply(this,arguments)}}();

/***/ }),

/***/ "UMww":
/***/ (function(module, exports) {

exports.model=Model={Game:{},Board:{},Move:{}},Model.Game.InitGameInfo=function(){},Model.Game.BuildGraphCoord=function(){var i=[],t=[];this.g.Graph=i,this.g.Coord=t},Model.Game.InitGame=function(){this.BuildGraphCoord(),this.g.TripletsByPos=[];for(var i=0;i<this.g.Coord.length;i++)this.g.TripletsByPos[i]=[];for(var i in this.g.Triplets)if(this.g.Triplets.hasOwnProperty(i)){var t=this.g.Triplets[i];for(var e in t)if(t.hasOwnProperty(e)){var s=t[e];this.g.TripletsByPos[s].push(t)}}this.InitGameExtra()},Model.Game.DestroyGame=function(){},Model.Game.MillsDirections=4,Model.Game.MillsEachDirection=function(i,t){for(var e=0;e<this.MillsDirections;e++){var s=this.g.Graph[i][e];null!=s&&t(s)}},Model.Move.Init=function(i){this.f=i.f,this.t=i.t,this.c=i.c},Model.Move.CopyFrom=function(i){this.f=i.f,this.t=i.t,this.c=i.c},Model.Move.Equals=function(i){return this.t==i.t&&this.c==i.c&&this.f==i.f},Model.Move.ToString=function(){var i="";return this.f>-1&&(i+=this.f+">"),i+=this.t,this.c>-1&&(i+="x"+this.c),i},Model.Board.Init=function(i){},Model.Board.InitialPosition=function(i){var t=i.g.Coord.length,e=i.mOptions.mencount;this.board=[];for(var s=0;s<t;s++)this.board[s]=-1;this.pieces=[],this.dock={1:[],"-1":[]},this.menCount={1:0,"-1":0};for(var o=0,r=0;r<2;r++)for(var n=0==r?1:-1,h=0;h<e;h++)this.dock[n].unshift(o),this.pieces.push({s:n,a:!0,d:h,p:-1,i:o++});this.placing=!0},Model.Board.StaticGenerateMoves=function(i){if(0==i.mFullPlayedMoves.length){for(var t=[],e=0;e<i.g.Coord.length;e++)t.push({f:-1,t:e,c:-1});return t}return null},Model.Board.GenerateMoves=function(i){this.mMoves=[],this.placing?this.GeneratePlacingMoves(i):i.mOptions.canFly?this.GenerateFlyingMoves(i):this.GenerateMovingMoves(i),0==this.mMoves.length&&(this.mFinished=!0,this.menCount[JocGame.PLAYER_A]+this.menCount[JocGame.PLAYER_B]==i.g.Coord.length?this.mWinner=JocGame.DRAW:this.mWinner=-this.mWho)},Model.Board.GeneratePlacingMoves=function(i){for(var t=0;t<i.g.Coord.length;t++)if(this.board[t]==-1){var e=!0;if(void 0!==i.mLevelInfo&&i.mCurrentLevel>=0){var s=i.mLevelInfo.maxDepth-i.mCurrentLevel;if(s>=i.mLevelInfo.placingRace){e=!1;for(var o in i.g.TripletsByPos[t])if(i.g.TripletsByPos[t].hasOwnProperty(o)){for(var r=i.g.TripletsByPos[t][o],n=0,h=0,a=0,l=0;l<3;l++)this.board[r[l]]==-1?a++:this.pieces[this.board[r[l]]].s==this.mWho?n++:h++;if(2==n||1==n&&0==h||2==h){e=!0;break}}}}e&&this.GenerateCapturingMoves(i,{f:-1,t:t,c:-1})}},Model.Board.GenerateMovingMoves=function(i){$this=this;for(var t=0;t<this.pieces.length;t++){var e=this.pieces[t];e.a&&e.s==this.mWho&&i.MillsEachDirection(e.p,function(t){$this.board[t]==-1&&$this.GenerateCapturingMoves(i,{f:e.p,t:t,c:-1})})}},Model.Board.GenerateFlyingMoves=function(i){if(3!=this.menCount[this.mWho])this.GenerateMovingMoves(i);else for(var t=0;t<this.pieces.length;t++){var e=this.pieces[t];if(e.a&&e.s==this.mWho)for(var s=0;s<this.board.length;s++)this.board[s]==-1&&this.GenerateCapturingMoves(i,{f:e.p,t:s,c:-1})}},Model.Board.GenerateCapturingMoves=function(i,t){for(var e in i.g.TripletsByPos[t.t])if(i.g.TripletsByPos[t.t].hasOwnProperty(e)){for(var s=i.g.TripletsByPos[t.t][e],o=!0,r=0;r<3;r++){var n=s[r];if(n!=t.t){if(this.board[n]==-1||t.f==n){o=!1;break}var h=this.pieces[this.board[n]];if(0==h.a||h.d>-1||h.s!=this.mWho){o=!1;break}}}if(o){if(3==this.menCount[-this.mWho]&&0==this.placing)return void this.mMoves.push({f:t.f,t:t.t,c:-2});for(var a=[],r=0;r<this.pieces.length;r++){var h=this.pieces[r];if(1==h.a&&h.d==-1&&h.s==-this.mWho){var l={f:t.f,t:t.t,c:h.p};a.push(l)}}if(0==i.mOptions.poundInMill){var c={};for(var f in i.g.Triplets)if(i.g.Triplets.hasOwnProperty(f)){var d=i.g.Triplets[f];this.board[d[0]]!=-1&&this.pieces[this.board[d[0]]].s==-this.mWho&&this.board[d[1]]!=-1&&this.pieces[this.board[d[1]]].s==-this.mWho&&this.board[d[2]]!=-1&&this.pieces[this.board[d[2]]].s==-this.mWho&&(c[d[0]]=!0,c[d[1]]=!0,c[d[2]]=!0)}for(var v=[],f=0;f<a.length;f++)c[a[f].c]||v.push(a[f]);v.length>0&&(a=v)}return void(this.mMoves=this.mMoves.concat(a))}}this.mMoves.push({f:t.f,t:t.t,c:-1})},Model.Board.Evaluate=function(i,t,e){if(i.GetRepeatOccurence(this)>2)return this.mFinished=!0,void(this.mWinner=JocGame.DRAW);if(0==this.placing){if(this.menCount[JocGame.PLAYER_A]<3)return this.mFinished=!0,void(this.mWinner=JocGame.PLAYER_B);if(this.menCount[JocGame.PLAYER_B]<3)return this.mFinished=!0,void(this.mWinner=JocGame.PLAYER_A)}var s=this.menCount[JocGame.PLAYER_A]-this.menCount[JocGame.PLAYER_B],o=0,r=0;for(var n in i.g.Triplets)if(i.g.Triplets.hasOwnProperty(n)){for(var h={"-1":0,0:0,1:0},a=i.g.Triplets[n],l=0;l<3;l++){var c=a[l],f=this.board[c];if(f>-1){var d=this.pieces[f];h[d.s]++}}1==h[1]&&0==h[-1]?o++:2==h[1]&&0==h[-1]&&r++,1==h[-1]&&0==h[1]?o--:2==h[-1]&&0==h[1]&&r--}this.mEvaluation=10*s,this.mEvaluation+=1*o,this.mEvaluation+=3*r},Model.Board.ApplyMove=function(i,t){if(this.placing){var e=this.dock[this.mWho].shift(),s=this.pieces[e];s.d=-1,s.p=t.t,this.board[t.t]=e,this.lastMoveIndex=e,this.menCount[this.mWho]++,0==this.dock[JocGame.PLAYER_B].length&&(this.placing=!1)}else{var s=this.pieces[this.board[t.f]];this.board[s.p]=-1,this.board[t.t]=s.i,s.p=t.t,this.lastMoveIndex=s.i}if(t.c>-1){var e=this.board[t.c];this.board[t.c]=-1;var s=this.pieces[e];s.a=!1,this.menCount[-this.mWho]--}else t.c==-2&&this.menCount[-this.mWho]--},Model.Board.IsValidMove=function(i,t){return!0},Model.Game.InitGameExtra=function(){},Model.Game.BuildGraphCoord=function(){this.g.Graph=[[1,9,null,3],[2,4,0,null],[null,14,1,5],[4,10,0,6],[5,7,3,1],[2,13,4,8],[7,11,null,3],[8,null,6,4],[null,12,7,5],[10,21,null,0],[11,18,9,3],[null,15,10,6],[13,17,null,8],[14,20,12,5],[null,23,13,2],[16,null,18,11],[17,19,15,null],[20,null,16,12],[19,21,15,10],[20,22,18,16],[23,17,19,13],[22,null,18,9],[23,null,21,19],[20,null,22,14]],this.g.Coord=[[0,0],[0,3],[0,6],[1,1],[1,3],[1,5],[2,2],[2,3],[2,4],[3,0],[3,1],[3,2],[3,4],[3,5],[3,6],[4,2],[4,3],[4,4],[5,1],[5,3],[5,5],[6,0],[6,3],[6,6]],this.g.Triplets=[[0,1,2],[3,4,5],[6,7,8],[9,10,11],[12,13,14],[15,16,17],[18,19,20],[21,22,23],[0,9,21],[3,10,18],[6,11,15],[1,4,7],[16,19,22],[8,12,17],[5,13,20],[2,14,23],[0,3,6],[17,20,23],[2,5,8],[15,18,21]]};

/***/ }),

/***/ "UNGF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var reduce_1 = __webpack_require__("pgP5");
Observable_1.Observable.prototype.reduce = reduce_1.reduce;
//# sourceMappingURL=reduce.js.map

/***/ }),

/***/ "UNwW":
/***/ (function(module, exports) {

exports.config = {"status":true,"model":{"plazza":"true","title-en":"Thai Draughts","module":"checkers","maxLevel":20,"summary":"Checkers according to Thai rules.","thumbnail":"draughts8-thumb3d.png","rules":"rules-thai-draughts.html","description":"description.html","credits":"credits.html","js":["checkersbase-model.js","draughts-model.js"],"gameOptions":{"preventRepeat":true,"width":4,"height":8,"initial":{"a":[[0,0],[0,1],[0,2],[0,3],[1,0],[1,1],[1,2],[1,3]],"b":[[7,0],[7,1],[7,2],[7,3],[6,0],[6,1],[6,2],[6,3]]},"variant":{"mustMoveForwardStrict":true,"lastRowCrown":true,"captureLongestLine":false,"lastRowFactor":0.001,"kingValue":4,"kingCaptureShort":true,"captureInstantRemove":true,"noMove":"lose","king180deg":true},"uctTransposition":"state"},"levels":[{"label":"Fast","ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.5,"maxDuration":1,"isDefault":true},{"label":"Beginner","ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.5,"maxDuration":0.5,"maxNodes":100,"maxLoops":200},{"label":"Easy","ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.5,"maxDuration":1,"maxNodes":2500,"maxLoops":500},{"label":"Medium","ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.5,"maxDuration":2,"maxNodes":5500,"maxLoops":500},{"label":"Hard","ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.5,"maxDuration":5,"maxNodes":2000,"maxLoops":3500},{"label":"Expert","ai":"uct","c":0.8,"playoutDepth":0,"minVisitsExpand":1,"ignoreLeaf":false,"uncertaintyFactor":5,"propagateMultiVisits":false,"maxDuration":60,"maxNodes":15000,"maxLoops":8000}]},"view":{"js":["checkers-xd-view.js","draughts8-xd-view.js"],"css":["checkersbase.css","draughts.css"],"title-en":"Draughts View","skins":[{"name":"classic3d","title":"3D Classic","3d":true,"camera":{"radius":24,"elevationAngle":65,"limitCamMoves":true,"distMax":30,"fov":35},"world":{"lightIntensity":0.7,"skyLightIntensity":0.5,"lightPosition":{"x":-15,"y":15,"z":0},"lightShadowDarkness":0.45,"ambientLightColor":8947848,"color":4686804,"fog":false},"preload":["image|/res/images/wood-chipboard-5.jpg","image|/res/xd-view/meshes/piecetop-bump.jpg","image|/res/xd-view/meshes/piecediff.jpg","image|/res/xd-view/meshes/piecetop-queen-mask.png","smoothedfilegeo|0|/res/xd-view/meshes/ring-target.js","smoothedfilegeo|0|/res/xd-view/meshes/piece-v2.js"]},{"name":"turtles3d","title":"3D Turtles","3d":true,"camera":{"radius":14,"elevationAngle":45,"limitCamMoves":true,"distMax":40},"world":{"lightIntensity":0,"skyLightIntensity":3,"fog":true,"color":3645658,"lightPosition":{"x":-5,"y":18,"z":5},"lightShadowDarkness":0.55,"ambientLightColor":4473924},"preload":["image|/res/images/wood-chipboard-5.jpg","image|/res/xd-view/meshes/turtle.png","image|/res/xd-view/meshes/star.png","image|/res/xd-view/meshes/rock.jpg","smoothedfilegeo|0|/res/xd-view/meshes/turtle-legs-smoothed.js","smoothedfilegeo|0|/res/xd-view/meshes/turtle-head-smoothed.js","smoothedfilegeo|0|/res/xd-view/meshes/turtle-tail-smoothed.js","smoothedfilegeo|0|/res/xd-view/meshes/turtle-hotel.js","smoothedfilegeo|0|/res/xd-view/meshes/turtle-house.js","smoothedfilegeo|0|/res/xd-view/meshes/rainbowflat.js","smoothedfilegeo|0|/res/xd-view/meshes/ring-target.js","smoothedfilegeo|0|/res/xd-view/meshes/rocksmoothed.js","smoothedfilegeo|0|/res/xd-view/meshes/turtle-fences.js"]},{"name":"classical","title":"Classic"},{"name":"marble0","title":"Marble"},{"name":"wood0","title":"Wood"},{"name":"green","title":"Green"}],"visuals":{"600x600":["res/visuals/thai-draughts-600x600-3d.jpg","res/visuals/thai-draughts-600x600-2d.jpg"]},"sounds":{"move1":"move1","move2":"move2","move3":"move3","move4":"move4","tac1":"tac1","tac2":"tac1","tac3":"tac1","promo":"promo","usermove":null},"module":"checkers","preferredRatio":1,"switchable":true,"animateSelfMoves":false,"useNotation":true,"useShowMoves":true,"defaultOptions":{"sounds":true,"notation":false,"moves":true},"xdView":true}}

/***/ }),

/***/ "UZYs":
/***/ (function(module, exports) {

exports.model=Model={Game:{},Board:{},Move:{}},Model.Game.InitGame=function(){for(var r=this,o=this.mOptions.size,e=[],t=[],i=0,a=0,n=[],s=0;s<o;s++)n.push(a),a+=(o-s)*(o-s);for(var s=0;s<o;s++)for(var p=0;p<o-s;p++)for(var u=0;u<o-s;u++){var l=i++;e[l]=[p,u,s],t[l]=[];for(var h=0;h<2;h++)for(var f=0;f<2;f++){var v=s-1,d=p+h,g=u+f;v>=0&&v<o&&d>=0&&d<o-v&&g>=0&&g<o-v?t[l].push(n[v]+d*(o-v)+g):t[l].push(null)}var c=[[0,-1],[0,1],[-1,0],[1,0]];for(var b in c){var m=c[b],v=s,d=p+m[0],g=u+m[1];v>=0&&v<o&&d>=0&&d<o-v&&g>=0&&g<o-v?t[l].push(n[v]+d*(o-v)+g):t[l].push(null)}for(var h=-1;h<1;h++)for(var f=-1;f<1;f++){var v=s+1,d=p+h,g=u+f;v>=0&&v<o&&d>=0&&d<o-v&&g>=0&&g<o-v?t[l].push(n[v]+d*(o-v)+g):t[l].push(null)}}this.g.Graph=t,this.g.Coord=e,this.g.Over=[],this.g.Beneath=[];for(var l=0;l<this.g.Graph.length;l++)this.g.Over[l]=null,this.g.Beneath[l]=null;for(var l=0;l<this.g.Graph.length;l++)for(var e=this.g.Coord[l],G=l+1;G<this.g.Graph.length;G++){var y=this.g.Coord[G];if(y[2]==e[2]+2&&y[0]==e[0]-1&&y[1]==e[1]-1){this.g.Over[l]=G,this.g.Beneath[G]=l;break}}this.g.EachDirection=function(o,e){for(var t=0;t<12;t++){var i=r.g.Graph[o][t];if(null!=i&&0==e(i,t))return}},this.g.EachDirectionDown=function(o,e){for(var t=[0,1,2,3],i=0;i<t.length;i++){var a=r.g.Graph[o][t[i]];if(null!=a&&0==e(a,t[i]))return}},this.g.EachDirectionUp=function(o,e){for(var t=[8,9,10,11],i=0;i<t.length;i++){var a=r.g.Graph[o][t[i]];if(null!=a&&0==e(a,t[i]))return}},this.g.EachDirectionFlat=function(o,e){for(var t=[4,5,6,7],i=0;i<t.length;i++){var a=r.g.Graph[o][t[i]];if(null!=a&&0==e(a,t[i]))return}},this.g.EachDirectionFlatDown=function(o,e){for(var t=[0,1,2,3,4,5,6,7],i=0;i<t.length;i++){var a=r.g.Graph[o][t[i]];if(null!=a&&0==e(a,t[i]))return}},this.g.EachDirectionFlatUp=function(o,e){for(var t=[4,5,6,7,8,9,10,11],i=0;i<t.length;i++){var a=r.g.Graph[o][t[i]];if(null!=a&&0==e(a,t[i]))return}},this.zobrist=new JocGame.Zobrist({board:{type:"array",size:this.g.Graph.length,values:[0,1]}}),this.InitGameExtra()},Model.Game.MapSameLevelDiagGraph=function(){for(var r=[0,16,25,29],o=0;o<4;o++)for(var e=0;e<4-o;e++)for(var t=0;t<4-o;t++)for(var i=r[o]+e*(4-o)+t,a=-1;a<2;a+=2)for(var n=-1;n<2;n+=2){var s=o,p=e+a,u=t+n;s>=0&&s<4&&p>=0&&p<4-s&&u>=0&&u<4-s?this.g.Graph[i].push(r[s]+p*(4-s)+u):this.g.Graph[i].push(null)}},Model.Game.InitGameExtra=function(){},Model.Game.DestroyGame=function(){this.DestroyGameExtra()},Model.Game.DestroyGameExtra=function(){},Model.Game.spUpdateZobrist=function(r,o,e,t,i,a){for(var n=0;n<o.length;n++)r=this.zobrist.update(r,"board",e,o[n]);for(var n=0;n<t.length;n++)r=this.zobrist.update(r,"board",i,t[n]);return r},Model.Move.Init=function(r){for(var o in r)r.hasOwnProperty(o)&&(this[o]=JSON.parse(JSON.stringify(r[o])))},Model.Move.ToString=function(){var r=["?","W","B","R"][this.clr],o="";switch(this.act){case"+":o+="+"+this.pos+r;break;case">":o+=this.from+">"+this.to+r}return o},Model.Board.Init=function(r){},Model.Board.InitialPosition=function(r){this.spInitialPosition(r)},Model.Board.spInitialPosition=function(r){this.board=[];for(var o=0;o<r.g.Graph.length;o++)this.board[o]=0;this.maxLayer=0,this.ballCount=[0,0,0],this.playables={},this.height=[0,0,0],this.zSign=0;for(var o=0;o<r.mOptions.size*r.mOptions.size;o++)this.playables[o]=!0},Model.Board.MakeFreeMoves=function(r){var o=[];for(var e in this.playables)o.push({act:"+",pos:e,clr:this.mWho==JocGame.PLAYER_A?1:2});return o},Model.Board.GenerateMoves=function(r){var o=this.GenerateAllMoves(r),e=r.mOptions.moveCount;0==o.length?(this.mFinished=!0,this.ballCount[1]>this.ballCount[2]?this.mWinner=JocGame.PLAYER_A:this.ballCount[1]<this.ballCount[2]?this.mWinner=JocGame.PLAYER_B:this.mWinner=JocGame.DRAW):void 0!==e&&o.length>e&&(r.ArrayShuffle(o),o.sort(function(r,o){o.nextBoard.evaluation,r.nextBoard.evaluation}),o.splice(e,o.length-e)),this.mMoves=o},Model.Board.GenerateAllMoves=function(r){return this.MakeFreeMoves(r)},Model.Board.Evaluate=function(r,o,e){this.mEvaluation=0},Model.Board.ApplyMove=function(r,o){this.spApplyMove(r,o)},Model.Board.spApplyMove=function(r,o){function e(o){delete t.playables[o],r.g.EachDirectionFlat(o,function(e,i){if(t.board[e]){var a,n;switch(i){case 4:a=7,n=10;break;case 5:a=6,n=9;break;case 6:a=4,n=8;break;case 7:a=5,n=11}var s=r.g.Graph[o][a];null!==s&&t.board[s]>0&&t.board[r.g.Graph[e][a]]&&(t.playables[r.g.Graph[o][n]]=!0)}})}var t=this;switch(o.act){case"+":this.board[o.pos]=o.clr;var i=r.g.Coord[o.pos][2];i>this.maxLayer&&(this.maxLayer=i),this.height[o.clr]+=i,this.ballCount[o.clr]++,e(o.pos);break;case">":o.down.length>0?this.playables[o.down[o.down.length-1]]=!0:this.playables[o.from]=!0;var a=o.from;for(var n in o.down){var s=o.down[n];this.height[this.board[s]]--,this.board[a]=this.board[s],a=s}this.board[a]=0,this.board[o.to]=o.clr;var i=r.g.Coord[o.to][2];this.height[o.clr]+=i,i>this.maxLayer&&(this.maxLayer=i),e(o.to)}},Model.Board.IsValidMove=function(r,o){return!0},Model.Board.ExtendMove=function(r,o){return{}},Model.Board.GetSignature=function(){return this.zSign},Model.Board.InitialPosition=function(r){this.spInitialPosition(r),this.groupMaxId=1,this.groups={},this.posGroup={},this.posFree={},this.center=0,this.moveEvaluation=0},Model.Board.GenerateAllMoves=function(r){for(var o=this.MakeFreeMoves(r),e=[],t=0;t<o.length;t++){var i=o[t],a=this.ExtendMove(r,i.pos);if(null!==a){i.nextBoard=a.board,i.remove=a.remove;var n=!1;r.mVisitedBoards&&r.mVisitedBoards[i.nextBoard.zSign]&&(n=!0),0==n&&e.push(i)}}return e},Model.Board.ExtendMove=function(r,o,e,t){function i(e){var t=p.board[e],i={side:t,p:{},pCount:1,f:{},fCount:0};i.p[e]=!0;for(var a=[e];a.length>0;){var n=a.pop();r.g.EachDirection(n,function(e,s){var u=p.board[e];if(u==t){if(e in i.p)return!0;var h=r.g.Over[e];if(null!==h&&(0!=p.board[h]||o==h))return!0;var f=G[s];if(void 0!==f){var v=r.g.Graph[n][f[0]],d=r.g.Graph[n][f[1]];if((v==o&&t==l||p.board[v]==3-t)&&(d==o&&t==l||p.board[d]==3-t))return!0}i.p[e]=!0,i.pCount++,a.push(e)}else if(0==u&&e!=o&&0==r.g.Coord[e][2]){if(e in i.f)return!0;i.f[e]=!0,i.fCount++}return!0})}return i}function a(r){var o=p.groupMaxId++;p.groups[o]=r;for(var e in r.p){p.posGroup[e];p.posGroup[e]=o}for(var t in r.f)void 0===p.posFree[t]&&(p.posFree[t]={}),p.posFree[t][o]=!0;return o}function n(r,o){var e=[];for(var t in o)e.push(t);for(var i=e[0],a=p.groups[i],n=1;n<e.length;n++){var t=e[n],s=p.groups[t];for(var u in s.p)a.p[u]=!0,p.posGroup[u]=i;a.pCount+=s.pCount;for(var l in s.f)l in a.f||(a.f[l]=!0,a.fCount++),delete p.posFree[l][t],p.posFree[l][i]=!0;delete p.groups[t]}if(r>=0){for(var l in b)l in a.f||(a.f[l]=!0,a.fCount++),void 0===p.posFree[l]&&(p.posFree[l]={}),p.posFree[l][i]=!0;a.p[r]=!0,a.pCount++,p.posGroup[r]=i}}function s(r,o,e){var t=p.groups[o];for(var i in e)i in t.f||(t.f[i]=!0,t.fCount++,void 0===p.posFree[i]&&(p.posFree[i]={}),p.posFree[i][o]=!0);t.p[r]=!0,t.pCount++,p.posGroup[r]=o}arguments.length<3&&(e=0),arguments.length<4&&(t=null),null==t&&(t=this);var p=JSON.parse(JSON.stringify({board:t.board,playables:t.playables,ballCount:t.ballCount,groups:t.groups,posFree:t.posFree,posGroup:t.posGroup,groupMaxId:t.groupMaxId,center:t.center,zSign:t.zSign,mWho:t.mWho})),u={};0==e&&(e=this.mWho==JocGame.PLAYER_A?1:2);var l=3-e,h=r.g.Coord[o],f=h[2],v={},d=0,g={},c=0,b={},m=0,G={4:[8,10],5:[9,11],6:[8,9],7:[10,11]},y={4:[0,2],5:[1,3],6:[0,1],7:[2,3]},M={},C={},F=r.g.Beneath[o];if(null!=F){var E=p.posGroup[F],B=p.groups[E];delete B.p[F],B.pCount--,p.posGroup[F]=0;var S=p.board[F],x=r.g.Coord[F][2];r.g.EachDirection(F,function(o,e){var t=p.board[o];if(r.g.Coord[o][2]==x){var i=G[e],a=r.g.Graph[F][i[0]],n=r.g.Graph[F][i[1]];if(null!=a&&p.board[a]==3-S&&null!=n||p.board[n]==3-S)return!0}return t==S&&p.posGroup[o]>0&&(C[o]=!0),!0})}f>0&&r.g.EachDirectionFlat(o,function(t,i){if(p.board[t]==e){var a=y[i],n=r.g.Graph[o][a[0]],s=r.g.Graph[o][a[1]];p.board[n]==l&&p.board[s]==l&&(p.posGroup[n]&&(C[n]=!0),p.posGroup[s]&&(C[s]=!0))}return!0});var D={};for(var z in C){var O=p.posGroup[z];D[O]=!0}for(var O in D)!function(r){var o=p.groups[r];for(var e in o.p)0!=p.posGroup[e]&&(p.posGroup[e]=-1);for(var t in o.f)delete p.posFree[t][r];delete p.groups[r]}(O);for(var z in C)p.posGroup[z]<0&&a(i(z));r.g.EachDirection(o,function(r){if(0==p.board[r])return!0;var o=p.posGroup[r];return 0==o||(p.board[r]==e?void 0===v[o]&&(v[o]=!0,d++):p.board[r]==l&&void 0===g[o]&&(g[o]=!0,c++),!0)}),0==f&&r.g.EachDirectionFlat(o,function(r){return 0==p.board[r]&&(b[r]=!0,m++),!0});var A=p.posFree[o];if(void 0!==A){for(var O in A){var B=p.groups[O];delete B.f[o],B.fCount--}delete p.posFree[o]}if(0==d){var B={side:e,p:{},pCount:1,f:b,fCount:m};B.p[o]=!0,a(B)}else if(1==d){for(var E in v);s(o,E,b)}else n(o,v);var w=!1;for(var E in p.groups)if(0!=E){var B=p.groups[E];B.side==l&&0==B.fCount&&(!function(e){var t=p.groups[e],n={},s={},l=[];for(var h in t.p)l.push({p:h,z:r.g.Coord[h][2]});l.sort(function(r,o){return o.z-r.z});for(var f=0;f<l.length;f++){var v=l[f],h=v.p,d=!1;if(r.g.EachDirectionUp(h,function(r){return!p.board[r]&&r!=o||(d=!0,!1)}),d)n[h]=!0,p.posGroup[h]=-1;else{0==v.z&&(s[h]=!0),p.board[h]=0,u[h]=!0,delete p.posGroup[h],p.ballCount[t.side]--,p.playables[h]=!0,r.g.EachDirectionUp(h,function(r){return p.playables[r]&&delete p.playables[r],!0});var g=r.g.Beneath[h];if(g)if(p.board[g]==t.side){var c=!1;if(r.g.EachDirectionDown(h,function(r){return p.board[r]!=t.side||(c=!0,!1)}),c){t.p[g]=!0,t.pCount++,p.posGroup[g]=e;for(var b={p:g,z:r.g.Coord[g][2]},m=f+1;m<l.length&&b.z<l[m].z;m++);l.splice(m,0,b)}else M[g]=!0}else M[g]=!0}}for(var G in t.f)delete p.posFree[G][e];delete p.groups[e];for(var G in s)r.g.EachDirectionFlat(G,function(r){var o=p.posGroup[r];if(void 0!==o&&o>0&&(void 0===p.posFree[G]&&(p.posFree[G]={}),void 0===p.posFree[G][o])){p.posFree[G][o]=!0;var e=p.groups[o];e.f[G]=!0,e.fCount++}return!0});for(var h in n)p.posGroup[h]==-1&&a(i(h))}(E),w=!0)}for(var z in M)if(0==p.posGroup[z]){var I=p.board[z],J={},P=0,W={},k=0,L=r.g.Coord[z][2];if(r.g.EachDirection(z,function(o,e){if(0==p.board[o])return!0;var t=p.posGroup[o];if(0==t)return!0;if(r.g.Coord[o][2]==L){var i=G[e],a=r.g.Graph[z][i[0]],n=r.g.Graph[z][i[1]];if(null!=a&&p.board[a]==3-I&&null!=n&&p.board[n]==3-I)return!0}return p.board[o]==I?void 0===J[t]&&(J[t]=!0,P++):0==p.board[o]&&0==r.g.Coord[o][2]&&(W[o]=!0,k++),!0}),0==P){var B={side:I,p:{},pCount:1,f:W,fCount:k};B.p[z]=!0;var E=a(B)}else if(1==P){for(var E in J);s(z,E,{})}else n(z,J)}if(w){var N=[];for(var E in p.groups)if(0!=E){var B=p.groups[E];B.side==e&&N.push(E)}N.sort(function(r,o){return parseInt(r)-parseInt(o)});for(var R=[],U=0;U<N.length;U++){var E=N[U],B=p.groups[E];for(var z in B.p){r.g.EachDirectionFlat(z,function(o,t){if(p.board[o]!=e)return!0;var i=p.posGroup[o];if(i!=E&&0!=i){var a=G[t],n=r.g.Graph[z][a[0]],s=r.g.Graph[z][a[1]];if(null==n||p.board[n]!=l||null==s||p.board[s]!=l){for(var u=null,h=[],f=0;f<R.length;f++){var v=R[f];if(E in v||i in v)if(u){for(var d in v)u[d]=!0;h.push(f)}else v[E]=!0,v[i]=!0,u=v}for(var f=h.length-1;f>=0;f--)R.splice(h[f],1);if(null==u){var v={};v[E]=!0,v[i]=!0,R.push(v)}}}return!0})}}for(var U=0;U<R.length;U++)n(-1,R[U])}for(var E in p.groups)if(0!=E){var B=p.groups[E];if(B.side==e&&0==B.fCount)for(var z in B.p){var H=!1;if(r.g.EachDirectionUp(z,function(r){return!(p.board[r]>0)||(H=!0,!1)}),0==H)return null}}var _=[];for(var E in p.groups){var B=p.groups[E];B.eyes=0;for(var z in B.p)_.push({p:z,z:r.g.Coord[z][2],group:B,gid:E})}_.sort(function(r,o){return o.z-r.z});for(var j={},Y={},U=0;U<_.length;U++){var V=_[U],Z=!1;r.g.EachDirectionUp(V.p,function(r){var o=j[r];return!(void 0!==o&&V.group.side&3-o)||(Z=!0,!1)}),V.pinned=Z,Y[V.p]=V,j[V.p]=Z?3:V.group.side}for(var T in p.posFree){var X=0,$=!0;r.g.EachDirectionFlat(T,function(r){if(0==p.board[r])return $=!1,!1;var o=p.posGroup[r];return 0!=X&&o!=X?($=!1,!1):(X=o,!0)}),0==X&&($=!1),$&&p.groups[X].eye++}p.relativeSecured=0,p.relativeHeight=0;var q=r.mOptions.levelOptions;for(var E in p.groups){var B=p.groups[E],K=1==B.side?1:-1,Q=q.evalSafety;B.eyes>=2?Q=q.evalSafety2eyes+Math.log(B.eyes-1)*q.evalSafetyXEyesBonus:1==B.fCount?Q=q.evalSafety1f:3==B.fCount?Q=q.evalSafety3f:B.fCount>3&&(Q=q.evalSafety3fMore+Math.log(B.fCount-3)*q.evalSafety3fMoreBonus),1==B.eyes&&(Q+=q.evalSafety1eyeBonus);for(var z in B.p){var V=Y[z],rr=Q;V.pinned&&(rr+=q.evalSafetyPinnedBonus),p.relativeSecured+=rr*K,p.relativeHeight+=V.z*K}}if(0==f){var K=1==e?1:-1,or=Math.abs(h[0]-(r.mOptions.size-1)/2)+Math.abs(h[1]-(r.mOptions.size-1)/2);p.center+=or*K*-1}p.moveEvaluation=p.relativeSecured+q.evalHeightRatio*p.relativeHeight+q.evalCenterRatio*p.center;var er=[];for(var tr in u)er.push(tr);return p.zSign=r.spUpdateZobrist(p.zSign,[o],e-1,er,2-e),{board:p,remove:er}},Model.Board.Evaluate=function(r,o,e){this.mEvaluation=this.moveEvaluation},Model.Board.CheckConsistency=function(r){for(var o=[0,0,0],e=0;e<r.g.Graph.length;e++){var t=(r.g.Coord[e],this.board[e]);if(t>0){if(void 0===this.posGroup[e])return console.error("pos",e,"side",t,"not assigned to any group"),!1;if(this.posFree[e]){var i=null;for(i in this.posFree[e]);if(null!=i)return console.error("pos",e,"side",t,"set as free for group",i),!1}o[t]++}else if(this.posGroup[e])return console.error("empty pos",e,"in posGroup"),!1;var a=r.g.Over[e];if(null!=a&&this.board[a]>0&&0!=this.posGroup[e])return console.error("buried ball",e,"does not have posGroup 0 but",this.posGroup[e]),!0}if(o[1]!=this.ballCount[1]||o[2]!=this.ballCount[2])return console.error("ball count mismatch, got",o[1],o[2],"expecting",this.ballCount[1],this.ballCount[2]),!1;for(var e in this.posGroup){if(0==this.board[e])return console.error("posGroup pos",e,"is empty"),!1;if(0!=this.posGroup[e]){if(void 0===this.groups[this.posGroup[e]])return console.error("posGroup",e,"in unknown group",this.posGroup[e]),!1;if(!(e in this.groups[this.posGroup[e]].p))return console.error("posGroup",e,"does not match group"),!1}}for(var e in this.posFree){if(0!=this.board[e])return console.error("posFree pos",e,"is not empty"),!1;for(var n in this.posFree[e]){var s=this.groups[n];if(void 0===s)return console.error("posFree pos",e,"group",n,"does not exist"),!1;if(!(e in s.f))return console.error("posFree pos",e,"group",n,"not in group freedoms"),!1}}for(var n in this.groups){var s=this.groups[n],p=0;for(var u in s.p){if(0==this.board[u])return console.error("pos",u,"in group",n,"marked as empty"),!1;if(this.board[u]!=s.side)return console.error("pos",u,"in group",n,"has wrong side"),!1;if(this.posGroup[u]!=n)return console.error("pos",u,"in group",n,"has wrong group",this.posGroup[u]),!1;p++}if(p!=s.pCount)return console.error("group",n,"count mismatch"),!1;p=0;for(var u in s.f){if(0!=this.board[u])return console.error("freedom pos",u,"in group",n,"is not empty"),!1;if(0!=r.g.Coord[u][2])return console.error("freedom pos",u,"in group",n,"not at ground level"),!1;if(void 0===this.posFree[u])return console.error("freedom pos",u,"in group",n,"not in freedoms"),!1;if(!this.posFree[u][n])return console.error("freedom pos",u,"in group",n,"is not empty for group"),!1;p++}if(p!=s.fCount)return console.error("group",n,"freedom count mismatch"),!1}return!0},Model.Board.ApplyMove=function(r,o){if(void 0===o.nextBoard){var e=this.ExtendMove(r,o.pos);e||console.log("move",o,JSON.stringify(r.mPlayedMoves)),this.CopyFrom(e.board)}else this.CopyFrom(o.nextBoard);this.spApplyMove(r,o)},Model.Board.CopyFrom=function(r){this.groupMaxId=r.groupMaxId,this.center=r.center,this.maxLayer=r.maxLayer,this.zSign=r.zSign,this.mWho=r.mWho,this.moveEvaluation=r.moveEvaluation,this.board=[],this.ballCount=[0,r.ballCount[1],r.ballCount[2]];for(var o=0;o<r.board.length;o++)this.board.push(r.board[o]);this.playables={};for(var o in r.playables)this.playables[o]=!0;this.groups={};for(var e in r.groups){var t=r.groups[e],i={side:t.side,p:{},pCount:t.pCount,f:{},fCount:t.fCount};for(var o in t.p)i.p[o]=!0;for(var o in t.f)i.f[o]=!0;this.groups[e]=i}this.posFree={};for(var o in r.posFree){var a={};for(var n in r.posFree[o])a[n]=!0;this.posFree[o]=a}this.posGroup={};for(var o in r.posGroup)this.posGroup[o]=r.posGroup[o];r.height?this.height=[0,r.height[1],r.height[2]]:this.height=[0,0,0],void 0!==r.mEvaluation&&(this.mEvaluation=r.mEvaluation),void 0!==r.mFinished&&(this.mFinished=r.mFinished),void 0!==r.mWinner&&(this.mWinner=r.mWinner)},Model.Game.Save=function(){for(var r={playedMoves:[],game:JoclyHub.modelName},o=0;o<this.mPlayedMoves.length;o++){var e=new(this.GetMoveClass())(this.mPlayedMoves[o]);delete e.nextBoard,delete e.remove,delete e.boardJSON,r.playedMoves.push(e)}var t=new Date;if(r.date=t.getFullYear()+"-"+(t.getMonth()+1)+"-"+t.getDate()+"-"+t.getHours()+"_"+t.getMinutes()+"_"+t.getSeconds(),JoclyHub.network.connected){$(".jocly-temp").remove();var i=document.createElement("form");i.setAttribute("class","jocly-temp"),i.setAttribute("style","display: none;"),i.setAttribute("method","post"),i.setAttribute("action","/jocly/save-game");var a=document.createElement("input");a.setAttribute("type","hidden"),a.setAttribute("name","data"),a.setAttribute("value",JSON.stringify(r)),i.appendChild(a),document.body.appendChild(i),i.submit()}else{var n=r.game+"-"+r.date+".joc",s="data:application/x-joc;filename="+n+","+encodeURIComponent(JSON.stringify(r));window.open(s,n)}},Model.Move.Strip=function(){if(void 0!==this.nextBoard||void 0!==this.remove){var r={};for(var o in this)this.hasOwnProperty(o)&&"nextBoard"!=o&&(r[o]=JSON.parse(JSON.stringify(this[o])));return r}return this};

/***/ }),

/***/ "UeEq":
/***/ (function(module, exports) {

exports.model=Model={Game:{},Board:{},Move:{}},function(){function t(t){var i=t%e;return[i,(t-i)/e]}function i(t,i){return i*e+t}var e;Model.Game.InitGame=function(){var s=this;e=2*this.mOptions.centerDistance+1;var r=[[0,-1],[1,0],[0,1],[-1,0]];this.g.attackersCount=this.mOptions.initial.attackers.length,this.g.defendersCount=this.mOptions.initial.defenders.soldiers.length,this.g.excludeMap={},this.mOptions.exclude.forEach(function(t){s.g.excludeMap[t]=!0}),this.g.home=this.mOptions.initial.defenders.king,this.g.Graph=[],this.g.borders={};for(var a=0;a<e*e;a++){var o=[],n=t(a);r.forEach(function(t){var r=n[0]+t[0];if(r<0||r>=e)o.push(null),s.g.borders[a]=!0;else{var h=n[1]+t[1];if(h<0||h>=e)o.push(null),s.g.borders[a]=!0;else{var d=i(r,h);s.g.excludeMap[d]?o.push(null):o.push(d)}}}),this.g.Graph.push(o)}this.zobrist=new JocGame.Zobrist({board:{type:"array",size:e*e,values:["s1","s-1","k1","k-1"]}})},Model.Move.Init=function(t){var i=this;if(this.f=t.f,this.t=t.t,this.c=[],t.c)for(var e=0;e<t.c.length;e++)i.c.push(t.c[e])},Model.Move.CopyFrom=function(t){this.Init(t)},Model.Move.ToString=function(){var t=this.f+">"+this.t;return this.c.length>0&&(t+="x"+this.c.join(",")),t},Model.Board.Init=function(t){this.zSign=0},Model.Board.InitialPosition=function(i){function s(t,e,s){r.zSign=i.zobrist.update(r.zSign,"board",s+e,t),r.board[t]=r.pieces.length,r.pieces.push({i:r.pieces.length,p:t,s:e,t:s})}var r=this;this.board=[],this.pieces=[];for(var a=0;a<e*e;a++)this.board.push(-1);var o=i.mOptions.attackers;s(i.mOptions.initial.defenders.king,-o,"k");var n=i.mOptions.initial.defenders.soldiers;this.defendersCount=0;for(var h=0;h<n.length;h++)s(n[h],-o,"s"),this.defendersCount++;this.defendersCount=n.length;var d=i.mOptions.initial.attackers;this.attackersCount=0;for(var h=0;h<d.length;h++){s(d[h],o,"s");t(d[h]);this.attackersCount++}},Model.Board.CopyFrom=function(t){var i=this;this.board=[];for(var e=t.board,s=0;s<e.length;s++)i.board.push(e[s]);this.pieces=[];for(var r=t.pieces,a=0;a<r.length;a++){var o=r[a];i.pieces.push({i:o.i,p:o.p,s:o.s,t:o.t})}this.defendersCount=t.defendersCount,this.attackersCount=t.attackersCount,this.mWho=t.mWho,this.zSign=t.zSign},Model.Board.GenerateMoves=function(t){for(var i=this,e=[],s=0;s<this.pieces.length;s++){var r=this.pieces[s];if(!(r.s!=i.mWho||r.p<0))for(var a=0;a<4;a++)for(var o=t.g.Graph[r.p][a];null!=o;){var n=i.board[o];if(!(n<0)||o==t.g.home&&t.mOptions.privateHome&&"k"!=r.t)break;for(var h={f:r.p,t:o,c:[]},d=0;d<4;d++){var p=t.g.Graph[o][d];if(null!=p){var c=i.board[p];if(c>=0){var f=i.pieces[c];if(f.s==-r.s)if("k"==f.t){for(var u=0;u<4;u++){var l=t.g.Graph[p][u];if(null==l)break;var v=i.board[l];if(v<0){if(l!=o&&(l!=t.g.home||!t.mOptions.homeCatch))break}else{var g=i.pieces[v];if(g.s==f.s)break}}4==u&&h.c.push(p)}else{var l=t.g.Graph[p][d];if(null!=l){var v=i.board[l];if(l==t.g.home&&t.mOptions.homeCatch)h.c.push(p);else if(v>=0){var g=i.pieces[v];g.s==r.s&&h.c.push(p)}}}}}}if(e.push(h),!t.mOptions.longMove)break;o=t.g.Graph[o][a]}}this.mMoves=e},Model.Board.Evaluate=function(i){var e="debug"==arguments[3];if(this.mEvaluation=0,this.pieces[0].p<0)return this.mFinished=!0,void(this.mWinner=i.mOptions.attackers);if(this.pieces[0].p in i.g.borders)return this.mFinished=!0,void(this.mWinner=-i.mOptions.attackers);if(i.GetRepeatOccurence(this)>2)return this.mFinished=!0,void(this.mWinner=JocGame.DRAW);for(var s=this.pieces[0].p,r=t(s),a=0,o=i.mOptions.initial.attackers.length+1;o<this.pieces.length;o++){var n=this.pieces[o];if(n.p>=0){var h=t(n.p);a+=Math.max(Math.abs(h[0]-r[0]),Math.abs(h[1]-r[1]))}}var d={},p={};d[s]=1;for(var c=1,f=0,u=0;c>0;){var l={};c=0;for(var v in d){for(var g=d[v],m=g/4,b=i.g.Graph[v],k=0;k<4;k++)for(var M=b[k];M&&!(this.board[M]>=0)&&(M in p||M in d||(M in i.g.borders?f+=g:M in l?l[M]+=m:(u++,c++,l[M]=m)),i.mOptions.longMove);)M=i.g.Graph[M][k];p[v]=g}d=l}var O={attackersCount:this.attackersCount,defendersCount:this.defendersCount,kingPath:f,kingFreedom:u,distKing:a},C=i.mOptions.levelOptions;for(var z in O){var G=O[z],S=C[z+"Factor"]||0,E=G*S;e&&console.log(z,"=",G,"*",S,"=>",E),this.mEvaluation+=E}this.mEvaluation*=i.mOptions.attackers,e&&console.log("Evaluation",this.mEvaluation)},Model.Board.ApplyMove=function(i,e){var s=this,r=this.board[e.f],a=this.pieces[r];if(this.zSign=i.zobrist.update(this.zSign,"board",a.t+a.s,e.f),this.zSign=i.zobrist.update(this.zSign,"board",a.t+a.s,e.t),this.board[e.f]=-1,this.board[e.t]=r,a.p=e.t,this.mWho==i.mOptions.attackers){t(e.f),t(e.t)}for(var o=e.c,n=0;n<o.length;n++){var h=o[n],d=s.board[h],p=s.pieces[d];s.zSign=i.zobrist.update(s.zSign,"board",p.t+p.s,h),s.board[h]=-1,p.p=-1,s.mWho==-i.mOptions.attackers?s.attackersCount--:"s"==p.t&&s.defendersCount--}},Model.Board.taflIntegrity=function(t){var i=this,e=0,s=0;this.board.forEach(function(r,a){if(r>=0){var o=i.pieces[r];o.p,"s"==o.t&&(o.s==t.mOptions.attackers?e++:s++)}}),this.attackersCount,this.defendersCount,this.pieces.forEach(function(t,e){t.p>=0&&i.board[t.p]})},Model.Board.GetSignature=function(){return this.zSign}}();

/***/ }),

/***/ "Uk0N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("3j3K");
/* unused harmony export VERSION */
/* unused harmony export TEMPLATE_TRANSFORMS */
/* unused harmony export CompilerConfig */
/* unused harmony export JitCompiler */
/* unused harmony export DirectiveResolver */
/* unused harmony export PipeResolver */
/* unused harmony export NgModuleResolver */
/* unused harmony export DEFAULT_INTERPOLATION_CONFIG */
/* unused harmony export InterpolationConfig */
/* unused harmony export NgModuleCompiler */
/* unused harmony export ViewCompiler */
/* unused harmony export isSyntaxError */
/* unused harmony export syntaxError */
/* unused harmony export TextAst */
/* unused harmony export BoundTextAst */
/* unused harmony export AttrAst */
/* unused harmony export BoundElementPropertyAst */
/* unused harmony export BoundEventAst */
/* unused harmony export ReferenceAst */
/* unused harmony export VariableAst */
/* unused harmony export ElementAst */
/* unused harmony export EmbeddedTemplateAst */
/* unused harmony export BoundDirectivePropertyAst */
/* unused harmony export DirectiveAst */
/* unused harmony export ProviderAst */
/* unused harmony export ProviderAstType */
/* unused harmony export NgContentAst */
/* unused harmony export PropertyBindingType */
/* unused harmony export templateVisitAll */
/* unused harmony export CompileAnimationEntryMetadata */
/* unused harmony export CompileAnimationStateMetadata */
/* unused harmony export CompileAnimationStateDeclarationMetadata */
/* unused harmony export CompileAnimationStateTransitionMetadata */
/* unused harmony export CompileAnimationMetadata */
/* unused harmony export CompileAnimationKeyframesSequenceMetadata */
/* unused harmony export CompileAnimationStyleMetadata */
/* unused harmony export CompileAnimationAnimateMetadata */
/* unused harmony export CompileAnimationWithStepsMetadata */
/* unused harmony export CompileAnimationSequenceMetadata */
/* unused harmony export CompileAnimationGroupMetadata */
/* unused harmony export identifierName */
/* unused harmony export identifierModuleUrl */
/* unused harmony export viewClassName */
/* unused harmony export rendererTypeName */
/* unused harmony export hostViewClassName */
/* unused harmony export dirWrapperClassName */
/* unused harmony export componentFactoryName */
/* unused harmony export CompileSummaryKind */
/* unused harmony export tokenName */
/* unused harmony export tokenReference */
/* unused harmony export CompileStylesheetMetadata */
/* unused harmony export CompileTemplateMetadata */
/* unused harmony export CompileDirectiveMetadata */
/* unused harmony export createHostComponentMeta */
/* unused harmony export CompilePipeMetadata */
/* unused harmony export CompileNgModuleMetadata */
/* unused harmony export TransitiveCompileNgModuleMetadata */
/* unused harmony export ProviderMeta */
/* unused harmony export flatten */
/* unused harmony export sourceUrl */
/* unused harmony export templateSourceUrl */
/* unused harmony export sharedStylesheetJitUrl */
/* unused harmony export ngModuleJitUrl */
/* unused harmony export templateJitUrl */
/* unused harmony export createAotCompiler */
/* unused harmony export AotCompiler */
/* unused harmony export analyzeNgModules */
/* unused harmony export analyzeAndValidateNgModules */
/* unused harmony export extractProgramSymbols */
/* unused harmony export GeneratedFile */
/* unused harmony export StaticReflector */
/* unused harmony export StaticAndDynamicReflectionCapabilities */
/* unused harmony export StaticSymbol */
/* unused harmony export StaticSymbolCache */
/* unused harmony export ResolvedStaticSymbol */
/* unused harmony export StaticSymbolResolver */
/* unused harmony export unescapeIdentifier */
/* unused harmony export AotSummaryResolver */
/* unused harmony export SummaryResolver */
/* unused harmony export i18nHtmlParserFactory */
/* unused harmony export COMPILER_PROVIDERS */
/* unused harmony export JitCompilerFactory */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return platformCoreDynamic; });
/* unused harmony export createUrlResolverWithoutPackagePrefix */
/* unused harmony export createOfflineCompileUrlResolver */
/* unused harmony export DEFAULT_PACKAGE_URL_PROVIDER */
/* unused harmony export UrlResolver */
/* unused harmony export getUrlScheme */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ResourceLoader; });
/* unused harmony export ElementSchemaRegistry */
/* unused harmony export Extractor */
/* unused harmony export I18NHtmlParser */
/* unused harmony export MessageBundle */
/* unused harmony export Serializer */
/* unused harmony export Xliff */
/* unused harmony export Xliff2 */
/* unused harmony export Xmb */
/* unused harmony export Xtb */
/* unused harmony export DirectiveNormalizer */
/* unused harmony export ParserError */
/* unused harmony export ParseSpan */
/* unused harmony export AST */
/* unused harmony export Quote */
/* unused harmony export EmptyExpr */
/* unused harmony export ImplicitReceiver */
/* unused harmony export Chain */
/* unused harmony export Conditional */
/* unused harmony export PropertyRead */
/* unused harmony export PropertyWrite */
/* unused harmony export SafePropertyRead */
/* unused harmony export KeyedRead */
/* unused harmony export KeyedWrite */
/* unused harmony export BindingPipe */
/* unused harmony export LiteralPrimitive */
/* unused harmony export LiteralArray */
/* unused harmony export LiteralMap */
/* unused harmony export Interpolation */
/* unused harmony export Binary */
/* unused harmony export PrefixNot */
/* unused harmony export MethodCall */
/* unused harmony export SafeMethodCall */
/* unused harmony export FunctionCall */
/* unused harmony export ASTWithSource */
/* unused harmony export TemplateBinding */
/* unused harmony export RecursiveAstVisitor */
/* unused harmony export AstTransformer */
/* unused harmony export TokenType */
/* unused harmony export Lexer */
/* unused harmony export Token */
/* unused harmony export EOF */
/* unused harmony export isIdentifier */
/* unused harmony export isQuote */
/* unused harmony export SplitInterpolation */
/* unused harmony export TemplateBindingParseResult */
/* unused harmony export Parser */
/* unused harmony export _ParseAST */
/* unused harmony export ERROR_COLLECTOR_TOKEN */
/* unused harmony export CompileMetadataResolver */
/* unused harmony export componentModuleUrl */
/* unused harmony export Text */
/* unused harmony export Expansion */
/* unused harmony export ExpansionCase */
/* unused harmony export Attribute */
/* unused harmony export Element */
/* unused harmony export Comment */
/* unused harmony export visitAll */
/* unused harmony export ParseTreeResult */
/* unused harmony export TreeError */
/* unused harmony export HtmlParser */
/* unused harmony export HtmlTagDefinition */
/* unused harmony export getHtmlTagDefinition */
/* unused harmony export TagContentType */
/* unused harmony export splitNsName */
/* unused harmony export isNgContainer */
/* unused harmony export isNgContent */
/* unused harmony export isNgTemplate */
/* unused harmony export getNsPrefix */
/* unused harmony export mergeNsAndName */
/* unused harmony export NAMED_ENTITIES */
/* unused harmony export ImportResolver */
/* unused harmony export debugOutputAstAsTypeScript */
/* unused harmony export TypeScriptEmitter */
/* unused harmony export ParseLocation */
/* unused harmony export ParseSourceFile */
/* unused harmony export ParseSourceSpan */
/* unused harmony export ParseErrorLevel */
/* unused harmony export ParseError */
/* unused harmony export typeSourceSpan */
/* unused harmony export DomElementSchemaRegistry */
/* unused harmony export CssSelector */
/* unused harmony export SelectorMatcher */
/* unused harmony export SelectorListContext */
/* unused harmony export SelectorContext */
/* unused harmony export StylesCompileDependency */
/* unused harmony export StylesCompileResult */
/* unused harmony export CompiledStylesheet */
/* unused harmony export StyleCompiler */
/* unused harmony export TemplateParseError */
/* unused harmony export TemplateParseResult */
/* unused harmony export TemplateParser */
/* unused harmony export splitClasses */
/* unused harmony export createElementCssSelector */
/* unused harmony export removeSummaryDuplicates */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * @license Angular v4.1.0
 * (c) 2010-2017 Google, Inc. https://angular.io/
 * License: MIT
 */

/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @module
 * @description
 * Entry point for all public APIs of the common package.
 */
/**
 * \@stable
 */
var VERSION = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["Version"]('4.1.0');
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * A segment of text within the template.
 */
var TextAst = (function () {
    /**
     * @param {?} value
     * @param {?} ngContentIndex
     * @param {?} sourceSpan
     */
    function TextAst(value, ngContentIndex, sourceSpan) {
        this.value = value;
        this.ngContentIndex = ngContentIndex;
        this.sourceSpan = sourceSpan;
    }
    /**
     * @param {?} visitor
     * @param {?} context
     * @return {?}
     */
    TextAst.prototype.visit = function (visitor, context) { return visitor.visitText(this, context); };
    return TextAst;
}());
/**
 * A bound expression within the text of a template.
 */
var BoundTextAst = (function () {
    /**
     * @param {?} value
     * @param {?} ngContentIndex
     * @param {?} sourceSpan
     */
    function BoundTextAst(value, ngContentIndex, sourceSpan) {
        this.value = value;
        this.ngContentIndex = ngContentIndex;
        this.sourceSpan = sourceSpan;
    }
    /**
     * @param {?} visitor
     * @param {?} context
     * @return {?}
     */
    BoundTextAst.prototype.visit = function (visitor, context) {
        return visitor.visitBoundText(this, context);
    };
    return BoundTextAst;
}());
/**
 * A plain attribute on an element.
 */
var AttrAst = (function () {
    /**
     * @param {?} name
     * @param {?} value
     * @param {?} sourceSpan
     */
    function AttrAst(name, value, sourceSpan) {
        this.name = name;
        this.value = value;
        this.sourceSpan = sourceSpan;
    }
    /**
     * @param {?} visitor
     * @param {?} context
     * @return {?}
     */
    AttrAst.prototype.visit = function (visitor, context) { return visitor.visitAttr(this, context); };
    return AttrAst;
}());
/**
 * A binding for an element property (e.g. `[property]="expression"`) or an animation trigger (e.g.
 * `[\@trigger]="stateExp"`)
 */
var BoundElementPropertyAst = (function () {
    /**
     * @param {?} name
     * @param {?} type
     * @param {?} securityContext
     * @param {?} value
     * @param {?} unit
     * @param {?} sourceSpan
     */
    function BoundElementPropertyAst(name, type, securityContext, value, unit, sourceSpan) {
        this.name = name;
        this.type = type;
        this.securityContext = securityContext;
        this.value = value;
        this.unit = unit;
        this.sourceSpan = sourceSpan;
    }
    /**
     * @param {?} visitor
     * @param {?} context
     * @return {?}
     */
    BoundElementPropertyAst.prototype.visit = function (visitor, context) {
        return visitor.visitElementProperty(this, context);
    };
    Object.defineProperty(BoundElementPropertyAst.prototype, "isAnimation", {
        /**
         * @return {?}
         */
        get: function () { return this.type === PropertyBindingType.Animation; },
        enumerable: true,
        configurable: true
    });
    return BoundElementPropertyAst;
}());
/**
 * A binding for an element event (e.g. `(event)="handler()"`) or an animation trigger event (e.g.
 * `(\@trigger.phase)="callback($event)"`).
 */
var BoundEventAst = (function () {
    /**
     * @param {?} name
     * @param {?} target
     * @param {?} phase
     * @param {?} handler
     * @param {?} sourceSpan
     */
    function BoundEventAst(name, target, phase, handler, sourceSpan) {
        this.name = name;
        this.target = target;
        this.phase = phase;
        this.handler = handler;
        this.sourceSpan = sourceSpan;
    }
    /**
     * @param {?} name
     * @param {?} target
     * @param {?} phase
     * @return {?}
     */
    BoundEventAst.calcFullName = function (name, target, phase) {
        if (target) {
            return target + ":" + name;
        }
        else if (phase) {
            return "@" + name + "." + phase;
        }
        else {
            return name;
        }
    };
    /**
     * @param {?} visitor
     * @param {?} context
     * @return {?}
     */
    BoundEventAst.prototype.visit = function (visitor, context) {
        return visitor.visitEvent(this, context);
    };
    Object.defineProperty(BoundEventAst.prototype, "fullName", {
        /**
         * @return {?}
         */
        get: function () { return BoundEventAst.calcFullName(this.name, this.target, this.phase); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BoundEventAst.prototype, "isAnimation", {
        /**
         * @return {?}
         */
        get: function () { return !!this.phase; },
        enumerable: true,
        configurable: true
    });
    return BoundEventAst;
}());
/**
 * A reference declaration on an element (e.g. `let someName="expression"`).
 */
var ReferenceAst = (function () {
    /**
     * @param {?} name
     * @param {?} value
     * @param {?} sourceSpan
     */
    function ReferenceAst(name, value, sourceSpan) {
        this.name = name;
        this.value = value;
        this.sourceSpan = sourceSpan;
    }
    /**
     * @param {?} visitor
     * @param {?} context
     * @return {?}
     */
    ReferenceAst.prototype.visit = function (visitor, context) {
        return visitor.visitReference(this, context);
    };
    return ReferenceAst;
}());
/**
 * A variable declaration on a <ng-template> (e.g. `var-someName="someLocalName"`).
 */
var VariableAst = (function () {
    /**
     * @param {?} name
     * @param {?} value
     * @param {?} sourceSpan
     */
    function VariableAst(name, value, sourceSpan) {
        this.name = name;
        this.value = value;
        this.sourceSpan = sourceSpan;
    }
    /**
     * @param {?} visitor
     * @param {?} context
     * @return {?}
     */
    VariableAst.prototype.visit = function (visitor, context) {
        return visitor.visitVariable(this, context);
    };
    return VariableAst;
}());
/**
 * An element declaration in a template.
 */
var ElementAst = (function () {
    /**
     * @param {?} name
     * @param {?} attrs
     * @param {?} inputs
     * @param {?} outputs
     * @param {?} references
     * @param {?} directives
     * @param {?} providers
     * @param {?} hasViewContainer
     * @param {?} queryMatches
     * @param {?} children
     * @param {?} ngContentIndex
     * @param {?} sourceSpan
     * @param {?} endSourceSpan
     */
    function ElementAst(name, attrs, inputs, outputs, references, directives, providers, hasViewContainer, queryMatches, children, ngContentIndex, sourceSpan, endSourceSpan) {
        this.name = name;
        this.attrs = attrs;
        this.inputs = inputs;
        this.outputs = outputs;
        this.references = references;
        this.directives = directives;
        this.providers = providers;
        this.hasViewContainer = hasViewContainer;
        this.queryMatches = queryMatches;
        this.children = children;
        this.ngContentIndex = ngContentIndex;
        this.sourceSpan = sourceSpan;
        this.endSourceSpan = endSourceSpan;
    }
    /**
     * @param {?} visitor
     * @param {?} context
     * @return {?}
     */
    ElementAst.prototype.visit = function (visitor, context) {
        return visitor.visitElement(this, context);
    };
    return ElementAst;
}());
/**
 * A `<ng-template>` element included in an Angular template.
 */
var EmbeddedTemplateAst = (function () {
    /**
     * @param {?} attrs
     * @param {?} outputs
     * @param {?} references
     * @param {?} variables
     * @param {?} directives
     * @param {?} providers
     * @param {?} hasViewContainer
     * @param {?} queryMatches
     * @param {?} children
     * @param {?} ngContentIndex
     * @param {?} sourceSpan
     */
    function EmbeddedTemplateAst(attrs, outputs, references, variables, directives, providers, hasViewContainer, queryMatches, children, ngContentIndex, sourceSpan) {
        this.attrs = attrs;
        this.outputs = outputs;
        this.references = references;
        this.variables = variables;
        this.directives = directives;
        this.providers = providers;
        this.hasViewContainer = hasViewContainer;
        this.queryMatches = queryMatches;
        this.children = children;
        this.ngContentIndex = ngContentIndex;
        this.sourceSpan = sourceSpan;
    }
    /**
     * @param {?} visitor
     * @param {?} context
     * @return {?}
     */
    EmbeddedTemplateAst.prototype.visit = function (visitor, context) {
        return visitor.visitEmbeddedTemplate(this, context);
    };
    return EmbeddedTemplateAst;
}());
/**
 * A directive property with a bound value (e.g. `*ngIf="condition").
 */
var BoundDirectivePropertyAst = (function () {
    /**
     * @param {?} directiveName
     * @param {?} templateName
     * @param {?} value
     * @param {?} sourceSpan
     */
    function BoundDirectivePropertyAst(directiveName, templateName, value, sourceSpan) {
        this.directiveName = directiveName;
        this.templateName = templateName;
        this.value = value;
        this.sourceSpan = sourceSpan;
    }
    /**
     * @param {?} visitor
     * @param {?} context
     * @return {?}
     */
    BoundDirectivePropertyAst.prototype.visit = function (visitor, context) {
        return visitor.visitDirectiveProperty(this, context);
    };
    return BoundDirectivePropertyAst;
}());
/**
 * A directive declared on an element.
 */
var DirectiveAst = (function () {
    /**
     * @param {?} directive
     * @param {?} inputs
     * @param {?} hostProperties
     * @param {?} hostEvents
     * @param {?} contentQueryStartId
     * @param {?} sourceSpan
     */
    function DirectiveAst(directive, inputs, hostProperties, hostEvents, contentQueryStartId, sourceSpan) {
        this.directive = directive;
        this.inputs = inputs;
        this.hostProperties = hostProperties;
        this.hostEvents = hostEvents;
        this.contentQueryStartId = contentQueryStartId;
        this.sourceSpan = sourceSpan;
    }
    /**
     * @param {?} visitor
     * @param {?} context
     * @return {?}
     */
    DirectiveAst.prototype.visit = function (visitor, context) {
        return visitor.visitDirective(this, context);
    };
    return DirectiveAst;
}());
/**
 * A provider declared on an element
 */
var ProviderAst = (function () {
    /**
     * @param {?} token
     * @param {?} multiProvider
     * @param {?} eager
     * @param {?} providers
     * @param {?} providerType
     * @param {?} lifecycleHooks
     * @param {?} sourceSpan
     */
    function ProviderAst(token, multiProvider, eager, providers, providerType, lifecycleHooks, sourceSpan) {
        this.token = token;
        this.multiProvider = multiProvider;
        this.eager = eager;
        this.providers = providers;
        this.providerType = providerType;
        this.lifecycleHooks = lifecycleHooks;
        this.sourceSpan = sourceSpan;
    }
    /**
     * @param {?} visitor
     * @param {?} context
     * @return {?}
     */
    ProviderAst.prototype.visit = function (visitor, context) {
        // No visit method in the visitor for now...
        return null;
    };
    return ProviderAst;
}());
var ProviderAstType = {};
ProviderAstType.PublicService = 0;
ProviderAstType.PrivateService = 1;
ProviderAstType.Component = 2;
ProviderAstType.Directive = 3;
ProviderAstType.Builtin = 4;
ProviderAstType[ProviderAstType.PublicService] = "PublicService";
ProviderAstType[ProviderAstType.PrivateService] = "PrivateService";
ProviderAstType[ProviderAstType.Component] = "Component";
ProviderAstType[ProviderAstType.Directive] = "Directive";
ProviderAstType[ProviderAstType.Builtin] = "Builtin";
/**
 * Position where content is to be projected (instance of `<ng-content>` in a template).
 */
var NgContentAst = (function () {
    /**
     * @param {?} index
     * @param {?} ngContentIndex
     * @param {?} sourceSpan
     */
    function NgContentAst(index, ngContentIndex, sourceSpan) {
        this.index = index;
        this.ngContentIndex = ngContentIndex;
        this.sourceSpan = sourceSpan;
    }
    /**
     * @param {?} visitor
     * @param {?} context
     * @return {?}
     */
    NgContentAst.prototype.visit = function (visitor, context) {
        return visitor.visitNgContent(this, context);
    };
    return NgContentAst;
}());
var PropertyBindingType = {};
PropertyBindingType.Property = 0;
PropertyBindingType.Attribute = 1;
PropertyBindingType.Class = 2;
PropertyBindingType.Style = 3;
PropertyBindingType.Animation = 4;
PropertyBindingType[PropertyBindingType.Property] = "Property";
PropertyBindingType[PropertyBindingType.Attribute] = "Attribute";
PropertyBindingType[PropertyBindingType.Class] = "Class";
PropertyBindingType[PropertyBindingType.Style] = "Style";
PropertyBindingType[PropertyBindingType.Animation] = "Animation";
/**
 * Visit every node in a list of {\@link TemplateAst}s with the given {\@link TemplateAstVisitor}.
 * @param {?} visitor
 * @param {?} asts
 * @param {?=} context
 * @return {?}
 */
function templateVisitAll(visitor, asts, context) {
    if (context === void 0) { context = null; }
    var /** @type {?} */ result = [];
    var /** @type {?} */ visit = visitor.visit ?
        function (ast) { return ((visitor.visit))(ast, context) || ast.visit(visitor, context); } :
        function (ast) { return ast.visit(visitor, context); };
    asts.forEach(function (ast) {
        var /** @type {?} */ astResult = visit(ast);
        if (astResult) {
            result.push(astResult);
        }
    });
    return result;
}
/**
 * A token representing the a reference to a static type.
 *
 * This token is unique for a filePath and name and can be used as a hash table key.
 */
var StaticSymbol = (function () {
    /**
     * @param {?} filePath
     * @param {?} name
     * @param {?} members
     */
    function StaticSymbol(filePath, name, members) {
        this.filePath = filePath;
        this.name = name;
        this.members = members;
    }
    /**
     * @return {?}
     */
    StaticSymbol.prototype.assertNoMembers = function () {
        if (this.members.length) {
            throw new Error("Illegal state: symbol without members expected, but got " + JSON.stringify(this) + ".");
        }
    };
    return StaticSymbol;
}());
/**
 * A cache of static symbol used by the StaticReflector to return the same symbol for the
 * same symbol values.
 */
var StaticSymbolCache = (function () {
    function StaticSymbolCache() {
        this.cache = new Map();
    }
    /**
     * @param {?} declarationFile
     * @param {?} name
     * @param {?=} members
     * @return {?}
     */
    StaticSymbolCache.prototype.get = function (declarationFile, name, members) {
        members = members || [];
        var /** @type {?} */ memberSuffix = members.length ? "." + members.join('.') : '';
        var /** @type {?} */ key = "\"" + declarationFile + "\"." + name + memberSuffix;
        var /** @type {?} */ result = this.cache.get(key);
        if (!result) {
            result = new StaticSymbol(declarationFile, name, members);
            this.cache.set(key, result);
        }
        return result;
    };
    return StaticSymbolCache;
}());
var TagContentType = {};
TagContentType.RAW_TEXT = 0;
TagContentType.ESCAPABLE_RAW_TEXT = 1;
TagContentType.PARSABLE_DATA = 2;
TagContentType[TagContentType.RAW_TEXT] = "RAW_TEXT";
TagContentType[TagContentType.ESCAPABLE_RAW_TEXT] = "ESCAPABLE_RAW_TEXT";
TagContentType[TagContentType.PARSABLE_DATA] = "PARSABLE_DATA";
/**
 * @param {?} elementName
 * @return {?}
 */
function splitNsName(elementName) {
    if (elementName[0] != ':') {
        return [null, elementName];
    }
    var /** @type {?} */ colonIndex = elementName.indexOf(':', 1);
    if (colonIndex == -1) {
        throw new Error("Unsupported format \"" + elementName + "\" expecting \":namespace:name\"");
    }
    return [elementName.slice(1, colonIndex), elementName.slice(colonIndex + 1)];
}
/**
 * @param {?} tagName
 * @return {?}
 */
function isNgContainer(tagName) {
    return splitNsName(tagName)[1] === 'ng-container';
}
/**
 * @param {?} tagName
 * @return {?}
 */
function isNgContent(tagName) {
    return splitNsName(tagName)[1] === 'ng-content';
}
/**
 * @param {?} tagName
 * @return {?}
 */
function isNgTemplate(tagName) {
    return splitNsName(tagName)[1] === 'ng-template';
}
/**
 * @param {?} fullName
 * @return {?}
 */
function getNsPrefix(fullName) {
    return fullName === null ? null : splitNsName(fullName)[0];
}
/**
 * @param {?} prefix
 * @param {?} localName
 * @return {?}
 */
function mergeNsAndName(prefix, localName) {
    return prefix ? ":" + prefix + ":" + localName : localName;
}
// see http://www.w3.org/TR/html51/syntax.html#named-character-references
// see https://html.spec.whatwg.org/multipage/entities.json
// This list is not exhaustive to keep the compiler footprint low.
// The `&#123;` / `&#x1ab;` syntax should be used when the named character reference does not
// exist.
var NAMED_ENTITIES = {
    'Aacute': '\u00C1',
    'aacute': '\u00E1',
    'Acirc': '\u00C2',
    'acirc': '\u00E2',
    'acute': '\u00B4',
    'AElig': '\u00C6',
    'aelig': '\u00E6',
    'Agrave': '\u00C0',
    'agrave': '\u00E0',
    'alefsym': '\u2135',
    'Alpha': '\u0391',
    'alpha': '\u03B1',
    'amp': '&',
    'and': '\u2227',
    'ang': '\u2220',
    'apos': '\u0027',
    'Aring': '\u00C5',
    'aring': '\u00E5',
    'asymp': '\u2248',
    'Atilde': '\u00C3',
    'atilde': '\u00E3',
    'Auml': '\u00C4',
    'auml': '\u00E4',
    'bdquo': '\u201E',
    'Beta': '\u0392',
    'beta': '\u03B2',
    'brvbar': '\u00A6',
    'bull': '\u2022',
    'cap': '\u2229',
    'Ccedil': '\u00C7',
    'ccedil': '\u00E7',
    'cedil': '\u00B8',
    'cent': '\u00A2',
    'Chi': '\u03A7',
    'chi': '\u03C7',
    'circ': '\u02C6',
    'clubs': '\u2663',
    'cong': '\u2245',
    'copy': '\u00A9',
    'crarr': '\u21B5',
    'cup': '\u222A',
    'curren': '\u00A4',
    'dagger': '\u2020',
    'Dagger': '\u2021',
    'darr': '\u2193',
    'dArr': '\u21D3',
    'deg': '\u00B0',
    'Delta': '\u0394',
    'delta': '\u03B4',
    'diams': '\u2666',
    'divide': '\u00F7',
    'Eacute': '\u00C9',
    'eacute': '\u00E9',
    'Ecirc': '\u00CA',
    'ecirc': '\u00EA',
    'Egrave': '\u00C8',
    'egrave': '\u00E8',
    'empty': '\u2205',
    'emsp': '\u2003',
    'ensp': '\u2002',
    'Epsilon': '\u0395',
    'epsilon': '\u03B5',
    'equiv': '\u2261',
    'Eta': '\u0397',
    'eta': '\u03B7',
    'ETH': '\u00D0',
    'eth': '\u00F0',
    'Euml': '\u00CB',
    'euml': '\u00EB',
    'euro': '\u20AC',
    'exist': '\u2203',
    'fnof': '\u0192',
    'forall': '\u2200',
    'frac12': '\u00BD',
    'frac14': '\u00BC',
    'frac34': '\u00BE',
    'frasl': '\u2044',
    'Gamma': '\u0393',
    'gamma': '\u03B3',
    'ge': '\u2265',
    'gt': '>',
    'harr': '\u2194',
    'hArr': '\u21D4',
    'hearts': '\u2665',
    'hellip': '\u2026',
    'Iacute': '\u00CD',
    'iacute': '\u00ED',
    'Icirc': '\u00CE',
    'icirc': '\u00EE',
    'iexcl': '\u00A1',
    'Igrave': '\u00CC',
    'igrave': '\u00EC',
    'image': '\u2111',
    'infin': '\u221E',
    'int': '\u222B',
    'Iota': '\u0399',
    'iota': '\u03B9',
    'iquest': '\u00BF',
    'isin': '\u2208',
    'Iuml': '\u00CF',
    'iuml': '\u00EF',
    'Kappa': '\u039A',
    'kappa': '\u03BA',
    'Lambda': '\u039B',
    'lambda': '\u03BB',
    'lang': '\u27E8',
    'laquo': '\u00AB',
    'larr': '\u2190',
    'lArr': '\u21D0',
    'lceil': '\u2308',
    'ldquo': '\u201C',
    'le': '\u2264',
    'lfloor': '\u230A',
    'lowast': '\u2217',
    'loz': '\u25CA',
    'lrm': '\u200E',
    'lsaquo': '\u2039',
    'lsquo': '\u2018',
    'lt': '<',
    'macr': '\u00AF',
    'mdash': '\u2014',
    'micro': '\u00B5',
    'middot': '\u00B7',
    'minus': '\u2212',
    'Mu': '\u039C',
    'mu': '\u03BC',
    'nabla': '\u2207',
    'nbsp': '\u00A0',
    'ndash': '\u2013',
    'ne': '\u2260',
    'ni': '\u220B',
    'not': '\u00AC',
    'notin': '\u2209',
    'nsub': '\u2284',
    'Ntilde': '\u00D1',
    'ntilde': '\u00F1',
    'Nu': '\u039D',
    'nu': '\u03BD',
    'Oacute': '\u00D3',
    'oacute': '\u00F3',
    'Ocirc': '\u00D4',
    'ocirc': '\u00F4',
    'OElig': '\u0152',
    'oelig': '\u0153',
    'Ograve': '\u00D2',
    'ograve': '\u00F2',
    'oline': '\u203E',
    'Omega': '\u03A9',
    'omega': '\u03C9',
    'Omicron': '\u039F',
    'omicron': '\u03BF',
    'oplus': '\u2295',
    'or': '\u2228',
    'ordf': '\u00AA',
    'ordm': '\u00BA',
    'Oslash': '\u00D8',
    'oslash': '\u00F8',
    'Otilde': '\u00D5',
    'otilde': '\u00F5',
    'otimes': '\u2297',
    'Ouml': '\u00D6',
    'ouml': '\u00F6',
    'para': '\u00B6',
    'permil': '\u2030',
    'perp': '\u22A5',
    'Phi': '\u03A6',
    'phi': '\u03C6',
    'Pi': '\u03A0',
    'pi': '\u03C0',
    'piv': '\u03D6',
    'plusmn': '\u00B1',
    'pound': '\u00A3',
    'prime': '\u2032',
    'Prime': '\u2033',
    'prod': '\u220F',
    'prop': '\u221D',
    'Psi': '\u03A8',
    'psi': '\u03C8',
    'quot': '\u0022',
    'radic': '\u221A',
    'rang': '\u27E9',
    'raquo': '\u00BB',
    'rarr': '\u2192',
    'rArr': '\u21D2',
    'rceil': '\u2309',
    'rdquo': '\u201D',
    'real': '\u211C',
    'reg': '\u00AE',
    'rfloor': '\u230B',
    'Rho': '\u03A1',
    'rho': '\u03C1',
    'rlm': '\u200F',
    'rsaquo': '\u203A',
    'rsquo': '\u2019',
    'sbquo': '\u201A',
    'Scaron': '\u0160',
    'scaron': '\u0161',
    'sdot': '\u22C5',
    'sect': '\u00A7',
    'shy': '\u00AD',
    'Sigma': '\u03A3',
    'sigma': '\u03C3',
    'sigmaf': '\u03C2',
    'sim': '\u223C',
    'spades': '\u2660',
    'sub': '\u2282',
    'sube': '\u2286',
    'sum': '\u2211',
    'sup': '\u2283',
    'sup1': '\u00B9',
    'sup2': '\u00B2',
    'sup3': '\u00B3',
    'supe': '\u2287',
    'szlig': '\u00DF',
    'Tau': '\u03A4',
    'tau': '\u03C4',
    'there4': '\u2234',
    'Theta': '\u0398',
    'theta': '\u03B8',
    'thetasym': '\u03D1',
    'thinsp': '\u2009',
    'THORN': '\u00DE',
    'thorn': '\u00FE',
    'tilde': '\u02DC',
    'times': '\u00D7',
    'trade': '\u2122',
    'Uacute': '\u00DA',
    'uacute': '\u00FA',
    'uarr': '\u2191',
    'uArr': '\u21D1',
    'Ucirc': '\u00DB',
    'ucirc': '\u00FB',
    'Ugrave': '\u00D9',
    'ugrave': '\u00F9',
    'uml': '\u00A8',
    'upsih': '\u03D2',
    'Upsilon': '\u03A5',
    'upsilon': '\u03C5',
    'Uuml': '\u00DC',
    'uuml': '\u00FC',
    'weierp': '\u2118',
    'Xi': '\u039E',
    'xi': '\u03BE',
    'Yacute': '\u00DD',
    'yacute': '\u00FD',
    'yen': '\u00A5',
    'yuml': '\u00FF',
    'Yuml': '\u0178',
    'Zeta': '\u0396',
    'zeta': '\u03B6',
    'zwj': '\u200D',
    'zwnj': '\u200C',
};
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var HtmlTagDefinition = (function () {
    /**
     * @param {?=} __0
     */
    function HtmlTagDefinition(_a) {
        var _b = _a === void 0 ? {} : _a, closedByChildren = _b.closedByChildren, requiredParents = _b.requiredParents, implicitNamespacePrefix = _b.implicitNamespacePrefix, _c = _b.contentType, contentType = _c === void 0 ? TagContentType.PARSABLE_DATA : _c, _d = _b.closedByParent, closedByParent = _d === void 0 ? false : _d, _e = _b.isVoid, isVoid = _e === void 0 ? false : _e, _f = _b.ignoreFirstLf, ignoreFirstLf = _f === void 0 ? false : _f;
        var _this = this;
        this.closedByChildren = {};
        this.closedByParent = false;
        this.canSelfClose = false;
        if (closedByChildren && closedByChildren.length > 0) {
            closedByChildren.forEach(function (tagName) { return _this.closedByChildren[tagName] = true; });
        }
        this.isVoid = isVoid;
        this.closedByParent = closedByParent || isVoid;
        if (requiredParents && requiredParents.length > 0) {
            this.requiredParents = {};
            // The first parent is the list is automatically when none of the listed parents are present
            this.parentToAdd = requiredParents[0];
            requiredParents.forEach(function (tagName) { return _this.requiredParents[tagName] = true; });
        }
        this.implicitNamespacePrefix = implicitNamespacePrefix || null;
        this.contentType = contentType;
        this.ignoreFirstLf = ignoreFirstLf;
    }
    /**
     * @param {?} currentParent
     * @return {?}
     */
    HtmlTagDefinition.prototype.requireExtraParent = function (currentParent) {
        if (!this.requiredParents) {
            return false;
        }
        if (!currentParent) {
            return true;
        }
        var /** @type {?} */ lcParent = currentParent.toLowerCase();
        var /** @type {?} */ isParentTemplate = lcParent === 'template' || currentParent === 'ng-template';
        return !isParentTemplate && this.requiredParents[lcParent] != true;
    };
    /**
     * @param {?} name
     * @return {?}
     */
    HtmlTagDefinition.prototype.isClosedByChild = function (name) {
        return this.isVoid || name.toLowerCase() in this.closedByChildren;
    };
    return HtmlTagDefinition;
}());
// see http://www.w3.org/TR/html51/syntax.html#optional-tags
// This implementation does not fully conform to the HTML5 spec.
var TAG_DEFINITIONS = {
    'base': new HtmlTagDefinition({ isVoid: true }),
    'meta': new HtmlTagDefinition({ isVoid: true }),
    'area': new HtmlTagDefinition({ isVoid: true }),
    'embed': new HtmlTagDefinition({ isVoid: true }),
    'link': new HtmlTagDefinition({ isVoid: true }),
    'img': new HtmlTagDefinition({ isVoid: true }),
    'input': new HtmlTagDefinition({ isVoid: true }),
    'param': new HtmlTagDefinition({ isVoid: true }),
    'hr': new HtmlTagDefinition({ isVoid: true }),
    'br': new HtmlTagDefinition({ isVoid: true }),
    'source': new HtmlTagDefinition({ isVoid: true }),
    'track': new HtmlTagDefinition({ isVoid: true }),
    'wbr': new HtmlTagDefinition({ isVoid: true }),
    'p': new HtmlTagDefinition({
        closedByChildren: [
            'address', 'article', 'aside', 'blockquote', 'div', 'dl', 'fieldset', 'footer', 'form',
            'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'header', 'hgroup', 'hr',
            'main', 'nav', 'ol', 'p', 'pre', 'section', 'table', 'ul'
        ],
        closedByParent: true
    }),
    'thead': new HtmlTagDefinition({ closedByChildren: ['tbody', 'tfoot'] }),
    'tbody': new HtmlTagDefinition({ closedByChildren: ['tbody', 'tfoot'], closedByParent: true }),
    'tfoot': new HtmlTagDefinition({ closedByChildren: ['tbody'], closedByParent: true }),
    'tr': new HtmlTagDefinition({
        closedByChildren: ['tr'],
        requiredParents: ['tbody', 'tfoot', 'thead'],
        closedByParent: true
    }),
    'td': new HtmlTagDefinition({ closedByChildren: ['td', 'th'], closedByParent: true }),
    'th': new HtmlTagDefinition({ closedByChildren: ['td', 'th'], closedByParent: true }),
    'col': new HtmlTagDefinition({ requiredParents: ['colgroup'], isVoid: true }),
    'svg': new HtmlTagDefinition({ implicitNamespacePrefix: 'svg' }),
    'math': new HtmlTagDefinition({ implicitNamespacePrefix: 'math' }),
    'li': new HtmlTagDefinition({ closedByChildren: ['li'], closedByParent: true }),
    'dt': new HtmlTagDefinition({ closedByChildren: ['dt', 'dd'] }),
    'dd': new HtmlTagDefinition({ closedByChildren: ['dt', 'dd'], closedByParent: true }),
    'rb': new HtmlTagDefinition({ closedByChildren: ['rb', 'rt', 'rtc', 'rp'], closedByParent: true }),
    'rt': new HtmlTagDefinition({ closedByChildren: ['rb', 'rt', 'rtc', 'rp'], closedByParent: true }),
    'rtc': new HtmlTagDefinition({ closedByChildren: ['rb', 'rtc', 'rp'], closedByParent: true }),
    'rp': new HtmlTagDefinition({ closedByChildren: ['rb', 'rt', 'rtc', 'rp'], closedByParent: true }),
    'optgroup': new HtmlTagDefinition({ closedByChildren: ['optgroup'], closedByParent: true }),
    'option': new HtmlTagDefinition({ closedByChildren: ['option', 'optgroup'], closedByParent: true }),
    'pre': new HtmlTagDefinition({ ignoreFirstLf: true }),
    'listing': new HtmlTagDefinition({ ignoreFirstLf: true }),
    'style': new HtmlTagDefinition({ contentType: TagContentType.RAW_TEXT }),
    'script': new HtmlTagDefinition({ contentType: TagContentType.RAW_TEXT }),
    'title': new HtmlTagDefinition({ contentType: TagContentType.ESCAPABLE_RAW_TEXT }),
    'textarea': new HtmlTagDefinition({ contentType: TagContentType.ESCAPABLE_RAW_TEXT, ignoreFirstLf: true }),
};
var _DEFAULT_TAG_DEFINITION = new HtmlTagDefinition();
/**
 * @param {?} tagName
 * @return {?}
 */
function getHtmlTagDefinition(tagName) {
    return TAG_DEFINITIONS[tagName.toLowerCase()] || _DEFAULT_TAG_DEFINITION;
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var _SELECTOR_REGEXP = new RegExp('(\\:not\\()|' +
    '([-\\w]+)|' +
    '(?:\\.([-\\w]+))|' +
    // "-" should appear first in the regexp below as FF31 parses "[.-\w]" as a range
    '(?:\\[([-.\\w*]+)(?:=([\"\']?)([^\\]\"\']*)\\5)?\\])|' +
    // "[name="value"]",
    // "[name='value']"
    '(\\))|' +
    '(\\s*,\\s*)', // ","
'g');
/**
 * A css selector contains an element name,
 * css classes and attribute/value pairs with the purpose
 * of selecting subsets out of them.
 */
var CssSelector = (function () {
    function CssSelector() {
        this.element = null;
        this.classNames = [];
        this.attrs = [];
        this.notSelectors = [];
    }
    /**
     * @param {?} selector
     * @return {?}
     */
    CssSelector.parse = function (selector) {
        var /** @type {?} */ results = [];
        var /** @type {?} */ _addResult = function (res, cssSel) {
            if (cssSel.notSelectors.length > 0 && !cssSel.element && cssSel.classNames.length == 0 &&
                cssSel.attrs.length == 0) {
                cssSel.element = '*';
            }
            res.push(cssSel);
        };
        var /** @type {?} */ cssSelector = new CssSelector();
        var /** @type {?} */ match;
        var /** @type {?} */ current = cssSelector;
        var /** @type {?} */ inNot = false;
        _SELECTOR_REGEXP.lastIndex = 0;
        while (match = _SELECTOR_REGEXP.exec(selector)) {
            if (match[1]) {
                if (inNot) {
                    throw new Error('Nesting :not is not allowed in a selector');
                }
                inNot = true;
                current = new CssSelector();
                cssSelector.notSelectors.push(current);
            }
            if (match[2]) {
                current.setElement(match[2]);
            }
            if (match[3]) {
                current.addClassName(match[3]);
            }
            if (match[4]) {
                current.addAttribute(match[4], match[6]);
            }
            if (match[7]) {
                inNot = false;
                current = cssSelector;
            }
            if (match[8]) {
                if (inNot) {
                    throw new Error('Multiple selectors in :not are not supported');
                }
                _addResult(results, cssSelector);
                cssSelector = current = new CssSelector();
            }
        }
        _addResult(results, cssSelector);
        return results;
    };
    /**
     * @return {?}
     */
    CssSelector.prototype.isElementSelector = function () {
        return this.hasElementSelector() && this.classNames.length == 0 && this.attrs.length == 0 &&
            this.notSelectors.length === 0;
    };
    /**
     * @return {?}
     */
    CssSelector.prototype.hasElementSelector = function () { return !!this.element; };
    /**
     * @param {?=} element
     * @return {?}
     */
    CssSelector.prototype.setElement = function (element) {
        if (element === void 0) { element = null; }
        this.element = element;
    };
    /**
     * Gets a template string for an element that matches the selector.
     * @return {?}
     */
    CssSelector.prototype.getMatchingElementTemplate = function () {
        var /** @type {?} */ tagName = this.element || 'div';
        var /** @type {?} */ classAttr = this.classNames.length > 0 ? " class=\"" + this.classNames.join(' ') + "\"" : '';
        var /** @type {?} */ attrs = '';
        for (var /** @type {?} */ i = 0; i < this.attrs.length; i += 2) {
            var /** @type {?} */ attrName = this.attrs[i];
            var /** @type {?} */ attrValue = this.attrs[i + 1] !== '' ? "=\"" + this.attrs[i + 1] + "\"" : '';
            attrs += " " + attrName + attrValue;
        }
        return getHtmlTagDefinition(tagName).isVoid ? "<" + tagName + classAttr + attrs + "/>" :
            "<" + tagName + classAttr + attrs + "></" + tagName + ">";
    };
    /**
     * @param {?} name
     * @param {?=} value
     * @return {?}
     */
    CssSelector.prototype.addAttribute = function (name, value) {
        if (value === void 0) { value = ''; }
        this.attrs.push(name, value && value.toLowerCase() || '');
    };
    /**
     * @param {?} name
     * @return {?}
     */
    CssSelector.prototype.addClassName = function (name) { this.classNames.push(name.toLowerCase()); };
    /**
     * @return {?}
     */
    CssSelector.prototype.toString = function () {
        var /** @type {?} */ res = this.element || '';
        if (this.classNames) {
            this.classNames.forEach(function (klass) { return res += "." + klass; });
        }
        if (this.attrs) {
            for (var /** @type {?} */ i = 0; i < this.attrs.length; i += 2) {
                var /** @type {?} */ name = this.attrs[i];
                var /** @type {?} */ value = this.attrs[i + 1];
                res += "[" + name + (value ? '=' + value : '') + "]";
            }
        }
        this.notSelectors.forEach(function (notSelector) { return res += ":not(" + notSelector + ")"; });
        return res;
    };
    return CssSelector;
}());
/**
 * Reads a list of CssSelectors and allows to calculate which ones
 * are contained in a given CssSelector.
 */
var SelectorMatcher = (function () {
    function SelectorMatcher() {
        this._elementMap = new Map();
        this._elementPartialMap = new Map();
        this._classMap = new Map();
        this._classPartialMap = new Map();
        this._attrValueMap = new Map();
        this._attrValuePartialMap = new Map();
        this._listContexts = [];
    }
    /**
     * @param {?} notSelectors
     * @return {?}
     */
    SelectorMatcher.createNotMatcher = function (notSelectors) {
        var /** @type {?} */ notMatcher = new SelectorMatcher();
        notMatcher.addSelectables(notSelectors, null);
        return notMatcher;
    };
    /**
     * @param {?} cssSelectors
     * @param {?=} callbackCtxt
     * @return {?}
     */
    SelectorMatcher.prototype.addSelectables = function (cssSelectors, callbackCtxt) {
        var /** @type {?} */ listContext = ((null));
        if (cssSelectors.length > 1) {
            listContext = new SelectorListContext(cssSelectors);
            this._listContexts.push(listContext);
        }
        for (var /** @type {?} */ i = 0; i < cssSelectors.length; i++) {
            this._addSelectable(cssSelectors[i], callbackCtxt, listContext);
        }
    };
    /**
     * Add an object that can be found later on by calling `match`.
     * @param {?} cssSelector A css selector
     * @param {?} callbackCtxt An opaque object that will be given to the callback of the `match` function
     * @param {?} listContext
     * @return {?}
     */
    SelectorMatcher.prototype._addSelectable = function (cssSelector, callbackCtxt, listContext) {
        var /** @type {?} */ matcher = this;
        var /** @type {?} */ element = cssSelector.element;
        var /** @type {?} */ classNames = cssSelector.classNames;
        var /** @type {?} */ attrs = cssSelector.attrs;
        var /** @type {?} */ selectable = new SelectorContext(cssSelector, callbackCtxt, listContext);
        if (element) {
            var /** @type {?} */ isTerminal = attrs.length === 0 && classNames.length === 0;
            if (isTerminal) {
                this._addTerminal(matcher._elementMap, element, selectable);
            }
            else {
                matcher = this._addPartial(matcher._elementPartialMap, element);
            }
        }
        if (classNames) {
            for (var /** @type {?} */ i = 0; i < classNames.length; i++) {
                var /** @type {?} */ isTerminal = attrs.length === 0 && i === classNames.length - 1;
                var /** @type {?} */ className = classNames[i];
                if (isTerminal) {
                    this._addTerminal(matcher._classMap, className, selectable);
                }
                else {
                    matcher = this._addPartial(matcher._classPartialMap, className);
                }
            }
        }
        if (attrs) {
            for (var /** @type {?} */ i = 0; i < attrs.length; i += 2) {
                var /** @type {?} */ isTerminal = i === attrs.length - 2;
                var /** @type {?} */ name = attrs[i];
                var /** @type {?} */ value = attrs[i + 1];
                if (isTerminal) {
                    var /** @type {?} */ terminalMap = matcher._attrValueMap;
                    var /** @type {?} */ terminalValuesMap = terminalMap.get(name);
                    if (!terminalValuesMap) {
                        terminalValuesMap = new Map();
                        terminalMap.set(name, terminalValuesMap);
                    }
                    this._addTerminal(terminalValuesMap, value, selectable);
                }
                else {
                    var /** @type {?} */ partialMap = matcher._attrValuePartialMap;
                    var /** @type {?} */ partialValuesMap = partialMap.get(name);
                    if (!partialValuesMap) {
                        partialValuesMap = new Map();
                        partialMap.set(name, partialValuesMap);
                    }
                    matcher = this._addPartial(partialValuesMap, value);
                }
            }
        }
    };
    /**
     * @param {?} map
     * @param {?} name
     * @param {?} selectable
     * @return {?}
     */
    SelectorMatcher.prototype._addTerminal = function (map, name, selectable) {
        var /** @type {?} */ terminalList = map.get(name);
        if (!terminalList) {
            terminalList = [];
            map.set(name, terminalList);
        }
        terminalList.push(selectable);
    };
    /**
     * @param {?} map
     * @param {?} name
     * @return {?}
     */
    SelectorMatcher.prototype._addPartial = function (map, name) {
        var /** @type {?} */ matcher = map.get(name);
        if (!matcher) {
            matcher = new SelectorMatcher();
            map.set(name, matcher);
        }
        return matcher;
    };
    /**
     * Find the objects that have been added via `addSelectable`
     * whose css selector is contained in the given css selector.
     * @param {?} cssSelector A css selector
     * @param {?} matchedCallback This callback will be called with the object handed into `addSelectable`
     * @return {?} boolean true if a match was found
     */
    SelectorMatcher.prototype.match = function (cssSelector, matchedCallback) {
        var /** @type {?} */ result = false;
        var /** @type {?} */ element = ((cssSelector.element));
        var /** @type {?} */ classNames = cssSelector.classNames;
        var /** @type {?} */ attrs = cssSelector.attrs;
        for (var /** @type {?} */ i = 0; i < this._listContexts.length; i++) {
            this._listContexts[i].alreadyMatched = false;
        }
        result = this._matchTerminal(this._elementMap, element, cssSelector, matchedCallback) || result;
        result = this._matchPartial(this._elementPartialMap, element, cssSelector, matchedCallback) ||
            result;
        if (classNames) {
            for (var /** @type {?} */ i = 0; i < classNames.length; i++) {
                var /** @type {?} */ className = classNames[i];
                result =
                    this._matchTerminal(this._classMap, className, cssSelector, matchedCallback) || result;
                result =
                    this._matchPartial(this._classPartialMap, className, cssSelector, matchedCallback) ||
                        result;
            }
        }
        if (attrs) {
            for (var /** @type {?} */ i = 0; i < attrs.length; i += 2) {
                var /** @type {?} */ name = attrs[i];
                var /** @type {?} */ value = attrs[i + 1];
                var /** @type {?} */ terminalValuesMap = ((this._attrValueMap.get(name)));
                if (value) {
                    result =
                        this._matchTerminal(terminalValuesMap, '', cssSelector, matchedCallback) || result;
                }
                result =
                    this._matchTerminal(terminalValuesMap, value, cssSelector, matchedCallback) || result;
                var /** @type {?} */ partialValuesMap = ((this._attrValuePartialMap.get(name)));
                if (value) {
                    result = this._matchPartial(partialValuesMap, '', cssSelector, matchedCallback) || result;
                }
                result =
                    this._matchPartial(partialValuesMap, value, cssSelector, matchedCallback) || result;
            }
        }
        return result;
    };
    /**
     * \@internal
     * @param {?} map
     * @param {?} name
     * @param {?} cssSelector
     * @param {?} matchedCallback
     * @return {?}
     */
    SelectorMatcher.prototype._matchTerminal = function (map, name, cssSelector, matchedCallback) {
        if (!map || typeof name !== 'string') {
            return false;
        }
        var /** @type {?} */ selectables = map.get(name) || [];
        var /** @type {?} */ starSelectables = ((map.get('*')));
        if (starSelectables) {
            selectables = selectables.concat(starSelectables);
        }
        if (selectables.length === 0) {
            return false;
        }
        var /** @type {?} */ selectable;
        var /** @type {?} */ result = false;
        for (var /** @type {?} */ i = 0; i < selectables.length; i++) {
            selectable = selectables[i];
            result = selectable.finalize(cssSelector, matchedCallback) || result;
        }
        return result;
    };
    /**
     * \@internal
     * @param {?} map
     * @param {?} name
     * @param {?} cssSelector
     * @param {?} matchedCallback
     * @return {?}
     */
    SelectorMatcher.prototype._matchPartial = function (map, name, cssSelector, matchedCallback) {
        if (!map || typeof name !== 'string') {
            return false;
        }
        var /** @type {?} */ nestedSelector = map.get(name);
        if (!nestedSelector) {
            return false;
        }
        // TODO(perf): get rid of recursion and measure again
        // TODO(perf): don't pass the whole selector into the recursion,
        // but only the not processed parts
        return nestedSelector.match(cssSelector, matchedCallback);
    };
    return SelectorMatcher;
}());
var SelectorListContext = (function () {
    /**
     * @param {?} selectors
     */
    function SelectorListContext(selectors) {
        this.selectors = selectors;
        this.alreadyMatched = false;
    }
    return SelectorListContext;
}());
var SelectorContext = (function () {
    /**
     * @param {?} selector
     * @param {?} cbContext
     * @param {?} listContext
     */
    function SelectorContext(selector, cbContext, listContext) {
        this.selector = selector;
        this.cbContext = cbContext;
        this.listContext = listContext;
        this.notSelectors = selector.notSelectors;
    }
    /**
     * @param {?} cssSelector
     * @param {?} callback
     * @return {?}
     */
    SelectorContext.prototype.finalize = function (cssSelector, callback) {
        var /** @type {?} */ result = true;
        if (this.notSelectors.length > 0 && (!this.listContext || !this.listContext.alreadyMatched)) {
            var /** @type {?} */ notMatcher = SelectorMatcher.createNotMatcher(this.notSelectors);
            result = !notMatcher.match(cssSelector, null);
        }
        if (result && callback && (!this.listContext || !this.listContext.alreadyMatched)) {
            if (this.listContext) {
                this.listContext.alreadyMatched = true;
            }
            callback(this.selector, this.cbContext);
        }
        return result;
    };
    return SelectorContext;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var MODULE_SUFFIX = '';
var DASH_CASE_REGEXP = /-+([a-z0-9])/g;
/**
 * @param {?} input
 * @return {?}
 */
/**
 * @param {?} input
 * @return {?}
 */
function dashCaseToCamelCase(input) {
    return input.replace(DASH_CASE_REGEXP, function () {
        var m = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            m[_i] = arguments[_i];
        }
        return m[1].toUpperCase();
    });
}
/**
 * @param {?} input
 * @param {?} defaultValues
 * @return {?}
 */
function splitAtColon(input, defaultValues) {
    return _splitAt(input, ':', defaultValues);
}
/**
 * @param {?} input
 * @param {?} defaultValues
 * @return {?}
 */
function splitAtPeriod(input, defaultValues) {
    return _splitAt(input, '.', defaultValues);
}
/**
 * @param {?} input
 * @param {?} character
 * @param {?} defaultValues
 * @return {?}
 */
function _splitAt(input, character, defaultValues) {
    var /** @type {?} */ characterIndex = input.indexOf(character);
    if (characterIndex == -1)
        return defaultValues;
    return [input.slice(0, characterIndex).trim(), input.slice(characterIndex + 1).trim()];
}
/**
 * @param {?} value
 * @param {?} visitor
 * @param {?} context
 * @return {?}
 */
function visitValue(value, visitor, context) {
    if (Array.isArray(value)) {
        return visitor.visitArray(/** @type {?} */ (value), context);
    }
    if (isStrictStringMap(value)) {
        return visitor.visitStringMap(/** @type {?} */ (value), context);
    }
    if (value == null || typeof value == 'string' || typeof value == 'number' ||
        typeof value == 'boolean') {
        return visitor.visitPrimitive(value, context);
    }
    return visitor.visitOther(value, context);
}
/**
 * @param {?} val
 * @return {?}
 */
function isDefined(val) {
    return val !== null && val !== undefined;
}
/**
 * @template T
 * @param {?} val
 * @return {?}
 */
function noUndefined(val) {
    return val === undefined ? ((null)) : val;
}
var ValueTransformer = (function () {
    function ValueTransformer() {
    }
    /**
     * @param {?} arr
     * @param {?} context
     * @return {?}
     */
    ValueTransformer.prototype.visitArray = function (arr, context) {
        var _this = this;
        return arr.map(function (value) { return visitValue(value, _this, context); });
    };
    /**
     * @param {?} map
     * @param {?} context
     * @return {?}
     */
    ValueTransformer.prototype.visitStringMap = function (map, context) {
        var _this = this;
        var /** @type {?} */ result = {};
        Object.keys(map).forEach(function (key) { result[key] = visitValue(map[key], _this, context); });
        return result;
    };
    /**
     * @param {?} value
     * @param {?} context
     * @return {?}
     */
    ValueTransformer.prototype.visitPrimitive = function (value, context) { return value; };
    /**
     * @param {?} value
     * @param {?} context
     * @return {?}
     */
    ValueTransformer.prototype.visitOther = function (value, context) { return value; };
    return ValueTransformer;
}());
var SyncAsyncResult = (function () {
    /**
     * @param {?} syncResult
     * @param {?=} asyncResult
     */
    function SyncAsyncResult(syncResult, asyncResult) {
        if (asyncResult === void 0) { asyncResult = null; }
        this.syncResult = syncResult;
        this.asyncResult = asyncResult;
        if (!asyncResult) {
            this.asyncResult = Promise.resolve(syncResult);
        }
    }
    return SyncAsyncResult;
}());
/**
 * @param {?} msg
 * @return {?}
 */
function syntaxError(msg) {
    var /** @type {?} */ error = Error(msg);
    ((error))[ERROR_SYNTAX_ERROR] = true;
    return error;
}
var ERROR_SYNTAX_ERROR = 'ngSyntaxError';
/**
 * @param {?} error
 * @return {?}
 */
function isSyntaxError(error) {
    return ((error))[ERROR_SYNTAX_ERROR];
}
/**
 * @param {?} s
 * @return {?}
 */
function escapeRegExp(s) {
    return s.replace(/([.*+?^=!:${}()|[\]\/\\])/g, '\\$1');
}
var STRING_MAP_PROTO = Object.getPrototypeOf({});
/**
 * @param {?} obj
 * @return {?}
 */
function isStrictStringMap(obj) {
    return typeof obj === 'object' && obj !== null && Object.getPrototypeOf(obj) === STRING_MAP_PROTO;
}
/**
 * @param {?} str
 * @return {?}
 */
function utf8Encode(str) {
    var /** @type {?} */ encoded = '';
    for (var /** @type {?} */ index = 0; index < str.length; index++) {
        var /** @type {?} */ codePoint = str.charCodeAt(index);
        // decode surrogate
        // see https://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
        if (codePoint >= 0xd800 && codePoint <= 0xdbff && str.length > (index + 1)) {
            var /** @type {?} */ low = str.charCodeAt(index + 1);
            if (low >= 0xdc00 && low <= 0xdfff) {
                index++;
                codePoint = ((codePoint - 0xd800) << 10) + low - 0xdc00 + 0x10000;
            }
        }
        if (codePoint <= 0x7f) {
            encoded += String.fromCharCode(codePoint);
        }
        else if (codePoint <= 0x7ff) {
            encoded += String.fromCharCode(((codePoint >> 6) & 0x1F) | 0xc0, (codePoint & 0x3f) | 0x80);
        }
        else if (codePoint <= 0xffff) {
            encoded += String.fromCharCode((codePoint >> 12) | 0xe0, ((codePoint >> 6) & 0x3f) | 0x80, (codePoint & 0x3f) | 0x80);
        }
        else if (codePoint <= 0x1fffff) {
            encoded += String.fromCharCode(((codePoint >> 18) & 0x07) | 0xf0, ((codePoint >> 12) & 0x3f) | 0x80, ((codePoint >> 6) & 0x3f) | 0x80, (codePoint & 0x3f) | 0x80);
        }
    }
    return encoded;
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
// group 0: "[prop] or (event) or @trigger"
// group 1: "prop" from "[prop]"
// group 2: "event" from "(event)"
// group 3: "@trigger" from "@trigger"
var HOST_REG_EXP = /^(?:(?:\[([^\]]+)\])|(?:\(([^\)]+)\)))|(\@[-\w]+)$/;
var CompileAnimationEntryMetadata = (function () {
    /**
     * @param {?=} name
     * @param {?=} definitions
     */
    function CompileAnimationEntryMetadata(name, definitions) {
        if (name === void 0) { name = null; }
        if (definitions === void 0) { definitions = null; }
        this.name = name;
        this.definitions = definitions;
    }
    return CompileAnimationEntryMetadata;
}());
/**
 * @abstract
 */
var CompileAnimationStateMetadata = (function () {
    function CompileAnimationStateMetadata() {
    }
    return CompileAnimationStateMetadata;
}());
var CompileAnimationStateDeclarationMetadata = (function (_super) {
    __extends(CompileAnimationStateDeclarationMetadata, _super);
    /**
     * @param {?} stateNameExpr
     * @param {?} styles
     */
    function CompileAnimationStateDeclarationMetadata(stateNameExpr, styles) {
        var _this = _super.call(this) || this;
        _this.stateNameExpr = stateNameExpr;
        _this.styles = styles;
        return _this;
    }
    return CompileAnimationStateDeclarationMetadata;
}(CompileAnimationStateMetadata));
var CompileAnimationStateTransitionMetadata = (function (_super) {
    __extends(CompileAnimationStateTransitionMetadata, _super);
    /**
     * @param {?} stateChangeExpr
     * @param {?} steps
     */
    function CompileAnimationStateTransitionMetadata(stateChangeExpr, steps) {
        var _this = _super.call(this) || this;
        _this.stateChangeExpr = stateChangeExpr;
        _this.steps = steps;
        return _this;
    }
    return CompileAnimationStateTransitionMetadata;
}(CompileAnimationStateMetadata));
/**
 * @abstract
 */
var CompileAnimationMetadata = (function () {
    function CompileAnimationMetadata() {
    }
    return CompileAnimationMetadata;
}());
var CompileAnimationKeyframesSequenceMetadata = (function (_super) {
    __extends(CompileAnimationKeyframesSequenceMetadata, _super);
    /**
     * @param {?=} steps
     */
    function CompileAnimationKeyframesSequenceMetadata(steps) {
        if (steps === void 0) { steps = []; }
        var _this = _super.call(this) || this;
        _this.steps = steps;
        return _this;
    }
    return CompileAnimationKeyframesSequenceMetadata;
}(CompileAnimationMetadata));
var CompileAnimationStyleMetadata = (function (_super) {
    __extends(CompileAnimationStyleMetadata, _super);
    /**
     * @param {?} offset
     * @param {?=} styles
     */
    function CompileAnimationStyleMetadata(offset, styles) {
        if (styles === void 0) { styles = null; }
        var _this = _super.call(this) || this;
        _this.offset = offset;
        _this.styles = styles;
        return _this;
    }
    return CompileAnimationStyleMetadata;
}(CompileAnimationMetadata));
var CompileAnimationAnimateMetadata = (function (_super) {
    __extends(CompileAnimationAnimateMetadata, _super);
    /**
     * @param {?=} timings
     * @param {?=} styles
     */
    function CompileAnimationAnimateMetadata(timings, styles) {
        if (timings === void 0) { timings = 0; }
        if (styles === void 0) { styles = null; }
        var _this = _super.call(this) || this;
        _this.timings = timings;
        _this.styles = styles;
        return _this;
    }
    return CompileAnimationAnimateMetadata;
}(CompileAnimationMetadata));
/**
 * @abstract
 */
var CompileAnimationWithStepsMetadata = (function (_super) {
    __extends(CompileAnimationWithStepsMetadata, _super);
    /**
     * @param {?=} steps
     */
    function CompileAnimationWithStepsMetadata(steps) {
        if (steps === void 0) { steps = null; }
        var _this = _super.call(this) || this;
        _this.steps = steps;
        return _this;
    }
    return CompileAnimationWithStepsMetadata;
}(CompileAnimationMetadata));
var CompileAnimationSequenceMetadata = (function (_super) {
    __extends(CompileAnimationSequenceMetadata, _super);
    /**
     * @param {?=} steps
     */
    function CompileAnimationSequenceMetadata(steps) {
        if (steps === void 0) { steps = null; }
        return _super.call(this, steps) || this;
    }
    return CompileAnimationSequenceMetadata;
}(CompileAnimationWithStepsMetadata));
var CompileAnimationGroupMetadata = (function (_super) {
    __extends(CompileAnimationGroupMetadata, _super);
    /**
     * @param {?=} steps
     */
    function CompileAnimationGroupMetadata(steps) {
        if (steps === void 0) { steps = null; }
        return _super.call(this, steps) || this;
    }
    return CompileAnimationGroupMetadata;
}(CompileAnimationWithStepsMetadata));
/**
 * @param {?} name
 * @return {?}
 */
function _sanitizeIdentifier(name) {
    return name.replace(/\W/g, '_');
}
var _anonymousTypeIndex = 0;
/**
 * @param {?} compileIdentifier
 * @return {?}
 */
function identifierName(compileIdentifier) {
    if (!compileIdentifier || !compileIdentifier.reference) {
        return null;
    }
    var /** @type {?} */ ref = compileIdentifier.reference;
    if (ref instanceof StaticSymbol) {
        return ref.name;
    }
    if (ref['__anonymousType']) {
        return ref['__anonymousType'];
    }
    var /** @type {?} */ identifier = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵstringify"])(ref);
    if (identifier.indexOf('(') >= 0) {
        // case: anonymous functions!
        identifier = "anonymous_" + _anonymousTypeIndex++;
        ref['__anonymousType'] = identifier;
    }
    else {
        identifier = _sanitizeIdentifier(identifier);
    }
    return identifier;
}
/**
 * @param {?} compileIdentifier
 * @return {?}
 */
function identifierModuleUrl(compileIdentifier) {
    var /** @type {?} */ ref = compileIdentifier.reference;
    if (ref instanceof StaticSymbol) {
        return ref.filePath;
    }
    return __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵreflector"].importUri(ref);
}
/**
 * @param {?} compType
 * @param {?} embeddedTemplateIndex
 * @return {?}
 */
function viewClassName(compType, embeddedTemplateIndex) {
    return "View_" + identifierName({ reference: compType }) + "_" + embeddedTemplateIndex;
}
/**
 * @param {?} compType
 * @return {?}
 */
function rendererTypeName(compType) {
    return "RenderType_" + identifierName({ reference: compType });
}
/**
 * @param {?} compType
 * @return {?}
 */
function hostViewClassName(compType) {
    return "HostView_" + identifierName({ reference: compType });
}
/**
 * @param {?} dirType
 * @return {?}
 */
function dirWrapperClassName(dirType) {
    return "Wrapper_" + identifierName({ reference: dirType });
}
/**
 * @param {?} compType
 * @return {?}
 */
function componentFactoryName(compType) {
    return identifierName({ reference: compType }) + "NgFactory";
}
var CompileSummaryKind = {};
CompileSummaryKind.Pipe = 0;
CompileSummaryKind.Directive = 1;
CompileSummaryKind.NgModule = 2;
CompileSummaryKind.Injectable = 3;
CompileSummaryKind[CompileSummaryKind.Pipe] = "Pipe";
CompileSummaryKind[CompileSummaryKind.Directive] = "Directive";
CompileSummaryKind[CompileSummaryKind.NgModule] = "NgModule";
CompileSummaryKind[CompileSummaryKind.Injectable] = "Injectable";
/**
 * @param {?} token
 * @return {?}
 */
function tokenName(token) {
    return token.value != null ? _sanitizeIdentifier(token.value) : identifierName(token.identifier);
}
/**
 * @param {?} token
 * @return {?}
 */
function tokenReference(token) {
    if (token.identifier != null) {
        return token.identifier.reference;
    }
    else {
        return token.value;
    }
}
/**
 * Metadata about a stylesheet
 */
var CompileStylesheetMetadata = (function () {
    /**
     * @param {?=} __0
     */
    function CompileStylesheetMetadata(_a) {
        var _b = _a === void 0 ? {} : _a, moduleUrl = _b.moduleUrl, styles = _b.styles, styleUrls = _b.styleUrls;
        this.moduleUrl = moduleUrl || null;
        this.styles = _normalizeArray(styles);
        this.styleUrls = _normalizeArray(styleUrls);
    }
    return CompileStylesheetMetadata;
}());
/**
 * Metadata regarding compilation of a template.
 */
var CompileTemplateMetadata = (function () {
    /**
     * @param {?} __0
     */
    function CompileTemplateMetadata(_a) {
        var encapsulation = _a.encapsulation, template = _a.template, templateUrl = _a.templateUrl, styles = _a.styles, styleUrls = _a.styleUrls, externalStylesheets = _a.externalStylesheets, animations = _a.animations, ngContentSelectors = _a.ngContentSelectors, interpolation = _a.interpolation, isInline = _a.isInline;
        this.encapsulation = encapsulation;
        this.template = template;
        this.templateUrl = templateUrl;
        this.styles = _normalizeArray(styles);
        this.styleUrls = _normalizeArray(styleUrls);
        this.externalStylesheets = _normalizeArray(externalStylesheets);
        this.animations = animations ? flatten(animations) : [];
        this.ngContentSelectors = ngContentSelectors || [];
        if (interpolation && interpolation.length != 2) {
            throw new Error("'interpolation' should have a start and an end symbol.");
        }
        this.interpolation = interpolation;
        this.isInline = isInline;
    }
    /**
     * @return {?}
     */
    CompileTemplateMetadata.prototype.toSummary = function () {
        return {
            animations: this.animations.map(function (anim) { return anim.name; }),
            ngContentSelectors: this.ngContentSelectors,
            encapsulation: this.encapsulation,
        };
    };
    return CompileTemplateMetadata;
}());
/**
 * Metadata regarding compilation of a directive.
 */
var CompileDirectiveMetadata = (function () {
    /**
     * @param {?} __0
     */
    function CompileDirectiveMetadata(_a) {
        var isHost = _a.isHost, type = _a.type, isComponent = _a.isComponent, selector = _a.selector, exportAs = _a.exportAs, changeDetection = _a.changeDetection, inputs = _a.inputs, outputs = _a.outputs, hostListeners = _a.hostListeners, hostProperties = _a.hostProperties, hostAttributes = _a.hostAttributes, providers = _a.providers, viewProviders = _a.viewProviders, queries = _a.queries, viewQueries = _a.viewQueries, entryComponents = _a.entryComponents, template = _a.template, componentViewType = _a.componentViewType, rendererType = _a.rendererType, componentFactory = _a.componentFactory;
        this.isHost = !!isHost;
        this.type = type;
        this.isComponent = isComponent;
        this.selector = selector;
        this.exportAs = exportAs;
        this.changeDetection = changeDetection;
        this.inputs = inputs;
        this.outputs = outputs;
        this.hostListeners = hostListeners;
        this.hostProperties = hostProperties;
        this.hostAttributes = hostAttributes;
        this.providers = _normalizeArray(providers);
        this.viewProviders = _normalizeArray(viewProviders);
        this.queries = _normalizeArray(queries);
        this.viewQueries = _normalizeArray(viewQueries);
        this.entryComponents = _normalizeArray(entryComponents);
        this.template = template;
        this.componentViewType = componentViewType;
        this.rendererType = rendererType;
        this.componentFactory = componentFactory;
    }
    /**
     * @param {?} __0
     * @return {?}
     */
    CompileDirectiveMetadata.create = function (_a) {
        var isHost = _a.isHost, type = _a.type, isComponent = _a.isComponent, selector = _a.selector, exportAs = _a.exportAs, changeDetection = _a.changeDetection, inputs = _a.inputs, outputs = _a.outputs, host = _a.host, providers = _a.providers, viewProviders = _a.viewProviders, queries = _a.queries, viewQueries = _a.viewQueries, entryComponents = _a.entryComponents, template = _a.template, componentViewType = _a.componentViewType, rendererType = _a.rendererType, componentFactory = _a.componentFactory;
        var /** @type {?} */ hostListeners = {};
        var /** @type {?} */ hostProperties = {};
        var /** @type {?} */ hostAttributes = {};
        if (host != null) {
            Object.keys(host).forEach(function (key) {
                var /** @type {?} */ value = host[key];
                var /** @type {?} */ matches = key.match(HOST_REG_EXP);
                if (matches === null) {
                    hostAttributes[key] = value;
                }
                else if (matches[1] != null) {
                    hostProperties[matches[1]] = value;
                }
                else if (matches[2] != null) {
                    hostListeners[matches[2]] = value;
                }
            });
        }
        var /** @type {?} */ inputsMap = {};
        if (inputs != null) {
            inputs.forEach(function (bindConfig) {
                // canonical syntax: `dirProp: elProp`
                // if there is no `:`, use dirProp = elProp
                var /** @type {?} */ parts = splitAtColon(bindConfig, [bindConfig, bindConfig]);
                inputsMap[parts[0]] = parts[1];
            });
        }
        var /** @type {?} */ outputsMap = {};
        if (outputs != null) {
            outputs.forEach(function (bindConfig) {
                // canonical syntax: `dirProp: elProp`
                // if there is no `:`, use dirProp = elProp
                var /** @type {?} */ parts = splitAtColon(bindConfig, [bindConfig, bindConfig]);
                outputsMap[parts[0]] = parts[1];
            });
        }
        return new CompileDirectiveMetadata({
            isHost: isHost,
            type: type,
            isComponent: !!isComponent, selector: selector, exportAs: exportAs, changeDetection: changeDetection,
            inputs: inputsMap,
            outputs: outputsMap,
            hostListeners: hostListeners,
            hostProperties: hostProperties,
            hostAttributes: hostAttributes,
            providers: providers,
            viewProviders: viewProviders,
            queries: queries,
            viewQueries: viewQueries,
            entryComponents: entryComponents,
            template: template,
            componentViewType: componentViewType,
            rendererType: rendererType,
            componentFactory: componentFactory,
        });
    };
    /**
     * @return {?}
     */
    CompileDirectiveMetadata.prototype.toSummary = function () {
        return {
            summaryKind: CompileSummaryKind.Directive,
            type: this.type,
            isComponent: this.isComponent,
            selector: this.selector,
            exportAs: this.exportAs,
            inputs: this.inputs,
            outputs: this.outputs,
            hostListeners: this.hostListeners,
            hostProperties: this.hostProperties,
            hostAttributes: this.hostAttributes,
            providers: this.providers,
            viewProviders: this.viewProviders,
            queries: this.queries,
            viewQueries: this.viewQueries,
            entryComponents: this.entryComponents,
            changeDetection: this.changeDetection,
            template: this.template && this.template.toSummary(),
            componentViewType: this.componentViewType,
            rendererType: this.rendererType,
            componentFactory: this.componentFactory
        };
    };
    return CompileDirectiveMetadata;
}());
/**
 * Construct {\@link CompileDirectiveMetadata} from {\@link ComponentTypeMetadata} and a selector.
 * @param {?} hostTypeReference
 * @param {?} compMeta
 * @param {?} hostViewType
 * @return {?}
 */
function createHostComponentMeta(hostTypeReference, compMeta, hostViewType) {
    var /** @type {?} */ template = CssSelector.parse(/** @type {?} */ ((compMeta.selector)))[0].getMatchingElementTemplate();
    return CompileDirectiveMetadata.create({
        isHost: true,
        type: { reference: hostTypeReference, diDeps: [], lifecycleHooks: [] },
        template: new CompileTemplateMetadata({
            encapsulation: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewEncapsulation"].None,
            template: template,
            templateUrl: '',
            styles: [],
            styleUrls: [],
            ngContentSelectors: [],
            animations: [],
            isInline: true,
            externalStylesheets: [],
            interpolation: null
        }),
        exportAs: null,
        changeDetection: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectionStrategy"].Default,
        inputs: [],
        outputs: [],
        host: {},
        isComponent: true,
        selector: '*',
        providers: [],
        viewProviders: [],
        queries: [],
        viewQueries: [],
        componentViewType: hostViewType,
        rendererType: { id: '__Host__', encapsulation: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewEncapsulation"].None, styles: [], data: {} },
        entryComponents: [],
        componentFactory: null
    });
}
var CompilePipeMetadata = (function () {
    /**
     * @param {?} __0
     */
    function CompilePipeMetadata(_a) {
        var type = _a.type, name = _a.name, pure = _a.pure;
        this.type = type;
        this.name = name;
        this.pure = !!pure;
    }
    /**
     * @return {?}
     */
    CompilePipeMetadata.prototype.toSummary = function () {
        return {
            summaryKind: CompileSummaryKind.Pipe,
            type: this.type,
            name: this.name,
            pure: this.pure
        };
    };
    return CompilePipeMetadata;
}());
/**
 * Metadata regarding compilation of a module.
 */
var CompileNgModuleMetadata = (function () {
    /**
     * @param {?} __0
     */
    function CompileNgModuleMetadata(_a) {
        var type = _a.type, providers = _a.providers, declaredDirectives = _a.declaredDirectives, exportedDirectives = _a.exportedDirectives, declaredPipes = _a.declaredPipes, exportedPipes = _a.exportedPipes, entryComponents = _a.entryComponents, bootstrapComponents = _a.bootstrapComponents, importedModules = _a.importedModules, exportedModules = _a.exportedModules, schemas = _a.schemas, transitiveModule = _a.transitiveModule, id = _a.id;
        this.type = type || null;
        this.declaredDirectives = _normalizeArray(declaredDirectives);
        this.exportedDirectives = _normalizeArray(exportedDirectives);
        this.declaredPipes = _normalizeArray(declaredPipes);
        this.exportedPipes = _normalizeArray(exportedPipes);
        this.providers = _normalizeArray(providers);
        this.entryComponents = _normalizeArray(entryComponents);
        this.bootstrapComponents = _normalizeArray(bootstrapComponents);
        this.importedModules = _normalizeArray(importedModules);
        this.exportedModules = _normalizeArray(exportedModules);
        this.schemas = _normalizeArray(schemas);
        this.id = id || null;
        this.transitiveModule = transitiveModule || null;
    }
    /**
     * @return {?}
     */
    CompileNgModuleMetadata.prototype.toSummary = function () {
        var /** @type {?} */ module = ((this.transitiveModule));
        return {
            summaryKind: CompileSummaryKind.NgModule,
            type: this.type,
            entryComponents: module.entryComponents,
            providers: module.providers,
            modules: module.modules,
            exportedDirectives: module.exportedDirectives,
            exportedPipes: module.exportedPipes
        };
    };
    return CompileNgModuleMetadata;
}());
var TransitiveCompileNgModuleMetadata = (function () {
    function TransitiveCompileNgModuleMetadata() {
        this.directivesSet = new Set();
        this.directives = [];
        this.exportedDirectivesSet = new Set();
        this.exportedDirectives = [];
        this.pipesSet = new Set();
        this.pipes = [];
        this.exportedPipesSet = new Set();
        this.exportedPipes = [];
        this.modulesSet = new Set();
        this.modules = [];
        this.entryComponentsSet = new Set();
        this.entryComponents = [];
        this.providers = [];
    }
    /**
     * @param {?} provider
     * @param {?} module
     * @return {?}
     */
    TransitiveCompileNgModuleMetadata.prototype.addProvider = function (provider, module) {
        this.providers.push({ provider: provider, module: module });
    };
    /**
     * @param {?} id
     * @return {?}
     */
    TransitiveCompileNgModuleMetadata.prototype.addDirective = function (id) {
        if (!this.directivesSet.has(id.reference)) {
            this.directivesSet.add(id.reference);
            this.directives.push(id);
        }
    };
    /**
     * @param {?} id
     * @return {?}
     */
    TransitiveCompileNgModuleMetadata.prototype.addExportedDirective = function (id) {
        if (!this.exportedDirectivesSet.has(id.reference)) {
            this.exportedDirectivesSet.add(id.reference);
            this.exportedDirectives.push(id);
        }
    };
    /**
     * @param {?} id
     * @return {?}
     */
    TransitiveCompileNgModuleMetadata.prototype.addPipe = function (id) {
        if (!this.pipesSet.has(id.reference)) {
            this.pipesSet.add(id.reference);
            this.pipes.push(id);
        }
    };
    /**
     * @param {?} id
     * @return {?}
     */
    TransitiveCompileNgModuleMetadata.prototype.addExportedPipe = function (id) {
        if (!this.exportedPipesSet.has(id.reference)) {
            this.exportedPipesSet.add(id.reference);
            this.exportedPipes.push(id);
        }
    };
    /**
     * @param {?} id
     * @return {?}
     */
    TransitiveCompileNgModuleMetadata.prototype.addModule = function (id) {
        if (!this.modulesSet.has(id.reference)) {
            this.modulesSet.add(id.reference);
            this.modules.push(id);
        }
    };
    /**
     * @param {?} ec
     * @return {?}
     */
    TransitiveCompileNgModuleMetadata.prototype.addEntryComponent = function (ec) {
        if (!this.entryComponentsSet.has(ec.componentType)) {
            this.entryComponentsSet.add(ec.componentType);
            this.entryComponents.push(ec);
        }
    };
    return TransitiveCompileNgModuleMetadata;
}());
/**
 * @param {?} obj
 * @return {?}
 */
function _normalizeArray(obj) {
    return obj || [];
}
var ProviderMeta = (function () {
    /**
     * @param {?} token
     * @param {?} __1
     */
    function ProviderMeta(token, _a) {
        var useClass = _a.useClass, useValue = _a.useValue, useExisting = _a.useExisting, useFactory = _a.useFactory, deps = _a.deps, multi = _a.multi;
        this.token = token;
        this.useClass = useClass || null;
        this.useValue = useValue;
        this.useExisting = useExisting;
        this.useFactory = useFactory || null;
        this.dependencies = deps || null;
        this.multi = !!multi;
    }
    return ProviderMeta;
}());
/**
 * @template T
 * @param {?} list
 * @return {?}
 */
function flatten(list) {
    return list.reduce(function (flat, item) {
        var /** @type {?} */ flatItem = Array.isArray(item) ? flatten(item) : item;
        return ((flat)).concat(flatItem);
    }, []);
}
/**
 * @param {?} url
 * @return {?}
 */
function sourceUrl(url) {
    // Note: We need 3 "/" so that ng shows up as a separate domain
    // in the chrome dev tools.
    return url.replace(/(\w+:\/\/[\w:-]+)?(\/+)?/, 'ng:///');
}
/**
 * @param {?} ngModuleType
 * @param {?} compMeta
 * @param {?} templateMeta
 * @return {?}
 */
function templateSourceUrl(ngModuleType, compMeta, templateMeta) {
    var /** @type {?} */ url;
    if (templateMeta.isInline) {
        if (compMeta.type.reference instanceof StaticSymbol) {
            // Note: a .ts file might contain multiple components with inline templates,
            // so we need to give them unique urls, as these will be used for sourcemaps.
            url = compMeta.type.reference.filePath + "." + compMeta.type.reference.name + ".html";
        }
        else {
            url = identifierName(ngModuleType) + "/" + identifierName(compMeta.type) + ".html";
        }
    }
    else {
        url = ((templateMeta.templateUrl));
    }
    // always prepend ng:// to make angular resources easy to find and not clobber
    // user resources.
    return sourceUrl(url);
}
/**
 * @param {?} meta
 * @param {?} id
 * @return {?}
 */
function sharedStylesheetJitUrl(meta, id) {
    var /** @type {?} */ pathParts = ((meta.moduleUrl)).split(/\/\\/g);
    var /** @type {?} */ baseName = pathParts[pathParts.length - 1];
    return sourceUrl("css/" + id + baseName + ".ngstyle.js");
}
/**
 * @param {?} moduleMeta
 * @return {?}
 */
function ngModuleJitUrl(moduleMeta) {
    return sourceUrl(identifierName(moduleMeta.type) + "/module.ngfactory.js");
}
/**
 * @param {?} ngModuleType
 * @param {?} compMeta
 * @return {?}
 */
function templateJitUrl(ngModuleType, compMeta) {
    return sourceUrl(identifierName(ngModuleType) + "/" + identifierName(compMeta.type) + ".ngfactory.js");
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var CompilerConfig = (function () {
    /**
     * @param {?=} __0
     */
    function CompilerConfig(_a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.defaultEncapsulation, defaultEncapsulation = _c === void 0 ? __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewEncapsulation"].Emulated : _c, _d = _b.useJit, useJit = _d === void 0 ? true : _d, missingTranslation = _b.missingTranslation, enableLegacyTemplate = _b.enableLegacyTemplate;
        this.defaultEncapsulation = defaultEncapsulation;
        this.useJit = !!useJit;
        this.missingTranslation = missingTranslation || null;
        this.enableLegacyTemplate = enableLegacyTemplate !== false;
    }
    return CompilerConfig;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var ParserError = (function () {
    /**
     * @param {?} message
     * @param {?} input
     * @param {?} errLocation
     * @param {?=} ctxLocation
     */
    function ParserError(message, input, errLocation, ctxLocation) {
        this.input = input;
        this.errLocation = errLocation;
        this.ctxLocation = ctxLocation;
        this.message = "Parser Error: " + message + " " + errLocation + " [" + input + "] in " + ctxLocation;
    }
    return ParserError;
}());
var ParseSpan = (function () {
    /**
     * @param {?} start
     * @param {?} end
     */
    function ParseSpan(start, end) {
        this.start = start;
        this.end = end;
    }
    return ParseSpan;
}());
var AST = (function () {
    /**
     * @param {?} span
     */
    function AST(span) {
        this.span = span;
    }
    /**
     * @param {?} visitor
     * @param {?=} context
     * @return {?}
     */
    AST.prototype.visit = function (visitor, context) {
        if (context === void 0) { context = null; }
        return null;
    };
    /**
     * @return {?}
     */
    AST.prototype.toString = function () { return 'AST'; };
    return AST;
}());
/**
 * Represents a quoted expression of the form:
 *
 * quote = prefix `:` uninterpretedExpression
 * prefix = identifier
 * uninterpretedExpression = arbitrary string
 *
 * A quoted expression is meant to be pre-processed by an AST transformer that
 * converts it into another AST that no longer contains quoted expressions.
 * It is meant to allow third-party developers to extend Angular template
 * expression language. The `uninterpretedExpression` part of the quote is
 * therefore not interpreted by the Angular's own expression parser.
 */
var Quote = (function (_super) {
    __extends(Quote, _super);
    /**
     * @param {?} span
     * @param {?} prefix
     * @param {?} uninterpretedExpression
     * @param {?} location
     */
    function Quote(span, prefix, uninterpretedExpression, location) {
        var _this = _super.call(this, span) || this;
        _this.prefix = prefix;
        _this.uninterpretedExpression = uninterpretedExpression;
        _this.location = location;
        return _this;
    }
    /**
     * @param {?} visitor
     * @param {?=} context
     * @return {?}
     */
    Quote.prototype.visit = function (visitor, context) {
        if (context === void 0) { context = null; }
        return visitor.visitQuote(this, context);
    };
    /**
     * @return {?}
     */
    Quote.prototype.toString = function () { return 'Quote'; };
    return Quote;
}(AST));
var EmptyExpr = (function (_super) {
    __extends(EmptyExpr, _super);
    function EmptyExpr() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @param {?} visitor
     * @param {?=} context
     * @return {?}
     */
    EmptyExpr.prototype.visit = function (visitor, context) {
        if (context === void 0) { context = null; }
        // do nothing
    };
    return EmptyExpr;
}(AST));
var ImplicitReceiver = (function (_super) {
    __extends(ImplicitReceiver, _super);
    function ImplicitReceiver() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @param {?} visitor
     * @param {?=} context
     * @return {?}
     */
    ImplicitReceiver.prototype.visit = function (visitor, context) {
        if (context === void 0) { context = null; }
        return visitor.visitImplicitReceiver(this, context);
    };
    return ImplicitReceiver;
}(AST));
/**
 * Multiple expressions separated by a semicolon.
 */
var Chain = (function (_super) {
    __extends(Chain, _super);
    /**
     * @param {?} span
     * @param {?} expressions
     */
    function Chain(span, expressions) {
        var _this = _super.call(this, span) || this;
        _this.expressions = expressions;
        return _this;
    }
    /**
     * @param {?} visitor
     * @param {?=} context
     * @return {?}
     */
    Chain.prototype.visit = function (visitor, context) {
        if (context === void 0) { context = null; }
        return visitor.visitChain(this, context);
    };
    return Chain;
}(AST));
var Conditional = (function (_super) {
    __extends(Conditional, _super);
    /**
     * @param {?} span
     * @param {?} condition
     * @param {?} trueExp
     * @param {?} falseExp
     */
    function Conditional(span, condition, trueExp, falseExp) {
        var _this = _super.call(this, span) || this;
        _this.condition = condition;
        _this.trueExp = trueExp;
        _this.falseExp = falseExp;
        return _this;
    }
    /**
     * @param {?} visitor
     * @param {?=} context
     * @return {?}
     */
    Conditional.prototype.visit = function (visitor, context) {
        if (context === void 0) { context = null; }
        return visitor.visitConditional(this, context);
    };
    return Conditional;
}(AST));
var PropertyRead = (function (_super) {
    __extends(PropertyRead, _super);
    /**
     * @param {?} span
     * @param {?} receiver
     * @param {?} name
     */
    function PropertyRead(span, receiver, name) {
        var _this = _super.call(this, span) || this;
        _this.receiver = receiver;
        _this.name = name;
        return _this;
    }
    /**
     * @param {?} visitor
     * @param {?=} context
     * @return {?}
     */
    PropertyRead.prototype.visit = function (visitor, context) {
        if (context === void 0) { context = null; }
        return visitor.visitPropertyRead(this, context);
    };
    return PropertyRead;
}(AST));
var PropertyWrite = (function (_super) {
    __extends(PropertyWrite, _super);
    /**
     * @param {?} span
     * @param {?} receiver
     * @param {?} name
     * @param {?} value
     */
    function PropertyWrite(span, receiver, name, value) {
        var _this = _super.call(this, span) || this;
        _this.receiver = receiver;
        _this.name = name;
        _this.value = value;
        return _this;
    }
    /**
     * @param {?} visitor
     * @param {?=} context
     * @return {?}
     */
    PropertyWrite.prototype.visit = function (visitor, context) {
        if (context === void 0) { context = null; }
        return visitor.visitPropertyWrite(this, context);
    };
    return PropertyWrite;
}(AST));
var SafePropertyRead = (function (_super) {
    __extends(SafePropertyRead, _super);
    /**
     * @param {?} span
     * @param {?} receiver
     * @param {?} name
     */
    function SafePropertyRead(span, receiver, name) {
        var _this = _super.call(this, span) || this;
        _this.receiver = receiver;
        _this.name = name;
        return _this;
    }
    /**
     * @param {?} visitor
     * @param {?=} context
     * @return {?}
     */
    SafePropertyRead.prototype.visit = function (visitor, context) {
        if (context === void 0) { context = null; }
        return visitor.visitSafePropertyRead(this, context);
    };
    return SafePropertyRead;
}(AST));
var KeyedRead = (function (_super) {
    __extends(KeyedRead, _super);
    /**
     * @param {?} span
     * @param {?} obj
     * @param {?} key
     */
    function KeyedRead(span, obj, key) {
        var _this = _super.call(this, span) || this;
        _this.obj = obj;
        _this.key = key;
        return _this;
    }
    /**
     * @param {?} visitor
     * @param {?=} context
     * @return {?}
     */
    KeyedRead.prototype.visit = function (visitor, context) {
        if (context === void 0) { context = null; }
        return visitor.visitKeyedRead(this, context);
    };
    return KeyedRead;
}(AST));
var KeyedWrite = (function (_super) {
    __extends(KeyedWrite, _super);
    /**
     * @param {?} span
     * @param {?} obj
     * @param {?} key
     * @param {?} value
     */
    function KeyedWrite(span, obj, key, value) {
        var _this = _super.call(this, span) || this;
        _this.obj = obj;
        _this.key = key;
        _this.value = value;
        return _this;
    }
    /**
     * @param {?} visitor
     * @param {?=} context
     * @return {?}
     */
    KeyedWrite.prototype.visit = function (visitor, context) {
        if (context === void 0) { context = null; }
        return visitor.visitKeyedWrite(this, context);
    };
    return KeyedWrite;
}(AST));
var BindingPipe = (function (_super) {
    __extends(BindingPipe, _super);
    /**
     * @param {?} span
     * @param {?} exp
     * @param {?} name
     * @param {?} args
     */
    function BindingPipe(span, exp, name, args) {
        var _this = _super.call(this, span) || this;
        _this.exp = exp;
        _this.name = name;
        _this.args = args;
        return _this;
    }
    /**
     * @param {?} visitor
     * @param {?=} context
     * @return {?}
     */
    BindingPipe.prototype.visit = function (visitor, context) {
        if (context === void 0) { context = null; }
        return visitor.visitPipe(this, context);
    };
    return BindingPipe;
}(AST));
var LiteralPrimitive = (function (_super) {
    __extends(LiteralPrimitive, _super);
    /**
     * @param {?} span
     * @param {?} value
     */
    function LiteralPrimitive(span, value) {
        var _this = _super.call(this, span) || this;
        _this.value = value;
        return _this;
    }
    /**
     * @param {?} visitor
     * @param {?=} context
     * @return {?}
     */
    LiteralPrimitive.prototype.visit = function (visitor, context) {
        if (context === void 0) { context = null; }
        return visitor.visitLiteralPrimitive(this, context);
    };
    return LiteralPrimitive;
}(AST));
var LiteralArray = (function (_super) {
    __extends(LiteralArray, _super);
    /**
     * @param {?} span
     * @param {?} expressions
     */
    function LiteralArray(span, expressions) {
        var _this = _super.call(this, span) || this;
        _this.expressions = expressions;
        return _this;
    }
    /**
     * @param {?} visitor
     * @param {?=} context
     * @return {?}
     */
    LiteralArray.prototype.visit = function (visitor, context) {
        if (context === void 0) { context = null; }
        return visitor.visitLiteralArray(this, context);
    };
    return LiteralArray;
}(AST));
var LiteralMap = (function (_super) {
    __extends(LiteralMap, _super);
    /**
     * @param {?} span
     * @param {?} keys
     * @param {?} values
     */
    function LiteralMap(span, keys, values) {
        var _this = _super.call(this, span) || this;
        _this.keys = keys;
        _this.values = values;
        return _this;
    }
    /**
     * @param {?} visitor
     * @param {?=} context
     * @return {?}
     */
    LiteralMap.prototype.visit = function (visitor, context) {
        if (context === void 0) { context = null; }
        return visitor.visitLiteralMap(this, context);
    };
    return LiteralMap;
}(AST));
var Interpolation = (function (_super) {
    __extends(Interpolation, _super);
    /**
     * @param {?} span
     * @param {?} strings
     * @param {?} expressions
     */
    function Interpolation(span, strings, expressions) {
        var _this = _super.call(this, span) || this;
        _this.strings = strings;
        _this.expressions = expressions;
        return _this;
    }
    /**
     * @param {?} visitor
     * @param {?=} context
     * @return {?}
     */
    Interpolation.prototype.visit = function (visitor, context) {
        if (context === void 0) { context = null; }
        return visitor.visitInterpolation(this, context);
    };
    return Interpolation;
}(AST));
var Binary = (function (_super) {
    __extends(Binary, _super);
    /**
     * @param {?} span
     * @param {?} operation
     * @param {?} left
     * @param {?} right
     */
    function Binary(span, operation, left, right) {
        var _this = _super.call(this, span) || this;
        _this.operation = operation;
        _this.left = left;
        _this.right = right;
        return _this;
    }
    /**
     * @param {?} visitor
     * @param {?=} context
     * @return {?}
     */
    Binary.prototype.visit = function (visitor, context) {
        if (context === void 0) { context = null; }
        return visitor.visitBinary(this, context);
    };
    return Binary;
}(AST));
var PrefixNot = (function (_super) {
    __extends(PrefixNot, _super);
    /**
     * @param {?} span
     * @param {?} expression
     */
    function PrefixNot(span, expression) {
        var _this = _super.call(this, span) || this;
        _this.expression = expression;
        return _this;
    }
    /**
     * @param {?} visitor
     * @param {?=} context
     * @return {?}
     */
    PrefixNot.prototype.visit = function (visitor, context) {
        if (context === void 0) { context = null; }
        return visitor.visitPrefixNot(this, context);
    };
    return PrefixNot;
}(AST));
var MethodCall = (function (_super) {
    __extends(MethodCall, _super);
    /**
     * @param {?} span
     * @param {?} receiver
     * @param {?} name
     * @param {?} args
     */
    function MethodCall(span, receiver, name, args) {
        var _this = _super.call(this, span) || this;
        _this.receiver = receiver;
        _this.name = name;
        _this.args = args;
        return _this;
    }
    /**
     * @param {?} visitor
     * @param {?=} context
     * @return {?}
     */
    MethodCall.prototype.visit = function (visitor, context) {
        if (context === void 0) { context = null; }
        return visitor.visitMethodCall(this, context);
    };
    return MethodCall;
}(AST));
var SafeMethodCall = (function (_super) {
    __extends(SafeMethodCall, _super);
    /**
     * @param {?} span
     * @param {?} receiver
     * @param {?} name
     * @param {?} args
     */
    function SafeMethodCall(span, receiver, name, args) {
        var _this = _super.call(this, span) || this;
        _this.receiver = receiver;
        _this.name = name;
        _this.args = args;
        return _this;
    }
    /**
     * @param {?} visitor
     * @param {?=} context
     * @return {?}
     */
    SafeMethodCall.prototype.visit = function (visitor, context) {
        if (context === void 0) { context = null; }
        return visitor.visitSafeMethodCall(this, context);
    };
    return SafeMethodCall;
}(AST));
var FunctionCall = (function (_super) {
    __extends(FunctionCall, _super);
    /**
     * @param {?} span
     * @param {?} target
     * @param {?} args
     */
    function FunctionCall(span, target, args) {
        var _this = _super.call(this, span) || this;
        _this.target = target;
        _this.args = args;
        return _this;
    }
    /**
     * @param {?} visitor
     * @param {?=} context
     * @return {?}
     */
    FunctionCall.prototype.visit = function (visitor, context) {
        if (context === void 0) { context = null; }
        return visitor.visitFunctionCall(this, context);
    };
    return FunctionCall;
}(AST));
var ASTWithSource = (function (_super) {
    __extends(ASTWithSource, _super);
    /**
     * @param {?} ast
     * @param {?} source
     * @param {?} location
     * @param {?} errors
     */
    function ASTWithSource(ast, source, location, errors) {
        var _this = _super.call(this, new ParseSpan(0, source == null ? 0 : source.length)) || this;
        _this.ast = ast;
        _this.source = source;
        _this.location = location;
        _this.errors = errors;
        return _this;
    }
    /**
     * @param {?} visitor
     * @param {?=} context
     * @return {?}
     */
    ASTWithSource.prototype.visit = function (visitor, context) {
        if (context === void 0) { context = null; }
        return this.ast.visit(visitor, context);
    };
    /**
     * @return {?}
     */
    ASTWithSource.prototype.toString = function () { return this.source + " in " + this.location; };
    return ASTWithSource;
}(AST));
var TemplateBinding = (function () {
    /**
     * @param {?} span
     * @param {?} key
     * @param {?} keyIsVar
     * @param {?} name
     * @param {?} expression
     */
    function TemplateBinding(span, key, keyIsVar, name, expression) {
        this.span = span;
        this.key = key;
        this.keyIsVar = keyIsVar;
        this.name = name;
        this.expression = expression;
    }
    return TemplateBinding;
}());
var RecursiveAstVisitor = (function () {
    function RecursiveAstVisitor() {
    }
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    RecursiveAstVisitor.prototype.visitBinary = function (ast, context) {
        ast.left.visit(this);
        ast.right.visit(this);
        return null;
    };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    RecursiveAstVisitor.prototype.visitChain = function (ast, context) { return this.visitAll(ast.expressions, context); };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    RecursiveAstVisitor.prototype.visitConditional = function (ast, context) {
        ast.condition.visit(this);
        ast.trueExp.visit(this);
        ast.falseExp.visit(this);
        return null;
    };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    RecursiveAstVisitor.prototype.visitPipe = function (ast, context) {
        ast.exp.visit(this);
        this.visitAll(ast.args, context);
        return null;
    };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    RecursiveAstVisitor.prototype.visitFunctionCall = function (ast, context) {
        ((ast.target)).visit(this);
        this.visitAll(ast.args, context);
        return null;
    };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    RecursiveAstVisitor.prototype.visitImplicitReceiver = function (ast, context) { return null; };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    RecursiveAstVisitor.prototype.visitInterpolation = function (ast, context) {
        return this.visitAll(ast.expressions, context);
    };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    RecursiveAstVisitor.prototype.visitKeyedRead = function (ast, context) {
        ast.obj.visit(this);
        ast.key.visit(this);
        return null;
    };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    RecursiveAstVisitor.prototype.visitKeyedWrite = function (ast, context) {
        ast.obj.visit(this);
        ast.key.visit(this);
        ast.value.visit(this);
        return null;
    };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    RecursiveAstVisitor.prototype.visitLiteralArray = function (ast, context) {
        return this.visitAll(ast.expressions, context);
    };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    RecursiveAstVisitor.prototype.visitLiteralMap = function (ast, context) { return this.visitAll(ast.values, context); };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    RecursiveAstVisitor.prototype.visitLiteralPrimitive = function (ast, context) { return null; };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    RecursiveAstVisitor.prototype.visitMethodCall = function (ast, context) {
        ast.receiver.visit(this);
        return this.visitAll(ast.args, context);
    };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    RecursiveAstVisitor.prototype.visitPrefixNot = function (ast, context) {
        ast.expression.visit(this);
        return null;
    };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    RecursiveAstVisitor.prototype.visitPropertyRead = function (ast, context) {
        ast.receiver.visit(this);
        return null;
    };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    RecursiveAstVisitor.prototype.visitPropertyWrite = function (ast, context) {
        ast.receiver.visit(this);
        ast.value.visit(this);
        return null;
    };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    RecursiveAstVisitor.prototype.visitSafePropertyRead = function (ast, context) {
        ast.receiver.visit(this);
        return null;
    };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    RecursiveAstVisitor.prototype.visitSafeMethodCall = function (ast, context) {
        ast.receiver.visit(this);
        return this.visitAll(ast.args, context);
    };
    /**
     * @param {?} asts
     * @param {?} context
     * @return {?}
     */
    RecursiveAstVisitor.prototype.visitAll = function (asts, context) {
        var _this = this;
        asts.forEach(function (ast) { return ast.visit(_this, context); });
        return null;
    };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    RecursiveAstVisitor.prototype.visitQuote = function (ast, context) { return null; };
    return RecursiveAstVisitor;
}());
var AstTransformer = (function () {
    function AstTransformer() {
    }
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    AstTransformer.prototype.visitImplicitReceiver = function (ast, context) { return ast; };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    AstTransformer.prototype.visitInterpolation = function (ast, context) {
        return new Interpolation(ast.span, ast.strings, this.visitAll(ast.expressions));
    };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    AstTransformer.prototype.visitLiteralPrimitive = function (ast, context) {
        return new LiteralPrimitive(ast.span, ast.value);
    };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    AstTransformer.prototype.visitPropertyRead = function (ast, context) {
        return new PropertyRead(ast.span, ast.receiver.visit(this), ast.name);
    };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    AstTransformer.prototype.visitPropertyWrite = function (ast, context) {
        return new PropertyWrite(ast.span, ast.receiver.visit(this), ast.name, ast.value.visit(this));
    };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    AstTransformer.prototype.visitSafePropertyRead = function (ast, context) {
        return new SafePropertyRead(ast.span, ast.receiver.visit(this), ast.name);
    };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    AstTransformer.prototype.visitMethodCall = function (ast, context) {
        return new MethodCall(ast.span, ast.receiver.visit(this), ast.name, this.visitAll(ast.args));
    };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    AstTransformer.prototype.visitSafeMethodCall = function (ast, context) {
        return new SafeMethodCall(ast.span, ast.receiver.visit(this), ast.name, this.visitAll(ast.args));
    };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    AstTransformer.prototype.visitFunctionCall = function (ast, context) {
        return new FunctionCall(ast.span, /** @type {?} */ ((ast.target)).visit(this), this.visitAll(ast.args));
    };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    AstTransformer.prototype.visitLiteralArray = function (ast, context) {
        return new LiteralArray(ast.span, this.visitAll(ast.expressions));
    };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    AstTransformer.prototype.visitLiteralMap = function (ast, context) {
        return new LiteralMap(ast.span, ast.keys, this.visitAll(ast.values));
    };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    AstTransformer.prototype.visitBinary = function (ast, context) {
        return new Binary(ast.span, ast.operation, ast.left.visit(this), ast.right.visit(this));
    };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    AstTransformer.prototype.visitPrefixNot = function (ast, context) {
        return new PrefixNot(ast.span, ast.expression.visit(this));
    };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    AstTransformer.prototype.visitConditional = function (ast, context) {
        return new Conditional(ast.span, ast.condition.visit(this), ast.trueExp.visit(this), ast.falseExp.visit(this));
    };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    AstTransformer.prototype.visitPipe = function (ast, context) {
        return new BindingPipe(ast.span, ast.exp.visit(this), ast.name, this.visitAll(ast.args));
    };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    AstTransformer.prototype.visitKeyedRead = function (ast, context) {
        return new KeyedRead(ast.span, ast.obj.visit(this), ast.key.visit(this));
    };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    AstTransformer.prototype.visitKeyedWrite = function (ast, context) {
        return new KeyedWrite(ast.span, ast.obj.visit(this), ast.key.visit(this), ast.value.visit(this));
    };
    /**
     * @param {?} asts
     * @return {?}
     */
    AstTransformer.prototype.visitAll = function (asts) {
        var /** @type {?} */ res = new Array(asts.length);
        for (var /** @type {?} */ i = 0; i < asts.length; ++i) {
            res[i] = asts[i].visit(this);
        }
        return res;
    };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    AstTransformer.prototype.visitChain = function (ast, context) {
        return new Chain(ast.span, this.visitAll(ast.expressions));
    };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    AstTransformer.prototype.visitQuote = function (ast, context) {
        return new Quote(ast.span, ast.prefix, ast.uninterpretedExpression, ast.location);
    };
    return AstTransformer;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var $EOF = 0;
var $TAB = 9;
var $LF = 10;
var $VTAB = 11;
var $FF = 12;
var $CR = 13;
var $SPACE = 32;
var $BANG = 33;
var $DQ = 34;
var $HASH = 35;
var $$ = 36;
var $PERCENT = 37;
var $AMPERSAND = 38;
var $SQ = 39;
var $LPAREN = 40;
var $RPAREN = 41;
var $STAR = 42;
var $PLUS = 43;
var $COMMA = 44;
var $MINUS = 45;
var $PERIOD = 46;
var $SLASH = 47;
var $COLON = 58;
var $SEMICOLON = 59;
var $LT = 60;
var $EQ = 61;
var $GT = 62;
var $QUESTION = 63;
var $0 = 48;
var $9 = 57;
var $A = 65;
var $E = 69;
var $F = 70;
var $X = 88;
var $Z = 90;
var $LBRACKET = 91;
var $BACKSLASH = 92;
var $RBRACKET = 93;
var $CARET = 94;
var $_ = 95;
var $a = 97;
var $e = 101;
var $f = 102;
var $n = 110;
var $r = 114;
var $t = 116;
var $u = 117;
var $v = 118;
var $x = 120;
var $z = 122;
var $LBRACE = 123;
var $BAR = 124;
var $RBRACE = 125;
var $NBSP = 160;
var $BT = 96;
/**
 * @param {?} code
 * @return {?}
 */
function isWhitespace(code) {
    return (code >= $TAB && code <= $SPACE) || (code == $NBSP);
}
/**
 * @param {?} code
 * @return {?}
 */
function isDigit(code) {
    return $0 <= code && code <= $9;
}
/**
 * @param {?} code
 * @return {?}
 */
function isAsciiLetter(code) {
    return code >= $a && code <= $z || code >= $A && code <= $Z;
}
/**
 * @param {?} code
 * @return {?}
 */
function isAsciiHexDigit(code) {
    return code >= $a && code <= $f || code >= $A && code <= $F || isDigit(code);
}
/**
 * A replacement for \@Injectable to be used in the compiler, so that
 * we don't try to evaluate the metadata in the compiler during AoT.
 * This decorator is enough to make the compiler work with the ReflectiveInjector though.
 * \@Annotation
 * @return {?}
 */
function CompilerInjectable() {
    return function (x) { return x; };
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @param {?} identifier
 * @param {?} value
 * @return {?}
 */
function assertArrayOfStrings(identifier, value) {
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["isDevMode"])() || value == null) {
        return;
    }
    if (!Array.isArray(value)) {
        throw new Error("Expected '" + identifier + "' to be an array of strings.");
    }
    for (var /** @type {?} */ i = 0; i < value.length; i += 1) {
        if (typeof value[i] !== 'string') {
            throw new Error("Expected '" + identifier + "' to be an array of strings.");
        }
    }
}
var INTERPOLATION_BLACKLIST_REGEXPS = [
    /^\s*$/,
    /[<>]/,
    /^[{}]$/,
    /&(#|[a-z])/i,
    /^\/\//,
];
/**
 * @param {?} identifier
 * @param {?} value
 * @return {?}
 */
function assertInterpolationSymbols(identifier, value) {
    if (value != null && !(Array.isArray(value) && value.length == 2)) {
        throw new Error("Expected '" + identifier + "' to be an array, [start, end].");
    }
    else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["isDevMode"])() && value != null) {
        var /** @type {?} */ start_1 = (value[0]);
        var /** @type {?} */ end_1 = (value[1]);
        // black list checking
        INTERPOLATION_BLACKLIST_REGEXPS.forEach(function (regexp) {
            if (regexp.test(start_1) || regexp.test(end_1)) {
                throw new Error("['" + start_1 + "', '" + end_1 + "'] contains unusable interpolation symbol.");
            }
        });
    }
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var InterpolationConfig = (function () {
    /**
     * @param {?} start
     * @param {?} end
     */
    function InterpolationConfig(start, end) {
        this.start = start;
        this.end = end;
    }
    /**
     * @param {?} markers
     * @return {?}
     */
    InterpolationConfig.fromArray = function (markers) {
        if (!markers) {
            return DEFAULT_INTERPOLATION_CONFIG;
        }
        assertInterpolationSymbols('interpolation', markers);
        return new InterpolationConfig(markers[0], markers[1]);
    };
    ;
    return InterpolationConfig;
}());
var DEFAULT_INTERPOLATION_CONFIG = new InterpolationConfig('{{', '}}');
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var TokenType = {};
TokenType.Character = 0;
TokenType.Identifier = 1;
TokenType.Keyword = 2;
TokenType.String = 3;
TokenType.Operator = 4;
TokenType.Number = 5;
TokenType.Error = 6;
TokenType[TokenType.Character] = "Character";
TokenType[TokenType.Identifier] = "Identifier";
TokenType[TokenType.Keyword] = "Keyword";
TokenType[TokenType.String] = "String";
TokenType[TokenType.Operator] = "Operator";
TokenType[TokenType.Number] = "Number";
TokenType[TokenType.Error] = "Error";
var KEYWORDS = ['var', 'let', 'as', 'null', 'undefined', 'true', 'false', 'if', 'else', 'this'];
var Lexer = (function () {
    function Lexer() {
    }
    /**
     * @param {?} text
     * @return {?}
     */
    Lexer.prototype.tokenize = function (text) {
        var /** @type {?} */ scanner = new _Scanner(text);
        var /** @type {?} */ tokens = [];
        var /** @type {?} */ token = scanner.scanToken();
        while (token != null) {
            tokens.push(token);
            token = scanner.scanToken();
        }
        return tokens;
    };
    return Lexer;
}());
Lexer.decorators = [
    { type: CompilerInjectable },
];
/**
 * @nocollapse
 */
Lexer.ctorParameters = function () { return []; };
var Token = (function () {
    /**
     * @param {?} index
     * @param {?} type
     * @param {?} numValue
     * @param {?} strValue
     */
    function Token(index, type, numValue, strValue) {
        this.index = index;
        this.type = type;
        this.numValue = numValue;
        this.strValue = strValue;
    }
    /**
     * @param {?} code
     * @return {?}
     */
    Token.prototype.isCharacter = function (code) {
        return this.type == TokenType.Character && this.numValue == code;
    };
    /**
     * @return {?}
     */
    Token.prototype.isNumber = function () { return this.type == TokenType.Number; };
    /**
     * @return {?}
     */
    Token.prototype.isString = function () { return this.type == TokenType.String; };
    /**
     * @param {?} operater
     * @return {?}
     */
    Token.prototype.isOperator = function (operater) {
        return this.type == TokenType.Operator && this.strValue == operater;
    };
    /**
     * @return {?}
     */
    Token.prototype.isIdentifier = function () { return this.type == TokenType.Identifier; };
    /**
     * @return {?}
     */
    Token.prototype.isKeyword = function () { return this.type == TokenType.Keyword; };
    /**
     * @return {?}
     */
    Token.prototype.isKeywordLet = function () { return this.type == TokenType.Keyword && this.strValue == 'let'; };
    /**
     * @return {?}
     */
    Token.prototype.isKeywordAs = function () { return this.type == TokenType.Keyword && this.strValue == 'as'; };
    /**
     * @return {?}
     */
    Token.prototype.isKeywordNull = function () { return this.type == TokenType.Keyword && this.strValue == 'null'; };
    /**
     * @return {?}
     */
    Token.prototype.isKeywordUndefined = function () {
        return this.type == TokenType.Keyword && this.strValue == 'undefined';
    };
    /**
     * @return {?}
     */
    Token.prototype.isKeywordTrue = function () { return this.type == TokenType.Keyword && this.strValue == 'true'; };
    /**
     * @return {?}
     */
    Token.prototype.isKeywordFalse = function () { return this.type == TokenType.Keyword && this.strValue == 'false'; };
    /**
     * @return {?}
     */
    Token.prototype.isKeywordThis = function () { return this.type == TokenType.Keyword && this.strValue == 'this'; };
    /**
     * @return {?}
     */
    Token.prototype.isError = function () { return this.type == TokenType.Error; };
    /**
     * @return {?}
     */
    Token.prototype.toNumber = function () { return this.type == TokenType.Number ? this.numValue : -1; };
    /**
     * @return {?}
     */
    Token.prototype.toString = function () {
        switch (this.type) {
            case TokenType.Character:
            case TokenType.Identifier:
            case TokenType.Keyword:
            case TokenType.Operator:
            case TokenType.String:
            case TokenType.Error:
                return this.strValue;
            case TokenType.Number:
                return this.numValue.toString();
            default:
                return null;
        }
    };
    return Token;
}());
/**
 * @param {?} index
 * @param {?} code
 * @return {?}
 */
function newCharacterToken(index, code) {
    return new Token(index, TokenType.Character, code, String.fromCharCode(code));
}
/**
 * @param {?} index
 * @param {?} text
 * @return {?}
 */
function newIdentifierToken(index, text) {
    return new Token(index, TokenType.Identifier, 0, text);
}
/**
 * @param {?} index
 * @param {?} text
 * @return {?}
 */
function newKeywordToken(index, text) {
    return new Token(index, TokenType.Keyword, 0, text);
}
/**
 * @param {?} index
 * @param {?} text
 * @return {?}
 */
function newOperatorToken(index, text) {
    return new Token(index, TokenType.Operator, 0, text);
}
/**
 * @param {?} index
 * @param {?} text
 * @return {?}
 */
function newStringToken(index, text) {
    return new Token(index, TokenType.String, 0, text);
}
/**
 * @param {?} index
 * @param {?} n
 * @return {?}
 */
function newNumberToken(index, n) {
    return new Token(index, TokenType.Number, n, '');
}
/**
 * @param {?} index
 * @param {?} message
 * @return {?}
 */
function newErrorToken(index, message) {
    return new Token(index, TokenType.Error, 0, message);
}
var EOF = new Token(-1, TokenType.Character, 0, '');
var _Scanner = (function () {
    /**
     * @param {?} input
     */
    function _Scanner(input) {
        this.input = input;
        this.peek = 0;
        this.index = -1;
        this.length = input.length;
        this.advance();
    }
    /**
     * @return {?}
     */
    _Scanner.prototype.advance = function () {
        this.peek = ++this.index >= this.length ? $EOF : this.input.charCodeAt(this.index);
    };
    /**
     * @return {?}
     */
    _Scanner.prototype.scanToken = function () {
        var /** @type {?} */ input = this.input, /** @type {?} */ length = this.length;
        var /** @type {?} */ peek = this.peek, /** @type {?} */ index = this.index;
        // Skip whitespace.
        while (peek <= $SPACE) {
            if (++index >= length) {
                peek = $EOF;
                break;
            }
            else {
                peek = input.charCodeAt(index);
            }
        }
        this.peek = peek;
        this.index = index;
        if (index >= length) {
            return null;
        }
        // Handle identifiers and numbers.
        if (isIdentifierStart(peek))
            return this.scanIdentifier();
        if (isDigit(peek))
            return this.scanNumber(index);
        var /** @type {?} */ start = index;
        switch (peek) {
            case $PERIOD:
                this.advance();
                return isDigit(this.peek) ? this.scanNumber(start) :
                    newCharacterToken(start, $PERIOD);
            case $LPAREN:
            case $RPAREN:
            case $LBRACE:
            case $RBRACE:
            case $LBRACKET:
            case $RBRACKET:
            case $COMMA:
            case $COLON:
            case $SEMICOLON:
                return this.scanCharacter(start, peek);
            case $SQ:
            case $DQ:
                return this.scanString();
            case $HASH:
            case $PLUS:
            case $MINUS:
            case $STAR:
            case $SLASH:
            case $PERCENT:
            case $CARET:
                return this.scanOperator(start, String.fromCharCode(peek));
            case $QUESTION:
                return this.scanComplexOperator(start, '?', $PERIOD, '.');
            case $LT:
            case $GT:
                return this.scanComplexOperator(start, String.fromCharCode(peek), $EQ, '=');
            case $BANG:
            case $EQ:
                return this.scanComplexOperator(start, String.fromCharCode(peek), $EQ, '=', $EQ, '=');
            case $AMPERSAND:
                return this.scanComplexOperator(start, '&', $AMPERSAND, '&');
            case $BAR:
                return this.scanComplexOperator(start, '|', $BAR, '|');
            case $NBSP:
                while (isWhitespace(this.peek))
                    this.advance();
                return this.scanToken();
        }
        this.advance();
        return this.error("Unexpected character [" + String.fromCharCode(peek) + "]", 0);
    };
    /**
     * @param {?} start
     * @param {?} code
     * @return {?}
     */
    _Scanner.prototype.scanCharacter = function (start, code) {
        this.advance();
        return newCharacterToken(start, code);
    };
    /**
     * @param {?} start
     * @param {?} str
     * @return {?}
     */
    _Scanner.prototype.scanOperator = function (start, str) {
        this.advance();
        return newOperatorToken(start, str);
    };
    /**
     * Tokenize a 2/3 char long operator
     *
     * @param {?} start start index in the expression
     * @param {?} one first symbol (always part of the operator)
     * @param {?} twoCode code point for the second symbol
     * @param {?} two second symbol (part of the operator when the second code point matches)
     * @param {?=} threeCode code point for the third symbol
     * @param {?=} three third symbol (part of the operator when provided and matches source expression)
     * @return {?}
     */
    _Scanner.prototype.scanComplexOperator = function (start, one, twoCode, two, threeCode, three) {
        this.advance();
        var /** @type {?} */ str = one;
        if (this.peek == twoCode) {
            this.advance();
            str += two;
        }
        if (threeCode != null && this.peek == threeCode) {
            this.advance();
            str += three;
        }
        return newOperatorToken(start, str);
    };
    /**
     * @return {?}
     */
    _Scanner.prototype.scanIdentifier = function () {
        var /** @type {?} */ start = this.index;
        this.advance();
        while (isIdentifierPart(this.peek))
            this.advance();
        var /** @type {?} */ str = this.input.substring(start, this.index);
        return KEYWORDS.indexOf(str) > -1 ? newKeywordToken(start, str) :
            newIdentifierToken(start, str);
    };
    /**
     * @param {?} start
     * @return {?}
     */
    _Scanner.prototype.scanNumber = function (start) {
        var /** @type {?} */ simple = (this.index === start);
        this.advance(); // Skip initial digit.
        while (true) {
            if (isDigit(this.peek)) {
            }
            else if (this.peek == $PERIOD) {
                simple = false;
            }
            else if (isExponentStart(this.peek)) {
                this.advance();
                if (isExponentSign(this.peek))
                    this.advance();
                if (!isDigit(this.peek))
                    return this.error('Invalid exponent', -1);
                simple = false;
            }
            else {
                break;
            }
            this.advance();
        }
        var /** @type {?} */ str = this.input.substring(start, this.index);
        var /** @type {?} */ value = simple ? parseIntAutoRadix(str) : parseFloat(str);
        return newNumberToken(start, value);
    };
    /**
     * @return {?}
     */
    _Scanner.prototype.scanString = function () {
        var /** @type {?} */ start = this.index;
        var /** @type {?} */ quote = this.peek;
        this.advance(); // Skip initial quote.
        var /** @type {?} */ buffer = '';
        var /** @type {?} */ marker = this.index;
        var /** @type {?} */ input = this.input;
        while (this.peek != quote) {
            if (this.peek == $BACKSLASH) {
                buffer += input.substring(marker, this.index);
                this.advance();
                var /** @type {?} */ unescapedCode = void 0;
                // Workaround for TS2.1-introduced type strictness
                this.peek = this.peek;
                if (this.peek == $u) {
                    // 4 character hex code for unicode character.
                    var /** @type {?} */ hex = input.substring(this.index + 1, this.index + 5);
                    if (/^[0-9a-f]+$/i.test(hex)) {
                        unescapedCode = parseInt(hex, 16);
                    }
                    else {
                        return this.error("Invalid unicode escape [\\u" + hex + "]", 0);
                    }
                    for (var /** @type {?} */ i = 0; i < 5; i++) {
                        this.advance();
                    }
                }
                else {
                    unescapedCode = unescape(this.peek);
                    this.advance();
                }
                buffer += String.fromCharCode(unescapedCode);
                marker = this.index;
            }
            else if (this.peek == $EOF) {
                return this.error('Unterminated quote', 0);
            }
            else {
                this.advance();
            }
        }
        var /** @type {?} */ last = input.substring(marker, this.index);
        this.advance(); // Skip terminating quote.
        return newStringToken(start, buffer + last);
    };
    /**
     * @param {?} message
     * @param {?} offset
     * @return {?}
     */
    _Scanner.prototype.error = function (message, offset) {
        var /** @type {?} */ position = this.index + offset;
        return newErrorToken(position, "Lexer Error: " + message + " at column " + position + " in expression [" + this.input + "]");
    };
    return _Scanner;
}());
/**
 * @param {?} code
 * @return {?}
 */
function isIdentifierStart(code) {
    return ($a <= code && code <= $z) || ($A <= code && code <= $Z) ||
        (code == $_) || (code == $$);
}
/**
 * @param {?} input
 * @return {?}
 */
function isIdentifier(input) {
    if (input.length == 0)
        return false;
    var /** @type {?} */ scanner = new _Scanner(input);
    if (!isIdentifierStart(scanner.peek))
        return false;
    scanner.advance();
    while (scanner.peek !== $EOF) {
        if (!isIdentifierPart(scanner.peek))
            return false;
        scanner.advance();
    }
    return true;
}
/**
 * @param {?} code
 * @return {?}
 */
function isIdentifierPart(code) {
    return isAsciiLetter(code) || isDigit(code) || (code == $_) ||
        (code == $$);
}
/**
 * @param {?} code
 * @return {?}
 */
function isExponentStart(code) {
    return code == $e || code == $E;
}
/**
 * @param {?} code
 * @return {?}
 */
function isExponentSign(code) {
    return code == $MINUS || code == $PLUS;
}
/**
 * @param {?} code
 * @return {?}
 */
function isQuote(code) {
    return code === $SQ || code === $DQ || code === $BT;
}
/**
 * @param {?} code
 * @return {?}
 */
function unescape(code) {
    switch (code) {
        case $n:
            return $LF;
        case $f:
            return $FF;
        case $r:
            return $CR;
        case $t:
            return $TAB;
        case $v:
            return $VTAB;
        default:
            return code;
    }
}
/**
 * @param {?} text
 * @return {?}
 */
function parseIntAutoRadix(text) {
    var /** @type {?} */ result = parseInt(text);
    if (isNaN(result)) {
        throw new Error('Invalid integer literal when parsing ' + text);
    }
    return result;
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var SplitInterpolation = (function () {
    /**
     * @param {?} strings
     * @param {?} expressions
     * @param {?} offsets
     */
    function SplitInterpolation(strings, expressions, offsets) {
        this.strings = strings;
        this.expressions = expressions;
        this.offsets = offsets;
    }
    return SplitInterpolation;
}());
var TemplateBindingParseResult = (function () {
    /**
     * @param {?} templateBindings
     * @param {?} warnings
     * @param {?} errors
     */
    function TemplateBindingParseResult(templateBindings, warnings, errors) {
        this.templateBindings = templateBindings;
        this.warnings = warnings;
        this.errors = errors;
    }
    return TemplateBindingParseResult;
}());
/**
 * @param {?} config
 * @return {?}
 */
function _createInterpolateRegExp(config) {
    var /** @type {?} */ pattern = escapeRegExp(config.start) + '([\\s\\S]*?)' + escapeRegExp(config.end);
    return new RegExp(pattern, 'g');
}
var Parser = (function () {
    /**
     * @param {?} _lexer
     */
    function Parser(_lexer) {
        this._lexer = _lexer;
        this.errors = [];
    }
    /**
     * @param {?} input
     * @param {?} location
     * @param {?=} interpolationConfig
     * @return {?}
     */
    Parser.prototype.parseAction = function (input, location, interpolationConfig) {
        if (interpolationConfig === void 0) { interpolationConfig = DEFAULT_INTERPOLATION_CONFIG; }
        this._checkNoInterpolation(input, location, interpolationConfig);
        var /** @type {?} */ sourceToLex = this._stripComments(input);
        var /** @type {?} */ tokens = this._lexer.tokenize(this._stripComments(input));
        var /** @type {?} */ ast = new _ParseAST(input, location, tokens, sourceToLex.length, true, this.errors, input.length - sourceToLex.length)
            .parseChain();
        return new ASTWithSource(ast, input, location, this.errors);
    };
    /**
     * @param {?} input
     * @param {?} location
     * @param {?=} interpolationConfig
     * @return {?}
     */
    Parser.prototype.parseBinding = function (input, location, interpolationConfig) {
        if (interpolationConfig === void 0) { interpolationConfig = DEFAULT_INTERPOLATION_CONFIG; }
        var /** @type {?} */ ast = this._parseBindingAst(input, location, interpolationConfig);
        return new ASTWithSource(ast, input, location, this.errors);
    };
    /**
     * @param {?} input
     * @param {?} location
     * @param {?=} interpolationConfig
     * @return {?}
     */
    Parser.prototype.parseSimpleBinding = function (input, location, interpolationConfig) {
        if (interpolationConfig === void 0) { interpolationConfig = DEFAULT_INTERPOLATION_CONFIG; }
        var /** @type {?} */ ast = this._parseBindingAst(input, location, interpolationConfig);
        var /** @type {?} */ errors = SimpleExpressionChecker.check(ast);
        if (errors.length > 0) {
            this._reportError("Host binding expression cannot contain " + errors.join(' '), input, location);
        }
        return new ASTWithSource(ast, input, location, this.errors);
    };
    /**
     * @param {?} message
     * @param {?} input
     * @param {?} errLocation
     * @param {?=} ctxLocation
     * @return {?}
     */
    Parser.prototype._reportError = function (message, input, errLocation, ctxLocation) {
        this.errors.push(new ParserError(message, input, errLocation, ctxLocation));
    };
    /**
     * @param {?} input
     * @param {?} location
     * @param {?} interpolationConfig
     * @return {?}
     */
    Parser.prototype._parseBindingAst = function (input, location, interpolationConfig) {
        // Quotes expressions use 3rd-party expression language. We don't want to use
        // our lexer or parser for that, so we check for that ahead of time.
        var /** @type {?} */ quote = this._parseQuote(input, location);
        if (quote != null) {
            return quote;
        }
        this._checkNoInterpolation(input, location, interpolationConfig);
        var /** @type {?} */ sourceToLex = this._stripComments(input);
        var /** @type {?} */ tokens = this._lexer.tokenize(sourceToLex);
        return new _ParseAST(input, location, tokens, sourceToLex.length, false, this.errors, input.length - sourceToLex.length)
            .parseChain();
    };
    /**
     * @param {?} input
     * @param {?} location
     * @return {?}
     */
    Parser.prototype._parseQuote = function (input, location) {
        if (input == null)
            return null;
        var /** @type {?} */ prefixSeparatorIndex = input.indexOf(':');
        if (prefixSeparatorIndex == -1)
            return null;
        var /** @type {?} */ prefix = input.substring(0, prefixSeparatorIndex).trim();
        if (!isIdentifier(prefix))
            return null;
        var /** @type {?} */ uninterpretedExpression = input.substring(prefixSeparatorIndex + 1);
        return new Quote(new ParseSpan(0, input.length), prefix, uninterpretedExpression, location);
    };
    /**
     * @param {?} prefixToken
     * @param {?} input
     * @param {?} location
     * @return {?}
     */
    Parser.prototype.parseTemplateBindings = function (prefixToken, input, location) {
        var /** @type {?} */ tokens = this._lexer.tokenize(input);
        if (prefixToken) {
            // Prefix the tokens with the tokens from prefixToken but have them take no space (0 index).
            var /** @type {?} */ prefixTokens = this._lexer.tokenize(prefixToken).map(function (t) {
                t.index = 0;
                return t;
            });
            tokens.unshift.apply(tokens, prefixTokens);
        }
        return new _ParseAST(input, location, tokens, input.length, false, this.errors, 0)
            .parseTemplateBindings();
    };
    /**
     * @param {?} input
     * @param {?} location
     * @param {?=} interpolationConfig
     * @return {?}
     */
    Parser.prototype.parseInterpolation = function (input, location, interpolationConfig) {
        if (interpolationConfig === void 0) { interpolationConfig = DEFAULT_INTERPOLATION_CONFIG; }
        var /** @type {?} */ split = this.splitInterpolation(input, location, interpolationConfig);
        if (split == null)
            return null;
        var /** @type {?} */ expressions = [];
        for (var /** @type {?} */ i = 0; i < split.expressions.length; ++i) {
            var /** @type {?} */ expressionText = split.expressions[i];
            var /** @type {?} */ sourceToLex = this._stripComments(expressionText);
            var /** @type {?} */ tokens = this._lexer.tokenize(this._stripComments(split.expressions[i]));
            var /** @type {?} */ ast = new _ParseAST(input, location, tokens, sourceToLex.length, false, this.errors, split.offsets[i] + (expressionText.length - sourceToLex.length))
                .parseChain();
            expressions.push(ast);
        }
        return new ASTWithSource(new Interpolation(new ParseSpan(0, input == null ? 0 : input.length), split.strings, expressions), input, location, this.errors);
    };
    /**
     * @param {?} input
     * @param {?} location
     * @param {?=} interpolationConfig
     * @return {?}
     */
    Parser.prototype.splitInterpolation = function (input, location, interpolationConfig) {
        if (interpolationConfig === void 0) { interpolationConfig = DEFAULT_INTERPOLATION_CONFIG; }
        var /** @type {?} */ regexp = _createInterpolateRegExp(interpolationConfig);
        var /** @type {?} */ parts = input.split(regexp);
        if (parts.length <= 1) {
            return null;
        }
        var /** @type {?} */ strings = [];
        var /** @type {?} */ expressions = [];
        var /** @type {?} */ offsets = [];
        var /** @type {?} */ offset = 0;
        for (var /** @type {?} */ i = 0; i < parts.length; i++) {
            var /** @type {?} */ part = parts[i];
            if (i % 2 === 0) {
                // fixed string
                strings.push(part);
                offset += part.length;
            }
            else if (part.trim().length > 0) {
                offset += interpolationConfig.start.length;
                expressions.push(part);
                offsets.push(offset);
                offset += part.length + interpolationConfig.end.length;
            }
            else {
                this._reportError('Blank expressions are not allowed in interpolated strings', input, "at column " + this._findInterpolationErrorColumn(parts, i, interpolationConfig) + " in", location);
                expressions.push('$implict');
                offsets.push(offset);
            }
        }
        return new SplitInterpolation(strings, expressions, offsets);
    };
    /**
     * @param {?} input
     * @param {?} location
     * @return {?}
     */
    Parser.prototype.wrapLiteralPrimitive = function (input, location) {
        return new ASTWithSource(new LiteralPrimitive(new ParseSpan(0, input == null ? 0 : input.length), input), input, location, this.errors);
    };
    /**
     * @param {?} input
     * @return {?}
     */
    Parser.prototype._stripComments = function (input) {
        var /** @type {?} */ i = this._commentStart(input);
        return i != null ? input.substring(0, i).trim() : input;
    };
    /**
     * @param {?} input
     * @return {?}
     */
    Parser.prototype._commentStart = function (input) {
        var /** @type {?} */ outerQuote = null;
        for (var /** @type {?} */ i = 0; i < input.length - 1; i++) {
            var /** @type {?} */ char = input.charCodeAt(i);
            var /** @type {?} */ nextChar = input.charCodeAt(i + 1);
            if (char === $SLASH && nextChar == $SLASH && outerQuote == null)
                return i;
            if (outerQuote === char) {
                outerQuote = null;
            }
            else if (outerQuote == null && isQuote(char)) {
                outerQuote = char;
            }
        }
        return null;
    };
    /**
     * @param {?} input
     * @param {?} location
     * @param {?} interpolationConfig
     * @return {?}
     */
    Parser.prototype._checkNoInterpolation = function (input, location, interpolationConfig) {
        var /** @type {?} */ regexp = _createInterpolateRegExp(interpolationConfig);
        var /** @type {?} */ parts = input.split(regexp);
        if (parts.length > 1) {
            this._reportError("Got interpolation (" + interpolationConfig.start + interpolationConfig.end + ") where expression was expected", input, "at column " + this._findInterpolationErrorColumn(parts, 1, interpolationConfig) + " in", location);
        }
    };
    /**
     * @param {?} parts
     * @param {?} partInErrIdx
     * @param {?} interpolationConfig
     * @return {?}
     */
    Parser.prototype._findInterpolationErrorColumn = function (parts, partInErrIdx, interpolationConfig) {
        var /** @type {?} */ errLocation = '';
        for (var /** @type {?} */ j = 0; j < partInErrIdx; j++) {
            errLocation += j % 2 === 0 ?
                parts[j] :
                "" + interpolationConfig.start + parts[j] + interpolationConfig.end;
        }
        return errLocation.length;
    };
    return Parser;
}());
Parser.decorators = [
    { type: CompilerInjectable },
];
/**
 * @nocollapse
 */
Parser.ctorParameters = function () { return [
    { type: Lexer, },
]; };
var _ParseAST = (function () {
    /**
     * @param {?} input
     * @param {?} location
     * @param {?} tokens
     * @param {?} inputLength
     * @param {?} parseAction
     * @param {?} errors
     * @param {?} offset
     */
    function _ParseAST(input, location, tokens, inputLength, parseAction, errors, offset) {
        this.input = input;
        this.location = location;
        this.tokens = tokens;
        this.inputLength = inputLength;
        this.parseAction = parseAction;
        this.errors = errors;
        this.offset = offset;
        this.rparensExpected = 0;
        this.rbracketsExpected = 0;
        this.rbracesExpected = 0;
        this.index = 0;
    }
    /**
     * @param {?} offset
     * @return {?}
     */
    _ParseAST.prototype.peek = function (offset) {
        var /** @type {?} */ i = this.index + offset;
        return i < this.tokens.length ? this.tokens[i] : EOF;
    };
    Object.defineProperty(_ParseAST.prototype, "next", {
        /**
         * @return {?}
         */
        get: function () { return this.peek(0); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(_ParseAST.prototype, "inputIndex", {
        /**
         * @return {?}
         */
        get: function () {
            return (this.index < this.tokens.length) ? this.next.index + this.offset :
                this.inputLength + this.offset;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} start
     * @return {?}
     */
    _ParseAST.prototype.span = function (start) { return new ParseSpan(start, this.inputIndex); };
    /**
     * @return {?}
     */
    _ParseAST.prototype.advance = function () { this.index++; };
    /**
     * @param {?} code
     * @return {?}
     */
    _ParseAST.prototype.optionalCharacter = function (code) {
        if (this.next.isCharacter(code)) {
            this.advance();
            return true;
        }
        else {
            return false;
        }
    };
    /**
     * @return {?}
     */
    _ParseAST.prototype.peekKeywordLet = function () { return this.next.isKeywordLet(); };
    /**
     * @return {?}
     */
    _ParseAST.prototype.peekKeywordAs = function () { return this.next.isKeywordAs(); };
    /**
     * @param {?} code
     * @return {?}
     */
    _ParseAST.prototype.expectCharacter = function (code) {
        if (this.optionalCharacter(code))
            return;
        this.error("Missing expected " + String.fromCharCode(code));
    };
    /**
     * @param {?} op
     * @return {?}
     */
    _ParseAST.prototype.optionalOperator = function (op) {
        if (this.next.isOperator(op)) {
            this.advance();
            return true;
        }
        else {
            return false;
        }
    };
    /**
     * @param {?} operator
     * @return {?}
     */
    _ParseAST.prototype.expectOperator = function (operator) {
        if (this.optionalOperator(operator))
            return;
        this.error("Missing expected operator " + operator);
    };
    /**
     * @return {?}
     */
    _ParseAST.prototype.expectIdentifierOrKeyword = function () {
        var /** @type {?} */ n = this.next;
        if (!n.isIdentifier() && !n.isKeyword()) {
            this.error("Unexpected token " + n + ", expected identifier or keyword");
            return '';
        }
        this.advance();
        return n.toString();
    };
    /**
     * @return {?}
     */
    _ParseAST.prototype.expectIdentifierOrKeywordOrString = function () {
        var /** @type {?} */ n = this.next;
        if (!n.isIdentifier() && !n.isKeyword() && !n.isString()) {
            this.error("Unexpected token " + n + ", expected identifier, keyword, or string");
            return '';
        }
        this.advance();
        return n.toString();
    };
    /**
     * @return {?}
     */
    _ParseAST.prototype.parseChain = function () {
        var /** @type {?} */ exprs = [];
        var /** @type {?} */ start = this.inputIndex;
        while (this.index < this.tokens.length) {
            var /** @type {?} */ expr = this.parsePipe();
            exprs.push(expr);
            if (this.optionalCharacter($SEMICOLON)) {
                if (!this.parseAction) {
                    this.error('Binding expression cannot contain chained expression');
                }
                while (this.optionalCharacter($SEMICOLON)) {
                } // read all semicolons
            }
            else if (this.index < this.tokens.length) {
                this.error("Unexpected token '" + this.next + "'");
            }
        }
        if (exprs.length == 0)
            return new EmptyExpr(this.span(start));
        if (exprs.length == 1)
            return exprs[0];
        return new Chain(this.span(start), exprs);
    };
    /**
     * @return {?}
     */
    _ParseAST.prototype.parsePipe = function () {
        var /** @type {?} */ result = this.parseExpression();
        if (this.optionalOperator('|')) {
            if (this.parseAction) {
                this.error('Cannot have a pipe in an action expression');
            }
            do {
                var /** @type {?} */ name = ((this.expectIdentifierOrKeyword()));
                var /** @type {?} */ args = [];
                while (this.optionalCharacter($COLON)) {
                    args.push(this.parseExpression());
                }
                result = new BindingPipe(this.span(result.span.start), result, name, args);
            } while (this.optionalOperator('|'));
        }
        return result;
    };
    /**
     * @return {?}
     */
    _ParseAST.prototype.parseExpression = function () { return this.parseConditional(); };
    /**
     * @return {?}
     */
    _ParseAST.prototype.parseConditional = function () {
        var /** @type {?} */ start = this.inputIndex;
        var /** @type {?} */ result = this.parseLogicalOr();
        if (this.optionalOperator('?')) {
            var /** @type {?} */ yes = this.parsePipe();
            var /** @type {?} */ no = void 0;
            if (!this.optionalCharacter($COLON)) {
                var /** @type {?} */ end = this.inputIndex;
                var /** @type {?} */ expression = this.input.substring(start, end);
                this.error("Conditional expression " + expression + " requires all 3 expressions");
                no = new EmptyExpr(this.span(start));
            }
            else {
                no = this.parsePipe();
            }
            return new Conditional(this.span(start), result, yes, no);
        }
        else {
            return result;
        }
    };
    /**
     * @return {?}
     */
    _ParseAST.prototype.parseLogicalOr = function () {
        // '||'
        var /** @type {?} */ result = this.parseLogicalAnd();
        while (this.optionalOperator('||')) {
            var /** @type {?} */ right = this.parseLogicalAnd();
            result = new Binary(this.span(result.span.start), '||', result, right);
        }
        return result;
    };
    /**
     * @return {?}
     */
    _ParseAST.prototype.parseLogicalAnd = function () {
        // '&&'
        var /** @type {?} */ result = this.parseEquality();
        while (this.optionalOperator('&&')) {
            var /** @type {?} */ right = this.parseEquality();
            result = new Binary(this.span(result.span.start), '&&', result, right);
        }
        return result;
    };
    /**
     * @return {?}
     */
    _ParseAST.prototype.parseEquality = function () {
        // '==','!=','===','!=='
        var /** @type {?} */ result = this.parseRelational();
        while (this.next.type == TokenType.Operator) {
            var /** @type {?} */ operator = this.next.strValue;
            switch (operator) {
                case '==':
                case '===':
                case '!=':
                case '!==':
                    this.advance();
                    var /** @type {?} */ right = this.parseRelational();
                    result = new Binary(this.span(result.span.start), operator, result, right);
                    continue;
            }
            break;
        }
        return result;
    };
    /**
     * @return {?}
     */
    _ParseAST.prototype.parseRelational = function () {
        // '<', '>', '<=', '>='
        var /** @type {?} */ result = this.parseAdditive();
        while (this.next.type == TokenType.Operator) {
            var /** @type {?} */ operator = this.next.strValue;
            switch (operator) {
                case '<':
                case '>':
                case '<=':
                case '>=':
                    this.advance();
                    var /** @type {?} */ right = this.parseAdditive();
                    result = new Binary(this.span(result.span.start), operator, result, right);
                    continue;
            }
            break;
        }
        return result;
    };
    /**
     * @return {?}
     */
    _ParseAST.prototype.parseAdditive = function () {
        // '+', '-'
        var /** @type {?} */ result = this.parseMultiplicative();
        while (this.next.type == TokenType.Operator) {
            var /** @type {?} */ operator = this.next.strValue;
            switch (operator) {
                case '+':
                case '-':
                    this.advance();
                    var /** @type {?} */ right = this.parseMultiplicative();
                    result = new Binary(this.span(result.span.start), operator, result, right);
                    continue;
            }
            break;
        }
        return result;
    };
    /**
     * @return {?}
     */
    _ParseAST.prototype.parseMultiplicative = function () {
        // '*', '%', '/'
        var /** @type {?} */ result = this.parsePrefix();
        while (this.next.type == TokenType.Operator) {
            var /** @type {?} */ operator = this.next.strValue;
            switch (operator) {
                case '*':
                case '%':
                case '/':
                    this.advance();
                    var /** @type {?} */ right = this.parsePrefix();
                    result = new Binary(this.span(result.span.start), operator, result, right);
                    continue;
            }
            break;
        }
        return result;
    };
    /**
     * @return {?}
     */
    _ParseAST.prototype.parsePrefix = function () {
        if (this.next.type == TokenType.Operator) {
            var /** @type {?} */ start = this.inputIndex;
            var /** @type {?} */ operator = this.next.strValue;
            var /** @type {?} */ result = void 0;
            switch (operator) {
                case '+':
                    this.advance();
                    return this.parsePrefix();
                case '-':
                    this.advance();
                    result = this.parsePrefix();
                    return new Binary(this.span(start), operator, new LiteralPrimitive(new ParseSpan(start, start), 0), result);
                case '!':
                    this.advance();
                    result = this.parsePrefix();
                    return new PrefixNot(this.span(start), result);
            }
        }
        return this.parseCallChain();
    };
    /**
     * @return {?}
     */
    _ParseAST.prototype.parseCallChain = function () {
        var /** @type {?} */ result = this.parsePrimary();
        while (true) {
            if (this.optionalCharacter($PERIOD)) {
                result = this.parseAccessMemberOrMethodCall(result, false);
            }
            else if (this.optionalOperator('?.')) {
                result = this.parseAccessMemberOrMethodCall(result, true);
            }
            else if (this.optionalCharacter($LBRACKET)) {
                this.rbracketsExpected++;
                var /** @type {?} */ key = this.parsePipe();
                this.rbracketsExpected--;
                this.expectCharacter($RBRACKET);
                if (this.optionalOperator('=')) {
                    var /** @type {?} */ value = this.parseConditional();
                    result = new KeyedWrite(this.span(result.span.start), result, key, value);
                }
                else {
                    result = new KeyedRead(this.span(result.span.start), result, key);
                }
            }
            else if (this.optionalCharacter($LPAREN)) {
                this.rparensExpected++;
                var /** @type {?} */ args = this.parseCallArguments();
                this.rparensExpected--;
                this.expectCharacter($RPAREN);
                result = new FunctionCall(this.span(result.span.start), result, args);
            }
            else {
                return result;
            }
        }
    };
    /**
     * @return {?}
     */
    _ParseAST.prototype.parsePrimary = function () {
        var /** @type {?} */ start = this.inputIndex;
        if (this.optionalCharacter($LPAREN)) {
            this.rparensExpected++;
            var /** @type {?} */ result = this.parsePipe();
            this.rparensExpected--;
            this.expectCharacter($RPAREN);
            return result;
        }
        else if (this.next.isKeywordNull()) {
            this.advance();
            return new LiteralPrimitive(this.span(start), null);
        }
        else if (this.next.isKeywordUndefined()) {
            this.advance();
            return new LiteralPrimitive(this.span(start), void 0);
        }
        else if (this.next.isKeywordTrue()) {
            this.advance();
            return new LiteralPrimitive(this.span(start), true);
        }
        else if (this.next.isKeywordFalse()) {
            this.advance();
            return new LiteralPrimitive(this.span(start), false);
        }
        else if (this.next.isKeywordThis()) {
            this.advance();
            return new ImplicitReceiver(this.span(start));
        }
        else if (this.optionalCharacter($LBRACKET)) {
            this.rbracketsExpected++;
            var /** @type {?} */ elements = this.parseExpressionList($RBRACKET);
            this.rbracketsExpected--;
            this.expectCharacter($RBRACKET);
            return new LiteralArray(this.span(start), elements);
        }
        else if (this.next.isCharacter($LBRACE)) {
            return this.parseLiteralMap();
        }
        else if (this.next.isIdentifier()) {
            return this.parseAccessMemberOrMethodCall(new ImplicitReceiver(this.span(start)), false);
        }
        else if (this.next.isNumber()) {
            var /** @type {?} */ value = this.next.toNumber();
            this.advance();
            return new LiteralPrimitive(this.span(start), value);
        }
        else if (this.next.isString()) {
            var /** @type {?} */ literalValue = this.next.toString();
            this.advance();
            return new LiteralPrimitive(this.span(start), literalValue);
        }
        else if (this.index >= this.tokens.length) {
            this.error("Unexpected end of expression: " + this.input);
            return new EmptyExpr(this.span(start));
        }
        else {
            this.error("Unexpected token " + this.next);
            return new EmptyExpr(this.span(start));
        }
    };
    /**
     * @param {?} terminator
     * @return {?}
     */
    _ParseAST.prototype.parseExpressionList = function (terminator) {
        var /** @type {?} */ result = [];
        if (!this.next.isCharacter(terminator)) {
            do {
                result.push(this.parsePipe());
            } while (this.optionalCharacter($COMMA));
        }
        return result;
    };
    /**
     * @return {?}
     */
    _ParseAST.prototype.parseLiteralMap = function () {
        var /** @type {?} */ keys = [];
        var /** @type {?} */ values = [];
        var /** @type {?} */ start = this.inputIndex;
        this.expectCharacter($LBRACE);
        if (!this.optionalCharacter($RBRACE)) {
            this.rbracesExpected++;
            do {
                var /** @type {?} */ key = ((this.expectIdentifierOrKeywordOrString()));
                keys.push(key);
                this.expectCharacter($COLON);
                values.push(this.parsePipe());
            } while (this.optionalCharacter($COMMA));
            this.rbracesExpected--;
            this.expectCharacter($RBRACE);
        }
        return new LiteralMap(this.span(start), keys, values);
    };
    /**
     * @param {?} receiver
     * @param {?=} isSafe
     * @return {?}
     */
    _ParseAST.prototype.parseAccessMemberOrMethodCall = function (receiver, isSafe) {
        if (isSafe === void 0) { isSafe = false; }
        var /** @type {?} */ start = receiver.span.start;
        var /** @type {?} */ id = ((this.expectIdentifierOrKeyword()));
        if (this.optionalCharacter($LPAREN)) {
            this.rparensExpected++;
            var /** @type {?} */ args = this.parseCallArguments();
            this.expectCharacter($RPAREN);
            this.rparensExpected--;
            var /** @type {?} */ span = this.span(start);
            return isSafe ? new SafeMethodCall(span, receiver, id, args) :
                new MethodCall(span, receiver, id, args);
        }
        else {
            if (isSafe) {
                if (this.optionalOperator('=')) {
                    this.error('The \'?.\' operator cannot be used in the assignment');
                    return new EmptyExpr(this.span(start));
                }
                else {
                    return new SafePropertyRead(this.span(start), receiver, id);
                }
            }
            else {
                if (this.optionalOperator('=')) {
                    if (!this.parseAction) {
                        this.error('Bindings cannot contain assignments');
                        return new EmptyExpr(this.span(start));
                    }
                    var /** @type {?} */ value = this.parseConditional();
                    return new PropertyWrite(this.span(start), receiver, id, value);
                }
                else {
                    return new PropertyRead(this.span(start), receiver, id);
                }
            }
        }
    };
    /**
     * @return {?}
     */
    _ParseAST.prototype.parseCallArguments = function () {
        if (this.next.isCharacter($RPAREN))
            return [];
        var /** @type {?} */ positionals = [];
        do {
            positionals.push(this.parsePipe());
        } while (this.optionalCharacter($COMMA));
        return (positionals);
    };
    /**
     * An identifier, a keyword, a string with an optional `-` inbetween.
     * @return {?}
     */
    _ParseAST.prototype.expectTemplateBindingKey = function () {
        var /** @type {?} */ result = '';
        var /** @type {?} */ operatorFound = false;
        do {
            result += this.expectIdentifierOrKeywordOrString();
            operatorFound = this.optionalOperator('-');
            if (operatorFound) {
                result += '-';
            }
        } while (operatorFound);
        return result.toString();
    };
    /**
     * @return {?}
     */
    _ParseAST.prototype.parseTemplateBindings = function () {
        var /** @type {?} */ bindings = [];
        var /** @type {?} */ prefix = ((null));
        var /** @type {?} */ warnings = [];
        while (this.index < this.tokens.length) {
            var /** @type {?} */ start = this.inputIndex;
            var /** @type {?} */ keyIsVar = this.peekKeywordLet();
            if (keyIsVar) {
                this.advance();
            }
            var /** @type {?} */ rawKey = this.expectTemplateBindingKey();
            var /** @type {?} */ key = rawKey;
            if (!keyIsVar) {
                if (prefix == null) {
                    prefix = key;
                }
                else {
                    key = prefix + key[0].toUpperCase() + key.substring(1);
                }
            }
            this.optionalCharacter($COLON);
            var /** @type {?} */ name = ((null));
            var /** @type {?} */ expression = ((null));
            if (keyIsVar) {
                if (this.optionalOperator('=')) {
                    name = this.expectTemplateBindingKey();
                }
                else {
                    name = '\$implicit';
                }
            }
            else if (this.peekKeywordAs()) {
                var /** @type {?} */ letStart = this.inputIndex;
                this.advance(); // consume `as`
                name = rawKey;
                key = this.expectTemplateBindingKey(); // read local var name
                keyIsVar = true;
            }
            else if (this.next !== EOF && !this.peekKeywordLet()) {
                var /** @type {?} */ start_2 = this.inputIndex;
                var /** @type {?} */ ast = this.parsePipe();
                var /** @type {?} */ source = this.input.substring(start_2 - this.offset, this.inputIndex - this.offset);
                expression = new ASTWithSource(ast, source, this.location, this.errors);
            }
            bindings.push(new TemplateBinding(this.span(start), key, keyIsVar, name, expression));
            if (this.peekKeywordAs() && !keyIsVar) {
                var /** @type {?} */ letStart = this.inputIndex;
                this.advance(); // consume `as`
                var /** @type {?} */ letName = this.expectTemplateBindingKey(); // read local var name
                bindings.push(new TemplateBinding(this.span(letStart), letName, true, key, /** @type {?} */ ((null))));
            }
            if (!this.optionalCharacter($SEMICOLON)) {
                this.optionalCharacter($COMMA);
            }
        }
        return new TemplateBindingParseResult(bindings, warnings, this.errors);
    };
    /**
     * @param {?} message
     * @param {?=} index
     * @return {?}
     */
    _ParseAST.prototype.error = function (message, index) {
        if (index === void 0) { index = null; }
        this.errors.push(new ParserError(message, this.input, this.locationText(index), this.location));
        this.skip();
    };
    /**
     * @param {?=} index
     * @return {?}
     */
    _ParseAST.prototype.locationText = function (index) {
        if (index === void 0) { index = null; }
        if (index == null)
            index = this.index;
        return (index < this.tokens.length) ? "at column " + (this.tokens[index].index + 1) + " in" :
            "at the end of the expression";
    };
    /**
     * @return {?}
     */
    _ParseAST.prototype.skip = function () {
        var /** @type {?} */ n = this.next;
        while (this.index < this.tokens.length && !n.isCharacter($SEMICOLON) &&
            (this.rparensExpected <= 0 || !n.isCharacter($RPAREN)) &&
            (this.rbracesExpected <= 0 || !n.isCharacter($RBRACE)) &&
            (this.rbracketsExpected <= 0 || !n.isCharacter($RBRACKET))) {
            if (this.next.isError()) {
                this.errors.push(new ParserError(/** @type {?} */ ((this.next.toString())), this.input, this.locationText(), this.location));
            }
            this.advance();
            n = this.next;
        }
    };
    return _ParseAST;
}());
var SimpleExpressionChecker = (function () {
    function SimpleExpressionChecker() {
        this.errors = [];
    }
    /**
     * @param {?} ast
     * @return {?}
     */
    SimpleExpressionChecker.check = function (ast) {
        var /** @type {?} */ s = new SimpleExpressionChecker();
        ast.visit(s);
        return s.errors;
    };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    SimpleExpressionChecker.prototype.visitImplicitReceiver = function (ast, context) { };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    SimpleExpressionChecker.prototype.visitInterpolation = function (ast, context) { };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    SimpleExpressionChecker.prototype.visitLiteralPrimitive = function (ast, context) { };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    SimpleExpressionChecker.prototype.visitPropertyRead = function (ast, context) { };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    SimpleExpressionChecker.prototype.visitPropertyWrite = function (ast, context) { };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    SimpleExpressionChecker.prototype.visitSafePropertyRead = function (ast, context) { };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    SimpleExpressionChecker.prototype.visitMethodCall = function (ast, context) { };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    SimpleExpressionChecker.prototype.visitSafeMethodCall = function (ast, context) { };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    SimpleExpressionChecker.prototype.visitFunctionCall = function (ast, context) { };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    SimpleExpressionChecker.prototype.visitLiteralArray = function (ast, context) { this.visitAll(ast.expressions); };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    SimpleExpressionChecker.prototype.visitLiteralMap = function (ast, context) { this.visitAll(ast.values); };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    SimpleExpressionChecker.prototype.visitBinary = function (ast, context) { };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    SimpleExpressionChecker.prototype.visitPrefixNot = function (ast, context) { };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    SimpleExpressionChecker.prototype.visitConditional = function (ast, context) { };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    SimpleExpressionChecker.prototype.visitPipe = function (ast, context) { this.errors.push('pipes'); };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    SimpleExpressionChecker.prototype.visitKeyedRead = function (ast, context) { };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    SimpleExpressionChecker.prototype.visitKeyedWrite = function (ast, context) { };
    /**
     * @param {?} asts
     * @return {?}
     */
    SimpleExpressionChecker.prototype.visitAll = function (asts) {
        var _this = this;
        return asts.map(function (node) { return node.visit(_this); });
    };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    SimpleExpressionChecker.prototype.visitChain = function (ast, context) { };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    SimpleExpressionChecker.prototype.visitQuote = function (ast, context) { };
    return SimpleExpressionChecker;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var ParseLocation = (function () {
    /**
     * @param {?} file
     * @param {?} offset
     * @param {?} line
     * @param {?} col
     */
    function ParseLocation(file, offset, line, col) {
        this.file = file;
        this.offset = offset;
        this.line = line;
        this.col = col;
    }
    /**
     * @return {?}
     */
    ParseLocation.prototype.toString = function () {
        return this.offset != null ? this.file.url + "@" + this.line + ":" + this.col : this.file.url;
    };
    /**
     * @param {?} delta
     * @return {?}
     */
    ParseLocation.prototype.moveBy = function (delta) {
        var /** @type {?} */ source = this.file.content;
        var /** @type {?} */ len = source.length;
        var /** @type {?} */ offset = this.offset;
        var /** @type {?} */ line = this.line;
        var /** @type {?} */ col = this.col;
        while (offset > 0 && delta < 0) {
            offset--;
            delta++;
            var /** @type {?} */ ch = source.charCodeAt(offset);
            if (ch == $LF) {
                line--;
                var /** @type {?} */ priorLine = source.substr(0, offset - 1).lastIndexOf(String.fromCharCode($LF));
                col = priorLine > 0 ? offset - priorLine : offset;
            }
            else {
                col--;
            }
        }
        while (offset < len && delta > 0) {
            var /** @type {?} */ ch = source.charCodeAt(offset);
            offset++;
            delta--;
            if (ch == $LF) {
                line++;
                col = 0;
            }
            else {
                col++;
            }
        }
        return new ParseLocation(this.file, offset, line, col);
    };
    /**
     * @param {?} maxChars
     * @param {?} maxLines
     * @return {?}
     */
    ParseLocation.prototype.getContext = function (maxChars, maxLines) {
        var /** @type {?} */ content = this.file.content;
        var /** @type {?} */ startOffset = this.offset;
        if (startOffset != null) {
            if (startOffset > content.length - 1) {
                startOffset = content.length - 1;
            }
            var /** @type {?} */ endOffset = startOffset;
            var /** @type {?} */ ctxChars = 0;
            var /** @type {?} */ ctxLines = 0;
            while (ctxChars < maxChars && startOffset > 0) {
                startOffset--;
                ctxChars++;
                if (content[startOffset] == '\n') {
                    if (++ctxLines == maxLines) {
                        break;
                    }
                }
            }
            ctxChars = 0;
            ctxLines = 0;
            while (ctxChars < maxChars && endOffset < content.length - 1) {
                endOffset++;
                ctxChars++;
                if (content[endOffset] == '\n') {
                    if (++ctxLines == maxLines) {
                        break;
                    }
                }
            }
            return {
                before: content.substring(startOffset, this.offset),
                after: content.substring(this.offset, endOffset + 1),
            };
        }
        return null;
    };
    return ParseLocation;
}());
var ParseSourceFile = (function () {
    /**
     * @param {?} content
     * @param {?} url
     */
    function ParseSourceFile(content, url) {
        this.content = content;
        this.url = url;
    }
    return ParseSourceFile;
}());
var ParseSourceSpan = (function () {
    /**
     * @param {?} start
     * @param {?} end
     * @param {?=} details
     */
    function ParseSourceSpan(start, end, details) {
        if (details === void 0) { details = null; }
        this.start = start;
        this.end = end;
        this.details = details;
    }
    /**
     * @return {?}
     */
    ParseSourceSpan.prototype.toString = function () {
        return this.start.file.content.substring(this.start.offset, this.end.offset);
    };
    return ParseSourceSpan;
}());
var ParseErrorLevel = {};
ParseErrorLevel.WARNING = 0;
ParseErrorLevel.ERROR = 1;
ParseErrorLevel[ParseErrorLevel.WARNING] = "WARNING";
ParseErrorLevel[ParseErrorLevel.ERROR] = "ERROR";
var ParseError = (function () {
    /**
     * @param {?} span
     * @param {?} msg
     * @param {?=} level
     */
    function ParseError(span, msg, level) {
        if (level === void 0) { level = ParseErrorLevel.ERROR; }
        this.span = span;
        this.msg = msg;
        this.level = level;
    }
    /**
     * @return {?}
     */
    ParseError.prototype.toString = function () {
        var /** @type {?} */ ctx = this.span.start.getContext(100, 3);
        var /** @type {?} */ contextStr = ctx ? " (\"" + ctx.before + "[" + ParseErrorLevel[this.level] + " ->]" + ctx.after + "\")" : '';
        var /** @type {?} */ details = this.span.details ? ", " + this.span.details : '';
        return "" + this.msg + contextStr + ": " + this.span.start + details;
    };
    return ParseError;
}());
/**
 * @param {?} kind
 * @param {?} type
 * @return {?}
 */
function typeSourceSpan(kind, type) {
    var /** @type {?} */ moduleUrl = identifierModuleUrl(type);
    var /** @type {?} */ sourceFileName = moduleUrl != null ? "in " + kind + " " + identifierName(type) + " in " + moduleUrl :
        "in " + kind + " " + identifierName(type);
    var /** @type {?} */ sourceFile = new ParseSourceFile('', sourceFileName);
    return new ParseSourceSpan(new ParseLocation(sourceFile, -1, -1, -1), new ParseLocation(sourceFile, -1, -1, -1));
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var Text = (function () {
    /**
     * @param {?} value
     * @param {?} sourceSpan
     */
    function Text(value, sourceSpan) {
        this.value = value;
        this.sourceSpan = sourceSpan;
    }
    /**
     * @param {?} visitor
     * @param {?} context
     * @return {?}
     */
    Text.prototype.visit = function (visitor, context) { return visitor.visitText(this, context); };
    return Text;
}());
var Expansion = (function () {
    /**
     * @param {?} switchValue
     * @param {?} type
     * @param {?} cases
     * @param {?} sourceSpan
     * @param {?} switchValueSourceSpan
     */
    function Expansion(switchValue, type, cases, sourceSpan, switchValueSourceSpan) {
        this.switchValue = switchValue;
        this.type = type;
        this.cases = cases;
        this.sourceSpan = sourceSpan;
        this.switchValueSourceSpan = switchValueSourceSpan;
    }
    /**
     * @param {?} visitor
     * @param {?} context
     * @return {?}
     */
    Expansion.prototype.visit = function (visitor, context) { return visitor.visitExpansion(this, context); };
    return Expansion;
}());
var ExpansionCase = (function () {
    /**
     * @param {?} value
     * @param {?} expression
     * @param {?} sourceSpan
     * @param {?} valueSourceSpan
     * @param {?} expSourceSpan
     */
    function ExpansionCase(value, expression, sourceSpan, valueSourceSpan, expSourceSpan) {
        this.value = value;
        this.expression = expression;
        this.sourceSpan = sourceSpan;
        this.valueSourceSpan = valueSourceSpan;
        this.expSourceSpan = expSourceSpan;
    }
    /**
     * @param {?} visitor
     * @param {?} context
     * @return {?}
     */
    ExpansionCase.prototype.visit = function (visitor, context) { return visitor.visitExpansionCase(this, context); };
    return ExpansionCase;
}());
var Attribute$1 = (function () {
    /**
     * @param {?} name
     * @param {?} value
     * @param {?} sourceSpan
     * @param {?=} valueSpan
     */
    function Attribute$1(name, value, sourceSpan, valueSpan) {
        this.name = name;
        this.value = value;
        this.sourceSpan = sourceSpan;
        this.valueSpan = valueSpan;
    }
    /**
     * @param {?} visitor
     * @param {?} context
     * @return {?}
     */
    Attribute$1.prototype.visit = function (visitor, context) { return visitor.visitAttribute(this, context); };
    return Attribute$1;
}());
var Element = (function () {
    /**
     * @param {?} name
     * @param {?} attrs
     * @param {?} children
     * @param {?} sourceSpan
     * @param {?=} startSourceSpan
     * @param {?=} endSourceSpan
     */
    function Element(name, attrs, children, sourceSpan, startSourceSpan, endSourceSpan) {
        if (startSourceSpan === void 0) { startSourceSpan = null; }
        if (endSourceSpan === void 0) { endSourceSpan = null; }
        this.name = name;
        this.attrs = attrs;
        this.children = children;
        this.sourceSpan = sourceSpan;
        this.startSourceSpan = startSourceSpan;
        this.endSourceSpan = endSourceSpan;
    }
    /**
     * @param {?} visitor
     * @param {?} context
     * @return {?}
     */
    Element.prototype.visit = function (visitor, context) { return visitor.visitElement(this, context); };
    return Element;
}());
var Comment = (function () {
    /**
     * @param {?} value
     * @param {?} sourceSpan
     */
    function Comment(value, sourceSpan) {
        this.value = value;
        this.sourceSpan = sourceSpan;
    }
    /**
     * @param {?} visitor
     * @param {?} context
     * @return {?}
     */
    Comment.prototype.visit = function (visitor, context) { return visitor.visitComment(this, context); };
    return Comment;
}());
/**
 * @param {?} visitor
 * @param {?} nodes
 * @param {?=} context
 * @return {?}
 */
function visitAll(visitor, nodes, context) {
    if (context === void 0) { context = null; }
    var /** @type {?} */ result = [];
    var /** @type {?} */ visit = visitor.visit ?
        function (ast) { return ((visitor.visit))(ast, context) || ast.visit(visitor, context); } :
        function (ast) { return ast.visit(visitor, context); };
    nodes.forEach(function (ast) {
        var /** @type {?} */ astResult = visit(ast);
        if (astResult) {
            result.push(astResult);
        }
    });
    return result;
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var TokenType$1 = {};
TokenType$1.TAG_OPEN_START = 0;
TokenType$1.TAG_OPEN_END = 1;
TokenType$1.TAG_OPEN_END_VOID = 2;
TokenType$1.TAG_CLOSE = 3;
TokenType$1.TEXT = 4;
TokenType$1.ESCAPABLE_RAW_TEXT = 5;
TokenType$1.RAW_TEXT = 6;
TokenType$1.COMMENT_START = 7;
TokenType$1.COMMENT_END = 8;
TokenType$1.CDATA_START = 9;
TokenType$1.CDATA_END = 10;
TokenType$1.ATTR_NAME = 11;
TokenType$1.ATTR_VALUE = 12;
TokenType$1.DOC_TYPE = 13;
TokenType$1.EXPANSION_FORM_START = 14;
TokenType$1.EXPANSION_CASE_VALUE = 15;
TokenType$1.EXPANSION_CASE_EXP_START = 16;
TokenType$1.EXPANSION_CASE_EXP_END = 17;
TokenType$1.EXPANSION_FORM_END = 18;
TokenType$1.EOF = 19;
TokenType$1[TokenType$1.TAG_OPEN_START] = "TAG_OPEN_START";
TokenType$1[TokenType$1.TAG_OPEN_END] = "TAG_OPEN_END";
TokenType$1[TokenType$1.TAG_OPEN_END_VOID] = "TAG_OPEN_END_VOID";
TokenType$1[TokenType$1.TAG_CLOSE] = "TAG_CLOSE";
TokenType$1[TokenType$1.TEXT] = "TEXT";
TokenType$1[TokenType$1.ESCAPABLE_RAW_TEXT] = "ESCAPABLE_RAW_TEXT";
TokenType$1[TokenType$1.RAW_TEXT] = "RAW_TEXT";
TokenType$1[TokenType$1.COMMENT_START] = "COMMENT_START";
TokenType$1[TokenType$1.COMMENT_END] = "COMMENT_END";
TokenType$1[TokenType$1.CDATA_START] = "CDATA_START";
TokenType$1[TokenType$1.CDATA_END] = "CDATA_END";
TokenType$1[TokenType$1.ATTR_NAME] = "ATTR_NAME";
TokenType$1[TokenType$1.ATTR_VALUE] = "ATTR_VALUE";
TokenType$1[TokenType$1.DOC_TYPE] = "DOC_TYPE";
TokenType$1[TokenType$1.EXPANSION_FORM_START] = "EXPANSION_FORM_START";
TokenType$1[TokenType$1.EXPANSION_CASE_VALUE] = "EXPANSION_CASE_VALUE";
TokenType$1[TokenType$1.EXPANSION_CASE_EXP_START] = "EXPANSION_CASE_EXP_START";
TokenType$1[TokenType$1.EXPANSION_CASE_EXP_END] = "EXPANSION_CASE_EXP_END";
TokenType$1[TokenType$1.EXPANSION_FORM_END] = "EXPANSION_FORM_END";
TokenType$1[TokenType$1.EOF] = "EOF";
var Token$1 = (function () {
    /**
     * @param {?} type
     * @param {?} parts
     * @param {?} sourceSpan
     */
    function Token$1(type, parts, sourceSpan) {
        this.type = type;
        this.parts = parts;
        this.sourceSpan = sourceSpan;
    }
    return Token$1;
}());
var TokenError = (function (_super) {
    __extends(TokenError, _super);
    /**
     * @param {?} errorMsg
     * @param {?} tokenType
     * @param {?} span
     */
    function TokenError(errorMsg, tokenType, span) {
        var _this = _super.call(this, span, errorMsg) || this;
        _this.tokenType = tokenType;
        return _this;
    }
    return TokenError;
}(ParseError));
var TokenizeResult = (function () {
    /**
     * @param {?} tokens
     * @param {?} errors
     */
    function TokenizeResult(tokens, errors) {
        this.tokens = tokens;
        this.errors = errors;
    }
    return TokenizeResult;
}());
/**
 * @param {?} source
 * @param {?} url
 * @param {?} getTagDefinition
 * @param {?=} tokenizeExpansionForms
 * @param {?=} interpolationConfig
 * @return {?}
 */
function tokenize(source, url, getTagDefinition, tokenizeExpansionForms, interpolationConfig) {
    if (tokenizeExpansionForms === void 0) { tokenizeExpansionForms = false; }
    if (interpolationConfig === void 0) { interpolationConfig = DEFAULT_INTERPOLATION_CONFIG; }
    return new _Tokenizer(new ParseSourceFile(source, url), getTagDefinition, tokenizeExpansionForms, interpolationConfig)
        .tokenize();
}
var _CR_OR_CRLF_REGEXP = /\r\n?/g;
/**
 * @param {?} charCode
 * @return {?}
 */
function _unexpectedCharacterErrorMsg(charCode) {
    var /** @type {?} */ char = charCode === $EOF ? 'EOF' : String.fromCharCode(charCode);
    return "Unexpected character \"" + char + "\"";
}
/**
 * @param {?} entitySrc
 * @return {?}
 */
function _unknownEntityErrorMsg(entitySrc) {
    return "Unknown entity \"" + entitySrc + "\" - use the \"&#<decimal>;\" or  \"&#x<hex>;\" syntax";
}
var _ControlFlowError = (function () {
    /**
     * @param {?} error
     */
    function _ControlFlowError(error) {
        this.error = error;
    }
    return _ControlFlowError;
}());
var _Tokenizer = (function () {
    /**
     * @param {?} _file The html source
     * @param {?} _getTagDefinition
     * @param {?} _tokenizeIcu Whether to tokenize ICU messages (considered as text nodes when false)
     * @param {?=} _interpolationConfig
     */
    function _Tokenizer(_file, _getTagDefinition, _tokenizeIcu, _interpolationConfig) {
        if (_interpolationConfig === void 0) { _interpolationConfig = DEFAULT_INTERPOLATION_CONFIG; }
        this._file = _file;
        this._getTagDefinition = _getTagDefinition;
        this._tokenizeIcu = _tokenizeIcu;
        this._interpolationConfig = _interpolationConfig;
        this._peek = -1;
        this._nextPeek = -1;
        this._index = -1;
        this._line = 0;
        this._column = -1;
        this._expansionCaseStack = [];
        this._inInterpolation = false;
        this.tokens = [];
        this.errors = [];
        this._input = _file.content;
        this._length = _file.content.length;
        this._advance();
    }
    /**
     * @param {?} content
     * @return {?}
     */
    _Tokenizer.prototype._processCarriageReturns = function (content) {
        // http://www.w3.org/TR/html5/syntax.html#preprocessing-the-input-stream
        // In order to keep the original position in the source, we can not
        // pre-process it.
        // Instead CRs are processed right before instantiating the tokens.
        return content.replace(_CR_OR_CRLF_REGEXP, '\n');
    };
    /**
     * @return {?}
     */
    _Tokenizer.prototype.tokenize = function () {
        while (this._peek !== $EOF) {
            var /** @type {?} */ start = this._getLocation();
            try {
                if (this._attemptCharCode($LT)) {
                    if (this._attemptCharCode($BANG)) {
                        if (this._attemptCharCode($LBRACKET)) {
                            this._consumeCdata(start);
                        }
                        else if (this._attemptCharCode($MINUS)) {
                            this._consumeComment(start);
                        }
                        else {
                            this._consumeDocType(start);
                        }
                    }
                    else if (this._attemptCharCode($SLASH)) {
                        this._consumeTagClose(start);
                    }
                    else {
                        this._consumeTagOpen(start);
                    }
                }
                else if (!(this._tokenizeIcu && this._tokenizeExpansionForm())) {
                    this._consumeText();
                }
            }
            catch (e) {
                if (e instanceof _ControlFlowError) {
                    this.errors.push(e.error);
                }
                else {
                    throw e;
                }
            }
        }
        this._beginToken(TokenType$1.EOF);
        this._endToken([]);
        return new TokenizeResult(mergeTextTokens(this.tokens), this.errors);
    };
    /**
     * \@internal
     * @return {?}
     */
    _Tokenizer.prototype._tokenizeExpansionForm = function () {
        if (isExpansionFormStart(this._input, this._index, this._interpolationConfig)) {
            this._consumeExpansionFormStart();
            return true;
        }
        if (isExpansionCaseStart(this._peek) && this._isInExpansionForm()) {
            this._consumeExpansionCaseStart();
            return true;
        }
        if (this._peek === $RBRACE) {
            if (this._isInExpansionCase()) {
                this._consumeExpansionCaseEnd();
                return true;
            }
            if (this._isInExpansionForm()) {
                this._consumeExpansionFormEnd();
                return true;
            }
        }
        return false;
    };
    /**
     * @return {?}
     */
    _Tokenizer.prototype._getLocation = function () {
        return new ParseLocation(this._file, this._index, this._line, this._column);
    };
    /**
     * @param {?=} start
     * @param {?=} end
     * @return {?}
     */
    _Tokenizer.prototype._getSpan = function (start, end) {
        if (start === void 0) { start = this._getLocation(); }
        if (end === void 0) { end = this._getLocation(); }
        return new ParseSourceSpan(start, end);
    };
    /**
     * @param {?} type
     * @param {?=} start
     * @return {?}
     */
    _Tokenizer.prototype._beginToken = function (type, start) {
        if (start === void 0) { start = this._getLocation(); }
        this._currentTokenStart = start;
        this._currentTokenType = type;
    };
    /**
     * @param {?} parts
     * @param {?=} end
     * @return {?}
     */
    _Tokenizer.prototype._endToken = function (parts, end) {
        if (end === void 0) { end = this._getLocation(); }
        var /** @type {?} */ token = new Token$1(this._currentTokenType, parts, new ParseSourceSpan(this._currentTokenStart, end));
        this.tokens.push(token);
        this._currentTokenStart = ((null));
        this._currentTokenType = ((null));
        return token;
    };
    /**
     * @param {?} msg
     * @param {?} span
     * @return {?}
     */
    _Tokenizer.prototype._createError = function (msg, span) {
        if (this._isInExpansionForm()) {
            msg += " (Do you have an unescaped \"{\" in your template? Use \"{{ '{' }}\") to escape it.)";
        }
        var /** @type {?} */ error = new TokenError(msg, this._currentTokenType, span);
        this._currentTokenStart = ((null));
        this._currentTokenType = ((null));
        return new _ControlFlowError(error);
    };
    /**
     * @return {?}
     */
    _Tokenizer.prototype._advance = function () {
        if (this._index >= this._length) {
            throw this._createError(_unexpectedCharacterErrorMsg($EOF), this._getSpan());
        }
        if (this._peek === $LF) {
            this._line++;
            this._column = 0;
        }
        else if (this._peek !== $LF && this._peek !== $CR) {
            this._column++;
        }
        this._index++;
        this._peek = this._index >= this._length ? $EOF : this._input.charCodeAt(this._index);
        this._nextPeek =
            this._index + 1 >= this._length ? $EOF : this._input.charCodeAt(this._index + 1);
    };
    /**
     * @param {?} charCode
     * @return {?}
     */
    _Tokenizer.prototype._attemptCharCode = function (charCode) {
        if (this._peek === charCode) {
            this._advance();
            return true;
        }
        return false;
    };
    /**
     * @param {?} charCode
     * @return {?}
     */
    _Tokenizer.prototype._attemptCharCodeCaseInsensitive = function (charCode) {
        if (compareCharCodeCaseInsensitive(this._peek, charCode)) {
            this._advance();
            return true;
        }
        return false;
    };
    /**
     * @param {?} charCode
     * @return {?}
     */
    _Tokenizer.prototype._requireCharCode = function (charCode) {
        var /** @type {?} */ location = this._getLocation();
        if (!this._attemptCharCode(charCode)) {
            throw this._createError(_unexpectedCharacterErrorMsg(this._peek), this._getSpan(location, location));
        }
    };
    /**
     * @param {?} chars
     * @return {?}
     */
    _Tokenizer.prototype._attemptStr = function (chars) {
        var /** @type {?} */ len = chars.length;
        if (this._index + len > this._length) {
            return false;
        }
        var /** @type {?} */ initialPosition = this._savePosition();
        for (var /** @type {?} */ i = 0; i < len; i++) {
            if (!this._attemptCharCode(chars.charCodeAt(i))) {
                // If attempting to parse the string fails, we want to reset the parser
                // to where it was before the attempt
                this._restorePosition(initialPosition);
                return false;
            }
        }
        return true;
    };
    /**
     * @param {?} chars
     * @return {?}
     */
    _Tokenizer.prototype._attemptStrCaseInsensitive = function (chars) {
        for (var /** @type {?} */ i = 0; i < chars.length; i++) {
            if (!this._attemptCharCodeCaseInsensitive(chars.charCodeAt(i))) {
                return false;
            }
        }
        return true;
    };
    /**
     * @param {?} chars
     * @return {?}
     */
    _Tokenizer.prototype._requireStr = function (chars) {
        var /** @type {?} */ location = this._getLocation();
        if (!this._attemptStr(chars)) {
            throw this._createError(_unexpectedCharacterErrorMsg(this._peek), this._getSpan(location));
        }
    };
    /**
     * @param {?} predicate
     * @return {?}
     */
    _Tokenizer.prototype._attemptCharCodeUntilFn = function (predicate) {
        while (!predicate(this._peek)) {
            this._advance();
        }
    };
    /**
     * @param {?} predicate
     * @param {?} len
     * @return {?}
     */
    _Tokenizer.prototype._requireCharCodeUntilFn = function (predicate, len) {
        var /** @type {?} */ start = this._getLocation();
        this._attemptCharCodeUntilFn(predicate);
        if (this._index - start.offset < len) {
            throw this._createError(_unexpectedCharacterErrorMsg(this._peek), this._getSpan(start, start));
        }
    };
    /**
     * @param {?} char
     * @return {?}
     */
    _Tokenizer.prototype._attemptUntilChar = function (char) {
        while (this._peek !== char) {
            this._advance();
        }
    };
    /**
     * @param {?} decodeEntities
     * @return {?}
     */
    _Tokenizer.prototype._readChar = function (decodeEntities) {
        if (decodeEntities && this._peek === $AMPERSAND) {
            return this._decodeEntity();
        }
        else {
            var /** @type {?} */ index = this._index;
            this._advance();
            return this._input[index];
        }
    };
    /**
     * @return {?}
     */
    _Tokenizer.prototype._decodeEntity = function () {
        var /** @type {?} */ start = this._getLocation();
        this._advance();
        if (this._attemptCharCode($HASH)) {
            var /** @type {?} */ isHex = this._attemptCharCode($x) || this._attemptCharCode($X);
            var /** @type {?} */ numberStart = this._getLocation().offset;
            this._attemptCharCodeUntilFn(isDigitEntityEnd);
            if (this._peek != $SEMICOLON) {
                throw this._createError(_unexpectedCharacterErrorMsg(this._peek), this._getSpan());
            }
            this._advance();
            var /** @type {?} */ strNum = this._input.substring(numberStart, this._index - 1);
            try {
                var /** @type {?} */ charCode = parseInt(strNum, isHex ? 16 : 10);
                return String.fromCharCode(charCode);
            }
            catch (e) {
                var /** @type {?} */ entity = this._input.substring(start.offset + 1, this._index - 1);
                throw this._createError(_unknownEntityErrorMsg(entity), this._getSpan(start));
            }
        }
        else {
            var /** @type {?} */ startPosition = this._savePosition();
            this._attemptCharCodeUntilFn(isNamedEntityEnd);
            if (this._peek != $SEMICOLON) {
                this._restorePosition(startPosition);
                return '&';
            }
            this._advance();
            var /** @type {?} */ name = this._input.substring(start.offset + 1, this._index - 1);
            var /** @type {?} */ char = NAMED_ENTITIES[name];
            if (!char) {
                throw this._createError(_unknownEntityErrorMsg(name), this._getSpan(start));
            }
            return char;
        }
    };
    /**
     * @param {?} decodeEntities
     * @param {?} firstCharOfEnd
     * @param {?} attemptEndRest
     * @return {?}
     */
    _Tokenizer.prototype._consumeRawText = function (decodeEntities, firstCharOfEnd, attemptEndRest) {
        var /** @type {?} */ tagCloseStart;
        var /** @type {?} */ textStart = this._getLocation();
        this._beginToken(decodeEntities ? TokenType$1.ESCAPABLE_RAW_TEXT : TokenType$1.RAW_TEXT, textStart);
        var /** @type {?} */ parts = [];
        while (true) {
            tagCloseStart = this._getLocation();
            if (this._attemptCharCode(firstCharOfEnd) && attemptEndRest()) {
                break;
            }
            if (this._index > tagCloseStart.offset) {
                // add the characters consumed by the previous if statement to the output
                parts.push(this._input.substring(tagCloseStart.offset, this._index));
            }
            while (this._peek !== firstCharOfEnd) {
                parts.push(this._readChar(decodeEntities));
            }
        }
        return this._endToken([this._processCarriageReturns(parts.join(''))], tagCloseStart);
    };
    /**
     * @param {?} start
     * @return {?}
     */
    _Tokenizer.prototype._consumeComment = function (start) {
        var _this = this;
        this._beginToken(TokenType$1.COMMENT_START, start);
        this._requireCharCode($MINUS);
        this._endToken([]);
        var /** @type {?} */ textToken = this._consumeRawText(false, $MINUS, function () { return _this._attemptStr('->'); });
        this._beginToken(TokenType$1.COMMENT_END, textToken.sourceSpan.end);
        this._endToken([]);
    };
    /**
     * @param {?} start
     * @return {?}
     */
    _Tokenizer.prototype._consumeCdata = function (start) {
        var _this = this;
        this._beginToken(TokenType$1.CDATA_START, start);
        this._requireStr('CDATA[');
        this._endToken([]);
        var /** @type {?} */ textToken = this._consumeRawText(false, $RBRACKET, function () { return _this._attemptStr(']>'); });
        this._beginToken(TokenType$1.CDATA_END, textToken.sourceSpan.end);
        this._endToken([]);
    };
    /**
     * @param {?} start
     * @return {?}
     */
    _Tokenizer.prototype._consumeDocType = function (start) {
        this._beginToken(TokenType$1.DOC_TYPE, start);
        this._attemptUntilChar($GT);
        this._advance();
        this._endToken([this._input.substring(start.offset + 2, this._index - 1)]);
    };
    /**
     * @return {?}
     */
    _Tokenizer.prototype._consumePrefixAndName = function () {
        var /** @type {?} */ nameOrPrefixStart = this._index;
        var /** @type {?} */ prefix = ((null));
        while (this._peek !== $COLON && !isPrefixEnd(this._peek)) {
            this._advance();
        }
        var /** @type {?} */ nameStart;
        if (this._peek === $COLON) {
            this._advance();
            prefix = this._input.substring(nameOrPrefixStart, this._index - 1);
            nameStart = this._index;
        }
        else {
            nameStart = nameOrPrefixStart;
        }
        this._requireCharCodeUntilFn(isNameEnd, this._index === nameStart ? 1 : 0);
        var /** @type {?} */ name = this._input.substring(nameStart, this._index);
        return [prefix, name];
    };
    /**
     * @param {?} start
     * @return {?}
     */
    _Tokenizer.prototype._consumeTagOpen = function (start) {
        var /** @type {?} */ savedPos = this._savePosition();
        var /** @type {?} */ tagName;
        var /** @type {?} */ lowercaseTagName;
        try {
            if (!isAsciiLetter(this._peek)) {
                throw this._createError(_unexpectedCharacterErrorMsg(this._peek), this._getSpan());
            }
            var /** @type {?} */ nameStart = this._index;
            this._consumeTagOpenStart(start);
            tagName = this._input.substring(nameStart, this._index);
            lowercaseTagName = tagName.toLowerCase();
            this._attemptCharCodeUntilFn(isNotWhitespace);
            while (this._peek !== $SLASH && this._peek !== $GT) {
                this._consumeAttributeName();
                this._attemptCharCodeUntilFn(isNotWhitespace);
                if (this._attemptCharCode($EQ)) {
                    this._attemptCharCodeUntilFn(isNotWhitespace);
                    this._consumeAttributeValue();
                }
                this._attemptCharCodeUntilFn(isNotWhitespace);
            }
            this._consumeTagOpenEnd();
        }
        catch (e) {
            if (e instanceof _ControlFlowError) {
                // When the start tag is invalid, assume we want a "<"
                this._restorePosition(savedPos);
                // Back to back text tokens are merged at the end
                this._beginToken(TokenType$1.TEXT, start);
                this._endToken(['<']);
                return;
            }
            throw e;
        }
        var /** @type {?} */ contentTokenType = this._getTagDefinition(tagName).contentType;
        if (contentTokenType === TagContentType.RAW_TEXT) {
            this._consumeRawTextWithTagClose(lowercaseTagName, false);
        }
        else if (contentTokenType === TagContentType.ESCAPABLE_RAW_TEXT) {
            this._consumeRawTextWithTagClose(lowercaseTagName, true);
        }
    };
    /**
     * @param {?} lowercaseTagName
     * @param {?} decodeEntities
     * @return {?}
     */
    _Tokenizer.prototype._consumeRawTextWithTagClose = function (lowercaseTagName, decodeEntities) {
        var _this = this;
        var /** @type {?} */ textToken = this._consumeRawText(decodeEntities, $LT, function () {
            if (!_this._attemptCharCode($SLASH))
                return false;
            _this._attemptCharCodeUntilFn(isNotWhitespace);
            if (!_this._attemptStrCaseInsensitive(lowercaseTagName))
                return false;
            _this._attemptCharCodeUntilFn(isNotWhitespace);
            return _this._attemptCharCode($GT);
        });
        this._beginToken(TokenType$1.TAG_CLOSE, textToken.sourceSpan.end);
        this._endToken([/** @type {?} */ ((null)), lowercaseTagName]);
    };
    /**
     * @param {?} start
     * @return {?}
     */
    _Tokenizer.prototype._consumeTagOpenStart = function (start) {
        this._beginToken(TokenType$1.TAG_OPEN_START, start);
        var /** @type {?} */ parts = this._consumePrefixAndName();
        this._endToken(parts);
    };
    /**
     * @return {?}
     */
    _Tokenizer.prototype._consumeAttributeName = function () {
        this._beginToken(TokenType$1.ATTR_NAME);
        var /** @type {?} */ prefixAndName = this._consumePrefixAndName();
        this._endToken(prefixAndName);
    };
    /**
     * @return {?}
     */
    _Tokenizer.prototype._consumeAttributeValue = function () {
        this._beginToken(TokenType$1.ATTR_VALUE);
        var /** @type {?} */ value;
        if (this._peek === $SQ || this._peek === $DQ) {
            var /** @type {?} */ quoteChar = this._peek;
            this._advance();
            var /** @type {?} */ parts = [];
            while (this._peek !== quoteChar) {
                parts.push(this._readChar(true));
            }
            value = parts.join('');
            this._advance();
        }
        else {
            var /** @type {?} */ valueStart = this._index;
            this._requireCharCodeUntilFn(isNameEnd, 1);
            value = this._input.substring(valueStart, this._index);
        }
        this._endToken([this._processCarriageReturns(value)]);
    };
    /**
     * @return {?}
     */
    _Tokenizer.prototype._consumeTagOpenEnd = function () {
        var /** @type {?} */ tokenType = this._attemptCharCode($SLASH) ? TokenType$1.TAG_OPEN_END_VOID : TokenType$1.TAG_OPEN_END;
        this._beginToken(tokenType);
        this._requireCharCode($GT);
        this._endToken([]);
    };
    /**
     * @param {?} start
     * @return {?}
     */
    _Tokenizer.prototype._consumeTagClose = function (start) {
        this._beginToken(TokenType$1.TAG_CLOSE, start);
        this._attemptCharCodeUntilFn(isNotWhitespace);
        var /** @type {?} */ prefixAndName = this._consumePrefixAndName();
        this._attemptCharCodeUntilFn(isNotWhitespace);
        this._requireCharCode($GT);
        this._endToken(prefixAndName);
    };
    /**
     * @return {?}
     */
    _Tokenizer.prototype._consumeExpansionFormStart = function () {
        this._beginToken(TokenType$1.EXPANSION_FORM_START, this._getLocation());
        this._requireCharCode($LBRACE);
        this._endToken([]);
        this._expansionCaseStack.push(TokenType$1.EXPANSION_FORM_START);
        this._beginToken(TokenType$1.RAW_TEXT, this._getLocation());
        var /** @type {?} */ condition = this._readUntil($COMMA);
        this._endToken([condition], this._getLocation());
        this._requireCharCode($COMMA);
        this._attemptCharCodeUntilFn(isNotWhitespace);
        this._beginToken(TokenType$1.RAW_TEXT, this._getLocation());
        var /** @type {?} */ type = this._readUntil($COMMA);
        this._endToken([type], this._getLocation());
        this._requireCharCode($COMMA);
        this._attemptCharCodeUntilFn(isNotWhitespace);
    };
    /**
     * @return {?}
     */
    _Tokenizer.prototype._consumeExpansionCaseStart = function () {
        this._beginToken(TokenType$1.EXPANSION_CASE_VALUE, this._getLocation());
        var /** @type {?} */ value = this._readUntil($LBRACE).trim();
        this._endToken([value], this._getLocation());
        this._attemptCharCodeUntilFn(isNotWhitespace);
        this._beginToken(TokenType$1.EXPANSION_CASE_EXP_START, this._getLocation());
        this._requireCharCode($LBRACE);
        this._endToken([], this._getLocation());
        this._attemptCharCodeUntilFn(isNotWhitespace);
        this._expansionCaseStack.push(TokenType$1.EXPANSION_CASE_EXP_START);
    };
    /**
     * @return {?}
     */
    _Tokenizer.prototype._consumeExpansionCaseEnd = function () {
        this._beginToken(TokenType$1.EXPANSION_CASE_EXP_END, this._getLocation());
        this._requireCharCode($RBRACE);
        this._endToken([], this._getLocation());
        this._attemptCharCodeUntilFn(isNotWhitespace);
        this._expansionCaseStack.pop();
    };
    /**
     * @return {?}
     */
    _Tokenizer.prototype._consumeExpansionFormEnd = function () {
        this._beginToken(TokenType$1.EXPANSION_FORM_END, this._getLocation());
        this._requireCharCode($RBRACE);
        this._endToken([]);
        this._expansionCaseStack.pop();
    };
    /**
     * @return {?}
     */
    _Tokenizer.prototype._consumeText = function () {
        var /** @type {?} */ start = this._getLocation();
        this._beginToken(TokenType$1.TEXT, start);
        var /** @type {?} */ parts = [];
        do {
            if (this._interpolationConfig && this._attemptStr(this._interpolationConfig.start)) {
                parts.push(this._interpolationConfig.start);
                this._inInterpolation = true;
            }
            else if (this._interpolationConfig && this._inInterpolation &&
                this._attemptStr(this._interpolationConfig.end)) {
                parts.push(this._interpolationConfig.end);
                this._inInterpolation = false;
            }
            else {
                parts.push(this._readChar(true));
            }
        } while (!this._isTextEnd());
        this._endToken([this._processCarriageReturns(parts.join(''))]);
    };
    /**
     * @return {?}
     */
    _Tokenizer.prototype._isTextEnd = function () {
        if (this._peek === $LT || this._peek === $EOF) {
            return true;
        }
        if (this._tokenizeIcu && !this._inInterpolation) {
            if (isExpansionFormStart(this._input, this._index, this._interpolationConfig)) {
                // start of an expansion form
                return true;
            }
            if (this._peek === $RBRACE && this._isInExpansionCase()) {
                // end of and expansion case
                return true;
            }
        }
        return false;
    };
    /**
     * @return {?}
     */
    _Tokenizer.prototype._savePosition = function () {
        return [this._peek, this._index, this._column, this._line, this.tokens.length];
    };
    /**
     * @param {?} char
     * @return {?}
     */
    _Tokenizer.prototype._readUntil = function (char) {
        var /** @type {?} */ start = this._index;
        this._attemptUntilChar(char);
        return this._input.substring(start, this._index);
    };
    /**
     * @param {?} position
     * @return {?}
     */
    _Tokenizer.prototype._restorePosition = function (position) {
        this._peek = position[0];
        this._index = position[1];
        this._column = position[2];
        this._line = position[3];
        var /** @type {?} */ nbTokens = position[4];
        if (nbTokens < this.tokens.length) {
            // remove any extra tokens
            this.tokens = this.tokens.slice(0, nbTokens);
        }
    };
    /**
     * @return {?}
     */
    _Tokenizer.prototype._isInExpansionCase = function () {
        return this._expansionCaseStack.length > 0 &&
            this._expansionCaseStack[this._expansionCaseStack.length - 1] ===
                TokenType$1.EXPANSION_CASE_EXP_START;
    };
    /**
     * @return {?}
     */
    _Tokenizer.prototype._isInExpansionForm = function () {
        return this._expansionCaseStack.length > 0 &&
            this._expansionCaseStack[this._expansionCaseStack.length - 1] ===
                TokenType$1.EXPANSION_FORM_START;
    };
    return _Tokenizer;
}());
/**
 * @param {?} code
 * @return {?}
 */
function isNotWhitespace(code) {
    return !isWhitespace(code) || code === $EOF;
}
/**
 * @param {?} code
 * @return {?}
 */
function isNameEnd(code) {
    return isWhitespace(code) || code === $GT || code === $SLASH ||
        code === $SQ || code === $DQ || code === $EQ;
}
/**
 * @param {?} code
 * @return {?}
 */
function isPrefixEnd(code) {
    return (code < $a || $z < code) && (code < $A || $Z < code) &&
        (code < $0 || code > $9);
}
/**
 * @param {?} code
 * @return {?}
 */
function isDigitEntityEnd(code) {
    return code == $SEMICOLON || code == $EOF || !isAsciiHexDigit(code);
}
/**
 * @param {?} code
 * @return {?}
 */
function isNamedEntityEnd(code) {
    return code == $SEMICOLON || code == $EOF || !isAsciiLetter(code);
}
/**
 * @param {?} input
 * @param {?} offset
 * @param {?} interpolationConfig
 * @return {?}
 */
function isExpansionFormStart(input, offset, interpolationConfig) {
    var /** @type {?} */ isInterpolationStart = interpolationConfig ? input.indexOf(interpolationConfig.start, offset) == offset : false;
    return input.charCodeAt(offset) == $LBRACE && !isInterpolationStart;
}
/**
 * @param {?} peek
 * @return {?}
 */
function isExpansionCaseStart(peek) {
    return peek === $EQ || isAsciiLetter(peek);
}
/**
 * @param {?} code1
 * @param {?} code2
 * @return {?}
 */
function compareCharCodeCaseInsensitive(code1, code2) {
    return toUpperCaseCharCode(code1) == toUpperCaseCharCode(code2);
}
/**
 * @param {?} code
 * @return {?}
 */
function toUpperCaseCharCode(code) {
    return code >= $a && code <= $z ? code - $a + $A : code;
}
/**
 * @param {?} srcTokens
 * @return {?}
 */
function mergeTextTokens(srcTokens) {
    var /** @type {?} */ dstTokens = [];
    var /** @type {?} */ lastDstToken = undefined;
    for (var /** @type {?} */ i = 0; i < srcTokens.length; i++) {
        var /** @type {?} */ token = srcTokens[i];
        if (lastDstToken && lastDstToken.type == TokenType$1.TEXT && token.type == TokenType$1.TEXT) {
            lastDstToken.parts[0] += token.parts[0];
            lastDstToken.sourceSpan.end = token.sourceSpan.end;
        }
        else {
            lastDstToken = token;
            dstTokens.push(lastDstToken);
        }
    }
    return dstTokens;
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var TreeError = (function (_super) {
    __extends(TreeError, _super);
    /**
     * @param {?} elementName
     * @param {?} span
     * @param {?} msg
     */
    function TreeError(elementName, span, msg) {
        var _this = _super.call(this, span, msg) || this;
        _this.elementName = elementName;
        return _this;
    }
    /**
     * @param {?} elementName
     * @param {?} span
     * @param {?} msg
     * @return {?}
     */
    TreeError.create = function (elementName, span, msg) {
        return new TreeError(elementName, span, msg);
    };
    return TreeError;
}(ParseError));
var ParseTreeResult = (function () {
    /**
     * @param {?} rootNodes
     * @param {?} errors
     */
    function ParseTreeResult(rootNodes, errors) {
        this.rootNodes = rootNodes;
        this.errors = errors;
    }
    return ParseTreeResult;
}());
var Parser$1 = (function () {
    /**
     * @param {?} getTagDefinition
     */
    function Parser$1(getTagDefinition) {
        this.getTagDefinition = getTagDefinition;
    }
    /**
     * @param {?} source
     * @param {?} url
     * @param {?=} parseExpansionForms
     * @param {?=} interpolationConfig
     * @return {?}
     */
    Parser$1.prototype.parse = function (source, url, parseExpansionForms, interpolationConfig) {
        if (parseExpansionForms === void 0) { parseExpansionForms = false; }
        if (interpolationConfig === void 0) { interpolationConfig = DEFAULT_INTERPOLATION_CONFIG; }
        var /** @type {?} */ tokensAndErrors = tokenize(source, url, this.getTagDefinition, parseExpansionForms, interpolationConfig);
        var /** @type {?} */ treeAndErrors = new _TreeBuilder(tokensAndErrors.tokens, this.getTagDefinition).build();
        return new ParseTreeResult(treeAndErrors.rootNodes, ((tokensAndErrors.errors)).concat(treeAndErrors.errors));
    };
    return Parser$1;
}());
var _TreeBuilder = (function () {
    /**
     * @param {?} tokens
     * @param {?} getTagDefinition
     */
    function _TreeBuilder(tokens, getTagDefinition) {
        this.tokens = tokens;
        this.getTagDefinition = getTagDefinition;
        this._index = -1;
        this._rootNodes = [];
        this._errors = [];
        this._elementStack = [];
        this._advance();
    }
    /**
     * @return {?}
     */
    _TreeBuilder.prototype.build = function () {
        while (this._peek.type !== TokenType$1.EOF) {
            if (this._peek.type === TokenType$1.TAG_OPEN_START) {
                this._consumeStartTag(this._advance());
            }
            else if (this._peek.type === TokenType$1.TAG_CLOSE) {
                this._consumeEndTag(this._advance());
            }
            else if (this._peek.type === TokenType$1.CDATA_START) {
                this._closeVoidElement();
                this._consumeCdata(this._advance());
            }
            else if (this._peek.type === TokenType$1.COMMENT_START) {
                this._closeVoidElement();
                this._consumeComment(this._advance());
            }
            else if (this._peek.type === TokenType$1.TEXT || this._peek.type === TokenType$1.RAW_TEXT ||
                this._peek.type === TokenType$1.ESCAPABLE_RAW_TEXT) {
                this._closeVoidElement();
                this._consumeText(this._advance());
            }
            else if (this._peek.type === TokenType$1.EXPANSION_FORM_START) {
                this._consumeExpansion(this._advance());
            }
            else {
                // Skip all other tokens...
                this._advance();
            }
        }
        return new ParseTreeResult(this._rootNodes, this._errors);
    };
    /**
     * @return {?}
     */
    _TreeBuilder.prototype._advance = function () {
        var /** @type {?} */ prev = this._peek;
        if (this._index < this.tokens.length - 1) {
            // Note: there is always an EOF token at the end
            this._index++;
        }
        this._peek = this.tokens[this._index];
        return prev;
    };
    /**
     * @param {?} type
     * @return {?}
     */
    _TreeBuilder.prototype._advanceIf = function (type) {
        if (this._peek.type === type) {
            return this._advance();
        }
        return null;
    };
    /**
     * @param {?} startToken
     * @return {?}
     */
    _TreeBuilder.prototype._consumeCdata = function (startToken) {
        this._consumeText(this._advance());
        this._advanceIf(TokenType$1.CDATA_END);
    };
    /**
     * @param {?} token
     * @return {?}
     */
    _TreeBuilder.prototype._consumeComment = function (token) {
        var /** @type {?} */ text = this._advanceIf(TokenType$1.RAW_TEXT);
        this._advanceIf(TokenType$1.COMMENT_END);
        var /** @type {?} */ value = text != null ? text.parts[0].trim() : null;
        this._addToParent(new Comment(value, token.sourceSpan));
    };
    /**
     * @param {?} token
     * @return {?}
     */
    _TreeBuilder.prototype._consumeExpansion = function (token) {
        var /** @type {?} */ switchValue = this._advance();
        var /** @type {?} */ type = this._advance();
        var /** @type {?} */ cases = [];
        // read =
        while (this._peek.type === TokenType$1.EXPANSION_CASE_VALUE) {
            var /** @type {?} */ expCase = this._parseExpansionCase();
            if (!expCase)
                return; // error
            cases.push(expCase);
        }
        // read the final }
        if (this._peek.type !== TokenType$1.EXPANSION_FORM_END) {
            this._errors.push(TreeError.create(null, this._peek.sourceSpan, "Invalid ICU message. Missing '}'."));
            return;
        }
        var /** @type {?} */ sourceSpan = new ParseSourceSpan(token.sourceSpan.start, this._peek.sourceSpan.end);
        this._addToParent(new Expansion(switchValue.parts[0], type.parts[0], cases, sourceSpan, switchValue.sourceSpan));
        this._advance();
    };
    /**
     * @return {?}
     */
    _TreeBuilder.prototype._parseExpansionCase = function () {
        var /** @type {?} */ value = this._advance();
        // read {
        if (this._peek.type !== TokenType$1.EXPANSION_CASE_EXP_START) {
            this._errors.push(TreeError.create(null, this._peek.sourceSpan, "Invalid ICU message. Missing '{'."));
            return null;
        }
        // read until }
        var /** @type {?} */ start = this._advance();
        var /** @type {?} */ exp = this._collectExpansionExpTokens(start);
        if (!exp)
            return null;
        var /** @type {?} */ end = this._advance();
        exp.push(new Token$1(TokenType$1.EOF, [], end.sourceSpan));
        // parse everything in between { and }
        var /** @type {?} */ parsedExp = new _TreeBuilder(exp, this.getTagDefinition).build();
        if (parsedExp.errors.length > 0) {
            this._errors = this._errors.concat(/** @type {?} */ (parsedExp.errors));
            return null;
        }
        var /** @type {?} */ sourceSpan = new ParseSourceSpan(value.sourceSpan.start, end.sourceSpan.end);
        var /** @type {?} */ expSourceSpan = new ParseSourceSpan(start.sourceSpan.start, end.sourceSpan.end);
        return new ExpansionCase(value.parts[0], parsedExp.rootNodes, sourceSpan, value.sourceSpan, expSourceSpan);
    };
    /**
     * @param {?} start
     * @return {?}
     */
    _TreeBuilder.prototype._collectExpansionExpTokens = function (start) {
        var /** @type {?} */ exp = [];
        var /** @type {?} */ expansionFormStack = [TokenType$1.EXPANSION_CASE_EXP_START];
        while (true) {
            if (this._peek.type === TokenType$1.EXPANSION_FORM_START ||
                this._peek.type === TokenType$1.EXPANSION_CASE_EXP_START) {
                expansionFormStack.push(this._peek.type);
            }
            if (this._peek.type === TokenType$1.EXPANSION_CASE_EXP_END) {
                if (lastOnStack(expansionFormStack, TokenType$1.EXPANSION_CASE_EXP_START)) {
                    expansionFormStack.pop();
                    if (expansionFormStack.length == 0)
                        return exp;
                }
                else {
                    this._errors.push(TreeError.create(null, start.sourceSpan, "Invalid ICU message. Missing '}'."));
                    return null;
                }
            }
            if (this._peek.type === TokenType$1.EXPANSION_FORM_END) {
                if (lastOnStack(expansionFormStack, TokenType$1.EXPANSION_FORM_START)) {
                    expansionFormStack.pop();
                }
                else {
                    this._errors.push(TreeError.create(null, start.sourceSpan, "Invalid ICU message. Missing '}'."));
                    return null;
                }
            }
            if (this._peek.type === TokenType$1.EOF) {
                this._errors.push(TreeError.create(null, start.sourceSpan, "Invalid ICU message. Missing '}'."));
                return null;
            }
            exp.push(this._advance());
        }
    };
    /**
     * @param {?} token
     * @return {?}
     */
    _TreeBuilder.prototype._consumeText = function (token) {
        var /** @type {?} */ text = token.parts[0];
        if (text.length > 0 && text[0] == '\n') {
            var /** @type {?} */ parent = this._getParentElement();
            if (parent != null && parent.children.length == 0 &&
                this.getTagDefinition(parent.name).ignoreFirstLf) {
                text = text.substring(1);
            }
        }
        if (text.length > 0) {
            this._addToParent(new Text(text, token.sourceSpan));
        }
    };
    /**
     * @return {?}
     */
    _TreeBuilder.prototype._closeVoidElement = function () {
        if (this._elementStack.length > 0) {
            var /** @type {?} */ el = this._elementStack[this._elementStack.length - 1];
            if (this.getTagDefinition(el.name).isVoid) {
                this._elementStack.pop();
            }
        }
    };
    /**
     * @param {?} startTagToken
     * @return {?}
     */
    _TreeBuilder.prototype._consumeStartTag = function (startTagToken) {
        var /** @type {?} */ prefix = startTagToken.parts[0];
        var /** @type {?} */ name = startTagToken.parts[1];
        var /** @type {?} */ attrs = [];
        while (this._peek.type === TokenType$1.ATTR_NAME) {
            attrs.push(this._consumeAttr(this._advance()));
        }
        var /** @type {?} */ fullName = this._getElementFullName(prefix, name, this._getParentElement());
        var /** @type {?} */ selfClosing = false;
        // Note: There could have been a tokenizer error
        // so that we don't get a token for the end tag...
        if (this._peek.type === TokenType$1.TAG_OPEN_END_VOID) {
            this._advance();
            selfClosing = true;
            var /** @type {?} */ tagDef = this.getTagDefinition(fullName);
            if (!(tagDef.canSelfClose || getNsPrefix(fullName) !== null || tagDef.isVoid)) {
                this._errors.push(TreeError.create(fullName, startTagToken.sourceSpan, "Only void and foreign elements can be self closed \"" + startTagToken.parts[1] + "\""));
            }
        }
        else if (this._peek.type === TokenType$1.TAG_OPEN_END) {
            this._advance();
            selfClosing = false;
        }
        var /** @type {?} */ end = this._peek.sourceSpan.start;
        var /** @type {?} */ span = new ParseSourceSpan(startTagToken.sourceSpan.start, end);
        var /** @type {?} */ el = new Element(fullName, attrs, [], span, span, undefined);
        this._pushElement(el);
        if (selfClosing) {
            this._popElement(fullName);
            el.endSourceSpan = span;
        }
    };
    /**
     * @param {?} el
     * @return {?}
     */
    _TreeBuilder.prototype._pushElement = function (el) {
        if (this._elementStack.length > 0) {
            var /** @type {?} */ parentEl = this._elementStack[this._elementStack.length - 1];
            if (this.getTagDefinition(parentEl.name).isClosedByChild(el.name)) {
                this._elementStack.pop();
            }
        }
        var /** @type {?} */ tagDef = this.getTagDefinition(el.name);
        var _a = this._getParentElementSkippingContainers(), parent = _a.parent, container = _a.container;
        if (parent && tagDef.requireExtraParent(parent.name)) {
            var /** @type {?} */ newParent = new Element(tagDef.parentToAdd, [], [], el.sourceSpan, el.startSourceSpan, el.endSourceSpan);
            this._insertBeforeContainer(parent, container, newParent);
        }
        this._addToParent(el);
        this._elementStack.push(el);
    };
    /**
     * @param {?} endTagToken
     * @return {?}
     */
    _TreeBuilder.prototype._consumeEndTag = function (endTagToken) {
        var /** @type {?} */ fullName = this._getElementFullName(endTagToken.parts[0], endTagToken.parts[1], this._getParentElement());
        if (this._getParentElement()) {
            ((this._getParentElement())).endSourceSpan = endTagToken.sourceSpan;
        }
        if (this.getTagDefinition(fullName).isVoid) {
            this._errors.push(TreeError.create(fullName, endTagToken.sourceSpan, "Void elements do not have end tags \"" + endTagToken.parts[1] + "\""));
        }
        else if (!this._popElement(fullName)) {
            var /** @type {?} */ errMsg = "Unexpected closing tag \"" + fullName + "\". It may happen when the tag has already been closed by another tag. For more info see https://www.w3.org/TR/html5/syntax.html#closing-elements-that-have-implied-end-tags";
            this._errors.push(TreeError.create(fullName, endTagToken.sourceSpan, errMsg));
        }
    };
    /**
     * @param {?} fullName
     * @return {?}
     */
    _TreeBuilder.prototype._popElement = function (fullName) {
        for (var /** @type {?} */ stackIndex = this._elementStack.length - 1; stackIndex >= 0; stackIndex--) {
            var /** @type {?} */ el = this._elementStack[stackIndex];
            if (el.name == fullName) {
                this._elementStack.splice(stackIndex, this._elementStack.length - stackIndex);
                return true;
            }
            if (!this.getTagDefinition(el.name).closedByParent) {
                return false;
            }
        }
        return false;
    };
    /**
     * @param {?} attrName
     * @return {?}
     */
    _TreeBuilder.prototype._consumeAttr = function (attrName) {
        var /** @type {?} */ fullName = mergeNsAndName(attrName.parts[0], attrName.parts[1]);
        var /** @type {?} */ end = attrName.sourceSpan.end;
        var /** @type {?} */ value = '';
        var /** @type {?} */ valueSpan = ((undefined));
        if (this._peek.type === TokenType$1.ATTR_VALUE) {
            var /** @type {?} */ valueToken = this._advance();
            value = valueToken.parts[0];
            end = valueToken.sourceSpan.end;
            valueSpan = valueToken.sourceSpan;
        }
        return new Attribute$1(fullName, value, new ParseSourceSpan(attrName.sourceSpan.start, end), valueSpan);
    };
    /**
     * @return {?}
     */
    _TreeBuilder.prototype._getParentElement = function () {
        return this._elementStack.length > 0 ? this._elementStack[this._elementStack.length - 1] : null;
    };
    /**
     * Returns the parent in the DOM and the container.
     *
     * `<ng-container>` elements are skipped as they are not rendered as DOM element.
     * @return {?}
     */
    _TreeBuilder.prototype._getParentElementSkippingContainers = function () {
        var /** @type {?} */ container = null;
        for (var /** @type {?} */ i = this._elementStack.length - 1; i >= 0; i--) {
            if (!isNgContainer(this._elementStack[i].name)) {
                return { parent: this._elementStack[i], container: container };
            }
            container = this._elementStack[i];
        }
        return { parent: this._elementStack[this._elementStack.length - 1], container: container };
    };
    /**
     * @param {?} node
     * @return {?}
     */
    _TreeBuilder.prototype._addToParent = function (node) {
        var /** @type {?} */ parent = this._getParentElement();
        if (parent != null) {
            parent.children.push(node);
        }
        else {
            this._rootNodes.push(node);
        }
    };
    /**
     * Insert a node between the parent and the container.
     * When no container is given, the node is appended as a child of the parent.
     * Also updates the element stack accordingly.
     *
     * \@internal
     * @param {?} parent
     * @param {?} container
     * @param {?} node
     * @return {?}
     */
    _TreeBuilder.prototype._insertBeforeContainer = function (parent, container, node) {
        if (!container) {
            this._addToParent(node);
            this._elementStack.push(node);
        }
        else {
            if (parent) {
                // replace the container with the new node in the children
                var /** @type {?} */ index = parent.children.indexOf(container);
                parent.children[index] = node;
            }
            else {
                this._rootNodes.push(node);
            }
            node.children.push(container);
            this._elementStack.splice(this._elementStack.indexOf(container), 0, node);
        }
    };
    /**
     * @param {?} prefix
     * @param {?} localName
     * @param {?} parentElement
     * @return {?}
     */
    _TreeBuilder.prototype._getElementFullName = function (prefix, localName, parentElement) {
        if (prefix == null) {
            prefix = ((this.getTagDefinition(localName).implicitNamespacePrefix));
            if (prefix == null && parentElement != null) {
                prefix = getNsPrefix(parentElement.name);
            }
        }
        return mergeNsAndName(prefix, localName);
    };
    return _TreeBuilder;
}());
/**
 * @param {?} stack
 * @param {?} element
 * @return {?}
 */
function lastOnStack(stack, element) {
    return stack.length > 0 && stack[stack.length - 1] === element;
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var Message = (function () {
    /**
     * @param {?} nodes message AST
     * @param {?} placeholders maps placeholder names to static content
     * @param {?} placeholderToMessage maps placeholder names to messages (used for nested ICU messages)
     * @param {?} meaning
     * @param {?} description
     * @param {?} id
     */
    function Message(nodes, placeholders, placeholderToMessage, meaning, description, id) {
        this.nodes = nodes;
        this.placeholders = placeholders;
        this.placeholderToMessage = placeholderToMessage;
        this.meaning = meaning;
        this.description = description;
        this.id = id;
        if (nodes.length) {
            this.sources = [{
                    filePath: nodes[0].sourceSpan.start.file.url,
                    startLine: nodes[0].sourceSpan.start.line + 1,
                    startCol: nodes[0].sourceSpan.start.col + 1,
                    endLine: nodes[nodes.length - 1].sourceSpan.end.line + 1,
                    endCol: nodes[0].sourceSpan.start.col + 1
                }];
        }
        else {
            this.sources = [];
        }
    }
    return Message;
}());
var Text$1 = (function () {
    /**
     * @param {?} value
     * @param {?} sourceSpan
     */
    function Text$1(value, sourceSpan) {
        this.value = value;
        this.sourceSpan = sourceSpan;
    }
    /**
     * @param {?} visitor
     * @param {?=} context
     * @return {?}
     */
    Text$1.prototype.visit = function (visitor, context) { return visitor.visitText(this, context); };
    return Text$1;
}());
var Container = (function () {
    /**
     * @param {?} children
     * @param {?} sourceSpan
     */
    function Container(children, sourceSpan) {
        this.children = children;
        this.sourceSpan = sourceSpan;
    }
    /**
     * @param {?} visitor
     * @param {?=} context
     * @return {?}
     */
    Container.prototype.visit = function (visitor, context) { return visitor.visitContainer(this, context); };
    return Container;
}());
var Icu = (function () {
    /**
     * @param {?} expression
     * @param {?} type
     * @param {?} cases
     * @param {?} sourceSpan
     */
    function Icu(expression, type, cases, sourceSpan) {
        this.expression = expression;
        this.type = type;
        this.cases = cases;
        this.sourceSpan = sourceSpan;
    }
    /**
     * @param {?} visitor
     * @param {?=} context
     * @return {?}
     */
    Icu.prototype.visit = function (visitor, context) { return visitor.visitIcu(this, context); };
    return Icu;
}());
var TagPlaceholder = (function () {
    /**
     * @param {?} tag
     * @param {?} attrs
     * @param {?} startName
     * @param {?} closeName
     * @param {?} children
     * @param {?} isVoid
     * @param {?} sourceSpan
     */
    function TagPlaceholder(tag, attrs, startName, closeName, children, isVoid, sourceSpan) {
        this.tag = tag;
        this.attrs = attrs;
        this.startName = startName;
        this.closeName = closeName;
        this.children = children;
        this.isVoid = isVoid;
        this.sourceSpan = sourceSpan;
    }
    /**
     * @param {?} visitor
     * @param {?=} context
     * @return {?}
     */
    TagPlaceholder.prototype.visit = function (visitor, context) { return visitor.visitTagPlaceholder(this, context); };
    return TagPlaceholder;
}());
var Placeholder = (function () {
    /**
     * @param {?} value
     * @param {?} name
     * @param {?} sourceSpan
     */
    function Placeholder(value, name, sourceSpan) {
        this.value = value;
        this.name = name;
        this.sourceSpan = sourceSpan;
    }
    /**
     * @param {?} visitor
     * @param {?=} context
     * @return {?}
     */
    Placeholder.prototype.visit = function (visitor, context) { return visitor.visitPlaceholder(this, context); };
    return Placeholder;
}());
var IcuPlaceholder = (function () {
    /**
     * @param {?} value
     * @param {?} name
     * @param {?} sourceSpan
     */
    function IcuPlaceholder(value, name, sourceSpan) {
        this.value = value;
        this.name = name;
        this.sourceSpan = sourceSpan;
    }
    /**
     * @param {?} visitor
     * @param {?=} context
     * @return {?}
     */
    IcuPlaceholder.prototype.visit = function (visitor, context) { return visitor.visitIcuPlaceholder(this, context); };
    return IcuPlaceholder;
}());
var CloneVisitor = (function () {
    function CloneVisitor() {
    }
    /**
     * @param {?} text
     * @param {?=} context
     * @return {?}
     */
    CloneVisitor.prototype.visitText = function (text, context) { return new Text$1(text.value, text.sourceSpan); };
    /**
     * @param {?} container
     * @param {?=} context
     * @return {?}
     */
    CloneVisitor.prototype.visitContainer = function (container, context) {
        var _this = this;
        var /** @type {?} */ children = container.children.map(function (n) { return n.visit(_this, context); });
        return new Container(children, container.sourceSpan);
    };
    /**
     * @param {?} icu
     * @param {?=} context
     * @return {?}
     */
    CloneVisitor.prototype.visitIcu = function (icu, context) {
        var _this = this;
        var /** @type {?} */ cases = {};
        Object.keys(icu.cases).forEach(function (key) { return cases[key] = icu.cases[key].visit(_this, context); });
        var /** @type {?} */ msg = new Icu(icu.expression, icu.type, cases, icu.sourceSpan);
        msg.expressionPlaceholder = icu.expressionPlaceholder;
        return msg;
    };
    /**
     * @param {?} ph
     * @param {?=} context
     * @return {?}
     */
    CloneVisitor.prototype.visitTagPlaceholder = function (ph, context) {
        var _this = this;
        var /** @type {?} */ children = ph.children.map(function (n) { return n.visit(_this, context); });
        return new TagPlaceholder(ph.tag, ph.attrs, ph.startName, ph.closeName, children, ph.isVoid, ph.sourceSpan);
    };
    /**
     * @param {?} ph
     * @param {?=} context
     * @return {?}
     */
    CloneVisitor.prototype.visitPlaceholder = function (ph, context) {
        return new Placeholder(ph.value, ph.name, ph.sourceSpan);
    };
    /**
     * @param {?} ph
     * @param {?=} context
     * @return {?}
     */
    CloneVisitor.prototype.visitIcuPlaceholder = function (ph, context) {
        return new IcuPlaceholder(ph.value, ph.name, ph.sourceSpan);
    };
    return CloneVisitor;
}());
var RecurseVisitor = (function () {
    function RecurseVisitor() {
    }
    /**
     * @param {?} text
     * @param {?=} context
     * @return {?}
     */
    RecurseVisitor.prototype.visitText = function (text, context) { };
    ;
    /**
     * @param {?} container
     * @param {?=} context
     * @return {?}
     */
    RecurseVisitor.prototype.visitContainer = function (container, context) {
        var _this = this;
        container.children.forEach(function (child) { return child.visit(_this); });
    };
    /**
     * @param {?} icu
     * @param {?=} context
     * @return {?}
     */
    RecurseVisitor.prototype.visitIcu = function (icu, context) {
        var _this = this;
        Object.keys(icu.cases).forEach(function (k) { icu.cases[k].visit(_this); });
    };
    /**
     * @param {?} ph
     * @param {?=} context
     * @return {?}
     */
    RecurseVisitor.prototype.visitTagPlaceholder = function (ph, context) {
        var _this = this;
        ph.children.forEach(function (child) { return child.visit(_this); });
    };
    /**
     * @param {?} ph
     * @param {?=} context
     * @return {?}
     */
    RecurseVisitor.prototype.visitPlaceholder = function (ph, context) { };
    ;
    /**
     * @param {?} ph
     * @param {?=} context
     * @return {?}
     */
    RecurseVisitor.prototype.visitIcuPlaceholder = function (ph, context) { };
    ;
    return RecurseVisitor;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var TAG_TO_PLACEHOLDER_NAMES = {
    'A': 'LINK',
    'B': 'BOLD_TEXT',
    'BR': 'LINE_BREAK',
    'EM': 'EMPHASISED_TEXT',
    'H1': 'HEADING_LEVEL1',
    'H2': 'HEADING_LEVEL2',
    'H3': 'HEADING_LEVEL3',
    'H4': 'HEADING_LEVEL4',
    'H5': 'HEADING_LEVEL5',
    'H6': 'HEADING_LEVEL6',
    'HR': 'HORIZONTAL_RULE',
    'I': 'ITALIC_TEXT',
    'LI': 'LIST_ITEM',
    'LINK': 'MEDIA_LINK',
    'OL': 'ORDERED_LIST',
    'P': 'PARAGRAPH',
    'Q': 'QUOTATION',
    'S': 'STRIKETHROUGH_TEXT',
    'SMALL': 'SMALL_TEXT',
    'SUB': 'SUBSTRIPT',
    'SUP': 'SUPERSCRIPT',
    'TBODY': 'TABLE_BODY',
    'TD': 'TABLE_CELL',
    'TFOOT': 'TABLE_FOOTER',
    'TH': 'TABLE_HEADER_CELL',
    'THEAD': 'TABLE_HEADER',
    'TR': 'TABLE_ROW',
    'TT': 'MONOSPACED_TEXT',
    'U': 'UNDERLINED_TEXT',
    'UL': 'UNORDERED_LIST',
};
/**
 * Creates unique names for placeholder with different content.
 *
 * Returns the same placeholder name when the content is identical.
 *
 * \@internal
 */
var PlaceholderRegistry = (function () {
    function PlaceholderRegistry() {
        this._placeHolderNameCounts = {};
        this._signatureToName = {};
    }
    /**
     * @param {?} tag
     * @param {?} attrs
     * @param {?} isVoid
     * @return {?}
     */
    PlaceholderRegistry.prototype.getStartTagPlaceholderName = function (tag, attrs, isVoid) {
        var /** @type {?} */ signature = this._hashTag(tag, attrs, isVoid);
        if (this._signatureToName[signature]) {
            return this._signatureToName[signature];
        }
        var /** @type {?} */ upperTag = tag.toUpperCase();
        var /** @type {?} */ baseName = TAG_TO_PLACEHOLDER_NAMES[upperTag] || "TAG_" + upperTag;
        var /** @type {?} */ name = this._generateUniqueName(isVoid ? baseName : "START_" + baseName);
        this._signatureToName[signature] = name;
        return name;
    };
    /**
     * @param {?} tag
     * @return {?}
     */
    PlaceholderRegistry.prototype.getCloseTagPlaceholderName = function (tag) {
        var /** @type {?} */ signature = this._hashClosingTag(tag);
        if (this._signatureToName[signature]) {
            return this._signatureToName[signature];
        }
        var /** @type {?} */ upperTag = tag.toUpperCase();
        var /** @type {?} */ baseName = TAG_TO_PLACEHOLDER_NAMES[upperTag] || "TAG_" + upperTag;
        var /** @type {?} */ name = this._generateUniqueName("CLOSE_" + baseName);
        this._signatureToName[signature] = name;
        return name;
    };
    /**
     * @param {?} name
     * @param {?} content
     * @return {?}
     */
    PlaceholderRegistry.prototype.getPlaceholderName = function (name, content) {
        var /** @type {?} */ upperName = name.toUpperCase();
        var /** @type {?} */ signature = "PH: " + upperName + "=" + content;
        if (this._signatureToName[signature]) {
            return this._signatureToName[signature];
        }
        var /** @type {?} */ uniqueName = this._generateUniqueName(upperName);
        this._signatureToName[signature] = uniqueName;
        return uniqueName;
    };
    /**
     * @param {?} name
     * @return {?}
     */
    PlaceholderRegistry.prototype.getUniquePlaceholder = function (name) {
        return this._generateUniqueName(name.toUpperCase());
    };
    /**
     * @param {?} tag
     * @param {?} attrs
     * @param {?} isVoid
     * @return {?}
     */
    PlaceholderRegistry.prototype._hashTag = function (tag, attrs, isVoid) {
        var /** @type {?} */ start = "<" + tag;
        var /** @type {?} */ strAttrs = Object.keys(attrs).sort().map(function (name) { return " " + name + "=" + attrs[name]; }).join('');
        var /** @type {?} */ end = isVoid ? '/>' : "></" + tag + ">";
        return start + strAttrs + end;
    };
    /**
     * @param {?} tag
     * @return {?}
     */
    PlaceholderRegistry.prototype._hashClosingTag = function (tag) { return this._hashTag("/" + tag, {}, false); };
    /**
     * @param {?} base
     * @return {?}
     */
    PlaceholderRegistry.prototype._generateUniqueName = function (base) {
        var /** @type {?} */ seen = this._placeHolderNameCounts.hasOwnProperty(base);
        if (!seen) {
            this._placeHolderNameCounts[base] = 1;
            return base;
        }
        var /** @type {?} */ id = this._placeHolderNameCounts[base];
        this._placeHolderNameCounts[base] = id + 1;
        return base + "_" + id;
    };
    return PlaceholderRegistry;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var _expParser = new Parser(new Lexer());
/**
 * Returns a function converting html nodes to an i18n Message given an interpolationConfig
 * @param {?} interpolationConfig
 * @return {?}
 */
function createI18nMessageFactory(interpolationConfig) {
    var /** @type {?} */ visitor = new _I18nVisitor(_expParser, interpolationConfig);
    return function (nodes, meaning, description, id) { return visitor.toI18nMessage(nodes, meaning, description, id); };
}
var _I18nVisitor = (function () {
    /**
     * @param {?} _expressionParser
     * @param {?} _interpolationConfig
     */
    function _I18nVisitor(_expressionParser, _interpolationConfig) {
        this._expressionParser = _expressionParser;
        this._interpolationConfig = _interpolationConfig;
    }
    /**
     * @param {?} nodes
     * @param {?} meaning
     * @param {?} description
     * @param {?} id
     * @return {?}
     */
    _I18nVisitor.prototype.toI18nMessage = function (nodes, meaning, description, id) {
        this._isIcu = nodes.length == 1 && nodes[0] instanceof Expansion;
        this._icuDepth = 0;
        this._placeholderRegistry = new PlaceholderRegistry();
        this._placeholderToContent = {};
        this._placeholderToMessage = {};
        var /** @type {?} */ i18nodes = visitAll(this, nodes, {});
        return new Message(i18nodes, this._placeholderToContent, this._placeholderToMessage, meaning, description, id);
    };
    /**
     * @param {?} el
     * @param {?} context
     * @return {?}
     */
    _I18nVisitor.prototype.visitElement = function (el, context) {
        var /** @type {?} */ children = visitAll(this, el.children);
        var /** @type {?} */ attrs = {};
        el.attrs.forEach(function (attr) {
            // Do not visit the attributes, translatable ones are top-level ASTs
            attrs[attr.name] = attr.value;
        });
        var /** @type {?} */ isVoid = getHtmlTagDefinition(el.name).isVoid;
        var /** @type {?} */ startPhName = this._placeholderRegistry.getStartTagPlaceholderName(el.name, attrs, isVoid);
        this._placeholderToContent[startPhName] = ((el.sourceSpan)).toString();
        var /** @type {?} */ closePhName = '';
        if (!isVoid) {
            closePhName = this._placeholderRegistry.getCloseTagPlaceholderName(el.name);
            this._placeholderToContent[closePhName] = "</" + el.name + ">";
        }
        return new TagPlaceholder(el.name, attrs, startPhName, closePhName, children, isVoid, /** @type {?} */ ((el.sourceSpan)));
    };
    /**
     * @param {?} attribute
     * @param {?} context
     * @return {?}
     */
    _I18nVisitor.prototype.visitAttribute = function (attribute, context) {
        return this._visitTextWithInterpolation(attribute.value, attribute.sourceSpan);
    };
    /**
     * @param {?} text
     * @param {?} context
     * @return {?}
     */
    _I18nVisitor.prototype.visitText = function (text, context) {
        return this._visitTextWithInterpolation(text.value, /** @type {?} */ ((text.sourceSpan)));
    };
    /**
     * @param {?} comment
     * @param {?} context
     * @return {?}
     */
    _I18nVisitor.prototype.visitComment = function (comment, context) { return null; };
    /**
     * @param {?} icu
     * @param {?} context
     * @return {?}
     */
    _I18nVisitor.prototype.visitExpansion = function (icu, context) {
        var _this = this;
        this._icuDepth++;
        var /** @type {?} */ i18nIcuCases = {};
        var /** @type {?} */ i18nIcu = new Icu(icu.switchValue, icu.type, i18nIcuCases, icu.sourceSpan);
        icu.cases.forEach(function (caze) {
            i18nIcuCases[caze.value] = new Container(caze.expression.map(function (node) { return node.visit(_this, {}); }), caze.expSourceSpan);
        });
        this._icuDepth--;
        if (this._isIcu || this._icuDepth > 0) {
            // Returns an ICU node when:
            // - the message (vs a part of the message) is an ICU message, or
            // - the ICU message is nested.
            var /** @type {?} */ expPh = this._placeholderRegistry.getUniquePlaceholder("VAR_" + icu.type);
            i18nIcu.expressionPlaceholder = expPh;
            this._placeholderToContent[expPh] = icu.switchValue;
            return i18nIcu;
        }
        // Else returns a placeholder
        // ICU placeholders should not be replaced with their original content but with the their
        // translations. We need to create a new visitor (they are not re-entrant) to compute the
        // message id.
        // TODO(vicb): add a html.Node -> i18n.Message cache to avoid having to re-create the msg
        var /** @type {?} */ phName = this._placeholderRegistry.getPlaceholderName('ICU', icu.sourceSpan.toString());
        var /** @type {?} */ visitor = new _I18nVisitor(this._expressionParser, this._interpolationConfig);
        this._placeholderToMessage[phName] = visitor.toI18nMessage([icu], '', '', '');
        return new IcuPlaceholder(i18nIcu, phName, icu.sourceSpan);
    };
    /**
     * @param {?} icuCase
     * @param {?} context
     * @return {?}
     */
    _I18nVisitor.prototype.visitExpansionCase = function (icuCase, context) {
        throw new Error('Unreachable code');
    };
    /**
     * @param {?} text
     * @param {?} sourceSpan
     * @return {?}
     */
    _I18nVisitor.prototype._visitTextWithInterpolation = function (text, sourceSpan) {
        var /** @type {?} */ splitInterpolation = this._expressionParser.splitInterpolation(text, sourceSpan.start.toString(), this._interpolationConfig);
        if (!splitInterpolation) {
            // No expression, return a single text
            return new Text$1(text, sourceSpan);
        }
        // Return a group of text + expressions
        var /** @type {?} */ nodes = [];
        var /** @type {?} */ container = new Container(nodes, sourceSpan);
        var _a = this._interpolationConfig, sDelimiter = _a.start, eDelimiter = _a.end;
        for (var /** @type {?} */ i = 0; i < splitInterpolation.strings.length - 1; i++) {
            var /** @type {?} */ expression = splitInterpolation.expressions[i];
            var /** @type {?} */ baseName = _extractPlaceholderName(expression) || 'INTERPOLATION';
            var /** @type {?} */ phName = this._placeholderRegistry.getPlaceholderName(baseName, expression);
            if (splitInterpolation.strings[i].length) {
                // No need to add empty strings
                nodes.push(new Text$1(splitInterpolation.strings[i], sourceSpan));
            }
            nodes.push(new Placeholder(expression, phName, sourceSpan));
            this._placeholderToContent[phName] = sDelimiter + expression + eDelimiter;
        }
        // The last index contains no expression
        var /** @type {?} */ lastStringIdx = splitInterpolation.strings.length - 1;
        if (splitInterpolation.strings[lastStringIdx].length) {
            nodes.push(new Text$1(splitInterpolation.strings[lastStringIdx], sourceSpan));
        }
        return container;
    };
    return _I18nVisitor;
}());
var _CUSTOM_PH_EXP = /\/\/[\s\S]*i18n[\s\S]*\([\s\S]*ph[\s\S]*=[\s\S]*("|')([\s\S]*?)\1[\s\S]*\)/g;
/**
 * @param {?} input
 * @return {?}
 */
function _extractPlaceholderName(input) {
    return input.split(_CUSTOM_PH_EXP)[2];
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * An i18n error.
 */
var I18nError = (function (_super) {
    __extends(I18nError, _super);
    /**
     * @param {?} span
     * @param {?} msg
     */
    function I18nError(span, msg) {
        return _super.call(this, span, msg) || this;
    }
    return I18nError;
}(ParseError));
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var _I18N_ATTR = 'i18n';
var _I18N_ATTR_PREFIX = 'i18n-';
var _I18N_COMMENT_PREFIX_REGEXP = /^i18n:?/;
var MEANING_SEPARATOR = '|';
var ID_SEPARATOR = '@@';
/**
 * Extract translatable messages from an html AST
 * @param {?} nodes
 * @param {?} interpolationConfig
 * @param {?} implicitTags
 * @param {?} implicitAttrs
 * @return {?}
 */
function extractMessages(nodes, interpolationConfig, implicitTags, implicitAttrs) {
    var /** @type {?} */ visitor = new _Visitor(implicitTags, implicitAttrs);
    return visitor.extract(nodes, interpolationConfig);
}
/**
 * @param {?} nodes
 * @param {?} translations
 * @param {?} interpolationConfig
 * @param {?} implicitTags
 * @param {?} implicitAttrs
 * @return {?}
 */
function mergeTranslations(nodes, translations, interpolationConfig, implicitTags, implicitAttrs) {
    var /** @type {?} */ visitor = new _Visitor(implicitTags, implicitAttrs);
    return visitor.merge(nodes, translations, interpolationConfig);
}
var ExtractionResult = (function () {
    /**
     * @param {?} messages
     * @param {?} errors
     */
    function ExtractionResult(messages, errors) {
        this.messages = messages;
        this.errors = errors;
    }
    return ExtractionResult;
}());
var _VisitorMode = {};
_VisitorMode.Extract = 0;
_VisitorMode.Merge = 1;
_VisitorMode[_VisitorMode.Extract] = "Extract";
_VisitorMode[_VisitorMode.Merge] = "Merge";
/**
 * This Visitor is used:
 * 1. to extract all the translatable strings from an html AST (see `extract()`),
 * 2. to replace the translatable strings with the actual translations (see `merge()`)
 *
 * \@internal
 */
var _Visitor = (function () {
    /**
     * @param {?} _implicitTags
     * @param {?} _implicitAttrs
     */
    function _Visitor(_implicitTags, _implicitAttrs) {
        this._implicitTags = _implicitTags;
        this._implicitAttrs = _implicitAttrs;
    }
    /**
     * Extracts the messages from the tree
     * @param {?} nodes
     * @param {?} interpolationConfig
     * @return {?}
     */
    _Visitor.prototype.extract = function (nodes, interpolationConfig) {
        var _this = this;
        this._init(_VisitorMode.Extract, interpolationConfig);
        nodes.forEach(function (node) { return node.visit(_this, null); });
        if (this._inI18nBlock) {
            this._reportError(nodes[nodes.length - 1], 'Unclosed block');
        }
        return new ExtractionResult(this._messages, this._errors);
    };
    /**
     * Returns a tree where all translatable nodes are translated
     * @param {?} nodes
     * @param {?} translations
     * @param {?} interpolationConfig
     * @return {?}
     */
    _Visitor.prototype.merge = function (nodes, translations, interpolationConfig) {
        this._init(_VisitorMode.Merge, interpolationConfig);
        this._translations = translations;
        // Construct a single fake root element
        var /** @type {?} */ wrapper = new Element('wrapper', [], nodes, /** @type {?} */ ((undefined)), undefined, undefined);
        var /** @type {?} */ translatedNode = wrapper.visit(this, null);
        if (this._inI18nBlock) {
            this._reportError(nodes[nodes.length - 1], 'Unclosed block');
        }
        return new ParseTreeResult(translatedNode.children, this._errors);
    };
    /**
     * @param {?} icuCase
     * @param {?} context
     * @return {?}
     */
    _Visitor.prototype.visitExpansionCase = function (icuCase, context) {
        // Parse cases for translatable html attributes
        var /** @type {?} */ expression = visitAll(this, icuCase.expression, context);
        if (this._mode === _VisitorMode.Merge) {
            return new ExpansionCase(icuCase.value, expression, icuCase.sourceSpan, icuCase.valueSourceSpan, icuCase.expSourceSpan);
        }
    };
    /**
     * @param {?} icu
     * @param {?} context
     * @return {?}
     */
    _Visitor.prototype.visitExpansion = function (icu, context) {
        this._mayBeAddBlockChildren(icu);
        var /** @type {?} */ wasInIcu = this._inIcu;
        if (!this._inIcu) {
            // nested ICU messages should not be extracted but top-level translated as a whole
            if (this._isInTranslatableSection) {
                this._addMessage([icu]);
            }
            this._inIcu = true;
        }
        var /** @type {?} */ cases = visitAll(this, icu.cases, context);
        if (this._mode === _VisitorMode.Merge) {
            icu = new Expansion(icu.switchValue, icu.type, cases, icu.sourceSpan, icu.switchValueSourceSpan);
        }
        this._inIcu = wasInIcu;
        return icu;
    };
    /**
     * @param {?} comment
     * @param {?} context
     * @return {?}
     */
    _Visitor.prototype.visitComment = function (comment, context) {
        var /** @type {?} */ isOpening = _isOpeningComment(comment);
        if (isOpening && this._isInTranslatableSection) {
            this._reportError(comment, 'Could not start a block inside a translatable section');
            return;
        }
        var /** @type {?} */ isClosing = _isClosingComment(comment);
        if (isClosing && !this._inI18nBlock) {
            this._reportError(comment, 'Trying to close an unopened block');
            return;
        }
        if (!this._inI18nNode && !this._inIcu) {
            if (!this._inI18nBlock) {
                if (isOpening) {
                    this._inI18nBlock = true;
                    this._blockStartDepth = this._depth;
                    this._blockChildren = [];
                    this._blockMeaningAndDesc = ((comment.value)).replace(_I18N_COMMENT_PREFIX_REGEXP, '').trim();
                    this._openTranslatableSection(comment);
                }
            }
            else {
                if (isClosing) {
                    if (this._depth == this._blockStartDepth) {
                        this._closeTranslatableSection(comment, this._blockChildren);
                        this._inI18nBlock = false;
                        var /** @type {?} */ message = ((this._addMessage(this._blockChildren, this._blockMeaningAndDesc)));
                        // merge attributes in sections
                        var /** @type {?} */ nodes = this._translateMessage(comment, message);
                        return visitAll(this, nodes);
                    }
                    else {
                        this._reportError(comment, 'I18N blocks should not cross element boundaries');
                        return;
                    }
                }
            }
        }
    };
    /**
     * @param {?} text
     * @param {?} context
     * @return {?}
     */
    _Visitor.prototype.visitText = function (text, context) {
        if (this._isInTranslatableSection) {
            this._mayBeAddBlockChildren(text);
        }
        return text;
    };
    /**
     * @param {?} el
     * @param {?} context
     * @return {?}
     */
    _Visitor.prototype.visitElement = function (el, context) {
        var _this = this;
        this._mayBeAddBlockChildren(el);
        this._depth++;
        var /** @type {?} */ wasInI18nNode = this._inI18nNode;
        var /** @type {?} */ wasInImplicitNode = this._inImplicitNode;
        var /** @type {?} */ childNodes = [];
        var /** @type {?} */ translatedChildNodes = ((undefined));
        // Extract:
        // - top level nodes with the (implicit) "i18n" attribute if not already in a section
        // - ICU messages
        var /** @type {?} */ i18nAttr = _getI18nAttr(el);
        var /** @type {?} */ i18nMeta = i18nAttr ? i18nAttr.value : '';
        var /** @type {?} */ isImplicit = this._implicitTags.some(function (tag) { return el.name === tag; }) && !this._inIcu &&
            !this._isInTranslatableSection;
        var /** @type {?} */ isTopLevelImplicit = !wasInImplicitNode && isImplicit;
        this._inImplicitNode = wasInImplicitNode || isImplicit;
        if (!this._isInTranslatableSection && !this._inIcu) {
            if (i18nAttr || isTopLevelImplicit) {
                this._inI18nNode = true;
                var /** @type {?} */ message = ((this._addMessage(el.children, i18nMeta)));
                translatedChildNodes = this._translateMessage(el, message);
            }
            if (this._mode == _VisitorMode.Extract) {
                var /** @type {?} */ isTranslatable = i18nAttr || isTopLevelImplicit;
                if (isTranslatable)
                    this._openTranslatableSection(el);
                visitAll(this, el.children);
                if (isTranslatable)
                    this._closeTranslatableSection(el, el.children);
            }
        }
        else {
            if (i18nAttr || isTopLevelImplicit) {
                this._reportError(el, 'Could not mark an element as translatable inside a translatable section');
            }
            if (this._mode == _VisitorMode.Extract) {
                // Descend into child nodes for extraction
                visitAll(this, el.children);
            }
        }
        if (this._mode === _VisitorMode.Merge) {
            var /** @type {?} */ visitNodes = translatedChildNodes || el.children;
            visitNodes.forEach(function (child) {
                var /** @type {?} */ visited = child.visit(_this, context);
                if (visited && !_this._isInTranslatableSection) {
                    // Do not add the children from translatable sections (= i18n blocks here)
                    // They will be added later in this loop when the block closes (i.e. on `<!-- /i18n -->`)
                    childNodes = childNodes.concat(visited);
                }
            });
        }
        this._visitAttributesOf(el);
        this._depth--;
        this._inI18nNode = wasInI18nNode;
        this._inImplicitNode = wasInImplicitNode;
        if (this._mode === _VisitorMode.Merge) {
            var /** @type {?} */ translatedAttrs = this._translateAttributes(el);
            return new Element(el.name, translatedAttrs, childNodes, el.sourceSpan, el.startSourceSpan, el.endSourceSpan);
        }
        return null;
    };
    /**
     * @param {?} attribute
     * @param {?} context
     * @return {?}
     */
    _Visitor.prototype.visitAttribute = function (attribute, context) {
        throw new Error('unreachable code');
    };
    /**
     * @param {?} mode
     * @param {?} interpolationConfig
     * @return {?}
     */
    _Visitor.prototype._init = function (mode, interpolationConfig) {
        this._mode = mode;
        this._inI18nBlock = false;
        this._inI18nNode = false;
        this._depth = 0;
        this._inIcu = false;
        this._msgCountAtSectionStart = undefined;
        this._errors = [];
        this._messages = [];
        this._inImplicitNode = false;
        this._createI18nMessage = createI18nMessageFactory(interpolationConfig);
    };
    /**
     * @param {?} el
     * @return {?}
     */
    _Visitor.prototype._visitAttributesOf = function (el) {
        var _this = this;
        var /** @type {?} */ explicitAttrNameToValue = {};
        var /** @type {?} */ implicitAttrNames = this._implicitAttrs[el.name] || [];
        el.attrs.filter(function (attr) { return attr.name.startsWith(_I18N_ATTR_PREFIX); })
            .forEach(function (attr) { return explicitAttrNameToValue[attr.name.slice(_I18N_ATTR_PREFIX.length)] =
            attr.value; });
        el.attrs.forEach(function (attr) {
            if (attr.name in explicitAttrNameToValue) {
                _this._addMessage([attr], explicitAttrNameToValue[attr.name]);
            }
            else if (implicitAttrNames.some(function (name) { return attr.name === name; })) {
                _this._addMessage([attr]);
            }
        });
    };
    /**
     * @param {?} ast
     * @param {?=} msgMeta
     * @return {?}
     */
    _Visitor.prototype._addMessage = function (ast, msgMeta) {
        if (ast.length == 0 ||
            ast.length == 1 && ast[0] instanceof Attribute$1 && !((ast[0])).value) {
            // Do not create empty messages
            return null;
        }
        var _a = _parseMessageMeta(msgMeta), meaning = _a.meaning, description = _a.description, id = _a.id;
        var /** @type {?} */ message = this._createI18nMessage(ast, meaning, description, id);
        this._messages.push(message);
        return message;
    };
    /**
     * @param {?} el
     * @param {?} message
     * @return {?}
     */
    _Visitor.prototype._translateMessage = function (el, message) {
        if (message && this._mode === _VisitorMode.Merge) {
            var /** @type {?} */ nodes = this._translations.get(message);
            if (nodes) {
                return nodes;
            }
            this._reportError(el, "Translation unavailable for message id=\"" + this._translations.digest(message) + "\"");
        }
        return [];
    };
    /**
     * @param {?} el
     * @return {?}
     */
    _Visitor.prototype._translateAttributes = function (el) {
        var _this = this;
        var /** @type {?} */ attributes = el.attrs;
        var /** @type {?} */ i18nParsedMessageMeta = {};
        attributes.forEach(function (attr) {
            if (attr.name.startsWith(_I18N_ATTR_PREFIX)) {
                i18nParsedMessageMeta[attr.name.slice(_I18N_ATTR_PREFIX.length)] =
                    _parseMessageMeta(attr.value);
            }
        });
        var /** @type {?} */ translatedAttributes = [];
        attributes.forEach(function (attr) {
            if (attr.name === _I18N_ATTR || attr.name.startsWith(_I18N_ATTR_PREFIX)) {
                // strip i18n specific attributes
                return;
            }
            if (attr.value && attr.value != '' && i18nParsedMessageMeta.hasOwnProperty(attr.name)) {
                var _a = i18nParsedMessageMeta[attr.name], meaning = _a.meaning, description = _a.description, id = _a.id;
                var /** @type {?} */ message = _this._createI18nMessage([attr], meaning, description, id);
                var /** @type {?} */ nodes = _this._translations.get(message);
                if (nodes) {
                    if (nodes.length == 0) {
                        translatedAttributes.push(new Attribute$1(attr.name, '', attr.sourceSpan));
                    }
                    else if (nodes[0] instanceof Text) {
                        var /** @type {?} */ value = ((nodes[0])).value;
                        translatedAttributes.push(new Attribute$1(attr.name, value, attr.sourceSpan));
                    }
                    else {
                        _this._reportError(el, "Unexpected translation for attribute \"" + attr.name + "\" (id=\"" + (id || _this._translations.digest(message)) + "\")");
                    }
                }
                else {
                    _this._reportError(el, "Translation unavailable for attribute \"" + attr.name + "\" (id=\"" + (id || _this._translations.digest(message)) + "\")");
                }
            }
            else {
                translatedAttributes.push(attr);
            }
        });
        return translatedAttributes;
    };
    /**
     * Add the node as a child of the block when:
     * - we are in a block,
     * - we are not inside a ICU message (those are handled separately),
     * - the node is a "direct child" of the block
     * @param {?} node
     * @return {?}
     */
    _Visitor.prototype._mayBeAddBlockChildren = function (node) {
        if (this._inI18nBlock && !this._inIcu && this._depth == this._blockStartDepth) {
            this._blockChildren.push(node);
        }
    };
    /**
     * Marks the start of a section, see `_closeTranslatableSection`
     * @param {?} node
     * @return {?}
     */
    _Visitor.prototype._openTranslatableSection = function (node) {
        if (this._isInTranslatableSection) {
            this._reportError(node, 'Unexpected section start');
        }
        else {
            this._msgCountAtSectionStart = this._messages.length;
        }
    };
    Object.defineProperty(_Visitor.prototype, "_isInTranslatableSection", {
        /**
         * A translatable section could be:
         * - the content of translatable element,
         * - nodes between `<!-- i18n -->` and `<!-- /i18n -->` comments
         * @return {?}
         */
        get: function () {
            return this._msgCountAtSectionStart !== void 0;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Terminates a section.
     *
     * If a section has only one significant children (comments not significant) then we should not
     * keep the message from this children:
     *
     * `<p i18n="meaning|description">{ICU message}</p>` would produce two messages:
     * - one for the <p> content with meaning and description,
     * - another one for the ICU message.
     *
     * In this case the last message is discarded as it contains less information (the AST is
     * otherwise identical).
     *
     * Note that we should still keep messages extracted from attributes inside the section (ie in the
     * ICU message here)
     * @param {?} node
     * @param {?} directChildren
     * @return {?}
     */
    _Visitor.prototype._closeTranslatableSection = function (node, directChildren) {
        if (!this._isInTranslatableSection) {
            this._reportError(node, 'Unexpected section end');
            return;
        }
        var /** @type {?} */ startIndex = this._msgCountAtSectionStart;
        var /** @type {?} */ significantChildren = directChildren.reduce(function (count, node) { return count + (node instanceof Comment ? 0 : 1); }, 0);
        if (significantChildren == 1) {
            for (var /** @type {?} */ i = this._messages.length - 1; i >= startIndex; i--) {
                var /** @type {?} */ ast = this._messages[i].nodes;
                if (!(ast.length == 1 && ast[0] instanceof Text$1)) {
                    this._messages.splice(i, 1);
                    break;
                }
            }
        }
        this._msgCountAtSectionStart = undefined;
    };
    /**
     * @param {?} node
     * @param {?} msg
     * @return {?}
     */
    _Visitor.prototype._reportError = function (node, msg) {
        this._errors.push(new I18nError(/** @type {?} */ ((node.sourceSpan)), msg));
    };
    return _Visitor;
}());
/**
 * @param {?} n
 * @return {?}
 */
function _isOpeningComment(n) {
    return !!(n instanceof Comment && n.value && n.value.startsWith('i18n'));
}
/**
 * @param {?} n
 * @return {?}
 */
function _isClosingComment(n) {
    return !!(n instanceof Comment && n.value && n.value === '/i18n');
}
/**
 * @param {?} p
 * @return {?}
 */
function _getI18nAttr(p) {
    return p.attrs.find(function (attr) { return attr.name === _I18N_ATTR; }) || null;
}
/**
 * @param {?=} i18n
 * @return {?}
 */
function _parseMessageMeta(i18n) {
    if (!i18n)
        return { meaning: '', description: '', id: '' };
    var /** @type {?} */ idIndex = i18n.indexOf(ID_SEPARATOR);
    var /** @type {?} */ descIndex = i18n.indexOf(MEANING_SEPARATOR);
    var _a = (idIndex > -1) ? [i18n.slice(0, idIndex), i18n.slice(idIndex + 2)] : [i18n, ''], meaningAndDesc = _a[0], id = _a[1];
    var _b = (descIndex > -1) ?
        [meaningAndDesc.slice(0, descIndex), meaningAndDesc.slice(descIndex + 1)] :
        ['', meaningAndDesc], meaning = _b[0], description = _b[1];
    return { meaning: meaning, description: description, id: id };
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var XmlTagDefinition = (function () {
    function XmlTagDefinition() {
        this.closedByParent = false;
        this.contentType = TagContentType.PARSABLE_DATA;
        this.isVoid = false;
        this.ignoreFirstLf = false;
        this.canSelfClose = true;
    }
    /**
     * @param {?} currentParent
     * @return {?}
     */
    XmlTagDefinition.prototype.requireExtraParent = function (currentParent) { return false; };
    /**
     * @param {?} name
     * @return {?}
     */
    XmlTagDefinition.prototype.isClosedByChild = function (name) { return false; };
    return XmlTagDefinition;
}());
var _TAG_DEFINITION = new XmlTagDefinition();
/**
 * @param {?} tagName
 * @return {?}
 */
function getXmlTagDefinition(tagName) {
    return _TAG_DEFINITION;
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var XmlParser = (function (_super) {
    __extends(XmlParser, _super);
    function XmlParser() {
        return _super.call(this, getXmlTagDefinition) || this;
    }
    /**
     * @param {?} source
     * @param {?} url
     * @param {?=} parseExpansionForms
     * @return {?}
     */
    XmlParser.prototype.parse = function (source, url, parseExpansionForms) {
        if (parseExpansionForms === void 0) { parseExpansionForms = false; }
        return _super.prototype.parse.call(this, source, url, parseExpansionForms);
    };
    return XmlParser;
}(Parser$1));
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @param {?} message
 * @return {?}
 */
function digest(message) {
    return message.id || sha1(serializeNodes(message.nodes).join('') + ("[" + message.meaning + "]"));
}
/**
 * @param {?} message
 * @return {?}
 */
function decimalDigest(message) {
    if (message.id) {
        return message.id;
    }
    var /** @type {?} */ visitor = new _SerializerIgnoreIcuExpVisitor();
    var /** @type {?} */ parts = message.nodes.map(function (a) { return a.visit(visitor, null); });
    return computeMsgId(parts.join(''), message.meaning);
}
/**
 * Serialize the i18n ast to something xml-like in order to generate an UID.
 *
 * The visitor is also used in the i18n parser tests
 *
 * \@internal
 */
var _SerializerVisitor = (function () {
    function _SerializerVisitor() {
    }
    /**
     * @param {?} text
     * @param {?} context
     * @return {?}
     */
    _SerializerVisitor.prototype.visitText = function (text, context) { return text.value; };
    /**
     * @param {?} container
     * @param {?} context
     * @return {?}
     */
    _SerializerVisitor.prototype.visitContainer = function (container, context) {
        var _this = this;
        return "[" + container.children.map(function (child) { return child.visit(_this); }).join(', ') + "]";
    };
    /**
     * @param {?} icu
     * @param {?} context
     * @return {?}
     */
    _SerializerVisitor.prototype.visitIcu = function (icu, context) {
        var _this = this;
        var /** @type {?} */ strCases = Object.keys(icu.cases).map(function (k) { return k + " {" + icu.cases[k].visit(_this) + "}"; });
        return "{" + icu.expression + ", " + icu.type + ", " + strCases.join(', ') + "}";
    };
    /**
     * @param {?} ph
     * @param {?} context
     * @return {?}
     */
    _SerializerVisitor.prototype.visitTagPlaceholder = function (ph, context) {
        var _this = this;
        return ph.isVoid ?
            "<ph tag name=\"" + ph.startName + "\"/>" :
            "<ph tag name=\"" + ph.startName + "\">" + ph.children.map(function (child) { return child.visit(_this); }).join(', ') + "</ph name=\"" + ph.closeName + "\">";
    };
    /**
     * @param {?} ph
     * @param {?} context
     * @return {?}
     */
    _SerializerVisitor.prototype.visitPlaceholder = function (ph, context) {
        return ph.value ? "<ph name=\"" + ph.name + "\">" + ph.value + "</ph>" : "<ph name=\"" + ph.name + "\"/>";
    };
    /**
     * @param {?} ph
     * @param {?=} context
     * @return {?}
     */
    _SerializerVisitor.prototype.visitIcuPlaceholder = function (ph, context) {
        return "<ph icu name=\"" + ph.name + "\">" + ph.value.visit(this) + "</ph>";
    };
    return _SerializerVisitor;
}());
var serializerVisitor = new _SerializerVisitor();
/**
 * @param {?} nodes
 * @return {?}
 */
function serializeNodes(nodes) {
    return nodes.map(function (a) { return a.visit(serializerVisitor, null); });
}
/**
 * Serialize the i18n ast to something xml-like in order to generate an UID.
 *
 * Ignore the ICU expressions so that message IDs stays identical if only the expression changes.
 *
 * \@internal
 */
var _SerializerIgnoreIcuExpVisitor = (function (_super) {
    __extends(_SerializerIgnoreIcuExpVisitor, _super);
    function _SerializerIgnoreIcuExpVisitor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @param {?} icu
     * @param {?} context
     * @return {?}
     */
    _SerializerIgnoreIcuExpVisitor.prototype.visitIcu = function (icu, context) {
        var _this = this;
        var /** @type {?} */ strCases = Object.keys(icu.cases).map(function (k) { return k + " {" + icu.cases[k].visit(_this) + "}"; });
        // Do not take the expression into account
        return "{" + icu.type + ", " + strCases.join(', ') + "}";
    };
    return _SerializerIgnoreIcuExpVisitor;
}(_SerializerVisitor));
/**
 * Compute the SHA1 of the given string
 *
 * see http://csrc.nist.gov/publications/fips/fips180-4/fips-180-4.pdf
 *
 * WARNING: this function has not been designed not tested with security in mind.
 *          DO NOT USE IT IN A SECURITY SENSITIVE CONTEXT.
 * @param {?} str
 * @return {?}
 */
function sha1(str) {
    var /** @type {?} */ utf8 = utf8Encode(str);
    var /** @type {?} */ words32 = stringToWords32(utf8, Endian.Big);
    var /** @type {?} */ len = utf8.length * 8;
    var /** @type {?} */ w = new Array(80);
    var _a = [0x67452301, 0xefcdab89, 0x98badcfe, 0x10325476, 0xc3d2e1f0], a = _a[0], b = _a[1], c = _a[2], d = _a[3], e = _a[4];
    words32[len >> 5] |= 0x80 << (24 - len % 32);
    words32[((len + 64 >> 9) << 4) + 15] = len;
    for (var /** @type {?} */ i = 0; i < words32.length; i += 16) {
        var _b = [a, b, c, d, e], h0 = _b[0], h1 = _b[1], h2 = _b[2], h3 = _b[3], h4 = _b[4];
        for (var /** @type {?} */ j = 0; j < 80; j++) {
            if (j < 16) {
                w[j] = words32[i + j];
            }
            else {
                w[j] = rol32(w[j - 3] ^ w[j - 8] ^ w[j - 14] ^ w[j - 16], 1);
            }
            var _c = fk(j, b, c, d), f = _c[0], k = _c[1];
            var /** @type {?} */ temp = [rol32(a, 5), f, e, k, w[j]].reduce(add32);
            _d = [d, c, rol32(b, 30), a, temp], e = _d[0], d = _d[1], c = _d[2], b = _d[3], a = _d[4];
        }
        _e = [add32(a, h0), add32(b, h1), add32(c, h2), add32(d, h3), add32(e, h4)], a = _e[0], b = _e[1], c = _e[2], d = _e[3], e = _e[4];
    }
    return byteStringToHexString(words32ToByteString([a, b, c, d, e]));
    var _d, _e;
}
/**
 * @param {?} index
 * @param {?} b
 * @param {?} c
 * @param {?} d
 * @return {?}
 */
function fk(index, b, c, d) {
    if (index < 20) {
        return [(b & c) | (~b & d), 0x5a827999];
    }
    if (index < 40) {
        return [b ^ c ^ d, 0x6ed9eba1];
    }
    if (index < 60) {
        return [(b & c) | (b & d) | (c & d), 0x8f1bbcdc];
    }
    return [b ^ c ^ d, 0xca62c1d6];
}
/**
 * Compute the fingerprint of the given string
 *
 * The output is 64 bit number encoded as a decimal string
 *
 * based on:
 * https://github.com/google/closure-compiler/blob/master/src/com/google/javascript/jscomp/GoogleJsMessageIdGenerator.java
 * @param {?} str
 * @return {?}
 */
function fingerprint(str) {
    var /** @type {?} */ utf8 = utf8Encode(str);
    var _a = [hash32(utf8, 0), hash32(utf8, 102072)], hi = _a[0], lo = _a[1];
    if (hi == 0 && (lo == 0 || lo == 1)) {
        hi = hi ^ 0x130f9bef;
        lo = lo ^ -0x6b5f56d8;
    }
    return [hi, lo];
}
/**
 * @param {?} msg
 * @param {?} meaning
 * @return {?}
 */
function computeMsgId(msg, meaning) {
    var _a = fingerprint(msg), hi = _a[0], lo = _a[1];
    if (meaning) {
        var _b = fingerprint(meaning), him = _b[0], lom = _b[1];
        _c = add64(rol64([hi, lo], 1), [him, lom]), hi = _c[0], lo = _c[1];
    }
    return byteStringToDecString(words32ToByteString([hi & 0x7fffffff, lo]));
    var _c;
}
/**
 * @param {?} str
 * @param {?} c
 * @return {?}
 */
function hash32(str, c) {
    var _a = [0x9e3779b9, 0x9e3779b9], a = _a[0], b = _a[1];
    var /** @type {?} */ i;
    var /** @type {?} */ len = str.length;
    for (i = 0; i + 12 <= len; i += 12) {
        a = add32(a, wordAt(str, i, Endian.Little));
        b = add32(b, wordAt(str, i + 4, Endian.Little));
        c = add32(c, wordAt(str, i + 8, Endian.Little));
        _b = mix([a, b, c]), a = _b[0], b = _b[1], c = _b[2];
    }
    a = add32(a, wordAt(str, i, Endian.Little));
    b = add32(b, wordAt(str, i + 4, Endian.Little));
    // the first byte of c is reserved for the length
    c = add32(c, len);
    c = add32(c, wordAt(str, i + 8, Endian.Little) << 8);
    return mix([a, b, c])[2];
    var _b;
}
/**
 * @param {?} __0
 * @return {?}
 */
function mix(_a) {
    var a = _a[0], b = _a[1], c = _a[2];
    a = sub32(a, b);
    a = sub32(a, c);
    a ^= c >>> 13;
    b = sub32(b, c);
    b = sub32(b, a);
    b ^= a << 8;
    c = sub32(c, a);
    c = sub32(c, b);
    c ^= b >>> 13;
    a = sub32(a, b);
    a = sub32(a, c);
    a ^= c >>> 12;
    b = sub32(b, c);
    b = sub32(b, a);
    b ^= a << 16;
    c = sub32(c, a);
    c = sub32(c, b);
    c ^= b >>> 5;
    a = sub32(a, b);
    a = sub32(a, c);
    a ^= c >>> 3;
    b = sub32(b, c);
    b = sub32(b, a);
    b ^= a << 10;
    c = sub32(c, a);
    c = sub32(c, b);
    c ^= b >>> 15;
    return [a, b, c];
}
var Endian = {};
Endian.Little = 0;
Endian.Big = 1;
Endian[Endian.Little] = "Little";
Endian[Endian.Big] = "Big";
/**
 * @param {?} a
 * @param {?} b
 * @return {?}
 */
function add32(a, b) {
    return add32to64(a, b)[1];
}
/**
 * @param {?} a
 * @param {?} b
 * @return {?}
 */
function add32to64(a, b) {
    var /** @type {?} */ low = (a & 0xffff) + (b & 0xffff);
    var /** @type {?} */ high = (a >>> 16) + (b >>> 16) + (low >>> 16);
    return [high >>> 16, (high << 16) | (low & 0xffff)];
}
/**
 * @param {?} __0
 * @param {?} __1
 * @return {?}
 */
function add64(_a, _b) {
    var ah = _a[0], al = _a[1];
    var bh = _b[0], bl = _b[1];
    var _c = add32to64(al, bl), carry = _c[0], l = _c[1];
    var /** @type {?} */ h = add32(add32(ah, bh), carry);
    return [h, l];
}
/**
 * @param {?} a
 * @param {?} b
 * @return {?}
 */
function sub32(a, b) {
    var /** @type {?} */ low = (a & 0xffff) - (b & 0xffff);
    var /** @type {?} */ high = (a >> 16) - (b >> 16) + (low >> 16);
    return (high << 16) | (low & 0xffff);
}
/**
 * @param {?} a
 * @param {?} count
 * @return {?}
 */
function rol32(a, count) {
    return (a << count) | (a >>> (32 - count));
}
/**
 * @param {?} __0
 * @param {?} count
 * @return {?}
 */
function rol64(_a, count) {
    var hi = _a[0], lo = _a[1];
    var /** @type {?} */ h = (hi << count) | (lo >>> (32 - count));
    var /** @type {?} */ l = (lo << count) | (hi >>> (32 - count));
    return [h, l];
}
/**
 * @param {?} str
 * @param {?} endian
 * @return {?}
 */
function stringToWords32(str, endian) {
    var /** @type {?} */ words32 = Array((str.length + 3) >>> 2);
    for (var /** @type {?} */ i = 0; i < words32.length; i++) {
        words32[i] = wordAt(str, i * 4, endian);
    }
    return words32;
}
/**
 * @param {?} str
 * @param {?} index
 * @return {?}
 */
function byteAt(str, index) {
    return index >= str.length ? 0 : str.charCodeAt(index) & 0xff;
}
/**
 * @param {?} str
 * @param {?} index
 * @param {?} endian
 * @return {?}
 */
function wordAt(str, index, endian) {
    var /** @type {?} */ word = 0;
    if (endian === Endian.Big) {
        for (var /** @type {?} */ i = 0; i < 4; i++) {
            word += byteAt(str, index + i) << (24 - 8 * i);
        }
    }
    else {
        for (var /** @type {?} */ i = 0; i < 4; i++) {
            word += byteAt(str, index + i) << 8 * i;
        }
    }
    return word;
}
/**
 * @param {?} words32
 * @return {?}
 */
function words32ToByteString(words32) {
    return words32.reduce(function (str, word) { return str + word32ToByteString(word); }, '');
}
/**
 * @param {?} word
 * @return {?}
 */
function word32ToByteString(word) {
    var /** @type {?} */ str = '';
    for (var /** @type {?} */ i = 0; i < 4; i++) {
        str += String.fromCharCode((word >>> 8 * (3 - i)) & 0xff);
    }
    return str;
}
/**
 * @param {?} str
 * @return {?}
 */
function byteStringToHexString(str) {
    var /** @type {?} */ hex = '';
    for (var /** @type {?} */ i = 0; i < str.length; i++) {
        var /** @type {?} */ b = byteAt(str, i);
        hex += (b >>> 4).toString(16) + (b & 0x0f).toString(16);
    }
    return hex.toLowerCase();
}
/**
 * @param {?} str
 * @return {?}
 */
function byteStringToDecString(str) {
    var /** @type {?} */ decimal = '';
    var /** @type {?} */ toThePower = '1';
    for (var /** @type {?} */ i = str.length - 1; i >= 0; i--) {
        decimal = addBigInt(decimal, numberTimesBigInt(byteAt(str, i), toThePower));
        toThePower = numberTimesBigInt(256, toThePower);
    }
    return decimal.split('').reverse().join('');
}
/**
 * @param {?} x
 * @param {?} y
 * @return {?}
 */
function addBigInt(x, y) {
    var /** @type {?} */ sum = '';
    var /** @type {?} */ len = Math.max(x.length, y.length);
    for (var /** @type {?} */ i = 0, /** @type {?} */ carry = 0; i < len || carry; i++) {
        var /** @type {?} */ tmpSum = carry + +(x[i] || 0) + +(y[i] || 0);
        if (tmpSum >= 10) {
            carry = 1;
            sum += tmpSum - 10;
        }
        else {
            carry = 0;
            sum += tmpSum;
        }
    }
    return sum;
}
/**
 * @param {?} num
 * @param {?} b
 * @return {?}
 */
function numberTimesBigInt(num, b) {
    var /** @type {?} */ product = '';
    var /** @type {?} */ bToThePower = b;
    for (; num !== 0; num = num >>> 1) {
        if (num & 1)
            product = addBigInt(product, bToThePower);
        bToThePower = addBigInt(bToThePower, bToThePower);
    }
    return product;
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @abstract
 */
var Serializer = (function () {
    function Serializer() {
    }
    /**
     * @abstract
     * @param {?} messages
     * @param {?} locale
     * @return {?}
     */
    Serializer.prototype.write = function (messages, locale) { };
    /**
     * @abstract
     * @param {?} content
     * @param {?} url
     * @return {?}
     */
    Serializer.prototype.load = function (content, url) { };
    /**
     * @abstract
     * @param {?} message
     * @return {?}
     */
    Serializer.prototype.digest = function (message) { };
    /**
     * @param {?} message
     * @return {?}
     */
    Serializer.prototype.createNameMapper = function (message) { return null; };
    return Serializer;
}());
/**
 * A simple mapper that take a function to transform an internal name to a public name
 */
var SimplePlaceholderMapper = (function (_super) {
    __extends(SimplePlaceholderMapper, _super);
    /**
     * @param {?} message
     * @param {?} mapName
     */
    function SimplePlaceholderMapper(message, mapName) {
        var _this = _super.call(this) || this;
        _this.mapName = mapName;
        _this.internalToPublic = {};
        _this.publicToNextId = {};
        _this.publicToInternal = {};
        message.nodes.forEach(function (node) { return node.visit(_this); });
        return _this;
    }
    /**
     * @param {?} internalName
     * @return {?}
     */
    SimplePlaceholderMapper.prototype.toPublicName = function (internalName) {
        return this.internalToPublic.hasOwnProperty(internalName) ?
            this.internalToPublic[internalName] :
            null;
    };
    /**
     * @param {?} publicName
     * @return {?}
     */
    SimplePlaceholderMapper.prototype.toInternalName = function (publicName) {
        return this.publicToInternal.hasOwnProperty(publicName) ? this.publicToInternal[publicName] :
            null;
    };
    /**
     * @param {?} text
     * @param {?=} context
     * @return {?}
     */
    SimplePlaceholderMapper.prototype.visitText = function (text, context) { return null; };
    /**
     * @param {?} ph
     * @param {?=} context
     * @return {?}
     */
    SimplePlaceholderMapper.prototype.visitTagPlaceholder = function (ph, context) {
        this.visitPlaceholderName(ph.startName);
        _super.prototype.visitTagPlaceholder.call(this, ph, context);
        this.visitPlaceholderName(ph.closeName);
    };
    /**
     * @param {?} ph
     * @param {?=} context
     * @return {?}
     */
    SimplePlaceholderMapper.prototype.visitPlaceholder = function (ph, context) { this.visitPlaceholderName(ph.name); };
    /**
     * @param {?} ph
     * @param {?=} context
     * @return {?}
     */
    SimplePlaceholderMapper.prototype.visitIcuPlaceholder = function (ph, context) {
        this.visitPlaceholderName(ph.name);
    };
    /**
     * @param {?} internalName
     * @return {?}
     */
    SimplePlaceholderMapper.prototype.visitPlaceholderName = function (internalName) {
        if (!internalName || this.internalToPublic.hasOwnProperty(internalName)) {
            return;
        }
        var /** @type {?} */ publicName = this.mapName(internalName);
        if (this.publicToInternal.hasOwnProperty(publicName)) {
            // Create a new XMB when it has already been used
            var /** @type {?} */ nextId = this.publicToNextId[publicName];
            this.publicToNextId[publicName] = nextId + 1;
            publicName = publicName + "_" + nextId;
        }
        else {
            this.publicToNextId[publicName] = 1;
        }
        this.internalToPublic[internalName] = publicName;
        this.publicToInternal[publicName] = internalName;
    };
    return SimplePlaceholderMapper;
}(RecurseVisitor));
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var _Visitor$1 = (function () {
    function _Visitor$1() {
    }
    /**
     * @param {?} tag
     * @return {?}
     */
    _Visitor$1.prototype.visitTag = function (tag) {
        var _this = this;
        var /** @type {?} */ strAttrs = this._serializeAttributes(tag.attrs);
        if (tag.children.length == 0) {
            return "<" + tag.name + strAttrs + "/>";
        }
        var /** @type {?} */ strChildren = tag.children.map(function (node) { return node.visit(_this); });
        return "<" + tag.name + strAttrs + ">" + strChildren.join('') + "</" + tag.name + ">";
    };
    /**
     * @param {?} text
     * @return {?}
     */
    _Visitor$1.prototype.visitText = function (text) { return text.value; };
    /**
     * @param {?} decl
     * @return {?}
     */
    _Visitor$1.prototype.visitDeclaration = function (decl) {
        return "<?xml" + this._serializeAttributes(decl.attrs) + " ?>";
    };
    /**
     * @param {?} attrs
     * @return {?}
     */
    _Visitor$1.prototype._serializeAttributes = function (attrs) {
        var /** @type {?} */ strAttrs = Object.keys(attrs).map(function (name) { return name + "=\"" + attrs[name] + "\""; }).join(' ');
        return strAttrs.length > 0 ? ' ' + strAttrs : '';
    };
    /**
     * @param {?} doctype
     * @return {?}
     */
    _Visitor$1.prototype.visitDoctype = function (doctype) {
        return "<!DOCTYPE " + doctype.rootTag + " [\n" + doctype.dtd + "\n]>";
    };
    return _Visitor$1;
}());
var _visitor = new _Visitor$1();
/**
 * @param {?} nodes
 * @return {?}
 */
function serialize(nodes) {
    return nodes.map(function (node) { return node.visit(_visitor); }).join('');
}
var Declaration = (function () {
    /**
     * @param {?} unescapedAttrs
     */
    function Declaration(unescapedAttrs) {
        var _this = this;
        this.attrs = {};
        Object.keys(unescapedAttrs).forEach(function (k) {
            _this.attrs[k] = _escapeXml(unescapedAttrs[k]);
        });
    }
    /**
     * @param {?} visitor
     * @return {?}
     */
    Declaration.prototype.visit = function (visitor) { return visitor.visitDeclaration(this); };
    return Declaration;
}());
var Doctype = (function () {
    /**
     * @param {?} rootTag
     * @param {?} dtd
     */
    function Doctype(rootTag, dtd) {
        this.rootTag = rootTag;
        this.dtd = dtd;
    }
    ;
    /**
     * @param {?} visitor
     * @return {?}
     */
    Doctype.prototype.visit = function (visitor) { return visitor.visitDoctype(this); };
    return Doctype;
}());
var Tag = (function () {
    /**
     * @param {?} name
     * @param {?=} unescapedAttrs
     * @param {?=} children
     */
    function Tag(name, unescapedAttrs, children) {
        if (unescapedAttrs === void 0) { unescapedAttrs = {}; }
        if (children === void 0) { children = []; }
        var _this = this;
        this.name = name;
        this.children = children;
        this.attrs = {};
        Object.keys(unescapedAttrs).forEach(function (k) {
            _this.attrs[k] = _escapeXml(unescapedAttrs[k]);
        });
    }
    /**
     * @param {?} visitor
     * @return {?}
     */
    Tag.prototype.visit = function (visitor) { return visitor.visitTag(this); };
    return Tag;
}());
var Text$2 = (function () {
    /**
     * @param {?} unescapedValue
     */
    function Text$2(unescapedValue) {
        this.value = _escapeXml(unescapedValue);
    }
    ;
    /**
     * @param {?} visitor
     * @return {?}
     */
    Text$2.prototype.visit = function (visitor) { return visitor.visitText(this); };
    return Text$2;
}());
var CR = (function (_super) {
    __extends(CR, _super);
    /**
     * @param {?=} ws
     */
    function CR(ws) {
        if (ws === void 0) { ws = 0; }
        return _super.call(this, "\n" + new Array(ws + 1).join(' ')) || this;
    }
    return CR;
}(Text$2));
var _ESCAPED_CHARS = [
    [/&/g, '&amp;'],
    [/"/g, '&quot;'],
    [/'/g, '&apos;'],
    [/</g, '&lt;'],
    [/>/g, '&gt;'],
];
/**
 * @param {?} text
 * @return {?}
 */
function _escapeXml(text) {
    return _ESCAPED_CHARS.reduce(function (text, entry) { return text.replace(entry[0], entry[1]); }, text);
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var _VERSION = '1.2';
var _XMLNS = 'urn:oasis:names:tc:xliff:document:1.2';
// TODO(vicb): make this a param (s/_/-/)
var _DEFAULT_SOURCE_LANG = 'en';
var _PLACEHOLDER_TAG = 'x';
var _FILE_TAG = 'file';
var _SOURCE_TAG = 'source';
var _TARGET_TAG = 'target';
var _UNIT_TAG = 'trans-unit';
var _CONTEXT_GROUP_TAG = 'context-group';
var _CONTEXT_TAG = 'context';
var Xliff = (function (_super) {
    __extends(Xliff, _super);
    function Xliff() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @param {?} messages
     * @param {?} locale
     * @return {?}
     */
    Xliff.prototype.write = function (messages, locale) {
        var /** @type {?} */ visitor = new _WriteVisitor();
        var /** @type {?} */ transUnits = [];
        messages.forEach(function (message) {
            var /** @type {?} */ contextTags = [];
            message.sources.forEach(function (source) {
                var /** @type {?} */ contextGroupTag = new Tag(_CONTEXT_GROUP_TAG, { purpose: 'location' });
                contextGroupTag.children.push(new CR(10), new Tag(_CONTEXT_TAG, { 'context-type': 'sourcefile' }, [new Text$2(source.filePath)]), new CR(10), new Tag(_CONTEXT_TAG, { 'context-type': 'linenumber' }, [new Text$2("" + source.startLine)]), new CR(8));
                contextTags.push(new CR(8), contextGroupTag);
            });
            var /** @type {?} */ transUnit = new Tag(_UNIT_TAG, { id: message.id, datatype: 'html' });
            (_a = transUnit.children).push.apply(_a, [new CR(8), new Tag(_SOURCE_TAG, {}, visitor.serialize(message.nodes)), new CR(8), new Tag(_TARGET_TAG)].concat(contextTags));
            if (message.description) {
                transUnit.children.push(new CR(8), new Tag('note', { priority: '1', from: 'description' }, [new Text$2(message.description)]));
            }
            if (message.meaning) {
                transUnit.children.push(new CR(8), new Tag('note', { priority: '1', from: 'meaning' }, [new Text$2(message.meaning)]));
            }
            transUnit.children.push(new CR(6));
            transUnits.push(new CR(6), transUnit);
            var _a;
        });
        var /** @type {?} */ body = new Tag('body', {}, transUnits.concat([new CR(4)]));
        var /** @type {?} */ file = new Tag('file', {
            'source-language': locale || _DEFAULT_SOURCE_LANG,
            datatype: 'plaintext',
            original: 'ng2.template',
        }, [new CR(4), body, new CR(2)]);
        var /** @type {?} */ xliff = new Tag('xliff', { version: _VERSION, xmlns: _XMLNS }, [new CR(2), file, new CR()]);
        return serialize([
            new Declaration({ version: '1.0', encoding: 'UTF-8' }), new CR(), xliff, new CR()
        ]);
    };
    /**
     * @param {?} content
     * @param {?} url
     * @return {?}
     */
    Xliff.prototype.load = function (content, url) {
        // xliff to xml nodes
        var /** @type {?} */ xliffParser = new XliffParser();
        var _a = xliffParser.parse(content, url), locale = _a.locale, msgIdToHtml = _a.msgIdToHtml, errors = _a.errors;
        // xml nodes to i18n nodes
        var /** @type {?} */ i18nNodesByMsgId = {};
        var /** @type {?} */ converter = new XmlToI18n();
        Object.keys(msgIdToHtml).forEach(function (msgId) {
            var _a = converter.convert(msgIdToHtml[msgId], url), i18nNodes = _a.i18nNodes, e = _a.errors;
            errors.push.apply(errors, e);
            i18nNodesByMsgId[msgId] = i18nNodes;
        });
        if (errors.length) {
            throw new Error("xliff parse errors:\n" + errors.join('\n'));
        }
        return { locale: /** @type {?} */ ((locale)), i18nNodesByMsgId: i18nNodesByMsgId };
    };
    /**
     * @param {?} message
     * @return {?}
     */
    Xliff.prototype.digest = function (message) { return digest(message); };
    return Xliff;
}(Serializer));
var _WriteVisitor = (function () {
    function _WriteVisitor() {
    }
    /**
     * @param {?} text
     * @param {?=} context
     * @return {?}
     */
    _WriteVisitor.prototype.visitText = function (text, context) { return [new Text$2(text.value)]; };
    /**
     * @param {?} container
     * @param {?=} context
     * @return {?}
     */
    _WriteVisitor.prototype.visitContainer = function (container, context) {
        var _this = this;
        var /** @type {?} */ nodes = [];
        container.children.forEach(function (node) { return nodes.push.apply(nodes, node.visit(_this)); });
        return nodes;
    };
    /**
     * @param {?} icu
     * @param {?=} context
     * @return {?}
     */
    _WriteVisitor.prototype.visitIcu = function (icu, context) {
        var _this = this;
        var /** @type {?} */ nodes = [new Text$2("{" + icu.expressionPlaceholder + ", " + icu.type + ", ")];
        Object.keys(icu.cases).forEach(function (c) {
            nodes.push.apply(nodes, [new Text$2(c + " {")].concat(icu.cases[c].visit(_this), [new Text$2("} ")]));
        });
        nodes.push(new Text$2("}"));
        return nodes;
    };
    /**
     * @param {?} ph
     * @param {?=} context
     * @return {?}
     */
    _WriteVisitor.prototype.visitTagPlaceholder = function (ph, context) {
        var /** @type {?} */ ctype = getCtypeForTag(ph.tag);
        var /** @type {?} */ startTagPh = new Tag(_PLACEHOLDER_TAG, { id: ph.startName, ctype: ctype });
        if (ph.isVoid) {
            // void tags have no children nor closing tags
            return [startTagPh];
        }
        var /** @type {?} */ closeTagPh = new Tag(_PLACEHOLDER_TAG, { id: ph.closeName, ctype: ctype });
        return [startTagPh].concat(this.serialize(ph.children), [closeTagPh]);
    };
    /**
     * @param {?} ph
     * @param {?=} context
     * @return {?}
     */
    _WriteVisitor.prototype.visitPlaceholder = function (ph, context) {
        return [new Tag(_PLACEHOLDER_TAG, { id: ph.name })];
    };
    /**
     * @param {?} ph
     * @param {?=} context
     * @return {?}
     */
    _WriteVisitor.prototype.visitIcuPlaceholder = function (ph, context) {
        return [new Tag(_PLACEHOLDER_TAG, { id: ph.name })];
    };
    /**
     * @param {?} nodes
     * @return {?}
     */
    _WriteVisitor.prototype.serialize = function (nodes) {
        var _this = this;
        return [].concat.apply([], nodes.map(function (node) { return node.visit(_this); }));
    };
    return _WriteVisitor;
}());
var XliffParser = (function () {
    function XliffParser() {
        this._locale = null;
    }
    /**
     * @param {?} xliff
     * @param {?} url
     * @return {?}
     */
    XliffParser.prototype.parse = function (xliff, url) {
        this._unitMlString = null;
        this._msgIdToHtml = {};
        var /** @type {?} */ xml = new XmlParser().parse(xliff, url, false);
        this._errors = xml.errors;
        visitAll(this, xml.rootNodes, null);
        return {
            msgIdToHtml: this._msgIdToHtml,
            errors: this._errors,
            locale: this._locale,
        };
    };
    /**
     * @param {?} element
     * @param {?} context
     * @return {?}
     */
    XliffParser.prototype.visitElement = function (element, context) {
        switch (element.name) {
            case _UNIT_TAG:
                this._unitMlString = ((null));
                var /** @type {?} */ idAttr = element.attrs.find(function (attr) { return attr.name === 'id'; });
                if (!idAttr) {
                    this._addError(element, "<" + _UNIT_TAG + "> misses the \"id\" attribute");
                }
                else {
                    var /** @type {?} */ id = idAttr.value;
                    if (this._msgIdToHtml.hasOwnProperty(id)) {
                        this._addError(element, "Duplicated translations for msg " + id);
                    }
                    else {
                        visitAll(this, element.children, null);
                        if (typeof this._unitMlString === 'string') {
                            this._msgIdToHtml[id] = this._unitMlString;
                        }
                        else {
                            this._addError(element, "Message " + id + " misses a translation");
                        }
                    }
                }
                break;
            case _SOURCE_TAG:
                // ignore source message
                break;
            case _TARGET_TAG:
                var /** @type {?} */ innerTextStart = ((element.startSourceSpan)).end.offset;
                var /** @type {?} */ innerTextEnd = ((element.endSourceSpan)).start.offset;
                var /** @type {?} */ content = ((element.startSourceSpan)).start.file.content;
                var /** @type {?} */ innerText = content.slice(innerTextStart, innerTextEnd);
                this._unitMlString = innerText;
                break;
            case _FILE_TAG:
                var /** @type {?} */ localeAttr = element.attrs.find(function (attr) { return attr.name === 'target-language'; });
                if (localeAttr) {
                    this._locale = localeAttr.value;
                }
                visitAll(this, element.children, null);
                break;
            default:
                // TODO(vicb): assert file structure, xliff version
                // For now only recurse on unhandled nodes
                visitAll(this, element.children, null);
        }
    };
    /**
     * @param {?} attribute
     * @param {?} context
     * @return {?}
     */
    XliffParser.prototype.visitAttribute = function (attribute, context) { };
    /**
     * @param {?} text
     * @param {?} context
     * @return {?}
     */
    XliffParser.prototype.visitText = function (text, context) { };
    /**
     * @param {?} comment
     * @param {?} context
     * @return {?}
     */
    XliffParser.prototype.visitComment = function (comment, context) { };
    /**
     * @param {?} expansion
     * @param {?} context
     * @return {?}
     */
    XliffParser.prototype.visitExpansion = function (expansion, context) { };
    /**
     * @param {?} expansionCase
     * @param {?} context
     * @return {?}
     */
    XliffParser.prototype.visitExpansionCase = function (expansionCase, context) { };
    /**
     * @param {?} node
     * @param {?} message
     * @return {?}
     */
    XliffParser.prototype._addError = function (node, message) {
        this._errors.push(new I18nError(/** @type {?} */ ((node.sourceSpan)), message));
    };
    return XliffParser;
}());
var XmlToI18n = (function () {
    function XmlToI18n() {
    }
    /**
     * @param {?} message
     * @param {?} url
     * @return {?}
     */
    XmlToI18n.prototype.convert = function (message, url) {
        var /** @type {?} */ xmlIcu = new XmlParser().parse(message, url, true);
        this._errors = xmlIcu.errors;
        var /** @type {?} */ i18nNodes = this._errors.length > 0 || xmlIcu.rootNodes.length == 0 ?
            [] :
            visitAll(this, xmlIcu.rootNodes);
        return {
            i18nNodes: i18nNodes,
            errors: this._errors,
        };
    };
    /**
     * @param {?} text
     * @param {?} context
     * @return {?}
     */
    XmlToI18n.prototype.visitText = function (text, context) { return new Text$1(text.value, /** @type {?} */ ((text.sourceSpan))); };
    /**
     * @param {?} el
     * @param {?} context
     * @return {?}
     */
    XmlToI18n.prototype.visitElement = function (el, context) {
        if (el.name === _PLACEHOLDER_TAG) {
            var /** @type {?} */ nameAttr = el.attrs.find(function (attr) { return attr.name === 'id'; });
            if (nameAttr) {
                return new Placeholder('', nameAttr.value, /** @type {?} */ ((el.sourceSpan)));
            }
            this._addError(el, "<" + _PLACEHOLDER_TAG + "> misses the \"id\" attribute");
        }
        else {
            this._addError(el, "Unexpected tag");
        }
        return null;
    };
    /**
     * @param {?} icu
     * @param {?} context
     * @return {?}
     */
    XmlToI18n.prototype.visitExpansion = function (icu, context) {
        var /** @type {?} */ caseMap = {};
        visitAll(this, icu.cases).forEach(function (c) {
            caseMap[c.value] = new Container(c.nodes, icu.sourceSpan);
        });
        return new Icu(icu.switchValue, icu.type, caseMap, icu.sourceSpan);
    };
    /**
     * @param {?} icuCase
     * @param {?} context
     * @return {?}
     */
    XmlToI18n.prototype.visitExpansionCase = function (icuCase, context) {
        return {
            value: icuCase.value,
            nodes: visitAll(this, icuCase.expression),
        };
    };
    /**
     * @param {?} comment
     * @param {?} context
     * @return {?}
     */
    XmlToI18n.prototype.visitComment = function (comment, context) { };
    /**
     * @param {?} attribute
     * @param {?} context
     * @return {?}
     */
    XmlToI18n.prototype.visitAttribute = function (attribute, context) { };
    /**
     * @param {?} node
     * @param {?} message
     * @return {?}
     */
    XmlToI18n.prototype._addError = function (node, message) {
        this._errors.push(new I18nError(/** @type {?} */ ((node.sourceSpan)), message));
    };
    return XmlToI18n;
}());
/**
 * @param {?} tag
 * @return {?}
 */
function getCtypeForTag(tag) {
    switch (tag.toLowerCase()) {
        case 'br':
            return 'lb';
        case 'img':
            return 'image';
        default:
            return "x-" + tag;
    }
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var _VERSION$1 = '2.0';
var _XMLNS$1 = 'urn:oasis:names:tc:xliff:document:2.0';
// TODO(vicb): make this a param (s/_/-/)
var _DEFAULT_SOURCE_LANG$1 = 'en';
var _PLACEHOLDER_TAG$1 = 'ph';
var _PLACEHOLDER_SPANNING_TAG = 'pc';
var _XLIFF_TAG = 'xliff';
var _SOURCE_TAG$1 = 'source';
var _TARGET_TAG$1 = 'target';
var _UNIT_TAG$1 = 'unit';
var Xliff2 = (function (_super) {
    __extends(Xliff2, _super);
    function Xliff2() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @param {?} messages
     * @param {?} locale
     * @return {?}
     */
    Xliff2.prototype.write = function (messages, locale) {
        var /** @type {?} */ visitor = new _WriteVisitor$1();
        var /** @type {?} */ units = [];
        messages.forEach(function (message) {
            var /** @type {?} */ unit = new Tag(_UNIT_TAG$1, { id: message.id });
            if (message.description || message.meaning) {
                var /** @type {?} */ notes = new Tag('notes');
                if (message.description) {
                    notes.children.push(new CR(8), new Tag('note', { category: 'description' }, [new Text$2(message.description)]));
                }
                if (message.meaning) {
                    notes.children.push(new CR(8), new Tag('note', { category: 'meaning' }, [new Text$2(message.meaning)]));
                }
                notes.children.push(new CR(6));
                unit.children.push(new CR(6), notes);
            }
            var /** @type {?} */ segment = new Tag('segment');
            segment.children.push(new CR(8), new Tag(_SOURCE_TAG$1, {}, visitor.serialize(message.nodes)), new CR(6));
            unit.children.push(new CR(6), segment, new CR(4));
            units.push(new CR(4), unit);
        });
        var /** @type {?} */ file = new Tag('file', { 'original': 'ng.template', id: 'ngi18n' }, units.concat([new CR(2)]));
        var /** @type {?} */ xliff = new Tag(_XLIFF_TAG, { version: _VERSION$1, xmlns: _XMLNS$1, srcLang: locale || _DEFAULT_SOURCE_LANG$1 }, [new CR(2), file, new CR()]);
        return serialize([
            new Declaration({ version: '1.0', encoding: 'UTF-8' }), new CR(), xliff, new CR()
        ]);
    };
    /**
     * @param {?} content
     * @param {?} url
     * @return {?}
     */
    Xliff2.prototype.load = function (content, url) {
        // xliff to xml nodes
        var /** @type {?} */ xliff2Parser = new Xliff2Parser();
        var _a = xliff2Parser.parse(content, url), locale = _a.locale, msgIdToHtml = _a.msgIdToHtml, errors = _a.errors;
        // xml nodes to i18n nodes
        var /** @type {?} */ i18nNodesByMsgId = {};
        var /** @type {?} */ converter = new XmlToI18n$1();
        Object.keys(msgIdToHtml).forEach(function (msgId) {
            var _a = converter.convert(msgIdToHtml[msgId], url), i18nNodes = _a.i18nNodes, e = _a.errors;
            errors.push.apply(errors, e);
            i18nNodesByMsgId[msgId] = i18nNodes;
        });
        if (errors.length) {
            throw new Error("xliff2 parse errors:\n" + errors.join('\n'));
        }
        return { locale: /** @type {?} */ ((locale)), i18nNodesByMsgId: i18nNodesByMsgId };
    };
    /**
     * @param {?} message
     * @return {?}
     */
    Xliff2.prototype.digest = function (message) { return decimalDigest(message); };
    return Xliff2;
}(Serializer));
var _WriteVisitor$1 = (function () {
    function _WriteVisitor$1() {
    }
    /**
     * @param {?} text
     * @param {?=} context
     * @return {?}
     */
    _WriteVisitor$1.prototype.visitText = function (text, context) { return [new Text$2(text.value)]; };
    /**
     * @param {?} container
     * @param {?=} context
     * @return {?}
     */
    _WriteVisitor$1.prototype.visitContainer = function (container, context) {
        var _this = this;
        var /** @type {?} */ nodes = [];
        container.children.forEach(function (node) { return nodes.push.apply(nodes, node.visit(_this)); });
        return nodes;
    };
    /**
     * @param {?} icu
     * @param {?=} context
     * @return {?}
     */
    _WriteVisitor$1.prototype.visitIcu = function (icu, context) {
        var _this = this;
        var /** @type {?} */ nodes = [new Text$2("{" + icu.expressionPlaceholder + ", " + icu.type + ", ")];
        Object.keys(icu.cases).forEach(function (c) {
            nodes.push.apply(nodes, [new Text$2(c + " {")].concat(icu.cases[c].visit(_this), [new Text$2("} ")]));
        });
        nodes.push(new Text$2("}"));
        return nodes;
    };
    /**
     * @param {?} ph
     * @param {?=} context
     * @return {?}
     */
    _WriteVisitor$1.prototype.visitTagPlaceholder = function (ph, context) {
        var _this = this;
        var /** @type {?} */ type = getTypeForTag(ph.tag);
        if (ph.isVoid) {
            var /** @type {?} */ tagPh = new Tag(_PLACEHOLDER_TAG$1, {
                id: (this._nextPlaceholderId++).toString(),
                equiv: ph.startName,
                type: type,
                disp: "<" + ph.tag + "/>",
            });
            return [tagPh];
        }
        var /** @type {?} */ tagPc = new Tag(_PLACEHOLDER_SPANNING_TAG, {
            id: (this._nextPlaceholderId++).toString(),
            equivStart: ph.startName,
            equivEnd: ph.closeName,
            type: type,
            dispStart: "<" + ph.tag + ">",
            dispEnd: "</" + ph.tag + ">",
        });
        var /** @type {?} */ nodes = [].concat.apply([], ph.children.map(function (node) { return node.visit(_this); }));
        if (nodes.length) {
            nodes.forEach(function (node) { return tagPc.children.push(node); });
        }
        else {
            tagPc.children.push(new Text$2(''));
        }
        return [tagPc];
    };
    /**
     * @param {?} ph
     * @param {?=} context
     * @return {?}
     */
    _WriteVisitor$1.prototype.visitPlaceholder = function (ph, context) {
        return [new Tag(_PLACEHOLDER_TAG$1, {
                id: (this._nextPlaceholderId++).toString(),
                equiv: ph.name,
                disp: "{{" + ph.value + "}}",
            })];
    };
    /**
     * @param {?} ph
     * @param {?=} context
     * @return {?}
     */
    _WriteVisitor$1.prototype.visitIcuPlaceholder = function (ph, context) {
        return [new Tag(_PLACEHOLDER_TAG$1, { id: (this._nextPlaceholderId++).toString() })];
    };
    /**
     * @param {?} nodes
     * @return {?}
     */
    _WriteVisitor$1.prototype.serialize = function (nodes) {
        var _this = this;
        this._nextPlaceholderId = 0;
        return [].concat.apply([], nodes.map(function (node) { return node.visit(_this); }));
    };
    return _WriteVisitor$1;
}());
var Xliff2Parser = (function () {
    function Xliff2Parser() {
        this._locale = null;
    }
    /**
     * @param {?} xliff
     * @param {?} url
     * @return {?}
     */
    Xliff2Parser.prototype.parse = function (xliff, url) {
        this._unitMlString = null;
        this._msgIdToHtml = {};
        var /** @type {?} */ xml = new XmlParser().parse(xliff, url, false);
        this._errors = xml.errors;
        visitAll(this, xml.rootNodes, null);
        return {
            msgIdToHtml: this._msgIdToHtml,
            errors: this._errors,
            locale: this._locale,
        };
    };
    /**
     * @param {?} element
     * @param {?} context
     * @return {?}
     */
    Xliff2Parser.prototype.visitElement = function (element, context) {
        switch (element.name) {
            case _UNIT_TAG$1:
                this._unitMlString = null;
                var /** @type {?} */ idAttr = element.attrs.find(function (attr) { return attr.name === 'id'; });
                if (!idAttr) {
                    this._addError(element, "<" + _UNIT_TAG$1 + "> misses the \"id\" attribute");
                }
                else {
                    var /** @type {?} */ id = idAttr.value;
                    if (this._msgIdToHtml.hasOwnProperty(id)) {
                        this._addError(element, "Duplicated translations for msg " + id);
                    }
                    else {
                        visitAll(this, element.children, null);
                        if (typeof this._unitMlString === 'string') {
                            this._msgIdToHtml[id] = this._unitMlString;
                        }
                        else {
                            this._addError(element, "Message " + id + " misses a translation");
                        }
                    }
                }
                break;
            case _SOURCE_TAG$1:
                // ignore source message
                break;
            case _TARGET_TAG$1:
                var /** @type {?} */ innerTextStart = ((element.startSourceSpan)).end.offset;
                var /** @type {?} */ innerTextEnd = ((element.endSourceSpan)).start.offset;
                var /** @type {?} */ content = ((element.startSourceSpan)).start.file.content;
                var /** @type {?} */ innerText = content.slice(innerTextStart, innerTextEnd);
                this._unitMlString = innerText;
                break;
            case _XLIFF_TAG:
                var /** @type {?} */ localeAttr = element.attrs.find(function (attr) { return attr.name === 'trgLang'; });
                if (localeAttr) {
                    this._locale = localeAttr.value;
                }
                var /** @type {?} */ versionAttr = element.attrs.find(function (attr) { return attr.name === 'version'; });
                if (versionAttr) {
                    var /** @type {?} */ version = versionAttr.value;
                    if (version !== '2.0') {
                        this._addError(element, "The XLIFF file version " + version + " is not compatible with XLIFF 2.0 serializer");
                    }
                    else {
                        visitAll(this, element.children, null);
                    }
                }
                break;
            default:
                visitAll(this, element.children, null);
        }
    };
    /**
     * @param {?} attribute
     * @param {?} context
     * @return {?}
     */
    Xliff2Parser.prototype.visitAttribute = function (attribute, context) { };
    /**
     * @param {?} text
     * @param {?} context
     * @return {?}
     */
    Xliff2Parser.prototype.visitText = function (text, context) { };
    /**
     * @param {?} comment
     * @param {?} context
     * @return {?}
     */
    Xliff2Parser.prototype.visitComment = function (comment, context) { };
    /**
     * @param {?} expansion
     * @param {?} context
     * @return {?}
     */
    Xliff2Parser.prototype.visitExpansion = function (expansion, context) { };
    /**
     * @param {?} expansionCase
     * @param {?} context
     * @return {?}
     */
    Xliff2Parser.prototype.visitExpansionCase = function (expansionCase, context) { };
    /**
     * @param {?} node
     * @param {?} message
     * @return {?}
     */
    Xliff2Parser.prototype._addError = function (node, message) {
        this._errors.push(new I18nError(node.sourceSpan, message));
    };
    return Xliff2Parser;
}());
var XmlToI18n$1 = (function () {
    function XmlToI18n$1() {
    }
    /**
     * @param {?} message
     * @param {?} url
     * @return {?}
     */
    XmlToI18n$1.prototype.convert = function (message, url) {
        var /** @type {?} */ xmlIcu = new XmlParser().parse(message, url, true);
        this._errors = xmlIcu.errors;
        var /** @type {?} */ i18nNodes = this._errors.length > 0 || xmlIcu.rootNodes.length == 0 ?
            [] : [].concat.apply([], visitAll(this, xmlIcu.rootNodes));
        return {
            i18nNodes: i18nNodes,
            errors: this._errors,
        };
    };
    /**
     * @param {?} text
     * @param {?} context
     * @return {?}
     */
    XmlToI18n$1.prototype.visitText = function (text, context) { return new Text$1(text.value, text.sourceSpan); };
    /**
     * @param {?} el
     * @param {?} context
     * @return {?}
     */
    XmlToI18n$1.prototype.visitElement = function (el, context) {
        var _this = this;
        switch (el.name) {
            case _PLACEHOLDER_TAG$1:
                var /** @type {?} */ nameAttr = el.attrs.find(function (attr) { return attr.name === 'equiv'; });
                if (nameAttr) {
                    return [new Placeholder('', nameAttr.value, el.sourceSpan)];
                }
                this._addError(el, "<" + _PLACEHOLDER_TAG$1 + "> misses the \"equiv\" attribute");
                break;
            case _PLACEHOLDER_SPANNING_TAG:
                var /** @type {?} */ startAttr = el.attrs.find(function (attr) { return attr.name === 'equivStart'; });
                var /** @type {?} */ endAttr = el.attrs.find(function (attr) { return attr.name === 'equivEnd'; });
                if (!startAttr) {
                    this._addError(el, "<" + _PLACEHOLDER_TAG$1 + "> misses the \"equivStart\" attribute");
                }
                else if (!endAttr) {
                    this._addError(el, "<" + _PLACEHOLDER_TAG$1 + "> misses the \"equivEnd\" attribute");
                }
                else {
                    var /** @type {?} */ startId = startAttr.value;
                    var /** @type {?} */ endId = endAttr.value;
                    var /** @type {?} */ nodes = [];
                    return nodes.concat.apply(nodes, [new Placeholder('', startId, el.sourceSpan)].concat(el.children.map(function (node) { return node.visit(_this, null); }), [new Placeholder('', endId, el.sourceSpan)]));
                }
                break;
            default:
                this._addError(el, "Unexpected tag");
        }
        return null;
    };
    /**
     * @param {?} icu
     * @param {?} context
     * @return {?}
     */
    XmlToI18n$1.prototype.visitExpansion = function (icu, context) {
        var /** @type {?} */ caseMap = {};
        visitAll(this, icu.cases).forEach(function (c) {
            caseMap[c.value] = new Container(c.nodes, icu.sourceSpan);
        });
        return new Icu(icu.switchValue, icu.type, caseMap, icu.sourceSpan);
    };
    /**
     * @param {?} icuCase
     * @param {?} context
     * @return {?}
     */
    XmlToI18n$1.prototype.visitExpansionCase = function (icuCase, context) {
        return {
            value: icuCase.value,
            nodes: [].concat.apply([], visitAll(this, icuCase.expression)),
        };
    };
    /**
     * @param {?} comment
     * @param {?} context
     * @return {?}
     */
    XmlToI18n$1.prototype.visitComment = function (comment, context) { };
    /**
     * @param {?} attribute
     * @param {?} context
     * @return {?}
     */
    XmlToI18n$1.prototype.visitAttribute = function (attribute, context) { };
    /**
     * @param {?} node
     * @param {?} message
     * @return {?}
     */
    XmlToI18n$1.prototype._addError = function (node, message) {
        this._errors.push(new I18nError(node.sourceSpan, message));
    };
    return XmlToI18n$1;
}());
/**
 * @param {?} tag
 * @return {?}
 */
function getTypeForTag(tag) {
    switch (tag.toLowerCase()) {
        case 'br':
        case 'b':
        case 'i':
        case 'u':
            return 'fmt';
        case 'img':
            return 'image';
        case 'a':
            return 'link';
        default:
            return 'other';
    }
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var _MESSAGES_TAG = 'messagebundle';
var _MESSAGE_TAG = 'msg';
var _PLACEHOLDER_TAG$2 = 'ph';
var _EXEMPLE_TAG = 'ex';
var _SOURCE_TAG$2 = 'source';
var _DOCTYPE = "<!ELEMENT messagebundle (msg)*>\n<!ATTLIST messagebundle class CDATA #IMPLIED>\n\n<!ELEMENT msg (#PCDATA|ph|source)*>\n<!ATTLIST msg id CDATA #IMPLIED>\n<!ATTLIST msg seq CDATA #IMPLIED>\n<!ATTLIST msg name CDATA #IMPLIED>\n<!ATTLIST msg desc CDATA #IMPLIED>\n<!ATTLIST msg meaning CDATA #IMPLIED>\n<!ATTLIST msg obsolete (obsolete) #IMPLIED>\n<!ATTLIST msg xml:space (default|preserve) \"default\">\n<!ATTLIST msg is_hidden CDATA #IMPLIED>\n\n<!ELEMENT source (#PCDATA)>\n\n<!ELEMENT ph (#PCDATA|ex)*>\n<!ATTLIST ph name CDATA #REQUIRED>\n\n<!ELEMENT ex (#PCDATA)>";
var Xmb = (function (_super) {
    __extends(Xmb, _super);
    function Xmb() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @param {?} messages
     * @param {?} locale
     * @return {?}
     */
    Xmb.prototype.write = function (messages, locale) {
        var /** @type {?} */ exampleVisitor = new ExampleVisitor();
        var /** @type {?} */ visitor = new _Visitor$2();
        var /** @type {?} */ rootNode = new Tag(_MESSAGES_TAG);
        messages.forEach(function (message) {
            var /** @type {?} */ attrs = { id: message.id };
            if (message.description) {
                attrs['desc'] = message.description;
            }
            if (message.meaning) {
                attrs['meaning'] = message.meaning;
            }
            var /** @type {?} */ sourceTags = [];
            message.sources.forEach(function (source) {
                sourceTags.push(new Tag(_SOURCE_TAG$2, {}, [
                    new Text$2(source.filePath + ":" + source.startLine + (source.endLine !== source.startLine ? ',' + source.endLine : ''))
                ]));
            });
            rootNode.children.push(new CR(2), new Tag(_MESSAGE_TAG, attrs, sourceTags.concat(visitor.serialize(message.nodes))));
        });
        rootNode.children.push(new CR());
        return serialize([
            new Declaration({ version: '1.0', encoding: 'UTF-8' }),
            new CR(),
            new Doctype(_MESSAGES_TAG, _DOCTYPE),
            new CR(),
            exampleVisitor.addDefaultExamples(rootNode),
            new CR(),
        ]);
    };
    /**
     * @param {?} content
     * @param {?} url
     * @return {?}
     */
    Xmb.prototype.load = function (content, url) {
        throw new Error('Unsupported');
    };
    /**
     * @param {?} message
     * @return {?}
     */
    Xmb.prototype.digest = function (message) { return digest$1(message); };
    /**
     * @param {?} message
     * @return {?}
     */
    Xmb.prototype.createNameMapper = function (message) {
        return new SimplePlaceholderMapper(message, toPublicName);
    };
    return Xmb;
}(Serializer));
var _Visitor$2 = (function () {
    function _Visitor$2() {
    }
    /**
     * @param {?} text
     * @param {?=} context
     * @return {?}
     */
    _Visitor$2.prototype.visitText = function (text, context) { return [new Text$2(text.value)]; };
    /**
     * @param {?} container
     * @param {?} context
     * @return {?}
     */
    _Visitor$2.prototype.visitContainer = function (container, context) {
        var _this = this;
        var /** @type {?} */ nodes = [];
        container.children.forEach(function (node) { return nodes.push.apply(nodes, node.visit(_this)); });
        return nodes;
    };
    /**
     * @param {?} icu
     * @param {?=} context
     * @return {?}
     */
    _Visitor$2.prototype.visitIcu = function (icu, context) {
        var _this = this;
        var /** @type {?} */ nodes = [new Text$2("{" + icu.expressionPlaceholder + ", " + icu.type + ", ")];
        Object.keys(icu.cases).forEach(function (c) {
            nodes.push.apply(nodes, [new Text$2(c + " {")].concat(icu.cases[c].visit(_this), [new Text$2("} ")]));
        });
        nodes.push(new Text$2("}"));
        return nodes;
    };
    /**
     * @param {?} ph
     * @param {?=} context
     * @return {?}
     */
    _Visitor$2.prototype.visitTagPlaceholder = function (ph, context) {
        var /** @type {?} */ startEx = new Tag(_EXEMPLE_TAG, {}, [new Text$2("<" + ph.tag + ">")]);
        var /** @type {?} */ startTagPh = new Tag(_PLACEHOLDER_TAG$2, { name: ph.startName }, [startEx]);
        if (ph.isVoid) {
            // void tags have no children nor closing tags
            return [startTagPh];
        }
        var /** @type {?} */ closeEx = new Tag(_EXEMPLE_TAG, {}, [new Text$2("</" + ph.tag + ">")]);
        var /** @type {?} */ closeTagPh = new Tag(_PLACEHOLDER_TAG$2, { name: ph.closeName }, [closeEx]);
        return [startTagPh].concat(this.serialize(ph.children), [closeTagPh]);
    };
    /**
     * @param {?} ph
     * @param {?=} context
     * @return {?}
     */
    _Visitor$2.prototype.visitPlaceholder = function (ph, context) {
        return [new Tag(_PLACEHOLDER_TAG$2, { name: ph.name })];
    };
    /**
     * @param {?} ph
     * @param {?=} context
     * @return {?}
     */
    _Visitor$2.prototype.visitIcuPlaceholder = function (ph, context) {
        return [new Tag(_PLACEHOLDER_TAG$2, { name: ph.name })];
    };
    /**
     * @param {?} nodes
     * @return {?}
     */
    _Visitor$2.prototype.serialize = function (nodes) {
        var _this = this;
        return [].concat.apply([], nodes.map(function (node) { return node.visit(_this); }));
    };
    return _Visitor$2;
}());
/**
 * @param {?} message
 * @return {?}
 */
function digest$1(message) {
    return decimalDigest(message);
}
var ExampleVisitor = (function () {
    function ExampleVisitor() {
    }
    /**
     * @param {?} node
     * @return {?}
     */
    ExampleVisitor.prototype.addDefaultExamples = function (node) {
        node.visit(this);
        return node;
    };
    /**
     * @param {?} tag
     * @return {?}
     */
    ExampleVisitor.prototype.visitTag = function (tag) {
        var _this = this;
        if (tag.name === _PLACEHOLDER_TAG$2) {
            if (!tag.children || tag.children.length == 0) {
                var /** @type {?} */ exText = new Text$2(tag.attrs['name'] || '...');
                tag.children = [new Tag(_EXEMPLE_TAG, {}, [exText])];
            }
        }
        else if (tag.children) {
            tag.children.forEach(function (node) { return node.visit(_this); });
        }
    };
    /**
     * @param {?} text
     * @return {?}
     */
    ExampleVisitor.prototype.visitText = function (text) { };
    /**
     * @param {?} decl
     * @return {?}
     */
    ExampleVisitor.prototype.visitDeclaration = function (decl) { };
    /**
     * @param {?} doctype
     * @return {?}
     */
    ExampleVisitor.prototype.visitDoctype = function (doctype) { };
    return ExampleVisitor;
}());
/**
 * @param {?} internalName
 * @return {?}
 */
function toPublicName(internalName) {
    return internalName.toUpperCase().replace(/[^A-Z0-9_]/g, '_');
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var _TRANSLATIONS_TAG = 'translationbundle';
var _TRANSLATION_TAG = 'translation';
var _PLACEHOLDER_TAG$3 = 'ph';
var Xtb = (function (_super) {
    __extends(Xtb, _super);
    function Xtb() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @param {?} messages
     * @param {?} locale
     * @return {?}
     */
    Xtb.prototype.write = function (messages, locale) { throw new Error('Unsupported'); };
    /**
     * @param {?} content
     * @param {?} url
     * @return {?}
     */
    Xtb.prototype.load = function (content, url) {
        // xtb to xml nodes
        var /** @type {?} */ xtbParser = new XtbParser();
        var _a = xtbParser.parse(content, url), locale = _a.locale, msgIdToHtml = _a.msgIdToHtml, errors = _a.errors;
        // xml nodes to i18n nodes
        var /** @type {?} */ i18nNodesByMsgId = {};
        var /** @type {?} */ converter = new XmlToI18n$2();
        // Because we should be able to load xtb files that rely on features not supported by angular,
        // we need to delay the conversion of html to i18n nodes so that non angular messages are not
        // converted
        Object.keys(msgIdToHtml).forEach(function (msgId) {
            var /** @type {?} */ valueFn = function () {
                var _a = converter.convert(msgIdToHtml[msgId], url), i18nNodes = _a.i18nNodes, errors = _a.errors;
                if (errors.length) {
                    throw new Error("xtb parse errors:\n" + errors.join('\n'));
                }
                return i18nNodes;
            };
            createLazyProperty(i18nNodesByMsgId, msgId, valueFn);
        });
        if (errors.length) {
            throw new Error("xtb parse errors:\n" + errors.join('\n'));
        }
        return { locale: /** @type {?} */ ((locale)), i18nNodesByMsgId: i18nNodesByMsgId };
    };
    /**
     * @param {?} message
     * @return {?}
     */
    Xtb.prototype.digest = function (message) { return digest$1(message); };
    /**
     * @param {?} message
     * @return {?}
     */
    Xtb.prototype.createNameMapper = function (message) {
        return new SimplePlaceholderMapper(message, toPublicName);
    };
    return Xtb;
}(Serializer));
/**
 * @param {?} messages
 * @param {?} id
 * @param {?} valueFn
 * @return {?}
 */
function createLazyProperty(messages, id, valueFn) {
    Object.defineProperty(messages, id, {
        configurable: true,
        enumerable: true,
        get: function () {
            var /** @type {?} */ value = valueFn();
            Object.defineProperty(messages, id, { enumerable: true, value: value });
            return value;
        },
        set: function (_) { throw new Error('Could not overwrite an XTB translation'); },
    });
}
var XtbParser = (function () {
    function XtbParser() {
        this._locale = null;
    }
    /**
     * @param {?} xtb
     * @param {?} url
     * @return {?}
     */
    XtbParser.prototype.parse = function (xtb, url) {
        this._bundleDepth = 0;
        this._msgIdToHtml = {};
        // We can not parse the ICU messages at this point as some messages might not originate
        // from Angular that could not be lex'd.
        var /** @type {?} */ xml = new XmlParser().parse(xtb, url, false);
        this._errors = xml.errors;
        visitAll(this, xml.rootNodes);
        return {
            msgIdToHtml: this._msgIdToHtml,
            errors: this._errors,
            locale: this._locale,
        };
    };
    /**
     * @param {?} element
     * @param {?} context
     * @return {?}
     */
    XtbParser.prototype.visitElement = function (element, context) {
        switch (element.name) {
            case _TRANSLATIONS_TAG:
                this._bundleDepth++;
                if (this._bundleDepth > 1) {
                    this._addError(element, "<" + _TRANSLATIONS_TAG + "> elements can not be nested");
                }
                var /** @type {?} */ langAttr = element.attrs.find(function (attr) { return attr.name === 'lang'; });
                if (langAttr) {
                    this._locale = langAttr.value;
                }
                visitAll(this, element.children, null);
                this._bundleDepth--;
                break;
            case _TRANSLATION_TAG:
                var /** @type {?} */ idAttr = element.attrs.find(function (attr) { return attr.name === 'id'; });
                if (!idAttr) {
                    this._addError(element, "<" + _TRANSLATION_TAG + "> misses the \"id\" attribute");
                }
                else {
                    var /** @type {?} */ id = idAttr.value;
                    if (this._msgIdToHtml.hasOwnProperty(id)) {
                        this._addError(element, "Duplicated translations for msg " + id);
                    }
                    else {
                        var /** @type {?} */ innerTextStart = ((element.startSourceSpan)).end.offset;
                        var /** @type {?} */ innerTextEnd = ((element.endSourceSpan)).start.offset;
                        var /** @type {?} */ content = ((element.startSourceSpan)).start.file.content;
                        var /** @type {?} */ innerText = content.slice(/** @type {?} */ ((innerTextStart)), /** @type {?} */ ((innerTextEnd)));
                        this._msgIdToHtml[id] = innerText;
                    }
                }
                break;
            default:
                this._addError(element, 'Unexpected tag');
        }
    };
    /**
     * @param {?} attribute
     * @param {?} context
     * @return {?}
     */
    XtbParser.prototype.visitAttribute = function (attribute, context) { };
    /**
     * @param {?} text
     * @param {?} context
     * @return {?}
     */
    XtbParser.prototype.visitText = function (text, context) { };
    /**
     * @param {?} comment
     * @param {?} context
     * @return {?}
     */
    XtbParser.prototype.visitComment = function (comment, context) { };
    /**
     * @param {?} expansion
     * @param {?} context
     * @return {?}
     */
    XtbParser.prototype.visitExpansion = function (expansion, context) { };
    /**
     * @param {?} expansionCase
     * @param {?} context
     * @return {?}
     */
    XtbParser.prototype.visitExpansionCase = function (expansionCase, context) { };
    /**
     * @param {?} node
     * @param {?} message
     * @return {?}
     */
    XtbParser.prototype._addError = function (node, message) {
        this._errors.push(new I18nError(/** @type {?} */ ((node.sourceSpan)), message));
    };
    return XtbParser;
}());
var XmlToI18n$2 = (function () {
    function XmlToI18n$2() {
    }
    /**
     * @param {?} message
     * @param {?} url
     * @return {?}
     */
    XmlToI18n$2.prototype.convert = function (message, url) {
        var /** @type {?} */ xmlIcu = new XmlParser().parse(message, url, true);
        this._errors = xmlIcu.errors;
        var /** @type {?} */ i18nNodes = this._errors.length > 0 || xmlIcu.rootNodes.length == 0 ?
            [] :
            visitAll(this, xmlIcu.rootNodes);
        return {
            i18nNodes: i18nNodes,
            errors: this._errors,
        };
    };
    /**
     * @param {?} text
     * @param {?} context
     * @return {?}
     */
    XmlToI18n$2.prototype.visitText = function (text, context) { return new Text$1(text.value, /** @type {?} */ ((text.sourceSpan))); };
    /**
     * @param {?} icu
     * @param {?} context
     * @return {?}
     */
    XmlToI18n$2.prototype.visitExpansion = function (icu, context) {
        var /** @type {?} */ caseMap = {};
        visitAll(this, icu.cases).forEach(function (c) {
            caseMap[c.value] = new Container(c.nodes, icu.sourceSpan);
        });
        return new Icu(icu.switchValue, icu.type, caseMap, icu.sourceSpan);
    };
    /**
     * @param {?} icuCase
     * @param {?} context
     * @return {?}
     */
    XmlToI18n$2.prototype.visitExpansionCase = function (icuCase, context) {
        return {
            value: icuCase.value,
            nodes: visitAll(this, icuCase.expression),
        };
    };
    /**
     * @param {?} el
     * @param {?} context
     * @return {?}
     */
    XmlToI18n$2.prototype.visitElement = function (el, context) {
        if (el.name === _PLACEHOLDER_TAG$3) {
            var /** @type {?} */ nameAttr = el.attrs.find(function (attr) { return attr.name === 'name'; });
            if (nameAttr) {
                return new Placeholder('', nameAttr.value, /** @type {?} */ ((el.sourceSpan)));
            }
            this._addError(el, "<" + _PLACEHOLDER_TAG$3 + "> misses the \"name\" attribute");
        }
        else {
            this._addError(el, "Unexpected tag");
        }
        return null;
    };
    /**
     * @param {?} comment
     * @param {?} context
     * @return {?}
     */
    XmlToI18n$2.prototype.visitComment = function (comment, context) { };
    /**
     * @param {?} attribute
     * @param {?} context
     * @return {?}
     */
    XmlToI18n$2.prototype.visitAttribute = function (attribute, context) { };
    /**
     * @param {?} node
     * @param {?} message
     * @return {?}
     */
    XmlToI18n$2.prototype._addError = function (node, message) {
        this._errors.push(new I18nError(/** @type {?} */ ((node.sourceSpan)), message));
    };
    return XmlToI18n$2;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var HtmlParser = (function (_super) {
    __extends(HtmlParser, _super);
    function HtmlParser() {
        return _super.call(this, getHtmlTagDefinition) || this;
    }
    /**
     * @param {?} source
     * @param {?} url
     * @param {?=} parseExpansionForms
     * @param {?=} interpolationConfig
     * @return {?}
     */
    HtmlParser.prototype.parse = function (source, url, parseExpansionForms, interpolationConfig) {
        if (parseExpansionForms === void 0) { parseExpansionForms = false; }
        if (interpolationConfig === void 0) { interpolationConfig = DEFAULT_INTERPOLATION_CONFIG; }
        return _super.prototype.parse.call(this, source, url, parseExpansionForms, interpolationConfig);
    };
    return HtmlParser;
}(Parser$1));
HtmlParser.decorators = [
    { type: CompilerInjectable },
];
/**
 * @nocollapse
 */
HtmlParser.ctorParameters = function () { return []; };
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * A container for translated messages
 */
var TranslationBundle = (function () {
    /**
     * @param {?=} _i18nNodesByMsgId
     * @param {?=} locale
     * @param {?=} digest
     * @param {?=} mapperFactory
     * @param {?=} missingTranslationStrategy
     * @param {?=} console
     */
    function TranslationBundle(_i18nNodesByMsgId, locale, digest, mapperFactory, missingTranslationStrategy, console) {
        if (_i18nNodesByMsgId === void 0) { _i18nNodesByMsgId = {}; }
        if (missingTranslationStrategy === void 0) { missingTranslationStrategy = __WEBPACK_IMPORTED_MODULE_0__angular_core__["MissingTranslationStrategy"].Warning; }
        this._i18nNodesByMsgId = _i18nNodesByMsgId;
        this.digest = digest;
        this.mapperFactory = mapperFactory;
        this._i18nToHtml = new I18nToHtmlVisitor(_i18nNodesByMsgId, locale, digest, mapperFactory, missingTranslationStrategy, console);
    }
    /**
     * @param {?} content
     * @param {?} url
     * @param {?} serializer
     * @param {?} missingTranslationStrategy
     * @param {?=} console
     * @return {?}
     */
    TranslationBundle.load = function (content, url, serializer, missingTranslationStrategy, console) {
        var _a = serializer.load(content, url), locale = _a.locale, i18nNodesByMsgId = _a.i18nNodesByMsgId;
        var /** @type {?} */ digestFn = function (m) { return serializer.digest(m); };
        var /** @type {?} */ mapperFactory = function (m) { return ((serializer.createNameMapper(m))); };
        return new TranslationBundle(i18nNodesByMsgId, locale, digestFn, mapperFactory, missingTranslationStrategy, console);
    };
    /**
     * @param {?} srcMsg
     * @return {?}
     */
    TranslationBundle.prototype.get = function (srcMsg) {
        var /** @type {?} */ html = this._i18nToHtml.convert(srcMsg);
        if (html.errors.length) {
            throw new Error(html.errors.join('\n'));
        }
        return html.nodes;
    };
    /**
     * @param {?} srcMsg
     * @return {?}
     */
    TranslationBundle.prototype.has = function (srcMsg) { return this.digest(srcMsg) in this._i18nNodesByMsgId; };
    return TranslationBundle;
}());
var I18nToHtmlVisitor = (function () {
    /**
     * @param {?=} _i18nNodesByMsgId
     * @param {?=} _locale
     * @param {?=} _digest
     * @param {?=} _mapperFactory
     * @param {?=} _missingTranslationStrategy
     * @param {?=} _console
     */
    function I18nToHtmlVisitor(_i18nNodesByMsgId, _locale, _digest, _mapperFactory, _missingTranslationStrategy, _console) {
        if (_i18nNodesByMsgId === void 0) { _i18nNodesByMsgId = {}; }
        this._i18nNodesByMsgId = _i18nNodesByMsgId;
        this._locale = _locale;
        this._digest = _digest;
        this._mapperFactory = _mapperFactory;
        this._missingTranslationStrategy = _missingTranslationStrategy;
        this._console = _console;
        this._contextStack = [];
        this._errors = [];
    }
    /**
     * @param {?} srcMsg
     * @return {?}
     */
    I18nToHtmlVisitor.prototype.convert = function (srcMsg) {
        this._contextStack.length = 0;
        this._errors.length = 0;
        // i18n to text
        var /** @type {?} */ text = this._convertToText(srcMsg);
        // text to html
        var /** @type {?} */ url = srcMsg.nodes[0].sourceSpan.start.file.url;
        var /** @type {?} */ html = new HtmlParser().parse(text, url, true);
        return {
            nodes: html.rootNodes,
            errors: this._errors.concat(html.errors),
        };
    };
    /**
     * @param {?} text
     * @param {?=} context
     * @return {?}
     */
    I18nToHtmlVisitor.prototype.visitText = function (text, context) { return text.value; };
    /**
     * @param {?} container
     * @param {?=} context
     * @return {?}
     */
    I18nToHtmlVisitor.prototype.visitContainer = function (container, context) {
        var _this = this;
        return container.children.map(function (n) { return n.visit(_this); }).join('');
    };
    /**
     * @param {?} icu
     * @param {?=} context
     * @return {?}
     */
    I18nToHtmlVisitor.prototype.visitIcu = function (icu, context) {
        var _this = this;
        var /** @type {?} */ cases = Object.keys(icu.cases).map(function (k) { return k + " {" + icu.cases[k].visit(_this) + "}"; });
        // TODO(vicb): Once all format switch to using expression placeholders
        // we should throw when the placeholder is not in the source message
        var /** @type {?} */ exp = this._srcMsg.placeholders.hasOwnProperty(icu.expression) ?
            this._srcMsg.placeholders[icu.expression] :
            icu.expression;
        return "{" + exp + ", " + icu.type + ", " + cases.join(' ') + "}";
    };
    /**
     * @param {?} ph
     * @param {?=} context
     * @return {?}
     */
    I18nToHtmlVisitor.prototype.visitPlaceholder = function (ph, context) {
        var /** @type {?} */ phName = this._mapper(ph.name);
        if (this._srcMsg.placeholders.hasOwnProperty(phName)) {
            return this._srcMsg.placeholders[phName];
        }
        if (this._srcMsg.placeholderToMessage.hasOwnProperty(phName)) {
            return this._convertToText(this._srcMsg.placeholderToMessage[phName]);
        }
        this._addError(ph, "Unknown placeholder \"" + ph.name + "\"");
        return '';
    };
    /**
     * @param {?} ph
     * @param {?=} context
     * @return {?}
     */
    I18nToHtmlVisitor.prototype.visitTagPlaceholder = function (ph, context) {
        var _this = this;
        var /** @type {?} */ tag = "" + ph.tag;
        var /** @type {?} */ attrs = Object.keys(ph.attrs).map(function (name) { return name + "=\"" + ph.attrs[name] + "\""; }).join(' ');
        if (ph.isVoid) {
            return "<" + tag + " " + attrs + "/>";
        }
        var /** @type {?} */ children = ph.children.map(function (c) { return c.visit(_this); }).join('');
        return "<" + tag + " " + attrs + ">" + children + "</" + tag + ">";
    };
    /**
     * @param {?} ph
     * @param {?=} context
     * @return {?}
     */
    I18nToHtmlVisitor.prototype.visitIcuPlaceholder = function (ph, context) {
        // An ICU placeholder references the source message to be serialized
        return this._convertToText(this._srcMsg.placeholderToMessage[ph.name]);
    };
    /**
     * Convert a source message to a translated text string:
     * - text nodes are replaced with their translation,
     * - placeholders are replaced with their content,
     * - ICU nodes are converted to ICU expressions.
     * @param {?} srcMsg
     * @return {?}
     */
    I18nToHtmlVisitor.prototype._convertToText = function (srcMsg) {
        var _this = this;
        var /** @type {?} */ id = this._digest(srcMsg);
        var /** @type {?} */ mapper = this._mapperFactory ? this._mapperFactory(srcMsg) : null;
        var /** @type {?} */ nodes;
        this._contextStack.push({ msg: this._srcMsg, mapper: this._mapper });
        this._srcMsg = srcMsg;
        if (this._i18nNodesByMsgId.hasOwnProperty(id)) {
            // When there is a translation use its nodes as the source
            // And create a mapper to convert serialized placeholder names to internal names
            nodes = this._i18nNodesByMsgId[id];
            this._mapper = function (name) { return mapper ? ((mapper.toInternalName(name))) : name; };
        }
        else {
            // When no translation has been found
            // - report an error / a warning / nothing,
            // - use the nodes from the original message
            // - placeholders are already internal and need no mapper
            if (this._missingTranslationStrategy === __WEBPACK_IMPORTED_MODULE_0__angular_core__["MissingTranslationStrategy"].Error) {
                var /** @type {?} */ ctx = this._locale ? " for locale \"" + this._locale + "\"" : '';
                this._addError(srcMsg.nodes[0], "Missing translation for message \"" + id + "\"" + ctx);
            }
            else if (this._console &&
                this._missingTranslationStrategy === __WEBPACK_IMPORTED_MODULE_0__angular_core__["MissingTranslationStrategy"].Warning) {
                var /** @type {?} */ ctx = this._locale ? " for locale \"" + this._locale + "\"" : '';
                this._console.warn("Missing translation for message \"" + id + "\"" + ctx);
            }
            nodes = srcMsg.nodes;
            this._mapper = function (name) { return name; };
        }
        var /** @type {?} */ text = nodes.map(function (node) { return node.visit(_this); }).join('');
        var /** @type {?} */ context = ((this._contextStack.pop()));
        this._srcMsg = context.msg;
        this._mapper = context.mapper;
        return text;
    };
    /**
     * @param {?} el
     * @param {?} msg
     * @return {?}
     */
    I18nToHtmlVisitor.prototype._addError = function (el, msg) {
        this._errors.push(new I18nError(el.sourceSpan, msg));
    };
    return I18nToHtmlVisitor;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var I18NHtmlParser = (function () {
    /**
     * @param {?} _htmlParser
     * @param {?=} translations
     * @param {?=} translationsFormat
     * @param {?=} missingTranslation
     * @param {?=} console
     */
    function I18NHtmlParser(_htmlParser, translations, translationsFormat, missingTranslation, console) {
        if (missingTranslation === void 0) { missingTranslation = __WEBPACK_IMPORTED_MODULE_0__angular_core__["MissingTranslationStrategy"].Warning; }
        this._htmlParser = _htmlParser;
        if (translations) {
            var serializer = createSerializer(translationsFormat);
            this._translationBundle =
                TranslationBundle.load(translations, 'i18n', serializer, missingTranslation, console);
        }
    }
    /**
     * @param {?} source
     * @param {?} url
     * @param {?=} parseExpansionForms
     * @param {?=} interpolationConfig
     * @return {?}
     */
    I18NHtmlParser.prototype.parse = function (source, url, parseExpansionForms, interpolationConfig) {
        if (parseExpansionForms === void 0) { parseExpansionForms = false; }
        if (interpolationConfig === void 0) { interpolationConfig = DEFAULT_INTERPOLATION_CONFIG; }
        var /** @type {?} */ parseResult = this._htmlParser.parse(source, url, parseExpansionForms, interpolationConfig);
        if (!this._translationBundle) {
            // Do not enable i18n when no translation bundle is provided
            return parseResult;
        }
        if (parseResult.errors.length) {
            return new ParseTreeResult(parseResult.rootNodes, parseResult.errors);
        }
        return mergeTranslations(parseResult.rootNodes, this._translationBundle, interpolationConfig, [], {});
    };
    return I18NHtmlParser;
}());
/**
 * @param {?=} format
 * @return {?}
 */
function createSerializer(format) {
    format = (format || 'xlf').toLowerCase();
    switch (format) {
        case 'xmb':
            return new Xmb();
        case 'xtb':
            return new Xtb();
        case 'xliff2':
        case 'xlf2':
            return new Xliff2();
        case 'xliff':
        case 'xlf':
        default:
            return new Xliff();
    }
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var CORE = assetUrl('core');
var Identifiers = (function () {
    function Identifiers() {
    }
    return Identifiers;
}());
Identifiers.ANALYZE_FOR_ENTRY_COMPONENTS = {
    name: 'ANALYZE_FOR_ENTRY_COMPONENTS',
    moduleUrl: CORE,
    runtime: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ANALYZE_FOR_ENTRY_COMPONENTS"]
};
Identifiers.ElementRef = { name: 'ElementRef', moduleUrl: CORE, runtime: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"] };
Identifiers.NgModuleRef = { name: 'NgModuleRef', moduleUrl: CORE, runtime: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModuleRef"] };
Identifiers.ViewContainerRef = { name: 'ViewContainerRef', moduleUrl: CORE, runtime: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewContainerRef"] };
Identifiers.ChangeDetectorRef = { name: 'ChangeDetectorRef', moduleUrl: CORE, runtime: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectorRef"] };
Identifiers.QueryList = { name: 'QueryList', moduleUrl: CORE, runtime: __WEBPACK_IMPORTED_MODULE_0__angular_core__["QueryList"] };
Identifiers.TemplateRef = { name: 'TemplateRef', moduleUrl: CORE, runtime: __WEBPACK_IMPORTED_MODULE_0__angular_core__["TemplateRef"] };
Identifiers.CodegenComponentFactoryResolver = {
    name: 'ɵCodegenComponentFactoryResolver',
    moduleUrl: CORE,
    runtime: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵCodegenComponentFactoryResolver"]
};
Identifiers.ComponentFactoryResolver = {
    name: 'ComponentFactoryResolver',
    moduleUrl: CORE,
    runtime: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ComponentFactoryResolver"]
};
Identifiers.ComponentFactory = { name: 'ComponentFactory', moduleUrl: CORE, runtime: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ComponentFactory"] };
Identifiers.ComponentRef = { name: 'ComponentRef', moduleUrl: CORE, runtime: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ComponentRef"] };
Identifiers.NgModuleFactory = { name: 'NgModuleFactory', moduleUrl: CORE, runtime: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModuleFactory"] };
Identifiers.NgModuleInjector = {
    name: 'ɵNgModuleInjector',
    moduleUrl: CORE,
    runtime: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵNgModuleInjector"],
};
Identifiers.RegisterModuleFactoryFn = {
    name: 'ɵregisterModuleFactory',
    moduleUrl: CORE,
    runtime: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵregisterModuleFactory"],
};
Identifiers.Injector = { name: 'Injector', moduleUrl: CORE, runtime: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injector"] };
Identifiers.ViewEncapsulation = { name: 'ViewEncapsulation', moduleUrl: CORE, runtime: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewEncapsulation"] };
Identifiers.ChangeDetectionStrategy = {
    name: 'ChangeDetectionStrategy',
    moduleUrl: CORE,
    runtime: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectionStrategy"]
};
Identifiers.SecurityContext = {
    name: 'SecurityContext',
    moduleUrl: CORE,
    runtime: __WEBPACK_IMPORTED_MODULE_0__angular_core__["SecurityContext"],
};
Identifiers.LOCALE_ID = { name: 'LOCALE_ID', moduleUrl: CORE, runtime: __WEBPACK_IMPORTED_MODULE_0__angular_core__["LOCALE_ID"] };
Identifiers.TRANSLATIONS_FORMAT = { name: 'TRANSLATIONS_FORMAT', moduleUrl: CORE, runtime: __WEBPACK_IMPORTED_MODULE_0__angular_core__["TRANSLATIONS_FORMAT"] };
Identifiers.inlineInterpolate = { name: 'ɵinlineInterpolate', moduleUrl: CORE, runtime: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵinlineInterpolate"] };
Identifiers.interpolate = { name: 'ɵinterpolate', moduleUrl: CORE, runtime: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵinterpolate"] };
Identifiers.EMPTY_ARRAY = { name: 'ɵEMPTY_ARRAY', moduleUrl: CORE, runtime: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵEMPTY_ARRAY"] };
Identifiers.EMPTY_MAP = { name: 'ɵEMPTY_MAP', moduleUrl: CORE, runtime: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵEMPTY_MAP"] };
Identifiers.Renderer = { name: 'Renderer', moduleUrl: CORE, runtime: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"] };
Identifiers.viewDef = { name: 'ɵvid', moduleUrl: CORE, runtime: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵvid"] };
Identifiers.elementDef = { name: 'ɵeld', moduleUrl: CORE, runtime: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵeld"] };
Identifiers.anchorDef = { name: 'ɵand', moduleUrl: CORE, runtime: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵand"] };
Identifiers.textDef = { name: 'ɵted', moduleUrl: CORE, runtime: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵted"] };
Identifiers.directiveDef = { name: 'ɵdid', moduleUrl: CORE, runtime: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵdid"] };
Identifiers.providerDef = { name: 'ɵprd', moduleUrl: CORE, runtime: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵprd"] };
Identifiers.queryDef = { name: 'ɵqud', moduleUrl: CORE, runtime: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵqud"] };
Identifiers.pureArrayDef = { name: 'ɵpad', moduleUrl: CORE, runtime: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵpad"] };
Identifiers.pureObjectDef = { name: 'ɵpod', moduleUrl: CORE, runtime: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵpod"] };
Identifiers.purePipeDef = { name: 'ɵppd', moduleUrl: CORE, runtime: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵppd"] };
Identifiers.pipeDef = { name: 'ɵpid', moduleUrl: CORE, runtime: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵpid"] };
Identifiers.nodeValue = { name: 'ɵnov', moduleUrl: CORE, runtime: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵnov"] };
Identifiers.ngContentDef = { name: 'ɵncd', moduleUrl: CORE, runtime: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵncd"] };
Identifiers.unwrapValue = { name: 'ɵunv', moduleUrl: CORE, runtime: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵunv"] };
Identifiers.createRendererType2 = { name: 'ɵcrt', moduleUrl: CORE, runtime: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵcrt"] };
Identifiers.RendererType2 = {
    name: 'RendererType2',
    moduleUrl: CORE,
    // type only
    runtime: null
};
Identifiers.ViewDefinition = {
    name: 'ɵViewDefinition',
    moduleUrl: CORE,
    // type only
    runtime: null
};
Identifiers.createComponentFactory = { name: 'ɵccf', moduleUrl: CORE, runtime: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵccf"] };
/**
 * @param {?} pkg
 * @param {?=} path
 * @param {?=} type
 * @return {?}
 */
function assetUrl(pkg, path, type) {
    if (path === void 0) { path = null; }
    if (type === void 0) { type = 'src'; }
    if (path == null) {
        return "@angular/" + pkg;
    }
    else {
        return "@angular/" + pkg + "/" + type + "/" + path;
    }
}
/**
 * @param {?} identifier
 * @return {?}
 */
function resolveIdentifier(identifier) {
    var /** @type {?} */ name = identifier.name;
    return __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵreflector"].resolveIdentifier(name, identifier.moduleUrl, null, identifier.runtime);
}
/**
 * @param {?} identifier
 * @return {?}
 */
function createIdentifier(identifier) {
    return { reference: resolveIdentifier(identifier) };
}
/**
 * @param {?} identifier
 * @return {?}
 */
function identifierToken(identifier) {
    return { identifier: identifier };
}
/**
 * @param {?} identifier
 * @return {?}
 */
function createIdentifierToken(identifier) {
    return identifierToken(createIdentifier(identifier));
}
/**
 * @param {?} enumType
 * @param {?} name
 * @return {?}
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
// http://cldr.unicode.org/index/cldr-spec/plural-rules
var PLURAL_CASES = ['zero', 'one', 'two', 'few', 'many', 'other'];
/**
 * Expands special forms into elements.
 *
 * For example,
 *
 * ```
 * { messages.length, plural,
 *   =0 {zero}
 *   =1 {one}
 *   other {more than one}
 * }
 * ```
 *
 * will be expanded into
 *
 * ```
 * <ng-container [ngPlural]="messages.length">
 *   <ng-template ngPluralCase="=0">zero</ng-template>
 *   <ng-template ngPluralCase="=1">one</ng-template>
 *   <ng-template ngPluralCase="other">more than one</ng-template>
 * </ng-container>
 * ```
 * @param {?} nodes
 * @return {?}
 */
function expandNodes(nodes) {
    var /** @type {?} */ expander = new _Expander();
    return new ExpansionResult(visitAll(expander, nodes), expander.isExpanded, expander.errors);
}
var ExpansionResult = (function () {
    /**
     * @param {?} nodes
     * @param {?} expanded
     * @param {?} errors
     */
    function ExpansionResult(nodes, expanded, errors) {
        this.nodes = nodes;
        this.expanded = expanded;
        this.errors = errors;
    }
    return ExpansionResult;
}());
var ExpansionError = (function (_super) {
    __extends(ExpansionError, _super);
    /**
     * @param {?} span
     * @param {?} errorMsg
     */
    function ExpansionError(span, errorMsg) {
        return _super.call(this, span, errorMsg) || this;
    }
    return ExpansionError;
}(ParseError));
/**
 * Expand expansion forms (plural, select) to directives
 *
 * \@internal
 */
var _Expander = (function () {
    function _Expander() {
        this.isExpanded = false;
        this.errors = [];
    }
    /**
     * @param {?} element
     * @param {?} context
     * @return {?}
     */
    _Expander.prototype.visitElement = function (element, context) {
        return new Element(element.name, element.attrs, visitAll(this, element.children), element.sourceSpan, element.startSourceSpan, element.endSourceSpan);
    };
    /**
     * @param {?} attribute
     * @param {?} context
     * @return {?}
     */
    _Expander.prototype.visitAttribute = function (attribute, context) { return attribute; };
    /**
     * @param {?} text
     * @param {?} context
     * @return {?}
     */
    _Expander.prototype.visitText = function (text, context) { return text; };
    /**
     * @param {?} comment
     * @param {?} context
     * @return {?}
     */
    _Expander.prototype.visitComment = function (comment, context) { return comment; };
    /**
     * @param {?} icu
     * @param {?} context
     * @return {?}
     */
    _Expander.prototype.visitExpansion = function (icu, context) {
        this.isExpanded = true;
        return icu.type == 'plural' ? _expandPluralForm(icu, this.errors) :
            _expandDefaultForm(icu, this.errors);
    };
    /**
     * @param {?} icuCase
     * @param {?} context
     * @return {?}
     */
    _Expander.prototype.visitExpansionCase = function (icuCase, context) {
        throw new Error('Should not be reached');
    };
    return _Expander;
}());
/**
 * @param {?} ast
 * @param {?} errors
 * @return {?}
 */
function _expandPluralForm(ast, errors) {
    var /** @type {?} */ children = ast.cases.map(function (c) {
        if (PLURAL_CASES.indexOf(c.value) == -1 && !c.value.match(/^=\d+$/)) {
            errors.push(new ExpansionError(c.valueSourceSpan, "Plural cases should be \"=<number>\" or one of " + PLURAL_CASES.join(", ")));
        }
        var /** @type {?} */ expansionResult = expandNodes(c.expression);
        errors.push.apply(errors, expansionResult.errors);
        return new Element("ng-template", [new Attribute$1('ngPluralCase', "" + c.value, c.valueSourceSpan)], expansionResult.nodes, c.sourceSpan, c.sourceSpan, c.sourceSpan);
    });
    var /** @type {?} */ switchAttr = new Attribute$1('[ngPlural]', ast.switchValue, ast.switchValueSourceSpan);
    return new Element('ng-container', [switchAttr], children, ast.sourceSpan, ast.sourceSpan, ast.sourceSpan);
}
/**
 * @param {?} ast
 * @param {?} errors
 * @return {?}
 */
function _expandDefaultForm(ast, errors) {
    var /** @type {?} */ children = ast.cases.map(function (c) {
        var /** @type {?} */ expansionResult = expandNodes(c.expression);
        errors.push.apply(errors, expansionResult.errors);
        if (c.value === 'other') {
            // other is the default case when no values match
            return new Element("ng-template", [new Attribute$1('ngSwitchDefault', '', c.valueSourceSpan)], expansionResult.nodes, c.sourceSpan, c.sourceSpan, c.sourceSpan);
        }
        return new Element("ng-template", [new Attribute$1('ngSwitchCase', "" + c.value, c.valueSourceSpan)], expansionResult.nodes, c.sourceSpan, c.sourceSpan, c.sourceSpan);
    });
    var /** @type {?} */ switchAttr = new Attribute$1('[ngSwitch]', ast.switchValue, ast.switchValueSourceSpan);
    return new Element('ng-container', [switchAttr], children, ast.sourceSpan, ast.sourceSpan, ast.sourceSpan);
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var ProviderError = (function (_super) {
    __extends(ProviderError, _super);
    /**
     * @param {?} message
     * @param {?} span
     */
    function ProviderError(message, span) {
        return _super.call(this, span, message) || this;
    }
    return ProviderError;
}(ParseError));
var ProviderViewContext = (function () {
    /**
     * @param {?} component
     */
    function ProviderViewContext(component) {
        var _this = this;
        this.component = component;
        this.errors = [];
        this.viewQueries = _getViewQueries(component);
        this.viewProviders = new Map();
        component.viewProviders.forEach(function (provider) {
            if (_this.viewProviders.get(tokenReference(provider.token)) == null) {
                _this.viewProviders.set(tokenReference(provider.token), true);
            }
        });
    }
    return ProviderViewContext;
}());
var ProviderElementContext = (function () {
    /**
     * @param {?} viewContext
     * @param {?} _parent
     * @param {?} _isViewRoot
     * @param {?} _directiveAsts
     * @param {?} attrs
     * @param {?} refs
     * @param {?} isTemplate
     * @param {?} contentQueryStartId
     * @param {?} _sourceSpan
     */
    function ProviderElementContext(viewContext, _parent, _isViewRoot, _directiveAsts, attrs, refs, isTemplate, contentQueryStartId, _sourceSpan) {
        var _this = this;
        this.viewContext = viewContext;
        this._parent = _parent;
        this._isViewRoot = _isViewRoot;
        this._directiveAsts = _directiveAsts;
        this._sourceSpan = _sourceSpan;
        this._transformedProviders = new Map();
        this._seenProviders = new Map();
        this._hasViewContainer = false;
        this._queriedTokens = new Map();
        this._attrs = {};
        attrs.forEach(function (attrAst) { return _this._attrs[attrAst.name] = attrAst.value; });
        var directivesMeta = _directiveAsts.map(function (directiveAst) { return directiveAst.directive; });
        this._allProviders =
            _resolveProvidersFromDirectives(directivesMeta, _sourceSpan, viewContext.errors);
        this._contentQueries = _getContentQueries(contentQueryStartId, directivesMeta);
        Array.from(this._allProviders.values()).forEach(function (provider) {
            _this._addQueryReadsTo(provider.token, provider.token, _this._queriedTokens);
        });
        if (isTemplate) {
            var templateRefId = createIdentifierToken(Identifiers.TemplateRef);
            this._addQueryReadsTo(templateRefId, templateRefId, this._queriedTokens);
        }
        refs.forEach(function (refAst) {
            var defaultQueryValue = refAst.value || createIdentifierToken(Identifiers.ElementRef);
            _this._addQueryReadsTo({ value: refAst.name }, defaultQueryValue, _this._queriedTokens);
        });
        if (this._queriedTokens.get(resolveIdentifier(Identifiers.ViewContainerRef))) {
            this._hasViewContainer = true;
        }
        // create the providers that we know are eager first
        Array.from(this._allProviders.values()).forEach(function (provider) {
            var eager = provider.eager || _this._queriedTokens.get(tokenReference(provider.token));
            if (eager) {
                _this._getOrCreateLocalProvider(provider.providerType, provider.token, true);
            }
        });
    }
    /**
     * @return {?}
     */
    ProviderElementContext.prototype.afterElement = function () {
        var _this = this;
        // collect lazy providers
        Array.from(this._allProviders.values()).forEach(function (provider) {
            _this._getOrCreateLocalProvider(provider.providerType, provider.token, false);
        });
    };
    Object.defineProperty(ProviderElementContext.prototype, "transformProviders", {
        /**
         * @return {?}
         */
        get: function () {
            return Array.from(this._transformedProviders.values());
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProviderElementContext.prototype, "transformedDirectiveAsts", {
        /**
         * @return {?}
         */
        get: function () {
            var /** @type {?} */ sortedProviderTypes = this.transformProviders.map(function (provider) { return provider.token.identifier; });
            var /** @type {?} */ sortedDirectives = this._directiveAsts.slice();
            sortedDirectives.sort(function (dir1, dir2) { return sortedProviderTypes.indexOf(dir1.directive.type) -
                sortedProviderTypes.indexOf(dir2.directive.type); });
            return sortedDirectives;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProviderElementContext.prototype, "transformedHasViewContainer", {
        /**
         * @return {?}
         */
        get: function () { return this._hasViewContainer; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProviderElementContext.prototype, "queryMatches", {
        /**
         * @return {?}
         */
        get: function () {
            var /** @type {?} */ allMatches = [];
            this._queriedTokens.forEach(function (matches) { allMatches.push.apply(allMatches, matches); });
            return allMatches;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} token
     * @param {?} defaultValue
     * @param {?} queryReadTokens
     * @return {?}
     */
    ProviderElementContext.prototype._addQueryReadsTo = function (token, defaultValue, queryReadTokens) {
        this._getQueriesFor(token).forEach(function (query) {
            var /** @type {?} */ queryValue = query.meta.read || defaultValue;
            var /** @type {?} */ tokenRef = tokenReference(queryValue);
            var /** @type {?} */ queryMatches = queryReadTokens.get(tokenRef);
            if (!queryMatches) {
                queryMatches = [];
                queryReadTokens.set(tokenRef, queryMatches);
            }
            queryMatches.push({ queryId: query.queryId, value: queryValue });
        });
    };
    /**
     * @param {?} token
     * @return {?}
     */
    ProviderElementContext.prototype._getQueriesFor = function (token) {
        var /** @type {?} */ result = [];
        var /** @type {?} */ currentEl = this;
        var /** @type {?} */ distance = 0;
        var /** @type {?} */ queries;
        while (currentEl !== null) {
            queries = currentEl._contentQueries.get(tokenReference(token));
            if (queries) {
                result.push.apply(result, queries.filter(function (query) { return query.meta.descendants || distance <= 1; }));
            }
            if (currentEl._directiveAsts.length > 0) {
                distance++;
            }
            currentEl = currentEl._parent;
        }
        queries = this.viewContext.viewQueries.get(tokenReference(token));
        if (queries) {
            result.push.apply(result, queries);
        }
        return result;
    };
    /**
     * @param {?} requestingProviderType
     * @param {?} token
     * @param {?} eager
     * @return {?}
     */
    ProviderElementContext.prototype._getOrCreateLocalProvider = function (requestingProviderType, token, eager) {
        var _this = this;
        var /** @type {?} */ resolvedProvider = this._allProviders.get(tokenReference(token));
        if (!resolvedProvider || ((requestingProviderType === ProviderAstType.Directive ||
            requestingProviderType === ProviderAstType.PublicService) &&
            resolvedProvider.providerType === ProviderAstType.PrivateService) ||
            ((requestingProviderType === ProviderAstType.PrivateService ||
                requestingProviderType === ProviderAstType.PublicService) &&
                resolvedProvider.providerType === ProviderAstType.Builtin)) {
            return null;
        }
        var /** @type {?} */ transformedProviderAst = this._transformedProviders.get(tokenReference(token));
        if (transformedProviderAst) {
            return transformedProviderAst;
        }
        if (this._seenProviders.get(tokenReference(token)) != null) {
            this.viewContext.errors.push(new ProviderError("Cannot instantiate cyclic dependency! " + tokenName(token), this._sourceSpan));
            return null;
        }
        this._seenProviders.set(tokenReference(token), true);
        var /** @type {?} */ transformedProviders = resolvedProvider.providers.map(function (provider) {
            var /** @type {?} */ transformedUseValue = provider.useValue;
            var /** @type {?} */ transformedUseExisting = ((provider.useExisting));
            var /** @type {?} */ transformedDeps = ((undefined));
            if (provider.useExisting != null) {
                var /** @type {?} */ existingDiDep = ((_this._getDependency(resolvedProvider.providerType, { token: provider.useExisting }, eager)));
                if (existingDiDep.token != null) {
                    transformedUseExisting = existingDiDep.token;
                }
                else {
                    transformedUseExisting = ((null));
                    transformedUseValue = existingDiDep.value;
                }
            }
            else if (provider.useFactory) {
                var /** @type {?} */ deps = provider.deps || provider.useFactory.diDeps;
                transformedDeps =
                    deps.map(function (dep) { return ((_this._getDependency(resolvedProvider.providerType, dep, eager))); });
            }
            else if (provider.useClass) {
                var /** @type {?} */ deps = provider.deps || provider.useClass.diDeps;
                transformedDeps =
                    deps.map(function (dep) { return ((_this._getDependency(resolvedProvider.providerType, dep, eager))); });
            }
            return _transformProvider(provider, {
                useExisting: transformedUseExisting,
                useValue: transformedUseValue,
                deps: transformedDeps
            });
        });
        transformedProviderAst =
            _transformProviderAst(resolvedProvider, { eager: eager, providers: transformedProviders });
        this._transformedProviders.set(tokenReference(token), transformedProviderAst);
        return transformedProviderAst;
    };
    /**
     * @param {?} requestingProviderType
     * @param {?} dep
     * @param {?=} eager
     * @return {?}
     */
    ProviderElementContext.prototype._getLocalDependency = function (requestingProviderType, dep, eager) {
        if (eager === void 0) { eager = false; }
        if (dep.isAttribute) {
            var /** @type {?} */ attrValue = this._attrs[((dep.token)).value];
            return { isValue: true, value: attrValue == null ? null : attrValue };
        }
        if (dep.token != null) {
            // access builtints
            if ((requestingProviderType === ProviderAstType.Directive ||
                requestingProviderType === ProviderAstType.Component)) {
                if (tokenReference(dep.token) === resolveIdentifier(Identifiers.Renderer) ||
                    tokenReference(dep.token) === resolveIdentifier(Identifiers.ElementRef) ||
                    tokenReference(dep.token) === resolveIdentifier(Identifiers.ChangeDetectorRef) ||
                    tokenReference(dep.token) === resolveIdentifier(Identifiers.TemplateRef)) {
                    return dep;
                }
                if (tokenReference(dep.token) === resolveIdentifier(Identifiers.ViewContainerRef)) {
                    this._hasViewContainer = true;
                }
            }
            // access the injector
            if (tokenReference(dep.token) === resolveIdentifier(Identifiers.Injector)) {
                return dep;
            }
            // access providers
            if (this._getOrCreateLocalProvider(requestingProviderType, dep.token, eager) != null) {
                return dep;
            }
        }
        return null;
    };
    /**
     * @param {?} requestingProviderType
     * @param {?} dep
     * @param {?=} eager
     * @return {?}
     */
    ProviderElementContext.prototype._getDependency = function (requestingProviderType, dep, eager) {
        if (eager === void 0) { eager = false; }
        var /** @type {?} */ currElement = this;
        var /** @type {?} */ currEager = eager;
        var /** @type {?} */ result = null;
        if (!dep.isSkipSelf) {
            result = this._getLocalDependency(requestingProviderType, dep, eager);
        }
        if (dep.isSelf) {
            if (!result && dep.isOptional) {
                result = { isValue: true, value: null };
            }
        }
        else {
            // check parent elements
            while (!result && currElement._parent) {
                var /** @type {?} */ prevElement = currElement;
                currElement = currElement._parent;
                if (prevElement._isViewRoot) {
                    currEager = false;
                }
                result = currElement._getLocalDependency(ProviderAstType.PublicService, dep, currEager);
            }
            // check @Host restriction
            if (!result) {
                if (!dep.isHost || this.viewContext.component.isHost ||
                    this.viewContext.component.type.reference === tokenReference(/** @type {?} */ ((dep.token))) ||
                    this.viewContext.viewProviders.get(tokenReference(/** @type {?} */ ((dep.token)))) != null) {
                    result = dep;
                }
                else {
                    result = dep.isOptional ? result = { isValue: true, value: null } : null;
                }
            }
        }
        if (!result) {
            this.viewContext.errors.push(new ProviderError("No provider for " + tokenName(/** @type {?} */ ((dep.token))), this._sourceSpan));
        }
        return result;
    };
    return ProviderElementContext;
}());
var NgModuleProviderAnalyzer = (function () {
    /**
     * @param {?} ngModule
     * @param {?} extraProviders
     * @param {?} sourceSpan
     */
    function NgModuleProviderAnalyzer(ngModule, extraProviders, sourceSpan) {
        var _this = this;
        this._transformedProviders = new Map();
        this._seenProviders = new Map();
        this._errors = [];
        this._allProviders = new Map();
        ngModule.transitiveModule.modules.forEach(function (ngModuleType) {
            var ngModuleProvider = { token: { identifier: ngModuleType }, useClass: ngModuleType };
            _resolveProviders([ngModuleProvider], ProviderAstType.PublicService, true, sourceSpan, _this._errors, _this._allProviders);
        });
        _resolveProviders(ngModule.transitiveModule.providers.map(function (entry) { return entry.provider; }).concat(extraProviders), ProviderAstType.PublicService, false, sourceSpan, this._errors, this._allProviders);
    }
    /**
     * @return {?}
     */
    NgModuleProviderAnalyzer.prototype.parse = function () {
        var _this = this;
        Array.from(this._allProviders.values()).forEach(function (provider) {
            _this._getOrCreateLocalProvider(provider.token, provider.eager);
        });
        if (this._errors.length > 0) {
            var /** @type {?} */ errorString = this._errors.join('\n');
            throw new Error("Provider parse errors:\n" + errorString);
        }
        return Array.from(this._transformedProviders.values());
    };
    /**
     * @param {?} token
     * @param {?} eager
     * @return {?}
     */
    NgModuleProviderAnalyzer.prototype._getOrCreateLocalProvider = function (token, eager) {
        var _this = this;
        var /** @type {?} */ resolvedProvider = this._allProviders.get(tokenReference(token));
        if (!resolvedProvider) {
            return null;
        }
        var /** @type {?} */ transformedProviderAst = this._transformedProviders.get(tokenReference(token));
        if (transformedProviderAst) {
            return transformedProviderAst;
        }
        if (this._seenProviders.get(tokenReference(token)) != null) {
            this._errors.push(new ProviderError("Cannot instantiate cyclic dependency! " + tokenName(token), resolvedProvider.sourceSpan));
            return null;
        }
        this._seenProviders.set(tokenReference(token), true);
        var /** @type {?} */ transformedProviders = resolvedProvider.providers.map(function (provider) {
            var /** @type {?} */ transformedUseValue = provider.useValue;
            var /** @type {?} */ transformedUseExisting = ((provider.useExisting));
            var /** @type {?} */ transformedDeps = ((undefined));
            if (provider.useExisting != null) {
                var /** @type {?} */ existingDiDep = _this._getDependency({ token: provider.useExisting }, eager, resolvedProvider.sourceSpan);
                if (existingDiDep.token != null) {
                    transformedUseExisting = existingDiDep.token;
                }
                else {
                    transformedUseExisting = ((null));
                    transformedUseValue = existingDiDep.value;
                }
            }
            else if (provider.useFactory) {
                var /** @type {?} */ deps = provider.deps || provider.useFactory.diDeps;
                transformedDeps =
                    deps.map(function (dep) { return _this._getDependency(dep, eager, resolvedProvider.sourceSpan); });
            }
            else if (provider.useClass) {
                var /** @type {?} */ deps = provider.deps || provider.useClass.diDeps;
                transformedDeps =
                    deps.map(function (dep) { return _this._getDependency(dep, eager, resolvedProvider.sourceSpan); });
            }
            return _transformProvider(provider, {
                useExisting: transformedUseExisting,
                useValue: transformedUseValue,
                deps: transformedDeps
            });
        });
        transformedProviderAst =
            _transformProviderAst(resolvedProvider, { eager: eager, providers: transformedProviders });
        this._transformedProviders.set(tokenReference(token), transformedProviderAst);
        return transformedProviderAst;
    };
    /**
     * @param {?} dep
     * @param {?=} eager
     * @param {?=} requestorSourceSpan
     * @return {?}
     */
    NgModuleProviderAnalyzer.prototype._getDependency = function (dep, eager, requestorSourceSpan) {
        if (eager === void 0) { eager = false; }
        var /** @type {?} */ foundLocal = false;
        if (!dep.isSkipSelf && dep.token != null) {
            // access the injector
            if (tokenReference(dep.token) === resolveIdentifier(Identifiers.Injector) ||
                tokenReference(dep.token) === resolveIdentifier(Identifiers.ComponentFactoryResolver)) {
                foundLocal = true;
            }
            else if (this._getOrCreateLocalProvider(dep.token, eager) != null) {
                foundLocal = true;
            }
        }
        var /** @type {?} */ result = dep;
        if (dep.isSelf && !foundLocal) {
            if (dep.isOptional) {
                result = { isValue: true, value: null };
            }
            else {
                this._errors.push(new ProviderError("No provider for " + tokenName(/** @type {?} */ ((dep.token))), requestorSourceSpan));
            }
        }
        return result;
    };
    return NgModuleProviderAnalyzer;
}());
/**
 * @param {?} provider
 * @param {?} __1
 * @return {?}
 */
function _transformProvider(provider, _a) {
    var useExisting = _a.useExisting, useValue = _a.useValue, deps = _a.deps;
    return {
        token: provider.token,
        useClass: provider.useClass,
        useExisting: useExisting,
        useFactory: provider.useFactory,
        useValue: useValue,
        deps: deps,
        multi: provider.multi
    };
}
/**
 * @param {?} provider
 * @param {?} __1
 * @return {?}
 */
function _transformProviderAst(provider, _a) {
    var eager = _a.eager, providers = _a.providers;
    return new ProviderAst(provider.token, provider.multiProvider, provider.eager || eager, providers, provider.providerType, provider.lifecycleHooks, provider.sourceSpan);
}
/**
 * @param {?} directives
 * @param {?} sourceSpan
 * @param {?} targetErrors
 * @return {?}
 */
function _resolveProvidersFromDirectives(directives, sourceSpan, targetErrors) {
    var /** @type {?} */ providersByToken = new Map();
    directives.forEach(function (directive) {
        var /** @type {?} */ dirProvider = { token: { identifier: directive.type }, useClass: directive.type };
        _resolveProviders([dirProvider], directive.isComponent ? ProviderAstType.Component : ProviderAstType.Directive, true, sourceSpan, targetErrors, providersByToken);
    });
    // Note: directives need to be able to overwrite providers of a component!
    var /** @type {?} */ directivesWithComponentFirst = directives.filter(function (dir) { return dir.isComponent; }).concat(directives.filter(function (dir) { return !dir.isComponent; }));
    directivesWithComponentFirst.forEach(function (directive) {
        _resolveProviders(directive.providers, ProviderAstType.PublicService, false, sourceSpan, targetErrors, providersByToken);
        _resolveProviders(directive.viewProviders, ProviderAstType.PrivateService, false, sourceSpan, targetErrors, providersByToken);
    });
    return providersByToken;
}
/**
 * @param {?} providers
 * @param {?} providerType
 * @param {?} eager
 * @param {?} sourceSpan
 * @param {?} targetErrors
 * @param {?} targetProvidersByToken
 * @return {?}
 */
function _resolveProviders(providers, providerType, eager, sourceSpan, targetErrors, targetProvidersByToken) {
    providers.forEach(function (provider) {
        var /** @type {?} */ resolvedProvider = targetProvidersByToken.get(tokenReference(provider.token));
        if (resolvedProvider != null && !!resolvedProvider.multiProvider !== !!provider.multi) {
            targetErrors.push(new ProviderError("Mixing multi and non multi provider is not possible for token " + tokenName(resolvedProvider.token), sourceSpan));
        }
        if (!resolvedProvider) {
            var /** @type {?} */ lifecycleHooks = provider.token.identifier &&
                ((provider.token.identifier)).lifecycleHooks ?
                ((provider.token.identifier)).lifecycleHooks :
                [];
            var /** @type {?} */ isUseValue = !(provider.useClass || provider.useExisting || provider.useFactory);
            resolvedProvider = new ProviderAst(provider.token, !!provider.multi, eager || isUseValue, [provider], providerType, lifecycleHooks, sourceSpan);
            targetProvidersByToken.set(tokenReference(provider.token), resolvedProvider);
        }
        else {
            if (!provider.multi) {
                resolvedProvider.providers.length = 0;
            }
            resolvedProvider.providers.push(provider);
        }
    });
}
/**
 * @param {?} component
 * @return {?}
 */
function _getViewQueries(component) {
    // Note: queries start with id 1 so we can use the number in a Bloom filter!
    var /** @type {?} */ viewQueryId = 1;
    var /** @type {?} */ viewQueries = new Map();
    if (component.viewQueries) {
        component.viewQueries.forEach(function (query) { return _addQueryToTokenMap(viewQueries, { meta: query, queryId: viewQueryId++ }); });
    }
    return viewQueries;
}
/**
 * @param {?} contentQueryStartId
 * @param {?} directives
 * @return {?}
 */
function _getContentQueries(contentQueryStartId, directives) {
    var /** @type {?} */ contentQueryId = contentQueryStartId;
    var /** @type {?} */ contentQueries = new Map();
    directives.forEach(function (directive, directiveIndex) {
        if (directive.queries) {
            directive.queries.forEach(function (query) { return _addQueryToTokenMap(contentQueries, { meta: query, queryId: contentQueryId++ }); });
        }
    });
    return contentQueries;
}
/**
 * @param {?} map
 * @param {?} query
 * @return {?}
 */
function _addQueryToTokenMap(map, query) {
    query.meta.selectors.forEach(function (token) {
        var /** @type {?} */ entry = map.get(tokenReference(token));
        if (!entry) {
            entry = [];
            map.set(tokenReference(token), entry);
        }
        entry.push(query);
    });
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @abstract
 */
var ElementSchemaRegistry = (function () {
    function ElementSchemaRegistry() {
    }
    /**
     * @abstract
     * @param {?} tagName
     * @param {?} propName
     * @param {?} schemaMetas
     * @return {?}
     */
    ElementSchemaRegistry.prototype.hasProperty = function (tagName, propName, schemaMetas) { };
    /**
     * @abstract
     * @param {?} tagName
     * @param {?} schemaMetas
     * @return {?}
     */
    ElementSchemaRegistry.prototype.hasElement = function (tagName, schemaMetas) { };
    /**
     * @abstract
     * @param {?} elementName
     * @param {?} propName
     * @param {?} isAttribute
     * @return {?}
     */
    ElementSchemaRegistry.prototype.securityContext = function (elementName, propName, isAttribute) { };
    /**
     * @abstract
     * @return {?}
     */
    ElementSchemaRegistry.prototype.allKnownElementNames = function () { };
    /**
     * @abstract
     * @param {?} propName
     * @return {?}
     */
    ElementSchemaRegistry.prototype.getMappedPropName = function (propName) { };
    /**
     * @abstract
     * @return {?}
     */
    ElementSchemaRegistry.prototype.getDefaultComponentElementName = function () { };
    /**
     * @abstract
     * @param {?} name
     * @return {?}
     */
    ElementSchemaRegistry.prototype.validateProperty = function (name) { };
    /**
     * @abstract
     * @param {?} name
     * @return {?}
     */
    ElementSchemaRegistry.prototype.validateAttribute = function (name) { };
    /**
     * @abstract
     * @param {?} propName
     * @return {?}
     */
    ElementSchemaRegistry.prototype.normalizeAnimationStyleProperty = function (propName) { };
    /**
     * @abstract
     * @param {?} camelCaseProp
     * @param {?} userProvidedProp
     * @param {?} val
     * @return {?}
     */
    ElementSchemaRegistry.prototype.normalizeAnimationStyleValue = function (camelCaseProp, userProvidedProp, val) { };
    return ElementSchemaRegistry;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var StyleWithImports = (function () {
    /**
     * @param {?} style
     * @param {?} styleUrls
     */
    function StyleWithImports(style$$1, styleUrls) {
        this.style = style$$1;
        this.styleUrls = styleUrls;
    }
    return StyleWithImports;
}());
/**
 * @param {?} url
 * @return {?}
 */
function isStyleUrlResolvable(url) {
    if (url == null || url.length === 0 || url[0] == '/')
        return false;
    var /** @type {?} */ schemeMatch = url.match(URL_WITH_SCHEMA_REGEXP);
    return schemeMatch === null || schemeMatch[1] == 'package' || schemeMatch[1] == 'asset';
}
/**
 * Rewrites stylesheets by resolving and removing the \@import urls that
 * are either relative or don't have a `package:` scheme
 * @param {?} resolver
 * @param {?} baseUrl
 * @param {?} cssText
 * @return {?}
 */
function extractStyleUrls(resolver, baseUrl, cssText) {
    var /** @type {?} */ foundUrls = [];
    var /** @type {?} */ modifiedCssText = cssText.replace(CSS_COMMENT_REGEXP, '').replace(CSS_IMPORT_REGEXP, function () {
        var m = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            m[_i] = arguments[_i];
        }
        var /** @type {?} */ url = m[1] || m[2];
        if (!isStyleUrlResolvable(url)) {
            // Do not attempt to resolve non-package absolute URLs with URI scheme
            return m[0];
        }
        foundUrls.push(resolver.resolve(baseUrl, url));
        return '';
    });
    return new StyleWithImports(modifiedCssText, foundUrls);
}
var CSS_IMPORT_REGEXP = /@import\s+(?:url\()?\s*(?:(?:['"]([^'"]*))|([^;\)\s]*))[^;]*;?/g;
var CSS_COMMENT_REGEXP = /\/\*.+?\*\//g;
var URL_WITH_SCHEMA_REGEXP = /^([^:/?#]+):/;
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var PROPERTY_PARTS_SEPARATOR = '.';
var ATTRIBUTE_PREFIX = 'attr';
var CLASS_PREFIX = 'class';
var STYLE_PREFIX = 'style';
var ANIMATE_PROP_PREFIX = 'animate-';
var BoundPropertyType = {};
BoundPropertyType.DEFAULT = 0;
BoundPropertyType.LITERAL_ATTR = 1;
BoundPropertyType.ANIMATION = 2;
BoundPropertyType[BoundPropertyType.DEFAULT] = "DEFAULT";
BoundPropertyType[BoundPropertyType.LITERAL_ATTR] = "LITERAL_ATTR";
BoundPropertyType[BoundPropertyType.ANIMATION] = "ANIMATION";
/**
 * Represents a parsed property.
 */
var BoundProperty = (function () {
    /**
     * @param {?} name
     * @param {?} expression
     * @param {?} type
     * @param {?} sourceSpan
     */
    function BoundProperty(name, expression, type, sourceSpan) {
        this.name = name;
        this.expression = expression;
        this.type = type;
        this.sourceSpan = sourceSpan;
    }
    Object.defineProperty(BoundProperty.prototype, "isLiteral", {
        /**
         * @return {?}
         */
        get: function () { return this.type === BoundPropertyType.LITERAL_ATTR; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BoundProperty.prototype, "isAnimation", {
        /**
         * @return {?}
         */
        get: function () { return this.type === BoundPropertyType.ANIMATION; },
        enumerable: true,
        configurable: true
    });
    return BoundProperty;
}());
/**
 * Parses bindings in templates and in the directive host area.
 */
var BindingParser = (function () {
    /**
     * @param {?} _exprParser
     * @param {?} _interpolationConfig
     * @param {?} _schemaRegistry
     * @param {?} pipes
     * @param {?} _targetErrors
     */
    function BindingParser(_exprParser, _interpolationConfig, _schemaRegistry, pipes, _targetErrors) {
        var _this = this;
        this._exprParser = _exprParser;
        this._interpolationConfig = _interpolationConfig;
        this._schemaRegistry = _schemaRegistry;
        this._targetErrors = _targetErrors;
        this.pipesByName = new Map();
        this._usedPipes = new Map();
        pipes.forEach(function (pipe) { return _this.pipesByName.set(pipe.name, pipe); });
    }
    /**
     * @return {?}
     */
    BindingParser.prototype.getUsedPipes = function () { return Array.from(this._usedPipes.values()); };
    /**
     * @param {?} dirMeta
     * @param {?} elementSelector
     * @param {?} sourceSpan
     * @return {?}
     */
    BindingParser.prototype.createDirectiveHostPropertyAsts = function (dirMeta, elementSelector, sourceSpan) {
        var _this = this;
        if (dirMeta.hostProperties) {
            var /** @type {?} */ boundProps_1 = [];
            Object.keys(dirMeta.hostProperties).forEach(function (propName) {
                var /** @type {?} */ expression = dirMeta.hostProperties[propName];
                if (typeof expression === 'string') {
                    _this.parsePropertyBinding(propName, expression, true, sourceSpan, [], boundProps_1);
                }
                else {
                    _this._reportError("Value of the host property binding \"" + propName + "\" needs to be a string representing an expression but got \"" + expression + "\" (" + typeof expression + ")", sourceSpan);
                }
            });
            return boundProps_1.map(function (prop) { return _this.createElementPropertyAst(elementSelector, prop); });
        }
        return null;
    };
    /**
     * @param {?} dirMeta
     * @param {?} sourceSpan
     * @return {?}
     */
    BindingParser.prototype.createDirectiveHostEventAsts = function (dirMeta, sourceSpan) {
        var _this = this;
        if (dirMeta.hostListeners) {
            var /** @type {?} */ targetEventAsts_1 = [];
            Object.keys(dirMeta.hostListeners).forEach(function (propName) {
                var /** @type {?} */ expression = dirMeta.hostListeners[propName];
                if (typeof expression === 'string') {
                    _this.parseEvent(propName, expression, sourceSpan, [], targetEventAsts_1);
                }
                else {
                    _this._reportError("Value of the host listener \"" + propName + "\" needs to be a string representing an expression but got \"" + expression + "\" (" + typeof expression + ")", sourceSpan);
                }
            });
            return targetEventAsts_1;
        }
        return null;
    };
    /**
     * @param {?} value
     * @param {?} sourceSpan
     * @return {?}
     */
    BindingParser.prototype.parseInterpolation = function (value, sourceSpan) {
        var /** @type {?} */ sourceInfo = sourceSpan.start.toString();
        try {
            var /** @type {?} */ ast = ((this._exprParser.parseInterpolation(value, sourceInfo, this._interpolationConfig)));
            if (ast)
                this._reportExpressionParserErrors(ast.errors, sourceSpan);
            this._checkPipes(ast, sourceSpan);
            return ast;
        }
        catch (e) {
            this._reportError("" + e, sourceSpan);
            return this._exprParser.wrapLiteralPrimitive('ERROR', sourceInfo);
        }
    };
    /**
     * @param {?} prefixToken
     * @param {?} value
     * @param {?} sourceSpan
     * @param {?} targetMatchableAttrs
     * @param {?} targetProps
     * @param {?} targetVars
     * @return {?}
     */
    BindingParser.prototype.parseInlineTemplateBinding = function (prefixToken, value, sourceSpan, targetMatchableAttrs, targetProps, targetVars) {
        var /** @type {?} */ bindings = this._parseTemplateBindings(prefixToken, value, sourceSpan);
        for (var /** @type {?} */ i = 0; i < bindings.length; i++) {
            var /** @type {?} */ binding = bindings[i];
            if (binding.keyIsVar) {
                targetVars.push(new VariableAst(binding.key, binding.name, sourceSpan));
            }
            else if (binding.expression) {
                this._parsePropertyAst(binding.key, binding.expression, sourceSpan, targetMatchableAttrs, targetProps);
            }
            else {
                targetMatchableAttrs.push([binding.key, '']);
                this.parseLiteralAttr(binding.key, null, sourceSpan, targetMatchableAttrs, targetProps);
            }
        }
    };
    /**
     * @param {?} prefixToken
     * @param {?} value
     * @param {?} sourceSpan
     * @return {?}
     */
    BindingParser.prototype._parseTemplateBindings = function (prefixToken, value, sourceSpan) {
        var _this = this;
        var /** @type {?} */ sourceInfo = sourceSpan.start.toString();
        try {
            var /** @type {?} */ bindingsResult = this._exprParser.parseTemplateBindings(prefixToken, value, sourceInfo);
            this._reportExpressionParserErrors(bindingsResult.errors, sourceSpan);
            bindingsResult.templateBindings.forEach(function (binding) {
                if (binding.expression) {
                    _this._checkPipes(binding.expression, sourceSpan);
                }
            });
            bindingsResult.warnings.forEach(function (warning) { _this._reportError(warning, sourceSpan, ParseErrorLevel.WARNING); });
            return bindingsResult.templateBindings;
        }
        catch (e) {
            this._reportError("" + e, sourceSpan);
            return [];
        }
    };
    /**
     * @param {?} name
     * @param {?} value
     * @param {?} sourceSpan
     * @param {?} targetMatchableAttrs
     * @param {?} targetProps
     * @return {?}
     */
    BindingParser.prototype.parseLiteralAttr = function (name, value, sourceSpan, targetMatchableAttrs, targetProps) {
        if (_isAnimationLabel(name)) {
            name = name.substring(1);
            if (value) {
                this._reportError("Assigning animation triggers via @prop=\"exp\" attributes with an expression is invalid." +
                    " Use property bindings (e.g. [@prop]=\"exp\") or use an attribute without a value (e.g. @prop) instead.", sourceSpan, ParseErrorLevel.ERROR);
            }
            this._parseAnimation(name, value, sourceSpan, targetMatchableAttrs, targetProps);
        }
        else {
            targetProps.push(new BoundProperty(name, this._exprParser.wrapLiteralPrimitive(value, ''), BoundPropertyType.LITERAL_ATTR, sourceSpan));
        }
    };
    /**
     * @param {?} name
     * @param {?} expression
     * @param {?} isHost
     * @param {?} sourceSpan
     * @param {?} targetMatchableAttrs
     * @param {?} targetProps
     * @return {?}
     */
    BindingParser.prototype.parsePropertyBinding = function (name, expression, isHost, sourceSpan, targetMatchableAttrs, targetProps) {
        var /** @type {?} */ isAnimationProp = false;
        if (name.startsWith(ANIMATE_PROP_PREFIX)) {
            isAnimationProp = true;
            name = name.substring(ANIMATE_PROP_PREFIX.length);
        }
        else if (_isAnimationLabel(name)) {
            isAnimationProp = true;
            name = name.substring(1);
        }
        if (isAnimationProp) {
            this._parseAnimation(name, expression, sourceSpan, targetMatchableAttrs, targetProps);
        }
        else {
            this._parsePropertyAst(name, this._parseBinding(expression, isHost, sourceSpan), sourceSpan, targetMatchableAttrs, targetProps);
        }
    };
    /**
     * @param {?} name
     * @param {?} value
     * @param {?} sourceSpan
     * @param {?} targetMatchableAttrs
     * @param {?} targetProps
     * @return {?}
     */
    BindingParser.prototype.parsePropertyInterpolation = function (name, value, sourceSpan, targetMatchableAttrs, targetProps) {
        var /** @type {?} */ expr = this.parseInterpolation(value, sourceSpan);
        if (expr) {
            this._parsePropertyAst(name, expr, sourceSpan, targetMatchableAttrs, targetProps);
            return true;
        }
        return false;
    };
    /**
     * @param {?} name
     * @param {?} ast
     * @param {?} sourceSpan
     * @param {?} targetMatchableAttrs
     * @param {?} targetProps
     * @return {?}
     */
    BindingParser.prototype._parsePropertyAst = function (name, ast, sourceSpan, targetMatchableAttrs, targetProps) {
        targetMatchableAttrs.push([name, /** @type {?} */ ((ast.source))]);
        targetProps.push(new BoundProperty(name, ast, BoundPropertyType.DEFAULT, sourceSpan));
    };
    /**
     * @param {?} name
     * @param {?} expression
     * @param {?} sourceSpan
     * @param {?} targetMatchableAttrs
     * @param {?} targetProps
     * @return {?}
     */
    BindingParser.prototype._parseAnimation = function (name, expression, sourceSpan, targetMatchableAttrs, targetProps) {
        // This will occur when a @trigger is not paired with an expression.
        // For animations it is valid to not have an expression since */void
        // states will be applied by angular when the element is attached/detached
        var /** @type {?} */ ast = this._parseBinding(expression || 'null', false, sourceSpan);
        targetMatchableAttrs.push([name, /** @type {?} */ ((ast.source))]);
        targetProps.push(new BoundProperty(name, ast, BoundPropertyType.ANIMATION, sourceSpan));
    };
    /**
     * @param {?} value
     * @param {?} isHostBinding
     * @param {?} sourceSpan
     * @return {?}
     */
    BindingParser.prototype._parseBinding = function (value, isHostBinding, sourceSpan) {
        var /** @type {?} */ sourceInfo = sourceSpan.start.toString();
        try {
            var /** @type {?} */ ast = isHostBinding ?
                this._exprParser.parseSimpleBinding(value, sourceInfo, this._interpolationConfig) :
                this._exprParser.parseBinding(value, sourceInfo, this._interpolationConfig);
            if (ast)
                this._reportExpressionParserErrors(ast.errors, sourceSpan);
            this._checkPipes(ast, sourceSpan);
            return ast;
        }
        catch (e) {
            this._reportError("" + e, sourceSpan);
            return this._exprParser.wrapLiteralPrimitive('ERROR', sourceInfo);
        }
    };
    /**
     * @param {?} elementSelector
     * @param {?} boundProp
     * @return {?}
     */
    BindingParser.prototype.createElementPropertyAst = function (elementSelector, boundProp) {
        if (boundProp.isAnimation) {
            return new BoundElementPropertyAst(boundProp.name, PropertyBindingType.Animation, __WEBPACK_IMPORTED_MODULE_0__angular_core__["SecurityContext"].NONE, boundProp.expression, null, boundProp.sourceSpan);
        }
        var /** @type {?} */ unit = null;
        var /** @type {?} */ bindingType = ((undefined));
        var /** @type {?} */ boundPropertyName = null;
        var /** @type {?} */ parts = boundProp.name.split(PROPERTY_PARTS_SEPARATOR);
        var /** @type {?} */ securityContexts = ((undefined));
        // Check check for special cases (prefix style, attr, class)
        if (parts.length > 1) {
            if (parts[0] == ATTRIBUTE_PREFIX) {
                boundPropertyName = parts[1];
                this._validatePropertyOrAttributeName(boundPropertyName, boundProp.sourceSpan, true);
                securityContexts = calcPossibleSecurityContexts(this._schemaRegistry, elementSelector, boundPropertyName, true);
                var /** @type {?} */ nsSeparatorIdx = boundPropertyName.indexOf(':');
                if (nsSeparatorIdx > -1) {
                    var /** @type {?} */ ns = boundPropertyName.substring(0, nsSeparatorIdx);
                    var /** @type {?} */ name = boundPropertyName.substring(nsSeparatorIdx + 1);
                    boundPropertyName = mergeNsAndName(ns, name);
                }
                bindingType = PropertyBindingType.Attribute;
            }
            else if (parts[0] == CLASS_PREFIX) {
                boundPropertyName = parts[1];
                bindingType = PropertyBindingType.Class;
                securityContexts = [__WEBPACK_IMPORTED_MODULE_0__angular_core__["SecurityContext"].NONE];
            }
            else if (parts[0] == STYLE_PREFIX) {
                unit = parts.length > 2 ? parts[2] : null;
                boundPropertyName = parts[1];
                bindingType = PropertyBindingType.Style;
                securityContexts = [__WEBPACK_IMPORTED_MODULE_0__angular_core__["SecurityContext"].STYLE];
            }
        }
        // If not a special case, use the full property name
        if (boundPropertyName === null) {
            boundPropertyName = this._schemaRegistry.getMappedPropName(boundProp.name);
            securityContexts = calcPossibleSecurityContexts(this._schemaRegistry, elementSelector, boundPropertyName, false);
            bindingType = PropertyBindingType.Property;
            this._validatePropertyOrAttributeName(boundPropertyName, boundProp.sourceSpan, false);
        }
        return new BoundElementPropertyAst(boundPropertyName, bindingType, securityContexts[0], boundProp.expression, unit, boundProp.sourceSpan);
    };
    /**
     * @param {?} name
     * @param {?} expression
     * @param {?} sourceSpan
     * @param {?} targetMatchableAttrs
     * @param {?} targetEvents
     * @return {?}
     */
    BindingParser.prototype.parseEvent = function (name, expression, sourceSpan, targetMatchableAttrs, targetEvents) {
        if (_isAnimationLabel(name)) {
            name = name.substr(1);
            this._parseAnimationEvent(name, expression, sourceSpan, targetEvents);
        }
        else {
            this._parseEvent(name, expression, sourceSpan, targetMatchableAttrs, targetEvents);
        }
    };
    /**
     * @param {?} name
     * @param {?} expression
     * @param {?} sourceSpan
     * @param {?} targetEvents
     * @return {?}
     */
    BindingParser.prototype._parseAnimationEvent = function (name, expression, sourceSpan, targetEvents) {
        var /** @type {?} */ matches = splitAtPeriod(name, [name, '']);
        var /** @type {?} */ eventName = matches[0];
        var /** @type {?} */ phase = matches[1].toLowerCase();
        if (phase) {
            switch (phase) {
                case 'start':
                case 'done':
                    var /** @type {?} */ ast = this._parseAction(expression, sourceSpan);
                    targetEvents.push(new BoundEventAst(eventName, null, phase, ast, sourceSpan));
                    break;
                default:
                    this._reportError("The provided animation output phase value \"" + phase + "\" for \"@" + eventName + "\" is not supported (use start or done)", sourceSpan);
                    break;
            }
        }
        else {
            this._reportError("The animation trigger output event (@" + eventName + ") is missing its phase value name (start or done are currently supported)", sourceSpan);
        }
    };
    /**
     * @param {?} name
     * @param {?} expression
     * @param {?} sourceSpan
     * @param {?} targetMatchableAttrs
     * @param {?} targetEvents
     * @return {?}
     */
    BindingParser.prototype._parseEvent = function (name, expression, sourceSpan, targetMatchableAttrs, targetEvents) {
        // long format: 'target: eventName'
        var _a = splitAtColon(name, [/** @type {?} */ ((null)), name]), target = _a[0], eventName = _a[1];
        var /** @type {?} */ ast = this._parseAction(expression, sourceSpan);
        targetMatchableAttrs.push([/** @type {?} */ ((name)), /** @type {?} */ ((ast.source))]);
        targetEvents.push(new BoundEventAst(eventName, target, null, ast, sourceSpan));
        // Don't detect directives for event names for now,
        // so don't add the event name to the matchableAttrs
    };
    /**
     * @param {?} value
     * @param {?} sourceSpan
     * @return {?}
     */
    BindingParser.prototype._parseAction = function (value, sourceSpan) {
        var /** @type {?} */ sourceInfo = sourceSpan.start.toString();
        try {
            var /** @type {?} */ ast = this._exprParser.parseAction(value, sourceInfo, this._interpolationConfig);
            if (ast) {
                this._reportExpressionParserErrors(ast.errors, sourceSpan);
            }
            if (!ast || ast.ast instanceof EmptyExpr) {
                this._reportError("Empty expressions are not allowed", sourceSpan);
                return this._exprParser.wrapLiteralPrimitive('ERROR', sourceInfo);
            }
            this._checkPipes(ast, sourceSpan);
            return ast;
        }
        catch (e) {
            this._reportError("" + e, sourceSpan);
            return this._exprParser.wrapLiteralPrimitive('ERROR', sourceInfo);
        }
    };
    /**
     * @param {?} message
     * @param {?} sourceSpan
     * @param {?=} level
     * @return {?}
     */
    BindingParser.prototype._reportError = function (message, sourceSpan, level) {
        if (level === void 0) { level = ParseErrorLevel.ERROR; }
        this._targetErrors.push(new ParseError(sourceSpan, message, level));
    };
    /**
     * @param {?} errors
     * @param {?} sourceSpan
     * @return {?}
     */
    BindingParser.prototype._reportExpressionParserErrors = function (errors, sourceSpan) {
        for (var _i = 0, errors_1 = errors; _i < errors_1.length; _i++) {
            var error = errors_1[_i];
            this._reportError(error.message, sourceSpan);
        }
    };
    /**
     * @param {?} ast
     * @param {?} sourceSpan
     * @return {?}
     */
    BindingParser.prototype._checkPipes = function (ast, sourceSpan) {
        var _this = this;
        if (ast) {
            var /** @type {?} */ collector = new PipeCollector();
            ast.visit(collector);
            collector.pipes.forEach(function (ast, pipeName) {
                var /** @type {?} */ pipeMeta = _this.pipesByName.get(pipeName);
                if (!pipeMeta) {
                    _this._reportError("The pipe '" + pipeName + "' could not be found", new ParseSourceSpan(sourceSpan.start.moveBy(ast.span.start), sourceSpan.start.moveBy(ast.span.end)));
                }
                else {
                    _this._usedPipes.set(pipeName, pipeMeta);
                }
            });
        }
    };
    /**
     * @param {?} propName the name of the property / attribute
     * @param {?} sourceSpan
     * @param {?} isAttr true when binding to an attribute
     * @return {?}
     */
    BindingParser.prototype._validatePropertyOrAttributeName = function (propName, sourceSpan, isAttr) {
        var /** @type {?} */ report = isAttr ? this._schemaRegistry.validateAttribute(propName) :
            this._schemaRegistry.validateProperty(propName);
        if (report.error) {
            this._reportError(/** @type {?} */ ((report.msg)), sourceSpan, ParseErrorLevel.ERROR);
        }
    };
    return BindingParser;
}());
var PipeCollector = (function (_super) {
    __extends(PipeCollector, _super);
    function PipeCollector() {
        var _this = _super.apply(this, arguments) || this;
        _this.pipes = new Map();
        return _this;
    }
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    PipeCollector.prototype.visitPipe = function (ast, context) {
        this.pipes.set(ast.name, ast);
        ast.exp.visit(this);
        this.visitAll(ast.args, context);
        return null;
    };
    return PipeCollector;
}(RecursiveAstVisitor));
/**
 * @param {?} name
 * @return {?}
 */
function _isAnimationLabel(name) {
    return name[0] == '@';
}
/**
 * @param {?} registry
 * @param {?} selector
 * @param {?} propName
 * @param {?} isAttribute
 * @return {?}
 */
function calcPossibleSecurityContexts(registry, selector, propName, isAttribute) {
    var /** @type {?} */ ctxs = [];
    CssSelector.parse(selector).forEach(function (selector) {
        var /** @type {?} */ elementNames = selector.element ? [selector.element] : registry.allKnownElementNames();
        var /** @type {?} */ notElementNames = new Set(selector.notSelectors.filter(function (selector) { return selector.isElementSelector(); })
            .map(function (selector) { return selector.element; }));
        var /** @type {?} */ possibleElementNames = elementNames.filter(function (elementName) { return !notElementNames.has(elementName); });
        ctxs.push.apply(ctxs, possibleElementNames.map(function (elementName) { return registry.securityContext(elementName, propName, isAttribute); }));
    });
    return ctxs.length === 0 ? [__WEBPACK_IMPORTED_MODULE_0__angular_core__["SecurityContext"].NONE] : Array.from(new Set(ctxs)).sort();
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var NG_CONTENT_SELECT_ATTR = 'select';
var LINK_ELEMENT = 'link';
var LINK_STYLE_REL_ATTR = 'rel';
var LINK_STYLE_HREF_ATTR = 'href';
var LINK_STYLE_REL_VALUE = 'stylesheet';
var STYLE_ELEMENT = 'style';
var SCRIPT_ELEMENT = 'script';
var NG_NON_BINDABLE_ATTR = 'ngNonBindable';
var NG_PROJECT_AS = 'ngProjectAs';
/**
 * @param {?} ast
 * @return {?}
 */
function preparseElement(ast) {
    var /** @type {?} */ selectAttr = ((null));
    var /** @type {?} */ hrefAttr = ((null));
    var /** @type {?} */ relAttr = ((null));
    var /** @type {?} */ nonBindable = false;
    var /** @type {?} */ projectAs = ((null));
    ast.attrs.forEach(function (attr) {
        var /** @type {?} */ lcAttrName = attr.name.toLowerCase();
        if (lcAttrName == NG_CONTENT_SELECT_ATTR) {
            selectAttr = attr.value;
        }
        else if (lcAttrName == LINK_STYLE_HREF_ATTR) {
            hrefAttr = attr.value;
        }
        else if (lcAttrName == LINK_STYLE_REL_ATTR) {
            relAttr = attr.value;
        }
        else if (attr.name == NG_NON_BINDABLE_ATTR) {
            nonBindable = true;
        }
        else if (attr.name == NG_PROJECT_AS) {
            if (attr.value.length > 0) {
                projectAs = attr.value;
            }
        }
    });
    selectAttr = normalizeNgContentSelect(selectAttr);
    var /** @type {?} */ nodeName = ast.name.toLowerCase();
    var /** @type {?} */ type = PreparsedElementType.OTHER;
    if (isNgContent(nodeName)) {
        type = PreparsedElementType.NG_CONTENT;
    }
    else if (nodeName == STYLE_ELEMENT) {
        type = PreparsedElementType.STYLE;
    }
    else if (nodeName == SCRIPT_ELEMENT) {
        type = PreparsedElementType.SCRIPT;
    }
    else if (nodeName == LINK_ELEMENT && relAttr == LINK_STYLE_REL_VALUE) {
        type = PreparsedElementType.STYLESHEET;
    }
    return new PreparsedElement(type, selectAttr, hrefAttr, nonBindable, projectAs);
}
var PreparsedElementType = {};
PreparsedElementType.NG_CONTENT = 0;
PreparsedElementType.STYLE = 1;
PreparsedElementType.STYLESHEET = 2;
PreparsedElementType.SCRIPT = 3;
PreparsedElementType.OTHER = 4;
PreparsedElementType[PreparsedElementType.NG_CONTENT] = "NG_CONTENT";
PreparsedElementType[PreparsedElementType.STYLE] = "STYLE";
PreparsedElementType[PreparsedElementType.STYLESHEET] = "STYLESHEET";
PreparsedElementType[PreparsedElementType.SCRIPT] = "SCRIPT";
PreparsedElementType[PreparsedElementType.OTHER] = "OTHER";
var PreparsedElement = (function () {
    /**
     * @param {?} type
     * @param {?} selectAttr
     * @param {?} hrefAttr
     * @param {?} nonBindable
     * @param {?} projectAs
     */
    function PreparsedElement(type, selectAttr, hrefAttr, nonBindable, projectAs) {
        this.type = type;
        this.selectAttr = selectAttr;
        this.hrefAttr = hrefAttr;
        this.nonBindable = nonBindable;
        this.projectAs = projectAs;
    }
    return PreparsedElement;
}());
/**
 * @param {?} selectAttr
 * @return {?}
 */
function normalizeNgContentSelect(selectAttr) {
    if (selectAttr === null || selectAttr.length === 0) {
        return '*';
    }
    return selectAttr;
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var BIND_NAME_REGEXP = /^(?:(?:(?:(bind-)|(let-)|(ref-|#)|(on-)|(bindon-)|(@))(.+))|\[\(([^\)]+)\)\]|\[([^\]]+)\]|\(([^\)]+)\))$/;
// Group 1 = "bind-"
var KW_BIND_IDX = 1;
// Group 2 = "let-"
var KW_LET_IDX = 2;
// Group 3 = "ref-/#"
var KW_REF_IDX = 3;
// Group 4 = "on-"
var KW_ON_IDX = 4;
// Group 5 = "bindon-"
var KW_BINDON_IDX = 5;
// Group 6 = "@"
var KW_AT_IDX = 6;
// Group 7 = the identifier after "bind-", "let-", "ref-/#", "on-", "bindon-" or "@"
var IDENT_KW_IDX = 7;
// Group 8 = identifier inside [()]
var IDENT_BANANA_BOX_IDX = 8;
// Group 9 = identifier inside []
var IDENT_PROPERTY_IDX = 9;
// Group 10 = identifier inside ()
var IDENT_EVENT_IDX = 10;
// deprecated in 4.x
var TEMPLATE_ELEMENT = 'template';
// deprecated in 4.x
var TEMPLATE_ATTR = 'template';
var TEMPLATE_ATTR_PREFIX = '*';
var CLASS_ATTR = 'class';
var TEXT_CSS_SELECTOR = CssSelector.parse('*')[0];
var TEMPLATE_ELEMENT_DEPRECATION_WARNING = 'The <template> element is deprecated. Use <ng-template> instead';
var TEMPLATE_ATTR_DEPRECATION_WARNING = 'The template attribute is deprecated. Use an ng-template element instead.';
var warningCounts = {};
/**
 * @param {?} warnings
 * @return {?}
 */
function warnOnlyOnce(warnings) {
    return function (error) {
        if (warnings.indexOf(error.msg) !== -1) {
            warningCounts[error.msg] = (warningCounts[error.msg] || 0) + 1;
            return warningCounts[error.msg] <= 1;
        }
        return true;
    };
}
/**
 * Provides an array of {@link TemplateAstVisitor}s which will be used to transform
 * parsed templates before compilation is invoked, allowing custom expression syntax
 * and other advanced transformations.
 *
 * This is currently an internal-only feature and not meant for general use.
 */
var TEMPLATE_TRANSFORMS = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["InjectionToken"]('TemplateTransforms');
var TemplateParseError = (function (_super) {
    __extends(TemplateParseError, _super);
    /**
     * @param {?} message
     * @param {?} span
     * @param {?} level
     */
    function TemplateParseError(message, span, level) {
        return _super.call(this, span, message, level) || this;
    }
    return TemplateParseError;
}(ParseError));
var TemplateParseResult = (function () {
    /**
     * @param {?=} templateAst
     * @param {?=} usedPipes
     * @param {?=} errors
     */
    function TemplateParseResult(templateAst, usedPipes, errors) {
        this.templateAst = templateAst;
        this.usedPipes = usedPipes;
        this.errors = errors;
    }
    return TemplateParseResult;
}());
var TemplateParser = (function () {
    /**
     * @param {?} _config
     * @param {?} _exprParser
     * @param {?} _schemaRegistry
     * @param {?} _htmlParser
     * @param {?} _console
     * @param {?} transforms
     */
    function TemplateParser(_config, _exprParser, _schemaRegistry, _htmlParser, _console, transforms) {
        this._config = _config;
        this._exprParser = _exprParser;
        this._schemaRegistry = _schemaRegistry;
        this._htmlParser = _htmlParser;
        this._console = _console;
        this.transforms = transforms;
    }
    /**
     * @param {?} component
     * @param {?} template
     * @param {?} directives
     * @param {?} pipes
     * @param {?} schemas
     * @param {?} templateUrl
     * @return {?}
     */
    TemplateParser.prototype.parse = function (component, template, directives, pipes, schemas, templateUrl) {
        var /** @type {?} */ result = this.tryParse(component, template, directives, pipes, schemas, templateUrl);
        var /** @type {?} */ warnings = ((result.errors)).filter(function (error) { return error.level === ParseErrorLevel.WARNING; })
            .filter(warnOnlyOnce([TEMPLATE_ATTR_DEPRECATION_WARNING, TEMPLATE_ELEMENT_DEPRECATION_WARNING]));
        var /** @type {?} */ errors = ((result.errors)).filter(function (error) { return error.level === ParseErrorLevel.ERROR; });
        if (warnings.length > 0) {
            this._console.warn("Template parse warnings:\n" + warnings.join('\n'));
        }
        if (errors.length > 0) {
            var /** @type {?} */ errorString = errors.join('\n');
            throw syntaxError("Template parse errors:\n" + errorString);
        }
        return { template: /** @type {?} */ ((result.templateAst)), pipes: /** @type {?} */ ((result.usedPipes)) };
    };
    /**
     * @param {?} component
     * @param {?} template
     * @param {?} directives
     * @param {?} pipes
     * @param {?} schemas
     * @param {?} templateUrl
     * @return {?}
     */
    TemplateParser.prototype.tryParse = function (component, template, directives, pipes, schemas, templateUrl) {
        return this.tryParseHtml(this.expandHtml(/** @type {?} */ ((this._htmlParser)).parse(template, templateUrl, true, this.getInterpolationConfig(component))), component, directives, pipes, schemas);
    };
    /**
     * @param {?} htmlAstWithErrors
     * @param {?} component
     * @param {?} directives
     * @param {?} pipes
     * @param {?} schemas
     * @return {?}
     */
    TemplateParser.prototype.tryParseHtml = function (htmlAstWithErrors, component, directives, pipes, schemas) {
        var /** @type {?} */ result;
        var /** @type {?} */ errors = htmlAstWithErrors.errors;
        var /** @type {?} */ usedPipes = [];
        if (htmlAstWithErrors.rootNodes.length > 0) {
            var /** @type {?} */ uniqDirectives = removeSummaryDuplicates(directives);
            var /** @type {?} */ uniqPipes = removeSummaryDuplicates(pipes);
            var /** @type {?} */ providerViewContext = new ProviderViewContext(component);
            var /** @type {?} */ interpolationConfig = ((undefined));
            if (component.template && component.template.interpolation) {
                interpolationConfig = {
                    start: component.template.interpolation[0],
                    end: component.template.interpolation[1]
                };
            }
            var /** @type {?} */ bindingParser = new BindingParser(this._exprParser, /** @type {?} */ ((interpolationConfig)), this._schemaRegistry, uniqPipes, errors);
            var /** @type {?} */ parseVisitor = new TemplateParseVisitor(this._config, providerViewContext, uniqDirectives, bindingParser, this._schemaRegistry, schemas, errors);
            result = visitAll(parseVisitor, htmlAstWithErrors.rootNodes, EMPTY_ELEMENT_CONTEXT);
            errors.push.apply(errors, providerViewContext.errors);
            usedPipes.push.apply(usedPipes, bindingParser.getUsedPipes());
        }
        else {
            result = [];
        }
        this._assertNoReferenceDuplicationOnTemplate(result, errors);
        if (errors.length > 0) {
            return new TemplateParseResult(result, usedPipes, errors);
        }
        if (this.transforms) {
            this.transforms.forEach(function (transform) { result = templateVisitAll(transform, result); });
        }
        return new TemplateParseResult(result, usedPipes, errors);
    };
    /**
     * @param {?} htmlAstWithErrors
     * @param {?=} forced
     * @return {?}
     */
    TemplateParser.prototype.expandHtml = function (htmlAstWithErrors, forced) {
        if (forced === void 0) { forced = false; }
        var /** @type {?} */ errors = htmlAstWithErrors.errors;
        if (errors.length == 0 || forced) {
            // Transform ICU messages to angular directives
            var /** @type {?} */ expandedHtmlAst = expandNodes(htmlAstWithErrors.rootNodes);
            errors.push.apply(errors, expandedHtmlAst.errors);
            htmlAstWithErrors = new ParseTreeResult(expandedHtmlAst.nodes, errors);
        }
        return htmlAstWithErrors;
    };
    /**
     * @param {?} component
     * @return {?}
     */
    TemplateParser.prototype.getInterpolationConfig = function (component) {
        if (component.template) {
            return InterpolationConfig.fromArray(component.template.interpolation);
        }
        return undefined;
    };
    /**
     * \@internal
     * @param {?} result
     * @param {?} errors
     * @return {?}
     */
    TemplateParser.prototype._assertNoReferenceDuplicationOnTemplate = function (result, errors) {
        var /** @type {?} */ existingReferences = [];
        result.filter(function (element) { return !!((element)).references; })
            .forEach(function (element) { return ((element)).references.forEach(function (reference) {
            var /** @type {?} */ name = reference.name;
            if (existingReferences.indexOf(name) < 0) {
                existingReferences.push(name);
            }
            else {
                var /** @type {?} */ error = new TemplateParseError("Reference \"#" + name + "\" is defined several times", reference.sourceSpan, ParseErrorLevel.ERROR);
                errors.push(error);
            }
        }); });
    };
    return TemplateParser;
}());
TemplateParser.decorators = [
    { type: CompilerInjectable },
];
/**
 * @nocollapse
 */
TemplateParser.ctorParameters = function () { return [
    { type: CompilerConfig, },
    { type: Parser, },
    { type: ElementSchemaRegistry, },
    { type: I18NHtmlParser, },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵConsole"], },
    { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [TEMPLATE_TRANSFORMS,] },] },
]; };
var TemplateParseVisitor = (function () {
    /**
     * @param {?} config
     * @param {?} providerViewContext
     * @param {?} directives
     * @param {?} _bindingParser
     * @param {?} _schemaRegistry
     * @param {?} _schemas
     * @param {?} _targetErrors
     */
    function TemplateParseVisitor(config, providerViewContext, directives, _bindingParser, _schemaRegistry, _schemas, _targetErrors) {
        var _this = this;
        this.config = config;
        this.providerViewContext = providerViewContext;
        this._bindingParser = _bindingParser;
        this._schemaRegistry = _schemaRegistry;
        this._schemas = _schemas;
        this._targetErrors = _targetErrors;
        this.selectorMatcher = new SelectorMatcher();
        this.directivesIndex = new Map();
        this.ngContentCount = 0;
        // Note: queries start with id 1 so we can use the number in a Bloom filter!
        this.contentQueryStartId = providerViewContext.component.viewQueries.length + 1;
        directives.forEach(function (directive, index) {
            var selector = CssSelector.parse(directive.selector);
            _this.selectorMatcher.addSelectables(selector, directive);
            _this.directivesIndex.set(directive, index);
        });
    }
    /**
     * @param {?} expansion
     * @param {?} context
     * @return {?}
     */
    TemplateParseVisitor.prototype.visitExpansion = function (expansion, context) { return null; };
    /**
     * @param {?} expansionCase
     * @param {?} context
     * @return {?}
     */
    TemplateParseVisitor.prototype.visitExpansionCase = function (expansionCase, context) { return null; };
    /**
     * @param {?} text
     * @param {?} parent
     * @return {?}
     */
    TemplateParseVisitor.prototype.visitText = function (text, parent) {
        var /** @type {?} */ ngContentIndex = ((parent.findNgContentIndex(TEXT_CSS_SELECTOR)));
        var /** @type {?} */ expr = this._bindingParser.parseInterpolation(text.value, /** @type {?} */ ((text.sourceSpan)));
        return expr ? new BoundTextAst(expr, ngContentIndex, /** @type {?} */ ((text.sourceSpan))) :
            new TextAst(text.value, ngContentIndex, /** @type {?} */ ((text.sourceSpan)));
    };
    /**
     * @param {?} attribute
     * @param {?} context
     * @return {?}
     */
    TemplateParseVisitor.prototype.visitAttribute = function (attribute, context) {
        return new AttrAst(attribute.name, attribute.value, attribute.sourceSpan);
    };
    /**
     * @param {?} comment
     * @param {?} context
     * @return {?}
     */
    TemplateParseVisitor.prototype.visitComment = function (comment, context) { return null; };
    /**
     * @param {?} element
     * @param {?} parent
     * @return {?}
     */
    TemplateParseVisitor.prototype.visitElement = function (element, parent) {
        var _this = this;
        var /** @type {?} */ queryStartIndex = this.contentQueryStartId;
        var /** @type {?} */ nodeName = element.name;
        var /** @type {?} */ preparsedElement = preparseElement(element);
        if (preparsedElement.type === PreparsedElementType.SCRIPT ||
            preparsedElement.type === PreparsedElementType.STYLE) {
            // Skipping <script> for security reasons
            // Skipping <style> as we already processed them
            // in the StyleCompiler
            return null;
        }
        if (preparsedElement.type === PreparsedElementType.STYLESHEET &&
            isStyleUrlResolvable(preparsedElement.hrefAttr)) {
            // Skipping stylesheets with either relative urls or package scheme as we already processed
            // them in the StyleCompiler
            return null;
        }
        var /** @type {?} */ matchableAttrs = [];
        var /** @type {?} */ elementOrDirectiveProps = [];
        var /** @type {?} */ elementOrDirectiveRefs = [];
        var /** @type {?} */ elementVars = [];
        var /** @type {?} */ events = [];
        var /** @type {?} */ templateElementOrDirectiveProps = [];
        var /** @type {?} */ templateMatchableAttrs = [];
        var /** @type {?} */ templateElementVars = [];
        var /** @type {?} */ hasInlineTemplates = false;
        var /** @type {?} */ attrs = [];
        var /** @type {?} */ isTemplateElement = isTemplate(element, this.config.enableLegacyTemplate, function (m, span) { return _this._reportError(m, span, ParseErrorLevel.WARNING); });
        element.attrs.forEach(function (attr) {
            var /** @type {?} */ hasBinding = _this._parseAttr(isTemplateElement, attr, matchableAttrs, elementOrDirectiveProps, events, elementOrDirectiveRefs, elementVars);
            var /** @type {?} */ templateBindingsSource;
            var /** @type {?} */ prefixToken;
            var /** @type {?} */ normalizedName = _this._normalizeAttributeName(attr.name);
            if (_this.config.enableLegacyTemplate && normalizedName == TEMPLATE_ATTR) {
                _this._reportError(TEMPLATE_ATTR_DEPRECATION_WARNING, attr.sourceSpan, ParseErrorLevel.WARNING);
                templateBindingsSource = attr.value;
            }
            else if (normalizedName.startsWith(TEMPLATE_ATTR_PREFIX)) {
                templateBindingsSource = attr.value;
                prefixToken = normalizedName.substring(TEMPLATE_ATTR_PREFIX.length) + ':';
            }
            var /** @type {?} */ hasTemplateBinding = templateBindingsSource != null;
            if (hasTemplateBinding) {
                if (hasInlineTemplates) {
                    _this._reportError("Can't have multiple template bindings on one element. Use only one attribute named 'template' or prefixed with *", attr.sourceSpan);
                }
                hasInlineTemplates = true;
                _this._bindingParser.parseInlineTemplateBinding(/** @type {?} */ ((prefixToken)), /** @type {?} */ ((templateBindingsSource)), attr.sourceSpan, templateMatchableAttrs, templateElementOrDirectiveProps, templateElementVars);
            }
            if (!hasBinding && !hasTemplateBinding) {
                // don't include the bindings as attributes as well in the AST
                attrs.push(_this.visitAttribute(attr, null));
                matchableAttrs.push([attr.name, attr.value]);
            }
        });
        var /** @type {?} */ elementCssSelector = createElementCssSelector(nodeName, matchableAttrs);
        var _a = this._parseDirectives(this.selectorMatcher, elementCssSelector), directiveMetas = _a.directives, matchElement = _a.matchElement;
        var /** @type {?} */ references = [];
        var /** @type {?} */ boundDirectivePropNames = new Set();
        var /** @type {?} */ directiveAsts = this._createDirectiveAsts(isTemplateElement, element.name, directiveMetas, elementOrDirectiveProps, elementOrDirectiveRefs, /** @type {?} */ ((element.sourceSpan)), references, boundDirectivePropNames);
        var /** @type {?} */ elementProps = this._createElementPropertyAsts(element.name, elementOrDirectiveProps, boundDirectivePropNames);
        var /** @type {?} */ isViewRoot = parent.isTemplateElement || hasInlineTemplates;
        var /** @type {?} */ providerContext = new ProviderElementContext(this.providerViewContext, /** @type {?} */ ((parent.providerContext)), isViewRoot, directiveAsts, attrs, references, isTemplateElement, queryStartIndex, /** @type {?} */ ((element.sourceSpan)));
        var /** @type {?} */ children = visitAll(preparsedElement.nonBindable ? NON_BINDABLE_VISITOR : this, element.children, ElementContext.create(isTemplateElement, directiveAsts, isTemplateElement ? ((parent.providerContext)) : providerContext));
        providerContext.afterElement();
        // Override the actual selector when the `ngProjectAs` attribute is provided
        var /** @type {?} */ projectionSelector = preparsedElement.projectAs != null ?
            CssSelector.parse(preparsedElement.projectAs)[0] :
            elementCssSelector;
        var /** @type {?} */ ngContentIndex = ((parent.findNgContentIndex(projectionSelector)));
        var /** @type {?} */ parsedElement;
        if (preparsedElement.type === PreparsedElementType.NG_CONTENT) {
            if (element.children && !element.children.every(_isEmptyTextNode)) {
                this._reportError("<ng-content> element cannot have content.", /** @type {?} */ ((element.sourceSpan)));
            }
            parsedElement = new NgContentAst(this.ngContentCount++, hasInlineTemplates ? ((null)) : ngContentIndex, /** @type {?} */ ((element.sourceSpan)));
        }
        else if (isTemplateElement) {
            this._assertAllEventsPublishedByDirectives(directiveAsts, events);
            this._assertNoComponentsNorElementBindingsOnTemplate(directiveAsts, elementProps, /** @type {?} */ ((element.sourceSpan)));
            parsedElement = new EmbeddedTemplateAst(attrs, events, references, elementVars, providerContext.transformedDirectiveAsts, providerContext.transformProviders, providerContext.transformedHasViewContainer, providerContext.queryMatches, children, hasInlineTemplates ? ((null)) : ngContentIndex, /** @type {?} */ ((element.sourceSpan)));
        }
        else {
            this._assertElementExists(matchElement, element);
            this._assertOnlyOneComponent(directiveAsts, /** @type {?} */ ((element.sourceSpan)));
            var /** @type {?} */ ngContentIndex_1 = hasInlineTemplates ? null : parent.findNgContentIndex(projectionSelector);
            parsedElement = new ElementAst(nodeName, attrs, elementProps, events, references, providerContext.transformedDirectiveAsts, providerContext.transformProviders, providerContext.transformedHasViewContainer, providerContext.queryMatches, children, hasInlineTemplates ? null : ngContentIndex_1, element.sourceSpan, element.endSourceSpan || null);
        }
        if (hasInlineTemplates) {
            var /** @type {?} */ templateQueryStartIndex = this.contentQueryStartId;
            var /** @type {?} */ templateSelector = createElementCssSelector(TEMPLATE_ELEMENT, templateMatchableAttrs);
            var templateDirectiveMetas = this._parseDirectives(this.selectorMatcher, templateSelector).directives;
            var /** @type {?} */ templateBoundDirectivePropNames = new Set();
            var /** @type {?} */ templateDirectiveAsts = this._createDirectiveAsts(true, element.name, templateDirectiveMetas, templateElementOrDirectiveProps, [], /** @type {?} */ ((element.sourceSpan)), [], templateBoundDirectivePropNames);
            var /** @type {?} */ templateElementProps = this._createElementPropertyAsts(element.name, templateElementOrDirectiveProps, templateBoundDirectivePropNames);
            this._assertNoComponentsNorElementBindingsOnTemplate(templateDirectiveAsts, templateElementProps, /** @type {?} */ ((element.sourceSpan)));
            var /** @type {?} */ templateProviderContext = new ProviderElementContext(this.providerViewContext, /** @type {?} */ ((parent.providerContext)), parent.isTemplateElement, templateDirectiveAsts, [], [], true, templateQueryStartIndex, /** @type {?} */ ((element.sourceSpan)));
            templateProviderContext.afterElement();
            parsedElement = new EmbeddedTemplateAst([], [], [], templateElementVars, templateProviderContext.transformedDirectiveAsts, templateProviderContext.transformProviders, templateProviderContext.transformedHasViewContainer, templateProviderContext.queryMatches, [parsedElement], ngContentIndex, /** @type {?} */ ((element.sourceSpan)));
        }
        return parsedElement;
    };
    /**
     * @param {?} isTemplateElement
     * @param {?} attr
     * @param {?} targetMatchableAttrs
     * @param {?} targetProps
     * @param {?} targetEvents
     * @param {?} targetRefs
     * @param {?} targetVars
     * @return {?}
     */
    TemplateParseVisitor.prototype._parseAttr = function (isTemplateElement, attr, targetMatchableAttrs, targetProps, targetEvents, targetRefs, targetVars) {
        var /** @type {?} */ name = this._normalizeAttributeName(attr.name);
        var /** @type {?} */ value = attr.value;
        var /** @type {?} */ srcSpan = attr.sourceSpan;
        var /** @type {?} */ bindParts = name.match(BIND_NAME_REGEXP);
        var /** @type {?} */ hasBinding = false;
        if (bindParts !== null) {
            hasBinding = true;
            if (bindParts[KW_BIND_IDX] != null) {
                this._bindingParser.parsePropertyBinding(bindParts[IDENT_KW_IDX], value, false, srcSpan, targetMatchableAttrs, targetProps);
            }
            else if (bindParts[KW_LET_IDX]) {
                if (isTemplateElement) {
                    var /** @type {?} */ identifier = bindParts[IDENT_KW_IDX];
                    this._parseVariable(identifier, value, srcSpan, targetVars);
                }
                else {
                    this._reportError("\"let-\" is only supported on template elements.", srcSpan);
                }
            }
            else if (bindParts[KW_REF_IDX]) {
                var /** @type {?} */ identifier = bindParts[IDENT_KW_IDX];
                this._parseReference(identifier, value, srcSpan, targetRefs);
            }
            else if (bindParts[KW_ON_IDX]) {
                this._bindingParser.parseEvent(bindParts[IDENT_KW_IDX], value, srcSpan, targetMatchableAttrs, targetEvents);
            }
            else if (bindParts[KW_BINDON_IDX]) {
                this._bindingParser.parsePropertyBinding(bindParts[IDENT_KW_IDX], value, false, srcSpan, targetMatchableAttrs, targetProps);
                this._parseAssignmentEvent(bindParts[IDENT_KW_IDX], value, srcSpan, targetMatchableAttrs, targetEvents);
            }
            else if (bindParts[KW_AT_IDX]) {
                this._bindingParser.parseLiteralAttr(name, value, srcSpan, targetMatchableAttrs, targetProps);
            }
            else if (bindParts[IDENT_BANANA_BOX_IDX]) {
                this._bindingParser.parsePropertyBinding(bindParts[IDENT_BANANA_BOX_IDX], value, false, srcSpan, targetMatchableAttrs, targetProps);
                this._parseAssignmentEvent(bindParts[IDENT_BANANA_BOX_IDX], value, srcSpan, targetMatchableAttrs, targetEvents);
            }
            else if (bindParts[IDENT_PROPERTY_IDX]) {
                this._bindingParser.parsePropertyBinding(bindParts[IDENT_PROPERTY_IDX], value, false, srcSpan, targetMatchableAttrs, targetProps);
            }
            else if (bindParts[IDENT_EVENT_IDX]) {
                this._bindingParser.parseEvent(bindParts[IDENT_EVENT_IDX], value, srcSpan, targetMatchableAttrs, targetEvents);
            }
        }
        else {
            hasBinding = this._bindingParser.parsePropertyInterpolation(name, value, srcSpan, targetMatchableAttrs, targetProps);
        }
        if (!hasBinding) {
            this._bindingParser.parseLiteralAttr(name, value, srcSpan, targetMatchableAttrs, targetProps);
        }
        return hasBinding;
    };
    /**
     * @param {?} attrName
     * @return {?}
     */
    TemplateParseVisitor.prototype._normalizeAttributeName = function (attrName) {
        return /^data-/i.test(attrName) ? attrName.substring(5) : attrName;
    };
    /**
     * @param {?} identifier
     * @param {?} value
     * @param {?} sourceSpan
     * @param {?} targetVars
     * @return {?}
     */
    TemplateParseVisitor.prototype._parseVariable = function (identifier, value, sourceSpan, targetVars) {
        if (identifier.indexOf('-') > -1) {
            this._reportError("\"-\" is not allowed in variable names", sourceSpan);
        }
        targetVars.push(new VariableAst(identifier, value, sourceSpan));
    };
    /**
     * @param {?} identifier
     * @param {?} value
     * @param {?} sourceSpan
     * @param {?} targetRefs
     * @return {?}
     */
    TemplateParseVisitor.prototype._parseReference = function (identifier, value, sourceSpan, targetRefs) {
        if (identifier.indexOf('-') > -1) {
            this._reportError("\"-\" is not allowed in reference names", sourceSpan);
        }
        targetRefs.push(new ElementOrDirectiveRef(identifier, value, sourceSpan));
    };
    /**
     * @param {?} name
     * @param {?} expression
     * @param {?} sourceSpan
     * @param {?} targetMatchableAttrs
     * @param {?} targetEvents
     * @return {?}
     */
    TemplateParseVisitor.prototype._parseAssignmentEvent = function (name, expression, sourceSpan, targetMatchableAttrs, targetEvents) {
        this._bindingParser.parseEvent(name + "Change", expression + "=$event", sourceSpan, targetMatchableAttrs, targetEvents);
    };
    /**
     * @param {?} selectorMatcher
     * @param {?} elementCssSelector
     * @return {?}
     */
    TemplateParseVisitor.prototype._parseDirectives = function (selectorMatcher, elementCssSelector) {
        var _this = this;
        // Need to sort the directives so that we get consistent results throughout,
        // as selectorMatcher uses Maps inside.
        // Also deduplicate directives as they might match more than one time!
        var /** @type {?} */ directives = new Array(this.directivesIndex.size);
        // Whether any directive selector matches on the element name
        var /** @type {?} */ matchElement = false;
        selectorMatcher.match(elementCssSelector, function (selector, directive) {
            directives[((_this.directivesIndex.get(directive)))] = directive;
            matchElement = matchElement || selector.hasElementSelector();
        });
        return {
            directives: directives.filter(function (dir) { return !!dir; }),
            matchElement: matchElement,
        };
    };
    /**
     * @param {?} isTemplateElement
     * @param {?} elementName
     * @param {?} directives
     * @param {?} props
     * @param {?} elementOrDirectiveRefs
     * @param {?} elementSourceSpan
     * @param {?} targetReferences
     * @param {?} targetBoundDirectivePropNames
     * @return {?}
     */
    TemplateParseVisitor.prototype._createDirectiveAsts = function (isTemplateElement, elementName, directives, props, elementOrDirectiveRefs, elementSourceSpan, targetReferences, targetBoundDirectivePropNames) {
        var _this = this;
        var /** @type {?} */ matchedReferences = new Set();
        var /** @type {?} */ component = ((null));
        var /** @type {?} */ directiveAsts = directives.map(function (directive) {
            var /** @type {?} */ sourceSpan = new ParseSourceSpan(elementSourceSpan.start, elementSourceSpan.end, "Directive " + identifierName(directive.type));
            if (directive.isComponent) {
                component = directive;
            }
            var /** @type {?} */ directiveProperties = [];
            var /** @type {?} */ hostProperties = ((_this._bindingParser.createDirectiveHostPropertyAsts(directive, elementName, sourceSpan)));
            // Note: We need to check the host properties here as well,
            // as we don't know the element name in the DirectiveWrapperCompiler yet.
            hostProperties = _this._checkPropertiesInSchema(elementName, hostProperties);
            var /** @type {?} */ hostEvents = ((_this._bindingParser.createDirectiveHostEventAsts(directive, sourceSpan)));
            _this._createDirectivePropertyAsts(directive.inputs, props, directiveProperties, targetBoundDirectivePropNames);
            elementOrDirectiveRefs.forEach(function (elOrDirRef) {
                if ((elOrDirRef.value.length === 0 && directive.isComponent) ||
                    (directive.exportAs == elOrDirRef.value)) {
                    targetReferences.push(new ReferenceAst(elOrDirRef.name, identifierToken(directive.type), elOrDirRef.sourceSpan));
                    matchedReferences.add(elOrDirRef.name);
                }
            });
            var /** @type {?} */ contentQueryStartId = _this.contentQueryStartId;
            _this.contentQueryStartId += directive.queries.length;
            return new DirectiveAst(directive, directiveProperties, hostProperties, hostEvents, contentQueryStartId, sourceSpan);
        });
        elementOrDirectiveRefs.forEach(function (elOrDirRef) {
            if (elOrDirRef.value.length > 0) {
                if (!matchedReferences.has(elOrDirRef.name)) {
                    _this._reportError("There is no directive with \"exportAs\" set to \"" + elOrDirRef.value + "\"", elOrDirRef.sourceSpan);
                }
            }
            else if (!component) {
                var /** @type {?} */ refToken = ((null));
                if (isTemplateElement) {
                    refToken = createIdentifierToken(Identifiers.TemplateRef);
                }
                targetReferences.push(new ReferenceAst(elOrDirRef.name, refToken, elOrDirRef.sourceSpan));
            }
        });
        return directiveAsts;
    };
    /**
     * @param {?} directiveProperties
     * @param {?} boundProps
     * @param {?} targetBoundDirectiveProps
     * @param {?} targetBoundDirectivePropNames
     * @return {?}
     */
    TemplateParseVisitor.prototype._createDirectivePropertyAsts = function (directiveProperties, boundProps, targetBoundDirectiveProps, targetBoundDirectivePropNames) {
        if (directiveProperties) {
            var /** @type {?} */ boundPropsByName_1 = new Map();
            boundProps.forEach(function (boundProp) {
                var /** @type {?} */ prevValue = boundPropsByName_1.get(boundProp.name);
                if (!prevValue || prevValue.isLiteral) {
                    // give [a]="b" a higher precedence than a="b" on the same element
                    boundPropsByName_1.set(boundProp.name, boundProp);
                }
            });
            Object.keys(directiveProperties).forEach(function (dirProp) {
                var /** @type {?} */ elProp = directiveProperties[dirProp];
                var /** @type {?} */ boundProp = boundPropsByName_1.get(elProp);
                // Bindings are optional, so this binding only needs to be set up if an expression is given.
                if (boundProp) {
                    targetBoundDirectivePropNames.add(boundProp.name);
                    if (!isEmptyExpression(boundProp.expression)) {
                        targetBoundDirectiveProps.push(new BoundDirectivePropertyAst(dirProp, boundProp.name, boundProp.expression, boundProp.sourceSpan));
                    }
                }
            });
        }
    };
    /**
     * @param {?} elementName
     * @param {?} props
     * @param {?} boundDirectivePropNames
     * @return {?}
     */
    TemplateParseVisitor.prototype._createElementPropertyAsts = function (elementName, props, boundDirectivePropNames) {
        var _this = this;
        var /** @type {?} */ boundElementProps = [];
        props.forEach(function (prop) {
            if (!prop.isLiteral && !boundDirectivePropNames.has(prop.name)) {
                boundElementProps.push(_this._bindingParser.createElementPropertyAst(elementName, prop));
            }
        });
        return this._checkPropertiesInSchema(elementName, boundElementProps);
    };
    /**
     * @param {?} directives
     * @return {?}
     */
    TemplateParseVisitor.prototype._findComponentDirectives = function (directives) {
        return directives.filter(function (directive) { return directive.directive.isComponent; });
    };
    /**
     * @param {?} directives
     * @return {?}
     */
    TemplateParseVisitor.prototype._findComponentDirectiveNames = function (directives) {
        return this._findComponentDirectives(directives)
            .map(function (directive) { return ((identifierName(directive.directive.type))); });
    };
    /**
     * @param {?} directives
     * @param {?} sourceSpan
     * @return {?}
     */
    TemplateParseVisitor.prototype._assertOnlyOneComponent = function (directives, sourceSpan) {
        var /** @type {?} */ componentTypeNames = this._findComponentDirectiveNames(directives);
        if (componentTypeNames.length > 1) {
            this._reportError("More than one component matched on this element.\n" +
                "Make sure that only one component's selector can match a given element.\n" +
                ("Conflicting components: " + componentTypeNames.join(',')), sourceSpan);
        }
    };
    /**
     * Make sure that non-angular tags conform to the schemas.
     *
     * Note: An element is considered an angular tag when at least one directive selector matches the
     * tag name.
     *
     * @param {?} matchElement Whether any directive has matched on the tag name
     * @param {?} element the html element
     * @return {?}
     */
    TemplateParseVisitor.prototype._assertElementExists = function (matchElement, element) {
        var /** @type {?} */ elName = element.name.replace(/^:xhtml:/, '');
        if (!matchElement && !this._schemaRegistry.hasElement(elName, this._schemas)) {
            var /** @type {?} */ errorMsg = "'" + elName + "' is not a known element:\n";
            errorMsg +=
                "1. If '" + elName + "' is an Angular component, then verify that it is part of this module.\n";
            if (elName.indexOf('-') > -1) {
                errorMsg +=
                    "2. If '" + elName + "' is a Web Component then add 'CUSTOM_ELEMENTS_SCHEMA' to the '@NgModule.schemas' of this component to suppress this message.";
            }
            else {
                errorMsg +=
                    "2. To allow any element add 'NO_ERRORS_SCHEMA' to the '@NgModule.schemas' of this component.";
            }
            this._reportError(errorMsg, /** @type {?} */ ((element.sourceSpan)));
        }
    };
    /**
     * @param {?} directives
     * @param {?} elementProps
     * @param {?} sourceSpan
     * @return {?}
     */
    TemplateParseVisitor.prototype._assertNoComponentsNorElementBindingsOnTemplate = function (directives, elementProps, sourceSpan) {
        var _this = this;
        var /** @type {?} */ componentTypeNames = this._findComponentDirectiveNames(directives);
        if (componentTypeNames.length > 0) {
            this._reportError("Components on an embedded template: " + componentTypeNames.join(','), sourceSpan);
        }
        elementProps.forEach(function (prop) {
            _this._reportError("Property binding " + prop.name + " not used by any directive on an embedded template. Make sure that the property name is spelled correctly and all directives are listed in the \"@NgModule.declarations\".", sourceSpan);
        });
    };
    /**
     * @param {?} directives
     * @param {?} events
     * @return {?}
     */
    TemplateParseVisitor.prototype._assertAllEventsPublishedByDirectives = function (directives, events) {
        var _this = this;
        var /** @type {?} */ allDirectiveEvents = new Set();
        directives.forEach(function (directive) {
            Object.keys(directive.directive.outputs).forEach(function (k) {
                var /** @type {?} */ eventName = directive.directive.outputs[k];
                allDirectiveEvents.add(eventName);
            });
        });
        events.forEach(function (event) {
            if (event.target != null || !allDirectiveEvents.has(event.name)) {
                _this._reportError("Event binding " + event.fullName + " not emitted by any directive on an embedded template. Make sure that the event name is spelled correctly and all directives are listed in the \"@NgModule.declarations\".", event.sourceSpan);
            }
        });
    };
    /**
     * @param {?} elementName
     * @param {?} boundProps
     * @return {?}
     */
    TemplateParseVisitor.prototype._checkPropertiesInSchema = function (elementName, boundProps) {
        var _this = this;
        // Note: We can't filter out empty expressions before this method,
        // as we still want to validate them!
        return boundProps.filter(function (boundProp) {
            if (boundProp.type === PropertyBindingType.Property &&
                !_this._schemaRegistry.hasProperty(elementName, boundProp.name, _this._schemas)) {
                var /** @type {?} */ errorMsg = "Can't bind to '" + boundProp.name + "' since it isn't a known property of '" + elementName + "'.";
                if (elementName.startsWith('ng-')) {
                    errorMsg +=
                        "\n1. If '" + boundProp.name + "' is an Angular directive, then add 'CommonModule' to the '@NgModule.imports' of this component." +
                            "\n2. To allow any property add 'NO_ERRORS_SCHEMA' to the '@NgModule.schemas' of this component.";
                }
                else if (elementName.indexOf('-') > -1) {
                    errorMsg +=
                        "\n1. If '" + elementName + "' is an Angular component and it has '" + boundProp.name + "' input, then verify that it is part of this module." +
                            ("\n2. If '" + elementName + "' is a Web Component then add 'CUSTOM_ELEMENTS_SCHEMA' to the '@NgModule.schemas' of this component to suppress this message.") +
                            "\n3. To allow any property add 'NO_ERRORS_SCHEMA' to the '@NgModule.schemas' of this component.";
                }
                _this._reportError(errorMsg, boundProp.sourceSpan);
            }
            return !isEmptyExpression(boundProp.value);
        });
    };
    /**
     * @param {?} message
     * @param {?} sourceSpan
     * @param {?=} level
     * @return {?}
     */
    TemplateParseVisitor.prototype._reportError = function (message, sourceSpan, level) {
        if (level === void 0) { level = ParseErrorLevel.ERROR; }
        this._targetErrors.push(new ParseError(sourceSpan, message, level));
    };
    return TemplateParseVisitor;
}());
var NonBindableVisitor = (function () {
    function NonBindableVisitor() {
    }
    /**
     * @param {?} ast
     * @param {?} parent
     * @return {?}
     */
    NonBindableVisitor.prototype.visitElement = function (ast, parent) {
        var /** @type {?} */ preparsedElement = preparseElement(ast);
        if (preparsedElement.type === PreparsedElementType.SCRIPT ||
            preparsedElement.type === PreparsedElementType.STYLE ||
            preparsedElement.type === PreparsedElementType.STYLESHEET) {
            // Skipping <script> for security reasons
            // Skipping <style> and stylesheets as we already processed them
            // in the StyleCompiler
            return null;
        }
        var /** @type {?} */ attrNameAndValues = ast.attrs.map(function (attr) { return [attr.name, attr.value]; });
        var /** @type {?} */ selector = createElementCssSelector(ast.name, attrNameAndValues);
        var /** @type {?} */ ngContentIndex = parent.findNgContentIndex(selector);
        var /** @type {?} */ children = visitAll(this, ast.children, EMPTY_ELEMENT_CONTEXT);
        return new ElementAst(ast.name, visitAll(this, ast.attrs), [], [], [], [], [], false, [], children, ngContentIndex, ast.sourceSpan, ast.endSourceSpan);
    };
    /**
     * @param {?} comment
     * @param {?} context
     * @return {?}
     */
    NonBindableVisitor.prototype.visitComment = function (comment, context) { return null; };
    /**
     * @param {?} attribute
     * @param {?} context
     * @return {?}
     */
    NonBindableVisitor.prototype.visitAttribute = function (attribute, context) {
        return new AttrAst(attribute.name, attribute.value, attribute.sourceSpan);
    };
    /**
     * @param {?} text
     * @param {?} parent
     * @return {?}
     */
    NonBindableVisitor.prototype.visitText = function (text, parent) {
        var /** @type {?} */ ngContentIndex = ((parent.findNgContentIndex(TEXT_CSS_SELECTOR)));
        return new TextAst(text.value, ngContentIndex, /** @type {?} */ ((text.sourceSpan)));
    };
    /**
     * @param {?} expansion
     * @param {?} context
     * @return {?}
     */
    NonBindableVisitor.prototype.visitExpansion = function (expansion, context) { return expansion; };
    /**
     * @param {?} expansionCase
     * @param {?} context
     * @return {?}
     */
    NonBindableVisitor.prototype.visitExpansionCase = function (expansionCase, context) { return expansionCase; };
    return NonBindableVisitor;
}());
var ElementOrDirectiveRef = (function () {
    /**
     * @param {?} name
     * @param {?} value
     * @param {?} sourceSpan
     */
    function ElementOrDirectiveRef(name, value, sourceSpan) {
        this.name = name;
        this.value = value;
        this.sourceSpan = sourceSpan;
    }
    return ElementOrDirectiveRef;
}());
/**
 * @param {?} classAttrValue
 * @return {?}
 */
function splitClasses(classAttrValue) {
    return classAttrValue.trim().split(/\s+/g);
}
var ElementContext = (function () {
    /**
     * @param {?} isTemplateElement
     * @param {?} _ngContentIndexMatcher
     * @param {?} _wildcardNgContentIndex
     * @param {?} providerContext
     */
    function ElementContext(isTemplateElement, _ngContentIndexMatcher, _wildcardNgContentIndex, providerContext) {
        this.isTemplateElement = isTemplateElement;
        this._ngContentIndexMatcher = _ngContentIndexMatcher;
        this._wildcardNgContentIndex = _wildcardNgContentIndex;
        this.providerContext = providerContext;
    }
    /**
     * @param {?} isTemplateElement
     * @param {?} directives
     * @param {?} providerContext
     * @return {?}
     */
    ElementContext.create = function (isTemplateElement, directives, providerContext) {
        var /** @type {?} */ matcher = new SelectorMatcher();
        var /** @type {?} */ wildcardNgContentIndex = ((null));
        var /** @type {?} */ component = directives.find(function (directive) { return directive.directive.isComponent; });
        if (component) {
            var /** @type {?} */ ngContentSelectors = ((component.directive.template)).ngContentSelectors;
            for (var /** @type {?} */ i = 0; i < ngContentSelectors.length; i++) {
                var /** @type {?} */ selector = ngContentSelectors[i];
                if (selector === '*') {
                    wildcardNgContentIndex = i;
                }
                else {
                    matcher.addSelectables(CssSelector.parse(ngContentSelectors[i]), i);
                }
            }
        }
        return new ElementContext(isTemplateElement, matcher, wildcardNgContentIndex, providerContext);
    };
    /**
     * @param {?} selector
     * @return {?}
     */
    ElementContext.prototype.findNgContentIndex = function (selector) {
        var /** @type {?} */ ngContentIndices = [];
        this._ngContentIndexMatcher.match(selector, function (selector, ngContentIndex) { ngContentIndices.push(ngContentIndex); });
        ngContentIndices.sort();
        if (this._wildcardNgContentIndex != null) {
            ngContentIndices.push(this._wildcardNgContentIndex);
        }
        return ngContentIndices.length > 0 ? ngContentIndices[0] : null;
    };
    return ElementContext;
}());
/**
 * @param {?} elementName
 * @param {?} attributes
 * @return {?}
 */
function createElementCssSelector(elementName, attributes) {
    var /** @type {?} */ cssSelector = new CssSelector();
    var /** @type {?} */ elNameNoNs = splitNsName(elementName)[1];
    cssSelector.setElement(elNameNoNs);
    for (var /** @type {?} */ i = 0; i < attributes.length; i++) {
        var /** @type {?} */ attrName = attributes[i][0];
        var /** @type {?} */ attrNameNoNs = splitNsName(attrName)[1];
        var /** @type {?} */ attrValue = attributes[i][1];
        cssSelector.addAttribute(attrNameNoNs, attrValue);
        if (attrName.toLowerCase() == CLASS_ATTR) {
            var /** @type {?} */ classes = splitClasses(attrValue);
            classes.forEach(function (className) { return cssSelector.addClassName(className); });
        }
    }
    return cssSelector;
}
var EMPTY_ELEMENT_CONTEXT = new ElementContext(true, new SelectorMatcher(), null, null);
var NON_BINDABLE_VISITOR = new NonBindableVisitor();
/**
 * @param {?} node
 * @return {?}
 */
function _isEmptyTextNode(node) {
    return node instanceof Text && node.value.trim().length == 0;
}
/**
 * @template T
 * @param {?} items
 * @return {?}
 */
function removeSummaryDuplicates(items) {
    var /** @type {?} */ map = new Map();
    items.forEach(function (item) {
        if (!map.get(item.type.reference)) {
            map.set(item.type.reference, item);
        }
    });
    return Array.from(map.values());
}
/**
 * @param {?} ast
 * @return {?}
 */
function isEmptyExpression(ast) {
    if (ast instanceof ASTWithSource) {
        ast = ast.ast;
    }
    return ast instanceof EmptyExpr;
}
/**
 * @param {?} el
 * @param {?} enableLegacyTemplate
 * @param {?} reportDeprecation
 * @return {?}
 */
function isTemplate(el, enableLegacyTemplate, reportDeprecation) {
    if (isNgTemplate(el.name))
        return true;
    var /** @type {?} */ tagNoNs = splitNsName(el.name)[1];
    // `<template>` is HTML and case insensitive
    if (tagNoNs.toLowerCase() === TEMPLATE_ELEMENT) {
        if (enableLegacyTemplate && tagNoNs.toLowerCase() === TEMPLATE_ELEMENT) {
            reportDeprecation(TEMPLATE_ELEMENT_DEPRECATION_WARNING, /** @type {?} */ ((el.sourceSpan)));
            return true;
        }
    }
    return false;
}
/**
 * An interface for retrieving documents by URL that the compiler uses
 * to load templates.
 */
var ResourceLoader = (function () {
    function ResourceLoader() {
    }
    /**
     * @param {?} url
     * @return {?}
     */
    ResourceLoader.prototype.get = function (url) { return null; };
    return ResourceLoader;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Create a {\@link UrlResolver} with no package prefix.
 * @return {?}
 */
function createUrlResolverWithoutPackagePrefix() {
    return new UrlResolver();
}
/**
 * @return {?}
 */
function createOfflineCompileUrlResolver() {
    return new UrlResolver('.');
}
/**
 * A default provider for {@link PACKAGE_ROOT_URL} that maps to '/'.
 */
var DEFAULT_PACKAGE_URL_PROVIDER = {
    provide: __WEBPACK_IMPORTED_MODULE_0__angular_core__["PACKAGE_ROOT_URL"],
    useValue: '/'
};
/**
 * Used by the {\@link Compiler} when resolving HTML and CSS template URLs.
 *
 * This class can be overridden by the application developer to create custom behavior.
 *
 * See {\@link Compiler}
 *
 * ## Example
 *
 * {\@example compiler/ts/url_resolver/url_resolver.ts region='url_resolver'}
 *
 * \@security When compiling templates at runtime, you must
 * ensure that the entire template comes from a trusted source.
 * Attacker-controlled data introduced by a template could expose your
 * application to XSS risks. For more detail, see the [Security Guide](http://g.co/ng/security).
 */
var UrlResolver = (function () {
    /**
     * @param {?=} _packagePrefix
     */
    function UrlResolver(_packagePrefix) {
        if (_packagePrefix === void 0) { _packagePrefix = null; }
        this._packagePrefix = _packagePrefix;
    }
    /**
     * Resolves the `url` given the `baseUrl`:
     * - when the `url` is null, the `baseUrl` is returned,
     * - if `url` is relative ('path/to/here', './path/to/here'), the resolved url is a combination of
     * `baseUrl` and `url`,
     * - if `url` is absolute (it has a scheme: 'http://', 'https://' or start with '/'), the `url` is
     * returned as is (ignoring the `baseUrl`)
     * @param {?} baseUrl
     * @param {?} url
     * @return {?}
     */
    UrlResolver.prototype.resolve = function (baseUrl, url) {
        var /** @type {?} */ resolvedUrl = url;
        if (baseUrl != null && baseUrl.length > 0) {
            resolvedUrl = _resolveUrl(baseUrl, resolvedUrl);
        }
        var /** @type {?} */ resolvedParts = _split(resolvedUrl);
        var /** @type {?} */ prefix = this._packagePrefix;
        if (prefix != null && resolvedParts != null &&
            resolvedParts[_ComponentIndex.Scheme] == 'package') {
            var /** @type {?} */ path = resolvedParts[_ComponentIndex.Path];
            prefix = prefix.replace(/\/+$/, '');
            path = path.replace(/^\/+/, '');
            return prefix + "/" + path;
        }
        return resolvedUrl;
    };
    return UrlResolver;
}());
UrlResolver.decorators = [
    { type: CompilerInjectable },
];
/**
 * @nocollapse
 */
UrlResolver.ctorParameters = function () { return [
    { type: undefined, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_0__angular_core__["PACKAGE_ROOT_URL"],] },] },
]; };
/**
 * Extract the scheme of a URL.
 * @param {?} url
 * @return {?}
 */
function getUrlScheme(url) {
    var /** @type {?} */ match = _split(url);
    return (match && match[_ComponentIndex.Scheme]) || '';
}
/**
 * Builds a URI string from already-encoded parts.
 *
 * No encoding is performed.  Any component may be omitted as either null or
 * undefined.
 *
 * @param {?=} opt_scheme The scheme such as 'http'.
 * @param {?=} opt_userInfo The user name before the '\@'.
 * @param {?=} opt_domain The domain such as 'www.google.com', already
 *     URI-encoded.
 * @param {?=} opt_port The port number.
 * @param {?=} opt_path The path, already URI-encoded.  If it is not
 *     empty, it must begin with a slash.
 * @param {?=} opt_queryData The URI-encoded query data.
 * @param {?=} opt_fragment The URI-encoded fragment identifier.
 * @return {?} The fully combined URI.
 */
function _buildFromEncodedParts(opt_scheme, opt_userInfo, opt_domain, opt_port, opt_path, opt_queryData, opt_fragment) {
    var /** @type {?} */ out = [];
    if (opt_scheme != null) {
        out.push(opt_scheme + ':');
    }
    if (opt_domain != null) {
        out.push('//');
        if (opt_userInfo != null) {
            out.push(opt_userInfo + '@');
        }
        out.push(opt_domain);
        if (opt_port != null) {
            out.push(':' + opt_port);
        }
    }
    if (opt_path != null) {
        out.push(opt_path);
    }
    if (opt_queryData != null) {
        out.push('?' + opt_queryData);
    }
    if (opt_fragment != null) {
        out.push('#' + opt_fragment);
    }
    return out.join('');
}
/**
 * A regular expression for breaking a URI into its component parts.
 *
 * {\@link http://www.gbiv.com/protocols/uri/rfc/rfc3986.html#RFC2234} says
 * As the "first-match-wins" algorithm is identical to the "greedy"
 * disambiguation method used by POSIX regular expressions, it is natural and
 * commonplace to use a regular expression for parsing the potential five
 * components of a URI reference.
 *
 * The following line is the regular expression for breaking-down a
 * well-formed URI reference into its components.
 *
 * <pre>
 * ^(([^:/?#]+):)?(//([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?
 *  12            3  4          5       6  7        8 9
 * </pre>
 *
 * The numbers in the second line above are only to assist readability; they
 * indicate the reference points for each subexpression (i.e., each paired
 * parenthesis). We refer to the value matched for subexpression <n> as $<n>.
 * For example, matching the above expression to
 * <pre>
 *     http://www.ics.uci.edu/pub/ietf/uri/#Related
 * </pre>
 * results in the following subexpression matches:
 * <pre>
 *    $1 = http:
 *    $2 = http
 *    $3 = //www.ics.uci.edu
 *    $4 = www.ics.uci.edu
 *    $5 = /pub/ietf/uri/
 *    $6 = <undefined>
 *    $7 = <undefined>
 *    $8 = #Related
 *    $9 = Related
 * </pre>
 * where <undefined> indicates that the component is not present, as is the
 * case for the query component in the above example. Therefore, we can
 * determine the value of the five components as
 * <pre>
 *    scheme    = $2
 *    authority = $4
 *    path      = $5
 *    query     = $7
 *    fragment  = $9
 * </pre>
 *
 * The regular expression has been modified slightly to expose the
 * userInfo, domain, and port separately from the authority.
 * The modified version yields
 * <pre>
 *    $1 = http              scheme
 *    $2 = <undefined>       userInfo -\
 *    $3 = www.ics.uci.edu   domain     | authority
 *    $4 = <undefined>       port     -/
 *    $5 = /pub/ietf/uri/    path
 *    $6 = <undefined>       query without ?
 *    $7 = Related           fragment without #
 * </pre>
 * \@internal
 */
var _splitRe = new RegExp('^' +
    '(?:' +
    '([^:/?#.]+)' +
    // used by other URL parts such as :,
    // ?, /, #, and .
    ':)?' +
    '(?://' +
    '(?:([^/?#]*)@)?' +
    '([\\w\\d\\-\\u0100-\\uffff.%]*)' +
    // digits, dashes, dots, percent
    // escapes, and unicode characters.
    '(?::([0-9]+))?' +
    ')?' +
    '([^?#]+)?' +
    '(?:\\?([^#]*))?' +
    '(?:#(.*))?' +
    '$');
var _ComponentIndex = {};
_ComponentIndex.Scheme = 1;
_ComponentIndex.UserInfo = 2;
_ComponentIndex.Domain = 3;
_ComponentIndex.Port = 4;
_ComponentIndex.Path = 5;
_ComponentIndex.QueryData = 6;
_ComponentIndex.Fragment = 7;
_ComponentIndex[_ComponentIndex.Scheme] = "Scheme";
_ComponentIndex[_ComponentIndex.UserInfo] = "UserInfo";
_ComponentIndex[_ComponentIndex.Domain] = "Domain";
_ComponentIndex[_ComponentIndex.Port] = "Port";
_ComponentIndex[_ComponentIndex.Path] = "Path";
_ComponentIndex[_ComponentIndex.QueryData] = "QueryData";
_ComponentIndex[_ComponentIndex.Fragment] = "Fragment";
/**
 * Splits a URI into its component parts.
 *
 * Each component can be accessed via the component indices; for example:
 * <pre>
 * goog.uri.utils.split(someStr)[goog.uri.utils.CompontentIndex.QUERY_DATA];
 * </pre>
 *
 * @param {?} uri The URI string to examine.
 * @return {?} Each component still URI-encoded.
 *     Each component that is present will contain the encoded value, whereas
 *     components that are not present will be undefined or empty, depending
 *     on the browser's regular expression implementation.  Never null, since
 *     arbitrary strings may still look like path names.
 */
function _split(uri) {
    return ((uri.match(_splitRe)));
}
/**
 * Removes dot segments in given path component, as described in
 * RFC 3986, section 5.2.4.
 *
 * @param {?} path A non-empty path component.
 * @return {?} Path component with removed dot segments.
 */
function _removeDotSegments(path) {
    if (path == '/')
        return '/';
    var /** @type {?} */ leadingSlash = path[0] == '/' ? '/' : '';
    var /** @type {?} */ trailingSlash = path[path.length - 1] === '/' ? '/' : '';
    var /** @type {?} */ segments = path.split('/');
    var /** @type {?} */ out = [];
    var /** @type {?} */ up = 0;
    for (var /** @type {?} */ pos = 0; pos < segments.length; pos++) {
        var /** @type {?} */ segment = segments[pos];
        switch (segment) {
            case '':
            case '.':
                break;
            case '..':
                if (out.length > 0) {
                    out.pop();
                }
                else {
                    up++;
                }
                break;
            default:
                out.push(segment);
        }
    }
    if (leadingSlash == '') {
        while (up-- > 0) {
            out.unshift('..');
        }
        if (out.length === 0)
            out.push('.');
    }
    return leadingSlash + out.join('/') + trailingSlash;
}
/**
 * Takes an array of the parts from split and canonicalizes the path part
 * and then joins all the parts.
 * @param {?} parts
 * @return {?}
 */
function _joinAndCanonicalizePath(parts) {
    var /** @type {?} */ path = parts[_ComponentIndex.Path];
    path = path == null ? '' : _removeDotSegments(path);
    parts[_ComponentIndex.Path] = path;
    return _buildFromEncodedParts(parts[_ComponentIndex.Scheme], parts[_ComponentIndex.UserInfo], parts[_ComponentIndex.Domain], parts[_ComponentIndex.Port], path, parts[_ComponentIndex.QueryData], parts[_ComponentIndex.Fragment]);
}
/**
 * Resolves a URL.
 * @param {?} base The URL acting as the base URL.
 * @param {?} url
 * @return {?}
 */
function _resolveUrl(base, url) {
    var /** @type {?} */ parts = _split(encodeURI(url));
    var /** @type {?} */ baseParts = _split(base);
    if (parts[_ComponentIndex.Scheme] != null) {
        return _joinAndCanonicalizePath(parts);
    }
    else {
        parts[_ComponentIndex.Scheme] = baseParts[_ComponentIndex.Scheme];
    }
    for (var /** @type {?} */ i = _ComponentIndex.Scheme; i <= _ComponentIndex.Port; i++) {
        if (parts[i] == null) {
            parts[i] = baseParts[i];
        }
    }
    if (parts[_ComponentIndex.Path][0] == '/') {
        return _joinAndCanonicalizePath(parts);
    }
    var /** @type {?} */ path = baseParts[_ComponentIndex.Path];
    if (path == null)
        path = '/';
    var /** @type {?} */ index = path.lastIndexOf('/');
    path = path.substring(0, index + 1) + parts[_ComponentIndex.Path];
    parts[_ComponentIndex.Path] = path;
    return _joinAndCanonicalizePath(parts);
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var DirectiveNormalizer = (function () {
    /**
     * @param {?} _resourceLoader
     * @param {?} _urlResolver
     * @param {?} _htmlParser
     * @param {?} _config
     */
    function DirectiveNormalizer(_resourceLoader, _urlResolver, _htmlParser, _config) {
        this._resourceLoader = _resourceLoader;
        this._urlResolver = _urlResolver;
        this._htmlParser = _htmlParser;
        this._config = _config;
        this._resourceLoaderCache = new Map();
    }
    /**
     * @return {?}
     */
    DirectiveNormalizer.prototype.clearCache = function () { this._resourceLoaderCache.clear(); };
    /**
     * @param {?} normalizedDirective
     * @return {?}
     */
    DirectiveNormalizer.prototype.clearCacheFor = function (normalizedDirective) {
        var _this = this;
        if (!normalizedDirective.isComponent) {
            return;
        }
        var /** @type {?} */ template = ((normalizedDirective.template));
        this._resourceLoaderCache.delete(/** @type {?} */ ((template.templateUrl)));
        template.externalStylesheets.forEach(function (stylesheet) { _this._resourceLoaderCache.delete(/** @type {?} */ ((stylesheet.moduleUrl))); });
    };
    /**
     * @param {?} url
     * @return {?}
     */
    DirectiveNormalizer.prototype._fetch = function (url) {
        var /** @type {?} */ result = this._resourceLoaderCache.get(url);
        if (!result) {
            result = ((this._resourceLoader.get(url)));
            this._resourceLoaderCache.set(url, result);
        }
        return result;
    };
    /**
     * @param {?} prenormData
     * @return {?}
     */
    DirectiveNormalizer.prototype.normalizeTemplate = function (prenormData) {
        var _this = this;
        var /** @type {?} */ normalizedTemplateSync = ((null));
        var /** @type {?} */ normalizedTemplateAsync = ((undefined));
        if (isDefined(prenormData.template)) {
            if (isDefined(prenormData.templateUrl)) {
                throw syntaxError("'" + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵstringify"])(prenormData.componentType) + "' component cannot define both template and templateUrl");
            }
            if (typeof prenormData.template !== 'string') {
                throw syntaxError("The template specified for component " + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵstringify"])(prenormData.componentType) + " is not a string");
            }
            normalizedTemplateSync = this.normalizeTemplateSync(prenormData);
            normalizedTemplateAsync = Promise.resolve(/** @type {?} */ ((normalizedTemplateSync)));
        }
        else if (isDefined(prenormData.templateUrl)) {
            if (typeof prenormData.templateUrl !== 'string') {
                throw syntaxError("The templateUrl specified for component " + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵstringify"])(prenormData.componentType) + " is not a string");
            }
            normalizedTemplateAsync = this.normalizeTemplateAsync(prenormData);
        }
        else {
            throw syntaxError("No template specified for component " + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵstringify"])(prenormData.componentType));
        }
        if (normalizedTemplateSync && normalizedTemplateSync.styleUrls.length === 0) {
            // sync case
            return new SyncAsyncResult(normalizedTemplateSync);
        }
        else {
            // async case
            return new SyncAsyncResult(null, normalizedTemplateAsync.then(function (normalizedTemplate) { return _this.normalizeExternalStylesheets(normalizedTemplate); }));
        }
    };
    /**
     * @param {?} prenomData
     * @return {?}
     */
    DirectiveNormalizer.prototype.normalizeTemplateSync = function (prenomData) {
        return this.normalizeLoadedTemplate(prenomData, /** @type {?} */ ((prenomData.template)), prenomData.moduleUrl);
    };
    /**
     * @param {?} prenomData
     * @return {?}
     */
    DirectiveNormalizer.prototype.normalizeTemplateAsync = function (prenomData) {
        var _this = this;
        var /** @type {?} */ templateUrl = this._urlResolver.resolve(prenomData.moduleUrl, /** @type {?} */ ((prenomData.templateUrl)));
        return this._fetch(templateUrl)
            .then(function (value) { return _this.normalizeLoadedTemplate(prenomData, value, templateUrl); });
    };
    /**
     * @param {?} prenormData
     * @param {?} template
     * @param {?} templateAbsUrl
     * @return {?}
     */
    DirectiveNormalizer.prototype.normalizeLoadedTemplate = function (prenormData, template, templateAbsUrl) {
        var /** @type {?} */ isInline = !!prenormData.template;
        var /** @type {?} */ interpolationConfig = InterpolationConfig.fromArray(/** @type {?} */ ((prenormData.interpolation)));
        var /** @type {?} */ rootNodesAndErrors = this._htmlParser.parse(template, templateSourceUrl({ reference: prenormData.ngModuleType }, { type: { reference: prenormData.componentType } }, { isInline: isInline, templateUrl: templateAbsUrl }), true, interpolationConfig);
        if (rootNodesAndErrors.errors.length > 0) {
            var /** @type {?} */ errorString = rootNodesAndErrors.errors.join('\n');
            throw syntaxError("Template parse errors:\n" + errorString);
        }
        var /** @type {?} */ templateMetadataStyles = this.normalizeStylesheet(new CompileStylesheetMetadata({
            styles: prenormData.styles,
            styleUrls: prenormData.styleUrls,
            moduleUrl: prenormData.moduleUrl
        }));
        var /** @type {?} */ visitor = new TemplatePreparseVisitor();
        visitAll(visitor, rootNodesAndErrors.rootNodes);
        var /** @type {?} */ templateStyles = this.normalizeStylesheet(new CompileStylesheetMetadata({ styles: visitor.styles, styleUrls: visitor.styleUrls, moduleUrl: templateAbsUrl }));
        var /** @type {?} */ encapsulation = prenormData.encapsulation;
        if (encapsulation == null) {
            encapsulation = this._config.defaultEncapsulation;
        }
        var /** @type {?} */ styles = templateMetadataStyles.styles.concat(templateStyles.styles);
        var /** @type {?} */ styleUrls = templateMetadataStyles.styleUrls.concat(templateStyles.styleUrls);
        if (encapsulation === __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewEncapsulation"].Emulated && styles.length === 0 &&
            styleUrls.length === 0) {
            encapsulation = __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewEncapsulation"].None;
        }
        return new CompileTemplateMetadata({
            encapsulation: encapsulation,
            template: template,
            templateUrl: templateAbsUrl, styles: styles, styleUrls: styleUrls,
            ngContentSelectors: visitor.ngContentSelectors,
            animations: prenormData.animations,
            interpolation: prenormData.interpolation, isInline: isInline,
            externalStylesheets: []
        });
    };
    /**
     * @param {?} templateMeta
     * @return {?}
     */
    DirectiveNormalizer.prototype.normalizeExternalStylesheets = function (templateMeta) {
        return this._loadMissingExternalStylesheets(templateMeta.styleUrls)
            .then(function (externalStylesheets) { return new CompileTemplateMetadata({
            encapsulation: templateMeta.encapsulation,
            template: templateMeta.template,
            templateUrl: templateMeta.templateUrl,
            styles: templateMeta.styles,
            styleUrls: templateMeta.styleUrls,
            externalStylesheets: externalStylesheets,
            ngContentSelectors: templateMeta.ngContentSelectors,
            animations: templateMeta.animations,
            interpolation: templateMeta.interpolation,
            isInline: templateMeta.isInline,
        }); });
    };
    /**
     * @param {?} styleUrls
     * @param {?=} loadedStylesheets
     * @return {?}
     */
    DirectiveNormalizer.prototype._loadMissingExternalStylesheets = function (styleUrls, loadedStylesheets) {
        var _this = this;
        if (loadedStylesheets === void 0) { loadedStylesheets = new Map(); }
        return Promise
            .all(styleUrls.filter(function (styleUrl) { return !loadedStylesheets.has(styleUrl); })
            .map(function (styleUrl) { return _this._fetch(styleUrl).then(function (loadedStyle) {
            var /** @type {?} */ stylesheet = _this.normalizeStylesheet(new CompileStylesheetMetadata({ styles: [loadedStyle], moduleUrl: styleUrl }));
            loadedStylesheets.set(styleUrl, stylesheet);
            return _this._loadMissingExternalStylesheets(stylesheet.styleUrls, loadedStylesheets);
        }); }))
            .then(function (_) { return Array.from(loadedStylesheets.values()); });
    };
    /**
     * @param {?} stylesheet
     * @return {?}
     */
    DirectiveNormalizer.prototype.normalizeStylesheet = function (stylesheet) {
        var _this = this;
        var /** @type {?} */ moduleUrl = ((stylesheet.moduleUrl));
        var /** @type {?} */ allStyleUrls = stylesheet.styleUrls.filter(isStyleUrlResolvable)
            .map(function (url) { return _this._urlResolver.resolve(moduleUrl, url); });
        var /** @type {?} */ allStyles = stylesheet.styles.map(function (style$$1) {
            var /** @type {?} */ styleWithImports = extractStyleUrls(_this._urlResolver, moduleUrl, style$$1);
            allStyleUrls.push.apply(allStyleUrls, styleWithImports.styleUrls);
            return styleWithImports.style;
        });
        return new CompileStylesheetMetadata({ styles: allStyles, styleUrls: allStyleUrls, moduleUrl: moduleUrl });
    };
    return DirectiveNormalizer;
}());
DirectiveNormalizer.decorators = [
    { type: CompilerInjectable },
];
/**
 * @nocollapse
 */
DirectiveNormalizer.ctorParameters = function () { return [
    { type: ResourceLoader, },
    { type: UrlResolver, },
    { type: HtmlParser, },
    { type: CompilerConfig, },
]; };
var TemplatePreparseVisitor = (function () {
    function TemplatePreparseVisitor() {
        this.ngContentSelectors = [];
        this.styles = [];
        this.styleUrls = [];
        this.ngNonBindableStackCount = 0;
    }
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    TemplatePreparseVisitor.prototype.visitElement = function (ast, context) {
        var /** @type {?} */ preparsedElement = preparseElement(ast);
        switch (preparsedElement.type) {
            case PreparsedElementType.NG_CONTENT:
                if (this.ngNonBindableStackCount === 0) {
                    this.ngContentSelectors.push(preparsedElement.selectAttr);
                }
                break;
            case PreparsedElementType.STYLE:
                var /** @type {?} */ textContent_1 = '';
                ast.children.forEach(function (child) {
                    if (child instanceof Text) {
                        textContent_1 += child.value;
                    }
                });
                this.styles.push(textContent_1);
                break;
            case PreparsedElementType.STYLESHEET:
                this.styleUrls.push(preparsedElement.hrefAttr);
                break;
            default:
                break;
        }
        if (preparsedElement.nonBindable) {
            this.ngNonBindableStackCount++;
        }
        visitAll(this, ast.children);
        if (preparsedElement.nonBindable) {
            this.ngNonBindableStackCount--;
        }
        return null;
    };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    TemplatePreparseVisitor.prototype.visitExpansion = function (ast, context) { visitAll(this, ast.cases); };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    TemplatePreparseVisitor.prototype.visitExpansionCase = function (ast, context) {
        visitAll(this, ast.expression);
    };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    TemplatePreparseVisitor.prototype.visitComment = function (ast, context) { return null; };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    TemplatePreparseVisitor.prototype.visitAttribute = function (ast, context) { return null; };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    TemplatePreparseVisitor.prototype.visitText = function (ast, context) { return null; };
    return TemplatePreparseVisitor;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var __assign = (undefined && undefined.__assign) || Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s)
            if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
    }
    return t;
};
var DirectiveResolver = (function () {
    /**
     * @param {?=} _reflector
     */
    function DirectiveResolver(_reflector) {
        if (_reflector === void 0) { _reflector = __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵreflector"]; }
        this._reflector = _reflector;
    }
    /**
     * @param {?} type
     * @return {?}
     */
    DirectiveResolver.prototype.isDirective = function (type) {
        var /** @type {?} */ typeMetadata = this._reflector.annotations(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["resolveForwardRef"])(type));
        return typeMetadata && typeMetadata.some(isDirectiveMetadata);
    };
    /**
     * @param {?} type
     * @param {?=} throwIfNotFound
     * @return {?}
     */
    DirectiveResolver.prototype.resolve = function (type, throwIfNotFound) {
        if (throwIfNotFound === void 0) { throwIfNotFound = true; }
        var /** @type {?} */ typeMetadata = this._reflector.annotations(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["resolveForwardRef"])(type));
        if (typeMetadata) {
            var /** @type {?} */ metadata = findLast(typeMetadata, isDirectiveMetadata);
            if (metadata) {
                var /** @type {?} */ propertyMetadata = this._reflector.propMetadata(type);
                return this._mergeWithPropertyMetadata(metadata, propertyMetadata, type);
            }
        }
        if (throwIfNotFound) {
            throw new Error("No Directive annotation found on " + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵstringify"])(type));
        }
        return null;
    };
    /**
     * @param {?} dm
     * @param {?} propertyMetadata
     * @param {?} directiveType
     * @return {?}
     */
    DirectiveResolver.prototype._mergeWithPropertyMetadata = function (dm, propertyMetadata, directiveType) {
        var /** @type {?} */ inputs = [];
        var /** @type {?} */ outputs = [];
        var /** @type {?} */ host = {};
        var /** @type {?} */ queries = {};
        Object.keys(propertyMetadata).forEach(function (propName) {
            var /** @type {?} */ input = findLast(propertyMetadata[propName], function (a) { return a instanceof __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"]; });
            if (input) {
                if (input.bindingPropertyName) {
                    inputs.push(propName + ": " + input.bindingPropertyName);
                }
                else {
                    inputs.push(propName);
                }
            }
            var /** @type {?} */ output = findLast(propertyMetadata[propName], function (a) { return a instanceof __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"]; });
            if (output) {
                if (output.bindingPropertyName) {
                    outputs.push(propName + ": " + output.bindingPropertyName);
                }
                else {
                    outputs.push(propName);
                }
            }
            var /** @type {?} */ hostBindings = propertyMetadata[propName].filter(function (a) { return a && a instanceof __WEBPACK_IMPORTED_MODULE_0__angular_core__["HostBinding"]; });
            hostBindings.forEach(function (hostBinding) {
                if (hostBinding.hostPropertyName) {
                    var /** @type {?} */ startWith = hostBinding.hostPropertyName[0];
                    if (startWith === '(') {
                        throw new Error("@HostBinding can not bind to events. Use @HostListener instead.");
                    }
                    else if (startWith === '[') {
                        throw new Error("@HostBinding parameter should be a property name, 'class.<name>', or 'attr.<name>'.");
                    }
                    host["[" + hostBinding.hostPropertyName + "]"] = propName;
                }
                else {
                    host["[" + propName + "]"] = propName;
                }
            });
            var /** @type {?} */ hostListeners = propertyMetadata[propName].filter(function (a) { return a && a instanceof __WEBPACK_IMPORTED_MODULE_0__angular_core__["HostListener"]; });
            hostListeners.forEach(function (hostListener) {
                var /** @type {?} */ args = hostListener.args || [];
                host["(" + hostListener.eventName + ")"] = propName + "(" + args.join(',') + ")";
            });
            var /** @type {?} */ query = findLast(propertyMetadata[propName], function (a) { return a instanceof __WEBPACK_IMPORTED_MODULE_0__angular_core__["Query"]; });
            if (query) {
                queries[propName] = query;
            }
        });
        return this._merge(dm, inputs, outputs, host, queries, directiveType);
    };
    /**
     * @param {?} def
     * @return {?}
     */
    DirectiveResolver.prototype._extractPublicName = function (def) { return splitAtColon(def, [/** @type {?} */ ((null)), def])[1].trim(); };
    /**
     * @param {?} bindings
     * @return {?}
     */
    DirectiveResolver.prototype._dedupeBindings = function (bindings) {
        var /** @type {?} */ names = new Set();
        var /** @type {?} */ reversedResult = [];
        // go last to first to allow later entries to overwrite previous entries
        for (var /** @type {?} */ i = bindings.length - 1; i >= 0; i--) {
            var /** @type {?} */ binding = bindings[i];
            var /** @type {?} */ name = this._extractPublicName(binding);
            if (!names.has(name)) {
                names.add(name);
                reversedResult.push(binding);
            }
        }
        return reversedResult.reverse();
    };
    /**
     * @param {?} directive
     * @param {?} inputs
     * @param {?} outputs
     * @param {?} host
     * @param {?} queries
     * @param {?} directiveType
     * @return {?}
     */
    DirectiveResolver.prototype._merge = function (directive, inputs, outputs, host, queries, directiveType) {
        var /** @type {?} */ mergedInputs = this._dedupeBindings(directive.inputs ? directive.inputs.concat(inputs) : inputs);
        var /** @type {?} */ mergedOutputs = this._dedupeBindings(directive.outputs ? directive.outputs.concat(outputs) : outputs);
        var /** @type {?} */ mergedHost = directive.host ? __assign({}, directive.host, host) : host;
        var /** @type {?} */ mergedQueries = directive.queries ? __assign({}, directive.queries, queries) : queries;
        if (directive instanceof __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"]) {
            return new __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"]({
                selector: directive.selector,
                inputs: mergedInputs,
                outputs: mergedOutputs,
                host: mergedHost,
                exportAs: directive.exportAs,
                moduleId: directive.moduleId,
                queries: mergedQueries,
                changeDetection: directive.changeDetection,
                providers: directive.providers,
                viewProviders: directive.viewProviders,
                entryComponents: directive.entryComponents,
                template: directive.template,
                templateUrl: directive.templateUrl,
                styles: directive.styles,
                styleUrls: directive.styleUrls,
                encapsulation: directive.encapsulation,
                animations: directive.animations,
                interpolation: directive.interpolation
            });
        }
        else {
            return new __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"]({
                selector: directive.selector,
                inputs: mergedInputs,
                outputs: mergedOutputs,
                host: mergedHost,
                exportAs: directive.exportAs,
                queries: mergedQueries,
                providers: directive.providers
            });
        }
    };
    return DirectiveResolver;
}());
DirectiveResolver.decorators = [
    { type: CompilerInjectable },
];
/**
 * @nocollapse
 */
DirectiveResolver.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵReflectorReader"], },
]; };
/**
 * @param {?} type
 * @return {?}
 */
function isDirectiveMetadata(type) {
    return type instanceof __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"];
}
/**
 * @template T
 * @param {?} arr
 * @param {?} condition
 * @return {?}
 */
function findLast(arr, condition) {
    for (var /** @type {?} */ i = arr.length - 1; i >= 0; i--) {
        if (condition(arr[i])) {
            return arr[i];
        }
    }
    return null;
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var STRIP_SRC_FILE_SUFFIXES = /(\.ts|\.d\.ts|\.js|\.jsx|\.tsx)$/;
var NG_FACTORY = /\.ngfactory\./;
/**
 * @param {?} filePath
 * @return {?}
 */
function ngfactoryFilePath(filePath) {
    var /** @type {?} */ urlWithSuffix = splitTypescriptSuffix(filePath);
    return urlWithSuffix[0] + ".ngfactory" + urlWithSuffix[1];
}
/**
 * @param {?} filePath
 * @return {?}
 */
function stripNgFactory(filePath) {
    return filePath.replace(NG_FACTORY, '.');
}
/**
 * @param {?} filePath
 * @return {?}
 */
function isNgFactoryFile(filePath) {
    return NG_FACTORY.test(filePath);
}
/**
 * @param {?} path
 * @return {?}
 */
function splitTypescriptSuffix(path) {
    if (path.endsWith('.d.ts')) {
        return [path.slice(0, -5), '.ts'];
    }
    var /** @type {?} */ lastDot = path.lastIndexOf('.');
    if (lastDot !== -1) {
        return [path.substring(0, lastDot), path.substring(lastDot)];
    }
    return [path, ''];
}
/**
 * @param {?} fileName
 * @return {?}
 */
function summaryFileName(fileName) {
    var /** @type {?} */ fileNameWithoutSuffix = fileName.replace(STRIP_SRC_FILE_SUFFIXES, '');
    return fileNameWithoutSuffix + ".ngsummary.json";
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @param {?} hook
 * @param {?} token
 * @return {?}
 */
function hasLifecycleHook(hook, token) {
    return __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵreflector"].hasLifecycleHook(token, getHookName(hook));
}
/**
 * @param {?} hook
 * @return {?}
 */
function getHookName(hook) {
    switch (hook) {
        case __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵLifecycleHooks"].OnInit:
            return 'ngOnInit';
        case __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵLifecycleHooks"].OnDestroy:
            return 'ngOnDestroy';
        case __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵLifecycleHooks"].DoCheck:
            return 'ngDoCheck';
        case __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵLifecycleHooks"].OnChanges:
            return 'ngOnChanges';
        case __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵLifecycleHooks"].AfterContentInit:
            return 'ngAfterContentInit';
        case __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵLifecycleHooks"].AfterContentChecked:
            return 'ngAfterContentChecked';
        case __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵLifecycleHooks"].AfterViewInit:
            return 'ngAfterViewInit';
        case __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵLifecycleHooks"].AfterViewChecked:
            return 'ngAfterViewChecked';
    }
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @param {?} obj
 * @return {?}
 */
function _isNgModuleMetadata(obj) {
    return obj instanceof __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"];
}
/**
 * Resolves types to {\@link NgModule}.
 */
var NgModuleResolver = (function () {
    /**
     * @param {?=} _reflector
     */
    function NgModuleResolver(_reflector) {
        if (_reflector === void 0) { _reflector = __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵreflector"]; }
        this._reflector = _reflector;
    }
    /**
     * @param {?} type
     * @return {?}
     */
    NgModuleResolver.prototype.isNgModule = function (type) { return this._reflector.annotations(type).some(_isNgModuleMetadata); };
    /**
     * @param {?} type
     * @param {?=} throwIfNotFound
     * @return {?}
     */
    NgModuleResolver.prototype.resolve = function (type, throwIfNotFound) {
        if (throwIfNotFound === void 0) { throwIfNotFound = true; }
        var /** @type {?} */ ngModuleMeta = findLast(this._reflector.annotations(type), _isNgModuleMetadata);
        if (ngModuleMeta) {
            return ngModuleMeta;
        }
        else {
            if (throwIfNotFound) {
                throw new Error("No NgModule metadata found for '" + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵstringify"])(type) + "'.");
            }
            return null;
        }
    };
    return NgModuleResolver;
}());
NgModuleResolver.decorators = [
    { type: CompilerInjectable },
];
/**
 * @nocollapse
 */
NgModuleResolver.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵReflectorReader"], },
]; };
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @param {?} type
 * @return {?}
 */
function _isPipeMetadata(type) {
    return type instanceof __WEBPACK_IMPORTED_MODULE_0__angular_core__["Pipe"];
}
/**
 * Resolve a `Type` for {\@link Pipe}.
 *
 * This interface can be overridden by the application developer to create custom behavior.
 *
 * See {\@link Compiler}
 */
var PipeResolver = (function () {
    /**
     * @param {?=} _reflector
     */
    function PipeResolver(_reflector) {
        if (_reflector === void 0) { _reflector = __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵreflector"]; }
        this._reflector = _reflector;
    }
    /**
     * @param {?} type
     * @return {?}
     */
    PipeResolver.prototype.isPipe = function (type) {
        var /** @type {?} */ typeMetadata = this._reflector.annotations(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["resolveForwardRef"])(type));
        return typeMetadata && typeMetadata.some(_isPipeMetadata);
    };
    /**
     * Return {\@link Pipe} for a given `Type`.
     * @param {?} type
     * @param {?=} throwIfNotFound
     * @return {?}
     */
    PipeResolver.prototype.resolve = function (type, throwIfNotFound) {
        if (throwIfNotFound === void 0) { throwIfNotFound = true; }
        var /** @type {?} */ metas = this._reflector.annotations(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["resolveForwardRef"])(type));
        if (metas) {
            var /** @type {?} */ annotation = findLast(metas, _isPipeMetadata);
            if (annotation) {
                return annotation;
            }
        }
        if (throwIfNotFound) {
            throw new Error("No Pipe decorator found on " + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵstringify"])(type));
        }
        return null;
    };
    return PipeResolver;
}());
PipeResolver.decorators = [
    { type: CompilerInjectable },
];
/**
 * @nocollapse
 */
PipeResolver.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵReflectorReader"], },
]; };
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var SummaryResolver = (function () {
    function SummaryResolver() {
    }
    /**
     * @param {?} fileName
     * @return {?}
     */
    SummaryResolver.prototype.isLibraryFile = function (fileName) { return false; };
    ;
    /**
     * @param {?} fileName
     * @return {?}
     */
    SummaryResolver.prototype.getLibraryFileName = function (fileName) { return null; };
    /**
     * @param {?} reference
     * @return {?}
     */
    SummaryResolver.prototype.resolveSummary = function (reference) { return null; };
    ;
    /**
     * @param {?} filePath
     * @return {?}
     */
    SummaryResolver.prototype.getSymbolsOf = function (filePath) { return []; };
    /**
     * @param {?} reference
     * @return {?}
     */
    SummaryResolver.prototype.getImportAs = function (reference) { return reference; };
    return SummaryResolver;
}());
SummaryResolver.decorators = [
    { type: CompilerInjectable },
];
/**
 * @nocollapse
 */
SummaryResolver.ctorParameters = function () { return []; };
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var ERROR_COLLECTOR_TOKEN = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["InjectionToken"]('ErrorCollector');
var CompileMetadataResolver = (function () {
    /**
     * @param {?} _config
     * @param {?} _ngModuleResolver
     * @param {?} _directiveResolver
     * @param {?} _pipeResolver
     * @param {?} _summaryResolver
     * @param {?} _schemaRegistry
     * @param {?} _directiveNormalizer
     * @param {?} _console
     * @param {?} _staticSymbolCache
     * @param {?=} _reflector
     * @param {?=} _errorCollector
     */
    function CompileMetadataResolver(_config, _ngModuleResolver, _directiveResolver, _pipeResolver, _summaryResolver, _schemaRegistry, _directiveNormalizer, _console, _staticSymbolCache, _reflector, _errorCollector) {
        if (_reflector === void 0) { _reflector = __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵreflector"]; }
        this._config = _config;
        this._ngModuleResolver = _ngModuleResolver;
        this._directiveResolver = _directiveResolver;
        this._pipeResolver = _pipeResolver;
        this._summaryResolver = _summaryResolver;
        this._schemaRegistry = _schemaRegistry;
        this._directiveNormalizer = _directiveNormalizer;
        this._console = _console;
        this._staticSymbolCache = _staticSymbolCache;
        this._reflector = _reflector;
        this._errorCollector = _errorCollector;
        this._nonNormalizedDirectiveCache = new Map();
        this._directiveCache = new Map();
        this._summaryCache = new Map();
        this._pipeCache = new Map();
        this._ngModuleCache = new Map();
        this._ngModuleOfTypes = new Map();
    }
    /**
     * @param {?} type
     * @return {?}
     */
    CompileMetadataResolver.prototype.clearCacheFor = function (type) {
        var /** @type {?} */ dirMeta = this._directiveCache.get(type);
        this._directiveCache.delete(type);
        this._nonNormalizedDirectiveCache.delete(type);
        this._summaryCache.delete(type);
        this._pipeCache.delete(type);
        this._ngModuleOfTypes.delete(type);
        // Clear all of the NgModule as they contain transitive information!
        this._ngModuleCache.clear();
        if (dirMeta) {
            this._directiveNormalizer.clearCacheFor(dirMeta);
        }
    };
    /**
     * @return {?}
     */
    CompileMetadataResolver.prototype.clearCache = function () {
        this._directiveCache.clear();
        this._nonNormalizedDirectiveCache.clear();
        this._summaryCache.clear();
        this._pipeCache.clear();
        this._ngModuleCache.clear();
        this._ngModuleOfTypes.clear();
        this._directiveNormalizer.clearCache();
    };
    /**
     * @param {?} baseType
     * @param {?} name
     * @return {?}
     */
    CompileMetadataResolver.prototype._createProxyClass = function (baseType, name) {
        var /** @type {?} */ delegate = null;
        var /** @type {?} */ proxyClass = (function () {
            if (!delegate) {
                throw new Error("Illegal state: Class " + name + " for type " + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵstringify"])(baseType) + " is not compiled yet!");
            }
            return delegate.apply(this, arguments);
        });
        proxyClass.setDelegate = function (d) {
            delegate = d;
            ((proxyClass)).prototype = d.prototype;
        };
        // Make stringify work correctly
        ((proxyClass)).overriddenName = name;
        return proxyClass;
    };
    /**
     * @param {?} dirType
     * @param {?} name
     * @return {?}
     */
    CompileMetadataResolver.prototype.getGeneratedClass = function (dirType, name) {
        if (dirType instanceof StaticSymbol) {
            return this._staticSymbolCache.get(ngfactoryFilePath(dirType.filePath), name);
        }
        else {
            return this._createProxyClass(dirType, name);
        }
    };
    /**
     * @param {?} dirType
     * @return {?}
     */
    CompileMetadataResolver.prototype.getComponentViewClass = function (dirType) {
        return this.getGeneratedClass(dirType, viewClassName(dirType, 0));
    };
    /**
     * @param {?} dirType
     * @return {?}
     */
    CompileMetadataResolver.prototype.getHostComponentViewClass = function (dirType) {
        return this.getGeneratedClass(dirType, hostViewClassName(dirType));
    };
    /**
     * @param {?} dirType
     * @return {?}
     */
    CompileMetadataResolver.prototype.getHostComponentType = function (dirType) {
        var /** @type {?} */ name = identifierName({ reference: dirType }) + "_Host";
        if (dirType instanceof StaticSymbol) {
            return this._staticSymbolCache.get(dirType.filePath, name);
        }
        else {
            var /** @type {?} */ HostClass = (function HostClass() { });
            HostClass.overriddenName = name;
            return HostClass;
        }
    };
    /**
     * @param {?} dirType
     * @return {?}
     */
    CompileMetadataResolver.prototype.getRendererType = function (dirType) {
        if (dirType instanceof StaticSymbol) {
            return this._staticSymbolCache.get(ngfactoryFilePath(dirType.filePath), rendererTypeName(dirType));
        }
        else {
            // returning an object as proxy,
            // that we fill later during runtime compilation.
            return ({});
        }
    };
    /**
     * @param {?} selector
     * @param {?} dirType
     * @param {?} inputs
     * @param {?} outputs
     * @return {?}
     */
    CompileMetadataResolver.prototype.getComponentFactory = function (selector, dirType, inputs, outputs) {
        if (dirType instanceof StaticSymbol) {
            return this._staticSymbolCache.get(ngfactoryFilePath(dirType.filePath), componentFactoryName(dirType));
        }
        else {
            var /** @type {?} */ hostView = this.getHostComponentViewClass(dirType);
            // Note: ngContentSelectors will be filled later once the template is
            // loaded.
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵccf"])(selector, dirType, /** @type {?} */ (hostView), inputs, outputs, []);
        }
    };
    /**
     * @param {?} factory
     * @param {?} ngContentSelectors
     * @return {?}
     */
    CompileMetadataResolver.prototype.initComponentFactory = function (factory, ngContentSelectors) {
        if (!(factory instanceof StaticSymbol)) {
            (_a = factory.ngContentSelectors).push.apply(_a, ngContentSelectors);
        }
        var _a;
    };
    /**
     * @param {?} type
     * @param {?} kind
     * @return {?}
     */
    CompileMetadataResolver.prototype._loadSummary = function (type, kind) {
        var /** @type {?} */ typeSummary = this._summaryCache.get(type);
        if (!typeSummary) {
            var /** @type {?} */ summary = this._summaryResolver.resolveSummary(type);
            typeSummary = summary ? summary.type : null;
            this._summaryCache.set(type, typeSummary || null);
        }
        return typeSummary && typeSummary.summaryKind === kind ? typeSummary : null;
    };
    /**
     * @param {?} ngModuleType
     * @param {?} directiveType
     * @param {?} isSync
     * @return {?}
     */
    CompileMetadataResolver.prototype._loadDirectiveMetadata = function (ngModuleType, directiveType, isSync) {
        var _this = this;
        if (this._directiveCache.has(directiveType)) {
            return null;
        }
        directiveType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["resolveForwardRef"])(directiveType);
        var _a = ((this.getNonNormalizedDirectiveMetadata(directiveType))), annotation = _a.annotation, metadata = _a.metadata;
        var /** @type {?} */ createDirectiveMetadata = function (templateMetadata) {
            var /** @type {?} */ normalizedDirMeta = new CompileDirectiveMetadata({
                isHost: false,
                type: metadata.type,
                isComponent: metadata.isComponent,
                selector: metadata.selector,
                exportAs: metadata.exportAs,
                changeDetection: metadata.changeDetection,
                inputs: metadata.inputs,
                outputs: metadata.outputs,
                hostListeners: metadata.hostListeners,
                hostProperties: metadata.hostProperties,
                hostAttributes: metadata.hostAttributes,
                providers: metadata.providers,
                viewProviders: metadata.viewProviders,
                queries: metadata.queries,
                viewQueries: metadata.viewQueries,
                entryComponents: metadata.entryComponents,
                componentViewType: metadata.componentViewType,
                rendererType: metadata.rendererType,
                componentFactory: metadata.componentFactory,
                template: templateMetadata
            });
            if (templateMetadata) {
                _this.initComponentFactory(/** @type {?} */ ((metadata.componentFactory)), templateMetadata.ngContentSelectors);
            }
            _this._directiveCache.set(directiveType, normalizedDirMeta);
            _this._summaryCache.set(directiveType, normalizedDirMeta.toSummary());
            return normalizedDirMeta;
        };
        if (metadata.isComponent) {
            var /** @type {?} */ template = ((metadata.template));
            var /** @type {?} */ templateMeta = this._directiveNormalizer.normalizeTemplate({
                ngModuleType: ngModuleType,
                componentType: directiveType,
                moduleUrl: componentModuleUrl(this._reflector, directiveType, annotation),
                encapsulation: template.encapsulation,
                template: template.template,
                templateUrl: template.templateUrl,
                styles: template.styles,
                styleUrls: template.styleUrls,
                animations: template.animations,
                interpolation: template.interpolation
            });
            if (templateMeta.syncResult) {
                createDirectiveMetadata(templateMeta.syncResult);
                return null;
            }
            else {
                if (isSync) {
                    this._reportError(componentStillLoadingError(directiveType), directiveType);
                    return null;
                }
                return ((templateMeta.asyncResult)).then(createDirectiveMetadata);
            }
        }
        else {
            // directive
            createDirectiveMetadata(null);
            return null;
        }
    };
    /**
     * @param {?} directiveType
     * @return {?}
     */
    CompileMetadataResolver.prototype.getNonNormalizedDirectiveMetadata = function (directiveType) {
        var _this = this;
        directiveType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["resolveForwardRef"])(directiveType);
        if (!directiveType) {
            return null;
        }
        var /** @type {?} */ cacheEntry = this._nonNormalizedDirectiveCache.get(directiveType);
        if (cacheEntry) {
            return cacheEntry;
        }
        var /** @type {?} */ dirMeta = this._directiveResolver.resolve(directiveType, false);
        if (!dirMeta) {
            return null;
        }
        var /** @type {?} */ nonNormalizedTemplateMetadata = ((undefined));
        if (dirMeta instanceof __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"]) {
            // component
            assertArrayOfStrings('styles', dirMeta.styles);
            assertArrayOfStrings('styleUrls', dirMeta.styleUrls);
            assertInterpolationSymbols('interpolation', dirMeta.interpolation);
            var /** @type {?} */ animations = dirMeta.animations;
            nonNormalizedTemplateMetadata = new CompileTemplateMetadata({
                encapsulation: noUndefined(dirMeta.encapsulation),
                template: noUndefined(dirMeta.template),
                templateUrl: noUndefined(dirMeta.templateUrl),
                styles: dirMeta.styles || [],
                styleUrls: dirMeta.styleUrls || [],
                animations: animations || [],
                interpolation: noUndefined(dirMeta.interpolation),
                isInline: !!dirMeta.template,
                externalStylesheets: [],
                ngContentSelectors: []
            });
        }
        var /** @type {?} */ changeDetectionStrategy = ((null));
        var /** @type {?} */ viewProviders = [];
        var /** @type {?} */ entryComponentMetadata = [];
        var /** @type {?} */ selector = dirMeta.selector;
        if (dirMeta instanceof __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"]) {
            // Component
            changeDetectionStrategy = ((dirMeta.changeDetection));
            if (dirMeta.viewProviders) {
                viewProviders = this._getProvidersMetadata(dirMeta.viewProviders, entryComponentMetadata, "viewProviders for \"" + stringifyType(directiveType) + "\"", [], directiveType);
            }
            if (dirMeta.entryComponents) {
                entryComponentMetadata = flattenAndDedupeArray(dirMeta.entryComponents)
                    .map(function (type) { return ((_this._getEntryComponentMetadata(type))); })
                    .concat(entryComponentMetadata);
            }
            if (!selector) {
                selector = this._schemaRegistry.getDefaultComponentElementName();
            }
        }
        else {
            // Directive
            if (!selector) {
                this._reportError(syntaxError("Directive " + stringifyType(directiveType) + " has no selector, please add it!"), directiveType);
                selector = 'error';
            }
        }
        var /** @type {?} */ providers = [];
        if (dirMeta.providers != null) {
            providers = this._getProvidersMetadata(dirMeta.providers, entryComponentMetadata, "providers for \"" + stringifyType(directiveType) + "\"", [], directiveType);
        }
        var /** @type {?} */ queries = [];
        var /** @type {?} */ viewQueries = [];
        if (dirMeta.queries != null) {
            queries = this._getQueriesMetadata(dirMeta.queries, false, directiveType);
            viewQueries = this._getQueriesMetadata(dirMeta.queries, true, directiveType);
        }
        var /** @type {?} */ metadata = CompileDirectiveMetadata.create({
            isHost: false,
            selector: selector,
            exportAs: noUndefined(dirMeta.exportAs),
            isComponent: !!nonNormalizedTemplateMetadata,
            type: this._getTypeMetadata(directiveType),
            template: nonNormalizedTemplateMetadata,
            changeDetection: changeDetectionStrategy,
            inputs: dirMeta.inputs || [],
            outputs: dirMeta.outputs || [],
            host: dirMeta.host || {},
            providers: providers || [],
            viewProviders: viewProviders || [],
            queries: queries || [],
            viewQueries: viewQueries || [],
            entryComponents: entryComponentMetadata,
            componentViewType: nonNormalizedTemplateMetadata ? this.getComponentViewClass(directiveType) :
                null,
            rendererType: nonNormalizedTemplateMetadata ? this.getRendererType(directiveType) : null,
            componentFactory: null
        });
        if (nonNormalizedTemplateMetadata) {
            metadata.componentFactory =
                this.getComponentFactory(selector, directiveType, metadata.inputs, metadata.outputs);
        }
        cacheEntry = { metadata: metadata, annotation: dirMeta };
        this._nonNormalizedDirectiveCache.set(directiveType, cacheEntry);
        return cacheEntry;
    };
    /**
     * Gets the metadata for the given directive.
     * This assumes `loadNgModuleDirectiveAndPipeMetadata` has been called first.
     * @param {?} directiveType
     * @return {?}
     */
    CompileMetadataResolver.prototype.getDirectiveMetadata = function (directiveType) {
        var /** @type {?} */ dirMeta = ((this._directiveCache.get(directiveType)));
        if (!dirMeta) {
            this._reportError(syntaxError("Illegal state: getDirectiveMetadata can only be called after loadNgModuleDirectiveAndPipeMetadata for a module that declares it. Directive " + stringifyType(directiveType) + "."), directiveType);
        }
        return dirMeta;
    };
    /**
     * @param {?} dirType
     * @return {?}
     */
    CompileMetadataResolver.prototype.getDirectiveSummary = function (dirType) {
        var /** @type {?} */ dirSummary = (this._loadSummary(dirType, CompileSummaryKind.Directive));
        if (!dirSummary) {
            this._reportError(syntaxError("Illegal state: Could not load the summary for directive " + stringifyType(dirType) + "."), dirType);
        }
        return dirSummary;
    };
    /**
     * @param {?} type
     * @return {?}
     */
    CompileMetadataResolver.prototype.isDirective = function (type) { return this._directiveResolver.isDirective(type); };
    /**
     * @param {?} type
     * @return {?}
     */
    CompileMetadataResolver.prototype.isPipe = function (type) { return this._pipeResolver.isPipe(type); };
    /**
     * @param {?} moduleType
     * @return {?}
     */
    CompileMetadataResolver.prototype.getNgModuleSummary = function (moduleType) {
        var /** @type {?} */ moduleSummary = (this._loadSummary(moduleType, CompileSummaryKind.NgModule));
        if (!moduleSummary) {
            var /** @type {?} */ moduleMeta = this.getNgModuleMetadata(moduleType, false);
            moduleSummary = moduleMeta ? moduleMeta.toSummary() : null;
            if (moduleSummary) {
                this._summaryCache.set(moduleType, moduleSummary);
            }
        }
        return moduleSummary;
    };
    /**
     * Loads the declared directives and pipes of an NgModule.
     * @param {?} moduleType
     * @param {?} isSync
     * @param {?=} throwIfNotFound
     * @return {?}
     */
    CompileMetadataResolver.prototype.loadNgModuleDirectiveAndPipeMetadata = function (moduleType, isSync, throwIfNotFound) {
        var _this = this;
        if (throwIfNotFound === void 0) { throwIfNotFound = true; }
        var /** @type {?} */ ngModule = this.getNgModuleMetadata(moduleType, throwIfNotFound);
        var /** @type {?} */ loading = [];
        if (ngModule) {
            ngModule.declaredDirectives.forEach(function (id) {
                var /** @type {?} */ promise = _this._loadDirectiveMetadata(moduleType, id.reference, isSync);
                if (promise) {
                    loading.push(promise);
                }
            });
            ngModule.declaredPipes.forEach(function (id) { return _this._loadPipeMetadata(id.reference); });
        }
        return Promise.all(loading);
    };
    /**
     * @param {?} moduleType
     * @param {?=} throwIfNotFound
     * @return {?}
     */
    CompileMetadataResolver.prototype.getNgModuleMetadata = function (moduleType, throwIfNotFound) {
        var _this = this;
        if (throwIfNotFound === void 0) { throwIfNotFound = true; }
        moduleType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["resolveForwardRef"])(moduleType);
        var /** @type {?} */ compileMeta = this._ngModuleCache.get(moduleType);
        if (compileMeta) {
            return compileMeta;
        }
        var /** @type {?} */ meta = this._ngModuleResolver.resolve(moduleType, throwIfNotFound);
        if (!meta) {
            return null;
        }
        var /** @type {?} */ declaredDirectives = [];
        var /** @type {?} */ exportedNonModuleIdentifiers = [];
        var /** @type {?} */ declaredPipes = [];
        var /** @type {?} */ importedModules = [];
        var /** @type {?} */ exportedModules = [];
        var /** @type {?} */ providers = [];
        var /** @type {?} */ entryComponents = [];
        var /** @type {?} */ bootstrapComponents = [];
        var /** @type {?} */ schemas = [];
        if (meta.imports) {
            flattenAndDedupeArray(meta.imports).forEach(function (importedType) {
                var /** @type {?} */ importedModuleType = ((undefined));
                if (isValidType(importedType)) {
                    importedModuleType = importedType;
                }
                else if (importedType && importedType.ngModule) {
                    var /** @type {?} */ moduleWithProviders = importedType;
                    importedModuleType = moduleWithProviders.ngModule;
                    if (moduleWithProviders.providers) {
                        providers.push.apply(providers, _this._getProvidersMetadata(moduleWithProviders.providers, entryComponents, "provider for the NgModule '" + stringifyType(importedModuleType) + "'", [], importedType));
                    }
                }
                if (importedModuleType) {
                    if (_this._checkSelfImport(moduleType, importedModuleType))
                        return;
                    var /** @type {?} */ importedModuleSummary = _this.getNgModuleSummary(importedModuleType);
                    if (!importedModuleSummary) {
                        _this._reportError(syntaxError("Unexpected " + _this._getTypeDescriptor(importedType) + " '" + stringifyType(importedType) + "' imported by the module '" + stringifyType(moduleType) + "'. Please add a @NgModule annotation."), moduleType);
                        return;
                    }
                    importedModules.push(importedModuleSummary);
                }
                else {
                    _this._reportError(syntaxError("Unexpected value '" + stringifyType(importedType) + "' imported by the module '" + stringifyType(moduleType) + "'"), moduleType);
                    return;
                }
            });
        }
        if (meta.exports) {
            flattenAndDedupeArray(meta.exports).forEach(function (exportedType) {
                if (!isValidType(exportedType)) {
                    _this._reportError(syntaxError("Unexpected value '" + stringifyType(exportedType) + "' exported by the module '" + stringifyType(moduleType) + "'"), moduleType);
                    return;
                }
                var /** @type {?} */ exportedModuleSummary = _this.getNgModuleSummary(exportedType);
                if (exportedModuleSummary) {
                    exportedModules.push(exportedModuleSummary);
                }
                else {
                    exportedNonModuleIdentifiers.push(_this._getIdentifierMetadata(exportedType));
                }
            });
        }
        // Note: This will be modified later, so we rely on
        // getting a new instance every time!
        var /** @type {?} */ transitiveModule = this._getTransitiveNgModuleMetadata(importedModules, exportedModules);
        if (meta.declarations) {
            flattenAndDedupeArray(meta.declarations).forEach(function (declaredType) {
                if (!isValidType(declaredType)) {
                    _this._reportError(syntaxError("Unexpected value '" + stringifyType(declaredType) + "' declared by the module '" + stringifyType(moduleType) + "'"), moduleType);
                    return;
                }
                var /** @type {?} */ declaredIdentifier = _this._getIdentifierMetadata(declaredType);
                if (_this._directiveResolver.isDirective(declaredType)) {
                    transitiveModule.addDirective(declaredIdentifier);
                    declaredDirectives.push(declaredIdentifier);
                    _this._addTypeToModule(declaredType, moduleType);
                }
                else if (_this._pipeResolver.isPipe(declaredType)) {
                    transitiveModule.addPipe(declaredIdentifier);
                    transitiveModule.pipes.push(declaredIdentifier);
                    declaredPipes.push(declaredIdentifier);
                    _this._addTypeToModule(declaredType, moduleType);
                }
                else {
                    _this._reportError(syntaxError("Unexpected " + _this._getTypeDescriptor(declaredType) + " '" + stringifyType(declaredType) + "' declared by the module '" + stringifyType(moduleType) + "'. Please add a @Pipe/@Directive/@Component annotation."), moduleType);
                    return;
                }
            });
        }
        var /** @type {?} */ exportedDirectives = [];
        var /** @type {?} */ exportedPipes = [];
        exportedNonModuleIdentifiers.forEach(function (exportedId) {
            if (transitiveModule.directivesSet.has(exportedId.reference)) {
                exportedDirectives.push(exportedId);
                transitiveModule.addExportedDirective(exportedId);
            }
            else if (transitiveModule.pipesSet.has(exportedId.reference)) {
                exportedPipes.push(exportedId);
                transitiveModule.addExportedPipe(exportedId);
            }
            else {
                _this._reportError(syntaxError("Can't export " + _this._getTypeDescriptor(exportedId.reference) + " " + stringifyType(exportedId.reference) + " from " + stringifyType(moduleType) + " as it was neither declared nor imported!"), moduleType);
                return;
            }
        });
        // The providers of the module have to go last
        // so that they overwrite any other provider we already added.
        if (meta.providers) {
            providers.push.apply(providers, this._getProvidersMetadata(meta.providers, entryComponents, "provider for the NgModule '" + stringifyType(moduleType) + "'", [], moduleType));
        }
        if (meta.entryComponents) {
            entryComponents.push.apply(entryComponents, flattenAndDedupeArray(meta.entryComponents)
                .map(function (type) { return ((_this._getEntryComponentMetadata(type))); }));
        }
        if (meta.bootstrap) {
            flattenAndDedupeArray(meta.bootstrap).forEach(function (type) {
                if (!isValidType(type)) {
                    _this._reportError(syntaxError("Unexpected value '" + stringifyType(type) + "' used in the bootstrap property of module '" + stringifyType(moduleType) + "'"), moduleType);
                    return;
                }
                bootstrapComponents.push(_this._getIdentifierMetadata(type));
            });
        }
        entryComponents.push.apply(entryComponents, bootstrapComponents.map(function (type) { return ((_this._getEntryComponentMetadata(type.reference))); }));
        if (meta.schemas) {
            schemas.push.apply(schemas, flattenAndDedupeArray(meta.schemas));
        }
        compileMeta = new CompileNgModuleMetadata({
            type: this._getTypeMetadata(moduleType),
            providers: providers,
            entryComponents: entryComponents,
            bootstrapComponents: bootstrapComponents,
            schemas: schemas,
            declaredDirectives: declaredDirectives,
            exportedDirectives: exportedDirectives,
            declaredPipes: declaredPipes,
            exportedPipes: exportedPipes,
            importedModules: importedModules,
            exportedModules: exportedModules,
            transitiveModule: transitiveModule,
            id: meta.id || null,
        });
        entryComponents.forEach(function (id) { return transitiveModule.addEntryComponent(id); });
        providers.forEach(function (provider) { return transitiveModule.addProvider(provider, /** @type {?} */ ((compileMeta)).type); });
        transitiveModule.addModule(compileMeta.type);
        this._ngModuleCache.set(moduleType, compileMeta);
        return compileMeta;
    };
    /**
     * @param {?} moduleType
     * @param {?} importedModuleType
     * @return {?}
     */
    CompileMetadataResolver.prototype._checkSelfImport = function (moduleType, importedModuleType) {
        if (moduleType === importedModuleType) {
            this._reportError(syntaxError("'" + stringifyType(moduleType) + "' module can't import itself"), moduleType);
            return true;
        }
        return false;
    };
    /**
     * @param {?} type
     * @return {?}
     */
    CompileMetadataResolver.prototype._getTypeDescriptor = function (type) {
        if (this._directiveResolver.isDirective(type)) {
            return 'directive';
        }
        if (this._pipeResolver.isPipe(type)) {
            return 'pipe';
        }
        if (this._ngModuleResolver.isNgModule(type)) {
            return 'module';
        }
        if (((type)).provide) {
            return 'provider';
        }
        return 'value';
    };
    /**
     * @param {?} type
     * @param {?} moduleType
     * @return {?}
     */
    CompileMetadataResolver.prototype._addTypeToModule = function (type, moduleType) {
        var /** @type {?} */ oldModule = this._ngModuleOfTypes.get(type);
        if (oldModule && oldModule !== moduleType) {
            this._reportError(syntaxError("Type " + stringifyType(type) + " is part of the declarations of 2 modules: " + stringifyType(oldModule) + " and " + stringifyType(moduleType) + "! " +
                ("Please consider moving " + stringifyType(type) + " to a higher module that imports " + stringifyType(oldModule) + " and " + stringifyType(moduleType) + ". ") +
                ("You can also create a new NgModule that exports and includes " + stringifyType(type) + " then import that NgModule in " + stringifyType(oldModule) + " and " + stringifyType(moduleType) + ".")), moduleType);
            return;
        }
        this._ngModuleOfTypes.set(type, moduleType);
    };
    /**
     * @param {?} importedModules
     * @param {?} exportedModules
     * @return {?}
     */
    CompileMetadataResolver.prototype._getTransitiveNgModuleMetadata = function (importedModules, exportedModules) {
        // collect `providers` / `entryComponents` from all imported and all exported modules
        var /** @type {?} */ result = new TransitiveCompileNgModuleMetadata();
        var /** @type {?} */ modulesByToken = new Map();
        importedModules.concat(exportedModules).forEach(function (modSummary) {
            modSummary.modules.forEach(function (mod) { return result.addModule(mod); });
            modSummary.entryComponents.forEach(function (comp) { return result.addEntryComponent(comp); });
            var /** @type {?} */ addedTokens = new Set();
            modSummary.providers.forEach(function (entry) {
                var /** @type {?} */ tokenRef = tokenReference(entry.provider.token);
                var /** @type {?} */ prevModules = modulesByToken.get(tokenRef);
                if (!prevModules) {
                    prevModules = new Set();
                    modulesByToken.set(tokenRef, prevModules);
                }
                var /** @type {?} */ moduleRef = entry.module.reference;
                // Note: the providers of one module may still contain multiple providers
                // per token (e.g. for multi providers), and we need to preserve these.
                if (addedTokens.has(tokenRef) || !prevModules.has(moduleRef)) {
                    prevModules.add(moduleRef);
                    addedTokens.add(tokenRef);
                    result.addProvider(entry.provider, entry.module);
                }
            });
        });
        exportedModules.forEach(function (modSummary) {
            modSummary.exportedDirectives.forEach(function (id) { return result.addExportedDirective(id); });
            modSummary.exportedPipes.forEach(function (id) { return result.addExportedPipe(id); });
        });
        importedModules.forEach(function (modSummary) {
            modSummary.exportedDirectives.forEach(function (id) { return result.addDirective(id); });
            modSummary.exportedPipes.forEach(function (id) { return result.addPipe(id); });
        });
        return result;
    };
    /**
     * @param {?} type
     * @return {?}
     */
    CompileMetadataResolver.prototype._getIdentifierMetadata = function (type) {
        type = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["resolveForwardRef"])(type);
        return { reference: type };
    };
    /**
     * @param {?} type
     * @return {?}
     */
    CompileMetadataResolver.prototype.isInjectable = function (type) {
        var /** @type {?} */ annotations = this._reflector.annotations(type);
        // Note: We need an exact check here as @Component / @Directive / ... inherit
        // from @CompilerInjectable!
        return annotations.some(function (ann) { return ann.constructor === __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"]; });
    };
    /**
     * @param {?} type
     * @return {?}
     */
    CompileMetadataResolver.prototype.getInjectableSummary = function (type) {
        return {
            summaryKind: CompileSummaryKind.Injectable,
            type: this._getTypeMetadata(type, null, false)
        };
    };
    /**
     * @param {?} type
     * @param {?=} dependencies
     * @return {?}
     */
    CompileMetadataResolver.prototype._getInjectableMetadata = function (type, dependencies) {
        if (dependencies === void 0) { dependencies = null; }
        var /** @type {?} */ typeSummary = this._loadSummary(type, CompileSummaryKind.Injectable);
        if (typeSummary) {
            return typeSummary.type;
        }
        return this._getTypeMetadata(type, dependencies);
    };
    /**
     * @param {?} type
     * @param {?=} dependencies
     * @param {?=} throwOnUnknownDeps
     * @return {?}
     */
    CompileMetadataResolver.prototype._getTypeMetadata = function (type, dependencies, throwOnUnknownDeps) {
        if (dependencies === void 0) { dependencies = null; }
        if (throwOnUnknownDeps === void 0) { throwOnUnknownDeps = true; }
        var /** @type {?} */ identifier = this._getIdentifierMetadata(type);
        return {
            reference: identifier.reference,
            diDeps: this._getDependenciesMetadata(identifier.reference, dependencies, throwOnUnknownDeps),
            lifecycleHooks: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵLIFECYCLE_HOOKS_VALUES"].filter(function (hook) { return hasLifecycleHook(hook, identifier.reference); }),
        };
    };
    /**
     * @param {?} factory
     * @param {?=} dependencies
     * @return {?}
     */
    CompileMetadataResolver.prototype._getFactoryMetadata = function (factory, dependencies) {
        if (dependencies === void 0) { dependencies = null; }
        factory = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["resolveForwardRef"])(factory);
        return { reference: factory, diDeps: this._getDependenciesMetadata(factory, dependencies) };
    };
    /**
     * Gets the metadata for the given pipe.
     * This assumes `loadNgModuleDirectiveAndPipeMetadata` has been called first.
     * @param {?} pipeType
     * @return {?}
     */
    CompileMetadataResolver.prototype.getPipeMetadata = function (pipeType) {
        var /** @type {?} */ pipeMeta = this._pipeCache.get(pipeType);
        if (!pipeMeta) {
            this._reportError(syntaxError("Illegal state: getPipeMetadata can only be called after loadNgModuleDirectiveAndPipeMetadata for a module that declares it. Pipe " + stringifyType(pipeType) + "."), pipeType);
        }
        return pipeMeta || null;
    };
    /**
     * @param {?} pipeType
     * @return {?}
     */
    CompileMetadataResolver.prototype.getPipeSummary = function (pipeType) {
        var /** @type {?} */ pipeSummary = (this._loadSummary(pipeType, CompileSummaryKind.Pipe));
        if (!pipeSummary) {
            this._reportError(syntaxError("Illegal state: Could not load the summary for pipe " + stringifyType(pipeType) + "."), pipeType);
        }
        return pipeSummary;
    };
    /**
     * @param {?} pipeType
     * @return {?}
     */
    CompileMetadataResolver.prototype.getOrLoadPipeMetadata = function (pipeType) {
        var /** @type {?} */ pipeMeta = this._pipeCache.get(pipeType);
        if (!pipeMeta) {
            pipeMeta = this._loadPipeMetadata(pipeType);
        }
        return pipeMeta;
    };
    /**
     * @param {?} pipeType
     * @return {?}
     */
    CompileMetadataResolver.prototype._loadPipeMetadata = function (pipeType) {
        pipeType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["resolveForwardRef"])(pipeType);
        var /** @type {?} */ pipeAnnotation = ((this._pipeResolver.resolve(pipeType)));
        var /** @type {?} */ pipeMeta = new CompilePipeMetadata({
            type: this._getTypeMetadata(pipeType),
            name: pipeAnnotation.name,
            pure: !!pipeAnnotation.pure
        });
        this._pipeCache.set(pipeType, pipeMeta);
        this._summaryCache.set(pipeType, pipeMeta.toSummary());
        return pipeMeta;
    };
    /**
     * @param {?} typeOrFunc
     * @param {?} dependencies
     * @param {?=} throwOnUnknownDeps
     * @return {?}
     */
    CompileMetadataResolver.prototype._getDependenciesMetadata = function (typeOrFunc, dependencies, throwOnUnknownDeps) {
        var _this = this;
        if (throwOnUnknownDeps === void 0) { throwOnUnknownDeps = true; }
        var /** @type {?} */ hasUnknownDeps = false;
        var /** @type {?} */ params = dependencies || this._reflector.parameters(typeOrFunc) || [];
        var /** @type {?} */ dependenciesMetadata = params.map(function (param) {
            var /** @type {?} */ isAttribute = false;
            var /** @type {?} */ isHost = false;
            var /** @type {?} */ isSelf = false;
            var /** @type {?} */ isSkipSelf = false;
            var /** @type {?} */ isOptional = false;
            var /** @type {?} */ token = null;
            if (Array.isArray(param)) {
                param.forEach(function (paramEntry) {
                    if (paramEntry instanceof __WEBPACK_IMPORTED_MODULE_0__angular_core__["Host"]) {
                        isHost = true;
                    }
                    else if (paramEntry instanceof __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"]) {
                        isSelf = true;
                    }
                    else if (paramEntry instanceof __WEBPACK_IMPORTED_MODULE_0__angular_core__["SkipSelf"]) {
                        isSkipSelf = true;
                    }
                    else if (paramEntry instanceof __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"]) {
                        isOptional = true;
                    }
                    else if (paramEntry instanceof __WEBPACK_IMPORTED_MODULE_0__angular_core__["Attribute"]) {
                        isAttribute = true;
                        token = paramEntry.attributeName;
                    }
                    else if (paramEntry instanceof __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"]) {
                        token = paramEntry.token;
                    }
                    else if (paramEntry instanceof __WEBPACK_IMPORTED_MODULE_0__angular_core__["InjectionToken"]) {
                        token = paramEntry;
                    }
                    else if (isValidType(paramEntry) && token == null) {
                        token = paramEntry;
                    }
                });
            }
            else {
                token = param;
            }
            if (token == null) {
                hasUnknownDeps = true;
                return ((null));
            }
            return {
                isAttribute: isAttribute,
                isHost: isHost,
                isSelf: isSelf,
                isSkipSelf: isSkipSelf,
                isOptional: isOptional,
                token: _this._getTokenMetadata(token)
            };
        });
        if (hasUnknownDeps) {
            var /** @type {?} */ depsTokens = dependenciesMetadata.map(function (dep) { return dep ? stringifyType(dep.token) : '?'; }).join(', ');
            var /** @type {?} */ message = "Can't resolve all parameters for " + stringifyType(typeOrFunc) + ": (" + depsTokens + ").";
            if (throwOnUnknownDeps) {
                this._reportError(syntaxError(message), typeOrFunc);
            }
            else {
                this._console.warn("Warning: " + message + " This will become an error in Angular v5.x");
            }
        }
        return dependenciesMetadata;
    };
    /**
     * @param {?} token
     * @return {?}
     */
    CompileMetadataResolver.prototype._getTokenMetadata = function (token) {
        token = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["resolveForwardRef"])(token);
        var /** @type {?} */ compileToken;
        if (typeof token === 'string') {
            compileToken = { value: token };
        }
        else {
            compileToken = { identifier: { reference: token } };
        }
        return compileToken;
    };
    /**
     * @param {?} providers
     * @param {?} targetEntryComponents
     * @param {?=} debugInfo
     * @param {?=} compileProviders
     * @param {?=} type
     * @return {?}
     */
    CompileMetadataResolver.prototype._getProvidersMetadata = function (providers, targetEntryComponents, debugInfo, compileProviders, type) {
        var _this = this;
        if (compileProviders === void 0) { compileProviders = []; }
        providers.forEach(function (provider, providerIdx) {
            if (Array.isArray(provider)) {
                _this._getProvidersMetadata(provider, targetEntryComponents, debugInfo, compileProviders);
            }
            else {
                provider = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["resolveForwardRef"])(provider);
                var /** @type {?} */ providerMeta = ((undefined));
                if (provider && typeof provider === 'object' && provider.hasOwnProperty('provide')) {
                    _this._validateProvider(provider);
                    providerMeta = new ProviderMeta(provider.provide, provider);
                }
                else if (isValidType(provider)) {
                    providerMeta = new ProviderMeta(provider, { useClass: provider });
                }
                else if (provider === void 0) {
                    _this._reportError(syntaxError("Encountered undefined provider! Usually this means you have a circular dependencies (might be caused by using 'barrel' index.ts files."));
                    return;
                }
                else {
                    var /** @type {?} */ providersInfo = ((providers.reduce(function (soFar, seenProvider, seenProviderIdx) {
                        if (seenProviderIdx < providerIdx) {
                            soFar.push("" + stringifyType(seenProvider));
                        }
                        else if (seenProviderIdx == providerIdx) {
                            soFar.push("?" + stringifyType(seenProvider) + "?");
                        }
                        else if (seenProviderIdx == providerIdx + 1) {
                            soFar.push('...');
                        }
                        return soFar;
                    }, [])))
                        .join(', ');
                    _this._reportError(syntaxError("Invalid " + (debugInfo ? debugInfo : 'provider') + " - only instances of Provider and Type are allowed, got: [" + providersInfo + "]"), type);
                    return;
                }
                if (providerMeta.token === resolveIdentifier(Identifiers.ANALYZE_FOR_ENTRY_COMPONENTS)) {
                    targetEntryComponents.push.apply(targetEntryComponents, _this._getEntryComponentsFromProvider(providerMeta, type));
                }
                else {
                    compileProviders.push(_this.getProviderMetadata(providerMeta));
                }
            }
        });
        return compileProviders;
    };
    /**
     * @param {?} provider
     * @return {?}
     */
    CompileMetadataResolver.prototype._validateProvider = function (provider) {
        if (provider.hasOwnProperty('useClass') && provider.useClass == null) {
            this._reportError(syntaxError("Invalid provider for " + stringifyType(provider.provide) + ". useClass cannot be " + provider.useClass + ".\n           Usually it happens when:\n           1. There's a circular dependency (might be caused by using index.ts (barrel) files).\n           2. Class was used before it was declared. Use forwardRef in this case."));
        }
    };
    /**
     * @param {?} provider
     * @param {?=} type
     * @return {?}
     */
    CompileMetadataResolver.prototype._getEntryComponentsFromProvider = function (provider, type) {
        var _this = this;
        var /** @type {?} */ components = [];
        var /** @type {?} */ collectedIdentifiers = [];
        if (provider.useFactory || provider.useExisting || provider.useClass) {
            this._reportError(syntaxError("The ANALYZE_FOR_ENTRY_COMPONENTS token only supports useValue!"), type);
            return [];
        }
        if (!provider.multi) {
            this._reportError(syntaxError("The ANALYZE_FOR_ENTRY_COMPONENTS token only supports 'multi = true'!"), type);
            return [];
        }
        extractIdentifiers(provider.useValue, collectedIdentifiers);
        collectedIdentifiers.forEach(function (identifier) {
            var /** @type {?} */ entry = _this._getEntryComponentMetadata(identifier.reference, false);
            if (entry) {
                components.push(entry);
            }
        });
        return components;
    };
    /**
     * @param {?} dirType
     * @param {?=} throwIfNotFound
     * @return {?}
     */
    CompileMetadataResolver.prototype._getEntryComponentMetadata = function (dirType, throwIfNotFound) {
        if (throwIfNotFound === void 0) { throwIfNotFound = true; }
        var /** @type {?} */ dirMeta = this.getNonNormalizedDirectiveMetadata(dirType);
        if (dirMeta && dirMeta.metadata.isComponent) {
            return { componentType: dirType, componentFactory: /** @type {?} */ ((dirMeta.metadata.componentFactory)) };
        }
        var /** @type {?} */ dirSummary = (this._loadSummary(dirType, CompileSummaryKind.Directive));
        if (dirSummary && dirSummary.isComponent) {
            return { componentType: dirType, componentFactory: /** @type {?} */ ((dirSummary.componentFactory)) };
        }
        if (throwIfNotFound) {
            throw syntaxError(dirType.name + " cannot be used as an entry component.");
        }
        return null;
    };
    /**
     * @param {?} provider
     * @return {?}
     */
    CompileMetadataResolver.prototype.getProviderMetadata = function (provider) {
        var /** @type {?} */ compileDeps = ((undefined));
        var /** @type {?} */ compileTypeMetadata = ((null));
        var /** @type {?} */ compileFactoryMetadata = ((null));
        var /** @type {?} */ token = this._getTokenMetadata(provider.token);
        if (provider.useClass) {
            compileTypeMetadata = this._getInjectableMetadata(provider.useClass, provider.dependencies);
            compileDeps = compileTypeMetadata.diDeps;
            if (provider.token === provider.useClass) {
                // use the compileTypeMetadata as it contains information about lifecycleHooks...
                token = { identifier: compileTypeMetadata };
            }
        }
        else if (provider.useFactory) {
            compileFactoryMetadata = this._getFactoryMetadata(provider.useFactory, provider.dependencies);
            compileDeps = compileFactoryMetadata.diDeps;
        }
        return {
            token: token,
            useClass: compileTypeMetadata,
            useValue: provider.useValue,
            useFactory: compileFactoryMetadata,
            useExisting: provider.useExisting ? this._getTokenMetadata(provider.useExisting) : undefined,
            deps: compileDeps,
            multi: provider.multi
        };
    };
    /**
     * @param {?} queries
     * @param {?} isViewQuery
     * @param {?} directiveType
     * @return {?}
     */
    CompileMetadataResolver.prototype._getQueriesMetadata = function (queries, isViewQuery, directiveType) {
        var _this = this;
        var /** @type {?} */ res = [];
        Object.keys(queries).forEach(function (propertyName) {
            var /** @type {?} */ query = queries[propertyName];
            if (query.isViewQuery === isViewQuery) {
                res.push(_this._getQueryMetadata(query, propertyName, directiveType));
            }
        });
        return res;
    };
    /**
     * @param {?} selector
     * @return {?}
     */
    CompileMetadataResolver.prototype._queryVarBindings = function (selector) { return selector.split(/\s*,\s*/); };
    /**
     * @param {?} q
     * @param {?} propertyName
     * @param {?} typeOrFunc
     * @return {?}
     */
    CompileMetadataResolver.prototype._getQueryMetadata = function (q, propertyName, typeOrFunc) {
        var _this = this;
        var /** @type {?} */ selectors;
        if (typeof q.selector === 'string') {
            selectors =
                this._queryVarBindings(q.selector).map(function (varName) { return _this._getTokenMetadata(varName); });
        }
        else {
            if (!q.selector) {
                this._reportError(syntaxError("Can't construct a query for the property \"" + propertyName + "\" of \"" + stringifyType(typeOrFunc) + "\" since the query selector wasn't defined."), typeOrFunc);
                selectors = [];
            }
            else {
                selectors = [this._getTokenMetadata(q.selector)];
            }
        }
        return {
            selectors: selectors,
            first: q.first,
            descendants: q.descendants, propertyName: propertyName,
            read: q.read ? this._getTokenMetadata(q.read) : ((null))
        };
    };
    /**
     * @param {?} error
     * @param {?=} type
     * @param {?=} otherType
     * @return {?}
     */
    CompileMetadataResolver.prototype._reportError = function (error, type, otherType) {
        if (this._errorCollector) {
            this._errorCollector(error, type);
            if (otherType) {
                this._errorCollector(error, otherType);
            }
        }
        else {
            throw error;
        }
    };
    return CompileMetadataResolver;
}());
CompileMetadataResolver.decorators = [
    { type: CompilerInjectable },
];
/**
 * @nocollapse
 */
CompileMetadataResolver.ctorParameters = function () { return [
    { type: CompilerConfig, },
    { type: NgModuleResolver, },
    { type: DirectiveResolver, },
    { type: PipeResolver, },
    { type: SummaryResolver, },
    { type: ElementSchemaRegistry, },
    { type: DirectiveNormalizer, },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵConsole"], },
    { type: StaticSymbolCache, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] },] },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵReflectorReader"], },
    { type: undefined, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [ERROR_COLLECTOR_TOKEN,] },] },
]; };
/**
 * @param {?} tree
 * @param {?=} out
 * @return {?}
 */
function flattenArray(tree, out) {
    if (out === void 0) { out = []; }
    if (tree) {
        for (var /** @type {?} */ i = 0; i < tree.length; i++) {
            var /** @type {?} */ item = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["resolveForwardRef"])(tree[i]);
            if (Array.isArray(item)) {
                flattenArray(item, out);
            }
            else {
                out.push(item);
            }
        }
    }
    return out;
}
/**
 * @param {?} array
 * @return {?}
 */
function dedupeArray(array) {
    if (array) {
        return Array.from(new Set(array));
    }
    return [];
}
/**
 * @param {?} tree
 * @return {?}
 */
function flattenAndDedupeArray(tree) {
    return dedupeArray(flattenArray(tree));
}
/**
 * @param {?} value
 * @return {?}
 */
function isValidType(value) {
    return (value instanceof StaticSymbol) || (value instanceof __WEBPACK_IMPORTED_MODULE_0__angular_core__["Type"]);
}
/**
 * @param {?} reflector
 * @param {?} type
 * @param {?} cmpMetadata
 * @return {?}
 */
function componentModuleUrl(reflector, type, cmpMetadata) {
    if (type instanceof StaticSymbol) {
        return reflector.resourceUri(type);
    }
    var /** @type {?} */ moduleId = cmpMetadata.moduleId;
    if (typeof moduleId === 'string') {
        var /** @type {?} */ scheme = getUrlScheme(moduleId);
        return scheme ? moduleId : "package:" + moduleId + MODULE_SUFFIX;
    }
    else if (moduleId !== null && moduleId !== void 0) {
        throw syntaxError("moduleId should be a string in \"" + stringifyType(type) + "\". See https://goo.gl/wIDDiL for more information.\n" +
            "If you're using Webpack you should inline the template and the styles, see https://goo.gl/X2J8zc.");
    }
    return ((reflector.importUri(type)));
}
/**
 * @param {?} value
 * @param {?} targetIdentifiers
 * @return {?}
 */
function extractIdentifiers(value, targetIdentifiers) {
    visitValue(value, new _CompileValueConverter(), targetIdentifiers);
}
var _CompileValueConverter = (function (_super) {
    __extends(_CompileValueConverter, _super);
    function _CompileValueConverter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @param {?} value
     * @param {?} targetIdentifiers
     * @return {?}
     */
    _CompileValueConverter.prototype.visitOther = function (value, targetIdentifiers) {
        targetIdentifiers.push({ reference: value });
    };
    return _CompileValueConverter;
}(ValueTransformer));
/**
 * @param {?} type
 * @return {?}
 */
function stringifyType(type) {
    if (type instanceof StaticSymbol) {
        return type.name + " in " + type.filePath;
    }
    else {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵstringify"])(type);
    }
}
/**
 * Indicates that a component is still being loaded in a synchronous compile.
 * @param {?} compType
 * @return {?}
 */
function componentStillLoadingError(compType) {
    var /** @type {?} */ error = Error("Can't compile synchronously as " + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵstringify"])(compType) + " is still being loaded!");
    ((error))[__WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵERROR_COMPONENT_TYPE"]] = compType;
    return error;
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var TypeModifier = {};
TypeModifier.Const = 0;
TypeModifier[TypeModifier.Const] = "Const";
/**
 * @abstract
 */
var Type$1 = (function () {
    /**
     * @param {?=} modifiers
     */
    function Type$1(modifiers) {
        if (modifiers === void 0) { modifiers = null; }
        this.modifiers = modifiers;
        if (!modifiers) {
            this.modifiers = [];
        }
    }
    /**
     * @abstract
     * @param {?} visitor
     * @param {?} context
     * @return {?}
     */
    Type$1.prototype.visitType = function (visitor, context) { };
    /**
     * @param {?} modifier
     * @return {?}
     */
    Type$1.prototype.hasModifier = function (modifier) { return ((this.modifiers)).indexOf(modifier) !== -1; };
    return Type$1;
}());
var BuiltinTypeName = {};
BuiltinTypeName.Dynamic = 0;
BuiltinTypeName.Bool = 1;
BuiltinTypeName.String = 2;
BuiltinTypeName.Int = 3;
BuiltinTypeName.Number = 4;
BuiltinTypeName.Function = 5;
BuiltinTypeName.Inferred = 6;
BuiltinTypeName[BuiltinTypeName.Dynamic] = "Dynamic";
BuiltinTypeName[BuiltinTypeName.Bool] = "Bool";
BuiltinTypeName[BuiltinTypeName.String] = "String";
BuiltinTypeName[BuiltinTypeName.Int] = "Int";
BuiltinTypeName[BuiltinTypeName.Number] = "Number";
BuiltinTypeName[BuiltinTypeName.Function] = "Function";
BuiltinTypeName[BuiltinTypeName.Inferred] = "Inferred";
var BuiltinType = (function (_super) {
    __extends(BuiltinType, _super);
    /**
     * @param {?} name
     * @param {?=} modifiers
     */
    function BuiltinType(name, modifiers) {
        if (modifiers === void 0) { modifiers = null; }
        var _this = _super.call(this, modifiers) || this;
        _this.name = name;
        return _this;
    }
    /**
     * @param {?} visitor
     * @param {?} context
     * @return {?}
     */
    BuiltinType.prototype.visitType = function (visitor, context) {
        return visitor.visitBuiltintType(this, context);
    };
    return BuiltinType;
}(Type$1));
var ExpressionType = (function (_super) {
    __extends(ExpressionType, _super);
    /**
     * @param {?} value
     * @param {?=} modifiers
     */
    function ExpressionType(value, modifiers) {
        if (modifiers === void 0) { modifiers = null; }
        var _this = _super.call(this, modifiers) || this;
        _this.value = value;
        return _this;
    }
    /**
     * @param {?} visitor
     * @param {?} context
     * @return {?}
     */
    ExpressionType.prototype.visitType = function (visitor, context) {
        return visitor.visitExpressionType(this, context);
    };
    return ExpressionType;
}(Type$1));
var ArrayType = (function (_super) {
    __extends(ArrayType, _super);
    /**
     * @param {?} of
     * @param {?=} modifiers
     */
    function ArrayType(of, modifiers) {
        if (modifiers === void 0) { modifiers = null; }
        var _this = _super.call(this, modifiers) || this;
        _this.of = of;
        return _this;
    }
    /**
     * @param {?} visitor
     * @param {?} context
     * @return {?}
     */
    ArrayType.prototype.visitType = function (visitor, context) {
        return visitor.visitArrayType(this, context);
    };
    return ArrayType;
}(Type$1));
var MapType = (function (_super) {
    __extends(MapType, _super);
    /**
     * @param {?} valueType
     * @param {?=} modifiers
     */
    function MapType(valueType, modifiers) {
        if (modifiers === void 0) { modifiers = null; }
        var _this = _super.call(this, modifiers) || this;
        _this.valueType = valueType || null;
        return _this;
    }
    /**
     * @param {?} visitor
     * @param {?} context
     * @return {?}
     */
    MapType.prototype.visitType = function (visitor, context) { return visitor.visitMapType(this, context); };
    return MapType;
}(Type$1));
var DYNAMIC_TYPE = new BuiltinType(BuiltinTypeName.Dynamic);
var INFERRED_TYPE = new BuiltinType(BuiltinTypeName.Inferred);
var BOOL_TYPE = new BuiltinType(BuiltinTypeName.Bool);
var INT_TYPE = new BuiltinType(BuiltinTypeName.Int);
var NUMBER_TYPE = new BuiltinType(BuiltinTypeName.Number);
var STRING_TYPE = new BuiltinType(BuiltinTypeName.String);
var FUNCTION_TYPE = new BuiltinType(BuiltinTypeName.Function);
var BinaryOperator = {};
BinaryOperator.Equals = 0;
BinaryOperator.NotEquals = 1;
BinaryOperator.Identical = 2;
BinaryOperator.NotIdentical = 3;
BinaryOperator.Minus = 4;
BinaryOperator.Plus = 5;
BinaryOperator.Divide = 6;
BinaryOperator.Multiply = 7;
BinaryOperator.Modulo = 8;
BinaryOperator.And = 9;
BinaryOperator.Or = 10;
BinaryOperator.Lower = 11;
BinaryOperator.LowerEquals = 12;
BinaryOperator.Bigger = 13;
BinaryOperator.BiggerEquals = 14;
BinaryOperator[BinaryOperator.Equals] = "Equals";
BinaryOperator[BinaryOperator.NotEquals] = "NotEquals";
BinaryOperator[BinaryOperator.Identical] = "Identical";
BinaryOperator[BinaryOperator.NotIdentical] = "NotIdentical";
BinaryOperator[BinaryOperator.Minus] = "Minus";
BinaryOperator[BinaryOperator.Plus] = "Plus";
BinaryOperator[BinaryOperator.Divide] = "Divide";
BinaryOperator[BinaryOperator.Multiply] = "Multiply";
BinaryOperator[BinaryOperator.Modulo] = "Modulo";
BinaryOperator[BinaryOperator.And] = "And";
BinaryOperator[BinaryOperator.Or] = "Or";
BinaryOperator[BinaryOperator.Lower] = "Lower";
BinaryOperator[BinaryOperator.LowerEquals] = "LowerEquals";
BinaryOperator[BinaryOperator.Bigger] = "Bigger";
BinaryOperator[BinaryOperator.BiggerEquals] = "BiggerEquals";
/**
 * @abstract
 */
var Expression = (function () {
    /**
     * @param {?} type
     * @param {?=} sourceSpan
     */
    function Expression(type, sourceSpan) {
        this.type = type || null;
        this.sourceSpan = sourceSpan || null;
    }
    /**
     * @abstract
     * @param {?} visitor
     * @param {?} context
     * @return {?}
     */
    Expression.prototype.visitExpression = function (visitor, context) { };
    /**
     * @param {?} name
     * @param {?=} sourceSpan
     * @return {?}
     */
    Expression.prototype.prop = function (name, sourceSpan) {
        return new ReadPropExpr(this, name, null, sourceSpan);
    };
    /**
     * @param {?} index
     * @param {?=} type
     * @param {?=} sourceSpan
     * @return {?}
     */
    Expression.prototype.key = function (index, type, sourceSpan) {
        return new ReadKeyExpr(this, index, type, sourceSpan);
    };
    /**
     * @param {?} name
     * @param {?} params
     * @param {?=} sourceSpan
     * @return {?}
     */
    Expression.prototype.callMethod = function (name, params, sourceSpan) {
        return new InvokeMethodExpr(this, name, params, null, sourceSpan);
    };
    /**
     * @param {?} params
     * @param {?=} sourceSpan
     * @return {?}
     */
    Expression.prototype.callFn = function (params, sourceSpan) {
        return new InvokeFunctionExpr(this, params, null, sourceSpan);
    };
    /**
     * @param {?} params
     * @param {?=} type
     * @param {?=} sourceSpan
     * @return {?}
     */
    Expression.prototype.instantiate = function (params, type, sourceSpan) {
        return new InstantiateExpr(this, params, type, sourceSpan);
    };
    /**
     * @param {?} trueCase
     * @param {?=} falseCase
     * @param {?=} sourceSpan
     * @return {?}
     */
    Expression.prototype.conditional = function (trueCase, falseCase, sourceSpan) {
        if (falseCase === void 0) { falseCase = null; }
        return new ConditionalExpr(this, trueCase, falseCase, null, sourceSpan);
    };
    /**
     * @param {?} rhs
     * @param {?=} sourceSpan
     * @return {?}
     */
    Expression.prototype.equals = function (rhs, sourceSpan) {
        return new BinaryOperatorExpr(BinaryOperator.Equals, this, rhs, null, sourceSpan);
    };
    /**
     * @param {?} rhs
     * @param {?=} sourceSpan
     * @return {?}
     */
    Expression.prototype.notEquals = function (rhs, sourceSpan) {
        return new BinaryOperatorExpr(BinaryOperator.NotEquals, this, rhs, null, sourceSpan);
    };
    /**
     * @param {?} rhs
     * @param {?=} sourceSpan
     * @return {?}
     */
    Expression.prototype.identical = function (rhs, sourceSpan) {
        return new BinaryOperatorExpr(BinaryOperator.Identical, this, rhs, null, sourceSpan);
    };
    /**
     * @param {?} rhs
     * @param {?=} sourceSpan
     * @return {?}
     */
    Expression.prototype.notIdentical = function (rhs, sourceSpan) {
        return new BinaryOperatorExpr(BinaryOperator.NotIdentical, this, rhs, null, sourceSpan);
    };
    /**
     * @param {?} rhs
     * @param {?=} sourceSpan
     * @return {?}
     */
    Expression.prototype.minus = function (rhs, sourceSpan) {
        return new BinaryOperatorExpr(BinaryOperator.Minus, this, rhs, null, sourceSpan);
    };
    /**
     * @param {?} rhs
     * @param {?=} sourceSpan
     * @return {?}
     */
    Expression.prototype.plus = function (rhs, sourceSpan) {
        return new BinaryOperatorExpr(BinaryOperator.Plus, this, rhs, null, sourceSpan);
    };
    /**
     * @param {?} rhs
     * @param {?=} sourceSpan
     * @return {?}
     */
    Expression.prototype.divide = function (rhs, sourceSpan) {
        return new BinaryOperatorExpr(BinaryOperator.Divide, this, rhs, null, sourceSpan);
    };
    /**
     * @param {?} rhs
     * @param {?=} sourceSpan
     * @return {?}
     */
    Expression.prototype.multiply = function (rhs, sourceSpan) {
        return new BinaryOperatorExpr(BinaryOperator.Multiply, this, rhs, null, sourceSpan);
    };
    /**
     * @param {?} rhs
     * @param {?=} sourceSpan
     * @return {?}
     */
    Expression.prototype.modulo = function (rhs, sourceSpan) {
        return new BinaryOperatorExpr(BinaryOperator.Modulo, this, rhs, null, sourceSpan);
    };
    /**
     * @param {?} rhs
     * @param {?=} sourceSpan
     * @return {?}
     */
    Expression.prototype.and = function (rhs, sourceSpan) {
        return new BinaryOperatorExpr(BinaryOperator.And, this, rhs, null, sourceSpan);
    };
    /**
     * @param {?} rhs
     * @param {?=} sourceSpan
     * @return {?}
     */
    Expression.prototype.or = function (rhs, sourceSpan) {
        return new BinaryOperatorExpr(BinaryOperator.Or, this, rhs, null, sourceSpan);
    };
    /**
     * @param {?} rhs
     * @param {?=} sourceSpan
     * @return {?}
     */
    Expression.prototype.lower = function (rhs, sourceSpan) {
        return new BinaryOperatorExpr(BinaryOperator.Lower, this, rhs, null, sourceSpan);
    };
    /**
     * @param {?} rhs
     * @param {?=} sourceSpan
     * @return {?}
     */
    Expression.prototype.lowerEquals = function (rhs, sourceSpan) {
        return new BinaryOperatorExpr(BinaryOperator.LowerEquals, this, rhs, null, sourceSpan);
    };
    /**
     * @param {?} rhs
     * @param {?=} sourceSpan
     * @return {?}
     */
    Expression.prototype.bigger = function (rhs, sourceSpan) {
        return new BinaryOperatorExpr(BinaryOperator.Bigger, this, rhs, null, sourceSpan);
    };
    /**
     * @param {?} rhs
     * @param {?=} sourceSpan
     * @return {?}
     */
    Expression.prototype.biggerEquals = function (rhs, sourceSpan) {
        return new BinaryOperatorExpr(BinaryOperator.BiggerEquals, this, rhs, null, sourceSpan);
    };
    /**
     * @param {?=} sourceSpan
     * @return {?}
     */
    Expression.prototype.isBlank = function (sourceSpan) {
        // Note: We use equals by purpose here to compare to null and undefined in JS.
        // We use the typed null to allow strictNullChecks to narrow types.
        return this.equals(TYPED_NULL_EXPR, sourceSpan);
    };
    /**
     * @param {?} type
     * @param {?=} sourceSpan
     * @return {?}
     */
    Expression.prototype.cast = function (type, sourceSpan) {
        return new CastExpr(this, type, sourceSpan);
    };
    /**
     * @return {?}
     */
    Expression.prototype.toStmt = function () { return new ExpressionStatement(this, null); };
    return Expression;
}());
var BuiltinVar = {};
BuiltinVar.This = 0;
BuiltinVar.Super = 1;
BuiltinVar.CatchError = 2;
BuiltinVar.CatchStack = 3;
BuiltinVar[BuiltinVar.This] = "This";
BuiltinVar[BuiltinVar.Super] = "Super";
BuiltinVar[BuiltinVar.CatchError] = "CatchError";
BuiltinVar[BuiltinVar.CatchStack] = "CatchStack";
var ReadVarExpr = (function (_super) {
    __extends(ReadVarExpr, _super);
    /**
     * @param {?} name
     * @param {?=} type
     * @param {?=} sourceSpan
     */
    function ReadVarExpr(name, type, sourceSpan) {
        var _this = _super.call(this, type, sourceSpan) || this;
        if (typeof name === 'string') {
            _this.name = name;
            _this.builtin = null;
        }
        else {
            _this.name = null;
            _this.builtin = name;
        }
        return _this;
    }
    /**
     * @param {?} visitor
     * @param {?} context
     * @return {?}
     */
    ReadVarExpr.prototype.visitExpression = function (visitor, context) {
        return visitor.visitReadVarExpr(this, context);
    };
    /**
     * @param {?} value
     * @return {?}
     */
    ReadVarExpr.prototype.set = function (value) {
        if (!this.name) {
            throw new Error("Built in variable " + this.builtin + " can not be assigned to.");
        }
        return new WriteVarExpr(this.name, value, null, this.sourceSpan);
    };
    return ReadVarExpr;
}(Expression));
var WriteVarExpr = (function (_super) {
    __extends(WriteVarExpr, _super);
    /**
     * @param {?} name
     * @param {?} value
     * @param {?=} type
     * @param {?=} sourceSpan
     */
    function WriteVarExpr(name, value, type, sourceSpan) {
        var _this = _super.call(this, type || value.type, sourceSpan) || this;
        _this.name = name;
        _this.value = value;
        return _this;
    }
    /**
     * @param {?} visitor
     * @param {?} context
     * @return {?}
     */
    WriteVarExpr.prototype.visitExpression = function (visitor, context) {
        return visitor.visitWriteVarExpr(this, context);
    };
    /**
     * @param {?=} type
     * @param {?=} modifiers
     * @return {?}
     */
    WriteVarExpr.prototype.toDeclStmt = function (type, modifiers) {
        return new DeclareVarStmt(this.name, this.value, type, modifiers, this.sourceSpan);
    };
    return WriteVarExpr;
}(Expression));
var WriteKeyExpr = (function (_super) {
    __extends(WriteKeyExpr, _super);
    /**
     * @param {?} receiver
     * @param {?} index
     * @param {?} value
     * @param {?=} type
     * @param {?=} sourceSpan
     */
    function WriteKeyExpr(receiver, index, value, type, sourceSpan) {
        var _this = _super.call(this, type || value.type, sourceSpan) || this;
        _this.receiver = receiver;
        _this.index = index;
        _this.value = value;
        return _this;
    }
    /**
     * @param {?} visitor
     * @param {?} context
     * @return {?}
     */
    WriteKeyExpr.prototype.visitExpression = function (visitor, context) {
        return visitor.visitWriteKeyExpr(this, context);
    };
    return WriteKeyExpr;
}(Expression));
var WritePropExpr = (function (_super) {
    __extends(WritePropExpr, _super);
    /**
     * @param {?} receiver
     * @param {?} name
     * @param {?} value
     * @param {?=} type
     * @param {?=} sourceSpan
     */
    function WritePropExpr(receiver, name, value, type, sourceSpan) {
        var _this = _super.call(this, type || value.type, sourceSpan) || this;
        _this.receiver = receiver;
        _this.name = name;
        _this.value = value;
        return _this;
    }
    /**
     * @param {?} visitor
     * @param {?} context
     * @return {?}
     */
    WritePropExpr.prototype.visitExpression = function (visitor, context) {
        return visitor.visitWritePropExpr(this, context);
    };
    return WritePropExpr;
}(Expression));
var BuiltinMethod = {};
BuiltinMethod.ConcatArray = 0;
BuiltinMethod.SubscribeObservable = 1;
BuiltinMethod.Bind = 2;
BuiltinMethod[BuiltinMethod.ConcatArray] = "ConcatArray";
BuiltinMethod[BuiltinMethod.SubscribeObservable] = "SubscribeObservable";
BuiltinMethod[BuiltinMethod.Bind] = "Bind";
var InvokeMethodExpr = (function (_super) {
    __extends(InvokeMethodExpr, _super);
    /**
     * @param {?} receiver
     * @param {?} method
     * @param {?} args
     * @param {?=} type
     * @param {?=} sourceSpan
     */
    function InvokeMethodExpr(receiver, method, args, type, sourceSpan) {
        var _this = _super.call(this, type, sourceSpan) || this;
        _this.receiver = receiver;
        _this.args = args;
        if (typeof method === 'string') {
            _this.name = method;
            _this.builtin = null;
        }
        else {
            _this.name = null;
            _this.builtin = method;
        }
        return _this;
    }
    /**
     * @param {?} visitor
     * @param {?} context
     * @return {?}
     */
    InvokeMethodExpr.prototype.visitExpression = function (visitor, context) {
        return visitor.visitInvokeMethodExpr(this, context);
    };
    return InvokeMethodExpr;
}(Expression));
var InvokeFunctionExpr = (function (_super) {
    __extends(InvokeFunctionExpr, _super);
    /**
     * @param {?} fn
     * @param {?} args
     * @param {?=} type
     * @param {?=} sourceSpan
     */
    function InvokeFunctionExpr(fn, args, type, sourceSpan) {
        var _this = _super.call(this, type, sourceSpan) || this;
        _this.fn = fn;
        _this.args = args;
        return _this;
    }
    /**
     * @param {?} visitor
     * @param {?} context
     * @return {?}
     */
    InvokeFunctionExpr.prototype.visitExpression = function (visitor, context) {
        return visitor.visitInvokeFunctionExpr(this, context);
    };
    return InvokeFunctionExpr;
}(Expression));
var InstantiateExpr = (function (_super) {
    __extends(InstantiateExpr, _super);
    /**
     * @param {?} classExpr
     * @param {?} args
     * @param {?=} type
     * @param {?=} sourceSpan
     */
    function InstantiateExpr(classExpr, args, type, sourceSpan) {
        var _this = _super.call(this, type, sourceSpan) || this;
        _this.classExpr = classExpr;
        _this.args = args;
        return _this;
    }
    /**
     * @param {?} visitor
     * @param {?} context
     * @return {?}
     */
    InstantiateExpr.prototype.visitExpression = function (visitor, context) {
        return visitor.visitInstantiateExpr(this, context);
    };
    return InstantiateExpr;
}(Expression));
var LiteralExpr = (function (_super) {
    __extends(LiteralExpr, _super);
    /**
     * @param {?} value
     * @param {?=} type
     * @param {?=} sourceSpan
     */
    function LiteralExpr(value, type, sourceSpan) {
        var _this = _super.call(this, type, sourceSpan) || this;
        _this.value = value;
        return _this;
    }
    /**
     * @param {?} visitor
     * @param {?} context
     * @return {?}
     */
    LiteralExpr.prototype.visitExpression = function (visitor, context) {
        return visitor.visitLiteralExpr(this, context);
    };
    return LiteralExpr;
}(Expression));
var ExternalExpr = (function (_super) {
    __extends(ExternalExpr, _super);
    /**
     * @param {?} value
     * @param {?=} type
     * @param {?=} typeParams
     * @param {?=} sourceSpan
     */
    function ExternalExpr(value, type, typeParams, sourceSpan) {
        if (typeParams === void 0) { typeParams = null; }
        var _this = _super.call(this, type, sourceSpan) || this;
        _this.value = value;
        _this.typeParams = typeParams;
        return _this;
    }
    /**
     * @param {?} visitor
     * @param {?} context
     * @return {?}
     */
    ExternalExpr.prototype.visitExpression = function (visitor, context) {
        return visitor.visitExternalExpr(this, context);
    };
    return ExternalExpr;
}(Expression));
var ConditionalExpr = (function (_super) {
    __extends(ConditionalExpr, _super);
    /**
     * @param {?} condition
     * @param {?} trueCase
     * @param {?=} falseCase
     * @param {?=} type
     * @param {?=} sourceSpan
     */
    function ConditionalExpr(condition, trueCase, falseCase, type, sourceSpan) {
        if (falseCase === void 0) { falseCase = null; }
        var _this = _super.call(this, type || trueCase.type, sourceSpan) || this;
        _this.condition = condition;
        _this.falseCase = falseCase;
        _this.trueCase = trueCase;
        return _this;
    }
    /**
     * @param {?} visitor
     * @param {?} context
     * @return {?}
     */
    ConditionalExpr.prototype.visitExpression = function (visitor, context) {
        return visitor.visitConditionalExpr(this, context);
    };
    return ConditionalExpr;
}(Expression));
var NotExpr = (function (_super) {
    __extends(NotExpr, _super);
    /**
     * @param {?} condition
     * @param {?=} sourceSpan
     */
    function NotExpr(condition, sourceSpan) {
        var _this = _super.call(this, BOOL_TYPE, sourceSpan) || this;
        _this.condition = condition;
        return _this;
    }
    /**
     * @param {?} visitor
     * @param {?} context
     * @return {?}
     */
    NotExpr.prototype.visitExpression = function (visitor, context) {
        return visitor.visitNotExpr(this, context);
    };
    return NotExpr;
}(Expression));
var CastExpr = (function (_super) {
    __extends(CastExpr, _super);
    /**
     * @param {?} value
     * @param {?=} type
     * @param {?=} sourceSpan
     */
    function CastExpr(value, type, sourceSpan) {
        var _this = _super.call(this, type, sourceSpan) || this;
        _this.value = value;
        return _this;
    }
    /**
     * @param {?} visitor
     * @param {?} context
     * @return {?}
     */
    CastExpr.prototype.visitExpression = function (visitor, context) {
        return visitor.visitCastExpr(this, context);
    };
    return CastExpr;
}(Expression));
var FnParam = (function () {
    /**
     * @param {?} name
     * @param {?=} type
     */
    function FnParam(name, type) {
        if (type === void 0) { type = null; }
        this.name = name;
        this.type = type;
    }
    return FnParam;
}());
var FunctionExpr = (function (_super) {
    __extends(FunctionExpr, _super);
    /**
     * @param {?} params
     * @param {?} statements
     * @param {?=} type
     * @param {?=} sourceSpan
     */
    function FunctionExpr(params, statements, type, sourceSpan) {
        var _this = _super.call(this, type, sourceSpan) || this;
        _this.params = params;
        _this.statements = statements;
        return _this;
    }
    /**
     * @param {?} visitor
     * @param {?} context
     * @return {?}
     */
    FunctionExpr.prototype.visitExpression = function (visitor, context) {
        return visitor.visitFunctionExpr(this, context);
    };
    /**
     * @param {?} name
     * @param {?=} modifiers
     * @return {?}
     */
    FunctionExpr.prototype.toDeclStmt = function (name, modifiers) {
        if (modifiers === void 0) { modifiers = null; }
        return new DeclareFunctionStmt(name, this.params, this.statements, this.type, modifiers, this.sourceSpan);
    };
    return FunctionExpr;
}(Expression));
var BinaryOperatorExpr = (function (_super) {
    __extends(BinaryOperatorExpr, _super);
    /**
     * @param {?} operator
     * @param {?} lhs
     * @param {?} rhs
     * @param {?=} type
     * @param {?=} sourceSpan
     */
    function BinaryOperatorExpr(operator, lhs, rhs, type, sourceSpan) {
        var _this = _super.call(this, type || lhs.type, sourceSpan) || this;
        _this.operator = operator;
        _this.rhs = rhs;
        _this.lhs = lhs;
        return _this;
    }
    /**
     * @param {?} visitor
     * @param {?} context
     * @return {?}
     */
    BinaryOperatorExpr.prototype.visitExpression = function (visitor, context) {
        return visitor.visitBinaryOperatorExpr(this, context);
    };
    return BinaryOperatorExpr;
}(Expression));
var ReadPropExpr = (function (_super) {
    __extends(ReadPropExpr, _super);
    /**
     * @param {?} receiver
     * @param {?} name
     * @param {?=} type
     * @param {?=} sourceSpan
     */
    function ReadPropExpr(receiver, name, type, sourceSpan) {
        var _this = _super.call(this, type, sourceSpan) || this;
        _this.receiver = receiver;
        _this.name = name;
        return _this;
    }
    /**
     * @param {?} visitor
     * @param {?} context
     * @return {?}
     */
    ReadPropExpr.prototype.visitExpression = function (visitor, context) {
        return visitor.visitReadPropExpr(this, context);
    };
    /**
     * @param {?} value
     * @return {?}
     */
    ReadPropExpr.prototype.set = function (value) {
        return new WritePropExpr(this.receiver, this.name, value, null, this.sourceSpan);
    };
    return ReadPropExpr;
}(Expression));
var ReadKeyExpr = (function (_super) {
    __extends(ReadKeyExpr, _super);
    /**
     * @param {?} receiver
     * @param {?} index
     * @param {?=} type
     * @param {?=} sourceSpan
     */
    function ReadKeyExpr(receiver, index, type, sourceSpan) {
        var _this = _super.call(this, type, sourceSpan) || this;
        _this.receiver = receiver;
        _this.index = index;
        return _this;
    }
    /**
     * @param {?} visitor
     * @param {?} context
     * @return {?}
     */
    ReadKeyExpr.prototype.visitExpression = function (visitor, context) {
        return visitor.visitReadKeyExpr(this, context);
    };
    /**
     * @param {?} value
     * @return {?}
     */
    ReadKeyExpr.prototype.set = function (value) {
        return new WriteKeyExpr(this.receiver, this.index, value, null, this.sourceSpan);
    };
    return ReadKeyExpr;
}(Expression));
var LiteralArrayExpr = (function (_super) {
    __extends(LiteralArrayExpr, _super);
    /**
     * @param {?} entries
     * @param {?=} type
     * @param {?=} sourceSpan
     */
    function LiteralArrayExpr(entries, type, sourceSpan) {
        var _this = _super.call(this, type, sourceSpan) || this;
        _this.entries = entries;
        return _this;
    }
    /**
     * @param {?} visitor
     * @param {?} context
     * @return {?}
     */
    LiteralArrayExpr.prototype.visitExpression = function (visitor, context) {
        return visitor.visitLiteralArrayExpr(this, context);
    };
    return LiteralArrayExpr;
}(Expression));
var LiteralMapEntry = (function () {
    /**
     * @param {?} key
     * @param {?} value
     * @param {?=} quoted
     */
    function LiteralMapEntry(key, value, quoted) {
        if (quoted === void 0) { quoted = false; }
        this.key = key;
        this.value = value;
        this.quoted = quoted;
    }
    return LiteralMapEntry;
}());
var LiteralMapExpr = (function (_super) {
    __extends(LiteralMapExpr, _super);
    /**
     * @param {?} entries
     * @param {?=} type
     * @param {?=} sourceSpan
     */
    function LiteralMapExpr(entries, type, sourceSpan) {
        var _this = _super.call(this, type, sourceSpan) || this;
        _this.entries = entries;
        _this.valueType = null;
        if (type) {
            _this.valueType = type.valueType;
        }
        return _this;
    }
    /**
     * @param {?} visitor
     * @param {?} context
     * @return {?}
     */
    LiteralMapExpr.prototype.visitExpression = function (visitor, context) {
        return visitor.visitLiteralMapExpr(this, context);
    };
    return LiteralMapExpr;
}(Expression));
var CommaExpr = (function (_super) {
    __extends(CommaExpr, _super);
    /**
     * @param {?} parts
     * @param {?=} sourceSpan
     */
    function CommaExpr(parts, sourceSpan) {
        var _this = _super.call(this, parts[parts.length - 1].type, sourceSpan) || this;
        _this.parts = parts;
        return _this;
    }
    /**
     * @param {?} visitor
     * @param {?} context
     * @return {?}
     */
    CommaExpr.prototype.visitExpression = function (visitor, context) {
        return visitor.visitCommaExpr(this, context);
    };
    return CommaExpr;
}(Expression));
var THIS_EXPR = new ReadVarExpr(BuiltinVar.This, null, null);
var SUPER_EXPR = new ReadVarExpr(BuiltinVar.Super, null, null);
var CATCH_ERROR_VAR = new ReadVarExpr(BuiltinVar.CatchError, null, null);
var CATCH_STACK_VAR = new ReadVarExpr(BuiltinVar.CatchStack, null, null);
var NULL_EXPR = new LiteralExpr(null, null, null);
var TYPED_NULL_EXPR = new LiteralExpr(null, INFERRED_TYPE, null);
var StmtModifier = {};
StmtModifier.Final = 0;
StmtModifier.Private = 1;
StmtModifier[StmtModifier.Final] = "Final";
StmtModifier[StmtModifier.Private] = "Private";
/**
 * @abstract
 */
var Statement = (function () {
    /**
     * @param {?=} modifiers
     * @param {?=} sourceSpan
     */
    function Statement(modifiers, sourceSpan) {
        this.modifiers = modifiers || [];
        this.sourceSpan = sourceSpan || null;
    }
    /**
     * @abstract
     * @param {?} visitor
     * @param {?} context
     * @return {?}
     */
    Statement.prototype.visitStatement = function (visitor, context) { };
    /**
     * @param {?} modifier
     * @return {?}
     */
    Statement.prototype.hasModifier = function (modifier) { return ((this.modifiers)).indexOf(modifier) !== -1; };
    return Statement;
}());
var DeclareVarStmt = (function (_super) {
    __extends(DeclareVarStmt, _super);
    /**
     * @param {?} name
     * @param {?} value
     * @param {?=} type
     * @param {?=} modifiers
     * @param {?=} sourceSpan
     */
    function DeclareVarStmt(name, value, type, modifiers, sourceSpan) {
        if (modifiers === void 0) { modifiers = null; }
        var _this = _super.call(this, modifiers, sourceSpan) || this;
        _this.name = name;
        _this.value = value;
        _this.type = type || value.type;
        return _this;
    }
    /**
     * @param {?} visitor
     * @param {?} context
     * @return {?}
     */
    DeclareVarStmt.prototype.visitStatement = function (visitor, context) {
        return visitor.visitDeclareVarStmt(this, context);
    };
    return DeclareVarStmt;
}(Statement));
var DeclareFunctionStmt = (function (_super) {
    __extends(DeclareFunctionStmt, _super);
    /**
     * @param {?} name
     * @param {?} params
     * @param {?} statements
     * @param {?=} type
     * @param {?=} modifiers
     * @param {?=} sourceSpan
     */
    function DeclareFunctionStmt(name, params, statements, type, modifiers, sourceSpan) {
        if (modifiers === void 0) { modifiers = null; }
        var _this = _super.call(this, modifiers, sourceSpan) || this;
        _this.name = name;
        _this.params = params;
        _this.statements = statements;
        _this.type = type || null;
        return _this;
    }
    /**
     * @param {?} visitor
     * @param {?} context
     * @return {?}
     */
    DeclareFunctionStmt.prototype.visitStatement = function (visitor, context) {
        return visitor.visitDeclareFunctionStmt(this, context);
    };
    return DeclareFunctionStmt;
}(Statement));
var ExpressionStatement = (function (_super) {
    __extends(ExpressionStatement, _super);
    /**
     * @param {?} expr
     * @param {?=} sourceSpan
     */
    function ExpressionStatement(expr, sourceSpan) {
        var _this = _super.call(this, null, sourceSpan) || this;
        _this.expr = expr;
        return _this;
    }
    /**
     * @param {?} visitor
     * @param {?} context
     * @return {?}
     */
    ExpressionStatement.prototype.visitStatement = function (visitor, context) {
        return visitor.visitExpressionStmt(this, context);
    };
    return ExpressionStatement;
}(Statement));
var ReturnStatement = (function (_super) {
    __extends(ReturnStatement, _super);
    /**
     * @param {?} value
     * @param {?=} sourceSpan
     */
    function ReturnStatement(value, sourceSpan) {
        var _this = _super.call(this, null, sourceSpan) || this;
        _this.value = value;
        return _this;
    }
    /**
     * @param {?} visitor
     * @param {?} context
     * @return {?}
     */
    ReturnStatement.prototype.visitStatement = function (visitor, context) {
        return visitor.visitReturnStmt(this, context);
    };
    return ReturnStatement;
}(Statement));
var AbstractClassPart = (function () {
    /**
     * @param {?} type
     * @param {?} modifiers
     */
    function AbstractClassPart(type, modifiers) {
        this.modifiers = modifiers;
        if (!modifiers) {
            this.modifiers = [];
        }
        this.type = type || null;
    }
    /**
     * @param {?} modifier
     * @return {?}
     */
    AbstractClassPart.prototype.hasModifier = function (modifier) { return ((this.modifiers)).indexOf(modifier) !== -1; };
    return AbstractClassPart;
}());
var ClassField = (function (_super) {
    __extends(ClassField, _super);
    /**
     * @param {?} name
     * @param {?=} type
     * @param {?=} modifiers
     */
    function ClassField(name, type, modifiers) {
        if (modifiers === void 0) { modifiers = null; }
        var _this = _super.call(this, type, modifiers) || this;
        _this.name = name;
        return _this;
    }
    return ClassField;
}(AbstractClassPart));
var ClassMethod = (function (_super) {
    __extends(ClassMethod, _super);
    /**
     * @param {?} name
     * @param {?} params
     * @param {?} body
     * @param {?=} type
     * @param {?=} modifiers
     */
    function ClassMethod(name, params, body, type, modifiers) {
        if (modifiers === void 0) { modifiers = null; }
        var _this = _super.call(this, type, modifiers) || this;
        _this.name = name;
        _this.params = params;
        _this.body = body;
        return _this;
    }
    return ClassMethod;
}(AbstractClassPart));
var ClassGetter = (function (_super) {
    __extends(ClassGetter, _super);
    /**
     * @param {?} name
     * @param {?} body
     * @param {?=} type
     * @param {?=} modifiers
     */
    function ClassGetter(name, body, type, modifiers) {
        if (modifiers === void 0) { modifiers = null; }
        var _this = _super.call(this, type, modifiers) || this;
        _this.name = name;
        _this.body = body;
        return _this;
    }
    return ClassGetter;
}(AbstractClassPart));
var ClassStmt = (function (_super) {
    __extends(ClassStmt, _super);
    /**
     * @param {?} name
     * @param {?} parent
     * @param {?} fields
     * @param {?} getters
     * @param {?} constructorMethod
     * @param {?} methods
     * @param {?=} modifiers
     * @param {?=} sourceSpan
     */
    function ClassStmt(name, parent, fields, getters, constructorMethod, methods, modifiers, sourceSpan) {
        if (modifiers === void 0) { modifiers = null; }
        var _this = _super.call(this, modifiers, sourceSpan) || this;
        _this.name = name;
        _this.parent = parent;
        _this.fields = fields;
        _this.getters = getters;
        _this.constructorMethod = constructorMethod;
        _this.methods = methods;
        return _this;
    }
    /**
     * @param {?} visitor
     * @param {?} context
     * @return {?}
     */
    ClassStmt.prototype.visitStatement = function (visitor, context) {
        return visitor.visitDeclareClassStmt(this, context);
    };
    return ClassStmt;
}(Statement));
var IfStmt = (function (_super) {
    __extends(IfStmt, _super);
    /**
     * @param {?} condition
     * @param {?} trueCase
     * @param {?=} falseCase
     * @param {?=} sourceSpan
     */
    function IfStmt(condition, trueCase, falseCase, sourceSpan) {
        if (falseCase === void 0) { falseCase = []; }
        var _this = _super.call(this, null, sourceSpan) || this;
        _this.condition = condition;
        _this.trueCase = trueCase;
        _this.falseCase = falseCase;
        return _this;
    }
    /**
     * @param {?} visitor
     * @param {?} context
     * @return {?}
     */
    IfStmt.prototype.visitStatement = function (visitor, context) {
        return visitor.visitIfStmt(this, context);
    };
    return IfStmt;
}(Statement));
var TryCatchStmt = (function (_super) {
    __extends(TryCatchStmt, _super);
    /**
     * @param {?} bodyStmts
     * @param {?} catchStmts
     * @param {?=} sourceSpan
     */
    function TryCatchStmt(bodyStmts, catchStmts, sourceSpan) {
        var _this = _super.call(this, null, sourceSpan) || this;
        _this.bodyStmts = bodyStmts;
        _this.catchStmts = catchStmts;
        return _this;
    }
    /**
     * @param {?} visitor
     * @param {?} context
     * @return {?}
     */
    TryCatchStmt.prototype.visitStatement = function (visitor, context) {
        return visitor.visitTryCatchStmt(this, context);
    };
    return TryCatchStmt;
}(Statement));
var ThrowStmt = (function (_super) {
    __extends(ThrowStmt, _super);
    /**
     * @param {?} error
     * @param {?=} sourceSpan
     */
    function ThrowStmt(error, sourceSpan) {
        var _this = _super.call(this, null, sourceSpan) || this;
        _this.error = error;
        return _this;
    }
    /**
     * @param {?} visitor
     * @param {?} context
     * @return {?}
     */
    ThrowStmt.prototype.visitStatement = function (visitor, context) {
        return visitor.visitThrowStmt(this, context);
    };
    return ThrowStmt;
}(Statement));
var AstTransformer$1 = (function () {
    function AstTransformer$1() {
    }
    /**
     * @param {?} expr
     * @param {?} context
     * @return {?}
     */
    AstTransformer$1.prototype.transformExpr = function (expr, context) { return expr; };
    /**
     * @param {?} stmt
     * @param {?} context
     * @return {?}
     */
    AstTransformer$1.prototype.transformStmt = function (stmt, context) { return stmt; };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    AstTransformer$1.prototype.visitReadVarExpr = function (ast, context) { return this.transformExpr(ast, context); };
    /**
     * @param {?} expr
     * @param {?} context
     * @return {?}
     */
    AstTransformer$1.prototype.visitWriteVarExpr = function (expr, context) {
        return this.transformExpr(new WriteVarExpr(expr.name, expr.value.visitExpression(this, context), expr.type, expr.sourceSpan), context);
    };
    /**
     * @param {?} expr
     * @param {?} context
     * @return {?}
     */
    AstTransformer$1.prototype.visitWriteKeyExpr = function (expr, context) {
        return this.transformExpr(new WriteKeyExpr(expr.receiver.visitExpression(this, context), expr.index.visitExpression(this, context), expr.value.visitExpression(this, context), expr.type, expr.sourceSpan), context);
    };
    /**
     * @param {?} expr
     * @param {?} context
     * @return {?}
     */
    AstTransformer$1.prototype.visitWritePropExpr = function (expr, context) {
        return this.transformExpr(new WritePropExpr(expr.receiver.visitExpression(this, context), expr.name, expr.value.visitExpression(this, context), expr.type, expr.sourceSpan), context);
    };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    AstTransformer$1.prototype.visitInvokeMethodExpr = function (ast, context) {
        var /** @type {?} */ method = ast.builtin || ast.name;
        return this.transformExpr(new InvokeMethodExpr(ast.receiver.visitExpression(this, context), /** @type {?} */ ((method)), this.visitAllExpressions(ast.args, context), ast.type, ast.sourceSpan), context);
    };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    AstTransformer$1.prototype.visitInvokeFunctionExpr = function (ast, context) {
        return this.transformExpr(new InvokeFunctionExpr(ast.fn.visitExpression(this, context), this.visitAllExpressions(ast.args, context), ast.type, ast.sourceSpan), context);
    };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    AstTransformer$1.prototype.visitInstantiateExpr = function (ast, context) {
        return this.transformExpr(new InstantiateExpr(ast.classExpr.visitExpression(this, context), this.visitAllExpressions(ast.args, context), ast.type, ast.sourceSpan), context);
    };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    AstTransformer$1.prototype.visitLiteralExpr = function (ast, context) { return this.transformExpr(ast, context); };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    AstTransformer$1.prototype.visitExternalExpr = function (ast, context) {
        return this.transformExpr(ast, context);
    };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    AstTransformer$1.prototype.visitConditionalExpr = function (ast, context) {
        return this.transformExpr(new ConditionalExpr(ast.condition.visitExpression(this, context), ast.trueCase.visitExpression(this, context), /** @type {?} */ ((ast.falseCase)).visitExpression(this, context), ast.type, ast.sourceSpan), context);
    };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    AstTransformer$1.prototype.visitNotExpr = function (ast, context) {
        return this.transformExpr(new NotExpr(ast.condition.visitExpression(this, context), ast.sourceSpan), context);
    };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    AstTransformer$1.prototype.visitCastExpr = function (ast, context) {
        return this.transformExpr(new CastExpr(ast.value.visitExpression(this, context), ast.type, ast.sourceSpan), context);
    };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    AstTransformer$1.prototype.visitFunctionExpr = function (ast, context) {
        return this.transformExpr(new FunctionExpr(ast.params, this.visitAllStatements(ast.statements, context), ast.type, ast.sourceSpan), context);
    };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    AstTransformer$1.prototype.visitBinaryOperatorExpr = function (ast, context) {
        return this.transformExpr(new BinaryOperatorExpr(ast.operator, ast.lhs.visitExpression(this, context), ast.rhs.visitExpression(this, context), ast.type, ast.sourceSpan), context);
    };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    AstTransformer$1.prototype.visitReadPropExpr = function (ast, context) {
        return this.transformExpr(new ReadPropExpr(ast.receiver.visitExpression(this, context), ast.name, ast.type, ast.sourceSpan), context);
    };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    AstTransformer$1.prototype.visitReadKeyExpr = function (ast, context) {
        return this.transformExpr(new ReadKeyExpr(ast.receiver.visitExpression(this, context), ast.index.visitExpression(this, context), ast.type, ast.sourceSpan), context);
    };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    AstTransformer$1.prototype.visitLiteralArrayExpr = function (ast, context) {
        return this.transformExpr(new LiteralArrayExpr(this.visitAllExpressions(ast.entries, context), ast.type, ast.sourceSpan), context);
    };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    AstTransformer$1.prototype.visitLiteralMapExpr = function (ast, context) {
        var _this = this;
        var /** @type {?} */ entries = ast.entries.map(function (entry) { return new LiteralMapEntry(entry.key, entry.value.visitExpression(_this, context), entry.quoted); });
        var /** @type {?} */ mapType = new MapType(ast.valueType, null);
        return this.transformExpr(new LiteralMapExpr(entries, mapType, ast.sourceSpan), context);
    };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    AstTransformer$1.prototype.visitCommaExpr = function (ast, context) {
        return this.transformExpr(new CommaExpr(this.visitAllExpressions(ast.parts, context), ast.sourceSpan), context);
    };
    /**
     * @param {?} exprs
     * @param {?} context
     * @return {?}
     */
    AstTransformer$1.prototype.visitAllExpressions = function (exprs, context) {
        var _this = this;
        return exprs.map(function (expr) { return expr.visitExpression(_this, context); });
    };
    /**
     * @param {?} stmt
     * @param {?} context
     * @return {?}
     */
    AstTransformer$1.prototype.visitDeclareVarStmt = function (stmt, context) {
        return this.transformStmt(new DeclareVarStmt(stmt.name, stmt.value.visitExpression(this, context), stmt.type, stmt.modifiers, stmt.sourceSpan), context);
    };
    /**
     * @param {?} stmt
     * @param {?} context
     * @return {?}
     */
    AstTransformer$1.prototype.visitDeclareFunctionStmt = function (stmt, context) {
        return this.transformStmt(new DeclareFunctionStmt(stmt.name, stmt.params, this.visitAllStatements(stmt.statements, context), stmt.type, stmt.modifiers, stmt.sourceSpan), context);
    };
    /**
     * @param {?} stmt
     * @param {?} context
     * @return {?}
     */
    AstTransformer$1.prototype.visitExpressionStmt = function (stmt, context) {
        return this.transformStmt(new ExpressionStatement(stmt.expr.visitExpression(this, context), stmt.sourceSpan), context);
    };
    /**
     * @param {?} stmt
     * @param {?} context
     * @return {?}
     */
    AstTransformer$1.prototype.visitReturnStmt = function (stmt, context) {
        return this.transformStmt(new ReturnStatement(stmt.value.visitExpression(this, context), stmt.sourceSpan), context);
    };
    /**
     * @param {?} stmt
     * @param {?} context
     * @return {?}
     */
    AstTransformer$1.prototype.visitDeclareClassStmt = function (stmt, context) {
        var _this = this;
        var /** @type {?} */ parent = ((stmt.parent)).visitExpression(this, context);
        var /** @type {?} */ getters = stmt.getters.map(function (getter) { return new ClassGetter(getter.name, _this.visitAllStatements(getter.body, context), getter.type, getter.modifiers); });
        var /** @type {?} */ ctorMethod = stmt.constructorMethod &&
            new ClassMethod(stmt.constructorMethod.name, stmt.constructorMethod.params, this.visitAllStatements(stmt.constructorMethod.body, context), stmt.constructorMethod.type, stmt.constructorMethod.modifiers);
        var /** @type {?} */ methods = stmt.methods.map(function (method) { return new ClassMethod(method.name, method.params, _this.visitAllStatements(method.body, context), method.type, method.modifiers); });
        return this.transformStmt(new ClassStmt(stmt.name, parent, stmt.fields, getters, ctorMethod, methods, stmt.modifiers, stmt.sourceSpan), context);
    };
    /**
     * @param {?} stmt
     * @param {?} context
     * @return {?}
     */
    AstTransformer$1.prototype.visitIfStmt = function (stmt, context) {
        return this.transformStmt(new IfStmt(stmt.condition.visitExpression(this, context), this.visitAllStatements(stmt.trueCase, context), this.visitAllStatements(stmt.falseCase, context), stmt.sourceSpan), context);
    };
    /**
     * @param {?} stmt
     * @param {?} context
     * @return {?}
     */
    AstTransformer$1.prototype.visitTryCatchStmt = function (stmt, context) {
        return this.transformStmt(new TryCatchStmt(this.visitAllStatements(stmt.bodyStmts, context), this.visitAllStatements(stmt.catchStmts, context), stmt.sourceSpan), context);
    };
    /**
     * @param {?} stmt
     * @param {?} context
     * @return {?}
     */
    AstTransformer$1.prototype.visitThrowStmt = function (stmt, context) {
        return this.transformStmt(new ThrowStmt(stmt.error.visitExpression(this, context), stmt.sourceSpan), context);
    };
    /**
     * @param {?} stmt
     * @param {?} context
     * @return {?}
     */
    AstTransformer$1.prototype.visitCommentStmt = function (stmt, context) {
        return this.transformStmt(stmt, context);
    };
    /**
     * @param {?} stmts
     * @param {?} context
     * @return {?}
     */
    AstTransformer$1.prototype.visitAllStatements = function (stmts, context) {
        var _this = this;
        return stmts.map(function (stmt) { return stmt.visitStatement(_this, context); });
    };
    return AstTransformer$1;
}());
var RecursiveAstVisitor$1 = (function () {
    function RecursiveAstVisitor$1() {
    }
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    RecursiveAstVisitor$1.prototype.visitReadVarExpr = function (ast, context) { return ast; };
    /**
     * @param {?} expr
     * @param {?} context
     * @return {?}
     */
    RecursiveAstVisitor$1.prototype.visitWriteVarExpr = function (expr, context) {
        expr.value.visitExpression(this, context);
        return expr;
    };
    /**
     * @param {?} expr
     * @param {?} context
     * @return {?}
     */
    RecursiveAstVisitor$1.prototype.visitWriteKeyExpr = function (expr, context) {
        expr.receiver.visitExpression(this, context);
        expr.index.visitExpression(this, context);
        expr.value.visitExpression(this, context);
        return expr;
    };
    /**
     * @param {?} expr
     * @param {?} context
     * @return {?}
     */
    RecursiveAstVisitor$1.prototype.visitWritePropExpr = function (expr, context) {
        expr.receiver.visitExpression(this, context);
        expr.value.visitExpression(this, context);
        return expr;
    };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    RecursiveAstVisitor$1.prototype.visitInvokeMethodExpr = function (ast, context) {
        ast.receiver.visitExpression(this, context);
        this.visitAllExpressions(ast.args, context);
        return ast;
    };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    RecursiveAstVisitor$1.prototype.visitInvokeFunctionExpr = function (ast, context) {
        ast.fn.visitExpression(this, context);
        this.visitAllExpressions(ast.args, context);
        return ast;
    };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    RecursiveAstVisitor$1.prototype.visitInstantiateExpr = function (ast, context) {
        ast.classExpr.visitExpression(this, context);
        this.visitAllExpressions(ast.args, context);
        return ast;
    };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    RecursiveAstVisitor$1.prototype.visitLiteralExpr = function (ast, context) { return ast; };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    RecursiveAstVisitor$1.prototype.visitExternalExpr = function (ast, context) { return ast; };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    RecursiveAstVisitor$1.prototype.visitConditionalExpr = function (ast, context) {
        ast.condition.visitExpression(this, context);
        ast.trueCase.visitExpression(this, context); /** @type {?} */
        ((ast.falseCase)).visitExpression(this, context);
        return ast;
    };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    RecursiveAstVisitor$1.prototype.visitNotExpr = function (ast, context) {
        ast.condition.visitExpression(this, context);
        return ast;
    };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    RecursiveAstVisitor$1.prototype.visitCastExpr = function (ast, context) {
        ast.value.visitExpression(this, context);
        return ast;
    };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    RecursiveAstVisitor$1.prototype.visitFunctionExpr = function (ast, context) {
        this.visitAllStatements(ast.statements, context);
        return ast;
    };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    RecursiveAstVisitor$1.prototype.visitBinaryOperatorExpr = function (ast, context) {
        ast.lhs.visitExpression(this, context);
        ast.rhs.visitExpression(this, context);
        return ast;
    };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    RecursiveAstVisitor$1.prototype.visitReadPropExpr = function (ast, context) {
        ast.receiver.visitExpression(this, context);
        return ast;
    };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    RecursiveAstVisitor$1.prototype.visitReadKeyExpr = function (ast, context) {
        ast.receiver.visitExpression(this, context);
        ast.index.visitExpression(this, context);
        return ast;
    };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    RecursiveAstVisitor$1.prototype.visitLiteralArrayExpr = function (ast, context) {
        this.visitAllExpressions(ast.entries, context);
        return ast;
    };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    RecursiveAstVisitor$1.prototype.visitLiteralMapExpr = function (ast, context) {
        var _this = this;
        ast.entries.forEach(function (entry) { return entry.value.visitExpression(_this, context); });
        return ast;
    };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    RecursiveAstVisitor$1.prototype.visitCommaExpr = function (ast, context) {
        this.visitAllExpressions(ast.parts, context);
    };
    /**
     * @param {?} exprs
     * @param {?} context
     * @return {?}
     */
    RecursiveAstVisitor$1.prototype.visitAllExpressions = function (exprs, context) {
        var _this = this;
        exprs.forEach(function (expr) { return expr.visitExpression(_this, context); });
    };
    /**
     * @param {?} stmt
     * @param {?} context
     * @return {?}
     */
    RecursiveAstVisitor$1.prototype.visitDeclareVarStmt = function (stmt, context) {
        stmt.value.visitExpression(this, context);
        return stmt;
    };
    /**
     * @param {?} stmt
     * @param {?} context
     * @return {?}
     */
    RecursiveAstVisitor$1.prototype.visitDeclareFunctionStmt = function (stmt, context) {
        this.visitAllStatements(stmt.statements, context);
        return stmt;
    };
    /**
     * @param {?} stmt
     * @param {?} context
     * @return {?}
     */
    RecursiveAstVisitor$1.prototype.visitExpressionStmt = function (stmt, context) {
        stmt.expr.visitExpression(this, context);
        return stmt;
    };
    /**
     * @param {?} stmt
     * @param {?} context
     * @return {?}
     */
    RecursiveAstVisitor$1.prototype.visitReturnStmt = function (stmt, context) {
        stmt.value.visitExpression(this, context);
        return stmt;
    };
    /**
     * @param {?} stmt
     * @param {?} context
     * @return {?}
     */
    RecursiveAstVisitor$1.prototype.visitDeclareClassStmt = function (stmt, context) {
        var _this = this;
        ((stmt.parent)).visitExpression(this, context);
        stmt.getters.forEach(function (getter) { return _this.visitAllStatements(getter.body, context); });
        if (stmt.constructorMethod) {
            this.visitAllStatements(stmt.constructorMethod.body, context);
        }
        stmt.methods.forEach(function (method) { return _this.visitAllStatements(method.body, context); });
        return stmt;
    };
    /**
     * @param {?} stmt
     * @param {?} context
     * @return {?}
     */
    RecursiveAstVisitor$1.prototype.visitIfStmt = function (stmt, context) {
        stmt.condition.visitExpression(this, context);
        this.visitAllStatements(stmt.trueCase, context);
        this.visitAllStatements(stmt.falseCase, context);
        return stmt;
    };
    /**
     * @param {?} stmt
     * @param {?} context
     * @return {?}
     */
    RecursiveAstVisitor$1.prototype.visitTryCatchStmt = function (stmt, context) {
        this.visitAllStatements(stmt.bodyStmts, context);
        this.visitAllStatements(stmt.catchStmts, context);
        return stmt;
    };
    /**
     * @param {?} stmt
     * @param {?} context
     * @return {?}
     */
    RecursiveAstVisitor$1.prototype.visitThrowStmt = function (stmt, context) {
        stmt.error.visitExpression(this, context);
        return stmt;
    };
    /**
     * @param {?} stmt
     * @param {?} context
     * @return {?}
     */
    RecursiveAstVisitor$1.prototype.visitCommentStmt = function (stmt, context) { return stmt; };
    /**
     * @param {?} stmts
     * @param {?} context
     * @return {?}
     */
    RecursiveAstVisitor$1.prototype.visitAllStatements = function (stmts, context) {
        var _this = this;
        stmts.forEach(function (stmt) { return stmt.visitStatement(_this, context); });
    };
    return RecursiveAstVisitor$1;
}());
/**
 * @param {?} stmts
 * @return {?}
 */
function findReadVarNames(stmts) {
    var /** @type {?} */ visitor = new _ReadVarVisitor();
    visitor.visitAllStatements(stmts, null);
    return visitor.varNames;
}
var _ReadVarVisitor = (function (_super) {
    __extends(_ReadVarVisitor, _super);
    function _ReadVarVisitor() {
        var _this = _super.apply(this, arguments) || this;
        _this.varNames = new Set();
        return _this;
    }
    /**
     * @param {?} stmt
     * @param {?} context
     * @return {?}
     */
    _ReadVarVisitor.prototype.visitDeclareFunctionStmt = function (stmt, context) {
        // Don't descend into nested functions
        return stmt;
    };
    /**
     * @param {?} stmt
     * @param {?} context
     * @return {?}
     */
    _ReadVarVisitor.prototype.visitDeclareClassStmt = function (stmt, context) {
        // Don't descend into nested classes
        return stmt;
    };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    _ReadVarVisitor.prototype.visitReadVarExpr = function (ast, context) {
        if (ast.name) {
            this.varNames.add(ast.name);
        }
        return null;
    };
    return _ReadVarVisitor;
}(RecursiveAstVisitor$1));
/**
 * @param {?} stmt
 * @param {?} sourceSpan
 * @return {?}
 */
function applySourceSpanToStatementIfNeeded(stmt, sourceSpan) {
    if (!sourceSpan) {
        return stmt;
    }
    var /** @type {?} */ transformer = new _ApplySourceSpanTransformer(sourceSpan);
    return stmt.visitStatement(transformer, null);
}
/**
 * @param {?} expr
 * @param {?} sourceSpan
 * @return {?}
 */
function applySourceSpanToExpressionIfNeeded(expr, sourceSpan) {
    if (!sourceSpan) {
        return expr;
    }
    var /** @type {?} */ transformer = new _ApplySourceSpanTransformer(sourceSpan);
    return expr.visitExpression(transformer, null);
}
var _ApplySourceSpanTransformer = (function (_super) {
    __extends(_ApplySourceSpanTransformer, _super);
    /**
     * @param {?} sourceSpan
     */
    function _ApplySourceSpanTransformer(sourceSpan) {
        var _this = _super.call(this) || this;
        _this.sourceSpan = sourceSpan;
        return _this;
    }
    /**
     * @param {?} obj
     * @return {?}
     */
    _ApplySourceSpanTransformer.prototype._clone = function (obj) {
        var /** @type {?} */ clone = Object.create(obj.constructor.prototype);
        for (var /** @type {?} */ prop in obj) {
            clone[prop] = obj[prop];
        }
        return clone;
    };
    /**
     * @param {?} expr
     * @param {?} context
     * @return {?}
     */
    _ApplySourceSpanTransformer.prototype.transformExpr = function (expr, context) {
        if (!expr.sourceSpan) {
            expr = this._clone(expr);
            expr.sourceSpan = this.sourceSpan;
        }
        return expr;
    };
    /**
     * @param {?} stmt
     * @param {?} context
     * @return {?}
     */
    _ApplySourceSpanTransformer.prototype.transformStmt = function (stmt, context) {
        if (!stmt.sourceSpan) {
            stmt = this._clone(stmt);
            stmt.sourceSpan = this.sourceSpan;
        }
        return stmt;
    };
    return _ApplySourceSpanTransformer;
}(AstTransformer$1));
/**
 * @param {?} name
 * @param {?=} type
 * @param {?=} sourceSpan
 * @return {?}
 */
function variable(name, type, sourceSpan) {
    return new ReadVarExpr(name, type, sourceSpan);
}
/**
 * @param {?} id
 * @param {?=} typeParams
 * @param {?=} sourceSpan
 * @return {?}
 */
function importExpr(id, typeParams, sourceSpan) {
    if (typeParams === void 0) { typeParams = null; }
    return new ExternalExpr(id, null, typeParams, sourceSpan);
}
/**
 * @param {?} id
 * @param {?=} typeParams
 * @param {?=} typeModifiers
 * @return {?}
 */
function importType(id, typeParams, typeModifiers) {
    if (typeParams === void 0) { typeParams = null; }
    if (typeModifiers === void 0) { typeModifiers = null; }
    return id != null ? expressionType(importExpr(id, typeParams, null), typeModifiers) : null;
}
/**
 * @param {?} expr
 * @param {?=} typeModifiers
 * @return {?}
 */
function expressionType(expr, typeModifiers) {
    if (typeModifiers === void 0) { typeModifiers = null; }
    return expr != null ? ((new ExpressionType(expr, typeModifiers))) : null;
}
/**
 * @param {?} values
 * @param {?=} type
 * @param {?=} sourceSpan
 * @return {?}
 */
function literalArr(values, type, sourceSpan) {
    return new LiteralArrayExpr(values, type, sourceSpan);
}
/**
 * @param {?} values
 * @param {?=} type
 * @param {?=} quoted
 * @return {?}
 */
function literalMap(values, type, quoted) {
    if (type === void 0) { type = null; }
    if (quoted === void 0) { quoted = false; }
    return new LiteralMapExpr(values.map(function (entry) { return new LiteralMapEntry(entry[0], entry[1], quoted); }), type, null);
}
/**
 * @param {?} expr
 * @param {?=} sourceSpan
 * @return {?}
 */
function not(expr, sourceSpan) {
    return new NotExpr(expr, sourceSpan);
}
/**
 * @param {?} params
 * @param {?} body
 * @param {?=} type
 * @param {?=} sourceSpan
 * @return {?}
 */
function fn(params, body, type, sourceSpan) {
    return new FunctionExpr(params, body, type, sourceSpan);
}
/**
 * @param {?} value
 * @param {?=} type
 * @param {?=} sourceSpan
 * @return {?}
 */
function literal(value, type, sourceSpan) {
    return new LiteralExpr(value, type, sourceSpan);
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Create a new class stmts based on the given data.
 * @param {?} config
 * @return {?}
 */
function createClassStmt(config) {
    var /** @type {?} */ parentArgs = config.parentArgs || [];
    var /** @type {?} */ superCtorStmts = config.parent ? [SUPER_EXPR.callFn(parentArgs).toStmt()] : [];
    var /** @type {?} */ builder = concatClassBuilderParts(Array.isArray(config.builders) ? config.builders : [config.builders]);
    var /** @type {?} */ ctor = new ClassMethod(null, config.ctorParams || [], superCtorStmts.concat(builder.ctorStmts));
    return new ClassStmt(config.name, config.parent || null, builder.fields, builder.getters, ctor, builder.methods, config.modifiers || [], config.sourceSpan);
}
/**
 * @param {?} builders
 * @return {?}
 */
function concatClassBuilderParts(builders) {
    return {
        fields: [].concat.apply([], ((builders.map((function (builder) { return builder.fields || []; }))))),
        methods: [].concat.apply([], ((builders.map(function (builder) { return builder.methods || []; })))),
        getters: [].concat.apply([], ((builders.map(function (builder) { return builder.getters || []; })))),
        ctorStmts: [].concat.apply([], ((builders.map(function (builder) { return builder.ctorStmts || []; })))),
    };
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var QUOTED_KEYS = '$quoted$';
/**
 * @param {?} value
 * @param {?=} type
 * @return {?}
 */
function convertValueToOutputAst(value, type) {
    if (type === void 0) { type = null; }
    return visitValue(value, new _ValueOutputAstTransformer(), type);
}
var _ValueOutputAstTransformer = (function () {
    function _ValueOutputAstTransformer() {
    }
    /**
     * @param {?} arr
     * @param {?} type
     * @return {?}
     */
    _ValueOutputAstTransformer.prototype.visitArray = function (arr, type) {
        var _this = this;
        return literalArr(arr.map(function (value) { return visitValue(value, _this, null); }), type);
    };
    /**
     * @param {?} map
     * @param {?} type
     * @return {?}
     */
    _ValueOutputAstTransformer.prototype.visitStringMap = function (map, type) {
        var _this = this;
        var /** @type {?} */ entries = [];
        var /** @type {?} */ quotedSet = new Set(map && map[QUOTED_KEYS]);
        Object.keys(map).forEach(function (key) {
            entries.push(new LiteralMapEntry(key, visitValue(map[key], _this, null), quotedSet.has(key)));
        });
        return new LiteralMapExpr(entries, type);
    };
    /**
     * @param {?} value
     * @param {?} type
     * @return {?}
     */
    _ValueOutputAstTransformer.prototype.visitPrimitive = function (value, type) { return literal(value, type); };
    /**
     * @param {?} value
     * @param {?} type
     * @return {?}
     */
    _ValueOutputAstTransformer.prototype.visitOther = function (value, type) {
        if (value instanceof Expression) {
            return value;
        }
        else {
            return importExpr({ reference: value });
        }
    };
    return _ValueOutputAstTransformer;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * This is currently not read, but will probably be used in the future.
 * We keep it as we already pass it through all the rigth places...
 */
var ComponentFactoryDependency = (function () {
    /**
     * @param {?} compType
     */
    function ComponentFactoryDependency(compType) {
        this.compType = compType;
    }
    return ComponentFactoryDependency;
}());
var NgModuleCompileResult = (function () {
    /**
     * @param {?} statements
     * @param {?} ngModuleFactoryVar
     * @param {?} dependencies
     */
    function NgModuleCompileResult(statements, ngModuleFactoryVar, dependencies) {
        this.statements = statements;
        this.ngModuleFactoryVar = ngModuleFactoryVar;
        this.dependencies = dependencies;
    }
    return NgModuleCompileResult;
}());
var NgModuleCompiler = (function () {
    function NgModuleCompiler() {
    }
    /**
     * @param {?} ngModuleMeta
     * @param {?} extraProviders
     * @return {?}
     */
    NgModuleCompiler.prototype.compile = function (ngModuleMeta, extraProviders) {
        var /** @type {?} */ sourceSpan = typeSourceSpan('NgModule', ngModuleMeta.type);
        var /** @type {?} */ deps = [];
        var /** @type {?} */ bootstrapComponentFactories = [];
        var /** @type {?} */ entryComponentFactories = ngModuleMeta.transitiveModule.entryComponents.map(function (entryComponent) {
            if (ngModuleMeta.bootstrapComponents.some(function (id) { return id.reference === entryComponent.componentType; })) {
                bootstrapComponentFactories.push({ reference: entryComponent.componentFactory });
            }
            deps.push(new ComponentFactoryDependency(entryComponent.componentType));
            return { reference: entryComponent.componentFactory };
        });
        var /** @type {?} */ builder = new _InjectorBuilder(ngModuleMeta, entryComponentFactories, bootstrapComponentFactories, sourceSpan);
        var /** @type {?} */ providerParser = new NgModuleProviderAnalyzer(ngModuleMeta, extraProviders, sourceSpan);
        providerParser.parse().forEach(function (provider) { return builder.addProvider(provider); });
        var /** @type {?} */ injectorClass = builder.build();
        var /** @type {?} */ ngModuleFactoryVar = identifierName(ngModuleMeta.type) + "NgFactory";
        var /** @type {?} */ ngModuleFactoryStmt = variable(ngModuleFactoryVar)
            .set(importExpr(createIdentifier(Identifiers.NgModuleFactory))
            .instantiate([variable(injectorClass.name), importExpr(ngModuleMeta.type)], importType(createIdentifier(Identifiers.NgModuleFactory), [/** @type {?} */ ((importType(ngModuleMeta.type)))], [TypeModifier.Const])))
            .toDeclStmt(null, [StmtModifier.Final]);
        var /** @type {?} */ stmts = [injectorClass, ngModuleFactoryStmt];
        if (ngModuleMeta.id) {
            var /** @type {?} */ registerFactoryStmt = importExpr(createIdentifier(Identifiers.RegisterModuleFactoryFn))
                .callFn([literal(ngModuleMeta.id), variable(ngModuleFactoryVar)])
                .toStmt();
            stmts.push(registerFactoryStmt);
        }
        return new NgModuleCompileResult(stmts, ngModuleFactoryVar, deps);
    };
    return NgModuleCompiler;
}());
NgModuleCompiler.decorators = [
    { type: CompilerInjectable },
];
/**
 * @nocollapse
 */
NgModuleCompiler.ctorParameters = function () { return []; };
var _InjectorBuilder = (function () {
    /**
     * @param {?} _ngModuleMeta
     * @param {?} _entryComponentFactories
     * @param {?} _bootstrapComponentFactories
     * @param {?} _sourceSpan
     */
    function _InjectorBuilder(_ngModuleMeta, _entryComponentFactories, _bootstrapComponentFactories, _sourceSpan) {
        this._ngModuleMeta = _ngModuleMeta;
        this._entryComponentFactories = _entryComponentFactories;
        this._bootstrapComponentFactories = _bootstrapComponentFactories;
        this._sourceSpan = _sourceSpan;
        this.fields = [];
        this.getters = [];
        this.methods = [];
        this.ctorStmts = [];
        this._lazyProps = new Map();
        this._tokens = [];
        this._instances = new Map();
        this._createStmts = [];
        this._destroyStmts = [];
    }
    /**
     * @param {?} resolvedProvider
     * @return {?}
     */
    _InjectorBuilder.prototype.addProvider = function (resolvedProvider) {
        var _this = this;
        var /** @type {?} */ providerValueExpressions = resolvedProvider.providers.map(function (provider) { return _this._getProviderValue(provider); });
        var /** @type {?} */ propName = "_" + tokenName(resolvedProvider.token) + "_" + this._instances.size;
        var /** @type {?} */ instance = this._createProviderProperty(propName, resolvedProvider, providerValueExpressions, resolvedProvider.multiProvider, resolvedProvider.eager);
        if (resolvedProvider.lifecycleHooks.indexOf(__WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵLifecycleHooks"].OnDestroy) !== -1) {
            var /** @type {?} */ callNgOnDestroy = instance.callMethod('ngOnDestroy', []);
            if (!resolvedProvider.eager) {
                callNgOnDestroy = ((this._lazyProps.get(instance.name))).and(callNgOnDestroy);
            }
            this._destroyStmts.push(callNgOnDestroy.toStmt());
        }
        this._tokens.push(resolvedProvider.token);
        this._instances.set(tokenReference(resolvedProvider.token), instance);
    };
    /**
     * @return {?}
     */
    _InjectorBuilder.prototype.build = function () {
        var _this = this;
        var /** @type {?} */ getMethodStmts = this._tokens.map(function (token) {
            var /** @type {?} */ providerExpr = ((_this._instances.get(tokenReference(token))));
            return new IfStmt(InjectMethodVars.token.identical(createDiTokenExpression(token)), [new ReturnStatement(providerExpr)]);
        });
        var /** @type {?} */ methods = [
            new ClassMethod('createInternal', [], this._createStmts.concat(new ReturnStatement(/** @type {?} */ ((this._instances.get(this._ngModuleMeta.type.reference))))), importType(this._ngModuleMeta.type)),
            new ClassMethod('getInternal', [
                new FnParam(/** @type {?} */ ((InjectMethodVars.token.name)), DYNAMIC_TYPE),
                new FnParam(/** @type {?} */ ((InjectMethodVars.notFoundResult.name)), DYNAMIC_TYPE)
            ], getMethodStmts.concat([new ReturnStatement(InjectMethodVars.notFoundResult)]), DYNAMIC_TYPE),
            new ClassMethod('destroyInternal', [], this._destroyStmts),
        ];
        var /** @type {?} */ parentArgs = [
            variable(InjectorProps.parent.name),
            literalArr(this._entryComponentFactories.map(function (componentFactory) { return importExpr(componentFactory); })),
            literalArr(this._bootstrapComponentFactories.map(function (componentFactory) { return importExpr(componentFactory); }))
        ];
        var /** @type {?} */ injClassName = identifierName(this._ngModuleMeta.type) + "Injector";
        return createClassStmt({
            name: injClassName,
            ctorParams: [new FnParam(InjectorProps.parent.name, importType(createIdentifier(Identifiers.Injector)))],
            parent: importExpr(createIdentifier(Identifiers.NgModuleInjector), [/** @type {?} */ ((importType(this._ngModuleMeta.type)))]),
            parentArgs: parentArgs,
            builders: [{ methods: methods }, this]
        });
    };
    /**
     * @param {?} provider
     * @return {?}
     */
    _InjectorBuilder.prototype._getProviderValue = function (provider) {
        var _this = this;
        var /** @type {?} */ result;
        if (provider.useExisting != null) {
            result = this._getDependency({ token: provider.useExisting });
        }
        else if (provider.useFactory != null) {
            var /** @type {?} */ deps = provider.deps || provider.useFactory.diDeps;
            var /** @type {?} */ depsExpr = deps.map(function (dep) { return _this._getDependency(dep); });
            result = importExpr(provider.useFactory).callFn(depsExpr);
        }
        else if (provider.useClass != null) {
            var /** @type {?} */ deps = provider.deps || provider.useClass.diDeps;
            var /** @type {?} */ depsExpr = deps.map(function (dep) { return _this._getDependency(dep); });
            result =
                importExpr(provider.useClass).instantiate(depsExpr, importType(provider.useClass));
        }
        else {
            result = convertValueToOutputAst(provider.useValue);
        }
        return result;
    };
    /**
     * @param {?} propName
     * @param {?} provider
     * @param {?} providerValueExpressions
     * @param {?} isMulti
     * @param {?} isEager
     * @return {?}
     */
    _InjectorBuilder.prototype._createProviderProperty = function (propName, provider, providerValueExpressions, isMulti, isEager) {
        var /** @type {?} */ resolvedProviderValueExpr;
        var /** @type {?} */ type;
        if (isMulti) {
            resolvedProviderValueExpr = literalArr(providerValueExpressions);
            type = new ArrayType(DYNAMIC_TYPE);
        }
        else {
            resolvedProviderValueExpr = providerValueExpressions[0];
            type = ((providerValueExpressions[0].type));
        }
        if (!type) {
            type = DYNAMIC_TYPE;
        }
        if (isEager) {
            this.fields.push(new ClassField(propName, type));
            this._createStmts.push(THIS_EXPR.prop(propName).set(resolvedProviderValueExpr).toStmt());
        }
        else {
            var /** @type {?} */ internalFieldProp = THIS_EXPR.prop("_" + propName);
            this.fields.push(new ClassField(internalFieldProp.name, type));
            // Note: Equals is important for JS so that it also checks the undefined case!
            var /** @type {?} */ getterStmts = [
                new IfStmt(internalFieldProp.isBlank(), [internalFieldProp.set(resolvedProviderValueExpr).toStmt()]),
                new ReturnStatement(internalFieldProp)
            ];
            this.getters.push(new ClassGetter(propName, getterStmts, type));
            this._lazyProps.set(propName, internalFieldProp);
        }
        return THIS_EXPR.prop(propName);
    };
    /**
     * @param {?} dep
     * @return {?}
     */
    _InjectorBuilder.prototype._getDependency = function (dep) {
        var /** @type {?} */ result = ((null));
        if (dep.isValue) {
            result = literal(dep.value);
        }
        if (!dep.isSkipSelf) {
            if (dep.token) {
                if (tokenReference(dep.token) === resolveIdentifier(Identifiers.Injector)) {
                    result = THIS_EXPR;
                }
                else if (tokenReference(dep.token) === resolveIdentifier(Identifiers.ComponentFactoryResolver)) {
                    result = THIS_EXPR.prop('componentFactoryResolver');
                }
            }
            if (!result) {
                result = ((this._instances.get(tokenReference(/** @type {?} */ ((dep.token))))));
            }
        }
        if (!result) {
            var /** @type {?} */ args = [createDiTokenExpression(/** @type {?} */ ((dep.token)))];
            if (dep.isOptional) {
                args.push(NULL_EXPR);
            }
            result = InjectorProps.parent.callMethod('get', args);
        }
        return result;
    };
    return _InjectorBuilder;
}());
/**
 * @param {?} token
 * @return {?}
 */
function createDiTokenExpression(token) {
    if (token.value != null) {
        return literal(token.value);
    }
    else {
        return importExpr(/** @type {?} */ ((token.identifier)));
    }
}
var InjectorProps = (function () {
    function InjectorProps() {
    }
    return InjectorProps;
}());
InjectorProps.parent = THIS_EXPR.prop('parent');
var InjectMethodVars = (function () {
    function InjectMethodVars() {
    }
    return InjectMethodVars;
}());
InjectMethodVars.token = variable('token');
InjectMethodVars.notFoundResult = variable('notFoundResult');
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
// https://docs.google.com/document/d/1U1RGAehQwRypUTovF1KRlpiOFze0b-_2gc6fAH0KY0k/edit
var VERSION$1 = 3;
var JS_B64_PREFIX = '# sourceMappingURL=data:application/json;base64,';
var SourceMapGenerator = (function () {
    /**
     * @param {?=} file
     */
    function SourceMapGenerator(file) {
        if (file === void 0) { file = null; }
        this.file = file;
        this.sourcesContent = new Map();
        this.lines = [];
        this.lastCol0 = 0;
        this.hasMappings = false;
    }
    /**
     * @param {?} url
     * @param {?=} content
     * @return {?}
     */
    SourceMapGenerator.prototype.addSource = function (url, content) {
        if (content === void 0) { content = null; }
        if (!this.sourcesContent.has(url)) {
            this.sourcesContent.set(url, content);
        }
        return this;
    };
    /**
     * @return {?}
     */
    SourceMapGenerator.prototype.addLine = function () {
        this.lines.push([]);
        this.lastCol0 = 0;
        return this;
    };
    /**
     * @param {?} col0
     * @param {?=} sourceUrl
     * @param {?=} sourceLine0
     * @param {?=} sourceCol0
     * @return {?}
     */
    SourceMapGenerator.prototype.addMapping = function (col0, sourceUrl, sourceLine0, sourceCol0) {
        if (!this.currentLine) {
            throw new Error("A line must be added before mappings can be added");
        }
        if (sourceUrl != null && !this.sourcesContent.has(sourceUrl)) {
            throw new Error("Unknown source file \"" + sourceUrl + "\"");
        }
        if (col0 == null) {
            throw new Error("The column in the generated code must be provided");
        }
        if (col0 < this.lastCol0) {
            throw new Error("Mapping should be added in output order");
        }
        if (sourceUrl && (sourceLine0 == null || sourceCol0 == null)) {
            throw new Error("The source location must be provided when a source url is provided");
        }
        this.hasMappings = true;
        this.lastCol0 = col0;
        this.currentLine.push({ col0: col0, sourceUrl: sourceUrl, sourceLine0: sourceLine0, sourceCol0: sourceCol0 });
        return this;
    };
    Object.defineProperty(SourceMapGenerator.prototype, "currentLine", {
        /**
         * @return {?}
         */
        get: function () { return this.lines.slice(-1)[0]; },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    SourceMapGenerator.prototype.toJSON = function () {
        var _this = this;
        if (!this.hasMappings) {
            return null;
        }
        var /** @type {?} */ sourcesIndex = new Map();
        var /** @type {?} */ sources = [];
        var /** @type {?} */ sourcesContent = [];
        Array.from(this.sourcesContent.keys()).forEach(function (url, i) {
            sourcesIndex.set(url, i);
            sources.push(url);
            sourcesContent.push(_this.sourcesContent.get(url) || null);
        });
        var /** @type {?} */ mappings = '';
        var /** @type {?} */ lastCol0 = 0;
        var /** @type {?} */ lastSourceIndex = 0;
        var /** @type {?} */ lastSourceLine0 = 0;
        var /** @type {?} */ lastSourceCol0 = 0;
        this.lines.forEach(function (segments) {
            lastCol0 = 0;
            mappings += segments
                .map(function (segment) {
                // zero-based starting column of the line in the generated code
                var /** @type {?} */ segAsStr = toBase64VLQ(segment.col0 - lastCol0);
                lastCol0 = segment.col0;
                if (segment.sourceUrl != null) {
                    // zero-based index into the “sources” list
                    segAsStr +=
                        toBase64VLQ(/** @type {?} */ ((sourcesIndex.get(segment.sourceUrl))) - lastSourceIndex);
                    lastSourceIndex = ((sourcesIndex.get(segment.sourceUrl)));
                    // the zero-based starting line in the original source
                    segAsStr += toBase64VLQ(/** @type {?} */ ((segment.sourceLine0)) - lastSourceLine0);
                    lastSourceLine0 = ((segment.sourceLine0));
                    // the zero-based starting column in the original source
                    segAsStr += toBase64VLQ(/** @type {?} */ ((segment.sourceCol0)) - lastSourceCol0);
                    lastSourceCol0 = ((segment.sourceCol0));
                }
                return segAsStr;
            })
                .join(',');
            mappings += ';';
        });
        mappings = mappings.slice(0, -1);
        return {
            'file': this.file || '',
            'version': VERSION$1,
            'sourceRoot': '',
            'sources': sources,
            'sourcesContent': sourcesContent,
            'mappings': mappings,
        };
    };
    /**
     * @return {?}
     */
    SourceMapGenerator.prototype.toJsComment = function () {
        return this.hasMappings ? '//' + JS_B64_PREFIX + toBase64String(JSON.stringify(this, null, 0)) :
            '';
    };
    return SourceMapGenerator;
}());
/**
 * @param {?} value
 * @return {?}
 */
function toBase64String(value) {
    var /** @type {?} */ b64 = '';
    value = utf8Encode(value);
    for (var /** @type {?} */ i = 0; i < value.length;) {
        var /** @type {?} */ i1 = value.charCodeAt(i++);
        var /** @type {?} */ i2 = value.charCodeAt(i++);
        var /** @type {?} */ i3 = value.charCodeAt(i++);
        b64 += toBase64Digit(i1 >> 2);
        b64 += toBase64Digit(((i1 & 3) << 4) | (isNaN(i2) ? 0 : i2 >> 4));
        b64 += isNaN(i2) ? '=' : toBase64Digit(((i2 & 15) << 2) | (i3 >> 6));
        b64 += isNaN(i2) || isNaN(i3) ? '=' : toBase64Digit(i3 & 63);
    }
    return b64;
}
/**
 * @param {?} value
 * @return {?}
 */
function toBase64VLQ(value) {
    value = value < 0 ? ((-value) << 1) + 1 : value << 1;
    var /** @type {?} */ out = '';
    do {
        var /** @type {?} */ digit = value & 31;
        value = value >> 5;
        if (value > 0) {
            digit = digit | 32;
        }
        out += toBase64Digit(digit);
    } while (value > 0);
    return out;
}
var B64_DIGITS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
/**
 * @param {?} value
 * @return {?}
 */
function toBase64Digit(value) {
    if (value < 0 || value >= 64) {
        throw new Error("Can only encode value in the range [0, 63]");
    }
    return B64_DIGITS[value];
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var _SINGLE_QUOTE_ESCAPE_STRING_RE = /'|\\|\n|\r|\$/g;
var _LEGAL_IDENTIFIER_RE = /^[$A-Z_][0-9A-Z_$]*$/i;
var _INDENT_WITH = '  ';
var CATCH_ERROR_VAR$1 = variable('error', null, null);
var CATCH_STACK_VAR$1 = variable('stack', null, null);
/**
 * @abstract
 */
var _EmittedLine = (function () {
    /**
     * @param {?} indent
     */
    function _EmittedLine(indent) {
        this.indent = indent;
        this.parts = [];
        this.srcSpans = [];
    }
    return _EmittedLine;
}());
var EmitterVisitorContext = (function () {
    /**
     * @param {?} _exportedVars
     * @param {?} _indent
     */
    function EmitterVisitorContext(_exportedVars, _indent) {
        this._exportedVars = _exportedVars;
        this._indent = _indent;
        this._classes = [];
        this._lines = [new _EmittedLine(_indent)];
    }
    /**
     * @param {?} exportedVars
     * @return {?}
     */
    EmitterVisitorContext.createRoot = function (exportedVars) {
        return new EmitterVisitorContext(exportedVars, 0);
    };
    Object.defineProperty(EmitterVisitorContext.prototype, "_currentLine", {
        /**
         * @return {?}
         */
        get: function () { return this._lines[this._lines.length - 1]; },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} varName
     * @return {?}
     */
    EmitterVisitorContext.prototype.isExportedVar = function (varName) { return this._exportedVars.indexOf(varName) !== -1; };
    /**
     * @param {?=} from
     * @param {?=} lastPart
     * @return {?}
     */
    EmitterVisitorContext.prototype.println = function (from, lastPart) {
        if (lastPart === void 0) { lastPart = ''; }
        this.print(from || null, lastPart, true);
    };
    /**
     * @return {?}
     */
    EmitterVisitorContext.prototype.lineIsEmpty = function () { return this._currentLine.parts.length === 0; };
    /**
     * @param {?} from
     * @param {?} part
     * @param {?=} newLine
     * @return {?}
     */
    EmitterVisitorContext.prototype.print = function (from, part, newLine) {
        if (newLine === void 0) { newLine = false; }
        if (part.length > 0) {
            this._currentLine.parts.push(part);
            this._currentLine.srcSpans.push(from && from.sourceSpan || null);
        }
        if (newLine) {
            this._lines.push(new _EmittedLine(this._indent));
        }
    };
    /**
     * @return {?}
     */
    EmitterVisitorContext.prototype.removeEmptyLastLine = function () {
        if (this.lineIsEmpty()) {
            this._lines.pop();
        }
    };
    /**
     * @return {?}
     */
    EmitterVisitorContext.prototype.incIndent = function () {
        this._indent++;
        this._currentLine.indent = this._indent;
    };
    /**
     * @return {?}
     */
    EmitterVisitorContext.prototype.decIndent = function () {
        this._indent--;
        this._currentLine.indent = this._indent;
    };
    /**
     * @param {?} clazz
     * @return {?}
     */
    EmitterVisitorContext.prototype.pushClass = function (clazz) { this._classes.push(clazz); };
    /**
     * @return {?}
     */
    EmitterVisitorContext.prototype.popClass = function () { return ((this._classes.pop())); };
    Object.defineProperty(EmitterVisitorContext.prototype, "currentClass", {
        /**
         * @return {?}
         */
        get: function () {
            return this._classes.length > 0 ? this._classes[this._classes.length - 1] : null;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    EmitterVisitorContext.prototype.toSource = function () {
        return this.sourceLines
            .map(function (l) { return l.parts.length > 0 ? _createIndent(l.indent) + l.parts.join('') : ''; })
            .join('\n');
    };
    /**
     * @param {?} sourceFilePath
     * @param {?} genFilePath
     * @param {?=} startsAtLine
     * @return {?}
     */
    EmitterVisitorContext.prototype.toSourceMapGenerator = function (sourceFilePath, genFilePath, startsAtLine) {
        if (startsAtLine === void 0) { startsAtLine = 0; }
        var /** @type {?} */ map = new SourceMapGenerator(genFilePath);
        var /** @type {?} */ firstOffsetMapped = false;
        var /** @type {?} */ mapFirstOffsetIfNeeded = function () {
            if (!firstOffsetMapped) {
                // Add a single space so that tools won't try to load the file from disk.
                // Note: We are using virtual urls like `ng:///`, so we have to
                // provide a content here.
                map.addSource(sourceFilePath, ' ').addMapping(0, sourceFilePath, 0, 0);
                firstOffsetMapped = true;
            }
        };
        for (var /** @type {?} */ i = 0; i < startsAtLine; i++) {
            map.addLine();
            mapFirstOffsetIfNeeded();
        }
        this.sourceLines.forEach(function (line, lineIdx) {
            map.addLine();
            var /** @type {?} */ spans = line.srcSpans;
            var /** @type {?} */ parts = line.parts;
            var /** @type {?} */ col0 = line.indent * _INDENT_WITH.length;
            var /** @type {?} */ spanIdx = 0;
            // skip leading parts without source spans
            while (spanIdx < spans.length && !spans[spanIdx]) {
                col0 += parts[spanIdx].length;
                spanIdx++;
            }
            if (spanIdx < spans.length && lineIdx === 0 && col0 === 0) {
                firstOffsetMapped = true;
            }
            else {
                mapFirstOffsetIfNeeded();
            }
            while (spanIdx < spans.length) {
                var /** @type {?} */ span = ((spans[spanIdx]));
                var /** @type {?} */ source = span.start.file;
                var /** @type {?} */ sourceLine = span.start.line;
                var /** @type {?} */ sourceCol = span.start.col;
                map.addSource(source.url, source.content)
                    .addMapping(col0, source.url, sourceLine, sourceCol);
                col0 += parts[spanIdx].length;
                spanIdx++;
                // assign parts without span or the same span to the previous segment
                while (spanIdx < spans.length && (span === spans[spanIdx] || !spans[spanIdx])) {
                    col0 += parts[spanIdx].length;
                    spanIdx++;
                }
            }
        });
        return map;
    };
    Object.defineProperty(EmitterVisitorContext.prototype, "sourceLines", {
        /**
         * @return {?}
         */
        get: function () {
            if (this._lines.length && this._lines[this._lines.length - 1].parts.length === 0) {
                return this._lines.slice(0, -1);
            }
            return this._lines;
        },
        enumerable: true,
        configurable: true
    });
    return EmitterVisitorContext;
}());
/**
 * @abstract
 */
var AbstractEmitterVisitor = (function () {
    /**
     * @param {?} _escapeDollarInStrings
     */
    function AbstractEmitterVisitor(_escapeDollarInStrings) {
        this._escapeDollarInStrings = _escapeDollarInStrings;
    }
    /**
     * @param {?} stmt
     * @param {?} ctx
     * @return {?}
     */
    AbstractEmitterVisitor.prototype.visitExpressionStmt = function (stmt, ctx) {
        stmt.expr.visitExpression(this, ctx);
        ctx.println(stmt, ';');
        return null;
    };
    /**
     * @param {?} stmt
     * @param {?} ctx
     * @return {?}
     */
    AbstractEmitterVisitor.prototype.visitReturnStmt = function (stmt, ctx) {
        ctx.print(stmt, "return ");
        stmt.value.visitExpression(this, ctx);
        ctx.println(stmt, ';');
        return null;
    };
    /**
     * @abstract
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    AbstractEmitterVisitor.prototype.visitCastExpr = function (ast, context) { };
    /**
     * @abstract
     * @param {?} stmt
     * @param {?} ctx
     * @return {?}
     */
    AbstractEmitterVisitor.prototype.visitDeclareClassStmt = function (stmt, ctx) { };
    /**
     * @param {?} stmt
     * @param {?} ctx
     * @return {?}
     */
    AbstractEmitterVisitor.prototype.visitIfStmt = function (stmt, ctx) {
        ctx.print(stmt, "if (");
        stmt.condition.visitExpression(this, ctx);
        ctx.print(stmt, ") {");
        var /** @type {?} */ hasElseCase = stmt.falseCase != null && stmt.falseCase.length > 0;
        if (stmt.trueCase.length <= 1 && !hasElseCase) {
            ctx.print(stmt, " ");
            this.visitAllStatements(stmt.trueCase, ctx);
            ctx.removeEmptyLastLine();
            ctx.print(stmt, " ");
        }
        else {
            ctx.println();
            ctx.incIndent();
            this.visitAllStatements(stmt.trueCase, ctx);
            ctx.decIndent();
            if (hasElseCase) {
                ctx.println(stmt, "} else {");
                ctx.incIndent();
                this.visitAllStatements(stmt.falseCase, ctx);
                ctx.decIndent();
            }
        }
        ctx.println(stmt, "}");
        return null;
    };
    /**
     * @abstract
     * @param {?} stmt
     * @param {?} ctx
     * @return {?}
     */
    AbstractEmitterVisitor.prototype.visitTryCatchStmt = function (stmt, ctx) { };
    /**
     * @param {?} stmt
     * @param {?} ctx
     * @return {?}
     */
    AbstractEmitterVisitor.prototype.visitThrowStmt = function (stmt, ctx) {
        ctx.print(stmt, "throw ");
        stmt.error.visitExpression(this, ctx);
        ctx.println(stmt, ";");
        return null;
    };
    /**
     * @param {?} stmt
     * @param {?} ctx
     * @return {?}
     */
    AbstractEmitterVisitor.prototype.visitCommentStmt = function (stmt, ctx) {
        var /** @type {?} */ lines = stmt.comment.split('\n');
        lines.forEach(function (line) { ctx.println(stmt, "// " + line); });
        return null;
    };
    /**
     * @abstract
     * @param {?} stmt
     * @param {?} ctx
     * @return {?}
     */
    AbstractEmitterVisitor.prototype.visitDeclareVarStmt = function (stmt, ctx) { };
    /**
     * @param {?} expr
     * @param {?} ctx
     * @return {?}
     */
    AbstractEmitterVisitor.prototype.visitWriteVarExpr = function (expr, ctx) {
        var /** @type {?} */ lineWasEmpty = ctx.lineIsEmpty();
        if (!lineWasEmpty) {
            ctx.print(expr, '(');
        }
        ctx.print(expr, expr.name + " = ");
        expr.value.visitExpression(this, ctx);
        if (!lineWasEmpty) {
            ctx.print(expr, ')');
        }
        return null;
    };
    /**
     * @param {?} expr
     * @param {?} ctx
     * @return {?}
     */
    AbstractEmitterVisitor.prototype.visitWriteKeyExpr = function (expr, ctx) {
        var /** @type {?} */ lineWasEmpty = ctx.lineIsEmpty();
        if (!lineWasEmpty) {
            ctx.print(expr, '(');
        }
        expr.receiver.visitExpression(this, ctx);
        ctx.print(expr, "[");
        expr.index.visitExpression(this, ctx);
        ctx.print(expr, "] = ");
        expr.value.visitExpression(this, ctx);
        if (!lineWasEmpty) {
            ctx.print(expr, ')');
        }
        return null;
    };
    /**
     * @param {?} expr
     * @param {?} ctx
     * @return {?}
     */
    AbstractEmitterVisitor.prototype.visitWritePropExpr = function (expr, ctx) {
        var /** @type {?} */ lineWasEmpty = ctx.lineIsEmpty();
        if (!lineWasEmpty) {
            ctx.print(expr, '(');
        }
        expr.receiver.visitExpression(this, ctx);
        ctx.print(expr, "." + expr.name + " = ");
        expr.value.visitExpression(this, ctx);
        if (!lineWasEmpty) {
            ctx.print(expr, ')');
        }
        return null;
    };
    /**
     * @param {?} expr
     * @param {?} ctx
     * @return {?}
     */
    AbstractEmitterVisitor.prototype.visitInvokeMethodExpr = function (expr, ctx) {
        expr.receiver.visitExpression(this, ctx);
        var /** @type {?} */ name = expr.name;
        if (expr.builtin != null) {
            name = this.getBuiltinMethodName(expr.builtin);
            if (name == null) {
                // some builtins just mean to skip the call.
                return null;
            }
        }
        ctx.print(expr, "." + name + "(");
        this.visitAllExpressions(expr.args, ctx, ",");
        ctx.print(expr, ")");
        return null;
    };
    /**
     * @abstract
     * @param {?} method
     * @return {?}
     */
    AbstractEmitterVisitor.prototype.getBuiltinMethodName = function (method) { };
    /**
     * @param {?} expr
     * @param {?} ctx
     * @return {?}
     */
    AbstractEmitterVisitor.prototype.visitInvokeFunctionExpr = function (expr, ctx) {
        expr.fn.visitExpression(this, ctx);
        ctx.print(expr, "(");
        this.visitAllExpressions(expr.args, ctx, ',');
        ctx.print(expr, ")");
        return null;
    };
    /**
     * @param {?} ast
     * @param {?} ctx
     * @return {?}
     */
    AbstractEmitterVisitor.prototype.visitReadVarExpr = function (ast, ctx) {
        var /** @type {?} */ varName = ((ast.name));
        if (ast.builtin != null) {
            switch (ast.builtin) {
                case BuiltinVar.Super:
                    varName = 'super';
                    break;
                case BuiltinVar.This:
                    varName = 'this';
                    break;
                case BuiltinVar.CatchError:
                    varName = ((CATCH_ERROR_VAR$1.name));
                    break;
                case BuiltinVar.CatchStack:
                    varName = ((CATCH_STACK_VAR$1.name));
                    break;
                default:
                    throw new Error("Unknown builtin variable " + ast.builtin);
            }
        }
        ctx.print(ast, varName);
        return null;
    };
    /**
     * @param {?} ast
     * @param {?} ctx
     * @return {?}
     */
    AbstractEmitterVisitor.prototype.visitInstantiateExpr = function (ast, ctx) {
        ctx.print(ast, "new ");
        ast.classExpr.visitExpression(this, ctx);
        ctx.print(ast, "(");
        this.visitAllExpressions(ast.args, ctx, ',');
        ctx.print(ast, ")");
        return null;
    };
    /**
     * @param {?} ast
     * @param {?} ctx
     * @return {?}
     */
    AbstractEmitterVisitor.prototype.visitLiteralExpr = function (ast, ctx) {
        var /** @type {?} */ value = ast.value;
        if (typeof value === 'string') {
            ctx.print(ast, escapeIdentifier(value, this._escapeDollarInStrings));
        }
        else {
            ctx.print(ast, "" + value);
        }
        return null;
    };
    /**
     * @abstract
     * @param {?} ast
     * @param {?} ctx
     * @return {?}
     */
    AbstractEmitterVisitor.prototype.visitExternalExpr = function (ast, ctx) { };
    /**
     * @param {?} ast
     * @param {?} ctx
     * @return {?}
     */
    AbstractEmitterVisitor.prototype.visitConditionalExpr = function (ast, ctx) {
        ctx.print(ast, "(");
        ast.condition.visitExpression(this, ctx);
        ctx.print(ast, '? ');
        ast.trueCase.visitExpression(this, ctx);
        ctx.print(ast, ': '); /** @type {?} */
        ((ast.falseCase)).visitExpression(this, ctx);
        ctx.print(ast, ")");
        return null;
    };
    /**
     * @param {?} ast
     * @param {?} ctx
     * @return {?}
     */
    AbstractEmitterVisitor.prototype.visitNotExpr = function (ast, ctx) {
        ctx.print(ast, '!');
        ast.condition.visitExpression(this, ctx);
        return null;
    };
    /**
     * @abstract
     * @param {?} ast
     * @param {?} ctx
     * @return {?}
     */
    AbstractEmitterVisitor.prototype.visitFunctionExpr = function (ast, ctx) { };
    /**
     * @abstract
     * @param {?} stmt
     * @param {?} context
     * @return {?}
     */
    AbstractEmitterVisitor.prototype.visitDeclareFunctionStmt = function (stmt, context) { };
    /**
     * @param {?} ast
     * @param {?} ctx
     * @return {?}
     */
    AbstractEmitterVisitor.prototype.visitBinaryOperatorExpr = function (ast, ctx) {
        var /** @type {?} */ opStr;
        switch (ast.operator) {
            case BinaryOperator.Equals:
                opStr = '==';
                break;
            case BinaryOperator.Identical:
                opStr = '===';
                break;
            case BinaryOperator.NotEquals:
                opStr = '!=';
                break;
            case BinaryOperator.NotIdentical:
                opStr = '!==';
                break;
            case BinaryOperator.And:
                opStr = '&&';
                break;
            case BinaryOperator.Or:
                opStr = '||';
                break;
            case BinaryOperator.Plus:
                opStr = '+';
                break;
            case BinaryOperator.Minus:
                opStr = '-';
                break;
            case BinaryOperator.Divide:
                opStr = '/';
                break;
            case BinaryOperator.Multiply:
                opStr = '*';
                break;
            case BinaryOperator.Modulo:
                opStr = '%';
                break;
            case BinaryOperator.Lower:
                opStr = '<';
                break;
            case BinaryOperator.LowerEquals:
                opStr = '<=';
                break;
            case BinaryOperator.Bigger:
                opStr = '>';
                break;
            case BinaryOperator.BiggerEquals:
                opStr = '>=';
                break;
            default:
                throw new Error("Unknown operator " + ast.operator);
        }
        ctx.print(ast, "(");
        ast.lhs.visitExpression(this, ctx);
        ctx.print(ast, " " + opStr + " ");
        ast.rhs.visitExpression(this, ctx);
        ctx.print(ast, ")");
        return null;
    };
    /**
     * @param {?} ast
     * @param {?} ctx
     * @return {?}
     */
    AbstractEmitterVisitor.prototype.visitReadPropExpr = function (ast, ctx) {
        ast.receiver.visitExpression(this, ctx);
        ctx.print(ast, ".");
        ctx.print(ast, ast.name);
        return null;
    };
    /**
     * @param {?} ast
     * @param {?} ctx
     * @return {?}
     */
    AbstractEmitterVisitor.prototype.visitReadKeyExpr = function (ast, ctx) {
        ast.receiver.visitExpression(this, ctx);
        ctx.print(ast, "[");
        ast.index.visitExpression(this, ctx);
        ctx.print(ast, "]");
        return null;
    };
    /**
     * @param {?} ast
     * @param {?} ctx
     * @return {?}
     */
    AbstractEmitterVisitor.prototype.visitLiteralArrayExpr = function (ast, ctx) {
        var /** @type {?} */ useNewLine = ast.entries.length > 1;
        ctx.print(ast, "[", useNewLine);
        ctx.incIndent();
        this.visitAllExpressions(ast.entries, ctx, ',', useNewLine);
        ctx.decIndent();
        ctx.print(ast, "]", useNewLine);
        return null;
    };
    /**
     * @param {?} ast
     * @param {?} ctx
     * @return {?}
     */
    AbstractEmitterVisitor.prototype.visitLiteralMapExpr = function (ast, ctx) {
        var _this = this;
        var /** @type {?} */ useNewLine = ast.entries.length > 1;
        ctx.print(ast, "{", useNewLine);
        ctx.incIndent();
        this.visitAllObjects(function (entry) {
            ctx.print(ast, escapeIdentifier(entry.key, _this._escapeDollarInStrings, entry.quoted) + ": ");
            entry.value.visitExpression(_this, ctx);
        }, ast.entries, ctx, ',', useNewLine);
        ctx.decIndent();
        ctx.print(ast, "}", useNewLine);
        return null;
    };
    /**
     * @param {?} ast
     * @param {?} ctx
     * @return {?}
     */
    AbstractEmitterVisitor.prototype.visitCommaExpr = function (ast, ctx) {
        ctx.print(ast, '(');
        this.visitAllExpressions(ast.parts, ctx, ',');
        ctx.print(ast, ')');
        return null;
    };
    /**
     * @param {?} expressions
     * @param {?} ctx
     * @param {?} separator
     * @param {?=} newLine
     * @return {?}
     */
    AbstractEmitterVisitor.prototype.visitAllExpressions = function (expressions, ctx, separator, newLine) {
        var _this = this;
        if (newLine === void 0) { newLine = false; }
        this.visitAllObjects(function (expr) { return expr.visitExpression(_this, ctx); }, expressions, ctx, separator, newLine);
    };
    /**
     * @template T
     * @param {?} handler
     * @param {?} expressions
     * @param {?} ctx
     * @param {?} separator
     * @param {?=} newLine
     * @return {?}
     */
    AbstractEmitterVisitor.prototype.visitAllObjects = function (handler, expressions, ctx, separator, newLine) {
        if (newLine === void 0) { newLine = false; }
        for (var /** @type {?} */ i = 0; i < expressions.length; i++) {
            if (i > 0) {
                ctx.print(null, separator, newLine);
            }
            handler(expressions[i]);
        }
        if (newLine) {
            ctx.println();
        }
    };
    /**
     * @param {?} statements
     * @param {?} ctx
     * @return {?}
     */
    AbstractEmitterVisitor.prototype.visitAllStatements = function (statements, ctx) {
        var _this = this;
        statements.forEach(function (stmt) { return stmt.visitStatement(_this, ctx); });
    };
    return AbstractEmitterVisitor;
}());
/**
 * @param {?} input
 * @param {?} escapeDollar
 * @param {?=} alwaysQuote
 * @return {?}
 */
function escapeIdentifier(input, escapeDollar, alwaysQuote) {
    if (alwaysQuote === void 0) { alwaysQuote = true; }
    if (input == null) {
        return null;
    }
    var /** @type {?} */ body = input.replace(_SINGLE_QUOTE_ESCAPE_STRING_RE, function () {
        var match = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            match[_i] = arguments[_i];
        }
        if (match[0] == '$') {
            return escapeDollar ? '\\$' : '$';
        }
        else if (match[0] == '\n') {
            return '\\n';
        }
        else if (match[0] == '\r') {
            return '\\r';
        }
        else {
            return "\\" + match[0];
        }
    });
    var /** @type {?} */ requiresQuotes = alwaysQuote || !_LEGAL_IDENTIFIER_RE.test(body);
    return requiresQuotes ? "'" + body + "'" : body;
}
/**
 * @param {?} count
 * @return {?}
 */
function _createIndent(count) {
    var /** @type {?} */ res = '';
    for (var /** @type {?} */ i = 0; i < count; i++) {
        res += _INDENT_WITH;
    }
    return res;
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var _debugFilePath = '/debug/lib';
/**
 * @param {?} ast
 * @return {?}
 */
function debugOutputAstAsTypeScript(ast) {
    var /** @type {?} */ converter = new _TsEmitterVisitor(_debugFilePath, {
        /**
         * @param {?} filePath
         * @param {?} containingFilePath
         * @return {?}
         */
        fileNameToModuleName: function (filePath, containingFilePath) { return filePath; },
        /**
         * @param {?} symbol
         * @return {?}
         */
        getImportAs: function (symbol) { return null; },
        getTypeArity: function (symbol) { return null; }
    });
    var /** @type {?} */ ctx = EmitterVisitorContext.createRoot([]);
    var /** @type {?} */ asts = Array.isArray(ast) ? ast : [ast];
    asts.forEach(function (ast) {
        if (ast instanceof Statement) {
            ast.visitStatement(converter, ctx);
        }
        else if (ast instanceof Expression) {
            ast.visitExpression(converter, ctx);
        }
        else if (ast instanceof Type$1) {
            ast.visitType(converter, ctx);
        }
        else {
            throw new Error("Don't know how to print debug info for " + ast);
        }
    });
    return ctx.toSource();
}
var TypeScriptEmitter = (function () {
    /**
     * @param {?} _importResolver
     */
    function TypeScriptEmitter(_importResolver) {
        this._importResolver = _importResolver;
    }
    /**
     * @param {?} srcFilePath
     * @param {?} genFilePath
     * @param {?} stmts
     * @param {?} exportedVars
     * @param {?=} preamble
     * @return {?}
     */
    TypeScriptEmitter.prototype.emitStatements = function (srcFilePath, genFilePath, stmts, exportedVars, preamble) {
        var _this = this;
        if (preamble === void 0) { preamble = ''; }
        var /** @type {?} */ converter = new _TsEmitterVisitor(genFilePath, this._importResolver);
        var /** @type {?} */ ctx = EmitterVisitorContext.createRoot(exportedVars);
        converter.visitAllStatements(stmts, ctx);
        var /** @type {?} */ preambleLines = preamble ? preamble.split('\n') : [];
        converter.reexports.forEach(function (reexports, exportedFilePath) {
            var /** @type {?} */ reexportsCode = reexports.map(function (reexport) { return reexport.name + " as " + reexport.as; }).join(',');
            preambleLines.push("export {" + reexportsCode + "} from '" + _this._importResolver.fileNameToModuleName(exportedFilePath, genFilePath) + "';");
        });
        converter.importsWithPrefixes.forEach(function (prefix, importedFilePath) {
            // Note: can't write the real word for import as it screws up system.js auto detection...
            preambleLines.push("imp" +
                ("ort * as " + prefix + " from '" + _this._importResolver.fileNameToModuleName(importedFilePath, genFilePath) + "';"));
        });
        var /** @type {?} */ sm = ctx.toSourceMapGenerator(srcFilePath, genFilePath, preambleLines.length).toJsComment();
        var /** @type {?} */ lines = preambleLines.concat([ctx.toSource(), sm]);
        if (sm) {
            // always add a newline at the end, as some tools have bugs without it.
            lines.push('');
        }
        return lines.join('\n');
    };
    return TypeScriptEmitter;
}());
var _TsEmitterVisitor = (function (_super) {
    __extends(_TsEmitterVisitor, _super);
    /**
     * @param {?} _genFilePath
     * @param {?} _importResolver
     */
    function _TsEmitterVisitor(_genFilePath, _importResolver) {
        var _this = _super.call(this, false) || this;
        _this._genFilePath = _genFilePath;
        _this._importResolver = _importResolver;
        _this.typeExpression = 0;
        _this.importsWithPrefixes = new Map();
        _this.reexports = new Map();
        return _this;
    }
    /**
     * @param {?} t
     * @param {?} ctx
     * @param {?=} defaultType
     * @return {?}
     */
    _TsEmitterVisitor.prototype.visitType = function (t, ctx, defaultType) {
        if (defaultType === void 0) { defaultType = 'any'; }
        if (t) {
            this.typeExpression++;
            t.visitType(this, ctx);
            this.typeExpression--;
        }
        else {
            ctx.print(null, defaultType);
        }
    };
    /**
     * @param {?} ast
     * @param {?} ctx
     * @return {?}
     */
    _TsEmitterVisitor.prototype.visitLiteralExpr = function (ast, ctx) {
        var /** @type {?} */ value = ast.value;
        if (value == null && ast.type != INFERRED_TYPE) {
            ctx.print(ast, "(" + value + " as any)");
            return null;
        }
        return _super.prototype.visitLiteralExpr.call(this, ast, ctx);
    };
    /**
     * @param {?} ast
     * @param {?} ctx
     * @return {?}
     */
    _TsEmitterVisitor.prototype.visitLiteralArrayExpr = function (ast, ctx) {
        if (ast.entries.length === 0) {
            ctx.print(ast, '(');
        }
        var /** @type {?} */ result = _super.prototype.visitLiteralArrayExpr.call(this, ast, ctx);
        if (ast.entries.length === 0) {
            ctx.print(ast, ' as any[])');
        }
        return result;
    };
    /**
     * @param {?} ast
     * @param {?} ctx
     * @return {?}
     */
    _TsEmitterVisitor.prototype.visitExternalExpr = function (ast, ctx) {
        this._visitIdentifier(ast.value, ast.typeParams, ctx);
        return null;
    };
    /**
     * @param {?} stmt
     * @param {?} ctx
     * @return {?}
     */
    _TsEmitterVisitor.prototype.visitDeclareVarStmt = function (stmt, ctx) {
        if (ctx.isExportedVar(stmt.name) && stmt.value instanceof ExternalExpr && !stmt.type) {
            // check for a reexport
            var _a = this._resolveStaticSymbol(stmt.value.value), name = _a.name, filePath = _a.filePath, members = _a.members;
            if (((members)).length === 0 && filePath !== this._genFilePath) {
                var /** @type {?} */ reexports = this.reexports.get(filePath);
                if (!reexports) {
                    reexports = [];
                    this.reexports.set(filePath, reexports);
                }
                reexports.push({ name: name, as: stmt.name });
                return null;
            }
        }
        if (ctx.isExportedVar(stmt.name)) {
            ctx.print(stmt, "export ");
        }
        if (stmt.hasModifier(StmtModifier.Final)) {
            ctx.print(stmt, "const");
        }
        else {
            ctx.print(stmt, "var");
        }
        ctx.print(stmt, " " + stmt.name);
        this._printColonType(stmt.type, ctx);
        ctx.print(stmt, " = ");
        stmt.value.visitExpression(this, ctx);
        ctx.println(stmt, ";");
        return null;
    };
    /**
     * @param {?} ast
     * @param {?} ctx
     * @return {?}
     */
    _TsEmitterVisitor.prototype.visitCastExpr = function (ast, ctx) {
        ctx.print(ast, "(<"); /** @type {?} */
        ((ast.type)).visitType(this, ctx);
        ctx.print(ast, ">");
        ast.value.visitExpression(this, ctx);
        ctx.print(ast, ")");
        return null;
    };
    /**
     * @param {?} ast
     * @param {?} ctx
     * @return {?}
     */
    _TsEmitterVisitor.prototype.visitInstantiateExpr = function (ast, ctx) {
        ctx.print(ast, "new ");
        this.typeExpression++;
        ast.classExpr.visitExpression(this, ctx);
        this.typeExpression--;
        ctx.print(ast, "(");
        this.visitAllExpressions(ast.args, ctx, ',');
        ctx.print(ast, ")");
        return null;
    };
    /**
     * @param {?} stmt
     * @param {?} ctx
     * @return {?}
     */
    _TsEmitterVisitor.prototype.visitDeclareClassStmt = function (stmt, ctx) {
        var _this = this;
        ctx.pushClass(stmt);
        if (ctx.isExportedVar(stmt.name)) {
            ctx.print(stmt, "export ");
        }
        ctx.print(stmt, "class " + stmt.name);
        if (stmt.parent != null) {
            ctx.print(stmt, " extends ");
            this.typeExpression++;
            stmt.parent.visitExpression(this, ctx);
            this.typeExpression--;
        }
        ctx.println(stmt, " {");
        ctx.incIndent();
        stmt.fields.forEach(function (field) { return _this._visitClassField(field, ctx); });
        if (stmt.constructorMethod != null) {
            this._visitClassConstructor(stmt, ctx);
        }
        stmt.getters.forEach(function (getter) { return _this._visitClassGetter(getter, ctx); });
        stmt.methods.forEach(function (method) { return _this._visitClassMethod(method, ctx); });
        ctx.decIndent();
        ctx.println(stmt, "}");
        ctx.popClass();
        return null;
    };
    /**
     * @param {?} field
     * @param {?} ctx
     * @return {?}
     */
    _TsEmitterVisitor.prototype._visitClassField = function (field, ctx) {
        if (field.hasModifier(StmtModifier.Private)) {
            // comment out as a workaround for #10967
            ctx.print(null, "/*private*/ ");
        }
        ctx.print(null, field.name);
        this._printColonType(field.type, ctx);
        ctx.println(null, ";");
    };
    /**
     * @param {?} getter
     * @param {?} ctx
     * @return {?}
     */
    _TsEmitterVisitor.prototype._visitClassGetter = function (getter, ctx) {
        if (getter.hasModifier(StmtModifier.Private)) {
            ctx.print(null, "private ");
        }
        ctx.print(null, "get " + getter.name + "()");
        this._printColonType(getter.type, ctx);
        ctx.println(null, " {");
        ctx.incIndent();
        this.visitAllStatements(getter.body, ctx);
        ctx.decIndent();
        ctx.println(null, "}");
    };
    /**
     * @param {?} stmt
     * @param {?} ctx
     * @return {?}
     */
    _TsEmitterVisitor.prototype._visitClassConstructor = function (stmt, ctx) {
        ctx.print(stmt, "constructor(");
        this._visitParams(stmt.constructorMethod.params, ctx);
        ctx.println(stmt, ") {");
        ctx.incIndent();
        this.visitAllStatements(stmt.constructorMethod.body, ctx);
        ctx.decIndent();
        ctx.println(stmt, "}");
    };
    /**
     * @param {?} method
     * @param {?} ctx
     * @return {?}
     */
    _TsEmitterVisitor.prototype._visitClassMethod = function (method, ctx) {
        if (method.hasModifier(StmtModifier.Private)) {
            ctx.print(null, "private ");
        }
        ctx.print(null, method.name + "(");
        this._visitParams(method.params, ctx);
        ctx.print(null, ")");
        this._printColonType(method.type, ctx, 'void');
        ctx.println(null, " {");
        ctx.incIndent();
        this.visitAllStatements(method.body, ctx);
        ctx.decIndent();
        ctx.println(null, "}");
    };
    /**
     * @param {?} ast
     * @param {?} ctx
     * @return {?}
     */
    _TsEmitterVisitor.prototype.visitFunctionExpr = function (ast, ctx) {
        ctx.print(ast, "(");
        this._visitParams(ast.params, ctx);
        ctx.print(ast, ")");
        this._printColonType(ast.type, ctx, 'void');
        ctx.println(ast, " => {");
        ctx.incIndent();
        this.visitAllStatements(ast.statements, ctx);
        ctx.decIndent();
        ctx.print(ast, "}");
        return null;
    };
    /**
     * @param {?} stmt
     * @param {?} ctx
     * @return {?}
     */
    _TsEmitterVisitor.prototype.visitDeclareFunctionStmt = function (stmt, ctx) {
        if (ctx.isExportedVar(stmt.name)) {
            ctx.print(stmt, "export ");
        }
        ctx.print(stmt, "function " + stmt.name + "(");
        this._visitParams(stmt.params, ctx);
        ctx.print(stmt, ")");
        this._printColonType(stmt.type, ctx, 'void');
        ctx.println(stmt, " {");
        ctx.incIndent();
        this.visitAllStatements(stmt.statements, ctx);
        ctx.decIndent();
        ctx.println(stmt, "}");
        return null;
    };
    /**
     * @param {?} stmt
     * @param {?} ctx
     * @return {?}
     */
    _TsEmitterVisitor.prototype.visitTryCatchStmt = function (stmt, ctx) {
        ctx.println(stmt, "try {");
        ctx.incIndent();
        this.visitAllStatements(stmt.bodyStmts, ctx);
        ctx.decIndent();
        ctx.println(stmt, "} catch (" + CATCH_ERROR_VAR$1.name + ") {");
        ctx.incIndent();
        var /** @type {?} */ catchStmts = [/** @type {?} */ (CATCH_STACK_VAR$1.set(CATCH_ERROR_VAR$1.prop('stack', null)).toDeclStmt(null, [
                StmtModifier.Final
            ]))].concat(stmt.catchStmts);
        this.visitAllStatements(catchStmts, ctx);
        ctx.decIndent();
        ctx.println(stmt, "}");
        return null;
    };
    /**
     * @param {?} type
     * @param {?} ctx
     * @return {?}
     */
    _TsEmitterVisitor.prototype.visitBuiltintType = function (type, ctx) {
        var /** @type {?} */ typeStr;
        switch (type.name) {
            case BuiltinTypeName.Bool:
                typeStr = 'boolean';
                break;
            case BuiltinTypeName.Dynamic:
                typeStr = 'any';
                break;
            case BuiltinTypeName.Function:
                typeStr = 'Function';
                break;
            case BuiltinTypeName.Number:
                typeStr = 'number';
                break;
            case BuiltinTypeName.Int:
                typeStr = 'number';
                break;
            case BuiltinTypeName.String:
                typeStr = 'string';
                break;
            default:
                throw new Error("Unsupported builtin type " + type.name);
        }
        ctx.print(null, typeStr);
        return null;
    };
    /**
     * @param {?} ast
     * @param {?} ctx
     * @return {?}
     */
    _TsEmitterVisitor.prototype.visitExpressionType = function (ast, ctx) {
        ast.value.visitExpression(this, ctx);
        return null;
    };
    /**
     * @param {?} type
     * @param {?} ctx
     * @return {?}
     */
    _TsEmitterVisitor.prototype.visitArrayType = function (type, ctx) {
        this.visitType(type.of, ctx);
        ctx.print(null, "[]");
        return null;
    };
    /**
     * @param {?} type
     * @param {?} ctx
     * @return {?}
     */
    _TsEmitterVisitor.prototype.visitMapType = function (type, ctx) {
        ctx.print(null, "{[key: string]:");
        this.visitType(type.valueType, ctx);
        ctx.print(null, "}");
        return null;
    };
    /**
     * @param {?} method
     * @return {?}
     */
    _TsEmitterVisitor.prototype.getBuiltinMethodName = function (method) {
        var /** @type {?} */ name;
        switch (method) {
            case BuiltinMethod.ConcatArray:
                name = 'concat';
                break;
            case BuiltinMethod.SubscribeObservable:
                name = 'subscribe';
                break;
            case BuiltinMethod.Bind:
                name = 'bind';
                break;
            default:
                throw new Error("Unknown builtin method: " + method);
        }
        return name;
    };
    /**
     * @param {?} params
     * @param {?} ctx
     * @return {?}
     */
    _TsEmitterVisitor.prototype._visitParams = function (params, ctx) {
        var _this = this;
        this.visitAllObjects(function (param) {
            ctx.print(null, param.name);
            _this._printColonType(param.type, ctx);
        }, params, ctx, ',');
    };
    /**
     * @param {?} value
     * @return {?}
     */
    _TsEmitterVisitor.prototype._resolveStaticSymbol = function (value) {
        var /** @type {?} */ reference = value.reference;
        if (!(reference instanceof StaticSymbol)) {
            throw new Error("Internal error: unknown identifier " + JSON.stringify(value));
        }
        var /** @type {?} */ arity = this._importResolver.getTypeArity(reference) || undefined;
        var /** @type {?} */ importReference = this._importResolver.getImportAs(reference) || reference;
        return {
            name: importReference.name,
            filePath: importReference.filePath,
            members: importReference.members, arity: arity
        };
    };
    /**
     * @param {?} value
     * @param {?} typeParams
     * @param {?} ctx
     * @return {?}
     */
    _TsEmitterVisitor.prototype._visitIdentifier = function (value, typeParams, ctx) {
        var _this = this;
        var _a = this._resolveStaticSymbol(value), name = _a.name, filePath = _a.filePath, members = _a.members, arity = _a.arity;
        if (filePath != this._genFilePath) {
            var /** @type {?} */ prefix = this.importsWithPrefixes.get(filePath);
            if (prefix == null) {
                prefix = "import" + this.importsWithPrefixes.size;
                this.importsWithPrefixes.set(filePath, prefix);
            }
            ctx.print(null, prefix + ".");
        }
        if (((members)).length) {
            ctx.print(null, name);
            ctx.print(null, '.');
            ctx.print(null, /** @type {?} */ ((members)).join('.'));
        }
        else {
            ctx.print(null, name);
        }
        if (this.typeExpression > 0) {
            // If we are in a type expression that refers to a generic type then supply
            // the required type parameters. If there were not enough type parameters
            // supplied, supply any as the type. Outside a type expression the reference
            // should not supply type parameters and be treated as a simple value reference
            // to the constructor function itself.
            var /** @type {?} */ suppliedParameters = (typeParams && typeParams.length) || 0;
            var /** @type {?} */ additionalParameters = (arity || 0) - suppliedParameters;
            if (suppliedParameters > 0 || additionalParameters > 0) {
                ctx.print(null, "<");
                if (suppliedParameters > 0) {
                    this.visitAllObjects(function (type) { return type.visitType(_this, ctx); }, /** @type {?} */ ((typeParams)), ctx, ',');
                }
                if (additionalParameters > 0) {
                    for (var /** @type {?} */ i = 0; i < additionalParameters; i++) {
                        if (i > 0 || suppliedParameters > 0)
                            ctx.print(null, ',');
                        ctx.print(null, 'any');
                    }
                }
                ctx.print(null, ">");
            }
        }
    };
    /**
     * @param {?} type
     * @param {?} ctx
     * @param {?=} defaultType
     * @return {?}
     */
    _TsEmitterVisitor.prototype._printColonType = function (type, ctx, defaultType) {
        if (type !== INFERRED_TYPE) {
            ctx.print(null, ':');
            this.visitType(type, ctx, defaultType);
        }
    };
    return _TsEmitterVisitor;
}(AbstractEmitterVisitor));
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
// =================================================================================================
// =================================================================================================
// =========== S T O P   -  S T O P   -  S T O P   -  S T O P   -  S T O P   -  S T O P  ===========
// =================================================================================================
// =================================================================================================
//
//        DO NOT EDIT THIS LIST OF SECURITY SENSITIVE PROPERTIES WITHOUT A SECURITY REVIEW!
//                               Reach out to mprobst for details.
//
// =================================================================================================
/** Map from tagName|propertyName SecurityContext. Properties applying to all tags use '*'. */
var SECURITY_SCHEMA = {};
/**
 * @param {?} ctx
 * @param {?} specs
 * @return {?}
 */
function registerContext(ctx, specs) {
    for (var _i = 0, specs_1 = specs; _i < specs_1.length; _i++) {
        var spec = specs_1[_i];
        SECURITY_SCHEMA[spec.toLowerCase()] = ctx;
    }
}
// Case is insignificant below, all element and attribute names are lower-cased for lookup.
registerContext(__WEBPACK_IMPORTED_MODULE_0__angular_core__["SecurityContext"].HTML, [
    'iframe|srcdoc',
    '*|innerHTML',
    '*|outerHTML',
]);
registerContext(__WEBPACK_IMPORTED_MODULE_0__angular_core__["SecurityContext"].STYLE, ['*|style']);
// NB: no SCRIPT contexts here, they are never allowed due to the parser stripping them.
registerContext(__WEBPACK_IMPORTED_MODULE_0__angular_core__["SecurityContext"].URL, [
    '*|formAction', 'area|href', 'area|ping', 'audio|src', 'a|href',
    'a|ping', 'blockquote|cite', 'body|background', 'del|cite', 'form|action',
    'img|src', 'img|srcset', 'input|src', 'ins|cite', 'q|cite',
    'source|src', 'source|srcset', 'track|src', 'video|poster', 'video|src',
]);
registerContext(__WEBPACK_IMPORTED_MODULE_0__angular_core__["SecurityContext"].RESOURCE_URL, [
    'applet|code',
    'applet|codebase',
    'base|href',
    'embed|src',
    'frame|src',
    'head|profile',
    'html|manifest',
    'iframe|src',
    'link|href',
    'media|src',
    'object|codebase',
    'object|data',
    'script|src',
]);
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var BOOLEAN = 'boolean';
var NUMBER = 'number';
var STRING = 'string';
var OBJECT = 'object';
/**
 * This array represents the DOM schema. It encodes inheritance, properties, and events.
 *
 * ## Overview
 *
 * Each line represents one kind of element. The `element_inheritance` and properties are joined
 * using `element_inheritance|properties` syntax.
 *
 * ## Element Inheritance
 *
 * The `element_inheritance` can be further subdivided as `element1,element2,...^parentElement`.
 * Here the individual elements are separated by `,` (commas). Every element in the list
 * has identical properties.
 *
 * An `element` may inherit additional properties from `parentElement` If no `^parentElement` is
 * specified then `""` (blank) element is assumed.
 *
 * NOTE: The blank element inherits from root `[Element]` element, the super element of all
 * elements.
 *
 * NOTE an element prefix such as `:svg:` has no special meaning to the schema.
 *
 * ## Properties
 *
 * Each element has a set of properties separated by `,` (commas). Each property can be prefixed
 * by a special character designating its type:
 *
 * - (no prefix): property is a string.
 * - `*`: property represents an event.
 * - `!`: property is a boolean.
 * - `#`: property is a number.
 * - `%`: property is an object.
 *
 * ## Query
 *
 * The class creates an internal squas representation which allows to easily answer the query of
 * if a given property exist on a given element.
 *
 * NOTE: We don't yet support querying for types or events.
 * NOTE: This schema is auto extracted from `schema_extractor.ts` located in the test folder,
 *       see dom_element_schema_registry_spec.ts
 */
// =================================================================================================
// =================================================================================================
// =========== S T O P   -  S T O P   -  S T O P   -  S T O P   -  S T O P   -  S T O P  ===========
// =================================================================================================
// =================================================================================================
//
//                       DO NOT EDIT THIS DOM SCHEMA WITHOUT A SECURITY REVIEW!
//
// Newly added properties must be security reviewed and assigned an appropriate SecurityContext in
// dom_security_schema.ts. Reach out to mprobst & rjamet for details.
//
// =================================================================================================
var SCHEMA = [
    '[Element]|textContent,%classList,className,id,innerHTML,*beforecopy,*beforecut,*beforepaste,*copy,*cut,*paste,*search,*selectstart,*webkitfullscreenchange,*webkitfullscreenerror,*wheel,outerHTML,#scrollLeft,#scrollTop',
    '[HTMLElement]^[Element]|accessKey,contentEditable,dir,!draggable,!hidden,innerText,lang,*abort,*beforecopy,*beforecut,*beforepaste,*blur,*cancel,*canplay,*canplaythrough,*change,*click,*close,*contextmenu,*copy,*cuechange,*cut,*dblclick,*drag,*dragend,*dragenter,*dragleave,*dragover,*dragstart,*drop,*durationchange,*emptied,*ended,*error,*focus,*input,*invalid,*keydown,*keypress,*keyup,*load,*loadeddata,*loadedmetadata,*loadstart,*message,*mousedown,*mouseenter,*mouseleave,*mousemove,*mouseout,*mouseover,*mouseup,*mousewheel,*mozfullscreenchange,*mozfullscreenerror,*mozpointerlockchange,*mozpointerlockerror,*paste,*pause,*play,*playing,*progress,*ratechange,*reset,*resize,*scroll,*search,*seeked,*seeking,*select,*selectstart,*show,*stalled,*submit,*suspend,*timeupdate,*toggle,*volumechange,*waiting,*webglcontextcreationerror,*webglcontextlost,*webglcontextrestored,*webkitfullscreenchange,*webkitfullscreenerror,*wheel,outerText,!spellcheck,%style,#tabIndex,title,!translate',
    'abbr,address,article,aside,b,bdi,bdo,cite,code,dd,dfn,dt,em,figcaption,figure,footer,header,i,kbd,main,mark,nav,noscript,rb,rp,rt,rtc,ruby,s,samp,section,small,strong,sub,sup,u,var,wbr^[HTMLElement]|accessKey,contentEditable,dir,!draggable,!hidden,innerText,lang,*abort,*beforecopy,*beforecut,*beforepaste,*blur,*cancel,*canplay,*canplaythrough,*change,*click,*close,*contextmenu,*copy,*cuechange,*cut,*dblclick,*drag,*dragend,*dragenter,*dragleave,*dragover,*dragstart,*drop,*durationchange,*emptied,*ended,*error,*focus,*input,*invalid,*keydown,*keypress,*keyup,*load,*loadeddata,*loadedmetadata,*loadstart,*message,*mousedown,*mouseenter,*mouseleave,*mousemove,*mouseout,*mouseover,*mouseup,*mousewheel,*mozfullscreenchange,*mozfullscreenerror,*mozpointerlockchange,*mozpointerlockerror,*paste,*pause,*play,*playing,*progress,*ratechange,*reset,*resize,*scroll,*search,*seeked,*seeking,*select,*selectstart,*show,*stalled,*submit,*suspend,*timeupdate,*toggle,*volumechange,*waiting,*webglcontextcreationerror,*webglcontextlost,*webglcontextrestored,*webkitfullscreenchange,*webkitfullscreenerror,*wheel,outerText,!spellcheck,%style,#tabIndex,title,!translate',
    'media^[HTMLElement]|!autoplay,!controls,%crossOrigin,#currentTime,!defaultMuted,#defaultPlaybackRate,!disableRemotePlayback,!loop,!muted,*encrypted,#playbackRate,preload,src,%srcObject,#volume',
    ':svg:^[HTMLElement]|*abort,*blur,*cancel,*canplay,*canplaythrough,*change,*click,*close,*contextmenu,*cuechange,*dblclick,*drag,*dragend,*dragenter,*dragleave,*dragover,*dragstart,*drop,*durationchange,*emptied,*ended,*error,*focus,*input,*invalid,*keydown,*keypress,*keyup,*load,*loadeddata,*loadedmetadata,*loadstart,*mousedown,*mouseenter,*mouseleave,*mousemove,*mouseout,*mouseover,*mouseup,*mousewheel,*pause,*play,*playing,*progress,*ratechange,*reset,*resize,*scroll,*seeked,*seeking,*select,*show,*stalled,*submit,*suspend,*timeupdate,*toggle,*volumechange,*waiting,%style,#tabIndex',
    ':svg:graphics^:svg:|',
    ':svg:animation^:svg:|*begin,*end,*repeat',
    ':svg:geometry^:svg:|',
    ':svg:componentTransferFunction^:svg:|',
    ':svg:gradient^:svg:|',
    ':svg:textContent^:svg:graphics|',
    ':svg:textPositioning^:svg:textContent|',
    'a^[HTMLElement]|charset,coords,download,hash,host,hostname,href,hreflang,name,password,pathname,ping,port,protocol,referrerPolicy,rel,rev,search,shape,target,text,type,username',
    'area^[HTMLElement]|alt,coords,hash,host,hostname,href,!noHref,password,pathname,ping,port,protocol,referrerPolicy,search,shape,target,username',
    'audio^media|',
    'br^[HTMLElement]|clear',
    'base^[HTMLElement]|href,target',
    'body^[HTMLElement]|aLink,background,bgColor,link,*beforeunload,*blur,*error,*focus,*hashchange,*languagechange,*load,*message,*offline,*online,*pagehide,*pageshow,*popstate,*rejectionhandled,*resize,*scroll,*storage,*unhandledrejection,*unload,text,vLink',
    'button^[HTMLElement]|!autofocus,!disabled,formAction,formEnctype,formMethod,!formNoValidate,formTarget,name,type,value',
    'canvas^[HTMLElement]|#height,#width',
    'content^[HTMLElement]|select',
    'dl^[HTMLElement]|!compact',
    'datalist^[HTMLElement]|',
    'details^[HTMLElement]|!open',
    'dialog^[HTMLElement]|!open,returnValue',
    'dir^[HTMLElement]|!compact',
    'div^[HTMLElement]|align',
    'embed^[HTMLElement]|align,height,name,src,type,width',
    'fieldset^[HTMLElement]|!disabled,name',
    'font^[HTMLElement]|color,face,size',
    'form^[HTMLElement]|acceptCharset,action,autocomplete,encoding,enctype,method,name,!noValidate,target',
    'frame^[HTMLElement]|frameBorder,longDesc,marginHeight,marginWidth,name,!noResize,scrolling,src',
    'frameset^[HTMLElement]|cols,*beforeunload,*blur,*error,*focus,*hashchange,*languagechange,*load,*message,*offline,*online,*pagehide,*pageshow,*popstate,*rejectionhandled,*resize,*scroll,*storage,*unhandledrejection,*unload,rows',
    'hr^[HTMLElement]|align,color,!noShade,size,width',
    'head^[HTMLElement]|',
    'h1,h2,h3,h4,h5,h6^[HTMLElement]|align',
    'html^[HTMLElement]|version',
    'iframe^[HTMLElement]|align,!allowFullscreen,frameBorder,height,longDesc,marginHeight,marginWidth,name,referrerPolicy,%sandbox,scrolling,src,srcdoc,width',
    'img^[HTMLElement]|align,alt,border,%crossOrigin,#height,#hspace,!isMap,longDesc,lowsrc,name,referrerPolicy,sizes,src,srcset,useMap,#vspace,#width',
    'input^[HTMLElement]|accept,align,alt,autocapitalize,autocomplete,!autofocus,!checked,!defaultChecked,defaultValue,dirName,!disabled,%files,formAction,formEnctype,formMethod,!formNoValidate,formTarget,#height,!incremental,!indeterminate,max,#maxLength,min,#minLength,!multiple,name,pattern,placeholder,!readOnly,!required,selectionDirection,#selectionEnd,#selectionStart,#size,src,step,type,useMap,value,%valueAsDate,#valueAsNumber,#width',
    'keygen^[HTMLElement]|!autofocus,challenge,!disabled,keytype,name',
    'li^[HTMLElement]|type,#value',
    'label^[HTMLElement]|htmlFor',
    'legend^[HTMLElement]|align',
    'link^[HTMLElement]|as,charset,%crossOrigin,!disabled,href,hreflang,integrity,media,rel,%relList,rev,%sizes,target,type',
    'map^[HTMLElement]|name',
    'marquee^[HTMLElement]|behavior,bgColor,direction,height,#hspace,#loop,#scrollAmount,#scrollDelay,!trueSpeed,#vspace,width',
    'menu^[HTMLElement]|!compact',
    'meta^[HTMLElement]|content,httpEquiv,name,scheme',
    'meter^[HTMLElement]|#high,#low,#max,#min,#optimum,#value',
    'ins,del^[HTMLElement]|cite,dateTime',
    'ol^[HTMLElement]|!compact,!reversed,#start,type',
    'object^[HTMLElement]|align,archive,border,code,codeBase,codeType,data,!declare,height,#hspace,name,standby,type,useMap,#vspace,width',
    'optgroup^[HTMLElement]|!disabled,label',
    'option^[HTMLElement]|!defaultSelected,!disabled,label,!selected,text,value',
    'output^[HTMLElement]|defaultValue,%htmlFor,name,value',
    'p^[HTMLElement]|align',
    'param^[HTMLElement]|name,type,value,valueType',
    'picture^[HTMLElement]|',
    'pre^[HTMLElement]|#width',
    'progress^[HTMLElement]|#max,#value',
    'q,blockquote,cite^[HTMLElement]|',
    'script^[HTMLElement]|!async,charset,%crossOrigin,!defer,event,htmlFor,integrity,src,text,type',
    'select^[HTMLElement]|!autofocus,!disabled,#length,!multiple,name,!required,#selectedIndex,#size,value',
    'shadow^[HTMLElement]|',
    'source^[HTMLElement]|media,sizes,src,srcset,type',
    'span^[HTMLElement]|',
    'style^[HTMLElement]|!disabled,media,type',
    'caption^[HTMLElement]|align',
    'th,td^[HTMLElement]|abbr,align,axis,bgColor,ch,chOff,#colSpan,headers,height,!noWrap,#rowSpan,scope,vAlign,width',
    'col,colgroup^[HTMLElement]|align,ch,chOff,#span,vAlign,width',
    'table^[HTMLElement]|align,bgColor,border,%caption,cellPadding,cellSpacing,frame,rules,summary,%tFoot,%tHead,width',
    'tr^[HTMLElement]|align,bgColor,ch,chOff,vAlign',
    'tfoot,thead,tbody^[HTMLElement]|align,ch,chOff,vAlign',
    'template^[HTMLElement]|',
    'textarea^[HTMLElement]|autocapitalize,!autofocus,#cols,defaultValue,dirName,!disabled,#maxLength,#minLength,name,placeholder,!readOnly,!required,#rows,selectionDirection,#selectionEnd,#selectionStart,value,wrap',
    'title^[HTMLElement]|text',
    'track^[HTMLElement]|!default,kind,label,src,srclang',
    'ul^[HTMLElement]|!compact,type',
    'unknown^[HTMLElement]|',
    'video^media|#height,poster,#width',
    ':svg:a^:svg:graphics|',
    ':svg:animate^:svg:animation|',
    ':svg:animateMotion^:svg:animation|',
    ':svg:animateTransform^:svg:animation|',
    ':svg:circle^:svg:geometry|',
    ':svg:clipPath^:svg:graphics|',
    ':svg:cursor^:svg:|',
    ':svg:defs^:svg:graphics|',
    ':svg:desc^:svg:|',
    ':svg:discard^:svg:|',
    ':svg:ellipse^:svg:geometry|',
    ':svg:feBlend^:svg:|',
    ':svg:feColorMatrix^:svg:|',
    ':svg:feComponentTransfer^:svg:|',
    ':svg:feComposite^:svg:|',
    ':svg:feConvolveMatrix^:svg:|',
    ':svg:feDiffuseLighting^:svg:|',
    ':svg:feDisplacementMap^:svg:|',
    ':svg:feDistantLight^:svg:|',
    ':svg:feDropShadow^:svg:|',
    ':svg:feFlood^:svg:|',
    ':svg:feFuncA^:svg:componentTransferFunction|',
    ':svg:feFuncB^:svg:componentTransferFunction|',
    ':svg:feFuncG^:svg:componentTransferFunction|',
    ':svg:feFuncR^:svg:componentTransferFunction|',
    ':svg:feGaussianBlur^:svg:|',
    ':svg:feImage^:svg:|',
    ':svg:feMerge^:svg:|',
    ':svg:feMergeNode^:svg:|',
    ':svg:feMorphology^:svg:|',
    ':svg:feOffset^:svg:|',
    ':svg:fePointLight^:svg:|',
    ':svg:feSpecularLighting^:svg:|',
    ':svg:feSpotLight^:svg:|',
    ':svg:feTile^:svg:|',
    ':svg:feTurbulence^:svg:|',
    ':svg:filter^:svg:|',
    ':svg:foreignObject^:svg:graphics|',
    ':svg:g^:svg:graphics|',
    ':svg:image^:svg:graphics|',
    ':svg:line^:svg:geometry|',
    ':svg:linearGradient^:svg:gradient|',
    ':svg:mpath^:svg:|',
    ':svg:marker^:svg:|',
    ':svg:mask^:svg:|',
    ':svg:metadata^:svg:|',
    ':svg:path^:svg:geometry|',
    ':svg:pattern^:svg:|',
    ':svg:polygon^:svg:geometry|',
    ':svg:polyline^:svg:geometry|',
    ':svg:radialGradient^:svg:gradient|',
    ':svg:rect^:svg:geometry|',
    ':svg:svg^:svg:graphics|#currentScale,#zoomAndPan',
    ':svg:script^:svg:|type',
    ':svg:set^:svg:animation|',
    ':svg:stop^:svg:|',
    ':svg:style^:svg:|!disabled,media,title,type',
    ':svg:switch^:svg:graphics|',
    ':svg:symbol^:svg:|',
    ':svg:tspan^:svg:textPositioning|',
    ':svg:text^:svg:textPositioning|',
    ':svg:textPath^:svg:textContent|',
    ':svg:title^:svg:|',
    ':svg:use^:svg:graphics|',
    ':svg:view^:svg:|#zoomAndPan',
    'data^[HTMLElement]|value',
    'menuitem^[HTMLElement]|type,label,icon,!disabled,!checked,radiogroup,!default',
    'summary^[HTMLElement]|',
    'time^[HTMLElement]|dateTime',
];
var _ATTR_TO_PROP = {
    'class': 'className',
    'for': 'htmlFor',
    'formaction': 'formAction',
    'innerHtml': 'innerHTML',
    'readonly': 'readOnly',
    'tabindex': 'tabIndex',
};
var DomElementSchemaRegistry = (function (_super) {
    __extends(DomElementSchemaRegistry, _super);
    function DomElementSchemaRegistry() {
        var _this = _super.call(this) || this;
        _this._schema = {};
        SCHEMA.forEach(function (encodedType) {
            var type = {};
            var _a = encodedType.split('|'), strType = _a[0], strProperties = _a[1];
            var properties = strProperties.split(',');
            var _b = strType.split('^'), typeNames = _b[0], superName = _b[1];
            typeNames.split(',').forEach(function (tag) { return _this._schema[tag.toLowerCase()] = type; });
            var superType = superName && _this._schema[superName.toLowerCase()];
            if (superType) {
                Object.keys(superType).forEach(function (prop) { type[prop] = superType[prop]; });
            }
            properties.forEach(function (property) {
                if (property.length > 0) {
                    switch (property[0]) {
                        case '*':
                            // We don't yet support events.
                            // If ever allowing to bind to events, GO THROUGH A SECURITY REVIEW, allowing events
                            // will
                            // almost certainly introduce bad XSS vulnerabilities.
                            // type[property.substring(1)] = EVENT;
                            break;
                        case '!':
                            type[property.substring(1)] = BOOLEAN;
                            break;
                        case '#':
                            type[property.substring(1)] = NUMBER;
                            break;
                        case '%':
                            type[property.substring(1)] = OBJECT;
                            break;
                        default:
                            type[property] = STRING;
                    }
                }
            });
        });
        return _this;
    }
    /**
     * @param {?} tagName
     * @param {?} propName
     * @param {?} schemaMetas
     * @return {?}
     */
    DomElementSchemaRegistry.prototype.hasProperty = function (tagName, propName, schemaMetas) {
        if (schemaMetas.some(function (schema) { return schema.name === __WEBPACK_IMPORTED_MODULE_0__angular_core__["NO_ERRORS_SCHEMA"].name; })) {
            return true;
        }
        if (tagName.indexOf('-') > -1) {
            if (isNgContainer(tagName) || isNgContent(tagName)) {
                return false;
            }
            if (schemaMetas.some(function (schema) { return schema.name === __WEBPACK_IMPORTED_MODULE_0__angular_core__["CUSTOM_ELEMENTS_SCHEMA"].name; })) {
                // Can't tell now as we don't know which properties a custom element will get
                // once it is instantiated
                return true;
            }
        }
        var /** @type {?} */ elementProperties = this._schema[tagName.toLowerCase()] || this._schema['unknown'];
        return !!elementProperties[propName];
    };
    /**
     * @param {?} tagName
     * @param {?} schemaMetas
     * @return {?}
     */
    DomElementSchemaRegistry.prototype.hasElement = function (tagName, schemaMetas) {
        if (schemaMetas.some(function (schema) { return schema.name === __WEBPACK_IMPORTED_MODULE_0__angular_core__["NO_ERRORS_SCHEMA"].name; })) {
            return true;
        }
        if (tagName.indexOf('-') > -1) {
            if (isNgContainer(tagName) || isNgContent(tagName)) {
                return true;
            }
            if (schemaMetas.some(function (schema) { return schema.name === __WEBPACK_IMPORTED_MODULE_0__angular_core__["CUSTOM_ELEMENTS_SCHEMA"].name; })) {
                // Allow any custom elements
                return true;
            }
        }
        return !!this._schema[tagName.toLowerCase()];
    };
    /**
     * securityContext returns the security context for the given property on the given DOM tag.
     *
     * Tag and property name are statically known and cannot change at runtime, i.e. it is not
     * possible to bind a value into a changing attribute or tag name.
     *
     * The filtering is white list based. All attributes in the schema above are assumed to have the
     * 'NONE' security context, i.e. that they are safe inert string values. Only specific well known
     * attack vectors are assigned their appropriate context.
     * @param {?} tagName
     * @param {?} propName
     * @param {?} isAttribute
     * @return {?}
     */
    DomElementSchemaRegistry.prototype.securityContext = function (tagName, propName, isAttribute) {
        if (isAttribute) {
            // NB: For security purposes, use the mapped property name, not the attribute name.
            propName = this.getMappedPropName(propName);
        }
        // Make sure comparisons are case insensitive, so that case differences between attribute and
        // property names do not have a security impact.
        tagName = tagName.toLowerCase();
        propName = propName.toLowerCase();
        var /** @type {?} */ ctx = SECURITY_SCHEMA[tagName + '|' + propName];
        if (ctx) {
            return ctx;
        }
        ctx = SECURITY_SCHEMA['*|' + propName];
        return ctx ? ctx : __WEBPACK_IMPORTED_MODULE_0__angular_core__["SecurityContext"].NONE;
    };
    /**
     * @param {?} propName
     * @return {?}
     */
    DomElementSchemaRegistry.prototype.getMappedPropName = function (propName) { return _ATTR_TO_PROP[propName] || propName; };
    /**
     * @return {?}
     */
    DomElementSchemaRegistry.prototype.getDefaultComponentElementName = function () { return 'ng-component'; };
    /**
     * @param {?} name
     * @return {?}
     */
    DomElementSchemaRegistry.prototype.validateProperty = function (name) {
        if (name.toLowerCase().startsWith('on')) {
            var /** @type {?} */ msg = "Binding to event property '" + name + "' is disallowed for security reasons, " +
                ("please use (" + name.slice(2) + ")=...") +
                ("\nIf '" + name + "' is a directive input, make sure the directive is imported by the") +
                " current module.";
            return { error: true, msg: msg };
        }
        else {
            return { error: false };
        }
    };
    /**
     * @param {?} name
     * @return {?}
     */
    DomElementSchemaRegistry.prototype.validateAttribute = function (name) {
        if (name.toLowerCase().startsWith('on')) {
            var /** @type {?} */ msg = "Binding to event attribute '" + name + "' is disallowed for security reasons, " +
                ("please use (" + name.slice(2) + ")=...");
            return { error: true, msg: msg };
        }
        else {
            return { error: false };
        }
    };
    /**
     * @return {?}
     */
    DomElementSchemaRegistry.prototype.allKnownElementNames = function () { return Object.keys(this._schema); };
    /**
     * @param {?} propName
     * @return {?}
     */
    DomElementSchemaRegistry.prototype.normalizeAnimationStyleProperty = function (propName) {
        return dashCaseToCamelCase(propName);
    };
    /**
     * @param {?} camelCaseProp
     * @param {?} userProvidedProp
     * @param {?} val
     * @return {?}
     */
    DomElementSchemaRegistry.prototype.normalizeAnimationStyleValue = function (camelCaseProp, userProvidedProp, val) {
        var /** @type {?} */ unit = '';
        var /** @type {?} */ strVal = val.toString().trim();
        var /** @type {?} */ errorMsg = ((null));
        if (_isPixelDimensionStyle(camelCaseProp) && val !== 0 && val !== '0') {
            if (typeof val === 'number') {
                unit = 'px';
            }
            else {
                var /** @type {?} */ valAndSuffixMatch = val.match(/^[+-]?[\d\.]+([a-z]*)$/);
                if (valAndSuffixMatch && valAndSuffixMatch[1].length == 0) {
                    errorMsg = "Please provide a CSS unit value for " + userProvidedProp + ":" + val;
                }
            }
        }
        return { error: errorMsg, value: strVal + unit };
    };
    return DomElementSchemaRegistry;
}(ElementSchemaRegistry));
DomElementSchemaRegistry.decorators = [
    { type: CompilerInjectable },
];
/**
 * @nocollapse
 */
DomElementSchemaRegistry.ctorParameters = function () { return []; };
/**
 * @param {?} prop
 * @return {?}
 */
function _isPixelDimensionStyle(prop) {
    switch (prop) {
        case 'width':
        case 'height':
        case 'minWidth':
        case 'minHeight':
        case 'maxWidth':
        case 'maxHeight':
        case 'left':
        case 'top':
        case 'bottom':
        case 'right':
        case 'fontSize':
        case 'outlineWidth':
        case 'outlineOffset':
        case 'paddingTop':
        case 'paddingLeft':
        case 'paddingBottom':
        case 'paddingRight':
        case 'marginTop':
        case 'marginLeft':
        case 'marginBottom':
        case 'marginRight':
        case 'borderRadius':
        case 'borderWidth':
        case 'borderTopWidth':
        case 'borderLeftWidth':
        case 'borderRightWidth':
        case 'borderBottomWidth':
        case 'textIndent':
            return true;
        default:
            return false;
    }
}
var ShadowCss = (function () {
    function ShadowCss() {
        this.strictStyling = true;
    }
    /**
     * @param {?} cssText
     * @param {?} selector
     * @param {?=} hostSelector
     * @return {?}
     */
    ShadowCss.prototype.shimCssText = function (cssText, selector, hostSelector) {
        if (hostSelector === void 0) { hostSelector = ''; }
        var /** @type {?} */ sourceMappingUrl = extractSourceMappingUrl(cssText);
        cssText = stripComments(cssText);
        cssText = this._insertDirectives(cssText);
        return this._scopeCssText(cssText, selector, hostSelector) + sourceMappingUrl;
    };
    /**
     * @param {?} cssText
     * @return {?}
     */
    ShadowCss.prototype._insertDirectives = function (cssText) {
        cssText = this._insertPolyfillDirectivesInCssText(cssText);
        return this._insertPolyfillRulesInCssText(cssText);
    };
    /**
     * @param {?} cssText
     * @return {?}
     */
    ShadowCss.prototype._insertPolyfillDirectivesInCssText = function (cssText) {
        // Difference with webcomponents.js: does not handle comments
        return cssText.replace(_cssContentNextSelectorRe, function () {
            var m = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                m[_i] = arguments[_i];
            }
            return m[2] + '{';
        });
    };
    /**
     * @param {?} cssText
     * @return {?}
     */
    ShadowCss.prototype._insertPolyfillRulesInCssText = function (cssText) {
        // Difference with webcomponents.js: does not handle comments
        return cssText.replace(_cssContentRuleRe, function () {
            var m = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                m[_i] = arguments[_i];
            }
            var /** @type {?} */ rule = m[0].replace(m[1], '').replace(m[2], '');
            return m[4] + rule;
        });
    };
    /**
     * @param {?} cssText
     * @param {?} scopeSelector
     * @param {?} hostSelector
     * @return {?}
     */
    ShadowCss.prototype._scopeCssText = function (cssText, scopeSelector, hostSelector) {
        var /** @type {?} */ unscopedRules = this._extractUnscopedRulesFromCssText(cssText);
        // replace :host and :host-context -shadowcsshost and -shadowcsshost respectively
        cssText = this._insertPolyfillHostInCssText(cssText);
        cssText = this._convertColonHost(cssText);
        cssText = this._convertColonHostContext(cssText);
        cssText = this._convertShadowDOMSelectors(cssText);
        if (scopeSelector) {
            cssText = this._scopeSelectors(cssText, scopeSelector, hostSelector);
        }
        cssText = cssText + '\n' + unscopedRules;
        return cssText.trim();
    };
    /**
     * @param {?} cssText
     * @return {?}
     */
    ShadowCss.prototype._extractUnscopedRulesFromCssText = function (cssText) {
        // Difference with webcomponents.js: does not handle comments
        var /** @type {?} */ r = '';
        var /** @type {?} */ m;
        _cssContentUnscopedRuleRe.lastIndex = 0;
        while ((m = _cssContentUnscopedRuleRe.exec(cssText)) !== null) {
            var /** @type {?} */ rule = m[0].replace(m[2], '').replace(m[1], m[4]);
            r += rule + '\n\n';
        }
        return r;
    };
    /**
     * @param {?} cssText
     * @return {?}
     */
    ShadowCss.prototype._convertColonHost = function (cssText) {
        return this._convertColonRule(cssText, _cssColonHostRe, this._colonHostPartReplacer);
    };
    /**
     * @param {?} cssText
     * @return {?}
     */
    ShadowCss.prototype._convertColonHostContext = function (cssText) {
        return this._convertColonRule(cssText, _cssColonHostContextRe, this._colonHostContextPartReplacer);
    };
    /**
     * @param {?} cssText
     * @param {?} regExp
     * @param {?} partReplacer
     * @return {?}
     */
    ShadowCss.prototype._convertColonRule = function (cssText, regExp, partReplacer) {
        // m[1] = :host(-context), m[2] = contents of (), m[3] rest of rule
        return cssText.replace(regExp, function () {
            var m = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                m[_i] = arguments[_i];
            }
            if (m[2]) {
                var /** @type {?} */ parts = m[2].split(',');
                var /** @type {?} */ r = [];
                for (var /** @type {?} */ i = 0; i < parts.length; i++) {
                    var /** @type {?} */ p = parts[i].trim();
                    if (!p)
                        break;
                    r.push(partReplacer(_polyfillHostNoCombinator, p, m[3]));
                }
                return r.join(',');
            }
            else {
                return _polyfillHostNoCombinator + m[3];
            }
        });
    };
    /**
     * @param {?} host
     * @param {?} part
     * @param {?} suffix
     * @return {?}
     */
    ShadowCss.prototype._colonHostContextPartReplacer = function (host, part, suffix) {
        if (part.indexOf(_polyfillHost) > -1) {
            return this._colonHostPartReplacer(host, part, suffix);
        }
        else {
            return host + part + suffix + ', ' + part + ' ' + host + suffix;
        }
    };
    /**
     * @param {?} host
     * @param {?} part
     * @param {?} suffix
     * @return {?}
     */
    ShadowCss.prototype._colonHostPartReplacer = function (host, part, suffix) {
        return host + part.replace(_polyfillHost, '') + suffix;
    };
    /**
     * @param {?} cssText
     * @return {?}
     */
    ShadowCss.prototype._convertShadowDOMSelectors = function (cssText) {
        return _shadowDOMSelectorsRe.reduce(function (result, pattern) { return result.replace(pattern, ' '); }, cssText);
    };
    /**
     * @param {?} cssText
     * @param {?} scopeSelector
     * @param {?} hostSelector
     * @return {?}
     */
    ShadowCss.prototype._scopeSelectors = function (cssText, scopeSelector, hostSelector) {
        var _this = this;
        return processRules(cssText, function (rule) {
            var /** @type {?} */ selector = rule.selector;
            var /** @type {?} */ content = rule.content;
            if (rule.selector[0] != '@') {
                selector =
                    _this._scopeSelector(rule.selector, scopeSelector, hostSelector, _this.strictStyling);
            }
            else if (rule.selector.startsWith('@media') || rule.selector.startsWith('@supports') ||
                rule.selector.startsWith('@page') || rule.selector.startsWith('@document')) {
                content = _this._scopeSelectors(rule.content, scopeSelector, hostSelector);
            }
            return new CssRule(selector, content);
        });
    };
    /**
     * @param {?} selector
     * @param {?} scopeSelector
     * @param {?} hostSelector
     * @param {?} strict
     * @return {?}
     */
    ShadowCss.prototype._scopeSelector = function (selector, scopeSelector, hostSelector, strict) {
        var _this = this;
        return selector.split(',')
            .map(function (part) { return part.trim().split(_shadowDeepSelectors); })
            .map(function (deepParts) {
            var shallowPart = deepParts[0], otherParts = deepParts.slice(1);
            var /** @type {?} */ applyScope = function (shallowPart) {
                if (_this._selectorNeedsScoping(shallowPart, scopeSelector)) {
                    return strict ?
                        _this._applyStrictSelectorScope(shallowPart, scopeSelector, hostSelector) :
                        _this._applySelectorScope(shallowPart, scopeSelector, hostSelector);
                }
                else {
                    return shallowPart;
                }
            };
            return [applyScope(shallowPart)].concat(otherParts).join(' ');
        })
            .join(', ');
    };
    /**
     * @param {?} selector
     * @param {?} scopeSelector
     * @return {?}
     */
    ShadowCss.prototype._selectorNeedsScoping = function (selector, scopeSelector) {
        var /** @type {?} */ re = this._makeScopeMatcher(scopeSelector);
        return !re.test(selector);
    };
    /**
     * @param {?} scopeSelector
     * @return {?}
     */
    ShadowCss.prototype._makeScopeMatcher = function (scopeSelector) {
        var /** @type {?} */ lre = /\[/g;
        var /** @type {?} */ rre = /\]/g;
        scopeSelector = scopeSelector.replace(lre, '\\[').replace(rre, '\\]');
        return new RegExp('^(' + scopeSelector + ')' + _selectorReSuffix, 'm');
    };
    /**
     * @param {?} selector
     * @param {?} scopeSelector
     * @param {?} hostSelector
     * @return {?}
     */
    ShadowCss.prototype._applySelectorScope = function (selector, scopeSelector, hostSelector) {
        // Difference from webcomponents.js: scopeSelector could not be an array
        return this._applySimpleSelectorScope(selector, scopeSelector, hostSelector);
    };
    /**
     * @param {?} selector
     * @param {?} scopeSelector
     * @param {?} hostSelector
     * @return {?}
     */
    ShadowCss.prototype._applySimpleSelectorScope = function (selector, scopeSelector, hostSelector) {
        // In Android browser, the lastIndex is not reset when the regex is used in String.replace()
        _polyfillHostRe.lastIndex = 0;
        if (_polyfillHostRe.test(selector)) {
            var /** @type {?} */ replaceBy_1 = this.strictStyling ? "[" + hostSelector + "]" : scopeSelector;
            return selector
                .replace(_polyfillHostNoCombinatorRe, function (hnc, selector) {
                return selector.replace(/([^:]*)(:*)(.*)/, function (_, before, colon, after) {
                    return before + replaceBy_1 + colon + after;
                });
            })
                .replace(_polyfillHostRe, replaceBy_1 + ' ');
        }
        return scopeSelector + ' ' + selector;
    };
    /**
     * @param {?} selector
     * @param {?} scopeSelector
     * @param {?} hostSelector
     * @return {?}
     */
    ShadowCss.prototype._applyStrictSelectorScope = function (selector, scopeSelector, hostSelector) {
        var _this = this;
        var /** @type {?} */ isRe = /\[is=([^\]]*)\]/g;
        scopeSelector = scopeSelector.replace(isRe, function (_) {
            var parts = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                parts[_i - 1] = arguments[_i];
            }
            return parts[0];
        });
        var /** @type {?} */ attrName = '[' + scopeSelector + ']';
        var /** @type {?} */ _scopeSelectorPart = function (p) {
            var /** @type {?} */ scopedP = p.trim();
            if (!scopedP) {
                return '';
            }
            if (p.indexOf(_polyfillHostNoCombinator) > -1) {
                scopedP = _this._applySimpleSelectorScope(p, scopeSelector, hostSelector);
            }
            else {
                // remove :host since it should be unnecessary
                var /** @type {?} */ t = p.replace(_polyfillHostRe, '');
                if (t.length > 0) {
                    var /** @type {?} */ matches = t.match(/([^:]*)(:*)(.*)/);
                    if (matches) {
                        scopedP = matches[1] + attrName + matches[2] + matches[3];
                    }
                }
            }
            return scopedP;
        };
        var /** @type {?} */ safeContent = new SafeSelector(selector);
        selector = safeContent.content();
        var /** @type {?} */ scopedSelector = '';
        var /** @type {?} */ startIndex = 0;
        var /** @type {?} */ res;
        var /** @type {?} */ sep = /( |>|\+|~(?!=))\s*/g;
        var /** @type {?} */ scopeAfter = selector.indexOf(_polyfillHostNoCombinator);
        while ((res = sep.exec(selector)) !== null) {
            var /** @type {?} */ separator = res[1];
            var /** @type {?} */ part = selector.slice(startIndex, res.index).trim();
            // if a selector appears before :host-context it should not be shimmed as it
            // matches on ancestor elements and not on elements in the host's shadow
            var /** @type {?} */ scopedPart = startIndex >= scopeAfter ? _scopeSelectorPart(part) : part;
            scopedSelector += scopedPart + " " + separator + " ";
            startIndex = sep.lastIndex;
        }
        scopedSelector += _scopeSelectorPart(selector.substring(startIndex));
        // replace the placeholders with their original values
        return safeContent.restore(scopedSelector);
    };
    /**
     * @param {?} selector
     * @return {?}
     */
    ShadowCss.prototype._insertPolyfillHostInCssText = function (selector) {
        return selector.replace(_colonHostContextRe, _polyfillHostContext)
            .replace(_colonHostRe, _polyfillHost);
    };
    return ShadowCss;
}());
var SafeSelector = (function () {
    /**
     * @param {?} selector
     */
    function SafeSelector(selector) {
        var _this = this;
        this.placeholders = [];
        this.index = 0;
        // Replaces attribute selectors with placeholders.
        // The WS in [attr="va lue"] would otherwise be interpreted as a selector separator.
        selector = selector.replace(/(\[[^\]]*\])/g, function (_, keep) {
            var replaceBy = "__ph-" + _this.index + "__";
            _this.placeholders.push(keep);
            _this.index++;
            return replaceBy;
        });
        // Replaces the expression in `:nth-child(2n + 1)` with a placeholder.
        // WS and "+" would otherwise be interpreted as selector separators.
        this._content = selector.replace(/(:nth-[-\w]+)(\([^)]+\))/g, function (_, pseudo, exp) {
            var replaceBy = "__ph-" + _this.index + "__";
            _this.placeholders.push(exp);
            _this.index++;
            return pseudo + replaceBy;
        });
    }
    ;
    /**
     * @param {?} content
     * @return {?}
     */
    SafeSelector.prototype.restore = function (content) {
        var _this = this;
        return content.replace(/__ph-(\d+)__/g, function (ph, index) { return _this.placeholders[+index]; });
    };
    /**
     * @return {?}
     */
    SafeSelector.prototype.content = function () { return this._content; };
    return SafeSelector;
}());
var _cssContentNextSelectorRe = /polyfill-next-selector[^}]*content:[\s]*?(['"])(.*?)\1[;\s]*}([^{]*?){/gim;
var _cssContentRuleRe = /(polyfill-rule)[^}]*(content:[\s]*(['"])(.*?)\3)[;\s]*[^}]*}/gim;
var _cssContentUnscopedRuleRe = /(polyfill-unscoped-rule)[^}]*(content:[\s]*(['"])(.*?)\3)[;\s]*[^}]*}/gim;
var _polyfillHost = '-shadowcsshost';
// note: :host-context pre-processed to -shadowcsshostcontext.
var _polyfillHostContext = '-shadowcsscontext';
var _parenSuffix = ')(?:\\((' +
    '(?:\\([^)(]*\\)|[^)(]*)+?' +
    ')\\))?([^,{]*)';
var _cssColonHostRe = new RegExp('(' + _polyfillHost + _parenSuffix, 'gim');
var _cssColonHostContextRe = new RegExp('(' + _polyfillHostContext + _parenSuffix, 'gim');
var _polyfillHostNoCombinator = _polyfillHost + '-no-combinator';
var _polyfillHostNoCombinatorRe = /-shadowcsshost-no-combinator([^\s]*)/;
var _shadowDOMSelectorsRe = [
    /::shadow/g,
    /::content/g,
    // Deprecated selectors
    /\/shadow-deep\//g,
    /\/shadow\//g,
];
var _shadowDeepSelectors = /(?:>>>)|(?:\/deep\/)/g;
var _selectorReSuffix = '([>\\s~+\[.,{:][\\s\\S]*)?$';
var _polyfillHostRe = /-shadowcsshost/gim;
var _colonHostRe = /:host/gim;
var _colonHostContextRe = /:host-context/gim;
var _commentRe = /\/\*\s*[\s\S]*?\*\//g;
/**
 * @param {?} input
 * @return {?}
 */
function stripComments(input) {
    return input.replace(_commentRe, '');
}
// all comments except inline source mapping
var _sourceMappingUrlRe = /\/\*\s*#\s*sourceMappingURL=[\s\S]+?\*\//;
/**
 * @param {?} input
 * @return {?}
 */
function extractSourceMappingUrl(input) {
    var /** @type {?} */ matcher = input.match(_sourceMappingUrlRe);
    return matcher ? matcher[0] : '';
}
var _ruleRe = /(\s*)([^;\{\}]+?)(\s*)((?:{%BLOCK%}?\s*;?)|(?:\s*;))/g;
var _curlyRe = /([{}])/g;
var OPEN_CURLY = '{';
var CLOSE_CURLY = '}';
var BLOCK_PLACEHOLDER = '%BLOCK%';
var CssRule = (function () {
    /**
     * @param {?} selector
     * @param {?} content
     */
    function CssRule(selector, content) {
        this.selector = selector;
        this.content = content;
    }
    return CssRule;
}());
/**
 * @param {?} input
 * @param {?} ruleCallback
 * @return {?}
 */
function processRules(input, ruleCallback) {
    var /** @type {?} */ inputWithEscapedBlocks = escapeBlocks(input);
    var /** @type {?} */ nextBlockIndex = 0;
    return inputWithEscapedBlocks.escapedString.replace(_ruleRe, function () {
        var m = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            m[_i] = arguments[_i];
        }
        var /** @type {?} */ selector = m[2];
        var /** @type {?} */ content = '';
        var /** @type {?} */ suffix = m[4];
        var /** @type {?} */ contentPrefix = '';
        if (suffix && suffix.startsWith('{' + BLOCK_PLACEHOLDER)) {
            content = inputWithEscapedBlocks.blocks[nextBlockIndex++];
            suffix = suffix.substring(BLOCK_PLACEHOLDER.length + 1);
            contentPrefix = '{';
        }
        var /** @type {?} */ rule = ruleCallback(new CssRule(selector, content));
        return "" + m[1] + rule.selector + m[3] + contentPrefix + rule.content + suffix;
    });
}
var StringWithEscapedBlocks = (function () {
    /**
     * @param {?} escapedString
     * @param {?} blocks
     */
    function StringWithEscapedBlocks(escapedString, blocks) {
        this.escapedString = escapedString;
        this.blocks = blocks;
    }
    return StringWithEscapedBlocks;
}());
/**
 * @param {?} input
 * @return {?}
 */
function escapeBlocks(input) {
    var /** @type {?} */ inputParts = input.split(_curlyRe);
    var /** @type {?} */ resultParts = [];
    var /** @type {?} */ escapedBlocks = [];
    var /** @type {?} */ bracketCount = 0;
    var /** @type {?} */ currentBlockParts = [];
    for (var /** @type {?} */ partIndex = 0; partIndex < inputParts.length; partIndex++) {
        var /** @type {?} */ part = inputParts[partIndex];
        if (part == CLOSE_CURLY) {
            bracketCount--;
        }
        if (bracketCount > 0) {
            currentBlockParts.push(part);
        }
        else {
            if (currentBlockParts.length > 0) {
                escapedBlocks.push(currentBlockParts.join(''));
                resultParts.push(BLOCK_PLACEHOLDER);
                currentBlockParts = [];
            }
            resultParts.push(part);
        }
        if (part == OPEN_CURLY) {
            bracketCount++;
        }
    }
    if (currentBlockParts.length > 0) {
        escapedBlocks.push(currentBlockParts.join(''));
        resultParts.push(BLOCK_PLACEHOLDER);
    }
    return new StringWithEscapedBlocks(resultParts.join(''), escapedBlocks);
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var COMPONENT_VARIABLE = '%COMP%';
var HOST_ATTR = "_nghost-" + COMPONENT_VARIABLE;
var CONTENT_ATTR = "_ngcontent-" + COMPONENT_VARIABLE;
var StylesCompileDependency = (function () {
    /**
     * @param {?} name
     * @param {?} moduleUrl
     * @param {?} isShimmed
     * @param {?} valuePlaceholder
     */
    function StylesCompileDependency(name, moduleUrl, isShimmed, valuePlaceholder) {
        this.name = name;
        this.moduleUrl = moduleUrl;
        this.isShimmed = isShimmed;
        this.valuePlaceholder = valuePlaceholder;
    }
    return StylesCompileDependency;
}());
var StylesCompileResult = (function () {
    /**
     * @param {?} componentStylesheet
     * @param {?} externalStylesheets
     */
    function StylesCompileResult(componentStylesheet, externalStylesheets) {
        this.componentStylesheet = componentStylesheet;
        this.externalStylesheets = externalStylesheets;
    }
    return StylesCompileResult;
}());
var CompiledStylesheet = (function () {
    /**
     * @param {?} statements
     * @param {?} stylesVar
     * @param {?} dependencies
     * @param {?} isShimmed
     * @param {?} meta
     */
    function CompiledStylesheet(statements, stylesVar, dependencies, isShimmed, meta) {
        this.statements = statements;
        this.stylesVar = stylesVar;
        this.dependencies = dependencies;
        this.isShimmed = isShimmed;
        this.meta = meta;
    }
    return CompiledStylesheet;
}());
var StyleCompiler = (function () {
    /**
     * @param {?} _urlResolver
     */
    function StyleCompiler(_urlResolver) {
        this._urlResolver = _urlResolver;
        this._shadowCss = new ShadowCss();
    }
    /**
     * @param {?} comp
     * @return {?}
     */
    StyleCompiler.prototype.compileComponent = function (comp) {
        var _this = this;
        var /** @type {?} */ template = ((comp.template));
        var /** @type {?} */ externalStylesheets = [];
        var /** @type {?} */ componentStylesheet = this._compileStyles(comp, new CompileStylesheetMetadata({
            styles: template.styles,
            styleUrls: template.styleUrls,
            moduleUrl: identifierModuleUrl(comp.type)
        }), true);
        template.externalStylesheets.forEach(function (stylesheetMeta) {
            var /** @type {?} */ compiledStylesheet = _this._compileStyles(comp, stylesheetMeta, false);
            externalStylesheets.push(compiledStylesheet);
        });
        return new StylesCompileResult(componentStylesheet, externalStylesheets);
    };
    /**
     * @param {?} comp
     * @param {?} stylesheet
     * @param {?} isComponentStylesheet
     * @return {?}
     */
    StyleCompiler.prototype._compileStyles = function (comp, stylesheet, isComponentStylesheet) {
        var _this = this;
        var /** @type {?} */ shim = ((comp.template)).encapsulation === __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewEncapsulation"].Emulated;
        var /** @type {?} */ styleExpressions = stylesheet.styles.map(function (plainStyle) { return literal(_this._shimIfNeeded(plainStyle, shim)); });
        var /** @type {?} */ dependencies = [];
        for (var /** @type {?} */ i = 0; i < stylesheet.styleUrls.length; i++) {
            var /** @type {?} */ identifier = { reference: null };
            dependencies.push(new StylesCompileDependency(getStylesVarName(null), stylesheet.styleUrls[i], shim, identifier));
            styleExpressions.push(new ExternalExpr(identifier));
        }
        // styles variable contains plain strings and arrays of other styles arrays (recursive),
        // so we set its type to dynamic.
        var /** @type {?} */ stylesVar = getStylesVarName(isComponentStylesheet ? comp : null);
        var /** @type {?} */ stmt = variable(stylesVar)
            .set(literalArr(styleExpressions, new ArrayType(DYNAMIC_TYPE, [TypeModifier.Const])))
            .toDeclStmt(null, [StmtModifier.Final]);
        return new CompiledStylesheet([stmt], stylesVar, dependencies, shim, stylesheet);
    };
    /**
     * @param {?} style
     * @param {?} shim
     * @return {?}
     */
    StyleCompiler.prototype._shimIfNeeded = function (style$$1, shim) {
        return shim ? this._shadowCss.shimCssText(style$$1, CONTENT_ATTR, HOST_ATTR) : style$$1;
    };
    return StyleCompiler;
}());
StyleCompiler.decorators = [
    { type: CompilerInjectable },
];
/**
 * @nocollapse
 */
StyleCompiler.ctorParameters = function () { return [
    { type: UrlResolver, },
]; };
/**
 * @param {?} component
 * @return {?}
 */
function getStylesVarName(component) {
    var /** @type {?} */ result = "styles";
    if (component) {
        result += "_" + identifierName(component.type);
    }
    return result;
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var EventHandlerVars = (function () {
    function EventHandlerVars() {
    }
    return EventHandlerVars;
}());
EventHandlerVars.event = variable('$event');
var ConvertActionBindingResult = (function () {
    /**
     * @param {?} stmts
     * @param {?} allowDefault
     */
    function ConvertActionBindingResult(stmts, allowDefault) {
        this.stmts = stmts;
        this.allowDefault = allowDefault;
    }
    return ConvertActionBindingResult;
}());
/**
 * Converts the given expression AST into an executable output AST, assuming the expression is
 * used in an action binding (e.g. an event handler).
 * @param {?} localResolver
 * @param {?} implicitReceiver
 * @param {?} action
 * @param {?} bindingId
 * @return {?}
 */
function convertActionBinding(localResolver, implicitReceiver, action, bindingId) {
    if (!localResolver) {
        localResolver = new DefaultLocalResolver();
    }
    var /** @type {?} */ actionWithoutBuiltins = convertPropertyBindingBuiltins({
        createLiteralArrayConverter: function (argCount) {
            // Note: no caching for literal arrays in actions.
            return function (args) { return literalArr(args); };
        },
        createLiteralMapConverter: function (keys) {
            // Note: no caching for literal maps in actions.
            return function (args) { return literalMap(/** @type {?} */ (keys.map(function (key, i) { return [key, args[i]]; }))); };
        },
        createPipeConverter: function (name) {
            throw new Error("Illegal State: Actions are not allowed to contain pipes. Pipe: " + name);
        }
    }, action);
    var /** @type {?} */ visitor = new _AstToIrVisitor(localResolver, implicitReceiver, bindingId);
    var /** @type {?} */ actionStmts = [];
    flattenStatements(actionWithoutBuiltins.visit(visitor, _Mode.Statement), actionStmts);
    prependTemporaryDecls(visitor.temporaryCount, bindingId, actionStmts);
    var /** @type {?} */ lastIndex = actionStmts.length - 1;
    var /** @type {?} */ preventDefaultVar = ((null));
    if (lastIndex >= 0) {
        var /** @type {?} */ lastStatement = actionStmts[lastIndex];
        var /** @type {?} */ returnExpr = convertStmtIntoExpression(lastStatement);
        if (returnExpr) {
            // Note: We need to cast the result of the method call to dynamic,
            // as it might be a void method!
            preventDefaultVar = createPreventDefaultVar(bindingId);
            actionStmts[lastIndex] =
                preventDefaultVar.set(returnExpr.cast(DYNAMIC_TYPE).notIdentical(literal(false)))
                    .toDeclStmt(null, [StmtModifier.Final]);
        }
    }
    return new ConvertActionBindingResult(actionStmts, preventDefaultVar);
}
/**
 * @param {?} converterFactory
 * @param {?} ast
 * @return {?}
 */
function convertPropertyBindingBuiltins(converterFactory, ast) {
    return convertBuiltins(converterFactory, ast);
}
var ConvertPropertyBindingResult = (function () {
    /**
     * @param {?} stmts
     * @param {?} currValExpr
     */
    function ConvertPropertyBindingResult(stmts, currValExpr) {
        this.stmts = stmts;
        this.currValExpr = currValExpr;
    }
    return ConvertPropertyBindingResult;
}());
/**
 * Converts the given expression AST into an executable output AST, assuming the expression
 * is used in property binding. The expression has to be preprocessed via
 * `convertPropertyBindingBuiltins`.
 * @param {?} localResolver
 * @param {?} implicitReceiver
 * @param {?} expressionWithoutBuiltins
 * @param {?} bindingId
 * @return {?}
 */
function convertPropertyBinding(localResolver, implicitReceiver, expressionWithoutBuiltins, bindingId) {
    if (!localResolver) {
        localResolver = new DefaultLocalResolver();
    }
    var /** @type {?} */ currValExpr = createCurrValueExpr(bindingId);
    var /** @type {?} */ stmts = [];
    var /** @type {?} */ visitor = new _AstToIrVisitor(localResolver, implicitReceiver, bindingId);
    var /** @type {?} */ outputExpr = expressionWithoutBuiltins.visit(visitor, _Mode.Expression);
    if (visitor.temporaryCount) {
        for (var /** @type {?} */ i = 0; i < visitor.temporaryCount; i++) {
            stmts.push(temporaryDeclaration(bindingId, i));
        }
    }
    stmts.push(currValExpr.set(outputExpr).toDeclStmt(null, [StmtModifier.Final]));
    return new ConvertPropertyBindingResult(stmts, currValExpr);
}
/**
 * @param {?} converterFactory
 * @param {?} ast
 * @return {?}
 */
function convertBuiltins(converterFactory, ast) {
    var /** @type {?} */ visitor = new _BuiltinAstConverter(converterFactory);
    return ast.visit(visitor);
}
/**
 * @param {?} bindingId
 * @param {?} temporaryNumber
 * @return {?}
 */
function temporaryName(bindingId, temporaryNumber) {
    return "tmp_" + bindingId + "_" + temporaryNumber;
}
/**
 * @param {?} bindingId
 * @param {?} temporaryNumber
 * @return {?}
 */
function temporaryDeclaration(bindingId, temporaryNumber) {
    return new DeclareVarStmt(temporaryName(bindingId, temporaryNumber), NULL_EXPR);
}
/**
 * @param {?} temporaryCount
 * @param {?} bindingId
 * @param {?} statements
 * @return {?}
 */
function prependTemporaryDecls(temporaryCount, bindingId, statements) {
    for (var /** @type {?} */ i = temporaryCount - 1; i >= 0; i--) {
        statements.unshift(temporaryDeclaration(bindingId, i));
    }
}
var _Mode = {};
_Mode.Statement = 0;
_Mode.Expression = 1;
_Mode[_Mode.Statement] = "Statement";
_Mode[_Mode.Expression] = "Expression";
/**
 * @param {?} mode
 * @param {?} ast
 * @return {?}
 */
function ensureStatementMode(mode, ast) {
    if (mode !== _Mode.Statement) {
        throw new Error("Expected a statement, but saw " + ast);
    }
}
/**
 * @param {?} mode
 * @param {?} ast
 * @return {?}
 */
function ensureExpressionMode(mode, ast) {
    if (mode !== _Mode.Expression) {
        throw new Error("Expected an expression, but saw " + ast);
    }
}
/**
 * @param {?} mode
 * @param {?} expr
 * @return {?}
 */
function convertToStatementIfNeeded(mode, expr) {
    if (mode === _Mode.Statement) {
        return expr.toStmt();
    }
    else {
        return expr;
    }
}
var _BuiltinAstConverter = (function (_super) {
    __extends(_BuiltinAstConverter, _super);
    /**
     * @param {?} _converterFactory
     */
    function _BuiltinAstConverter(_converterFactory) {
        var _this = _super.call(this) || this;
        _this._converterFactory = _converterFactory;
        return _this;
    }
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    _BuiltinAstConverter.prototype.visitPipe = function (ast, context) {
        var _this = this;
        var /** @type {?} */ args = [ast.exp].concat(ast.args).map(function (ast) { return ast.visit(_this, context); });
        return new BuiltinFunctionCall(ast.span, args, this._converterFactory.createPipeConverter(ast.name, args.length));
    };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    _BuiltinAstConverter.prototype.visitLiteralArray = function (ast, context) {
        var _this = this;
        var /** @type {?} */ args = ast.expressions.map(function (ast) { return ast.visit(_this, context); });
        return new BuiltinFunctionCall(ast.span, args, this._converterFactory.createLiteralArrayConverter(ast.expressions.length));
    };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    _BuiltinAstConverter.prototype.visitLiteralMap = function (ast, context) {
        var _this = this;
        var /** @type {?} */ args = ast.values.map(function (ast) { return ast.visit(_this, context); });
        return new BuiltinFunctionCall(ast.span, args, this._converterFactory.createLiteralMapConverter(ast.keys));
    };
    return _BuiltinAstConverter;
}(AstTransformer));
var _AstToIrVisitor = (function () {
    /**
     * @param {?} _localResolver
     * @param {?} _implicitReceiver
     * @param {?} bindingId
     */
    function _AstToIrVisitor(_localResolver, _implicitReceiver, bindingId) {
        this._localResolver = _localResolver;
        this._implicitReceiver = _implicitReceiver;
        this.bindingId = bindingId;
        this._nodeMap = new Map();
        this._resultMap = new Map();
        this._currentTemporary = 0;
        this.temporaryCount = 0;
    }
    /**
     * @param {?} ast
     * @param {?} mode
     * @return {?}
     */
    _AstToIrVisitor.prototype.visitBinary = function (ast, mode) {
        var /** @type {?} */ op;
        switch (ast.operation) {
            case '+':
                op = BinaryOperator.Plus;
                break;
            case '-':
                op = BinaryOperator.Minus;
                break;
            case '*':
                op = BinaryOperator.Multiply;
                break;
            case '/':
                op = BinaryOperator.Divide;
                break;
            case '%':
                op = BinaryOperator.Modulo;
                break;
            case '&&':
                op = BinaryOperator.And;
                break;
            case '||':
                op = BinaryOperator.Or;
                break;
            case '==':
                op = BinaryOperator.Equals;
                break;
            case '!=':
                op = BinaryOperator.NotEquals;
                break;
            case '===':
                op = BinaryOperator.Identical;
                break;
            case '!==':
                op = BinaryOperator.NotIdentical;
                break;
            case '<':
                op = BinaryOperator.Lower;
                break;
            case '>':
                op = BinaryOperator.Bigger;
                break;
            case '<=':
                op = BinaryOperator.LowerEquals;
                break;
            case '>=':
                op = BinaryOperator.BiggerEquals;
                break;
            default:
                throw new Error("Unsupported operation " + ast.operation);
        }
        return convertToStatementIfNeeded(mode, new BinaryOperatorExpr(op, this.visit(ast.left, _Mode.Expression), this.visit(ast.right, _Mode.Expression)));
    };
    /**
     * @param {?} ast
     * @param {?} mode
     * @return {?}
     */
    _AstToIrVisitor.prototype.visitChain = function (ast, mode) {
        ensureStatementMode(mode, ast);
        return this.visitAll(ast.expressions, mode);
    };
    /**
     * @param {?} ast
     * @param {?} mode
     * @return {?}
     */
    _AstToIrVisitor.prototype.visitConditional = function (ast, mode) {
        var /** @type {?} */ value = this.visit(ast.condition, _Mode.Expression);
        return convertToStatementIfNeeded(mode, value.conditional(this.visit(ast.trueExp, _Mode.Expression), this.visit(ast.falseExp, _Mode.Expression)));
    };
    /**
     * @param {?} ast
     * @param {?} mode
     * @return {?}
     */
    _AstToIrVisitor.prototype.visitPipe = function (ast, mode) {
        throw new Error("Illegal state: Pipes should have been converted into functions. Pipe: " + ast.name);
    };
    /**
     * @param {?} ast
     * @param {?} mode
     * @return {?}
     */
    _AstToIrVisitor.prototype.visitFunctionCall = function (ast, mode) {
        var /** @type {?} */ convertedArgs = this.visitAll(ast.args, _Mode.Expression);
        var /** @type {?} */ fnResult;
        if (ast instanceof BuiltinFunctionCall) {
            fnResult = ast.converter(convertedArgs);
        }
        else {
            fnResult = this.visit(/** @type {?} */ ((ast.target)), _Mode.Expression).callFn(convertedArgs);
        }
        return convertToStatementIfNeeded(mode, fnResult);
    };
    /**
     * @param {?} ast
     * @param {?} mode
     * @return {?}
     */
    _AstToIrVisitor.prototype.visitImplicitReceiver = function (ast, mode) {
        ensureExpressionMode(mode, ast);
        return this._implicitReceiver;
    };
    /**
     * @param {?} ast
     * @param {?} mode
     * @return {?}
     */
    _AstToIrVisitor.prototype.visitInterpolation = function (ast, mode) {
        ensureExpressionMode(mode, ast);
        var /** @type {?} */ args = [literal(ast.expressions.length)];
        for (var /** @type {?} */ i = 0; i < ast.strings.length - 1; i++) {
            args.push(literal(ast.strings[i]));
            args.push(this.visit(ast.expressions[i], _Mode.Expression));
        }
        args.push(literal(ast.strings[ast.strings.length - 1]));
        return ast.expressions.length <= 9 ?
            importExpr(createIdentifier(Identifiers.inlineInterpolate)).callFn(args) :
            importExpr(createIdentifier(Identifiers.interpolate)).callFn([
                args[0], literalArr(args.slice(1))
            ]);
    };
    /**
     * @param {?} ast
     * @param {?} mode
     * @return {?}
     */
    _AstToIrVisitor.prototype.visitKeyedRead = function (ast, mode) {
        var /** @type {?} */ leftMostSafe = this.leftMostSafeNode(ast);
        if (leftMostSafe) {
            return this.convertSafeAccess(ast, leftMostSafe, mode);
        }
        else {
            return convertToStatementIfNeeded(mode, this.visit(ast.obj, _Mode.Expression).key(this.visit(ast.key, _Mode.Expression)));
        }
    };
    /**
     * @param {?} ast
     * @param {?} mode
     * @return {?}
     */
    _AstToIrVisitor.prototype.visitKeyedWrite = function (ast, mode) {
        var /** @type {?} */ obj = this.visit(ast.obj, _Mode.Expression);
        var /** @type {?} */ key = this.visit(ast.key, _Mode.Expression);
        var /** @type {?} */ value = this.visit(ast.value, _Mode.Expression);
        return convertToStatementIfNeeded(mode, obj.key(key).set(value));
    };
    /**
     * @param {?} ast
     * @param {?} mode
     * @return {?}
     */
    _AstToIrVisitor.prototype.visitLiteralArray = function (ast, mode) {
        throw new Error("Illegal State: literal arrays should have been converted into functions");
    };
    /**
     * @param {?} ast
     * @param {?} mode
     * @return {?}
     */
    _AstToIrVisitor.prototype.visitLiteralMap = function (ast, mode) {
        throw new Error("Illegal State: literal maps should have been converted into functions");
    };
    /**
     * @param {?} ast
     * @param {?} mode
     * @return {?}
     */
    _AstToIrVisitor.prototype.visitLiteralPrimitive = function (ast, mode) {
        return convertToStatementIfNeeded(mode, literal(ast.value));
    };
    /**
     * @param {?} name
     * @return {?}
     */
    _AstToIrVisitor.prototype._getLocal = function (name) { return this._localResolver.getLocal(name); };
    /**
     * @param {?} ast
     * @param {?} mode
     * @return {?}
     */
    _AstToIrVisitor.prototype.visitMethodCall = function (ast, mode) {
        var /** @type {?} */ leftMostSafe = this.leftMostSafeNode(ast);
        if (leftMostSafe) {
            return this.convertSafeAccess(ast, leftMostSafe, mode);
        }
        else {
            var /** @type {?} */ args = this.visitAll(ast.args, _Mode.Expression);
            var /** @type {?} */ result = null;
            var /** @type {?} */ receiver = this.visit(ast.receiver, _Mode.Expression);
            if (receiver === this._implicitReceiver) {
                var /** @type {?} */ varExpr = this._getLocal(ast.name);
                if (varExpr) {
                    result = varExpr.callFn(args);
                }
            }
            if (result == null) {
                result = receiver.callMethod(ast.name, args);
            }
            return convertToStatementIfNeeded(mode, result);
        }
    };
    /**
     * @param {?} ast
     * @param {?} mode
     * @return {?}
     */
    _AstToIrVisitor.prototype.visitPrefixNot = function (ast, mode) {
        return convertToStatementIfNeeded(mode, not(this.visit(ast.expression, _Mode.Expression)));
    };
    /**
     * @param {?} ast
     * @param {?} mode
     * @return {?}
     */
    _AstToIrVisitor.prototype.visitPropertyRead = function (ast, mode) {
        var /** @type {?} */ leftMostSafe = this.leftMostSafeNode(ast);
        if (leftMostSafe) {
            return this.convertSafeAccess(ast, leftMostSafe, mode);
        }
        else {
            var /** @type {?} */ result = null;
            var /** @type {?} */ receiver = this.visit(ast.receiver, _Mode.Expression);
            if (receiver === this._implicitReceiver) {
                result = this._getLocal(ast.name);
            }
            if (result == null) {
                result = receiver.prop(ast.name);
            }
            return convertToStatementIfNeeded(mode, result);
        }
    };
    /**
     * @param {?} ast
     * @param {?} mode
     * @return {?}
     */
    _AstToIrVisitor.prototype.visitPropertyWrite = function (ast, mode) {
        var /** @type {?} */ receiver = this.visit(ast.receiver, _Mode.Expression);
        if (receiver === this._implicitReceiver) {
            var /** @type {?} */ varExpr = this._getLocal(ast.name);
            if (varExpr) {
                throw new Error('Cannot assign to a reference or variable!');
            }
        }
        return convertToStatementIfNeeded(mode, receiver.prop(ast.name).set(this.visit(ast.value, _Mode.Expression)));
    };
    /**
     * @param {?} ast
     * @param {?} mode
     * @return {?}
     */
    _AstToIrVisitor.prototype.visitSafePropertyRead = function (ast, mode) {
        return this.convertSafeAccess(ast, this.leftMostSafeNode(ast), mode);
    };
    /**
     * @param {?} ast
     * @param {?} mode
     * @return {?}
     */
    _AstToIrVisitor.prototype.visitSafeMethodCall = function (ast, mode) {
        return this.convertSafeAccess(ast, this.leftMostSafeNode(ast), mode);
    };
    /**
     * @param {?} asts
     * @param {?} mode
     * @return {?}
     */
    _AstToIrVisitor.prototype.visitAll = function (asts, mode) {
        var _this = this;
        return asts.map(function (ast) { return _this.visit(ast, mode); });
    };
    /**
     * @param {?} ast
     * @param {?} mode
     * @return {?}
     */
    _AstToIrVisitor.prototype.visitQuote = function (ast, mode) {
        throw new Error("Quotes are not supported for evaluation!\n        Statement: " + ast.uninterpretedExpression + " located at " + ast.location);
    };
    /**
     * @param {?} ast
     * @param {?} mode
     * @return {?}
     */
    _AstToIrVisitor.prototype.visit = function (ast, mode) {
        var /** @type {?} */ result = this._resultMap.get(ast);
        if (result)
            return result;
        return (this._nodeMap.get(ast) || ast).visit(this, mode);
    };
    /**
     * @param {?} ast
     * @param {?} leftMostSafe
     * @param {?} mode
     * @return {?}
     */
    _AstToIrVisitor.prototype.convertSafeAccess = function (ast, leftMostSafe, mode) {
        // If the expression contains a safe access node on the left it needs to be converted to
        // an expression that guards the access to the member by checking the receiver for blank. As
        // execution proceeds from left to right, the left most part of the expression must be guarded
        // first but, because member access is left associative, the right side of the expression is at
        // the top of the AST. The desired result requires lifting a copy of the the left part of the
        // expression up to test it for blank before generating the unguarded version.
        // Consider, for example the following expression: a?.b.c?.d.e
        // This results in the ast:
        //         .
        //        / \
        //       ?.   e
        //      /  \
        //     .    d
        //    / \
        //   ?.  c
        //  /  \
        // a    b
        // The following tree should be generated:
        //
        //        /---- ? ----\
        //       /      |      \
        //     a   /--- ? ---\  null
        //        /     |     \
        //       .      .     null
        //      / \    / \
        //     .  c   .   e
        //    / \    / \
        //   a   b  ,   d
        //         / \
        //        .   c
        //       / \
        //      a   b
        //
        // Notice that the first guard condition is the left hand of the left most safe access node
        // which comes in as leftMostSafe to this routine.
        var /** @type {?} */ guardedExpression = this.visit(leftMostSafe.receiver, _Mode.Expression);
        var /** @type {?} */ temporary = ((undefined));
        if (this.needsTemporary(leftMostSafe.receiver)) {
            // If the expression has method calls or pipes then we need to save the result into a
            // temporary variable to avoid calling stateful or impure code more than once.
            temporary = this.allocateTemporary();
            // Preserve the result in the temporary variable
            guardedExpression = temporary.set(guardedExpression);
            // Ensure all further references to the guarded expression refer to the temporary instead.
            this._resultMap.set(leftMostSafe.receiver, temporary);
        }
        var /** @type {?} */ condition = guardedExpression.isBlank();
        // Convert the ast to an unguarded access to the receiver's member. The map will substitute
        // leftMostNode with its unguarded version in the call to `this.visit()`.
        if (leftMostSafe instanceof SafeMethodCall) {
            this._nodeMap.set(leftMostSafe, new MethodCall(leftMostSafe.span, leftMostSafe.receiver, leftMostSafe.name, leftMostSafe.args));
        }
        else {
            this._nodeMap.set(leftMostSafe, new PropertyRead(leftMostSafe.span, leftMostSafe.receiver, leftMostSafe.name));
        }
        // Recursively convert the node now without the guarded member access.
        var /** @type {?} */ access = this.visit(ast, _Mode.Expression);
        // Remove the mapping. This is not strictly required as the converter only traverses each node
        // once but is safer if the conversion is changed to traverse the nodes more than once.
        this._nodeMap.delete(leftMostSafe);
        // If we allocated a temporary, release it.
        if (temporary) {
            this.releaseTemporary(temporary);
        }
        // Produce the conditional
        return convertToStatementIfNeeded(mode, condition.conditional(literal(null), access));
    };
    /**
     * @param {?} ast
     * @return {?}
     */
    _AstToIrVisitor.prototype.leftMostSafeNode = function (ast) {
        var _this = this;
        var /** @type {?} */ visit = function (visitor, ast) {
            return (_this._nodeMap.get(ast) || ast).visit(visitor);
        };
        return ast.visit({
            /**
             * @param {?} ast
             * @return {?}
             */
            visitBinary: function (ast) { return null; },
            /**
             * @param {?} ast
             * @return {?}
             */
            visitChain: function (ast) { return null; },
            /**
             * @param {?} ast
             * @return {?}
             */
            visitConditional: function (ast) { return null; },
            /**
             * @param {?} ast
             * @return {?}
             */
            visitFunctionCall: function (ast) { return null; },
            /**
             * @param {?} ast
             * @return {?}
             */
            visitImplicitReceiver: function (ast) { return null; },
            /**
             * @param {?} ast
             * @return {?}
             */
            visitInterpolation: function (ast) { return null; },
            /**
             * @param {?} ast
             * @return {?}
             */
            visitKeyedRead: function (ast) { return visit(this, ast.obj); },
            /**
             * @param {?} ast
             * @return {?}
             */
            visitKeyedWrite: function (ast) { return null; },
            /**
             * @param {?} ast
             * @return {?}
             */
            visitLiteralArray: function (ast) { return null; },
            /**
             * @param {?} ast
             * @return {?}
             */
            visitLiteralMap: function (ast) { return null; },
            /**
             * @param {?} ast
             * @return {?}
             */
            visitLiteralPrimitive: function (ast) { return null; },
            /**
             * @param {?} ast
             * @return {?}
             */
            visitMethodCall: function (ast) { return visit(this, ast.receiver); },
            /**
             * @param {?} ast
             * @return {?}
             */
            visitPipe: function (ast) { return null; },
            /**
             * @param {?} ast
             * @return {?}
             */
            visitPrefixNot: function (ast) { return null; },
            /**
             * @param {?} ast
             * @return {?}
             */
            visitPropertyRead: function (ast) { return visit(this, ast.receiver); },
            /**
             * @param {?} ast
             * @return {?}
             */
            visitPropertyWrite: function (ast) { return null; },
            /**
             * @param {?} ast
             * @return {?}
             */
            visitQuote: function (ast) { return null; },
            /**
             * @param {?} ast
             * @return {?}
             */
            visitSafeMethodCall: function (ast) { return visit(this, ast.receiver) || ast; },
            /**
             * @param {?} ast
             * @return {?}
             */
            visitSafePropertyRead: function (ast) {
                return visit(this, ast.receiver) || ast;
            }
        });
    };
    /**
     * @param {?} ast
     * @return {?}
     */
    _AstToIrVisitor.prototype.needsTemporary = function (ast) {
        var _this = this;
        var /** @type {?} */ visit = function (visitor, ast) {
            return ast && (_this._nodeMap.get(ast) || ast).visit(visitor);
        };
        var /** @type {?} */ visitSome = function (visitor, ast) {
            return ast.some(function (ast) { return visit(visitor, ast); });
        };
        return ast.visit({
            /**
             * @param {?} ast
             * @return {?}
             */
            visitBinary: function (ast) { return visit(this, ast.left) || visit(this, ast.right); },
            /**
             * @param {?} ast
             * @return {?}
             */
            visitChain: function (ast) { return false; },
            /**
             * @param {?} ast
             * @return {?}
             */
            visitConditional: function (ast) {
                return visit(this, ast.condition) || visit(this, ast.trueExp) ||
                    visit(this, ast.falseExp);
            },
            /**
             * @param {?} ast
             * @return {?}
             */
            visitFunctionCall: function (ast) { return true; },
            /**
             * @param {?} ast
             * @return {?}
             */
            visitImplicitReceiver: function (ast) { return false; },
            /**
             * @param {?} ast
             * @return {?}
             */
            visitInterpolation: function (ast) { return visitSome(this, ast.expressions); },
            /**
             * @param {?} ast
             * @return {?}
             */
            visitKeyedRead: function (ast) { return false; },
            /**
             * @param {?} ast
             * @return {?}
             */
            visitKeyedWrite: function (ast) { return false; },
            /**
             * @param {?} ast
             * @return {?}
             */
            visitLiteralArray: function (ast) { return true; },
            /**
             * @param {?} ast
             * @return {?}
             */
            visitLiteralMap: function (ast) { return true; },
            /**
             * @param {?} ast
             * @return {?}
             */
            visitLiteralPrimitive: function (ast) { return false; },
            /**
             * @param {?} ast
             * @return {?}
             */
            visitMethodCall: function (ast) { return true; },
            /**
             * @param {?} ast
             * @return {?}
             */
            visitPipe: function (ast) { return true; },
            /**
             * @param {?} ast
             * @return {?}
             */
            visitPrefixNot: function (ast) { return visit(this, ast.expression); },
            /**
             * @param {?} ast
             * @return {?}
             */
            visitPropertyRead: function (ast) { return false; },
            /**
             * @param {?} ast
             * @return {?}
             */
            visitPropertyWrite: function (ast) { return false; },
            /**
             * @param {?} ast
             * @return {?}
             */
            visitQuote: function (ast) { return false; },
            /**
             * @param {?} ast
             * @return {?}
             */
            visitSafeMethodCall: function (ast) { return true; },
            /**
             * @param {?} ast
             * @return {?}
             */
            visitSafePropertyRead: function (ast) { return false; }
        });
    };
    /**
     * @return {?}
     */
    _AstToIrVisitor.prototype.allocateTemporary = function () {
        var /** @type {?} */ tempNumber = this._currentTemporary++;
        this.temporaryCount = Math.max(this._currentTemporary, this.temporaryCount);
        return new ReadVarExpr(temporaryName(this.bindingId, tempNumber));
    };
    /**
     * @param {?} temporary
     * @return {?}
     */
    _AstToIrVisitor.prototype.releaseTemporary = function (temporary) {
        this._currentTemporary--;
        if (temporary.name != temporaryName(this.bindingId, this._currentTemporary)) {
            throw new Error("Temporary " + temporary.name + " released out of order");
        }
    };
    return _AstToIrVisitor;
}());
/**
 * @param {?} arg
 * @param {?} output
 * @return {?}
 */
function flattenStatements(arg, output) {
    if (Array.isArray(arg)) {
        ((arg)).forEach(function (entry) { return flattenStatements(entry, output); });
    }
    else {
        output.push(arg);
    }
}
var DefaultLocalResolver = (function () {
    function DefaultLocalResolver() {
    }
    /**
     * @param {?} name
     * @return {?}
     */
    DefaultLocalResolver.prototype.getLocal = function (name) {
        if (name === EventHandlerVars.event.name) {
            return EventHandlerVars.event;
        }
        return null;
    };
    return DefaultLocalResolver;
}());
/**
 * @param {?} bindingId
 * @return {?}
 */
function createCurrValueExpr(bindingId) {
    return variable("currVal_" + bindingId); // fix syntax highlighting: `
}
/**
 * @param {?} bindingId
 * @return {?}
 */
function createPreventDefaultVar(bindingId) {
    return variable("pd_" + bindingId);
}
/**
 * @param {?} stmt
 * @return {?}
 */
function convertStmtIntoExpression(stmt) {
    if (stmt instanceof ExpressionStatement) {
        return stmt.expr;
    }
    else if (stmt instanceof ReturnStatement) {
        return stmt.value;
    }
    return null;
}
var BuiltinFunctionCall = (function (_super) {
    __extends(BuiltinFunctionCall, _super);
    /**
     * @param {?} span
     * @param {?} args
     * @param {?} converter
     */
    function BuiltinFunctionCall(span, args, converter) {
        var _this = _super.call(this, span, null, args) || this;
        _this.args = args;
        _this.converter = converter;
        return _this;
    }
    return BuiltinFunctionCall;
}(FunctionCall));
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var CLASS_ATTR$1 = 'class';
var STYLE_ATTR = 'style';
var IMPLICIT_TEMPLATE_VAR = '\$implicit';
var ViewCompileResult = (function () {
    /**
     * @param {?} statements
     * @param {?} viewClassVar
     * @param {?} rendererTypeVar
     */
    function ViewCompileResult(statements, viewClassVar, rendererTypeVar) {
        this.statements = statements;
        this.viewClassVar = viewClassVar;
        this.rendererTypeVar = rendererTypeVar;
    }
    return ViewCompileResult;
}());
var ViewCompiler = (function () {
    /**
     * @param {?} _genConfigNext
     * @param {?} _schemaRegistry
     */
    function ViewCompiler(_genConfigNext, _schemaRegistry) {
        this._genConfigNext = _genConfigNext;
        this._schemaRegistry = _schemaRegistry;
    }
    /**
     * @param {?} component
     * @param {?} template
     * @param {?} styles
     * @param {?} usedPipes
     * @return {?}
     */
    ViewCompiler.prototype.compileComponent = function (component, template, styles, usedPipes) {
        var /** @type {?} */ embeddedViewCount = 0;
        var /** @type {?} */ staticQueryIds = findStaticQueryIds(template);
        var /** @type {?} */ statements = [];
        var /** @type {?} */ renderComponentVarName = ((undefined));
        if (!component.isHost) {
            var /** @type {?} */ template_1 = ((component.template));
            var /** @type {?} */ customRenderData = [];
            if (template_1.animations && template_1.animations.length) {
                customRenderData.push(new LiteralMapEntry('animation', convertValueToOutputAst(template_1.animations), true));
            }
            var /** @type {?} */ renderComponentVar = variable(rendererTypeName(component.type.reference));
            renderComponentVarName = ((renderComponentVar.name));
            statements.push(renderComponentVar
                .set(importExpr(createIdentifier(Identifiers.createRendererType2))
                .callFn([new LiteralMapExpr([
                    new LiteralMapEntry('encapsulation', literal(template_1.encapsulation)),
                    new LiteralMapEntry('styles', styles),
                    new LiteralMapEntry('data', new LiteralMapExpr(customRenderData))
                ])]))
                .toDeclStmt(importType(createIdentifier(Identifiers.RendererType2)), [StmtModifier.Final]));
        }
        var /** @type {?} */ viewBuilderFactory = function (parent) {
            var /** @type {?} */ embeddedViewIndex = embeddedViewCount++;
            return new ViewBuilder(parent, component, embeddedViewIndex, usedPipes, staticQueryIds, viewBuilderFactory);
        };
        var /** @type {?} */ visitor = viewBuilderFactory(null);
        visitor.visitAll([], template);
        statements.push.apply(statements, visitor.build());
        return new ViewCompileResult(statements, visitor.viewName, renderComponentVarName);
    };
    return ViewCompiler;
}());
ViewCompiler.decorators = [
    { type: CompilerInjectable },
];
/**
 * @nocollapse
 */
ViewCompiler.ctorParameters = function () { return [
    { type: CompilerConfig, },
    { type: ElementSchemaRegistry, },
]; };
var LOG_VAR = variable('l');
var VIEW_VAR = variable('v');
var CHECK_VAR = variable('ck');
var COMP_VAR = variable('co');
var EVENT_NAME_VAR = variable('en');
var ALLOW_DEFAULT_VAR = variable("ad");
var ViewBuilder = (function () {
    /**
     * @param {?} parent
     * @param {?} component
     * @param {?} embeddedViewIndex
     * @param {?} usedPipes
     * @param {?} staticQueryIds
     * @param {?} viewBuilderFactory
     */
    function ViewBuilder(parent, component, embeddedViewIndex, usedPipes, staticQueryIds, viewBuilderFactory) {
        this.parent = parent;
        this.component = component;
        this.embeddedViewIndex = embeddedViewIndex;
        this.usedPipes = usedPipes;
        this.staticQueryIds = staticQueryIds;
        this.viewBuilderFactory = viewBuilderFactory;
        this.nodes = [];
        this.purePipeNodeIndices = Object.create(null);
        this.refNodeIndices = Object.create(null);
        this.variables = [];
        this.children = [];
        // TODO(tbosch): The old view compiler used to use an `any` type
        // for the context in any embedded view. We keep this behaivor for now
        // to be able to introduce the new view compiler without too many errors.
        this.compType =
            this.embeddedViewIndex > 0 ? DYNAMIC_TYPE : importType(this.component.type);
    }
    Object.defineProperty(ViewBuilder.prototype, "viewName", {
        /**
         * @return {?}
         */
        get: function () {
            return viewClassName(this.component.type.reference, this.embeddedViewIndex);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} variables
     * @param {?} astNodes
     * @return {?}
     */
    ViewBuilder.prototype.visitAll = function (variables, astNodes) {
        var _this = this;
        this.variables = variables;
        // create the pipes for the pure pipes immediately, so that we know their indices.
        if (!this.parent) {
            this.usedPipes.forEach(function (pipe) {
                if (pipe.pure) {
                    _this.purePipeNodeIndices[pipe.name] = _this._createPipe(null, pipe);
                }
            });
        }
        if (!this.parent) {
            var /** @type {?} */ queryIds_1 = staticViewQueryIds(this.staticQueryIds);
            this.component.viewQueries.forEach(function (query, queryIndex) {
                // Note: queries start with id 1 so we can use the number in a Bloom filter!
                var /** @type {?} */ queryId = queryIndex + 1;
                var /** @type {?} */ bindingType = query.first ? 0 /* First */ : 1;
                var /** @type {?} */ flags = 67108864 /* TypeViewQuery */ | calcStaticDynamicQueryFlags(queryIds_1, queryId, query.first);
                _this.nodes.push(function () { return ({
                    sourceSpan: null,
                    nodeFlags: flags,
                    nodeDef: importExpr(createIdentifier(Identifiers.queryDef)).callFn([
                        literal(flags), literal(queryId),
                        new LiteralMapExpr([new LiteralMapEntry(query.propertyName, literal(bindingType))])
                    ])
                }); });
            });
        }
        templateVisitAll(this, astNodes);
        if (this.parent && (astNodes.length === 0 || needsAdditionalRootNode(astNodes))) {
            // if the view is an embedded view, then we need to add an additional root node in some cases
            this.nodes.push(function () { return ({
                sourceSpan: null,
                nodeFlags: 1 /* TypeElement */,
                nodeDef: importExpr(createIdentifier(Identifiers.anchorDef)).callFn([
                    literal(0 /* None */), NULL_EXPR, NULL_EXPR, literal(0)
                ])
            }); });
        }
    };
    /**
     * @param {?=} targetStatements
     * @return {?}
     */
    ViewBuilder.prototype.build = function (targetStatements) {
        if (targetStatements === void 0) { targetStatements = []; }
        this.children.forEach(function (child) { return child.build(targetStatements); });
        var _a = this._createNodeExpressions(), updateRendererStmts = _a.updateRendererStmts, updateDirectivesStmts = _a.updateDirectivesStmts, nodeDefExprs = _a.nodeDefExprs;
        var /** @type {?} */ updateRendererFn = this._createUpdateFn(updateRendererStmts);
        var /** @type {?} */ updateDirectivesFn = this._createUpdateFn(updateDirectivesStmts);
        var /** @type {?} */ viewFlags = 0;
        if (!this.parent && this.component.changeDetection === __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectionStrategy"].OnPush) {
            viewFlags |= 2 /* OnPush */;
        }
        var /** @type {?} */ viewFactory = new DeclareFunctionStmt(this.viewName, [new FnParam(/** @type {?} */ ((LOG_VAR.name)))], [new ReturnStatement(importExpr(createIdentifier(Identifiers.viewDef)).callFn([
                literal(viewFlags),
                literalArr(nodeDefExprs),
                updateDirectivesFn,
                updateRendererFn,
            ]))], importType(createIdentifier(Identifiers.ViewDefinition)));
        targetStatements.push(viewFactory);
        return targetStatements;
    };
    /**
     * @param {?} updateStmts
     * @return {?}
     */
    ViewBuilder.prototype._createUpdateFn = function (updateStmts) {
        var /** @type {?} */ updateFn;
        if (updateStmts.length > 0) {
            var /** @type {?} */ preStmts = [];
            if (!this.component.isHost && findReadVarNames(updateStmts).has(/** @type {?} */ ((COMP_VAR.name)))) {
                preStmts.push(COMP_VAR.set(VIEW_VAR.prop('component')).toDeclStmt(this.compType));
            }
            updateFn = fn([
                new FnParam(/** @type {?} */ ((CHECK_VAR.name)), INFERRED_TYPE),
                new FnParam(/** @type {?} */ ((VIEW_VAR.name)), INFERRED_TYPE)
            ], preStmts.concat(updateStmts), INFERRED_TYPE);
        }
        else {
            updateFn = NULL_EXPR;
        }
        return updateFn;
    };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    ViewBuilder.prototype.visitNgContent = function (ast, context) {
        // ngContentDef(ngContentIndex: number, index: number): NodeDef;
        this.nodes.push(function () { return ({
            sourceSpan: ast.sourceSpan,
            nodeFlags: 4 /* TypeNgContent */,
            nodeDef: importExpr(createIdentifier(Identifiers.ngContentDef)).callFn([
                literal(ast.ngContentIndex), literal(ast.index)
            ])
        }); });
    };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    ViewBuilder.prototype.visitText = function (ast, context) {
        // textDef(ngContentIndex: number, constants: string[]): NodeDef;
        this.nodes.push(function () { return ({
            sourceSpan: ast.sourceSpan,
            nodeFlags: 2 /* TypeText */,
            nodeDef: importExpr(createIdentifier(Identifiers.textDef)).callFn([
                literal(ast.ngContentIndex), literalArr([literal(ast.value)])
            ])
        }); });
    };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    ViewBuilder.prototype.visitBoundText = function (ast, context) {
        var _this = this;
        var /** @type {?} */ nodeIndex = this.nodes.length;
        // reserve the space in the nodeDefs array
        this.nodes.push(/** @type {?} */ ((null)));
        var /** @type {?} */ astWithSource = (ast.value);
        var /** @type {?} */ inter = (astWithSource.ast);
        var /** @type {?} */ updateRendererExpressions = inter.expressions.map(function (expr, bindingIndex) { return _this._preprocessUpdateExpression({ nodeIndex: nodeIndex, bindingIndex: bindingIndex, sourceSpan: ast.sourceSpan, context: COMP_VAR, value: expr }); });
        // textDef(ngContentIndex: number, constants: string[]): NodeDef;
        this.nodes[nodeIndex] = function () { return ({
            sourceSpan: ast.sourceSpan,
            nodeFlags: 2 /* TypeText */,
            nodeDef: importExpr(createIdentifier(Identifiers.textDef)).callFn([
                literal(ast.ngContentIndex), literalArr(inter.strings.map(function (s) { return literal(s); }))
            ]),
            updateRenderer: updateRendererExpressions
        }); };
    };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    ViewBuilder.prototype.visitEmbeddedTemplate = function (ast, context) {
        var _this = this;
        var /** @type {?} */ nodeIndex = this.nodes.length;
        // reserve the space in the nodeDefs array
        this.nodes.push(/** @type {?} */ ((null)));
        var _a = this._visitElementOrTemplate(nodeIndex, ast), flags = _a.flags, queryMatchesExpr = _a.queryMatchesExpr, hostEvents = _a.hostEvents;
        var /** @type {?} */ childVisitor = this.viewBuilderFactory(this);
        this.children.push(childVisitor);
        childVisitor.visitAll(ast.variables, ast.children);
        var /** @type {?} */ childCount = this.nodes.length - nodeIndex - 1;
        // anchorDef(
        //   flags: NodeFlags, matchedQueries: [string, QueryValueType][], ngContentIndex: number,
        //   childCount: number, handleEventFn?: ElementHandleEventFn, templateFactory?:
        //   ViewDefinitionFactory): NodeDef;
        this.nodes[nodeIndex] = function () { return ({
            sourceSpan: ast.sourceSpan,
            nodeFlags: 1 /* TypeElement */ | flags,
            nodeDef: importExpr(createIdentifier(Identifiers.anchorDef)).callFn([
                literal(flags),
                queryMatchesExpr,
                literal(ast.ngContentIndex),
                literal(childCount),
                _this._createElementHandleEventFn(nodeIndex, hostEvents),
                variable(childVisitor.viewName),
            ])
        }); };
    };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    ViewBuilder.prototype.visitElement = function (ast, context) {
        var _this = this;
        var /** @type {?} */ nodeIndex = this.nodes.length;
        // reserve the space in the nodeDefs array so we can add children
        this.nodes.push(/** @type {?} */ ((null)));
        // Using a null element name creates an anchor.
        var /** @type {?} */ elName = isNgContainer(ast.name) ? null : ast.name;
        var _a = this._visitElementOrTemplate(nodeIndex, ast), flags = _a.flags, usedEvents = _a.usedEvents, queryMatchesExpr = _a.queryMatchesExpr, dirHostBindings = _a.hostBindings, hostEvents = _a.hostEvents;
        var /** @type {?} */ inputDefs = [];
        var /** @type {?} */ updateRendererExpressions = [];
        var /** @type {?} */ outputDefs = [];
        if (elName) {
            var /** @type {?} */ hostBindings = ast.inputs
                .map(function (inputAst) { return ({
                context: /** @type {?} */ (COMP_VAR),
                inputAst: inputAst,
                dirAst: /** @type {?} */ (null),
            }); })
                .concat(dirHostBindings);
            if (hostBindings.length) {
                updateRendererExpressions =
                    hostBindings.map(function (hostBinding, bindingIndex) { return _this._preprocessUpdateExpression({
                        context: hostBinding.context,
                        nodeIndex: nodeIndex,
                        bindingIndex: bindingIndex,
                        sourceSpan: hostBinding.inputAst.sourceSpan,
                        value: hostBinding.inputAst.value
                    }); });
                inputDefs = hostBindings.map(function (hostBinding) { return elementBindingDef(hostBinding.inputAst, hostBinding.dirAst); });
            }
            outputDefs = usedEvents.map(function (_a) {
                var target = _a[0], eventName = _a[1];
                return literalArr([literal(target), literal(eventName)]);
            });
        }
        templateVisitAll(this, ast.children);
        var /** @type {?} */ childCount = this.nodes.length - nodeIndex - 1;
        var /** @type {?} */ compAst = ast.directives.find(function (dirAst) { return dirAst.directive.isComponent; });
        var /** @type {?} */ compRendererType = NULL_EXPR;
        var /** @type {?} */ compView = NULL_EXPR;
        if (compAst) {
            compView = importExpr({ reference: compAst.directive.componentViewType });
            compRendererType = importExpr({ reference: compAst.directive.rendererType });
        }
        // elementDef(
        //   flags: NodeFlags, matchedQueriesDsl: [string | number, QueryValueType][],
        //   ngContentIndex: number, childCount: number, namespaceAndName: string,
        //   fixedAttrs: [string, string][] = [],
        //   bindings?: [BindingFlags, string, string | SecurityContext][],
        //   outputs?: ([OutputType.ElementOutput | OutputType.DirectiveHostOutput, string, string])[],
        //   handleEvent?: ElementHandleEventFn,
        //   componentView?: () => ViewDefinition, componentRendererType?: RendererType2): NodeDef;
        this.nodes[nodeIndex] = function () { return ({
            sourceSpan: ast.sourceSpan,
            nodeFlags: 1 /* TypeElement */ | flags,
            nodeDef: importExpr(createIdentifier(Identifiers.elementDef)).callFn([
                literal(flags),
                queryMatchesExpr,
                literal(ast.ngContentIndex),
                literal(childCount),
                literal(elName),
                elName ? fixedAttrsDef(ast) : NULL_EXPR,
                inputDefs.length ? literalArr(inputDefs) : NULL_EXPR,
                outputDefs.length ? literalArr(outputDefs) : NULL_EXPR,
                _this._createElementHandleEventFn(nodeIndex, hostEvents),
                compView,
                compRendererType,
            ]),
            updateRenderer: updateRendererExpressions
        }); };
    };
    /**
     * @param {?} nodeIndex
     * @param {?} ast
     * @return {?}
     */
    ViewBuilder.prototype._visitElementOrTemplate = function (nodeIndex, ast) {
        var _this = this;
        var /** @type {?} */ flags = 0;
        if (ast.hasViewContainer) {
            flags |= 8388608 /* EmbeddedViews */;
        }
        var /** @type {?} */ usedEvents = new Map();
        ast.outputs.forEach(function (event) {
            var _a = elementEventNameAndTarget(event, null), name = _a.name, target = _a.target;
            usedEvents.set(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵelementEventFullName"])(target, name), [target, name]);
        });
        ast.directives.forEach(function (dirAst) {
            dirAst.hostEvents.forEach(function (event) {
                var _a = elementEventNameAndTarget(event, dirAst), name = _a.name, target = _a.target;
                usedEvents.set(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵelementEventFullName"])(target, name), [target, name]);
            });
        });
        var /** @type {?} */ hostBindings = [];
        var /** @type {?} */ hostEvents = [];
        var /** @type {?} */ componentFactoryResolverProvider = createComponentFactoryResolver(ast.directives);
        if (componentFactoryResolverProvider) {
            this._visitProvider(componentFactoryResolverProvider, ast.queryMatches);
        }
        ast.providers.forEach(function (providerAst, providerIndex) {
            var /** @type {?} */ dirAst = ((undefined));
            var /** @type {?} */ dirIndex = ((undefined));
            ast.directives.forEach(function (localDirAst, i) {
                if (localDirAst.directive.type.reference === tokenReference(providerAst.token)) {
                    dirAst = localDirAst;
                    dirIndex = i;
                }
            });
            if (dirAst) {
                var _a = _this._visitDirective(providerAst, dirAst, dirIndex, nodeIndex, ast.references, ast.queryMatches, usedEvents, /** @type {?} */ ((_this.staticQueryIds.get(/** @type {?} */ (ast))))), dirHostBindings = _a.hostBindings, dirHostEvents = _a.hostEvents;
                hostBindings.push.apply(hostBindings, dirHostBindings);
                hostEvents.push.apply(hostEvents, dirHostEvents);
            }
            else {
                _this._visitProvider(providerAst, ast.queryMatches);
            }
        });
        var /** @type {?} */ queryMatchExprs = [];
        ast.queryMatches.forEach(function (match) {
            var /** @type {?} */ valueType = ((undefined));
            if (tokenReference(match.value) === resolveIdentifier(Identifiers.ElementRef)) {
                valueType = 0 /* ElementRef */;
            }
            else if (tokenReference(match.value) === resolveIdentifier(Identifiers.ViewContainerRef)) {
                valueType = 3 /* ViewContainerRef */;
            }
            else if (tokenReference(match.value) === resolveIdentifier(Identifiers.TemplateRef)) {
                valueType = 2 /* TemplateRef */;
            }
            if (valueType != null) {
                queryMatchExprs.push(literalArr([literal(match.queryId), literal(valueType)]));
            }
        });
        ast.references.forEach(function (ref) {
            var /** @type {?} */ valueType = ((undefined));
            if (!ref.value) {
                valueType = 1 /* RenderElement */;
            }
            else if (tokenReference(ref.value) === resolveIdentifier(Identifiers.TemplateRef)) {
                valueType = 2 /* TemplateRef */;
            }
            if (valueType != null) {
                _this.refNodeIndices[ref.name] = nodeIndex;
                queryMatchExprs.push(literalArr([literal(ref.name), literal(valueType)]));
            }
        });
        ast.outputs.forEach(function (outputAst) {
            hostEvents.push({ context: COMP_VAR, eventAst: outputAst, dirAst: /** @type {?} */ ((null)) });
        });
        return {
            flags: flags,
            usedEvents: Array.from(usedEvents.values()),
            queryMatchesExpr: queryMatchExprs.length ? literalArr(queryMatchExprs) : NULL_EXPR,
            hostBindings: hostBindings,
            hostEvents: hostEvents
        };
    };
    /**
     * @param {?} providerAst
     * @param {?} dirAst
     * @param {?} directiveIndex
     * @param {?} elementNodeIndex
     * @param {?} refs
     * @param {?} queryMatches
     * @param {?} usedEvents
     * @param {?} queryIds
     * @return {?}
     */
    ViewBuilder.prototype._visitDirective = function (providerAst, dirAst, directiveIndex, elementNodeIndex, refs, queryMatches, usedEvents, queryIds) {
        var _this = this;
        var /** @type {?} */ nodeIndex = this.nodes.length;
        // reserve the space in the nodeDefs array so we can add children
        this.nodes.push(/** @type {?} */ ((null)));
        dirAst.directive.queries.forEach(function (query, queryIndex) {
            var /** @type {?} */ queryId = dirAst.contentQueryStartId + queryIndex;
            var /** @type {?} */ flags = 33554432 /* TypeContentQuery */ | calcStaticDynamicQueryFlags(queryIds, queryId, query.first);
            var /** @type {?} */ bindingType = query.first ? 0 /* First */ : 1;
            _this.nodes.push(function () { return ({
                sourceSpan: dirAst.sourceSpan,
                nodeFlags: flags,
                nodeDef: importExpr(createIdentifier(Identifiers.queryDef)).callFn([
                    literal(flags), literal(queryId),
                    new LiteralMapExpr([new LiteralMapEntry(query.propertyName, literal(bindingType))])
                ]),
            }); });
        });
        // Note: the operation below might also create new nodeDefs,
        // but we don't want them to be a child of a directive,
        // as they might be a provider/pipe on their own.
        // I.e. we only allow queries as children of directives nodes.
        var /** @type {?} */ childCount = this.nodes.length - nodeIndex - 1;
        var _a = this._visitProviderOrDirective(providerAst, queryMatches), flags = _a.flags, queryMatchExprs = _a.queryMatchExprs, providerExpr = _a.providerExpr, depsExpr = _a.depsExpr;
        refs.forEach(function (ref) {
            if (ref.value && tokenReference(ref.value) === tokenReference(providerAst.token)) {
                _this.refNodeIndices[ref.name] = nodeIndex;
                queryMatchExprs.push(literalArr([literal(ref.name), literal(4 /* Provider */)]));
            }
        });
        if (dirAst.directive.isComponent) {
            flags |= 16384 /* Component */;
        }
        var /** @type {?} */ inputDefs = dirAst.inputs.map(function (inputAst, inputIndex) {
            var /** @type {?} */ mapValue = literalArr([literal(inputIndex), literal(inputAst.directiveName)]);
            // Note: it's important to not quote the key so that we can capture renames by minifiers!
            return new LiteralMapEntry(inputAst.directiveName, mapValue, false);
        });
        var /** @type {?} */ outputDefs = [];
        var /** @type {?} */ dirMeta = dirAst.directive;
        Object.keys(dirMeta.outputs).forEach(function (propName) {
            var /** @type {?} */ eventName = dirMeta.outputs[propName];
            if (usedEvents.has(eventName)) {
                // Note: it's important to not quote the key so that we can capture renames by minifiers!
                outputDefs.push(new LiteralMapEntry(propName, literal(eventName), false));
            }
        });
        var /** @type {?} */ updateDirectiveExpressions = [];
        if (dirAst.inputs.length || (flags & (131072 /* DoCheck */ | 32768 /* OnInit */)) > 0) {
            updateDirectiveExpressions =
                dirAst.inputs.map(function (input, bindingIndex) { return _this._preprocessUpdateExpression({
                    nodeIndex: nodeIndex,
                    bindingIndex: bindingIndex,
                    sourceSpan: input.sourceSpan,
                    context: COMP_VAR,
                    value: input.value
                }); });
        }
        var /** @type {?} */ dirContextExpr = importExpr(createIdentifier(Identifiers.nodeValue)).callFn([
            VIEW_VAR, literal(nodeIndex)
        ]);
        var /** @type {?} */ hostBindings = dirAst.hostProperties.map(function (inputAst) { return ({
            context: dirContextExpr,
            dirAst: dirAst,
            inputAst: inputAst,
        }); });
        var /** @type {?} */ hostEvents = dirAst.hostEvents.map(function (hostEventAst) { return ({
            context: dirContextExpr,
            eventAst: hostEventAst, dirAst: dirAst,
        }); });
        // directiveDef(
        //   flags: NodeFlags, matchedQueries: [string, QueryValueType][], childCount: number, ctor:
        //   any,
        //   deps: ([DepFlags, any] | any)[], props?: {[name: string]: [number, string]},
        //   outputs?: {[name: string]: string}, component?: () => ViewDefinition): NodeDef;
        this.nodes[nodeIndex] = function () { return ({
            sourceSpan: dirAst.sourceSpan,
            nodeFlags: 8192 /* TypeDirective */ | flags,
            nodeDef: importExpr(createIdentifier(Identifiers.directiveDef)).callFn([
                literal(flags), queryMatchExprs.length ? literalArr(queryMatchExprs) : NULL_EXPR,
                literal(childCount), providerExpr, depsExpr,
                inputDefs.length ? new LiteralMapExpr(inputDefs) : NULL_EXPR,
                outputDefs.length ? new LiteralMapExpr(outputDefs) : NULL_EXPR
            ]),
            updateDirectives: updateDirectiveExpressions,
            directive: dirAst.directive.type,
        }); };
        return { hostBindings: hostBindings, hostEvents: hostEvents };
    };
    /**
     * @param {?} providerAst
     * @param {?} queryMatches
     * @return {?}
     */
    ViewBuilder.prototype._visitProvider = function (providerAst, queryMatches) {
        var /** @type {?} */ nodeIndex = this.nodes.length;
        // reserve the space in the nodeDefs array so we can add children
        this.nodes.push(/** @type {?} */ ((null)));
        var _a = this._visitProviderOrDirective(providerAst, queryMatches), flags = _a.flags, queryMatchExprs = _a.queryMatchExprs, providerExpr = _a.providerExpr, depsExpr = _a.depsExpr;
        // providerDef(
        //   flags: NodeFlags, matchedQueries: [string, QueryValueType][], token:any,
        //   value: any, deps: ([DepFlags, any] | any)[]): NodeDef;
        this.nodes[nodeIndex] = function () { return ({
            sourceSpan: providerAst.sourceSpan,
            nodeFlags: flags,
            nodeDef: importExpr(createIdentifier(Identifiers.providerDef)).callFn([
                literal(flags), queryMatchExprs.length ? literalArr(queryMatchExprs) : NULL_EXPR,
                tokenExpr(providerAst.token), providerExpr, depsExpr
            ])
        }); };
    };
    /**
     * @param {?} providerAst
     * @param {?} queryMatches
     * @return {?}
     */
    ViewBuilder.prototype._visitProviderOrDirective = function (providerAst, queryMatches) {
        var /** @type {?} */ flags = 0;
        if (!providerAst.eager) {
            flags |= 2048 /* LazyProvider */;
        }
        if (providerAst.providerType === ProviderAstType.PrivateService) {
            flags |= 4096 /* PrivateProvider */;
        }
        providerAst.lifecycleHooks.forEach(function (lifecycleHook) {
            // for regular providers, we only support ngOnDestroy
            if (lifecycleHook === __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵLifecycleHooks"].OnDestroy ||
                providerAst.providerType === ProviderAstType.Directive ||
                providerAst.providerType === ProviderAstType.Component) {
                flags |= lifecycleHookToNodeFlag(lifecycleHook);
            }
        });
        var /** @type {?} */ queryMatchExprs = [];
        queryMatches.forEach(function (match) {
            if (tokenReference(match.value) === tokenReference(providerAst.token)) {
                queryMatchExprs.push(literalArr([literal(match.queryId), literal(4 /* Provider */)]));
            }
        });
        var _a = providerDef(providerAst), providerExpr = _a.providerExpr, depsExpr = _a.depsExpr, providerType = _a.flags;
        return { flags: flags | providerType, queryMatchExprs: queryMatchExprs, providerExpr: providerExpr, depsExpr: depsExpr };
    };
    /**
     * @param {?} name
     * @return {?}
     */
    ViewBuilder.prototype.getLocal = function (name) {
        if (name == EventHandlerVars.event.name) {
            return EventHandlerVars.event;
        }
        var /** @type {?} */ currViewExpr = VIEW_VAR;
        for (var /** @type {?} */ currBuilder = this; currBuilder; currBuilder = currBuilder.parent,
            currViewExpr = currViewExpr.prop('parent').cast(DYNAMIC_TYPE)) {
            // check references
            var /** @type {?} */ refNodeIndex = currBuilder.refNodeIndices[name];
            if (refNodeIndex != null) {
                return importExpr(createIdentifier(Identifiers.nodeValue)).callFn([
                    currViewExpr, literal(refNodeIndex)
                ]);
            }
            // check variables
            var /** @type {?} */ varAst = currBuilder.variables.find(function (varAst) { return varAst.name === name; });
            if (varAst) {
                var /** @type {?} */ varValue = varAst.value || IMPLICIT_TEMPLATE_VAR;
                return currViewExpr.prop('context').prop(varValue);
            }
        }
        return null;
    };
    /**
     * @param {?} sourceSpan
     * @param {?} argCount
     * @return {?}
     */
    ViewBuilder.prototype.createLiteralArrayConverter = function (sourceSpan, argCount) {
        if (argCount === 0) {
            var /** @type {?} */ valueExpr_1 = importExpr(createIdentifier(Identifiers.EMPTY_ARRAY));
            return function () { return valueExpr_1; };
        }
        var /** @type {?} */ nodeIndex = this.nodes.length;
        // pureArrayDef(argCount: number): NodeDef;
        this.nodes.push(function () { return ({
            sourceSpan: sourceSpan,
            nodeFlags: 16 /* TypePureArray */,
            nodeDef: importExpr(createIdentifier(Identifiers.pureArrayDef)).callFn([literal(argCount)])
        }); });
        return function (args) { return callCheckStmt(nodeIndex, args); };
    };
    /**
     * @param {?} sourceSpan
     * @param {?} keys
     * @return {?}
     */
    ViewBuilder.prototype.createLiteralMapConverter = function (sourceSpan, keys) {
        if (keys.length === 0) {
            var /** @type {?} */ valueExpr_2 = importExpr(createIdentifier(Identifiers.EMPTY_MAP));
            return function () { return valueExpr_2; };
        }
        var /** @type {?} */ nodeIndex = this.nodes.length;
        // function pureObjectDef(propertyNames: string[]): NodeDef
        this.nodes.push(function () { return ({
            sourceSpan: sourceSpan,
            nodeFlags: 32 /* TypePureObject */,
            nodeDef: importExpr(createIdentifier(Identifiers.pureObjectDef))
                .callFn([literalArr(keys.map(function (key) { return literal(key); }))])
        }); });
        return function (args) { return callCheckStmt(nodeIndex, args); };
    };
    /**
     * @param {?} expression
     * @param {?} name
     * @param {?} argCount
     * @return {?}
     */
    ViewBuilder.prototype.createPipeConverter = function (expression, name, argCount) {
        var /** @type {?} */ pipe = ((this.usedPipes.find(function (pipeSummary) { return pipeSummary.name === name; })));
        if (pipe.pure) {
            var /** @type {?} */ nodeIndex_1 = this.nodes.length;
            // function purePipeDef(argCount: number): NodeDef;
            this.nodes.push(function () { return ({
                sourceSpan: expression.sourceSpan,
                nodeFlags: 64 /* TypePurePipe */,
                nodeDef: importExpr(createIdentifier(Identifiers.purePipeDef))
                    .callFn([literal(argCount)])
            }); });
            // find underlying pipe in the component view
            var /** @type {?} */ compViewExpr = VIEW_VAR;
            var /** @type {?} */ compBuilder = this;
            while (compBuilder.parent) {
                compBuilder = compBuilder.parent;
                compViewExpr = compViewExpr.prop('parent').cast(DYNAMIC_TYPE);
            }
            var /** @type {?} */ pipeNodeIndex = compBuilder.purePipeNodeIndices[name];
            var /** @type {?} */ pipeValueExpr_1 = importExpr(createIdentifier(Identifiers.nodeValue)).callFn([
                compViewExpr, literal(pipeNodeIndex)
            ]);
            return function (args) { return callUnwrapValue(expression.nodeIndex, expression.bindingIndex, callCheckStmt(nodeIndex_1, [pipeValueExpr_1].concat(args))); };
        }
        else {
            var /** @type {?} */ nodeIndex = this._createPipe(expression.sourceSpan, pipe);
            var /** @type {?} */ nodeValueExpr_1 = importExpr(createIdentifier(Identifiers.nodeValue)).callFn([
                VIEW_VAR, literal(nodeIndex)
            ]);
            return function (args) { return callUnwrapValue(expression.nodeIndex, expression.bindingIndex, nodeValueExpr_1.callMethod('transform', args)); };
        }
    };
    /**
     * @param {?} sourceSpan
     * @param {?} pipe
     * @return {?}
     */
    ViewBuilder.prototype._createPipe = function (sourceSpan, pipe) {
        var /** @type {?} */ nodeIndex = this.nodes.length;
        var /** @type {?} */ flags = 0;
        pipe.type.lifecycleHooks.forEach(function (lifecycleHook) {
            // for pipes, we only support ngOnDestroy
            if (lifecycleHook === __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵLifecycleHooks"].OnDestroy) {
                flags |= lifecycleHookToNodeFlag(lifecycleHook);
            }
        });
        var /** @type {?} */ depExprs = pipe.type.diDeps.map(depDef);
        // function pipeDef(
        //   flags: NodeFlags, ctor: any, deps: ([DepFlags, any] | any)[]): NodeDef
        this.nodes.push(function () { return ({
            sourceSpan: sourceSpan,
            nodeFlags: 8 /* TypePipe */,
            nodeDef: importExpr(createIdentifier(Identifiers.pipeDef)).callFn([
                literal(flags), importExpr(pipe.type), literalArr(depExprs)
            ])
        }); });
        return nodeIndex;
    };
    /**
     * @param {?} expression
     * @return {?}
     */
    ViewBuilder.prototype._preprocessUpdateExpression = function (expression) {
        var _this = this;
        return {
            nodeIndex: expression.nodeIndex,
            bindingIndex: expression.bindingIndex,
            sourceSpan: expression.sourceSpan,
            context: expression.context,
            value: convertPropertyBindingBuiltins({
                createLiteralArrayConverter: function (argCount) { return _this.createLiteralArrayConverter(expression.sourceSpan, argCount); },
                createLiteralMapConverter: function (keys) { return _this.createLiteralMapConverter(expression.sourceSpan, keys); },
                createPipeConverter: function (name, argCount) { return _this.createPipeConverter(expression, name, argCount); }
            }, expression.value)
        };
    };
    /**
     * @return {?}
     */
    ViewBuilder.prototype._createNodeExpressions = function () {
        var /** @type {?} */ self = this;
        var /** @type {?} */ updateBindingCount = 0;
        var /** @type {?} */ updateRendererStmts = [];
        var /** @type {?} */ updateDirectivesStmts = [];
        var /** @type {?} */ nodeDefExprs = this.nodes.map(function (factory, nodeIndex) {
            var _a = factory(), nodeDef = _a.nodeDef, nodeFlags = _a.nodeFlags, updateDirectives = _a.updateDirectives, updateRenderer = _a.updateRenderer, sourceSpan = _a.sourceSpan;
            if (updateRenderer) {
                updateRendererStmts.push.apply(updateRendererStmts, createUpdateStatements(nodeIndex, sourceSpan, updateRenderer, false));
            }
            if (updateDirectives) {
                updateDirectivesStmts.push.apply(updateDirectivesStmts, createUpdateStatements(nodeIndex, sourceSpan, updateDirectives, (nodeFlags & (131072 /* DoCheck */ | 32768 /* OnInit */)) > 0));
            }
            // We use a comma expression to call the log function before
            // the nodeDef function, but still use the result of the nodeDef function
            // as the value.
            // Note: We only add the logger to elements / text nodes,
            // so we don't generate too much code.
            var /** @type {?} */ logWithNodeDef = nodeFlags & 3 /* CatRenderNode */ ?
                new CommaExpr([LOG_VAR.callFn([]).callFn([]), nodeDef]) :
                nodeDef;
            return applySourceSpanToExpressionIfNeeded(logWithNodeDef, sourceSpan);
        });
        return { updateRendererStmts: updateRendererStmts, updateDirectivesStmts: updateDirectivesStmts, nodeDefExprs: nodeDefExprs };
        /**
         * @param {?} nodeIndex
         * @param {?} sourceSpan
         * @param {?} expressions
         * @param {?} allowEmptyExprs
         * @return {?}
         */
        function createUpdateStatements(nodeIndex, sourceSpan, expressions, allowEmptyExprs) {
            var /** @type {?} */ updateStmts = [];
            var /** @type {?} */ exprs = expressions.map(function (_a) {
                var sourceSpan = _a.sourceSpan, context = _a.context, value = _a.value;
                var /** @type {?} */ bindingId = "" + updateBindingCount++;
                var /** @type {?} */ nameResolver = context === COMP_VAR ? self : null;
                var _b = convertPropertyBinding(nameResolver, context, value, bindingId), stmts = _b.stmts, currValExpr = _b.currValExpr;
                updateStmts.push.apply(updateStmts, stmts.map(function (stmt) { return applySourceSpanToStatementIfNeeded(stmt, sourceSpan); }));
                return applySourceSpanToExpressionIfNeeded(currValExpr, sourceSpan);
            });
            if (expressions.length || allowEmptyExprs) {
                updateStmts.push(applySourceSpanToStatementIfNeeded(callCheckStmt(nodeIndex, exprs).toStmt(), sourceSpan));
            }
            return updateStmts;
        }
    };
    /**
     * @param {?} nodeIndex
     * @param {?} handlers
     * @return {?}
     */
    ViewBuilder.prototype._createElementHandleEventFn = function (nodeIndex, handlers) {
        var _this = this;
        var /** @type {?} */ handleEventStmts = [];
        var /** @type {?} */ handleEventBindingCount = 0;
        handlers.forEach(function (_a) {
            var context = _a.context, eventAst = _a.eventAst, dirAst = _a.dirAst;
            var /** @type {?} */ bindingId = "" + handleEventBindingCount++;
            var /** @type {?} */ nameResolver = context === COMP_VAR ? _this : null;
            var _b = convertActionBinding(nameResolver, context, eventAst.handler, bindingId), stmts = _b.stmts, allowDefault = _b.allowDefault;
            var /** @type {?} */ trueStmts = stmts;
            if (allowDefault) {
                trueStmts.push(ALLOW_DEFAULT_VAR.set(allowDefault.and(ALLOW_DEFAULT_VAR)).toStmt());
            }
            var _c = elementEventNameAndTarget(eventAst, dirAst), eventTarget = _c.target, eventName = _c.name;
            var /** @type {?} */ fullEventName = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵelementEventFullName"])(eventTarget, eventName);
            handleEventStmts.push(applySourceSpanToStatementIfNeeded(new IfStmt(literal(fullEventName).identical(EVENT_NAME_VAR), trueStmts), eventAst.sourceSpan));
        });
        var /** @type {?} */ handleEventFn;
        if (handleEventStmts.length > 0) {
            var /** @type {?} */ preStmts = [ALLOW_DEFAULT_VAR.set(literal(true)).toDeclStmt(BOOL_TYPE)];
            if (!this.component.isHost && findReadVarNames(handleEventStmts).has(/** @type {?} */ ((COMP_VAR.name)))) {
                preStmts.push(COMP_VAR.set(VIEW_VAR.prop('component')).toDeclStmt(this.compType));
            }
            handleEventFn = fn([
                new FnParam(/** @type {?} */ ((VIEW_VAR.name)), INFERRED_TYPE),
                new FnParam(/** @type {?} */ ((EVENT_NAME_VAR.name)), INFERRED_TYPE),
                new FnParam(/** @type {?} */ ((EventHandlerVars.event.name)), INFERRED_TYPE)
            ], preStmts.concat(handleEventStmts, [new ReturnStatement(ALLOW_DEFAULT_VAR)]), INFERRED_TYPE);
        }
        else {
            handleEventFn = NULL_EXPR;
        }
        return handleEventFn;
    };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    ViewBuilder.prototype.visitDirective = function (ast, context) { };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    ViewBuilder.prototype.visitDirectiveProperty = function (ast, context) { };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    ViewBuilder.prototype.visitReference = function (ast, context) { };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    ViewBuilder.prototype.visitVariable = function (ast, context) { };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    ViewBuilder.prototype.visitEvent = function (ast, context) { };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    ViewBuilder.prototype.visitElementProperty = function (ast, context) { };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    ViewBuilder.prototype.visitAttr = function (ast, context) { };
    return ViewBuilder;
}());
/**
 * @param {?} providerAst
 * @return {?}
 */
function providerDef(providerAst) {
    return providerAst.multiProvider ?
        multiProviderDef(providerAst.providers) :
        singleProviderDef(providerAst.providerType, providerAst.providers[0]);
}
/**
 * @param {?} providers
 * @return {?}
 */
function multiProviderDef(providers) {
    var /** @type {?} */ allDepDefs = [];
    var /** @type {?} */ allParams = [];
    var /** @type {?} */ exprs = providers.map(function (provider, providerIndex) {
        var /** @type {?} */ expr;
        if (provider.useClass) {
            var /** @type {?} */ depExprs = convertDeps(providerIndex, provider.deps || provider.useClass.diDeps);
            expr = importExpr(provider.useClass).instantiate(depExprs);
        }
        else if (provider.useFactory) {
            var /** @type {?} */ depExprs = convertDeps(providerIndex, provider.deps || provider.useFactory.diDeps);
            expr = importExpr(provider.useFactory).callFn(depExprs);
        }
        else if (provider.useExisting) {
            var /** @type {?} */ depExprs = convertDeps(providerIndex, [{ token: provider.useExisting }]);
            expr = depExprs[0];
        }
        else {
            expr = convertValueToOutputAst(provider.useValue);
        }
        return expr;
    });
    var /** @type {?} */ providerExpr = fn(allParams, [new ReturnStatement(literalArr(exprs))], INFERRED_TYPE);
    return { providerExpr: providerExpr, flags: 512 /* TypeFactoryProvider */, depsExpr: literalArr(allDepDefs) };
    /**
     * @param {?} providerIndex
     * @param {?} deps
     * @return {?}
     */
    function convertDeps(providerIndex, deps) {
        return deps.map(function (dep, depIndex) {
            var /** @type {?} */ paramName = "p" + providerIndex + "_" + depIndex;
            allParams.push(new FnParam(paramName, DYNAMIC_TYPE));
            allDepDefs.push(depDef(dep));
            return variable(paramName);
        });
    }
}
/**
 * @param {?} providerType
 * @param {?} providerMeta
 * @return {?}
 */
function singleProviderDef(providerType, providerMeta) {
    var /** @type {?} */ providerExpr;
    var /** @type {?} */ flags;
    var /** @type {?} */ deps;
    if (providerType === ProviderAstType.Directive || providerType === ProviderAstType.Component) {
        providerExpr = importExpr(/** @type {?} */ ((providerMeta.useClass)));
        flags = 8192 /* TypeDirective */;
        deps = providerMeta.deps || ((providerMeta.useClass)).diDeps;
    }
    else {
        if (providerMeta.useClass) {
            providerExpr = importExpr(providerMeta.useClass);
            flags = 256 /* TypeClassProvider */;
            deps = providerMeta.deps || providerMeta.useClass.diDeps;
        }
        else if (providerMeta.useFactory) {
            providerExpr = importExpr(providerMeta.useFactory);
            flags = 512 /* TypeFactoryProvider */;
            deps = providerMeta.deps || providerMeta.useFactory.diDeps;
        }
        else if (providerMeta.useExisting) {
            providerExpr = NULL_EXPR;
            flags = 1024 /* TypeUseExistingProvider */;
            deps = [{ token: providerMeta.useExisting }];
        }
        else {
            providerExpr = convertValueToOutputAst(providerMeta.useValue);
            flags = 128 /* TypeValueProvider */;
            deps = [];
        }
    }
    var /** @type {?} */ depsExpr = literalArr(deps.map(function (dep) { return depDef(dep); }));
    return { providerExpr: providerExpr, flags: flags, depsExpr: depsExpr };
}
/**
 * @param {?} tokenMeta
 * @return {?}
 */
function tokenExpr(tokenMeta) {
    return tokenMeta.identifier ? importExpr(tokenMeta.identifier) : literal(tokenMeta.value);
}
/**
 * @param {?} dep
 * @return {?}
 */
function depDef(dep) {
    // Note: the following fields have already been normalized out by provider_analyzer:
    // - isAttribute, isSelf, isHost
    var /** @type {?} */ expr = dep.isValue ? convertValueToOutputAst(dep.value) : tokenExpr(/** @type {?} */ ((dep.token)));
    var /** @type {?} */ flags = 0;
    if (dep.isSkipSelf) {
        flags |= 1 /* SkipSelf */;
    }
    if (dep.isOptional) {
        flags |= 2 /* Optional */;
    }
    if (dep.isValue) {
        flags |= 8 /* Value */;
    }
    return flags === 0 /* None */ ? expr : literalArr([literal(flags), expr]);
}
/**
 * @param {?} astNodes
 * @return {?}
 */
function needsAdditionalRootNode(astNodes) {
    var /** @type {?} */ lastAstNode = astNodes[astNodes.length - 1];
    if (lastAstNode instanceof EmbeddedTemplateAst) {
        return lastAstNode.hasViewContainer;
    }
    if (lastAstNode instanceof ElementAst) {
        if (isNgContainer(lastAstNode.name) && lastAstNode.children.length) {
            return needsAdditionalRootNode(lastAstNode.children);
        }
        return lastAstNode.hasViewContainer;
    }
    return lastAstNode instanceof NgContentAst;
}
/**
 * @param {?} lifecycleHook
 * @return {?}
 */
function lifecycleHookToNodeFlag(lifecycleHook) {
    var /** @type {?} */ nodeFlag = 0;
    switch (lifecycleHook) {
        case __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵLifecycleHooks"].AfterContentChecked:
            nodeFlag = 1048576 /* AfterContentChecked */;
            break;
        case __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵLifecycleHooks"].AfterContentInit:
            nodeFlag = 524288 /* AfterContentInit */;
            break;
        case __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵLifecycleHooks"].AfterViewChecked:
            nodeFlag = 4194304 /* AfterViewChecked */;
            break;
        case __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵLifecycleHooks"].AfterViewInit:
            nodeFlag = 2097152 /* AfterViewInit */;
            break;
        case __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵLifecycleHooks"].DoCheck:
            nodeFlag = 131072 /* DoCheck */;
            break;
        case __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵLifecycleHooks"].OnChanges:
            nodeFlag = 262144 /* OnChanges */;
            break;
        case __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵLifecycleHooks"].OnDestroy:
            nodeFlag = 65536 /* OnDestroy */;
            break;
        case __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵLifecycleHooks"].OnInit:
            nodeFlag = 32768 /* OnInit */;
            break;
    }
    return nodeFlag;
}
/**
 * @param {?} inputAst
 * @param {?} dirAst
 * @return {?}
 */
function elementBindingDef(inputAst, dirAst) {
    switch (inputAst.type) {
        case PropertyBindingType.Attribute:
            return literalArr([
                literal(1 /* TypeElementAttribute */), literal(inputAst.name),
                literal(inputAst.securityContext)
            ]);
        case PropertyBindingType.Property:
            return literalArr([
                literal(8 /* TypeProperty */), literal(inputAst.name),
                literal(inputAst.securityContext)
            ]);
        case PropertyBindingType.Animation:
            var /** @type {?} */ bindingType = 8 /* TypeProperty */ |
                (dirAst && dirAst.directive.isComponent ? 32 /* SyntheticHostProperty */ :
                    16 /* SyntheticProperty */);
            return literalArr([
                literal(bindingType), literal('@' + inputAst.name), literal(inputAst.securityContext)
            ]);
        case PropertyBindingType.Class:
            return literalArr([literal(2 /* TypeElementClass */), literal(inputAst.name), NULL_EXPR]);
        case PropertyBindingType.Style:
            return literalArr([
                literal(4 /* TypeElementStyle */), literal(inputAst.name), literal(inputAst.unit)
            ]);
    }
}
/**
 * @param {?} elementAst
 * @return {?}
 */
function fixedAttrsDef(elementAst) {
    var /** @type {?} */ mapResult = Object.create(null);
    elementAst.attrs.forEach(function (attrAst) { mapResult[attrAst.name] = attrAst.value; });
    elementAst.directives.forEach(function (dirAst) {
        Object.keys(dirAst.directive.hostAttributes).forEach(function (name) {
            var /** @type {?} */ value = dirAst.directive.hostAttributes[name];
            var /** @type {?} */ prevValue = mapResult[name];
            mapResult[name] = prevValue != null ? mergeAttributeValue(name, prevValue, value) : value;
        });
    });
    // Note: We need to sort to get a defined output order
    // for tests and for caching generated artifacts...
    return literalArr(Object.keys(mapResult).sort().map(function (attrName) { return literalArr([literal(attrName), literal(mapResult[attrName])]); }));
}
/**
 * @param {?} attrName
 * @param {?} attrValue1
 * @param {?} attrValue2
 * @return {?}
 */
function mergeAttributeValue(attrName, attrValue1, attrValue2) {
    if (attrName == CLASS_ATTR$1 || attrName == STYLE_ATTR) {
        return attrValue1 + " " + attrValue2;
    }
    else {
        return attrValue2;
    }
}
/**
 * @param {?} nodeIndex
 * @param {?} exprs
 * @return {?}
 */
function callCheckStmt(nodeIndex, exprs) {
    if (exprs.length > 10) {
        return CHECK_VAR.callFn([VIEW_VAR, literal(nodeIndex), literal(1 /* Dynamic */), literalArr(exprs)]);
    }
    else {
        return CHECK_VAR.callFn([VIEW_VAR, literal(nodeIndex), literal(0 /* Inline */)].concat(exprs));
    }
}
/**
 * @param {?} nodeIndex
 * @param {?} bindingIdx
 * @param {?} expr
 * @return {?}
 */
function callUnwrapValue(nodeIndex, bindingIdx, expr) {
    return importExpr(createIdentifier(Identifiers.unwrapValue)).callFn([
        VIEW_VAR, literal(nodeIndex), literal(bindingIdx), expr
    ]);
}
/**
 * @param {?} nodes
 * @param {?=} result
 * @return {?}
 */
function findStaticQueryIds(nodes, result) {
    if (result === void 0) { result = new Map(); }
    nodes.forEach(function (node) {
        var /** @type {?} */ staticQueryIds = new Set();
        var /** @type {?} */ dynamicQueryIds = new Set();
        var /** @type {?} */ queryMatches = ((undefined));
        if (node instanceof ElementAst) {
            findStaticQueryIds(node.children, result);
            node.children.forEach(function (child) {
                var /** @type {?} */ childData = ((result.get(child)));
                childData.staticQueryIds.forEach(function (queryId) { return staticQueryIds.add(queryId); });
                childData.dynamicQueryIds.forEach(function (queryId) { return dynamicQueryIds.add(queryId); });
            });
            queryMatches = node.queryMatches;
        }
        else if (node instanceof EmbeddedTemplateAst) {
            findStaticQueryIds(node.children, result);
            node.children.forEach(function (child) {
                var /** @type {?} */ childData = ((result.get(child)));
                childData.staticQueryIds.forEach(function (queryId) { return dynamicQueryIds.add(queryId); });
                childData.dynamicQueryIds.forEach(function (queryId) { return dynamicQueryIds.add(queryId); });
            });
            queryMatches = node.queryMatches;
        }
        if (queryMatches) {
            queryMatches.forEach(function (match) { return staticQueryIds.add(match.queryId); });
        }
        dynamicQueryIds.forEach(function (queryId) { return staticQueryIds.delete(queryId); });
        result.set(node, { staticQueryIds: staticQueryIds, dynamicQueryIds: dynamicQueryIds });
    });
    return result;
}
/**
 * @param {?} nodeStaticQueryIds
 * @return {?}
 */
function staticViewQueryIds(nodeStaticQueryIds) {
    var /** @type {?} */ staticQueryIds = new Set();
    var /** @type {?} */ dynamicQueryIds = new Set();
    Array.from(nodeStaticQueryIds.values()).forEach(function (entry) {
        entry.staticQueryIds.forEach(function (queryId) { return staticQueryIds.add(queryId); });
        entry.dynamicQueryIds.forEach(function (queryId) { return dynamicQueryIds.add(queryId); });
    });
    dynamicQueryIds.forEach(function (queryId) { return staticQueryIds.delete(queryId); });
    return { staticQueryIds: staticQueryIds, dynamicQueryIds: dynamicQueryIds };
}
/**
 * @param {?} directives
 * @return {?}
 */
function createComponentFactoryResolver(directives) {
    var /** @type {?} */ componentDirMeta = directives.find(function (dirAst) { return dirAst.directive.isComponent; });
    if (componentDirMeta && componentDirMeta.directive.entryComponents.length) {
        var /** @type {?} */ entryComponentFactories = componentDirMeta.directive.entryComponents.map(function (entryComponent) { return importExpr({ reference: entryComponent.componentFactory }); });
        var /** @type {?} */ token = createIdentifierToken(Identifiers.ComponentFactoryResolver);
        var /** @type {?} */ classMeta = {
            diDeps: [
                { isValue: true, value: literalArr(entryComponentFactories) },
                { token: token, isSkipSelf: true, isOptional: true },
                { token: createIdentifierToken(Identifiers.NgModuleRef) },
            ],
            lifecycleHooks: [],
            reference: resolveIdentifier(Identifiers.CodegenComponentFactoryResolver)
        };
        return new ProviderAst(token, false, true, [{ token: token, multi: false, useClass: classMeta }], ProviderAstType.PrivateService, [], componentDirMeta.sourceSpan);
    }
    return null;
}
/**
 * @param {?} eventAst
 * @param {?} dirAst
 * @return {?}
 */
function elementEventNameAndTarget(eventAst, dirAst) {
    if (eventAst.isAnimation) {
        return {
            name: "@" + eventAst.name + "." + eventAst.phase,
            target: dirAst && dirAst.directive.isComponent ? 'component' : null
        };
    }
    else {
        return eventAst;
    }
}
/**
 * @param {?} queryIds
 * @param {?} queryId
 * @param {?} isFirst
 * @return {?}
 */
function calcStaticDynamicQueryFlags(queryIds, queryId, isFirst) {
    var /** @type {?} */ flags = 0;
    // Note: We only make queries static that query for a single item.
    // This is because of backwards compatibility with the old view compiler...
    if (isFirst && (queryIds.staticQueryIds.has(queryId) || !queryIds.dynamicQueryIds.has(queryId))) {
        flags |= 134217728 /* StaticQuery */;
    }
    else {
        flags |= 268435456 /* DynamicQuery */;
    }
    return flags;
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var GeneratedFile = (function () {
    /**
     * @param {?} srcFileUrl
     * @param {?} genFileUrl
     * @param {?} source
     */
    function GeneratedFile(srcFileUrl, genFileUrl, source) {
        this.srcFileUrl = srcFileUrl;
        this.genFileUrl = genFileUrl;
        this.source = source;
    }
    return GeneratedFile;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @param {?} summaryResolver
 * @param {?} symbolResolver
 * @param {?} symbols
 * @param {?} types
 * @return {?}
 */
function serializeSummaries(summaryResolver, symbolResolver, symbols, types) {
    var /** @type {?} */ serializer = new Serializer$1(symbolResolver, summaryResolver);
    // for symbols, we use everything except for the class metadata itself
    // (we keep the statics though), as the class metadata is contained in the
    // CompileTypeSummary.
    symbols.forEach(function (resolvedSymbol) { return serializer.addOrMergeSummary({ symbol: resolvedSymbol.symbol, metadata: resolvedSymbol.metadata }); });
    // Add summaries that are referenced by the given symbols (transitively)
    // Note: the serializer.symbols array might be growing while
    // we execute the loop!
    for (var /** @type {?} */ processedIndex = 0; processedIndex < serializer.symbols.length; processedIndex++) {
        var /** @type {?} */ symbol = serializer.symbols[processedIndex];
        if (summaryResolver.isLibraryFile(symbol.filePath)) {
            var /** @type {?} */ summary = summaryResolver.resolveSummary(symbol);
            if (!summary) {
                // some symbols might originate from a plain typescript library
                // that just exported .d.ts and .metadata.json files, i.e. where no summary
                // files were created.
                var /** @type {?} */ resolvedSymbol = symbolResolver.resolveSymbol(symbol);
                if (resolvedSymbol) {
                    summary = { symbol: resolvedSymbol.symbol, metadata: resolvedSymbol.metadata };
                }
            }
            if (summary) {
                serializer.addOrMergeSummary(summary);
            }
        }
    }
    // Add type summaries.
    // Note: We don't add the summaries of all referenced symbols as for the ResolvedSymbols,
    // as the type summaries already contain the transitive data that they require
    // (in a minimal way).
    types.forEach(function (typeSummary) {
        serializer.addOrMergeSummary({ symbol: typeSummary.type.reference, metadata: null, type: typeSummary });
        if (typeSummary.summaryKind === CompileSummaryKind.NgModule) {
            var /** @type {?} */ ngModuleSummary = (typeSummary);
            ngModuleSummary.exportedDirectives.concat(ngModuleSummary.exportedPipes).forEach(function (id) {
                var /** @type {?} */ symbol = id.reference;
                if (summaryResolver.isLibraryFile(symbol.filePath)) {
                    var /** @type {?} */ summary = summaryResolver.resolveSummary(symbol);
                    if (summary) {
                        serializer.addOrMergeSummary(summary);
                    }
                }
            });
        }
    });
    return serializer.serialize();
}
/**
 * @param {?} symbolCache
 * @param {?} json
 * @return {?}
 */
function deserializeSummaries(symbolCache, json) {
    var /** @type {?} */ deserializer = new Deserializer(symbolCache);
    return deserializer.deserialize(json);
}
var Serializer$1 = (function (_super) {
    __extends(Serializer$1, _super);
    /**
     * @param {?} symbolResolver
     * @param {?} summaryResolver
     */
    function Serializer$1(symbolResolver, summaryResolver) {
        var _this = _super.call(this) || this;
        _this.symbolResolver = symbolResolver;
        _this.summaryResolver = summaryResolver;
        // Note: This only contains symbols without members.
        _this.symbols = [];
        _this.indexBySymbol = new Map();
        _this.processedSummaryBySymbol = new Map();
        _this.processedSummaries = [];
        return _this;
    }
    /**
     * @param {?} summary
     * @return {?}
     */
    Serializer$1.prototype.addOrMergeSummary = function (summary) {
        var /** @type {?} */ symbolMeta = summary.metadata;
        if (symbolMeta && symbolMeta.__symbolic === 'class') {
            // For classes, we keep everything except their class decorators.
            // We need to keep e.g. the ctor args, method names, method decorators
            // so that the class can be extended in another compilation unit.
            // We don't keep the class decorators as
            // 1) they refer to data
            //   that should not cause a rebuild of downstream compilation units
            //   (e.g. inline templates of @Component, or @NgModule.declarations)
            // 2) their data is already captured in TypeSummaries, e.g. DirectiveSummary.
            var /** @type {?} */ clone_1 = {};
            Object.keys(symbolMeta).forEach(function (propName) {
                if (propName !== 'decorators') {
                    clone_1[propName] = symbolMeta[propName];
                }
            });
            symbolMeta = clone_1;
        }
        var /** @type {?} */ processedSummary = this.processedSummaryBySymbol.get(summary.symbol);
        if (!processedSummary) {
            processedSummary = this.processValue({ symbol: summary.symbol });
            this.processedSummaries.push(processedSummary);
            this.processedSummaryBySymbol.set(summary.symbol, processedSummary);
        }
        // Note: == on purpose to compare with undefined!
        if (processedSummary.metadata == null && symbolMeta != null) {
            processedSummary.metadata = this.processValue(symbolMeta);
        }
        // Note: == on purpose to compare with undefined!
        if (processedSummary.type == null && summary.type != null) {
            processedSummary.type = this.processValue(summary.type);
        }
    };
    /**
     * @return {?}
     */
    Serializer$1.prototype.serialize = function () {
        var _this = this;
        var /** @type {?} */ exportAs = [];
        var /** @type {?} */ json = JSON.stringify({
            summaries: this.processedSummaries,
            symbols: this.symbols.map(function (symbol, index) {
                symbol.assertNoMembers();
                var /** @type {?} */ importAs = ((undefined));
                if (_this.summaryResolver.isLibraryFile(symbol.filePath)) {
                    importAs = symbol.name + "_" + index;
                    exportAs.push({ symbol: symbol, exportAs: importAs });
                }
                return {
                    __symbol: index,
                    name: symbol.name,
                    // We convert the source filenames tinto output filenames,
                    // as the generated summary file will be used when teh current
                    // compilation unit is used as a library
                    filePath: _this.summaryResolver.getLibraryFileName(symbol.filePath),
                    importAs: importAs
                };
            })
        });
        return { json: json, exportAs: exportAs };
    };
    /**
     * @param {?} value
     * @return {?}
     */
    Serializer$1.prototype.processValue = function (value) { return visitValue(value, this, null); };
    /**
     * @param {?} value
     * @param {?} context
     * @return {?}
     */
    Serializer$1.prototype.visitOther = function (value, context) {
        if (value instanceof StaticSymbol) {
            var /** @type {?} */ baseSymbol = this.symbolResolver.getStaticSymbol(value.filePath, value.name);
            var /** @type {?} */ index = this.indexBySymbol.get(baseSymbol);
            // Note: == on purpose to compare with undefined!
            if (index == null) {
                index = this.indexBySymbol.size;
                this.indexBySymbol.set(baseSymbol, index);
                this.symbols.push(baseSymbol);
            }
            return { __symbol: index, members: value.members };
        }
    };
    return Serializer$1;
}(ValueTransformer));
var Deserializer = (function (_super) {
    __extends(Deserializer, _super);
    /**
     * @param {?} symbolCache
     */
    function Deserializer(symbolCache) {
        var _this = _super.call(this) || this;
        _this.symbolCache = symbolCache;
        return _this;
    }
    /**
     * @param {?} json
     * @return {?}
     */
    Deserializer.prototype.deserialize = function (json) {
        var _this = this;
        var /** @type {?} */ data = JSON.parse(json);
        var /** @type {?} */ importAs = [];
        this.symbols = [];
        data.symbols.forEach(function (serializedSymbol) {
            var /** @type {?} */ symbol = _this.symbolCache.get(serializedSymbol.filePath, serializedSymbol.name);
            _this.symbols.push(symbol);
            if (serializedSymbol.importAs) {
                importAs.push({ symbol: symbol, importAs: serializedSymbol.importAs });
            }
        });
        var /** @type {?} */ summaries = visitValue(data.summaries, this, null);
        return { summaries: summaries, importAs: importAs };
    };
    /**
     * @param {?} map
     * @param {?} context
     * @return {?}
     */
    Deserializer.prototype.visitStringMap = function (map, context) {
        if ('__symbol' in map) {
            var /** @type {?} */ baseSymbol = this.symbols[map['__symbol']];
            var /** @type {?} */ members = map['members'];
            return members.length ? this.symbolCache.get(baseSymbol.filePath, baseSymbol.name, members) :
                baseSymbol;
        }
        else {
            return _super.prototype.visitStringMap.call(this, map, context);
        }
    };
    return Deserializer;
}(ValueTransformer));
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var AotCompiler = (function () {
    /**
     * @param {?} _config
     * @param {?} _host
     * @param {?} _metadataResolver
     * @param {?} _templateParser
     * @param {?} _styleCompiler
     * @param {?} _viewCompiler
     * @param {?} _ngModuleCompiler
     * @param {?} _outputEmitter
     * @param {?} _summaryResolver
     * @param {?} _localeId
     * @param {?} _translationFormat
     * @param {?} _genFilePreamble
     * @param {?} _symbolResolver
     */
    function AotCompiler(_config, _host, _metadataResolver, _templateParser, _styleCompiler, _viewCompiler, _ngModuleCompiler, _outputEmitter, _summaryResolver, _localeId, _translationFormat, _genFilePreamble, _symbolResolver) {
        this._config = _config;
        this._host = _host;
        this._metadataResolver = _metadataResolver;
        this._templateParser = _templateParser;
        this._styleCompiler = _styleCompiler;
        this._viewCompiler = _viewCompiler;
        this._ngModuleCompiler = _ngModuleCompiler;
        this._outputEmitter = _outputEmitter;
        this._summaryResolver = _summaryResolver;
        this._localeId = _localeId;
        this._translationFormat = _translationFormat;
        this._genFilePreamble = _genFilePreamble;
        this._symbolResolver = _symbolResolver;
    }
    /**
     * @return {?}
     */
    AotCompiler.prototype.clearCache = function () { this._metadataResolver.clearCache(); };
    /**
     * @param {?} rootFiles
     * @return {?}
     */
    AotCompiler.prototype.compileAll = function (rootFiles) {
        var _this = this;
        var /** @type {?} */ programSymbols = extractProgramSymbols(this._symbolResolver, rootFiles, this._host);
        var _a = analyzeAndValidateNgModules(programSymbols, this._host, this._metadataResolver), ngModuleByPipeOrDirective = _a.ngModuleByPipeOrDirective, files = _a.files, ngModules = _a.ngModules;
        return Promise
            .all(ngModules.map(function (ngModule) { return _this._metadataResolver.loadNgModuleDirectiveAndPipeMetadata(ngModule.type.reference, false); }))
            .then(function () {
            var /** @type {?} */ sourceModules = files.map(function (file) { return _this._compileSrcFile(file.srcUrl, ngModuleByPipeOrDirective, file.directives, file.pipes, file.ngModules, file.injectables); });
            return flatten(sourceModules);
        });
    };
    /**
     * @param {?} srcFileUrl
     * @param {?} ngModuleByPipeOrDirective
     * @param {?} directives
     * @param {?} pipes
     * @param {?} ngModules
     * @param {?} injectables
     * @return {?}
     */
    AotCompiler.prototype._compileSrcFile = function (srcFileUrl, ngModuleByPipeOrDirective, directives, pipes, ngModules, injectables) {
        var _this = this;
        var /** @type {?} */ fileSuffix = splitTypescriptSuffix(srcFileUrl)[1];
        var /** @type {?} */ statements = [];
        var /** @type {?} */ exportedVars = [];
        var /** @type {?} */ generatedFiles = [];
        generatedFiles.push(this._createSummary(srcFileUrl, directives, pipes, ngModules, injectables, statements, exportedVars));
        // compile all ng modules
        exportedVars.push.apply(exportedVars, ngModules.map(function (ngModuleType) { return _this._compileModule(ngModuleType, statements); }));
        // compile components
        directives.forEach(function (dirType) {
            var /** @type {?} */ compMeta = _this._metadataResolver.getDirectiveMetadata(/** @type {?} */ (dirType));
            if (!compMeta.isComponent) {
                return Promise.resolve(null);
            }
            var /** @type {?} */ ngModule = ngModuleByPipeOrDirective.get(dirType);
            if (!ngModule) {
                throw new Error("Internal Error: cannot determine the module for component " + identifierName(compMeta.type) + "!");
            }
            _assertComponent(compMeta);
            // compile styles
            var /** @type {?} */ stylesCompileResults = _this._styleCompiler.compileComponent(compMeta);
            stylesCompileResults.externalStylesheets.forEach(function (compiledStyleSheet) {
                generatedFiles.push(_this._codgenStyles(srcFileUrl, compiledStyleSheet, fileSuffix));
            });
            // compile components
            var /** @type {?} */ compViewVars = _this._compileComponent(compMeta, ngModule, ngModule.transitiveModule.directives, stylesCompileResults.componentStylesheet, fileSuffix, statements);
            exportedVars.push(_this._compileComponentFactory(compMeta, ngModule, fileSuffix, statements), compViewVars.viewClassVar, compViewVars.compRenderTypeVar);
        });
        if (statements.length > 0) {
            var /** @type {?} */ srcModule = this._codegenSourceModule(srcFileUrl, ngfactoryFilePath(srcFileUrl), statements, exportedVars);
            generatedFiles.unshift(srcModule);
        }
        return generatedFiles;
    };
    /**
     * @param {?} srcFileUrl
     * @param {?} directives
     * @param {?} pipes
     * @param {?} ngModules
     * @param {?} injectables
     * @param {?} targetStatements
     * @param {?} targetExportedVars
     * @return {?}
     */
    AotCompiler.prototype._createSummary = function (srcFileUrl, directives, pipes, ngModules, injectables, targetStatements, targetExportedVars) {
        var _this = this;
        var /** @type {?} */ symbolSummaries = this._symbolResolver.getSymbolsOf(srcFileUrl)
            .map(function (symbol) { return _this._symbolResolver.resolveSymbol(symbol); });
        var /** @type {?} */ typeSummaries = ngModules.map(function (ref) { return ((_this._metadataResolver.getNgModuleSummary(ref))); }).concat(directives.map(function (ref) { return ((_this._metadataResolver.getDirectiveSummary(ref))); }), pipes.map(function (ref) { return ((_this._metadataResolver.getPipeSummary(ref))); }), injectables.map(function (ref) { return ((_this._metadataResolver.getInjectableSummary(ref))); }));
        var _a = serializeSummaries(this._summaryResolver, this._symbolResolver, symbolSummaries, typeSummaries), json = _a.json, exportAs = _a.exportAs;
        exportAs.forEach(function (entry) {
            targetStatements.push(variable(entry.exportAs).set(importExpr({ reference: entry.symbol })).toDeclStmt());
            targetExportedVars.push(entry.exportAs);
        });
        return new GeneratedFile(srcFileUrl, summaryFileName(srcFileUrl), json);
    };
    /**
     * @param {?} ngModuleType
     * @param {?} targetStatements
     * @return {?}
     */
    AotCompiler.prototype._compileModule = function (ngModuleType, targetStatements) {
        var /** @type {?} */ ngModule = ((this._metadataResolver.getNgModuleMetadata(ngModuleType)));
        var /** @type {?} */ providers = [];
        if (this._localeId) {
            providers.push({
                token: createIdentifierToken(Identifiers.LOCALE_ID),
                useValue: this._localeId,
            });
        }
        if (this._translationFormat) {
            providers.push({
                token: createIdentifierToken(Identifiers.TRANSLATIONS_FORMAT),
                useValue: this._translationFormat
            });
        }
        var /** @type {?} */ appCompileResult = this._ngModuleCompiler.compile(ngModule, providers);
        targetStatements.push.apply(targetStatements, appCompileResult.statements);
        return appCompileResult.ngModuleFactoryVar;
    };
    /**
     * @param {?} compMeta
     * @param {?} ngModule
     * @param {?} fileSuffix
     * @param {?} targetStatements
     * @return {?}
     */
    AotCompiler.prototype._compileComponentFactory = function (compMeta, ngModule, fileSuffix, targetStatements) {
        var /** @type {?} */ hostType = this._metadataResolver.getHostComponentType(compMeta.type.reference);
        var /** @type {?} */ hostMeta = createHostComponentMeta(hostType, compMeta, this._metadataResolver.getHostComponentViewClass(hostType));
        var /** @type {?} */ hostViewFactoryVar = this._compileComponent(hostMeta, ngModule, [compMeta.type], null, fileSuffix, targetStatements)
            .viewClassVar;
        var /** @type {?} */ compFactoryVar = componentFactoryName(compMeta.type.reference);
        var /** @type {?} */ inputsExprs = [];
        for (var /** @type {?} */ propName in compMeta.inputs) {
            var /** @type {?} */ templateName = compMeta.inputs[propName];
            // Don't quote so that the key gets minified...
            inputsExprs.push(new LiteralMapEntry(propName, literal(templateName), false));
        }
        var /** @type {?} */ outputsExprs = [];
        for (var /** @type {?} */ propName in compMeta.outputs) {
            var /** @type {?} */ templateName = compMeta.outputs[propName];
            // Don't quote so that the key gets minified...
            outputsExprs.push(new LiteralMapEntry(propName, literal(templateName), false));
        }
        targetStatements.push(variable(compFactoryVar)
            .set(importExpr(createIdentifier(Identifiers.createComponentFactory)).callFn([
            literal(compMeta.selector), importExpr(compMeta.type),
            variable(hostViewFactoryVar), new LiteralMapExpr(inputsExprs),
            new LiteralMapExpr(outputsExprs),
            literalArr(/** @type {?} */ ((compMeta.template)).ngContentSelectors.map(function (selector) { return literal(selector); }))
        ]))
            .toDeclStmt(importType(createIdentifier(Identifiers.ComponentFactory), [/** @type {?} */ ((importType(compMeta.type)))], [TypeModifier.Const]), [StmtModifier.Final]));
        return compFactoryVar;
    };
    /**
     * @param {?} compMeta
     * @param {?} ngModule
     * @param {?} directiveIdentifiers
     * @param {?} componentStyles
     * @param {?} fileSuffix
     * @param {?} targetStatements
     * @return {?}
     */
    AotCompiler.prototype._compileComponent = function (compMeta, ngModule, directiveIdentifiers, componentStyles, fileSuffix, targetStatements) {
        var _this = this;
        var /** @type {?} */ directives = directiveIdentifiers.map(function (dir) { return _this._metadataResolver.getDirectiveSummary(dir.reference); });
        var /** @type {?} */ pipes = ngModule.transitiveModule.pipes.map(function (pipe) { return _this._metadataResolver.getPipeSummary(pipe.reference); });
        var _a = this._templateParser.parse(compMeta, /** @type {?} */ ((((compMeta.template)).template)), directives, pipes, ngModule.schemas, templateSourceUrl(ngModule.type, compMeta, /** @type {?} */ ((compMeta.template)))), parsedTemplate = _a.template, usedPipes = _a.pipes;
        var /** @type {?} */ stylesExpr = componentStyles ? variable(componentStyles.stylesVar) : literalArr([]);
        var /** @type {?} */ viewResult = this._viewCompiler.compileComponent(compMeta, parsedTemplate, stylesExpr, usedPipes);
        if (componentStyles) {
            targetStatements.push.apply(targetStatements, _resolveStyleStatements(this._symbolResolver, componentStyles, fileSuffix));
        }
        targetStatements.push.apply(targetStatements, viewResult.statements);
        return { viewClassVar: viewResult.viewClassVar, compRenderTypeVar: viewResult.rendererTypeVar };
    };
    /**
     * @param {?} fileUrl
     * @param {?} stylesCompileResult
     * @param {?} fileSuffix
     * @return {?}
     */
    AotCompiler.prototype._codgenStyles = function (fileUrl, stylesCompileResult, fileSuffix) {
        _resolveStyleStatements(this._symbolResolver, stylesCompileResult, fileSuffix);
        return this._codegenSourceModule(fileUrl, _stylesModuleUrl(/** @type {?} */ ((stylesCompileResult.meta.moduleUrl)), stylesCompileResult.isShimmed, fileSuffix), stylesCompileResult.statements, [stylesCompileResult.stylesVar]);
    };
    /**
     * @param {?} srcFileUrl
     * @param {?} genFileUrl
     * @param {?} statements
     * @param {?} exportedVars
     * @return {?}
     */
    AotCompiler.prototype._codegenSourceModule = function (srcFileUrl, genFileUrl, statements, exportedVars) {
        return new GeneratedFile(srcFileUrl, genFileUrl, this._outputEmitter.emitStatements(sourceUrl(srcFileUrl), genFileUrl, statements, exportedVars, this._genFilePreamble));
    };
    return AotCompiler;
}());
/**
 * @param {?} reflector
 * @param {?} compileResult
 * @param {?} fileSuffix
 * @return {?}
 */
function _resolveStyleStatements(reflector, compileResult, fileSuffix) {
    compileResult.dependencies.forEach(function (dep) {
        dep.valuePlaceholder.reference = reflector.getStaticSymbol(_stylesModuleUrl(dep.moduleUrl, dep.isShimmed, fileSuffix), dep.name);
    });
    return compileResult.statements;
}
/**
 * @param {?} stylesheetUrl
 * @param {?} shim
 * @param {?} suffix
 * @return {?}
 */
function _stylesModuleUrl(stylesheetUrl, shim, suffix) {
    return "" + stylesheetUrl + (shim ? '.shim' : '') + ".ngstyle" + suffix;
}
/**
 * @param {?} meta
 * @return {?}
 */
function _assertComponent(meta) {
    if (!meta.isComponent) {
        throw new Error("Could not compile '" + identifierName(meta.type) + "' because it is not a component.");
    }
}
/**
 * @param {?} programStaticSymbols
 * @param {?} host
 * @param {?} metadataResolver
 * @return {?}
 */
function analyzeNgModules(programStaticSymbols, host, metadataResolver) {
    var _a = _createNgModules(programStaticSymbols, host, metadataResolver), ngModules = _a.ngModules, symbolsMissingModule = _a.symbolsMissingModule;
    return _analyzeNgModules(programStaticSymbols, ngModules, symbolsMissingModule, metadataResolver);
}
/**
 * @param {?} programStaticSymbols
 * @param {?} host
 * @param {?} metadataResolver
 * @return {?}
 */
function analyzeAndValidateNgModules(programStaticSymbols, host, metadataResolver) {
    var /** @type {?} */ result = analyzeNgModules(programStaticSymbols, host, metadataResolver);
    if (result.symbolsMissingModule && result.symbolsMissingModule.length) {
        var /** @type {?} */ messages = result.symbolsMissingModule.map(function (s) { return "Cannot determine the module for class " + s.name + " in " + s.filePath + "! Add " + s.name + " to the NgModule to fix it."; });
        throw syntaxError(messages.join('\n'));
    }
    return result;
}
/**
 * @param {?} programSymbols
 * @param {?} ngModuleMetas
 * @param {?} symbolsMissingModule
 * @param {?} metadataResolver
 * @return {?}
 */
function _analyzeNgModules(programSymbols, ngModuleMetas, symbolsMissingModule, metadataResolver) {
    var /** @type {?} */ moduleMetasByRef = new Map();
    ngModuleMetas.forEach(function (ngModule) { return moduleMetasByRef.set(ngModule.type.reference, ngModule); });
    var /** @type {?} */ ngModuleByPipeOrDirective = new Map();
    var /** @type {?} */ ngModulesByFile = new Map();
    var /** @type {?} */ ngDirectivesByFile = new Map();
    var /** @type {?} */ ngPipesByFile = new Map();
    var /** @type {?} */ ngInjectablesByFile = new Map();
    var /** @type {?} */ filePaths = new Set();
    // Make sure we produce an analyzed file for each input file
    programSymbols.forEach(function (symbol) {
        var /** @type {?} */ filePath = symbol.filePath;
        filePaths.add(filePath);
        if (metadataResolver.isInjectable(symbol)) {
            ngInjectablesByFile.set(filePath, (ngInjectablesByFile.get(filePath) || []).concat(symbol));
        }
    });
    // Looping over all modules to construct:
    // - a map from file to modules `ngModulesByFile`,
    // - a map from file to directives `ngDirectivesByFile`,
    // - a map from file to pipes `ngPipesByFile`,
    // - a map from directive/pipe to module `ngModuleByPipeOrDirective`.
    ngModuleMetas.forEach(function (ngModuleMeta) {
        var /** @type {?} */ srcFileUrl = ngModuleMeta.type.reference.filePath;
        filePaths.add(srcFileUrl);
        ngModulesByFile.set(srcFileUrl, (ngModulesByFile.get(srcFileUrl) || []).concat(ngModuleMeta.type.reference));
        ngModuleMeta.declaredDirectives.forEach(function (dirIdentifier) {
            var /** @type {?} */ fileUrl = dirIdentifier.reference.filePath;
            filePaths.add(fileUrl);
            ngDirectivesByFile.set(fileUrl, (ngDirectivesByFile.get(fileUrl) || []).concat(dirIdentifier.reference));
            ngModuleByPipeOrDirective.set(dirIdentifier.reference, ngModuleMeta);
        });
        ngModuleMeta.declaredPipes.forEach(function (pipeIdentifier) {
            var /** @type {?} */ fileUrl = pipeIdentifier.reference.filePath;
            filePaths.add(fileUrl);
            ngPipesByFile.set(fileUrl, (ngPipesByFile.get(fileUrl) || []).concat(pipeIdentifier.reference));
            ngModuleByPipeOrDirective.set(pipeIdentifier.reference, ngModuleMeta);
        });
    });
    var /** @type {?} */ files = [];
    filePaths.forEach(function (srcUrl) {
        var /** @type {?} */ directives = ngDirectivesByFile.get(srcUrl) || [];
        var /** @type {?} */ pipes = ngPipesByFile.get(srcUrl) || [];
        var /** @type {?} */ ngModules = ngModulesByFile.get(srcUrl) || [];
        var /** @type {?} */ injectables = ngInjectablesByFile.get(srcUrl) || [];
        files.push({ srcUrl: srcUrl, directives: directives, pipes: pipes, ngModules: ngModules, injectables: injectables });
    });
    return {
        // map directive/pipe to module
        ngModuleByPipeOrDirective: ngModuleByPipeOrDirective,
        // list modules and directives for every source file
        files: files,
        ngModules: ngModuleMetas, symbolsMissingModule: symbolsMissingModule
    };
}
/**
 * @param {?} staticSymbolResolver
 * @param {?} files
 * @param {?} host
 * @return {?}
 */
function extractProgramSymbols(staticSymbolResolver, files, host) {
    var /** @type {?} */ staticSymbols = [];
    files.filter(function (fileName) { return host.isSourceFile(fileName); }).forEach(function (sourceFile) {
        staticSymbolResolver.getSymbolsOf(sourceFile).forEach(function (symbol) {
            var /** @type {?} */ resolvedSymbol = staticSymbolResolver.resolveSymbol(symbol);
            var /** @type {?} */ symbolMeta = resolvedSymbol.metadata;
            if (symbolMeta) {
                if (symbolMeta.__symbolic != 'error') {
                    // Ignore symbols that are only included to record error information.
                    staticSymbols.push(resolvedSymbol.symbol);
                }
            }
        });
    });
    return staticSymbols;
}
/**
 * @param {?} programStaticSymbols
 * @param {?} host
 * @param {?} metadataResolver
 * @return {?}
 */
function _createNgModules(programStaticSymbols, host, metadataResolver) {
    var /** @type {?} */ ngModules = new Map();
    var /** @type {?} */ programPipesAndDirectives = [];
    var /** @type {?} */ ngModulePipesAndDirective = new Set();
    var /** @type {?} */ addNgModule = function (staticSymbol) {
        if (ngModules.has(staticSymbol) || !host.isSourceFile(staticSymbol.filePath)) {
            return false;
        }
        var /** @type {?} */ ngModule = metadataResolver.getNgModuleMetadata(staticSymbol, false);
        if (ngModule) {
            ngModules.set(ngModule.type.reference, ngModule);
            ngModule.declaredDirectives.forEach(function (dir) { return ngModulePipesAndDirective.add(dir.reference); });
            ngModule.declaredPipes.forEach(function (pipe) { return ngModulePipesAndDirective.add(pipe.reference); });
            // For every input module add the list of transitively included modules
            ngModule.transitiveModule.modules.forEach(function (modMeta) { return addNgModule(modMeta.reference); });
        }
        return !!ngModule;
    };
    programStaticSymbols.forEach(function (staticSymbol) {
        if (!addNgModule(staticSymbol) &&
            (metadataResolver.isDirective(staticSymbol) || metadataResolver.isPipe(staticSymbol))) {
            programPipesAndDirectives.push(staticSymbol);
        }
    });
    // Throw an error if any of the program pipe or directives is not declared by a module
    var /** @type {?} */ symbolsMissingModule = programPipesAndDirectives.filter(function (s) { return !ngModulePipesAndDirective.has(s); });
    return { ngModules: Array.from(ngModules.values()), symbolsMissingModule: symbolsMissingModule };
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var StaticAndDynamicReflectionCapabilities = (function () {
    /**
     * @param {?} staticDelegate
     */
    function StaticAndDynamicReflectionCapabilities(staticDelegate) {
        this.staticDelegate = staticDelegate;
        this.dynamicDelegate = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵReflectionCapabilities"]();
    }
    /**
     * @param {?} staticDelegate
     * @return {?}
     */
    StaticAndDynamicReflectionCapabilities.install = function (staticDelegate) {
        __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵreflector"].updateCapabilities(new StaticAndDynamicReflectionCapabilities(staticDelegate));
    };
    /**
     * @return {?}
     */
    StaticAndDynamicReflectionCapabilities.prototype.isReflectionEnabled = function () { return true; };
    /**
     * @param {?} type
     * @return {?}
     */
    StaticAndDynamicReflectionCapabilities.prototype.factory = function (type) { return this.dynamicDelegate.factory(type); };
    /**
     * @param {?} type
     * @param {?} lcProperty
     * @return {?}
     */
    StaticAndDynamicReflectionCapabilities.prototype.hasLifecycleHook = function (type, lcProperty) {
        return isStaticType(type) ? this.staticDelegate.hasLifecycleHook(type, lcProperty) :
            this.dynamicDelegate.hasLifecycleHook(type, lcProperty);
    };
    /**
     * @param {?} type
     * @return {?}
     */
    StaticAndDynamicReflectionCapabilities.prototype.parameters = function (type) {
        return isStaticType(type) ? this.staticDelegate.parameters(type) :
            this.dynamicDelegate.parameters(type);
    };
    /**
     * @param {?} type
     * @return {?}
     */
    StaticAndDynamicReflectionCapabilities.prototype.annotations = function (type) {
        return isStaticType(type) ? this.staticDelegate.annotations(type) :
            this.dynamicDelegate.annotations(type);
    };
    /**
     * @param {?} typeOrFunc
     * @return {?}
     */
    StaticAndDynamicReflectionCapabilities.prototype.propMetadata = function (typeOrFunc) {
        return isStaticType(typeOrFunc) ? this.staticDelegate.propMetadata(typeOrFunc) :
            this.dynamicDelegate.propMetadata(typeOrFunc);
    };
    /**
     * @param {?} name
     * @return {?}
     */
    StaticAndDynamicReflectionCapabilities.prototype.getter = function (name) { return this.dynamicDelegate.getter(name); };
    /**
     * @param {?} name
     * @return {?}
     */
    StaticAndDynamicReflectionCapabilities.prototype.setter = function (name) { return this.dynamicDelegate.setter(name); };
    /**
     * @param {?} name
     * @return {?}
     */
    StaticAndDynamicReflectionCapabilities.prototype.method = function (name) { return this.dynamicDelegate.method(name); };
    /**
     * @param {?} type
     * @return {?}
     */
    StaticAndDynamicReflectionCapabilities.prototype.importUri = function (type) { return ((this.staticDelegate.importUri(type))); };
    /**
     * @param {?} type
     * @return {?}
     */
    StaticAndDynamicReflectionCapabilities.prototype.resourceUri = function (type) { return this.staticDelegate.resourceUri(type); };
    /**
     * @param {?} name
     * @param {?} moduleUrl
     * @param {?} members
     * @param {?} runtime
     * @return {?}
     */
    StaticAndDynamicReflectionCapabilities.prototype.resolveIdentifier = function (name, moduleUrl, members, runtime) {
        return this.staticDelegate.resolveIdentifier(name, moduleUrl, members);
    };
    /**
     * @param {?} enumIdentifier
     * @param {?} name
     * @return {?}
     */
    StaticAndDynamicReflectionCapabilities.prototype.resolveEnum = function (enumIdentifier, name) {
        if (isStaticType(enumIdentifier)) {
            return this.staticDelegate.resolveEnum(enumIdentifier, name);
        }
        else {
            return null;
        }
    };
    return StaticAndDynamicReflectionCapabilities;
}());
/**
 * @param {?} type
 * @return {?}
 */
function isStaticType(type) {
    return typeof type === 'object' && type.name && type.filePath;
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var ANGULAR_CORE = '@angular/core';
var HIDDEN_KEY = /^\$.*\$$/;
var IGNORE = {
    __symbolic: 'ignore'
};
/**
 * @param {?} value
 * @return {?}
 */
function shouldIgnore(value) {
    return value && value.__symbolic == 'ignore';
}
/**
 * A static reflector implements enough of the Reflector API that is necessary to compile
 * templates statically.
 */
var StaticReflector = (function () {
    /**
     * @param {?} summaryResolver
     * @param {?} symbolResolver
     * @param {?=} knownMetadataClasses
     * @param {?=} knownMetadataFunctions
     * @param {?=} errorRecorder
     */
    function StaticReflector(summaryResolver, symbolResolver, knownMetadataClasses, knownMetadataFunctions, errorRecorder) {
        if (knownMetadataClasses === void 0) { knownMetadataClasses = []; }
        if (knownMetadataFunctions === void 0) { knownMetadataFunctions = []; }
        var _this = this;
        this.summaryResolver = summaryResolver;
        this.symbolResolver = symbolResolver;
        this.errorRecorder = errorRecorder;
        this.annotationCache = new Map();
        this.propertyCache = new Map();
        this.parameterCache = new Map();
        this.methodCache = new Map();
        this.conversionMap = new Map();
        this.annotationForParentClassWithSummaryKind = new Map();
        this.annotationNames = new Map();
        this.initializeConversionMap();
        knownMetadataClasses.forEach(function (kc) { return _this._registerDecoratorOrConstructor(_this.getStaticSymbol(kc.filePath, kc.name), kc.ctor); });
        knownMetadataFunctions.forEach(function (kf) { return _this._registerFunction(_this.getStaticSymbol(kf.filePath, kf.name), kf.fn); });
        this.annotationForParentClassWithSummaryKind.set(CompileSummaryKind.Directive, [__WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"]]);
        this.annotationForParentClassWithSummaryKind.set(CompileSummaryKind.Pipe, [__WEBPACK_IMPORTED_MODULE_0__angular_core__["Pipe"]]);
        this.annotationForParentClassWithSummaryKind.set(CompileSummaryKind.NgModule, [__WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"]]);
        this.annotationForParentClassWithSummaryKind.set(CompileSummaryKind.Injectable, [__WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"], __WEBPACK_IMPORTED_MODULE_0__angular_core__["Pipe"], __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"]]);
        this.annotationNames.set(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], 'Directive');
        this.annotationNames.set(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], 'Component');
        this.annotationNames.set(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Pipe"], 'Pipe');
        this.annotationNames.set(__WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], 'NgModule');
        this.annotationNames.set(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"], 'Injectable');
    }
    /**
     * @param {?} typeOrFunc
     * @return {?}
     */
    StaticReflector.prototype.importUri = function (typeOrFunc) {
        var /** @type {?} */ staticSymbol = this.findSymbolDeclaration(typeOrFunc);
        return staticSymbol ? staticSymbol.filePath : null;
    };
    /**
     * @param {?} typeOrFunc
     * @return {?}
     */
    StaticReflector.prototype.resourceUri = function (typeOrFunc) {
        var /** @type {?} */ staticSymbol = this.findSymbolDeclaration(typeOrFunc);
        return this.symbolResolver.getResourcePath(staticSymbol);
    };
    /**
     * @param {?} name
     * @param {?} moduleUrl
     * @param {?} members
     * @return {?}
     */
    StaticReflector.prototype.resolveIdentifier = function (name, moduleUrl, members) {
        var /** @type {?} */ importSymbol = this.getStaticSymbol(moduleUrl, name);
        var /** @type {?} */ rootSymbol = this.findDeclaration(moduleUrl, name);
        if (importSymbol != rootSymbol) {
            this.symbolResolver.recordImportAs(rootSymbol, importSymbol);
        }
        if (members && members.length) {
            return this.getStaticSymbol(rootSymbol.filePath, rootSymbol.name, members);
        }
        return rootSymbol;
    };
    /**
     * @param {?} moduleUrl
     * @param {?} name
     * @param {?=} containingFile
     * @return {?}
     */
    StaticReflector.prototype.findDeclaration = function (moduleUrl, name, containingFile) {
        return this.findSymbolDeclaration(this.symbolResolver.getSymbolByModule(moduleUrl, name, containingFile));
    };
    /**
     * @param {?} symbol
     * @return {?}
     */
    StaticReflector.prototype.findSymbolDeclaration = function (symbol) {
        var /** @type {?} */ resolvedSymbol = this.symbolResolver.resolveSymbol(symbol);
        if (resolvedSymbol && resolvedSymbol.metadata instanceof StaticSymbol) {
            return this.findSymbolDeclaration(resolvedSymbol.metadata);
        }
        else {
            return symbol;
        }
    };
    /**
     * @param {?} enumIdentifier
     * @param {?} name
     * @return {?}
     */
    StaticReflector.prototype.resolveEnum = function (enumIdentifier, name) {
        var /** @type {?} */ staticSymbol = enumIdentifier;
        var /** @type {?} */ members = (staticSymbol.members || []).concat(name);
        return this.getStaticSymbol(staticSymbol.filePath, staticSymbol.name, members);
    };
    /**
     * @param {?} type
     * @return {?}
     */
    StaticReflector.prototype.annotations = function (type) {
        var _this = this;
        var /** @type {?} */ annotations = this.annotationCache.get(type);
        if (!annotations) {
            annotations = [];
            var /** @type {?} */ classMetadata = this.getTypeMetadata(type);
            var /** @type {?} */ parentType = this.findParentType(type, classMetadata);
            if (parentType) {
                var /** @type {?} */ parentAnnotations = this.annotations(parentType);
                annotations.push.apply(annotations, parentAnnotations);
            }
            var /** @type {?} */ ownAnnotations_1 = [];
            if (classMetadata['decorators']) {
                ownAnnotations_1 = this.simplify(type, classMetadata['decorators']);
                annotations.push.apply(annotations, ownAnnotations_1);
            }
            if (parentType && !this.summaryResolver.isLibraryFile(type.filePath) &&
                this.summaryResolver.isLibraryFile(parentType.filePath)) {
                var /** @type {?} */ summary = this.summaryResolver.resolveSummary(parentType);
                if (summary && summary.type) {
                    var /** @type {?} */ requiredAnnotationTypes = ((this.annotationForParentClassWithSummaryKind.get(/** @type {?} */ ((summary.type.summaryKind)))));
                    var /** @type {?} */ typeHasRequiredAnnotation = requiredAnnotationTypes.some(function (requiredType) { return ownAnnotations_1.some(function (ann) { return ann instanceof requiredType; }); });
                    if (!typeHasRequiredAnnotation) {
                        this.reportError(syntaxError("Class " + type.name + " in " + type.filePath + " extends from a " + CompileSummaryKind[((summary.type.summaryKind))] + " in another compilation unit without duplicating the decorator. " +
                            ("Please add a " + requiredAnnotationTypes.map(function (type) { return _this.annotationNames.get(type); }).join(' or ') + " decorator to the class.")), type);
                    }
                }
            }
            this.annotationCache.set(type, annotations.filter(function (ann) { return !!ann; }));
        }
        return annotations;
    };
    /**
     * @param {?} type
     * @return {?}
     */
    StaticReflector.prototype.propMetadata = function (type) {
        var _this = this;
        var /** @type {?} */ propMetadata = this.propertyCache.get(type);
        if (!propMetadata) {
            var /** @type {?} */ classMetadata = this.getTypeMetadata(type);
            propMetadata = {};
            var /** @type {?} */ parentType = this.findParentType(type, classMetadata);
            if (parentType) {
                var /** @type {?} */ parentPropMetadata_1 = this.propMetadata(parentType);
                Object.keys(parentPropMetadata_1).forEach(function (parentProp) {
                    ((propMetadata))[parentProp] = parentPropMetadata_1[parentProp];
                });
            }
            var /** @type {?} */ members_1 = classMetadata['members'] || {};
            Object.keys(members_1).forEach(function (propName) {
                var /** @type {?} */ propData = members_1[propName];
                var /** @type {?} */ prop = ((propData))
                    .find(function (a) { return a['__symbolic'] == 'property' || a['__symbolic'] == 'method'; });
                var /** @type {?} */ decorators = [];
                if (((propMetadata))[propName]) {
                    decorators.push.apply(decorators, ((propMetadata))[propName]);
                } /** @type {?} */
                ((propMetadata))[propName] = decorators;
                if (prop && prop['decorators']) {
                    decorators.push.apply(decorators, _this.simplify(type, prop['decorators']));
                }
            });
            this.propertyCache.set(type, propMetadata);
        }
        return propMetadata;
    };
    /**
     * @param {?} type
     * @return {?}
     */
    StaticReflector.prototype.parameters = function (type) {
        if (!(type instanceof StaticSymbol)) {
            this.reportError(new Error("parameters received " + JSON.stringify(type) + " which is not a StaticSymbol"), type);
            return [];
        }
        try {
            var /** @type {?} */ parameters_1 = this.parameterCache.get(type);
            if (!parameters_1) {
                var /** @type {?} */ classMetadata = this.getTypeMetadata(type);
                var /** @type {?} */ parentType = this.findParentType(type, classMetadata);
                var /** @type {?} */ members = classMetadata ? classMetadata['members'] : null;
                var /** @type {?} */ ctorData = members ? members['__ctor__'] : null;
                if (ctorData) {
                    var /** @type {?} */ ctor = ((ctorData)).find(function (a) { return a['__symbolic'] == 'constructor'; });
                    var /** @type {?} */ parameterTypes = (this.simplify(type, ctor['parameters'] || []));
                    var /** @type {?} */ parameterDecorators_1 = (this.simplify(type, ctor['parameterDecorators'] || []));
                    parameters_1 = [];
                    parameterTypes.forEach(function (paramType, index) {
                        var /** @type {?} */ nestedResult = [];
                        if (paramType) {
                            nestedResult.push(paramType);
                        }
                        var /** @type {?} */ decorators = parameterDecorators_1 ? parameterDecorators_1[index] : null;
                        if (decorators) {
                            nestedResult.push.apply(nestedResult, decorators);
                        } /** @type {?} */
                        ((parameters_1)).push(nestedResult);
                    });
                }
                else if (parentType) {
                    parameters_1 = this.parameters(parentType);
                }
                if (!parameters_1) {
                    parameters_1 = [];
                }
                this.parameterCache.set(type, parameters_1);
            }
            return parameters_1;
        }
        catch (e) {
            console.error("Failed on type " + JSON.stringify(type) + " with error " + e);
            throw e;
        }
    };
    /**
     * @param {?} type
     * @return {?}
     */
    StaticReflector.prototype._methodNames = function (type) {
        var /** @type {?} */ methodNames = this.methodCache.get(type);
        if (!methodNames) {
            var /** @type {?} */ classMetadata = this.getTypeMetadata(type);
            methodNames = {};
            var /** @type {?} */ parentType = this.findParentType(type, classMetadata);
            if (parentType) {
                var /** @type {?} */ parentMethodNames_1 = this._methodNames(parentType);
                Object.keys(parentMethodNames_1).forEach(function (parentProp) {
                    ((methodNames))[parentProp] = parentMethodNames_1[parentProp];
                });
            }
            var /** @type {?} */ members_2 = classMetadata['members'] || {};
            Object.keys(members_2).forEach(function (propName) {
                var /** @type {?} */ propData = members_2[propName];
                var /** @type {?} */ isMethod = ((propData)).some(function (a) { return a['__symbolic'] == 'method'; }); /** @type {?} */
                ((methodNames))[propName] = ((methodNames))[propName] || isMethod;
            });
            this.methodCache.set(type, methodNames);
        }
        return methodNames;
    };
    /**
     * @param {?} type
     * @param {?} classMetadata
     * @return {?}
     */
    StaticReflector.prototype.findParentType = function (type, classMetadata) {
        var /** @type {?} */ parentType = this.trySimplify(type, classMetadata['extends']);
        if (parentType instanceof StaticSymbol) {
            return parentType;
        }
    };
    /**
     * @param {?} type
     * @param {?} lcProperty
     * @return {?}
     */
    StaticReflector.prototype.hasLifecycleHook = function (type, lcProperty) {
        if (!(type instanceof StaticSymbol)) {
            this.reportError(new Error("hasLifecycleHook received " + JSON.stringify(type) + " which is not a StaticSymbol"), type);
        }
        try {
            return !!this._methodNames(type)[lcProperty];
        }
        catch (e) {
            console.error("Failed on type " + JSON.stringify(type) + " with error " + e);
            throw e;
        }
    };
    /**
     * @param {?} type
     * @param {?} ctor
     * @return {?}
     */
    StaticReflector.prototype._registerDecoratorOrConstructor = function (type, ctor) {
        this.conversionMap.set(type, function (context, args) { return new (ctor.bind.apply(ctor, [void 0].concat(args)))(); });
    };
    /**
     * @param {?} type
     * @param {?} fn
     * @return {?}
     */
    StaticReflector.prototype._registerFunction = function (type, fn) {
        this.conversionMap.set(type, function (context, args) { return fn.apply(undefined, args); });
    };
    /**
     * @return {?}
     */
    StaticReflector.prototype.initializeConversionMap = function () {
        this.injectionToken = this.findDeclaration(ANGULAR_CORE, 'InjectionToken');
        this.opaqueToken = this.findDeclaration(ANGULAR_CORE, 'OpaqueToken');
        this._registerDecoratorOrConstructor(this.findDeclaration(ANGULAR_CORE, 'Host'), __WEBPACK_IMPORTED_MODULE_0__angular_core__["Host"]);
        this._registerDecoratorOrConstructor(this.findDeclaration(ANGULAR_CORE, 'Injectable'), __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"]);
        this._registerDecoratorOrConstructor(this.findDeclaration(ANGULAR_CORE, 'Self'), __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"]);
        this._registerDecoratorOrConstructor(this.findDeclaration(ANGULAR_CORE, 'SkipSelf'), __WEBPACK_IMPORTED_MODULE_0__angular_core__["SkipSelf"]);
        this._registerDecoratorOrConstructor(this.findDeclaration(ANGULAR_CORE, 'Inject'), __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"]);
        this._registerDecoratorOrConstructor(this.findDeclaration(ANGULAR_CORE, 'Optional'), __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"]);
        this._registerDecoratorOrConstructor(this.findDeclaration(ANGULAR_CORE, 'Attribute'), __WEBPACK_IMPORTED_MODULE_0__angular_core__["Attribute"]);
        this._registerDecoratorOrConstructor(this.findDeclaration(ANGULAR_CORE, 'ContentChild'), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ContentChild"]);
        this._registerDecoratorOrConstructor(this.findDeclaration(ANGULAR_CORE, 'ContentChildren'), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ContentChildren"]);
        this._registerDecoratorOrConstructor(this.findDeclaration(ANGULAR_CORE, 'ViewChild'), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewChild"]);
        this._registerDecoratorOrConstructor(this.findDeclaration(ANGULAR_CORE, 'ViewChildren'), __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewChildren"]);
        this._registerDecoratorOrConstructor(this.findDeclaration(ANGULAR_CORE, 'Input'), __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"]);
        this._registerDecoratorOrConstructor(this.findDeclaration(ANGULAR_CORE, 'Output'), __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"]);
        this._registerDecoratorOrConstructor(this.findDeclaration(ANGULAR_CORE, 'Pipe'), __WEBPACK_IMPORTED_MODULE_0__angular_core__["Pipe"]);
        this._registerDecoratorOrConstructor(this.findDeclaration(ANGULAR_CORE, 'HostBinding'), __WEBPACK_IMPORTED_MODULE_0__angular_core__["HostBinding"]);
        this._registerDecoratorOrConstructor(this.findDeclaration(ANGULAR_CORE, 'HostListener'), __WEBPACK_IMPORTED_MODULE_0__angular_core__["HostListener"]);
        this._registerDecoratorOrConstructor(this.findDeclaration(ANGULAR_CORE, 'Directive'), __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"]);
        this._registerDecoratorOrConstructor(this.findDeclaration(ANGULAR_CORE, 'Component'), __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"]);
        this._registerDecoratorOrConstructor(this.findDeclaration(ANGULAR_CORE, 'NgModule'), __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"]);
        // Note: Some metadata classes can be used directly with Provider.deps.
        this._registerDecoratorOrConstructor(this.findDeclaration(ANGULAR_CORE, 'Host'), __WEBPACK_IMPORTED_MODULE_0__angular_core__["Host"]);
        this._registerDecoratorOrConstructor(this.findDeclaration(ANGULAR_CORE, 'Self'), __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"]);
        this._registerDecoratorOrConstructor(this.findDeclaration(ANGULAR_CORE, 'SkipSelf'), __WEBPACK_IMPORTED_MODULE_0__angular_core__["SkipSelf"]);
        this._registerDecoratorOrConstructor(this.findDeclaration(ANGULAR_CORE, 'Optional'), __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"]);
        this._registerFunction(this.findDeclaration(ANGULAR_CORE, 'trigger'), __WEBPACK_IMPORTED_MODULE_0__angular_core__["trigger"]);
        this._registerFunction(this.findDeclaration(ANGULAR_CORE, 'state'), __WEBPACK_IMPORTED_MODULE_0__angular_core__["state"]);
        this._registerFunction(this.findDeclaration(ANGULAR_CORE, 'transition'), __WEBPACK_IMPORTED_MODULE_0__angular_core__["transition"]);
        this._registerFunction(this.findDeclaration(ANGULAR_CORE, 'style'), __WEBPACK_IMPORTED_MODULE_0__angular_core__["style"]);
        this._registerFunction(this.findDeclaration(ANGULAR_CORE, 'animate'), __WEBPACK_IMPORTED_MODULE_0__angular_core__["animate"]);
        this._registerFunction(this.findDeclaration(ANGULAR_CORE, 'keyframes'), __WEBPACK_IMPORTED_MODULE_0__angular_core__["keyframes"]);
        this._registerFunction(this.findDeclaration(ANGULAR_CORE, 'sequence'), __WEBPACK_IMPORTED_MODULE_0__angular_core__["sequence"]);
        this._registerFunction(this.findDeclaration(ANGULAR_CORE, 'group'), __WEBPACK_IMPORTED_MODULE_0__angular_core__["group"]);
    };
    /**
     * getStaticSymbol produces a Type whose metadata is known but whose implementation is not loaded.
     * All types passed to the StaticResolver should be pseudo-types returned by this method.
     *
     * @param {?} declarationFile the absolute path of the file where the symbol is declared
     * @param {?} name the name of the type.
     * @param {?=} members
     * @return {?}
     */
    StaticReflector.prototype.getStaticSymbol = function (declarationFile, name, members) {
        return this.symbolResolver.getStaticSymbol(declarationFile, name, members);
    };
    /**
     * @param {?} error
     * @param {?} context
     * @param {?=} path
     * @return {?}
     */
    StaticReflector.prototype.reportError = function (error, context, path) {
        if (this.errorRecorder) {
            this.errorRecorder(error, (context && context.filePath) || path);
        }
        else {
            throw error;
        }
    };
    /**
     * Simplify but discard any errors
     * @param {?} context
     * @param {?} value
     * @return {?}
     */
    StaticReflector.prototype.trySimplify = function (context, value) {
        var /** @type {?} */ originalRecorder = this.errorRecorder;
        this.errorRecorder = function (error, fileName) { };
        var /** @type {?} */ result = this.simplify(context, value);
        this.errorRecorder = originalRecorder;
        return result;
    };
    /**
     * \@internal
     * @param {?} context
     * @param {?} value
     * @return {?}
     */
    StaticReflector.prototype.simplify = function (context, value) {
        var _this = this;
        var /** @type {?} */ self = this;
        var /** @type {?} */ scope = BindingScope.empty;
        var /** @type {?} */ calling = new Map();
        /**
         * @param {?} context
         * @param {?} value
         * @param {?} depth
         * @return {?}
         */
        function simplifyInContext(context, value, depth) {
            /**
             * @param {?} staticSymbol
             * @return {?}
             */
            function resolveReferenceValue(staticSymbol) {
                var /** @type {?} */ resolvedSymbol = self.symbolResolver.resolveSymbol(staticSymbol);
                return resolvedSymbol ? resolvedSymbol.metadata : null;
            }
            /**
             * @param {?} functionSymbol
             * @param {?} targetFunction
             * @param {?} args
             * @return {?}
             */
            function simplifyCall(functionSymbol, targetFunction, args) {
                if (targetFunction && targetFunction['__symbolic'] == 'function') {
                    if (calling.get(functionSymbol)) {
                        throw new Error('Recursion not supported');
                    }
                    calling.set(functionSymbol, true);
                    try {
                        var /** @type {?} */ value_1 = targetFunction['value'];
                        if (value_1 && (depth != 0 || value_1.__symbolic != 'error')) {
                            var /** @type {?} */ parameters = targetFunction['parameters'];
                            var /** @type {?} */ defaults = targetFunction.defaults;
                            args = args.map(function (arg) { return simplifyInContext(context, arg, depth + 1); })
                                .map(function (arg) { return shouldIgnore(arg) ? undefined : arg; });
                            if (defaults && defaults.length > args.length) {
                                args.push.apply(args, defaults.slice(args.length).map(function (value) { return simplify(value); }));
                            }
                            var /** @type {?} */ functionScope = BindingScope.build();
                            for (var /** @type {?} */ i = 0; i < parameters.length; i++) {
                                functionScope.define(parameters[i], args[i]);
                            }
                            var /** @type {?} */ oldScope = scope;
                            var /** @type {?} */ result_1;
                            try {
                                scope = functionScope.done();
                                result_1 = simplifyInContext(functionSymbol, value_1, depth + 1);
                            }
                            finally {
                                scope = oldScope;
                            }
                            return result_1;
                        }
                    }
                    finally {
                        calling.delete(functionSymbol);
                    }
                }
                if (depth === 0) {
                    // If depth is 0 we are evaluating the top level expression that is describing element
                    // decorator. In this case, it is a decorator we don't understand, such as a custom
                    // non-angular decorator, and we should just ignore it.
                    return IGNORE;
                }
                return simplify({ __symbolic: 'error', message: 'Function call not supported', context: functionSymbol });
            }
            /**
             * @param {?} expression
             * @return {?}
             */
            function simplify(expression) {
                if (isPrimitive(expression)) {
                    return expression;
                }
                if (expression instanceof Array) {
                    var /** @type {?} */ result_2 = [];
                    for (var _i = 0, _a = ((expression)); _i < _a.length; _i++) {
                        var item = _a[_i];
                        // Check for a spread expression
                        if (item && item.__symbolic === 'spread') {
                            var /** @type {?} */ spreadArray = simplify(item.expression);
                            if (Array.isArray(spreadArray)) {
                                for (var _b = 0, spreadArray_1 = spreadArray; _b < spreadArray_1.length; _b++) {
                                    var spreadItem = spreadArray_1[_b];
                                    result_2.push(spreadItem);
                                }
                                continue;
                            }
                        }
                        var /** @type {?} */ value_2 = simplify(item);
                        if (shouldIgnore(value_2)) {
                            continue;
                        }
                        result_2.push(value_2);
                    }
                    return result_2;
                }
                if (expression instanceof StaticSymbol) {
                    // Stop simplification at builtin symbols
                    if (expression === self.injectionToken || expression === self.opaqueToken ||
                        self.conversionMap.has(expression)) {
                        return expression;
                    }
                    else {
                        var /** @type {?} */ staticSymbol = expression;
                        var /** @type {?} */ declarationValue = resolveReferenceValue(staticSymbol);
                        if (declarationValue) {
                            return simplifyInContext(staticSymbol, declarationValue, depth + 1);
                        }
                        else {
                            return staticSymbol;
                        }
                    }
                }
                if (expression) {
                    if (expression['__symbolic']) {
                        var /** @type {?} */ staticSymbol = void 0;
                        switch (expression['__symbolic']) {
                            case 'binop':
                                var /** @type {?} */ left = simplify(expression['left']);
                                if (shouldIgnore(left))
                                    return left;
                                var /** @type {?} */ right = simplify(expression['right']);
                                if (shouldIgnore(right))
                                    return right;
                                switch (expression['operator']) {
                                    case '&&':
                                        return left && right;
                                    case '||':
                                        return left || right;
                                    case '|':
                                        return left | right;
                                    case '^':
                                        return left ^ right;
                                    case '&':
                                        return left & right;
                                    case '==':
                                        return left == right;
                                    case '!=':
                                        return left != right;
                                    case '===':
                                        return left === right;
                                    case '!==':
                                        return left !== right;
                                    case '<':
                                        return left < right;
                                    case '>':
                                        return left > right;
                                    case '<=':
                                        return left <= right;
                                    case '>=':
                                        return left >= right;
                                    case '<<':
                                        return left << right;
                                    case '>>':
                                        return left >> right;
                                    case '+':
                                        return left + right;
                                    case '-':
                                        return left - right;
                                    case '*':
                                        return left * right;
                                    case '/':
                                        return left / right;
                                    case '%':
                                        return left % right;
                                }
                                return null;
                            case 'if':
                                var /** @type {?} */ condition = simplify(expression['condition']);
                                return condition ? simplify(expression['thenExpression']) :
                                    simplify(expression['elseExpression']);
                            case 'pre':
                                var /** @type {?} */ operand = simplify(expression['operand']);
                                if (shouldIgnore(operand))
                                    return operand;
                                switch (expression['operator']) {
                                    case '+':
                                        return operand;
                                    case '-':
                                        return -operand;
                                    case '!':
                                        return !operand;
                                    case '~':
                                        return ~operand;
                                }
                                return null;
                            case 'index':
                                var /** @type {?} */ indexTarget = simplify(expression['expression']);
                                var /** @type {?} */ index = simplify(expression['index']);
                                if (indexTarget && isPrimitive(index))
                                    return indexTarget[index];
                                return null;
                            case 'select':
                                var /** @type {?} */ member = expression['member'];
                                var /** @type {?} */ selectContext = context;
                                var /** @type {?} */ selectTarget = simplify(expression['expression']);
                                if (selectTarget instanceof StaticSymbol) {
                                    var /** @type {?} */ members = selectTarget.members.concat(member);
                                    selectContext =
                                        self.getStaticSymbol(selectTarget.filePath, selectTarget.name, members);
                                    var /** @type {?} */ declarationValue = resolveReferenceValue(selectContext);
                                    if (declarationValue) {
                                        return simplifyInContext(selectContext, declarationValue, depth + 1);
                                    }
                                    else {
                                        return selectContext;
                                    }
                                }
                                if (selectTarget && isPrimitive(member))
                                    return simplifyInContext(selectContext, selectTarget[member], depth + 1);
                                return null;
                            case 'reference':
                                // Note: This only has to deal with variable references,
                                // as symbol references have been converted into StaticSymbols already
                                // in the StaticSymbolResolver!
                                var /** @type {?} */ name = expression['name'];
                                var /** @type {?} */ localValue = scope.resolve(name);
                                if (localValue != BindingScope.missing) {
                                    return localValue;
                                }
                                break;
                            case 'class':
                                return context;
                            case 'function':
                                return context;
                            case 'new':
                            case 'call':
                                // Determine if the function is a built-in conversion
                                staticSymbol = simplifyInContext(context, expression['expression'], depth + 1);
                                if (staticSymbol instanceof StaticSymbol) {
                                    if (staticSymbol === self.injectionToken || staticSymbol === self.opaqueToken) {
                                        // if somebody calls new InjectionToken, don't create an InjectionToken,
                                        // but rather return the symbol to which the InjectionToken is assigned to.
                                        return context;
                                    }
                                    var /** @type {?} */ argExpressions = expression['arguments'] || [];
                                    var /** @type {?} */ converter = self.conversionMap.get(staticSymbol);
                                    if (converter) {
                                        var /** @type {?} */ args = argExpressions.map(function (arg) { return simplifyInContext(context, arg, depth + 1); })
                                            .map(function (arg) { return shouldIgnore(arg) ? undefined : arg; });
                                        return converter(context, args);
                                    }
                                    else {
                                        // Determine if the function is one we can simplify.
                                        var /** @type {?} */ targetFunction = resolveReferenceValue(staticSymbol);
                                        return simplifyCall(staticSymbol, targetFunction, argExpressions);
                                    }
                                }
                                return IGNORE;
                            case 'error':
                                var /** @type {?} */ message = produceErrorMessage(expression);
                                if (expression['line']) {
                                    message =
                                        message + " (position " + (expression['line'] + 1) + ":" + (expression['character'] + 1) + " in the original .ts file)";
                                    self.reportError(positionalError(message, context.filePath, expression['line'], expression['character']), context);
                                }
                                else {
                                    self.reportError(new Error(message), context);
                                }
                                return IGNORE;
                            case 'ignore':
                                return expression;
                        }
                        return null;
                    }
                    return mapStringMap(expression, function (value, name) { return simplify(value); });
                }
                return IGNORE;
            }
            try {
                return simplify(value);
            }
            catch (e) {
                var /** @type {?} */ members = context.members.length ? "." + context.members.join('.') : '';
                var /** @type {?} */ message = e.message + ", resolving symbol " + context.name + members + " in " + context.filePath;
                if (e.fileName) {
                    throw positionalError(message, e.fileName, e.line, e.column);
                }
                throw syntaxError(message);
            }
        }
        var /** @type {?} */ recordedSimplifyInContext = function (context, value, depth) {
            try {
                return simplifyInContext(context, value, depth);
            }
            catch (e) {
                _this.reportError(e, context);
            }
        };
        var /** @type {?} */ result = this.errorRecorder ? recordedSimplifyInContext(context, value, 0) :
            simplifyInContext(context, value, 0);
        if (shouldIgnore(result)) {
            return undefined;
        }
        return result;
    };
    /**
     * @param {?} type
     * @return {?}
     */
    StaticReflector.prototype.getTypeMetadata = function (type) {
        var /** @type {?} */ resolvedSymbol = this.symbolResolver.resolveSymbol(type);
        return resolvedSymbol && resolvedSymbol.metadata ? resolvedSymbol.metadata :
            { __symbolic: 'class' };
    };
    return StaticReflector;
}());
/**
 * @param {?} error
 * @return {?}
 */
function expandedMessage(error) {
    switch (error.message) {
        case 'Reference to non-exported class':
            if (error.context && error.context.className) {
                return "Reference to a non-exported class " + error.context.className + ". Consider exporting the class";
            }
            break;
        case 'Variable not initialized':
            return 'Only initialized variables and constants can be referenced because the value of this variable is needed by the template compiler';
        case 'Destructuring not supported':
            return 'Referencing an exported destructured variable or constant is not supported by the template compiler. Consider simplifying this to avoid destructuring';
        case 'Could not resolve type':
            if (error.context && error.context.typeName) {
                return "Could not resolve type " + error.context.typeName;
            }
            break;
        case 'Function call not supported':
            var /** @type {?} */ prefix = error.context && error.context.name ? "Calling function '" + error.context.name + "', f" : 'F';
            return prefix +
                'unction calls are not supported. Consider replacing the function or lambda with a reference to an exported function';
        case 'Reference to a local symbol':
            if (error.context && error.context.name) {
                return "Reference to a local (non-exported) symbol '" + error.context.name + "'. Consider exporting the symbol";
            }
            break;
    }
    return error.message;
}
/**
 * @param {?} error
 * @return {?}
 */
function produceErrorMessage(error) {
    return "Error encountered resolving symbol values statically. " + expandedMessage(error);
}
/**
 * @param {?} input
 * @param {?} transform
 * @return {?}
 */
function mapStringMap(input, transform) {
    if (!input)
        return {};
    var /** @type {?} */ result = {};
    Object.keys(input).forEach(function (key) {
        var /** @type {?} */ value = transform(input[key], key);
        if (!shouldIgnore(value)) {
            if (HIDDEN_KEY.test(key)) {
                Object.defineProperty(result, key, { enumerable: false, configurable: true, value: value });
            }
            else {
                result[key] = value;
            }
        }
    });
    return result;
}
/**
 * @param {?} o
 * @return {?}
 */
function isPrimitive(o) {
    return o === null || (typeof o !== 'function' && typeof o !== 'object');
}
/**
 * @abstract
 */
var BindingScope = (function () {
    function BindingScope() {
    }
    /**
     * @abstract
     * @param {?} name
     * @return {?}
     */
    BindingScope.prototype.resolve = function (name) { };
    /**
     * @return {?}
     */
    BindingScope.build = function () {
        var /** @type {?} */ current = new Map();
        return {
            define: function (name, value) {
                current.set(name, value);
                return this;
            },
            done: function () {
                return current.size > 0 ? new PopulatedScope(current) : BindingScope.empty;
            }
        };
    };
    return BindingScope;
}());
BindingScope.missing = {};
BindingScope.empty = { resolve: function (name) { return BindingScope.missing; } };
var PopulatedScope = (function (_super) {
    __extends(PopulatedScope, _super);
    /**
     * @param {?} bindings
     */
    function PopulatedScope(bindings) {
        var _this = _super.call(this) || this;
        _this.bindings = bindings;
        return _this;
    }
    /**
     * @param {?} name
     * @return {?}
     */
    PopulatedScope.prototype.resolve = function (name) {
        return this.bindings.has(name) ? this.bindings.get(name) : BindingScope.missing;
    };
    return PopulatedScope;
}(BindingScope));
/**
 * @param {?} message
 * @param {?} fileName
 * @param {?} line
 * @param {?} column
 * @return {?}
 */
function positionalError(message, fileName, line, column) {
    var /** @type {?} */ result = new Error(message);
    ((result)).fileName = fileName;
    ((result)).line = line;
    ((result)).column = column;
    return result;
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var ResolvedStaticSymbol = (function () {
    /**
     * @param {?} symbol
     * @param {?} metadata
     */
    function ResolvedStaticSymbol(symbol, metadata) {
        this.symbol = symbol;
        this.metadata = metadata;
    }
    return ResolvedStaticSymbol;
}());
var SUPPORTED_SCHEMA_VERSION = 3;
/**
 * This class is responsible for loading metadata per symbol,
 * and normalizing references between symbols.
 *
 * Internally, it only uses symbols without members,
 * and deduces the values for symbols with members based
 * on these symbols.
 */
var StaticSymbolResolver = (function () {
    /**
     * @param {?} host
     * @param {?} staticSymbolCache
     * @param {?} summaryResolver
     * @param {?=} errorRecorder
     */
    function StaticSymbolResolver(host, staticSymbolCache, summaryResolver, errorRecorder) {
        this.host = host;
        this.staticSymbolCache = staticSymbolCache;
        this.summaryResolver = summaryResolver;
        this.errorRecorder = errorRecorder;
        this.metadataCache = new Map();
        this.resolvedSymbols = new Map();
        this.resolvedFilePaths = new Set();
        this.importAs = new Map();
        this.symbolResourcePaths = new Map();
        this.symbolFromFile = new Map();
    }
    /**
     * @param {?} staticSymbol
     * @return {?}
     */
    StaticSymbolResolver.prototype.resolveSymbol = function (staticSymbol) {
        if (staticSymbol.members.length > 0) {
            return ((this._resolveSymbolMembers(staticSymbol)));
        }
        var /** @type {?} */ result = this.resolvedSymbols.get(staticSymbol);
        if (result) {
            return result;
        }
        result = ((this._resolveSymbolFromSummary(staticSymbol)));
        if (result) {
            return result;
        }
        // Note: Some users use libraries that were not compiled with ngc, i.e. they don't
        // have summaries, only .d.ts files. So we always need to check both, the summary
        // and metadata.
        this._createSymbolsOf(staticSymbol.filePath);
        result = ((this.resolvedSymbols.get(staticSymbol)));
        return result;
    };
    /**
     * getImportAs produces a symbol that can be used to import the given symbol.
     * The import might be different than the symbol if the symbol is exported from
     * a library with a summary; in which case we want to import the symbol from the
     * ngfactory re-export instead of directly to avoid introducing a direct dependency
     * on an otherwise indirect dependency.
     *
     * @param {?} staticSymbol the symbol for which to generate a import symbol
     * @return {?}
     */
    StaticSymbolResolver.prototype.getImportAs = function (staticSymbol) {
        if (staticSymbol.members.length) {
            var /** @type {?} */ baseSymbol = this.getStaticSymbol(staticSymbol.filePath, staticSymbol.name);
            var /** @type {?} */ baseImportAs = this.getImportAs(baseSymbol);
            return baseImportAs ?
                this.getStaticSymbol(baseImportAs.filePath, baseImportAs.name, staticSymbol.members) :
                null;
        }
        var /** @type {?} */ result = this.summaryResolver.getImportAs(staticSymbol);
        if (!result) {
            result = ((this.importAs.get(staticSymbol)));
        }
        return result;
    };
    /**
     * getResourcePath produces the path to the original location of the symbol and should
     * be used to determine the relative location of resource references recorded in
     * symbol metadata.
     * @param {?} staticSymbol
     * @return {?}
     */
    StaticSymbolResolver.prototype.getResourcePath = function (staticSymbol) {
        return this.symbolResourcePaths.get(staticSymbol) || staticSymbol.filePath;
    };
    /**
     * getTypeArity returns the number of generic type parameters the given symbol
     * has. If the symbol is not a type the result is null.
     * @param {?} staticSymbol
     * @return {?}
     */
    StaticSymbolResolver.prototype.getTypeArity = function (staticSymbol) {
        // If the file is a factory file, don't resolve the symbol as doing so would
        // cause the metadata for an factory file to be loaded which doesn't exist.
        // All references to generated classes must include the correct arity whenever
        // generating code.
        if (isNgFactoryFile(staticSymbol.filePath)) {
            return null;
        }
        var /** @type {?} */ resolvedSymbol = this.resolveSymbol(staticSymbol);
        while (resolvedSymbol && resolvedSymbol.metadata instanceof StaticSymbol) {
            resolvedSymbol = this.resolveSymbol(resolvedSymbol.metadata);
        }
        return (resolvedSymbol && resolvedSymbol.metadata && resolvedSymbol.metadata.arity) || null;
    };
    /**
     * @param {?} sourceSymbol
     * @param {?} targetSymbol
     * @return {?}
     */
    StaticSymbolResolver.prototype.recordImportAs = function (sourceSymbol, targetSymbol) {
        sourceSymbol.assertNoMembers();
        targetSymbol.assertNoMembers();
        this.importAs.set(sourceSymbol, targetSymbol);
    };
    /**
     * Invalidate all information derived from the given file.
     *
     * @param {?} fileName the file to invalidate
     * @return {?}
     */
    StaticSymbolResolver.prototype.invalidateFile = function (fileName) {
        this.metadataCache.delete(fileName);
        this.resolvedFilePaths.delete(fileName);
        var /** @type {?} */ symbols = this.symbolFromFile.get(fileName);
        if (symbols) {
            this.symbolFromFile.delete(fileName);
            for (var _i = 0, symbols_1 = symbols; _i < symbols_1.length; _i++) {
                var symbol = symbols_1[_i];
                this.resolvedSymbols.delete(symbol);
                this.importAs.delete(symbol);
                this.symbolResourcePaths.delete(symbol);
            }
        }
    };
    /**
     * @param {?} staticSymbol
     * @return {?}
     */
    StaticSymbolResolver.prototype._resolveSymbolMembers = function (staticSymbol) {
        var /** @type {?} */ members = staticSymbol.members;
        var /** @type {?} */ baseResolvedSymbol = this.resolveSymbol(this.getStaticSymbol(staticSymbol.filePath, staticSymbol.name));
        if (!baseResolvedSymbol) {
            return null;
        }
        var /** @type {?} */ baseMetadata = baseResolvedSymbol.metadata;
        if (baseMetadata instanceof StaticSymbol) {
            return new ResolvedStaticSymbol(staticSymbol, this.getStaticSymbol(baseMetadata.filePath, baseMetadata.name, members));
        }
        else if (baseMetadata && baseMetadata.__symbolic === 'class') {
            if (baseMetadata.statics && members.length === 1) {
                return new ResolvedStaticSymbol(staticSymbol, baseMetadata.statics[members[0]]);
            }
        }
        else {
            var /** @type {?} */ value = baseMetadata;
            for (var /** @type {?} */ i = 0; i < members.length && value; i++) {
                value = value[members[i]];
            }
            return new ResolvedStaticSymbol(staticSymbol, value);
        }
        return null;
    };
    /**
     * @param {?} staticSymbol
     * @return {?}
     */
    StaticSymbolResolver.prototype._resolveSymbolFromSummary = function (staticSymbol) {
        var /** @type {?} */ summary = this.summaryResolver.resolveSummary(staticSymbol);
        return summary ? new ResolvedStaticSymbol(staticSymbol, summary.metadata) : null;
    };
    /**
     * getStaticSymbol produces a Type whose metadata is known but whose implementation is not loaded.
     * All types passed to the StaticResolver should be pseudo-types returned by this method.
     *
     * @param {?} declarationFile the absolute path of the file where the symbol is declared
     * @param {?} name the name of the type.
     * @param {?=} members a symbol for a static member of the named type
     * @return {?}
     */
    StaticSymbolResolver.prototype.getStaticSymbol = function (declarationFile, name, members) {
        return this.staticSymbolCache.get(declarationFile, name, members);
    };
    /**
     * @param {?} filePath
     * @return {?}
     */
    StaticSymbolResolver.prototype.getSymbolsOf = function (filePath) {
        // Note: Some users use libraries that were not compiled with ngc, i.e. they don't
        // have summaries, only .d.ts files. So we always need to check both, the summary
        // and metadata.
        var /** @type {?} */ symbols = new Set(this.summaryResolver.getSymbolsOf(filePath));
        this._createSymbolsOf(filePath);
        this.resolvedSymbols.forEach(function (resolvedSymbol) {
            if (resolvedSymbol.symbol.filePath === filePath) {
                symbols.add(resolvedSymbol.symbol);
            }
        });
        return Array.from(symbols);
    };
    /**
     * @param {?} filePath
     * @return {?}
     */
    StaticSymbolResolver.prototype._createSymbolsOf = function (filePath) {
        var _this = this;
        if (this.resolvedFilePaths.has(filePath)) {
            return;
        }
        this.resolvedFilePaths.add(filePath);
        var /** @type {?} */ resolvedSymbols = [];
        var /** @type {?} */ metadata = this.getModuleMetadata(filePath);
        if (metadata['metadata']) {
            // handle direct declarations of the symbol
            var /** @type {?} */ topLevelSymbolNames_1 = new Set(Object.keys(metadata['metadata']).map(unescapeIdentifier));
            var /** @type {?} */ origins_1 = metadata['origins'] || {};
            Object.keys(metadata['metadata']).forEach(function (metadataKey) {
                var /** @type {?} */ symbolMeta = metadata['metadata'][metadataKey];
                var /** @type {?} */ name = unescapeIdentifier(metadataKey);
                var /** @type {?} */ symbol = _this.getStaticSymbol(filePath, name);
                var /** @type {?} */ importSymbol = undefined;
                if (metadata['importAs']) {
                    // Index bundle indexes should use the importAs module name instead of a reference
                    // to the .d.ts file directly.
                    importSymbol = _this.getStaticSymbol(metadata['importAs'], name);
                    _this.recordImportAs(symbol, importSymbol);
                }
                var /** @type {?} */ origin = origins_1.hasOwnProperty(metadataKey) && origins_1[metadataKey];
                if (origin) {
                    // If the symbol is from a bundled index, use the declaration location of the
                    // symbol so relative references (such as './my.html') will be calculated
                    // correctly.
                    var /** @type {?} */ originFilePath = _this.resolveModule(origin, filePath);
                    if (!originFilePath) {
                        _this.reportError(new Error("Couldn't resolve original symbol for " + origin + " from " + filePath));
                    }
                    else {
                        _this.symbolResourcePaths.set(symbol, originFilePath);
                    }
                }
                resolvedSymbols.push(_this.createResolvedSymbol(symbol, filePath, topLevelSymbolNames_1, symbolMeta));
            });
        }
        // handle the symbols in one of the re-export location
        if (metadata['exports']) {
            var _loop_1 = function (moduleExport) {
                // handle the symbols in the list of explicitly re-exported symbols.
                if (moduleExport.export) {
                    moduleExport.export.forEach(function (exportSymbol) {
                        var /** @type {?} */ symbolName;
                        if (typeof exportSymbol === 'string') {
                            symbolName = exportSymbol;
                        }
                        else {
                            symbolName = exportSymbol.as;
                        }
                        symbolName = unescapeIdentifier(symbolName);
                        var /** @type {?} */ symName = symbolName;
                        if (typeof exportSymbol !== 'string') {
                            symName = unescapeIdentifier(exportSymbol.name);
                        }
                        var /** @type {?} */ resolvedModule = _this.resolveModule(moduleExport.from, filePath);
                        if (resolvedModule) {
                            var /** @type {?} */ targetSymbol = _this.getStaticSymbol(resolvedModule, symName);
                            var /** @type {?} */ sourceSymbol = _this.getStaticSymbol(filePath, symbolName);
                            resolvedSymbols.push(_this.createExport(sourceSymbol, targetSymbol));
                        }
                    });
                }
                else {
                    // handle the symbols via export * directives.
                    var /** @type {?} */ resolvedModule = this_1.resolveModule(moduleExport.from, filePath);
                    if (resolvedModule) {
                        var /** @type {?} */ nestedExports = this_1.getSymbolsOf(resolvedModule);
                        nestedExports.forEach(function (targetSymbol) {
                            var /** @type {?} */ sourceSymbol = _this.getStaticSymbol(filePath, targetSymbol.name);
                            resolvedSymbols.push(_this.createExport(sourceSymbol, targetSymbol));
                        });
                    }
                }
            };
            var this_1 = this;
            for (var _i = 0, _a = metadata['exports']; _i < _a.length; _i++) {
                var moduleExport = _a[_i];
                _loop_1(/** @type {?} */ moduleExport);
            }
        }
        resolvedSymbols.forEach(function (resolvedSymbol) { return _this.resolvedSymbols.set(resolvedSymbol.symbol, resolvedSymbol); });
        this.symbolFromFile.set(filePath, resolvedSymbols.map(function (resolvedSymbol) { return resolvedSymbol.symbol; }));
    };
    /**
     * @param {?} sourceSymbol
     * @param {?} topLevelPath
     * @param {?} topLevelSymbolNames
     * @param {?} metadata
     * @return {?}
     */
    StaticSymbolResolver.prototype.createResolvedSymbol = function (sourceSymbol, topLevelPath, topLevelSymbolNames, metadata) {
        // For classes that don't have Angular summaries / metadata,
        // we only keep their arity, but nothing else
        // (e.g. their constructor parameters).
        // We do this to prevent introducing deep imports
        // as we didn't generate .ngfactory.ts files with proper reexports.
        if (this.summaryResolver.isLibraryFile(sourceSymbol.filePath) && metadata &&
            metadata['__symbolic'] === 'class') {
            var /** @type {?} */ transformedMeta_1 = { __symbolic: 'class', arity: metadata.arity };
            return new ResolvedStaticSymbol(sourceSymbol, transformedMeta_1);
        }
        var /** @type {?} */ self = this;
        var ReferenceTransformer = (function (_super) {
            __extends(ReferenceTransformer, _super);
            function ReferenceTransformer() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            /**
             * @param {?} map
             * @param {?} functionParams
             * @return {?}
             */
            ReferenceTransformer.prototype.visitStringMap = function (map, functionParams) {
                var /** @type {?} */ symbolic = map['__symbolic'];
                if (symbolic === 'function') {
                    var /** @type {?} */ oldLen = functionParams.length;
                    functionParams.push.apply(functionParams, (map['parameters'] || []));
                    var /** @type {?} */ result = _super.prototype.visitStringMap.call(this, map, functionParams);
                    functionParams.length = oldLen;
                    return result;
                }
                else if (symbolic === 'reference') {
                    var /** @type {?} */ module_1 = map['module'];
                    var /** @type {?} */ name = map['name'] ? unescapeIdentifier(map['name']) : map['name'];
                    if (!name) {
                        return null;
                    }
                    var /** @type {?} */ filePath = void 0;
                    if (module_1) {
                        filePath = ((self.resolveModule(module_1, sourceSymbol.filePath)));
                        if (!filePath) {
                            return {
                                __symbolic: 'error',
                                message: "Could not resolve " + module_1 + " relative to " + sourceSymbol.filePath + "."
                            };
                        }
                        return self.getStaticSymbol(filePath, name);
                    }
                    else if (functionParams.indexOf(name) >= 0) {
                        // reference to a function parameter
                        return { __symbolic: 'reference', name: name };
                    }
                    else {
                        if (topLevelSymbolNames.has(name)) {
                            return self.getStaticSymbol(topLevelPath, name);
                        }
                        // ambient value
                        null;
                    }
                }
                else {
                    return _super.prototype.visitStringMap.call(this, map, functionParams);
                }
            };
            return ReferenceTransformer;
        }(ValueTransformer));
        var /** @type {?} */ transformedMeta = visitValue(metadata, new ReferenceTransformer(), []);
        if (transformedMeta instanceof StaticSymbol) {
            return this.createExport(sourceSymbol, transformedMeta);
        }
        return new ResolvedStaticSymbol(sourceSymbol, transformedMeta);
    };
    /**
     * @param {?} sourceSymbol
     * @param {?} targetSymbol
     * @return {?}
     */
    StaticSymbolResolver.prototype.createExport = function (sourceSymbol, targetSymbol) {
        sourceSymbol.assertNoMembers();
        targetSymbol.assertNoMembers();
        if (this.summaryResolver.isLibraryFile(sourceSymbol.filePath)) {
            // This case is for an ng library importing symbols from a plain ts library
            // transitively.
            // Note: We rely on the fact that we discover symbols in the direction
            // from source files to library files
            this.importAs.set(targetSymbol, this.getImportAs(sourceSymbol) || sourceSymbol);
        }
        return new ResolvedStaticSymbol(sourceSymbol, targetSymbol);
    };
    /**
     * @param {?} error
     * @param {?=} context
     * @param {?=} path
     * @return {?}
     */
    StaticSymbolResolver.prototype.reportError = function (error, context, path) {
        if (this.errorRecorder) {
            this.errorRecorder(error, (context && context.filePath) || path);
        }
        else {
            throw error;
        }
    };
    /**
     * @param {?} module an absolute path to a module file.
     * @return {?}
     */
    StaticSymbolResolver.prototype.getModuleMetadata = function (module) {
        var /** @type {?} */ moduleMetadata = this.metadataCache.get(module);
        if (!moduleMetadata) {
            var /** @type {?} */ moduleMetadatas = this.host.getMetadataFor(module);
            if (moduleMetadatas) {
                var /** @type {?} */ maxVersion_1 = -1;
                moduleMetadatas.forEach(function (md) {
                    if (md['version'] > maxVersion_1) {
                        maxVersion_1 = md['version'];
                        moduleMetadata = md;
                    }
                });
            }
            if (!moduleMetadata) {
                moduleMetadata =
                    { __symbolic: 'module', version: SUPPORTED_SCHEMA_VERSION, module: module, metadata: {} };
            }
            if (moduleMetadata['version'] != SUPPORTED_SCHEMA_VERSION) {
                var /** @type {?} */ errorMessage = moduleMetadata['version'] == 2 ?
                    "Unsupported metadata version " + moduleMetadata['version'] + " for module " + module + ". This module should be compiled with a newer version of ngc" :
                    "Metadata version mismatch for module " + module + ", found version " + moduleMetadata['version'] + ", expected " + SUPPORTED_SCHEMA_VERSION;
                this.reportError(new Error(errorMessage));
            }
            this.metadataCache.set(module, moduleMetadata);
        }
        return moduleMetadata;
    };
    /**
     * @param {?} module
     * @param {?} symbolName
     * @param {?=} containingFile
     * @return {?}
     */
    StaticSymbolResolver.prototype.getSymbolByModule = function (module, symbolName, containingFile) {
        var /** @type {?} */ filePath = this.resolveModule(module, containingFile);
        if (!filePath) {
            this.reportError(new Error("Could not resolve module " + module + (containingFile ? " relative to $ {\n            containingFile\n          } " : '')));
            return this.getStaticSymbol("ERROR:" + module, symbolName);
        }
        return this.getStaticSymbol(filePath, symbolName);
    };
    /**
     * @param {?} module
     * @param {?=} containingFile
     * @return {?}
     */
    StaticSymbolResolver.prototype.resolveModule = function (module, containingFile) {
        try {
            return this.host.moduleNameToFileName(module, containingFile);
        }
        catch (e) {
            console.error("Could not resolve module '" + module + "' relative to file " + containingFile);
            this.reportError(e, undefined, containingFile);
        }
        return null;
    };
    return StaticSymbolResolver;
}());
/**
 * @param {?} identifier
 * @return {?}
 */
function unescapeIdentifier(identifier) {
    return identifier.startsWith('___') ? identifier.substr(1) : identifier;
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var AotSummaryResolver = (function () {
    /**
     * @param {?} host
     * @param {?} staticSymbolCache
     */
    function AotSummaryResolver(host, staticSymbolCache) {
        this.host = host;
        this.staticSymbolCache = staticSymbolCache;
        this.summaryCache = new Map();
        this.loadedFilePaths = new Set();
        this.importAs = new Map();
    }
    /**
     * @param {?} filePath
     * @return {?}
     */
    AotSummaryResolver.prototype.isLibraryFile = function (filePath) {
        // Note: We need to strip the .ngfactory. file path,
        // so this method also works for generated files
        // (for which host.isSourceFile will always return false).
        return !this.host.isSourceFile(stripNgFactory(filePath));
    };
    /**
     * @param {?} filePath
     * @return {?}
     */
    AotSummaryResolver.prototype.getLibraryFileName = function (filePath) { return this.host.getOutputFileName(filePath); };
    /**
     * @param {?} staticSymbol
     * @return {?}
     */
    AotSummaryResolver.prototype.resolveSummary = function (staticSymbol) {
        staticSymbol.assertNoMembers();
        var /** @type {?} */ summary = this.summaryCache.get(staticSymbol);
        if (!summary) {
            this._loadSummaryFile(staticSymbol.filePath);
            summary = ((this.summaryCache.get(staticSymbol)));
        }
        return summary;
    };
    /**
     * @param {?} filePath
     * @return {?}
     */
    AotSummaryResolver.prototype.getSymbolsOf = function (filePath) {
        this._loadSummaryFile(filePath);
        return Array.from(this.summaryCache.keys()).filter(function (symbol) { return symbol.filePath === filePath; });
    };
    /**
     * @param {?} staticSymbol
     * @return {?}
     */
    AotSummaryResolver.prototype.getImportAs = function (staticSymbol) {
        staticSymbol.assertNoMembers();
        return ((this.importAs.get(staticSymbol)));
    };
    /**
     * @param {?} filePath
     * @return {?}
     */
    AotSummaryResolver.prototype._loadSummaryFile = function (filePath) {
        var _this = this;
        if (this.loadedFilePaths.has(filePath)) {
            return;
        }
        this.loadedFilePaths.add(filePath);
        if (this.isLibraryFile(filePath)) {
            var /** @type {?} */ summaryFilePath = summaryFileName(filePath);
            var /** @type {?} */ json = void 0;
            try {
                json = this.host.loadSummary(summaryFilePath);
            }
            catch (e) {
                console.error("Error loading summary file " + summaryFilePath);
                throw e;
            }
            if (json) {
                var _a = deserializeSummaries(this.staticSymbolCache, json), summaries = _a.summaries, importAs = _a.importAs;
                summaries.forEach(function (summary) { return _this.summaryCache.set(summary.symbol, summary); });
                importAs.forEach(function (importAs) {
                    _this.importAs.set(importAs.symbol, _this.staticSymbolCache.get(ngfactoryFilePath(filePath), importAs.importAs));
                });
            }
        }
    };
    return AotSummaryResolver;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Creates a new AotCompiler based on options and a host.
 * @param {?} compilerHost
 * @param {?} options
 * @return {?}
 */
function createAotCompiler(compilerHost, options) {
    var /** @type {?} */ translations = options.translations || '';
    var /** @type {?} */ urlResolver = createOfflineCompileUrlResolver();
    var /** @type {?} */ symbolCache = new StaticSymbolCache();
    var /** @type {?} */ summaryResolver = new AotSummaryResolver(compilerHost, symbolCache);
    var /** @type {?} */ symbolResolver = new StaticSymbolResolver(compilerHost, symbolCache, summaryResolver);
    var /** @type {?} */ staticReflector = new StaticReflector(summaryResolver, symbolResolver);
    StaticAndDynamicReflectionCapabilities.install(staticReflector);
    var /** @type {?} */ console = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵConsole"]();
    var /** @type {?} */ htmlParser = new I18NHtmlParser(new HtmlParser(), translations, options.i18nFormat, __WEBPACK_IMPORTED_MODULE_0__angular_core__["MissingTranslationStrategy"].Warning, console);
    var /** @type {?} */ config = new CompilerConfig({
        defaultEncapsulation: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewEncapsulation"].Emulated,
        useJit: false,
        enableLegacyTemplate: options.enableLegacyTemplate !== false,
    });
    var /** @type {?} */ normalizer = new DirectiveNormalizer({ get: function (url) { return compilerHost.loadResource(url); } }, urlResolver, htmlParser, config);
    var /** @type {?} */ expressionParser = new Parser(new Lexer());
    var /** @type {?} */ elementSchemaRegistry = new DomElementSchemaRegistry();
    var /** @type {?} */ tmplParser = new TemplateParser(config, expressionParser, elementSchemaRegistry, htmlParser, console, []);
    var /** @type {?} */ resolver = new CompileMetadataResolver(config, new NgModuleResolver(staticReflector), new DirectiveResolver(staticReflector), new PipeResolver(staticReflector), summaryResolver, elementSchemaRegistry, normalizer, console, symbolCache, staticReflector);
    // TODO(vicb): do not pass options.i18nFormat here
    var /** @type {?} */ importResolver = {
        getImportAs: function (symbol) { return ((symbolResolver.getImportAs(symbol))); },
        fileNameToModuleName: function (fileName, containingFilePath) { return compilerHost.fileNameToModuleName(fileName, containingFilePath); },
        getTypeArity: function (symbol) { return ((symbolResolver.getTypeArity(symbol))); }
    };
    var /** @type {?} */ viewCompiler = new ViewCompiler(config, elementSchemaRegistry);
    var /** @type {?} */ compiler = new AotCompiler(config, compilerHost, resolver, tmplParser, new StyleCompiler(urlResolver), viewCompiler, new NgModuleCompiler(), new TypeScriptEmitter(importResolver), summaryResolver, options.locale || null, options.i18nFormat || null, options.genFilePreamble || null, symbolResolver);
    return { compiler: compiler, reflector: staticReflector };
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @param {?} statements
 * @param {?} resultVars
 * @return {?}
 */
function interpretStatements(statements, resultVars) {
    var /** @type {?} */ stmtsWithReturn = statements.concat([new ReturnStatement(literalArr(resultVars.map(function (resultVar) { return variable(resultVar); })))]);
    var /** @type {?} */ ctx = new _ExecutionContext(null, null, null, new Map());
    var /** @type {?} */ visitor = new StatementInterpreter();
    var /** @type {?} */ result = visitor.visitAllStatements(stmtsWithReturn, ctx);
    return result != null ? result.value : null;
}
/**
 * @param {?} varNames
 * @param {?} varValues
 * @param {?} statements
 * @param {?} ctx
 * @param {?} visitor
 * @return {?}
 */
function _executeFunctionStatements(varNames, varValues, statements, ctx, visitor) {
    var /** @type {?} */ childCtx = ctx.createChildWihtLocalVars();
    for (var /** @type {?} */ i = 0; i < varNames.length; i++) {
        childCtx.vars.set(varNames[i], varValues[i]);
    }
    var /** @type {?} */ result = visitor.visitAllStatements(statements, childCtx);
    return result ? result.value : null;
}
var _ExecutionContext = (function () {
    /**
     * @param {?} parent
     * @param {?} instance
     * @param {?} className
     * @param {?} vars
     */
    function _ExecutionContext(parent, instance, className, vars) {
        this.parent = parent;
        this.instance = instance;
        this.className = className;
        this.vars = vars;
    }
    /**
     * @return {?}
     */
    _ExecutionContext.prototype.createChildWihtLocalVars = function () {
        return new _ExecutionContext(this, this.instance, this.className, new Map());
    };
    return _ExecutionContext;
}());
var ReturnValue = (function () {
    /**
     * @param {?} value
     */
    function ReturnValue(value) {
        this.value = value;
    }
    return ReturnValue;
}());
/**
 * @param {?} _classStmt
 * @param {?} _ctx
 * @param {?} _visitor
 * @return {?}
 */
function createDynamicClass(_classStmt, _ctx, _visitor) {
    var /** @type {?} */ propertyDescriptors = {};
    _classStmt.getters.forEach(function (getter) {
        // Note: use `function` instead of arrow function to capture `this`
        propertyDescriptors[getter.name] = {
            configurable: false,
            get: function () {
                var /** @type {?} */ instanceCtx = new _ExecutionContext(_ctx, this, _classStmt.name, _ctx.vars);
                return _executeFunctionStatements([], [], getter.body, instanceCtx, _visitor);
            }
        };
    });
    _classStmt.methods.forEach(function (method) {
        var /** @type {?} */ paramNames = method.params.map(function (param) { return param.name; });
        // Note: use `function` instead of arrow function to capture `this`
        propertyDescriptors[((method.name))] = {
            writable: false,
            configurable: false,
            value: function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                var /** @type {?} */ instanceCtx = new _ExecutionContext(_ctx, this, _classStmt.name, _ctx.vars);
                return _executeFunctionStatements(paramNames, args, method.body, instanceCtx, _visitor);
            }
        };
    });
    var /** @type {?} */ ctorParamNames = _classStmt.constructorMethod.params.map(function (param) { return param.name; });
    // Note: use `function` instead of arrow function to capture `this`
    var /** @type {?} */ ctor = function () {
        var _this = this;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var /** @type {?} */ instanceCtx = new _ExecutionContext(_ctx, this, _classStmt.name, _ctx.vars);
        _classStmt.fields.forEach(function (field) { _this[field.name] = undefined; });
        _executeFunctionStatements(ctorParamNames, args, _classStmt.constructorMethod.body, instanceCtx, _visitor);
    };
    var /** @type {?} */ superClass = _classStmt.parent ? _classStmt.parent.visitExpression(_visitor, _ctx) : Object;
    ctor.prototype = Object.create(superClass.prototype, propertyDescriptors);
    return ctor;
}
var StatementInterpreter = (function () {
    function StatementInterpreter() {
    }
    /**
     * @param {?} ast
     * @return {?}
     */
    StatementInterpreter.prototype.debugAst = function (ast) { return debugOutputAstAsTypeScript(ast); };
    /**
     * @param {?} stmt
     * @param {?} ctx
     * @return {?}
     */
    StatementInterpreter.prototype.visitDeclareVarStmt = function (stmt, ctx) {
        ctx.vars.set(stmt.name, stmt.value.visitExpression(this, ctx));
        return null;
    };
    /**
     * @param {?} expr
     * @param {?} ctx
     * @return {?}
     */
    StatementInterpreter.prototype.visitWriteVarExpr = function (expr, ctx) {
        var /** @type {?} */ value = expr.value.visitExpression(this, ctx);
        var /** @type {?} */ currCtx = ctx;
        while (currCtx != null) {
            if (currCtx.vars.has(expr.name)) {
                currCtx.vars.set(expr.name, value);
                return value;
            }
            currCtx = ((currCtx.parent));
        }
        throw new Error("Not declared variable " + expr.name);
    };
    /**
     * @param {?} ast
     * @param {?} ctx
     * @return {?}
     */
    StatementInterpreter.prototype.visitReadVarExpr = function (ast, ctx) {
        var /** @type {?} */ varName = ((ast.name));
        if (ast.builtin != null) {
            switch (ast.builtin) {
                case BuiltinVar.Super:
                    return ctx.instance.__proto__;
                case BuiltinVar.This:
                    return ctx.instance;
                case BuiltinVar.CatchError:
                    varName = CATCH_ERROR_VAR$2;
                    break;
                case BuiltinVar.CatchStack:
                    varName = CATCH_STACK_VAR$2;
                    break;
                default:
                    throw new Error("Unknown builtin variable " + ast.builtin);
            }
        }
        var /** @type {?} */ currCtx = ctx;
        while (currCtx != null) {
            if (currCtx.vars.has(varName)) {
                return currCtx.vars.get(varName);
            }
            currCtx = ((currCtx.parent));
        }
        throw new Error("Not declared variable " + varName);
    };
    /**
     * @param {?} expr
     * @param {?} ctx
     * @return {?}
     */
    StatementInterpreter.prototype.visitWriteKeyExpr = function (expr, ctx) {
        var /** @type {?} */ receiver = expr.receiver.visitExpression(this, ctx);
        var /** @type {?} */ index = expr.index.visitExpression(this, ctx);
        var /** @type {?} */ value = expr.value.visitExpression(this, ctx);
        receiver[index] = value;
        return value;
    };
    /**
     * @param {?} expr
     * @param {?} ctx
     * @return {?}
     */
    StatementInterpreter.prototype.visitWritePropExpr = function (expr, ctx) {
        var /** @type {?} */ receiver = expr.receiver.visitExpression(this, ctx);
        var /** @type {?} */ value = expr.value.visitExpression(this, ctx);
        receiver[expr.name] = value;
        return value;
    };
    /**
     * @param {?} expr
     * @param {?} ctx
     * @return {?}
     */
    StatementInterpreter.prototype.visitInvokeMethodExpr = function (expr, ctx) {
        var /** @type {?} */ receiver = expr.receiver.visitExpression(this, ctx);
        var /** @type {?} */ args = this.visitAllExpressions(expr.args, ctx);
        var /** @type {?} */ result;
        if (expr.builtin != null) {
            switch (expr.builtin) {
                case BuiltinMethod.ConcatArray:
                    result = receiver.concat.apply(receiver, args);
                    break;
                case BuiltinMethod.SubscribeObservable:
                    result = receiver.subscribe({ next: args[0] });
                    break;
                case BuiltinMethod.Bind:
                    result = receiver.bind.apply(receiver, args);
                    break;
                default:
                    throw new Error("Unknown builtin method " + expr.builtin);
            }
        }
        else {
            result = receiver[((expr.name))].apply(receiver, args);
        }
        return result;
    };
    /**
     * @param {?} stmt
     * @param {?} ctx
     * @return {?}
     */
    StatementInterpreter.prototype.visitInvokeFunctionExpr = function (stmt, ctx) {
        var /** @type {?} */ args = this.visitAllExpressions(stmt.args, ctx);
        var /** @type {?} */ fnExpr = stmt.fn;
        if (fnExpr instanceof ReadVarExpr && fnExpr.builtin === BuiltinVar.Super) {
            ctx.instance.constructor.prototype.constructor.apply(ctx.instance, args);
            return null;
        }
        else {
            var /** @type {?} */ fn$$1 = stmt.fn.visitExpression(this, ctx);
            return fn$$1.apply(null, args);
        }
    };
    /**
     * @param {?} stmt
     * @param {?} ctx
     * @return {?}
     */
    StatementInterpreter.prototype.visitReturnStmt = function (stmt, ctx) {
        return new ReturnValue(stmt.value.visitExpression(this, ctx));
    };
    /**
     * @param {?} stmt
     * @param {?} ctx
     * @return {?}
     */
    StatementInterpreter.prototype.visitDeclareClassStmt = function (stmt, ctx) {
        var /** @type {?} */ clazz = createDynamicClass(stmt, ctx, this);
        ctx.vars.set(stmt.name, clazz);
        return null;
    };
    /**
     * @param {?} stmt
     * @param {?} ctx
     * @return {?}
     */
    StatementInterpreter.prototype.visitExpressionStmt = function (stmt, ctx) {
        return stmt.expr.visitExpression(this, ctx);
    };
    /**
     * @param {?} stmt
     * @param {?} ctx
     * @return {?}
     */
    StatementInterpreter.prototype.visitIfStmt = function (stmt, ctx) {
        var /** @type {?} */ condition = stmt.condition.visitExpression(this, ctx);
        if (condition) {
            return this.visitAllStatements(stmt.trueCase, ctx);
        }
        else if (stmt.falseCase != null) {
            return this.visitAllStatements(stmt.falseCase, ctx);
        }
        return null;
    };
    /**
     * @param {?} stmt
     * @param {?} ctx
     * @return {?}
     */
    StatementInterpreter.prototype.visitTryCatchStmt = function (stmt, ctx) {
        try {
            return this.visitAllStatements(stmt.bodyStmts, ctx);
        }
        catch (e) {
            var /** @type {?} */ childCtx = ctx.createChildWihtLocalVars();
            childCtx.vars.set(CATCH_ERROR_VAR$2, e);
            childCtx.vars.set(CATCH_STACK_VAR$2, e.stack);
            return this.visitAllStatements(stmt.catchStmts, childCtx);
        }
    };
    /**
     * @param {?} stmt
     * @param {?} ctx
     * @return {?}
     */
    StatementInterpreter.prototype.visitThrowStmt = function (stmt, ctx) {
        throw stmt.error.visitExpression(this, ctx);
    };
    /**
     * @param {?} stmt
     * @param {?=} context
     * @return {?}
     */
    StatementInterpreter.prototype.visitCommentStmt = function (stmt, context) { return null; };
    /**
     * @param {?} ast
     * @param {?} ctx
     * @return {?}
     */
    StatementInterpreter.prototype.visitInstantiateExpr = function (ast, ctx) {
        var /** @type {?} */ args = this.visitAllExpressions(ast.args, ctx);
        var /** @type {?} */ clazz = ast.classExpr.visitExpression(this, ctx);
        return new (clazz.bind.apply(clazz, [void 0].concat(args)))();
    };
    /**
     * @param {?} ast
     * @param {?} ctx
     * @return {?}
     */
    StatementInterpreter.prototype.visitLiteralExpr = function (ast, ctx) { return ast.value; };
    /**
     * @param {?} ast
     * @param {?} ctx
     * @return {?}
     */
    StatementInterpreter.prototype.visitExternalExpr = function (ast, ctx) {
        return ast.value.reference;
    };
    /**
     * @param {?} ast
     * @param {?} ctx
     * @return {?}
     */
    StatementInterpreter.prototype.visitConditionalExpr = function (ast, ctx) {
        if (ast.condition.visitExpression(this, ctx)) {
            return ast.trueCase.visitExpression(this, ctx);
        }
        else if (ast.falseCase != null) {
            return ast.falseCase.visitExpression(this, ctx);
        }
        return null;
    };
    /**
     * @param {?} ast
     * @param {?} ctx
     * @return {?}
     */
    StatementInterpreter.prototype.visitNotExpr = function (ast, ctx) {
        return !ast.condition.visitExpression(this, ctx);
    };
    /**
     * @param {?} ast
     * @param {?} ctx
     * @return {?}
     */
    StatementInterpreter.prototype.visitCastExpr = function (ast, ctx) {
        return ast.value.visitExpression(this, ctx);
    };
    /**
     * @param {?} ast
     * @param {?} ctx
     * @return {?}
     */
    StatementInterpreter.prototype.visitFunctionExpr = function (ast, ctx) {
        var /** @type {?} */ paramNames = ast.params.map(function (param) { return param.name; });
        return _declareFn(paramNames, ast.statements, ctx, this);
    };
    /**
     * @param {?} stmt
     * @param {?} ctx
     * @return {?}
     */
    StatementInterpreter.prototype.visitDeclareFunctionStmt = function (stmt, ctx) {
        var /** @type {?} */ paramNames = stmt.params.map(function (param) { return param.name; });
        ctx.vars.set(stmt.name, _declareFn(paramNames, stmt.statements, ctx, this));
        return null;
    };
    /**
     * @param {?} ast
     * @param {?} ctx
     * @return {?}
     */
    StatementInterpreter.prototype.visitBinaryOperatorExpr = function (ast, ctx) {
        var _this = this;
        var /** @type {?} */ lhs = function () { return ast.lhs.visitExpression(_this, ctx); };
        var /** @type {?} */ rhs = function () { return ast.rhs.visitExpression(_this, ctx); };
        switch (ast.operator) {
            case BinaryOperator.Equals:
                return lhs() == rhs();
            case BinaryOperator.Identical:
                return lhs() === rhs();
            case BinaryOperator.NotEquals:
                return lhs() != rhs();
            case BinaryOperator.NotIdentical:
                return lhs() !== rhs();
            case BinaryOperator.And:
                return lhs() && rhs();
            case BinaryOperator.Or:
                return lhs() || rhs();
            case BinaryOperator.Plus:
                return lhs() + rhs();
            case BinaryOperator.Minus:
                return lhs() - rhs();
            case BinaryOperator.Divide:
                return lhs() / rhs();
            case BinaryOperator.Multiply:
                return lhs() * rhs();
            case BinaryOperator.Modulo:
                return lhs() % rhs();
            case BinaryOperator.Lower:
                return lhs() < rhs();
            case BinaryOperator.LowerEquals:
                return lhs() <= rhs();
            case BinaryOperator.Bigger:
                return lhs() > rhs();
            case BinaryOperator.BiggerEquals:
                return lhs() >= rhs();
            default:
                throw new Error("Unknown operator " + ast.operator);
        }
    };
    /**
     * @param {?} ast
     * @param {?} ctx
     * @return {?}
     */
    StatementInterpreter.prototype.visitReadPropExpr = function (ast, ctx) {
        var /** @type {?} */ result;
        var /** @type {?} */ receiver = ast.receiver.visitExpression(this, ctx);
        result = receiver[ast.name];
        return result;
    };
    /**
     * @param {?} ast
     * @param {?} ctx
     * @return {?}
     */
    StatementInterpreter.prototype.visitReadKeyExpr = function (ast, ctx) {
        var /** @type {?} */ receiver = ast.receiver.visitExpression(this, ctx);
        var /** @type {?} */ prop = ast.index.visitExpression(this, ctx);
        return receiver[prop];
    };
    /**
     * @param {?} ast
     * @param {?} ctx
     * @return {?}
     */
    StatementInterpreter.prototype.visitLiteralArrayExpr = function (ast, ctx) {
        return this.visitAllExpressions(ast.entries, ctx);
    };
    /**
     * @param {?} ast
     * @param {?} ctx
     * @return {?}
     */
    StatementInterpreter.prototype.visitLiteralMapExpr = function (ast, ctx) {
        var _this = this;
        var /** @type {?} */ result = {};
        ast.entries.forEach(function (entry) { return ((result))[entry.key] = entry.value.visitExpression(_this, ctx); });
        return result;
    };
    /**
     * @param {?} ast
     * @param {?} context
     * @return {?}
     */
    StatementInterpreter.prototype.visitCommaExpr = function (ast, context) {
        var /** @type {?} */ values = this.visitAllExpressions(ast.parts, context);
        return values[values.length - 1];
    };
    /**
     * @param {?} expressions
     * @param {?} ctx
     * @return {?}
     */
    StatementInterpreter.prototype.visitAllExpressions = function (expressions, ctx) {
        var _this = this;
        return expressions.map(function (expr) { return expr.visitExpression(_this, ctx); });
    };
    /**
     * @param {?} statements
     * @param {?} ctx
     * @return {?}
     */
    StatementInterpreter.prototype.visitAllStatements = function (statements, ctx) {
        for (var /** @type {?} */ i = 0; i < statements.length; i++) {
            var /** @type {?} */ stmt = statements[i];
            var /** @type {?} */ val = stmt.visitStatement(this, ctx);
            if (val instanceof ReturnValue) {
                return val;
            }
        }
        return null;
    };
    return StatementInterpreter;
}());
/**
 * @param {?} varNames
 * @param {?} statements
 * @param {?} ctx
 * @param {?} visitor
 * @return {?}
 */
function _declareFn(varNames, statements, ctx, visitor) {
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return _executeFunctionStatements(varNames, args, statements, ctx, visitor);
    };
}
var CATCH_ERROR_VAR$2 = 'error';
var CATCH_STACK_VAR$2 = 'stack';
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @abstract
 */
var AbstractJsEmitterVisitor = (function (_super) {
    __extends(AbstractJsEmitterVisitor, _super);
    function AbstractJsEmitterVisitor() {
        return _super.call(this, false) || this;
    }
    /**
     * @param {?} stmt
     * @param {?} ctx
     * @return {?}
     */
    AbstractJsEmitterVisitor.prototype.visitDeclareClassStmt = function (stmt, ctx) {
        var _this = this;
        ctx.pushClass(stmt);
        this._visitClassConstructor(stmt, ctx);
        if (stmt.parent != null) {
            ctx.print(stmt, stmt.name + ".prototype = Object.create(");
            stmt.parent.visitExpression(this, ctx);
            ctx.println(stmt, ".prototype);");
        }
        stmt.getters.forEach(function (getter) { return _this._visitClassGetter(stmt, getter, ctx); });
        stmt.methods.forEach(function (method) { return _this._visitClassMethod(stmt, method, ctx); });
        ctx.popClass();
        return null;
    };
    /**
     * @param {?} stmt
     * @param {?} ctx
     * @return {?}
     */
    AbstractJsEmitterVisitor.prototype._visitClassConstructor = function (stmt, ctx) {
        ctx.print(stmt, "function " + stmt.name + "(");
        if (stmt.constructorMethod != null) {
            this._visitParams(stmt.constructorMethod.params, ctx);
        }
        ctx.println(stmt, ") {");
        ctx.incIndent();
        if (stmt.constructorMethod != null) {
            if (stmt.constructorMethod.body.length > 0) {
                ctx.println(stmt, "var self = this;");
                this.visitAllStatements(stmt.constructorMethod.body, ctx);
            }
        }
        ctx.decIndent();
        ctx.println(stmt, "}");
    };
    /**
     * @param {?} stmt
     * @param {?} getter
     * @param {?} ctx
     * @return {?}
     */
    AbstractJsEmitterVisitor.prototype._visitClassGetter = function (stmt, getter, ctx) {
        ctx.println(stmt, "Object.defineProperty(" + stmt.name + ".prototype, '" + getter.name + "', { get: function() {");
        ctx.incIndent();
        if (getter.body.length > 0) {
            ctx.println(stmt, "var self = this;");
            this.visitAllStatements(getter.body, ctx);
        }
        ctx.decIndent();
        ctx.println(stmt, "}});");
    };
    /**
     * @param {?} stmt
     * @param {?} method
     * @param {?} ctx
     * @return {?}
     */
    AbstractJsEmitterVisitor.prototype._visitClassMethod = function (stmt, method, ctx) {
        ctx.print(stmt, stmt.name + ".prototype." + method.name + " = function(");
        this._visitParams(method.params, ctx);
        ctx.println(stmt, ") {");
        ctx.incIndent();
        if (method.body.length > 0) {
            ctx.println(stmt, "var self = this;");
            this.visitAllStatements(method.body, ctx);
        }
        ctx.decIndent();
        ctx.println(stmt, "};");
    };
    /**
     * @param {?} ast
     * @param {?} ctx
     * @return {?}
     */
    AbstractJsEmitterVisitor.prototype.visitReadVarExpr = function (ast, ctx) {
        if (ast.builtin === BuiltinVar.This) {
            ctx.print(ast, 'self');
        }
        else if (ast.builtin === BuiltinVar.Super) {
            throw new Error("'super' needs to be handled at a parent ast node, not at the variable level!");
        }
        else {
            _super.prototype.visitReadVarExpr.call(this, ast, ctx);
        }
        return null;
    };
    /**
     * @param {?} stmt
     * @param {?} ctx
     * @return {?}
     */
    AbstractJsEmitterVisitor.prototype.visitDeclareVarStmt = function (stmt, ctx) {
        ctx.print(stmt, "var " + stmt.name + " = ");
        stmt.value.visitExpression(this, ctx);
        ctx.println(stmt, ";");
        return null;
    };
    /**
     * @param {?} ast
     * @param {?} ctx
     * @return {?}
     */
    AbstractJsEmitterVisitor.prototype.visitCastExpr = function (ast, ctx) {
        ast.value.visitExpression(this, ctx);
        return null;
    };
    /**
     * @param {?} expr
     * @param {?} ctx
     * @return {?}
     */
    AbstractJsEmitterVisitor.prototype.visitInvokeFunctionExpr = function (expr, ctx) {
        var /** @type {?} */ fnExpr = expr.fn;
        if (fnExpr instanceof ReadVarExpr && fnExpr.builtin === BuiltinVar.Super) {
            ((((ctx.currentClass)).parent)).visitExpression(this, ctx);
            ctx.print(expr, ".call(this");
            if (expr.args.length > 0) {
                ctx.print(expr, ", ");
                this.visitAllExpressions(expr.args, ctx, ',');
            }
            ctx.print(expr, ")");
        }
        else {
            _super.prototype.visitInvokeFunctionExpr.call(this, expr, ctx);
        }
        return null;
    };
    /**
     * @param {?} ast
     * @param {?} ctx
     * @return {?}
     */
    AbstractJsEmitterVisitor.prototype.visitFunctionExpr = function (ast, ctx) {
        ctx.print(ast, "function(");
        this._visitParams(ast.params, ctx);
        ctx.println(ast, ") {");
        ctx.incIndent();
        this.visitAllStatements(ast.statements, ctx);
        ctx.decIndent();
        ctx.print(ast, "}");
        return null;
    };
    /**
     * @param {?} stmt
     * @param {?} ctx
     * @return {?}
     */
    AbstractJsEmitterVisitor.prototype.visitDeclareFunctionStmt = function (stmt, ctx) {
        ctx.print(stmt, "function " + stmt.name + "(");
        this._visitParams(stmt.params, ctx);
        ctx.println(stmt, ") {");
        ctx.incIndent();
        this.visitAllStatements(stmt.statements, ctx);
        ctx.decIndent();
        ctx.println(stmt, "}");
        return null;
    };
    /**
     * @param {?} stmt
     * @param {?} ctx
     * @return {?}
     */
    AbstractJsEmitterVisitor.prototype.visitTryCatchStmt = function (stmt, ctx) {
        ctx.println(stmt, "try {");
        ctx.incIndent();
        this.visitAllStatements(stmt.bodyStmts, ctx);
        ctx.decIndent();
        ctx.println(stmt, "} catch (" + CATCH_ERROR_VAR$1.name + ") {");
        ctx.incIndent();
        var /** @type {?} */ catchStmts = [/** @type {?} */ (CATCH_STACK_VAR$1.set(CATCH_ERROR_VAR$1.prop('stack')).toDeclStmt(null, [
                StmtModifier.Final
            ]))].concat(stmt.catchStmts);
        this.visitAllStatements(catchStmts, ctx);
        ctx.decIndent();
        ctx.println(stmt, "}");
        return null;
    };
    /**
     * @param {?} params
     * @param {?} ctx
     * @return {?}
     */
    AbstractJsEmitterVisitor.prototype._visitParams = function (params, ctx) {
        this.visitAllObjects(function (param) { return ctx.print(null, param.name); }, params, ctx, ',');
    };
    /**
     * @param {?} method
     * @return {?}
     */
    AbstractJsEmitterVisitor.prototype.getBuiltinMethodName = function (method) {
        var /** @type {?} */ name;
        switch (method) {
            case BuiltinMethod.ConcatArray:
                name = 'concat';
                break;
            case BuiltinMethod.SubscribeObservable:
                name = 'subscribe';
                break;
            case BuiltinMethod.Bind:
                name = 'bind';
                break;
            default:
                throw new Error("Unknown builtin method: " + method);
        }
        return name;
    };
    return AbstractJsEmitterVisitor;
}(AbstractEmitterVisitor));
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @param {?} sourceUrl
 * @param {?} ctx
 * @param {?} vars
 * @return {?}
 */
function evalExpression(sourceUrl$$1, ctx, vars) {
    var /** @type {?} */ fnBody = ctx.toSource() + "\n//# sourceURL=" + sourceUrl$$1;
    var /** @type {?} */ fnArgNames = [];
    var /** @type {?} */ fnArgValues = [];
    for (var /** @type {?} */ argName in vars) {
        fnArgNames.push(argName);
        fnArgValues.push(vars[argName]);
    }
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["isDevMode"])()) {
        // using `new Function(...)` generates a header, 1 line of no arguments, 2 lines otherwise
        // E.g. ```
        // function anonymous(a,b,c
        // /**/) { ... }```
        // We don't want to hard code this fact, so we auto detect it via an empty function first.
        var /** @type {?} */ emptyFn = new (Function.bind.apply(Function, [void 0].concat(fnArgNames.concat('return null;'))))().toString();
        var /** @type {?} */ headerLines = emptyFn.slice(0, emptyFn.indexOf('return null;')).split('\n').length - 1;
        fnBody += "\n" + ctx.toSourceMapGenerator(sourceUrl$$1, sourceUrl$$1, headerLines).toJsComment();
    }
    return new (Function.bind.apply(Function, [void 0].concat(fnArgNames.concat(fnBody))))().apply(void 0, fnArgValues);
}
/**
 * @param {?} sourceUrl
 * @param {?} statements
 * @param {?} resultVars
 * @return {?}
 */
function jitStatements(sourceUrl$$1, statements, resultVars) {
    var /** @type {?} */ converter = new JitEmitterVisitor();
    var /** @type {?} */ ctx = EmitterVisitorContext.createRoot(resultVars);
    var /** @type {?} */ returnStmt = new ReturnStatement(literalArr(resultVars.map(function (resultVar) { return variable(resultVar); })));
    converter.visitAllStatements(statements.concat([returnStmt]), ctx);
    return evalExpression(sourceUrl$$1, ctx, converter.getArgs());
}
var JitEmitterVisitor = (function (_super) {
    __extends(JitEmitterVisitor, _super);
    function JitEmitterVisitor() {
        var _this = _super.apply(this, arguments) || this;
        _this._evalArgNames = [];
        _this._evalArgValues = [];
        return _this;
    }
    /**
     * @return {?}
     */
    JitEmitterVisitor.prototype.getArgs = function () {
        var /** @type {?} */ result = {};
        for (var /** @type {?} */ i = 0; i < this._evalArgNames.length; i++) {
            result[this._evalArgNames[i]] = this._evalArgValues[i];
        }
        return result;
    };
    /**
     * @param {?} ast
     * @param {?} ctx
     * @return {?}
     */
    JitEmitterVisitor.prototype.visitExternalExpr = function (ast, ctx) {
        var /** @type {?} */ value = ast.value.reference;
        var /** @type {?} */ id = this._evalArgValues.indexOf(value);
        if (id === -1) {
            id = this._evalArgValues.length;
            this._evalArgValues.push(value);
            var /** @type {?} */ name = identifierName(ast.value) || 'val';
            this._evalArgNames.push("jit_" + name + id);
        }
        ctx.print(ast, this._evalArgNames[id]);
        return null;
    };
    return JitEmitterVisitor;
}(AbstractJsEmitterVisitor));
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * An internal module of the Angular compiler that begins with component types,
 * extracts templates, and eventually produces a compiled version of the component
 * ready for linking into an application.
 *
 * \@security When compiling templates at runtime, you must ensure that the entire template comes
 * from a trusted source. Attacker-controlled data introduced by a template could expose your
 * application to XSS risks.  For more detail, see the [Security Guide](http://g.co/ng/security).
 */
var JitCompiler = (function () {
    /**
     * @param {?} _injector
     * @param {?} _metadataResolver
     * @param {?} _templateParser
     * @param {?} _styleCompiler
     * @param {?} _viewCompiler
     * @param {?} _ngModuleCompiler
     * @param {?} _compilerConfig
     * @param {?} _console
     */
    function JitCompiler(_injector, _metadataResolver, _templateParser, _styleCompiler, _viewCompiler, _ngModuleCompiler, _compilerConfig, _console) {
        this._injector = _injector;
        this._metadataResolver = _metadataResolver;
        this._templateParser = _templateParser;
        this._styleCompiler = _styleCompiler;
        this._viewCompiler = _viewCompiler;
        this._ngModuleCompiler = _ngModuleCompiler;
        this._compilerConfig = _compilerConfig;
        this._console = _console;
        this._compiledTemplateCache = new Map();
        this._compiledHostTemplateCache = new Map();
        this._compiledDirectiveWrapperCache = new Map();
        this._compiledNgModuleCache = new Map();
        this._sharedStylesheetCount = 0;
    }
    Object.defineProperty(JitCompiler.prototype, "injector", {
        /**
         * @return {?}
         */
        get: function () { return this._injector; },
        enumerable: true,
        configurable: true
    });
    /**
     * @template T
     * @param {?} moduleType
     * @return {?}
     */
    JitCompiler.prototype.compileModuleSync = function (moduleType) {
        return ((this._compileModuleAndComponents(moduleType, true).syncResult));
    };
    /**
     * @template T
     * @param {?} moduleType
     * @return {?}
     */
    JitCompiler.prototype.compileModuleAsync = function (moduleType) {
        return ((this._compileModuleAndComponents(moduleType, false).asyncResult));
    };
    /**
     * @template T
     * @param {?} moduleType
     * @return {?}
     */
    JitCompiler.prototype.compileModuleAndAllComponentsSync = function (moduleType) {
        return ((this._compileModuleAndAllComponents(moduleType, true).syncResult));
    };
    /**
     * @template T
     * @param {?} moduleType
     * @return {?}
     */
    JitCompiler.prototype.compileModuleAndAllComponentsAsync = function (moduleType) {
        return ((this._compileModuleAndAllComponents(moduleType, false).asyncResult));
    };
    /**
     * @param {?} component
     * @return {?}
     */
    JitCompiler.prototype.getNgContentSelectors = function (component) {
        this._console.warn('Compiler.getNgContentSelectors is deprecated. Use ComponentFactory.ngContentSelectors instead!');
        var /** @type {?} */ template = this._compiledTemplateCache.get(component);
        if (!template) {
            throw new Error("The component " + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵstringify"])(component) + " is not yet compiled!");
        }
        return ((template.compMeta.template)).ngContentSelectors;
    };
    /**
     * @template T
     * @param {?} moduleType
     * @param {?} isSync
     * @return {?}
     */
    JitCompiler.prototype._compileModuleAndComponents = function (moduleType, isSync) {
        var _this = this;
        var /** @type {?} */ loadingPromise = this._loadModules(moduleType, isSync);
        var /** @type {?} */ createResult = function () {
            _this._compileComponents(moduleType, null);
            return _this._compileModule(moduleType);
        };
        if (isSync) {
            return new SyncAsyncResult(createResult());
        }
        else {
            return new SyncAsyncResult(null, loadingPromise.then(createResult));
        }
    };
    /**
     * @template T
     * @param {?} moduleType
     * @param {?} isSync
     * @return {?}
     */
    JitCompiler.prototype._compileModuleAndAllComponents = function (moduleType, isSync) {
        var _this = this;
        var /** @type {?} */ loadingPromise = this._loadModules(moduleType, isSync);
        var /** @type {?} */ createResult = function () {
            var /** @type {?} */ componentFactories = [];
            _this._compileComponents(moduleType, componentFactories);
            return new __WEBPACK_IMPORTED_MODULE_0__angular_core__["ModuleWithComponentFactories"](_this._compileModule(moduleType), componentFactories);
        };
        if (isSync) {
            return new SyncAsyncResult(createResult());
        }
        else {
            return new SyncAsyncResult(null, loadingPromise.then(createResult));
        }
    };
    /**
     * @param {?} mainModule
     * @param {?} isSync
     * @return {?}
     */
    JitCompiler.prototype._loadModules = function (mainModule, isSync) {
        var _this = this;
        var /** @type {?} */ loadingPromises = [];
        var /** @type {?} */ ngModule = ((this._metadataResolver.getNgModuleMetadata(mainModule)));
        // Note: the loadingPromise for a module only includes the loading of the exported directives
        // of imported modules.
        // However, for runtime compilation, we want to transitively compile all modules,
        // so we also need to call loadNgModuleDirectiveAndPipeMetadata for all nested modules.
        ngModule.transitiveModule.modules.forEach(function (localModuleMeta) {
            loadingPromises.push(_this._metadataResolver.loadNgModuleDirectiveAndPipeMetadata(localModuleMeta.reference, isSync));
        });
        return Promise.all(loadingPromises);
    };
    /**
     * @template T
     * @param {?} moduleType
     * @return {?}
     */
    JitCompiler.prototype._compileModule = function (moduleType) {
        var _this = this;
        var /** @type {?} */ ngModuleFactory = ((this._compiledNgModuleCache.get(moduleType)));
        if (!ngModuleFactory) {
            var /** @type {?} */ moduleMeta_1 = ((this._metadataResolver.getNgModuleMetadata(moduleType)));
            // Always provide a bound Compiler
            var /** @type {?} */ extraProviders = [this._metadataResolver.getProviderMetadata(new ProviderMeta(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Compiler"], { useFactory: function () { return new ModuleBoundCompiler(_this, moduleMeta_1.type.reference); } }))];
            var /** @type {?} */ compileResult = this._ngModuleCompiler.compile(moduleMeta_1, extraProviders);
            if (!this._compilerConfig.useJit) {
                ngModuleFactory =
                    interpretStatements(compileResult.statements, [compileResult.ngModuleFactoryVar])[0];
            }
            else {
                ngModuleFactory = jitStatements(ngModuleJitUrl(moduleMeta_1), compileResult.statements, [compileResult.ngModuleFactoryVar])[0];
            }
            this._compiledNgModuleCache.set(moduleMeta_1.type.reference, ngModuleFactory);
        }
        return ngModuleFactory;
    };
    /**
     * \@internal
     * @param {?} mainModule
     * @param {?} allComponentFactories
     * @return {?}
     */
    JitCompiler.prototype._compileComponents = function (mainModule, allComponentFactories) {
        var _this = this;
        var /** @type {?} */ ngModule = ((this._metadataResolver.getNgModuleMetadata(mainModule)));
        var /** @type {?} */ moduleByDirective = new Map();
        var /** @type {?} */ templates = new Set();
        ngModule.transitiveModule.modules.forEach(function (localModuleSummary) {
            var /** @type {?} */ localModuleMeta = ((_this._metadataResolver.getNgModuleMetadata(localModuleSummary.reference)));
            localModuleMeta.declaredDirectives.forEach(function (dirIdentifier) {
                moduleByDirective.set(dirIdentifier.reference, localModuleMeta);
                var /** @type {?} */ dirMeta = _this._metadataResolver.getDirectiveMetadata(dirIdentifier.reference);
                if (dirMeta.isComponent) {
                    templates.add(_this._createCompiledTemplate(dirMeta, localModuleMeta));
                    if (allComponentFactories) {
                        var /** @type {?} */ template = _this._createCompiledHostTemplate(dirMeta.type.reference, localModuleMeta);
                        templates.add(template);
                        allComponentFactories.push(/** @type {?} */ (dirMeta.componentFactory));
                    }
                }
            });
        });
        ngModule.transitiveModule.modules.forEach(function (localModuleSummary) {
            var /** @type {?} */ localModuleMeta = ((_this._metadataResolver.getNgModuleMetadata(localModuleSummary.reference)));
            localModuleMeta.declaredDirectives.forEach(function (dirIdentifier) {
                var /** @type {?} */ dirMeta = _this._metadataResolver.getDirectiveMetadata(dirIdentifier.reference);
                if (dirMeta.isComponent) {
                    dirMeta.entryComponents.forEach(function (entryComponentType) {
                        var /** @type {?} */ moduleMeta = ((moduleByDirective.get(entryComponentType.componentType)));
                        templates.add(_this._createCompiledHostTemplate(entryComponentType.componentType, moduleMeta));
                    });
                }
            });
            localModuleMeta.entryComponents.forEach(function (entryComponentType) {
                var /** @type {?} */ moduleMeta = ((moduleByDirective.get(entryComponentType.componentType)));
                templates.add(_this._createCompiledHostTemplate(entryComponentType.componentType, moduleMeta));
            });
        });
        templates.forEach(function (template) { return _this._compileTemplate(template); });
    };
    /**
     * @param {?} type
     * @return {?}
     */
    JitCompiler.prototype.clearCacheFor = function (type) {
        this._compiledNgModuleCache.delete(type);
        this._metadataResolver.clearCacheFor(type);
        this._compiledHostTemplateCache.delete(type);
        var /** @type {?} */ compiledTemplate = this._compiledTemplateCache.get(type);
        if (compiledTemplate) {
            this._compiledTemplateCache.delete(type);
        }
    };
    /**
     * @return {?}
     */
    JitCompiler.prototype.clearCache = function () {
        this._metadataResolver.clearCache();
        this._compiledTemplateCache.clear();
        this._compiledHostTemplateCache.clear();
        this._compiledNgModuleCache.clear();
    };
    /**
     * @param {?} compType
     * @param {?} ngModule
     * @return {?}
     */
    JitCompiler.prototype._createCompiledHostTemplate = function (compType, ngModule) {
        if (!ngModule) {
            throw new Error("Component " + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵstringify"])(compType) + " is not part of any NgModule or the module has not been imported into your module.");
        }
        var /** @type {?} */ compiledTemplate = this._compiledHostTemplateCache.get(compType);
        if (!compiledTemplate) {
            var /** @type {?} */ compMeta = this._metadataResolver.getDirectiveMetadata(compType);
            assertComponent(compMeta);
            var /** @type {?} */ componentFactory = (compMeta.componentFactory);
            var /** @type {?} */ hostClass = this._metadataResolver.getHostComponentType(compType);
            var /** @type {?} */ hostMeta = createHostComponentMeta(hostClass, compMeta, /** @type {?} */ (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵgetComponentViewDefinitionFactory"])(componentFactory)));
            compiledTemplate =
                new CompiledTemplate(true, compMeta.type, hostMeta, ngModule, [compMeta.type]);
            this._compiledHostTemplateCache.set(compType, compiledTemplate);
        }
        return compiledTemplate;
    };
    /**
     * @param {?} compMeta
     * @param {?} ngModule
     * @return {?}
     */
    JitCompiler.prototype._createCompiledTemplate = function (compMeta, ngModule) {
        var /** @type {?} */ compiledTemplate = this._compiledTemplateCache.get(compMeta.type.reference);
        if (!compiledTemplate) {
            assertComponent(compMeta);
            compiledTemplate = new CompiledTemplate(false, compMeta.type, compMeta, ngModule, ngModule.transitiveModule.directives);
            this._compiledTemplateCache.set(compMeta.type.reference, compiledTemplate);
        }
        return compiledTemplate;
    };
    /**
     * @param {?} template
     * @return {?}
     */
    JitCompiler.prototype._compileTemplate = function (template) {
        var _this = this;
        if (template.isCompiled) {
            return;
        }
        var /** @type {?} */ compMeta = template.compMeta;
        var /** @type {?} */ externalStylesheetsByModuleUrl = new Map();
        var /** @type {?} */ stylesCompileResult = this._styleCompiler.compileComponent(compMeta);
        stylesCompileResult.externalStylesheets.forEach(function (r) { externalStylesheetsByModuleUrl.set(/** @type {?} */ ((r.meta.moduleUrl)), r); });
        this._resolveStylesCompileResult(stylesCompileResult.componentStylesheet, externalStylesheetsByModuleUrl);
        var /** @type {?} */ directives = template.directives.map(function (dir) { return _this._metadataResolver.getDirectiveSummary(dir.reference); });
        var /** @type {?} */ pipes = template.ngModule.transitiveModule.pipes.map(function (pipe) { return _this._metadataResolver.getPipeSummary(pipe.reference); });
        var _a = this._templateParser.parse(compMeta, /** @type {?} */ ((((compMeta.template)).template)), directives, pipes, template.ngModule.schemas, templateSourceUrl(template.ngModule.type, template.compMeta, /** @type {?} */ ((template.compMeta.template)))), parsedTemplate = _a.template, usedPipes = _a.pipes;
        var /** @type {?} */ compileResult = this._viewCompiler.compileComponent(compMeta, parsedTemplate, variable(stylesCompileResult.componentStylesheet.stylesVar), usedPipes);
        var /** @type {?} */ statements = stylesCompileResult.componentStylesheet.statements.concat(compileResult.statements);
        var /** @type {?} */ viewClassAndRendererTypeVars = compMeta.isHost ?
            [compileResult.viewClassVar] :
            [compileResult.viewClassVar, compileResult.rendererTypeVar];
        var /** @type {?} */ viewClass;
        var /** @type {?} */ rendererType;
        if (!this._compilerConfig.useJit) {
            _b = interpretStatements(statements, viewClassAndRendererTypeVars), viewClass = _b[0], rendererType = _b[1];
        }
        else {
            _c = jitStatements(templateJitUrl(template.ngModule.type, template.compMeta), statements, viewClassAndRendererTypeVars), viewClass = _c[0], rendererType = _c[1];
        }
        template.compiled(viewClass, rendererType);
        var _b, _c;
    };
    /**
     * @param {?} result
     * @param {?} externalStylesheetsByModuleUrl
     * @return {?}
     */
    JitCompiler.prototype._resolveStylesCompileResult = function (result, externalStylesheetsByModuleUrl) {
        var _this = this;
        result.dependencies.forEach(function (dep, i) {
            var /** @type {?} */ nestedCompileResult = ((externalStylesheetsByModuleUrl.get(dep.moduleUrl)));
            var /** @type {?} */ nestedStylesArr = _this._resolveAndEvalStylesCompileResult(nestedCompileResult, externalStylesheetsByModuleUrl);
            dep.valuePlaceholder.reference = nestedStylesArr;
        });
    };
    /**
     * @param {?} result
     * @param {?} externalStylesheetsByModuleUrl
     * @return {?}
     */
    JitCompiler.prototype._resolveAndEvalStylesCompileResult = function (result, externalStylesheetsByModuleUrl) {
        this._resolveStylesCompileResult(result, externalStylesheetsByModuleUrl);
        if (!this._compilerConfig.useJit) {
            return interpretStatements(result.statements, [result.stylesVar])[0];
        }
        else {
            return jitStatements(sharedStylesheetJitUrl(result.meta, this._sharedStylesheetCount++), result.statements, [result.stylesVar])[0];
        }
    };
    return JitCompiler;
}());
JitCompiler.decorators = [
    { type: CompilerInjectable },
];
/**
 * @nocollapse
 */
JitCompiler.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injector"], },
    { type: CompileMetadataResolver, },
    { type: TemplateParser, },
    { type: StyleCompiler, },
    { type: ViewCompiler, },
    { type: NgModuleCompiler, },
    { type: CompilerConfig, },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵConsole"], },
]; };
var CompiledTemplate = (function () {
    /**
     * @param {?} isHost
     * @param {?} compType
     * @param {?} compMeta
     * @param {?} ngModule
     * @param {?} directives
     */
    function CompiledTemplate(isHost, compType, compMeta, ngModule, directives) {
        this.isHost = isHost;
        this.compType = compType;
        this.compMeta = compMeta;
        this.ngModule = ngModule;
        this.directives = directives;
        this._viewClass = ((null));
        this.isCompiled = false;
    }
    /**
     * @param {?} viewClass
     * @param {?} rendererType
     * @return {?}
     */
    CompiledTemplate.prototype.compiled = function (viewClass, rendererType) {
        this._viewClass = viewClass;
        ((this.compMeta.componentViewType)).setDelegate(viewClass);
        for (var /** @type {?} */ prop in rendererType) {
            ((this.compMeta.rendererType))[prop] = rendererType[prop];
        }
        this.isCompiled = true;
    };
    return CompiledTemplate;
}());
/**
 * @param {?} meta
 * @return {?}
 */
function assertComponent(meta) {
    if (!meta.isComponent) {
        throw new Error("Could not compile '" + identifierName(meta.type) + "' because it is not a component.");
    }
}
/**
 * Implements `Compiler` by delegating to the JitCompiler using a known module.
 */
var ModuleBoundCompiler = (function () {
    /**
     * @param {?} _delegate
     * @param {?} _ngModule
     */
    function ModuleBoundCompiler(_delegate, _ngModule) {
        this._delegate = _delegate;
        this._ngModule = _ngModule;
    }
    Object.defineProperty(ModuleBoundCompiler.prototype, "_injector", {
        /**
         * @return {?}
         */
        get: function () { return this._delegate.injector; },
        enumerable: true,
        configurable: true
    });
    /**
     * @template T
     * @param {?} moduleType
     * @return {?}
     */
    ModuleBoundCompiler.prototype.compileModuleSync = function (moduleType) {
        return this._delegate.compileModuleSync(moduleType);
    };
    /**
     * @template T
     * @param {?} moduleType
     * @return {?}
     */
    ModuleBoundCompiler.prototype.compileModuleAsync = function (moduleType) {
        return this._delegate.compileModuleAsync(moduleType);
    };
    /**
     * @template T
     * @param {?} moduleType
     * @return {?}
     */
    ModuleBoundCompiler.prototype.compileModuleAndAllComponentsSync = function (moduleType) {
        return this._delegate.compileModuleAndAllComponentsSync(moduleType);
    };
    /**
     * @template T
     * @param {?} moduleType
     * @return {?}
     */
    ModuleBoundCompiler.prototype.compileModuleAndAllComponentsAsync = function (moduleType) {
        return this._delegate.compileModuleAndAllComponentsAsync(moduleType);
    };
    /**
     * @param {?} component
     * @return {?}
     */
    ModuleBoundCompiler.prototype.getNgContentSelectors = function (component) {
        return this._delegate.getNgContentSelectors(component);
    };
    /**
     * Clears all caches
     * @return {?}
     */
    ModuleBoundCompiler.prototype.clearCache = function () { this._delegate.clearCache(); };
    /**
     * Clears the cache for the given component/ngModule.
     * @param {?} type
     * @return {?}
     */
    ModuleBoundCompiler.prototype.clearCacheFor = function (type) { this._delegate.clearCacheFor(type); };
    return ModuleBoundCompiler;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * A container for message extracted from the templates.
 */
var MessageBundle = (function () {
    /**
     * @param {?} _htmlParser
     * @param {?} _implicitTags
     * @param {?} _implicitAttrs
     * @param {?=} _locale
     */
    function MessageBundle(_htmlParser, _implicitTags, _implicitAttrs, _locale) {
        if (_locale === void 0) { _locale = null; }
        this._htmlParser = _htmlParser;
        this._implicitTags = _implicitTags;
        this._implicitAttrs = _implicitAttrs;
        this._locale = _locale;
        this._messages = [];
    }
    /**
     * @param {?} html
     * @param {?} url
     * @param {?} interpolationConfig
     * @return {?}
     */
    MessageBundle.prototype.updateFromTemplate = function (html, url, interpolationConfig) {
        var /** @type {?} */ htmlParserResult = this._htmlParser.parse(html, url, true, interpolationConfig);
        if (htmlParserResult.errors.length) {
            return htmlParserResult.errors;
        }
        var /** @type {?} */ i18nParserResult = extractMessages(htmlParserResult.rootNodes, interpolationConfig, this._implicitTags, this._implicitAttrs);
        if (i18nParserResult.errors.length) {
            return i18nParserResult.errors;
        }
        (_a = this._messages).push.apply(_a, i18nParserResult.messages);
        return null;
        var _a;
    };
    /**
     * @return {?}
     */
    MessageBundle.prototype.getMessages = function () { return this._messages; };
    /**
     * @param {?} serializer
     * @param {?=} filterSources
     * @return {?}
     */
    MessageBundle.prototype.write = function (serializer, filterSources) {
        var /** @type {?} */ messages = {};
        var /** @type {?} */ mapperVisitor = new MapPlaceholderNames();
        // Deduplicate messages based on their ID
        this._messages.forEach(function (message) {
            var /** @type {?} */ id = serializer.digest(message);
            if (!messages.hasOwnProperty(id)) {
                messages[id] = message;
            }
            else {
                (_a = messages[id].sources).push.apply(_a, message.sources);
            }
            var _a;
        });
        // Transform placeholder names using the serializer mapping
        var /** @type {?} */ msgList = Object.keys(messages).map(function (id) {
            var /** @type {?} */ mapper = serializer.createNameMapper(messages[id]);
            var /** @type {?} */ src = messages[id];
            var /** @type {?} */ nodes = mapper ? mapperVisitor.convert(src.nodes, mapper) : src.nodes;
            var /** @type {?} */ transformedMessage = new Message(nodes, {}, {}, src.meaning, src.description, id);
            transformedMessage.sources = src.sources;
            if (filterSources) {
                transformedMessage.sources.forEach(function (source) { return source.filePath = filterSources(source.filePath); });
            }
            return transformedMessage;
        });
        return serializer.write(msgList, this._locale);
    };
    return MessageBundle;
}());
var MapPlaceholderNames = (function (_super) {
    __extends(MapPlaceholderNames, _super);
    function MapPlaceholderNames() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @param {?} nodes
     * @param {?} mapper
     * @return {?}
     */
    MapPlaceholderNames.prototype.convert = function (nodes, mapper) {
        var _this = this;
        return mapper ? nodes.map(function (n) { return n.visit(_this, mapper); }) : nodes;
    };
    /**
     * @param {?} ph
     * @param {?} mapper
     * @return {?}
     */
    MapPlaceholderNames.prototype.visitTagPlaceholder = function (ph, mapper) {
        var _this = this;
        var /** @type {?} */ startName = ((mapper.toPublicName(ph.startName)));
        var /** @type {?} */ closeName = ph.closeName ? ((mapper.toPublicName(ph.closeName))) : ph.closeName;
        var /** @type {?} */ children = ph.children.map(function (n) { return n.visit(_this, mapper); });
        return new TagPlaceholder(ph.tag, ph.attrs, startName, closeName, children, ph.isVoid, ph.sourceSpan);
    };
    /**
     * @param {?} ph
     * @param {?} mapper
     * @return {?}
     */
    MapPlaceholderNames.prototype.visitPlaceholder = function (ph, mapper) {
        return new Placeholder(ph.value, /** @type {?} */ ((mapper.toPublicName(ph.name))), ph.sourceSpan);
    };
    /**
     * @param {?} ph
     * @param {?} mapper
     * @return {?}
     */
    MapPlaceholderNames.prototype.visitIcuPlaceholder = function (ph, mapper) {
        return new IcuPlaceholder(ph.value, /** @type {?} */ ((mapper.toPublicName(ph.name))), ph.sourceSpan);
    };
    return MapPlaceholderNames;
}(CloneVisitor));
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Extract i18n messages from source code
 */
var Extractor = (function () {
    /**
     * @param {?} host
     * @param {?} staticSymbolResolver
     * @param {?} messageBundle
     * @param {?} metadataResolver
     */
    function Extractor(host, staticSymbolResolver, messageBundle, metadataResolver) {
        this.host = host;
        this.staticSymbolResolver = staticSymbolResolver;
        this.messageBundle = messageBundle;
        this.metadataResolver = metadataResolver;
    }
    /**
     * @param {?} rootFiles
     * @return {?}
     */
    Extractor.prototype.extract = function (rootFiles) {
        var _this = this;
        var /** @type {?} */ programSymbols = extractProgramSymbols(this.staticSymbolResolver, rootFiles, this.host);
        var _a = analyzeAndValidateNgModules(programSymbols, this.host, this.metadataResolver), files = _a.files, ngModules = _a.ngModules;
        return Promise
            .all(ngModules.map(function (ngModule) { return _this.metadataResolver.loadNgModuleDirectiveAndPipeMetadata(ngModule.type.reference, false); }))
            .then(function () {
            var /** @type {?} */ errors = [];
            files.forEach(function (file) {
                var /** @type {?} */ compMetas = [];
                file.directives.forEach(function (directiveType) {
                    var /** @type {?} */ dirMeta = _this.metadataResolver.getDirectiveMetadata(directiveType);
                    if (dirMeta && dirMeta.isComponent) {
                        compMetas.push(dirMeta);
                    }
                });
                compMetas.forEach(function (compMeta) {
                    var /** @type {?} */ html = ((((compMeta.template)).template));
                    var /** @type {?} */ interpolationConfig = InterpolationConfig.fromArray(/** @type {?} */ ((compMeta.template)).interpolation);
                    errors.push.apply(errors, ((_this.messageBundle.updateFromTemplate(html, file.srcUrl, interpolationConfig))));
                });
            });
            if (errors.length) {
                throw new Error(errors.map(function (e) { return e.toString(); }).join('\n'));
            }
            return _this.messageBundle;
        });
    };
    /**
     * @param {?} host
     * @param {?} locale
     * @return {?}
     */
    Extractor.create = function (host, locale) {
        var /** @type {?} */ htmlParser = new I18NHtmlParser(new HtmlParser());
        var /** @type {?} */ urlResolver = createOfflineCompileUrlResolver();
        var /** @type {?} */ symbolCache = new StaticSymbolCache();
        var /** @type {?} */ summaryResolver = new AotSummaryResolver(host, symbolCache);
        var /** @type {?} */ staticSymbolResolver = new StaticSymbolResolver(host, symbolCache, summaryResolver);
        var /** @type {?} */ staticReflector = new StaticReflector(summaryResolver, staticSymbolResolver);
        StaticAndDynamicReflectionCapabilities.install(staticReflector);
        var /** @type {?} */ config = new CompilerConfig({ defaultEncapsulation: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewEncapsulation"].Emulated, useJit: false });
        var /** @type {?} */ normalizer = new DirectiveNormalizer({ get: function (url) { return host.loadResource(url); } }, urlResolver, htmlParser, config);
        var /** @type {?} */ elementSchemaRegistry = new DomElementSchemaRegistry();
        var /** @type {?} */ resolver = new CompileMetadataResolver(config, new NgModuleResolver(staticReflector), new DirectiveResolver(staticReflector), new PipeResolver(staticReflector), summaryResolver, elementSchemaRegistry, normalizer, new __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵConsole"](), symbolCache, staticReflector);
        // TODO(vicb): implicit tags & attributes
        var /** @type {?} */ messageBundle = new MessageBundle(htmlParser, [], {}, locale);
        var /** @type {?} */ extractor = new Extractor(host, staticSymbolResolver, messageBundle, resolver);
        return { extractor: extractor, staticReflector: staticReflector };
    };
    return Extractor;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var _NO_RESOURCE_LOADER = {
    /**
     * @param {?} url
     * @return {?}
     */
    get: function (url) {
        throw new Error("No ResourceLoader implementation has been provided. Can't read the url \"" + url + "\"");
    }
};
var baseHtmlParser = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["InjectionToken"]('HtmlParser');
/**
 * @param {?} parser
 * @param {?} translations
 * @param {?} format
 * @param {?} config
 * @param {?} console
 * @return {?}
 */
function i18nHtmlParserFactory(parser, translations, format, config, console) {
    return new I18NHtmlParser(parser, translations, format, /** @type {?} */ ((config.missingTranslation)), console);
}
/**
 * A set of providers that provide `JitCompiler` and its dependencies to use for
 * template compilation.
 */
var COMPILER_PROVIDERS = [
    { provide: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵReflector"], useValue: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵreflector"] },
    { provide: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵReflectorReader"], useExisting: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵReflector"] },
    { provide: ResourceLoader, useValue: _NO_RESOURCE_LOADER },
    SummaryResolver,
    __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵConsole"],
    Lexer,
    Parser,
    {
        provide: baseHtmlParser,
        useClass: HtmlParser,
    },
    {
        provide: I18NHtmlParser,
        useFactory: i18nHtmlParserFactory,
        deps: [
            baseHtmlParser,
            [new __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"](), new __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"](__WEBPACK_IMPORTED_MODULE_0__angular_core__["TRANSLATIONS"])],
            [new __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"](), new __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"](__WEBPACK_IMPORTED_MODULE_0__angular_core__["TRANSLATIONS_FORMAT"])],
            [CompilerConfig],
            [__WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵConsole"]],
        ]
    },
    {
        provide: HtmlParser,
        useExisting: I18NHtmlParser,
    },
    TemplateParser,
    DirectiveNormalizer,
    CompileMetadataResolver,
    DEFAULT_PACKAGE_URL_PROVIDER,
    StyleCompiler,
    ViewCompiler,
    NgModuleCompiler,
    { provide: CompilerConfig, useValue: new CompilerConfig() },
    JitCompiler,
    { provide: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Compiler"], useExisting: JitCompiler },
    DomElementSchemaRegistry,
    { provide: ElementSchemaRegistry, useExisting: DomElementSchemaRegistry },
    UrlResolver,
    DirectiveResolver,
    PipeResolver,
    NgModuleResolver,
];
var JitCompilerFactory = (function () {
    /**
     * @param {?} defaultOptions
     */
    function JitCompilerFactory(defaultOptions) {
        var compilerOptions = {
            useDebug: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["isDevMode"])(),
            useJit: true,
            defaultEncapsulation: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewEncapsulation"].Emulated,
            missingTranslation: __WEBPACK_IMPORTED_MODULE_0__angular_core__["MissingTranslationStrategy"].Warning,
            enableLegacyTemplate: true,
        };
        this._defaultOptions = [compilerOptions].concat(defaultOptions);
    }
    /**
     * @param {?=} options
     * @return {?}
     */
    JitCompilerFactory.prototype.createCompiler = function (options) {
        if (options === void 0) { options = []; }
        var /** @type {?} */ opts = _mergeOptions(this._defaultOptions.concat(options));
        var /** @type {?} */ injector = __WEBPACK_IMPORTED_MODULE_0__angular_core__["ReflectiveInjector"].resolveAndCreate([
            COMPILER_PROVIDERS, {
                provide: CompilerConfig,
                useFactory: function () {
                    return new CompilerConfig({
                        // let explicit values from the compiler options overwrite options
                        // from the app providers
                        useJit: opts.useJit,
                        // let explicit values from the compiler options overwrite options
                        // from the app providers
                        defaultEncapsulation: opts.defaultEncapsulation,
                        missingTranslation: opts.missingTranslation,
                        enableLegacyTemplate: opts.enableLegacyTemplate,
                    });
                },
                deps: []
            }, /** @type {?} */ ((opts.providers))
        ]);
        return injector.get(__WEBPACK_IMPORTED_MODULE_0__angular_core__["Compiler"]);
    };
    return JitCompilerFactory;
}());
JitCompilerFactory.decorators = [
    { type: CompilerInjectable },
];
/**
 * @nocollapse
 */
JitCompilerFactory.ctorParameters = function () { return [
    { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_0__angular_core__["COMPILER_OPTIONS"],] },] },
]; };
/**
 * @return {?}
 */
function _initReflector() {
    __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵreflector"].reflectionCapabilities = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["ɵReflectionCapabilities"]();
}
/**
 * A platform that included corePlatform and the compiler.
 *
 * \@experimental
 */
var platformCoreDynamic = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["createPlatformFactory"])(__WEBPACK_IMPORTED_MODULE_0__angular_core__["platformCore"], 'coreDynamic', [
    { provide: __WEBPACK_IMPORTED_MODULE_0__angular_core__["COMPILER_OPTIONS"], useValue: {}, multi: true },
    { provide: __WEBPACK_IMPORTED_MODULE_0__angular_core__["CompilerFactory"], useClass: JitCompilerFactory },
    { provide: __WEBPACK_IMPORTED_MODULE_0__angular_core__["PLATFORM_INITIALIZER"], useValue: _initReflector, multi: true },
]);
/**
 * @param {?} optionsArr
 * @return {?}
 */
function _mergeOptions(optionsArr) {
    return {
        useJit: _lastDefined(optionsArr.map(function (options) { return options.useJit; })),
        defaultEncapsulation: _lastDefined(optionsArr.map(function (options) { return options.defaultEncapsulation; })),
        providers: _mergeArrays(optionsArr.map(function (options) { return ((options.providers)); })),
        missingTranslation: _lastDefined(optionsArr.map(function (options) { return options.missingTranslation; })),
    };
}
/**
 * @template T
 * @param {?} args
 * @return {?}
 */
function _lastDefined(args) {
    for (var /** @type {?} */ i = args.length - 1; i >= 0; i--) {
        if (args[i] !== undefined) {
            return args[i];
        }
    }
    return undefined;
}
/**
 * @param {?} parts
 * @return {?}
 */
function _mergeArrays(parts) {
    var /** @type {?} */ result = [];
    parts.forEach(function (part) { return part && result.push.apply(result, part); });
    return result;
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Interface that defines how import statements should be generated.
 * @abstract
 */
var ImportResolver = (function () {
    function ImportResolver() {
    }
    /**
     * Converts a file path to a module name that can be used as an `import.
     * I.e. `path/to/importedFile.ts` should be imported by `path/to/containingFile.ts`.
     * @abstract
     * @param {?} importedFilePath
     * @param {?} containingFilePath
     * @return {?}
     */
    ImportResolver.prototype.fileNameToModuleName = function (importedFilePath, containingFilePath) { };
    /**
     * Converts the given StaticSymbol into another StaticSymbol that should be used
     * to generate the import from.
     * @abstract
     * @param {?} symbol
     * @return {?}
     */
    ImportResolver.prototype.getImportAs = function (symbol) { };
    /**
     * Determine the arity of a type.
     * @abstract
     * @param {?} symbol
     * @return {?}
     */
    ImportResolver.prototype.getTypeArity = function (symbol) { };
    return ImportResolver;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @module
 * @description
 * Entry point for all APIs of the compiler package.
 *
 * <div class="callout is-critical">
 *   <header>Unstable APIs</header>
 *   <p>
 *     All compiler apis are currently considered experimental and private!
 *   </p>
 *   <p>
 *     We expect the APIs in this package to keep on changing. Do not rely on them.
 *   </p>
 * </div>
 */
// This file only reexports content of the `src` folder. Keep it that way.
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @module
 * @description
 * Entry point for all public APIs of the compiler package.
 */
// This file only reexports content of the `src` folder. Keep it that way.

//# sourceMappingURL=compiler.js.map
//# sourceMappingURL=compiler.es5.js.map

/***/ }),

/***/ "Um43":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return AUTO_STYLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return animate; });
/* unused harmony export group */
/* unused harmony export keyframes */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return sequence; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return state; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return style; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return transition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return trigger; });
/* unused harmony export AnimationPlayer */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NoopAnimationPlayer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return AnimationGroupPlayer; });
/**
 * @license Angular v4.1.0
 * (c) 2010-2017 Google, Inc. https://angular.io/
 * License: MIT
 */
/**
 * \@experimental Animation support is experimental.
 */
var AUTO_STYLE = '*';
/**
 * `trigger` is an animation-specific function that is designed to be used inside of Angular's
 * animation DSL language. If this information is new, please navigate to the {\@link
 * Component#animations-anchor component animations metadata page} to gain a better understanding of
 * how animations in Angular are used.
 *
 * `trigger` Creates an animation trigger which will a list of {\@link state state} and {\@link
 * transition transition} entries that will be evaluated when the expression bound to the trigger
 * changes.
 *
 * Triggers are registered within the component annotation data under the {\@link
 * Component#animations-anchor animations section}. An animation trigger can be placed on an element
 * within a template by referencing the name of the trigger followed by the expression value that the
 * trigger is bound to (in the form of `[\@triggerName]="expression"`.
 *
 * ### Usage
 *
 * `trigger` will create an animation trigger reference based on the provided `name` value. The
 * provided `animation` value is expected to be an array consisting of {\@link state state} and {\@link
 * transition transition} declarations.
 *
 * ```typescript
 * \@Component({
 *   selector: 'my-component',
 *   templateUrl: 'my-component-tpl.html',
 *   animations: [
 *     trigger("myAnimationTrigger", [
 *       state(...),
 *       state(...),
 *       transition(...),
 *       transition(...)
 *     ])
 *   ]
 * })
 * class MyComponent {
 *   myStatusExp = "something";
 * }
 * ```
 *
 * The template associated with this component will make use of the `myAnimationTrigger` animation
 * trigger by binding to an element within its template code.
 *
 * ```html
 * <!-- somewhere inside of my-component-tpl.html -->
 * <div [\@myAnimationTrigger]="myStatusExp">...</div>
 * tools/gulp-tasks/validate-commit-message.js ```
 *
 * {\@example core/animation/ts/dsl/animation_example.ts region='Component'}
 *
 * \@experimental Animation support is experimental.
 * @param {?} name
 * @param {?} definitions
 * @return {?}
 */
function trigger(name, definitions) {
    return { name: name, definitions: definitions };
}
/**
 * `animate` is an animation-specific function that is designed to be used inside of Angular's
 * animation DSL language. If this information is new, please navigate to the {\@link
 * Component#animations-anchor component animations metadata page} to gain a better understanding of
 * how animations in Angular are used.
 *
 * `animate` specifies an animation step that will apply the provided `styles` data for a given
 * amount of time based on the provided `timing` expression value. Calls to `animate` are expected
 * to be used within {\@link sequence an animation sequence}, {\@link group group}, or {\@link
 * transition transition}.
 *
 * ### Usage
 *
 * The `animate` function accepts two input parameters: `timing` and `styles`:
 *
 * - `timing` is a string based value that can be a combination of a duration with optional delay
 * and easing values. The format for the expression breaks down to `duration delay easing`
 * (therefore a value such as `1s 100ms ease-out` will be parse itself into `duration=1000,
 * delay=100, easing=ease-out`. If a numeric value is provided then that will be used as the
 * `duration` value in millisecond form.
 * - `styles` is the style input data which can either be a call to {\@link style style} or {\@link
 * keyframes keyframes}. If left empty then the styles from the destination state will be collected
 * and used (this is useful when describing an animation step that will complete an animation by
 * {\@link transition#the-final-animate-call animating to the final state}).
 *
 * ```typescript
 * // various functions for specifying timing data
 * animate(500, style(...))
 * animate("1s", style(...))
 * animate("100ms 0.5s", style(...))
 * animate("5s ease", style(...))
 * animate("5s 10ms cubic-bezier(.17,.67,.88,.1)", style(...))
 *
 * // either style() of keyframes() can be used
 * animate(500, style({ background: "red" }))
 * animate(500, keyframes([
 *   style({ background: "blue" })),
 *   style({ background: "red" }))
 * ])
 * ```
 *
 * {\@example core/animation/ts/dsl/animation_example.ts region='Component'}
 *
 * \@experimental Animation support is experimental.
 * @param {?} timings
 * @param {?=} styles
 * @return {?}
 */
function animate(timings, styles) {
    if (styles === void 0) { styles = null; }
    return { type: 4 /* Animate */, styles: styles, timings: timings };
}
/**
 * `group` is an animation-specific function that is designed to be used inside of Angular's
 * animation DSL language. If this information is new, please navigate to the {\@link
 * Component#animations-anchor component animations metadata page} to gain a better understanding of
 * how animations in Angular are used.
 *
 * `group` specifies a list of animation steps that are all run in parallel. Grouped animations are
 * useful when a series of styles must be animated/closed off at different statrting/ending times.
 *
 * The `group` function can either be used within a {\@link sequence sequence} or a {\@link transition
 * transition} and it will only continue to the next instruction once all of the inner animation
 * steps have completed.
 *
 * ### Usage
 *
 * The `steps` data that is passed into the `group` animation function can either consist of {\@link
 * style style} or {\@link animate animate} function calls. Each call to `style()` or `animate()`
 * within a group will be executed instantly (use {\@link keyframes keyframes} or a {\@link
 * animate#usage animate() with a delay value} to offset styles to be applied at a later time).
 *
 * ```typescript
 * group([
 *   animate("1s", { background: "black" }))
 *   animate("2s", { color: "white" }))
 * ])
 * ```
 *
 * {\@example core/animation/ts/dsl/animation_example.ts region='Component'}
 *
 * \@experimental Animation support is experimental.
 * @param {?} steps
 * @return {?}
 */
function group(steps) {
    return { type: 3 /* Group */, steps: steps };
}
/**
 * `sequence` is an animation-specific function that is designed to be used inside of Angular's
 * animation DSL language. If this information is new, please navigate to the {\@link
 * Component#animations-anchor component animations metadata page} to gain a better understanding of
 * how animations in Angular are used.
 *
 * `sequence` Specifies a list of animation steps that are run one by one. (`sequence` is used by
 * default when an array is passed as animation data into {\@link transition transition}.)
 *
 * The `sequence` function can either be used within a {\@link group group} or a {\@link transition
 * transition} and it will only continue to the next instruction once each of the inner animation
 * steps have completed.
 *
 * To perform animation styling in parallel with other animation steps then have a look at the
 * {\@link group group} animation function.
 *
 * ### Usage
 *
 * The `steps` data that is passed into the `sequence` animation function can either consist of
 * {\@link style style} or {\@link animate animate} function calls. A call to `style()` will apply the
 * provided styling data immediately while a call to `animate()` will apply its styling data over a
 * given time depending on its timing data.
 *
 * ```typescript
 * sequence([
 *   style({ opacity: 0 })),
 *   animate("1s", { opacity: 1 }))
 * ])
 * ```
 *
 * {\@example core/animation/ts/dsl/animation_example.ts region='Component'}
 *
 * \@experimental Animation support is experimental.
 * @param {?} steps
 * @return {?}
 */
function sequence(steps) {
    return { type: 2 /* Sequence */, steps: steps };
}
/**
 * `style` is an animation-specific function that is designed to be used inside of Angular's
 * animation DSL language. If this information is new, please navigate to the {\@link
 * Component#animations-anchor component animations metadata page} to gain a better understanding of
 * how animations in Angular are used.
 *
 * `style` declares a key/value object containing CSS properties/styles that can then be used for
 * {\@link state animation states}, within an {\@link sequence animation sequence}, or as styling data
 * for both {\@link animate animate} and {\@link keyframes keyframes}.
 *
 * ### Usage
 *
 * `style` takes in a key/value string map as data and expects one or more CSS property/value pairs
 * to be defined.
 *
 * ```typescript
 * // string values are used for css properties
 * style({ background: "red", color: "blue" })
 *
 * // numerical (pixel) values are also supported
 * style({ width: 100, height: 0 })
 * ```
 *
 * #### Auto-styles (using `*`)
 *
 * When an asterix (`*`) character is used as a value then it will be detected from the element
 * being animated and applied as animation data when the animation starts.
 *
 * This feature proves useful for a state depending on layout and/or environment factors; in such
 * cases the styles are calculated just before the animation starts.
 *
 * ```typescript
 * // the steps below will animate from 0 to the
 * // actual height of the element
 * style({ height: 0 }),
 * animate("1s", style({ height: "*" }))
 * ```
 *
 * {\@example core/animation/ts/dsl/animation_example.ts region='Component'}
 *
 * \@experimental Animation support is experimental.
 * @param {?} tokens
 * @return {?}
 */
function style(tokens) {
    return { type: 6 /* Style */, styles: tokens };
}
/**
 * `state` is an animation-specific function that is designed to be used inside of Angular's
 * animation DSL language. If this information is new, please navigate to the {\@link
 * Component#animations-anchor component animations metadata page} to gain a better understanding of
 * how animations in Angular are used.
 *
 * `state` declares an animation state within the given trigger. When a state is active within a
 * component then its associated styles will persist on the element that the trigger is attached to
 * (even when the animation ends).
 *
 * To animate between states, have a look at the animation {\@link transition transition} DSL
 * function. To register states to an animation trigger please have a look at the {\@link trigger
 * trigger} function.
 *
 * #### The `void` state
 *
 * The `void` state value is a reserved word that angular uses to determine when the element is not
 * apart of the application anymore (e.g. when an `ngIf` evaluates to false then the state of the
 * associated element is void).
 *
 * #### The `*` (default) state
 *
 * The `*` state (when styled) is a fallback state that will be used if the state that is being
 * animated is not declared within the trigger.
 *
 * ### Usage
 *
 * `state` will declare an animation state with its associated styles
 * within the given trigger.
 *
 * - `stateNameExpr` can be one or more state names separated by commas.
 * - `styles` refers to the {\@link style styling data} that will be persisted on the element once
 * the state has been reached.
 *
 * ```typescript
 * // "void" is a reserved name for a state and is used to represent
 * // the state in which an element is detached from from the application.
 * state("void", style({ height: 0 }))
 *
 * // user-defined states
 * state("closed", style({ height: 0 }))
 * state("open, visible", style({ height: "*" }))
 * ```
 *
 * {\@example core/animation/ts/dsl/animation_example.ts region='Component'}
 *
 * \@experimental Animation support is experimental.
 * @param {?} name
 * @param {?} styles
 * @return {?}
 */
function state(name, styles) {
    return { type: 0 /* State */, name: name, styles: styles };
}
/**
 * `keyframes` is an animation-specific function that is designed to be used inside of Angular's
 * animation DSL language. If this information is new, please navigate to the {\@link
 * Component#animations-anchor component animations metadata page} to gain a better understanding of
 * how animations in Angular are used.
 *
 * `keyframes` specifies a collection of {\@link style style} entries each optionally characterized
 * by an `offset` value.
 *
 * ### Usage
 *
 * The `keyframes` animation function is designed to be used alongside the {\@link animate animate}
 * animation function. Instead of applying animations from where they are currently to their
 * destination, keyframes can describe how each style entry is applied and at what point within the
 * animation arc (much like CSS Keyframe Animations do).
 *
 * For each `style()` entry an `offset` value can be set. Doing so allows to specifiy at what
 * percentage of the animate time the styles will be applied.
 *
 * ```typescript
 * // the provided offset values describe when each backgroundColor value is applied.
 * animate("5s", keyframes([
 *   style({ backgroundColor: "red", offset: 0 }),
 *   style({ backgroundColor: "blue", offset: 0.2 }),
 *   style({ backgroundColor: "orange", offset: 0.3 }),
 *   style({ backgroundColor: "black", offset: 1 })
 * ]))
 * ```
 *
 * Alternatively, if there are no `offset` values used within the style entries then the offsets
 * will be calculated automatically.
 *
 * ```typescript
 * animate("5s", keyframes([
 *   style({ backgroundColor: "red" }) // offset = 0
 *   style({ backgroundColor: "blue" }) // offset = 0.33
 *   style({ backgroundColor: "orange" }) // offset = 0.66
 *   style({ backgroundColor: "black" }) // offset = 1
 * ]))
 * ```
 *
 * {\@example core/animation/ts/dsl/animation_example.ts region='Component'}
 *
 * \@experimental Animation support is experimental.
 * @param {?} steps
 * @return {?}
 */
function keyframes(steps) {
    return { type: 5 /* KeyframeSequence */, steps: steps };
}
/**
 * `transition` is an animation-specific function that is designed to be used inside of Angular's
 * animation DSL language. If this information is new, please navigate to the {\@link
 * Component#animations-anchor component animations metadata page} to gain a better understanding of
 * how animations in Angular are used.
 *
 * `transition` declares the {\@link sequence sequence of animation steps} that will be run when the
 * provided `stateChangeExpr` value is satisfied. The `stateChangeExpr` consists of a `state1 =>
 * state2` which consists of two known states (use an asterix (`*`) to refer to a dynamic starting
 * and/or ending state).
 *
 * A function can also be provided as the `stateChangeExpr` argument for a transition and this
 * function will be executed each time a state change occurs. If the value returned within the
 * function is true then the associated animation will be run.
 *
 * Animation transitions are placed within an {\@link trigger animation trigger}. For an transition
 * to animate to a state value and persist its styles then one or more {\@link state animation
 * states} is expected to be defined.
 *
 * ### Usage
 *
 * An animation transition is kicked off the `stateChangeExpr` predicate evaluates to true based on
 * what the previous state is and what the current state has become. In other words, if a transition
 * is defined that matches the old/current state criteria then the associated animation will be
 * triggered.
 *
 * ```typescript
 * // all transition/state changes are defined within an animation trigger
 * trigger("myAnimationTrigger", [
 *   // if a state is defined then its styles will be persisted when the
 *   // animation has fully completed itself
 *   state("on", style({ background: "green" })),
 *   state("off", style({ background: "grey" })),
 *
 *   // a transition animation that will be kicked off when the state value
 *   // bound to "myAnimationTrigger" changes from "on" to "off"
 *   transition("on => off", animate(500)),
 *
 *   // it is also possible to do run the same animation for both directions
 *   transition("on <=> off", animate(500)),
 *
 *   // or to define multiple states pairs separated by commas
 *   transition("on => off, off => void", animate(500)),
 *
 *   // this is a catch-all state change for when an element is inserted into
 *   // the page and the destination state is unknown
 *   transition("void => *", [
 *     style({ opacity: 0 }),
 *     animate(500)
 *   ]),
 *
 *   // this will capture a state change between any states
 *   transition("* => *", animate("1s 0s")),
 *
 *   // you can also go full out and include a function
 *   transition((fromState, toState) => {
 *     // when `true` then it will allow the animation below to be invoked
 *     return fromState == "off" && toState == "on";
 *   }, animate("1s 0s"))
 * ])
 * ```
 *
 * The template associated with this component will make use of the `myAnimationTrigger` animation
 * trigger by binding to an element within its template code.
 *
 * ```html
 * <!-- somewhere inside of my-component-tpl.html -->
 * <div [\@myAnimationTrigger]="myStatusExp">...</div>
 * ```
 *
 * #### The final `animate` call
 *
 * If the final step within the transition steps is a call to `animate()` that **only** uses a
 * timing value with **no style data** then it will be automatically used as the final animation arc
 * for the element to animate itself to the final state. This involves an automatic mix of
 * adding/removing CSS styles so that the element will be in the exact state it should be for the
 * applied state to be presented correctly.
 *
 * ```
 * // start off by hiding the element, but make sure that it animates properly to whatever state
 * // is currently active for "myAnimationTrigger"
 * transition("void => *", [
 *   style({ opacity: 0 }),
 *   animate(500)
 * ])
 * ```
 *
 * ### Transition Aliases (`:enter` and `:leave`)
 *
 * Given that enter (insertion) and leave (removal) animations are so common, the `transition`
 * function accepts both `:enter` and `:leave` values which are aliases for the `void => *` and `*
 * => void` state changes.
 *
 * ```
 * transition(":enter", [
 *   style({ opacity: 0 }),
 *   animate(500, style({ opacity: 1 }))
 * ])
 * transition(":leave", [
 *   animate(500, style({ opacity: 0 }))
 * ])
 * ```
 *
 * {\@example core/animation/ts/dsl/animation_example.ts region='Component'}
 *
 * \@experimental Animation support is experimental.
 * @param {?} stateChangeExpr
 * @param {?} steps
 * @return {?}
 */
function transition(stateChangeExpr, steps) {
    return { type: 1 /* Transition */, expr: stateChangeExpr, animation: steps };
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 * @param {?} cb
 * @return {?}
 */
function scheduleMicroTask(cb) {
    Promise.resolve(null).then(cb);
}
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * \@experimental Animation support is experimental.
 * @abstract
 */
var AnimationPlayer = (function () {
    function AnimationPlayer() {
    }
    /**
     * @abstract
     * @param {?} fn
     * @return {?}
     */
    AnimationPlayer.prototype.onDone = function (fn) { };
    /**
     * @abstract
     * @param {?} fn
     * @return {?}
     */
    AnimationPlayer.prototype.onStart = function (fn) { };
    /**
     * @abstract
     * @param {?} fn
     * @return {?}
     */
    AnimationPlayer.prototype.onDestroy = function (fn) { };
    /**
     * @abstract
     * @return {?}
     */
    AnimationPlayer.prototype.init = function () { };
    /**
     * @abstract
     * @return {?}
     */
    AnimationPlayer.prototype.hasStarted = function () { };
    /**
     * @abstract
     * @return {?}
     */
    AnimationPlayer.prototype.play = function () { };
    /**
     * @abstract
     * @return {?}
     */
    AnimationPlayer.prototype.pause = function () { };
    /**
     * @abstract
     * @return {?}
     */
    AnimationPlayer.prototype.restart = function () { };
    /**
     * @abstract
     * @return {?}
     */
    AnimationPlayer.prototype.finish = function () { };
    /**
     * @abstract
     * @return {?}
     */
    AnimationPlayer.prototype.destroy = function () { };
    /**
     * @abstract
     * @return {?}
     */
    AnimationPlayer.prototype.reset = function () { };
    /**
     * @abstract
     * @param {?} p
     * @return {?}
     */
    AnimationPlayer.prototype.setPosition = function (p) { };
    /**
     * @abstract
     * @return {?}
     */
    AnimationPlayer.prototype.getPosition = function () { };
    Object.defineProperty(AnimationPlayer.prototype, "parentPlayer", {
        /**
         * @return {?}
         */
        get: function () { throw new Error('NOT IMPLEMENTED: Base Class'); },
        /**
         * @param {?} player
         * @return {?}
         */
        set: function (player) { throw new Error('NOT IMPLEMENTED: Base Class'); },
        enumerable: true,
        configurable: true
    });
    return AnimationPlayer;
}());
/**
 * \@experimental Animation support is experimental.
 */
var NoopAnimationPlayer = (function () {
    function NoopAnimationPlayer() {
        this._onDoneFns = [];
        this._onStartFns = [];
        this._onDestroyFns = [];
        this._started = false;
        this._destroyed = false;
        this._finished = false;
        this.parentPlayer = null;
    }
    /**
     * @return {?}
     */
    NoopAnimationPlayer.prototype._onFinish = function () {
        if (!this._finished) {
            this._finished = true;
            this._onDoneFns.forEach(function (fn) { return fn(); });
            this._onDoneFns = [];
        }
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    NoopAnimationPlayer.prototype.onStart = function (fn) { this._onStartFns.push(fn); };
    /**
     * @param {?} fn
     * @return {?}
     */
    NoopAnimationPlayer.prototype.onDone = function (fn) { this._onDoneFns.push(fn); };
    /**
     * @param {?} fn
     * @return {?}
     */
    NoopAnimationPlayer.prototype.onDestroy = function (fn) { this._onDestroyFns.push(fn); };
    /**
     * @return {?}
     */
    NoopAnimationPlayer.prototype.hasStarted = function () { return this._started; };
    /**
     * @return {?}
     */
    NoopAnimationPlayer.prototype.init = function () { };
    /**
     * @return {?}
     */
    NoopAnimationPlayer.prototype.play = function () {
        var _this = this;
        if (!this.hasStarted()) {
            scheduleMicroTask(function () { return _this._onFinish(); });
            this._onStart();
        }
        this._started = true;
    };
    /**
     * @return {?}
     */
    NoopAnimationPlayer.prototype._onStart = function () {
        this._onStartFns.forEach(function (fn) { return fn(); });
        this._onStartFns = [];
    };
    /**
     * @return {?}
     */
    NoopAnimationPlayer.prototype.pause = function () { };
    /**
     * @return {?}
     */
    NoopAnimationPlayer.prototype.restart = function () { };
    /**
     * @return {?}
     */
    NoopAnimationPlayer.prototype.finish = function () { this._onFinish(); };
    /**
     * @return {?}
     */
    NoopAnimationPlayer.prototype.destroy = function () {
        if (!this._destroyed) {
            this._destroyed = true;
            if (!this.hasStarted()) {
                this._onStart();
            }
            this.finish();
            this._onDestroyFns.forEach(function (fn) { return fn(); });
            this._onDestroyFns = [];
        }
    };
    /**
     * @return {?}
     */
    NoopAnimationPlayer.prototype.reset = function () { };
    /**
     * @param {?} p
     * @return {?}
     */
    NoopAnimationPlayer.prototype.setPosition = function (p) { };
    /**
     * @return {?}
     */
    NoopAnimationPlayer.prototype.getPosition = function () { return 0; };
    return NoopAnimationPlayer;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
var AnimationGroupPlayer = (function () {
    /**
     * @param {?} _players
     */
    function AnimationGroupPlayer(_players) {
        var _this = this;
        this._players = _players;
        this._onDoneFns = [];
        this._onStartFns = [];
        this._finished = false;
        this._started = false;
        this._destroyed = false;
        this._onDestroyFns = [];
        this.parentPlayer = null;
        var count = 0;
        var total = this._players.length;
        if (total == 0) {
            scheduleMicroTask(function () { return _this._onFinish(); });
        }
        else {
            this._players.forEach(function (player) {
                player.parentPlayer = _this;
                player.onDone(function () {
                    if (++count >= total) {
                        _this._onFinish();
                    }
                });
            });
        }
    }
    /**
     * @return {?}
     */
    AnimationGroupPlayer.prototype._onFinish = function () {
        if (!this._finished) {
            this._finished = true;
            this._onDoneFns.forEach(function (fn) { return fn(); });
            this._onDoneFns = [];
        }
    };
    /**
     * @return {?}
     */
    AnimationGroupPlayer.prototype.init = function () { this._players.forEach(function (player) { return player.init(); }); };
    /**
     * @param {?} fn
     * @return {?}
     */
    AnimationGroupPlayer.prototype.onStart = function (fn) { this._onStartFns.push(fn); };
    /**
     * @param {?} fn
     * @return {?}
     */
    AnimationGroupPlayer.prototype.onDone = function (fn) { this._onDoneFns.push(fn); };
    /**
     * @param {?} fn
     * @return {?}
     */
    AnimationGroupPlayer.prototype.onDestroy = function (fn) { this._onDestroyFns.push(fn); };
    /**
     * @return {?}
     */
    AnimationGroupPlayer.prototype.hasStarted = function () { return this._started; };
    /**
     * @return {?}
     */
    AnimationGroupPlayer.prototype.play = function () {
        if (!this.parentPlayer) {
            this.init();
        }
        if (!this.hasStarted()) {
            this._onStartFns.forEach(function (fn) { return fn(); });
            this._onStartFns = [];
            this._started = true;
        }
        this._players.forEach(function (player) { return player.play(); });
    };
    /**
     * @return {?}
     */
    AnimationGroupPlayer.prototype.pause = function () { this._players.forEach(function (player) { return player.pause(); }); };
    /**
     * @return {?}
     */
    AnimationGroupPlayer.prototype.restart = function () { this._players.forEach(function (player) { return player.restart(); }); };
    /**
     * @return {?}
     */
    AnimationGroupPlayer.prototype.finish = function () {
        this._onFinish();
        this._players.forEach(function (player) { return player.finish(); });
    };
    /**
     * @return {?}
     */
    AnimationGroupPlayer.prototype.destroy = function () {
        if (!this._destroyed) {
            this._onFinish();
            this._players.forEach(function (player) { return player.destroy(); });
            this._destroyed = true;
            this._onDestroyFns.forEach(function (fn) { return fn(); });
            this._onDestroyFns = [];
        }
    };
    /**
     * @return {?}
     */
    AnimationGroupPlayer.prototype.reset = function () {
        this._players.forEach(function (player) { return player.reset(); });
        this._destroyed = false;
        this._finished = false;
        this._started = false;
    };
    /**
     * @param {?} p
     * @return {?}
     */
    AnimationGroupPlayer.prototype.setPosition = function (p) {
        this._players.forEach(function (player) { player.setPosition(p); });
    };
    /**
     * @return {?}
     */
    AnimationGroupPlayer.prototype.getPosition = function () {
        var /** @type {?} */ min = 0;
        this._players.forEach(function (player) {
            var /** @type {?} */ p = player.getPosition();
            min = Math.min(p, min);
        });
        return min;
    };
    Object.defineProperty(AnimationGroupPlayer.prototype, "players", {
        /**
         * @return {?}
         */
        get: function () { return this._players; },
        enumerable: true,
        configurable: true
    });
    return AnimationGroupPlayer;
}());
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @module
 * @description
 * Entry point for all public APIs of the animation package.
 */
/**
 * Generated bundle index. Do not edit.
 */

//# sourceMappingURL=animations.es5.js.map


/***/ }),

/***/ "UmTU":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isScheduler_1 = __webpack_require__("fWbP");
var isArray_1 = __webpack_require__("Xajo");
var ArrayObservable_1 = __webpack_require__("Yh8Q");
var combineLatest_1 = __webpack_require__("A7JX");
/* tslint:enable:max-line-length */
/**
 * Combines multiple Observables to create an Observable whose values are
 * calculated from the latest values of each of its input Observables.
 *
 * <span class="informal">Whenever any input Observable emits a value, it
 * computes a formula using the latest values from all the inputs, then emits
 * the output of that formula.</span>
 *
 * <img src="./img/combineLatest.png" width="100%">
 *
 * `combineLatest` combines the values from all the Observables passed as
 * arguments. This is done by subscribing to each Observable in order and,
 * whenever any Observable emits, collecting an array of the most recent
 * values from each Observable. So if you pass `n` Observables to operator,
 * returned Observable will always emit an array of `n` values, in order
 * corresponding to order of passed Observables (value from the first Observable
 * on the first place and so on).
 *
 * Static version of `combineLatest` accepts either an array of Observables
 * or each Observable can be put directly as an argument. Note that array of
 * Observables is good choice, if you don't know beforehand how many Observables
 * you will combine. Passing empty array will result in Observable that
 * completes immediately.
 *
 * To ensure output array has always the same length, `combineLatest` will
 * actually wait for all input Observables to emit at least once,
 * before it starts emitting results. This means if some Observable emits
 * values before other Observables started emitting, all that values but last
 * will be lost. On the other hand, is some Observable does not emit value but
 * completes, resulting Observable will complete at the same moment without
 * emitting anything, since it will be now impossible to include value from
 * completed Observable in resulting array. Also, if some input Observable does
 * not emit any value and never completes, `combineLatest` will also never emit
 * and never complete, since, again, it will wait for all streams to emit some
 * value.
 *
 * If at least one Observable was passed to `combineLatest` and all passed Observables
 * emitted something, resulting Observable will complete when all combined
 * streams complete. So even if some Observable completes, result of
 * `combineLatest` will still emit values when other Observables do. In case
 * of completed Observable, its value from now on will always be the last
 * emitted value. On the other hand, if any Observable errors, `combineLatest`
 * will error immediately as well, and all other Observables will be unsubscribed.
 *
 * `combineLatest` accepts as optional parameter `project` function, which takes
 * as arguments all values that would normally be emitted by resulting Observable.
 * `project` can return any kind of value, which will be then emitted by Observable
 * instead of default array. Note that `project` does not take as argument that array
 * of values, but values themselves. That means default `project` can be imagined
 * as function that takes all its arguments and puts them into an array.
 *
 *
 * @example <caption>Combine two timer Observables</caption>
 * const firstTimer = Rx.Observable.timer(0, 1000); // emit 0, 1, 2... after every second, starting from now
 * const secondTimer = Rx.Observable.timer(500, 1000); // emit 0, 1, 2... after every second, starting 0,5s from now
 * const combinedTimers = Rx.Observable.combineLatest(firstTimer, secondTimer);
 * combinedTimers.subscribe(value => console.log(value));
 * // Logs
 * // [0, 0] after 0.5s
 * // [1, 0] after 1s
 * // [1, 1] after 1.5s
 * // [2, 1] after 2s
 *
 *
 * @example <caption>Combine an array of Observables</caption>
 * const observables = [1, 5, 10].map(
 *   n => Rx.Observable.of(n).delay(n * 1000).startWith(0) // emit 0 and then emit n after n seconds
 * );
 * const combined = Rx.Observable.combineLatest(observables);
 * combined.subscribe(value => console.log(value));
 * // Logs
 * // [0, 0, 0] immediately
 * // [1, 0, 0] after 1s
 * // [1, 5, 0] after 5s
 * // [1, 5, 10] after 10s
 *
 *
 * @example <caption>Use project function to dynamically calculate the Body-Mass Index</caption>
 * var weight = Rx.Observable.of(70, 72, 76, 79, 75);
 * var height = Rx.Observable.of(1.76, 1.77, 1.78);
 * var bmi = Rx.Observable.combineLatest(weight, height, (w, h) => w / (h * h));
 * bmi.subscribe(x => console.log('BMI is ' + x));
 *
 * // With output to console:
 * // BMI is 24.212293388429753
 * // BMI is 23.93948099205209
 * // BMI is 23.671253629592222
 *
 *
 * @see {@link combineAll}
 * @see {@link merge}
 * @see {@link withLatestFrom}
 *
 * @param {ObservableInput} observable1 An input Observable to combine with other Observables.
 * @param {ObservableInput} observable2 An input Observable to combine with other Observables.
 * More than one input Observables may be given as arguments
 * or an array of Observables may be given as the first argument.
 * @param {function} [project] An optional function to project the values from
 * the combined latest values into a new value on the output Observable.
 * @param {Scheduler} [scheduler=null] The IScheduler to use for subscribing to
 * each input Observable.
 * @return {Observable} An Observable of projected values from the most recent
 * values from each input Observable, or an array of the most recent values from
 * each input Observable.
 * @static true
 * @name combineLatest
 * @owner Observable
 */
function combineLatest() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i - 0] = arguments[_i];
    }
    var project = null;
    var scheduler = null;
    if (isScheduler_1.isScheduler(observables[observables.length - 1])) {
        scheduler = observables.pop();
    }
    if (typeof observables[observables.length - 1] === 'function') {
        project = observables.pop();
    }
    // if the first and only other argument besides the resultSelector is an array
    // assume it's been called with `combineLatest([obs1, obs2, obs3], project)`
    if (observables.length === 1 && isArray_1.isArray(observables[0])) {
        observables = observables[0];
    }
    return new ArrayObservable_1.ArrayObservable(observables, scheduler).lift(new combineLatest_1.CombineLatestOperator(project));
}
exports.combineLatest = combineLatest;
//# sourceMappingURL=combineLatest.js.map

/***/ }),

/***/ "UngX":
/***/ (function(module, exports) {

exports.model=Model={Game:{},Board:{},Move:{}},function(){var t;Model.Game.cbConstants={MASK:65535,FLAG_MOVE:65536,FLAG_CAPTURE:131072,FLAG_STOP:262144,FLAG_SCREEN_CAPTURE:524288,FLAG_CAPTURE_KING:1048576,FLAG_CAPTURE_NO_KING:2097152};var e="undefined"!=typeof Int32Array;Model.Game.cbUseTypedArrays=e,Model.Game.cbTypedArray=function(t){if(e){var i=new Int32Array(t.length);return i.set(t),i}for(var r=[],a=t.length,s=0;s<a;s++)r.push(t[s]);return r},Model.Game.cbShortRangeGraph=function(t,e,i,r){var a=this;void 0===r&&(r=196608);for(var s={},n=0;n<t.boardSize;n++)s[n]=[],(!i||n in i)&&e.forEach(function(e){var o=t.Graph(n,e);null!=o&&(!i||o in i)&&s[n].push(a.cbTypedArray([o|r]))});return s},Model.Game.cbLongRangeGraph=function(t,e,i,r,a){var s=this;void 0!==r&&null!=r||(r=196608),a||(a=1/0);for(var n={},o=0;o<t.boardSize;o++)n[o]=[],(!i||o in i)&&e.forEach(function(e){for(var h=[],c=t.Graph(o,e),p=0;null!=c&&(!i||c in i)&&(h.push(c|r),++p!=a);)c=t.Graph(c,e);h.length>0&&n[o].push(s.cbTypedArray(h))});return n},Model.Game.cbNullGraph=function(t){for(var e={},i=0;i<t.boardSize;i++)e[i]=[];return e},Model.Game.cbAuthorGraph=function(t){for(var e={},i=0;i<t.boardSize;i++){e[i]=[];for(var r=0;r<t.boardSize;r++)e[i].push([2293760|r])}return e},Model.Game.cbMergeGraphs=function(t){for(var e=[],i=0;i<t.boardSize;i++){e[i]=[];for(var r=1;r<arguments.length;r++)e[i]=e[i].concat(arguments[r][i])}return e},Model.Game.cbGetThreatGraph=function(){function t(e,i){for(var r in n){var a=n[r];if(!(a.p.length<i.length+1)){for(var s=!0,o=0;o<i.length;o++)if(i[o]!=a.p[o]){s=!1;break}if(s){var h=a.p[i.length],c=e[h];void 0===c&&(c={e:{}},e[h]=c),a.p.length==i.length+1&&(c.t=a.t,c.ts=a.ts,c.tk=a.tk,delete n[r]),i.push(h),t(c.e,i),i.pop()}}}}var e=this;this.cbUseScreenCapture=!1,this.cbUseCaptureKing=!1,this.cbUseCaptureNoKing=!1;for(var i={1:[],"-1":[]},r=[],a=0;a<this.g.boardSize;a++)this.g.pTypes.forEach(function(t,i){t.graph[a].forEach(function(t){for(var s=[],n=0;n<t.length;n++){var o=t[n];1048576&o?(e.cbUseCaptureKing=!0,s.unshift({d:65535&o,a:a,tk:i})):2097152&o?(e.cbUseCaptureNoKing=!0,s.unshift({d:65535&o,a:a,tnk:i})):131072&o?s.unshift({d:65535&o,a:a,t:i}):262144&o?s.unshift({d:65535&o,a:a}):524288&o&&(e.cbUseScreenCapture=!0,s.unshift({d:65535&o,a:a,ts:i}))}s.length>0&&r.push(s)})});var s={};r.forEach(function(t){t.forEach(function(e,i){var r=s[e.d];void 0===r&&(r={},s[e.d]=r);for(var a=[],n=i+1;n<t.length;n++)a.push(t[n].d);a.push(e.a);var o=a.join(","),h=r[o];void 0===h&&(h={p:a,t:{},ts:{},tk:{}},r[o]=h),void 0!==e.t?h.t[e.t]=!0:void 0!==e.tk?h.tk[e.tk]=!0:void 0!==e.ts&&(h.ts[e.ts]=!0)})});for(var a=0;a<e.g.boardSize;a++){var n=s[a],o={};t(o,[]),i[1][a]=o,i[-1][a]=o}return i},Model.Game.InitGame=function(){var e=this;this.cbVar=t=this.cbDefine(),this.g.boardSize=this.cbVar.geometry.boardSize,this.g.pTypes=this.cbGetPieceTypes(),this.g.threatGraph=this.cbGetThreatGraph(),this.g.distGraph=this.cbVar.geometry.GetDistances(),this.cbPiecesCount=0,this.g.castleablePiecesCount={1:0,"-1":0};for(var i in t.pieceTypes){var r=t.pieceTypes[i];if(r.castle){(r.initial||[]).forEach(function(t){e.g.castleablePiecesCount[t.s]++})}r.initial&&(this.cbPiecesCount+=r.initial.length)}for(var a=[],i=0;i<this.cbPiecesCount;i++)a.push(i);var s=Object.keys(t.pieceTypes);this.zobrist=new JocGame.Zobrist({board:{type:"array",size:this.cbVar.geometry.boardSize,values:a},who:{values:["1","-1"]},type:{type:"array",size:this.cbPiecesCount,values:s}})},Model.Game.cbGetPieceTypes=function(){for(var t=[],e={},i=0;i<this.cbVar.geometry.boardSize;i++)e[i]=[];for(var r in this.cbVar.pieceTypes){var a=this.cbVar.pieceTypes[r];t[r]={graph:a.graph||e,abbrev:a.abbrev||"",value:a.isKing?100:a.value||1,isKing:!!a.isKing,castle:!!a.castle,epTarget:!!a.epTarget,epCatch:!!a.epCatch}}return t},Model.Board.Init=function(t){this.zSign=0},Model.Board.InitialPosition=function(i){var r=this;this.board=e?new Int16Array(i.g.boardSize):[];for(var a=0;a<i.g.boardSize;a++)this.board[a]=-1;if(this.kings={},this.pieces=[],this.ending={1:!1,"-1":!1},this.lastMove=null,i.cbVar.castle&&(this.castled={1:!1,"-1":!1}),this.zSign=i.zobrist.update(0,"who",-1),this.noCaptCount=0,this.mWho=1,i.mInitial)this.mWho=i.mInitial.turn||1,i.mInitial.pieces.forEach(function(t){var e={};for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i]);r.pieces.push(e)}),i.mInitial.lastMove&&(this.lastMove={f:i.mInitial.lastMove.f,t:i.mInitial.lastMove.t}),void 0!==i.mInitial.noCaptCount&&(this.noCaptCount=i.mInitial.noCaptCount),i.cbVar.castle&&i.mInitial.castle&&(this.castled={1:{k:!!i.mInitial.castle[1]&&!!i.mInitial.castle[1].k,q:!!i.mInitial.castle[1]&&!!i.mInitial.castle[1].q},"-1":{k:!!i.mInitial.castle[-1]&&!!i.mInitial.castle[-1].k,q:!!i.mInitial.castle[-1]&&!!i.mInitial.castle[-1].q}});else for(var s in i.cbVar.pieceTypes)for(var n=i.cbVar.pieceTypes[s],o=n.initial||[],h=0;h<o.length;h++){var c=o[h],p={s:c.s,t:parseInt(s),p:c.p,m:!1};this.pieces.push(p)}if(this.pieces.sort(function(t,e){if(t.s!=e.s)return e.s-t.s;var r=i.cbVar.pieceTypes[t.t].value||100,a=i.cbVar.pieceTypes[e.t].value||100;return r!=a?r-a:t.p-e.p}),this.pieces.forEach(function(t,e){t.i=e,r.board[t.p]=e,i.g.pTypes[t.t].isKing&&(r.kings[t.s]=t.p),r.zSign=i.zobrist.update(r.zSign,"board",e,t.p),r.zSign=i.zobrist.update(r.zSign,"type",t.t,e)}),i.mInitial&&i.mInitial.enPassant){var a=t.geometry.PosByName(i.mInitial.enPassant);if(a>=0){var l,u=t.geometry.C(a),v=t.geometry.R(a);l=1==i.mInitial.turn?t.geometry.POS(u,v-1):t.geometry.POS(u,v+1),this.epTarget={p:a,i:this.board[l]}}}},Model.Board.CopyFrom=function(t){if(e)this.board=new Int16Array(t.board.length),this.board.set(t.board);else{this.board=[];for(var i=t.board,r=i.length,a=0;a<r;a++)this.board.push(i[a])}this.pieces=[];for(var s=t.pieces.length,a=0;a<s;a++){var n=t.pieces[a];this.pieces.push({s:n.s,p:n.p,t:n.t,i:n.i,m:n.m})}this.kings={1:t.kings[1],"-1":t.kings[-1]},this.check=t.check,t.lastMove?this.lastMove={f:t.lastMove.f,t:t.lastMove.t,c:t.lastMove.c}:this.lastMove=null,this.ending={1:t.ending[1],"-1":t.ending[-1]},void 0!==t.castled&&(this.castled={1:t.castled[1],"-1":t.castled[-1]}),this.noCaptCount=t.noCaptCount,t.epTarget?this.epTarget={p:t.epTarget.p,i:t.epTarget.i}:this.epTarget=null,this.mWho=t.mWho,this.zSign=t.zSign},Model.Board.cbApplyCastle=function(t,e,i){var r=t.cbVar.castle[e.f+"/"+e.cg],a=r.r[r.r.length-1],s=this.pieces[this.board[e.cg]],n=r.k[r.k.length-1],o=this.pieces[this.board[e.f]];return i&&(this.zSign=t.zobrist.update(this.zSign,"board",s.i,e.cg),this.zSign=t.zobrist.update(this.zSign,"board",s.i,a),this.zSign=t.zobrist.update(this.zSign,"board",o.i,e.f),this.zSign=t.zobrist.update(this.zSign,"board",o.i,n)),s.p=a,s.m=!0,this.board[e.cg]=-1,o.p=n,o.m=!0,this.board[e.f]=-1,this.board[a]=s.i,this.board[n]=o.i,this.castled[s.s]=!0,this.kings[o.s]=n,[{i:s.i,f:a,t:-1},{i:o.i,f:n,t:e.f,kp:e.f,who:o.s,m:!1},{i:s.i,f:-1,t:e.cg,m:!1,cg:!1}]},Model.Board.cbQuickApply=function(t,e){if(void 0!==e.cg)return this.cbApplyCastle(t,e,!1);var i=[],r=this.board[e.f],a=this.pieces[r];if(null!=e.c){i.unshift({i:e.c,f:-1,t:this.pieces[e.c].p});var s=this.pieces[e.c];this.board[s.p]=-1,s.p=-1}var n=this.kings[a.s];return t.g.pTypes[a.t].isKing&&(this.kings[a.s]=e.t),i.unshift({i:r,f:e.t,t:e.f,kp:n,who:a.s,ty:a.t}),a.p=e.t,void 0!==e.pr&&(a.t=e.pr),this.board[e.f]=-1,this.board[e.t]=r,i},Model.Board.cbQuickUnapply=function(t,e){for(var i=0;i<e.length;i++){var r=e[i],a=this.pieces[r.i];r.f>=0&&(a.p=-1,this.board[r.f]=-1),r.t>=0&&(a.p=r.t,this.board[r.t]=r.i),void 0!==r.m&&(a.m=r.m),void 0!==r.kp&&(this.kings[r.who]=r.kp),void 0!=r.ty&&(a.t=r.ty),void 0!=r.cg&&(this.castled[a.s]=r.cg)}},Model.Board.ApplyMove=function(t,e){var i=this.pieces[this.board[e.f]];if(void 0!==e.cg)this.cbApplyCastle(t,e,!0);else{if(this.zSign=t.zobrist.update(this.zSign,"board",i.i,e.f),this.board[i.p]=-1,void 0!==e.pr&&(this.zSign=t.zobrist.update(this.zSign,"type",i.t,i.i),i.t=e.pr,this.zSign=t.zobrist.update(this.zSign,"type",i.t,i.i)),null!=e.c){var r=this.pieces[e.c];this.zSign=t.zobrist.update(this.zSign,"board",r.i,r.p),this.board[r.p]=-1,r.p=-1,r.m=!0,this.noCaptCount=0}else this.noCaptCount++;i.p=e.t,i.m=!0,this.board[e.t]=i.i,this.zSign=t.zobrist.update(this.zSign,"board",i.i,e.t),t.g.pTypes[i.t].isKing&&(this.kings[i.s]=e.t)}this.check=!!e.ck,this.lastMove={f:e.f,t:e.t,c:e.c},void 0!==e.ko&&(this.ending[i.s]=e.ko),void 0!==e.ept?this.epTarget={p:e.ept,i:i.i}:this.epTarget=null,this.zSign=t.zobrist.update(this.zSign,"who",-this.mWho),this.zSign=t.zobrist.update(this.zSign,"who",this.mWho)},Model.Board.Evaluate=function(i){function r(e){var i=1/0;for(var r in t.geometry.corners)i=Math.min(i,h.distGraph[s.kings[e]][r]);return i-Math.sqrt(h.boardSize)}var a="debug"==arguments[3],s=this;this.mEvaluation=0;var n,o=this.mWho,h=i.g;if(e)n={1:{count:new Uint8Array(h.pTypes.length),byType:{}},"-1":{count:new Uint8Array(h.pTypes.length),byType:{}}};else{n={1:{count:[],byType:{}},"-1":{count:[],byType:{}}};for(var c=0;c<h.pTypes.length;c++)n[1].count[c]=n[-1].count[c]=0}if(i.mOptions.preventRepeat&&i.GetRepeatOccurence(this)>2)return this.mFinished=!0,void(this.mWinner=i.cbOnPerpetual?o*i.cbOnPerpetual:JocGame.DRAW);for(var p={1:0,"-1":0},l={1:h.distGraph[this.kings[-1]],"-1":h.distGraph[this.kings[1]]},u={1:0,"-1":0},v={1:0,"-1":0},b={1:0,"-1":0},f={1:0,"-1":0},d={1:!1,"-1":!1},g=this.pieces,m=g.length,c=0;c<m;c++){var G=g[c];if(G.p>=0){var y=G.s,M=h.pTypes[G.t];M.isKing?d[y]=G.m:p[y]+=M.value,M.castle&&!G.m&&f[y]++,v[y]++,u[y]+=l[y][G.p],b[y]+=t.geometry.distEdge[G.p];var C=n[y];C.count[G.t]++;var S=C.byType;void 0===S[G.t]?S[G.t]=[G]:S[G.t].push(G)}}if(this.lastMove&&null!=this.lastMove.c){var G=this.pieces[this.board[this.lastMove.t]];p[-G.s]+=this.cbStaticExchangeEval(i,G.p,G.s,{piece:G})}var k={1:0,"-1":0},A={1:0,"-1":0},T={1:0,"-1":0};this.ending[1]&&(A[1]=(u[1]-Math.sqrt(h.boardSize))/v[1],t.geometry.corners&&(T[1]=r(1))),this.ending[-1]&&(A[-1]=(u[-1]-Math.sqrt(h.boardSize))/v[-1],t.geometry.corners&&(T[1]=r(-1)));var z={pieceValue:p[1]-p[-1],pieceValueRatio:(p[1]-p[-1])/(p[1]+p[-1]+1),posValue:b[1]-b[-1],averageDistKing:u[1]/v[1]-u[-1]/v[-1],check:this.check?-o:0,endingKingFreedom:k[1]-k[-1],endingDistKing:A[1]-A[-1],distKingCorner:T[1]-T[-1]};t.castle&&(z.castle=(this.castled[1]?1:d[1]?0:f[1]/(h.castleablePiecesCount[1]+1))-(this.castled[-1]?1:d[-1]?0:f[-1]/(h.castleablePiecesCount[-1]+1))),t.evaluate&&t.evaluate.call(this,i,z,n);var E=i.mOptions.levelOptions;for(var P in z){var R=z[P],I=E[P+"Factor"]||0,F=R*I;a&&console.log(P,"=",R,"*",I,"=>",F),this.mEvaluation+=F}a&&console.log("Evaluation",this.mEvaluation)},Model.Board.cbGeneratePseudoLegalMoves=function(t){function e(e,a){var s=t.cbVar.promote;if(!s)return void r.push(a);var n=s.call(i,t,e,a);if(null!=n)if(0==n.length)r.push(a);else if(1==n.length)a.pr=n[0],r.push(a);else for(var o=0;o<n.length;o++){var h=n[o];r.push({f:a.f,t:a.t,c:a.c,pr:h,ept:a.ept,ep:a.ep,a:a.a})}}for(var i=this,r=[],a=t.cbVar,s=this.mWho,n=!a.castle||this.check||this.castled[s]?null:[],o=-1,h=this.pieces.length,c=0;c<h;c++){var p=this.pieces[c];if(!(p.p<0||p.s!=s)){var l=t.g.pTypes[p.t];l.isKing&&(p.m?n=null:o=p),n&&l.castle&&!p.m&&n.push(p);var u,v;u=l.graph[p.p],v=u.length;for(var b=0;b<v;b++)for(var f=u[b],d=!1,g=f.length,m=null,G=0;G<g;G++){var y=f[G],M=65535&y,C=this.board[M];if(!(C<0)||l.epCatch&&this.epTarget&&this.epTarget.p==M){if(!(524288&y)){var S;S=C<0?this.pieces[this.epTarget.i]:this.pieces[C],!(S.s!=p.s&&131072&y)||1048576&y&&!t.g.pTypes[S.t].isKing||2097152&y&&t.g.pTypes[S.t].isKing||e(p,{f:p.p,t:M,c:S.i,a:l.abbrev,ep:C<0});break}if(d){var S=this.pieces[C];S.s!=p.s&&e(p,{f:p.p,t:M,c:S.i,a:l.abbrev});break}d=!0}else 65536&y&&0==d&&e(p,{f:p.p,t:M,c:null,a:l.abbrev,ept:null!=m&&l.epTarget?m:void 0});m=M}}}if(n)for(var c=0;c<n.length;c++){var k=n[c],A=t.cbVar.castle[o.p+"/"+k.p];if(A){for(var T=!0,b=0;b<A.r.length;b++){var z=A.r[b];if(this.board[z]>=0&&z!=o.p&&z!=k.p){T=!1;break}}if(T){for(var E=!0,b=0;b<A.k.length;b++){var z=A.k[b];if(this.board[z]>=0&&z!=k.p&&z!=o.p||this.cbGetAttackers(t,z,s).length>0){E=!1;break}}E&&r.push({f:o.p,t:A.k[A.k.length-1],c:null,cg:k.p})}}}return r},Model.Board.cbStaticExchangeEval=function(t,e,i,r){var a=0,s=this.cbGetSmallestAttacker(t,e,i);if(s){var n=this.mWho;this.mWho=s.s;var o=this.cbQuickApply(t,{f:s.p,t:e,c:r.piece.i}),h=t.g.pTypes[r.piece.t].value;r.piece=s,a=Math.max(0,h-this.cbStaticExchangeEval(t,e,-i,r)),this.cbQuickUnapply(t,o),this.mWho=n}return a},Model.Board.cbGetSmallestAttacker=function(t,e,i){var r=this.cbGetAttackers(t,e,i);if(0==r.length)return null;for(var a=1/0,s=null,n=r.length,o=0;o<n;o++){var h=r[o],c=t.g.pTypes[h.t].value;c<a&&(a=c,s=h)}return s},Model.Board.cbCollectAttackers=function(t,e,i,r){for(var a in e){var s=e[a],n=this.board[a];if(n<0)this.cbCollectAttackers(t,s.e,i,r);else{var o=this.pieces[n];o.s==-t&&(s.t&&o.t in s.t||r&&s.tk&&o.t in s.tk)&&i.push(o)}}},Model.Board.cbCollectAttackersScreen=function(t,e,i,r,a){for(var s in e){var n=e[s],o=this.board[s];if(o<0)this.cbCollectAttackersScreen(t,n.e,i,r,a);else{var h=this.pieces[o];!a&&h.s==-t&&(n.t&&h.t in n.t||r&&n.tk&&h.t in n.tk)?i.push(h):a?a&&h.s==-t&&n.ts&&h.t in n.ts&&i.push(h):this.cbCollectAttackersScreen(t,n.e,i,r,!0)}}},Model.Board.cbGetAttackers=function(t,e,i,r){var a=[];return t.cbUseScreenCapture?this.cbCollectAttackersScreen(i,t.g.threatGraph[i][e],a,r,!1):this.cbCollectAttackers(i,t.g.threatGraph[i][e],a,r),a},Model.Board.GenerateMoves=function(t){var e=this.cbGeneratePseudoLegalMoves(t);this.mMoves=[];for(var i=!0,r=this.kings[this.mWho],a=e.length,s=0;s<a;s++){var n=e[s],o=this.cbQuickApply(t,n);if(!(this.cbGetAttackers(t,this.kings[this.mWho],this.mWho,!0).length>0)){var h=this.cbGetAttackers(t,this.kings[-this.mWho],-this.mWho,!0).length>0;n.ck=h,this.mMoves.push(n),n.f!=r&&(i=!1)}this.cbQuickUnapply(t,o)}if(0==this.mMoves.length)this.mFinished=!0,this.mWinner=t.cbOnStaleMate?t.cbOnStaleMate*this.mWho:JocGame.DRAW,this.check&&(this.mWinner=-this.mWho);else if(this.ending[this.mWho]){if(!i)for(var s=0;s<this.mMoves.length;s++)this.mMoves[s].ko=!1}else if(!this.ending[this.mWho]&&i&&!this.check)for(var s=0;s<this.mMoves.length;s++)this.mMoves[s].ko=!0},Model.Board.GetSignature=function(){return this.zSign},Model.Move.Init=function(t){for(var e in t)t.hasOwnProperty(e)&&(this[e]=t[e])},Model.Move.Equals=function(t){return this.f==t.f&&this.t==t.t&&this.pr==t.pr},Model.Move.CopyFrom=function(t){this.Init(t)},Model.Move.ToString=function(e){var i=this;switch(e=e||"natural"){case"natural":return function(){var e;if(void 0!==i.cg?e=t.castle[i.f+"/"+i.cg].n:(e=i.a||"",e+=t.geometry.PosName(i.f),null==i.c?e+="-":e+="x",e+=t.geometry.PosName(i.t)),void 0!==i.pr){var r=t.pieceTypes[i.pr];r&&r.abbrev&&r.abbrev.length>0&&!r.silentPromo&&(e+="="+r.abbrev)}return i.ck&&(e+="+"),e}();case"engine":return function(){var e=t.geometry.PosName(i.f)+t.geometry.PosName(i.t);if(void 0!=i.pr){var r=t.pieceTypes[i.pr];r&&r.abbrev&&r.abbrev.length>0&&!r.silentPromo&&(e+=r.abbrev)}return e}();default:return"??"}},Model.Board.CompactMoveString=function(e,i,r){"function"!=typeof i.ToString&&(i=e.CreateMove(i));var a=i.ToString(),s=/^([A-Z]?)([a-z])([1-9][0-9]*)([-x])([a-z])([1-9][0-9]*)(.*?)$/.exec(a);if(!s)return a;var n=s[7];if(r||(r={}),r.value||(r.value=[]),0==r.value.length){var o=this.mMoves;this.mMoves&&0!=this.mMoves.length||this.GenerateMoves(e);for(var h=0;h<this.mMoves.length;h++){var c=this.mMoves[h];"function"!=typeof c.ToString&&(c=e.CreateMove(c)),r.value.push({str:c.ToString(),move:c})}this.mMoves=o}var p=[];if(r.value.forEach(function(t){var e=/^([A-Z]?[a-z][1-9][0-9]*[-x][a-z][1-9][0-9]*)(.*?)$/.exec(t.str);e&&t.move.t==i.t&&(t.move.a||"")==s[1]&&e[2]==n&&p.push(t.move)}),1==p.length)return""==s[1]&&"x"==s[4]?s[2]+"x"+s[5]+s[6]+s[7]:s[1]+("x"==s[4]?"x":"")+s[5]+s[6]+s[7];if(t.geometry.CompactCrit)for(var l="",h=0;;h++){var u=t.geometry.CompactCrit(i.f,h);if(null==u)return a;l+=u;for(var v=[],b=0;b<p.length;b++){var f=p[b];t.geometry.CompactCrit(f.f,h)==u&&v.push(f)}if(console.assert(v.length>0),1==v.length)return s[1]+l+("x"==s[4]?"x":"")+s[5]+s[6]+s[7];p=v}return a},Model.Board.cbIntegrity=function(t){function e(t,e){t||console.error(e)}for(var i=this,r=0;r<this.board.length;r++){var a=this.board[r];if(a>=0){var s=i.pieces[a];e(void 0!==s,"no piece at pos"),e(s.p==r,"piece has different pos")}}for(var a=0;a<this.pieces.length;a++){var s=this.pieces[a];s.p>=0&&e(i.board[s.p]==a,"board index mismatch")}},Model.Board.ExportBoardState=function(t){return t.cbVar.geometry.ExportBoardState?t.cbVar.geometry.ExportBoardState(this,t.cbVar,t.mPlayedMoves.length):"not supported"},Model.Game.Import=function(e,i){var r,a=[],s={1:{},"-1":{}},n=null,o=0;if("pjn"==e){var h={status:!1,error:"parse"},c=i.split(" ");if(6!=c.length)return console.warn("FEN should have 6 parts"),h;var p=c[0].split("/"),l=t.geometry.fenHeight||t.geometry.height;if(p.length!=l)return console.warn("FEN board should have",l,"rows, got",p.length),h;var u={};for(var v in t.pieceTypes){var b=t.pieceTypes[v],f=b.fenAbbrev||b.abbrev||"X";u[f.toUpperCase()]={s:1,t:v},u[f.toLowerCase()]={s:-1,t:v}}var d=t.geometry.FenRowPos||function(e,i){return(t.geometry.height-1-e)*t.geometry.width+i};if(p.forEach(function(e,i){for(var r=0,s=0;s<e.length;s++){var n=e.substr(s,1),o=u[n];if(void 0!==o){var c=d(i,r);r++;for(var p={s:o.s,t:o.t,p:c},l=!0,v=t.pieceTypes[p.t].initial||[],b=0;b<v.length;b++){var f=v[b];f.s==p.s&&f.p==c&&(l=!1)}p.m=l,a.push(p)}else{if(isNaN(parseInt(n)))return console.warn("FEN invalid board spec",n),h;r+=parseInt(n)}}}),a.sort(function(t,e){return e.s-t.s}),"w"==c[1])r=1;else{if("b"!=c[1])return console.warn("FEN invalid turn spec",c[1]),h;r=-1}s[1].k=c[2].indexOf("K")>=0,s[1].q=c[2].indexOf("Q")>=0,s[-1].k=c[2].indexOf("k")>=0,s[-1].q=c[2].indexOf("q")>=0,n="-"==c[3]?null:c[3];var g=parseInt(c[4]);isNaN(g)||(o=g);var m={pieces:a,turn:r,castle:s,enPassant:n,noCaptCount:o};return t.importGame&&t.importGame.call(this,m,e,i),{status:!0,initial:m}}return{status:!1,error:"unsupported"}}}(),function(){Model.Game.cbBoardGeometryGrid=function(t,e){function i(e){return e%t}function r(e){return Math.floor(e/t)}function a(e,i){return i*t+e}function s(s,n){var o=i(s),h=r(s),c=o+n[0],p=h+n[1];return c<0||c>=t||p<0||p>=e?null:a(c,p)}function n(t){return String.fromCharCode("a".charCodeAt(0)+i(t))+(r(t)+1)}function o(t){var e=/^([a-z])([0-9]+)$/.exec(t);return e?a(e[1].charCodeAt(0)-"a".charCodeAt(0),parseInt(e[2])-1):-1}function h(t,e){return 0==e?String.fromCharCode("a".charCodeAt(0)+i(t)):1==e?r(t)+1:null}function c(){for(var a=[],s=0;s<t*e;s++){var n=[];a.push(n);for(var o=0;o<t*e;o++){var h=r(s),c=i(s),p=r(o),l=i(o);n.push(Math.max(Math.abs(h-p),Math.abs(c-l)))}}return a}function p(i,r,s){for(var o=[],h=e-1;h>=0;h--){for(var c="",p=0,l=0;l<t;l++){var u=i.board[a(l,h)];if(u<0)p++;else{p>0&&(c+=p,p=0);var v=i.pieces[u],b=r.pieceTypes[v.t].fenAbbrev||r.pieceTypes[v.t].abbrev||"?";v.s==-1?c+=b.toLowerCase():c+=b.toUpperCase()}}p&&(c+=p),o.push(c)}var f=o.join("/");f+=" ",1==i.mWho?f+="w":f+="b",f+=" ";var d="";return i.castled&&(i.castled[1]===!1?d+="KQ":(i.castled[1].k&&(d+="K"),i.castled[1].q&&(d+="Q")),i.castled[-1]===!1?d+="kq":(i.castled[-1].k&&(d+="k"),i.castled[-1].q&&(d+="q"))),0==d.length&&(d="-"),f+=d,f+=" ",i.epTarget?f+=n(i.epTarget.p):f+="-",f+=" ",f+=i.noCaptCount,f+=" ",f+=Math.floor(s/2)+1}return{boardSize:t*e,width:t,height:e,C:i,R:r,POS:a,Graph:s,PosName:n,PosByName:o,CompactCrit:h,GetDistances:c,distEdge:function(){for(var a=[],s=0;s<t*e;s++){var n=i(s),o=r(s);a[s]=Math.min(n,Math.abs(t-n-1),o,Math.abs(e-o-1))}return a}(),corners:function(){var i={};return i[a(0,0)]=1,i[a(0,e-1)]=1,i[a(t-1,0)]=1,i[a(t-1,e-1)]=1,i}(),ExportBoardState:p}},Model.Game.cbPawnGraph=function(t,e,i){for(var r=this,a={},s=0;s<t.boardSize;s++)if(!i||s in i){var n=[],o=t.Graph(s,[0,e]);null!=o&&(!i||o in i)&&n.push(r.cbTypedArray([o|r.cbConstants.FLAG_MOVE])),[-1,1].forEach(function(a){var o=t.Graph(s,[a,e]);null!=o&&(!i||o in i)&&n.push(r.cbTypedArray([o|r.cbConstants.FLAG_CAPTURE]))}),a[s]=n}else a[s]=[];return a},Model.Game.cbInitialPawnGraph=function(t,e,i){for(var r=this,a={},s=0;s<t.boardSize;s++)if(!i||s in i){var n=[],o=t.Graph(s,[0,e]);if(null!=o&&(!i||o in i)){var h=[o|r.cbConstants.FLAG_MOVE],c=t.Graph(o,[0,e]);null!=c&&(!i||c in i)&&h.push(c|r.cbConstants.FLAG_MOVE),n.push(r.cbTypedArray(h))}[-1,1].forEach(function(a){var o=t.Graph(s,[a,e]);null!=o&&(!i||o in i)&&n.push(r.cbTypedArray([o|r.cbConstants.FLAG_CAPTURE]))}),a[s]=n}else a[s]=[];return a},Model.Game.cbKingGraph=function(t,e){return this.cbShortRangeGraph(t,[[-1,-1],[-1,0],[-1,1],[0,-1],[0,1],[1,-1],[1,0],[1,1]],e)},Model.Game.cbKnightGraph=function(t,e){return this.cbShortRangeGraph(t,[[2,-1],[2,1],[-2,-1],[-2,1],[-1,2],[-1,-2],[1,2],[1,-2]],e)},Model.Game.cbHorseGraph=function(t){for(var e=this,i={},r=0;r<t.boardSize;r++)i[r]=[],[[1,0,2,-1],[1,0,2,1],[-1,0,-2,-1],[-1,0,-2,1],[0,1,-1,2],[0,-1,-1,-2],[0,1,1,2],[0,-1,1,-2]].forEach(function(a){var s=t.Graph(r,[a[0],a[1]]);if(null!=s){var n=t.Graph(r,[a[2],a[3]]);null!=n&&i[r].push(e.cbTypedArray([s|e.cbConstants.FLAG_STOP,n|e.cbConstants.FLAG_MOVE|e.cbConstants.FLAG_CAPTURE]))}});return i},Model.Game.cbRookGraph=function(t,e){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0]],e)},Model.Game.cbBishopGraph=function(t,e){return this.cbLongRangeGraph(t,[[1,-1],[1,1],[-1,1],[-1,-1]],e)},Model.Game.cbQueenGraph=function(t,e){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0],[1,-1],[1,1],[-1,1],[-1,-1]],e)},Model.Game.cbXQGeneralGraph=function(t,e){for(var i=this,r={},a=0;a<t.boardSize;a++)r[a]=[],[[-1,0,!1],[0,-1,!0],[0,1,!0],[1,0,!1]].forEach(function(s){var n=[],o=t.Graph(a,s);if(null!=o&&((!e||o in e)&&n.push(o|i.cbConstants.FLAG_MOVE|i.cbConstants.FLAG_CAPTURE),s[2]))for(var h=t.Graph(o,s);null!=h;)!e||h in e?n.push(h|i.cbConstants.FLAG_CAPTURE|i.cbConstants.FLAG_CAPTURE_KING):n.push(h|i.cbConstants.FLAG_STOP),h=t.Graph(h,s);n.length>0&&r[a].push(i.cbTypedArray(n))});return r},Model.Game.cbXQSoldierGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e]])},Model.Game.cbXQPromoSoldierGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e],[-1,0],[1,0]])},Model.Game.cbXQAdvisorGraph=function(t,e){return this.cbShortRangeGraph(t,[[1,1],[-1,1],[1,-1],[-1,-1]],e)},Model.Game.cbXQCannonGraph=function(t){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0]],null,this.cbConstants.FLAG_MOVE|this.cbConstants.FLAG_SCREEN_CAPTURE)},Model.Game.cbXQElephantGraph=function(t,e){for(var i=this,r={},a=0;a<t.boardSize;a++)r[a]=[],(!e||a in e)&&[[1,1,2,2],[1,-1,2,-2],[-1,1,-2,2],[-1,-1,-2,-2]].forEach(function(s){var n=t.Graph(a,[s[0],s[1]]);if(null!=n){var o=t.Graph(a,[s[2],s[3]]);null!=o&&(!e||o in e)&&r[a].push(i.cbTypedArray([n|i.cbConstants.FLAG_STOP,o|i.cbConstants.FLAG_MOVE|i.cbConstants.FLAG_CAPTURE]))}});return r},Model.Game.cbSilverGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e],[-1,-1],[-1,1],[1,-1],[1,1]])},Model.Game.cbFersGraph=function(t,e){return this.cbShortRangeGraph(t,[[-1,-1],[-1,1],[1,-1],[1,1]])},Model.Game.cbSchleichGraph=function(t,e){return this.cbShortRangeGraph(t,[[-1,0],[1,0],[0,-1],[0,1]])},Model.Game.cbAlfilGraph=function(t,e){return this.cbShortRangeGraph(t,[[-2,-2],[-2,2],[2,2],[2,-2]])}}(),function(){var t=Model.Game.cbBoardGeometryGrid(12,8);Model.Game.cbDefine=function(){return{geometry:t,pieceTypes:{0:{name:"pawn-w",aspect:"cc-pawn",graph:this.cbPawnGraph(t,1),value:1,abbrev:"",fenAbbrev:"P",initial:[{s:1,p:36},{s:1,p:13},{s:1,p:14},{s:1,p:15},{s:1,p:16},{s:1,p:17},{s:1,p:42},{s:1,p:19},{s:1,p:20},{s:1,p:21},{s:1,p:22},{s:1,p:47}],epCatch:!0},1:{name:"pawn-b",aspect:"cc-pawn",graph:this.cbPawnGraph(t,-1),value:1,abbrev:"",fenAbbrev:"P",initial:[{s:-1,p:48},{s:-1,p:73},{s:-1,p:74},{s:-1,p:75},{s:-1,p:76},{s:-1,p:77},{s:-1,p:54},{s:-1,p:79},{s:-1,p:80},{s:-1,p:81},{s:-1,p:82},{s:-1,p:59}],epCatch:!0},2:{name:"cc-knight",graph:this.cbKnightGraph(t),value:3,abbrev:"N",initial:[{s:1,p:1},{s:1,p:10},{s:-1,p:85},{s:-1,p:94}]},3:{name:"cc-archer",graph:this.cbAlfilGraph(t),value:2,abbrev:"B",initial:[{s:1,p:2},{s:1,p:9},{s:-1,p:86},{s:-1,p:93}]},4:{name:"cc-rook",graph:this.cbRookGraph(t),value:5,abbrev:"R",initial:[{s:1,p:0},{s:1,p:11},{s:-1,p:84},{s:-1,p:95}],castle:!0},5:{name:"cc-queen",graph:this.cbFersGraph(t),value:2,abbrev:"Q",initial:[{s:1,p:30},{s:-1,p:66}]},6:{name:"cc-king",isKing:!0,graph:this.cbKingGraph(t),abbrev:"K",initial:[{s:1,p:5},{s:-1,p:89}]},7:{name:"cc-man",graph:this.cbKingGraph(t),value:3,abbrev:"M",initial:[{s:1,p:4},{s:-1,p:88}]},8:{name:"cc-schleich",graph:this.cbSchleichGraph(t),value:2,abbrev:"S",initial:[{s:1,p:7},{s:-1,p:91}]},9:{name:"cc-courier",graph:this.cbBishopGraph(t),value:3,abbrev:"C",initial:[{s:1,p:3},{s:1,p:8},{s:-1,p:87},{s:-1,p:92}]}},promote:function(e,i,r){return 0==i.t&&7==t.R(r.t)?[5]:1==i.t&&0==t.R(r.t)?[5]:[]},castle:{},evaluate:function(t,e,i){this.noCaptCount>=100&&(this.mFinished=!0,this.mWinner=JocGame.DRAW)}}}}();

/***/ }),

/***/ "Uqs8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var AsapAction_1 = __webpack_require__("TL2s");
var AsapScheduler_1 = __webpack_require__("1Cj3");
/**
 *
 * Asap Scheduler
 *
 * <span class="informal">Perform task as fast as it can be performed asynchronously</span>
 *
 * `asap` scheduler behaves the same as {@link async} scheduler when you use it to delay task
 * in time. If however you set delay to `0`, `asap` will wait for current synchronously executing
 * code to end and then it will try to execute given task as fast as possible.
 *
 * `asap` scheduler will do its best to minimize time between end of currently executing code
 * and start of scheduled task. This makes it best candidate for performing so called "deferring".
 * Traditionally this was achieved by calling `setTimeout(deferredTask, 0)`, but that technique involves
 * some (although minimal) unwanted delay.
 *
 * Note that using `asap` scheduler does not necessarily mean that your task will be first to process
 * after currently executing code. In particular, if some task was also scheduled with `asap` before,
 * that task will execute first. That being said, if you need to schedule task asynchronously, but
 * as soon as possible, `asap` scheduler is your best bet.
 *
 * @example <caption>Compare async and asap scheduler</caption>
 *
 * Rx.Scheduler.async.schedule(() => console.log('async')); // scheduling 'async' first...
 * Rx.Scheduler.asap.schedule(() => console.log('asap'));
 *
 * // Logs:
 * // "asap"
 * // "async"
 * // ... but 'asap' goes first!
 *
 * @static true
 * @name asap
 * @owner Scheduler
 */
exports.asap = new AsapScheduler_1.AsapScheduler(AsapAction_1.AsapAction);
//# sourceMappingURL=asap.js.map

/***/ }),

/***/ "UyzR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var switch_1 = __webpack_require__("XvGf");
Observable_1.Observable.prototype.switch = switch_1._switch;
Observable_1.Observable.prototype._switch = switch_1._switch;
//# sourceMappingURL=switch.js.map

/***/ }),

/***/ "VDSN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_add_operator_map__ = __webpack_require__("+pb+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_add_operator_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs_add_operator_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_add_operator_filter__ = __webpack_require__("wUn1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_add_operator_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs_add_operator_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_object_extend__ = __webpack_require__("xZ/u");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return KeyOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ResponsiveActivation; });



var KeyOptions = (function () {
    function KeyOptions(baseKey, defaultValue, inputKeys) {
        this.baseKey = baseKey;
        this.defaultValue = defaultValue;
        this.inputKeys = inputKeys;
    }
    return KeyOptions;
}());

/**
 * ResponsiveActivation acts as a proxy between the MonitorMedia service (which emits mediaQuery
 * changes) and the fx API directives. The MQA proxies mediaQuery change events and notifies the
 * directive via the specified callback.
 *
 * - The MQA also determines which directive property should be used to determine the
 *   current change 'value'... BEFORE the original `onMediaQueryChanges()` method is called.
 * - The `ngOnDestroy()` method is also head-hooked to enable auto-unsubscribe from the
 *   MediaQueryServices.
 *
 * NOTE: these interceptions enables the logic in the fx API directives to remain terse and clean.
 */
var ResponsiveActivation = (function () {
    /**
     * Constructor
     */
    function ResponsiveActivation(_options, _mediaMonitor, _onMediaChanges) {
        this._options = _options;
        this._mediaMonitor = _mediaMonitor;
        this._onMediaChanges = _onMediaChanges;
        this._subscribers = [];
        this._subscribers = this._configureChangeObservers();
    }
    Object.defineProperty(ResponsiveActivation.prototype, "mediaMonitor", {
        /**
         * Accessor to the DI'ed directive property
         * Each directive instance has a reference to the MediaMonitor which is
         * used HERE to subscribe to mediaQuery change notifications.
         */
        get: function () {
            return this._mediaMonitor;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ResponsiveActivation.prototype, "activatedInputKey", {
        /**
         * Determine which directive @Input() property is currently active (for the viewport size):
         * The key must be defined (in use) or fallback to the 'closest' overlapping property key
         * that is defined; otherwise the default property key will be used.
         * e.g.
         *      if `<div fxHide fxHide.gt-sm="false">` is used but the current activated mediaQuery alias
         *      key is `.md` then `.gt-sm` should be used instead
         */
        get: function () {
            return this._activatedInputKey || this._options.baseKey;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ResponsiveActivation.prototype, "activatedInput", {
        /**
         * Get the currently activated @Input value or the fallback default @Input value
         */
        get: function () {
            var key = this.activatedInputKey;
            return this.hasKeyValue(key) ? this._lookupKeyValue(key) : this._options.defaultValue;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Fast validator for presence of attribute on the host element
     */
    ResponsiveActivation.prototype.hasKeyValue = function (key) {
        var value = this._options.inputKeys[key];
        return typeof value !== 'undefined';
    };
    /**
     * Remove interceptors, restore original functions, and forward the onDestroy() call
     */
    ResponsiveActivation.prototype.destroy = function () {
        this._subscribers.forEach(function (link) {
            link.unsubscribe();
        });
        this._subscribers = [];
    };
    /**
     * For each *defined* API property, register a callback to `_onMonitorEvents( )`
     * Cache 1..n subscriptions for internal auto-unsubscribes when the the directive destructs
     */
    ResponsiveActivation.prototype._configureChangeObservers = function () {
        var _this = this;
        var subscriptions = [];
        this._buildRegistryMap().forEach(function (bp) {
            if (_this._keyInUse(bp.key)) {
                // Inject directive default property key name: to let onMediaChange() calls
                // know which property is being triggered...
                var buildChanges = function (change) {
                    change = change.clone();
                    change.property = _this._options.baseKey;
                    return change;
                };
                subscriptions.push(_this.mediaMonitor.observe(bp.alias)
                    .map(buildChanges)
                    .subscribe(function (change) {
                    _this._onMonitorEvents(change);
                }));
            }
        });
        return subscriptions;
    };
    /**
     * Build mediaQuery key-hashmap; only for the directive properties that are actually defined/used
     * in the HTML markup
     */
    ResponsiveActivation.prototype._buildRegistryMap = function () {
        var _this = this;
        return this.mediaMonitor.breakpoints
            .map(function (bp) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_object_extend__["a" /* extendObject */])({}, bp, {
                baseKey: _this._options.baseKey,
                key: _this._options.baseKey + bp.suffix // e.g.  layoutGtSm, layoutMd, layoutGtLg
            });
        })
            .filter(function (bp) { return _this._keyInUse(bp.key); });
    };
    /**
     * Synchronizes change notifications with the current mq-activated @Input and calculates the
     * mq-activated input value or the default value
     */
    ResponsiveActivation.prototype._onMonitorEvents = function (change) {
        if (change.property == this._options.baseKey) {
            change.value = this._calculateActivatedValue(change);
            this._onMediaChanges(change);
        }
    };
    /**
     * Has the key been specified in the HTML markup and thus is intended
     * to participate in activation processes.
     */
    ResponsiveActivation.prototype._keyInUse = function (key) {
        return this._lookupKeyValue(key) !== undefined;
    };
    /**
     *  Map input key associated with mediaQuery activation to closest defined input key
     *  then return the values associated with the targeted input property
     *
     *  !! change events may arrive out-of-order (activate before deactivate)
     *     so make sure the deactivate is used ONLY when the keys match
     *     (since a different activate may be in use)
     */
    ResponsiveActivation.prototype._calculateActivatedValue = function (current) {
        var currentKey = this._options.baseKey + current.suffix; // e.g. suffix == 'GtSm',
        var newKey = this._activatedInputKey; // e.g. newKey == hideGtSm
        newKey = current.matches ? currentKey : ((newKey == currentKey) ? null : newKey);
        this._activatedInputKey = this._validateInputKey(newKey);
        return this.activatedInput;
    };
    /**
     * For the specified input property key, validate it is defined (used in the markup)
     * If not see if a overlapping mediaQuery-related input key fallback has been defined
     *
     * NOTE: scans in the order defined by activeOverLaps (largest viewport ranges -> smallest ranges)
     */
    ResponsiveActivation.prototype._validateInputKey = function (inputKey) {
        var _this = this;
        var items = this.mediaMonitor.activeOverlaps;
        var isMissingKey = function (key) { return !_this._keyInUse(key); };
        if (isMissingKey(inputKey)) {
            items.some(function (bp) {
                var key = _this._options.baseKey + bp.suffix;
                if (!isMissingKey(key)) {
                    inputKey = key;
                    return true; // exit .some()
                }
                return false;
            });
        }
        return inputKey;
    };
    /**
     * Get the value (if any) for the directive instances @Input property (aka key)
     */
    ResponsiveActivation.prototype._lookupKeyValue = function (key) {
        return this._options.inputKeys[key];
    };
    return ResponsiveActivation;
}());

//# sourceMappingURL=responsive-activation.js.map

/***/ }),

/***/ "VEfc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var OuterSubscriber_1 = __webpack_require__("wAkD");
var subscribeToResult_1 = __webpack_require__("CURp");
/* tslint:enable:max-line-length */
/**
 * Projects each source value to an Observable which is merged in the output
 * Observable, emitting values only from the most recently projected Observable.
 *
 * <span class="informal">Maps each value to an Observable, then flattens all of
 * these inner Observables using {@link switch}.</span>
 *
 * <img src="./img/switchMap.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an (so-called "inner") Observable. Each time it observes one of these
 * inner Observables, the output Observable begins emitting the items emitted by
 * that inner Observable. When a new inner Observable is emitted, `switchMap`
 * stops emitting items from the earlier-emitted inner Observable and begins
 * emitting items from the new one. It continues to behave like this for
 * subsequent inner Observables.
 *
 * @example <caption>Rerun an interval Observable on every click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.switchMap((ev) => Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link concatMap}
 * @see {@link exhaustMap}
 * @see {@link mergeMap}
 * @see {@link switch}
 * @see {@link switchMapTo}
 *
 * @param {function(value: T, ?index: number): ObservableInput} project A function
 * that, when applied to an item emitted by the source Observable, returns an
 * Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} An Observable that emits the result of applying the
 * projection function (and the optional `resultSelector`) to each item emitted
 * by the source Observable and taking only the values from the most recently
 * projected inner Observable.
 * @method switchMap
 * @owner Observable
 */
function switchMap(project, resultSelector) {
    return this.lift(new SwitchMapOperator(project, resultSelector));
}
exports.switchMap = switchMap;
var SwitchMapOperator = (function () {
    function SwitchMapOperator(project, resultSelector) {
        this.project = project;
        this.resultSelector = resultSelector;
    }
    SwitchMapOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new SwitchMapSubscriber(subscriber, this.project, this.resultSelector));
    };
    return SwitchMapOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var SwitchMapSubscriber = (function (_super) {
    __extends(SwitchMapSubscriber, _super);
    function SwitchMapSubscriber(destination, project, resultSelector) {
        _super.call(this, destination);
        this.project = project;
        this.resultSelector = resultSelector;
        this.index = 0;
    }
    SwitchMapSubscriber.prototype._next = function (value) {
        var result;
        var index = this.index++;
        try {
            result = this.project(value, index);
        }
        catch (error) {
            this.destination.error(error);
            return;
        }
        this._innerSub(result, value, index);
    };
    SwitchMapSubscriber.prototype._innerSub = function (result, value, index) {
        var innerSubscription = this.innerSubscription;
        if (innerSubscription) {
            innerSubscription.unsubscribe();
        }
        this.add(this.innerSubscription = subscribeToResult_1.subscribeToResult(this, result, value, index));
    };
    SwitchMapSubscriber.prototype._complete = function () {
        var innerSubscription = this.innerSubscription;
        if (!innerSubscription || innerSubscription.closed) {
            _super.prototype._complete.call(this);
        }
    };
    SwitchMapSubscriber.prototype._unsubscribe = function () {
        this.innerSubscription = null;
    };
    SwitchMapSubscriber.prototype.notifyComplete = function (innerSub) {
        this.remove(innerSub);
        this.innerSubscription = null;
        if (this.isStopped) {
            _super.prototype._complete.call(this);
        }
    };
    SwitchMapSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        if (this.resultSelector) {
            this._tryNotifyNext(outerValue, innerValue, outerIndex, innerIndex);
        }
        else {
            this.destination.next(innerValue);
        }
    };
    SwitchMapSubscriber.prototype._tryNotifyNext = function (outerValue, innerValue, outerIndex, innerIndex) {
        var result;
        try {
            result = this.resultSelector(outerValue, innerValue, outerIndex, innerIndex);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return SwitchMapSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=switchMap.js.map

/***/ }),

/***/ "VOfZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {
/**
 * window: browser in DOM main thread
 * self: browser in WebWorker
 * global: Node.js/other
 */
exports.root = (typeof window == 'object' && window.window === window && window
    || typeof self == 'object' && self.self === self && self
    || typeof global == 'object' && global.global === global && global);
if (!exports.root) {
    throw new Error('RxJS could not find any global context (window, self, global)');
}
//# sourceMappingURL=root.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("DuR2")))

/***/ }),

/***/ "VQlU":
/***/ (function(module, exports) {

exports.config = {"status":true,"model":{"plazza":"true","released":1403189777,"title-en":"De Vasa Chess","module":"chessbase","summary":"Hexagonal Chess","thumbnail":"devasa-thumb.png","rules":{"en":"devasa-rules.html"},"credits":{"en":"devasa-credits.html"},"gameOptions":{"preventRepeat":true,"uctTransposition":"state","uctIgnoreLoop":false,"levelOptions":{"pieceValueFactor":1,"pieceValueRatioFactor":1,"posValueFactor":0.1,"averageDistKingFactor":-0.01,"castleFactor":0.1,"minorPiecesMovedFactor":0.1,"checkFactor":0.2,"endingKingFreedomFactor":0.01,"endingDistKingFactor":0.05,"distKingCornerFactor":0.1,"distPawnPromo1Factor":0.3,"distPawnPromo2Factor":0.1,"distPawnPromo3Factor":0.05}},"obsolete":false,"js":["base-model.js","hex-geo-model.js","devasa-model.js"],"description":{"en":"devasa-description.html"},"levels":[{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"easy","label":"Easy","maxNodes":6000},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"fast","label":"Fast [3sec]","maxDuration":3,"isDefault":true},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"medium","label":"Medium","maxNodes":30000,"maxDuration":30},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"strong","label":"Strong","maxNodes":60000,"maxDuration":45}]},"view":{"title-en":"Chessbase view","module":"chessbase","xdView":true,"css":["chessbase.css","hex.css"],"preferredRatio":1.154700538,"useShowMoves":true,"useNotation":true,"useAutoComplete":true,"defaultOptions":{"sounds":true,"moves":true,"notation":false,"autocomplete":false},"skins":[{"name":"skin3d","title":"3D Classic","3d":true,"preload":["smoothedfilegeo|0|/res/ring-target-hexagon.js","image|/res/images/cancel.png","image|/res/images/wikipedia.png","smoothedfilegeo|0|/res/staunton/pawn/pawn-classic.js","image|/res/staunton/pawn/pawn-diffusemap.jpg","image|/res/staunton/pawn/pawn-normalmap.jpg","smoothedfilegeo|0|/res/staunton/knight/knight.js","image|/res/staunton/knight/knight-diffusemap.jpg","image|/res/staunton/knight/knight-normalmap.jpg","smoothedfilegeo|0|/res/staunton/bishop/bishop.js","image|/res/staunton/bishop/bishop-diffusemap.jpg","image|/res/staunton/bishop/bishop-normalmap.jpg","smoothedfilegeo|0|/res/staunton/rook/rook.js","image|/res/staunton/rook/rook-diffusemap.jpg","image|/res/staunton/rook/rook-normalmap.jpg","smoothedfilegeo|0|/res/staunton/queen/queen.js","image|/res/staunton/queen/queen-diffusemap.jpg","image|/res/staunton/queen/queen-normalmap.jpg","smoothedfilegeo|0|/res/staunton/king/king.js","image|/res/staunton/king/king-diffusemap.jpg","image|/res/staunton/king/king-normalmap.jpg"],"world":{"lightIntensity":1.3,"skyLightIntensity":1.2,"lightCastShadow":true,"fog":false,"color":4686804,"lightPosition":{"x":-9,"y":9,"z":9},"skyLightPosition":{"x":9,"y":9,"z":9},"lightShadowDarkness":0.55,"ambientLightColor":2236962},"camera":{"fov":45,"distMax":50,"radius":14.5,"elevationAngle":45,"elevationMin":0,"distMin":0,"rotationAngle":80}},{"name":"skin2d","title":"2D Classic","3d":false,"preload":["image|/res/images/wikipedia.png","image|/res/images/whitebg.png","image|/res/images/cancel.png"]}],"animateSelfMoves":false,"switchable":true,"sounds":{"move1":"alq_move1","move2":"alq_move2","move3":"alq_move3","move4":"alq_move2","tac1":"alq_tac1","tac2":"alq_tac2","tac3":"alq_tac1","promo":"promo","usermove":null},"js":["base-view.js","hex-board-view.js","staunton-set-view.js","devasa-view.js"],"visuals":{"600x600":["res/visuals/devasa-600x600-3d.jpg","res/visuals/devasa-600x600-2d.jpg"]}}}

/***/ }),

/***/ "VQzz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("3j3K");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DockComponent; });

var DockComponent = (function () {
    function DockComponent() {
        this.position = 'right';
        this.size = 0.3;
        this.visible = true;
    }
    Object.defineProperty(DockComponent.prototype, "absoluteSize", {
        get: function () {
            return 100 * this.size + "%";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DockComponent.prototype, "restSize", {
        get: function () {
            return (100 - (100 * this.size)) + "%";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DockComponent.prototype, "leftPosition", {
        get: function () {
            return this.calculatePosition('left', 'right');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DockComponent.prototype, "rightPosition", {
        get: function () {
            return this.calculatePosition('right', 'left');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DockComponent.prototype, "topPosition", {
        get: function () {
            return this.calculatePosition('top', 'bottom');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DockComponent.prototype, "bottomPosition", {
        get: function () {
            return this.calculatePosition('bottom', 'top');
        },
        enumerable: true,
        configurable: true
    });
    DockComponent.prototype.calculatePosition = function (primary, secondary) {
        if (this.visible) {
            switch (this.position) {
                case secondary:
                    return this.restSize;
                default:
                    return '0%';
            }
        }
        else {
            switch (this.position) {
                case primary:
                    return "-" + this.absoluteSize;
                case secondary:
                    return '100%';
                default:
                    return '0%';
            }
        }
    };
    DockComponent.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{
                    selector: 'ngrx-dock',
                    template: "\n    <div class=\"dock\">\n      <div class=\"dock-content\">\n        <ng-content></ng-content>\n      </div>\n    </div>\n  ",
                    styles: ["\n    :host {\n      position: fixed;\n      top: 0;\n      left: 0;\n      right: 0;\n      bottom: 0;\n      transition: all 0.3s;\n      z-index: 9999;\n    }\n\n    .dock {\n      position: absolute;\n      z-index: 1;\n      box-shadow: 0 0 4px rgba(0, 0, 0, 0.3);\n      background-color: white;\n      left: 0;\n      top: 0;\n      width: 100%;\n      height: 100%;\n    }\n\n    .dock-content {\n      width: 100%;\n      height: 100%;\n      overflow: auto;\n    }\n  "]
                },] },
    ];
    /** @nocollapse */
    DockComponent.ctorParameters = [];
    DockComponent.propDecorators = {
        'position': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'size': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'visible': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'leftPosition': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["HostBinding"], args: ['style.left',] },],
        'rightPosition': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["HostBinding"], args: ['style.right',] },],
        'topPosition': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["HostBinding"], args: ['style.top',] },],
        'bottomPosition': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["HostBinding"], args: ['style.bottom',] },],
    };
    return DockComponent;
}());
//# sourceMappingURL=dock.js.map

/***/ }),

/***/ "VaQ6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var skipWhile_1 = __webpack_require__("sake");
Observable_1.Observable.prototype.skipWhile = skipWhile_1.skipWhile;
//# sourceMappingURL=skipWhile.js.map

/***/ }),

/***/ "VfeM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var mergeMapTo_1 = __webpack_require__("iESu");
Observable_1.Observable.prototype.flatMapTo = mergeMapTo_1.mergeMapTo;
Observable_1.Observable.prototype.mergeMapTo = mergeMapTo_1.mergeMapTo;
//# sourceMappingURL=mergeMapTo.js.map

/***/ }),

/***/ "VnU3":
/***/ (function(module, exports) {

exports.model=Model={Game:{},Board:{},Move:{}},function(){var t;Model.Game.cbConstants={MASK:65535,FLAG_MOVE:65536,FLAG_CAPTURE:131072,FLAG_STOP:262144,FLAG_SCREEN_CAPTURE:524288,FLAG_CAPTURE_KING:1048576,FLAG_CAPTURE_NO_KING:2097152};var e="undefined"!=typeof Int32Array;Model.Game.cbUseTypedArrays=e,Model.Game.cbTypedArray=function(t){if(e){var r=new Int32Array(t.length);return r.set(t),r}for(var i=[],a=t.length,n=0;n<a;n++)i.push(t[n]);return i},Model.Game.cbShortRangeGraph=function(t,e,r,i){var a=this;void 0===i&&(i=196608);for(var n={},s=0;s<t.boardSize;s++)n[s]=[],(!r||s in r)&&e.forEach(function(e){var o=t.Graph(s,e);null!=o&&(!r||o in r)&&n[s].push(a.cbTypedArray([o|i]))});return n},Model.Game.cbLongRangeGraph=function(t,e,r,i,a){var n=this;void 0!==i&&null!=i||(i=196608),a||(a=1/0);for(var s={},o=0;o<t.boardSize;o++)s[o]=[],(!r||o in r)&&e.forEach(function(e){for(var h=[],c=t.Graph(o,e),p=0;null!=c&&(!r||c in r)&&(h.push(c|i),++p!=a);)c=t.Graph(c,e);h.length>0&&s[o].push(n.cbTypedArray(h))});return s},Model.Game.cbNullGraph=function(t){for(var e={},r=0;r<t.boardSize;r++)e[r]=[];return e},Model.Game.cbAuthorGraph=function(t){for(var e={},r=0;r<t.boardSize;r++){e[r]=[];for(var i=0;i<t.boardSize;i++)e[r].push([2293760|i])}return e},Model.Game.cbMergeGraphs=function(t){for(var e=[],r=0;r<t.boardSize;r++){e[r]=[];for(var i=1;i<arguments.length;i++)e[r]=e[r].concat(arguments[i][r])}return e},Model.Game.cbGetThreatGraph=function(){function t(e,r){for(var i in s){var a=s[i];if(!(a.p.length<r.length+1)){for(var n=!0,o=0;o<r.length;o++)if(r[o]!=a.p[o]){n=!1;break}if(n){var h=a.p[r.length],c=e[h];void 0===c&&(c={e:{}},e[h]=c),a.p.length==r.length+1&&(c.t=a.t,c.ts=a.ts,c.tk=a.tk,delete s[i]),r.push(h),t(c.e,r),r.pop()}}}}var e=this;this.cbUseScreenCapture=!1,this.cbUseCaptureKing=!1,this.cbUseCaptureNoKing=!1;for(var r={1:[],"-1":[]},i=[],a=0;a<this.g.boardSize;a++)this.g.pTypes.forEach(function(t,r){t.graph[a].forEach(function(t){for(var n=[],s=0;s<t.length;s++){var o=t[s];1048576&o?(e.cbUseCaptureKing=!0,n.unshift({d:65535&o,a:a,tk:r})):2097152&o?(e.cbUseCaptureNoKing=!0,n.unshift({d:65535&o,a:a,tnk:r})):131072&o?n.unshift({d:65535&o,a:a,t:r}):262144&o?n.unshift({d:65535&o,a:a}):524288&o&&(e.cbUseScreenCapture=!0,n.unshift({d:65535&o,a:a,ts:r}))}n.length>0&&i.push(n)})});var n={};i.forEach(function(t){t.forEach(function(e,r){var i=n[e.d];void 0===i&&(i={},n[e.d]=i);for(var a=[],s=r+1;s<t.length;s++)a.push(t[s].d);a.push(e.a);var o=a.join(","),h=i[o];void 0===h&&(h={p:a,t:{},ts:{},tk:{}},i[o]=h),void 0!==e.t?h.t[e.t]=!0:void 0!==e.tk?h.tk[e.tk]=!0:void 0!==e.ts&&(h.ts[e.ts]=!0)})});for(var a=0;a<e.g.boardSize;a++){var s=n[a],o={};t(o,[]),r[1][a]=o,r[-1][a]=o}return r},Model.Game.InitGame=function(){var e=this;this.cbVar=t=this.cbDefine(),this.g.boardSize=this.cbVar.geometry.boardSize,this.g.pTypes=this.cbGetPieceTypes(),this.g.threatGraph=this.cbGetThreatGraph(),this.g.distGraph=this.cbVar.geometry.GetDistances(),this.cbPiecesCount=0,this.g.castleablePiecesCount={1:0,"-1":0};for(var r in t.pieceTypes){var i=t.pieceTypes[r];if(i.castle){(i.initial||[]).forEach(function(t){e.g.castleablePiecesCount[t.s]++})}i.initial&&(this.cbPiecesCount+=i.initial.length)}for(var a=[],r=0;r<this.cbPiecesCount;r++)a.push(r);var n=Object.keys(t.pieceTypes);this.zobrist=new JocGame.Zobrist({board:{type:"array",size:this.cbVar.geometry.boardSize,values:a},who:{values:["1","-1"]},type:{type:"array",size:this.cbPiecesCount,values:n}})},Model.Game.cbGetPieceTypes=function(){for(var t=[],e={},r=0;r<this.cbVar.geometry.boardSize;r++)e[r]=[];for(var i in this.cbVar.pieceTypes){var a=this.cbVar.pieceTypes[i];t[i]={graph:a.graph||e,abbrev:a.abbrev||"",value:a.isKing?100:a.value||1,isKing:!!a.isKing,castle:!!a.castle,epTarget:!!a.epTarget,epCatch:!!a.epCatch}}return t},Model.Board.Init=function(t){this.zSign=0},Model.Board.InitialPosition=function(r){var i=this;this.board=e?new Int16Array(r.g.boardSize):[];for(var a=0;a<r.g.boardSize;a++)this.board[a]=-1;if(this.kings={},this.pieces=[],this.ending={1:!1,"-1":!1},this.lastMove=null,r.cbVar.castle&&(this.castled={1:!1,"-1":!1}),this.zSign=r.zobrist.update(0,"who",-1),this.noCaptCount=0,this.mWho=1,r.mInitial)this.mWho=r.mInitial.turn||1,r.mInitial.pieces.forEach(function(t){var e={};for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);i.pieces.push(e)}),r.mInitial.lastMove&&(this.lastMove={f:r.mInitial.lastMove.f,t:r.mInitial.lastMove.t}),void 0!==r.mInitial.noCaptCount&&(this.noCaptCount=r.mInitial.noCaptCount),r.cbVar.castle&&r.mInitial.castle&&(this.castled={1:{k:!!r.mInitial.castle[1]&&!!r.mInitial.castle[1].k,q:!!r.mInitial.castle[1]&&!!r.mInitial.castle[1].q},"-1":{k:!!r.mInitial.castle[-1]&&!!r.mInitial.castle[-1].k,q:!!r.mInitial.castle[-1]&&!!r.mInitial.castle[-1].q}});else for(var n in r.cbVar.pieceTypes)for(var s=r.cbVar.pieceTypes[n],o=s.initial||[],h=0;h<o.length;h++){var c=o[h],p={s:c.s,t:parseInt(n),p:c.p,m:!1};this.pieces.push(p)}if(this.pieces.sort(function(t,e){if(t.s!=e.s)return e.s-t.s;var i=r.cbVar.pieceTypes[t.t].value||100,a=r.cbVar.pieceTypes[e.t].value||100;return i!=a?i-a:t.p-e.p}),this.pieces.forEach(function(t,e){t.i=e,i.board[t.p]=e,r.g.pTypes[t.t].isKing&&(i.kings[t.s]=t.p),i.zSign=r.zobrist.update(i.zSign,"board",e,t.p),i.zSign=r.zobrist.update(i.zSign,"type",t.t,e)}),r.mInitial&&r.mInitial.enPassant){var a=t.geometry.PosByName(r.mInitial.enPassant);if(a>=0){var l,u=t.geometry.C(a),v=t.geometry.R(a);l=1==r.mInitial.turn?t.geometry.POS(u,v-1):t.geometry.POS(u,v+1),this.epTarget={p:a,i:this.board[l]}}}},Model.Board.CopyFrom=function(t){if(e)this.board=new Int16Array(t.board.length),this.board.set(t.board);else{this.board=[];for(var r=t.board,i=r.length,a=0;a<i;a++)this.board.push(r[a])}this.pieces=[];for(var n=t.pieces.length,a=0;a<n;a++){var s=t.pieces[a];this.pieces.push({s:s.s,p:s.p,t:s.t,i:s.i,m:s.m})}this.kings={1:t.kings[1],"-1":t.kings[-1]},this.check=t.check,t.lastMove?this.lastMove={f:t.lastMove.f,t:t.lastMove.t,c:t.lastMove.c}:this.lastMove=null,this.ending={1:t.ending[1],"-1":t.ending[-1]},void 0!==t.castled&&(this.castled={1:t.castled[1],"-1":t.castled[-1]}),this.noCaptCount=t.noCaptCount,t.epTarget?this.epTarget={p:t.epTarget.p,i:t.epTarget.i}:this.epTarget=null,this.mWho=t.mWho,this.zSign=t.zSign},Model.Board.cbApplyCastle=function(t,e,r){var i=t.cbVar.castle[e.f+"/"+e.cg],a=i.r[i.r.length-1],n=this.pieces[this.board[e.cg]],s=i.k[i.k.length-1],o=this.pieces[this.board[e.f]];return r&&(this.zSign=t.zobrist.update(this.zSign,"board",n.i,e.cg),this.zSign=t.zobrist.update(this.zSign,"board",n.i,a),this.zSign=t.zobrist.update(this.zSign,"board",o.i,e.f),this.zSign=t.zobrist.update(this.zSign,"board",o.i,s)),n.p=a,n.m=!0,this.board[e.cg]=-1,o.p=s,o.m=!0,this.board[e.f]=-1,this.board[a]=n.i,this.board[s]=o.i,this.castled[n.s]=!0,this.kings[o.s]=s,[{i:n.i,f:a,t:-1},{i:o.i,f:s,t:e.f,kp:e.f,who:o.s,m:!1},{i:n.i,f:-1,t:e.cg,m:!1,cg:!1}]},Model.Board.cbQuickApply=function(t,e){if(void 0!==e.cg)return this.cbApplyCastle(t,e,!1);var r=[],i=this.board[e.f],a=this.pieces[i];if(null!=e.c){r.unshift({i:e.c,f:-1,t:this.pieces[e.c].p});var n=this.pieces[e.c];this.board[n.p]=-1,n.p=-1}var s=this.kings[a.s];return t.g.pTypes[a.t].isKing&&(this.kings[a.s]=e.t),r.unshift({i:i,f:e.t,t:e.f,kp:s,who:a.s,ty:a.t}),a.p=e.t,void 0!==e.pr&&(a.t=e.pr),this.board[e.f]=-1,this.board[e.t]=i,r},Model.Board.cbQuickUnapply=function(t,e){for(var r=0;r<e.length;r++){var i=e[r],a=this.pieces[i.i];i.f>=0&&(a.p=-1,this.board[i.f]=-1),i.t>=0&&(a.p=i.t,this.board[i.t]=i.i),void 0!==i.m&&(a.m=i.m),void 0!==i.kp&&(this.kings[i.who]=i.kp),void 0!=i.ty&&(a.t=i.ty),void 0!=i.cg&&(this.castled[a.s]=i.cg)}},Model.Board.ApplyMove=function(t,e){var r=this.pieces[this.board[e.f]];if(void 0!==e.cg)this.cbApplyCastle(t,e,!0);else{if(this.zSign=t.zobrist.update(this.zSign,"board",r.i,e.f),this.board[r.p]=-1,void 0!==e.pr&&(this.zSign=t.zobrist.update(this.zSign,"type",r.t,r.i),r.t=e.pr,this.zSign=t.zobrist.update(this.zSign,"type",r.t,r.i)),null!=e.c){var i=this.pieces[e.c];this.zSign=t.zobrist.update(this.zSign,"board",i.i,i.p),this.board[i.p]=-1,i.p=-1,i.m=!0,this.noCaptCount=0}else this.noCaptCount++;r.p=e.t,r.m=!0,this.board[e.t]=r.i,this.zSign=t.zobrist.update(this.zSign,"board",r.i,e.t),t.g.pTypes[r.t].isKing&&(this.kings[r.s]=e.t)}this.check=!!e.ck,this.lastMove={f:e.f,t:e.t,c:e.c},void 0!==e.ko&&(this.ending[r.s]=e.ko),void 0!==e.ept?this.epTarget={p:e.ept,i:r.i}:this.epTarget=null,this.zSign=t.zobrist.update(this.zSign,"who",-this.mWho),this.zSign=t.zobrist.update(this.zSign,"who",this.mWho)},Model.Board.Evaluate=function(r){function i(e){var r=1/0;for(var i in t.geometry.corners)r=Math.min(r,h.distGraph[n.kings[e]][i]);return r-Math.sqrt(h.boardSize)}var a="debug"==arguments[3],n=this;this.mEvaluation=0;var s,o=this.mWho,h=r.g;if(e)s={1:{count:new Uint8Array(h.pTypes.length),byType:{}},"-1":{count:new Uint8Array(h.pTypes.length),byType:{}}};else{s={1:{count:[],byType:{}},"-1":{count:[],byType:{}}};for(var c=0;c<h.pTypes.length;c++)s[1].count[c]=s[-1].count[c]=0}if(r.mOptions.preventRepeat&&r.GetRepeatOccurence(this)>2)return this.mFinished=!0,void(this.mWinner=r.cbOnPerpetual?o*r.cbOnPerpetual:JocGame.DRAW);for(var p={1:0,"-1":0},l={1:h.distGraph[this.kings[-1]],"-1":h.distGraph[this.kings[1]]},u={1:0,"-1":0},v={1:0,"-1":0},b={1:0,"-1":0},f={1:0,"-1":0},d={1:!1,"-1":!1},g=this.pieces,m=g.length,c=0;c<m;c++){var G=g[c];if(G.p>=0){var y=G.s,M=h.pTypes[G.t];M.isKing?d[y]=G.m:p[y]+=M.value,M.castle&&!G.m&&f[y]++,v[y]++,u[y]+=l[y][G.p],b[y]+=t.geometry.distEdge[G.p];var C=s[y];C.count[G.t]++;var S=C.byType;void 0===S[G.t]?S[G.t]=[G]:S[G.t].push(G)}}if(this.lastMove&&null!=this.lastMove.c){var G=this.pieces[this.board[this.lastMove.t]];p[-G.s]+=this.cbStaticExchangeEval(r,G.p,G.s,{piece:G})}var k={1:0,"-1":0},A={1:0,"-1":0},T={1:0,"-1":0};this.ending[1]&&(A[1]=(u[1]-Math.sqrt(h.boardSize))/v[1],t.geometry.corners&&(T[1]=i(1))),this.ending[-1]&&(A[-1]=(u[-1]-Math.sqrt(h.boardSize))/v[-1],t.geometry.corners&&(T[1]=i(-1)));var z={pieceValue:p[1]-p[-1],pieceValueRatio:(p[1]-p[-1])/(p[1]+p[-1]+1),posValue:b[1]-b[-1],averageDistKing:u[1]/v[1]-u[-1]/v[-1],check:this.check?-o:0,endingKingFreedom:k[1]-k[-1],endingDistKing:A[1]-A[-1],distKingCorner:T[1]-T[-1]};t.castle&&(z.castle=(this.castled[1]?1:d[1]?0:f[1]/(h.castleablePiecesCount[1]+1))-(this.castled[-1]?1:d[-1]?0:f[-1]/(h.castleablePiecesCount[-1]+1))),t.evaluate&&t.evaluate.call(this,r,z,s);var P=r.mOptions.levelOptions;for(var E in z){var w=z[E],R=P[E+"Factor"]||0,I=w*R;a&&console.log(E,"=",w,"*",R,"=>",I),this.mEvaluation+=I}a&&console.log("Evaluation",this.mEvaluation)},Model.Board.cbGeneratePseudoLegalMoves=function(t){function e(e,a){var n=t.cbVar.promote;if(!n)return void i.push(a);var s=n.call(r,t,e,a);if(null!=s)if(0==s.length)i.push(a);else if(1==s.length)a.pr=s[0],i.push(a);else for(var o=0;o<s.length;o++){var h=s[o];i.push({f:a.f,t:a.t,c:a.c,pr:h,ept:a.ept,ep:a.ep,a:a.a})}}for(var r=this,i=[],a=t.cbVar,n=this.mWho,s=!a.castle||this.check||this.castled[n]?null:[],o=-1,h=this.pieces.length,c=0;c<h;c++){var p=this.pieces[c];if(!(p.p<0||p.s!=n)){var l=t.g.pTypes[p.t];l.isKing&&(p.m?s=null:o=p),s&&l.castle&&!p.m&&s.push(p);var u,v;u=l.graph[p.p],v=u.length;for(var b=0;b<v;b++)for(var f=u[b],d=!1,g=f.length,m=null,G=0;G<g;G++){var y=f[G],M=65535&y,C=this.board[M];if(!(C<0)||l.epCatch&&this.epTarget&&this.epTarget.p==M){if(!(524288&y)){var S;S=C<0?this.pieces[this.epTarget.i]:this.pieces[C],!(S.s!=p.s&&131072&y)||1048576&y&&!t.g.pTypes[S.t].isKing||2097152&y&&t.g.pTypes[S.t].isKing||e(p,{f:p.p,t:M,c:S.i,a:l.abbrev,ep:C<0});break}if(d){var S=this.pieces[C];S.s!=p.s&&e(p,{f:p.p,t:M,c:S.i,a:l.abbrev});break}d=!0}else 65536&y&&0==d&&e(p,{f:p.p,t:M,c:null,a:l.abbrev,ept:null!=m&&l.epTarget?m:void 0});m=M}}}if(s)for(var c=0;c<s.length;c++){var k=s[c],A=t.cbVar.castle[o.p+"/"+k.p];if(A){for(var T=!0,b=0;b<A.r.length;b++){var z=A.r[b];if(this.board[z]>=0&&z!=o.p&&z!=k.p){T=!1;break}}if(T){for(var P=!0,b=0;b<A.k.length;b++){var z=A.k[b];if(this.board[z]>=0&&z!=k.p&&z!=o.p||this.cbGetAttackers(t,z,n).length>0){P=!1;break}}P&&i.push({f:o.p,t:A.k[A.k.length-1],c:null,cg:k.p})}}}return i},Model.Board.cbStaticExchangeEval=function(t,e,r,i){var a=0,n=this.cbGetSmallestAttacker(t,e,r);if(n){var s=this.mWho;this.mWho=n.s;var o=this.cbQuickApply(t,{f:n.p,t:e,c:i.piece.i}),h=t.g.pTypes[i.piece.t].value;i.piece=n,a=Math.max(0,h-this.cbStaticExchangeEval(t,e,-r,i)),this.cbQuickUnapply(t,o),this.mWho=s}return a},Model.Board.cbGetSmallestAttacker=function(t,e,r){var i=this.cbGetAttackers(t,e,r);if(0==i.length)return null;for(var a=1/0,n=null,s=i.length,o=0;o<s;o++){var h=i[o],c=t.g.pTypes[h.t].value;c<a&&(a=c,n=h)}return n},Model.Board.cbCollectAttackers=function(t,e,r,i){for(var a in e){var n=e[a],s=this.board[a];if(s<0)this.cbCollectAttackers(t,n.e,r,i);else{var o=this.pieces[s];o.s==-t&&(n.t&&o.t in n.t||i&&n.tk&&o.t in n.tk)&&r.push(o)}}},Model.Board.cbCollectAttackersScreen=function(t,e,r,i,a){for(var n in e){var s=e[n],o=this.board[n];if(o<0)this.cbCollectAttackersScreen(t,s.e,r,i,a);else{var h=this.pieces[o];!a&&h.s==-t&&(s.t&&h.t in s.t||i&&s.tk&&h.t in s.tk)?r.push(h):a?a&&h.s==-t&&s.ts&&h.t in s.ts&&r.push(h):this.cbCollectAttackersScreen(t,s.e,r,i,!0)}}},Model.Board.cbGetAttackers=function(t,e,r,i){var a=[];return t.cbUseScreenCapture?this.cbCollectAttackersScreen(r,t.g.threatGraph[r][e],a,i,!1):this.cbCollectAttackers(r,t.g.threatGraph[r][e],a,i),a},Model.Board.GenerateMoves=function(t){var e=this.cbGeneratePseudoLegalMoves(t);this.mMoves=[];for(var r=!0,i=this.kings[this.mWho],a=e.length,n=0;n<a;n++){var s=e[n],o=this.cbQuickApply(t,s);if(!(this.cbGetAttackers(t,this.kings[this.mWho],this.mWho,!0).length>0)){var h=this.cbGetAttackers(t,this.kings[-this.mWho],-this.mWho,!0).length>0;s.ck=h,this.mMoves.push(s),s.f!=i&&(r=!1)}this.cbQuickUnapply(t,o)}if(0==this.mMoves.length)this.mFinished=!0,this.mWinner=t.cbOnStaleMate?t.cbOnStaleMate*this.mWho:JocGame.DRAW,this.check&&(this.mWinner=-this.mWho);else if(this.ending[this.mWho]){if(!r)for(var n=0;n<this.mMoves.length;n++)this.mMoves[n].ko=!1}else if(!this.ending[this.mWho]&&r&&!this.check)for(var n=0;n<this.mMoves.length;n++)this.mMoves[n].ko=!0},Model.Board.GetSignature=function(){return this.zSign},Model.Move.Init=function(t){for(var e in t)t.hasOwnProperty(e)&&(this[e]=t[e])},Model.Move.Equals=function(t){return this.f==t.f&&this.t==t.t&&this.pr==t.pr},Model.Move.CopyFrom=function(t){this.Init(t)},Model.Move.ToString=function(e){var r=this;switch(e=e||"natural"){case"natural":return function(){var e;if(void 0!==r.cg?e=t.castle[r.f+"/"+r.cg].n:(e=r.a||"",e+=t.geometry.PosName(r.f),null==r.c?e+="-":e+="x",e+=t.geometry.PosName(r.t)),void 0!==r.pr){var i=t.pieceTypes[r.pr];i&&i.abbrev&&i.abbrev.length>0&&!i.silentPromo&&(e+="="+i.abbrev)}return r.ck&&(e+="+"),e}();case"engine":return function(){var e=t.geometry.PosName(r.f)+t.geometry.PosName(r.t);if(void 0!=r.pr){var i=t.pieceTypes[r.pr];i&&i.abbrev&&i.abbrev.length>0&&!i.silentPromo&&(e+=i.abbrev)}return e}();default:return"??"}},Model.Board.CompactMoveString=function(e,r,i){"function"!=typeof r.ToString&&(r=e.CreateMove(r));var a=r.ToString(),n=/^([A-Z]?)([a-z])([1-9][0-9]*)([-x])([a-z])([1-9][0-9]*)(.*?)$/.exec(a);if(!n)return a;var s=n[7];if(i||(i={}),i.value||(i.value=[]),0==i.value.length){var o=this.mMoves;this.mMoves&&0!=this.mMoves.length||this.GenerateMoves(e);for(var h=0;h<this.mMoves.length;h++){var c=this.mMoves[h];"function"!=typeof c.ToString&&(c=e.CreateMove(c)),i.value.push({str:c.ToString(),move:c})}this.mMoves=o}var p=[];if(i.value.forEach(function(t){var e=/^([A-Z]?[a-z][1-9][0-9]*[-x][a-z][1-9][0-9]*)(.*?)$/.exec(t.str);e&&t.move.t==r.t&&(t.move.a||"")==n[1]&&e[2]==s&&p.push(t.move)}),1==p.length)return""==n[1]&&"x"==n[4]?n[2]+"x"+n[5]+n[6]+n[7]:n[1]+("x"==n[4]?"x":"")+n[5]+n[6]+n[7];if(t.geometry.CompactCrit)for(var l="",h=0;;h++){var u=t.geometry.CompactCrit(r.f,h);if(null==u)return a;l+=u;for(var v=[],b=0;b<p.length;b++){var f=p[b];t.geometry.CompactCrit(f.f,h)==u&&v.push(f)}if(console.assert(v.length>0),1==v.length)return n[1]+l+("x"==n[4]?"x":"")+n[5]+n[6]+n[7];p=v}return a},Model.Board.cbIntegrity=function(t){function e(t,e){t||console.error(e)}for(var r=this,i=0;i<this.board.length;i++){var a=this.board[i];if(a>=0){var n=r.pieces[a];e(void 0!==n,"no piece at pos"),e(n.p==i,"piece has different pos")}}for(var a=0;a<this.pieces.length;a++){var n=this.pieces[a];n.p>=0&&e(r.board[n.p]==a,"board index mismatch")}},Model.Board.ExportBoardState=function(t){return t.cbVar.geometry.ExportBoardState?t.cbVar.geometry.ExportBoardState(this,t.cbVar,t.mPlayedMoves.length):"not supported"},Model.Game.Import=function(e,r){var i,a=[],n={1:{},"-1":{}},s=null,o=0;if("pjn"==e){var h={status:!1,error:"parse"},c=r.split(" ");if(6!=c.length)return console.warn("FEN should have 6 parts"),h;var p=c[0].split("/"),l=t.geometry.fenHeight||t.geometry.height;if(p.length!=l)return console.warn("FEN board should have",l,"rows, got",p.length),h;var u={};for(var v in t.pieceTypes){var b=t.pieceTypes[v],f=b.fenAbbrev||b.abbrev||"X";u[f.toUpperCase()]={s:1,t:v},u[f.toLowerCase()]={s:-1,t:v}}var d=t.geometry.FenRowPos||function(e,r){return(t.geometry.height-1-e)*t.geometry.width+r};if(p.forEach(function(e,r){for(var i=0,n=0;n<e.length;n++){var s=e.substr(n,1),o=u[s];if(void 0!==o){var c=d(r,i);i++;for(var p={s:o.s,t:o.t,p:c},l=!0,v=t.pieceTypes[p.t].initial||[],b=0;b<v.length;b++){var f=v[b];f.s==p.s&&f.p==c&&(l=!1)}p.m=l,a.push(p)}else{if(isNaN(parseInt(s)))return console.warn("FEN invalid board spec",s),h;i+=parseInt(s)}}}),a.sort(function(t,e){return e.s-t.s}),"w"==c[1])i=1;else{if("b"!=c[1])return console.warn("FEN invalid turn spec",c[1]),h;i=-1}n[1].k=c[2].indexOf("K")>=0,n[1].q=c[2].indexOf("Q")>=0,n[-1].k=c[2].indexOf("k")>=0,n[-1].q=c[2].indexOf("q")>=0,s="-"==c[3]?null:c[3];var g=parseInt(c[4]);isNaN(g)||(o=g);var m={pieces:a,turn:i,castle:n,enPassant:s,noCaptCount:o};return t.importGame&&t.importGame.call(this,m,e,r),{status:!0,initial:m}}return{status:!1,error:"unsupported"}}}(),function(){Model.Game.cbBoardGeometryGrid=function(t,e){function r(e){return e%t}function i(e){return Math.floor(e/t)}function a(e,r){return r*t+e}function n(n,s){var o=r(n),h=i(n),c=o+s[0],p=h+s[1];return c<0||c>=t||p<0||p>=e?null:a(c,p)}function s(t){return String.fromCharCode("a".charCodeAt(0)+r(t))+(i(t)+1)}function o(t){var e=/^([a-z])([0-9]+)$/.exec(t);return e?a(e[1].charCodeAt(0)-"a".charCodeAt(0),parseInt(e[2])-1):-1}function h(t,e){return 0==e?String.fromCharCode("a".charCodeAt(0)+r(t)):1==e?i(t)+1:null}function c(){for(var a=[],n=0;n<t*e;n++){var s=[];a.push(s);for(var o=0;o<t*e;o++){var h=i(n),c=r(n),p=i(o),l=r(o);s.push(Math.max(Math.abs(h-p),Math.abs(c-l)))}}return a}function p(r,i,n){for(var o=[],h=e-1;h>=0;h--){for(var c="",p=0,l=0;l<t;l++){var u=r.board[a(l,h)];if(u<0)p++;else{p>0&&(c+=p,p=0);var v=r.pieces[u],b=i.pieceTypes[v.t].fenAbbrev||i.pieceTypes[v.t].abbrev||"?";v.s==-1?c+=b.toLowerCase():c+=b.toUpperCase()}}p&&(c+=p),o.push(c)}var f=o.join("/");f+=" ",1==r.mWho?f+="w":f+="b",f+=" ";var d="";return r.castled&&(r.castled[1]===!1?d+="KQ":(r.castled[1].k&&(d+="K"),r.castled[1].q&&(d+="Q")),r.castled[-1]===!1?d+="kq":(r.castled[-1].k&&(d+="k"),r.castled[-1].q&&(d+="q"))),0==d.length&&(d="-"),f+=d,f+=" ",r.epTarget?f+=s(r.epTarget.p):f+="-",f+=" ",f+=r.noCaptCount,f+=" ",f+=Math.floor(n/2)+1}return{boardSize:t*e,width:t,height:e,C:r,R:i,POS:a,Graph:n,PosName:s,PosByName:o,CompactCrit:h,GetDistances:c,distEdge:function(){for(var a=[],n=0;n<t*e;n++){var s=r(n),o=i(n);a[n]=Math.min(s,Math.abs(t-s-1),o,Math.abs(e-o-1))}return a}(),corners:function(){var r={};return r[a(0,0)]=1,r[a(0,e-1)]=1,r[a(t-1,0)]=1,r[a(t-1,e-1)]=1,r}(),ExportBoardState:p}},Model.Game.cbPawnGraph=function(t,e,r){for(var i=this,a={},n=0;n<t.boardSize;n++)if(!r||n in r){var s=[],o=t.Graph(n,[0,e]);null!=o&&(!r||o in r)&&s.push(i.cbTypedArray([o|i.cbConstants.FLAG_MOVE])),[-1,1].forEach(function(a){var o=t.Graph(n,[a,e]);null!=o&&(!r||o in r)&&s.push(i.cbTypedArray([o|i.cbConstants.FLAG_CAPTURE]))}),a[n]=s}else a[n]=[];return a},Model.Game.cbInitialPawnGraph=function(t,e,r){for(var i=this,a={},n=0;n<t.boardSize;n++)if(!r||n in r){var s=[],o=t.Graph(n,[0,e]);if(null!=o&&(!r||o in r)){var h=[o|i.cbConstants.FLAG_MOVE],c=t.Graph(o,[0,e]);null!=c&&(!r||c in r)&&h.push(c|i.cbConstants.FLAG_MOVE),s.push(i.cbTypedArray(h))}[-1,1].forEach(function(a){var o=t.Graph(n,[a,e]);null!=o&&(!r||o in r)&&s.push(i.cbTypedArray([o|i.cbConstants.FLAG_CAPTURE]))}),a[n]=s}else a[n]=[];return a},Model.Game.cbKingGraph=function(t,e){return this.cbShortRangeGraph(t,[[-1,-1],[-1,0],[-1,1],[0,-1],[0,1],[1,-1],[1,0],[1,1]],e)},Model.Game.cbKnightGraph=function(t,e){return this.cbShortRangeGraph(t,[[2,-1],[2,1],[-2,-1],[-2,1],[-1,2],[-1,-2],[1,2],[1,-2]],e)},Model.Game.cbHorseGraph=function(t){for(var e=this,r={},i=0;i<t.boardSize;i++)r[i]=[],[[1,0,2,-1],[1,0,2,1],[-1,0,-2,-1],[-1,0,-2,1],[0,1,-1,2],[0,-1,-1,-2],[0,1,1,2],[0,-1,1,-2]].forEach(function(a){var n=t.Graph(i,[a[0],a[1]]);if(null!=n){var s=t.Graph(i,[a[2],a[3]]);null!=s&&r[i].push(e.cbTypedArray([n|e.cbConstants.FLAG_STOP,s|e.cbConstants.FLAG_MOVE|e.cbConstants.FLAG_CAPTURE]))}});return r},Model.Game.cbRookGraph=function(t,e){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0]],e)},Model.Game.cbBishopGraph=function(t,e){return this.cbLongRangeGraph(t,[[1,-1],[1,1],[-1,1],[-1,-1]],e)},Model.Game.cbQueenGraph=function(t,e){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0],[1,-1],[1,1],[-1,1],[-1,-1]],e)},Model.Game.cbXQGeneralGraph=function(t,e){for(var r=this,i={},a=0;a<t.boardSize;a++)i[a]=[],[[-1,0,!1],[0,-1,!0],[0,1,!0],[1,0,!1]].forEach(function(n){var s=[],o=t.Graph(a,n);if(null!=o&&((!e||o in e)&&s.push(o|r.cbConstants.FLAG_MOVE|r.cbConstants.FLAG_CAPTURE),n[2]))for(var h=t.Graph(o,n);null!=h;)!e||h in e?s.push(h|r.cbConstants.FLAG_CAPTURE|r.cbConstants.FLAG_CAPTURE_KING):s.push(h|r.cbConstants.FLAG_STOP),h=t.Graph(h,n);s.length>0&&i[a].push(r.cbTypedArray(s))});return i},Model.Game.cbXQSoldierGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e]])},Model.Game.cbXQPromoSoldierGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e],[-1,0],[1,0]])},Model.Game.cbXQAdvisorGraph=function(t,e){return this.cbShortRangeGraph(t,[[1,1],[-1,1],[1,-1],[-1,-1]],e)},Model.Game.cbXQCannonGraph=function(t){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0]],null,this.cbConstants.FLAG_MOVE|this.cbConstants.FLAG_SCREEN_CAPTURE)},Model.Game.cbXQElephantGraph=function(t,e){for(var r=this,i={},a=0;a<t.boardSize;a++)i[a]=[],(!e||a in e)&&[[1,1,2,2],[1,-1,2,-2],[-1,1,-2,2],[-1,-1,-2,-2]].forEach(function(n){var s=t.Graph(a,[n[0],n[1]]);if(null!=s){var o=t.Graph(a,[n[2],n[3]]);null!=o&&(!e||o in e)&&i[a].push(r.cbTypedArray([s|r.cbConstants.FLAG_STOP,o|r.cbConstants.FLAG_MOVE|r.cbConstants.FLAG_CAPTURE]))}});return i},Model.Game.cbSilverGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e],[-1,-1],[-1,1],[1,-1],[1,1]])},Model.Game.cbFersGraph=function(t,e){return this.cbShortRangeGraph(t,[[-1,-1],[-1,1],[1,-1],[1,1]])},Model.Game.cbSchleichGraph=function(t,e){return this.cbShortRangeGraph(t,[[-1,0],[1,0],[0,-1],[0,1]])},Model.Game.cbAlfilGraph=function(t,e){return this.cbShortRangeGraph(t,[[-2,-2],[-2,2],[2,2],[2,-2]])}}(),function(){var t=Model.Game.cbBoardGeometryGrid(4,5);Model.Game.cbDefine=function(){return{geometry:t,pieceTypes:{0:{name:"pawn-w",aspect:"pawn",graph:this.cbPawnGraph(t,1),value:1,abbrev:"",fenAbbrev:"P",epCatch:!0},1:{name:"ipawn-w",aspect:"pawn",graph:this.cbInitialPawnGraph(t,1),value:1,abbrev:"",fenAbbrev:"P",initial:[{s:1,p:7}],epCatch:!0,epTarget:!0},2:{name:"pawn-b",aspect:"pawn",graph:this.cbPawnGraph(t,-1),value:1,abbrev:"",fenAbbrev:"P",epCatch:!0},3:{name:"ipawn-b",aspect:"pawn",graph:this.cbInitialPawnGraph(t,-1),value:1,abbrev:"",fenAbbrev:"P",initial:[{s:-1,p:12}],epCatch:!0,epTarget:!0},4:{name:"knight",graph:this.cbKnightGraph(t),value:2.9,abbrev:"N",initial:[{s:1,p:2},{s:-1,p:17}]},5:{name:"bishop",graph:this.cbBishopGraph(t),value:3.1,abbrev:"B",initial:[{s:1,p:1},{s:-1,p:18}]},6:{name:"rook",graph:this.cbRookGraph(t),value:5,abbrev:"R",initial:[{s:1,p:0},{s:-1,p:19}],castle:!0},8:{name:"king",isKing:!0,graph:this.cbKingGraph(t),abbrev:"K",initial:[{s:1,p:3},{s:-1,p:16}]}},promote:function(e,r,i){return 1==r.t?[0]:3==r.t?[2]:0==r.t&&4==t.R(i.t)?[4,5,6]:2==r.t&&0==t.R(i.t)?[4,5,6]:[]},castle:{"3/0":{k:[2,1],r:[1,2],n:"O-O"},"16/19":{k:[17,18],r:[18,17],n:"O-O"}},evaluate:function(e,r,i){var a=i[1].count,n=i[-1].count;a[0]||a[1]||a[4]||a[5]||a[6]||a[7]||n[2]||n[3]||n[6]||n[7]||!(n[4]+n[5]<2||n[5]<2)||(this.mFinished=!0,this.mWinner=JocGame.DRAW),n[2]||n[3]||n[4]||n[5]||n[6]||n[7]||a[0]||a[1]||a[6]||a[7]||!(a[4]+a[5]<2||a[5]<2)||(this.mFinished=!0,this.mWinner=JocGame.DRAW),this.noCaptCount>=100&&(this.mFinished=!0,this.mWinner=JocGame.DRAW);var s,o=e.cbUseTypedArrays?new Int8Array(3):[0,0,0],h=t.height,c=i[1].byType[0];if(c){s=c.length;for(var p=0;p<s;p++)switch(h-t.R(c[p].p)){case 2:o[0]++;break;case 3:o[1]++;break;case 4:o[2]++}}if(c=i[-1].byType[2]){s=c.length;for(var p=0;p<s;p++)switch(t.R(c[p].p)){case 1:o[0]--;break;case 2:o[1]--;break;case 3:o[2]--}}0!=o[0]&&(r.distPawnPromo1=o[0]),0!=o[1]&&(r.distPawnPromo2=o[1]),0!=o[2]&&(r.distPawnPromo3=o[2]);for(var l=0,u=4;u<=5;u++)for(var v=1;v>=-1;v-=2){var b=i[v].byType[u];if(b)for(var p=0;p<b.length;p++)b[p].m&&(l+=v)}0!=l&&(r.minorPiecesMoved=l)}}}}();

/***/ }),

/***/ "W1/H":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var findIndex_1 = __webpack_require__("YgqK");
Observable_1.Observable.prototype.findIndex = findIndex_1.findIndex;
//# sourceMappingURL=findIndex.js.map

/***/ }),

/***/ "W2nU":
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),

/***/ "W9Dn":
/***/ (function(module, exports, __webpack_require__) {

var
    symbols = __webpack_require__("bgfr"),
    RafleItem = __webpack_require__("bAB1")
    Piece = symbols.Piece
;

function Diagonal(isGD) {
    this.squares = []; // [case]
    this.isGD = isGD; //  Parallèle à la GD (false => // au TT)
}

Diagonal.prototype.addCase = function(c) {
    this.squares.push(c);
    return this;
};

Diagonal.prototype._size = function() {
    return this.squares.length;
};

Diagonal.prototype._getSquareByNumber = function(number) {
    var c = null;
    for (var k = 0; k < this._size(); k++) {
        var cTmp = this.squares[k];
        if (cTmp.number == number) {
            c = cTmp;
            break;
        }
    }
    return c;
};

Diagonal.prototype._getSquareByIndex = function(idx) {
    return this.squares[idx];
};

/** index de la case dans la liste. */
Diagonal.prototype._indexOf = function(number) {
    var idx = -1;
    for (var k = 0; k < this._size(); k++) {
        var sq = this.squares[k];
        if (sq.number == number) {
            idx = k;
            break;
        }
    }
    return idx;
};

Diagonal.prototype._isEmpty = function(idxSquare) {
    var piece = this.squares[idxSquare];
    return piece.isEmpty();
};


Diagonal.prototype.getSimpleMovements = function(squareNum) {
    var list = [];

    var sq = this._getSquareByNumber(squareNum);
    var lg = this._size();
    var idxSquare = this._indexOf(squareNum);

    // Déplacement Pion Blanc dans le sens gauche-droite ?
    if (sq.piece == Piece.PAWN_WHITE) {
        // La case à droite doit être libre.
        if (idxSquare + 1 < lg) {
            if (this._isEmpty(idxSquare + 1)) {
                list.push(this._getSquareByIndex(idxSquare + 1).number);
            }
        }

    }
    // Déplacement Pion Noir dans le sens droite-gauche ?
    else if (sq.piece == Piece.PAWN_BLACK) {
        // La case à gauche doit être libre.
        if (idxSquare - 1 >= 0) {
            if (this._isEmpty(idxSquare - 1)) {
                list.push(this._getSquareByIndex(idxSquare - 1).number);
            }
        }
    }

    // Déplacement Dame Blanche ou Noire dans les 2 sens
    else if (sq.isDame()) {

        // Déplacement dans le sens gauche-droite ?
        // -----------------------------------------
        // Au moins 1 case à droite.
        if (idxSquare + 1 < lg) {
            // On avance case par case, en comptant les cases vides.
            for (var k = idxSquare + 1; k < lg; k++) {
                if (this._isEmpty(k)) {
                    list.push(this._getSquareByIndex(k).number);
                } else {
                    // On a rencontré une pièce ou le bord du damier
                    // => fin d'analyse.
                    break;
                }
            }

        }

        // Déplacement dans le sens droite-gauche ?
        // -----------------------------------------
        // Au moins 1 case à gauche.
        if (idxSquare - 1 >= 0) {
            // On recule case par case, en comptant les cases vides.
            for (var k = idxSquare - 1; k >= 0; k--) {
                if (this._isEmpty(k)) {
                    list.push(this._getSquareByIndex(k).number);
                } else {
                    // On a rencontré une pièce ou le bord du damier
                    // => fin d'analyse.
                    break;
                }
            }
        }
    }

    return list;
};


/**
 * @param numCasesDejaPrises
 *            Pour ne pas la reprendre (coup Turc).
 */
Diagonal.prototype.getRaflesItem = function(squareNum, numSquaresPrevCaptured) {
    var sq = this._getSquareByNumber(squareNum);

    raflesItem = [];

    var lg = this._size();
    var idxSquare = this._indexOf(squareNum);

    if (sq.isPawn()) {

        // Prise dans le sens gauche-droite ?
        // S'il y a au moins 2 cases devant.
        if (idxSquare + 2 < lg) {
            if (this._isEmpty(idxSquare + 2)) {
                var sq1 = this._getSquareByIndex(idxSquare + 1);
                if (sq.isOppositeColor(sq1)) {
                    // prise OK
                    var capturedSq = sq1;
                    var endingSq = this._getSquareByIndex(idxSquare + 2);
                    if (!(numSquaresPrevCaptured.indexOf(capturedSq.number) > -1)) {
                        var ri = new RafleItem(endingSq.number, capturedSq.number);
                        raflesItem.push(ri);
                    }
                }
            }
        }

        // Prise dans le sens droite-gauche ?
        // S'il y a au moins 2 cases derrière.
        if (idxSquare - 2 >= 0) {
            if (this._isEmpty(idxSquare - 2)) {
                var sq1 = this._getSquareByIndex(idxSquare - 1);
                if (sq.isOppositeColor(sq1)) {
                    // prise OK
                    var capturedSq = sq1;
                    var endingSq = this._getSquareByIndex(idxSquare - 2);
                    // console.log("debug[" + this.type + "] : " + (idxSquare - 1) + "=" + capturedSq);
                    if (!(numSquaresPrevCaptured.indexOf(capturedSq.number) > -1)) {
                        var ri = new RafleItem(endingSq.number, capturedSq.number);
                        raflesItem.push(ri);
                    }
                }
            }
        }
    } else if (sq.isDame()) {

        // -----------------------------------
        // Prise dans le sens gauche-droite ?
        // -----------------------------------

        // il faut : [0..n] vide + 1 Couleur opposee + [1..n] vide
        var nbEmptyBefore = 0;
        var idxPieceToCapture = -1;
        var nbEmptyAfter = 0;
        // ---

        // Avant tout, Il faut au moins 2 cases devant.
        if (idxSquare + 2 < lg) {
            // On avance case par case, en comptant les cases vides.
            for (var k = idxSquare + 1; k < lg; k++) {
                if (this._isEmpty(k)) {
                    nbEmptyBefore++;
                } else {
                    // On a rencontré une pièce ou le bord du damier
                    // => fin d'analyse.
                    break;
                }
            }

            // On s'assure que la case d'après n'est pas hors du damier
            if (idxSquare + nbEmptyBefore + 2 < lg) {
                idxPieceToCapture = idxSquare + nbEmptyBefore + 1;

                // S'assurer que la case prise est de couleur opposée.
                var capturedSq = this._getSquareByIndex(idxPieceToCapture);
                if (sq.isOppositeColor(capturedSq)) {
                    // Verifier qu'il existe au moins une case d'atterrisage.

                    // On avance case par case, en comptant les cases vides.
                    for (var k = idxPieceToCapture + 1; k < lg; k++) {
                        if (this._isEmpty(k)) {
                            nbEmptyAfter++;
                        } else {
                            // On a rencontré une pièce ou le bord
                            // => fin d'analyse.
                            break;
                        }
                    }
                }
            }
        }

        // Y a t-il une prise possible ?
        if (idxPieceToCapture >= 0 && nbEmptyAfter > 0) {
            var capturedSq = this._getSquareByIndex(idxPieceToCapture);

            // On ne passe pas 2 fois sur la même pièce. (coup turc).
            if (!(numSquaresPrevCaptured.indexOf(capturedSq.number) > -1)) {

                // n cases d'arrivée possibles
                for (var k = 1; k <= nbEmptyAfter; k++) {
                    var endingSq = this._getSquareByIndex(idxPieceToCapture + k);
                    var ri = new RafleItem(endingSq.number, capturedSq.number);
                    raflesItem.push(ri);
                }
            }
        }

        // -----------------------------------
        // Prise dans le sens droite-gauche ?
        // -----------------------------------

        // il faut : [0..n] vide + 1 Couleur opposee + [1..n] vide
        nbEmptyBefore = 0;
        idxPieceToCapture = -1;
        nbEmptyAfter = 0;
        // ---

        // Avant tout, Il faut au moins 2 cases derrière.
        if (idxSquare - 2 >= 0) {
            // On recule case par case, en comptant les cases vides.
            for (var k = idxSquare - 1; k >= 0; k--) {
                if (this._isEmpty(k)) {
                    nbEmptyBefore++;
                } else {
                    // On a rencontré une pièce ou le bord du damier
                    // => fin d'analyse.
                    break;
                }
            }

            // On s'assure que la case d'avant n'est pas hors du damier
            if (idxSquare - nbEmptyBefore - 2 >= 0) {
                idxPieceToCapture = idxSquare - nbEmptyBefore - 1;

                // S'assurer que la case prise est de couleur opposée.
                var capturedSq = this._getSquareByIndex(idxPieceToCapture);
                if (sq.isOppositeColor(capturedSq)) {
                    // Verifier qu'il existe au moins une case d'atterrisage.

                    // On avance case par case, en comptant les cases vides.
                    for (var k = idxPieceToCapture - 1; k >= 0; k--) {
                        if (this._isEmpty(k)) {
                            nbEmptyAfter++;
                        } else {
                            // On a rencontré une pièce ou le bord
                            // => fin d'analyse.
                            break;
                        }
                    }
                }
            }
        }

        // Y a t-il une prise possible ?
        if (idxPieceToCapture >= 0 && nbEmptyAfter > 0) {
            var capturedSq = this._getSquareByIndex(idxPieceToCapture);

            // On ne passe pas 2 fois sur la même pièce. (coup turc).
            if (!(numSquaresPrevCaptured.indexOf(capturedSq.number) > -1)) {

                // n cases d'arrivée possibles
                for (var k = 1; k <= nbEmptyAfter; k++) {
                    var endingSq = this._getSquareByIndex(idxPieceToCapture - k);
                    var ri = new RafleItem(endingSq.number, capturedSq.number);
                    raflesItem.push(ri);
                }
            }
        }
    }

    return raflesItem;
};

Diagonal.prototype.toString = function() {

    var type = "GD";
    if (!this.isGD){
        type = "TT";
    }
    var s = "Diagonal [" + type + "] = ";

    for (var k = 0; k < this._size(); k++) {
        s += this.squares[k].number;
        var p = this.squares[k].piece;

        s += "[";
        switch (p) {
            case Piece.PAWN_WHITE:
                s += "b";
                break;
            case Piece.PAWN_BLACK:
                s += "n";
                break;
            case Piece.DAME_WHITE:
                s += "B";
                break;
            case Piece.DAME_BLACK:
                s += "N";
                break;
            default:
                s += "*";
        }
        s += "] ";
    }

    return s;
};


module.exports = Diagonal;


/***/ }),

/***/ "WQmy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var share_1 = __webpack_require__("+ayw");
Observable_1.Observable.prototype.share = share_1.share;
//# sourceMappingURL=share.js.map

/***/ }),

/***/ "WTUZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var tryCatch_1 = __webpack_require__("+3eL");
var errorObject_1 = __webpack_require__("WhVc");
var OuterSubscriber_1 = __webpack_require__("wAkD");
var subscribeToResult_1 = __webpack_require__("CURp");
/**
 * Ignores source values for a duration determined by another Observable, then
 * emits the most recent value from the source Observable, then repeats this
 * process.
 *
 * <span class="informal">It's like {@link auditTime}, but the silencing
 * duration is determined by a second Observable.</span>
 *
 * <img src="./img/audit.png" width="100%">
 *
 * `audit` is similar to `throttle`, but emits the last value from the silenced
 * time window, instead of the first value. `audit` emits the most recent value
 * from the source Observable on the output Observable as soon as its internal
 * timer becomes disabled, and ignores source values while the timer is enabled.
 * Initially, the timer is disabled. As soon as the first source value arrives,
 * the timer is enabled by calling the `durationSelector` function with the
 * source value, which returns the "duration" Observable. When the duration
 * Observable emits a value or completes, the timer is disabled, then the most
 * recent source value is emitted on the output Observable, and this process
 * repeats for the next source value.
 *
 * @example <caption>Emit clicks at a rate of at most one click per second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.audit(ev => Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link auditTime}
 * @see {@link debounce}
 * @see {@link delayWhen}
 * @see {@link sample}
 * @see {@link throttle}
 *
 * @param {function(value: T): SubscribableOrPromise} durationSelector A function
 * that receives a value from the source Observable, for computing the silencing
 * duration, returned as an Observable or a Promise.
 * @return {Observable<T>} An Observable that performs rate-limiting of
 * emissions from the source Observable.
 * @method audit
 * @owner Observable
 */
function audit(durationSelector) {
    return this.lift(new AuditOperator(durationSelector));
}
exports.audit = audit;
var AuditOperator = (function () {
    function AuditOperator(durationSelector) {
        this.durationSelector = durationSelector;
    }
    AuditOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new AuditSubscriber(subscriber, this.durationSelector));
    };
    return AuditOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var AuditSubscriber = (function (_super) {
    __extends(AuditSubscriber, _super);
    function AuditSubscriber(destination, durationSelector) {
        _super.call(this, destination);
        this.durationSelector = durationSelector;
        this.hasValue = false;
    }
    AuditSubscriber.prototype._next = function (value) {
        this.value = value;
        this.hasValue = true;
        if (!this.throttled) {
            var duration = tryCatch_1.tryCatch(this.durationSelector)(value);
            if (duration === errorObject_1.errorObject) {
                this.destination.error(errorObject_1.errorObject.e);
            }
            else {
                this.add(this.throttled = subscribeToResult_1.subscribeToResult(this, duration));
            }
        }
    };
    AuditSubscriber.prototype.clearThrottle = function () {
        var _a = this, value = _a.value, hasValue = _a.hasValue, throttled = _a.throttled;
        if (throttled) {
            this.remove(throttled);
            this.throttled = null;
            throttled.unsubscribe();
        }
        if (hasValue) {
            this.value = null;
            this.hasValue = false;
            this.destination.next(value);
        }
    };
    AuditSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex) {
        this.clearThrottle();
    };
    AuditSubscriber.prototype.notifyComplete = function () {
        this.clearThrottle();
    };
    return AuditSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=audit.js.map

/***/ }),

/***/ "WWmu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_dispatcher__ = __webpack_require__("osFu");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__src_dispatcher__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_ng2__ = __webpack_require__("cPow");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__src_ng2__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_1__src_ng2__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_1__src_ng2__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_reducer__ = __webpack_require__("oi6x");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_2__src_reducer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_state__ = __webpack_require__("NPiC");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_3__src_state__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_store__ = __webpack_require__("Zcpd");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_4__src_store__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_utils__ = __webpack_require__("dt2B");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_5__src_utils__["a"]; });






//# sourceMappingURL=index.js.map

/***/ }),

/***/ "WeUy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__object_extend__ = __webpack_require__("xZ/u");
/* harmony export (immutable) */ __webpack_exports__["a"] = mergeAlias;

/**
 * For the specified MediaChange, make sure it contains the breakpoint alias
 * and suffix (if available).
 */
function mergeAlias(dest, source) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__object_extend__["a" /* extendObject */])(dest, source ? {
        mqAlias: source.alias,
        suffix: source.suffix
    } : {});
}
//# sourceMappingURL=add-alias.js.map

/***/ }),

/***/ "WgQY":
/***/ (function(module, exports) {

exports.config = {"status":true,"model":{"plazza":"true","title-en":"Four In A Row 9x6","module":"fourinarow","js":["fiarbase-model.js"],"summary":"Four In A Row on a 9x6 board","thumbnail":"fiar-thumb.png","rules":{"en":"rules.html","fr":"rules-fr.html"},"description":{"en":"description.html","fr":"description-fr.html"},"credits":{"en":"credits.html","fr":"credits-fr.html"},"gameOptions":{"width":9,"height":6,"lines":4,"remove":false,"levelOptions":{"evalTuple1":1,"evalTuple2":2,"evalTuple3":4,"evalTuple4":8,"evalTuple5":16,"evalTuple6":32},"uctTransposition":"state"},"levels":[{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.55,"ignoreLeaf":false,"name":"easy","label":"Easy","maxNodes":1000,"isDefault":true},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.55,"ignoreLeaf":false,"name":"fast","label":"Fast [1sec]","maxDuration":1},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.55,"ignoreLeaf":false,"name":"strong","label":"Strong","maxNodes":10000}]},"view":{"title-en":"Four In A Row View","module":"fourinarow","js":["fiarbase-xd-view.js"],"xdView":true,"css":["fiarbase.css"],"preferredRatio":1,"useShowMoves":false,"useNotation":true,"sounds":{"sound1":"sound1","sound2":"sound2"},"defaultOptions":{"sounds":true,"moves":true,"notation":false},"skins":[{"name":"fiar3d","title":"3D Classic","3d":true,"camera":{"radius":20,"limitCamMoves":true,"rotationAngle":180,"elevationAngle":0,"elevationMin":-89,"elevationMax":89,"distMax":30},"world":{"lightIntensity":0.2,"skyLightIntensity":0.2,"lightCastShadow":false,"fog":true,"color":0,"lightPosition":{"x":10,"y":5,"z":0},"lightShadowDarkness":0.55,"ambientLightColor":2236996},"preload":["map|/res/xd-view/meshes/connect4-red-star.png","map|/res/xd-view/meshes/connect4-red.png","map|/res/xd-view/meshes/connect4-yellow-star.png","map|/res/xd-view/meshes/connect4-yellow.png","smoothedfilegeo|0|/res/xd-view/meshes/connect4cell.js","smoothedfilegeo|0|/res/xd-view/meshes/connect4cell-ring-smoothed.js","smoothedfilegeo|0|/res/xd-view/meshes/connect4-token.js","smoothedfilegeo|0|/res/xd-view/meshes/connect4cell-foot.js"]},{"name":"fiar2d","title":"2D Classic","3d":false,"preload":["image|/res/sprites2d.png"]}],"animateSelfMoves":false,"visuals":{"600x600":["res/visuals/fourinarow-9x6-600x600-3d.jpg","res/visuals/fourinarow-9x6-600x600-2d.jpg"]}}}

/***/ }),

/***/ "Wh/D":
/***/ (function(module, exports) {

exports.model=Model={Game:{},Board:{},Move:{}},function(){function t(t){var i=t%e;return[i,(t-i)/e]}function i(t,i){return i*e+t}var e;Model.Game.InitGame=function(){var s=this;e=2*this.mOptions.centerDistance+1;var r=[[0,-1],[1,0],[0,1],[-1,0]];this.g.attackersCount=this.mOptions.initial.attackers.length,this.g.defendersCount=this.mOptions.initial.defenders.soldiers.length,this.g.excludeMap={},this.mOptions.exclude.forEach(function(t){s.g.excludeMap[t]=!0}),this.g.home=this.mOptions.initial.defenders.king,this.g.Graph=[],this.g.borders={};for(var a=0;a<e*e;a++){var o=[],n=t(a);r.forEach(function(t){var r=n[0]+t[0];if(r<0||r>=e)o.push(null),s.g.borders[a]=!0;else{var h=n[1]+t[1];if(h<0||h>=e)o.push(null),s.g.borders[a]=!0;else{var d=i(r,h);s.g.excludeMap[d]?o.push(null):o.push(d)}}}),this.g.Graph.push(o)}this.zobrist=new JocGame.Zobrist({board:{type:"array",size:e*e,values:["s1","s-1","k1","k-1"]}})},Model.Move.Init=function(t){var i=this;if(this.f=t.f,this.t=t.t,this.c=[],t.c)for(var e=0;e<t.c.length;e++)i.c.push(t.c[e])},Model.Move.CopyFrom=function(t){this.Init(t)},Model.Move.ToString=function(){var t=this.f+">"+this.t;return this.c.length>0&&(t+="x"+this.c.join(",")),t},Model.Board.Init=function(t){this.zSign=0},Model.Board.InitialPosition=function(i){function s(t,e,s){r.zSign=i.zobrist.update(r.zSign,"board",s+e,t),r.board[t]=r.pieces.length,r.pieces.push({i:r.pieces.length,p:t,s:e,t:s})}var r=this;this.board=[],this.pieces=[];for(var a=0;a<e*e;a++)this.board.push(-1);var o=i.mOptions.attackers;s(i.mOptions.initial.defenders.king,-o,"k");var n=i.mOptions.initial.defenders.soldiers;this.defendersCount=0;for(var h=0;h<n.length;h++)s(n[h],-o,"s"),this.defendersCount++;this.defendersCount=n.length;var d=i.mOptions.initial.attackers;this.attackersCount=0;for(var h=0;h<d.length;h++){s(d[h],o,"s");t(d[h]);this.attackersCount++}},Model.Board.CopyFrom=function(t){var i=this;this.board=[];for(var e=t.board,s=0;s<e.length;s++)i.board.push(e[s]);this.pieces=[];for(var r=t.pieces,a=0;a<r.length;a++){var o=r[a];i.pieces.push({i:o.i,p:o.p,s:o.s,t:o.t})}this.defendersCount=t.defendersCount,this.attackersCount=t.attackersCount,this.mWho=t.mWho,this.zSign=t.zSign},Model.Board.GenerateMoves=function(t){for(var i=this,e=[],s=0;s<this.pieces.length;s++){var r=this.pieces[s];if(!(r.s!=i.mWho||r.p<0))for(var a=0;a<4;a++)for(var o=t.g.Graph[r.p][a];null!=o;){var n=i.board[o];if(!(n<0)||o==t.g.home&&t.mOptions.privateHome&&"k"!=r.t)break;for(var h={f:r.p,t:o,c:[]},d=0;d<4;d++){var p=t.g.Graph[o][d];if(null!=p){var c=i.board[p];if(c>=0){var f=i.pieces[c];if(f.s==-r.s)if("k"==f.t){for(var u=0;u<4;u++){var l=t.g.Graph[p][u];if(null==l)break;var v=i.board[l];if(v<0){if(l!=o&&(l!=t.g.home||!t.mOptions.homeCatch))break}else{var g=i.pieces[v];if(g.s==f.s)break}}4==u&&h.c.push(p)}else{var l=t.g.Graph[p][d];if(null!=l){var v=i.board[l];if(l==t.g.home&&t.mOptions.homeCatch)h.c.push(p);else if(v>=0){var g=i.pieces[v];g.s==r.s&&h.c.push(p)}}}}}}if(e.push(h),!t.mOptions.longMove)break;o=t.g.Graph[o][a]}}this.mMoves=e},Model.Board.Evaluate=function(i){var e="debug"==arguments[3];if(this.mEvaluation=0,this.pieces[0].p<0)return this.mFinished=!0,void(this.mWinner=i.mOptions.attackers);if(this.pieces[0].p in i.g.borders)return this.mFinished=!0,void(this.mWinner=-i.mOptions.attackers);if(i.GetRepeatOccurence(this)>2)return this.mFinished=!0,void(this.mWinner=JocGame.DRAW);for(var s=this.pieces[0].p,r=t(s),a=0,o=i.mOptions.initial.attackers.length+1;o<this.pieces.length;o++){var n=this.pieces[o];if(n.p>=0){var h=t(n.p);a+=Math.max(Math.abs(h[0]-r[0]),Math.abs(h[1]-r[1]))}}var d={},p={};d[s]=1;for(var c=1,f=0,u=0;c>0;){var l={};c=0;for(var v in d){for(var g=d[v],m=g/4,b=i.g.Graph[v],k=0;k<4;k++)for(var M=b[k];M&&!(this.board[M]>=0)&&(M in p||M in d||(M in i.g.borders?f+=g:M in l?l[M]+=m:(u++,c++,l[M]=m)),i.mOptions.longMove);)M=i.g.Graph[M][k];p[v]=g}d=l}var O={attackersCount:this.attackersCount,defendersCount:this.defendersCount,kingPath:f,kingFreedom:u,distKing:a},C=i.mOptions.levelOptions;for(var z in O){var G=O[z],S=C[z+"Factor"]||0,E=G*S;e&&console.log(z,"=",G,"*",S,"=>",E),this.mEvaluation+=E}this.mEvaluation*=i.mOptions.attackers,e&&console.log("Evaluation",this.mEvaluation)},Model.Board.ApplyMove=function(i,e){var s=this,r=this.board[e.f],a=this.pieces[r];if(this.zSign=i.zobrist.update(this.zSign,"board",a.t+a.s,e.f),this.zSign=i.zobrist.update(this.zSign,"board",a.t+a.s,e.t),this.board[e.f]=-1,this.board[e.t]=r,a.p=e.t,this.mWho==i.mOptions.attackers){t(e.f),t(e.t)}for(var o=e.c,n=0;n<o.length;n++){var h=o[n],d=s.board[h],p=s.pieces[d];s.zSign=i.zobrist.update(s.zSign,"board",p.t+p.s,h),s.board[h]=-1,p.p=-1,s.mWho==-i.mOptions.attackers?s.attackersCount--:"s"==p.t&&s.defendersCount--}},Model.Board.taflIntegrity=function(t){var i=this,e=0,s=0;this.board.forEach(function(r,a){if(r>=0){var o=i.pieces[r];o.p,"s"==o.t&&(o.s==t.mOptions.attackers?e++:s++)}}),this.attackersCount,this.defendersCount,this.pieces.forEach(function(t,e){t.p>=0&&i.board[t.p]})},Model.Board.GetSignature=function(){return this.zSign}}();

/***/ }),

/***/ "WhVc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// typeof any so that it we don't have to cast when comparing a result to the error object
exports.errorObject = { e: {} };
//# sourceMappingURL=errorObject.js.map

/***/ }),

/***/ "Whbc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var bufferWhen_1 = __webpack_require__("1hN3");
Observable_1.Observable.prototype.bufferWhen = bufferWhen_1.bufferWhen;
//# sourceMappingURL=bufferWhen.js.map

/***/ }),

/***/ "WkCC":
/***/ (function(module, exports, __webpack_require__) {

exports.Game = __webpack_require__("HZzI");
exports.Piece = __webpack_require__("bgfr").Piece;



/***/ }),

/***/ "WxOs":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Observable_1 = __webpack_require__("rCTf");
var tryCatch_1 = __webpack_require__("+3eL");
var errorObject_1 = __webpack_require__("WhVc");
var AsyncSubject_1 = __webpack_require__("5c/I");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var BoundNodeCallbackObservable = (function (_super) {
    __extends(BoundNodeCallbackObservable, _super);
    function BoundNodeCallbackObservable(callbackFunc, selector, args, context, scheduler) {
        _super.call(this);
        this.callbackFunc = callbackFunc;
        this.selector = selector;
        this.args = args;
        this.context = context;
        this.scheduler = scheduler;
    }
    /* tslint:enable:max-line-length */
    /**
     * Converts a Node.js-style callback API to a function that returns an
     * Observable.
     *
     * <span class="informal">It's just like {@link bindCallback}, but the
     * callback is expected to be of type `callback(error, result)`.</span>
     *
     * `bindNodeCallback` is not an operator because its input and output are not
     * Observables. The input is a function `func` with some parameters, but the
     * last parameter must be a callback function that `func` calls when it is
     * done. The callback function is expected to follow Node.js conventions,
     * where the first argument to the callback is an error object, signaling
     * whether call was successful. If that object is passed to callback, it means
     * something went wrong.
     *
     * The output of `bindNodeCallback` is a function that takes the same
     * parameters as `func`, except the last one (the callback). When the output
     * function is called with arguments, it will return an Observable.
     * If `func` calls its callback with error parameter present, Observable will
     * error with that value as well. If error parameter is not passed, Observable will emit
     * second parameter. If there are more parameters (third and so on),
     * Observable will emit an array with all arguments, except first error argument.
     *
     * Optionally `bindNodeCallback` accepts selector function, which allows you to
     * make resulting Observable emit value computed by selector, instead of regular
     * callback arguments. It works similarly to {@link bindCallback} selector, but
     * Node.js-style error argument will never be passed to that function.
     *
     * Note that `func` will not be called at the same time output function is,
     * but rather whenever resulting Observable is subscribed. By default call to
     * `func` will happen synchronously after subscription, but that can be changed
     * with proper {@link Scheduler} provided as optional third parameter. Scheduler
     * can also control when values from callback will be emitted by Observable.
     * To find out more, check out documentation for {@link bindCallback}, where
     * Scheduler works exactly the same.
     *
     * As in {@link bindCallback}, context (`this` property) of input function will be set to context
     * of returned function, when it is called.
     *
     * After Observable emits value, it will complete immediately. This means
     * even if `func` calls callback again, values from second and consecutive
     * calls will never appear on the stream. If you need to handle functions
     * that call callbacks multiple times, check out {@link fromEvent} or
     * {@link fromEventPattern} instead.
     *
     * Note that `bindNodeCallback` can be used in non-Node.js environments as well.
     * "Node.js-style" callbacks are just a convention, so if you write for
     * browsers or any other environment and API you use implements that callback style,
     * `bindNodeCallback` can be safely used on that API functions as well.
     *
     * Remember that Error object passed to callback does not have to be an instance
     * of JavaScript built-in `Error` object. In fact, it does not even have to an object.
     * Error parameter of callback function is interpreted as "present", when value
     * of that parameter is truthy. It could be, for example, non-zero number, non-empty
     * string or boolean `true`. In all of these cases resulting Observable would error
     * with that value. This means usually regular style callbacks will fail very often when
     * `bindNodeCallback` is used. If your Observable errors much more often then you
     * would expect, check if callback really is called in Node.js-style and, if not,
     * switch to {@link bindCallback} instead.
     *
     * Note that even if error parameter is technically present in callback, but its value
     * is falsy, it still won't appear in array emitted by Observable or in selector function.
     *
     *
     * @example <caption>Read a file from the filesystem and get the data as an Observable</caption>
     * import * as fs from 'fs';
     * var readFileAsObservable = Rx.Observable.bindNodeCallback(fs.readFile);
     * var result = readFileAsObservable('./roadNames.txt', 'utf8');
     * result.subscribe(x => console.log(x), e => console.error(e));
     *
     *
     * @example <caption>Use on function calling callback with multiple arguments</caption>
     * someFunction((err, a, b) => {
     *   console.log(err); // null
     *   console.log(a); // 5
     *   console.log(b); // "some string"
     * });
     * var boundSomeFunction = Rx.Observable.bindNodeCallback(someFunction);
     * boundSomeFunction()
     * .subscribe(value => {
     *   console.log(value); // [5, "some string"]
     * });
     *
     *
     * @example <caption>Use with selector function</caption>
     * someFunction((err, a, b) => {
     *   console.log(err); // undefined
     *   console.log(a); // "abc"
     *   console.log(b); // "DEF"
     * });
     * var boundSomeFunction = Rx.Observable.bindNodeCallback(someFunction, (a, b) => a + b);
     * boundSomeFunction()
     * .subscribe(value => {
     *   console.log(value); // "abcDEF"
     * });
     *
     *
     * @example <caption>Use on function calling callback in regular style</caption>
     * someFunction(a => {
     *   console.log(a); // 5
     * });
     * var boundSomeFunction = Rx.Observable.bindNodeCallback(someFunction);
     * boundSomeFunction()
     * .subscribe(
     *   value => {}             // never gets called
     *   err => console.log(err) // 5
     *);
     *
     *
     * @see {@link bindCallback}
     * @see {@link from}
     * @see {@link fromPromise}
     *
     * @param {function} func Function with a Node.js-style callback as the last parameter.
     * @param {function} [selector] A function which takes the arguments from the
     * callback and maps those to a value to emit on the output Observable.
     * @param {Scheduler} [scheduler] The scheduler on which to schedule the
     * callbacks.
     * @return {function(...params: *): Observable} A function which returns the
     * Observable that delivers the same values the Node.js callback would
     * deliver.
     * @static true
     * @name bindNodeCallback
     * @owner Observable
     */
    BoundNodeCallbackObservable.create = function (func, selector, scheduler) {
        if (selector === void 0) { selector = undefined; }
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i - 0] = arguments[_i];
            }
            return new BoundNodeCallbackObservable(func, selector, args, this, scheduler);
        };
    };
    BoundNodeCallbackObservable.prototype._subscribe = function (subscriber) {
        var callbackFunc = this.callbackFunc;
        var args = this.args;
        var scheduler = this.scheduler;
        var subject = this.subject;
        if (!scheduler) {
            if (!subject) {
                subject = this.subject = new AsyncSubject_1.AsyncSubject();
                var handler = function handlerFn() {
                    var innerArgs = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        innerArgs[_i - 0] = arguments[_i];
                    }
                    var source = handlerFn.source;
                    var selector = source.selector, subject = source.subject;
                    var err = innerArgs.shift();
                    if (err) {
                        subject.error(err);
                    }
                    else if (selector) {
                        var result_1 = tryCatch_1.tryCatch(selector).apply(this, innerArgs);
                        if (result_1 === errorObject_1.errorObject) {
                            subject.error(errorObject_1.errorObject.e);
                        }
                        else {
                            subject.next(result_1);
                            subject.complete();
                        }
                    }
                    else {
                        subject.next(innerArgs.length <= 1 ? innerArgs[0] : innerArgs);
                        subject.complete();
                    }
                };
                // use named function instance to avoid closure.
                handler.source = this;
                var result = tryCatch_1.tryCatch(callbackFunc).apply(this.context, args.concat(handler));
                if (result === errorObject_1.errorObject) {
                    subject.error(errorObject_1.errorObject.e);
                }
            }
            return subject.subscribe(subscriber);
        }
        else {
            return scheduler.schedule(dispatch, 0, { source: this, subscriber: subscriber, context: this.context });
        }
    };
    return BoundNodeCallbackObservable;
}(Observable_1.Observable));
exports.BoundNodeCallbackObservable = BoundNodeCallbackObservable;
function dispatch(state) {
    var self = this;
    var source = state.source, subscriber = state.subscriber, context = state.context;
    // XXX: cast to `any` to access to the private field in `source`.
    var _a = source, callbackFunc = _a.callbackFunc, args = _a.args, scheduler = _a.scheduler;
    var subject = source.subject;
    if (!subject) {
        subject = source.subject = new AsyncSubject_1.AsyncSubject();
        var handler = function handlerFn() {
            var innerArgs = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                innerArgs[_i - 0] = arguments[_i];
            }
            var source = handlerFn.source;
            var selector = source.selector, subject = source.subject;
            var err = innerArgs.shift();
            if (err) {
                self.add(scheduler.schedule(dispatchError, 0, { err: err, subject: subject }));
            }
            else if (selector) {
                var result_2 = tryCatch_1.tryCatch(selector).apply(this, innerArgs);
                if (result_2 === errorObject_1.errorObject) {
                    self.add(scheduler.schedule(dispatchError, 0, { err: errorObject_1.errorObject.e, subject: subject }));
                }
                else {
                    self.add(scheduler.schedule(dispatchNext, 0, { value: result_2, subject: subject }));
                }
            }
            else {
                var value = innerArgs.length <= 1 ? innerArgs[0] : innerArgs;
                self.add(scheduler.schedule(dispatchNext, 0, { value: value, subject: subject }));
            }
        };
        // use named function to pass values in without closure
        handler.source = source;
        var result = tryCatch_1.tryCatch(callbackFunc).apply(context, args.concat(handler));
        if (result === errorObject_1.errorObject) {
            self.add(scheduler.schedule(dispatchError, 0, { err: errorObject_1.errorObject.e, subject: subject }));
        }
    }
    self.add(subject.subscribe(subscriber));
}
function dispatchNext(arg) {
    var value = arg.value, subject = arg.subject;
    subject.next(value);
    subject.complete();
}
function dispatchError(arg) {
    var err = arg.err, subject = arg.subject;
    subject.error(err);
}
//# sourceMappingURL=BoundNodeCallbackObservable.js.map

/***/ }),

/***/ "X2ud":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var combineLatest_1 = __webpack_require__("A7JX");
/**
 * Converts a higher-order Observable into a first-order Observable by waiting
 * for the outer Observable to complete, then applying {@link combineLatest}.
 *
 * <span class="informal">Flattens an Observable-of-Observables by applying
 * {@link combineLatest} when the Observable-of-Observables completes.</span>
 *
 * <img src="./img/combineAll.png" width="100%">
 *
 * Takes an Observable of Observables, and collects all Observables from it.
 * Once the outer Observable completes, it subscribes to all collected
 * Observables and combines their values using the {@link combineLatest}
 * strategy, such that:
 * - Every time an inner Observable emits, the output Observable emits.
 * - When the returned observable emits, it emits all of the latest values by:
 *   - If a `project` function is provided, it is called with each recent value
 *     from each inner Observable in whatever order they arrived, and the result
 *     of the `project` function is what is emitted by the output Observable.
 *   - If there is no `project` function, an array of all of the most recent
 *     values is emitted by the output Observable.
 *
 * @example <caption>Map two click events to a finite interval Observable, then apply combineAll</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map(ev =>
 *   Rx.Observable.interval(Math.random()*2000).take(3)
 * ).take(2);
 * var result = higherOrder.combineAll();
 * result.subscribe(x => console.log(x));
 *
 * @see {@link combineLatest}
 * @see {@link mergeAll}
 *
 * @param {function} [project] An optional function to map the most recent
 * values from each inner Observable into a new result. Takes each of the most
 * recent values from each collected inner Observable as arguments, in order.
 * @return {Observable} An Observable of projected results or arrays of recent
 * values.
 * @method combineAll
 * @owner Observable
 */
function combineAll(project) {
    return this.lift(new combineLatest_1.CombineLatestOperator(project));
}
exports.combineAll = combineAll;
//# sourceMappingURL=combineAll.js.map

/***/ }),

/***/ "XKof":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var timeInterval_1 = __webpack_require__("sVus");
Observable_1.Observable.prototype.timeInterval = timeInterval_1.timeInterval;
//# sourceMappingURL=timeInterval.js.map

/***/ }),

/***/ "XO5T":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var subscribeToResult_1 = __webpack_require__("CURp");
var OuterSubscriber_1 = __webpack_require__("wAkD");
/* tslint:enable:max-line-length */
/**
 * Projects each source value to an Observable which is merged in the output
 * Observable.
 *
 * <span class="informal">Maps each value to an Observable, then flattens all of
 * these inner Observables using {@link mergeAll}.</span>
 *
 * <img src="./img/mergeMap.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an Observable, and then merging those resulting Observables and
 * emitting the results of this merger.
 *
 * @example <caption>Map and flatten each letter to an Observable ticking every 1 second</caption>
 * var letters = Rx.Observable.of('a', 'b', 'c');
 * var result = letters.mergeMap(x =>
 *   Rx.Observable.interval(1000).map(i => x+i)
 * );
 * result.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // a0
 * // b0
 * // c0
 * // a1
 * // b1
 * // c1
 * // continues to list a,b,c with respective ascending integers
 *
 * @see {@link concatMap}
 * @see {@link exhaustMap}
 * @see {@link merge}
 * @see {@link mergeAll}
 * @see {@link mergeMapTo}
 * @see {@link mergeScan}
 * @see {@link switchMap}
 *
 * @param {function(value: T, ?index: number): ObservableInput} project A function
 * that, when applied to an item emitted by the source Observable, returns an
 * Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @return {Observable} An Observable that emits the result of applying the
 * projection function (and the optional `resultSelector`) to each item emitted
 * by the source Observable and merging the results of the Observables obtained
 * from this transformation.
 * @method mergeMap
 * @owner Observable
 */
function mergeMap(project, resultSelector, concurrent) {
    if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
    if (typeof resultSelector === 'number') {
        concurrent = resultSelector;
        resultSelector = null;
    }
    return this.lift(new MergeMapOperator(project, resultSelector, concurrent));
}
exports.mergeMap = mergeMap;
var MergeMapOperator = (function () {
    function MergeMapOperator(project, resultSelector, concurrent) {
        if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
        this.project = project;
        this.resultSelector = resultSelector;
        this.concurrent = concurrent;
    }
    MergeMapOperator.prototype.call = function (observer, source) {
        return source.subscribe(new MergeMapSubscriber(observer, this.project, this.resultSelector, this.concurrent));
    };
    return MergeMapOperator;
}());
exports.MergeMapOperator = MergeMapOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var MergeMapSubscriber = (function (_super) {
    __extends(MergeMapSubscriber, _super);
    function MergeMapSubscriber(destination, project, resultSelector, concurrent) {
        if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
        _super.call(this, destination);
        this.project = project;
        this.resultSelector = resultSelector;
        this.concurrent = concurrent;
        this.hasCompleted = false;
        this.buffer = [];
        this.active = 0;
        this.index = 0;
    }
    MergeMapSubscriber.prototype._next = function (value) {
        if (this.active < this.concurrent) {
            this._tryNext(value);
        }
        else {
            this.buffer.push(value);
        }
    };
    MergeMapSubscriber.prototype._tryNext = function (value) {
        var result;
        var index = this.index++;
        try {
            result = this.project(value, index);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        this.active++;
        this._innerSub(result, value, index);
    };
    MergeMapSubscriber.prototype._innerSub = function (ish, value, index) {
        this.add(subscribeToResult_1.subscribeToResult(this, ish, value, index));
    };
    MergeMapSubscriber.prototype._complete = function () {
        this.hasCompleted = true;
        if (this.active === 0 && this.buffer.length === 0) {
            this.destination.complete();
        }
    };
    MergeMapSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        if (this.resultSelector) {
            this._notifyResultSelector(outerValue, innerValue, outerIndex, innerIndex);
        }
        else {
            this.destination.next(innerValue);
        }
    };
    MergeMapSubscriber.prototype._notifyResultSelector = function (outerValue, innerValue, outerIndex, innerIndex) {
        var result;
        try {
            result = this.resultSelector(outerValue, innerValue, outerIndex, innerIndex);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    MergeMapSubscriber.prototype.notifyComplete = function (innerSub) {
        var buffer = this.buffer;
        this.remove(innerSub);
        this.active--;
        if (buffer.length > 0) {
            this._next(buffer.shift());
        }
        else if (this.active === 0 && this.hasCompleted) {
            this.destination.complete();
        }
    };
    return MergeMapSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
exports.MergeMapSubscriber = MergeMapSubscriber;
//# sourceMappingURL=mergeMap.js.map

/***/ }),

/***/ "XVVf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("3j3K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_object_extend__ = __webpack_require__("xZ/u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base__ = __webpack_require__("TwGT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__media_query_media_monitor__ = __webpack_require__("bWt6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__layout__ = __webpack_require__("Sxsi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__layout_wrap__ = __webpack_require__("jazq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_basis_validator__ = __webpack_require__("ytmK");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FlexDirective; });
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */







/**
 * Directive to control the size of a flex item using flex-basis, flex-grow, and flex-shrink.
 * Corresponds to the css `flex` shorthand property.
 *
 * @see https://css-tricks.com/snippets/css/a-guide-to-flexbox/
 */
var FlexDirective = (function (_super) {
    __extends(FlexDirective, _super);
    /* tslint:enable */
    // Explicitly @SkipSelf on LayoutDirective and LayoutWrapDirective because we want the
    // parent flex container for this flex item.
    function FlexDirective(monitor, elRef, renderer, _container, _wrap) {
        var _this = _super.call(this, monitor, elRef, renderer) || this;
        _this._container = _container;
        _this._wrap = _wrap;
        /** The flex-direction of this element's flex container. Defaults to 'row'. */
        _this._layout = 'row';
        _this._cacheInput("flex", "");
        _this._cacheInput("shrink", 1);
        _this._cacheInput("grow", 1);
        if (_container) {
            // If this flex item is inside of a flex container marked with
            // Subscribe to layout immediate parent direction changes
            _this._layoutWatcher = _container.layout$.subscribe(function (direction) {
                // `direction` === null if parent container does not have a `fxLayout`
                _this._onLayoutChange(direction);
            });
        }
        return _this;
    }
    Object.defineProperty(FlexDirective.prototype, "shrink", {
        /* tslint:disable */
        set: function (val) { this._cacheInput("shrink", val); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(FlexDirective.prototype, "grow", {
        set: function (val) { this._cacheInput("grow", val); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(FlexDirective.prototype, "flex", {
        set: function (val) { this._cacheInput("flex", val); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(FlexDirective.prototype, "flexXs", {
        set: function (val) { this._cacheInput('flexXs', val); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(FlexDirective.prototype, "flexSm", {
        set: function (val) { this._cacheInput('flexSm', val); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(FlexDirective.prototype, "flexMd", {
        set: function (val) { this._cacheInput('flexMd', val); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(FlexDirective.prototype, "flexLg", {
        set: function (val) { this._cacheInput('flexLg', val); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(FlexDirective.prototype, "flexXl", {
        set: function (val) { this._cacheInput('flexXl', val); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(FlexDirective.prototype, "flexGtXs", {
        set: function (val) { this._cacheInput('flexGtXs', val); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(FlexDirective.prototype, "flexGtSm", {
        set: function (val) { this._cacheInput('flexGtSm', val); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(FlexDirective.prototype, "flexGtMd", {
        set: function (val) { this._cacheInput('flexGtMd', val); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(FlexDirective.prototype, "flexGtLg", {
        set: function (val) { this._cacheInput('flexGtLg', val); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(FlexDirective.prototype, "flexLtSm", {
        set: function (val) { this._cacheInput('flexLtSm', val); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(FlexDirective.prototype, "flexLtMd", {
        set: function (val) { this._cacheInput('flexLtMd', val); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(FlexDirective.prototype, "flexLtLg", {
        set: function (val) { this._cacheInput('flexLtLg', val); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(FlexDirective.prototype, "flexLtXl", {
        set: function (val) { this._cacheInput('flexLtXl', val); },
        enumerable: true,
        configurable: true
    });
    ;
    /**
     * For @Input changes on the current mq activation property, see onMediaQueryChanges()
     */
    FlexDirective.prototype.ngOnChanges = function (changes) {
        if (changes['flex'] != null || this._mqActivation) {
            this._updateStyle();
        }
    };
    /**
     * After the initial onChanges, build an mqActivation object that bridges
     * mql change events to onMediaQueryChange handlers
     */
    FlexDirective.prototype.ngOnInit = function () {
        var _this = this;
        this._listenForMediaQueryChanges('flex', '', function (changes) {
            _this._updateStyle(changes.value);
        });
        this._updateStyle();
    };
    FlexDirective.prototype.ngOnDestroy = function () {
        _super.prototype.ngOnDestroy.call(this);
        if (this._layoutWatcher) {
            this._layoutWatcher.unsubscribe();
        }
    };
    /**
     * Caches the parent container's 'flex-direction' and updates the element's style.
     * Used as a handler for layout change events from the parent flex container.
     */
    FlexDirective.prototype._onLayoutChange = function (direction) {
        this._layout = direction || this._layout || "row";
        this._updateStyle();
    };
    FlexDirective.prototype._updateStyle = function (value) {
        var flexBasis = value || this._queryInput("flex") || '';
        if (this._mqActivation) {
            flexBasis = this._mqActivation.activatedInput;
        }
        var basis = String(flexBasis).replace(";", "");
        var parts = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_basis_validator__["a" /* validateBasis */])(basis, this._queryInput("grow"), this._queryInput("shrink"));
        this._applyStyleToElement(this._validateValue.apply(this, parts));
    };
    /**
     * Validate the value to be one of the acceptable value options
     * Use default fallback of "row"
     */
    FlexDirective.prototype._validateValue = function (grow, shrink, basis) {
        // The flex-direction of this element's flex container. Defaults to 'row'.
        var layout = this._getFlowDirection(this.parentElement, true);
        var direction = (layout.indexOf('column') > -1) ? 'column' : 'row';
        var css, isValue;
        grow = (grow == "0") ? 0 : grow;
        shrink = (shrink == "0") ? 0 : shrink;
        // flex-basis allows you to specify the initial/starting main-axis size of the element,
        // before anything else is computed. It can either be a percentage or an absolute value.
        // It is, however, not the breaking point for flex-grow/shrink properties
        //
        // flex-grow can be seen as this:
        //   0: Do not stretch. Either size to element's content width, or obey 'flex-basis'.
        //   1: (Default value). Stretch; will be the same size to all other flex items on
        //       the same row since they have a default value of 1.
        //   ≥2 (integer n): Stretch. Will be n times the size of other elements
        //      with 'flex-grow: 1' on the same row.
        // Use `null` to clear existing styles.
        var clearStyles = {
            'max-width': null,
            'max-height': null,
            'min-width': null,
            'min-height': null
        };
        switch (basis || '') {
            case '':
                css = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_object_extend__["a" /* extendObject */])(clearStyles, { 'flex': '1 1 0.000000001px' });
                break;
            case 'initial': // default
            case 'nogrow':
                grow = 0;
                css = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_object_extend__["a" /* extendObject */])(clearStyles, { 'flex': '0 1 auto' });
                break;
            case 'grow':
                css = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_object_extend__["a" /* extendObject */])(clearStyles, { 'flex': '1 1 100%' });
                break;
            case 'noshrink':
                shrink = 0;
                css = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_object_extend__["a" /* extendObject */])(clearStyles, { 'flex': '1 0 auto' });
                break;
            case 'auto':
                css = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_object_extend__["a" /* extendObject */])(clearStyles, { 'flex': grow + " " + shrink + " auto" });
                break;
            case 'none':
                grow = 0;
                shrink = 0;
                css = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_object_extend__["a" /* extendObject */])(clearStyles, { 'flex': '0 0 auto' });
                break;
            default:
                var hasCalc = String(basis).indexOf('calc') > -1;
                var isPercent = String(basis).indexOf('%') > -1 && !hasCalc;
                isValue = hasCalc ||
                    String(basis).indexOf('px') > -1 ||
                    String(basis).indexOf('em') > -1 ||
                    String(basis).indexOf('vw') > -1 ||
                    String(basis).indexOf('vh') > -1;
                // Defaults to percentage sizing unless `px` is explicitly set
                if (!isValue && !isPercent && !isNaN(basis)) {
                    basis = basis + '%';
                }
                if (basis === '0px') {
                    basis = '0%';
                }
                // Set max-width = basis if using layout-wrap
                // tslint:disable-next-line:max-line-length
                // @see https://github.com/philipwalton/flexbugs#11-min-and-max-size-declarations-are-ignored-when-wrappifl-flex-items
                css = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_object_extend__["a" /* extendObject */])(clearStyles, {
                    'flex': grow + " " + shrink + " " + ((isValue || this._wrap) ? basis : '100%'),
                });
                break;
        }
        var max = (direction === 'row') ? 'max-width' : 'max-height';
        var min = (direction === 'row') ? 'min-width' : 'min-height';
        var usingCalc = (String(basis).indexOf('calc') > -1) || (basis == 'auto');
        var isPx = String(basis).indexOf('px') > -1 || usingCalc;
        // make box inflexible when shrink and grow are both zero
        // should not set a min when the grow is zero
        // should not set a max when the shrink is zero
        var isFixed = !grow && !shrink;
        css[min] = (basis == '0%') ? 0 : isFixed || (isPx && grow) ? basis : null;
        css[max] = (basis == '0%') ? 0 : isFixed || (!usingCalc && shrink) ? basis : null;
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_object_extend__["a" /* extendObject */])(css, { 'box-sizing': 'border-box' });
    };
    Object.defineProperty(FlexDirective.prototype, "parentElement", {
        get: function () {
            return this._elementRef.nativeElement.parentNode;
        },
        enumerable: true,
        configurable: true
    });
    return FlexDirective;
}(__WEBPACK_IMPORTED_MODULE_2__base__["a" /* BaseFxDirective */]));

FlexDirective.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{ selector: "\n  [fxFlex],\n  [fxFlex.xs], [fxFlex.sm], [fxFlex.md], [fxFlex.lg], [fxFlex.xl],\n  [fxFlex.lt-sm], [fxFlex.lt-md], [fxFlex.lt-lg], [fxFlex.lt-xl],\n  [fxFlex.gt-xs], [fxFlex.gt-sm], [fxFlex.gt-md], [fxFlex.gt-lg],\n"
            },] },
];
/** @nocollapse */
FlexDirective.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_3__media_query_media_monitor__["a" /* MediaMonitor */], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer2"], },
    { type: __WEBPACK_IMPORTED_MODULE_4__layout__["a" /* LayoutDirective */], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["SkipSelf"] },] },
    { type: __WEBPACK_IMPORTED_MODULE_5__layout_wrap__["a" /* LayoutWrapDirective */], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["SkipSelf"] },] },
]; };
FlexDirective.propDecorators = {
    'shrink': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxShrink',] },],
    'grow': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxGrow',] },],
    'flex': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxFlex',] },],
    'flexXs': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxFlex.xs',] },],
    'flexSm': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxFlex.sm',] },],
    'flexMd': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxFlex.md',] },],
    'flexLg': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxFlex.lg',] },],
    'flexXl': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxFlex.xl',] },],
    'flexGtXs': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxFlex.gt-xs',] },],
    'flexGtSm': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxFlex.gt-sm',] },],
    'flexGtMd': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxFlex.gt-md',] },],
    'flexGtLg': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxFlex.gt-lg',] },],
    'flexLtSm': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxFlex.lt-sm',] },],
    'flexLtMd': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxFlex.lt-md',] },],
    'flexLtLg': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxFlex.lt-lg',] },],
    'flexLtXl': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxFlex.lt-xl',] },],
};
//# sourceMappingURL=flex.js.map

/***/ }),

/***/ "XZ4o":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var repeat_1 = __webpack_require__("0GXu");
Observable_1.Observable.prototype.repeat = repeat_1.repeat;
//# sourceMappingURL=repeat.js.map

/***/ }),

/***/ "Xajo":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.isArray = Array.isArray || (function (x) { return x && typeof x.length === 'number'; });
//# sourceMappingURL=isArray.js.map

/***/ }),

/***/ "XlOA":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var combineLatest_1 = __webpack_require__("UmTU");
Observable_1.Observable.combineLatest = combineLatest_1.combineLatest;
//# sourceMappingURL=combineLatest.js.map

/***/ }),

/***/ "XvGf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var OuterSubscriber_1 = __webpack_require__("wAkD");
var subscribeToResult_1 = __webpack_require__("CURp");
/**
 * Converts a higher-order Observable into a first-order Observable by
 * subscribing to only the most recently emitted of those inner Observables.
 *
 * <span class="informal">Flattens an Observable-of-Observables by dropping the
 * previous inner Observable once a new one appears.</span>
 *
 * <img src="./img/switch.png" width="100%">
 *
 * `switch` subscribes to an Observable that emits Observables, also known as a
 * higher-order Observable. Each time it observes one of these emitted inner
 * Observables, the output Observable subscribes to the inner Observable and
 * begins emitting the items emitted by that. So far, it behaves
 * like {@link mergeAll}. However, when a new inner Observable is emitted,
 * `switch` unsubscribes from the earlier-emitted inner Observable and
 * subscribes to the new inner Observable and begins emitting items from it. It
 * continues to behave like this for subsequent inner Observables.
 *
 * @example <caption>Rerun an interval Observable on every click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * // Each click event is mapped to an Observable that ticks every second
 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000));
 * var switched = higherOrder.switch();
 * // The outcome is that `switched` is essentially a timer that restarts
 * // on every click. The interval Observables from older clicks do not merge
 * // with the current interval Observable.
 * switched.subscribe(x => console.log(x));
 *
 * @see {@link combineAll}
 * @see {@link concatAll}
 * @see {@link exhaust}
 * @see {@link mergeAll}
 * @see {@link switchMap}
 * @see {@link switchMapTo}
 * @see {@link zipAll}
 *
 * @return {Observable<T>} An Observable that emits the items emitted by the
 * Observable most recently emitted by the source Observable.
 * @method switch
 * @name switch
 * @owner Observable
 */
function _switch() {
    return this.lift(new SwitchOperator());
}
exports._switch = _switch;
var SwitchOperator = (function () {
    function SwitchOperator() {
    }
    SwitchOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new SwitchSubscriber(subscriber));
    };
    return SwitchOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var SwitchSubscriber = (function (_super) {
    __extends(SwitchSubscriber, _super);
    function SwitchSubscriber(destination) {
        _super.call(this, destination);
        this.active = 0;
        this.hasCompleted = false;
    }
    SwitchSubscriber.prototype._next = function (value) {
        this.unsubscribeInner();
        this.active++;
        this.add(this.innerSubscription = subscribeToResult_1.subscribeToResult(this, value));
    };
    SwitchSubscriber.prototype._complete = function () {
        this.hasCompleted = true;
        if (this.active === 0) {
            this.destination.complete();
        }
    };
    SwitchSubscriber.prototype.unsubscribeInner = function () {
        this.active = this.active > 0 ? this.active - 1 : 0;
        var innerSubscription = this.innerSubscription;
        if (innerSubscription) {
            innerSubscription.unsubscribe();
            this.remove(innerSubscription);
        }
    };
    SwitchSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.destination.next(innerValue);
    };
    SwitchSubscriber.prototype.notifyError = function (err) {
        this.destination.error(err);
    };
    SwitchSubscriber.prototype.notifyComplete = function () {
        this.unsubscribeInner();
        if (this.hasCompleted && this.active === 0) {
            this.destination.complete();
        }
    };
    return SwitchSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=switch.js.map

/***/ }),

/***/ "XwmK":
/***/ (function(module, exports) {

exports.model=Model={Game:{},Board:{},Move:{}},Model.Game.InitGame=function(){for(var t=this,r=this.mOptions.size,a=[],i=[],o=0,e=0,n=[],s=0;s<r;s++)n.push(e),e+=(r-s)*(r-s);for(var s=0;s<r;s++)for(var h=0;h<r-s;h++)for(var l=0;l<r-s;l++){var u=o++;a[u]=[h,l,s],i[u]=[];for(var v=0;v<2;v++)for(var f=0;f<2;f++){var c=s-1,p=h+v,d=l+f;c>=0&&c<r&&p>=0&&p<r-c&&d>=0&&d<r-c?i[u].push(n[c]+p*(r-c)+d):i[u].push(null)}var g=[[0,-1],[0,1],[-1,0],[1,0]];for(var m in g){var G=g[m],c=s,p=h+G[0],d=l+G[1];c>=0&&c<r&&p>=0&&p<r-c&&d>=0&&d<r-c?i[u].push(n[c]+p*(r-c)+d):i[u].push(null)}for(var v=-1;v<1;v++)for(var f=-1;f<1;f++){var c=s+1,p=h+v,d=l+f;c>=0&&c<r&&p>=0&&p<r-c&&d>=0&&d<r-c?i[u].push(n[c]+p*(r-c)+d):i[u].push(null)}}this.g.Graph=i,this.g.Coord=a,this.g.Over=[],this.g.Beneath=[];for(var u=0;u<this.g.Graph.length;u++)this.g.Over[u]=null,this.g.Beneath[u]=null;for(var u=0;u<this.g.Graph.length;u++)for(var a=this.g.Coord[u],b=u+1;b<this.g.Graph.length;b++){var M=this.g.Coord[b];if(M[2]==a[2]+2&&M[0]==a[0]-1&&M[1]==a[1]-1){this.g.Over[u]=b,this.g.Beneath[b]=u;break}}this.g.EachDirection=function(r,a){for(var i=0;i<12;i++){var o=t.g.Graph[r][i];if(null!=o&&0==a(o,i))return}},this.g.EachDirectionDown=function(r,a){for(var i=[0,1,2,3],o=0;o<i.length;o++){var e=t.g.Graph[r][i[o]];if(null!=e&&0==a(e,i[o]))return}},this.g.EachDirectionUp=function(r,a){for(var i=[8,9,10,11],o=0;o<i.length;o++){var e=t.g.Graph[r][i[o]];if(null!=e&&0==a(e,i[o]))return}},this.g.EachDirectionFlat=function(r,a){for(var i=[4,5,6,7],o=0;o<i.length;o++){var e=t.g.Graph[r][i[o]];if(null!=e&&0==a(e,i[o]))return}},this.g.EachDirectionFlatDown=function(r,a){for(var i=[0,1,2,3,4,5,6,7],o=0;o<i.length;o++){var e=t.g.Graph[r][i[o]];if(null!=e&&0==a(e,i[o]))return}},this.g.EachDirectionFlatUp=function(r,a){for(var i=[4,5,6,7,8,9,10,11],o=0;o<i.length;o++){var e=t.g.Graph[r][i[o]];if(null!=e&&0==a(e,i[o]))return}},this.zobrist=new JocGame.Zobrist({board:{type:"array",size:this.g.Graph.length,values:[0,1]}}),this.InitGameExtra()},Model.Game.MapSameLevelDiagGraph=function(){for(var t=[0,16,25,29],r=0;r<4;r++)for(var a=0;a<4-r;a++)for(var i=0;i<4-r;i++)for(var o=t[r]+a*(4-r)+i,e=-1;e<2;e+=2)for(var n=-1;n<2;n+=2){var s=r,h=a+e,l=i+n;s>=0&&s<4&&h>=0&&h<4-s&&l>=0&&l<4-s?this.g.Graph[o].push(t[s]+h*(4-s)+l):this.g.Graph[o].push(null)}},Model.Game.InitGameExtra=function(){},Model.Game.DestroyGame=function(){this.DestroyGameExtra()},Model.Game.DestroyGameExtra=function(){},Model.Game.spUpdateZobrist=function(t,r,a,i,o,e){for(var n=0;n<r.length;n++)t=this.zobrist.update(t,"board",a,r[n]);for(var n=0;n<i.length;n++)t=this.zobrist.update(t,"board",o,i[n]);return t},Model.Move.Init=function(t){for(var r in t)t.hasOwnProperty(r)&&(this[r]=JSON.parse(JSON.stringify(t[r])))},Model.Move.ToString=function(){var t=["?","W","B","R"][this.clr],r="";switch(this.act){case"+":r+="+"+this.pos+t;break;case">":r+=this.from+">"+this.to+t}return r},Model.Board.Init=function(t){},Model.Board.InitialPosition=function(t){this.spInitialPosition(t)},Model.Board.spInitialPosition=function(t){this.board=[];for(var r=0;r<t.g.Graph.length;r++)this.board[r]=0;this.maxLayer=0,this.ballCount=[0,0,0],this.playables={},this.height=[0,0,0],this.zSign=0;for(var r=0;r<t.mOptions.size*t.mOptions.size;r++)this.playables[r]=!0},Model.Board.MakeFreeMoves=function(t){var r=[];for(var a in this.playables)r.push({act:"+",pos:a,clr:this.mWho==JocGame.PLAYER_A?1:2});return r},Model.Board.GenerateMoves=function(t){var r=this.GenerateAllMoves(t),a=t.mOptions.moveCount;0==r.length?(this.mFinished=!0,this.ballCount[1]>this.ballCount[2]?this.mWinner=JocGame.PLAYER_A:this.ballCount[1]<this.ballCount[2]?this.mWinner=JocGame.PLAYER_B:this.mWinner=JocGame.DRAW):void 0!==a&&r.length>a&&(t.ArrayShuffle(r),r.sort(function(t,r){r.nextBoard.evaluation,t.nextBoard.evaluation}),r.splice(a,r.length-a)),this.mMoves=r},Model.Board.GenerateAllMoves=function(t){return this.MakeFreeMoves(t)},Model.Board.Evaluate=function(t,r,a){this.mEvaluation=0},Model.Board.ApplyMove=function(t,r){this.spApplyMove(t,r)},Model.Board.spApplyMove=function(t,r){function a(r){delete i.playables[r],t.g.EachDirectionFlat(r,function(a,o){if(i.board[a]){var e,n;switch(o){case 4:e=7,n=10;break;case 5:e=6,n=9;break;case 6:e=4,n=8;break;case 7:e=5,n=11}var s=t.g.Graph[r][e];null!==s&&i.board[s]>0&&i.board[t.g.Graph[a][e]]&&(i.playables[t.g.Graph[r][n]]=!0)}})}var i=this;switch(r.act){case"+":this.board[r.pos]=r.clr;var o=t.g.Coord[r.pos][2];o>this.maxLayer&&(this.maxLayer=o),this.height[r.clr]+=o,this.ballCount[r.clr]++,a(r.pos);break;case">":r.down.length>0?this.playables[r.down[r.down.length-1]]=!0:this.playables[r.from]=!0;var e=r.from;for(var n in r.down){var s=r.down[n];this.height[this.board[s]]--,this.board[e]=this.board[s],e=s}this.board[e]=0,this.board[r.to]=r.clr;var o=t.g.Coord[r.to][2];this.height[r.clr]+=o,o>this.maxLayer&&(this.maxLayer=o),a(r.to)}},Model.Board.IsValidMove=function(t,r){return!0},Model.Board.ExtendMove=function(t,r){return{}},Model.Board.GetSignature=function(){return this.zSign},Model.Game.InitGameExtra=function(){this.MapSameLevelDiagGraph(),this.BuildSplineLines(),this.g.factor={completion:[[4,2,1],[4,2],[4]],count:.1,sppHeight:1}},Model.Game.BuildSplineLines=function(){for(var t=this,r=[],a=[0,16,25,29],i=0;i<4;i++)for(var o=0;o<4-i;o++)for(var e=0;e<4-i;e++){var n=a[i]+o*(4-i)+e;!function(r,a){for(var i=[7,15,5,13],o=0;o<i.length;o++){var e=t.g.Graph[r][i[o]];null!=e&&a(e,i[o])}}(n,function(a,o){for(var e=[n];null!=a;)e.push(a),a=t.g.Graph[a][o];e.length==4-i&&r.push(e)})}this.g.SplineLines=r},Model.Board.splineEvaluate=function(t,r,a){for(var i=[[0,0,0],[0,0],[0]],o=[[0,0,0],[0,0],[0]],e=0;e<t.g.SplineLines.length;e++){var n=t.g.SplineLines[e],s=t.g.Coord[n[0]][2];if(s>this.maxLayer)break;var h=0,l=0,u=0;for(var v in n){var f=n[v];if(1==this.board[f])l++;else{if(2!=this.board[f]){h++;break}u++}}if(0==h){if(0==l?(this.mFinished=!0,this.mWinner=JocGame.PLAYER_B):0==u&&(this.mFinished=!0,this.mWinner=JocGame.PLAYER_A),this.mFinished)return void(a&&(this.mWinLine=n))}else 0==l&&u>0?o[s][s-u-1]++:0==u&&l>0&&i[s][s-l-1]++}this.mEvaluation=0;for(var e=0;e<3;e++)for(var v=0;v<3-e;v++)this.mEvaluation+=(i[e][v]-o[e][v])*t.g.factor.completion[e][v];this.mEvaluation+=(this.ballCount[1]-this.ballCount[2])*t.g.factor.count},Model.Board.Evaluate=function(){this.splineEvaluate.apply(this,arguments)};

/***/ }),

/***/ "Y/AU":
/***/ (function(module, exports) {

exports.model=Model={Game:{},Board:{},Move:{}},function(){var t;Model.Game.cbConstants={MASK:65535,FLAG_MOVE:65536,FLAG_CAPTURE:131072,FLAG_STOP:262144,FLAG_SCREEN_CAPTURE:524288,FLAG_CAPTURE_KING:1048576,FLAG_CAPTURE_NO_KING:2097152};var e="undefined"!=typeof Int32Array;Model.Game.cbUseTypedArrays=e,Model.Game.cbTypedArray=function(t){if(e){var r=new Int32Array(t.length);return r.set(t),r}for(var i=[],a=t.length,s=0;s<a;s++)i.push(t[s]);return i},Model.Game.cbShortRangeGraph=function(t,e,r,i){var a=this;void 0===i&&(i=196608);for(var s={},n=0;n<t.boardSize;n++)s[n]=[],(!r||n in r)&&e.forEach(function(e){var o=t.Graph(n,e);null!=o&&(!r||o in r)&&s[n].push(a.cbTypedArray([o|i]))});return s},Model.Game.cbLongRangeGraph=function(t,e,r,i,a){var s=this;void 0!==i&&null!=i||(i=196608),a||(a=1/0);for(var n={},o=0;o<t.boardSize;o++)n[o]=[],(!r||o in r)&&e.forEach(function(e){for(var h=[],c=t.Graph(o,e),p=0;null!=c&&(!r||c in r)&&(h.push(c|i),++p!=a);)c=t.Graph(c,e);h.length>0&&n[o].push(s.cbTypedArray(h))});return n},Model.Game.cbNullGraph=function(t){for(var e={},r=0;r<t.boardSize;r++)e[r]=[];return e},Model.Game.cbAuthorGraph=function(t){for(var e={},r=0;r<t.boardSize;r++){e[r]=[];for(var i=0;i<t.boardSize;i++)e[r].push([2293760|i])}return e},Model.Game.cbMergeGraphs=function(t){for(var e=[],r=0;r<t.boardSize;r++){e[r]=[];for(var i=1;i<arguments.length;i++)e[r]=e[r].concat(arguments[i][r])}return e},Model.Game.cbGetThreatGraph=function(){function t(e,r){for(var i in n){var a=n[i];if(!(a.p.length<r.length+1)){for(var s=!0,o=0;o<r.length;o++)if(r[o]!=a.p[o]){s=!1;break}if(s){var h=a.p[r.length],c=e[h];void 0===c&&(c={e:{}},e[h]=c),a.p.length==r.length+1&&(c.t=a.t,c.ts=a.ts,c.tk=a.tk,delete n[i]),r.push(h),t(c.e,r),r.pop()}}}}var e=this;this.cbUseScreenCapture=!1,this.cbUseCaptureKing=!1,this.cbUseCaptureNoKing=!1;for(var r={1:[],"-1":[]},i=[],a=0;a<this.g.boardSize;a++)this.g.pTypes.forEach(function(t,r){t.graph[a].forEach(function(t){for(var s=[],n=0;n<t.length;n++){var o=t[n];1048576&o?(e.cbUseCaptureKing=!0,s.unshift({d:65535&o,a:a,tk:r})):2097152&o?(e.cbUseCaptureNoKing=!0,s.unshift({d:65535&o,a:a,tnk:r})):131072&o?s.unshift({d:65535&o,a:a,t:r}):262144&o?s.unshift({d:65535&o,a:a}):524288&o&&(e.cbUseScreenCapture=!0,s.unshift({d:65535&o,a:a,ts:r}))}s.length>0&&i.push(s)})});var s={};i.forEach(function(t){t.forEach(function(e,r){var i=s[e.d];void 0===i&&(i={},s[e.d]=i);for(var a=[],n=r+1;n<t.length;n++)a.push(t[n].d);a.push(e.a);var o=a.join(","),h=i[o];void 0===h&&(h={p:a,t:{},ts:{},tk:{}},i[o]=h),void 0!==e.t?h.t[e.t]=!0:void 0!==e.tk?h.tk[e.tk]=!0:void 0!==e.ts&&(h.ts[e.ts]=!0)})});for(var a=0;a<e.g.boardSize;a++){var n=s[a],o={};t(o,[]),r[1][a]=o,r[-1][a]=o}return r},Model.Game.InitGame=function(){var e=this;this.cbVar=t=this.cbDefine(),this.g.boardSize=this.cbVar.geometry.boardSize,this.g.pTypes=this.cbGetPieceTypes(),this.g.threatGraph=this.cbGetThreatGraph(),this.g.distGraph=this.cbVar.geometry.GetDistances(),this.cbPiecesCount=0,this.g.castleablePiecesCount={1:0,"-1":0};for(var r in t.pieceTypes){var i=t.pieceTypes[r];if(i.castle){(i.initial||[]).forEach(function(t){e.g.castleablePiecesCount[t.s]++})}i.initial&&(this.cbPiecesCount+=i.initial.length)}for(var a=[],r=0;r<this.cbPiecesCount;r++)a.push(r);var s=Object.keys(t.pieceTypes);this.zobrist=new JocGame.Zobrist({board:{type:"array",size:this.cbVar.geometry.boardSize,values:a},who:{values:["1","-1"]},type:{type:"array",size:this.cbPiecesCount,values:s}})},Model.Game.cbGetPieceTypes=function(){for(var t=[],e={},r=0;r<this.cbVar.geometry.boardSize;r++)e[r]=[];for(var i in this.cbVar.pieceTypes){var a=this.cbVar.pieceTypes[i];t[i]={graph:a.graph||e,abbrev:a.abbrev||"",value:a.isKing?100:a.value||1,isKing:!!a.isKing,castle:!!a.castle,epTarget:!!a.epTarget,epCatch:!!a.epCatch}}return t},Model.Board.Init=function(t){this.zSign=0},Model.Board.InitialPosition=function(r){var i=this;this.board=e?new Int16Array(r.g.boardSize):[];for(var a=0;a<r.g.boardSize;a++)this.board[a]=-1;if(this.kings={},this.pieces=[],this.ending={1:!1,"-1":!1},this.lastMove=null,r.cbVar.castle&&(this.castled={1:!1,"-1":!1}),this.zSign=r.zobrist.update(0,"who",-1),this.noCaptCount=0,this.mWho=1,r.mInitial)this.mWho=r.mInitial.turn||1,r.mInitial.pieces.forEach(function(t){var e={};for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);i.pieces.push(e)}),r.mInitial.lastMove&&(this.lastMove={f:r.mInitial.lastMove.f,t:r.mInitial.lastMove.t}),void 0!==r.mInitial.noCaptCount&&(this.noCaptCount=r.mInitial.noCaptCount),r.cbVar.castle&&r.mInitial.castle&&(this.castled={1:{k:!!r.mInitial.castle[1]&&!!r.mInitial.castle[1].k,q:!!r.mInitial.castle[1]&&!!r.mInitial.castle[1].q},"-1":{k:!!r.mInitial.castle[-1]&&!!r.mInitial.castle[-1].k,q:!!r.mInitial.castle[-1]&&!!r.mInitial.castle[-1].q}});else for(var s in r.cbVar.pieceTypes)for(var n=r.cbVar.pieceTypes[s],o=n.initial||[],h=0;h<o.length;h++){var c=o[h],p={s:c.s,t:parseInt(s),p:c.p,m:!1};this.pieces.push(p)}if(this.pieces.sort(function(t,e){if(t.s!=e.s)return e.s-t.s;var i=r.cbVar.pieceTypes[t.t].value||100,a=r.cbVar.pieceTypes[e.t].value||100;return i!=a?i-a:t.p-e.p}),this.pieces.forEach(function(t,e){t.i=e,i.board[t.p]=e,r.g.pTypes[t.t].isKing&&(i.kings[t.s]=t.p),i.zSign=r.zobrist.update(i.zSign,"board",e,t.p),i.zSign=r.zobrist.update(i.zSign,"type",t.t,e)}),r.mInitial&&r.mInitial.enPassant){var a=t.geometry.PosByName(r.mInitial.enPassant);if(a>=0){var l,u=t.geometry.C(a),v=t.geometry.R(a);l=1==r.mInitial.turn?t.geometry.POS(u,v-1):t.geometry.POS(u,v+1),this.epTarget={p:a,i:this.board[l]}}}},Model.Board.CopyFrom=function(t){if(e)this.board=new Int16Array(t.board.length),this.board.set(t.board);else{this.board=[];for(var r=t.board,i=r.length,a=0;a<i;a++)this.board.push(r[a])}this.pieces=[];for(var s=t.pieces.length,a=0;a<s;a++){var n=t.pieces[a];this.pieces.push({s:n.s,p:n.p,t:n.t,i:n.i,m:n.m})}this.kings={1:t.kings[1],"-1":t.kings[-1]},this.check=t.check,t.lastMove?this.lastMove={f:t.lastMove.f,t:t.lastMove.t,c:t.lastMove.c}:this.lastMove=null,this.ending={1:t.ending[1],"-1":t.ending[-1]},void 0!==t.castled&&(this.castled={1:t.castled[1],"-1":t.castled[-1]}),this.noCaptCount=t.noCaptCount,t.epTarget?this.epTarget={p:t.epTarget.p,i:t.epTarget.i}:this.epTarget=null,this.mWho=t.mWho,this.zSign=t.zSign},Model.Board.cbApplyCastle=function(t,e,r){var i=t.cbVar.castle[e.f+"/"+e.cg],a=i.r[i.r.length-1],s=this.pieces[this.board[e.cg]],n=i.k[i.k.length-1],o=this.pieces[this.board[e.f]];return r&&(this.zSign=t.zobrist.update(this.zSign,"board",s.i,e.cg),this.zSign=t.zobrist.update(this.zSign,"board",s.i,a),this.zSign=t.zobrist.update(this.zSign,"board",o.i,e.f),this.zSign=t.zobrist.update(this.zSign,"board",o.i,n)),s.p=a,s.m=!0,this.board[e.cg]=-1,o.p=n,o.m=!0,this.board[e.f]=-1,this.board[a]=s.i,this.board[n]=o.i,this.castled[s.s]=!0,this.kings[o.s]=n,[{i:s.i,f:a,t:-1},{i:o.i,f:n,t:e.f,kp:e.f,who:o.s,m:!1},{i:s.i,f:-1,t:e.cg,m:!1,cg:!1}]},Model.Board.cbQuickApply=function(t,e){if(void 0!==e.cg)return this.cbApplyCastle(t,e,!1);var r=[],i=this.board[e.f],a=this.pieces[i];if(null!=e.c){r.unshift({i:e.c,f:-1,t:this.pieces[e.c].p});var s=this.pieces[e.c];this.board[s.p]=-1,s.p=-1}var n=this.kings[a.s];return t.g.pTypes[a.t].isKing&&(this.kings[a.s]=e.t),r.unshift({i:i,f:e.t,t:e.f,kp:n,who:a.s,ty:a.t}),a.p=e.t,void 0!==e.pr&&(a.t=e.pr),this.board[e.f]=-1,this.board[e.t]=i,r},Model.Board.cbQuickUnapply=function(t,e){for(var r=0;r<e.length;r++){var i=e[r],a=this.pieces[i.i];i.f>=0&&(a.p=-1,this.board[i.f]=-1),i.t>=0&&(a.p=i.t,this.board[i.t]=i.i),void 0!==i.m&&(a.m=i.m),void 0!==i.kp&&(this.kings[i.who]=i.kp),void 0!=i.ty&&(a.t=i.ty),void 0!=i.cg&&(this.castled[a.s]=i.cg)}},Model.Board.ApplyMove=function(t,e){var r=this.pieces[this.board[e.f]];if(void 0!==e.cg)this.cbApplyCastle(t,e,!0);else{if(this.zSign=t.zobrist.update(this.zSign,"board",r.i,e.f),this.board[r.p]=-1,void 0!==e.pr&&(this.zSign=t.zobrist.update(this.zSign,"type",r.t,r.i),r.t=e.pr,this.zSign=t.zobrist.update(this.zSign,"type",r.t,r.i)),null!=e.c){var i=this.pieces[e.c];this.zSign=t.zobrist.update(this.zSign,"board",i.i,i.p),this.board[i.p]=-1,i.p=-1,i.m=!0,this.noCaptCount=0}else this.noCaptCount++;r.p=e.t,r.m=!0,this.board[e.t]=r.i,this.zSign=t.zobrist.update(this.zSign,"board",r.i,e.t),t.g.pTypes[r.t].isKing&&(this.kings[r.s]=e.t)}this.check=!!e.ck,this.lastMove={f:e.f,t:e.t,c:e.c},void 0!==e.ko&&(this.ending[r.s]=e.ko),void 0!==e.ept?this.epTarget={p:e.ept,i:r.i}:this.epTarget=null,this.zSign=t.zobrist.update(this.zSign,"who",-this.mWho),this.zSign=t.zobrist.update(this.zSign,"who",this.mWho)},Model.Board.Evaluate=function(r){function i(e){var r=1/0;for(var i in t.geometry.corners)r=Math.min(r,h.distGraph[s.kings[e]][i]);return r-Math.sqrt(h.boardSize)}var a="debug"==arguments[3],s=this;this.mEvaluation=0;var n,o=this.mWho,h=r.g;if(e)n={1:{count:new Uint8Array(h.pTypes.length),byType:{}},"-1":{count:new Uint8Array(h.pTypes.length),byType:{}}};else{n={1:{count:[],byType:{}},"-1":{count:[],byType:{}}};for(var c=0;c<h.pTypes.length;c++)n[1].count[c]=n[-1].count[c]=0}if(r.mOptions.preventRepeat&&r.GetRepeatOccurence(this)>2)return this.mFinished=!0,void(this.mWinner=r.cbOnPerpetual?o*r.cbOnPerpetual:JocGame.DRAW);for(var p={1:0,"-1":0},l={1:h.distGraph[this.kings[-1]],"-1":h.distGraph[this.kings[1]]},u={1:0,"-1":0},v={1:0,"-1":0},b={1:0,"-1":0},f={1:0,"-1":0},g={1:!1,"-1":!1},d=this.pieces,m=d.length,c=0;c<m;c++){var G=d[c];if(G.p>=0){var y=G.s,M=h.pTypes[G.t];M.isKing?g[y]=G.m:p[y]+=M.value,M.castle&&!G.m&&f[y]++,v[y]++,u[y]+=l[y][G.p],b[y]+=t.geometry.distEdge[G.p];var C=n[y];C.count[G.t]++;var S=C.byType;void 0===S[G.t]?S[G.t]=[G]:S[G.t].push(G)}}if(this.lastMove&&null!=this.lastMove.c){var G=this.pieces[this.board[this.lastMove.t]];p[-G.s]+=this.cbStaticExchangeEval(r,G.p,G.s,{piece:G})}var k={1:0,"-1":0},A={1:0,"-1":0},T={1:0,"-1":0};this.ending[1]&&(A[1]=(u[1]-Math.sqrt(h.boardSize))/v[1],t.geometry.corners&&(T[1]=i(1))),this.ending[-1]&&(A[-1]=(u[-1]-Math.sqrt(h.boardSize))/v[-1],t.geometry.corners&&(T[1]=i(-1)));var z={pieceValue:p[1]-p[-1],pieceValueRatio:(p[1]-p[-1])/(p[1]+p[-1]+1),posValue:b[1]-b[-1],averageDistKing:u[1]/v[1]-u[-1]/v[-1],check:this.check?-o:0,endingKingFreedom:k[1]-k[-1],endingDistKing:A[1]-A[-1],distKingCorner:T[1]-T[-1]};t.castle&&(z.castle=(this.castled[1]?1:g[1]?0:f[1]/(h.castleablePiecesCount[1]+1))-(this.castled[-1]?1:g[-1]?0:f[-1]/(h.castleablePiecesCount[-1]+1))),t.evaluate&&t.evaluate.call(this,r,z,n);var E=r.mOptions.levelOptions;for(var P in z){var w=z[P],I=E[P+"Factor"]||0,R=w*I;a&&console.log(P,"=",w,"*",I,"=>",R),this.mEvaluation+=R}a&&console.log("Evaluation",this.mEvaluation)},Model.Board.cbGeneratePseudoLegalMoves=function(t){function e(e,a){var s=t.cbVar.promote;if(!s)return void i.push(a);var n=s.call(r,t,e,a);if(null!=n)if(0==n.length)i.push(a);else if(1==n.length)a.pr=n[0],i.push(a);else for(var o=0;o<n.length;o++){var h=n[o];i.push({f:a.f,t:a.t,c:a.c,pr:h,ept:a.ept,ep:a.ep,a:a.a})}}for(var r=this,i=[],a=t.cbVar,s=this.mWho,n=!a.castle||this.check||this.castled[s]?null:[],o=-1,h=this.pieces.length,c=0;c<h;c++){var p=this.pieces[c];if(!(p.p<0||p.s!=s)){var l=t.g.pTypes[p.t];l.isKing&&(p.m?n=null:o=p),n&&l.castle&&!p.m&&n.push(p);var u,v;u=l.graph[p.p],v=u.length;for(var b=0;b<v;b++)for(var f=u[b],g=!1,d=f.length,m=null,G=0;G<d;G++){var y=f[G],M=65535&y,C=this.board[M];if(!(C<0)||l.epCatch&&this.epTarget&&this.epTarget.p==M){if(!(524288&y)){var S;S=C<0?this.pieces[this.epTarget.i]:this.pieces[C],!(S.s!=p.s&&131072&y)||1048576&y&&!t.g.pTypes[S.t].isKing||2097152&y&&t.g.pTypes[S.t].isKing||e(p,{f:p.p,t:M,c:S.i,a:l.abbrev,ep:C<0});break}if(g){var S=this.pieces[C];S.s!=p.s&&e(p,{f:p.p,t:M,c:S.i,a:l.abbrev});break}g=!0}else 65536&y&&0==g&&e(p,{f:p.p,t:M,c:null,a:l.abbrev,ept:null!=m&&l.epTarget?m:void 0});m=M}}}if(n)for(var c=0;c<n.length;c++){var k=n[c],A=t.cbVar.castle[o.p+"/"+k.p];if(A){for(var T=!0,b=0;b<A.r.length;b++){var z=A.r[b];if(this.board[z]>=0&&z!=o.p&&z!=k.p){T=!1;break}}if(T){for(var E=!0,b=0;b<A.k.length;b++){var z=A.k[b];if(this.board[z]>=0&&z!=k.p&&z!=o.p||this.cbGetAttackers(t,z,s).length>0){E=!1;break}}E&&i.push({f:o.p,t:A.k[A.k.length-1],c:null,cg:k.p})}}}return i},Model.Board.cbStaticExchangeEval=function(t,e,r,i){var a=0,s=this.cbGetSmallestAttacker(t,e,r);if(s){var n=this.mWho;this.mWho=s.s;var o=this.cbQuickApply(t,{f:s.p,t:e,c:i.piece.i}),h=t.g.pTypes[i.piece.t].value;i.piece=s,a=Math.max(0,h-this.cbStaticExchangeEval(t,e,-r,i)),this.cbQuickUnapply(t,o),this.mWho=n}return a},Model.Board.cbGetSmallestAttacker=function(t,e,r){var i=this.cbGetAttackers(t,e,r);if(0==i.length)return null;for(var a=1/0,s=null,n=i.length,o=0;o<n;o++){var h=i[o],c=t.g.pTypes[h.t].value;c<a&&(a=c,s=h)}return s},Model.Board.cbCollectAttackers=function(t,e,r,i){for(var a in e){var s=e[a],n=this.board[a];if(n<0)this.cbCollectAttackers(t,s.e,r,i);else{var o=this.pieces[n];o.s==-t&&(s.t&&o.t in s.t||i&&s.tk&&o.t in s.tk)&&r.push(o)}}},Model.Board.cbCollectAttackersScreen=function(t,e,r,i,a){for(var s in e){var n=e[s],o=this.board[s];if(o<0)this.cbCollectAttackersScreen(t,n.e,r,i,a);else{var h=this.pieces[o];!a&&h.s==-t&&(n.t&&h.t in n.t||i&&n.tk&&h.t in n.tk)?r.push(h):a?a&&h.s==-t&&n.ts&&h.t in n.ts&&r.push(h):this.cbCollectAttackersScreen(t,n.e,r,i,!0)}}},Model.Board.cbGetAttackers=function(t,e,r,i){var a=[];return t.cbUseScreenCapture?this.cbCollectAttackersScreen(r,t.g.threatGraph[r][e],a,i,!1):this.cbCollectAttackers(r,t.g.threatGraph[r][e],a,i),a},Model.Board.GenerateMoves=function(t){var e=this.cbGeneratePseudoLegalMoves(t);this.mMoves=[];for(var r=!0,i=this.kings[this.mWho],a=e.length,s=0;s<a;s++){var n=e[s],o=this.cbQuickApply(t,n);if(!(this.cbGetAttackers(t,this.kings[this.mWho],this.mWho,!0).length>0)){var h=this.cbGetAttackers(t,this.kings[-this.mWho],-this.mWho,!0).length>0;n.ck=h,this.mMoves.push(n),n.f!=i&&(r=!1)}this.cbQuickUnapply(t,o)}if(0==this.mMoves.length)this.mFinished=!0,this.mWinner=t.cbOnStaleMate?t.cbOnStaleMate*this.mWho:JocGame.DRAW,this.check&&(this.mWinner=-this.mWho);else if(this.ending[this.mWho]){if(!r)for(var s=0;s<this.mMoves.length;s++)this.mMoves[s].ko=!1}else if(!this.ending[this.mWho]&&r&&!this.check)for(var s=0;s<this.mMoves.length;s++)this.mMoves[s].ko=!0},Model.Board.GetSignature=function(){return this.zSign},Model.Move.Init=function(t){for(var e in t)t.hasOwnProperty(e)&&(this[e]=t[e])},Model.Move.Equals=function(t){return this.f==t.f&&this.t==t.t&&this.pr==t.pr},Model.Move.CopyFrom=function(t){this.Init(t)},Model.Move.ToString=function(e){var r=this;switch(e=e||"natural"){case"natural":return function(){var e;if(void 0!==r.cg?e=t.castle[r.f+"/"+r.cg].n:(e=r.a||"",e+=t.geometry.PosName(r.f),null==r.c?e+="-":e+="x",e+=t.geometry.PosName(r.t)),void 0!==r.pr){var i=t.pieceTypes[r.pr];i&&i.abbrev&&i.abbrev.length>0&&!i.silentPromo&&(e+="="+i.abbrev)}return r.ck&&(e+="+"),e}();case"engine":return function(){var e=t.geometry.PosName(r.f)+t.geometry.PosName(r.t);if(void 0!=r.pr){var i=t.pieceTypes[r.pr];i&&i.abbrev&&i.abbrev.length>0&&!i.silentPromo&&(e+=i.abbrev)}return e}();default:return"??"}},Model.Board.CompactMoveString=function(e,r,i){"function"!=typeof r.ToString&&(r=e.CreateMove(r));var a=r.ToString(),s=/^([A-Z]?)([a-z])([1-9][0-9]*)([-x])([a-z])([1-9][0-9]*)(.*?)$/.exec(a);if(!s)return a;var n=s[7];if(i||(i={}),i.value||(i.value=[]),0==i.value.length){var o=this.mMoves;this.mMoves&&0!=this.mMoves.length||this.GenerateMoves(e);for(var h=0;h<this.mMoves.length;h++){var c=this.mMoves[h];"function"!=typeof c.ToString&&(c=e.CreateMove(c)),i.value.push({str:c.ToString(),move:c})}this.mMoves=o}var p=[];if(i.value.forEach(function(t){var e=/^([A-Z]?[a-z][1-9][0-9]*[-x][a-z][1-9][0-9]*)(.*?)$/.exec(t.str);e&&t.move.t==r.t&&(t.move.a||"")==s[1]&&e[2]==n&&p.push(t.move)}),1==p.length)return""==s[1]&&"x"==s[4]?s[2]+"x"+s[5]+s[6]+s[7]:s[1]+("x"==s[4]?"x":"")+s[5]+s[6]+s[7];if(t.geometry.CompactCrit)for(var l="",h=0;;h++){var u=t.geometry.CompactCrit(r.f,h);if(null==u)return a;l+=u;for(var v=[],b=0;b<p.length;b++){var f=p[b];t.geometry.CompactCrit(f.f,h)==u&&v.push(f)}if(console.assert(v.length>0),1==v.length)return s[1]+l+("x"==s[4]?"x":"")+s[5]+s[6]+s[7];p=v}return a},Model.Board.cbIntegrity=function(t){function e(t,e){t||console.error(e)}for(var r=this,i=0;i<this.board.length;i++){var a=this.board[i];if(a>=0){var s=r.pieces[a];e(void 0!==s,"no piece at pos"),e(s.p==i,"piece has different pos")}}for(var a=0;a<this.pieces.length;a++){var s=this.pieces[a];s.p>=0&&e(r.board[s.p]==a,"board index mismatch")}},Model.Board.ExportBoardState=function(t){return t.cbVar.geometry.ExportBoardState?t.cbVar.geometry.ExportBoardState(this,t.cbVar,t.mPlayedMoves.length):"not supported"},Model.Game.Import=function(e,r){var i,a=[],s={1:{},"-1":{}},n=null,o=0;if("pjn"==e){var h={status:!1,error:"parse"},c=r.split(" ");if(6!=c.length)return console.warn("FEN should have 6 parts"),h;var p=c[0].split("/"),l=t.geometry.fenHeight||t.geometry.height;if(p.length!=l)return console.warn("FEN board should have",l,"rows, got",p.length),h;var u={};for(var v in t.pieceTypes){var b=t.pieceTypes[v],f=b.fenAbbrev||b.abbrev||"X";u[f.toUpperCase()]={s:1,t:v},u[f.toLowerCase()]={s:-1,t:v}}var g=t.geometry.FenRowPos||function(e,r){return(t.geometry.height-1-e)*t.geometry.width+r};if(p.forEach(function(e,r){for(var i=0,s=0;s<e.length;s++){var n=e.substr(s,1),o=u[n];if(void 0!==o){var c=g(r,i);i++;for(var p={s:o.s,t:o.t,p:c},l=!0,v=t.pieceTypes[p.t].initial||[],b=0;b<v.length;b++){var f=v[b];f.s==p.s&&f.p==c&&(l=!1)}p.m=l,a.push(p)}else{if(isNaN(parseInt(n)))return console.warn("FEN invalid board spec",n),h;i+=parseInt(n)}}}),a.sort(function(t,e){return e.s-t.s}),"w"==c[1])i=1;else{if("b"!=c[1])return console.warn("FEN invalid turn spec",c[1]),h;i=-1}s[1].k=c[2].indexOf("K")>=0,s[1].q=c[2].indexOf("Q")>=0,s[-1].k=c[2].indexOf("k")>=0,s[-1].q=c[2].indexOf("q")>=0,n="-"==c[3]?null:c[3];var d=parseInt(c[4]);isNaN(d)||(o=d);var m={pieces:a,turn:i,castle:s,enPassant:n,noCaptCount:o};return t.importGame&&t.importGame.call(this,m,e,r),{status:!0,initial:m}}return{status:!1,error:"unsupported"}}}(),function(){Model.Game.cbBoardGeometryGrid=function(t,e){function r(e){return e%t}function i(e){return Math.floor(e/t)}function a(e,r){return r*t+e}function s(s,n){var o=r(s),h=i(s),c=o+n[0],p=h+n[1];return c<0||c>=t||p<0||p>=e?null:a(c,p)}function n(t){return String.fromCharCode("a".charCodeAt(0)+r(t))+(i(t)+1)}function o(t){var e=/^([a-z])([0-9]+)$/.exec(t);return e?a(e[1].charCodeAt(0)-"a".charCodeAt(0),parseInt(e[2])-1):-1}function h(t,e){return 0==e?String.fromCharCode("a".charCodeAt(0)+r(t)):1==e?i(t)+1:null}function c(){for(var a=[],s=0;s<t*e;s++){var n=[];a.push(n);for(var o=0;o<t*e;o++){var h=i(s),c=r(s),p=i(o),l=r(o);n.push(Math.max(Math.abs(h-p),Math.abs(c-l)))}}return a}function p(r,i,s){for(var o=[],h=e-1;h>=0;h--){for(var c="",p=0,l=0;l<t;l++){var u=r.board[a(l,h)];if(u<0)p++;else{p>0&&(c+=p,p=0);var v=r.pieces[u],b=i.pieceTypes[v.t].fenAbbrev||i.pieceTypes[v.t].abbrev||"?";v.s==-1?c+=b.toLowerCase():c+=b.toUpperCase()}}p&&(c+=p),o.push(c)}var f=o.join("/");f+=" ",1==r.mWho?f+="w":f+="b",f+=" ";var g="";return r.castled&&(r.castled[1]===!1?g+="KQ":(r.castled[1].k&&(g+="K"),r.castled[1].q&&(g+="Q")),r.castled[-1]===!1?g+="kq":(r.castled[-1].k&&(g+="k"),r.castled[-1].q&&(g+="q"))),0==g.length&&(g="-"),f+=g,f+=" ",r.epTarget?f+=n(r.epTarget.p):f+="-",f+=" ",f+=r.noCaptCount,f+=" ",f+=Math.floor(s/2)+1}return{boardSize:t*e,width:t,height:e,C:r,R:i,POS:a,Graph:s,PosName:n,PosByName:o,CompactCrit:h,GetDistances:c,distEdge:function(){for(var a=[],s=0;s<t*e;s++){var n=r(s),o=i(s);a[s]=Math.min(n,Math.abs(t-n-1),o,Math.abs(e-o-1))}return a}(),corners:function(){var r={};return r[a(0,0)]=1,r[a(0,e-1)]=1,r[a(t-1,0)]=1,r[a(t-1,e-1)]=1,r}(),ExportBoardState:p}},Model.Game.cbPawnGraph=function(t,e,r){for(var i=this,a={},s=0;s<t.boardSize;s++)if(!r||s in r){var n=[],o=t.Graph(s,[0,e]);null!=o&&(!r||o in r)&&n.push(i.cbTypedArray([o|i.cbConstants.FLAG_MOVE])),[-1,1].forEach(function(a){var o=t.Graph(s,[a,e]);null!=o&&(!r||o in r)&&n.push(i.cbTypedArray([o|i.cbConstants.FLAG_CAPTURE]))}),a[s]=n}else a[s]=[];return a},Model.Game.cbInitialPawnGraph=function(t,e,r){for(var i=this,a={},s=0;s<t.boardSize;s++)if(!r||s in r){var n=[],o=t.Graph(s,[0,e]);if(null!=o&&(!r||o in r)){var h=[o|i.cbConstants.FLAG_MOVE],c=t.Graph(o,[0,e]);null!=c&&(!r||c in r)&&h.push(c|i.cbConstants.FLAG_MOVE),n.push(i.cbTypedArray(h))}[-1,1].forEach(function(a){var o=t.Graph(s,[a,e]);null!=o&&(!r||o in r)&&n.push(i.cbTypedArray([o|i.cbConstants.FLAG_CAPTURE]))}),a[s]=n}else a[s]=[];return a},Model.Game.cbKingGraph=function(t,e){return this.cbShortRangeGraph(t,[[-1,-1],[-1,0],[-1,1],[0,-1],[0,1],[1,-1],[1,0],[1,1]],e)},Model.Game.cbKnightGraph=function(t,e){return this.cbShortRangeGraph(t,[[2,-1],[2,1],[-2,-1],[-2,1],[-1,2],[-1,-2],[1,2],[1,-2]],e)},Model.Game.cbHorseGraph=function(t){for(var e=this,r={},i=0;i<t.boardSize;i++)r[i]=[],[[1,0,2,-1],[1,0,2,1],[-1,0,-2,-1],[-1,0,-2,1],[0,1,-1,2],[0,-1,-1,-2],[0,1,1,2],[0,-1,1,-2]].forEach(function(a){var s=t.Graph(i,[a[0],a[1]]);if(null!=s){var n=t.Graph(i,[a[2],a[3]]);null!=n&&r[i].push(e.cbTypedArray([s|e.cbConstants.FLAG_STOP,n|e.cbConstants.FLAG_MOVE|e.cbConstants.FLAG_CAPTURE]))}});return r},Model.Game.cbRookGraph=function(t,e){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0]],e)},Model.Game.cbBishopGraph=function(t,e){return this.cbLongRangeGraph(t,[[1,-1],[1,1],[-1,1],[-1,-1]],e)},Model.Game.cbQueenGraph=function(t,e){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0],[1,-1],[1,1],[-1,1],[-1,-1]],e)},Model.Game.cbXQGeneralGraph=function(t,e){for(var r=this,i={},a=0;a<t.boardSize;a++)i[a]=[],[[-1,0,!1],[0,-1,!0],[0,1,!0],[1,0,!1]].forEach(function(s){var n=[],o=t.Graph(a,s);if(null!=o&&((!e||o in e)&&n.push(o|r.cbConstants.FLAG_MOVE|r.cbConstants.FLAG_CAPTURE),s[2]))for(var h=t.Graph(o,s);null!=h;)!e||h in e?n.push(h|r.cbConstants.FLAG_CAPTURE|r.cbConstants.FLAG_CAPTURE_KING):n.push(h|r.cbConstants.FLAG_STOP),h=t.Graph(h,s);n.length>0&&i[a].push(r.cbTypedArray(n))});return i},Model.Game.cbXQSoldierGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e]])},Model.Game.cbXQPromoSoldierGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e],[-1,0],[1,0]])},Model.Game.cbXQAdvisorGraph=function(t,e){return this.cbShortRangeGraph(t,[[1,1],[-1,1],[1,-1],[-1,-1]],e)},Model.Game.cbXQCannonGraph=function(t){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0]],null,this.cbConstants.FLAG_MOVE|this.cbConstants.FLAG_SCREEN_CAPTURE)},Model.Game.cbXQElephantGraph=function(t,e){for(var r=this,i={},a=0;a<t.boardSize;a++)i[a]=[],(!e||a in e)&&[[1,1,2,2],[1,-1,2,-2],[-1,1,-2,2],[-1,-1,-2,-2]].forEach(function(s){var n=t.Graph(a,[s[0],s[1]]);if(null!=n){var o=t.Graph(a,[s[2],s[3]]);null!=o&&(!e||o in e)&&i[a].push(r.cbTypedArray([n|r.cbConstants.FLAG_STOP,o|r.cbConstants.FLAG_MOVE|r.cbConstants.FLAG_CAPTURE]))}});return i},Model.Game.cbSilverGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e],[-1,-1],[-1,1],[1,-1],[1,1]])},Model.Game.cbFersGraph=function(t,e){return this.cbShortRangeGraph(t,[[-1,-1],[-1,1],[1,-1],[1,1]])},Model.Game.cbSchleichGraph=function(t,e){return this.cbShortRangeGraph(t,[[-1,0],[1,0],[0,-1],[0,1]])},Model.Game.cbAlfilGraph=function(t,e){return this.cbShortRangeGraph(t,[[-2,-2],[-2,2],[2,2],[2,-2]])}}(),function(){var t=Model.Game.cbBoardGeometryGrid(10,10);Model.Game.cbDefine=function(){return{geometry:t,pieceTypes:{0:{name:"pawn-w",aspect:"fr-pawn",graph:this.cbPawnGraph(t,1),value:1,abbrev:"",fenAbbrev:"P",epCatch:!0},1:{name:"ipawn-w",aspect:"fr-pawn",graph:this.cbInitialPawnGraph(t,1),value:1,abbrev:"",fenAbbrev:"P",initial:[{s:1,p:20},{s:1,p:21},{s:1,p:22},{s:1,p:23},{s:1,p:24},{s:1,p:25},{s:1,p:26},{s:1,p:27},{s:1,p:28},{s:1,p:29}],epTarget:!0},2:{name:"pawn-b",aspect:"fr-pawn",graph:this.cbPawnGraph(t,-1),value:1,abbrev:"",fenAbbrev:"P",epCatch:!0},3:{name:"ipawn-b",aspect:"fr-pawn",graph:this.cbInitialPawnGraph(t,-1),value:1,abbrev:"",fenAbbrev:"P",initial:[{s:-1,p:70},{s:-1,p:71},{s:-1,p:72},{s:-1,p:73},{s:-1,p:74},{s:-1,p:75},{s:-1,p:76},{s:-1,p:77},{s:-1,p:78},{s:-1,p:79}],epTarget:!0},4:{name:"knight",aspect:"fr-knight",graph:this.cbKnightGraph(t),value:2.9,abbrev:"N",initial:[{s:1,p:11},{s:1,p:18},{s:-1,p:81},{s:-1,p:88}]},5:{name:"bishop",aspect:"fr-bishop",graph:this.cbBishopGraph(t),value:3.1,abbrev:"B",initial:[{s:1,p:12},{s:1,p:17},{s:-1,p:82},{s:-1,p:87}]},6:{name:"rook",aspect:"fr-rook",graph:this.cbRookGraph(t),value:5,abbrev:"R",initial:[{s:1,p:0},{s:1,p:9},{s:-1,p:90},{s:-1,p:99}]},7:{name:"queen",aspect:"fr-queen",graph:this.cbQueenGraph(t),value:9,abbrev:"Q",initial:[{s:1,p:13},{s:-1,p:83}]},8:{name:"king",aspect:"fr-king",isKing:!0,graph:this.cbKingGraph(t),abbrev:"K",initial:[{s:1,p:14},{s:-1,p:84}]},9:{name:"marshall",aspect:"fr-marshall",graph:this.cbMergeGraphs(t,this.cbRookGraph(t),this.cbKnightGraph(t)),value:7.8,abbrev:"M",initial:[{s:1,p:15},{s:-1,p:85}]},10:{name:"cardinal",aspect:"fr-cardinal",graph:this.cbMergeGraphs(t,this.cbBishopGraph(t),this.cbKnightGraph(t)),value:6,abbrev:"C",initial:[{s:1,p:16},{s:-1,p:86}]}},promote:function(e,r,i){if(1==r.t)return[0];if(3==r.t)return[2];var a=t.R(i.t);if(0==r.t&&a<=9&&a>=7||2==r.t&&a>=0&&a<=2){for(var s={4:2,5:2,6:2,7:1,9:1,10:1},n=0;n<this.pieces.length;n++){var o=this.pieces[n];o.s==r.s&&o.p>=0&&o.t in s&&s[o.t]--}var h=[];for(var c in s)s[c]>0&&h.push(c);if(0!=a&&9!=a)h.unshift(r.t);else if(0==h.length)return null;return h}return[]}}}}();

/***/ }),

/***/ "Y3yw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var isArray_1 = __webpack_require__("Xajo");
var ArrayObservable_1 = __webpack_require__("Yh8Q");
var OuterSubscriber_1 = __webpack_require__("wAkD");
var subscribeToResult_1 = __webpack_require__("CURp");
/* tslint:enable:max-line-length */
/**
 * Returns an Observable that mirrors the first source Observable to emit an item
 * from the combination of this Observable and supplied Observables.
 * @param {...Observables} ...observables Sources used to race for which Observable emits first.
 * @return {Observable} An Observable that mirrors the output of the first Observable to emit an item.
 * @method race
 * @owner Observable
 */
function race() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i - 0] = arguments[_i];
    }
    // if the only argument is an array, it was most likely called with
    // `pair([obs1, obs2, ...])`
    if (observables.length === 1 && isArray_1.isArray(observables[0])) {
        observables = observables[0];
    }
    return this.lift.call(raceStatic.apply(void 0, [this].concat(observables)));
}
exports.race = race;
function raceStatic() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i - 0] = arguments[_i];
    }
    // if the only argument is an array, it was most likely called with
    // `pair([obs1, obs2, ...])`
    if (observables.length === 1) {
        if (isArray_1.isArray(observables[0])) {
            observables = observables[0];
        }
        else {
            return observables[0];
        }
    }
    return new ArrayObservable_1.ArrayObservable(observables).lift(new RaceOperator());
}
exports.raceStatic = raceStatic;
var RaceOperator = (function () {
    function RaceOperator() {
    }
    RaceOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new RaceSubscriber(subscriber));
    };
    return RaceOperator;
}());
exports.RaceOperator = RaceOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var RaceSubscriber = (function (_super) {
    __extends(RaceSubscriber, _super);
    function RaceSubscriber(destination) {
        _super.call(this, destination);
        this.hasFirst = false;
        this.observables = [];
        this.subscriptions = [];
    }
    RaceSubscriber.prototype._next = function (observable) {
        this.observables.push(observable);
    };
    RaceSubscriber.prototype._complete = function () {
        var observables = this.observables;
        var len = observables.length;
        if (len === 0) {
            this.destination.complete();
        }
        else {
            for (var i = 0; i < len && !this.hasFirst; i++) {
                var observable = observables[i];
                var subscription = subscribeToResult_1.subscribeToResult(this, observable, observable, i);
                if (this.subscriptions) {
                    this.subscriptions.push(subscription);
                }
                this.add(subscription);
            }
            this.observables = null;
        }
    };
    RaceSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        if (!this.hasFirst) {
            this.hasFirst = true;
            for (var i = 0; i < this.subscriptions.length; i++) {
                if (i !== outerIndex) {
                    var subscription = this.subscriptions[i];
                    subscription.unsubscribe();
                    this.remove(subscription);
                }
            }
            this.subscriptions = null;
        }
        this.destination.next(innerValue);
    };
    return RaceSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
exports.RaceSubscriber = RaceSubscriber;
//# sourceMappingURL=race.js.map

/***/ }),

/***/ "Y6+q":
/***/ (function(module, exports) {

exports.config = {"status":true,"model":{"plazza":"true","released":1402584978,"title-en":"3D Chess","module":"chessbase","summary":"6x8x3 Chess","thumbnail":"3dchess-thumb.png","rules":{"en":"3dchess-rules.html"},"credits":{"en":"3dchess-credits.html"},"gameOptions":{"preventRepeat":true,"uctTransposition":"state","uctIgnoreLoop":false,"levelOptions":{"pieceValueFactor":1,"pieceValueRatioFactor":1,"posValueFactor":0.1,"averageDistKingFactor":-0.01,"castleFactor":0.1,"minorPiecesMovedFactor":0.1,"checkFactor":0.2,"endingKingFreedomFactor":0.01,"endingDistKingFactor":0.05,"distKingCornerFactor":0.1,"distPawnPromo1Factor":0.3,"distPawnPromo2Factor":0.1,"distPawnPromo3Factor":0.05}},"obsolete":false,"js":["base-model.js","multiplan-geo-model.js","3dchess-model.js"],"description":{"en":"3dchess-description.html"},"levels":[{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"easy","label":"Easy","maxNodes":6000},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"fast","label":"Fast [3sec]","maxDuration":3,"isDefault":true},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"medium","label":"Medium","maxNodes":30000,"maxDuration":30},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"strong","label":"Strong","maxNodes":60000,"maxDuration":45}]},"view":{"title-en":"Chessbase view","module":"chessbase","xdView":true,"css":["chessbase.css"],"preferredRatio":1,"useShowMoves":true,"useNotation":true,"useAutoComplete":true,"defaultOptions":{"sounds":true,"moves":true,"notation":false,"autocomplete":false},"skins":[{"name":"skin3d","title":"3D Classic","3d":true,"preload":["smoothedfilegeo|0|/res/ring-target.js","image|/res/images/cancel.png","image|/res/images/wikipedia.png","smoothedfilegeo|0|/res/staunton/pawn/pawn-classic.js","image|/res/staunton/pawn/pawn-diffusemap.jpg","image|/res/staunton/pawn/pawn-normalmap.jpg","smoothedfilegeo|0|/res/staunton/knight/knight.js","image|/res/staunton/knight/knight-diffusemap.jpg","image|/res/staunton/knight/knight-normalmap.jpg","smoothedfilegeo|0|/res/staunton/bishop/bishop.js","image|/res/staunton/bishop/bishop-diffusemap.jpg","image|/res/staunton/bishop/bishop-normalmap.jpg","smoothedfilegeo|0|/res/staunton/rook/rook.js","image|/res/staunton/rook/rook-diffusemap.jpg","image|/res/staunton/rook/rook-normalmap.jpg","smoothedfilegeo|0|/res/staunton/queen/queen.js","image|/res/staunton/queen/queen-diffusemap.jpg","image|/res/staunton/queen/queen-normalmap.jpg","smoothedfilegeo|0|/res/staunton/king/king.js","image|/res/staunton/king/king-diffusemap.jpg","image|/res/staunton/king/king-normalmap.jpg"],"world":{"lightIntensity":0.8,"skyLightIntensity":0.5,"lightCastShadow":false,"fog":false,"color":4686804,"lightPosition":{"x":-9,"y":9,"z":9},"skyLightPosition":{"x":9,"y":9,"z":9},"lightShadowDarkness":0.55,"ambientLightColor":8947848},"camera":{"fov":45,"distMax":200,"radius":18,"elevationAngle":30,"elevationMin":-89,"rotationAngle":150,"target":[0,0,2500],"targetBounds":[3000,3000,6000]}},{"name":"skin2d","title":"2D Classic","3d":false,"preload":["image|/res/images/wikipedia.png","image|/res/images/cancel.png","image|/res/images/whitebg.png"]}],"animateSelfMoves":false,"switchable":true,"sounds":{"move1":"alq_move1","move2":"alq_move2","move3":"alq_move3","move4":"alq_move2","tac1":"alq_tac1","tac2":"alq_tac2","tac3":"alq_tac1","promo":"promo","usermove":null},"js":["base-view.js","multiplan-board-view.js","staunton-set-view.js","3dchess-view.js"],"visuals":{"600x600":["res/visuals/3dchess-600x600-3d.jpg","res/visuals/3dchess-600x600-2d.jpg"]}}}

/***/ }),

/***/ "Y6hq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__("mmVS");
var Notification_1 = __webpack_require__("8GmM");
/**
 * Represents all of the notifications from the source Observable as `next`
 * emissions marked with their original types within {@link Notification}
 * objects.
 *
 * <span class="informal">Wraps `next`, `error` and `complete` emissions in
 * {@link Notification} objects, emitted as `next` on the output Observable.
 * </span>
 *
 * <img src="./img/materialize.png" width="100%">
 *
 * `materialize` returns an Observable that emits a `next` notification for each
 * `next`, `error`, or `complete` emission of the source Observable. When the
 * source Observable emits `complete`, the output Observable will emit `next` as
 * a Notification of type "complete", and then it will emit `complete` as well.
 * When the source Observable emits `error`, the output will emit `next` as a
 * Notification of type "error", and then `complete`.
 *
 * This operator is useful for producing metadata of the source Observable, to
 * be consumed as `next` emissions. Use it in conjunction with
 * {@link dematerialize}.
 *
 * @example <caption>Convert a faulty Observable to an Observable of Notifications</caption>
 * var letters = Rx.Observable.of('a', 'b', 13, 'd');
 * var upperCase = letters.map(x => x.toUpperCase());
 * var materialized = upperCase.materialize();
 * materialized.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // - Notification {kind: "N", value: "A", error: undefined, hasValue: true}
 * // - Notification {kind: "N", value: "B", error: undefined, hasValue: true}
 * // - Notification {kind: "E", value: undefined, error: TypeError:
 * //   x.toUpperCase is not a function at MapSubscriber.letters.map.x
 * //   [as project] (http://1…, hasValue: false}
 *
 * @see {@link Notification}
 * @see {@link dematerialize}
 *
 * @return {Observable<Notification<T>>} An Observable that emits
 * {@link Notification} objects that wrap the original emissions from the source
 * Observable with metadata.
 * @method materialize
 * @owner Observable
 */
function materialize() {
    return this.lift(new MaterializeOperator());
}
exports.materialize = materialize;
var MaterializeOperator = (function () {
    function MaterializeOperator() {
    }
    MaterializeOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new MaterializeSubscriber(subscriber));
    };
    return MaterializeOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var MaterializeSubscriber = (function (_super) {
    __extends(MaterializeSubscriber, _super);
    function MaterializeSubscriber(destination) {
        _super.call(this, destination);
    }
    MaterializeSubscriber.prototype._next = function (value) {
        this.destination.next(Notification_1.Notification.createNext(value));
    };
    MaterializeSubscriber.prototype._error = function (err) {
        var destination = this.destination;
        destination.next(Notification_1.Notification.createError(err));
        destination.complete();
    };
    MaterializeSubscriber.prototype._complete = function () {
        var destination = this.destination;
        destination.next(Notification_1.Notification.createComplete());
        destination.complete();
    };
    return MaterializeSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=materialize.js.map

/***/ }),

/***/ "YEB2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NgStyleKeyValue */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ngStyleUtils; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * NgStyle allowed inputs
 */
var NgStyleKeyValue = (function () {
    function NgStyleKeyValue(key, value, noQuotes) {
        if (noQuotes === void 0) { noQuotes = true; }
        this.key = key;
        this.value = value;
        this.key = noQuotes ? key.replace(/['"]/g, "").trim() : key.trim();
        this.value = noQuotes ? value.replace(/['"]/g, "").trim() : value.trim();
        this.value = this.value.replace(/;/, "");
    }
    return NgStyleKeyValue;
}());

/**
 * Transform Operators for @angular/flex-layout NgStyle Directive
 */
var ngStyleUtils = {
    getType: getType,
    buildRawList: buildRawList,
    buildMapFromList: buildMapFromList,
    buildMapFromSet: buildMapFromSet
};
function getType(target) {
    var what = typeof target;
    if (what === 'object') {
        return (target.constructor === Array) ? 'array' :
            (target.constructor === Set) ? 'set' : 'object';
    }
    return what;
}
/**
 * Split string of key:value pairs into Array of k-v pairs
 * e.g.  'key:value; key:value; key:value;' -> ['key:value',...]
 */
function buildRawList(source, delimiter) {
    if (delimiter === void 0) { delimiter = ";"; }
    return String(source)
        .trim()
        .split(delimiter)
        .map(function (val) { return val.trim(); })
        .filter(function (val) { return val !== ""; });
}
/**
 * Convert array of key:value strings to a iterable map object
 */
function buildMapFromList(styles, sanitize) {
    var sanitizeValue = function (it) {
        if (sanitize) {
            it.value = sanitize(it.value);
        }
        return it;
    };
    return styles
        .map(stringToKeyValue)
        .filter(function (entry) { return !!entry; })
        .map(sanitizeValue)
        .reduce(keyValuesToMap, {});
}
;
/**
 * Convert Set<string> or raw Object to an iterable NgStyleMap
 */
function buildMapFromSet(source, sanitize) {
    var list = new Array();
    if (getType(source) == 'set') {
        source.forEach(function (entry) { return list.push(entry); });
    }
    else {
        Object.keys(source).forEach(function (key) {
            list.push(key + ":" + source[key]);
        });
    }
    return buildMapFromList(list, sanitize);
}
/**
 * Convert "key:value" -> [key, value]
 */
function stringToKeyValue(it) {
    var _a = it.split(":"), key = _a[0], val = _a[1];
    return val ? new NgStyleKeyValue(key, val) : null;
}
;
/**
 * Convert [ [key,value] ] -> { key : value }
 */
function keyValuesToMap(map, entry) {
    if (!!entry.key) {
        map[entry.key] = entry.value;
    }
    return map;
}
//# sourceMappingURL=style-transforms.js.map

/***/ }),

/***/ "YOd+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* tslint:disable:no-empty */
function noop() { }
exports.noop = noop;
//# sourceMappingURL=noop.js.map

/***/ }),

/***/ "YVIf":
/***/ (function(module, exports) {

exports.model=Model={Game:{},Board:{},Move:{}},function(){function i(i){return[Math.floor(i/8),i%8]}function t(i,t){if(i==t)return 0;if(t>i){var s=t;t=i,i=s}return h[i][t]}for(var s=[],a=0;a<64;a++){var r=i(a),o=r[0],n=r[1];s.push(Math.max(o,n))}for(var h=[],l=0;l<64;l++){var d=[];h.push(d);for(var e=i(l),p=e[0],u=e[1],b=0;b<l;b++){var g=i(b),z=g[0],v=g[1];d.push(Math.max(Math.abs(p-z),Math.abs(u-v)))}}for(var f=[[1,1],[1,0],[1,-1],[0,-1],[-1,-1],[-1,0],[-1,1],[0,1]],S=[],a=0;a<64;a++){for(var c=[],r=i(a),m=0;m<8;m++){var o=r[0]+f[m][0],n=r[1]+f[m][1];o<0||o>=8||n<0||n>=8?c.push(null):c.push(8*o+n)}S.push(c)}for(var M=[],a=0;a<64;a++){var G={},B={"-1":G};M.push(B);for(var m=0;m<8;m++){var F={};B[m]=F;for(var b=S[a][m],P=1;P<4&&null!=b;P++)F[b]=P,G[b]=P,b=S[b][m]}}Model.Game.InitGame=function(){this.g.Graph=S,this.zobrist=new JocGame.Zobrist({board:{type:"array",size:65,values:["-1","0","1","2","3","4","5","6"]},dirs:{type:"array",size:9,values:["0","1","2","3","4","5","6"]}})},Model.Move.Init=function(i){this.i=parseInt(i.i),this.p=parseInt(i.p),this.d=parseInt(i.d),this.md=parseInt(i.md)},Model.Move.CopyFrom=function(i){this.Init(i)},Model.Move.ToString=function(){var i="";return i+=this.p,i+=["M","P","B","M","P","B"][this.i],i+=this.d},Model.Move.Equals=function(i){return this.p==i.p&&this.i==i.i&&this.d==i.d&&this.md==i.md},Model.Board.Init=function(i){this.zSign=0},Model.Board.InitialPosition=function(i){this.board=[];for(var t=0;t<64;t++)this.board.push(null);this.penguins=[];for(var s=1;s>-2;s-=2)for(var a=0;a<3;a++){var r=this.penguins.length,o={p:-1,i:r,s:s,t:a,d:-1};this.penguins.push(o),this.zSign=i.zobrist.update(this.zSign,"board",r,0),this.zSign=i.zobrist.update(this.zSign,"dirs",r,0)}this.ball=-1,this.zSign=i.zobrist.update(this.zSign,"board",-1,0)},Model.Board.CopyFrom=function(i){this.board=[];for(var t=0;t<i.board.length;t++)this.board.push(null);this.penguins=[];for(var t in i.penguins){var s=i.penguins[t],a={p:s.p,s:s.s,i:s.i,t:s.t,d:s.d};this.penguins.push(a),a.p>-1&&(this.board[a.p]=a)}this.ball=i.ball,this.mWho=i.mWho,this.zSign=i.zSign},Model.Board.GenerateMoves=function(i){this.mMoves=this.PenSocGetAllMoves(i)},Model.Board.PenSocGetAllMoves=function(i){for(var t=[],s=0;s<this.penguins.length;s++){var a=this.penguins[s];a.s==this.mWho&&(t=t.concat(this.PenSocGetBoardMoves(i,a)))}return t},Model.Board.PenSocGetRotatingMoves=function(i,t,s,a,r){for(var o=[],n=a-r;n<=a+r;n++)o.push({i:t,p:s,d:(n+8)%8,md:(a+8)%8});return o},Model.Board.PenSocGetBoardMoves=function(i,t){var s,a=[],r=this.mWho==JocGame.PLAYER_A?63:0;s=t.d==-1?[0,1,2,3,4,5,6,7]:[parseInt(t.d)];var o=t.p,n=t.t+1,h=t.t+1;if(o==-1&&(o=this.mWho==JocGame.PLAYER_A?0:63,s=this.mWho==JocGame.PLAYER_A?[0,1,7]:[4,3,5],n=t.t,null!=this.board[o]))return a;if(t.p>-1&&t.d>-1&&a.push({i:t.i,p:t.p,d:-1,md:-1}),this.ball!=-1&&this.ball==t.p){n=3-t.t;for(var l=0;l<8;l++){for(var d=o,e=o,p=!1,u=0;u<n;u++){if(null==(d=i.g.Graph[d][l])){u>0&&a.push({i:t.i,p:e,d:-1,md:l}),p=!0;break}if(null!=d&&null!=this.board[d]){a.push({i:t.i,p:d,d:-1,md:l}),p=!0;break}e=d}p||a.push({i:t.i,p:e,d:-1,md:l})}}else for(var b=0;b<s.length;b++){for(var l=s[b],d=o,e=o,g=!0,u=0;u<n;u++){if(null==(d=i.g.Graph[d][l])||null!=this.board[d]){if(null!=d&&this.ball!=-1&&d==this.ball){var z=this.board[d];if(z&&z.s==t.s){g=!1;break}for(var v=!0,f=d;f;){if(f==r){v=!1;break}if(null==this.board[f])break;f=i.g.Graph[f][l]}v&&a.push({i:t.i,p:d,d:t.d,md:l})}else u>0&&null==d&&a.push({i:t.i,p:e,d:-1,md:l});g=!1;break}if(this.ball==-1&&(27==d||28==d||35==d||36==d)){a.push({i:t.i,p:d,d:-1,md:l}),g=!1;break}if(null!=d&&this.ball!=-1&&this.ball==d){a.push({i:t.i,p:d,d:-1,md:l}),g=!1;break}e=d}if(g&&e!=r&&(a=a.concat(this.PenSocGetRotatingMoves(i,t.i,e,l,h))),t.p==-1&&0==t.t&&0==b)break}return a},Model.Board.IsValidMove=function(i,t){return!0},Model.Board.Evaluate=function(i,a,r){var o="debug"==arguments[3];if(this.mEvaluation=0,0==this.ball?(this.mFinished=!0,this.mWinner=JocGame.PLAYER_B):63==this.ball&&(this.mFinished=!0,this.mWinner=JocGame.PLAYER_A),!this.mFinished){for(var n=0,h=0,l=0,d=0;d<6;d++){var e,p=this.penguins[d];if(p.p>=0){e=this.ball<0?Math.min(t(p.p,27),t(p.p,28),t(p.p,35),t(p.p,36)):t(p.p,this.ball);var u=M[p.p][p.d];for(var b in u){u[b]<=p.t+1&&(l+=p.s,this.ball>=0&&b==this.ball?h+=p.s:this.ball<0&&(27==b||28==b||35==b||36==b)&&(h+=p.s))}}else e=8;n+=e*p.s}var g=0,z=0;if(this.ball>=0){g=s[this.ball]-s[63-this.ball];var v=this.board[this.ball];null!=v&&(z=v.s)}var f=i.mOptions.levelOptions;o&&(console.log("distBall",n,"*",f.distBallFactor),console.log("distGoal",g,"*",f.distGoalFactor),console.log("haveBall",z,"*",f.haveBallFactor),console.log("reachable",l,"*",f.reachableFactor),console.log("ballReachable",h,"*",f.ballReachableFactor),console.log("distBall details",this.ball,s[this.ball],s[63-this.ball])),this.mEvaluation=n*f.distBallFactor+g*f.distGoalFactor+z*f.haveBallFactor+l*f.reachableFactor}},Model.Board.ApplyMove=function(i,t){var s=this.penguins[t.i];if(t.d=parseInt(t.d),this.ball!=-1&&this.ball==s.p){this.zSign=i.zobrist.update(this.zSign,"board",-1,this.ball+1),this.ball=t.p,this.zSign=i.zobrist.update(this.zSign,"board",-1,this.ball+1),this.zSign=i.zobrist.update(this.zSign,"dirs",s.i,s.d+1),s.d=t.md,this.zSign=i.zobrist.update(this.zSign,"dirs",s.i,s.d+1);var a=this.board[t.p];null!=a&&(this.zSign=i.zobrist.update(this.zSign,"dirs",a.i,a.d+1),a.d=-1,this.zSign=i.zobrist.update(this.zSign,"dirs",a.i,a.d+1))}else{if(s.p>-1&&(this.board[s.p]=null),t.p>-1){for(var r=t.p,o=s;null!=r;){var a=this.board[r];if(this.board[r]=o,this.zSign=i.zobrist.update(this.zSign,"board",o.i,o.p+1),o.p=r,this.zSign=i.zobrist.update(this.zSign,"board",o.i,o.p+1),null==a)break;this.zSign=i.zobrist.update(this.zSign,"dirs",a.i,a.d+1),a.d=t.md,this.zSign=i.zobrist.update(this.zSign,"dirs",a.i,a.d+1),o=a,r=i.g.Graph[r][t.md]}null==r&&(this.zSign=i.zobrist.update(this.zSign,"board",o.i,o.p+1),o.p=-1,this.zSign=i.zobrist.update(this.zSign,"board",o.i,o.p+1),this.zSign=i.zobrist.update(this.zSign,"dirs",o.i,o.d+1),o.d=-1,this.zSign=i.zobrist.update(this.zSign,"dirs",o.i,o.d+1))}this.zSign=i.zobrist.update(this.zSign,"board",s.i,s.p+1),s.p=t.p,this.zSign=i.zobrist.update(this.zSign,"board",s.i,s.p+1),this.zSign=i.zobrist.update(this.zSign,"dirs",s.i,s.d+1),s.d=t.d,this.zSign=i.zobrist.update(this.zSign,"dirs",s.i,s.d+1),this.ball!=-1||27!=t.p&&28!=t.p&&35!=t.p&&36!=t.p||(this.zSign=i.zobrist.update(this.zSign,"board",-1,this.ball+1),this.ball=t.p,this.zSign=i.zobrist.update(this.zSign,"board",-1,this.ball+1)),this.ball!=-1&&this.ball==s.p&&(this.zSign=i.zobrist.update(this.zSign,"dirs",s.i,s.d+1),s.d=-1,this.zSign=i.zobrist.update(this.zSign,"dirs",s.i,s.d+1))}},Model.Board.GetSignature=function(){return this.zSign}}();

/***/ }),

/***/ "Yaz8":
/***/ (function(module, exports) {

exports.config = {"status":true,"model":{"plazza":"true","released":1393430178,"title-en":"Courier Chess","module":"chessbase","summary":"12x8 chess (12th century)","thumbnail":"courier-thumb.png","rules":{"en":"courier-rules.html"},"credits":{"en":"courier-credits.html"},"gameOptions":{"preventRepeat":true,"uctTransposition":"state","uctIgnoreLoop":false,"levelOptions":{"pieceValueFactor":1,"pieceValueRatioFactor":1,"posValueFactor":0.1,"averageDistKingFactor":-0.01,"castleFactor":0.1,"minorPiecesMovedFactor":0.1,"checkFactor":0.2,"endingKingFreedomFactor":0.01,"endingDistKingFactor":0.05,"distKingCornerFactor":0.1}},"js":["base-model.js","grid-geo-model.js","courier-model.js"],"description":{"en":"courier-description.html"},"levels":[{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"easy","label":"Easy","maxNodes":4000},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"fast","label":"Fast [2sec]","maxDuration":2,"isDefault":true},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"medium","label":"Medium","maxNodes":20000,"maxDuration":20},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"strong","label":"Strong","maxNodes":40000,"maxDuration":30}]},"view":{"title-en":"Chessbase view","module":"chessbase","xdView":true,"css":["chessbase.css"],"preferredRatio":1.5,"useShowMoves":true,"useNotation":true,"useAutoComplete":true,"defaultOptions":{"sounds":true,"moves":true,"notation":false,"autocomplete":false},"skins":[{"name":"skin3d","title":"3D Classic","3d":true,"preload":["smoothedfilegeo|0|/res/ring-target.js","image|/res/images/cancel.png","smoothedfilegeo|0|/res/courierchess/cc-pawn/cc-pawn.js","image|/res/courierchess/cc-pawn/cc-pawn-diffuse.jpg","image|/res/courierchess/cc-pawn/cc-pawn-normal.jpg","smoothedfilegeo|0|/res/courierchess/cc-archer/cc-archer.js","image|/res/courierchess/cc-archer/cc-archer-diffuse.jpg","image|/res/courierchess/cc-archer/cc-archer-normal.jpg","smoothedfilegeo|0|/res/courierchess/cc-queen/cc-queen.js","image|/res/courierchess/cc-queen/cc-queen-diffuse.jpg","image|/res/courierchess/cc-queen/cc-queen-normal.jpg","smoothedfilegeo|0|/res/courierchess/cc-schleich/cc-schleich.js","image|/res/courierchess/cc-schleich/cc-schleich-diffuse.jpg","image|/res/courierchess/cc-schleich/cc-schleich-normal.jpg","smoothedfilegeo|0|/res/courierchess/cc-knight/cc-knight.js","image|/res/courierchess/cc-knight/cc-knight-diffuse.jpg","image|/res/courierchess/cc-knight/cc-knight-normal.jpg","smoothedfilegeo|0|/res/courierchess/cc-man/cc-man.js","image|/res/courierchess/cc-man/cc-man-diffuse.jpg","image|/res/courierchess/cc-man/cc-man-normal.jpg","smoothedfilegeo|0|/res/courierchess/cc-courier/cc-courier.js","image|/res/courierchess/cc-courier/cc-courier-diffuse.jpg","image|/res/courierchess/cc-courier/cc-courier-normal.jpg","smoothedfilegeo|0|/res/courierchess/cc-rook/cc-rook.js","image|/res/courierchess/cc-rook/cc-rook-diffuse.jpg","image|/res/courierchess/cc-rook/cc-rook-normal.jpg","smoothedfilegeo|0|/res/courierchess/cc-king/cc-king.js","image|/res/courierchess/cc-king/cc-king-diffuse.jpg","image|/res/courierchess/cc-king/cc-king-normal.jpg","image|/res/images/crackles.jpg","image|/res/images/tileralpha.png"],"world":{"lightIntensity":1.3,"skyLightIntensity":1.2,"lightCastShadow":true,"fog":false,"color":4686804,"lightPosition":{"x":-9,"y":9,"z":9},"skyLightPosition":{"x":9,"y":9,"z":9},"lightShadowDarkness":0.55,"ambientLightColor":2236962},"camera":{"fov":45,"distMax":50,"radius":12,"elevationAngle":60,"elevationMin":0}},{"name":"skin2d","title":"2D Classic","3d":false,"preload":["image|/res/courierchess/wikipedia-courier-sprites.png"]}],"animateSelfMoves":false,"switchable":true,"sounds":{"move1":"alq_move1","move2":"alq_move2","move3":"alq_move3","move4":"alq_move2","tac1":"alq_tac1","tac2":"alq_tac2","tac3":"alq_tac1","promo":"promo","usermove":null},"js":["base-view.js","grid-board-view.js","courier-board-view.js","courierchess-set-view.js","courier-view.js"],"visuals":{"600x600":["res/visuals/courier-600x600-3d.jpg","res/visuals/courier-600x600-2d.jpg"]}}}

/***/ }),

/***/ "Ye9U":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var materialize_1 = __webpack_require__("Y6hq");
Observable_1.Observable.prototype.materialize = materialize_1.materialize;
//# sourceMappingURL=materialize.js.map

/***/ }),

/***/ "Yfq7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var exhaust_1 = __webpack_require__("GR1s");
Observable_1.Observable.prototype.exhaust = exhaust_1.exhaust;
//# sourceMappingURL=exhaust.js.map

/***/ }),

/***/ "YgqK":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var find_1 = __webpack_require__("GZqV");
/**
 * Emits only the index of the first value emitted by the source Observable that
 * meets some condition.
 *
 * <span class="informal">It's like {@link find}, but emits the index of the
 * found value, not the value itself.</span>
 *
 * <img src="./img/findIndex.png" width="100%">
 *
 * `findIndex` searches for the first item in the source Observable that matches
 * the specified condition embodied by the `predicate`, and returns the
 * (zero-based) index of the first occurrence in the source. Unlike
 * {@link first}, the `predicate` is required in `findIndex`, and does not emit
 * an error if a valid value is not found.
 *
 * @example <caption>Emit the index of first click that happens on a DIV element</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.findIndex(ev => ev.target.tagName === 'DIV');
 * result.subscribe(x => console.log(x));
 *
 * @see {@link filter}
 * @see {@link find}
 * @see {@link first}
 * @see {@link take}
 *
 * @param {function(value: T, index: number, source: Observable<T>): boolean} predicate
 * A function called with each item to test for condition matching.
 * @param {any} [thisArg] An optional argument to determine the value of `this`
 * in the `predicate` function.
 * @return {Observable} An Observable of the index of the first item that
 * matches the condition.
 * @method find
 * @owner Observable
 */
function findIndex(predicate, thisArg) {
    return this.lift(new find_1.FindValueOperator(predicate, this, true, thisArg));
}
exports.findIndex = findIndex;
//# sourceMappingURL=findIndex.js.map

/***/ }),

/***/ "Yh8Q":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Observable_1 = __webpack_require__("rCTf");
var ScalarObservable_1 = __webpack_require__("RRVv");
var EmptyObservable_1 = __webpack_require__("jBEF");
var isScheduler_1 = __webpack_require__("fWbP");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var ArrayObservable = (function (_super) {
    __extends(ArrayObservable, _super);
    function ArrayObservable(array, scheduler) {
        _super.call(this);
        this.array = array;
        this.scheduler = scheduler;
        if (!scheduler && array.length === 1) {
            this._isScalar = true;
            this.value = array[0];
        }
    }
    ArrayObservable.create = function (array, scheduler) {
        return new ArrayObservable(array, scheduler);
    };
    /**
     * Creates an Observable that emits some values you specify as arguments,
     * immediately one after the other, and then emits a complete notification.
     *
     * <span class="informal">Emits the arguments you provide, then completes.
     * </span>
     *
     * <img src="./img/of.png" width="100%">
     *
     * This static operator is useful for creating a simple Observable that only
     * emits the arguments given, and the complete notification thereafter. It can
     * be used for composing with other Observables, such as with {@link concat}.
     * By default, it uses a `null` IScheduler, which means the `next`
     * notifications are sent synchronously, although with a different IScheduler
     * it is possible to determine when those notifications will be delivered.
     *
     * @example <caption>Emit 10, 20, 30, then 'a', 'b', 'c', then start ticking every second.</caption>
     * var numbers = Rx.Observable.of(10, 20, 30);
     * var letters = Rx.Observable.of('a', 'b', 'c');
     * var interval = Rx.Observable.interval(1000);
     * var result = numbers.concat(letters).concat(interval);
     * result.subscribe(x => console.log(x));
     *
     * @see {@link create}
     * @see {@link empty}
     * @see {@link never}
     * @see {@link throw}
     *
     * @param {...T} values Arguments that represent `next` values to be emitted.
     * @param {Scheduler} [scheduler] A {@link IScheduler} to use for scheduling
     * the emissions of the `next` notifications.
     * @return {Observable<T>} An Observable that emits each given input value.
     * @static true
     * @name of
     * @owner Observable
     */
    ArrayObservable.of = function () {
        var array = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            array[_i - 0] = arguments[_i];
        }
        var scheduler = array[array.length - 1];
        if (isScheduler_1.isScheduler(scheduler)) {
            array.pop();
        }
        else {
            scheduler = null;
        }
        var len = array.length;
        if (len > 1) {
            return new ArrayObservable(array, scheduler);
        }
        else if (len === 1) {
            return new ScalarObservable_1.ScalarObservable(array[0], scheduler);
        }
        else {
            return new EmptyObservable_1.EmptyObservable(scheduler);
        }
    };
    ArrayObservable.dispatch = function (state) {
        var array = state.array, index = state.index, count = state.count, subscriber = state.subscriber;
        if (index >= count) {
            subscriber.complete();
            return;
        }
        subscriber.next(array[index]);
        if (subscriber.closed) {
            return;
        }
        state.index = index + 1;
        this.schedule(state);
    };
    ArrayObservable.prototype._subscribe = function (subscriber) {
        var index = 0;
        var array = this.array;
        var count = array.length;
        var scheduler = this.scheduler;
        if (scheduler) {
            return scheduler.schedule(ArrayObservable.dispatch, 0, {
                array: array, index: index, count: count, subscriber: subscriber
            });
        }
        else {
            for (var i = 0; i < count && !subscriber.closed; i++) {
                subscriber.next(array[i]);
            }
            subscriber.complete();
        }
    };
    return ArrayObservable;
}(Observable_1.Observable));
exports.ArrayObservable = ArrayObservable;
//# sourceMappingURL=ArrayObservable.js.map

/***/ }),

/***/ "YhcC":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")();
// imports


// module
exports.push([module.i, "/* clearfix */\r\n.clearfix-7da63 {\r\n  clear: both;\r\n}\r\n\r\n/* board */\r\n.board-b72b1 {\r\n  border: 2px solid #404040;\r\n  -webkit-box-sizing: content-box;\r\n  -moz-box-sizing: content-box;\r\n  box-sizing: content-box;\r\n}\r\n\r\n/* square */\r\n.square-55d63 {\r\n  float: left;\r\n  position: relative;\r\n  /* disable any native browser highlighting */\r\n  -webkit-touch-callout: none;\r\n    -webkit-user-select: none;\r\n     -khtml-user-select: none;\r\n       -moz-user-select: none;\r\n        -ms-user-select: none;\r\n            user-select: none;\r\n}\r\n\r\n/* white square */\r\n.white-1e1d7 {\r\n  background-color: #fff;\r\n  color: #31708f;\r\n}\r\n.unicode.w, .unicode.W {\r\n  color: #fff;\r\n}\r\n/* black square */\r\n.black-3c85d {\r\n  background-color: #31708f;\r\n  color: #fff;\r\n}\r\n.unicode.b, .unicode.B {\r\n  color: #000;\r\n}\r\n.unicode {\r\n  position: absolute;\r\n  top: -40%;\r\n}\r\n.unicode:hover {\r\n  position: absolute;\r\n  top: -40%;\r\n}\r\n/* highlighted square */\r\n.highlight1-32417, .highlight2-9c5d2 {\r\n  -webkit-box-shadow: inset 0 0 3px 3px #31b0d5;\r\n  -moz-box-shadow: inset 0 0 3px 3px #31b0d5;\r\n  box-shadow: inset 0 0 3px 3px #31b0d5;\r\n}\r\n\r\n/* notation */\r\n.notation-322f9 {\r\n  cursor: default;\r\n  font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\r\n  font-size: 14px;\r\n  position: absolute;\r\n}\r\n.alpha-d2270 {\r\n  bottom: 1px;\r\n  right: 3px;\r\n}\r\n.numeric-fc462 {\r\n  top: 2px;\r\n  left: 2px;\r\n}\r\n", ""]);

// exports


/***/ }),

/***/ "YhcL":
/***/ (function(module, exports) {

exports.model=Model={Game:{},Board:{},Move:{}},Model.Game.InitGame=function(){for(var t=this.mOptions.width,i=this.mOptions.height,s=this.mOptions.lines,o=[[-1,-1],[0,-1],[1,-1],[-1,0]],h=[],e=0;e<i;e++)for(var r=0;r<t;r++)for(var n=0;n<o.length;n++){var l,a=o[n][0],p=o[n][1],d=[];for(l=0;l<s;l++){var u;if(u=this.mOptions.torus?(e+p*l)*t+(r+a*l+t)%t:(e+p*l)*t+r+a*l,this.mOptions.torus&&(e+p*l<0||e+p*l>=i))break;if(!this.mOptions.torus&&(r+a*l<0||r+a*l>=t||e+p*l<0||e+p*l>=i))break;d.push(u)}l==s&&h.push(d)}this.g.TuplesList=h;for(var m={},l=0;l<h.length;l++)for(var d=h[l],v=0;v<d.length;v++){var u=d[v];void 0===m[u]&&(m[u]=[]),m[u].push(d)}this.g.Tuples=m,this.zobrist=new JocGame.Zobrist({board:{type:"array",size:this.mOptions.width*this.mOptions.height,values:["1","-1"]}})},Model.Move.Init=function(t){this.op=t.op,this.col=t.col},Model.Move.CopyFrom=function(t){this.Init(t)},Model.Move.ToString=function(){var t="";switch(this.op){case"+":t+="+";break;case"-":t+="-";break;default:t+="?"}return t+=String.fromCharCode(65+this.col)},Model.Board.Init=function(t){this.zSign=0},Model.Board.InitialPosition=function(t){this.board=[];for(var i=t.mOptions.width,s=t.mOptions.height,o=0;o<s;o++)for(var h=0;h<i;h++)this.board.push(0);this.tuples={};for(var e=1;e<=t.mOptions.lines;e++)this.tuples[e]=0,this.tuples[-e]=0;this.cols=[];for(var h=0;h<i;h++)this.cols.push(0);if(t.mOptions.fillSides)for(var e=0;e<s;e++){var r=e*i,n=e%2?-1:1,l=0;this.board[r]=n,this.cols[l]++,this.tuples[n]++,this.zSign=t.zobrist.update(this.zSign,"board",n,r);var r=e*i+i-1,n=e%2?1:-1,l=i-1;this.board[r]=n,this.cols[l]++,this.tuples[n]++,this.zSign=t.zobrist.update(this.zSign,"board",n,r)}},Model.Board.GenerateMoves=function(t){for(var i=[],s=t.mOptions.height,o=0;o<t.mOptions.width;o++)this.cols[o]<s&&i.push({op:"+",col:o});if(t.mOptions.remove)for(var o=0;o<t.mOptions.width;o++)this.board[o]==this.mWho&&i.push({op:"-",col:o});this.mMoves=i,0==i.length&&(this.mFinished=!0,this.mWinner=JocGame.DRAW)},Model.Board.Evaluate=function(t){if(this.mEvaluation=0,this.mWinner=0,t.mOptions.preventRepeat&&t.GetRepeatOccurence(this)>2)return this.mFinished=!0,void(this.mWinner=JocGame.DRAW);if(this.tuples[t.mOptions.lines]>0&&(this.mFinished=!0,this.mWinner=1),this.tuples[-t.mOptions.lines]>0)return this.mFinished=!0,void(this.mWinner?this.mWinner=JocGame.DRAW:this.mWinner=-1);if(!this.mFinished)for(var i=t.mOptions.levelOptions,s=1;s<t.mOptions.lines;s++)this.mEvaluation+=this.tuples[s]*i["evalTuple"+s],this.mEvaluation-=this.tuples[-s]*i["evalTuple"+s]},Model.Board.ApplyMove=function(t,i){if("+"==i.op){for(var s=i.col,o=this.cols[s],h=o*t.mOptions.width+s,e=0;e<t.g.Tuples[h].length;e++){for(var r=t.g.Tuples[h][e],n={1:0,0:0,"-1":0},l=0;l<r.length;l++)n[this.board[r[l]]]++;n[1]>0&&0==n[-1]?this.tuples[n[1]]--:n[-1]>0&&0==n[1]&&this.tuples[-n[-1]]--,n[this.mWho]++,n[1]>0&&0==n[-1]?this.tuples[n[1]]++:n[-1]>0&&0==n[1]&&this.tuples[-n[-1]]++}this.board[h]=this.mWho,this.cols[s]++,this.zSign=t.zobrist.update(this.zSign,"board",this.mWho,h)}else if("-"==i.op){for(var o=0;o<this.cols[i.col];o++)for(var h=o*t.mOptions.width+i.col,e=0;e<t.g.Tuples[h].length;e++){for(var r=t.g.Tuples[h][e],n={1:0,0:0,"-1":0},l=0;l<r.length;l++)n[this.board[r[l]]]++;n[1]>0&&0==n[-1]?this.tuples[n[1]]--:n[-1]>0&&0==n[1]&&this.tuples[-n[-1]]--}for(var e=0;e<this.cols[i.col];e++){var h=e*t.mOptions.width+i.col,a=h+t.mOptions.width,p=0;a<this.board.length&&(p=this.board[a]),this.zSign=t.zobrist.update(this.zSign,"board",this.board[h],h),p&&(this.zSign=t.zobrist.update(this.zSign,"board",p,h)),this.board[h]=p}this.cols[i.col]--;for(var o=0;o<this.cols[i.col];o++)for(var h=o*t.mOptions.width+i.col,e=0;e<t.g.Tuples[h].length;e++){for(var r=t.g.Tuples[h][e],n={1:0,0:0,"-1":0},l=0;l<r.length;l++)n[this.board[r[l]]]++;n[1]>0&&0==n[-1]?this.tuples[n[1]]++:n[-1]>0&&0==n[1]&&this.tuples[-n[-1]]++}}else console.error("Invalid move",i)},Model.Board.CopyFrom=function(t){this.tuples={};for(var i in t.tuples)this.tuples[i]=t.tuples[i];this.board=[];for(var s=0;s<t.board.length;s++)this.board.push(t.board[s]);this.cols=[];for(var o=0;o<t.cols.length;o++)this.cols.push(t.cols[o]);this.mWho=t.mWho,this.zSign=t.zSign},Model.Board.GetSignature=function(){return this.zSign};

/***/ }),

/***/ "Yuqe":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var mergeMapTo_1 = __webpack_require__("iESu");
/* tslint:enable:max-line-length */
/**
 * Projects each source value to the same Observable which is merged multiple
 * times in a serialized fashion on the output Observable.
 *
 * <span class="informal">It's like {@link concatMap}, but maps each value
 * always to the same inner Observable.</span>
 *
 * <img src="./img/concatMapTo.png" width="100%">
 *
 * Maps each source value to the given Observable `innerObservable` regardless
 * of the source value, and then flattens those resulting Observables into one
 * single Observable, which is the output Observable. Each new `innerObservable`
 * instance emitted on the output Observable is concatenated with the previous
 * `innerObservable` instance.
 *
 * __Warning:__ if source values arrive endlessly and faster than their
 * corresponding inner Observables can complete, it will result in memory issues
 * as inner Observables amass in an unbounded buffer waiting for their turn to
 * be subscribed to.
 *
 * Note: `concatMapTo` is equivalent to `mergeMapTo` with concurrency parameter
 * set to `1`.
 *
 * @example <caption>For each click event, tick every second from 0 to 3, with no concurrency</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.concatMapTo(Rx.Observable.interval(1000).take(4));
 * result.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // (results are not concurrent)
 * // For every click on the "document" it will emit values 0 to 3 spaced
 * // on a 1000ms interval
 * // one click = 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3
 *
 * @see {@link concat}
 * @see {@link concatAll}
 * @see {@link concatMap}
 * @see {@link mergeMapTo}
 * @see {@link switchMapTo}
 *
 * @param {ObservableInput} innerObservable An Observable to replace each value from
 * the source Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} An observable of values merged together by joining the
 * passed observable with itself, one after the other, for each value emitted
 * from the source.
 * @method concatMapTo
 * @owner Observable
 */
function concatMapTo(innerObservable, resultSelector) {
    return this.lift(new mergeMapTo_1.MergeMapToOperator(innerObservable, resultSelector, 1));
}
exports.concatMapTo = concatMapTo;
//# sourceMappingURL=concatMapTo.js.map

/***/ }),

/***/ "Z5yY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("3j3K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__media_query_media_monitor__ = __webpack_require__("bWt6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base__ = __webpack_require__("TwGT");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FlexFillDirective; });
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */



var FLEX_FILL_CSS = {
    'margin': 0,
    'width': '100%',
    'height': '100%',
    'min-width': '100%',
    'min-height': '100%'
};
/**
 * 'fxFill' flexbox styling directive
 *  Maximizes width and height of element in a layout container
 *
 *  NOTE: fxFill is NOT responsive API!!
 */
var FlexFillDirective = (function (_super) {
    __extends(FlexFillDirective, _super);
    function FlexFillDirective(monitor, elRef, renderer) {
        var _this = _super.call(this, monitor, elRef, renderer) || this;
        _this.elRef = elRef;
        _this.renderer = renderer;
        _this._applyStyleToElement(FLEX_FILL_CSS);
        return _this;
    }
    return FlexFillDirective;
}(__WEBPACK_IMPORTED_MODULE_2__base__["a" /* BaseFxDirective */]));

FlexFillDirective.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{ selector: "\n  [fxFill],\n  [fxFlexFill]\n" },] },
];
/** @nocollapse */
FlexFillDirective.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_1__media_query_media_monitor__["a" /* MediaMonitor */], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer2"], },
]; };
//# sourceMappingURL=flex-fill.js.map

/***/ }),

/***/ "Z9P/":
/***/ (function(module, exports) {

exports.config = {"status":true,"model":{"title-en":"Margo 7","module":"margo","js":["spbase-model.js","margo-model.js"],"summary":"Margo game","thumbnail":"tn-margo7.png","strings":[],"rules":{"en":"rules.html","fr":"rules-fr.html"},"description":{"en":"description.html","fr":"description-fr.html"},"credits":{"en":"credits.html","fr":"credits-fr.html"},"demoRandom":true,"gameOptions":{"preventRepeat":true,"uctTransposition":"states","uctIgnoreLoop":true,"size":7,"levelOptions":{"evalSafety":20,"evalSafety2eyes":19.585075193114,"evalSafetyXEyesBonus":1.341487216319,"evalSafety1f":9.6161542055582,"evalSafety3f":39.04195901009,"evalSafety3fMore":34.25098499078,"evalSafety3fMoreBonus":0.74764503238808,"evalSafety1eyeBonus":6.6109850341,"evalSafetyPinnedBonus":0,"evalHeightRatio":1.8392730390391,"evalCenterRatio":0.077991601047649}},"plazza":"true","levels":[{"label":"Fast (1sec)","maxDuration":1,"isDefault":true,"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0,"ignoreLeaf":false,"uncertaintyFactor":1.1607776901587},{"label":"Beginner","maxDuration":1,"maxNodes":250,"maxLoops":50,"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0,"ignoreLeaf":false,"uncertaintyFactor":1.1607776901587},{"label":"Easy","maxDuration":2,"maxNodes":500,"maxLoops":100,"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0,"ignoreLeaf":false,"uncertaintyFactor":1.1607776901587},{"label":"Medium","maxDuration":4,"maxNodes":2500,"maxLoops":200,"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0,"ignoreLeaf":false,"uncertaintyFactor":1.1607776901587},{"label":"Confirmed","maxDuration":8,"maxNodes":5000,"maxLoops":500,"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0,"ignoreLeaf":false,"uncertaintyFactor":1.1607776901587},{"label":"Slow (10sec)","maxDuration":10,"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0,"ignoreLeaf":false,"uncertaintyFactor":1.1607776901587}]},"view":{"title-en":"Margo View","module":"margo","js":["spbase-xd-view.js"],"xdView":true,"css":["spbase.css"],"preferredRatio":1,"useNotation":true,"defaultOptions":{"sounds":true,"moves":true,"notation":false},"skins":[{"name":"classic3d","title":"3D Classic","3d":true,"camera":{"radius":20,"elevationAngle":45,"limitCamMoves":true,"distMax":40,"distMin":10,"elevationMin":-45,"elevationMax":89.9,"enableDrag":false},"world":{"lightIntensity":0,"color":0,"fog":false,"skyLightIntensity":0.7,"skyLightPosition":{"x":0,"y":10,"z":0},"ambientLightColor":8947848},"preload":["image|/res/xd-view/meshes/grey.png","image|/res/xd-view/meshes/black.png","image|/res/xd-view/meshes/white.png","image|/res/xd-view/meshes/green.png","image|/res/xd-view/meshes/skybox/nx.jpg","image|/res/xd-view/meshes/skybox/ny.jpg","image|/res/xd-view/meshes/skybox/nz.jpg","image|/res/xd-view/meshes/skybox/px.jpg","image|/res/xd-view/meshes/skybox/py.jpg","image|/res/xd-view/meshes/skybox/pz.jpg"]},{"name":"wood","title":"Wood","preload":["image|/res/images/ball_black.png","image|/res/images/ball_white.png","image|/res/images/ball_green.png","image|/res/images/plot.png","image|/res/images/wood.png"]},{"name":"classical","title":"Classic","preload":["image|/res/images/ball_black.png","image|/res/images/ball_white.png","image|/res/images/ball_green.png","image|/res/images/plot.png"]}],"animateSelfMoves":false,"visuals":{"600x600":["res/visuals/margo7-600x600-3d.jpg","res/visuals/margo7-600x600-2d.jpg"]}}}

/***/ }),

/***/ "ZJf8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscription_1 = __webpack_require__("B00U");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var SubjectSubscription = (function (_super) {
    __extends(SubjectSubscription, _super);
    function SubjectSubscription(subject, subscriber) {
        _super.call(this);
        this.subject = subject;
        this.subscriber = subscriber;
        this.closed = false;
    }
    SubjectSubscription.prototype.unsubscribe = function () {
        if (this.closed) {
            return;
        }
        this.closed = true;
        var subject = this.subject;
        var observers = subject.observers;
        this.subject = null;
        if (!observers || observers.length === 0 || subject.isStopped || subject.closed) {
            return;
        }
        var subscriberIndex = observers.indexOf(this.subscriber);
        if (subscriberIndex !== -1) {
            observers.splice(subscriberIndex, 1);
        }
    };
    return SubjectSubscription;
}(Subscription_1.Subscription));
exports.SubjectSubscription = SubjectSubscription;
//# sourceMappingURL=SubjectSubscription.js.map

/***/ }),

/***/ "Zcpd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ngrx_core__ = __webpack_require__("pCI3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__ = __webpack_require__("rCTf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Store; });
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var Store = (function (_super) {
    __extends(Store, _super);
    function Store(_dispatcher, _reducer, state$) {
        var _this = _super.call(this) || this;
        _this._dispatcher = _dispatcher;
        _this._reducer = _reducer;
        _this.select = __WEBPACK_IMPORTED_MODULE_0__ngrx_core__["a" /* select */].bind(_this);
        _this.source = state$;
        return _this;
    }
    Store.prototype.lift = function (operator) {
        var store = new Store(this._dispatcher, this._reducer, this);
        store.operator = operator;
        return store;
    };
    Store.prototype.replaceReducer = function (reducer) {
        this._reducer.next(reducer);
    };
    Store.prototype.dispatch = function (action) {
        this._dispatcher.next(action);
    };
    Store.prototype.next = function (action) {
        this._dispatcher.next(action);
    };
    Store.prototype.error = function (err) {
        this._dispatcher.error(err);
    };
    Store.prototype.complete = function () {
        // noop
    };
    return Store;
}(__WEBPACK_IMPORTED_MODULE_1_rxjs_Observable__["Observable"]));

//# sourceMappingURL=store.js.map

/***/ }),

/***/ "ZgDm":
/***/ (function(module, exports) {

exports.model=Model={Game:{},Board:{},Move:{}},function(){function t(t){if(o){var e=t%s;return(t-e)/s*s+s-e}var r=s*i-t-1,n=r%s;return r-n+s-n}var s,i,o=!1;Model.Game.checkersPosToString=t,Model.Game.InitGameInfo=function(){},Model.Game.BuildGraphCoord=function(){var t=(this.mOptions.width,this.mOptions.height,[]),s=[];this.g.Graph=t,this.g.Coord=s},Model.Game.InitGame=function(){var t=this.mOptions.width,e=this.mOptions.height;if(s=t,i=e,o=this.mOptions.invertNotation||!1,this.g.compulsoryCatch=!0,this.g.canStepBack=!0,this.g.mustMoveForward=!1,this.g.mustMoveForwardStrict=!1,this.g.lastRowFreeze=!1,this.g.lastRowCrown=!1,this.g.captureLongestLine=!1,this.g.noMove="lose",this.g.kingCaptureShort=!1,this.g.kingValue=5,this.g.lastRowFactor=0,this.g.canCaptureBackward=!0,this.g.captureInstantRemove=!1,this.g.longRangeKing=!0,this.g.drawKvsK=!0,this.g.drawKvs2K=!0,this.g.whiteStarts=!0,this.g.king180deg=!1,this.mOptions.variant)for(var r in this.mOptions.variant)this.mOptions.variant.hasOwnProperty(r)&&(this.g[r]=this.mOptions.variant[r]);this.BuildGraphCoord(),this.zobrist=new JocGame.Zobrist({board:{type:"array",size:this.g.Graph.length,values:["1/0","1/1","-1/0","-1/1"]}})},Model.Game.DestroyGame=function(){},Model.Game.CheckersDirections=4,Model.Game.Checkers2WaysDirections=[0,1,1,0],Model.Game.CheckersEachDirection=function(t,s){for(var i=0;i<this.CheckersDirections;i++){var o=this.g.Graph[t][i];if(null!=o&&0==s(o,i))return}},Model.Move.Init=function(t){this.pos=[];for(var s=t.pos?Object.keys(t.pos).sort():[],i=0;i<s.length;i++)this.pos.push(t.pos[i]);this.capt=[];for(var o=t.capt?Object.keys(t.capt).sort():[],i=0;i<o.length;i++)this.capt.push(t.capt[i])},Model.Move.ToString=function(s){s=s||"natural";var i=this;switch(s){case"natural":return function(){for(var s=[t(i.pos[0]),t(i.pos[i.pos.length-1])],o="-",e=1;e<i.capt.length;e++)null!=i.capt[e]&&(o="x",i.capt.length>3&&s.push(t(i.capt[e])));return s.join(o)}();case"hub":return function(){var s="-",o=[t(i.pos[0]),t(i.pos[i.pos.length-1])];if(i.capt[1]){s="x";var e=i.capt.slice(1).map(function(s){return t(s)});e.sort(),o=o.concat(e)}return o.join(s)}();case"dxp":return function(){var s=[t(i.pos[0]),t(i.pos[i.pos.length-1])];if(i.capt[1]){s.push(i.capt.length-1);for(var o=[],e=1;e<i.capt.length;e++)o.push(t(i.capt[e]));o.sort(),s=s.concat(o)}else s.push(0);return s.map(function(t){return t<10?"0"+t:t}).join("")}();default:return"??"}},Model.Board.Init=function(t){this.zSign=0},Model.Board.InitialPosition=function(t){var s=t.mOptions.width,i=t.mOptions.height,o=t.mOptions.initial;this.board=[];for(var e=0;e<i;e++)for(var r=0;r<s;r++)this.board[e*s+r]=-1;this.pieces=[];var n=0;if(t.mInitial){this.pCount=[0,0],this.spCount=[0,0],this.kpCount=[0,0];for(var a=0;a<t.mInitial.pieces.length;a++){var h=t.mInitial.pieces[a];this.board[h.p]=a,this.pieces.push({s:h.s,p:h.p,l:-1,t:h.t,plp:h.p}),this.zSign=t.zobrist.update(this.zSign,"board",h.s+"/"+h.t,h.p);var p=-(h.s-1)/2;this.pCount[p]++,0==h.t?this.spCount[p]++:this.kpCount[p]++}}else{for(var a in o.a)if(o.a.hasOwnProperty(a)){var u=o.a[a],c=u[0]*s+u[1],h={s:JocGame.PLAYER_A,p:c,l:-1,t:0,plp:c};this.pieces.push(h),this.board[c]=n++,this.zSign=t.zobrist.update(this.zSign,"board","1/0",c)}for(var a in o.b)if(o.b.hasOwnProperty(a)){var u=o.b[a],c=u[0]*s+u[1],h={s:JocGame.PLAYER_B,p:c,l:-1,t:0,plp:c};this.pieces.push(h),this.board[c]=n++,this.zSign=t.zobrist.update(this.zSign,"board","-1/0",c)}this.pCount=[o.a.length,o.b.length],this.spCount=[o.a.length,o.b.length],this.kpCount=[o.a.length,o.b.length]}},Model.Board.GenerateMoves=function(t){try{this._GenerateMoves(t)}catch(t){}},Model.Board._GenerateMoves=function(t){function s(t){for(var s=0;s<e.pieces.length;s++){var i=e.pieces[s];i&&i.s==e.mWho&&t(s,i.p)}}function i(s,o,r,n,a){for(;;){var h=[],p=[],u=[];if(t.CheckersEachDirection(s,function(i,c){var l;0==t.g.canCaptureBackward&&(l=t.g.Coord[s][0]);var g=t.Checkers2WaysDirections[c];if(a){if(t.g.longRangeKing)for(;e.board[i]==-1||t.g.king180deg&&null!=i&&r.indexOf(i)>=0;)i=t.g.Graph[i][c];if(null!=i&&e.board[i]>=0&&e.pieces[e.board[i]].s==-e.mWho){var v=i;if(i=t.g.Graph[i][c],t.g.kingCaptureShort){if(e.board[i]==-1||i==o[0]){for(var f=!0,d=0;d<n.length;d++)if(t.g.king180deg){if(r[d]==v){f=!1;break}}else if(t.g.captureInstantRemove&&r[d]==v||0==t.g.captureInstantRemove&&r[d]==v&&n[d]==g){f=!1;break}f&&(h.push(i),p.push(v),u.push(g)),i=t.g.Graph[i][c]}}else for(;e.board[i]==-1||i==o[0];){for(var f=!0,d=0;d<n.length;d++)if(t.g.captureInstantRemove&&r[d]==v||0==t.g.captureInstantRemove&&r[d]==v&&n[d]==g){f=!1;break}f&&(h.push(i),p.push(v),u.push(g)),i=t.g.Graph[i][c]}}}else if(e.board[i]>=0&&e.pieces[e.board[i]].s==-e.mWho){var m,C;if(0==t.g.canCaptureBackward&&(m=t.g.Coord[i][0],C=!1,(e.mWho==JocGame.PLAYER_A&&m>=l||e.mWho==JocGame.PLAYER_B&&m<=l)&&(C=!0)),t.g.canCaptureBackward||1==C){var b=t.g.Graph[i][c];if(null!=b&&(e.board[b]==-1||b==o[0])){for(var f=!0,d=0;d<n.length;d++)if(t.g.captureInstantRemove&&r[d]==i||0==t.g.captureInstantRemove&&r[d]==i&&n[d]==g){f=!1;break}f&&(h.push(b),p.push(i),u.push(g))}}}return!0}),0==h.length){o.length>1&&e.mMoves.push({pos:o,capt:r});break}if(!t.g.compulsoryCatch&&o.length>1){for(var c=[],l=0;l<o.length;l++)c.push(o[l]);for(var g=[],l=0;l<r.length;l++)g.push(r[l]);e.mMoves.push({pos:c,capt:g})}if(1!=h.length){for(var l=0;l<h.length;l++){for(var c=[],v=0;v<o.length;v++)c.push(o[v]);c.push(h[l]);for(var g=[],v=0;v<r.length;v++)g.push(r[v]);g.push(p[l]);for(var f=[],v=0;v<n.length;v++)f.push(n[v]);f.push(u[l]),i(h[l],c,g,f,a)}break}s=h[0],o.push(s),r.push(p[0]),n.push(u[0])}}var o=t.mOptions.height,e=this;if(this.mMoves=[],s(function(t,s){0==e.pieces[t].t?i(s,[s],[null],[null],!1):1==e.pieces[t].t&&i(s,[s],[null],[null],!0)}),0!=t.g.compulsoryCatch&&0!=this.mMoves.length||s(function(s,i){var r;0==e.pieces[s].t?((t.g.mustMoveForward||t.g.mustMoveForwardStrict||t.lastRowFreeze)&&(r=t.g.Coord[i][0]),t.CheckersEachDirection(i,function(n,a){var h,p,u;return t.g.mustMoveForwardStrict?(h=t.g.Coord[n][0],p=!1,(e.mWho==JocGame.PLAYER_A&&h>r||e.mWho==JocGame.PLAYER_B&&h<r)&&(p=!0)):t.g.mustMoveForward&&(h=t.g.Coord[n][0],p=!0,(e.mWho==JocGame.PLAYER_A&&h<r||e.mWho==JocGame.PLAYER_B&&h>r)&&(p=!1)),t.g.lastRowFreeze&&(u=!1,(e.mWho==JocGame.PLAYER_A&&r==o-1||e.mWho==JocGame.PLAYER_B&&0==r)&&(u=!0)),e.board[n]!=-1||!t.g.canStepBack&&n==e.pieces[s].l||(0!=t.g.mustMoveForward||0!=t.g.mustMoveForwardStrict)&&1!=p||0!=t.g.lastRowFreeze&&0!=u||e.mMoves.push({pos:[i,n],capt:[null,null]}),!0})):1==e.pieces[s].t&&t.CheckersEachDirection(i,function(s,o){if(t.g.longRangeKing)for(;e.board[s]==-1;)e.mMoves.push({pos:[i,s],capt:[null,null]}),s=t.g.Graph[s][o];else e.board[s]==-1&&(e.mMoves.push({pos:[i,s],capt:[null,null]}),s=t.g.Graph[s][o]);return!0})}),0==this.mMoves.length)switch(t.g.noMove){case"count":this.mFinished=!0,this.pCount[0]<this.pCount[1]?this.mWinner=JocGame.PLAYER_B:this.pCount[1]<this.pCount[0]?this.mWinner=JocGame.PLAYER_A:this.mWinner=JocGame.DRAW;break;case"lose":this.mFinished=!0,this.mWinner=-this.mWho;break;default:this.mFinished=!0,this.mWinner=JocGame.DRAW}if(t.g.captureLongestLine){for(var r=this.mMoves,n=[],a=0,h=0;h<r.length;h++){var p=r[h];p.pos.length==a?n.push(p):p.pos.length>a&&(n=[p],a=p.pos.length)}this.mMoves=n}},Model.Board.Evaluate=function(t,s,i){if(t.mOptions.preventRepeat&&t.GetRepeatOccurence(this)>2)return this.mFinished=!0,void(this.mWinner=JocGame.DRAW);if(t.g.drawKvsK&&0==this.spCount[0]&&0==this.spCount[1]&&1==this.kpCount[0]&&1==this.kpCount[1])return this.mFinished=!0,void(this.mWinner=JocGame.DRAW);if(t.g.drawKvs2K&&0==this.spCount[0]&&0==this.spCount[1]&&this.kpCount[0]+this.kpCount[1]==3&&(1==this.kpCount[0]||2==this.kpCount[0]))return this.mFinished=!0,void(this.mWinner=JocGame.DRAW);if(0==this.pCount[1])return this.mFinished=!0,void(this.mWinner=JocGame.PLAYER_A);if(0==this.pCount[0])return this.mFinished=!0,void(this.mWinner=JocGame.PLAYER_B);if(this.mEvaluation=10*(this.spCount[0]-this.spCount[1])+10*(this.kpCount[0]-this.kpCount[1])*t.g.kingValue+this.pCount[0]/this.pCount[1]-this.pCount[1]/this.pCount[0],0!=t.g.lastRowFactor){for(var o=t.mOptions.height,e=0,r=0,n=0;n<this.pieces.length;n++){var a=this.pieces[n];a&&0==a.t&&(this.mWho==JocGame.PLAYER_A?e+=t.g.Coord[a.p][0]:r+=o-1-t.g.Coord[a.p][0])}this.mEvaluation+=(e-r)*t.g.lastRowFactor}},Model.Board.CopyFrom=function(t){this.board=[];for(var s=0;s<t.board.length;s++)this.board[s]=t.board[s];this.pieces=[];for(var s=0;s<t.pieces.length;s++){var i=t.pieces[s];this.pieces[s]=null==i?null:{s:i.s,p:i.p,l:i.l,t:i.t,plp:i.plp}}this.pCount=[t.pCount[0],t.pCount[1]],this.spCount=[t.spCount[0],t.spCount[1]],this.kpCount=[t.kpCount[0],t.kpCount[1]],this.mWho=t.mWho,this.zSign=t.zSign},Model.Board.ApplyMove=function(t,s){var i=(t.mOptions.width,t.mOptions.height),o=s.pos[0],e=this.board[o],r=this.pieces[e],n=r.s;r.l=o;var a={};this.zSign=t.zobrist.update(this.zSign,"board",r.s+"/"+r.t,r.p);for(var h=1;h<s.pos.length;h++){var p=s.pos[h];this.board[r.p]=-1,r.p=p,this.board[p]=e;var u=s.capt[h];null!=u&&(this.board[u]>=0&&(a[this.board[u]]=!0),this.board[u]=-1),o=p}this.zSign=t.zobrist.update(this.zSign,"board",r.s+"/"+r.t,p);var c=s.capt[s.capt.length-1];r.plp=c||s.pos[s.pos.length-2];for(var l in a)if(a.hasOwnProperty(l)){var g=this.pieces[l],v=(1-g.s)/2;switch(this.pCount[v]--,g.t){case 0:this.spCount[v]--;break;case 1:this.kpCount[v]--}this.zSign=t.zobrist.update(this.zSign,"board",g.s+"/"+g.t,g.p),this.pieces[l]=null}if(t.g.lastRowCrown&&0==this.pieces[e].t){var f=t.g.Coord[s.pos[s.pos.length-1]][0];if(n==JocGame.PLAYER_A&&f==i-1||n==JocGame.PLAYER_B&&0==f){var g=this.pieces[e];g.t=1;var d=(1-n)/2;this.spCount[d]--,this.kpCount[d]++,this.zSign=t.zobrist.update(this.zSign,"board",g.s+"/0",g.p),this.zSign=t.zobrist.update(this.zSign,"board",g.s+"/1",g.p)}}},Model.Board.IsValidMove=function(t,s){return!0},Model.Board.GetSignature=function(){return this.zSign},Model.Game.Import=function(t,s){function i(t,s,i){i=r-i;var o=i%n;i=i-o+n-o-1,e.push({s:t,p:i,l:-1,t:s,plp:i})}var o=1,e=[],r=this.mOptions.width*this.mOptions.height,n=this.mOptions.width;if("pjn"==t){var a=s.split(":");o="W"==a[0]?1:-1;for(var h=1;h<a.length;h++)if(0!=a[h].length)for(var p="W"==a[h].substr(0,1)?1:-1,u=a[h].substr(1).split(","),c=0;c<u.length;c++){var l=u[c],g=0;"K"==l.substr(0,1)&&(g=1,l=l.substr(1));var v=/^([0-9]+)-([0-9]+)$/.exec(l);if(v)for(var f=parseInt(v[1]);f<=parseInt(v[2]);f++)i(p,g,f);else i(p,g,parseInt(l))}return e.sort(function(t,s){return s.s-t.s}),{status:!0,initial:{pieces:e,turn:o}}}return{status:!1,error:"unsupported"}};var e=JocGame.prototype.GetBestMatchingMove;Model.Game.GetBestMatchingMove=function(t,s){var i=[],o=this;s.forEach(function(t){"function"==typeof t.ToString?i.push(t.ToString()):i.push(o.CreateMove(t).ToString())}),t=t.replace(/0([1-9])/g,"$1");var r=/^([0-9]+)[\-x]([0-9]+)([\-x][0-9]+)*$/.exec(t);if(r){var n=new RegExp("^"+r[1]+"[-x]"+r[2]+"([-x][0-9]+)*$"),a={};s.forEach(function(t,s){if(n.test(i[s])){var o=i[s],e=/^([0-9]+)x([0-9]+)x([0-9]+(x[0-9]+)*)/.exec(o);if(e){var r=e[3].split("x");r.sort(function(t,s){return parseInt(t)-parseInt(s)}),o=e[1]+"x"+e[2]+"x"+r.join("x")}a[o]=t}});var h=[];for(var p in a)a.hasOwnProperty(p)&&h.push(a[p]);h.length>0&&(s=h)}return e.call(this,t,s)},Model.Board.ExportBoardState=function(o,e){function r(t){for(var o=[],e=0;e<n.board.length;e++){var r=e%s,a=(e-r)/s,h=(i-a-1)*s+r,p=n.board[e];if(p<0)o[h]="e";else{var u=n.pieces[p],c=1==u.s?"w":t;1==u.t&&(c=c.toUpperCase()),o[h]=c}}return o.join("")}e=e||"natural";var n=this;switch(e){case"natural":case"fen":return function(){var s={},i=[];n.pieces.forEach(function(i){if(i&&null!=i.p){var o=1==i.s?"W":"B";void 0===s[o]&&(s[o]={});var e=1==i.t?"K":"";void 0===s[o][e]&&(s[o][e]={group:0==i.t,pos:[]}),s[o][e].pos.push(parseInt(t(i.p)))}});for(var o in s)if(s.hasOwnProperty(o)){var e=[];for(var r in s[o])if(s[o].hasOwnProperty(r)){var a=s[o][r];if(a.group){a.pos.sort(function(t,s){return parseInt(t)-parseInt(s)});var h=-2,p=-1,u=-1;a.pos.forEach(function(t){parseInt(t)==h+1?p=t:(p>=0?(e.push(r+u+"-"+p),p=-1):u>=0&&e.push(r+u),u=t),h=parseInt(t)}),p>=0?e.push(r+u+"-"+p):u>=0&&e.push(r+u)}else a.pos.forEach(function(t){e.push(r+t)})}i.push(o+e.join(","))}return i.join(":")}();case"dxp":return function(){return r("z")}();case"hub":return function(){return r("z")}();default:return JSON.stringify(this)}}}(),Model.Game.BuildGraphCoord=function(){for(var t=this.mOptions.width,s=this.mOptions.height,i=[],o=[],e=0;e<s;e++)for(var r=0;r<t;r++){var n=e*t+r;o[n]=[e,r],i[n]=[],e%2==0?(e<s-1?(i[n].push((e+1)*t+r),r>0?i[n].push((e+1)*t+r-1):i[n].push(null)):(i[n].push(null),i[n].push(null)),e>0?(i[n].push((e-1)*t+r),r>0?i[n].push((e-1)*t+r-1):i[n].push(null)):(i[n].push(null),i[n].push(null))):(e<s-1?(r<t-1?i[n].push((e+1)*t+r+1):i[n].push(null),i[n].push((e+1)*t+r)):(i[n].push(null),i[n].push(null)),e>0?(r<t-1?i[n].push((e-1)*t+r+1):i[n].push(null),i[n].push((e-1)*t+r)):(i[n].push(null),i[n].push(null)))}this.g.Graph=i,this.g.Coord=o};

/***/ }),

/***/ "ZvZx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var reduce_1 = __webpack_require__("pgP5");
/**
 * The Max operator operates on an Observable that emits numbers (or items that can be compared with a provided function),
 * and when source Observable completes it emits a single item: the item with the largest value.
 *
 * <img src="./img/max.png" width="100%">
 *
 * @example <caption>Get the maximal value of a series of numbers</caption>
 * Rx.Observable.of(5, 4, 7, 2, 8)
 *   .max()
 *   .subscribe(x => console.log(x)); // -> 8
 *
 * @example <caption>Use a comparer function to get the maximal item</caption>
 * interface Person {
 *   age: number,
 *   name: string
 * }
 * Observable.of<Person>({age: 7, name: 'Foo'},
 *                       {age: 5, name: 'Bar'},
 *                       {age: 9, name: 'Beer'})
 *           .max<Person>((a: Person, b: Person) => a.age < b.age ? -1 : 1)
 *           .subscribe((x: Person) => console.log(x.name)); // -> 'Beer'
 * }
 *
 * @see {@link min}
 *
 * @param {Function} [comparer] - Optional comparer function that it will use instead of its default to compare the
 * value of two items.
 * @return {Observable} An Observable that emits item with the largest value.
 * @method max
 * @owner Observable
 */
function max(comparer) {
    var max = (typeof comparer === 'function')
        ? function (x, y) { return comparer(x, y) > 0 ? x : y; }
        : function (x, y) { return x > y ? x : y; };
    return this.lift(new reduce_1.ReduceOperator(max));
}
exports.max = max;
//# sourceMappingURL=max.js.map

/***/ }),

/***/ "ZyKR":
/***/ (function(module, exports, __webpack_require__) {

var
    PDNParser = __webpack_require__("CGDc"),
    Game = __webpack_require__("WkCC").Game,
    Piece = __webpack_require__("WkCC").Piece
;

function PDN(pdnText) {
    this.parser = new PDNParser();
    this.parser.setPDNText(pdnText);
};

PDN.prototype.getGameCount = function(){
    return this.parser.getGameCount();
};

PDN.prototype.getTitle = function(numGame, pattern){
    return this.parser.getTitle(numGame, pattern);
};

PDN.prototype.getTitles = function(pattern){
    return this.parser.getTitles(pattern);
};

PDN.prototype.getGame = function(numGame) {
    var game = new Game();

    var nbGame = this.getGameCount();
    if (nbGame > 0){
        var pdnObj = this.parser.parse(numGame);
                
        // ----------------------
        // Position
        // ----------------------
        if (!pdnObj.hasFEN()) {
            game.board.setInitialPosition();
        } else {
            var lst = pdnObj.getFENList("WP");
            game.board.setPosition(Piece.PAWN_WHITE, lst);
            
            lst = pdnObj.getFENList("BP");
            game.board.setPosition(Piece.PAWN_BLACK, lst);

            lst = pdnObj.getFENList("WK");
            game.board.setPosition(Piece.DAME_WHITE, lst);

            lst = pdnObj.getFENList("BK");
            game.board.setPosition(Piece.DAME_BLACK, lst);
        } 


        // ----------------------
        // Notation
        // ----------------------
        var moves = pdnObj.getMoves();
        for (var k = 0; k < moves.length; k++){
            var move = moves[k];
            var move1 = move["move1"];
            var move2 = move["move2"];

            if (move1 != "") {
                game.addMoveTxt(move1);
            }

            if (move2 != "") {
                game.addMoveTxt(move2);
            }
        }
    }

    return game;
};


module.exports = PDN;


/***/ }),

/***/ "a0Ch":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var timeoutWith_1 = __webpack_require__("8DDp");
Observable_1.Observable.prototype.timeoutWith = timeoutWith_1.timeoutWith;
//# sourceMappingURL=timeoutWith.js.map

/***/ }),

/***/ "aDoP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("3j3K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_object_extend__ = __webpack_require__("xZ/u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base__ = __webpack_require__("TwGT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__media_query_media_monitor__ = __webpack_require__("bWt6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__layout__ = __webpack_require__("Sxsi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_layout_validator__ = __webpack_require__("eKS0");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LayoutAlignDirective; });
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */






/**
 * 'layout-align' flexbox styling directive
 *  Defines positioning of child elements along main and cross axis in a layout container
 *  Optional values: {main-axis} values or {main-axis cross-axis} value pairs
 *
 *  @see https://css-tricks.com/almanac/properties/j/justify-content/
 *  @see https://css-tricks.com/almanac/properties/a/align-items/
 *  @see https://css-tricks.com/almanac/properties/a/align-content/
 */
var LayoutAlignDirective = (function (_super) {
    __extends(LayoutAlignDirective, _super);
    /* tslint:enable */
    function LayoutAlignDirective(monitor, elRef, renderer, container) {
        var _this = _super.call(this, monitor, elRef, renderer) || this;
        _this._layout = 'row'; // default flex-direction
        if (container) {
            _this._layoutWatcher = container.layout$.subscribe(_this._onLayoutChange.bind(_this));
        }
        return _this;
    }
    Object.defineProperty(LayoutAlignDirective.prototype, "align", {
        /* tslint:disable */
        set: function (val) { this._cacheInput('align', val); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LayoutAlignDirective.prototype, "alignXs", {
        set: function (val) { this._cacheInput('alignXs', val); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LayoutAlignDirective.prototype, "alignSm", {
        set: function (val) { this._cacheInput('alignSm', val); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(LayoutAlignDirective.prototype, "alignMd", {
        set: function (val) { this._cacheInput('alignMd', val); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(LayoutAlignDirective.prototype, "alignLg", {
        set: function (val) { this._cacheInput('alignLg', val); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(LayoutAlignDirective.prototype, "alignXl", {
        set: function (val) { this._cacheInput('alignXl', val); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(LayoutAlignDirective.prototype, "alignGtXs", {
        set: function (val) { this._cacheInput('alignGtXs', val); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(LayoutAlignDirective.prototype, "alignGtSm", {
        set: function (val) { this._cacheInput('alignGtSm', val); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(LayoutAlignDirective.prototype, "alignGtMd", {
        set: function (val) { this._cacheInput('alignGtMd', val); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(LayoutAlignDirective.prototype, "alignGtLg", {
        set: function (val) { this._cacheInput('alignGtLg', val); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(LayoutAlignDirective.prototype, "alignLtSm", {
        set: function (val) { this._cacheInput('alignLtSm', val); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(LayoutAlignDirective.prototype, "alignLtMd", {
        set: function (val) { this._cacheInput('alignLtMd', val); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(LayoutAlignDirective.prototype, "alignLtLg", {
        set: function (val) { this._cacheInput('alignLtLg', val); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(LayoutAlignDirective.prototype, "alignLtXl", {
        set: function (val) { this._cacheInput('alignLtXl', val); },
        enumerable: true,
        configurable: true
    });
    ;
    // *********************************************
    // Lifecycle Methods
    // *********************************************
    LayoutAlignDirective.prototype.ngOnChanges = function (changes) {
        if (changes['align'] != null || this._mqActivation) {
            this._updateWithValue();
        }
    };
    /**
     * After the initial onChanges, build an mqActivation object that bridges
     * mql change events to onMediaQueryChange handlers
     */
    LayoutAlignDirective.prototype.ngOnInit = function () {
        var _this = this;
        this._listenForMediaQueryChanges('align', 'start stretch', function (changes) {
            _this._updateWithValue(changes.value);
        });
        this._updateWithValue();
    };
    LayoutAlignDirective.prototype.ngOnDestroy = function () {
        _super.prototype.ngOnDestroy.call(this);
        if (this._layoutWatcher) {
            this._layoutWatcher.unsubscribe();
        }
    };
    // *********************************************
    // Protected methods
    // *********************************************
    /**
     *
     */
    LayoutAlignDirective.prototype._updateWithValue = function (value) {
        value = value || this._queryInput("align") || 'start stretch';
        if (this._mqActivation) {
            value = this._mqActivation.activatedInput;
        }
        this._applyStyleToElement(this._buildCSS(value));
        this._allowStretching(value, !this._layout ? "row" : this._layout);
    };
    /**
     * Cache the parent container 'flex-direction' and update the 'flex' styles
     */
    LayoutAlignDirective.prototype._onLayoutChange = function (direction) {
        var _this = this;
        this._layout = (direction || '').toLowerCase();
        if (!__WEBPACK_IMPORTED_MODULE_5__utils_layout_validator__["b" /* LAYOUT_VALUES */].find(function (x) { return x === _this._layout; })) {
            this._layout = 'row';
        }
        var value = this._queryInput("align") || 'start stretch';
        if (this._mqActivation) {
            value = this._mqActivation.activatedInput;
        }
        this._allowStretching(value, this._layout || "row");
    };
    LayoutAlignDirective.prototype._buildCSS = function (align) {
        var css = {}, _a = align.split(' '), main_axis = _a[0], cross_axis = _a[1]; // tslint:disable-line:variable-name
        // Main axis
        switch (main_axis) {
            case 'center':
                css['justify-content'] = 'center';
                break;
            case 'space-around':
                css['justify-content'] = 'space-around';
                break;
            case 'space-between':
                css['justify-content'] = 'space-between';
                break;
            case 'end':
            case 'flex-end':
                css['justify-content'] = 'flex-end';
                break;
            case 'start':
            case 'flex-start':
            default:
                css['justify-content'] = 'flex-start'; // default main axis
                break;
        }
        // Cross-axis
        switch (cross_axis) {
            case 'start':
            case 'flex-start':
                css['align-items'] = css['align-content'] = 'flex-start';
                break;
            case 'baseline':
                css['align-items'] = 'baseline';
                break;
            case 'center':
                css['align-items'] = css['align-content'] = 'center';
                break;
            case 'end':
            case 'flex-end':
                css['align-items'] = css['align-content'] = 'flex-end';
                break;
            case 'stretch':
            default:
                css['align-items'] = css['align-content'] = 'stretch'; // default cross axis
                break;
        }
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_object_extend__["a" /* extendObject */])(css, {
            'display': 'flex',
            'flex-direction': this._layout || "row",
            'box-sizing': 'border-box'
        });
    };
    /**
     * Update container element to 'stretch' as needed...
     * NOTE: this is only done if the crossAxis is explicitly set to 'stretch'
     */
    LayoutAlignDirective.prototype._allowStretching = function (align, layout) {
        var _a = align.split(' '), cross_axis = _a[1]; // tslint:disable-line:variable-name
        if (cross_axis == 'stretch') {
            // Use `null` values to remove style
            this._applyStyleToElement({
                'box-sizing': 'border-box',
                'max-width': (layout === 'column') ? '100%' : null,
                'max-height': (layout === 'row') ? '100%' : null
            });
        }
    };
    return LayoutAlignDirective;
}(__WEBPACK_IMPORTED_MODULE_2__base__["a" /* BaseFxDirective */]));

LayoutAlignDirective.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{ selector: "\n  [fxLayoutAlign],\n  [fxLayoutAlign.xs], [fxLayoutAlign.sm], [fxLayoutAlign.md], [fxLayoutAlign.lg],[fxLayoutAlign.xl],\n  [fxLayoutAlign.lt-sm], [fxLayoutAlign.lt-md], [fxLayoutAlign.lt-lg], [fxLayoutAlign.lt-xl],\n  [fxLayoutAlign.gt-xs], [fxLayoutAlign.gt-sm], [fxLayoutAlign.gt-md], [fxLayoutAlign.gt-lg]\n" },] },
];
/** @nocollapse */
LayoutAlignDirective.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_3__media_query_media_monitor__["a" /* MediaMonitor */], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer2"], },
    { type: __WEBPACK_IMPORTED_MODULE_4__layout__["a" /* LayoutDirective */], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] },] },
]; };
LayoutAlignDirective.propDecorators = {
    'align': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxLayoutAlign',] },],
    'alignXs': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxLayoutAlign.xs',] },],
    'alignSm': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxLayoutAlign.sm',] },],
    'alignMd': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxLayoutAlign.md',] },],
    'alignLg': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxLayoutAlign.lg',] },],
    'alignXl': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxLayoutAlign.xl',] },],
    'alignGtXs': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxLayoutAlign.gt-xs',] },],
    'alignGtSm': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxLayoutAlign.gt-sm',] },],
    'alignGtMd': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxLayoutAlign.gt-md',] },],
    'alignGtLg': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxLayoutAlign.gt-lg',] },],
    'alignLtSm': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxLayoutAlign.lt-sm',] },],
    'alignLtMd': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxLayoutAlign.lt-md',] },],
    'alignLtLg': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxLayoutAlign.lt-lg',] },],
    'alignLtXl': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxLayoutAlign.lt-xl',] },],
};
//# sourceMappingURL=layout-align.js.map

/***/ }),

/***/ "aJ5y":
/***/ (function(module, exports) {

exports.model=Model={Game:{},Board:{},Move:{}},function(){var t;Model.Game.cbConstants={MASK:65535,FLAG_MOVE:65536,FLAG_CAPTURE:131072,FLAG_STOP:262144,FLAG_SCREEN_CAPTURE:524288,FLAG_CAPTURE_KING:1048576,FLAG_CAPTURE_NO_KING:2097152};var e="undefined"!=typeof Int32Array;Model.Game.cbUseTypedArrays=e,Model.Game.cbTypedArray=function(t){if(e){var r=new Int32Array(t.length);return r.set(t),r}for(var i=[],a=t.length,n=0;n<a;n++)i.push(t[n]);return i},Model.Game.cbShortRangeGraph=function(t,e,r,i){var a=this;void 0===i&&(i=196608);for(var n={},s=0;s<t.boardSize;s++)n[s]=[],(!r||s in r)&&e.forEach(function(e){var o=t.Graph(s,e);null!=o&&(!r||o in r)&&n[s].push(a.cbTypedArray([o|i]))});return n},Model.Game.cbLongRangeGraph=function(t,e,r,i,a){var n=this;void 0!==i&&null!=i||(i=196608),a||(a=1/0);for(var s={},o=0;o<t.boardSize;o++)s[o]=[],(!r||o in r)&&e.forEach(function(e){for(var h=[],c=t.Graph(o,e),p=0;null!=c&&(!r||c in r)&&(h.push(c|i),++p!=a);)c=t.Graph(c,e);h.length>0&&s[o].push(n.cbTypedArray(h))});return s},Model.Game.cbNullGraph=function(t){for(var e={},r=0;r<t.boardSize;r++)e[r]=[];return e},Model.Game.cbAuthorGraph=function(t){for(var e={},r=0;r<t.boardSize;r++){e[r]=[];for(var i=0;i<t.boardSize;i++)e[r].push([2293760|i])}return e},Model.Game.cbMergeGraphs=function(t){for(var e=[],r=0;r<t.boardSize;r++){e[r]=[];for(var i=1;i<arguments.length;i++)e[r]=e[r].concat(arguments[i][r])}return e},Model.Game.cbGetThreatGraph=function(){function t(e,r){for(var i in s){var a=s[i];if(!(a.p.length<r.length+1)){for(var n=!0,o=0;o<r.length;o++)if(r[o]!=a.p[o]){n=!1;break}if(n){var h=a.p[r.length],c=e[h];void 0===c&&(c={e:{}},e[h]=c),a.p.length==r.length+1&&(c.t=a.t,c.ts=a.ts,c.tk=a.tk,delete s[i]),r.push(h),t(c.e,r),r.pop()}}}}var e=this;this.cbUseScreenCapture=!1,this.cbUseCaptureKing=!1,this.cbUseCaptureNoKing=!1;for(var r={1:[],"-1":[]},i=[],a=0;a<this.g.boardSize;a++)this.g.pTypes.forEach(function(t,r){t.graph[a].forEach(function(t){for(var n=[],s=0;s<t.length;s++){var o=t[s];1048576&o?(e.cbUseCaptureKing=!0,n.unshift({d:65535&o,a:a,tk:r})):2097152&o?(e.cbUseCaptureNoKing=!0,n.unshift({d:65535&o,a:a,tnk:r})):131072&o?n.unshift({d:65535&o,a:a,t:r}):262144&o?n.unshift({d:65535&o,a:a}):524288&o&&(e.cbUseScreenCapture=!0,n.unshift({d:65535&o,a:a,ts:r}))}n.length>0&&i.push(n)})});var n={};i.forEach(function(t){t.forEach(function(e,r){var i=n[e.d];void 0===i&&(i={},n[e.d]=i);for(var a=[],s=r+1;s<t.length;s++)a.push(t[s].d);a.push(e.a);var o=a.join(","),h=i[o];void 0===h&&(h={p:a,t:{},ts:{},tk:{}},i[o]=h),void 0!==e.t?h.t[e.t]=!0:void 0!==e.tk?h.tk[e.tk]=!0:void 0!==e.ts&&(h.ts[e.ts]=!0)})});for(var a=0;a<e.g.boardSize;a++){var s=n[a],o={};t(o,[]),r[1][a]=o,r[-1][a]=o}return r},Model.Game.InitGame=function(){var e=this;this.cbVar=t=this.cbDefine(),this.g.boardSize=this.cbVar.geometry.boardSize,this.g.pTypes=this.cbGetPieceTypes(),this.g.threatGraph=this.cbGetThreatGraph(),this.g.distGraph=this.cbVar.geometry.GetDistances(),this.cbPiecesCount=0,this.g.castleablePiecesCount={1:0,"-1":0};for(var r in t.pieceTypes){var i=t.pieceTypes[r];if(i.castle){(i.initial||[]).forEach(function(t){e.g.castleablePiecesCount[t.s]++})}i.initial&&(this.cbPiecesCount+=i.initial.length)}for(var a=[],r=0;r<this.cbPiecesCount;r++)a.push(r);var n=Object.keys(t.pieceTypes);this.zobrist=new JocGame.Zobrist({board:{type:"array",size:this.cbVar.geometry.boardSize,values:a},who:{values:["1","-1"]},type:{type:"array",size:this.cbPiecesCount,values:n}})},Model.Game.cbGetPieceTypes=function(){for(var t=[],e={},r=0;r<this.cbVar.geometry.boardSize;r++)e[r]=[];for(var i in this.cbVar.pieceTypes){var a=this.cbVar.pieceTypes[i];t[i]={graph:a.graph||e,abbrev:a.abbrev||"",value:a.isKing?100:a.value||1,isKing:!!a.isKing,castle:!!a.castle,epTarget:!!a.epTarget,epCatch:!!a.epCatch}}return t},Model.Board.Init=function(t){this.zSign=0},Model.Board.InitialPosition=function(r){var i=this;this.board=e?new Int16Array(r.g.boardSize):[];for(var a=0;a<r.g.boardSize;a++)this.board[a]=-1;if(this.kings={},this.pieces=[],this.ending={1:!1,"-1":!1},this.lastMove=null,r.cbVar.castle&&(this.castled={1:!1,"-1":!1}),this.zSign=r.zobrist.update(0,"who",-1),this.noCaptCount=0,this.mWho=1,r.mInitial)this.mWho=r.mInitial.turn||1,r.mInitial.pieces.forEach(function(t){var e={};for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);i.pieces.push(e)}),r.mInitial.lastMove&&(this.lastMove={f:r.mInitial.lastMove.f,t:r.mInitial.lastMove.t}),void 0!==r.mInitial.noCaptCount&&(this.noCaptCount=r.mInitial.noCaptCount),r.cbVar.castle&&r.mInitial.castle&&(this.castled={1:{k:!!r.mInitial.castle[1]&&!!r.mInitial.castle[1].k,q:!!r.mInitial.castle[1]&&!!r.mInitial.castle[1].q},"-1":{k:!!r.mInitial.castle[-1]&&!!r.mInitial.castle[-1].k,q:!!r.mInitial.castle[-1]&&!!r.mInitial.castle[-1].q}});else for(var n in r.cbVar.pieceTypes)for(var s=r.cbVar.pieceTypes[n],o=s.initial||[],h=0;h<o.length;h++){var c=o[h],p={s:c.s,t:parseInt(n),p:c.p,m:!1};this.pieces.push(p)}if(this.pieces.sort(function(t,e){if(t.s!=e.s)return e.s-t.s;var i=r.cbVar.pieceTypes[t.t].value||100,a=r.cbVar.pieceTypes[e.t].value||100;return i!=a?i-a:t.p-e.p}),this.pieces.forEach(function(t,e){t.i=e,i.board[t.p]=e,r.g.pTypes[t.t].isKing&&(i.kings[t.s]=t.p),i.zSign=r.zobrist.update(i.zSign,"board",e,t.p),i.zSign=r.zobrist.update(i.zSign,"type",t.t,e)}),r.mInitial&&r.mInitial.enPassant){var a=t.geometry.PosByName(r.mInitial.enPassant);if(a>=0){var l,u=t.geometry.C(a),v=t.geometry.R(a);l=1==r.mInitial.turn?t.geometry.POS(u,v-1):t.geometry.POS(u,v+1),this.epTarget={p:a,i:this.board[l]}}}},Model.Board.CopyFrom=function(t){if(e)this.board=new Int16Array(t.board.length),this.board.set(t.board);else{this.board=[];for(var r=t.board,i=r.length,a=0;a<i;a++)this.board.push(r[a])}this.pieces=[];for(var n=t.pieces.length,a=0;a<n;a++){var s=t.pieces[a];this.pieces.push({s:s.s,p:s.p,t:s.t,i:s.i,m:s.m})}this.kings={1:t.kings[1],"-1":t.kings[-1]},this.check=t.check,t.lastMove?this.lastMove={f:t.lastMove.f,t:t.lastMove.t,c:t.lastMove.c}:this.lastMove=null,this.ending={1:t.ending[1],"-1":t.ending[-1]},void 0!==t.castled&&(this.castled={1:t.castled[1],"-1":t.castled[-1]}),this.noCaptCount=t.noCaptCount,t.epTarget?this.epTarget={p:t.epTarget.p,i:t.epTarget.i}:this.epTarget=null,this.mWho=t.mWho,this.zSign=t.zSign},Model.Board.cbApplyCastle=function(t,e,r){var i=t.cbVar.castle[e.f+"/"+e.cg],a=i.r[i.r.length-1],n=this.pieces[this.board[e.cg]],s=i.k[i.k.length-1],o=this.pieces[this.board[e.f]];return r&&(this.zSign=t.zobrist.update(this.zSign,"board",n.i,e.cg),this.zSign=t.zobrist.update(this.zSign,"board",n.i,a),this.zSign=t.zobrist.update(this.zSign,"board",o.i,e.f),this.zSign=t.zobrist.update(this.zSign,"board",o.i,s)),n.p=a,n.m=!0,this.board[e.cg]=-1,o.p=s,o.m=!0,this.board[e.f]=-1,this.board[a]=n.i,this.board[s]=o.i,this.castled[n.s]=!0,this.kings[o.s]=s,[{i:n.i,f:a,t:-1},{i:o.i,f:s,t:e.f,kp:e.f,who:o.s,m:!1},{i:n.i,f:-1,t:e.cg,m:!1,cg:!1}]},Model.Board.cbQuickApply=function(t,e){if(void 0!==e.cg)return this.cbApplyCastle(t,e,!1);var r=[],i=this.board[e.f],a=this.pieces[i];if(null!=e.c){r.unshift({i:e.c,f:-1,t:this.pieces[e.c].p});var n=this.pieces[e.c];this.board[n.p]=-1,n.p=-1}var s=this.kings[a.s];return t.g.pTypes[a.t].isKing&&(this.kings[a.s]=e.t),r.unshift({i:i,f:e.t,t:e.f,kp:s,who:a.s,ty:a.t}),a.p=e.t,void 0!==e.pr&&(a.t=e.pr),this.board[e.f]=-1,this.board[e.t]=i,r},Model.Board.cbQuickUnapply=function(t,e){for(var r=0;r<e.length;r++){var i=e[r],a=this.pieces[i.i];i.f>=0&&(a.p=-1,this.board[i.f]=-1),i.t>=0&&(a.p=i.t,this.board[i.t]=i.i),void 0!==i.m&&(a.m=i.m),void 0!==i.kp&&(this.kings[i.who]=i.kp),void 0!=i.ty&&(a.t=i.ty),void 0!=i.cg&&(this.castled[a.s]=i.cg)}},Model.Board.ApplyMove=function(t,e){var r=this.pieces[this.board[e.f]];if(void 0!==e.cg)this.cbApplyCastle(t,e,!0);else{if(this.zSign=t.zobrist.update(this.zSign,"board",r.i,e.f),this.board[r.p]=-1,void 0!==e.pr&&(this.zSign=t.zobrist.update(this.zSign,"type",r.t,r.i),r.t=e.pr,this.zSign=t.zobrist.update(this.zSign,"type",r.t,r.i)),null!=e.c){var i=this.pieces[e.c];this.zSign=t.zobrist.update(this.zSign,"board",i.i,i.p),this.board[i.p]=-1,i.p=-1,i.m=!0,this.noCaptCount=0}else this.noCaptCount++;r.p=e.t,r.m=!0,this.board[e.t]=r.i,this.zSign=t.zobrist.update(this.zSign,"board",r.i,e.t),t.g.pTypes[r.t].isKing&&(this.kings[r.s]=e.t)}this.check=!!e.ck,this.lastMove={f:e.f,t:e.t,c:e.c},void 0!==e.ko&&(this.ending[r.s]=e.ko),void 0!==e.ept?this.epTarget={p:e.ept,i:r.i}:this.epTarget=null,this.zSign=t.zobrist.update(this.zSign,"who",-this.mWho),this.zSign=t.zobrist.update(this.zSign,"who",this.mWho)},Model.Board.Evaluate=function(r){function i(e){var r=1/0;for(var i in t.geometry.corners)r=Math.min(r,h.distGraph[n.kings[e]][i]);return r-Math.sqrt(h.boardSize)}var a="debug"==arguments[3],n=this;this.mEvaluation=0;var s,o=this.mWho,h=r.g;if(e)s={1:{count:new Uint8Array(h.pTypes.length),byType:{}},"-1":{count:new Uint8Array(h.pTypes.length),byType:{}}};else{s={1:{count:[],byType:{}},"-1":{count:[],byType:{}}};for(var c=0;c<h.pTypes.length;c++)s[1].count[c]=s[-1].count[c]=0}if(r.mOptions.preventRepeat&&r.GetRepeatOccurence(this)>2)return this.mFinished=!0,void(this.mWinner=r.cbOnPerpetual?o*r.cbOnPerpetual:JocGame.DRAW);for(var p={1:0,"-1":0},l={1:h.distGraph[this.kings[-1]],"-1":h.distGraph[this.kings[1]]},u={1:0,"-1":0},v={1:0,"-1":0},b={1:0,"-1":0},f={1:0,"-1":0},d={1:!1,"-1":!1},g=this.pieces,m=g.length,c=0;c<m;c++){var G=g[c];if(G.p>=0){var y=G.s,M=h.pTypes[G.t];M.isKing?d[y]=G.m:p[y]+=M.value,M.castle&&!G.m&&f[y]++,v[y]++,u[y]+=l[y][G.p],b[y]+=t.geometry.distEdge[G.p];var C=s[y];C.count[G.t]++;var S=C.byType;void 0===S[G.t]?S[G.t]=[G]:S[G.t].push(G)}}if(this.lastMove&&null!=this.lastMove.c){var G=this.pieces[this.board[this.lastMove.t]];p[-G.s]+=this.cbStaticExchangeEval(r,G.p,G.s,{piece:G})}var k={1:0,"-1":0},A={1:0,"-1":0},T={1:0,"-1":0};this.ending[1]&&(A[1]=(u[1]-Math.sqrt(h.boardSize))/v[1],t.geometry.corners&&(T[1]=i(1))),this.ending[-1]&&(A[-1]=(u[-1]-Math.sqrt(h.boardSize))/v[-1],t.geometry.corners&&(T[1]=i(-1)));var z={pieceValue:p[1]-p[-1],pieceValueRatio:(p[1]-p[-1])/(p[1]+p[-1]+1),posValue:b[1]-b[-1],averageDistKing:u[1]/v[1]-u[-1]/v[-1],check:this.check?-o:0,endingKingFreedom:k[1]-k[-1],endingDistKing:A[1]-A[-1],distKingCorner:T[1]-T[-1]};t.castle&&(z.castle=(this.castled[1]?1:d[1]?0:f[1]/(h.castleablePiecesCount[1]+1))-(this.castled[-1]?1:d[-1]?0:f[-1]/(h.castleablePiecesCount[-1]+1))),t.evaluate&&t.evaluate.call(this,r,z,s);var P=r.mOptions.levelOptions;for(var E in z){var w=z[E],R=P[E+"Factor"]||0,I=w*R;a&&console.log(E,"=",w,"*",R,"=>",I),this.mEvaluation+=I}a&&console.log("Evaluation",this.mEvaluation)},Model.Board.cbGeneratePseudoLegalMoves=function(t){function e(e,a){var n=t.cbVar.promote;if(!n)return void i.push(a);var s=n.call(r,t,e,a);if(null!=s)if(0==s.length)i.push(a);else if(1==s.length)a.pr=s[0],i.push(a);else for(var o=0;o<s.length;o++){var h=s[o];i.push({f:a.f,t:a.t,c:a.c,pr:h,ept:a.ept,ep:a.ep,a:a.a})}}for(var r=this,i=[],a=t.cbVar,n=this.mWho,s=!a.castle||this.check||this.castled[n]?null:[],o=-1,h=this.pieces.length,c=0;c<h;c++){var p=this.pieces[c];if(!(p.p<0||p.s!=n)){var l=t.g.pTypes[p.t];l.isKing&&(p.m?s=null:o=p),s&&l.castle&&!p.m&&s.push(p);var u,v;u=l.graph[p.p],v=u.length;for(var b=0;b<v;b++)for(var f=u[b],d=!1,g=f.length,m=null,G=0;G<g;G++){var y=f[G],M=65535&y,C=this.board[M];if(!(C<0)||l.epCatch&&this.epTarget&&this.epTarget.p==M){if(!(524288&y)){var S;S=C<0?this.pieces[this.epTarget.i]:this.pieces[C],!(S.s!=p.s&&131072&y)||1048576&y&&!t.g.pTypes[S.t].isKing||2097152&y&&t.g.pTypes[S.t].isKing||e(p,{f:p.p,t:M,c:S.i,a:l.abbrev,ep:C<0});break}if(d){var S=this.pieces[C];S.s!=p.s&&e(p,{f:p.p,t:M,c:S.i,a:l.abbrev});break}d=!0}else 65536&y&&0==d&&e(p,{f:p.p,t:M,c:null,a:l.abbrev,ept:null!=m&&l.epTarget?m:void 0});m=M}}}if(s)for(var c=0;c<s.length;c++){var k=s[c],A=t.cbVar.castle[o.p+"/"+k.p];if(A){for(var T=!0,b=0;b<A.r.length;b++){var z=A.r[b];if(this.board[z]>=0&&z!=o.p&&z!=k.p){T=!1;break}}if(T){for(var P=!0,b=0;b<A.k.length;b++){var z=A.k[b];if(this.board[z]>=0&&z!=k.p&&z!=o.p||this.cbGetAttackers(t,z,n).length>0){P=!1;break}}P&&i.push({f:o.p,t:A.k[A.k.length-1],c:null,cg:k.p})}}}return i},Model.Board.cbStaticExchangeEval=function(t,e,r,i){var a=0,n=this.cbGetSmallestAttacker(t,e,r);if(n){var s=this.mWho;this.mWho=n.s;var o=this.cbQuickApply(t,{f:n.p,t:e,c:i.piece.i}),h=t.g.pTypes[i.piece.t].value;i.piece=n,a=Math.max(0,h-this.cbStaticExchangeEval(t,e,-r,i)),this.cbQuickUnapply(t,o),this.mWho=s}return a},Model.Board.cbGetSmallestAttacker=function(t,e,r){var i=this.cbGetAttackers(t,e,r);if(0==i.length)return null;for(var a=1/0,n=null,s=i.length,o=0;o<s;o++){var h=i[o],c=t.g.pTypes[h.t].value;c<a&&(a=c,n=h)}return n},Model.Board.cbCollectAttackers=function(t,e,r,i){for(var a in e){var n=e[a],s=this.board[a];if(s<0)this.cbCollectAttackers(t,n.e,r,i);else{var o=this.pieces[s];o.s==-t&&(n.t&&o.t in n.t||i&&n.tk&&o.t in n.tk)&&r.push(o)}}},Model.Board.cbCollectAttackersScreen=function(t,e,r,i,a){for(var n in e){var s=e[n],o=this.board[n];if(o<0)this.cbCollectAttackersScreen(t,s.e,r,i,a);else{var h=this.pieces[o];!a&&h.s==-t&&(s.t&&h.t in s.t||i&&s.tk&&h.t in s.tk)?r.push(h):a?a&&h.s==-t&&s.ts&&h.t in s.ts&&r.push(h):this.cbCollectAttackersScreen(t,s.e,r,i,!0)}}},Model.Board.cbGetAttackers=function(t,e,r,i){var a=[];return t.cbUseScreenCapture?this.cbCollectAttackersScreen(r,t.g.threatGraph[r][e],a,i,!1):this.cbCollectAttackers(r,t.g.threatGraph[r][e],a,i),a},Model.Board.GenerateMoves=function(t){var e=this.cbGeneratePseudoLegalMoves(t);this.mMoves=[];for(var r=!0,i=this.kings[this.mWho],a=e.length,n=0;n<a;n++){var s=e[n],o=this.cbQuickApply(t,s);if(!(this.cbGetAttackers(t,this.kings[this.mWho],this.mWho,!0).length>0)){var h=this.cbGetAttackers(t,this.kings[-this.mWho],-this.mWho,!0).length>0;s.ck=h,this.mMoves.push(s),s.f!=i&&(r=!1)}this.cbQuickUnapply(t,o)}if(0==this.mMoves.length)this.mFinished=!0,this.mWinner=t.cbOnStaleMate?t.cbOnStaleMate*this.mWho:JocGame.DRAW,this.check&&(this.mWinner=-this.mWho);else if(this.ending[this.mWho]){if(!r)for(var n=0;n<this.mMoves.length;n++)this.mMoves[n].ko=!1}else if(!this.ending[this.mWho]&&r&&!this.check)for(var n=0;n<this.mMoves.length;n++)this.mMoves[n].ko=!0},Model.Board.GetSignature=function(){return this.zSign},Model.Move.Init=function(t){for(var e in t)t.hasOwnProperty(e)&&(this[e]=t[e])},Model.Move.Equals=function(t){return this.f==t.f&&this.t==t.t&&this.pr==t.pr},Model.Move.CopyFrom=function(t){this.Init(t)},Model.Move.ToString=function(e){var r=this;switch(e=e||"natural"){case"natural":return function(){var e;if(void 0!==r.cg?e=t.castle[r.f+"/"+r.cg].n:(e=r.a||"",e+=t.geometry.PosName(r.f),null==r.c?e+="-":e+="x",e+=t.geometry.PosName(r.t)),void 0!==r.pr){var i=t.pieceTypes[r.pr];i&&i.abbrev&&i.abbrev.length>0&&!i.silentPromo&&(e+="="+i.abbrev)}return r.ck&&(e+="+"),e}();case"engine":return function(){var e=t.geometry.PosName(r.f)+t.geometry.PosName(r.t);if(void 0!=r.pr){var i=t.pieceTypes[r.pr];i&&i.abbrev&&i.abbrev.length>0&&!i.silentPromo&&(e+=i.abbrev)}return e}();default:return"??"}},Model.Board.CompactMoveString=function(e,r,i){"function"!=typeof r.ToString&&(r=e.CreateMove(r));var a=r.ToString(),n=/^([A-Z]?)([a-z])([1-9][0-9]*)([-x])([a-z])([1-9][0-9]*)(.*?)$/.exec(a);if(!n)return a;var s=n[7];if(i||(i={}),i.value||(i.value=[]),0==i.value.length){var o=this.mMoves;this.mMoves&&0!=this.mMoves.length||this.GenerateMoves(e);for(var h=0;h<this.mMoves.length;h++){var c=this.mMoves[h];"function"!=typeof c.ToString&&(c=e.CreateMove(c)),i.value.push({str:c.ToString(),move:c})}this.mMoves=o}var p=[];if(i.value.forEach(function(t){var e=/^([A-Z]?[a-z][1-9][0-9]*[-x][a-z][1-9][0-9]*)(.*?)$/.exec(t.str);e&&t.move.t==r.t&&(t.move.a||"")==n[1]&&e[2]==s&&p.push(t.move)}),1==p.length)return""==n[1]&&"x"==n[4]?n[2]+"x"+n[5]+n[6]+n[7]:n[1]+("x"==n[4]?"x":"")+n[5]+n[6]+n[7];if(t.geometry.CompactCrit)for(var l="",h=0;;h++){var u=t.geometry.CompactCrit(r.f,h);if(null==u)return a;l+=u;for(var v=[],b=0;b<p.length;b++){var f=p[b];t.geometry.CompactCrit(f.f,h)==u&&v.push(f)}if(console.assert(v.length>0),1==v.length)return n[1]+l+("x"==n[4]?"x":"")+n[5]+n[6]+n[7];p=v}return a},Model.Board.cbIntegrity=function(t){function e(t,e){t||console.error(e)}for(var r=this,i=0;i<this.board.length;i++){var a=this.board[i];if(a>=0){var n=r.pieces[a];e(void 0!==n,"no piece at pos"),e(n.p==i,"piece has different pos")}}for(var a=0;a<this.pieces.length;a++){var n=this.pieces[a];n.p>=0&&e(r.board[n.p]==a,"board index mismatch")}},Model.Board.ExportBoardState=function(t){return t.cbVar.geometry.ExportBoardState?t.cbVar.geometry.ExportBoardState(this,t.cbVar,t.mPlayedMoves.length):"not supported"},Model.Game.Import=function(e,r){var i,a=[],n={1:{},"-1":{}},s=null,o=0;if("pjn"==e){var h={status:!1,error:"parse"},c=r.split(" ");if(6!=c.length)return console.warn("FEN should have 6 parts"),h;var p=c[0].split("/"),l=t.geometry.fenHeight||t.geometry.height;if(p.length!=l)return console.warn("FEN board should have",l,"rows, got",p.length),h;var u={};for(var v in t.pieceTypes){var b=t.pieceTypes[v],f=b.fenAbbrev||b.abbrev||"X";u[f.toUpperCase()]={s:1,t:v},u[f.toLowerCase()]={s:-1,t:v}}var d=t.geometry.FenRowPos||function(e,r){return(t.geometry.height-1-e)*t.geometry.width+r};if(p.forEach(function(e,r){for(var i=0,n=0;n<e.length;n++){var s=e.substr(n,1),o=u[s];if(void 0!==o){var c=d(r,i);i++;for(var p={s:o.s,t:o.t,p:c},l=!0,v=t.pieceTypes[p.t].initial||[],b=0;b<v.length;b++){var f=v[b];f.s==p.s&&f.p==c&&(l=!1)}p.m=l,a.push(p)}else{if(isNaN(parseInt(s)))return console.warn("FEN invalid board spec",s),h;i+=parseInt(s)}}}),a.sort(function(t,e){return e.s-t.s}),"w"==c[1])i=1;else{if("b"!=c[1])return console.warn("FEN invalid turn spec",c[1]),h;i=-1}n[1].k=c[2].indexOf("K")>=0,n[1].q=c[2].indexOf("Q")>=0,n[-1].k=c[2].indexOf("k")>=0,n[-1].q=c[2].indexOf("q")>=0,s="-"==c[3]?null:c[3];var g=parseInt(c[4]);isNaN(g)||(o=g);var m={pieces:a,turn:i,castle:n,enPassant:s,noCaptCount:o};return t.importGame&&t.importGame.call(this,m,e,r),{status:!0,initial:m}}return{status:!1,error:"unsupported"}}}(),function(){Model.Game.cbBoardGeometryGrid=function(t,e){function r(e){return e%t}function i(e){return Math.floor(e/t)}function a(e,r){return r*t+e}function n(n,s){var o=r(n),h=i(n),c=o+s[0],p=h+s[1];return c<0||c>=t||p<0||p>=e?null:a(c,p)}function s(t){return String.fromCharCode("a".charCodeAt(0)+r(t))+(i(t)+1)}function o(t){var e=/^([a-z])([0-9]+)$/.exec(t);return e?a(e[1].charCodeAt(0)-"a".charCodeAt(0),parseInt(e[2])-1):-1}function h(t,e){return 0==e?String.fromCharCode("a".charCodeAt(0)+r(t)):1==e?i(t)+1:null}function c(){for(var a=[],n=0;n<t*e;n++){var s=[];a.push(s);for(var o=0;o<t*e;o++){var h=i(n),c=r(n),p=i(o),l=r(o);s.push(Math.max(Math.abs(h-p),Math.abs(c-l)))}}return a}function p(r,i,n){for(var o=[],h=e-1;h>=0;h--){for(var c="",p=0,l=0;l<t;l++){var u=r.board[a(l,h)];if(u<0)p++;else{p>0&&(c+=p,p=0);var v=r.pieces[u],b=i.pieceTypes[v.t].fenAbbrev||i.pieceTypes[v.t].abbrev||"?";v.s==-1?c+=b.toLowerCase():c+=b.toUpperCase()}}p&&(c+=p),o.push(c)}var f=o.join("/");f+=" ",1==r.mWho?f+="w":f+="b",f+=" ";var d="";return r.castled&&(r.castled[1]===!1?d+="KQ":(r.castled[1].k&&(d+="K"),r.castled[1].q&&(d+="Q")),r.castled[-1]===!1?d+="kq":(r.castled[-1].k&&(d+="k"),r.castled[-1].q&&(d+="q"))),0==d.length&&(d="-"),f+=d,f+=" ",r.epTarget?f+=s(r.epTarget.p):f+="-",f+=" ",f+=r.noCaptCount,f+=" ",f+=Math.floor(n/2)+1}return{boardSize:t*e,width:t,height:e,C:r,R:i,POS:a,Graph:n,PosName:s,PosByName:o,CompactCrit:h,GetDistances:c,distEdge:function(){for(var a=[],n=0;n<t*e;n++){var s=r(n),o=i(n);a[n]=Math.min(s,Math.abs(t-s-1),o,Math.abs(e-o-1))}return a}(),corners:function(){var r={};return r[a(0,0)]=1,r[a(0,e-1)]=1,r[a(t-1,0)]=1,r[a(t-1,e-1)]=1,r}(),ExportBoardState:p}},Model.Game.cbPawnGraph=function(t,e,r){for(var i=this,a={},n=0;n<t.boardSize;n++)if(!r||n in r){var s=[],o=t.Graph(n,[0,e]);null!=o&&(!r||o in r)&&s.push(i.cbTypedArray([o|i.cbConstants.FLAG_MOVE])),[-1,1].forEach(function(a){var o=t.Graph(n,[a,e]);null!=o&&(!r||o in r)&&s.push(i.cbTypedArray([o|i.cbConstants.FLAG_CAPTURE]))}),a[n]=s}else a[n]=[];return a},Model.Game.cbInitialPawnGraph=function(t,e,r){for(var i=this,a={},n=0;n<t.boardSize;n++)if(!r||n in r){var s=[],o=t.Graph(n,[0,e]);if(null!=o&&(!r||o in r)){var h=[o|i.cbConstants.FLAG_MOVE],c=t.Graph(o,[0,e]);null!=c&&(!r||c in r)&&h.push(c|i.cbConstants.FLAG_MOVE),s.push(i.cbTypedArray(h))}[-1,1].forEach(function(a){var o=t.Graph(n,[a,e]);null!=o&&(!r||o in r)&&s.push(i.cbTypedArray([o|i.cbConstants.FLAG_CAPTURE]))}),a[n]=s}else a[n]=[];return a},Model.Game.cbKingGraph=function(t,e){return this.cbShortRangeGraph(t,[[-1,-1],[-1,0],[-1,1],[0,-1],[0,1],[1,-1],[1,0],[1,1]],e)},Model.Game.cbKnightGraph=function(t,e){return this.cbShortRangeGraph(t,[[2,-1],[2,1],[-2,-1],[-2,1],[-1,2],[-1,-2],[1,2],[1,-2]],e)},Model.Game.cbHorseGraph=function(t){for(var e=this,r={},i=0;i<t.boardSize;i++)r[i]=[],[[1,0,2,-1],[1,0,2,1],[-1,0,-2,-1],[-1,0,-2,1],[0,1,-1,2],[0,-1,-1,-2],[0,1,1,2],[0,-1,1,-2]].forEach(function(a){var n=t.Graph(i,[a[0],a[1]]);if(null!=n){var s=t.Graph(i,[a[2],a[3]]);null!=s&&r[i].push(e.cbTypedArray([n|e.cbConstants.FLAG_STOP,s|e.cbConstants.FLAG_MOVE|e.cbConstants.FLAG_CAPTURE]))}});return r},Model.Game.cbRookGraph=function(t,e){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0]],e)},Model.Game.cbBishopGraph=function(t,e){return this.cbLongRangeGraph(t,[[1,-1],[1,1],[-1,1],[-1,-1]],e)},Model.Game.cbQueenGraph=function(t,e){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0],[1,-1],[1,1],[-1,1],[-1,-1]],e)},Model.Game.cbXQGeneralGraph=function(t,e){for(var r=this,i={},a=0;a<t.boardSize;a++)i[a]=[],[[-1,0,!1],[0,-1,!0],[0,1,!0],[1,0,!1]].forEach(function(n){var s=[],o=t.Graph(a,n);if(null!=o&&((!e||o in e)&&s.push(o|r.cbConstants.FLAG_MOVE|r.cbConstants.FLAG_CAPTURE),n[2]))for(var h=t.Graph(o,n);null!=h;)!e||h in e?s.push(h|r.cbConstants.FLAG_CAPTURE|r.cbConstants.FLAG_CAPTURE_KING):s.push(h|r.cbConstants.FLAG_STOP),h=t.Graph(h,n);s.length>0&&i[a].push(r.cbTypedArray(s))});return i},Model.Game.cbXQSoldierGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e]])},Model.Game.cbXQPromoSoldierGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e],[-1,0],[1,0]])},Model.Game.cbXQAdvisorGraph=function(t,e){return this.cbShortRangeGraph(t,[[1,1],[-1,1],[1,-1],[-1,-1]],e)},Model.Game.cbXQCannonGraph=function(t){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0]],null,this.cbConstants.FLAG_MOVE|this.cbConstants.FLAG_SCREEN_CAPTURE)},Model.Game.cbXQElephantGraph=function(t,e){for(var r=this,i={},a=0;a<t.boardSize;a++)i[a]=[],(!e||a in e)&&[[1,1,2,2],[1,-1,2,-2],[-1,1,-2,2],[-1,-1,-2,-2]].forEach(function(n){var s=t.Graph(a,[n[0],n[1]]);if(null!=s){var o=t.Graph(a,[n[2],n[3]]);null!=o&&(!e||o in e)&&i[a].push(r.cbTypedArray([s|r.cbConstants.FLAG_STOP,o|r.cbConstants.FLAG_MOVE|r.cbConstants.FLAG_CAPTURE]))}});return i},Model.Game.cbSilverGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e],[-1,-1],[-1,1],[1,-1],[1,1]])},Model.Game.cbFersGraph=function(t,e){return this.cbShortRangeGraph(t,[[-1,-1],[-1,1],[1,-1],[1,1]])},Model.Game.cbSchleichGraph=function(t,e){return this.cbShortRangeGraph(t,[[-1,0],[1,0],[0,-1],[0,1]])},Model.Game.cbAlfilGraph=function(t,e){return this.cbShortRangeGraph(t,[[-2,-2],[-2,2],[2,2],[2,-2]])}}(),function(){var t=Model.Game.cbBoardGeometryGrid(4,8);Model.Game.cbDefine=function(){return{geometry:t,pieceTypes:{0:{name:"pawn-w",aspect:"pawn",graph:this.cbPawnGraph(t,1),value:1,abbrev:"",fenAbbrev:"P",epCatch:!0},1:{name:"ipawn-w",aspect:"pawn",graph:this.cbInitialPawnGraph(t,1),value:1,abbrev:"",fenAbbrev:"P",initial:[{s:1,p:4},{s:1,p:5},{s:1,p:6},{s:1,p:7}],epCatch:!0,epTarget:!0},2:{name:"pawn-b",aspect:"pawn",graph:this.cbPawnGraph(t,-1),value:1,abbrev:"",fenAbbrev:"P",epCatch:!0},3:{name:"ipawn-b",aspect:"pawn",graph:this.cbInitialPawnGraph(t,-1),value:1,abbrev:"",fenAbbrev:"P",initial:[{s:-1,p:24},{s:-1,p:25},{s:-1,p:26},{s:-1,p:27}],epCatch:!0,epTarget:!0},4:{name:"knight",graph:this.cbKnightGraph(t),value:2.9,abbrev:"N",initial:[{s:1,p:2},{s:-1,p:30}]},5:{name:"bishop",graph:this.cbBishopGraph(t),value:3.1,abbrev:"B",initial:[{s:1,p:1},{s:-1,p:29}]},6:{name:"rook",graph:this.cbRookGraph(t),value:5,abbrev:"R",initial:[{s:1,p:3},{s:-1,p:31}],castle:!0},7:{name:"queen",graph:this.cbQueenGraph(t),abbrev:"Q"},8:{name:"king",isKing:!0,graph:this.cbKingGraph(t),abbrev:"K",initial:[{s:1,p:0},{s:-1,p:28}]}},promote:function(e,r,i){return 1==r.t?[0]:3==r.t?[2]:0==r.t&&7==t.R(i.t)?[4,5,6,7]:2==r.t&&0==t.R(i.t)?[4,5,6,7]:[]},castle:{"0/3":{k:[1,2],r:[2,1],n:"O-O"},"28/31":{k:[30,29],r:[29,30],n:"O-O"}},evaluate:function(e,r,i){var a=i[1].count,n=i[-1].count;a[0]||a[1]||a[4]||a[5]||a[6]||a[7]||n[2]||n[3]||n[6]||n[7]||!(n[4]+n[5]<2||n[5]<2)||(this.mFinished=!0,this.mWinner=JocGame.DRAW),n[2]||n[3]||n[4]||n[5]||n[6]||n[7]||a[0]||a[1]||a[6]||a[7]||!(a[4]+a[5]<2||a[5]<2)||(this.mFinished=!0,this.mWinner=JocGame.DRAW),this.noCaptCount>=100&&(this.mFinished=!0,this.mWinner=JocGame.DRAW);var s,o=e.cbUseTypedArrays?new Int8Array(3):[0,0,0],h=t.height,c=i[1].byType[0];if(c){s=c.length;for(var p=0;p<s;p++)switch(h-t.R(c[p].p)){case 2:o[0]++;break;case 3:o[1]++;break;case 4:o[2]++}}if(c=i[-1].byType[2]){s=c.length;for(var p=0;p<s;p++)switch(t.R(c[p].p)){case 1:o[0]--;break;case 2:o[1]--;break;case 3:o[2]--}}0!=o[0]&&(r.distPawnPromo1=o[0]),0!=o[1]&&(r.distPawnPromo2=o[1]),0!=o[2]&&(r.distPawnPromo3=o[2]);for(var l=0,u=4;u<=5;u++)for(var v=1;v>=-1;v-=2){var b=i[v].byType[u];if(b)for(var p=0;p<b.length;p++)b[p].m&&(l+=v)}0!=l&&(r.minorPiecesMoved=l)}}}}();

/***/ }),

/***/ "aQl7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function isPromise(value) {
    return value && typeof value.subscribe !== 'function' && typeof value.then === 'function';
}
exports.isPromise = isPromise;
//# sourceMappingURL=isPromise.js.map

/***/ }),

/***/ "aV5h":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var debounceTime_1 = __webpack_require__("driz");
Observable_1.Observable.prototype.debounceTime = debounceTime_1.debounceTime;
//# sourceMappingURL=debounceTime.js.map

/***/ }),

/***/ "aWfe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Subscriber__ = __webpack_require__("mmVS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_Subscriber___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs_Subscriber__);
/* unused harmony export enterZone */
/* unused harmony export EnterZoneOperator */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

function enterZone(zone) {
    return this.lift(new EnterZoneOperator(zone));
}
var EnterZoneOperator = (function () {
    function EnterZoneOperator(_zone) {
        this._zone = _zone;
    }
    EnterZoneOperator.prototype.call = function (subscriber, source) {
        return source._subscribe(new EnterZoneSubscriber(subscriber, this._zone));
    };
    return EnterZoneOperator;
}());
var EnterZoneSubscriber = (function (_super) {
    __extends(EnterZoneSubscriber, _super);
    function EnterZoneSubscriber(destination, _zone) {
        _super.call(this, destination);
        this._zone = _zone;
    }
    EnterZoneSubscriber.prototype._next = function (value) {
        var _this = this;
        this._zone.run(function () { return _this.destination.next(value); });
    };
    return EnterZoneSubscriber;
}(__WEBPACK_IMPORTED_MODULE_0_rxjs_Subscriber__["Subscriber"]));
//# sourceMappingURL=enterZone.js.map

/***/ }),

/***/ "ack3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__("mmVS");
/* tslint:enable:max-line-length */
/**
 * Filter items emitted by the source Observable by only emitting those that
 * satisfy a specified predicate.
 *
 * <span class="informal">Like
 * [Array.prototype.filter()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/filter),
 * it only emits a value from the source if it passes a criterion function.</span>
 *
 * <img src="./img/filter.png" width="100%">
 *
 * Similar to the well-known `Array.prototype.filter` method, this operator
 * takes values from the source Observable, passes them through a `predicate`
 * function and only emits those values that yielded `true`.
 *
 * @example <caption>Emit only click events whose target was a DIV element</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var clicksOnDivs = clicks.filter(ev => ev.target.tagName === 'DIV');
 * clicksOnDivs.subscribe(x => console.log(x));
 *
 * @see {@link distinct}
 * @see {@link distinctUntilChanged}
 * @see {@link distinctUntilKeyChanged}
 * @see {@link ignoreElements}
 * @see {@link partition}
 * @see {@link skip}
 *
 * @param {function(value: T, index: number): boolean} predicate A function that
 * evaluates each value emitted by the source Observable. If it returns `true`,
 * the value is emitted, if `false` the value is not passed to the output
 * Observable. The `index` parameter is the number `i` for the i-th source
 * emission that has happened since the subscription, starting from the number
 * `0`.
 * @param {any} [thisArg] An optional argument to determine the value of `this`
 * in the `predicate` function.
 * @return {Observable} An Observable of values from the source that were
 * allowed by the `predicate` function.
 * @method filter
 * @owner Observable
 */
function filter(predicate, thisArg) {
    return this.lift(new FilterOperator(predicate, thisArg));
}
exports.filter = filter;
var FilterOperator = (function () {
    function FilterOperator(predicate, thisArg) {
        this.predicate = predicate;
        this.thisArg = thisArg;
    }
    FilterOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new FilterSubscriber(subscriber, this.predicate, this.thisArg));
    };
    return FilterOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var FilterSubscriber = (function (_super) {
    __extends(FilterSubscriber, _super);
    function FilterSubscriber(destination, predicate, thisArg) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.thisArg = thisArg;
        this.count = 0;
        this.predicate = predicate;
    }
    // the try catch block below is left specifically for
    // optimization and perf reasons. a tryCatcher is not necessary here.
    FilterSubscriber.prototype._next = function (value) {
        var result;
        try {
            result = this.predicate.call(this.thisArg, value, this.count++);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        if (result) {
            this.destination.next(value);
        }
    };
    return FilterSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=filter.js.map

/***/ }),

/***/ "adqA":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var partition_1 = __webpack_require__("tn1n");
Observable_1.Observable.prototype.partition = partition_1.partition;
//# sourceMappingURL=partition.js.map

/***/ }),

/***/ "aec7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var async_1 = __webpack_require__("CGGv");
var isDate_1 = __webpack_require__("fuZx");
var Subscriber_1 = __webpack_require__("mmVS");
var Notification_1 = __webpack_require__("8GmM");
/**
 * Delays the emission of items from the source Observable by a given timeout or
 * until a given Date.
 *
 * <span class="informal">Time shifts each item by some specified amount of
 * milliseconds.</span>
 *
 * <img src="./img/delay.png" width="100%">
 *
 * If the delay argument is a Number, this operator time shifts the source
 * Observable by that amount of time expressed in milliseconds. The relative
 * time intervals between the values are preserved.
 *
 * If the delay argument is a Date, this operator time shifts the start of the
 * Observable execution until the given date occurs.
 *
 * @example <caption>Delay each click by one second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var delayedClicks = clicks.delay(1000); // each click emitted after 1 second
 * delayedClicks.subscribe(x => console.log(x));
 *
 * @example <caption>Delay all clicks until a future date happens</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var date = new Date('March 15, 2050 12:00:00'); // in the future
 * var delayedClicks = clicks.delay(date); // click emitted only after that date
 * delayedClicks.subscribe(x => console.log(x));
 *
 * @see {@link debounceTime}
 * @see {@link delayWhen}
 *
 * @param {number|Date} delay The delay duration in milliseconds (a `number`) or
 * a `Date` until which the emission of the source items is delayed.
 * @param {Scheduler} [scheduler=async] The IScheduler to use for
 * managing the timers that handle the time-shift for each item.
 * @return {Observable} An Observable that delays the emissions of the source
 * Observable by the specified timeout or Date.
 * @method delay
 * @owner Observable
 */
function delay(delay, scheduler) {
    if (scheduler === void 0) { scheduler = async_1.async; }
    var absoluteDelay = isDate_1.isDate(delay);
    var delayFor = absoluteDelay ? (+delay - scheduler.now()) : Math.abs(delay);
    return this.lift(new DelayOperator(delayFor, scheduler));
}
exports.delay = delay;
var DelayOperator = (function () {
    function DelayOperator(delay, scheduler) {
        this.delay = delay;
        this.scheduler = scheduler;
    }
    DelayOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new DelaySubscriber(subscriber, this.delay, this.scheduler));
    };
    return DelayOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var DelaySubscriber = (function (_super) {
    __extends(DelaySubscriber, _super);
    function DelaySubscriber(destination, delay, scheduler) {
        _super.call(this, destination);
        this.delay = delay;
        this.scheduler = scheduler;
        this.queue = [];
        this.active = false;
        this.errored = false;
    }
    DelaySubscriber.dispatch = function (state) {
        var source = state.source;
        var queue = source.queue;
        var scheduler = state.scheduler;
        var destination = state.destination;
        while (queue.length > 0 && (queue[0].time - scheduler.now()) <= 0) {
            queue.shift().notification.observe(destination);
        }
        if (queue.length > 0) {
            var delay_1 = Math.max(0, queue[0].time - scheduler.now());
            this.schedule(state, delay_1);
        }
        else {
            source.active = false;
        }
    };
    DelaySubscriber.prototype._schedule = function (scheduler) {
        this.active = true;
        this.add(scheduler.schedule(DelaySubscriber.dispatch, this.delay, {
            source: this, destination: this.destination, scheduler: scheduler
        }));
    };
    DelaySubscriber.prototype.scheduleNotification = function (notification) {
        if (this.errored === true) {
            return;
        }
        var scheduler = this.scheduler;
        var message = new DelayMessage(scheduler.now() + this.delay, notification);
        this.queue.push(message);
        if (this.active === false) {
            this._schedule(scheduler);
        }
    };
    DelaySubscriber.prototype._next = function (value) {
        this.scheduleNotification(Notification_1.Notification.createNext(value));
    };
    DelaySubscriber.prototype._error = function (err) {
        this.errored = true;
        this.queue = [];
        this.destination.error(err);
    };
    DelaySubscriber.prototype._complete = function () {
        this.scheduleNotification(Notification_1.Notification.createComplete());
    };
    return DelaySubscriber;
}(Subscriber_1.Subscriber));
var DelayMessage = (function () {
    function DelayMessage(time, notification) {
        this.time = time;
        this.notification = notification;
    }
    return DelayMessage;
}());
//# sourceMappingURL=delay.js.map

/***/ }),

/***/ "b1Ba":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var BoundNodeCallbackObservable_1 = __webpack_require__("WxOs");
exports.bindNodeCallback = BoundNodeCallbackObservable_1.BoundNodeCallbackObservable.create;
//# sourceMappingURL=bindNodeCallback.js.map

/***/ }),

/***/ "bAB1":
/***/ (function(module, exports) {

function RafleItem(endingSquareNum, capturedSquareNum) {
    this.capturedSquareNum = capturedSquareNum ? capturedSquareNum : null;
    this.endingSquareNum = endingSquareNum;
}

RafleItem.prototype.getNumber = function() {
    return this.endingSquareNum;
};

RafleItem.prototype.toString = function() {
    //return JSON.stringify(this);
    return "" + this.endingSquareNum;
};

module.exports = RafleItem;


/***/ }),

/***/ "bBJu":
/***/ (function(module, exports) {

exports.config = {"status":true,"model":{"plazza":"true","title-en":"Tablut","module":"tafl","js":["tafl-model.js"],"summary":"9x9 board (from Laponia)","thumbnail":"thumb-tafl-tablut.png","rules":{"en":"rules-tafl-tablut.html","fr":"rules-tafl-tablut-fr.html"},"description":{"en":"description.html","fr":"description-fr.html"},"credits":{"en":"credits.html","fr":"credits-fr.html"},"gameOptions":{"preventRepeat":true,"uctTransposition":"states","levelOptions":{"attackersCountFactor":10,"defendersCountFactor":-10,"kingPathFactor":-20,"kingFreedomFactor":-0.1,"distKingFactor":-0.05},"exclude":[],"attackers":1,"longMove":true,"initial":{"attackers":[3,4,5,13,27,36,45,37,35,44,53,43,75,76,77,67],"defenders":{"king":40,"soldiers":[22,31,38,39,41,42,49,58]}},"homeCatch":true,"privateHome":true,"centerDistance":4},"demoRandom":true,"visuals":["res/visuals/tablut-600x600-3d.jpg","res/visuals/tablut-600x600-2d.jpg"],"levels":[{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.65,"uncertaintyFactor":3,"useAlphaBeta":true,"name":"easy","label":"Easy","maxNodes":1000},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.65,"uncertaintyFactor":3,"useAlphaBeta":true,"name":"fast","label":"Fast [1sec]","maxDuration":1,"isDefault":true},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.65,"uncertaintyFactor":3,"useAlphaBeta":true,"name":"strong","label":"Strong","maxNodes":10000,"maxDuration":10}]},"view":{"title-en":"Tafl view","module":"tafl","js":["tafl-xd-view.js"],"xdView":true,"css":["tafl.css"],"preferredRatio":1,"switchable":true,"useShowMoves":false,"useNotation":true,"sounds":{"death1":"death1","death2":"death2","death3":"death3","move1":"move1","move3":"move3"},"defaultOptions":{"sounds":true,"moves":true,"notation":false},"skins":[{"name":"tafl3d","title":"3D Classic","3d":true,"camera":{"limitCamMoves":true,"radius":14,"rotationAngle":90,"elevationAngle":89.9,"elevationMin":2,"elevationMax":89.9},"world":{"lightIntensity":0.8,"skyLightIntensity":0.5,"lightCastShadow":false,"fog":false,"color":1118481,"lightPosition":{"x":10,"y":5,"z":0},"lightShadowDarkness":0.55,"ambientLightColor":4473924},"preload":["image|/res/xd-view/meshes/woodtoken-diffuse-black.jpg","image|/res/xd-view/meshes/woodtoken-diffuse.jpg","image|/res/images/ardriboard_bgx1024.jpg","image|/res/images/ardricellborders.png","image|/res/images/ardriblackcell.png","image|/res/images/ardrikingcell.png","image|/res/images/blackcell.png","image|/res/images/whitecell.png","smoothedfilegeo|0|/res/xd-view/meshes/taflboard.js","smoothedfilegeo|0|/res/xd-view/meshes/ring-target.js","smoothedfilegeo|0|/res/xd-view/meshes/woodtoken.js"]},{"name":"tafl2d","title":"2D Classic","3d":false,"preload":["image|/res/xd-view/meshes/ardri-sprites.png","image|/res/images/ardriboard_bgx1024.jpg","image|/res/images/ardricellborders.png","image|/res/images/ardriblackcell.png","image|/res/images/ardrikingcell.png","image|/res/images/blackcell.png","image|/res/images/whitecell.png"]}],"animateSelfMoves":false,"visuals":{"600x600":["res/visuals/tablut-600x600-3d.jpg","res/visuals/tablut-600x600-2d.jpg"]}}}

/***/ }),

/***/ "bBiI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__("mmVS");
var EmptyError_1 = __webpack_require__("F7Al");
/**
 * Emits only the first value (or the first value that meets some condition)
 * emitted by the source Observable.
 *
 * <span class="informal">Emits only the first value. Or emits only the first
 * value that passes some test.</span>
 *
 * <img src="./img/first.png" width="100%">
 *
 * If called with no arguments, `first` emits the first value of the source
 * Observable, then completes. If called with a `predicate` function, `first`
 * emits the first value of the source that matches the specified condition. It
 * may also take a `resultSelector` function to produce the output value from
 * the input value, and a `defaultValue` to emit in case the source completes
 * before it is able to emit a valid value. Throws an error if `defaultValue`
 * was not provided and a matching element is not found.
 *
 * @example <caption>Emit only the first click that happens on the DOM</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.first();
 * result.subscribe(x => console.log(x));
 *
 * @example <caption>Emits the first click that happens on a DIV</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.first(ev => ev.target.tagName === 'DIV');
 * result.subscribe(x => console.log(x));
 *
 * @see {@link filter}
 * @see {@link find}
 * @see {@link take}
 *
 * @throws {EmptyError} Delivers an EmptyError to the Observer's `error`
 * callback if the Observable completes before any `next` notification was sent.
 *
 * @param {function(value: T, index: number, source: Observable<T>): boolean} [predicate]
 * An optional function called with each item to test for condition matching.
 * @param {function(value: T, index: number): R} [resultSelector] A function to
 * produce the value on the output Observable based on the values
 * and the indices of the source Observable. The arguments passed to this
 * function are:
 * - `value`: the value that was emitted on the source.
 * - `index`: the "index" of the value from the source.
 * @param {R} [defaultValue] The default value emitted in case no valid value
 * was found on the source.
 * @return {Observable<T|R>} An Observable of the first item that matches the
 * condition.
 * @method first
 * @owner Observable
 */
function first(predicate, resultSelector, defaultValue) {
    return this.lift(new FirstOperator(predicate, resultSelector, defaultValue, this));
}
exports.first = first;
var FirstOperator = (function () {
    function FirstOperator(predicate, resultSelector, defaultValue, source) {
        this.predicate = predicate;
        this.resultSelector = resultSelector;
        this.defaultValue = defaultValue;
        this.source = source;
    }
    FirstOperator.prototype.call = function (observer, source) {
        return source.subscribe(new FirstSubscriber(observer, this.predicate, this.resultSelector, this.defaultValue, this.source));
    };
    return FirstOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var FirstSubscriber = (function (_super) {
    __extends(FirstSubscriber, _super);
    function FirstSubscriber(destination, predicate, resultSelector, defaultValue, source) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.resultSelector = resultSelector;
        this.defaultValue = defaultValue;
        this.source = source;
        this.index = 0;
        this.hasCompleted = false;
        this._emitted = false;
    }
    FirstSubscriber.prototype._next = function (value) {
        var index = this.index++;
        if (this.predicate) {
            this._tryPredicate(value, index);
        }
        else {
            this._emit(value, index);
        }
    };
    FirstSubscriber.prototype._tryPredicate = function (value, index) {
        var result;
        try {
            result = this.predicate(value, index, this.source);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        if (result) {
            this._emit(value, index);
        }
    };
    FirstSubscriber.prototype._emit = function (value, index) {
        if (this.resultSelector) {
            this._tryResultSelector(value, index);
            return;
        }
        this._emitFinal(value);
    };
    FirstSubscriber.prototype._tryResultSelector = function (value, index) {
        var result;
        try {
            result = this.resultSelector(value, index);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        this._emitFinal(result);
    };
    FirstSubscriber.prototype._emitFinal = function (value) {
        var destination = this.destination;
        if (!this._emitted) {
            this._emitted = true;
            destination.next(value);
            destination.complete();
            this.hasCompleted = true;
        }
    };
    FirstSubscriber.prototype._complete = function () {
        var destination = this.destination;
        if (!this.hasCompleted && typeof this.defaultValue !== 'undefined') {
            destination.next(this.defaultValue);
            destination.complete();
        }
        else if (!this.hasCompleted) {
            destination.error(new EmptyError_1.EmptyError);
        }
    };
    return FirstSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=first.js.map

/***/ }),

/***/ "bE1M":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var mergeMap_1 = __webpack_require__("XO5T");
/* tslint:enable:max-line-length */
/**
 * Projects each source value to an Observable which is merged in the output
 * Observable, in a serialized fashion waiting for each one to complete before
 * merging the next.
 *
 * <span class="informal">Maps each value to an Observable, then flattens all of
 * these inner Observables using {@link concatAll}.</span>
 *
 * <img src="./img/concatMap.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an (so-called "inner") Observable. Each new inner Observable is
 * concatenated with the previous inner Observable.
 *
 * __Warning:__ if source values arrive endlessly and faster than their
 * corresponding inner Observables can complete, it will result in memory issues
 * as inner Observables amass in an unbounded buffer waiting for their turn to
 * be subscribed to.
 *
 * Note: `concatMap` is equivalent to `mergeMap` with concurrency parameter set
 * to `1`.
 *
 * @example <caption>For each click event, tick every second from 0 to 3, with no concurrency</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.concatMap(ev => Rx.Observable.interval(1000).take(4));
 * result.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // (results are not concurrent)
 * // For every click on the "document" it will emit values 0 to 3 spaced
 * // on a 1000ms interval
 * // one click = 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3
 *
 * @see {@link concat}
 * @see {@link concatAll}
 * @see {@link concatMapTo}
 * @see {@link exhaustMap}
 * @see {@link mergeMap}
 * @see {@link switchMap}
 *
 * @param {function(value: T, ?index: number): ObservableInput} project A function
 * that, when applied to an item emitted by the source Observable, returns an
 * Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} An observable of values merged from the projected
 * Observables as they were subscribed to, one at a time. Optionally, these
 * values may have been projected from a passed `projectResult` argument.
 * @return {Observable} An Observable that emits the result of applying the
 * projection function (and the optional `resultSelector`) to each item emitted
 * by the source Observable and taking values from each projected inner
 * Observable sequentially.
 * @method concatMap
 * @owner Observable
 */
function concatMap(project, resultSelector) {
    return this.lift(new mergeMap_1.MergeMapOperator(project, resultSelector, 1));
}
exports.concatMap = concatMap;
//# sourceMappingURL=concatMap.js.map

/***/ }),

/***/ "bWt6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("3j3K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__breakpoints_break_point_registry__ = __webpack_require__("eZjk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__match_media__ = __webpack_require__("LuwH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_add_alias__ = __webpack_require__("WeUy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_add_operator_map__ = __webpack_require__("+pb+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_add_operator_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_rxjs_add_operator_map__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MediaMonitor; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */





/**
 * MediaMonitor uses the MatchMedia service to observe mediaQuery changes (both activations and
 * deactivations). These changes are are published as MediaChange notifications.
 *
 * Note: all notifications will be performed within the
 * ng Zone to trigger change detections and component updates.
 *
 * It is the MediaMonitor that:
 *  - auto registers all known breakpoints
 *  - injects alias information into each raw MediaChange event
 *  - provides accessor to the currently active BreakPoint
 *  - publish list of overlapping BreakPoint(s); used by ResponsiveActivation
 */
var MediaMonitor = (function () {
    function MediaMonitor(_breakpoints, _matchMedia) {
        this._breakpoints = _breakpoints;
        this._matchMedia = _matchMedia;
        this._registerBreakpoints();
    }
    Object.defineProperty(MediaMonitor.prototype, "breakpoints", {
        /**
         * Read-only accessor to the list of breakpoints configured in the BreakPointRegistry provider
         */
        get: function () {
            return this._breakpoints.items.slice();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MediaMonitor.prototype, "activeOverlaps", {
        get: function () {
            var _this = this;
            var items = this._breakpoints.overlappings.reverse();
            return items.filter(function (bp) {
                return _this._matchMedia.isActive(bp.mediaQuery);
            });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MediaMonitor.prototype, "active", {
        get: function () {
            var _this = this;
            var found = null, items = this.breakpoints.reverse();
            items.forEach(function (bp) {
                if (bp.alias !== '') {
                    if (!found && _this._matchMedia.isActive(bp.mediaQuery)) {
                        found = bp;
                    }
                }
            });
            var first = this.breakpoints[0];
            return found || (this._matchMedia.isActive(first.mediaQuery) ? first : null);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * For the specified mediaQuery alias, is the mediaQuery range active?
     */
    MediaMonitor.prototype.isActive = function (alias) {
        var bp = this._breakpoints.findByAlias(alias) || this._breakpoints.findByQuery(alias);
        return this._matchMedia.isActive(bp ? bp.mediaQuery : alias);
    };
    /**
     * External observers can watch for all (or a specific) mql changes.
     * If specific breakpoint is observed, only return *activated* events
     * otherwise return all events for BOTH activated + deactivated changes.
     */
    MediaMonitor.prototype.observe = function (alias) {
        var bp = this._breakpoints.findByAlias(alias) || this._breakpoints.findByQuery(alias);
        var hasAlias = function (change) { return (bp ? change.mqAlias !== "" : true); };
        // Note: the raw MediaChange events [from MatchMedia] do not contain important alias information
        return this._matchMedia
            .observe(bp ? bp.mediaQuery : alias)
            .map(function (change) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_add_alias__["a" /* mergeAlias */])(change, bp); })
            .filter(hasAlias);
    };
    /**
     * Immediate calls to matchMedia() to establish listeners
     * and prepare for immediate subscription notifications
     */
    MediaMonitor.prototype._registerBreakpoints = function () {
        var _this = this;
        this._breakpoints.items.forEach(function (bp) {
            _this._matchMedia.registerQuery(bp.mediaQuery);
        });
    };
    return MediaMonitor;
}());

MediaMonitor.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
];
/** @nocollapse */
MediaMonitor.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_1__breakpoints_break_point_registry__["a" /* BreakPointRegistry */], },
    { type: __WEBPACK_IMPORTED_MODULE_2__match_media__["a" /* MatchMedia */], },
]; };
//# sourceMappingURL=media-monitor.js.map

/***/ }),

/***/ "bZY+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var isNumeric_1 = __webpack_require__("P3oE");
var Observable_1 = __webpack_require__("rCTf");
var async_1 = __webpack_require__("CGGv");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var IntervalObservable = (function (_super) {
    __extends(IntervalObservable, _super);
    function IntervalObservable(period, scheduler) {
        if (period === void 0) { period = 0; }
        if (scheduler === void 0) { scheduler = async_1.async; }
        _super.call(this);
        this.period = period;
        this.scheduler = scheduler;
        if (!isNumeric_1.isNumeric(period) || period < 0) {
            this.period = 0;
        }
        if (!scheduler || typeof scheduler.schedule !== 'function') {
            this.scheduler = async_1.async;
        }
    }
    /**
     * Creates an Observable that emits sequential numbers every specified
     * interval of time, on a specified IScheduler.
     *
     * <span class="informal">Emits incremental numbers periodically in time.
     * </span>
     *
     * <img src="./img/interval.png" width="100%">
     *
     * `interval` returns an Observable that emits an infinite sequence of
     * ascending integers, with a constant interval of time of your choosing
     * between those emissions. The first emission is not sent immediately, but
     * only after the first period has passed. By default, this operator uses the
     * `async` IScheduler to provide a notion of time, but you may pass any
     * IScheduler to it.
     *
     * @example <caption>Emits ascending numbers, one every second (1000ms)</caption>
     * var numbers = Rx.Observable.interval(1000);
     * numbers.subscribe(x => console.log(x));
     *
     * @see {@link timer}
     * @see {@link delay}
     *
     * @param {number} [period=0] The interval size in milliseconds (by default)
     * or the time unit determined by the scheduler's clock.
     * @param {Scheduler} [scheduler=async] The IScheduler to use for scheduling
     * the emission of values, and providing a notion of "time".
     * @return {Observable} An Observable that emits a sequential number each time
     * interval.
     * @static true
     * @name interval
     * @owner Observable
     */
    IntervalObservable.create = function (period, scheduler) {
        if (period === void 0) { period = 0; }
        if (scheduler === void 0) { scheduler = async_1.async; }
        return new IntervalObservable(period, scheduler);
    };
    IntervalObservable.dispatch = function (state) {
        var index = state.index, subscriber = state.subscriber, period = state.period;
        subscriber.next(index);
        if (subscriber.closed) {
            return;
        }
        state.index += 1;
        this.schedule(state, period);
    };
    IntervalObservable.prototype._subscribe = function (subscriber) {
        var index = 0;
        var period = this.period;
        var scheduler = this.scheduler;
        subscriber.add(scheduler.schedule(IntervalObservable.dispatch, period, {
            index: index, subscriber: subscriber, period: period
        }));
    };
    return IntervalObservable;
}(Observable_1.Observable));
exports.IntervalObservable = IntervalObservable;
//# sourceMappingURL=IntervalObservable.js.map

/***/ }),

/***/ "bgfr":
/***/ (function(module, exports) {

exports.Piece = {
    EMPTY : 0,
    PAWN_WHITE : 1,
    PAWN_BLACK : 2,
    DAME_WHITE : 3,
    DAME_BLACK : 4
};

exports.Color = {
    NONE : 0,
    WHITE : 1,
    BLACK : 2
};


/***/ }),

/***/ "c3t5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var fromPromise_1 = __webpack_require__("ioK+");
Observable_1.Observable.fromPromise = fromPromise_1.fromPromise;
//# sourceMappingURL=fromPromise.js.map

/***/ }),

/***/ "cDAr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var timeout_1 = __webpack_require__("E/WS");
Observable_1.Observable.prototype.timeout = timeout_1.timeout;
//# sourceMappingURL=timeout.js.map

/***/ }),

/***/ "cHRr":
/***/ (function(module, exports) {

exports.model=Model={Game:{},Board:{},Move:{}},Model.Game.InitGameInfo=function(){},Model.Game.BuildGraphCoord=function(){var i=[],t=[];this.g.Graph=i,this.g.Coord=t},Model.Game.InitGame=function(){this.BuildGraphCoord(),this.g.TripletsByPos=[];for(var i=0;i<this.g.Coord.length;i++)this.g.TripletsByPos[i]=[];for(var i in this.g.Triplets)if(this.g.Triplets.hasOwnProperty(i)){var t=this.g.Triplets[i];for(var e in t)if(t.hasOwnProperty(e)){var s=t[e];this.g.TripletsByPos[s].push(t)}}this.InitGameExtra()},Model.Game.DestroyGame=function(){},Model.Game.MillsDirections=4,Model.Game.MillsEachDirection=function(i,t){for(var e=0;e<this.MillsDirections;e++){var s=this.g.Graph[i][e];null!=s&&t(s)}},Model.Move.Init=function(i){this.f=i.f,this.t=i.t,this.c=i.c},Model.Move.CopyFrom=function(i){this.f=i.f,this.t=i.t,this.c=i.c},Model.Move.Equals=function(i){return this.t==i.t&&this.c==i.c&&this.f==i.f},Model.Move.ToString=function(){var i="";return this.f>-1&&(i+=this.f+">"),i+=this.t,this.c>-1&&(i+="x"+this.c),i},Model.Board.Init=function(i){},Model.Board.InitialPosition=function(i){var t=i.g.Coord.length,e=i.mOptions.mencount;this.board=[];for(var s=0;s<t;s++)this.board[s]=-1;this.pieces=[],this.dock={1:[],"-1":[]},this.menCount={1:0,"-1":0};for(var o=0,r=0;r<2;r++)for(var n=0==r?1:-1,h=0;h<e;h++)this.dock[n].unshift(o),this.pieces.push({s:n,a:!0,d:h,p:-1,i:o++});this.placing=!0},Model.Board.StaticGenerateMoves=function(i){if(0==i.mFullPlayedMoves.length){for(var t=[],e=0;e<i.g.Coord.length;e++)t.push({f:-1,t:e,c:-1});return t}return null},Model.Board.GenerateMoves=function(i){this.mMoves=[],this.placing?this.GeneratePlacingMoves(i):i.mOptions.canFly?this.GenerateFlyingMoves(i):this.GenerateMovingMoves(i),0==this.mMoves.length&&(this.mFinished=!0,this.menCount[JocGame.PLAYER_A]+this.menCount[JocGame.PLAYER_B]==i.g.Coord.length?this.mWinner=JocGame.DRAW:this.mWinner=-this.mWho)},Model.Board.GeneratePlacingMoves=function(i){for(var t=0;t<i.g.Coord.length;t++)if(this.board[t]==-1){var e=!0;if(void 0!==i.mLevelInfo&&i.mCurrentLevel>=0){var s=i.mLevelInfo.maxDepth-i.mCurrentLevel;if(s>=i.mLevelInfo.placingRace){e=!1;for(var o in i.g.TripletsByPos[t])if(i.g.TripletsByPos[t].hasOwnProperty(o)){for(var r=i.g.TripletsByPos[t][o],n=0,h=0,a=0,l=0;l<3;l++)this.board[r[l]]==-1?a++:this.pieces[this.board[r[l]]].s==this.mWho?n++:h++;if(2==n||1==n&&0==h||2==h){e=!0;break}}}}e&&this.GenerateCapturingMoves(i,{f:-1,t:t,c:-1})}},Model.Board.GenerateMovingMoves=function(i){$this=this;for(var t=0;t<this.pieces.length;t++){var e=this.pieces[t];e.a&&e.s==this.mWho&&i.MillsEachDirection(e.p,function(t){$this.board[t]==-1&&$this.GenerateCapturingMoves(i,{f:e.p,t:t,c:-1})})}},Model.Board.GenerateFlyingMoves=function(i){if(3!=this.menCount[this.mWho])this.GenerateMovingMoves(i);else for(var t=0;t<this.pieces.length;t++){var e=this.pieces[t];if(e.a&&e.s==this.mWho)for(var s=0;s<this.board.length;s++)this.board[s]==-1&&this.GenerateCapturingMoves(i,{f:e.p,t:s,c:-1})}},Model.Board.GenerateCapturingMoves=function(i,t){for(var e in i.g.TripletsByPos[t.t])if(i.g.TripletsByPos[t.t].hasOwnProperty(e)){for(var s=i.g.TripletsByPos[t.t][e],o=!0,r=0;r<3;r++){var n=s[r];if(n!=t.t){if(this.board[n]==-1||t.f==n){o=!1;break}var h=this.pieces[this.board[n]];if(0==h.a||h.d>-1||h.s!=this.mWho){o=!1;break}}}if(o){if(3==this.menCount[-this.mWho]&&0==this.placing)return void this.mMoves.push({f:t.f,t:t.t,c:-2});for(var a=[],r=0;r<this.pieces.length;r++){var h=this.pieces[r];if(1==h.a&&h.d==-1&&h.s==-this.mWho){var l={f:t.f,t:t.t,c:h.p};a.push(l)}}if(0==i.mOptions.poundInMill){var c={};for(var f in i.g.Triplets)if(i.g.Triplets.hasOwnProperty(f)){var d=i.g.Triplets[f];this.board[d[0]]!=-1&&this.pieces[this.board[d[0]]].s==-this.mWho&&this.board[d[1]]!=-1&&this.pieces[this.board[d[1]]].s==-this.mWho&&this.board[d[2]]!=-1&&this.pieces[this.board[d[2]]].s==-this.mWho&&(c[d[0]]=!0,c[d[1]]=!0,c[d[2]]=!0)}for(var v=[],f=0;f<a.length;f++)c[a[f].c]||v.push(a[f]);v.length>0&&(a=v)}return void(this.mMoves=this.mMoves.concat(a))}}this.mMoves.push({f:t.f,t:t.t,c:-1})},Model.Board.Evaluate=function(i,t,e){if(i.GetRepeatOccurence(this)>2)return this.mFinished=!0,void(this.mWinner=JocGame.DRAW);if(0==this.placing){if(this.menCount[JocGame.PLAYER_A]<3)return this.mFinished=!0,void(this.mWinner=JocGame.PLAYER_B);if(this.menCount[JocGame.PLAYER_B]<3)return this.mFinished=!0,void(this.mWinner=JocGame.PLAYER_A)}var s=this.menCount[JocGame.PLAYER_A]-this.menCount[JocGame.PLAYER_B],o=0,r=0;for(var n in i.g.Triplets)if(i.g.Triplets.hasOwnProperty(n)){for(var h={"-1":0,0:0,1:0},a=i.g.Triplets[n],l=0;l<3;l++){var c=a[l],f=this.board[c];if(f>-1){var d=this.pieces[f];h[d.s]++}}1==h[1]&&0==h[-1]?o++:2==h[1]&&0==h[-1]&&r++,1==h[-1]&&0==h[1]?o--:2==h[-1]&&0==h[1]&&r--}this.mEvaluation=10*s,this.mEvaluation+=1*o,this.mEvaluation+=3*r},Model.Board.ApplyMove=function(i,t){if(this.placing){var e=this.dock[this.mWho].shift(),s=this.pieces[e];s.d=-1,s.p=t.t,this.board[t.t]=e,this.lastMoveIndex=e,this.menCount[this.mWho]++,0==this.dock[JocGame.PLAYER_B].length&&(this.placing=!1)}else{var s=this.pieces[this.board[t.f]];this.board[s.p]=-1,this.board[t.t]=s.i,s.p=t.t,this.lastMoveIndex=s.i}if(t.c>-1){var e=this.board[t.c];this.board[t.c]=-1;var s=this.pieces[e];s.a=!1,this.menCount[-this.mWho]--}else t.c==-2&&this.menCount[-this.mWho]--},Model.Board.IsValidMove=function(i,t){return!0},Model.Game.InitGameExtra=function(){},Model.Game.BuildGraphCoord=function(){this.g.Graph=[[1,3,null,null],[2,4,0,null],[null,5,1,null],[4,6,null,0],[5,7,3,1],[null,8,4,2],[7,null,null,3],[8,null,6,4],[null,null,7,5]],this.g.Coord=[[0,0],[0,1],[0,2],[1,0],[1,1],[1,2],[2,0],[2,1],[2,2]],this.g.Triplets=[[0,1,2],[3,4,5],[6,7,8],[0,3,6],[1,4,7],[2,5,8]]};

/***/ }),

/***/ "cJSH":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__("mmVS");
var Subscription_1 = __webpack_require__("B00U");
var Observable_1 = __webpack_require__("rCTf");
var Subject_1 = __webpack_require__("EEr4");
var Map_1 = __webpack_require__("9JPB");
var FastMap_1 = __webpack_require__("1kxm");
/* tslint:enable:max-line-length */
/**
 * Groups the items emitted by an Observable according to a specified criterion,
 * and emits these grouped items as `GroupedObservables`, one
 * {@link GroupedObservable} per group.
 *
 * <img src="./img/groupBy.png" width="100%">
 *
 * @example <caption>Group objects by id and return as array</caption>
 * Observable.of<Obj>({id: 1, name: 'aze1'},
 *                    {id: 2, name: 'sf2'},
 *                    {id: 2, name: 'dg2'},
 *                    {id: 1, name: 'erg1'},
 *                    {id: 1, name: 'df1'},
 *                    {id: 2, name: 'sfqfb2'},
 *                    {id: 3, name: 'qfs3'},
 *                    {id: 2, name: 'qsgqsfg2'}
 *     )
 *     .groupBy(p => p.id)
 *     .flatMap( (group$) => group$.reduce((acc, cur) => [...acc, cur], []))
 *     .subscribe(p => console.log(p));
 *
 * // displays:
 * // [ { id: 1, name: 'aze1' },
 * //   { id: 1, name: 'erg1' },
 * //   { id: 1, name: 'df1' } ]
 * //
 * // [ { id: 2, name: 'sf2' },
 * //   { id: 2, name: 'dg2' },
 * //   { id: 2, name: 'sfqfb2' },
 * //   { id: 2, name: 'qsgqsfg2' } ]
 * //
 * // [ { id: 3, name: 'qfs3' } ]
 *
 * @example <caption>Pivot data on the id field</caption>
 * Observable.of<Obj>({id: 1, name: 'aze1'},
 *                    {id: 2, name: 'sf2'},
 *                    {id: 2, name: 'dg2'},
 *                    {id: 1, name: 'erg1'},
 *                    {id: 1, name: 'df1'},
 *                    {id: 2, name: 'sfqfb2'},
 *                    {id: 3, name: 'qfs1'},
 *                    {id: 2, name: 'qsgqsfg2'}
 *                   )
 *     .groupBy(p => p.id, p => p.anme)
 *     .flatMap( (group$) => group$.reduce((acc, cur) => [...acc, cur], ["" + group$.key]))
 *     .map(arr => ({'id': parseInt(arr[0]), 'values': arr.slice(1)}))
 *     .subscribe(p => console.log(p));
 *
 * // displays:
 * // { id: 1, values: [ 'aze1', 'erg1', 'df1' ] }
 * // { id: 2, values: [ 'sf2', 'dg2', 'sfqfb2', 'qsgqsfg2' ] }
 * // { id: 3, values: [ 'qfs1' ] }
 *
 * @param {function(value: T): K} keySelector A function that extracts the key
 * for each item.
 * @param {function(value: T): R} [elementSelector] A function that extracts the
 * return element for each item.
 * @param {function(grouped: GroupedObservable<K,R>): Observable<any>} [durationSelector]
 * A function that returns an Observable to determine how long each group should
 * exist.
 * @return {Observable<GroupedObservable<K,R>>} An Observable that emits
 * GroupedObservables, each of which corresponds to a unique key value and each
 * of which emits those items from the source Observable that share that key
 * value.
 * @method groupBy
 * @owner Observable
 */
function groupBy(keySelector, elementSelector, durationSelector, subjectSelector) {
    return this.lift(new GroupByOperator(keySelector, elementSelector, durationSelector, subjectSelector));
}
exports.groupBy = groupBy;
var GroupByOperator = (function () {
    function GroupByOperator(keySelector, elementSelector, durationSelector, subjectSelector) {
        this.keySelector = keySelector;
        this.elementSelector = elementSelector;
        this.durationSelector = durationSelector;
        this.subjectSelector = subjectSelector;
    }
    GroupByOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new GroupBySubscriber(subscriber, this.keySelector, this.elementSelector, this.durationSelector, this.subjectSelector));
    };
    return GroupByOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var GroupBySubscriber = (function (_super) {
    __extends(GroupBySubscriber, _super);
    function GroupBySubscriber(destination, keySelector, elementSelector, durationSelector, subjectSelector) {
        _super.call(this, destination);
        this.keySelector = keySelector;
        this.elementSelector = elementSelector;
        this.durationSelector = durationSelector;
        this.subjectSelector = subjectSelector;
        this.groups = null;
        this.attemptedToUnsubscribe = false;
        this.count = 0;
    }
    GroupBySubscriber.prototype._next = function (value) {
        var key;
        try {
            key = this.keySelector(value);
        }
        catch (err) {
            this.error(err);
            return;
        }
        this._group(value, key);
    };
    GroupBySubscriber.prototype._group = function (value, key) {
        var groups = this.groups;
        if (!groups) {
            groups = this.groups = typeof key === 'string' ? new FastMap_1.FastMap() : new Map_1.Map();
        }
        var group = groups.get(key);
        var element;
        if (this.elementSelector) {
            try {
                element = this.elementSelector(value);
            }
            catch (err) {
                this.error(err);
            }
        }
        else {
            element = value;
        }
        if (!group) {
            group = this.subjectSelector ? this.subjectSelector() : new Subject_1.Subject();
            groups.set(key, group);
            var groupedObservable = new GroupedObservable(key, group, this);
            this.destination.next(groupedObservable);
            if (this.durationSelector) {
                var duration = void 0;
                try {
                    duration = this.durationSelector(new GroupedObservable(key, group));
                }
                catch (err) {
                    this.error(err);
                    return;
                }
                this.add(duration.subscribe(new GroupDurationSubscriber(key, group, this)));
            }
        }
        if (!group.closed) {
            group.next(element);
        }
    };
    GroupBySubscriber.prototype._error = function (err) {
        var groups = this.groups;
        if (groups) {
            groups.forEach(function (group, key) {
                group.error(err);
            });
            groups.clear();
        }
        this.destination.error(err);
    };
    GroupBySubscriber.prototype._complete = function () {
        var groups = this.groups;
        if (groups) {
            groups.forEach(function (group, key) {
                group.complete();
            });
            groups.clear();
        }
        this.destination.complete();
    };
    GroupBySubscriber.prototype.removeGroup = function (key) {
        this.groups.delete(key);
    };
    GroupBySubscriber.prototype.unsubscribe = function () {
        if (!this.closed) {
            this.attemptedToUnsubscribe = true;
            if (this.count === 0) {
                _super.prototype.unsubscribe.call(this);
            }
        }
    };
    return GroupBySubscriber;
}(Subscriber_1.Subscriber));
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var GroupDurationSubscriber = (function (_super) {
    __extends(GroupDurationSubscriber, _super);
    function GroupDurationSubscriber(key, group, parent) {
        _super.call(this);
        this.key = key;
        this.group = group;
        this.parent = parent;
    }
    GroupDurationSubscriber.prototype._next = function (value) {
        this._complete();
    };
    GroupDurationSubscriber.prototype._error = function (err) {
        var group = this.group;
        if (!group.closed) {
            group.error(err);
        }
        this.parent.removeGroup(this.key);
    };
    GroupDurationSubscriber.prototype._complete = function () {
        var group = this.group;
        if (!group.closed) {
            group.complete();
        }
        this.parent.removeGroup(this.key);
    };
    return GroupDurationSubscriber;
}(Subscriber_1.Subscriber));
/**
 * An Observable representing values belonging to the same group represented by
 * a common key. The values emitted by a GroupedObservable come from the source
 * Observable. The common key is available as the field `key` on a
 * GroupedObservable instance.
 *
 * @class GroupedObservable<K, T>
 */
var GroupedObservable = (function (_super) {
    __extends(GroupedObservable, _super);
    function GroupedObservable(key, groupSubject, refCountSubscription) {
        _super.call(this);
        this.key = key;
        this.groupSubject = groupSubject;
        this.refCountSubscription = refCountSubscription;
    }
    GroupedObservable.prototype._subscribe = function (subscriber) {
        var subscription = new Subscription_1.Subscription();
        var _a = this, refCountSubscription = _a.refCountSubscription, groupSubject = _a.groupSubject;
        if (refCountSubscription && !refCountSubscription.closed) {
            subscription.add(new InnerRefCountSubscription(refCountSubscription));
        }
        subscription.add(groupSubject.subscribe(subscriber));
        return subscription;
    };
    return GroupedObservable;
}(Observable_1.Observable));
exports.GroupedObservable = GroupedObservable;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var InnerRefCountSubscription = (function (_super) {
    __extends(InnerRefCountSubscription, _super);
    function InnerRefCountSubscription(parent) {
        _super.call(this);
        this.parent = parent;
        parent.count++;
    }
    InnerRefCountSubscription.prototype.unsubscribe = function () {
        var parent = this.parent;
        if (!parent.closed && !this.closed) {
            _super.prototype.unsubscribe.call(this);
            parent.count -= 1;
            if (parent.count === 0 && parent.attemptedToUnsubscribe) {
                parent.unsubscribe();
            }
        }
    };
    return InnerRefCountSubscription;
}(Subscription_1.Subscription));
//# sourceMappingURL=groupBy.js.map

/***/ }),

/***/ "cPow":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("3j3K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reducer__ = __webpack_require__("oi6x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dispatcher__ = __webpack_require__("osFu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__("Zcpd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__state__ = __webpack_require__("NPiC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__("dt2B");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return INITIAL_REDUCER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return INITIAL_STATE; });
/* unused harmony export _INITIAL_REDUCER */
/* unused harmony export _INITIAL_STATE */
/* unused harmony export _initialReducerFactory */
/* unused harmony export _initialStateFactory */
/* unused harmony export _storeFactory */
/* unused harmony export _stateFactory */
/* unused harmony export _reducerFactory */
/* unused harmony export provideStore */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StoreModule; });
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};






var INITIAL_REDUCER = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["OpaqueToken"]('Token ngrx/store/reducer');
var INITIAL_STATE = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["OpaqueToken"]('Token ngrx/store/initial-state');
var _INITIAL_REDUCER = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["OpaqueToken"]('Token _ngrx/store/reducer');
var _INITIAL_STATE = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["OpaqueToken"]('Token _ngrx/store/initial-state');
function _initialReducerFactory(reducer) {
    if (typeof reducer === 'function') {
        return reducer;
    }
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils__["a" /* combineReducers */])(reducer);
}
function _initialStateFactory(initialState, reducer) {
    if (!initialState) {
        return reducer(undefined, { type: __WEBPACK_IMPORTED_MODULE_2__dispatcher__["a" /* Dispatcher */].INIT });
    }
    return initialState;
}
function _storeFactory(dispatcher, reducer, state$) {
    return new __WEBPACK_IMPORTED_MODULE_3__store__["a" /* Store */](dispatcher, reducer, state$);
}
function _stateFactory(initialState, dispatcher, reducer) {
    return new __WEBPACK_IMPORTED_MODULE_4__state__["a" /* State */](initialState, dispatcher, reducer);
}
function _reducerFactory(dispatcher, reducer) {
    return new __WEBPACK_IMPORTED_MODULE_1__reducer__["a" /* Reducer */](dispatcher, reducer);
}
;
/**
 * @deprecated, use StoreModule.provideStore instead!
 */
function provideStore(_reducer, _initialState) {
    return [
        __WEBPACK_IMPORTED_MODULE_2__dispatcher__["a" /* Dispatcher */],
        { provide: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* Store */], useFactory: _storeFactory, deps: [__WEBPACK_IMPORTED_MODULE_2__dispatcher__["a" /* Dispatcher */], __WEBPACK_IMPORTED_MODULE_1__reducer__["a" /* Reducer */], __WEBPACK_IMPORTED_MODULE_4__state__["a" /* State */]] },
        { provide: __WEBPACK_IMPORTED_MODULE_1__reducer__["a" /* Reducer */], useFactory: _reducerFactory, deps: [__WEBPACK_IMPORTED_MODULE_2__dispatcher__["a" /* Dispatcher */], INITIAL_REDUCER] },
        { provide: __WEBPACK_IMPORTED_MODULE_4__state__["a" /* State */], useFactory: _stateFactory, deps: [INITIAL_STATE, __WEBPACK_IMPORTED_MODULE_2__dispatcher__["a" /* Dispatcher */], __WEBPACK_IMPORTED_MODULE_1__reducer__["a" /* Reducer */]] },
        { provide: INITIAL_REDUCER, useFactory: _initialReducerFactory, deps: [_INITIAL_REDUCER] },
        { provide: INITIAL_STATE, useFactory: _initialStateFactory, deps: [_INITIAL_STATE, INITIAL_REDUCER] },
        { provide: _INITIAL_STATE, useValue: _initialState },
        { provide: _INITIAL_REDUCER, useValue: _reducer }
    ];
}
var StoreModule = StoreModule_1 = (function () {
    function StoreModule() {
    }
    StoreModule.provideStore = function (_reducer, _initialState) {
        return {
            ngModule: StoreModule_1,
            providers: provideStore(_reducer, _initialState)
        };
    };
    return StoreModule;
}());
StoreModule = StoreModule_1 = __decorate([
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"])({})
], StoreModule);

var StoreModule_1;
//# sourceMappingURL=ng2.js.map

/***/ }),

/***/ "cPwE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * An execution context and a data structure to order tasks and schedule their
 * execution. Provides a notion of (potentially virtual) time, through the
 * `now()` getter method.
 *
 * Each unit of work in a Scheduler is called an {@link Action}.
 *
 * ```ts
 * class Scheduler {
 *   now(): number;
 *   schedule(work, delay?, state?): Subscription;
 * }
 * ```
 *
 * @class Scheduler
 */
var Scheduler = (function () {
    function Scheduler(SchedulerAction, now) {
        if (now === void 0) { now = Scheduler.now; }
        this.SchedulerAction = SchedulerAction;
        this.now = now;
    }
    /**
     * Schedules a function, `work`, for execution. May happen at some point in
     * the future, according to the `delay` parameter, if specified. May be passed
     * some context object, `state`, which will be passed to the `work` function.
     *
     * The given arguments will be processed an stored as an Action object in a
     * queue of actions.
     *
     * @param {function(state: ?T): ?Subscription} work A function representing a
     * task, or some unit of work to be executed by the Scheduler.
     * @param {number} [delay] Time to wait before executing the work, where the
     * time unit is implicit and defined by the Scheduler itself.
     * @param {T} [state] Some contextual data that the `work` function uses when
     * called by the Scheduler.
     * @return {Subscription} A subscription in order to be able to unsubscribe
     * the scheduled work.
     */
    Scheduler.prototype.schedule = function (work, delay, state) {
        if (delay === void 0) { delay = 0; }
        return new this.SchedulerAction(this, work).schedule(state, delay);
    };
    Scheduler.now = Date.now ? Date.now : function () { return +new Date(); };
    return Scheduler;
}());
exports.Scheduler = Scheduler;
//# sourceMappingURL=Scheduler.js.map

/***/ }),

/***/ "cVl3":
/***/ (function(module, exports) {

exports.model=Model={Game:{},Board:{},Move:{}},function(){var t;Model.Game.cbConstants={MASK:65535,FLAG_MOVE:65536,FLAG_CAPTURE:131072,FLAG_STOP:262144,FLAG_SCREEN_CAPTURE:524288,FLAG_CAPTURE_KING:1048576,FLAG_CAPTURE_NO_KING:2097152};var e="undefined"!=typeof Int32Array;Model.Game.cbUseTypedArrays=e,Model.Game.cbTypedArray=function(t){if(e){var r=new Int32Array(t.length);return r.set(t),r}for(var a=[],i=t.length,s=0;s<i;s++)a.push(t[s]);return a},Model.Game.cbShortRangeGraph=function(t,e,r,a){var i=this;void 0===a&&(a=196608);for(var s={},n=0;n<t.boardSize;n++)s[n]=[],(!r||n in r)&&e.forEach(function(e){var o=t.Graph(n,e);null!=o&&(!r||o in r)&&s[n].push(i.cbTypedArray([o|a]))});return s},Model.Game.cbLongRangeGraph=function(t,e,r,a,i){var s=this;void 0!==a&&null!=a||(a=196608),i||(i=1/0);for(var n={},o=0;o<t.boardSize;o++)n[o]=[],(!r||o in r)&&e.forEach(function(e){for(var h=[],c=t.Graph(o,e),p=0;null!=c&&(!r||c in r)&&(h.push(c|a),++p!=i);)c=t.Graph(c,e);h.length>0&&n[o].push(s.cbTypedArray(h))});return n},Model.Game.cbNullGraph=function(t){for(var e={},r=0;r<t.boardSize;r++)e[r]=[];return e},Model.Game.cbAuthorGraph=function(t){for(var e={},r=0;r<t.boardSize;r++){e[r]=[];for(var a=0;a<t.boardSize;a++)e[r].push([2293760|a])}return e},Model.Game.cbMergeGraphs=function(t){for(var e=[],r=0;r<t.boardSize;r++){e[r]=[];for(var a=1;a<arguments.length;a++)e[r]=e[r].concat(arguments[a][r])}return e},Model.Game.cbGetThreatGraph=function(){function t(e,r){for(var a in n){var i=n[a];if(!(i.p.length<r.length+1)){for(var s=!0,o=0;o<r.length;o++)if(r[o]!=i.p[o]){s=!1;break}if(s){var h=i.p[r.length],c=e[h];void 0===c&&(c={e:{}},e[h]=c),i.p.length==r.length+1&&(c.t=i.t,c.ts=i.ts,c.tk=i.tk,delete n[a]),r.push(h),t(c.e,r),r.pop()}}}}var e=this;this.cbUseScreenCapture=!1,this.cbUseCaptureKing=!1,this.cbUseCaptureNoKing=!1;for(var r={1:[],"-1":[]},a=[],i=0;i<this.g.boardSize;i++)this.g.pTypes.forEach(function(t,r){t.graph[i].forEach(function(t){for(var s=[],n=0;n<t.length;n++){var o=t[n];1048576&o?(e.cbUseCaptureKing=!0,s.unshift({d:65535&o,a:i,tk:r})):2097152&o?(e.cbUseCaptureNoKing=!0,s.unshift({d:65535&o,a:i,tnk:r})):131072&o?s.unshift({d:65535&o,a:i,t:r}):262144&o?s.unshift({d:65535&o,a:i}):524288&o&&(e.cbUseScreenCapture=!0,s.unshift({d:65535&o,a:i,ts:r}))}s.length>0&&a.push(s)})});var s={};a.forEach(function(t){t.forEach(function(e,r){var a=s[e.d];void 0===a&&(a={},s[e.d]=a);for(var i=[],n=r+1;n<t.length;n++)i.push(t[n].d);i.push(e.a);var o=i.join(","),h=a[o];void 0===h&&(h={p:i,t:{},ts:{},tk:{}},a[o]=h),void 0!==e.t?h.t[e.t]=!0:void 0!==e.tk?h.tk[e.tk]=!0:void 0!==e.ts&&(h.ts[e.ts]=!0)})});for(var i=0;i<e.g.boardSize;i++){var n=s[i],o={};t(o,[]),r[1][i]=o,r[-1][i]=o}return r},Model.Game.InitGame=function(){var e=this;this.cbVar=t=this.cbDefine(),this.g.boardSize=this.cbVar.geometry.boardSize,this.g.pTypes=this.cbGetPieceTypes(),this.g.threatGraph=this.cbGetThreatGraph(),this.g.distGraph=this.cbVar.geometry.GetDistances(),this.cbPiecesCount=0,this.g.castleablePiecesCount={1:0,"-1":0};for(var r in t.pieceTypes){var a=t.pieceTypes[r];if(a.castle){(a.initial||[]).forEach(function(t){e.g.castleablePiecesCount[t.s]++})}a.initial&&(this.cbPiecesCount+=a.initial.length)}for(var i=[],r=0;r<this.cbPiecesCount;r++)i.push(r);var s=Object.keys(t.pieceTypes);this.zobrist=new JocGame.Zobrist({board:{type:"array",size:this.cbVar.geometry.boardSize,values:i},who:{values:["1","-1"]},type:{type:"array",size:this.cbPiecesCount,values:s}})},Model.Game.cbGetPieceTypes=function(){for(var t=[],e={},r=0;r<this.cbVar.geometry.boardSize;r++)e[r]=[];for(var a in this.cbVar.pieceTypes){var i=this.cbVar.pieceTypes[a];t[a]={graph:i.graph||e,abbrev:i.abbrev||"",value:i.isKing?100:i.value||1,isKing:!!i.isKing,castle:!!i.castle,epTarget:!!i.epTarget,epCatch:!!i.epCatch}}return t},Model.Board.Init=function(t){this.zSign=0},Model.Board.InitialPosition=function(r){var a=this;this.board=e?new Int16Array(r.g.boardSize):[];for(var i=0;i<r.g.boardSize;i++)this.board[i]=-1;if(this.kings={},this.pieces=[],this.ending={1:!1,"-1":!1},this.lastMove=null,r.cbVar.castle&&(this.castled={1:!1,"-1":!1}),this.zSign=r.zobrist.update(0,"who",-1),this.noCaptCount=0,this.mWho=1,r.mInitial)this.mWho=r.mInitial.turn||1,r.mInitial.pieces.forEach(function(t){var e={};for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);a.pieces.push(e)}),r.mInitial.lastMove&&(this.lastMove={f:r.mInitial.lastMove.f,t:r.mInitial.lastMove.t}),void 0!==r.mInitial.noCaptCount&&(this.noCaptCount=r.mInitial.noCaptCount),r.cbVar.castle&&r.mInitial.castle&&(this.castled={1:{k:!!r.mInitial.castle[1]&&!!r.mInitial.castle[1].k,q:!!r.mInitial.castle[1]&&!!r.mInitial.castle[1].q},"-1":{k:!!r.mInitial.castle[-1]&&!!r.mInitial.castle[-1].k,q:!!r.mInitial.castle[-1]&&!!r.mInitial.castle[-1].q}});else for(var s in r.cbVar.pieceTypes)for(var n=r.cbVar.pieceTypes[s],o=n.initial||[],h=0;h<o.length;h++){var c=o[h],p={s:c.s,t:parseInt(s),p:c.p,m:!1};this.pieces.push(p)}if(this.pieces.sort(function(t,e){if(t.s!=e.s)return e.s-t.s;var a=r.cbVar.pieceTypes[t.t].value||100,i=r.cbVar.pieceTypes[e.t].value||100;return a!=i?a-i:t.p-e.p}),this.pieces.forEach(function(t,e){t.i=e,a.board[t.p]=e,r.g.pTypes[t.t].isKing&&(a.kings[t.s]=t.p),a.zSign=r.zobrist.update(a.zSign,"board",e,t.p),a.zSign=r.zobrist.update(a.zSign,"type",t.t,e)}),r.mInitial&&r.mInitial.enPassant){var i=t.geometry.PosByName(r.mInitial.enPassant);if(i>=0){var l,u=t.geometry.C(i),b=t.geometry.R(i);l=1==r.mInitial.turn?t.geometry.POS(u,b-1):t.geometry.POS(u,b+1),this.epTarget={p:i,i:this.board[l]}}}},Model.Board.CopyFrom=function(t){if(e)this.board=new Int16Array(t.board.length),this.board.set(t.board);else{this.board=[];for(var r=t.board,a=r.length,i=0;i<a;i++)this.board.push(r[i])}this.pieces=[];for(var s=t.pieces.length,i=0;i<s;i++){var n=t.pieces[i];this.pieces.push({s:n.s,p:n.p,t:n.t,i:n.i,m:n.m})}this.kings={1:t.kings[1],"-1":t.kings[-1]},this.check=t.check,t.lastMove?this.lastMove={f:t.lastMove.f,t:t.lastMove.t,c:t.lastMove.c}:this.lastMove=null,this.ending={1:t.ending[1],"-1":t.ending[-1]},void 0!==t.castled&&(this.castled={1:t.castled[1],"-1":t.castled[-1]}),this.noCaptCount=t.noCaptCount,t.epTarget?this.epTarget={p:t.epTarget.p,i:t.epTarget.i}:this.epTarget=null,this.mWho=t.mWho,this.zSign=t.zSign},Model.Board.cbApplyCastle=function(t,e,r){var a=t.cbVar.castle[e.f+"/"+e.cg],i=a.r[a.r.length-1],s=this.pieces[this.board[e.cg]],n=a.k[a.k.length-1],o=this.pieces[this.board[e.f]];return r&&(this.zSign=t.zobrist.update(this.zSign,"board",s.i,e.cg),this.zSign=t.zobrist.update(this.zSign,"board",s.i,i),this.zSign=t.zobrist.update(this.zSign,"board",o.i,e.f),this.zSign=t.zobrist.update(this.zSign,"board",o.i,n)),s.p=i,s.m=!0,this.board[e.cg]=-1,o.p=n,o.m=!0,this.board[e.f]=-1,this.board[i]=s.i,this.board[n]=o.i,this.castled[s.s]=!0,this.kings[o.s]=n,[{i:s.i,f:i,t:-1},{i:o.i,f:n,t:e.f,kp:e.f,who:o.s,m:!1},{i:s.i,f:-1,t:e.cg,m:!1,cg:!1}]},Model.Board.cbQuickApply=function(t,e){if(void 0!==e.cg)return this.cbApplyCastle(t,e,!1);var r=[],a=this.board[e.f],i=this.pieces[a];if(null!=e.c){r.unshift({i:e.c,f:-1,t:this.pieces[e.c].p});var s=this.pieces[e.c];this.board[s.p]=-1,s.p=-1}var n=this.kings[i.s];return t.g.pTypes[i.t].isKing&&(this.kings[i.s]=e.t),r.unshift({i:a,f:e.t,t:e.f,kp:n,who:i.s,ty:i.t}),i.p=e.t,void 0!==e.pr&&(i.t=e.pr),this.board[e.f]=-1,this.board[e.t]=a,r},Model.Board.cbQuickUnapply=function(t,e){for(var r=0;r<e.length;r++){var a=e[r],i=this.pieces[a.i];a.f>=0&&(i.p=-1,this.board[a.f]=-1),a.t>=0&&(i.p=a.t,this.board[a.t]=a.i),void 0!==a.m&&(i.m=a.m),void 0!==a.kp&&(this.kings[a.who]=a.kp),void 0!=a.ty&&(i.t=a.ty),void 0!=a.cg&&(this.castled[i.s]=a.cg)}},Model.Board.ApplyMove=function(t,e){var r=this.pieces[this.board[e.f]];if(void 0!==e.cg)this.cbApplyCastle(t,e,!0);else{if(this.zSign=t.zobrist.update(this.zSign,"board",r.i,e.f),this.board[r.p]=-1,void 0!==e.pr&&(this.zSign=t.zobrist.update(this.zSign,"type",r.t,r.i),r.t=e.pr,this.zSign=t.zobrist.update(this.zSign,"type",r.t,r.i)),null!=e.c){var a=this.pieces[e.c];this.zSign=t.zobrist.update(this.zSign,"board",a.i,a.p),this.board[a.p]=-1,a.p=-1,a.m=!0,this.noCaptCount=0}else this.noCaptCount++;r.p=e.t,r.m=!0,this.board[e.t]=r.i,this.zSign=t.zobrist.update(this.zSign,"board",r.i,e.t),t.g.pTypes[r.t].isKing&&(this.kings[r.s]=e.t)}this.check=!!e.ck,this.lastMove={f:e.f,t:e.t,c:e.c},void 0!==e.ko&&(this.ending[r.s]=e.ko),void 0!==e.ept?this.epTarget={p:e.ept,i:r.i}:this.epTarget=null,this.zSign=t.zobrist.update(this.zSign,"who",-this.mWho),this.zSign=t.zobrist.update(this.zSign,"who",this.mWho)},Model.Board.Evaluate=function(r){function a(e){var r=1/0;for(var a in t.geometry.corners)r=Math.min(r,h.distGraph[s.kings[e]][a]);return r-Math.sqrt(h.boardSize)}var i="debug"==arguments[3],s=this;this.mEvaluation=0;var n,o=this.mWho,h=r.g;if(e)n={1:{count:new Uint8Array(h.pTypes.length),byType:{}},"-1":{count:new Uint8Array(h.pTypes.length),byType:{}}};else{n={1:{count:[],byType:{}},"-1":{count:[],byType:{}}};for(var c=0;c<h.pTypes.length;c++)n[1].count[c]=n[-1].count[c]=0}if(r.mOptions.preventRepeat&&r.GetRepeatOccurence(this)>2)return this.mFinished=!0,void(this.mWinner=r.cbOnPerpetual?o*r.cbOnPerpetual:JocGame.DRAW);for(var p={1:0,"-1":0},l={1:h.distGraph[this.kings[-1]],"-1":h.distGraph[this.kings[1]]},u={1:0,"-1":0},b={1:0,"-1":0},v={1:0,"-1":0},f={1:0,"-1":0},g={1:!1,"-1":!1},d=this.pieces,m=d.length,c=0;c<m;c++){var G=d[c];if(G.p>=0){var y=G.s,M=h.pTypes[G.t];M.isKing?g[y]=G.m:p[y]+=M.value,M.castle&&!G.m&&f[y]++,b[y]++,u[y]+=l[y][G.p],v[y]+=t.geometry.distEdge[G.p];var C=n[y];C.count[G.t]++;var S=C.byType;void 0===S[G.t]?S[G.t]=[G]:S[G.t].push(G)}}if(this.lastMove&&null!=this.lastMove.c){var G=this.pieces[this.board[this.lastMove.t]];p[-G.s]+=this.cbStaticExchangeEval(r,G.p,G.s,{piece:G})}var k={1:0,"-1":0},A={1:0,"-1":0},T={1:0,"-1":0};this.ending[1]&&(A[1]=(u[1]-Math.sqrt(h.boardSize))/b[1],t.geometry.corners&&(T[1]=a(1))),this.ending[-1]&&(A[-1]=(u[-1]-Math.sqrt(h.boardSize))/b[-1],t.geometry.corners&&(T[1]=a(-1)));var z={pieceValue:p[1]-p[-1],pieceValueRatio:(p[1]-p[-1])/(p[1]+p[-1]+1),posValue:v[1]-v[-1],averageDistKing:u[1]/b[1]-u[-1]/b[-1],check:this.check?-o:0,endingKingFreedom:k[1]-k[-1],endingDistKing:A[1]-A[-1],distKingCorner:T[1]-T[-1]};t.castle&&(z.castle=(this.castled[1]?1:g[1]?0:f[1]/(h.castleablePiecesCount[1]+1))-(this.castled[-1]?1:g[-1]?0:f[-1]/(h.castleablePiecesCount[-1]+1))),t.evaluate&&t.evaluate.call(this,r,z,n);var E=r.mOptions.levelOptions;for(var P in z){var w=z[P],I=E[P+"Factor"]||0,R=w*I;i&&console.log(P,"=",w,"*",I,"=>",R),this.mEvaluation+=R}i&&console.log("Evaluation",this.mEvaluation)},Model.Board.cbGeneratePseudoLegalMoves=function(t){function e(e,i){var s=t.cbVar.promote;if(!s)return void a.push(i);var n=s.call(r,t,e,i);if(null!=n)if(0==n.length)a.push(i);else if(1==n.length)i.pr=n[0],a.push(i);else for(var o=0;o<n.length;o++){var h=n[o];a.push({f:i.f,t:i.t,c:i.c,pr:h,ept:i.ept,ep:i.ep,a:i.a})}}for(var r=this,a=[],i=t.cbVar,s=this.mWho,n=!i.castle||this.check||this.castled[s]?null:[],o=-1,h=this.pieces.length,c=0;c<h;c++){var p=this.pieces[c];if(!(p.p<0||p.s!=s)){var l=t.g.pTypes[p.t];l.isKing&&(p.m?n=null:o=p),n&&l.castle&&!p.m&&n.push(p);var u,b;u=l.graph[p.p],b=u.length;for(var v=0;v<b;v++)for(var f=u[v],g=!1,d=f.length,m=null,G=0;G<d;G++){var y=f[G],M=65535&y,C=this.board[M];if(!(C<0)||l.epCatch&&this.epTarget&&this.epTarget.p==M){if(!(524288&y)){var S;S=C<0?this.pieces[this.epTarget.i]:this.pieces[C],!(S.s!=p.s&&131072&y)||1048576&y&&!t.g.pTypes[S.t].isKing||2097152&y&&t.g.pTypes[S.t].isKing||e(p,{f:p.p,t:M,c:S.i,a:l.abbrev,ep:C<0});break}if(g){var S=this.pieces[C];S.s!=p.s&&e(p,{f:p.p,t:M,c:S.i,a:l.abbrev});break}g=!0}else 65536&y&&0==g&&e(p,{f:p.p,t:M,c:null,a:l.abbrev,ept:null!=m&&l.epTarget?m:void 0});m=M}}}if(n)for(var c=0;c<n.length;c++){var k=n[c],A=t.cbVar.castle[o.p+"/"+k.p];if(A){for(var T=!0,v=0;v<A.r.length;v++){var z=A.r[v];if(this.board[z]>=0&&z!=o.p&&z!=k.p){T=!1;break}}if(T){for(var E=!0,v=0;v<A.k.length;v++){var z=A.k[v];if(this.board[z]>=0&&z!=k.p&&z!=o.p||this.cbGetAttackers(t,z,s).length>0){E=!1;break}}E&&a.push({f:o.p,t:A.k[A.k.length-1],c:null,cg:k.p})}}}return a},Model.Board.cbStaticExchangeEval=function(t,e,r,a){var i=0,s=this.cbGetSmallestAttacker(t,e,r);if(s){var n=this.mWho;this.mWho=s.s;var o=this.cbQuickApply(t,{f:s.p,t:e,c:a.piece.i}),h=t.g.pTypes[a.piece.t].value;a.piece=s,i=Math.max(0,h-this.cbStaticExchangeEval(t,e,-r,a)),this.cbQuickUnapply(t,o),this.mWho=n}return i},Model.Board.cbGetSmallestAttacker=function(t,e,r){var a=this.cbGetAttackers(t,e,r);if(0==a.length)return null;for(var i=1/0,s=null,n=a.length,o=0;o<n;o++){var h=a[o],c=t.g.pTypes[h.t].value;c<i&&(i=c,s=h)}return s},Model.Board.cbCollectAttackers=function(t,e,r,a){for(var i in e){var s=e[i],n=this.board[i];if(n<0)this.cbCollectAttackers(t,s.e,r,a);else{var o=this.pieces[n];o.s==-t&&(s.t&&o.t in s.t||a&&s.tk&&o.t in s.tk)&&r.push(o)}}},Model.Board.cbCollectAttackersScreen=function(t,e,r,a,i){for(var s in e){var n=e[s],o=this.board[s];if(o<0)this.cbCollectAttackersScreen(t,n.e,r,a,i);else{var h=this.pieces[o];!i&&h.s==-t&&(n.t&&h.t in n.t||a&&n.tk&&h.t in n.tk)?r.push(h):i?i&&h.s==-t&&n.ts&&h.t in n.ts&&r.push(h):this.cbCollectAttackersScreen(t,n.e,r,a,!0)}}},Model.Board.cbGetAttackers=function(t,e,r,a){var i=[];return t.cbUseScreenCapture?this.cbCollectAttackersScreen(r,t.g.threatGraph[r][e],i,a,!1):this.cbCollectAttackers(r,t.g.threatGraph[r][e],i,a),i},Model.Board.GenerateMoves=function(t){var e=this.cbGeneratePseudoLegalMoves(t);this.mMoves=[];for(var r=!0,a=this.kings[this.mWho],i=e.length,s=0;s<i;s++){var n=e[s],o=this.cbQuickApply(t,n);if(!(this.cbGetAttackers(t,this.kings[this.mWho],this.mWho,!0).length>0)){var h=this.cbGetAttackers(t,this.kings[-this.mWho],-this.mWho,!0).length>0;n.ck=h,this.mMoves.push(n),n.f!=a&&(r=!1)}this.cbQuickUnapply(t,o)}if(0==this.mMoves.length)this.mFinished=!0,this.mWinner=t.cbOnStaleMate?t.cbOnStaleMate*this.mWho:JocGame.DRAW,this.check&&(this.mWinner=-this.mWho);else if(this.ending[this.mWho]){if(!r)for(var s=0;s<this.mMoves.length;s++)this.mMoves[s].ko=!1}else if(!this.ending[this.mWho]&&r&&!this.check)for(var s=0;s<this.mMoves.length;s++)this.mMoves[s].ko=!0},Model.Board.GetSignature=function(){return this.zSign},Model.Move.Init=function(t){for(var e in t)t.hasOwnProperty(e)&&(this[e]=t[e])},Model.Move.Equals=function(t){return this.f==t.f&&this.t==t.t&&this.pr==t.pr},Model.Move.CopyFrom=function(t){this.Init(t)},Model.Move.ToString=function(e){var r=this;switch(e=e||"natural"){case"natural":return function(){var e;if(void 0!==r.cg?e=t.castle[r.f+"/"+r.cg].n:(e=r.a||"",e+=t.geometry.PosName(r.f),null==r.c?e+="-":e+="x",e+=t.geometry.PosName(r.t)),void 0!==r.pr){var a=t.pieceTypes[r.pr];a&&a.abbrev&&a.abbrev.length>0&&!a.silentPromo&&(e+="="+a.abbrev)}return r.ck&&(e+="+"),e}();case"engine":return function(){var e=t.geometry.PosName(r.f)+t.geometry.PosName(r.t);if(void 0!=r.pr){var a=t.pieceTypes[r.pr];a&&a.abbrev&&a.abbrev.length>0&&!a.silentPromo&&(e+=a.abbrev)}return e}();default:return"??"}},Model.Board.CompactMoveString=function(e,r,a){"function"!=typeof r.ToString&&(r=e.CreateMove(r));var i=r.ToString(),s=/^([A-Z]?)([a-z])([1-9][0-9]*)([-x])([a-z])([1-9][0-9]*)(.*?)$/.exec(i);if(!s)return i;var n=s[7];if(a||(a={}),a.value||(a.value=[]),0==a.value.length){var o=this.mMoves;this.mMoves&&0!=this.mMoves.length||this.GenerateMoves(e);for(var h=0;h<this.mMoves.length;h++){var c=this.mMoves[h];"function"!=typeof c.ToString&&(c=e.CreateMove(c)),a.value.push({str:c.ToString(),move:c})}this.mMoves=o}var p=[];if(a.value.forEach(function(t){var e=/^([A-Z]?[a-z][1-9][0-9]*[-x][a-z][1-9][0-9]*)(.*?)$/.exec(t.str);e&&t.move.t==r.t&&(t.move.a||"")==s[1]&&e[2]==n&&p.push(t.move)}),1==p.length)return""==s[1]&&"x"==s[4]?s[2]+"x"+s[5]+s[6]+s[7]:s[1]+("x"==s[4]?"x":"")+s[5]+s[6]+s[7];if(t.geometry.CompactCrit)for(var l="",h=0;;h++){var u=t.geometry.CompactCrit(r.f,h);if(null==u)return i;l+=u;for(var b=[],v=0;v<p.length;v++){var f=p[v];t.geometry.CompactCrit(f.f,h)==u&&b.push(f)}if(console.assert(b.length>0),1==b.length)return s[1]+l+("x"==s[4]?"x":"")+s[5]+s[6]+s[7];p=b}return i},Model.Board.cbIntegrity=function(t){function e(t,e){t||console.error(e)}for(var r=this,a=0;a<this.board.length;a++){var i=this.board[a];if(i>=0){var s=r.pieces[i];e(void 0!==s,"no piece at pos"),e(s.p==a,"piece has different pos")}}for(var i=0;i<this.pieces.length;i++){var s=this.pieces[i];s.p>=0&&e(r.board[s.p]==i,"board index mismatch")}},Model.Board.ExportBoardState=function(t){return t.cbVar.geometry.ExportBoardState?t.cbVar.geometry.ExportBoardState(this,t.cbVar,t.mPlayedMoves.length):"not supported"},Model.Game.Import=function(e,r){var a,i=[],s={1:{},"-1":{}},n=null,o=0;if("pjn"==e){var h={status:!1,error:"parse"},c=r.split(" ");if(6!=c.length)return console.warn("FEN should have 6 parts"),h;var p=c[0].split("/"),l=t.geometry.fenHeight||t.geometry.height;if(p.length!=l)return console.warn("FEN board should have",l,"rows, got",p.length),h;var u={};for(var b in t.pieceTypes){var v=t.pieceTypes[b],f=v.fenAbbrev||v.abbrev||"X";u[f.toUpperCase()]={s:1,t:b},u[f.toLowerCase()]={s:-1,t:b}}var g=t.geometry.FenRowPos||function(e,r){return(t.geometry.height-1-e)*t.geometry.width+r};if(p.forEach(function(e,r){for(var a=0,s=0;s<e.length;s++){var n=e.substr(s,1),o=u[n];if(void 0!==o){var c=g(r,a);a++;for(var p={s:o.s,t:o.t,p:c},l=!0,b=t.pieceTypes[p.t].initial||[],v=0;v<b.length;v++){var f=b[v];f.s==p.s&&f.p==c&&(l=!1)}p.m=l,i.push(p)}else{if(isNaN(parseInt(n)))return console.warn("FEN invalid board spec",n),h;a+=parseInt(n)}}}),i.sort(function(t,e){return e.s-t.s}),"w"==c[1])a=1;else{if("b"!=c[1])return console.warn("FEN invalid turn spec",c[1]),h;a=-1}s[1].k=c[2].indexOf("K")>=0,s[1].q=c[2].indexOf("Q")>=0,s[-1].k=c[2].indexOf("k")>=0,s[-1].q=c[2].indexOf("q")>=0,n="-"==c[3]?null:c[3];var d=parseInt(c[4]);isNaN(d)||(o=d);var m={pieces:i,turn:a,castle:s,enPassant:n,noCaptCount:o};return t.importGame&&t.importGame.call(this,m,e,r),{status:!0,initial:m}}return{status:!1,error:"unsupported"}}}(),function(){Model.Game.cbBoardGeometryGrid=function(t,e){function r(e){return e%t}function a(e){return Math.floor(e/t)}function i(e,r){return r*t+e}function s(s,n){var o=r(s),h=a(s),c=o+n[0],p=h+n[1];return c<0||c>=t||p<0||p>=e?null:i(c,p)}function n(t){return String.fromCharCode("a".charCodeAt(0)+r(t))+(a(t)+1)}function o(t){var e=/^([a-z])([0-9]+)$/.exec(t);return e?i(e[1].charCodeAt(0)-"a".charCodeAt(0),parseInt(e[2])-1):-1}function h(t,e){return 0==e?String.fromCharCode("a".charCodeAt(0)+r(t)):1==e?a(t)+1:null}function c(){for(var i=[],s=0;s<t*e;s++){var n=[];i.push(n);for(var o=0;o<t*e;o++){var h=a(s),c=r(s),p=a(o),l=r(o);n.push(Math.max(Math.abs(h-p),Math.abs(c-l)))}}return i}function p(r,a,s){for(var o=[],h=e-1;h>=0;h--){for(var c="",p=0,l=0;l<t;l++){var u=r.board[i(l,h)];if(u<0)p++;else{p>0&&(c+=p,p=0);var b=r.pieces[u],v=a.pieceTypes[b.t].fenAbbrev||a.pieceTypes[b.t].abbrev||"?";b.s==-1?c+=v.toLowerCase():c+=v.toUpperCase()}}p&&(c+=p),o.push(c)}var f=o.join("/");f+=" ",1==r.mWho?f+="w":f+="b",f+=" ";var g="";return r.castled&&(r.castled[1]===!1?g+="KQ":(r.castled[1].k&&(g+="K"),r.castled[1].q&&(g+="Q")),r.castled[-1]===!1?g+="kq":(r.castled[-1].k&&(g+="k"),r.castled[-1].q&&(g+="q"))),0==g.length&&(g="-"),f+=g,f+=" ",r.epTarget?f+=n(r.epTarget.p):f+="-",f+=" ",f+=r.noCaptCount,f+=" ",f+=Math.floor(s/2)+1}return{boardSize:t*e,width:t,height:e,C:r,R:a,POS:i,Graph:s,PosName:n,PosByName:o,CompactCrit:h,GetDistances:c,distEdge:function(){for(var i=[],s=0;s<t*e;s++){var n=r(s),o=a(s);i[s]=Math.min(n,Math.abs(t-n-1),o,Math.abs(e-o-1))}return i}(),corners:function(){var r={};return r[i(0,0)]=1,r[i(0,e-1)]=1,r[i(t-1,0)]=1,r[i(t-1,e-1)]=1,r}(),ExportBoardState:p}},Model.Game.cbPawnGraph=function(t,e,r){for(var a=this,i={},s=0;s<t.boardSize;s++)if(!r||s in r){var n=[],o=t.Graph(s,[0,e]);null!=o&&(!r||o in r)&&n.push(a.cbTypedArray([o|a.cbConstants.FLAG_MOVE])),[-1,1].forEach(function(i){var o=t.Graph(s,[i,e]);null!=o&&(!r||o in r)&&n.push(a.cbTypedArray([o|a.cbConstants.FLAG_CAPTURE]))}),i[s]=n}else i[s]=[];return i},Model.Game.cbInitialPawnGraph=function(t,e,r){for(var a=this,i={},s=0;s<t.boardSize;s++)if(!r||s in r){var n=[],o=t.Graph(s,[0,e]);if(null!=o&&(!r||o in r)){var h=[o|a.cbConstants.FLAG_MOVE],c=t.Graph(o,[0,e]);null!=c&&(!r||c in r)&&h.push(c|a.cbConstants.FLAG_MOVE),n.push(a.cbTypedArray(h))}[-1,1].forEach(function(i){var o=t.Graph(s,[i,e]);null!=o&&(!r||o in r)&&n.push(a.cbTypedArray([o|a.cbConstants.FLAG_CAPTURE]))}),i[s]=n}else i[s]=[];return i},Model.Game.cbKingGraph=function(t,e){return this.cbShortRangeGraph(t,[[-1,-1],[-1,0],[-1,1],[0,-1],[0,1],[1,-1],[1,0],[1,1]],e)},Model.Game.cbKnightGraph=function(t,e){return this.cbShortRangeGraph(t,[[2,-1],[2,1],[-2,-1],[-2,1],[-1,2],[-1,-2],[1,2],[1,-2]],e)},Model.Game.cbHorseGraph=function(t){for(var e=this,r={},a=0;a<t.boardSize;a++)r[a]=[],[[1,0,2,-1],[1,0,2,1],[-1,0,-2,-1],[-1,0,-2,1],[0,1,-1,2],[0,-1,-1,-2],[0,1,1,2],[0,-1,1,-2]].forEach(function(i){var s=t.Graph(a,[i[0],i[1]]);if(null!=s){var n=t.Graph(a,[i[2],i[3]]);null!=n&&r[a].push(e.cbTypedArray([s|e.cbConstants.FLAG_STOP,n|e.cbConstants.FLAG_MOVE|e.cbConstants.FLAG_CAPTURE]))}});return r},Model.Game.cbRookGraph=function(t,e){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0]],e)},Model.Game.cbBishopGraph=function(t,e){return this.cbLongRangeGraph(t,[[1,-1],[1,1],[-1,1],[-1,-1]],e)},Model.Game.cbQueenGraph=function(t,e){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0],[1,-1],[1,1],[-1,1],[-1,-1]],e)},Model.Game.cbXQGeneralGraph=function(t,e){for(var r=this,a={},i=0;i<t.boardSize;i++)a[i]=[],[[-1,0,!1],[0,-1,!0],[0,1,!0],[1,0,!1]].forEach(function(s){var n=[],o=t.Graph(i,s);if(null!=o&&((!e||o in e)&&n.push(o|r.cbConstants.FLAG_MOVE|r.cbConstants.FLAG_CAPTURE),s[2]))for(var h=t.Graph(o,s);null!=h;)!e||h in e?n.push(h|r.cbConstants.FLAG_CAPTURE|r.cbConstants.FLAG_CAPTURE_KING):n.push(h|r.cbConstants.FLAG_STOP),h=t.Graph(h,s);n.length>0&&a[i].push(r.cbTypedArray(n))});return a},Model.Game.cbXQSoldierGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e]])},Model.Game.cbXQPromoSoldierGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e],[-1,0],[1,0]])},Model.Game.cbXQAdvisorGraph=function(t,e){return this.cbShortRangeGraph(t,[[1,1],[-1,1],[1,-1],[-1,-1]],e)},Model.Game.cbXQCannonGraph=function(t){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0]],null,this.cbConstants.FLAG_MOVE|this.cbConstants.FLAG_SCREEN_CAPTURE)},Model.Game.cbXQElephantGraph=function(t,e){for(var r=this,a={},i=0;i<t.boardSize;i++)a[i]=[],(!e||i in e)&&[[1,1,2,2],[1,-1,2,-2],[-1,1,-2,2],[-1,-1,-2,-2]].forEach(function(s){var n=t.Graph(i,[s[0],s[1]]);if(null!=n){var o=t.Graph(i,[s[2],s[3]]);null!=o&&(!e||o in e)&&a[i].push(r.cbTypedArray([n|r.cbConstants.FLAG_STOP,o|r.cbConstants.FLAG_MOVE|r.cbConstants.FLAG_CAPTURE]))}});return a},Model.Game.cbSilverGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e],[-1,-1],[-1,1],[1,-1],[1,1]])},Model.Game.cbFersGraph=function(t,e){return this.cbShortRangeGraph(t,[[-1,-1],[-1,1],[1,-1],[1,1]])},Model.Game.cbSchleichGraph=function(t,e){return this.cbShortRangeGraph(t,[[-1,0],[1,0],[0,-1],[0,1]])},Model.Game.cbAlfilGraph=function(t,e){return this.cbShortRangeGraph(t,[[-2,-2],[-2,2],[2,2],[2,-2]])}}(),function(){var t=Model.Game.cbBoardGeometryGrid(8,8);Model.Game.cbDefine=function(){return{geometry:t,pieceTypes:{0:{name:"pawn-w",aspect:"fr-pawn",graph:this.cbPawnGraph(t,1),value:1.4,abbrev:"",fenAbbrev:"P",epCatch:!0},1:{name:"ipawn-w",aspect:"fr-pawn",graph:this.cbInitialPawnGraph(t,1),value:1.4,abbrev:"",fenAbbrev:"P",initial:[{s:1,p:8},{s:1,p:9},{s:1,p:10},{s:1,p:11},{s:1,p:12},{s:1,p:13},{s:1,p:14},{s:1,p:15}],epTarget:!0},2:{name:"pawn-b",aspect:"fr-pawn",graph:this.cbPawnGraph(t,-1),value:1.4,abbrev:"",fenAbbrev:"P",epCatch:!0},3:{name:"ipawn-b",aspect:"fr-pawn",graph:this.cbInitialPawnGraph(t,-1),value:1.4,abbrev:"",fenAbbrev:"P",initial:[{s:-1,p:48},{s:-1,p:49},{s:-1,p:50},{s:-1,p:51},{s:-1,p:52},{s:-1,p:53},{s:-1,p:54},{s:-1,p:55}],epTarget:!0},4:{name:"knight",aspect:"fr-knight",graph:this.cbKnightGraph(t),value:2.9,abbrev:"N",initial:[{s:1,p:1},{s:-1,p:57}]},5:{name:"bishop",aspect:"fr-bishop",graph:this.cbBishopGraph(t),value:3.4,abbrev:"B",initial:[{s:1,p:2},{s:-1,p:58}]},6:{name:"rook",aspect:"fr-rook",graph:this.cbRookGraph(t),value:5,abbrev:"R",initial:[{s:1,p:7},{s:-1,p:63}],castle:!0},7:{name:"queen",aspect:"fr-queen",graph:this.cbQueenGraph(t),value:8.2,abbrev:"Q",initial:[{s:1,p:5},{s:-1,p:61}]},8:{name:"king",aspect:"fr-king",isKing:!0,graph:this.cbKingGraph(t),abbrev:"K",initial:[{s:1,p:4},{s:-1,p:60}]},9:{name:"amazon",aspect:"fr-amazon",graph:this.cbMergeGraphs(t,this.cbQueenGraph(t),this.cbKnightGraph(t)),value:11,abbrev:"A",initial:[{s:1,p:3},{s:-1,p:59}]},10:{name:"empress",aspect:"fr-marshall",graph:this.cbMergeGraphs(t,this.cbRookGraph(t),this.cbKnightGraph(t)),value:7.8,abbrev:"E",initial:[{s:1,p:0},{s:-1,p:56}],castle:!0},11:{name:"princess",aspect:"fr-cardinal",graph:this.cbMergeGraphs(t,this.cbBishopGraph(t),this.cbKnightGraph(t)),value:6.3,abbrev:"Pr",initial:[{s:1,p:6},{s:-1,p:62}]}},promote:function(e,r,a){return 1==r.t?[0]:3==r.t?[2]:0==r.t&&7==t.R(a.t)?[4,5,6,7,9,10,11]:2==r.t&&0==t.R(a.t)?[4,5,6,7,9,10,11]:[]},castle:{"4/0":{k:[3,2],r:[1,2,3],n:"O-O-O"},"4/7":{k:[5,6],r:[6,5],n:"O-O"},"60/56":{k:[59,58],r:[57,58,59],n:"O-O-O"},"60/63":{k:[61,62],r:[62,61],n:"O-O"}}}}}();

/***/ }),

/***/ "cWuS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("3j3K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_common__ = __webpack_require__("2Je8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_dock_monitor_index__ = __webpack_require__("4VA+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_log_monitor_index__ = __webpack_require__("JUgO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_store_log_monitor__ = __webpack_require__("9r1b");
/* unused harmony reexport useLogMonitor */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StoreLogMonitorModule; });





var StoreLogMonitorModule = (function () {
    function StoreLogMonitorModule() {
    }
    StoreLogMonitorModule.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{
                    imports: [
                        __WEBPACK_IMPORTED_MODULE_1__angular_common__["CommonModule"],
                        __WEBPACK_IMPORTED_MODULE_2__src_dock_monitor_index__["a" /* DockMonitorModule */],
                        __WEBPACK_IMPORTED_MODULE_3__src_log_monitor_index__["a" /* LogMonitorModule */]
                    ],
                    declarations: [
                        __WEBPACK_IMPORTED_MODULE_4__src_store_log_monitor__["a" /* StoreLogMonitorComponent */]
                    ],
                    exports: [
                        __WEBPACK_IMPORTED_MODULE_4__src_store_log_monitor__["a" /* StoreLogMonitorComponent */]
                    ]
                },] },
    ];
    /** @nocollapse */
    StoreLogMonitorModule.ctorParameters = [];
    return StoreLogMonitorModule;
}());

//# sourceMappingURL=index.js.map

/***/ }),

/***/ "cXjt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__flexbox_index__ = __webpack_require__("L5US");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__flexbox_index__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__media_query_index__ = __webpack_require__("5aXj");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_index__ = __webpack_require__("o7Xg");
/* unused harmony namespace reexport */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */



//# sourceMappingURL=index.js.map

/***/ }),

/***/ "cbuX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var OuterSubscriber_1 = __webpack_require__("wAkD");
var subscribeToResult_1 = __webpack_require__("CURp");
/**
 * Converts a higher-order Observable into a first-order Observable which
 * concurrently delivers all values that are emitted on the inner Observables.
 *
 * <span class="informal">Flattens an Observable-of-Observables.</span>
 *
 * <img src="./img/mergeAll.png" width="100%">
 *
 * `mergeAll` subscribes to an Observable that emits Observables, also known as
 * a higher-order Observable. Each time it observes one of these emitted inner
 * Observables, it subscribes to that and delivers all the values from the
 * inner Observable on the output Observable. The output Observable only
 * completes once all inner Observables have completed. Any error delivered by
 * a inner Observable will be immediately emitted on the output Observable.
 *
 * @example <caption>Spawn a new interval Observable for each click event, and blend their outputs as one Observable</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000));
 * var firstOrder = higherOrder.mergeAll();
 * firstOrder.subscribe(x => console.log(x));
 *
 * @example <caption>Count from 0 to 9 every second for each click, but only allow 2 concurrent timers</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000).take(10));
 * var firstOrder = higherOrder.mergeAll(2);
 * firstOrder.subscribe(x => console.log(x));
 *
 * @see {@link combineAll}
 * @see {@link concatAll}
 * @see {@link exhaust}
 * @see {@link merge}
 * @see {@link mergeMap}
 * @see {@link mergeMapTo}
 * @see {@link mergeScan}
 * @see {@link switch}
 * @see {@link zipAll}
 *
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of inner
 * Observables being subscribed to concurrently.
 * @return {Observable} An Observable that emits values coming from all the
 * inner Observables emitted by the source Observable.
 * @method mergeAll
 * @owner Observable
 */
function mergeAll(concurrent) {
    if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
    return this.lift(new MergeAllOperator(concurrent));
}
exports.mergeAll = mergeAll;
var MergeAllOperator = (function () {
    function MergeAllOperator(concurrent) {
        this.concurrent = concurrent;
    }
    MergeAllOperator.prototype.call = function (observer, source) {
        return source.subscribe(new MergeAllSubscriber(observer, this.concurrent));
    };
    return MergeAllOperator;
}());
exports.MergeAllOperator = MergeAllOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var MergeAllSubscriber = (function (_super) {
    __extends(MergeAllSubscriber, _super);
    function MergeAllSubscriber(destination, concurrent) {
        _super.call(this, destination);
        this.concurrent = concurrent;
        this.hasCompleted = false;
        this.buffer = [];
        this.active = 0;
    }
    MergeAllSubscriber.prototype._next = function (observable) {
        if (this.active < this.concurrent) {
            this.active++;
            this.add(subscribeToResult_1.subscribeToResult(this, observable));
        }
        else {
            this.buffer.push(observable);
        }
    };
    MergeAllSubscriber.prototype._complete = function () {
        this.hasCompleted = true;
        if (this.active === 0 && this.buffer.length === 0) {
            this.destination.complete();
        }
    };
    MergeAllSubscriber.prototype.notifyComplete = function (innerSub) {
        var buffer = this.buffer;
        this.remove(innerSub);
        this.active--;
        if (buffer.length > 0) {
            this._next(buffer.shift());
        }
        else if (this.active === 0 && this.hasCompleted) {
            this.destination.complete();
        }
    };
    return MergeAllSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
exports.MergeAllSubscriber = MergeAllSubscriber;
//# sourceMappingURL=mergeAll.js.map

/***/ }),

/***/ "cdmN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var root_1 = __webpack_require__("VOfZ");
function symbolIteratorPonyfill(root) {
    var Symbol = root.Symbol;
    if (typeof Symbol === 'function') {
        if (!Symbol.iterator) {
            Symbol.iterator = Symbol('iterator polyfill');
        }
        return Symbol.iterator;
    }
    else {
        // [for Mozilla Gecko 27-35:](https://mzl.la/2ewE1zC)
        var Set_1 = root.Set;
        if (Set_1 && typeof new Set_1()['@@iterator'] === 'function') {
            return '@@iterator';
        }
        var Map_1 = root.Map;
        // required for compatability with es6-shim
        if (Map_1) {
            var keys = Object.getOwnPropertyNames(Map_1.prototype);
            for (var i = 0; i < keys.length; ++i) {
                var key = keys[i];
                // according to spec, Map.prototype[@@iterator] and Map.orototype.entries must be equal.
                if (key !== 'entries' && key !== 'size' && Map_1.prototype[key] === Map_1.prototype['entries']) {
                    return key;
                }
            }
        }
        return '@@iterator';
    }
}
exports.symbolIteratorPonyfill = symbolIteratorPonyfill;
exports.iterator = symbolIteratorPonyfill(root_1.root);
/**
 * @deprecated use iterator instead
 */
exports.$$iterator = exports.iterator;
//# sourceMappingURL=iterator.js.map

/***/ }),

/***/ "chfF":
/***/ (function(module, exports) {

exports.model=Model={Game:{},Board:{},Move:{}},function(){var t;Model.Game.cbConstants={MASK:65535,FLAG_MOVE:65536,FLAG_CAPTURE:131072,FLAG_STOP:262144,FLAG_SCREEN_CAPTURE:524288,FLAG_CAPTURE_KING:1048576,FLAG_CAPTURE_NO_KING:2097152};var e="undefined"!=typeof Int32Array;Model.Game.cbUseTypedArrays=e,Model.Game.cbTypedArray=function(t){if(e){var r=new Int32Array(t.length);return r.set(t),r}for(var i=[],a=t.length,n=0;n<a;n++)i.push(t[n]);return i},Model.Game.cbShortRangeGraph=function(t,e,r,i){var a=this;void 0===i&&(i=196608);for(var n={},s=0;s<t.boardSize;s++)n[s]=[],(!r||s in r)&&e.forEach(function(e){var o=t.Graph(s,e);null!=o&&(!r||o in r)&&n[s].push(a.cbTypedArray([o|i]))});return n},Model.Game.cbLongRangeGraph=function(t,e,r,i,a){var n=this;void 0!==i&&null!=i||(i=196608),a||(a=1/0);for(var s={},o=0;o<t.boardSize;o++)s[o]=[],(!r||o in r)&&e.forEach(function(e){for(var h=[],c=t.Graph(o,e),p=0;null!=c&&(!r||c in r)&&(h.push(c|i),++p!=a);)c=t.Graph(c,e);h.length>0&&s[o].push(n.cbTypedArray(h))});return s},Model.Game.cbNullGraph=function(t){for(var e={},r=0;r<t.boardSize;r++)e[r]=[];return e},Model.Game.cbAuthorGraph=function(t){for(var e={},r=0;r<t.boardSize;r++){e[r]=[];for(var i=0;i<t.boardSize;i++)e[r].push([2293760|i])}return e},Model.Game.cbMergeGraphs=function(t){for(var e=[],r=0;r<t.boardSize;r++){e[r]=[];for(var i=1;i<arguments.length;i++)e[r]=e[r].concat(arguments[i][r])}return e},Model.Game.cbGetThreatGraph=function(){function t(e,r){for(var i in s){var a=s[i];if(!(a.p.length<r.length+1)){for(var n=!0,o=0;o<r.length;o++)if(r[o]!=a.p[o]){n=!1;break}if(n){var h=a.p[r.length],c=e[h];void 0===c&&(c={e:{}},e[h]=c),a.p.length==r.length+1&&(c.t=a.t,c.ts=a.ts,c.tk=a.tk,delete s[i]),r.push(h),t(c.e,r),r.pop()}}}}var e=this;this.cbUseScreenCapture=!1,this.cbUseCaptureKing=!1,this.cbUseCaptureNoKing=!1;for(var r={1:[],"-1":[]},i=[],a=0;a<this.g.boardSize;a++)this.g.pTypes.forEach(function(t,r){t.graph[a].forEach(function(t){for(var n=[],s=0;s<t.length;s++){var o=t[s];1048576&o?(e.cbUseCaptureKing=!0,n.unshift({d:65535&o,a:a,tk:r})):2097152&o?(e.cbUseCaptureNoKing=!0,n.unshift({d:65535&o,a:a,tnk:r})):131072&o?n.unshift({d:65535&o,a:a,t:r}):262144&o?n.unshift({d:65535&o,a:a}):524288&o&&(e.cbUseScreenCapture=!0,n.unshift({d:65535&o,a:a,ts:r}))}n.length>0&&i.push(n)})});var n={};i.forEach(function(t){t.forEach(function(e,r){var i=n[e.d];void 0===i&&(i={},n[e.d]=i);for(var a=[],s=r+1;s<t.length;s++)a.push(t[s].d);a.push(e.a);var o=a.join(","),h=i[o];void 0===h&&(h={p:a,t:{},ts:{},tk:{}},i[o]=h),void 0!==e.t?h.t[e.t]=!0:void 0!==e.tk?h.tk[e.tk]=!0:void 0!==e.ts&&(h.ts[e.ts]=!0)})});for(var a=0;a<e.g.boardSize;a++){var s=n[a],o={};t(o,[]),r[1][a]=o,r[-1][a]=o}return r},Model.Game.InitGame=function(){var e=this;this.cbVar=t=this.cbDefine(),this.g.boardSize=this.cbVar.geometry.boardSize,this.g.pTypes=this.cbGetPieceTypes(),this.g.threatGraph=this.cbGetThreatGraph(),this.g.distGraph=this.cbVar.geometry.GetDistances(),this.cbPiecesCount=0,this.g.castleablePiecesCount={1:0,"-1":0};for(var r in t.pieceTypes){var i=t.pieceTypes[r];if(i.castle){(i.initial||[]).forEach(function(t){e.g.castleablePiecesCount[t.s]++})}i.initial&&(this.cbPiecesCount+=i.initial.length)}for(var a=[],r=0;r<this.cbPiecesCount;r++)a.push(r);var n=Object.keys(t.pieceTypes);this.zobrist=new JocGame.Zobrist({board:{type:"array",size:this.cbVar.geometry.boardSize,values:a},who:{values:["1","-1"]},type:{type:"array",size:this.cbPiecesCount,values:n}})},Model.Game.cbGetPieceTypes=function(){for(var t=[],e={},r=0;r<this.cbVar.geometry.boardSize;r++)e[r]=[];for(var i in this.cbVar.pieceTypes){var a=this.cbVar.pieceTypes[i];t[i]={graph:a.graph||e,abbrev:a.abbrev||"",value:a.isKing?100:a.value||1,isKing:!!a.isKing,castle:!!a.castle,epTarget:!!a.epTarget,epCatch:!!a.epCatch}}return t},Model.Board.Init=function(t){this.zSign=0},Model.Board.InitialPosition=function(r){var i=this;this.board=e?new Int16Array(r.g.boardSize):[];for(var a=0;a<r.g.boardSize;a++)this.board[a]=-1;if(this.kings={},this.pieces=[],this.ending={1:!1,"-1":!1},this.lastMove=null,r.cbVar.castle&&(this.castled={1:!1,"-1":!1}),this.zSign=r.zobrist.update(0,"who",-1),this.noCaptCount=0,this.mWho=1,r.mInitial)this.mWho=r.mInitial.turn||1,r.mInitial.pieces.forEach(function(t){var e={};for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);i.pieces.push(e)}),r.mInitial.lastMove&&(this.lastMove={f:r.mInitial.lastMove.f,t:r.mInitial.lastMove.t}),void 0!==r.mInitial.noCaptCount&&(this.noCaptCount=r.mInitial.noCaptCount),r.cbVar.castle&&r.mInitial.castle&&(this.castled={1:{k:!!r.mInitial.castle[1]&&!!r.mInitial.castle[1].k,q:!!r.mInitial.castle[1]&&!!r.mInitial.castle[1].q},"-1":{k:!!r.mInitial.castle[-1]&&!!r.mInitial.castle[-1].k,q:!!r.mInitial.castle[-1]&&!!r.mInitial.castle[-1].q}});else for(var n in r.cbVar.pieceTypes)for(var s=r.cbVar.pieceTypes[n],o=s.initial||[],h=0;h<o.length;h++){var c=o[h],p={s:c.s,t:parseInt(n),p:c.p,m:!1};this.pieces.push(p)}if(this.pieces.sort(function(t,e){if(t.s!=e.s)return e.s-t.s;var i=r.cbVar.pieceTypes[t.t].value||100,a=r.cbVar.pieceTypes[e.t].value||100;return i!=a?i-a:t.p-e.p}),this.pieces.forEach(function(t,e){t.i=e,i.board[t.p]=e,r.g.pTypes[t.t].isKing&&(i.kings[t.s]=t.p),i.zSign=r.zobrist.update(i.zSign,"board",e,t.p),i.zSign=r.zobrist.update(i.zSign,"type",t.t,e)}),r.mInitial&&r.mInitial.enPassant){var a=t.geometry.PosByName(r.mInitial.enPassant);if(a>=0){var l,u=t.geometry.C(a),v=t.geometry.R(a);l=1==r.mInitial.turn?t.geometry.POS(u,v-1):t.geometry.POS(u,v+1),this.epTarget={p:a,i:this.board[l]}}}},Model.Board.CopyFrom=function(t){if(e)this.board=new Int16Array(t.board.length),this.board.set(t.board);else{this.board=[];for(var r=t.board,i=r.length,a=0;a<i;a++)this.board.push(r[a])}this.pieces=[];for(var n=t.pieces.length,a=0;a<n;a++){var s=t.pieces[a];this.pieces.push({s:s.s,p:s.p,t:s.t,i:s.i,m:s.m})}this.kings={1:t.kings[1],"-1":t.kings[-1]},this.check=t.check,t.lastMove?this.lastMove={f:t.lastMove.f,t:t.lastMove.t,c:t.lastMove.c}:this.lastMove=null,this.ending={1:t.ending[1],"-1":t.ending[-1]},void 0!==t.castled&&(this.castled={1:t.castled[1],"-1":t.castled[-1]}),this.noCaptCount=t.noCaptCount,t.epTarget?this.epTarget={p:t.epTarget.p,i:t.epTarget.i}:this.epTarget=null,this.mWho=t.mWho,this.zSign=t.zSign},Model.Board.cbApplyCastle=function(t,e,r){var i=t.cbVar.castle[e.f+"/"+e.cg],a=i.r[i.r.length-1],n=this.pieces[this.board[e.cg]],s=i.k[i.k.length-1],o=this.pieces[this.board[e.f]];return r&&(this.zSign=t.zobrist.update(this.zSign,"board",n.i,e.cg),this.zSign=t.zobrist.update(this.zSign,"board",n.i,a),this.zSign=t.zobrist.update(this.zSign,"board",o.i,e.f),this.zSign=t.zobrist.update(this.zSign,"board",o.i,s)),n.p=a,n.m=!0,this.board[e.cg]=-1,o.p=s,o.m=!0,this.board[e.f]=-1,this.board[a]=n.i,this.board[s]=o.i,this.castled[n.s]=!0,this.kings[o.s]=s,[{i:n.i,f:a,t:-1},{i:o.i,f:s,t:e.f,kp:e.f,who:o.s,m:!1},{i:n.i,f:-1,t:e.cg,m:!1,cg:!1}]},Model.Board.cbQuickApply=function(t,e){if(void 0!==e.cg)return this.cbApplyCastle(t,e,!1);var r=[],i=this.board[e.f],a=this.pieces[i];if(null!=e.c){r.unshift({i:e.c,f:-1,t:this.pieces[e.c].p});var n=this.pieces[e.c];this.board[n.p]=-1,n.p=-1}var s=this.kings[a.s];return t.g.pTypes[a.t].isKing&&(this.kings[a.s]=e.t),r.unshift({i:i,f:e.t,t:e.f,kp:s,who:a.s,ty:a.t}),a.p=e.t,void 0!==e.pr&&(a.t=e.pr),this.board[e.f]=-1,this.board[e.t]=i,r},Model.Board.cbQuickUnapply=function(t,e){for(var r=0;r<e.length;r++){var i=e[r],a=this.pieces[i.i];i.f>=0&&(a.p=-1,this.board[i.f]=-1),i.t>=0&&(a.p=i.t,this.board[i.t]=i.i),void 0!==i.m&&(a.m=i.m),void 0!==i.kp&&(this.kings[i.who]=i.kp),void 0!=i.ty&&(a.t=i.ty),void 0!=i.cg&&(this.castled[a.s]=i.cg)}},Model.Board.ApplyMove=function(t,e){var r=this.pieces[this.board[e.f]];if(void 0!==e.cg)this.cbApplyCastle(t,e,!0);else{if(this.zSign=t.zobrist.update(this.zSign,"board",r.i,e.f),this.board[r.p]=-1,void 0!==e.pr&&(this.zSign=t.zobrist.update(this.zSign,"type",r.t,r.i),r.t=e.pr,this.zSign=t.zobrist.update(this.zSign,"type",r.t,r.i)),null!=e.c){var i=this.pieces[e.c];this.zSign=t.zobrist.update(this.zSign,"board",i.i,i.p),this.board[i.p]=-1,i.p=-1,i.m=!0,this.noCaptCount=0}else this.noCaptCount++;r.p=e.t,r.m=!0,this.board[e.t]=r.i,this.zSign=t.zobrist.update(this.zSign,"board",r.i,e.t),t.g.pTypes[r.t].isKing&&(this.kings[r.s]=e.t)}this.check=!!e.ck,this.lastMove={f:e.f,t:e.t,c:e.c},void 0!==e.ko&&(this.ending[r.s]=e.ko),void 0!==e.ept?this.epTarget={p:e.ept,i:r.i}:this.epTarget=null,this.zSign=t.zobrist.update(this.zSign,"who",-this.mWho),this.zSign=t.zobrist.update(this.zSign,"who",this.mWho)},Model.Board.Evaluate=function(r){function i(e){var r=1/0;for(var i in t.geometry.corners)r=Math.min(r,h.distGraph[n.kings[e]][i]);return r-Math.sqrt(h.boardSize)}var a="debug"==arguments[3],n=this;this.mEvaluation=0;var s,o=this.mWho,h=r.g;if(e)s={1:{count:new Uint8Array(h.pTypes.length),byType:{}},"-1":{count:new Uint8Array(h.pTypes.length),byType:{}}};else{s={1:{count:[],byType:{}},"-1":{count:[],byType:{}}};for(var c=0;c<h.pTypes.length;c++)s[1].count[c]=s[-1].count[c]=0}if(r.mOptions.preventRepeat&&r.GetRepeatOccurence(this)>2)return this.mFinished=!0,void(this.mWinner=r.cbOnPerpetual?o*r.cbOnPerpetual:JocGame.DRAW);for(var p={1:0,"-1":0},l={1:h.distGraph[this.kings[-1]],"-1":h.distGraph[this.kings[1]]},u={1:0,"-1":0},v={1:0,"-1":0},b={1:0,"-1":0},f={1:0,"-1":0},d={1:!1,"-1":!1},g=this.pieces,m=g.length,c=0;c<m;c++){var G=g[c];if(G.p>=0){var y=G.s,M=h.pTypes[G.t];M.isKing?d[y]=G.m:p[y]+=M.value,M.castle&&!G.m&&f[y]++,v[y]++,u[y]+=l[y][G.p],b[y]+=t.geometry.distEdge[G.p];var C=s[y];C.count[G.t]++;var S=C.byType;void 0===S[G.t]?S[G.t]=[G]:S[G.t].push(G)}}if(this.lastMove&&null!=this.lastMove.c){var G=this.pieces[this.board[this.lastMove.t]];p[-G.s]+=this.cbStaticExchangeEval(r,G.p,G.s,{piece:G})}var k={1:0,"-1":0},A={1:0,"-1":0},T={1:0,"-1":0};this.ending[1]&&(A[1]=(u[1]-Math.sqrt(h.boardSize))/v[1],t.geometry.corners&&(T[1]=i(1))),this.ending[-1]&&(A[-1]=(u[-1]-Math.sqrt(h.boardSize))/v[-1],t.geometry.corners&&(T[1]=i(-1)));var z={pieceValue:p[1]-p[-1],pieceValueRatio:(p[1]-p[-1])/(p[1]+p[-1]+1),posValue:b[1]-b[-1],averageDistKing:u[1]/v[1]-u[-1]/v[-1],check:this.check?-o:0,endingKingFreedom:k[1]-k[-1],endingDistKing:A[1]-A[-1],distKingCorner:T[1]-T[-1]};t.castle&&(z.castle=(this.castled[1]?1:d[1]?0:f[1]/(h.castleablePiecesCount[1]+1))-(this.castled[-1]?1:d[-1]?0:f[-1]/(h.castleablePiecesCount[-1]+1))),t.evaluate&&t.evaluate.call(this,r,z,s);var P=r.mOptions.levelOptions;for(var E in z){var w=z[E],R=P[E+"Factor"]||0,I=w*R;a&&console.log(E,"=",w,"*",R,"=>",I),this.mEvaluation+=I}a&&console.log("Evaluation",this.mEvaluation)},Model.Board.cbGeneratePseudoLegalMoves=function(t){function e(e,a){var n=t.cbVar.promote;if(!n)return void i.push(a);var s=n.call(r,t,e,a);if(null!=s)if(0==s.length)i.push(a);else if(1==s.length)a.pr=s[0],i.push(a);else for(var o=0;o<s.length;o++){var h=s[o];i.push({f:a.f,t:a.t,c:a.c,pr:h,ept:a.ept,ep:a.ep,a:a.a})}}for(var r=this,i=[],a=t.cbVar,n=this.mWho,s=!a.castle||this.check||this.castled[n]?null:[],o=-1,h=this.pieces.length,c=0;c<h;c++){var p=this.pieces[c];if(!(p.p<0||p.s!=n)){var l=t.g.pTypes[p.t];l.isKing&&(p.m?s=null:o=p),s&&l.castle&&!p.m&&s.push(p);var u,v;u=l.graph[p.p],v=u.length;for(var b=0;b<v;b++)for(var f=u[b],d=!1,g=f.length,m=null,G=0;G<g;G++){var y=f[G],M=65535&y,C=this.board[M];if(!(C<0)||l.epCatch&&this.epTarget&&this.epTarget.p==M){if(!(524288&y)){var S;S=C<0?this.pieces[this.epTarget.i]:this.pieces[C],!(S.s!=p.s&&131072&y)||1048576&y&&!t.g.pTypes[S.t].isKing||2097152&y&&t.g.pTypes[S.t].isKing||e(p,{f:p.p,t:M,c:S.i,a:l.abbrev,ep:C<0});break}if(d){var S=this.pieces[C];S.s!=p.s&&e(p,{f:p.p,t:M,c:S.i,a:l.abbrev});break}d=!0}else 65536&y&&0==d&&e(p,{f:p.p,t:M,c:null,a:l.abbrev,ept:null!=m&&l.epTarget?m:void 0});m=M}}}if(s)for(var c=0;c<s.length;c++){var k=s[c],A=t.cbVar.castle[o.p+"/"+k.p];if(A){for(var T=!0,b=0;b<A.r.length;b++){var z=A.r[b];if(this.board[z]>=0&&z!=o.p&&z!=k.p){T=!1;break}}if(T){for(var P=!0,b=0;b<A.k.length;b++){var z=A.k[b];if(this.board[z]>=0&&z!=k.p&&z!=o.p||this.cbGetAttackers(t,z,n).length>0){P=!1;break}}P&&i.push({f:o.p,t:A.k[A.k.length-1],c:null,cg:k.p})}}}return i},Model.Board.cbStaticExchangeEval=function(t,e,r,i){var a=0,n=this.cbGetSmallestAttacker(t,e,r);if(n){var s=this.mWho;this.mWho=n.s;var o=this.cbQuickApply(t,{f:n.p,t:e,c:i.piece.i}),h=t.g.pTypes[i.piece.t].value;i.piece=n,a=Math.max(0,h-this.cbStaticExchangeEval(t,e,-r,i)),this.cbQuickUnapply(t,o),this.mWho=s}return a},Model.Board.cbGetSmallestAttacker=function(t,e,r){var i=this.cbGetAttackers(t,e,r);if(0==i.length)return null;for(var a=1/0,n=null,s=i.length,o=0;o<s;o++){var h=i[o],c=t.g.pTypes[h.t].value;c<a&&(a=c,n=h)}return n},Model.Board.cbCollectAttackers=function(t,e,r,i){for(var a in e){var n=e[a],s=this.board[a];if(s<0)this.cbCollectAttackers(t,n.e,r,i);else{var o=this.pieces[s];o.s==-t&&(n.t&&o.t in n.t||i&&n.tk&&o.t in n.tk)&&r.push(o)}}},Model.Board.cbCollectAttackersScreen=function(t,e,r,i,a){for(var n in e){var s=e[n],o=this.board[n];if(o<0)this.cbCollectAttackersScreen(t,s.e,r,i,a);else{var h=this.pieces[o];!a&&h.s==-t&&(s.t&&h.t in s.t||i&&s.tk&&h.t in s.tk)?r.push(h):a?a&&h.s==-t&&s.ts&&h.t in s.ts&&r.push(h):this.cbCollectAttackersScreen(t,s.e,r,i,!0)}}},Model.Board.cbGetAttackers=function(t,e,r,i){var a=[];return t.cbUseScreenCapture?this.cbCollectAttackersScreen(r,t.g.threatGraph[r][e],a,i,!1):this.cbCollectAttackers(r,t.g.threatGraph[r][e],a,i),a},Model.Board.GenerateMoves=function(t){var e=this.cbGeneratePseudoLegalMoves(t);this.mMoves=[];for(var r=!0,i=this.kings[this.mWho],a=e.length,n=0;n<a;n++){var s=e[n],o=this.cbQuickApply(t,s);if(!(this.cbGetAttackers(t,this.kings[this.mWho],this.mWho,!0).length>0)){var h=this.cbGetAttackers(t,this.kings[-this.mWho],-this.mWho,!0).length>0;s.ck=h,this.mMoves.push(s),s.f!=i&&(r=!1)}this.cbQuickUnapply(t,o)}if(0==this.mMoves.length)this.mFinished=!0,this.mWinner=t.cbOnStaleMate?t.cbOnStaleMate*this.mWho:JocGame.DRAW,this.check&&(this.mWinner=-this.mWho);else if(this.ending[this.mWho]){if(!r)for(var n=0;n<this.mMoves.length;n++)this.mMoves[n].ko=!1}else if(!this.ending[this.mWho]&&r&&!this.check)for(var n=0;n<this.mMoves.length;n++)this.mMoves[n].ko=!0},Model.Board.GetSignature=function(){return this.zSign},Model.Move.Init=function(t){for(var e in t)t.hasOwnProperty(e)&&(this[e]=t[e])},Model.Move.Equals=function(t){return this.f==t.f&&this.t==t.t&&this.pr==t.pr},Model.Move.CopyFrom=function(t){this.Init(t)},Model.Move.ToString=function(e){var r=this;switch(e=e||"natural"){case"natural":return function(){var e;if(void 0!==r.cg?e=t.castle[r.f+"/"+r.cg].n:(e=r.a||"",e+=t.geometry.PosName(r.f),null==r.c?e+="-":e+="x",e+=t.geometry.PosName(r.t)),void 0!==r.pr){var i=t.pieceTypes[r.pr];i&&i.abbrev&&i.abbrev.length>0&&!i.silentPromo&&(e+="="+i.abbrev)}return r.ck&&(e+="+"),e}();case"engine":return function(){var e=t.geometry.PosName(r.f)+t.geometry.PosName(r.t);if(void 0!=r.pr){var i=t.pieceTypes[r.pr];i&&i.abbrev&&i.abbrev.length>0&&!i.silentPromo&&(e+=i.abbrev)}return e}();default:return"??"}},Model.Board.CompactMoveString=function(e,r,i){"function"!=typeof r.ToString&&(r=e.CreateMove(r));var a=r.ToString(),n=/^([A-Z]?)([a-z])([1-9][0-9]*)([-x])([a-z])([1-9][0-9]*)(.*?)$/.exec(a);if(!n)return a;var s=n[7];if(i||(i={}),i.value||(i.value=[]),0==i.value.length){var o=this.mMoves;this.mMoves&&0!=this.mMoves.length||this.GenerateMoves(e);for(var h=0;h<this.mMoves.length;h++){var c=this.mMoves[h];"function"!=typeof c.ToString&&(c=e.CreateMove(c)),i.value.push({str:c.ToString(),move:c})}this.mMoves=o}var p=[];if(i.value.forEach(function(t){var e=/^([A-Z]?[a-z][1-9][0-9]*[-x][a-z][1-9][0-9]*)(.*?)$/.exec(t.str);e&&t.move.t==r.t&&(t.move.a||"")==n[1]&&e[2]==s&&p.push(t.move)}),1==p.length)return""==n[1]&&"x"==n[4]?n[2]+"x"+n[5]+n[6]+n[7]:n[1]+("x"==n[4]?"x":"")+n[5]+n[6]+n[7];if(t.geometry.CompactCrit)for(var l="",h=0;;h++){var u=t.geometry.CompactCrit(r.f,h);if(null==u)return a;l+=u;for(var v=[],b=0;b<p.length;b++){var f=p[b];t.geometry.CompactCrit(f.f,h)==u&&v.push(f)}if(console.assert(v.length>0),1==v.length)return n[1]+l+("x"==n[4]?"x":"")+n[5]+n[6]+n[7];p=v}return a},Model.Board.cbIntegrity=function(t){function e(t,e){t||console.error(e)}for(var r=this,i=0;i<this.board.length;i++){var a=this.board[i];if(a>=0){var n=r.pieces[a];e(void 0!==n,"no piece at pos"),e(n.p==i,"piece has different pos")}}for(var a=0;a<this.pieces.length;a++){var n=this.pieces[a];n.p>=0&&e(r.board[n.p]==a,"board index mismatch")}},Model.Board.ExportBoardState=function(t){return t.cbVar.geometry.ExportBoardState?t.cbVar.geometry.ExportBoardState(this,t.cbVar,t.mPlayedMoves.length):"not supported"},Model.Game.Import=function(e,r){var i,a=[],n={1:{},"-1":{}},s=null,o=0;if("pjn"==e){var h={status:!1,error:"parse"},c=r.split(" ");if(6!=c.length)return console.warn("FEN should have 6 parts"),h;var p=c[0].split("/"),l=t.geometry.fenHeight||t.geometry.height;if(p.length!=l)return console.warn("FEN board should have",l,"rows, got",p.length),h;var u={};for(var v in t.pieceTypes){var b=t.pieceTypes[v],f=b.fenAbbrev||b.abbrev||"X";u[f.toUpperCase()]={s:1,t:v},u[f.toLowerCase()]={s:-1,t:v}}var d=t.geometry.FenRowPos||function(e,r){return(t.geometry.height-1-e)*t.geometry.width+r};if(p.forEach(function(e,r){for(var i=0,n=0;n<e.length;n++){var s=e.substr(n,1),o=u[s];if(void 0!==o){var c=d(r,i);i++;for(var p={s:o.s,t:o.t,p:c},l=!0,v=t.pieceTypes[p.t].initial||[],b=0;b<v.length;b++){var f=v[b];f.s==p.s&&f.p==c&&(l=!1)}p.m=l,a.push(p)}else{if(isNaN(parseInt(s)))return console.warn("FEN invalid board spec",s),h;i+=parseInt(s)}}}),a.sort(function(t,e){return e.s-t.s}),"w"==c[1])i=1;else{if("b"!=c[1])return console.warn("FEN invalid turn spec",c[1]),h;i=-1}n[1].k=c[2].indexOf("K")>=0,n[1].q=c[2].indexOf("Q")>=0,n[-1].k=c[2].indexOf("k")>=0,n[-1].q=c[2].indexOf("q")>=0,s="-"==c[3]?null:c[3];var g=parseInt(c[4]);isNaN(g)||(o=g);var m={pieces:a,turn:i,castle:n,enPassant:s,noCaptCount:o};return t.importGame&&t.importGame.call(this,m,e,r),{status:!0,initial:m}}return{status:!1,error:"unsupported"}}}(),function(){Model.Game.cbBoardGeometryGrid=function(t,e){function r(e){return e%t}function i(e){return Math.floor(e/t)}function a(e,r){return r*t+e}function n(n,s){var o=r(n),h=i(n),c=o+s[0],p=h+s[1];return c<0||c>=t||p<0||p>=e?null:a(c,p)}function s(t){return String.fromCharCode("a".charCodeAt(0)+r(t))+(i(t)+1)}function o(t){var e=/^([a-z])([0-9]+)$/.exec(t);return e?a(e[1].charCodeAt(0)-"a".charCodeAt(0),parseInt(e[2])-1):-1}function h(t,e){return 0==e?String.fromCharCode("a".charCodeAt(0)+r(t)):1==e?i(t)+1:null}function c(){for(var a=[],n=0;n<t*e;n++){var s=[];a.push(s);for(var o=0;o<t*e;o++){var h=i(n),c=r(n),p=i(o),l=r(o);s.push(Math.max(Math.abs(h-p),Math.abs(c-l)))}}return a}function p(r,i,n){for(var o=[],h=e-1;h>=0;h--){for(var c="",p=0,l=0;l<t;l++){var u=r.board[a(l,h)];if(u<0)p++;else{p>0&&(c+=p,p=0);var v=r.pieces[u],b=i.pieceTypes[v.t].fenAbbrev||i.pieceTypes[v.t].abbrev||"?";v.s==-1?c+=b.toLowerCase():c+=b.toUpperCase()}}p&&(c+=p),o.push(c)}var f=o.join("/");f+=" ",1==r.mWho?f+="w":f+="b",f+=" ";var d="";return r.castled&&(r.castled[1]===!1?d+="KQ":(r.castled[1].k&&(d+="K"),r.castled[1].q&&(d+="Q")),r.castled[-1]===!1?d+="kq":(r.castled[-1].k&&(d+="k"),r.castled[-1].q&&(d+="q"))),0==d.length&&(d="-"),f+=d,f+=" ",r.epTarget?f+=s(r.epTarget.p):f+="-",f+=" ",f+=r.noCaptCount,f+=" ",f+=Math.floor(n/2)+1}return{boardSize:t*e,width:t,height:e,C:r,R:i,POS:a,Graph:n,PosName:s,PosByName:o,CompactCrit:h,GetDistances:c,distEdge:function(){for(var a=[],n=0;n<t*e;n++){var s=r(n),o=i(n);a[n]=Math.min(s,Math.abs(t-s-1),o,Math.abs(e-o-1))}return a}(),corners:function(){var r={};return r[a(0,0)]=1,r[a(0,e-1)]=1,r[a(t-1,0)]=1,r[a(t-1,e-1)]=1,r}(),ExportBoardState:p}},Model.Game.cbPawnGraph=function(t,e,r){for(var i=this,a={},n=0;n<t.boardSize;n++)if(!r||n in r){var s=[],o=t.Graph(n,[0,e]);null!=o&&(!r||o in r)&&s.push(i.cbTypedArray([o|i.cbConstants.FLAG_MOVE])),[-1,1].forEach(function(a){var o=t.Graph(n,[a,e]);null!=o&&(!r||o in r)&&s.push(i.cbTypedArray([o|i.cbConstants.FLAG_CAPTURE]))}),a[n]=s}else a[n]=[];return a},Model.Game.cbInitialPawnGraph=function(t,e,r){for(var i=this,a={},n=0;n<t.boardSize;n++)if(!r||n in r){var s=[],o=t.Graph(n,[0,e]);if(null!=o&&(!r||o in r)){var h=[o|i.cbConstants.FLAG_MOVE],c=t.Graph(o,[0,e]);null!=c&&(!r||c in r)&&h.push(c|i.cbConstants.FLAG_MOVE),s.push(i.cbTypedArray(h))}[-1,1].forEach(function(a){var o=t.Graph(n,[a,e]);null!=o&&(!r||o in r)&&s.push(i.cbTypedArray([o|i.cbConstants.FLAG_CAPTURE]))}),a[n]=s}else a[n]=[];return a},Model.Game.cbKingGraph=function(t,e){return this.cbShortRangeGraph(t,[[-1,-1],[-1,0],[-1,1],[0,-1],[0,1],[1,-1],[1,0],[1,1]],e)},Model.Game.cbKnightGraph=function(t,e){return this.cbShortRangeGraph(t,[[2,-1],[2,1],[-2,-1],[-2,1],[-1,2],[-1,-2],[1,2],[1,-2]],e)},Model.Game.cbHorseGraph=function(t){for(var e=this,r={},i=0;i<t.boardSize;i++)r[i]=[],[[1,0,2,-1],[1,0,2,1],[-1,0,-2,-1],[-1,0,-2,1],[0,1,-1,2],[0,-1,-1,-2],[0,1,1,2],[0,-1,1,-2]].forEach(function(a){var n=t.Graph(i,[a[0],a[1]]);if(null!=n){var s=t.Graph(i,[a[2],a[3]]);null!=s&&r[i].push(e.cbTypedArray([n|e.cbConstants.FLAG_STOP,s|e.cbConstants.FLAG_MOVE|e.cbConstants.FLAG_CAPTURE]))}});return r},Model.Game.cbRookGraph=function(t,e){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0]],e)},Model.Game.cbBishopGraph=function(t,e){return this.cbLongRangeGraph(t,[[1,-1],[1,1],[-1,1],[-1,-1]],e)},Model.Game.cbQueenGraph=function(t,e){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0],[1,-1],[1,1],[-1,1],[-1,-1]],e)},Model.Game.cbXQGeneralGraph=function(t,e){for(var r=this,i={},a=0;a<t.boardSize;a++)i[a]=[],[[-1,0,!1],[0,-1,!0],[0,1,!0],[1,0,!1]].forEach(function(n){var s=[],o=t.Graph(a,n);if(null!=o&&((!e||o in e)&&s.push(o|r.cbConstants.FLAG_MOVE|r.cbConstants.FLAG_CAPTURE),n[2]))for(var h=t.Graph(o,n);null!=h;)!e||h in e?s.push(h|r.cbConstants.FLAG_CAPTURE|r.cbConstants.FLAG_CAPTURE_KING):s.push(h|r.cbConstants.FLAG_STOP),h=t.Graph(h,n);s.length>0&&i[a].push(r.cbTypedArray(s))});return i},Model.Game.cbXQSoldierGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e]])},Model.Game.cbXQPromoSoldierGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e],[-1,0],[1,0]])},Model.Game.cbXQAdvisorGraph=function(t,e){return this.cbShortRangeGraph(t,[[1,1],[-1,1],[1,-1],[-1,-1]],e)},Model.Game.cbXQCannonGraph=function(t){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0]],null,this.cbConstants.FLAG_MOVE|this.cbConstants.FLAG_SCREEN_CAPTURE)},Model.Game.cbXQElephantGraph=function(t,e){for(var r=this,i={},a=0;a<t.boardSize;a++)i[a]=[],(!e||a in e)&&[[1,1,2,2],[1,-1,2,-2],[-1,1,-2,2],[-1,-1,-2,-2]].forEach(function(n){var s=t.Graph(a,[n[0],n[1]]);if(null!=s){var o=t.Graph(a,[n[2],n[3]]);null!=o&&(!e||o in e)&&i[a].push(r.cbTypedArray([s|r.cbConstants.FLAG_STOP,o|r.cbConstants.FLAG_MOVE|r.cbConstants.FLAG_CAPTURE]))}});return i},Model.Game.cbSilverGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e],[-1,-1],[-1,1],[1,-1],[1,1]])},Model.Game.cbFersGraph=function(t,e){return this.cbShortRangeGraph(t,[[-1,-1],[-1,1],[1,-1],[1,1]])},Model.Game.cbSchleichGraph=function(t,e){return this.cbShortRangeGraph(t,[[-1,0],[1,0],[0,-1],[0,1]])},Model.Game.cbAlfilGraph=function(t,e){return this.cbShortRangeGraph(t,[[-2,-2],[-2,2],[2,2],[2,-2]])}}(),function(){var t=Model.Game.cbBoardGeometryGrid(5,5);Model.Game.cbDefine=function(){return{geometry:t,pieceTypes:{0:{name:"pawn-w",aspect:"pawn",graph:this.cbPawnGraph(t,1),value:1,abbrev:"",fenAbbrev:"P",epCatch:!0},1:{name:"ipawn-w",aspect:"pawn",graph:this.cbInitialPawnGraph(t,1),value:1,abbrev:"",fenAbbrev:"P",initial:[{s:1,p:5},{s:1,p:6},{s:1,p:7},{s:1,p:8},{s:1,p:9}],epCatch:!0,epTarget:!0},2:{name:"pawn-b",aspect:"pawn",graph:this.cbPawnGraph(t,-1),value:1,abbrev:"",fenAbbrev:"P",epCatch:!0},3:{name:"ipawn-b",aspect:"pawn",graph:this.cbInitialPawnGraph(t,-1),value:1,abbrev:"",fenAbbrev:"P",initial:[{s:-1,p:15},{s:-1,p:16},{s:-1,p:17},{s:-1,p:18},{s:-1,p:19}],epCatch:!0,epTarget:!0},4:{name:"knight",graph:this.cbKnightGraph(t),value:2.9,abbrev:"N",initial:[{s:1,p:1},{s:1,p:4}]},5:{name:"bishop",graph:this.cbBishopGraph(t),value:3.1,abbrev:"B",initial:[{s:-1,p:21},{s:-1,p:24}]},6:{name:"rook",graph:this.cbRookGraph(t),value:5,abbrev:"R",initial:[{s:1,p:0},{s:-1,p:20}],castle:!0},7:{name:"queen",graph:this.cbQueenGraph(t),value:9,abbrev:"Q",initial:[{s:1,p:3},{s:-1,p:23}]},8:{name:"king",isKing:!0,graph:this.cbKingGraph(t),abbrev:"K",initial:[{s:1,p:2},{s:-1,p:22}]}},promote:function(e,r,i){return 1==r.t?[0]:3==r.t?[2]:0==r.t&&4==t.R(i.t)?[4,5,6,7]:2==r.t&&0==t.R(i.t)?[4,5,6,7]:[]},castle:{"2/0":{k:[1],r:[1],n:"O-O"},"22/20":{k:[21],r:[21],n:"O-O"}},evaluate:function(e,r,i){var a=i[1].count,n=i[-1].count;a[0]||a[1]||a[4]||a[5]||a[6]||a[7]||n[2]||n[3]||n[6]||n[7]||!(n[4]+n[5]<2||n[5]<2)||(this.mFinished=!0,this.mWinner=JocGame.DRAW),n[2]||n[3]||n[4]||n[5]||n[6]||n[7]||a[0]||a[1]||a[6]||a[7]||!(a[4]+a[5]<2||a[5]<2)||(this.mFinished=!0,this.mWinner=JocGame.DRAW),this.noCaptCount>=100&&(this.mFinished=!0,this.mWinner=JocGame.DRAW);var s,o=e.cbUseTypedArrays?new Int8Array(3):[0,0,0],h=t.height,c=i[1].byType[0];if(c){s=c.length;for(var p=0;p<s;p++)switch(h-t.R(c[p].p)){case 2:o[0]++;break;case 3:o[1]++;break;case 4:o[2]++}}if(c=i[-1].byType[2]){s=c.length;for(var p=0;p<s;p++)switch(t.R(c[p].p)){case 1:o[0]--;break;case 2:o[1]--;break;case 3:o[2]--}}0!=o[0]&&(r.distPawnPromo1=o[0]),0!=o[1]&&(r.distPawnPromo2=o[1]),0!=o[2]&&(r.distPawnPromo3=o[2]);for(var l=0,u=4;u<=5;u++)for(var v=1;v>=-1;v-=2){var b=i[v].byType[u];if(b)for(var p=0;p<b.length;p++)b[p].m&&(l+=v)}0!=l&&(r.minorPiecesMoved=l)}}}}();

/***/ }),

/***/ "cjT5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var OuterSubscriber_1 = __webpack_require__("wAkD");
var subscribeToResult_1 = __webpack_require__("CURp");
/**
 * Emits a value from the source Observable only after a particular time span
 * determined by another Observable has passed without another source emission.
 *
 * <span class="informal">It's like {@link debounceTime}, but the time span of
 * emission silence is determined by a second Observable.</span>
 *
 * <img src="./img/debounce.png" width="100%">
 *
 * `debounce` delays values emitted by the source Observable, but drops previous
 * pending delayed emissions if a new value arrives on the source Observable.
 * This operator keeps track of the most recent value from the source
 * Observable, and spawns a duration Observable by calling the
 * `durationSelector` function. The value is emitted only when the duration
 * Observable emits a value or completes, and if no other value was emitted on
 * the source Observable since the duration Observable was spawned. If a new
 * value appears before the duration Observable emits, the previous value will
 * be dropped and will not be emitted on the output Observable.
 *
 * Like {@link debounceTime}, this is a rate-limiting operator, and also a
 * delay-like operator since output emissions do not necessarily occur at the
 * same time as they did on the source Observable.
 *
 * @example <caption>Emit the most recent click after a burst of clicks</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.debounce(() => Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link audit}
 * @see {@link debounceTime}
 * @see {@link delayWhen}
 * @see {@link throttle}
 *
 * @param {function(value: T): SubscribableOrPromise} durationSelector A function
 * that receives a value from the source Observable, for computing the timeout
 * duration for each source value, returned as an Observable or a Promise.
 * @return {Observable} An Observable that delays the emissions of the source
 * Observable by the specified duration Observable returned by
 * `durationSelector`, and may drop some values if they occur too frequently.
 * @method debounce
 * @owner Observable
 */
function debounce(durationSelector) {
    return this.lift(new DebounceOperator(durationSelector));
}
exports.debounce = debounce;
var DebounceOperator = (function () {
    function DebounceOperator(durationSelector) {
        this.durationSelector = durationSelector;
    }
    DebounceOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new DebounceSubscriber(subscriber, this.durationSelector));
    };
    return DebounceOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var DebounceSubscriber = (function (_super) {
    __extends(DebounceSubscriber, _super);
    function DebounceSubscriber(destination, durationSelector) {
        _super.call(this, destination);
        this.durationSelector = durationSelector;
        this.hasValue = false;
        this.durationSubscription = null;
    }
    DebounceSubscriber.prototype._next = function (value) {
        try {
            var result = this.durationSelector.call(this, value);
            if (result) {
                this._tryNext(value, result);
            }
        }
        catch (err) {
            this.destination.error(err);
        }
    };
    DebounceSubscriber.prototype._complete = function () {
        this.emitValue();
        this.destination.complete();
    };
    DebounceSubscriber.prototype._tryNext = function (value, duration) {
        var subscription = this.durationSubscription;
        this.value = value;
        this.hasValue = true;
        if (subscription) {
            subscription.unsubscribe();
            this.remove(subscription);
        }
        subscription = subscribeToResult_1.subscribeToResult(this, duration);
        if (!subscription.closed) {
            this.add(this.durationSubscription = subscription);
        }
    };
    DebounceSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.emitValue();
    };
    DebounceSubscriber.prototype.notifyComplete = function () {
        this.emitValue();
    };
    DebounceSubscriber.prototype.emitValue = function () {
        if (this.hasValue) {
            var value = this.value;
            var subscription = this.durationSubscription;
            if (subscription) {
                this.durationSubscription = null;
                subscription.unsubscribe();
                this.remove(subscription);
            }
            this.value = null;
            this.hasValue = false;
            _super.prototype._next.call(this, value);
        }
    };
    return DebounceSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=debounce.js.map

/***/ }),

/***/ "cmqr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * An error thrown when duetime elapses.
 *
 * @see {@link timeout}
 *
 * @class TimeoutError
 */
var TimeoutError = (function (_super) {
    __extends(TimeoutError, _super);
    function TimeoutError() {
        var err = _super.call(this, 'Timeout has occurred');
        this.name = err.name = 'TimeoutError';
        this.stack = err.stack;
        this.message = err.message;
    }
    return TimeoutError;
}(Error));
exports.TimeoutError = TimeoutError;
//# sourceMappingURL=TimeoutError.js.map

/***/ }),

/***/ "cnKp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("3j3K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ngrx_store__ = __webpack_require__("WWmu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_ReplaySubject__ = __webpack_require__("MQMf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_ReplaySubject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs_ReplaySubject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_operator_map__ = __webpack_require__("xAJs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_operator_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rxjs_operator_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_operator_merge__ = __webpack_require__("kkb0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_operator_merge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_rxjs_operator_merge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_operator_observeOn__ = __webpack_require__("Ji1B");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_operator_observeOn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_rxjs_operator_observeOn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs_operator_scan__ = __webpack_require__("td8d");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs_operator_scan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_rxjs_operator_scan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rxjs_operator_skip__ = __webpack_require__("M5jZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rxjs_operator_skip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_rxjs_operator_skip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rxjs_operator_withLatestFrom__ = __webpack_require__("u2wr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rxjs_operator_withLatestFrom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_rxjs_operator_withLatestFrom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_rxjs_scheduler_queue__ = __webpack_require__("RA5l");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_rxjs_scheduler_queue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_rxjs_scheduler_queue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__extension__ = __webpack_require__("MjDH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils__ = __webpack_require__("3Nrk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__reducer__ = __webpack_require__("kWVG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__actions__ = __webpack_require__("2ene");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__config__ = __webpack_require__("2iB7");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DevtoolsDispatcher; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StoreDevtools; });
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();















var DevtoolsDispatcher = (function (_super) {
    __extends(DevtoolsDispatcher, _super);
    function DevtoolsDispatcher() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return DevtoolsDispatcher;
}(__WEBPACK_IMPORTED_MODULE_1__ngrx_store__["d" /* Dispatcher */]));

DevtoolsDispatcher.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
];
/** @nocollapse */
DevtoolsDispatcher.ctorParameters = function () { return []; };
var StoreDevtools = (function () {
    function StoreDevtools(dispatcher, actions$, reducers$, extension, initialState, config) {
        var liftedInitialState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__reducer__["a" /* liftInitialState */])(initialState, config.monitor);
        var liftReducer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__reducer__["b" /* liftReducerWith */])(initialState, liftedInitialState, config.monitor, {
            maxAge: config.maxAge
        });
        var liftedAction$ = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils__["a" /* applyOperators */])(actions$, [
            [__WEBPACK_IMPORTED_MODULE_7_rxjs_operator_skip__["skip"], 1],
            [__WEBPACK_IMPORTED_MODULE_4_rxjs_operator_merge__["merge"], extension.actions$],
            [__WEBPACK_IMPORTED_MODULE_3_rxjs_operator_map__["map"], __WEBPACK_IMPORTED_MODULE_11__utils__["b" /* liftAction */]],
            [__WEBPACK_IMPORTED_MODULE_4_rxjs_operator_merge__["merge"], dispatcher, extension.liftedActions$],
            [__WEBPACK_IMPORTED_MODULE_5_rxjs_operator_observeOn__["observeOn"], __WEBPACK_IMPORTED_MODULE_9_rxjs_scheduler_queue__["queue"]]
        ]);
        var liftedReducer$ = __WEBPACK_IMPORTED_MODULE_3_rxjs_operator_map__["map"].call(reducers$, liftReducer);
        var liftedStateSubject = new __WEBPACK_IMPORTED_MODULE_2_rxjs_ReplaySubject__["ReplaySubject"](1);
        var liftedStateSubscription = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils__["a" /* applyOperators */])(liftedAction$, [
            [__WEBPACK_IMPORTED_MODULE_8_rxjs_operator_withLatestFrom__["withLatestFrom"], liftedReducer$],
            [__WEBPACK_IMPORTED_MODULE_6_rxjs_operator_scan__["scan"], function (liftedState, _a) {
                    var action = _a[0], reducer = _a[1];
                    var nextState = reducer(liftedState, action);
                    extension.notify(action, nextState);
                    return nextState;
                }, liftedInitialState]
        ]).subscribe(liftedStateSubject);
        var liftedState$ = liftedStateSubject.asObservable();
        var state$ = __WEBPACK_IMPORTED_MODULE_3_rxjs_operator_map__["map"].call(liftedState$, __WEBPACK_IMPORTED_MODULE_11__utils__["c" /* unliftState */]);
        this.stateSubscription = liftedStateSubscription;
        this.dispatcher = dispatcher;
        this.liftedState = liftedState$;
        this.state = state$;
    }
    StoreDevtools.prototype.dispatch = function (action) {
        this.dispatcher.dispatch(action);
    };
    StoreDevtools.prototype.next = function (action) {
        this.dispatcher.dispatch(action);
    };
    StoreDevtools.prototype.error = function (error) { };
    StoreDevtools.prototype.complete = function () { };
    StoreDevtools.prototype.performAction = function (action) {
        this.dispatch(__WEBPACK_IMPORTED_MODULE_13__actions__["a" /* StoreDevtoolActions */].performAction(action));
    };
    StoreDevtools.prototype.reset = function () {
        this.dispatch(__WEBPACK_IMPORTED_MODULE_13__actions__["a" /* StoreDevtoolActions */].reset());
    };
    StoreDevtools.prototype.rollback = function () {
        this.dispatch(__WEBPACK_IMPORTED_MODULE_13__actions__["a" /* StoreDevtoolActions */].rollback());
    };
    StoreDevtools.prototype.commit = function () {
        this.dispatch(__WEBPACK_IMPORTED_MODULE_13__actions__["a" /* StoreDevtoolActions */].commit());
    };
    StoreDevtools.prototype.sweep = function () {
        this.dispatch(__WEBPACK_IMPORTED_MODULE_13__actions__["a" /* StoreDevtoolActions */].sweep());
    };
    StoreDevtools.prototype.toggleAction = function (id) {
        this.dispatch(__WEBPACK_IMPORTED_MODULE_13__actions__["a" /* StoreDevtoolActions */].toggleAction(id));
    };
    StoreDevtools.prototype.jumpToState = function (index) {
        this.dispatch(__WEBPACK_IMPORTED_MODULE_13__actions__["a" /* StoreDevtoolActions */].jumpToState(index));
    };
    StoreDevtools.prototype.importState = function (nextLiftedState) {
        this.dispatch(__WEBPACK_IMPORTED_MODULE_13__actions__["a" /* StoreDevtoolActions */].importState(nextLiftedState));
    };
    return StoreDevtools;
}());

StoreDevtools.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
];
/** @nocollapse */
StoreDevtools.ctorParameters = function () { return [
    { type: DevtoolsDispatcher, },
    { type: __WEBPACK_IMPORTED_MODULE_1__ngrx_store__["d" /* Dispatcher */], },
    { type: __WEBPACK_IMPORTED_MODULE_1__ngrx_store__["e" /* Reducer */], },
    { type: __WEBPACK_IMPORTED_MODULE_10__extension__["a" /* DevtoolsExtension */], },
    { type: undefined, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_1__ngrx_store__["f" /* INITIAL_STATE */],] },] },
    { type: undefined, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_14__config__["a" /* STORE_DEVTOOLS_CONFIG */],] },] },
]; };
//# sourceMappingURL=devtools.js.map

/***/ }),

/***/ "cnab":
/***/ (function(module, exports) {

exports.config = {"status":true,"model":{"plazza":"true","title-en":"Spanish Draughts","module":"checkers","maxLevel":20,"summary":"Same as international checkers on a 8x8 board, no backward capture.","thumbnail":"draughts8-thumb3d.png","rules":"rules-spanish-draughts.html","description":"description.html","credits":"credits.html","js":["checkersbase-model.js","draughts-model.js"],"gameOptions":{"preventRepeat":true,"width":4,"height":8,"initial":{"a":[[0,0],[0,1],[0,2],[0,3],[1,0],[1,1],[1,2],[1,3],[2,0],[2,1],[2,2],[2,3]],"b":[[7,0],[7,1],[7,2],[7,3],[6,0],[6,1],[6,2],[6,3],[5,0],[5,1],[5,2],[5,3]]},"variant":{"mustMoveForwardStrict":true,"lastRowCrown":true,"captureLongestLine":true,"lastRowFactor":0.001,"canCaptureBackward":false},"uctTransposition":"state"},"levels":[{"label":"Fast","ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.5,"maxDuration":1,"isDefault":true},{"label":"Beginner","ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.5,"maxDuration":0.5,"maxNodes":100,"maxLoops":200},{"label":"Easy","ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.5,"maxDuration":1,"maxNodes":2500,"maxLoops":500},{"label":"Medium","ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.5,"maxDuration":2,"maxNodes":5500,"maxLoops":500},{"label":"Hard","ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.5,"maxDuration":5,"maxNodes":2000,"maxLoops":3500},{"label":"Expert","ai":"uct","c":0.8,"playoutDepth":0,"minVisitsExpand":1,"ignoreLeaf":false,"uncertaintyFactor":5,"propagateMultiVisits":false,"maxDuration":60,"maxNodes":15000,"maxLoops":8000}]},"view":{"js":["checkers-xd-view.js","draughts8-xd-view.js"],"css":["checkersbase.css","draughts.css"],"title-en":"Draughts View","skins":[{"name":"classic3d","title":"3D Classic","3d":true,"camera":{"radius":24,"elevationAngle":65,"limitCamMoves":true,"distMax":30,"fov":35},"world":{"lightIntensity":0.7,"skyLightIntensity":0.5,"lightPosition":{"x":-15,"y":15,"z":0},"lightShadowDarkness":0.45,"ambientLightColor":8947848,"color":4686804,"fog":false},"preload":["image|/res/images/wood-chipboard-5.jpg","image|/res/xd-view/meshes/piecetop-bump.jpg","image|/res/xd-view/meshes/piecediff.jpg","image|/res/xd-view/meshes/piecetop-queen-mask.png","smoothedfilegeo|0|/res/xd-view/meshes/ring-target.js","smoothedfilegeo|0|/res/xd-view/meshes/piece-v2.js"]},{"name":"turtles3d","title":"3D Turtles","3d":true,"camera":{"radius":14,"elevationAngle":45,"limitCamMoves":true,"distMax":40},"world":{"lightIntensity":0,"skyLightIntensity":3,"fog":true,"color":3645658,"lightPosition":{"x":-5,"y":18,"z":5},"lightShadowDarkness":0.55,"ambientLightColor":4473924},"preload":["image|/res/images/wood-chipboard-5.jpg","image|/res/xd-view/meshes/turtle.png","image|/res/xd-view/meshes/star.png","image|/res/xd-view/meshes/rock.jpg","smoothedfilegeo|0|/res/xd-view/meshes/turtle-legs-smoothed.js","smoothedfilegeo|0|/res/xd-view/meshes/turtle-head-smoothed.js","smoothedfilegeo|0|/res/xd-view/meshes/turtle-tail-smoothed.js","smoothedfilegeo|0|/res/xd-view/meshes/turtle-hotel.js","smoothedfilegeo|0|/res/xd-view/meshes/turtle-house.js","smoothedfilegeo|0|/res/xd-view/meshes/rainbowflat.js","smoothedfilegeo|0|/res/xd-view/meshes/ring-target.js","smoothedfilegeo|0|/res/xd-view/meshes/rocksmoothed.js","smoothedfilegeo|0|/res/xd-view/meshes/turtle-fences.js"]},{"name":"classical","title":"Classic"},{"name":"marble0","title":"Marble"},{"name":"wood0","title":"Wood"},{"name":"green","title":"Green"}],"visuals":{"600x600":["res/visuals/brazilian-draughts-600x600-3d.jpg","res/visuals/brazilian-draughts-600x600-2d.jpg"]},"sounds":{"move1":"move1","move2":"move2","move3":"move3","move4":"move4","tac1":"tac1","tac2":"tac1","tac3":"tac1","promo":"promo","usermove":null},"module":"checkers","preferredRatio":1,"switchable":true,"animateSelfMoves":false,"useNotation":true,"useShowMoves":true,"defaultOptions":{"sounds":true,"notation":false,"moves":true},"xdView":true}}

/***/ }),

/***/ "cwzr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var root_1 = __webpack_require__("VOfZ");
var Action_1 = __webpack_require__("zQPq");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var AsyncAction = (function (_super) {
    __extends(AsyncAction, _super);
    function AsyncAction(scheduler, work) {
        _super.call(this, scheduler, work);
        this.scheduler = scheduler;
        this.work = work;
        this.pending = false;
    }
    AsyncAction.prototype.schedule = function (state, delay) {
        if (delay === void 0) { delay = 0; }
        if (this.closed) {
            return this;
        }
        // Always replace the current state with the new state.
        this.state = state;
        // Set the pending flag indicating that this action has been scheduled, or
        // has recursively rescheduled itself.
        this.pending = true;
        var id = this.id;
        var scheduler = this.scheduler;
        //
        // Important implementation note:
        //
        // Actions only execute once by default, unless rescheduled from within the
        // scheduled callback. This allows us to implement single and repeat
        // actions via the same code path, without adding API surface area, as well
        // as mimic traditional recursion but across asynchronous boundaries.
        //
        // However, JS runtimes and timers distinguish between intervals achieved by
        // serial `setTimeout` calls vs. a single `setInterval` call. An interval of
        // serial `setTimeout` calls can be individually delayed, which delays
        // scheduling the next `setTimeout`, and so on. `setInterval` attempts to
        // guarantee the interval callback will be invoked more precisely to the
        // interval period, regardless of load.
        //
        // Therefore, we use `setInterval` to schedule single and repeat actions.
        // If the action reschedules itself with the same delay, the interval is not
        // canceled. If the action doesn't reschedule, or reschedules with a
        // different delay, the interval will be canceled after scheduled callback
        // execution.
        //
        if (id != null) {
            this.id = this.recycleAsyncId(scheduler, id, delay);
        }
        this.delay = delay;
        // If this action has already an async Id, don't request a new one.
        this.id = this.id || this.requestAsyncId(scheduler, this.id, delay);
        return this;
    };
    AsyncAction.prototype.requestAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) { delay = 0; }
        return root_1.root.setInterval(scheduler.flush.bind(scheduler, this), delay);
    };
    AsyncAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) { delay = 0; }
        // If this action is rescheduled with the same delay time, don't clear the interval id.
        if (delay !== null && this.delay === delay) {
            return id;
        }
        // Otherwise, if the action's delay time is different from the current delay,
        // clear the interval id
        return root_1.root.clearInterval(id) && undefined || undefined;
    };
    /**
     * Immediately executes this action and the `work` it contains.
     * @return {any}
     */
    AsyncAction.prototype.execute = function (state, delay) {
        if (this.closed) {
            return new Error('executing a cancelled action');
        }
        this.pending = false;
        var error = this._execute(state, delay);
        if (error) {
            return error;
        }
        else if (this.pending === false && this.id != null) {
            // Dequeue if the action didn't reschedule itself. Don't call
            // unsubscribe(), because the action could reschedule later.
            // For example:
            // ```
            // scheduler.schedule(function doWork(counter) {
            //   /* ... I'm a busy worker bee ... */
            //   var originalAction = this;
            //   /* wait 100ms before rescheduling the action */
            //   setTimeout(function () {
            //     originalAction.schedule(counter + 1);
            //   }, 100);
            // }, 1000);
            // ```
            this.id = this.recycleAsyncId(this.scheduler, this.id, null);
        }
    };
    AsyncAction.prototype._execute = function (state, delay) {
        var errored = false;
        var errorValue = undefined;
        try {
            this.work(state);
        }
        catch (e) {
            errored = true;
            errorValue = !!e && e || new Error(e);
        }
        if (errored) {
            this.unsubscribe();
            return errorValue;
        }
    };
    AsyncAction.prototype._unsubscribe = function () {
        var id = this.id;
        var scheduler = this.scheduler;
        var actions = scheduler.actions;
        var index = actions.indexOf(this);
        this.work = null;
        this.delay = null;
        this.state = null;
        this.pending = false;
        this.scheduler = null;
        if (index !== -1) {
            actions.splice(index, 1);
        }
        if (id != null) {
            this.id = this.recycleAsyncId(scheduler, id, null);
        }
    };
    return AsyncAction;
}(Action_1.Action));
exports.AsyncAction = AsyncAction;
//# sourceMappingURL=AsyncAction.js.map

/***/ }),

/***/ "d/I2":
/***/ (function(module, exports) {

function PDNObject() {
    this.tags = {};
    this.listMoveText = []; // [{}]
    this.gameTermination = "";
    this.fenWhitePawn = []; // [int]
    this.fenBlackPawn = []; // [int]
    this.fenWhiteKing = []; // [int]
    this.fenBlackKing = []; // [int]
    this.fenTurnColor = ""; // "W" | "B"
}

PDNObject.prototype.getTagPair = function(tagName) {
    var value = "??";

    if (this.tags != null && (tagName in this.tags)) {
        value = this.tags[tagName];
    }

    if (value.trim() == "") {
        value = "??";
    }

    return value;
};

PDNObject.prototype.getFENTurnColor = function() {
    if (this.fenTurnColor == null) {
        return "";
    }
    return this.fenTurnColor;
};

PDNObject.prototype.getFENList = function(which) {
    var list = null;

    if (which == "WP") {
        list = this.fenWhitePawn;
    } else if (which == "BP") {
        list = this.fenBlackPawn;
    } else if (which == "WK") {
        list = this.fenWhiteKing;
    } else if (which == "BK") {
        list = this.fenBlackKing;
    }

    if (list == null) {
        list = [];
    }
    return list;
};

PDNObject.prototype.isTagValueEmpty = function(value) {
    return (value == null || value == "??");
};

PDNObject.prototype.hasFEN = function() {
    return !this.isTagValueEmpty(this.getTagPair("FEN"));
};

PDNObject.prototype.getMoves = function() {
    return this.listMoveText;
};

PDNObject.prototype.getGameTermination = function() {
    return this.gameTermination;
};

PDNObject.prototype.setFenWP = function(wpList) {
    this.fenWhitePawn = wpList;
};

PDNObject.prototype.setFenBP = function(bpList) {
    this.fenBlackPawn = bpList;
};

PDNObject.prototype.setFenWK = function(wkList) {
    this.fenWhiteKing = wkList;
};

PDNObject.prototype.setFenBK = function(bkList) {
    this.fenBlackKing = bkList;
};

PDNObject.prototype.setFenTurnColor = function(fenTurnColor) {
    this.fenTurnColor = fenTurnColor;
};

PDNObject.prototype.setGameTermination = function(gameTermination) {
    if (gameTermination != null) {
        this.gameTermination = gameTermination;
    }
};

PDNObject.prototype.setTagPairs = function(tags) {
    if (tags != null) {
        this.tags = tags;
    }
};

PDNObject.prototype.setMoveText = function(list) {
    if (list != null) {
        this.listMoveText = list;
    }
};

PDNObject.prototype.debugTags = function() {
    console.log("");
    console.log("----------------------------------------");
    console.log(" Tag Pairs :");
    console.log("----------------------------------------");
    if (this.tags == null) {
        console.log("Erreur...");
        return;
    }

    var tagNames = Object.keys(this.tags);
    for (var k = 0; k < tagNames.length; k++) {
        console.log(tagNames[k] + " = " + this.tags[tagNames[k]]);
    }
};

PDNObject.prototype.debugOfficialTags = function() {
    console.log("");
    console.log("-----------------------------------------------------");
    console.log("Event : " + this.getTagPair("Event"));
    console.log("Site : " + this.getTagPair("Site"));
    console.log("Date : " + this.getTagPair("Date"));
    console.log("GameType : " + this.getTagPair("GameType"));
    console.log("Round : " + this.getTagPair("Round"));
    console.log("White : " + this.getTagPair("White"));
    console.log("Black : " + this.getTagPair("Black"));
    console.log("Result : " + this.getTagPair("Result"));
    console.log("SetUp : " + this.getTagPair("SetUp"));
    console.log("FEN : " + this.getTagPair("FEN"));

    console.log("FEN TURN = " + this.getFENTurnColor());
    console.log("FEN WP = " + this.getFENList("WP"));
    console.log("FEN BP = " + this.getFENList("BP"));
    console.log("FEN WK = " + this.getFENList("WK"));
    console.log("FEN BK = " + this.getFENList("BK"));
};

PDNObject.prototype.debugMoveText = function() {
    console.log("");
    console.log("----------------------------------------");
    console.log(" Move Text :");
    console.log("----------------------------------------");
    if (!this.listMoveText) {
        console.log("Erreur...");
        return;
    }

    // Moves
    for (var m = 0; m < this.listMoveText.length; m++){
        var mapMove = this.listMoveText[m];
        var keys = Object.keys(mapMove);
        for (var k = 0; k < keys.length; k++) {
            console.log(keys[k] + " = " + mapMove[keys[k]]);
        }
        console.log("----------");
    }
};


module.exports = PDNObject;



/***/ }),

/***/ "d5KB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("3j3K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_common__ = __webpack_require__("2Je8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__json_node__ = __webpack_require__("Kpad");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__json_tree__ = __webpack_require__("y5CN");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return JsonTreeModule; });




var JsonTreeModule = (function () {
    function JsonTreeModule() {
    }
    JsonTreeModule.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{
                    imports: [
                        __WEBPACK_IMPORTED_MODULE_1__angular_common__["CommonModule"]
                    ],
                    declarations: [
                        __WEBPACK_IMPORTED_MODULE_2__json_node__["a" /* JsonNodeComponent */],
                        __WEBPACK_IMPORTED_MODULE_3__json_tree__["a" /* JsonTreeComponent */]
                    ],
                    exports: [
                        __WEBPACK_IMPORTED_MODULE_3__json_tree__["a" /* JsonTreeComponent */]
                    ]
                },] },
    ];
    /** @nocollapse */
    JsonTreeModule.ctorParameters = [];
    return JsonTreeModule;
}());
//# sourceMappingURL=index.js.map

/***/ }),

/***/ "d8f8":
/***/ (function(module, exports) {

exports.model=Model={Game:{},Board:{},Move:{}},Model.Game.InitGame=function(){function t(e,s,o,a){for(var r=i.g.Graph[o[o.length-1]],h=0;h<4;h++){var n=r[h];if(n>=0&&!a[n])if(0==s){e[n]||(e[n]=[]);for(var p=[],m=0;m<o.length;m++)p.push(o[m]);p.push(n),e[n].push(p)}else o.push(n),a[n]=!0,t(e,s-1,o,a),delete a[n],o.pop()}}var i=this;this.g.Graph=[],this.g.CValue=[];for(var e=[[1,0],[-1,0],[0,1],[0,-1]],s=0;s<this.mOptions.height;s++)for(var o=0;o<this.mOptions.width;o++){for(var a=[],r=0;r<e.length;r++){var h=e[r][0],n=e[r][1],p=s+n,m=o+h;p>=0&&p<this.mOptions.height&&m>=0&&m<this.mOptions.width?a.push(p*this.mOptions.width+m):a.push(-1)}this.g.Graph.push(a),this.g.CValue[s*this.mOptions.width+o]=parseInt(this.mOptions.initial[s].charAt(o))}this.g.Targets=[];for(var d=0;d<this.g.Graph.length;d++){var l={},v={};v[d]=!0,t(l,this.g.CValue[d]-1,[d],v),this.g.Targets[d]=l}this.g.Orients={NW:{angle:-90},NE:{angle:180},SW:{angle:0},SE:{angle:90}};for(var u=[],f=0;f<this.g.Graph.length;f++){u.push([]);for(var c=0;c<this.g.Graph.length;c++)u[f].push(f==c?0:-1)}for(;;){for(var g=0,f=0;f<this.g.Graph.length;f++)for(var c=0;c<this.g.Graph.length;c++)if(u[f][c]>=0){var y=this.g.Targets[c];for(var O in y)if(y.hasOwnProperty(O)){var C=parseInt(O);u[f][C]<0&&(u[f][C]=u[f][c]+1,g++)}}if(0==g)break}this.g.Dist=u},Model.Game.DestroyGame=function(){},Model.Move.Init=function(t){void 0!==t&&this.CopyFrom(t)},Model.Move.ToString=function(){var t=[];if(this.o&&t.push("o"+this.o),this.p){for(var i=0;i<this.p.d.length;i++)t.push("d"+this.p.d[i]);for(var i=0;i<this.p.r.length;i++)t.push("r"+this.p.r[i])}return this.m&&t.push("m"+this.m[0]+">"+this.m[1]),void 0!==this.i&&t.push("p"+this.i),t.join(" ")},Model.Move.CopyFrom=function(t){Object.assign(this,JSON.parse(JSON.stringify(t)))},Model.Board.Init=function(t){},Model.Board.InitialPosition=function(t){for(var i=[],e=[],s=0;s<t.g.Graph.length;s++)e[s]=-1;this.pieces=i,this.board=e,this.stage=1,this.mana=-1,this.roninOut={1:0,"-1":0},this.damyoOut={1:0,"-1":0}},Model.Board._getRCCoord=function(t,i,e){var s=Math.floor(i/t.mOptions.width),o=i%t.mOptions.width;if(arguments.length<3&&(e=this.orient),"NE"==e||"SW"==e){var a=s;s=o,o=a}return"NE"!=e&&"NW"!=e||(o=t.mOptions.width-1-o),"NE"!=e&&"SE"!=e||(s=t.mOptions.height-1-s),[s,o]},Model.Board.manaCreatePlacement=function(t,i){for(var e=[],s=0;s<t.g.Graph.length;s++){var o=this._getRCCoord(t,s,i);(this.mWho==-1&&o[1]<=1||1==this.mWho&&o[1]>=t.mOptions.width-2)&&e.push(s)}for(var a={d:[],r:[]},r=0;r<t.mOptions.damyoCount;r++){var h=t.Random(e.length),s=e[h];e.splice(h,1),a.d.push(s)}for(var r=0;r<t.mOptions.roninCount;r++){var h=t.Random(e.length),s=e[h];e.splice(h,1),a.r.push(s)}return a},Model.Board.GenerateMoves=function(t){if(1==this.stage)for(var i=["NE","SE","SW","NW"],e=0;e<t.mOptions.stage1start;e++){var s=i[t.Random(4)],o=this.manaCreatePlacement(t,s);this.mMoves.push({o:s,p:o})}else if(2==this.stage)for(var e=0;e<t.mOptions.stage2start;e++){var o=this.manaCreatePlacement(t,this.orient);this.mMoves.push({p:o})}else{var a=this.manaMovablePieces(t),r=[],h=-1;this.mana>=0&&(h=t.g.CValue[this.mana]);for(var e in a)if(a.hasOwnProperty(e)){var n=this.pieces[e];if(h<0||t.g.CValue[n.p]==h)for(var p in a[e])a[e].hasOwnProperty(p)&&r.push({m:[n.p,parseInt(p)]})}if(0==r.length){for(var e in a)if(a.hasOwnProperty(e)){var n=this.pieces[e];for(var p in a[e])a[e].hasOwnProperty(p)&&r.push({m:[n.p,parseInt(p)]})}if(this.roninOut[this.mWho]>0)for(var p=0;p<t.g.Graph.length;p++)this.board[p]<0&&(t.mOptions.insertAnywhere||t.g.CValue[p]==h)&&r.push({i:p})}this.mMoves=r}},Model.Board.Evaluate=function(aGame,aFinishOnly,aTopLevel){if(this.mEvaluation=0,this.damyoOut[JocGame.PLAYER_A]>=aGame.mOptions.damyoKillWin)return this.mFinished=!0,void(this.mWinner=JocGame.PLAYER_B);if(this.damyoOut[JocGame.PLAYER_B]>=aGame.mOptions.damyoKillWin)return this.mFinished=!0,void(this.mWinner=JocGame.PLAYER_A);for(var cellTypesPieceCount={1:{1:0,2:0,3:0},"-1":{1:0,2:0,3:0}},cellTypesDamyoCount={1:{1:0,2:0,3:0},"-1":{1:0,2:0,3:0}},damyoPoss={1:[],"-1":[]},pIndex=0;pIndex<this.pieces.length;pIndex++){var piece=this.pieces[pIndex];piece.p>=0&&(cellTypesPieceCount[piece.s][aGame.g.CValue[piece.p]]++,"d"==piece.t&&(cellTypesDamyoCount[piece.s][aGame.g.CValue[piece.p]]++,damyoPoss[piece.s].push(piece.p)))}for(var pos=0;pos<aGame.g.Graph.length;pos++){var pIndex=this.board[pos];if(pIndex>=0)var piece=this.pieces[pIndex]}for(var typeCount={1:0,"-1":0},who=-1;who<=1;who+=2)for(var type=1;type<=3;type++)cellTypesPieceCount[who][type]>0&&typeCount[who]++;for(var sameAsDamyo={1:0,"-1":0},who=-1;who<=1;who+=2)for(var type=1;type<=3;type++)sameAsDamyo[who]+=cellTypesDamyoCount[who][type]*cellTypesPieceCount[who][type];for(var roninCount={1:0,"-1":0},who=-1;who<=1;who+=2)roninCount[who]=aGame.mOptions.roninCount-this.roninOut[who];for(var dist2Damyo={1:{dist:0,invSquare:0},"-1":{dist:0,invSquare:0}},pIndex=0;pIndex<this.pieces.length;pIndex++){var piece=this.pieces[pIndex];if(piece.p>=0&&"r"==piece.t){for(var minDist=-1,i=0;i<damyoPoss[-piece.s].length;i++){var damyoPos=damyoPoss[-piece.s][i],dist=aGame.g.Dist[piece.p][damyoPos];(minDist<0||dist<minDist)&&(minDist=dist)}dist2Damyo[piece.s].dist+=minDist,dist2Damyo[piece.s].invSquare+=1/(minDist*minDist)}}var eval=0,factors=aGame.mOptions.factors;eval+=factors.typeCount[typeCount[1]]-factors.typeCount[typeCount[-1]],eval+=factors.sameAsDamyo*(sameAsDamyo[1]-sameAsDamyo[-1]),eval+=factors.roninCount[roninCount[1]]-factors.roninCount[roninCount[-1]],eval+=factors.dist2Damyo*(dist2Damyo[1].dist-dist2Damyo[-1].dist),eval+=factors.dist2DamyoInvSquare*(dist2Damyo[1].invSquare-dist2Damyo[-1].invSquare),isNaN(eval),this.mEvaluation=eval},Model.Board.ApplyMove=function(t,i){if(1==this.stage&&(this.orient=i.o),1==this.stage||2==this.stage){for(var e=0,s=0;s<i.p.d.length;s++){var o=i.p.d[s],a={s:this.mWho,t:"d",p:o,i:e++};this.pieces.push(a),this.board[o]=this.pieces.length-1}e=0;for(var s=0;s<i.p.r.length;s++){var o=i.p.r[s],a={s:this.mWho,t:"r",p:o,i:e++};this.pieces.push(a),this.board[o]=this.pieces.length-1}this.stage++}if(i.m){var r=this.board[i.m[0]],a=this.pieces[r];this.board[i.m[0]]=-1;var h=this.board[i.m[1]];if(h>=0){var n=this.pieces[h];n.p=-1,"r"==n.t?this.roninOut[-this.mWho]++:"d"==n.t&&this.damyoOut[-this.mWho]++}a.p=i.m[1],this.board[i.m[1]]=r,this.mana=i.m[1]}if(void 0!==i.i){var a,s;for(s=0;s<this.pieces.length&&(a=this.pieces[s],!("r"==a.t&&a.s==this.mWho&&a.p<0));s++);a.p=i.i,this.board[i.i]=s,this.mana=i.i,this.roninOut[this.mWho]--}},Model.Board.IsValidMove=function(t,i){return!0},Model.Board.manaMovablePieces=function(t){for(var i={},e=0;e<this.pieces.length;e++){var s=this.pieces[e];if(s.s==this.mWho){var o=s.p;for(var a in t.g.Targets[o])if(t.g.Targets[o].hasOwnProperty(a)){if(this.board[a]>=0&&this.pieces[this.board[a]].s==this.mWho)continue;for(var r=null,h=t.g.Targets[o][a],n=0;n<h.length;n++){for(var p=!0,m=h[n],d=1;d<m.length-1;d++)if(this.board[m[d]]>=0){p=!1;break}if(p){r=m;break}}r&&(i[e]||(i[e]={}),i[e][a]=r)}}}return i};

/***/ }),

/***/ "dMml":
/***/ (function(module, exports) {

exports.config = {"status":true,"model":{"plazza":"true","released":1402671377,"title-en":"Smess","module":"chessbase","summary":"The Ninny's Chess (1970)","thumbnail":"smess-thumb.png","rules":{"en":"smess-rules.html"},"credits":{"en":"smess-credits.html"},"gameOptions":{"preventRepeat":true,"uctTransposition":"state","uctIgnoreLoop":false,"levelOptions":{"pieceValueFactor":1,"pieceValueRatioFactor":1,"posValueFactor":0.1,"averageDistKingFactor":-0.01,"castleFactor":0.1,"minorPiecesMovedFactor":0.1,"checkFactor":0.2,"endingKingFreedomFactor":0.01,"endingDistKingFactor":0.05,"distKingCornerFactor":0.1,"distPawnPromo1Factor":0.3,"distPawnPromo2Factor":0.2,"distPawnPromo3Factor":0.1,"distPawnPromo4Factor":0.05,"distPawnPromo5Factor":0.03}},"obsolete":false,"js":["base-model.js","smess-geo-model.js","smess-model.js"],"description":{"en":"smess-description.html"},"levels":[{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"easy","label":"Easy","maxNodes":1000},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"fast","label":"Fast [1sec]","maxDuration":1,"isDefault":true},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"medium","label":"Medium","maxNodes":10000,"maxDuration":10},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"strong","label":"Strong","maxNodes":20000,"maxDuration":15}]},"view":{"title-en":"Chessbase view","module":"chessbase","xdView":true,"css":["chessbase.css"],"preferredRatio":1,"useShowMoves":true,"useNotation":true,"useAutoComplete":true,"defaultOptions":{"sounds":true,"moves":true,"notation":false,"autocomplete":false},"skins":[{"name":"skin3d","title":"3D Classic","3d":true,"preload":["smoothedfilegeo|0|/res/ring-target.js","image|/res/images/cancel.png","smoothedfilegeo|0|/res/smess/token.js","image|/res/smess/promo.png","image|/res/smess/arrow-top.png","image|/res/smess/arrow-top-left.png","image|/res/images/wood-chipboard-4.jpg","image|/res/smess/playera-bg.png","image|/res/smess/playerb-bg.png","image|/res/smess/smess-pieces-sprites.png"],"world":{"lightIntensity":1.3,"skyLightIntensity":1.2,"lightCastShadow":true,"fog":false,"color":4686804,"lightPosition":{"x":-9,"y":9,"z":9},"skyLightPosition":{"x":9,"y":9,"z":9},"lightShadowDarkness":0.55,"ambientLightColor":2236962},"camera":{"fov":45,"distMax":50,"radius":18,"elevationAngle":60,"elevationMin":0}},{"name":"skin2d","title":"2D Classic","3d":false,"preload":["image|/res/images/cancel.png","image|/res/images/whitebg.png","image|/res/smess/promo.png","image|/res/smess/arrow-top.png","image|/res/smess/arrow-top-left.png","image|/res/images/wood-chipboard-4.jpg","image|/res/smess/smess-pieces-sprites-a.png","image|/res/smess/smess-pieces-sprites-b.png"]}],"animateSelfMoves":false,"switchable":true,"sounds":{"move1":"alq_move1","move2":"alq_move2","move3":"alq_move3","move4":"alq_move2","tac1":"alq_tac1","tac2":"alq_tac2","tac3":"alq_tac1","promo":"promo","usermove":null},"js":["base-view.js","grid-board-view.js","smess-set-view.js","smess-view.js"],"visuals":{"600x600":["res/visuals/smess-600x600-3d.jpg","res/visuals/smess-600x600-2d.jpg"]}}}

/***/ }),

/***/ "dPkb":
/***/ (function(module, exports) {

exports.config = {"status":true,"model":{"plazza":"true","title-en":"Scrum","js":["scrum-model.js"],"module":"scrum","maxLevel":5,"defaultLevel":1,"summary":"A little rugby game","rules":{"en":"rules.html","fr":"rules-fr.html"},"description":{"en":"description.html","fr":"description-fr.html"},"credits":{"en":"credits.html","fr":"credits-fr.html"},"thumbnail":"scrum-thumb3d.png","strings":{"no-surround":"You cannot completely surround the ball"},"gameOptions":{"preventRepeat":true,"width":5,"height":12,"initial":{"a":[[1,2],[2,0],[2,4],[3,2],[4,1],[5,2],[5,0]],"b":[[11,2],[10,0],[10,4],[9,2],[8,1],[7,2],[7,0]],"ball":[5,1]},"uctTransposition":"states","levelOptions":{"MIN_MOVES":20,"ROW_FACTOR":20,"BDIST_FACTOR":0.05,"NEIGHBOR_FACTOR":0.18953811793163}},"levels":[{"label":"Fast","ai":"uct","maxDuration":1,"playoutDepth":1,"minVisitsExpand":1,"c":0.35272296388695,"ignoreLeaf":false,"propagateMultiVisits":false,"productRatio":0,"useDepthWeights":false,"propagation":"mixed","useAlphaBeta":true,"uncertaintyFactor":2.4883591498064,"isDefault":true},{"label":"Beginner","ai":"uct","playoutDepth":1,"minVisitsExpand":1,"c":0.35272296388695,"ignoreLeaf":false,"propagateMultiVisits":false,"productRatio":0,"useDepthWeights":false,"propagation":"mixed","useAlphaBeta":true,"uncertaintyFactor":2.4883591498064,"maxDuration":0.5,"maxNodes":100,"maxLoops":200},{"label":"Easy","ai":"uct","playoutDepth":1,"minVisitsExpand":1,"c":0.35272296388695,"ignoreLeaf":false,"propagateMultiVisits":false,"productRatio":0,"useDepthWeights":false,"propagation":"mixed","useAlphaBeta":true,"uncertaintyFactor":2.4883591498064,"maxDuration":1,"maxNodes":2500,"maxLoops":500},{"label":"Medium","ai":"uct","playoutDepth":1,"minVisitsExpand":1,"c":0.35272296388695,"ignoreLeaf":false,"propagateMultiVisits":false,"productRatio":0,"useDepthWeights":false,"propagation":"mixed","useAlphaBeta":true,"uncertaintyFactor":2.4883591498064,"maxDuration":2,"maxNodes":5500,"maxLoops":500},{"label":"Hard","ai":"uct","playoutDepth":1,"minVisitsExpand":1,"c":0.35272296388695,"ignoreLeaf":false,"propagateMultiVisits":false,"productRatio":0,"useDepthWeights":false,"propagation":"mixed","useAlphaBeta":true,"uncertaintyFactor":2.4883591498064,"maxDuration":5,"maxNodes":2000,"maxLoops":3500},{"label":"Expert","ai":"uct","playoutDepth":1,"minVisitsExpand":1,"c":0.35272296388695,"ignoreLeaf":false,"propagateMultiVisits":false,"productRatio":0,"useDepthWeights":false,"propagation":"mixed","useAlphaBeta":true,"uncertaintyFactor":2.4883591498064,"maxDuration":60,"maxNodes":50000,"maxLoops":3000}]},"view":{"title-en":"Scrum View","preferredRatio":0.58,"switchable":true,"useNotation":true,"useShowMoves":true,"animateSelfMoves":false,"skins":[{"name":"scrum3djocly","title":"Scrum 3D","3d":true,"camera":{"radius":12,"limitCamMoves":true,"elevationMax":80,"rotationAngle":30,"elevationAngle":35},"world":{"lightIntensity":1,"fog":false,"color":0,"lightPosition":{"x":-10,"y":18,"z":10},"lightShadowDarkness":0.35,"ambientLightColor":8947848,"skyLightIntensity":0.3},"preload":["image|/res/xd-view/meshes/scrumfield8x12.jpg","image|/res/xd-view/meshes/teama-text.jpg","image|/res/xd-view/meshes/teamb-text.jpg","image|/res/xd-view/meshes/ballUVslayout.jpg","image|/res/xd-view/meshes/pubs.jocly.jpg","smoothedfilegeo|0|/res/xd-view/meshes/target.js","smoothedfilegeo|0|/res/xd-view/meshes/stade2-xtra.js","smoothedfilegeo|0|/res/xd-view/meshes/player-anim.js","smoothedfilegeo|0|/res/xd-view/meshes/scrum-ball.js","smoothedfilegeo|0|/res/xd-view/meshes/arrow.js","smoothedfilegeo|0|/res/xd-view/meshes/arrowscrum.js"],"brand":"none"},{"name":"scrum3dsg","title":"Scrum 3D SG","3d":true,"camera":{"radius":12,"limitCamMoves":true,"elevationMax":80,"rotationAngle":30,"elevationAngle":35},"world":{"lightIntensity":1,"fog":false,"color":0,"lightPosition":{"x":-10,"y":18,"z":10},"lightShadowDarkness":0.35,"ambientLightColor":8947848,"skyLightIntensity":0.3},"preload":["image|/res/xd-view/meshes/scrumfield8x12.jpg","image|/res/xd-view/meshes/teama-text.jpg","image|/res/xd-view/meshes/teamb-text.jpg","image|/res/xd-view/meshes/ballUVslayout.jpg","image|/res/xd-view/meshes/pubs.jocly.jpg","smoothedfilegeo|0|/res/xd-view/meshes/target.js","smoothedfilegeo|0|/res/xd-view/meshes/stade2-xtra.js","smoothedfilegeo|0|/res/xd-view/meshes/player-anim.js","smoothedfilegeo|0|/res/xd-view/meshes/scrum-ball.js","smoothedfilegeo|0|/res/xd-view/meshes/arrow.js","smoothedfilegeo|0|/res/xd-view/meshes/arrowscrum.js"],"brand":"sg"},{"name":"scrum3dhnk","title":"Scrum 3D HNK","3d":true,"camera":{"radius":12,"limitCamMoves":true,"elevationMax":80,"rotationAngle":30,"elevationAngle":35},"world":{"lightIntensity":1,"fog":false,"color":0,"lightPosition":{"x":-10,"y":18,"z":10},"lightShadowDarkness":0.35,"ambientLightColor":8947848,"skyLightIntensity":0.3},"preload":["image|/res/xd-view/meshes/scrumfield8x12.jpg","image|/res/xd-view/meshes/teama-text.jpg","image|/res/xd-view/meshes/teamb-text.jpg","image|/res/xd-view/meshes/ballUVslayout.jpg","image|/res/xd-view/meshes/pubs.jocly.jpg","smoothedfilegeo|0|/res/xd-view/meshes/target.js","smoothedfilegeo|0|/res/xd-view/meshes/stade2-xtra.js","smoothedfilegeo|0|/res/xd-view/meshes/player-anim.js","smoothedfilegeo|0|/res/xd-view/meshes/scrum-ball.js","smoothedfilegeo|0|/res/xd-view/meshes/arrow.js","smoothedfilegeo|0|/res/xd-view/meshes/arrowscrum.js"],"brand":"hnk"},{"name":"scrum3dlr","title":"Scrum 3D LR","3d":true,"camera":{"radius":12,"limitCamMoves":true,"elevationMax":80,"rotationAngle":30,"elevationAngle":35},"world":{"lightIntensity":1,"fog":false,"color":0,"lightPosition":{"x":-10,"y":18,"z":10},"lightShadowDarkness":0.35,"ambientLightColor":8947848,"skyLightIntensity":0.3},"preload":["image|/res/xd-view/meshes/scrumfield8x12.jpg","image|/res/xd-view/meshes/teama-text.jpg","image|/res/xd-view/meshes/teamb-text.jpg","image|/res/xd-view/meshes/ballUVslayout.jpg","image|/res/xd-view/meshes/pubs.jocly.jpg","smoothedfilegeo|0|/res/xd-view/meshes/target.js","smoothedfilegeo|0|/res/xd-view/meshes/stade2-xtra.js","smoothedfilegeo|0|/res/xd-view/meshes/player-anim.js","smoothedfilegeo|0|/res/xd-view/meshes/scrum-ball.js","smoothedfilegeo|0|/res/xd-view/meshes/arrow.js","smoothedfilegeo|0|/res/xd-view/meshes/arrowscrum.js"],"brand":"lr"},{"name":"scrum3dea","title":"Scrum 3D EA","3d":true,"camera":{"radius":12,"limitCamMoves":true,"elevationMax":80,"rotationAngle":30,"elevationAngle":35},"world":{"lightIntensity":1,"fog":false,"color":0,"lightPosition":{"x":-10,"y":18,"z":10},"lightShadowDarkness":0.35,"ambientLightColor":8947848,"skyLightIntensity":0.3},"preload":["image|/res/xd-view/meshes/scrumfield8x12.jpg","image|/res/xd-view/meshes/teama-text.jpg","image|/res/xd-view/meshes/teamb-text.jpg","image|/res/xd-view/meshes/ballUVslayout.jpg","image|/res/xd-view/meshes/pubs.jocly.jpg","smoothedfilegeo|0|/res/xd-view/meshes/target.js","smoothedfilegeo|0|/res/xd-view/meshes/stade2-xtra.js","smoothedfilegeo|0|/res/xd-view/meshes/player-anim.js","smoothedfilegeo|0|/res/xd-view/meshes/scrum-ball.js","smoothedfilegeo|0|/res/xd-view/meshes/arrow.js","smoothedfilegeo|0|/res/xd-view/meshes/arrowscrum.js"],"brand":"ea"},{"name":"scrum3dcc","title":"Scrum 3D CC","3d":true,"camera":{"radius":12,"limitCamMoves":true,"elevationMax":80,"rotationAngle":30,"elevationAngle":35},"world":{"lightIntensity":1,"fog":false,"color":0,"lightPosition":{"x":-10,"y":18,"z":10},"lightShadowDarkness":0.35,"ambientLightColor":8947848,"skyLightIntensity":0.3},"preload":["image|/res/xd-view/meshes/scrumfield8x12.jpg","image|/res/xd-view/meshes/teama-text.jpg","image|/res/xd-view/meshes/teamb-text.jpg","image|/res/xd-view/meshes/ballUVslayout.jpg","image|/res/xd-view/meshes/pubs.jocly.jpg","smoothedfilegeo|0|/res/xd-view/meshes/target.js","smoothedfilegeo|0|/res/xd-view/meshes/stade2-xtra.js","smoothedfilegeo|0|/res/xd-view/meshes/player-anim.js","smoothedfilegeo|0|/res/xd-view/meshes/scrum-ball.js","smoothedfilegeo|0|/res/xd-view/meshes/arrow.js","smoothedfilegeo|0|/res/xd-view/meshes/arrowscrum.js"],"brand":"cc"},{"name":"scrum3dtb","title":"Scrum 3D TB","3d":true,"camera":{"radius":12,"limitCamMoves":true,"elevationMax":80,"rotationAngle":30,"elevationAngle":35},"world":{"lightIntensity":1,"fog":false,"color":0,"lightPosition":{"x":-10,"y":18,"z":10},"lightShadowDarkness":0.35,"ambientLightColor":8947848,"skyLightIntensity":0.3},"preload":["image|/res/xd-view/meshes/scrumfield8x12.jpg","image|/res/xd-view/meshes/teama-text.jpg","image|/res/xd-view/meshes/teamb-text.jpg","image|/res/xd-view/meshes/ballUVslayout.jpg","image|/res/xd-view/meshes/pubs.jocly.jpg","smoothedfilegeo|0|/res/xd-view/meshes/target.js","smoothedfilegeo|0|/res/xd-view/meshes/stade2-xtra.js","smoothedfilegeo|0|/res/xd-view/meshes/player-anim.js","smoothedfilegeo|0|/res/xd-view/meshes/scrum-ball.js","smoothedfilegeo|0|/res/xd-view/meshes/arrow.js","smoothedfilegeo|0|/res/xd-view/meshes/arrowscrum.js"],"brand":"tb"},{"name":"scrum3dmc","title":"Scrum 3D MC","3d":true,"camera":{"radius":12,"limitCamMoves":true,"elevationMax":80,"rotationAngle":30,"elevationAngle":35},"world":{"lightIntensity":1,"fog":false,"color":0,"lightPosition":{"x":-10,"y":18,"z":10},"lightShadowDarkness":0.35,"ambientLightColor":8947848,"skyLightIntensity":0.3},"preload":["image|/res/xd-view/meshes/scrumfield8x12.jpg","image|/res/xd-view/meshes/teama-text.jpg","image|/res/xd-view/meshes/teamb-text.jpg","image|/res/xd-view/meshes/ballUVslayout.jpg","image|/res/xd-view/meshes/pubs.jocly.jpg","smoothedfilegeo|0|/res/xd-view/meshes/target.js","smoothedfilegeo|0|/res/xd-view/meshes/stade2-xtra.js","smoothedfilegeo|0|/res/xd-view/meshes/player-anim.js","smoothedfilegeo|0|/res/xd-view/meshes/scrum-ball.js","smoothedfilegeo|0|/res/xd-view/meshes/arrow.js","smoothedfilegeo|0|/res/xd-view/meshes/arrowscrum.js"],"brand":"mc"},{"name":"scrum3ddhl","title":"Scrum 3D DHL","3d":true,"camera":{"radius":12,"limitCamMoves":true,"elevationMax":80,"rotationAngle":30,"elevationAngle":35},"world":{"lightIntensity":1,"fog":false,"color":0,"lightPosition":{"x":-10,"y":18,"z":10},"lightShadowDarkness":0.35,"ambientLightColor":8947848,"skyLightIntensity":0.3},"preload":["image|/res/xd-view/meshes/scrumfield8x12.jpg","image|/res/xd-view/meshes/teama-text.jpg","image|/res/xd-view/meshes/teamb-text.jpg","image|/res/xd-view/meshes/ballUVslayout.jpg","image|/res/xd-view/meshes/pubs.jocly.jpg","smoothedfilegeo|0|/res/xd-view/meshes/target.js","smoothedfilegeo|0|/res/xd-view/meshes/stade2-xtra.js","smoothedfilegeo|0|/res/xd-view/meshes/player-anim.js","smoothedfilegeo|0|/res/xd-view/meshes/scrum-ball.js","smoothedfilegeo|0|/res/xd-view/meshes/arrow.js","smoothedfilegeo|0|/res/xd-view/meshes/arrowscrum.js"],"brand":"dhl"},{"name":"regular","title":"Classical 2D","brand":"none","preload":["image|/res/xd-view/meshes/scrumfield8x12.jpg","image|/res/images/regular.png"]},{"name":"regularsg","title":"Classical 2D SG","brand":"sg"},{"name":"regularhnk","title":"Classical 2D HNK","brand":"hnk"},{"name":"regularlr","title":"Classical 2D LR","brand":"lr"},{"name":"regularea","title":"Classical 2D EA","brand":"ea"},{"name":"regularcc","title":"Classical 2D CC","brand":"cc"},{"name":"regulartb","title":"Classical 2D TB","brand":"tb"},{"name":"regularmc","title":"Classical 2D MC","brand":"mc"},{"name":"regulardhl","title":"Classical 2D DHL","brand":"dhl"}],"sounds":{"whistle":"whistle","win":"stadiumcrowd","loss":"stadiumcrowd","end":"stadiumcrowd"},"defaultOptions":{"sounds":true,"notation":false,"moves":true,"skin-scrum":"rugby","viewAs":1},"xdView":true,"js":["scrum-xd-view.js"],"visuals":{"600x600":["res/visuals/scrum-600x600-3d.jpg","res/visuals/scrum-600x600-2d.jpg"]},"css":["scrum.css"]}}

/***/ }),

/***/ "driz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__("mmVS");
var async_1 = __webpack_require__("CGGv");
/**
 * Emits a value from the source Observable only after a particular time span
 * has passed without another source emission.
 *
 * <span class="informal">It's like {@link delay}, but passes only the most
 * recent value from each burst of emissions.</span>
 *
 * <img src="./img/debounceTime.png" width="100%">
 *
 * `debounceTime` delays values emitted by the source Observable, but drops
 * previous pending delayed emissions if a new value arrives on the source
 * Observable. This operator keeps track of the most recent value from the
 * source Observable, and emits that only when `dueTime` enough time has passed
 * without any other value appearing on the source Observable. If a new value
 * appears before `dueTime` silence occurs, the previous value will be dropped
 * and will not be emitted on the output Observable.
 *
 * This is a rate-limiting operator, because it is impossible for more than one
 * value to be emitted in any time window of duration `dueTime`, but it is also
 * a delay-like operator since output emissions do not occur at the same time as
 * they did on the source Observable. Optionally takes a {@link IScheduler} for
 * managing timers.
 *
 * @example <caption>Emit the most recent click after a burst of clicks</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.debounceTime(1000);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link auditTime}
 * @see {@link debounce}
 * @see {@link delay}
 * @see {@link sampleTime}
 * @see {@link throttleTime}
 *
 * @param {number} dueTime The timeout duration in milliseconds (or the time
 * unit determined internally by the optional `scheduler`) for the window of
 * time required to wait for emission silence before emitting the most recent
 * source value.
 * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
 * managing the timers that handle the timeout for each value.
 * @return {Observable} An Observable that delays the emissions of the source
 * Observable by the specified `dueTime`, and may drop some values if they occur
 * too frequently.
 * @method debounceTime
 * @owner Observable
 */
function debounceTime(dueTime, scheduler) {
    if (scheduler === void 0) { scheduler = async_1.async; }
    return this.lift(new DebounceTimeOperator(dueTime, scheduler));
}
exports.debounceTime = debounceTime;
var DebounceTimeOperator = (function () {
    function DebounceTimeOperator(dueTime, scheduler) {
        this.dueTime = dueTime;
        this.scheduler = scheduler;
    }
    DebounceTimeOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new DebounceTimeSubscriber(subscriber, this.dueTime, this.scheduler));
    };
    return DebounceTimeOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var DebounceTimeSubscriber = (function (_super) {
    __extends(DebounceTimeSubscriber, _super);
    function DebounceTimeSubscriber(destination, dueTime, scheduler) {
        _super.call(this, destination);
        this.dueTime = dueTime;
        this.scheduler = scheduler;
        this.debouncedSubscription = null;
        this.lastValue = null;
        this.hasValue = false;
    }
    DebounceTimeSubscriber.prototype._next = function (value) {
        this.clearDebounce();
        this.lastValue = value;
        this.hasValue = true;
        this.add(this.debouncedSubscription = this.scheduler.schedule(dispatchNext, this.dueTime, this));
    };
    DebounceTimeSubscriber.prototype._complete = function () {
        this.debouncedNext();
        this.destination.complete();
    };
    DebounceTimeSubscriber.prototype.debouncedNext = function () {
        this.clearDebounce();
        if (this.hasValue) {
            this.destination.next(this.lastValue);
            this.lastValue = null;
            this.hasValue = false;
        }
    };
    DebounceTimeSubscriber.prototype.clearDebounce = function () {
        var debouncedSubscription = this.debouncedSubscription;
        if (debouncedSubscription !== null) {
            this.remove(debouncedSubscription);
            debouncedSubscription.unsubscribe();
            this.debouncedSubscription = null;
        }
    };
    return DebounceTimeSubscriber;
}(Subscriber_1.Subscriber));
function dispatchNext(subscriber) {
    subscriber.debouncedNext();
}
//# sourceMappingURL=debounceTime.js.map

/***/ }),

/***/ "dt2B":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = combineReducers;
function combineReducers(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for (var i = 0; i < reducerKeys.length; i++) {
        var key = reducerKeys[i];
        if (typeof reducers[key] === 'function') {
            finalReducers[key] = reducers[key];
        }
    }
    var finalReducerKeys = Object.keys(finalReducers);
    return function combination(state, action) {
        if (state === void 0) { state = {}; }
        var hasChanged = false;
        var nextState = {};
        for (var i = 0; i < finalReducerKeys.length; i++) {
            var key = finalReducerKeys[i];
            var reducer = finalReducers[key];
            var previousStateForKey = state[key];
            var nextStateForKey = reducer(previousStateForKey, action);
            nextState[key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        return hasChanged ? nextState : state;
    };
}
//# sourceMappingURL=utils.js.map

/***/ }),

/***/ "e8SQ":
/***/ (function(module, exports) {

exports.config = {"status":true,"model":{"plazza":"true","title-en":"12 Men´s Morris","module":"mills","maxLevel":7,"summary":"An old board game","thumbnail":"mensmorris12-thumb3d.png","rules":"rules.html","description":"description.html","credits":"credits.html","js":["mills-model.js","12-men-morris-model.js"],"gameOptions":{"preventRepeat":true,"width":7,"height":7,"mencount":12,"poundInMill":false},"levels":[{"label":"Easy","maxDepth":2,"potential":100,"placingRace":1,"isDefault":true},{"label":"Medium","maxDepth":4,"potential":300,"placingRace":1},{"label":"Hard","maxDepth":8,"potential":1000,"placingRace":2}]},"view":{"js":["mills-xd-view.js","12-men-morris-view.js"],"visuals":{"600x600":["res/visuals/twelvemen-600x600-3d.jpg","res/visuals/twelvemen-600x600-2d.jpg"]},"xdView":true,"css":["mills.css","12-men-morris.css"],"title-en":"12 Men´s Morris View","module":"mills","preferredRatio":1.2857142857143,"switchable":true,"animateSelfMoves":false,"useNotation":true,"useShowMoves":true,"defaultOptions":{"sounds":true,"notation":false,"moves":true},"sounds":{"move1":"move1","move2":"move2","move3":"move3","move4":"move4","tac1":"tac1","tac2":"tac2","tac3":"tac3","capture":"promo","usermove":null},"skins":[{"name":"classic3d","title":"3D Classic","3d":true,"camera":{"radius":14,"elevationAngle":45,"distMax":39.5,"distMin":10.1,"elevationMin":-89.9,"elevationMax":89.9,"limitCamMoves":true},"world":{"lightIntensity":0.6,"skyLightIntensity":0.3,"lightPosition":{"x":0,"y":18,"z":0},"color":0,"fog":false},"preload":["image|/res/xd-view/meshes/woodcell1x512.jpg","image|/res/xd-view/meshes/piecetop-bump.jpg","image|/res/xd-view/meshes/piecediff.jpg","smoothedfilegeo|0|/res/xd-view/meshes/piece-v2.js","smoothedfilegeo|0|/res/xd-view/meshes/boardoriented.js","smoothedfilegeo|0|/res/xd-view/meshes/ring-target.js"]},{"name":"stone","title":"Stone"},{"name":"suede","title":"Suede"},{"name":"wood","title":"Wood"}]}}

/***/ }),

/***/ "eErF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var toPromise_1 = __webpack_require__("nFIP");
Observable_1.Observable.prototype.toPromise = toPromise_1.toPromise;
//# sourceMappingURL=toPromise.js.map

/***/ }),

/***/ "eKS0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LAYOUT_VALUES; });
/* harmony export (immutable) */ __webpack_exports__["a"] = buildLayoutCSS;
/* harmony export (immutable) */ __webpack_exports__["c"] = validateWrapValue;
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */ var LAYOUT_VALUES = ['row', 'column', 'row-reverse', 'column-reverse'];
/**
 * Validate the direction|"direction wrap" value and then update the host's inline flexbox styles
 */
function buildLayoutCSS(value) {
    var _a = validateValue(value), direction = _a[0], wrap = _a[1];
    return buildCSS(direction, wrap);
}
/**
  * Validate the value to be one of the acceptable value options
  * Use default fallback of "row"
  */
function validateValue(value) {
    value = value ? value.toLowerCase() : '';
    var _a = value.split(" "), direction = _a[0], wrap = _a[1];
    if (!LAYOUT_VALUES.find(function (x) { return x === direction; })) {
        direction = LAYOUT_VALUES[0];
    }
    return [direction, validateWrapValue(wrap)];
}
/**
 * Convert layout-wrap="<value>" to expected flex-wrap style
 */
function validateWrapValue(value) {
    if (!!value) {
        switch (value.toLowerCase()) {
            case 'reverse':
            case 'wrap-reverse':
            case 'reverse-wrap':
                value = 'wrap-reverse';
                break;
            case 'no':
            case 'none':
            case 'nowrap':
                value = 'nowrap';
                break;
            // All other values fallback to "wrap"
            default:
                value = 'wrap';
                break;
        }
    }
    return value;
}
/**
 * Build the CSS that should be assigned to the element instance
 * BUG:
 *   1) min-height on a column flex container won’t apply to its flex item children in IE 10-11.
 *      Use height instead if possible; height : <xxx>vh;
 *
 *  This way any padding or border specified on the child elements are
 *  laid out and drawn inside that element's specified width and height.
 */
function buildCSS(direction, wrap) {
    if (wrap === void 0) { wrap = null; }
    return {
        'display': 'flex',
        'box-sizing': 'border-box',
        'flex-direction': direction,
        'flex-wrap': !!wrap ? wrap : null
    };
}
//# sourceMappingURL=layout-validator.js.map

/***/ }),

/***/ "eKwc":
/***/ (function(module, exports) {

exports.config = {"status":true,"model":{"plazza":"true","released":1402671378,"title-en":"McCooey Chess","module":"chessbase","summary":"Hexagonal Chess","thumbnail":"mccooey-thumb.png","rules":{"en":"mccooey-rules.html"},"credits":{"en":"mccooey-credits.html"},"gameOptions":{"preventRepeat":true,"uctTransposition":"state","uctIgnoreLoop":false,"levelOptions":{"pieceValueFactor":1,"pieceValueRatioFactor":1,"posValueFactor":0.1,"averageDistKingFactor":-0.01,"castleFactor":0.1,"minorPiecesMovedFactor":0.1,"checkFactor":0.2,"endingKingFreedomFactor":0.01,"endingDistKingFactor":0.05,"distKingCornerFactor":0.1,"distPawnPromo1Factor":0.3,"distPawnPromo2Factor":0.1,"distPawnPromo3Factor":0.05}},"obsolete":false,"js":["base-model.js","hex-geo-model.js","mccooey-model.js"],"description":{"en":"mccooey-description.html"},"levels":[{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"easy","label":"Easy","maxNodes":6000},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"fast","label":"Fast [3sec]","maxDuration":3,"isDefault":true},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"medium","label":"Medium","maxNodes":30000,"maxDuration":30},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"strong","label":"Strong","maxNodes":60000,"maxDuration":45}]},"view":{"title-en":"Chessbase view","module":"chessbase","xdView":true,"css":["chessbase.css","hex.css"],"preferredRatio":1,"useShowMoves":true,"useNotation":true,"useAutoComplete":true,"defaultOptions":{"sounds":true,"moves":true,"notation":false,"autocomplete":false},"skins":[{"name":"skin3d","title":"3D Classic","3d":true,"preload":["smoothedfilegeo|0|/res/ring-target-hexagon.js","image|/res/images/cancel.png","image|/res/images/wikipedia.png","smoothedfilegeo|0|/res/staunton/pawn/pawn-classic.js","image|/res/staunton/pawn/pawn-diffusemap.jpg","image|/res/staunton/pawn/pawn-normalmap.jpg","smoothedfilegeo|0|/res/staunton/knight/knight.js","image|/res/staunton/knight/knight-diffusemap.jpg","image|/res/staunton/knight/knight-normalmap.jpg","smoothedfilegeo|0|/res/staunton/bishop/bishop.js","image|/res/staunton/bishop/bishop-diffusemap.jpg","image|/res/staunton/bishop/bishop-normalmap.jpg","smoothedfilegeo|0|/res/staunton/rook/rook.js","image|/res/staunton/rook/rook-diffusemap.jpg","image|/res/staunton/rook/rook-normalmap.jpg","smoothedfilegeo|0|/res/staunton/queen/queen.js","image|/res/staunton/queen/queen-diffusemap.jpg","image|/res/staunton/queen/queen-normalmap.jpg","smoothedfilegeo|0|/res/staunton/king/king.js","image|/res/staunton/king/king-diffusemap.jpg","image|/res/staunton/king/king-normalmap.jpg"],"world":{"lightIntensity":1.3,"skyLightIntensity":1.2,"lightCastShadow":true,"fog":false,"color":4686804,"lightPosition":{"x":-9,"y":9,"z":9},"skyLightPosition":{"x":9,"y":9,"z":9},"lightShadowDarkness":0.55,"ambientLightColor":2236962},"camera":{"fov":45,"distMax":50,"radius":13.5,"elevationAngle":45,"elevationMin":0,"distMin":0}},{"name":"skin2d","title":"2D Classic","3d":false,"preload":["image|/res/images/wikipedia.png","image|/res/images/whitebg.png","image|/res/images/cancel.png"]}],"animateSelfMoves":false,"switchable":true,"sounds":{"move1":"alq_move1","move2":"alq_move2","move3":"alq_move3","move4":"alq_move2","tac1":"alq_tac1","tac2":"alq_tac2","tac3":"alq_tac1","promo":"promo","usermove":null},"js":["base-view.js","hex-board-view.js","staunton-set-view.js","mccooey-view.js"],"visuals":{"600x600":["res/visuals/mccooey-600x600-3d.jpg","res/visuals/mccooey-600x600-2d.jpg"]}}}

/***/ }),

/***/ "eZjk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("3j3K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__break_points_token__ = __webpack_require__("pvzN");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BreakPointRegistry; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


/**
 * Registry of 1..n MediaQuery breakpoint ranges
 * This is published as a provider and may be overriden from custom, application-specific ranges
 *
 */
var BreakPointRegistry = (function () {
    function BreakPointRegistry(_registry) {
        this._registry = _registry;
    }
    Object.defineProperty(BreakPointRegistry.prototype, "items", {
        /**
         * Accessor to raw list
         */
        get: function () {
            return this._registry.slice();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Search breakpoints by alias (e.g. gt-xs)
     */
    BreakPointRegistry.prototype.findByAlias = function (alias) {
        return this._registry.find(function (bp) { return bp.alias == alias; });
    };
    BreakPointRegistry.prototype.findByQuery = function (query) {
        return this._registry.find(function (bp) { return bp.mediaQuery == query; });
    };
    Object.defineProperty(BreakPointRegistry.prototype, "overlappings", {
        /**
         * Get all the breakpoints whose ranges could overlapping `normal` ranges;
         * e.g. gt-sm overlaps md, lg, and xl
         */
        get: function () {
            return this._registry.filter(function (it) { return it.overlapping == true; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BreakPointRegistry.prototype, "aliases", {
        /**
         * Get list of all registered (non-empty) breakpoint aliases
         */
        get: function () {
            return this._registry.map(function (it) { return it.alias; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BreakPointRegistry.prototype, "suffixes", {
        /**
         * Aliases are mapped to properties using suffixes
         * e.g.  'gt-sm' for property 'layout'  uses suffix 'GtSm'
         * for property layoutGtSM.
         */
        get: function () {
            return this._registry.map(function (it) { return it.suffix; });
        },
        enumerable: true,
        configurable: true
    });
    return BreakPointRegistry;
}());

BreakPointRegistry.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
];
/** @nocollapse */
BreakPointRegistry.ctorParameters = function () { return [
    { type: Array, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_1__break_points_token__["a" /* BREAKPOINTS */],] },] },
]; };
//# sourceMappingURL=break-point-registry.js.map

/***/ }),

/***/ "efBw":
/***/ (function(module, exports) {

exports.config = {"status":true,"model":{"title-en":"Spargo","module":"margo","js":["spbase-model.js","margo-model.js"],"summary":"Margo on the Shibumi platform","thumbnail":"tn-spargo.png","strings":[],"rules":{"en":"rules.html","fr":"rules-fr.html"},"description":{"en":"description.html","fr":"description-fr.html"},"credits":{"en":"credits.html","fr":"credits-fr.html"},"demoRandom":true,"gameOptions":{"preventRepeat":true,"uctTransposition":"states","uctIgnoreLoop":true,"size":4,"levelOptions":{"evalSafety":19.107304715313,"evalSafety2eyes":4.3758955150703,"evalSafetyXEyesBonus":1.7865484737243,"evalSafety1f":9.1591122993614,"evalSafety3f":35.452884571656,"evalSafety3fMore":42.512798629808,"evalSafety3fMoreBonus":0.74012620371718,"evalSafety1eyeBonus":5.894529516766,"evalSafetyPinnedBonus":0,"evalHeightRatio":0,"evalCenterRatio":0.09143959872229}},"plazza":"true","levels":[{"label":"Fast (1sec)","maxDuration":1,"isDefault":true,"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0,"ignoreLeaf":false,"uncertaintyFactor":1.0450571101395},{"label":"Beginner","maxDuration":1,"maxNodes":250,"maxLoops":50,"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0,"ignoreLeaf":false,"uncertaintyFactor":1.0450571101395},{"label":"Easy","maxDuration":2,"maxNodes":500,"maxLoops":100,"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0,"ignoreLeaf":false,"uncertaintyFactor":1.0450571101395},{"label":"Medium","maxDuration":4,"maxNodes":2500,"maxLoops":200,"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0,"ignoreLeaf":false,"uncertaintyFactor":1.0450571101395},{"label":"Confirmed","maxDuration":8,"maxNodes":5000,"maxLoops":500,"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0,"ignoreLeaf":false,"uncertaintyFactor":1.0450571101395},{"label":"Slow (10sec)","maxDuration":10,"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0,"ignoreLeaf":false,"uncertaintyFactor":1.0450571101395}]},"view":{"title-en":"Margo View","module":"margo","js":["spbase-xd-view.js"],"xdView":true,"css":["spbase.css"],"preferredRatio":1,"useNotation":true,"defaultOptions":{"sounds":true,"moves":true,"notation":false},"skins":[{"name":"classic3d","title":"3D Classic","3d":true,"camera":{"radius":20,"elevationAngle":45,"limitCamMoves":true,"distMax":40,"distMin":10,"elevationMin":-45,"elevationMax":89.9,"enableDrag":false},"world":{"lightIntensity":0,"color":0,"fog":false,"skyLightIntensity":0.7,"skyLightPosition":{"x":0,"y":10,"z":0},"ambientLightColor":8947848},"preload":["image|/res/xd-view/meshes/grey.png","image|/res/xd-view/meshes/black.png","image|/res/xd-view/meshes/white.png","image|/res/xd-view/meshes/green.png","image|/res/xd-view/meshes/skybox/nx.jpg","image|/res/xd-view/meshes/skybox/ny.jpg","image|/res/xd-view/meshes/skybox/nz.jpg","image|/res/xd-view/meshes/skybox/px.jpg","image|/res/xd-view/meshes/skybox/py.jpg","image|/res/xd-view/meshes/skybox/pz.jpg"]},{"name":"wood","title":"Wood","preload":["image|/res/images/ball_black.png","image|/res/images/ball_white.png","image|/res/images/ball_green.png","image|/res/images/plot.png","image|/res/images/wood.png"]},{"name":"classical","title":"Classic","preload":["image|/res/images/ball_black.png","image|/res/images/ball_white.png","image|/res/images/ball_green.png","image|/res/images/plot.png"]}],"animateSelfMoves":false,"visuals":{"600x600":["res/visuals/spargo-600x600-3d.jpg","res/visuals/spargo-600x600-2d.jpg"]}}}

/***/ }),

/***/ "emOw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ConnectableObservable_1 = __webpack_require__("sIYO");
/* tslint:enable:max-line-length */
/**
 * Returns an Observable that emits the results of invoking a specified selector on items
 * emitted by a ConnectableObservable that shares a single subscription to the underlying stream.
 *
 * <img src="./img/multicast.png" width="100%">
 *
 * @param {Function|Subject} subjectOrSubjectFactory - Factory function to create an intermediate subject through
 * which the source sequence's elements will be multicast to the selector function
 * or Subject to push source elements into.
 * @param {Function} [selector] - Optional selector function that can use the multicasted source stream
 * as many times as needed, without causing multiple subscriptions to the source stream.
 * Subscribers to the given source will receive all notifications of the source from the
 * time of the subscription forward.
 * @return {Observable} An Observable that emits the results of invoking the selector
 * on the items emitted by a `ConnectableObservable` that shares a single subscription to
 * the underlying stream.
 * @method multicast
 * @owner Observable
 */
function multicast(subjectOrSubjectFactory, selector) {
    var subjectFactory;
    if (typeof subjectOrSubjectFactory === 'function') {
        subjectFactory = subjectOrSubjectFactory;
    }
    else {
        subjectFactory = function subjectFactory() {
            return subjectOrSubjectFactory;
        };
    }
    if (typeof selector === 'function') {
        return this.lift(new MulticastOperator(subjectFactory, selector));
    }
    var connectable = Object.create(this, ConnectableObservable_1.connectableObservableDescriptor);
    connectable.source = this;
    connectable.subjectFactory = subjectFactory;
    return connectable;
}
exports.multicast = multicast;
var MulticastOperator = (function () {
    function MulticastOperator(subjectFactory, selector) {
        this.subjectFactory = subjectFactory;
        this.selector = selector;
    }
    MulticastOperator.prototype.call = function (subscriber, source) {
        var selector = this.selector;
        var subject = this.subjectFactory();
        var subscription = selector(subject).subscribe(subscriber);
        subscription.add(source.subscribe(subject));
        return subscription;
    };
    return MulticastOperator;
}());
exports.MulticastOperator = MulticastOperator;
//# sourceMappingURL=multicast.js.map

/***/ }),

/***/ "erNO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__("mmVS");
var Subject_1 = __webpack_require__("EEr4");
/**
 * Branch out the source Observable values as a nested Observable with each
 * nested Observable emitting at most `windowSize` values.
 *
 * <span class="informal">It's like {@link bufferCount}, but emits a nested
 * Observable instead of an array.</span>
 *
 * <img src="./img/windowCount.png" width="100%">
 *
 * Returns an Observable that emits windows of items it collects from the source
 * Observable. The output Observable emits windows every `startWindowEvery`
 * items, each containing no more than `windowSize` items. When the source
 * Observable completes or encounters an error, the output Observable emits
 * the current window and propagates the notification from the source
 * Observable. If `startWindowEvery` is not provided, then new windows are
 * started immediately at the start of the source and when each window completes
 * with size `windowSize`.
 *
 * @example <caption>Ignore every 3rd click event, starting from the first one</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.windowCount(3)
 *   .map(win => win.skip(1)) // skip first of every 3 clicks
 *   .mergeAll(); // flatten the Observable-of-Observables
 * result.subscribe(x => console.log(x));
 *
 * @example <caption>Ignore every 3rd click event, starting from the third one</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.windowCount(2, 3)
 *   .mergeAll(); // flatten the Observable-of-Observables
 * result.subscribe(x => console.log(x));
 *
 * @see {@link window}
 * @see {@link windowTime}
 * @see {@link windowToggle}
 * @see {@link windowWhen}
 * @see {@link bufferCount}
 *
 * @param {number} windowSize The maximum number of values emitted by each
 * window.
 * @param {number} [startWindowEvery] Interval at which to start a new window.
 * For example if `startWindowEvery` is `2`, then a new window will be started
 * on every other value from the source. A new window is started at the
 * beginning of the source by default.
 * @return {Observable<Observable<T>>} An Observable of windows, which in turn
 * are Observable of values.
 * @method windowCount
 * @owner Observable
 */
function windowCount(windowSize, startWindowEvery) {
    if (startWindowEvery === void 0) { startWindowEvery = 0; }
    return this.lift(new WindowCountOperator(windowSize, startWindowEvery));
}
exports.windowCount = windowCount;
var WindowCountOperator = (function () {
    function WindowCountOperator(windowSize, startWindowEvery) {
        this.windowSize = windowSize;
        this.startWindowEvery = startWindowEvery;
    }
    WindowCountOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new WindowCountSubscriber(subscriber, this.windowSize, this.startWindowEvery));
    };
    return WindowCountOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var WindowCountSubscriber = (function (_super) {
    __extends(WindowCountSubscriber, _super);
    function WindowCountSubscriber(destination, windowSize, startWindowEvery) {
        _super.call(this, destination);
        this.destination = destination;
        this.windowSize = windowSize;
        this.startWindowEvery = startWindowEvery;
        this.windows = [new Subject_1.Subject()];
        this.count = 0;
        destination.next(this.windows[0]);
    }
    WindowCountSubscriber.prototype._next = function (value) {
        var startWindowEvery = (this.startWindowEvery > 0) ? this.startWindowEvery : this.windowSize;
        var destination = this.destination;
        var windowSize = this.windowSize;
        var windows = this.windows;
        var len = windows.length;
        for (var i = 0; i < len && !this.closed; i++) {
            windows[i].next(value);
        }
        var c = this.count - windowSize + 1;
        if (c >= 0 && c % startWindowEvery === 0 && !this.closed) {
            windows.shift().complete();
        }
        if (++this.count % startWindowEvery === 0 && !this.closed) {
            var window_1 = new Subject_1.Subject();
            windows.push(window_1);
            destination.next(window_1);
        }
    };
    WindowCountSubscriber.prototype._error = function (err) {
        var windows = this.windows;
        if (windows) {
            while (windows.length > 0 && !this.closed) {
                windows.shift().error(err);
            }
        }
        this.destination.error(err);
    };
    WindowCountSubscriber.prototype._complete = function () {
        var windows = this.windows;
        if (windows) {
            while (windows.length > 0 && !this.closed) {
                windows.shift().complete();
            }
        }
        this.destination.complete();
    };
    WindowCountSubscriber.prototype._unsubscribe = function () {
        this.count = 0;
        this.windows = null;
    };
    return WindowCountSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=windowCount.js.map

/***/ }),

/***/ "esTq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base__ = __webpack_require__("TwGT");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BaseFxDirectiveAdapter; });
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

/**
 * Adapter to the BaseFxDirective abstract class so it can be used via composition.
 * @see BaseFxDirective
 */
var BaseFxDirectiveAdapter = (function (_super) {
    __extends(BaseFxDirectiveAdapter, _super);
    /**
     * BaseFxDirectiveAdapter constructor
     */
    function BaseFxDirectiveAdapter(_baseKey, // non-responsive @Input property name
        _mediaMonitor, _elementRef, _renderer) {
        var _this = _super.call(this, _mediaMonitor, _elementRef, _renderer) || this;
        _this._baseKey = _baseKey;
        _this._mediaMonitor = _mediaMonitor;
        _this._elementRef = _elementRef;
        _this._renderer = _renderer;
        return _this;
    }
    Object.defineProperty(BaseFxDirectiveAdapter.prototype, "activeKey", {
        /**
         * Accessor to determine which @Input property is "active"
         * e.g. which property value will be used.
         */
        get: function () {
            var mqa = this._mqActivation;
            var key = mqa ? mqa.activatedInputKey : this._baseKey;
            // Note: ClassDirective::SimpleChanges uses 'klazz' instead of 'class' as a key
            return (key === 'class') ? 'klazz' : key;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BaseFxDirectiveAdapter.prototype, "inputMap", {
        /** Hash map of all @Input keys/values defined/used */
        get: function () {
            return this._inputMap;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BaseFxDirectiveAdapter.prototype, "mqActivation", {
        /**
         * @see BaseFxDirective._mqActivation
         */
        get: function () {
            return this._mqActivation;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @see BaseFxDirective._queryInput
     */
    BaseFxDirectiveAdapter.prototype.queryInput = function (key) {
        return key ? this._queryInput(key) : undefined;
    };
    /**
     *  Save the property value.
     */
    BaseFxDirectiveAdapter.prototype.cacheInput = function (key, source, cacheRaw) {
        if (cacheRaw === void 0) { cacheRaw = false; }
        if (cacheRaw) {
            this._cacheInputRaw(key, source);
        }
        else if (Array.isArray(source)) {
            this._cacheInputArray(key, source);
        }
        else if (typeof source === 'object') {
            this._cacheInputObject(key, source);
        }
        else if (typeof source === 'string') {
            this._cacheInputString(key, source);
        }
        else {
            throw new Error('Invalid class value provided. Did you want to cache the raw value?');
        }
    };
    /**
     * @see BaseFxDirective._listenForMediaQueryChanges
     */
    BaseFxDirectiveAdapter.prototype.listenForMediaQueryChanges = function (key, defaultValue, onMediaQueryChange) {
        return this._listenForMediaQueryChanges(key, defaultValue, onMediaQueryChange);
    };
    // ************************************************************
    // Protected Methods
    // ************************************************************
    /**
     * No implicit transforms of the source.
     * Required when caching values expected later for KeyValueDiffers
     */
    BaseFxDirectiveAdapter.prototype._cacheInputRaw = function (key, source) {
        this._inputMap[key] = source;
    };
    /**
     *  Save the property value for Array values.
     */
    BaseFxDirectiveAdapter.prototype._cacheInputArray = function (key, source) {
        this._inputMap[key] = source.join(' ');
    };
    /**
     *  Save the property value for key/value pair values.
     */
    BaseFxDirectiveAdapter.prototype._cacheInputObject = function (key, source) {
        var classes = [];
        for (var prop in source) {
            if (!!source[prop]) {
                classes.push(prop);
            }
        }
        this._inputMap[key] = classes.join(' ');
    };
    /**
     *  Save the property value for string values.
     */
    BaseFxDirectiveAdapter.prototype._cacheInputString = function (key, source) {
        this._inputMap[key] = source;
    };
    return BaseFxDirectiveAdapter;
}(__WEBPACK_IMPORTED_MODULE_0__base__["a" /* BaseFxDirective */]));

//# sourceMappingURL=base-adapter.js.map

/***/ }),

/***/ "f1gJ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var GenerateObservable_1 = __webpack_require__("Qt4r");
Observable_1.Observable.generate = GenerateObservable_1.GenerateObservable.create;
//# sourceMappingURL=generate.js.map

/***/ }),

/***/ "f9r6":
/***/ (function(module, exports) {

exports.config = {"status":true,"model":{"plazza":"true","title-en":"9 Men´s Morris","module":"mills","maxLevel":7,"summary":"An old board game","thumbnail":"mensmorris9-thumb3d.png","rules":"rules.html","description":"description.html","credits":"credits.html","js":["mills-model.js","9-men-morris-model.js"],"gameOptions":{"preventRepeat":true,"width":7,"height":7,"mencount":9,"poundInMill":false},"levels":[{"label":"Easy","maxDepth":2,"potential":100,"placingRace":1,"isDefault":true},{"label":"Medium","maxDepth":4,"potential":300,"placingRace":1},{"label":"Hard","maxDepth":8,"potential":1000,"placingRace":2}]},"view":{"js":["mills-xd-view.js","9-men-morris-view.js"],"visuals":{"600x600":["res/visuals/ninemen-600x600-3d.jpg","res/visuals/ninemen-600x600-2d.jpg"]},"xdView":true,"css":["mills.css","9-men-morris.css"],"title-en":"7 Men´s Morris View","module":"mills","preferredRatio":1.2857142857143,"switchable":true,"animateSelfMoves":false,"useNotation":true,"useShowMoves":true,"defaultOptions":{"sounds":true,"notation":false,"moves":true},"sounds":{"move1":"move1","move2":"move2","move3":"move3","move4":"move4","tac1":"tac1","tac2":"tac2","tac3":"tac3","capture":"promo","usermove":null},"skins":[{"name":"classic3d","title":"3D Classic","3d":true,"camera":{"radius":14,"elevationAngle":45,"distMax":39.5,"distMin":10.1,"elevationMin":-89.9,"elevationMax":89.9,"limitCamMoves":true},"world":{"lightIntensity":0.6,"skyLightIntensity":0.3,"lightPosition":{"x":0,"y":18,"z":0},"color":0,"fog":false},"preload":["image|/res/xd-view/meshes/woodcell1x512.jpg","image|/res/xd-view/meshes/piecetop-bump.jpg","image|/res/xd-view/meshes/piecediff.jpg","smoothedfilegeo|0|/res/xd-view/meshes/piece-v2.js","smoothedfilegeo|0|/res/xd-view/meshes/boardoriented.js","smoothedfilegeo|0|/res/xd-view/meshes/ring-target.js"]},{"name":"stone","title":"Stone"},{"name":"suede","title":"Suede"},{"name":"wood","title":"Wood"}]}}

/***/ }),

/***/ "fC4T":
/***/ (function(module, exports) {

module.exports = function isBuffer(arg) {
  return arg && typeof arg === 'object'
    && typeof arg.copy === 'function'
    && typeof arg.fill === 'function'
    && typeof arg.readUInt8 === 'function';
}

/***/ }),

/***/ "fICK":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var merge_1 = __webpack_require__("1KT0");
Observable_1.Observable.merge = merge_1.merge;
//# sourceMappingURL=merge.js.map

/***/ }),

/***/ "fO1r":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var SubscriptionLog = (function () {
    function SubscriptionLog(subscribedFrame, unsubscribedFrame) {
        if (unsubscribedFrame === void 0) { unsubscribedFrame = Number.POSITIVE_INFINITY; }
        this.subscribedFrame = subscribedFrame;
        this.unsubscribedFrame = unsubscribedFrame;
    }
    return SubscriptionLog;
}());
exports.SubscriptionLog = SubscriptionLog;
//# sourceMappingURL=SubscriptionLog.js.map

/***/ }),

/***/ "fWbP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function isScheduler(value) {
    return value && typeof value.schedule === 'function';
}
exports.isScheduler = isScheduler;
//# sourceMappingURL=isScheduler.js.map

/***/ }),

/***/ "fWrr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
exports.games={"alquerque-bell":{title:"Alquerque",summary:"A 10th century checkers game from Middle-East.",thumbnail:"alquerque-thumb3d.png",module:"checkers"},"alquerque-avds":{title:"Alquerque AvdS",summary:"Alquerque rules proposal from a Draughts historian.",thumbnail:"alquerque-avds3-thumb.png",module:"checkers"},draughts:{title:"International Draughts",summary:"Rules for draughts as played in worldwide competitions.",thumbnail:"draughts-thumb3d.png",module:"checkers"},"english-draughts":{title:"English Draughts",summary:"A popular version of checkers on a 8x8 board.",thumbnail:"draughts8-thumb3d.png",module:"checkers"},"brazilian-draughts":{title:"Brazilian Draughts",summary:"Same as international checkers on a 8x8 board.",thumbnail:"draughts8-thumb3d.png",module:"checkers"},"spanish-draughts":{title:"Spanish Draughts",summary:"Same as international checkers on a 8x8 board, no backward capture.",thumbnail:"draughts8-thumb3d.png",module:"checkers"},"german-draughts":{title:"German Draughts",summary:"Checkers according to German Draughts rules.",thumbnail:"draughts8-thumb3d.png",module:"checkers"},"thai-draughts":{title:"Thai Draughts",summary:"Checkers according to Thai rules.",thumbnail:"draughts8-thumb3d.png",module:"checkers"},"kids-draughts":{title:"Kids Draughts",summary:"A version for kids of checkers on a 6x6 board.",thumbnail:"kidsdraughts-thumb3d.png",module:"checkers"},"turkish-draughts":{title:"Turkish Draughts",summary:"A 8x8 checkers on straight lines.",thumbnail:"turkish-thumb3d.png",module:"checkers"},"classic-chess":{title:"Chess",summary:"Regular Orthodox Classic Western Chess",thumbnail:"knight-thumbnail.png",module:"chessbase"},xiangqi:{title:"Xiangqi",summary:"Chinese Chess",thumbnail:"xiangqi-thumb.png",module:"chessbase"},"gardner-chess":{title:"Gardner MiniChess",summary:"Gardner 5x5 minichess (1969)",thumbnail:"gardner-thumb.png",module:"chessbase"},"mini4x4-chess":{title:"Mini Chess 4x4",summary:"4x4 mini chess variant",thumbnail:"mini4x4-thumb.png",module:"chessbase"},"mini4x5-chess":{title:"Mini Chess 4x5",summary:"4x5 mini chess variant",thumbnail:"mini4x5-thumb.png",module:"chessbase"},"micro4x5-chess":{title:"Micro Chess",summary:"4x5 chess variant by Glimne (1997)",thumbnail:"micro4x5-thumb.png",module:"chessbase"},"baby-chess":{title:"Baby Chess",summary:"5x5 Baby chess",thumbnail:"baby-thumb.png",module:"chessbase"},"malett-chess":{title:"Malett Chess",summary:"5x5 chess variant by Jeff Malett",thumbnail:"malett-thumb.png",module:"chessbase"},"los-alamos-chess":{title:"Los Alamos Chess",summary:"6x6 chess variant",thumbnail:"los-alamos-thumb.png",module:"chessbase"},"attack-chess":{title:"Chess Attack",summary:"5x6 chess variant",thumbnail:"attack-thumb.png",module:"chessbase"},"courier-chess":{title:"Courier Chess",summary:"12x8 chess (12th century)",thumbnail:"courier-thumb.png",module:"chessbase"},makruk:{title:"Makruk",summary:"Thai Chess",thumbnail:"mk-thumb.png",module:"chessbase"},"shako-chess":{title:"Shako",summary:"10x10 Chess",thumbnail:"shako-thumb.png",module:"chessbase"},"shatranj-chess":{title:"Shatranj",summary:"Ancient Chess",thumbnail:"shatranj-thumb.png",module:"chessbase"},raumschach:{title:"Raumschach",summary:"5x5x5 Chess",thumbnail:"raumschach-thumb.png",module:"chessbase"},"glinski-chess":{title:"Glinski Chess",summary:"Hexagonal Chess",thumbnail:"glinski-thumb.png",module:"chessbase"},"brusky-chess":{title:"Brusky Chess",summary:"Hexagonal Chess",thumbnail:"brusky-thumb.png",module:"chessbase"},"devasa-chess":{title:"De Vasa Chess",summary:"Hexagonal Chess",thumbnail:"devasa-thumb.png",module:"chessbase"},"mccooey-chess":{title:"McCooey Chess",summary:"Hexagonal Chess",thumbnail:"mccooey-thumb.png",module:"chessbase"},"shafran-chess":{title:"Shafran Chess",summary:"Hexagonal Chess",thumbnail:"shafran-thumb.png",module:"chessbase"},"circular-chess":{title:"Modern Circular Chess",summary:"Chess on a ring",thumbnail:"circular-thumb.png",module:"chessbase"},"byzantine-chess":{title:"Byzantine Chess",summary:"10th century circular Chess",thumbnail:"byzantine-thumb.png",module:"chessbase"},"3dchess":{title:"3D Chess",summary:"6x8x3 Chess",thumbnail:"3dchess-thumb.png",module:"chessbase"},"cylinder-chess":{title:"Cylinder Chess",summary:"Cylinder Chess",thumbnail:"cylinder-thumb.png",module:"chessbase"},"rollerball-chess":{title:"Rollerball Chess",summary:"Chess variant on an unusual board",thumbnail:"rollerball-thumb.png",module:"chessbase"},chess960:{title:"Chess 960",summary:"Chess from randomized positions",thumbnail:"chess960-thumb.png",module:"chessbase"},"metamachy-chess":{title:"Metamachy",summary:"Chess on 12x12 with fairy pieces",thumbnail:"metamachy-thumb.png",module:"chessbase"},"capablanca-chess":{title:"Capablanca Chess",summary:"Chess on 10x8 (1920)",thumbnail:"capablanca-thumb.png",module:"chessbase"},"carrera-chess":{title:"Carerra Chess",summary:"Chess on 10x8 (1617)",thumbnail:"carrera-thumb.png",module:"chessbase"},"gothic-chess":{title:"Gothic Chess",summary:"Chess on 10x8 (2000)",thumbnail:"gothic-thumb.png",module:"chessbase"},"janus-chess":{title:"Janus Chess",summary:"Chess on 10x8 (1978)",thumbnail:"janus-thumb.png",module:"chessbase"},"grand-chess":{title:"Grand Chess",summary:"Chess on 10x10 (1984)",thumbnail:"grand-thumb.png",module:"chessbase"},"modern-chess":{title:"Modern Chess",summary:"Chess on 9x9 (1968)",thumbnail:"modern-thumb.png",module:"chessbase"},"chancellor-chess":{title:"Chancellor Chess",summary:"Chess on 9x9 (1887)",thumbnail:"chancellor-thumb.png",module:"chessbase"},"wildebeest-chess":{title:"Wildebeest Chess",summary:"Chess on 11x10 (1987)",thumbnail:"wildebeest-thumb.png",module:"chessbase"},smess:{title:"Smess",summary:"The Ninny's Chess (1970)",thumbnail:"smess-thumb.png",module:"chessbase"},"demi-chess":{title:"Demi-Chess",summary:"4x8 chess variant by Peter Krystufek (1986)",thumbnail:"demi-thumb.png",module:"chessbase"},"romanchenko-chess":{title:"Romanchenko's Chess",summary:"Shifted 8x8 chess variant by V. Romanchenko",thumbnail:"romanchenko-thumb.png",module:"chessbase"},"amazon-chess":{title:"Amazon Chess",summary:"18th century, Russia",thumbnail:"amazon-thumb.png",module:"chessbase"},"dukerutland-chess":{title:"Duke of Rutland Chess",summary:"Chess on 14x10 (1747)",thumbnail:"dukerutland-thumb.png",module:"chessbase"},"gustav3-chess":{title:"Gustav III Chess",summary:"Gustav Johan Billberg, 1839",thumbnail:"gustav3-thumb.png",module:"chessbase"},"hyderabad-chess":{title:"Hyderabad Decimal Chess",summary:"Shir Muhammad Khan Iman, 1797-1798",thumbnail:"hyderabad-thumb.png",module:"chessbase"},"kaisergame-chess":{title:"Kaiserspiel",summary:"Tressau, 1840",thumbnail:"kaisergame-thumb.png",module:"chessbase"},"sultangame-chess":{title:"Sultanspiel",summary:"Tressau, 1840",thumbnail:"sultangame-thumb.png",module:"chessbase"},"reformed-courier-chess":{title:"Reformed Courierspiel",summary:"Clément Bégnis, 2011",thumbnail:"reformed-courier-thumb.png",module:"chessbase"},"tutti-frutti-chess":{title:"Tutti-Frutti Chess",summary:"Ralph Betza et Philip Cohen, 1978-79",thumbnail:"tutti-frutti-thumb.png",module:"chessbase"},"sweet16-chess":{title:"Sweet 16 Chess",summary:"A huge 16x16 Chess Variant",thumbnail:"sweet16-thumb.png",module:"chessbase"},fourinarow:{title:"Four In A Row",summary:"Four In A Row game",thumbnail:"fiar-thumb.png",module:"fourinarow"},fourinarow96:{title:"Four In A Row 9x6",summary:"Four In A Row on a 9x6 board",thumbnail:"fiar-thumb.png",module:"fourinarow"},fiarpopout:{title:"Popout",summary:"Four In A Row with removals",thumbnail:"fiar-thumb.png",module:"fourinarow"},fiveinarow:{title:"Five In A Row",summary:"Variant of Four In A Row",thumbnail:"fiar-thumb.png",module:"fourinarow"},torus4:{title:"Torus 4",summary:"Four In A Row on a cylinder",thumbnail:"fiar-torus-thumb.png",module:"fourinarow"},decercarlaliebre:{title:"De cercar la liebre",summary:"Middle age hunt game",thumbnail:"decercarlaliebre-thumbnail.png",module:"hunt"},mana:{title:"Mana",summary:"Capture the opponent's Damyo",thumbnail:"thumbnail.png",module:"mana"},"shibumi-spline":{title:"Spline",summary:"Shibumi game",thumbnail:"tn-shibumi-spline.png",module:"margo"},"shibumi-splineplus":{title:"Spline+",summary:"Shibumi game",thumbnail:"tn-shibumi-spline-plus.png",module:"margo"},"shibumi-spargo":{title:"Spargo",summary:"Margo on the Shibumi platform",thumbnail:"tn-spargo.png",module:"margo"},margo5:{title:"Margo 5",summary:"Margo game",thumbnail:"tn-margo5.png",module:"margo"},margo6:{title:"Margo 6",summary:"Margo game",thumbnail:"tn-margo6.png",module:"margo"},margo7:{title:"Margo 7",summary:"Margo game",thumbnail:"tn-margo7.png",module:"margo"},margo8:{title:"Margo 8",summary:"Margo game",thumbnail:"tn-margo8.png",module:"margo"},"9-men-morris":{title:"9 Men´s Morris",summary:"An old board game",thumbnail:"mensmorris9-thumb3d.png",module:"mills"},"9-men-morris-fly":{title:"9 Men´s Morris Fly",summary:"An old board game",thumbnail:"mensmorris9-thumb3d.png",module:"mills"},"12-men-morris":{title:"12 Men´s Morris",summary:"An old board game",thumbnail:"mensmorris12-thumb3d.png",module:"mills"},"12-men-morris-fly":{title:"12 Men´s Morris Fly",summary:"An old board game",thumbnail:"mensmorris12-thumb3d.png",module:"mills"},"6-men-morris":{title:"6 Men´s Morris",summary:"An old board game",thumbnail:"mensmorris6-thumb3d.png",module:"mills"},"3-men-morris":{title:"6 Men´s Morris",summary:"An old board game",thumbnail:"mensmorris3-thumb3d.png",module:"mills"},"7-men-morris":{title:"7 Men´s Morris",summary:"An old board game",thumbnail:"mensmorris7-thumb3d.png",module:"mills"},pensoc:{title:"Penguin soccer",summary:"Penguins playing soccer",thumbnail:"thumbnail.png",module:"pensoc"},reversi:{title:"Annexation",summary:"Also called Reversi or Othello",thumbnail:"thumb-reversi.png",module:"reversi"},reversi6:{title:"Annexation 6",summary:"Reversi/Othello rules on a 6x6 board",thumbnail:"thumb-reversi6.png",module:"reversi"},reversi4:{title:"Annexation 4",summary:"Reversi/Othello rules on a 4x4 board",thumbnail:"thumb-reversi4.png",module:"reversi"},reversi10:{title:"Annexation 10",summary:"Reversi/Othello rules on a 10x10 board",thumbnail:"thumb-reversi10.png",module:"reversi"},reversicross:{title:"Annexation Cross",summary:"Reversi/Othello rules on a cross-shaped board",thumbnail:"thumb-cross.png",module:"reversi"},reversicross10:{title:"Annexation Cross 10",summary:"Reversi/Othello rules on a 10x10 cross-shaped board",thumbnail:"thumb-cross10.png",module:"reversi"},reversiturnover:{title:"Annexation Turn-Over",summary:"Reversi/Othello rules on a 10x10 octogonal-shaped board",thumbnail:"thumb-turnover.png",module:"reversi"},scrum:{title:"Scrum",summary:"A little rugby game",thumbnail:"scrum-thumb3d.png",module:"scrum"},"tafl-tablut":{title:"Tablut",summary:"9x9 board (from Laponia)",thumbnail:"thumb-tafl-tablut.png",module:"tafl"},"tafl-ardri":{title:"Ardri",summary:"7x7 board (from Scotland)",thumbnail:"thumb-tafl-ardri.png",module:"tafl"},"tafl-hnefatafl":{title:"Hnefatafl",summary:"11x11 board (from Scandinavia)",thumbnail:"thumb-tafl-hnefatafl.png",module:"tafl"},tawlbwrdd:{title:"Tawlbwrdd",summary:"11x11 board (from Wales)",thumbnail:"thumb-tawlbwrdd.png",module:"tafl"},"tafl-brandubh":{title:"Brandubh",summary:"7x7 board (from Ireland)",thumbnail:"thumb-tafl-brandubh.png",module:"tafl"},"alea-evangelii":{title:"Alea Evangelii",summary:"19x19 board (from England)",thumbnail:"thumb-alea-evangelii.png",module:"tafl"},yohoho:{title:"Yohoho!",summary:"Sea Battle over hexagons",thumbnail:"yohoho-thumb3d.png",module:"yohoho"}};

/***/ }),

/***/ "fYnu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("3j3K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_platform_browser__ = __webpack_require__("Qbdm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_common__ = __webpack_require__("2Je8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_Subject__ = __webpack_require__("EEr4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_rxjs_Subject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_rxjs_Subject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_Observable__ = __webpack_require__("rCTf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_rxjs_Observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_rxjs_Observable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_add_observable_fromEvent__ = __webpack_require__("E7Yq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_rxjs_add_observable_fromEvent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_rxjs_add_observable_fromEvent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs_add_observable_merge__ = __webpack_require__("fICK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_rxjs_add_observable_merge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_rxjs_add_observable_merge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rxjs_add_operator_auditTime__ = __webpack_require__("CYDS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rxjs_add_operator_auditTime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_rxjs_add_operator_auditTime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__angular_forms__ = __webpack_require__("NVOs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__angular_animations__ = __webpack_require__("Um43");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_rxjs_add_operator_startWith__ = __webpack_require__("/lY3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_rxjs_add_operator_startWith___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_rxjs_add_operator_startWith__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_rxjs_add_operator_first__ = __webpack_require__("okk1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_rxjs_add_operator_first___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_rxjs_add_operator_first__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__angular_http__ = __webpack_require__("Fzro");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_rxjs_add_observable_forkJoin__ = __webpack_require__("iJMh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_rxjs_add_observable_forkJoin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_rxjs_add_observable_forkJoin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_rxjs_add_observable_of__ = __webpack_require__("1APj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_rxjs_add_observable_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_rxjs_add_observable_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_rxjs_add_operator_map__ = __webpack_require__("+pb+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_rxjs_add_operator_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_rxjs_add_operator_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_rxjs_add_operator_filter__ = __webpack_require__("wUn1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_rxjs_add_operator_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_rxjs_add_operator_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_rxjs_add_operator_do__ = __webpack_require__("EnA3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_rxjs_add_operator_do___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_rxjs_add_operator_do__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_rxjs_add_operator_share__ = __webpack_require__("WQmy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_rxjs_add_operator_share___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_rxjs_add_operator_share__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_rxjs_add_operator_finally__ = __webpack_require__("tDJK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_rxjs_add_operator_finally___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_rxjs_add_operator_finally__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_rxjs_add_operator_catch__ = __webpack_require__("6Yye");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_rxjs_add_operator_catch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_rxjs_add_operator_catch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_rxjs_add_observable_throw__ = __webpack_require__("h0qH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_rxjs_add_observable_throw___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_rxjs_add_observable_throw__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_rxjs_add_operator_switchMap__ = __webpack_require__("uCY4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_rxjs_add_operator_switchMap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_rxjs_add_operator_switchMap__);
/* unused harmony export Dir */
/* unused harmony export RtlModule */
/* unused harmony export ObserveContentModule */
/* unused harmony export ObserveContent */
/* unused harmony export MdOptionModule */
/* unused harmony export MdOption */
/* unused harmony export Portal */
/* unused harmony export BasePortalHost */
/* unused harmony export ComponentPortal */
/* unused harmony export TemplatePortal */
/* unused harmony export PortalHostDirective */
/* unused harmony export TemplatePortalDirective */
/* unused harmony export PortalModule */
/* unused harmony export DomPortalHost */
/* unused harmony export Overlay */
/* unused harmony export OVERLAY_PROVIDERS */
/* unused harmony export OverlayContainer */
/* unused harmony export FullscreenOverlayContainer */
/* unused harmony export OverlayRef */
/* unused harmony export OverlayState */
/* unused harmony export ConnectedOverlayDirective */
/* unused harmony export OverlayOrigin */
/* unused harmony export OverlayModule */
/* unused harmony export ScrollDispatcher */
/* unused harmony export GestureConfig */
/* unused harmony export LiveAnnouncer */
/* unused harmony export LIVE_ANNOUNCER_ELEMENT_TOKEN */
/* unused harmony export LIVE_ANNOUNCER_PROVIDER */
/* unused harmony export InteractivityChecker */
/* unused harmony export isFakeMousedownFromScreenReader */
/* unused harmony export A11yModule */
/* unused harmony export UniqueSelectionDispatcher */
/* unused harmony export UNIQUE_SELECTION_DISPATCHER_PROVIDER */
/* unused harmony export MdLineModule */
/* unused harmony export MdLine */
/* unused harmony export MdLineSetter */
/* unused harmony export MdError */
/* unused harmony export coerceBooleanProperty */
/* unused harmony export coerceNumberProperty */
/* unused harmony export CompatibilityModule */
/* unused harmony export NoConflictStyleCompatibilityMode */
/* unused harmony export MdCoreModule */
/* unused harmony export PlatformModule */
/* unused harmony export Platform */
/* unused harmony export getSupportedInputTypes */
/* unused harmony export GlobalPositionStrategy */
/* unused harmony export ConnectedPositionStrategy */
/* unused harmony export ConnectionPositionPair */
/* unused harmony export ScrollableViewProperties */
/* unused harmony export ConnectedOverlayPositionChange */
/* unused harmony export MdRipple */
/* unused harmony export MD_RIPPLE_GLOBAL_OPTIONS */
/* unused harmony export RippleRef */
/* unused harmony export RippleState */
/* unused harmony export RIPPLE_FADE_IN_DURATION */
/* unused harmony export RIPPLE_FADE_OUT_DURATION */
/* unused harmony export MdRippleModule */
/* unused harmony export SelectionModel */
/* unused harmony export SelectionChange */
/* unused harmony export FocusTrap */
/* unused harmony export FocusTrapFactory */
/* unused harmony export FocusTrapDeprecatedDirective */
/* unused harmony export FocusTrapDirective */
/* unused harmony export StyleModule */
/* unused harmony export TOUCH_BUFFER_MS */
/* unused harmony export FocusOriginMonitor */
/* unused harmony export CdkMonitorFocus */
/* unused harmony export FOCUS_ORIGIN_MONITOR_PROVIDER_FACTORY */
/* unused harmony export FOCUS_ORIGIN_MONITOR_PROVIDER */
/* unused harmony export applyCssTransform */
/* unused harmony export UP_ARROW */
/* unused harmony export DOWN_ARROW */
/* unused harmony export RIGHT_ARROW */
/* unused harmony export LEFT_ARROW */
/* unused harmony export PAGE_UP */
/* unused harmony export PAGE_DOWN */
/* unused harmony export HOME */
/* unused harmony export END */
/* unused harmony export ENTER */
/* unused harmony export SPACE */
/* unused harmony export TAB */
/* unused harmony export ESCAPE */
/* unused harmony export BACKSPACE */
/* unused harmony export DELETE */
/* unused harmony export MATERIAL_COMPATIBILITY_MODE */
/* unused harmony export MAT_ELEMENTS_SELECTOR */
/* unused harmony export MD_ELEMENTS_SELECTOR */
/* unused harmony export MatPrefixRejector */
/* unused harmony export MdPrefixRejector */
/* unused harmony export AnimationCurves */
/* unused harmony export AnimationDurations */
/* unused harmony export MdSelectionModule */
/* unused harmony export MdPseudoCheckbox */
/* unused harmony export MaterialRootModule */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MaterialModule; });
/* unused harmony export MdAutocompleteModule */
/* unused harmony export MdAutocomplete */
/* unused harmony export AUTOCOMPLETE_OPTION_HEIGHT */
/* unused harmony export AUTOCOMPLETE_PANEL_HEIGHT */
/* unused harmony export MD_AUTOCOMPLETE_VALUE_ACCESSOR */
/* unused harmony export MdAutocompleteTrigger */
/* unused harmony export MdButtonModule */
/* unused harmony export MdButtonCssMatStyler */
/* unused harmony export MdRaisedButtonCssMatStyler */
/* unused harmony export MdIconButtonCssMatStyler */
/* unused harmony export MdFabCssMatStyler */
/* unused harmony export MdMiniFabCssMatStyler */
/* unused harmony export MdButton */
/* unused harmony export MdAnchor */
/* unused harmony export MdButtonToggleModule */
/* unused harmony export MD_BUTTON_TOGGLE_GROUP_VALUE_ACCESSOR */
/* unused harmony export MdButtonToggleChange */
/* unused harmony export MdButtonToggleGroup */
/* unused harmony export MdButtonToggleGroupMultiple */
/* unused harmony export MdButtonToggle */
/* unused harmony export MdCardModule */
/* unused harmony export MdCardContent */
/* unused harmony export MdCardTitle */
/* unused harmony export MdCardSubtitle */
/* unused harmony export MdCardActions */
/* unused harmony export MdCardFooter */
/* unused harmony export MdCardSmImage */
/* unused harmony export MdCardMdImage */
/* unused harmony export MdCardLgImage */
/* unused harmony export MdCardImage */
/* unused harmony export MdCardXlImage */
/* unused harmony export MdCardAvatar */
/* unused harmony export MdCard */
/* unused harmony export MdCardHeader */
/* unused harmony export MdCardTitleGroup */
/* unused harmony export MdChipsModule */
/* unused harmony export MdChipList */
/* unused harmony export MdChip */
/* unused harmony export MdCheckboxModule */
/* unused harmony export MD_CHECKBOX_CONTROL_VALUE_ACCESSOR */
/* unused harmony export TransitionCheckState */
/* unused harmony export MdCheckboxChange */
/* unused harmony export MdCheckbox */
/* unused harmony export MdDialogModule */
/* unused harmony export MD_DIALOG_DATA */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return MdDialog; });
/* unused harmony export MdDialogContainer */
/* unused harmony export MdDialogClose */
/* unused harmony export MdDialogTitle */
/* unused harmony export MdDialogContent */
/* unused harmony export MdDialogActions */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MdDialogConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return MdDialogRef; });
/* unused harmony export MdGridListModule */
/* unused harmony export MdGridList */
/* unused harmony export MdIconModule */
/* unused harmony export MdIconRegistry */
/* unused harmony export MdIconInvalidNameError */
/* unused harmony export MdIcon */
/* unused harmony export ICON_REGISTRY_PROVIDER_FACTORY */
/* unused harmony export ICON_REGISTRY_PROVIDER */
/* unused harmony export MdInputModule */
/* unused harmony export MdTextareaAutosize */
/* unused harmony export MdPlaceholder */
/* unused harmony export MdHint */
/* unused harmony export MdErrorDirective */
/* unused harmony export MdPrefix */
/* unused harmony export MdSuffix */
/* unused harmony export MdInputDirective */
/* unused harmony export MdInputContainer */
/* unused harmony export MdInputContainerPlaceholderConflictError */
/* unused harmony export MdInputContainerUnsupportedTypeError */
/* unused harmony export MdInputContainerDuplicatedHintError */
/* unused harmony export MdInputContainerMissingMdInputError */
/* unused harmony export MdListModule */
/* unused harmony export MdListDivider */
/* unused harmony export LIST_TYPE_TOKEN */
/* unused harmony export MdList */
/* unused harmony export MdListCssMatStyler */
/* unused harmony export MdNavListCssMatStyler */
/* unused harmony export MdNavListTokenSetter */
/* unused harmony export MdDividerCssMatStyler */
/* unused harmony export MdListAvatarCssMatStyler */
/* unused harmony export MdListIconCssMatStyler */
/* unused harmony export MdListSubheaderCssMatStyler */
/* unused harmony export MdListItem */
/* unused harmony export MdMenuModule */
/* unused harmony export fadeInItems */
/* unused harmony export transformMenu */
/* unused harmony export MdMenu */
/* unused harmony export MdMenuItem */
/* unused harmony export MdMenuTrigger */
/* unused harmony export MdProgressBarModule */
/* unused harmony export MdProgressBar */
/* unused harmony export MdProgressSpinnerModule */
/* unused harmony export MdProgressSpinnerCssMatStyler */
/* unused harmony export MdProgressSpinner */
/* unused harmony export MdSpinner */
/* unused harmony export MdRadioModule */
/* unused harmony export MD_RADIO_GROUP_CONTROL_VALUE_ACCESSOR */
/* unused harmony export MdRadioChange */
/* unused harmony export MdRadioGroup */
/* unused harmony export MdRadioButton */
/* unused harmony export MdSelectModule */
/* unused harmony export fadeInContent */
/* unused harmony export transformPanel */
/* unused harmony export transformPlaceholder */
/* unused harmony export SELECT_OPTION_HEIGHT */
/* unused harmony export SELECT_PANEL_MAX_HEIGHT */
/* unused harmony export SELECT_MAX_OPTIONS_DISPLAYED */
/* unused harmony export SELECT_TRIGGER_HEIGHT */
/* unused harmony export SELECT_OPTION_HEIGHT_ADJUSTMENT */
/* unused harmony export SELECT_PANEL_PADDING_X */
/* unused harmony export SELECT_MULTIPLE_PANEL_PADDING_X */
/* unused harmony export SELECT_PANEL_PADDING_Y */
/* unused harmony export SELECT_PANEL_VIEWPORT_PADDING */
/* unused harmony export MdSelectChange */
/* unused harmony export MdSelect */
/* unused harmony export MdSidenavModule */
/* unused harmony export MdDuplicatedSidenavError */
/* unused harmony export MdSidenavToggleResult */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return MdSidenav; });
/* unused harmony export MdSidenavContainer */
/* unused harmony export MdSliderModule */
/* unused harmony export MD_SLIDER_VALUE_ACCESSOR */
/* unused harmony export MdSliderChange */
/* unused harmony export MdSlider */
/* unused harmony export SliderRenderer */
/* unused harmony export MdSlideToggleModule */
/* unused harmony export MD_SLIDE_TOGGLE_VALUE_ACCESSOR */
/* unused harmony export MdSlideToggleChange */
/* unused harmony export MdSlideToggle */
/* unused harmony export MdSnackBarModule */
/* unused harmony export MdSnackBar */
/* unused harmony export SHOW_ANIMATION */
/* unused harmony export HIDE_ANIMATION */
/* unused harmony export MdSnackBarContainer */
/* unused harmony export MdSnackBarConfig */
/* unused harmony export MdSnackBarRef */
/* unused harmony export SimpleSnackBar */
/* unused harmony export MdTabsModule */
/* unused harmony export MdInkBar */
/* unused harmony export MdTabBody */
/* unused harmony export MdTabHeader */
/* unused harmony export MdTabLabelWrapper */
/* unused harmony export MdTab */
/* unused harmony export MdTabLabel */
/* unused harmony export MdTabChangeEvent */
/* unused harmony export MdTabGroup */
/* unused harmony export MdTabNavBar */
/* unused harmony export MdTabLink */
/* unused harmony export MdTabLinkRipple */
/* unused harmony export MdToolbarModule */
/* unused harmony export MdToolbarRow */
/* unused harmony export MdToolbar */
/* unused harmony export MdTooltipModule */
/* unused harmony export TOUCHEND_HIDE_DELAY */
/* unused harmony export SCROLL_THROTTLE_MS */
/* unused harmony export MdTooltip */
/* unused harmony export TooltipComponent */
/* unused harmony export ɵf */
/* unused harmony export ɵg */
/* unused harmony export ɵb */
/* unused harmony export ɵa */
/* unused harmony export ɵk */
/* unused harmony export ɵj */
/* unused harmony export ɵi */
/* unused harmony export ɵh */
/* unused harmony export ɵd */
/* unused harmony export ɵc */
/* unused harmony export ɵl */
/* unused harmony export ɵe */
/* unused harmony export ɵo */
/* unused harmony export ɵm */
/* unused harmony export ɵq */
/* unused harmony export ɵp */
/* unused harmony export ɵn */
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
  * @license Angular Material v2.0.0-beta.3
  * Copyright (c) 2017 Google, Inc. https://material.angular.io/
  * License: MIT
  */























/** Whether we've done the global sanity checks (e.g. a theme is loaded, there is a doctype). */
var hasDoneGlobalChecks = false;
var MATERIAL_COMPATIBILITY_MODE = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["OpaqueToken"]('md-compatibility-mode');
/** Selector that matches all elements that may have style collisions with AngularJS Material. */
var MAT_ELEMENTS_SELECTOR = "\n  [mat-button],\n  [mat-dialog-actions],\n  [mat-dialog-close],\n  [mat-dialog-content],\n  [mat-dialog-title],\n  [mat-fab],\n  [mat-icon-button],\n  [mat-menu-trigger-for],\n  [mat-mini-fab],\n  [mat-raised-button],\n  [mat-tab-label],\n  [mat-tab-link],\n  [mat-tab-nav-bar],\n  [matTooltip],\n  mat-autocomplete,\n  mat-button-toggle,\n  mat-button-toggle-group,\n  mat-button-toggle,\n  mat-card,\n  mat-card-actions,\n  mat-card-content,\n  mat-card-footer,\n  mat-card-header,\n  mat-card-subtitle,\n  mat-card-title,\n  mat-card-title-group,\n  mat-checkbox,\n  mat-chip,\n  mat-dialog-actions,\n  mat-dialog-container,\n  mat-dialog-content,\n  mat-divider,\n  mat-grid-list,\n  mat-grid-tile,\n  mat-grid-tile-footer,\n  mat-grid-tile-header,\n  mat-hint,\n  mat-icon,\n  mat-list,\n  mat-list-item,\n  mat-menu,\n  mat-nav-list,\n  mat-option,\n  mat-placeholder,\n  mat-progress-bar,\n  mat-pseudo-checkbox,\n  mat-radio-button,\n  mat-radio-group,\n  mat-select,\n  mat-sidenav,\n  mat-sidenav-container,\n  mat-slider,\n  mat-spinner,\n  mat-tab,\n  mat-tab-group,\n  mat-toolbar,\n  mat-error";
/** Selector that matches all elements that may have style collisions with AngularJS Material. */
var MD_ELEMENTS_SELECTOR = "\n  [md-button],\n  [md-dialog-actions],\n  [md-dialog-close],\n  [md-dialog-content],\n  [md-dialog-title],\n  [md-fab],\n  [md-icon-button],\n  [md-menu-trigger-for],\n  [md-mini-fab],\n  [md-raised-button],\n  [md-tab-label],\n  [md-tab-link],\n  [md-tab-nav-bar],\n  [mdTooltip],\n  md-autocomplete,\n  md-button-toggle,\n  md-button-toggle-group,\n  md-button-toggle,\n  md-card,\n  md-card-actions,\n  md-card-content,\n  md-card-footer,\n  md-card-header,\n  md-card-subtitle,\n  md-card-title,\n  md-card-title-group,\n  md-checkbox,\n  md-chip,\n  md-dialog-actions,\n  md-dialog-container,\n  md-dialog-content,\n  md-divider,\n  md-grid-list,\n  md-grid-tile,\n  md-grid-tile-footer,\n  md-grid-tile-header,\n  md-hint,\n  md-icon,\n  md-list,\n  md-list-item,\n  md-menu,\n  md-nav-list,\n  md-option,\n  md-placeholder,\n  md-progress-bar,\n  md-pseudo-checkbox,\n  md-radio-button,\n  md-radio-group,\n  md-select,\n  md-sidenav,\n  md-sidenav-container,\n  md-slider,\n  md-spinner,\n  md-tab,\n  md-tab-group,\n  md-toolbar,\n  md-error";
/**
 * Directive that enforces that the `mat-` prefix cannot be used.
 */
var MatPrefixRejector = (function () {
    /**
     * @param {?} isCompatibilityMode
     */
    function MatPrefixRejector(isCompatibilityMode) {
        if (!isCompatibilityMode) {
            throw Error('The "mat-" prefix cannot be used out of ng-material v1 compatibility mode.');
        }
    }
    return MatPrefixRejector;
}());
MatPrefixRejector.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{ selector: MAT_ELEMENTS_SELECTOR },] },
];
/**
 * @nocollapse
 */
MatPrefixRejector.ctorParameters = function () { return [
    { type: undefined, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [MATERIAL_COMPATIBILITY_MODE,] },] },
]; };
/**
 * Directive that enforces that the `md-` prefix cannot be used.
 */
var MdPrefixRejector = (function () {
    /**
     * @param {?} isCompatibilityMode
     */
    function MdPrefixRejector(isCompatibilityMode) {
        if (isCompatibilityMode) {
            throw Error('The "md-" prefix cannot be used in ng-material v1 compatibility mode.');
        }
    }
    return MdPrefixRejector;
}());
MdPrefixRejector.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{ selector: MD_ELEMENTS_SELECTOR },] },
];
/**
 * @nocollapse
 */
MdPrefixRejector.ctorParameters = function () { return [
    { type: undefined, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [MATERIAL_COMPATIBILITY_MODE,] },] },
]; };
/**
 * Module that enforces the default compatibility mode settings. When this module is loaded
 * without NoConflictStyleCompatibilityMode also being imported, it will throw an error if
 * there are any uses of the `mat-` prefix.
 */
var CompatibilityModule = (function () {
    /**
     * @param {?} _document
     */
    function CompatibilityModule(_document) {
        this._document = _document;
        if (!hasDoneGlobalChecks && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["isDevMode"])()) {
            this._checkDoctype();
            this._checkTheme();
            hasDoneGlobalChecks = true;
        }
    }
    /**
     * @return {?}
     */
    CompatibilityModule.forRoot = function () {
        return {
            ngModule: CompatibilityModule,
            providers: [],
        };
    };
    /**
     * @return {?}
     */
    CompatibilityModule.prototype._checkDoctype = function () {
        if (this._document && !this._document.doctype) {
            console.warn('Current document does not have a doctype. This may cause ' +
                'some Angular Material components not to behave as expected.');
        }
    };
    /**
     * @return {?}
     */
    CompatibilityModule.prototype._checkTheme = function () {
        if (this._document) {
            var /** @type {?} */ testElement = this._document.createElement('div');
            testElement.classList.add('mat-theme-loaded-marker');
            this._document.body.appendChild(testElement);
            if (getComputedStyle(testElement).display !== 'none') {
                console.warn('Could not find Angular Material core theme. Most Material ' +
                    'components may not work as expected. For more info refer ' +
                    'to the theming guide: https://material.angular.io/guide/theming');
            }
            this._document.body.removeChild(testElement);
        }
    };
    return CompatibilityModule;
}());
CompatibilityModule.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{
                declarations: [MatPrefixRejector, MdPrefixRejector],
                exports: [MatPrefixRejector, MdPrefixRejector],
            },] },
];
/**
 * @nocollapse
 */
CompatibilityModule.ctorParameters = function () { return [
    { type: undefined, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [__WEBPACK_IMPORTED_MODULE_1__angular_platform_browser__["DOCUMENT"],] },] },
]; };
/**
 * Module that enforces "no-conflict" compatibility mode settings. When this module is loaded,
 * it will throw an error if there are any uses of the `md-` prefix.
 */
var NoConflictStyleCompatibilityMode = (function () {
    function NoConflictStyleCompatibilityMode() {
    }
    return NoConflictStyleCompatibilityMode;
}());
NoConflictStyleCompatibilityMode.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{
                providers: [{
                        provide: MATERIAL_COMPATIBILITY_MODE, useValue: true,
                    }],
            },] },
];
/**
 * @nocollapse
 */
NoConflictStyleCompatibilityMode.ctorParameters = function () { return []; };
/**
 * Shared directive to count lines inside a text area, such as a list item.
 * Line elements can be extracted with a \@ContentChildren(MdLine) query, then
 * counted by checking the query list's length.
 */
var MdLine = (function () {
    function MdLine() {
    }
    return MdLine;
}());
MdLine.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                selector: '[md-line], [mat-line]',
                host: {
                    '[class.mat-line]': 'true'
                }
            },] },
];
/**
 * @nocollapse
 */
MdLine.ctorParameters = function () { return []; };
/**
 * Helper that takes a query list of lines and sets the correct class on the host.
 * \@docs-private
 */
var MdLineSetter = (function () {
    /**
     * @param {?} _lines
     * @param {?} _renderer
     * @param {?} _element
     */
    function MdLineSetter(_lines, _renderer, _element) {
        var _this = this;
        this._lines = _lines;
        this._renderer = _renderer;
        this._element = _element;
        this._setLineClass(this._lines.length);
        this._lines.changes.subscribe(function () {
            _this._setLineClass(_this._lines.length);
        });
    }
    /**
     * @param {?} count
     * @return {?}
     */
    MdLineSetter.prototype._setLineClass = function (count) {
        this._resetClasses();
        if (count === 2 || count === 3) {
            this._setClass("mat-" + count + "-line", true);
        }
        else if (count > 3) {
            this._setClass("mat-multi-line", true);
        }
    };
    /**
     * @return {?}
     */
    MdLineSetter.prototype._resetClasses = function () {
        this._setClass('mat-2-line', false);
        this._setClass('mat-3-line', false);
        this._setClass('mat-multi-line', false);
    };
    /**
     * @param {?} className
     * @param {?} bool
     * @return {?}
     */
    MdLineSetter.prototype._setClass = function (className, bool) {
        this._renderer.setElementClass(this._element.nativeElement, className, bool);
    };
    return MdLineSetter;
}());
var MdLineModule = (function () {
    function MdLineModule() {
    }
    return MdLineModule;
}());
MdLineModule.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{
                imports: [CompatibilityModule],
                exports: [MdLine, CompatibilityModule],
                declarations: [MdLine],
            },] },
];
/**
 * @nocollapse
 */
MdLineModule.ctorParameters = function () { return []; };
/**
 * Directive to listen for changes of direction of part of the DOM.
 *
 * Applications should use this directive instead of the native attribute so that Material
 * components can listen on changes of direction.
 */
var Dir = (function () {
    function Dir() {
        /** Layout direction of the element. */
        this._dir = 'ltr';
        /** Event emitted when the direction changes. */
        this.dirChange = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
    }
    Object.defineProperty(Dir.prototype, "dir", {
        /**
         * \@docs-private
         * @return {?}
         */
        get: function () {
            return this._dir;
        },
        /**
         * @param {?} v
         * @return {?}
         */
        set: function (v) {
            var /** @type {?} */ old = this._dir;
            this._dir = v;
            if (old != this._dir) {
                this.dirChange.emit();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Dir.prototype, "value", {
        /**
         * Current layout direction of the element.
         * @return {?}
         */
        get: function () { return this.dir; },
        /**
         * @param {?} v
         * @return {?}
         */
        set: function (v) { this.dir = v; },
        enumerable: true,
        configurable: true
    });
    return Dir;
}());
Dir.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                selector: '[dir]',
                // TODO(hansl): maybe `$implicit` isn't the best option here, but for now that's the best we got.
                exportAs: '$implicit'
            },] },
];
/**
 * @nocollapse
 */
Dir.ctorParameters = function () { return []; };
Dir.propDecorators = {
    '_dir': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['dir',] },],
    'dirChange': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
    'dir': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["HostBinding"], args: ['attr.dir',] },],
};
var RtlModule = (function () {
    function RtlModule() {
    }
    /**
     * @deprecated
     * @return {?}
     */
    RtlModule.forRoot = function () {
        return {
            ngModule: RtlModule,
            providers: []
        };
    };
    return RtlModule;
}());
RtlModule.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{
                exports: [Dir],
                declarations: [Dir]
            },] },
];
/**
 * @nocollapse
 */
RtlModule.ctorParameters = function () { return []; };
/**
 * Directive that triggers a callback whenever the content of
 * its associated element has changed.
 */
var ObserveContent = (function () {
    /**
     * @param {?} _elementRef
     */
    function ObserveContent(_elementRef) {
        this._elementRef = _elementRef;
        /** Event emitted for each change in the element's content. */
        this.event = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
    }
    /**
     * @return {?}
     */
    ObserveContent.prototype.ngAfterContentInit = function () {
        var _this = this;
        this._observer = new MutationObserver(function (mutations) { return mutations.forEach(function () { return _this.event.emit(); }); });
        this._observer.observe(this._elementRef.nativeElement, {
            characterData: true,
            childList: true,
            subtree: true
        });
    };
    /**
     * @return {?}
     */
    ObserveContent.prototype.ngOnDestroy = function () {
        if (this._observer) {
            this._observer.disconnect();
        }
    };
    return ObserveContent;
}());
ObserveContent.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                selector: '[cdkObserveContent]'
            },] },
];
/**
 * @nocollapse
 */
ObserveContent.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
]; };
ObserveContent.propDecorators = {
    'event': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"], args: ['cdkObserveContent',] },],
};
var ObserveContentModule = (function () {
    function ObserveContentModule() {
    }
    /**
     * @deprecated
     * @return {?}
     */
    ObserveContentModule.forRoot = function () {
        return {
            ngModule: ObserveContentModule,
            providers: []
        };
    };
    return ObserveContentModule;
}());
ObserveContentModule.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{
                exports: [ObserveContent],
                declarations: [ObserveContent]
            },] },
];
/**
 * @nocollapse
 */
ObserveContentModule.ctorParameters = function () { return []; };
// Due to a bug in the ChromeDriver, Angular keyboard events are not triggered by `sendKeys`
// during E2E tests when using dot notation such as `(keydown.rightArrow)`. To get around this,
// we are temporarily using a single (keydown) handler.
// See: https://github.com/angular/angular/issues/9419
var UP_ARROW = 38;
var DOWN_ARROW = 40;
var RIGHT_ARROW = 39;
var LEFT_ARROW = 37;
var PAGE_UP = 33;
var PAGE_DOWN = 34;
var HOME = 36;
var END = 35;
var ENTER = 13;
var SPACE = 32;
var TAB = 9;
var ESCAPE = 27;
var BACKSPACE = 8;
var DELETE = 46;
/**
 * Coerces a data-bound value (typically a string) to a boolean.
 * @param {?} value
 * @return {?}
 */
function coerceBooleanProperty(value) {
    return value != null && "" + value !== 'false';
}
var RippleState = {};
RippleState.FADING_IN = 0;
RippleState.VISIBLE = 1;
RippleState.FADING_OUT = 2;
RippleState.HIDDEN = 3;
RippleState[RippleState.FADING_IN] = "FADING_IN";
RippleState[RippleState.VISIBLE] = "VISIBLE";
RippleState[RippleState.FADING_OUT] = "FADING_OUT";
RippleState[RippleState.HIDDEN] = "HIDDEN";
/**
 * Reference to a previously launched ripple element.
 */
var RippleRef = (function () {
    /**
     * @param {?} _renderer
     * @param {?} element
     * @param {?} config
     */
    function RippleRef(_renderer, element, config) {
        this._renderer = _renderer;
        this.element = element;
        this.config = config;
        /** Current state of the ripple reference. */
        this.state = RippleState.HIDDEN;
    }
    /**
     * Fades out the ripple element.
     * @return {?}
     */
    RippleRef.prototype.fadeOut = function () {
        this._renderer.fadeOutRipple(this);
    };
    return RippleRef;
}());
/** Fade-in duration for the ripples. Can be modified with the speedFactor option. */
var RIPPLE_FADE_IN_DURATION = 450;
/** Fade-out duration for the ripples in milliseconds. This can't be modified by the speedFactor. */
var RIPPLE_FADE_OUT_DURATION = 400;
/**
 * Helper service that performs DOM manipulations. Not intended to be used outside this module.
 * The constructor takes a reference to the ripple directive's host element and a map of DOM
 * event handlers to be installed on the element that triggers ripple animations.
 * This will eventually become a custom renderer once Angular support exists.
 * \@docs-private
 */
var RippleRenderer = (function () {
    /**
     * @param {?} _elementRef
     * @param {?} _ngZone
     * @param {?} _ruler
     */
    function RippleRenderer(_elementRef, _ngZone, _ruler) {
        this._ngZone = _ngZone;
        this._ruler = _ruler;
        this._isMousedown = false;
        this._triggerEvents = new Map();
        this._activeRipples = new Set();
        /** Ripple config for all ripples created by events. */
        this.rippleConfig = {};
        /** Whether mouse ripples should be created or not. */
        this.rippleDisabled = false;
        this._containerElement = _elementRef.nativeElement;
        // Specify events which need to be registered on the trigger.
        this._triggerEvents.set('mousedown', this.onMousedown.bind(this));
        this._triggerEvents.set('mouseup', this.onMouseup.bind(this));
        this._triggerEvents.set('mouseleave', this.onMouseLeave.bind(this));
        // By default use the host element as trigger element.
        this.setTriggerElement(this._containerElement);
    }
    /**
     * Fades in a ripple at the given coordinates.
     * @param {?} pageX
     * @param {?} pageY
     * @param {?=} config
     * @return {?}
     */
    RippleRenderer.prototype.fadeInRipple = function (pageX, pageY, config) {
        var _this = this;
        if (config === void 0) { config = {}; }
        var /** @type {?} */ containerRect = this._containerElement.getBoundingClientRect();
        if (config.centered) {
            pageX = containerRect.left + containerRect.width / 2;
            pageY = containerRect.top + containerRect.height / 2;
        }
        else {
            // Subtract scroll values from the coordinates because calculations below
            // are always relative to the viewport rectangle.
            var /** @type {?} */ scrollPosition = this._ruler.getViewportScrollPosition();
            pageX -= scrollPosition.left;
            pageY -= scrollPosition.top;
        }
        var /** @type {?} */ radius = config.radius || distanceToFurthestCorner(pageX, pageY, containerRect);
        var /** @type {?} */ duration = RIPPLE_FADE_IN_DURATION * (1 / (config.speedFactor || 1));
        var /** @type {?} */ offsetX = pageX - containerRect.left;
        var /** @type {?} */ offsetY = pageY - containerRect.top;
        var /** @type {?} */ ripple = document.createElement('div');
        ripple.classList.add('mat-ripple-element');
        ripple.style.left = offsetX - radius + "px";
        ripple.style.top = offsetY - radius + "px";
        ripple.style.height = radius * 2 + "px";
        ripple.style.width = radius * 2 + "px";
        // If the color is not set, the default CSS color will be used.
        ripple.style.backgroundColor = config.color;
        ripple.style.transitionDuration = duration + "ms";
        this._containerElement.appendChild(ripple);
        // By default the browser does not recalculate the styles of dynamically created
        // ripple elements. This is critical because then the `scale` would not animate properly.
        enforceStyleRecalculation(ripple);
        ripple.style.transform = 'scale(1)';
        // Exposed reference to the ripple that will be returned.
        var /** @type {?} */ rippleRef = new RippleRef(this, ripple, config);
        rippleRef.state = RippleState.FADING_IN;
        // Add the ripple reference to the list of all active ripples.
        this._activeRipples.add(rippleRef);
        // Wait for the ripple element to be completely faded in.
        // Once it's faded in, the ripple can be hidden immediately if the mouse is released.
        this.runTimeoutOutsideZone(function () {
            rippleRef.state = RippleState.VISIBLE;
            if (!config.persistent && !_this._isMousedown) {
                rippleRef.fadeOut();
            }
        }, duration);
        return rippleRef;
    };
    /**
     * Fades out a ripple reference.
     * @param {?} rippleRef
     * @return {?}
     */
    RippleRenderer.prototype.fadeOutRipple = function (rippleRef) {
        // For ripples that are not active anymore, don't re-un the fade-out animation.
        if (!this._activeRipples.delete(rippleRef)) {
            return;
        }
        var /** @type {?} */ rippleEl = rippleRef.element;
        rippleEl.style.transitionDuration = RIPPLE_FADE_OUT_DURATION + "ms";
        rippleEl.style.opacity = '0';
        rippleRef.state = RippleState.FADING_OUT;
        // Once the ripple faded out, the ripple can be safely removed from the DOM.
        this.runTimeoutOutsideZone(function () {
            rippleRef.state = RippleState.HIDDEN;
            rippleEl.parentNode.removeChild(rippleEl);
        }, RIPPLE_FADE_OUT_DURATION);
    };
    /**
     * Fades out all currently active ripples.
     * @return {?}
     */
    RippleRenderer.prototype.fadeOutAll = function () {
        this._activeRipples.forEach(function (ripple) { return ripple.fadeOut(); });
    };
    /**
     * Sets the trigger element and registers the mouse events.
     * @param {?} element
     * @return {?}
     */
    RippleRenderer.prototype.setTriggerElement = function (element) {
        var _this = this;
        // Remove all previously register event listeners from the trigger element.
        if (this._triggerElement) {
            this._triggerEvents.forEach(function (fn, type) { return _this._triggerElement.removeEventListener(type, fn); });
        }
        if (element) {
            // If the element is not null, register all event listeners on the trigger element.
            this._ngZone.runOutsideAngular(function () {
                _this._triggerEvents.forEach(function (fn, type) { return element.addEventListener(type, fn); });
            });
        }
        this._triggerElement = element;
    };
    /**
     * Listener being called on mousedown event.
     * @param {?} event
     * @return {?}
     */
    RippleRenderer.prototype.onMousedown = function (event) {
        if (!this.rippleDisabled) {
            this._isMousedown = true;
            this.fadeInRipple(event.pageX, event.pageY, this.rippleConfig);
        }
    };
    /**
     * Listener being called on mouseup event.
     * @return {?}
     */
    RippleRenderer.prototype.onMouseup = function () {
        this._isMousedown = false;
        // Fade-out all ripples that are completely visible and not persistent.
        this._activeRipples.forEach(function (ripple) {
            if (!ripple.config.persistent && ripple.state === RippleState.VISIBLE) {
                ripple.fadeOut();
            }
        });
    };
    /**
     * Listener being called on mouseleave event.
     * @return {?}
     */
    RippleRenderer.prototype.onMouseLeave = function () {
        if (this._isMousedown) {
            this.onMouseup();
        }
    };
    /**
     * Runs a timeout outside of the Angular zone to avoid triggering the change detection.
     * @param {?} fn
     * @param {?=} delay
     * @return {?}
     */
    RippleRenderer.prototype.runTimeoutOutsideZone = function (fn, delay) {
        if (delay === void 0) { delay = 0; }
        this._ngZone.runOutsideAngular(function () { return setTimeout(fn, delay); });
    };
    return RippleRenderer;
}());
/**
 * @param {?} element
 * @return {?}
 */
function enforceStyleRecalculation(element) {
    // Enforce a style recalculation by calling `getComputedStyle` and accessing any property.
    // Calling `getPropertyValue` is important to let optimizers know that this is not a noop.
    // See: https://gist.github.com/paulirish/5d52fb081b3570c81e3a
    window.getComputedStyle(element).getPropertyValue('opacity');
}
/**
 * Returns the distance from the point (x, y) to the furthest corner of a rectangle.
 * @param {?} x
 * @param {?} y
 * @param {?} rect
 * @return {?}
 */
function distanceToFurthestCorner(x, y, rect) {
    var /** @type {?} */ distX = Math.max(Math.abs(x - rect.left), Math.abs(x - rect.right));
    var /** @type {?} */ distY = Math.max(Math.abs(y - rect.top), Math.abs(y - rect.bottom));
    return Math.sqrt(distX * distX + distY * distY);
}
/** Time in ms to throttle the scrolling events by default. */
var DEFAULT_SCROLL_TIME = 20;
/**
 * Service contained all registered Scrollable references and emits an event when any one of the
 * Scrollable references emit a scrolled event.
 */
var ScrollDispatcher = (function () {
    /**
     * @param {?} _ngZone
     */
    function ScrollDispatcher(_ngZone) {
        this._ngZone = _ngZone;
        /** Subject for notifying that a registered scrollable reference element has been scrolled. */
        this._scrolled = new __WEBPACK_IMPORTED_MODULE_3_rxjs_Subject__["Subject"]();
        /** Keeps track of the global `scroll` and `resize` subscriptions. */
        this._globalSubscription = null;
        this._scrolledCount = 0;
        /**
         * Map of all the scrollable references that are registered with the service and their
         * scroll event subscriptions.
         */
        this.scrollableReferences = new Map();
    }
    /**
     * Registers a Scrollable with the service and listens for its scrolled events. When the
     * scrollable is scrolled, the service emits the event in its scrolled observable.
     * @param {?} scrollable Scrollable instance to be registered.
     * @return {?}
     */
    ScrollDispatcher.prototype.register = function (scrollable) {
        var _this = this;
        var /** @type {?} */ scrollSubscription = scrollable.elementScrolled().subscribe(function () { return _this._notify(); });
        this.scrollableReferences.set(scrollable, scrollSubscription);
    };
    /**
     * Deregisters a Scrollable reference and unsubscribes from its scroll event observable.
     * @param {?} scrollable Scrollable instance to be deregistered.
     * @return {?}
     */
    ScrollDispatcher.prototype.deregister = function (scrollable) {
        if (this.scrollableReferences.has(scrollable)) {
            this.scrollableReferences.get(scrollable).unsubscribe();
            this.scrollableReferences.delete(scrollable);
        }
    };
    /**
     * Subscribes to an observable that emits an event whenever any of the registered Scrollable
     * references (or window, document, or body) fire a scrolled event. Can provide a time in ms
     * to override the default "throttle" time.
     * @param {?=} auditTimeInMs
     * @param {?=} callback
     * @return {?}
     */
    ScrollDispatcher.prototype.scrolled = function (auditTimeInMs, callback) {
        var _this = this;
        if (auditTimeInMs === void 0) { auditTimeInMs = DEFAULT_SCROLL_TIME; }
        // In the case of a 0ms delay, use an observable without auditTime
        // since it does add a perceptible delay in processing overhead.
        var /** @type {?} */ observable = auditTimeInMs > 0 ?
            this._scrolled.asObservable().auditTime(auditTimeInMs) :
            this._scrolled.asObservable();
        this._scrolledCount++;
        if (!this._globalSubscription) {
            this._globalSubscription = this._ngZone.runOutsideAngular(function () {
                return __WEBPACK_IMPORTED_MODULE_4_rxjs_Observable__["Observable"].merge(__WEBPACK_IMPORTED_MODULE_4_rxjs_Observable__["Observable"].fromEvent(window.document, 'scroll'), __WEBPACK_IMPORTED_MODULE_4_rxjs_Observable__["Observable"].fromEvent(window, 'resize')).subscribe(function () { return _this._notify(); });
            });
        }
        // Note that we need to do the subscribing from here, in order to be able to remove
        // the global event listeners once there are no more subscriptions.
        var /** @type {?} */ subscription = observable.subscribe(callback);
        subscription.add(function () {
            _this._scrolledCount--;
            if (_this._globalSubscription && !_this.scrollableReferences.size && !_this._scrolledCount) {
                _this._globalSubscription.unsubscribe();
                _this._globalSubscription = null;
            }
        });
        return subscription;
    };
    /**
     * Returns all registered Scrollables that contain the provided element.
     * @param {?} elementRef
     * @return {?}
     */
    ScrollDispatcher.prototype.getScrollContainers = function (elementRef) {
        var _this = this;
        var /** @type {?} */ scrollingContainers = [];
        this.scrollableReferences.forEach(function (subscription, scrollable) {
            if (_this.scrollableContainsElement(scrollable, elementRef)) {
                scrollingContainers.push(scrollable);
            }
        });
        return scrollingContainers;
    };
    /**
     * Returns true if the element is contained within the provided Scrollable.
     * @param {?} scrollable
     * @param {?} elementRef
     * @return {?}
     */
    ScrollDispatcher.prototype.scrollableContainsElement = function (scrollable, elementRef) {
        var /** @type {?} */ element = elementRef.nativeElement;
        var /** @type {?} */ scrollableElement = scrollable.getElementRef().nativeElement;
        // Traverse through the element parents until we reach null, checking if any of the elements
        // are the scrollable's element.
        do {
            if (element == scrollableElement) {
                return true;
            }
        } while (element = element.parentElement);
    };
    /**
     * Sends a notification that a scroll event has been fired.
     * @return {?}
     */
    ScrollDispatcher.prototype._notify = function () {
        this._scrolled.next();
    };
    return ScrollDispatcher;
}());
ScrollDispatcher.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
];
/**
 * @nocollapse
 */
ScrollDispatcher.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgZone"], },
]; };
/**
 * @param {?} parentDispatcher
 * @param {?} ngZone
 * @return {?}
 */
function SCROLL_DISPATCHER_PROVIDER_FACTORY(parentDispatcher, ngZone) {
    return parentDispatcher || new ScrollDispatcher(ngZone);
}
var SCROLL_DISPATCHER_PROVIDER = {
    // If there is already a ScrollDispatcher available, use that. Otherwise, provide a new one.
    provide: ScrollDispatcher,
    deps: [[new __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"](), new __WEBPACK_IMPORTED_MODULE_0__angular_core__["SkipSelf"](), ScrollDispatcher], __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgZone"]],
    useFactory: SCROLL_DISPATCHER_PROVIDER_FACTORY
};
/**
 * Simple utility for getting the bounds of the browser viewport.
 * \@docs-private
 */
var ViewportRuler = (function () {
    /**
     * @param {?} scrollDispatcher
     */
    function ViewportRuler(scrollDispatcher) {
        var _this = this;
        // Initially cache the document rectangle.
        this._cacheViewportGeometry();
        // Subscribe to scroll and resize events and update the document rectangle on changes.
        scrollDispatcher.scrolled(null, function () { return _this._cacheViewportGeometry(); });
    }
    /**
     * Gets a ClientRect for the viewport's bounds.
     * @param {?=} documentRect
     * @return {?}
     */
    ViewportRuler.prototype.getViewportRect = function (documentRect) {
        if (documentRect === void 0) { documentRect = this._documentRect; }
        // Use the document element's bounding rect rather than the window scroll properties
        // (e.g. pageYOffset, scrollY) due to in issue in Chrome and IE where window scroll
        // properties and client coordinates (boundingClientRect, clientX/Y, etc.) are in different
        // conceptual viewports. Under most circumstances these viewports are equivalent, but they
        // can disagree when the page is pinch-zoomed (on devices that support touch).
        // See https://bugs.chromium.org/p/chromium/issues/detail?id=489206#c4
        // We use the documentElement instead of the body because, by default (without a css reset)
        // browsers typically give the document body an 8px margin, which is not included in
        // getBoundingClientRect().
        var /** @type {?} */ scrollPosition = this.getViewportScrollPosition(documentRect);
        var /** @type {?} */ height = window.innerHeight;
        var /** @type {?} */ width = window.innerWidth;
        return {
            top: scrollPosition.top,
            left: scrollPosition.left,
            bottom: scrollPosition.top + height,
            right: scrollPosition.left + width,
            height: height,
            width: width,
        };
    };
    /**
     * Gets the (top, left) scroll position of the viewport.
     * @param {?=} documentRect
     * @return {?}
     */
    ViewportRuler.prototype.getViewportScrollPosition = function (documentRect) {
        if (documentRect === void 0) { documentRect = this._documentRect; }
        // The top-left-corner of the viewport is determined by the scroll position of the document
        // body, normally just (scrollLeft, scrollTop). However, Chrome and Firefox disagree about
        // whether `document.body` or `document.documentElement` is the scrolled element, so reading
        // `scrollTop` and `scrollLeft` is inconsistent. However, using the bounding rect of
        // `document.documentElement` works consistently, where the `top` and `left` values will
        // equal negative the scroll position.
        var /** @type {?} */ top = -documentRect.top || document.body.scrollTop || window.scrollY || 0;
        var /** @type {?} */ left = -documentRect.left || document.body.scrollLeft || window.scrollX || 0;
        return { top: top, left: left };
    };
    /**
     * Caches the latest client rectangle of the document element.
     * @return {?}
     */
    ViewportRuler.prototype._cacheViewportGeometry = function () {
        this._documentRect = document.documentElement.getBoundingClientRect();
    };
    return ViewportRuler;
}());
ViewportRuler.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
];
/**
 * @nocollapse
 */
ViewportRuler.ctorParameters = function () { return [
    { type: ScrollDispatcher, },
]; };
/**
 * @param {?} parentRuler
 * @param {?} scrollDispatcher
 * @return {?}
 */
function VIEWPORT_RULER_PROVIDER_FACTORY(parentRuler, scrollDispatcher) {
    return parentRuler || new ViewportRuler(scrollDispatcher);
}
var VIEWPORT_RULER_PROVIDER = {
    // If there is already a ViewportRuler available, use that. Otherwise, provide a new one.
    provide: ViewportRuler,
    deps: [[new __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"](), new __WEBPACK_IMPORTED_MODULE_0__angular_core__["SkipSelf"](), ViewportRuler], ScrollDispatcher],
    useFactory: VIEWPORT_RULER_PROVIDER_FACTORY
};
/** OpaqueToken that can be used to specify the global ripple options. */
var MD_RIPPLE_GLOBAL_OPTIONS = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["OpaqueToken"]('md-ripple-global-options');
var MdRipple = (function () {
    /**
     * @param {?} elementRef
     * @param {?} ngZone
     * @param {?} ruler
     * @param {?} globalOptions
     */
    function MdRipple(elementRef, ngZone, ruler, 
        // Type needs to be `any` because of https://github.com/angular/angular/issues/12631
        globalOptions) {
        /**
         * If set, the radius in pixels of foreground ripples when fully expanded. If unset, the radius
         * will be the distance from the center of the ripple to the furthest corner of the host element's
         * bounding rectangle.
         */
        this.radius = 0;
        /**
         * If set, the normal duration of ripple animations is divided by this value. For example,
         * setting it to 0.5 will cause the animations to take twice as long.
         * A changed speedFactor will not modify the fade-out duration of the ripples.
         */
        this.speedFactor = 1;
        this._rippleRenderer = new RippleRenderer(elementRef, ngZone, ruler);
        this._globalOptions = globalOptions ? globalOptions : {};
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    MdRipple.prototype.ngOnChanges = function (changes) {
        if (changes['trigger'] && this.trigger) {
            this._rippleRenderer.setTriggerElement(this.trigger);
        }
        this._rippleRenderer.rippleDisabled = this._globalOptions.disabled || this.disabled;
        this._rippleRenderer.rippleConfig = this.rippleConfig;
    };
    /**
     * @return {?}
     */
    MdRipple.prototype.ngOnDestroy = function () {
        // Set the trigger element to null to cleanup all listeners.
        this._rippleRenderer.setTriggerElement(null);
    };
    /**
     * Launches a manual ripple at the specified position.
     * @param {?} pageX
     * @param {?} pageY
     * @param {?=} config
     * @return {?}
     */
    MdRipple.prototype.launch = function (pageX, pageY, config) {
        if (config === void 0) { config = this.rippleConfig; }
        return this._rippleRenderer.fadeInRipple(pageX, pageY, config);
    };
    /**
     * Fades out all currently showing ripple elements.
     * @return {?}
     */
    MdRipple.prototype.fadeOutAll = function () {
        this._rippleRenderer.fadeOutAll();
    };
    Object.defineProperty(MdRipple.prototype, "rippleConfig", {
        /**
         * Ripple configuration from the directive's input values.
         * @return {?}
         */
        get: function () {
            return {
                centered: this.centered,
                speedFactor: this.speedFactor * (this._globalOptions.baseSpeedFactor || 1),
                radius: this.radius,
                color: this.color
            };
        },
        enumerable: true,
        configurable: true
    });
    return MdRipple;
}());
MdRipple.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                selector: '[md-ripple], [mat-ripple], [mdRipple], [matRipple]',
                exportAs: 'mdRipple',
                host: {
                    '[class.mat-ripple]': 'true',
                    '[class.mat-ripple-unbounded]': 'unbounded'
                }
            },] },
];
/**
 * @nocollapse
 */
MdRipple.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgZone"], },
    { type: ViewportRuler, },
    { type: undefined, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [MD_RIPPLE_GLOBAL_OPTIONS,] },] },
]; };
MdRipple.propDecorators = {
    'trigger': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['mdRippleTrigger',] },],
    'centered': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['mdRippleCentered',] },],
    'disabled': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['mdRippleDisabled',] },],
    'radius': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['mdRippleRadius',] },],
    'speedFactor': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['mdRippleSpeedFactor',] },],
    'color': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['mdRippleColor',] },],
    'unbounded': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['mdRippleUnbounded',] },],
};
var MdRippleModule = (function () {
    function MdRippleModule() {
    }
    /**
     * @deprecated
     * @return {?}
     */
    MdRippleModule.forRoot = function () {
        return {
            ngModule: MdRippleModule,
            providers: []
        };
    };
    return MdRippleModule;
}());
MdRippleModule.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{
                imports: [CompatibilityModule],
                exports: [MdRipple, CompatibilityModule],
                declarations: [MdRipple],
                providers: [VIEWPORT_RULER_PROVIDER, SCROLL_DISPATCHER_PROVIDER],
            },] },
];
/**
 * @nocollapse
 */
MdRippleModule.ctorParameters = function () { return []; };
/**
 * Component that shows a simplified checkbox without including any kind of "real" checkbox.
 * Meant to be used when the checkbox is purely decorative and a large number of them will be
 * included, such as for the options in a multi-select. Uses no SVGs or complex animations.
 *
 * Note that this component will be completely invisible to screen-reader users. This is *not*
 * interchangeable with <md-checkbox> and should *not* be used if the user would directly interact
 * with the checkbox. The pseudo-checkbox should only be used as an implementation detail of
 * more complex components that appropriately handle selected / checked state.
 * \@docs-private
 */
var MdPseudoCheckbox = (function () {
    /**
     * @param {?} _elementRef
     * @param {?} _renderer
     */
    function MdPseudoCheckbox(_elementRef, _renderer) {
        this._elementRef = _elementRef;
        this._renderer = _renderer;
        /** Display state of the checkbox. */
        this.state = 'unchecked';
        /** Whether the checkbox is disabled. */
        this.disabled = false;
        this.color = 'accent';
    }
    Object.defineProperty(MdPseudoCheckbox.prototype, "color", {
        /**
         * Color of the checkbox.
         * @return {?}
         */
        get: function () { return this._color; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            if (value) {
                var /** @type {?} */ nativeElement = this._elementRef.nativeElement;
                this._renderer.setElementClass(nativeElement, "mat-" + this.color, false);
                this._renderer.setElementClass(nativeElement, "mat-" + value, true);
                this._color = value;
            }
        },
        enumerable: true,
        configurable: true
    });
    ;
    return MdPseudoCheckbox;
}());
MdPseudoCheckbox.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{ encapsulation: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewEncapsulation"].None,
                selector: 'md-pseudo-checkbox, mat-pseudo-checkbox',
                styles: [".mat-pseudo-checkbox{width:20px;height:20px;border:2px solid;border-radius:2px;cursor:pointer;display:inline-block;vertical-align:middle;box-sizing:border-box;position:relative;transition:border-color 90ms cubic-bezier(0,0,.2,.1),background-color 90ms cubic-bezier(0,0,.2,.1)}.mat-pseudo-checkbox::after{position:absolute;opacity:0;content:'';border-bottom:2px solid currentColor;transition:opacity 90ms cubic-bezier(0,0,.2,.1)}.mat-pseudo-checkbox.mat-pseudo-checkbox-checked,.mat-pseudo-checkbox.mat-pseudo-checkbox-indeterminate{border:none}.mat-pseudo-checkbox-disabled{cursor:default}.mat-pseudo-checkbox-indeterminate::after{top:9px;left:2px;width:16px;opacity:1}.mat-pseudo-checkbox-checked::after{top:5px;left:3px;width:12px;height:5px;border-left:2px solid currentColor;transform:rotate(-45deg);opacity:1} /*# sourceMappingURL=pseudo-checkbox.css.map */ "],
                template: '',
                host: {
                    '[class.mat-pseudo-checkbox]': 'true',
                    '[class.mat-pseudo-checkbox-indeterminate]': 'state === "indeterminate"',
                    '[class.mat-pseudo-checkbox-checked]': 'state === "checked"',
                    '[class.mat-pseudo-checkbox-disabled]': 'disabled',
                },
            },] },
];
/**
 * @nocollapse
 */
MdPseudoCheckbox.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
]; };
MdPseudoCheckbox.propDecorators = {
    'state': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'disabled': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'color': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
};
var MdSelectionModule = (function () {
    function MdSelectionModule() {
    }
    return MdSelectionModule;
}());
MdSelectionModule.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{
                exports: [MdPseudoCheckbox],
                declarations: [MdPseudoCheckbox]
            },] },
];
/**
 * @nocollapse
 */
MdSelectionModule.ctorParameters = function () { return []; };
/**
 * Option IDs need to be unique across components, so this counter exists outside of
 * the component definition.
 */
var _uniqueIdCounter = 0;
/**
 * Event object emitted by MdOption when selected or deselected.
 */
var MdOptionSelectionChange = (function () {
    /**
     * @param {?} source
     * @param {?=} isUserInput
     */
    function MdOptionSelectionChange(source, isUserInput) {
        if (isUserInput === void 0) { isUserInput = false; }
        this.source = source;
        this.isUserInput = isUserInput;
    }
    return MdOptionSelectionChange;
}());
/**
 * Single option inside of a `<md-select>` element.
 */
var MdOption = (function () {
    /**
     * @param {?} _element
     * @param {?} _renderer
     * @param {?} _isCompatibilityMode
     */
    function MdOption(_element, _renderer, _isCompatibilityMode) {
        this._element = _element;
        this._renderer = _renderer;
        this._isCompatibilityMode = _isCompatibilityMode;
        this._selected = false;
        this._active = false;
        this._disabled = false;
        this._id = "md-option-" + _uniqueIdCounter++;
        /** Whether the wrapping component is in multiple selection mode. */
        this.multiple = false;
        /** Event emitted when the option is selected or deselected. */
        this.onSelectionChange = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
    }
    Object.defineProperty(MdOption.prototype, "id", {
        /**
         * The unique ID of the option.
         * @return {?}
         */
        get: function () { return this._id; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdOption.prototype, "selected", {
        /**
         * Whether or not the option is currently selected.
         * @return {?}
         */
        get: function () { return this._selected; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdOption.prototype, "disabled", {
        /**
         * Whether the option is disabled.
         * @return {?}
         */
        get: function () { return this._disabled; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this._disabled = coerceBooleanProperty(value); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdOption.prototype, "active", {
        /**
         * Whether or not the option is currently active and ready to be selected.
         * An active option displays styles as if it is focused, but the
         * focus is actually retained somewhere else. This comes in handy
         * for components like autocomplete where focus must remain on the input.
         * @return {?}
         */
        get: function () {
            return this._active;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdOption.prototype, "viewValue", {
        /**
         * The displayed value of the option. It is necessary to show the selected option in the
         * select's trigger.
         * @return {?}
         */
        get: function () {
            // TODO(kara): Add input property alternative for node envs.
            return this._getHostElement().textContent.trim();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Selects the option.
     * @return {?}
     */
    MdOption.prototype.select = function () {
        this._selected = true;
        this._emitSelectionChangeEvent();
    };
    /**
     * Deselects the option.
     * @return {?}
     */
    MdOption.prototype.deselect = function () {
        this._selected = false;
        this._emitSelectionChangeEvent();
    };
    /**
     * Sets focus onto this option.
     * @return {?}
     */
    MdOption.prototype.focus = function () {
        this._renderer.invokeElementMethod(this._getHostElement(), 'focus');
    };
    /**
     * This method sets display styles on the option to make it appear
     * active. This is used by the ActiveDescendantKeyManager so key
     * events will display the proper options as active on arrow key events.
     * @return {?}
     */
    MdOption.prototype.setActiveStyles = function () {
        this._active = true;
    };
    /**
     * This method removes display styles on the option that made it appear
     * active. This is used by the ActiveDescendantKeyManager so key
     * events will display the proper options as active on arrow key events.
     * @return {?}
     */
    MdOption.prototype.setInactiveStyles = function () {
        this._active = false;
    };
    /**
     * Ensures the option is selected when activated from the keyboard.
     * @param {?} event
     * @return {?}
     */
    MdOption.prototype._handleKeydown = function (event) {
        if (event.keyCode === ENTER || event.keyCode === SPACE) {
            this._selectViaInteraction();
        }
    };
    /**
     * Selects the option while indicating the selection came from the user. Used to
     * determine if the select's view -> model callback should be invoked.
     * @return {?}
     */
    MdOption.prototype._selectViaInteraction = function () {
        if (!this.disabled) {
            this._selected = this.multiple ? !this._selected : true;
            this._emitSelectionChangeEvent(true);
        }
    };
    /**
     * Returns the correct tabindex for the option depending on disabled state.
     * @return {?}
     */
    MdOption.prototype._getTabIndex = function () {
        return this.disabled ? '-1' : '0';
    };
    /**
     * Fetches the host DOM element.
     * @return {?}
     */
    MdOption.prototype._getHostElement = function () {
        return this._element.nativeElement;
    };
    /**
     * Emits the selection change event.
     * @param {?=} isUserInput
     * @return {?}
     */
    MdOption.prototype._emitSelectionChangeEvent = function (isUserInput) {
        if (isUserInput === void 0) { isUserInput = false; }
        this.onSelectionChange.emit(new MdOptionSelectionChange(this, isUserInput));
    };
    ;
    return MdOption;
}());
MdOption.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{ selector: 'md-option, mat-option',
                host: {
                    'role': 'option',
                    '[attr.tabindex]': '_getTabIndex()',
                    '[class.mat-selected]': 'selected',
                    '[class.mat-option-multiple]': 'multiple',
                    '[class.mat-active]': 'active',
                    '[id]': 'id',
                    '[attr.aria-selected]': 'selected.toString()',
                    '[attr.aria-disabled]': 'disabled.toString()',
                    '[class.mat-option-disabled]': 'disabled',
                    '(click)': '_selectViaInteraction()',
                    '(keydown)': '_handleKeydown($event)',
                    '[class.mat-option]': 'true',
                },
                template: "<span [ngSwitch]=\"_isCompatibilityMode\" *ngIf=\"multiple\"> <mat-pseudo-checkbox class=\"mat-option-pseudo-checkbox\" *ngSwitchCase=\"true\" [state]=\"selected ? 'checked' : ''\" color=\"primary\"></mat-pseudo-checkbox> <md-pseudo-checkbox class=\"mat-option-pseudo-checkbox\" *ngSwitchDefault [state]=\"selected ? 'checked' : ''\" color=\"primary\"></md-pseudo-checkbox> </span> <ng-content></ng-content> <div class=\"mat-option-ripple\" *ngIf=\"!disabled\" md-ripple [mdRippleTrigger]=\"_getHostElement()\"> </div> ",
                encapsulation: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewEncapsulation"].None
            },] },
];
/**
 * @nocollapse
 */
MdOption.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
    { type: undefined, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [MATERIAL_COMPATIBILITY_MODE,] },] },
]; };
MdOption.propDecorators = {
    'value': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'disabled': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'onSelectionChange': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
};
var MdOptionModule = (function () {
    function MdOptionModule() {
    }
    /**
     * @return {?}
     */
    MdOptionModule.forRoot = function () {
        return {
            ngModule: MdOptionModule,
            providers: []
        };
    };
    return MdOptionModule;
}());
MdOptionModule.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{
                imports: [MdRippleModule, __WEBPACK_IMPORTED_MODULE_2__angular_common__["CommonModule"], MdSelectionModule],
                exports: [MdOption],
                declarations: [MdOption]
            },] },
];
/**
 * @nocollapse
 */
MdOptionModule.ctorParameters = function () { return []; };
/**
 * Wrapper around Error that sets the error message.
 * \@docs-private
 */
var MdError = (function (_super) {
    __extends(MdError, _super);
    /**
     * @param {?} value
     */
    function MdError(value) {
        var _this = _super.call(this) || this;
        _this.message = value;
        return _this;
    }
    return MdError;
}(Error));
/**
 * Exception thrown when attempting to attach a null portal to a host.
 * \@docs-private
 */
var NullPortalError = (function (_super) {
    __extends(NullPortalError, _super);
    function NullPortalError() {
        return _super.call(this, 'Must provide a portal to attach') || this;
    }
    return NullPortalError;
}(MdError));
/**
 * Exception thrown when attempting to attach a portal to a host that is already attached.
 * \@docs-private
 */
var PortalAlreadyAttachedError = (function (_super) {
    __extends(PortalAlreadyAttachedError, _super);
    function PortalAlreadyAttachedError() {
        return _super.call(this, 'Host already has a portal attached') || this;
    }
    return PortalAlreadyAttachedError;
}(MdError));
/**
 * Exception thrown when attempting to attach a portal to an already-disposed host.
 * \@docs-private
 */
var PortalHostAlreadyDisposedError = (function (_super) {
    __extends(PortalHostAlreadyDisposedError, _super);
    function PortalHostAlreadyDisposedError() {
        return _super.call(this, 'This PortalHost has already been disposed') || this;
    }
    return PortalHostAlreadyDisposedError;
}(MdError));
/**
 * Exception thrown when attempting to attach an unknown portal type.
 * \@docs-private
 */
var UnknownPortalTypeError = (function (_super) {
    __extends(UnknownPortalTypeError, _super);
    function UnknownPortalTypeError() {
        return _super.call(this, 'Attempting to attach an unknown Portal type. ' +
            'BasePortalHost accepts either a ComponentPortal or a TemplatePortal.') || this;
    }
    return UnknownPortalTypeError;
}(MdError));
/**
 * Exception thrown when attempting to attach a portal to a null host.
 * \@docs-private
 */
var NullPortalHostError = (function (_super) {
    __extends(NullPortalHostError, _super);
    function NullPortalHostError() {
        return _super.call(this, 'Attempting to attach a portal to a null PortalHost') || this;
    }
    return NullPortalHostError;
}(MdError));
/**
 * Exception thrown when attempting to detach a portal that is not attached.
 * \@docs-private
 */
var NoPortalAttachedError = (function (_super) {
    __extends(NoPortalAttachedError, _super);
    function NoPortalAttachedError() {
        return _super.call(this, 'Attempting to detach a portal that is not attached to a host') || this;
    }
    return NoPortalAttachedError;
}(MdError));
/**
 * A `Portal` is something that you want to render somewhere else.
 * It can be attach to / detached from a `PortalHost`.
 * @abstract
 */
var Portal = (function () {
    function Portal() {
    }
    /**
     * Attach this portal to a host.
     * @param {?} host
     * @return {?}
     */
    Portal.prototype.attach = function (host) {
        if (host == null) {
            throw new NullPortalHostError();
        }
        if (host.hasAttached()) {
            throw new PortalAlreadyAttachedError();
        }
        this._attachedHost = host;
        return (host.attach(this));
    };
    /**
     * Detach this portal from its host
     * @return {?}
     */
    Portal.prototype.detach = function () {
        var /** @type {?} */ host = this._attachedHost;
        if (host == null) {
            throw new NoPortalAttachedError();
        }
        this._attachedHost = null;
        return host.detach();
    };
    Object.defineProperty(Portal.prototype, "isAttached", {
        /**
         * Whether this portal is attached to a host.
         * @return {?}
         */
        get: function () {
            return this._attachedHost != null;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Sets the PortalHost reference without performing `attach()`. This is used directly by
     * the PortalHost when it is performing an `attach()` or `detach()`.
     * @param {?} host
     * @return {?}
     */
    Portal.prototype.setAttachedHost = function (host) {
        this._attachedHost = host;
    };
    return Portal;
}());
/**
 * A `ComponentPortal` is a portal that instantiates some Component upon attachment.
 */
var ComponentPortal = (function (_super) {
    __extends(ComponentPortal, _super);
    /**
     * @param {?} component
     * @param {?=} viewContainerRef
     * @param {?=} injector
     */
    function ComponentPortal(component, viewContainerRef, injector) {
        if (viewContainerRef === void 0) { viewContainerRef = null; }
        if (injector === void 0) { injector = null; }
        var _this = _super.call(this) || this;
        _this.component = component;
        _this.viewContainerRef = viewContainerRef;
        _this.injector = injector;
        return _this;
    }
    return ComponentPortal;
}(Portal));
/**
 * A `TemplatePortal` is a portal that represents some embedded template (TemplateRef).
 */
var TemplatePortal = (function (_super) {
    __extends(TemplatePortal, _super);
    /**
     * @param {?} template
     * @param {?} viewContainerRef
     */
    function TemplatePortal(template, viewContainerRef) {
        var _this = _super.call(this) || this;
        /**
         * Additional locals for the instantiated embedded view.
         * These locals can be seen as "exports" for the template, such as how ngFor has
         * index / event / odd.
         * See https://angular.io/docs/ts/latest/api/core/EmbeddedViewRef-class.html
         */
        _this.locals = new Map();
        _this.templateRef = template;
        _this.viewContainerRef = viewContainerRef;
        return _this;
    }
    Object.defineProperty(TemplatePortal.prototype, "origin", {
        /**
         * @return {?}
         */
        get: function () {
            return this.templateRef.elementRef;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} host
     * @param {?=} locals
     * @return {?}
     */
    TemplatePortal.prototype.attach = function (host, locals) {
        this.locals = locals == null ? new Map() : locals;
        return _super.prototype.attach.call(this, host);
    };
    /**
     * @return {?}
     */
    TemplatePortal.prototype.detach = function () {
        this.locals = new Map();
        return _super.prototype.detach.call(this);
    };
    return TemplatePortal;
}(Portal));
/**
 * Partial implementation of PortalHost that only deals with attaching either a
 * ComponentPortal or a TemplatePortal.
 * @abstract
 */
var BasePortalHost = (function () {
    function BasePortalHost() {
        this._isDisposed = false;
    }
    /**
     * Whether this host has an attached portal.
     * @return {?}
     */
    BasePortalHost.prototype.hasAttached = function () {
        return !!this._attachedPortal;
    };
    /**
     * @param {?} portal
     * @return {?}
     */
    BasePortalHost.prototype.attach = function (portal) {
        if (!portal) {
            throw new NullPortalError();
        }
        if (this.hasAttached()) {
            throw new PortalAlreadyAttachedError();
        }
        if (this._isDisposed) {
            throw new PortalHostAlreadyDisposedError();
        }
        if (portal instanceof ComponentPortal) {
            this._attachedPortal = portal;
            return this.attachComponentPortal(portal);
        }
        else if (portal instanceof TemplatePortal) {
            this._attachedPortal = portal;
            return this.attachTemplatePortal(portal);
        }
        throw new UnknownPortalTypeError();
    };
    /**
     * @abstract
     * @template T
     * @param {?} portal
     * @return {?}
     */
    BasePortalHost.prototype.attachComponentPortal = function (portal) { };
    /**
     * @abstract
     * @param {?} portal
     * @return {?}
     */
    BasePortalHost.prototype.attachTemplatePortal = function (portal) { };
    /**
     * @return {?}
     */
    BasePortalHost.prototype.detach = function () {
        if (this._attachedPortal) {
            this._attachedPortal.setAttachedHost(null);
            this._attachedPortal = null;
        }
        this._invokeDisposeFn();
    };
    /**
     * @return {?}
     */
    BasePortalHost.prototype.dispose = function () {
        if (this.hasAttached()) {
            this.detach();
        }
        this._invokeDisposeFn();
        this._isDisposed = true;
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    BasePortalHost.prototype.setDisposeFn = function (fn) {
        this._disposeFn = fn;
    };
    /**
     * @return {?}
     */
    BasePortalHost.prototype._invokeDisposeFn = function () {
        if (this._disposeFn) {
            this._disposeFn();
            this._disposeFn = null;
        }
    };
    return BasePortalHost;
}());
/**
 * Directive version of a `TemplatePortal`. Because the directive *is* a TemplatePortal,
 * the directive instance itself can be attached to a host, enabling declarative use of portals.
 *
 * Usage:
 * <ng-template portal #greeting>
 *   <p> Hello {{name}} </p>
 * </ng-template>
 */
var TemplatePortalDirective = (function (_super) {
    __extends(TemplatePortalDirective, _super);
    /**
     * @param {?} templateRef
     * @param {?} viewContainerRef
     */
    function TemplatePortalDirective(templateRef, viewContainerRef) {
        return _super.call(this, templateRef, viewContainerRef) || this;
    }
    return TemplatePortalDirective;
}(TemplatePortal));
TemplatePortalDirective.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                selector: '[cdk-portal], [portal]',
                exportAs: 'cdkPortal',
            },] },
];
/**
 * @nocollapse
 */
TemplatePortalDirective.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["TemplateRef"], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewContainerRef"], },
]; };
/**
 * Directive version of a PortalHost. Because the directive *is* a PortalHost, portals can be
 * directly attached to it, enabling declarative use.
 *
 * Usage:
 * <ng-template [cdkPortalHost]="greeting"></ng-template>
 */
var PortalHostDirective = (function (_super) {
    __extends(PortalHostDirective, _super);
    /**
     * @param {?} _componentFactoryResolver
     * @param {?} _viewContainerRef
     */
    function PortalHostDirective(_componentFactoryResolver, _viewContainerRef) {
        var _this = _super.call(this) || this;
        _this._componentFactoryResolver = _componentFactoryResolver;
        _this._viewContainerRef = _viewContainerRef;
        return _this;
    }
    Object.defineProperty(PortalHostDirective.prototype, "_deprecatedPortal", {
        /**
         * @deprecated
         * @return {?}
         */
        get: function () { return this.portal; },
        /**
         * @param {?} v
         * @return {?}
         */
        set: function (v) { this.portal = v; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PortalHostDirective.prototype, "portal", {
        /**
         * Portal associated with the Portal host.
         * @return {?}
         */
        get: function () {
            return this._portal;
        },
        /**
         * @param {?} portal
         * @return {?}
         */
        set: function (portal) {
            if (this.hasAttached()) {
                _super.prototype.detach.call(this);
            }
            if (portal) {
                _super.prototype.attach.call(this, portal);
            }
            this._portal = portal;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    PortalHostDirective.prototype.ngOnDestroy = function () {
        _super.prototype.dispose.call(this);
        this._portal = null;
    };
    /**
     * Attach the given ComponentPortal to this PortalHost using the ComponentFactoryResolver.
     *
     * @template T
     * @param {?} portal Portal to be attached to the portal host.
     * @return {?}
     */
    PortalHostDirective.prototype.attachComponentPortal = function (portal) {
        portal.setAttachedHost(this);
        // If the portal specifies an origin, use that as the logical location of the component
        // in the application tree. Otherwise use the location of this PortalHost.
        var /** @type {?} */ viewContainerRef = portal.viewContainerRef != null ?
            portal.viewContainerRef :
            this._viewContainerRef;
        var /** @type {?} */ componentFactory = this._componentFactoryResolver.resolveComponentFactory(portal.component);
        var /** @type {?} */ ref = viewContainerRef.createComponent(componentFactory, viewContainerRef.length, portal.injector || viewContainerRef.parentInjector);
        _super.prototype.setDisposeFn.call(this, function () { return ref.destroy(); });
        this._portal = portal;
        return ref;
    };
    /**
     * Attach the given TemplatePortal to this PortlHost as an embedded View.
     * @param {?} portal Portal to be attached.
     * @return {?}
     */
    PortalHostDirective.prototype.attachTemplatePortal = function (portal) {
        var _this = this;
        portal.setAttachedHost(this);
        this._viewContainerRef.createEmbeddedView(portal.templateRef);
        _super.prototype.setDisposeFn.call(this, function () { return _this._viewContainerRef.clear(); });
        this._portal = portal;
        // TODO(jelbourn): return locals from view
        return new Map();
    };
    return PortalHostDirective;
}(BasePortalHost));
PortalHostDirective.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                selector: '[cdkPortalHost], [portalHost]',
                inputs: ['portal: cdkPortalHost']
            },] },
];
/**
 * @nocollapse
 */
PortalHostDirective.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ComponentFactoryResolver"], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewContainerRef"], },
]; };
PortalHostDirective.propDecorators = {
    '_deprecatedPortal': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['portalHost',] },],
};
var PortalModule = (function () {
    function PortalModule() {
    }
    /**
     * @deprecated
     * @return {?}
     */
    PortalModule.forRoot = function () {
        return {
            ngModule: PortalModule,
            providers: []
        };
    };
    return PortalModule;
}());
PortalModule.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{
                exports: [TemplatePortalDirective, PortalHostDirective],
                declarations: [TemplatePortalDirective, PortalHostDirective],
            },] },
];
/**
 * @nocollapse
 */
PortalModule.ctorParameters = function () { return []; };
/**
 * OverlayState is a bag of values for either the initial configuration or current state of an
 * overlay.
 */
var OverlayState = (function () {
    function OverlayState() {
        /** Whether the overlay has a backdrop. */
        this.hasBackdrop = false;
        /** Custom class to add to the backdrop **/
        this.backdropClass = 'cdk-overlay-dark-backdrop';
        /** The direction of the text in the overlay panel. */
        this.direction = 'ltr';
        // TODO(jelbourn): configuration still to add
        // - focus trap
        // - disable pointer events
        // - z-index
    }
    return OverlayState;
}());
/**
 * A PortalHost for attaching portals to an arbitrary DOM element outside of the Angular
 * application context.
 *
 * This is the only part of the portal core that directly touches the DOM.
 */
var DomPortalHost = (function (_super) {
    __extends(DomPortalHost, _super);
    /**
     * @param {?} _hostDomElement
     * @param {?} _componentFactoryResolver
     * @param {?} _appRef
     * @param {?} _defaultInjector
     */
    function DomPortalHost(_hostDomElement, _componentFactoryResolver, _appRef, _defaultInjector) {
        var _this = _super.call(this) || this;
        _this._hostDomElement = _hostDomElement;
        _this._componentFactoryResolver = _componentFactoryResolver;
        _this._appRef = _appRef;
        _this._defaultInjector = _defaultInjector;
        return _this;
    }
    /**
     * Attach the given ComponentPortal to DOM element using the ComponentFactoryResolver.
     * @template T
     * @param {?} portal Portal to be attached
     * @return {?}
     */
    DomPortalHost.prototype.attachComponentPortal = function (portal) {
        var _this = this;
        var /** @type {?} */ componentFactory = this._componentFactoryResolver.resolveComponentFactory(portal.component);
        var /** @type {?} */ componentRef;
        // If the portal specifies a ViewContainerRef, we will use that as the attachment point
        // for the component (in terms of Angular's component tree, not rendering).
        // When the ViewContainerRef is missing, we use the factory to create the component directly
        // and then manually attach the view to the application.
        if (portal.viewContainerRef) {
            componentRef = portal.viewContainerRef.createComponent(componentFactory, portal.viewContainerRef.length, portal.injector || portal.viewContainerRef.parentInjector);
            this.setDisposeFn(function () { return componentRef.destroy(); });
        }
        else {
            componentRef = componentFactory.create(portal.injector || this._defaultInjector);
            this._appRef.attachView(componentRef.hostView);
            this.setDisposeFn(function () {
                _this._appRef.detachView(componentRef.hostView);
                componentRef.destroy();
            });
        }
        // At this point the component has been instantiated, so we move it to the location in the DOM
        // where we want it to be rendered.
        this._hostDomElement.appendChild(this._getComponentRootNode(componentRef));
        return componentRef;
    };
    /**
     * Attaches a template portal to the DOM as an embedded view.
     * @param {?} portal Portal to be attached.
     * @return {?}
     */
    DomPortalHost.prototype.attachTemplatePortal = function (portal) {
        var _this = this;
        var /** @type {?} */ viewContainer = portal.viewContainerRef;
        var /** @type {?} */ viewRef = viewContainer.createEmbeddedView(portal.templateRef);
        // The method `createEmbeddedView` will add the view as a child of the viewContainer.
        // But for the DomPortalHost the view can be added everywhere in the DOM (e.g Overlay Container)
        // To move the view to the specified host element. We just re-append the existing root nodes.
        viewRef.rootNodes.forEach(function (rootNode) { return _this._hostDomElement.appendChild(rootNode); });
        this.setDisposeFn((function () {
            var /** @type {?} */ index = viewContainer.indexOf(viewRef);
            if (index !== -1) {
                viewContainer.remove(index);
            }
        }));
        // TODO(jelbourn): Return locals from view.
        return new Map();
    };
    /**
     * Clears out a portal from the DOM.
     * @return {?}
     */
    DomPortalHost.prototype.dispose = function () {
        _super.prototype.dispose.call(this);
        if (this._hostDomElement.parentNode != null) {
            this._hostDomElement.parentNode.removeChild(this._hostDomElement);
        }
    };
    /**
     * Gets the root HTMLElement for an instantiated component.
     * @param {?} componentRef
     * @return {?}
     */
    DomPortalHost.prototype._getComponentRootNode = function (componentRef) {
        return (((componentRef.hostView)).rootNodes[0]);
    };
    return DomPortalHost;
}(BasePortalHost));
/**
 * Reference to an overlay that has been created with the Overlay service.
 * Used to manipulate or dispose of said overlay.
 */
var OverlayRef = (function () {
    /**
     * @param {?} _portalHost
     * @param {?} _pane
     * @param {?} _state
     * @param {?} _ngZone
     */
    function OverlayRef(_portalHost, _pane, _state, _ngZone) {
        this._portalHost = _portalHost;
        this._pane = _pane;
        this._state = _state;
        this._ngZone = _ngZone;
        this._backdropElement = null;
        this._backdropClick = new __WEBPACK_IMPORTED_MODULE_3_rxjs_Subject__["Subject"]();
    }
    Object.defineProperty(OverlayRef.prototype, "overlayElement", {
        /**
         * The overlay's HTML element
         * @return {?}
         */
        get: function () {
            return this._pane;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Attaches the overlay to a portal instance and adds the backdrop.
     * @param {?} portal Portal instance to which to attach the overlay.
     * @return {?} The portal attachment result.
     */
    OverlayRef.prototype.attach = function (portal) {
        var /** @type {?} */ attachResult = this._portalHost.attach(portal);
        // Update the pane element with the given state configuration.
        this._updateStackingOrder();
        this.updateSize();
        this.updateDirection();
        this.updatePosition();
        // Enable pointer events for the overlay pane element.
        this._togglePointerEvents(true);
        if (this._state.hasBackdrop) {
            this._attachBackdrop();
        }
        return attachResult;
    };
    /**
     * Detaches an overlay from a portal.
     * @return {?} Resolves when the overlay has been detached.
     */
    OverlayRef.prototype.detach = function () {
        this.detachBackdrop();
        // When the overlay is detached, the pane element should disable pointer events.
        // This is necessary because otherwise the pane element will cover the page and disable
        // pointer events therefore. Depends on the position strategy and the applied pane boundaries.
        this._togglePointerEvents(false);
        return this._portalHost.detach();
    };
    /**
     * Cleans up the overlay from the DOM.
     * @return {?}
     */
    OverlayRef.prototype.dispose = function () {
        if (this._state.positionStrategy) {
            this._state.positionStrategy.dispose();
        }
        this.detachBackdrop();
        this._portalHost.dispose();
    };
    /**
     * Checks whether the overlay has been attached.
     * @return {?}
     */
    OverlayRef.prototype.hasAttached = function () {
        return this._portalHost.hasAttached();
    };
    /**
     * Returns an observable that emits when the backdrop has been clicked.
     * @return {?}
     */
    OverlayRef.prototype.backdropClick = function () {
        return this._backdropClick.asObservable();
    };
    /**
     * Gets the current state config of the overlay.
     * @return {?}
     */
    OverlayRef.prototype.getState = function () {
        return this._state;
    };
    /**
     * Updates the position of the overlay based on the position strategy.
     * @return {?}
     */
    OverlayRef.prototype.updatePosition = function () {
        if (this._state.positionStrategy) {
            this._state.positionStrategy.apply(this._pane);
        }
    };
    /**
     * Updates the text direction of the overlay panel. *
     * @return {?}
     */
    OverlayRef.prototype.updateDirection = function () {
        this._pane.setAttribute('dir', this._state.direction);
    };
    /**
     * Updates the size of the overlay based on the overlay config.
     * @return {?}
     */
    OverlayRef.prototype.updateSize = function () {
        if (this._state.width || this._state.width === 0) {
            this._pane.style.width = formatCssUnit(this._state.width);
        }
        if (this._state.height || this._state.height === 0) {
            this._pane.style.height = formatCssUnit(this._state.height);
        }
        if (this._state.minWidth || this._state.minWidth === 0) {
            this._pane.style.minWidth = formatCssUnit(this._state.minWidth);
        }
        if (this._state.minHeight || this._state.minHeight === 0) {
            this._pane.style.minHeight = formatCssUnit(this._state.minHeight);
        }
    };
    /**
     * Toggles the pointer events for the overlay pane element.
     * @param {?} enablePointer
     * @return {?}
     */
    OverlayRef.prototype._togglePointerEvents = function (enablePointer) {
        this._pane.style.pointerEvents = enablePointer ? 'auto' : 'none';
    };
    /**
     * Attaches a backdrop for this overlay.
     * @return {?}
     */
    OverlayRef.prototype._attachBackdrop = function () {
        var _this = this;
        this._backdropElement = document.createElement('div');
        this._backdropElement.classList.add('cdk-overlay-backdrop');
        this._backdropElement.classList.add(this._state.backdropClass);
        // Insert the backdrop before the pane in the DOM order,
        // in order to handle stacked overlays properly.
        this._pane.parentElement.insertBefore(this._backdropElement, this._pane);
        // Forward backdrop clicks such that the consumer of the overlay can perform whatever
        // action desired when such a click occurs (usually closing the overlay).
        this._backdropElement.addEventListener('click', function () { return _this._backdropClick.next(null); });
        // Add class to fade-in the backdrop after one frame.
        requestAnimationFrame(function () {
            if (_this._backdropElement) {
                _this._backdropElement.classList.add('cdk-overlay-backdrop-showing');
            }
        });
    };
    /**
     * Updates the stacking order of the element, moving it to the top if necessary.
     * This is required in cases where one overlay was detached, while another one,
     * that should be behind it, was destroyed. The next time both of them are opened,
     * the stacking will be wrong, because the detached element's pane will still be
     * in its original DOM position.
     * @return {?}
     */
    OverlayRef.prototype._updateStackingOrder = function () {
        if (this._pane.nextSibling) {
            this._pane.parentNode.appendChild(this._pane);
        }
    };
    /**
     * Detaches the backdrop (if any) associated with the overlay.
     * @return {?}
     */
    OverlayRef.prototype.detachBackdrop = function () {
        var _this = this;
        var /** @type {?} */ backdropToDetach = this._backdropElement;
        if (backdropToDetach) {
            var /** @type {?} */ finishDetach_1 = function () {
                // It may not be attached to anything in certain cases (e.g. unit tests).
                if (backdropToDetach && backdropToDetach.parentNode) {
                    backdropToDetach.parentNode.removeChild(backdropToDetach);
                }
                // It is possible that a new portal has been attached to this overlay since we started
                // removing the backdrop. If that is the case, only clear the backdrop reference if it
                // is still the same instance that we started to remove.
                if (_this._backdropElement == backdropToDetach) {
                    _this._backdropElement = null;
                }
            };
            backdropToDetach.classList.remove('cdk-overlay-backdrop-showing');
            backdropToDetach.classList.remove(this._state.backdropClass);
            backdropToDetach.addEventListener('transitionend', finishDetach_1);
            // If the backdrop doesn't have a transition, the `transitionend` event won't fire.
            // In this case we make it unclickable and we try to remove it after a delay.
            backdropToDetach.style.pointerEvents = 'none';
            // Run this outside the Angular zone because there's nothing that Angular cares about.
            // If it were to run inside the Angular zone, every test that used Overlay would have to be
            // either async or fakeAsync.
            this._ngZone.runOutsideAngular(function () {
                setTimeout(finishDetach_1, 500);
            });
        }
    };
    return OverlayRef;
}());
/**
 * @param {?} value
 * @return {?}
 */
function formatCssUnit(value) {
    return typeof value === 'string' ? (value) : value + "px";
}
/** Horizontal dimension of a connection point on the perimeter of the origin or overlay element. */
/**
 * The points of the origin element and the overlay element to connect.
 */
var ConnectionPositionPair = (function () {
    /**
     * @param {?} origin
     * @param {?} overlay
     */
    function ConnectionPositionPair(origin, overlay) {
        this.originX = origin.originX;
        this.originY = origin.originY;
        this.overlayX = overlay.overlayX;
        this.overlayY = overlay.overlayY;
    }
    return ConnectionPositionPair;
}());
/**
 * Set of properties regarding the position of the origin and overlay relative to the viewport
 * with respect to the containing Scrollable elements.
 *
 * The overlay and origin are clipped if any part of their bounding client rectangle exceeds the
 * bounds of any one of the strategy's Scrollable's bounding client rectangle.
 *
 * The overlay and origin are outside view if there is no overlap between their bounding client
 * rectangle and any one of the strategy's Scrollable's bounding client rectangle.
 *
 *       -----------                    -----------
 *       | outside |                    | clipped |
 *       |  view   |              --------------------------
 *       |         |              |     |         |        |
 *       ----------               |     -----------        |
 *  --------------------------    |                        |
 *  |                        |    |      Scrollable        |
 *  |                        |    |                        |
 *  |                        |     --------------------------
 *  |      Scrollable        |
 *  |                        |
 *  --------------------------
 */
var ScrollableViewProperties = (function () {
    function ScrollableViewProperties() {
    }
    return ScrollableViewProperties;
}());
/**
 * The change event emitted by the strategy when a fallback position is used.
 */
var ConnectedOverlayPositionChange = (function () {
    /**
     * @param {?} connectionPair
     * @param {?} scrollableViewProperties
     */
    function ConnectedOverlayPositionChange(connectionPair, scrollableViewProperties) {
        this.connectionPair = connectionPair;
        this.scrollableViewProperties = scrollableViewProperties;
    }
    return ConnectedOverlayPositionChange;
}());
/**
 * @nocollapse
 */
ConnectedOverlayPositionChange.ctorParameters = function () { return [
    { type: ConnectionPositionPair, },
    { type: ScrollableViewProperties, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] },] },
]; };
/**
 * A strategy for positioning overlays. Using this strategy, an overlay is given an
 * implicit position relative some origin element. The relative position is defined in terms of
 * a point on the origin element that is connected to a point on the overlay element. For example,
 * a basic dropdown is connecting the bottom-left corner of the origin to the top-left corner
 * of the overlay.
 */
var ConnectedPositionStrategy = (function () {
    /**
     * @param {?} _connectedTo
     * @param {?} _originPos
     * @param {?} _overlayPos
     * @param {?} _viewportRuler
     */
    function ConnectedPositionStrategy(_connectedTo, _originPos, _overlayPos, _viewportRuler) {
        this._connectedTo = _connectedTo;
        this._originPos = _originPos;
        this._overlayPos = _overlayPos;
        this._viewportRuler = _viewportRuler;
        this._dir = 'ltr';
        this._offsetX = 0;
        this._offsetY = 0;
        this.scrollables = [];
        /** Ordered list of preferred positions, from most to least desirable. */
        this._preferredPositions = [];
        this._onPositionChange = new __WEBPACK_IMPORTED_MODULE_3_rxjs_Subject__["Subject"]();
        this._origin = this._connectedTo.nativeElement;
        this.withFallbackPosition(_originPos, _overlayPos);
    }
    Object.defineProperty(ConnectedPositionStrategy.prototype, "_isRtl", {
        /**
         * Whether the we're dealing with an RTL context
         * @return {?}
         */
        get: function () {
            return this._dir === 'rtl';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ConnectedPositionStrategy.prototype, "onPositionChange", {
        /**
         * Emits an event when the connection point changes.
         * @return {?}
         */
        get: function () {
            return this._onPositionChange.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ConnectedPositionStrategy.prototype, "positions", {
        /**
         * Ordered list of preferred positions, from most to least desirable.
         * @return {?}
         */
        get: function () {
            return this._preferredPositions;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * To be used to for any cleanup after the element gets destroyed.
     * @return {?}
     */
    ConnectedPositionStrategy.prototype.dispose = function () { };
    /**
     * Updates the position of the overlay element, using whichever preferred position relative
     * to the origin fits on-screen.
     * \@docs-private
     *
     * @param {?} element Element to which to apply the CSS styles.
     * @return {?} Resolves when the styles have been applied.
     */
    ConnectedPositionStrategy.prototype.apply = function (element) {
        // Cache the overlay pane element in case re-calculating position is necessary
        this._pane = element;
        // We need the bounding rects for the origin and the overlay to determine how to position
        // the overlay relative to the origin.
        var /** @type {?} */ originRect = this._origin.getBoundingClientRect();
        var /** @type {?} */ overlayRect = element.getBoundingClientRect();
        // We use the viewport rect to determine whether a position would go off-screen.
        var /** @type {?} */ viewportRect = this._viewportRuler.getViewportRect();
        // Fallback point if none of the fallbacks fit into the viewport.
        var /** @type {?} */ fallbackPoint = null;
        // We want to place the overlay in the first of the preferred positions such that the
        // overlay fits on-screen.
        for (var _i = 0, _a = this._preferredPositions; _i < _a.length; _i++) {
            var pos = _a[_i];
            // Get the (x, y) point of connection on the origin, and then use that to get the
            // (top, left) coordinate for the overlay at `pos`.
            var /** @type {?} */ originPoint = this._getOriginConnectionPoint(originRect, pos);
            var /** @type {?} */ overlayPoint = this._getOverlayPoint(originPoint, overlayRect, viewportRect, pos);
            // If the overlay in the calculated position fits on-screen, put it there and we're done.
            if (overlayPoint.fitsInViewport) {
                this._setElementPosition(element, overlayPoint);
                // Save the last connected position in case the position needs to be re-calculated.
                this._lastConnectedPosition = pos;
                // Notify that the position has been changed along with its change properties.
                var /** @type {?} */ scrollableViewProperties = this.getScrollableViewProperties(element);
                var /** @type {?} */ positionChange = new ConnectedOverlayPositionChange(pos, scrollableViewProperties);
                this._onPositionChange.next(positionChange);
                return Promise.resolve(null);
            }
            else if (!fallbackPoint || fallbackPoint.visibleArea < overlayPoint.visibleArea) {
                fallbackPoint = overlayPoint;
            }
        }
        // If none of the preferred positions were in the viewport, take the one
        // with the largest visible area.
        this._setElementPosition(element, fallbackPoint);
        return Promise.resolve(null);
    };
    /**
     * This re-aligns the overlay element with the trigger in its last calculated position,
     * even if a position higher in the "preferred positions" list would now fit. This
     * allows one to re-align the panel without changing the orientation of the panel.
     * @return {?}
     */
    ConnectedPositionStrategy.prototype.recalculateLastPosition = function () {
        var /** @type {?} */ originRect = this._origin.getBoundingClientRect();
        var /** @type {?} */ overlayRect = this._pane.getBoundingClientRect();
        var /** @type {?} */ viewportRect = this._viewportRuler.getViewportRect();
        var /** @type {?} */ lastPosition = this._lastConnectedPosition || this._preferredPositions[0];
        var /** @type {?} */ originPoint = this._getOriginConnectionPoint(originRect, lastPosition);
        var /** @type {?} */ overlayPoint = this._getOverlayPoint(originPoint, overlayRect, viewportRect, lastPosition);
        this._setElementPosition(this._pane, overlayPoint);
    };
    /**
     * Sets the list of Scrollable containers that host the origin element so that
     * on reposition we can evaluate if it or the overlay has been clipped or outside view. Every
     * Scrollable must be an ancestor element of the strategy's origin element.
     * @param {?} scrollables
     * @return {?}
     */
    ConnectedPositionStrategy.prototype.withScrollableContainers = function (scrollables) {
        this.scrollables = scrollables;
    };
    /**
     * Adds a new preferred fallback position.
     * @param {?} originPos
     * @param {?} overlayPos
     * @return {?}
     */
    ConnectedPositionStrategy.prototype.withFallbackPosition = function (originPos, overlayPos) {
        this._preferredPositions.push(new ConnectionPositionPair(originPos, overlayPos));
        return this;
    };
    /**
     * Sets the layout direction so the overlay's position can be adjusted to match.
     * @param {?} dir New layout direction.
     * @return {?}
     */
    ConnectedPositionStrategy.prototype.withDirection = function (dir) {
        this._dir = dir;
        return this;
    };
    /**
     * Sets an offset for the overlay's connection point on the x-axis
     * @param {?} offset New offset in the X axis.
     * @return {?}
     */
    ConnectedPositionStrategy.prototype.withOffsetX = function (offset) {
        this._offsetX = offset;
        return this;
    };
    /**
     * Sets an offset for the overlay's connection point on the y-axis
     * @param {?} offset New offset in the Y axis.
     * @return {?}
     */
    ConnectedPositionStrategy.prototype.withOffsetY = function (offset) {
        this._offsetY = offset;
        return this;
    };
    /**
     * Gets the horizontal (x) "start" dimension based on whether the overlay is in an RTL context.
     * @param {?} rect
     * @return {?}
     */
    ConnectedPositionStrategy.prototype._getStartX = function (rect) {
        return this._isRtl ? rect.right : rect.left;
    };
    /**
     * Gets the horizontal (x) "end" dimension based on whether the overlay is in an RTL context.
     * @param {?} rect
     * @return {?}
     */
    ConnectedPositionStrategy.prototype._getEndX = function (rect) {
        return this._isRtl ? rect.left : rect.right;
    };
    /**
     * Gets the (x, y) coordinate of a connection point on the origin based on a relative position.
     * @param {?} originRect
     * @param {?} pos
     * @return {?}
     */
    ConnectedPositionStrategy.prototype._getOriginConnectionPoint = function (originRect, pos) {
        var /** @type {?} */ originStartX = this._getStartX(originRect);
        var /** @type {?} */ originEndX = this._getEndX(originRect);
        var /** @type {?} */ x;
        if (pos.originX == 'center') {
            x = originStartX + (originRect.width / 2);
        }
        else {
            x = pos.originX == 'start' ? originStartX : originEndX;
        }
        var /** @type {?} */ y;
        if (pos.originY == 'center') {
            y = originRect.top + (originRect.height / 2);
        }
        else {
            y = pos.originY == 'top' ? originRect.top : originRect.bottom;
        }
        return { x: x, y: y };
    };
    /**
     * Gets the (x, y) coordinate of the top-left corner of the overlay given a given position and
     * origin point to which the overlay should be connected, as well as how much of the element
     * would be inside the viewport at that position.
     * @param {?} originPoint
     * @param {?} overlayRect
     * @param {?} viewportRect
     * @param {?} pos
     * @return {?}
     */
    ConnectedPositionStrategy.prototype._getOverlayPoint = function (originPoint, overlayRect, viewportRect, pos) {
        // Calculate the (overlayStartX, overlayStartY), the start of the potential overlay position
        // relative to the origin point.
        var /** @type {?} */ overlayStartX;
        if (pos.overlayX == 'center') {
            overlayStartX = -overlayRect.width / 2;
        }
        else if (pos.overlayX === 'start') {
            overlayStartX = this._isRtl ? -overlayRect.width : 0;
        }
        else {
            overlayStartX = this._isRtl ? 0 : -overlayRect.width;
        }
        var /** @type {?} */ overlayStartY;
        if (pos.overlayY == 'center') {
            overlayStartY = -overlayRect.height / 2;
        }
        else {
            overlayStartY = pos.overlayY == 'top' ? 0 : -overlayRect.height;
        }
        // The (x, y) coordinates of the overlay.
        var /** @type {?} */ x = originPoint.x + overlayStartX + this._offsetX;
        var /** @type {?} */ y = originPoint.y + overlayStartY + this._offsetY;
        // How much the overlay would overflow at this position, on each side.
        var /** @type {?} */ leftOverflow = 0 - x;
        var /** @type {?} */ rightOverflow = (x + overlayRect.width) - viewportRect.width;
        var /** @type {?} */ topOverflow = 0 - y;
        var /** @type {?} */ bottomOverflow = (y + overlayRect.height) - viewportRect.height;
        // Visible parts of the element on each axis.
        var /** @type {?} */ visibleWidth = this._subtractOverflows(overlayRect.width, leftOverflow, rightOverflow);
        var /** @type {?} */ visibleHeight = this._subtractOverflows(overlayRect.height, topOverflow, bottomOverflow);
        // The area of the element that's within the viewport.
        var /** @type {?} */ visibleArea = visibleWidth * visibleHeight;
        var /** @type {?} */ fitsInViewport = (overlayRect.width * overlayRect.height) === visibleArea;
        return { x: x, y: y, fitsInViewport: fitsInViewport, visibleArea: visibleArea };
    };
    /**
     * Gets the view properties of the trigger and overlay, including whether they are clipped
     * or completely outside the view of any of the strategy's scrollables.
     * @param {?} overlay
     * @return {?}
     */
    ConnectedPositionStrategy.prototype.getScrollableViewProperties = function (overlay) {
        var _this = this;
        var /** @type {?} */ originBounds = this._getElementBounds(this._origin);
        var /** @type {?} */ overlayBounds = this._getElementBounds(overlay);
        var /** @type {?} */ scrollContainerBounds = this.scrollables.map(function (scrollable) {
            return _this._getElementBounds(scrollable.getElementRef().nativeElement);
        });
        return {
            isOriginClipped: this.isElementClipped(originBounds, scrollContainerBounds),
            isOriginOutsideView: this.isElementOutsideView(originBounds, scrollContainerBounds),
            isOverlayClipped: this.isElementClipped(overlayBounds, scrollContainerBounds),
            isOverlayOutsideView: this.isElementOutsideView(overlayBounds, scrollContainerBounds),
        };
    };
    /**
     * Whether the element is completely out of the view of any of the containers.
     * @param {?} elementBounds
     * @param {?} containersBounds
     * @return {?}
     */
    ConnectedPositionStrategy.prototype.isElementOutsideView = function (elementBounds, containersBounds) {
        return containersBounds.some(function (containerBounds) {
            var /** @type {?} */ outsideAbove = elementBounds.bottom < containerBounds.top;
            var /** @type {?} */ outsideBelow = elementBounds.top > containerBounds.bottom;
            var /** @type {?} */ outsideLeft = elementBounds.right < containerBounds.left;
            var /** @type {?} */ outsideRight = elementBounds.left > containerBounds.right;
            return outsideAbove || outsideBelow || outsideLeft || outsideRight;
        });
    };
    /**
     * Whether the element is clipped by any of the containers.
     * @param {?} elementBounds
     * @param {?} containersBounds
     * @return {?}
     */
    ConnectedPositionStrategy.prototype.isElementClipped = function (elementBounds, containersBounds) {
        return containersBounds.some(function (containerBounds) {
            var /** @type {?} */ clippedAbove = elementBounds.top < containerBounds.top;
            var /** @type {?} */ clippedBelow = elementBounds.bottom > containerBounds.bottom;
            var /** @type {?} */ clippedLeft = elementBounds.left < containerBounds.left;
            var /** @type {?} */ clippedRight = elementBounds.right > containerBounds.right;
            return clippedAbove || clippedBelow || clippedLeft || clippedRight;
        });
    };
    /**
     * Physically positions the overlay element to the given coordinate.
     * @param {?} element
     * @param {?} overlayPoint
     * @return {?}
     */
    ConnectedPositionStrategy.prototype._setElementPosition = function (element, overlayPoint) {
        element.style.left = overlayPoint.x + 'px';
        element.style.top = overlayPoint.y + 'px';
    };
    /**
     * Returns the bounding positions of the provided element with respect to the viewport.
     * @param {?} element
     * @return {?}
     */
    ConnectedPositionStrategy.prototype._getElementBounds = function (element) {
        var /** @type {?} */ boundingClientRect = element.getBoundingClientRect();
        return {
            top: boundingClientRect.top,
            right: boundingClientRect.left + boundingClientRect.width,
            bottom: boundingClientRect.top + boundingClientRect.height,
            left: boundingClientRect.left
        };
    };
    /**
     * Subtracts the amount that an element is overflowing on an axis from it's length.
     * @param {?} length
     * @param {...?} overflows
     * @return {?}
     */
    ConnectedPositionStrategy.prototype._subtractOverflows = function (length) {
        var overflows = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            overflows[_i - 1] = arguments[_i];
        }
        return overflows.reduce(function (currentValue, currentOverflow) {
            return currentValue - Math.max(currentOverflow, 0);
        }, length);
    };
    return ConnectedPositionStrategy;
}());
/**
 * A strategy for positioning overlays. Using this strategy, an overlay is given an
 * explicit position relative to the browser's viewport. We use flexbox, instead of
 * transforms, in order to avoid issues with subpixel rendering which can cause the
 * element to become blurry.
 */
var GlobalPositionStrategy = (function () {
    function GlobalPositionStrategy() {
        this._cssPosition = 'static';
        this._topOffset = '';
        this._bottomOffset = '';
        this._leftOffset = '';
        this._rightOffset = '';
        this._alignItems = '';
        this._justifyContent = '';
        this._width = '';
        this._height = '';
    }
    /**
     * Sets the top position of the overlay. Clears any previously set vertical position.
     * @param {?} value New top offset.
     * @return {?}
     */
    GlobalPositionStrategy.prototype.top = function (value) {
        this._bottomOffset = '';
        this._topOffset = value;
        this._alignItems = 'flex-start';
        return this;
    };
    /**
     * Sets the left position of the overlay. Clears any previously set horizontal position.
     * @param {?} value New left offset.
     * @return {?}
     */
    GlobalPositionStrategy.prototype.left = function (value) {
        this._rightOffset = '';
        this._leftOffset = value;
        this._justifyContent = 'flex-start';
        return this;
    };
    /**
     * Sets the bottom position of the overlay. Clears any previously set vertical position.
     * @param {?} value New bottom offset.
     * @return {?}
     */
    GlobalPositionStrategy.prototype.bottom = function (value) {
        this._topOffset = '';
        this._bottomOffset = value;
        this._alignItems = 'flex-end';
        return this;
    };
    /**
     * Sets the right position of the overlay. Clears any previously set horizontal position.
     * @param {?} value New right offset.
     * @return {?}
     */
    GlobalPositionStrategy.prototype.right = function (value) {
        this._leftOffset = '';
        this._rightOffset = value;
        this._justifyContent = 'flex-end';
        return this;
    };
    /**
     * Sets the overlay width and clears any previously set width.
     * @param {?} value New width for the overlay
     * @return {?}
     */
    GlobalPositionStrategy.prototype.width = function (value) {
        this._width = value;
        // When the width is 100%, we should reset the `left` and the offset,
        // in order to ensure that the element is flush against the viewport edge.
        if (value === '100%') {
            this.left('0px');
        }
        return this;
    };
    /**
     * Sets the overlay height and clears any previously set height.
     * @param {?} value New height for the overlay
     * @return {?}
     */
    GlobalPositionStrategy.prototype.height = function (value) {
        this._height = value;
        // When the height is 100%, we should reset the `top` and the offset,
        // in order to ensure that the element is flush against the viewport edge.
        if (value === '100%') {
            this.top('0px');
        }
        return this;
    };
    /**
     * Centers the overlay horizontally with an optional offset.
     * Clears any previously set horizontal position.
     *
     * @param {?=} offset Overlay offset from the horizontal center.
     * @return {?}
     */
    GlobalPositionStrategy.prototype.centerHorizontally = function (offset) {
        if (offset === void 0) { offset = ''; }
        this.left(offset);
        this._justifyContent = 'center';
        return this;
    };
    /**
     * Centers the overlay vertically with an optional offset.
     * Clears any previously set vertical position.
     *
     * @param {?=} offset Overlay offset from the vertical center.
     * @return {?}
     */
    GlobalPositionStrategy.prototype.centerVertically = function (offset) {
        if (offset === void 0) { offset = ''; }
        this.top(offset);
        this._alignItems = 'center';
        return this;
    };
    /**
     * Apply the position to the element.
     * \@docs-private
     *
     * @param {?} element Element to which to apply the CSS.
     * @return {?} Resolved when the styles have been applied.
     */
    GlobalPositionStrategy.prototype.apply = function (element) {
        if (!this._wrapper) {
            this._wrapper = document.createElement('div');
            this._wrapper.classList.add('cdk-global-overlay-wrapper');
            element.parentNode.insertBefore(this._wrapper, element);
            this._wrapper.appendChild(element);
        }
        var /** @type {?} */ styles = element.style;
        var /** @type {?} */ parentStyles = ((element.parentNode)).style;
        styles.position = this._cssPosition;
        styles.marginTop = this._topOffset;
        styles.marginLeft = this._leftOffset;
        styles.marginBottom = this._bottomOffset;
        styles.marginRight = this._rightOffset;
        styles.width = this._width;
        styles.height = this._height;
        parentStyles.justifyContent = this._justifyContent;
        parentStyles.alignItems = this._alignItems;
        return Promise.resolve(null);
    };
    /**
     * Removes the wrapper element from the DOM.
     * @return {?}
     */
    GlobalPositionStrategy.prototype.dispose = function () {
        if (this._wrapper && this._wrapper.parentNode) {
            this._wrapper.parentNode.removeChild(this._wrapper);
            this._wrapper = null;
        }
    };
    return GlobalPositionStrategy;
}());
/**
 * Builder for overlay position strategy.
 */
var OverlayPositionBuilder = (function () {
    /**
     * @param {?} _viewportRuler
     */
    function OverlayPositionBuilder(_viewportRuler) {
        this._viewportRuler = _viewportRuler;
    }
    /**
     * Creates a global position strategy.
     * @return {?}
     */
    OverlayPositionBuilder.prototype.global = function () {
        return new GlobalPositionStrategy();
    };
    /**
     * Creates a relative position strategy.
     * @param {?} elementRef
     * @param {?} originPos
     * @param {?} overlayPos
     * @return {?}
     */
    OverlayPositionBuilder.prototype.connectedTo = function (elementRef, originPos, overlayPos) {
        return new ConnectedPositionStrategy(elementRef, originPos, overlayPos, this._viewportRuler);
    };
    return OverlayPositionBuilder;
}());
OverlayPositionBuilder.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
];
/**
 * @nocollapse
 */
OverlayPositionBuilder.ctorParameters = function () { return [
    { type: ViewportRuler, },
]; };
/**
 * The OverlayContainer is the container in which all overlays will load.
 * It should be provided in the root component to ensure it is properly shared.
 */
var OverlayContainer = (function () {
    function OverlayContainer() {
    }
    Object.defineProperty(OverlayContainer.prototype, "themeClass", {
        /**
         * Base theme to be applied to all overlay-based components.
         * @return {?}
         */
        get: function () { return this._themeClass; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            if (this._containerElement) {
                this._containerElement.classList.remove(this._themeClass);
                if (value) {
                    this._containerElement.classList.add(value);
                }
            }
            this._themeClass = value;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * This method returns the overlay container element.  It will lazily
     * create the element the first time  it is called to facilitate using
     * the container in non-browser environments.
     * @return {?} the container element
     */
    OverlayContainer.prototype.getContainerElement = function () {
        if (!this._containerElement) {
            this._createContainer();
        }
        return this._containerElement;
    };
    /**
     * Create the overlay container element, which is simply a div
     * with the 'cdk-overlay-container' class on the document body.
     * @return {?}
     */
    OverlayContainer.prototype._createContainer = function () {
        var /** @type {?} */ container = document.createElement('div');
        container.classList.add('cdk-overlay-container');
        if (this._themeClass) {
            container.classList.add(this._themeClass);
        }
        document.body.appendChild(container);
        this._containerElement = container;
    };
    return OverlayContainer;
}());
OverlayContainer.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
];
/**
 * @nocollapse
 */
OverlayContainer.ctorParameters = function () { return []; };
/**
 * @param {?} parentContainer
 * @return {?}
 */
function OVERLAY_CONTAINER_PROVIDER_FACTORY(parentContainer) {
    return parentContainer || new OverlayContainer();
}
var OVERLAY_CONTAINER_PROVIDER = {
    // If there is already an OverlayContainer available, use that. Otherwise, provide a new one.
    provide: OverlayContainer,
    deps: [[new __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"](), new __WEBPACK_IMPORTED_MODULE_0__angular_core__["SkipSelf"](), OverlayContainer]],
    useFactory: OVERLAY_CONTAINER_PROVIDER_FACTORY
};
/** Next overlay unique ID. */
var nextUniqueId = 0;
/** The default state for newly created overlays. */
var defaultState = new OverlayState();
/**
 * Service to create Overlays. Overlays are dynamically added pieces of floating UI, meant to be
 * used as a low-level building building block for other components. Dialogs, tooltips, menus,
 * selects, etc. can all be built using overlays. The service should primarily be used by authors
 * of re-usable components rather than developers building end-user applications.
 *
 * An overlay *is* a PortalHost, so any kind of Portal can be loaded into one.
 */
var Overlay = (function () {
    /**
     * @param {?} _overlayContainer
     * @param {?} _componentFactoryResolver
     * @param {?} _positionBuilder
     * @param {?} _appRef
     * @param {?} _injector
     * @param {?} _ngZone
     */
    function Overlay(_overlayContainer, _componentFactoryResolver, _positionBuilder, _appRef, _injector, _ngZone) {
        this._overlayContainer = _overlayContainer;
        this._componentFactoryResolver = _componentFactoryResolver;
        this._positionBuilder = _positionBuilder;
        this._appRef = _appRef;
        this._injector = _injector;
        this._ngZone = _ngZone;
    }
    /**
     * Creates an overlay.
     * @param {?=} state State to apply to the overlay.
     * @return {?} Reference to the created overlay.
     */
    Overlay.prototype.create = function (state$$1) {
        if (state$$1 === void 0) { state$$1 = defaultState; }
        return this._createOverlayRef(this._createPaneElement(), state$$1);
    };
    /**
     * Returns a position builder that can be used, via fluent API,
     * to construct and configure a position strategy.
     * @return {?}
     */
    Overlay.prototype.position = function () {
        return this._positionBuilder;
    };
    /**
     * Creates the DOM element for an overlay and appends it to the overlay container.
     * @return {?} Newly-created pane element
     */
    Overlay.prototype._createPaneElement = function () {
        var /** @type {?} */ pane = document.createElement('div');
        pane.id = "cdk-overlay-" + nextUniqueId++;
        pane.classList.add('cdk-overlay-pane');
        this._overlayContainer.getContainerElement().appendChild(pane);
        return pane;
    };
    /**
     * Create a DomPortalHost into which the overlay content can be loaded.
     * @param {?} pane The DOM element to turn into a portal host.
     * @return {?} A portal host for the given DOM element.
     */
    Overlay.prototype._createPortalHost = function (pane) {
        return new DomPortalHost(pane, this._componentFactoryResolver, this._appRef, this._injector);
    };
    /**
     * Creates an OverlayRef for an overlay in the given DOM element.
     * @param {?} pane DOM element for the overlay
     * @param {?} state
     * @return {?}
     */
    Overlay.prototype._createOverlayRef = function (pane, state$$1) {
        return new OverlayRef(this._createPortalHost(pane), pane, state$$1, this._ngZone);
    };
    return Overlay;
}());
Overlay.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
];
/**
 * @nocollapse
 */
Overlay.ctorParameters = function () { return [
    { type: OverlayContainer, },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ComponentFactoryResolver"], },
    { type: OverlayPositionBuilder, },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ApplicationRef"], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injector"], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgZone"], },
]; };
/** Providers for Overlay and its related injectables. */
var OVERLAY_PROVIDERS = [
    Overlay,
    OverlayPositionBuilder,
    VIEWPORT_RULER_PROVIDER,
    SCROLL_DISPATCHER_PROVIDER,
    OVERLAY_CONTAINER_PROVIDER,
];
/**
 * Sends an event when the directive's element is scrolled. Registers itself with the
 * ScrollDispatcher service to include itself as part of its collection of scrolling events that it
 * can be listened to through the service.
 */
var Scrollable = (function () {
    /**
     * @param {?} _elementRef
     * @param {?} _scroll
     * @param {?} _ngZone
     * @param {?} _renderer
     */
    function Scrollable(_elementRef, _scroll, _ngZone, _renderer) {
        this._elementRef = _elementRef;
        this._scroll = _scroll;
        this._ngZone = _ngZone;
        this._renderer = _renderer;
        this._elementScrolled = new __WEBPACK_IMPORTED_MODULE_3_rxjs_Subject__["Subject"]();
    }
    /**
     * @return {?}
     */
    Scrollable.prototype.ngOnInit = function () {
        var _this = this;
        this._scrollListener = this._ngZone.runOutsideAngular(function () {
            return _this._renderer.listen(_this.getElementRef().nativeElement, 'scroll', function (event) {
                _this._elementScrolled.next(event);
            });
        });
        this._scroll.register(this);
    };
    /**
     * @return {?}
     */
    Scrollable.prototype.ngOnDestroy = function () {
        this._scroll.deregister(this);
        if (this._scrollListener) {
            this._scrollListener();
            this._scrollListener = null;
        }
    };
    /**
     * Returns observable that emits when a scroll event is fired on the host element.
     * @return {?}
     */
    Scrollable.prototype.elementScrolled = function () {
        return this._elementScrolled.asObservable();
    };
    /**
     * @return {?}
     */
    Scrollable.prototype.getElementRef = function () {
        return this._elementRef;
    };
    return Scrollable;
}());
Scrollable.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                selector: '[cdk-scrollable]'
            },] },
];
/**
 * @nocollapse
 */
Scrollable.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
    { type: ScrollDispatcher, },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgZone"], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
]; };
/** Default set of positions for the overlay. Follows the behavior of a dropdown. */
var defaultPositionList = [
    new ConnectionPositionPair({ originX: 'start', originY: 'bottom' }, { overlayX: 'start', overlayY: 'top' }),
    new ConnectionPositionPair({ originX: 'start', originY: 'top' }, { overlayX: 'start', overlayY: 'bottom' }),
];
/**
 * Directive applied to an element to make it usable as an origin for an Overlay using a
 * ConnectedPositionStrategy.
 */
var OverlayOrigin = (function () {
    /**
     * @param {?} elementRef
     */
    function OverlayOrigin(elementRef) {
        this.elementRef = elementRef;
    }
    return OverlayOrigin;
}());
OverlayOrigin.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                selector: '[cdk-overlay-origin], [overlay-origin]',
                exportAs: 'cdkOverlayOrigin',
            },] },
];
/**
 * @nocollapse
 */
OverlayOrigin.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
]; };
/**
 * Directive to facilitate declarative creation of an Overlay using a ConnectedPositionStrategy.
 */
var ConnectedOverlayDirective = (function () {
    /**
     * @param {?} _overlay
     * @param {?} templateRef
     * @param {?} viewContainerRef
     * @param {?} _dir
     */
    function ConnectedOverlayDirective(_overlay, templateRef, viewContainerRef, _dir) {
        this._overlay = _overlay;
        this._dir = _dir;
        this._open = false;
        this._hasBackdrop = false;
        this._offsetX = 0;
        this._offsetY = 0;
        /** Event emitted when the backdrop is clicked. */
        this.backdropClick = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /** Event emitted when the position has changed. */
        this.positionChange = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /** Event emitted when the overlay has been attached. */
        this.attach = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /** Event emitted when the overlay has been detached. */
        this.detach = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this._templatePortal = new TemplatePortal(templateRef, viewContainerRef);
    }
    Object.defineProperty(ConnectedOverlayDirective.prototype, "offsetX", {
        /**
         * The offset in pixels for the overlay connection point on the x-axis
         * @return {?}
         */
        get: function () {
            return this._offsetX;
        },
        /**
         * @param {?} offsetX
         * @return {?}
         */
        set: function (offsetX) {
            this._offsetX = offsetX;
            if (this._position) {
                this._position.withOffsetX(offsetX);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ConnectedOverlayDirective.prototype, "offsetY", {
        /**
         * The offset in pixels for the overlay connection point on the y-axis
         * @return {?}
         */
        get: function () {
            return this._offsetY;
        },
        /**
         * @param {?} offsetY
         * @return {?}
         */
        set: function (offsetY) {
            this._offsetY = offsetY;
            if (this._position) {
                this._position.withOffsetY(offsetY);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ConnectedOverlayDirective.prototype, "hasBackdrop", {
        /**
         * Whether or not the overlay should attach a backdrop.
         * @return {?}
         */
        get: function () {
            return this._hasBackdrop;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._hasBackdrop = coerceBooleanProperty(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ConnectedOverlayDirective.prototype, "open", {
        /**
         * @return {?}
         */
        get: function () {
            return this._open;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            value ? this._attachOverlay() : this._detachOverlay();
            this._open = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ConnectedOverlayDirective.prototype, "overlayRef", {
        /**
         * The associated overlay reference.
         * @return {?}
         */
        get: function () {
            return this._overlayRef;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ConnectedOverlayDirective.prototype, "dir", {
        /**
         * The element's layout direction.
         * @return {?}
         */
        get: function () {
            return this._dir ? this._dir.value : 'ltr';
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    ConnectedOverlayDirective.prototype.ngOnDestroy = function () {
        this._destroyOverlay();
    };
    /**
     * Creates an overlay
     * @return {?}
     */
    ConnectedOverlayDirective.prototype._createOverlay = function () {
        if (!this.positions || !this.positions.length) {
            this.positions = defaultPositionList;
        }
        this._overlayRef = this._overlay.create(this._buildConfig());
    };
    /**
     * Builds the overlay config based on the directive's inputs
     * @return {?}
     */
    ConnectedOverlayDirective.prototype._buildConfig = function () {
        var /** @type {?} */ overlayConfig = new OverlayState();
        if (this.width || this.width === 0) {
            overlayConfig.width = this.width;
        }
        if (this.height || this.height === 0) {
            overlayConfig.height = this.height;
        }
        if (this.minWidth || this.minWidth === 0) {
            overlayConfig.minWidth = this.minWidth;
        }
        if (this.minHeight || this.minHeight === 0) {
            overlayConfig.minHeight = this.minHeight;
        }
        overlayConfig.hasBackdrop = this.hasBackdrop;
        if (this.backdropClass) {
            overlayConfig.backdropClass = this.backdropClass;
        }
        this._position = (this._createPositionStrategy());
        overlayConfig.positionStrategy = this._position;
        return overlayConfig;
    };
    /**
     * Returns the position strategy of the overlay to be set on the overlay config
     * @return {?}
     */
    ConnectedOverlayDirective.prototype._createPositionStrategy = function () {
        var /** @type {?} */ pos = this.positions[0];
        var /** @type {?} */ originPoint = { originX: pos.originX, originY: pos.originY };
        var /** @type {?} */ overlayPoint = { overlayX: pos.overlayX, overlayY: pos.overlayY };
        var /** @type {?} */ strategy = this._overlay.position()
            .connectedTo(this.origin.elementRef, originPoint, overlayPoint)
            .withOffsetX(this.offsetX)
            .withOffsetY(this.offsetY);
        this._handlePositionChanges(strategy);
        return strategy;
    };
    /**
     * @param {?} strategy
     * @return {?}
     */
    ConnectedOverlayDirective.prototype._handlePositionChanges = function (strategy) {
        var _this = this;
        for (var /** @type {?} */ i = 1; i < this.positions.length; i++) {
            strategy.withFallbackPosition({ originX: this.positions[i].originX, originY: this.positions[i].originY }, { overlayX: this.positions[i].overlayX, overlayY: this.positions[i].overlayY });
        }
        this._positionSubscription =
            strategy.onPositionChange.subscribe(function (pos) { return _this.positionChange.emit(pos); });
    };
    /**
     * Attaches the overlay and subscribes to backdrop clicks if backdrop exists
     * @return {?}
     */
    ConnectedOverlayDirective.prototype._attachOverlay = function () {
        var _this = this;
        if (!this._overlayRef) {
            this._createOverlay();
        }
        this._position.withDirection(this.dir);
        this._overlayRef.getState().direction = this.dir;
        if (!this._overlayRef.hasAttached()) {
            this._overlayRef.attach(this._templatePortal);
            this.attach.emit();
        }
        if (this.hasBackdrop) {
            this._backdropSubscription = this._overlayRef.backdropClick().subscribe(function () {
                _this.backdropClick.emit();
            });
        }
    };
    /**
     * Detaches the overlay and unsubscribes to backdrop clicks if backdrop exists
     * @return {?}
     */
    ConnectedOverlayDirective.prototype._detachOverlay = function () {
        if (this._overlayRef) {
            this._overlayRef.detach();
            this.detach.emit();
        }
        if (this._backdropSubscription) {
            this._backdropSubscription.unsubscribe();
            this._backdropSubscription = null;
        }
    };
    /**
     * Destroys the overlay created by this directive.
     * @return {?}
     */
    ConnectedOverlayDirective.prototype._destroyOverlay = function () {
        if (this._overlayRef) {
            this._overlayRef.dispose();
        }
        if (this._backdropSubscription) {
            this._backdropSubscription.unsubscribe();
        }
        if (this._positionSubscription) {
            this._positionSubscription.unsubscribe();
        }
    };
    return ConnectedOverlayDirective;
}());
ConnectedOverlayDirective.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                selector: '[cdk-connected-overlay], [connected-overlay]',
                exportAs: 'cdkConnectedOverlay'
            },] },
];
/**
 * @nocollapse
 */
ConnectedOverlayDirective.ctorParameters = function () { return [
    { type: Overlay, },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["TemplateRef"], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewContainerRef"], },
    { type: Dir, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] },] },
]; };
ConnectedOverlayDirective.propDecorators = {
    'origin': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'positions': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'offsetX': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'offsetY': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'width': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'height': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'minWidth': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'minHeight': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'backdropClass': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'hasBackdrop': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'open': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'backdropClick': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
    'positionChange': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
    'attach': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
    'detach': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
};
var OverlayModule = (function () {
    function OverlayModule() {
    }
    /**
     * @deprecated
     * @return {?}
     */
    OverlayModule.forRoot = function () {
        return {
            ngModule: OverlayModule,
            providers: [],
        };
    };
    return OverlayModule;
}());
OverlayModule.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{
                imports: [PortalModule],
                exports: [ConnectedOverlayDirective, OverlayOrigin, Scrollable],
                declarations: [ConnectedOverlayDirective, OverlayOrigin, Scrollable],
                providers: [OVERLAY_PROVIDERS],
            },] },
];
/**
 * @nocollapse
 */
OverlayModule.ctorParameters = function () { return []; };
// Whether the current platform supports the V8 Break Iterator. The V8 check
// is necessary to detect all Blink based browsers.
var hasV8BreakIterator = typeof (window) !== 'undefined' ?
    (window.Intl && ((window.Intl)).v8BreakIterator) :
    (typeof (Intl) !== 'undefined' && ((Intl)).v8BreakIterator);
/**
 * Service to detect the current platform by comparing the userAgent strings and
 * checking browser-specific global properties.
 * \@docs-private
 */
var Platform = (function () {
    function Platform() {
        /** Layout Engines */
        this.EDGE = /(edge)/i.test(navigator.userAgent);
        this.TRIDENT = /(msie|trident)/i.test(navigator.userAgent);
        // EdgeHTML and Trident mock Blink specific things and need to excluded from this check.
        this.BLINK = !!(window.chrome || hasV8BreakIterator) && !!CSS && !this.EDGE && !this.TRIDENT;
        // Webkit is part of the userAgent in EdgeHTML Blink and Trident, so we need to
        // ensure that Webkit runs standalone and is not use as another engines base.
        this.WEBKIT = /AppleWebKit/i.test(navigator.userAgent) && !this.BLINK && !this.EDGE && !this.TRIDENT;
        /** Browsers and Platform Types */
        this.IOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
        // It's difficult to detect the plain Gecko engine, because most of the browsers identify
        // them self as Gecko-like browsers and modify the userAgent's according to that.
        // Since we only cover one explicit Firefox case, we can simply check for Firefox
        // instead of having an unstable check for Gecko.
        this.FIREFOX = /(firefox|minefield)/i.test(navigator.userAgent);
        // Trident on mobile adds the android platform to the userAgent to trick detections.
        this.ANDROID = /android/i.test(navigator.userAgent) && !this.TRIDENT;
    }
    return Platform;
}());
Platform.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
];
/**
 * @nocollapse
 */
Platform.ctorParameters = function () { return []; };
/**
 * Utility for checking the interactivity of an element, such as whether is is focusable or
 * tabbable.
 */
var InteractivityChecker = (function () {
    /**
     * @param {?} _platform
     */
    function InteractivityChecker(_platform) {
        this._platform = _platform;
    }
    /**
     * Gets whether an element is disabled.
     *
     * @param {?} element Element to be checked.
     * @return {?} Whether the element is disabled.
     */
    InteractivityChecker.prototype.isDisabled = function (element) {
        // This does not capture some cases, such as a non-form control with a disabled attribute or
        // a form control inside of a disabled form, but should capture the most common cases.
        return element.hasAttribute('disabled');
    };
    /**
     * Gets whether an element is visible for the purposes of interactivity.
     *
     * This will capture states like `display: none` and `visibility: hidden`, but not things like
     * being clipped by an `overflow: hidden` parent or being outside the viewport.
     *
     * @param {?} element
     * @return {?} Whether the element is visible.
     */
    InteractivityChecker.prototype.isVisible = function (element) {
        return hasGeometry(element) && getComputedStyle(element).visibility === 'visible';
    };
    /**
     * Gets whether an element can be reached via Tab key.
     * Assumes that the element has already been checked with isFocusable.
     *
     * @param {?} element Element to be checked.
     * @return {?} Whether the element is tabbable.
     */
    InteractivityChecker.prototype.isTabbable = function (element) {
        var /** @type {?} */ frameElement = (getWindow(element).frameElement);
        if (frameElement) {
            var /** @type {?} */ frameType = frameElement && frameElement.nodeName.toLowerCase();
            // Frame elements inherit their tabindex onto all child elements.
            if (getTabIndexValue(frameElement) === -1) {
                return false;
            }
            // Webkit and Blink consider anything inside of an <object> element as non-tabbable.
            if ((this._platform.BLINK || this._platform.WEBKIT) && frameType === 'object') {
                return false;
            }
            // Webkit and Blink disable tabbing to an element inside of an invisible frame.
            if ((this._platform.BLINK || this._platform.WEBKIT) && !this.isVisible(frameElement)) {
                return false;
            }
        }
        var /** @type {?} */ nodeName = element.nodeName.toLowerCase();
        var /** @type {?} */ tabIndexValue = getTabIndexValue(element);
        if (element.hasAttribute('contenteditable')) {
            return tabIndexValue !== -1;
        }
        if (nodeName === 'iframe') {
            // The frames may be tabbable depending on content, but it's not possibly to reliably
            // investigate the content of the frames.
            return false;
        }
        if (nodeName === 'audio') {
            if (!element.hasAttribute('controls')) {
                // By default an <audio> element without the controls enabled is not tabbable.
                return false;
            }
            else if (this._platform.BLINK) {
                // In Blink <audio controls> elements are always tabbable.
                return true;
            }
        }
        if (nodeName === 'video') {
            if (!element.hasAttribute('controls') && this._platform.TRIDENT) {
                // In Trident a <video> element without the controls enabled is not tabbable.
                return false;
            }
            else if (this._platform.BLINK || this._platform.FIREFOX) {
                // In Chrome and Firefox <video controls> elements are always tabbable.
                return true;
            }
        }
        if (nodeName === 'object' && (this._platform.BLINK || this._platform.WEBKIT)) {
            // In all Blink and WebKit based browsers <object> elements are never tabbable.
            return false;
        }
        // In iOS the browser only considers some specific elements as tabbable.
        if (this._platform.WEBKIT && this._platform.IOS && !isPotentiallyTabbableIOS(element)) {
            return false;
        }
        return element.tabIndex >= 0;
    };
    /**
     * Gets whether an element can be focused by the user.
     *
     * @param {?} element Element to be checked.
     * @return {?} Whether the element is focusable.
     */
    InteractivityChecker.prototype.isFocusable = function (element) {
        // Perform checks in order of left to most expensive.
        // Again, naive approach that does not capture many edge cases and browser quirks.
        return isPotentiallyFocusable(element) && !this.isDisabled(element) && this.isVisible(element);
    };
    return InteractivityChecker;
}());
InteractivityChecker.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
];
/**
 * @nocollapse
 */
InteractivityChecker.ctorParameters = function () { return [
    { type: Platform, },
]; };
/**
 * Checks whether the specified element has any geometry / rectangles.
 * @param {?} element
 * @return {?}
 */
function hasGeometry(element) {
    // Use logic from jQuery to check for an invisible element.
    // See https://github.com/jquery/jquery/blob/master/src/css/hiddenVisibleSelectors.js#L12
    return !!(element.offsetWidth || element.offsetHeight || element.getClientRects().length);
}
/**
 * Gets whether an element's
 * @param {?} element
 * @return {?}
 */
function isNativeFormElement(element) {
    var /** @type {?} */ nodeName = element.nodeName.toLowerCase();
    return nodeName === 'input' ||
        nodeName === 'select' ||
        nodeName === 'button' ||
        nodeName === 'textarea';
}
/**
 * Gets whether an element is an <input type="hidden">.
 * @param {?} element
 * @return {?}
 */
function isHiddenInput(element) {
    return isInputElement(element) && element.type == 'hidden';
}
/**
 * Gets whether an element is an anchor that has an href attribute.
 * @param {?} element
 * @return {?}
 */
function isAnchorWithHref(element) {
    return isAnchorElement(element) && element.hasAttribute('href');
}
/**
 * Gets whether an element is an input element.
 * @param {?} element
 * @return {?}
 */
function isInputElement(element) {
    return element.nodeName.toLowerCase() == 'input';
}
/**
 * Gets whether an element is an anchor element.
 * @param {?} element
 * @return {?}
 */
function isAnchorElement(element) {
    return element.nodeName.toLowerCase() == 'a';
}
/**
 * Gets whether an element has a valid tabindex.
 * @param {?} element
 * @return {?}
 */
function hasValidTabIndex(element) {
    if (!element.hasAttribute('tabindex') || element.tabIndex === undefined) {
        return false;
    }
    var /** @type {?} */ tabIndex = element.getAttribute('tabindex');
    // IE11 parses tabindex="" as the value "-32768"
    if (tabIndex == '-32768') {
        return false;
    }
    return !!(tabIndex && !isNaN(parseInt(tabIndex, 10)));
}
/**
 * Returns the parsed tabindex from the element attributes instead of returning the
 * evaluated tabindex from the browsers defaults.
 * @param {?} element
 * @return {?}
 */
function getTabIndexValue(element) {
    if (!hasValidTabIndex(element)) {
        return null;
    }
    // See browser issue in Gecko https://bugzilla.mozilla.org/show_bug.cgi?id=1128054
    var /** @type {?} */ tabIndex = parseInt(element.getAttribute('tabindex'), 10);
    return isNaN(tabIndex) ? -1 : tabIndex;
}
/**
 * Checks whether the specified element is potentially tabbable on iOS
 * @param {?} element
 * @return {?}
 */
function isPotentiallyTabbableIOS(element) {
    var /** @type {?} */ nodeName = element.nodeName.toLowerCase();
    var /** @type {?} */ inputType = nodeName === 'input' && ((element)).type;
    return inputType === 'text'
        || inputType === 'password'
        || nodeName === 'select'
        || nodeName === 'textarea';
}
/**
 * Gets whether an element is potentially focusable without taking current visible/disabled state
 * into account.
 * @param {?} element
 * @return {?}
 */
function isPotentiallyFocusable(element) {
    // Inputs are potentially focusable *unless* they're type="hidden".
    if (isHiddenInput(element)) {
        return false;
    }
    return isNativeFormElement(element) ||
        isAnchorWithHref(element) ||
        element.hasAttribute('contenteditable') ||
        hasValidTabIndex(element);
}
/**
 * Gets the parent window of a DOM node with regards of being inside of an iframe.
 * @param {?} node
 * @return {?}
 */
function getWindow(node) {
    return node.ownerDocument.defaultView || window;
}
/**
 * Class that allows for trapping focus within a DOM element.
 *
 * NOTE: This class currently uses a very simple (naive) approach to focus trapping.
 * It assumes that the tab order is the same as DOM order, which is not necessarily true.
 * Things like tabIndex > 0, flex `order`, and shadow roots can cause to two to misalign.
 * This will be replaced with a more intelligent solution before the library is considered stable.
 */
var FocusTrap = (function () {
    /**
     * @param {?} _element
     * @param {?} _checker
     * @param {?} _ngZone
     * @param {?=} deferAnchors
     */
    function FocusTrap(_element, _checker, _ngZone, deferAnchors) {
        if (deferAnchors === void 0) { deferAnchors = false; }
        this._element = _element;
        this._checker = _checker;
        this._ngZone = _ngZone;
        this._enabled = true;
        if (!deferAnchors) {
            this.attachAnchors();
        }
    }
    Object.defineProperty(FocusTrap.prototype, "enabled", {
        /**
         * Whether the focus trap is active.
         * @return {?}
         */
        get: function () { return this._enabled; },
        /**
         * @param {?} val
         * @return {?}
         */
        set: function (val) {
            this._enabled = val;
            if (this._startAnchor && this._endAnchor) {
                this._startAnchor.tabIndex = this._endAnchor.tabIndex = this._enabled ? 0 : -1;
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Destroys the focus trap by cleaning up the anchors.
     * @return {?}
     */
    FocusTrap.prototype.destroy = function () {
        if (this._startAnchor && this._startAnchor.parentNode) {
            this._startAnchor.parentNode.removeChild(this._startAnchor);
        }
        if (this._endAnchor && this._endAnchor.parentNode) {
            this._endAnchor.parentNode.removeChild(this._endAnchor);
        }
        this._startAnchor = this._endAnchor = null;
    };
    /**
     * Inserts the anchors into the DOM. This is usually done automatically
     * in the constructor, but can be deferred for cases like directives with `*ngIf`.
     * @return {?}
     */
    FocusTrap.prototype.attachAnchors = function () {
        var _this = this;
        if (!this._startAnchor) {
            this._startAnchor = this._createAnchor();
        }
        if (!this._endAnchor) {
            this._endAnchor = this._createAnchor();
        }
        this._ngZone.runOutsideAngular(function () {
            _this._startAnchor.addEventListener('focus', function () { return _this.focusLastTabbableElement(); });
            _this._endAnchor.addEventListener('focus', function () { return _this.focusFirstTabbableElement(); });
            _this._element.parentNode.insertBefore(_this._startAnchor, _this._element);
            _this._element.parentNode.insertBefore(_this._endAnchor, _this._element.nextSibling);
        });
    };
    /**
     * Waits for microtask queue to empty, then focuses
     * the first tabbable element within the focus trap region.
     * @return {?}
     */
    FocusTrap.prototype.focusFirstTabbableElementWhenReady = function () {
        var _this = this;
        this._ngZone.onMicrotaskEmpty.first().subscribe(function () { return _this.focusFirstTabbableElement(); });
    };
    /**
     * Waits for microtask queue to empty, then focuses
     * the last tabbable element within the focus trap region.
     * @return {?}
     */
    FocusTrap.prototype.focusLastTabbableElementWhenReady = function () {
        var _this = this;
        this._ngZone.onMicrotaskEmpty.first().subscribe(function () { return _this.focusLastTabbableElement(); });
    };
    /**
     * Focuses the first tabbable element within the focus trap region.
     * @return {?}
     */
    FocusTrap.prototype.focusFirstTabbableElement = function () {
        var /** @type {?} */ redirectToElement = (this._element.querySelector('[cdk-focus-start]')) ||
            this._getFirstTabbableElement(this._element);
        if (redirectToElement) {
            redirectToElement.focus();
        }
    };
    /**
     * Focuses the last tabbable element within the focus trap region.
     * @return {?}
     */
    FocusTrap.prototype.focusLastTabbableElement = function () {
        var /** @type {?} */ focusTargets = this._element.querySelectorAll('[cdk-focus-end]');
        var /** @type {?} */ redirectToElement = null;
        if (focusTargets.length) {
            redirectToElement = (focusTargets[focusTargets.length - 1]);
        }
        else {
            redirectToElement = this._getLastTabbableElement(this._element);
        }
        if (redirectToElement) {
            redirectToElement.focus();
        }
    };
    /**
     * Get the first tabbable element from a DOM subtree (inclusive).
     * @param {?} root
     * @return {?}
     */
    FocusTrap.prototype._getFirstTabbableElement = function (root) {
        if (this._checker.isFocusable(root) && this._checker.isTabbable(root)) {
            return root;
        }
        // Iterate in DOM order. Note that IE doesn't have `children` for SVG so we fall
        // back to `childNodes` which includes text nodes, comments etc.
        var /** @type {?} */ children = root.children || root.childNodes;
        for (var /** @type {?} */ i = 0; i < children.length; i++) {
            var /** @type {?} */ tabbableChild = children[i].nodeType === Node.ELEMENT_NODE ?
                this._getFirstTabbableElement(/** @type {?} */ (children[i])) :
                null;
            if (tabbableChild) {
                return tabbableChild;
            }
        }
        return null;
    };
    /**
     * Get the last tabbable element from a DOM subtree (inclusive).
     * @param {?} root
     * @return {?}
     */
    FocusTrap.prototype._getLastTabbableElement = function (root) {
        if (this._checker.isFocusable(root) && this._checker.isTabbable(root)) {
            return root;
        }
        // Iterate in reverse DOM order.
        var /** @type {?} */ children = root.children || root.childNodes;
        for (var /** @type {?} */ i = children.length - 1; i >= 0; i--) {
            var /** @type {?} */ tabbableChild = children[i].nodeType === Node.ELEMENT_NODE ?
                this._getLastTabbableElement(/** @type {?} */ (children[i])) :
                null;
            if (tabbableChild) {
                return tabbableChild;
            }
        }
        return null;
    };
    /**
     * Creates an anchor element.
     * @return {?}
     */
    FocusTrap.prototype._createAnchor = function () {
        var /** @type {?} */ anchor = document.createElement('div');
        anchor.tabIndex = this._enabled ? 0 : -1;
        anchor.classList.add('cdk-visually-hidden');
        anchor.classList.add('cdk-focus-trap-anchor');
        return anchor;
    };
    return FocusTrap;
}());
/**
 * Factory that allows easy instantiation of focus traps.
 */
var FocusTrapFactory = (function () {
    /**
     * @param {?} _checker
     * @param {?} _ngZone
     */
    function FocusTrapFactory(_checker, _ngZone) {
        this._checker = _checker;
        this._ngZone = _ngZone;
    }
    /**
     * @param {?} element
     * @param {?=} deferAnchors
     * @return {?}
     */
    FocusTrapFactory.prototype.create = function (element, deferAnchors) {
        if (deferAnchors === void 0) { deferAnchors = false; }
        return new FocusTrap(element, this._checker, this._ngZone, deferAnchors);
    };
    return FocusTrapFactory;
}());
FocusTrapFactory.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
];
/**
 * @nocollapse
 */
FocusTrapFactory.ctorParameters = function () { return [
    { type: InteractivityChecker, },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgZone"], },
]; };
/**
 * Directive for trapping focus within a region.
 * @deprecated
 */
var FocusTrapDeprecatedDirective = (function () {
    /**
     * @param {?} _elementRef
     * @param {?} _focusTrapFactory
     */
    function FocusTrapDeprecatedDirective(_elementRef, _focusTrapFactory) {
        this._elementRef = _elementRef;
        this._focusTrapFactory = _focusTrapFactory;
        this.focusTrap = this._focusTrapFactory.create(this._elementRef.nativeElement, true);
    }
    Object.defineProperty(FocusTrapDeprecatedDirective.prototype, "disabled", {
        /**
         * Whether the focus trap is active.
         * @return {?}
         */
        get: function () { return !this.focusTrap.enabled; },
        /**
         * @param {?} val
         * @return {?}
         */
        set: function (val) {
            this.focusTrap.enabled = !coerceBooleanProperty(val);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    FocusTrapDeprecatedDirective.prototype.ngOnDestroy = function () {
        this.focusTrap.destroy();
    };
    /**
     * @return {?}
     */
    FocusTrapDeprecatedDirective.prototype.ngAfterContentInit = function () {
        this.focusTrap.attachAnchors();
    };
    return FocusTrapDeprecatedDirective;
}());
FocusTrapDeprecatedDirective.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                selector: 'cdk-focus-trap',
            },] },
];
/**
 * @nocollapse
 */
FocusTrapDeprecatedDirective.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
    { type: FocusTrapFactory, },
]; };
FocusTrapDeprecatedDirective.propDecorators = {
    'disabled': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
};
/**
 * Directive for trapping focus within a region.
 */
var FocusTrapDirective = (function () {
    /**
     * @param {?} _elementRef
     * @param {?} _focusTrapFactory
     */
    function FocusTrapDirective(_elementRef, _focusTrapFactory) {
        this._elementRef = _elementRef;
        this._focusTrapFactory = _focusTrapFactory;
        this.focusTrap = this._focusTrapFactory.create(this._elementRef.nativeElement, true);
    }
    Object.defineProperty(FocusTrapDirective.prototype, "enabled", {
        /**
         * Whether the focus trap is active.
         * @return {?}
         */
        get: function () { return this.focusTrap.enabled; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this.focusTrap.enabled = coerceBooleanProperty(value); },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    FocusTrapDirective.prototype.ngOnDestroy = function () {
        this.focusTrap.destroy();
    };
    /**
     * @return {?}
     */
    FocusTrapDirective.prototype.ngAfterContentInit = function () {
        this.focusTrap.attachAnchors();
    };
    return FocusTrapDirective;
}());
FocusTrapDirective.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                selector: '[cdkTrapFocus]',
                exportAs: 'cdkTrapFocus',
            },] },
];
/**
 * @nocollapse
 */
FocusTrapDirective.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
    { type: FocusTrapFactory, },
]; };
FocusTrapDirective.propDecorators = {
    'enabled': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['cdkTrapFocus',] },],
};
var LIVE_ANNOUNCER_ELEMENT_TOKEN = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["OpaqueToken"]('liveAnnouncerElement');
var LiveAnnouncer = (function () {
    /**
     * @param {?} elementToken
     */
    function LiveAnnouncer(elementToken) {
        // We inject the live element as `any` because the constructor signature cannot reference
        // browser globals (HTMLElement) on non-browser environments, since having a class decorator
        // causes TypeScript to preserve the constructor signature types.
        this._liveElement = elementToken || this._createLiveElement();
    }
    /**
     * Announces a message to screenreaders.
     * @param {?} message Message to be announced to the screenreader
     * @param {?=} politeness The politeness of the announcer element
     * @return {?}
     */
    LiveAnnouncer.prototype.announce = function (message, politeness) {
        var _this = this;
        if (politeness === void 0) { politeness = 'polite'; }
        this._liveElement.textContent = '';
        // TODO: ensure changing the politeness works on all environments we support.
        this._liveElement.setAttribute('aria-live', politeness);
        // This 100ms timeout is necessary for some browser + screen-reader combinations:
        // - Both JAWS and NVDA over IE11 will not announce anything without a non-zero timeout.
        // - With Chrome and IE11 with NVDA or JAWS, a repeated (identical) message won't be read a
        //   second time without clearing and then using a non-zero delay.
        // (using JAWS 17 at time of this writing).
        setTimeout(function () { return _this._liveElement.textContent = message; }, 100);
    };
    /**
     * Removes the aria-live element from the DOM.
     * @return {?}
     */
    LiveAnnouncer.prototype._removeLiveElement = function () {
        if (this._liveElement && this._liveElement.parentNode) {
            this._liveElement.parentNode.removeChild(this._liveElement);
        }
    };
    /**
     * @return {?}
     */
    LiveAnnouncer.prototype._createLiveElement = function () {
        var /** @type {?} */ liveEl = document.createElement('div');
        liveEl.classList.add('cdk-visually-hidden');
        liveEl.setAttribute('aria-atomic', 'true');
        liveEl.setAttribute('aria-live', 'polite');
        document.body.appendChild(liveEl);
        return liveEl;
    };
    return LiveAnnouncer;
}());
LiveAnnouncer.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
];
/**
 * @nocollapse
 */
LiveAnnouncer.ctorParameters = function () { return [
    { type: undefined, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [LIVE_ANNOUNCER_ELEMENT_TOKEN,] },] },
]; };
/**
 * @param {?} parentDispatcher
 * @param {?} liveElement
 * @return {?}
 */
function LIVE_ANNOUNCER_PROVIDER_FACTORY(parentDispatcher, liveElement) {
    return parentDispatcher || new LiveAnnouncer(liveElement);
}
var LIVE_ANNOUNCER_PROVIDER = {
    // If there is already a LiveAnnouncer available, use that. Otherwise, provide a new one.
    provide: LiveAnnouncer,
    deps: [
        [new __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"](), new __WEBPACK_IMPORTED_MODULE_0__angular_core__["SkipSelf"](), LiveAnnouncer],
        [new __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"](), new __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"](LIVE_ANNOUNCER_ELEMENT_TOKEN)]
    ],
    useFactory: LIVE_ANNOUNCER_PROVIDER_FACTORY
};
var supportedInputTypes;
/**
 * @return {?} The input types supported by this browser.
 */
function getSupportedInputTypes() {
    if (!supportedInputTypes) {
        var /** @type {?} */ featureTestInput_1 = document.createElement('input');
        supportedInputTypes = new Set([
            // `color` must come first. Chrome 56 shows a warning if we change the type to `color` after
            // first changing it to something else:
            // The specified value "" does not conform to the required format.
            // The format is "#rrggbb" where rr, gg, bb are two-digit hexadecimal numbers.
            'color',
            'button',
            'checkbox',
            'date',
            'datetime-local',
            'email',
            'file',
            'hidden',
            'image',
            'month',
            'number',
            'password',
            'radio',
            'range',
            'reset',
            'search',
            'submit',
            'tel',
            'text',
            'time',
            'url',
            'week',
        ].filter(function (value) {
            featureTestInput_1.setAttribute('type', value);
            return featureTestInput_1.type === value;
        }));
    }
    return supportedInputTypes;
}
var PlatformModule = (function () {
    function PlatformModule() {
    }
    /**
     * @deprecated
     * @return {?}
     */
    PlatformModule.forRoot = function () {
        return {
            ngModule: PlatformModule,
            providers: [],
        };
    };
    return PlatformModule;
}());
PlatformModule.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{
                providers: [Platform]
            },] },
];
/**
 * @nocollapse
 */
PlatformModule.ctorParameters = function () { return []; };
var A11yModule = (function () {
    function A11yModule() {
    }
    /**
     * @deprecated
     * @return {?}
     */
    A11yModule.forRoot = function () {
        return {
            ngModule: A11yModule,
            providers: [],
        };
    };
    return A11yModule;
}());
A11yModule.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{
                imports: [__WEBPACK_IMPORTED_MODULE_2__angular_common__["CommonModule"], PlatformModule],
                declarations: [FocusTrapDirective, FocusTrapDeprecatedDirective],
                exports: [FocusTrapDirective, FocusTrapDeprecatedDirective],
                providers: [InteractivityChecker, FocusTrapFactory, LIVE_ANNOUNCER_PROVIDER]
            },] },
];
/**
 * @nocollapse
 */
A11yModule.ctorParameters = function () { return []; };
/**
 * The FullscreenOverlayContainer is the alternative to OverlayContainer
 * that supports correct displaying of overlay elements in Fullscreen mode
 * https://developer.mozilla.org/en-US/docs/Web/API/Element/requestFullScreen
 * It should be provided in the root component that way:
 * providers: [
 *   {provide: OverlayContainer, useClass: FullscreenOverlayContainer}
 * ],
 */
var FullscreenOverlayContainer = (function (_super) {
    __extends(FullscreenOverlayContainer, _super);
    function FullscreenOverlayContainer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @return {?}
     */
    FullscreenOverlayContainer.prototype._createContainer = function () {
        var _this = this;
        _super.prototype._createContainer.call(this);
        this._adjustParentForFullscreenChange();
        this._addFullscreenChangeListener(function () { return _this._adjustParentForFullscreenChange(); });
    };
    /**
     * @return {?}
     */
    FullscreenOverlayContainer.prototype._adjustParentForFullscreenChange = function () {
        if (!this._containerElement) {
            return;
        }
        var /** @type {?} */ fullscreenElement = this.getFullscreenElement();
        var /** @type {?} */ parent = fullscreenElement || document.body;
        parent.appendChild(this._containerElement);
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    FullscreenOverlayContainer.prototype._addFullscreenChangeListener = function (fn) {
        if (document.fullscreenEnabled) {
            document.addEventListener('fullscreenchange', fn);
        }
        else if (document.webkitFullscreenEnabled) {
            document.addEventListener('webkitfullscreenchange', fn);
        }
        else if (((document)).mozFullScreenEnabled) {
            document.addEventListener('mozfullscreenchange', fn);
        }
        else if (((document)).msFullscreenEnabled) {
            document.addEventListener('MSFullscreenChange', fn);
        }
    };
    /**
     * When the page is put into fullscreen mode, a specific element is specified.
     * Only that element and its children are visible when in fullscreen mode.
     * @return {?}
     */
    FullscreenOverlayContainer.prototype.getFullscreenElement = function () {
        return document.fullscreenElement ||
            document.webkitFullscreenElement ||
            ((document)).mozFullScreenElement ||
            ((document)).msFullscreenElement ||
            null;
    };
    return FullscreenOverlayContainer;
}(OverlayContainer));
FullscreenOverlayContainer.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
];
/**
 * @nocollapse
 */
FullscreenOverlayContainer.ctorParameters = function () { return []; };
var GestureConfig = (function (_super) {
    __extends(GestureConfig, _super);
    function GestureConfig() {
        var _this = _super.call(this) || this;
        _this._hammer = typeof window !== 'undefined' ? ((window)).Hammer : null;
        /* List of new event names to add to the gesture support list */
        _this.events = _this._hammer ? [
            'longpress',
            'slide',
            'slidestart',
            'slideend',
            'slideright',
            'slideleft'
        ] : [];
        if (!_this._hammer && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["isDevMode"])()) {
            console.warn('Could not find HammerJS. Certain Angular Material ' +
                'components may not work correctly.');
        }
        return _this;
    }
    /**
     * Builds Hammer instance manually to add custom recognizers that match the Material Design spec.
     *
     * Our gesture names come from the Material Design gestures spec:
     * https://www.google.com/design/spec/patterns/gestures.html#gestures-touch-mechanics
     *
     * More information on default recognizers can be found in Hammer docs:
     * http://hammerjs.github.io/recognizer-pan/
     * http://hammerjs.github.io/recognizer-press/
     *
     * @param {?} element Element to which to assign the new HammerJS gestures.
     * @return {?} Newly-created HammerJS instance.
     */
    GestureConfig.prototype.buildHammer = function (element) {
        var /** @type {?} */ mc = new this._hammer(element);
        // Default Hammer Recognizers.
        var /** @type {?} */ pan = new this._hammer.Pan();
        var /** @type {?} */ swipe = new this._hammer.Swipe();
        var /** @type {?} */ press = new this._hammer.Press();
        // Notice that a HammerJS recognizer can only depend on one other recognizer once.
        // Otherwise the previous `recognizeWith` will be dropped.
        // TODO: Confirm threshold numbers with Material Design UX Team
        var /** @type {?} */ slide = this._createRecognizer(pan, { event: 'slide', threshold: 0 }, swipe);
        var /** @type {?} */ longpress = this._createRecognizer(press, { event: 'longpress', time: 500 });
        // Overwrite the default `pan` event to use the swipe event.
        pan.recognizeWith(swipe);
        // Add customized gestures to Hammer manager
        mc.add([swipe, press, pan, slide, longpress]);
        return (mc);
    };
    /**
     * Creates a new recognizer, without affecting the default recognizers of HammerJS
     * @param {?} base
     * @param {?} options
     * @param {...?} inheritances
     * @return {?}
     */
    GestureConfig.prototype._createRecognizer = function (base, options) {
        var inheritances = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            inheritances[_i - 2] = arguments[_i];
        }
        var /** @type {?} */ recognizer = new ((base.constructor))(options);
        inheritances.push(base);
        inheritances.forEach(function (item) { return recognizer.recognizeWith(item); });
        return recognizer;
    };
    return GestureConfig;
}(__WEBPACK_IMPORTED_MODULE_1__angular_platform_browser__["HammerGestureConfig"]));
GestureConfig.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
];
/**
 * @nocollapse
 */
GestureConfig.ctorParameters = function () { return []; };
/**
 * Class to be used to power selecting one or more options from a list.
 * \@docs-private
 */
var SelectionModel = (function () {
    /**
     * @param {?=} _isMulti
     * @param {?=} initiallySelectedValues
     * @param {?=} _emitChanges
     */
    function SelectionModel(_isMulti, initiallySelectedValues, _emitChanges) {
        if (_isMulti === void 0) { _isMulti = false; }
        if (_emitChanges === void 0) { _emitChanges = true; }
        var _this = this;
        this._isMulti = _isMulti;
        this._emitChanges = _emitChanges;
        this._selection = new Set();
        this._deselectedToEmit = [];
        this._selectedToEmit = [];
        /** Event emitted when the value has changed. */
        this.onChange = this._emitChanges ? new __WEBPACK_IMPORTED_MODULE_3_rxjs_Subject__["Subject"]() : null;
        if (initiallySelectedValues) {
            if (_isMulti) {
                initiallySelectedValues.forEach(function (value) { return _this._markSelected(value); });
            }
            else {
                this._markSelected(initiallySelectedValues[0]);
            }
            // Clear the array in order to avoid firing the change event for preselected values.
            this._selectedToEmit.length = 0;
        }
    }
    Object.defineProperty(SelectionModel.prototype, "selected", {
        /**
         * Selected value(s).
         * @return {?}
         */
        get: function () {
            if (!this._selected) {
                this._selected = Array.from(this._selection.values());
            }
            return this._selected;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Selects a value or an array of values.
     * @param {?} value
     * @return {?}
     */
    SelectionModel.prototype.select = function (value) {
        this._markSelected(value);
        this._emitChangeEvent();
    };
    /**
     * Deselects a value or an array of values.
     * @param {?} value
     * @return {?}
     */
    SelectionModel.prototype.deselect = function (value) {
        this._unmarkSelected(value);
        this._emitChangeEvent();
    };
    /**
     * Toggles a value between selected and deselected.
     * @param {?} value
     * @return {?}
     */
    SelectionModel.prototype.toggle = function (value) {
        this.isSelected(value) ? this.deselect(value) : this.select(value);
    };
    /**
     * Clears all of the selected values.
     * @return {?}
     */
    SelectionModel.prototype.clear = function () {
        this._unmarkAll();
        this._emitChangeEvent();
    };
    /**
     * Determines whether a value is selected.
     * @param {?} value
     * @return {?}
     */
    SelectionModel.prototype.isSelected = function (value) {
        return this._selection.has(value);
    };
    /**
     * Determines whether the model does not have a value.
     * @return {?}
     */
    SelectionModel.prototype.isEmpty = function () {
        return this._selection.size === 0;
    };
    /**
     * Determines whether the model has a value.
     * @return {?}
     */
    SelectionModel.prototype.hasValue = function () {
        return !this.isEmpty();
    };
    /**
     * Sorts the selected values based on a predicate function.
     * @param {?=} predicate
     * @return {?}
     */
    SelectionModel.prototype.sort = function (predicate) {
        if (this._isMulti && this.selected) {
            this._selected.sort(predicate);
        }
    };
    /**
     * Emits a change event and clears the records of selected and deselected values.
     * @return {?}
     */
    SelectionModel.prototype._emitChangeEvent = function () {
        if (this._selectedToEmit.length || this._deselectedToEmit.length) {
            var /** @type {?} */ eventData = new SelectionChange(this._selectedToEmit, this._deselectedToEmit);
            this.onChange.next(eventData);
            this._deselectedToEmit = [];
            this._selectedToEmit = [];
        }
        this._selected = null;
    };
    /**
     * Selects a value.
     * @param {?} value
     * @return {?}
     */
    SelectionModel.prototype._markSelected = function (value) {
        if (!this.isSelected(value)) {
            if (!this._isMulti) {
                this._unmarkAll();
            }
            this._selection.add(value);
            if (this._emitChanges) {
                this._selectedToEmit.push(value);
            }
        }
    };
    /**
     * Deselects a value.
     * @param {?} value
     * @return {?}
     */
    SelectionModel.prototype._unmarkSelected = function (value) {
        if (this.isSelected(value)) {
            this._selection.delete(value);
            if (this._emitChanges) {
                this._deselectedToEmit.push(value);
            }
        }
    };
    /**
     * Clears out the selected values.
     * @return {?}
     */
    SelectionModel.prototype._unmarkAll = function () {
        var _this = this;
        if (!this.isEmpty()) {
            this._selection.forEach(function (value) { return _this._unmarkSelected(value); });
        }
    };
    return SelectionModel;
}());
/**
 * Describes an event emitted when the value of a MdSelectionModel has changed.
 * \@docs-private
 */
var SelectionChange = (function () {
    /**
     * @param {?=} added
     * @param {?=} removed
     */
    function SelectionChange(added, removed) {
        this.added = added;
        this.removed = removed;
    }
    return SelectionChange;
}());
/**
 * Screenreaders will often fire fake mousedown events when a focusable element
 * is activated using the keyboard. We can typically distinguish between these faked
 * mousedown events and real mousedown events using the "buttons" property. While
 * real mousedowns will indicate the mouse button that was pressed (e.g. "1" for
 * the left mouse button), faked mousedowns will usually set the property value to 0.
 * @param {?} event
 * @return {?}
 */
function isFakeMousedownFromScreenReader(event) {
    return event.buttons === 0;
}
/**
 * Class to coordinate unique selection based on name.
 * Intended to be consumed as an Angular service.
 * This service is needed because native radio change events are only fired on the item currently
 * being selected, and we still need to uncheck the previous selection.
 *
 * This service does not *store* any IDs and names because they may change at any time, so it is
 * less error-prone if they are simply passed through when the events occur.
 */
var UniqueSelectionDispatcher = (function () {
    function UniqueSelectionDispatcher() {
        this._listeners = [];
    }
    /**
     * Notify other items that selection for the given name has been set.
     * @param {?} id ID of the item.
     * @param {?} name Name of the item.
     * @return {?}
     */
    UniqueSelectionDispatcher.prototype.notify = function (id, name) {
        for (var _i = 0, _a = this._listeners; _i < _a.length; _i++) {
            var listener = _a[_i];
            listener(id, name);
        }
    };
    /**
     * Listen for future changes to item selection.
     * @param {?} listener
     * @return {?}
     */
    UniqueSelectionDispatcher.prototype.listen = function (listener) {
        this._listeners.push(listener);
    };
    return UniqueSelectionDispatcher;
}());
UniqueSelectionDispatcher.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
];
/**
 * @nocollapse
 */
UniqueSelectionDispatcher.ctorParameters = function () { return []; };
/**
 * @param {?} parentDispatcher
 * @return {?}
 */
function UNIQUE_SELECTION_DISPATCHER_PROVIDER_FACTORY(parentDispatcher) {
    return parentDispatcher || new UniqueSelectionDispatcher();
}
var UNIQUE_SELECTION_DISPATCHER_PROVIDER = {
    // If there is already a dispatcher available, use that. Otherwise, provide a new one.
    provide: UniqueSelectionDispatcher,
    deps: [[new __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"](), new __WEBPACK_IMPORTED_MODULE_0__angular_core__["SkipSelf"](), UniqueSelectionDispatcher]],
    useFactory: UNIQUE_SELECTION_DISPATCHER_PROVIDER_FACTORY
};
// This is the value used by AngularJS Material. Through trial and error (on iPhone 6S) they found
// that a value of around 650ms seems appropriate.
var TOUCH_BUFFER_MS = 650;
/**
 * Monitors mouse and keyboard events to determine the cause of focus events.
 */
var FocusOriginMonitor = (function () {
    /**
     * @param {?} _ngZone
     */
    function FocusOriginMonitor(_ngZone) {
        var _this = this;
        this._ngZone = _ngZone;
        this._origin = null;
        this._windowFocused = false;
        this._elementInfo = new WeakMap();
        this._ngZone.runOutsideAngular(function () { return _this._registerDocumentEvents(); });
    }
    /**
     * Monitors focus on an element and applies appropriate CSS classes.
     * @param {?} element The element to monitor
     * @param {?} renderer The renderer to use to apply CSS classes to the element.
     * @param {?} checkChildren Whether to count the element as focused when its children are focused.
     * @return {?} An observable that emits when the focus state of the element changes.
     *     When the element is blurred, null will be emitted.
     */
    FocusOriginMonitor.prototype.monitor = function (element, renderer, checkChildren) {
        var _this = this;
        // Check if we're already monitoring this element.
        if (this._elementInfo.has(element)) {
            var /** @type {?} */ info_1 = this._elementInfo.get(element);
            info_1.checkChildren = checkChildren;
            return info_1.subject.asObservable();
        }
        // Create monitored element info.
        var /** @type {?} */ info = {
            unlisten: null,
            checkChildren: checkChildren,
            renderer: renderer,
            subject: new __WEBPACK_IMPORTED_MODULE_3_rxjs_Subject__["Subject"]()
        };
        this._elementInfo.set(element, info);
        // Start listening. We need to listen in capture phase since focus events don't bubble.
        var /** @type {?} */ focusListener = function (event) { return _this._onFocus(event, element); };
        var /** @type {?} */ blurListener = function (event) { return _this._onBlur(event, element); };
        this._ngZone.runOutsideAngular(function () {
            element.addEventListener('focus', focusListener, true);
            element.addEventListener('blur', blurListener, true);
        });
        // Create an unlisten function for later.
        info.unlisten = function () {
            element.removeEventListener('focus', focusListener, true);
            element.removeEventListener('blur', blurListener, true);
        };
        return info.subject.asObservable();
    };
    /**
     * Stops monitoring an element and removes all focus classes.
     * @param {?} element The element to stop monitoring.
     * @return {?}
     */
    FocusOriginMonitor.prototype.stopMonitoring = function (element) {
        var /** @type {?} */ elementInfo = this._elementInfo.get(element);
        if (elementInfo) {
            elementInfo.unlisten();
            elementInfo.subject.complete();
            this._setClasses(element, null);
            this._elementInfo.delete(element);
        }
    };
    /**
     * Focuses the element via the specified focus origin.
     * @param {?} element The element to focus.
     * @param {?} renderer The renderer to use to invoke the focus method on the element.
     * @param {?} origin The focus origin.
     * @return {?}
     */
    FocusOriginMonitor.prototype.focusVia = function (element, renderer, origin) {
        this._setOriginForCurrentEventQueue(origin);
        renderer.invokeElementMethod(element, 'focus');
    };
    /**
     * Register necessary event listeners on the document and window.
     * @return {?}
     */
    FocusOriginMonitor.prototype._registerDocumentEvents = function () {
        var _this = this;
        // Note: we listen to events in the capture phase so we can detect them even if the user stops
        // propagation.
        // On keydown record the origin and clear any touch event that may be in progress.
        document.addEventListener('keydown', function () {
            _this._lastTouchTarget = null;
            _this._setOriginForCurrentEventQueue('keyboard');
        }, true);
        // On mousedown record the origin only if there is not touch target, since a mousedown can
        // happen as a result of a touch event.
        document.addEventListener('mousedown', function () {
            if (!_this._lastTouchTarget) {
                _this._setOriginForCurrentEventQueue('mouse');
            }
        }, true);
        // When the touchstart event fires the focus event is not yet in the event queue. This means
        // we can't rely on the trick used above (setting timeout of 0ms). Instead we wait 650ms to
        // see if a focus happens.
        document.addEventListener('touchstart', function (event) {
            if (_this._touchTimeout != null) {
                clearTimeout(_this._touchTimeout);
            }
            _this._lastTouchTarget = event.target;
            _this._touchTimeout = setTimeout(function () { return _this._lastTouchTarget = null; }, TOUCH_BUFFER_MS);
        }, true);
        // Make a note of when the window regains focus, so we can restore the origin info for the
        // focused element.
        window.addEventListener('focus', function () {
            _this._windowFocused = true;
            setTimeout(function () { return _this._windowFocused = false; }, 0);
        });
    };
    /**
     * Sets the focus classes on the element based on the given focus origin.
     * @param {?} element The element to update the classes on.
     * @param {?} origin The focus origin.
     * @return {?}
     */
    FocusOriginMonitor.prototype._setClasses = function (element, origin) {
        var /** @type {?} */ renderer = this._elementInfo.get(element).renderer;
        renderer.setElementClass(element, 'cdk-focused', !!origin);
        renderer.setElementClass(element, 'cdk-touch-focused', origin === 'touch');
        renderer.setElementClass(element, 'cdk-keyboard-focused', origin === 'keyboard');
        renderer.setElementClass(element, 'cdk-mouse-focused', origin === 'mouse');
        renderer.setElementClass(element, 'cdk-program-focused', origin === 'program');
    };
    /**
     * Sets the origin and schedules an async function to clear it at the end of the event queue.
     * @param {?} origin The origin to set.
     * @return {?}
     */
    FocusOriginMonitor.prototype._setOriginForCurrentEventQueue = function (origin) {
        var _this = this;
        this._origin = origin;
        setTimeout(function () { return _this._origin = null; }, 0);
    };
    /**
     * Checks whether the given focus event was caused by a touchstart event.
     * @param {?} event The focus event to check.
     * @return {?} Whether the event was caused by a touch.
     */
    FocusOriginMonitor.prototype._wasCausedByTouch = function (event) {
        // Note(mmalerba): This implementation is not quite perfect, there is a small edge case.
        // Consider the following dom structure:
        //
        // <div #parent tabindex="0" cdkFocusClasses>
        //   <div #child (click)="#parent.focus()"></div>
        // </div>
        //
        // If the user touches the #child element and the #parent is programmatically focused as a
        // result, this code will still consider it to have been caused by the touch event and will
        // apply the cdk-touch-focused class rather than the cdk-program-focused class. This is a
        // relatively small edge-case that can be worked around by using
        // focusVia(parentEl, renderer,  'program') to focus the parent element.
        //
        // If we decide that we absolutely must handle this case correctly, we can do so by listening
        // for the first focus event after the touchstart, and then the first blur event after that
        // focus event. When that blur event fires we know that whatever follows is not a result of the
        // touchstart.
        var /** @type {?} */ focusTarget = event.target;
        return this._lastTouchTarget instanceof Node && focusTarget instanceof Node &&
            (focusTarget === this._lastTouchTarget || focusTarget.contains(this._lastTouchTarget));
    };
    /**
     * Handles focus events on a registered element.
     * @param {?} event The focus event.
     * @param {?} element The monitored element.
     * @return {?}
     */
    FocusOriginMonitor.prototype._onFocus = function (event, element) {
        // NOTE(mmalerba): We currently set the classes based on the focus origin of the most recent
        // focus event affecting the monitored element. If we want to use the origin of the first event
        // instead we should check for the cdk-focused class here and return if the element already has
        // it. (This only matters for elements that have includesChildren = true).
        // If we are not counting child-element-focus as focused, make sure that the event target is the
        // monitored element itself.
        if (!this._elementInfo.get(element).checkChildren && element !== event.target) {
            return;
        }
        // If we couldn't detect a cause for the focus event, it's due to one of three reasons:
        // 1) The window has just regained focus, in which case we want to restore the focused state of
        //    the element from before the window blurred.
        // 2) It was caused by a touch event, in which case we mark the origin as 'touch'.
        // 3) The element was programmatically focused, in which case we should mark the origin as
        //    'program'.
        if (!this._origin) {
            if (this._windowFocused && this._lastFocusOrigin) {
                this._origin = this._lastFocusOrigin;
            }
            else if (this._wasCausedByTouch(event)) {
                this._origin = 'touch';
            }
            else {
                this._origin = 'program';
            }
        }
        this._setClasses(element, this._origin);
        this._elementInfo.get(element).subject.next(this._origin);
        this._lastFocusOrigin = this._origin;
        this._origin = null;
    };
    /**
     * Handles blur events on a registered element.
     * @param {?} event The blur event.
     * @param {?} element The monitored element.
     * @return {?}
     */
    FocusOriginMonitor.prototype._onBlur = function (event, element) {
        // If we are counting child-element-focus as focused, make sure that we aren't just blurring in
        // order to focus another child of the monitored element.
        if (this._elementInfo.get(element).checkChildren && event.relatedTarget instanceof Node &&
            element.contains(event.relatedTarget)) {
            return;
        }
        this._setClasses(element, null);
        this._elementInfo.get(element).subject.next(null);
    };
    return FocusOriginMonitor;
}());
FocusOriginMonitor.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
];
/**
 * @nocollapse
 */
FocusOriginMonitor.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgZone"], },
]; };
/**
 * Directive that determines how a particular element was focused (via keyboard, mouse, touch, or
 * programmatically) and adds corresponding classes to the element.
 *
 * There are two variants of this directive:
 * 1) cdkMonitorElementFocus: does not consider an element to be focused if one of its children is
 *    focused.
 * 2) cdkMonitorSubtreeFocus: considers an element focused if it or any of its children are focused.
 */
var CdkMonitorFocus = (function () {
    /**
     * @param {?} _elementRef
     * @param {?} _focusOriginMonitor
     * @param {?} renderer
     */
    function CdkMonitorFocus(_elementRef, _focusOriginMonitor, renderer) {
        var _this = this;
        this._elementRef = _elementRef;
        this._focusOriginMonitor = _focusOriginMonitor;
        this.cdkFocusChange = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this._focusOriginMonitor.monitor(this._elementRef.nativeElement, renderer, this._elementRef.nativeElement.hasAttribute('cdkMonitorSubtreeFocus'))
            .subscribe(function (origin) { return _this.cdkFocusChange.emit(origin); });
    }
    /**
     * @return {?}
     */
    CdkMonitorFocus.prototype.ngOnDestroy = function () {
        this._focusOriginMonitor.stopMonitoring(this._elementRef.nativeElement);
    };
    return CdkMonitorFocus;
}());
CdkMonitorFocus.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                selector: '[cdkMonitorElementFocus], [cdkMonitorSubtreeFocus]',
            },] },
];
/**
 * @nocollapse
 */
CdkMonitorFocus.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
    { type: FocusOriginMonitor, },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
]; };
CdkMonitorFocus.propDecorators = {
    'cdkFocusChange': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
};
/**
 * @param {?} parentDispatcher
 * @param {?} ngZone
 * @return {?}
 */
function FOCUS_ORIGIN_MONITOR_PROVIDER_FACTORY(parentDispatcher, ngZone) {
    return parentDispatcher || new FocusOriginMonitor(ngZone);
}
var FOCUS_ORIGIN_MONITOR_PROVIDER = {
    // If there is already a FocusOriginMonitor available, use that. Otherwise, provide a new one.
    provide: FocusOriginMonitor,
    deps: [[new __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"](), new __WEBPACK_IMPORTED_MODULE_0__angular_core__["SkipSelf"](), FocusOriginMonitor], __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgZone"]],
    useFactory: FOCUS_ORIGIN_MONITOR_PROVIDER_FACTORY
};
/**
 * Applies a CSS transform to an element, including browser-prefixed properties.
 * @param {?} element
 * @param {?} transformValue
 * @return {?}
 */
function applyCssTransform(element, transformValue) {
    // It's important to trim the result, because the browser will ignore the set operation
    // if the string contains only whitespace.
    var /** @type {?} */ value = transformValue.trim();
    element.style.transform = value;
    element.style.webkitTransform = value;
}
var StyleModule = (function () {
    function StyleModule() {
    }
    return StyleModule;
}());
StyleModule.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{
                declarations: [CdkMonitorFocus],
                exports: [CdkMonitorFocus],
                providers: [FOCUS_ORIGIN_MONITOR_PROVIDER],
            },] },
];
/**
 * @nocollapse
 */
StyleModule.ctorParameters = function () { return []; };
/**
 * \@docs-private
 */
var AnimationCurves = (function () {
    function AnimationCurves() {
    }
    return AnimationCurves;
}());
AnimationCurves.STANDARD_CURVE = 'cubic-bezier(0.4,0.0,0.2,1)';
AnimationCurves.DECELERATION_CURVE = 'cubic-bezier(0.0,0.0,0.2,1)';
AnimationCurves.ACCELERATION_CURVE = 'cubic-bezier(0.4,0.0,1,1)';
AnimationCurves.SHARP_CURVE = 'cubic-bezier(0.4,0.0,0.6,1)';
/**
 * \@docs-private
 */
var AnimationDurations = (function () {
    function AnimationDurations() {
    }
    return AnimationDurations;
}());
AnimationDurations.COMPLEX = '375ms';
AnimationDurations.ENTERING = '225ms';
AnimationDurations.EXITING = '195ms';
/**
 * Coerces a data-bound value (typically a string) to a number.
 * @param {?} value
 * @param {?=} fallbackValue
 * @return {?}
 */
function coerceNumberProperty(value, fallbackValue) {
    if (fallbackValue === void 0) { fallbackValue = 0; }
    // parseFloat(value) handles most of the cases we're interested in (it treats null, empty string,
    // and other non-number values as NaN, where Number just uses 0) but it considers the string
    // '123hello' to be a valid number. Therefore we also check if Number(value) is NaN.
    return isNaN(parseFloat(/** @type {?} */ (value))) || isNaN(Number(value)) ? fallbackValue : Number(value);
}
var MdCoreModule = (function () {
    function MdCoreModule() {
    }
    /**
     * @deprecated
     * @return {?}
     */
    MdCoreModule.forRoot = function () {
        return {
            ngModule: MdCoreModule,
            providers: [],
        };
    };
    return MdCoreModule;
}());
MdCoreModule.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{
                imports: [
                    MdLineModule,
                    RtlModule,
                    MdRippleModule,
                    ObserveContentModule,
                    PortalModule,
                    OverlayModule,
                    A11yModule,
                    MdOptionModule,
                    MdSelectionModule,
                ],
                exports: [
                    MdLineModule,
                    RtlModule,
                    MdRippleModule,
                    ObserveContentModule,
                    PortalModule,
                    OverlayModule,
                    A11yModule,
                    MdOptionModule,
                    MdSelectionModule,
                ],
            },] },
];
/**
 * @nocollapse
 */
MdCoreModule.ctorParameters = function () { return []; };
/**
 * Provider Expression that allows md-button-toggle-group to register as a ControlValueAccessor.
 * This allows it to support [(ngModel)].
 * \@docs-private
 */
var MD_BUTTON_TOGGLE_GROUP_VALUE_ACCESSOR = {
    provide: __WEBPACK_IMPORTED_MODULE_8__angular_forms__["c" /* NG_VALUE_ACCESSOR */],
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return MdButtonToggleGroup; }),
    multi: true
};
var _uniqueIdCounter$1 = 0;
/**
 * Change event object emitted by MdButtonToggle.
 */
var MdButtonToggleChange = (function () {
    function MdButtonToggleChange() {
    }
    return MdButtonToggleChange;
}());
/**
 * Exclusive selection button toggle group that behaves like a radio-button group.
 */
var MdButtonToggleGroup = (function () {
    function MdButtonToggleGroup() {
        this._value = null;
        this._name = "md-button-toggle-group-" + _uniqueIdCounter$1++;
        this._disabled = null;
        this._vertical = false;
        this._selected = null;
        this._isInitialized = false;
        this._controlValueAccessorChangeFn = function (value) { };
        /** onTouch function registered via registerOnTouch (ControlValueAccessor). */
        this.onTouched = function () { };
        /** Child button toggle buttons. */
        this._buttonToggles = null;
        this._change = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
    }
    /**
     * @return {?}
     */
    MdButtonToggleGroup.prototype.ngAfterViewInit = function () {
        this._isInitialized = true;
    };
    Object.defineProperty(MdButtonToggleGroup.prototype, "name", {
        /**
         * `name` attribute for the underlying `input` element.
         * @return {?}
         */
        get: function () {
            return this._name;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._name = value;
            this._updateButtonToggleNames();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdButtonToggleGroup.prototype, "disabled", {
        /**
         * Whether the toggle group is disabled.
         * @return {?}
         */
        get: function () {
            return this._disabled;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._disabled = coerceBooleanProperty(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdButtonToggleGroup.prototype, "vertical", {
        /**
         * Whether the toggle group is vertical.
         * @return {?}
         */
        get: function () {
            return this._vertical;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._vertical = coerceBooleanProperty(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdButtonToggleGroup.prototype, "value", {
        /**
         * Value of the toggle group.
         * @return {?}
         */
        get: function () {
            return this._value;
        },
        /**
         * @param {?} newValue
         * @return {?}
         */
        set: function (newValue) {
            if (this._value != newValue) {
                this._value = newValue;
                this._updateSelectedButtonToggleFromValue();
                // Only emit a change event if the view is completely initialized.
                // We don't want to emit a change event for the initial values.
                if (this._isInitialized) {
                    this._emitChangeEvent();
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdButtonToggleGroup.prototype, "selected", {
        /**
         * Whether the toggle group is selected.
         * @return {?}
         */
        get: function () {
            return this._selected;
        },
        /**
         * @param {?} selected
         * @return {?}
         */
        set: function (selected) {
            this._selected = selected;
            this.value = selected ? selected.value : null;
            if (selected && !selected.checked) {
                selected.checked = true;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdButtonToggleGroup.prototype, "change", {
        /**
         * Event emitted when the group's value changes.
         * @return {?}
         */
        get: function () {
            return this._change.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    MdButtonToggleGroup.prototype._updateButtonToggleNames = function () {
        var _this = this;
        if (this._buttonToggles) {
            this._buttonToggles.forEach(function (toggle) {
                toggle.name = _this._name;
            });
        }
    };
    /**
     * @return {?}
     */
    MdButtonToggleGroup.prototype._updateSelectedButtonToggleFromValue = function () {
        var _this = this;
        var /** @type {?} */ isAlreadySelected = this._selected != null && this._selected.value == this._value;
        if (this._buttonToggles != null && !isAlreadySelected) {
            var /** @type {?} */ matchingButtonToggle = this._buttonToggles.filter(function (buttonToggle) { return buttonToggle.value == _this._value; })[0];
            if (matchingButtonToggle) {
                this.selected = matchingButtonToggle;
            }
            else if (this.value == null) {
                this.selected = null;
                this._buttonToggles.forEach(function (buttonToggle) {
                    buttonToggle.checked = false;
                });
            }
        }
    };
    /**
     * Dispatch change event with current selection and group value.
     * @return {?}
     */
    MdButtonToggleGroup.prototype._emitChangeEvent = function () {
        var /** @type {?} */ event = new MdButtonToggleChange();
        event.source = this._selected;
        event.value = this._value;
        this._controlValueAccessorChangeFn(event.value);
        this._change.emit(event);
    };
    /**
     * Sets the model value. Implemented as part of ControlValueAccessor.
     * @param {?} value Value to be set to the model.
     * @return {?}
     */
    MdButtonToggleGroup.prototype.writeValue = function (value) {
        this.value = value;
    };
    /**
     * Registers a callback that will be triggered when the value has changed.
     * Implemented as part of ControlValueAccessor.
     * @param {?} fn On change callback function.
     * @return {?}
     */
    MdButtonToggleGroup.prototype.registerOnChange = function (fn) {
        this._controlValueAccessorChangeFn = fn;
    };
    /**
     * Registers a callback that will be triggered when the control has been touched.
     * Implemented as part of ControlValueAccessor.
     * @param {?} fn On touch callback function.
     * @return {?}
     */
    MdButtonToggleGroup.prototype.registerOnTouched = function (fn) {
        this.onTouched = fn;
    };
    /**
     * Toggles the disabled state of the component. Implemented as part of ControlValueAccessor.
     * @param {?} isDisabled Whether the component should be disabled.
     * @return {?}
     */
    MdButtonToggleGroup.prototype.setDisabledState = function (isDisabled) {
        this.disabled = isDisabled;
    };
    return MdButtonToggleGroup;
}());
MdButtonToggleGroup.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                selector: 'md-button-toggle-group:not([multiple]), mat-button-toggle-group:not([multiple])',
                providers: [MD_BUTTON_TOGGLE_GROUP_VALUE_ACCESSOR],
                host: {
                    '[class.mat-button-toggle-group]': 'true',
                    'role': 'radiogroup',
                    '[class.mat-button-toggle-vertical]': 'vertical'
                },
                exportAs: 'mdButtonToggleGroup',
            },] },
];
/**
 * @nocollapse
 */
MdButtonToggleGroup.ctorParameters = function () { return []; };
MdButtonToggleGroup.propDecorators = {
    '_buttonToggles': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ContentChildren"], args: [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return MdButtonToggle; }),] },],
    'name': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'disabled': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'vertical': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'value': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'selected': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'change': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
};
/**
 * Multiple selection button-toggle group. `ngModel` is not supported in this mode.
 */
var MdButtonToggleGroupMultiple = (function () {
    function MdButtonToggleGroupMultiple() {
        this._disabled = null;
        this._vertical = false;
    }
    Object.defineProperty(MdButtonToggleGroupMultiple.prototype, "disabled", {
        /**
         * Whether the toggle group is disabled.
         * @return {?}
         */
        get: function () {
            return this._disabled;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._disabled = (value != null && value !== false) ? true : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdButtonToggleGroupMultiple.prototype, "vertical", {
        /**
         * Whether the toggle group is vertical.
         * @return {?}
         */
        get: function () {
            return this._vertical;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._vertical = coerceBooleanProperty(value);
        },
        enumerable: true,
        configurable: true
    });
    return MdButtonToggleGroupMultiple;
}());
MdButtonToggleGroupMultiple.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                selector: 'md-button-toggle-group[multiple], mat-button-toggle-group[multiple]',
                exportAs: 'mdButtonToggleGroup',
                host: {
                    '[class.mat-button-toggle-group]': 'true',
                    '[class.mat-button-toggle-vertical]': 'vertical'
                }
            },] },
];
/**
 * @nocollapse
 */
MdButtonToggleGroupMultiple.ctorParameters = function () { return []; };
MdButtonToggleGroupMultiple.propDecorators = {
    'disabled': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'vertical': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
};
/**
 * Single button inside of a toggle group.
 */
var MdButtonToggle = (function () {
    /**
     * @param {?} toggleGroup
     * @param {?} toggleGroupMultiple
     * @param {?} _buttonToggleDispatcher
     * @param {?} _renderer
     * @param {?} _elementRef
     * @param {?} _focusOriginMonitor
     */
    function MdButtonToggle(toggleGroup, toggleGroupMultiple, _buttonToggleDispatcher, _renderer, _elementRef, _focusOriginMonitor) {
        var _this = this;
        this._buttonToggleDispatcher = _buttonToggleDispatcher;
        this._renderer = _renderer;
        this._elementRef = _elementRef;
        this._focusOriginMonitor = _focusOriginMonitor;
        this._checked = false;
        this._disabled = null;
        this._value = null;
        this._isSingleSelector = null;
        this._change = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this.buttonToggleGroup = toggleGroup;
        this.buttonToggleGroupMultiple = toggleGroupMultiple;
        if (this.buttonToggleGroup) {
            _buttonToggleDispatcher.listen(function (id, name) {
                if (id != _this.id && name == _this.name) {
                    _this.checked = false;
                }
            });
            this._type = 'radio';
            this.name = this.buttonToggleGroup.name;
            this._isSingleSelector = true;
        }
        else {
            // Even if there is no group at all, treat the button toggle as a checkbox so it can be
            // toggled on or off.
            this._type = 'checkbox';
            this._isSingleSelector = false;
        }
    }
    Object.defineProperty(MdButtonToggle.prototype, "inputId", {
        /**
         * Unique ID for the underlying `input` element.
         * @return {?}
         */
        get: function () {
            return this.id + "-input";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdButtonToggle.prototype, "checked", {
        /**
         * Whether the button is checked.
         * @return {?}
         */
        get: function () {
            return this._checked;
        },
        /**
         * @param {?} newCheckedState
         * @return {?}
         */
        set: function (newCheckedState) {
            if (this._isSingleSelector) {
                if (newCheckedState) {
                    // Notify all button toggles with the same name (in the same group) to un-check.
                    this._buttonToggleDispatcher.notify(this.id, this.name);
                }
            }
            this._checked = newCheckedState;
            if (newCheckedState && this._isSingleSelector && this.buttonToggleGroup.value != this.value) {
                this.buttonToggleGroup.selected = this;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdButtonToggle.prototype, "value", {
        /**
         * MdButtonToggleGroup reads this to assign its own value.
         * @return {?}
         */
        get: function () {
            return this._value;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            if (this._value != value) {
                if (this.buttonToggleGroup != null && this.checked) {
                    this.buttonToggleGroup.value = value;
                }
                this._value = value;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdButtonToggle.prototype, "disabled", {
        /**
         * Whether the button is disabled.
         * @return {?}
         */
        get: function () {
            return this._disabled || (this.buttonToggleGroup != null && this.buttonToggleGroup.disabled) ||
                (this.buttonToggleGroupMultiple != null && this.buttonToggleGroupMultiple.disabled);
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._disabled = (value != null && value !== false) ? true : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdButtonToggle.prototype, "change", {
        /**
         * @return {?}
         */
        get: function () {
            return this._change.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    MdButtonToggle.prototype.ngOnInit = function () {
        if (this.id == null) {
            this.id = "md-button-toggle-" + _uniqueIdCounter$1++;
        }
        if (this.buttonToggleGroup && this._value == this.buttonToggleGroup.value) {
            this._checked = true;
        }
        this._focusOriginMonitor.monitor(this._elementRef.nativeElement, this._renderer, true);
    };
    /**
     * Focuses the button.
     * @return {?}
     */
    MdButtonToggle.prototype.focus = function () {
        this._renderer.invokeElementMethod(this._inputElement.nativeElement, 'focus');
    };
    /**
     * Toggle the state of the current button toggle.
     * @return {?}
     */
    MdButtonToggle.prototype._toggle = function () {
        this.checked = !this.checked;
    };
    /**
     * Checks the button toggle due to an interaction with the underlying native input.
     * @param {?} event
     * @return {?}
     */
    MdButtonToggle.prototype._onInputChange = function (event) {
        event.stopPropagation();
        if (this._isSingleSelector) {
            // Propagate the change one-way via the group, which will in turn mark this
            // button toggle as checked.
            this.checked = true;
            this.buttonToggleGroup.selected = this;
            this.buttonToggleGroup.onTouched();
        }
        else {
            this._toggle();
        }
        // Emit a change event when the native input does.
        this._emitChangeEvent();
    };
    /**
     * @param {?} event
     * @return {?}
     */
    MdButtonToggle.prototype._onInputClick = function (event) {
        // We have to stop propagation for click events on the visual hidden input element.
        // By default, when a user clicks on a label element, a generated click event will be
        // dispatched on the associated input element. Since we are using a label element as our
        // root container, the click event on the `slide-toggle` will be executed twice.
        // The real click event will bubble up, and the generated click event also tries to bubble up.
        // This will lead to multiple click events.
        // Preventing bubbling for the second event will solve that issue.
        event.stopPropagation();
    };
    /**
     * Dispatch change event with current value.
     * @return {?}
     */
    MdButtonToggle.prototype._emitChangeEvent = function () {
        var /** @type {?} */ event = new MdButtonToggleChange();
        event.source = this;
        event.value = this._value;
        this._change.emit(event);
    };
    return MdButtonToggle;
}());
MdButtonToggle.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{ selector: 'md-button-toggle, mat-button-toggle',
                template: "<label [attr.for]=\"inputId\" class=\"mat-button-toggle-label\"> <input #input class=\"mat-button-toggle-input cdk-visually-hidden\" [type]=\"_type\" [id]=\"inputId\" [checked]=\"checked\" [disabled]=\"disabled\" [name]=\"name\" (change)=\"_onInputChange($event)\" (click)=\"_onInputClick($event)\"> <div class=\"mat-button-toggle-label-content\"> <ng-content></ng-content> </div> </label> <!-- the touchstart handler prevents the overlay from capturing the initial tap on touch devices --> <div class=\"mat-button-toggle-focus-overlay\" (touchstart)=\"$event.preventDefault()\"></div> ",
                styles: [".mat-button-toggle-group{box-shadow:0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12);position:relative;display:inline-flex;flex-direction:row;border-radius:2px;cursor:pointer;white-space:nowrap}.mat-button-toggle-vertical{flex-direction:column}.mat-button-toggle-vertical .mat-button-toggle-label-content{display:block}.mat-button-toggle-disabled .mat-button-toggle-label-content{cursor:default}.mat-button-toggle{white-space:nowrap;font-family:Roboto,\"Helvetica Neue\",sans-serif;position:relative}.mat-button-toggle.cdk-keyboard-focused .mat-button-toggle-focus-overlay{opacity:1}.mat-button-toggle-label-content{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;display:inline-block;line-height:36px;padding:0 16px;cursor:pointer}.mat-button-toggle-label-content>*{vertical-align:middle}.mat-button-toggle-focus-overlay{border-radius:inherit;pointer-events:none;opacity:0;position:absolute;top:0;left:0;right:0;bottom:0} /*# sourceMappingURL=button-toggle.css.map */ "],
                encapsulation: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewEncapsulation"].None,
                host: {
                    '[class.mat-button-toggle]': 'true'
                }
            },] },
];
/**
 * @nocollapse
 */
MdButtonToggle.ctorParameters = function () { return [
    { type: MdButtonToggleGroup, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] },] },
    { type: MdButtonToggleGroupMultiple, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] },] },
    { type: UniqueSelectionDispatcher, },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
    { type: FocusOriginMonitor, },
]; };
MdButtonToggle.propDecorators = {
    '_inputElement': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewChild"], args: ['input',] },],
    'id': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["HostBinding"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'name': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'checked': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["HostBinding"], args: ['class.mat-button-toggle-checked',] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'value': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'disabled': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["HostBinding"], args: ['class.mat-button-toggle-disabled',] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'change': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
};
var MdButtonToggleModule = (function () {
    function MdButtonToggleModule() {
    }
    /**
     * @deprecated
     * @return {?}
     */
    MdButtonToggleModule.forRoot = function () {
        return {
            ngModule: MdButtonToggleModule,
            providers: []
        };
    };
    return MdButtonToggleModule;
}());
MdButtonToggleModule.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{
                imports: [__WEBPACK_IMPORTED_MODULE_8__angular_forms__["d" /* FormsModule */], CompatibilityModule],
                exports: [
                    MdButtonToggleGroup,
                    MdButtonToggleGroupMultiple,
                    MdButtonToggle,
                    CompatibilityModule,
                ],
                declarations: [MdButtonToggleGroup, MdButtonToggleGroupMultiple, MdButtonToggle],
                providers: [UNIQUE_SELECTION_DISPATCHER_PROVIDER, FocusOriginMonitor]
            },] },
];
/**
 * @nocollapse
 */
MdButtonToggleModule.ctorParameters = function () { return []; };
/**
 * Directive whose purpose is to add the mat- CSS styling to this selector.
 * \@docs-private
 */
var MdButtonCssMatStyler = (function () {
    function MdButtonCssMatStyler() {
    }
    return MdButtonCssMatStyler;
}());
MdButtonCssMatStyler.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                selector: 'button[md-button], button[mat-button], a[md-button], a[mat-button]',
                host: {
                    '[class.mat-button]': 'true'
                }
            },] },
];
/**
 * @nocollapse
 */
MdButtonCssMatStyler.ctorParameters = function () { return []; };
/**
 * Directive whose purpose is to add the mat- CSS styling to this selector.
 * \@docs-private
 */
var MdRaisedButtonCssMatStyler = (function () {
    function MdRaisedButtonCssMatStyler() {
    }
    return MdRaisedButtonCssMatStyler;
}());
MdRaisedButtonCssMatStyler.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                selector: 'button[md-raised-button], button[mat-raised-button], ' +
                    'a[md-raised-button], a[mat-raised-button]',
                host: {
                    '[class.mat-raised-button]': 'true'
                }
            },] },
];
/**
 * @nocollapse
 */
MdRaisedButtonCssMatStyler.ctorParameters = function () { return []; };
/**
 * Directive whose purpose is to add the mat- CSS styling to this selector.
 * \@docs-private
 */
var MdIconButtonCssMatStyler = (function () {
    function MdIconButtonCssMatStyler() {
    }
    return MdIconButtonCssMatStyler;
}());
MdIconButtonCssMatStyler.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                selector: 'button[md-icon-button], button[mat-icon-button], a[md-icon-button], a[mat-icon-button]',
                host: {
                    '[class.mat-icon-button]': 'true',
                }
            },] },
];
/**
 * @nocollapse
 */
MdIconButtonCssMatStyler.ctorParameters = function () { return []; };
/**
 * Directive whose purpose is to add the mat- CSS styling to this selector.
 * \@docs-private
 */
var MdFabCssMatStyler = (function () {
    function MdFabCssMatStyler() {
    }
    return MdFabCssMatStyler;
}());
MdFabCssMatStyler.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                selector: 'button[md-fab], button[mat-fab], a[md-fab], a[mat-fab]',
                host: {
                    '[class.mat-fab]': 'true'
                }
            },] },
];
/**
 * @nocollapse
 */
MdFabCssMatStyler.ctorParameters = function () { return []; };
/**
 * Directive whose purpose is to add the mat- CSS styling to this selector.
 * \@docs-private
 */
var MdMiniFabCssMatStyler = (function () {
    function MdMiniFabCssMatStyler() {
    }
    return MdMiniFabCssMatStyler;
}());
MdMiniFabCssMatStyler.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                selector: 'button[md-mini-fab], button[mat-mini-fab], a[md-mini-fab], a[mat-mini-fab]',
                host: {
                    '[class.mat-mini-fab]': 'true'
                }
            },] },
];
/**
 * @nocollapse
 */
MdMiniFabCssMatStyler.ctorParameters = function () { return []; };
/**
 * Material design button.
 */
var MdButton = (function () {
    /**
     * @param {?} _elementRef
     * @param {?} _renderer
     * @param {?} _focusOriginMonitor
     */
    function MdButton(_elementRef, _renderer, _focusOriginMonitor) {
        this._elementRef = _elementRef;
        this._renderer = _renderer;
        this._focusOriginMonitor = _focusOriginMonitor;
        /** Whether the button is round. */
        this._isRoundButton = this._hasAttributeWithPrefix('fab', 'mini-fab');
        /** Whether the button is icon button. */
        this._isIconButton = this._hasAttributeWithPrefix('icon-button');
        this._disableRipple = false;
        this._disabled = null;
        this._focusOriginMonitor.monitor(this._elementRef.nativeElement, this._renderer, true);
    }
    Object.defineProperty(MdButton.prototype, "disableRipple", {
        /**
         * Whether the ripple effect for this button is disabled.
         * @return {?}
         */
        get: function () { return this._disableRipple; },
        /**
         * @param {?} v
         * @return {?}
         */
        set: function (v) { this._disableRipple = coerceBooleanProperty(v); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdButton.prototype, "disabled", {
        /**
         * Whether the button is disabled.
         * @return {?}
         */
        get: function () { return this._disabled; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this._disabled = coerceBooleanProperty(value) ? true : null; },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    MdButton.prototype.ngOnDestroy = function () {
        this._focusOriginMonitor.stopMonitoring(this._elementRef.nativeElement);
    };
    Object.defineProperty(MdButton.prototype, "color", {
        /**
         * The color of the button. Can be `primary`, `accent`, or `warn`.
         * @return {?}
         */
        get: function () { return this._color; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this._updateColor(value); },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} newColor
     * @return {?}
     */
    MdButton.prototype._updateColor = function (newColor) {
        this._setElementColor(this._color, false);
        this._setElementColor(newColor, true);
        this._color = newColor;
    };
    /**
     * @param {?} color
     * @param {?} isAdd
     * @return {?}
     */
    MdButton.prototype._setElementColor = function (color, isAdd) {
        if (color != null && color != '') {
            this._renderer.setElementClass(this._getHostElement(), "mat-" + color, isAdd);
        }
    };
    /**
     * Focuses the button.
     * @return {?}
     */
    MdButton.prototype.focus = function () {
        this._renderer.invokeElementMethod(this._getHostElement(), 'focus');
    };
    /**
     * @return {?}
     */
    MdButton.prototype._getHostElement = function () {
        return this._elementRef.nativeElement;
    };
    /**
     * @return {?}
     */
    MdButton.prototype._isRippleDisabled = function () {
        return this.disableRipple || this.disabled;
    };
    /**
     * Gets whether the button has one of the given attributes
     * with either an 'md-' or 'mat-' prefix.
     * @param {...?} unprefixedAttributeNames
     * @return {?}
     */
    MdButton.prototype._hasAttributeWithPrefix = function () {
        var _this = this;
        var unprefixedAttributeNames = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            unprefixedAttributeNames[_i] = arguments[_i];
        }
        return unprefixedAttributeNames.some(function (suffix) {
            var /** @type {?} */ el = _this._getHostElement();
            return el.hasAttribute('md-' + suffix) || el.hasAttribute('mat-' + suffix);
        });
    };
    return MdButton;
}());
MdButton.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{ selector: 'button[md-button], button[md-raised-button], button[md-icon-button],' +
                    'button[md-fab], button[md-mini-fab],' +
                    'button[mat-button], button[mat-raised-button], button[mat-icon-button],' +
                    'button[mat-fab], button[mat-mini-fab]',
                host: {
                    '[disabled]': 'disabled',
                },
                template: "<span class=\"mat-button-wrapper\"><ng-content></ng-content></span> <div md-ripple *ngIf=\"!_isRippleDisabled()\" class=\"mat-button-ripple\" [class.mat-button-ripple-round]=\"_isRoundButton || _isIconButton\" [mdRippleCentered]=\"_isIconButton\" [mdRippleTrigger]=\"_getHostElement()\"></div> <!-- the touchstart handler prevents the overlay from capturing the initial tap on touch devices --> <div class=\"mat-button-focus-overlay\" (touchstart)=\"$event.preventDefault()\"></div> ",
                styles: [".mat-button,.mat-fab,.mat-icon-button,.mat-mini-fab,.mat-raised-button{box-sizing:border-box;position:relative;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:pointer;outline:0;border:none;display:inline-block;white-space:nowrap;text-decoration:none;vertical-align:baseline;font-size:14px;font-family:Roboto,\"Helvetica Neue\",sans-serif;font-weight:500;text-align:center;margin:0;min-width:88px;line-height:36px;padding:0 16px;border-radius:2px}[disabled].mat-button,[disabled].mat-fab,[disabled].mat-icon-button,[disabled].mat-mini-fab,[disabled].mat-raised-button{cursor:default}.cdk-keyboard-focused.mat-button .mat-button-focus-overlay,.cdk-keyboard-focused.mat-fab .mat-button-focus-overlay,.cdk-keyboard-focused.mat-icon-button .mat-button-focus-overlay,.cdk-keyboard-focused.mat-mini-fab .mat-button-focus-overlay,.cdk-keyboard-focused.mat-raised-button .mat-button-focus-overlay{opacity:1}.mat-button::-moz-focus-inner,.mat-fab::-moz-focus-inner,.mat-icon-button::-moz-focus-inner,.mat-mini-fab::-moz-focus-inner,.mat-raised-button::-moz-focus-inner{border:0}.mat-fab,.mat-mini-fab,.mat-raised-button{box-shadow:0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12);transform:translate3d(0,0,0);transition:background .4s cubic-bezier(.25,.8,.25,1),box-shadow 280ms cubic-bezier(.4,0,.2,1)}.mat-fab:not([disabled]):active,.mat-mini-fab:not([disabled]):active,.mat-raised-button:not([disabled]):active{box-shadow:0 5px 5px -3px rgba(0,0,0,.2),0 8px 10px 1px rgba(0,0,0,.14),0 3px 14px 2px rgba(0,0,0,.12)}[disabled].mat-fab,[disabled].mat-mini-fab,[disabled].mat-raised-button{box-shadow:none}.mat-button .mat-button-focus-overlay,.mat-icon-button .mat-button-focus-overlay{transition:none;opacity:0}.mat-button:hover .mat-button-focus-overlay{opacity:1}.mat-fab{box-shadow:0 3px 5px -1px rgba(0,0,0,.2),0 6px 10px 0 rgba(0,0,0,.14),0 1px 18px 0 rgba(0,0,0,.12);min-width:0;border-radius:50%;width:56px;height:56px;padding:0;flex-shrink:0}.mat-fab:not([disabled]):active{box-shadow:0 7px 8px -4px rgba(0,0,0,.2),0 12px 17px 2px rgba(0,0,0,.14),0 5px 22px 4px rgba(0,0,0,.12)}.mat-fab .mat-icon,.mat-fab i{padding:16px 0;line-height:24px}.mat-mini-fab{box-shadow:0 3px 5px -1px rgba(0,0,0,.2),0 6px 10px 0 rgba(0,0,0,.14),0 1px 18px 0 rgba(0,0,0,.12);min-width:0;border-radius:50%;width:40px;height:40px;padding:0;flex-shrink:0}.mat-mini-fab:not([disabled]):active{box-shadow:0 7px 8px -4px rgba(0,0,0,.2),0 12px 17px 2px rgba(0,0,0,.14),0 5px 22px 4px rgba(0,0,0,.12)}.mat-mini-fab .mat-icon,.mat-mini-fab i{padding:8px 0;line-height:24px}.mat-icon-button{padding:0;min-width:0;width:40px;height:40px;flex-shrink:0;line-height:40px;border-radius:50%}.mat-icon-button .mat-icon,.mat-icon-button i{line-height:24px}.mat-button,.mat-icon-button,.mat-raised-button{color:currentColor}.mat-button .mat-button-wrapper>*,.mat-icon-button .mat-button-wrapper>*,.mat-raised-button .mat-button-wrapper>*{vertical-align:middle}.mat-button-focus-overlay,.mat-button-ripple{position:absolute;top:0;left:0;bottom:0;right:0}.mat-button-focus-overlay{background-color:rgba(0,0,0,.12);border-radius:inherit;pointer-events:none;opacity:0;transition:opacity .2s cubic-bezier(.35,0,.25,1),background-color .2s cubic-bezier(.35,0,.25,1)}@media screen and (-ms-high-contrast:active){.mat-button-focus-overlay{background-color:rgba(255,255,255,.5)}}.mat-button-ripple-round{border-radius:50%;z-index:1}@media screen and (-ms-high-contrast:active){.mat-button,.mat-fab,.mat-icon-button,.mat-mini-fab,.mat-raised-button{outline:solid 1px}} /*# sourceMappingURL=button.css.map */ "],
                encapsulation: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewEncapsulation"].None,
                changeDetection: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectionStrategy"].OnPush,
            },] },
];
/**
 * @nocollapse
 */
MdButton.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
    { type: FocusOriginMonitor, },
]; };
MdButton.propDecorators = {
    'disableRipple': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'disabled': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'color': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
};
/**
 * Raised Material design button.
 */
var MdAnchor = (function (_super) {
    __extends(MdAnchor, _super);
    /**
     * @param {?} elementRef
     * @param {?} renderer
     * @param {?} focusOriginMonitor
     */
    function MdAnchor(elementRef, renderer, focusOriginMonitor) {
        return _super.call(this, elementRef, renderer, focusOriginMonitor) || this;
    }
    Object.defineProperty(MdAnchor.prototype, "tabIndex", {
        /**
         * \@docs-private
         * @return {?}
         */
        get: function () {
            return this.disabled ? -1 : 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdAnchor.prototype, "_isAriaDisabled", {
        /**
         * @return {?}
         */
        get: function () {
            return this.disabled ? 'true' : 'false';
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} event
     * @return {?}
     */
    MdAnchor.prototype._haltDisabledEvents = function (event) {
        // A disabled button shouldn't apply any actions
        if (this.disabled) {
            event.preventDefault();
            event.stopImmediatePropagation();
        }
    };
    return MdAnchor;
}(MdButton));
MdAnchor.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{ selector: "a[md-button], a[md-raised-button], a[md-icon-button], a[md-fab], a[md-mini-fab],\n             a[mat-button], a[mat-raised-button], a[mat-icon-button], a[mat-fab], a[mat-mini-fab]",
                host: {
                    '[attr.disabled]': 'disabled',
                    '[attr.aria-disabled]': '_isAriaDisabled',
                    '(click)': '_haltDisabledEvents($event)',
                },
                template: "<span class=\"mat-button-wrapper\"><ng-content></ng-content></span> <div md-ripple *ngIf=\"!_isRippleDisabled()\" class=\"mat-button-ripple\" [class.mat-button-ripple-round]=\"_isRoundButton || _isIconButton\" [mdRippleCentered]=\"_isIconButton\" [mdRippleTrigger]=\"_getHostElement()\"></div> <!-- the touchstart handler prevents the overlay from capturing the initial tap on touch devices --> <div class=\"mat-button-focus-overlay\" (touchstart)=\"$event.preventDefault()\"></div> ",
                styles: [".mat-button,.mat-fab,.mat-icon-button,.mat-mini-fab,.mat-raised-button{box-sizing:border-box;position:relative;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:pointer;outline:0;border:none;display:inline-block;white-space:nowrap;text-decoration:none;vertical-align:baseline;font-size:14px;font-family:Roboto,\"Helvetica Neue\",sans-serif;font-weight:500;text-align:center;margin:0;min-width:88px;line-height:36px;padding:0 16px;border-radius:2px}[disabled].mat-button,[disabled].mat-fab,[disabled].mat-icon-button,[disabled].mat-mini-fab,[disabled].mat-raised-button{cursor:default}.cdk-keyboard-focused.mat-button .mat-button-focus-overlay,.cdk-keyboard-focused.mat-fab .mat-button-focus-overlay,.cdk-keyboard-focused.mat-icon-button .mat-button-focus-overlay,.cdk-keyboard-focused.mat-mini-fab .mat-button-focus-overlay,.cdk-keyboard-focused.mat-raised-button .mat-button-focus-overlay{opacity:1}.mat-button::-moz-focus-inner,.mat-fab::-moz-focus-inner,.mat-icon-button::-moz-focus-inner,.mat-mini-fab::-moz-focus-inner,.mat-raised-button::-moz-focus-inner{border:0}.mat-fab,.mat-mini-fab,.mat-raised-button{box-shadow:0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12);transform:translate3d(0,0,0);transition:background .4s cubic-bezier(.25,.8,.25,1),box-shadow 280ms cubic-bezier(.4,0,.2,1)}.mat-fab:not([disabled]):active,.mat-mini-fab:not([disabled]):active,.mat-raised-button:not([disabled]):active{box-shadow:0 5px 5px -3px rgba(0,0,0,.2),0 8px 10px 1px rgba(0,0,0,.14),0 3px 14px 2px rgba(0,0,0,.12)}[disabled].mat-fab,[disabled].mat-mini-fab,[disabled].mat-raised-button{box-shadow:none}.mat-button .mat-button-focus-overlay,.mat-icon-button .mat-button-focus-overlay{transition:none;opacity:0}.mat-button:hover .mat-button-focus-overlay{opacity:1}.mat-fab{box-shadow:0 3px 5px -1px rgba(0,0,0,.2),0 6px 10px 0 rgba(0,0,0,.14),0 1px 18px 0 rgba(0,0,0,.12);min-width:0;border-radius:50%;width:56px;height:56px;padding:0;flex-shrink:0}.mat-fab:not([disabled]):active{box-shadow:0 7px 8px -4px rgba(0,0,0,.2),0 12px 17px 2px rgba(0,0,0,.14),0 5px 22px 4px rgba(0,0,0,.12)}.mat-fab .mat-icon,.mat-fab i{padding:16px 0;line-height:24px}.mat-mini-fab{box-shadow:0 3px 5px -1px rgba(0,0,0,.2),0 6px 10px 0 rgba(0,0,0,.14),0 1px 18px 0 rgba(0,0,0,.12);min-width:0;border-radius:50%;width:40px;height:40px;padding:0;flex-shrink:0}.mat-mini-fab:not([disabled]):active{box-shadow:0 7px 8px -4px rgba(0,0,0,.2),0 12px 17px 2px rgba(0,0,0,.14),0 5px 22px 4px rgba(0,0,0,.12)}.mat-mini-fab .mat-icon,.mat-mini-fab i{padding:8px 0;line-height:24px}.mat-icon-button{padding:0;min-width:0;width:40px;height:40px;flex-shrink:0;line-height:40px;border-radius:50%}.mat-icon-button .mat-icon,.mat-icon-button i{line-height:24px}.mat-button,.mat-icon-button,.mat-raised-button{color:currentColor}.mat-button .mat-button-wrapper>*,.mat-icon-button .mat-button-wrapper>*,.mat-raised-button .mat-button-wrapper>*{vertical-align:middle}.mat-button-focus-overlay,.mat-button-ripple{position:absolute;top:0;left:0;bottom:0;right:0}.mat-button-focus-overlay{background-color:rgba(0,0,0,.12);border-radius:inherit;pointer-events:none;opacity:0;transition:opacity .2s cubic-bezier(.35,0,.25,1),background-color .2s cubic-bezier(.35,0,.25,1)}@media screen and (-ms-high-contrast:active){.mat-button-focus-overlay{background-color:rgba(255,255,255,.5)}}.mat-button-ripple-round{border-radius:50%;z-index:1}@media screen and (-ms-high-contrast:active){.mat-button,.mat-fab,.mat-icon-button,.mat-mini-fab,.mat-raised-button{outline:solid 1px}} /*# sourceMappingURL=button.css.map */ "],
                encapsulation: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewEncapsulation"].None
            },] },
];
/**
 * @nocollapse
 */
MdAnchor.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
    { type: FocusOriginMonitor, },
]; };
MdAnchor.propDecorators = {
    'tabIndex': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["HostBinding"], args: ['tabIndex',] },],
};
var MdButtonModule = (function () {
    function MdButtonModule() {
    }
    /**
     * @deprecated
     * @return {?}
     */
    MdButtonModule.forRoot = function () {
        return {
            ngModule: MdButtonModule,
            providers: []
        };
    };
    return MdButtonModule;
}());
MdButtonModule.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{
                imports: [
                    __WEBPACK_IMPORTED_MODULE_2__angular_common__["CommonModule"],
                    MdRippleModule,
                    CompatibilityModule,
                    StyleModule,
                ],
                exports: [
                    MdButton,
                    MdAnchor,
                    CompatibilityModule,
                    MdButtonCssMatStyler,
                    MdRaisedButtonCssMatStyler,
                    MdIconButtonCssMatStyler,
                    MdFabCssMatStyler,
                    MdMiniFabCssMatStyler,
                ],
                declarations: [
                    MdButton,
                    MdAnchor,
                    MdButtonCssMatStyler,
                    MdRaisedButtonCssMatStyler,
                    MdIconButtonCssMatStyler,
                    MdFabCssMatStyler,
                    MdMiniFabCssMatStyler,
                ],
            },] },
];
/**
 * @nocollapse
 */
MdButtonModule.ctorParameters = function () { return []; };
/** Monotonically increasing integer used to auto-generate unique ids for checkbox components. */
var nextId = 0;
/**
 * Provider Expression that allows md-checkbox to register as a ControlValueAccessor.
 * This allows it to support [(ngModel)].
 * \@docs-private
 */
var MD_CHECKBOX_CONTROL_VALUE_ACCESSOR = {
    provide: __WEBPACK_IMPORTED_MODULE_8__angular_forms__["c" /* NG_VALUE_ACCESSOR */],
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return MdCheckbox; }),
    multi: true
};
var TransitionCheckState = {};
TransitionCheckState.Init = 0;
TransitionCheckState.Checked = 1;
TransitionCheckState.Unchecked = 2;
TransitionCheckState.Indeterminate = 3;
TransitionCheckState[TransitionCheckState.Init] = "Init";
TransitionCheckState[TransitionCheckState.Checked] = "Checked";
TransitionCheckState[TransitionCheckState.Unchecked] = "Unchecked";
TransitionCheckState[TransitionCheckState.Indeterminate] = "Indeterminate";
/**
 * Change event object emitted by MdCheckbox.
 */
var MdCheckboxChange = (function () {
    function MdCheckboxChange() {
    }
    return MdCheckboxChange;
}());
/**
 * A material design checkbox component. Supports all of the functionality of an HTML5 checkbox,
 * and exposes a similar API. A MdCheckbox can be either checked, unchecked, indeterminate, or
 * disabled. Note that all additional accessibility attributes are taken care of by the component,
 * so there is no need to provide them yourself. However, if you want to omit a label and still
 * have the checkbox be accessible, you may supply an [aria-label] input.
 * See: https://www.google.com/design/spec/components/selection-controls.html
 */
var MdCheckbox = (function () {
    /**
     * @param {?} _renderer
     * @param {?} _elementRef
     * @param {?} _changeDetectorRef
     * @param {?} _focusOriginMonitor
     */
    function MdCheckbox(_renderer, _elementRef, _changeDetectorRef, _focusOriginMonitor) {
        this._renderer = _renderer;
        this._elementRef = _elementRef;
        this._changeDetectorRef = _changeDetectorRef;
        this._focusOriginMonitor = _focusOriginMonitor;
        /**
         * Attached to the aria-label attribute of the host element. In most cases, arial-labelledby will
         * take precedence so this may be omitted.
         */
        this.ariaLabel = '';
        /**
         * Users can specify the `aria-labelledby` attribute which will be forwarded to the input element
         */
        this.ariaLabelledby = null;
        /** A unique id for the checkbox. If one is not supplied, it is auto-generated. */
        this.id = "md-checkbox-" + ++nextId;
        /** Whether the label should appear after or before the checkbox. Defaults to 'after' */
        this.labelPosition = 'after';
        this._disabled = false;
        /** Tabindex value that is passed to the underlying input element. */
        this.tabIndex = 0;
        /** Name value will be applied to the input element if present */
        this.name = null;
        /** Event emitted when the checkbox's `checked` value changes. */
        this.change = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /** Event emitted when the checkbox's `indeterminate` value changes. */
        this.indeterminateChange = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /**
         * Called when the checkbox is blurred. Needed to properly implement ControlValueAccessor.
         * \@docs-private
         */
        this.onTouched = function () { };
        this._currentAnimationClass = '';
        this._currentCheckState = TransitionCheckState.Init;
        this._checked = false;
        this._indeterminate = false;
        this._controlValueAccessorChangeFn = function (value) { };
        this.color = 'accent';
    }
    Object.defineProperty(MdCheckbox.prototype, "disableRipple", {
        /**
         * Whether the ripple effect for this checkbox is disabled.
         * @return {?}
         */
        get: function () { return this._disableRipple; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this._disableRipple = coerceBooleanProperty(value); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdCheckbox.prototype, "inputId", {
        /**
         * ID of the native input element inside `<md-checkbox>`
         * @return {?}
         */
        get: function () {
            return "input-" + this.id;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdCheckbox.prototype, "required", {
        /**
         * Whether the checkbox is required.
         * @return {?}
         */
        get: function () { return this._required; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this._required = coerceBooleanProperty(value); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdCheckbox.prototype, "align", {
        /**
         * Whether or not the checkbox should appear before or after the label.
         * @deprecated
         * @return {?}
         */
        get: function () {
            // align refers to the checkbox relative to the label, while labelPosition refers to the
            // label relative to the checkbox. As such, they are inverted.
            return this.labelPosition == 'after' ? 'start' : 'end';
        },
        /**
         * @param {?} v
         * @return {?}
         */
        set: function (v) {
            this.labelPosition = (v == 'start') ? 'after' : 'before';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdCheckbox.prototype, "disabled", {
        /**
         * Whether the checkbox is disabled.
         * @return {?}
         */
        get: function () { return this._disabled; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this._disabled = coerceBooleanProperty(value); },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    MdCheckbox.prototype.ngAfterViewInit = function () {
        var _this = this;
        this._focusedSubscription = this._focusOriginMonitor
            .monitor(this._inputElement.nativeElement, this._renderer, false)
            .subscribe(function (focusOrigin) {
            if (!_this._focusedRipple && (focusOrigin === 'keyboard' || focusOrigin === 'program')) {
                _this._focusedRipple = _this._ripple.launch(0, 0, { persistent: true, centered: true });
            }
        });
    };
    /**
     * @return {?}
     */
    MdCheckbox.prototype.ngOnDestroy = function () {
        this._focusOriginMonitor.stopMonitoring(this._inputElement.nativeElement);
    };
    Object.defineProperty(MdCheckbox.prototype, "checked", {
        /**
         * Whether the checkbox is checked. Note that setting `checked` will immediately set
         * `indeterminate` to false.
         * @return {?}
         */
        get: function () {
            return this._checked;
        },
        /**
         * @param {?} checked
         * @return {?}
         */
        set: function (checked) {
            var _this = this;
            if (checked != this.checked) {
                if (this._indeterminate) {
                    Promise.resolve().then(function () {
                        _this._indeterminate = false;
                        _this.indeterminateChange.emit(_this._indeterminate);
                    });
                }
                this._checked = checked;
                this._changeDetectorRef.markForCheck();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdCheckbox.prototype, "indeterminate", {
        /**
         * Whether the checkbox is indeterminate. This is also known as "mixed" mode and can be used to
         * represent a checkbox with three states, e.g. a checkbox that represents a nested list of
         * checkable items. Note that whenever `checked` is set, indeterminate is immediately set to
         * false. This differs from the web platform in that indeterminate state on native
         * checkboxes is only remove when the user manually checks the checkbox (rather than setting the
         * `checked` property programmatically). However, we feel that this behavior is more accommodating
         * to the way consumers would envision using this component.
         * @return {?}
         */
        get: function () {
            return this._indeterminate;
        },
        /**
         * @param {?} indeterminate
         * @return {?}
         */
        set: function (indeterminate) {
            var /** @type {?} */ changed = indeterminate != this._indeterminate;
            this._indeterminate = indeterminate;
            if (changed) {
                if (this._indeterminate) {
                    this._transitionCheckState(TransitionCheckState.Indeterminate);
                }
                else {
                    this._transitionCheckState(this.checked ? TransitionCheckState.Checked : TransitionCheckState.Unchecked);
                }
                this.indeterminateChange.emit(this._indeterminate);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdCheckbox.prototype, "color", {
        /**
         * The color of the button. Can be `primary`, `accent`, or `warn`.
         * @return {?}
         */
        get: function () { return this._color; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this._updateColor(value); },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} newColor
     * @return {?}
     */
    MdCheckbox.prototype._updateColor = function (newColor) {
        this._setElementColor(this._color, false);
        this._setElementColor(newColor, true);
        this._color = newColor;
    };
    /**
     * @param {?} color
     * @param {?} isAdd
     * @return {?}
     */
    MdCheckbox.prototype._setElementColor = function (color, isAdd) {
        if (color != null && color != '') {
            this._renderer.setElementClass(this._elementRef.nativeElement, "mat-" + color, isAdd);
        }
    };
    /**
     * @return {?}
     */
    MdCheckbox.prototype._isRippleDisabled = function () {
        return this.disableRipple || this.disabled;
    };
    /**
     * Sets the model value. Implemented as part of ControlValueAccessor.
     * @param {?} value Value to be set to the model.
     * @return {?}
     */
    MdCheckbox.prototype.writeValue = function (value) {
        this.checked = !!value;
    };
    /**
     * Registers a callback to be triggered when the value has changed.
     * Implemented as part of ControlValueAccessor.
     * @param {?} fn Function to be called on change.
     * @return {?}
     */
    MdCheckbox.prototype.registerOnChange = function (fn) {
        this._controlValueAccessorChangeFn = fn;
    };
    /**
     * Registers a callback to be triggered when the control has been touched.
     * Implemented as part of ControlValueAccessor.
     * @param {?} fn Callback to be triggered when the checkbox is touched.
     * @return {?}
     */
    MdCheckbox.prototype.registerOnTouched = function (fn) {
        this.onTouched = fn;
    };
    /**
     * Sets the checkbox's disabled state. Implemented as a part of ControlValueAccessor.
     * @param {?} isDisabled Whether the checkbox should be disabled.
     * @return {?}
     */
    MdCheckbox.prototype.setDisabledState = function (isDisabled) {
        this.disabled = isDisabled;
    };
    /**
     * @param {?} newState
     * @return {?}
     */
    MdCheckbox.prototype._transitionCheckState = function (newState) {
        var /** @type {?} */ oldState = this._currentCheckState;
        var /** @type {?} */ renderer = this._renderer;
        var /** @type {?} */ elementRef = this._elementRef;
        if (oldState === newState) {
            return;
        }
        if (this._currentAnimationClass.length > 0) {
            renderer.setElementClass(elementRef.nativeElement, this._currentAnimationClass, false);
        }
        this._currentAnimationClass = this._getAnimationClassForCheckStateTransition(oldState, newState);
        this._currentCheckState = newState;
        if (this._currentAnimationClass.length > 0) {
            renderer.setElementClass(elementRef.nativeElement, this._currentAnimationClass, true);
        }
    };
    /**
     * @return {?}
     */
    MdCheckbox.prototype._emitChangeEvent = function () {
        var /** @type {?} */ event = new MdCheckboxChange();
        event.source = this;
        event.checked = this.checked;
        this._controlValueAccessorChangeFn(this.checked);
        this.change.emit(event);
    };
    /**
     * Informs the component when we lose focus in order to style accordingly
     * @return {?}
     */
    MdCheckbox.prototype._onInputBlur = function () {
        this._removeFocusedRipple();
        this.onTouched();
    };
    /**
     * Toggles the `checked` state of the checkbox.
     * @return {?}
     */
    MdCheckbox.prototype.toggle = function () {
        this.checked = !this.checked;
    };
    /**
     * Event handler for checkbox input element.
     * Toggles checked state if element is not disabled.
     * Do not toggle on (change) event since IE doesn't fire change event when
     *   indeterminate checkbox is clicked.
     * @param {?} event
     * @return {?}
     */
    MdCheckbox.prototype._onInputClick = function (event) {
        // We have to stop propagation for click events on the visual hidden input element.
        // By default, when a user clicks on a label element, a generated click event will be
        // dispatched on the associated input element. Since we are using a label element as our
        // root container, the click event on the `checkbox` will be executed twice.
        // The real click event will bubble up, and the generated click event also tries to bubble up.
        // This will lead to multiple click events.
        // Preventing bubbling for the second event will solve that issue.
        event.stopPropagation();
        this._removeFocusedRipple();
        if (!this.disabled) {
            this.toggle();
            this._transitionCheckState(this._checked ? TransitionCheckState.Checked : TransitionCheckState.Unchecked);
            // Emit our custom change event if the native input emitted one.
            // It is important to only emit it, if the native input triggered one, because
            // we don't want to trigger a change event, when the `checked` variable changes for example.
            this._emitChangeEvent();
        }
    };
    /**
     * Focuses the checkbox.
     * @return {?}
     */
    MdCheckbox.prototype.focus = function () {
        this._focusOriginMonitor.focusVia(this._inputElement.nativeElement, this._renderer, 'program');
    };
    /**
     * @param {?} event
     * @return {?}
     */
    MdCheckbox.prototype._onInteractionEvent = function (event) {
        // We always have to stop propagation on the change event.
        // Otherwise the change event, from the input element, will bubble up and
        // emit its event object to the `change` output.
        event.stopPropagation();
    };
    /**
     * @param {?} oldState
     * @param {?} newState
     * @return {?}
     */
    MdCheckbox.prototype._getAnimationClassForCheckStateTransition = function (oldState, newState) {
        var /** @type {?} */ animSuffix;
        switch (oldState) {
            case TransitionCheckState.Init:
                // Handle edge case where user interacts with checkbox that does not have [(ngModel)] or
                // [checked] bound to it.
                if (newState === TransitionCheckState.Checked) {
                    animSuffix = 'unchecked-checked';
                }
                else if (newState == TransitionCheckState.Indeterminate) {
                    animSuffix = 'unchecked-indeterminate';
                }
                else {
                    return '';
                }
                break;
            case TransitionCheckState.Unchecked:
                animSuffix = newState === TransitionCheckState.Checked ?
                    'unchecked-checked' : 'unchecked-indeterminate';
                break;
            case TransitionCheckState.Checked:
                animSuffix = newState === TransitionCheckState.Unchecked ?
                    'checked-unchecked' : 'checked-indeterminate';
                break;
            case TransitionCheckState.Indeterminate:
                animSuffix = newState === TransitionCheckState.Checked ?
                    'indeterminate-checked' : 'indeterminate-unchecked';
        }
        return "mat-checkbox-anim-" + animSuffix;
    };
    /**
     * Fades out the focused state ripple.
     * @return {?}
     */
    MdCheckbox.prototype._removeFocusedRipple = function () {
        if (this._focusedRipple) {
            this._focusedRipple.fadeOut();
            this._focusedRipple = null;
        }
    };
    return MdCheckbox;
}());
MdCheckbox.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{ selector: 'md-checkbox, mat-checkbox',
                template: "<label class=\"mat-checkbox-layout\" #label> <div class=\"mat-checkbox-inner-container\"> <input #input class=\"mat-checkbox-input cdk-visually-hidden\" type=\"checkbox\" [id]=\"inputId\" [required]=\"required\" [checked]=\"checked\" [value]=\"value\" [disabled]=\"disabled\" [name]=\"name\" [tabIndex]=\"tabIndex\" [indeterminate]=\"indeterminate\" [attr.aria-label]=\"ariaLabel\" [attr.aria-labelledby]=\"ariaLabelledby\" (blur)=\"_onInputBlur()\" (change)=\"_onInteractionEvent($event)\" (click)=\"_onInputClick($event)\"> <div md-ripple *ngIf=\"!_isRippleDisabled()\" class=\"mat-checkbox-ripple\" [mdRippleTrigger]=\"label\" [mdRippleCentered]=\"true\"></div> <div class=\"mat-checkbox-frame\"></div> <div class=\"mat-checkbox-background\"> <svg version=\"1.1\" class=\"mat-checkbox-checkmark\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" xml:space=\"preserve\"> <path class=\"mat-checkbox-checkmark-path\" fill=\"none\" stroke=\"white\" d=\"M4.1,12.7 9,17.6 20.3,6.3\"/> </svg> <!-- Element for rendering the indeterminate state checkbox. --> <div class=\"mat-checkbox-mixedmark\"></div> </div> </div> <span class=\"mat-checkbox-label\"> <ng-content></ng-content> </span> </label> ",
                styles: ["@keyframes mat-checkbox-fade-in-background{0%{opacity:0}50%{opacity:1}}@keyframes mat-checkbox-fade-out-background{0%,50%{opacity:1}100%{opacity:0}}@keyframes mat-checkbox-unchecked-checked-checkmark-path{0%,50%{stroke-dashoffset:22.91026}50%{animation-timing-function:cubic-bezier(0,0,.2,.1)}100%{stroke-dashoffset:0}}@keyframes mat-checkbox-unchecked-indeterminate-mixedmark{0%,68.2%{transform:scaleX(0)}68.2%{animation-timing-function:cubic-bezier(0,0,0,1)}100%{transform:scaleX(1)}}@keyframes mat-checkbox-checked-unchecked-checkmark-path{from{animation-timing-function:cubic-bezier(.4,0,1,1);stroke-dashoffset:0}to{stroke-dashoffset:-22.91026}}@keyframes mat-checkbox-checked-indeterminate-checkmark{from{animation-timing-function:cubic-bezier(0,0,.2,.1);opacity:1;transform:rotate(0)}to{opacity:0;transform:rotate(45deg)}}@keyframes mat-checkbox-indeterminate-checked-checkmark{from{animation-timing-function:cubic-bezier(.14,0,0,1);opacity:0;transform:rotate(45deg)}to{opacity:1;transform:rotate(360deg)}}@keyframes mat-checkbox-checked-indeterminate-mixedmark{from{animation-timing-function:cubic-bezier(0,0,.2,.1);opacity:0;transform:rotate(-45deg)}to{opacity:1;transform:rotate(0)}}@keyframes mat-checkbox-indeterminate-checked-mixedmark{from{animation-timing-function:cubic-bezier(.14,0,0,1);opacity:1;transform:rotate(0)}to{opacity:0;transform:rotate(315deg)}}@keyframes mat-checkbox-indeterminate-unchecked-mixedmark{0%{animation-timing-function:linear;opacity:1;transform:scaleX(1)}100%,32.8%{opacity:0;transform:scaleX(0)}}.mat-checkbox-background,.mat-checkbox-checkmark,.mat-checkbox-frame{bottom:0;left:0;position:absolute;right:0;top:0}.mat-checkbox-checkmark,.mat-checkbox-mixedmark{width:calc(100% - 4px)}.mat-checkbox-background,.mat-checkbox-frame{border-radius:2px;box-sizing:border-box;pointer-events:none}.mat-checkbox{font-family:Roboto,\"Helvetica Neue\",sans-serif;transition:background .4s cubic-bezier(.25,.8,.25,1),box-shadow 280ms cubic-bezier(.4,0,.2,1)}.mat-checkbox-label{cursor:pointer}.mat-checkbox-layout{cursor:inherit;align-items:baseline;vertical-align:middle;display:inline-flex}.mat-checkbox-inner-container{display:inline-block;height:20px;line-height:0;margin:auto;margin-right:8px;order:0;position:relative;vertical-align:middle;white-space:nowrap;width:20px;flex-shrink:0}[dir=rtl] .mat-checkbox-inner-container{margin-left:8px;margin-right:auto}.mat-checkbox-layout .mat-checkbox-label{line-height:24px}.mat-checkbox-frame{background-color:transparent;transition:border-color 90ms cubic-bezier(0,0,.2,.1);border-width:2px;border-style:solid}.mat-checkbox-background{align-items:center;display:inline-flex;justify-content:center;transition:background-color 90ms cubic-bezier(0,0,.2,.1),opacity 90ms cubic-bezier(0,0,.2,.1)}.mat-checkbox-checkmark{width:100%}.mat-checkbox-checkmark-path{stroke-dashoffset:22.91026;stroke-dasharray:22.91026;stroke-width:2.66667px}.mat-checkbox-mixedmark{height:2px;opacity:0;transform:scaleX(0) rotate(0)}.mat-checkbox-label-before .mat-checkbox-inner-container{order:1;margin-left:8px;margin-right:auto}[dir=rtl] .mat-checkbox-label-before .mat-checkbox-inner-container{margin-left:auto;margin-right:8px}.mat-checkbox-checked .mat-checkbox-checkmark{opacity:1}.mat-checkbox-checked .mat-checkbox-checkmark-path{stroke-dashoffset:0}.mat-checkbox-checked .mat-checkbox-mixedmark{transform:scaleX(1) rotate(-45deg)}.mat-checkbox-indeterminate .mat-checkbox-checkmark{opacity:0;transform:rotate(45deg)}.mat-checkbox-indeterminate .mat-checkbox-checkmark-path{stroke-dashoffset:0}.mat-checkbox-indeterminate .mat-checkbox-mixedmark{opacity:1;transform:scaleX(1) rotate(0)}.mat-checkbox-unchecked .mat-checkbox-background{background-color:transparent}.mat-checkbox-disabled{cursor:default}.mat-checkbox-anim-unchecked-checked .mat-checkbox-background{animation:180ms linear 0s mat-checkbox-fade-in-background}.mat-checkbox-anim-unchecked-checked .mat-checkbox-checkmark-path{animation:180ms linear 0s mat-checkbox-unchecked-checked-checkmark-path}.mat-checkbox-anim-unchecked-indeterminate .mat-checkbox-background{animation:180ms linear 0s mat-checkbox-fade-in-background}.mat-checkbox-anim-unchecked-indeterminate .mat-checkbox-mixedmark{animation:90ms linear 0s mat-checkbox-unchecked-indeterminate-mixedmark}.mat-checkbox-anim-checked-unchecked .mat-checkbox-background{animation:180ms linear 0s mat-checkbox-fade-out-background}.mat-checkbox-anim-checked-unchecked .mat-checkbox-checkmark-path{animation:90ms linear 0s mat-checkbox-checked-unchecked-checkmark-path}.mat-checkbox-anim-checked-indeterminate .mat-checkbox-checkmark{animation:90ms linear 0s mat-checkbox-checked-indeterminate-checkmark}.mat-checkbox-anim-checked-indeterminate .mat-checkbox-mixedmark{animation:90ms linear 0s mat-checkbox-checked-indeterminate-mixedmark}.mat-checkbox-anim-indeterminate-checked .mat-checkbox-checkmark{animation:.5s linear 0s mat-checkbox-indeterminate-checked-checkmark}.mat-checkbox-anim-indeterminate-checked .mat-checkbox-mixedmark{animation:.5s linear 0s mat-checkbox-indeterminate-checked-mixedmark}.mat-checkbox-anim-indeterminate-unchecked .mat-checkbox-background{animation:180ms linear 0s mat-checkbox-fade-out-background}.mat-checkbox-anim-indeterminate-unchecked .mat-checkbox-mixedmark{animation:.3s linear 0s mat-checkbox-indeterminate-unchecked-mixedmark}.mat-checkbox-input{bottom:0;left:50%}.mat-checkbox-ripple{position:absolute;left:-15px;top:-15px;right:-15px;bottom:-15px;border-radius:50%;z-index:1;pointer-events:none} /*# sourceMappingURL=checkbox.css.map */ "],
                host: {
                    '[class.mat-checkbox]': 'true',
                    '[class.mat-checkbox-indeterminate]': 'indeterminate',
                    '[class.mat-checkbox-checked]': 'checked',
                    '[class.mat-checkbox-disabled]': 'disabled',
                    '[class.mat-checkbox-label-before]': 'labelPosition == "before"',
                },
                providers: [MD_CHECKBOX_CONTROL_VALUE_ACCESSOR],
                encapsulation: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewEncapsulation"].None,
                changeDetection: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectionStrategy"].OnPush
            },] },
];
/**
 * @nocollapse
 */
MdCheckbox.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectorRef"], },
    { type: FocusOriginMonitor, },
]; };
MdCheckbox.propDecorators = {
    'ariaLabel': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['aria-label',] },],
    'ariaLabelledby': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['aria-labelledby',] },],
    'id': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'disableRipple': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'required': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'align': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'labelPosition': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'disabled': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'tabIndex': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'name': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'change': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
    'indeterminateChange': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
    'value': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    '_inputElement': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewChild"], args: ['input',] },],
    '_ripple': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewChild"], args: [MdRipple,] },],
    'checked': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'indeterminate': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'color': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
};
var MdCheckboxModule = (function () {
    function MdCheckboxModule() {
    }
    /**
     * @deprecated
     * @return {?}
     */
    MdCheckboxModule.forRoot = function () {
        return {
            ngModule: MdCheckboxModule,
            providers: []
        };
    };
    return MdCheckboxModule;
}());
MdCheckboxModule.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{
                imports: [__WEBPACK_IMPORTED_MODULE_2__angular_common__["CommonModule"], MdRippleModule, CompatibilityModule],
                exports: [MdCheckbox, CompatibilityModule],
                declarations: [MdCheckbox],
                providers: [FocusOriginMonitor]
            },] },
];
/**
 * @nocollapse
 */
MdCheckboxModule.ctorParameters = function () { return []; };
/**
 * Provider Expression that allows md-radio-group to register as a ControlValueAccessor. This
 * allows it to support [(ngModel)] and ngControl.
 * \@docs-private
 */
var MD_RADIO_GROUP_CONTROL_VALUE_ACCESSOR = {
    provide: __WEBPACK_IMPORTED_MODULE_8__angular_forms__["c" /* NG_VALUE_ACCESSOR */],
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return MdRadioGroup; }),
    multi: true
};
var _uniqueIdCounter$2 = 0;
/**
 * Change event object emitted by MdRadio and MdRadioGroup.
 */
var MdRadioChange = (function () {
    function MdRadioChange() {
    }
    return MdRadioChange;
}());
/**
 * A group of radio buttons. May contain one or more `<md-radio-button>` elements.
 */
var MdRadioGroup = (function () {
    function MdRadioGroup() {
        this._value = null;
        this._name = "md-radio-group-" + _uniqueIdCounter$2++;
        this._disabled = false;
        this._selected = null;
        this._isInitialized = false;
        /** The method to be called in order to update ngModel */
        this._controlValueAccessorChangeFn = function (value) { };
        /**
         * onTouch function registered via registerOnTouch (ControlValueAccessor).
         * \@docs-private
         */
        this.onTouched = function () { };
        /**
         * Event emitted when the group value changes.
         * Change events are only emitted when the value changes due to user interaction with
         * a radio button (the same behavior as `<input type-"radio">`).
         */
        this.change = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /** Child radio buttons. */
        this._radios = null;
        /** Whether the labels should appear after or before the radio-buttons. Defaults to 'after' */
        this.labelPosition = 'after';
    }
    Object.defineProperty(MdRadioGroup.prototype, "name", {
        /**
         * Name of the radio button group. All radio buttons inside this group will use this name.
         * @return {?}
         */
        get: function () { return this._name; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._name = value;
            this._updateRadioButtonNames();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdRadioGroup.prototype, "align", {
        /**
         * Alignment of the radio-buttons relative to their labels. Can be 'before' or 'after'.
         * @deprecated
         * @return {?}
         */
        get: function () {
            // align refers to the checkbox relative to the label, while labelPosition refers to the
            // label relative to the checkbox. As such, they are inverted.
            return this.labelPosition == 'after' ? 'start' : 'end';
        },
        /**
         * @param {?} v
         * @return {?}
         */
        set: function (v) {
            this.labelPosition = (v == 'start') ? 'after' : 'before';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdRadioGroup.prototype, "disabled", {
        /**
         * Whether the radio button is disabled.
         * @return {?}
         */
        get: function () { return this._disabled; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            // The presence of *any* disabled value makes the component disabled, *except* for false.
            this._disabled = (value != null && value !== false) ? true : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdRadioGroup.prototype, "value", {
        /**
         * Value of the radio button.
         * @return {?}
         */
        get: function () { return this._value; },
        /**
         * @param {?} newValue
         * @return {?}
         */
        set: function (newValue) {
            if (this._value != newValue) {
                // Set this before proceeding to ensure no circular loop occurs with selection.
                this._value = newValue;
                this._updateSelectedRadioFromValue();
                this._checkSelectedRadioButton();
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    MdRadioGroup.prototype._checkSelectedRadioButton = function () {
        if (this.selected && !this._selected.checked) {
            this._selected.checked = true;
        }
    };
    Object.defineProperty(MdRadioGroup.prototype, "selected", {
        /**
         * Whether the radio button is selected.
         * @return {?}
         */
        get: function () { return this._selected; },
        /**
         * @param {?} selected
         * @return {?}
         */
        set: function (selected) {
            this._selected = selected;
            this.value = selected ? selected.value : null;
            this._checkSelectedRadioButton();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Initialize properties once content children are available.
     * This allows us to propagate relevant attributes to associated buttons.
     * @return {?}
     */
    MdRadioGroup.prototype.ngAfterContentInit = function () {
        // Mark this component as initialized in AfterContentInit because the initial value can
        // possibly be set by NgModel on MdRadioGroup, and it is possible that the OnInit of the
        // NgModel occurs *after* the OnInit of the MdRadioGroup.
        this._isInitialized = true;
    };
    /**
     * Mark this group as being "touched" (for ngModel). Meant to be called by the contained
     * radio buttons upon their blur.
     * @return {?}
     */
    MdRadioGroup.prototype._touch = function () {
        if (this.onTouched) {
            this.onTouched();
        }
    };
    /**
     * @return {?}
     */
    MdRadioGroup.prototype._updateRadioButtonNames = function () {
        var _this = this;
        if (this._radios) {
            this._radios.forEach(function (radio) {
                radio.name = _this.name;
            });
        }
    };
    /**
     * Updates the `selected` radio button from the internal _value state.
     * @return {?}
     */
    MdRadioGroup.prototype._updateSelectedRadioFromValue = function () {
        var _this = this;
        // If the value already matches the selected radio, do nothing.
        var /** @type {?} */ isAlreadySelected = this._selected != null && this._selected.value == this._value;
        if (this._radios != null && !isAlreadySelected) {
            this._selected = null;
            this._radios.forEach(function (radio) {
                radio.checked = _this.value == radio.value;
                if (radio.checked) {
                    _this._selected = radio;
                }
            });
        }
    };
    /**
     * Dispatch change event with current selection and group value.
     * @return {?}
     */
    MdRadioGroup.prototype._emitChangeEvent = function () {
        if (this._isInitialized) {
            var /** @type {?} */ event = new MdRadioChange();
            event.source = this._selected;
            event.value = this._value;
            this.change.emit(event);
        }
    };
    /**
     * Sets the model value. Implemented as part of ControlValueAccessor.
     * @param {?} value
     * @return {?}
     */
    MdRadioGroup.prototype.writeValue = function (value) {
        this.value = value;
    };
    /**
     * Registers a callback to be triggered when the model value changes.
     * Implemented as part of ControlValueAccessor.
     * @param {?} fn Callback to be registered.
     * @return {?}
     */
    MdRadioGroup.prototype.registerOnChange = function (fn) {
        this._controlValueAccessorChangeFn = fn;
    };
    /**
     * Registers a callback to be triggered when the control is touched.
     * Implemented as part of ControlValueAccessor.
     * @param {?} fn Callback to be registered.
     * @return {?}
     */
    MdRadioGroup.prototype.registerOnTouched = function (fn) {
        this.onTouched = fn;
    };
    /**
     * Sets the disabled state of the control. Implemented as a part of ControlValueAccessor.
     * @param {?} isDisabled Whether the control should be disabled.
     * @return {?}
     */
    MdRadioGroup.prototype.setDisabledState = function (isDisabled) {
        this.disabled = isDisabled;
    };
    return MdRadioGroup;
}());
MdRadioGroup.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                selector: 'md-radio-group, mat-radio-group',
                providers: [MD_RADIO_GROUP_CONTROL_VALUE_ACCESSOR],
                host: {
                    'role': 'radiogroup',
                    '[class.mat-radio-group]': 'true',
                },
            },] },
];
/**
 * @nocollapse
 */
MdRadioGroup.ctorParameters = function () { return []; };
MdRadioGroup.propDecorators = {
    'change': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
    '_radios': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ContentChildren"], args: [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return MdRadioButton; }),] },],
    'name': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'align': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'labelPosition': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'disabled': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'value': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'selected': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
};
/**
 * A radio-button. May be inside of
 */
var MdRadioButton = (function () {
    /**
     * @param {?} radioGroup
     * @param {?} _elementRef
     * @param {?} _renderer
     * @param {?} _focusOriginMonitor
     * @param {?} _radioDispatcher
     */
    function MdRadioButton(radioGroup, _elementRef, _renderer, _focusOriginMonitor, _radioDispatcher) {
        var _this = this;
        // Assertions. Ideally these should be stripped out by the compiler.
        // TODO(jelbourn): Assert that there's no name binding AND a parent radio group.
        this._elementRef = _elementRef;
        this._renderer = _renderer;
        this._focusOriginMonitor = _focusOriginMonitor;
        this._radioDispatcher = _radioDispatcher;
        /** The unique ID for the radio button. */
        this.id = "md-radio-" + _uniqueIdCounter$2++;
        /**
         * Event emitted when the checked state of this radio button changes.
         * Change events are only emitted when the value changes due to user interaction with
         * the radio button (the same behavior as `<input type-"radio">`).
         */
        this.change = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this._checked = false;
        this._value = null;
        this.radioGroup = radioGroup;
        _radioDispatcher.listen(function (id, name) {
            if (id != _this.id && name == _this.name) {
                _this.checked = false;
            }
        });
    }
    Object.defineProperty(MdRadioButton.prototype, "disableRipple", {
        /**
         * Whether the ripple effect for this radio button is disabled.
         * @return {?}
         */
        get: function () { return this._disableRipple; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this._disableRipple = coerceBooleanProperty(value); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdRadioButton.prototype, "checked", {
        /**
         * Whether this radio button is checked.
         * @return {?}
         */
        get: function () {
            return this._checked;
        },
        /**
         * @param {?} newCheckedState
         * @return {?}
         */
        set: function (newCheckedState) {
            if (this._checked != newCheckedState) {
                this._checked = newCheckedState;
                if (newCheckedState && this.radioGroup && this.radioGroup.value != this.value) {
                    this.radioGroup.selected = this;
                }
                else if (!newCheckedState && this.radioGroup && this.radioGroup.value == this.value) {
                    // When unchecking the selected radio button, update the selected radio
                    // property on the group.
                    this.radioGroup.selected = null;
                }
                if (newCheckedState) {
                    // Notify all radio buttons with the same name to un-check.
                    this._radioDispatcher.notify(this.id, this.name);
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdRadioButton.prototype, "value", {
        /**
         * The value of this radio button.
         * @return {?}
         */
        get: function () {
            return this._value;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            if (this._value != value) {
                this._value = value;
                if (this.radioGroup != null) {
                    if (!this.checked) {
                        // Update checked when the value changed to match the radio group's value
                        this.checked = this.radioGroup.value == value;
                    }
                    if (this.checked) {
                        this.radioGroup.selected = this;
                    }
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdRadioButton.prototype, "align", {
        /**
         * Whether or not the radio-button should appear before or after the label.
         * @deprecated
         * @return {?}
         */
        get: function () {
            // align refers to the checkbox relative to the label, while labelPosition refers to the
            // label relative to the checkbox. As such, they are inverted.
            return this.labelPosition == 'after' ? 'start' : 'end';
        },
        /**
         * @param {?} v
         * @return {?}
         */
        set: function (v) {
            this.labelPosition = (v == 'start') ? 'after' : 'before';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdRadioButton.prototype, "labelPosition", {
        /**
         * Whether the label should appear after or before the radio button. Defaults to 'after'
         * @return {?}
         */
        get: function () {
            return this._labelPosition || (this.radioGroup && this.radioGroup.labelPosition) || 'after';
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._labelPosition = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdRadioButton.prototype, "disabled", {
        /**
         * Whether the radio button is disabled.
         * @return {?}
         */
        get: function () {
            return this._disabled || (this.radioGroup != null && this.radioGroup.disabled);
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            // The presence of *any* disabled value makes the component disabled, *except* for false.
            this._disabled = (value != null && value !== false) ? true : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdRadioButton.prototype, "inputId", {
        /**
         * ID of the native input element inside `<md-radio-button>`
         * @return {?}
         */
        get: function () {
            return this.id + "-input";
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Focuses the radio button.
     * @return {?}
     */
    MdRadioButton.prototype.focus = function () {
        this._focusOriginMonitor.focusVia(this._inputElement.nativeElement, this._renderer, 'keyboard');
    };
    /**
     * @return {?}
     */
    MdRadioButton.prototype.ngOnInit = function () {
        if (this.radioGroup) {
            // If the radio is inside a radio group, determine if it should be checked
            this.checked = this.radioGroup.value === this._value;
            // Copy name from parent radio group
            this.name = this.radioGroup.name;
        }
    };
    /**
     * @return {?}
     */
    MdRadioButton.prototype.ngAfterViewInit = function () {
        var _this = this;
        this._focusOriginMonitorSubscription = this._focusOriginMonitor
            .monitor(this._inputElement.nativeElement, this._renderer, false)
            .subscribe(function (focusOrigin) {
            if (focusOrigin === 'keyboard' && !_this._focusedRippleRef) {
                _this._focusedRippleRef = _this._ripple.launch(0, 0, { persistent: true, centered: true });
            }
        });
    };
    /**
     * @return {?}
     */
    MdRadioButton.prototype.ngOnDestroy = function () {
        this._focusOriginMonitor.stopMonitoring(this._inputElement.nativeElement);
    };
    /**
     * Dispatch change event with current value.
     * @return {?}
     */
    MdRadioButton.prototype._emitChangeEvent = function () {
        var /** @type {?} */ event = new MdRadioChange();
        event.source = this;
        event.value = this._value;
        this.change.emit(event);
    };
    /**
     * @return {?}
     */
    MdRadioButton.prototype._isRippleDisabled = function () {
        return this.disableRipple || this.disabled;
    };
    /**
     * @return {?}
     */
    MdRadioButton.prototype._onInputBlur = function () {
        if (this._focusedRippleRef) {
            this._focusedRippleRef.fadeOut();
            this._focusedRippleRef = null;
        }
        if (this.radioGroup) {
            this.radioGroup._touch();
        }
    };
    /**
     * @param {?} event
     * @return {?}
     */
    MdRadioButton.prototype._onInputClick = function (event) {
        // We have to stop propagation for click events on the visual hidden input element.
        // By default, when a user clicks on a label element, a generated click event will be
        // dispatched on the associated input element. Since we are using a label element as our
        // root container, the click event on the `radio-button` will be executed twice.
        // The real click event will bubble up, and the generated click event also tries to bubble up.
        // This will lead to multiple click events.
        // Preventing bubbling for the second event will solve that issue.
        event.stopPropagation();
    };
    /**
     * Triggered when the radio button received a click or the input recognized any change.
     * Clicking on a label element, will trigger a change event on the associated input.
     * @param {?} event
     * @return {?}
     */
    MdRadioButton.prototype._onInputChange = function (event) {
        // We always have to stop propagation on the change event.
        // Otherwise the change event, from the input element, will bubble up and
        // emit its event object to the `change` output.
        event.stopPropagation();
        var /** @type {?} */ groupValueChanged = this.radioGroup && this.value != this.radioGroup.value;
        this.checked = true;
        this._emitChangeEvent();
        if (this.radioGroup) {
            this.radioGroup._controlValueAccessorChangeFn(this.value);
            this.radioGroup._touch();
            if (groupValueChanged) {
                this.radioGroup._emitChangeEvent();
            }
        }
    };
    return MdRadioButton;
}());
MdRadioButton.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{ selector: 'md-radio-button, mat-radio-button',
                template: "<!-- TODO(jelbourn): render the radio on either side of the content --> <!-- TODO(mtlin): Evaluate trade-offs of using native radio vs. cost of additional bindings. --> <label [attr.for]=\"inputId\" class=\"mat-radio-label\" #label> <!-- The actual 'radio' part of the control. --> <div class=\"mat-radio-container\"> <div class=\"mat-radio-outer-circle\"></div> <div class=\"mat-radio-inner-circle\"></div> <div md-ripple *ngIf=\"!_isRippleDisabled()\" class=\"mat-radio-ripple\" [mdRippleTrigger]=\"label\" [mdRippleCentered]=\"true\"></div> </div> <input #input class=\"mat-radio-input cdk-visually-hidden\" type=\"radio\" [id]=\"inputId\" [checked]=\"checked\" [disabled]=\"disabled\" [name]=\"name\" [attr.aria-label]=\"ariaLabel\" [attr.aria-labelledby]=\"ariaLabelledby\" (change)=\"_onInputChange($event)\" (blur)=\"_onInputBlur()\" (click)=\"_onInputClick($event)\"> <!-- The label content for radio control. --> <div class=\"mat-radio-label-content\" [class.mat-radio-label-before]=\"labelPosition == 'before'\"> <ng-content></ng-content> </div> </label> ",
                styles: [".mat-radio-button{display:inline-block;font-family:Roboto,\"Helvetica Neue\",sans-serif}.mat-radio-label{cursor:pointer;display:inline-flex;align-items:baseline;white-space:nowrap}.mat-radio-container{box-sizing:border-box;display:inline-block;height:20px;position:relative;width:20px;top:2px}.mat-radio-outer-circle{box-sizing:border-box;height:20px;left:0;position:absolute;top:0;transition:border-color ease 280ms;width:20px;border-width:2px;border-style:solid;border-radius:50%}.mat-radio-inner-circle{border-radius:50%;box-sizing:border-box;height:20px;left:0;position:absolute;top:0;transition:transform ease 280ms,background-color ease 280ms;transform:scale(0);width:20px}.mat-radio-checked .mat-radio-inner-circle{transform:scale(.5)}.mat-radio-label-content{display:inline-block;order:0;line-height:inherit;padding-left:8px;padding-right:0}[dir=rtl] .mat-radio-label-content{padding-right:8px;padding-left:0}.mat-radio-label-content.mat-radio-label-before{order:-1;padding-left:0;padding-right:8px}[dir=rtl] .mat-radio-label-content.mat-radio-label-before{padding-right:0;padding-left:8px}.mat-radio-disabled,.mat-radio-disabled .mat-radio-label{cursor:default}.mat-radio-ripple{position:absolute;left:-15px;top:-15px;right:-15px;bottom:-15px;border-radius:50%;z-index:1;pointer-events:none} /*# sourceMappingURL=radio.css.map */ "],
                encapsulation: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewEncapsulation"].None,
                host: {
                    '[class.mat-radio-button]': 'true',
                    '[class.mat-radio-checked]': 'checked',
                    '[class.mat-radio-disabled]': 'disabled',
                    '[attr.id]': 'id',
                }
            },] },
];
/**
 * @nocollapse
 */
MdRadioButton.ctorParameters = function () { return [
    { type: MdRadioGroup, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] },] },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
    { type: FocusOriginMonitor, },
    { type: UniqueSelectionDispatcher, },
]; };
MdRadioButton.propDecorators = {
    'id': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'name': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'ariaLabel': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['aria-label',] },],
    'ariaLabelledby': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['aria-labelledby',] },],
    'disableRipple': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'checked': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'value': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'align': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'labelPosition': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'disabled': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'change': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
    '_ripple': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewChild"], args: [MdRipple,] },],
    '_inputElement': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewChild"], args: ['input',] },],
};
var MdRadioModule = (function () {
    function MdRadioModule() {
    }
    /**
     * @deprecated
     * @return {?}
     */
    MdRadioModule.forRoot = function () {
        return {
            ngModule: MdRadioModule,
            providers: [],
        };
    };
    return MdRadioModule;
}());
MdRadioModule.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{
                imports: [__WEBPACK_IMPORTED_MODULE_2__angular_common__["CommonModule"], MdRippleModule, CompatibilityModule],
                exports: [MdRadioGroup, MdRadioButton, CompatibilityModule],
                providers: [UNIQUE_SELECTION_DISPATCHER_PROVIDER, VIEWPORT_RULER_PROVIDER, FocusOriginMonitor],
                declarations: [MdRadioGroup, MdRadioButton],
            },] },
];
/**
 * @nocollapse
 */
MdRadioModule.ctorParameters = function () { return []; };
/**
 * This class manages keyboard events for selectable lists. If you pass it a query list
 * of items, it will set the active item correctly when arrow events occur.
 */
var ListKeyManager = (function () {
    /**
     * @param {?} _items
     */
    function ListKeyManager(_items) {
        this._items = _items;
        this._activeItemIndex = null;
        this._tabOut = new __WEBPACK_IMPORTED_MODULE_3_rxjs_Subject__["Subject"]();
        this._wrap = false;
    }
    /**
     * Turns on wrapping mode, which ensures that the active item will wrap to
     * the other end of list when there are no more items in the given direction.
     *
     * @return {?} The ListKeyManager that the method was called on.
     */
    ListKeyManager.prototype.withWrap = function () {
        this._wrap = true;
        return this;
    };
    /**
     * Sets the active item to the item at the index specified.
     *
     * @param {?} index The index of the item to be set as active.
     * @return {?}
     */
    ListKeyManager.prototype.setActiveItem = function (index) {
        this._activeItemIndex = index;
        this._activeItem = this._items.toArray()[index];
    };
    /**
     * Sets the active item depending on the key event passed in.
     * @param {?} event Keyboard event to be used for determining which element should be active.
     * @return {?}
     */
    ListKeyManager.prototype.onKeydown = function (event) {
        switch (event.keyCode) {
            case DOWN_ARROW:
                this.setNextItemActive();
                break;
            case UP_ARROW:
                this.setPreviousItemActive();
                break;
            case HOME:
                this.setFirstItemActive();
                break;
            case END:
                this.setLastItemActive();
                break;
            case TAB:
                // Note that we shouldn't prevent the default action on tab.
                this._tabOut.next(null);
                return;
            default:
                return;
        }
        event.preventDefault();
    };
    Object.defineProperty(ListKeyManager.prototype, "activeItemIndex", {
        /**
         * Returns the index of the currently active item.
         * @return {?}
         */
        get: function () {
            return this._activeItemIndex;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ListKeyManager.prototype, "activeItem", {
        /**
         * Returns the currently active item.
         * @return {?}
         */
        get: function () {
            return this._activeItem;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Sets the active item to the first enabled item in the list.
     * @return {?}
     */
    ListKeyManager.prototype.setFirstItemActive = function () {
        this._setActiveItemByIndex(0, 1);
    };
    /**
     * Sets the active item to the last enabled item in the list.
     * @return {?}
     */
    ListKeyManager.prototype.setLastItemActive = function () {
        this._setActiveItemByIndex(this._items.length - 1, -1);
    };
    /**
     * Sets the active item to the next enabled item in the list.
     * @return {?}
     */
    ListKeyManager.prototype.setNextItemActive = function () {
        this._activeItemIndex === null ? this.setFirstItemActive() : this._setActiveItemByDelta(1);
    };
    /**
     * Sets the active item to a previous enabled item in the list.
     * @return {?}
     */
    ListKeyManager.prototype.setPreviousItemActive = function () {
        this._activeItemIndex === null && this._wrap ? this.setLastItemActive()
            : this._setActiveItemByDelta(-1);
    };
    /**
     * Allows setting of the activeItemIndex without any other effects.
     * @param {?} index The new activeItemIndex.
     * @return {?}
     */
    ListKeyManager.prototype.updateActiveItemIndex = function (index) {
        this._activeItemIndex = index;
    };
    Object.defineProperty(ListKeyManager.prototype, "tabOut", {
        /**
         * Observable that emits any time the TAB key is pressed, so components can react
         * when focus is shifted off of the list.
         * @return {?}
         */
        get: function () {
            return this._tabOut.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * This method sets the active item, given a list of items and the delta between the
     * currently active item and the new active item. It will calculate differently
     * depending on whether wrap mode is turned on.
     * @param {?} delta
     * @param {?=} items
     * @return {?}
     */
    ListKeyManager.prototype._setActiveItemByDelta = function (delta, items) {
        if (items === void 0) { items = this._items.toArray(); }
        this._wrap ? this._setActiveInWrapMode(delta, items)
            : this._setActiveInDefaultMode(delta, items);
    };
    /**
     * Sets the active item properly given "wrap" mode. In other words, it will continue to move
     * down the list until it finds an item that is not disabled, and it will wrap if it
     * encounters either end of the list.
     * @param {?} delta
     * @param {?} items
     * @return {?}
     */
    ListKeyManager.prototype._setActiveInWrapMode = function (delta, items) {
        // when active item would leave menu, wrap to beginning or end
        this._activeItemIndex =
            (this._activeItemIndex + delta + items.length) % items.length;
        // skip all disabled menu items recursively until an enabled one is reached
        if (items[this._activeItemIndex].disabled) {
            this._setActiveInWrapMode(delta, items);
        }
        else {
            this.setActiveItem(this._activeItemIndex);
        }
    };
    /**
     * Sets the active item properly given the default mode. In other words, it will
     * continue to move down the list until it finds an item that is not disabled. If
     * it encounters either end of the list, it will stop and not wrap.
     * @param {?} delta
     * @param {?} items
     * @return {?}
     */
    ListKeyManager.prototype._setActiveInDefaultMode = function (delta, items) {
        this._setActiveItemByIndex(this._activeItemIndex + delta, delta, items);
    };
    /**
     * Sets the active item to the first enabled item starting at the index specified. If the
     * item is disabled, it will move in the fallbackDelta direction until it either
     * finds an enabled item or encounters the end of the list.
     * @param {?} index
     * @param {?} fallbackDelta
     * @param {?=} items
     * @return {?}
     */
    ListKeyManager.prototype._setActiveItemByIndex = function (index, fallbackDelta, items) {
        if (items === void 0) { items = this._items.toArray(); }
        if (!items[index]) {
            return;
        }
        while (items[index].disabled) {
            index += fallbackDelta;
            if (!items[index]) {
                return;
            }
        }
        this.setActiveItem(index);
    };
    return ListKeyManager;
}());
var FocusKeyManager = (function (_super) {
    __extends(FocusKeyManager, _super);
    /**
     * @param {?} items
     */
    function FocusKeyManager(items) {
        return _super.call(this, items) || this;
    }
    /**
     * This method sets the active item to the item at the specified index.
     * It also adds focuses the newly active item.
     * @param {?} index
     * @return {?}
     */
    FocusKeyManager.prototype.setActiveItem = function (index) {
        _super.prototype.setActiveItem.call(this, index);
        this.activeItem.focus();
    };
    return FocusKeyManager;
}(ListKeyManager));
/**
 * The following are all the animations for the md-select component, with each
 * const containing the metadata for one animation.
 *
 * The values below match the implementation of the AngularJS Material md-select animation.
 */
/**
 * This animation shrinks the placeholder text to 75% of its normal size and translates
 * it to either the top left corner (ltr) or top right corner (rtl) of the trigger,
 * depending on the text direction of the application.
 */
var transformPlaceholder = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__angular_animations__["f" /* trigger */])('transformPlaceholder', [
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__angular_animations__["g" /* state */])('floating-ltr', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__angular_animations__["c" /* style */])({
        top: '-22px',
        left: '-2px',
        transform: "scale(0.75)"
    })),
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__angular_animations__["g" /* state */])('floating-rtl', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__angular_animations__["c" /* style */])({
        top: '-22px',
        left: '2px',
        transform: "scale(0.75)"
    })),
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__angular_animations__["h" /* transition */])('* => *', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__angular_animations__["i" /* animate */])("400ms cubic-bezier(0.25, 0.8, 0.25, 1)"))
]);
/**
 * This animation transforms the select's overlay panel on and off the page.
 *
 * When the panel is attached to the DOM, it expands its width 32px, scales it up to
 * 100% on the Y axis, fades in its border, and translates slightly up and to the
 * side to ensure the option text correctly overlaps the trigger text.
 *
 * When the panel is removed from the DOM, it simply fades out linearly.
 */
var transformPanel = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__angular_animations__["f" /* trigger */])('transformPanel', [
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__angular_animations__["g" /* state */])('showing', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__angular_animations__["c" /* style */])({
        opacity: 1,
        minWidth: 'calc(100% + 32px)',
        transform: "scaleY(1)"
    })),
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__angular_animations__["h" /* transition */])('void => *', [
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__angular_animations__["c" /* style */])({
            opacity: 0,
            minWidth: '100%',
            transform: "scaleY(0)"
        }),
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__angular_animations__["i" /* animate */])("150ms cubic-bezier(0.25, 0.8, 0.25, 1)")
    ]),
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__angular_animations__["h" /* transition */])('* => void', [
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__angular_animations__["i" /* animate */])('250ms 100ms linear', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__angular_animations__["c" /* style */])({ opacity: 0 }))
    ])
]);
/**
 * This animation fades in the background color and text content of the
 * select's options. It is time delayed to occur 100ms after the overlay
 * panel has transformed in.
 */
var fadeInContent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__angular_animations__["f" /* trigger */])('fadeInContent', [
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__angular_animations__["g" /* state */])('showing', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__angular_animations__["c" /* style */])({ opacity: 1 })),
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__angular_animations__["h" /* transition */])('void => showing', [
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__angular_animations__["c" /* style */])({ opacity: 0 }),
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__angular_animations__["i" /* animate */])("150ms 100ms cubic-bezier(0.55, 0, 0.55, 0.2)")
    ])
]);
/**
 * Exception thrown when attempting to change a select's `multiple` option after initialization.
 * \@docs-private
 */
var MdSelectDynamicMultipleError = (function (_super) {
    __extends(MdSelectDynamicMultipleError, _super);
    function MdSelectDynamicMultipleError() {
        return _super.call(this, 'Cannot change `multiple` mode of select after initialization.') || this;
    }
    return MdSelectDynamicMultipleError;
}(MdError));
/**
 * Exception thrown when attempting to assign a non-array value to a select in `multiple` mode.
 * Note that `undefined` and `null` are still valid values to allow for resetting the value.
 * \@docs-private
 */
var MdSelectNonArrayValueError = (function (_super) {
    __extends(MdSelectNonArrayValueError, _super);
    function MdSelectNonArrayValueError() {
        return _super.call(this, 'Cannot assign truthy non-array value to select in `multiple` mode.') || this;
    }
    return MdSelectNonArrayValueError;
}(MdError));
/**
 * The following style constants are necessary to save here in order
 * to properly calculate the alignment of the selected option over
 * the trigger element.
 */
/** The fixed height of every option element. */
var SELECT_OPTION_HEIGHT = 48;
/** The max height of the select's overlay panel */
var SELECT_PANEL_MAX_HEIGHT = 256;
/** The max number of options visible at once in the select panel. */
var SELECT_MAX_OPTIONS_DISPLAYED = 5;
/** The fixed height of the select's trigger element. */
var SELECT_TRIGGER_HEIGHT = 30;
/**
 * Must adjust for the difference in height between the option and the trigger,
 * so the text will align on the y axis.
 * (SELECT_OPTION_HEIGHT (48) - SELECT_TRIGGER_HEIGHT (30)) / 2 = 9
 */
var SELECT_OPTION_HEIGHT_ADJUSTMENT = 9;
/** The panel's padding on the x-axis */
var SELECT_PANEL_PADDING_X = 16;
/**
 * Distance between the panel edge and the option text in
 * multi-selection mode.
 *
 * (SELECT_PADDING * 1.75) + 20 = 48
 * The padding is multiplied by 1.75 because the checkbox's margin is half the padding, and
 * the browser adds ~4px, because we're using inline elements.
 * The checkbox width is 20px.
 */
var SELECT_MULTIPLE_PANEL_PADDING_X = SELECT_PANEL_PADDING_X * 1.75 + 20;
/**
 * The panel's padding on the y-axis. This padding indicates there are more
 * options available if you scroll.
 */
var SELECT_PANEL_PADDING_Y = 16;
/**
 * The select panel will only "fit" inside the viewport if it is positioned at
 * this value or more away from the viewport boundary.
 */
var SELECT_PANEL_VIEWPORT_PADDING = 8;
/**
 * Change event object that is emitted when the select value has changed.
 */
var MdSelectChange = (function () {
    /**
     * @param {?} source
     * @param {?} value
     */
    function MdSelectChange(source, value) {
        this.source = source;
        this.value = value;
    }
    return MdSelectChange;
}());
var MdSelect = (function () {
    /**
     * @param {?} _element
     * @param {?} _renderer
     * @param {?} _viewportRuler
     * @param {?} _changeDetectorRef
     * @param {?} _dir
     * @param {?} _control
     * @param {?} tabIndex
     */
    function MdSelect(_element, _renderer, _viewportRuler, _changeDetectorRef, _dir, _control, tabIndex) {
        this._element = _element;
        this._renderer = _renderer;
        this._viewportRuler = _viewportRuler;
        this._changeDetectorRef = _changeDetectorRef;
        this._dir = _dir;
        this._control = _control;
        this._panelOpen = false;
        this._required = false;
        this._disabled = false;
        this._scrollTop = 0;
        this._multiple = false;
        this._placeholderState = '';
        /** View -> model callback called when value changes */
        this._onChange = function (value) { };
        /** View -> model callback called when select has been touched */
        this._onTouched = function () { };
        /** The IDs of child options to be passed to the aria-owns attribute. */
        this._optionIds = '';
        /** The value of the select panel's transform-origin property. */
        this._transformOrigin = 'top';
        /** Whether the panel's animation is done. */
        this._panelDoneAnimating = false;
        /**
         * The x-offset of the overlay panel in relation to the trigger's top start corner.
         * This must be adjusted to align the selected option text over the trigger text when
         * the panel opens. Will change based on LTR or RTL text direction.
         */
        this._offsetX = 0;
        /**
         * The y-offset of the overlay panel in relation to the trigger's top start corner.
         * This must be adjusted to align the selected option text over the trigger text.
         * when the panel opens. Will change based on the y-position of the selected option.
         */
        this._offsetY = 0;
        /**
         * This position config ensures that the top "start" corner of the overlay
         * is aligned with with the top "start" of the origin by default (overlapping
         * the trigger completely). If the panel cannot fit below the trigger, it
         * will fall back to a position above the trigger.
         */
        this._positions = [
            {
                originX: 'start',
                originY: 'top',
                overlayX: 'start',
                overlayY: 'top',
            },
            {
                originX: 'start',
                originY: 'bottom',
                overlayX: 'start',
                overlayY: 'bottom',
            },
        ];
        this._floatPlaceholder = 'auto';
        /** Aria label of the select. If not specified, the placeholder will be used as label. */
        this.ariaLabel = '';
        /** Input that can be used to specify the `aria-labelledby` attribute. */
        this.ariaLabelledby = '';
        /** Event emitted when the select has been opened. */
        this.onOpen = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /** Event emitted when the select has been closed. */
        this.onClose = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /** Event emitted when the selected value has been changed by the user. */
        this.change = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        if (this._control) {
            this._control.valueAccessor = this;
        }
        this._tabIndex = parseInt(tabIndex) || 0;
    }
    Object.defineProperty(MdSelect.prototype, "placeholder", {
        /**
         * Placeholder to be shown if no value has been selected.
         * @return {?}
         */
        get: function () { return this._placeholder; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            var _this = this;
            this._placeholder = value;
            // Must wait to record the trigger width to ensure placeholder width is included.
            Promise.resolve(null).then(function () { return _this._triggerWidth = _this._getWidth(); });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdSelect.prototype, "disabled", {
        /**
         * Whether the component is disabled.
         * @return {?}
         */
        get: function () { return this._disabled; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._disabled = coerceBooleanProperty(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdSelect.prototype, "required", {
        /**
         * Whether the component is required.
         * @return {?}
         */
        get: function () { return this._required; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this._required = coerceBooleanProperty(value); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdSelect.prototype, "multiple", {
        /**
         * Whether the user should be allowed to select multiple options.
         * @return {?}
         */
        get: function () { return this._multiple; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            if (this._selectionModel) {
                throw new MdSelectDynamicMultipleError();
            }
            this._multiple = coerceBooleanProperty(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdSelect.prototype, "floatPlaceholder", {
        /**
         * Whether to float the placeholder text.
         * @return {?}
         */
        get: function () { return this._floatPlaceholder; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._floatPlaceholder = value || 'auto';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdSelect.prototype, "tabIndex", {
        /**
         * Tab index for the select element.
         * @return {?}
         */
        get: function () { return this._disabled ? -1 : this._tabIndex; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            if (typeof value !== 'undefined') {
                this._tabIndex = value;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdSelect.prototype, "optionSelectionChanges", {
        /**
         * Combined stream of all of the child options' change events.
         * @return {?}
         */
        get: function () {
            return __WEBPACK_IMPORTED_MODULE_4_rxjs_Observable__["Observable"].merge.apply(__WEBPACK_IMPORTED_MODULE_4_rxjs_Observable__["Observable"], this.options.map(function (option) { return option.onSelectionChange; }));
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    MdSelect.prototype.ngOnInit = function () {
        this._selectionModel = new SelectionModel(this.multiple, null, false);
    };
    /**
     * @return {?}
     */
    MdSelect.prototype.ngAfterContentInit = function () {
        var _this = this;
        this._initKeyManager();
        this._changeSubscription = this.options.changes.startWith(null).subscribe(function () {
            _this._resetOptions();
            if (_this._control) {
                // Defer setting the value in order to avoid the "Expression
                // has changed after it was checked" errors from Angular.
                Promise.resolve(null).then(function () { return _this._setSelectionByValue(_this._control.value); });
            }
        });
    };
    /**
     * @return {?}
     */
    MdSelect.prototype.ngOnDestroy = function () {
        this._dropSubscriptions();
        if (this._changeSubscription) {
            this._changeSubscription.unsubscribe();
        }
        if (this._tabSubscription) {
            this._tabSubscription.unsubscribe();
        }
    };
    /**
     * Toggles the overlay panel open or closed.
     * @return {?}
     */
    MdSelect.prototype.toggle = function () {
        this.panelOpen ? this.close() : this.open();
    };
    /**
     * Opens the overlay panel.
     * @return {?}
     */
    MdSelect.prototype.open = function () {
        if (this.disabled || !this.options.length) {
            return;
        }
        this._calculateOverlayPosition();
        this._placeholderState = this._floatPlaceholderState();
        this._panelOpen = true;
    };
    /**
     * Closes the overlay panel and focuses the host element.
     * @return {?}
     */
    MdSelect.prototype.close = function () {
        if (this._panelOpen) {
            this._panelOpen = false;
            if (this._selectionModel.isEmpty()) {
                this._placeholderState = '';
            }
            this._focusHost();
        }
    };
    /**
     * Sets the select's value. Part of the ControlValueAccessor interface
     * required to integrate with Angular's core forms API.
     *
     * @param {?} value New value to be written to the model.
     * @return {?}
     */
    MdSelect.prototype.writeValue = function (value) {
        if (this.options) {
            this._setSelectionByValue(value);
        }
    };
    /**
     * Saves a callback function to be invoked when the select's value
     * changes from user input. Part of the ControlValueAccessor interface
     * required to integrate with Angular's core forms API.
     *
     * @param {?} fn Callback to be triggered when the value changes.
     * @return {?}
     */
    MdSelect.prototype.registerOnChange = function (fn) {
        this._onChange = fn;
    };
    /**
     * Saves a callback function to be invoked when the select is blurred
     * by the user. Part of the ControlValueAccessor interface required
     * to integrate with Angular's core forms API.
     *
     * @param {?} fn Callback to be triggered when the component has been touched.
     * @return {?}
     */
    MdSelect.prototype.registerOnTouched = function (fn) {
        this._onTouched = fn;
    };
    /**
     * Disables the select. Part of the ControlValueAccessor interface required
     * to integrate with Angular's core forms API.
     *
     * @param {?} isDisabled Sets whether the component is disabled.
     * @return {?}
     */
    MdSelect.prototype.setDisabledState = function (isDisabled) {
        this.disabled = isDisabled;
    };
    Object.defineProperty(MdSelect.prototype, "panelOpen", {
        /**
         * Whether or not the overlay panel is open.
         * @return {?}
         */
        get: function () {
            return this._panelOpen;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdSelect.prototype, "selected", {
        /**
         * The currently selected option.
         * @return {?}
         */
        get: function () {
            return this.multiple ? this._selectionModel.selected : this._selectionModel.selected[0];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdSelect.prototype, "triggerValue", {
        /**
         * The value displayed in the trigger.
         * @return {?}
         */
        get: function () {
            if (this._multiple) {
                var /** @type {?} */ selectedOptions = this._selectionModel.selected.map(function (option) { return option.viewValue; });
                if (this._isRtl()) {
                    selectedOptions.reverse();
                }
                // TODO(crisbeto): delimiter should be configurable for proper localization.
                return selectedOptions.join(', ');
            }
            return this._selectionModel.selected[0].viewValue;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Whether the element is in RTL mode.
     * @return {?}
     */
    MdSelect.prototype._isRtl = function () {
        return this._dir ? this._dir.value === 'rtl' : false;
    };
    /**
     * The width of the trigger element. This is necessary to match
     * the overlay width to the trigger width.
     * @return {?}
     */
    MdSelect.prototype._getWidth = function () {
        return this._getTriggerRect().width;
    };
    /**
     * Ensures the panel opens if activated by the keyboard.
     * @param {?} event
     * @return {?}
     */
    MdSelect.prototype._handleKeydown = function (event) {
        if (event.keyCode === ENTER || event.keyCode === SPACE) {
            this.open();
        }
    };
    /**
     * When the panel element is finished transforming in (though not fading in), it
     * emits an event and focuses an option if the panel is open.
     * @return {?}
     */
    MdSelect.prototype._onPanelDone = function () {
        if (this.panelOpen) {
            this._focusCorrectOption();
            this.onOpen.emit();
        }
        else {
            this.onClose.emit();
            this._panelDoneAnimating = false;
        }
    };
    /**
     * When the panel content is done fading in, the _panelDoneAnimating property is
     * set so the proper class can be added to the panel.
     * @return {?}
     */
    MdSelect.prototype._onFadeInDone = function () {
        this._panelDoneAnimating = this.panelOpen;
    };
    /**
     * Calls the touched callback only if the panel is closed. Otherwise, the trigger will
     * "blur" to the panel when it opens, causing a false positive.
     * @return {?}
     */
    MdSelect.prototype._onBlur = function () {
        if (!this.panelOpen) {
            this._onTouched();
        }
    };
    /**
     * Sets the scroll position of the scroll container. This must be called after
     * the overlay pane is attached or the scroll container element will not yet be
     * present in the DOM.
     * @return {?}
     */
    MdSelect.prototype._setScrollTop = function () {
        var /** @type {?} */ scrollContainer = this.overlayDir.overlayRef.overlayElement.querySelector('.mat-select-panel');
        scrollContainer.scrollTop = this._scrollTop;
    };
    /**
     * Sets the selected option based on a value. If no option can be
     * found with the designated value, the select trigger is cleared.
     * @param {?} value
     * @return {?}
     */
    MdSelect.prototype._setSelectionByValue = function (value) {
        var _this = this;
        var /** @type {?} */ isArray = Array.isArray(value);
        if (this.multiple && value && !isArray) {
            throw new MdSelectNonArrayValueError();
        }
        if (isArray) {
            this._clearSelection();
            value.forEach(function (currentValue) { return _this._selectValue(currentValue); });
            this._sortValues();
        }
        else if (!this._selectValue(value)) {
            this._clearSelection();
        }
        this._setValueWidth();
        if (this._selectionModel.isEmpty()) {
            this._placeholderState = '';
        }
        this._changeDetectorRef.markForCheck();
    };
    /**
     * Finds and selects and option based on its value.
     * @param {?} value
     * @return {?} Option that has the corresponding value.
     */
    MdSelect.prototype._selectValue = function (value) {
        var /** @type {?} */ correspondingOption = this.options.find(function (option) { return option.value === value; });
        if (correspondingOption) {
            correspondingOption.select();
            this._selectionModel.select(correspondingOption);
        }
        return correspondingOption;
    };
    /**
     * Clears the select trigger and deselects every option in the list.
     * @param {?=} skip Option that should not be deselected.
     * @return {?}
     */
    MdSelect.prototype._clearSelection = function (skip) {
        this._selectionModel.clear();
        this.options.forEach(function (option) {
            if (option !== skip) {
                option.deselect();
            }
        });
    };
    /**
     * @return {?}
     */
    MdSelect.prototype._getTriggerRect = function () {
        return this.trigger.nativeElement.getBoundingClientRect();
    };
    /**
     * Sets up a key manager to listen to keyboard events on the overlay panel.
     * @return {?}
     */
    MdSelect.prototype._initKeyManager = function () {
        var _this = this;
        this._keyManager = new FocusKeyManager(this.options);
        this._tabSubscription = this._keyManager.tabOut.subscribe(function () { return _this.close(); });
    };
    /**
     * Drops current option subscriptions and IDs and resets from scratch.
     * @return {?}
     */
    MdSelect.prototype._resetOptions = function () {
        this._dropSubscriptions();
        this._listenToOptions();
        this._setOptionIds();
        this._setOptionMultiple();
    };
    /**
     * Listens to user-generated selection events on each option.
     * @return {?}
     */
    MdSelect.prototype._listenToOptions = function () {
        var _this = this;
        this._optionSubscription = this.optionSelectionChanges
            .filter(function (event) { return event.isUserInput; })
            .subscribe(function (event) {
            _this._onSelect(event.source);
            _this._setValueWidth();
            if (!_this.multiple) {
                _this.close();
            }
        });
    };
    /**
     * Invoked when an option is clicked.
     * @param {?} option
     * @return {?}
     */
    MdSelect.prototype._onSelect = function (option) {
        var /** @type {?} */ wasSelected = this._selectionModel.isSelected(option);
        if (this.multiple) {
            this._selectionModel.toggle(option);
            wasSelected ? option.deselect() : option.select();
            this._sortValues();
        }
        else {
            this._clearSelection(option);
            this._selectionModel.select(option);
        }
        if (wasSelected !== this._selectionModel.isSelected(option)) {
            this._propagateChanges();
        }
    };
    /**
     * Sorts the model values, ensuring that they keep the same
     * order that they have in the panel.
     * @return {?}
     */
    MdSelect.prototype._sortValues = function () {
        var _this = this;
        if (this._multiple) {
            this._selectionModel.clear();
            this.options.forEach(function (option) {
                if (option.selected) {
                    _this._selectionModel.select(option);
                }
            });
        }
    };
    /**
     * Unsubscribes from all option subscriptions.
     * @return {?}
     */
    MdSelect.prototype._dropSubscriptions = function () {
        if (this._optionSubscription) {
            this._optionSubscription.unsubscribe();
            this._optionSubscription = null;
        }
    };
    /**
     * Emits change event to set the model value.
     * @return {?}
     */
    MdSelect.prototype._propagateChanges = function () {
        var /** @type {?} */ valueToEmit = Array.isArray(this.selected) ?
            this.selected.map(function (option) { return option.value; }) :
            this.selected.value;
        this._onChange(valueToEmit);
        this.change.emit(new MdSelectChange(this, valueToEmit));
    };
    /**
     * Records option IDs to pass to the aria-owns property.
     * @return {?}
     */
    MdSelect.prototype._setOptionIds = function () {
        this._optionIds = this.options.map(function (option) { return option.id; }).join(' ');
    };
    /**
     * Sets the `multiple` property on each option. The promise is necessary
     * in order to avoid Angular errors when modifying the property after init.
     * TODO: there should be a better way of doing this.
     * @return {?}
     */
    MdSelect.prototype._setOptionMultiple = function () {
        var _this = this;
        if (this.multiple) {
            Promise.resolve(null).then(function () {
                _this.options.forEach(function (option) { return option.multiple = _this.multiple; });
            });
        }
    };
    /**
     * Must set the width of the selected option's value programmatically
     * because it is absolutely positioned and otherwise will not clip
     * overflow. The selection arrow is 9px wide, add 4px of padding = 13
     * @return {?}
     */
    MdSelect.prototype._setValueWidth = function () {
        this._selectedValueWidth = this._triggerWidth - 13;
    };
    /**
     * Focuses the selected item. If no option is selected, it will focus
     * the first item instead.
     * @return {?}
     */
    MdSelect.prototype._focusCorrectOption = function () {
        if (this._selectionModel.isEmpty()) {
            this._keyManager.setFirstItemActive();
        }
        else {
            this._keyManager.setActiveItem(this._getOptionIndex(this._selectionModel.selected[0]));
        }
    };
    /**
     * Focuses the host element when the panel closes.
     * @return {?}
     */
    MdSelect.prototype._focusHost = function () {
        this._renderer.invokeElementMethod(this._element.nativeElement, 'focus');
    };
    /**
     * Gets the index of the provided option in the option list.
     * @param {?} option
     * @return {?}
     */
    MdSelect.prototype._getOptionIndex = function (option) {
        return this.options.reduce(function (result, current, index) {
            return result === undefined ? (option === current ? index : undefined) : result;
        }, undefined);
    };
    /**
     * Calculates the scroll position and x- and y-offsets of the overlay panel.
     * @return {?}
     */
    MdSelect.prototype._calculateOverlayPosition = function () {
        this._offsetX = this.multiple ? SELECT_MULTIPLE_PANEL_PADDING_X : SELECT_PANEL_PADDING_X;
        if (!this._isRtl()) {
            this._offsetX *= -1;
        }
        var /** @type {?} */ panelHeight = Math.min(this.options.length * SELECT_OPTION_HEIGHT, SELECT_PANEL_MAX_HEIGHT);
        var /** @type {?} */ scrollContainerHeight = this.options.length * SELECT_OPTION_HEIGHT;
        // The farthest the panel can be scrolled before it hits the bottom
        var /** @type {?} */ maxScroll = scrollContainerHeight - panelHeight;
        if (this._selectionModel.hasValue()) {
            var /** @type {?} */ selectedIndex = this._getOptionIndex(this._selectionModel.selected[0]);
            // We must maintain a scroll buffer so the selected option will be scrolled to the
            // center of the overlay panel rather than the top.
            var /** @type {?} */ scrollBuffer = panelHeight / 2;
            this._scrollTop = this._calculateOverlayScroll(selectedIndex, scrollBuffer, maxScroll);
            this._offsetY = this._calculateOverlayOffset(selectedIndex, scrollBuffer, maxScroll);
        }
        else {
            // If no option is selected, the panel centers on the first option. In this case,
            // we must only adjust for the height difference between the option element
            // and the trigger element, then multiply it by -1 to ensure the panel moves
            // in the correct direction up the page.
            this._offsetY = (SELECT_OPTION_HEIGHT - SELECT_TRIGGER_HEIGHT) / 2 * -1;
        }
        this._checkOverlayWithinViewport(maxScroll);
    };
    /**
     * Calculates the scroll position of the select's overlay panel.
     *
     * Attempts to center the selected option in the panel. If the option is
     * too high or too low in the panel to be scrolled to the center, it clamps the
     * scroll position to the min or max scroll positions respectively.
     * @param {?} selectedIndex
     * @param {?} scrollBuffer
     * @param {?} maxScroll
     * @return {?}
     */
    MdSelect.prototype._calculateOverlayScroll = function (selectedIndex, scrollBuffer, maxScroll) {
        var /** @type {?} */ optionOffsetFromScrollTop = SELECT_OPTION_HEIGHT * selectedIndex;
        var /** @type {?} */ halfOptionHeight = SELECT_OPTION_HEIGHT / 2;
        // Starts at the optionOffsetFromScrollTop, which scrolls the option to the top of the
        // scroll container, then subtracts the scroll buffer to scroll the option down to
        // the center of the overlay panel. Half the option height must be re-added to the
        // scrollTop so the option is centered based on its middle, not its top edge.
        var /** @type {?} */ optimalScrollPosition = optionOffsetFromScrollTop - scrollBuffer + halfOptionHeight;
        return clampValue(0, optimalScrollPosition, maxScroll);
    };
    /**
     * Figures out the appropriate animation state for the placeholder.
     * @return {?}
     */
    MdSelect.prototype._getPlaceholderAnimationState = function () {
        if (this.floatPlaceholder === 'never') {
            return '';
        }
        if (this.floatPlaceholder === 'always') {
            return this._floatPlaceholderState();
        }
        return this._placeholderState;
    };
    /**
     * Determines the CSS `visibility` of the placeholder element.
     * @return {?}
     */
    MdSelect.prototype._getPlaceholderVisibility = function () {
        return (this.floatPlaceholder !== 'never' || this._selectionModel.isEmpty()) ?
            'visible' : 'hidden';
    };
    Object.defineProperty(MdSelect.prototype, "_ariaLabel", {
        /**
         * Returns the aria-label of the select component.
         * @return {?}
         */
        get: function () {
            // If an ariaLabelledby value has been set, the select should not overwrite the
            // `aria-labelledby` value by setting the ariaLabel to the placeholder.
            return this.ariaLabelledby ? null : this.ariaLabel || this.placeholder;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Calculates the y-offset of the select's overlay panel in relation to the
     * top start corner of the trigger. It has to be adjusted in order for the
     * selected option to be aligned over the trigger when the panel opens.
     * @param {?} selectedIndex
     * @param {?} scrollBuffer
     * @param {?} maxScroll
     * @return {?}
     */
    MdSelect.prototype._calculateOverlayOffset = function (selectedIndex, scrollBuffer, maxScroll) {
        var /** @type {?} */ optionOffsetFromPanelTop;
        if (this._scrollTop === 0) {
            optionOffsetFromPanelTop = selectedIndex * SELECT_OPTION_HEIGHT;
        }
        else if (this._scrollTop === maxScroll) {
            var /** @type {?} */ firstDisplayedIndex = this.options.length - SELECT_MAX_OPTIONS_DISPLAYED;
            var /** @type {?} */ selectedDisplayIndex = selectedIndex - firstDisplayedIndex;
            // Because the panel height is longer than the height of the options alone,
            // there is always extra padding at the top or bottom of the panel. When
            // scrolled to the very bottom, this padding is at the top of the panel and
            // must be added to the offset.
            optionOffsetFromPanelTop =
                selectedDisplayIndex * SELECT_OPTION_HEIGHT + SELECT_PANEL_PADDING_Y;
        }
        else {
            // If the option was scrolled to the middle of the panel using a scroll buffer,
            // its offset will be the scroll buffer minus the half height that was added to
            // center it.
            optionOffsetFromPanelTop = scrollBuffer - SELECT_OPTION_HEIGHT / 2;
        }
        // The final offset is the option's offset from the top, adjusted for the height
        // difference, multiplied by -1 to ensure that the overlay moves in the correct
        // direction up the page.
        return optionOffsetFromPanelTop * -1 - SELECT_OPTION_HEIGHT_ADJUSTMENT;
    };
    /**
     * Checks that the attempted overlay position will fit within the viewport.
     * If it will not fit, tries to adjust the scroll position and the associated
     * y-offset so the panel can open fully on-screen. If it still won't fit,
     * sets the offset back to 0 to allow the fallback position to take over.
     * @param {?} maxScroll
     * @return {?}
     */
    MdSelect.prototype._checkOverlayWithinViewport = function (maxScroll) {
        var /** @type {?} */ viewportRect = this._viewportRuler.getViewportRect();
        var /** @type {?} */ triggerRect = this._getTriggerRect();
        var /** @type {?} */ topSpaceAvailable = triggerRect.top - SELECT_PANEL_VIEWPORT_PADDING;
        var /** @type {?} */ bottomSpaceAvailable = viewportRect.height - triggerRect.bottom - SELECT_PANEL_VIEWPORT_PADDING;
        var /** @type {?} */ panelHeightTop = Math.abs(this._offsetY);
        var /** @type {?} */ totalPanelHeight = Math.min(this.options.length * SELECT_OPTION_HEIGHT, SELECT_PANEL_MAX_HEIGHT);
        var /** @type {?} */ panelHeightBottom = totalPanelHeight - panelHeightTop - triggerRect.height;
        if (panelHeightBottom > bottomSpaceAvailable) {
            this._adjustPanelUp(panelHeightBottom, bottomSpaceAvailable);
        }
        else if (panelHeightTop > topSpaceAvailable) {
            this._adjustPanelDown(panelHeightTop, topSpaceAvailable, maxScroll);
        }
        else {
            this._transformOrigin = this._getOriginBasedOnOption();
        }
    };
    /**
     * Adjusts the overlay panel up to fit in the viewport.
     * @param {?} panelHeightBottom
     * @param {?} bottomSpaceAvailable
     * @return {?}
     */
    MdSelect.prototype._adjustPanelUp = function (panelHeightBottom, bottomSpaceAvailable) {
        var /** @type {?} */ distanceBelowViewport = panelHeightBottom - bottomSpaceAvailable;
        // Scrolls the panel up by the distance it was extending past the boundary, then
        // adjusts the offset by that amount to move the panel up into the viewport.
        this._scrollTop -= distanceBelowViewport;
        this._offsetY -= distanceBelowViewport;
        this._transformOrigin = this._getOriginBasedOnOption();
        // If the panel is scrolled to the very top, it won't be able to fit the panel
        // by scrolling, so set the offset to 0 to allow the fallback position to take
        // effect.
        if (this._scrollTop <= 0) {
            this._scrollTop = 0;
            this._offsetY = 0;
            this._transformOrigin = "50% bottom 0px";
        }
    };
    /**
     * Adjusts the overlay panel down to fit in the viewport.
     * @param {?} panelHeightTop
     * @param {?} topSpaceAvailable
     * @param {?} maxScroll
     * @return {?}
     */
    MdSelect.prototype._adjustPanelDown = function (panelHeightTop, topSpaceAvailable, maxScroll) {
        var /** @type {?} */ distanceAboveViewport = panelHeightTop - topSpaceAvailable;
        // Scrolls the panel down by the distance it was extending past the boundary, then
        // adjusts the offset by that amount to move the panel down into the viewport.
        this._scrollTop += distanceAboveViewport;
        this._offsetY += distanceAboveViewport;
        this._transformOrigin = this._getOriginBasedOnOption();
        // If the panel is scrolled to the very bottom, it won't be able to fit the
        // panel by scrolling, so set the offset to 0 to allow the fallback position
        // to take effect.
        if (this._scrollTop >= maxScroll) {
            this._scrollTop = maxScroll;
            this._offsetY = 0;
            this._transformOrigin = "50% top 0px";
            return;
        }
    };
    /**
     * Sets the transform origin point based on the selected option.
     * @return {?}
     */
    MdSelect.prototype._getOriginBasedOnOption = function () {
        var /** @type {?} */ originY = Math.abs(this._offsetY) - SELECT_OPTION_HEIGHT_ADJUSTMENT + SELECT_OPTION_HEIGHT / 2;
        return "50% " + originY + "px 0px";
    };
    /**
     * Figures out the floating placeholder state value.
     * @return {?}
     */
    MdSelect.prototype._floatPlaceholderState = function () {
        return this._isRtl() ? 'floating-rtl' : 'floating-ltr';
    };
    return MdSelect;
}());
MdSelect.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{ selector: 'md-select, mat-select',
                template: "<div class=\"mat-select-trigger\" cdk-overlay-origin (click)=\"toggle()\" #origin=\"cdkOverlayOrigin\" #trigger> <span class=\"mat-select-placeholder\" [class.mat-floating-placeholder]=\"_selectionModel.hasValue()\" [@transformPlaceholder]=\"_getPlaceholderAnimationState()\" [style.visibility]=\"_getPlaceholderVisibility()\" [style.width.px]=\"_selectedValueWidth\"> {{ placeholder }} </span> <span class=\"mat-select-value\" *ngIf=\"_selectionModel.hasValue()\"> <span class=\"mat-select-value-text\">{{ triggerValue }}</span> </span> <span class=\"mat-select-arrow\"></span> <span class=\"mat-select-underline\"></span> </div> <ng-template cdk-connected-overlay [origin]=\"origin\" [open]=\"panelOpen\" hasBackdrop (backdropClick)=\"close()\" backdropClass=\"cdk-overlay-transparent-backdrop\" [positions]=\"_positions\" [minWidth]=\"_triggerWidth\" [offsetY]=\"_offsetY\" [offsetX]=\"_offsetX\" (attach)=\"_setScrollTop()\"> <div class=\"mat-select-panel\" [@transformPanel]=\"'showing'\" (@transformPanel.done)=\"_onPanelDone()\" (keydown)=\"_keyManager.onKeydown($event)\" [style.transformOrigin]=\"_transformOrigin\" [class.mat-select-panel-done-animating]=\"_panelDoneAnimating\"> <div class=\"mat-select-content\" [@fadeInContent]=\"'showing'\" (@fadeInContent.done)=\"_onFadeInDone()\"> <ng-content></ng-content> </div> </div> </ng-template> ",
                styles: [".mat-select{display:inline-block;outline:0;font-family:Roboto,\"Helvetica Neue\",sans-serif}.mat-select-trigger{display:flex;align-items:center;height:30px;min-width:112px;cursor:pointer;position:relative;box-sizing:border-box;font-size:16px}[aria-disabled=true] .mat-select-trigger{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:default}.mat-select-underline{position:absolute;bottom:0;left:0;right:0;height:1px}[aria-disabled=true] .mat-select-underline{background-image:linear-gradient(to right,rgba(0,0,0,.26) 0,rgba(0,0,0,.26) 33%,transparent 0);background-size:4px 1px;background-repeat:repeat-x;background-color:transparent;background-position:0 bottom}.mat-select-placeholder{position:relative;padding:0 2px;transform-origin:left top;flex-grow:1}.mat-select-placeholder.mat-floating-placeholder{top:-22px;left:-2px;text-align:left;transform:scale(.75)}[dir=rtl] .mat-select-placeholder{transform-origin:right top}[dir=rtl] .mat-select-placeholder.mat-floating-placeholder{left:2px;text-align:right}[aria-required=true] .mat-select-placeholder::after{content:'*'}.mat-select-value{position:absolute;max-width:calc(100% - 18px);flex-grow:1;top:0;left:0;bottom:0;display:flex;align-items:center}[dir=rtl] .mat-select-value{left:auto;right:0}.mat-select-value-text{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;line-height:30px}.mat-select-arrow{width:0;height:0;border-left:5px solid transparent;border-right:5px solid transparent;border-top:5px solid;margin:0 4px}.mat-select-panel{box-shadow:0 5px 5px -3px rgba(0,0,0,.2),0 8px 10px 1px rgba(0,0,0,.14),0 3px 14px 2px rgba(0,0,0,.12);min-width:112px;max-width:280px;overflow:auto;-webkit-overflow-scrolling:touch;padding-top:0;padding-bottom:0;max-height:256px;min-width:100%}@media screen and (-ms-high-contrast:active){.mat-select-panel{outline:solid 1px}} /*# sourceMappingURL=select.css.map */ "],
                encapsulation: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewEncapsulation"].None,
                host: {
                    'role': 'listbox',
                    '[attr.tabindex]': 'tabIndex',
                    '[attr.aria-label]': '_ariaLabel',
                    '[attr.aria-labelledby]': 'ariaLabelledby',
                    '[attr.aria-required]': 'required.toString()',
                    '[attr.aria-disabled]': 'disabled.toString()',
                    '[attr.aria-invalid]': '_control?.invalid || "false"',
                    '[attr.aria-owns]': '_optionIds',
                    '[class.mat-select-disabled]': 'disabled',
                    '[class.mat-select]': 'true',
                    '(keydown)': '_handleKeydown($event)',
                    '(blur)': '_onBlur()'
                },
                animations: [
                    transformPlaceholder,
                    transformPanel,
                    fadeInContent
                ],
                exportAs: 'mdSelect',
            },] },
];
/**
 * @nocollapse
 */
MdSelect.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
    { type: ViewportRuler, },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectorRef"], },
    { type: Dir, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] },] },
    { type: __WEBPACK_IMPORTED_MODULE_8__angular_forms__["e" /* NgControl */], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] },] },
    { type: undefined, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Attribute"], args: ['tabindex',] },] },
]; };
MdSelect.propDecorators = {
    'trigger': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewChild"], args: ['trigger',] },],
    'overlayDir': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewChild"], args: [ConnectedOverlayDirective,] },],
    'options': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ContentChildren"], args: [MdOption,] },],
    'placeholder': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'disabled': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'required': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'multiple': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'floatPlaceholder': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'tabIndex': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'ariaLabel': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['aria-label',] },],
    'ariaLabelledby': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['aria-labelledby',] },],
    'onOpen': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
    'onClose': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
    'change': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
};
/**
 * Clamps a value n between min and max values.
 * @param {?} min
 * @param {?} n
 * @param {?} max
 * @return {?}
 */
function clampValue(min, n, max) {
    return Math.min(Math.max(min, n), max);
}
var MdSelectModule = (function () {
    function MdSelectModule() {
    }
    /**
     * @deprecated
     * @return {?}
     */
    MdSelectModule.forRoot = function () {
        return {
            ngModule: MdSelectModule,
            providers: []
        };
    };
    return MdSelectModule;
}());
MdSelectModule.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{
                imports: [
                    __WEBPACK_IMPORTED_MODULE_2__angular_common__["CommonModule"],
                    OverlayModule,
                    MdOptionModule,
                    CompatibilityModule,
                ],
                exports: [MdSelect, MdOptionModule, CompatibilityModule],
                declarations: [MdSelect],
            },] },
];
/**
 * @nocollapse
 */
MdSelectModule.ctorParameters = function () { return []; };
var MD_SLIDE_TOGGLE_VALUE_ACCESSOR = {
    provide: __WEBPACK_IMPORTED_MODULE_8__angular_forms__["c" /* NG_VALUE_ACCESSOR */],
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return MdSlideToggle; }),
    multi: true
};
var MdSlideToggleChange = (function () {
    function MdSlideToggleChange() {
    }
    return MdSlideToggleChange;
}());
// Increasing integer for generating unique ids for slide-toggle components.
var nextId$1 = 0;
/**
 * Two-state control, which can be also called `switch`.
 */
var MdSlideToggle = (function () {
    /**
     * @param {?} _elementRef
     * @param {?} _renderer
     * @param {?} _focusOriginMonitor
     */
    function MdSlideToggle(_elementRef, _renderer, _focusOriginMonitor) {
        this._elementRef = _elementRef;
        this._renderer = _renderer;
        this._focusOriginMonitor = _focusOriginMonitor;
        this.onChange = function (_) { };
        this.onTouched = function () { };
        this._uniqueId = "md-slide-toggle-" + ++nextId$1;
        this._checked = false;
        this._isMousedown = false;
        this._slideRenderer = null;
        this._disabled = false;
        this._required = false;
        this._disableRipple = false;
        /** Name value will be applied to the input element if present */
        this.name = null;
        /** A unique id for the slide-toggle input. If none is supplied, it will be auto-generated. */
        this.id = this._uniqueId;
        /** Used to specify the tabIndex value for the underlying input element. */
        this.tabIndex = 0;
        /** Whether the label should appear after or before the slide-toggle. Defaults to 'after' */
        this.labelPosition = 'after';
        /** Used to set the aria-label attribute on the underlying input element. */
        this.ariaLabel = null;
        /** Used to set the aria-labelledby attribute on the underlying input element. */
        this.ariaLabelledby = null;
        this._change = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /** An event will be dispatched each time the slide-toggle changes its value. */
        this.change = this._change.asObservable();
    }
    Object.defineProperty(MdSlideToggle.prototype, "disabled", {
        /**
         * Whether the slide-toggle is disabled.
         * @return {?}
         */
        get: function () { return this._disabled; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this._disabled = coerceBooleanProperty(value); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdSlideToggle.prototype, "required", {
        /**
         * Whether the slide-toggle is required.
         * @return {?}
         */
        get: function () { return this._required; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this._required = coerceBooleanProperty(value); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdSlideToggle.prototype, "disableRipple", {
        /**
         * Whether the ripple effect for this slide-toggle is disabled.
         * @return {?}
         */
        get: function () { return this._disableRipple; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this._disableRipple = coerceBooleanProperty(value); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdSlideToggle.prototype, "inputId", {
        /**
         * Returns the unique id for the visual hidden input.
         * @return {?}
         */
        get: function () { return (this.id || this._uniqueId) + "-input"; },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    MdSlideToggle.prototype.ngAfterContentInit = function () {
        var _this = this;
        this._slideRenderer = new SlideToggleRenderer(this._elementRef);
        this._focusOriginMonitor
            .monitor(this._inputElement.nativeElement, this._renderer, false)
            .subscribe(function (focusOrigin) { return _this._onInputFocusChange(focusOrigin); });
    };
    /**
     * @return {?}
     */
    MdSlideToggle.prototype.ngOnDestroy = function () {
        this._focusOriginMonitor.stopMonitoring(this._inputElement.nativeElement);
    };
    /**
     * The onChangeEvent method will be also called on click.
     * This is because everything for the slide-toggle is wrapped inside of a label,
     * which triggers a onChange event on click.
     * @param {?} event
     * @return {?}
     */
    MdSlideToggle.prototype._onChangeEvent = function (event) {
        // We always have to stop propagation on the change event.
        // Otherwise the change event, from the input element, will bubble up and
        // emit its event object to the component's `change` output.
        event.stopPropagation();
        // Once a drag is currently in progress, we do not want to toggle the slide-toggle on a click.
        if (!this.disabled && !this._slideRenderer.dragging) {
            this.toggle();
            // Emit our custom change event if the native input emitted one.
            // It is important to only emit it, if the native input triggered one, because
            // we don't want to trigger a change event, when the `checked` variable changes for example.
            this._emitChangeEvent();
        }
    };
    /**
     * @param {?} event
     * @return {?}
     */
    MdSlideToggle.prototype._onInputClick = function (event) {
        this.onTouched();
        // We have to stop propagation for click events on the visual hidden input element.
        // By default, when a user clicks on a label element, a generated click event will be
        // dispatched on the associated input element. Since we are using a label element as our
        // root container, the click event on the `slide-toggle` will be executed twice.
        // The real click event will bubble up, and the generated click event also tries to bubble up.
        // This will lead to multiple click events.
        // Preventing bubbling for the second event will solve that issue.
        event.stopPropagation();
    };
    /**
     * @return {?}
     */
    MdSlideToggle.prototype._setMousedown = function () {
        var _this = this;
        // We only *show* the focus style when focus has come to the button via the keyboard.
        // The Material Design spec is silent on this topic, and without doing this, the
        // button continues to look :active after clicking.
        // @see http://marcysutton.com/button-focus-hell/
        this._isMousedown = true;
        setTimeout(function () { return _this._isMousedown = false; }, 100);
    };
    /**
     * Implemented as part of ControlValueAccessor.
     * @param {?} value
     * @return {?}
     */
    MdSlideToggle.prototype.writeValue = function (value) {
        this.checked = value;
    };
    /**
     * Implemented as part of ControlValueAccessor.
     * @param {?} fn
     * @return {?}
     */
    MdSlideToggle.prototype.registerOnChange = function (fn) {
        this.onChange = fn;
    };
    /**
     * Implemented as part of ControlValueAccessor.
     * @param {?} fn
     * @return {?}
     */
    MdSlideToggle.prototype.registerOnTouched = function (fn) {
        this.onTouched = fn;
    };
    /**
     * Implemented as a part of ControlValueAccessor.
     * @param {?} isDisabled
     * @return {?}
     */
    MdSlideToggle.prototype.setDisabledState = function (isDisabled) {
        this.disabled = isDisabled;
    };
    /**
     * Focuses the slide-toggle.
     * @return {?}
     */
    MdSlideToggle.prototype.focus = function () {
        this._focusOriginMonitor.focusVia(this._inputElement.nativeElement, this._renderer, 'program');
    };
    Object.defineProperty(MdSlideToggle.prototype, "checked", {
        /**
         * Whether the slide-toggle is checked.
         * @return {?}
         */
        get: function () { return !!this._checked; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            if (this.checked !== !!value) {
                this._checked = value;
                this.onChange(this._checked);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdSlideToggle.prototype, "color", {
        /**
         * The color of the slide-toggle. Can be primary, accent, or warn.
         * @return {?}
         */
        get: function () { return this._color; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._updateColor(value);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Toggles the checked state of the slide-toggle.
     * @return {?}
     */
    MdSlideToggle.prototype.toggle = function () {
        this.checked = !this.checked;
    };
    /**
     * Function is called whenever the focus changes for the input element.
     * @param {?} focusOrigin
     * @return {?}
     */
    MdSlideToggle.prototype._onInputFocusChange = function (focusOrigin) {
        if (!this._focusRipple && focusOrigin === 'keyboard') {
            // For keyboard focus show a persistent ripple as focus indicator.
            this._focusRipple = this._ripple.launch(0, 0, { persistent: true, centered: true });
        }
        else if (!focusOrigin) {
            this.onTouched();
            // Fade out and clear the focus ripple if one is currently present.
            if (this._focusRipple) {
                this._focusRipple.fadeOut();
                this._focusRipple = null;
            }
        }
    };
    /**
     * @param {?} newColor
     * @return {?}
     */
    MdSlideToggle.prototype._updateColor = function (newColor) {
        this._setElementColor(this._color, false);
        this._setElementColor(newColor, true);
        this._color = newColor;
    };
    /**
     * @param {?} color
     * @param {?} isAdd
     * @return {?}
     */
    MdSlideToggle.prototype._setElementColor = function (color, isAdd) {
        if (color != null && color != '') {
            this._renderer.setElementClass(this._elementRef.nativeElement, "mat-" + color, isAdd);
        }
    };
    /**
     * Emits the change event to the `change` output EventEmitter
     * @return {?}
     */
    MdSlideToggle.prototype._emitChangeEvent = function () {
        var /** @type {?} */ event = new MdSlideToggleChange();
        event.source = this;
        event.checked = this.checked;
        this._change.emit(event);
    };
    /**
     * @return {?}
     */
    MdSlideToggle.prototype._onDragStart = function () {
        if (!this.disabled) {
            this._slideRenderer.startThumbDrag(this.checked);
        }
    };
    /**
     * @param {?} event
     * @return {?}
     */
    MdSlideToggle.prototype._onDrag = function (event) {
        if (this._slideRenderer.dragging) {
            this._slideRenderer.updateThumbPosition(event.deltaX);
        }
    };
    /**
     * @return {?}
     */
    MdSlideToggle.prototype._onDragEnd = function () {
        var _this = this;
        if (this._slideRenderer.dragging) {
            var /** @type {?} */ _previousChecked = this.checked;
            this.checked = this._slideRenderer.dragPercentage > 50;
            if (_previousChecked !== this.checked) {
                this._emitChangeEvent();
            }
            // The drag should be stopped outside of the current event handler, because otherwise the
            // click event will be fired before and will revert the drag change.
            setTimeout(function () { return _this._slideRenderer.stopThumbDrag(); });
        }
    };
    return MdSlideToggle;
}());
MdSlideToggle.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{ selector: 'md-slide-toggle, mat-slide-toggle',
                host: {
                    '[class.mat-slide-toggle]': 'true',
                    '[class.mat-checked]': 'checked',
                    '[class.mat-disabled]': 'disabled',
                    '[class.mat-slide-toggle-label-before]': 'labelPosition == "before"',
                    '(mousedown)': '_setMousedown()'
                },
                template: "<label class=\"mat-slide-toggle-label\" #label> <div class=\"mat-slide-toggle-bar\"> <input #input class=\"mat-slide-toggle-input cdk-visually-hidden\" type=\"checkbox\" [id]=\"inputId\" [required]=\"required\" [tabIndex]=\"tabIndex\" [checked]=\"checked\" [disabled]=\"disabled\" [attr.name]=\"name\" [attr.aria-label]=\"ariaLabel\" [attr.aria-labelledby]=\"ariaLabelledby\" (change)=\"_onChangeEvent($event)\" (click)=\"_onInputClick($event)\"> <div class=\"mat-slide-toggle-thumb-container\" (slidestart)=\"_onDragStart()\" (slide)=\"_onDrag($event)\" (slideend)=\"_onDragEnd()\"> <div class=\"mat-slide-toggle-thumb\"></div> <div class=\"mat-slide-toggle-ripple\" md-ripple [mdRippleTrigger]=\"label\" [mdRippleCentered]=\"true\" [mdRippleDisabled]=\"disableRipple || disabled\"> </div> </div> </div> <span class=\"mat-slide-toggle-content\"> <ng-content></ng-content> </span> </label> ",
                styles: [".mat-slide-toggle{display:inline-block;height:24px;line-height:24px;white-space:nowrap;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;outline:0}.mat-slide-toggle.mat-checked .mat-slide-toggle-thumb-container{transform:translate3d(16px,0,0)}.mat-slide-toggle.mat-disabled .mat-slide-toggle-label,.mat-slide-toggle.mat-disabled .mat-slide-toggle-thumb-container{cursor:default}.mat-slide-toggle-content{font-size:14px;font-family:Roboto,\"Helvetica Neue\",sans-serif;font-weight:500}.mat-slide-toggle-label{display:flex;flex:1;flex-direction:row;align-items:center;cursor:pointer}.mat-slide-toggle-label-before .mat-slide-toggle-label{order:1}.mat-slide-toggle-label-before .mat-slide-toggle-bar{order:2}.mat-slide-toggle-bar,[dir=rtl] .mat-slide-toggle-label-before .mat-slide-toggle-bar{margin-right:8px;margin-left:0}.mat-slide-toggle-label-before .mat-slide-toggle-bar,[dir=rtl] .mat-slide-toggle-bar{margin-left:8px;margin-right:0}.mat-slide-toggle-thumb-container{position:absolute;z-index:1;width:20px;height:20px;top:-3px;left:0;transform:translate3d(0,0,0);transition:all 80ms linear;transition-property:transform;cursor:-webkit-grab;cursor:grab}.mat-slide-toggle-thumb-container.mat-dragging{transition-duration:0s}.mat-slide-toggle-thumb{height:20px;width:20px;border-radius:50%;box-shadow:0 2px 1px -1px rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 1px 3px 0 rgba(0,0,0,.12)}@media screen and (-ms-high-contrast:active){.mat-slide-toggle-thumb{background:#fff;border:solid 1px #000}}.mat-slide-toggle-bar{position:relative;width:36px;height:14px;border-radius:8px}@media screen and (-ms-high-contrast:active){.mat-slide-toggle-bar{background:#fff}}.mat-slide-toggle-input{bottom:0;left:10px}.mat-slide-toggle-bar,.mat-slide-toggle-thumb{transition:all 80ms linear;transition-property:background-color;transition-delay:50ms}.mat-slide-toggle-ripple{position:absolute;top:-13px;left:-13px;height:46px;width:46px;border-radius:50%;z-index:1;pointer-events:none} /*# sourceMappingURL=slide-toggle.css.map */ "],
                providers: [MD_SLIDE_TOGGLE_VALUE_ACCESSOR],
                encapsulation: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewEncapsulation"].None,
                changeDetection: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectionStrategy"].OnPush
            },] },
];
/**
 * @nocollapse
 */
MdSlideToggle.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
    { type: FocusOriginMonitor, },
]; };
MdSlideToggle.propDecorators = {
    'name': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'id': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'tabIndex': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'labelPosition': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'ariaLabel': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['aria-label',] },],
    'ariaLabelledby': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['aria-labelledby',] },],
    'disabled': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'required': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'disableRipple': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'change': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
    '_inputElement': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewChild"], args: ['input',] },],
    '_ripple': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewChild"], args: [MdRipple,] },],
    'checked': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'color': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
};
/**
 * Renderer for the Slide Toggle component, which separates DOM modification in its own class
 */
var SlideToggleRenderer = (function () {
    /**
     * @param {?} _elementRef
     */
    function SlideToggleRenderer(_elementRef) {
        this._elementRef = _elementRef;
        /** Whether the thumb is currently being dragged. */
        this.dragging = false;
        this._thumbEl = _elementRef.nativeElement.querySelector('.mat-slide-toggle-thumb-container');
        this._thumbBarEl = _elementRef.nativeElement.querySelector('.mat-slide-toggle-bar');
    }
    /**
     * Initializes the drag of the slide-toggle.
     * @param {?} checked
     * @return {?}
     */
    SlideToggleRenderer.prototype.startThumbDrag = function (checked) {
        if (this.dragging) {
            return;
        }
        this._thumbBarWidth = this._thumbBarEl.clientWidth - this._thumbEl.clientWidth;
        this._thumbEl.classList.add('mat-dragging');
        this._previousChecked = checked;
        this.dragging = true;
    };
    /**
     * Resets the current drag and returns the new checked value.
     * @return {?}
     */
    SlideToggleRenderer.prototype.stopThumbDrag = function () {
        if (!this.dragging) {
            return;
        }
        this.dragging = false;
        this._thumbEl.classList.remove('mat-dragging');
        // Reset the transform because the component will take care of the thumb position after drag.
        applyCssTransform(this._thumbEl, '');
        return this.dragPercentage > 50;
    };
    /**
     * Updates the thumb containers position from the specified distance.
     * @param {?} distance
     * @return {?}
     */
    SlideToggleRenderer.prototype.updateThumbPosition = function (distance) {
        this.dragPercentage = this._getDragPercentage(distance);
        // Calculate the moved distance based on the thumb bar width.
        var /** @type {?} */ dragX = (this.dragPercentage / 100) * this._thumbBarWidth;
        applyCssTransform(this._thumbEl, "translate3d(" + dragX + "px, 0, 0)");
    };
    /**
     * Retrieves the percentage of thumb from the moved distance. Percentage as fraction of 100.
     * @param {?} distance
     * @return {?}
     */
    SlideToggleRenderer.prototype._getDragPercentage = function (distance) {
        var /** @type {?} */ percentage = (distance / this._thumbBarWidth) * 100;
        // When the toggle was initially checked, then we have to start the drag at the end.
        if (this._previousChecked) {
            percentage += 100;
        }
        return Math.max(0, Math.min(percentage, 100));
    };
    return SlideToggleRenderer;
}());
var MdSlideToggleModule = (function () {
    function MdSlideToggleModule() {
    }
    /**
     * @deprecated
     * @return {?}
     */
    MdSlideToggleModule.forRoot = function () {
        return {
            ngModule: MdSlideToggleModule,
            providers: []
        };
    };
    return MdSlideToggleModule;
}());
MdSlideToggleModule.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{
                imports: [__WEBPACK_IMPORTED_MODULE_8__angular_forms__["d" /* FormsModule */], MdRippleModule, CompatibilityModule],
                exports: [MdSlideToggle, CompatibilityModule],
                declarations: [MdSlideToggle],
                providers: [
                    FOCUS_ORIGIN_MONITOR_PROVIDER,
                    { provide: __WEBPACK_IMPORTED_MODULE_1__angular_platform_browser__["HAMMER_GESTURE_CONFIG"], useClass: GestureConfig }
                ],
            },] },
];
/**
 * @nocollapse
 */
MdSlideToggleModule.ctorParameters = function () { return []; };
/**
 * Visually, a 30px separation between tick marks looks best. This is very subjective but it is
 * the default separation we chose.
 */
var MIN_AUTO_TICK_SEPARATION = 30;
/** The thumb gap size for a disabled slider. */
var DISABLED_THUMB_GAP = 7;
/** The thumb gap size for a non-active slider at its minimum value. */
var MIN_VALUE_NONACTIVE_THUMB_GAP = 7;
/** The thumb gap size for an active slider at its minimum value. */
var MIN_VALUE_ACTIVE_THUMB_GAP = 10;
/**
 * Provider Expression that allows md-slider to register as a ControlValueAccessor.
 * This allows it to support [(ngModel)] and [formControl].
 */
var MD_SLIDER_VALUE_ACCESSOR = {
    provide: __WEBPACK_IMPORTED_MODULE_8__angular_forms__["c" /* NG_VALUE_ACCESSOR */],
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return MdSlider; }),
    multi: true
};
/**
 * A simple change event emitted by the MdSlider component.
 */
var MdSliderChange = (function () {
    function MdSliderChange() {
    }
    return MdSliderChange;
}());
/**
 * Allows users to select from a range of values by moving the slider thumb. It is similar in
 * behavior to the native `<input type="range">` element.
 */
var MdSlider = (function () {
    /**
     * @param {?} renderer
     * @param {?} _elementRef
     * @param {?} _focusOriginMonitor
     * @param {?} _dir
     */
    function MdSlider(renderer, _elementRef, _focusOriginMonitor, _dir) {
        var _this = this;
        this._elementRef = _elementRef;
        this._focusOriginMonitor = _focusOriginMonitor;
        this._dir = _dir;
        this._disabled = false;
        this._invert = false;
        this._max = 100;
        this._min = 0;
        this._step = 1;
        this._thumbLabel = false;
        this._tickInterval = 0;
        this._value = null;
        this._vertical = false;
        this.color = 'accent';
        /** Event emitted when the slider value has changed. */
        this.change = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /** Event emitted when the slider thumb moves. */
        this.input = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /** onTouch function registered via registerOnTouch (ControlValueAccessor). */
        this.onTouched = function () { };
        this._percent = 0;
        /**
         * Whether or not the thumb is sliding.
         * Used to determine if there should be a transition for the thumb and fill track.
         */
        this._isSliding = false;
        /**
         * Whether or not the slider is active (clicked or sliding).
         * Used to shrink and grow the thumb as according to the Material Design spec.
         */
        this._isActive = false;
        this._tickIntervalPercent = 0;
        this._renderer = null;
        this._sliderDimensions = null;
        this._controlValueAccessorChangeFn = function () { };
        this._lastChangeValue = null;
        this._lastInputValue = null;
        this._focusOriginMonitor.monitor(this._elementRef.nativeElement, renderer, true)
            .subscribe(function (origin) { return _this._isActive = !!origin && origin !== 'keyboard'; });
        this._renderer = new SliderRenderer(this._elementRef);
    }
    Object.defineProperty(MdSlider.prototype, "disabled", {
        /**
         * Whether or not the slider is disabled.
         * @return {?}
         */
        get: function () { return this._disabled; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this._disabled = coerceBooleanProperty(value); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdSlider.prototype, "invert", {
        /**
         * Whether the slider is inverted.
         * @return {?}
         */
        get: function () { return this._invert; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this._invert = coerceBooleanProperty(value); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdSlider.prototype, "max", {
        /**
         * The maximum value that the slider can have.
         * @return {?}
         */
        get: function () {
            return this._max;
        },
        /**
         * @param {?} v
         * @return {?}
         */
        set: function (v) {
            this._max = coerceNumberProperty(v, this._max);
            this._percent = this._calculatePercentage(this._value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdSlider.prototype, "min", {
        /**
         * The minimum value that the slider can have.
         * @return {?}
         */
        get: function () {
            return this._min;
        },
        /**
         * @param {?} v
         * @return {?}
         */
        set: function (v) {
            this._min = coerceNumberProperty(v, this._min);
            // If the value wasn't explicitly set by the user, set it to the min.
            if (this._value === null) {
                this.value = this._min;
            }
            this._percent = this._calculatePercentage(this._value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdSlider.prototype, "step", {
        /**
         * The values at which the thumb will snap.
         * @return {?}
         */
        get: function () { return this._step; },
        /**
         * @param {?} v
         * @return {?}
         */
        set: function (v) {
            this._step = coerceNumberProperty(v, this._step);
            if (this._step % 1 !== 0) {
                this._roundLabelTo = this._step.toString().split('.').pop().length;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdSlider.prototype, "thumbLabel", {
        /**
         * Whether or not to show the thumb label.
         * @return {?}
         */
        get: function () { return this._thumbLabel; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this._thumbLabel = coerceBooleanProperty(value); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdSlider.prototype, "_thumbLabelDeprecated", {
        /**
         * @deprecated
         * @return {?}
         */
        get: function () { return this._thumbLabel; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this._thumbLabel = value; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdSlider.prototype, "tickInterval", {
        /**
         * How often to show ticks. Relative to the step so that a tick always appears on a step.
         * Ex: Tick interval of 4 with a step of 3 will draw a tick every 4 steps (every 12 values).
         * @return {?}
         */
        get: function () { return this._tickInterval; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            if (value === 'auto') {
                this._tickInterval = 'auto';
            }
            else if (typeof value === 'number' || typeof value === 'string') {
                this._tickInterval = coerceNumberProperty(value, /** @type {?} */ (this._tickInterval));
            }
            else {
                this._tickInterval = 0;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdSlider.prototype, "_tickIntervalDeprecated", {
        /**
         * @deprecated
         * @return {?}
         */
        get: function () { return this.tickInterval; },
        /**
         * @param {?} v
         * @return {?}
         */
        set: function (v) { this.tickInterval = v; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdSlider.prototype, "value", {
        /**
         * Value of the slider.
         * @return {?}
         */
        get: function () {
            // If the value needs to be read and it is still uninitialized, initialize it to the min.
            if (this._value === null) {
                this.value = this._min;
            }
            return this._value;
        },
        /**
         * @param {?} v
         * @return {?}
         */
        set: function (v) {
            this._value = coerceNumberProperty(v, this._value);
            this._percent = this._calculatePercentage(this._value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdSlider.prototype, "vertical", {
        /**
         * Whether the slider is vertical.
         * @return {?}
         */
        get: function () { return this._vertical; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this._vertical = coerceBooleanProperty(value); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdSlider.prototype, "displayValue", {
        /**
         * The value to be used for display purposes.
         * @return {?}
         */
        get: function () {
            // Note that this could be improved further by rounding something like 0.999 to 1 or
            // 0.899 to 0.9, however it is very performance sensitive, because it gets called on
            // every change detection cycle.
            if (this._roundLabelTo && this.value % 1 !== 0) {
                return this.value.toFixed(this._roundLabelTo);
            }
            return this.value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdSlider.prototype, "percent", {
        /**
         * The percentage of the slider that coincides with the value.
         * @return {?}
         */
        get: function () { return this._clamp(this._percent); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdSlider.prototype, "_invertAxis", {
        /**
         * Whether the axis of the slider is inverted.
         * (i.e. whether moving the thumb in the positive x or y direction decreases the slider's value).
         * @return {?}
         */
        get: function () {
            // Standard non-inverted mode for a vertical slider should be dragging the thumb from bottom to
            // top. However from a y-axis standpoint this is inverted.
            return this.vertical ? !this.invert : this.invert;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdSlider.prototype, "_isMinValue", {
        /**
         * Whether the slider is at its minimum value.
         * @return {?}
         */
        get: function () {
            return this.percent === 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdSlider.prototype, "_thumbGap", {
        /**
         * The amount of space to leave between the slider thumb and the track fill & track background
         * elements.
         * @return {?}
         */
        get: function () {
            if (this.disabled) {
                return DISABLED_THUMB_GAP;
            }
            if (this._isMinValue && !this.thumbLabel) {
                return this._isActive ? MIN_VALUE_ACTIVE_THUMB_GAP : MIN_VALUE_NONACTIVE_THUMB_GAP;
            }
            return 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdSlider.prototype, "_trackBackgroundStyles", {
        /**
         * CSS styles for the track background element.
         * @return {?}
         */
        get: function () {
            var /** @type {?} */ axis = this.vertical ? 'Y' : 'X';
            var /** @type {?} */ sign = this._invertMouseCoords ? '-' : '';
            return {
                'transform': "translate" + axis + "(" + sign + this._thumbGap + "px) scale" + axis + "(" + (1 - this.percent) + ")"
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdSlider.prototype, "_trackFillStyles", {
        /**
         * CSS styles for the track fill element.
         * @return {?}
         */
        get: function () {
            var /** @type {?} */ axis = this.vertical ? 'Y' : 'X';
            var /** @type {?} */ sign = this._invertMouseCoords ? '' : '-';
            return {
                'transform': "translate" + axis + "(" + sign + this._thumbGap + "px) scale" + axis + "(" + this.percent + ")"
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdSlider.prototype, "_ticksContainerStyles", {
        /**
         * CSS styles for the ticks container element.
         * @return {?}
         */
        get: function () {
            var /** @type {?} */ axis = this.vertical ? 'Y' : 'X';
            // For a horizontal slider in RTL languages we push the ticks container off the left edge
            // instead of the right edge to avoid causing a horizontal scrollbar to appear.
            var /** @type {?} */ sign = !this.vertical && this._direction == 'rtl' ? '' : '-';
            var /** @type {?} */ offset = this._tickIntervalPercent / 2 * 100;
            return {
                'transform': "translate" + axis + "(" + sign + offset + "%)"
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdSlider.prototype, "_ticksStyles", {
        /**
         * CSS styles for the ticks element.
         * @return {?}
         */
        get: function () {
            var /** @type {?} */ tickSize = this._tickIntervalPercent * 100;
            var /** @type {?} */ backgroundSize = this.vertical ? "2px " + tickSize + "%" : tickSize + "% 2px";
            var /** @type {?} */ axis = this.vertical ? 'Y' : 'X';
            // Depending on the direction we pushed the ticks container, push the ticks the opposite
            // direction to re-center them but clip off the end edge. In RTL languages we need to flip the
            // ticks 180 degrees so we're really cutting off the end edge abd not the start.
            var /** @type {?} */ sign = !this.vertical && this._direction == 'rtl' ? '-' : '';
            var /** @type {?} */ rotate = !this.vertical && this._direction == 'rtl' ? ' rotate(180deg)' : '';
            var /** @type {?} */ styles = {
                'backgroundSize': backgroundSize,
                // Without translateZ ticks sometimes jitter as the slider moves on Chrome & Firefox.
                'transform': "translateZ(0) translate" + axis + "(" + sign + tickSize / 2 + "%)" + rotate
            };
            if (this._isMinValue && this._thumbGap) {
                var /** @type {?} */ side = this.vertical ?
                    (this._invertAxis ? 'Bottom' : 'Top') :
                    (this._invertAxis ? 'Right' : 'Left');
                styles["padding" + side] = this._thumbGap + "px";
            }
            return styles;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdSlider.prototype, "_thumbContainerStyles", {
        /**
         * @return {?}
         */
        get: function () {
            var /** @type {?} */ axis = this.vertical ? 'Y' : 'X';
            // For a horizontal slider in RTL languages we push the thumb container off the left edge
            // instead of the right edge to avoid causing a horizontal scrollbar to appear.
            var /** @type {?} */ invertOffset = (this._direction == 'rtl' && !this.vertical) ? !this._invertAxis : this._invertAxis;
            var /** @type {?} */ offset = (invertOffset ? this.percent : 1 - this.percent) * 100;
            return {
                'transform': "translate" + axis + "(-" + offset + "%)"
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdSlider.prototype, "_invertMouseCoords", {
        /**
         * Whether mouse events should be converted to a slider position by calculating their distance
         * from the right or bottom edge of the slider as opposed to the top or left.
         * @return {?}
         */
        get: function () {
            return (this._direction == 'rtl' && !this.vertical) ? !this._invertAxis : this._invertAxis;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdSlider.prototype, "_direction", {
        /**
         * The language direction for this slider element.
         * @return {?}
         */
        get: function () {
            return (this._dir && this._dir.value == 'rtl') ? 'rtl' : 'ltr';
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    MdSlider.prototype.ngOnDestroy = function () {
        this._focusOriginMonitor.stopMonitoring(this._elementRef.nativeElement);
    };
    /**
     * @return {?}
     */
    MdSlider.prototype._onMouseenter = function () {
        if (this.disabled) {
            return;
        }
        // We save the dimensions of the slider here so we can use them to update the spacing of the
        // ticks and determine where on the slider click and slide events happen.
        this._sliderDimensions = this._renderer.getSliderDimensions();
        this._updateTickIntervalPercent();
    };
    /**
     * @param {?} event
     * @return {?}
     */
    MdSlider.prototype._onClick = function (event) {
        if (this.disabled) {
            return;
        }
        this._isSliding = false;
        this._renderer.addFocus();
        this._updateValueFromPosition({ x: event.clientX, y: event.clientY });
        /* Emits a change and input event if the value changed. */
        this._emitInputEvent();
        this._emitValueIfChanged();
    };
    /**
     * @param {?} event
     * @return {?}
     */
    MdSlider.prototype._onSlide = function (event) {
        if (this.disabled) {
            return;
        }
        // Prevent the slide from selecting anything else.
        event.preventDefault();
        this._updateValueFromPosition({ x: event.center.x, y: event.center.y });
        // Native range elements always emit `input` events when the value changed while sliding.
        this._emitInputEvent();
    };
    /**
     * @param {?} event
     * @return {?}
     */
    MdSlider.prototype._onSlideStart = function (event) {
        if (this.disabled) {
            return;
        }
        // Simulate mouseenter in case this is a mobile device.
        this._onMouseenter();
        event.preventDefault();
        this._isSliding = true;
        this._renderer.addFocus();
        this._updateValueFromPosition({ x: event.center.x, y: event.center.y });
    };
    /**
     * @return {?}
     */
    MdSlider.prototype._onSlideEnd = function () {
        this._isSliding = false;
        this._emitValueIfChanged();
    };
    /**
     * @return {?}
     */
    MdSlider.prototype._onFocus = function () {
        // We save the dimensions of the slider here so we can use them to update the spacing of the
        // ticks and determine where on the slider click and slide events happen.
        this._sliderDimensions = this._renderer.getSliderDimensions();
        this._updateTickIntervalPercent();
    };
    /**
     * @return {?}
     */
    MdSlider.prototype._onBlur = function () {
        this.onTouched();
    };
    /**
     * @param {?} event
     * @return {?}
     */
    MdSlider.prototype._onKeydown = function (event) {
        if (this.disabled) {
            return;
        }
        switch (event.keyCode) {
            case PAGE_UP:
                this._increment(10);
                break;
            case PAGE_DOWN:
                this._increment(-10);
                break;
            case END:
                this.value = this.max;
                break;
            case HOME:
                this.value = this.min;
                break;
            case LEFT_ARROW:
                // NOTE: For a sighted user it would make more sense that when they press an arrow key on an
                // inverted slider the thumb moves in that direction. However for a blind user, nothing
                // about the slider indicates that it is inverted. They will expect left to be decrement,
                // regardless of how it appears on the screen. For speakers ofRTL languages, they probably
                // expect left to mean increment. Therefore we flip the meaning of the side arrow keys for
                // RTL. For inverted sliders we prefer a good a11y experience to having it "look right" for
                // sighted users, therefore we do not swap the meaning.
                this._increment(this._direction == 'rtl' ? 1 : -1);
                break;
            case UP_ARROW:
                this._increment(1);
                break;
            case RIGHT_ARROW:
                // See comment on LEFT_ARROW about the conditions under which we flip the meaning.
                this._increment(this._direction == 'rtl' ? -1 : 1);
                break;
            case DOWN_ARROW:
                this._increment(-1);
                break;
            default:
                // Return if the key is not one that we explicitly handle to avoid calling preventDefault on
                // it.
                return;
        }
        this._isSliding = true;
        event.preventDefault();
    };
    /**
     * @return {?}
     */
    MdSlider.prototype._onKeyup = function () {
        this._isSliding = false;
    };
    /**
     * Increments the slider by the given number of steps (negative number decrements).
     * @param {?} numSteps
     * @return {?}
     */
    MdSlider.prototype._increment = function (numSteps) {
        this.value = this._clamp(this.value + this.step * numSteps, this.min, this.max);
        this._emitInputEvent();
        this._emitValueIfChanged();
    };
    /**
     * Calculate the new value from the new physical location. The value will always be snapped.
     * @param {?} pos
     * @return {?}
     */
    MdSlider.prototype._updateValueFromPosition = function (pos) {
        if (!this._sliderDimensions) {
            return;
        }
        var /** @type {?} */ offset = this.vertical ? this._sliderDimensions.top : this._sliderDimensions.left;
        var /** @type {?} */ size = this.vertical ? this._sliderDimensions.height : this._sliderDimensions.width;
        var /** @type {?} */ posComponent = this.vertical ? pos.y : pos.x;
        // The exact value is calculated from the event and used to find the closest snap value.
        var /** @type {?} */ percent = this._clamp((posComponent - offset) / size);
        if (this._invertMouseCoords) {
            percent = 1 - percent;
        }
        var /** @type {?} */ exactValue = this._calculateValue(percent);
        // This calculation finds the closest step by finding the closest whole number divisible by the
        // step relative to the min.
        var /** @type {?} */ closestValue = Math.round((exactValue - this.min) / this.step) * this.step + this.min;
        // The value needs to snap to the min and max.
        this.value = this._clamp(closestValue, this.min, this.max);
    };
    /**
     * Emits a change event if the current value is different from the last emitted value.
     * @return {?}
     */
    MdSlider.prototype._emitValueIfChanged = function () {
        if (this.value != this._lastChangeValue) {
            var /** @type {?} */ event = this._createChangeEvent();
            this._lastChangeValue = this.value;
            this._controlValueAccessorChangeFn(this.value);
            this.change.emit(event);
        }
    };
    /**
     * Emits an input event when the current value is different from the last emitted value.
     * @return {?}
     */
    MdSlider.prototype._emitInputEvent = function () {
        if (this.value != this._lastInputValue) {
            var /** @type {?} */ event = this._createChangeEvent();
            this._lastInputValue = this.value;
            this.input.emit(event);
        }
    };
    /**
     * Updates the amount of space between ticks as a percentage of the width of the slider.
     * @return {?}
     */
    MdSlider.prototype._updateTickIntervalPercent = function () {
        if (!this.tickInterval) {
            return;
        }
        if (this.tickInterval == 'auto') {
            var /** @type {?} */ trackSize = this.vertical ? this._sliderDimensions.height : this._sliderDimensions.width;
            var /** @type {?} */ pixelsPerStep = trackSize * this.step / (this.max - this.min);
            var /** @type {?} */ stepsPerTick = Math.ceil(MIN_AUTO_TICK_SEPARATION / pixelsPerStep);
            var /** @type {?} */ pixelsPerTick = stepsPerTick * this.step;
            this._tickIntervalPercent = pixelsPerTick / trackSize;
        }
        else {
            this._tickIntervalPercent = this.tickInterval * this.step / (this.max - this.min);
        }
    };
    /**
     * Creates a slider change object from the specified value.
     * @param {?=} value
     * @return {?}
     */
    MdSlider.prototype._createChangeEvent = function (value) {
        if (value === void 0) { value = this.value; }
        var /** @type {?} */ event = new MdSliderChange();
        event.source = this;
        event.value = value;
        return event;
    };
    /**
     * Calculates the percentage of the slider that a value is.
     * @param {?} value
     * @return {?}
     */
    MdSlider.prototype._calculatePercentage = function (value) {
        return (value - this.min) / (this.max - this.min);
    };
    /**
     * Calculates the value a percentage of the slider corresponds to.
     * @param {?} percentage
     * @return {?}
     */
    MdSlider.prototype._calculateValue = function (percentage) {
        return this.min + percentage * (this.max - this.min);
    };
    /**
     * Return a number between two numbers.
     * @param {?} value
     * @param {?=} min
     * @param {?=} max
     * @return {?}
     */
    MdSlider.prototype._clamp = function (value, min, max) {
        if (min === void 0) { min = 0; }
        if (max === void 0) { max = 1; }
        return Math.max(min, Math.min(value, max));
    };
    /**
     * Sets the model value. Implemented as part of ControlValueAccessor.
     * @param {?} value
     * @return {?}
     */
    MdSlider.prototype.writeValue = function (value) {
        this.value = value;
    };
    /**
     * Registers a callback to eb triggered when the value has changed.
     * Implemented as part of ControlValueAccessor.
     * @param {?} fn Callback to be registered.
     * @return {?}
     */
    MdSlider.prototype.registerOnChange = function (fn) {
        this._controlValueAccessorChangeFn = fn;
    };
    /**
     * Registers a callback to be triggered when the component is touched.
     * Implemented as part of ControlValueAccessor.
     * @param {?} fn Callback to be registered.
     * @return {?}
     */
    MdSlider.prototype.registerOnTouched = function (fn) {
        this.onTouched = fn;
    };
    /**
     * Sets whether the component should be disabled.
     * Implemented as part of ControlValueAccessor.
     * @param {?} isDisabled
     * @return {?}
     */
    MdSlider.prototype.setDisabledState = function (isDisabled) {
        this.disabled = isDisabled;
    };
    return MdSlider;
}());
MdSlider.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{ selector: 'md-slider, mat-slider',
                providers: [MD_SLIDER_VALUE_ACCESSOR],
                host: {
                    '[class.mat-slider]': 'true',
                    '(focus)': '_onFocus()',
                    '(blur)': '_onBlur()',
                    '(click)': '_onClick($event)',
                    '(keydown)': '_onKeydown($event)',
                    '(keyup)': '_onKeyup()',
                    '(mouseenter)': '_onMouseenter()',
                    '(slide)': '_onSlide($event)',
                    '(slideend)': '_onSlideEnd()',
                    '(slidestart)': '_onSlideStart($event)',
                    'role': 'slider',
                    'tabindex': '0',
                    '[attr.aria-disabled]': 'disabled',
                    '[attr.aria-valuemax]': 'max',
                    '[attr.aria-valuemin]': 'min',
                    '[attr.aria-valuenow]': 'value',
                    '[class.mat-primary]': 'color == "primary"',
                    '[class.mat-accent]': 'color != "primary" && color != "warn"',
                    '[class.mat-warn]': 'color == "warn"',
                    '[class.mat-slider-disabled]': 'disabled',
                    '[class.mat-slider-has-ticks]': 'tickInterval',
                    '[class.mat-slider-horizontal]': '!vertical',
                    '[class.mat-slider-axis-inverted]': '_invertAxis',
                    '[class.mat-slider-sliding]': '_isSliding',
                    '[class.mat-slider-thumb-label-showing]': 'thumbLabel',
                    '[class.mat-slider-vertical]': 'vertical',
                    '[class.mat-slider-min-value]': '_isMinValue',
                    '[class.mat-slider-hide-last-tick]': 'disabled || _isMinValue && _thumbGap && _invertAxis',
                },
                template: "<div class=\"mat-slider-wrapper\"> <div class=\"mat-slider-track-wrapper\"> <div class=\"mat-slider-track-background\" [ngStyle]=\"_trackBackgroundStyles\"></div> <div class=\"mat-slider-track-fill\" [ngStyle]=\"_trackFillStyles\"></div> </div> <div class=\"mat-slider-ticks-container\" [ngStyle]=\"_ticksContainerStyles\"> <div class=\"mat-slider-ticks\" [ngStyle]=\"_ticksStyles\"></div> </div> <div class=\"mat-slider-thumb-container\" [ngStyle]=\"_thumbContainerStyles\"> <div class=\"mat-slider-focus-ring\"></div> <div class=\"mat-slider-thumb\"></div> <div class=\"mat-slider-thumb-label\"> <span class=\"mat-slider-thumb-label-text\">{{displayValue}}</span> </div> </div> </div> ",
                styles: [".mat-slider{display:inline-block;position:relative;box-sizing:border-box;padding:8px;outline:0;vertical-align:middle}.mat-slider-wrapper{position:absolute}.mat-slider-track-wrapper{position:absolute;top:0;left:0;overflow:hidden}.mat-slider-track-fill{position:absolute;transform-origin:0 0;transition:transform .4s cubic-bezier(.25,.8,.25,1),background-color .4s cubic-bezier(.25,.8,.25,1)}.mat-slider-track-background{position:absolute;transform-origin:100% 100%;transition:transform .4s cubic-bezier(.25,.8,.25,1),background-color .4s cubic-bezier(.25,.8,.25,1)}.mat-slider-ticks-container{position:absolute;left:0;top:0;overflow:hidden}.mat-slider-ticks{box-sizing:border-box;opacity:0;transition:opacity .4s cubic-bezier(.25,.8,.25,1)}.mat-slider-thumb-container{position:absolute;z-index:1;transition:transform .4s cubic-bezier(.25,.8,.25,1)}.mat-slider-focus-ring{position:absolute;width:30px;height:30px;border-radius:50%;transform:scale(0);opacity:0;transition:transform .4s cubic-bezier(.25,.8,.25,1),background-color .4s cubic-bezier(.25,.8,.25,1),opacity .4s cubic-bezier(.25,.8,.25,1)}.cdk-keyboard-focused .mat-slider-focus-ring{transform:scale(1);opacity:1}.mat-slider-thumb{position:absolute;right:-10px;bottom:-10px;box-sizing:border-box;width:20px;height:20px;border:3px solid transparent;border-radius:50%;transform:scale(.7);transition:transform .4s cubic-bezier(.25,.8,.25,1),background-color .4s cubic-bezier(.25,.8,.25,1),border-color .4s cubic-bezier(.25,.8,.25,1)}.mat-slider-thumb-label{display:none;align-items:center;justify-content:center;position:absolute;width:28px;height:28px;border-radius:50%;transition:transform .4s cubic-bezier(.25,.8,.25,1),border-radius .4s cubic-bezier(.25,.8,.25,1),background-color .4s cubic-bezier(.25,.8,.25,1)}.mat-slider-thumb-label-text{z-index:1;font-size:12px;font-weight:700;opacity:0;transition:opacity .4s cubic-bezier(.25,.8,.25,1)}.mat-slider-sliding .mat-slider-thumb-container,.mat-slider-sliding .mat-slider-track-background,.mat-slider-sliding .mat-slider-track-fill{transition-duration:0s}.mat-slider-has-ticks .mat-slider-wrapper::after{content:'';position:absolute;border:0 solid rgba(0,0,0,.6);opacity:0;transition:opacity .4s cubic-bezier(.25,.8,.25,1)}.mat-slider-has-ticks.cdk-focused:not(.mat-slider-hide-last-tick) .mat-slider-wrapper::after,.mat-slider-has-ticks:hover:not(.mat-slider-hide-last-tick) .mat-slider-wrapper::after{opacity:1}.mat-slider-has-ticks.cdk-focused:not(.mat-slider-disabled) .mat-slider-ticks,.mat-slider-has-ticks:hover:not(.mat-slider-disabled) .mat-slider-ticks{opacity:1}.mat-slider-thumb-label-showing .mat-slider-focus-ring{transform:scale(0);opacity:0}.mat-slider-thumb-label-showing .mat-slider-thumb-label{display:flex}.mat-slider-axis-inverted .mat-slider-track-fill{transform-origin:100% 100%}.mat-slider-axis-inverted .mat-slider-track-background{transform-origin:0 0}.cdk-focused.mat-slider-thumb-label-showing .mat-slider-thumb{transform:scale(0)}.cdk-focused .mat-slider-thumb-label{border-radius:50% 50% 0}.cdk-focused .mat-slider-thumb-label-text{opacity:1}.cdk-mouse-focused .mat-slider-thumb,.cdk-program-focused .mat-slider-thumb,.cdk-touch-focused .mat-slider-thumb{border-width:2px;transform:scale(1)}.mat-slider-disabled .mat-slider-focus-ring{transform:scale(0);opacity:0}.mat-slider-disabled .mat-slider-thumb{border-width:4px;transform:scale(.5)}.mat-slider-disabled .mat-slider-thumb-label{display:none}.mat-slider-horizontal{height:48px;min-width:128px}.mat-slider-horizontal .mat-slider-wrapper{height:2px;top:23px;left:8px;right:8px}.mat-slider-horizontal .mat-slider-wrapper::after{height:2px;border-left-width:2px;right:0;top:0}.mat-slider-horizontal .mat-slider-track-wrapper{height:2px;width:100%}.mat-slider-horizontal .mat-slider-track-fill{height:2px;width:100%;transform:scaleX(0)}.mat-slider-horizontal .mat-slider-track-background{height:2px;width:100%;transform:scaleX(1)}.mat-slider-horizontal .mat-slider-ticks-container{height:2px;width:100%}.mat-slider-horizontal .mat-slider-ticks{background:repeating-linear-gradient(to right,rgba(0,0,0,.6),rgba(0,0,0,.6) 2px,transparent 0,transparent) repeat;background:-moz-repeating-linear-gradient(.0001deg,rgba(0,0,0,.6),rgba(0,0,0,.6) 2px,transparent 0,transparent) repeat;background-clip:content-box;height:2px;width:100%}.mat-slider-horizontal .mat-slider-thumb-container{width:100%;height:0;top:50%}.mat-slider-horizontal .mat-slider-focus-ring{top:-15px;right:-15px}.mat-slider-horizontal .mat-slider-thumb-label{right:-14px;top:-40px;transform:translateY(26px) scale(.01) rotate(45deg)}.mat-slider-horizontal .mat-slider-thumb-label-text{transform:rotate(-45deg)}.mat-slider-horizontal.cdk-focused .mat-slider-thumb-label{transform:rotate(45deg)}.mat-slider-vertical{width:48px;min-height:128px}.mat-slider-vertical .mat-slider-wrapper{width:2px;top:8px;bottom:8px;left:23px}.mat-slider-vertical .mat-slider-wrapper::after{width:2px;border-top-width:2px;bottom:0;left:0}.mat-slider-vertical .mat-slider-track-wrapper{height:100%;width:2px}.mat-slider-vertical .mat-slider-track-fill{height:100%;width:2px;transform:scaleY(0)}.mat-slider-vertical .mat-slider-track-background{height:100%;width:2px;transform:scaleY(1)}.mat-slider-vertical .mat-slider-ticks-container{width:2px;height:100%}.mat-slider-vertical .mat-slider-focus-ring{bottom:-15px;left:-15px}.mat-slider-vertical .mat-slider-ticks{background:repeating-linear-gradient(to bottom,rgba(0,0,0,.6),rgba(0,0,0,.6) 2px,transparent 0,transparent) repeat;background-clip:content-box;width:2px;height:100%}.mat-slider-vertical .mat-slider-thumb-container{height:100%;width:0;left:50%}.mat-slider-vertical .mat-slider-thumb-label{bottom:-14px;left:-40px;transform:translateX(26px) scale(.01) rotate(-45deg)}.mat-slider-vertical .mat-slider-thumb-label-text{transform:rotate(45deg)}.mat-slider-vertical.cdk-focused .mat-slider-thumb-label{transform:rotate(-45deg)}[dir=rtl] .mat-slider-wrapper::after{left:0;right:auto}[dir=rtl] .mat-slider-horizontal .mat-slider-track-fill{transform-origin:100% 100%}[dir=rtl] .mat-slider-horizontal .mat-slider-track-background{transform-origin:0 0}[dir=rtl] .mat-slider-horizontal.mat-slider-axis-inverted .mat-slider-track-fill{transform-origin:0 0}[dir=rtl] .mat-slider-horizontal.mat-slider-axis-inverted .mat-slider-track-background{transform-origin:100% 100%} /*# sourceMappingURL=slider.css.map */ "],
                encapsulation: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewEncapsulation"].None,
            },] },
];
/**
 * @nocollapse
 */
MdSlider.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
    { type: FocusOriginMonitor, },
    { type: Dir, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] },] },
]; };
MdSlider.propDecorators = {
    'disabled': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'invert': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'max': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'min': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'step': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'thumbLabel': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    '_thumbLabelDeprecated': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['thumb-label',] },],
    'tickInterval': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    '_tickIntervalDeprecated': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['tick-interval',] },],
    'value': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'vertical': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'color': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'change': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
    'input': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
};
/**
 * Renderer class in order to keep all dom manipulation in one place and outside of the main class.
 * \@docs-private
 */
var SliderRenderer = (function () {
    /**
     * @param {?} elementRef
     */
    function SliderRenderer(elementRef) {
        this._sliderElement = elementRef.nativeElement;
    }
    /**
     * Get the bounding client rect of the slider track element.
     * The track is used rather than the native element to ignore the extra space that the thumb can
     * take up.
     * @return {?}
     */
    SliderRenderer.prototype.getSliderDimensions = function () {
        var /** @type {?} */ wrapperElement = this._sliderElement.querySelector('.mat-slider-wrapper');
        return wrapperElement.getBoundingClientRect();
    };
    /**
     * Focuses the native element.
     * Currently only used to allow a blur event to fire but will be used with keyboard input later.
     * @return {?}
     */
    SliderRenderer.prototype.addFocus = function () {
        this._sliderElement.focus();
    };
    return SliderRenderer;
}());
var MdSliderModule = (function () {
    function MdSliderModule() {
    }
    /**
     * @deprecated
     * @return {?}
     */
    MdSliderModule.forRoot = function () {
        return {
            ngModule: MdSliderModule,
            providers: []
        };
    };
    return MdSliderModule;
}());
MdSliderModule.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{
                imports: [__WEBPACK_IMPORTED_MODULE_2__angular_common__["CommonModule"], __WEBPACK_IMPORTED_MODULE_8__angular_forms__["d" /* FormsModule */], CompatibilityModule, StyleModule, RtlModule],
                exports: [MdSlider, CompatibilityModule],
                declarations: [MdSlider],
                providers: [{ provide: __WEBPACK_IMPORTED_MODULE_1__angular_platform_browser__["HAMMER_GESTURE_CONFIG"], useClass: GestureConfig }]
            },] },
];
/**
 * @nocollapse
 */
MdSliderModule.ctorParameters = function () { return []; };
/**
 * Exception thrown when two MdSidenav are matching the same side.
 */
var MdDuplicatedSidenavError = (function (_super) {
    __extends(MdDuplicatedSidenavError, _super);
    /**
     * @param {?} align
     */
    function MdDuplicatedSidenavError(align) {
        return _super.call(this, "A sidenav was already declared for 'align=\"" + align + "\"'") || this;
    }
    return MdDuplicatedSidenavError;
}(MdError));
/**
 * Sidenav toggle promise result.
 */
var MdSidenavToggleResult = (function () {
    /**
     * @param {?} type
     * @param {?} animationFinished
     */
    function MdSidenavToggleResult(type, animationFinished) {
        this.type = type;
        this.animationFinished = animationFinished;
    }
    return MdSidenavToggleResult;
}());
/**
 * <md-sidenav> component.
 *
 * This component corresponds to the drawer of the sidenav.
 *
 * Please refer to README.md for examples on how to use it.
 */
var MdSidenav = (function () {
    /**
     * @param {?} _elementRef The DOM element reference. Used for transition and width calculation.
     *     If not available we do not hook on transitions.
     * @param {?} _renderer
     * @param {?} _focusTrapFactory
     */
    function MdSidenav(_elementRef, _renderer, _focusTrapFactory) {
        var _this = this;
        this._elementRef = _elementRef;
        this._renderer = _renderer;
        this._focusTrapFactory = _focusTrapFactory;
        this._align = 'start';
        /** Mode of the sidenav; whether 'over' or 'side'. */
        this.mode = 'over';
        this._disableClose = false;
        /** Whether the sidenav is opened. */
        this._opened = false;
        /** Event emitted when the sidenav is being opened. Use this to synchronize animations. */
        this.onOpenStart = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /** Event emitted when the sidenav is fully opened. */
        this.onOpen = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /** Event emitted when the sidenav is being closed. Use this to synchronize animations. */
        this.onCloseStart = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /** Event emitted when the sidenav is fully closed. */
        this.onClose = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /** Event emitted when the sidenav alignment changes. */
        this.onAlignChanged = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this._toggleAnimationPromise = null;
        this._resolveToggleAnimationPromise = null;
        this._elementFocusedBeforeSidenavWasOpened = null;
        this.onOpen.subscribe(function () {
            _this._elementFocusedBeforeSidenavWasOpened = document.activeElement;
            if (_this.isFocusTrapEnabled && _this._focusTrap) {
                _this._focusTrap.focusFirstTabbableElementWhenReady();
            }
        });
        this.onClose.subscribe(function () {
            if (_this._elementFocusedBeforeSidenavWasOpened instanceof HTMLElement) {
                _this._renderer.invokeElementMethod(_this._elementFocusedBeforeSidenavWasOpened, 'focus');
            }
            else {
                _this._renderer.invokeElementMethod(_this._elementRef.nativeElement, 'blur');
            }
            _this._elementFocusedBeforeSidenavWasOpened = null;
        });
    }
    Object.defineProperty(MdSidenav.prototype, "align", {
        /**
         * Direction which the sidenav is aligned in.
         * @return {?}
         */
        get: function () { return this._align; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            // Make sure we have a valid value.
            value = (value == 'end') ? 'end' : 'start';
            if (value != this._align) {
                this._align = value;
                this.onAlignChanged.emit();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdSidenav.prototype, "disableClose", {
        /**
         * Whether the sidenav can be closed with the escape key or not.
         * @return {?}
         */
        get: function () { return this._disableClose; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this._disableClose = coerceBooleanProperty(value); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdSidenav.prototype, "isFocusTrapEnabled", {
        /**
         * @return {?}
         */
        get: function () {
            // The focus trap is only enabled when the sidenav is open in any mode other than side.
            return this.opened && this.mode !== 'side';
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    MdSidenav.prototype.ngAfterContentInit = function () {
        this._focusTrap = this._focusTrapFactory.create(this._elementRef.nativeElement);
        this._focusTrap.enabled = this.isFocusTrapEnabled;
        // This can happen when the sidenav is set to opened in
        // the template and the transition hasn't ended.
        if (this._toggleAnimationPromise) {
            this._resolveToggleAnimationPromise(true);
            this._toggleAnimationPromise = this._resolveToggleAnimationPromise = null;
        }
    };
    /**
     * @return {?}
     */
    MdSidenav.prototype.ngOnDestroy = function () {
        if (this._focusTrap) {
            this._focusTrap.destroy();
        }
    };
    Object.defineProperty(MdSidenav.prototype, "opened", {
        /**
         * Whether the sidenav is opened. We overload this because we trigger an event when it
         * starts or end.
         * @return {?}
         */
        get: function () { return this._opened; },
        /**
         * @param {?} v
         * @return {?}
         */
        set: function (v) {
            this.toggle(coerceBooleanProperty(v));
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Open this sidenav, and return a Promise that will resolve when it's fully opened (or get
     * rejected if it didn't).
     * @return {?}
     */
    MdSidenav.prototype.open = function () {
        return this.toggle(true);
    };
    /**
     * Close this sidenav, and return a Promise that will resolve when it's fully closed (or get
     * rejected if it didn't).
     * @return {?}
     */
    MdSidenav.prototype.close = function () {
        return this.toggle(false);
    };
    /**
     * Toggle this sidenav. This is equivalent to calling open() when it's already opened, or
     * close() when it's closed.
     * @param {?=} isOpen Whether the sidenav should be open.
     * @return {?} Resolves with the result of whether the sidenav was opened or closed.
     */
    MdSidenav.prototype.toggle = function (isOpen) {
        var _this = this;
        if (isOpen === void 0) { isOpen = !this.opened; }
        // Shortcut it if we're already opened.
        if (isOpen === this.opened) {
            return this._toggleAnimationPromise ||
                Promise.resolve(new MdSidenavToggleResult(isOpen ? 'open' : 'close', true));
        }
        this._opened = isOpen;
        if (this._focusTrap) {
            this._focusTrap.enabled = this.isFocusTrapEnabled;
        }
        if (isOpen) {
            this.onOpenStart.emit();
        }
        else {
            this.onCloseStart.emit();
        }
        if (this._toggleAnimationPromise) {
            this._resolveToggleAnimationPromise(false);
        }
        this._toggleAnimationPromise = new Promise(function (resolve) {
            _this._resolveToggleAnimationPromise = function (animationFinished) { return resolve(new MdSidenavToggleResult(isOpen ? 'open' : 'close', animationFinished)); };
        });
        return this._toggleAnimationPromise;
    };
    /**
     * Handles the keyboard events.
     * \@docs-private
     * @param {?} event
     * @return {?}
     */
    MdSidenav.prototype.handleKeydown = function (event) {
        if (event.keyCode === ESCAPE && !this.disableClose) {
            this.close();
            event.stopPropagation();
        }
    };
    /**
     * When transition has finished, set the internal state for classes and emit the proper event.
     * The event passed is actually of type TransitionEvent, but that type is not available in
     * Android so we use any.
     * @param {?} transitionEvent
     * @return {?}
     */
    MdSidenav.prototype._onTransitionEnd = function (transitionEvent) {
        if (transitionEvent.target == this._elementRef.nativeElement
            && transitionEvent.propertyName.endsWith('transform')) {
            if (this._opened) {
                this.onOpen.emit();
            }
            else {
                this.onClose.emit();
            }
            if (this._toggleAnimationPromise) {
                this._resolveToggleAnimationPromise(true);
                this._toggleAnimationPromise = this._resolveToggleAnimationPromise = null;
            }
        }
    };
    Object.defineProperty(MdSidenav.prototype, "_isClosing", {
        /**
         * @return {?}
         */
        get: function () {
            return !this._opened && !!this._toggleAnimationPromise;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdSidenav.prototype, "_isOpening", {
        /**
         * @return {?}
         */
        get: function () {
            return this._opened && !!this._toggleAnimationPromise;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdSidenav.prototype, "_isClosed", {
        /**
         * @return {?}
         */
        get: function () {
            return !this._opened && !this._toggleAnimationPromise;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdSidenav.prototype, "_isOpened", {
        /**
         * @return {?}
         */
        get: function () {
            return this._opened && !this._toggleAnimationPromise;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdSidenav.prototype, "_isEnd", {
        /**
         * @return {?}
         */
        get: function () {
            return this.align == 'end';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdSidenav.prototype, "_modeSide", {
        /**
         * @return {?}
         */
        get: function () {
            return this.mode == 'side';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdSidenav.prototype, "_modeOver", {
        /**
         * @return {?}
         */
        get: function () {
            return this.mode == 'over';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdSidenav.prototype, "_modePush", {
        /**
         * @return {?}
         */
        get: function () {
            return this.mode == 'push';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdSidenav.prototype, "_width", {
        /**
         * @return {?}
         */
        get: function () {
            if (this._elementRef.nativeElement) {
                return this._elementRef.nativeElement.offsetWidth;
            }
            return 0;
        },
        enumerable: true,
        configurable: true
    });
    return MdSidenav;
}());
MdSidenav.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{ selector: 'md-sidenav, mat-sidenav',
                // TODO(mmalerba): move template to separate file.
                template: "<ng-content></ng-content> ",
                host: {
                    '[class.mat-sidenav]': 'true',
                    '(transitionend)': '_onTransitionEnd($event)',
                    '(keydown)': 'handleKeydown($event)',
                    // must prevent the browser from aligning text based on value
                    '[attr.align]': 'null',
                    '[class.mat-sidenav-closed]': '_isClosed',
                    '[class.mat-sidenav-closing]': '_isClosing',
                    '[class.mat-sidenav-end]': '_isEnd',
                    '[class.mat-sidenav-opened]': '_isOpened',
                    '[class.mat-sidenav-opening]': '_isOpening',
                    '[class.mat-sidenav-over]': '_modeOver',
                    '[class.mat-sidenav-push]': '_modePush',
                    '[class.mat-sidenav-side]': '_modeSide',
                    'tabIndex': '-1'
                },
                changeDetection: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectionStrategy"].OnPush,
                encapsulation: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewEncapsulation"].None,
            },] },
];
/**
 * @nocollapse
 */
MdSidenav.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
    { type: FocusTrapFactory, },
]; };
MdSidenav.propDecorators = {
    'align': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'mode': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'disableClose': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'onOpenStart': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"], args: ['open-start',] },],
    'onOpen': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"], args: ['open',] },],
    'onCloseStart': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"], args: ['close-start',] },],
    'onClose': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"], args: ['close',] },],
    'onAlignChanged': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"], args: ['align-changed',] },],
    'opened': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
};
/**
 * <md-sidenav-container> component.
 *
 * This is the parent component to one or two <md-sidenav>s that validates the state internally
 * and coordinates the backdrop and content styling.
 */
var MdSidenavContainer = (function () {
    /**
     * @param {?} _dir
     * @param {?} _element
     * @param {?} _renderer
     * @param {?} _ngZone
     */
    function MdSidenavContainer(_dir, _element, _renderer, _ngZone) {
        var _this = this;
        this._dir = _dir;
        this._element = _element;
        this._renderer = _renderer;
        this._ngZone = _ngZone;
        /** Event emitted when the sidenav backdrop is clicked. */
        this.backdropClick = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /** Whether to enable open/close trantions. */
        this._enableTransitions = false;
        // If a `Dir` directive exists up the tree, listen direction changes and update the left/right
        // properties to point to the proper start/end.
        if (_dir != null) {
            _dir.dirChange.subscribe(function () { return _this._validateDrawers(); });
        }
    }
    Object.defineProperty(MdSidenavContainer.prototype, "start", {
        /**
         * The sidenav child with the `start` alignment.
         * @return {?}
         */
        get: function () { return this._start; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdSidenavContainer.prototype, "end", {
        /**
         * The sidenav child with the `end` alignment.
         * @return {?}
         */
        get: function () { return this._end; },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    MdSidenavContainer.prototype.ngAfterContentInit = function () {
        var _this = this;
        // On changes, assert on consistency.
        this._sidenavs.changes.subscribe(function () { return _this._validateDrawers(); });
        this._sidenavs.forEach(function (sidenav) {
            _this._watchSidenavToggle(sidenav);
            _this._watchSidenavAlign(sidenav);
        });
        this._validateDrawers();
        // Give the view a chance to render the initial state, then enable transitions.
        this._ngZone.onMicrotaskEmpty.first().subscribe(function () { return _this._enableTransitions = true; });
    };
    /**
     * Subscribes to sidenav events in order to set a class on the main container element when the
     * sidenav is open and the backdrop is visible. This ensures any overflow on the container element
     * is properly hidden.
     * @param {?} sidenav
     * @return {?}
     */
    MdSidenavContainer.prototype._watchSidenavToggle = function (sidenav) {
        var _this = this;
        if (!sidenav || sidenav.mode === 'side') {
            return;
        }
        sidenav.onOpen.subscribe(function () { return _this._setContainerClass(sidenav, true); });
        sidenav.onClose.subscribe(function () { return _this._setContainerClass(sidenav, false); });
    };
    /**
     * Subscribes to sidenav onAlignChanged event in order to re-validate drawers when the align
     * changes.
     * @param {?} sidenav
     * @return {?}
     */
    MdSidenavContainer.prototype._watchSidenavAlign = function (sidenav) {
        var _this = this;
        if (!sidenav) {
            return;
        }
        // NOTE: We need to wait for the microtask queue to be empty before validating,
        // since both drawers may be swapping sides at the same time.
        sidenav.onAlignChanged.subscribe(function () { return _this._ngZone.onMicrotaskEmpty.first().subscribe(function () { return _this._validateDrawers(); }); });
    };
    /**
     * Toggles the 'mat-sidenav-opened' class on the main 'md-sidenav-container' element.
     * @param {?} sidenav
     * @param {?} bool
     * @return {?}
     */
    MdSidenavContainer.prototype._setContainerClass = function (sidenav, bool) {
        this._renderer.setElementClass(this._element.nativeElement, 'mat-sidenav-opened', bool);
    };
    /**
     * Validate the state of the sidenav children components.
     * @return {?}
     */
    MdSidenavContainer.prototype._validateDrawers = function () {
        this._start = this._end = null;
        // Ensure that we have at most one start and one end sidenav.
        // NOTE: We must call toArray on _sidenavs even though it's iterable
        // (see https://github.com/Microsoft/TypeScript/issues/3164).
        for (var _i = 0, _a = this._sidenavs.toArray(); _i < _a.length; _i++) {
            var sidenav = _a[_i];
            if (sidenav.align == 'end') {
                if (this._end != null) {
                    throw new MdDuplicatedSidenavError('end');
                }
                this._end = sidenav;
            }
            else {
                if (this._start != null) {
                    throw new MdDuplicatedSidenavError('start');
                }
                this._start = sidenav;
            }
        }
        this._right = this._left = null;
        // Detect if we're LTR or RTL.
        if (this._dir == null || this._dir.value == 'ltr') {
            this._left = this._start;
            this._right = this._end;
        }
        else {
            this._left = this._end;
            this._right = this._start;
        }
    };
    /**
     * @return {?}
     */
    MdSidenavContainer.prototype._onBackdropClicked = function () {
        this.backdropClick.emit();
        this._closeModalSidenav();
    };
    /**
     * @return {?}
     */
    MdSidenavContainer.prototype._closeModalSidenav = function () {
        // Close all open sidenav's where closing is not disabled and the mode is not `side`.
        [this._start, this._end]
            .filter(function (sidenav) { return sidenav && !sidenav.disableClose && sidenav.mode !== 'side'; })
            .forEach(function (sidenav) { return sidenav.close(); });
    };
    /**
     * @return {?}
     */
    MdSidenavContainer.prototype._isShowingBackdrop = function () {
        return (this._isSidenavOpen(this._start) && this._start.mode != 'side')
            || (this._isSidenavOpen(this._end) && this._end.mode != 'side');
    };
    /**
     * @param {?} side
     * @return {?}
     */
    MdSidenavContainer.prototype._isSidenavOpen = function (side) {
        return side != null && side.opened;
    };
    /**
     * Return the width of the sidenav, if it's in the proper mode and opened.
     * This may relayout the view, so do not call this often.
     * @param {?} sidenav
     * @param {?} mode
     * @return {?}
     */
    MdSidenavContainer.prototype._getSidenavEffectiveWidth = function (sidenav, mode) {
        return (this._isSidenavOpen(sidenav) && sidenav.mode == mode) ? sidenav._width : 0;
    };
    /**
     * @return {?}
     */
    MdSidenavContainer.prototype._getMarginLeft = function () {
        return this._getSidenavEffectiveWidth(this._left, 'side');
    };
    /**
     * @return {?}
     */
    MdSidenavContainer.prototype._getMarginRight = function () {
        return this._getSidenavEffectiveWidth(this._right, 'side');
    };
    /**
     * @return {?}
     */
    MdSidenavContainer.prototype._getPositionLeft = function () {
        return this._getSidenavEffectiveWidth(this._left, 'push');
    };
    /**
     * @return {?}
     */
    MdSidenavContainer.prototype._getPositionRight = function () {
        return this._getSidenavEffectiveWidth(this._right, 'push');
    };
    /**
     * Returns the horizontal offset for the content area.  There should never be a value for both
     * left and right, so by subtracting the right value from the left value, we should always get
     * the appropriate offset.
     * @return {?}
     */
    MdSidenavContainer.prototype._getPositionOffset = function () {
        return this._getPositionLeft() - this._getPositionRight();
    };
    /**
     * This is using [ngStyle] rather than separate [style...] properties because [style.transform]
     * doesn't seem to work right now.
     * @return {?}
     */
    MdSidenavContainer.prototype._getStyles = function () {
        return {
            marginLeft: this._getMarginLeft() + "px",
            marginRight: this._getMarginRight() + "px",
            transform: "translate3d(" + this._getPositionOffset() + "px, 0, 0)"
        };
    };
    return MdSidenavContainer;
}());
MdSidenavContainer.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{ selector: 'md-sidenav-container, mat-sidenav-container',
                // Do not use ChangeDetectionStrategy.OnPush. It does not work for this component because
                // technically it is a sibling of MdSidenav (on the content tree) and isn't updated when MdSidenav
                // changes its state.
                template: "<div class=\"mat-sidenav-backdrop\" (click)=\"_onBackdropClicked()\" [class.mat-sidenav-shown]=\"_isShowingBackdrop()\"></div> <ng-content select=\"md-sidenav, mat-sidenav\"></ng-content> <div class=\"mat-sidenav-content\" [ngStyle]=\"_getStyles()\" cdk-scrollable> <ng-content></ng-content> </div> ",
                styles: [".mat-sidenav-container{position:relative;transform:translate3d(0,0,0);box-sizing:border-box;-webkit-overflow-scrolling:touch;display:block;overflow:hidden}.mat-sidenav-container[fullscreen]{position:absolute;top:0;left:0;right:0;bottom:0}.mat-sidenav-container[fullscreen].mat-sidenav-opened{overflow:hidden}.mat-sidenav-backdrop{position:absolute;top:0;left:0;right:0;bottom:0;display:block;z-index:2;visibility:hidden}.mat-sidenav-backdrop.mat-sidenav-shown{visibility:visible}@media screen and (-ms-high-contrast:active){.mat-sidenav-backdrop{opacity:.5}}.mat-sidenav-content{position:relative;transform:translate3d(0,0,0);display:block;height:100%;overflow:auto}.mat-sidenav{position:relative;transform:translate3d(0,0,0);display:block;position:absolute;top:0;bottom:0;z-index:3;min-width:5vw;outline:0;box-sizing:border-box;height:100%;overflow-y:auto;transform:translate3d(-100%,0,0)}.mat-sidenav.mat-sidenav-closed{visibility:hidden}.mat-sidenav.mat-sidenav-opened,.mat-sidenav.mat-sidenav-opening{transform:translate3d(0,0,0)}.mat-sidenav.mat-sidenav-side{z-index:1}.mat-sidenav.mat-sidenav-end{right:0;transform:translate3d(100%,0,0)}.mat-sidenav.mat-sidenav-end.mat-sidenav-closed{visibility:hidden}.mat-sidenav.mat-sidenav-end.mat-sidenav-opened,.mat-sidenav.mat-sidenav-end.mat-sidenav-opening{transform:translate3d(0,0,0)}[dir=rtl] .mat-sidenav{transform:translate3d(100%,0,0)}[dir=rtl] .mat-sidenav.mat-sidenav-closed{visibility:hidden}[dir=rtl] .mat-sidenav.mat-sidenav-opened,[dir=rtl] .mat-sidenav.mat-sidenav-opening{transform:translate3d(0,0,0)}[dir=rtl] .mat-sidenav.mat-sidenav-end{left:0;right:auto;transform:translate3d(-100%,0,0)}[dir=rtl] .mat-sidenav.mat-sidenav-end.mat-sidenav-closed{visibility:hidden}[dir=rtl] .mat-sidenav.mat-sidenav-end.mat-sidenav-opened,[dir=rtl] .mat-sidenav.mat-sidenav-end.mat-sidenav-opening{transform:translate3d(0,0,0)}.mat-sidenav.mat-sidenav-opened:not(.mat-sidenav-side),.mat-sidenav.mat-sidenav-opening:not(.mat-sidenav-side){box-shadow:0 8px 10px -5px rgba(0,0,0,.2),0 16px 24px 2px rgba(0,0,0,.14),0 6px 30px 5px rgba(0,0,0,.12)} /*# sourceMappingURL=sidenav.css.map */ ",
                    ".mat-sidenav-transition .mat-sidenav{transition:transform .4s cubic-bezier(.25,.8,.25,1)}.mat-sidenav-transition .mat-sidenav-content{transition-duration:.4s;transition-timing-function:cubic-bezier(.25,.8,.25,1);transition-property:transform,margin-left,margin-right}.mat-sidenav-transition .mat-sidenav-backdrop.mat-sidenav-shown{transition:background-color .4s cubic-bezier(.25,.8,.25,1)} /*# sourceMappingURL=sidenav-transitions.css.map */ "],
                host: {
                    '[class.mat-sidenav-container]': 'true',
                    '[class.mat-sidenav-transition]': '_enableTransitions',
                },
                encapsulation: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewEncapsulation"].None,
            },] },
];
/**
 * @nocollapse
 */
MdSidenavContainer.ctorParameters = function () { return [
    { type: Dir, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] },] },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgZone"], },
]; };
MdSidenavContainer.propDecorators = {
    '_sidenavs': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ContentChildren"], args: [MdSidenav,] },],
    'backdropClick': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
};
var MdSidenavModule = (function () {
    function MdSidenavModule() {
    }
    /**
     * @deprecated
     * @return {?}
     */
    MdSidenavModule.forRoot = function () {
        return {
            ngModule: MdSidenavModule,
            providers: []
        };
    };
    return MdSidenavModule;
}());
MdSidenavModule.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{
                imports: [__WEBPACK_IMPORTED_MODULE_2__angular_common__["CommonModule"], CompatibilityModule, A11yModule, OverlayModule],
                exports: [MdSidenavContainer, MdSidenav, CompatibilityModule],
                declarations: [MdSidenavContainer, MdSidenav],
            },] },
];
/**
 * @nocollapse
 */
MdSidenavModule.ctorParameters = function () { return []; };
var MdListDivider = (function () {
    function MdListDivider() {
    }
    return MdListDivider;
}());
MdListDivider.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                selector: 'md-divider, mat-divider'
            },] },
];
/**
 * @nocollapse
 */
MdListDivider.ctorParameters = function () { return []; };
/**
 * Token used to inject the list type into child MdListItem components so they can know whether
 * they're in a nav list (and thus should use an MdRipple).
 */
var LIST_TYPE_TOKEN = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["OpaqueToken"]('list_type');
var NORMAL_LIST_TYPE = 'normal_list_type';
var NAV_LIST_TYPE = 'nav_list_type';
var MdList = (function () {
    function MdList() {
    }
    return MdList;
}());
MdList.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{ selector: 'md-list, mat-list, md-nav-list, mat-nav-list',
                host: {
                    'role': 'list'
                },
                template: '<ng-content></ng-content>',
                styles: [".mat-list,.mat-nav-list{padding-top:8px;display:block}.mat-list .mat-subheader,.mat-nav-list .mat-subheader{display:block;box-sizing:border-box;height:48px;padding:16px;margin:0;font-family:Roboto,\"Helvetica Neue\",sans-serif;font-size:14px;font-weight:500}.mat-list .mat-subheader:first-child,.mat-nav-list .mat-subheader:first-child{margin-top:-8px}.mat-list .mat-list-item,.mat-nav-list .mat-list-item{display:block}.mat-list .mat-list-item .mat-list-item-content,.mat-nav-list .mat-list-item .mat-list-item-content{display:flex;flex-direction:row;align-items:center;font-family:Roboto,\"Helvetica Neue\",sans-serif;box-sizing:border-box;font-size:16px;height:48px;padding:0 16px;position:relative}.mat-list .mat-list-item.mat-list-item-avatar .mat-list-item-content,.mat-nav-list .mat-list-item.mat-list-item-avatar .mat-list-item-content{height:56px}.mat-list .mat-list-item.mat-2-line .mat-list-item-content,.mat-nav-list .mat-list-item.mat-2-line .mat-list-item-content{height:72px}.mat-list .mat-list-item.mat-3-line .mat-list-item-content,.mat-nav-list .mat-list-item.mat-3-line .mat-list-item-content{height:88px}.mat-list .mat-list-item.mat-multi-line .mat-list-item-content,.mat-nav-list .mat-list-item.mat-multi-line .mat-list-item-content{height:100%;padding:8px 16px}.mat-list .mat-list-item .mat-list-text,.mat-nav-list .mat-list-item .mat-list-text{display:flex;flex-direction:column;width:100%;box-sizing:border-box;overflow:hidden;padding:0 16px}.mat-list .mat-list-item .mat-list-text>*,.mat-nav-list .mat-list-item .mat-list-text>*{margin:0;padding:0;font-weight:400;font-size:inherit}.mat-list .mat-list-item .mat-list-text:empty,.mat-nav-list .mat-list-item .mat-list-text:empty{display:none}.mat-list .mat-list-item .mat-list-text:first-child,.mat-nav-list .mat-list-item .mat-list-text:first-child{padding:0}.mat-list .mat-list-item .mat-list-avatar,.mat-nav-list .mat-list-item .mat-list-avatar{flex-shrink:0;width:40px;height:40px;border-radius:50%}.mat-list .mat-list-item .mat-list-icon,.mat-nav-list .mat-list-item .mat-list-icon{width:24px;height:24px;border-radius:50%;padding:4px}.mat-list .mat-list-item .mat-line,.mat-nav-list .mat-list-item .mat-line{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:block;box-sizing:border-box}.mat-list .mat-list-item .mat-line:nth-child(n+2),.mat-nav-list .mat-list-item .mat-line:nth-child(n+2){font-size:14px}.mat-list[dense],.mat-nav-list[dense]{padding-top:4px;display:block}.mat-list[dense] .mat-subheader,.mat-nav-list[dense] .mat-subheader{display:block;box-sizing:border-box;height:40px;padding:16px;margin:0;font-family:Roboto,\"Helvetica Neue\",sans-serif;font-size:13px;font-weight:500}.mat-list[dense] .mat-subheader:first-child,.mat-nav-list[dense] .mat-subheader:first-child{margin-top:-4px}.mat-list[dense] .mat-list-item,.mat-nav-list[dense] .mat-list-item{display:block}.mat-list[dense] .mat-list-item .mat-list-item-content,.mat-nav-list[dense] .mat-list-item .mat-list-item-content{display:flex;flex-direction:row;align-items:center;font-family:Roboto,\"Helvetica Neue\",sans-serif;box-sizing:border-box;font-size:13px;height:40px;padding:0 16px;position:relative}.mat-list[dense] .mat-list-item.mat-list-item-avatar .mat-list-item-content,.mat-nav-list[dense] .mat-list-item.mat-list-item-avatar .mat-list-item-content{height:48px}.mat-list[dense] .mat-list-item.mat-2-line .mat-list-item-content,.mat-nav-list[dense] .mat-list-item.mat-2-line .mat-list-item-content{height:60px}.mat-list[dense] .mat-list-item.mat-3-line .mat-list-item-content,.mat-nav-list[dense] .mat-list-item.mat-3-line .mat-list-item-content{height:76px}.mat-list[dense] .mat-list-item.mat-multi-line .mat-list-item-content,.mat-nav-list[dense] .mat-list-item.mat-multi-line .mat-list-item-content{height:100%;padding:8px 16px}.mat-list[dense] .mat-list-item .mat-list-text,.mat-nav-list[dense] .mat-list-item .mat-list-text{display:flex;flex-direction:column;width:100%;box-sizing:border-box;overflow:hidden;padding:0 16px}.mat-list[dense] .mat-list-item .mat-list-text>*,.mat-nav-list[dense] .mat-list-item .mat-list-text>*{margin:0;padding:0;font-weight:400;font-size:inherit}.mat-list[dense] .mat-list-item .mat-list-text:empty,.mat-nav-list[dense] .mat-list-item .mat-list-text:empty{display:none}.mat-list[dense] .mat-list-item .mat-list-text:first-child,.mat-nav-list[dense] .mat-list-item .mat-list-text:first-child{padding:0}.mat-list[dense] .mat-list-item .mat-list-avatar,.mat-nav-list[dense] .mat-list-item .mat-list-avatar{flex-shrink:0;width:40px;height:40px;border-radius:50%}.mat-list[dense] .mat-list-item .mat-list-icon,.mat-nav-list[dense] .mat-list-item .mat-list-icon{width:24px;height:24px;border-radius:50%;padding:4px}.mat-list[dense] .mat-list-item .mat-line,.mat-nav-list[dense] .mat-list-item .mat-line{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:block;box-sizing:border-box}.mat-list[dense] .mat-list-item .mat-line:nth-child(n+2),.mat-nav-list[dense] .mat-list-item .mat-line:nth-child(n+2){font-size:13px}.mat-divider{display:block;border-top-style:solid;border-top-width:1px;margin:0}.mat-nav-list a{text-decoration:none;color:inherit}.mat-nav-list .mat-list-item-content{cursor:pointer}.mat-nav-list .mat-list-item-content.mat-list-item-focus,.mat-nav-list .mat-list-item-content:hover{outline:0} /*# sourceMappingURL=list.css.map */ "],
                providers: [{ provide: LIST_TYPE_TOKEN, useValue: NORMAL_LIST_TYPE }],
                encapsulation: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewEncapsulation"].None
            },] },
];
/**
 * @nocollapse
 */
MdList.ctorParameters = function () { return []; };
/**
 * Directive whose purpose is to add the mat- CSS styling to this selector.
 * \@docs-private
 */
var MdListCssMatStyler = (function () {
    function MdListCssMatStyler() {
    }
    return MdListCssMatStyler;
}());
MdListCssMatStyler.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                selector: 'md-list, mat-list',
                host: {
                    '[class.mat-list]': 'true'
                }
            },] },
];
/**
 * @nocollapse
 */
MdListCssMatStyler.ctorParameters = function () { return []; };
/**
 * Directive whose purpose is to add the mat- CSS styling to this selector.
 * \@docs-private
 */
var MdNavListCssMatStyler = (function () {
    function MdNavListCssMatStyler() {
    }
    return MdNavListCssMatStyler;
}());
MdNavListCssMatStyler.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                selector: 'md-nav-list, mat-nav-list',
                host: {
                    '[class.mat-nav-list]': 'true'
                }
            },] },
];
/**
 * @nocollapse
 */
MdNavListCssMatStyler.ctorParameters = function () { return []; };
/**
 * Directive to set the ListType token to NAV_LIST_TYPE.
 */
var MdNavListTokenSetter = (function () {
    function MdNavListTokenSetter() {
    }
    return MdNavListTokenSetter;
}());
MdNavListTokenSetter.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                selector: 'md-nav-list, mat-nav-list',
                providers: [{ provide: LIST_TYPE_TOKEN, useValue: NAV_LIST_TYPE }],
            },] },
];
/**
 * @nocollapse
 */
MdNavListTokenSetter.ctorParameters = function () { return []; };
/**
 * Directive whose purpose is to add the mat- CSS styling to this selector.
 * \@docs-private
 */
var MdDividerCssMatStyler = (function () {
    function MdDividerCssMatStyler() {
    }
    return MdDividerCssMatStyler;
}());
MdDividerCssMatStyler.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                selector: 'md-divider, mat-divider',
                host: {
                    '[class.mat-divider]': 'true'
                }
            },] },
];
/**
 * @nocollapse
 */
MdDividerCssMatStyler.ctorParameters = function () { return []; };
/**
 * Directive whose purpose is to add the mat- CSS styling to this selector.
 * \@docs-private
 */
var MdListAvatarCssMatStyler = (function () {
    function MdListAvatarCssMatStyler() {
    }
    return MdListAvatarCssMatStyler;
}());
MdListAvatarCssMatStyler.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                selector: '[md-list-avatar], [mat-list-avatar]',
                host: {
                    '[class.mat-list-avatar]': 'true'
                }
            },] },
];
/**
 * @nocollapse
 */
MdListAvatarCssMatStyler.ctorParameters = function () { return []; };
/**
 * Directive whose purpose is to add the mat- CSS styling to this selector.
 * \@docs-private
 */
var MdListIconCssMatStyler = (function () {
    function MdListIconCssMatStyler() {
    }
    return MdListIconCssMatStyler;
}());
MdListIconCssMatStyler.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                selector: '[md-list-icon], [mat-list-icon]',
                host: {
                    '[class.mat-list-icon]': 'true'
                }
            },] },
];
/**
 * @nocollapse
 */
MdListIconCssMatStyler.ctorParameters = function () { return []; };
/**
 * Directive whose purpose is to add the mat- CSS styling to this selector.
 * \@docs-private
 */
var MdListSubheaderCssMatStyler = (function () {
    function MdListSubheaderCssMatStyler() {
    }
    return MdListSubheaderCssMatStyler;
}());
MdListSubheaderCssMatStyler.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                selector: '[md-subheader], [mat-subheader]',
                host: {
                    '[class.mat-subheader]': 'true'
                }
            },] },
];
/**
 * @nocollapse
 */
MdListSubheaderCssMatStyler.ctorParameters = function () { return []; };
var MdListItem = (function () {
    /**
     * @param {?} _renderer
     * @param {?} _element
     * @param {?} _listType
     */
    function MdListItem(_renderer, _element, _listType) {
        this._renderer = _renderer;
        this._element = _element;
        this._listType = _listType;
        /**
         * Whether the ripple effect on click should be disabled. This applies only to list items that
         * are children of an md-nav-list; md-list items never have ripples.
         */
        this.disableRipple = false;
        this._hasFocus = false;
    }
    Object.defineProperty(MdListItem.prototype, "_hasAvatar", {
        /**
         * @param {?} avatar
         * @return {?}
         */
        set: function (avatar) {
            this._renderer.setElementClass(this._element.nativeElement, 'mat-list-item-avatar', avatar != null);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    MdListItem.prototype.ngAfterContentInit = function () {
        this._lineSetter = new MdLineSetter(this._lines, this._renderer, this._element);
    };
    /**
     * Whether this list item should show a ripple effect when clicked.
     * @return {?}
     */
    MdListItem.prototype.isRippleEnabled = function () {
        return !this.disableRipple && (this._listType === NAV_LIST_TYPE);
    };
    /**
     * @return {?}
     */
    MdListItem.prototype._handleFocus = function () {
        this._hasFocus = true;
    };
    /**
     * @return {?}
     */
    MdListItem.prototype._handleBlur = function () {
        this._hasFocus = false;
    };
    return MdListItem;
}());
MdListItem.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{ selector: 'md-list-item, mat-list-item, a[md-list-item], a[mat-list-item]',
                host: {
                    'role': 'listitem',
                    '(focus)': '_handleFocus()',
                    '(blur)': '_handleBlur()',
                    '[class.mat-list-item]': 'true',
                },
                template: "<div class=\"mat-list-item-content\" [class.mat-list-item-focus]=\"_hasFocus\" md-ripple [mdRippleDisabled]=\"!isRippleEnabled()\"> <ng-content select=\"[md-list-avatar],[md-list-icon], [mat-list-avatar], [mat-list-icon]\"></ng-content> <div class=\"mat-list-text\"><ng-content select=\"[md-line], [mat-line]\"></ng-content></div> <ng-content></ng-content> </div> ",
                encapsulation: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewEncapsulation"].None
            },] },
];
/**
 * @nocollapse
 */
MdListItem.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
    { type: undefined, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [LIST_TYPE_TOKEN,] },] },
]; };
MdListItem.propDecorators = {
    'disableRipple': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    '_lines': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ContentChildren"], args: [MdLine,] },],
    '_hasAvatar': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ContentChild"], args: [MdListAvatarCssMatStyler,] },],
};
var MdListModule = (function () {
    function MdListModule() {
    }
    /**
     * @deprecated
     * @return {?}
     */
    MdListModule.forRoot = function () {
        return {
            ngModule: MdListModule,
            providers: []
        };
    };
    return MdListModule;
}());
MdListModule.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{
                imports: [MdLineModule, MdRippleModule, CompatibilityModule],
                exports: [
                    MdList,
                    MdListItem,
                    MdListDivider,
                    MdListAvatarCssMatStyler,
                    MdLineModule,
                    CompatibilityModule,
                    MdListIconCssMatStyler,
                    MdListCssMatStyler,
                    MdNavListCssMatStyler,
                    MdDividerCssMatStyler,
                    MdListSubheaderCssMatStyler,
                    MdNavListTokenSetter,
                ],
                declarations: [
                    MdList,
                    MdListItem,
                    MdListDivider,
                    MdListAvatarCssMatStyler,
                    MdListIconCssMatStyler,
                    MdListCssMatStyler,
                    MdNavListCssMatStyler,
                    MdDividerCssMatStyler,
                    MdListSubheaderCssMatStyler,
                    MdNavListTokenSetter,
                ],
            },] },
];
/**
 * @nocollapse
 */
MdListModule.ctorParameters = function () { return []; };
/**
 * Converts values into strings. Falsy values become empty strings.
 * \@docs-private
 * @param {?} value
 * @return {?}
 */
function coerceToString(value) {
    return "" + (value || '');
}
/**
 * Converts a value that might be a string into a number.
 * \@docs-private
 * @param {?} value
 * @return {?}
 */
function coerceToNumber(value) {
    return typeof value === 'string' ? parseInt(value, 10) : value;
}
var MdGridTile = (function () {
    /**
     * @param {?} _renderer
     * @param {?} _element
     */
    function MdGridTile(_renderer, _element) {
        this._renderer = _renderer;
        this._element = _element;
        this._rowspan = 1;
        this._colspan = 1;
    }
    Object.defineProperty(MdGridTile.prototype, "rowspan", {
        /**
         * Amount of rows that the grid tile takes up.
         * @return {?}
         */
        get: function () { return this._rowspan; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this._rowspan = coerceToNumber(value); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdGridTile.prototype, "colspan", {
        /**
         * Amount of columns that the grid tile takes up.
         * @return {?}
         */
        get: function () { return this._colspan; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this._colspan = coerceToNumber(value); },
        enumerable: true,
        configurable: true
    });
    /**
     * Sets the style of the grid-tile element.  Needs to be set manually to avoid
     * "Changed after checked" errors that would occur with HostBinding.
     * @param {?} property
     * @param {?} value
     * @return {?}
     */
    MdGridTile.prototype._setStyle = function (property, value) {
        this._renderer.setElementStyle(this._element.nativeElement, property, value);
    };
    return MdGridTile;
}());
MdGridTile.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{ selector: 'md-grid-tile, mat-grid-tile',
                host: {
                    'role': 'listitem',
                    '[class.mat-grid-tile]': 'true',
                },
                template: "<!-- TODO(kara): Revisit why this is a figure.--> <figure class=\"mat-figure\"> <ng-content></ng-content> </figure>",
                styles: [".mat-grid-list{display:block;position:relative}.mat-grid-tile{display:block;position:absolute;overflow:hidden}.mat-grid-tile .mat-figure{display:flex;position:absolute;align-items:center;justify-content:center;height:100%;top:0;right:0;bottom:0;left:0;padding:0;margin:0}.mat-grid-tile .mat-grid-tile-footer,.mat-grid-tile .mat-grid-tile-header{display:flex;align-items:center;height:48px;color:#fff;background:rgba(0,0,0,.38);overflow:hidden;padding:0 16px;font-size:16px;position:absolute;left:0;right:0}.mat-grid-tile .mat-grid-tile-footer .mat-line,.mat-grid-tile .mat-grid-tile-header .mat-line{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:block;box-sizing:border-box}.mat-grid-tile .mat-grid-tile-footer .mat-line:nth-child(n+2),.mat-grid-tile .mat-grid-tile-header .mat-line:nth-child(n+2){font-size:12px}.mat-grid-tile .mat-grid-tile-footer>*,.mat-grid-tile .mat-grid-tile-header>*{margin:0;padding:0;font-weight:400;font-size:inherit}.mat-grid-tile .mat-grid-tile-footer.mat-2-line,.mat-grid-tile .mat-grid-tile-header.mat-2-line{height:68px}.mat-grid-tile .mat-grid-list-text{display:flex;flex-direction:column;width:100%;box-sizing:border-box;overflow:hidden}.mat-grid-tile .mat-grid-list-text>*{margin:0;padding:0;font-weight:400;font-size:inherit}.mat-grid-tile .mat-grid-list-text:empty{display:none}.mat-grid-tile .mat-grid-tile-header{top:0}.mat-grid-tile .mat-grid-tile-footer{bottom:0}.mat-grid-tile .mat-grid-avatar{padding-right:16px}[dir=rtl] .mat-grid-tile .mat-grid-avatar{padding-right:0;padding-left:16px}.mat-grid-tile .mat-grid-avatar:empty{display:none} /*# sourceMappingURL=grid-list.css.map */ "],
                encapsulation: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewEncapsulation"].None,
            },] },
];
/**
 * @nocollapse
 */
MdGridTile.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
]; };
MdGridTile.propDecorators = {
    'rowspan': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'colspan': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
};
var MdGridTileText = (function () {
    /**
     * @param {?} _renderer
     * @param {?} _element
     */
    function MdGridTileText(_renderer, _element) {
        this._renderer = _renderer;
        this._element = _element;
    }
    /**
     * @return {?}
     */
    MdGridTileText.prototype.ngAfterContentInit = function () {
        this._lineSetter = new MdLineSetter(this._lines, this._renderer, this._element);
    };
    return MdGridTileText;
}());
MdGridTileText.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{ selector: 'md-grid-tile-header, mat-grid-tile-header, md-grid-tile-footer, mat-grid-tile-footer',
                template: "<ng-content select=\"[md-grid-avatar], [mat-grid-avatar]\"></ng-content> <div class=\"mat-grid-list-text\"><ng-content select=\"[md-line], [mat-line]\"></ng-content></div> <ng-content></ng-content> "
            },] },
];
/**
 * @nocollapse
 */
MdGridTileText.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
]; };
MdGridTileText.propDecorators = {
    '_lines': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ContentChildren"], args: [MdLine,] },],
};
/**
 * Directive whose purpose is to add the mat- CSS styling to this selector.
 * \@docs-private
 */
var MdGridAvatarCssMatStyler = (function () {
    function MdGridAvatarCssMatStyler() {
    }
    return MdGridAvatarCssMatStyler;
}());
MdGridAvatarCssMatStyler.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                selector: '[md-grid-avatar], [mat-grid-avatar]',
                host: {
                    '[class.mat-grid-avatar]': 'true'
                }
            },] },
];
/**
 * @nocollapse
 */
MdGridAvatarCssMatStyler.ctorParameters = function () { return []; };
/**
 * Directive whose purpose is to add the mat- CSS styling to this selector.
 * \@docs-private
 */
var MdGridTileHeaderCssMatStyler = (function () {
    function MdGridTileHeaderCssMatStyler() {
    }
    return MdGridTileHeaderCssMatStyler;
}());
MdGridTileHeaderCssMatStyler.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                selector: 'md-grid-tile-header, mat-grid-tile-header',
                host: {
                    '[class.mat-grid-tile-header]': 'true'
                }
            },] },
];
/**
 * @nocollapse
 */
MdGridTileHeaderCssMatStyler.ctorParameters = function () { return []; };
/**
 * Directive whose purpose is to add the mat- CSS styling to this selector.
 * \@docs-private
 */
var MdGridTileFooterCssMatStyler = (function () {
    function MdGridTileFooterCssMatStyler() {
    }
    return MdGridTileFooterCssMatStyler;
}());
MdGridTileFooterCssMatStyler.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                selector: 'md-grid-tile-footer, mat-grid-tile-footer',
                host: {
                    '[class.mat-grid-tile-footer]': 'true'
                }
            },] },
];
/**
 * @nocollapse
 */
MdGridTileFooterCssMatStyler.ctorParameters = function () { return []; };
/**
 * Exception thrown when cols property is missing from grid-list
 * \@docs-private
 */
var MdGridListColsError = (function (_super) {
    __extends(MdGridListColsError, _super);
    function MdGridListColsError() {
        return _super.call(this, "md-grid-list: must pass in number of columns. Example: <md-grid-list cols=\"3\">") || this;
    }
    return MdGridListColsError;
}(MdError));
/**
 * Exception thrown when a tile's colspan is longer than the number of cols in list
 * \@docs-private
 */
var MdGridTileTooWideError = (function (_super) {
    __extends(MdGridTileTooWideError, _super);
    /**
     * @param {?} cols
     * @param {?} listLength
     */
    function MdGridTileTooWideError(cols, listLength) {
        return _super.call(this, "md-grid-list: tile with colspan " + cols + " is wider than grid with cols=\"" + listLength + "\".") || this;
    }
    return MdGridTileTooWideError;
}(MdError));
/**
 * Exception thrown when an invalid ratio is passed in as a rowHeight
 * \@docs-private
 */
var MdGridListBadRatioError = (function (_super) {
    __extends(MdGridListBadRatioError, _super);
    /**
     * @param {?} value
     */
    function MdGridListBadRatioError(value) {
        return _super.call(this, "md-grid-list: invalid ratio given for row-height: \"" + value + "\"") || this;
    }
    return MdGridListBadRatioError;
}(MdError));
/**
 * Class for determining, from a list of tiles, the (row, col) position of each of those tiles
 * in the grid. This is necessary (rather than just rendering the tiles in normal document flow)
 * because the tiles can have a rowspan.
 *
 * The positioning algorithm greedily places each tile as soon as it encounters a gap in the grid
 * large enough to accommodate it so that the tiles still render in the same order in which they
 * are given.
 *
 * The basis of the algorithm is the use of an array to track the already placed tiles. Each
 * element of the array corresponds to a column, and the value indicates how many cells in that
 * column are already occupied; zero indicates an empty cell. Moving "down" to the next row
 * decrements each value in the tracking array (indicating that the column is one cell closer to
 * being free).
 *
 * \@docs-private
 */
var TileCoordinator = (function () {
    /**
     * @param {?} numColumns
     * @param {?} tiles
     */
    function TileCoordinator(numColumns, tiles) {
        var _this = this;
        /** Index at which the search for the next gap will start. */
        this.columnIndex = 0;
        /** The current row index. */
        this.rowIndex = 0;
        this.tracker = new Array(numColumns);
        this.tracker.fill(0, 0, this.tracker.length);
        this.positions = tiles.map(function (tile) { return _this._trackTile(tile); });
    }
    Object.defineProperty(TileCoordinator.prototype, "rowCount", {
        /**
         * Gets the total number of rows occupied by tiles
         * @return {?}
         */
        get: function () { return this.rowIndex + 1; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TileCoordinator.prototype, "rowspan", {
        /**
         * Gets the total span of rows occupied by tiles.
         * Ex: A list with 1 row that contains a tile with rowspan 2 will have a total rowspan of 2.
         * @return {?}
         */
        get: function () {
            var /** @type {?} */ lastRowMax = Math.max.apply(Math, this.tracker);
            // if any of the tiles has a rowspan that pushes it beyond the total row count,
            // add the difference to the rowcount
            return lastRowMax > 1 ? this.rowCount + lastRowMax - 1 : this.rowCount;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Calculates the row and col position of a tile.
     * @param {?} tile
     * @return {?}
     */
    TileCoordinator.prototype._trackTile = function (tile) {
        // Find a gap large enough for this tile.
        var /** @type {?} */ gapStartIndex = this._findMatchingGap(tile.colspan);
        // Place tile in the resulting gap.
        this._markTilePosition(gapStartIndex, tile);
        // The next time we look for a gap, the search will start at columnIndex, which should be
        // immediately after the tile that has just been placed.
        this.columnIndex = gapStartIndex + tile.colspan;
        return new TilePosition(this.rowIndex, gapStartIndex);
    };
    /**
     * Finds the next available space large enough to fit the tile.
     * @param {?} tileCols
     * @return {?}
     */
    TileCoordinator.prototype._findMatchingGap = function (tileCols) {
        if (tileCols > this.tracker.length) {
            throw new MdGridTileTooWideError(tileCols, this.tracker.length);
        }
        // Start index is inclusive, end index is exclusive.
        var /** @type {?} */ gapStartIndex = -1;
        var /** @type {?} */ gapEndIndex = -1;
        // Look for a gap large enough to fit the given tile. Empty spaces are marked with a zero.
        do {
            // If we've reached the end of the row, go to the next row.
            if (this.columnIndex + tileCols > this.tracker.length) {
                this._nextRow();
                continue;
            }
            gapStartIndex = this.tracker.indexOf(0, this.columnIndex);
            // If there are no more empty spaces in this row at all, move on to the next row.
            if (gapStartIndex == -1) {
                this._nextRow();
                continue;
            }
            gapEndIndex = this._findGapEndIndex(gapStartIndex);
            // If a gap large enough isn't found, we want to start looking immediately after the current
            // gap on the next iteration.
            this.columnIndex = gapStartIndex + 1;
        } while (gapEndIndex - gapStartIndex < tileCols);
        return gapStartIndex;
    };
    /**
     * Move "down" to the next row.
     * @return {?}
     */
    TileCoordinator.prototype._nextRow = function () {
        this.columnIndex = 0;
        this.rowIndex++;
        // Decrement all spaces by one to reflect moving down one row.
        for (var /** @type {?} */ i = 0; i < this.tracker.length; i++) {
            this.tracker[i] = Math.max(0, this.tracker[i] - 1);
        }
    };
    /**
     * Finds the end index (exclusive) of a gap given the index from which to start looking.
     * The gap ends when a non-zero value is found.
     * @param {?} gapStartIndex
     * @return {?}
     */
    TileCoordinator.prototype._findGapEndIndex = function (gapStartIndex) {
        for (var /** @type {?} */ i = gapStartIndex + 1; i < this.tracker.length; i++) {
            if (this.tracker[i] != 0) {
                return i;
            }
        }
        // The gap ends with the end of the row.
        return this.tracker.length;
    };
    /**
     * Update the tile tracker to account for the given tile in the given space.
     * @param {?} start
     * @param {?} tile
     * @return {?}
     */
    TileCoordinator.prototype._markTilePosition = function (start, tile) {
        for (var /** @type {?} */ i = 0; i < tile.colspan; i++) {
            this.tracker[start + i] = tile.rowspan;
        }
    };
    return TileCoordinator;
}());
/**
 * Simple data structure for tile position (row, col).
 * \@docs-private
 */
var TilePosition = (function () {
    /**
     * @param {?} row
     * @param {?} col
     */
    function TilePosition(row, col) {
        this.row = row;
        this.col = col;
    }
    return TilePosition;
}());
/**
 * Sets the style properties for an individual tile, given the position calculated by the
 * Tile Coordinator.
 * \@docs-private
 */
var TileStyler = (function () {
    function TileStyler() {
        this._rows = 0;
        this._rowspan = 0;
    }
    /**
     * Adds grid-list layout info once it is available. Cannot be processed in the constructor
     * because these properties haven't been calculated by that point.
     *
     * @param {?} gutterSize Size of the grid's gutter.
     * @param {?} tracker Instance of the TileCoordinator.
     * @param {?} cols Amount of columns in the grid.
     * @param {?} direction Layout direction of the grid.
     * @return {?}
     */
    TileStyler.prototype.init = function (gutterSize, tracker, cols, direction) {
        this._gutterSize = normalizeUnits(gutterSize);
        this._rows = tracker.rowCount;
        this._rowspan = tracker.rowspan;
        this._cols = cols;
        this._direction = direction;
    };
    /**
     * Computes the amount of space a single 1x1 tile would take up (width or height).
     * Used as a basis for other calculations.
     * @param {?} sizePercent Percent of the total grid-list space that one 1x1 tile would take up.
     * @param {?} gutterFraction Fraction of the gutter size taken up by one 1x1 tile.
     * @return {?} The size of a 1x1 tile as an expression that can be evaluated via CSS calc().
     */
    TileStyler.prototype.getBaseTileSize = function (sizePercent, gutterFraction) {
        // Take the base size percent (as would be if evenly dividing the size between cells),
        // and then subtracting the size of one gutter. However, since there are no gutters on the
        // edges, each tile only uses a fraction (gutterShare = numGutters / numCells) of the gutter
        // size. (Imagine having one gutter per tile, and then breaking up the extra gutter on the
        // edge evenly among the cells).
        return "(" + sizePercent + "% - ( " + this._gutterSize + " * " + gutterFraction + " ))";
    };
    /**
     * Gets The horizontal or vertical position of a tile, e.g., the 'top' or 'left' property value.
     * @param {?} baseSize Base size of a 1x1 tile (as computed in getBaseTileSize).
     * @param {?} offset Number of tiles that have already been rendered in the row/column.
     * @return {?} Position of the tile as a CSS calc() expression.
     */
    TileStyler.prototype.getTilePosition = function (baseSize, offset) {
        // The position comes the size of a 1x1 tile plus gutter for each previous tile in the
        // row/column (offset).
        return calc("(" + baseSize + " + " + this._gutterSize + ") * " + offset);
    };
    /**
     * Gets the actual size of a tile, e.g., width or height, taking rowspan or colspan into account.
     * @param {?} baseSize Base size of a 1x1 tile (as computed in getBaseTileSize).
     * @param {?} span The tile's rowspan or colspan.
     * @return {?} Size of the tile as a CSS calc() expression.
     */
    TileStyler.prototype.getTileSize = function (baseSize, span) {
        return "(" + baseSize + " * " + span + ") + (" + (span - 1) + " * " + this._gutterSize + ")";
    };
    /**
     * Sets the style properties to be applied to a tile for the given row and column index.
     * @param {?} tile Tile to which to apply the styling.
     * @param {?} rowIndex Index of the tile's row.
     * @param {?} colIndex Index of the tile's column.
     * @return {?}
     */
    TileStyler.prototype.setStyle = function (tile, rowIndex, colIndex) {
        // Percent of the available horizontal space that one column takes up.
        var /** @type {?} */ percentWidthPerTile = 100 / this._cols;
        // Fraction of the vertical gutter size that each column takes up.
        // For example, if there are 5 columns, each column uses 4/5 = 0.8 times the gutter width.
        var /** @type {?} */ gutterWidthFractionPerTile = (this._cols - 1) / this._cols;
        this.setColStyles(tile, colIndex, percentWidthPerTile, gutterWidthFractionPerTile);
        this.setRowStyles(tile, rowIndex, percentWidthPerTile, gutterWidthFractionPerTile);
    };
    /**
     * Sets the horizontal placement of the tile in the list.
     * @param {?} tile
     * @param {?} colIndex
     * @param {?} percentWidth
     * @param {?} gutterWidth
     * @return {?}
     */
    TileStyler.prototype.setColStyles = function (tile, colIndex, percentWidth, gutterWidth) {
        // Base horizontal size of a column.
        var /** @type {?} */ baseTileWidth = this.getBaseTileSize(percentWidth, gutterWidth);
        // The width and horizontal position of each tile is always calculated the same way, but the
        // height and vertical position depends on the rowMode.
        var /** @type {?} */ side = this._direction === 'ltr' ? 'left' : 'right';
        tile._setStyle(side, this.getTilePosition(baseTileWidth, colIndex));
        tile._setStyle('width', calc(this.getTileSize(baseTileWidth, tile.colspan)));
    };
    /**
     * Calculates the total size taken up by gutters across one axis of a list.
     * @return {?}
     */
    TileStyler.prototype.getGutterSpan = function () {
        return this._gutterSize + " * (" + this._rowspan + " - 1)";
    };
    /**
     * Calculates the total size taken up by tiles across one axis of a list.
     * @param {?} tileHeight Height of the tile.
     * @return {?}
     */
    TileStyler.prototype.getTileSpan = function (tileHeight) {
        return this._rowspan + " * " + this.getTileSize(tileHeight, 1);
    };
    /**
     * Sets the vertical placement of the tile in the list.
     * This method will be implemented by each type of TileStyler.
     * \@docs-private
     * @param {?} tile
     * @param {?} rowIndex
     * @param {?} percentWidth
     * @param {?} gutterWidth
     * @return {?}
     */
    TileStyler.prototype.setRowStyles = function (tile, rowIndex, percentWidth, gutterWidth) { };
    /**
     * Calculates the computed height and returns the correct style property to set.
     * This method will be implemented by each type of TileStyler.
     * \@docs-private
     * @return {?}
     */
    TileStyler.prototype.getComputedHeight = function () { return null; };
    return TileStyler;
}());
/**
 * This type of styler is instantiated when the user passes in a fixed row height.
 * Example <md-grid-list cols="3" rowHeight="100px">
 * \@docs-private
 */
var FixedTileStyler = (function (_super) {
    __extends(FixedTileStyler, _super);
    /**
     * @param {?} fixedRowHeight
     */
    function FixedTileStyler(fixedRowHeight) {
        var _this = _super.call(this) || this;
        _this.fixedRowHeight = fixedRowHeight;
        return _this;
    }
    /**
     * @param {?} gutterSize
     * @param {?} tracker
     * @param {?} cols
     * @param {?} direction
     * @return {?}
     */
    FixedTileStyler.prototype.init = function (gutterSize, tracker, cols, direction) {
        _super.prototype.init.call(this, gutterSize, tracker, cols, direction);
        this.fixedRowHeight = normalizeUnits(this.fixedRowHeight);
    };
    /**
     * @param {?} tile
     * @param {?} rowIndex
     * @param {?} percentWidth
     * @param {?} gutterWidth
     * @return {?}
     */
    FixedTileStyler.prototype.setRowStyles = function (tile, rowIndex, percentWidth, gutterWidth) {
        tile._setStyle('top', this.getTilePosition(this.fixedRowHeight, rowIndex));
        tile._setStyle('height', calc(this.getTileSize(this.fixedRowHeight, tile.rowspan)));
    };
    /**
     * @return {?}
     */
    FixedTileStyler.prototype.getComputedHeight = function () {
        return [
            'height', calc(this.getTileSpan(this.fixedRowHeight) + " + " + this.getGutterSpan())
        ];
    };
    return FixedTileStyler;
}(TileStyler));
/**
 * This type of styler is instantiated when the user passes in a width:height ratio
 * for the row height.  Example <md-grid-list cols="3" rowHeight="3:1">
 * \@docs-private
 */
var RatioTileStyler = (function (_super) {
    __extends(RatioTileStyler, _super);
    /**
     * @param {?} value
     */
    function RatioTileStyler(value) {
        var _this = _super.call(this) || this;
        _this._parseRatio(value);
        return _this;
    }
    /**
     * @param {?} tile
     * @param {?} rowIndex
     * @param {?} percentWidth
     * @param {?} gutterWidth
     * @return {?}
     */
    RatioTileStyler.prototype.setRowStyles = function (tile, rowIndex, percentWidth, gutterWidth) {
        var /** @type {?} */ percentHeightPerTile = percentWidth / this.rowHeightRatio;
        this.baseTileHeight = this.getBaseTileSize(percentHeightPerTile, gutterWidth);
        // Use paddingTop and marginTop to maintain the given aspect ratio, as
        // a percentage-based value for these properties is applied versus the *width* of the
        // containing block. See http://www.w3.org/TR/CSS2/box.html#margin-properties
        tile._setStyle('marginTop', this.getTilePosition(this.baseTileHeight, rowIndex));
        tile._setStyle('paddingTop', calc(this.getTileSize(this.baseTileHeight, tile.rowspan)));
    };
    /**
     * @return {?}
     */
    RatioTileStyler.prototype.getComputedHeight = function () {
        return [
            'paddingBottom', calc(this.getTileSpan(this.baseTileHeight) + " + " + this.getGutterSpan())
        ];
    };
    /**
     * @param {?} value
     * @return {?}
     */
    RatioTileStyler.prototype._parseRatio = function (value) {
        var /** @type {?} */ ratioParts = value.split(':');
        if (ratioParts.length !== 2) {
            throw new MdGridListBadRatioError(value);
        }
        this.rowHeightRatio = parseFloat(ratioParts[0]) / parseFloat(ratioParts[1]);
    };
    return RatioTileStyler;
}(TileStyler));
/**
 * This type of styler is instantiated when the user selects a "fit" row height mode.
 * In other words, the row height will reflect the total height of the container divided
 * by the number of rows.  Example <md-grid-list cols="3" rowHeight="fit">
 *
 * \@docs-private
 */
var FitTileStyler = (function (_super) {
    __extends(FitTileStyler, _super);
    function FitTileStyler() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @param {?} tile
     * @param {?} rowIndex
     * @param {?} percentWidth
     * @param {?} gutterWidth
     * @return {?}
     */
    FitTileStyler.prototype.setRowStyles = function (tile, rowIndex, percentWidth, gutterWidth) {
        // Percent of the available vertical space that one row takes up.
        var /** @type {?} */ percentHeightPerTile = 100 / this._rowspan;
        // Fraction of the horizontal gutter size that each column takes up.
        var /** @type {?} */ gutterHeightPerTile = (this._rows - 1) / this._rows;
        // Base vertical size of a column.
        var /** @type {?} */ baseTileHeight = this.getBaseTileSize(percentHeightPerTile, gutterHeightPerTile);
        tile._setStyle('top', this.getTilePosition(baseTileHeight, rowIndex));
        tile._setStyle('height', calc(this.getTileSize(baseTileHeight, tile.rowspan)));
    };
    return FitTileStyler;
}(TileStyler));
/**
 * Wraps a CSS string in a calc function
 * @param {?} exp
 * @return {?}
 */
function calc(exp) { return "calc(" + exp + ")"; }
/**
 * Appends pixels to a CSS string if no units are given.
 * @param {?} value
 * @return {?}
 */
function normalizeUnits(value) {
    return (value.match(/px|em|rem/)) ? value : value + 'px';
}
// TODO(kara): Conditional (responsive) column count / row size.
// TODO(kara): Re-layout on window resize / media change (debounced).
// TODO(kara): gridTileHeader and gridTileFooter.
var MD_FIT_MODE = 'fit';
var MdGridList = (function () {
    /**
     * @param {?} _renderer
     * @param {?} _element
     * @param {?} _dir
     */
    function MdGridList(_renderer, _element, _dir) {
        this._renderer = _renderer;
        this._element = _element;
        this._dir = _dir;
        this._gutter = '1px';
    }
    Object.defineProperty(MdGridList.prototype, "cols", {
        /**
         * Amount of columns in the grid list.
         * @return {?}
         */
        get: function () { return this._cols; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this._cols = coerceToNumber(value); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdGridList.prototype, "gutterSize", {
        /**
         * Size of the grid list's gutter in pixels.
         * @return {?}
         */
        get: function () { return this._gutter; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this._gutter = coerceToString(value); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdGridList.prototype, "rowHeight", {
        /**
         * Set internal representation of row height from the user-provided value.
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._rowHeight = coerceToString(value);
            this._setTileStyler();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    MdGridList.prototype.ngOnInit = function () {
        this._checkCols();
        this._checkRowHeight();
    };
    /**
     * The layout calculation is fairly cheap if nothing changes, so there's little cost
     * to run it frequently.
     * @return {?}
     */
    MdGridList.prototype.ngAfterContentChecked = function () {
        this._layoutTiles();
    };
    /**
     * Throw a friendly error if cols property is missing
     * @return {?}
     */
    MdGridList.prototype._checkCols = function () {
        if (!this.cols) {
            throw new MdGridListColsError();
        }
    };
    /**
     * Default to equal width:height if rowHeight property is missing
     * @return {?}
     */
    MdGridList.prototype._checkRowHeight = function () {
        if (!this._rowHeight) {
            this._tileStyler = new RatioTileStyler('1:1');
        }
    };
    /**
     * Creates correct Tile Styler subtype based on rowHeight passed in by user
     * @return {?}
     */
    MdGridList.prototype._setTileStyler = function () {
        if (this._rowHeight === MD_FIT_MODE) {
            this._tileStyler = new FitTileStyler();
        }
        else if (this._rowHeight && this._rowHeight.indexOf(':') > -1) {
            this._tileStyler = new RatioTileStyler(this._rowHeight);
        }
        else {
            this._tileStyler = new FixedTileStyler(this._rowHeight);
        }
    };
    /**
     * Computes and applies the size and position for all children grid tiles.
     * @return {?}
     */
    MdGridList.prototype._layoutTiles = function () {
        var _this = this;
        var /** @type {?} */ tracker = new TileCoordinator(this.cols, this._tiles);
        var /** @type {?} */ direction = this._dir ? this._dir.value : 'ltr';
        this._tileStyler.init(this.gutterSize, tracker, this.cols, direction);
        this._tiles.forEach(function (tile, index) {
            var /** @type {?} */ pos = tracker.positions[index];
            _this._tileStyler.setStyle(tile, pos.row, pos.col);
        });
        this._setListStyle(this._tileStyler.getComputedHeight());
    };
    /**
     * Sets style on the main grid-list element, given the style name and value.
     * @param {?} style
     * @return {?}
     */
    MdGridList.prototype._setListStyle = function (style$$1) {
        if (style$$1) {
            this._renderer.setElementStyle(this._element.nativeElement, style$$1[0], style$$1[1]);
        }
    };
    return MdGridList;
}());
MdGridList.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{ selector: 'md-grid-list, mat-grid-list',
                template: "<div> <ng-content></ng-content> </div>",
                styles: [".mat-grid-list{display:block;position:relative}.mat-grid-tile{display:block;position:absolute;overflow:hidden}.mat-grid-tile .mat-figure{display:flex;position:absolute;align-items:center;justify-content:center;height:100%;top:0;right:0;bottom:0;left:0;padding:0;margin:0}.mat-grid-tile .mat-grid-tile-footer,.mat-grid-tile .mat-grid-tile-header{display:flex;align-items:center;height:48px;color:#fff;background:rgba(0,0,0,.38);overflow:hidden;padding:0 16px;font-size:16px;position:absolute;left:0;right:0}.mat-grid-tile .mat-grid-tile-footer .mat-line,.mat-grid-tile .mat-grid-tile-header .mat-line{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:block;box-sizing:border-box}.mat-grid-tile .mat-grid-tile-footer .mat-line:nth-child(n+2),.mat-grid-tile .mat-grid-tile-header .mat-line:nth-child(n+2){font-size:12px}.mat-grid-tile .mat-grid-tile-footer>*,.mat-grid-tile .mat-grid-tile-header>*{margin:0;padding:0;font-weight:400;font-size:inherit}.mat-grid-tile .mat-grid-tile-footer.mat-2-line,.mat-grid-tile .mat-grid-tile-header.mat-2-line{height:68px}.mat-grid-tile .mat-grid-list-text{display:flex;flex-direction:column;width:100%;box-sizing:border-box;overflow:hidden}.mat-grid-tile .mat-grid-list-text>*{margin:0;padding:0;font-weight:400;font-size:inherit}.mat-grid-tile .mat-grid-list-text:empty{display:none}.mat-grid-tile .mat-grid-tile-header{top:0}.mat-grid-tile .mat-grid-tile-footer{bottom:0}.mat-grid-tile .mat-grid-avatar{padding-right:16px}[dir=rtl] .mat-grid-tile .mat-grid-avatar{padding-right:0;padding-left:16px}.mat-grid-tile .mat-grid-avatar:empty{display:none} /*# sourceMappingURL=grid-list.css.map */ "],
                host: {
                    'role': 'list',
                    '[class.mat-grid-list]': 'true',
                },
                encapsulation: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewEncapsulation"].None,
            },] },
];
/**
 * @nocollapse
 */
MdGridList.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
    { type: Dir, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] },] },
]; };
MdGridList.propDecorators = {
    '_tiles': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ContentChildren"], args: [MdGridTile,] },],
    'cols': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'gutterSize': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'rowHeight': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
};
var MdGridListModule = (function () {
    function MdGridListModule() {
    }
    /**
     * @deprecated
     * @return {?}
     */
    MdGridListModule.forRoot = function () {
        return {
            ngModule: MdGridListModule,
            providers: []
        };
    };
    return MdGridListModule;
}());
MdGridListModule.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{
                imports: [MdLineModule, CompatibilityModule],
                exports: [
                    MdGridList,
                    MdGridTile,
                    MdGridTileText,
                    MdLineModule,
                    CompatibilityModule,
                    MdGridTileHeaderCssMatStyler,
                    MdGridTileFooterCssMatStyler,
                    MdGridAvatarCssMatStyler
                ],
                declarations: [
                    MdGridList,
                    MdGridTile,
                    MdGridTileText,
                    MdGridTileHeaderCssMatStyler,
                    MdGridTileFooterCssMatStyler,
                    MdGridAvatarCssMatStyler
                ],
            },] },
];
/**
 * @nocollapse
 */
MdGridListModule.ctorParameters = function () { return []; };
/**
 * Content of a card, needed as it's used as a selector in the API.
 * \@docs-private
 */
var MdCardContent = (function () {
    function MdCardContent() {
    }
    return MdCardContent;
}());
MdCardContent.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                selector: 'md-card-content, mat-card-content',
                host: {
                    '[class.mat-card-content]': 'true'
                }
            },] },
];
/**
 * @nocollapse
 */
MdCardContent.ctorParameters = function () { return []; };
/**
 * Title of a card, needed as it's used as a selector in the API.
 * \@docs-private
 */
var MdCardTitle = (function () {
    function MdCardTitle() {
    }
    return MdCardTitle;
}());
MdCardTitle.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                selector: 'md-card-title, mat-card-title',
                host: {
                    '[class.mat-card-title]': 'true'
                }
            },] },
];
/**
 * @nocollapse
 */
MdCardTitle.ctorParameters = function () { return []; };
/**
 * Sub-title of a card, needed as it's used as a selector in the API.
 * \@docs-private
 */
var MdCardSubtitle = (function () {
    function MdCardSubtitle() {
    }
    return MdCardSubtitle;
}());
MdCardSubtitle.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                selector: 'md-card-subtitle, mat-card-subtitle',
                host: {
                    '[class.mat-card-subtitle]': 'true'
                }
            },] },
];
/**
 * @nocollapse
 */
MdCardSubtitle.ctorParameters = function () { return []; };
/**
 * Action section of a card, needed as it's used as a selector in the API.
 * \@docs-private
 */
var MdCardActions = (function () {
    function MdCardActions() {
    }
    return MdCardActions;
}());
MdCardActions.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                selector: 'md-card-actions, mat-card-actions',
                host: {
                    '[class.mat-card-actions]': 'true'
                }
            },] },
];
/**
 * @nocollapse
 */
MdCardActions.ctorParameters = function () { return []; };
/**
 * Footer of a card, needed as it's used as a selector in the API.
 * \@docs-private
 */
var MdCardFooter = (function () {
    function MdCardFooter() {
    }
    return MdCardFooter;
}());
MdCardFooter.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                selector: 'md-card-footer, mat-card-footer',
                host: {
                    '[class.mat-card-footer]': 'true'
                }
            },] },
];
/**
 * @nocollapse
 */
MdCardFooter.ctorParameters = function () { return []; };
/**
 * Image used in a card, needed to add the mat- CSS styling.
 * \@docs-private
 */
var MdCardSmImage = (function () {
    function MdCardSmImage() {
    }
    return MdCardSmImage;
}());
MdCardSmImage.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                selector: '[md-card-sm-image], [mat-card-sm-image]',
                host: {
                    '[class.mat-card-sm-image]': 'true'
                }
            },] },
];
/**
 * @nocollapse
 */
MdCardSmImage.ctorParameters = function () { return []; };
/**
 * Image used in a card, needed to add the mat- CSS styling.
 * \@docs-private
 */
var MdCardMdImage = (function () {
    function MdCardMdImage() {
    }
    return MdCardMdImage;
}());
MdCardMdImage.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                selector: '[md-card-md-image], [mat-card-md-image]',
                host: {
                    '[class.mat-card-md-image]': 'true'
                }
            },] },
];
/**
 * @nocollapse
 */
MdCardMdImage.ctorParameters = function () { return []; };
/**
 * Image used in a card, needed to add the mat- CSS styling.
 * \@docs-private
 */
var MdCardLgImage = (function () {
    function MdCardLgImage() {
    }
    return MdCardLgImage;
}());
MdCardLgImage.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                selector: '[md-card-lg-image], [mat-card-lg-image]',
                host: {
                    'class.mat-card-lg-image': 'true'
                }
            },] },
];
/**
 * @nocollapse
 */
MdCardLgImage.ctorParameters = function () { return []; };
/**
 * Image used in a card, needed to add the mat- CSS styling.
 * \@docs-private
 */
var MdCardImage = (function () {
    function MdCardImage() {
    }
    return MdCardImage;
}());
MdCardImage.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                selector: '[md-card-image], [mat-card-image]',
                host: {
                    '[class.mat-card-image]': 'true'
                }
            },] },
];
/**
 * @nocollapse
 */
MdCardImage.ctorParameters = function () { return []; };
/**
 * Large image used in a card, needed to add the mat- CSS styling.
 * \@docs-private
 */
var MdCardXlImage = (function () {
    function MdCardXlImage() {
    }
    return MdCardXlImage;
}());
MdCardXlImage.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                selector: '[md-card-xl-image], [mat-card-xl-image]',
                host: {
                    '[class.mat-card-xl-image]': 'true'
                }
            },] },
];
/**
 * @nocollapse
 */
MdCardXlImage.ctorParameters = function () { return []; };
/**
 * Avatar image used in a card, needed to add the mat- CSS styling.
 * \@docs-private
 */
var MdCardAvatar = (function () {
    function MdCardAvatar() {
    }
    return MdCardAvatar;
}());
MdCardAvatar.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                selector: '[md-card-avatar], [mat-card-avatar]',
                host: {
                    '[class.mat-card-avatar]': 'true'
                }
            },] },
];
/**
 * @nocollapse
 */
MdCardAvatar.ctorParameters = function () { return []; };
/**
 * A basic content container component that adds the styles of a Material design card.
 *
 * While this component can be used alone, it also provides a number
 * of preset styles for common card sections, including:
 * - md-card-title
 * - md-card-subtitle
 * - md-card-content
 * - md-card-actions
 * - md-card-footer
 */
var MdCard = (function () {
    function MdCard() {
    }
    return MdCard;
}());
MdCard.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{ selector: 'md-card, mat-card',
                template: "<ng-content></ng-content> ",
                styles: [".mat-card{transition:box-shadow 280ms cubic-bezier(.4,0,.2,1);will-change:box-shadow;display:block;position:relative;padding:24px;border-radius:2px;font-family:Roboto,\"Helvetica Neue\",sans-serif}.mat-card:not([class*=mat-elevation-z]){box-shadow:0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12)}@media screen and (-ms-high-contrast:active){.mat-card{outline:solid 1px}}.mat-card-flat{box-shadow:none}.mat-card-actions,.mat-card-content,.mat-card-subtitle,.mat-card-title{display:block;margin-bottom:16px}.mat-card-title{font-size:24px;font-weight:400}.mat-card-subtitle{font-size:14px}.mat-card-content{font-size:14px}.mat-card-actions{margin-left:-16px;margin-right:-16px;padding:8px 0}.mat-card-actions[align=end]{display:flex;justify-content:flex-end}.mat-card-image{width:calc(100% + 48px);margin:0 -24px 16px -24px}.mat-card-xl-image{width:240px;height:240px;margin:-8px}.mat-card-footer{position:absolute;width:100%;min-height:5px;bottom:0;left:0}.mat-card-actions .mat-button,.mat-card-actions .mat-raised-button{margin:0 4px}.mat-card-header{display:flex;flex-direction:row}.mat-card-header-text{margin:0 8px}.mat-card-avatar{height:40px;width:40px;border-radius:50%;flex-shrink:0}.mat-card-header .mat-card-title{font-size:14px}.mat-card-lg-image,.mat-card-md-image,.mat-card-sm-image{margin:-8px 0}.mat-card-title-group{display:flex;justify-content:space-between;margin:0 -8px}.mat-card-sm-image{width:80px;height:80px}.mat-card-md-image{width:112px;height:112px}.mat-card-lg-image{width:152px;height:152px}@media (max-width:600px){.mat-card{padding:24px 16px}.mat-card-actions{margin-left:-8px;margin-right:-8px}.mat-card-image{width:calc(100% + 32px);margin:16px -16px}.mat-card-title-group{margin:0}.mat-card-xl-image{margin-left:0;margin-right:0}.mat-card-header{margin:-8px 0 0 0}}.mat-card-content>:first-child,.mat-card>:first-child{margin-top:0}.mat-card-content>:last-child,.mat-card>:last-child{margin-bottom:0}.mat-card-image:first-child{margin-top:-24px}.mat-card>.mat-card-actions:last-child{margin-bottom:-16px;padding-bottom:0}.mat-card-actions .mat-button:first-child,.mat-card-actions .mat-raised-button:first-child{margin-left:0;margin-right:0}.mat-card-subtitle:not(:first-child),.mat-card-title:not(:first-child){margin-top:-4px}.mat-card-header .mat-card-subtitle:not(:first-child){margin-top:-8px}.mat-card>.mat-card-xl-image:first-child{margin-top:-8px}.mat-card>.mat-card-xl-image:last-child{margin-bottom:-8px} /*# sourceMappingURL=card.css.map */ "],
                encapsulation: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewEncapsulation"].None,
                changeDetection: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectionStrategy"].OnPush,
                host: {
                    '[class.mat-card]': 'true'
                }
            },] },
];
/**
 * @nocollapse
 */
MdCard.ctorParameters = function () { return []; };
/**
 * Component intended to be used within the `<md-card>` component. It adds styles for a
 * preset header section (i.e. a title, subtitle, and avatar layout).
 * \@docs-private
 */
var MdCardHeader = (function () {
    function MdCardHeader() {
    }
    return MdCardHeader;
}());
MdCardHeader.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{ selector: 'md-card-header, mat-card-header',
                template: "<ng-content select=\"[md-card-avatar], [mat-card-avatar]\"></ng-content> <div class=\"mat-card-header-text\"> <ng-content select=\"md-card-title, mat-card-title, md-card-subtitle, mat-card-subtitle\"></ng-content> </div> <ng-content></ng-content> ",
                encapsulation: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewEncapsulation"].None,
                changeDetection: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectionStrategy"].OnPush,
                host: {
                    '[class.mat-card-header]': 'true'
                }
            },] },
];
/**
 * @nocollapse
 */
MdCardHeader.ctorParameters = function () { return []; };
/**
 * Component intended to be used within the <md-card> component. It adds styles for a preset
 * layout that groups an image with a title section.
 * \@docs-private
 */
var MdCardTitleGroup = (function () {
    function MdCardTitleGroup() {
    }
    return MdCardTitleGroup;
}());
MdCardTitleGroup.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{ selector: 'md-card-title-group, mat-card-title-group',
                template: "<div> <ng-content select=\"md-card-title, mat-card-title, md-card-subtitle, mat-card-subtitle\"></ng-content> </div> <ng-content select=\"img\"></ng-content> <ng-content></ng-content> ",
                encapsulation: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewEncapsulation"].None,
                changeDetection: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectionStrategy"].OnPush,
                host: {
                    '[class.mat-card-title-group]': 'true'
                }
            },] },
];
/**
 * @nocollapse
 */
MdCardTitleGroup.ctorParameters = function () { return []; };
var MdCardModule = (function () {
    function MdCardModule() {
    }
    /**
     * @deprecated
     * @return {?}
     */
    MdCardModule.forRoot = function () {
        return {
            ngModule: MdCardModule,
            providers: []
        };
    };
    return MdCardModule;
}());
MdCardModule.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{
                imports: [CompatibilityModule],
                exports: [
                    MdCard,
                    MdCardHeader,
                    MdCardTitleGroup,
                    MdCardContent,
                    MdCardTitle,
                    MdCardSubtitle,
                    MdCardActions,
                    MdCardFooter,
                    MdCardSmImage,
                    MdCardMdImage,
                    MdCardLgImage,
                    MdCardImage,
                    MdCardXlImage,
                    MdCardAvatar,
                    CompatibilityModule,
                ],
                declarations: [
                    MdCard, MdCardHeader, MdCardTitleGroup, MdCardContent, MdCardTitle, MdCardSubtitle,
                    MdCardActions, MdCardFooter, MdCardSmImage, MdCardMdImage, MdCardLgImage, MdCardImage,
                    MdCardXlImage, MdCardAvatar,
                ],
            },] },
];
/**
 * @nocollapse
 */
MdCardModule.ctorParameters = function () { return []; };
/**
 * Material design styled Chip component. Used inside the MdChipList component.
 */
var MdChip = (function () {
    /**
     * @param {?} _renderer
     * @param {?} _elementRef
     */
    function MdChip(_renderer, _elementRef) {
        this._renderer = _renderer;
        this._elementRef = _elementRef;
        /** Whether or not the chip is disabled. Disabled chips cannot be focused. */
        this._disabled = null;
        /** Whether or not the chip is selected. */
        this._selected = false;
        /** The palette color of selected chips. */
        this._color = 'primary';
        /** Emitted when the chip is focused. */
        this.onFocus = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /** Emitted when the chip is selected. */
        this.select = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /** Emitted when the chip is deselected. */
        this.deselect = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /** Emitted when the chip is destroyed. */
        this.destroy = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
    }
    /**
     * @return {?}
     */
    MdChip.prototype.ngOnInit = function () {
        this._addDefaultCSSClass();
        this._updateColor(this._color);
    };
    /**
     * @return {?}
     */
    MdChip.prototype.ngOnDestroy = function () {
        this.destroy.emit({ chip: this });
    };
    Object.defineProperty(MdChip.prototype, "disabled", {
        /**
         * Whether or not the chip is disabled.
         * @return {?}
         */
        get: function () {
            return this._disabled;
        },
        /**
         * Sets the disabled state of the chip.
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._disabled = coerceBooleanProperty(value) ? true : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdChip.prototype, "_isAriaDisabled", {
        /**
         * A String representation of the current disabled state.
         * @return {?}
         */
        get: function () {
            return String(coerceBooleanProperty(this.disabled));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdChip.prototype, "selected", {
        /**
         * Whether or not this chip is selected.
         * @return {?}
         */
        get: function () {
            return this._selected;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._selected = coerceBooleanProperty(value);
            if (this._selected) {
                this.select.emit({ chip: this });
            }
            else {
                this.deselect.emit({ chip: this });
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Toggles the current selected state of this chip.
     * @return {?} Whether the chip is selected.
     */
    MdChip.prototype.toggleSelected = function () {
        this.selected = !this.selected;
        return this.selected;
    };
    Object.defineProperty(MdChip.prototype, "color", {
        /**
         * The color of the chip. Can be `primary`, `accent`, or `warn`.
         * @return {?}
         */
        get: function () {
            return this._color;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._updateColor(value);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Allows for programmatic focusing of the chip.
     * @return {?}
     */
    MdChip.prototype.focus = function () {
        this._renderer.invokeElementMethod(this._elementRef.nativeElement, 'focus');
        this.onFocus.emit({ chip: this });
    };
    /**
     * Ensures events fire properly upon click.
     * @param {?} event
     * @return {?}
     */
    MdChip.prototype._handleClick = function (event) {
        // Check disabled
        if (this.disabled) {
            event.preventDefault();
            event.stopPropagation();
        }
        else {
            this.focus();
        }
    };
    /**
     * Initializes the appropriate CSS classes based on the chip type (basic or standard).
     * @return {?}
     */
    MdChip.prototype._addDefaultCSSClass = function () {
        var /** @type {?} */ el = this._elementRef.nativeElement;
        // Always add the `mat-chip` class
        el.classList.add('mat-chip');
        // If we are a basic chip, also add the `mat-basic-chip` class for :not() targeting
        if (el.nodeName.toLowerCase() == 'mat-basic-chip' || el.hasAttribute('mat-basic-chip') ||
            el.nodeName.toLowerCase() == 'md-basic-chip' || el.hasAttribute('md-basic-chip')) {
            el.classList.add('mat-basic-chip');
        }
    };
    /**
     * Updates the private _color variable and the native element.
     * @param {?} newColor
     * @return {?}
     */
    MdChip.prototype._updateColor = function (newColor) {
        this._setElementColor(this._color, false);
        this._setElementColor(newColor, true);
        this._color = newColor;
    };
    /**
     * Sets the mat-color on the native element.
     * @param {?} color
     * @param {?} isAdd
     * @return {?}
     */
    MdChip.prototype._setElementColor = function (color, isAdd) {
        if (color != null && color != '') {
            this._renderer.setElementClass(this._elementRef.nativeElement, "mat-" + color, isAdd);
        }
    };
    return MdChip;
}());
MdChip.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{
                selector: "md-basic-chip, [md-basic-chip], md-chip, [md-chip],\n             mat-basic-chip, [mat-basic-chip], mat-chip, [mat-chip]",
                template: "<ng-content></ng-content>",
                host: {
                    '[class.mat-chip]': 'true',
                    'tabindex': '-1',
                    'role': 'option',
                    '[class.mat-chip-selected]': 'selected',
                    '[attr.disabled]': 'disabled',
                    '[attr.aria-disabled]': '_isAriaDisabled',
                    '(click)': '_handleClick($event)'
                }
            },] },
];
/**
 * @nocollapse
 */
MdChip.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
]; };
MdChip.propDecorators = {
    'select': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
    'deselect': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
    'destroy': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
    'disabled': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'selected': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'color': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
};
/**
 * A material design chips component (named ChipList for it's similarity to the List component).
 *
 * Example:
 *
 *     <md-chip-list>
 *       <md-chip>Chip 1<md-chip>
 *       <md-chip>Chip 2<md-chip>
 *     </md-chip-list>
 */
var MdChipList = (function () {
    /**
     * @param {?} _elementRef
     */
    function MdChipList(_elementRef) {
        this._elementRef = _elementRef;
        this._subscribed = new WeakMap();
        /** Whether or not the chip is selectable. */
        this._selectable = true;
    }
    /**
     * @return {?}
     */
    MdChipList.prototype.ngAfterContentInit = function () {
        var _this = this;
        this._keyManager = new FocusKeyManager(this.chips).withWrap();
        // Go ahead and subscribe all of the initial chips
        this._subscribeChips(this.chips);
        // When the list changes, re-subscribe
        this.chips.changes.subscribe(function (chips) {
            _this._subscribeChips(chips);
        });
    };
    Object.defineProperty(MdChipList.prototype, "selectable", {
        /**
         * Whether or not this chip is selectable. When a chip is not selectable,
         * it's selected state is always ignored.
         * @return {?}
         */
        get: function () {
            return this._selectable;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._selectable = coerceBooleanProperty(value);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Programmatically focus the chip list. This in turn focuses the first
     * non-disabled chip in this chip list.
     * @return {?}
     */
    MdChipList.prototype.focus = function () {
        // TODO: ARIA says this should focus the first `selected` chip.
        this._keyManager.setFirstItemActive();
    };
    /**
     * Passes relevant key presses to our key manager.
     * @param {?} event
     * @return {?}
     */
    MdChipList.prototype._keydown = function (event) {
        var /** @type {?} */ target = (event.target);
        // If they are on a chip, check for space/left/right, otherwise pass to our key manager
        if (target && target.classList.contains('mat-chip')) {
            switch (event.keyCode) {
                case SPACE:
                    // If we are selectable, toggle the focused chip
                    if (this.selectable) {
                        this._toggleSelectOnFocusedChip();
                    }
                    // Always prevent space from scrolling the page since the list has focus
                    event.preventDefault();
                    break;
                case LEFT_ARROW:
                    this._keyManager.setPreviousItemActive();
                    event.preventDefault();
                    break;
                case RIGHT_ARROW:
                    this._keyManager.setNextItemActive();
                    event.preventDefault();
                    break;
                default:
                    this._keyManager.onKeydown(event);
            }
        }
    };
    /**
     * Toggles the selected state of the currently focused chip.
     * @return {?}
     */
    MdChipList.prototype._toggleSelectOnFocusedChip = function () {
        // Allow disabling of chip selection
        if (!this.selectable) {
            return;
        }
        var /** @type {?} */ focusedIndex = this._keyManager.activeItemIndex;
        if (this._isValidIndex(focusedIndex)) {
            var /** @type {?} */ focusedChip = this.chips.toArray()[focusedIndex];
            if (focusedChip) {
                focusedChip.toggleSelected();
            }
        }
    };
    /**
     * Iterate through the list of chips and add them to our list of
     * subscribed chips.
     *
     * @param {?} chips The list of chips to be subscribed.
     * @return {?}
     */
    MdChipList.prototype._subscribeChips = function (chips) {
        var _this = this;
        chips.forEach(function (chip) { return _this._addChip(chip); });
    };
    /**
     * Add a specific chip to our subscribed list. If the chip has
     * already been subscribed, this ensures it is only subscribed
     * once.
     *
     * @param {?} chip The chip to be subscribed (or checked for existing
     * subscription).
     * @return {?}
     */
    MdChipList.prototype._addChip = function (chip) {
        var _this = this;
        // If we've already been subscribed to a parent, do nothing
        if (this._subscribed.has(chip)) {
            return;
        }
        // Watch for focus events outside of the keyboard navigation
        chip.onFocus.subscribe(function () {
            var /** @type {?} */ chipIndex = _this.chips.toArray().indexOf(chip);
            if (_this._isValidIndex(chipIndex)) {
                _this._keyManager.updateActiveItemIndex(chipIndex);
            }
        });
        // On destroy, remove the item from our list, and check focus
        chip.destroy.subscribe(function () {
            var /** @type {?} */ chipIndex = _this.chips.toArray().indexOf(chip);
            if (_this._isValidIndex(chipIndex)) {
                // Check whether the chip is the last item
                if (chipIndex < _this.chips.length - 1) {
                    _this._keyManager.setActiveItem(chipIndex);
                }
                else if (chipIndex - 1 >= 0) {
                    _this._keyManager.setActiveItem(chipIndex - 1);
                }
            }
            _this._subscribed.delete(chip);
            chip.destroy.unsubscribe();
        });
        this._subscribed.set(chip, true);
    };
    /**
     * Utility to ensure all indexes are valid.
     *
     * @param {?} index The index to be checked.
     * @return {?} True if the index is valid for our list of chips.
     */
    MdChipList.prototype._isValidIndex = function (index) {
        return index >= 0 && index < this.chips.length;
    };
    return MdChipList;
}());
MdChipList.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{ selector: 'md-chip-list, mat-chip-list',
                template: "<div class=\"mat-chip-list-wrapper\"><ng-content></ng-content></div>",
                host: {
                    // Properties
                    'tabindex': '0',
                    'role': 'listbox',
                    '[class.mat-chip-list]': 'true',
                    // Events
                    '(focus)': 'focus()',
                    '(keydown)': '_keydown($event)'
                },
                queries: {
                    chips: new __WEBPACK_IMPORTED_MODULE_0__angular_core__["ContentChildren"](MdChip)
                },
                styles: [".mat-chip-list-wrapper{display:flex;flex-direction:row;flex-wrap:wrap;align-items:flex-start}.mat-chip-list-wrapper .mat-chip:not(.mat-basic-chip){margin:0 3px 0 3px}.mat-chip-list-wrapper .mat-chip:not(.mat-basic-chip):first-child{margin-left:0;margin-right:3px}[dir=rtl] .mat-chip-list-wrapper .mat-chip:not(.mat-basic-chip):first-child{margin-left:3px;margin-right:0}.mat-chip-list-wrapper .mat-chip:not(.mat-basic-chip):last-child{margin-left:3px;margin-right:0}[dir=rtl] .mat-chip-list-wrapper .mat-chip:not(.mat-basic-chip):last-child{margin-left:0;margin-right:3px}.mat-chip:not(.mat-basic-chip){display:inline-block;padding:8px 12px 8px 12px;border-radius:24px;font-size:13px;line-height:16px}.mat-chip-list-stacked .mat-chip-list-wrapper{display:block}.mat-chip-list-stacked .mat-chip-list-wrapper .mat-chip:not(.mat-basic-chip){display:block;margin:0;margin-bottom:8px}[dir=rtl] .mat-chip-list-stacked .mat-chip-list-wrapper .mat-chip:not(.mat-basic-chip){margin:0;margin-bottom:8px}.mat-chip-list-stacked .mat-chip-list-wrapper .mat-chip:not(.mat-basic-chip):last-child,[dir=rtl] .mat-chip-list-stacked .mat-chip-list-wrapper .mat-chip:not(.mat-basic-chip):last-child{margin-bottom:0} /*# sourceMappingURL=chips.css.map */ "],
                encapsulation: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewEncapsulation"].None,
                changeDetection: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectionStrategy"].OnPush
            },] },
];
/**
 * @nocollapse
 */
MdChipList.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
]; };
MdChipList.propDecorators = {
    'selectable': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
};
var MdChipsModule = (function () {
    function MdChipsModule() {
    }
    /**
     * @deprecated
     * @return {?}
     */
    MdChipsModule.forRoot = function () {
        return {
            ngModule: MdChipsModule,
            providers: []
        };
    };
    return MdChipsModule;
}());
MdChipsModule.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{
                imports: [],
                exports: [MdChipList, MdChip],
                declarations: [MdChipList, MdChip]
            },] },
];
/**
 * @nocollapse
 */
MdChipsModule.ctorParameters = function () { return []; };
/**
 * Exception thrown when attempting to load an icon with a name that cannot be found.
 * \@docs-private
 */
var MdIconNameNotFoundError = (function (_super) {
    __extends(MdIconNameNotFoundError, _super);
    /**
     * @param {?} iconName
     */
    function MdIconNameNotFoundError(iconName) {
        return _super.call(this, "Unable to find icon with the name \"" + iconName + "\"") || this;
    }
    return MdIconNameNotFoundError;
}(MdError));
/**
 * Exception thrown when attempting to load SVG content that does not contain the expected
 * <svg> tag.
 * \@docs-private
 */
var MdIconSvgTagNotFoundError = (function (_super) {
    __extends(MdIconSvgTagNotFoundError, _super);
    function MdIconSvgTagNotFoundError() {
        return _super.call(this, '<svg> tag not found') || this;
    }
    return MdIconSvgTagNotFoundError;
}(MdError));
/**
 * Configuration for an icon, including the URL and possibly the cached SVG element.
 * \@docs-private
 */
var SvgIconConfig = (function () {
    /**
     * @param {?} url
     */
    function SvgIconConfig(url) {
        this.url = url;
        this.svgElement = null;
    }
    return SvgIconConfig;
}());
/** Returns the cache key to use for an icon namespace and name. */
var iconKey = function (namespace, name) { return namespace + ':' + name; };
/**
 * Service to register and display icons used by the <md-icon> component.
 * - Registers icon URLs by namespace and name.
 * - Registers icon set URLs by namespace.
 * - Registers aliases for CSS classes, for use with icon fonts.
 * - Loads icons from URLs and extracts individual icons from icon sets.
 */
var MdIconRegistry = (function () {
    /**
     * @param {?} _http
     * @param {?} _sanitizer
     */
    function MdIconRegistry(_http, _sanitizer) {
        this._http = _http;
        this._sanitizer = _sanitizer;
        this._svgIconConfigs = new Map();
        this._iconSetConfigs = new Map();
        this._cachedIconsByUrl = new Map();
        this._inProgressUrlFetches = new Map();
        this._fontCssClassesByAlias = new Map();
        this._defaultFontSetClass = 'material-icons';
    }
    /**
     * Registers an icon by URL in the default namespace.
     * @param {?} iconName Name under which the icon should be registered.
     * @param {?} url
     * @return {?}
     */
    MdIconRegistry.prototype.addSvgIcon = function (iconName, url) {
        return this.addSvgIconInNamespace('', iconName, url);
    };
    /**
     * Registers an icon by URL in the specified namespace.
     * @param {?} namespace Namespace in which the icon should be registered.
     * @param {?} iconName Name under which the icon should be registered.
     * @param {?} url
     * @return {?}
     */
    MdIconRegistry.prototype.addSvgIconInNamespace = function (namespace, iconName, url) {
        var /** @type {?} */ key = iconKey(namespace, iconName);
        this._svgIconConfigs.set(key, new SvgIconConfig(url));
        return this;
    };
    /**
     * Registers an icon set by URL in the default namespace.
     * @param {?} url
     * @return {?}
     */
    MdIconRegistry.prototype.addSvgIconSet = function (url) {
        return this.addSvgIconSetInNamespace('', url);
    };
    /**
     * Registers an icon set by URL in the specified namespace.
     * @param {?} namespace Namespace in which to register the icon set.
     * @param {?} url
     * @return {?}
     */
    MdIconRegistry.prototype.addSvgIconSetInNamespace = function (namespace, url) {
        var /** @type {?} */ config = new SvgIconConfig(url);
        if (this._iconSetConfigs.has(namespace)) {
            this._iconSetConfigs.get(namespace).push(config);
        }
        else {
            this._iconSetConfigs.set(namespace, [config]);
        }
        return this;
    };
    /**
     * Defines an alias for a CSS class name to be used for icon fonts. Creating an mdIcon
     * component with the alias as the fontSet input will cause the class name to be applied
     * to the <md-icon> element.
     *
     * @param {?} alias Alias for the font.
     * @param {?=} className Class name override to be used instead of the alias.
     * @return {?}
     */
    MdIconRegistry.prototype.registerFontClassAlias = function (alias, className) {
        if (className === void 0) { className = alias; }
        this._fontCssClassesByAlias.set(alias, className);
        return this;
    };
    /**
     * Returns the CSS class name associated with the alias by a previous call to
     * registerFontClassAlias. If no CSS class has been associated, returns the alias unmodified.
     * @param {?} alias
     * @return {?}
     */
    MdIconRegistry.prototype.classNameForFontAlias = function (alias) {
        return this._fontCssClassesByAlias.get(alias) || alias;
    };
    /**
     * Sets the CSS class name to be used for icon fonts when an <md-icon> component does not
     * have a fontSet input value, and is not loading an icon by name or URL.
     *
     * @param {?} className
     * @return {?}
     */
    MdIconRegistry.prototype.setDefaultFontSetClass = function (className) {
        this._defaultFontSetClass = className;
        return this;
    };
    /**
     * Returns the CSS class name to be used for icon fonts when an <md-icon> component does not
     * have a fontSet input value, and is not loading an icon by name or URL.
     * @return {?}
     */
    MdIconRegistry.prototype.getDefaultFontSetClass = function () {
        return this._defaultFontSetClass;
    };
    /**
     * Returns an Observable that produces the icon (as an <svg> DOM element) from the given URL.
     * The response from the URL may be cached so this will not always cause an HTTP request, but
     * the produced element will always be a new copy of the originally fetched icon. (That is,
     * it will not contain any modifications made to elements previously returned).
     *
     * @param {?} safeUrl URL from which to fetch the SVG icon.
     * @return {?}
     */
    MdIconRegistry.prototype.getSvgIconFromUrl = function (safeUrl) {
        var _this = this;
        var /** @type {?} */ url = this._sanitizer.sanitize(__WEBPACK_IMPORTED_MODULE_0__angular_core__["SecurityContext"].RESOURCE_URL, safeUrl);
        if (this._cachedIconsByUrl.has(url)) {
            return __WEBPACK_IMPORTED_MODULE_4_rxjs_Observable__["Observable"].of(cloneSvg(this._cachedIconsByUrl.get(url)));
        }
        return this._loadSvgIconFromConfig(new SvgIconConfig(url))
            .do(function (svg) { return _this._cachedIconsByUrl.set(url, svg); })
            .map(function (svg) { return cloneSvg(svg); });
    };
    /**
     * Returns an Observable that produces the icon (as an <svg> DOM element) with the given name
     * and namespace. The icon must have been previously registered with addIcon or addIconSet;
     * if not, the Observable will throw an MdIconNameNotFoundError.
     *
     * @param {?} name Name of the icon to be retrieved.
     * @param {?=} namespace Namespace in which to look for the icon.
     * @return {?}
     */
    MdIconRegistry.prototype.getNamedSvgIcon = function (name, namespace) {
        if (namespace === void 0) { namespace = ''; }
        // Return (copy of) cached icon if possible.
        var /** @type {?} */ key = iconKey(namespace, name);
        if (this._svgIconConfigs.has(key)) {
            return this._getSvgFromConfig(this._svgIconConfigs.get(key));
        }
        // See if we have any icon sets registered for the namespace.
        var /** @type {?} */ iconSetConfigs = this._iconSetConfigs.get(namespace);
        if (iconSetConfigs) {
            return this._getSvgFromIconSetConfigs(name, iconSetConfigs);
        }
        return __WEBPACK_IMPORTED_MODULE_4_rxjs_Observable__["Observable"].throw(new MdIconNameNotFoundError(key));
    };
    /**
     * Returns the cached icon for a SvgIconConfig if available, or fetches it from its URL if not.
     * @param {?} config
     * @return {?}
     */
    MdIconRegistry.prototype._getSvgFromConfig = function (config) {
        if (config.svgElement) {
            // We already have the SVG element for this icon, return a copy.
            return __WEBPACK_IMPORTED_MODULE_4_rxjs_Observable__["Observable"].of(cloneSvg(config.svgElement));
        }
        else {
            // Fetch the icon from the config's URL, cache it, and return a copy.
            return this._loadSvgIconFromConfig(config)
                .do(function (svg) { return config.svgElement = svg; })
                .map(function (svg) { return cloneSvg(svg); });
        }
    };
    /**
     * Attempts to find an icon with the specified name in any of the SVG icon sets.
     * First searches the available cached icons for a nested element with a matching name, and
     * if found copies the element to a new <svg> element. If not found, fetches all icon sets
     * that have not been cached, and searches again after all fetches are completed.
     * The returned Observable produces the SVG element if possible, and throws
     * MdIconNameNotFoundError if no icon with the specified name can be found.
     * @param {?} name
     * @param {?} iconSetConfigs
     * @return {?}
     */
    MdIconRegistry.prototype._getSvgFromIconSetConfigs = function (name, iconSetConfigs) {
        var _this = this;
        // For all the icon set SVG elements we've fetched, see if any contain an icon with the
        // requested name.
        var /** @type {?} */ namedIcon = this._extractIconWithNameFromAnySet(name, iconSetConfigs);
        if (namedIcon) {
            // We could cache namedIcon in _svgIconConfigs, but since we have to make a copy every
            // time anyway, there's probably not much advantage compared to just always extracting
            // it from the icon set.
            return __WEBPACK_IMPORTED_MODULE_4_rxjs_Observable__["Observable"].of(namedIcon);
        }
        // Not found in any cached icon sets. If there are icon sets with URLs that we haven't
        // fetched, fetch them now and look for iconName in the results.
        var /** @type {?} */ iconSetFetchRequests = iconSetConfigs
            .filter(function (iconSetConfig) { return !iconSetConfig.svgElement; })
            .map(function (iconSetConfig) { return _this._loadSvgIconSetFromConfig(iconSetConfig)
            .catch(function (err, caught) {
            var /** @type {?} */ url = _this._sanitizer.sanitize(__WEBPACK_IMPORTED_MODULE_0__angular_core__["SecurityContext"].RESOURCE_URL, iconSetConfig.url);
            // Swallow errors fetching individual URLs so the combined Observable won't
            // necessarily fail.
            console.log("Loading icon set URL: " + url + " failed: " + err);
            return __WEBPACK_IMPORTED_MODULE_4_rxjs_Observable__["Observable"].of(null);
        })
            .do(function (svg) {
            // Cache SVG element.
            if (svg) {
                iconSetConfig.svgElement = svg;
            }
        }); });
        // Fetch all the icon set URLs. When the requests complete, every IconSet should have a
        // cached SVG element (unless the request failed), and we can check again for the icon.
        return __WEBPACK_IMPORTED_MODULE_4_rxjs_Observable__["Observable"].forkJoin(iconSetFetchRequests)
            .map(function (ignoredResults) {
            var /** @type {?} */ foundIcon = _this._extractIconWithNameFromAnySet(name, iconSetConfigs);
            if (!foundIcon) {
                throw new MdIconNameNotFoundError(name);
            }
            return foundIcon;
        });
    };
    /**
     * Searches the cached SVG elements for the given icon sets for a nested icon element whose "id"
     * tag matches the specified name. If found, copies the nested element to a new SVG element and
     * returns it. Returns null if no matching element is found.
     * @param {?} iconName
     * @param {?} iconSetConfigs
     * @return {?}
     */
    MdIconRegistry.prototype._extractIconWithNameFromAnySet = function (iconName, iconSetConfigs) {
        // Iterate backwards, so icon sets added later have precedence.
        for (var /** @type {?} */ i = iconSetConfigs.length - 1; i >= 0; i--) {
            var /** @type {?} */ config = iconSetConfigs[i];
            if (config.svgElement) {
                var /** @type {?} */ foundIcon = this._extractSvgIconFromSet(config.svgElement, iconName);
                if (foundIcon) {
                    return foundIcon;
                }
            }
        }
        return null;
    };
    /**
     * Loads the content of the icon URL specified in the SvgIconConfig and creates an SVG element
     * from it.
     * @param {?} config
     * @return {?}
     */
    MdIconRegistry.prototype._loadSvgIconFromConfig = function (config) {
        var _this = this;
        return this._fetchUrl(config.url)
            .map(function (svgText) { return _this._createSvgElementForSingleIcon(svgText); });
    };
    /**
     * Loads the content of the icon set URL specified in the SvgIconConfig and creates an SVG element
     * from it.
     * @param {?} config
     * @return {?}
     */
    MdIconRegistry.prototype._loadSvgIconSetFromConfig = function (config) {
        var _this = this;
        // TODO: Document that icons should only be loaded from trusted sources.
        return this._fetchUrl(config.url)
            .map(function (svgText) { return _this._svgElementFromString(svgText); });
    };
    /**
     * Creates a DOM element from the given SVG string, and adds default attributes.
     * @param {?} responseText
     * @return {?}
     */
    MdIconRegistry.prototype._createSvgElementForSingleIcon = function (responseText) {
        var /** @type {?} */ svg = this._svgElementFromString(responseText);
        this._setSvgAttributes(svg);
        return svg;
    };
    /**
     * Searches the cached element of the given SvgIconConfig for a nested icon element whose "id"
     * tag matches the specified name. If found, copies the nested element to a new SVG element and
     * returns it. Returns null if no matching element is found.
     * @param {?} iconSet
     * @param {?} iconName
     * @return {?}
     */
    MdIconRegistry.prototype._extractSvgIconFromSet = function (iconSet, iconName) {
        var /** @type {?} */ iconNode = iconSet.querySelector('#' + iconName);
        if (!iconNode) {
            return null;
        }
        // If the icon node is itself an <svg> node, clone and return it directly. If not, set it as
        // the content of a new <svg> node.
        if (iconNode.tagName.toLowerCase() == 'svg') {
            return this._setSvgAttributes(/** @type {?} */ (iconNode.cloneNode(true)));
        }
        // createElement('SVG') doesn't work as expected; the DOM ends up with
        // the correct nodes, but the SVG content doesn't render. Instead we
        // have to create an empty SVG node using innerHTML and append its content.
        // Elements created using DOMParser.parseFromString have the same problem.
        // http://stackoverflow.com/questions/23003278/svg-innerhtml-in-firefox-can-not-display
        var /** @type {?} */ svg = this._svgElementFromString('<svg></svg>');
        // Clone the node so we don't remove it from the parent icon set element.
        svg.appendChild(iconNode.cloneNode(true));
        return this._setSvgAttributes(svg);
    };
    /**
     * Creates a DOM element from the given SVG string.
     * @param {?} str
     * @return {?}
     */
    MdIconRegistry.prototype._svgElementFromString = function (str) {
        // TODO: Is there a better way than innerHTML? Renderer doesn't appear to have a method for
        // creating an element from an HTML string.
        var /** @type {?} */ div = document.createElement('DIV');
        div.innerHTML = str;
        var /** @type {?} */ svg = (div.querySelector('svg'));
        if (!svg) {
            throw new MdIconSvgTagNotFoundError();
        }
        return svg;
    };
    /**
     * Sets the default attributes for an SVG element to be used as an icon.
     * @param {?} svg
     * @return {?}
     */
    MdIconRegistry.prototype._setSvgAttributes = function (svg) {
        if (!svg.getAttribute('xmlns')) {
            svg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
        }
        svg.setAttribute('fit', '');
        svg.setAttribute('height', '100%');
        svg.setAttribute('width', '100%');
        svg.setAttribute('preserveAspectRatio', 'xMidYMid meet');
        svg.setAttribute('focusable', 'false'); // Disable IE11 default behavior to make SVGs focusable.
        return svg;
    };
    /**
     * Returns an Observable which produces the string contents of the given URL. Results may be
     * cached, so future calls with the same URL may not cause another HTTP request.
     * @param {?} safeUrl
     * @return {?}
     */
    MdIconRegistry.prototype._fetchUrl = function (safeUrl) {
        var _this = this;
        var /** @type {?} */ url = this._sanitizer.sanitize(__WEBPACK_IMPORTED_MODULE_0__angular_core__["SecurityContext"].RESOURCE_URL, safeUrl);
        // Store in-progress fetches to avoid sending a duplicate request for a URL when there is
        // already a request in progress for that URL. It's necessary to call share() on the
        // Observable returned by http.get() so that multiple subscribers don't cause multiple XHRs.
        if (this._inProgressUrlFetches.has(url)) {
            return this._inProgressUrlFetches.get(url);
        }
        // TODO(jelbourn): for some reason, the `finally` operator "loses" the generic type on the
        // Observable. Figure out why and fix it.
        var /** @type {?} */ req = (this._http.get(url)
            .map(function (response) { return response.text(); })
            .finally(function () {
            _this._inProgressUrlFetches.delete(url);
        })
            .share());
        this._inProgressUrlFetches.set(url, req);
        return req;
    };
    return MdIconRegistry;
}());
MdIconRegistry.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
];
/**
 * @nocollapse
 */
MdIconRegistry.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_12__angular_http__["a" /* Http */], },
    { type: __WEBPACK_IMPORTED_MODULE_1__angular_platform_browser__["DomSanitizer"], },
]; };
/**
 * Clones an SVGElement while preserving type information.
 * @param {?} svg
 * @return {?}
 */
function cloneSvg(svg) {
    return (svg.cloneNode(true));
}
/**
 * Exception thrown when an invalid icon name is passed to an md-icon component.
 */
var MdIconInvalidNameError = (function (_super) {
    __extends(MdIconInvalidNameError, _super);
    /**
     * @param {?} iconName
     */
    function MdIconInvalidNameError(iconName) {
        return _super.call(this, "Invalid icon name: \"" + iconName + "\"") || this;
    }
    return MdIconInvalidNameError;
}(MdError));
/**
 * Component to display an icon. It can be used in the following ways:
 * - Specify the svgSrc input to load an SVG icon from a URL. The SVG content is directly inlined
 *   as a child of the <md-icon> component, so that CSS styles can easily be applied to it.
 *   The URL is loaded via an XMLHttpRequest, so it must be on the same domain as the page or its
 *   server must be configured to allow cross-domain requests.
 *   Example:
 *     <md-icon svgSrc="assets/arrow.svg"></md-icon>
 *
 * - Specify the svgIcon input to load an SVG icon from a URL previously registered with the
 *   addSvgIcon, addSvgIconInNamespace, addSvgIconSet, or addSvgIconSetInNamespace methods of
 *   MdIconRegistry. If the svgIcon value contains a colon it is assumed to be in the format
 *   "[namespace]:[name]", if not the value will be the name of an icon in the default namespace.
 *   Examples:
 *     <md-icon svgIcon="left-arrow"></md-icon>
 *     <md-icon svgIcon="animals:cat"></md-icon>
 *
 * - Use a font ligature as an icon by putting the ligature text in the content of the <md-icon>
 *   component. By default the Material icons font is used as described at
 *   http://google.github.io/material-design-icons/#icon-font-for-the-web. You can specify an
 *   alternate font by setting the fontSet input to either the CSS class to apply to use the
 *   desired font, or to an alias previously registered with MdIconRegistry.registerFontClassAlias.
 *   Examples:
 *     <md-icon>home</md-icon>
 *     <md-icon fontSet="myfont">sun</md-icon>
 *
 * - Specify a font glyph to be included via CSS rules by setting the fontSet input to specify the
 *   font, and the fontIcon input to specify the icon. Typically the fontIcon will specify a
 *   CSS class which causes the glyph to be displayed via a :before selector, as in
 *   https://fortawesome.github.io/Font-Awesome/examples/
 *   Example:
 *     <md-icon fontSet="fa" fontIcon="alarm"></md-icon>
 */
var MdIcon = (function () {
    /**
     * @param {?} _elementRef
     * @param {?} _renderer
     * @param {?} _mdIconRegistry
     */
    function MdIcon(_elementRef, _renderer, _mdIconRegistry) {
        this._elementRef = _elementRef;
        this._renderer = _renderer;
        this._mdIconRegistry = _mdIconRegistry;
        /** Screenreader label for the icon. */
        this.hostAriaLabel = '';
    }
    Object.defineProperty(MdIcon.prototype, "color", {
        /**
         * Color of the icon.
         * @return {?}
         */
        get: function () { return this._color; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this._updateColor(value); },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} newColor
     * @return {?}
     */
    MdIcon.prototype._updateColor = function (newColor) {
        this._setElementColor(this._color, false);
        this._setElementColor(newColor, true);
        this._color = newColor;
    };
    /**
     * @param {?} color
     * @param {?} isAdd
     * @return {?}
     */
    MdIcon.prototype._setElementColor = function (color, isAdd) {
        if (color != null && color != '') {
            this._renderer.setElementClass(this._elementRef.nativeElement, "mat-" + color, isAdd);
        }
    };
    /**
     * Splits an svgIcon binding value into its icon set and icon name components.
     * Returns a 2-element array of [(icon set), (icon name)].
     * The separator for the two fields is ':'. If there is no separator, an empty
     * string is returned for the icon set and the entire value is returned for
     * the icon name. If the argument is falsy, returns an array of two empty strings.
     * Throws a MdIconInvalidNameError if the name contains two or more ':' separators.
     * Examples:
     *   'social:cake' -> ['social', 'cake']
     *   'penguin' -> ['', 'penguin']
     *   null -> ['', '']
     *   'a:b:c' -> (throws MdIconInvalidNameError)
     * @param {?} iconName
     * @return {?}
     */
    MdIcon.prototype._splitIconName = function (iconName) {
        if (!iconName) {
            return ['', ''];
        }
        var /** @type {?} */ parts = iconName.split(':');
        switch (parts.length) {
            case 1:
                // Use default namespace.
                return ['', parts[0]];
            case 2:
                return (parts);
            default:
                throw new MdIconInvalidNameError(iconName);
        }
    };
    /**
     * @param {?} changes
     * @return {?}
     */
    MdIcon.prototype.ngOnChanges = function (changes) {
        var _this = this;
        var /** @type {?} */ changedInputs = Object.keys(changes);
        // Only update the inline SVG icon if the inputs changed, to avoid unnecessary DOM operations.
        if (changedInputs.indexOf('svgIcon') != -1 || changedInputs.indexOf('svgSrc') != -1) {
            if (this.svgIcon) {
                var _a = this._splitIconName(this.svgIcon), namespace = _a[0], iconName = _a[1];
                this._mdIconRegistry.getNamedSvgIcon(iconName, namespace).first().subscribe(function (svg) { return _this._setSvgElement(svg); }, function (err) { return console.log("Error retrieving icon: " + err.message); });
            }
        }
        if (this._usingFontIcon()) {
            this._updateFontIconClasses();
        }
        this._updateAriaLabel();
    };
    /**
     * @return {?}
     */
    MdIcon.prototype.ngOnInit = function () {
        // Update font classes because ngOnChanges won't be called if none of the inputs are present,
        // e.g. <md-icon>arrow</md-icon>. In this case we need to add a CSS class for the default font.
        if (this._usingFontIcon()) {
            this._updateFontIconClasses();
        }
    };
    /**
     * @return {?}
     */
    MdIcon.prototype.ngAfterViewChecked = function () {
        // Update aria label here because it may depend on the projected text content.
        // (e.g. <md-icon>home</md-icon> should use 'home').
        this._updateAriaLabel();
    };
    /**
     * @return {?}
     */
    MdIcon.prototype._updateAriaLabel = function () {
        var /** @type {?} */ ariaLabel = this._getAriaLabel();
        if (ariaLabel && ariaLabel !== this._previousAriaLabel) {
            this._previousAriaLabel = ariaLabel;
            this._renderer.setElementAttribute(this._elementRef.nativeElement, 'aria-label', ariaLabel);
        }
    };
    /**
     * @return {?}
     */
    MdIcon.prototype._getAriaLabel = function () {
        // If the parent provided an aria-label attribute value, use it as-is. Otherwise look for a
        // reasonable value from the alt attribute, font icon name, SVG icon name, or (for ligatures)
        // the text content of the directive.
        var /** @type {?} */ label = this.hostAriaLabel ||
            this.alt ||
            this.fontIcon ||
            this._splitIconName(this.svgIcon)[1];
        if (label) {
            return label;
        }
        // The "content" of an SVG icon is not a useful label.
        if (this._usingFontIcon()) {
            var /** @type {?} */ text = this._elementRef.nativeElement.textContent;
            if (text) {
                return text;
            }
        }
        // TODO: Warn here in dev mode.
        return null;
    };
    /**
     * @return {?}
     */
    MdIcon.prototype._usingFontIcon = function () {
        return !this.svgIcon;
    };
    /**
     * @param {?} svg
     * @return {?}
     */
    MdIcon.prototype._setSvgElement = function (svg) {
        var /** @type {?} */ layoutElement = this._elementRef.nativeElement;
        // Remove existing child nodes and add the new SVG element.
        // We would use renderer.detachView(Array.from(layoutElement.childNodes)) here,
        // but it fails in IE11: https://github.com/angular/angular/issues/6327
        layoutElement.innerHTML = '';
        this._renderer.projectNodes(layoutElement, [svg]);
    };
    /**
     * @return {?}
     */
    MdIcon.prototype._updateFontIconClasses = function () {
        if (!this._usingFontIcon()) {
            return;
        }
        var /** @type {?} */ elem = this._elementRef.nativeElement;
        var /** @type {?} */ fontSetClass = this.fontSet ?
            this._mdIconRegistry.classNameForFontAlias(this.fontSet) :
            this._mdIconRegistry.getDefaultFontSetClass();
        if (fontSetClass != this._previousFontSetClass) {
            if (this._previousFontSetClass) {
                this._renderer.setElementClass(elem, this._previousFontSetClass, false);
            }
            if (fontSetClass) {
                this._renderer.setElementClass(elem, fontSetClass, true);
            }
            this._previousFontSetClass = fontSetClass;
        }
        if (this.fontIcon != this._previousFontIconClass) {
            if (this._previousFontIconClass) {
                this._renderer.setElementClass(elem, this._previousFontIconClass, false);
            }
            if (this.fontIcon) {
                this._renderer.setElementClass(elem, this.fontIcon, true);
            }
            this._previousFontIconClass = this.fontIcon;
        }
    };
    return MdIcon;
}());
MdIcon.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{ template: '<ng-content></ng-content>',
                selector: 'md-icon, mat-icon',
                styles: [".mat-icon{background-repeat:no-repeat;display:inline-block;fill:currentColor;height:24px;width:24px} /*# sourceMappingURL=icon.css.map */ "],
                host: {
                    'role': 'img',
                    '[class.mat-icon]': 'true',
                },
                encapsulation: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewEncapsulation"].None,
                changeDetection: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectionStrategy"].OnPush,
            },] },
];
/**
 * @nocollapse
 */
MdIcon.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
    { type: MdIconRegistry, },
]; };
MdIcon.propDecorators = {
    'svgIcon': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'fontSet': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'fontIcon': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'alt': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'hostAriaLabel': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['aria-label',] },],
    'color': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
};
/**
 * @param {?} parentRegistry
 * @param {?} http
 * @param {?} sanitizer
 * @return {?}
 */
function ICON_REGISTRY_PROVIDER_FACTORY(parentRegistry, http, sanitizer) {
    return parentRegistry || new MdIconRegistry(http, sanitizer);
}
var ICON_REGISTRY_PROVIDER = {
    // If there is already an MdIconRegistry available, use that. Otherwise, provide a new one.
    provide: MdIconRegistry,
    deps: [[new __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"](), new __WEBPACK_IMPORTED_MODULE_0__angular_core__["SkipSelf"](), MdIconRegistry], __WEBPACK_IMPORTED_MODULE_12__angular_http__["a" /* Http */], __WEBPACK_IMPORTED_MODULE_1__angular_platform_browser__["DomSanitizer"]],
    useFactory: ICON_REGISTRY_PROVIDER_FACTORY,
};
var MdIconModule = (function () {
    function MdIconModule() {
    }
    /**
     * @deprecated
     * @return {?}
     */
    MdIconModule.forRoot = function () {
        return {
            ngModule: MdIconModule,
            providers: [],
        };
    };
    return MdIconModule;
}());
MdIconModule.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{
                imports: [__WEBPACK_IMPORTED_MODULE_12__angular_http__["d" /* HttpModule */], CompatibilityModule],
                exports: [MdIcon, CompatibilityModule],
                declarations: [MdIcon],
                providers: [ICON_REGISTRY_PROVIDER],
            },] },
];
/**
 * @nocollapse
 */
MdIconModule.ctorParameters = function () { return []; };
// TODO(josephperrott): Benchpress tests.
/** A single degree in radians. */
var DEGREE_IN_RADIANS = Math.PI / 180;
/** Duration of the indeterminate animation. */
var DURATION_INDETERMINATE = 667;
/** Duration of the indeterminate animation. */
var DURATION_DETERMINATE = 225;
/** Start animation value of the indeterminate animation */
var startIndeterminate = 3;
/** End animation value of the indeterminate animation */
var endIndeterminate = 80;
/* Maximum angle for the arc. The angle can't be exactly 360, because the arc becomes hidden. */
var MAX_ANGLE = 359.99 / 100;
/**
 * Directive whose purpose is to add the mat- CSS styling to this selector.
 * \@docs-private
 */
var MdProgressSpinnerCssMatStyler = (function () {
    function MdProgressSpinnerCssMatStyler() {
    }
    return MdProgressSpinnerCssMatStyler;
}());
MdProgressSpinnerCssMatStyler.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                selector: 'md-progress-spinner, mat-progress-spinner',
                host: {
                    '[class.mat-progress-spinner]': 'true'
                }
            },] },
];
/**
 * @nocollapse
 */
MdProgressSpinnerCssMatStyler.ctorParameters = function () { return []; };
/**
 * <md-progress-spinner> component.
 */
var MdProgressSpinner = (function () {
    /**
     * @param {?} _ngZone
     * @param {?} _elementRef
     * @param {?} _renderer
     */
    function MdProgressSpinner(_ngZone, _elementRef, _renderer) {
        this._ngZone = _ngZone;
        this._elementRef = _elementRef;
        this._renderer = _renderer;
        this._lastAnimationId = 0;
        this._mode = 'determinate';
        this._color = 'primary';
    }
    Object.defineProperty(MdProgressSpinner.prototype, "_ariaValueMin", {
        /**
         * Values for aria max and min are only defined as numbers when in a determinate mode.  We do this
         * because voiceover does not report the progress indicator as indeterminate if the aria min
         * and/or max value are number values.
         * @return {?}
         */
        get: function () {
            return this.mode == 'determinate' ? 0 : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdProgressSpinner.prototype, "_ariaValueMax", {
        /**
         * @return {?}
         */
        get: function () {
            return this.mode == 'determinate' ? 100 : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdProgressSpinner.prototype, "interdeterminateInterval", {
        /**
         * \@docs-private
         * @return {?}
         */
        get: function () {
            return this._interdeterminateInterval;
        },
        /**
         * \@docs-private
         * @param {?} interval
         * @return {?}
         */
        set: function (interval) {
            clearInterval(this._interdeterminateInterval);
            this._interdeterminateInterval = interval;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Clean up any animations that were running.
     * @return {?}
     */
    MdProgressSpinner.prototype.ngOnDestroy = function () {
        this._cleanupIndeterminateAnimation();
    };
    Object.defineProperty(MdProgressSpinner.prototype, "color", {
        /**
         * The color of the progress-spinner. Can be primary, accent, or warn.
         * @return {?}
         */
        get: function () { return this._color; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._updateColor(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdProgressSpinner.prototype, "value", {
        /**
         * Value of the progress circle. It is bound to the host as the attribute aria-valuenow.
         * @return {?}
         */
        get: function () {
            if (this.mode == 'determinate') {
                return this._value;
            }
        },
        /**
         * @param {?} v
         * @return {?}
         */
        set: function (v) {
            if (v != null && this.mode == 'determinate') {
                var /** @type {?} */ newValue = clamp(v);
                this._animateCircle(this.value || 0, newValue);
                this._value = newValue;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdProgressSpinner.prototype, "mode", {
        /**
         * Mode of the progress circle
         *
         * Input must be one of the values from ProgressMode, defaults to 'determinate'.
         * mode is bound to the host as the attribute host.
         * @return {?}
         */
        get: function () {
            return this._mode;
        },
        /**
         * @param {?} mode
         * @return {?}
         */
        set: function (mode) {
            if (mode !== this._mode) {
                if (mode === 'indeterminate') {
                    this._startIndeterminateAnimation();
                }
                else {
                    this._cleanupIndeterminateAnimation();
                    this._animateCircle(0, this._value);
                }
                this._mode = mode;
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Animates the circle from one percentage value to another.
     *
     * @param {?} animateFrom The percentage of the circle filled starting the animation.
     * @param {?} animateTo The percentage of the circle filled ending the animation.
     * @param {?=} ease The easing function to manage the pace of change in the animation.
     * @param {?=} duration The length of time to show the animation, in milliseconds.
     * @param {?=} rotation The starting angle of the circle fill, with 0° represented at the top center
     *    of the circle.
     * @return {?}
     */
    MdProgressSpinner.prototype._animateCircle = function (animateFrom, animateTo, ease, duration, rotation) {
        var _this = this;
        if (ease === void 0) { ease = linearEase; }
        if (duration === void 0) { duration = DURATION_DETERMINATE; }
        if (rotation === void 0) { rotation = 0; }
        var /** @type {?} */ id = ++this._lastAnimationId;
        var /** @type {?} */ startTime = Date.now();
        var /** @type {?} */ changeInValue = animateTo - animateFrom;
        // No need to animate it if the values are the same
        if (animateTo === animateFrom) {
            this._renderArc(animateTo, rotation);
        }
        else {
            var /** @type {?} */ animation_1 = function () {
                var /** @type {?} */ elapsedTime = Math.max(0, Math.min(Date.now() - startTime, duration));
                _this._renderArc(ease(elapsedTime, animateFrom, changeInValue, duration), rotation);
                // Prevent overlapping animations by checking if a new animation has been called for and
                // if the animation has lasted longer than the animation duration.
                if (id === _this._lastAnimationId && elapsedTime < duration) {
                    requestAnimationFrame(animation_1);
                }
            };
            // Run the animation outside of Angular's zone, in order to avoid
            // hitting ZoneJS and change detection on each frame.
            this._ngZone.runOutsideAngular(animation_1);
        }
    };
    /**
     * Starts the indeterminate animation interval, if it is not already running.
     * @return {?}
     */
    MdProgressSpinner.prototype._startIndeterminateAnimation = function () {
        var _this = this;
        var /** @type {?} */ rotationStartPoint = 0;
        var /** @type {?} */ start = startIndeterminate;
        var /** @type {?} */ end = endIndeterminate;
        var /** @type {?} */ duration = DURATION_INDETERMINATE;
        var /** @type {?} */ animate$$1 = function () {
            _this._animateCircle(start, end, materialEase, duration, rotationStartPoint);
            // Prevent rotation from reaching Number.MAX_SAFE_INTEGER.
            rotationStartPoint = (rotationStartPoint + end) % 100;
            var /** @type {?} */ temp = start;
            start = -end;
            end = -temp;
        };
        if (!this.interdeterminateInterval) {
            this._ngZone.runOutsideAngular(function () {
                _this.interdeterminateInterval = setInterval(animate$$1, duration + 50, 0, false);
                animate$$1();
            });
        }
    };
    /**
     * Removes interval, ending the animation.
     * @return {?}
     */
    MdProgressSpinner.prototype._cleanupIndeterminateAnimation = function () {
        this.interdeterminateInterval = null;
    };
    /**
     * Renders the arc onto the SVG element. Proxies `getArc` while setting the proper
     * DOM attribute on the `<path>`.
     * @param {?} currentValue
     * @param {?=} rotation
     * @return {?}
     */
    MdProgressSpinner.prototype._renderArc = function (currentValue, rotation) {
        if (rotation === void 0) { rotation = 0; }
        // Caches the path reference so it doesn't have to be looked up every time.
        var /** @type {?} */ path = this._path = this._path || this._elementRef.nativeElement.querySelector('path');
        // Ensure that the path was found. This may not be the case if the
        // animation function fires too early.
        if (path) {
            path.setAttribute('d', getSvgArc(currentValue, rotation));
        }
    };
    /**
     * Updates the color of the progress-spinner by adding the new palette class to the element
     * and removing the old one.
     * @param {?} newColor
     * @return {?}
     */
    MdProgressSpinner.prototype._updateColor = function (newColor) {
        this._setElementColor(this._color, false);
        this._setElementColor(newColor, true);
        this._color = newColor;
    };
    /**
     * Sets the given palette class on the component element.
     * @param {?} color
     * @param {?} isAdd
     * @return {?}
     */
    MdProgressSpinner.prototype._setElementColor = function (color, isAdd) {
        if (color != null && color != '') {
            this._renderer.setElementClass(this._elementRef.nativeElement, "mat-" + color, isAdd);
        }
    };
    return MdProgressSpinner;
}());
MdProgressSpinner.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{ selector: 'md-progress-spinner, mat-progress-spinner',
                host: {
                    'role': 'progressbar',
                    '[attr.aria-valuemin]': '_ariaValueMin',
                    '[attr.aria-valuemax]': '_ariaValueMax'
                },
                template: "<!-- preserveAspectRatio of xMidYMid meet as the center of the viewport is the circle's center. The center of the circle will remain at the center of the md-progress-spinner element containing the SVG. --> <svg viewBox=\"0 0 100 100\" preserveAspectRatio=\"xMidYMid meet\"> <path></path> </svg> ",
                styles: [":host{display:block;height:100px;width:100px;overflow:hidden}:host svg{height:100%;width:100%;transform-origin:center}:host path{fill:transparent;stroke-width:10px;transition:stroke .3s cubic-bezier(.35,0,.25,1)}:host[mode=indeterminate] svg{animation-duration:5.25s,2.887s;animation-name:mat-progress-spinner-sporadic-rotate,mat-progress-spinner-linear-rotate;animation-timing-function:cubic-bezier(.35,0,.25,1),linear;animation-iteration-count:infinite;transition:none}@keyframes mat-progress-spinner-linear-rotate{0%{transform:rotate(0)}100%{transform:rotate(360deg)}}@keyframes mat-progress-spinner-sporadic-rotate{12.5%{transform:rotate(135deg)}25%{transform:rotate(270deg)}37.5%{transform:rotate(405deg)}50%{transform:rotate(540deg)}62.5%{transform:rotate(675deg)}75%{transform:rotate(810deg)}87.5%{transform:rotate(945deg)}100%{transform:rotate(1080deg)}} /*# sourceMappingURL=progress-spinner.css.map */ "],
                changeDetection: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectionStrategy"].OnPush,
            },] },
];
/**
 * @nocollapse
 */
MdProgressSpinner.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgZone"], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
]; };
MdProgressSpinner.propDecorators = {
    'color': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'value': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["HostBinding"], args: ['attr.aria-valuenow',] },],
    'mode': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["HostBinding"], args: ['attr.mode',] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
};
/**
 * <md-spinner> component.
 *
 * This is a component definition to be used as a convenience reference to create an
 * indeterminate <md-progress-spinner> instance.
 */
var MdSpinner = (function (_super) {
    __extends(MdSpinner, _super);
    /**
     * @param {?} elementRef
     * @param {?} ngZone
     * @param {?} renderer
     */
    function MdSpinner(elementRef, ngZone, renderer) {
        var _this = _super.call(this, ngZone, elementRef, renderer) || this;
        _this.mode = 'indeterminate';
        return _this;
    }
    /**
     * @return {?}
     */
    MdSpinner.prototype.ngOnDestroy = function () {
        // The `ngOnDestroy` from `MdProgressSpinner` should be called explicitly, because
        // in certain cases Angular won't call it (e.g. when using AoT and in unit tests).
        _super.prototype.ngOnDestroy.call(this);
    };
    return MdSpinner;
}(MdProgressSpinner));
MdSpinner.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{ selector: 'md-spinner, mat-spinner',
                host: {
                    'role': 'progressbar',
                    'mode': 'indeterminate',
                    '[class.mat-spinner]': 'true',
                },
                template: "<!-- preserveAspectRatio of xMidYMid meet as the center of the viewport is the circle's center. The center of the circle will remain at the center of the md-progress-spinner element containing the SVG. --> <svg viewBox=\"0 0 100 100\" preserveAspectRatio=\"xMidYMid meet\"> <path></path> </svg> ",
                styles: [":host{display:block;height:100px;width:100px;overflow:hidden}:host svg{height:100%;width:100%;transform-origin:center}:host path{fill:transparent;stroke-width:10px;transition:stroke .3s cubic-bezier(.35,0,.25,1)}:host[mode=indeterminate] svg{animation-duration:5.25s,2.887s;animation-name:mat-progress-spinner-sporadic-rotate,mat-progress-spinner-linear-rotate;animation-timing-function:cubic-bezier(.35,0,.25,1),linear;animation-iteration-count:infinite;transition:none}@keyframes mat-progress-spinner-linear-rotate{0%{transform:rotate(0)}100%{transform:rotate(360deg)}}@keyframes mat-progress-spinner-sporadic-rotate{12.5%{transform:rotate(135deg)}25%{transform:rotate(270deg)}37.5%{transform:rotate(405deg)}50%{transform:rotate(540deg)}62.5%{transform:rotate(675deg)}75%{transform:rotate(810deg)}87.5%{transform:rotate(945deg)}100%{transform:rotate(1080deg)}} /*# sourceMappingURL=progress-spinner.css.map */ "],
            },] },
];
/**
 * @nocollapse
 */
MdSpinner.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgZone"], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
]; };
/**
 * Clamps a value to be between 0 and 100.
 * @param {?} v
 * @return {?}
 */
function clamp(v) {
    return Math.max(0, Math.min(100, v));
}
/**
 * Converts Polar coordinates to Cartesian.
 * @param {?} radius
 * @param {?} pathRadius
 * @param {?} angleInDegrees
 * @return {?}
 */
function polarToCartesian(radius, pathRadius, angleInDegrees) {
    var /** @type {?} */ angleInRadians = (angleInDegrees - 90) * DEGREE_IN_RADIANS;
    return (radius + (pathRadius * Math.cos(angleInRadians))) +
        ',' + (radius + (pathRadius * Math.sin(angleInRadians)));
}
/**
 * Easing function for linear animation.
 * @param {?} currentTime
 * @param {?} startValue
 * @param {?} changeInValue
 * @param {?} duration
 * @return {?}
 */
function linearEase(currentTime, startValue, changeInValue, duration) {
    return changeInValue * currentTime / duration + startValue;
}
/**
 * Easing function to match material design indeterminate animation.
 * @param {?} currentTime
 * @param {?} startValue
 * @param {?} changeInValue
 * @param {?} duration
 * @return {?}
 */
function materialEase(currentTime, startValue, changeInValue, duration) {
    var /** @type {?} */ time = currentTime / duration;
    var /** @type {?} */ timeCubed = Math.pow(time, 3);
    var /** @type {?} */ timeQuad = Math.pow(time, 4);
    var /** @type {?} */ timeQuint = Math.pow(time, 5);
    return startValue + changeInValue * ((6 * timeQuint) + (-15 * timeQuad) + (10 * timeCubed));
}
/**
 * Determines the path value to define the arc.  Converting percentage values to to polar
 * coordinates on the circle, and then to cartesian coordinates in the viewport.
 *
 * @param {?} currentValue The current percentage value of the progress circle, the percentage of the
 *    circle to fill.
 * @param {?} rotation The starting point of the circle with 0 being the 0 degree point.
 * @return {?} A string for an SVG path representing a circle filled from the starting point to the
 *    percentage value provided.
 */
function getSvgArc(currentValue, rotation) {
    var /** @type {?} */ startPoint = rotation || 0;
    var /** @type {?} */ radius = 50;
    var /** @type {?} */ pathRadius = 40;
    var /** @type {?} */ startAngle = startPoint * MAX_ANGLE;
    var /** @type {?} */ endAngle = currentValue * MAX_ANGLE;
    var /** @type {?} */ start = polarToCartesian(radius, pathRadius, startAngle);
    var /** @type {?} */ end = polarToCartesian(radius, pathRadius, endAngle + startAngle);
    var /** @type {?} */ arcSweep = endAngle < 0 ? 0 : 1;
    var /** @type {?} */ largeArcFlag;
    if (endAngle < 0) {
        largeArcFlag = endAngle >= -180 ? 0 : 1;
    }
    else {
        largeArcFlag = endAngle <= 180 ? 0 : 1;
    }
    return "M" + start + "A" + pathRadius + "," + pathRadius + " 0 " + largeArcFlag + "," + arcSweep + " " + end;
}
var MdProgressSpinnerModule = (function () {
    function MdProgressSpinnerModule() {
    }
    /**
     * @deprecated
     * @return {?}
     */
    MdProgressSpinnerModule.forRoot = function () {
        return {
            ngModule: MdProgressSpinnerModule,
            providers: []
        };
    };
    return MdProgressSpinnerModule;
}());
MdProgressSpinnerModule.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{
                imports: [CompatibilityModule],
                exports: [
                    MdProgressSpinner,
                    MdSpinner,
                    CompatibilityModule,
                    MdProgressSpinnerCssMatStyler
                ],
                declarations: [
                    MdProgressSpinner,
                    MdSpinner,
                    MdProgressSpinnerCssMatStyler
                ],
            },] },
];
/**
 * @nocollapse
 */
MdProgressSpinnerModule.ctorParameters = function () { return []; };
/**
 * <md-progress-bar> component.
 */
var MdProgressBar = (function () {
    function MdProgressBar() {
        /** Color of the progress bar. */
        this.color = 'primary';
        this._value = 0;
        this._bufferValue = 0;
        /**
         * Mode of the progress bar.
         *
         * Input must be one of these values: determinate, indeterminate, buffer, query, defaults to
         * 'determinate'.
         * Mirrored to mode attribute.
         */
        this.mode = 'determinate';
    }
    Object.defineProperty(MdProgressBar.prototype, "value", {
        /**
         * Value of the progressbar. Defaults to zero. Mirrored to aria-valuenow.
         * @return {?}
         */
        get: function () { return this._value; },
        /**
         * @param {?} v
         * @return {?}
         */
        set: function (v) { this._value = clamp$1(v || 0); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdProgressBar.prototype, "bufferValue", {
        /**
         * Buffer value of the progress bar. Defaults to zero.
         * @return {?}
         */
        get: function () { return this._bufferValue; },
        /**
         * @param {?} v
         * @return {?}
         */
        set: function (v) { this._bufferValue = clamp$1(v || 0); },
        enumerable: true,
        configurable: true
    });
    /**
     * Gets the current transform value for the progress bar's primary indicator.
     * @return {?}
     */
    MdProgressBar.prototype._primaryTransform = function () {
        var /** @type {?} */ scale = this.value / 100;
        return { transform: "scaleX(" + scale + ")" };
    };
    /**
     * Gets the current transform value for the progress bar's buffer indicator.  Only used if the
     * progress mode is set to buffer, otherwise returns an undefined, causing no transformation.
     * @return {?}
     */
    MdProgressBar.prototype._bufferTransform = function () {
        if (this.mode == 'buffer') {
            var /** @type {?} */ scale = this.bufferValue / 100;
            return { transform: "scaleX(" + scale + ")" };
        }
    };
    return MdProgressBar;
}());
MdProgressBar.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{ selector: 'md-progress-bar, mat-progress-bar',
                host: {
                    'role': 'progressbar',
                    'aria-valuemin': '0',
                    'aria-valuemax': '100',
                    '[class.mat-primary]': 'color == "primary"',
                    '[class.mat-accent]': 'color == "accent"',
                    '[class.mat-warn]': 'color == "warn"',
                    '[class.mat-progress-bar]': 'true',
                },
                template: "<!-- The background div is named as such because it appears below the other divs and is not sized based on values. --> <div class=\"mat-progress-bar-background mat-progress-bar-element\"></div> <div class=\"mat-progress-bar-buffer mat-progress-bar-element\" [ngStyle]=\"_bufferTransform()\"></div> <div class=\"mat-progress-bar-primary mat-progress-bar-fill mat-progress-bar-element\" [ngStyle]=\"_primaryTransform()\"></div> <div class=\"mat-progress-bar-secondary mat-progress-bar-fill mat-progress-bar-element\"></div> ",
                styles: [":host{display:block;height:5px;overflow:hidden;position:relative;transform:translateZ(0);transition:opacity 250ms linear;width:100%}:host .mat-progress-bar-element,:host .mat-progress-bar-fill::after{height:100%;position:absolute;width:100%}:host .mat-progress-bar-background{background-repeat:repeat-x;background-size:10px 4px;display:none}:host .mat-progress-bar-buffer{transform-origin:top left;transition:transform 250ms ease,stroke .3s cubic-bezier(.35,0,.25,1)}:host .mat-progress-bar-secondary{display:none}:host .mat-progress-bar-fill{animation:none;transform-origin:top left;transition:transform 250ms ease,stroke .3s cubic-bezier(.35,0,.25,1)}:host .mat-progress-bar-fill::after{animation:none;content:'';display:inline-block;left:0}:host[mode=query]{transform:rotateZ(180deg)}:host[mode=indeterminate] .mat-progress-bar-fill,:host[mode=query] .mat-progress-bar-fill{transition:none}:host[mode=indeterminate] .mat-progress-bar-primary,:host[mode=query] .mat-progress-bar-primary{animation:mat-progress-bar-primary-indeterminate-translate 2s infinite linear;left:-145.166611%}:host[mode=indeterminate] .mat-progress-bar-primary.mat-progress-bar-fill::after,:host[mode=query] .mat-progress-bar-primary.mat-progress-bar-fill::after{animation:mat-progress-bar-primary-indeterminate-scale 2s infinite linear}:host[mode=indeterminate] .mat-progress-bar-secondary,:host[mode=query] .mat-progress-bar-secondary{animation:mat-progress-bar-secondary-indeterminate-translate 2s infinite linear;left:-54.888891%;display:block}:host[mode=indeterminate] .mat-progress-bar-secondary.mat-progress-bar-fill::after,:host[mode=query] .mat-progress-bar-secondary.mat-progress-bar-fill::after{animation:mat-progress-bar-secondary-indeterminate-scale 2s infinite linear}:host[mode=buffer] .mat-progress-bar-background{animation:mat-progress-bar-background-scroll 250ms infinite linear;display:block}:host-context([dir=rtl]){transform:rotateY(180deg)}@keyframes mat-progress-bar-primary-indeterminate-translate{0%{transform:translateX(0)}20%{animation-timing-function:cubic-bezier(.5,0,.70173,.49582);transform:translateX(0)}59.15%{animation-timing-function:cubic-bezier(.30244,.38135,.55,.95635);transform:translateX(83.67142%)}100%{transform:translateX(200.61106%)}}@keyframes mat-progress-bar-primary-indeterminate-scale{0%{transform:scaleX(.08)}36.65%{animation-timing-function:cubic-bezier(.33473,.12482,.78584,1);transform:scaleX(.08)}69.15%{animation-timing-function:cubic-bezier(.06,.11,.6,1);transform:scaleX(.66148)}100%{transform:scaleX(.08)}}@keyframes mat-progress-bar-secondary-indeterminate-translate{0%{animation-timing-function:cubic-bezier(.15,0,.51506,.40969);transform:translateX(0)}25%{animation-timing-function:cubic-bezier(.31033,.28406,.8,.73371);transform:translateX(37.65191%)}48.35%{animation-timing-function:cubic-bezier(.4,.62704,.6,.90203);transform:translateX(84.38617%)}100%{transform:translateX(160.27778%)}}@keyframes mat-progress-bar-secondary-indeterminate-scale{0%{animation-timing-function:cubic-bezier(.15,0,.51506,.40969);transform:scaleX(.08)}19.15%{animation-timing-function:cubic-bezier(.31033,.28406,.8,.73371);transform:scaleX(.4571)}44.15%{animation-timing-function:cubic-bezier(.4,.62704,.6,.90203);transform:scaleX(.72796)}100%{transform:scaleX(.08)}}@keyframes mat-progress-bar-background-scroll{to{transform:translateX(-10px)}} /*# sourceMappingURL=progress-bar.css.map */ "],
                changeDetection: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectionStrategy"].OnPush,
            },] },
];
/**
 * @nocollapse
 */
MdProgressBar.ctorParameters = function () { return []; };
MdProgressBar.propDecorators = {
    'color': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'value': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["HostBinding"], args: ['attr.aria-valuenow',] },],
    'bufferValue': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'mode': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["HostBinding"], args: ['attr.mode',] },],
};
/**
 * Clamps a value to be between two numbers, by default 0 and 100.
 * @param {?} v
 * @param {?=} min
 * @param {?=} max
 * @return {?}
 */
function clamp$1(v, min, max) {
    if (min === void 0) { min = 0; }
    if (max === void 0) { max = 100; }
    return Math.max(min, Math.min(max, v));
}
var MdProgressBarModule = (function () {
    function MdProgressBarModule() {
    }
    /**
     * @deprecated
     * @return {?}
     */
    MdProgressBarModule.forRoot = function () {
        return {
            ngModule: MdProgressBarModule,
            providers: []
        };
    };
    return MdProgressBarModule;
}());
MdProgressBarModule.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{
                imports: [__WEBPACK_IMPORTED_MODULE_2__angular_common__["CommonModule"], CompatibilityModule],
                exports: [MdProgressBar, CompatibilityModule],
                declarations: [MdProgressBar],
            },] },
];
/**
 * @nocollapse
 */
MdProgressBarModule.ctorParameters = function () { return []; };
/**
 * \@docs-private
 */
var MdInputContainerPlaceholderConflictError = (function (_super) {
    __extends(MdInputContainerPlaceholderConflictError, _super);
    function MdInputContainerPlaceholderConflictError() {
        return _super.call(this, 'Placeholder attribute and child element were both specified.') || this;
    }
    return MdInputContainerPlaceholderConflictError;
}(MdError));
/**
 * \@docs-private
 */
var MdInputContainerUnsupportedTypeError = (function (_super) {
    __extends(MdInputContainerUnsupportedTypeError, _super);
    /**
     * @param {?} type
     */
    function MdInputContainerUnsupportedTypeError(type) {
        return _super.call(this, "Input type \"" + type + "\" isn't supported by md-input-container.") || this;
    }
    return MdInputContainerUnsupportedTypeError;
}(MdError));
/**
 * \@docs-private
 */
var MdInputContainerDuplicatedHintError = (function (_super) {
    __extends(MdInputContainerDuplicatedHintError, _super);
    /**
     * @param {?} align
     */
    function MdInputContainerDuplicatedHintError(align) {
        return _super.call(this, "A hint was already declared for 'align=\"" + align + "\"'.") || this;
    }
    return MdInputContainerDuplicatedHintError;
}(MdError));
/**
 * \@docs-private
 */
var MdInputContainerMissingMdInputError = (function (_super) {
    __extends(MdInputContainerMissingMdInputError, _super);
    function MdInputContainerMissingMdInputError() {
        return _super.call(this, 'md-input-container must contain an mdInput directive. Did you forget to add mdInput ' +
            'to the native input or textarea element?') || this;
    }
    return MdInputContainerMissingMdInputError;
}(MdError));
// Invalid input type. Using one of these will throw an MdInputContainerUnsupportedTypeError.
var MD_INPUT_INVALID_TYPES = [
    'button',
    'checkbox',
    'color',
    'file',
    'hidden',
    'image',
    'radio',
    'range',
    'reset',
    'submit'
];
var nextUniqueId$1 = 0;
/**
 * The placeholder directive. The content can declare this to implement more
 * complex placeholders.
 */
var MdPlaceholder = (function () {
    function MdPlaceholder() {
    }
    return MdPlaceholder;
}());
MdPlaceholder.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                selector: 'md-placeholder, mat-placeholder'
            },] },
];
/**
 * @nocollapse
 */
MdPlaceholder.ctorParameters = function () { return []; };
/**
 * The hint directive, used to tag content as hint labels (going under the input).
 */
var MdHint = (function () {
    function MdHint() {
        // Whether to align the hint label at the start or end of the line.
        this.align = 'start';
        // Unique ID for the hint. Used for the aria-describedby on the input.
        this.id = "md-input-hint-" + nextUniqueId$1++;
    }
    return MdHint;
}());
MdHint.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                selector: 'md-hint, mat-hint',
                host: {
                    '[class.mat-hint]': 'true',
                    '[class.mat-right]': 'align == "end"',
                    '[attr.id]': 'id',
                }
            },] },
];
/**
 * @nocollapse
 */
MdHint.ctorParameters = function () { return []; };
MdHint.propDecorators = {
    'align': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'id': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
};
/**
 * Directive, used to display a single error message under the input.
 */
var MdErrorDirective = (function () {
    function MdErrorDirective() {
    }
    return MdErrorDirective;
}());
MdErrorDirective.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                selector: 'md-error, mat-error',
                host: {
                    '[class.mat-input-error]': 'true'
                }
            },] },
];
/**
 * @nocollapse
 */
MdErrorDirective.ctorParameters = function () { return []; };
/**
 * The input prefix.
 */
var MdPrefix = (function () {
    function MdPrefix() {
    }
    return MdPrefix;
}());
MdPrefix.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                selector: '[mdPrefix], [matPrefix], [md-prefix]'
            },] },
];
/**
 * @nocollapse
 */
MdPrefix.ctorParameters = function () { return []; };
/**
 * The input suffix.
 */
var MdSuffix = (function () {
    function MdSuffix() {
    }
    return MdSuffix;
}());
MdSuffix.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                selector: '[mdSuffix], [matSuffix], [md-suffix]'
            },] },
];
/**
 * @nocollapse
 */
MdSuffix.ctorParameters = function () { return []; };
/**
 * The input directive, used to mark the input that `MdInputContainer` is wrapping.
 */
var MdInputDirective = (function () {
    /**
     * @param {?} _elementRef
     * @param {?} _renderer
     * @param {?} _ngControl
     */
    function MdInputDirective(_elementRef, _renderer, _ngControl) {
        this._elementRef = _elementRef;
        this._renderer = _renderer;
        this._ngControl = _ngControl;
        this._type = 'text';
        this._placeholder = '';
        this._disabled = false;
        this._required = false;
        /** Whether the element is focused or not. */
        this.focused = false;
        /**
         * Emits an event when the placeholder changes so that the `md-input-container` can re-validate.
         */
        this._placeholderChange = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this._neverEmptyInputTypes = [
            'date',
            'datetime',
            'datetime-local',
            'month',
            'time',
            'week'
        ].filter(function (t) { return getSupportedInputTypes().has(t); });
        // Force setter to be called in case id was not specified.
        this.id = this.id;
    }
    Object.defineProperty(MdInputDirective.prototype, "disabled", {
        /**
         * Whether the element is disabled.
         * @return {?}
         */
        get: function () {
            return this._ngControl ? this._ngControl.disabled : this._disabled;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._disabled = coerceBooleanProperty(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdInputDirective.prototype, "id", {
        /**
         * Unique id of the element.
         * @return {?}
         */
        get: function () { return this._id; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this._id = value || this._uid; },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(MdInputDirective.prototype, "placeholder", {
        /**
         * Placeholder attribute of the element.
         * @return {?}
         */
        get: function () { return this._placeholder; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            if (this._placeholder !== value) {
                this._placeholder = value;
                this._placeholderChange.emit(this._placeholder);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdInputDirective.prototype, "required", {
        /**
         * Whether the element is required.
         * @return {?}
         */
        get: function () { return this._required; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this._required = coerceBooleanProperty(value); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdInputDirective.prototype, "type", {
        /**
         * Input type of the element.
         * @return {?}
         */
        get: function () { return this._type; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._type = value || 'text';
            this._validateType();
            // When using Angular inputs, developers are no longer able to set the properties on the native
            // input element. To ensure that bindings for `type` work, we need to sync the setter
            // with the native property. Textarea elements don't support the type property or attribute.
            if (!this._isTextarea() && getSupportedInputTypes().has(this._type)) {
                this._renderer.setElementProperty(this._elementRef.nativeElement, 'type', this._type);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdInputDirective.prototype, "value", {
        /**
         * The input element's value.
         * @return {?}
         */
        get: function () { return this._elementRef.nativeElement.value; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this._elementRef.nativeElement.value = value; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdInputDirective.prototype, "empty", {
        /**
         * @return {?}
         */
        get: function () {
            return !this._isNeverEmpty() &&
                (this.value == null || this.value === '') &&
                // Check if the input contains bad input. If so, we know that it only appears empty because
                // the value failed to parse. From the user's perspective it is not empty.
                // TODO(mmalerba): Add e2e test for bad input case.
                !this._isBadInput();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdInputDirective.prototype, "_uid", {
        /**
         * @return {?}
         */
        get: function () { return this._cachedUid = this._cachedUid || "md-input-" + nextUniqueId$1++; },
        enumerable: true,
        configurable: true
    });
    /**
     * Focuses the input element.
     * @return {?}
     */
    MdInputDirective.prototype.focus = function () { this._renderer.invokeElementMethod(this._elementRef.nativeElement, 'focus'); };
    /**
     * @return {?}
     */
    MdInputDirective.prototype._onFocus = function () { this.focused = true; };
    /**
     * @return {?}
     */
    MdInputDirective.prototype._onBlur = function () { this.focused = false; };
    /**
     * @return {?}
     */
    MdInputDirective.prototype._onInput = function () {
        // This is a noop function and is used to let Angular know whenever the value changes.
        // Angular will run a new change detection each time the `input` event has been dispatched.
        // It's necessary that Angular recognizes the value change, because when floatingLabel
        // is set to false and Angular forms aren't used, the placeholder won't recognize the
        // value changes and will not disappear.
        // Listening to the input event wouldn't be necessary when the input is using the
        // FormsModule or ReactiveFormsModule, because Angular forms also listens to input events.
    };
    /**
     * Make sure the input is a supported type.
     * @return {?}
     */
    MdInputDirective.prototype._validateType = function () {
        if (MD_INPUT_INVALID_TYPES.indexOf(this._type) !== -1) {
            throw new MdInputContainerUnsupportedTypeError(this._type);
        }
    };
    /**
     * @return {?}
     */
    MdInputDirective.prototype._isNeverEmpty = function () { return this._neverEmptyInputTypes.indexOf(this._type) !== -1; };
    /**
     * @return {?}
     */
    MdInputDirective.prototype._isBadInput = function () {
        return ((this._elementRef.nativeElement)).validity.badInput;
    };
    /**
     * Determines if the component host is a textarea. If not recognizable it returns false.
     * @return {?}
     */
    MdInputDirective.prototype._isTextarea = function () {
        var /** @type {?} */ nativeElement = this._elementRef.nativeElement;
        return nativeElement ? nativeElement.nodeName.toLowerCase() === 'textarea' : false;
    };
    return MdInputDirective;
}());
MdInputDirective.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                selector: "input[mdInput], textarea[mdInput], input[matInput], textarea[matInput]",
                host: {
                    '[class.mat-input-element]': 'true',
                    // Native input properties that are overwritten by Angular inputs need to be synced with
                    // the native input element. Otherwise property bindings for those don't work.
                    '[id]': 'id',
                    '[placeholder]': 'placeholder',
                    '[disabled]': 'disabled',
                    '[required]': 'required',
                    '[attr.aria-describedby]': 'ariaDescribedby || null',
                    '(blur)': '_onBlur()',
                    '(focus)': '_onFocus()',
                    '(input)': '_onInput()',
                }
            },] },
];
/**
 * @nocollapse
 */
MdInputDirective.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
    { type: __WEBPACK_IMPORTED_MODULE_8__angular_forms__["e" /* NgControl */], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] },] },
]; };
MdInputDirective.propDecorators = {
    'disabled': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'id': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'placeholder': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'required': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'type': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    '_placeholderChange': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
};
/**
 * Component that represents a text input. It encapsulates the <input> HTMLElement and
 * improve on its behaviour, along with styling it according to the Material Design.
 */
var MdInputContainer = (function () {
    /**
     * @param {?} _changeDetectorRef
     * @param {?} _parentForm
     * @param {?} _parentFormGroup
     */
    function MdInputContainer(_changeDetectorRef, _parentForm, _parentFormGroup) {
        this._changeDetectorRef = _changeDetectorRef;
        this._parentForm = _parentForm;
        this._parentFormGroup = _parentFormGroup;
        /** Alignment of the input container's content. */
        this.align = 'start';
        /** Color of the input divider, based on the theme. */
        this.color = 'primary';
        /** State of the md-hint and md-error animations. */
        this._subscriptAnimationState = '';
        this._hintLabel = '';
        // Unique id for the hint label.
        this._hintLabelId = "md-input-hint-" + nextUniqueId$1++;
        this._floatPlaceholder = 'auto';
    }
    Object.defineProperty(MdInputContainer.prototype, "dividerColor", {
        /**
         * @deprecated Use color instead.
         * @return {?}
         */
        get: function () { return this.color; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this.color = value; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdInputContainer.prototype, "_shouldAlwaysFloat", {
        /**
         * Whether the floating label should always float or not.
         * @return {?}
         */
        get: function () { return this._floatPlaceholder === 'always'; },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(MdInputContainer.prototype, "_canPlaceholderFloat", {
        /**
         * Whether the placeholder can float or not.
         * @return {?}
         */
        get: function () { return this._floatPlaceholder !== 'never'; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdInputContainer.prototype, "hintLabel", {
        /**
         * Text for the input hint.
         * @return {?}
         */
        get: function () { return this._hintLabel; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._hintLabel = value;
            this._processHints();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdInputContainer.prototype, "floatPlaceholder", {
        /**
         * Whether the placeholder should always float, never float or float as the user types.
         * @return {?}
         */
        get: function () { return this._floatPlaceholder; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._floatPlaceholder = value || 'auto';
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    MdInputContainer.prototype.ngAfterContentInit = function () {
        var _this = this;
        if (!this._mdInputChild) {
            throw new MdInputContainerMissingMdInputError();
        }
        this._processHints();
        this._validatePlaceholders();
        // Re-validate when things change.
        this._hintChildren.changes.subscribe(function () { return _this._processHints(); });
        this._mdInputChild._placeholderChange.subscribe(function () { return _this._validatePlaceholders(); });
    };
    /**
     * @return {?}
     */
    MdInputContainer.prototype.ngAfterViewInit = function () {
        // Avoid animations on load.
        this._subscriptAnimationState = 'enter';
        this._changeDetectorRef.detectChanges();
    };
    /**
     * Determines whether a class from the NgControl should be forwarded to the host element.
     * @param {?} prop
     * @return {?}
     */
    MdInputContainer.prototype._shouldForward = function (prop) {
        var /** @type {?} */ control = this._mdInputChild ? this._mdInputChild._ngControl : null;
        return control && ((control))[prop];
    };
    /**
     * Whether the input has a placeholder.
     * @return {?}
     */
    MdInputContainer.prototype._hasPlaceholder = function () { return !!(this._mdInputChild.placeholder || this._placeholderChild); };
    /**
     * Focuses the underlying input.
     * @return {?}
     */
    MdInputContainer.prototype._focusInput = function () { this._mdInputChild.focus(); };
    /**
     * Whether the input container is in an error state.
     * @return {?}
     */
    MdInputContainer.prototype._isErrorState = function () {
        var /** @type {?} */ control = this._mdInputChild._ngControl;
        var /** @type {?} */ isInvalid = control && control.invalid;
        var /** @type {?} */ isTouched = control && control.touched;
        var /** @type {?} */ isSubmitted = (this._parentFormGroup && this._parentFormGroup.submitted) ||
            (this._parentForm && this._parentForm.submitted);
        return !!(isInvalid && (isTouched || isSubmitted));
    };
    /**
     * Determines whether to display hints or errors.
     * @return {?}
     */
    MdInputContainer.prototype._getDisplayedMessages = function () {
        return (this._errorChildren.length > 0 && this._isErrorState()) ? 'error' : 'hint';
    };
    /**
     * Ensure that there is only one placeholder (either `input` attribute or child element with the
     * `md-placeholder` attribute.
     * @return {?}
     */
    MdInputContainer.prototype._validatePlaceholders = function () {
        if (this._mdInputChild.placeholder && this._placeholderChild) {
            throw new MdInputContainerPlaceholderConflictError();
        }
    };
    /**
     * Does any extra processing that is required when handling the hints.
     * @return {?}
     */
    MdInputContainer.prototype._processHints = function () {
        this._validateHints();
        this._syncAriaDescribedby();
    };
    /**
     * Ensure that there is a maximum of one of each `<md-hint>` alignment specified, with the
     * attribute being considered as `align="start"`.
     * @return {?}
     */
    MdInputContainer.prototype._validateHints = function () {
        var _this = this;
        if (this._hintChildren) {
            var /** @type {?} */ startHint_1 = null;
            var /** @type {?} */ endHint_1 = null;
            this._hintChildren.forEach(function (hint) {
                if (hint.align == 'start') {
                    if (startHint_1 || _this.hintLabel) {
                        throw new MdInputContainerDuplicatedHintError('start');
                    }
                    startHint_1 = hint;
                }
                else if (hint.align == 'end') {
                    if (endHint_1) {
                        throw new MdInputContainerDuplicatedHintError('end');
                    }
                    endHint_1 = hint;
                }
            });
        }
    };
    /**
     * Sets the child input's `aria-describedby` to a space-separated list of the ids
     * of the currently-specified hints, as well as a generated id for the hint label.
     * @return {?}
     */
    MdInputContainer.prototype._syncAriaDescribedby = function () {
        var /** @type {?} */ ids = [];
        var /** @type {?} */ startHint = this._hintChildren ?
            this._hintChildren.find(function (hint) { return hint.align === 'start'; }) : null;
        var /** @type {?} */ endHint = this._hintChildren ?
            this._hintChildren.find(function (hint) { return hint.align === 'end'; }) : null;
        if (startHint) {
            ids.push(startHint.id);
        }
        else if (this._hintLabel) {
            ids.push(this._hintLabelId);
        }
        if (endHint) {
            ids.push(endHint.id);
        }
        this._mdInputChild.ariaDescribedby = ids.join(' ');
    };
    return MdInputContainer;
}());
MdInputContainer.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{ selector: 'md-input-container, mat-input-container',
                template: "<div class=\"mat-input-wrapper\"> <div class=\"mat-input-table\"> <div class=\"mat-input-prefix\" *ngIf=\"_prefixChildren.length\"> <!-- TODO(andrewseguin): remove [md-prefix] --> <ng-content select=\"[mdPrefix], [matPrefix], [md-prefix]\"></ng-content> </div> <div class=\"mat-input-infix\" [class.mat-end]=\"align == 'end'\"> <ng-content selector=\"input, textarea\"></ng-content> <span class=\"mat-input-placeholder-wrapper\"> <label class=\"mat-input-placeholder\" [attr.for]=\"_mdInputChild.id\" [class.mat-empty]=\"_mdInputChild.empty && !_shouldAlwaysFloat\" [class.mat-float]=\"_canPlaceholderFloat\" [class.mat-accent]=\"color == 'accent'\" [class.mat-warn]=\"color == 'warn'\" *ngIf=\"_hasPlaceholder()\"> <ng-content select=\"md-placeholder, mat-placeholder\"></ng-content> {{_mdInputChild.placeholder}} <span class=\"mat-placeholder-required\" *ngIf=\"_mdInputChild.required\">*</span> </label> </span> </div> <div class=\"mat-input-suffix\" *ngIf=\"_suffixChildren.length\"> <!-- TODO(andrewseguin): remove [md-suffix] --> <ng-content select=\"[mdSuffix], [matSuffix], [md-suffix]\"></ng-content> </div> </div> <div class=\"mat-input-underline\" [class.mat-disabled]=\"_mdInputChild.disabled\"> <span class=\"mat-input-ripple\" [class.mat-accent]=\"color == 'accent'\" [class.mat-warn]=\"color == 'warn'\"></span> </div> <div class=\"mat-input-subscript-wrapper\" [ngSwitch]=\"_getDisplayedMessages()\"> <div *ngSwitchCase=\"'error'\" [@transitionMessages]=\"_subscriptAnimationState\"> <ng-content select=\"md-error, mat-error\"></ng-content> </div> <div class=\"mat-input-hint-wrapper\" *ngSwitchCase=\"'hint'\" [@transitionMessages]=\"_subscriptAnimationState\"> <div *ngIf=\"hintLabel\" [id]=\"_hintLabelId\" class=\"mat-hint\">{{hintLabel}}</div> <ng-content select=\"md-hint, mat-hint\"></ng-content> </div> </div> </div> ",
                styles: [".mat-input-container{display:inline-block;position:relative;font-family:Roboto,\"Helvetica Neue\",sans-serif;line-height:normal;text-align:left}[dir=rtl] .mat-input-container{text-align:right}.mat-input-container .mat-icon{width:auto;height:auto;font-size:100%;vertical-align:top}.mat-input-wrapper{margin:1em 0;padding-bottom:6px}.mat-input-table{display:inline-table;flex-flow:column;vertical-align:bottom;width:100%}.mat-input-table>*{display:table-cell}.mat-input-infix{position:relative}.mat-input-element{font:inherit;background:0 0;color:currentColor;border:none;outline:0;padding:0;width:100%;vertical-align:bottom}.mat-end .mat-input-element{text-align:right}[dir=rtl] .mat-end .mat-input-element{text-align:left}.mat-input-element:-moz-ui-invalid{box-shadow:none}.mat-input-element:-webkit-autofill+.mat-input-placeholder-wrapper .mat-float{display:block;transform:translateY(-1.35em) scale(.75);width:133.33333%;transition:none}.mat-input-element::placeholder{color:transparent}.mat-input-element::-moz-placeholder{color:transparent}.mat-input-element::-webkit-input-placeholder{color:transparent}.mat-input-element:-ms-input-placeholder{color:transparent}.mat-input-placeholder{position:absolute;left:0;top:0;font-size:100%;pointer-events:none;z-index:1;padding-top:1em;width:100%;display:none;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;transform:translateY(0);transform-origin:bottom left;transition:transform .4s cubic-bezier(.25,.8,.25,1),color .4s cubic-bezier(.25,.8,.25,1),width .4s cubic-bezier(.25,.8,.25,1)}.mat-input-placeholder.mat-empty{display:block;cursor:text}.mat-focused .mat-input-placeholder.mat-float,.mat-input-placeholder.mat-float:not(.mat-empty){display:block;transform:translateY(-1.35em) scale(.75);width:133.33333%}[dir=rtl] .mat-input-placeholder{transform-origin:bottom right;left:auto;right:0}.mat-input-placeholder:not(.mat-empty){transition:none}.mat-input-placeholder-wrapper{position:absolute;left:0;top:-1em;width:100%;padding-top:1em;overflow:hidden;pointer-events:none;transform:translate3d(0,0,0)}.mat-input-placeholder-wrapper::after{content:'';display:inline-table}.mat-input-underline{position:absolute;height:1px;width:100%;margin-top:4px;border-top-width:1px;border-top-style:solid}.mat-input-underline.mat-disabled{background-image:linear-gradient(to right,rgba(0,0,0,.26) 0,rgba(0,0,0,.26) 33%,transparent 0);background-size:4px 1px;background-repeat:repeat-x;border-top:0;background-position:0}.mat-input-underline .mat-input-ripple{position:absolute;height:2px;z-index:1;top:-1px;width:100%;transform-origin:top;opacity:0;transition:opacity .4s cubic-bezier(.25,.8,.25,1)}.mat-focused .mat-input-underline .mat-input-ripple{opacity:1}.mat-input-subscript-wrapper{position:absolute;font-size:75%;top:100%;width:100%;margin-top:-1em;overflow:hidden}.mat-input-hint-wrapper::after,.mat-input-hint-wrapper::before{content:' ';display:table}.mat-input-hint-wrapper::after{clear:both}.mat-hint{display:block;float:left}.mat-hint.mat-right{float:right}[dir=rtl] .mat-hint{float:right}[dir=rtl] .mat-hint.mat-right{float:left}.mat-input-error{display:block}.mat-input-prefix,.mat-input-suffix{width:.1px;white-space:nowrap} /*# sourceMappingURL=input-container.css.map */ "],
                animations: [
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__angular_animations__["f" /* trigger */])('transitionMessages', [
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__angular_animations__["g" /* state */])('enter', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__angular_animations__["c" /* style */])({ opacity: 1, transform: 'translateY(0%)' })),
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__angular_animations__["h" /* transition */])('void => enter', [
                            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__angular_animations__["c" /* style */])({ opacity: 0, transform: 'translateY(-100%)' }),
                            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__angular_animations__["i" /* animate */])('300ms cubic-bezier(0.55, 0, 0.55, 0.2)')
                        ])
                    ])
                ],
                host: {
                    // Remove align attribute to prevent it from interfering with layout.
                    '[attr.align]': 'null',
                    '[class.mat-input-container]': 'true',
                    '[class.mat-input-invalid]': '_isErrorState()',
                    '[class.mat-focused]': '_mdInputChild.focused',
                    '[class.ng-untouched]': '_shouldForward("untouched")',
                    '[class.ng-touched]': '_shouldForward("touched")',
                    '[class.ng-pristine]': '_shouldForward("pristine")',
                    '[class.ng-dirty]': '_shouldForward("dirty")',
                    '[class.ng-valid]': '_shouldForward("valid")',
                    '[class.ng-invalid]': '_shouldForward("invalid")',
                    '[class.ng-pending]': '_shouldForward("pending")',
                    '(click)': '_focusInput()',
                },
                encapsulation: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewEncapsulation"].None,
            },] },
];
/**
 * @nocollapse
 */
MdInputContainer.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectorRef"], },
    { type: __WEBPACK_IMPORTED_MODULE_8__angular_forms__["f" /* NgForm */], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] },] },
    { type: __WEBPACK_IMPORTED_MODULE_8__angular_forms__["g" /* FormGroupDirective */], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] },] },
]; };
MdInputContainer.propDecorators = {
    'align': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'color': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'dividerColor': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'hintLabel': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'floatPlaceholder': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    '_mdInputChild': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ContentChild"], args: [MdInputDirective,] },],
    '_placeholderChild': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ContentChild"], args: [MdPlaceholder,] },],
    '_errorChildren': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ContentChildren"], args: [MdErrorDirective,] },],
    '_hintChildren': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ContentChildren"], args: [MdHint,] },],
    '_prefixChildren': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ContentChildren"], args: [MdPrefix,] },],
    '_suffixChildren': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ContentChildren"], args: [MdSuffix,] },],
};
/**
 * Directive to automatically resize a textarea to fit its content.
 */
var MdTextareaAutosize = (function () {
    /**
     * @param {?} _elementRef
     */
    function MdTextareaAutosize(_elementRef) {
        this._elementRef = _elementRef;
    }
    Object.defineProperty(MdTextareaAutosize.prototype, "mdAutosizeMinRows", {
        /**
         * @return {?}
         */
        get: function () {
            return this.minRows;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this.minRows = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdTextareaAutosize.prototype, "mdAutosizeMaxRows", {
        /**
         * @return {?}
         */
        get: function () {
            return this.maxRows;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this.maxRows = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdTextareaAutosize.prototype, "_minHeight", {
        /**
         * The minimum height of the textarea as determined by minRows.
         * @return {?}
         */
        get: function () {
            return this.minRows ? this.minRows * this._cachedLineHeight + "px" : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdTextareaAutosize.prototype, "_maxHeight", {
        /**
         * The maximum height of the textarea as determined by maxRows.
         * @return {?}
         */
        get: function () {
            return this.maxRows ? this.maxRows * this._cachedLineHeight + "px" : null;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    MdTextareaAutosize.prototype.ngOnInit = function () {
        this._cacheTextareaLineHeight();
        this.resizeToFitContent();
    };
    /**
     * Cache the height of a single-row textarea.
     *
     * We need to know how large a single "row" of a textarea is in order to apply minRows and
     * maxRows. For the initial version, we will assume that the height of a single line in the
     * textarea does not ever change.
     * @return {?}
     */
    MdTextareaAutosize.prototype._cacheTextareaLineHeight = function () {
        var /** @type {?} */ textarea = (this._elementRef.nativeElement);
        // Use a clone element because we have to override some styles.
        var /** @type {?} */ textareaClone = (textarea.cloneNode(false));
        textareaClone.rows = 1;
        // Use `position: absolute` so that this doesn't cause a browser layout and use
        // `visibility: hidden` so that nothing is rendered. Clear any other styles that
        // would affect the height.
        textareaClone.style.position = 'absolute';
        textareaClone.style.visibility = 'hidden';
        textareaClone.style.border = 'none';
        textareaClone.style.padding = '';
        textareaClone.style.height = '';
        textareaClone.style.minHeight = '';
        textareaClone.style.maxHeight = '';
        textarea.parentNode.appendChild(textareaClone);
        this._cachedLineHeight = textareaClone.offsetHeight;
        textarea.parentNode.removeChild(textareaClone);
    };
    /**
     * Resize the textarea to fit its content.
     * @return {?}
     */
    MdTextareaAutosize.prototype.resizeToFitContent = function () {
        var /** @type {?} */ textarea = (this._elementRef.nativeElement);
        // Reset the textarea height to auto in order to shrink back to its default size.
        textarea.style.height = 'auto';
        // Use the scrollHeight to know how large the textarea *would* be if fit its entire value.
        textarea.style.height = textarea.scrollHeight + "px";
    };
    return MdTextareaAutosize;
}());
MdTextareaAutosize.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                selector: 'textarea[md-autosize], textarea[mdTextareaAutosize],' +
                    'textarea[mat-autosize], textarea[matTextareaAutosize]',
                exportAs: 'mdTextareaAutosize',
                host: {
                    '(input)': 'resizeToFitContent()',
                    '[style.min-height]': '_minHeight',
                    '[style.max-height]': '_maxHeight',
                },
            },] },
];
/**
 * @nocollapse
 */
MdTextareaAutosize.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
]; };
MdTextareaAutosize.propDecorators = {
    'minRows': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'mdAutosizeMinRows': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'maxRows': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'mdAutosizeMaxRows': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
};
var MdInputModule = (function () {
    function MdInputModule() {
    }
    /**
     * @deprecated
     * @return {?}
     */
    MdInputModule.forRoot = function () {
        return {
            ngModule: MdInputModule,
            providers: [],
        };
    };
    return MdInputModule;
}());
MdInputModule.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{
                declarations: [
                    MdErrorDirective,
                    MdHint,
                    MdInputContainer,
                    MdInputDirective,
                    MdPlaceholder,
                    MdPrefix,
                    MdSuffix,
                    MdTextareaAutosize,
                ],
                imports: [
                    __WEBPACK_IMPORTED_MODULE_2__angular_common__["CommonModule"],
                    __WEBPACK_IMPORTED_MODULE_8__angular_forms__["d" /* FormsModule */],
                    PlatformModule,
                ],
                exports: [
                    MdErrorDirective,
                    MdHint,
                    MdInputContainer,
                    MdInputDirective,
                    MdPlaceholder,
                    MdPrefix,
                    MdSuffix,
                    MdTextareaAutosize,
                ],
            },] },
];
/**
 * @nocollapse
 */
MdInputModule.ctorParameters = function () { return []; };
/**
 * Configuration used when opening a snack-bar.
 */
var MdSnackBarConfig = (function () {
    function MdSnackBarConfig() {
        /** The politeness level for the MdAriaLiveAnnouncer announcement. */
        this.politeness = 'assertive';
        /** Message to be announced by the MdAriaLiveAnnouncer */
        this.announcementMessage = '';
        /** The view container to place the overlay for the snack bar into. */
        this.viewContainerRef = null;
        /** The length of time in milliseconds to wait before automatically dismissing the snack bar. */
        this.duration = 0;
    }
    return MdSnackBarConfig;
}());
/**
 * Reference to a snack bar dispatched from the snack bar service.
 */
var MdSnackBarRef = (function () {
    /**
     * @param {?} instance
     * @param {?} containerInstance
     * @param {?} _overlayRef
     */
    function MdSnackBarRef(instance, containerInstance, _overlayRef) {
        var _this = this;
        this._overlayRef = _overlayRef;
        this._afterClosed = new __WEBPACK_IMPORTED_MODULE_3_rxjs_Subject__["Subject"]();
        this._onAction = new __WEBPACK_IMPORTED_MODULE_3_rxjs_Subject__["Subject"]();
        // Sets the readonly instance of the snack bar content component.
        this._instance = instance;
        this.containerInstance = containerInstance;
        // Dismiss snackbar on action.
        this.onAction().subscribe(function () { return _this.dismiss(); });
        containerInstance._onExit().subscribe(function () { return _this._finishDismiss(); });
    }
    Object.defineProperty(MdSnackBarRef.prototype, "instance", {
        /**
         * The instance of the component making up the content of the snack bar.
         * @return {?}
         */
        get: function () {
            return this._instance;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Dismisses the snack bar.
     * @return {?}
     */
    MdSnackBarRef.prototype.dismiss = function () {
        if (!this._afterClosed.closed) {
            this.containerInstance.exit();
        }
    };
    /**
     * Marks the snackbar action clicked.
     * @return {?}
     */
    MdSnackBarRef.prototype._action = function () {
        if (!this._onAction.closed) {
            this._onAction.next();
            this._onAction.complete();
        }
    };
    /**
     * Marks the snackbar as opened
     * @return {?}
     */
    MdSnackBarRef.prototype._open = function () {
        if (!this._afterOpened.closed) {
            this._afterOpened.next();
            this._afterOpened.complete();
        }
    };
    /**
     * Cleans up the DOM after closing.
     * @return {?}
     */
    MdSnackBarRef.prototype._finishDismiss = function () {
        this._overlayRef.dispose();
        this._afterClosed.next();
        this._afterClosed.complete();
    };
    /**
     * Gets an observable that is notified when the snack bar is finished closing.
     * @return {?}
     */
    MdSnackBarRef.prototype.afterDismissed = function () {
        return this._afterClosed.asObservable();
    };
    /**
     * Gets an observable that is notified when the snack bar has opened and appeared.
     * @return {?}
     */
    MdSnackBarRef.prototype.afterOpened = function () {
        return this.containerInstance._onEnter();
    };
    /**
     * Gets an observable that is notified when the snack bar action is called.
     * @return {?}
     */
    MdSnackBarRef.prototype.onAction = function () {
        return this._onAction.asObservable();
    };
    return MdSnackBarRef;
}());
/**
 * Error that is thrown when attempting to attach a snack bar that is already attached.
 * \@docs-private
 */
var MdSnackBarContentAlreadyAttached = (function (_super) {
    __extends(MdSnackBarContentAlreadyAttached, _super);
    function MdSnackBarContentAlreadyAttached() {
        return _super.call(this, 'Attempting to attach snack bar content after content is already attached') || this;
    }
    return MdSnackBarContentAlreadyAttached;
}(MdError));
// TODO(jelbourn): we can't use constants from animation.ts here because you can't use
// a text interpolation in anything that is analyzed statically with ngc (for AoT compile).
var SHOW_ANIMATION = '225ms cubic-bezier(0.4,0.0,1,1)';
var HIDE_ANIMATION = '195ms cubic-bezier(0.0,0.0,0.2,1)';
/**
 * Internal component that wraps user-provided snack bar content.
 * \@docs-private
 */
var MdSnackBarContainer = (function (_super) {
    __extends(MdSnackBarContainer, _super);
    /**
     * @param {?} _ngZone
     * @param {?} _renderer
     * @param {?} _elementRef
     */
    function MdSnackBarContainer(_ngZone, _renderer, _elementRef) {
        var _this = _super.call(this) || this;
        _this._ngZone = _ngZone;
        _this._renderer = _renderer;
        _this._elementRef = _elementRef;
        _this.onExit = new __WEBPACK_IMPORTED_MODULE_3_rxjs_Subject__["Subject"]();
        _this.onEnter = new __WEBPACK_IMPORTED_MODULE_3_rxjs_Subject__["Subject"]();
        /** The state of the snack bar animations. */
        _this.animationState = 'initial';
        return _this;
    }
    /**
     * Attach a component portal as content to this snack bar container.
     * @template T
     * @param {?} portal
     * @return {?}
     */
    MdSnackBarContainer.prototype.attachComponentPortal = function (portal) {
        if (this._portalHost.hasAttached()) {
            throw new MdSnackBarContentAlreadyAttached();
        }
        if (this.snackBarConfig.extraClasses) {
            // Not the most efficient way of adding classes, but the renderer doesn't allow us
            // to pass in an array or a space-separated list.
            for (var _i = 0, _a = this.snackBarConfig.extraClasses; _i < _a.length; _i++) {
                var cssClass = _a[_i];
                this._renderer.setElementClass(this._elementRef.nativeElement, cssClass, true);
            }
        }
        return this._portalHost.attachComponentPortal(portal);
    };
    /**
     * Attach a template portal as content to this snack bar container.
     * @param {?} portal
     * @return {?}
     */
    MdSnackBarContainer.prototype.attachTemplatePortal = function (portal) {
        throw Error('Not yet implemented');
    };
    /**
     * Handle end of animations, updating the state of the snackbar.
     * @param {?} event
     * @return {?}
     */
    MdSnackBarContainer.prototype.onAnimationEnd = function (event) {
        var _this = this;
        if (event.toState === 'void' || event.toState === 'complete') {
            this._completeExit();
        }
        if (event.toState === 'visible') {
            this._ngZone.run(function () {
                _this.onEnter.next();
                _this.onEnter.complete();
            });
        }
    };
    /**
     * Begin animation of snack bar entrance into view.
     * @return {?}
     */
    MdSnackBarContainer.prototype.enter = function () {
        this.animationState = 'visible';
    };
    /**
     * Returns an observable resolving when the enter animation completes.
     * @return {?}
     */
    MdSnackBarContainer.prototype._onEnter = function () {
        this.animationState = 'visible';
        return this.onEnter.asObservable();
    };
    /**
     * Begin animation of the snack bar exiting from view.
     * @return {?}
     */
    MdSnackBarContainer.prototype.exit = function () {
        this.animationState = 'complete';
        return this._onExit();
    };
    /**
     * Returns an observable that completes after the closing animation is done.
     * @return {?}
     */
    MdSnackBarContainer.prototype._onExit = function () {
        return this.onExit.asObservable();
    };
    /**
     * Makes sure the exit callbacks have been invoked when the element is destroyed.
     * @return {?}
     */
    MdSnackBarContainer.prototype.ngOnDestroy = function () {
        this._completeExit();
    };
    /**
     * Waits for the zone to settle before removing the element. Helps prevent
     * errors where we end up removing an element which is in the middle of an animation.
     * @return {?}
     */
    MdSnackBarContainer.prototype._completeExit = function () {
        var _this = this;
        this._ngZone.onMicrotaskEmpty.first().subscribe(function () {
            _this.onExit.next();
            _this.onExit.complete();
        });
    };
    return MdSnackBarContainer;
}(BasePortalHost));
MdSnackBarContainer.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{ selector: 'snack-bar-container',
                template: "<ng-template cdkPortalHost></ng-template> ",
                styles: [":host{box-shadow:0 3px 5px -1px rgba(0,0,0,.2),0 6px 10px 0 rgba(0,0,0,.14),0 1px 18px 0 rgba(0,0,0,.12);background:#323232;border-radius:2px;box-sizing:content-box;display:block;height:20px;max-width:568px;min-width:288px;overflow:hidden;padding:14px 24px;transform:translateY(100%)}@media screen and (-ms-high-contrast:active){:host{border:solid 1px}} /*# sourceMappingURL=snack-bar-container.css.map */ "],
                host: {
                    'role': 'alert',
                    '[@state]': 'animationState',
                    '(@state.done)': 'onAnimationEnd($event)'
                },
                animations: [
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__angular_animations__["f" /* trigger */])('state', [
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__angular_animations__["g" /* state */])('initial', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__angular_animations__["c" /* style */])({ transform: 'translateY(100%)' })),
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__angular_animations__["g" /* state */])('visible', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__angular_animations__["c" /* style */])({ transform: 'translateY(0%)' })),
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__angular_animations__["g" /* state */])('complete', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__angular_animations__["c" /* style */])({ transform: 'translateY(100%)' })),
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__angular_animations__["h" /* transition */])('visible => complete', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__angular_animations__["i" /* animate */])(HIDE_ANIMATION)),
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__angular_animations__["h" /* transition */])('initial => visible, void => visible', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__angular_animations__["i" /* animate */])(SHOW_ANIMATION)),
                    ])
                ],
            },] },
];
/**
 * @nocollapse
 */
MdSnackBarContainer.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgZone"], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
]; };
MdSnackBarContainer.propDecorators = {
    '_portalHost': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewChild"], args: [PortalHostDirective,] },],
};
/**
 * A component used to open as the default snack bar, matching material spec.
 * This should only be used internally by the snack bar service.
 */
var SimpleSnackBar = (function () {
    function SimpleSnackBar() {
    }
    /**
     * Dismisses the snack bar.
     * @return {?}
     */
    SimpleSnackBar.prototype.dismiss = function () {
        this.snackBarRef._action();
    };
    Object.defineProperty(SimpleSnackBar.prototype, "hasAction", {
        /**
         * If the action button should be shown.
         * @return {?}
         */
        get: function () { return !!this.action; },
        enumerable: true,
        configurable: true
    });
    return SimpleSnackBar;
}());
SimpleSnackBar.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{ selector: 'simple-snack-bar',
                template: "<span class=\"mat-simple-snackbar-message\">{{message}}</span> <button class=\"mat-simple-snackbar-action\" *ngIf=\"hasAction\" (click)=\"dismiss()\">{{action}}</button> ",
                styles: [":host{display:flex;justify-content:space-between;color:#fff;line-height:20px;font-size:14px;font-family:Roboto,\"Helvetica Neue\",sans-serif}.mat-simple-snackbar-message{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.mat-simple-snackbar-action{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:pointer;outline:0;border:none;background:0 0;margin:-5px 0 0;padding:5px;text-transform:uppercase;color:inherit;line-height:inherit;flex-shrink:0;font-family:inherit;font-size:inherit;font-weight:600} /*# sourceMappingURL=simple-snack-bar.css.map */ "],
                host: {
                    '[class.mat-simple-snackbar]': 'true',
                }
            },] },
];
/**
 * @nocollapse
 */
SimpleSnackBar.ctorParameters = function () { return []; };
/**
 * Extends an object with the *enumerable* and *own* properties of one or more source objects,
 * similar to Object.assign.
 *
 * @param {?} dest The object which will have properties copied to it.
 * @param {...?} sources The source objects from which properties will be copied.
 * @return {?}
 */
function extendObject(dest) {
    var sources = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        sources[_i - 1] = arguments[_i];
    }
    if (dest == null) {
        throw TypeError('Cannot convert undefined or null to object');
    }
    for (var _a = 0, sources_1 = sources; _a < sources_1.length; _a++) {
        var source = sources_1[_a];
        if (source != null) {
            for (var /** @type {?} */ key in source) {
                if (source.hasOwnProperty(key)) {
                    dest[key] = source[key];
                }
            }
        }
    }
    return dest;
}
/**
 * Service to dispatch Material Design snack bar messages.
 */
var MdSnackBar = (function () {
    /**
     * @param {?} _overlay
     * @param {?} _live
     * @param {?} _parentSnackBar
     */
    function MdSnackBar(_overlay, _live, _parentSnackBar) {
        this._overlay = _overlay;
        this._live = _live;
        this._parentSnackBar = _parentSnackBar;
    }
    Object.defineProperty(MdSnackBar.prototype, "_openedSnackBarRef", {
        /**
         * Reference to the currently opened snackbar at *any* level.
         * @return {?}
         */
        get: function () {
            return this._parentSnackBar ?
                this._parentSnackBar._openedSnackBarRef : this._snackBarRefAtThisLevel;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            if (this._parentSnackBar) {
                this._parentSnackBar._openedSnackBarRef = value;
            }
            else {
                this._snackBarRefAtThisLevel = value;
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Creates and dispatches a snack bar with a custom component for the content, removing any
     * currently opened snack bars.
     *
     * @template T
     * @param {?} component Component to be instantiated.
     * @param {?=} config Extra configuration for the snack bar.
     * @return {?}
     */
    MdSnackBar.prototype.openFromComponent = function (component, config) {
        var _this = this;
        config = _applyConfigDefaults(config);
        var /** @type {?} */ overlayRef = this._createOverlay();
        var /** @type {?} */ snackBarContainer = this._attachSnackBarContainer(overlayRef, config);
        var /** @type {?} */ snackBarRef = this._attachSnackbarContent(component, snackBarContainer, overlayRef);
        // When the snackbar is dismissed, clear the reference to it.
        snackBarRef.afterDismissed().subscribe(function () {
            // Clear the snackbar ref if it hasn't already been replaced by a newer snackbar.
            if (_this._openedSnackBarRef == snackBarRef) {
                _this._openedSnackBarRef = null;
            }
        });
        // If a snack bar is already in view, dismiss it and enter the new snack bar after exit
        // animation is complete.
        if (this._openedSnackBarRef) {
            this._openedSnackBarRef.afterDismissed().subscribe(function () {
                snackBarRef.containerInstance.enter();
            });
            this._openedSnackBarRef.dismiss();
        }
        else {
            snackBarRef.containerInstance.enter();
        }
        // If a dismiss timeout is provided, set up dismiss based on after the snackbar is opened.
        if (config.duration > 0) {
            snackBarRef.afterOpened().subscribe(function () {
                setTimeout(function () { return snackBarRef.dismiss(); }, config.duration);
            });
        }
        this._live.announce(config.announcementMessage, config.politeness);
        this._openedSnackBarRef = snackBarRef;
        return this._openedSnackBarRef;
    };
    /**
     * Opens a snackbar with a message and an optional action.
     * @param {?} message The message to show in the snackbar.
     * @param {?=} action The label for the snackbar action.
     * @param {?=} config Additional configuration options for the snackbar.
     * @return {?}
     */
    MdSnackBar.prototype.open = function (message, action, config) {
        if (action === void 0) { action = ''; }
        if (config === void 0) { config = {}; }
        config.announcementMessage = message;
        var /** @type {?} */ simpleSnackBarRef = this.openFromComponent(SimpleSnackBar, config);
        simpleSnackBarRef.instance.snackBarRef = simpleSnackBarRef;
        simpleSnackBarRef.instance.message = message;
        simpleSnackBarRef.instance.action = action;
        return simpleSnackBarRef;
    };
    /**
     * Dismisses the currently-visible snack bar.
     * @return {?}
     */
    MdSnackBar.prototype.dismiss = function () {
        if (this._openedSnackBarRef) {
            this._openedSnackBarRef.dismiss();
        }
    };
    /**
     * Attaches the snack bar container component to the overlay.
     * @param {?} overlayRef
     * @param {?} config
     * @return {?}
     */
    MdSnackBar.prototype._attachSnackBarContainer = function (overlayRef, config) {
        var /** @type {?} */ containerPortal = new ComponentPortal(MdSnackBarContainer, config.viewContainerRef);
        var /** @type {?} */ containerRef = overlayRef.attach(containerPortal);
        containerRef.instance.snackBarConfig = config;
        return containerRef.instance;
    };
    /**
     * Places a new component as the content of the snack bar container.
     * @template T
     * @param {?} component
     * @param {?} container
     * @param {?} overlayRef
     * @return {?}
     */
    MdSnackBar.prototype._attachSnackbarContent = function (component, container, overlayRef) {
        var /** @type {?} */ portal = new ComponentPortal(component);
        var /** @type {?} */ contentRef = container.attachComponentPortal(portal);
        return new MdSnackBarRef(contentRef.instance, container, overlayRef);
    };
    /**
     * Creates a new overlay and places it in the correct location.
     * @return {?}
     */
    MdSnackBar.prototype._createOverlay = function () {
        var /** @type {?} */ state$$1 = new OverlayState();
        state$$1.positionStrategy = this._overlay.position().global()
            .centerHorizontally()
            .bottom('0');
        return this._overlay.create(state$$1);
    };
    return MdSnackBar;
}());
MdSnackBar.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
];
/**
 * @nocollapse
 */
MdSnackBar.ctorParameters = function () { return [
    { type: Overlay, },
    { type: LiveAnnouncer, },
    { type: MdSnackBar, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["SkipSelf"] },] },
]; };
/**
 * Applies default options to the snackbar config.
 * @param {?} config The configuration to which the defaults will be applied.
 * @return {?} The new configuration object with defaults applied.
 */
function _applyConfigDefaults(config) {
    return extendObject(new MdSnackBarConfig(), config);
}
var MdSnackBarModule = (function () {
    function MdSnackBarModule() {
    }
    /**
     * @deprecated
     * @return {?}
     */
    MdSnackBarModule.forRoot = function () {
        return {
            ngModule: MdSnackBarModule,
            providers: []
        };
    };
    return MdSnackBarModule;
}());
MdSnackBarModule.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{
                imports: [
                    OverlayModule,
                    PortalModule,
                    __WEBPACK_IMPORTED_MODULE_2__angular_common__["CommonModule"],
                    CompatibilityModule,
                ],
                exports: [MdSnackBarContainer, CompatibilityModule],
                declarations: [MdSnackBarContainer, SimpleSnackBar],
                entryComponents: [MdSnackBarContainer, SimpleSnackBar],
                providers: [MdSnackBar, LIVE_ANNOUNCER_PROVIDER]
            },] },
];
/**
 * @nocollapse
 */
MdSnackBarModule.ctorParameters = function () { return []; };
/**
 * Used to flag tab labels for use with the portal directive
 */
var MdTabLabel = (function (_super) {
    __extends(MdTabLabel, _super);
    /**
     * @param {?} templateRef
     * @param {?} viewContainerRef
     */
    function MdTabLabel(templateRef, viewContainerRef) {
        return _super.call(this, templateRef, viewContainerRef) || this;
    }
    return MdTabLabel;
}(TemplatePortalDirective));
MdTabLabel.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                selector: '[md-tab-label], [mat-tab-label]',
            },] },
];
/**
 * @nocollapse
 */
MdTabLabel.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["TemplateRef"], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewContainerRef"], },
]; };
var MdTab = (function () {
    /**
     * @param {?} _viewContainerRef
     */
    function MdTab(_viewContainerRef) {
        this._viewContainerRef = _viewContainerRef;
        /** The plain text label for the tab, used when there is no template label. */
        this.textLabel = '';
        this._contentPortal = null;
        /**
         * The relatively indexed position where 0 represents the center, negative is left, and positive
         * represents the right.
         */
        this.position = null;
        /**
         * The initial relatively index origin of the tab if it was created and selected after there
         * was already a selected tab. Provides context of what position the tab should originate from.
         */
        this.origin = null;
        this._disabled = false;
    }
    Object.defineProperty(MdTab.prototype, "content", {
        /**
         * @return {?}
         */
        get: function () { return this._contentPortal; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdTab.prototype, "disabled", {
        /**
         * @return {?}
         */
        get: function () { return this._disabled; },
        /**
         * Whether the tab is disabled
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this._disabled = coerceBooleanProperty(value); },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    MdTab.prototype.ngOnInit = function () {
        this._contentPortal = new TemplatePortal(this._content, this._viewContainerRef);
    };
    return MdTab;
}());
MdTab.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{ selector: 'md-tab, mat-tab',
                template: "<!-- Create a template for the content of the <md-tab> so that we can grab a reference to this TemplateRef and use it in a Portal to render the tab content in the appropriate place in the tab-group. --> <ng-template><ng-content></ng-content></ng-template> ",
            },] },
];
/**
 * @nocollapse
 */
MdTab.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewContainerRef"], },
]; };
MdTab.propDecorators = {
    'templateLabel': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ContentChild"], args: [MdTabLabel,] },],
    '_content': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewChild"], args: [__WEBPACK_IMPORTED_MODULE_0__angular_core__["TemplateRef"],] },],
    'textLabel': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['label',] },],
    'disabled': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
};
/** Used to generate unique ID's for each tab component */
var nextId$2 = 0;
/**
 * A simple change event emitted on focus or selection changes.
 */
var MdTabChangeEvent = (function () {
    function MdTabChangeEvent() {
    }
    return MdTabChangeEvent;
}());
/**
 * Material design tab-group component.  Supports basic tab pairs (label + content) and includes
 * animated ink-bar, keyboard navigation, and screen reader.
 * See: https://www.google.com/design/spec/components/tabs.html
 */
var MdTabGroup = (function () {
    /**
     * @param {?} _renderer
     */
    function MdTabGroup(_renderer) {
        this._renderer = _renderer;
        this._isInitialized = false;
        this._indexToSelect = 0;
        this._tabBodyWrapperHeight = null;
        this._dynamicHeight = false;
        this._selectedIndex = null;
        /** Position of the tab header. */
        this.headerPosition = 'above';
        this._onFocusChange = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        this._onSelectChange = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"](true);
        this._groupId = nextId$2++;
    }
    Object.defineProperty(MdTabGroup.prototype, "dynamicHeight", {
        /**
         * @return {?}
         */
        get: function () { return this._dynamicHeight; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this._dynamicHeight = coerceBooleanProperty(value); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdTabGroup.prototype, "_dynamicHeightDeprecated", {
        /**
         * @deprecated
         * @return {?}
         */
        get: function () { return this._dynamicHeight; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this._dynamicHeight = value; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdTabGroup.prototype, "selectedIndex", {
        /**
         * @return {?}
         */
        get: function () { return this._selectedIndex; },
        /**
         * The index of the active tab.
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this._indexToSelect = value; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdTabGroup.prototype, "selectedIndexChange", {
        /**
         * Output to enable support for two-way binding on ([selectedIndex])
         * @return {?}
         */
        get: function () {
            return this.selectChange.map(function (event) { return event.index; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdTabGroup.prototype, "focusChange", {
        /**
         * Event emitted when focus has changed within a tab group.
         * @return {?}
         */
        get: function () {
            return this._onFocusChange.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdTabGroup.prototype, "selectChange", {
        /**
         * Event emitted when the tab selection has changed.
         * @return {?}
         */
        get: function () {
            return this._onSelectChange.asObservable();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * After the content is checked, this component knows what tabs have been defined
     * and what the selected index should be. This is where we can know exactly what position
     * each tab should be in according to the new selected index, and additionally we know how
     * a new selected tab should transition in (from the left or right).
     * @return {?}
     */
    MdTabGroup.prototype.ngAfterContentChecked = function () {
        var _this = this;
        // Clamp the next selected index to the bounds of 0 and the tabs length. Note the `|| 0`, which
        // ensures that values like NaN can't get through and which would otherwise throw the
        // component into an infinite loop (since Math.max(NaN, 0) === NaN).
        this._indexToSelect =
            Math.min(this._tabs.length - 1, Math.max(this._indexToSelect || 0, 0));
        // If there is a change in selected index, emit a change event. Should not trigger if
        // the selected index has not yet been initialized.
        if (this._selectedIndex != this._indexToSelect && this._selectedIndex != null) {
            this._onSelectChange.emit(this._createChangeEvent(this._indexToSelect));
        }
        // Setup the position for each tab and optionally setup an origin on the next selected tab.
        this._tabs.forEach(function (tab, index) {
            tab.position = index - _this._indexToSelect;
            // If there is already a selected tab, then set up an origin for the next selected tab
            // if it doesn't have one already.
            if (_this._selectedIndex != null && tab.position == 0 && !tab.origin) {
                tab.origin = _this._indexToSelect - _this._selectedIndex;
            }
        });
        this._selectedIndex = this._indexToSelect;
    };
    /**
     * Waits one frame for the view to update, then updates the ink bar
     * Note: This must be run outside of the zone or it will create an infinite change detection loop.
     * @return {?}
     */
    MdTabGroup.prototype.ngAfterViewChecked = function () {
        this._isInitialized = true;
    };
    /**
     * @param {?} index
     * @return {?}
     */
    MdTabGroup.prototype._focusChanged = function (index) {
        this._onFocusChange.emit(this._createChangeEvent(index));
    };
    /**
     * @param {?} index
     * @return {?}
     */
    MdTabGroup.prototype._createChangeEvent = function (index) {
        var /** @type {?} */ event = new MdTabChangeEvent;
        event.index = index;
        if (this._tabs && this._tabs.length) {
            event.tab = this._tabs.toArray()[index];
        }
        return event;
    };
    /**
     * Returns a unique id for each tab label element
     * @param {?} i
     * @return {?}
     */
    MdTabGroup.prototype._getTabLabelId = function (i) {
        return "md-tab-label-" + this._groupId + "-" + i;
    };
    /**
     * Returns a unique id for each tab content element
     * @param {?} i
     * @return {?}
     */
    MdTabGroup.prototype._getTabContentId = function (i) {
        return "md-tab-content-" + this._groupId + "-" + i;
    };
    /**
     * Sets the height of the body wrapper to the height of the activating tab if dynamic
     * height property is true.
     * @param {?} tabHeight
     * @return {?}
     */
    MdTabGroup.prototype._setTabBodyWrapperHeight = function (tabHeight) {
        if (!this._dynamicHeight || !this._tabBodyWrapperHeight) {
            return;
        }
        this._renderer.setElementStyle(this._tabBodyWrapper.nativeElement, 'height', this._tabBodyWrapperHeight + 'px');
        // This conditional forces the browser to paint the height so that
        // the animation to the new height can have an origin.
        if (this._tabBodyWrapper.nativeElement.offsetHeight) {
            this._renderer.setElementStyle(this._tabBodyWrapper.nativeElement, 'height', tabHeight + 'px');
        }
    };
    /**
     * Removes the height of the tab body wrapper.
     * @return {?}
     */
    MdTabGroup.prototype._removeTabBodyWrapperHeight = function () {
        this._tabBodyWrapperHeight = this._tabBodyWrapper.nativeElement.clientHeight;
        this._renderer.setElementStyle(this._tabBodyWrapper.nativeElement, 'height', '');
    };
    return MdTabGroup;
}());
MdTabGroup.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{ selector: 'md-tab-group, mat-tab-group',
                template: "<md-tab-header [selectedIndex]=\"selectedIndex\" #tabHeader (indexFocused)=\"_focusChanged($event)\" (selectFocusedIndex)=\"selectedIndex = $event\"> <div class=\"mat-tab-label\" role=\"tab\" md-tab-label-wrapper md-ripple *ngFor=\"let tab of _tabs; let i = index\" [id]=\"_getTabLabelId(i)\" [tabIndex]=\"selectedIndex == i ? 0 : -1\" [attr.aria-controls]=\"_getTabContentId(i)\" [attr.aria-selected]=\"selectedIndex == i\" [class.mat-tab-label-active]=\"selectedIndex == i\" [disabled]=\"tab.disabled\" (click)=\"tabHeader.focusIndex = selectedIndex = i\"> <!-- If there is a label template, use it. --> <ng-template [ngIf]=\"tab.templateLabel\"> <ng-template [cdkPortalHost]=\"tab.templateLabel\"></ng-template> </ng-template> <!-- If there is not a label template, fall back to the text label. --> <ng-template [ngIf]=\"!tab.templateLabel\">{{tab.textLabel}}</ng-template> </div> </md-tab-header> <div class=\"mat-tab-body-wrapper\" #tabBodyWrapper> <md-tab-body role=\"tabpanel\" *ngFor=\"let tab of _tabs; let i = index\" [id]=\"_getTabContentId(i)\" [attr.aria-labelledby]=\"_getTabLabelId(i)\" [class.mat-tab-body-active]=\"selectedIndex == i\" [content]=\"tab.content\" [position]=\"tab.position\" [origin]=\"tab.origin\" (onCentered)=\"_removeTabBodyWrapperHeight()\" (onCentering)=\"_setTabBodyWrapperHeight($event)\"> </md-tab-body> </div> ",
                styles: [":host{display:flex;flex-direction:column;font-family:Roboto,\"Helvetica Neue\",sans-serif}:host.mat-tab-group-inverted-header{flex-direction:column-reverse}.mat-tab-label{line-height:48px;height:48px;padding:0 12px;font-size:14px;font-family:Roboto,\"Helvetica Neue\",sans-serif;font-weight:500;cursor:pointer;box-sizing:border-box;opacity:.6;min-width:160px;text-align:center;position:relative}.mat-tab-label:focus{outline:0;opacity:1}@media (max-width:600px){.mat-tab-label{min-width:72px}}:host[mat-stretch-tabs] .mat-tab-label,:host[md-stretch-tabs] .mat-tab-label{flex-basis:0;flex-grow:1}.mat-tab-body-wrapper{position:relative;overflow:hidden;display:flex;transition:height .5s cubic-bezier(.35,0,.25,1)}.mat-tab-body{position:absolute;top:0;left:0;right:0;bottom:0;display:block;overflow:hidden}.mat-tab-body.mat-tab-body-active{position:relative;overflow-x:hidden;overflow-y:auto;z-index:1;flex-grow:1}:host.mat-tab-group-dynamic-height .mat-tab-body.mat-tab-body-active{overflow-y:hidden}.mat-tab-disabled{cursor:default;pointer-events:none} /*# sourceMappingURL=tab-group.css.map */ "],
                host: {
                    '[class.mat-tab-group]': 'true',
                    '[class.mat-tab-group-dynamic-height]': 'dynamicHeight',
                    '[class.mat-tab-group-inverted-header]': 'headerPosition === "below"',
                }
            },] },
];
/**
 * @nocollapse
 */
MdTabGroup.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
]; };
MdTabGroup.propDecorators = {
    '_tabs': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ContentChildren"], args: [MdTab,] },],
    '_tabBodyWrapper': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewChild"], args: ['tabBodyWrapper',] },],
    'dynamicHeight': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    '_dynamicHeightDeprecated': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['md-dynamic-height',] },],
    'selectedIndex': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'headerPosition': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'selectedIndexChange': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
    'focusChange': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
    'selectChange': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
};
/**
 * Used in the `md-tab-group` view to display tab labels.
 * \@docs-private
 */
var MdTabLabelWrapper = (function () {
    /**
     * @param {?} elementRef
     * @param {?} _renderer
     */
    function MdTabLabelWrapper(elementRef, _renderer) {
        this.elementRef = elementRef;
        this._renderer = _renderer;
        this._disabled = false;
    }
    Object.defineProperty(MdTabLabelWrapper.prototype, "disabled", {
        /**
         * Whether the element is disabled.
         * @return {?}
         */
        get: function () { return this._disabled; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this._disabled = coerceBooleanProperty(value); },
        enumerable: true,
        configurable: true
    });
    /**
     * Sets focus on the wrapper element
     * @return {?}
     */
    MdTabLabelWrapper.prototype.focus = function () {
        this._renderer.invokeElementMethod(this.elementRef.nativeElement, 'focus');
    };
    /**
     * @return {?}
     */
    MdTabLabelWrapper.prototype.getOffsetLeft = function () {
        return this.elementRef.nativeElement.offsetLeft;
    };
    /**
     * @return {?}
     */
    MdTabLabelWrapper.prototype.getOffsetWidth = function () {
        return this.elementRef.nativeElement.offsetWidth;
    };
    return MdTabLabelWrapper;
}());
MdTabLabelWrapper.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                selector: '[md-tab-label-wrapper], [mat-tab-label-wrapper]',
                host: {
                    '[class.mat-tab-disabled]': 'disabled'
                }
            },] },
];
/**
 * @nocollapse
 */
MdTabLabelWrapper.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
]; };
MdTabLabelWrapper.propDecorators = {
    'disabled': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
};
/**
 * The ink-bar is used to display and animate the line underneath the current active tab label.
 * \@docs-private
 */
var MdInkBar = (function () {
    /**
     * @param {?} _renderer
     * @param {?} _elementRef
     * @param {?} _ngZone
     */
    function MdInkBar(_renderer, _elementRef, _ngZone) {
        this._renderer = _renderer;
        this._elementRef = _elementRef;
        this._ngZone = _ngZone;
    }
    /**
     * Calculates the styles from the provided element in order to align the ink-bar to that element.
     * Shows the ink bar if previously set as hidden.
     * @param {?} element
     * @return {?}
     */
    MdInkBar.prototype.alignToElement = function (element) {
        var _this = this;
        this.show();
        this._ngZone.runOutsideAngular(function () {
            requestAnimationFrame(function () {
                _this._renderer.setElementStyle(_this._elementRef.nativeElement, 'left', _this._getLeftPosition(element));
                _this._renderer.setElementStyle(_this._elementRef.nativeElement, 'width', _this._getElementWidth(element));
            });
        });
    };
    /**
     * Shows the ink bar.
     * @return {?}
     */
    MdInkBar.prototype.show = function () {
        this._renderer.setElementStyle(this._elementRef.nativeElement, 'visibility', 'visible');
    };
    /**
     * Hides the ink bar.
     * @return {?}
     */
    MdInkBar.prototype.hide = function () {
        this._renderer.setElementStyle(this._elementRef.nativeElement, 'visibility', 'hidden');
    };
    /**
     * Generates the pixel distance from the left based on the provided element in string format.
     * @param {?} element
     * @return {?}
     */
    MdInkBar.prototype._getLeftPosition = function (element) {
        return element ? element.offsetLeft + 'px' : '0';
    };
    /**
     * Generates the pixel width from the provided element in string format.
     * @param {?} element
     * @return {?}
     */
    MdInkBar.prototype._getElementWidth = function (element) {
        return element ? element.offsetWidth + 'px' : '0';
    };
    return MdInkBar;
}());
MdInkBar.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                selector: 'md-ink-bar, mat-ink-bar',
                host: {
                    '[class.mat-ink-bar]': 'true',
                },
            },] },
];
/**
 * @nocollapse
 */
MdInkBar.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgZone"], },
]; };
/**
 * Navigation component matching the styles of the tab group header.
 * Provides anchored navigation with animated ink bar.
 */
var MdTabNavBar = (function () {
    /**
     * @param {?} _dir
     */
    function MdTabNavBar(_dir) {
        var _this = this;
        this._dir = _dir;
        if (_dir) {
            this._directionChange = _dir.dirChange.subscribe(function () { return _this._alignInkBar(); });
        }
    }
    /**
     * Notifies the component that the active link has been changed.
     * @param {?} element
     * @return {?}
     */
    MdTabNavBar.prototype.updateActiveLink = function (element) {
        this._activeLinkChanged = this._activeLinkElement != element;
        this._activeLinkElement = element;
    };
    /**
     * Checks if the active link has been changed and, if so, will update the ink bar.
     * @return {?}
     */
    MdTabNavBar.prototype.ngAfterContentChecked = function () {
        if (this._activeLinkChanged) {
            this._alignInkBar();
            this._activeLinkChanged = false;
        }
    };
    /**
     * @return {?}
     */
    MdTabNavBar.prototype.ngOnDestroy = function () {
        if (this._directionChange) {
            this._directionChange.unsubscribe();
            this._directionChange = null;
        }
    };
    /**
     * Aligns the ink bar to the active link.
     * @return {?}
     */
    MdTabNavBar.prototype._alignInkBar = function () {
        this._inkBar.alignToElement(this._activeLinkElement.nativeElement);
    };
    return MdTabNavBar;
}());
MdTabNavBar.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{ selector: '[md-tab-nav-bar], [mat-tab-nav-bar]',
                template: "<div class=\"mat-tab-links\"> <ng-content></ng-content> <md-ink-bar></md-ink-bar> </div> ",
                styles: [".mat-tab-nav-bar{overflow:hidden;position:relative;flex-shrink:0}.mat-tab-links{position:relative}.mat-tab-link{line-height:48px;height:48px;padding:0 12px;font-size:14px;font-family:Roboto,\"Helvetica Neue\",sans-serif;font-weight:500;cursor:pointer;box-sizing:border-box;opacity:.6;min-width:160px;text-align:center;display:inline-block;vertical-align:top;text-decoration:none;position:relative;overflow:hidden}.mat-tab-link:focus{outline:0;opacity:1}@media (max-width:600px){.mat-tab-link{min-width:72px}}.mat-ink-bar{position:absolute;bottom:0;height:2px;transition:.5s cubic-bezier(.35,0,.25,1)}.mat-tab-group-inverted-header .mat-ink-bar{bottom:auto;top:0} /*# sourceMappingURL=tab-nav-bar.css.map */ "],
                host: {
                    '[class.mat-tab-nav-bar]': 'true',
                },
                encapsulation: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewEncapsulation"].None,
            },] },
];
/**
 * @nocollapse
 */
MdTabNavBar.ctorParameters = function () { return [
    { type: Dir, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] },] },
]; };
MdTabNavBar.propDecorators = {
    '_inkBar': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewChild"], args: [MdInkBar,] },],
};
/**
 * Link inside of a `md-tab-nav-bar`.
 */
var MdTabLink = (function () {
    /**
     * @param {?} _mdTabNavBar
     * @param {?} _elementRef
     */
    function MdTabLink(_mdTabNavBar, _elementRef) {
        this._mdTabNavBar = _mdTabNavBar;
        this._elementRef = _elementRef;
        this._isActive = false;
    }
    Object.defineProperty(MdTabLink.prototype, "active", {
        /**
         * Whether the link is active.
         * @return {?}
         */
        get: function () { return this._isActive; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._isActive = value;
            if (value) {
                this._mdTabNavBar.updateActiveLink(this._elementRef);
            }
        },
        enumerable: true,
        configurable: true
    });
    return MdTabLink;
}());
MdTabLink.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                selector: '[md-tab-link], [mat-tab-link]',
                host: {
                    '[class.mat-tab-link]': 'true',
                }
            },] },
];
/**
 * @nocollapse
 */
MdTabLink.ctorParameters = function () { return [
    { type: MdTabNavBar, },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
]; };
MdTabLink.propDecorators = {
    'active': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
};
/**
 * Simple directive that extends the ripple and matches the selector of the MdTabLink. This
 * adds the ripple behavior to nav bar labels.
 */
var MdTabLinkRipple = (function (_super) {
    __extends(MdTabLinkRipple, _super);
    /**
     * @param {?} elementRef
     * @param {?} ngZone
     * @param {?} ruler
     * @param {?} globalOptions
     */
    function MdTabLinkRipple(elementRef, ngZone, ruler, globalOptions) {
        return _super.call(this, elementRef, ngZone, ruler, globalOptions) || this;
    }
    return MdTabLinkRipple;
}(MdRipple));
MdTabLinkRipple.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                selector: '[md-tab-link], [mat-tab-link]',
                host: {
                    '[class.mat-tab-link]': 'true',
                },
            },] },
];
/**
 * @nocollapse
 */
MdTabLinkRipple.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgZone"], },
    { type: ViewportRuler, },
    { type: undefined, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Inject"], args: [MD_RIPPLE_GLOBAL_OPTIONS,] },] },
]; };
/**
 * Wrapper for the contents of a tab.
 * \@docs-private
 */
var MdTabBody = (function () {
    /**
     * @param {?} _dir
     * @param {?} _elementRef
     * @param {?} _changeDetectorRef
     */
    function MdTabBody(_dir, _elementRef, _changeDetectorRef) {
        this._dir = _dir;
        this._elementRef = _elementRef;
        this._changeDetectorRef = _changeDetectorRef;
        /** Event emitted when the tab begins to animate towards the center as the active tab. */
        this.onCentering = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /** Event emitted when the tab completes its animation towards the center. */
        this.onCentered = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"](true);
        /** Whether the element is allowed to be animated. */
        this._canBeAnimated = false;
    }
    Object.defineProperty(MdTabBody.prototype, "position", {
        /**
         * @param {?} position
         * @return {?}
         */
        set: function (position) {
            if (position < 0) {
                this._position = this._getLayoutDirection() == 'ltr' ? 'left' : 'right';
            }
            else if (position > 0) {
                this._position = this._getLayoutDirection() == 'ltr' ? 'right' : 'left';
            }
            else {
                this._position = 'center';
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdTabBody.prototype, "origin", {
        /**
         * The origin position from which this tab should appear when it is centered into view.
         * @param {?} origin
         * @return {?}
         */
        set: function (origin) {
            if (origin == null) {
                return;
            }
            var /** @type {?} */ dir = this._getLayoutDirection();
            if ((dir == 'ltr' && origin <= 0) || (dir == 'rtl' && origin > 0)) {
                this._origin = 'left';
            }
            else {
                this._origin = 'right';
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * After initialized, check if the content is centered and has an origin. If so, set the
     * special position states that transition the tab from the left or right before centering.
     * @return {?}
     */
    MdTabBody.prototype.ngOnInit = function () {
        if (this._position == 'center' && this._origin) {
            this._position = this._origin == 'left' ? 'left-origin-center' : 'right-origin-center';
        }
    };
    /**
     * After the view has been set, check if the tab content is set to the center and attach the
     * content if it is not already attached.
     * @return {?}
     */
    MdTabBody.prototype.ngAfterViewChecked = function () {
        if (this._isCenterPosition(this._position) && !this._portalHost.hasAttached()) {
            this._portalHost.attach(this._content);
        }
    };
    /**
     * After the content has been checked, determines whether the element should be allowed to
     * animate. This has to be limited, because under a specific set of circumstances (see #2151),
     * the animations can be triggered too early, which either crashes Chrome by putting it into an
     * infinite loop (with Angular < 2.3.0) or throws an error because the element doesn't have a
     * computed style (with Angular > 2.3.0). This can alternatively be determined by checking the
     * transform: canBeAnimated = getComputedStyle(element) !== '', however document.contains should
     * be faster since it doesn't cause a reflow.
     *
     * TODO: This can safely be removed after we stop supporting Angular < 2.4.2. The fix landed via
     * https://github.com/angular/angular/commit/21030e9a1cf30e8101399d8535ed72d847a23ba6
     * @return {?}
     */
    MdTabBody.prototype.ngAfterContentChecked = function () {
        if (!this._canBeAnimated) {
            this._canBeAnimated = document.body.contains(this._elementRef.nativeElement);
            if (this._canBeAnimated) {
                this._changeDetectorRef.markForCheck();
            }
        }
    };
    /**
     * @param {?} e
     * @return {?}
     */
    MdTabBody.prototype._onTranslateTabStarted = function (e) {
        if (this._isCenterPosition(e.toState)) {
            this.onCentering.emit(this._elementRef.nativeElement.clientHeight);
        }
    };
    /**
     * @param {?} e
     * @return {?}
     */
    MdTabBody.prototype._onTranslateTabComplete = function (e) {
        // If the end state is that the tab is not centered, then detach the content.
        if (!this._isCenterPosition(e.toState) && !this._isCenterPosition(this._position)) {
            this._portalHost.detach();
        }
        // If the transition to the center is complete, emit an event.
        if (this._isCenterPosition(e.toState) && this._isCenterPosition(this._position)) {
            this.onCentered.emit();
        }
    };
    /**
     * The text direction of the containing app.
     * @return {?}
     */
    MdTabBody.prototype._getLayoutDirection = function () {
        return this._dir && this._dir.value === 'rtl' ? 'rtl' : 'ltr';
    };
    /**
     * Whether the provided position state is considered center, regardless of origin.
     * @param {?} position
     * @return {?}
     */
    MdTabBody.prototype._isCenterPosition = function (position) {
        return position == 'center' ||
            position == 'left-origin-center' ||
            position == 'right-origin-center';
    };
    return MdTabBody;
}());
MdTabBody.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{ selector: 'md-tab-body, mat-tab-body',
                template: "<div class=\"mat-tab-body-content\" #content [@translateTab]=\"_canBeAnimated ? _position : null\" (@translateTab.start)=\"_onTranslateTabStarted($event)\" (@translateTab.done)=\"_onTranslateTabComplete($event)\"> <ng-template cdkPortalHost></ng-template> </div> ",
                styles: [".mat-tab-body-content{height:100%} /*# sourceMappingURL=tab-body.css.map */ "],
                host: {
                    '[class.mat-tab-body]': 'true',
                },
                animations: [
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__angular_animations__["f" /* trigger */])('translateTab', [
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__angular_animations__["g" /* state */])('left', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__angular_animations__["c" /* style */])({ transform: 'translate3d(-100%, 0, 0)' })),
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__angular_animations__["g" /* state */])('left-origin-center', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__angular_animations__["c" /* style */])({ transform: 'translate3d(0, 0, 0)' })),
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__angular_animations__["g" /* state */])('right-origin-center', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__angular_animations__["c" /* style */])({ transform: 'translate3d(0, 0, 0)' })),
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__angular_animations__["g" /* state */])('center', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__angular_animations__["c" /* style */])({ transform: 'translate3d(0, 0, 0)' })),
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__angular_animations__["g" /* state */])('right', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__angular_animations__["c" /* style */])({ transform: 'translate3d(100%, 0, 0)' })),
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__angular_animations__["h" /* transition */])('* => left, * => right, left => center, right => center', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__angular_animations__["i" /* animate */])('500ms cubic-bezier(0.35, 0, 0.25, 1)')),
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__angular_animations__["h" /* transition */])('void => left-origin-center', [
                            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__angular_animations__["c" /* style */])({ transform: 'translate3d(-100%, 0, 0)' }),
                            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__angular_animations__["i" /* animate */])('500ms cubic-bezier(0.35, 0, 0.25, 1)')
                        ]),
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__angular_animations__["h" /* transition */])('void => right-origin-center', [
                            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__angular_animations__["c" /* style */])({ transform: 'translate3d(100%, 0, 0)' }),
                            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__angular_animations__["i" /* animate */])('500ms cubic-bezier(0.35, 0, 0.25, 1)')
                        ])
                    ])
                ]
            },] },
];
/**
 * @nocollapse
 */
MdTabBody.ctorParameters = function () { return [
    { type: Dir, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] },] },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectorRef"], },
]; };
MdTabBody.propDecorators = {
    '_portalHost': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewChild"], args: [PortalHostDirective,] },],
    'onCentering': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
    'onCentered': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
    '_content': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['content',] },],
    'position': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['position',] },],
    'origin': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['origin',] },],
};
/**
 * The distance in pixels that will be overshot when scrolling a tab label into view. This helps
 * provide a small affordance to the label next to it.
 */
var EXAGGERATED_OVERSCROLL = 60;
/**
 * The header of the tab group which displays a list of all the tabs in the tab group. Includes
 * an ink bar that follows the currently selected tab. When the tabs list's width exceeds the
 * width of the header container, then arrows will be displayed to allow the user to scroll
 * left and right across the header.
 * \@docs-private
 */
var MdTabHeader = (function () {
    /**
     * @param {?} _elementRef
     * @param {?} _dir
     */
    function MdTabHeader(_elementRef, _dir) {
        this._elementRef = _elementRef;
        this._dir = _dir;
        this._focusIndex = 0;
        this._scrollDistance = 0;
        this._selectedIndexChanged = false;
        /** Whether the controls for pagination should be displayed */
        this._showPaginationControls = false;
        /** Whether the tab list can be scrolled more towards the end of the tab label list. */
        this._disableScrollAfter = true;
        /** Whether the tab list can be scrolled more towards the beginning of the tab label list. */
        this._disableScrollBefore = true;
        this._selectedIndex = 0;
        /** Event emitted when the option is selected. */
        this.selectFocusedIndex = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /** Event emitted when a label is focused. */
        this.indexFocused = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
    }
    Object.defineProperty(MdTabHeader.prototype, "selectedIndex", {
        /**
         * @return {?}
         */
        get: function () { return this._selectedIndex; },
        /**
         * The index of the active tab.
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._selectedIndexChanged = this._selectedIndex != value;
            this._selectedIndex = value;
            this._focusIndex = value;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    MdTabHeader.prototype.ngAfterContentChecked = function () {
        // If the number of tab labels have changed, check if scrolling should be enabled
        if (this._tabLabelCount != this._labelWrappers.length) {
            this._updatePagination();
            this._tabLabelCount = this._labelWrappers.length;
        }
        // If the selected index has changed, scroll to the label and check if the scrolling controls
        // should be disabled.
        if (this._selectedIndexChanged) {
            this._scrollToLabel(this._selectedIndex);
            this._checkScrollingControls();
            this._alignInkBarToSelectedTab();
            this._selectedIndexChanged = false;
        }
        // If the scroll distance has been changed (tab selected, focused, scroll controls activated),
        // then translate the header to reflect this.
        if (this._scrollDistanceChanged) {
            this._updateTabScrollPosition();
            this._scrollDistanceChanged = false;
        }
    };
    /**
     * @param {?} event
     * @return {?}
     */
    MdTabHeader.prototype._handleKeydown = function (event) {
        switch (event.keyCode) {
            case RIGHT_ARROW:
                this._focusNextTab();
                break;
            case LEFT_ARROW:
                this._focusPreviousTab();
                break;
            case ENTER:
                this.selectFocusedIndex.emit(this.focusIndex);
                break;
        }
    };
    /**
     * Aligns the ink bar to the selected tab on load.
     * @return {?}
     */
    MdTabHeader.prototype.ngAfterContentInit = function () {
        var _this = this;
        this._alignInkBarToSelectedTab();
        if (this._dir) {
            this._directionChange = this._dir.dirChange.subscribe(function () { return _this._alignInkBarToSelectedTab(); });
        }
    };
    /**
     * @return {?}
     */
    MdTabHeader.prototype.ngOnDestroy = function () {
        if (this._directionChange) {
            this._directionChange.unsubscribe();
            this._directionChange = null;
        }
    };
    /**
     * Callback for when the MutationObserver detects that the content has changed.
     * @return {?}
     */
    MdTabHeader.prototype._onContentChanges = function () {
        this._updatePagination();
        this._alignInkBarToSelectedTab();
    };
    /**
     * Updating the view whether pagination should be enabled or not
     * @return {?}
     */
    MdTabHeader.prototype._updatePagination = function () {
        this._checkPaginationEnabled();
        this._checkScrollingControls();
        this._updateTabScrollPosition();
    };
    Object.defineProperty(MdTabHeader.prototype, "focusIndex", {
        /**
         * Tracks which element has focus; used for keyboard navigation
         * @return {?}
         */
        get: function () { return this._focusIndex; },
        /**
         * When the focus index is set, we must manually send focus to the correct label
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            if (!this._isValidIndex(value) || this._focusIndex == value) {
                return;
            }
            this._focusIndex = value;
            this.indexFocused.emit(value);
            this._setTabFocus(value);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Determines if an index is valid.  If the tabs are not ready yet, we assume that the user is
     * providing a valid index and return true.
     * @param {?} index
     * @return {?}
     */
    MdTabHeader.prototype._isValidIndex = function (index) {
        if (!this._labelWrappers) {
            return true;
        }
        var /** @type {?} */ tab = this._labelWrappers ? this._labelWrappers.toArray()[index] : null;
        return tab && !tab.disabled;
    };
    /**
     * Sets focus on the HTML element for the label wrapper and scrolls it into the view if
     * scrolling is enabled.
     * @param {?} tabIndex
     * @return {?}
     */
    MdTabHeader.prototype._setTabFocus = function (tabIndex) {
        if (this._showPaginationControls) {
            this._scrollToLabel(tabIndex);
        }
        if (this._labelWrappers && this._labelWrappers.length) {
            this._labelWrappers.toArray()[tabIndex].focus();
            // Do not let the browser manage scrolling to focus the element, this will be handled
            // by using translation. In LTR, the scroll left should be 0. In RTL, the scroll width
            // should be the full width minus the offset width.
            var /** @type {?} */ containerEl = this._tabListContainer.nativeElement;
            var /** @type {?} */ dir = this._getLayoutDirection();
            if (dir == 'ltr') {
                containerEl.scrollLeft = 0;
            }
            else {
                containerEl.scrollLeft = containerEl.scrollWidth - containerEl.offsetWidth;
            }
        }
    };
    /**
     * Moves the focus towards the beginning or the end of the list depending on the offset provided.
     * Valid offsets are 1 and -1.
     * @param {?} offset
     * @return {?}
     */
    MdTabHeader.prototype._moveFocus = function (offset) {
        if (this._labelWrappers) {
            var /** @type {?} */ tabs = this._labelWrappers.toArray();
            for (var /** @type {?} */ i = this.focusIndex + offset; i < tabs.length && i >= 0; i += offset) {
                if (this._isValidIndex(i)) {
                    this.focusIndex = i;
                    return;
                }
            }
        }
    };
    /**
     * Increment the focus index by 1 until a valid tab is found.
     * @return {?}
     */
    MdTabHeader.prototype._focusNextTab = function () {
        this._moveFocus(this._getLayoutDirection() == 'ltr' ? 1 : -1);
    };
    /**
     * Decrement the focus index by 1 until a valid tab is found.
     * @return {?}
     */
    MdTabHeader.prototype._focusPreviousTab = function () {
        this._moveFocus(this._getLayoutDirection() == 'ltr' ? -1 : 1);
    };
    /**
     * The layout direction of the containing app.
     * @return {?}
     */
    MdTabHeader.prototype._getLayoutDirection = function () {
        return this._dir && this._dir.value === 'rtl' ? 'rtl' : 'ltr';
    };
    /**
     * Performs the CSS transformation on the tab list that will cause the list to scroll.
     * @return {?}
     */
    MdTabHeader.prototype._updateTabScrollPosition = function () {
        var /** @type {?} */ translateX = this.scrollDistance + 'px';
        if (this._getLayoutDirection() == 'ltr') {
            translateX = '-' + translateX;
        }
        applyCssTransform(this._tabList.nativeElement, "translate3d(" + translateX + ", 0, 0)");
    };
    Object.defineProperty(MdTabHeader.prototype, "scrollDistance", {
        /**
         * @return {?}
         */
        get: function () { return this._scrollDistance; },
        /**
         * Sets the distance in pixels that the tab header should be transformed in the X-axis.
         * @param {?} v
         * @return {?}
         */
        set: function (v) {
            this._scrollDistance = Math.max(0, Math.min(this._getMaxScrollDistance(), v));
            // Mark that the scroll distance has changed so that after the view is checked, the CSS
            // transformation can move the header.
            this._scrollDistanceChanged = true;
            this._checkScrollingControls();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Moves the tab list in the 'before' or 'after' direction (towards the beginning of the list or
     * the end of the list, respectively). The distance to scroll is computed to be a third of the
     * length of the tab list view window.
     *
     * This is an expensive call that forces a layout reflow to compute box and scroll metrics and
     * should be called sparingly.
     * @param {?} scrollDir
     * @return {?}
     */
    MdTabHeader.prototype._scrollHeader = function (scrollDir) {
        var /** @type {?} */ viewLength = this._tabListContainer.nativeElement.offsetWidth;
        // Move the scroll distance one-third the length of the tab list's viewport.
        this.scrollDistance += (scrollDir == 'before' ? -1 : 1) * viewLength / 3;
    };
    /**
     * Moves the tab list such that the desired tab label (marked by index) is moved into view.
     *
     * This is an expensive call that forces a layout reflow to compute box and scroll metrics and
     * should be called sparingly.
     * @param {?} labelIndex
     * @return {?}
     */
    MdTabHeader.prototype._scrollToLabel = function (labelIndex) {
        var /** @type {?} */ selectedLabel = this._labelWrappers
            ? this._labelWrappers.toArray()[labelIndex]
            : null;
        if (!selectedLabel) {
            return;
        }
        // The view length is the visible width of the tab labels.
        var /** @type {?} */ viewLength = this._tabListContainer.nativeElement.offsetWidth;
        var /** @type {?} */ labelBeforePos, /** @type {?} */ labelAfterPos;
        if (this._getLayoutDirection() == 'ltr') {
            labelBeforePos = selectedLabel.getOffsetLeft();
            labelAfterPos = labelBeforePos + selectedLabel.getOffsetWidth();
        }
        else {
            labelAfterPos = this._tabList.nativeElement.offsetWidth - selectedLabel.getOffsetLeft();
            labelBeforePos = labelAfterPos - selectedLabel.getOffsetWidth();
        }
        var /** @type {?} */ beforeVisiblePos = this.scrollDistance;
        var /** @type {?} */ afterVisiblePos = this.scrollDistance + viewLength;
        if (labelBeforePos < beforeVisiblePos) {
            // Scroll header to move label to the before direction
            this.scrollDistance -= beforeVisiblePos - labelBeforePos + EXAGGERATED_OVERSCROLL;
        }
        else if (labelAfterPos > afterVisiblePos) {
            // Scroll header to move label to the after direction
            this.scrollDistance += labelAfterPos - afterVisiblePos + EXAGGERATED_OVERSCROLL;
        }
    };
    /**
     * Evaluate whether the pagination controls should be displayed. If the scroll width of the
     * tab list is wider than the size of the header container, then the pagination controls should
     * be shown.
     *
     * This is an expensive call that forces a layout reflow to compute box and scroll metrics and
     * should be called sparingly.
     * @return {?}
     */
    MdTabHeader.prototype._checkPaginationEnabled = function () {
        this._showPaginationControls =
            this._tabList.nativeElement.scrollWidth > this._elementRef.nativeElement.offsetWidth;
        if (!this._showPaginationControls) {
            this.scrollDistance = 0;
        }
    };
    /**
     * Evaluate whether the before and after controls should be enabled or disabled.
     * If the header is at the beginning of the list (scroll distance is equal to 0) then disable the
     * before button. If the header is at the end of the list (scroll distance is equal to the
     * maximum distance we can scroll), then disable the after button.
     *
     * This is an expensive call that forces a layout reflow to compute box and scroll metrics and
     * should be called sparingly.
     * @return {?}
     */
    MdTabHeader.prototype._checkScrollingControls = function () {
        // Check if the pagination arrows should be activated.
        this._disableScrollBefore = this.scrollDistance == 0;
        this._disableScrollAfter = this.scrollDistance == this._getMaxScrollDistance();
    };
    /**
     * Determines what is the maximum length in pixels that can be set for the scroll distance. This
     * is equal to the difference in width between the tab list container and tab header container.
     *
     * This is an expensive call that forces a layout reflow to compute box and scroll metrics and
     * should be called sparingly.
     * @return {?}
     */
    MdTabHeader.prototype._getMaxScrollDistance = function () {
        var /** @type {?} */ lengthOfTabList = this._tabList.nativeElement.scrollWidth;
        var /** @type {?} */ viewLength = this._tabListContainer.nativeElement.offsetWidth;
        return lengthOfTabList - viewLength;
    };
    /**
     * Tells the ink-bar to align itself to the current label wrapper
     * @return {?}
     */
    MdTabHeader.prototype._alignInkBarToSelectedTab = function () {
        var /** @type {?} */ selectedLabelWrapper = this._labelWrappers && this._labelWrappers.length
            ? this._labelWrappers.toArray()[this.selectedIndex].elementRef.nativeElement
            : null;
        this._inkBar.alignToElement(selectedLabelWrapper);
    };
    return MdTabHeader;
}());
MdTabHeader.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{ selector: 'md-tab-header, mat-tab-header',
                template: "<div class=\"mat-tab-header-pagination mat-tab-header-pagination-before mat-elevation-z4\" aria-hidden=\"true\" md-ripple [mdRippleDisabled]=\"_disableScrollBefore\" [class.mat-tab-header-pagination-disabled]=\"_disableScrollBefore\" (click)=\"_scrollHeader('before')\"> <div class=\"mat-tab-header-pagination-chevron\"></div> </div> <div class=\"mat-tab-label-container\" #tabListContainer (keydown)=\"_handleKeydown($event)\"> <div class=\"mat-tab-list\" #tabList role=\"tablist\" (cdkObserveContent)=\"_onContentChanges()\"> <div class=\"mat-tab-labels\"> <ng-content></ng-content> </div> <md-ink-bar></md-ink-bar> </div> </div> <div class=\"mat-tab-header-pagination mat-tab-header-pagination-after mat-elevation-z4\" aria-hidden=\"true\" md-ripple [mdRippleDisabled]=\"_disableScrollAfter\" [class.mat-tab-header-pagination-disabled]=\"_disableScrollAfter\" (click)=\"_scrollHeader('after')\"> <div class=\"mat-tab-header-pagination-chevron\"></div> </div> ",
                styles: [".mat-tab-header{display:flex;overflow:hidden;position:relative;flex-shrink:0}.mat-tab-label{line-height:48px;height:48px;padding:0 12px;font-size:14px;font-family:Roboto,\"Helvetica Neue\",sans-serif;font-weight:500;cursor:pointer;box-sizing:border-box;opacity:.6;min-width:160px;text-align:center;position:relative}.mat-tab-label:focus{outline:0;opacity:1}@media (max-width:600px){.mat-tab-label{min-width:72px}}.mat-ink-bar{position:absolute;bottom:0;height:2px;transition:.5s cubic-bezier(.35,0,.25,1)}.mat-tab-group-inverted-header .mat-ink-bar{bottom:auto;top:0}.mat-tab-header-pagination{position:relative;display:none;justify-content:center;align-items:center;min-width:32px;cursor:pointer;z-index:2}.mat-tab-header-pagination-controls-enabled .mat-tab-header-pagination{display:flex}.mat-tab-header-pagination-before,.mat-tab-header-rtl .mat-tab-header-pagination-after{padding-left:4px}.mat-tab-header-pagination-before .mat-tab-header-pagination-chevron,.mat-tab-header-rtl .mat-tab-header-pagination-after .mat-tab-header-pagination-chevron{transform:rotate(-135deg)}.mat-tab-header-pagination-after,.mat-tab-header-rtl .mat-tab-header-pagination-before{padding-right:4px}.mat-tab-header-pagination-after .mat-tab-header-pagination-chevron,.mat-tab-header-rtl .mat-tab-header-pagination-before .mat-tab-header-pagination-chevron{transform:rotate(45deg)}.mat-tab-header-pagination-chevron{border-style:solid;border-width:2px 2px 0 0;content:'';height:8px;width:8px}.mat-tab-header-pagination-disabled{box-shadow:none;cursor:default}.mat-tab-header-pagination-disabled .mat-tab-header-pagination-chevron{border-color:#ccc}.mat-tab-label-container{display:flex;flex-grow:1;overflow:hidden;z-index:1}.mat-tab-list{flex-grow:1;position:relative;transition:transform .5s cubic-bezier(.35,0,.25,1)}.mat-tab-labels{display:flex} /*# sourceMappingURL=tab-header.css.map */ "],
                encapsulation: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewEncapsulation"].None,
                host: {
                    'class': 'mat-tab-header',
                    '[class.mat-tab-header-pagination-controls-enabled]': '_showPaginationControls',
                    '[class.mat-tab-header-rtl]': "_getLayoutDirection() == 'rtl'",
                }
            },] },
];
/**
 * @nocollapse
 */
MdTabHeader.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
    { type: Dir, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] },] },
]; };
MdTabHeader.propDecorators = {
    '_labelWrappers': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ContentChildren"], args: [MdTabLabelWrapper,] },],
    '_inkBar': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewChild"], args: [MdInkBar,] },],
    '_tabListContainer': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewChild"], args: ['tabListContainer',] },],
    '_tabList': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewChild"], args: ['tabList',] },],
    'selectedIndex': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'selectFocusedIndex': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
    'indexFocused': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
};
var MdTabsModule = (function () {
    function MdTabsModule() {
    }
    /**
     * @deprecated
     * @return {?}
     */
    MdTabsModule.forRoot = function () {
        return {
            ngModule: MdTabsModule,
            providers: []
        };
    };
    return MdTabsModule;
}());
MdTabsModule.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{
                imports: [
                    __WEBPACK_IMPORTED_MODULE_2__angular_common__["CommonModule"],
                    PortalModule,
                    MdRippleModule,
                    ObserveContentModule,
                ],
                // Don't export all components because some are only to be used internally.
                exports: [
                    MdTabGroup,
                    MdTabLabel,
                    MdTab,
                    MdTabNavBar,
                    MdTabLink,
                    MdTabLinkRipple
                ],
                declarations: [
                    MdTabGroup,
                    MdTabLabel,
                    MdTab,
                    MdInkBar,
                    MdTabLabelWrapper,
                    MdTabNavBar,
                    MdTabLink,
                    MdTabBody,
                    MdTabLinkRipple,
                    MdTabHeader
                ],
                providers: [VIEWPORT_RULER_PROVIDER, SCROLL_DISPATCHER_PROVIDER],
            },] },
];
/**
 * @nocollapse
 */
MdTabsModule.ctorParameters = function () { return []; };
var MdToolbarRow = (function () {
    function MdToolbarRow() {
    }
    return MdToolbarRow;
}());
MdToolbarRow.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                selector: 'md-toolbar-row, mat-toolbar-row',
                host: {
                    '[class.mat-toolbar-row]': 'true',
                },
            },] },
];
/**
 * @nocollapse
 */
MdToolbarRow.ctorParameters = function () { return []; };
var MdToolbar = (function () {
    /**
     * @param {?} elementRef
     * @param {?} renderer
     */
    function MdToolbar(elementRef, renderer) {
        this.elementRef = elementRef;
        this.renderer = renderer;
    }
    Object.defineProperty(MdToolbar.prototype, "color", {
        /**
         * The color of the toolbar. Can be primary, accent, or warn.
         * @return {?}
         */
        get: function () {
            return this._color;
        },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._updateColor(value);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} newColor
     * @return {?}
     */
    MdToolbar.prototype._updateColor = function (newColor) {
        this._setElementColor(this._color, false);
        this._setElementColor(newColor, true);
        this._color = newColor;
    };
    /**
     * @param {?} color
     * @param {?} isAdd
     * @return {?}
     */
    MdToolbar.prototype._setElementColor = function (color, isAdd) {
        if (color != null && color != '') {
            this.renderer.setElementClass(this.elementRef.nativeElement, "mat-" + color, isAdd);
        }
    };
    return MdToolbar;
}());
MdToolbar.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{ selector: 'md-toolbar, mat-toolbar',
                template: "<div class=\"mat-toolbar-layout\"> <md-toolbar-row> <ng-content></ng-content> </md-toolbar-row> <ng-content select=\"md-toolbar-row, mat-toolbar-row\"></ng-content> </div> ",
                styles: [".mat-toolbar{display:flex;box-sizing:border-box;width:100%;font-size:20px;font-weight:500;font-family:Roboto,\"Helvetica Neue\",sans-serif;padding:0 16px;flex-direction:column}.mat-toolbar .mat-toolbar-row{display:flex;box-sizing:border-box;width:100%;flex-direction:row;align-items:center;white-space:nowrap}.mat-toolbar{min-height:64px}.mat-toolbar-row{height:64px}@media (max-width:600px){.mat-toolbar{min-height:56px}.mat-toolbar-row{height:56px}} /*# sourceMappingURL=toolbar.css.map */ "],
                host: {
                    '[class.mat-toolbar]': 'true',
                    'role': 'toolbar'
                },
                changeDetection: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectionStrategy"].OnPush,
                encapsulation: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewEncapsulation"].None
            },] },
];
/**
 * @nocollapse
 */
MdToolbar.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
]; };
MdToolbar.propDecorators = {
    'color': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
};
var MdToolbarModule = (function () {
    function MdToolbarModule() {
    }
    /**
     * @deprecated
     * @return {?}
     */
    MdToolbarModule.forRoot = function () {
        return {
            ngModule: MdToolbarModule,
            providers: []
        };
    };
    return MdToolbarModule;
}());
MdToolbarModule.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{
                imports: [CompatibilityModule],
                exports: [MdToolbar, MdToolbarRow, CompatibilityModule],
                declarations: [MdToolbar, MdToolbarRow],
            },] },
];
/**
 * @nocollapse
 */
MdToolbarModule.ctorParameters = function () { return []; };
/**
 * Exception thrown when a tooltip has an invalid position.
 * \@docs-private
 */
var MdTooltipInvalidPositionError = (function (_super) {
    __extends(MdTooltipInvalidPositionError, _super);
    /**
     * @param {?} position
     */
    function MdTooltipInvalidPositionError(position) {
        return _super.call(this, "Tooltip position \"" + position + "\" is invalid.") || this;
    }
    return MdTooltipInvalidPositionError;
}(MdError));
/** Time in ms to delay before changing the tooltip visibility to hidden */
var TOUCHEND_HIDE_DELAY = 1500;
/** Time in ms to throttle repositioning after scroll events. */
var SCROLL_THROTTLE_MS = 20;
/**
 * Directive that attaches a material design tooltip to the host element. Animates the showing and
 * hiding of a tooltip provided position (defaults to below the element).
 *
 * https://material.google.com/components/tooltips.html
 */
var MdTooltip = (function () {
    /**
     * @param {?} _overlay
     * @param {?} _elementRef
     * @param {?} _scrollDispatcher
     * @param {?} _viewContainerRef
     * @param {?} _ngZone
     * @param {?} _renderer
     * @param {?} _platform
     * @param {?} _dir
     */
    function MdTooltip(_overlay, _elementRef, _scrollDispatcher, _viewContainerRef, _ngZone, _renderer, _platform, _dir) {
        var _this = this;
        this._overlay = _overlay;
        this._elementRef = _elementRef;
        this._scrollDispatcher = _scrollDispatcher;
        this._viewContainerRef = _viewContainerRef;
        this._ngZone = _ngZone;
        this._renderer = _renderer;
        this._platform = _platform;
        this._dir = _dir;
        this._position = 'below';
        this._disabled = false;
        /** The default delay in ms before showing the tooltip after show is called */
        this.showDelay = 0;
        /** The default delay in ms before hiding the tooltip after hide is called */
        this.hideDelay = 0;
        // The mouse events shouldn't be bound on iOS devices, because
        // they can prevent the first tap from firing it's click event.
        if (!_platform.IOS) {
            _renderer.listen(_elementRef.nativeElement, 'mouseenter', function () { return _this.show(); });
            _renderer.listen(_elementRef.nativeElement, 'mouseleave', function () { return _this.hide(); });
        }
    }
    Object.defineProperty(MdTooltip.prototype, "position", {
        /**
         * Allows the user to define the position of the tooltip relative to the parent element
         * @return {?}
         */
        get: function () { return this._position; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            if (value !== this._position) {
                this._position = value;
                // TODO(andrewjs): When the overlay's position can be dynamically changed, do not destroy
                // the tooltip.
                if (this._tooltipInstance) {
                    this._disposeTooltip();
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdTooltip.prototype, "disabled", {
        /**
         * Disables the display of the tooltip.
         * @return {?}
         */
        get: function () { return this._disabled; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._disabled = coerceBooleanProperty(value);
            // If tooltip is disabled, hide immediately.
            if (this._disabled) {
                this.hide(0);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdTooltip.prototype, "_positionDeprecated", {
        /**
         * @deprecated
         * @return {?}
         */
        get: function () { return this._position; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) { this._position = value; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdTooltip.prototype, "message", {
        /**
         * The message to be displayed in the tooltip
         * @return {?}
         */
        get: function () { return this._message; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._message = value;
            if (this._tooltipInstance) {
                this._setTooltipMessage(this._message);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdTooltip.prototype, "_deprecatedMessage", {
        /**
         * @deprecated
         * @return {?}
         */
        get: function () { return this.message; },
        /**
         * @param {?} v
         * @return {?}
         */
        set: function (v) { this.message = v; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdTooltip.prototype, "_matMessage", {
        /**
         * @return {?}
         */
        get: function () { return this.message; },
        /**
         * @param {?} v
         * @return {?}
         */
        set: function (v) { this.message = v; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdTooltip.prototype, "_matPosition", {
        /**
         * @return {?}
         */
        get: function () { return this.position; },
        /**
         * @param {?} v
         * @return {?}
         */
        set: function (v) { this.position = v; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdTooltip.prototype, "_matDisabled", {
        /**
         * @return {?}
         */
        get: function () { return this.disabled; },
        /**
         * @param {?} v
         * @return {?}
         */
        set: function (v) { this.disabled = v; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdTooltip.prototype, "_matHideDelay", {
        /**
         * @return {?}
         */
        get: function () { return this.hideDelay; },
        /**
         * @param {?} v
         * @return {?}
         */
        set: function (v) { this.hideDelay = v; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdTooltip.prototype, "_matShowDelay", {
        /**
         * @return {?}
         */
        get: function () { return this.showDelay; },
        /**
         * @param {?} v
         * @return {?}
         */
        set: function (v) { this.showDelay = v; },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    MdTooltip.prototype.ngOnInit = function () {
        var _this = this;
        // When a scroll on the page occurs, update the position in case this tooltip needs
        // to be repositioned.
        this.scrollSubscription = this._scrollDispatcher.scrolled(SCROLL_THROTTLE_MS, function () {
            if (_this._overlayRef) {
                _this._overlayRef.updatePosition();
            }
        });
    };
    /**
     * Dispose the tooltip when destroyed.
     * @return {?}
     */
    MdTooltip.prototype.ngOnDestroy = function () {
        if (this._tooltipInstance) {
            this._disposeTooltip();
        }
        if (this.scrollSubscription) {
            this.scrollSubscription.unsubscribe();
        }
    };
    /**
     * Shows the tooltip after the delay in ms, defaults to tooltip-delay-show or 0ms if no input
     * @param {?=} delay
     * @return {?}
     */
    MdTooltip.prototype.show = function (delay) {
        if (delay === void 0) { delay = this.showDelay; }
        if (this.disabled || !this._message || !this._message.trim()) {
            return;
        }
        if (!this._tooltipInstance) {
            this._createTooltip();
        }
        this._setTooltipMessage(this._message);
        this._tooltipInstance.show(this._position, delay);
    };
    /**
     * Hides the tooltip after the delay in ms, defaults to tooltip-delay-hide or 0ms if no input
     * @param {?=} delay
     * @return {?}
     */
    MdTooltip.prototype.hide = function (delay) {
        if (delay === void 0) { delay = this.hideDelay; }
        if (this._tooltipInstance) {
            this._tooltipInstance.hide(delay);
        }
    };
    /**
     * Shows/hides the tooltip
     * @return {?}
     */
    MdTooltip.prototype.toggle = function () {
        this._isTooltipVisible() ? this.hide() : this.show();
    };
    /**
     * Returns true if the tooltip is currently visible to the user
     * @return {?}
     */
    MdTooltip.prototype._isTooltipVisible = function () {
        return !!this._tooltipInstance && this._tooltipInstance.isVisible();
    };
    /**
     * Create the tooltip to display
     * @return {?}
     */
    MdTooltip.prototype._createTooltip = function () {
        var _this = this;
        this._createOverlay();
        var /** @type {?} */ portal = new ComponentPortal(TooltipComponent, this._viewContainerRef);
        this._tooltipInstance = this._overlayRef.attach(portal).instance;
        // Dispose the overlay when finished the shown tooltip.
        this._tooltipInstance.afterHidden().subscribe(function () {
            // Check first if the tooltip has already been removed through this components destroy.
            if (_this._tooltipInstance) {
                _this._disposeTooltip();
            }
        });
    };
    /**
     * Create the overlay config and position strategy
     * @return {?}
     */
    MdTooltip.prototype._createOverlay = function () {
        var _this = this;
        var /** @type {?} */ origin = this._getOrigin();
        var /** @type {?} */ position = this._getOverlayPosition();
        // Create connected position strategy that listens for scroll events to reposition.
        // After position changes occur and the overlay is clipped by a parent scrollable then
        // close the tooltip.
        var /** @type {?} */ strategy = this._overlay.position().connectedTo(this._elementRef, origin, position);
        strategy.withScrollableContainers(this._scrollDispatcher.getScrollContainers(this._elementRef));
        strategy.onPositionChange.subscribe(function (change) {
            if (change.scrollableViewProperties.isOverlayClipped &&
                _this._tooltipInstance && _this._tooltipInstance.isVisible()) {
                _this.hide(0);
            }
        });
        var /** @type {?} */ config = new OverlayState();
        config.positionStrategy = strategy;
        this._overlayRef = this._overlay.create(config);
    };
    /**
     * Disposes the current tooltip and the overlay it is attached to
     * @return {?}
     */
    MdTooltip.prototype._disposeTooltip = function () {
        this._overlayRef.dispose();
        this._overlayRef = null;
        this._tooltipInstance = null;
    };
    /**
     * Returns the origin position based on the user's position preference
     * @return {?}
     */
    MdTooltip.prototype._getOrigin = function () {
        if (this.position == 'above' || this.position == 'below') {
            return { originX: 'center', originY: this.position == 'above' ? 'top' : 'bottom' };
        }
        var /** @type {?} */ isDirectionLtr = !this._dir || this._dir.value == 'ltr';
        if (this.position == 'left' ||
            this.position == 'before' && isDirectionLtr ||
            this.position == 'after' && !isDirectionLtr) {
            return { originX: 'start', originY: 'center' };
        }
        if (this.position == 'right' ||
            this.position == 'after' && isDirectionLtr ||
            this.position == 'before' && !isDirectionLtr) {
            return { originX: 'end', originY: 'center' };
        }
        throw new MdTooltipInvalidPositionError(this.position);
    };
    /**
     * Returns the overlay position based on the user's preference
     * @return {?}
     */
    MdTooltip.prototype._getOverlayPosition = function () {
        if (this.position == 'above') {
            return { overlayX: 'center', overlayY: 'bottom' };
        }
        if (this.position == 'below') {
            return { overlayX: 'center', overlayY: 'top' };
        }
        var /** @type {?} */ isLtr = !this._dir || this._dir.value == 'ltr';
        if (this.position == 'left' ||
            this.position == 'before' && isLtr ||
            this.position == 'after' && !isLtr) {
            return { overlayX: 'end', overlayY: 'center' };
        }
        if (this.position == 'right' ||
            this.position == 'after' && isLtr ||
            this.position == 'before' && !isLtr) {
            return { overlayX: 'start', overlayY: 'center' };
        }
        throw new MdTooltipInvalidPositionError(this.position);
    };
    /**
     * Updates the tooltip message and repositions the overlay according to the new message length
     * @param {?} message
     * @return {?}
     */
    MdTooltip.prototype._setTooltipMessage = function (message) {
        var _this = this;
        // Must wait for the message to be painted to the tooltip so that the overlay can properly
        // calculate the correct positioning based on the size of the text.
        this._tooltipInstance.message = message;
        this._ngZone.onMicrotaskEmpty.first().subscribe(function () {
            if (_this._tooltipInstance) {
                _this._overlayRef.updatePosition();
            }
        });
    };
    return MdTooltip;
}());
MdTooltip.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                selector: '[md-tooltip], [mdTooltip], [mat-tooltip], [matTooltip]',
                host: {
                    '(longpress)': 'show()',
                    '(touchend)': 'hide(' + TOUCHEND_HIDE_DELAY + ')',
                },
                exportAs: 'mdTooltip',
            },] },
];
/**
 * @nocollapse
 */
MdTooltip.ctorParameters = function () { return [
    { type: Overlay, },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
    { type: ScrollDispatcher, },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewContainerRef"], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgZone"], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
    { type: Platform, },
    { type: Dir, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] },] },
]; };
MdTooltip.propDecorators = {
    'position': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['mdTooltipPosition',] },],
    'disabled': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['mdTooltipDisabled',] },],
    '_positionDeprecated': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['tooltip-position',] },],
    'showDelay': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['mdTooltipShowDelay',] },],
    'hideDelay': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['mdTooltipHideDelay',] },],
    'message': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['mdTooltip',] },],
    '_deprecatedMessage': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['md-tooltip',] },],
    '_matMessage': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['matTooltip',] },],
    '_matPosition': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['matTooltipPosition',] },],
    '_matDisabled': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['matTooltipDisabled',] },],
    '_matHideDelay': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['matTooltipHideDelay',] },],
    '_matShowDelay': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['matTooltipShowDelay',] },],
};
/**
 * Internal component that wraps the tooltip's content.
 * \@docs-private
 */
var TooltipComponent = (function () {
    /**
     * @param {?} _dir
     * @param {?} _changeDetectorRef
     */
    function TooltipComponent(_dir, _changeDetectorRef) {
        this._dir = _dir;
        this._changeDetectorRef = _changeDetectorRef;
        /** Property watched by the animation framework to show or hide the tooltip */
        this._visibility = 'initial';
        /** Whether interactions on the page should close the tooltip */
        this._closeOnInteraction = false;
        /** The transform origin used in the animation for showing and hiding the tooltip */
        this._transformOrigin = 'bottom';
        this._onHide = new __WEBPACK_IMPORTED_MODULE_3_rxjs_Subject__["Subject"]();
    }
    /**
     * Shows the tooltip with an animation originating from the provided origin
     * @param {?} position Position of the tooltip.
     * @param {?} delay Amount of milliseconds to the delay showing the tooltip.
     * @return {?}
     */
    TooltipComponent.prototype.show = function (position, delay) {
        var _this = this;
        // Cancel the delayed hide if it is scheduled
        if (this._hideTimeoutId) {
            clearTimeout(this._hideTimeoutId);
        }
        // Body interactions should cancel the tooltip if there is a delay in showing.
        this._closeOnInteraction = true;
        this._setTransformOrigin(position);
        this._showTimeoutId = setTimeout(function () {
            _this._visibility = 'visible';
            // If this was set to true immediately, then a body click that triggers show() would
            // trigger interaction and close the tooltip right after it was displayed.
            _this._closeOnInteraction = false;
            // Mark for check so if any parent component has set the
            // ChangeDetectionStrategy to OnPush it will be checked anyways
            _this._changeDetectorRef.markForCheck();
            setTimeout(function () { _this._closeOnInteraction = true; }, 0);
        }, delay);
    };
    /**
     * Begins the animation to hide the tooltip after the provided delay in ms.
     * @param {?} delay Amount of milliseconds to delay showing the tooltip.
     * @return {?}
     */
    TooltipComponent.prototype.hide = function (delay) {
        var _this = this;
        // Cancel the delayed show if it is scheduled
        if (this._showTimeoutId) {
            clearTimeout(this._showTimeoutId);
        }
        this._hideTimeoutId = setTimeout(function () {
            _this._visibility = 'hidden';
            _this._closeOnInteraction = false;
            // Mark for check so if any parent component has set the
            // ChangeDetectionStrategy to OnPush it will be checked anyways
            _this._changeDetectorRef.markForCheck();
        }, delay);
    };
    /**
     * Returns an observable that notifies when the tooltip has been hidden from view
     * @return {?}
     */
    TooltipComponent.prototype.afterHidden = function () {
        return this._onHide.asObservable();
    };
    /**
     * Whether the tooltip is being displayed
     * @return {?}
     */
    TooltipComponent.prototype.isVisible = function () {
        return this._visibility === 'visible';
    };
    /**
     * Sets the tooltip transform origin according to the tooltip position
     * @param {?} value
     * @return {?}
     */
    TooltipComponent.prototype._setTransformOrigin = function (value) {
        var /** @type {?} */ isLtr = !this._dir || this._dir.value == 'ltr';
        switch (value) {
            case 'before':
                this._transformOrigin = isLtr ? 'right' : 'left';
                break;
            case 'after':
                this._transformOrigin = isLtr ? 'left' : 'right';
                break;
            case 'left':
                this._transformOrigin = 'right';
                break;
            case 'right':
                this._transformOrigin = 'left';
                break;
            case 'above':
                this._transformOrigin = 'bottom';
                break;
            case 'below':
                this._transformOrigin = 'top';
                break;
            default: throw new MdTooltipInvalidPositionError(value);
        }
    };
    /**
     * @param {?} e
     * @return {?}
     */
    TooltipComponent.prototype._afterVisibilityAnimation = function (e) {
        if (e.toState === 'hidden' && !this.isVisible()) {
            this._onHide.next();
        }
    };
    /**
     * Interactions on the HTML body should close the tooltip immediately as defined in the
     * material design spec.
     * https://material.google.com/components/tooltips.html#tooltips-interaction
     * @return {?}
     */
    TooltipComponent.prototype._handleBodyInteraction = function () {
        if (this._closeOnInteraction) {
            this.hide(0);
        }
    };
    return TooltipComponent;
}());
TooltipComponent.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{ selector: 'md-tooltip-component, mat-tooltip-component',
                template: "<div class=\"mat-tooltip\" [style.transform-origin]=\"_transformOrigin\" [@state]=\"_visibility\" (@state.done)=\"_afterVisibilityAnimation($event)\"> {{message}} </div>",
                styles: [":host{pointer-events:none}.mat-tooltip{color:#fff;padding:6px 8px;border-radius:2px;font-family:Roboto,\"Helvetica Neue\",sans-serif;font-size:10px;margin:14px;max-width:250px}@media screen and (-ms-high-contrast:active){.mat-tooltip{outline:solid 1px}} /*# sourceMappingURL=tooltip.css.map */ "],
                animations: [
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__angular_animations__["f" /* trigger */])('state', [
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__angular_animations__["g" /* state */])('void', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__angular_animations__["c" /* style */])({ transform: 'scale(0)' })),
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__angular_animations__["g" /* state */])('initial', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__angular_animations__["c" /* style */])({ transform: 'scale(0)' })),
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__angular_animations__["g" /* state */])('visible', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__angular_animations__["c" /* style */])({ transform: 'scale(1)' })),
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__angular_animations__["g" /* state */])('hidden', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__angular_animations__["c" /* style */])({ transform: 'scale(0)' })),
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__angular_animations__["h" /* transition */])('* => visible', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__angular_animations__["i" /* animate */])('150ms cubic-bezier(0.0, 0.0, 0.2, 1)')),
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__angular_animations__["h" /* transition */])('* => hidden', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__angular_animations__["i" /* animate */])('150ms cubic-bezier(0.4, 0.0, 1, 1)')),
                    ])
                ],
                host: {
                    '(body:click)': 'this._handleBodyInteraction()'
                }
            },] },
];
/**
 * @nocollapse
 */
TooltipComponent.ctorParameters = function () { return [
    { type: Dir, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] },] },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ChangeDetectorRef"], },
]; };
var MdTooltipModule = (function () {
    function MdTooltipModule() {
    }
    /**
     * @deprecated
     * @return {?}
     */
    MdTooltipModule.forRoot = function () {
        return {
            ngModule: MdTooltipModule,
            providers: []
        };
    };
    return MdTooltipModule;
}());
MdTooltipModule.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{
                imports: [OverlayModule, CompatibilityModule, PlatformModule],
                exports: [MdTooltip, TooltipComponent, CompatibilityModule],
                declarations: [MdTooltip, TooltipComponent],
                entryComponents: [TooltipComponent],
            },] },
];
/**
 * @nocollapse
 */
MdTooltipModule.ctorParameters = function () { return []; };
/**
 * Exception thrown when menu trigger doesn't have a valid md-menu instance
 * \@docs-private
 */
var MdMenuMissingError = (function (_super) {
    __extends(MdMenuMissingError, _super);
    function MdMenuMissingError() {
        return _super.call(this, "md-menu-trigger: must pass in an md-menu instance.\n\n    Example:\n      <md-menu #menu=\"mdMenu\"></md-menu>\n      <button [mdMenuTriggerFor]=\"menu\"></button>\n    ") || this;
    }
    return MdMenuMissingError;
}(MdError));
/**
 * Exception thrown when menu's x-position value isn't valid.
 * In other words, it doesn't match 'before' or 'after'.
 * \@docs-private
 */
var MdMenuInvalidPositionX = (function (_super) {
    __extends(MdMenuInvalidPositionX, _super);
    function MdMenuInvalidPositionX() {
        return _super.call(this, "x-position value must be either 'before' or after'.\n      Example: <md-menu x-position=\"before\" #menu=\"mdMenu\"></md-menu>\n    ") || this;
    }
    return MdMenuInvalidPositionX;
}(MdError));
/**
 * Exception thrown when menu's y-position value isn't valid.
 * In other words, it doesn't match 'above' or 'below'.
 * \@docs-private
 */
var MdMenuInvalidPositionY = (function (_super) {
    __extends(MdMenuInvalidPositionY, _super);
    function MdMenuInvalidPositionY() {
        return _super.call(this, "y-position value must be either 'above' or below'.\n      Example: <md-menu y-position=\"above\" #menu=\"mdMenu\"></md-menu>\n    ") || this;
    }
    return MdMenuInvalidPositionY;
}(MdError));
/**
 * This directive is intended to be used inside an md-menu tag.
 * It exists mostly to set the role attribute.
 */
var MdMenuItem = (function () {
    /**
     * @param {?} _renderer
     * @param {?} _elementRef
     */
    function MdMenuItem(_renderer, _elementRef) {
        this._renderer = _renderer;
        this._elementRef = _elementRef;
        this._disabled = false;
    }
    /**
     * Focuses the menu item.
     * @return {?}
     */
    MdMenuItem.prototype.focus = function () {
        this._renderer.invokeElementMethod(this._getHostElement(), 'focus');
    };
    Object.defineProperty(MdMenuItem.prototype, "disabled", {
        /**
         * Whether the menu item is disabled.
         * @return {?}
         */
        get: function () { return this._disabled; },
        /**
         * @param {?} value
         * @return {?}
         */
        set: function (value) {
            this._disabled = coerceBooleanProperty(value);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Used to set the `tabindex`.
     * @return {?}
     */
    MdMenuItem.prototype._getTabIndex = function () {
        return this._disabled ? '-1' : '0';
    };
    /**
     * Used to set the HTML `disabled` attribute. Necessary for links to be disabled properly.
     * @return {?}
     */
    MdMenuItem.prototype._getDisabledAttr = function () {
        return this._disabled ? true : null;
    };
    /**
     * Returns the host DOM element.
     * @return {?}
     */
    MdMenuItem.prototype._getHostElement = function () {
        return this._elementRef.nativeElement;
    };
    /**
     * Prevents the default element actions if it is disabled.
     * @param {?} event
     * @return {?}
     */
    MdMenuItem.prototype._checkDisabled = function (event) {
        if (this.disabled) {
            event.preventDefault();
            event.stopPropagation();
        }
    };
    return MdMenuItem;
}());
MdMenuItem.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{ selector: '[md-menu-item], [mat-menu-item]',
                host: {
                    'role': 'menuitem',
                    '[class.mat-menu-item]': 'true',
                    '[attr.tabindex]': '_getTabIndex()',
                    '[attr.aria-disabled]': 'disabled.toString()',
                    '[attr.disabled]': '_getDisabledAttr()',
                    '(click)': '_checkDisabled($event)',
                },
                template: "<ng-content></ng-content> <div class=\"mat-menu-ripple\" *ngIf=\"!disabled\" md-ripple [mdRippleTrigger]=\"_getHostElement()\"> </div> ",
                exportAs: 'mdMenuItem'
            },] },
];
/**
 * @nocollapse
 */
MdMenuItem.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
]; };
MdMenuItem.propDecorators = {
    'disabled': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
};
/**
 * Below are all the animations for the md-menu component.
 * Animation duration and timing values are based on AngularJS Material.
 */
/**
 * This animation controls the menu panel's entry and exit from the page.
 *
 * When the menu panel is added to the DOM, it scales in and fades in its border.
 *
 * When the menu panel is removed from the DOM, it simply fades out after a brief
 * delay to display the ripple.
 */
// TODO(kara): switch to :enter and :leave once Mobile Safari is sorted out.
var transformMenu = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__angular_animations__["f" /* trigger */])('transformMenu', [
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__angular_animations__["g" /* state */])('showing', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__angular_animations__["c" /* style */])({
        opacity: 1,
        transform: "scale(1)"
    })),
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__angular_animations__["h" /* transition */])('void => *', [
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__angular_animations__["c" /* style */])({
            opacity: 0,
            transform: "scale(0)"
        }),
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__angular_animations__["i" /* animate */])("200ms cubic-bezier(0.25, 0.8, 0.25, 1)")
    ]),
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__angular_animations__["h" /* transition */])('* => void', [
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__angular_animations__["i" /* animate */])('50ms 100ms linear', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__angular_animations__["c" /* style */])({ opacity: 0 }))
    ])
]);
/**
 * This animation fades in the background color and content of the menu panel
 * after its containing element is scaled in.
 */
var fadeInItems = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__angular_animations__["f" /* trigger */])('fadeInItems', [
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__angular_animations__["g" /* state */])('showing', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__angular_animations__["c" /* style */])({ opacity: 1 })),
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__angular_animations__["h" /* transition */])('void => *', [
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__angular_animations__["c" /* style */])({ opacity: 0 }),
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__angular_animations__["i" /* animate */])("200ms 100ms cubic-bezier(0.55, 0, 0.55, 0.2)")
    ])
]);
// TODO(kara): prevent-close functionality
var MdMenu = (function () {
    /**
     * @param {?} posX
     * @param {?} posY
     * @param {?} deprecatedPosX
     * @param {?} deprecatedPosY
     */
    function MdMenu(posX, posY, deprecatedPosX, deprecatedPosY) {
        /** Config object to be passed into the menu's ngClass */
        this._classList = {};
        /** Position of the menu in the X axis. */
        this.positionX = 'after';
        /** Position of the menu in the Y axis. */
        this.positionY = 'below';
        this.overlapTrigger = true;
        /** Event emitted when the menu is closed. */
        this.close = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        // TODO(kara): Remove kebab-case attributes after next release
        if (deprecatedPosX) {
            this._setPositionX(deprecatedPosX);
        }
        if (deprecatedPosY) {
            this._setPositionY(deprecatedPosY);
        }
        if (posX) {
            this._setPositionX(posX);
        }
        if (posY) {
            this._setPositionY(posY);
        }
        this.setPositionClasses(this.positionX, this.positionY);
    }
    /**
     * @return {?}
     */
    MdMenu.prototype.ngAfterContentInit = function () {
        var _this = this;
        this._keyManager = new FocusKeyManager(this.items).withWrap();
        this._tabSubscription = this._keyManager.tabOut.subscribe(function () {
            _this._emitCloseEvent();
        });
    };
    /**
     * @return {?}
     */
    MdMenu.prototype.ngOnDestroy = function () {
        if (this._tabSubscription) {
            this._tabSubscription.unsubscribe();
        }
    };
    Object.defineProperty(MdMenu.prototype, "classList", {
        /**
         * This method takes classes set on the host md-menu element and applies them on the
         * menu template that displays in the overlay container.  Otherwise, it's difficult
         * to style the containing menu from outside the component.
         * @param {?} classes list of class names
         * @return {?}
         */
        set: function (classes) {
            this._classList = classes.split(' ').reduce(function (obj, className) {
                obj[className] = true;
                return obj;
            }, {});
            this.setPositionClasses(this.positionX, this.positionY);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Focus the first item in the menu. This method is used by the menu trigger
     * to focus the first item when the menu is opened by the ENTER key.
     * @return {?}
     */
    MdMenu.prototype.focusFirstItem = function () {
        this._keyManager.setFirstItemActive();
    };
    /**
     * This emits a close event to which the trigger is subscribed. When emitted, the
     * trigger will close the menu.
     * @return {?}
     */
    MdMenu.prototype._emitCloseEvent = function () {
        this.close.emit();
    };
    /**
     * @param {?} pos
     * @return {?}
     */
    MdMenu.prototype._setPositionX = function (pos) {
        if (pos !== 'before' && pos !== 'after') {
            throw new MdMenuInvalidPositionX();
        }
        this.positionX = pos;
    };
    /**
     * @param {?} pos
     * @return {?}
     */
    MdMenu.prototype._setPositionY = function (pos) {
        if (pos !== 'above' && pos !== 'below') {
            throw new MdMenuInvalidPositionY();
        }
        this.positionY = pos;
    };
    /**
     * It's necessary to set position-based classes to ensure the menu panel animation
     * folds out from the correct direction.
     * @param {?} posX
     * @param {?} posY
     * @return {?}
     */
    MdMenu.prototype.setPositionClasses = function (posX, posY) {
        this._classList['mat-menu-before'] = posX == 'before';
        this._classList['mat-menu-after'] = posX == 'after';
        this._classList['mat-menu-above'] = posY == 'above';
        this._classList['mat-menu-below'] = posY == 'below';
    };
    return MdMenu;
}());
MdMenu.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{ selector: 'md-menu, mat-menu',
                host: { 'role': 'menu' },
                template: "<ng-template> <div class=\"mat-menu-panel\" [ngClass]=\"_classList\" (keydown)=\"_keyManager.onKeydown($event)\" (click)=\"_emitCloseEvent()\" [@transformMenu]=\"'showing'\"> <div class=\"mat-menu-content\" [@fadeInItems]=\"'showing'\"> <ng-content></ng-content> </div> </div> </ng-template> ",
                styles: [".mat-menu-panel{box-shadow:0 5px 5px -3px rgba(0,0,0,.2),0 8px 10px 1px rgba(0,0,0,.14),0 3px 14px 2px rgba(0,0,0,.12);min-width:112px;max-width:280px;overflow:auto;-webkit-overflow-scrolling:touch;max-height:calc(100vh + 48px)}.mat-menu-panel.mat-menu-after.mat-menu-below{transform-origin:left top}.mat-menu-panel.mat-menu-after.mat-menu-above{transform-origin:left bottom}.mat-menu-panel.mat-menu-before.mat-menu-below{transform-origin:right top}.mat-menu-panel.mat-menu-before.mat-menu-above{transform-origin:right bottom}[dir=rtl] .mat-menu-panel.mat-menu-after.mat-menu-below{transform-origin:right top}[dir=rtl] .mat-menu-panel.mat-menu-after.mat-menu-above{transform-origin:right bottom}[dir=rtl] .mat-menu-panel.mat-menu-before.mat-menu-below{transform-origin:left top}[dir=rtl] .mat-menu-panel.mat-menu-before.mat-menu-above{transform-origin:left bottom}@media screen and (-ms-high-contrast:active){.mat-menu-panel{outline:solid 1px}}.mat-menu-content{padding-top:8px;padding-bottom:8px}.mat-menu-item{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:pointer;outline:0;border:none;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:block;line-height:48px;height:48px;padding:0 16px;font-size:16px;font-family:Roboto,\"Helvetica Neue\",sans-serif;text-align:left;text-decoration:none;position:relative}.mat-menu-item[disabled]{cursor:default}[dir=rtl] .mat-menu-item{text-align:right}.mat-menu-item .mat-icon{margin-right:16px}[dir=rtl] .mat-menu-item .mat-icon{margin-left:16px}button.mat-menu-item{width:100%}.mat-menu-ripple{position:absolute;top:0;left:0;bottom:0;right:0} /*# sourceMappingURL=menu.css.map */ "],
                encapsulation: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewEncapsulation"].None,
                animations: [
                    transformMenu,
                    fadeInItems
                ],
                exportAs: 'mdMenu'
            },] },
];
/**
 * @nocollapse
 */
MdMenu.ctorParameters = function () { return [
    { type: undefined, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Attribute"], args: ['xPosition',] },] },
    { type: undefined, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Attribute"], args: ['yPosition',] },] },
    { type: undefined, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Attribute"], args: ['x-position',] },] },
    { type: undefined, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Attribute"], args: ['y-position',] },] },
]; };
MdMenu.propDecorators = {
    'templateRef': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewChild"], args: [__WEBPACK_IMPORTED_MODULE_0__angular_core__["TemplateRef"],] },],
    'items': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ContentChildren"], args: [MdMenuItem,] },],
    'overlapTrigger': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    'classList': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['class',] },],
    'close': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
};
/**
 * This directive is intended to be used in conjunction with an md-menu tag.  It is
 * responsible for toggling the display of the provided menu instance.
 */
var MdMenuTrigger = (function () {
    /**
     * @param {?} _overlay
     * @param {?} _element
     * @param {?} _viewContainerRef
     * @param {?} _renderer
     * @param {?} _dir
     */
    function MdMenuTrigger(_overlay, _element, _viewContainerRef, _renderer, _dir) {
        this._overlay = _overlay;
        this._element = _element;
        this._viewContainerRef = _viewContainerRef;
        this._renderer = _renderer;
        this._dir = _dir;
        this._menuOpen = false;
        this._openedByMouse = false;
        /** Event emitted when the associated menu is opened. */
        this.onMenuOpen = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        /** Event emitted when the associated menu is closed. */
        this.onMenuClose = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
    }
    Object.defineProperty(MdMenuTrigger.prototype, "_deprecatedMdMenuTriggerFor", {
        /**
         * @deprecated
         * @return {?}
         */
        get: function () { return this.menu; },
        /**
         * @param {?} v
         * @return {?}
         */
        set: function (v) { this.menu = v; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdMenuTrigger.prototype, "_deprecatedMatMenuTriggerFor", {
        /**
         * @deprecated
         * @return {?}
         */
        get: function () { return this.menu; },
        /**
         * @param {?} v
         * @return {?}
         */
        set: function (v) { this.menu = v; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdMenuTrigger.prototype, "_matMenuTriggerFor", {
        /**
         * @return {?}
         */
        get: function () { return this.menu; },
        /**
         * @param {?} v
         * @return {?}
         */
        set: function (v) { this.menu = v; },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    MdMenuTrigger.prototype.ngAfterViewInit = function () {
        var _this = this;
        this._checkMenu();
        this.menu.close.subscribe(function () { return _this.closeMenu(); });
    };
    /**
     * @return {?}
     */
    MdMenuTrigger.prototype.ngOnDestroy = function () { this.destroyMenu(); };
    Object.defineProperty(MdMenuTrigger.prototype, "menuOpen", {
        /**
         * Whether the menu is open.
         * @return {?}
         */
        get: function () { return this._menuOpen; },
        enumerable: true,
        configurable: true
    });
    /**
     * Toggles the menu between the open and closed states.
     * @return {?}
     */
    MdMenuTrigger.prototype.toggleMenu = function () {
        return this._menuOpen ? this.closeMenu() : this.openMenu();
    };
    /**
     * Opens the menu.
     * @return {?}
     */
    MdMenuTrigger.prototype.openMenu = function () {
        if (!this._menuOpen) {
            this._createOverlay();
            this._overlayRef.attach(this._portal);
            this._subscribeToBackdrop();
            this._initMenu();
        }
    };
    /**
     * Closes the menu.
     * @return {?}
     */
    MdMenuTrigger.prototype.closeMenu = function () {
        if (this._overlayRef) {
            this._overlayRef.detach();
            this._backdropSubscription.unsubscribe();
            this._resetMenu();
        }
    };
    /**
     * Removes the menu from the DOM.
     * @return {?}
     */
    MdMenuTrigger.prototype.destroyMenu = function () {
        if (this._overlayRef) {
            this._overlayRef.dispose();
            this._overlayRef = null;
            this._cleanUpSubscriptions();
        }
    };
    /**
     * Focuses the menu trigger.
     * @return {?}
     */
    MdMenuTrigger.prototype.focus = function () {
        this._renderer.invokeElementMethod(this._element.nativeElement, 'focus');
    };
    Object.defineProperty(MdMenuTrigger.prototype, "dir", {
        /**
         * The text direction of the containing app.
         * @return {?}
         */
        get: function () {
            return this._dir && this._dir.value === 'rtl' ? 'rtl' : 'ltr';
        },
        enumerable: true,
        configurable: true
    });
    /**
     * This method ensures that the menu closes when the overlay backdrop is clicked.
     * We do not use first() here because doing so would not catch clicks from within
     * the menu, and it would fail to unsubscribe properly. Instead, we unsubscribe
     * explicitly when the menu is closed or destroyed.
     * @return {?}
     */
    MdMenuTrigger.prototype._subscribeToBackdrop = function () {
        var _this = this;
        this._backdropSubscription = this._overlayRef.backdropClick().subscribe(function () {
            _this.menu._emitCloseEvent();
        });
    };
    /**
     * This method sets the menu state to open and focuses the first item if
     * the menu was opened via the keyboard.
     * @return {?}
     */
    MdMenuTrigger.prototype._initMenu = function () {
        this._setIsMenuOpen(true);
        // Should only set focus if opened via the keyboard, so keyboard users can
        // can easily navigate menu items. According to spec, mouse users should not
        // see the focus style.
        if (!this._openedByMouse) {
            this.menu.focusFirstItem();
        }
    };
    ;
    /**
     * This method resets the menu when it's closed, most importantly restoring
     * focus to the menu trigger if the menu was opened via the keyboard.
     * @return {?}
     */
    MdMenuTrigger.prototype._resetMenu = function () {
        this._setIsMenuOpen(false);
        // Focus only needs to be reset to the host element if the menu was opened
        // by the keyboard and manually shifted to the first menu item.
        if (!this._openedByMouse) {
            this.focus();
        }
        this._openedByMouse = false;
    };
    /**
     * @param {?} isOpen
     * @return {?}
     */
    MdMenuTrigger.prototype._setIsMenuOpen = function (isOpen) {
        this._menuOpen = isOpen;
        this._menuOpen ? this.onMenuOpen.emit() : this.onMenuClose.emit();
    };
    /**
     *  This method checks that a valid instance of MdMenu has been passed into
     *  mdMenuTriggerFor. If not, an exception is thrown.
     * @return {?}
     */
    MdMenuTrigger.prototype._checkMenu = function () {
        if (!this.menu) {
            throw new MdMenuMissingError();
        }
    };
    /**
     *  This method creates the overlay from the provided menu's template and saves its
     *  OverlayRef so that it can be attached to the DOM when openMenu is called.
     * @return {?}
     */
    MdMenuTrigger.prototype._createOverlay = function () {
        if (!this._overlayRef) {
            this._portal = new TemplatePortal(this.menu.templateRef, this._viewContainerRef);
            var /** @type {?} */ config = this._getOverlayConfig();
            this._subscribeToPositions(/** @type {?} */ (config.positionStrategy));
            this._overlayRef = this._overlay.create(config);
        }
    };
    /**
     * This method builds the configuration object needed to create the overlay, the OverlayState.
     * @return {?} OverlayState
     */
    MdMenuTrigger.prototype._getOverlayConfig = function () {
        var /** @type {?} */ overlayState = new OverlayState();
        overlayState.positionStrategy = this._getPosition()
            .withDirection(this.dir);
        overlayState.hasBackdrop = true;
        overlayState.backdropClass = 'cdk-overlay-transparent-backdrop';
        overlayState.direction = this.dir;
        return overlayState;
    };
    /**
     * Listens to changes in the position of the overlay and sets the correct classes
     * on the menu based on the new position. This ensures the animation origin is always
     * correct, even if a fallback position is used for the overlay.
     * @param {?} position
     * @return {?}
     */
    MdMenuTrigger.prototype._subscribeToPositions = function (position) {
        var _this = this;
        this._positionSubscription = position.onPositionChange.subscribe(function (change) {
            var /** @type {?} */ posX = change.connectionPair.originX === 'start' ? 'after' : 'before';
            var /** @type {?} */ posY = change.connectionPair.originY === 'top' ? 'below' : 'above';
            if (!_this.menu.overlapTrigger) {
                posY = posY === 'below' ? 'above' : 'below';
            }
            _this.menu.setPositionClasses(posX, posY);
        });
    };
    /**
     * This method builds the position strategy for the overlay, so the menu is properly connected
     * to the trigger.
     * @return {?} ConnectedPositionStrategy
     */
    MdMenuTrigger.prototype._getPosition = function () {
        var _a = this.menu.positionX === 'before' ? ['end', 'start'] : ['start', 'end'], posX = _a[0], fallbackX = _a[1];
        var _b = this.menu.positionY === 'above' ? ['bottom', 'top'] : ['top', 'bottom'], overlayY = _b[0], fallbackOverlayY = _b[1];
        var /** @type {?} */ originY = overlayY;
        var /** @type {?} */ fallbackOriginY = fallbackOverlayY;
        if (!this.menu.overlapTrigger) {
            originY = overlayY === 'top' ? 'bottom' : 'top';
            fallbackOriginY = fallbackOverlayY === 'top' ? 'bottom' : 'top';
        }
        return this._overlay.position()
            .connectedTo(this._element, { originX: posX, originY: originY }, { overlayX: posX, overlayY: overlayY })
            .withFallbackPosition({ originX: fallbackX, originY: originY }, { overlayX: fallbackX, overlayY: overlayY })
            .withFallbackPosition({ originX: posX, originY: fallbackOriginY }, { overlayX: posX, overlayY: fallbackOverlayY })
            .withFallbackPosition({ originX: fallbackX, originY: fallbackOriginY }, { overlayX: fallbackX, overlayY: fallbackOverlayY });
    };
    /**
     * @return {?}
     */
    MdMenuTrigger.prototype._cleanUpSubscriptions = function () {
        if (this._backdropSubscription) {
            this._backdropSubscription.unsubscribe();
        }
        if (this._positionSubscription) {
            this._positionSubscription.unsubscribe();
        }
    };
    /**
     * @param {?} event
     * @return {?}
     */
    MdMenuTrigger.prototype._handleMousedown = function (event) {
        if (!isFakeMousedownFromScreenReader(event)) {
            this._openedByMouse = true;
        }
    };
    return MdMenuTrigger;
}());
MdMenuTrigger.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                selector: "[md-menu-trigger-for], [mat-menu-trigger-for],\n             [mdMenuTriggerFor], [matMenuTriggerFor]",
                host: {
                    'aria-haspopup': 'true',
                    '(mousedown)': '_handleMousedown($event)',
                    '(click)': 'toggleMenu()',
                },
                exportAs: 'mdMenuTrigger'
            },] },
];
/**
 * @nocollapse
 */
MdMenuTrigger.ctorParameters = function () { return [
    { type: Overlay, },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewContainerRef"], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
    { type: Dir, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] },] },
]; };
MdMenuTrigger.propDecorators = {
    '_deprecatedMdMenuTriggerFor': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['md-menu-trigger-for',] },],
    '_deprecatedMatMenuTriggerFor': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['mat-menu-trigger-for',] },],
    '_matMenuTriggerFor': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['matMenuTriggerFor',] },],
    'menu': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['mdMenuTriggerFor',] },],
    'onMenuOpen': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
    'onMenuClose': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Output"] },],
};
var MdMenuModule = (function () {
    function MdMenuModule() {
    }
    /**
     * @deprecated
     * @return {?}
     */
    MdMenuModule.forRoot = function () {
        return {
            ngModule: MdMenuModule,
            providers: [],
        };
    };
    return MdMenuModule;
}());
MdMenuModule.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{
                imports: [
                    OverlayModule,
                    __WEBPACK_IMPORTED_MODULE_2__angular_common__["CommonModule"],
                    MdRippleModule,
                    CompatibilityModule,
                ],
                exports: [MdMenu, MdMenuItem, MdMenuTrigger, CompatibilityModule],
                declarations: [MdMenu, MdMenuItem, MdMenuTrigger],
            },] },
];
/**
 * @nocollapse
 */
MdMenuModule.ctorParameters = function () { return []; };
/**
 * Reference to a dialog opened via the MdDialog service.
 */
var MdDialogRef = (function () {
    /**
     * @param {?} _overlayRef
     * @param {?} _containerInstance
     */
    function MdDialogRef(_overlayRef, _containerInstance) {
        var _this = this;
        this._overlayRef = _overlayRef;
        this._containerInstance = _containerInstance;
        this._afterClosed = new __WEBPACK_IMPORTED_MODULE_3_rxjs_Subject__["Subject"]();
        _containerInstance._onAnimationStateChange.subscribe(function (state$$1) {
            if (state$$1 === 'exit-start') {
                // Transition the backdrop in parallel with the dialog.
                _this._overlayRef.detachBackdrop();
            }
            else if (state$$1 === 'exit') {
                _this._overlayRef.dispose();
                _this._afterClosed.next(_this._result);
                _this._afterClosed.complete();
                _this.componentInstance = null;
            }
        });
    }
    /**
     * Close the dialog.
     * @param {?=} dialogResult Optional result to return to the dialog opener.
     * @return {?}
     */
    MdDialogRef.prototype.close = function (dialogResult) {
        this._result = dialogResult;
        this._containerInstance._exit();
    };
    /**
     * Gets an observable that is notified when the dialog is finished closing.
     * @return {?}
     */
    MdDialogRef.prototype.afterClosed = function () {
        return this._afterClosed.asObservable();
    };
    /**
     * Updates the dialog's position.
     * @param {?=} position New dialog position.
     * @return {?}
     */
    MdDialogRef.prototype.updatePosition = function (position) {
        var /** @type {?} */ strategy = this._getPositionStrategy();
        if (position && (position.left || position.right)) {
            position.left ? strategy.left(position.left) : strategy.right(position.right);
        }
        else {
            strategy.centerHorizontally();
        }
        if (position && (position.top || position.bottom)) {
            position.top ? strategy.top(position.top) : strategy.bottom(position.bottom);
        }
        else {
            strategy.centerVertically();
        }
        this._overlayRef.updatePosition();
        return this;
    };
    /**
     * Updates the dialog's width and height.
     * @param {?=} width New width of the dialog.
     * @param {?=} height New height of the dialog.
     * @return {?}
     */
    MdDialogRef.prototype.updateSize = function (width, height) {
        if (width === void 0) { width = 'auto'; }
        if (height === void 0) { height = 'auto'; }
        this._getPositionStrategy().width(width).height(height);
        this._overlayRef.updatePosition();
        return this;
    };
    /**
     * Fetches the position strategy object from the overlay ref.
     * @return {?}
     */
    MdDialogRef.prototype._getPositionStrategy = function () {
        return (this._overlayRef.getState().positionStrategy);
    };
    return MdDialogRef;
}());
var MD_DIALOG_DATA = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["OpaqueToken"]('MdDialogData');
/**
 * Custom injector type specifically for instantiating components with a dialog.
 */
var DialogInjector = (function () {
    /**
     * @param {?} _parentInjector
     * @param {?} _dialogRef
     * @param {?} _data
     */
    function DialogInjector(_parentInjector, _dialogRef, _data) {
        this._parentInjector = _parentInjector;
        this._dialogRef = _dialogRef;
        this._data = _data;
    }
    /**
     * @param {?} token
     * @param {?=} notFoundValue
     * @return {?}
     */
    DialogInjector.prototype.get = function (token, notFoundValue) {
        if (token === MdDialogRef) {
            return this._dialogRef;
        }
        if (token === MD_DIALOG_DATA && this._data) {
            return this._data;
        }
        return this._parentInjector.get(token, notFoundValue);
    };
    return DialogInjector;
}());
/**
 * Configuration for opening a modal dialog with the MdDialog service.
 */
var MdDialogConfig = (function () {
    function MdDialogConfig() {
        /** The ARIA role of the dialog element. */
        this.role = 'dialog';
        /** Whether the user can use escape or clicking outside to close a modal. */
        this.disableClose = false;
        /** Width of the dialog. */
        this.width = '';
        /** Height of the dialog. */
        this.height = '';
        // TODO(jelbourn): add configuration for lifecycle hooks, ARIA labelling.
    }
    return MdDialogConfig;
}());
/**
 * Exception thrown when a ComponentPortal is attached to a DomPortalHost without an origin.
 * \@docs-private
 */
var MdDialogContentAlreadyAttachedError = (function (_super) {
    __extends(MdDialogContentAlreadyAttachedError, _super);
    function MdDialogContentAlreadyAttachedError() {
        return _super.call(this, 'Attempting to attach dialog content after content is already attached') || this;
    }
    return MdDialogContentAlreadyAttachedError;
}(MdError));
/**
 * Internal component that wraps user-provided dialog content.
 * Animation is based on https://material.io/guidelines/motion/choreography.html.
 * \@docs-private
 */
var MdDialogContainer = (function (_super) {
    __extends(MdDialogContainer, _super);
    /**
     * @param {?} _ngZone
     * @param {?} _renderer
     * @param {?} _elementRef
     * @param {?} _focusTrapFactory
     */
    function MdDialogContainer(_ngZone, _renderer, _elementRef, _focusTrapFactory) {
        var _this = _super.call(this) || this;
        _this._ngZone = _ngZone;
        _this._renderer = _renderer;
        _this._elementRef = _elementRef;
        _this._focusTrapFactory = _focusTrapFactory;
        _this._elementFocusedBeforeDialogWasOpened = null;
        /** State of the dialog animation. */
        _this._state = 'enter';
        /** Emits the current animation state whenever it changes. */
        _this._onAnimationStateChange = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["EventEmitter"]();
        return _this;
    }
    /**
     * Attach a ComponentPortal as content to this dialog container.
     * @template T
     * @param {?} portal Portal to be attached as the dialog content.
     * @return {?}
     */
    MdDialogContainer.prototype.attachComponentPortal = function (portal) {
        if (this._portalHost.hasAttached()) {
            throw new MdDialogContentAlreadyAttachedError();
        }
        return this._portalHost.attachComponentPortal(portal);
    };
    /**
     * Attach a TemplatePortal as content to this dialog container.
     * @param {?} portal Portal to be attached as the dialog content.
     * @return {?}
     */
    MdDialogContainer.prototype.attachTemplatePortal = function (portal) {
        if (this._portalHost.hasAttached()) {
            throw new MdDialogContentAlreadyAttachedError();
        }
        return this._portalHost.attachTemplatePortal(portal);
    };
    /**
     * Moves the focus inside the focus trap.
     * @return {?}
     */
    MdDialogContainer.prototype._trapFocus = function () {
        if (!this._focusTrap) {
            this._focusTrap = this._focusTrapFactory.create(this._elementRef.nativeElement);
        }
        // If were to attempt to focus immediately, then the content of the dialog would not yet be
        // ready in instances where change detection has to run first. To deal with this, we simply
        // wait for the microtask queue to be empty.
        this._elementFocusedBeforeDialogWasOpened = (document.activeElement);
        this._focusTrap.focusFirstTabbableElementWhenReady();
    };
    /**
     * Kicks off the leave animation.
     * \@docs-private
     * @return {?}
     */
    MdDialogContainer.prototype._exit = function () {
        this._state = 'exit';
        this._onAnimationStateChange.emit('exit-start');
    };
    /**
     * Callback, invoked whenever an animation on the host completes.
     * \@docs-private
     * @param {?} event
     * @return {?}
     */
    MdDialogContainer.prototype._onAnimationDone = function (event) {
        if (event.toState === 'enter') {
            this._trapFocus();
        }
        this._onAnimationStateChange.emit(/** @type {?} */ (event.toState));
    };
    /**
     * @return {?}
     */
    MdDialogContainer.prototype.ngOnDestroy = function () {
        // When the dialog is destroyed, return focus to the element that originally had it before
        // the dialog was opened. Wait for the DOM to finish settling before changing the focus so
        // that it doesn't end up back on the <body>. Also note that we need the extra check, because
        // IE can set the `activeElement` to null in some cases.
        var /** @type {?} */ toFocus = (this._elementFocusedBeforeDialogWasOpened);
        // We shouldn't use `this` inside of the NgZone subscription, because it causes a memory leak.
        var /** @type {?} */ animationStream = this._onAnimationStateChange;
        this._ngZone.onMicrotaskEmpty.first().subscribe(function () {
            if (toFocus && 'focus' in toFocus) {
                toFocus.focus();
            }
            animationStream.complete();
        });
        if (this._focusTrap) {
            this._focusTrap.destroy();
        }
    };
    return MdDialogContainer;
}(BasePortalHost));
MdDialogContainer.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{ selector: 'md-dialog-container, mat-dialog-container',
                template: "<ng-template cdkPortalHost></ng-template> ",
                styles: [".mat-dialog-container{box-shadow:0 11px 15px -7px rgba(0,0,0,.2),0 24px 38px 3px rgba(0,0,0,.14),0 9px 46px 8px rgba(0,0,0,.12);display:block;padding:24px;border-radius:2px;box-sizing:border-box;overflow:auto;max-width:80vw;width:100%;height:100%}@media screen and (-ms-high-contrast:active){.mat-dialog-container{outline:solid 1px}}.mat-dialog-content{display:block;margin:0 -24px;padding:0 24px;max-height:65vh;overflow:auto}.mat-dialog-title{font-size:20px;font-weight:700;margin:0 0 20px;display:block}.mat-dialog-actions{padding:12px 0;display:flex}.mat-dialog-actions:last-child{margin-bottom:-24px}.mat-dialog-actions[align=end]{justify-content:flex-end}.mat-dialog-actions[align=center]{justify-content:center} /*# sourceMappingURL=dialog.css.map */ "],
                encapsulation: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewEncapsulation"].None,
                animations: [
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__angular_animations__["f" /* trigger */])('slideDialog', [
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__angular_animations__["g" /* state */])('void', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__angular_animations__["c" /* style */])({ transform: 'translateY(25%) scale(0.9)', opacity: 0 })),
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__angular_animations__["g" /* state */])('enter', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__angular_animations__["c" /* style */])({ transform: 'translateY(0%) scale(1)', opacity: 1 })),
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__angular_animations__["g" /* state */])('exit', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__angular_animations__["c" /* style */])({ transform: 'translateY(25%)', opacity: 0 })),
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__angular_animations__["h" /* transition */])('* => *', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__angular_animations__["i" /* animate */])('400ms cubic-bezier(0.25, 0.8, 0.25, 1)')),
                    ])
                ],
                host: {
                    '[class.mat-dialog-container]': 'true',
                    '[attr.role]': 'dialogConfig?.role',
                    '[@slideDialog]': '_state',
                    '(@slideDialog.done)': '_onAnimationDone($event)',
                },
            },] },
];
/**
 * @nocollapse
 */
MdDialogContainer.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgZone"], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
    { type: FocusTrapFactory, },
]; };
MdDialogContainer.propDecorators = {
    '_portalHost': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewChild"], args: [PortalHostDirective,] },],
};
/**
 * Service to open Material Design modal dialogs.
 */
var MdDialog = (function () {
    /**
     * @param {?} _overlay
     * @param {?} _injector
     * @param {?} _parentDialog
     */
    function MdDialog(_overlay, _injector, _parentDialog) {
        this._overlay = _overlay;
        this._injector = _injector;
        this._parentDialog = _parentDialog;
        this._openDialogsAtThisLevel = [];
        this._afterAllClosedAtThisLevel = new __WEBPACK_IMPORTED_MODULE_3_rxjs_Subject__["Subject"]();
        this._afterOpenAtThisLevel = new __WEBPACK_IMPORTED_MODULE_3_rxjs_Subject__["Subject"]();
        this._boundKeydown = this._handleKeydown.bind(this);
        /** Gets an observable that is notified when a dialog has been opened. */
        this.afterOpen = this._afterOpen.asObservable();
        /** Gets an observable that is notified when all open dialog have finished closing. */
        this.afterAllClosed = this._afterAllClosed.asObservable();
    }
    Object.defineProperty(MdDialog.prototype, "_openDialogs", {
        /**
         * Keeps track of the currently-open dialogs.
         * @return {?}
         */
        get: function () {
            return this._parentDialog ? this._parentDialog._openDialogs : this._openDialogsAtThisLevel;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdDialog.prototype, "_afterOpen", {
        /**
         * Subject for notifying the user that a dialog has opened.
         * @return {?}
         */
        get: function () {
            return this._parentDialog ? this._parentDialog._afterOpen : this._afterOpenAtThisLevel;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdDialog.prototype, "_afterAllClosed", {
        /**
         * Subject for notifying the user that all open dialogs have finished closing.
         * @return {?}
         */
        get: function () {
            return this._parentDialog ?
                this._parentDialog._afterAllClosed : this._afterAllClosedAtThisLevel;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Opens a modal dialog containing the given component.
     * @template T
     * @param {?} componentOrTemplateRef Type of the component to load into the dialog,
     *     or a TemplateRef to instantiate as the dialog content.
     * @param {?=} config Extra configuration options.
     * @return {?} Reference to the newly-opened dialog.
     */
    MdDialog.prototype.open = function (componentOrTemplateRef, config) {
        var _this = this;
        config = _applyConfigDefaults$1(config);
        var /** @type {?} */ overlayRef = this._createOverlay(config);
        var /** @type {?} */ dialogContainer = this._attachDialogContainer(overlayRef, config);
        var /** @type {?} */ dialogRef = this._attachDialogContent(componentOrTemplateRef, dialogContainer, overlayRef, config);
        if (!this._openDialogs.length && !this._parentDialog) {
            document.addEventListener('keydown', this._boundKeydown);
        }
        this._openDialogs.push(dialogRef);
        dialogRef.afterClosed().subscribe(function () { return _this._removeOpenDialog(dialogRef); });
        this._afterOpen.next(dialogRef);
        return dialogRef;
    };
    /**
     * Closes all of the currently-open dialogs.
     * @return {?}
     */
    MdDialog.prototype.closeAll = function () {
        var /** @type {?} */ i = this._openDialogs.length;
        while (i--) {
            // The `_openDialogs` property isn't updated after close until the rxjs subscription
            // runs on the next microtask, in addition to modifying the array as we're going
            // through it. We loop through all of them and call close without assuming that
            // they'll be removed from the list instantaneously.
            this._openDialogs[i].close();
        }
    };
    /**
     * Creates the overlay into which the dialog will be loaded.
     * @param {?} config The dialog configuration.
     * @return {?} A promise resolving to the OverlayRef for the created overlay.
     */
    MdDialog.prototype._createOverlay = function (config) {
        var /** @type {?} */ overlayState = this._getOverlayState(config);
        return this._overlay.create(overlayState);
    };
    /**
     * Creates an overlay state from a dialog config.
     * @param {?} dialogConfig The dialog configuration.
     * @return {?} The overlay configuration.
     */
    MdDialog.prototype._getOverlayState = function (dialogConfig) {
        var /** @type {?} */ overlayState = new OverlayState();
        overlayState.hasBackdrop = true;
        overlayState.positionStrategy = this._overlay.position().global();
        return overlayState;
    };
    /**
     * Attaches an MdDialogContainer to a dialog's already-created overlay.
     * @param {?} overlay Reference to the dialog's underlying overlay.
     * @param {?} config The dialog configuration.
     * @return {?} A promise resolving to a ComponentRef for the attached container.
     */
    MdDialog.prototype._attachDialogContainer = function (overlay, config) {
        var /** @type {?} */ viewContainer = config ? config.viewContainerRef : null;
        var /** @type {?} */ containerPortal = new ComponentPortal(MdDialogContainer, viewContainer);
        var /** @type {?} */ containerRef = overlay.attach(containerPortal);
        containerRef.instance.dialogConfig = config;
        return containerRef.instance;
    };
    /**
     * Attaches the user-provided component to the already-created MdDialogContainer.
     * @template T
     * @param {?} componentOrTemplateRef The type of component being loaded into the dialog,
     *     or a TemplateRef to instantiate as the content.
     * @param {?} dialogContainer Reference to the wrapping MdDialogContainer.
     * @param {?} overlayRef Reference to the overlay in which the dialog resides.
     * @param {?} config The dialog configuration.
     * @return {?} A promise resolving to the MdDialogRef that should be returned to the user.
     */
    MdDialog.prototype._attachDialogContent = function (componentOrTemplateRef, dialogContainer, overlayRef, config) {
        // Create a reference to the dialog we're creating in order to give the user a handle
        // to modify and close it.
        var /** @type {?} */ dialogRef = new MdDialogRef(overlayRef, dialogContainer);
        if (!config.disableClose) {
            // When the dialog backdrop is clicked, we want to close it.
            overlayRef.backdropClick().first().subscribe(function () { return dialogRef.close(); });
        }
        // We create an injector specifically for the component we're instantiating so that it can
        // inject the MdDialogRef. This allows a component loaded inside of a dialog to close itself
        // and, optionally, to return a value.
        var /** @type {?} */ userInjector = config && config.viewContainerRef && config.viewContainerRef.injector;
        var /** @type {?} */ dialogInjector = new DialogInjector(userInjector || this._injector, dialogRef, config.data);
        if (componentOrTemplateRef instanceof __WEBPACK_IMPORTED_MODULE_0__angular_core__["TemplateRef"]) {
            dialogContainer.attachTemplatePortal(new TemplatePortal(componentOrTemplateRef, null));
        }
        else {
            var /** @type {?} */ contentRef = dialogContainer.attachComponentPortal(new ComponentPortal(componentOrTemplateRef, null, dialogInjector));
            dialogRef.componentInstance = contentRef.instance;
        }
        dialogRef
            .updateSize(config.width, config.height)
            .updatePosition(config.position);
        return dialogRef;
    };
    /**
     * Removes a dialog from the array of open dialogs.
     * @param {?} dialogRef Dialog to be removed.
     * @return {?}
     */
    MdDialog.prototype._removeOpenDialog = function (dialogRef) {
        var /** @type {?} */ index = this._openDialogs.indexOf(dialogRef);
        if (index > -1) {
            this._openDialogs.splice(index, 1);
            // no open dialogs are left, call next on afterAllClosed Subject
            if (!this._openDialogs.length) {
                this._afterAllClosed.next();
                document.removeEventListener('keydown', this._boundKeydown);
            }
        }
    };
    /**
     * Handles global key presses while there are open dialogs. Closes the
     * top dialog when the user presses escape.
     * @param {?} event
     * @return {?}
     */
    MdDialog.prototype._handleKeydown = function (event) {
        var /** @type {?} */ topDialog = this._openDialogs[this._openDialogs.length - 1];
        if (event.keyCode === ESCAPE && topDialog &&
            !topDialog._containerInstance.dialogConfig.disableClose) {
            topDialog.close();
        }
    };
    return MdDialog;
}());
MdDialog.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
];
/**
 * @nocollapse
 */
MdDialog.ctorParameters = function () { return [
    { type: Overlay, },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injector"], },
    { type: MdDialog, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["SkipSelf"] },] },
]; };
/**
 * Applies default options to the dialog config.
 * @param {?} config Config to be modified.
 * @return {?} The new configuration object.
 */
function _applyConfigDefaults$1(config) {
    return extendObject(new MdDialogConfig(), config);
}
/**
 * Button that will close the current dialog.
 */
var MdDialogClose = (function () {
    /**
     * @param {?} dialogRef
     */
    function MdDialogClose(dialogRef) {
        this.dialogRef = dialogRef;
        /** Screenreader label for the button. */
        this.ariaLabel = 'Close dialog';
    }
    return MdDialogClose;
}());
MdDialogClose.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                selector: 'button[md-dialog-close], button[mat-dialog-close]',
                host: {
                    '(click)': 'dialogRef.close()',
                    '[attr.aria-label]': 'ariaLabel',
                    'type': 'button',
                }
            },] },
];
/**
 * @nocollapse
 */
MdDialogClose.ctorParameters = function () { return [
    { type: MdDialogRef, },
]; };
MdDialogClose.propDecorators = {
    'ariaLabel': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['aria-label',] },],
};
/**
 * Title of a dialog element. Stays fixed to the top of the dialog when scrolling.
 */
var MdDialogTitle = (function () {
    function MdDialogTitle() {
    }
    return MdDialogTitle;
}());
MdDialogTitle.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                selector: '[md-dialog-title], [mat-dialog-title]',
                host: {
                    '[class.mat-dialog-title]': 'true'
                }
            },] },
];
/**
 * @nocollapse
 */
MdDialogTitle.ctorParameters = function () { return []; };
/**
 * Scrollable content container of a dialog.
 */
var MdDialogContent = (function () {
    function MdDialogContent() {
    }
    return MdDialogContent;
}());
MdDialogContent.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                selector: '[md-dialog-content], md-dialog-content, [mat-dialog-content], mat-dialog-content',
                host: {
                    '[class.mat-dialog-content]': 'true'
                }
            },] },
];
/**
 * @nocollapse
 */
MdDialogContent.ctorParameters = function () { return []; };
/**
 * Container for the bottom action buttons in a dialog.
 * Stays fixed to the bottom when scrolling.
 */
var MdDialogActions = (function () {
    function MdDialogActions() {
    }
    return MdDialogActions;
}());
MdDialogActions.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                selector: '[md-dialog-actions], md-dialog-actions, [mat-dialog-actions], mat-dialog-actions',
                host: {
                    '[class.mat-dialog-actions]': 'true'
                }
            },] },
];
/**
 * @nocollapse
 */
MdDialogActions.ctorParameters = function () { return []; };
var MdDialogModule = (function () {
    function MdDialogModule() {
    }
    /**
     * @deprecated
     * @return {?}
     */
    MdDialogModule.forRoot = function () {
        return {
            ngModule: MdDialogModule,
            providers: [],
        };
    };
    return MdDialogModule;
}());
MdDialogModule.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{
                imports: [
                    OverlayModule,
                    PortalModule,
                    A11yModule,
                    CompatibilityModule,
                ],
                exports: [
                    MdDialogContainer,
                    MdDialogClose,
                    MdDialogTitle,
                    MdDialogContent,
                    MdDialogActions,
                    CompatibilityModule,
                ],
                declarations: [
                    MdDialogContainer,
                    MdDialogClose,
                    MdDialogTitle,
                    MdDialogActions,
                    MdDialogContent,
                ],
                providers: [
                    MdDialog,
                ],
                entryComponents: [MdDialogContainer],
            },] },
];
/**
 * @nocollapse
 */
MdDialogModule.ctorParameters = function () { return []; };
var ActiveDescendantKeyManager = (function (_super) {
    __extends(ActiveDescendantKeyManager, _super);
    /**
     * @param {?} items
     */
    function ActiveDescendantKeyManager(items) {
        return _super.call(this, items) || this;
    }
    /**
     * This method sets the active item to the item at the specified index.
     * It also adds active styles to the newly active item and removes active
     * styles from the previously active item.
     * @param {?} index
     * @return {?}
     */
    ActiveDescendantKeyManager.prototype.setActiveItem = function (index) {
        var _this = this;
        Promise.resolve().then(function () {
            if (_this.activeItem) {
                _this.activeItem.setInactiveStyles();
            }
            _super.prototype.setActiveItem.call(_this, index);
            if (_this.activeItem) {
                _this.activeItem.setActiveStyles();
            }
        });
    };
    return ActiveDescendantKeyManager;
}(ListKeyManager));
/**
 * Autocomplete IDs need to be unique across components, so this counter exists outside of
 * the component definition.
 */
var _uniqueAutocompleteIdCounter = 0;
var MdAutocomplete = (function () {
    function MdAutocomplete() {
        /** Whether the autocomplete panel displays above or below its trigger. */
        this.positionY = 'below';
        /** Whether the autocomplete panel should be visible, depending on option length. */
        this.showPanel = false;
        /** Unique ID to be used by autocomplete trigger's "aria-owns" property. */
        this.id = "md-autocomplete-" + _uniqueAutocompleteIdCounter++;
    }
    /**
     * @return {?}
     */
    MdAutocomplete.prototype.ngAfterContentInit = function () {
        this._keyManager = new ActiveDescendantKeyManager(this.options).withWrap();
    };
    /**
     * Sets the panel scrollTop. This allows us to manually scroll to display
     * options below the fold, as they are not actually being focused when active.
     * @param {?} scrollTop
     * @return {?}
     */
    MdAutocomplete.prototype._setScrollTop = function (scrollTop) {
        if (this.panel) {
            this.panel.nativeElement.scrollTop = scrollTop;
        }
    };
    /**
     * Panel should hide itself when the option list is empty.
     * @return {?}
     */
    MdAutocomplete.prototype._setVisibility = function () {
        var _this = this;
        Promise.resolve().then(function () { return _this.showPanel = !!_this.options.length; });
    };
    /**
     * Sets a class on the panel based on its position (used to set y-offset).
     * @return {?}
     */
    MdAutocomplete.prototype._getClassList = function () {
        return {
            'mat-autocomplete-panel-below': this.positionY === 'below',
            'mat-autocomplete-panel-above': this.positionY === 'above',
            'mat-autocomplete-visible': this.showPanel,
            'mat-autocomplete-hidden': !this.showPanel
        };
    };
    return MdAutocomplete;
}());
MdAutocomplete.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{ selector: 'md-autocomplete, mat-autocomplete',
                template: "<ng-template> <div class=\"mat-autocomplete-panel\" role=\"listbox\" [id]=\"id\" [ngClass]=\"_getClassList()\" #panel> <ng-content></ng-content> </div> </ng-template> ",
                styles: [".mat-autocomplete-panel{box-shadow:0 5px 5px -3px rgba(0,0,0,.2),0 8px 10px 1px rgba(0,0,0,.14),0 3px 14px 2px rgba(0,0,0,.12);min-width:112px;max-width:280px;overflow:auto;-webkit-overflow-scrolling:touch;visibility:hidden;max-width:none;max-height:256px;position:relative}.mat-autocomplete-panel.mat-autocomplete-panel-below{top:6px}.mat-autocomplete-panel.mat-autocomplete-panel-above{top:-24px}.mat-autocomplete-panel.mat-autocomplete-visible{visibility:visible}.mat-autocomplete-panel.mat-autocomplete-hidden{visibility:hidden} /*# sourceMappingURL=autocomplete.css.map */ "],
                encapsulation: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewEncapsulation"].None,
                exportAs: 'mdAutocomplete',
                host: {
                    '[class.mat-autocomplete]': 'true'
                }
            },] },
];
/**
 * @nocollapse
 */
MdAutocomplete.ctorParameters = function () { return []; };
MdAutocomplete.propDecorators = {
    'template': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewChild"], args: [__WEBPACK_IMPORTED_MODULE_0__angular_core__["TemplateRef"],] },],
    'panel': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewChild"], args: ['panel',] },],
    'options': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ContentChildren"], args: [MdOption,] },],
    'displayWith': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
};
/**
 * The following style constants are necessary to save here in order
 * to properly calculate the scrollTop of the panel. Because we are not
 * actually focusing the active item, scroll must be handled manually.
 */
/** The height of each autocomplete option. */
var AUTOCOMPLETE_OPTION_HEIGHT = 48;
/** The total height of the autocomplete panel. */
var AUTOCOMPLETE_PANEL_HEIGHT = 256;
/**
 * Provider that allows the autocomplete to register as a ControlValueAccessor.
 * \@docs-private
 */
var MD_AUTOCOMPLETE_VALUE_ACCESSOR = {
    provide: __WEBPACK_IMPORTED_MODULE_8__angular_forms__["c" /* NG_VALUE_ACCESSOR */],
    useExisting: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__angular_core__["forwardRef"])(function () { return MdAutocompleteTrigger; }),
    multi: true
};
var MdAutocompleteTrigger = (function () {
    /**
     * @param {?} _element
     * @param {?} _overlay
     * @param {?} _viewContainerRef
     * @param {?} _dir
     * @param {?} _zone
     * @param {?} _inputContainer
     */
    function MdAutocompleteTrigger(_element, _overlay, _viewContainerRef, _dir, _zone, _inputContainer) {
        this._element = _element;
        this._overlay = _overlay;
        this._viewContainerRef = _viewContainerRef;
        this._dir = _dir;
        this._zone = _zone;
        this._inputContainer = _inputContainer;
        this._panelOpen = false;
        this._blurStream = new __WEBPACK_IMPORTED_MODULE_3_rxjs_Subject__["Subject"]();
        this._manuallyFloatingPlaceholder = false;
        /** View -> model callback called when value changes */
        this._onChange = function (value) { };
        /** View -> model callback called when autocomplete has been touched */
        this._onTouched = function () { };
    }
    Object.defineProperty(MdAutocompleteTrigger.prototype, "_matAutocomplete", {
        /**
         * Property with mat- prefix for no-conflict mode.
         * @return {?}
         */
        get: function () {
            return this.autocomplete;
        },
        /**
         * @param {?} autocomplete
         * @return {?}
         */
        set: function (autocomplete) {
            this.autocomplete = autocomplete;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    MdAutocompleteTrigger.prototype.ngOnDestroy = function () {
        if (this._panelPositionSubscription) {
            this._panelPositionSubscription.unsubscribe();
        }
        this._destroyPanel();
    };
    Object.defineProperty(MdAutocompleteTrigger.prototype, "panelOpen", {
        /**
         * @return {?}
         */
        get: function () {
            return this._panelOpen && this.autocomplete.showPanel;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Opens the autocomplete suggestion panel.
     * @return {?}
     */
    MdAutocompleteTrigger.prototype.openPanel = function () {
        if (!this._overlayRef) {
            this._createOverlay();
        }
        else {
            /** Update the panel width, in case the host width has changed */
            this._overlayRef.getState().width = this._getHostWidth();
        }
        if (!this._overlayRef.hasAttached()) {
            this._overlayRef.attach(this._portal);
            this._subscribeToClosingActions();
        }
        this.autocomplete._setVisibility();
        this._floatPlaceholder();
        this._panelOpen = true;
    };
    /**
     * Closes the autocomplete suggestion panel.
     * @return {?}
     */
    MdAutocompleteTrigger.prototype.closePanel = function () {
        if (this._overlayRef && this._overlayRef.hasAttached()) {
            this._overlayRef.detach();
        }
        this._panelOpen = false;
        this._resetPlaceholder();
    };
    Object.defineProperty(MdAutocompleteTrigger.prototype, "panelClosingActions", {
        /**
         * A stream of actions that should close the autocomplete panel, including
         * when an option is selected, on blur, and when TAB is pressed.
         * @return {?}
         */
        get: function () {
            return __WEBPACK_IMPORTED_MODULE_4_rxjs_Observable__["Observable"].merge(this.optionSelections, this._blurStream.asObservable(), this.autocomplete._keyManager.tabOut);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdAutocompleteTrigger.prototype, "optionSelections", {
        /**
         * Stream of autocomplete option selections.
         * @return {?}
         */
        get: function () {
            return __WEBPACK_IMPORTED_MODULE_4_rxjs_Observable__["Observable"].merge.apply(__WEBPACK_IMPORTED_MODULE_4_rxjs_Observable__["Observable"], this.autocomplete.options.map(function (option) { return option.onSelectionChange; }));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MdAutocompleteTrigger.prototype, "activeOption", {
        /**
         * The currently active option, coerced to MdOption type.
         * @return {?}
         */
        get: function () {
            if (this.autocomplete._keyManager) {
                return (this.autocomplete._keyManager.activeItem);
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Sets the autocomplete's value. Part of the ControlValueAccessor interface
     * required to integrate with Angular's core forms API.
     *
     * @param {?} value New value to be written to the model.
     * @return {?}
     */
    MdAutocompleteTrigger.prototype.writeValue = function (value) {
        var _this = this;
        Promise.resolve(null).then(function () { return _this._setTriggerValue(value); });
    };
    /**
     * Saves a callback function to be invoked when the autocomplete's value
     * changes from user input. Part of the ControlValueAccessor interface
     * required to integrate with Angular's core forms API.
     *
     * @param {?} fn Callback to be triggered when the value changes.
     * @return {?}
     */
    MdAutocompleteTrigger.prototype.registerOnChange = function (fn) {
        this._onChange = fn;
    };
    /**
     * Saves a callback function to be invoked when the autocomplete is blurred
     * by the user. Part of the ControlValueAccessor interface required
     * to integrate with Angular's core forms API.
     *
     * @param {?} fn Callback to be triggered when the component has been touched.
     * @return {?}
     */
    MdAutocompleteTrigger.prototype.registerOnTouched = function (fn) {
        this._onTouched = fn;
    };
    /**
     * @param {?} event
     * @return {?}
     */
    MdAutocompleteTrigger.prototype._handleKeydown = function (event) {
        var _this = this;
        if (this.activeOption && event.keyCode === ENTER) {
            this.activeOption._selectViaInteraction();
            event.preventDefault();
        }
        else {
            this.autocomplete._keyManager.onKeydown(event);
            if (event.keyCode === UP_ARROW || event.keyCode === DOWN_ARROW) {
                this.openPanel();
                Promise.resolve().then(function () { return _this._scrollToOption(); });
            }
        }
    };
    /**
     * @param {?} event
     * @return {?}
     */
    MdAutocompleteTrigger.prototype._handleInput = function (event) {
        // We need to ensure that the input is focused, because IE will fire the `input`
        // event on focus/blur/load if the input has a placeholder. See:
        // https://connect.microsoft.com/IE/feedback/details/885747/
        if (document.activeElement === event.target) {
            this._onChange(((event.target)).value);
            this.openPanel();
        }
    };
    /**
     * @param {?} newlyFocusedTag
     * @return {?}
     */
    MdAutocompleteTrigger.prototype._handleBlur = function (newlyFocusedTag) {
        this._onTouched();
        // Only emit blur event if the new focus is *not* on an option.
        if (newlyFocusedTag !== 'MD-OPTION') {
            this._blurStream.next(null);
        }
    };
    /**
     * In "auto" mode, the placeholder will animate down as soon as focus is lost.
     * This causes the value to jump when selecting an option with the mouse.
     * This method manually floats the placeholder until the panel can be closed.
     * @return {?}
     */
    MdAutocompleteTrigger.prototype._floatPlaceholder = function () {
        if (this._inputContainer && this._inputContainer.floatPlaceholder === 'auto') {
            this._inputContainer.floatPlaceholder = 'always';
            this._manuallyFloatingPlaceholder = true;
        }
    };
    /**
     * If the placeholder has been manually elevated, return it to its normal state.
     * @return {?}
     */
    MdAutocompleteTrigger.prototype._resetPlaceholder = function () {
        if (this._manuallyFloatingPlaceholder) {
            this._inputContainer.floatPlaceholder = 'auto';
            this._manuallyFloatingPlaceholder = false;
        }
    };
    /**
     * Given that we are not actually focusing active options, we must manually adjust scroll
     * to reveal options below the fold. First, we find the offset of the option from the top
     * of the panel. The new scrollTop will be that offset - the panel height + the option
     * height, so the active option will be just visible at the bottom of the panel.
     * @return {?}
     */
    MdAutocompleteTrigger.prototype._scrollToOption = function () {
        var /** @type {?} */ optionOffset = this.autocomplete._keyManager.activeItemIndex * AUTOCOMPLETE_OPTION_HEIGHT;
        var /** @type {?} */ newScrollTop = Math.max(0, optionOffset - AUTOCOMPLETE_PANEL_HEIGHT + AUTOCOMPLETE_OPTION_HEIGHT);
        this.autocomplete._setScrollTop(newScrollTop);
    };
    /**
     * This method listens to a stream of panel closing actions and resets the
     * stream every time the option list changes.
     * @return {?}
     */
    MdAutocompleteTrigger.prototype._subscribeToClosingActions = function () {
        var _this = this;
        // When the zone is stable initially, and when the option list changes...
        __WEBPACK_IMPORTED_MODULE_4_rxjs_Observable__["Observable"].merge(this._zone.onStable.first(), this.autocomplete.options.changes)
            .switchMap(function () {
            _this._resetPanel();
            return _this.panelClosingActions;
        })
            .first()
            .subscribe(function (event) { return _this._setValueAndClose(event); });
    };
    /**
     * Destroys the autocomplete suggestion panel.
     * @return {?}
     */
    MdAutocompleteTrigger.prototype._destroyPanel = function () {
        if (this._overlayRef) {
            this.closePanel();
            this._overlayRef.dispose();
            this._overlayRef = null;
        }
    };
    /**
     * @param {?} value
     * @return {?}
     */
    MdAutocompleteTrigger.prototype._setTriggerValue = function (value) {
        var /** @type {?} */ toDisplay = this.autocomplete.displayWith ? this.autocomplete.displayWith(value) : value;
        this._element.nativeElement.value = toDisplay || '';
    };
    /**
     * This method closes the panel, and if a value is specified, also sets the associated
     * control to that value. It will also mark the control as dirty if this interaction
     * stemmed from the user.
     * @param {?} event
     * @return {?}
     */
    MdAutocompleteTrigger.prototype._setValueAndClose = function (event) {
        if (event) {
            this._clearPreviousSelectedOption(event.source);
            this._setTriggerValue(event.source.value);
            this._onChange(event.source.value);
        }
        this.closePanel();
    };
    /**
     * Clear any previous selected option and emit a selection change event for this option
     * @param {?} skip
     * @return {?}
     */
    MdAutocompleteTrigger.prototype._clearPreviousSelectedOption = function (skip) {
        this.autocomplete.options.forEach(function (option) {
            if (option != skip && option.selected) {
                option.deselect();
            }
        });
    };
    /**
     * @return {?}
     */
    MdAutocompleteTrigger.prototype._createOverlay = function () {
        this._portal = new TemplatePortal(this.autocomplete.template, this._viewContainerRef);
        this._overlayRef = this._overlay.create(this._getOverlayConfig());
    };
    /**
     * @return {?}
     */
    MdAutocompleteTrigger.prototype._getOverlayConfig = function () {
        var /** @type {?} */ overlayState = new OverlayState();
        overlayState.positionStrategy = this._getOverlayPosition();
        overlayState.width = this._getHostWidth();
        overlayState.direction = this._dir ? this._dir.value : 'ltr';
        return overlayState;
    };
    /**
     * @return {?}
     */
    MdAutocompleteTrigger.prototype._getOverlayPosition = function () {
        this._positionStrategy = this._overlay.position().connectedTo(this._element, { originX: 'start', originY: 'bottom' }, { overlayX: 'start', overlayY: 'top' })
            .withFallbackPosition({ originX: 'start', originY: 'top' }, { overlayX: 'start', overlayY: 'bottom' });
        this._subscribeToPositionChanges(this._positionStrategy);
        return this._positionStrategy;
    };
    /**
     * This method subscribes to position changes in the autocomplete panel, so the panel's
     * y-offset can be adjusted to match the new position.
     * @param {?} strategy
     * @return {?}
     */
    MdAutocompleteTrigger.prototype._subscribeToPositionChanges = function (strategy) {
        var _this = this;
        this._panelPositionSubscription = strategy.onPositionChange.subscribe(function (change) {
            _this.autocomplete.positionY = change.connectionPair.originY === 'top' ? 'above' : 'below';
        });
    };
    /**
     * Returns the width of the input element, so the panel width can match it.
     * @return {?}
     */
    MdAutocompleteTrigger.prototype._getHostWidth = function () {
        return this._element.nativeElement.getBoundingClientRect().width;
    };
    /**
     * Reset active item to null so arrow events will activate the correct options.
     * @return {?}
     */
    MdAutocompleteTrigger.prototype._resetActiveItem = function () {
        this.autocomplete._keyManager.setActiveItem(null);
    };
    /**
     * Resets the active item and re-calculates alignment of the panel in case its size
     * has changed due to fewer or greater number of options.
     * @return {?}
     */
    MdAutocompleteTrigger.prototype._resetPanel = function () {
        this._resetActiveItem();
        this._positionStrategy.recalculateLastPosition();
        this.autocomplete._setVisibility();
    };
    return MdAutocompleteTrigger;
}());
MdAutocompleteTrigger.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                selector: 'input[mdAutocomplete], input[matAutocomplete]',
                host: {
                    'role': 'combobox',
                    'autocomplete': 'off',
                    'aria-autocomplete': 'list',
                    'aria-multiline': 'false',
                    '[attr.aria-activedescendant]': 'activeOption?.id',
                    '[attr.aria-expanded]': 'panelOpen.toString()',
                    '[attr.aria-owns]': 'autocomplete?.id',
                    '(focus)': 'openPanel()',
                    '(blur)': '_handleBlur($event.relatedTarget?.tagName)',
                    '(input)': '_handleInput($event)',
                    '(keydown)': '_handleKeydown($event)',
                },
                providers: [MD_AUTOCOMPLETE_VALUE_ACCESSOR]
            },] },
];
/**
 * @nocollapse
 */
MdAutocompleteTrigger.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
    { type: Overlay, },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ViewContainerRef"], },
    { type: Dir, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] },] },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgZone"], },
    { type: MdInputContainer, decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Host"] },] },
]; };
MdAutocompleteTrigger.propDecorators = {
    'autocomplete': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['mdAutocomplete',] },],
    '_matAutocomplete': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['matAutocomplete',] },],
};
var MdAutocompleteModule = (function () {
    function MdAutocompleteModule() {
    }
    /**
     * @deprecated
     * @return {?}
     */
    MdAutocompleteModule.forRoot = function () {
        return {
            ngModule: MdAutocompleteModule,
            providers: [OVERLAY_PROVIDERS]
        };
    };
    return MdAutocompleteModule;
}());
MdAutocompleteModule.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{
                imports: [MdOptionModule, OverlayModule, CompatibilityModule, __WEBPACK_IMPORTED_MODULE_2__angular_common__["CommonModule"]],
                exports: [MdAutocomplete, MdOptionModule, MdAutocompleteTrigger, CompatibilityModule],
                declarations: [MdAutocomplete, MdAutocompleteTrigger],
            },] },
];
/**
 * @nocollapse
 */
MdAutocompleteModule.ctorParameters = function () { return []; };
var MATERIAL_MODULES = [
    MdAutocompleteModule,
    MdButtonModule,
    MdButtonToggleModule,
    MdCardModule,
    MdChipsModule,
    MdCheckboxModule,
    MdDialogModule,
    MdGridListModule,
    MdIconModule,
    MdInputModule,
    MdListModule,
    MdMenuModule,
    MdProgressBarModule,
    MdProgressSpinnerModule,
    MdRadioModule,
    MdRippleModule,
    MdSelectModule,
    MdSidenavModule,
    MdSliderModule,
    MdSlideToggleModule,
    MdSnackBarModule,
    MdTabsModule,
    MdToolbarModule,
    MdTooltipModule,
    OverlayModule,
    PortalModule,
    RtlModule,
    StyleModule,
    A11yModule,
    PlatformModule,
    CompatibilityModule,
    ObserveContentModule
];
/**
 * @deprecated
 */
var MaterialRootModule = (function () {
    function MaterialRootModule() {
    }
    return MaterialRootModule;
}());
MaterialRootModule.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{
                imports: [
                    MdAutocompleteModule.forRoot(),
                    MdButtonModule.forRoot(),
                    MdCardModule.forRoot(),
                    MdChipsModule.forRoot(),
                    MdCheckboxModule.forRoot(),
                    MdGridListModule.forRoot(),
                    MdInputModule.forRoot(),
                    MdListModule.forRoot(),
                    MdProgressBarModule.forRoot(),
                    MdProgressSpinnerModule.forRoot(),
                    MdRippleModule.forRoot(),
                    MdSelectModule.forRoot(),
                    MdSidenavModule.forRoot(),
                    MdTabsModule.forRoot(),
                    MdToolbarModule.forRoot(),
                    PortalModule.forRoot(),
                    RtlModule.forRoot(),
                    ObserveContentModule.forRoot(),
                    // These modules include providers.
                    A11yModule.forRoot(),
                    MdButtonToggleModule.forRoot(),
                    MdDialogModule.forRoot(),
                    MdIconModule.forRoot(),
                    MdMenuModule.forRoot(),
                    MdRadioModule.forRoot(),
                    MdSliderModule.forRoot(),
                    MdSlideToggleModule.forRoot(),
                    MdSnackBarModule.forRoot(),
                    MdTooltipModule.forRoot(),
                    PlatformModule.forRoot(),
                    OverlayModule.forRoot(),
                    CompatibilityModule.forRoot(),
                ],
                exports: MATERIAL_MODULES,
            },] },
];
/**
 * @nocollapse
 */
MaterialRootModule.ctorParameters = function () { return []; };
/**
 * @deprecated
 */
var MaterialModule = (function () {
    function MaterialModule() {
    }
    /**
     * @deprecated
     * @return {?}
     */
    MaterialModule.forRoot = function () {
        return { ngModule: MaterialRootModule };
    };
    return MaterialModule;
}());
MaterialModule.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{
                imports: MATERIAL_MODULES,
                exports: MATERIAL_MODULES,
            },] },
];
/**
 * @nocollapse
 */
MaterialModule.ctorParameters = function () { return []; };
/**
 * @module
 * @description
 * Entry point for all public APIs of Angular Material.
 */
/**
 * Generated bundle index. Do not edit.
 */



/***/ }),

/***/ "fdgs":
/***/ (function(module, exports) {

exports.config = {"status":true,"model":{"plazza":"true","released":1398178572,"title-en":"Chess Attack","module":"chessbase","summary":"5x6 chess variant","thumbnail":"attack-thumb.png","rules":{"en":"attack-rules.html"},"credits":{"en":"attack-credits.html"},"gameOptions":{"preventRepeat":true,"uctTransposition":"state","uctIgnoreLoop":false,"levelOptions":{"pieceValueFactor":1,"pieceValueRatioFactor":1,"posValueFactor":0.1,"averageDistKingFactor":-0.01,"castleFactor":0.1,"minorPiecesMovedFactor":0.1,"checkFactor":0.2,"endingKingFreedomFactor":0.01,"endingDistKingFactor":0.05,"distKingCornerFactor":0.1}},"obsolete":false,"js":["base-model.js","grid-geo-model.js","attack-model.js"],"levels":[{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"easy","label":"Easy","maxNodes":1000},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"fast","label":"Fast [1sec]","maxDuration":1,"isDefault":true},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"medium","label":"Medium","maxNodes":10000,"maxDuration":10},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"strong","label":"Strong","maxNodes":20000,"maxDuration":15}],"description":{"en":"attack-description.html"}},"view":{"title-en":"Chessbase view","module":"chessbase","xdView":true,"css":["chessbase.css"],"preferredRatio":1,"useShowMoves":true,"useNotation":true,"useAutoComplete":true,"defaultOptions":{"sounds":true,"moves":true,"notation":false,"autocomplete":false},"skins":[{"name":"skin3d","title":"3D Classic","3d":true,"preload":["smoothedfilegeo|0|/res/ring-target.js","image|/res/images/cancel.png","image|/res/images/wikipedia.png","smoothedfilegeo|0|/res/staunton/pawn/pawn-classic.js","image|/res/staunton/pawn/pawn-diffusemap.jpg","image|/res/staunton/pawn/pawn-normalmap.jpg","smoothedfilegeo|0|/res/staunton/knight/knight.js","image|/res/staunton/knight/knight-diffusemap.jpg","image|/res/staunton/knight/knight-normalmap.jpg","smoothedfilegeo|0|/res/staunton/bishop/bishop.js","image|/res/staunton/bishop/bishop-diffusemap.jpg","image|/res/staunton/bishop/bishop-normalmap.jpg","smoothedfilegeo|0|/res/staunton/rook/rook.js","image|/res/staunton/rook/rook-diffusemap.jpg","image|/res/staunton/rook/rook-normalmap.jpg","smoothedfilegeo|0|/res/staunton/queen/queen.js","image|/res/staunton/queen/queen-diffusemap.jpg","image|/res/staunton/queen/queen-normalmap.jpg","smoothedfilegeo|0|/res/staunton/king/king.js","image|/res/staunton/king/king-diffusemap.jpg","image|/res/staunton/king/king-normalmap.jpg"],"world":{"lightIntensity":1.3,"skyLightIntensity":1.2,"lightCastShadow":true,"fog":false,"color":4686804,"lightPosition":{"x":-9,"y":9,"z":9},"skyLightPosition":{"x":9,"y":9,"z":9},"lightShadowDarkness":0.55,"ambientLightColor":2236962},"camera":{"fov":45,"distMax":50,"radius":18,"elevationAngle":60,"elevationMin":0}},{"name":"skin2d","title":"2D Classic","3d":false,"preload":["image|/res/images/cancel.png","image|/res/images/whitebg.png","image|/res/images/wikipedia.png"]}],"animateSelfMoves":false,"switchable":true,"sounds":{"move1":"alq_move1","move2":"alq_move2","move3":"alq_move3","move4":"alq_move2","tac1":"alq_tac1","tac2":"alq_tac2","tac3":"alq_tac1","promo":"promo","usermove":null},"js":["base-view.js","grid-board-view.js","staunton-set-view.js","attack-view.js"],"visuals":{"600x600":["res/visuals/attack-600x600-3d.jpg","res/visuals/attack-600x600-2d.jpg"]}}}

/***/ }),

/***/ "fiy1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var withLatestFrom_1 = __webpack_require__("u2wr");
Observable_1.Observable.prototype.withLatestFrom = withLatestFrom_1.withLatestFrom;
//# sourceMappingURL=withLatestFrom.js.map

/***/ }),

/***/ "fjbf":
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
var stylesInDom = {},
	memoize = function(fn) {
		var memo;
		return function () {
			if (typeof memo === "undefined") memo = fn.apply(this, arguments);
			return memo;
		};
	},
	isOldIE = memoize(function() {
		return /msie [6-9]\b/.test(self.navigator.userAgent.toLowerCase());
	}),
	getHeadElement = memoize(function () {
		return document.head || document.getElementsByTagName("head")[0];
	}),
	singletonElement = null,
	singletonCounter = 0,
	styleElementsInsertedAtTop = [];

module.exports = function(list, options) {
	if(typeof DEBUG !== "undefined" && DEBUG) {
		if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};
	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (typeof options.singleton === "undefined") options.singleton = isOldIE();

	// By default, add <style> tags to the bottom of <head>.
	if (typeof options.insertAt === "undefined") options.insertAt = "bottom";

	var styles = listToStyles(list);
	addStylesToDom(styles, options);

	return function update(newList) {
		var mayRemove = [];
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			domStyle.refs--;
			mayRemove.push(domStyle);
		}
		if(newList) {
			var newStyles = listToStyles(newList);
			addStylesToDom(newStyles, options);
		}
		for(var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];
			if(domStyle.refs === 0) {
				for(var j = 0; j < domStyle.parts.length; j++)
					domStyle.parts[j]();
				delete stylesInDom[domStyle.id];
			}
		}
	};
}

function addStylesToDom(styles, options) {
	for(var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];
		if(domStyle) {
			domStyle.refs++;
			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}
			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];
			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}
			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles(list) {
	var styles = [];
	var newStyles = {};
	for(var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};
		if(!newStyles[id])
			styles.push(newStyles[id] = {id: id, parts: [part]});
		else
			newStyles[id].parts.push(part);
	}
	return styles;
}

function insertStyleElement(options, styleElement) {
	var head = getHeadElement();
	var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
	if (options.insertAt === "top") {
		if(!lastStyleElementInsertedAtTop) {
			head.insertBefore(styleElement, head.firstChild);
		} else if(lastStyleElementInsertedAtTop.nextSibling) {
			head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			head.appendChild(styleElement);
		}
		styleElementsInsertedAtTop.push(styleElement);
	} else if (options.insertAt === "bottom") {
		head.appendChild(styleElement);
	} else {
		throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
	}
}

function removeStyleElement(styleElement) {
	styleElement.parentNode.removeChild(styleElement);
	var idx = styleElementsInsertedAtTop.indexOf(styleElement);
	if(idx >= 0) {
		styleElementsInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement(options) {
	var styleElement = document.createElement("style");
	styleElement.type = "text/css";
	insertStyleElement(options, styleElement);
	return styleElement;
}

function createLinkElement(options) {
	var linkElement = document.createElement("link");
	linkElement.rel = "stylesheet";
	insertStyleElement(options, linkElement);
	return linkElement;
}

function addStyle(obj, options) {
	var styleElement, update, remove;

	if (options.singleton) {
		var styleIndex = singletonCounter++;
		styleElement = singletonElement || (singletonElement = createStyleElement(options));
		update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
		remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
	} else if(obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function") {
		styleElement = createLinkElement(options);
		update = updateLink.bind(null, styleElement);
		remove = function() {
			removeStyleElement(styleElement);
			if(styleElement.href)
				URL.revokeObjectURL(styleElement.href);
		};
	} else {
		styleElement = createStyleElement(options);
		update = applyToTag.bind(null, styleElement);
		remove = function() {
			removeStyleElement(styleElement);
		};
	}

	update(obj);

	return function updateStyle(newObj) {
		if(newObj) {
			if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
				return;
			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;
		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag(styleElement, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (styleElement.styleSheet) {
		styleElement.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = styleElement.childNodes;
		if (childNodes[index]) styleElement.removeChild(childNodes[index]);
		if (childNodes.length) {
			styleElement.insertBefore(cssNode, childNodes[index]);
		} else {
			styleElement.appendChild(cssNode);
		}
	}
}

function applyToTag(styleElement, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		styleElement.setAttribute("media", media)
	}

	if(styleElement.styleSheet) {
		styleElement.styleSheet.cssText = css;
	} else {
		while(styleElement.firstChild) {
			styleElement.removeChild(styleElement.firstChild);
		}
		styleElement.appendChild(document.createTextNode(css));
	}
}

function updateLink(linkElement, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	if(sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = linkElement.href;

	linkElement.href = URL.createObjectURL(blob);

	if(oldSrc)
		URL.revokeObjectURL(oldSrc);
}


/***/ }),

/***/ "foLR":
/***/ (function(module, exports) {

exports.config = {"status":true,"model":{"plazza":"true","title-en":"Torus 4","module":"fourinarow","js":["fiarbase-model.js"],"summary":"Four In A Row on a cylinder","thumbnail":"fiar-torus-thumb.png","rules":{"en":"rules.html","fr":"rules-fr.html"},"description":{"en":"description.html","fr":"description-fr.html"},"credits":{"en":"credits.html","fr":"credits-fr.html"},"gameOptions":{"width":9,"height":6,"lines":4,"remove":false,"levelOptions":{"evalTuple1":1,"evalTuple2":2,"evalTuple3":4,"evalTuple4":8,"evalTuple5":16,"evalTuple6":32},"uctTransposition":"state","torus":true},"levels":[{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.55,"ignoreLeaf":false,"name":"easy","label":"Easy","maxNodes":1000,"isDefault":true},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.55,"ignoreLeaf":false,"name":"fast","label":"Fast [1sec]","maxDuration":1},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.55,"ignoreLeaf":false,"name":"strong","label":"Strong","maxNodes":10000}]},"view":{"title-en":"Four In A Row View","module":"fourinarow","js":["fiarbase-xd-view.js"],"xdView":true,"css":["fiarbase.css"],"preferredRatio":1,"useShowMoves":false,"useNotation":true,"sounds":{"sound1":"sound1","sound2":"sound2"},"defaultOptions":{"sounds":true,"moves":true,"notation":false},"skins":[{"name":"fiar3d","title":"3D Classic","3d":true,"camera":{"radius":20,"limitCamMoves":true,"rotationAngle":180,"elevationAngle":0,"elevationMin":-89,"elevationMax":89,"distMax":30},"world":{"lightIntensity":0.2,"skyLightIntensity":0.2,"lightCastShadow":false,"fog":true,"color":0,"lightPosition":{"x":10,"y":5,"z":0},"lightShadowDarkness":0.55,"ambientLightColor":2236996},"preload":["map|/res/xd-view/meshes/connect4-red-star.png","map|/res/xd-view/meshes/connect4-red.png","map|/res/xd-view/meshes/connect4-yellow-star.png","map|/res/xd-view/meshes/connect4-yellow.png","smoothedfilegeo|0|/res/xd-view/meshes/connect4cell.js","smoothedfilegeo|0|/res/xd-view/meshes/connect4cell-ring-smoothed.js","smoothedfilegeo|0|/res/xd-view/meshes/connect4-token.js","smoothedfilegeo|0|/res/xd-view/meshes/connect4cell-foot.js"]},{"name":"fiar2d","title":"2D Classic","3d":false,"preload":["image|/res/sprites2d.png"]}],"animateSelfMoves":false,"visuals":{"600x600":["res/visuals/torus4-600x600-3d.jpg","res/visuals/torus4-600x600-2d.jpg"]}}}

/***/ }),

/***/ "ftJA":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Observable_1 = __webpack_require__("rCTf");
var asap_1 = __webpack_require__("Uqs8");
var isNumeric_1 = __webpack_require__("P3oE");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var SubscribeOnObservable = (function (_super) {
    __extends(SubscribeOnObservable, _super);
    function SubscribeOnObservable(source, delayTime, scheduler) {
        if (delayTime === void 0) { delayTime = 0; }
        if (scheduler === void 0) { scheduler = asap_1.asap; }
        _super.call(this);
        this.source = source;
        this.delayTime = delayTime;
        this.scheduler = scheduler;
        if (!isNumeric_1.isNumeric(delayTime) || delayTime < 0) {
            this.delayTime = 0;
        }
        if (!scheduler || typeof scheduler.schedule !== 'function') {
            this.scheduler = asap_1.asap;
        }
    }
    SubscribeOnObservable.create = function (source, delay, scheduler) {
        if (delay === void 0) { delay = 0; }
        if (scheduler === void 0) { scheduler = asap_1.asap; }
        return new SubscribeOnObservable(source, delay, scheduler);
    };
    SubscribeOnObservable.dispatch = function (arg) {
        var source = arg.source, subscriber = arg.subscriber;
        return this.add(source.subscribe(subscriber));
    };
    SubscribeOnObservable.prototype._subscribe = function (subscriber) {
        var delay = this.delayTime;
        var source = this.source;
        var scheduler = this.scheduler;
        return scheduler.schedule(SubscribeOnObservable.dispatch, delay, {
            source: source, subscriber: subscriber
        });
    };
    return SubscribeOnObservable;
}(Observable_1.Observable));
exports.SubscribeOnObservable = SubscribeOnObservable;
//# sourceMappingURL=SubscribeOnObservable.js.map

/***/ }),

/***/ "fuE2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export RESPONSIVE_ALIASES */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_BREAKPOINTS; });
var RESPONSIVE_ALIASES = [
    'xs', 'gt-xs', 'sm', 'gt-sm', 'md', 'gt-md', 'lg', 'gt-lg', 'xl'
];
var DEFAULT_BREAKPOINTS = [
    {
        alias: 'xs',
        mediaQuery: 'screen and (max-width: 599px)'
    },
    {
        alias: 'gt-xs',
        overlapping: true,
        mediaQuery: 'screen and (min-width: 600px)'
    },
    {
        alias: 'lt-sm',
        overlapping: true,
        mediaQuery: 'screen and (max-width: 599px)'
    },
    {
        alias: 'sm',
        mediaQuery: 'screen and (min-width: 600px) and (max-width: 959px)'
    },
    {
        alias: 'gt-sm',
        overlapping: true,
        mediaQuery: 'screen and (min-width: 960px)'
    },
    {
        alias: 'lt-md',
        overlapping: true,
        mediaQuery: 'screen and (max-width: 959px)'
    },
    {
        alias: 'md',
        mediaQuery: 'screen and (min-width: 960px) and (max-width: 1279px)'
    },
    {
        alias: 'gt-md',
        overlapping: true,
        mediaQuery: 'screen and (min-width: 1280px)'
    },
    {
        alias: 'lt-lg',
        overlapping: true,
        mediaQuery: 'screen and (max-width: 1279px)'
    },
    {
        alias: 'lg',
        mediaQuery: 'screen and (min-width: 1280px) and (max-width: 1919px)'
    },
    {
        alias: 'gt-lg',
        overlapping: true,
        mediaQuery: 'screen and (min-width: 1920px)'
    },
    {
        alias: 'lt-xl',
        overlapping: true,
        mediaQuery: 'screen and (max-width: 1920px)'
    },
    {
        alias: 'xl',
        mediaQuery: 'screen and (min-width: 1920px) and (max-width: 5000px)'
    }
];
//# sourceMappingURL=break-points.js.map

/***/ }),

/***/ "fuZx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function isDate(value) {
    return value instanceof Date && !isNaN(+value);
}
exports.isDate = isDate;
//# sourceMappingURL=isDate.js.map

/***/ }),

/***/ "g+RA":
/***/ (function(module, exports) {

exports.model=Model={Game:{},Board:{},Move:{}},function(){var t;Model.Game.cbConstants={MASK:65535,FLAG_MOVE:65536,FLAG_CAPTURE:131072,FLAG_STOP:262144,FLAG_SCREEN_CAPTURE:524288,FLAG_CAPTURE_KING:1048576,FLAG_CAPTURE_NO_KING:2097152};var e="undefined"!=typeof Int32Array;Model.Game.cbUseTypedArrays=e,Model.Game.cbTypedArray=function(t){if(e){var r=new Int32Array(t.length);return r.set(t),r}for(var i=[],a=t.length,n=0;n<a;n++)i.push(t[n]);return i},Model.Game.cbShortRangeGraph=function(t,e,r,i){var a=this;void 0===i&&(i=196608);for(var n={},s=0;s<t.boardSize;s++)n[s]=[],(!r||s in r)&&e.forEach(function(e){var o=t.Graph(s,e);null!=o&&(!r||o in r)&&n[s].push(a.cbTypedArray([o|i]))});return n},Model.Game.cbLongRangeGraph=function(t,e,r,i,a){var n=this;void 0!==i&&null!=i||(i=196608),a||(a=1/0);for(var s={},o=0;o<t.boardSize;o++)s[o]=[],(!r||o in r)&&e.forEach(function(e){for(var h=[],c=t.Graph(o,e),p=0;null!=c&&(!r||c in r)&&(h.push(c|i),++p!=a);)c=t.Graph(c,e);h.length>0&&s[o].push(n.cbTypedArray(h))});return s},Model.Game.cbNullGraph=function(t){for(var e={},r=0;r<t.boardSize;r++)e[r]=[];return e},Model.Game.cbAuthorGraph=function(t){for(var e={},r=0;r<t.boardSize;r++){e[r]=[];for(var i=0;i<t.boardSize;i++)e[r].push([2293760|i])}return e},Model.Game.cbMergeGraphs=function(t){for(var e=[],r=0;r<t.boardSize;r++){e[r]=[];for(var i=1;i<arguments.length;i++)e[r]=e[r].concat(arguments[i][r])}return e},Model.Game.cbGetThreatGraph=function(){function t(e,r){for(var i in s){var a=s[i];if(!(a.p.length<r.length+1)){for(var n=!0,o=0;o<r.length;o++)if(r[o]!=a.p[o]){n=!1;break}if(n){var h=a.p[r.length],c=e[h];void 0===c&&(c={e:{}},e[h]=c),a.p.length==r.length+1&&(c.t=a.t,c.ts=a.ts,c.tk=a.tk,delete s[i]),r.push(h),t(c.e,r),r.pop()}}}}var e=this;this.cbUseScreenCapture=!1,this.cbUseCaptureKing=!1,this.cbUseCaptureNoKing=!1;for(var r={1:[],"-1":[]},i=[],a=0;a<this.g.boardSize;a++)this.g.pTypes.forEach(function(t,r){t.graph[a].forEach(function(t){for(var n=[],s=0;s<t.length;s++){var o=t[s];1048576&o?(e.cbUseCaptureKing=!0,n.unshift({d:65535&o,a:a,tk:r})):2097152&o?(e.cbUseCaptureNoKing=!0,n.unshift({d:65535&o,a:a,tnk:r})):131072&o?n.unshift({d:65535&o,a:a,t:r}):262144&o?n.unshift({d:65535&o,a:a}):524288&o&&(e.cbUseScreenCapture=!0,n.unshift({d:65535&o,a:a,ts:r}))}n.length>0&&i.push(n)})});var n={};i.forEach(function(t){t.forEach(function(e,r){var i=n[e.d];void 0===i&&(i={},n[e.d]=i);for(var a=[],s=r+1;s<t.length;s++)a.push(t[s].d);a.push(e.a);var o=a.join(","),h=i[o];void 0===h&&(h={p:a,t:{},ts:{},tk:{}},i[o]=h),void 0!==e.t?h.t[e.t]=!0:void 0!==e.tk?h.tk[e.tk]=!0:void 0!==e.ts&&(h.ts[e.ts]=!0)})});for(var a=0;a<e.g.boardSize;a++){var s=n[a],o={};t(o,[]),r[1][a]=o,r[-1][a]=o}return r},Model.Game.InitGame=function(){var e=this;this.cbVar=t=this.cbDefine(),this.g.boardSize=this.cbVar.geometry.boardSize,this.g.pTypes=this.cbGetPieceTypes(),this.g.threatGraph=this.cbGetThreatGraph(),this.g.distGraph=this.cbVar.geometry.GetDistances(),this.cbPiecesCount=0,this.g.castleablePiecesCount={1:0,"-1":0};for(var r in t.pieceTypes){var i=t.pieceTypes[r];if(i.castle){(i.initial||[]).forEach(function(t){e.g.castleablePiecesCount[t.s]++})}i.initial&&(this.cbPiecesCount+=i.initial.length)}for(var a=[],r=0;r<this.cbPiecesCount;r++)a.push(r);var n=Object.keys(t.pieceTypes);this.zobrist=new JocGame.Zobrist({board:{type:"array",size:this.cbVar.geometry.boardSize,values:a},who:{values:["1","-1"]},type:{type:"array",size:this.cbPiecesCount,values:n}})},Model.Game.cbGetPieceTypes=function(){for(var t=[],e={},r=0;r<this.cbVar.geometry.boardSize;r++)e[r]=[];for(var i in this.cbVar.pieceTypes){var a=this.cbVar.pieceTypes[i];t[i]={graph:a.graph||e,abbrev:a.abbrev||"",value:a.isKing?100:a.value||1,isKing:!!a.isKing,castle:!!a.castle,epTarget:!!a.epTarget,epCatch:!!a.epCatch}}return t},Model.Board.Init=function(t){this.zSign=0},Model.Board.InitialPosition=function(r){var i=this;this.board=e?new Int16Array(r.g.boardSize):[];for(var a=0;a<r.g.boardSize;a++)this.board[a]=-1;if(this.kings={},this.pieces=[],this.ending={1:!1,"-1":!1},this.lastMove=null,r.cbVar.castle&&(this.castled={1:!1,"-1":!1}),this.zSign=r.zobrist.update(0,"who",-1),this.noCaptCount=0,this.mWho=1,r.mInitial)this.mWho=r.mInitial.turn||1,r.mInitial.pieces.forEach(function(t){var e={};for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);i.pieces.push(e)}),r.mInitial.lastMove&&(this.lastMove={f:r.mInitial.lastMove.f,t:r.mInitial.lastMove.t}),void 0!==r.mInitial.noCaptCount&&(this.noCaptCount=r.mInitial.noCaptCount),r.cbVar.castle&&r.mInitial.castle&&(this.castled={1:{k:!!r.mInitial.castle[1]&&!!r.mInitial.castle[1].k,q:!!r.mInitial.castle[1]&&!!r.mInitial.castle[1].q},"-1":{k:!!r.mInitial.castle[-1]&&!!r.mInitial.castle[-1].k,q:!!r.mInitial.castle[-1]&&!!r.mInitial.castle[-1].q}});else for(var n in r.cbVar.pieceTypes)for(var s=r.cbVar.pieceTypes[n],o=s.initial||[],h=0;h<o.length;h++){var c=o[h],p={s:c.s,t:parseInt(n),p:c.p,m:!1};this.pieces.push(p)}if(this.pieces.sort(function(t,e){if(t.s!=e.s)return e.s-t.s;var i=r.cbVar.pieceTypes[t.t].value||100,a=r.cbVar.pieceTypes[e.t].value||100;return i!=a?i-a:t.p-e.p}),this.pieces.forEach(function(t,e){t.i=e,i.board[t.p]=e,r.g.pTypes[t.t].isKing&&(i.kings[t.s]=t.p),i.zSign=r.zobrist.update(i.zSign,"board",e,t.p),i.zSign=r.zobrist.update(i.zSign,"type",t.t,e)}),r.mInitial&&r.mInitial.enPassant){var a=t.geometry.PosByName(r.mInitial.enPassant);if(a>=0){var l,u=t.geometry.C(a),v=t.geometry.R(a);l=1==r.mInitial.turn?t.geometry.POS(u,v-1):t.geometry.POS(u,v+1),this.epTarget={p:a,i:this.board[l]}}}},Model.Board.CopyFrom=function(t){if(e)this.board=new Int16Array(t.board.length),this.board.set(t.board);else{this.board=[];for(var r=t.board,i=r.length,a=0;a<i;a++)this.board.push(r[a])}this.pieces=[];for(var n=t.pieces.length,a=0;a<n;a++){var s=t.pieces[a];this.pieces.push({s:s.s,p:s.p,t:s.t,i:s.i,m:s.m})}this.kings={1:t.kings[1],"-1":t.kings[-1]},this.check=t.check,t.lastMove?this.lastMove={f:t.lastMove.f,t:t.lastMove.t,c:t.lastMove.c}:this.lastMove=null,this.ending={1:t.ending[1],"-1":t.ending[-1]},void 0!==t.castled&&(this.castled={1:t.castled[1],"-1":t.castled[-1]}),this.noCaptCount=t.noCaptCount,t.epTarget?this.epTarget={p:t.epTarget.p,i:t.epTarget.i}:this.epTarget=null,this.mWho=t.mWho,this.zSign=t.zSign},Model.Board.cbApplyCastle=function(t,e,r){var i=t.cbVar.castle[e.f+"/"+e.cg],a=i.r[i.r.length-1],n=this.pieces[this.board[e.cg]],s=i.k[i.k.length-1],o=this.pieces[this.board[e.f]];return r&&(this.zSign=t.zobrist.update(this.zSign,"board",n.i,e.cg),this.zSign=t.zobrist.update(this.zSign,"board",n.i,a),this.zSign=t.zobrist.update(this.zSign,"board",o.i,e.f),this.zSign=t.zobrist.update(this.zSign,"board",o.i,s)),n.p=a,n.m=!0,this.board[e.cg]=-1,o.p=s,o.m=!0,this.board[e.f]=-1,this.board[a]=n.i,this.board[s]=o.i,this.castled[n.s]=!0,this.kings[o.s]=s,[{i:n.i,f:a,t:-1},{i:o.i,f:s,t:e.f,kp:e.f,who:o.s,m:!1},{i:n.i,f:-1,t:e.cg,m:!1,cg:!1}]},Model.Board.cbQuickApply=function(t,e){if(void 0!==e.cg)return this.cbApplyCastle(t,e,!1);var r=[],i=this.board[e.f],a=this.pieces[i];if(null!=e.c){r.unshift({i:e.c,f:-1,t:this.pieces[e.c].p});var n=this.pieces[e.c];this.board[n.p]=-1,n.p=-1}var s=this.kings[a.s];return t.g.pTypes[a.t].isKing&&(this.kings[a.s]=e.t),r.unshift({i:i,f:e.t,t:e.f,kp:s,who:a.s,ty:a.t}),a.p=e.t,void 0!==e.pr&&(a.t=e.pr),this.board[e.f]=-1,this.board[e.t]=i,r},Model.Board.cbQuickUnapply=function(t,e){for(var r=0;r<e.length;r++){var i=e[r],a=this.pieces[i.i];i.f>=0&&(a.p=-1,this.board[i.f]=-1),i.t>=0&&(a.p=i.t,this.board[i.t]=i.i),void 0!==i.m&&(a.m=i.m),void 0!==i.kp&&(this.kings[i.who]=i.kp),void 0!=i.ty&&(a.t=i.ty),void 0!=i.cg&&(this.castled[a.s]=i.cg)}},Model.Board.ApplyMove=function(t,e){var r=this.pieces[this.board[e.f]];if(void 0!==e.cg)this.cbApplyCastle(t,e,!0);else{if(this.zSign=t.zobrist.update(this.zSign,"board",r.i,e.f),this.board[r.p]=-1,void 0!==e.pr&&(this.zSign=t.zobrist.update(this.zSign,"type",r.t,r.i),r.t=e.pr,this.zSign=t.zobrist.update(this.zSign,"type",r.t,r.i)),null!=e.c){var i=this.pieces[e.c];this.zSign=t.zobrist.update(this.zSign,"board",i.i,i.p),this.board[i.p]=-1,i.p=-1,i.m=!0,this.noCaptCount=0}else this.noCaptCount++;r.p=e.t,r.m=!0,this.board[e.t]=r.i,this.zSign=t.zobrist.update(this.zSign,"board",r.i,e.t),t.g.pTypes[r.t].isKing&&(this.kings[r.s]=e.t)}this.check=!!e.ck,this.lastMove={f:e.f,t:e.t,c:e.c},void 0!==e.ko&&(this.ending[r.s]=e.ko),void 0!==e.ept?this.epTarget={p:e.ept,i:r.i}:this.epTarget=null,this.zSign=t.zobrist.update(this.zSign,"who",-this.mWho),this.zSign=t.zobrist.update(this.zSign,"who",this.mWho)},Model.Board.Evaluate=function(r){function i(e){var r=1/0;for(var i in t.geometry.corners)r=Math.min(r,h.distGraph[n.kings[e]][i]);return r-Math.sqrt(h.boardSize)}var a="debug"==arguments[3],n=this;this.mEvaluation=0;var s,o=this.mWho,h=r.g;if(e)s={1:{count:new Uint8Array(h.pTypes.length),byType:{}},"-1":{count:new Uint8Array(h.pTypes.length),byType:{}}};else{s={1:{count:[],byType:{}},"-1":{count:[],byType:{}}};for(var c=0;c<h.pTypes.length;c++)s[1].count[c]=s[-1].count[c]=0}if(r.mOptions.preventRepeat&&r.GetRepeatOccurence(this)>2)return this.mFinished=!0,void(this.mWinner=r.cbOnPerpetual?o*r.cbOnPerpetual:JocGame.DRAW);for(var p={1:0,"-1":0},l={1:h.distGraph[this.kings[-1]],"-1":h.distGraph[this.kings[1]]},u={1:0,"-1":0},v={1:0,"-1":0},f={1:0,"-1":0},b={1:0,"-1":0},d={1:!1,"-1":!1},g=this.pieces,m=g.length,c=0;c<m;c++){var G=g[c];if(G.p>=0){var y=G.s,M=h.pTypes[G.t];M.isKing?d[y]=G.m:p[y]+=M.value,M.castle&&!G.m&&b[y]++,v[y]++,u[y]+=l[y][G.p],f[y]+=t.geometry.distEdge[G.p];var C=s[y];C.count[G.t]++;var S=C.byType;void 0===S[G.t]?S[G.t]=[G]:S[G.t].push(G)}}if(this.lastMove&&null!=this.lastMove.c){var G=this.pieces[this.board[this.lastMove.t]];p[-G.s]+=this.cbStaticExchangeEval(r,G.p,G.s,{piece:G})}var k={1:0,"-1":0},A={1:0,"-1":0},T={1:0,"-1":0};this.ending[1]&&(A[1]=(u[1]-Math.sqrt(h.boardSize))/v[1],t.geometry.corners&&(T[1]=i(1))),this.ending[-1]&&(A[-1]=(u[-1]-Math.sqrt(h.boardSize))/v[-1],t.geometry.corners&&(T[1]=i(-1)));var z={pieceValue:p[1]-p[-1],pieceValueRatio:(p[1]-p[-1])/(p[1]+p[-1]+1),posValue:f[1]-f[-1],averageDistKing:u[1]/v[1]-u[-1]/v[-1],check:this.check?-o:0,endingKingFreedom:k[1]-k[-1],endingDistKing:A[1]-A[-1],distKingCorner:T[1]-T[-1]};t.castle&&(z.castle=(this.castled[1]?1:d[1]?0:b[1]/(h.castleablePiecesCount[1]+1))-(this.castled[-1]?1:d[-1]?0:b[-1]/(h.castleablePiecesCount[-1]+1))),t.evaluate&&t.evaluate.call(this,r,z,s);var P=r.mOptions.levelOptions;for(var E in z){var R=z[E],w=P[E+"Factor"]||0,I=R*w;a&&console.log(E,"=",R,"*",w,"=>",I),this.mEvaluation+=I}a&&console.log("Evaluation",this.mEvaluation)},Model.Board.cbGeneratePseudoLegalMoves=function(t){function e(e,a){var n=t.cbVar.promote;if(!n)return void i.push(a);var s=n.call(r,t,e,a);if(null!=s)if(0==s.length)i.push(a);else if(1==s.length)a.pr=s[0],i.push(a);else for(var o=0;o<s.length;o++){var h=s[o];i.push({f:a.f,t:a.t,c:a.c,pr:h,ept:a.ept,ep:a.ep,a:a.a})}}for(var r=this,i=[],a=t.cbVar,n=this.mWho,s=!a.castle||this.check||this.castled[n]?null:[],o=-1,h=this.pieces.length,c=0;c<h;c++){var p=this.pieces[c];if(!(p.p<0||p.s!=n)){var l=t.g.pTypes[p.t];l.isKing&&(p.m?s=null:o=p),s&&l.castle&&!p.m&&s.push(p);var u,v;u=l.graph[p.p],v=u.length;for(var f=0;f<v;f++)for(var b=u[f],d=!1,g=b.length,m=null,G=0;G<g;G++){var y=b[G],M=65535&y,C=this.board[M];if(!(C<0)||l.epCatch&&this.epTarget&&this.epTarget.p==M){if(!(524288&y)){var S;S=C<0?this.pieces[this.epTarget.i]:this.pieces[C],!(S.s!=p.s&&131072&y)||1048576&y&&!t.g.pTypes[S.t].isKing||2097152&y&&t.g.pTypes[S.t].isKing||e(p,{f:p.p,t:M,c:S.i,a:l.abbrev,ep:C<0});break}if(d){var S=this.pieces[C];S.s!=p.s&&e(p,{f:p.p,t:M,c:S.i,a:l.abbrev});break}d=!0}else 65536&y&&0==d&&e(p,{f:p.p,t:M,c:null,a:l.abbrev,ept:null!=m&&l.epTarget?m:void 0});m=M}}}if(s)for(var c=0;c<s.length;c++){var k=s[c],A=t.cbVar.castle[o.p+"/"+k.p];if(A){for(var T=!0,f=0;f<A.r.length;f++){var z=A.r[f];if(this.board[z]>=0&&z!=o.p&&z!=k.p){T=!1;break}}if(T){for(var P=!0,f=0;f<A.k.length;f++){var z=A.k[f];if(this.board[z]>=0&&z!=k.p&&z!=o.p||this.cbGetAttackers(t,z,n).length>0){P=!1;break}}P&&i.push({f:o.p,t:A.k[A.k.length-1],c:null,cg:k.p})}}}return i},Model.Board.cbStaticExchangeEval=function(t,e,r,i){var a=0,n=this.cbGetSmallestAttacker(t,e,r);if(n){var s=this.mWho;this.mWho=n.s;var o=this.cbQuickApply(t,{f:n.p,t:e,c:i.piece.i}),h=t.g.pTypes[i.piece.t].value;i.piece=n,a=Math.max(0,h-this.cbStaticExchangeEval(t,e,-r,i)),this.cbQuickUnapply(t,o),this.mWho=s}return a},Model.Board.cbGetSmallestAttacker=function(t,e,r){var i=this.cbGetAttackers(t,e,r);if(0==i.length)return null;for(var a=1/0,n=null,s=i.length,o=0;o<s;o++){var h=i[o],c=t.g.pTypes[h.t].value;c<a&&(a=c,n=h)}return n},Model.Board.cbCollectAttackers=function(t,e,r,i){for(var a in e){var n=e[a],s=this.board[a];if(s<0)this.cbCollectAttackers(t,n.e,r,i);else{var o=this.pieces[s];o.s==-t&&(n.t&&o.t in n.t||i&&n.tk&&o.t in n.tk)&&r.push(o)}}},Model.Board.cbCollectAttackersScreen=function(t,e,r,i,a){for(var n in e){var s=e[n],o=this.board[n];if(o<0)this.cbCollectAttackersScreen(t,s.e,r,i,a);else{var h=this.pieces[o];!a&&h.s==-t&&(s.t&&h.t in s.t||i&&s.tk&&h.t in s.tk)?r.push(h):a?a&&h.s==-t&&s.ts&&h.t in s.ts&&r.push(h):this.cbCollectAttackersScreen(t,s.e,r,i,!0)}}},Model.Board.cbGetAttackers=function(t,e,r,i){var a=[];return t.cbUseScreenCapture?this.cbCollectAttackersScreen(r,t.g.threatGraph[r][e],a,i,!1):this.cbCollectAttackers(r,t.g.threatGraph[r][e],a,i),a},Model.Board.GenerateMoves=function(t){var e=this.cbGeneratePseudoLegalMoves(t);this.mMoves=[];for(var r=!0,i=this.kings[this.mWho],a=e.length,n=0;n<a;n++){var s=e[n],o=this.cbQuickApply(t,s);if(!(this.cbGetAttackers(t,this.kings[this.mWho],this.mWho,!0).length>0)){var h=this.cbGetAttackers(t,this.kings[-this.mWho],-this.mWho,!0).length>0;s.ck=h,this.mMoves.push(s),s.f!=i&&(r=!1)}this.cbQuickUnapply(t,o)}if(0==this.mMoves.length)this.mFinished=!0,this.mWinner=t.cbOnStaleMate?t.cbOnStaleMate*this.mWho:JocGame.DRAW,this.check&&(this.mWinner=-this.mWho);else if(this.ending[this.mWho]){if(!r)for(var n=0;n<this.mMoves.length;n++)this.mMoves[n].ko=!1}else if(!this.ending[this.mWho]&&r&&!this.check)for(var n=0;n<this.mMoves.length;n++)this.mMoves[n].ko=!0},Model.Board.GetSignature=function(){return this.zSign},Model.Move.Init=function(t){for(var e in t)t.hasOwnProperty(e)&&(this[e]=t[e])},Model.Move.Equals=function(t){return this.f==t.f&&this.t==t.t&&this.pr==t.pr},Model.Move.CopyFrom=function(t){this.Init(t)},Model.Move.ToString=function(e){var r=this;switch(e=e||"natural"){case"natural":return function(){var e;if(void 0!==r.cg?e=t.castle[r.f+"/"+r.cg].n:(e=r.a||"",e+=t.geometry.PosName(r.f),null==r.c?e+="-":e+="x",e+=t.geometry.PosName(r.t)),void 0!==r.pr){var i=t.pieceTypes[r.pr];i&&i.abbrev&&i.abbrev.length>0&&!i.silentPromo&&(e+="="+i.abbrev)}return r.ck&&(e+="+"),e}();case"engine":return function(){var e=t.geometry.PosName(r.f)+t.geometry.PosName(r.t);if(void 0!=r.pr){var i=t.pieceTypes[r.pr];i&&i.abbrev&&i.abbrev.length>0&&!i.silentPromo&&(e+=i.abbrev)}return e}();default:return"??"}},Model.Board.CompactMoveString=function(e,r,i){"function"!=typeof r.ToString&&(r=e.CreateMove(r));var a=r.ToString(),n=/^([A-Z]?)([a-z])([1-9][0-9]*)([-x])([a-z])([1-9][0-9]*)(.*?)$/.exec(a);if(!n)return a;var s=n[7];if(i||(i={}),i.value||(i.value=[]),0==i.value.length){var o=this.mMoves;this.mMoves&&0!=this.mMoves.length||this.GenerateMoves(e);for(var h=0;h<this.mMoves.length;h++){var c=this.mMoves[h];"function"!=typeof c.ToString&&(c=e.CreateMove(c)),i.value.push({str:c.ToString(),move:c})}this.mMoves=o}var p=[];if(i.value.forEach(function(t){var e=/^([A-Z]?[a-z][1-9][0-9]*[-x][a-z][1-9][0-9]*)(.*?)$/.exec(t.str);e&&t.move.t==r.t&&(t.move.a||"")==n[1]&&e[2]==s&&p.push(t.move)}),1==p.length)return""==n[1]&&"x"==n[4]?n[2]+"x"+n[5]+n[6]+n[7]:n[1]+("x"==n[4]?"x":"")+n[5]+n[6]+n[7];if(t.geometry.CompactCrit)for(var l="",h=0;;h++){var u=t.geometry.CompactCrit(r.f,h);if(null==u)return a;l+=u;for(var v=[],f=0;f<p.length;f++){var b=p[f];t.geometry.CompactCrit(b.f,h)==u&&v.push(b)}if(console.assert(v.length>0),1==v.length)return n[1]+l+("x"==n[4]?"x":"")+n[5]+n[6]+n[7];p=v}return a},Model.Board.cbIntegrity=function(t){function e(t,e){t||console.error(e)}for(var r=this,i=0;i<this.board.length;i++){var a=this.board[i];if(a>=0){var n=r.pieces[a];e(void 0!==n,"no piece at pos"),e(n.p==i,"piece has different pos")}}for(var a=0;a<this.pieces.length;a++){var n=this.pieces[a];n.p>=0&&e(r.board[n.p]==a,"board index mismatch")}},Model.Board.ExportBoardState=function(t){return t.cbVar.geometry.ExportBoardState?t.cbVar.geometry.ExportBoardState(this,t.cbVar,t.mPlayedMoves.length):"not supported"},Model.Game.Import=function(e,r){var i,a=[],n={1:{},"-1":{}},s=null,o=0;if("pjn"==e){var h={status:!1,error:"parse"},c=r.split(" ");if(6!=c.length)return console.warn("FEN should have 6 parts"),h;var p=c[0].split("/"),l=t.geometry.fenHeight||t.geometry.height;if(p.length!=l)return console.warn("FEN board should have",l,"rows, got",p.length),h;var u={};for(var v in t.pieceTypes){var f=t.pieceTypes[v],b=f.fenAbbrev||f.abbrev||"X";u[b.toUpperCase()]={s:1,t:v},u[b.toLowerCase()]={s:-1,t:v}}var d=t.geometry.FenRowPos||function(e,r){return(t.geometry.height-1-e)*t.geometry.width+r};if(p.forEach(function(e,r){for(var i=0,n=0;n<e.length;n++){var s=e.substr(n,1),o=u[s];if(void 0!==o){var c=d(r,i);i++;for(var p={s:o.s,t:o.t,p:c},l=!0,v=t.pieceTypes[p.t].initial||[],f=0;f<v.length;f++){var b=v[f];b.s==p.s&&b.p==c&&(l=!1)}p.m=l,a.push(p)}else{if(isNaN(parseInt(s)))return console.warn("FEN invalid board spec",s),h;i+=parseInt(s)}}}),a.sort(function(t,e){return e.s-t.s}),"w"==c[1])i=1;else{if("b"!=c[1])return console.warn("FEN invalid turn spec",c[1]),h;i=-1}n[1].k=c[2].indexOf("K")>=0,n[1].q=c[2].indexOf("Q")>=0,n[-1].k=c[2].indexOf("k")>=0,n[-1].q=c[2].indexOf("q")>=0,s="-"==c[3]?null:c[3];var g=parseInt(c[4]);isNaN(g)||(o=g);var m={pieces:a,turn:i,castle:n,enPassant:s,noCaptCount:o};return t.importGame&&t.importGame.call(this,m,e,r),{status:!0,initial:m}}return{status:!1,error:"unsupported"}}}(),function(){Model.Game.cbBoardGeometryGrid=function(t,e){function r(e){return e%t}function i(e){return Math.floor(e/t)}function a(e,r){return r*t+e}function n(n,s){var o=r(n),h=i(n),c=o+s[0],p=h+s[1];return c<0||c>=t||p<0||p>=e?null:a(c,p)}function s(t){return String.fromCharCode("a".charCodeAt(0)+r(t))+(i(t)+1)}function o(t){var e=/^([a-z])([0-9]+)$/.exec(t);return e?a(e[1].charCodeAt(0)-"a".charCodeAt(0),parseInt(e[2])-1):-1}function h(t,e){return 0==e?String.fromCharCode("a".charCodeAt(0)+r(t)):1==e?i(t)+1:null}function c(){for(var a=[],n=0;n<t*e;n++){var s=[];a.push(s);for(var o=0;o<t*e;o++){var h=i(n),c=r(n),p=i(o),l=r(o);s.push(Math.max(Math.abs(h-p),Math.abs(c-l)))}}return a}function p(r,i,n){for(var o=[],h=e-1;h>=0;h--){for(var c="",p=0,l=0;l<t;l++){var u=r.board[a(l,h)];if(u<0)p++;else{p>0&&(c+=p,p=0);var v=r.pieces[u],f=i.pieceTypes[v.t].fenAbbrev||i.pieceTypes[v.t].abbrev||"?";v.s==-1?c+=f.toLowerCase():c+=f.toUpperCase()}}p&&(c+=p),o.push(c)}var b=o.join("/");b+=" ",1==r.mWho?b+="w":b+="b",b+=" ";var d="";return r.castled&&(r.castled[1]===!1?d+="KQ":(r.castled[1].k&&(d+="K"),r.castled[1].q&&(d+="Q")),r.castled[-1]===!1?d+="kq":(r.castled[-1].k&&(d+="k"),r.castled[-1].q&&(d+="q"))),0==d.length&&(d="-"),b+=d,b+=" ",r.epTarget?b+=s(r.epTarget.p):b+="-",b+=" ",b+=r.noCaptCount,b+=" ",b+=Math.floor(n/2)+1}return{boardSize:t*e,width:t,height:e,C:r,R:i,POS:a,Graph:n,PosName:s,PosByName:o,CompactCrit:h,GetDistances:c,distEdge:function(){for(var a=[],n=0;n<t*e;n++){var s=r(n),o=i(n);a[n]=Math.min(s,Math.abs(t-s-1),o,Math.abs(e-o-1))}return a}(),corners:function(){var r={};return r[a(0,0)]=1,r[a(0,e-1)]=1,r[a(t-1,0)]=1,r[a(t-1,e-1)]=1,r}(),ExportBoardState:p}},Model.Game.cbPawnGraph=function(t,e,r){for(var i=this,a={},n=0;n<t.boardSize;n++)if(!r||n in r){var s=[],o=t.Graph(n,[0,e]);null!=o&&(!r||o in r)&&s.push(i.cbTypedArray([o|i.cbConstants.FLAG_MOVE])),[-1,1].forEach(function(a){var o=t.Graph(n,[a,e]);null!=o&&(!r||o in r)&&s.push(i.cbTypedArray([o|i.cbConstants.FLAG_CAPTURE]))}),a[n]=s}else a[n]=[];return a},Model.Game.cbInitialPawnGraph=function(t,e,r){for(var i=this,a={},n=0;n<t.boardSize;n++)if(!r||n in r){var s=[],o=t.Graph(n,[0,e]);if(null!=o&&(!r||o in r)){var h=[o|i.cbConstants.FLAG_MOVE],c=t.Graph(o,[0,e]);null!=c&&(!r||c in r)&&h.push(c|i.cbConstants.FLAG_MOVE),s.push(i.cbTypedArray(h))}[-1,1].forEach(function(a){var o=t.Graph(n,[a,e]);null!=o&&(!r||o in r)&&s.push(i.cbTypedArray([o|i.cbConstants.FLAG_CAPTURE]))}),a[n]=s}else a[n]=[];return a},Model.Game.cbKingGraph=function(t,e){return this.cbShortRangeGraph(t,[[-1,-1],[-1,0],[-1,1],[0,-1],[0,1],[1,-1],[1,0],[1,1]],e)},Model.Game.cbKnightGraph=function(t,e){return this.cbShortRangeGraph(t,[[2,-1],[2,1],[-2,-1],[-2,1],[-1,2],[-1,-2],[1,2],[1,-2]],e)},Model.Game.cbHorseGraph=function(t){for(var e=this,r={},i=0;i<t.boardSize;i++)r[i]=[],[[1,0,2,-1],[1,0,2,1],[-1,0,-2,-1],[-1,0,-2,1],[0,1,-1,2],[0,-1,-1,-2],[0,1,1,2],[0,-1,1,-2]].forEach(function(a){var n=t.Graph(i,[a[0],a[1]]);if(null!=n){var s=t.Graph(i,[a[2],a[3]]);null!=s&&r[i].push(e.cbTypedArray([n|e.cbConstants.FLAG_STOP,s|e.cbConstants.FLAG_MOVE|e.cbConstants.FLAG_CAPTURE]))}});return r},Model.Game.cbRookGraph=function(t,e){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0]],e)},Model.Game.cbBishopGraph=function(t,e){return this.cbLongRangeGraph(t,[[1,-1],[1,1],[-1,1],[-1,-1]],e)},Model.Game.cbQueenGraph=function(t,e){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0],[1,-1],[1,1],[-1,1],[-1,-1]],e)},Model.Game.cbXQGeneralGraph=function(t,e){for(var r=this,i={},a=0;a<t.boardSize;a++)i[a]=[],[[-1,0,!1],[0,-1,!0],[0,1,!0],[1,0,!1]].forEach(function(n){var s=[],o=t.Graph(a,n);if(null!=o&&((!e||o in e)&&s.push(o|r.cbConstants.FLAG_MOVE|r.cbConstants.FLAG_CAPTURE),n[2]))for(var h=t.Graph(o,n);null!=h;)!e||h in e?s.push(h|r.cbConstants.FLAG_CAPTURE|r.cbConstants.FLAG_CAPTURE_KING):s.push(h|r.cbConstants.FLAG_STOP),h=t.Graph(h,n);s.length>0&&i[a].push(r.cbTypedArray(s))});return i},Model.Game.cbXQSoldierGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e]])},Model.Game.cbXQPromoSoldierGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e],[-1,0],[1,0]])},Model.Game.cbXQAdvisorGraph=function(t,e){return this.cbShortRangeGraph(t,[[1,1],[-1,1],[1,-1],[-1,-1]],e)},Model.Game.cbXQCannonGraph=function(t){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0]],null,this.cbConstants.FLAG_MOVE|this.cbConstants.FLAG_SCREEN_CAPTURE)},Model.Game.cbXQElephantGraph=function(t,e){for(var r=this,i={},a=0;a<t.boardSize;a++)i[a]=[],(!e||a in e)&&[[1,1,2,2],[1,-1,2,-2],[-1,1,-2,2],[-1,-1,-2,-2]].forEach(function(n){var s=t.Graph(a,[n[0],n[1]]);if(null!=s){var o=t.Graph(a,[n[2],n[3]]);null!=o&&(!e||o in e)&&i[a].push(r.cbTypedArray([s|r.cbConstants.FLAG_STOP,o|r.cbConstants.FLAG_MOVE|r.cbConstants.FLAG_CAPTURE]))}});return i},Model.Game.cbSilverGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e],[-1,-1],[-1,1],[1,-1],[1,1]])},Model.Game.cbFersGraph=function(t,e){return this.cbShortRangeGraph(t,[[-1,-1],[-1,1],[1,-1],[1,1]])},Model.Game.cbSchleichGraph=function(t,e){return this.cbShortRangeGraph(t,[[-1,0],[1,0],[0,-1],[0,1]])},Model.Game.cbAlfilGraph=function(t,e){return this.cbShortRangeGraph(t,[[-2,-2],[-2,2],[2,2],[2,-2]])}}(),function(){var t=Model.Game.cbBoardGeometryGrid(4,4);Model.Game.cbDefine=function(){return{geometry:t,pieceTypes:{0:{name:"pawn-w",aspect:"pawn",graph:this.cbPawnGraph(t,1),value:1,abbrev:"",fenAbbrev:"P",epCatch:!0,initial:[{s:1,p:4},{s:1,p:5},{s:1,p:6},{s:1,p:7}]},2:{name:"pawn-b",aspect:"pawn",graph:this.cbPawnGraph(t,-1),value:1,abbrev:"",fenAbbrev:"P",epCatch:!0,initial:[{s:-1,p:8},{s:-1,p:9},{s:-1,p:10},{s:-1,p:11}]},6:{name:"rook",graph:this.cbRookGraph(t),value:5,abbrev:"R",initial:[{s:1,p:0},{s:1,p:3},{s:-1,p:12},{s:-1,p:15}]},7:{name:"queen",graph:this.cbQueenGraph(t),value:9,abbrev:"Q",initial:[{s:1,p:1},{s:-1,p:13}]},8:{name:"king",isKing:!0,graph:this.cbKingGraph(t),abbrev:"K",initial:[{s:1,p:2},{s:-1,p:14}]}},promote:function(e,r,i){return 0==r.t&&3==t.R(i.t)?[6,7]:2==r.t&&0==t.R(i.t)?[6,7]:[]},evaluate:function(e,r,i){var a=i[1].count,n=i[-1].count;a[0]||a[1]||a[4]||a[5]||a[6]||a[7]||n[2]||n[3]||n[6]||n[7]||!(n[4]+n[5]<2||n[5]<2)||(this.mFinished=!0,this.mWinner=JocGame.DRAW),n[2]||n[3]||n[4]||n[5]||n[6]||n[7]||a[0]||a[1]||a[6]||a[7]||!(a[4]+a[5]<2||a[5]<2)||(this.mFinished=!0,this.mWinner=JocGame.DRAW),this.noCaptCount>=100&&(this.mFinished=!0,this.mWinner=JocGame.DRAW);var s,o=e.cbUseTypedArrays?new Int8Array(3):[0,0,0],h=t.height,c=i[1].byType[0];if(c){s=c.length;for(var p=0;p<s;p++)switch(h-t.R(c[p].p)){case 2:o[0]++;break;case 3:o[1]++;break;case 4:o[2]++}}if(c=i[-1].byType[2]){s=c.length;for(var p=0;p<s;p++)switch(t.R(c[p].p)){case 1:o[0]--;break;case 2:o[1]--;break;case 3:o[2]--}}0!=o[0]&&(r.distPawnPromo1=o[0]),0!=o[1]&&(r.distPawnPromo2=o[1]),0!=o[2]&&(r.distPawnPromo3=o[2]);for(var l=0,u=4;u<=5;u++)for(var v=1;v>=-1;v-=2){var f=i[v].byType[u];if(f)for(var p=0;p<f.length;p++)f[p].m&&(l+=v)}0!=l&&(r.minorPiecesMoved=l)}}}}();

/***/ }),

/***/ "g0nL":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var pairs_1 = __webpack_require__("tefl");
Observable_1.Observable.pairs = pairs_1.pairs;
//# sourceMappingURL=pairs.js.map

/***/ }),

/***/ "g28B":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function applyMixins(derivedCtor, baseCtors) {
    for (var i = 0, len = baseCtors.length; i < len; i++) {
        var baseCtor = baseCtors[i];
        var propertyKeys = Object.getOwnPropertyNames(baseCtor.prototype);
        for (var j = 0, len2 = propertyKeys.length; j < len2; j++) {
            var name_1 = propertyKeys[j];
            derivedCtor.prototype[name_1] = baseCtor.prototype[name_1];
        }
    }
}
exports.applyMixins = applyMixins;
//# sourceMappingURL=applyMixins.js.map

/***/ }),

/***/ "gDzJ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var windowWhen_1 = __webpack_require__("Imsy");
Observable_1.Observable.prototype.windowWhen = windowWhen_1.windowWhen;
//# sourceMappingURL=windowWhen.js.map

/***/ }),

/***/ "gE51":
/***/ (function(module, exports) {

exports.model=Model={Game:{},Board:{},Move:{}},Model.Game.HuntInitGame=function(){this.g.huntOptions={compulsoryCatch:!1,catchLongestLine:!1,multipleCatch:!0},this.g.huntEval={pieceCount:1e6,freeZone:100,dist:1e3},this.g.RC=[],this.g.Graph=[],this.g.useDrop=!1,this.g.evaluate0=0,this.g.debugEval=!1},Model.Game.HuntPostInitGame=function(){this.HuntMakeDist(),this.zobrist=new JocGame.Zobrist({board:{type:"array",size:this.g.Graph.length,values:["1","-1"]},who:{values:["1","-1"]}})},Model.Game.HuntMakeGrid=function(t){var e={rows:5,cols:5,row0:0,col0:0,dirs:4};Object.assign(e,t);for(var i={},a=this.g.RC.length,r=0;r<e.rows;r++)for(var s=0;s<e.cols;s++){var h=a+r*e.cols+s;this.g.RC[h]=[r+e.row0,s+e.col0],i[r+","+s]=h}for(var h=0;h<this.g.RC.length;h++){var r=this.g.RC[h][0],s=this.g.RC[h][1],o=[],n=i[r-1+","+s];void 0!==n?o.push(n):o.push(null),n=i[r+1+","+s],void 0!==n?o.push(n):o.push(null),n=i[r+","+(s-1)],void 0!==n?o.push(n):o.push(null),n=i[r+","+(s+1)],void 0!==n?o.push(n):o.push(null);for(var c=o.length;c<e.dirs;c++)o.push(null);this.g.Graph.push(o)}},Model.Game.HuntMakeDist=function(){function t(t,i,a){e.g.Dist[t][i]=a,a>e.g.DistMax&&(e.g.DistMax=a)}var e=this;this.g.Dist=[],this.g.DistMax=0;for(var i=0;i<this.g.Graph.length;i++){for(var a=[],r=0;r<=i;r++)a.push(-1);this.g.Dist.push(a)}for(var s=0;s<this.g.Graph.length;s++)for(var h=this.g.Graph[s],o=0;o<h.length;o++){var n=h[o];null!=n&&(n<s&&this.g.Dist[s-1][n]==-1?t(s-1,n,1):n>s&&this.g.Dist[n-1][s]==-1&&t(n-1,s,1))}for(var c=!0,l=1;c;l++){c=!1;for(var s=1;s<this.g.Graph.length;s++)for(var n=0;n<s;n++)if(this.g.Dist[s-1][n]==l){for(var h=this.g.Graph[n],o=0;o<h.length;o++){var u=h[o];null!=u&&(u<s&&this.g.Dist[s-1][u]==-1?(t(s-1,u,l+1),c=!0):u>s&&this.g.Dist[u-1][s]==-1&&(t(u-1,s,l+1),c=!0))}h=this.g.Graph[s];for(var o=0;o<h.length;o++){var u=h[o];null!=u&&(u<n&&this.g.Dist[n-1][u]==-1?(t(n-1,u,l+1),c=!0):u>n&&this.g.Dist[u-1][n]==-1&&(t(u-1,n,l+1),c=!0))}}}},Model.Game.HuntRemovePositions=function(t){var e={},i=0;t.sort(function(t,e){return t-e});for(var a=0;a<this.g.Graph.length;a++)t.length>0&&a==t[0]?t.shift():e[a]=i++;for(var a=0;a<this.g.Graph.length;a++)if(void 0!==e[a]){for(var r=this.g.Graph[a],s=[],h=0;h<r.length;h++){var o=r[h];null!=o&&void 0!==e[o]?s.push(e[o]):s.push(null)}this.g.Graph[a]=s}else this.g.Graph[a]="X";for(var n=[],c=[],a=0;a<this.g.Graph.length;a++)void 0!==e[a]&&(n.push(this.g.Graph[a]),c.push(this.g.RC[a]));this.g.Graph=n,this.g.RC=c,this.g.PosName={}},Model.Game.HuntDist=function(t,e){if(t==e)return 0;if(e>t){var i=t;t=e,e=i}return this.g.Dist[t-1][e]},Model.Move.Init=function(t){void 0!==t&&this.CopyFrom(t)},Model.Move.PosName={},Model.Move.ToString=function(){function t(t){if(void 0!==e[t]&&e[t].length>0){var i=[];for(var a in e[t]){var r=e[t][a];void 0!==e.PosName[r]?i.push(e.PosName[r]):i.push(r)}return i.join(",")}return""}var e=this,i="";i+=t("p");var a=t("c");return a.length>0&&(i+="x"+a),i},Model.Move.Equals=function(t){if(null==t)return!1;if(t.p.length!=this.p.length)return!1;for(var e=0;e<this.p.length;e++)if(t.p[e]!=this.p[e])return!1;if(void 0===t.c&&void 0===this.c)return!0;if(void 0!==t.c&&void 0!==this.c){for(var e=0;e<this.c.length;e++)if(t.c[e]!=this.c[e])return!1;return!0}return!1},Model.Board.InitialPosition=function(t){this.HuntInitialPosition(t,t.g.initialPos),this.zSign=t.zobrist.update(0,"who",-1)},Model.Board.CopyFrom=function(t){this.board=[];for(var e=0;e<t.board.length;e++)this.board.push(null);this.pieces=[];for(var e in t.pieces){var i=t.pieces[e],a={p:i.p,s:i.s,i:i.i,a:i.a,pv:i.pv,pv2:i.pv2};this.pieces.push(a),a.p>-1&&(this.board[a.p]=a)}this.pieceCount=[t.pieceCount[0],t.pieceCount[1]],this.lastMoves={1:[t.lastMoves[1][0],t.lastMoves[1][1],t.lastMoves[1][2]],"-1":[t.lastMoves[-1][0],t.lastMoves[-1][1],t.lastMoves[-1][2]]},this.mWho=t.mWho,this.zSign=t.zSign},Model.Board.HuntInitialPosition=function(t,e){this.board=[];for(var i=0;i<t.g.Graph.length;i++)this.board.push(null);this.pieces=[],this.pieceCount=[0,0];for(var a=0;a<2;a++)for(var r=0;r<e[a].length;r++){var i=e[a][r],s={p:i,s:1-2*a,i:this.pieces.length,a:0};this.board[i]=s,this.zSign=t.zobrist.update(this.zSign,"board",1-2*a,i),this.pieces.push(s),this.pieceCount[a]++}this.lastMoves={1:[null,null,null],"-1":[null,null,null]}},Model.Board.GenerateMoves=function(t){this.mMoves=[],t.g.useDrop&&(this.mMoves=this.HuntGetAllDropMoves(t)),0==this.mMoves.length&&(this.mMoves=this.HuntGetAllMoves(t),0==this.mMoves.length&&(this.mFinished=!0,this.mWinner=-this.mWho))},Model.Board.HuntGetCatcherMoves=function(t){function e(r,s,h,o){for(var n=!1,c=0;c<t.g.Graph[r].length;c++){var l=t.g.Graph[r][c];if(null!=l){var u=i.board[l];if(null!=u&&u.s==-i.mWho){var v=t.g.Graph[l][c];if(null!=v&&(null==i.board[v]||s.indexOf(v)>=0)){for(var p=!0,g=Math.floor(c/2),d=0;d<h.length;d++)if(l==h[d]&&g==o[d]){p=!1;break}if(p){var f=s.concat([v]),M=h.concat([l]);if(0==t.g.huntOptions.multipleCatch)a.push({p:f,c:M}),n=!0;else{0!=e(v,f,M,o.concat([g]))&&0!=t.g.huntOptions.compulsaryCatch||(a.push({p:f,c:M}),n=!0)}}}}}}return n}for(var i=this,a=[],r=0;r<this.pieces.length;r++){var s=this.pieces[r];s.p>=0&&s.s==this.mWho&&e(s.p,[s.p],[],[])}if(0==a.length||0==t.g.huntOptions.compulsaryCatch)a=a.concat(this.HuntGetCatcheeMoves(t));else if(t.g.huntOptions.catchLongestLine){var h=0,o=[];for(var r in a)h<a[r].c.length?(h=a[r].c.length,o=[a[r]]):h==a[r].c.length&&o.push(a[r]);a=o}return a},Model.Board.HuntGetCatcheeMoves=function(t){for(var e=[],i=0;i<this.pieces.length;i++){var a=this.pieces[i];if(a.p>=0&&a.s==this.mWho)for(var r=0;r<t.g.Graph[a.p].length;r++){var s=t.g.Graph[a.p][r];null!=s&&null==this.board[s]&&e.push({p:[a.p,s]})}}return e},Model.Board.HuntGetAllMoves=function(t){return this.mWho==t.g.catcher?this.HuntGetCatcherMoves(t):this.HuntGetCatcheeMoves(t)},Model.Board.HuntGetAllDropMoves=function(t){for(var e=[],i=null,a=0;a<this.pieces.length;a++){var r=this.pieces[a];if(r.p==-2&&r.s==this.mWho){i=r;break}}if(i)for(var s=0;s<this.board.length;s++)null==this.board[s]&&e.push({p:[s]});return e},Model.Board.HuntMakeEvalData=function(t){for(var e={catcher:t.g.catcher,catchee:-t.g.catcher,catcherSide:(1-t.g.catcher)/2,catcheeSide:(t.g.catcher+1)/2,catcherPieces:[],catcheePieces:[],catcherPiecesDock:[],catcheePiecesDock:[]},i=0;i<this.pieces.length;i++){var a=this.pieces[i];a.p>-1?a.s==e.catcher?e.catcherPieces.push(a):e.catcheePieces.push(a):a.p==-2&&(a.s==e.catcher?e.catcherPiecesDock.push(a):e.catcheePiecesDock.push(a))}return e},Model.Board.HuntEvaluateFreeZone=function(t,e,i){var a={},r=-1;for(var s in e.catcherPieces){var h=e.catcherPieces[s],o={},n=0,c={},l=1;for(c[h.p]=!0;l>0;){var u;for(var v in c){u=parseInt(v),l--;break}delete c[u],o[u]=!0,n++,a[u]=!0;for(var p in t.g.Graph[u]){var g=t.g.Graph[u][p];null==g||null!=this.board[g]||o[g]||c[g]||(c[g]=!0,l++)}}(r<0||r<n-1)&&(r=n-1,o)}e.catcherZone=a,i.freeZone=[r,0],i.freeZone2=[r*r,0],i.freeZoneSQRT=[Math.sqrt(r),0];var d=0,f=0,M=0;for(var s in e.catcheePieces){var m=e.catcheePieces[s],G=0;for(var u in o){var p=t.HuntDist(u,m.p);p>G&&(G=p),p>M&&(M=p)}d+=G,f+=G*G}i.distFree=[d,0],i.distFree2=[f,0],i.maxDistFree=[M,0]},Model.Board.HuntEvaluateOppositeDistFromCatcher=function(t,e,i){var a=[];for(var r in e.catcherPieces){for(var s=e.catcherPieces[r],h=[],o=0,n=0;n<t.g.Graph.length;n++){var c=t.HuntDist(n,s.p);c>o?(o=c,h=[n]):c==o&&h.push(n)}a=a.concat(h)}var c=0,l=0,u=0;for(var r in e.catcheePieces){for(var s=e.catcheePieces[r],v=0,p=0,g=0,d=0;d<a.length;d++)d0=t.HuntDist(a[d],s.p),v+=d0,p+=d0*d0,g+=Math.sqrt(v);c+=v/h.length,l+=p/h.length,u+=g/h.length}i.oppDist=[-c,0],i.oppDist2=[-l,0],i.oppDists=[-u,0]},Model.Board.HuntEvaluateDistToCatcher=function(t,e,i){var a=0,r=0,s=0,h=0;for(var o in e.catcheePieces){var n=e.catcheePieces[o],c=-1;for(var l in e.catcherPieces){var u=e.catcherPieces[l],v=t.HuntDist(u.p,n.p);(c<0||c<v)&&(c=v)}a+=c;var p=c*c;r+=p,s+=c*p,c>h&&(h=c)}i.dist3=[s,0],i.dist2=[r,0],i.dist=[a,0],i.maxDist=[h,0]},Model.Board.HuntEvaluateCatchable=function(t,e,i){var a=0,r=0,s=0;for(var h in e.catcheePieces){for(var o=e.catcheePieces[h],n=o.p,c=!1,l=!1,u=t.g.Graph[n],v=0;v<u.length;v+=2){var p=u[v],g=u[v+1];null!=p&&null!=g&&(null==this.board[p]&&null==this.board[g]?(r++,c=!0):(null==this.board[p]&&this.board[g].s==t.g.catcher||null==this.board[g]&&this.board[p].s==t.g.catcher)&&(r++,l=!0,c=!0))}c&&a++,l&&s++}i.catchablePieces=[a,0],i.catchableDir=[r,0],i.catchableDir2=[r*r,0],i.catchDangerFork=[s>1?1:0,0]},Model.Board.HuntEvaluateRisk=function(t,e,i){function a(t){void 0===e.catcherZone[t]&&(void 0===h[t]?(h[t]=1,n++):h[t]++)}function r(t){void 0===s[t]?(s[t]=1,o++):s[t]++}var s={},h={},o=0,n=0;for(var c in e.catcheePieces)for(var l=e.catcheePieces[c],u=l.p,v=t.g.Graph[u],p=0;p<v.length;p+=2){var g=v[p],d=v[p+1];if(null!=g&&null!=d){var f=this.board[g],M=this.board[d];null==f&&null==M?(a(g),a(d)):null!=f&&f.s==t.g.catcher&&null==M?(a(g),r(d)):null!=M&&M.s==t.g.catcher&&null==f&&(r(g),a(d))}}var m=0;for(var u in h){var G=h[u];m+=G*G}var b=0;for(var u in s){var G=s[u];b+=G*G}i.openRisk=[m,0],i.forkRisk=[b,0]},Model.Board.HuntEvaluateAntiBack=function(t,e,i){var a=0,r=0,s=0,h=0;for(var o in e.catcheePieces){var n=e.catcheePieces[o];n.p==n.pv2&&h++}for(var o in e.catcherPieces){var n=e.catcherPieces[o];n.p==n.pv2&&s++}for(var c=-1;c<2;c+=2){var l=this.lastMoves[c];null!=l[0]&&l[0].Equals(l[2])&&(t.g.catcher==c?a++:r++)}i.antiBack=[r,a],i.antiBackPiece=[h,s]},Model.Board.HuntEvaluateCatcheeConnections=function(t,e,i){for(var a=0,r=0,s=0;s<this.pieces.length;s++){var h=this.pieces[s];if(h.s==-t.g.catcher&&h.p>=0){for(var o=0,n=t.g.Graph[h.p],c=0;c<n.length;c++){var l=n[c];if(null!=l){var u=this.board[l];u&&u.s==h.s&&o++}}a+=o,r+=Math.log(o+1)}}i.catcheeConn=[0,a],i.catcheeConnLog=[0,r]},Model.Board.HuntEvaluateCatcheeGroups=function(t,e,i){for(var a={},r=0,s=0;s<this.pieces.length;s++){var h=this.pieces[s];h.s==-t.g.catcher&&h.p>=0&&(a[h.i]=h,r++)}for(var o=0;r>0;){o++;for(var s in a)break;var h=a[s];delete a[s];var n={};n[s]=h;for(var c=1;c>0;){for(var s in n)break;var l=n[s];delete n[s],c--,delete a[s],r--;for(var u=t.g.Graph[l.p],v=0;v<u.length;v++){var p=u[v];if(null!=p){var g=this.board[p];g&&g.i in a&&!(g.i in n)&&(n[g.i]=g,c++)}}}}i.catcheeGroups=[o,0]},Model.Board.HuntEvaluateGroups=function(t,e,i){for(var a={},r={},s=0,h=0;h<t.g.Graph.length;h++)if(void 0===r[h]){for(var o=this.board[h],n=null,c=t.g.Graph[h],l=0;l<c.length;l++){var u=c[l];if(null!=u){var v=this.board[u];if((null==o&&null==v||null!=o&&null!=v&&o.s==v.s)&&void 0!==r[u]){var p=r[u];if(null==n)r[h]=p,a[p].poss.push(h),n=p;else if(n!=p){var g=a[n],d=a[p];g.poss=g.poss.concat(d.poss);for(var f in d.poss)r[d.poss[f]]=n;delete a[p]}}}}null==n&&(a[s]={type:null==o?0:o.s,poss:[h],touchCatcher:!1},r[h]=s++)}for(var f in e.catcherPieces)for(var o=e.catcherPieces[f],l=0;l<c.length;l++){var u=t.g.Graph[o.p][l];null!=u&&(a[r[u]].touchCatcher=!0)}var M=0,m=0,G=0,b=0;for(var C in a){var g=a[C];g.type==-t.g.catcher?M++:0==g.type&&(0==g.touchCatcher?(g.poss.length>m&&(m=g.poss.length),G+=g.poss.length):1==g.touchCatcher&&(b+=g.poss.length))}i.catcheeGroups=[M,0],i.maxEmptyNoCatcherGroup=[0,m],i.emptyNoCatcherGroup=[0,G],i.minEmptyCatcherGroup=[b<0?0:b,0]},Model.Board.HuntGameEvaluate=function(t,e,i){return{pieceCount:[1,1]}},Model.Board.QuickEvaluate=function(t){return this.Evaluate(t,!1,!0),this.mEvaluation},Model.Board.Evaluate=function(t,e,i){t.GetRepeatOccurence(this)>2&&(this.mFinished=!0,this.mWinner=JocGame.DRAW);var a=this.HuntMakeEvalData(t);if(this.pieceCount[a.catcherSide]<t.g.catcherMin&&(this.mFinished=!0,this.mWinner=a.catchee),this.pieceCount[a.catcheeSide]<t.g.catcheeMin&&(this.mFinished=!0,this.mWinner=a.catcher),this.mEvaluation=0,!this.mFinished){var r={pieceCount:[this.pieceCount[a.catcherSide],this.pieceCount[a.catcheeSide]]},s=this.HuntGameEvaluate(t,a,r),h="debug"==arguments[3];for(var o in s){var n=s[o],c=r[o];void 0===c&&console.error("Evaluation undefined map value",o),h&&console.log(o+":",c[0],"x",n[0]," - ",c[1],"x",n[1],"=",c[0]*n[0]-c[1]*n[1]),this.mEvaluation+=c[0]*n[0]-c[1]*n[1]}if(h){for(var o in r)void 0===s[o]&&JocLog("Unused",o+": ",r[o][0],r[o][1]);JocLog("==>",this.mEvaluation,"=>",this.mEvaluation*t.g.catcher,"=>",this.mEvaluation*t.g.catcher-t.g.evaluate0)}this.mEvaluation*=t.g.catcher,this.mEvaluation-=t.g.evaluate0}},Model.Board.HuntCheckBoard=function(t){for(var e in t.g.Graph){var i=t.g.Graph[e],a=this.board[i];if(null!=a&&a.p!=i)return"Piece "+a+e+" has p "+a.p+" while on board pos "+i}for(var e in this.pieces){var a=this.pieces[e];if(a.p!=-1&&this.board[a.p]!=a)return"Piece "+e+" not on board "+a.p}return null},Model.Board.HuntAngle=function(t,e,i){var a=t.g.RC[e],r=a[0],s=a[1],h=t.g.RC[i],o=h[0],n=h[1],c=0,l=o-r,u=n-s;return 0==l?c=u>0?90:-90:(c=180*Math.atan(u/l)/Math.PI,l<0&&(c=(c+180)%360)),c},Model.Board.ApplyMove=function(t,e){if(1==e.p.length)for(var i=0;i<this.pieces.length;i++){var a=this.pieces[i];if(a.s==this.mWho&&a.p==-2){a.p=e.p[0],a.a=0,this.board[a.p]=a,this.zSign=t.zobrist.update(this.zSign,"board",a.s,a.p);break}}else{var a=this.board[e.p[0]];if(this.zSign=t.zobrist.update(this.zSign,"board",a.s,a.p),this.board[e.p[0]]=null,this.board[e.p[e.p.length-1]]=a,a.pv2=a.pv,a.pv=a.p,a.p=e.p[e.p.length-1],a.a=this.HuntAngle(t,e.p[e.p.length-2],e.p[e.p.length-1]),this.zSign=t.zobrist.update(this.zSign,"board",a.s,a.p),void 0!==e.c)for(var r=this.mWho==JocGame.PLAYER_A?0:1,i=0;i<e.c.length;i++)null!=(a=this.board[e.c[i]])&&(this.board[e.c[i]]=null,this.zSign=t.zobrist.update(this.zSign,"board",a.s,a.p),a.p=-1,this.pieceCount[1-r]--)}this.lastMoves[this.mWho][2]=this.lastMoves[this.mWho][1],this.lastMoves[this.mWho][1]=this.lastMoves[this.mWho][0],this.lastMoves[this.mWho][0]=new(t.GetMoveClass())(e),this.zSign=t.zobrist.update(this.zSign,"who",-this.mWho),this.zSign=t.zobrist.update(this.zSign,"who",this.mWho)},Model.Board.GetSignature=function(){return this.zSign},Model.Move.PosName={0:"A5",1:"B5",2:"C5",3:"D5",4:"E5",5:"A4",6:"B4",7:"C4",8:"D4",9:"E4",10:"A3",11:"B3",12:"C3",13:"D3",14:"E3",15:"A2",16:"B2",17:"C2",18:"D2",19:"E2",20:"A1",21:"B1",22:"C1",23:"D1",24:"E1"},Model.Board.HuntGameEvaluate=function(t,e,i){this.HuntEvaluateDistToCatcher(t,e,i),this.HuntEvaluateCatcheeGroups(t,e,i),this.HuntEvaluateFreeZone(t,e,i),this.HuntEvaluateRisk(t,e,i);var a=t.mOptions.levelOptions,r={};for(var s in a){var h=/^(.*)(0|1)$/.exec(s);h&&(void 0===r[h[1]]&&(r[h[1]]=[0,0]),r[h[1]][h[2]]=a[s])}return r},Model.Game.InitGame=function(){function t(t,i,a,r){e.g.Graph[t][a]=i,e.g.Graph[i][r]=t}var e=this;this.HuntInitGame(),Object.assign(this.g.huntOptions,{compulsaryCatch:!1,catchLongestLine:!1,multipleCatch:!0}),this.HuntMakeGrid({}),t(10,6,4,5),t(6,2,4,5),t(20,16,4,5),t(16,12,4,5),t(12,8,4,5),t(8,4,4,5),t(22,18,4,5),t(18,14,4,5),t(0,6,6,7),t(6,12,6,7),t(12,18,6,7),t(18,24,6,7),t(10,16,6,7),t(16,22,6,7),t(2,8,6,7),t(8,14,6,7),this.g.catcher=JocGame.PLAYER_B,this.g.evaluate0=-25e5,this.g.catcherMin=1,this.g.catcheeMin=10,this.g.initialPos=[[0,1,2,3,4,5,6,7,8,9,10,14],[12]],this.HuntPostInitGame()};

/***/ }),

/***/ "gIFM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var AjaxObservable_1 = __webpack_require__("Dc2k");
exports.ajax = AjaxObservable_1.AjaxObservable.create;
//# sourceMappingURL=ajax.js.map

/***/ }),

/***/ "gL6D":
/***/ (function(module, exports) {

exports.config = {"status":true,"model":{"plazza":"true","released":1397141778,"title-en":"Rollerball Chess","module":"chessbase","summary":"Chess variant on an unusual board","thumbnail":"rollerball-thumb.png","rules":{"en":"rollerball-rules.html"},"credits":{"en":"rollerball-credits.html"},"gameOptions":{"preventRepeat":true,"uctTransposition":"state","uctIgnoreLoop":false,"levelOptions":{"pieceValueFactor":1,"pieceValueRatioFactor":1,"posValueFactor":0.1,"averageDistKingFactor":-0.01,"castleFactor":0.1,"minorPiecesMovedFactor":0.1,"checkFactor":0.2,"endingKingFreedomFactor":0.01,"endingDistKingFactor":0.05,"distKingCornerFactor":0.1,"distPawnPromoFactor":-0.05,"distKingThroneFactor":-0.1}},"obsolete":false,"js":["base-model.js","grid-geo-model.js","rollerball-model.js"],"description":{"en":"rollerball-description.html"},"levels":[{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"easy","label":"Easy","maxNodes":1000},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"fast","label":"Fast [1sec]","maxDuration":1,"isDefault":true},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"medium","label":"Medium","maxNodes":10000,"maxDuration":10},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"strong","label":"Strong","maxNodes":20000,"maxDuration":15}]},"view":{"title-en":"Chessbase view","module":"chessbase","xdView":true,"css":["chessbase.css"],"preferredRatio":1,"useShowMoves":true,"useNotation":true,"useAutoComplete":true,"defaultOptions":{"sounds":true,"moves":true,"notation":false,"autocomplete":false},"skins":[{"name":"skin3d","title":"3D Classic","3d":true,"preload":["smoothedfilegeo|0|/res/ring-target.js","image|/res/images/cancel.png","image|/res/images/wikipedia.png","smoothedfilegeo|0|/res/staunton/pawn/pawn-classic.js","image|/res/staunton/pawn/pawn-diffusemap.jpg","image|/res/staunton/pawn/pawn-normalmap.jpg","smoothedfilegeo|0|/res/staunton/knight/knight.js","image|/res/staunton/knight/knight-diffusemap.jpg","image|/res/staunton/knight/knight-normalmap.jpg","smoothedfilegeo|0|/res/staunton/bishop/bishop.js","image|/res/staunton/bishop/bishop-diffusemap.jpg","image|/res/staunton/bishop/bishop-normalmap.jpg","smoothedfilegeo|0|/res/staunton/rook/rook.js","image|/res/staunton/rook/rook-diffusemap.jpg","image|/res/staunton/rook/rook-normalmap.jpg","smoothedfilegeo|0|/res/staunton/queen/queen.js","image|/res/staunton/queen/queen-diffusemap.jpg","image|/res/staunton/queen/queen-normalmap.jpg","smoothedfilegeo|0|/res/staunton/king/king.js","image|/res/staunton/king/king-diffusemap.jpg","image|/res/staunton/king/king-normalmap.jpg","image|/res/images/wood.jpg"],"world":{"lightIntensity":1.3,"skyLightIntensity":1.2,"lightCastShadow":true,"fog":false,"color":4686804,"lightPosition":{"x":-9,"y":9,"z":9},"skyLightPosition":{"x":9,"y":9,"z":9},"lightShadowDarkness":0.55,"ambientLightColor":2236962},"camera":{"fov":45,"distMax":50,"radius":14.5,"elevationAngle":45,"elevationMin":0,"distMin":0}},{"name":"skin2d","title":"2D Classic","3d":false,"preload":["image|/res/images/wikipedia.png","image|/res/images/whitebg.png","image|/res/images/cancel.png"]}],"animateSelfMoves":false,"switchable":true,"sounds":{"move1":"alq_move1","move2":"alq_move2","move3":"alq_move3","move4":"alq_move2","tac1":"alq_tac1","tac2":"alq_tac2","tac3":"alq_tac1","promo":"promo","usermove":null},"js":["base-view.js","grid-board-view.js","staunton-set-view.js","rollerball-view.js"],"visuals":{"600x600":["res/visuals/rollerball-600x600-3d.jpg","res/visuals/rollerball-600x600-2d.jpg"]}}}

/***/ }),

/***/ "gQhC":
/***/ (function(module, exports) {

exports.model=Model={Game:{},Board:{},Move:{}},Model.Game.InitGame=function(){for(var r=this,o=this.mOptions.size,e=[],t=[],i=0,a=0,n=[],s=0;s<o;s++)n.push(a),a+=(o-s)*(o-s);for(var s=0;s<o;s++)for(var p=0;p<o-s;p++)for(var u=0;u<o-s;u++){var l=i++;e[l]=[p,u,s],t[l]=[];for(var h=0;h<2;h++)for(var f=0;f<2;f++){var v=s-1,d=p+h,g=u+f;v>=0&&v<o&&d>=0&&d<o-v&&g>=0&&g<o-v?t[l].push(n[v]+d*(o-v)+g):t[l].push(null)}var c=[[0,-1],[0,1],[-1,0],[1,0]];for(var b in c){var m=c[b],v=s,d=p+m[0],g=u+m[1];v>=0&&v<o&&d>=0&&d<o-v&&g>=0&&g<o-v?t[l].push(n[v]+d*(o-v)+g):t[l].push(null)}for(var h=-1;h<1;h++)for(var f=-1;f<1;f++){var v=s+1,d=p+h,g=u+f;v>=0&&v<o&&d>=0&&d<o-v&&g>=0&&g<o-v?t[l].push(n[v]+d*(o-v)+g):t[l].push(null)}}this.g.Graph=t,this.g.Coord=e,this.g.Over=[],this.g.Beneath=[];for(var l=0;l<this.g.Graph.length;l++)this.g.Over[l]=null,this.g.Beneath[l]=null;for(var l=0;l<this.g.Graph.length;l++)for(var e=this.g.Coord[l],G=l+1;G<this.g.Graph.length;G++){var y=this.g.Coord[G];if(y[2]==e[2]+2&&y[0]==e[0]-1&&y[1]==e[1]-1){this.g.Over[l]=G,this.g.Beneath[G]=l;break}}this.g.EachDirection=function(o,e){for(var t=0;t<12;t++){var i=r.g.Graph[o][t];if(null!=i&&0==e(i,t))return}},this.g.EachDirectionDown=function(o,e){for(var t=[0,1,2,3],i=0;i<t.length;i++){var a=r.g.Graph[o][t[i]];if(null!=a&&0==e(a,t[i]))return}},this.g.EachDirectionUp=function(o,e){for(var t=[8,9,10,11],i=0;i<t.length;i++){var a=r.g.Graph[o][t[i]];if(null!=a&&0==e(a,t[i]))return}},this.g.EachDirectionFlat=function(o,e){for(var t=[4,5,6,7],i=0;i<t.length;i++){var a=r.g.Graph[o][t[i]];if(null!=a&&0==e(a,t[i]))return}},this.g.EachDirectionFlatDown=function(o,e){for(var t=[0,1,2,3,4,5,6,7],i=0;i<t.length;i++){var a=r.g.Graph[o][t[i]];if(null!=a&&0==e(a,t[i]))return}},this.g.EachDirectionFlatUp=function(o,e){for(var t=[4,5,6,7,8,9,10,11],i=0;i<t.length;i++){var a=r.g.Graph[o][t[i]];if(null!=a&&0==e(a,t[i]))return}},this.zobrist=new JocGame.Zobrist({board:{type:"array",size:this.g.Graph.length,values:[0,1]}}),this.InitGameExtra()},Model.Game.MapSameLevelDiagGraph=function(){for(var r=[0,16,25,29],o=0;o<4;o++)for(var e=0;e<4-o;e++)for(var t=0;t<4-o;t++)for(var i=r[o]+e*(4-o)+t,a=-1;a<2;a+=2)for(var n=-1;n<2;n+=2){var s=o,p=e+a,u=t+n;s>=0&&s<4&&p>=0&&p<4-s&&u>=0&&u<4-s?this.g.Graph[i].push(r[s]+p*(4-s)+u):this.g.Graph[i].push(null)}},Model.Game.InitGameExtra=function(){},Model.Game.DestroyGame=function(){this.DestroyGameExtra()},Model.Game.DestroyGameExtra=function(){},Model.Game.spUpdateZobrist=function(r,o,e,t,i,a){for(var n=0;n<o.length;n++)r=this.zobrist.update(r,"board",e,o[n]);for(var n=0;n<t.length;n++)r=this.zobrist.update(r,"board",i,t[n]);return r},Model.Move.Init=function(r){for(var o in r)r.hasOwnProperty(o)&&(this[o]=JSON.parse(JSON.stringify(r[o])))},Model.Move.ToString=function(){var r=["?","W","B","R"][this.clr],o="";switch(this.act){case"+":o+="+"+this.pos+r;break;case">":o+=this.from+">"+this.to+r}return o},Model.Board.Init=function(r){},Model.Board.InitialPosition=function(r){this.spInitialPosition(r)},Model.Board.spInitialPosition=function(r){this.board=[];for(var o=0;o<r.g.Graph.length;o++)this.board[o]=0;this.maxLayer=0,this.ballCount=[0,0,0],this.playables={},this.height=[0,0,0],this.zSign=0;for(var o=0;o<r.mOptions.size*r.mOptions.size;o++)this.playables[o]=!0},Model.Board.MakeFreeMoves=function(r){var o=[];for(var e in this.playables)o.push({act:"+",pos:e,clr:this.mWho==JocGame.PLAYER_A?1:2});return o},Model.Board.GenerateMoves=function(r){var o=this.GenerateAllMoves(r),e=r.mOptions.moveCount;0==o.length?(this.mFinished=!0,this.ballCount[1]>this.ballCount[2]?this.mWinner=JocGame.PLAYER_A:this.ballCount[1]<this.ballCount[2]?this.mWinner=JocGame.PLAYER_B:this.mWinner=JocGame.DRAW):void 0!==e&&o.length>e&&(r.ArrayShuffle(o),o.sort(function(r,o){o.nextBoard.evaluation,r.nextBoard.evaluation}),o.splice(e,o.length-e)),this.mMoves=o},Model.Board.GenerateAllMoves=function(r){return this.MakeFreeMoves(r)},Model.Board.Evaluate=function(r,o,e){this.mEvaluation=0},Model.Board.ApplyMove=function(r,o){this.spApplyMove(r,o)},Model.Board.spApplyMove=function(r,o){function e(o){delete t.playables[o],r.g.EachDirectionFlat(o,function(e,i){if(t.board[e]){var a,n;switch(i){case 4:a=7,n=10;break;case 5:a=6,n=9;break;case 6:a=4,n=8;break;case 7:a=5,n=11}var s=r.g.Graph[o][a];null!==s&&t.board[s]>0&&t.board[r.g.Graph[e][a]]&&(t.playables[r.g.Graph[o][n]]=!0)}})}var t=this;switch(o.act){case"+":this.board[o.pos]=o.clr;var i=r.g.Coord[o.pos][2];i>this.maxLayer&&(this.maxLayer=i),this.height[o.clr]+=i,this.ballCount[o.clr]++,e(o.pos);break;case">":o.down.length>0?this.playables[o.down[o.down.length-1]]=!0:this.playables[o.from]=!0;var a=o.from;for(var n in o.down){var s=o.down[n];this.height[this.board[s]]--,this.board[a]=this.board[s],a=s}this.board[a]=0,this.board[o.to]=o.clr;var i=r.g.Coord[o.to][2];this.height[o.clr]+=i,i>this.maxLayer&&(this.maxLayer=i),e(o.to)}},Model.Board.IsValidMove=function(r,o){return!0},Model.Board.ExtendMove=function(r,o){return{}},Model.Board.GetSignature=function(){return this.zSign},Model.Board.InitialPosition=function(r){this.spInitialPosition(r),this.groupMaxId=1,this.groups={},this.posGroup={},this.posFree={},this.center=0,this.moveEvaluation=0},Model.Board.GenerateAllMoves=function(r){for(var o=this.MakeFreeMoves(r),e=[],t=0;t<o.length;t++){var i=o[t],a=this.ExtendMove(r,i.pos);if(null!==a){i.nextBoard=a.board,i.remove=a.remove;var n=!1;r.mVisitedBoards&&r.mVisitedBoards[i.nextBoard.zSign]&&(n=!0),0==n&&e.push(i)}}return e},Model.Board.ExtendMove=function(r,o,e,t){function i(e){var t=p.board[e],i={side:t,p:{},pCount:1,f:{},fCount:0};i.p[e]=!0;for(var a=[e];a.length>0;){var n=a.pop();r.g.EachDirection(n,function(e,s){var u=p.board[e];if(u==t){if(e in i.p)return!0;var h=r.g.Over[e];if(null!==h&&(0!=p.board[h]||o==h))return!0;var f=G[s];if(void 0!==f){var v=r.g.Graph[n][f[0]],d=r.g.Graph[n][f[1]];if((v==o&&t==l||p.board[v]==3-t)&&(d==o&&t==l||p.board[d]==3-t))return!0}i.p[e]=!0,i.pCount++,a.push(e)}else if(0==u&&e!=o&&0==r.g.Coord[e][2]){if(e in i.f)return!0;i.f[e]=!0,i.fCount++}return!0})}return i}function a(r){var o=p.groupMaxId++;p.groups[o]=r;for(var e in r.p){p.posGroup[e];p.posGroup[e]=o}for(var t in r.f)void 0===p.posFree[t]&&(p.posFree[t]={}),p.posFree[t][o]=!0;return o}function n(r,o){var e=[];for(var t in o)e.push(t);for(var i=e[0],a=p.groups[i],n=1;n<e.length;n++){var t=e[n],s=p.groups[t];for(var u in s.p)a.p[u]=!0,p.posGroup[u]=i;a.pCount+=s.pCount;for(var l in s.f)l in a.f||(a.f[l]=!0,a.fCount++),delete p.posFree[l][t],p.posFree[l][i]=!0;delete p.groups[t]}if(r>=0){for(var l in b)l in a.f||(a.f[l]=!0,a.fCount++),void 0===p.posFree[l]&&(p.posFree[l]={}),p.posFree[l][i]=!0;a.p[r]=!0,a.pCount++,p.posGroup[r]=i}}function s(r,o,e){var t=p.groups[o];for(var i in e)i in t.f||(t.f[i]=!0,t.fCount++,void 0===p.posFree[i]&&(p.posFree[i]={}),p.posFree[i][o]=!0);t.p[r]=!0,t.pCount++,p.posGroup[r]=o}arguments.length<3&&(e=0),arguments.length<4&&(t=null),null==t&&(t=this);var p=JSON.parse(JSON.stringify({board:t.board,playables:t.playables,ballCount:t.ballCount,groups:t.groups,posFree:t.posFree,posGroup:t.posGroup,groupMaxId:t.groupMaxId,center:t.center,zSign:t.zSign,mWho:t.mWho})),u={};0==e&&(e=this.mWho==JocGame.PLAYER_A?1:2);var l=3-e,h=r.g.Coord[o],f=h[2],v={},d=0,g={},c=0,b={},m=0,G={4:[8,10],5:[9,11],6:[8,9],7:[10,11]},y={4:[0,2],5:[1,3],6:[0,1],7:[2,3]},M={},C={},F=r.g.Beneath[o];if(null!=F){var E=p.posGroup[F],B=p.groups[E];delete B.p[F],B.pCount--,p.posGroup[F]=0;var S=p.board[F],x=r.g.Coord[F][2];r.g.EachDirection(F,function(o,e){var t=p.board[o];if(r.g.Coord[o][2]==x){var i=G[e],a=r.g.Graph[F][i[0]],n=r.g.Graph[F][i[1]];if(null!=a&&p.board[a]==3-S&&null!=n||p.board[n]==3-S)return!0}return t==S&&p.posGroup[o]>0&&(C[o]=!0),!0})}f>0&&r.g.EachDirectionFlat(o,function(t,i){if(p.board[t]==e){var a=y[i],n=r.g.Graph[o][a[0]],s=r.g.Graph[o][a[1]];p.board[n]==l&&p.board[s]==l&&(p.posGroup[n]&&(C[n]=!0),p.posGroup[s]&&(C[s]=!0))}return!0});var D={};for(var z in C){var O=p.posGroup[z];D[O]=!0}for(var O in D)!function(r){var o=p.groups[r];for(var e in o.p)0!=p.posGroup[e]&&(p.posGroup[e]=-1);for(var t in o.f)delete p.posFree[t][r];delete p.groups[r]}(O);for(var z in C)p.posGroup[z]<0&&a(i(z));r.g.EachDirection(o,function(r){if(0==p.board[r])return!0;var o=p.posGroup[r];return 0==o||(p.board[r]==e?void 0===v[o]&&(v[o]=!0,d++):p.board[r]==l&&void 0===g[o]&&(g[o]=!0,c++),!0)}),0==f&&r.g.EachDirectionFlat(o,function(r){return 0==p.board[r]&&(b[r]=!0,m++),!0});var A=p.posFree[o];if(void 0!==A){for(var O in A){var B=p.groups[O];delete B.f[o],B.fCount--}delete p.posFree[o]}if(0==d){var B={side:e,p:{},pCount:1,f:b,fCount:m};B.p[o]=!0,a(B)}else if(1==d){for(var E in v);s(o,E,b)}else n(o,v);var w=!1;for(var E in p.groups)if(0!=E){var B=p.groups[E];B.side==l&&0==B.fCount&&(!function(e){var t=p.groups[e],n={},s={},l=[];for(var h in t.p)l.push({p:h,z:r.g.Coord[h][2]});l.sort(function(r,o){return o.z-r.z});for(var f=0;f<l.length;f++){var v=l[f],h=v.p,d=!1;if(r.g.EachDirectionUp(h,function(r){return!p.board[r]&&r!=o||(d=!0,!1)}),d)n[h]=!0,p.posGroup[h]=-1;else{0==v.z&&(s[h]=!0),p.board[h]=0,u[h]=!0,delete p.posGroup[h],p.ballCount[t.side]--,p.playables[h]=!0,r.g.EachDirectionUp(h,function(r){return p.playables[r]&&delete p.playables[r],!0});var g=r.g.Beneath[h];if(g)if(p.board[g]==t.side){var c=!1;if(r.g.EachDirectionDown(h,function(r){return p.board[r]!=t.side||(c=!0,!1)}),c){t.p[g]=!0,t.pCount++,p.posGroup[g]=e;for(var b={p:g,z:r.g.Coord[g][2]},m=f+1;m<l.length&&b.z<l[m].z;m++);l.splice(m,0,b)}else M[g]=!0}else M[g]=!0}}for(var G in t.f)delete p.posFree[G][e];delete p.groups[e];for(var G in s)r.g.EachDirectionFlat(G,function(r){var o=p.posGroup[r];if(void 0!==o&&o>0&&(void 0===p.posFree[G]&&(p.posFree[G]={}),void 0===p.posFree[G][o])){p.posFree[G][o]=!0;var e=p.groups[o];e.f[G]=!0,e.fCount++}return!0});for(var h in n)p.posGroup[h]==-1&&a(i(h))}(E),w=!0)}for(var z in M)if(0==p.posGroup[z]){var I=p.board[z],J={},P=0,W={},k=0,L=r.g.Coord[z][2];if(r.g.EachDirection(z,function(o,e){if(0==p.board[o])return!0;var t=p.posGroup[o];if(0==t)return!0;if(r.g.Coord[o][2]==L){var i=G[e],a=r.g.Graph[z][i[0]],n=r.g.Graph[z][i[1]];if(null!=a&&p.board[a]==3-I&&null!=n&&p.board[n]==3-I)return!0}return p.board[o]==I?void 0===J[t]&&(J[t]=!0,P++):0==p.board[o]&&0==r.g.Coord[o][2]&&(W[o]=!0,k++),!0}),0==P){var B={side:I,p:{},pCount:1,f:W,fCount:k};B.p[z]=!0;var E=a(B)}else if(1==P){for(var E in J);s(z,E,{})}else n(z,J)}if(w){var N=[];for(var E in p.groups)if(0!=E){var B=p.groups[E];B.side==e&&N.push(E)}N.sort(function(r,o){return parseInt(r)-parseInt(o)});for(var R=[],U=0;U<N.length;U++){var E=N[U],B=p.groups[E];for(var z in B.p){r.g.EachDirectionFlat(z,function(o,t){if(p.board[o]!=e)return!0;var i=p.posGroup[o];if(i!=E&&0!=i){var a=G[t],n=r.g.Graph[z][a[0]],s=r.g.Graph[z][a[1]];if(null==n||p.board[n]!=l||null==s||p.board[s]!=l){for(var u=null,h=[],f=0;f<R.length;f++){var v=R[f];if(E in v||i in v)if(u){for(var d in v)u[d]=!0;h.push(f)}else v[E]=!0,v[i]=!0,u=v}for(var f=h.length-1;f>=0;f--)R.splice(h[f],1);if(null==u){var v={};v[E]=!0,v[i]=!0,R.push(v)}}}return!0})}}for(var U=0;U<R.length;U++)n(-1,R[U])}for(var E in p.groups)if(0!=E){var B=p.groups[E];if(B.side==e&&0==B.fCount)for(var z in B.p){var H=!1;if(r.g.EachDirectionUp(z,function(r){return!(p.board[r]>0)||(H=!0,!1)}),0==H)return null}}var _=[];for(var E in p.groups){var B=p.groups[E];B.eyes=0;for(var z in B.p)_.push({p:z,z:r.g.Coord[z][2],group:B,gid:E})}_.sort(function(r,o){return o.z-r.z});for(var j={},Y={},U=0;U<_.length;U++){var V=_[U],Z=!1;r.g.EachDirectionUp(V.p,function(r){var o=j[r];return!(void 0!==o&&V.group.side&3-o)||(Z=!0,!1)}),V.pinned=Z,Y[V.p]=V,j[V.p]=Z?3:V.group.side}for(var T in p.posFree){var X=0,$=!0;r.g.EachDirectionFlat(T,function(r){if(0==p.board[r])return $=!1,!1;var o=p.posGroup[r];return 0!=X&&o!=X?($=!1,!1):(X=o,!0)}),0==X&&($=!1),$&&p.groups[X].eye++}p.relativeSecured=0,p.relativeHeight=0;var q=r.mOptions.levelOptions;for(var E in p.groups){var B=p.groups[E],K=1==B.side?1:-1,Q=q.evalSafety;B.eyes>=2?Q=q.evalSafety2eyes+Math.log(B.eyes-1)*q.evalSafetyXEyesBonus:1==B.fCount?Q=q.evalSafety1f:3==B.fCount?Q=q.evalSafety3f:B.fCount>3&&(Q=q.evalSafety3fMore+Math.log(B.fCount-3)*q.evalSafety3fMoreBonus),1==B.eyes&&(Q+=q.evalSafety1eyeBonus);for(var z in B.p){var V=Y[z],rr=Q;V.pinned&&(rr+=q.evalSafetyPinnedBonus),p.relativeSecured+=rr*K,p.relativeHeight+=V.z*K}}if(0==f){var K=1==e?1:-1,or=Math.abs(h[0]-(r.mOptions.size-1)/2)+Math.abs(h[1]-(r.mOptions.size-1)/2);p.center+=or*K*-1}p.moveEvaluation=p.relativeSecured+q.evalHeightRatio*p.relativeHeight+q.evalCenterRatio*p.center;var er=[];for(var tr in u)er.push(tr);return p.zSign=r.spUpdateZobrist(p.zSign,[o],e-1,er,2-e),{board:p,remove:er}},Model.Board.Evaluate=function(r,o,e){this.mEvaluation=this.moveEvaluation},Model.Board.CheckConsistency=function(r){for(var o=[0,0,0],e=0;e<r.g.Graph.length;e++){var t=(r.g.Coord[e],this.board[e]);if(t>0){if(void 0===this.posGroup[e])return console.error("pos",e,"side",t,"not assigned to any group"),!1;if(this.posFree[e]){var i=null;for(i in this.posFree[e]);if(null!=i)return console.error("pos",e,"side",t,"set as free for group",i),!1}o[t]++}else if(this.posGroup[e])return console.error("empty pos",e,"in posGroup"),!1;var a=r.g.Over[e];if(null!=a&&this.board[a]>0&&0!=this.posGroup[e])return console.error("buried ball",e,"does not have posGroup 0 but",this.posGroup[e]),!0}if(o[1]!=this.ballCount[1]||o[2]!=this.ballCount[2])return console.error("ball count mismatch, got",o[1],o[2],"expecting",this.ballCount[1],this.ballCount[2]),!1;for(var e in this.posGroup){if(0==this.board[e])return console.error("posGroup pos",e,"is empty"),!1;if(0!=this.posGroup[e]){if(void 0===this.groups[this.posGroup[e]])return console.error("posGroup",e,"in unknown group",this.posGroup[e]),!1;if(!(e in this.groups[this.posGroup[e]].p))return console.error("posGroup",e,"does not match group"),!1}}for(var e in this.posFree){if(0!=this.board[e])return console.error("posFree pos",e,"is not empty"),!1;for(var n in this.posFree[e]){var s=this.groups[n];if(void 0===s)return console.error("posFree pos",e,"group",n,"does not exist"),!1;if(!(e in s.f))return console.error("posFree pos",e,"group",n,"not in group freedoms"),!1}}for(var n in this.groups){var s=this.groups[n],p=0;for(var u in s.p){if(0==this.board[u])return console.error("pos",u,"in group",n,"marked as empty"),!1;if(this.board[u]!=s.side)return console.error("pos",u,"in group",n,"has wrong side"),!1;if(this.posGroup[u]!=n)return console.error("pos",u,"in group",n,"has wrong group",this.posGroup[u]),!1;p++}if(p!=s.pCount)return console.error("group",n,"count mismatch"),!1;p=0;for(var u in s.f){if(0!=this.board[u])return console.error("freedom pos",u,"in group",n,"is not empty"),!1;if(0!=r.g.Coord[u][2])return console.error("freedom pos",u,"in group",n,"not at ground level"),!1;if(void 0===this.posFree[u])return console.error("freedom pos",u,"in group",n,"not in freedoms"),!1;if(!this.posFree[u][n])return console.error("freedom pos",u,"in group",n,"is not empty for group"),!1;p++}if(p!=s.fCount)return console.error("group",n,"freedom count mismatch"),!1}return!0},Model.Board.ApplyMove=function(r,o){if(void 0===o.nextBoard){var e=this.ExtendMove(r,o.pos);e||console.log("move",o,JSON.stringify(r.mPlayedMoves)),this.CopyFrom(e.board)}else this.CopyFrom(o.nextBoard);this.spApplyMove(r,o)},Model.Board.CopyFrom=function(r){this.groupMaxId=r.groupMaxId,this.center=r.center,this.maxLayer=r.maxLayer,this.zSign=r.zSign,this.mWho=r.mWho,this.moveEvaluation=r.moveEvaluation,this.board=[],this.ballCount=[0,r.ballCount[1],r.ballCount[2]];for(var o=0;o<r.board.length;o++)this.board.push(r.board[o]);this.playables={};for(var o in r.playables)this.playables[o]=!0;this.groups={};for(var e in r.groups){var t=r.groups[e],i={side:t.side,p:{},pCount:t.pCount,f:{},fCount:t.fCount};for(var o in t.p)i.p[o]=!0;for(var o in t.f)i.f[o]=!0;this.groups[e]=i}this.posFree={};for(var o in r.posFree){var a={};for(var n in r.posFree[o])a[n]=!0;this.posFree[o]=a}this.posGroup={};for(var o in r.posGroup)this.posGroup[o]=r.posGroup[o];r.height?this.height=[0,r.height[1],r.height[2]]:this.height=[0,0,0],void 0!==r.mEvaluation&&(this.mEvaluation=r.mEvaluation),void 0!==r.mFinished&&(this.mFinished=r.mFinished),void 0!==r.mWinner&&(this.mWinner=r.mWinner)},Model.Game.Save=function(){for(var r={playedMoves:[],game:JoclyHub.modelName},o=0;o<this.mPlayedMoves.length;o++){var e=new(this.GetMoveClass())(this.mPlayedMoves[o]);delete e.nextBoard,delete e.remove,delete e.boardJSON,r.playedMoves.push(e)}var t=new Date;if(r.date=t.getFullYear()+"-"+(t.getMonth()+1)+"-"+t.getDate()+"-"+t.getHours()+"_"+t.getMinutes()+"_"+t.getSeconds(),JoclyHub.network.connected){$(".jocly-temp").remove();var i=document.createElement("form");i.setAttribute("class","jocly-temp"),i.setAttribute("style","display: none;"),i.setAttribute("method","post"),i.setAttribute("action","/jocly/save-game");var a=document.createElement("input");a.setAttribute("type","hidden"),a.setAttribute("name","data"),a.setAttribute("value",JSON.stringify(r)),i.appendChild(a),document.body.appendChild(i),i.submit()}else{var n=r.game+"-"+r.date+".joc",s="data:application/x-joc;filename="+n+","+encodeURIComponent(JSON.stringify(r));window.open(s,n)}},Model.Move.Strip=function(){if(void 0!==this.nextBoard||void 0!==this.remove){var r={};for(var o in this)this.hasOwnProperty(o)&&"nextBoard"!=o&&(r[o]=JSON.parse(JSON.stringify(this[o])));return r}return this};

/***/ }),

/***/ "gTfM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;

/*
||==================================================================================
|| DESCRIPTION OF IMPLEMENTATION PRINCIPLES
|| A. Position for rules (internal representation): string with length 56.
||    Special numbering for easy applying rules.
||    Valid characters: b B w W 0 -
||       b (black) B (black king) w (white) W (white king) 0 (empty) (- unused)
||    Examples:
||      '-bbbBBB000w-wwWWWwwwww-bbbbbbbbbb-000wwwwwww-00bbbwwWW0-'
||      '-0000000000-0000000000-0000000000-0000000000-0000000000-'  (empty position)
||      '-bbbbbbbbbb-bbbbbbbbbb-0000000000-wwwwwwwwww-wwwwwwwwww-'  (start position)
|| B. Position (external respresentation): string with length 51.
||    Square numbers are represented by the position of the characters.
||    Position 0 is reserved for the side to move (B or W)
||    Valid characters: b B w W 0
||       b (black) B (black king) w (white) W (white king) 0 (empty)
||    Examples:
||       'B00000000000000000000000000000000000000000000000000'  (empty position)
||       'Wbbbbbbbbbbbbbbbbbbbb0000000000wwwwwwwwwwwwwwwwwwww'  (start position)
||       'WbbbbbbBbbbbb00bbbbb000000w0W00ww00wwwwww0wwwwwwwww'  (random position)
||
|| External numbering      Internal Numbering
|| --------------------    --------------------
||   01  02  03  04  05      01  02  03  04  05
|| 06  07  08  09  10      06  07  08  09  10
||   11  12  13  14  15      12  13  14  15  16
|| 16  17  18  19  20      17  18  19  20  21
||   21  22  23  24  25      23  24  25  26  27
|| 26  27  28  29  30      28  29  30  31  32
||   31  32  33  34  35      34  35  36  37  38
|| 36  37  38  39  40      39  40  41  42  43
||   41  42  43  44  45      45  46  47  48  49
|| 46  47  48  49  50      50  51  52  53  54
|| --------------------    --------------------
||
|| Internal numbering has fixed direction increments for easy applying rules:
||   NW   NE         -5   -6
||     \ /             \ /
||     sQr     >>      sQr
||     / \             / \
||   SW   SE         +5   +6
||
|| DIRECTION-STRINGS
|| Strings of variable length for each of four directions at one square.
|| Each string represents the position in that direction.
|| Directions: NE, SE, SW, NW (wind directions)
|| Example for square 29 (internal number):
||   NE: 29, 24, 19, 14, 09, 04     b00bb0
||   SE: 35, 41, 47, 53             bww0
||   SW: 34, 39                     b0
||   NW: 23, 17                     bw
|| CONVERSION internal to external representation of numbers.
||   N: external number, values 1..50
||   M: internal number, values 0..55 (invalid 0,11,22,33,44,55)
||   Formulas:
||   M = N + floor((N-1)/10)
||   N = M - floor((M-1)/11)
||
||==================================================================================
*/
var Draughts = function (fen) {
  var BLACK = 'B'
  var WHITE = 'W'
  // var EMPTY = -1
  var MAN = 'b'
  var KING = 'w'
  var SYMBOLS = 'bwBW'
  var DEFAULT_FEN = 'W:W31-50:B1-20'
  var position
  var DEFAULT_POSITION_INTERNAL = '-bbbbbbbbbb-bbbbbbbbbb-0000000000-wwwwwwwwww-wwwwwwwwww-'
  var DEFAULT_POSITION_EXTERNAL = 'Wbbbbbbbbbbbbbbbbbbbb0000000000wwwwwwwwwwwwwwwwwwww'
  var STEPS = {NE: -5, SE: 6, SW: 5, NW: -6}
  var POSSIBLE_RESULTS = ['2-0', '0-2', '1-1', '0-0', '*', '1-0', '0-1']
  var FLAGS = {
    NORMAL: 'n',
    CAPTURE: 'c',
    PROMOTION: 'p'
  }

  var UNICODES = {
    'w': '\u26C0',
    'b': '\u26C2',
    'B': '\u26C3',
    'W': '\u26C1',
    '0': '\u0020\u0020'
  }

  var SIGNS = {
    n: '-',
    c: 'x'
  }
  var BITS = {
    NORMAL: 1,
    CAPTURE: 2,
    PROMOTION: 4
  }

  var turn = WHITE
  var moveNumber = 1
  var history = []
  var header = {}

  if (!fen) {
    position = DEFAULT_POSITION_INTERNAL
    load(DEFAULT_FEN)
  } else {
    position = DEFAULT_POSITION_INTERNAL
    load(fen)
  }

  function clear () {
    position = DEFAULT_POSITION_INTERNAL
    turn = WHITE
    moveNumber = 1
    history = []
    header = {}
    update_setup(generate_fen())
  }

  function reset () {
    load(DEFAULT_FEN)
  }

  function load (fen) {
    // TODO for default fen
    if (!fen || fen === DEFAULT_FEN) {
      position = DEFAULT_POSITION_INTERNAL
      update_setup(generate_fen(position))
      return true
    }
    // fen_constants(dimension) //TODO for empty fens

    var checkedFen = validate_fen(fen)
    if (!checkedFen.valid) {
      console.error('Fen Error', fen, checkedFen)
      return false
    }

    clear()

    // remove spaces
    fen = fen.replace(/\s+/g, '')
    // remove suffixes
    fen.replace(/\..*$/, '')

    var tokens = fen.split(':')
    // which side to move
    turn = tokens[0].substr(0, 1)

    // var positions = new Array()
    var externalPosition = DEFAULT_POSITION_EXTERNAL
    for (var i = 1; i <= externalPosition.length; i++) {
      externalPosition = setCharAt(externalPosition, i, 0)
    }
    externalPosition = setCharAt(externalPosition, 0, turn)
    // TODO refactor
    for (var k = 1; k <= 2; k++) {
      // TODO called twice
      var color = tokens[k].substr(0, 1)
      var sideString = tokens[k].substr(1)
      if (sideString.length === 0) continue
      var numbers = sideString.split(',')
      for (i = 0; i < numbers.length; i++) {
        var numSquare = numbers[i]
        var isKing = (numSquare.substr(0, 1) === 'K')
        numSquare = (isKing === true ? numSquare.substr(1) : numSquare) // strip K
        var range = numSquare.split('-')
        if (range.length === 2) {
          var from = parseInt(range[0], 10)
          var to = parseInt(range[1], 10)
          for (var j = from; j <= to; j++) {
            externalPosition = setCharAt(externalPosition, j, (isKing === true ? color.toUpperCase() : color.toLowerCase()))
          }
        } else {
          numSquare = parseInt(numSquare, 10)
          externalPosition = setCharAt(externalPosition, numSquare, (isKing === true ? color.toUpperCase() : color.toLowerCase()))
        }
      }
    }

    position = convertPosition(externalPosition, 'internal')
    update_setup(generate_fen(position))

    return true
  }

  function validate_fen (fen) {
    var errors = [
      {
        code: 0,
        message: 'no errors'
      },
      {
        code: 1,
        message: 'fen position not a string'
      },
      {
        code: 2,
        message: 'fen position has not colon at second position'
      },
      {
        code: 3,
        message: 'fen position has not 2 colons'
      },
      {
        code: 4,
        message: 'side to move of fen position not valid'
      },
      {
        code: 5,
        message: 'color(s) of sides of fen position not valid'
      },
      {
        code: 6,
        message: 'squares of fen position not integer'
      },
      {
        code: 7,
        message: 'squares of fen position not valid'
      },
      {
        code: 8,
        message: 'empty fen position'
      }
    ]

    if (typeof fen !== 'string') {
      return {valid: false, error: errors[0], fen: fen}
    }

    fen = fen.replace(/\s+/g, '')

    if (fen === 'B::' || fen === 'W::' || fen === '?::') {
      return {valid: true, fen: fen + ':B:W'} // exception allowed i.e. empty fen
    }
    fen = fen.trim()
    fen = fen.replace(/\..*$/, '')

    if (fen === '') {
      return {valid: false, error: errors[7], fen: fen}
    }

    if (fen.substr(1, 1) !== ':') {
      return {valid: false, error: errors[1], fen: fen}
    }

    // fen should be 3 sections separated by colons
    var parts = fen.split(':')
    if (parts.length !== 3) {
      return {valid: false, error: errors[2], fen: fen}
    }

    //  which side to move
    var turnColor = parts[0]
    if (turnColor !== 'B' && turnColor !== 'W' && turnColor !== '?') {
      return {valid: false, error: errors[3], fen: fen}
    }

    // check colors of both sides
    var colors = parts[1].substr(0, 1) + parts[2].substr(0, 1)
    if (colors !== 'BW' && colors !== 'WB') {
      return {valid: false, error: errors[4], fen: fen}
    }

    // check parts for both sides
    for (var k = 1; k <= 2; k += 1) {
      var sideString = parts[k].substr(1) // Stripping color
      if (sideString.length === 0) {
        continue
      }
      var numbers = sideString.split(',')
      for (var i = 0; i < numbers.length; i++) {
        var numSquare = numbers[i]
        var isKing = (numSquare.substr(0, 1) === 'K')
        numSquare = (isKing === true ? numSquare.substr(1) : numSquare)
        var range = numSquare.split('-')
        if (range.length === 2) {
          if (isInteger(range[0]) === false) {
            return {valid: false, error: errors[5], fen: fen, range: range[0]}
          }
          if (!(range[0] >= 1 && range[0] <= 100)) {
            return {valid: false, error: errors[6], fen: fen}
          }
          if (isInteger(range[1]) === false) {
            return {valid: false, error: errors[5], fen: fen}
          }
          if (!(range[1] >= 1 && range[1] <= 100)) {
            return {valid: false, error: errors[6], fen: fen}
          }
        } else {
          if (isInteger(numSquare) === false) {
            return {valid: false, error: errors[5], fen: fen}
          }
          if (!(numSquare >= 1 && numSquare <= 100)) {
            return {valid: false, error: errors[6], fen: fen}
          }
        }
      }
    }

    return {valid: true, error_number: 0, error: errors[0]}
  }

  function generate_fen () {
    var black = []
    var white = []
    var externalPosition = convertPosition(position, 'external')
    for (var i = 0; i < externalPosition.length; i++) {
      switch (externalPosition[i]) {
        case 'w':
          white.push(i)
          break
        case 'W':
          white.push('K' + i)
          break
        case 'b':
          black.push(i)
          break
        case 'B':
          black.push('K' + i)
          break
        default:
          break
      }
    }
    return turn.toUpperCase() + ':W' + white.join(',') + ':B' + black.join(',')
  }

  function generatePDN (options) {
    // for html usage {maxWidth: 72, newline_char: "<br />"}
    var newline = (typeof options === 'object' && typeof options.newline_char === 'string')
      ? options.newline_char : '\n'
    var maxWidth = (typeof options === 'object' && typeof options.maxWidth === 'number')
      ? options.maxWidth : 0
    var result = []
    var headerExists = false

    for (var i in header) {
      result.push('[' + i + ' "' + header[i] + '"]' + newline)
      headerExists = true
    }

    if (headerExists && history.length) {
      result.push(newline)
    }

    var tempHistory = clone(history)

    var moves = []
    var moveString = ''
    var moveNumber = 1

    while (tempHistory.length > 0) {
      var move = tempHistory.shift()
      if (move.turn === 'W') {
        moveString += moveNumber + '. '
      }
      moveString += move.move.from
      if (move.move.flags === 'c') {
        moveString += 'x'
      } else {
        moveString += '-'
      }
      moveString += move.move.to
      moveString += ' '
      moveNumber += 1
    }

    if (moveString.length) {
      moves.push(moveString)
    }

    // TODO resutl from pdn or header??
    if (typeof header.Result !== 'undefined') {
      moves.push(header.Result)
    }

    if (maxWidth === 0) {
      return result.join('') + moves.join(' ')
    }

    var currentWidth = 0
    for (i = 0; i < moves.length; i++) {
      if (currentWidth + moves[i].length > maxWidth && i !== 0) {
        if (result[result.length - 1] === ' ') {
          result.pop()
        }

        result.push(newline)
        currentWidth = 0
      } else if (i !== 0) {
        result.push(' ')
        currentWidth++
      }
      result.push(' ')
      currentWidth += moves[i].length
    }

    return result.join('')
  }

  function set_header (args) {
    for (var i = 0; i < args.length; i += 2) {
      if (typeof args[i] === 'string' && typeof args[i + 1] === 'string') {
        header[args[i]] = args[i + 1]
      }
    }
    return header
  }

  /* called when the initial board setup is changed with put() or remove().
   * modifies the SetUp and FEN properties of the header object.  if the FEN is
   * equal to the default position, the SetUp and FEN are deleted
   * the setup is only updated if history.length is zero, ie moves haven't been
   * made.
   */
  function update_setup (fen) {
    if (history.length > 0) {
      return false
    }
    if (fen !== DEFAULT_FEN) {
      header['SetUp'] = '1'
      header['FEN'] = fen
    } else {
      delete header['SetUp']
      delete header['FEN']
    }
  }

  function parsePDN (pdn, options) {
    var newline_char = (typeof options === 'object' &&
    typeof options.newline_char === 'string')
      ? options.newline_char : '\r?\n'
    var regex = new RegExp('^(\\[(.|' + mask(newline_char) + ')*\\])' +
      '(' + mask(newline_char) + ')*' +
      '1.(' + mask(newline_char) + '|.)*$', 'g')

    function mask (str) {
      return str.replace(/\\/g, '\\')
    }

    function parsePDNHeader (header, options) {
      var headerObj = {}
      var headers = header.split(new RegExp(mask(newline_char)))
      var key = ''
      var value = ''

      for (var i = 0; i < headers.length; i++) {
        key = headers[i].replace(/^\[([A-Z][A-Za-z]*)\s.*\]$/, '$1')
        value = headers[i].replace(/^\[[A-Za-z]+\s"(.*)"\]$/, '$1')
        if (trim(key).length > 0) {
          headerObj[key] = value
        }
      }

      return headerObj
    }

    var headerString = pdn.replace(regex, '$1')
    if (headerString[0] !== '[') {
      headerString = ''
    }

    reset()

    var headers = parsePDNHeader(headerString, options)

    for (var key in headers) {
      set_header([key, headers[key]])
    }

    if (headers['Setup'] === '1') {
      if (!(('FEN' in headers) && load(headers['FEN']))) {
        console.error('fen invalid')
        return false
      }
    } else {
      position = DEFAULT_POSITION_INTERNAL
    }

    /* delete header to get the moves */
    var ms = pdn.replace(headerString, '').replace(new RegExp(mask(newline_char), 'g'), ' ')

    /* delete comments */
    ms = ms.replace(/(\{[^}]+\})+?/g, '')

    /* delete recursive annotation variations */
    var rav_regex = /(\([^\(\)]+\))+?/g
    while (rav_regex.test(ms)) {
      ms = ms.replace(rav_regex, '')
    }

    /* delete move numbers */
    // TODO not working for move numbers with space
    ms = ms.replace(/\d+\./g, '')

    /* delete ... indicating black to move */
    ms = ms.replace(/\.\.\./g, '')

    /* trim and get array of moves */
    var moves = trim(ms).split(new RegExp(/\s+/))

    /* delete empty entries */
    moves = moves.join(',').replace(/,,+/g, ',').split(',')

    var move = ''
    for (var half_move = 0; half_move < moves.length - 1; half_move += 1) {
      move = getMoveObject(moves[half_move])
      if (!move) {
        return false
      } else {
        makeMove(move)
      }
    }

    var result = moves[moves.length - 1]
    if (POSSIBLE_RESULTS.indexOf(result) > -1) {
      if (headers['Result'] === 'undefined') {
        set_header(['Result', result])
      }
    } else {
      move = getMoveObject(result)
      if (!move) {
        return false
      } else {
        makeMove(move)
      }
    }
    return true
  }

  function getMoveObject (move) {
    // TODO move flags for both capture and promote??
    var tempMove = {}
    var matches = move.split(/[x|-]/)
    tempMove.from = parseInt(matches[0], 10)
    tempMove.to = parseInt(matches[1], 10)
    var moveType = move.match(/[x|-]/)[0]
    if (moveType === '-') {
      tempMove.flags = FLAGS.NORMAL
    } else {
      tempMove.flags = FLAGS.CAPTURE
    }
    tempMove.piece = position.charAt(convertNumber(tempMove.from, 'internal'))
    var moves = getLegalMoves(tempMove.from)
    moves = convertMoves(moves, 'external')
    // if move legal then make move
    for (var i = 0; i < moves.length; i += 1) {
      if (tempMove.to === moves[i].to && tempMove.from === moves[i].from) {
        if (moves[i].takes.length > 0) {
          tempMove.flags = FLAGS.CAPTURE
          tempMove.captures = moves[i].takes
          tempMove.takes = moves[i].takes
          tempMove.piecesCaptured = moves[i].piecesTaken
        }
        return tempMove
      }
    }
    console.log(moves, tempMove)
    return false
  }

  function makeMove (move) {
    move.piece = position.charAt(convertNumber(move.from, 'internal'))
    position = setCharAt(position, convertNumber(move.to, 'internal'), move.piece)
    position = setCharAt(position, convertNumber(move.from, 'internal'), 0)
    move.flags = FLAGS.NORMAL
    // TODO refactor to either takes or capture
    if (move.takes && move.takes.length) {
      move.flags = FLAGS.CAPTURE
      move.captures = move.takes
      move.piecesCaptured = move.piecesTaken
      for (var i = 0; i < move.takes.length; i++) {
        position = setCharAt(position, convertNumber(move.takes[i], 'internal'), 0)
      }
    }
    // Promoting piece here
    if (move.to <= 5 && move.piece === 'w') {
      move.flags = FLAGS.PROMOTION
      position = setCharAt(position, convertNumber(move.to, 'internal'), move.piece.toUpperCase())
    } else if (move.to >= 46 && move.piece === 'b') {
      position = setCharAt(position, convertNumber(move.to, 'internal'), move.piece.toUpperCase())
    }
    push(move)
    if (turn === BLACK) {
      moveNumber += 1
    }
    turn = swap_color(turn)
  }

  function get (square) {
    var piece = position.charAt(convertNumber(square, 'internal'))
    return piece
  }

  function put (piece, square) {
    // check for valid piece string
    if (SYMBOLS.match(piece) === null) {
      return false
    }

    // check for valid square
    if (outsideBoard(convertNumber(square, 'internal')) === true) {
      return false
    }
    position = setCharAt(position, convertNumber(square, 'internal'), piece)
    update_setup(generate_fen())

    return true
  }

  function remove (square) {
    var piece = get(square)
    position = setCharAt(position, convertNumber(square, 'internal'), 0)
    update_setup(generate_fen())

    return piece
  }

  function build_move (board, from, to, flags, promotion) {
    var move = {
      color: turn,
      from: from,
      to: to,
      flags: flags,
      piece: board[from].type
    }

    if (promotion) {
      move.flags |= BITS.PROMOTION
    }

    if (board[to]) {
      move.captured = board[to].type
    } else if (flags & BITS.CAPTURE) {
      move.captured = MAN
    }
    return move
  }

  function generate_moves (square) {
    var moves = []

    if (square) {
      moves = getLegalMoves(square.square)
    } else {
      var tempCaptures = getCaptures()
      // TODO change to be applicable to array
      if (tempCaptures.length) {
        for (var i = 0; i < tempCaptures.length; i++) {
          tempCaptures[i].flags = FLAGS.CAPTURE
          tempCaptures[i].captures = tempCaptures[i].jumps
          tempCaptures[i].piecesCaptured = tempCaptures[i].piecesTaken
        }
        return tempCaptures
      }
      moves = getMoves()
    }
    // TODO returns [] for on hovering for square no
    moves = [].concat.apply([], moves)
    return moves
  }

  function getLegalMoves (index) {
    var legalMoves
    index = parseInt(index, 10)
    if (!Number.isNaN(index)) {
      index = convertNumber(index, 'internal')

      var captures = capturesAtSquare(index, {position: position, dirFrom: ''}, {jumps: [index], takes: [], piecesTaken: []})

      captures = longestCapture(captures)
      legalMoves = captures
      if (captures.length === 0) {
        legalMoves = movesAtSquare(index)
      }
    }
    // TODO called on hover ??
    return convertMoves(legalMoves, 'external')
  }

  function getMoves (index) {
    var moves = []
    var us = turn

    for (var i = 1; i < position.length; i++) {
      if (position[i] === us || position[i] === us.toLowerCase()) {
        var tempMoves = movesAtSquare(i)
        if (tempMoves.length) {
          moves = moves.concat(convertMoves(tempMoves, 'external'))
        }
      }
    }
    return moves
  }

  function setCharAt (position, idx, chr) {
    idx = parseInt(idx, 10)
    if (idx > position.length - 1) {
      return position.toString()
    } else {
      return position.substr(0, idx) + chr + position.substr(idx + 1)
    }
  }

  function movesAtSquare (square) {
    var moves = []
    var posFrom = square
    var piece = position.charAt(posFrom)
    // console.trace(piece, square, 'movesAtSquare')
    switch (piece) {
      case 'b':
      case 'w':
        var dirStrings = directionStrings(position, posFrom, 2)
        for (var dir in dirStrings) {
          var str = dirStrings[dir]

          var matchArray = str.match(/^[bw]0/) // e.g. b0 w0
          if (matchArray !== null && validDir(piece, dir) === true) {
            var posTo = posFrom + STEPS[dir]
            var moveObject = {from: posFrom, to: posTo, takes: [], jumps: []}
            moves.push(moveObject)
          }
        }
        break
      case 'W':
      case 'B':
        dirStrings = directionStrings(position, posFrom, 2)
        for (dir in dirStrings) {
          str = dirStrings[dir]

          matchArray = str.match(/^[BW]0+/) // e.g. B000, W0
          if (matchArray !== null) {
            for (var i = 0; i < matchArray[0].length; i++) {
              posTo = posFrom + (i * STEPS[dir])
              moveObject = {from: posFrom, to: posTo, takes: [], jumps: []}
              moves.push(moveObject)
            }
          }
        }
        break
      default:
        return moves
    }
    return moves
  }

  function getCaptures () {
    var us = turn
    var captures = []
    for (var i = 0; i < position.length; i++) {
      if (position[i] === us || position[i] === us.toLowerCase()) {
        var posFrom = i
        var state = {position: position, dirFrom: ''}
        var capture = {jumps: [], takes: [], from: posFrom, to: '', piecesTaken: []}
        capture.jumps[0] = posFrom
        var tempCaptures = capturesAtSquare(posFrom, state, capture)
        if (tempCaptures.length) {
          captures = captures.concat(convertMoves(tempCaptures, 'external'))
        }
      }
    }
    captures = longestCapture(captures)
    return captures
  }

  function capturesAtSquare (posFrom, state, capture) {
    var piece = state.position.charAt(posFrom)
    if (piece !== 'b' && piece !== 'w' && piece !== 'B' && piece !== 'W') {
      return [capture]
    }
    var dirString
    if (piece === 'b' || piece === 'w') {
      dirString = directionStrings(state.position, posFrom, 3)
    } else {
      dirString = directionStrings(state.position, posFrom)
    }
    var finished = true
    var captureArrayForDir = {}
    for (var dir in dirString) {
      if (dir === state.dirFrom) {
        continue
      }
      var str = dirString[dir]
      switch (piece) {
        case 'b':
        case 'w':
          var matchArray = str.match(/^b[wW]0|^w[bB]0/) // matches: bw0, bW0, wB0, wb0
          if (matchArray !== null) {
            var posTo = posFrom + (2 * STEPS[dir])
            var posTake = posFrom + (1 * STEPS[dir])
            if (capture.takes.indexOf(posTake) > -1) {
              continue // capturing twice forbidden
            }
            var updateCapture = clone(capture)
            updateCapture.to = posTo
            updateCapture.jumps.push(posTo)
            updateCapture.takes.push(posTake)
            updateCapture.piecesTaken.push(position.charAt(posTake))
            updateCapture.from = posFrom
            var updateState = clone(state)
            updateState.dirFrom = oppositeDir(dir)
            var pieceCode = updateState.position.charAt(posFrom)
            updateState.position = setCharAt(updateState.position, posFrom, 0)
            updateState.position = setCharAt(updateState.position, posTo, pieceCode)
            finished = false
            captureArrayForDir[dir] = capturesAtSquare(posTo, updateState, updateCapture)
          }
          break
        case 'B':
        case 'W':
          matchArray = str.match(/^B0*[wW]0+|^W0*[bB]0+/) // matches: B00w000, WB00
          if (matchArray !== null) {
            var matchStr = matchArray[0]
            var matchArraySubstr = matchStr.match(/[wW]0+$|[bB]0+$/) // matches: w000, B00
            var matchSubstr = matchArraySubstr[0]
            var takeIndex = matchStr.length - matchSubstr.length
            posTake = posFrom + (takeIndex * STEPS[dir])
            if (capture.takes.indexOf(posTake) > -1) {
              continue
            }
            for (var i = 1; i < matchSubstr.length; i++) {
              posTo = posFrom + ((takeIndex + i) * STEPS[dir])
              updateCapture = clone(capture)
              updateCapture.jumps.push(posTo)
              updateCapture.to = posTo
              updateCapture.takes.push(posTake)
              updateCapture.piecesTaken.push(position.charAt(posTake))
              updateCapture.posFrom = posFrom
              updateState = clone(state)
              updateState.dirFrom = oppositeDir(dir)
              pieceCode = updateState.position.charAt(posFrom)
              updateState.position = setCharAt(updateState.position, posFrom, 0)
              updateState.position = setCharAt(updateState.position, posTo, pieceCode)
              finished = false
              var dirIndex = dir + i.toString()
              captureArrayForDir[dirIndex] = capturesAtSquare(posTo, updateState, updateCapture)
            }
          }
          break
        default:
          captureArrayForDir = []
      }
    }
    var captureArray = []
    if (finished === true && capture.takes.length) {
      // fix for mutiple capture
      capture.from = capture.jumps[0]
      captureArray[0] = capture
    } else {
      for (dir in captureArrayForDir) {
        captureArray = captureArray.concat(captureArrayForDir[dir])
      }
    }
    return captureArray
  }

  function push (move) {
    history.push({
      move: move,
      turn: turn,
      moveNumber: moveNumber
    })
  }

  function undoMove () {
    var old = history.pop()
    if (!old) {
      return null
    }

    var move = old.move
    turn = old.turn
    moveNumber = old.moveNumber

    position = setCharAt(position, convertNumber(move.from, 'internal'), move.piece)
    position = setCharAt(position, convertNumber(move.to, 'internal'), 0)
    if (move.flags === 'c') {
      for (var i = 0; i < move.captures.length; i += 1) {
        position = setCharAt(position, convertNumber(move.captures[i], 'internal'), move.piecesCaptured[i])
      }
    } else if (move.flags === 'p') {
      position = setCharAt(position, convertNumber(move.from, 'internal'), move.piece.toLowerCase())
    }
    return move
  }

  function get_disambiguator (move) {

  }

  function swap_color (c) {
    return c === WHITE ? BLACK : WHITE
  }

  function isInteger (int) {
    var regex = /^\d+$/
    if (regex.test(int)) {
      return true
    } else {
      return false
    }
  }

  function longestCapture (captures) {
    var maxJumpCount = 0
    for (var i = 0; i < captures.length; i++) {
      var jumpCount = captures[i].jumps.length
      if (jumpCount > maxJumpCount) {
        maxJumpCount = jumpCount
      }
    }

    var selectedCaptures = []
    if (maxJumpCount < 2) {
      return selectedCaptures
    }

    for (i = 0; i < captures.length; i++) {
      if (captures[i].jumps.length === maxJumpCount) {
        selectedCaptures.push(captures[i])
      }
    }
    return selectedCaptures
  }

  function convertMoves (moves, type) {
    var tempMoves = []
    if (!type || moves.length === 0) {
      return tempMoves
    }
    for (var i = 0; i < moves.length; i++) {
      var moveObject = {jumps: [], takes: []}
      moveObject.from = convertNumber(moves[i].from, type)
      for (var j = 0; j < moves[i].jumps.length; j++) {
        moveObject.jumps[j] = convertNumber(moves[i].jumps[j], type)
      }
      for (j = 0; j < moves[i].takes.length; j++) {
        moveObject.takes[j] = convertNumber(moves[i].takes[j], type)
      }
      moveObject.to = convertNumber(moves[i].to, type)
      moveObject.piecesTaken = moves[i].piecesTaken
      tempMoves.push(moveObject)
    }
    return tempMoves
  }

  function convertNumber (number, notation) {
    var num = parseInt(number, 10)
    var result
    switch (notation) {
      case 'internal':
        result = num + Math.floor((num - 1) / 10)
        break
      case 'external':
        result = num - Math.floor((num - 1) / 11)
        break
      default:
        result = num
    }
    return result
  }

  function convertPosition (position, notation) {
    var sub1, sub2, sub3, sub4, sub5, newPosition
    switch (notation) {
      case 'internal':
        sub1 = position.substr(1, 10)
        sub2 = position.substr(11, 10)
        sub3 = position.substr(21, 10)
        sub4 = position.substr(31, 10)
        sub5 = position.substr(41, 10)
        newPosition = '-' + sub1 + '-' + sub2 + '-' + sub3 + '-' + sub4 + '-' + sub5 + '-'
        break
      case 'external':
        sub1 = position.substr(1, 10)
        sub2 = position.substr(12, 10)
        sub3 = position.substr(23, 10)
        sub4 = position.substr(34, 10)
        sub5 = position.substr(45, 10)
        newPosition = '?' + sub1 + sub2 + sub3 + sub4 + sub5
        break
      default:
        newPosition = position
    }
    return newPosition
  }

  function outsideBoard (square) {
    // internal notation only
    var n = parseInt(square, 10)
    if (n >= 0 && n <= 55 && (n % 11) !== 0) {
      return false
    } else {
      return true
    }
  }

  function directionStrings (tempPosition, square, maxLength) {
    // Create direction strings for square at position (internal representation)
    // Output object with four directions as properties (four rhumbs).
    // Each property has a string as value representing the pieces in that direction.
    // Piece of the given square is part of each string.
    // Example of output: {NE: 'b0', SE: 'b00wb00', SW: 'bbb00', NW: 'bb'}
    // Strings have maximum length of given maxLength.
    if (arguments.length === 2) {
      maxLength = 100
    }
    var dirStrings = {}
    if (outsideBoard(square) === true) {
      return 334
    }

    for (var dir in STEPS) {
      var dirArray = []
      var i = 0
      var index = square
      do {
        dirArray[i] = tempPosition.charAt(index)
        i++
        index = square + i * STEPS[dir]
        var outside = outsideBoard(index)
      } while (outside === false && i < maxLength)

      dirStrings[dir] = dirArray.join('')
    }

    return dirStrings
  }

  function oppositeDir (direction) {
    var opposite = {NE: 'SW', SE: 'NW', SW: 'NE', NW: 'SE'}
    return opposite[direction]
  }

  function validDir (piece, dir) {
    var validDirs = {}
    validDirs.w = {NE: true, SE: false, SW: false, NW: true}
    validDirs.b = {NE: false, SE: true, SW: true, NW: false}
    return validDirs[piece][dir]
  }

  function ascii (unicode) {
    var extPosition = convertPosition(position, 'external')
    var s = '\n+-------------------------------+\n'
    var i = 1
    for (var row = 1; row <= 10; row++) {
      s += '|\t'
      if (row % 2 !== 0) {
        s += '  '
      }
      for (var col = 1; col <= 10; col++) {
        if (col % 2 === 0) {
          s += '  '
          i++
        } else {
          if (unicode) {
            s += ' ' + UNICODES[extPosition[i]]
          } else {
            s += ' ' + extPosition[i]
          }
        }
      }
      if (row % 2 === 0) {
        s += '  '
      }
      s += '\t|\n'
    }
    s += '+-------------------------------+\n'
    return s
  }

  function gameOver () {
    // First check if any piece left
    for (var i = 0; i < position.length; i++) {
      if (position[i].toLowerCase() === turn.toLowerCase()) {
        // if moves left game not over
        return generate_moves().length === 0
      }
    }
    return true
  }

  function getHistory (options) {
    var tempHistory = clone(history)
    var moveHistory = []
    var verbose = (typeof options !== 'undefined' && 'verbose' in options && options.verbose)
    while (tempHistory.length > 0) {
      var move = tempHistory.shift()
      if (verbose) {
        moveHistory.push(makePretty(move))
      } else {
        moveHistory.push(move.move.from + SIGNS[move.move.flags] + move.move.to)
      }
    }

    return moveHistory
  }

  function getPosition () {
    return convertPosition(position, 'external')
  }

  function makePretty (uglyMove) {
    var move = {}
    move.from = uglyMove.move.from
    move.to = uglyMove.move.to
    move.flags = uglyMove.move.flags
    move.moveNumber = uglyMove.moveNumber
    move.piece = uglyMove.move.piece
    if (move.flags === 'c') {
      move.captures = uglyMove.move.captures.join(',')
    }
    return move
  }

  function clone (obj) {
    var dupe = JSON.parse(JSON.stringify(obj))
    return dupe
  }

  function trim (str) {
    return str.replace(/^\s+|\s+$/g, '')
  }

  // TODO
  function perft (depth) {
    var moves = generate_moves({legal: false})
    var nodes = 0

    for (var i = 0; i < moves.length; i++) {
      makeMove(moves[i])
      if (depth - 1 > 0) {
        var child_nodes = perft(depth - 1)
        nodes += child_nodes
      } else {
        nodes++
      }
      undoMove()
    }

    return nodes
  }

  return {
    WHITE: WHITE,
    BLACK: BLACK,
    MAN: MAN,
    KING: KING,
    FLAGS: FLAGS,
    SQUARES: 'A8',

    load: function (fen) {
      return load(fen)
    },

    reset: function () {
      return reset()
    },

    moves: generate_moves,

    gameOver: gameOver,

    inDraw: function () {
      return false
    },

    validate_fen: validate_fen,

    fen: generate_fen,

    pdn: generatePDN,

    load_pdn: function (pdn, options) {},

    parsePDN: parsePDN,

    header: function () {
      return set_header(arguments)
    },

    ascii: ascii,

    turn: function () {
      return turn.toLowerCase()
    },

    move: function move (move) {
      if (typeof move.to === 'undefined' && typeof move.from === 'undefined') {
        return false
      }
      move.to = parseInt(move.to, 10)
      move.from = parseInt(move.from, 10)
      var moves = generate_moves()
      for (var i = 0; i < moves.length; i++) {
        if ((move.to === moves[i].to) && (move.from === moves[i].from)) {
          makeMove(moves[i])
          return moves[i]
        }
      }
      return false
    },

    getMoves: getMoves,

    getLegalMoves: getLegalMoves,

    undo: function () {
      var move = undoMove()
      return move || null
    },

    clear: function () {
      return clear()
    },

    put: function (piece, square) {
      return put(piece, square)
    },

    get: function (square) {
      return get(square)
    },

    remove: function (square) {
      return remove(square)
    },

    perft: function (depth) {
      return perft(depth)
    },

    history: getHistory,

    convertMoves: convertMoves,

    convertNumber: convertNumber,

    convertPosition: convertPosition,

    outsideBoard: outsideBoard,

    directionStrings: directionStrings,

    oppositeDir: oppositeDir,

    validDir: validDir,

    position: getPosition,

    clone: clone,

    makePretty: makePretty,

    captures: getCaptures
  }
}

if (true) {
  exports.Draughts = Draughts
}

if (true) {
  !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
    return Draughts
  }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
}


/***/ }),

/***/ "gi2R":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var AsyncAction_1 = __webpack_require__("cwzr");
var AnimationFrame_1 = __webpack_require__("OLzJ");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var AnimationFrameAction = (function (_super) {
    __extends(AnimationFrameAction, _super);
    function AnimationFrameAction(scheduler, work) {
        _super.call(this, scheduler, work);
        this.scheduler = scheduler;
        this.work = work;
    }
    AnimationFrameAction.prototype.requestAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) { delay = 0; }
        // If delay is greater than 0, request as an async action.
        if (delay !== null && delay > 0) {
            return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
        }
        // Push the action to the end of the scheduler queue.
        scheduler.actions.push(this);
        // If an animation frame has already been requested, don't request another
        // one. If an animation frame hasn't been requested yet, request one. Return
        // the current animation frame request id.
        return scheduler.scheduled || (scheduler.scheduled = AnimationFrame_1.AnimationFrame.requestAnimationFrame(scheduler.flush.bind(scheduler, null)));
    };
    AnimationFrameAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) { delay = 0; }
        // If delay exists and is greater than 0, or if the delay is null (the
        // action wasn't rescheduled) but was originally scheduled as an async
        // action, then recycle as an async action.
        if ((delay !== null && delay > 0) || (delay === null && this.delay > 0)) {
            return _super.prototype.recycleAsyncId.call(this, scheduler, id, delay);
        }
        // If the scheduler queue is empty, cancel the requested animation frame and
        // set the scheduled flag to undefined so the next AnimationFrameAction will
        // request its own.
        if (scheduler.actions.length === 0) {
            AnimationFrame_1.AnimationFrame.cancelAnimationFrame(id);
            scheduler.scheduled = undefined;
        }
        // Return undefined so the action knows to request a new async id if it's rescheduled.
        return undefined;
    };
    return AnimationFrameAction;
}(AsyncAction_1.AsyncAction));
exports.AnimationFrameAction = AnimationFrameAction;
//# sourceMappingURL=AnimationFrameAction.js.map

/***/ }),

/***/ "glQv":
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;(function () {
  'use strict'

  var SIZE
  var COLUMNS
  var UNICODES = {
    'w': '\u26C0',
    'b': '\u26C2',
    'B': '\u26C3',
    'W': '\u26C1',
    '0': '  '
  }
  var START_FEN
  function validMove (move) {
    // move should be a string
    if (typeof move !== 'string') return false

    // move should be in the form of "27x31", "23-32"
    var tmp = move.split(/-|x/)
    if (tmp.length !== 2) return false

    return (validSquare(tmp[0]) === true && validSquare(tmp[1]) === true)
  }

  function validSquare (square) {
    if (square && square.substr(0, 1) === 'K') {
      square = square.substr(1)
    }
    square = parseInt(square, 10)
    return (square >= 0 && square < 51)
  }

  function validPieceCode (code) {
    if (typeof code !== 'string') return false
    return (code.search(/^[bwBW]$/) !== -1)
  }

  // TODO: this whole function could probably be replaced with a single regex
  function validFen (fen) {
    if (typeof fen !== 'string') return false
    if (fen === START_FEN) return true
    var FENPattern = /^(W|B):(W|B)((?:K?\d*)(?:,K?\d+)*?)(?::(W|B)((?:K?\d*)(?:,K?\d+)*?))?$/
    var matches = FENPattern.exec(fen)
    if (matches != null) {
      return true
    }
    return false
  }

  function validPositionObject (pos) {
    if (typeof pos !== 'object') return false
    // pos = fenToObj(pos)
    for (var i in pos) {
      if (pos.hasOwnProperty(i) !== true) continue
      if (pos[i] == null) {
        continue
      }
      if (validSquare(i) !== true || validPieceCode(pos[i]) !== true) {
        // TODO console.trace('flsed in valid check', i,pos[i], validSquare(i), validPieceCode(pos[i]))
        return false
      }
    }
    return true
  }

  // convert FEN string to position object
  // returns false if the FEN string is invalid
  function fenToObj (fen) {
    if (validFen(fen) !== true) {
      return false
    }

    // cut off any move, castling, etc info from the end
    // we're only interested in position information
    fen = fen.replace(/\s+/g, '')
    fen = fen.replace(/\..*$/, '')

    var rows = fen.split(':')
    var position = []

    var currentRow = 10
    // var colIndex = 0

    for (var i = 1; i <= 2; i++) {
      var color = rows[i].substr(0, 1)
      var row = rows[i].substr(1)
      var j
      if (row.indexOf('-') !== -1) {
        row = row.split('-')
        for (j = parseInt(row[0], 10); j <= parseInt(row[1], 10); j++) {
          position[j] = color.toLowerCase()
        }
      } else {
        row = row.split(',')
        for (j = 0; j < row.length; j++) {
          if (row[j].substr(0, 1) === 'K') {
            position[row[j].substr(1)] = color.toUpperCase()
          } else {
            position[row[j]] = color.toLowerCase()
          }
        }
      }
      currentRow--
    }

    return position
  }

  // position object to FEN string
  // returns false if the obj is not a valid position object
  function objToFen (obj) {
    if (validPositionObject(obj) !== true) {
      return false
    }
    var black = []
    var white = []
    for (var i = 0; i < obj.length; i++) {
      switch (obj[i]) {
        case 'w':
          white.push(i)
          break
        case 'W':
          white.push('K' + i)
          break
        case 'b':
          black.push(i)
          break
        case 'B':
          black.push('K' + i)
          break
        default:
          break
      }
    }
    return 'w'.toUpperCase() + ':W' + white.join(',') + ':B' + black.join(',')

  // return fen
  }

  window['DraughtsBoard'] = window['DraughtsBoard'] || function (containerElOrId, cfg, board) {
    cfg = cfg || {}
    board = board || 'draughts'
    // ------------------------------------------------------------------------------
    // Constants
    // ------------------------------------------------------------------------------

    var MINIMUM_JQUERY_VERSION = '1.7.0'
    if (board === 'checkers') {
      START_FEN = 'W:W21-32:B1-12'
      SIZE = 8
      COLUMNS = '01234567'.split('')
    } else {
      START_FEN = 'W:W31-50:B1-20'
      SIZE = 10
      COLUMNS = '0123456789'.split('')
    }
    var START_POSITION = fenToObj(START_FEN)

    // use unique class names to prevent clashing with anything else on the page
    // and simplify selectors
    // NOTE: these should never change
    var CSS = {
      alpha: 'alpha-d2270',
      black: 'black-3c85d',
      board: 'board-b72b1',
      draughtsboard: 'draughtsboard-63f37',
      clearfix: 'clearfix-7da63',
      highlight1: 'highlight1-32417',
      highlight2: 'highlight2-9c5d2',
      notation: 'notation-322f9',
      numeric: 'numeric-fc462',
      piece: 'piece-417db',
      row: 'row-5277c',
      sparePieces: 'spare-pieces-7492f',
      sparePiecesBottom: 'spare-pieces-bottom-ae20f',
      sparePiecesTop: 'spare-pieces-top-4028b',
      square: 'square-55d63',
      white: 'white-1e1d7'
    }

    // ------------------------------------------------------------------------------
    // Module Scope Variables
    // ------------------------------------------------------------------------------

    // DOM elements
    var containerEl,
      boardEl,
      draggedPieceEl,
      sparePiecesTopEl,
      sparePiecesBottomEl

    // constructor return object
    var widget = {}

    // ------------------------------------------------------------------------------
    // Stateful
    // ------------------------------------------------------------------------------

    var ANIMATION_HAPPENING = false
    var BOARD_BORDER_SIZE = 2
    var CURRENT_ORIENTATION = 'white'
    var CURRENT_POSITION = {}
    var SQUARE_SIZE
    var DRAGGED_PIECE
    var DRAGGED_PIECE_LOCATION
    var DRAGGED_PIECE_SOURCE
    var DRAGGING_A_PIECE = false
    var SPARE_PIECE_ELS_IDS = {}
    var SQUARE_ELS_IDS = {}
    var SQUARE_ELS_OFFSETS

    // ------------------------------------------------------------------------------
    // JS Util Functions
    // ------------------------------------------------------------------------------

    // http://tinyurl.com/3ttloxj
    function uuid () {
      return 'xxxx-xxxx-xxxx-xxxx-xxxx-xxxx-xxxx-xxxx'.replace(/x/g, function (c) {
        var r = Math.random() * 16 | 0
        return r.toString(16)
      })
    }

    function deepCopy (thing) {
      return JSON.parse(JSON.stringify(thing))
    }

    function parseSemVer (version) {
      var tmp = version.split('.')
      return {
        major: parseInt(tmp[0], 10),
        minor: parseInt(tmp[1], 10),
        patch: parseInt(tmp[2], 10)
      }
    }

    // returns true if version is >= minimum
    function compareSemVer (version, minimum) {
      version = parseSemVer(version)
      minimum = parseSemVer(minimum)

      var versionNum = (version.major * 10000 * 10000) +
        (version.minor * 10000) + version.patch
      var minimumNum = (minimum.major * 10000 * 10000) +
        (minimum.minor * 10000) + minimum.patch

      return (versionNum >= minimumNum)
    }

    // ------------------------------------------------------------------------------
    // Validation / Errors
    // ------------------------------------------------------------------------------

    function error (code, msg, obj) {
      // do nothing if showErrors is not set
      if (cfg.hasOwnProperty('showErrors') !== true ||
        cfg.showErrors === false) {
        return
      }

      var errorText = 'DraughtsBoard Error ' + code + ': ' + msg

      // print to console
      if (cfg.showErrors === 'console' &&
        typeof console === 'object' &&
        typeof console.log === 'function') {
        console.trace(errorText)
        if (arguments.length >= 2) {
          console.log(obj)
        }
        return
      }

      // alert errors
      if (cfg.showErrors === 'alert') {
        if (obj) {
          errorText += '\n\n' + JSON.stringify(obj)
        }
        window.alert(errorText)
        return
      }

      // custom function
      if (typeof cfg.showErrors === 'function') {
        cfg.showErrors(code, msg, obj)
      }
    }

    // check dependencies
    function checkDeps () {
      // if containerId is a string, it must be the ID of a DOM node
      if (typeof containerElOrId === 'string') {
        // cannot be empty
        if (containerElOrId === '') {
          window.alert('DraughtsBoard Error 1001: ' +
            'The first argument to DraughtsBoard() cannot be an empty string.' +
            '\n\nExiting...')
          return false
        }

        // make sure the container element exists in the DOM
        var el = document.getElementById(containerElOrId)
        if (!el) {
          window.alert('DraughtsBoard Error 1002: Element with id "' +
            containerElOrId + '" does not exist in the DOM.' +
            '\n\nExiting...')
          return false
        }

        // set the containerEl
        containerEl = $(el)
      } else {
        // else it must be something that becomes a jQuery collection
        // with size 1
        // ie: a single DOM node or jQuery object
        containerEl = $(containerElOrId)

        if (containerEl.length !== 1) {
          window.alert('DraughtsBoard Error 1003: The first argument to ' +
            'DraughtsBoard() must be an ID or a single DOM node.' +
            '\n\nExiting...')
          return false
        }
      }

      // JSON must exist
      if (!window.JSON ||
        typeof JSON.stringify !== 'function' ||
        typeof JSON.parse !== 'function') {
        window.alert('DraughtsBoard Error 1004: JSON does not exist. ' +
          'Please include a JSON polyfill.\n\nExiting...')
        return false
      }

      // check for a compatible version of jQuery
      if (!(typeof window.$ && $.fn && $.fn.jquery &&
        compareSemVer($.fn.jquery, MINIMUM_JQUERY_VERSION) === true)) {
        window.alert('DraughtsBoard Error 1005: Unable to find a valid version ' +
          'of jQuery. Please include jQuery ' + MINIMUM_JQUERY_VERSION + ' or ' +
          'higher on the page.\n\nExiting...')
        return false
      }

      return true
    }

    function validAnimationSpeed (speed) {
      if (speed === 'fast' || speed === 'slow') {
        return true
      }

      if ((parseInt(speed, 10) + '') !== (speed + '')) {
        return false
      }

      return (speed >= 0)
    }

    // validate config / set default options
    function expandConfig () {
      if (typeof cfg === 'string' || validPositionObject(cfg) === true) {
        cfg = {
          position: cfg
        }
      }

      // default for orientation is white
      if (cfg.orientation !== 'black') {
        cfg.orientation = 'white'
      }
      CURRENT_ORIENTATION = cfg.orientation

      // default for showNotation is true
      if (cfg.showNotation !== false) {
        cfg.showNotation = true
      }

      // default for draggable is false
      if (cfg.draggable !== true) {
        cfg.draggable = false
      }

      // default for dropOffBoard is 'snapback'
      if (cfg.dropOffBoard !== 'trash') {
        cfg.dropOffBoard = 'snapback'
      }

      // default for sparePieces is false
      if (cfg.sparePieces !== true) {
        cfg.sparePieces = false
      }

      // draggable must be true if sparePieces is enabled
      if (cfg.sparePieces === true) {
        cfg.draggable = true
      }

      // default piece theme is wikipedia
      if (cfg.hasOwnProperty('pieceTheme') !== true ||
        (typeof cfg.pieceTheme !== 'string' &&
        typeof cfg.pieceTheme !== 'function')) {
        cfg.pieceTheme = 'img/draughtspieces/wikipedia/{piece}.png'
      }

      // animation speeds
      if (cfg.hasOwnProperty('appearSpeed') !== true ||
        validAnimationSpeed(cfg.appearSpeed) !== true) {
        cfg.appearSpeed = 200
      }
      if (cfg.hasOwnProperty('moveSpeed') !== true ||
        validAnimationSpeed(cfg.moveSpeed) !== true) {
        cfg.moveSpeed = 200
      }
      if (cfg.hasOwnProperty('snapbackSpeed') !== true ||
        validAnimationSpeed(cfg.snapbackSpeed) !== true) {
        cfg.snapbackSpeed = 50
      }
      if (cfg.hasOwnProperty('snapSpeed') !== true ||
        validAnimationSpeed(cfg.snapSpeed) !== true) {
        cfg.snapSpeed = 25
      }
      if (cfg.hasOwnProperty('trashSpeed') !== true ||
        validAnimationSpeed(cfg.trashSpeed) !== true) {
        cfg.trashSpeed = 100
      }

      // make sure position is valid
      if (cfg.hasOwnProperty('position') === true) {
        if (cfg.position === 'start') {
          CURRENT_POSITION = deepCopy(START_POSITION)
        } else if (validFen(cfg.position) === true) {
          CURRENT_POSITION = fenToObj(cfg.position)
        } else if (validPositionObject(cfg.position) === true) {
          CURRENT_POSITION = deepCopy(cfg.position)
        } else {
          error(7263, 'Invalid value passed to config.position.', cfg.position)
        }
      }

      return true
    }

    // ------------------------------------------------------------------------------
    // DOM Misc
    // ------------------------------------------------------------------------------

    // calculates square size based on the width of the container
    // got a little CSS black magic here, so let me explain:
    // get the width of the container element (could be anything), reduce by 1 for
    // fudge factor, and then keep reducing until we find an exact mod SIZE for
    // our square size
    function calculateSquareSize () {
      var containerWidth = parseInt(containerEl.width(), 10)

      // defensive, prevent infinite loop
      if (!containerWidth || containerWidth <= 0) {
        return 0
      }

      // pad one pixel
      var boardWidth = containerWidth - 1

      while (boardWidth % SIZE !== 0 && boardWidth > 0) {
        boardWidth--
      }

      return (boardWidth / SIZE)
    }

    // create random IDs for elements
    function createElIds () {
      // squares on the board
      for (var i = 0; i <= (SIZE - 1); i++) {
        for (var j = 1; j <= SIZE; j++) {
          var square = (i * SIZE) + j
          SQUARE_ELS_IDS[square] = square + '-' + uuid()
        }
      }

      // spare pieces
      var pieces = 'bBwW'.split('')
      for (i = 0; i < pieces.length; i++) {
        SPARE_PIECE_ELS_IDS[pieces[i]] = pieces[i] + '-' + uuid()
      }
    }

    // ------------------------------------------------------------------------------
    // Markup Building
    // ------------------------------------------------------------------------------

    function buildBoardContainer () {
      var html = '<div class="' + CSS.draughtsboard + '">'

      if (cfg.sparePieces === true) {
        html += '<div class="' + CSS.sparePieces + ' ' +
          CSS.sparePiecesTop + '"></div>'
      }

      html += '<div class="' + CSS.board + '"></div>'

      if (cfg.sparePieces === true) {
        html += '<div class="' + CSS.sparePieces + ' ' +
          CSS.sparePiecesBottom + '"></div>'
      }

      html += '</div>'

      return html
    }

    /*
    var buildSquare = function(color, size, id) {
      var html = '<div class="' + CSS.square + ' ' + CSS[color] + '" ' +
      'style="width: ' + size + 'px; height: ' + size + 'px" ' +
      'id="' + id + '">'

      if (cfg.showNotation === true) {

      }

      html += '</div>'

      return html
    }
    */

    function buildBoard (orientation) {
      if (orientation !== 'black') {
        orientation = 'white'
      }

      var html = ''

      // algebraic notation / orientation
      var alpha = deepCopy(COLUMNS)
      var row = SIZE
      if (orientation === 'black') {
        alpha.reverse()
        row = 1
      }

      var squareColor = 'white'
      for (var i = 0; i < SIZE; i++) {
        html += '<div class="' + CSS.row + '">'
        for (var j = 1; j <= SIZE; j++) {
          var square
          if (orientation === 'black') {
            square = (parseInt(alpha[i], 10) * SIZE) + ((SIZE + 1) - j)
          } else {
            square = (parseInt(alpha[i], 10) * SIZE) + j
          }
          square = Math.round(square / 2)
          if (squareColor === 'white') {
            html += '<div class="' + CSS.square + ' ' + CSS[squareColor] + ' ' +
              'square-empty' + '" ' +
              'style="width: ' + SQUARE_SIZE + 'px; height: ' + SQUARE_SIZE + 'px">'
          } else {
            html += '<div class="' + CSS.square + ' ' + CSS[squareColor] + ' ' +
              'square-' + square + '" ' +
              'style="width: ' + SQUARE_SIZE + 'px; height: ' + SQUARE_SIZE + 'px" ' +
              'id="' + SQUARE_ELS_IDS[square] + '" ' +
              'data-square="' + square + '">'

            if (cfg.showNotation === true) {
              html += '<div class="' + CSS.notation + ' ' + CSS.alpha + '">' +
                square + '</div>'
              if (j === 0) {
                html += '<div class="' + CSS.notation + ' ' + CSS.numeric + '">' +
                  row + '</div>'
              }
            }
          }
          html += '</div>' // end .square
          squareColor = (squareColor === 'white' ? 'black' : 'white')
        }
        html += '<div class="' + CSS.clearfix + '"></div></div>'

        squareColor = (squareColor === 'white' ? 'black' : 'white')

        if (orientation === 'white') {
          row--
        } else {
          row++
        }
      }

      return html
    }

    function buildPieceImgSrc (piece) {
      // For handling case insensetive windows :(
      if (piece === 'W' || piece === 'B') {
        piece = 'K' + piece
      }
      if (typeof cfg.pieceTheme === 'function') {
        return cfg.pieceTheme(piece)
      }

      if (typeof cfg.pieceTheme === 'string') {
        return cfg.pieceTheme.replace(/{piece}/g, piece)
      }

      // NOTE: this should never happen
      error(8272, 'Unable to build image source for cfg.pieceTheme.')
      return ''
    }

    function buildPiece (piece, hidden, id) {
      if (!piece) {
        return false
      }
      var html
      if (cfg.pieceTheme === 'unicode') {
        html = '<span '
        if (id && typeof id === 'string') {
          html += 'id="' + id + '" '
        }
        html += 'class="unicode ' + piece + ' ' + CSS.piece + '" '
        html += 'data-piece="' + piece + '" '
        html += 'style="font-size: ' + SQUARE_SIZE + 'px;'
        if (hidden === true) {
          html += 'display:none;'
        }
        html += '">' + UNICODES[piece] + '</span>'
        return html
      }
      html = '<img src="' + buildPieceImgSrc(piece) + '" '
      if (id && typeof id === 'string') {
        html += 'id="' + id + '" '
      }
      html += 'alt="" ' +
        'class="' + CSS.piece + '" ' +
        'data-piece="' + piece + '" ' +
        'style="width: ' + SQUARE_SIZE + 'px;' +
        'height: ' + SQUARE_SIZE + 'px;'
      if (hidden === true) {
        html += 'display:none;'
      }
      html += '" />'

      return html
    }

    function buildSparePieces (color) {
      var pieces = ['w', 'W']
      if (color === 'black') {
        pieces = ['b', 'B']
      }

      var html = ''
      for (var i = 0; i < pieces.length; i++) {
        html += buildPiece(pieces[i], false, SPARE_PIECE_ELS_IDS[pieces[i]])
      }

      return html
    }

    // ------------------------------------------------------------------------------
    // Animations
    // ------------------------------------------------------------------------------

    function animateSquareToSquare (src, dest, piece, completeFn) {
      // get information about the source and destination squares
      var srcSquareEl = $('#' + SQUARE_ELS_IDS[src])
      var srcSquarePosition = srcSquareEl.offset()
      var destSquareEl = $('#' + SQUARE_ELS_IDS[dest])
      var destSquarePosition = destSquareEl.offset()

      // create the animated piece and absolutely position it
      // over the source square
      var animatedPieceId = uuid()
      $('body').append(buildPiece(piece, true, animatedPieceId))
      var animatedPieceEl = $('#' + animatedPieceId)
      animatedPieceEl.css({
        display: '',
        position: 'absolute',
        top: srcSquarePosition.top,
        left: srcSquarePosition.left,
        fontSize: SQUARE_SIZE + 'px'
      })

      // remove original piece from source square
      srcSquareEl.find('.' + CSS.piece).remove()

      // on complete
      var complete = function () {
        // add the "real" piece to the destination square
        destSquareEl.append(buildPiece(piece))

        // remove the animated piece
        animatedPieceEl.remove()

        // run complete function
        if (typeof completeFn === 'function') {
          completeFn()
        }
      }

      // animate the piece to the destination square
      var opts = {
        duration: cfg.moveSpeed,
        complete: complete
      }
      animatedPieceEl.animate(destSquarePosition, opts)
    }

    function animateSparePieceToSquare (piece, dest, completeFn) {
      var srcOffset = $('#' + SPARE_PIECE_ELS_IDS[piece]).offset()
      var destSquareEl = $('#' + SQUARE_ELS_IDS[dest])
      var destOffset = destSquareEl.offset()

      // create the animate piece
      var pieceId = uuid()
      $('body').append(buildPiece(piece, true, pieceId))
      var animatedPieceEl = $('#' + pieceId)
      animatedPieceEl.css({
        display: '',
        position: 'absolute',
        left: srcOffset.left,
        top: srcOffset.top,
        fontSize: SQUARE_SIZE + 'px'
      })

      // on complete
      var complete = function () {
        // add the "real" piece to the destination square
        destSquareEl.find('.' + CSS.piece).remove()
        destSquareEl.append(buildPiece(piece))

        // remove the animated piece
        animatedPieceEl.remove()

        // run complete function
        if (typeof completeFn === 'function') {
          completeFn()
        }
      }

      // animate the piece to the destination square
      var opts = {
        duration: cfg.moveSpeed,
        complete: complete
      }
      animatedPieceEl.animate(destOffset, opts)
    }

    // execute an array of animations
    function doAnimations (a, oldPos, newPos) {
      if (a.length === 0) {
        return
      }

      ANIMATION_HAPPENING = true

      var numFinished = 0
      function onFinish () {
        numFinished++

        // exit if all the animations aren't finished
        if (numFinished !== a.length) return

        drawPositionInstant()
        ANIMATION_HAPPENING = false

        // run their onMoveEnd function
        if (cfg.hasOwnProperty('onMoveEnd') === true &&
          typeof cfg.onMoveEnd === 'function') {
          cfg.onMoveEnd(deepCopy(oldPos), deepCopy(newPos))
        }
      }

      for (var i = 0; i < a.length; i++) {
        // clear a piece
        if (a[i].type === 'clear') {
          $('#' + SQUARE_ELS_IDS[a[i].square] + ' .' + CSS.piece)
            .fadeOut(cfg.trashSpeed, onFinish)
        }

        // add a piece (no spare pieces)
        if (a[i].type === 'add' && cfg.sparePieces !== true) {
          $('#' + SQUARE_ELS_IDS[a[i].square])
            .append(buildPiece(a[i].piece, true))
            .find('.' + CSS.piece)
            .fadeIn(cfg.appearSpeed, onFinish)
        }

        // add a piece from a spare piece
        if (a[i].type === 'add' && cfg.sparePieces === true) {
          animateSparePieceToSquare(a[i].piece, a[i].square, onFinish)
        }

        // move a piece
        if (a[i].type === 'move') {
          animateSquareToSquare(a[i].source, a[i].destination, a[i].piece,
            onFinish)
        }
      }
    }

    // returns the distance between two squares
    function squareDistance (s1, s2) {
      s1 = s1.split('')
      var s1x = COLUMNS.indexOf(s1[0]) + 1
      var s1y = parseInt(s1[1], 10)

      s2 = s2.split('')
      var s2x = COLUMNS.indexOf(s2[0]) + 1
      var s2y = parseInt(s2[1], 10)

      var xDelta = Math.abs(s1x - s2x)
      var yDelta = Math.abs(s1y - s2y)

      if (xDelta >= yDelta) return xDelta
      return yDelta
    }

    // returns an array of closest squares from square
    function createRadius (square) {
      var squares = []

      // calculate distance of all squares
      for (var i = 0; i < SIZE; i++) {
        for (var j = 0; j < SIZE; j++) {
          var s = COLUMNS[i] + (j + 1)

          // skip the square we're starting from
          if (square === s) continue

          squares.push({
            square: s,
            distance: squareDistance(square, s)
          })
        }
      }

      // sort by distance
      squares.sort(function (a, b) {
        return a.distance - b.distance
      })

      // just return the square code
      var squares2 = []
      for (i = 0; i < squares.length; i++) {
        squares2.push(squares[i].square)
      }

      return squares2
    }

    // returns the square of the closest instance of piece
    // returns false if no instance of piece is found in position
    function findClosestPiece (position, piece, square) {
      // create array of closest squares from square
      var closestSquares = createRadius(square)

      // search through the position in order of distance for the piece
      for (var i = 0; i < closestSquares.length; i++) {
        var s = closestSquares[i]

        if (position.hasOwnProperty(s) === true && position[s] === piece) {
          return s
        }
      }

      return false
    }

    // calculate an array of animations that need to happen in order to get
    // from pos1 to pos2
    function calculateAnimations (pos1, pos2) {
      // make copies of both
      pos1 = deepCopy(pos1)
      pos2 = deepCopy(pos2)

      var animations = []
      var squaresMovedTo = {}

      // remove pieces that are the same in both positions
      for (var i in pos2) {
        if (pos2.hasOwnProperty(i) !== true) continue

        if (pos1.hasOwnProperty(i) === true && pos1[i] === pos2[i]) {
          delete pos1[i]
          delete pos2[i]
        }
      }

      // find all the "move" animations
      for (i in pos2) {
        if (pos2.hasOwnProperty(i) !== true) continue

        var closestPiece = findClosestPiece(pos1, pos2[i], i)
        if (closestPiece !== false) {
          animations.push({
            type: 'move',
            source: closestPiece,
            destination: i,
            piece: pos2[i]
          })

          delete pos1[closestPiece]
          delete pos2[i]
          squaresMovedTo[i] = true
        }
      }

      // add pieces to pos2
      for (i in pos2) {
        if (pos2.hasOwnProperty(i) !== true) continue

        animations.push({
          type: 'add',
          square: i,
          piece: pos2[i]
        })

        delete pos2[i]
      }

      // clear pieces from pos1
      for (i in pos1) {
        if (pos1.hasOwnProperty(i) !== true) continue

        // do not clear a piece if it is on a square that is the result
        // of a "move", ie: a piece capture
        if (squaresMovedTo.hasOwnProperty(i) === true) continue

        animations.push({
          type: 'clear',
          square: i,
          piece: pos1[i]
        })

        delete pos1[i]
      }

      return animations
    }

    // ------------------------------------------------------------------------------
    // Control Flow
    // ------------------------------------------------------------------------------

    function drawPositionInstant () {
      // clear the board
      boardEl.find('.' + CSS.piece).remove()

      // add the pieces
      for (var i in CURRENT_POSITION) {
        if (CURRENT_POSITION.hasOwnProperty(i) !== true) {
          continue
        }
        if (CURRENT_POSITION[i] !== null) {
          $('#' + SQUARE_ELS_IDS[i]).append(buildPiece(CURRENT_POSITION[i]))
        }
      }
    }

    function drawBoard () {
      boardEl.html(buildBoard(CURRENT_ORIENTATION))
      drawPositionInstant()

      if (cfg.sparePieces === true) {
        if (CURRENT_ORIENTATION === 'white') {
          sparePiecesTopEl.html(buildSparePieces('black'))
          sparePiecesBottomEl.html(buildSparePieces('white'))
        } else {
          sparePiecesTopEl.html(buildSparePieces('white'))
          sparePiecesBottomEl.html(buildSparePieces('black'))
        }
      }
    }

    // given a position and a set of moves, return a new position
    // with the moves executed
    function calculatePositionFromMoves (position, moves) {
      position = deepCopy(position)

      for (var i in moves) {
        if (moves.hasOwnProperty(i) !== true) continue

        // skip the move if the position doesn't have a piece on the source square
        if (position.hasOwnProperty(i) !== true) continue

        var piece = position[i]
        delete position[i]
        position[moves[i]] = piece
      }

      return position
    }

    function setCurrentPosition (position) {
      var oldPos = deepCopy(CURRENT_POSITION)
      var newPos = deepCopy(position)
      var oldFen = objToFen(oldPos)
      var newFen = objToFen(newPos)
      // do nothing if no change in position
      if (oldFen === newFen) {
        return false
      }
      // run their onChange function
      if (cfg.hasOwnProperty('onChange') === true &&
        typeof cfg.onChange === 'function') {
        cfg.onChange(oldPos, newPos)
      }

      // update state
      CURRENT_POSITION = position
    }

    function isXYOnSquare (x, y) {
      for (var i in SQUARE_ELS_OFFSETS) {
        if (SQUARE_ELS_OFFSETS.hasOwnProperty(i) !== true) continue

        var s = SQUARE_ELS_OFFSETS[i]
        if (typeof s !== 'object') continue
        if (x >= s.left && x < s.left + SQUARE_SIZE &&
          y >= s.top && y < s.top + SQUARE_SIZE) {
          return i
        }
      }

      return 'offboard'
    }

    // records the XY coords of every square into memory
    function captureSquareOffsets () {
      SQUARE_ELS_OFFSETS = {}

      for (var i in SQUARE_ELS_IDS) {
        if (SQUARE_ELS_IDS.hasOwnProperty(i) !== true) continue

        SQUARE_ELS_OFFSETS[i] = $('#' + SQUARE_ELS_IDS[i]).offset()
      }
    }

    function removeSquareHighlights () {
      boardEl.find('.' + CSS.square)
        .removeClass(CSS.highlight1 + ' ' + CSS.highlight2)
    }

    function snapbackDraggedPiece () {
      // there is no "snapback" for spare pieces
      if (DRAGGED_PIECE_SOURCE === 'spare') {
        trashDraggedPiece()
        return
      }

      removeSquareHighlights()

      // animation complete
      function complete () {
        drawPositionInstant()
        draggedPieceEl.css('display', 'none')

        // run their onSnapbackEnd function
        if (cfg.hasOwnProperty('onSnapbackEnd') === true &&
          typeof cfg.onSnapbackEnd === 'function') {
          cfg.onSnapbackEnd(DRAGGED_PIECE, DRAGGED_PIECE_SOURCE,
            deepCopy(CURRENT_POSITION), CURRENT_ORIENTATION)
        }
      }

      // get source square position
      var sourceSquarePosition =
      $('#' + SQUARE_ELS_IDS[DRAGGED_PIECE_SOURCE]).offset()

      // animate the piece to the target square
      var opts = {
        duration: cfg.snapbackSpeed,
        complete: complete
      }
      draggedPieceEl.animate(sourceSquarePosition, opts)

      // set state
      DRAGGING_A_PIECE = false
    }

    function trashDraggedPiece () {
      removeSquareHighlights()

      // remove the source piece
      var newPosition = deepCopy(CURRENT_POSITION)
      delete newPosition[DRAGGED_PIECE_SOURCE]
      setCurrentPosition(newPosition)

      // redraw the position
      drawPositionInstant()

      // hide the dragged piece
      draggedPieceEl.fadeOut(cfg.trashSpeed)

      // set state
      DRAGGING_A_PIECE = false
    }

    function dropDraggedPieceOnSquare (square) {
      removeSquareHighlights()

      // update position
      var newPosition = deepCopy(CURRENT_POSITION)
      delete newPosition[DRAGGED_PIECE_SOURCE]
      newPosition[square] = DRAGGED_PIECE
      setCurrentPosition(newPosition)

      // get target square information
      var targetSquarePosition = $('#' + SQUARE_ELS_IDS[square]).offset()

      // animation complete
      var complete = function () {
        drawPositionInstant()
        draggedPieceEl.css('display', 'none')

        // execute their onSnapEnd function
        if (cfg.hasOwnProperty('onSnapEnd') === true &&
          typeof cfg.onSnapEnd === 'function') {
          cfg.onSnapEnd(DRAGGED_PIECE_SOURCE, square, DRAGGED_PIECE)
        }
      }

      // snap the piece to the target square
      var opts = {
        duration: cfg.snapSpeed,
        complete: complete
      }
      draggedPieceEl.animate(targetSquarePosition, opts)

      // set state
      DRAGGING_A_PIECE = false
    }

    function beginDraggingPiece (source, piece, x, y) {
      // run their custom onDragStart function
      // their custom onDragStart function can cancel drag start
      if (typeof cfg.onDragStart === 'function' &&
        cfg.onDragStart(source, piece,
          deepCopy(CURRENT_POSITION), CURRENT_ORIENTATION) === false) {
        return
      }
      // set state
      DRAGGING_A_PIECE = true
      DRAGGED_PIECE = piece
      DRAGGED_PIECE_SOURCE = source

      // if the piece came from spare pieces, location is offboard
      if (source === 'spare') {
        DRAGGED_PIECE_LOCATION = 'offboard'
      } else {
        DRAGGED_PIECE_LOCATION = source
      }

      // capture the x, y coords of all squares in memory
      captureSquareOffsets()

      // create the dragged piece
      if (cfg.pieceTheme === 'unicode') {
        draggedPieceEl.text(UNICODES[piece])
        draggedPieceEl.attr('class', '').addClass(piece).addClass('unicode')
      } else {
        draggedPieceEl.attr('src', buildPieceImgSrc(piece))
      }
      draggedPieceEl
        .css({
          display: '',
          position: 'absolute',
          left: x - (SQUARE_SIZE / 2),
          top: y - (SQUARE_SIZE / 2),
          fontSize: SQUARE_SIZE + 'px'
        })

      if (source !== 'spare') {
        // highlight the source square and hide the piece
        $('#' + SQUARE_ELS_IDS[source]).addClass(CSS.highlight1)
          .find('.' + CSS.piece).css('display', 'none')
      }
    }

    function updateDraggedPiece (x, y) {
      // put the dragged piece over the mouse cursor
      draggedPieceEl.css({
        left: x - (SQUARE_SIZE / 2),
        top: y - (SQUARE_SIZE / 2)
      })

      // get location
      var location = isXYOnSquare(x, y)

      // do nothing if the location has not changed
      if (location === DRAGGED_PIECE_LOCATION) return

      // remove highlight from previous square
      if (validSquare(DRAGGED_PIECE_LOCATION) === true) {
        $('#' + SQUARE_ELS_IDS[DRAGGED_PIECE_LOCATION])
          .removeClass(CSS.highlight2)
      }

      // add highlight to new square
      if (validSquare(location) === true) {
        $('#' + SQUARE_ELS_IDS[location]).addClass(CSS.highlight2)
      }

      // run onDragMove
      if (typeof cfg.onDragMove === 'function') {
        cfg.onDragMove(location, DRAGGED_PIECE_LOCATION,
          DRAGGED_PIECE_SOURCE, DRAGGED_PIECE,
          deepCopy(CURRENT_POSITION), CURRENT_ORIENTATION)
      }

      // update state
      DRAGGED_PIECE_LOCATION = location
    }

    function stopDraggedPiece (location) {
      // determine what the action should be
      var action = 'drop'
      if (location === 'offboard' && cfg.dropOffBoard === 'snapback') {
        action = 'snapback'
      }
      if (location === 'offboard' && cfg.dropOffBoard === 'trash') {
        action = 'trash'
      }

      // run their onDrop function, which can potentially change the drop action
      if (cfg.hasOwnProperty('onDrop') === true &&
        typeof cfg.onDrop === 'function') {
        var newPosition = deepCopy(CURRENT_POSITION)

        // source piece is a spare piece and position is off the board
        // if (DRAGGED_PIECE_SOURCE === 'spare' && location === 'offboard') {...}
        // position has not changed; do nothing

        // source piece is a spare piece and position is on the board
        if (DRAGGED_PIECE_SOURCE === 'spare' && validSquare(location) === true) {
          // add the piece to the board
          newPosition[location] = DRAGGED_PIECE
        }

        // source piece was on the board and position is off the board
        if (validSquare(DRAGGED_PIECE_SOURCE) === true && location === 'offboard') {
          // remove the piece from the board
          delete newPosition[DRAGGED_PIECE_SOURCE]
        }

        // source piece was on the board and position is on the board
        if (validSquare(DRAGGED_PIECE_SOURCE) === true &&
          validSquare(location) === true) {
          // move the piece
          delete newPosition[DRAGGED_PIECE_SOURCE]
          newPosition[location] = DRAGGED_PIECE
        }

        var oldPosition = deepCopy(CURRENT_POSITION)

        var result = cfg.onDrop(DRAGGED_PIECE_SOURCE, location, DRAGGED_PIECE,
          newPosition, oldPosition, CURRENT_ORIENTATION)
        if (result === 'snapback' || result === 'trash') {
          action = result
        }
      }

      // do it!
      if (action === 'snapback') {
        snapbackDraggedPiece()
      } else if (action === 'trash') {
        trashDraggedPiece()
      } else if (action === 'drop') {
        dropDraggedPieceOnSquare(location)
      }
    }

    // ------------------------------------------------------------------------------
    // Public Methods
    // ------------------------------------------------------------------------------

    // clear the board
    widget.clear = function (useAnimation) {
      widget.position({}, useAnimation)
    }

    // remove the widget from the page
    widget.destroy = function () {
      // remove markup
      containerEl.html('')
      draggedPieceEl.remove()

      // remove event handlers
      containerEl.unbind()
    }

    // shorthand method to get the current FEN
    widget.fen = function () {
      return widget.position('fen')
    }

    // flip orientation
    widget.flip = function () {
      return widget.orientation('flip')
    }

    /*
    // TODO: write this, GitHub Issue #5
    widget.highlight = function() {

    }
    */

    // move pieces
    widget.move = function () {
      // no need to throw an error here; just do nothing
      if (arguments.length === 0) return

      var useAnimation = true

      // collect the moves into an object
      var moves = {}
      for (var i = 0; i < arguments.length; i++) {
        // any "false" to this function means no animations
        if (arguments[i] === false) {
          useAnimation = false
          continue
        }

        // skip invalid arguments
        if (validMove(arguments[i]) !== true) {
          error(2826, 'Invalid move passed to the move method.', arguments[i])
          continue
        }

        var tmp = arguments[i].split(/-|x/)
        moves[tmp[0]] = tmp[1]
      }

      // calculate position from moves
      var newPos = calculatePositionFromMoves(CURRENT_POSITION, moves)

      // update the board
      widget.position(newPos, useAnimation)

      // return the new position object
      return newPos
    }

    widget.orientation = function (arg) {
      // no arguments, return the current orientation
      if (arguments.length === 0) {
        return CURRENT_ORIENTATION
      }

      // set to white or black
      if (arg === 'white' || arg === 'black') {
        CURRENT_ORIENTATION = arg
        drawBoard()
        return CURRENT_ORIENTATION
      }

      // flip orientation
      if (arg === 'flip') {
        CURRENT_ORIENTATION = (CURRENT_ORIENTATION === 'white') ? 'black' : 'white'
        drawBoard()
        return CURRENT_ORIENTATION
      }

      error(5482, 'Invalid value passed to the orientation method.', arg)
    }

    widget.position = function (position, useAnimation) {
      // no arguments, return the current position
      if (arguments.length === 0) {
        return deepCopy(CURRENT_POSITION)
      }

      // get position as FEN
      if (typeof position === 'string' && position.toLowerCase() === 'fen') {
        return objToFen(CURRENT_POSITION)
      }

      // default for useAnimations is true
      if (useAnimation !== false) {
        useAnimation = true
      }

      // start position
      if (typeof position === 'string' && position.toLowerCase() === 'start') {
        position = deepCopy(START_POSITION)
      }

      // convert FEN to position object
      if (validFen(position) === true) {
        position = fenToObj(position)
      }

      // validate position object
      if (validPositionObject(position) !== true) {
        error(6482, 'Invalid value passed to the position method.', position)
        return
      }

      if (useAnimation === true) {
        // start the animations
        doAnimations(calculateAnimations(CURRENT_POSITION, position),
          CURRENT_POSITION, position)

        // set the new position
        setCurrentPosition(position)
        drawPositionInstant()
      } else {
        // instant update
        setCurrentPosition(position)
        drawPositionInstant()
      }
    }

    widget.resize = function () {
      // calulate the new square size
      SQUARE_SIZE = calculateSquareSize()

      // set board width
      boardEl.css('width', (SQUARE_SIZE * SIZE) + 'px')

      // set drag piece size
      draggedPieceEl.css({
        height: SQUARE_SIZE,
        width: SQUARE_SIZE
      })

      // spare pieces
      if (cfg.sparePieces === true) {
        containerEl.find('.' + CSS.sparePieces)
          .css('paddingLeft', (SQUARE_SIZE + BOARD_BORDER_SIZE) + 'px')
      }

      // redraw the board
      drawBoard()
    }

    // set the starting position
    widget.start = function (useAnimation) {
      widget.position('start', useAnimation)
    }

    // ------------------------------------------------------------------------------
    // Browser Events
    // ------------------------------------------------------------------------------

    function isTouchDevice () {
      return ('ontouchstart' in document.documentElement)
    }

    // reference: http://www.quirksmode.org/js/detect.html
    function isMSIE () {
      return (navigator && navigator.userAgent &&
      navigator.userAgent.search(/MSIE/) !== -1)
    }

    function stopDefault (e) {
      e.preventDefault()
    }

    function mousedownSquare (e) {
      // do nothing if we're not draggable
      if (cfg.draggable !== true) return

      var square = $(this).attr('data-square')

      // no piece on this square
      if (validSquare(square) !== true ||
        CURRENT_POSITION.hasOwnProperty(square) !== true) {
        return
      }

      beginDraggingPiece(square, CURRENT_POSITION[square], e.pageX, e.pageY)
    }

    function touchstartSquare (e) {
      // do nothing if we're not draggable
      if (cfg.draggable !== true) return

      var square = $(this).attr('data-square')

      // no piece on this square
      if (validSquare(square) !== true ||
        CURRENT_POSITION.hasOwnProperty(square) !== true) {
        return
      }

      e = e.originalEvent
      beginDraggingPiece(square, CURRENT_POSITION[square],
        e.changedTouches[0].pageX, e.changedTouches[0].pageY)
    }

    function mousedownSparePiece (e) {
      // do nothing if sparePieces is not enabled
      if (cfg.sparePieces !== true) return

      var piece = $(this).attr('data-piece')

      beginDraggingPiece('spare', piece, e.pageX, e.pageY)
    }

    function touchstartSparePiece (e) {
      // do nothing if sparePieces is not enabled
      if (cfg.sparePieces !== true) return

      var piece = $(this).attr('data-piece')

      e = e.originalEvent
      beginDraggingPiece('spare', piece,
        e.changedTouches[0].pageX, e.changedTouches[0].pageY)
    }

    function mousemoveWindow (e) {
      // do nothing if we are not dragging a piece
      if (DRAGGING_A_PIECE !== true) return

      updateDraggedPiece(e.pageX, e.pageY)
    }

    function touchmoveWindow (e) {
      // do nothing if we are not dragging a piece
      if (DRAGGING_A_PIECE !== true) return

      // prevent screen from scrolling
      e.preventDefault()

      updateDraggedPiece(e.originalEvent.changedTouches[0].pageX,
        e.originalEvent.changedTouches[0].pageY)
    }

    function mouseupWindow (e) {
      // do nothing if we are not dragging a piece
      if (DRAGGING_A_PIECE !== true) return

      // get the location
      var location = isXYOnSquare(e.pageX, e.pageY)

      stopDraggedPiece(location)
    }

    function touchendWindow (e) {
      // do nothing if we are not dragging a piece
      if (DRAGGING_A_PIECE !== true) return

      // get the location
      var location = isXYOnSquare(e.originalEvent.changedTouches[0].pageX,
        e.originalEvent.changedTouches[0].pageY)

      stopDraggedPiece(location)
    }

    function mouseenterSquare (e) {
      // do not fire this event if we are dragging a piece
      // NOTE: this should never happen, but it's a safeguard
      if (DRAGGING_A_PIECE !== false) return

      if (cfg.hasOwnProperty('onMouseoverSquare') !== true ||
        typeof cfg.onMouseoverSquare !== 'function') return

      // get the square
      var square = $(e.currentTarget).attr('data-square')

      // NOTE: this should never happen; defensive
      if (validSquare(square) !== true) return

      // get the piece on this square
      var piece = false
      if (CURRENT_POSITION.hasOwnProperty(square) === true) {
        piece = CURRENT_POSITION[square]
      }

      // execute their function
      cfg.onMouseoverSquare(square, piece, deepCopy(CURRENT_POSITION),
        CURRENT_ORIENTATION)
    }

    function mouseleaveSquare (e) {
      // do not fire this event if we are dragging a piece
      // NOTE: this should never happen, but it's a safeguard
      if (DRAGGING_A_PIECE !== false) return

      if (cfg.hasOwnProperty('onMouseoutSquare') !== true ||
        typeof cfg.onMouseoutSquare !== 'function') return

      // get the square
      var square = $(e.currentTarget).attr('data-square')

      // NOTE: this should never happen; defensive
      if (validSquare(square) !== true) return

      // get the piece on this square
      var piece = false
      if (CURRENT_POSITION.hasOwnProperty(square) === true) {
        piece = CURRENT_POSITION[square]
      }

      // execute their function
      cfg.onMouseoutSquare(square, piece, deepCopy(CURRENT_POSITION),
        CURRENT_ORIENTATION)
    }

    // ------------------------------------------------------------------------------
    // Initialization
    // ------------------------------------------------------------------------------

    function addEvents () {
      // prevent browser "image drag"
      $('body').on('mousedown mousemove', '.' + CSS.piece, stopDefault)

      // mouse drag pieces
      boardEl.on('mousedown', '.' + CSS.square, mousedownSquare)
      containerEl.on('mousedown', '.' + CSS.sparePieces + ' .' + CSS.piece,
        mousedownSparePiece)

      // mouse enter / leave square
      boardEl.on('mouseenter', '.' + CSS.square, mouseenterSquare)
        .on('mouseleave', '.' + CSS.square, mouseleaveSquare)

      // IE doesn't like the events on the window object, but other browsers
      // perform better that way
      if (isMSIE() === true) {
        // IE-specific prevent browser "image drag"
        document.ondragstart = function () { return false }

        $('body').on('mousemove', mousemoveWindow)
          .on('mouseup', mouseupWindow)
      } else {
        $(window).on('mousemove', mousemoveWindow)
          .on('mouseup', mouseupWindow)
      }

      // touch drag pieces
      if (isTouchDevice() === true) {
        boardEl.on('touchstart', '.' + CSS.square, touchstartSquare)
        containerEl.on('touchstart', '.' + CSS.sparePieces + ' .' + CSS.piece,
          touchstartSparePiece)
        $(window).on('touchmove', touchmoveWindow)
          .on('touchend', touchendWindow)
      }
    }

    function initDom () {
      // create unique IDs for all the elements we will create
      createElIds()

      // build board and save it in memory
      containerEl.html(buildBoardContainer())
      boardEl = containerEl.find('.' + CSS.board)

      if (cfg.sparePieces === true) {
        sparePiecesTopEl = containerEl.find('.' + CSS.sparePiecesTop)
        sparePiecesBottomEl = containerEl.find('.' + CSS.sparePiecesBottom)
      }

      // create the drag piece
      var draggedPieceId = uuid()
      $('body').append(buildPiece('w', true, draggedPieceId))
      draggedPieceEl = $('#' + draggedPieceId)

      // get the border size
      BOARD_BORDER_SIZE = parseInt(boardEl.css('borderLeftWidth'), 10)

      // set the size and draw the board
      widget.resize()
    }

    function init () {
      if (checkDeps() !== true ||
        expandConfig() !== true) return

      initDom()
      addEvents()
    }

    // go time
    init()

    // return the widget object
    return widget
  }
  // end window.DraughtsBoard

  // expose util functions
  window.DraughtsBoard.fenToObj = fenToObj
  window.DraughtsBoard.objToFen = objToFen

  if (true) {
    exports.DraughtsBoard = DraughtsBoard
  }

  if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
      return DraughtsBoard
    }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  }
})()


/***/ }),

/***/ "h0qH":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var throw_1 = __webpack_require__("s3oX");
Observable_1.Observable.throw = throw_1._throw;
//# sourceMappingURL=throw.js.map

/***/ }),

/***/ "hAPe":
/***/ (function(module, exports) {

exports.model=Model={Game:{},Board:{},Move:{}},Model.Game.InitGame=function(){for(var t=this.mOptions.width,i=this.mOptions.height,s=this.mOptions.lines,o=[[-1,-1],[0,-1],[1,-1],[-1,0]],h=[],e=0;e<i;e++)for(var r=0;r<t;r++)for(var n=0;n<o.length;n++){var l,a=o[n][0],p=o[n][1],d=[];for(l=0;l<s;l++){var u;if(u=this.mOptions.torus?(e+p*l)*t+(r+a*l+t)%t:(e+p*l)*t+r+a*l,this.mOptions.torus&&(e+p*l<0||e+p*l>=i))break;if(!this.mOptions.torus&&(r+a*l<0||r+a*l>=t||e+p*l<0||e+p*l>=i))break;d.push(u)}l==s&&h.push(d)}this.g.TuplesList=h;for(var m={},l=0;l<h.length;l++)for(var d=h[l],v=0;v<d.length;v++){var u=d[v];void 0===m[u]&&(m[u]=[]),m[u].push(d)}this.g.Tuples=m,this.zobrist=new JocGame.Zobrist({board:{type:"array",size:this.mOptions.width*this.mOptions.height,values:["1","-1"]}})},Model.Move.Init=function(t){this.op=t.op,this.col=t.col},Model.Move.CopyFrom=function(t){this.Init(t)},Model.Move.ToString=function(){var t="";switch(this.op){case"+":t+="+";break;case"-":t+="-";break;default:t+="?"}return t+=String.fromCharCode(65+this.col)},Model.Board.Init=function(t){this.zSign=0},Model.Board.InitialPosition=function(t){this.board=[];for(var i=t.mOptions.width,s=t.mOptions.height,o=0;o<s;o++)for(var h=0;h<i;h++)this.board.push(0);this.tuples={};for(var e=1;e<=t.mOptions.lines;e++)this.tuples[e]=0,this.tuples[-e]=0;this.cols=[];for(var h=0;h<i;h++)this.cols.push(0);if(t.mOptions.fillSides)for(var e=0;e<s;e++){var r=e*i,n=e%2?-1:1,l=0;this.board[r]=n,this.cols[l]++,this.tuples[n]++,this.zSign=t.zobrist.update(this.zSign,"board",n,r);var r=e*i+i-1,n=e%2?1:-1,l=i-1;this.board[r]=n,this.cols[l]++,this.tuples[n]++,this.zSign=t.zobrist.update(this.zSign,"board",n,r)}},Model.Board.GenerateMoves=function(t){for(var i=[],s=t.mOptions.height,o=0;o<t.mOptions.width;o++)this.cols[o]<s&&i.push({op:"+",col:o});if(t.mOptions.remove)for(var o=0;o<t.mOptions.width;o++)this.board[o]==this.mWho&&i.push({op:"-",col:o});this.mMoves=i,0==i.length&&(this.mFinished=!0,this.mWinner=JocGame.DRAW)},Model.Board.Evaluate=function(t){if(this.mEvaluation=0,this.mWinner=0,t.mOptions.preventRepeat&&t.GetRepeatOccurence(this)>2)return this.mFinished=!0,void(this.mWinner=JocGame.DRAW);if(this.tuples[t.mOptions.lines]>0&&(this.mFinished=!0,this.mWinner=1),this.tuples[-t.mOptions.lines]>0)return this.mFinished=!0,void(this.mWinner?this.mWinner=JocGame.DRAW:this.mWinner=-1);if(!this.mFinished)for(var i=t.mOptions.levelOptions,s=1;s<t.mOptions.lines;s++)this.mEvaluation+=this.tuples[s]*i["evalTuple"+s],this.mEvaluation-=this.tuples[-s]*i["evalTuple"+s]},Model.Board.ApplyMove=function(t,i){if("+"==i.op){for(var s=i.col,o=this.cols[s],h=o*t.mOptions.width+s,e=0;e<t.g.Tuples[h].length;e++){for(var r=t.g.Tuples[h][e],n={1:0,0:0,"-1":0},l=0;l<r.length;l++)n[this.board[r[l]]]++;n[1]>0&&0==n[-1]?this.tuples[n[1]]--:n[-1]>0&&0==n[1]&&this.tuples[-n[-1]]--,n[this.mWho]++,n[1]>0&&0==n[-1]?this.tuples[n[1]]++:n[-1]>0&&0==n[1]&&this.tuples[-n[-1]]++}this.board[h]=this.mWho,this.cols[s]++,this.zSign=t.zobrist.update(this.zSign,"board",this.mWho,h)}else if("-"==i.op){for(var o=0;o<this.cols[i.col];o++)for(var h=o*t.mOptions.width+i.col,e=0;e<t.g.Tuples[h].length;e++){for(var r=t.g.Tuples[h][e],n={1:0,0:0,"-1":0},l=0;l<r.length;l++)n[this.board[r[l]]]++;n[1]>0&&0==n[-1]?this.tuples[n[1]]--:n[-1]>0&&0==n[1]&&this.tuples[-n[-1]]--}for(var e=0;e<this.cols[i.col];e++){var h=e*t.mOptions.width+i.col,a=h+t.mOptions.width,p=0;a<this.board.length&&(p=this.board[a]),this.zSign=t.zobrist.update(this.zSign,"board",this.board[h],h),p&&(this.zSign=t.zobrist.update(this.zSign,"board",p,h)),this.board[h]=p}this.cols[i.col]--;for(var o=0;o<this.cols[i.col];o++)for(var h=o*t.mOptions.width+i.col,e=0;e<t.g.Tuples[h].length;e++){for(var r=t.g.Tuples[h][e],n={1:0,0:0,"-1":0},l=0;l<r.length;l++)n[this.board[r[l]]]++;n[1]>0&&0==n[-1]?this.tuples[n[1]]++:n[-1]>0&&0==n[1]&&this.tuples[-n[-1]]++}}else console.error("Invalid move",i)},Model.Board.CopyFrom=function(t){this.tuples={};for(var i in t.tuples)this.tuples[i]=t.tuples[i];this.board=[];for(var s=0;s<t.board.length;s++)this.board.push(t.board[s]);this.cols=[];for(var o=0;o<t.cols.length;o++)this.cols.push(t.cols[o]);this.mWho=t.mWho,this.zSign=t.zSign},Model.Board.GetSignature=function(){return this.zSign};

/***/ }),

/***/ "hFwN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ngrx_core_compose__ = __webpack_require__("owqQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ngrx_core_compose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ngrx_core_compose__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return KNOWN; });
/* harmony export (immutable) */ __webpack_exports__["c"] = getTypeOf;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getLabelFor; });
/* harmony export (immutable) */ __webpack_exports__["a"] = getChildrenFor;

var KNOWN = {
    Array: 'array',
    Object: 'object',
    Null: 'null',
    Undefined: 'undefined',
    Boolean: 'boolean',
    Number: 'number',
    String: 'string',
    Symbol: 'symbol',
    Function: 'function',
    Iterable: 'iterable'
};
function getTypeOf(object) {
    var literalType = typeof object;
    if (literalType === 'object') {
        if (Array.isArray(object)) {
            return KNOWN.Array;
        }
        if (object === null) {
            return KNOWN.Null;
        }
        if (typeof object[Symbol.iterator] === 'function') {
            return KNOWN.Iterable;
        }
    }
    return literalType;
}
var arrayLength = function (value) { return value.length; };
var lengthLabel = function (single, plural) { return function (length) { return (length + " " + (length === 1 ? single : plural)); }; };
var typeIndicator = function (typeIndicator) { return function (input) { return (typeIndicator + " " + input); }; };
var typeIdentity = function (type) { return function () { return type; }; };
var withQuotes = function (val) { return ("\"" + val + "\""); };
var toString = function (val) { return val.toString(); };
var iterableToArray = function (value) { return Array.from(value); };
var labelFactoriesForTypes = (_a = {},
    _a[KNOWN.Array] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__ngrx_core_compose__["compose"])(typeIndicator('[]'), lengthLabel('item', 'items'), arrayLength),
    _a[KNOWN.Object] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__ngrx_core_compose__["compose"])(typeIndicator('{}'), lengthLabel('key', 'keys'), arrayLength, Object.getOwnPropertyNames),
    _a[KNOWN.Null] = typeIdentity(KNOWN.Null),
    _a[KNOWN.Undefined] = typeIdentity(KNOWN.Undefined),
    _a[KNOWN.Boolean] = function (val) { return val ? 'true' : 'false'; },
    _a[KNOWN.Number] = toString,
    _a[KNOWN.String] = withQuotes,
    _a[KNOWN.Symbol] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__ngrx_core_compose__["compose"])(withQuotes, toString),
    _a[KNOWN.Function] = typeIdentity(KNOWN.Function),
    _a[KNOWN.Iterable] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__ngrx_core_compose__["compose"])(typeIndicator('()'), lengthLabel('entry', 'entries'), arrayLength, iterableToArray),
    _a
);
var lookupLabelForType = function (type) { return labelFactoriesForTypes[type]; };
var getLabelFor = function (object) { return labelFactoriesForTypes[getTypeOf(object)](object); };
function getChildrenFor(object) {
    var literalType = getTypeOf(object);
    if (literalType === KNOWN.Object) {
        return Object.getOwnPropertyNames(object).map(function (name) {
            return { key: name, value: object[name] };
        });
    }
    else if (literalType === KNOWN.Array) {
        return object.map(function (value, index) {
            return { key: index, value: value };
        });
    }
    else if (literalType === KNOWN.Iterable) {
        return Array.from(object).map(function (value, index) {
            return { key: index, value: value };
        });
    }
    throw new TypeError("Tried to get children for non-enumerable type \"" + literalType + "\"");
}
var _a;
//# sourceMappingURL=types.js.map

/***/ }),

/***/ "hYBY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var root_1 = __webpack_require__("VOfZ");
var Observable_1 = __webpack_require__("rCTf");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var PromiseObservable = (function (_super) {
    __extends(PromiseObservable, _super);
    function PromiseObservable(promise, scheduler) {
        _super.call(this);
        this.promise = promise;
        this.scheduler = scheduler;
    }
    /**
     * Converts a Promise to an Observable.
     *
     * <span class="informal">Returns an Observable that just emits the Promise's
     * resolved value, then completes.</span>
     *
     * Converts an ES2015 Promise or a Promises/A+ spec compliant Promise to an
     * Observable. If the Promise resolves with a value, the output Observable
     * emits that resolved value as a `next`, and then completes. If the Promise
     * is rejected, then the output Observable emits the corresponding Error.
     *
     * @example <caption>Convert the Promise returned by Fetch to an Observable</caption>
     * var result = Rx.Observable.fromPromise(fetch('http://myserver.com/'));
     * result.subscribe(x => console.log(x), e => console.error(e));
     *
     * @see {@link bindCallback}
     * @see {@link from}
     *
     * @param {Promise<T>} promise The promise to be converted.
     * @param {Scheduler} [scheduler] An optional IScheduler to use for scheduling
     * the delivery of the resolved value (or the rejection).
     * @return {Observable<T>} An Observable which wraps the Promise.
     * @static true
     * @name fromPromise
     * @owner Observable
     */
    PromiseObservable.create = function (promise, scheduler) {
        return new PromiseObservable(promise, scheduler);
    };
    PromiseObservable.prototype._subscribe = function (subscriber) {
        var _this = this;
        var promise = this.promise;
        var scheduler = this.scheduler;
        if (scheduler == null) {
            if (this._isScalar) {
                if (!subscriber.closed) {
                    subscriber.next(this.value);
                    subscriber.complete();
                }
            }
            else {
                promise.then(function (value) {
                    _this.value = value;
                    _this._isScalar = true;
                    if (!subscriber.closed) {
                        subscriber.next(value);
                        subscriber.complete();
                    }
                }, function (err) {
                    if (!subscriber.closed) {
                        subscriber.error(err);
                    }
                })
                    .then(null, function (err) {
                    // escape the promise trap, throw unhandled errors
                    root_1.root.setTimeout(function () { throw err; });
                });
            }
        }
        else {
            if (this._isScalar) {
                if (!subscriber.closed) {
                    return scheduler.schedule(dispatchNext, 0, { value: this.value, subscriber: subscriber });
                }
            }
            else {
                promise.then(function (value) {
                    _this.value = value;
                    _this._isScalar = true;
                    if (!subscriber.closed) {
                        subscriber.add(scheduler.schedule(dispatchNext, 0, { value: value, subscriber: subscriber }));
                    }
                }, function (err) {
                    if (!subscriber.closed) {
                        subscriber.add(scheduler.schedule(dispatchError, 0, { err: err, subscriber: subscriber }));
                    }
                })
                    .then(null, function (err) {
                    // escape the promise trap, throw unhandled errors
                    root_1.root.setTimeout(function () { throw err; });
                });
            }
        }
    };
    return PromiseObservable;
}(Observable_1.Observable));
exports.PromiseObservable = PromiseObservable;
function dispatchNext(arg) {
    var value = arg.value, subscriber = arg.subscriber;
    if (!subscriber.closed) {
        subscriber.next(value);
        subscriber.complete();
    }
}
function dispatchError(arg) {
    var err = arg.err, subscriber = arg.subscriber;
    if (!subscriber.closed) {
        subscriber.error(err);
    }
}
//# sourceMappingURL=PromiseObservable.js.map

/***/ }),

/***/ "hiKS":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var zip_1 = __webpack_require__("RYQg");
/**
 * @param project
 * @return {Observable<R>|WebSocketSubject<T>|Observable<T>}
 * @method zipAll
 * @owner Observable
 */
function zipAll(project) {
    return this.lift(new zip_1.ZipOperator(project));
}
exports.zipAll = zipAll;
//# sourceMappingURL=zipAll.js.map

/***/ }),

/***/ "hiV6":
/***/ (function(module, exports) {

exports.model=Model={Game:{},Board:{},Move:{}},function(){var t;Model.Game.cbConstants={MASK:65535,FLAG_MOVE:65536,FLAG_CAPTURE:131072,FLAG_STOP:262144,FLAG_SCREEN_CAPTURE:524288,FLAG_CAPTURE_KING:1048576,FLAG_CAPTURE_NO_KING:2097152};var e="undefined"!=typeof Int32Array;Model.Game.cbUseTypedArrays=e,Model.Game.cbTypedArray=function(t){if(e){var r=new Int32Array(t.length);return r.set(t),r}for(var a=[],i=t.length,s=0;s<i;s++)a.push(t[s]);return a},Model.Game.cbShortRangeGraph=function(t,e,r,a){var i=this;void 0===a&&(a=196608);for(var s={},n=0;n<t.boardSize;n++)s[n]=[],(!r||n in r)&&e.forEach(function(e){var o=t.Graph(n,e);null!=o&&(!r||o in r)&&s[n].push(i.cbTypedArray([o|a]))});return s},Model.Game.cbLongRangeGraph=function(t,e,r,a,i){var s=this;void 0!==a&&null!=a||(a=196608),i||(i=1/0);for(var n={},o=0;o<t.boardSize;o++)n[o]=[],(!r||o in r)&&e.forEach(function(e){for(var h=[],p=t.Graph(o,e),c=0;null!=p&&(!r||p in r)&&(h.push(p|a),++c!=i);)p=t.Graph(p,e);h.length>0&&n[o].push(s.cbTypedArray(h))});return n},Model.Game.cbNullGraph=function(t){for(var e={},r=0;r<t.boardSize;r++)e[r]=[];return e},Model.Game.cbAuthorGraph=function(t){for(var e={},r=0;r<t.boardSize;r++){e[r]=[];for(var a=0;a<t.boardSize;a++)e[r].push([2293760|a])}return e},Model.Game.cbMergeGraphs=function(t){for(var e=[],r=0;r<t.boardSize;r++){e[r]=[];for(var a=1;a<arguments.length;a++)e[r]=e[r].concat(arguments[a][r])}return e},Model.Game.cbGetThreatGraph=function(){function t(e,r){for(var a in n){var i=n[a];if(!(i.p.length<r.length+1)){for(var s=!0,o=0;o<r.length;o++)if(r[o]!=i.p[o]){s=!1;break}if(s){var h=i.p[r.length],p=e[h];void 0===p&&(p={e:{}},e[h]=p),i.p.length==r.length+1&&(p.t=i.t,p.ts=i.ts,p.tk=i.tk,delete n[a]),r.push(h),t(p.e,r),r.pop()}}}}var e=this;this.cbUseScreenCapture=!1,this.cbUseCaptureKing=!1,this.cbUseCaptureNoKing=!1;for(var r={1:[],"-1":[]},a=[],i=0;i<this.g.boardSize;i++)this.g.pTypes.forEach(function(t,r){t.graph[i].forEach(function(t){for(var s=[],n=0;n<t.length;n++){var o=t[n];1048576&o?(e.cbUseCaptureKing=!0,s.unshift({d:65535&o,a:i,tk:r})):2097152&o?(e.cbUseCaptureNoKing=!0,s.unshift({d:65535&o,a:i,tnk:r})):131072&o?s.unshift({d:65535&o,a:i,t:r}):262144&o?s.unshift({d:65535&o,a:i}):524288&o&&(e.cbUseScreenCapture=!0,s.unshift({d:65535&o,a:i,ts:r}))}s.length>0&&a.push(s)})});var s={};a.forEach(function(t){t.forEach(function(e,r){var a=s[e.d];void 0===a&&(a={},s[e.d]=a);for(var i=[],n=r+1;n<t.length;n++)i.push(t[n].d);i.push(e.a);var o=i.join(","),h=a[o];void 0===h&&(h={p:i,t:{},ts:{},tk:{}},a[o]=h),void 0!==e.t?h.t[e.t]=!0:void 0!==e.tk?h.tk[e.tk]=!0:void 0!==e.ts&&(h.ts[e.ts]=!0)})});for(var i=0;i<e.g.boardSize;i++){var n=s[i],o={};t(o,[]),r[1][i]=o,r[-1][i]=o}return r},Model.Game.InitGame=function(){var e=this;this.cbVar=t=this.cbDefine(),this.g.boardSize=this.cbVar.geometry.boardSize,this.g.pTypes=this.cbGetPieceTypes(),this.g.threatGraph=this.cbGetThreatGraph(),this.g.distGraph=this.cbVar.geometry.GetDistances(),this.cbPiecesCount=0,this.g.castleablePiecesCount={1:0,"-1":0};for(var r in t.pieceTypes){var a=t.pieceTypes[r];if(a.castle){(a.initial||[]).forEach(function(t){e.g.castleablePiecesCount[t.s]++})}a.initial&&(this.cbPiecesCount+=a.initial.length)}for(var i=[],r=0;r<this.cbPiecesCount;r++)i.push(r);var s=Object.keys(t.pieceTypes);this.zobrist=new JocGame.Zobrist({board:{type:"array",size:this.cbVar.geometry.boardSize,values:i},who:{values:["1","-1"]},type:{type:"array",size:this.cbPiecesCount,values:s}})},Model.Game.cbGetPieceTypes=function(){for(var t=[],e={},r=0;r<this.cbVar.geometry.boardSize;r++)e[r]=[];for(var a in this.cbVar.pieceTypes){var i=this.cbVar.pieceTypes[a];t[a]={graph:i.graph||e,abbrev:i.abbrev||"",value:i.isKing?100:i.value||1,isKing:!!i.isKing,castle:!!i.castle,epTarget:!!i.epTarget,epCatch:!!i.epCatch}}return t},Model.Board.Init=function(t){this.zSign=0},Model.Board.InitialPosition=function(r){var a=this;this.board=e?new Int16Array(r.g.boardSize):[];for(var i=0;i<r.g.boardSize;i++)this.board[i]=-1;if(this.kings={},this.pieces=[],this.ending={1:!1,"-1":!1},this.lastMove=null,r.cbVar.castle&&(this.castled={1:!1,"-1":!1}),this.zSign=r.zobrist.update(0,"who",-1),this.noCaptCount=0,this.mWho=1,r.mInitial)this.mWho=r.mInitial.turn||1,r.mInitial.pieces.forEach(function(t){var e={};for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);a.pieces.push(e)}),r.mInitial.lastMove&&(this.lastMove={f:r.mInitial.lastMove.f,t:r.mInitial.lastMove.t}),void 0!==r.mInitial.noCaptCount&&(this.noCaptCount=r.mInitial.noCaptCount),r.cbVar.castle&&r.mInitial.castle&&(this.castled={1:{k:!!r.mInitial.castle[1]&&!!r.mInitial.castle[1].k,q:!!r.mInitial.castle[1]&&!!r.mInitial.castle[1].q},"-1":{k:!!r.mInitial.castle[-1]&&!!r.mInitial.castle[-1].k,q:!!r.mInitial.castle[-1]&&!!r.mInitial.castle[-1].q}});else for(var s in r.cbVar.pieceTypes)for(var n=r.cbVar.pieceTypes[s],o=n.initial||[],h=0;h<o.length;h++){var p=o[h],c={s:p.s,t:parseInt(s),p:p.p,m:!1};this.pieces.push(c)}if(this.pieces.sort(function(t,e){if(t.s!=e.s)return e.s-t.s;var a=r.cbVar.pieceTypes[t.t].value||100,i=r.cbVar.pieceTypes[e.t].value||100;return a!=i?a-i:t.p-e.p}),this.pieces.forEach(function(t,e){t.i=e,a.board[t.p]=e,r.g.pTypes[t.t].isKing&&(a.kings[t.s]=t.p),a.zSign=r.zobrist.update(a.zSign,"board",e,t.p),a.zSign=r.zobrist.update(a.zSign,"type",t.t,e)}),r.mInitial&&r.mInitial.enPassant){var i=t.geometry.PosByName(r.mInitial.enPassant);if(i>=0){var l,u=t.geometry.C(i),v=t.geometry.R(i);l=1==r.mInitial.turn?t.geometry.POS(u,v-1):t.geometry.POS(u,v+1),this.epTarget={p:i,i:this.board[l]}}}},Model.Board.CopyFrom=function(t){if(e)this.board=new Int16Array(t.board.length),this.board.set(t.board);else{this.board=[];for(var r=t.board,a=r.length,i=0;i<a;i++)this.board.push(r[i])}this.pieces=[];for(var s=t.pieces.length,i=0;i<s;i++){var n=t.pieces[i];this.pieces.push({s:n.s,p:n.p,t:n.t,i:n.i,m:n.m})}this.kings={1:t.kings[1],"-1":t.kings[-1]},this.check=t.check,t.lastMove?this.lastMove={f:t.lastMove.f,t:t.lastMove.t,c:t.lastMove.c}:this.lastMove=null,this.ending={1:t.ending[1],"-1":t.ending[-1]},void 0!==t.castled&&(this.castled={1:t.castled[1],"-1":t.castled[-1]}),this.noCaptCount=t.noCaptCount,t.epTarget?this.epTarget={p:t.epTarget.p,i:t.epTarget.i}:this.epTarget=null,this.mWho=t.mWho,this.zSign=t.zSign},Model.Board.cbApplyCastle=function(t,e,r){var a=t.cbVar.castle[e.f+"/"+e.cg],i=a.r[a.r.length-1],s=this.pieces[this.board[e.cg]],n=a.k[a.k.length-1],o=this.pieces[this.board[e.f]];return r&&(this.zSign=t.zobrist.update(this.zSign,"board",s.i,e.cg),this.zSign=t.zobrist.update(this.zSign,"board",s.i,i),this.zSign=t.zobrist.update(this.zSign,"board",o.i,e.f),this.zSign=t.zobrist.update(this.zSign,"board",o.i,n)),s.p=i,s.m=!0,this.board[e.cg]=-1,o.p=n,o.m=!0,this.board[e.f]=-1,this.board[i]=s.i,this.board[n]=o.i,this.castled[s.s]=!0,this.kings[o.s]=n,[{i:s.i,f:i,t:-1},{i:o.i,f:n,t:e.f,kp:e.f,who:o.s,m:!1},{i:s.i,f:-1,t:e.cg,m:!1,cg:!1}]},Model.Board.cbQuickApply=function(t,e){if(void 0!==e.cg)return this.cbApplyCastle(t,e,!1);var r=[],a=this.board[e.f],i=this.pieces[a];if(null!=e.c){r.unshift({i:e.c,f:-1,t:this.pieces[e.c].p});var s=this.pieces[e.c];this.board[s.p]=-1,s.p=-1}var n=this.kings[i.s];return t.g.pTypes[i.t].isKing&&(this.kings[i.s]=e.t),r.unshift({i:a,f:e.t,t:e.f,kp:n,who:i.s,ty:i.t}),i.p=e.t,void 0!==e.pr&&(i.t=e.pr),this.board[e.f]=-1,this.board[e.t]=a,r},Model.Board.cbQuickUnapply=function(t,e){for(var r=0;r<e.length;r++){var a=e[r],i=this.pieces[a.i];a.f>=0&&(i.p=-1,this.board[a.f]=-1),a.t>=0&&(i.p=a.t,this.board[a.t]=a.i),void 0!==a.m&&(i.m=a.m),void 0!==a.kp&&(this.kings[a.who]=a.kp),void 0!=a.ty&&(i.t=a.ty),void 0!=a.cg&&(this.castled[i.s]=a.cg)}},Model.Board.ApplyMove=function(t,e){var r=this.pieces[this.board[e.f]];if(void 0!==e.cg)this.cbApplyCastle(t,e,!0);else{if(this.zSign=t.zobrist.update(this.zSign,"board",r.i,e.f),this.board[r.p]=-1,void 0!==e.pr&&(this.zSign=t.zobrist.update(this.zSign,"type",r.t,r.i),r.t=e.pr,this.zSign=t.zobrist.update(this.zSign,"type",r.t,r.i)),null!=e.c){var a=this.pieces[e.c];this.zSign=t.zobrist.update(this.zSign,"board",a.i,a.p),this.board[a.p]=-1,a.p=-1,a.m=!0,this.noCaptCount=0}else this.noCaptCount++;r.p=e.t,r.m=!0,this.board[e.t]=r.i,this.zSign=t.zobrist.update(this.zSign,"board",r.i,e.t),t.g.pTypes[r.t].isKing&&(this.kings[r.s]=e.t)}this.check=!!e.ck,this.lastMove={f:e.f,t:e.t,c:e.c},void 0!==e.ko&&(this.ending[r.s]=e.ko),void 0!==e.ept?this.epTarget={p:e.ept,i:r.i}:this.epTarget=null,this.zSign=t.zobrist.update(this.zSign,"who",-this.mWho),this.zSign=t.zobrist.update(this.zSign,"who",this.mWho)},Model.Board.Evaluate=function(r){function a(e){var r=1/0;for(var a in t.geometry.corners)r=Math.min(r,h.distGraph[s.kings[e]][a]);return r-Math.sqrt(h.boardSize)}var i="debug"==arguments[3],s=this;this.mEvaluation=0;var n,o=this.mWho,h=r.g;if(e)n={1:{count:new Uint8Array(h.pTypes.length),byType:{}},"-1":{count:new Uint8Array(h.pTypes.length),byType:{}}};else{n={1:{count:[],byType:{}},"-1":{count:[],byType:{}}};for(var p=0;p<h.pTypes.length;p++)n[1].count[p]=n[-1].count[p]=0}if(r.mOptions.preventRepeat&&r.GetRepeatOccurence(this)>2)return this.mFinished=!0,void(this.mWinner=r.cbOnPerpetual?o*r.cbOnPerpetual:JocGame.DRAW);for(var c={1:0,"-1":0},l={1:h.distGraph[this.kings[-1]],"-1":h.distGraph[this.kings[1]]},u={1:0,"-1":0},v={1:0,"-1":0},b={1:0,"-1":0},f={1:0,"-1":0},g={1:!1,"-1":!1},d=this.pieces,m=d.length,p=0;p<m;p++){var G=d[p];if(G.p>=0){var y=G.s,M=h.pTypes[G.t];M.isKing?g[y]=G.m:c[y]+=M.value,M.castle&&!G.m&&f[y]++,v[y]++,u[y]+=l[y][G.p],b[y]+=t.geometry.distEdge[G.p];var C=n[y];C.count[G.t]++;var S=C.byType;void 0===S[G.t]?S[G.t]=[G]:S[G.t].push(G)}}if(this.lastMove&&null!=this.lastMove.c){var G=this.pieces[this.board[this.lastMove.t]];c[-G.s]+=this.cbStaticExchangeEval(r,G.p,G.s,{piece:G})}var k={1:0,"-1":0},A={1:0,"-1":0},T={1:0,"-1":0};this.ending[1]&&(A[1]=(u[1]-Math.sqrt(h.boardSize))/v[1],t.geometry.corners&&(T[1]=a(1))),this.ending[-1]&&(A[-1]=(u[-1]-Math.sqrt(h.boardSize))/v[-1],t.geometry.corners&&(T[1]=a(-1)));var z={pieceValue:c[1]-c[-1],pieceValueRatio:(c[1]-c[-1])/(c[1]+c[-1]+1),posValue:b[1]-b[-1],averageDistKing:u[1]/v[1]-u[-1]/v[-1],check:this.check?-o:0,endingKingFreedom:k[1]-k[-1],endingDistKing:A[1]-A[-1],distKingCorner:T[1]-T[-1]};t.castle&&(z.castle=(this.castled[1]?1:g[1]?0:f[1]/(h.castleablePiecesCount[1]+1))-(this.castled[-1]?1:g[-1]?0:f[-1]/(h.castleablePiecesCount[-1]+1))),t.evaluate&&t.evaluate.call(this,r,z,n);var E=r.mOptions.levelOptions;for(var P in z){var R=z[P],w=E[P+"Factor"]||0,I=R*w;i&&console.log(P,"=",R,"*",w,"=>",I),this.mEvaluation+=I}i&&console.log("Evaluation",this.mEvaluation)},Model.Board.cbGeneratePseudoLegalMoves=function(t){function e(e,i){var s=t.cbVar.promote;if(!s)return void a.push(i);var n=s.call(r,t,e,i);if(null!=n)if(0==n.length)a.push(i);else if(1==n.length)i.pr=n[0],a.push(i);else for(var o=0;o<n.length;o++){var h=n[o];a.push({f:i.f,t:i.t,c:i.c,pr:h,ept:i.ept,ep:i.ep,a:i.a})}}for(var r=this,a=[],i=t.cbVar,s=this.mWho,n=!i.castle||this.check||this.castled[s]?null:[],o=-1,h=this.pieces.length,p=0;p<h;p++){var c=this.pieces[p];if(!(c.p<0||c.s!=s)){var l=t.g.pTypes[c.t];l.isKing&&(c.m?n=null:o=c),n&&l.castle&&!c.m&&n.push(c);var u,v;u=l.graph[c.p],v=u.length;for(var b=0;b<v;b++)for(var f=u[b],g=!1,d=f.length,m=null,G=0;G<d;G++){var y=f[G],M=65535&y,C=this.board[M];if(!(C<0)||l.epCatch&&this.epTarget&&this.epTarget.p==M){if(!(524288&y)){var S;S=C<0?this.pieces[this.epTarget.i]:this.pieces[C],!(S.s!=c.s&&131072&y)||1048576&y&&!t.g.pTypes[S.t].isKing||2097152&y&&t.g.pTypes[S.t].isKing||e(c,{f:c.p,t:M,c:S.i,a:l.abbrev,ep:C<0});break}if(g){var S=this.pieces[C];S.s!=c.s&&e(c,{f:c.p,t:M,c:S.i,a:l.abbrev});break}g=!0}else 65536&y&&0==g&&e(c,{f:c.p,t:M,c:null,a:l.abbrev,ept:null!=m&&l.epTarget?m:void 0});m=M}}}if(n)for(var p=0;p<n.length;p++){var k=n[p],A=t.cbVar.castle[o.p+"/"+k.p];if(A){for(var T=!0,b=0;b<A.r.length;b++){var z=A.r[b];if(this.board[z]>=0&&z!=o.p&&z!=k.p){T=!1;break}}if(T){for(var E=!0,b=0;b<A.k.length;b++){var z=A.k[b];if(this.board[z]>=0&&z!=k.p&&z!=o.p||this.cbGetAttackers(t,z,s).length>0){E=!1;break}}E&&a.push({f:o.p,t:A.k[A.k.length-1],c:null,cg:k.p})}}}return a},Model.Board.cbStaticExchangeEval=function(t,e,r,a){var i=0,s=this.cbGetSmallestAttacker(t,e,r);if(s){var n=this.mWho;this.mWho=s.s;var o=this.cbQuickApply(t,{f:s.p,t:e,c:a.piece.i}),h=t.g.pTypes[a.piece.t].value;a.piece=s,i=Math.max(0,h-this.cbStaticExchangeEval(t,e,-r,a)),this.cbQuickUnapply(t,o),this.mWho=n}return i},Model.Board.cbGetSmallestAttacker=function(t,e,r){var a=this.cbGetAttackers(t,e,r);if(0==a.length)return null;for(var i=1/0,s=null,n=a.length,o=0;o<n;o++){var h=a[o],p=t.g.pTypes[h.t].value;p<i&&(i=p,s=h)}return s},Model.Board.cbCollectAttackers=function(t,e,r,a){for(var i in e){var s=e[i],n=this.board[i];if(n<0)this.cbCollectAttackers(t,s.e,r,a);else{var o=this.pieces[n];o.s==-t&&(s.t&&o.t in s.t||a&&s.tk&&o.t in s.tk)&&r.push(o)}}},Model.Board.cbCollectAttackersScreen=function(t,e,r,a,i){for(var s in e){var n=e[s],o=this.board[s];if(o<0)this.cbCollectAttackersScreen(t,n.e,r,a,i);else{var h=this.pieces[o];!i&&h.s==-t&&(n.t&&h.t in n.t||a&&n.tk&&h.t in n.tk)?r.push(h):i?i&&h.s==-t&&n.ts&&h.t in n.ts&&r.push(h):this.cbCollectAttackersScreen(t,n.e,r,a,!0)}}},Model.Board.cbGetAttackers=function(t,e,r,a){var i=[];return t.cbUseScreenCapture?this.cbCollectAttackersScreen(r,t.g.threatGraph[r][e],i,a,!1):this.cbCollectAttackers(r,t.g.threatGraph[r][e],i,a),i},Model.Board.GenerateMoves=function(t){var e=this.cbGeneratePseudoLegalMoves(t);this.mMoves=[];for(var r=!0,a=this.kings[this.mWho],i=e.length,s=0;s<i;s++){var n=e[s],o=this.cbQuickApply(t,n);if(!(this.cbGetAttackers(t,this.kings[this.mWho],this.mWho,!0).length>0)){var h=this.cbGetAttackers(t,this.kings[-this.mWho],-this.mWho,!0).length>0;n.ck=h,this.mMoves.push(n),n.f!=a&&(r=!1)}this.cbQuickUnapply(t,o)}if(0==this.mMoves.length)this.mFinished=!0,this.mWinner=t.cbOnStaleMate?t.cbOnStaleMate*this.mWho:JocGame.DRAW,this.check&&(this.mWinner=-this.mWho);else if(this.ending[this.mWho]){if(!r)for(var s=0;s<this.mMoves.length;s++)this.mMoves[s].ko=!1}else if(!this.ending[this.mWho]&&r&&!this.check)for(var s=0;s<this.mMoves.length;s++)this.mMoves[s].ko=!0},Model.Board.GetSignature=function(){return this.zSign},Model.Move.Init=function(t){for(var e in t)t.hasOwnProperty(e)&&(this[e]=t[e])},Model.Move.Equals=function(t){return this.f==t.f&&this.t==t.t&&this.pr==t.pr},Model.Move.CopyFrom=function(t){this.Init(t)},Model.Move.ToString=function(e){var r=this;switch(e=e||"natural"){case"natural":return function(){var e;if(void 0!==r.cg?e=t.castle[r.f+"/"+r.cg].n:(e=r.a||"",e+=t.geometry.PosName(r.f),null==r.c?e+="-":e+="x",e+=t.geometry.PosName(r.t)),void 0!==r.pr){var a=t.pieceTypes[r.pr];a&&a.abbrev&&a.abbrev.length>0&&!a.silentPromo&&(e+="="+a.abbrev)}return r.ck&&(e+="+"),e}();case"engine":return function(){var e=t.geometry.PosName(r.f)+t.geometry.PosName(r.t);if(void 0!=r.pr){var a=t.pieceTypes[r.pr];a&&a.abbrev&&a.abbrev.length>0&&!a.silentPromo&&(e+=a.abbrev)}return e}();default:return"??"}},Model.Board.CompactMoveString=function(e,r,a){"function"!=typeof r.ToString&&(r=e.CreateMove(r));var i=r.ToString(),s=/^([A-Z]?)([a-z])([1-9][0-9]*)([-x])([a-z])([1-9][0-9]*)(.*?)$/.exec(i);if(!s)return i;var n=s[7];if(a||(a={}),a.value||(a.value=[]),0==a.value.length){var o=this.mMoves;this.mMoves&&0!=this.mMoves.length||this.GenerateMoves(e);for(var h=0;h<this.mMoves.length;h++){var p=this.mMoves[h];"function"!=typeof p.ToString&&(p=e.CreateMove(p)),a.value.push({str:p.ToString(),move:p})}this.mMoves=o}var c=[];if(a.value.forEach(function(t){var e=/^([A-Z]?[a-z][1-9][0-9]*[-x][a-z][1-9][0-9]*)(.*?)$/.exec(t.str);e&&t.move.t==r.t&&(t.move.a||"")==s[1]&&e[2]==n&&c.push(t.move)}),1==c.length)return""==s[1]&&"x"==s[4]?s[2]+"x"+s[5]+s[6]+s[7]:s[1]+("x"==s[4]?"x":"")+s[5]+s[6]+s[7];if(t.geometry.CompactCrit)for(var l="",h=0;;h++){var u=t.geometry.CompactCrit(r.f,h);if(null==u)return i;l+=u;for(var v=[],b=0;b<c.length;b++){var f=c[b];t.geometry.CompactCrit(f.f,h)==u&&v.push(f)}if(console.assert(v.length>0),1==v.length)return s[1]+l+("x"==s[4]?"x":"")+s[5]+s[6]+s[7];c=v}return i},Model.Board.cbIntegrity=function(t){function e(t,e){t||console.error(e)}for(var r=this,a=0;a<this.board.length;a++){var i=this.board[a];if(i>=0){var s=r.pieces[i];e(void 0!==s,"no piece at pos"),e(s.p==a,"piece has different pos")}}for(var i=0;i<this.pieces.length;i++){var s=this.pieces[i];s.p>=0&&e(r.board[s.p]==i,"board index mismatch")}},Model.Board.ExportBoardState=function(t){return t.cbVar.geometry.ExportBoardState?t.cbVar.geometry.ExportBoardState(this,t.cbVar,t.mPlayedMoves.length):"not supported"},Model.Game.Import=function(e,r){var a,i=[],s={1:{},"-1":{}},n=null,o=0;if("pjn"==e){var h={status:!1,error:"parse"},p=r.split(" ");if(6!=p.length)return console.warn("FEN should have 6 parts"),h;var c=p[0].split("/"),l=t.geometry.fenHeight||t.geometry.height;if(c.length!=l)return console.warn("FEN board should have",l,"rows, got",c.length),h;var u={};for(var v in t.pieceTypes){var b=t.pieceTypes[v],f=b.fenAbbrev||b.abbrev||"X";u[f.toUpperCase()]={s:1,t:v},u[f.toLowerCase()]={s:-1,t:v}}var g=t.geometry.FenRowPos||function(e,r){return(t.geometry.height-1-e)*t.geometry.width+r};if(c.forEach(function(e,r){for(var a=0,s=0;s<e.length;s++){var n=e.substr(s,1),o=u[n];if(void 0!==o){var p=g(r,a);a++;for(var c={s:o.s,t:o.t,p:p},l=!0,v=t.pieceTypes[c.t].initial||[],b=0;b<v.length;b++){var f=v[b];f.s==c.s&&f.p==p&&(l=!1)}c.m=l,i.push(c)}else{if(isNaN(parseInt(n)))return console.warn("FEN invalid board spec",n),h;a+=parseInt(n)}}}),i.sort(function(t,e){return e.s-t.s}),"w"==p[1])a=1;else{if("b"!=p[1])return console.warn("FEN invalid turn spec",p[1]),h;a=-1}s[1].k=p[2].indexOf("K")>=0,s[1].q=p[2].indexOf("Q")>=0,s[-1].k=p[2].indexOf("k")>=0,s[-1].q=p[2].indexOf("q")>=0,n="-"==p[3]?null:p[3];var d=parseInt(p[4]);isNaN(d)||(o=d);var m={pieces:i,turn:a,castle:s,enPassant:n,noCaptCount:o};return t.importGame&&t.importGame.call(this,m,e,r),{status:!0,initial:m}}return{status:!1,error:"unsupported"}}}(),function(){Model.Game.cbBoardGeometryGrid=function(t,e){function r(e){return e%t}function a(e){return Math.floor(e/t)}function i(e,r){return r*t+e}function s(s,n){var o=r(s),h=a(s),p=o+n[0],c=h+n[1];return p<0||p>=t||c<0||c>=e?null:i(p,c)}function n(t){return String.fromCharCode("a".charCodeAt(0)+r(t))+(a(t)+1)}function o(t){var e=/^([a-z])([0-9]+)$/.exec(t);return e?i(e[1].charCodeAt(0)-"a".charCodeAt(0),parseInt(e[2])-1):-1}function h(t,e){return 0==e?String.fromCharCode("a".charCodeAt(0)+r(t)):1==e?a(t)+1:null}function p(){for(var i=[],s=0;s<t*e;s++){var n=[];i.push(n);for(var o=0;o<t*e;o++){var h=a(s),p=r(s),c=a(o),l=r(o);n.push(Math.max(Math.abs(h-c),Math.abs(p-l)))}}return i}function c(r,a,s){for(var o=[],h=e-1;h>=0;h--){for(var p="",c=0,l=0;l<t;l++){var u=r.board[i(l,h)];if(u<0)c++;else{c>0&&(p+=c,c=0);var v=r.pieces[u],b=a.pieceTypes[v.t].fenAbbrev||a.pieceTypes[v.t].abbrev||"?";v.s==-1?p+=b.toLowerCase():p+=b.toUpperCase()}}c&&(p+=c),o.push(p)}var f=o.join("/");f+=" ",1==r.mWho?f+="w":f+="b",f+=" ";var g="";return r.castled&&(r.castled[1]===!1?g+="KQ":(r.castled[1].k&&(g+="K"),r.castled[1].q&&(g+="Q")),r.castled[-1]===!1?g+="kq":(r.castled[-1].k&&(g+="k"),r.castled[-1].q&&(g+="q"))),0==g.length&&(g="-"),f+=g,f+=" ",r.epTarget?f+=n(r.epTarget.p):f+="-",f+=" ",f+=r.noCaptCount,f+=" ",f+=Math.floor(s/2)+1}return{boardSize:t*e,width:t,height:e,C:r,R:a,POS:i,Graph:s,PosName:n,PosByName:o,CompactCrit:h,GetDistances:p,distEdge:function(){for(var i=[],s=0;s<t*e;s++){var n=r(s),o=a(s);i[s]=Math.min(n,Math.abs(t-n-1),o,Math.abs(e-o-1))}return i}(),corners:function(){var r={};return r[i(0,0)]=1,r[i(0,e-1)]=1,r[i(t-1,0)]=1,r[i(t-1,e-1)]=1,r}(),ExportBoardState:c}},Model.Game.cbPawnGraph=function(t,e,r){for(var a=this,i={},s=0;s<t.boardSize;s++)if(!r||s in r){var n=[],o=t.Graph(s,[0,e]);null!=o&&(!r||o in r)&&n.push(a.cbTypedArray([o|a.cbConstants.FLAG_MOVE])),[-1,1].forEach(function(i){var o=t.Graph(s,[i,e]);null!=o&&(!r||o in r)&&n.push(a.cbTypedArray([o|a.cbConstants.FLAG_CAPTURE]))}),i[s]=n}else i[s]=[];return i},Model.Game.cbInitialPawnGraph=function(t,e,r){for(var a=this,i={},s=0;s<t.boardSize;s++)if(!r||s in r){var n=[],o=t.Graph(s,[0,e]);if(null!=o&&(!r||o in r)){var h=[o|a.cbConstants.FLAG_MOVE],p=t.Graph(o,[0,e]);null!=p&&(!r||p in r)&&h.push(p|a.cbConstants.FLAG_MOVE),n.push(a.cbTypedArray(h))}[-1,1].forEach(function(i){var o=t.Graph(s,[i,e]);null!=o&&(!r||o in r)&&n.push(a.cbTypedArray([o|a.cbConstants.FLAG_CAPTURE]))}),i[s]=n}else i[s]=[];return i},Model.Game.cbKingGraph=function(t,e){return this.cbShortRangeGraph(t,[[-1,-1],[-1,0],[-1,1],[0,-1],[0,1],[1,-1],[1,0],[1,1]],e)},Model.Game.cbKnightGraph=function(t,e){return this.cbShortRangeGraph(t,[[2,-1],[2,1],[-2,-1],[-2,1],[-1,2],[-1,-2],[1,2],[1,-2]],e)},Model.Game.cbHorseGraph=function(t){for(var e=this,r={},a=0;a<t.boardSize;a++)r[a]=[],[[1,0,2,-1],[1,0,2,1],[-1,0,-2,-1],[-1,0,-2,1],[0,1,-1,2],[0,-1,-1,-2],[0,1,1,2],[0,-1,1,-2]].forEach(function(i){var s=t.Graph(a,[i[0],i[1]]);if(null!=s){var n=t.Graph(a,[i[2],i[3]]);null!=n&&r[a].push(e.cbTypedArray([s|e.cbConstants.FLAG_STOP,n|e.cbConstants.FLAG_MOVE|e.cbConstants.FLAG_CAPTURE]))}});return r},Model.Game.cbRookGraph=function(t,e){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0]],e)},Model.Game.cbBishopGraph=function(t,e){return this.cbLongRangeGraph(t,[[1,-1],[1,1],[-1,1],[-1,-1]],e)},Model.Game.cbQueenGraph=function(t,e){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0],[1,-1],[1,1],[-1,1],[-1,-1]],e)},Model.Game.cbXQGeneralGraph=function(t,e){for(var r=this,a={},i=0;i<t.boardSize;i++)a[i]=[],[[-1,0,!1],[0,-1,!0],[0,1,!0],[1,0,!1]].forEach(function(s){var n=[],o=t.Graph(i,s);if(null!=o&&((!e||o in e)&&n.push(o|r.cbConstants.FLAG_MOVE|r.cbConstants.FLAG_CAPTURE),s[2]))for(var h=t.Graph(o,s);null!=h;)!e||h in e?n.push(h|r.cbConstants.FLAG_CAPTURE|r.cbConstants.FLAG_CAPTURE_KING):n.push(h|r.cbConstants.FLAG_STOP),h=t.Graph(h,s);n.length>0&&a[i].push(r.cbTypedArray(n))});return a},Model.Game.cbXQSoldierGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e]])},Model.Game.cbXQPromoSoldierGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e],[-1,0],[1,0]])},Model.Game.cbXQAdvisorGraph=function(t,e){return this.cbShortRangeGraph(t,[[1,1],[-1,1],[1,-1],[-1,-1]],e)},Model.Game.cbXQCannonGraph=function(t){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0]],null,this.cbConstants.FLAG_MOVE|this.cbConstants.FLAG_SCREEN_CAPTURE)},Model.Game.cbXQElephantGraph=function(t,e){for(var r=this,a={},i=0;i<t.boardSize;i++)a[i]=[],(!e||i in e)&&[[1,1,2,2],[1,-1,2,-2],[-1,1,-2,2],[-1,-1,-2,-2]].forEach(function(s){var n=t.Graph(i,[s[0],s[1]]);if(null!=n){var o=t.Graph(i,[s[2],s[3]]);null!=o&&(!e||o in e)&&a[i].push(r.cbTypedArray([n|r.cbConstants.FLAG_STOP,o|r.cbConstants.FLAG_MOVE|r.cbConstants.FLAG_CAPTURE]))}});return a},Model.Game.cbSilverGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e],[-1,-1],[-1,1],[1,-1],[1,1]])},Model.Game.cbFersGraph=function(t,e){return this.cbShortRangeGraph(t,[[-1,-1],[-1,1],[1,-1],[1,1]])},Model.Game.cbSchleichGraph=function(t,e){return this.cbShortRangeGraph(t,[[-1,0],[1,0],[0,-1],[0,1]])},Model.Game.cbAlfilGraph=function(t,e){return this.cbShortRangeGraph(t,[[-2,-2],[-2,2],[2,2],[2,-2]])}}(),function(){var t=Model.Game.cbBoardGeometryGrid(12,8);Model.Game.cbDefine=function(){return{geometry:t,pieceTypes:{0:{name:"pawn-w",aspect:"fr-pawn",graph:this.cbPawnGraph(t,1),value:1.05,abbrev:"",fenAbbrev:"P",epCatch:!0},1:{name:"ipawn-w",aspect:"fr-pawn",graph:this.cbInitialPawnGraph(t,1),value:1.05,abbrev:"",fenAbbrev:"P",initial:[{s:1,p:12},{s:1,p:13},{s:1,p:14},{s:1,p:15},{s:1,p:16},{s:1,p:17},{s:1,p:18},{s:1,p:19},{s:1,p:20},{s:1,p:21},{s:1,p:22},{s:1,p:23}],epTarget:!0},2:{name:"pawn-b",aspect:"fr-pawn",graph:this.cbPawnGraph(t,-1),value:1.05,abbrev:"",fenAbbrev:"P",epCatch:!0},3:{name:"ipawn-b",aspect:"fr-pawn",graph:this.cbInitialPawnGraph(t,-1),value:1.05,abbrev:"",fenAbbrev:"P",initial:[{s:-1,p:72},{s:-1,p:73},{s:-1,p:74},{s:-1,p:75},{s:-1,p:76},{s:-1,p:77},{s:-1,p:78},{s:-1,p:79},{s:-1,p:80},{s:-1,p:81},{s:-1,p:82},{s:-1,p:83}],epTarget:!0},4:{name:"knight",aspect:"fr-knight",graph:this.cbKnightGraph(t),value:2.7,abbrev:"N",initial:[{s:1,p:1},{s:1,p:10},{s:-1,p:85},{s:-1,p:94}]},5:{name:"courier",aspect:"fr-bishop",graph:this.cbBishopGraph(t),value:3.3,abbrev:"C",initial:[{s:1,p:3},{s:1,p:8},{s:-1,p:87},{s:-1,p:92}]},6:{name:"rook",aspect:"fr-rook",graph:this.cbRookGraph(t),value:5,abbrev:"R",initial:[{s:1,p:0},{s:1,p:11},{s:-1,p:84},{s:-1,p:95}],castle:!0},7:{name:"queen",aspect:"fr-queen",graph:this.cbQueenGraph(t),value:8.3,abbrev:"Q",initial:[{s:1,p:5},{s:-1,p:89}]},8:{name:"king",aspect:"fr-king",isKing:!0,graph:this.cbKingGraph(t),abbrev:"K",initial:[{s:1,p:6},{s:-1,p:90}]},9:{name:"archer",aspect:"fr-elephant",graph:this.cbShortRangeGraph(t,[[-1,-1],[-1,1],[1,-1],[1,1],[-2,-2],[-2,2],[2,-2],[2,2]]),value:2.75,abbrev:"A",initial:[{s:1,p:2},{s:1,p:9},{s:-1,p:86},{s:-1,p:93}]},10:{name:"champion",aspect:"fr-lighthouse",graph:this.cbShortRangeGraph(t,[[-1,-1],[-1,1],[1,-1],[1,1],[1,0],[0,1],[-1,0],[0,-1],[-2,0],[0,-2],[2,0],[0,2]]),value:4.8,abbrev:"Ch",initial:[{s:1,p:4},{s:-1,p:88}]},11:{name:"paladin",aspect:"fr-unicorn",graph:this.cbShortRangeGraph(t,[[-1,-1],[-1,1],[1,-1],[1,1],[1,0],[0,1],[-1,0],[0,-1],[-2,-1],[-1,-2],[1,-2],[2,-1],[2,1],[1,2],[-1,2],[-2,1]]),value:6,abbrev:"Pa",initial:[{s:1,p:7},{s:-1,p:91}]}},promote:function(e,r,a){return 1==r.t?[0]:3==r.t?[2]:0==r.t&&7==t.R(a.t)?[4,5,6,7,9,10,11]:2==r.t&&0==t.R(a.t)?[4,5,6,7,9,10,11]:[]},castle:{"6/0":{k:[5,4,3,2],r:[1,2,3],n:"O-O-O"},"6/11":{k:[7,8,9,10],r:[10,9],n:"O-O"},"90/84":{k:[89,88,87,86],r:[85,86,87],n:"O-O-O"},"90/95":{k:[91,92,93,94],r:[94,93],n:"O-O"}}}}}();

/***/ }),

/***/ "hs6U":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var find_1 = __webpack_require__("GZqV");
Observable_1.Observable.prototype.find = find_1.find;
//# sourceMappingURL=find.js.map

/***/ }),

/***/ "hvqw":
/***/ (function(module, exports) {

var conf = {
    '10x10':{},
    '8x8'  :{},
    '12x12':{}
};

// The greatest square number
conf['10x10']['SQ_MAX_NUM'] = 50;
conf['8x8']['SQ_MAX_NUM']   = 32;
conf['12x12']['SQ_MAX_NUM'] = 72;

// Number of active square per line
conf['10x10']['SQ_ACTIVE_PER_LINE'] = 5;
conf['8x8']['SQ_ACTIVE_PER_LINE']   = 4;
conf['12x12']['SQ_ACTIVE_PER_LINE'] = 6;

// Black initial position
conf['10x10']['B_POSITION'] = [1, 20];
conf['8x8']['B_POSITION']   = [1, 12];
conf['12x12']['B_POSITION'] = [1, 30];

// White initial position
conf['10x10']['W_POSITION'] = [31, 50];
conf['8x8']['W_POSITION']   = [21, 32];
conf['12x12']['W_POSITION'] = [43, 72];

// White pieces are crowned on this interval
conf['10x10']['W_CROWNED'] = [1, 5];
conf['8x8']['W_CROWNED']   = [1, 4];
conf['12x12']['W_CROWNED'] = [1, 12];

// Black pieces are crowned on this interval
conf['10x10']['B_CROWNED'] = [46, 50];
conf['8x8']['B_CROWNED']   = [29, 32];
conf['12x12']['B_CROWNED'] = [61, 72]


/** List of diagonal parallel to the "Great Diagonal" */
conf['10x10']['DIAGONALS_GD'] = [
    [  6,  1 ], 
    [ 16, 11,  7,  2 ], 
    [ 26, 21, 17, 12,  8,  3 ], 
    [ 36, 31, 27, 22, 18, 13,  9,  4 ], 
    [ 46, 41, 37, 32, 28, 23, 19, 14, 10, 5 ],
    [ 47, 42, 38, 33, 29, 24, 20, 15 ], 
    [ 48, 43, 39, 34, 30, 25 ], 
    [ 49, 44, 40, 35 ], 
    [ 50, 45 ] 
];

conf['8x8']['DIAGONALS_GD'] = [
    [  5,  1 ], 
    [ 13,  9,  6,  2 ], 
    [ 21, 17, 14, 10,  7,  3 ], 
    [ 29, 25, 22, 18, 15, 11, 8, 4 ], 
    [ 30, 26, 23, 19, 16, 12 ],
    [ 31, 27, 24, 20 ], 
    [ 32, 28 ] 
];

conf['12x12']['DIAGONALS_GD'] = [
    [ 7,  1 ], 
    [ 19, 13,  8,  2 ], 
    [ 31, 25, 20, 14,  9,  3 ], 
    [ 43, 37, 32, 26, 21, 15, 10,  4 ], 
    [ 55, 49, 44, 38, 33, 27, 22, 16, 11,  5 ],
    [ 67, 61, 56, 50, 45, 39, 34, 28, 23, 17, 12, 6 ], 
    [ 68, 62, 57, 51, 46, 40, 35, 29, 24, 18 ], 
    [ 69, 63, 58, 52, 47, 41, 36, 30 ], 
    [ 70, 64, 59, 53, 48, 42 ], 
    [ 71, 65, 60, 54 ], 
    [ 72, 66 ] 
];


/** List of diagonal parallel to the "Tric Trac" */
conf['10x10']['DIAGONALS_TT'] = [ 
    [  5 ], 
    [ 15, 10,  4 ], 
    [ 25, 20, 14,  9,  3 ], 
    [ 35, 30, 24, 19, 13,  8,  2 ], 
    [ 45, 40, 34, 29, 23, 18, 12,  7, 1 ], 
    [ 50, 44, 39, 33, 28, 22, 17, 11, 6 ],
    [ 49, 43, 38, 32, 27, 21, 16 ], 
    [ 48, 42, 37, 31, 26 ], 
    [ 47, 41, 36 ], 
    [ 46 ] 
];

conf['8x8']['DIAGONALS_TT'] = [ 
    [  4 ], 
    [ 12,  8,  3 ], 
    [ 20, 16, 11,  7,  2 ], 
    [ 28, 24, 19, 15, 10, 6, 1 ], 
    [ 32, 27, 23, 18, 14, 9, 5 ], 
    [ 31, 26, 22, 17, 13 ],
    [ 30, 25, 21 ], 
    [ 29 ]
];

conf['12x12']['DIAGONALS_TT'] = [ 
    [  6 ], 
    [ 18, 12,  5 ], 
    [ 30, 24, 17, 11,  4 ], 
    [ 42, 36, 29, 23, 16, 10,  3 ], 
    [ 54, 48, 41, 35, 28, 22, 15,  9,  2 ], 
    [ 66, 60, 53, 47, 40, 34, 27, 21, 14,  8, 1 ],
    [ 72, 65, 59, 52, 46, 39, 33, 26, 20, 13, 7 ],
    [ 71, 64, 58, 51, 45, 38, 32, 25, 19 ],
    [ 70, 63, 57, 50, 44, 37, 31 ],
    [ 69, 62, 56, 49, 43 ],
    [ 68, 61, 55 ],
    [ 67 ]
];


exports.Conf = conf;


/***/ }),

/***/ "hzF8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var take_1 = __webpack_require__("POFt");
Observable_1.Observable.prototype.take = take_1.take;
//# sourceMappingURL=take.js.map

/***/ }),

/***/ "iESu":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var OuterSubscriber_1 = __webpack_require__("wAkD");
var subscribeToResult_1 = __webpack_require__("CURp");
/* tslint:enable:max-line-length */
/**
 * Projects each source value to the same Observable which is merged multiple
 * times in the output Observable.
 *
 * <span class="informal">It's like {@link mergeMap}, but maps each value always
 * to the same inner Observable.</span>
 *
 * <img src="./img/mergeMapTo.png" width="100%">
 *
 * Maps each source value to the given Observable `innerObservable` regardless
 * of the source value, and then merges those resulting Observables into one
 * single Observable, which is the output Observable.
 *
 * @example <caption>For each click event, start an interval Observable ticking every 1 second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.mergeMapTo(Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link concatMapTo}
 * @see {@link merge}
 * @see {@link mergeAll}
 * @see {@link mergeMap}
 * @see {@link mergeScan}
 * @see {@link switchMapTo}
 *
 * @param {ObservableInput} innerObservable An Observable to replace each value from
 * the source Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @return {Observable} An Observable that emits items from the given
 * `innerObservable` (and optionally transformed through `resultSelector`) every
 * time a value is emitted on the source Observable.
 * @method mergeMapTo
 * @owner Observable
 */
function mergeMapTo(innerObservable, resultSelector, concurrent) {
    if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
    if (typeof resultSelector === 'number') {
        concurrent = resultSelector;
        resultSelector = null;
    }
    return this.lift(new MergeMapToOperator(innerObservable, resultSelector, concurrent));
}
exports.mergeMapTo = mergeMapTo;
// TODO: Figure out correct signature here: an Operator<Observable<T>, R>
//       needs to implement call(observer: Subscriber<R>): Subscriber<Observable<T>>
var MergeMapToOperator = (function () {
    function MergeMapToOperator(ish, resultSelector, concurrent) {
        if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
        this.ish = ish;
        this.resultSelector = resultSelector;
        this.concurrent = concurrent;
    }
    MergeMapToOperator.prototype.call = function (observer, source) {
        return source.subscribe(new MergeMapToSubscriber(observer, this.ish, this.resultSelector, this.concurrent));
    };
    return MergeMapToOperator;
}());
exports.MergeMapToOperator = MergeMapToOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var MergeMapToSubscriber = (function (_super) {
    __extends(MergeMapToSubscriber, _super);
    function MergeMapToSubscriber(destination, ish, resultSelector, concurrent) {
        if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
        _super.call(this, destination);
        this.ish = ish;
        this.resultSelector = resultSelector;
        this.concurrent = concurrent;
        this.hasCompleted = false;
        this.buffer = [];
        this.active = 0;
        this.index = 0;
    }
    MergeMapToSubscriber.prototype._next = function (value) {
        if (this.active < this.concurrent) {
            var resultSelector = this.resultSelector;
            var index = this.index++;
            var ish = this.ish;
            var destination = this.destination;
            this.active++;
            this._innerSub(ish, destination, resultSelector, value, index);
        }
        else {
            this.buffer.push(value);
        }
    };
    MergeMapToSubscriber.prototype._innerSub = function (ish, destination, resultSelector, value, index) {
        this.add(subscribeToResult_1.subscribeToResult(this, ish, value, index));
    };
    MergeMapToSubscriber.prototype._complete = function () {
        this.hasCompleted = true;
        if (this.active === 0 && this.buffer.length === 0) {
            this.destination.complete();
        }
    };
    MergeMapToSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        var _a = this, resultSelector = _a.resultSelector, destination = _a.destination;
        if (resultSelector) {
            this.trySelectResult(outerValue, innerValue, outerIndex, innerIndex);
        }
        else {
            destination.next(innerValue);
        }
    };
    MergeMapToSubscriber.prototype.trySelectResult = function (outerValue, innerValue, outerIndex, innerIndex) {
        var _a = this, resultSelector = _a.resultSelector, destination = _a.destination;
        var result;
        try {
            result = resultSelector(outerValue, innerValue, outerIndex, innerIndex);
        }
        catch (err) {
            destination.error(err);
            return;
        }
        destination.next(result);
    };
    MergeMapToSubscriber.prototype.notifyError = function (err) {
        this.destination.error(err);
    };
    MergeMapToSubscriber.prototype.notifyComplete = function (innerSub) {
        var buffer = this.buffer;
        this.remove(innerSub);
        this.active--;
        if (buffer.length > 0) {
            this._next(buffer.shift());
        }
        else if (this.active === 0 && this.hasCompleted) {
            this.destination.complete();
        }
    };
    return MergeMapToSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
exports.MergeMapToSubscriber = MergeMapToSubscriber;
//# sourceMappingURL=mergeMapTo.js.map

/***/ }),

/***/ "iFJ4":
/***/ (function(module, exports) {

exports.model=Model={Game:{},Board:{},Move:{}},function(){var e;Model.Game.cbConstants={MASK:65535,FLAG_MOVE:65536,FLAG_CAPTURE:131072,FLAG_STOP:262144,FLAG_SCREEN_CAPTURE:524288,FLAG_CAPTURE_KING:1048576,FLAG_CAPTURE_NO_KING:2097152};var m="undefined"!=typeof Int32Array;Model.Game.cbUseTypedArrays=m,Model.Game.cbTypedArray=function(e){if(m){var h=new Int32Array(e.length);return h.set(e),h}for(var b=[],c=e.length,g=0;g<c;g++)b.push(e[g]);return b},Model.Game.cbShortRangeGraph=function(e,m,h,b){var c=this;void 0===b&&(b=196608);for(var g={},i=0;i<e.boardSize;i++)g[i]=[],(!h||i in h)&&m.forEach(function(m){var H=e.Graph(i,m);null!=H&&(!h||H in h)&&g[i].push(c.cbTypedArray([H|b]))});return g},Model.Game.cbLongRangeGraph=function(e,m,h,b,c){var g=this;void 0!==b&&null!=b||(b=196608),c||(c=1/0);for(var i={},H=0;H<e.boardSize;H++)i[H]=[],(!h||H in h)&&m.forEach(function(m){for(var a=[],R=e.Graph(H,m),C=0;null!=R&&(!h||R in h)&&(a.push(R|b),++C!=c);)R=e.Graph(R,m);a.length>0&&i[H].push(g.cbTypedArray(a))});return i},Model.Game.cbNullGraph=function(e){for(var m={},h=0;h<e.boardSize;h++)m[h]=[];return m},Model.Game.cbAuthorGraph=function(e){for(var m={},h=0;h<e.boardSize;h++){m[h]=[];for(var b=0;b<e.boardSize;b++)m[h].push([2293760|b])}return m},Model.Game.cbMergeGraphs=function(e){for(var m=[],h=0;h<e.boardSize;h++){m[h]=[];for(var b=1;b<arguments.length;b++)m[h]=m[h].concat(arguments[b][h])}return m},Model.Game.cbGetThreatGraph=function(){function e(m,h){for(var b in i){var c=i[b];if(!(c.p.length<h.length+1)){for(var g=!0,H=0;H<h.length;H++)if(h[H]!=c.p[H]){g=!1;break}if(g){var a=c.p[h.length],R=m[a];void 0===R&&(R={e:{}},m[a]=R),c.p.length==h.length+1&&(R.t=c.t,R.ts=c.ts,R.tk=c.tk,delete i[b]),h.push(a),e(R.e,h),h.pop()}}}}var m=this;this.cbUseScreenCapture=!1,this.cbUseCaptureKing=!1,this.cbUseCaptureNoKing=!1;for(var h={1:[],"-1":[]},b=[],c=0;c<this.g.boardSize;c++)this.g.pTypes.forEach(function(e,h){e.graph[c].forEach(function(e){for(var g=[],i=0;i<e.length;i++){var H=e[i];1048576&H?(m.cbUseCaptureKing=!0,g.unshift({d:65535&H,a:c,tk:h})):2097152&H?(m.cbUseCaptureNoKing=!0,g.unshift({d:65535&H,a:c,tnk:h})):131072&H?g.unshift({d:65535&H,a:c,t:h}):262144&H?g.unshift({d:65535&H,a:c}):524288&H&&(m.cbUseScreenCapture=!0,g.unshift({d:65535&H,a:c,ts:h}))}g.length>0&&b.push(g)})});var g={};b.forEach(function(e){e.forEach(function(m,h){var b=g[m.d];void 0===b&&(b={},g[m.d]=b);for(var c=[],i=h+1;i<e.length;i++)c.push(e[i].d);c.push(m.a);var H=c.join(","),a=b[H];void 0===a&&(a={p:c,t:{},ts:{},tk:{}},b[H]=a),void 0!==m.t?a.t[m.t]=!0:void 0!==m.tk?a.tk[m.tk]=!0:void 0!==m.ts&&(a.ts[m.ts]=!0)})});for(var c=0;c<m.g.boardSize;c++){var i=g[c],H={};e(H,[]),h[1][c]=H,h[-1][c]=H}return h},Model.Game.InitGame=function(){var m=this;this.cbVar=e=this.cbDefine(),this.g.boardSize=this.cbVar.geometry.boardSize,this.g.pTypes=this.cbGetPieceTypes(),this.g.threatGraph=this.cbGetThreatGraph(),this.g.distGraph=this.cbVar.geometry.GetDistances(),this.cbPiecesCount=0,this.g.castleablePiecesCount={1:0,"-1":0};for(var h in e.pieceTypes){var b=e.pieceTypes[h];if(b.castle){(b.initial||[]).forEach(function(e){m.g.castleablePiecesCount[e.s]++})}b.initial&&(this.cbPiecesCount+=b.initial.length)}for(var c=[],h=0;h<this.cbPiecesCount;h++)c.push(h);var g=Object.keys(e.pieceTypes);this.zobrist=new JocGame.Zobrist({board:{type:"array",size:this.cbVar.geometry.boardSize,values:c},who:{values:["1","-1"]},type:{type:"array",size:this.cbPiecesCount,values:g}})},Model.Game.cbGetPieceTypes=function(){for(var e=[],m={},h=0;h<this.cbVar.geometry.boardSize;h++)m[h]=[];for(var b in this.cbVar.pieceTypes){var c=this.cbVar.pieceTypes[b];e[b]={graph:c.graph||m,abbrev:c.abbrev||"",value:c.isKing?100:c.value||1,isKing:!!c.isKing,castle:!!c.castle,epTarget:!!c.epTarget,epCatch:!!c.epCatch}}return e},Model.Board.Init=function(e){this.zSign=0},Model.Board.InitialPosition=function(h){var b=this;this.board=m?new Int16Array(h.g.boardSize):[];for(var c=0;c<h.g.boardSize;c++)this.board[c]=-1;if(this.kings={},this.pieces=[],this.ending={1:!1,"-1":!1},this.lastMove=null,h.cbVar.castle&&(this.castled={1:!1,"-1":!1}),this.zSign=h.zobrist.update(0,"who",-1),this.noCaptCount=0,this.mWho=1,h.mInitial)this.mWho=h.mInitial.turn||1,h.mInitial.pieces.forEach(function(e){var m={};for(var h in e)e.hasOwnProperty(h)&&(m[h]=e[h]);b.pieces.push(m)}),h.mInitial.lastMove&&(this.lastMove={f:h.mInitial.lastMove.f,t:h.mInitial.lastMove.t}),void 0!==h.mInitial.noCaptCount&&(this.noCaptCount=h.mInitial.noCaptCount),h.cbVar.castle&&h.mInitial.castle&&(this.castled={1:{k:!!h.mInitial.castle[1]&&!!h.mInitial.castle[1].k,q:!!h.mInitial.castle[1]&&!!h.mInitial.castle[1].q},"-1":{k:!!h.mInitial.castle[-1]&&!!h.mInitial.castle[-1].k,q:!!h.mInitial.castle[-1]&&!!h.mInitial.castle[-1].q}});else for(var g in h.cbVar.pieceTypes)for(var i=h.cbVar.pieceTypes[g],H=i.initial||[],a=0;a<H.length;a++){var R=H[a],C={s:R.s,t:parseInt(g),p:R.p,m:!1};this.pieces.push(C)}if(this.pieces.sort(function(e,m){if(e.s!=m.s)return m.s-e.s;var b=h.cbVar.pieceTypes[e.t].value||100,c=h.cbVar.pieceTypes[m.t].value||100;return b!=c?b-c:e.p-m.p}),this.pieces.forEach(function(e,m){e.i=m,b.board[e.p]=m,h.g.pTypes[e.t].isKing&&(b.kings[e.s]=e.p),b.zSign=h.zobrist.update(b.zSign,"board",m,e.p),b.zSign=h.zobrist.update(b.zSign,"type",e.t,m)}),h.mInitial&&h.mInitial.enPassant){var c=e.geometry.PosByName(h.mInitial.enPassant);if(c>=0){var f,d=e.geometry.C(c),t=e.geometry.R(c);f=1==h.mInitial.turn?e.geometry.POS(d,t-1):e.geometry.POS(d,t+1),this.epTarget={p:c,i:this.board[f]}}}},Model.Board.CopyFrom=function(e){if(m)this.board=new Int16Array(e.board.length),this.board.set(e.board);else{this.board=[];for(var h=e.board,b=h.length,c=0;c<b;c++)this.board.push(h[c])}this.pieces=[];for(var g=e.pieces.length,c=0;c<g;c++){var i=e.pieces[c];this.pieces.push({s:i.s,p:i.p,t:i.t,i:i.i,m:i.m})}this.kings={1:e.kings[1],"-1":e.kings[-1]},this.check=e.check,e.lastMove?this.lastMove={f:e.lastMove.f,t:e.lastMove.t,c:e.lastMove.c}:this.lastMove=null,this.ending={1:e.ending[1],"-1":e.ending[-1]},void 0!==e.castled&&(this.castled={1:e.castled[1],"-1":e.castled[-1]}),this.noCaptCount=e.noCaptCount,e.epTarget?this.epTarget={p:e.epTarget.p,i:e.epTarget.i}:this.epTarget=null,this.mWho=e.mWho,this.zSign=e.zSign},Model.Board.cbApplyCastle=function(e,m,h){var b=e.cbVar.castle[m.f+"/"+m.cg],c=b.r[b.r.length-1],g=this.pieces[this.board[m.cg]],i=b.k[b.k.length-1],H=this.pieces[this.board[m.f]];return h&&(this.zSign=e.zobrist.update(this.zSign,"board",g.i,m.cg),this.zSign=e.zobrist.update(this.zSign,"board",g.i,c),this.zSign=e.zobrist.update(this.zSign,"board",H.i,m.f),this.zSign=e.zobrist.update(this.zSign,"board",H.i,i)),g.p=c,g.m=!0,this.board[m.cg]=-1,H.p=i,H.m=!0,this.board[m.f]=-1,this.board[c]=g.i,this.board[i]=H.i,this.castled[g.s]=!0,this.kings[H.s]=i,[{i:g.i,f:c,t:-1},{i:H.i,f:i,t:m.f,kp:m.f,who:H.s,m:!1},{i:g.i,f:-1,t:m.cg,m:!1,cg:!1}]},Model.Board.cbQuickApply=function(e,m){if(void 0!==m.cg)return this.cbApplyCastle(e,m,!1);var h=[],b=this.board[m.f],c=this.pieces[b];if(null!=m.c){h.unshift({i:m.c,f:-1,t:this.pieces[m.c].p});var g=this.pieces[m.c];this.board[g.p]=-1,g.p=-1}var i=this.kings[c.s];return e.g.pTypes[c.t].isKing&&(this.kings[c.s]=m.t),h.unshift({i:b,f:m.t,t:m.f,kp:i,who:c.s,ty:c.t}),c.p=m.t,void 0!==m.pr&&(c.t=m.pr),this.board[m.f]=-1,this.board[m.t]=b,h},Model.Board.cbQuickUnapply=function(e,m){for(var h=0;h<m.length;h++){var b=m[h],c=this.pieces[b.i];b.f>=0&&(c.p=-1,this.board[b.f]=-1),b.t>=0&&(c.p=b.t,this.board[b.t]=b.i),void 0!==b.m&&(c.m=b.m),void 0!==b.kp&&(this.kings[b.who]=b.kp),void 0!=b.ty&&(c.t=b.ty),void 0!=b.cg&&(this.castled[c.s]=b.cg)}},Model.Board.ApplyMove=function(e,m){var h=this.pieces[this.board[m.f]];if(void 0!==m.cg)this.cbApplyCastle(e,m,!0);else{if(this.zSign=e.zobrist.update(this.zSign,"board",h.i,m.f),this.board[h.p]=-1,void 0!==m.pr&&(this.zSign=e.zobrist.update(this.zSign,"type",h.t,h.i),h.t=m.pr,this.zSign=e.zobrist.update(this.zSign,"type",h.t,h.i)),null!=m.c){var b=this.pieces[m.c];this.zSign=e.zobrist.update(this.zSign,"board",b.i,b.p),this.board[b.p]=-1,b.p=-1,b.m=!0,this.noCaptCount=0}else this.noCaptCount++;h.p=m.t,h.m=!0,this.board[m.t]=h.i,this.zSign=e.zobrist.update(this.zSign,"board",h.i,m.t),e.g.pTypes[h.t].isKing&&(this.kings[h.s]=m.t)}this.check=!!m.ck,this.lastMove={f:m.f,t:m.t,c:m.c},void 0!==m.ko&&(this.ending[h.s]=m.ko),void 0!==m.ept?this.epTarget={p:m.ept,i:h.i}:this.epTarget=null,this.zSign=e.zobrist.update(this.zSign,"who",-this.mWho),this.zSign=e.zobrist.update(this.zSign,"who",this.mWho)},Model.Board.Evaluate=function(h){function b(m){var h=1/0;for(var b in e.geometry.corners)h=Math.min(h,a.distGraph[g.kings[m]][b]);return h-Math.sqrt(a.boardSize)}var c="debug"==arguments[3],g=this;this.mEvaluation=0;var i,H=this.mWho,a=h.g;if(m)i={1:{count:new Uint8Array(a.pTypes.length),byType:{}},"-1":{count:new Uint8Array(a.pTypes.length),byType:{}}};else{i={1:{count:[],byType:{}},"-1":{count:[],byType:{}}};for(var R=0;R<a.pTypes.length;R++)i[1].count[R]=i[-1].count[R]=0}if(h.mOptions.preventRepeat&&h.GetRepeatOccurence(this)>2)return this.mFinished=!0,void(this.mWinner=h.cbOnPerpetual?H*h.cbOnPerpetual:JocGame.DRAW);for(var C={1:0,"-1":0},f={1:a.distGraph[this.kings[-1]],"-1":a.distGraph[this.kings[1]]},d={1:0,"-1":0},t={1:0,"-1":0},r={1:0,"-1":0},x={1:0,"-1":0},n={1:!1,"-1":!1},s=this.pieces,E=s.length,R=0;R<E;R++){var o=s[R];if(o.p>=0){var p=o.s,l=a.pTypes[o.t];l.isKing?n[p]=o.m:C[p]+=l.value,l.castle&&!o.m&&x[p]++,t[p]++,d[p]+=f[p][o.p],r[p]+=e.geometry.distEdge[o.p];var A=i[p];A.count[o.t]++;var u=A.byType;void 0===u[o.t]?u[o.t]=[o]:u[o.t].push(o)}}if(this.lastMove&&null!=this.lastMove.c){var o=this.pieces[this.board[this.lastMove.t]];C[-o.s]+=this.cbStaticExchangeEval(h,o.p,o.s,{piece:o})}var v={1:0,"-1":0},G={1:0,"-1":0},M={1:0,"-1":0};this.ending[1]&&(G[1]=(d[1]-Math.sqrt(a.boardSize))/t[1],e.geometry.corners&&(M[1]=b(1))),this.ending[-1]&&(G[-1]=(d[-1]-Math.sqrt(a.boardSize))/t[-1],e.geometry.corners&&(M[1]=b(-1)));var y={pieceValue:C[1]-C[-1],pieceValueRatio:(C[1]-C[-1])/(C[1]+C[-1]+1),posValue:r[1]-r[-1],averageDistKing:d[1]/t[1]-d[-1]/t[-1],check:this.check?-H:0,endingKingFreedom:v[1]-v[-1],endingDistKing:G[1]-G[-1],distKingCorner:M[1]-M[-1]};e.castle&&(y.castle=(this.castled[1]?1:n[1]?0:x[1]/(a.castleablePiecesCount[1]+1))-(this.castled[-1]?1:n[-1]?0:x[-1]/(a.castleablePiecesCount[-1]+1))),e.evaluate&&e.evaluate.call(this,h,y,i);var S=h.mOptions.levelOptions;for(var K in y){var k=y[K],T=S[K+"Factor"]||0,z=k*T;c&&console.log(K,"=",k,"*",T,"=>",z),this.mEvaluation+=z}c&&console.log("Evaluation",this.mEvaluation)},Model.Board.cbGeneratePseudoLegalMoves=function(e){function m(m,c){var g=e.cbVar.promote;if(!g)return void b.push(c);var i=g.call(h,e,m,c);if(null!=i)if(0==i.length)b.push(c);else if(1==i.length)c.pr=i[0],b.push(c);else for(var H=0;H<i.length;H++){var a=i[H];b.push({f:c.f,t:c.t,c:c.c,pr:a,ept:c.ept,ep:c.ep,a:c.a})}}for(var h=this,b=[],c=e.cbVar,g=this.mWho,i=!c.castle||this.check||this.castled[g]?null:[],H=-1,a=this.pieces.length,R=0;R<a;R++){var C=this.pieces[R];if(!(C.p<0||C.s!=g)){var f=e.g.pTypes[C.t];f.isKing&&(C.m?i=null:H=C),i&&f.castle&&!C.m&&i.push(C);var d,t;d=f.graph[C.p],t=d.length;for(var r=0;r<t;r++)for(var x=d[r],n=!1,s=x.length,E=null,o=0;o<s;o++){var p=x[o],l=65535&p,A=this.board[l];if(!(A<0)||f.epCatch&&this.epTarget&&this.epTarget.p==l){if(!(524288&p)){var u;u=A<0?this.pieces[this.epTarget.i]:this.pieces[A],!(u.s!=C.s&&131072&p)||1048576&p&&!e.g.pTypes[u.t].isKing||2097152&p&&e.g.pTypes[u.t].isKing||m(C,{f:C.p,t:l,c:u.i,a:f.abbrev,ep:A<0});break}if(n){var u=this.pieces[A];u.s!=C.s&&m(C,{f:C.p,t:l,c:u.i,a:f.abbrev});break}n=!0}else 65536&p&&0==n&&m(C,{f:C.p,t:l,c:null,a:f.abbrev,ept:null!=E&&f.epTarget?E:void 0});E=l}}}if(i)for(var R=0;R<i.length;R++){var v=i[R],G=e.cbVar.castle[H.p+"/"+v.p];if(G){for(var M=!0,r=0;r<G.r.length;r++){var y=G.r[r];if(this.board[y]>=0&&y!=H.p&&y!=v.p){M=!1;break}}if(M){for(var S=!0,r=0;r<G.k.length;r++){var y=G.k[r];if(this.board[y]>=0&&y!=v.p&&y!=H.p||this.cbGetAttackers(e,y,g).length>0){S=!1;break}}S&&b.push({f:H.p,t:G.k[G.k.length-1],c:null,cg:v.p})}}}return b},Model.Board.cbStaticExchangeEval=function(e,m,h,b){var c=0,g=this.cbGetSmallestAttacker(e,m,h);if(g){var i=this.mWho;this.mWho=g.s;var H=this.cbQuickApply(e,{f:g.p,t:m,c:b.piece.i}),a=e.g.pTypes[b.piece.t].value;b.piece=g,c=Math.max(0,a-this.cbStaticExchangeEval(e,m,-h,b)),this.cbQuickUnapply(e,H),this.mWho=i}return c},Model.Board.cbGetSmallestAttacker=function(e,m,h){var b=this.cbGetAttackers(e,m,h);if(0==b.length)return null;for(var c=1/0,g=null,i=b.length,H=0;H<i;H++){var a=b[H],R=e.g.pTypes[a.t].value;R<c&&(c=R,g=a)}return g},Model.Board.cbCollectAttackers=function(e,m,h,b){for(var c in m){var g=m[c],i=this.board[c];if(i<0)this.cbCollectAttackers(e,g.e,h,b);else{var H=this.pieces[i];H.s==-e&&(g.t&&H.t in g.t||b&&g.tk&&H.t in g.tk)&&h.push(H)}}},Model.Board.cbCollectAttackersScreen=function(e,m,h,b,c){for(var g in m){var i=m[g],H=this.board[g];if(H<0)this.cbCollectAttackersScreen(e,i.e,h,b,c);else{var a=this.pieces[H];!c&&a.s==-e&&(i.t&&a.t in i.t||b&&i.tk&&a.t in i.tk)?h.push(a):c?c&&a.s==-e&&i.ts&&a.t in i.ts&&h.push(a):this.cbCollectAttackersScreen(e,i.e,h,b,!0)}}},Model.Board.cbGetAttackers=function(e,m,h,b){var c=[];return e.cbUseScreenCapture?this.cbCollectAttackersScreen(h,e.g.threatGraph[h][m],c,b,!1):this.cbCollectAttackers(h,e.g.threatGraph[h][m],c,b),c},Model.Board.GenerateMoves=function(e){var m=this.cbGeneratePseudoLegalMoves(e);this.mMoves=[];for(var h=!0,b=this.kings[this.mWho],c=m.length,g=0;g<c;g++){var i=m[g],H=this.cbQuickApply(e,i);if(!(this.cbGetAttackers(e,this.kings[this.mWho],this.mWho,!0).length>0)){var a=this.cbGetAttackers(e,this.kings[-this.mWho],-this.mWho,!0).length>0;i.ck=a,this.mMoves.push(i),i.f!=b&&(h=!1)}this.cbQuickUnapply(e,H)}if(0==this.mMoves.length)this.mFinished=!0,this.mWinner=e.cbOnStaleMate?e.cbOnStaleMate*this.mWho:JocGame.DRAW,this.check&&(this.mWinner=-this.mWho);else if(this.ending[this.mWho]){if(!h)for(var g=0;g<this.mMoves.length;g++)this.mMoves[g].ko=!1}else if(!this.ending[this.mWho]&&h&&!this.check)for(var g=0;g<this.mMoves.length;g++)this.mMoves[g].ko=!0},Model.Board.GetSignature=function(){return this.zSign},Model.Move.Init=function(e){for(var m in e)e.hasOwnProperty(m)&&(this[m]=e[m])},Model.Move.Equals=function(e){return this.f==e.f&&this.t==e.t&&this.pr==e.pr},Model.Move.CopyFrom=function(e){this.Init(e)},Model.Move.ToString=function(m){var h=this;switch(m=m||"natural"){case"natural":return function(){var m;if(void 0!==h.cg?m=e.castle[h.f+"/"+h.cg].n:(m=h.a||"",m+=e.geometry.PosName(h.f),null==h.c?m+="-":m+="x",m+=e.geometry.PosName(h.t)),void 0!==h.pr){var b=e.pieceTypes[h.pr];b&&b.abbrev&&b.abbrev.length>0&&!b.silentPromo&&(m+="="+b.abbrev)}return h.ck&&(m+="+"),m}();case"engine":return function(){var m=e.geometry.PosName(h.f)+e.geometry.PosName(h.t);if(void 0!=h.pr){var b=e.pieceTypes[h.pr];b&&b.abbrev&&b.abbrev.length>0&&!b.silentPromo&&(m+=b.abbrev)}return m}();default:return"??"}},Model.Board.CompactMoveString=function(m,h,b){"function"!=typeof h.ToString&&(h=m.CreateMove(h));var c=h.ToString(),g=/^([A-Z]?)([a-z])([1-9][0-9]*)([-x])([a-z])([1-9][0-9]*)(.*?)$/.exec(c);if(!g)return c;var i=g[7];if(b||(b={}),b.value||(b.value=[]),0==b.value.length){var H=this.mMoves;this.mMoves&&0!=this.mMoves.length||this.GenerateMoves(m);for(var a=0;a<this.mMoves.length;a++){var R=this.mMoves[a];"function"!=typeof R.ToString&&(R=m.CreateMove(R)),b.value.push({str:R.ToString(),move:R})}this.mMoves=H}var C=[];if(b.value.forEach(function(e){var m=/^([A-Z]?[a-z][1-9][0-9]*[-x][a-z][1-9][0-9]*)(.*?)$/.exec(e.str);m&&e.move.t==h.t&&(e.move.a||"")==g[1]&&m[2]==i&&C.push(e.move)}),1==C.length)return""==g[1]&&"x"==g[4]?g[2]+"x"+g[5]+g[6]+g[7]:g[1]+("x"==g[4]?"x":"")+g[5]+g[6]+g[7];if(e.geometry.CompactCrit)for(var f="",a=0;;a++){var d=e.geometry.CompactCrit(h.f,a);if(null==d)return c;f+=d;for(var t=[],r=0;r<C.length;r++){var x=C[r];e.geometry.CompactCrit(x.f,a)==d&&t.push(x)}if(console.assert(t.length>0),1==t.length)return g[1]+f+("x"==g[4]?"x":"")+g[5]+g[6]+g[7];C=t}return c},Model.Board.cbIntegrity=function(e){function m(e,m){e||console.error(m)}for(var h=this,b=0;b<this.board.length;b++){var c=this.board[b];if(c>=0){var g=h.pieces[c];m(void 0!==g,"no piece at pos"),m(g.p==b,"piece has different pos")}}for(var c=0;c<this.pieces.length;c++){var g=this.pieces[c];g.p>=0&&m(h.board[g.p]==c,"board index mismatch")}},Model.Board.ExportBoardState=function(e){return e.cbVar.geometry.ExportBoardState?e.cbVar.geometry.ExportBoardState(this,e.cbVar,e.mPlayedMoves.length):"not supported"},Model.Game.Import=function(m,h){var b,c=[],g={1:{},"-1":{}},i=null,H=0;if("pjn"==m){var a={status:!1,error:"parse"},R=h.split(" ");if(6!=R.length)return console.warn("FEN should have 6 parts"),a;var C=R[0].split("/"),f=e.geometry.fenHeight||e.geometry.height;if(C.length!=f)return console.warn("FEN board should have",f,"rows, got",C.length),a;var d={};for(var t in e.pieceTypes){var r=e.pieceTypes[t],x=r.fenAbbrev||r.abbrev||"X";d[x.toUpperCase()]={s:1,t:t},d[x.toLowerCase()]={s:-1,t:t}}var n=e.geometry.FenRowPos||function(m,h){return(e.geometry.height-1-m)*e.geometry.width+h};if(C.forEach(function(m,h){for(var b=0,g=0;g<m.length;g++){var i=m.substr(g,1),H=d[i];if(void 0!==H){var R=n(h,b);b++;for(var C={s:H.s,t:H.t,p:R},f=!0,t=e.pieceTypes[C.t].initial||[],r=0;r<t.length;r++){var x=t[r];x.s==C.s&&x.p==R&&(f=!1)}C.m=f,c.push(C)}else{if(isNaN(parseInt(i)))return console.warn("FEN invalid board spec",i),a;b+=parseInt(i)}}}),c.sort(function(e,m){return m.s-e.s}),"w"==R[1])b=1;else{if("b"!=R[1])return console.warn("FEN invalid turn spec",R[1]),a;b=-1}g[1].k=R[2].indexOf("K")>=0,g[1].q=R[2].indexOf("Q")>=0,g[-1].k=R[2].indexOf("k")>=0,g[-1].q=R[2].indexOf("q")>=0,i="-"==R[3]?null:R[3];var s=parseInt(R[4]);isNaN(s)||(H=s);var E={pieces:c,turn:b,castle:g,enPassant:i,noCaptCount:H};return e.importGame&&e.importGame.call(this,E,m,h),{status:!0,initial:E}}return{status:!1,error:"unsupported"}}}(),function(){Model.Game.cbBoardGeometryGrid=function(e,m){function h(m){return m%e}function b(m){return Math.floor(m/e)}function c(m,h){return h*e+m}function g(g,i){var H=h(g),a=b(g),R=H+i[0],C=a+i[1];return R<0||R>=e||C<0||C>=m?null:c(R,C)}function i(e){return String.fromCharCode("a".charCodeAt(0)+h(e))+(b(e)+1)}function H(e){var m=/^([a-z])([0-9]+)$/.exec(e);return m?c(m[1].charCodeAt(0)-"a".charCodeAt(0),parseInt(m[2])-1):-1}function a(e,m){return 0==m?String.fromCharCode("a".charCodeAt(0)+h(e)):1==m?b(e)+1:null}function R(){for(var c=[],g=0;g<e*m;g++){var i=[];c.push(i);for(var H=0;H<e*m;H++){var a=b(g),R=h(g),C=b(H),f=h(H);i.push(Math.max(Math.abs(a-C),Math.abs(R-f)))}}return c}function C(h,b,g){for(var H=[],a=m-1;a>=0;a--){for(var R="",C=0,f=0;f<e;f++){var d=h.board[c(f,a)];if(d<0)C++;else{C>0&&(R+=C,C=0);var t=h.pieces[d],r=b.pieceTypes[t.t].fenAbbrev||b.pieceTypes[t.t].abbrev||"?";t.s==-1?R+=r.toLowerCase():R+=r.toUpperCase()}}C&&(R+=C),H.push(R)}var x=H.join("/");x+=" ",1==h.mWho?x+="w":x+="b",x+=" ";var n="";return h.castled&&(h.castled[1]===!1?n+="KQ":(h.castled[1].k&&(n+="K"),h.castled[1].q&&(n+="Q")),h.castled[-1]===!1?n+="kq":(h.castled[-1].k&&(n+="k"),h.castled[-1].q&&(n+="q"))),0==n.length&&(n="-"),x+=n,x+=" ",h.epTarget?x+=i(h.epTarget.p):x+="-",x+=" ",x+=h.noCaptCount,x+=" ",x+=Math.floor(g/2)+1}return{boardSize:e*m,width:e,height:m,C:h,R:b,POS:c,Graph:g,PosName:i,PosByName:H,CompactCrit:a,GetDistances:R,distEdge:function(){for(var c=[],g=0;g<e*m;g++){var i=h(g),H=b(g);c[g]=Math.min(i,Math.abs(e-i-1),H,Math.abs(m-H-1))}return c}(),corners:function(){var h={};return h[c(0,0)]=1,h[c(0,m-1)]=1,h[c(e-1,0)]=1,h[c(e-1,m-1)]=1,h}(),ExportBoardState:C}},Model.Game.cbPawnGraph=function(e,m,h){for(var b=this,c={},g=0;g<e.boardSize;g++)if(!h||g in h){var i=[],H=e.Graph(g,[0,m]);null!=H&&(!h||H in h)&&i.push(b.cbTypedArray([H|b.cbConstants.FLAG_MOVE])),[-1,1].forEach(function(c){var H=e.Graph(g,[c,m]);null!=H&&(!h||H in h)&&i.push(b.cbTypedArray([H|b.cbConstants.FLAG_CAPTURE]))}),c[g]=i}else c[g]=[];return c},Model.Game.cbInitialPawnGraph=function(e,m,h){for(var b=this,c={},g=0;g<e.boardSize;g++)if(!h||g in h){var i=[],H=e.Graph(g,[0,m]);if(null!=H&&(!h||H in h)){var a=[H|b.cbConstants.FLAG_MOVE],R=e.Graph(H,[0,m]);null!=R&&(!h||R in h)&&a.push(R|b.cbConstants.FLAG_MOVE),i.push(b.cbTypedArray(a))}[-1,1].forEach(function(c){var H=e.Graph(g,[c,m]);null!=H&&(!h||H in h)&&i.push(b.cbTypedArray([H|b.cbConstants.FLAG_CAPTURE]))}),c[g]=i}else c[g]=[];return c},Model.Game.cbKingGraph=function(e,m){return this.cbShortRangeGraph(e,[[-1,-1],[-1,0],[-1,1],[0,-1],[0,1],[1,-1],[1,0],[1,1]],m)},Model.Game.cbKnightGraph=function(e,m){return this.cbShortRangeGraph(e,[[2,-1],[2,1],[-2,-1],[-2,1],[-1,2],[-1,-2],[1,2],[1,-2]],m)},Model.Game.cbHorseGraph=function(e){for(var m=this,h={},b=0;b<e.boardSize;b++)h[b]=[],[[1,0,2,-1],[1,0,2,1],[-1,0,-2,-1],[-1,0,-2,1],[0,1,-1,2],[0,-1,-1,-2],[0,1,1,2],[0,-1,1,-2]].forEach(function(c){var g=e.Graph(b,[c[0],c[1]]);if(null!=g){var i=e.Graph(b,[c[2],c[3]]);null!=i&&h[b].push(m.cbTypedArray([g|m.cbConstants.FLAG_STOP,i|m.cbConstants.FLAG_MOVE|m.cbConstants.FLAG_CAPTURE]))}});return h},Model.Game.cbRookGraph=function(e,m){return this.cbLongRangeGraph(e,[[0,-1],[0,1],[-1,0],[1,0]],m)},Model.Game.cbBishopGraph=function(e,m){return this.cbLongRangeGraph(e,[[1,-1],[1,1],[-1,1],[-1,-1]],m)},Model.Game.cbQueenGraph=function(e,m){return this.cbLongRangeGraph(e,[[0,-1],[0,1],[-1,0],[1,0],[1,-1],[1,1],[-1,1],[-1,-1]],m)},Model.Game.cbXQGeneralGraph=function(e,m){for(var h=this,b={},c=0;c<e.boardSize;c++)b[c]=[],[[-1,0,!1],[0,-1,!0],[0,1,!0],[1,0,!1]].forEach(function(g){var i=[],H=e.Graph(c,g);if(null!=H&&((!m||H in m)&&i.push(H|h.cbConstants.FLAG_MOVE|h.cbConstants.FLAG_CAPTURE),g[2]))for(var a=e.Graph(H,g);null!=a;)!m||a in m?i.push(a|h.cbConstants.FLAG_CAPTURE|h.cbConstants.FLAG_CAPTURE_KING):i.push(a|h.cbConstants.FLAG_STOP),a=e.Graph(a,g);i.length>0&&b[c].push(h.cbTypedArray(i))});return b},Model.Game.cbXQSoldierGraph=function(e,m){return this.cbShortRangeGraph(e,[[0,m]])},Model.Game.cbXQPromoSoldierGraph=function(e,m){return this.cbShortRangeGraph(e,[[0,m],[-1,0],[1,0]])},Model.Game.cbXQAdvisorGraph=function(e,m){return this.cbShortRangeGraph(e,[[1,1],[-1,1],[1,-1],[-1,-1]],m)},Model.Game.cbXQCannonGraph=function(e){return this.cbLongRangeGraph(e,[[0,-1],[0,1],[-1,0],[1,0]],null,this.cbConstants.FLAG_MOVE|this.cbConstants.FLAG_SCREEN_CAPTURE)},Model.Game.cbXQElephantGraph=function(e,m){for(var h=this,b={},c=0;c<e.boardSize;c++)b[c]=[],(!m||c in m)&&[[1,1,2,2],[1,-1,2,-2],[-1,1,-2,2],[-1,-1,-2,-2]].forEach(function(g){var i=e.Graph(c,[g[0],g[1]]);if(null!=i){var H=e.Graph(c,[g[2],g[3]]);null!=H&&(!m||H in m)&&b[c].push(h.cbTypedArray([i|h.cbConstants.FLAG_STOP,H|h.cbConstants.FLAG_MOVE|h.cbConstants.FLAG_CAPTURE]))}});return b},Model.Game.cbSilverGraph=function(e,m){return this.cbShortRangeGraph(e,[[0,m],[-1,-1],[-1,1],[1,-1],[1,1]])},Model.Game.cbFersGraph=function(e,m){return this.cbShortRangeGraph(e,[[-1,-1],[-1,1],[1,-1],[1,1]])},Model.Game.cbSchleichGraph=function(e,m){return this.cbShortRangeGraph(e,[[-1,0],[1,0],[0,-1],[0,1]])},Model.Game.cbAlfilGraph=function(e,m){return this.cbShortRangeGraph(e,[[-2,-2],[-2,2],[2,2],[2,-2]])}}(),function(){var e=Model.Game.cbBoardGeometryGrid(9,10);e.ADVISOR_AREA={3:1,5:1,13:1,21:1,23:1,66:1,68:1,76:1,84:1,86:1},e.ELEPHANT_AREA={1:{2:1,6:1,18:1,22:1,26:1,38:1,42:1},"-1":{83:1,87:1,63:1,67:1,71:1,47:1,51:1}},e.GENERAL_AREA={3:1,4:1,5:1,12:1,13:1,14:1,21:1,22:1,23:1,84:1,85:1,86:1,75:1,76:1,77:1,66:1,67:1,68:1},Model.Game.cbOnPerpetual=1,Model.Game.cbOnStaleMate=1,Model.Game.cbDefine=function(){return{geometry:e,pieceTypes:{0:{name:"pawn-w",aspect:"xq-pawn",graph:this.cbXQPromoSoldierGraph(e,1),abbrev:"",value:2,fenAbbrev:"P"},1:{name:"pawn-b",aspect:"xq-pawn",graph:this.cbXQPromoSoldierGraph(e,-1),abbrev:"",value:2,fenAbbrev:"P"},2:{name:"ipawn-w",aspect:"xq-pawn",graph:this.cbXQSoldierGraph(e,1),abbrev:"",value:1,fenAbbrev:"P",initial:[{s:1,p:27},{s:1,p:29},{s:1,p:31},{s:1,p:33},{s:1,p:35}]},3:{name:"ipawn-b",aspect:"xq-pawn",graph:this.cbXQSoldierGraph(e,-1),abbrev:"",value:1,fenAbbrev:"P",initial:[{s:-1,p:54},{s:-1,p:56},{s:-1,p:58},{s:-1,p:60},{s:-1,p:62}]},4:{name:"cannon",aspect:"xq-cannon",graph:this.cbXQCannonGraph(e),abbrev:"C",value:4.5,initial:[{s:1,p:19},{s:1,p:25},{s:-1,p:64},{s:-1,p:70}]},5:{name:"chariot",aspect:"xq-chariot",graph:this.cbRookGraph(e),abbrev:"R",value:9,initial:[{s:1,p:0},{s:1,p:8},{s:-1,p:81},{s:-1,p:89}]},6:{name:"horse",aspect:"xq-horse",graph:this.cbHorseGraph(e),abbrev:"H",value:4,initial:[{s:1,p:1},{s:1,p:7},{s:-1,p:82},{s:-1,p:88}]},7:{name:"elephant-w",aspect:"xq-elephant",graph:this.cbXQElephantGraph(e,e.ELEPHANT_AREA[1]),abbrev:"E",value:2,initial:[{s:1,p:2},{s:1,p:6}]},8:{name:"elephant-b",aspect:"xq-elephant",graph:this.cbXQElephantGraph(e,e.ELEPHANT_AREA[-1]),abbrev:"E",value:2,initial:[{s:-1,p:83},{s:-1,p:87}]},9:{name:"advisor",aspect:"xq-advisor",graph:this.cbXQAdvisorGraph(e,e.ADVISOR_AREA),abbrev:"A",value:2,initial:[{s:1,p:3},{s:1,p:5},{s:-1,p:84},{s:-1,p:86}]},10:{name:"general",aspect:"xq-general",isKing:!0,graph:this.cbXQGeneralGraph(e,e.GENERAL_AREA),abbrev:"K",initial:[{s:1,p:4},{s:-1,p:85}]}},promote:function(e,m,h){return 2==m.t&&h.t>=45?[0]:3==m.t&&h.t<45?[1]:[]}}},Model.Board.CompactMoveString=function(m,h){function b(e){return c.mWho>0?9-e:e+1}var c=this,g={0:"P",1:"P",2:"P",3:"P",4:"C",5:"R",6:"H",7:"E",8:"E",9:"A",10:"K"},i=function(m){var h=c.pieces[c.board[m.f]],i=g[h.t],H=i,a=e.C(m.f),R=e.C(m.t),C=e.R(m.f),f=e.R(m.t),d=[];return c.pieces.forEach(function(m){m.p>=0&&m.s==c.mWho&&g[m.t]==i&&e.C(m.p)==a&&d.push(m)}),d.sort(function(m,h){return(e.R(m.p)-e.R(h.p))*c.mWho}),1==d.length?H+=b(a):2==d.length?d[0]==h?H+="+":H+="-":3==d.length?d[0]==h?H+="+":d[1]==h?H+=b(a):H+="-":4==d.length?d[0]==h?H="++":d[1]==h?H+="+":d[2]==h?H+="-":H="--":5==d.length&&(d[0]==h?H="++":d[1]==h?H+="+":d[2]==h?H+=b(a):d[3]==h?H+="-":H="--"),C==f?H+="."+b(R):((f-C)*c.mWho>0?H+="+":H+="-",a!=R?H+=b(R):(c.mWho,H+=Math.abs(f-C))),H}(h),H=this.pieces[this.board[h.f]];if("P"==g[H.t]&&e.R(h.f)==e.R(h.t)){var a={};this.pieces.forEach(function(m){if(m.p>=0&&m.s==c.mWho&&"P"==g[m.t]){var h=e.C(m.p);void 0===a[h]?a[h]=1:a[h]++}});var R=0;for(var C in a)a[C]>1&&R++;R>1&&(i=b(e.C(h.f))+i.substr(1))}return i},Model.Move.ToString=function(e){function m(e){var m=e%9,h=(e-m)/9;return String.fromCharCode("a".charCodeAt(0)+m)+h}var h=this;return m(h.f)+m(h.t)}}(),Model.Board.StaticGenerateMoves=function(e){return this.PickMoveFromDatabase(e,this.MoveDatabase)},Model.Board.MoveDatabase={"1#262583924":[{m:"Ch3-h7",e:10},{m:"Ch3-g3",e:10},{m:"Hb1-a3",e:10},{m:"Cb3-f3",e:10},{m:"c4-c5",e:10},{m:"Cb3-e3",e:10},{m:"Cb3-a3",e:10},{m:"Cb3-c3",e:10},{m:"Hb1-c3",e:10},{m:"Eg1-e3",e:10},{m:"i4-i5",e:10},{m:"Cb3-g3",e:10},{m:"g4-g5",e:10},{m:"Hh1-g3",e:10},{m:"Hh1-i3",e:10},{m:"Af1-e2",e:10},{m:"Ch3-d3",e:10},{m:"Ch3-e3",e:10},{m:"Ch3-i3",e:10},{m:"Ec1-e3",e:10},{m:"Ch3-h5",e:10},{m:"Ch3-f3",e:10},{m:"Cb3-d3",e:10},{m:"a4-a5",e:10},{m:"Ad1-e2",e:10},{m:"Ch3-c3",e:10}],"-1#2073307342":[{m:"Hh10-g8",e:6.667},{m:"g7-g6",e:6.667}],"1#-1186147453":[{m:"Hh1-g3",e:5}],"-1#-151945653":[{m:"g7-g6",e:5}],"1#-2085910218":[{m:"Ch7-g7",e:5}],"-1#-1937696873":[{m:"Ri10-h10",e:5}],"1#-692032922":[{m:"Ri1-h1",e:5}],"-1#-597872298":[{m:"Ec10-e8",e:5}],"1#-254856779":[{m:"Rh1-h5",e:5}],"-1#1610923805":[{m:"Ch8-i8",e:5}],"1#1575345646":[{m:"Rh5xh10",e:5}],"-1#897675454":[{m:"Hg8xh10",e:5}],"1#1776569175":[{m:"Cb3-e3",e:5}],"-1#-1012605747":[{m:"Hb10-d9",e:5}],"1#-913923113":[{m:"Ra1-a2",e:5}],"-1#1086794620":[{m:"Ci8-g8",e:5}],"1#369119284":[{m:"Ra2-d2",e:5}],"-1#-1039887858":[{m:"Ra10-a9",e:5}],"1#-631436465":[{m:"e4-e5",e:5}],"-1#1574104579":[{m:"Hh10-i8",e:5}],"1#-710288897":[{m:"Cg7-f7",e:5}],"-1#377641432":[{m:"g6-g5",e:5}],"1#1863565167":[{m:"e5-e6",e:5}],"-1#-436320062":[{m:"g5xg4",e:5}],"1#-836065713":[{m:"Hg3-e4",e:5}],"-1#760681296":[{m:"e7xe6",e:5}],"1#-809462646":[{m:"Ce3xe6+",e:5}],"-1#827859334":[{m:"Hd9-e7",e:5}],"1#609052724":[{m:"Eg1-e3",e:5}],"-1#-1563136282":[{m:"g4-f4",e:5}],"1#1314254622":[{m:"Cf7xc7",e:5}],"-1#-2123546031":[{m:"Cg8-g7",e:5}],"1#-1014282927":[{m:"He4-c5",e:5}],"-1#1634180010":[{m:"Ra9-c9",e:5}],"1#1170758277":[{m:"Cc7xg7",e:5}],"-1#-684240150":[{m:"Hi8xg7",e:5}],"1#1417013285":[{m:"Rd2-d7",e:5}],"-1#-911585090":[{m:"Hg7-f5",e:5}],"1#-676303166":[{m:"Hc5-b7",e:5}],"-1#-1638137748":[{m:"Rc9xc4",e:5}],"1#65234845":[{m:"Hb1-a3",e:5}],"-1#473816005":[{m:"Rc4-d4",e:5}],"1#424381598":[{m:"Rd7-d8",e:5}],"-1#1329174947":[{m:"Rd4xd8",e:5}],"1#30739704":[{m:"Hb7xd8+",e:5}],"-1#-1072854546":[{m:"Ke10-e9",e:5}],"1#-511593909":[{m:"Hd8-c6",e:5}],"-1#262123663":[{m:"Cb8-a8",e:5}],"1#-962755761":[{m:"a4-a5",e:5}],"-1#-386718205":[{m:"Ke9-f9",e:5}],"1#-1888973421":[{m:"Hc6xa7",e:5}],"-1#-105894962":[{m:"Hf5-d4",e:5}],"1#1640378172":[{m:"Ce6xe8",e:5}],"-1#-1111051954":[{m:"Ca8xa5",e:5}],"1#-1509757421":[{m:"Ad1-e2",e:5}],"-1#-385089773":[{m:"Ca5-a4",e:5}],"1#144462631":[{m:"Ce8-h8",e:5}],"-1#-2070926388":[{m:"He7-g6",e:5}],"1#1134040221":[{m:"Ch8-h2",e:5}],"-1#-1178364511":[{m:"Af10-e9",e:5}],"1#-1251454669":[{m:"Ch2-f2+",e:5}],"-1#450775419":[{m:"Ae9-f8",e:5}],"1#1305978465":[{m:"Ha3-c4",e:5}],"-1#1760513955":[{m:"Ad10-e9",e:5}],"1#-2077329582":[{m:"Ha7-c8",e:5}],"-1#-288315301":[{m:"Kf9-f10",e:5}],"1#-712041316":[{m:"Hc8xe9",e:5}],"-1#-1757409066":[{m:"Ca4-a1+",e:5}],"1#-165831803":[{m:"Ec1-a3",e:5}],"-1#1496600442":[{m:"Hg6-e5",e:5}],"1#-1991270775":[{m:"Hc4-b2",e:5}],"-1#-1144881973":[{m:"Hd4-b3",e:5}],"1#1858708066":[{m:"He9xg10",e:5}],"-1#1820603850":[{m:"He5-c4",e:5}],"1#-2077957128":[{m:"Hg10xf8",e:5}],"-1#2038316223":[{m:"Hc4xa3",e:5}],"1#1280498126":[{m:"Hf8-e6+",e:5}],"-1#-1871679140":[{m:"f4-e4",e:5}],"1#1297562669":[{m:"He6-d8",e:5}],"-1#1742861911":[{m:"Hb3-d4",e:5}],"1#-1293276930":[],"1#248438707":[{m:"c4-c5",e:5}],"-1#-1042422981":[{m:"Ch8-e8",e:5}],"1#-1565224448":[{m:"Hh1-g3",e:5}],"-1#-318160952":[{m:"Cb8-c8",e:5}],"1#1643607466":[{m:"Ec1-e3",e:5}],"-1#-753820797":[{m:"Hb10-a8",e:5}],"1#-1719215231":[{m:"Hb1-d2",e:5}],"-1#1270991492":[{m:"Ri10-i9",e:5}],"1#174792416":[{m:"Ra1-b1",e:5}],"-1#1019735580":[{m:"Ra10-a9",e:5}],"1#614365021":[{m:"Ri1-h1",e:5}],"-1#771959917":[{m:"Ra9-d9",e:5}],"1#1100165582":[{m:"Hd2-f3",e:5}],"-1#1052324320":[{m:"Ce8xe4+",e:5}],"1#-25467127":[{m:"Af1-e2",e:5}],"-1#-1507684925":[{m:"Rd9-d5",e:5}],"1#1215810918":[{m:"Ch7-h5",e:5}],"-1#1372007086":[{m:"Ce4-f4",e:5}],"1#1997931650":[{m:"Cb3-b5",e:5}],"-1#1079989308":[{m:"Ri9-b9",e:5}],"1#20736499":[{m:"Cb5xd5",e:5}],"-1#1136235406":[{m:"Rb9xb1",e:5}],"1#-1817871678":[{m:"Ch5-e5+",e:5}],"-1#-733050407":[{m:"Eg10-e8",e:5}],"1#387167526":[{m:"Rh1xh10",e:5}],"-1#1407218187":[{m:"e7-e6",e:5}],"1#-248379524":[{m:"Ce5-h5",e:5}],"-1#-1227230105":[{m:"e6-e5",e:5}],"1#1511649491":[{m:"Cd5-d7",e:5}],"-1#1157670705":[{m:"Ad10-e9",e:5}],"1#-1446928448":[{m:"Cd7-e7",e:5}],"-1#-746133298":[{m:"Cf4-e4",e:5}],"1#-178796830":[{m:"Ce7xe4",e:5}],"-1#1892456024":[{m:"e5xe4",e:5}],"1#-1838986100":[{m:"Hf3-e5",e:5}],"-1#1994763325":[{m:"e4-f4",e:5}],"1#1087145488":[{m:"He5-f7",e:5}],"-1#210767394":[{m:"Cc8-c9",e:5}],"1#-651017971":[{m:"Ch5-e5",e:5}],"-1#-1629900266":[{m:"Rb1-b6",e:5}],"1#205583026":[{m:"c5-c6",e:5}],"-1#1671111694":[{m:"c7xc6",e:5}],"1#-235538270":[{m:"Hf7xe9",e:5}],"-1#-1244646448":[{m:"Ke10-d10",e:5}],"1#-869886295":[{m:"Rh10xf10+",e:5}],"-1#-799071231":[{m:"Kd10-d9",e:5}],"1#-160020958":[{m:"Rf10xf4",e:5}],"-1#-352258597":[{m:"Rb6-b8",e:5}],"1#131307030":[{m:"He9-g8",e:5}],"-1#-696389379":[{m:"Rb8-d8",e:5}],"1#1467627920":[{m:"Hg8-f10+",e:5}],"-1#-553730412":[{m:"Kd9-d10",e:5}],"1#-120070985":[{m:"Rf4-f9",e:5}],"-1#-1038648707":[{m:"Rd8-d5",e:5}],"1#2128600224":[{m:"Ce5-e4",e:5}],"-1#1477918374":[{m:"Rd5-d4",e:5}],"1#605585675":[{m:"Rf9-e9",e:5}],"-1#-1577696470":[{m:"Ee8-g10",e:5}],"1#1655406549":[{
m:"g4-g5",e:5}],"-1#778078520":[{m:"g6xg5",e:5}],"1#-1264303857":[{m:"Ee3xg5",e:5}],"-1#-248457905":[{m:"Rd4-d5",e:5}],"1#-1925223710":[{m:"Ce4-e3",e:5}],"-1#-620131479":[{m:"c6-c5",e:5}],"1#1428398344":[{m:"Hg3-e4",e:5}],"-1#-1235348457":[{m:"Eg10-e8",e:5}],"1#1963141352":[{m:"He4-f6",e:5}],"-1#1020382087":[{m:"Rd5-e5",e:5}],"1#-1738161821":[{m:"Re9-d9+",e:5}],"-1#440557935":[{m:"Kd10-e10",e:5}],"1#1672791062":[{m:"Hf10xe8",e:5}],"-1#1679634090":[{m:"c5-d5",e:5}],"1#-1323044448":[{m:"He8-g9+",e:5}],"-1#-1040683934":[{m:"Ke10-f10",e:5}],"1#-1129297776":[{m:"Ce3-f3+",e:5}],"-1#-559505220":[{m:"Re5-f5",e:5}],"1#-2137782022":[{m:"Hf6-e8+",e:5}],"-1#2044181777":[],"-1#291023442":[{m:"c7-c6",e:8},{m:"Ch8-e8",e:8},{m:"Hh10-i8",e:8}],"1#-767602327":[{m:"Eg1-e3",e:5}],"-1#1420187579":[{m:"Hb10-c8",e:5}],"1#1169573127":[{m:"Hb1-a3",e:5}],"-1#1516829023":[{m:"Hh10-i8",e:5}],"1#-770453853":[{m:"Ra1-a2",e:5}],"-1#1532118536":[{m:"Ri10-h10",e:5}],"1#18037753":[{m:"Ra2-d2",e:5}],"-1#-719849021":[{m:"Ec10-e8",e:5}],"1#-108660448":[{m:"Hh1-f2",e:5}],"-1#-808436815":[{m:"Ad10-e9",e:5}],"1#588317504":[{m:"Ri1-h1",e:5}],"-1#697063536":[{m:"Ch8-h4",e:5}],"1#201679642":[{m:"g4-g5",e:5}],"-1#1087280631":[{m:"i7-i6",e:5}],"1#1327717160":[{m:"Rd2-d7",e:5}],"-1#-755178573":[{m:"Ra10-d10",e:5}],"1#349364953":[{m:"Rd7-c7",e:5}],"-1#623918355":[{m:"Ch4xc4",e:5}],"1#-599193701":[{m:"Rh1xh10",e:5}],"-1#960172818":[{m:"Cc4xc7",e:5}],"1#-250681971":[{m:"Rh10-h2",e:5}],"-1#331618033":[{m:"Rd10-d2",e:5}],"1#355047200":[{m:"Cb3-c3",e:5}],"-1#532788281":[{m:"Cc7xc3",e:5}],"1#-1053561277":[{m:"Cg3xc3",e:5}],"-1#-1413808287":[{m:"Hc8-d6",e:5}],"1#-2130160414":[{m:"a4-a5",e:5}],"-1#-1352207954":[{m:"Hd6xe4",e:5}],"1#-1377185405":[{m:"Cc3-d3",e:5}],"-1#243127500":[{m:"c6-c5",e:5}],"1#-2141716819":[{m:"Rh2-h4",e:5}],"-1#-533470568":[{m:"He4-f6",e:5}],"1#-1729268500":[{m:"Ad1-e2",e:5}],"-1#-672897556":[{m:"Cb8-b6",e:5}],"1#437245139":[{m:"Ee3xc5",e:5}],"-1#719970781":[{m:"Cb6-e6+",e:5}],"1#933917811":[{m:"Cd3-e3",e:5}],"-1#-207429826":[{m:"Ke10-d10",e:5}],"1#-1974175161":[{m:"Hf2-e4",e:5}],"-1#281124865":[{m:"Rd2-d4",e:5}],"1#243044099":[{m:"Rh4-f4",e:5}],"-1#-1251833565":[{m:"Rd4xe4",e:5}],"1#-646282225":[{m:"Rf4xf6",e:5}],"-1#-1077126180":[{m:"Re4-d4",e:5}],"1#-59428291":[{m:"Rf6xe6",e:5}],"-1#137424360":[{m:"e7xe6",e:5}],"1#1390047891":[{m:"Ha3-b5",e:5}],"-1#1451117546":[{m:"Hi8-h6",e:5}],"1#-2129367084":[{m:"Hb5xa7",e:5}],"-1#-1752206275":[{m:"Hh6xi4",e:5}],"1#-437740110":[{m:"Ce3-d3+",e:5}],"-1#568342271":[{m:"Kd10-e10",e:5}],"1#1477874566":[{m:"Ha7-c8",e:5}],"-1#-692468570":[{m:"e6-e5",e:5}],"1#981057554":[{m:"a5-a6",e:5}],"-1#-1693052658":[{m:"Hi4xg5",e:5}],"1#961642341":[{m:"a6-a7",e:5}],"-1#-286498789":[{m:"e5-e4",e:5}],"1#1440855194":[{m:"a7-b7",e:5}],"-1#658940586":[{m:"g7-g6",e:5}],"1#1377588695":[{m:"b7-b8",e:5}],"-1#787620143":[{m:"Rd4-b4",e:5}],"1#903436782":[{m:"b8-a8",e:5}],"-1#1784382153":[{m:"Rb4-b1",e:5}],"1#465321332":[{m:"Ec5-a3",e:5}],"-1#1382575551":[{m:"Hg5-e6",e:5}],"1#-1242501424":[{m:"Hc8-d6",e:5}],"-1#-1905576064":[{m:"e4-d4",e:5}],"1#265026150":[{m:"Cd3-f3",e:5}],"-1#-1274507658":[{m:"g6-g5",e:5}],"1#-845584191":[{m:"Cf3-f9",e:5}],"-1#-1541866526":[{m:"Ee8-c6",e:5}],"1#767601212":[{m:"a8-a9",e:5}],"-1#-2059591608":[{m:"Rb1-b8",e:5}],"1#8524293":[{m:"Cf9-f3",e:5}],"-1#1761837350":[{m:"Rb8-d8",e:5}],"1#904526971":[{m:"Cf3-g3",e:5}],"-1#328630677":[{m:"Eg10-e8",e:5}],"1#-791954070":[],"1#1915870057":[{m:"Hb1-c3",e:5}],"-1#543797284":[{m:"Hh10-g8",e:5}],"1#-491697303":[{m:"Eg1-e3",e:5}],"-1#1680362939":[{m:"Ri10-h10",e:5}],"1#1047081034":[{m:"Hh1-i3",e:5}],"-1#669462644":[{m:"g7-g6",e:5}],"1#1388168969":[{m:"Ri1-i2",e:5}],"-1#133794657":[{m:"Hb10-a8",e:5}],"1#1299106659":[{m:"c4-c5",e:5}],"-1#-2105673749":[{m:"Hg8-f6",e:5}],"1#537666392":[{m:"Af1-e2",e:5}],"-1#2018888082":[{m:"Hf6xe4",e:5}],"1#1963038521":[{m:"Hc3xe4",e:5}],"-1#2131778288":[{m:"Ce8xe4",e:5}],"1#-484495169":[{m:"Ri2-f2",e:5}],"-1#-271910203":[{m:"Cb8-e8",e:5}],"1#-631059091":[{m:"Ke1-f1",e:5}],"-1#1596572308":[{m:"Af10-e9",e:5}],"1#1401030150":[{m:"Ra1-b1",e:5}],"-1#1697576698":[{m:"Ra10-b10",e:5}],"1#1566365795":[{m:"Cb3-b8",e:5}],"-1#1437602962":[{m:"Rh10-h3",e:5}],"1#-43431698":[{m:"Rf2-i2",e:5}],"-1#-239304044":[{m:"Rh3xg3",e:5}],"1#1835738739":[{m:"Ri2-i1",e:5}],"-1#942631451":[{m:"Rg3-h3",e:5}],"1#690037715":[{m:"i4-i5",e:5}],"-1#-1757529165":[{m:"a7-a6",e:5}],"1#-1826871631":[{m:"Hi3-h1",e:5}],"-1#-1970133361":[{m:"Rh3-h7",e:5}],"1#394309997":[{m:"Hh1-f2",e:5}],"-1#567636988":[{m:"Rh7-f7",e:5}],"1#-1918736825":[{m:"Ri1-i2",e:5}],"-1#-656004561":[{m:"Ce8-f8",e:5}],"1#-1038242554":[{m:"Ae2-d3",e:5}],"-1#-788317812":[{m:"Ke10-f10",e:5}],"1#-1404363394":[{m:"Ad1-e2",e:5}],"-1#-482210690":[{m:"Rf7-f6",e:5}],"1#-1044166004":[{m:"Rb1-b4",e:5}],"-1#-1851442730":[{m:"Ce4-e5",e:5}],"1#-830226521":[{m:"Kf1-e1",e:5}],"-1#1271443550":[{m:"Ha8-b6",e:5}],"1#-837143151":[{m:"Ke1-d1",e:5}],"-1#-179722783":[{m:"Cf8-d8+",e:5}],"1#-1218477677":[{m:"Kd1-e1",e:5}],"-1#-1945366045":[{m:"Rb10xb8",e:5}],"1#-1063554899":[],"1#-1725719122":[{m:"Eg1-e3",e:6.667}],"-1#532323196":[{m:"Ri10-h10",e:6.667}],"1#1174136461":[{m:"Hb1-c3",e:6.667}],"-1#396594624":[{m:"c7-c6",e:6.667}],"1#-725321989":[{m:"Ra1-a2",e:6.667}],"-1#1569062480":[{m:"Hb10-c8",e:6.667}],"1#1284893932":[{m:"Ra2-f2",e:6.667}],"-1#-21535296":[{m:"Ec10-e8",e:6.667}],"1#-769301213":[{m:"Rf2-f5",e:6.667}],"-1#190819128":[{m:"Ad10-e9",e:6.667}],"1#-409037879":[{m:"Hh1-f2",e:6.667}],"-1#-775204520":[{m:"Ch8-f8",e:6.667}],"1#315755377":[{m:"Hf2-d3",e:6.667}],"-1#-516233854":[{m:"Ra10-d10",e:6.667}],"1#655680744":[{m:"c4-c5",e:6.667}],"-1#-402139040":[{m:"Rh10-h6",e:6.667}],"1#1305502010":[{m:"Af1-e2",e:6.667}],"-1#361335792":[{m:"i7-i6",e:6.667}],"1#442778927":[{m:"i4-i5",e:6.667}],"-1#-1535419057":[{m:"i6xi5",e:6.667}],"1#-2044632508":[{m:"Rf5xi5",e:6.667}],"-1#-1799102191":[{m:"c6xc5",e:6.667}],"1#-1346686843":[{m:"Hd3xc5",e:6.667}],"-1#-775691595":[{m:"Cb8-b10",e:6.667}],"1#-985325441":[{m:"Hc3-b5",e:6.667}],"-1#-1939354093":[{m:"Cb10-c10",e:8}],"1#569133783":[{m:"Hc5-d3",e:8},{m:"Ri1-f1",e:8}],"-1#-360865639":[{m:"Cc10-b10",e:6.667}],"1#1207313501":[{m:"Hc3-b5",e:6.667}],"-1#211866141":[{m:"Cc10xc5",e:6.667}],"1#-1869424051":[{m:"Ri5xc5",e:6.667}],"-1#1415719103":[{m:"Hc8-d6",e:6.667}],"1#2127594300":[{m:"e4-e5",e:6.667}],"-1#-111188368":[{m:"Hd6xb5",e:6.667}],"1#2145516176":[{m:"Rc5xb5",e:6.667}],"-1#-1822061345":[{m:"e7-e6",e:6.667}],"1#834140584":[{m:"g4-g5",e:6.667}],"-1#2105282373":[{m:"e6xe5",e:6.667}],"1#-157731442":[{m:"Rb5xe5",e:6.667}],"-1#1324314843":[{m:"Rd10-b10",e:6.667}],"1#-1385273255":[{m:"Re5-e7",e:6.667}],"-1#-944510520":[{m:"a7-a6",e:6.667}],"1#-1013844790":[{m:"Re7-a7",e:6.667}],"-1#724337783":[{m:"Rh6-c6",e:6.667}],"1#-579644314":[{m:"Cb3-d3",e:6.667}],"-1#-408740963":[{m:"g7-g6",e:6.667}],"1#-1829114656":[{m:"Cd3-d7",e:6.667}],"-1#965539115":[{m:"Rb10-c10",e:6.667}],"1#1238432814":[{m:"Cd7-e7",e:6.667}],"-1#865569568":[{m:"Rc6-c7",e:6.667}],"1#1472749023":[{m:"g5xg6",e:6.667}],"-1#1021658569":[{m:"Cf8-g8",e:6.667}],"1#-1797650853":[{m:"g6-f6",e:6.667}],"-1#-1885229937":[{m:"Hi8-g7",e:6.667}],"1#-117321693":[{m:"Ra7xc7",e:6.667}],"-1#-2070857479":[{m:"Rc10xc7",e:6.667}],"1#-708397444":[{m:"Cg3xg8",e:6.667}],"-1#218729972":[{m:"Rc7xe7",e:6.667}],"1#-791150460":[{m:"f6-f7",e:6.667}],"-1#-318904607":[{m:"Re7-c7",e:6.667}],"1#-1748331775":[{m:"f7xg7",e:6.667}],"-1#-1460496656":[{m:"Rc7xg7",e:6.667}],"1#48107281":[{m:"Rf1-g1",e:6.667}],"-1#1402128631":[{m:"Rg7-a7",e:6.667}],"1#2137964444":[{m:"Rg1-g5",e:6.667}],"-1#-312120676":[{m:"Ra7-b7",e:8}],"1#1233496236":[{m:"Rg5-g4",e:8},{m:"Cg8-g7",e:8}],"-1#-1828059819":[{m:"Rb7-a7",e:6.667}],"1#938133349":[{m:"Rg1-g5",e:6.667}],"-1#-1148585139":[{m:"Rb7-e7",e:6.667}],"1#-2134723021":[{m:"Ec1-a3",e:6.667}],"-1#803955404":[{m:"Re7-d7",e:8},{m:"Re7-f7",e:8}],"1#897146786":[{m:"Ee3-c5",e:6.667}],"-1#-1334422830":[{m:"Rd7-a7",e:6.667}],"1#894427378":[{m:"Ec5-e3",e:6.667}],"-1#-1337922174":[{m:"Ra7-e7",e:6.667}],"1#842421693":[{m:"Ea3-c1",e:6.667}],"-1#-1658879678":[{m:"Re7-d7",e:6.667}],"1#-2020754388":[{m:"Ee3-g1",e:6.667}],"-1#18135806":[{m:"Rd7-e7",e:8}],"1#461801360":[{m:"Ec1-e3",e:8},{m:"Eg1-i3",e:8}],"-1#-1453299271":[{m:"Re7-d7",e:6.667}],"1#-1275964201":[{m:"Eg1-i3",e:6.667}],"-1#1167168868":[{m:"Rd7-e7",e:6.667}],"1#1594075146":[{m:"Ee3-g1",e:6.667}],"-1#-70754738":[{m:"Re7-d7",e:6.667}],"1#-514170080":[{m:"Rg5-g3",e:6.667}],"-1#-240519282":[{m:"Rd7-a7",e:6.667}],"1#1955612078":[{m:"Rg3-g5",e:6.667}],"-1#1684263168":[{m:"Ra7-e7",e:6.667}],"1#-434804417":[{m:"Eg1-e3",e:6.667}],"-1#1121886075":[{m:"Re7-d7",e:6.667}],"1#1481417237":[{m:"Ee3-c5",e:6.667}],"-1#2116486980":[{m:"Rd7-a7",e:6.667}],"1#-81873564":[{m:"Ec5-a3",e:6.667}],"-1#-1061541149":[{m:"Ra7-e7",e:6.667}],"1#1120703196":[{m:"Ei3-g1",e:6.667}],"-1#-1263578257":[{m:"Re7-d7",e:6.667}],"1#-1371705855":[{m:"Ee3-g1",e:6.667}],"-1#-303741405":[{m:"Re7-d7",e:6.667}],"1#-143164595":[{m:"Rg5-g1",e:6.667}],"-1#1702669901":[{m:"Eg10-i8",e:6.667}],"1#994616615":[{m:"Cg7-g3",e:6.667}],"-1#1588508954":[{m:"Rd7-d4",e:6.667}],"1#1659445492":[{m:"Cg3-e3",e:6.667}],"-1#995983943":[{m:"Ke10-d10",e:6.667}],"1#1118512958":[{m:"Rg1-g7",e:6.667}],"-1#-1623275337":[{m:"Rd4xa4",e:6.667}],"1#-1427281346":[{m:"Rg7-a7",e:6.667}],"-1#707454869":[{m:"Ra4-c4",e:6.667}],"1#-1373105048":[{m:"Ra7-a10+",e:6.667}],"-1#-1478313248":[{m:"Rc4-c10",e:6.667}],"1#689525487":[{m:"Ra10xa6",e:6.667}],"-1#-1733436806":[{m:"Ei8-g10",e:6.667}],"1#-962998000":[{m:"Ei3-g5",e:6.667}],"-1#-101408108":[{m:"Rc10xc1",e:6.667}],"1#-662940864":[{m:"Ce3-g3",e:6.667}],"-1#-2117537293":[{m:"Rc1-c10",e:6.667}],"1#1958173303":[{m:"Ae2-d3",e:6.667}],"-1#1739181821":[{m:"Kd10-e10",e:6.667}],"1#509569924":[{m:"Ra6-a7",e:6.667}],"-1#-1915790309":[{m:"Eg10-i8",e:6.667}],"1#-738502799":[{m:"Cg3-e3",e:6.667}],"-1#-1974471230":[{m:"Ke10-d10",e:6.667}],"1#-205958981":[{m:"Ce3-h3",e:6.667}],"-1#-1456547489":[{m:"Ei8-g10",e:6.667}],"1#-149237195":[{m:"Ch3-g3",e:6.667}],"-1#-370881005":[{m:"Eg10-i8",e:6.667}],"1#-1211054727":[{m:"Ra7-d7+",e:6.667}],"-1#-279614863":[{m:"Kd10-e10",e:6.667}],"1#-1767649528":[{m:"Rd7-i7",e:6.667}],"-1#-899254887":[{m:"Ei8-g10",e:6.667}],"1#-1806532877":[{m:"Ri7-i10",e:6.667}],"-1#-177197998":[{m:"Rc10-d10",e:6.667}],"1#2070940324":[{m:"Ad3-e2",e:6.667}],"-1#1752079918":[],"1#1531245448":[{m:"Ae2-d3",e:6.667}],"-1#1213884162":[{m:"Rf7-e7",e:6.667}],"1#1022752326":[{m:"Ec1-a3",e:6.667},{m:"Ad1-e2",e:8}],"-1#1945954118":[{m:"Re7-b7",e:6.667}],"1#1219996216":[{m:"Ae2-d1",e:6.667}],"-1#129940280":[{m:"Rf7-e7",e:6.667}],"-1#276302380":[{m:"Hb10-c8",e:9.953},{m:"g7-g6",e:9.953},{m:"a7-a6",e:9.953},{m:"Cb8-e8",e:9.953},{m:"Hh10-g8",e:9.953},{m:"Ch8-d8",e:9.953},{m:"Ec10-e8",e:9.953},{m:"Ch8-e8",e:9.953},{m:"Eg10-e8",e:9.953}],"1#23599248":[{m:"c4-c5",e:9.688},{m:"Eg1-e3",e:9.688},{m:"Hh1-g3",e:9.688},{m:"Cb3-c3",e:9.688},{m:"Hb1-a3",e:9.998},{m:"Ra1-a2",e:9.688},{m:"Ch3-c3",e:9.688},{m:"g4-g5",e:9.688}],"-1#-830790632":[{m:"g7-g6",e:7.5}],"1#-1155411099":[{m:"Ch3-e3",e:7.5},{m:"Cb3-c3",e:7.5}],"-1#-508142975":[{m:"Hh10-g8",e:6.667}],"1#594452940":[{m:"Hh1-g3",e:6.667}],"-1#-1312165764":[{m:"Hh10-g8",e:6.667}],"-1#-2014241214":[{m:"Eg10-e8",e:9.524},{m:"Ch8-e8",e:9.524},{m:"c7-c6",e:9.524},{m:"Ec10-e8",e:9.524},{m:"Hh10-i8",e:9.524}],"-1#1322628440":[{m:"c7-c6",e:8.333},{m:"g7-g6",e:8.333},{m:"a7-a6",e:8.333}],"1#-1917694365":[{m:"Ri1-i2",e:5}],"1#999244325":[{m:"Hh1-g3",e:5},{m:"c4-c5",e:8.571},{m:"Ra1-a2",e:8.571}],"-1#367126377":[{m:"Ch8-f8",e:8},{m:"c7-c6",e:8},{m:"Hh10-g8",e:8},{m:"a7-a6",e:8}],"1#-688341696":[{m:"Ri1-h1",e:5}],"-1#-597301648":[{m:"Hh10-g8",e:5}],"1#515710269":[{m:"Ha3-b5",e:5}],"-1#437855300":[{m:"Cb8xb3",e:5}],"1#1679485523":[{m:"Ch3xb3",e:5}],"-1#823228195":[{m:"c7-c6",e:5}],"1#-227111912":[{m:"Rh1-h5",e:5}],"-1#1656554160":[{m:"Ri10-h10",e:5}],"1#956071745":[{m:"Rh5xh10",e:5}],"-1#1352192529":[{m:"Hg8xh10",e:5}],"1#-695853998":[{m:"Ri1-i2",e:5}],"-1#-2084417478":[{m:"Ch8-e8",e:5}],"1#-525655807":[{m:"Ha3-b5",e:5}],"-1#-468772744":[{m:"Hh10-g8",e:5}],"1#651682613":[{m:"Cb3xb8",e:5}],"-1#-2132094577":[{m:"Ce8xb8",e:5}],"1#851722063":[{m:"Ri2-d2",e:5}],"-1#-1662413908":[{m:"Ri10-h10",e:5}],"1#-962007459":[{m:"Ch3-i3",e:5}],"1#-684123100":[{m:"Ha3-b5",e:8.333}],"-1#-744676003":[{m:"Cb8xb3",e:8.333},{m:"Cb8-b6",e:8.333},{m:"Hg8-f6",e:8.333},{m:"Cb8-a8",e:8.333}],"1#-1382094006":[{m:"Ch3xb3",e:5}],"1#511087714":[{m:"Cb3xb6",e:5}],"1#1911353838":[{m:"Cb3xb8",e:6.667}],"1#446633629":[{m:"Hb5-d6",e:5}],"1#298056299":[{m:"Ha3-b5",e:5}],"-1#359121682":[{m:"Cb8-a8",e:5}],"1#-597298990":[{m:"Hb5-d6",e:5}],"-1#1342597579":[{m:"Hh10-g8",e:5}],"1#-1830907258":[{m:"Hd6-f7",e:5}],"-1#7403286":[{m:"Ch8-h9",e:5}],"1#1476629781":[{m:"Hf7-g9+",e:5}],"-1#1628751023":[{m:"Ke10-e9",e:5}],"1#1083768586":[{m:"Ra1-b1",e:5}],"-1#1983123446":[{m:"Ca8-b8",e:5}],"1#1257744474":[{m:"Cb3-d3",e:5}],"-1#192953225":[{m:"Ra10-b10",e:8.333}],"1#871503120":[{m:"Ra1-b1",e:8.333}],"-1#90105324":[{m:"Ch8-e8",e:8.333},{m:"Cb8-b4",e:8.333},{m:"g7-g6",e:8.333}],"1#-1198281496":[{m:"c4-c5",e:7.5}],"-1#1543475572":[{m:"Hh10-g8",e:8.75},{m:"Cb8-a8",e:8.75},{m:"Ec10-e8",e:8.75},{m:"Hb10-c8",e:9},{m:"Ch8-f8",e:8.75}],"1#782591497":[{m:"Hh1-g3",e:7.5},{m:"Cb3-c3",e:7.5}],"-1#-2010542021":[{m:"Hh10-g8",e:7.5},{m:"Cb8-a8",e:7.5},{m:"g7-g6",e:7.5}],"1#1257335670":[{m:"g4-g5",e:5}],"-1#104504731":[{m:"Cb8-a8",e:5}],"1#1093379067":[{m:"Eg1-e3",e:5}],"-1#1013137270":[{m:"Ch8-e8",e:5}],"1#1594510925":[{m:"Hh1-g3",e:5}],"-1#280486789":[{m:"Hh10-g8",e:5}],"1#-764471096":[{m:"Cc3xc7",e:5}],"-1#-1737551267":[{m:"Ri10-h10",e:5}],"1#-1037144148":[{m:"Cb3-c3",e:5}],"-1#1302589053":[{m:"Ra10-a9",e:9.091},{m:"c7-c6",e:9.091}],"1#1442477884":[{m:"Eg1-e3",e:6.667}],"-1#-748457490":[{m:"c7-c6",e:7.5},{m:"Ch8-e8",e:7.5}],"1#-1899752122":[{m:"Ra1-a2",e:9.091},{m:"Cb3-c3",e:9.091},{m:"Hh1-g3",e:9.091}],"1#1696791889":[{m:"Eg1-e3",e:9.89},{m:"Ch3-e3",e:9.89},{m:"Cb3-c3",e:9.89},{m:"Hb1-a3",e:8.333},{m:"Ra1-a2",e:9.89},{m:"Hb1-a3",e:9.982},{m:"Ch3-g3",e:9.89}],"-1#-474219645":[{m:"Eg10-e8",e:9.904},{m:"g7-g6",e:9.231},{m:"a7-a6",e:9.904},{m:"g7-g6",e:8.571},{m:"Cb8-e8",e:9.904},{m:"Hb10-c8",e:9.904}],"-1#1068856501":[{m:"Hb10-c8",e:9},{m:"Hh10-g8",e:9}],"1#-43151368":[{m:"Hh1-g3",e:8.889}],"-1#-1294982608":[{m:"Hb10-c8",e:9.667},{m:"Ri10-h10",e:9.667}],"-1#1875566152":[{m:"Hb10-a8",e:9.375},{m:"Hb10-c8",e:9.375},{m:"Cb8-f8",e:9.375},{m:"Cb8-e8",e:9.375}],"1#626892362":[{m:"Ra1-b1",e:9.167}],"1#2128268532":[{m:"Ra1-b1",e:5}],"1#1564760504":[{m:"Ra1-b1",e:6.667}],"1#1516431840":[{m:"Hh1-g3",e:5}],"-1#1609740970":[{m:"Hb10-c8",e:8.571},{m:"Cb8-b4",e:8.571},{m:"Cb8-f8",e:8.571}],"1#1323474966":[{m:"Ra1-b1",e:8}],"-1#2018398442":[{m:"Ra10-b10",e:8}],"1#1077706355":[{m:"Eg1-e3",e:8},{m:"Rb1-b7",e:8}],"1#-499123282":[{m:"Ch3-e3",e:5}],"-1#-1196920246":[{m:"Hb10-c8",e:5}],"1#-1447534346":[{m:"Hh1-g3",e:5}],"-1#-435827394":[{m:"Ch8-e8",e:5}],"1#1836856666":[{m:"Ra1-a2",e:5}],"-1#-465715727":[{m:"Hb10-c8",e:5}],"1#-181555379":[{m:"Ra2-f2",e:5}],"-1#1192175201":[{m:"Af10-e9",e:5}],"-1#-329026054":[{m:"Ec10-e8",e:9.545},{m:"Hh10-g8",e:9.545},{m:"Ch8-e8",e:9.545},{m:"Cb8-e8",e:9.545},{m:"g7-g6",e:7.5},{m:"a7-a6",e:9.545},{m:"Eg10-e8",e:9.545}],"-1#715083929":[{m:"g7-g6",e:9.524},{m:"g7-g6",e:7.5},{m:"g7-g6",e:8.333}],"1#523724593":[{m:"Ra1-b1",e:8},{m:"Eg1-e3",e:8}],"-1#698062797":[{m:"Hb10-c8",e:7.5}],"1#948667761":[{m:"Cb3-d3",e:7.5},{m:"Ra1-b1",e:6.667}],"-1#39570058":[{m:"c7-c6",e:5}],"-1#-1716624925":[{m:"Ra10-a9",e:6.667},{m:"Hb10-c8",e:6.667}],"1#-2114455390":[{m:"a4-a5",e:5}],"1#-2000784545":[{m:"Ra1-b1",e:6.667}],"1#-397956140":[{m:"Ra1-a2",e:9},{m:"Eg1-e3",e:9},{m:"Hb1-a3",e:7.5}],"-1#1627792255":[{m:"Hb10-c8",e:5}],"-1#1860087046":[{m:"a7-a6",e:8.333}],"-1#-970387816":[{m:"Hh10-g8",e:8},{m:"Hg8-f6",e:9},{m:"Ch8-i8",e:9},{m:"Hb10-a8",e:9},{m:"Ri10-i9",e:9}],"1#1683544619":[{m:"Ha3-b5",e:5}],"-1#1627186002":[{m:"Cb8-e8",e:5}],"1#-70751125":[{m:"Ri1-i2",e:6.667},{m:"Ri1-h1",e:6.667}],"1#-1933685094":[{m:"Ha3-b5",e:5}],"-1#-2011531293":[{m:"Ra10-b10",e:5}],"1#-2021401860":[{m:"Ha3-b5",e:5}],"-1#-2094537851":[{m:"c7-c6",e:5}],"-1#2078073207":[{m:"Eg10-e8",e:5}],"1#-1199448696":[{m:"Hh1-i3",e:5}],"-1#-1592795722":[{m:"Hb10-c8",e:5}],"1#-1340092662":[{m:"Cb3-e3",e:5}],"-1#442456208":[{m:"Ra10-b10",e:5}],"1#573404681":[{m:"Ra1-b1",e:5}],"-1#344033013":[{m:"Cb8-b4",e:5}],"1#-1454583823":[{m:"Ri1-h1",e:5}],"1#341448494":[{m:"Ch3-e3",e:9.167},{m:"g4-g5",e:9.167},{m:"Hh1-g3",e:9.167}],"-1#1322098378":[{m:"Hh10-g8",e:8.571},{m:"Hb10-c8",e:8.571},{m:"Ch8-e8",e:8.571}],"1#-1944754809":[{m:"Hh1-g3",e:7.5}],"-1#-1012348849":[{m:"Ri10-h10",e:7.5}],"1#-1712736834":[{m:"Ri1-h1",e:7.5}],"-1#-1821053298":[{m:"Hb10-a8",e:7.5}],"1#1608354934":[{m:"Hh1-g3",e:6.667}],"-1#274735550":[{m:"g7-g6",e:6.667},{m:"Ri10-i9",e:6.667}],"1#1698354883":[{m:"Ri1-h1",e:5}],"1#765784049":[{m:"Hh1-g3",e:5}],"-1#1645822521":[{m:"Hh10-g8",e:5}],"1#-1597916812":[{m:"Ri1-h1",e:5}],"-1#-1436753340":[{m:"Hb10-a8",e:5}],"1#-523525562":[{m:"Rh1-h7",e:5}],"-1#1485955523":[{m:"Hb10-a8",e:8},{m:"Ch8-e8",e:8}],"1#302424513":[{m:"Hh1-g3",e:7.5}],"-1#1572539401":[{m:"Eg10-e8",e:7.5},{m:"Ra10-a9",e:7.5}],"1#-1629081354":[{m:"Cb3-e3",e:5}],"-1#883337068":[{m:"Ha8-b6",e:5}],"1#1172477256":[{m:"Eg1-e3",e:6.667}],"-1#-1015311462":[{m:"Hh10-g8",e:6.667}],"1#1006145784":[{m:"Hh1-g3",e:5}],"-1#1950694704":[{m:"Hh10-g8",e:5}],"1#-1231174019":[{m:"Ri1-h1",e:5}],"-1#-1140810419":[{m:"Hb10-a8",e:6.667}],"1#-157819569":[{m:"Ch3-i3",e:6.667},{m:"Ra1-a2",e:6.667}],"-1#1541913318":[{m:"g7-g6",e:5}],"1#784158107":[{m:"Eg1-e3",e:5}],"-1#-1474016439":[{m:"Hb10-a8",e:5}],"1#-491582645":[{m:"Af1-e2",e:5}],"-1#-1159011967":[{m:"Hh10-g8",e:5}],"1#2016549580":[{m:"Cb3-d3",e:6.667},{m:"Ri1-f1",e:6.667}],"-1#1122129207":[{m:"Ha8-b6",e:5}],"1#-953102088":[{m:"Ra1-a2",e:5}],"-1#1316051027":[{m:"Eg10-e8",e:5}],"1#-1926470484":[{m:"c4-c5",e:5}],"-1#1434354182":[{m:"Eg10-e8",e:5}],"1#-1776042247":[{m:"Rf1-f5",e:5}],"-1#53615606":[{m:"Ra10-a9",e:5}],"1#460030647":[{m:"a4-a5",e:5}],"1#634404228":[{m:"Hh1-g3",e:9.545},{m:"Ch3-e3",e:9.545}],"-1#1785565260":[{m:"Hb10-c8",e:9.524},{m:"g7-g6",e:9.524}],"1#2071823088":[{m:"Eg1-e3",e:9.474},{m:"Ra1-b1",e:9.474},{m:"Ch3-i3",e:9.474},{m:"Ra1-a2",e:9.474}],"-1#-35355614":[{m:"Hh10-g8",e:6.667},{m:"Hb10-c8",e:6.667}],"-1#1305571852":[{m:"Ra10-a9",e:8.333}],"-1#214322671":[{m:"Hh10-g8",e:5}],"1#-836847966":[{m:"Ri1-h1",e:5}],"-1#-230946213":[{m:"Ra10-b10",e:9.091},{m:"g7-g6",e:9.091}],"-1#2135405664":[{m:"Hb10-c8",e:6.667},{m:"Hh10-g8",e:6.667}],"1#1851238108":[{m:"Hh1-g3",e:5}],"-1#568986388":[{m:"Ch8-f8",e:8.571},{m:"Ra10-b10",e:8.571},{m:"Hh10-i8",e:8.571}],"1#-487370435":[{m:"Ri1-h1",e:5}],"-1#-395441651":[{m:"Hh10-g8",e:8.889}],"1#429401485":[{m:"Cb3-c3",e:8},{m:"Ra1-b1",e:8}],"1#-1450099480":[{m:"Ra1-b1",e:6.667}],"-1#-1623340012":[{m:"Ri10-h10",e:6.667}],"1#-981683739":[{m:"Cb3-c3",e:6.667}],"1#-1113632979":[{m:"Hh1-g3",e:5}],"-1#-232594715":[{m:"Hb10-c8",e:8},{m:"Ri10-h10",e:8}],"1#-483200935":[{m:"Ri1-h1",e:6.667}],"-1#-374363287":[{m:"Ra10-b10",e:8},{m:"Ri10-h10",e:8}],"1#-774011408":[{m:"Cb3-d3",e:5}],"1#-1276193128":[{m:"c4-c5",e:8.333}],"1#-1469866220":[{m:"Cb3-d3",e:8},{m:"Ra1-b1",e:8},{m:"Cb3-c3",e:8},{m:"Ra1-a2",e:8}],"1#-761204383":[{m:"Cb3-c3",e:9.333},{m:"Cb3-d3",e:9.333},{m:"Hh1-g3",e:9.333},{m:"g4-g5",e:9.333}],"-1#-666316168":[{m:"Cb8-e8",e:6.667},{m:"Hb10-a8",e:6.667}],"1#-304028208":[{m:"Hh1-g3",e:5}],"-1#-1570945000":[{m:"Hb10-c8",e:5}],"1#-1286776156":[{m:"Ra1-b1",e:5}],"-1#-2048808360":[{m:"e7-e6",e:5}],"1#657710895":[{m:"Af1-e2",e:5}],"1#-1830841734":[{m:"Ch3-e3",e:5}],"-1#-934798434":[{m:"Ra10-b10",e:5}],"1#-264620793":[{m:"Hh1-g3",e:5}],"-1#-1081632561":[{m:"Ri10-h10",e:5}],"1#-439950018":[{m:"Ri1-h1",e:5}],"-1#-279200242":[{m:"Ch8-h4",e:5}],"-1#-395264358":[{m:"a7-a6",e:5}],"1#-330128488":[{m:"Ra1-b1",e:5}],"-1#-620866716":[{m:"Hb10-a8",e:5}],"1#-1872161946":[{m:"Ch3-e3",e:5}],"-1#-889283966":[{m:"Ri10-h10",e:5}],"1#-1866471565":[{m:"Hh1-g3",e:5}],"-1#-553497925":[{m:"Ra10-b10",e:5}],"1#-412064734":[{m:"Ri1-h1",e:5}],"-1#-303218926":[{m:"Ch8-h4",e:5}],"1#-932969352":[{m:"g4-g5",e:5}],"-1#-2068843883":[{m:"Ad10-e9",e:5}],"1#1752091236":[{m:"Hg3-f5",e:5}],"-1#1050450179":[{m:"Cb8-b4",e:5}],"-1#-1659020119":[{m:"g7-g6",e:7.5},{m:"Cb8-a8",e:7.5}],"1#1411346281":[{m:"Eg1-e3",e:5}],"-1#-762943045":[{m:"Eg10-e8",e:5}],"1#299586884":[{m:"Ri1-h1",e:5}],"-1#457576052":[{m:"c7-c6",e:5}],"1#-668863153":[{m:"Ra1-b1",e:5}],"-1#-292747853":[{m:"Hb10-c8",e:5}],"-1#-1637152884":[{m:"c7-c6",e:9.091},{m:"Hb10-c8",e:9.091},{m:"Ch8-i8",e:9.091},{m:"Ec10-e8",e:9.091},{m:"a7-a6",e:9.091},{m:"Cb8-e8",e:9.091}],"1#1561132215":[{m:"Hh1-g3",e:7.5}],"1#-1887759056":[{m:"Hh1-g3",e:5}],"1#-1551211137":[{m:"Hh1-g3",e:6.667}],"1#-1292302481":[{m:"Hh1-g3",e:5}],"1#-1706485106":[{m:"Hh1-g3",e:5}],"1#-1413271516":[{m:"Ch3-e3",e:6.667}],"1#126591969":[{m:"g4-g5",e:5}],"-1#1262507276":[{m:"Hh10-g8",e:5}],"1#-1986482623":[{m:"Hh1-g3",e:5}],"-1#-970652791":[{m:"Ri10-h10",e:5}],"1#-1671135624":[{m:"Ri1-h1",e:5}],"-1#-1762056888":[{m:"Rh10-h6",e:5}],"1#858692626":[{m:"Ch3-i3",e:5}],"-1#1150636813":[{m:"Rh6-d6",e:5}],"1#-273901442":[{m:"Ad1-e2",e:5}],"-1#-1599764098":[{m:"Hb10-a8",e:5}],"1#-365770372":[{m:"Cb3-f3",e:5}],"-1#-1889761773":[{m:"Ra10-b10",e:5}],"1#-1221678966":[{m:"Ec1-e3",e:5}],"-1#97011363":[{m:"a7-a6",e:5}],"1#32136097":[{m:"Hg3-f5",e:5}],"-1#1461192902":[{m:"Rd6-d5",e:5}],"1#-804555091":[{m:"Hf5xg7",e:5}],"-1#-1830164378":[{m:"Cb8-b4",e:5}],"1#790929762":[{m:"c4-c5",e:5}],"-1#-533226006":[{m:"Rd5-d4",e:5}],"1#-1674042809":[{m:"Rh1-h4",e:5}],"-1#-526074367":[{m:"Ec10-e8",e:5}],"1#-868827422":[{m:"Ha3-c2",e:5}],"-1#220651907":[{m:"Rd4-d2",e:5}],"1#-1915888350":[{m:"Hc2xb4",e:5}],"-1#-1471102351":[{m:"Rb10xb4",e:5}],"1#1935480977":[{m:"Cf3-f9",e:5}],"-1#1863008042":[{m:"Ha8-b6",e:5}],"1#-354829595":[{m:"Hg7xe8",e:5}],"-1#-1567251486":[{m:"Cd8-b8",e:5}],"1#566853771":[{m:"He8-g9",e:5}],"-1#1814743511":[{m:"Ke10-e9",e:5}],"1#1302786674":[{m:"Cf9-f2",e:5}],"-1#1387425304":[{m:"Rd2-d6",e:5}],"1#692425599":[{m:"Rh4-f4",e:5}],"-1#-1839491745":[{m:"Rb4-b1+",e:5}],"1#-474207518":[{m:"Ra1xb1",e:5}],"-1#513010428":[{m:"Cb8xb1",e:5}],"1#-170811570":[{m:"e4-e5",e:5}],"-1#1918794242":[{m:"Cb1-b5",e:5}],"1#-155575037":[{m:"e5-e6",e:5}],"-1#2086136494":[],"1#1021971151":[{m:"Ch3-d3",e:5}],"-1#-1079501033":[{m:"Hh10-g8",e:5}],"1#2104550490":[{m:"Hh1-g3",e:5}],"-1#852314514":[{m:"Ri10-h10",e:5}],"1#1754018915":[{m:"Ri1-i2",e:5}],"-1#1036548107":[{m:"Ch8-i8",e:5}],"1#2693880":[{m:"Ri2-f2",e:5}],"-1#217895042":[{m:"Rh10-h6",e:5}],"1#-1456772648":[{m:"Rf2-f5",e:5}],"-1#1429923198":[{m:"Hb10-c8",e:5}],"1#1143666626":[{m:"Ec1-e3",e:5}],"-1#-154396181":[{m:"c7-c6",e:5}],"1#900457168":[{m:"Rf5-d5",e:5}],"-1#211152684":[{m:"Ad10-e9",e:5}],"1#-531310627":[{m:"Ad1-e2",e:5}],"-1#-1352808739":[{m:"a7-a6",e:5}],"1#-1417684001":[{m:"Cb3-b1",e:5}],"-1#137555358":[{m:"Cb8-a8",e:5}],"1#-1053761954":[{m:"Rd5-b5",e:5}],"-1#1712600449":[{m:"Ca8xa4",e:5}],"1#-1305910364":[{m:"Ha3-c2",e:5}],"-1#1933130949":[{m:"a6-a5",e:5}],"1#-1018975431":[{m:"Rb5-d5",e:5}],"-1#1684488422":[{m:"g7-g6",e:5}],"1#289257371":[{m:"c4-c5",e:5}],"-1#-567375085":[{m:"Hc8-a7",e:5}],"1#-601315796":[{m:"Hc2-b4",e:5}],"-1#-143378111":[{m:"Rh6-h4",e:5}],"1#-1958782915":[{m:"c5xc6",e:5}],"-1#-1263787031":[{m:"Ha7xc6",e:5}],"1#-280238387":[{m:"Rd5-c5",e:5}],"-1#262178303":[{m:"Hc6-d8",e:5}],"1#-784089883":[{m:"Hb4-d5",e:5}],"-1#1556764097":[{m:"Hd8-e6",e:5}],"1#-708485708":[{m:"Rc5-c4",e:5}],"-1#1712833712":[{m:"Rh4xg4",e:5}],"1#126033591":[{m:"Rc4-c9",e:5}],"-1#1687527386":[{m:"Ra10-b10",e:5}],"1#1558688067":[{m:"Cb1-b4",e:5}],"-1#1514124240":[{m:"He6-d4",e:5}],"1#1358600672":[{m:"Rc9-c5",e:5}],"-1#-1646020872":[{m:"Rb10-a10",e:5}],"1#-1517184927":[{m:"Cb4-c4",e:5}],"-1#-154010682":[{m:"g6-g5",e:5}],"1#-1891623567":[{m:"Ra1-b1",e:5}],"-1#-1175655027":[{m:"g5-f5",e:5}],"1#-1004624234":[{m:"Hd5-c7",e:5}],"-1#-631531792":[{m:"f5-f4",e:5}],"1#-759210622":[{m:"Hc7-d9",e:5}],"1#1930525463":[{m:"Hh1-g3",e:9.756},{m:"Ch3-e3",e:9.756}],"-1#1017960159":[{m:"g7-g6",e:9.722},{m:"Hh10-g8",e:9.722}],"1#1240867234":[{m:"Ri1-h1",e:5}],"-1#1131117202":[{m:"Hh10-g8",e:5}],"1#-2118942241":[{m:"Ra1-a2",e:8.333},{m:"Ch3-i3",e:8.333}],"-1#150079860":[{m:"Cb8-b4",e:8.571},{m:"Hb10-c8",e:8.571},{m:"Ri10-h10",e:8.571}],"-1#-167227712":[{m:"Hb10-c8",e:5}],"1#-417833860":[{m:"Ad1-e2",e:6.667},{m:"c4-c5",e:6.667}],"-1#-1475261060":[{m:"c7-c6",e:5}],"1#-25940590":[{m:"Ra1-a2",e:9.714},{m:"Ri1-h1",e:9.714},{m:"g4-g5",e:9.714}],"-1#2000004409":[{m:"Ri10-h10",e:5}],"1#762632392":[{m:"Ri1-h1",e:5}],"-1#669615096":[{m:"Cb8-c8",e:7.5}],"-1#-186026334":[{m:"Hh10-g8",e:5},{m:"a7-a6",e:9.697}],"-1#-1296049281":[{m:"Ri10-h10",e:5}],"1#-385964402":[{m:"Ri1-h1",e:5}],"-1#-496763458":[{m:"Rh10-h6",e:7.5}],"-1#696709875":[{m:"Hh10-g8",e:8.333}],"1#-346158658":[{m:"Hh1-g3",e:8.333}],"-1#-1528585098":[{m:"Ri10-i9",e:8.889},{m:"Hb10-c8",e:8.889},{m:"Ri10-h10",e:8.889}],"1#-448172014":[{m:"Ri1-h1",e:8.333},{m:"Cb3-c3",e:8.333}],"-1#-271307998":[{m:"Hb10-a8",e:9.811},{m:"Ri10-i9",e:8.333}],"-1#-274640117":[{m:"Hb10-a8",e:7.5}],"1#-1523182839":[{m:"Ra1-b1",e:7.5}],"1#-1242319158":[{m:"c4-c5",e:6.667},{m:"Ri1-h1",e:6.667}],"-1#2061535810":[{m:"Ri10-h10",e:6.667},{m:"g7-g6",e:6.667}],"-1#-1083249158":[{m:"a7-a6",e:8.333},{m:"Ri10-i9",e:8.333}],"1#-22881913":[{m:"Ri1-i2",e:8.333},{m:"Hb1-a3",e:5}],"-1#-1410951697":[{m:"a7-a6",e:8.571},{m:"Hb10-a8",e:8.571},{m:"Af10-e9",e:8.571},{m:"Cb8-b4",e:8.571}],"-1#-196412770":[{m:"Hb10-a8",e:6.667},{m:"Cb8-d8",e:6.667}],"1#-1092765028":[{m:"Ra1-b1",e:5}],"-1#-2005841312":[{m:"Ra10-b10",e:5}],"1#-1341954823":[{m:"Rb1-b5",e:5}],"-1#-391293246":[{m:"a7-a6",e:5}],"1#-326153280":[{m:"g4-g5",e:5}],"-1#-1606107859":[{m:"Rh10-h6",e:5}],"1#93521015":[{m:"Cc3xc7",e:5}],"-1#-51096907":[{m:"Ha8-b6",e:5}],"1#2032588666":[{m:"Cc7-b7",e:6.667}],"-1#416762745":[{m:"Cb8-a8",e:6.667},{m:"Cb8-c8",e:6.667}],"1#-774539079":[{m:"Cb7xg7",e:5}],"-1#359631557":[{m:"Eg10-i8",e:5}],"1#-1809252069":[{m:"Cb7-c7",e:5}],"-1#-170353384":[{m:"Ha8-b6",e:5}],"1#-1727041939":[{m:"Ra1-b1",e:5}],"-1#-1348231535":[{m:"Hb10-a8",e:5}],"1#-449519981":[{m:"a4-a5",e:5}],"-1#-883262497":[{m:"Rh10-h4",e:5}],"1#253465736":[{m:"Ri1-h1",e:5}],"-1#92721080":[{m:"Rh4xg4",e:5}],"1#1678906815":[{m:"Rb1-b5",e:5}],"-1#1018963844":[{m:"Cd8-d3",e:5}],"1#1523158924":[{m:"Rh1-h3",e:5}],"-1#1124226505":[{m:"g7-g6",e:5}],"1#911778484":[{m:"Ad1-e2",e:5}],"-1#2035397556":[{m:"Cd3xa3",e:5}],"1#144350996":[{m:"Ce3xa3",e:5}],"-1#1302810106":[{m:"Ra10-b10",e:5}],"1#1976918883":[{m:"Rb5xb10",e:5}],"1#-752535853":[{m:"Cb3-d3",e:5}],"-1#-369788632":[{m:"Hb10-a8",e:6.667},{m:"Ra10-a9",e:6.667}],"1#-1553843926":[{m:"Ra1-b1",e:5}],"-1#-1781610026":[{m:"Ra10-b10",e:5}],"1#-1380128945":[{m:"Ch3-e3",e:5}],"-1#-148148565":[{m:"Hh10-g8",e:5}],"1#905156070":[{m:"Hh1-g3",e:5}],"-1#2051946542":[{m:"Af10-e9",e:5}],"1#1994783932":[{m:"Ri1-h1",e:5}],"-1#2088281996":[{m:"Ch8-i8",e:5}],"1#1100596607":[{m:"g4-g5",e:5}],"-1#223490962":[{m:"Ri10-f10",e:5}],"1#-2071559082":[{m:"Rb1-b5",e:5}],"-1#-601311635":[{m:"Cb8-d8",e:5}],"1#-1318247778":[{m:"Rb5-d5",e:5}],"-1#-1687427876":[{m:"Cd8xd3",e:5}],"1#-1966417279":[{m:"Rd5xd3",e:5}],"-1#618764428":[{m:"Rf10-h10",e:5}],"1#-357997112":[{m:"Rh1xh10+",e:5}],"-1#266039617":[{m:"Hg8xh10",e:5}],"1#1404979880":[{m:"Rd3-d6",e:5}],"-1#-1040775220":[{m:"Rb10-b5",e:5}],"1#-277921188":[{m:"Eg1-i3",e:5}],"-1#420250607":[{m:"Ci8-f8",e:5}],"1#-97940412":[{m:"Ce3xe7",e:5}],"1#-240328599":[{m:"a4-a5",e:5}],"-1#-540916443":[{m:"Ra9-d9",e:5}],"1#-1336780666":[{m:"Af1-e2",e:5}],"-1#-401886644":[{m:"Rd9-d6",e:5}],"1#803079306":[{m:"Ra1-b1",e:5}],"-1#426964086":[{m:"Hb10-a8",e:5}],"1#1407562868":[{m:"Hh1-g3",e:5}],"-1#475535804":[{m:"a7-a6",e:5}],"1#410649790":[{m:"a5xa6",e:5}],"-1#-1893272751":[{m:"Rd6xa6",e:5}],"1#1228813069":[{m:"Rb1-b7",e:5}],"-1#1776982190":[{m:"Cb8-d8",e:5}],"1#78580829":[{m:"Eg1-e3",e:5}],"-1#-2110387569":[{m:"Hh10-g8",e:5}],"1#1089401282":[{m:"Ri1-f1",e:5}],"-1#1839360264":[{m:"Ch8-i8",e:5}],"1#1346571259":[{m:"g4-g5",e:5}],"-1#478739734":[{m:"Ri10-h10",e:5}],"1#1187610855":[{m:"Ch3-i3",e:5}],"-1#829575160":[{m:"g7-g6",e:5}],"1#1143519365":[{m:"Rb7-b5",e:5}],"-1#563025516":[{m:"Af10-e9",e:5}],"1#757388030":[{m:"Ci3-i1",e:5}],"-1#1791555867":[{m:"Hb10-c8",e:9.929},{m:"Ra10-a8",e:9.929},{m:"Hh10-g8",e:9.929},{m:"c7-c6",e:9.929},{m:"Ra10-a9",e:9.929},{m:"Hb10-a8",e:9.929},{m:"Cb8-e8",e:9.929},{m:"Cb8-g8",e:9.929},{m:"Cb8-f8",e:9.929},{m:"Eg10-e8",e:9.929},{m:"g7-g6",e:9.929}],"1#2077813671":[{m:"Hb1-c3",e:9.839},{m:"c4-c5",e:9.839}],"-1#696287466":[{m:"Ra10-b10",e:9.808},{m:"Hb10-c8",e:7.5},{m:"Hb10-c8",e:9.583}],"1#301117043":[{m:"Ec1-e3",e:9.778},{m:"Hh1-i3",e:9.778},{m:"Hb1-c3",e:8.889},{m:"g4-g5",e:9.778},{m:"Ra1-b1",e:9.778}],"-1#-1558953894":[{m:"g7-g6",e:5}],"1#-699484377":[{m:"Hh1-i3",e:5}],"-1#142388813":[{m:"i7-i6",e:7.5},{m:"Hh10-i8",e:7.5}],"-1#-555642117":[{m:"g7-g6",e:9.697},{m:"Cb8-a8",e:9.697}],"1#-1413782138":[{m:"Eg1-e3",e:9.231},{m:"Hh1-i3",e:9.231},{m:"Ec1-e3",e:9.231}],"1#400793915":[{m:"Hh1-i3",e:9.583},{m:"Ra1-a2",e:9.583},{m:"Hh1-g3",e:9.583},{m:"Eg1-e3",e:9.583}],"-1#1564039326":[{m:"Ra10-b10",e:7.5},{m:"Cb8-a8",e:8.75}],"1#-1637964891":[{m:"Hh1-g3",e:8.75}],"-1#-773648787":[{m:"Hh10-i8",e:9.231}],"-1#660496015":[{m:"Ra10-b10",e:9.5},{m:"Cb8-b4",e:9}],"1#-465984076":[{m:"Rb1-b7",e:9.565},{m:"Rb1-b5",e:9.565}],"1#1557821335":[{m:"c4-c5",e:6.667},{m:"Ra1-b1",e:6.667}],"-1#-1815524577":[{m:"Hh10-g8",e:8.333},{m:"g7-g6",e:9.697}],"1#1360113746":[{m:"Ra1-b1",e:6.667}],"-1#1740456110":[{m:"Ra10-b10",e:6.667}],"1#1607429687":[{m:"Eg1-e3",e:8.889},{m:"Hh1-i3",e:8.889},{m:"Ch3-h7",e:8.889}],"-1#1786152811":[{m:"Ra10-b10",e:5}],"1#1376037362":[{m:"Rb1-b5",e:5}],"-1#178953161":[{m:"Hh10-g8",e:5}],"1#-932028284":[{m:"g4-g5",e:5}],"-1#-2068212119":[{m:"g6xg5",e:5}],"1#511532638":[{m:"Rb5xg5",e:5}],"-1#300391578":[{m:"Ch8-h9",e:5}],"1#1234501273":[{m:"Ch3-g3",e:5}],"-1#1466622655":[{m:"Ch9-g9",e:5}],"1#-353928239":[{m:"Hh1-g3",e:9.615},{m:"Ra1-b1",e:9.615},{m:"Hh1-i3",e:9.615},{m:"g4-g5",e:9.615}],"-1#-1520773607":[{m:"Ra10-b10",e:5}],"1#-1658259328":[{m:"Ch3-i3",e:5}],"-1#-359450721":[{m:"Ch8-g8",e:5}],"1#-1670899371":[{m:"Ri1-h1",e:5}],"-1#-599028947":[{m:"Ra10-b10",e:9.5}],"-1#-211190801":[{m:"Ra10-b10",e:6.667}],"1#-887401098":[{m:"Ec1-e3",e:6.667},{m:"Ri1-i2",e:6.667}],"-1#-1507029700":[{m:"Ra10-b10",e:7.5}],"-1#-1261709521":[{m:"g7-g6",e:9.091},{m:"Ra10-b10",e:9.091}],"1#-1047453614":[{m:"c4-c5",e:6.667}],"1#-1933968970":[{m:"Hb1-c3",e:8.889}],"1#-1278236221":[{m:"Hb1-c3",e:5}],"-1#-510147954":[{m:"Cb8-g8",e:5}],"1#-393430857":[{m:"Af1-e2",e:7.5},{m:"Ra1-b1",e:7.5}],"-1#-1328196995":[{m:"Ra8-f8",e:5}],"1#-1222209373":[{m:"Ra1-b1",e:5}],"-1#-2121637793":[{m:"Hb10-c8",e:7.5}],"1#-1868926237":[{m:"c4-c5",e:7.5},{m:"Rb1-b5",e:7.5}],"-1#1602834027":[{m:"g7-g6",e:5}],"1#718518550":[{m:"Hh1-i3",e:5}],"-1#861780264":[{m:"i7-i6",e:5}],"1#1018198007":[{m:"Eg1-e3",e:5}],"-1#-1171689179":[{m:"Cg8-g9",e:5}],"1#-779301906":[{m:"Ch3-h2",e:5}],"-1#-1903767993":[{m:"Hh10-g8",e:5}],"1#1281242378":[{m:"Ch2-f2",e:5}],"-1#-746336796":[{m:"Rf8-d8",e:5}],"1#1620080695":[{m:"Ri1-h1",e:5}],"-1#1779245831":[{m:"Ch8-h6",e:5}],"1#1371822085":[{m:"Rb1-b8",e:5}],"-1#2020114111":[{m:"i6-i5",e:5}],"1#-1092765086":[{m:"i4xi5",e:5}],"-1#-673935247":[{m:"Ri10xi5",e:5}],"1#-831747992":[{m:"Rh1-h3",e:5}],"-1#-676900307":[{m:"Cg9-h9",e:5}],"1#-844021965":[{m:"Rh3-g3",e:5}],"-1#1036162997":[{m:"Hg8-i7",e:5}],"1#-561893950":[{m:"Cf2-i2",e:5}],"-1#1762462071":[{m:"Hi7-h5",e:5}],"1#1105595236":[{m:"Ci2xi5",e:5}],"-1#284980143":[{m:"Hh5xg3",e:5}],"1#384920459":[{m:"Hc3-b5",e:5}],"-1#1607697895":[{m:"g6-g5",e:5}],"1#641885008":[{m:"Hb5xa7",e:5}],"-1#819558585":[{m:"Rd8-i8",e:5}],"1#-702137436":[{m:"Rb8xc8",e:5}],"-1#1861587813":[{m:"Eg10-e8",e:5}],"1#-1381453926":[{m:"Rc8xc7",e:5}],"-1#1809479034":[{m:"Ri8xi5",e:5}],"1#-304287780":[{m:"Rc7xe7",e:5}],
"-1#-1346956542":[{m:"Ch9-i9",e:5}],"-1#-936099624":[{m:"Hh10-i8",e:6.667}],"1#1078949668":[{m:"i4-i5",e:6.667}],"-1#-28283068":[{m:"Rf8-f6",e:6.667},{m:"Cg8xg4",e:6.667}],"1#1627557320":[{m:"Hh1-i3",e:5}],"-1#2022477302":[{m:"Ch8-h4",e:5}],"1#1560655516":[{m:"Hi3-h5",e:5}],"-1#984960235":[{m:"Rf6-d6",e:5}],"1#-690865868":[{m:"Rb5-f5",e:5}],"-1#1523135599":[{m:"Af10-e9",e:5}],"1#1449324797":[{m:"Eg1-e3",e:5}],"-1#-788793809":[{m:"Cg8xg4",e:5}],"1#-1706866557":[{m:"c4-c5",e:5}],"-1#1431335947":[{m:"Eg10-e8",e:5}],"1#-1777514252":[{m:"Rf5-f6",e:5}],"-1#392037812":[{m:"c7-c6",e:5}],"1#-734396785":[{m:"c5xc6",e:5}],"-1#-341146277":[{m:"Rd6xc6",e:5}],"1#-71579562":[{m:"a4-a5",e:5}],"1#-1259810328":[{m:"Ec1-e3",e:5}],"-1#101597121":[{m:"Eg10-e8",e:5}],"1#-984415426":[{m:"Ch3-h5",e:5}],"-1#-1257484995":[{m:"Rf8-f4",e:5}],"1#2073444153":[{m:"Ch5-h4",e:5}],"-1#-489632521":[{m:"Cg4-g6",e:5}],"1#447395572":[{m:"Ch4-h5",e:5}],"-1#-2081667782":[{m:"Af10-e9",e:5}],"1#-1891139160":[{m:"Hh1-i3",e:5}],"-1#-1765178986":[{m:"Cg6-e6",e:5}],"1#1341912205":[{m:"Rb5-e5",e:5}],"-1#507243839":[{m:"g7-g6",e:5}],"1#1801525826":[{m:"Ri1-i2",e:5}],"-1#1042634282":[{m:"Ri10-g10",e:5}],"1#-1717719453":[{m:"Ri2-g2",e:5}],"-1#-568309685":[{m:"Ra8-f8",e:6.667}],"1#-640447851":[{m:"Ra1-b1",e:5}],"1#-1475345834":[{m:"Hb1-c3",e:5}],"-1#-95917797":[{m:"c7-c6",e:5}],"1#959418912":[{m:"Ra1-b1",e:5}],"-1#260268764":[{m:"Ra10-a8",e:5}],"1#-695979516":[{m:"Eg1-e3",e:5}],"-1#1344091350":[{m:"Hb10-c8",e:5}],"1#1091380842":[{m:"Rb1-b5",e:5}],"-1#430117969":[{m:"Ch8-h9",e:5}],"1#1104180818":[{m:"g4-g5",e:5}],"-1#219906239":[{m:"Ch9-c9",e:5}],"1#-1122811750":[{m:"Af1-e2",e:5}],"-1#-448091568":[{m:"c6-c5",e:5}],"1#1801486385":[{m:"Rb5-b7",e:5}],"-1#247934680":[{m:"c5xc4",e:5}],"1#1094734939":[{m:"Hc3-a2",e:5}],"-1#433332395":[{m:"Hc8-d6",e:5}],"1#862358312":[{m:"Rb7-c7",e:5}],"-1#-910439738":[{m:"Cb8-c8",e:5}],"1#1162182820":[{m:"Rc7-d7",e:5}],"-1#1957125998":[{m:"Hd6xe4",e:5}],"1#1982365507":[{m:"Cf3-f8",e:5}],"-1#-1110305948":[{m:"Ec10-e8",e:5}],"1#-1858071673":[{m:"Cf8xc8",e:5}],"-1#573299660":[{m:"Ra8xc8",e:5}],"1#1373101406":[{m:"Ch3-f3",e:5}],"-1#1955302375":[{m:"Ri10-h10",e:5}],"1#785053206":[{m:"Hh1-i3",e:5}],"-1#927266344":[{m:"Rh10-h3",e:5}],"1#-1617057196":[{m:"Cf3-f8",e:5}],"-1#-446743309":[{m:"Rc8-c6",e:5}],"1#-864766845":[{m:"Rd7xe7",e:5}],"-1#-1574919962":[{m:"c4-d4",e:5}],"1#1742416273":[{m:"Re7xg7",e:5}],"-1#38277773":[{m:"Ad10-e9",e:5}],"1#-293000580":[{m:"Cf8-f4",e:5}],"-1#-2066549586":[{m:"He4-f6",e:5}],"1#-66297126":[{m:"Cf4-f5",e:5}],"-1#334202042":[{m:"Rc6-c5",e:5}],"1#1209713622":[{m:"g5-g6",e:5}],"-1#706104517":[{m:"Ee8xg6",e:5}],"1#-1448148448":[{m:"Hb1-c3",e:9.583}],"-1#-67671699":[{m:"Cb8-f8",e:9.583},{m:"Hb10-c8",e:9.583}],"1#-914755939":[{m:"Hh1-g3",e:8},{m:"Ra1-b1",e:8}],"-1#-2033958059":[{m:"Hb10-c8",e:5}],"1#-1747693079":[{m:"Hh1-g3",e:8.333}],"-1#-1585929963":[{m:"Hh10-g8",e:8},{m:"Hh10-i8",e:8}],"1#1671453272":[{m:"g4-g5",e:5}],"-1#795585717":[{m:"Eg10-e8",e:5}],"1#-331968438":[{m:"Eg1-e3",e:5}],"-1#1789892248":[{m:"Ra10-b10",e:5}],"1#688101097":[{m:"Rb1-b5",e:7.5},{m:"g4-g5",e:7.5}],"-1#1907205330":[{m:"Ra10-b10",e:6.667}],"-1#-2810271":[{m:"c7-c6",e:6.667}],"1#-289076003":[{m:"Hh1-g3",e:8.333},{m:"Hh1-i3",e:8.333},{m:"i4-i5",e:8.333}],"-1#-146076445":[{m:"i7-i6",e:5}],"1#-123289028":[{m:"Ch3-g3",e:5}],"-1#-430383590":[{m:"Hh10-i8",e:5}],"1#1847847398":[{m:"Ri1-h1",e:5}],"-1#1690219222":[{m:"Ri10-h10",e:5}],"1#1056952103":[{m:"Rh1-h5",e:5}],"-1#-1372307057":[{m:"Ch8-h6",e:5}],"1#-1778566515":[{m:"Ad1-e2",e:5}],"-1#-621532275":[{m:"Ch6-g6",e:5}],"1#-186151942":[{m:"Rh5xh10",e:5}],"-1#1356469437":[{m:"Hh10-i8",e:5}],"1#-660528319":[{m:"Hh1-i3",e:5}],"-1#-1053875329":[{m:"Ec10-e8",e:5}],"1#-306371684":[{m:"Eg1-e3",e:5}],"-1#1797530958":[{m:"Ri10-i9",e:5}],"1#714010922":[{m:"Ch3-g3",e:5}],"-1#879815948":[{m:"Ch8-g8",e:5}],"1#1116455878":[{m:"Ri1-h1",e:5}],"-1#1209440502":[{m:"Ra10-a9",e:5}],"1#1922130010":[{m:"Hb1-c3",e:9.286},{m:"Ad1-e2",e:9.286}],"-1#550046487":[{m:"Ra9-f9",e:9.231},{m:"Ra10-a9",e:6.667},{m:"Cb8-e8",e:9.231}],"1#-404814951":[{m:"Af1-e2",e:8.333},{m:"Hh1-g3",e:8.333},{m:"Hb1-c3",e:5}],"-1#-1081677485":[{m:"Cb8-e8",e:6.667}],"1#-1976639749":[{m:"Ra1-b1",e:6.667}],"-1#-1132319225":[{m:"Hb10-c8",e:6.667}],"-1#-1469927855":[{m:"Cb8-e8",e:5}],"1#-1647666695":[{m:"Ra1-b1",e:5}],"-1#-1462365543":[{m:"Cb8-e8",e:7.5},{m:"Hh10-g8",e:7.5}],"1#-1652677327":[{m:"Ec1-e3",e:6.667},{m:"Ra1-b1",e:6.667}],"-1#798542616":[{m:"Hb10-c8",e:5}],"1#1049156004":[{m:"Hh1-i3",e:5}],"-1#654760346":[{m:"Hh10-g8",e:5}],"-1#-1412246067":[{m:"Hb10-c8",e:5}],"1#-1161640079":[{m:"Rb1-b5",e:5}],"-1#-496175798":[{m:"Hh10-g8",e:5}],"1#1779362260":[{m:"Ra1-b1",e:5}],"-1#1554127144":[{m:"Hb10-a8",e:5}],"1#372594986":[{m:"Rb1-b6",e:5}],"-1#2086659543":[{m:"Cb8-c8",e:5}],"1#-257839179":[{m:"g4-g5",e:5}],"-1#-1133881000":[{m:"Rf9-f4",e:5}],"1#1934305429":[{m:"Hh1-i3",e:5}],"1#-476825624":[{m:"Ra1-b1",e:8.889},{m:"Hh1-i3",e:8.889}],"-1#-717699308":[{m:"Ra9-f9",e:8.75},{m:"a7-a6",e:8.75},{m:"Hb10-a8",e:8.75}],"1#305057690":[{m:"Af1-e2",e:8.333},{m:"Ad1-e2",e:8.333}],"-1#1249322320":[{m:"Hb10-a8",e:5}],"-1#1562893978":[{m:"Hb10-a8",e:8}],"1#397450904":[{m:"c4-c5",e:8}],"1#-786769386":[{m:"Rb1-b5",e:5}],"-1#-1984632787":[{m:"Ra9-f9",e:5}],"1#1319297187":[{m:"Af1-e2",e:5}],"-1#385550953":[{m:"Hb10-a8",e:5}],"1#1550600811":[{m:"Hh1-i3",e:5}],"1#-1615886570":[{m:"Hh1-i3",e:5}],"-1#-2044623064":[{m:"a7-a6",e:5}],"1#-2113693142":[{m:"Ad1-e2",e:5}],"-1#-854947030":[{m:"Ra9-f9",e:5}],"1#169640868":[{m:"Ch3-g3",e:7.5}],"-1#-98945066":[{m:"Ra9-f9",e:5}],"1#1024212824":[{m:"Ad1-e2",e:5}],"-1#1912942168":[{m:"Hb10-a8",e:5}],"1#949120602":[{m:"Ch3-g3",e:5}],"-1#644641404":[{m:"a7-a6",e:5}],"1#575565694":[{m:"a4-a5",e:5}],"-1#203475506":[{m:"a6xa5",e:5}],"1#647233197":[{m:"Ra1xa5",e:5}],"-1#-64672113":[{m:"i7-i6",e:5}],"1#-204939184":[{m:"i4-i5",e:5}],"-1#1305999408":[{m:"i6xi5",e:5}],"1#1871562555":[{m:"Hi3-h5",e:5}],"-1#138231116":[{m:"g7-g6",e:5}],"1#2103953969":[{m:"Cf3-f5",e:5}],"-1#1674752073":[{m:"Hh10-g8",e:5}],"1#-1593160956":[{m:"Cg3-f3",e:5}],"-1#-2022361366":[{m:"Rf9-d9",e:5}],"1#841880758":[{m:"Cf5xi5",e:5}],"1#358694079":[{m:"Ra1-b1",e:5}],"-1#600689731":[{m:"Ra10-a9",e:9.615}],"1#853401343":[{m:"Rb1-b5",e:9},{m:"Rb1-b7",e:9},{m:"c4-c5",e:9},{m:"g4-g5",e:9}],"-1#302609756":[{m:"Ra9-f9",e:7.5}],"-1#-36773257":[{m:"Ra9-f9",e:6.667}],"-1#1033400666":[{m:"Ra9-f9",e:5}],"1#-91325996":[{m:"Hb1-c3",e:5}],"1#543144217":[{m:"Hb1-c3",e:5}],"-1#1913115220":[{m:"Ra10-b10",e:5}],"1#1249246413":[{m:"Ra1-b1",e:5}],"-1#2094599217":[{m:"Cb8-b4",e:5}],"1#-1055636171":[{m:"c4-c5",e:5}],"-1#235370941":[{m:"Cb4-c4",e:5}],"1#1866414324":[{m:"Hh1-i3",e:5}],"-1#1991325898":[{m:"Ch8-e8",e:5}],"1#366496241":[{m:"Ch3-h4",e:5}],"-1#-518208691":[{m:"Hh10-g8",e:5}],"1#600061952":[{m:"Ec1-e3",e:5}],"-1#-1859987927":[{m:"Rb10xb1",e:5}],"1#1561243128":[{m:"Hc3xb1",e:5}],"-1#-992610729":[{m:"Ri10-h10",e:5}],"1#-1634432090":[{m:"Hi3-g2",e:5}],"-1#-351824774":[{m:"Rh10-h6",e:5}],"1#1322265888":[{m:"Hb1-c3",e:5}],"-1#478692973":[{m:"a7-a6",e:5}],"1#413817711":[{m:"Ri1-h1",e:5}],"-1#305594463":[{m:"Cc4xg4",e:5}],"1#-1866662922":[{m:"i4-i5",e:5}],"-1#782492566":[{m:"Ha8-b6",e:5}],"1#-1418631591":[{m:"Hg2-i3",e:5}],"-1#-555583099":[{m:"Cg4-g3",e:5}],"1#1387793289":[{m:"Ch4-g4",e:5}],"-1#-817012337":[{m:"g7-g6",e:5}],"1#-1172859150":[{m:"Rh1xh6",e:5}],"-1#-1352389877":[{m:"Hg8xh6",e:5}],"1#-467983237":[{m:"Hi3-h5",e:5}],"-1#-2085888500":[{m:"g6-g5",e:5}],"1#-96847685":[{m:"Cg4-h4",e:5}],"-1#1741640381":[{m:"Hh6-g8",e:5}],"1#-100222414":[{m:"Ee3xg5",e:5}],"-1#-1080938894":[{m:"Cg3xc3",e:5}],"1#-1504323393":[{m:"Cf3-g3",e:5}],"-1#-1713398131":[{m:"Ce8xe4",e:5}],"1#1495124068":[{m:"Ke1-e2",e:5}],"-1#-103681429":[{m:"Hg8-f6",e:5}],"1#1537222360":[{m:"Cg3xg10+",e:5}],"-1#-1207209158":[{m:"Ke10-e9",e:5}],"1#1600179891":[{m:"Hb1-c3",e:9.677}],"-1#221816318":[{m:"Hb10-c8",e:9.677}],"1#472430402":[{m:"Ec1-e3",e:9.677},{m:"Ra1-b1",e:9.677},{m:"g4-g5",e:9.677}],"-1#-1362208405":[{m:"Ra10-a9",e:7.5},{m:"Hh10-g8",e:7.5},{m:"Ra10-b10",e:7.5}],"1#-1231568854":[{m:"Ad1-e2",e:5}],"-1#-107032278":[{m:"Ra9-d9",e:5}],"1#-1777415031":[{m:"g4-g5",e:5}],"1#1813422630":[{m:"Ad1-e2",e:5}],"-1#589280038":[{m:"Ch8-i8",e:5}],"1#-1766033422":[{m:"Ad1-e2",e:5}],"-1#-642423054":[{m:"g7-g6",e:5}],"1#-1393585777":[{m:"Ch3-g3",e:5}],"-1#713312190":[{m:"Ra10-a9",e:9.615},{m:"Hh10-g8",e:9.615},{m:"Ch8-f8",e:9.615}],"1#-396575501":[{m:"Rb1-b7",e:9.412},{m:"g4-g5",e:9.412},{m:"Hh1-g3",e:9.412},{m:"Rb1-b5",e:9.412}],"1#-375579241":[{m:"Hh1-i3",e:5}],"-1#-267182679":[{m:"Hh10-g8",e:5}],"1#852223716":[{m:"Ri1-h1",e:5}],"-1#945208788":[{m:"i7-i6",e:5}],"1#935031563":[{m:"Ch3-g3",e:5}],"-1#1357070767":[{m:"Hh10-i8",e:6.667},{m:"Ra10-b10",e:6.667}],"1#-661096877":[{m:"Hh1-g3",e:5}],"-1#-1759126629":[{m:"Hh10-i8",e:5}],"1#-1353190142":[{m:"c4-c5",e:6.667},{m:"Ec1-e3",e:6.667}],"-1#1615120778":[{m:"Ri10-i9",e:5}],"1#569253358":[{m:"Eg1-e3",e:5}],"-1#498146091":[{m:"Rb10-b6",e:5}],"1#1856201405":[{m:"Ad1-e2",e:5}],"1#1754361654":[{m:"Hh1-g3",e:5}],"-1#657244926":[{m:"Hh10-i8",e:5}],"1#1674806050":[{m:"Hb1-c3",e:6.667}],"-1#831252591":[{m:"Cb8-g8",e:5}],"1#1481015019":[{m:"Hb1-c3",e:7.5}],"-1#169743782":[{m:"Hb10-c8",e:7.5}],"1#453904154":[{m:"Ra1-b1",e:7.5},{m:"Hh1-i3",e:7.5}],"-1#765655014":[{m:"c7-c6",e:6.667}],"-1#41944868":[{m:"Hh10-i8",e:5}],"1#-1963249448":[{m:"Ra1-b1",e:5}],"-1#-1135099868":[{m:"i7-i6",e:5}],"1#-1279652101":[{m:"c4-c5",e:5}],"-1#2091463283":[{m:"Ec10-e8",e:5}],"1#1346056848":[{m:"Cf3-f7",e:5}],"-1#-1683399968":[{m:"Hi8-h6",e:5}],"1#1287880414":[{m:"Ch3xh8",e:5}],"-1#2093612445":[{m:"Hh6xf7",e:5}],"1#1285836188":[{m:"Ri1-h1",e:5}],"-1#1178146476":[{m:"g7-g6",e:5}],"1#862183889":[{m:"Ch8-h9",e:5}],"-1#-1229552204":[{m:"Ri10-i7",e:5}],"1#1937375082":[{m:"Ec1-e3",e:5}],"-1#-1046539965":[{m:"Ad10-e9",e:5}],"1#761145778":[{m:"Ch9-h10",e:5}],"-1#1041467667":[{m:"e7-e6",e:5}],"1#-1665008540":[{m:"Rh1-h9",e:5}],"1#-1449802268":[{m:"Hb1-c3",e:6.667}],"-1#-70406487":[{m:"Ra10-a9",e:6.667}],"1#529665638":[{m:"Hb1-c3",e:7.5}],"-1#1305109803":[{m:"Hb10-c8",e:7.5},{m:"Cb8-e8",e:7.5},{m:"Hb10-a8",e:7.5}],"1#2019709571":[{m:"Ra1-b1",e:5}],"-1#1322164863":[{m:"Hb10-c8",e:5}],"1#1608429763":[{m:"Hh1-i3",e:5}],"-1#1179693309":[{m:"Hh10-g8",e:5}],"1#-2071442512":[{m:"Ch3-g3",e:5}],"-1#-1703520362":[{m:"Hg8-f6",e:5}],"1#940016421":[{m:"Ec1-e3",e:5}],"-1#-1964937972":[{m:"Hf6xe4",e:5}],"1#-2018167897":[{m:"Cg3xg6",e:5}],"-1#-455001645":[{m:"Ch8-h3",e:5}],"1#201492154":[{m:"Hc3xe4",e:5}],"-1#101927795":[{m:"Ce8xe4+",e:5}],"1#414396004":[{m:"Ad1-e2",e:5}],"-1#1471823716":[{m:"Ri10-h10",e:5}],"1#123544873":[{m:"Ra1-b1",e:5}],"-1#837932501":[{m:"Ra10-b10",e:5}],"1#159644492":[{m:"Rb1-b5",e:5}],"-1#1361955191":[{m:"Cb8-c8",e:5}],"1#-573340907":[{m:"Rb5-f5",e:5}],"-1#1372098126":[{m:"Hh10-g8",e:5}],"1#-1827638013":[{m:"Hh1-i3",e:5}],"-1#-1969326787":[{m:"Eg10-e8",e:5}],"1#1237535170":[{m:"Eg1-e3",e:5}],"-1#-816165104":[{m:"Rb10-b6",e:5}],"1#-1136118138":[{m:"Ri1-g1",e:5}],"-1#-577413413":[{m:"Ch8-h10",e:5}],"1#-515145405":[{m:"g4-g5",e:5}],"-1#-1061844228":[{m:"g7-g6",e:9.999},{m:"Cb8-d8",e:9.999},{m:"Ch8-f8",e:9.999},{m:"Hb10-a8",e:9.999},{m:"Cb8-c8",e:9.999},{m:"Hh10-i8",e:9.999},{m:"Cb8-f8",e:9.999},{m:"Hh10-g8",e:9.999},{m:"Ec10-a8",e:9.999},{m:"Ch8-e8",e:9.999},{m:"Ch8-c8",e:9.999},{m:"c7-c6",e:9.999},{m:"Ec10-e8",e:9.999},{m:"Cb8-e8",e:9.999},{m:"Ch8-d8",e:9.999},{m:"Hb10-c8",e:9.999},{m:"Cb8-g8",e:9.999},{m:"Ad10-e9",e:9.999},{m:"Eg10-e8",e:9.999}],"1#-1242595967":[{m:"Eg1-e3",e:9.996},{m:"Ch3-g3",e:9.996},{m:"Cb3-e3",e:9.996},{m:"Ch3-e3",e:9.996},{m:"c4-c5",e:9.545},{m:"Cb3-g3",e:9.996},{m:"g4-g5",e:9.996},{m:"c4-c5",e:9.961},{m:"c4-c5",e:8.333},{m:"c4-c5",e:9.924},{m:"c4-c5",e:9.982},{m:"Cb3-f3",e:9.996},{m:"Hh1-i3",e:9.996}],"-1#863402835":[{m:"g7-g6",e:9.412}],"-1#-1424924249":[{m:"Ch8-g8",e:9.993},{m:"Hb10-c8",e:9.993}],"-1#531622427":[{m:"Eg10-e8",e:9.957},{m:"Ch8-e8",e:9.957}],"-1#-277285787":[{m:"Ch8-e8",e:9.853}],"-1#118068136":[{m:"Ch8-e8",e:8},{m:"Hh10-g8",e:8}],"1#1684071059":[{m:"Hb1-c3",e:5}],"-1#909674974":[{m:"Hb10-a8",e:5}],"1#-976131867":[{m:"c4-c5",e:7.5}],"-1#-220838995":[{m:"Ec10-e8",e:7.5}],"-1#-115045524":[{m:"g6xg5",e:5}],"-1#917334105":[{m:"Ch8-f8",e:9.231},{m:"Ch8-c8",e:9.231},{m:"g7-g6",e:8},{m:"Cb8-c8",e:9.231}],"1#-172739984":[{m:"Hh1-g3",e:5}],"1#-835907869":[{m:"Hb1-c3",e:5}],"-1#-1891683718":[{m:"Ra10-a9",e:9.6},{m:"Hh10-g8",e:9.6},{m:"g7-g6",e:8.889},{m:"Ch8-e8",e:9.6},{m:"Ec10-e8",e:9.6}],"1#-1754879173":[{m:"Hb1-c3",e:8.571},{m:"Ch3-e3",e:8.571}],"-1#-839834913":[{m:"Hb10-c8",e:5}],"1#1307035959":[{m:"Hb1-c3",e:9.375}],"-1#532652666":[{m:"Cb8-f8",e:9.375}],"1#-1641078586":[{m:"c4-c5",e:6.667}],"-1#-864597109":[{m:"g7-g6",e:8.75},{m:"Hh10-g8",e:8.571}],"1#-200973038":[{m:"Ra1-b1",e:8.333}],"-1#-1029073426":[{m:"Ch8-e8",e:8.571},{m:"Hh10-g8",e:8.571}],"1#-1581194027":[{m:"Hh1-g3",e:5}],"1#7433891":[{m:"Ch3-e3",e:9.286}],"1#246395078":[{m:"Ra1-b1",e:8.889}],"1#-329891007":[{m:"Ch3-e3",e:5}],"-1#-1228813659":[{m:"Hh10-g8",e:5}],"1#1947808232":[{m:"Hh1-g3",e:5}],"1#-1548930407":[{m:"Cb3-d3",e:9.444},{m:"Hb1-c3",e:9.929}],"-1#-235578924":[{m:"Hb10-a8",e:9.929}],"-1#-407431476":[{m:"Hh10-g8",e:9.991},{m:"Cb8-c8",e:9.991},{m:"Eg10-e8",e:9.991}],"-1#-95236023":[{m:"Ch8-f8",e:9.971},{m:"Cb8-b4",e:9.971}],"-1#-796839186":[{m:"g7-g6",e:9.091}],"-1#-1402896961":[{m:"Ch8-e8",e:7.5},{m:"g7-g6",e:8.333}],"1#-1376772593":[{m:"Eg1-e3",e:8},{m:"Hb1-c3",e:8}],"-1#728307933":[{m:"Hb10-a8",e:9.964},{m:"g7-g6",e:9.964},{m:"Ch8-e8",e:9.964},{m:"Hb10-c8",e:9.964},{m:"Hh10-g8",e:9.964}],"1#1644058847":[{m:"Hb1-c3",e:9.963}],"1#1580461984":[{m:"Hb1-c3",e:7.5}],"1#1207986662":[{m:"Hb1-c3",e:5}],"1#981011041":[{m:"Hb1-c3",e:8.571}],"1#-374217840":[{m:"g4-g5",e:5}],"-1#-5737150":[{m:"Hb10-a8",e:7.5},{m:"Hh10-g8",e:7.5}],"1#-1254148800":[{m:"Ra1-b1",e:7.5}],"-1#-2087467588":[{m:"Ra10-b10",e:7.5}],"1#-1142822107":[{m:"Cb3-b7",e:7.5}],"-1#-1486003233":[{m:"Hh10-g8",e:7.5}],"1#1030786575":[{m:"Ad1-e2",e:7.5},{m:"Ra1-b1",e:7.5}],"-1#1920573199":[{m:"Hb10-a8",e:5}],"-1#198999795":[{m:"Hb10-c8",e:6.667},{m:"Hb10-a8",e:6.667}],"1#61657301":[{m:"Ch3-e3",e:8.333},{m:"g4-g5",e:8.333},{m:"Cb3-e3",e:8.333},{m:"c4-c5",e:6.667}],"-1#1497061681":[{m:"Hb10-c8",e:5}],"1#1210796941":[{m:"Hb1-c3",e:9.889},{m:"g4-g5",e:9.889},{m:"Cb3-b7",e:9.889},{m:"Cb3-c3",e:9.889},{m:"Cb3-d3",e:9.889},{m:"Ri1-i2",e:9.889}],"-1#1332160056":[{m:"Hh10-i8",e:5}],"1#-954461756":[{m:"Hh1-g3",e:5}],"-1#-2002666484":[{m:"Ri10-h10",e:5}],"1#-757022211":[{m:"Ri1-h1",e:5}],"-1#-662857011":[{m:"Rh10-h6",e:5}],"1#2108302231":[{m:"Ch3-i3",e:5}],"-1#-1444133041":[{m:"Hb10-c8",e:5}],"1#-1191422477":[{m:"Hb1-c3",e:5}],"-1#-358334786":[{m:"Hh10-g8",e:5}],"1#679265779":[{m:"Ch3-g3",e:5}],"-1#914545109":[{m:"Ri10-h10",e:5}],"1#1824760868":[{m:"Hh1-i3",e:5}],"-1#1374993304":[{m:"Hh10-g8",e:7.5},{m:"Hb10-c8",e:7.5}],"1#-1825816363":[{m:"Ch3-e3",e:5}],"-1#-910440143":[{m:"Hb10-c8",e:5}],"1#-659825779":[{m:"Hc3-d5",e:9.811},{m:"Cb3-a3",e:9.811}],"-1#-219667024":[{m:"Ad10-e9",e:9.767}],"-1#-348794143":[{m:"Ri10-h10",e:9.091}],"1#1088727332":[{m:"Hh1-i3",e:6.667},{m:"Hh1-g3",e:6.667}],"-1#1500162330":[{m:"Hh10-g8",e:5}],"1#-1682812329":[{m:"Ri1-h1",e:5}],"-1#257492204":[{m:"g7-g6",e:5}],"1#2047079313":[{m:"Ch3-h7",e:5}],"1#-1977431298":[{m:"Ch3-e3",e:9.744},{m:"Hb1-c3",e:9.744},{m:"Cb3-e3",e:9.744}],"-1#-793427174":[{m:"Ch8-e8",e:8.889},{m:"Hb10-a8",e:9.975},{m:"Ec10-e8",e:8.889}],"1#-1277414879":[{m:"Hh1-g3",e:8}],"1#309180503":[{m:"Hh1-g3",e:8}],"1#-64535559":[{m:"Hh1-g3",e:5}],"-1#-663051853":[{m:"Eg10-e8",e:9.643},{m:"Ch8-e8",e:9.643},{m:"Hh10-g8",e:9.643},{m:"Cb8-e8",e:9.643},{m:"Hb10-a8",e:7.5},{m:"g7-g6",e:9.643},{m:"Ra10-a9",e:9.643}],"-1#543317348":[{m:"Eg10-e8",e:7.5},{m:"Hh10-g8",e:7.5}],"1#-482385509":[{m:"Hb1-c3",e:5}],"-1#-1318647082":[{m:"Ra10-a9",e:5}],"1#-1455516777":[{m:"Ra1-b1",e:5}],"1#-491084247":[{m:"Hb1-c3",e:6.667}],"-1#-1327313564":[{m:"Ra10-b10",e:6.667}],"1#1280032926":[{m:"Hb1-a3",e:9.998},{m:"Hb1-c3",e:9.998},{m:"Ra1-a2",e:9.998},{m:"c4-c5",e:9.167},{m:"Hh1-g3",e:9.998},{m:"Ad1-e2",e:9.998},{m:"Ch3-h5",e:9.998},{m:"Ec1-e3",e:9.998},{m:"Ch3-e3",e:9.998},{m:"Cb3-e3",e:9.998}],"-1#1402305734":[{m:"Hh10-g8",e:9.859}],"-1#504605651":[{m:"c7-c6",e:8.75},{m:"Hb10-a8",e:8.75}],"-1#-989181899":[{m:"Ch8-e8",e:9.091}],"-1#-892156340":[{m:"g7-g6",e:9.932},{m:"Eg10-e8",e:9.932},{m:"Ch8-e8",e:9.932},{m:"Hb10-a8",e:9.932},{m:"Hh10-g8",e:9.932}],"1#-2142927282":[{m:"Hb1-a3",e:9.921}],"-1#66481494":[{m:"Hh10-g8",e:9.891}],"-1#54710686":[{m:"Hb10-a8",e:9.778},{m:"Ec10-e8",e:9.778}],"-1#1007980189":[{m:"Hh10-g8",e:9.444}],"-1#-22204745":[{m:"Ch8-e8",e:9.895}],"-1#383535482":[{m:"Cb8-c8",e:9.286}],"-1#-435464444":[{m:"Ch8-e8",e:9.96},{m:"c7-c6",e:9.96}],"1#1221508352":[{m:"Cb3-e3",e:5}],"-1#-493999462":[{m:"Cb8-e8",e:5}],"1#-685368014":[{m:"Hh1-g3",e:5}],"-1#-1734627078":[{m:"Hb10-c8",e:5}],"1#-1987337658":[{m:"Hb1-c3",e:5}],"-1#-606877429":[{m:"Ra10-b10",e:5}],"1#-475928686":[{m:"g4-g5",e:5}],"-1#-1352003201":[{m:"Rb10-b6",e:5}],"1#-596088599":[{m:"Ra1-b1",e:5}],"-1#-355166187":[{m:"Rb6xb1",e:5}],"1#1211608355":[{m:"Hc3xb1",e:5}],"-1#-772999540":[{m:"Ch8-g8",e:5}],"1#-1491609530":[{m:"Ri1-h1",e:5}],"-1#-1383431306":[{m:"g7-g6",e:5}],"1#-657427445":[{m:"Hg3-f5",e:5}],"-1#-1910364308":[{m:"g6xg5",e:5}],"1#350678875":[{m:"Hf5-d6",e:5}],"-1#-91309835":[{m:"Ri10-i9",e:5}],"1#-1155240815":[{m:"Hb1-c3",e:5}],"-1#-377747492":[{m:"Ri9-f9",e:5}],"1#-46410178":[{m:"Ch3-h8",e:5}],"-1#-185659421":[{m:"Rf9-h9",e:5}],"1#-474172433":[{m:"Ch8-h7",e:5}],"1#-231011060":[{m:"Hb1-c3",e:9.545},{m:"Ra1-a2",e:9.545}],"-1#-1604098495":[{m:"Hb10-c8",e:9.545}],"1#-1317833475":[{m:"c4-c5",e:6.667},{m:"Hh1-g3",e:9.545}],"-1#-2015394815":[{m:"Ra10-b10",e:9.545},{m:"Ra10-a9",e:9.545},{m:"Eg10-e8",e:9.545},{m:"Ec10-e8",e:9.545},{m:"Ad10-e9",e:9.545},{m:"Hh10-g8",e:9.545},{m:"Hh10-i8",e:9.545},{m:"g7-g6",e:9.545}],"1#-1618600640":[{m:"Ch3-e3",e:5}],"1#1149417726":[{m:"g4-g5",e:5}],"1#-1420983070":[{m:"Hh1-i3",e:7.5}],"1#1797176560":[{m:"Hh1-g3",e:5}],"1#1158119244":[{m:"g4-g5",e:7.5}],"1#262452221":[{m:"Hh1-i3",e:8.333}],"1#-226135172":[{m:"Cb3-a3",e:8.571}],"-1#-19998411":[{m:"g7-g6",e:6.667},{m:"Hh10-g8",e:6.667}],"1#-1953223096":[{m:"Hc3-b5",e:7.5},{m:"Ra1-a2",e:7.5}],"-1#-1028210652":[{m:"Hh10-g8",e:6.667}],"1#7224169":[{m:"Ra1-a2",e:6.667}],"-1#47556323":[{m:"Ec10-e8",e:5}],"1#1008083576":[{m:"Hc3-d5",e:5}],"-1#374725701":[{m:"g7-g6",e:5}],"1#1661938488":[{m:"Ch3-h7",e:8},{m:"Cb3-e3",e:8}],"-1#389920130":[{m:"Ra10-b10",e:5}],"-1#-917521246":[{m:"Af10-e9",e:7.5}],"-1#2071627175":[{m:"Hb10-c8",e:5}],"1#1785370395":[{m:"Ra2-f2",e:5}],"-1#-666362313":[{m:"Ad10-e9",e:5}],"1#881403590":[{m:"Cb3-e3",e:5}],"-1#-1630949028":[{m:"Ec10-e8",e:5}],"1#-1302613569":[{m:"Hh1-g3",e:5}],"-1#-35251081":[{m:"g7-g6",e:5}],"1#-2000884982":[{m:"Rf2-f7",e:5}],"-1#1695411425":[{m:"Hh10-i8",e:5}],"1#-310977763":[{m:"i4-i5",e:5}],"-1#1399440253":[{m:"Ch8-g8",e:5}],"1#630386103":[{m:"e4-e5",e:5}],"-1#-1575155461":[{m:"Ri10-h10",e:5}],"1#-128158454":[{m:"Ch3-h7",e:5}],"-1#-1938887760":[{m:"Ra10-d10",e:5}],"1#1245768410":[{m:"Hg3-e4",e:5}],"-1#-1455595579":[{m:"Rd10-d4",e:5}],"1#40726961":[{m:"Hh1-g3",e:9.99},{m:"Ch3-g3",e:9.99},{m:"c4-c5",e:9.946},{m:"c4-c5",e:9.999},{m:"c4-c5",e:9.767},{m:"c4-c5",e:9.885},{m:"c4-c5",e:9.988},{m:"c4-c5",e:8.333},{m:"Cb3-d3",e:9.99},{m:"Hh1-i3",e:9.99}],"-1#1305533561":[{m:"g7-g6",e:8}],"1#948579076":[{m:"Cb3-d3",e:9.97},{m:"Hb1-c3",e:9.97}],"-1#479423895":[{m:"Ri10-h10",e:9},{m:"Eg10-e8",e:9},{m:"Cb8-e8",e:9}],"-1#-1473386965":[{m:"Ec10-e8",e:9.744},{m:"Hb10-c8",e:9.744},{m:"g7-g6",e:9.744},{m:"Cb8-d8",e:9.744},{m:"Ra10-a9",e:9.744},{m:"Ch8-i8",e:9.744}],"1#-2067798328":[{m:"Cb3-e3",e:9.474},{m:"Hb1-c3",e:9.906}],"-1#-1657673994":[{m:"Ri10-i9",e:9.412}],"1#-1187122025":[{m:"Hb1-c3",e:9}],"-1#-345661478":[{m:"Hh10-g8",e:9.873}],"1#-579399338":[{m:"Hb1-c3",e:9.928},{m:"Hh1-i3",e:9.928}],"1#-983010600":[{m:"Hb1-c3",e:7.5}],"-1#-1758455403":[{m:"Hb10-c8",e:9.333}],"1#-1334542486":[{m:"Hb1-c3",e:7.5}],"-1#-500427737":[{m:"Ra9-f9",e:7.5}],"1#-1781758760":[{m:"Hh1-g3",e:9}],"-1#1492842581":[{m:"Hb10-a8",e:9.975},{m:"Cb8-e8",e:9.975},{m:"Cb8-c8",e:9.975},{m:"Cb8-d8",e:9.975},{m:"g7-g6",e:9.975}],"-1#-1333026920":[{m:"Cb8-e8",e:8.75},{m:"Hh10-g8",e:8}],"1#-2061260752":[{m:"Hh1-g3",e:5}],"-1#-895613448":[{m:"Hb10-c8",e:5}],"-1#1345657596":[{m:"Ec10-e8",e:9.979},{m:"Hb10-c8",e:9.979},{m:"Hh10-g8",e:9.643},{m:"Cb8-c8",e:9.979}],"-1#-2127600535":[{m:"Hb10-a8",e:8},{m:"Ri10-h10",e:8},{m:"g7-g6",e:8}],"1#-877124501":[{m:"Hh1-g3",e:5}],"1#-613541480":[{m:"Hh1-g3",e:6.667},{m:"Cb3-c3",e:6.667}],"-1#1319536476":[{m:"Cb8-c8",e:9.979},{m:"Ri10-i9",e:9.979},{m:"Ch8-h9",e:9.979},{m:"Ec10-e8",e:9.979},{m:"Ch8-i8",e:9.979},{m:"Cb8-e8",e:9.979},{m:"Hb10-a8",e:9.979}],"1#-1034367682":[{m:"Eg1-e3",e:9.94}],"-1#951926346":[{m:"Ch8-i8",e:9.091},{m:"Hh10-g8",e:9.6},{m:"Hb10-a8",e:9.091}],"-1#467890575":[{m:"g7-g6",e:8.333},{m:"Cb8-e8",e:8.333}],"1#776685095":[{m:"Hb1-c3",e:5}],"1#1807642813":[{m:"Ch3-e3",e:5}],"-1#824834393":[{m:"Hh10-g8",e:5}],"1#-202309100":[{m:"Hh1-g3",e:5}],"-1#-1135824932":[{m:"Ri10-h10",e:5}],"1#-435301843":[{m:"Ri1-h1",e:5}],"-1#-326072035":[{m:"Ch8-h6",e:5}],"1#-681971169":[{m:"Hb1-c3",e:5}],"-1#-2063492782":[{m:"Ad10-e9",e:5}],"1#1774231971":[{m:"Hc3-d5",e:5}],"-1#1132683166":[{m:"Hb10-c8",e:5}],"1#1385385250":[{m:"Cb3-c3",e:5}],"-1#1484484155":[{m:"Ra10-b10",e:5}],"1#1611219106":[{m:"Ra1-b1",e:5}],"-1#1453699166":[{m:"g7-g6",e:5}],"1#603932451":[{m:"Rb1-b7",e:5}],"-1#53210240":[{m:"Ch6-h7",e:5}],"1#1653370628":[{m:"Rh1-h5",e:5}],"-1#-230170196":[{m:"c7-c6",e:5}],"1#824187543":[{m:"Hd5-c7",e:5}],"-1#795159281":[{m:"c6xc5",e:5}],"1#337509221":[{m:"Rh5xc5",e:5}],"-1#1207399161":[{m:"Hg8-f6",e:5}],"1#-1545798713":[{m:"Hh1-g3",e:9.964},{m:"Hb1-c3",e:9.964},{m:"Cb3-e3",e:9.964},{m:"c4-c5",e:9.997}],"-1#-329165297":[{m:"g7-g6",e:9.959},{m:"Hh10-g8",e:9.959},{m:"Ri10-i9",e:9.959},{m:"Cb8-c8",e:9.959}],"1#-1724145294":[{m:"Hb1-c3",e:5}],"1#783920450":[{m:"c4-c5",e:6.667}],"-1#606402162":[{m:"Hb10-a8",e:9.955},{m:"g7-g6",e:9.955},{m:"Cb8-d8",e:9.955},{m:"Cb8-c8",e:9.955},{m:"Ri10-h10",e:9.955},{m:"Ri10-i9",e:9.955}],"1#1857271408":[{m:"Hb1-c3",e:8.75}],"1#1367212303":[{m:"c4-c5",e:6.667}],"-1#650497552":[{m:"Cb8-b4",e:8.75},{m:"Hb10-a8",e:8.75},{m:"Ri10-i9",e:8.75},{m:"Hb10-c8",e:8.75}],"1#-1693939948":[{m:"Hb1-c3",e:6.667}],"-1#-917443495":[{m:"Cb4-c4",e:6.667},{m:"Hb10-a8",e:6.667}],"1#-1469534960":[{m:"Rh1-h5",e:5}],"-1#950215608":[{m:"Hb10-c8",e:5}],"1#699609348":[{m:"g4-g5",e:5}],"-1#1702414313":[{m:"Ra10-b10",e:5}],"1#1560996208":[{m:"Ra1-b1",e:5}],"-1#1806047628":[{m:"Rb10-b6",e:5}],"1#-2084066213":[{m:"Ec1-e3",e:7.5},{m:"Eg1-e3",e:7.5}],"-1#824263282":[{m:"Ra10-a9",e:5}],"-1#90090121":[{m:"Ri10-i9",e:6.667}],"1#1817349650":[{m:"Hb1-c3",e:6.667}],"-1#1040901471":[{m:"Cb8-d8",e:8.571},{m:"Hb10-a8",e:6.667},{m:"Ra10-a9",e:8.571}],"1#1397715372":[{m:"Ra1-b1",e:5}],"-1#1709408592":[{m:"Ra10-b10",e:5}],"1#1569828809":[{m:"Cb3-b7",e:5}],"-1#1092429619":[{m:"Ad10-e9",e:5}],"1#643005470":[{m:"a4-a5",e:7.5},{m:"Ec1-e3",e:7.5}],"-1#138271058":[{m:"Ra9-f9",e:5}],"1#-819211812":[{m:"a5-a6",e:5}],"-1#-1800039881":[{m:"Ra9-d9",e:6.667}],"1#1735334516":[{m:"Hb1-c3",e:5}],"-1#892825913":[{m:"Ri9-d9",e:6.667},{m:"Cb8-c8",e:6.667}],"1#-902571898":[{m:"Rh1-h5",e:6.667}],"-1#1526224430":[{m:"Hb10-c8",e:6.667},{m:"Hb10-a8",e:6.667}],"1#275715628":[{m:"g4-g5",e:5}],"1#-1177994405":[{m:"Rh1-h5",e:5}],"-1#688043507":[{m:"Ri9-b9",e:5}],"1#1751222332":[{m:"Hc3-d5",e:5}],"-1#1109554689":[{m:"Ce8-e9",e:5}],"1#-1378323844":[{m:"Cb3-d3",e:5}],"1#936762540":[{m:"Hb1-c3",e:6.667}],"-1#1703786465":[{m:"Hg8-f6",e:6.667},{m:"Ra10-a9",e:6.667}],"1#-939760814":[{m:"Ra1-a2",e:5}],"-1#1321069561":[{m:"Ce8-f8",e:5}],"1#-216991846":[{m:"Ra2-d2",e:5}],"-1#655635872":[{m:"Ec10-e8",e:5}],"1#193344835":[{m:"Rh1-h7",e:5}],"1#2111057568":[{m:"Cb3-b5",e:5}],"-1#1251835422":[{m:"Ra9-f9",e:5}],"1#-1920239984":[{m:"Ec1-e3",e:5}],"-1#1064147129":[{m:"e7-e6",e:5}],"1#-1648366130":[{m:"Rh1-h7",e:5}],"1#1231118977":[{m:"Hb1-c3",e:7.5}],"1#-1462060016":[{m:"Hb1-c3",e:8}],"1#2120584067":[{m:"Hb1-c3",e:9.94},{m:"Eg1-e3",e:9.94}],"1#1703813654":[{m:"g4-g5",e:9.545}],"1#-1379171733":[{m:"Ri1-h1",e:5}],"-1#-242970486":[{m:"Hh10-g8",e:9.688}],"1#861694919":[{m:"g4-g5",e:9.688},{m:"Eg1-e3",e:9.688},{m:"Hh1-i3",e:9.688},{m:"Ra1-a2",e:9.688},{m:"Ch3-f3",e:9.688}],"-1#-1245352683":[{m:"g7-g6",e:8}],"-1#161246301":[{m:"Hh10-g8",e:5}],"1#-884697328":[{m:"Hb1-c3",e:5}],"-1#-1726153635":[{m:"Ri10-h10",e:5}],"1#-1017282132":[{m:"Hh1-g3",e:5}],"-1#-1931465628":[{m:"Cb8-d8",e:5}],"1#-509233001":[{m:"Hc3-d5",e:5}],"-1#-112496093":[{m:"Hh10-g8",e:8.75},{m:"Cb8-c8",e:8.75}],"1#999524718":[{m:"Hb1-c3",e:8.571},{m:"Hh1-g3",e:8.571}],"1#1974810689":[{m:"Hb1-a3",e:9.979},{m:"Ad1-e2",e:9.979}],"1#943057990":[{m:"Hb1-c3",e:9.868},{m:"Hb1-a3",e:9.868},{m:"Cb3-e3",e:9.868},{m:"Hh1-g3",e:9.868},{m:"Eg1-e3",e:9.868},{m:"Ch3-e3",e:9.868},{m:"Ec1-e3",e:9.868}],"-1#1785562891":[{m:"Hh10-g8",e:6.667}],"1#-1464501178":[{m:"Cb3-a3",e:6.667}],"-1#669732894":[{m:"Hh10-g8",e:6.667}],"1#-449598637":[{m:"Hh1-g3",e:6.667}],"-1#-1837794340":[{m:"Hh10-g8",e:8}],"1#1353547921":[{m:"Hb1-c3",e:8}],"-1#2005418382":[{m:"Hh10-g8",e:5}],"1#-1253000509":[{m:"Ri1-h1",e:5}],"-1#-1095964012":[{m:"Hh10-g8",e:8.333}],"1#2087981529":[{m:"Hb1-c3",e:8.333},{m:"g4-g5",e:8.333}],"-1#1654810018":[{m:"Hh10-g8",e:5}],"1#-1602576657":[{m:"Hb1-c3",e:5}],"-1#-1965882769":[{m:"Ec10-e8",e:9.836},{m:"Hh10-g8",e:9.836}],"1#64123335":[{m:"c5xc6",e:9.091}],"-1#1010895379":[{m:"Ec10-e8",e:9.091}],"1#282266352":[{m:"Ch3-e3",e:9.091},{m:"Ec1-e3",e:9.091},{m:"Hh1-i3",e:9.091},{m:"c6-c7",e:9.091},{m:"Hb1-c3",e:9.091}],"-1#1246003988":[{m:"Hb10-d9",e:6.667}],"1#1080491022":[{m:"Cb3-c3",e:6.667},{m:"Cb3-d3",e:6.667}],"-1#-1573526311":[{m:"Hb10-d9",e:6.667}],"1#-1474847805":[{m:"Hb1-c3",e:6.667},{m:"Hb1-d2",e:6.667}],"-1#-95424370":[{m:"Ra10-c10",e:6.667}],"-1#157092558":[{m:"Hb10-d9",e:5}],"1#58684884":[{m:"Ri1-i2",e:5}],"-1#1446721980":[{m:"Ra10-c10",e:5}],"1#63449425":[{m:"c6-d6",e:5}],"-1#2125583428":[{m:"Hb10-d9",e:8}],"1#1955834718":[{m:"c7-d7",e:8}],"-1#850585335":[{m:"Ra10-c10",e:8}],"-1#1116430781":[{m:"Hb10-d9",e:5}],"1#1219042983":[{m:"Hb1-c3",e:6.667}],"1#-332953057":[{m:"Hb1-c3",e:9.99},{m:"g4-g5",e:9.99},{m:"Cb3-f3",e:9.99},{m:"Eg1-e3",e:9.99},{m:"Cb3-e3",e:9.99},{m:"c4-c5",e:8.75},{m:"c4-c5",e:9.697},{m:"Cb3-d3",e:9.99},{m:"Hh1-g3",e:9.99},{m:"Ch3-d3",e:9.99},{m:"c4-c5",e:5}],"-1#-1098915502":[{m:"Hh10-i8",e:9.979},{m:"Hb10-c8",e:9.979}],"-1#-1595114254":[{m:"Hh10-i8",e:8.333},{m:"Ch8-g8",e:8.333}],"-1#-1991654032":[{m:"g7-g6",e:8.333},{m:"Hh10-i8",e:8.333}],"-1#1790872781":[{m:"g7-g6",e:9.697},{m:"Hb10-d9",e:9.697}],"-1#1181162885":[{m:"g7-g6",e:9.94}],"-1#1589732406":[{m:"g7-g6",e:8.75},{m:"Hh10-i8",e:8.75}],"1#731616075":[{m:"Hb1-c3",e:8.571}],"1#-692431926":[{m:"i4-i5",e:5}],"-1#-1229978629":[{m:"Ri10-i9",e:9.891},{m:"g7-g6",e:9.891},{m:"Hh10-g8",e:9.891},{m:"Cb8-c8",e:9.891},{m:"Hb10-d9",e:9.891}],"1#-149235809":[{m:"Hh1-g3",e:8.571}],"-1#-1196983721":[{m:"c7-c6",e:8.571}],"1#-1008012154":[{m:"Cb3-d3",e:9.444},{m:"Hh1-g3",e:9.444}],"-1#-1940432562":[{m:"Hh10-g8",e:9.412}],"1#1953036470":[{m:"Hh1-g3",e:9.851},{m:"Hb1-c3",e:9.851}],"-1#640717819":[{m:"Ri10-i9",e:8}],"1#978209177":[{m:"Ad1-e2",e:9.996},{m:"Ec1-a3",e:9.996},{m:"Hh1-g3",e:9.996}],"1#-1131250463":[{m:"Hh1-g3",e:6.667}],"-1#-214970071":[{m:"Ra10-c10",e:6.667}],"-1#-688405020":[{m:"Hh10-i8",e:9.944},{m:"Hb10-c8",e:9.944}],"-1#-1550178345":[{m:"g7-g6",e:8}],"-1#1868931015":[{m:"g7-g6",e:8},{m:"Hb10-c8",e:8}],"-1#-173438431":[{m:"i7-i6",e:9.778},{m:"Hh10-i8",e:9.778},{m:"Cb8-c8",e:9.778},{m:"g7-g6",e:9.778},{m:"Hh10-g8",e:9.778}],"1#-96189186":[{m:"Ec1-e3",e:9},{m:"Ch3-f3",e:9},{m:"Ch3-g3",e:9},{m:"Cb3-e3",e:9}],"-1#1218620119":[{m:"Hh10-i8",e:5}],"1#-1059480277":[{m:"Ri1-i2",e:5}],"-1#-552070585":[{m:"Hh10-i8",e:5}],"1#1466115515":[{m:"Ri1-h1",e:5}],"-1#-457549608":[{m:"Hh10-i8",e:7.5}],"1#1824616228":[{m:"Ri1-h1",e:7.5}],"-1#1342493540":[{m:"Hb10-d9",e:8},{m:"Hh10-i8",e:8}],"1#2110963165":[{m:"Cb3-e3",e:6.667}],"-1#-678286777":[{m:"Ri10-i9",e:6.667},{m:"Hb10-d9",e:6.667}],"1#-1774649821":[{m:"Hb1-c3",e:5}],"-1#-1000303250":[{m:"Ri9-d9",e:5}],"1#996424913":[{m:"i4-i5",e:5}],"-1#-2055527247":[{m:"Rd9-d4",e:5}],"1#-575646371":[{m:"Ri1-i2",e:5}],"-1#-1997268683":[{m:"Ad10-e9",e:5}],"1#1681203652":[{m:"Hb1-c3",e:5}],"-1#913132169":[{m:"Cb8-b10",e:5}],"1#2035793987":[{m:"Ec1-e3",e:5}],"-1#-877580694":[{m:"Hh10-g8",e:5}],"1#157930791":[{m:"Hb1-c3",e:5}],"-1#1529986666":[{m:"Ch8-i8",e:5}],"1#1724963993":[{m:"Ri1-h1",e:5}],"-1#1817020329":[{m:"Ri10-h10",e:5}],"1#906820184":[{m:"Ra1-b1",e:5}],"-1#10488484":[{m:"Rh10-h6",e:5}],"1#-1518881794":[{m:"Ch3-g3",e:5}],"-1#-1148604456":[{m:"Rh6-b6",e:5}],"1#1186928317":[{m:"Rh1-h5",e:5}],"-1#-697001963":[{m:"Hb10-a8",e:5}],"1#-2131526308":[{m:"Ch3-g3",e:9.333}],"-1#-1643290246":[{m:"Hh10-g8",e:9.951},{m:"Ch8-h4",e:9.951},{m:"i7-i6",e:9.951},{m:"Hb10-d9",e:9.951},{m:"Cb8-c8",e:9.951},{m:"Ri10-i9",e:9.951},{m:"Hh10-i8",e:9.951}],"1#1557502519":[{m:"Ri1-h1",e:9.941}],"1#-1148954096":[{m:"Cb3-e3",e:9.412}],"1#-542657250":[{m:"Ri1-h1",e:5}],"1#930181484":[{m:"Ch3-f3",e:9.474},{m:"Ch3-g3",e:9.474},{m:"Hb1-c3",e:9.474},{m:"Cb3-e3",e:9.474}],"-1#304949205":[{m:"Ri10-i9",e:5}],"1#1401418673":[{m:"Ri1-h1",e:5}],"-1#697265482":[{m:"Ch8-h6",e:9.286},{m:"Ri10-h10",e:9.286}],"-1#1697192481":[{m:"Ri10-i9",e:8.571},{m:"g7-g6",e:8.571}],"1#-182600364":[{m:"Hb1-c3",e:9.796},{m:"Ch3-e3",e:9.796},{m:"Hh1-g3",e:9.796}],"-1#-1488595431":[{m:"Ra10-a9",e:9.792},{m:"Hb10-c8",e:9.792},{m:"Hh10-g8",e:9.792}],"1#-1088663720":[{m:"Ra1-b1",e:6.667},{m:"Hh1-g3",e:6.667}],"1#-1235893083":[{m:"c4-c5",e:8.75},{m:"Hb1-c3",e:8}],"-1#-2131151783":[{m:"Hh10-i8",e:9.783},{m:"Ra10-a9",e:9.783},{m:"Ra10-b10",e:9.783}],"-1#-102209171":[{m:"Hh10-g8",e:8}],"1#1704799572":[{m:"g4-g5",e:5}],"-1#693558201":[{m:"Hb10-c8",e:9.565}],"-1#-1349897040":[{m:"Hb10-c8",e:6.667}],"1#-1097193972":[{m:"Hb1-c3",e:6.667}],"-1#-322810559":[{m:"Ra10-b10",e:6.667}],"1#-726637608":[{m:"Ra1-b1",e:6.667},{m:"Hh1-g3",e:6.667}],"-1#-501443804":[{m:"Rb10-b4",e:5}],"1#523987653":[{m:"Cb3-a3",e:5}],"-1#-1693594096":[{m:"Hh10-i8",e:5}],"1#326564332":[{m:"Ra1-b1",e:6.667}],"-1#-1163915108":[{m:"Hb10-c8",e:8}],"1#-1414528480":[{m:"Cb3-d3",e:8},{m:"Ec1-e3",e:8},{m:"Hb1-c3",e:8}],"-1#-1855959589":[{m:"Ra10-a9",e:6.667},{m:"Ra10-b10",e:6.667}],"-1#425126921":[{m:"Ra10-b10",e:5}],"1#-683269327":[{m:"Eg1-e3",e:9.945},{m:"Ri1-i2",e:9.945},{m:"c4-c5",e:9.091},{m:"Cb3-d3",e:9.945},{m:"Hh1-g3",e:9.945},{m:"Ch3-e3",e:9.945},{m:"c4-c5",e:8.333},{m:"Hh1-i3",e:9.945}],"-1#1373578723":[{m:"Hh10-g8",e:9.959},{m:"Ch8-d8",e:5}],"1#457729505":[{m:"Hb1-c3",e:6.667},{m:"Ri1-i2",e:6.667}],"-1#1225789100":[{m:"Hh10-g8",e:6.667}],"-1#-2113769639":[{m:"Hh10-g8",e:8}],"1#1088066580":[{m:"Ri2-d2",e:8}],"-1#-285787913":[{m:"Ad10-e9",e:8}],"-1#1705037080":[{m:"Hh10-g8",e:8.75}],"1#-1485293995":[{m:"Hb1-c3",e:8.75},{m:"Hh1-i3",e:8.75},{m:"Ch3-f3",e:8.75},{m:"Hh1-g3",e:8.75}],"-1#-308908854":[{m:"Hb10-a8",e:5}],"1#-1493095224":[{m:"Hb1-c3",e:5}],"-1#-178698363":[{m:"Hh10-g8",e:5}],"-1#-1728344327":[{m:"Hh10-g8",e:9.929},{m:"Ri10-i9",e:9.929}],"-1#-1915639083":[{m:"Hh10-g8",e:9.231}],"1#1326010776":[{m:"Hh1-g3",e:9.231}],"-1#11861072":[{m:"Ri10-h10",e:9.231}],"-1#-2061612932":[{m:"Hh10-g8",e:9.167}],"1#1204204337":[{m:"Hh1-g3",e:9.167},{m:"Hh1-i3",e:9.167},{m:"Eg1-e3",e:9.167},{m:"Ch3-e3",e:9.167}],"-1#1581822735":[{m:"Hb10-a8",e:6.667}],"-1#-1050692125":[{m:"Ec10-e8",e:9.89}],"-1#491862741":[{m:"Ri10-h10",e:6.667}],"-1#-825744625":[{m:"Hh10-g8",e:8.75}],"1#202430530":[{m:"Ri1-h1",e:8.75}],"1#-777676736":[{m:"c4-c5",e:7.5},{m:"c4-c5",e:9.986}],"-1#-2080509171":[{m:"g7-g6",e:9.412},{m:"Ch8-e8",e:9.412},{m:"Hh10-i8",e:9.412}],"1#-156826512":[{m:"Hc3-d5",e:9.444},{m:"Ch3-h7",e:9.444},{m:"Hh1-g3",e:9.444},{
m:"Ch3-e3",e:9.444},{m:"Ra1-a2",e:9.444}],"1#-527138250":[{m:"Hh1-g3",e:5}],"-1#-1356255234":[{m:"Hh10-g8",e:5}],"1#1844565171":[{m:"Ri1-h1",e:5}],"-1#1735167875":[{m:"Ra10-a9",e:5}],"1#2134185666":[{m:"Cb3-a3",e:5}],"1#193381617":[{m:"Hh1-g3",e:8},{m:"Ch3-e3",e:8},{m:"i4-i5",e:8}],"-1#1144744249":[{m:"Ri10-i9",e:6.667},{m:"Ec10-e8",e:6.667}],"-1#1360088341":[{m:"Ec10-e8",e:6.667}],"-1#-1248207727":[{m:"Ri10-i9",e:5}],"-1#2078609370":[{m:"g7-g6",e:9.855},{m:"Ra10-b10",e:9.855},{m:"Cb8-a8",e:9.855}],"1#247462055":[{m:"Ch3-h7",e:9.917},{m:"Hb1-c3",e:9.917}],"-1#2056087069":[{m:"Hh10-g8",e:5}],"1#-1202348720":[{m:"Hb1-c3",e:5}],"-1#1558680554":[{m:"Cb8-b9",e:9.917}],"1#1133977923":[{m:"Hb1-c3",e:9.787}],"-1#298797582":[{m:"Ch8-e8",e:9.873},{m:"Hh10-g8",e:9.873},{m:"g7-g6",e:9.873},{m:"Ra10-b10",e:5}],"1#-657622578":[{m:"Hb1-c3",e:5},{m:"g4-g5",e:9.714}],"-1#-1754213370":[{m:"g7-g6",e:9.545},{m:"Hh10-g8",e:9.545}],"1#-1293468646":[{m:"Hb1-c3",e:5}],"-1#-524331177":[{m:"Ra10-b10",e:5}],"1#-911281979":[{m:"Hb1-c3",e:5}],"-1#-1678337144":[{m:"Hb10-c8",e:5}],"1#-1964603084":[{m:"Ra1-b1",e:5}],"-1#-1135969848":[{m:"Eg10-e8",e:5}],"1#2132231479":[{m:"Hh1-i3",e:5}],"-1#1721320713":[{m:"Ra10-a9",e:5}],"1#2126568520":[{m:"Ch3-g3",e:5}],"-1#1614725230":[{m:"Hh10-f9",e:5}],"1#-1755337363":[{m:"Ri1-i2",e:5}],"-1#-1038360315":[{m:"c7-c6",e:5}],"1#24910398":[{m:"c5xc6",e:5}],"-1#1055875562":[{m:"Ee8xc6",e:5}],"1#1412756762":[{m:"Ec1-e3",e:5}],"-1#-422438093":[{m:"Ri10-h10",e:5}],"1#-1131190590":[{m:"Ri2-f2",e:5}],"-1#-1337545544":[{m:"Cg8-e8",e:5}],"1#-1859594664":[{m:"Ad1-e2",e:5}],"-1#-568211624":[{m:"Rh10-h9",e:5}],"1#-620546990":[{m:"Hc3-d5",e:5}],"-1#-247412113":[{m:"Ce8xe4",e:5}],"1#-1288858658":[{m:"Rf2-f8",e:5}],"-1#-833021417":[{m:"Ec6-e8",e:5}],"1#-175396496":[{m:"Cg3-h3",e:5}],"1#745845261":[{m:"Hb1-c3",e:5}],"-1#2116868416":[{m:"Hb10-c8",e:5}],"1#1866255356":[{m:"Hh1-g3",e:5}],"-1#545351220":[{m:"g7-g6",e:5}],"1#1440452937":[{m:"Ec1-e3",e:5}],"-1#-415400096":[{m:"Hh10-g8",e:5}],"1#635798573":[{m:"Ch3-h7",e:5}],"-1#1373051543":[{m:"Hg8-h6",e:5}],"1#-870387176":[{m:"Ch7xc7",e:5}],"-1#-819510831":[{m:"Ec10-e8",e:5}],"1#-474660558":[{m:"Cb3-a3",e:5}],"-1#-802469794":[{m:"Ri10-i9",e:5}],"1#-1853776838":[{m:"Ra1-b1",e:5}],"-1#-1490195258":[{m:"Cb8-a8",e:5}],"1#1848598278":[{m:"Ri1-i2",e:5}],"-1#996873070":[{m:"Ri9-f9",e:5}],"1#791462540":[{m:"Ri2-d2",e:5}],"-1#-2130612625":[{m:"Rf9-f6",e:5}],"1#898666191":[{m:"Rb1-b8",e:5}],"-1#473737333":[{m:"Hh6xg4",e:5}],"1#-1053123784":[{m:"Ca3xa7",e:5}],"-1#-1811922137":[{m:"Ca8xa4",e:5}],"1#1077744898":[{m:"Cc7xi7",e:5}],"1#65582595":[{m:"Hb1-c3",e:9.867},{m:"c4-c5",e:7.5},{m:"Cb3-e3",e:9.867},{m:"Ch3-e3",e:9.867},{m:"Ch3-d3",e:9.867}],"-1#1370545486":[{m:"Hh10-f9",e:9.811},{m:"Eg10-e8",e:9.643},{m:"Hh10-g8",e:9.811},{m:"Hb10-c8",e:9.811},{m:"Eg10-e8",e:9.991}],"-1#960035320":[{m:"Ra10-a9",e:6.667},{m:"Hh10-g8",e:6.667}],"1#560029881":[{m:"Hb1-c3",e:5}],"-1#1933118452":[{m:"Ra9-d9",e:5}],"1#480843351":[{m:"Af1-e2",e:5}],"-1#1156643997":[{m:"Cb8-c8",e:5}],"1#-938559745":[{m:"Ra1-b1",e:5}],"-1#-22919677":[{m:"Hb10-a8",e:5}],"1#-1271593471":[{m:"Ch3-e3",e:5}],"-1#-291336219":[{m:"Hh10-f9",e:5}],"1#432268006":[{m:"Hh1-g3",e:5}],"-1#1451118382":[{m:"Rd9-d4",e:5}],"1#-69205323":[{m:"Hb1-c3",e:5}],"-1#-1447532040":[{m:"Hb10-a8",e:5}],"1#-483448326":[{m:"Ra1-b1",e:5}],"-1#-712779514":[{m:"Ra10-b10",e:5}],"1#-302909537":[{m:"g4-g5",e:5}],"-1#-1590034062":[{m:"a7-a6",e:5}],"1#-1525146512":[{m:"Hh1-g3",e:5}],"-1#-358239816":[{m:"Af10-e9",e:5}],"1#-435260118":[{m:"Eg1-e3",e:5}],"-1#1620538360":[{m:"Ri10-f10",e:5}],"-1#-1448599143":[{m:"Hb10-c8",e:8.75},{m:"Hh10-f9",e:8.75},{m:"Ra10-a9",e:8.75}],"1#1590250650":[{m:"Hb1-c3",e:5}],"-1#1501511655":[{m:"Cb8-c8",e:9.286},{m:"Hb10-c8",e:9.286},{m:"Hh10-g8",e:9.286}],"1#-1683503958":[{m:"Hh1-g3",e:9}],"-1#-2136300581":[{m:"Ri10-i9",e:5}],"1#-1056933953":[{m:"Hh1-g3",e:5}],"-1#-1900160393":[{m:"c7-c6",e:5}],"1#1306141004":[{m:"Ri1-h1",e:5}],"-1#-1511644690":[{m:"Eg10-e8",e:9.99},{m:"Ec10-e8",e:9.99},{m:"Hb10-c8",e:9.99},{m:"Ch8-e8",e:9.99},{m:"Cb8-e8",e:9.99},{m:"Hh10-g8",e:9.99}],"1#1723538705":[{m:"Hb1-c3",e:6.667}],"-1#887322204":[{m:"Hb10-c8",e:6.667},{m:"Af10-e9",e:6.667}],"1#636708064":[{m:"Ra1-b1",e:5}],"-1#325030940":[{m:"Ra10-b10",e:5}],"1#724417157":[{m:"Hh1-g3",e:6.667},{m:"c4-c5",e:6.667}],"-1#1687164749":[{m:"c7-c6",e:5}],"1#-1476924298":[{m:"Rb1-b7",e:5}],"-1#-2027730987":[{m:"Hh10-f9",e:5}],"1#1883384534":[{m:"e4-e5",e:5}],"-1#-137506918":[{m:"Cb8-a8",e:5}],"1#1053817946":[{m:"Rb7xb10",e:5}],"-1#-1826849397":[{m:"Hc8xb10",e:5}],"1#360265991":[{m:"Ri1-i2",e:5}],"-1#1077769583":[{m:"Hb10-c8",e:5}],"1#1361930195":[{m:"Ri2-f2",e:5}],"-1#1576578473":[{m:"Ri10-i9",e:5}],"1#475167181":[{m:"Hg3-e4",e:5}],"-1#-13644590":[{m:"Ch8-h4",e:5}],"1#-626591816":[{m:"e5-e6",e:5}],"-1#1347092501":[{m:"Ch4xe4+",e:5}],"1#79664162":[{m:"Hc3xe4",e:5}],"-1#-465664499":[{m:"g7-g6",e:7.5},{m:"Cb8-b6",e:7.5}],"1#-1855688336":[{m:"Ch3-h7",e:6.667}],"-1#-447287350":[{m:"Hh10-g8",e:6.667}],"1#663622791":[{m:"Hh1-g3",e:7.5}],"-1#1748220239":[{m:"Hg8-f6",e:7.5},{m:"Hg8-h6",e:7.5},{m:"Ad10-e9",e:7.5}],"1#-2064481858":[{m:"Ch7xc7",e:5}],"1#701839154":[{m:"Hh1-i3",e:5}],"-1#811284236":[{m:"Hh10-f9",e:5}],"1#-952477169":[{m:"Ch3-g3",e:5}],"-1#-641448407":[{m:"i7-i6",e:5}],"1#-701921034":[{m:"Ri1-h1",e:5}],"-1#-592129082":[{m:"Af10-e9",e:5}],"1#-803268780":[{m:"Rh1-h5",e:5}],"1#944288462":[{m:"Ra1-b1",e:5}],"-1#249840178":[{m:"a7-a6",e:5}],"1#180772656":[{m:"Hh1-g3",e:5}],"-1#1165751032":[{m:"a6-a5",e:5}],"1#-184457980":[{m:"a4xa5",e:5}],"-1#1296418293":[{m:"Ra10xa5",e:5}],"1#1277368134":[{m:"e4-e5",e:5}],"-1#-877858294":[{m:"Hb10-a8",e:5}],"1#-2126794232":[{m:"Hg3-e4",e:5}],"-1#1648756503":[{m:"Cb8-d8",e:5}],"1#251892708":[{m:"Ch3-h5",e:5}],"-1#2136792551":[{m:"Ra5-a6",e:5}],"1#-2061299011":[{m:"Ch5-i5",e:5}],"-1#1869087807":[{m:"Hh10-i8",e:5}],"1#-418171965":[{m:"Ri1-h1",e:5}],"-1#-309434125":[{m:"i7-i6",e:5}],"1#-496785876":[{m:"Ci5xi8",e:5}],"-1#-864562803":[{m:"Ri10xi8",e:5}],"1#-1619876456":[{m:"Rh1-h7",e:5}],"-1#630767589":[{m:"Ri8-i10",e:5}],"1#2128454006":[{m:"Rh7xg7",e:5}],"-1#244909975":[{m:"Ri10-f10",e:5}],"1#-2024951725":[{m:"He4-g5",e:5}],"-1#-1170302529":[{m:"Ra6-d6",e:5}],"1#1811027217":[{m:"Ad1-e2",e:5}],"-1#620430353":[{m:"Ha8-b6",e:5}],"1#-1591115298":[{m:"Ce3xe7",e:5}],"-1#109558912":[{m:"Cd8-b8",e:5}],"1#1807886451":[{m:"Rb1-a1",e:5}],"-1#1567545487":[{m:"Hb6-d5",e:5}],"1#-1644216072":[{m:"e5-e6",e:5}],"-1#387102549":[{m:"Rd6-d7",e:5}],"1#1161278246":[{m:"Hc3-d1",e:5}],"-1#-1156379316":[{m:"Hd5-f4",e:5}],"1#781661065":[{m:"Hd1-e3",e:5}],"-1#1450409918":[{m:"Ch8-h3",e:5}],"1#-1988878067":[{m:"Hb1-c3",e:5}],"-1#-617854400":[{m:"Hb10-d9",e:5}],"1#-787597990":[{m:"Ra1-b1",e:5}],"-1#-408762970":[{m:"Hh10-i8",e:5}],"1#1876554330":[{m:"Hh1-g3",e:5}],"-1#543448978":[{m:"Ri10-i9",e:5}],"1#1640926198":[{m:"Ri1-i2",e:5}],"-1#881510302":[{m:"Ri9-f9",e:5}],"1#550311548":[{m:"Ri2-d2",e:5}],"-1#-1897874785":[{m:"Ra10-a9",e:5}],"1#-1766251554":[{m:"Rd2-d5",e:5}],"-1#-323751060":[{m:"Rf9-f4",e:5}],"1#-2093178385":[{m:"Hc3-e2",e:5}],"-1#-1470854296":[{m:"Rf4xg4",e:5}],"1#1887413181":[{m:"Ce3-d3",e:5}],"-1#-47035219":[{m:"Cb8-d8",e:5}],"1#-1871194018":[{m:"Cd3xd8",e:5}],"-1#1235538747":[{m:"Ch8xd8",e:5}],"1#868519294":[{m:"Rd5xd8",e:5}],"-1#-625247119":[{m:"Hd9-f8",e:5}],"1#261530704":[{m:"Rb1-b10",e:5}],"-1#-670052371":[{m:"Af10-e9",e:5}],"1#-727446657":[{m:"Rd8-d5",e:5}],"-1#237715026":[{m:"Hf8-g6",e:5}],"1#152801424":[{m:"Rb10-b5",e:5}],"-1#-1678639513":[{m:"Ae9-f10",e:5}],"1#-1755694347":[{m:"Rd5-g5",e:5}],"-1#-437274735":[{m:"Rg4xi4",e:5}],"1#322987652":[{m:"Ch3-h9",e:5}],"-1#-2103645107":[{m:"Ri4-h4",e:5}],"1#-48960523":[{m:"Ch9-b9",e:5}],"-1#85426462":[{m:"Af10-e9",e:5}],"1#163333516":[{m:"Hg3-f5",e:5}],"-1#1598953195":[{m:"Rh4xe4",e:5}],"1#887575628":[{m:"Cb9-b10+",e:5}],"-1#-1880426474":[{m:"Ee8-c10",e:5}],"1#-1552353035":[{m:"Hf5xg7",e:5}],"-1#-509974978":[{m:"Hi8xg7",e:5}],"1#864904852":[{m:"Rg5xg6",e:5}],"-1#-473462136":[{m:"Hg7-e8",e:5}],"1#-1989922914":[{m:"Rg6xg10+",e:5}],"-1#-1838137645":[{m:"Ae9-f10",e:5}],"1#-1629750719":[{m:"Rb5-b8",e:5}],"-1#-234563151":[{m:"Ke10-e9",e:5}],"1#-746003948":[{m:"Rb8xe8+",e:5}],"-1#1489360638":[],"1#-1258933422":[{m:"g4-g5",e:9.986},{m:"Hh1-i3",e:9.986},{m:"Hb1-c3",e:9.986},{m:"c4-c5",e:9.986},{m:"Hh1-g3",e:9.986}],"-1#-130169409":[{m:"Ra10-b10",e:9.722},{m:"c7-c6",e:9.722}],"1#-1068504282":[{m:"Hb1-c3",e:9.333},{m:"Ra1-a2",e:9.333}],"-1#-1843953557":[{m:"Hh10-g8",e:9.892},{m:"Ch8-e8",e:9.892},{m:"Cb8-a8",e:9.892}],"-1#1225679757":[{m:"Cb8-a8",e:5}],"1#-2146676659":[{m:"Hb1-c3",e:5}],"1#995769988":[{m:"Hb1-c3",e:9.643},{m:"Hh1-g3",e:9.643}],"-1#1761760713":[{m:"Hh10-g8",e:9.787},{m:"Eg10-e8",e:9.787},{m:"Ra10-b10",e:9.787}],"-1#1961333580":[{m:"Ch8-f8",e:9.73},{m:"Eg10-e8",e:9.73}],"-1#-1384631444":[{m:"Hh10-g8",e:5}],"1#1872807969":[{m:"e4-e5",e:5}],"-1#-399561363":[{m:"Ad10-e9",e:5}],"1#82711964":[{m:"Ri1-i2",e:5}],"-1#1370118644":[{m:"Ec10-e8",e:5}],"1#2100844823":[{m:"Ri2-f2",e:5}],"-1#1911395181":[{m:"c7-c6",e:5}],"1#-1299552170":[{m:"Hb1-c3",e:5}],"-1#-523107557":[{m:"Hc8-b6",e:5}],"1#1049089130":[{m:"Ch3-h4",e:5}],"-1#-901554474":[{m:"Ch8-i8",e:5}],"1#-140362715":[{m:"Rf2-f6",e:5}],"-1#-1239040593":[{m:"Ra10-d10",e:5}],"1#1879817413":[{m:"Rf6xc6",e:5}],"-1#1865829630":[{m:"Ee8xc6",e:5}],"1#-610291856":[{m:"Hi3-g2",e:5}],"-1#-1374900052":[{m:"Ec6-e8",e:5}],"-1#-424781793":[{m:"g7-g6",e:9.984},{m:"c7-c6",e:9.984},{m:"Ch8-e8",e:9.984},{m:"Ra10-b10",e:9.984},{m:"Hb10-c8",e:9.939},{m:"Ra10-a9",e:9.984},{m:"Cb8-b6",e:9.984}],"1#-1812680862":[{m:"Ra1-a2",e:9.643},{m:"Ra1-b1",e:9.643}],"1#633971492":[{m:"Hb1-c3",e:6.667},{m:"Ra1-b1",e:9.861}],"-1#1011327770":[{m:"Hh10-g8",e:7.5},{m:"Ra10-b10",e:7.5}],"1#-23111593":[{m:"Ra1-b1",e:5}],"-1#-936138581":[{m:"Ra10-b10",e:5}],"1#-264141262":[{m:"Rb1-b7",e:9.524},{m:"Ch3-g3",e:9.524},{m:"Ch3-f3",e:9.524},{m:"g4-g5",e:9.524}],"1#70618499":[{m:"Ch3-g3",e:6.667},{m:"Ra1-b1",e:6.667}],"-1#449548709":[{m:"Hh10-g8",e:6.667},{m:"Hh10-i8",e:6.667}],"-1#848919935":[{m:"Cb8-b4",e:6.667}],"1#-1890306949":[{m:"Ri1-i2",e:6.667}],"1#-2050545372":[{m:"Ra1-b1",e:6.667}],"1#-555977082":[{m:"Ra1-a2",e:9.98}],"1#611754834":[{m:"Hh1-g3",e:9.767}],"1#-17317538":[{m:"Hh1-g3",e:6.667},{m:"Ra1-b1",e:6.667}],"1#726001952":[{m:"Ra1-b1",e:5}],"-1#-78930278":[{m:"Ra10-b10",e:7.5},{m:"Hb10-c8",e:6.667}],"1#-1019629565":[{m:"c4-c5",e:6.667},{m:"Ri1-i2",e:6.667}],"-1#204115083":[{m:"Cb8-a8",e:5}],"1#-987185333":[{m:"Hb1-c3",e:5}],"-1#-1770128277":[{m:"Hh10-g8",e:5}],"1#1420101414":[{m:"g4-g5",e:6.667},{m:"Hb1-c3",e:6.667}],"-1#409924043":[{m:"c7-c6",e:5}],"1#-620164368":[{m:"Hg3-f5",e:5}],"-1#117271659":[{m:"c7-c6",e:5}],"1#-979724464":[{m:"Ri2-f2",e:5}],"1#965961175":[{m:"Ri1-i2",e:6.667},{m:"g4-g5",e:6.667}],"-1#1826040255":[{m:"Hh10-g8",e:5}],"-1#1968739130":[{m:"c7-c6",e:5}],"1#-1237358591":[{m:"Hg3-h5",e:9.545},{m:"Hb1-c3",e:9.545},{m:"Hb1-a3",e:9.545}],"1#-963686187":[{m:"Ce3xe7+",e:8.333},{m:"Hb1-c3",e:8.333}],"-1#1629580683":[{m:"Af10-e9",e:5}],"1#1837803801":[{m:"Hb1-c3",e:5}],"-1#1070776916":[{m:"Hb10-c8",e:5}],"1#784519400":[{m:"Ce7-e6",e:5}],"-1#-718918195":[{m:"Ra10-b10",e:5}],"1#-313261228":[{m:"Ri1-i2",e:5}],"-1#-1206890692":[{m:"Hh10-g8",e:5}],"1#2059973745":[{m:"Ri2-f2",e:5}],"-1#1981644299":[{m:"Ri10-h10",e:5}],"1#744227834":[{m:"Rf2-f3",e:5}],"-1#-275638286":[{m:"Cb8-b3",e:5}],"1#-1052231878":[{m:"Eg1-e3",e:5}],"-1#1204892136":[{m:"Rb10-b6",e:5}],"1#885213310":[{m:"Rf3-f6",e:5}],"-1#-1420301683":[{m:"Rh10xh3",e:5}],"1#-1921748855":[{m:"Hh1-f2",e:5}],"-1#-1155419624":[{m:"Rh3-h5",e:5}],"1#-1573392563":[{m:"g4-g5",e:5}],"-1#-285468256":[{m:"Rh5-h2",e:5}],"1#1764423068":[{m:"Ra1-a2",e:5}],"-1#-529826505":[{m:"Eg10-i8",e:5}],"1#-1101040035":[{m:"c4-c5",e:5}],"-1#1900825301":[{m:"g7-g6",e:5}],"1#68599208":[{m:"Rf6-f8",e:5}],"-1#624460442":[{m:"Rb6xe6",e:5}],"1#1566600207":[{m:"Rf8xg8",e:5}],"-1#-1874161047":[{m:"Re6-f6",e:5}],"1#-1076470068":[{m:"Rg8xi8",e:5}],"-1#-1980285808":[{m:"Ce8-f8",e:5}],"1#878321907":[{m:"Hc3-d5",e:5}],"-1#505011918":[{m:"Rf6-f3",e:5}],"1#-1023579481":[{m:"Hd5-f6",e:5}],"-1#1809846547":[{m:"Rf3xf6",e:5}],"1#-1246096149":[{m:"g5xg6",e:5}],"-1#-560526083":[{m:"Rf6-f3",e:5}],"1#41138324":[{m:"Ad1-e2",e:5}],"-1#-1797833832":[{m:"Hh10-g8",e:8},{m:"Hb10-a8",e:8}],"1#1443872981":[{m:"Hb1-c3",e:6.667},{m:"Ra1-b1",e:7.5}],"-1#1333903595":[{m:"Hb10-c8",e:7.5},{m:"Ri10-h10",e:7.5}],"1#1586614871":[{m:"Ra1-b1",e:6.667}],"-1#1748837035":[{m:"Ri10-h10",e:6.667},{m:"Ra10-b10",e:6.667}],"1#847011674":[{m:"Ri1-h1",e:5}],"-1#954270826":[{m:"Ra10-b10",e:5}],"1#9644787":[{m:"Rb1-b7",e:5}],"-1#541557072":[{m:"Cb8-a8",e:5}],"1#-381308272":[{m:"Rb7xc7",e:5}],"1#1347357746":[{m:"Rb1-b7",e:5}],"-1#1889249169":[{m:"Cb8-a8",e:5}],"1#-1181117359":[{m:"Rb7xc7",e:5}],"-1#-843664227":[{m:"Rb10-b8",e:5}],"1#-993410932":[{m:"Ri1-h1",e:5}],"1#364952858":[{m:"Ra1-b1",e:5}],"-1#594300390":[{m:"Rh10xh3",e:5}],"1#89118690":[{m:"Rb1xb8",e:5}],"-1#-2110648557":[{m:"Hb10-a8",e:5}],"1#-928690415":[{m:"Ri1-h1",e:5}],"-1#-1036512223":[{m:"Rh3xh1",e:5}],"1#1329724818":[{m:"Hi3xh1",e:5}],"-1#360557375":[{m:"Ra10-b10",e:5}],"1#755991974":[{m:"Rb8xb10",e:5}],"-1#-1985705618":[{m:"Ha8xb10",e:5}],"1#1413914460":[{m:"g4-g5",e:5}],"-1#411920817":[{m:"c7-c6",e:5}],"1#-605384054":[{m:"Hh1-g3",e:5}],"-1#-1806221502":[{m:"Hb10-c8",e:5}],"-1#1621307433":[{m:"Hb10-c8",e:6.667}],"1#1907565205":[{m:"Hh1-g3",e:7.5},{m:"Ch3-f3",e:7.5}],"-1#1041141597":[{m:"Ri10-h10",e:5}],"1#1682961068":[{m:"Rb1-b7",e:5}],"-1#1151031567":[{m:"Ec10-a8",e:5}],"1#-275733682":[{m:"Ri1-h1",e:5}],"-1#-452069250":[{m:"Rh10-h6",e:5}],"1#1088045348":[{m:"Ch3-i3",e:5}],"-1#1424978988":[{m:"Ad10-e9",e:6.667},{m:"Ra10-a9",e:6.667}],"1#-1204925219":[{m:"Rb1-b7",e:5}],"-1#-1728387202":[{m:"Ec10-a8",e:5}],"1#1287056749":[{m:"Hh1-g3",e:5}],"-1#51069093":[{m:"Ra9-f9",e:5}],"1#-566199398":[{m:"Ra1-b1",e:5}],"-1#-387151002":[{m:"Ra10-b10",e:5}],"1#-794909185":[{m:"Hh1-g3",e:5}],"-1#-1625094089":[{m:"Hh10-g8",e:5}],"1#1576792954":[{m:"Ri1-h1",e:5}],"-1#1466345546":[{m:"Ri10-i9",e:5}],"1#382499886":[{m:"g4-g5",e:5}],"-1#1510443715":[{m:"Ri9-f9",e:5}],"1#1312840481":[{m:"Rb1-b5",e:5}],"-1#384723226":[{m:"Cb8-c8",e:5}],"1#-1710218376":[{m:"Rb5xb10",e:5}],"-1#1337539377":[{m:"Ha8xb10",e:5}],"1#-1839518461":[{m:"Ch3-h5",e:5}],"-1#-503028992":[{m:"Hb10-a8",e:5}],"1#-1466752254":[{m:"Hg3-f5",e:5}],"-1#-27168667":[{m:"Rf9-d9",e:5}],"1#150945609":[{m:"Af1-e2",e:5}],"1#-1873930682":[{m:"Ra1-a2",e:9.911},{m:"Hb1-c3",e:9.911}],"-1#420454125":[{m:"Hb10-c8",e:9.474},{m:"Ce8xe4+",e:9.474}],"1#136285265":[{m:"Hb1-c3",e:9.444},{m:"Ra2-f2",e:9.444}],"-1#1514661660":[{m:"Ra10-b10",e:9.667},{m:"c7-c6",e:9.667},{m:"Ch8-f8",e:9.667},{m:"Hh10-g8",e:9.667}],"1#1647692165":[{m:"Hb1-c3",e:7.5}],"-1#-803782487":[{m:"Rb10-b6",e:9.643},{m:"c7-c6",e:9.643}],"1#-1725948889":[{m:"Ra2-f2",e:5}],"1#-1734402991":[{m:"Ra2-f2",e:6.667}],"-1#-1170406019":[{m:"Ad10-e9",e:8},{m:"Ra10-b10",e:8}],"1#1459371404":[{m:"Hb1-c3",e:5}],"-1#77878977":[{m:"Ra10-b10",e:5}],"1#1020688472":[{m:"Rf2-f9",e:7.5}],"1#-2108740636":[{m:"Hb1-c3",e:7.5}],"1#1533200220":[{m:"Af1-e2",e:5}],"-1#54209942":[{m:"Ch8-e8",e:5}],"1#1616010413":[{m:"Hb1-c3",e:5}],"-1#839530464":[{m:"Ce4-e6",e:5}],"1#1976411739":[{m:"Hh1-g3",e:5}],"-1#980421523":[{m:"Hh10-g8",e:5}],"1#-123146018":[{m:"Ri1-h1",e:5}],"-1#-231363602":[{m:"Ri10-h10",e:5}],"1#-1468738017":[{m:"Ch3-h7",e:5}],"-1#-599373659":[{m:"g7-g6",e:5}],"1#-1457733672":[{m:"Hc3-e4",e:5}],"-1#-1801753515":[{m:"Ra10-a9",e:5}],"1#-1933380332":[{m:"Ra2-d2",e:5}],"-1#1489385262":[{m:"Ra9-f9",e:5}],"1#-1613742176":[{m:"Rd2-d7",e:5}],"-1#34572091":[{m:"Hb10-a8",e:5}],"1#1217972025":[{m:"Ce3xe6",e:5}],"-1#-1038713589":[{m:"c7-c6",e:9.894},{m:"Ra10-a9",e:9.894},{m:"Hb10-c8",e:9.894}],"1#24217136":[{m:"Ra1-b1",e:5}],"-1#937260748":[{m:"Hb10-c8",e:5}],"1#650994800":[{m:"Rb1-b5",e:9.615},{m:"Hh1-g3",e:9.615},{m:"g4-g5",e:9.615},{m:"Ch3-f3",e:9.615},{m:"Hh1-i3",e:9.615}],"-1#2120439371":[{m:"Ra10-b10",e:5}],"-1#1768999352":[{m:"g7-g6",e:9}],"-1#59847369":[{m:"Af10-e9",e:5}],"-1#1061381198":[{m:"Hh10-g8",e:8.333}],"1#-632298422":[{m:"c4-c5",e:9.474},{m:"Ra1-b1",e:9.474},{m:"Ce3xe7+",e:9.474},{m:"Hh1-g3",e:9.474}],"-1#358406338":[{m:"Ra9-f9",e:5}],"1#-766848948":[{m:"g4-g5",e:5}],"-1#-320662346":[{m:"Hb10-c8",e:9.286}],"1#-34404854":[{m:"Rb1-b5",e:9.744}],"-1#2111953172":[{m:"Af10-e9",e:6.667}],"-1#-1779283582":[{m:"Hb10-c8",e:6.667},{m:"Ra9-f9",e:6.667}],"1#-754552905":[{m:"Ra1-b1",e:9.867},{m:"Hh1-g3",e:9.867},{m:"Hb1-c3",e:9.444},{m:"c4-c5",e:9.867}],"-1#-441802933":[{m:"Hh10-g8",e:9.818},{m:"Hb10-c8",e:5}],"-1#-1665416577":[{m:"Hh10-g8",e:7.5},{m:"Hb10-c8",e:6.667}],"-1#471159615":[{m:"Ra10-b10",e:5}],"1#610762150":[{m:"Ra1-b1",e:5}],"-1#315329882":[{m:"Rb10xb1",e:5}],"1#1732172451":[{m:"g4-g5",e:9.946},{m:"Hh1-g3",e:9.946},{m:"Hb1-c3",e:9.946},{m:"c4-c5",e:9.946}],"-1#737487950":[{m:"Ec10-e8",e:9.412},{m:"Cb8-d8",e:9.412},{m:"c7-c6",e:9.412}],"1#124202157":[{m:"Hh1-g3",e:5}],"-1#1222279525":[{m:"Ri10-i9",e:5}],"1#158356737":[{m:"Ch3-i3",e:5}],"-1#2127272478":[{m:"Ch8-h4",e:5}],"1#1531093364":[{m:"Ri1-h1",e:5}],"1#1185986749":[{m:"Hb1-c3",e:8.333},{m:"Hh1-g3",e:8.333}],"-1#350802928":[{m:"c7-c6",e:8.75},{m:"Ra10-a9",e:8.75}],"-1#151852405":[{m:"Hb10-c8",e:8}],"1#-393029771":[{m:"Ra1-a2",e:9.167},{m:"Hb1-c3",e:9.167},{m:"Cb3-e3",e:7.5}],"-1#-1161118664":[{m:"c7-c6",e:8.75}],"-1#679704427":[{m:"Cb8-d8",e:6.667},{m:"Hb10-c8",e:6.667}],"1#1170662296":[{m:"Ra1-a2",e:5}],"-1#-863540429":[{m:"Hb10-c8",e:5}],"1#-577275505":[{m:"Ra2-d2",e:5}],"-1#160676789":[{m:"Ra10-b10",e:5}],"1#836867372":[{m:"Hb1-c3",e:5}],"-1#1673133665":[{m:"Rb10-b6",e:8},{m:"Af10-e9",e:8}],"1#279676919":[{m:"g4-g5",e:6.667},{m:"Ch3-h5",e:6.667}],"1#1863465715":[{m:"e4-e5",e:6.667}],"-1#-392306753":[{m:"g7-g6",e:6.667}],"-1#895922670":[{m:"c7-c6",e:9.939},{m:"Hb10-c8",e:9.939},{m:"Ch8-i8",e:9.939},{m:"Ra10-a9",e:9.939},{m:"Hb10-a8",e:9.939},{m:"g7-g6",e:9.939},{m:"Cb8-d8",e:9.939},{m:"Ri10-i9",e:9.939}],"1#-167687467":[{m:"Ra1-a2",e:9}],"1#143119133":[{m:"Ra1-b1",e:9}],"1#759113903":[{m:"Ad1-e2",e:9.333}],"1#2146562540":[{m:"Ra1-b1",e:8}],"-1#1230831888":[{m:"Ra10-a9",e:8}],"1#1077692051":[{m:"Ra1-b1",e:8},{m:"Hb1-c3",e:9.928}],"1#1478698269":[{m:"Ch3-h7",e:9.909}],"1#1959552394":[{m:"g4-g5",e:5}],"-1#940020583":[{m:"Ec10-e8",e:5}],"-1#1010351896":[{m:"Hb10-c8",e:5}],"1#757640612":[{m:"Hb1-c3",e:5}],"-1#2138097385":[{m:"Ra10-b10",e:5}],"1#1191372912":[{m:"Ra1-b1",e:5}],"-1#1907234956":[{m:"Hh10-g8",e:5}],"1#-1284054079":[{m:"c4-c5",e:7.5},{m:"g4-g5",e:7.5}],"-1#2087051081":[{m:"Eg10-e8",e:6.667},{m:"g7-g6",e:6.667}],"1#-1086790730":[{m:"g4-g5",e:5}],"-1#-202173093":[{m:"g7-g6",e:5}],"1#-2035686874":[{m:"g5xg6",e:5}],"-1#-310052304":[{m:"Ee8xg6",e:5}],"1#-1170230929":[{m:"Hh1-g3",e:5}],"-1#-176022361":[{m:"Eg6-e8",e:5}],"1#-1677068818":[{m:"Hg3-h5",e:5}],"-1#-1383423377":[{m:"Ch8-h10",e:5}],"1#-1856733705":[{m:"Rb1-b7",e:5}],"-1#-1316956588":[{m:"Ch10-g10",e:5}],"1#744200163":[{m:"Eg1-e3",e:5}],"-1#-1430089423":[{m:"Cb8-a8",e:5}],"1#1673569009":[{m:"Rb7xc7",e:5}],"-1#401572413":[{m:"Rb10-b8",e:5}],"1#512816684":[{m:"c5-c6",e:5}],"-1#1900748944":[{m:"Ee8xc6",e:5}],"1#462468192":[{m:"Rc7xc6",e:5}],"-1#-1241277395":[{m:"Ca8-a9",e:5}],"1#1126567637":[{m:"Ca3xa7",e:5}],"-1#370988746":[{m:"Ec10-e8",e:5}],"1#982439465":[{m:"Rc6-c5",e:5}],"-1#514036631":[{m:"Ri10-i9",e:5}],"1#1594443763":[{m:"Af1-e2",e:5}],"-1#122727737":[{m:"Ri9-d9",e:5}],"1#-128711546":[{m:"Ri1-f1",e:5}],"-1#-719807412":[{m:"Ad10-e9",e:5}],"1#970564797":[{m:"Ca7xi7",e:5}],"-1#-1523707175":[{m:"Ca9-c9",e:5}],"1#-578256419":[{m:"Rc5-d5",e:5}],"-1#1643066434":[{m:"Rd9xd5",e:5}],"1#1052373470":[{m:"Hc3xd5",e:5}],"-1#-1684384938":[{m:"Hg8xi7",e:5}],"1#759589750":[{m:"Hh5xi7",e:5}],"-1#-1763079412":[{m:"Rb8-b7",e:5}],"1#2044305586":[{m:"Hd5-f6",e:5}],"-1#-792405242":[{m:"Hc8-d6",e:5}],"1#-92901243":[{m:"Hi7-g8",e:5}],"-1#-1726716283":[{m:"Ee8-g6",e:5}],"1#-2135341223":[{m:"Ch3-h10",e:5}],"-1#536173120":[{m:"Rb7-b8",e:5}],"1#-255495682":[{m:"Hg8xe7",e:5}],"-1#-1053458072":[{m:"Rb8-h8",e:5}],"1#-444544734":[{m:"Ch10-i10",e:5}],"-1#-1591632252":[{m:"Eg6-e8",e:5}],"1#-1198735528":[{m:"Rf1-g1",e:5}],"-1#-373262146":[{m:"Cg10-h10",e:5}],"1#1947941129":[{m:"Ci10-i5",e:5}],"-1#675224646":[{m:"Cc9-d9",e:5}],"1#257099485":[{m:"Ci5-e5",e:5}],"-1#-1087450059":[{m:"Rh8-f8",e:5}],"1#1952601329":[{m:"He7-g8",e:5}],"-1#-1102898964":[{m:"Ch10-g10",e:5}],"1#597186907":[{m:"Rg1-h1",e:5}],"-1#1426414919":[{m:"Cg10-g9",e:5}],"1#-781982763":[{m:"Rh1-h7",e:5}],"-1#1804204456":[{m:"Cg9-f9",e:5}],"1#-1018885089":[{m:"Rh7-d7",e:5}],"-1#182837076":[{m:"Hd6-f5",e:5}],"1#-1376211207":[{m:"Ee3-g5",e:5}],"-1#-496035300":[{m:"Cd9-c9",e:5}],"1#-989659001":[{m:"Rd7-a7",e:5}],"-1#-1652117617":[{m:"Ke10-d10",e:5}],"1#-462419210":[{m:"Ra7-a10+",e:5}],"-1#-306535298":[{m:"Cc9-c10",e:5}],"1#272027724":[{m:"Hf6xe8",e:5}],"-1#-480384159":[{m:"Rf8xe8",e:5}],"1#1011741586":[{m:"Ra10xc10+",e:5}],"-1#-1218901341":[{m:"Kd10-d9",e:5}],"1#-1854904192":[{m:"Hg8-h6",e:5}],"-1#-771382696":[{m:"Hf5-g3",e:5}],"1#216438194":[{m:"Ce5-d5",e:5}],"-1#1923613147":[{m:"Re8xe4",e:5}],"1#-1847427904":[{m:"Rc10-c6",e:5}],"-1#1863107464":[{m:"Kd9-d10",e:5}],"1#1227202987":[{m:"Cd5-d3",e:5}],"-1#-1639929229":[{m:"Ae9-f8",e:5}],"1#-727880321":[{m:"Rc6-d6+",e:5}],"-1#305229325":[{m:"Kd10-e10",e:5}],"1#1808255860":[{m:"Cd3-e3+",e:5}],"-1#-1345363911":[{m:"Cf9-e9",e:5}],"1#-1288767740":[{m:"Rd6-f6",e:5}],"-1#657104468":[{m:"Hg3xi4",e:5}],"1#-114943248":[{m:"Hh6-i8",e:5}],"-1#-1727326496":[{m:"Ce9xe3+",e:5}],"1#628931900":[{m:"Ec1xe3",e:5}],"-1#1254987917":[{m:"Af10-e9",e:5}],"1#1181113375":[{m:"Hi8-g9+",e:5}],"-1#153511155":[{m:"Ke10-f10",e:5}],"1#1953382401":[{m:"a4-a5",e:5}],"-1#1510008141":[{m:"Re4-h4",e:5}],"1#1350742785":[{m:"Hg9-e8",e:5}],"-1#492960349":[{m:"Kf10-f9",e:5}],"1#641617562":[{m:"Rf6-f7",e:5}],"-1#-1587909482":[{m:"Rh4-a4",e:5}],"1#1959313644":[{m:"Rf7-i7",e:5}],"-1#-747242850":[{m:"Hi4-h6",e:5}],"1#1836123667":[{m:"Ri7-h7",e:5}],"-1#-439789384":[{m:"Hh6-f5",e:5}],"1#470795196":[{m:"He8-f6",e:5}],"-1#-447973801":[{m:"Ae9-d8",e:5}],"1#1805549361":[{m:"Hf6-g8",e:5}],"-1#-1289323102":[{m:"Kf9-e9",e:5}],"1#-725756366":[{m:"Rh7-f7",e:5}],"-1#-429554278":[{m:"Hf5-g3",e:5}],"1#948351600":[{m:"Rf7xf8",e:5}],"-1#550572324":[{m:"Ke9-d9",e:5}],"1#1585638875":[{m:"Rf8-f3",e:5}],"-1#-35305621":[{m:"Hg3-h5",e:5}],"1#-247132887":[{m:"Rf3-f5",e:5}],"-1#-750279946":[{m:"Hh5-g7",e:5}],"1#155134004":[{m:"Ch3-d3",e:9.923},{m:"Hh1-g3",e:9.923},{m:"Ch3-e3",e:9.923},{m:"Rb1-b7",e:9.923},{m:"Eg1-e3",e:9.923},{m:"Hh1-i3",e:9.923},{m:"Ch3-g3",e:9.923},{m:"Ch3-h7",e:9.923}],"-1#-1971503636":[{m:"Hg8-h6",e:9.63},{m:"Eg10-e8",e:9.63},{m:"Ri10-h10",e:9.63},{m:"Ri10-i9",e:9.63},{m:"Cb8-b6",e:9.63},{m:"Cb8-b4",e:9.63},{m:"Hg8-f6",e:9.63},{m:"Ec10-e8",e:9.63}],"1#397727075":[{m:"Hh1-g3",e:5}],"1#-801357795":[{m:"Hh1-g3",e:8.75}],"1#1201048787":[{m:"Eg1-e3",e:7.5}],"1#934311144":[{m:"Hc3-d5",e:5}],"1#-1494270705":[{m:"Hh1-g3",e:9.87}],"-1#1182959100":[{m:"Ch8-h6",e:9.643},{m:"Eg10-e8",e:9.643},{m:"Cb8-b3",e:9.643},{m:"Cb8-b4",e:9.643},{m:"Ec10-e8",e:9.643},{m:"Ri10-i9",e:9.643}],"1#2102132478":[{m:"Rb1-b7",e:6.667}],"1#-2048935677":[{m:"Ch3-h7",e:7.5}],"1#1750639924":[{m:"Hc3-d5",e:5}],"-1#1109089033":[{m:"Cb3xh3",e:5}],"1#-78656264":[{m:"Eg1-e3",e:8}],"1#1779467551":[{m:"Rb1-b5",e:9.655}],"1#120082840":[{m:"Hh1-g3",e:9.091}],"-1#1403560400":[{m:"Eg10-e8",e:9.412},{m:"Ec10-e8",e:9.412},{m:"Ri10-h10",e:9.412}],"1#-1862951633":[{m:"Hh1-g3",e:5}],"-1#-548917017":[{m:"Ri10-h10",e:6.667},{m:"Cb8-b6",e:6.667}],"1#2134548787":[{m:"Hh1-g3",e:9.643}],"-1#814157051":[{m:"Ri10-i9",e:9.697},{m:"Ri10-h10",e:9.697},{m:"Hg8-f6",e:9.697}],"1#166321185":[{m:"Rb1-b7",e:9.375},{m:"Hh1-g3",e:9.375}],"-1#691894146":[{m:"Cb8-a8",e:6.667}],"-1#703300503":[{m:"Cb8-b9",e:9.091},{m:"Hg8-f6",e:9.091},{m:"Ch8-h7",e:9.091},{m:"Eg10-e8",e:9.091},{m:"Cb8-a8",e:9.091}],"1#-728743652":[{m:"Hh1-g3",e:5}],"-1#-1691489068":[{m:"Cb9-f9",e:5}],"1#-1952819420":[{m:"Ca3xa7",e:5}],"1#1851280480":[{m:"Ch3-e3",e:5}],"1#-357122200":[{m:"Eg1-e3",e:6.667},{m:"Ch3-d3",e:6.667}],"1#-521555881":[{m:"Rb7xb10",e:8.571}],"-1#1295659398":[{m:"Hc8xb10",e:8.571}],"-1#-1884934426":[{m:"Eg10-e8",e:9.6},{m:"Ec10-e8",e:9.6},{m:"Ri10-i9",e:9.6},{m:"Ch8-i8",e:9.6}],"1#1291522585":[{m:"Rb1-b5",e:9.091},{m:"Hh1-g3",e:9.091}],"1#-1556861435":[{m:"Rb1-b7",e:8.889},{m:"Hh1-g3",e:8.889},{m:"Ca3xa7",e:8.889}],"1#-838010238":[{m:"Hh1-g3",e:9.091},{m:"Ch3-h7",e:9.091}],"1#-1303950315":[{m:"Rb1-b7",e:7.5},{m:"Hh1-f2",e:7.5}],"-1#280045578":[{m:"i7-i6",e:6.667},{m:"Eg10-e8",e:6.667}],"1#526182101":[{m:"Ec1-e3",e:5}],"-1#-1380316932":[{m:"Ri10-i9",e:5}],"1#-334439272":[{m:"Ch3-f3",e:5}],"-1#-917730783":[{m:"Ri9-f9",e:5}],"1#-586458173":[{m:"Af1-e2",e:5}],"1#-739502859":[{m:"Ch3-g3",e:5}],"-1#-854456109":[{m:"Hg8-h6",e:5}],"1#1356587100":[{m:"Ri1-i2",e:5}],"-1#94350388":[{m:"Af10-e9",e:5}],"1#154429606":[{m:"Ri2-f2",e:5}],"-1#398537746":[{m:"Ri10-h10",e:5}],"1#1300253155":[{m:"Hh1-i3",e:5}],"-1#1410222557":[{m:"Ch8-i8",e:5}],"1#1777281838":[{m:"Rb1-b7",e:5}],"-1#1228636301":[{m:"Cb8-a8",e:5}],"1#-2143702195":[{m:"Rb7xb10",e:5}],"-1#770323100":[{m:"Hc8xb10",e:5}],"1#-1416661488":[{m:"g4-g5",e:5}],"-1#-414940931":[{m:"Hg8-f6",e:5}],"1#1161122894":[{m:"g5xg6",e:5}],"-1#773344344":[{m:"Hf6xe4",e:5}],"1#592188147":[{m:"Hc3xe4",e:5}],"-1#694017850":[{m:"Ci8-e8",e:5}],"-1#2098050702":[{m:"Ec10-e8",e:9.706},{m:"Eg10-e8",e:9.706},{m:"Hg8-h6",e:9.706},{m:"Cb8-b4",e:9.706}],"1#1369421421":[{m:"Hh1-i3",e:9.545},{m:"Hh1-g3",e:9.545}],"1#-1102017935":[{m:"Ch7xc7",e:5}],"-1#-1117177416":[{m:"Ri10-h10",e:5}],"1#-524001791":[{m:"Hh1-i3",e:9.333},{m:"Ri1-i2",e:9.333}],"1#-1061093494":[{m:"Hh1-g3",e:5}],"-1#-1887612350":[{m:"Hg8-f6",e:6.667}],"-1#-4385492":[{m:"c7-c6",e:6.667}],"1#1020980759":[{m:"Rb1-b7",e:8.889},{m:"Hh1-g3",e:8.889}],"-1#470697396":[{m:"Ch8-h4",e:9.444},{m:"Cb8-a8",e:9.444},{m:"Ch8-i8",e:9.444},{m:"Hc8-d6",e:9.444},{m:"Ri10-i9",e:9.444}],"1#965181150":[{m:"c4-c5",e:7.5},{m:"Eg1-e3",e:7.5},{m:"Hh1-g3",e:7.5}],"-1#-158055850":[{m:"c6xc5",e:5}],"1#-840133694":[{m:"Rb7-c7",e:5}],"-1#926011948":[{m:"Hg8-e9",e:5}],"1#1780146798":[{m:"Rc7xc5",e:5}],"-1#-885689925":[{m:"Cb8-b9",e:5}],"1#911127344":[{m:"Hh1-g3",e:5}],"-1#-1088522228":[{m:"Ch4xc4",e:5}],"1#1181172356":[{m:"Hh1-g3",e:5}],"-1#165343052":[{m:"Ri10-h10",e:5}],"1#1402704573":[{m:"Ri1-h1",e:5}],"-1#1493617037":[{m:"Rh10-h4",e:5}],"1#-1656281382":[{m:"Ch3-i3",e:5}],"-1#1983566614":[{m:"Ch4-g4",e:5}],"1#1730195130":[{m:"Ri1-h1",e:5}],"-1#1841165706":[{m:"Ri10-h10",e:5}],"1#939296891":[{m:"Ch3-h5",e:5}],"-1#1201915512":[{m:"Hc8-d6",e:5}],"1#1829858811":[{m:"Eg1-e3",e:5}],"1#-720603532":[{m:"Rb7xb10",e:8.75},{m:"Rb7-c7",e:8.75}],"-1#2027943845":[{m:"Hc8xb10",e:8.571}],"1#-21318871":[{m:"Hh1-g3",e:8.571},{m:"Ca3xa7",e:8.571}],"-1#-1324933407":[{m:"Hb10-c8",e:8.333}],"1#-1609102243":[{m:"Ec1-e3",e:9.375},{m:"Hg3-h5",e:9.375}],"-1#-1417647306":[{m:"Hb10-c8",e:5}],"1#-1164936822":[{m:"Ca7xg7",e:5}],"-1#907274638":[{m:"Ch8-h4",e:5}],"-1#802240410":[{m:"Rb10-b8",e:9.091},{m:"Ca8-a9",e:9.091}],"1#648954763":[{m:"Hh1-g3",e:5}],"-1#1762913859":[{m:"Eg10-e8",e:5}],"1#-1437674820":[{m:"Hg3-h5",e:5}],"-1#-1681029827":[{m:"Ch8xh3",e:5}],"1#-621501086":[{m:"Ch3-g3",e:9},{m:"Hh1-g3",e:9}],"-1#-1005930172":[{m:"Ri10-h10",e:5}],"-1#-1790375766":[{m:"Hg8-e9",e:8.889}],"1#569321287":[{m:"Hh1-g3",e:5}],"-1#1850903183":[{m:"Ri10-h10",e:5}],"1#873723774":[{m:"Hg3-f5",e:5}],"-1#1658954777":[{m:"Cb8-a8",e:5}],"1#-1411147815":[{m:"Rb7-c7",e:5}],"-1#1363072567":[{m:"Ca8-a9",e:5}],"1#-1541716785":[{m:"Hf5xg7",e:5}],"-1#-419833340":[{m:"Ca9-c9",e:5}],"1#-1637922560":[{m:"Rc7-d7",e:5}],"-1#-1346529590":[{m:"Hc8-b6",e:5}],"1#1911046587":[{m:"Hg7xi8",e:5}],"-1#1291011625":[{m:"Eg10xi8",e:5}],"1#-1890316614":[{m:"Ch3-g3",e:5}],"-1#-1851125092":[{m:"Hg8-f6",e:5}],"1#870041135":[{m:"Rd7xe7+",e:5}],"-1#1569706570":[{m:"Cc9-e9",e:5}],"1#265738249":[{m:"Eg1-e3",e:5}],"-1#-1991254309":[{m:"Hf6-d5",e:5}],"1#-673442538":[{m:"Re7-e5",e:5}],"-1#-1123969913":[{m:"Hd5xc3",e:5}],"1#918351415":[{m:"Rb7-d7",e:8},{m:"Hh1-g3",e:8}],"-1#-530692254":[{m:"Hd6xc4",e:5}],"1#1552154729":[{m:"Hh1-g3",e:5}],"-1#322547105":[{m:"Cb8-c8",e:5}],"1#-1614288957":[{m:"Ca3xa7",e:5}],"-1#-889372708":[{m:"Eg10-e8",e:5}],"1#161481507":[{m:"Ca7xe7+",e:5}],"-1#1358644069":[{m:"Hg8xe7",e:5}],"1#239150036":[{m:"Rd7xe7",e:5}],"-1#461462644":[{m:"Af10-e9",e:5}],"-1#2030126079":[{m:"Hc8-d6",e:7.5}],"1#950769563":[{m:"Rb7-b5",e:8},{m:"Rb7-d7",e:8}],"-1#1561082226":[{m:"c6-c5",e:6.667}],"1#-752479469":[{m:"Rb5xc5",e:6.667}],"-1#-311201855":[{m:"Cb8-c8",e:6.667}],"1#1636640163":[{m:"Ri1-i2",e:6.667}],"-1#885615051":[{m:"Rb10-b6",e:6.667},{m:"Ri9-f9",e:6.667}],"1#1205538909":[{m:"Ri2-d2",e:5}],"-1#-369705794":[{m:"Ri9-f9",e:5}],"1#-38703780":[{m:"Ca3xa7",e:5}],"-1#-1467239101":[{m:"Rf9-f6",e:5}],"1#546224169":[{m:"Ca3xa7",e:5}],"-1#1974755382":[{m:"Rb10-b7",e:5}],"1#-1910109976":[{m:"Ca7-a6",e:5}],"-1#1693889387":[{m:"Rf9-f4",e:5}],"-1#-297189682":[{m:"Hd6xc4",e:6.667}],"1#1385396677":[{m:"Ca3xa7",e:6.667}],"-1#128557530":[{m:"Rb10-b9",e:6.667},{m:"Ri9-f9",e:6.667}],"1#1493057030":[{m:"Ch3-i3",e:5}],"-1#793112857":[{m:"Hc4-b6",e:5}],"1#14957292":[{m:"Rd7-b7",e:5}],"-1#-704212039":[{m:"Cb8-c8",e:5}],"1#1526258139":[{m:"Rb7xb9",e:5}],"1#334393400":[{m:"Eg1-e3",e:5}],"-1#-1787332886":[{m:"Rf9-f4",e:5}],"1#-84401047":[{m:"Af1-e2",e:5}],"-1#-1566454109":[{m:"Rf4-g4",e:5}],"1#-926348950":[{m:"Ri1-g1",e:5}],"1#1571066320":[{m:"Rb1-b7",e:5}],"-1#303643672":[{m:"Ri9-f9",e:7.5},{m:"Hc8-d6",e:7.5}],"1#106884602":[{m:"Ch3-i3",e:6.667}],"-1#1910842085":[{m:"Ch8-h4",e:6.667}],"1#1416370575":[{m:"c4-c5",e:6.667}],"-1#-1686166265":[{m:"c6xc5",e:6.667}],"1#-1610091373":[{m:"Rb7-c7",e:6.667}],"-1#1524282749":[{m:"Hc8-e9",e:6.667},{m:"Cb8-b4",e:6.667}],"1#1195892232":[{m:"Rc7xc5",e:5}],"-1#-429371939":[{m:"Rf9-f2",e:5}],"1#385528318":[{m:"Ca3-b3",e:5}],"-1#627357842":[{m:"Rb10-a10",e:5}],"1#488019467":[{m:"Af1-e2",e:5}],"-1#1162837185":[{m:"Ec10-e8",e:5}],"1#1776122914":[{m:"Ri1-h1",e:5}],"-1#1665148690":[{m:"Ch4-g4",e:5}],"1#1918524094":[{m:"Cb3-b2",e:5}],"-1#-945290942":[{m:"Rf2-f6",e:5}],"1#-1636422992":[{m:"Hc3-d5",e:5}],"-1#-1271540595":[{m:"Rf6-f5",e:5}],"1#-417858439":[{m:"Rc7xc5",e:5}],"-1#1178103724":[{m:"Cb4-c4",e:5}],"1#654323429":[{m:"Eg1-e3",e:5}],"-1#-1583798217":[{m:"Hc8-d6",e:5}],"1#-1960082508":[{m:"Rc5-d5",e:5}],"-1#927741483":[{m:"Rf9-f6",e:5}],"1#-2082613621":[{m:"Hg3-h5",e:5}],"-1#-1302429430":[{m:"Rb10-b5",e:5}],"1#-1664695142":[{m:"Rd5-d3",e:5}],"-1#-1760803801":[{m:"Ch4-h3",e:5}],"1#1203500885":[{m:"Hh5-g3",e:5}],"-1#1983422676":[{m:"Rb5-b3",e:5}],"1#-279728903":[{m:"Ri1-h1",e:5}],"-1#1936147423":[{m:"Ch8-h4",e:8.333},{m:"Ri10-i9",e:8.333},{m:"Eg10-e8",e:8.333}],"1#1458469045":[{m:"Hg3-f5",e:7.5},{m:"Eg1-e3",e:7.5},{m:"Ec1-e3",e:7.5}],"-1#1846226":[{m:"Ch4xc4",e:5}],"1#-110816934":[{m:"Hf5-e3",e:5}],"-1#1545069414":[{m:"c6-c5",e:5}],"1#-767702777":[{m:"Ch3-h5",e:5}],"-1#-1570601212":[{m:"c5-b5",e:5}],"1#43494878":[{m:"Rb1xb5",e:5}],"-1#1392032304":[{m:"Cc4xc1+",e:5}],"1#1857403696":[{m:"Ad1-e2",e:5}],"-1#566012464":[{m:"Cb8-a8",e:5}],"1#-390161936":[{m:"Ch5-h8",e:5}],"-1#-797475225":[{m:"Cb8-b4",e:5}],"1#1840920419":[{m:"Ad1-e2",e:5}],"-1#582166115":[{m:"Ch4xc4",e:5}],"1#-607511317":[{m:"Ri1-h1",e:5}],"-1#-782809125":[{m:"Ri10-h10",e:5}],"1#-1961477590":[{m:"Ch3-h7",e:5}],"-1#-14375792":[{m:"Eg10-e8",e:5}],"1#1014601839":[{m:"i4-i5",e:5}],"-1#-2107211761":[{m:"Af10-e9",e:5}],"1#-1899150179":[{m:"Ch7-h8",e:5}],"-1#-285854581":[{m:"Rb10-b6",e:5}],"-1#-469199204":[{m:"Ch4-g4",e:5}],"1#-183309520":[{m:"Ri1-h1",e:5}],"-1#-7360512":[{m:"Ri10-h10",e:5}],"1#-1513173519":[{m:"Rb1-b5",e:5}],"-1#-43974710":[{m:"Cb8-a8",e:5}],"1#878889994":[{m:"Rb5xb10",e:5}],"-1#-506735549":[{m:"Hc8xb10",e:5}],"1#1739493583":[{m:"Ca3xa7",e:5}],"-1#848578768":[{m:"Hb10-c8",e:5}],"1#595876460":[{m:"Ca7-a6",e:5}],"-1#-917184017":[{m:"Rh10-h4",e:5}],"1#852334523":[{
m:"Rb1-b7",e:5}],"1#-1338343648":[{m:"Eg1-e3",e:6.667},{m:"Ch3-h5",e:6.667}],"-1#916683250":[{m:"Cb8-b7",e:5}],"1#-416036712":[{m:"Rb1-b5",e:5}],"-1#-1080165725":[{m:"Ch8-h6",e:5}],"1#-2074836575":[{m:"Af1-e2",e:5}],"-1#-603100309":[{m:"Af10-e9",e:5}],"1#-794382343":[{m:"Ri1-f1",e:5}],"-1#-34982093":[{m:"a7-a6",e:5}],"1#-104322511":[{m:"g5-g6",e:5}],"-1#-1681611486":[{m:"g7xg6",e:5}],"1#-793841591":[{m:"c4-c5",e:5}],"-1#532532417":[{m:"Ri10-f10",e:5}],"1#-1771472123":[{m:"Rf1xf10+",e:5}],"-1#-955539816":[{m:"Ae9xf10",e:5}],"1#357130869":[{m:"Hc3-d5",e:5}],"-1#1057659976":[{m:"c6xc5",e:5}],"1#74599900":[{m:"Rb5xc5",e:5}],"-1#975646990":[{m:"Hc8-d6",e:5}],"-1#-1067110109":[{m:"Cb8-b6",e:5}],"1#227442716":[{m:"Eg1-e3",e:5}],"-1#-1961392434":[{m:"g7-g6",e:5}],"1#-28479053":[{m:"Rb1-b5",e:5}],"-1#-1495055480":[{m:"Ch8-h9",e:5}],"1#-24108661":[{m:"Af1-e2",e:5}],"-1#-1496724671":[{m:"Ch9-b9",e:5}],"1#-1495489139":[{m:"Rb5-d5",e:5}],"-1#-1931844657":[{m:"Cb9-g9",e:5}],"1#-237023299":[{m:"Ri1-h1",e:5}],"-1#-79555443":[{m:"g6xg5",e:5}],"1#1636228282":[{m:"Ee3xg5",e:5}],"-1#222743438":[{m:"Ri10-h10",e:5}],"1#1460123263":[{m:"Ch5-h8",e:5}],"-1#860952272":[{m:"Hc8-d6",e:5}],"1#434355539":[{m:"Ch8-i8",e:6.667}],"-1#-1769093008":[{m:"Rh10-i10",e:6.667}],"-1#89036141":[{m:"Cb8-f8",e:8.889},{m:"Hh10-g8",e:8.889},{m:"Eg10-e8",e:8.889},{m:"Hb10-a8",e:8.889},{m:"Ch8-e8",e:8.889},{m:"Cb8-e8",e:8.889}],"1#935334557":[{m:"Hb1-a3",e:5}],"-1#673099461":[{m:"Hb10-c8",e:5}],"1#957267065":[{m:"Ra1-b1",e:5}],"-1#262294661":[{m:"Ra10-a9",e:5}],"1#402380228":[{m:"Hh1-g3",e:5}],"-1#1481013260":[{m:"g7-g6",e:5}],"1#756846449":[{m:"Ch3xh10",e:5}],"-1#143730250":[{m:"Ri10xh10",e:5}],"1#1589360555":[{m:"Eg1-e3",e:5}],"-1#-668814983":[{m:"Ch8-g8",e:5}],"1#-1361469517":[{m:"Af1-e2",e:5}],"-1#-159353479":[{m:"Ec10-e8",e:5}],"1#-636324454":[{m:"Ri1-f1",e:5}],"-1#-144773808":[{m:"Ad10-e9",e:5}],"1#463459745":[{m:"Rf1-f7",e:5}],"-1#-1449039617":[{m:"i7-i6",e:5}],"1#-1504926176":[{m:"Rb1-b7",e:5}],"-1#-2036855421":[{m:"a7-a6",e:5}],"1#-2101735295":[{m:"Rb7xc7",e:5}],"-1#-157994931":[{m:"Rh10-h3",e:5}],"1#1582066737":[{m:"c4-c5",e:5}],"-1#-1856024391":[{m:"Cg8-i8",e:5}],"1#-946328591":[{m:"c5-c6",e:5}],"-1#-1471939251":[{m:"Ra9-a7",e:5}],"1#-892872950":[{m:"Ha3-c4",e:5}],"-1#-268484920":[{m:"Ci8xi4",e:5}],"1#-1417395625":[{m:"Rf7-f1",e:5}],"-1#431685385":[{m:"Cf8-i8",e:5}],"1#-437251135":[{m:"Rf1-h1",e:5}],"-1#-537073846":[{m:"Rh3xh1+",e:5}],"1#1384451833":[{m:"Hg3xh1",e:5}],"-1#1586165154":[{m:"e7-e6",e:5}],"1#-61308715":[{m:"Hh1-g3",e:5}],"-1#-1276826339":[{m:"Ci4-i1",e:5}],"1#-199313897":[{m:"c6-d6",e:5}],"-1#-1220844161":[{m:"Ra7xc7",e:5}],"1#-727744672":[{m:"Cc3xc7",e:5}],"-1#1115314447":[{m:"Hc8-e7",e:5}],"1#1281195291":[{m:"d6xe6",e:5}],"-1#2050950544":[{m:"He7-g8",e:5}],"1#-636131802":[{m:"Cc7-g7",e:5}],"-1#52783137":[{m:"i6-i5",e:5}],"1#-980374276":[{m:"g4-g5",e:5}],"-1#-1990501871":[{m:"g6xg5",e:5}],"1#329224742":[{m:"Ee3xg5",e:5}],"-1#2136966418":[{m:"Hg8-i7",e:5}],"1#1018534053":[{m:"Cg7-b7",e:5}],"-1#-1716961840":[{m:"i5-h5",e:5}],"1#847678122":[{m:"e6-e7",e:5}],"-1#1096626340":[{m:"Hi7-g6",e:5}],"1#1704292852":[{m:"Hg3xh5",e:5}],"-1#905090061":[{m:"Hg6xe7",e:5}],"1#-60009254":[{m:"Cb7-d7",e:5}],"-1#1900382736":[{m:"He7-d5",e:5}],"1#1638326530":[{m:"e4-e5",e:5}],"-1#-433519538":[{m:"Ci1-i4",e:5}],"1#-1580032188":[{m:"Hc4-d6",e:5}],"-1#204330726":[{m:"Hd5-b4",e:5}],"1#860755879":[{m:"Hd6-b7",e:5}],"-1#-1995615330":[{m:"Ci4-e4+",e:5}],"1#-189045292":[{m:"Ke1-f1",e:5}],"-1#1911581229":[{m:"Ci8-i9",e:5}],"1#367580630":[{m:"Eg5-e3",e:5}],"-1#1518297395":[{m:"Ci9-f9",e:5}],"1#852651210":[{m:"Hh5-g7",e:5}],"-1#1994891758":[{m:"Cf9-f8",e:5}],"1#-2045182172":[{m:"Hb7-c9+",e:5}],"-1#1639296571":[{m:"Ke10-d10",e:5}],"1#407046978":[{m:"Cd7-d2",e:5}],"-1#1666035615":[{m:"Hb4-c6",e:5}],"1#1241706068":[{m:"Ee3-c5",e:7.5},{m:"Hc9-d7+",e:7.5}],"-1#-821173468":[{m:"Hc6-e7",e:5}],"-1#836310243":[{m:"Kd10-e10",e:6.667}],"1#-946442720":[{m:"g4-g5",e:5}],"-1#-1956800307":[{m:"Eg10-e8",e:5}],"1#1208001586":[{m:"Ch3-e3",e:5}],"-1#311897558":[{m:"Ri10-h10",e:5}],"1#1222004775":[{m:"Hh1-g3",e:5}],"-1#124517871":[{m:"Ch8-i8",e:5}],"1#982163228":[{m:"Hb1-a3",e:5}],"-1#626271044":[{m:"Hb10-a8",e:6.667}],"1#1875075910":[{m:"Ra1-b1",e:6.667}],"-1#1500484538":[{m:"Ra10-b10",e:6.667}],"1#1629338915":[{m:"Rb1-b5",e:6.667}],"-1#968068888":[{m:"Cb8-d8",e:6.667},{m:"a7-a6",e:6.667}],"1#1425415147":[{m:"Rb5-d5",e:5}],"-1#2129714601":[{m:"Af10-e9",e:5}],"1#1918572859":[{m:"a4-a5",e:5}],"-1#1547025527":[{m:"Rb10-b6",e:5}],"1#791135713":[{m:"Ha3-b5",e:5}],"-1#730070168":[{m:"g7-g6",e:5}],"1#1591282661":[{m:"Cc3-b3",e:5}],"-1#1412507900":[{m:"Rb6-f6",e:5}],"1#1593249657":[{m:"Ce3-c3",e:5}],"-1#615945738":[{m:"a7-a6",e:5}],"1#546605832":[{m:"a5xa6",e:5}],"-1#-1211597593":[{m:"Rf6xa6",e:5}],"1#-2140471787":[{m:"Eg1-e3",e:5}],"-1#116652231":[{m:"Ci8-i9",e:5}],"1#-1489691802":[{m:"g5xg6",e:5}],"-1#-870841488":[{m:"Ra6xg6",e:5}],"1#1598348485":[{m:"Cc3-c2",e:5}],"-1#309868329":[{m:"Rh10-h6",e:5}],"1#-1213231501":[{m:"Cc2-g2",e:5}],"-1#-613253162":[{m:"Rg6-f6",e:5}],"1#1270217476":[{m:"Af1-e2",e:5}],"-1#334238158":[{m:"Rf6-f2",e:5}],"1#-803310507":[{m:"Cb3-b2",e:5}],"-1#1709977513":[{m:"Rf2-f4",e:5}],"1#-136914246":[{m:"Rd5-f5",e:5}],"-1#1276520146":[{m:"Rf4xf5",e:5}],"1#-1187259508":[{m:"Hg3xf5",e:5}],"-1#-505229443":[{m:"Rh6-f6",e:5}],"1#-16191760":[{m:"Hf5-g3",e:5}],"-1#-1443185257":[{m:"Ha8-b6",e:5}],"1#740833368":[{m:"Ri1-h1",e:5}],"1#1032950298":[{m:"Hg3-f5",e:5}],"-1#1801699709":[{m:"Rh10-h6",e:5}],"1#-827033561":[{m:"Rb5-d5",e:5}],"-1#-458047899":[{m:"Ha8-b6",e:5}],"1#1633696682":[{m:"Rd5-d6",e:5}],"-1#-448872190":[{m:"Rh6xd6",e:5}],"1#-132302547":[{m:"Hf5xd6",e:5}],"-1#64715564":[{m:"Rb10-b9",e:5}],"1#1552737520":[{m:"Ri1-h1",e:5}],"-1#1444003776":[{m:"Rb9-d9",e:5}],"1#1528872214":[{m:"Hd6-f5",e:5}],"-1#-1253512520":[{m:"Hb6-d5",e:5}],"1#1977184975":[{m:"Cc3-c2",e:5}],"-1#-1421171697":[{m:"Rd9-f9",e:5}],"1#504464979":[{m:"Hf5xg7",e:5}],"-1#1559435416":[{m:"Ci8xi4",e:5}],"1#411591687":[{m:"Af1-e2",e:5}],"-1#1087475405":[{m:"Rf9-f7",e:5}],"1#239579662":[{m:"g5-g6",e:5}],"-1#1816870173":[{m:"Hd5-f4",e:5}],"1#-103873576":[{m:"Ce3-g3",e:5}],"-1#-1602510485":[{m:"Ci4xe4+",e:5}],"1#549092195":[{m:"Eg1-e3",e:5}],"-1#-1507623503":[{m:"Hf4xg6",e:5}],"1#-629361375":[{m:"Rh1-f1",e:5}],"-1#-529514070":[{m:"Rf7xf1+",e:5}],"1#970482035":[{m:"Ke1xf1",e:5}],"-1#-863122647":[{m:"c7-c6",e:5}],"1#267005970":[{m:"Cg3-g5",e:5}],"-1#577114044":[{m:"Ce4xa4",e:5}],"1#-971789934":[{m:"Ch3-e3",e:5}],"-1#-1669062538":[{m:"Hh10-g8",e:5}],"1#1583143739":[{m:"Hh1-g3",e:5}],"-1#299988723":[{m:"Ri10-h10",e:5}],"1#1268779778":[{m:"Ri1-i2",e:5}],"-1#518276970":[{m:"Hb10-a8",e:5}],"1#1416824680":[{m:"Hb1-a3",e:5}],"-1#1269676848":[{m:"Ra10-b10",e:5}],"1#1944032681":[{m:"Ra1-b1",e:5}],"-1#1165190485":[{m:"g7-g6",e:5}],"1#808030760":[{m:"a4-a5",e:8.571},{m:"Rb1-b5",e:8.571}],"-1#507983716":[{m:"Af10-e9",e:8.333},{m:"Ch8-i8",e:8.333}],"1#317518838":[{m:"Ri2-f2",e:8}],"-1#507066764":[{m:"Ch8-h6",e:8},{m:"Ch8-i8",e:8}],"1#636502670":[{m:"Rf2-f5",e:7.5},{m:"Rf2-f7",e:7.5},{m:"Rb1-b5",e:7.5}],"-1#-639513048":[{m:"a7-a6",e:5}],"-1#-19999111":[{m:"a7-a6",e:5}],"-1#2103341237":[{m:"a7-a6",e:5}],"1#601381759":[{m:"Rb1-b5",e:5}],"-1#2071357764":[{m:"Rh10-h4",e:5}],"1#-1086880237":[{m:"g4-g5",e:5}],"-1#-201559810":[{m:"Rh4-g4",e:5}],"1#539706853":[{m:"Rf2-f5",e:5}],"-1#-600127165":[{m:"Cb8-d8",e:5}],"1#598103447":[{m:"Rb1-b5",e:5}],"-1#2064148396":[{m:"Rh10-h4",e:5}],"1#-1085699845":[{m:"Ce3-d3",e:5}],"-1#2067866550":[{m:"Rh4xg4",e:5}],"1#450230705":[{m:"Ec1-e3",e:5}],"-1#-1473046632":[{m:"Rg4-f4",e:5}],"1#-1034170287":[{m:"Cd3-d8",e:5}],"-1#1488130240":[{m:"Cb8-c8",e:5}],"1#-733128030":[{m:"Cd8xa8",e:5}],"-1#2032157562":[{m:"Rb10xb5",e:5}],"1#1341786460":[{m:"Ha3xb5",e:5}],"-1#1062745210":[{m:"Ec10xa8",e:5}],"1#-165721704":[{m:"Hb5-d6",e:5}],"-1#2055000193":[{m:"Cc8-d8",e:5}],"-1#1753718803":[{m:"Cb8-d8",e:7.5}],"1#96613600":[{m:"Ri2-b2",e:7.5},{m:"a4-a5",e:7.5},{m:"Rb5xb10",e:7.5}],"-1#-48523381":[{m:"Rb10xb5",e:5}],"1#-876487251":[{m:"Rb2xb5",e:5}],"-1#700504678":[{m:"a7-a6",e:5}],"1#769836900":[{m:"g4-g5",e:5}],"-1#1630089609":[{m:"g6xg5",e:5}],"1#-68290114":[{m:"Rb5xg5",e:5}],"-1#284560293":[{m:"Ch8-h9",e:5}],"1#1216702886":[{m:"Rg5-h5",e:5}],"-1#1020802578":[{m:"Ha8-b6",e:6.667}],"-1#732729772":[{m:"Af10-e9",e:5}],"1#654791998":[{m:"Ri2-f2",e:5}],"-1#735223620":[{m:"Rb10xb5",e:5}],"1#487118178":[{m:"Ha3xb5",e:5}],"-1#1839917124":[{m:"Rh10-f10",e:5}],"1#-1545464576":[{m:"Rf2xf10+",e:5}],"-1#-1686054604":[{m:"Ke10xf10",e:5}],"1#941737401":[{m:"Cc3-a3",e:5}],"-1#478861501":[{m:"Cd8-d7",e:5}],"-1#-798282583":[{m:"Ha8xb10",e:5}],"1#227097243":[{m:"Ri2-b2",e:5}],"-1#-179267088":[{m:"Hb10-a8",e:5}],"1#-1077421582":[{m:"a4-a5",e:5}],"-1#-1851163458":[{m:"Af10-e9",e:5}],"1#-1660766164":[{m:"Rb2-b8",e:5}],"-1#-1544740401":[{m:"Rh10-f10",e:5}],"1#1839586443":[{m:"Ad1-e2",e:5}],"-1#581750155":[{m:"c7-c6",e:5}],"1#1339676015":[{m:"a4-a5",e:5}],"-1#1639411747":[{m:"Ra10-b10",e:5}],"1#1506107066":[{m:"Hb1-a3",e:5}],"-1#1176232674":[{m:"Ch8-e8",e:5}],"1#628265945":[{m:"Hh1-g3",e:5}],"-1#1791966737":[{m:"Hh10-g8",e:5}],"1#-1474837156":[{m:"Ri1-h1",e:5}],"-1#-1567973780":[{m:"Ri10-h10",e:5}],"1#-120855651":[{m:"Ra1-b1",e:5}],"-1#-832105631":[{m:"Cb8-b3",e:5}],"1#-524471383":[{m:"Eg1-e3",e:5}],"-1#1713649019":[{m:"g7-g6",e:5}],"1#327074310":[{m:"Ch3-h5",e:5}],"-1#1663142917":[{m:"Cb3-b4",e:5}],"1#-303312200":[{m:"Af1-e2",e:5}],"-1#-1246611342":[{m:"Hg8-f6",e:5}],"1#398716097":[{m:"Ch5-b5",e:5}],"-1#617792234":[{m:"Rh10xh1+",e:5}],"1#481247316":[{m:"Hg3xh1",e:5}],"-1#278969103":[{m:"Cb4xe4",e:5}],"1#-626484206":[{m:"Cc3-b3",e:5}],"-1#-801063157":[{m:"Rb10-a10",e:5}],"1#-399339118":[{m:"Hh1-g3",e:5}],"-1#-1483785126":[{m:"Ce4-e5",e:5}],"1#858422405":[{m:"c4-c5",e:5}],"-1#-63356915":[{m:"Ra10-a9",e:5}],"1#-463414964":[{m:"Cb3-c3",e:5}],"-1#-293012907":[{m:"Ra9-d9",e:5}],"1#-2129074186":[{m:"c5-c6",e:5}],"-1#-289197750":[{m:"Hf6-d5",e:5}],"1#-1336870265":[{m:"Cc3-c2",e:5}],"-1#1858284615":[{m:"Ce5xb5",e:5}],"1#-289653657":[{m:"Rb1xb5",e:5}],"-1#1260356835":[{m:"c7xc6",e:5}],"1#-646883249":[{m:"Cc2xc10+",e:5}],"-1#626463484":[{m:"Ke10-e9",e:5}],"1#81471833":[{m:"Ke1-f1",e:5}],"-1#-2121259360":[{m:"Ce8-f8",e:5}],"1#1010645699":[{m:"Kf1-e1",e:5}],"-1#-1183435462":[{m:"c6-c5",e:5}],"1#928784219":[{m:"Rb5xc5",e:5}],"-1#151610249":[{m:"Ha8-c7",e:5}],"1#206288880":[{m:"Ha3-b5",e:5}],"-1#149917321":[{m:"Hc7xb5",e:5}],"1#-98156755":[{m:"Rc5xb5",e:5}],"-1#379734370":[{m:"Cf8-f5",e:5}],"1#1986997629":[{m:"Cc10-c9+",e:5}],"-1#1114140805":[{m:"Rd9-d8",e:5}],"1#1481036722":[{m:"Rb5-b9",e:5}],"-1#944695037":[{m:"Ke9-e10",e:5}],"1#432201048":[{m:"Cc9-c10+",e:5}],"-1#767918240":[{m:"Ad10-e9",e:5}],"1#-1056655279":[{m:"Cc10-a10",e:5}],"-1#-640979966":[{m:"Ke10-d10",e:5}],"1#-1606563461":[{m:"Rb9-b10+",e:5}],"-1#1325573554":[{m:"Kd10-d9",e:5}],"1#1764476817":[{m:"Hg3-h1",e:5}],"-1#647391833":[{m:"Hd5-f4",e:6.667},{m:"Cf5-e5",e:6.667}],"1#-1837973422":[{m:"Rb10-b4",e:5}],"-1#139521988":[{m:"Rd8xd1+",e:5}],"1#-430364512":[{m:"Ae2xd1",e:5}],"-1#98779628":[{m:"Hf4-d3+",e:5}],"1#-1391270433":[{m:"Ke1-f1",e:5}],"-1#676981286":[{m:"Hd3xb4",e:5}],"1#-1602929302":[{m:"Ca10xg10",e:5}],"-1#1995529543":[{m:"Hb4-d5",e:5}],"1#-230503708":[{m:"Hh1-g3",e:5}],"-1#-1107335380":[{m:"Cf5xa5",e:5}],"1#-2068309618":[{m:"Ke1-f1",e:6.667}],"-1#32708215":[{m:"Rd8-f8+",e:6.667},{m:"Ce5-f5",e:6.667}],"1#-1293900892":[{m:"Kf1-e1",e:5}],"-1#933997661":[{m:"Cf5-e5",e:6.667}],"1#-1545771616":[{m:"Hg3-h1",e:5}],"1#1713890390":[{m:"Ch3-e3",e:7.5},{m:"Hh1-g3",e:7.5}],"-1#1018195378":[{m:"Hh10-g8",e:5}],"1#-26700033":[{m:"Hh1-g3",e:5}],"-1#-1311425737":[{m:"Ri10-h10",e:5}],"1#-342604090":[{m:"Hb1-a3",e:5}],"-1#697977246":[{m:"Hh10-g8",e:6.667}],"1#-347950381":[{m:"Ri1-h1",e:6.667}],"-1#-505419293":[{m:"Ri10-h10",e:6.667}],"1#-1147235310":[{m:"Eg1-e3",e:6.667},{m:"Hb1-a3",e:6.667}],"-1#1023906496":[{m:"Hb10-a8",e:5}],"1#2005979842":[{m:"Hb1-a3",e:5}],"-1#1749970586":[{m:"Ra10-b10",e:5}],"1#1346125827":[{m:"Ra1-a2",e:5}],"-1#-646068056":[{m:"Cb8-d8",e:5}],"1#-1271374757":[{m:"Ra2-d2",e:5}],"-1#1614585441":[{m:"Ad10-e9",e:5}],"1#-1929533808":[{m:"Rd2-d5",e:5}],"-1#-1782781820":[{m:"Rh10-h6",e:5}],"1#812339678":[{m:"a4-a5",e:5}],"-1#503706770":[{m:"g7-g6",e:5}],"1#1801389039":[{m:"Af1-e2",e:5}],"-1#856090917":[{m:"Hg8-f6",e:5}],"1#-1854456426":[{m:"Rd5-d6",e:5}],"-1#355059518":[{m:"Hf6xg4",e:5}],"1#-141047729":[{m:"Ch3-i3",e:5}],"-1#-1539299254":[{m:"Hb10-a8",e:5}],"1#-287872952":[{m:"Ra1-b1",e:5}],"-1#-662988620":[{m:"Ra10-b10",e:5}],"1#-536234451":[{m:"g4-g5",e:5}],"-1#-1396555584":[{m:"Rh10-h4",e:5}],"1#1753460631":[{m:"Eg1-e3",e:5}],"-1#-300242619":[{m:"Cb8-b4",e:5}],"1#1406656577":[{m:"c4-c5",e:5}],"-1#-1664820023":[{m:"Ce8-c8",e:5}],"1#452000825":[{m:"Ch3-i3",e:5}],"-1#1833644838":[{m:"Rh4xh1",e:5}],"1#-1934988866":[{m:"Hg3xh1",e:5}],"-1#-2136632603":[{m:"Ec10-e8",e:5}],"1#-1405644282":[{m:"Hh1-g3",e:5}],"-1#-477478962":[{m:"g7-g6",e:5}],"1#820421317":[{m:"Ch3-e3",e:5}],"-1#1785801505":[{m:"Ce8xe4+",e:5}],"1#672952976":[{m:"Af1-e2",e:5}],"-1#1883609178":[{m:"Hb10-c8",e:5}],"1#1632996070":[{m:"Hh1-g3",e:5}],"-1#786966318":[{m:"Ce4-e6",e:5}],"1#1764734613":[{m:"Ri1-h1",e:5}],"-1#1672670629":[{m:"Ch8-g8",e:5}],"1#357155695":[{m:"Hb1-a3",e:5}],"-1#177700663":[{m:"Eg10-e8",e:5}],"1#-909491256":[{m:"Rh1-h9",e:5}],"-1#-544933770":[{m:"Ra10-a9",e:5}],"1#-941792969":[{m:"Rh9xa9",e:5}],"-1#629943815":[{m:"Hc8xa9",e:5}],"1#1942063864":[{m:"Ra1-b1",e:5}],"-1#1164802564":[{m:"Ha9-c8",e:5}],"1#-49975351":[{m:"Hg3-e4",e:5}],"-1#511236822":[{m:"Hh10-f9",e:5}],"1#-384190507":[{m:"Ce3xe6",e:5}],"-1#-1345126567":[{m:"e7xe6",e:5}],"1#-505456668":[{m:"He4-c5",e:5}],"-1#1127450911":[{m:"Hf9-d8",e:5}],"1#-2100052307":[{m:"Hc5-d7",e:5}],"-1#1459332346":[{m:"Ri10-i9",e:5}],"1#391213214":[{m:"Rb1-b8",e:5}],"-1#1056790052":[{m:"Af10-e9",e:5}],"1#844534454":[{m:"Rb8xc8",e:5}],"-1#-1970980233":[{m:"Cg8xg4",e:5}],"1#2058272103":[{m:"Cc3-f3",e:5}],"-1#150333024":[{m:"Cg4-e4+",e:5}],"1#2137480263":[{m:"Ec1-e3",e:5}],"-1#-847138194":[{m:"Ri9-f9",e:5}],"1#-641309812":[{m:"Cf3-f1",e:5}],"-1#-126284082":[{m:"i7-i6",e:5}],"1#-141246447":[{m:"Hd7-c5",e:5}],"-1#599579206":[{m:"e6-e5",e:5}],"1#-813900046":[{m:"Hc5-b7",e:5}],"-1#-2037338020":[{m:"Rf9-h9",e:5}],"1#-1849488304":[{m:"Hb7-c9+",e:5}],"-1#1317115160":[{m:"Ke10-f10",e:5}],"1#868856298":[{m:"Rc8xc7",e:5}],"-1#-172266742":[{m:"Ee8-g6",e:5}],"1#-1674542525":[{m:"Rc7-f7+",e:5}],"-1#-1147491857":[{m:"Hd8-f9",e:5}],"1#2054856285":[{m:"Rf7-f4",e:5}],"-1#-1742952157":[{m:"Ce4xa4",e:5}],"1#1098270244":[{m:"c4-c5",e:5}],"-1#-1905952084":[{m:"Ca4-a6",e:5}],"1#-2118425220":[{m:"Rf4-f6",e:5}],"-1#-879173181":[{m:"Ca6-a4",e:5}],"1#-1001980397":[{m:"Cf1-f4",e:5}],"-1#1081531663":[{m:"Ca4xi4",e:5}],"1#388028074":[{m:"Ke1-f1",e:5}],"-1#-1838425773":[{m:"Rh9-h2",e:5}],"1#-1131548611":[{m:"Kf1-e1",e:5}],"-1#969342916":[{m:"Ci4-i1+",e:5}],"1#2117952718":[{m:"Ae2-f1",e:5}],"-1#644124164":[{m:"Rh2-f2",e:5}],"1#-280762555":[{m:"Ad1-e2",e:5}],"-1#-1605700027":[{m:"e5-e4",e:5}],"1#457646788":[{m:"Ha3-c4",e:5}],"-1#1048562438":[{m:"Rf2xf4",e:5}],"1#828017224":[{m:"Rf6xf4",e:5}],"-1#1721221":[{m:"e4xf4",e:5}],"1#1959237067":[{m:"Hc4-e5",e:5}],"-1#130691531":[],"-1#1576983865":[{m:"Hh10-g8",e:9.995},{m:"Cb8-c8",e:9.995},{m:"Ch8-c8",e:9.995},{m:"Ec10-e8",e:9.995},{m:"c7-c6",e:9.995},{m:"Ch8-d8",e:9.995},{m:"g7-g6",e:9.995},{m:"Hh10-i8",e:9.995},{m:"Hb10-c8",e:9.995},{m:"Cb8-f8",e:9.995},{m:"Hb10-a8",e:9.995},{m:"Cb8-e8",e:9.995},{m:"Ch8-f8",e:9.995},{m:"Ch8-e8",e:9.995}],"1#-1624889740":[{m:"g4-g5",e:9.885},{m:"Ra1-a2",e:9.885},{m:"c4-c5",e:9.885},{m:"Cb3-a3",e:9.885},{m:"Hh1-g3",e:9.885},{m:"Hb1-c3",e:9.999}],"-1#-739389287":[{m:"Ch8-i8",e:9.714},{m:"c7-c6",e:9.714}],"1#-301157782":[{m:"Ch3-f3",e:7.5},{m:"Hh1-g3",e:7.5}],"1#277490594":[{m:"Ch3-f3",e:9.722},{m:"Cb3-a3",e:9.722}],"-1#375893727":[{m:"Hb10-c8",e:5}],"1#125287523":[{m:"Ra2-d2",e:5}],"-1#-747405735":[{m:"Ra10-a9",e:5}],"1#-886380776":[{m:"Ch3-e3",e:5}],"-1#-1849856260":[{m:"Ri10-h10",e:5}],"1#-872672499":[{m:"e4-e5",e:5}],"-1#-1397215464":[{m:"Hb10-c8",e:8},{m:"Cb8-e8",e:8}],"1#-1113047644":[{m:"Ra1-b1",e:7.5}],"1#-1726998352":[{m:"Ra1-b1",e:5}],"-1#-1346574260":[{m:"Hb10-c8",e:5}],"-1#-795112516":[{m:"Ec10-e8",e:5}],"1#-66483361":[{m:"Ra1-a2",e:5}],"-1#1967653876":[{m:"Hb10-a8",e:5}],"1#1071596534":[{m:"Ra2-f2",e:5}],"-1#-1912747302":[{m:"Ri10-i9",e:5}],"-1#-978210928":[{m:"Ri10-h10",e:9.231},{m:"Hh10-g8",e:8.333},{m:"Ri10-i9",e:9.231},{m:"c7-c6",e:9.231}],"1#-1611607455":[{m:"Hh1-g3",e:8.889}],"1#-788490405":[{m:"Hh1-g3",e:7.5},{m:"g4-g5",e:7.5}],"-1#-1631765869":[{m:"Hh10-g8",e:5}],"1#1550172638":[{m:"Ra1-b1",e:5}],"-1#1791570210":[{m:"g7-g6",e:5}],"1#529778271":[{m:"c4-c5",e:5}],"-1#-796853545":[{m:"Ec10-e8",e:5}],"1#-65865164":[{m:"Cb3-a3",e:5}],"-1#-812846248":[{m:"Ri10-i9",e:6.667},{m:"Hb10-d9",e:6.667}],"1#-1910102212":[{m:"Ri1-i2",e:7.5}],"-1#-614306988":[{m:"Cc8xc5",e:7.5},{m:"Hg8-h6",e:7.5}],"1#-978416574":[{m:"Rb1-b9",e:5}],"-1#-522863545":[{m:"Hd9-f8",e:5}],"1#905471078":[{m:"Hc3-d5",e:5}],"-1#532388443":[{m:"Hf8-e6",e:5}],"-1#-1647615562":[{m:"Hb10-a8",e:6.667},{m:"c7-c6",e:6.667}],"1#-681827916":[{m:"Ch3-f3",e:5}],"-1#-234850547":[{m:"Ra10-b10",e:5}],"1#-898475628":[{m:"Ra1-b1",e:5}],"-1#-52516504":[{m:"Rb10-b6",e:5}],"1#-1882402562":[{m:"Hh1-g3",e:5}],"-1#-1066304202":[{m:"Ch8-e8",e:5}],"1#1588370061":[{m:"Hh1-g3",e:5}],"-1#286340933":[{m:"Eg10-e8",e:5}],"1#-766768198":[{m:"Ra1-b1",e:5}],"-1#-455017658":[{m:"Hb10-a8",e:5}],"1#-1367884988":[{m:"Cb3-a3",e:5}],"-1#-1645628888":[{m:"Hh10-f9",e:5}],"1#-1518421117":[{m:"g4-g5",e:6.667},{m:"Cb3-a3",e:6.667}],"-1#-373994130":[{m:"Hh10-g8",e:5}],"1#728610339":[{m:"Hh1-g3",e:5}],"-1#1691360235":[{m:"Ri10-h10",e:5}],"1#1049716250":[{m:"Ri1-h1",e:5}],"-1#873217322":[{m:"c7-c6",e:5}],"1#-143931887":[{m:"Cb3-b5",e:6.667},{m:"Cb3-a3",e:6.667}],"-1#-1071475025":[{m:"Rh10-h4",e:5}],"1#73628152":[{m:"Hg3-f5",e:5}],"-1#1385245343":[{m:"c6-c5",e:5}],"1#-591724290":[{m:"Cb5-a5",e:5}],"-1#-990523523":[{m:"Ec10-e8",e:5}],"1#-395849826":[{m:"Ra1-b1",e:5}],"-1#-557105310":[{m:"Hb10-d9",e:5}],"1#-722911112":[{m:"Ec1-e3",e:5}],"-1#-1763659025":[{m:"Ec10-e8",e:5}],"1#-1166888436":[{m:"Ra1-b1",e:5}],"-1#-1931590928":[{m:"Hb10-d9",e:5}],"1#-2030289430":[{m:"Ri1-i2",e:5}],"-1#-742887038":[{m:"Cb8-b10",e:5}],"1#-952192184":[{m:"Ri2-d2",e:5}],"-1#1762860971":[{m:"Cc8-b8",e:5}],"1#87880629":[{m:"Rb1-a1",e:5}],"-1#865076041":[{m:"Ra10-a9",e:5}],"1#734632456":[{m:"Ra1-a2",e:5}],"-1#-1568140637":[{m:"Ad10-e9",e:5}],"1#1313417810":[{m:"Ch3-h9",e:5}],"-1#-543842149":[{m:"Ri10-i9",e:5}],"1#-1640008449":[{m:"Ch9xd9",e:5}],"-1#-1726991072":[{m:"Ae9-d8",e:5}],"1#1902960090":[{m:"Cb3-a3",e:8},{m:"Ch3-e3",e:8}],"-1#1123210422":[{m:"Hb10-c8",e:7.5}],"1#1407370762":[{m:"Ra1-b1",e:7.5}],"-1#1699624694":[{m:"Ra10-b10",e:7.5},{m:"Cb8-a8",e:7.5}],"1#1564219503":[{m:"c4-c5",e:6.667}],"-1#-1842404121":[{m:"g7-g6",e:6.667},{m:"Hh10-g8",e:6.667}],"1#-411708518":[{m:"Rb1-b7",e:9.919}],"1#1358421930":[{m:"g4-g5",e:5}],"1#-1404304074":[{m:"c4-c5",e:5}],"-1#1667185086":[{m:"Ad10-e9",e:5}],"1#-1885470385":[{m:"g4-g5",e:5}],"-1#-1017776222":[{m:"Hh10-i8",e:5}],"1#1261355102":[{m:"Hh1-g3",e:5}],"-1#737891390":[{m:"Hh10-g8",e:5}],"1#-383537293":[{m:"Hh1-g3",e:5}],"-1#-1499594053":[{m:"Ri10-h10",e:5}],"1#-52461750":[{m:"c4-c5",e:6.667},{m:"g4-g5",e:6.667}],"-1#869024706":[{m:"c7-c6",e:9.474},{m:"Ch8-i8",e:9.474},{m:"Cb8-c8",e:9.474},{m:"g7-g6",e:9.474},{m:"Hb10-d9",e:9.474}],"-1#-1340831321":[{m:"Ch8-i8",e:6.667}],"1#-1913263276":[{m:"Ra1-a2",e:9.5},{m:"Cb3-a3",e:9.5},{m:"c4-c5",e:9.5}],"-1#-1100225992":[{m:"Rh10-h6",e:9.231}],"1#-1634130430":[{m:"Ch3-e3",e:9.994},{m:"g4-g5",e:9.994},{m:"Hh1-g3",e:9.994},{m:"Ch3-f3",e:9.994},{m:"Ra1-a2",e:9.994},{m:"Cb3-b5",e:9.994},{m:"Hb1-c3",e:9.412},{m:"Cb3-a3",e:9.994},{m:"i4-i5",e:9.994}],"-1#-1005670426":[{m:"Ch8-e8",e:9.974},{m:"Ec10-e8",e:9.974},{m:"c7-c6",e:9.231}],"-1#-766324497":[{m:"c7-c6",e:9.714}],"-1#-786134070":[{m:"g7-g6",e:8.75},{m:"c7-c6",e:7.5}],"1#-1535214409":[{m:"Cb3-a3",e:7.5}],"1#-1070294666":[{m:"Ri1-i2",e:8.75},{m:"Ch3-i3",e:8.75}],"-1#-1144688453":[{m:"g7-g6",e:9.96},{m:"Hh10-g8",e:9.96},{m:"Ch8-d8",e:9.96}],"-1#400076457":[{m:"Hb10-c8",e:9},{m:"Cb8-c8",e:9},{m:"Ch8-c8",e:9}],"-1#-1445955908":[{m:"Hb10-c8",e:5}],"1#-1195351040":[{m:"Cb5-i5",e:5}],"-1#1060692266":[{m:"Hh10-i8",e:5}],"-1#-2028526020":[{m:"Hb10-c8",e:8.75},{m:"Ch8-e8",e:8.75},{m:"c7-c6",e:5}],"1#-1777912704":[{m:"Ec1-e3",e:8.333},{m:"Ri1-i2",e:8.333},{m:"i4-i5",e:8.333}],"-1#618781353":[{m:"Ch8-e8",e:5}],"-1#-1018988312":[{m:"Hb10-c8",e:5}],"1#-860965321":[{m:"Ri2-d2",e:6.667}],"-1#1652759252":[{m:"Hh10-i8",e:6.667}],"1#-352834264":[{m:"Rd2-d5",e:6.667}],"-1#-1863123558":[{m:"Ec10-e8",e:6.667},{m:"Ri10-i9",e:6.667}],"1#-1134494343":[{m:"Ec1-e3",e:5}],"-1#243667792":[{m:"Ch8-f8",e:5}],"1#-845198983":[{m:"Ad1-e2",e:5}],"-1#-2104076167":[{m:"Ri10-h10",e:5}],"1#-782751234":[{m:"Ad1-e2",e:6.667},{m:"i6-i7",e:6.667}],"-1#2029818924":[{m:"Ca6-a7",e:5}],"-1#672672992":[{m:"Hh10-g8",e:5}],"1#-461482233":[{m:"Ri1-h1",e:5}],"-1#-287110089":[{m:"Hh10-g8",e:5}],"1#742127482":[{m:"i4-i5",e:5}],"-1#-1843073254":[{m:"Hb10-c8",e:5}],"1#-2093679194":[{m:"Cb3-b5",e:5}],"1#1171250545":[{m:"Ri1-i2",e:6.667}],"-1#277582105":[{m:"Hb10-c8",e:6.667}],"1#26968997":[{m:"Ri2-d2",e:7.5}],"-1#-1347014842":[{m:"i7-i6",e:7.5},{m:"g7-g6",e:7.5}],"1#-1604591207":[{m:"Rd2-d5",e:6.667}],"-1#-632213205":[{m:"Ch8-i8",e:6.667}],"1#-407874600":[{m:"c4-c5",e:6.667},{m:"Ch3-f3",e:6.667}],"-1#681799504":[{m:"c6xc5",e:5}],"-1#-1024719519":[{m:"Ri10-h10",e:5}],"1#-1733461872":[{m:"Ad1-e2",e:5}],"1#-622012357":[{m:"Rd2-d9",e:5}],"-1#-867300752":[{m:"Af10-e9",e:5}],"1#-1058681118":[{m:"Ec1-e3",e:5}],"-1#1912807627":[{m:"Ch8-h9",e:5}],"1#712000200":[{m:"Rd9-d5",e:5}],"-1#1527084864":[{m:"Hg8-f6",e:5}],"1#-109796365":[{m:"Rd5-f5",e:5}],"-1#-1392038034":[{m:"Hb10-c8",e:9.932},{m:"Hb10-a8",e:9.932},{m:"Cb8-g8",e:9.932}],"-1#545668706":[{m:"Hh10-g8",e:5}],"1#-497105617":[{m:"Ra1-a2",e:5}],"-1#1797213572":[{m:"Cb8-e8",e:5}],"1#1242395892":[{m:"c4-c5",e:8.333},{m:"Ch3-e3",e:8.333},{m:"Cb3-a3",e:8.333}],"-1#278592784":[{m:"Hh10-g8",e:7.5}],"1#-767424931":[{m:"Hh1-g3",e:7.5}],"-1#-1644188779":[{m:"Ri10-h10",e:7.5},{m:"Eg10-e8",e:7.5}],"1#-943794588":[{m:"Ri1-i2",e:6.667}],"-1#-1829070324":[{m:"Rh10-h6",e:6.667},{m:"Hb10-c8",e:6.667}],"1#1587713898":[{m:"c4-c5",e:5}],"-1#-1850627102":[{m:"Af10-e9",e:5}],"1#-1659211920":[{m:"Ri1-h1",e:6.667}],"-1#2039709080":[{m:"Hh10-g8",e:5}],"1#-1152678187":[{m:"Ra1-b1",e:5}],"-1#-1914210775":[{m:"Cb8-c8",e:5}],"1#18431051":[{m:"Hh1-g3",e:5}],"-1#1319408003":[{m:"Hb10-a8",e:5}],"1#70504833":[{m:"g4-g5",e:5}],"-1#1224222572":[{m:"Ri10-h10",e:5}],"1#314137245":[{m:"Hg3-f5",e:5}],"-1#1145768442":[{m:"Ra10-b10",e:5}],"1#2084120419":[{m:"Rb1xb10",e:5}],"1#681847364":[{m:"c4-c5",e:9.924},{m:"Ch3-f3",e:9.924},{m:"Ch3-e3",e:9.924},{m:"Ra1-a2",e:9.924},{m:"Ch3-g3",e:9.924},{m:"Cb3-a3",e:9.924},{m:"Eg1-e3",e:9.924}],"-1#234388733":[{m:"Hh10-g8",e:8},{m:"g7-g6",e:9.96},{m:"Ch8-f8",e:8}],"1#-819951696":[{m:"Cb3-a3",e:5}],"1#-824105260":[{m:"Hh1-i3",e:5}],"-1#1915986848":[{m:"Hb10-c8",e:9.286},{m:"Hh10-g8",e:9.286}],"1#1663283484":[{m:"Hh1-g3",e:8}],"1#-1326753555":[{m:"Hh1-g3",e:9.091}],"-1#-1578786065":[{m:"Hh10-g8",e:8.571},{m:"Eg10-e8",e:8.571},{m:"Ec10-e8",e:8.571}],"1#1664965026":[{m:"Eg1-e3",e:6.667}],"1#1656266256":[{m:"g4-g5",e:6.667}],"-1#911881826":[{m:"Hh10-i8",e:9.412},{m:"Eg10-e8",e:9.412},{m:"Ec10-e8",e:9.412}],"1#-1105133154":[{m:"Hh1-i3",e:6.667}],"1#449328769":[{m:"Hh1-i3",e:8.333}],"-1#456794920":[{m:"Cb8-e8",e:8.75},{m:"Hb10-c8",e:8.75},{m:"Cb8-d8",e:8.75}],"1#1988081627":[{m:"Ra1-b1",e:5}],"-1#-1371722602":[{m:"Hh10-g8",e:9.949},{m:"Ch8-f8",e:9.949},{m:"c7-c6",e:9.949},{m:"Hb10-c8",e:9.949}],"1#-712643899":[{m:"c4-c5",e:5}],"-1#446092877":[{m:"Ri10-i9",e:5}],"1#1530659369":[{m:"Hh1-g3",e:5}],"-1#344043489":[{m:"Ec10-e8",e:5}],"1#940814082":[{m:"Ri1-i2",e:8.333},{m:"Ch3-i3",e:8.333},{m:"Ec1-e3",e:8.333}],"-1#1834476394":[{m:"Ri9-d9",e:5}],"1#-1840035115":[{m:"g4-g5",e:5}],"-1#-560415688":[{m:"Hb10-c8",e:5}],"1#-813126012":[{m:"Hg3-h5",e:6.667},{m:"Ec1-e3",e:6.667}],"-1#-32769787":[{m:"Ch8-f8",e:5}],"1#1024631596":[{m:"Ri2-f2",e:5}],"-1#2104377517":[{m:"Ra10-c10",e:6.667}],"-1#1336434717":[{m:"Ri9-d9",e:7.5},{m:"Ri9-c9",e:7.5}],"1#-1330853470":[{m:"Ri1-h1",e:6.667}],"-1#-1171156334":[{m:"Rd9-d6",e:6.667}],"1#1345380497":[{m:"g4-g5",e:6.667}],"1#523090518":[{m:"Hc3-d5",e:5}],"-1#896418923":[{m:"c7-c6",e:5}],"1#-167133360":[{m:"c5xc6",e:5}],"-1#-1963638485":[{m:"c7-c6",e:5}],"1#1234352656":[{m:"c5xc6",e:5}],"-1#1979826628":[{m:"Ri9-c9",e:5}],"1#646192015":[{m:"Hc3-d5",e:5}],"-1#214427058":[{m:"Rc9xc6",e:5}],"1#1160304816":[{m:"g4-g5",e:5}],"-1#165883485":[{m:"Rc6-d6",e:5}],"1#1230504526":[{m:"Ch3-h5",e:5}],"1#1290719109":[{m:"c4-c5",e:7.5},{m:"Hb1-c3",e:9.942}],"-1#2439528":[{m:"c7-c6",e:7.5},{m:"Ra10-a9",e:7.5},{m:"Eg10-e8",e:7.5}],"1#-1019035053":[{m:"Hh1-g3",e:9.986},{m:"Ch3-e3",e:9.986},{m:"Ra1-a2",e:9.986},{m:"g4-g5",e:5}],"-1#1906584698":[{m:"Hb10-c8",e:5}],"1#1563831449":[{m:"Hh1-g3",e:6.667}],"-1#311132497":[{m:"c7-c6",e:5}],"1#410820649":[{m:"Cb3-a3",e:5}],"-1#736274757":[{m:"Eg10-e8",e:5}],"1#-390097478":[{m:"Ra1-b1",e:5}],"-1#-569154234":[{m:"Cb8-a8",e:5}],"1#387012230":[{m:"Rb1-b5",e:5}],"1#-1015544425":[{m:"Ch3-e3",e:5}],"-1#-1712354189":[{m:"Ch8-f8",e:5}],"1#1526126170":[{m:"Ri1-i3",e:5}],"-1#-14080922":[{m:"Hh10-g8",e:5}],"1#1039261483":[{m:"Ri3-f3",e:5}],"1#1869634249":[{m:"Ra1-b1",e:7.5},{m:"Hb1-c3",e:9.545}],"-1#1507633717":[{m:"Hb10-c8",e:6.667}],"1#1221376137":[{m:"c4-c5",e:6.667}],"1#392797499":[{m:"Ch3-e3",e:5}],"-1#1308497119":[{m:"Ch8-e8",e:5}],"1#781673956":[{m:"Ri1-i2",e:5}],"-1#2077436300":[{m:"Hh10-g8",e:5}],"1#-1190407487":[{m:"Hh1-g3",e:5}],"-1#-155812087":[{m:"Cb8-d8",e:7.5},{m:"Ri10-h10",e:7.5},{m:"Cb8-c8",e:7.5}],"1#-1678513158":[{m:"Ra1-b1",e:5}],"-1#-1386276090":[{m:"Ra10-b10",e:5}],"1#-1792199265":[{m:"Cb3-b7",e:5}],"-1#-1985888923":[{m:"Af10-e9",e:5}],"1#-2062910985":[{m:"g4-g5",e:5}],"-1#-910061798":[{m:"Ri10-h10",e:5}],"1#-1820265749":[{m:"c4-c5",e:5}],"-1#1553190499":[{m:"Rh10-h6",e:5}],"1#-1393097992":[{m:"g4-g5",e:6.667},{m:"Ri2-d2",e:6.667}],"-1#-532876267":[{m:"Rh10-h6",e:7.5}],"1#1173048655":[{m:"Ri2-d2",e:7.5},{m:"Ra1-a2",e:7.5}],"-1#47885851":[{m:"Af10-e9",e:8},{m:"Rh10-h6",e:8}],"1#-1492314303":[{m:"Ra1-a2",e:8.75}],"1#2051552619":[{m:"Ra1-b1",e:5}],"-1#1290061207":[{m:"c7-c6",e:5}],"1#-1887224148":[{m:"Ri2-d2",e:5}],"-1#565088847":[{m:"c6-c5",e:5}],"1#-1350256594":[{m:"Hc3-e2",e:5}],"-1#-2064870743":[{m:"Ra10-b10",e:5}],"1#-1130447824":[{m:"Cb3-b7",e:5}],"1#1750526609":[{m:"Ch3-f3",e:9.333},{m:"Ra1-b1",e:9.333},{m:"Hb1-c3",e:9.231},{m:"Hb1-c3",e:9.796}],"-1#1292549160":[{m:"c7-c6",e:9.966},{m:"g7-g6",e:9.966},{m:"Hh10-i8",e:9.966},{m:"Hb10-c8",e:9.966}],"1#-1905441005":[{m:"Hh1-g3",e:5}],"-1#-1043272997":[{m:"Ch8-g8",e:5}],"1#944786261":[{m:"Ra1-b1",e:8.75}],"1#-982414380":[{m:"Hh1-g3",e:7.5}],"1#1545252500":[{m:"c4-c5",e:9.965}],"-1#1593449069":[{m:"Hb10-c8",e:8.75}],"1#1340737745":[{m:"Hh1-g3",e:8.75},{m:"c4-c5",e:8.75},{m:"Cb3-a3",e:8.75}],"-1#5743897":[{m:"Ra10-b10",e:8.75},{m:"c7-c6",e:8.75}],"1#941984640":[{m:"c4-c5",e:8.571}],"-1#2087977405":[{m:"c7-c6",e:6.667},{m:"Ch8-f8",e:6.667}],"1#-1083352172":[{m:"Hh1-g3",e:5}],"-1#669730649":[{m:"Hb10-c8",e:8.75}],"1#922441189":[{m:"g4-g5",e:8.75},{m:"Hh1-g3",e:8.75}],"-1#2050007816":[{m:"e7-e6",e:9.444},{m:"c7-c6",e:9.444}],"1#-1628993776":[{m:"Ch3-d3",e:6.667},{m:"c4-c5",e:6.667}],"-1#497390280":[{m:"Hb10-c8",e:5}],"1#213221492":[{m:"Cb3-a3",e:5}],"-1#1059817752":[{m:"c7-c6",e:5}],"1#-62098909":[{m:"Ra1-b1",e:5}],"-1#-891256097":[{m:"Ra10-b10",e:5}],"1#-225268666":[{m:"Rb1-b5",e:5}],"-1#-1438867843":[{m:"Hh10-g8",e:5}],"1#1759798576":[{m:"c4-c5",e:5}],"-1#-1476961864":[{m:"c6xc5",e:5}],"1#-1668315092":[{m:"Rb5xc5",e:5}],"-1#-1562708738":[{m:"Ec10-e8",e:5}],"1#-1907821539":[{m:"Hh1-g3",e:5}],"-1#-1040885291":[{m:"Ri10-h10",e:5}],"1#-1682693084":[{m:"Af1-e2",e:5}],"-1#-1007825170":[{m:"g7-g6",e:5}],"1#1050127362":[{m:"Ch3-f3",e:9.091},{m:"Hh1-g3",e:9.091},{m:"Ra1-a2",e:9.091},{m:"g4-g5",e:9.091},{m:"Cb3-a3",e:9.091},{m:"Hb1-c3",e:9.997}],"-1#466352827":[{m:"Cb8-c8",e:9.6},{m:"c7-c6",e:9.6},{m:"g7-g6",e:9.6},{m:"Hh10-g8",e:9.6}],"1#-1758088999":[{m:"Hh1-g3",e:5}],"-1#-662168303":[{m:"Hh10-g8",e:5}],"1#-659816064":[{m:"g4-g5",e:5}],"-1#-1805125779":[{m:"Hb10-c8",e:5}],"1#1855000006":[{m:"Hh1-g3",e:5}],"-1#556572686":[{m:"Hh10-g8",e:5}],"1#-653065738":[{m:"g4-g5",e:9.545},{m:"Hh1-g3",e:9.545}],"-1#1898578378":[{m:"Hh10-g8",e:8}],"1#-1275921785":[{m:"Ri1-h1",e:8}],"-1#-1183866441":[{m:"Ri10-h10",e:8},{m:"Ri10-i9",e:8}],"1#-483468218":[{m:"g4-g5",e:7.5},{m:"Hb1-c3",e:5}],"-1#-1343935829":[{m:"Hb10-a8",e:8},{m:"Rh10-h6",e:8},{m:"c7-c6",e:8}],"1#-445486423":[{m:"Ch3-h7",e:5}],"1#1820512656":[{m:"Ch3-h7",e:5}],"-1#1372074607":[{m:"g7-g6",e:6.667},{m:"Rh10-h6",e:6.667}],"1#613598482":[{m:"c4-c5",e:5}],"-1#-343803494":[{m:"Hb10-a8",e:8.889},{m:"Cb8-b4",e:8.889}],"1#-1592346216":[{m:"a4-a5",e:8.333},{m:"Ad1-e2",e:8.333}],"-1#-1887953708":[{m:"Cb8-d8",e:6.667}],"-1#-299915112":[{m:"Ad10-e9",e:8}],"1#1447866526":[{m:"Hc3-d5",e:8.571},{m:"Hc3-b5",e:8.571},{m:"Ad1-e2",e:8.571}],"1#-199259339":[{m:"Ad1-e2",e:5}],"-1#-1156146635":[{m:"Cb8-c8",e:5}],"1#938004567":[{m:"c4-c5",e:5}],"-1#-117707553":[{m:"Rh6-b6",e:5}],"1#97342906":[{m:"Ra1-b1",e:5}],"-1#862037318":[{m:"Hb10-a8",e:5}],"1#2046223684":[{m:"g4-g5",e:5}],"-1#893195177":[{m:"Ce8-f8",e:5}],"1#-2003824694":[{m:"Ch3-h5",e:5}],"-1#-120634935":[{m:"Ec10-e8",e:5}],"1#-121276973":[{m:"Hb1-c3",e:5}],"-1#-1887520052":[{m:"Hb10-c8",e:6.667}],"1#-1636915088":[{m:"c4-c5",e:6.667}],"-1#1367184632":[{m:"g7-g6",e:6.667},{m:"Ri9-d9",e:6.667}],"1#606561157":[{m:"Rh1-h7",e:5}],"-1#-1630701064":[{m:"Ri9-d9",e:5}],"1#1640616007":[{m:"Ec1-e3",e:5}],"-1#-751878546":[{m:"Rd9-d4",e:5}],"1#-1036874325":[{m:"Ra1-c1",e:5}],"-1#1718746087":[{m:"Cb8-a8",e:5}],"1#-1351366617":[{m:"Rh7-g7",e:5}],"-1#-1097778737":[{m:"Ra10-b10",e:5}],"1#-2031937706":[{m:"Cb3-a3",e:5}],"-1#-1250091462":[{m:"Rb10-b6",e:5}],"1#-965777492":[{m:"g4-g5",e:5}],"-1#-1968926399":[{m:"c7-c6",e:5}],"1#1237543546":[{m:"Hg3-f5",e:5}],"-1#523319581":[{m:"Rd4-c4",e:5}],"1#1816951989":[{m:"Ca3-a2",e:5}],"-1#-1155729283":[{m:"Rb6-b2",e:5}],"1#2028843831":[{m:"Ad1-e2",e:5}],"-1#937730615":[{m:"Ce8-e9",e:5}],"1#-669079990":[{m:"Ci3-f3",e:5}],"-1#-1759246179":[{m:"Rc4-b4",e:5}],"1#10620422":[{m:"c5xc6",e:5}],"-1#1060206034":[{m:"Ce9-g9",e:5}],"1#-1765728215":[{m:"Rg7-f7",e:5}],"-1#-1473858280":[{m:"Ad10-e9",e:5}],"1#1156025833":[{m:"g5xg6",e:5}],"-1#801805823":[{m:"Cg9xg6",e:5}],"1#558091297":[{m:"Rf7-g7",e:5}],"-1#530864400":[{m:"Ec10-e8",e:5}],"1#859199987":[{m:"c6-c7",e:5}],"-1#1565820743":[{m:"Hc8-d10",e:5}],"1#-619933324":[{m:"Hf5-d6",e:5}],"-1#895796954":[{m:"Cg6-e6",e:5}],"1#-1399676184":[{m:"Cf3-g3",e:5}],"-1#-1964122362":[{m:"Rb4-d4",e:5}],"1#1942727492":[{m:"Hc3-b5",e:5}],"-1#988366120":[{m:"Rd4-d5",e:5}],"1#1189542533":[{m:"Ca2xa7",e:5}],"-1#-648965853":[{m:"Ee8-c6",e:5}],"1#1351205117":[{m:"Cg3xg8",e:5}],"-1#-1082474418":[{m:"Rb2xb5",e:5}],"1#-199337465":[{m:"Ca7xe7+",e:5}],"-1#-1387980223":[{m:"Ca8-e8",e:5}],"1#1278355800":[{m:"Cg8-h8",e:5}],"-1#-785411058":[{m:"Rd5-h5",e:5}],"1#-383936155":[{m:"e4-e5",e:5}],"-1#1855093801":[{m:"Ce6xe3+",e:5}],"1#2113655136":[{m:"Eg1xe3",e:5}],"-1#641014826":[{m:"Rh5xh8",e:5}],"1#-1000064971":[{m:"Hd6-f7",e:5}],"-1#-70650087":[{m:"Rh8-f8",e:5}],"1#-1726700267":[{m:"Ce7-e6",e:5}],"-1#1659918384":[{m:"Hd10-b9",e:5}],"1#-2029100412":[{m:"Rc1xc6",e:5}],"-1#416141707":[{m:"Rb5-d5",e:5}],"1#-1749319995":[{m:"Rc6-b6",e:5}],"1#-1367786169":[{m:"Cb3-a3",e:7.5},{m:"Rh1-h7",e:7.5},{m:"Ad1-e2",e:7.5}],"-1#-1645792213":[{m:"e7-e6",e:5}],"1#1060454748":[{m:"Ra1-b1",e:5}],"-1#161067424":[{m:"Ra10-b10",e:5}],"1#837525305":[{m:"Rb1-b7",e:5}],"-1#289354906":[{m:"Ce8-e7",e:5}],"1#62888971":[{
m:"Rb7-b5",e:5}],"-1#1712861922":[{m:"Cb8-a8",e:5}],"1#-1357250270":[{m:"Rb5xb10",e:5}],"-1#2058557803":[{m:"Hc8xb10",e:5}],"1#-53060121":[{m:"Rh1-h5",e:5}],"-1#1813893967":[{m:"Hb10-c8",e:5}],"1#2098053619":[{m:"Af1-e2",e:5}],"-1#626273081":[{m:"Ce7-e9",e:5}],"1#-973885276":[{m:"Hc3-d5",e:5}],"-1#-273658215":[{m:"Rd9-d7",e:5}],"1#-900223518":[{m:"Ca3-d3",e:5}],"-1#-557523964":[{m:"Rd7-f7",e:5}],"-1#345188154":[{m:"e7-e6",e:5}],"1#-1237233075":[{m:"Af1-e2",e:5}],"-1#-300369785":[{m:"Hc8-e7",e:5}],"1#-532702061":[{m:"Hc3-b5",e:5}],"-1#-1457687809":[{m:"Cb8xb3",e:5}],"1#-685851416":[{m:"Ci3xb3",e:5}],"-1#-395060746":[{m:"e6-e5",e:5}],"1#78896450":[{m:"e4xe5",e:5}],"-1#1787454697":[{m:"He7-f5",e:5}],"1#-385705261":[{m:"Ec1-e3",e:5}],"-1#1541698810":[{m:"Rd9-d4",e:5}],"1#1257883455":[{m:"Hb5xc7",e:5}],"-1#-1188067798":[{m:"Ra10-b10",e:5}],"1#-2124568397":[{m:"Hc7xe8",e:5}],"-1#-334322527":[{m:"Ec10xe8",e:5}],"1#1117682102":[{m:"Cb3-d3",e:5}],"-1#349974429":[{m:"Rd4xg4",e:5}],"-1#-512742329":[{m:"Rd9-d4",e:5}],"1#-261251198":[{m:"Rh1-h5",e:5}],"-1#1621496106":[{m:"e7-e6",e:5}],"1#-1032559523":[{m:"Cb3-b7",e:5}],"-1#-554111833":[{m:"e6-e5",e:5}],"1#842590227":[{m:"Rh5xe5",e:5}],"-1#-626547679":[{m:"Hg8-e7",e:5}],"1#586890240":[{m:"Re5-h5",e:5}],"-1#600976597":[{m:"c7-c6",e:5}],"1#-524953618":[{m:"Ec1-e3",e:5}],"-1#1381185991":[{m:"Rd4-c4",e:5}],"1#556694639":[{m:"Ra1-c1",e:5}],"-1#-2056451549":[{m:"Hc8-d6",e:5}],"1#-1344298592":[{m:"Ci3xi7",e:5}],"-1#-129998160":[{m:"g7-g6",e:5}],"1#-1927637555":[{m:"Ci7-i10",e:5}],"-1#-1509305246":[{m:"Ce8-d8",e:5}],"-1#-1210702679":[{m:"Hh10-g8",e:5}],"1#1963909092":[{m:"Hh1-g3",e:5}],"-1#984838700":[{m:"Ri10-h10",e:5}],"1#1626476509":[{m:"Ri1-h1",e:5}],"-1#1785681133":[{m:"Hb10-a8",e:5}],"1#553129199":[{m:"g4-g5",e:5}],"-1#1815339522":[{m:"Rh10-h6",e:5}],"-1#1918655215":[{m:"Hh10-g8",e:5}],"1#-1333485150":[{m:"Hh1-g3",e:5}],"-1#-13038486":[{m:"Ri10-h10",e:6.667},{m:"Hb10-a8",e:6.667}],"1#-1518833253":[{m:"g4-g5",e:7.5}],"1#-1246868376":[{m:"Ri1-h1",e:5}],"-1#218735982":[{m:"Hb10-c8",e:5}],"1#471447506":[{m:"Ra1-b1",e:5}],"-1#716523310":[{m:"Ra10-b10",e:5}],"1#315058615":[{m:"Rb1-b7",e:5}],"-1#840155668":[{m:"Cb8-a8",e:5}],"1#-82710060":[{m:"Rb7xc7",e:5}],"-1#1677731302":[{m:"Hh10-g8",e:7.5}],"1#-1495736661":[{m:"Hh1-g3",e:7.5}],"-1#-379227293":[{m:"c7-c6",e:9.63},{m:"Ri10-i9",e:9.63},{m:"Hb10-c8",e:9.63},{m:"Ri10-h10",e:9.63}],"-1#-1992314714":[{m:"Cb8-c8",e:9.998},{m:"Ch8-g8",e:9.998},{m:"Cb8-g8",e:9.998},{m:"Ch8-d8",e:9.998},{m:"Ec10-e8",e:9.998},{m:"Hh10-g8",e:9.998},{m:"g7-g6",e:9.998},{m:"Hb10-c8",e:9.998},{m:"Hh10-i8",e:9.998},{m:"Ch8-e8",e:9.998},{m:"c7-c6",e:9.998},{m:"Hb10-a8",e:9.998},{m:"e7-e6",e:9.998},{m:"Ch8-c8",e:9.998},{m:"Eg10-e8",e:9.998},{m:"Ch8-f8",e:9.998},{m:"Cb8-f8",e:9.998},{m:"Cb8-d8",e:9.998},{m:"Cb8-e8",e:9.998}],"1#96598724":[{m:"g4-g5",e:9.167},{m:"c4-c5",e:9.167},{m:"Hb1-a3",e:9.167}],"-1#1225395241":[{m:"Hb10-a8",e:7.5}],"1#60640299":[{m:"Hb1-c3",e:8}],"-1#1371875174":[{m:"c7-c6",e:8},{m:"Ra10-b10",e:8}],"1#-1834820515":[{m:"Ra1-b1",e:6.667}],"1#1773603327":[{m:"Ra1-b1",e:7.5}],"-1#1595668739":[{m:"Rb10-b6",e:7.5}],"-1#438257308":[{m:"Ch8-e8",e:8.571},{m:"a7-a6",e:8.571},{m:"Hb10-a8",e:8.571}],"1#2037790631":[{m:"Hh1-g3",e:6.667}],"-1#919313007":[{m:"Hh10-g8",e:6.667}],"1#507337630":[{m:"Ra1-b1",e:6.667}],"1#1351091870":[{m:"Ra1-b1",e:6.667}],"1#-3891604":[{m:"c4-c5",e:6.667},{m:"g4-g5",e:6.667}],"-1#819438308":[{m:"Hh10-i8",e:5}],"1#-1196649192":[{m:"Hb1-c3",e:5}],"-1#-353042859":[{m:"Ri10-h10",e:5}],"1#-1330281564":[{m:"Hh1-f2",e:5}],"-1#-2032123595":[{m:"Cb8-f8",e:5}],"1#-1267808571":[{m:"Ra1-b1",e:5}],"-1#-2101201351":[{m:"Hb10-c8",e:5}],"1#-1814944635":[{m:"Ri1-h1",e:5}],"-1#-1722843211":[{m:"Rh10-h6",e:6.667}],"1#1016645359":[{m:"Ch3-i3",e:6.667},{m:"Ch3-g3",e:6.667}],"-1#-1290835839":[{m:"Cb8-e8",e:9.811},{m:"Hh10-i8",e:9.811},{m:"c7-c6",e:9.811}],"1#-2035851479":[{m:"Hh1-g3",e:9},{m:"Hb1-c3",e:9}],"1#997482365":[{m:"i4-i5",e:9.767},{m:"Hh1-f2",e:9.767}],"1#1885901754":[{m:"Hh1-g3",e:5}],"-1#1070939762":[{m:"Hh10-i8",e:5}],"1#-2145072481":[{m:"Ra1-a2",e:6.667},{m:"Hb1-c3",e:6.667}],"-1#157631028":[{m:"Ra10-a8",e:5}],"1#-798878996":[{m:"Ra2-f2",e:5}],"-1#1648401344":[{m:"Ra8-f8",e:5}],"1#1706252574":[{m:"Ch3-i3",e:5}],"-1#302552577":[{m:"Eg10-e8",e:5}],"1#-782914818":[{m:"c4-c5",e:5}],"-1#507942518":[{m:"Hh10-f9",e:5}],"1#-383255691":[{m:"Hb1-c3",e:5}],"-1#-1149267912":[{m:"Hb10-c8",e:5}],"1#-1435532668":[{m:"Hc3-d5",e:5}],"-1#-2144568135":[{m:"Ri10-h10",e:5}],"-1#-763584046":[{m:"Hb10-c8",e:5}],"1#-1016286354":[{m:"Ra1-b1",e:5}],"-1#-171949166":[{m:"Ra10-b10",e:5}],"1#-843944693":[{m:"Cb3-b7",e:5}],"-1#-784407055":[{m:"c7-c6",e:5}],"1#307830474":[{m:"Hh1-f2",e:5}],"-1#604822619":[{m:"Eg10-e8",e:5}],"1#-414064476":[{m:"Ch3-i3",e:5}],"-1#-1863700549":[{m:"Hh10-f9",e:5}],"1#1737179832":[{m:"Ri1-h1",e:5}],"1#-1630791317":[{m:"Eg1-e3",e:9.945},{m:"Hh1-g3",e:9.992},{m:"Eg1-e3",e:8.571},{m:"Cb3-d3",e:9.992},{m:"Hb1-a3",e:9.992},{m:"Hh1-i3",e:9.992},{m:"Hh1-f2",e:9.992},{m:"Ch3-g3",e:9.992},{m:"Hb1-c3",e:9.992},{m:"Ch3-f3",e:9.992},{m:"Ri1-i2",e:9.992}],"-1#-781077341":[{m:"Hh10-g8",e:9.985}],"-1#-771231866":[{m:"Hh10-g8",e:9.902},{m:"Eg10-e8",e:9.902},{m:"c7-c6",e:9.902}],"1#283055307":[{m:"Hh1-f2",e:9.898}],"1#291165049":[{m:"Hh1-g3",e:5}],"-1#1592229553":[{m:"c7-c6",e:5}],"1#291509437":[{m:"Ri1-i2",e:7.5}],"-1#-1541646704":[{m:"Cb8-c8",e:9.333},{m:"c7-c6",e:9.333}],"-1#-2129484493":[{m:"Hh10-g8",e:9.6}],"-1#-2025711275":[{m:"Hh10-g8",e:8}],"1#1167778328":[{m:"i4-i5",e:8}],"-1#-1466311686":[{m:"Hh10-g8",e:8.333}],"-1#-2144205491":[{m:"Hh10-g8",e:9.091}],"-1#-862686682":[{m:"c7-c6",e:9.655}],"-1#-1148170286":[{m:"Hh10-g8",e:9.375}],"-1#-880257789":[{m:"Hb10-a8",e:9.839}],"1#-1515343803":[{m:"g4-g5",e:9.902},{m:"Hb1-a3",e:9.902},{m:"Cb3-d3",e:9.902},{m:"Hh1-g3",e:9.902},{m:"Hb1-c3",e:9.902},{m:"Eg1-e3",e:9.99}],"-1#-379173208":[{m:"c7-c6",e:9.75},{m:"Hb10-d9",e:9.75}],"-1#-1166865379":[{m:"g7-g6",e:9.231},{m:"c7-c6",e:9.231},{m:"Ec10-e8",e:9.524}],"-1#-1619132482":[{m:"c7-c6",e:8.571},{m:"Hb10-c8",e:8.571},{m:"Hh10-i8",e:8.571}],"-1#-368042611":[{m:"Hb10-c8",e:9.167},{m:"Hh10-i8",e:9.167},{m:"g7-g6",e:9.167}],"-1#-134882552":[{m:"Hh10-g8",e:8.75},{m:"c7-c6",e:8.75}],"1#881991731":[{m:"g4-g5",e:8.333}],"1#1273449451":[{m:"g4-g5",e:9.898},{m:"Hb1-c3",e:9.898},{m:"Cb3-d3",e:9.898},{m:"c4-c5",e:9.898},{m:"Hh1-g3",e:9.898},{m:"Ch3-g3",e:9.898},{m:"Hb1-a3",e:9.898}],"-1#120372486":[{m:"Hb10-a8",e:9.836},{m:"Ch8-i8",e:9.836},{m:"c7-c6",e:9.836},{m:"Cb8-e8",e:9.836},{m:"Hb10-c8",e:9.836},{m:"Ec10-e8",e:9.836},{m:"Ri10-i9",e:9.836}],"1#1183213922":[{m:"Hh1-g3",e:5}],"-1#431956134":[{m:"Hh10-g8",e:8.75},{m:"Hh10-g8",e:9.949},{m:"c7-c6",e:8.571}],"-1#1899430928":[{m:"Ec10-e8",e:7.5},{m:"c7-c6",e:7.5},{m:"Ch8-i8",e:7.5}],"-1#-2064353437":[{m:"g7-g6",e:9.412},{m:"Cb8-e8",e:9.412}],"-1#73066019":[{m:"c7-c6",e:8.571},{m:"Hh10-g8",e:9.231}],"1#-952296168":[{m:"Hb1-a3",e:5}],"-1#1427724237":[{m:"Ri10-h10",e:5}],"1#257436220":[{m:"c4-c5",e:5}],"-1#1413085107":[{m:"g7-g6",e:8.571},{m:"Ri10-i9",e:8.571},{m:"Hb10-c8",e:8.571}],"1#-60471333":[{m:"Hh1-g3",e:9.985},{m:"Ch3-f3",e:9.985},{m:"Cb3-d3",e:9.985},{m:"Hh1-i3",e:9.985},{m:"Ch3-g3",e:9.985},{m:"Eg1-e3",e:9.89},{m:"Eg1-e3",e:9.996},{m:"Eg1-e3",e:9.924},{m:"Hh1-f2",e:9.985}],"-1#-1277629933":[{m:"Hh10-g8",e:9.231},{m:"Ch8-g8",e:9.231},{m:"g7-g6",e:5}],"1#-112219631":[{m:"c4-c5",e:6.667},{m:"Hb1-a3",e:6.667}],"-1#-650571422":[{m:"Hh10-g8",e:5}],"1#467790383":[{m:"Hh1-g3",e:5}],"-1#1415333863":[{m:"Ri10-h10",e:5}],"-1#-961214432":[{m:"Hb10-a8",e:8},{m:"Hh10-g8",e:8}],"1#-1943910366":[{m:"a4-a5",e:7.5}],"-1#-437565467":[{m:"Hh10-g8",e:5}],"1#657702056":[{m:"g4-g5",e:5}],"-1#-493134851":[{m:"Hh10-i8",e:9.697},{m:"Eg10-e8",e:9.697}],"-1#-902789814":[{m:"Ec10-e8",e:9.474},{m:"Ch8-f8",e:9.474},{m:"Eg10-e8",e:9.474}],"1#-1741708774":[{m:"Hh1-f2",e:9.985},{m:"Eg1-e3",e:9.688},{m:"Hb1-c3",e:9.985},{m:"Hh1-g3",e:9.985},{m:"Eg1-e3",e:9.942},{m:"c4-c5",e:9.985},{m:"Cb3-c3",e:9.985}],"-1#-1367711605":[{m:"Ch8-e8",e:5}],"1#-854388304":[{m:"Ch3-g3",e:5}],"-1#-739439210":[{m:"Ra10-a9",e:5}],"-1#-898119337":[{m:"Ch8-e8",e:7.5},{m:"Hb10-c8",e:6.667}],"1#-1457604500":[{m:"Ch3-f3",e:7.5}],"1#152056428":[{m:"Cb3-a3",e:8}],"-1#-678293550":[{m:"Cb8-a8",e:9.878},{m:"g7-g6",e:9.878},{m:"Ra10-a9",e:9.878}],"-1#-723233545":[{m:"Cb8-a8",e:9.958},{m:"Hh10-i8",e:9.958}],"-1#1463590546":[{m:"Cb8-a8",e:9.97},{m:"Ch8-e8",e:9.97},{m:"Ra10-a9",e:9.97},{m:"Hh10-i8",e:9.97}],"-1#-1832419069":[{m:"g7-g6",e:8},{m:"Ra10-b10",e:8},{m:"e7-e6",e:8}],"1#21268314":[{m:"Hb1-a3",e:9.615},{m:"i4-i5",e:9.615},{m:"Hh1-g3",e:9.615},{m:"c4-c5",e:9.615}],"-1#513424130":[{m:"a7-a6",e:5}],"1#448275968":[{m:"Hh1-g3",e:5}],"-1#1426426824":[{m:"g7-g6",e:5}],"1#543128757":[{m:"Af1-e2",e:5}],"-1#-1084514502":[{m:"Ch8-g8",e:6.667}],"1#-912215568":[{m:"Hh1-i3",e:6.667}],"-1#-802246194":[{m:"Ri10-h10",e:6.667}],"1#-1972384705":[{m:"Ri1-h1",e:6.667}],"-1#-2131585265":[{m:"Cb8-e8",e:6.667}],"-1#1324952210":[{m:"c7-c6",e:9.5},{m:"g7-g6",e:9.5},{m:"Hh10-i8",e:9.902},{m:"Cb8-f8",e:9.5},{m:"Hh10-i8",e:9.167}],"-1#-833111086":[{m:"Ch8-f8",e:7.5},{m:"Ec10-e8",e:7.5}],"1#223273467":[{m:"Hh1-g3",e:8}],"1#-490357967":[{m:"Hh1-g3",e:8.889},{m:"Hb1-c3",e:8.889}],"1#-363413091":[{m:"Hh1-g3",e:9.983},{m:"c4-c5",e:9.983},{m:"g4-g5",e:9.983},{m:"Hb1-c3",e:9.983},{m:"Af1-e2",e:9.983}],"-1#-1511297963":[{m:"Hh10-g8",e:9.979},{m:"g7-g6",e:9.979},{m:"Ri10-i9",e:9.979}],"-1#625343765":[{m:"Hh10-g8",e:6.667}],"1#-409139624":[{m:"Eg1-e3",e:9.688}],"-1#-1499646096":[{m:"Hh10-g8",e:9}],"1#1682295869":[{m:"Hb1-c3",e:9},{m:"Hh1-g3",e:9}],"-1#737698293":[{m:"Cb8-d8",e:9.792}],"-1#-1206998320":[{m:"Cb8-c8",e:9.904},{m:"Hb10-a8",e:9.904},{m:"Hh10-g8",e:9.904},{m:"c7-c6",e:9.904}],"-1#-1307628713":[{m:"Hh10-g8",e:5}],"1#1893191706":[{m:"Hh1-g3",e:5}],"-1#1063943634":[{m:"Ri10-h10",e:5}],"1#1697316899":[{m:"Ri1-h1",e:5}],"1#1247300509":[{m:"Cb3-c3",e:9.972},{m:"Eg1-e3",e:9.981},{m:"Hh1-g3",e:9.972},{m:"Hh1-f2",e:9.972},{m:"Hb1-a3",e:9.972},{m:"Hb1-c3",e:9.972}],"-1#1085302916":[{m:"g7-g6",e:9.95},{m:"Hb10-a8",e:9.95},{m:"Hh10-g8",e:9.95}],"-1#110345584":[{m:"Cb8-e8",e:9.915},{m:"c7-c6",e:9.75}],"-1#98952789":[{m:"Hb10-c8",e:8.75}],"1#351663337":[{m:"Af1-e2",e:9.868},{m:"g4-g5",e:9.868}],"-1#2081261836":[{m:"Hb10-c8",e:8.333}],"1#1830656944":[{m:"Hf2-d3",e:8.333}],"-1#-1628080829":[{m:"Cb8-a8",e:8.333}],"-1#1434908613":[{m:"Ch8-e8",e:9.714},{m:"Cb8-e8",e:9.714},{m:"c7-c6",e:9.524}],"-1#402661584":[{m:"Hb10-c8",e:6.667}],"1#-1012338524":[{m:"Hh1-g3",e:9.677},{m:"g4-g5",e:9.677},{m:"Hb1-c3",e:9.677},{m:"a4-a5",e:9.677},{m:"c4-c5",e:9.677}],"-1#-1944756884":[{m:"g7-g6",e:5}],"-1#-1889335735":[{m:"Ra10-a9",e:8.333},{m:"Hb10-a8",e:7.5},{m:"Eg10-e8",e:8.333}],"-1#-1846502423":[{m:"Cb8-d8",e:9.524},{m:"Ra10-a9",e:9.524},{m:"c7-c6",e:9.524},{m:"Hh10-g8",e:9.524}],"-1#-305768984":[{m:"Ch8-e8",e:7.5},{m:"Eg10-e8",e:7.5},{m:"Ch8-d8",e:7.5}],"1#-1901124397":[{m:"Hb1-a3",e:5}],"-1#213634092":[{m:"Ch8-d8",e:5}],"1#737002961":[{m:"c4-c5",e:7.5},{m:"Hb1-c3",e:7.5},{m:"Hh1-g3",e:7.5}],"-1#-453052071":[{m:"Ch8-e8",e:5}],"1#-2020112286":[{m:"Hh1-g3",e:5}],"-1#-936761942":[{m:"Hh10-g8",e:5}],"1#183688935":[{m:"Ri1-h1",e:5}],"-1#7308759":[{m:"Hb10-c8",e:5}],"1#293574507":[{m:"Hb1-c3",e:8.75}],"-1#1126693926":[{m:"Ra10-a9",e:8.75}],"-1#2041949852":[{m:"Cb8-e8",e:5}],"1#1277008180":[{m:"Hh1-g3",e:5}],"-1#60830972":[{m:"Hb10-c8",e:6.667},{m:"Hh10-g8",e:6.667}],"1#313534016":[{m:"Ra1-b1",e:5}],"-1#605869756":[{m:"Ra10-a9",e:5}],"1#1011175421":[{m:"Af1-e2",e:5}],"-1#1679598903":[{m:"Hh10-g8",e:5}],"1#-1049047119":[{m:"g4-g5",e:5}],"-1#-1917634212":[{m:"Hb10-c8",e:5}],"1#-1667028000":[{m:"Af1-e2",e:5}],"-1#1682991129":[{m:"Cb8-e8",e:5}],"1#1375231921":[{m:"Hh1-g3",e:5}],"1#1908397596":[{m:"Ri1-i2",e:9.167},{m:"Hh1-g3",e:9.167},{m:"Hb1-a3",e:9.167}],"-1#620468852":[{m:"Hh10-g8",e:6.667}],"1#-433888967":[{m:"Ri2-d2",e:6.667}],"-1#1208929754":[{m:"Cc8-f8",e:6.667},{m:"Ec10-e8",e:6.667}],"1#1850394168":[{m:"c4-c5",e:6.667},{m:"Hb1-a3",e:6.667}],"1#1687997753":[{m:"c4-c5",e:5}],"-1#1040350164":[{m:"Ri10-i8",e:8},{m:"g7-g6",e:8},{m:"Hh10-g8",e:8}],"1#1699177799":[{m:"Hb1-a3",e:5}],"1#1264094377":[{m:"Hb1-a3",e:5}],"1#-52789095":[{m:"Ri1-h1",e:6.667}],"-1#1851877956":[{m:"Hh10-g8",e:8.333},{m:"a7-a6",e:8.333},{m:"Ri10-i8",e:8.333}],"1#-1397124855":[{m:"Cb3-d3",e:6.667},{m:"Hh1-g3",e:6.667}],"1#1782806342":[{m:"Ra1-a2",e:6.667}],"1#891581655":[{m:"Ra1-a2",e:5}],"1#1247972441":[{m:"c4-c5",e:9.888},{m:"Hh1-g3",e:9.888},{m:"Hb1-a3",e:9.888},{m:"g4-g5",e:9.888},{m:"Hb1-c3",e:9.888},{m:"Cb3-d3",e:9.888}],"-1#-2056146735":[{m:"Hb10-a8",e:9.808},{m:"Hh10-f9",e:9.808},{m:"Ch8-f8",e:9.808}],"-1#98509201":[{m:"g7-g6",e:7.5}],"1#1887819500":[{m:"c4-c5",e:7.5}],"-1#-1080628636":[{m:"Hh10-g8",e:8}],"-1#1438396417":[{m:"a7-a6",e:6.667}],"1#1369320707":[{m:"g4-g5",e:6.667},{m:"Ra1-a2",e:6.667}],"-1#111770292":[{m:"Hb10-c8",e:9.667},{m:"Eg10-e8",e:8.333}],"-1#406513428":[{m:"g7-g6",e:7.5},{m:"Hb10-a8",e:7.5},{m:"c7-c6",e:7.5}],"-1#1890763682":[{m:"g7-g6",e:6.667},{m:"Hb10-a8",e:6.667}],"1#99103967":[{m:"Hb1-c3",e:5}],"1#1244064399":[{m:"Cb3-d3",e:9.937},{m:"c4-c5",e:9.937},{m:"Hb1-a3",e:9.937},{m:"g4-g5",e:9.937},{m:"Hh1-g3",e:9.937}],"-1#1895212404":[{m:"Hh10-g8",e:5}],"1#-1305584071":[{m:"Hb1-c3",e:5}],"-1#-529123980":[{m:"Hb10-c8",e:5}],"-1#-2060069369":[{m:"g7-g6",e:9.091},{m:"Hh10-g8",e:9.091},{m:"Ch8-f8",e:7.5}],"-1#1442338519":[{m:"Hh10-g8",e:8},{m:"Hb10-c8",e:8}],"1#-1759466086":[{m:"Ra1-a2",e:7.5}],"1#1156072555":[{m:"Cb3-c3",e:5}],"-1#116202594":[{m:"Hb10-c8",e:9.762},{m:"Hh10-g8",e:9.762},{m:"Hh10-i8",e:9.762}],"-1#94062407":[{m:"Hh10-i8",e:9.902},{m:"Hh10-g8",e:9.902},{m:"g7-g6",e:9.902}],"1#-951862262":[{m:"g4-g5",e:9.167}],"1#-1146013866":[{m:"Hh1-g3",e:9.925},{m:"Eg1-e3",e:9.737},{m:"Hb1-a3",e:9.925},{m:"Ra1-a2",e:9.925},{m:"Hb1-c3",e:9.925},{m:"c4-c5",e:9.925}],"-1#-200500578":[{m:"Hb10-c8",e:5}],"1#-451114974":[{m:"Hb1-a3",e:5}],"-1#-87935878":[{m:"g7-g6",e:5}],"-1#-142949957":[{m:"Hb10-c8",e:9.667}],"1#-429206777":[{m:"g4-g5",e:9.167},{m:"g4-g5",e:9.63},{m:"Cb3-d3",e:9.667}],"-1#-1536193778":[{m:"Hb10-c8",e:9.167}],"1#-1249928782":[{m:"g4-g5",e:9.167},{m:"a4-a5",e:9.167},{m:"Ra1-b1",e:9.167}],"-1#854638589":[{m:"Hb10-c8",e:9.688}],"1#601926977":[{m:"Ra2-f2",e:9.688},{m:"Hb1-a3",e:9.688}],"-1#-370582501":[{m:"Hb10-c8",e:9.667},{m:"c7-c6",e:9.667}],"1#-117879129":[{m:"g4-g5",e:9.63}],"-1#1956776926":[{m:"g7-g6",e:9.706},{m:"Hb10-c8",e:9.706}],"1#33094819":[{m:"Hb1-c3",e:5}],"1#1706170722":[{m:"Cb3-d3",e:9.697}],"1#-461757355":[{m:"g4-g5",e:9.988},{m:"Eg1-e3",e:8},{m:"Cb3-d3",e:9.988},{m:"Ra1-a2",e:9.988},{m:"Hb1-c3",e:9.988},{m:"Ch3-f3",e:9.988},{m:"Hh1-g3",e:9.988},{m:"Hb1-a3",e:9.988}],"-1#-1464741192":[{m:"Hb10-a8",e:9.892},{m:"Ch8-e8",e:9.892}],"-1#-559256658":[{m:"c7-c6",e:5}],"1#500011157":[{m:"Hb1-a3",e:5}],"-1#1832627454":[{m:"Hh10-g8",e:9.951},{m:"Ch8-e8",e:9.951}],"-1#-1239265512":[{m:"Eg10-e8",e:9.924},{m:"c7-c6",e:9.924}],"-1#-1054444820":[{m:"Hb10-a8",e:5}],"1#-1951321362":[{m:"Hh1-g3",e:5}],"-1#-1412986467":[{m:"Hb10-a8",e:7.5},{m:"Hh10-g8",e:7.5}],"-1#-73099251":[{m:"Ch8-e8",e:9.894},{m:"Hb10-c8",e:9.894}],"1#-1130920178":[{m:"Hh1-g3",e:9.878},{m:"Hb1-c3",e:9.878}],"-1#-215340346":[{m:"Hb10-c8",e:9.375},{m:"g7-g6",e:9.375}],"1#-499500934":[{m:"Cb3-d3",e:9.333},{m:"Hb1-c3",e:9.333}],"-1#-655722623":[{m:"Ra10-b10",e:9.091}],"-1#-1335733449":[{m:"g7-g6",e:9.091}],"1#-2039423557":[{m:"Cb3-d3",e:5}],"-1#-1130327488":[{m:"Hb10-c8",e:5}],"1#-1380941572":[{m:"Hb1-c3",e:5}],"-1#-1512527":[{m:"Ra10-b10",e:5}],"-1#-288363453":[{m:"Hb10-c8",e:9.851},{m:"Hh10-g8",e:9.851},{m:"c7-c6",e:9.851}],"1#-2097409":[{m:"Ra1-b1",e:9.811},{m:"Ra1-a2",e:9.811},{m:"Hb1-c3",e:9.333}],"1#739710734":[{m:"Ra1-b1",e:5}],"-1#448522226":[{m:"Ra10-a9",e:5}],"1#765990776":[{m:"Ra1-b1",e:9.286},{m:"Ra1-a2",e:9.286},{m:"g4-g5",e:9.286}],"-1#-1313231340":[{m:"Hh10-g8",e:8.889},{m:"c7-c6",e:8.889},{m:"Cb8-e8",e:8.889}],"1#1935758681":[{m:"g4-g5",e:5}],"-1#1068147636":[{m:"c7-c6",e:5}],"1#-53651313":[{m:"Hb1-c3",e:5}],"-1#-1365953598":[{m:"Hb10-c8",e:5}],"1#-1081794178":[{m:"Hh1-g3",e:5}],"-1#-264729418":[{m:"Hc8-b6",e:5}],"1#778918855":[{m:"Cb3-a3",e:5}],"-1#502485675":[{m:"Eg10-e8",e:5}],"1#-558993836":[{m:"a4-a5",e:5}],"-1#-255800552":[{m:"Hb6xc4",e:5}],"1#-1191317279":[{m:"Ca3-a2",e:5}],"-1#1873638441":[{m:"Cb8-c8",e:5}],"1#-481083829":[{m:"Ra1-b1",e:5}],"-1#-704655689":[{m:"Af10-e9",e:5}],"1#-648803803":[{m:"a5-a6",e:5}],"-1#2017188665":[{m:"Ri10-f10",e:5}],"1#-235967235":[{m:"a6-b6",e:5}],"-1#-1102265994":[{m:"Ra10-b10",e:5}],"1#-2042695697":[{m:"b6-b7",e:5}],"-1#1820805930":[{m:"Ch8-h9",e:5}],"1#888416553":[{m:"b7-b8",e:5}],"-1#1209687505":[{m:"Cc8-d8",e:5}],"1#-1266895823":[{m:"Ch3-i3",e:5}],"-1#-1010336978":[{m:"Hc4-a5",e:5}],"1#-1785621785":[{m:"Ri1-h1",e:5}],"-1#-1626551849":[{m:"Ch9-i9",e:5}],"1#1532504710":[{m:"Rb1-b5",e:5}],"-1#66459837":[{m:"c6-c5",e:5}],"1#-1914948900":[{m:"Rb5xa5",e:5}],"-1#185995069":[{m:"Rb10xb8",e:5}],"1#-778797799":[{m:"Ra5xc5",e:5}],"-1#-796778014":[{m:"Rf10-f4",e:5}],"1#2129262162":[{m:"Hg3-h5",e:5}],"-1#1332388307":[{m:"Ci9xi5",e:5}],"1#-395424696":[{m:"Eg1-e3",e:5}],"-1#1861700250":[{m:"Rf4-f10",e:5}],"1#-1063477974":[{m:"Rc5-c7",e:5}],"-1#-732285311":[{m:"Rf10-h10",e:5}],"1#437439429":[{m:"Hh5-g3",e:5}],"-1#730963012":[{m:"Rh10xh1",e:5}],"1#334241530":[{m:"Hg3xh1",e:5}],"-1#535029153":[{m:"a7-a6",e:5}],"1#465696931":[{m:"Hh1-f2",e:5}],"-1#764688946":[{m:"a6-a5",e:5}],"1#-1645302322":[{m:"Hf2-h3",e:5}],"-1#-1378817163":[{m:"Ci5-h5",e:5}],"1#-1218997804":[{m:"Ca2-f2",e:5}],"-1#901114062":[{m:"Rb8-b6",e:5}],"1#1376113208":[{m:"Af1-e2",e:5}],"-1#173816050":[{m:"a5-b5",e:5}],"1#-164357163":[{m:"Rc7-d7",e:5}],"-1#-942226401":[{m:"b5-c5",e:5}],"1#1372942706":[{m:"Rd7-c7",e:6.667},{m:"Hh3-f4",e:6.667}],"-1#1614261944":[{m:"Rb6-i6",e:5}],"1#516759205":[{m:"Cf2-f3",e:5}],"-1#5411333":[{m:"Ri6-i4",e:5}],"1#-2134105101":[{m:"g5-g6",e:5}],"-1#-490689312":[{m:"g7xg6",e:5}],"1#-1448412789":[{m:"Rc7xc5",e:5}],"-1#1093517783":[{m:"Ri4-h4",e:5}],"1#1668024103":[{m:"Hh3-g1",e:5}],"-1#-1327515592":[{m:"i7-i6",e:5}],"1#-1087211801":[{m:"Ci3-g3",e:5}],"-1#-878013777":[{m:"i6-i5",e:5}],"1#220157554":[{m:"Rc5-f5",e:5}],"-1#392505588":[{m:"Rh4-g4",e:5}],"1#1691996309":[{m:"Cg3-h3",e:5}],"-1#2049428659":[{m:"Cd8-c8",e:5}],"1#-2042550957":[{m:"Ec1-a3",e:5}],"-1#694743468":[{m:"Cc8-c4",e:5}],"1#2036577155":[{m:"Rf5-e5",e:5}],"-1#-1184526309":[{m:"e7-e6",e:5}],"1#465036652":[{m:"Re5-c5",e:5}],"-1#-602501373":[{m:"Cc4-b4",e:5}],"1#-1121006006":[{m:"Rc5-c7",e:5}],"-1#-1444387359":[{m:"i5-i4",e:5}],"1#-1126424288":[{m:"Rc7-g7",e:5}],"-1#479083025":[{m:"Cb4-b8",e:5}],"1#-1589415147":[{m:"Hc3-d5",e:5}],"-1#-1962898136":[{m:"e6-e5",e:5}],"1#1740671388":[{m:"Hd5-b6",e:5}],"-1#1032117286":[{m:"e5xe4",e:5}],"1#2080302309":[{m:"Hb6-d7",e:5}],"-1#-393357434":[{m:"Cb8-d8",e:5}],"1#-2050473099":[{m:"Ea3-c1",e:5}],"-1#719427466":[{m:"e4xe3",e:5}],"1#-407669385":[{m:"Ec1xe3",e:5}],"-1#1676107400":[{m:"Ch5-b5",e:5}],"1#491329196":[{m:"Ae2-d3",e:5}],"-1#240615974":[{m:"Cb5-b1+",e:5}],"1#-1967921881":[{m:"Ad1-e2",e:5}],"-1#-977603545":[{m:"Cb1xg1",e:5}],"1#601332461":[{m:"Ee3xg1",e:5}],"-1#823647561":[{m:"Rg4xg1+",e:5}],"1#-1099171349":[{m:"Cf3-f1",e:5}],"-1#-1614506839":[{m:"Rg1-g3",e:5}],"1#-1228551620":[{m:"Ch3-h2",e:5}],"-1#-372256875":[{m:"Rg3-e3",e:5}],"1#-1426106988":[{m:"Rg7xg8",e:5}],"-1#1480050623":[{m:"Re3-e7",e:5}],"1#2118070665":[{m:"Ch2-h10",e:5}],"-1#-1549525432":[{m:"Cd8xg8",e:5}],"1#1782699590":[{m:"Hd7-c9+",e:5}],"-1#295316721":[{m:"Ke10-f10",e:5}],"1#1825703939":[{m:"Ch10-h2",e:5}],"-1#-1320605758":[],"-1#1536331080":[{m:"Ch5-i5",e:5}],"1#1091958761":[{m:"Hf4-h3",e:5}],"-1#1263668179":[{m:"b5-c5",e:5}],"1#1927173423":[{m:"Cb3-e3",e:6.667},{m:"g4-g5",e:6.667}],"-1#-660684107":[{m:"Hb10-c8",e:5}],"1#-913387511":[{m:"Hb1-c3",e:5}],"-1#-1680426172":[{m:"Ra10-b10",e:5}],"1#-1549494819":[{m:"Ra1-a2",e:5}],"-1#719658358":[{m:"Hh10-g8",e:5}],"1#-398596549":[{m:"Hh1-g3",e:5}],"-1#-1484764173":[{m:"g7-g6",e:5}],"1#-757416818":[{m:"Ra2-d2",e:5}],"-1#115244724":[{m:"Eg10-e8",e:5}],"1#-981253557":[{m:"Rd2-d5",e:5}],"-1#-591262625":[{m:"Hg8-f6",e:5}],"1#2125715692":[{m:"Rd5-f5",e:5}],"-1#-982309756":[{m:"Cb8-b6",e:5}],"1#144217531":[{m:"c4-c5",e:5}],"-1#-947148493":[{m:"Ch8-f8",e:5}],"1#76739354":[{m:"Rf5-h5",e:5}],"-1#-289191644":[{m:"c6xc5",e:5}],"1#-709125968":[{m:"Rh5xc5",e:5}],"-1#-1918610681":[{m:"Ri10-h10",e:5}],"1#-672846090":[{m:"Ri1-h1",e:5}],"-1#-579308090":[{m:"Rh10-h4",e:5}],"1#423205521":[{m:"Ch3-i3",e:5}],"-1#1854035342":[{m:"Rh4xg4",e:5}],"1#253136777":[{m:"Ci3xi7",e:5}],"-1#1485393049":[{m:"Rb10-b8",e:5}],"1#1375090824":[{m:"Rh1-h8",e:5}],"-1#-2144051971":[{m:"Ad10-e9",e:5}],"1#1828021260":[{m:"Rc5-c6",e:5}],"-1#1222123954":[{m:"Rg4xg3",e:5}],"1#709181336":[{m:"Rc6xf6",e:5}],"-1#1328140860":[{m:"Rg3-g5",e:5}],"1#-688641575":[{m:"i5-i6",e:5}],"-1#-655491788":[{m:"Ee8-g10",e:5}],"1#464568779":[{m:"Eg1-i3",e:5}],"-1#-304938888":[{m:"Rg5-c5",e:5}],"1#451122293":[{m:"Ce3-g3",e:5}],"-1#-364442958":[{m:"Ec10-e8",e:5}],"1#-959116719":[{m:"Ec1-e3",e:5}],"-1#1949557880":[{m:"Cb6-e6",e:5}],"1#1768976854":[{m:"Ei3-g1",e:5}],"-1#-1626099611":[{m:"g6-g5",e:5}],"1#-427665710":[{m:"Rf6xe6",e:5}],"-1#-1323287017":[{m:"Rc5xc3",e:5}],"1#322008745":[{m:"Re6-f6",e:5}],"-1#988464310":[{m:"Rc3-c4",e:5}],"1#1433600890":[{m:"Ci7-i10",e:5}],"-1#2120237781":[{m:"Rb8-b6",e:5}],"1#433092643":[{m:"Rf6xb6",e:5}],"-1#302889430":[{m:"Hc8xb6",e:5}],"1#-421597225":[{m:"Rh8-g8",e:5}],"-1#-1403556288":[{m:"Ke10-d10",e:5}],"1#-710816967":[{m:"Rg8xg5",e:5}],"-1#-1795789977":[{m:"Rc4xe4",e:5}],"1#-1114558256":[{m:"i6-h6",e:5}],"-1#-1920488224":[{m:"Re4-d4",e:5}],"1#926378444":[{m:"Af1-e2",e:5}],"-1#1869513478":[{m:"Hb6-d5",e:5}],"1#-1342235791":[{m:"h6-h7",e:5}],"-1#-210156466":[{m:"Cf8-f6",e:5}],"1#821739594":[{m:"Rg5-f5",e:5}],"-1#1722578851":[{m:"Cf6-b6",e:5}],"1#199892074":[{m:"Ee3-c1",e:5}],"-1#-1190333885":[{m:"Cb6-e6+",e:5}],"1#1159843729":[{m:"Ke1-f1",e:5}],"-1#-1066745752":[{m:"Hd5-b4",e:5}],"1#-16187095":[{m:"Cg3-b3",e:5}],"-1#-1204797691":[{m:"Rd4-h4",e:5}],"1#-1987877955":[{m:"h7-g7",e:5}],"-1#-1360235445":[{m:"Rh4-g4",e:5}],"1#2101035344":[{m:"g7-f7",e:5}],"-1#-19010444":[{m:"Rg4xg1+",e:5}],"1#-1655202812":[{m:"Kf1-f2",e:5}],"-1#1033756867":[{m:"Ce6-c6",e:5}],"1#732484466":[{m:"Cb3-c3",e:5}],"-1#1041605570":[{m:"Hb10-c8",e:5}],"1#788902270":[{m:"Hh1-g3",e:5}],"-1#1622678710":[{m:"Ch8-d8",e:5}],"1#2001450363":[{m:"Hb1-a3",e:5}],"-1#1754597667":[{m:"Hh10-g8",e:5}],"1#-1437732242":[{m:"Ri1-h1",e:5}],"-1#-1596937890":[{m:"i7-i6",e:5}],"1#-1354930303":[{m:"Ch3-i3",e:5}],"-1#-662263650":[{m:"a7-a6",e:5}],"1#-593185380":[{m:"Ra1-a2",e:5}],"-1#1441086775":[{m:"Cb8-a8",e:5}],"1#-1662578953":[{m:"c4-c5",e:5}],"-1#1408512639":[{m:"c6xc5",e:5}],"1#1754063851":[{m:"Ra2-c2",e:5}],"-1#268179766":[{m:"Hc8-d6",e:5}],"1#625914549":[{m:"Rc2xc5",e:5}],"-1#-1691844906":[{m:"Ec10-e8",e:5}],"1#-1212514763":[{m:"Rh1-h6",e:5}],"-1#25373281":[{m:"g7-g6",e:5}],"1#1960434972":[{m:"i5xi6",e:5}],"-1#-1510490063":[{m:"Hg8xh6",e:5}],"1#-293023935":[{m:"Ci3xi10",e:5}],"-1#503474151":[{m:"Hh6-g8",e:5}],"1#-2083811480":[{m:"g5xg6",e:5}],"-1#-387541122":[{m:"Ee8xg6",e:5}],"1#-814017356":[{m:"Rc5-c6",e:5}],"-1#-346664694":[{m:"Hd6xe4",e:5}],"1#-371625689":[{m:"Hg3xe4",e:5}],"-1#-1044034735":[{m:"Cd8-e8",e:5}],"1#-1467833130":[{m:"Rc6xg6",e:5}],"-1#786906214":[{m:"Hg8-i9",e:5}],"1#1229579215":[{m:"Cb3-e3",e:5}],"-1#-485919659":[{m:"Ce8xe4+",e:5}],"1#-249714125":[{m:"Ce3xe7",e:5}],"-1#1454610285":[{m:"Ra10-c10",e:5}],"1#54560640":[{m:"Rg6-e6",e:5}],"-1#2040311235":[],"1#-2079221316":[{m:"Hb1-c3",e:8.333}],"-1#-699796751":[{m:"Hb10-c8",e:8.333}],"1#-950411187":[{m:"Hh1-i3",e:8.333},{m:"c4-c5",e:8.333},{m:"Ra1-b1",e:8.333}],"-1#-556277645":[{m:"Ra10-b10",e:6.667}],"1#-425341206":[{m:"Hi3-h5",e:6.667}],"-1#-2129316707":[{m:"Ch8-h6",e:6.667}],"1#-1159966817":[{m:"c4-c5",e:6.667},{m:"Hh5-f6",e:6.667}],"-1#1976529687":[{m:"Rb10-b6",e:5}],"1#115149441":[{m:"Ad1-e2",e:5}],"-1#1238637441":[{m:"Hh10-g8",e:5}],"1#-1962090292":[{m:"Ra1-b1",e:5}],"-1#-1113583568":[{m:"Ri10-i9",e:5}],"1#-66403244":[{m:"Ch3-g3",e:5}],"-1#-487270286":[{m:"c7-c6",e:5}],"1#563290953":[{m:"Hh5-f6",e:5}],"-1#-1161878856":[{m:"c6xc5",e:5}],"1#-2117602516":[{m:"Hf6xg8",e:5}],"-1#1018923425":[{m:"Ri9-i8",e:5}],"1#998863911":[{m:"Hg8xf10",e:5}],"-1#-1234632626":[{m:"Ke10xf10",e:5}],"1#-1540907113":[{m:"Cb3-a3",e:5}],"-1#-1749444869":[{m:"c5-c4",e:5}],"1#-1079894924":[{m:"Ri1-h1",e:5}],"-1#-1254144188":[{m:"Ch6-c6",e:5}],"1#351252656":[{m:"Rb1xb6",e:5}],"-1#1460220948":[{m:"Hc8xb6",e:5}],"1#-1545969131":[{m:"Rh1-h6",e:5}],"-1#367212097":[{m:"Ec10-a8",e:5}],"1#-1092039680":[{m:"Hc3-d1",e:5}],"-1#569396846":[{m:"g7-g6",e:5}],"1#1420474643":[{m:"Hf6xe8",e:5}],"-1#726528618":[{m:"Eg10xe8",e:5}],"1#1998650588":[{m:"Ra1-b1",e:5}],"-1#1099697184":[{m:"Hh10-g8",e:5}],"1#-2091583635":[{m:"Cb3-b5",e:5}],"-1#-1273124909":[{m:"c7-c6",e:5}],"1#2004507880":[{m:"Ch3-i3",e:5}],"-1#12686327":[{m:"Ch6-h3",e:5}],"1#-835297043":[{m:"i5-i6",e:5}],"-1#-1070615552":[{m:"Ri10-h10",e:5}],"1#-1704015375":[{m:"Ci3xi7",e:5}],"-1#-839841055":[{m:"Hg8-f6",e:5}],"1#1870716498":[{m:"Ri1-i5",e:5}],"-1#-1273365658":[{m:"Hf6xg4",e:5}],"1#1453847575":[{m:"Ri5-f5",e:5}],"-1#895741158":[{m:"Ch3-h1",e:5}],"1#-1911862853":[{m:"Ad1-e2",e:5}],"-1#-1056810821":[{m:"Ad10-e9",e:5}],"1#767778890":[{m:"Cb5-b7",e:5}],"-1#467373951":[{m:"Rh10-h3",e:5}],"-1#139123909":[{m:"Ra10-b10",e:7.5}],"1#809038428":[{m:"Cb3-b5",e:7.5}],"-1#124887778":[{m:"Hh10-g8",e:7.5},{m:"Ch8-f8",e:7.5}],"1#-978757201":[{m:"Hh1-g3",e:6.667}],"-1#-1978338201":[{m:"Ri10-i9",e:6.667}],"1#-876732413":[{m:"Ra1-b1",e:6.667},{m:"Eg1-e3",e:6.667}],"-1#-49098497":[{m:"Rb10-b6",e:5}],"1#-1912559255":[{m:"Eg1-e3",e:5}],"-1#144289723":[{m:"Rb10-b6",e:5}],"1#484343385":[{m:"Af1-e2",e:6.667},{m:"Ri1-g1",e:6.667}],"-1#1149736083":[{m:"Rf9-f4",e:5}],"1#721995280":[{m:"g4-g5",e:5}],"-1#1740845309":[{m:"g7-g6",e:5}],"1#312067968":[{m:"Ch3-h7",e:5}],"-1#1722505530":[{m:"c7-c6",e:5}],"1#-1513315839":[{m:"g5xg6",e:5}],"-1#2097354244":[{m:"c7-c6",e:5}],"1#-1100681921":[{m:"c5xc6",e:5}],"-1#-2114480405":[{m:"Rb6xc6",e:5}],"1#2001177020":[{m:"Cb5-g5",e:5}],"-1#-1160368888":[{m:"Rc6xc3",e:5}],"-1#1294411473":[{m:"Ri9-f9",e:5}],"1#1499526963":[{m:"Ra1-b1",e:5}],"-1#1875642319":[{m:"Rb10-b6",e:5}],"1#-999753525":[{m:"Hh1-g3",e:5}],"-1#-1948953341":[{m:"Hh10-g8",e:5}],"1#1225633358":[{m:"Ch3-h2",e:5}],"-1#369601511":[{m:"Rb10-b6",e:5}],"1#1695928945":[{m:"Ch2-c2",e:5}],"-1#1244142546":[{m:"Rb6-h6",e:5}],"1#287528427":[{m:"Eg1-e3",e:5}],"-1#-1749396679":[{m:"Rh6-h3",e:5}],"1#-768294748":[{m:"Ri1-g1",e:5}],"-1#-1276532487":[{m:"g7-g6",e:5}],"1#-961323132":[{m:"Ra1-b1",e:5}],"-1#-266358920":[{m:"Hg8-f6",e:5}],"1#1382972363":[{m:"Af1-e2",e:5}],"-1#171413761":[{m:"Hf6xg4",e:5}],"1#-393634192":[{m:"Hc3-d5",e:5}],"-1#-1026924467":[{m:"i7-i6",e:5}],"1#-853037422":[{m:"c5-c6",e:5}],"-1#-1560512466":[{m:"c7xc6",e:5}],"1#814916738":[{m:"Hd5xe7",e:5}],"-1#-412742007":[{m:"i6xi5",e:5}],"1#-985910910":[{m:"He7xc8",e:5}],"-1#598450079":[{m:"Cf8xc8",e:5}],"-1#-235597647":[{m:"Ra10-b10",e:5}],"1#-913883608":[{m:"Hh1-g3",e:5}],"-1#-2042981408":[{m:"g7-g6",e:5}],"1#-211786595":[{m:"c4-c5",e:5}],"-1#1014192149":[{m:"Rb10-b4",e:5}],"1#-1051418124":[{m:"Eg1-e3",e:5}],"-1#1204660006":[{m:"Hh10-g8",e:5}],"1#-2062197653":[{m:"Ch3-h4",e:5}],"-1#1909577431":[{m:"Ch8-i8",e:5}],"1#1278260260":[{m:"g4-g5",e:5}],"-1#16466633":[{m:"Rb4-b6",e:5}],"1#-1827408433":[{m:"Ch4-g4",e:5}],"-1#249995209":[{m:"Ri10-h10",e:5}],"1#1420288568":[{m:"Cg4xg6",e:5}],"-1#1575035809":[{m:"Ce8-f8",e:5}],"1#1192928392":[{m:"Cb3-a3",e:5}],"-1#1954852324":[{m:"Rb6-d6",e:5}],"1#-1879521073":[{m:"Cg6-g7",e:5}],"-1#-1648984334":[{m:"c7-c6",e:5}],"1#1590789577":[{m:"Rb1-b7",e:5}],"-1#2114268778":[{m:"c6xc5",e:5}],"1#1165885438":[{m:"Rb7-c7",e:5}],"-1#-1079984624":[{m:"Eg10-e8",e:5}],"1#2096988911":[{m:"Rc7xc5",e:5}],"-1#-573435590":[{m:"i7-i6",e:5}],"1#-767565851":[{m:"Hg3-f5",e:5}],"-1#-2066903934":[{m:"Rd6-e6",e:5}],"1#1525351049":[{m:"Cg7xa7",e:5}],"-1#1949406792":[{m:"Re6-f6",e:5}],"1#1538087661":[{m:"Ca7-a5",e:5}],"-1#1052308364":[{m:"Ci8xi5",e:5}],"1#631753415":[{m:"g5-g6",e:5}],"-1#1202406868":[{m:"Rf6xg6",e:5}],"1#-379821296":[{m:"Rc5-c7",e:5}],"-1#-40187717":[{m:"Rg6-f6",e:5}],"1#1834830953":[{m:"Ca5xi5",e:5}],"-1#239134802":[{m:"Rf6xf5",e:5}],"1#-1190186323":[{m:"Ci5-i2",e:5}],"-1#1413723102":[{m:"Rh10-h6",e:5}],"1#-241956220":[{m:"Ri1-g1",e:5}],"-1#-1874238759":[{m:"Hg8-f6",e:5}],"1#842577514":[{m:"Ci2-c2",e:5}],"-1#894935954":[{m:"Rh6-h9",e:5}],"1#-2004885837":[{m:"Ad1-e2",e:5}],"-1#-948514893":[{m:"Rh9-b9",e:5}],"1#-2063491182":[{m:"Cc2-d2",e:5}],"-1#1508546417":[{m:"Af10-e9",e:5}],"1#1430344675":[{m:"Rg1-h1",e:5}],"-1#1218414680":[{m:"g7-g6",e:8.571},{m:"c7-c6",e:8.571},{m:"Hh10-i8",e:8.571}],"1#1036353317":[{m:"g4-g5",e:5}],"-1#1896778184":[{m:"Eg10-e8",e:5}],"1#-1303136969":[{m:"g5xg6",e:5}],"-1#-646009567":[{m:"Ee8xg6",e:5}],"1#-1899633026":[{m:"Hb1-c3",e:5}],"-1#-593654477":[{m:"Hb10-c8",e:5}],"1#-846356593":[{m:"Ra1-b1",e:5}],"-1#-81694861":[{m:"Ra10-b10",e:5}],"1#-1017953814":[{m:"Rb1-b5",e:5}],"-1#-1677888559":[{m:"Eg6-e8",e:5}],"1#-227108200":[{m:"Eg1-e3",e:5}],"-1#1961860170":[{m:"Cb8-a8",e:5}],"1#-1108496502":[{m:"Rb5-f5",e:5}],"-1#838247121":[{m:"Rb10-b6",e:5}],"1#1122294599":[{m:"Hh1-f2",e:5}],"-1#1957763542":[{m:"Hh10-g8",e:5}],"1#-1234574693":[{m:"Rf5-g5",e:5}],"-1#191019428":[{m:"Hg8-f6",e:5}],"1#-1458344681":[{m:"Ch3-h6",e:5}],"-1#-817719749":[{m:"Hf6xe4",e:5}],"1#-1038694256":[{m:"Hf2xe4",e:5}],"-1#1863650450":[{m:"Rb6xh6",e:5}],"1#-1050130290":[{m:"c4-c5",e:5}],"-1#242971654":[{m:"Af10-e9",e:5}],"1#47231124":[{m:"Hc3-d5",e:5}],"-1#680742569":[{m:"c7-c6",e:5}],"1#-336284270":[{m:"c5xc6",e:5}],"-1#-731394490":[{m:"Ee8xc6",e:5}],"1#-1094952266":[{m:"Af1-e2",e:5}],"-1#-421154692":[{m:"Ec10-e8",e:5}],"1#-898125665":[{m:"Ri1-f1",e:5}],"-1#-415553451":[{m:"Ri10-f10",e:5}],"1#1861197713":[{m:"Hd5-f6",e:5}],"-1#-940383195":[{m:"e7-e6",e:5}],"1#1696633170":[{m:"Cg3-f3",e:5}],"-1#1521145696":[{m:"Rf10-g10",e:5}],"1#1763422108":[{m:"Hf6-g8",e:5}],"-1#-589173745":[{m:"Rh6-g6",e:5}],"1#501940577":[{m:"Rg5xg6",e:5}],"-1#-589028547":[{m:"Ee8xg6",e:5}],"1#-2092641008":[{m:"Hg8-h6",e:5}],"-1#436393287":[{m:"e6-e5",e:5}],"1#-155004429":[{m:"Cf3-g3",e:5}],"-1#-917989439":[{m:"Ch8-g8",e:5}],"1#-1078740725":[{m:"Cg3xg8",e:5}],"-1#1437319946":[{m:"Ca8xg8",e:5}],"1#661607509":[{m:"He4-c3",e:5}],"-1#730650736":[{m:"Cg8-e8",e:5}],"1#182624912":[{m:"Hh6-g4",e:5}],"-1#161528819":[{m:"Rg10-g7",e:5}],"1#-1928241257":[{m:"Hg4xe5",e:5}],"-1#-743160183":[{m:"Hc8-e7",e:5}],"1#-577543523":[{m:"Rf1-f7",e:5}],"-1#1873665987":[],"1#-1946651805":[{m:"Hb1-c3",e:8},{m:"Hh1-i3",e:8}],"-1#-643819474":[{m:"Hb10-c8",e:7.5},{m:"Cb8-d8",e:7.5}],"1#-927987054":[{m:"Ra1-b1",e:6.667},{m:"Eg1-e3",e:6.667}],"-1#-31655314":[{m:"Ra10-b10",e:5}],"1#-965815049":[{m:"Rb1-b5",e:5}],"-1#-1631525172":[{m:"Cb8-a8",e:5}],"1#1472386316":[{m:"Rb5-d5",e:5}],"-1#2110001998":[{m:"Hh10-i8",e:5}],"1#-172022606":[{m:"i4-i5",e:5}],"-1#1268792530":[{m:"Ri10-i9",e:5}],"1#168487094":[{m:"Af1-e2",e:5}],"-1#1381171836":[{m:"Ri9-f9",e:5}],"1#1175770014":[{m:"Eg1-e3",e:5}],"-1#-1064446644":[{m:"Rb10-b4",e:5}],"1#1034562733":[{m:"Cg3-f3",e:5}],"-1#35678879":[{m:"Rb4xc4",e:5}],"1#1715241592":[{m:"Hh1-i3",e:5}],"-1#2142405190":[{m:"c6-c5",e:5}],"1#-241653721":[{m:"Rd5-e5",e:5}],"-1#1311312960":[{m:"Eg10-e8",e:5}],"1#-1921765185":[{m:"Ra1-b1",e:5}],"-1#-1143422909":[{m:"Hc8-d6",e:5}],"1#-1855296576":[{m:"Rb1-b5",e:5}],"-1#-909878789":[{m:"Cb8-d8",e:5}],"1#-1534997240":[{m:"c4-c5",e:5}],"-1#1804792192":[{m:"c6xc5",e:5}],"1#1357520916":[{m:"Rb5xc5",e:5}],"-1#1858034886":[{m:"Ra10-a9",e:5}],"1#1994835335":[{m:"Af1-e2",e:5}],"-1#784281421":[{m:"Ra9-f9",e:5}],"1#-374790205":[{m:"Hh1-i3",e:5}],"-1#-265869315":[{m:"Rf9-f2",e:5}],"1#-1327393710":[{m:"Cg3-g2",e:5}],"-1#383362470":[{m:"Hh10-f9",e:5}],"1#-507983707":[{m:"Ch3-h2",e:7.5}],
"-1#-1095578356":[{m:"Rf2-f7",e:7.5}],"1#-1260024611":[{m:"Ra1-a2",e:5}],"-1#1034159222":[{m:"Eg10-e8",e:5}],"1#-17221495":[{m:"Hh1-i3",e:5}],"-1#-411617097":[{m:"Hb10-c8",e:5}],"1#-161011189":[{m:"Ra2-d2",e:5}],"-1#576972849":[{m:"Af10-e9",e:5}],"1#784870563":[{m:"Cg3xg7",e:5}],"-1#-1312331767":[{m:"Hh10-g8",e:5}],"1#1931449156":[{m:"Rd2-d5",e:5}],"-1#1784601936":[{m:"Ra10-b10",e:5}],"1#1378677705":[{m:"Ch3-g3",e:5}],"-1#1288892399":[{m:"Ch8-h6",e:5}],"1#1998296301":[{m:"Ri1-h1",e:5}],"-1#2105987037":[{m:"Ch6-d6",e:5}],"1#2126143046":[{m:"Rd5-f5",e:5}],"-1#-981818834":[{m:"Rb10-b4",e:5}],"1#945642447":[{m:"c4-c5",e:5}],"-1#-145856697":[{m:"Cd6-e6+",e:5}],"1#1133982361":[{m:"Af1-e2",e:5}],"-1#466540627":[{m:"Hc8-d6",e:5}],"1#830239696":[{m:"e4-e5",e:5}],"-1#-1225550180":[{m:"Ce6-i6",e:5}],"1#-1019890943":[{m:"e5-e6",e:5}],"-1#1238910124":[{m:"e7xe6",e:5}],"1#-1420835978":[{m:"g4-g5",e:5}],"-1#-410765925":[{m:"Ci6xi3",e:5}],"1#388208245":[{m:"Eg1xi3",e:5}],"-1#1262241864":[{m:"Rb4-c4",e:5}],"1#1220300963":[{m:"c5xc6",e:5}],"-1#1999580023":[{m:"Rc4xc6",e:5}],"1#301439949":[{m:"Hc3-b5",e:5}],"-1#1490384289":[{m:"Rc6-b6",e:5}],"1#-9679519":[{m:"Hb5xd6",e:5}],"-1#1514905615":[{m:"Rb6xd6",e:5}],"1#-443120055":[{m:"Rf5-f6",e:5}],"-1#1690684169":[{m:"Ri10-f10",e:5}],"-1#-1837730979":[{m:"Hb10-c8",e:5}],"1#-2090442271":[{m:"Ri1-i2",e:5}],"-1#-702403191":[{m:"Ch8-e8",e:5}],"1#-1253352270":[{m:"Hb1-c3",e:5}],"-1#-418170881":[{m:"Hh10-g8",e:5}],"1#634113202":[{m:"i4-i5",e:5}],"-1#-1680550702":[{m:"Ri10-h10",e:5}],"1#-1047156445":[{m:"Ch3-h5",e:5}],"-1#-1312102624":[{m:"Rh10-h6",e:5}],"1#337469050":[{m:"Ec1-e3",e:5}],"-1#-1493454765":[{m:"Ra10-b10",e:5}],"1#-1635148086":[{m:"g4-g5",e:5}],"-1#-767399897":[{m:"Cb8-b4",e:5}],"1#1871651107":[{m:"c4-c5",e:5}],"-1#-1600381525":[{m:"c6xc5",e:5}],"1#-1679504321":[{m:"Ch5xc5",e:5}],"-1#1289808738":[{m:"Hc8-d6",e:5}],"1#1716666593":[{m:"Ri2-d2",e:5}],"-1#-931140606":[{m:"Hd6-f5",e:5}],"1#1868733871":[{m:"Cg3-f3",e:5}],"-1#1357437853":[{m:"Cb4-d4",e:5}],"1#1462541941":[{m:"Cc5-e5",e:5}],"-1#1878476092":[{m:"e7-e6",e:5}],"1#-853200821":[{m:"Ce5xe8",e:5}],"-1#28571949":[{m:"Eg10xe8",e:5}],"1#-310289295":[{m:"Ra1-b1",e:5}],"-1#-617763699":[{m:"Rb10xb1",e:5}],"1#385996636":[{m:"Hc3xb1",e:5}],"-1#-1898279693":[{m:"Rh6-h4",e:5}],"1#-225317489":[{m:"Hb1-c3",e:5}],"-1#-1597405502":[{m:"Hg8-e7",e:5}],"1#1486167779":[{m:"Ad1-e2",e:5}],"-1#396103651":[{m:"He7-c6",e:5}],"1#1012753438":[{m:"Rd2-b2",e:5}],"-1#2004114663":[{m:"Cd4-d8",e:5}],"1#-1606892296":[{m:"Rb2-b7",e:5}],"-1#-2020328566":[{m:"Ad10-e9",e:5}],"1#1800733563":[{m:"Rb7-d7",e:5}],"-1#-2056341891":[{m:"Hc6-b4",e:5}],"1#782421372":[{m:"Ee3-c5",e:7.5},{m:"Hi3-g2",e:7.5}],"-1#147417133":[{m:"Rh4-i4",e:5}],"1#2000777109":[{m:"Cf3-f2",e:5}],"-1#1776214837":[{m:"Ri4xi5",e:5}],"1#-1942791869":[{m:"Rd7-b7",e:5}],"-1#1644751941":[{m:"Hb4-c6",e:5}],"1#-909863100":[{m:"Cf2-h2",e:5}],"-1#1718783756":[{m:"Ri5xg5",e:5}],"1#37474787":[{m:"Eg1-e3",e:5}],"-1#-2069702863":[{m:"Rg5-g6",e:5}],"1#-1825613361":[{m:"Rb7-f7",e:5}],"-1#-2039714774":[{m:"Rg6-h6",e:5}],"1#339523039":[{m:"Hi3-g4",e:5}],"-1#43391629":[{m:"Rh6-h5",e:5}],"1#378446590":[{m:"Ae2-f3",e:5}],"-1#1436032327":[{m:"Cd8-d4",e:5}],"1#-2100001448":[{m:"Ch2-f2",e:5}],"-1#761437456":[{m:"Hf5-h4",e:5}],"1#-1657190983":[{m:"Rf7xg7",e:5}],"-1#-1032288383":[{m:"Rh5xc5",e:5}],"1#-114632019":[{m:"Hc3-a2",e:5}],"-1#-1581339043":[{m:"Rc5-c4",e:5}],"1#-267705786":[{m:"Hg4-f6",e:5}],"-1#440235666":[{m:"Cd4xa4",e:5}],"1#-1596577558":[{m:"Af1-e2",e:5}],"-1#-124796384":[{m:"Rc4-d4",e:5}],"1#-1947039864":[{m:"Rg7xi7",e:5}],"-1#-1032704044":[],"-1#1529991840":[{m:"Rh4-g4",e:6.667}],"1#-1998133317":[{m:"Hg2-i3",e:7.5}],"-1#-42600345":[{m:"Hc6-b4",e:5},{m:"Rg4-i4",e:7.5}],"1#1291320757":[{m:"Hi3-g2",e:5}],"-1#962912873":[{m:"Rh4-g4",e:6.667}],"1#-1058750556":[{m:"Hb1-c3",e:5}],"-1#-1833118487":[{m:"Hb10-c8",e:5}],"1#-2085829035":[{m:"Ra1-b1",e:5}],"-1#-1258277207":[{m:"Ra10-b10",e:5}],"1#-1921902544":[{m:"c4-c5",e:5}],"-1#1113662648":[{m:"Ri10-i9",e:5}],"1#63697116":[{m:"Eg1-e3",e:5}],"-1#-2058160626":[{m:"Ri9-f9",e:5}],"1#-1860884500":[{m:"i4-i5",e:5}],"-1#789200780":[{m:"Rf9-f4",e:5}],"1#1082486031":[{m:"Cg3-g1",e:5}],"-1#68966128":[{m:"Ec10-e8",e:5}],"1#680416787":[{m:"Hh1-g3",e:5}],"-1#1731460059":[{m:"Cb8-b3",e:5}],"1#1240062739":[{m:"g4-g5",e:5}],"-1#86126078":[{m:"Ch8-g8",e:5}],"1#1943601972":[{m:"Ch3-i3",e:5}],"-1#73583659":[{m:"g7-g6",e:5}],"1#1899510614":[{m:"Hg3-h5",e:5}],"-1#1086024919":[{m:"Rf4-h4",e:5}],"1#-455497356":[{m:"Hh5xi7",e:5}],"-1#153652344":[{m:"Cg8-g9",e:5}],"1#1198372222":[{m:"g5xg6",e:5}],"-1#742436200":[{m:"Rh4-i4",e:5}],"1#1405659856":[{m:"Cg1xg9",e:5}],"-1#-1276936371":[{m:"Hi8xg9",e:5}],"1#610192472":[{m:"Hi7-h5",e:5}],"-1#78174522":[{m:"Ee8xg6",e:5}],"1#590699248":[{m:"Ri1-h1",e:5}],"-1#698876352":[{m:"Hg9-h7",e:5}],"1#719453952":[{m:"Ci3-g3",e:5}],"-1#1584995144":[{m:"Hh7-f8",e:5}],"1#-358825086":[{m:"Hh5-f6",e:5}],"-1#1907409523":[{m:"Ri4xi5",e:5}],"1#-1805813755":[{m:"Hf6-d7",e:5}],"-1#-1421123642":[{m:"Rb10-b9",e:5}],"1#-199442406":[{m:"Rh1-h8",e:5}],"-1#635348079":[{m:"Ri5-f5",e:5}],"1#-239889231":[{m:"Cg3xg10+",e:5}],"-1#797819800":[{m:"Hf8xg10",e:5}],"1#753868873":[{m:"Rh8xc8",e:5}],"-1#-1470759192":[{m:"Af10-e9",e:5}],"1#-1526842758":[{m:"Rc8xc7",e:5}],"-1#-875694949":[{m:"Hg10-f8",e:5}],"1#-20978548":[{m:"Ad1-e2",e:5}],"-1#-1313409652":[{m:"Ke10-f10",e:5}],"1#-855715458":[{m:"Rc7xa7",e:5}],"-1#2142400803":[{m:"Rf5-f6",e:5}],"1#-1208727788":[{m:"Hd7-e5",e:5}],"-1#-538388090":[{m:"e7-e6",e:5}],"1#2100997361":[{m:"He5-g4",e:5}],"-1#-1073331852":[{m:"Rf6-f4",e:5}],"1#113624102":[{m:"Hg4-i5",e:5}],"-1#-1603321474":[{m:"Rf4-i4",e:5}],"1#1717089300":[{m:"Ra7-i7",e:5}],"-1#2143655676":[{m:"Eg6-e8",e:5}],"1#1718138656":[{m:"Hc3-d5",e:5}],"-1#1277905181":[{m:"Ee8-g10",e:5}],"1#-619583255":[{m:"Hi5-g6",e:5}],"-1#-1984901955":[{m:"Ri4xi7",e:5}],"1#-13970432":[{m:"Hg6xi7",e:5}],"-1#-570206750":[{m:"Rb9-b7",e:5}],"1#1729861009":[{m:"Hi7-h5",e:5}],"-1#1206747379":[{m:"Hf8-d7",e:5}],"1#1277628447":[{m:"c5-c6",e:5}],"-1#603768483":[{m:"Rb7-b5",e:5}],"1#-349447012":[{m:"Hh5-g7",e:5}],"-1#-1356983880":[{m:"Rb5xd5",e:5}],"1#-1776925790":[{m:"Rb1xb3",e:5}],"-1#1643427434":[{m:"Rd5-d4",e:5}],"1#1003219685":[{m:"a4-a5",e:5}],"-1#363155369":[{m:"Rd4xe4",e:5}],"1#-1418999286":[{m:"a5-a6",e:5}],"-1#168041238":[{m:"Hd7-f8",e:5}],"1#30313466":[{m:"Rb3-b7",e:5}],"-1#1458768658":[{m:"e6-e5",e:5}],"1#-1171058778":[{m:"Hg7-h5",e:5}],"-1#-33111422":[{m:"Re4-h4",e:5}],"1#-192637746":[{m:"Hh5-f6",e:5}],"-1#1873319231":[{m:"Rh4-f4",e:5}],"1#-178335144":[{m:"Hf6-g8+",e:5}],"-1#770101451":[{m:"Kf10-e10",e:5}],"1#1353643065":[{m:"a6-b6",e:5}],"-1#520968626":[{m:"Rf4-g4",e:5}],"1#-342175291":[{m:"Hg8-f6",e:5}],"-1#857920342":[{m:"Rg4-f4",e:5}],"1#-944415967":[{m:"Hf6-h5",e:5}],"-1#1553554128":[{m:"Rf4-h4",e:5}],"1#-965796425":[{m:"Hh5-f6",e:5}],"-1#1564679238":[{m:"Rh4-h6",e:5}],"1#-944725483":[{m:"Rb7-f7",e:5}],"-1#119209766":[{m:"Rh6-g6",e:5}],"1#-972025272":[{m:"c6-c7",e:5}],"-1#-1468871428":[{m:"Rg6-h6",e:5}],"1#1769480594":[{m:"Ee3-g5",e:5}],"-1#653235575":[{m:"Rh6-h4",e:5}],"1#-1139004636":[{m:"Rf7-e7",e:5}],"-1#1070692268":[{m:"Rh4-f4",e:5}],"1#-1524158261":[{m:"Hf6-g8",e:5}],"-1#2107585112":[{m:"Rf4-c4",e:5}],"1#-1225184584":[{m:"b6-b7",e:5}],"-1#1547734653":[{m:"Rc4xc1+",e:5}],"1#-286351145":[{m:"Ae2-d1",e:5}],"-1#-1578651177":[{m:"e5-d5",e:5}],"1#698646443":[{m:"Hg8-f6",e:5}],"-1#-249791176":[{m:"d5-d4",e:5}],"1#1139976739":[{m:"Re7-f7",e:5}],"-1#-1069549909":[{m:"Rc1-c5",e:5}],"1#-901361136":[{m:"Rf7-g7",e:5}],"-1#1348687356":[{m:"Rc5-e5+",e:5}],"1#216201221":[{m:"Af1-e2",e:5}],"-1#1421546191":[{m:"Re5-e6",e:6.667},{m:"Re5-f5",e:6.667}],"1#-785896518":[{m:"Rg7-f7",e:5}],"-1#1259154518":[{m:"Re6-e5",e:5}],"1#-828500701":[{m:"Af1-e2",e:5}],"1#-740966571":[{m:"Hf6-d7",e:5}],"-1#-322725738":[{m:"Hf8xd7",e:5}],"1#-1100175333":[{m:"c7xd7",e:5}],"-1#1394479196":[{m:"Eg10-i8",e:5}],"1#1837246548":[{m:"Rg7-i7",e:5}],"-1#-1939510833":[{m:"Rf5-f8",e:5}],"1#596370552":[{m:"Ri7-i4",e:5}],"-1#454666636":[{m:"Rf8-g8",e:5}],"1#1684539148":[{m:"Eg5-i3",e:5}],"-1#1527084168":[{m:"Ei8-g10",e:5}],"1#1704545408":[{m:"Ri4xd4",e:5}],"-1#-449193168":[{m:"Eg10-i8",e:5}],"1#-609885384":[{m:"b7-c7",e:5}],"-1#-2141323073":[{m:"Ei8-g10",e:5}],"1#-1094567753":[{m:"d7-e7",e:5}],"-1#-725400374":[{m:"Ke10-f10",e:5}],"1#-1450483656":[{m:"e7-f7",e:5}],"-1#-1157512745":[{m:"Kf10-e10",e:5}],"1#-968235739":[{m:"Rd4-c4",e:5}],"-1#1031686596":[{m:"Rg8-d8",e:5}],"1#-322869786":[{m:"f7-g7",e:5}],"-1#-717540091":[{m:"Ae9-f10",e:5}],"1#-644812393":[{m:"c7-c8",e:5}],"-1#-1049781325":[{m:"Rd8-e8",e:5}],"1#850254870":[{m:"c8-c9",e:5}],"-1#-270829888":[{m:"Re8-e9",e:5}],"1#-826215161":[{m:"g7-f7",e:5}],"-1#-147151388":[{m:"Re9-h9",e:5}],"1#617703637":[{m:"Ei3-g1",e:5}],"-1#-760043162":[{m:"Rh9-f9",e:5}],"1#2096570718":[{m:"Rc4-c7",e:5}],"-1#-1386460975":[{m:"Eg10-i8",e:5}],"1#-1816104743":[{m:"Eg1-e3",e:5}],"-1#358184459":[{m:"Ei8-g10",e:5}],"-1#1131233433":[{m:"Hh10-i8",e:9.994},{m:"Ch8-d8",e:9.994},{m:"Hb10-c8",e:9.994},{m:"Ch8-e8",e:9.994},{m:"Cb8-d8",e:9.994},{m:"c7-c6",e:9.994},{m:"Cb8-g8",e:9.994},{m:"Cb8-e8",e:9.994},{m:"Cb8-f8",e:9.994},{m:"Hb10-a8",e:9.994},{m:"Ch8-g8",e:9.994},{m:"Af10-e9",e:9.994},{m:"Eg10-e8",e:9.994},{m:"Hh10-g8",e:9.994},{m:"g7-g6",e:9.994},{m:"Ec10-e8",e:9.994}],"1#-887720091":[{m:"Hh1-g3",e:6.667}],"-1#-2069112147":[{m:"Ri10-i9",e:6.667}],"1#-989786423":[{m:"Eg1-e3",e:6.667},{m:"Ec1-e3",e:6.667}],"-1#1134037019":[{m:"c7-c6",e:5}],"1#-2130709728":[{m:"Cb3-c3",e:5}],"-1#-1978150855":[{m:"Ec10-e8",e:5}],"1#-1501179686":[{m:"Hb1-a3",e:5}],"-1#-1185190782":[{m:"Hb10-c8",e:5}],"1#-1471447490":[{m:"Ra1-b1",e:5}],"-1#-1628991806":[{m:"Ra10-b10",e:5}],"1#-1500143525":[{m:"Rb1-b5",e:9.667},{m:"Ch3-i3",e:9.667},{m:"i4-i5",e:9.667},{m:"Af1-e2",e:9.667}],"-1#-29650336":[{m:"Ri9-d9",e:8.571}],"-1#2011685088":[{m:"Ri9-f9",e:5}],"1#1671442690":[{m:"i4-i5",e:5}],"-1#-574674590":[{m:"Ec10-e8",e:5}],"1#-248698495":[{m:"Hb1-c3",e:5}],"-1#-1552596276":[{m:"c7-c6",e:5}],"1#1611839991":[{m:"i5-i6",e:5}],"-1#1846242586":[{m:"i7xi6",e:5}],"1#803519849":[{m:"Ri1xi6",e:5}],"-1#-2041364763":[{m:"Ch8-g8",e:5}],"1#-257421265":[{m:"Ch3-i3",e:5}],"-1#-2028740816":[{m:"Cg8-g9",e:5}],"1#-917051850":[{m:"Hg3-h5",e:5}],"1#1419700564":[{m:"Eg1-e3",e:8.571},{m:"Hh1-g3",e:8.571},{m:"Ch3-e3",e:8.571}],"-1#455296156":[{m:"Hh10-g8",e:8}],"1#-637812783":[{m:"g4-g5",e:6.667},{m:"Hg3-h5",e:8}],"-1#-748231455":[{m:"c7-c6",e:8.333},{m:"Ri10-h10",e:8.333},{m:"Ri10-i9",e:8.333}],"1#268509146":[{m:"Hb1-a3",e:6.667},{m:"Cb3-c3",e:6.667}],"-1#266314626":[{m:"Hb10-c8",e:5}],"1#516927806":[{m:"Ra1-a2",e:5}],"-1#-1752286827":[{m:"Cb8-b6",e:5}],"-1#451493059":[{m:"Cb8-b3",e:5}],"1#875764747":[{m:"Eg1-e3",e:5}],"-1#-1297474855":[{m:"Hb10-a8",e:5}],"1#-130196773":[{m:"Hb1-a3",e:5}],"1#-1993893616":[{m:"Ch3-h7",e:5}],"-1#-48953430":[{m:"Ad10-e9",e:5}],"1#299122523":[{m:"Cb3-e3",e:5}],"-1#-1147885375":[{m:"Ec10-e8",e:5}],"1#-1761171422":[{m:"Hb1-c3",e:5}],"-1#-983645329":[{m:"c7-c6",e:5}],"1#104413268":[{m:"Ra1-b1",e:5}],"-1#815122600":[{m:"Hb10-c8",e:5}],"1#562420244":[{m:"Rb1-b7",e:5}],"1#-1832111995":[{m:"Hb1-a3",e:6.667},{m:"Hb1-c3",e:6.667}],"-1#-1928164131":[{m:"a7-a6",e:5}],"1#-1993305633":[{m:"Ra1-a2",e:5}],"-1#7412084":[{m:"Ri9-f9",e:5}],"1#339134614":[{m:"Ra2-d2",e:5}],"-1#-1064019000":[{m:"c7-c6",e:5}],"1#66298099":[{m:"Ra1-a2",e:5}],"-1#-1968035752":[{m:"Ri9-c9",e:5}],"-1#-394729392":[{m:"c7-c6",e:5}],"1#723456875":[{m:"Ri1-i2",e:5}],"-1#2119917315":[{m:"Eg10-e8",e:5}],"1#-1123654660":[{m:"Ec1-e3",e:5}],"-1#266374613":[{m:"Af10-e9",e:5}],"1#55265607":[{m:"Ri2-d2",e:5}],"-1#235495600":[{m:"Hh10-g8",e:5}],"1#-858678275":[{m:"Ri1-i2",e:5}],"-1#-1718233195":[{m:"Ri10-h10",e:5}],"1#-1009472924":[{m:"Hh1-g3",e:5}],"-1#-1939273812":[{m:"Rh10-h6",e:5}],"1#700366582":[{m:"Ri2-d2",e:5}],"-1#-2020404715":[{m:"Af10-e9",e:5}],"1#-1959209337":[{m:"Hg3-f5",e:5}],"-1#-573930016":[{m:"Rh6-f6",e:5}],"1#1383944741":[{m:"Hb1-c3",e:9.942},{m:"Cb3-c3",e:9.942},{m:"c4-c5",e:9.942},{m:"Eg1-e3",e:9.942},{m:"g4-g5",e:9.986},{m:"Ch3-f3",e:9.942},{m:"Ch3-g3",e:9.942},{m:"g4-g5",e:9.583},{m:"g4-g5",e:9.998}],"-1#1486188860":[{m:"Ra10-b10",e:5}],"1#1625776037":[{m:"Ch3-e3",e:5}],"-1#980473409":[{m:"Ch8-e8",e:5}],"1#1494853498":[{m:"Hh1-g3",e:5}],"-1#-1653707091":[{m:"Ch8-e8",e:9.885},{m:"Eg10-e8",e:9.885},{m:"Ra10-a9",e:9.885},{m:"Cb8-a8",e:9.885}],"-1#1998652572":[{m:"Ch8-f8",e:8.571},{m:"c7-c6",e:8.571},{m:"Ri10-i9",e:8.571}],"1#915132664":[{m:"Hh1-g3",e:7.5}],"-1#1283673603":[{m:"Hh10-i8",e:5}],"1#-990348801":[{m:"Hh1-i3",e:5}],"-1#-579438143":[{m:"Ri10-i9",e:5}],"1#-1663259227":[{m:"Ri1-h1",e:5}],"-1#499187693":[{m:"Ec10-e8",e:9.853},{m:"Hh10-i8",e:9.853},{m:"Hb10-c8",e:9.962},{m:"Eg10-e8",e:9.853},{m:"Ad10-e9",e:9.853}],"-1#149609409":[{m:"Cb8-a8",e:9.722},{m:"Ch8-f8",e:9.722},{m:"Eg10-e8",e:9.722},{m:"Hh10-i8",e:9.722}],"1#537145762":[{m:"g4-g5",e:8.333}],"-1#1874435178":[{m:"Hh10-g8",e:9.091},{m:"c7-c6",e:9.091}],"1#-1386125529":[{m:"c4-c5",e:9},{m:"Ec1-e3",e:9},{m:"Ri1-h1",e:9},{m:"Hh1-g3",e:5},{m:"Cb3-b5",e:9}],"-1#1651661743":[{m:"Hb10-a8",e:6.667},{m:"Ri10-i9",e:6.667}],"-1#528976142":[{m:"Ri10-h10",e:5}],"-1#-1476641769":[{m:"Ri10-i9",e:8.333},{m:"Hh10-g8",e:5}],"1#1687930668":[{m:"Cb3-e3",e:6.667},{m:"Hb1-c3",e:6.667}],"-1#-824487754":[{m:"Hb10-c8",e:5}],"-1#918793313":[{m:"Hb10-c8",e:6.667}],"-1#-1708640359":[{m:"c7-c6",e:5}],"1#1498401954":[{m:"Hb1-c3",e:5}],"1#-1394710703":[{m:"Cb3-d3",e:6.667},{m:"Ri1-h1",e:6.667}],"-1#-1777456982":[{m:"Ri10-i9",e:5}],"1#-677053234":[{m:"Hb1-c3",e:5}],"-1#-2047043709":[{m:"Ri9-d9",e:5}],"1#2063089212":[{m:"Ra1-a2",e:5}],"-1#-205932905":[{m:"Hh10-g8",e:5}],"-1#-1505543071":[{m:"Hh10-g8",e:5}],"1#774427754":[{m:"c4-c5",e:5}],"-1#-516167454":[{m:"Hb10-a8",e:5}],"1#-1414747936":[{m:"Hb1-c3",e:5}],"-1#-101399635":[{m:"Hh10-g8",e:5}],"1#992753888":[{m:"Ra1-b1",e:5}],"-1#226543644":[{m:"Ri10-i9",e:5}],"1#1277828216":[{m:"Cb3-b8",e:5}],"-1#1153880201":[{m:"Eg10-e8",e:5}],"1#-2019824522":[{m:"Ch3-g3",e:5}],"-1#-1721372592":[{m:"c7-c6",e:5}],"1#1510083435":[{m:"c5xc6",e:5}],"-1#1704030399":[{m:"Ri9-c9",e:5}],"1#890546932":[{m:"g5-g6",e:5}],"-1#1461200359":[{m:"Rc9xc6",e:5}],"1#519510245":[{m:"g6xg7",e:5}],"-1#590215646":[{m:"Hg8-e9",e:5}],"1#2114374044":[{m:"Eg1-e3",e:5}],"-1#-123744434":[{m:"Ra10-b10",e:5}],"1#-1058151977":[{m:"Hh1-f2",e:5}],"-1#-155704506":[{m:"Rc6-g6",e:5}],"1#-1888870957":[{m:"Cg3-g5",e:5}],"-1#-1561976195":[{m:"Rg6xg7",e:5}],"1#-1816657829":[{m:"Ri1-h1",e:5}],"-1#-1725605013":[{m:"Rg7-f7",e:5}],"1#1678562275":[{m:"Hf2-g4",e:5}],"-1#1568521758":[{m:"Ch8-g8",e:5}],"1#730239188":[{m:"Cg5-a5",e:5}],"1#-2146780254":[{m:"Eg1-e3",e:9.981},{m:"Ch3-e3",e:9.981},{m:"Ch3-h5",e:9.981},{m:"Ch3-f3",e:9.981},{m:"g4-g5",e:9.994},{m:"g4-g5",e:9.773},{m:"Cb3-c3",e:9.981},{m:"Hb1-a3",e:9.981},{m:"Cb3-e3",e:9.981},{m:"g4-g5",e:9.722},{m:"c4-c5",e:9.981},{m:"Ch3-c3",e:9.981}],"-1#-627232186":[{m:"Hb10-c8",e:9.831},{m:"c7-c6",e:9.993}],"-1#-262802015":[{m:"Hb10-c8",e:5}],"1#-515512547":[{m:"c4-c5",e:5}],"-1#-1521029861":[{m:"Hh10-i8",e:8.571},{m:"Cb8-e8",e:8.571},{m:"Ch8-c8",e:8.571},{m:"c7-c6",e:8.571}],"1#-1862346061":[{m:"Hb1-c3",e:5}],"-1#854349195":[{m:"Ec10-e8",e:9.412},{m:"Eg10-e8",e:9.412}],"-1#-1964861253":[{m:"Hb10-a8",e:9.953},{m:"Ec10-e8",e:9.953}],"-1#-1613494278":[{m:"c7-c6",e:9.091}],"-1#709504056":[{m:"c7-c6",e:9.412},{m:"c7-c6",e:9.722}],"-1#-810084758":[{m:"Hb10-c8",e:9.962},{m:"Eg10-e8",e:9.962},{m:"c7-c6",e:9.286},{m:"c7-c6",e:9.091},{m:"c7-c6",e:9.333}],"1#-98623038":[{m:"Cb3-d3",e:6.667},{m:"Ec1-e3",e:6.667}],"-1#-1060147655":[{m:"Hb10-c8",e:5}],"-1#1327073066":[{m:"c6xc5",e:6.667}],"1#1952536254":[{m:"Ec1-e3",e:6.667}],"-1#-1123967932":[{m:"Ec10-e8",e:6.667}],"1#-1852597081":[{m:"Ri1-i3",e:6.667}],"1#1249262240":[{m:"Cb3-e3",e:9.375},{m:"Ec1-e3",e:9.375},{m:"Eg1-e3",e:9.375},{m:"Hh1-i3",e:9.375},{m:"Hh1-g3",e:9.375}],"-1#-533287622":[{m:"Hb10-c8",e:7.5}],"1#-249118842":[{m:"Hh1-g3",e:7.5},{m:"Hb1-c3",e:7.5}],"-1#-1097133490":[{m:"g7-g6",e:5}],"-1#-124726135":[{m:"Hb10-c8",e:5}],"1#-377436619":[{m:"Hh1-g3",e:5}],"-1#-1505924099":[{m:"Ra10-b10",e:5}],"1#-1638972060":[{m:"Hg3-h5",e:5}],"-1#-1345580315":[{m:"Ch8xh3",e:5}],"-1#-856736654":[{m:"Ra10-a8",e:9},{m:"Hb10-c8",e:9}],"1#367553706":[{m:"Hb1-c3",e:5}],"1#-570478898":[{m:"Hb1-c3",e:8.889},{m:"Ra1-a2",e:8.889}],"-1#1408776862":[{m:"Hb10-c8",e:5}],"1#1122510882":[{m:"Hb1-c3",e:5}],"-1#279987055":[{m:"Ra10-b10",e:5}],"1#683830774":[{m:"Ra1-b1",e:5}],"-1#97228648":[{m:"g7-g6",e:5}],"1#1888575509":[{m:"Hg3-f5",e:5}],"-1#644035442":[{m:"g6xg5",e:5}],"1#-1129841851":[{m:"Hf5xe7",e:5}],"1#1992652593":[{m:"Cb3-e3",e:9.855},{m:"g4-g5",e:9.231},{m:"Ch3-e3",e:9.855},{m:"Hb1-c3",e:9.855}],"-1#-595205973":[{m:"Hb10-c8",e:5}],"1#-845811177":[{m:"Ra1-a2",e:5}],"-1#1154775740":[{m:"Ra10-b10",e:5}],"1#2091275301":[{m:"Hb1-c3",e:5}],"-1#788414312":[{m:"Hh10-g8",e:5}],"1#-333003739":[{m:"Ra2-f2",e:5}],"-1#1577340169":[{m:"Rb10-b6",e:6.667},{m:"Ri10-i9",e:6.667}],"-1#964221689":[{m:"c7-c6",e:9.333},{m:"Hb10-c8",e:9.333}],"1#677955653":[{m:"g4-g5",e:8.333},{m:"g4-g5",e:8.75},{m:"Cb3-c3",e:9.286}],"-1#-1701960084":[{m:"Ra10-b10",e:8.333},{m:"Hh10-g8",e:8.333}],"-1#743636693":[{m:"Hb10-c8",e:5}],"1#1027796073":[{m:"Hh1-g3",e:5}],"-1#1929331105":[{m:"c7-c6",e:6.667},{m:"Hh10-g8",e:6.667}],"1#-1315390822":[{m:"Ri1-h1",e:5}],"-1#-1157242454":[{m:"Hh10-g8",e:5}],"1#-1339573524":[{m:"Hb1-a3",e:9.545}],"-1#614276220":[{m:"Hb10-c8",e:9.815}],"1#898436800":[{m:"Ra1-b1",e:9.815},{m:"Cb3-b7",e:9.815},{m:"g4-g5",e:8.75}],"-1#52559420":[{m:"Ch8-g8",e:9.773},{m:"c7-c6",e:9.773}],"-1#687965754":[{m:"Hh10-g8",e:5}],"1#-338068105":[{m:"Ch3-g3",e:5}],"1#1910753129":[{m:"Hh1-g3",e:9.737},{m:"Eg1-e3",e:9.737},{m:"Cb3-e3",e:9.737},{m:"Ra1-a2",e:9.737},{m:"Hb1-c3",e:9.737}],"-1#1046375073":[{m:"Hb10-c8",e:7.5}],"1#793671709":[{m:"Hb1-a3",e:7.5}],"-1#814793797":[{m:"Ra10-b10",e:7.5}],"1#149088988":[{m:"Ra1-b1",e:7.5}],"-1#1045305888":[{m:"Rb10-b6",e:7.5}],"-1#-610053901":[{m:"Hb10-c8",e:6.667}],"1#-894221745":[{m:"Hh1-g3",e:6.667},{m:"Hb1-c3",e:6.667}],"-1#-2062618745":[{m:"Ra10-b10",e:5}],"-1#-1729419006":[{m:"Ra10-b10",e:5}],"-1#-123580478":[{m:"Hb10-c8",e:7.5},{m:"Hh10-i8",e:7.5}],"1#-374186626":[{m:"Ra2-f2",e:6.667}],"1#1893300286":[{m:"Eg1-e3",e:5}],"-1#599501860":[{m:"Hb10-c8",e:9.643},{m:"c7-c6",e:9.643},{m:"Ra10-a9",e:9.643}],"1#1004680549":[{m:"Ec1-e3",e:5}],"1#167379099":[{m:"Ch3-e3",e:5}],"-1#1399687551":[{m:"Ch8-e8",e:5}],"1#805632068":[{m:"Hh1-g3",e:5}],"-1#2142852492":[{m:"Hh10-g8",e:5}],"1#-1117671743":[{m:"Ri1-h1",e:5}],"-1#-1208158735":[{m:"Cb8-c8",e:7.5},{m:"Ra10-a9",e:7.5}],"1#990035859":[{m:"Hb1-a3",e:6.667},{m:"Hb1-c3",e:6.667}],"-1#618398667":[{m:"Ra10-b10",e:5}],"1#481176914":[{m:"Ra1-b1",e:5}],"-1#704830894":[{m:"Rb10-b5",e:5}],"1#77240382":[{m:"Rh1-h5",e:5}],"-1#1767560414":[{m:"Ra10-b10",e:5}],"1#1361640007":[{m:"Ra1-b1",e:5}],"-1#1736706747":[{m:"Rb10-b6",e:5}],"1#345404205":[{m:"Rh1-h7",e:5}],"1#-1348113232":[{m:"Cb3-c3",e:5}],"-1#-1521659991":[{m:"Ra9-f9",e:5}],"1#1650149159":[{m:"Ad1-e2",e:5}],"-1#760370727":[{m:"Rf9-f6",e:5}],"1#-1279543454":[{m:"Rh1-h7",e:5}],"-1#156347679":[{m:"g7-g6",e:5}],"1#2081118818":[{m:"Rh7-g7",e:5}],"-1#1844030346":[{m:"g6xg5",e:5}],"1#-148020291":[{m:"Rg7xg5",e:5}],"-1#-2043032172":[{m:"Ri10-h10",e:5}],"1#899051091":[{m:"Hh1-g3",e:9.986},{m:"Cb3-b5",e:9.986},{m:"Ch3-e3",e:9.986},{m:"Ec1-e3",e:9.986},{m:"Ch3-f3",e:9.986},{m:"Eg1-i3",e:9.986},{m:"g4-g5",e:6.667},{m:"Cb3-e3",e:9.986},{m:"Hb1-c3",e:9.986},{m:"Cb3-b4",e:9.986},{m:"Hh1-i3",e:9.986},{m:"Af1-e2",e:9.986}],"-1#2049688475":[{m:"Hh10-i8",e:9.167}],"-1#48185069":[{m:"g7-g6",e:8.571},{m:"Cb8-e8",e:8.571}],"-1#1862395831":[{m:"Cb8-e8",e:9.892}],"-1#-2022670214":[{m:"Cb8-e8",e:9.8}],"-1#281688298":[{m:"Cb8-e8",e:5}],"1#627183426":[{m:"Hb1-c3",e:5}],"-1#-1007308832":[{m:"Hh10-i8",e:6.667}],"-1#-1613301303":[{m:"Eg10-e8",e:9.977},{m:"Cb8-e8",e:9.977}],"-1#1741554974":[{m:"g7-g6",e:9.722}],"-1#-1914802704":[{m:"Cb8-e8",e:5}],"1#-1200203176":[{m:"Ch3-e3",e:5}],"-1#739798637":[{m:"c7-c6",e:9.375}],"-1#1842316441":[{m:"Hb10-c8",e:8.571}],"1#1338409995":[{m:"Hh1-g3",e:6.667}],"-1#8071619":[{m:"Hh10-g8",e:6.667},{m:"c7-c6",e:6.667}],"1#-1029451122":[{m:"Cb3-e3",e:5}],"-1#1759724820":[{m:"Cb8-d8",e:5}],"1#94818791":[{m:"Hg3-f5",e:5}],"-1#1398047360":[{m:"Hb10-c8",e:5}],"1#1111789628":[{m:"Hb1-c3",e:6.667},{m:"Ch3-i3",e:6.667}],"-1#270334833":[{m:"Ra10-b10",e:5}],"1#678352360":[{m:"Ch3-g3",e:5}],"-1#915458510":[{m:"Rb10-b6",e:5}],"-1#905928483":[{m:"Ra10-b10",e:5}],"1#227373498":[{m:"Ri1-h1",e:5}],"-1#118499978":[{m:"Rb10-b6",e:5}],"1#-1021521160":[{m:"Hb1-c3",e:5}],"-1#-1857766987":[{m:"Hb10-c8",e:5}],"1#-2141934839":[{m:"Ra1-a2",e:5}],"-1#152380322":[{m:"Hh10-g8",e:5}],"1#-875702033":[{m:"Eg1-e3",e:5}],"-1#1297407549":[{m:"Hc8-b6",e:5}],"1#-1828648628":[{m:"Cb3xb8",e:5}],"-1#893139958":[{m:"Ch8xb8",e:5}],"1#-106523780":[{m:"Ri1-h1",e:5}],"-1#-214185908":[{m:"Eg10-e8",e:5}],"1#812053683":[{m:"Hg3-f5",e:5}],"-1#1721018324":[{m:"Hb6xc4",e:5}],"1#-2144306074":[{m:"Hb1-a3",e:9.928},{m:"Hb1-c3",e:9.928},{m:"Ch3-f3",e:9.928},{m:"Ch3-e3",e:9.928},{m:"Hh1-g3",e:9.928},{m:"g4-g5",e:9.888},{m:"Ch3-d3",e:9.928},{m:"Cb3-f3",e:9.928},{m:"Cb3-e3",e:9.928}],"-1#-1611743170":[{m:"Hb10-c8",e:8.75},{m:"c7-c6",e:8.75}],"-1#-764930261":[{m:"c7-c6",e:5}],"1#286256144":[{m:"Hh1-g3",e:6.667}],"-1#1588740568":[{m:"Hb10-c8",e:8}],"-1#-1519637793":[{m:"c7-c6",e:9.677},{m:"Ch8-f8",e:9.677},{m:"Cb8-d8",e:9.677}],"-1#-626526846":[{m:"Hh10-f9",e:9.688},{m:"Eg10-e8",e:9.993}],"-1#-812789330":[{m:"Eg10-e8",e:9.962},{m:"Hh10-f9",e:9.825}],"-1#57829822":[{m:"c7-c6",e:5}],"1#-1072328059":[{m:"Hh1-g3",e:5}],"-1#-446811383":[{m:"Ra10-a9",e:5}],"1#-49829304":[{m:"Hb1-c3",e:5}],"-1#712043516":[{m:"Eg10-e8",e:9.977},{m:"Hh10-f9",e:8.889}],"1#-2118796332":[{m:"c4-c5",e:8.333},{m:"Ch3-e3",e:8.333},{m:"g4-g5",e:9.898},{m:"g4-g5",e:8.333}],"-1#-618515920":[{m:"c7-c6",e:9.993},{m:"Ri10-i9",e:9.993},{m:"Ri10-h10",e:9.993},{m:"Ch8-i8",e:9.993},{m:"Eg10-e8",e:9.993},{m:"Ec10-e8",e:9.993},{m:"Ch8-h2",e:9.993},{m:"Hb10-c8",e:9.993}],"-1#-838330852":[{m:"c7-c6",e:8},{m:"Eg10-e8",e:8},{m:"Ch8-i8",e:8}],"1#225439015":[{m:"Cb3-e3",e:7.5},{m:"Hg3-f5",e:7.5},{m:"Ch3-i3",e:7.5}],"1#223685347":[{m:"Hb1-c3",e:6.667},{m:"Hg3-f5",e:6.667}],"-1#1537702276":[{m:"Af10-e9",e:5}],"1#-202803985":[{m:"Ri1-h1",e:5}],"-1#-109826081":[{m:"Ri10-h10",e:5}],"1#-1556786642":[{m:"Ch3-h7",e:5}],"1#909621220":[{m:"Cb3-e3",e:7.5},{m:"g5xg6",e:7.5}],"-1#-1669914498":[{m:"Eg10-e8",e:5}],"1#1596595329":[{m:"g5xg6",e:5}],"-1#872875159":[{m:"Hh10-f9",e:5}],"1#-1016698476":[{m:"Ch3-g3",e:5}],"-1#-577210958":[{m:"Ee8xg6",e:5}],"1#-1977401619":[{m:"Ra1-a2",e:5}],"-1#56800838":[{m:"Ra10-a9",e:5}],"1#456863495":[{m:"Ra2-f2",e:5}],"-1#-1457936853":[{m:"Eg6-e8",e:5}],"1#-1064153246":[{m:"Cg3-g9",e:5}],"-1#-1524189267":[{m:"Hf9-g7",e:5}],"1#-1399025154":[{m:"Ce3xe7+",e:5}],"-1#187870368":[{m:"Ee8-c6",e:5}],"-1#1562030066":[{m:"Eg10-e8",e:6.667}],"1#-1639476467":[{m:"g6-g7",e:6.667},{m:"Hh1-g3",e:6.667}],"-1#-1036311233":[{m:"Hh10-f9",e:5}],"1#895109180":[{m:"g7-f7",e:5}],"-1#1316532927":[{m:"Ri10-g10",e:5}],"1#-373273866":[{m:"Eg1-e3",e:5}],"-1#1868123172":[{m:"Rg10-g4",e:5}],"-1#-772129083":[{m:"Hh10-f9",e:5}],"1#647713734":[{m:"Ri1-i2",e:5}],"-1#1944002478":[{m:"Ri10-g10",e:5}],"1#-731387929":[{m:"Ri2-f2",e:5}],"1#1878999162":[{m:"Hh1-g3",e:9.444},{m:"Cb3-e3",e:9.444},{m:"Ch3-e3",e:9.444}],"-1#541257138":[{m:"c7-c6",e:9.286},{m:"Hh10-i8",e:9.286},{m:"Hh10-g8",e:9.286},{m:"Ec10-e8",e:9.853},{m:"Hb10-d9",e:9.286}],"1#-1472603570":[{m:"Cb3-e3",e:6.667}],"1#-493218049":[{m:"Hb1-c3",e:5}],"1#710972072":[{m:"Eg1-e3",e:8.571}],"-1#-977283104":[{m:"Hb10-c8",e:6.667}],"1#-726678180":[{m:"Hb1-c3",e:6.667}],"-1#-2030588399":[{m:"Ra10-b10",e:6.667}],"1#-1098547064":[{m:"Ra1-b1",e:6.667}],"-1#-2010550156":[{m:"Ch8-f8",e:6.667},{m:"Hh10-i8",e:6.667}],"1#1261447773":[{m:"Ch3-f3",e:5}],"1#5392264":[{m:"Hh1-g3",e:5}],"-1#896059806":[{m:"Hb10-c8",e:6.667}],"1#611900194":[{m:"Hh1-g3",e:6.667}],"-1#1808103146":[{m:"Ch8-f8",e:6.667},{m:"Hh10-i8",e:6.667}],"1#-1461965629":[{m:"Ri1-h1",e:5}],"-1#-1572767757":[{m:"Ad10-e9",e:7.5}],"1#-474070762":[{m:"Ri1-h1",e:5}],"-1#-383575514":[{m:"Ri10-h10",e:5}],"-1#1075518396":[{m:"Hb10-c8",e:9.985},{m:"Cb8-e8",e:9.985},{m:"g7-g6",e:9.985},{m:"c7-c6",e:9.985},{m:"Hh10-g8",e:9.985},{m:"Ch8-e8",e:9.985},{m:"Hb10-a8",e:9.985},{m:"Cb8-f8",e:9.985},{m:"Ch8-g8",e:9.985},{m:"Ch8-d8",e:9.985},{m:"Ec10-e8",e:9.985},{m:"Cb8-g8",e:9.985},{m:"Eg10-e8",e:9.985}],"1#1359677696":[{m:"g4-g5",e:9.583},{m:"Ch3-i3",e:9.583},{m:"c4-c5",e:9.583},{m:"Hh1-g3",e:9.688},{m:"Hb1-c3",e:9.583}],"-1#649119263":[{m:"Hh10-g8",e:8},{m:"g7-g6",e:8}],"1#-462930606":[{m:"Ri1-h1",e:7.5}],"-1#-285907358":[{m:"Ri10-h10",e:7.5}],"1#-1263264877":[{m:"Rh1-h5",e:7.5}],"1#1407856994":[{m:"Ri1-h1",e:5}],"-1#1500998226":[{m:"Ch8-f8",e:5}],"-1#-1642580600":[{m:"Ra10-a9",e:9.231},{m:"Eg10-e8",e:9.231},{m:"g7-g6",e:9.231},{m:"Cb8-a8",e:9.231}],"1#1564805495":[{m:"Hb1-c3",e:5}],"1#1461323336":[{m:"Hb1-c3",e:5}],"-1#55796301":[{m:"c7-c6",e:7.5},{m:"Hh10-i8",e:7.5}],"1#-1960290895":[{m:"Hh1-g3",e:8}],"1#1974676500":[{m:"Ch3-i3",e:9.231},{m:"g4-g5",e:9.231},{m:"Hb1-c3",e:9.231},{m:"Hh1-g3",e:9.545},{m:"Hh1-g3",e:8.75},{m:"Ra1-a2",e:9.231},{m:"Hh1-g3",e:9.796}],"-1#34136843":[{m:"Hh10-g8",e:5}],"1#-1060104122":[{m:"Ri1-h1",e:5}],"-1#-900906122":[{m:"Hb10-c8",e:5}],"1#-614641206":[{m:"Cb3-d3",e:5}],"-1#-510845391":[{m:"Ad10-e9",e:5}],"1#223094464":[{m:"c4-c5",e:5}],"-1#-1033954744":[{m:"Ri10-h10",e:5}],"1#-1742837831":[{m:"Rh1-h7",e:5}],"-1#586448324":[{m:"e7-e6",e:5}],"-1#1331913711":[{m:"Hb10-c8",e:9},{m:"g7-g6",e:9}],"1#1584623955":[{m:"Hb1-c3",e:8.889}],"-1#204151326":[{m:"Ra10-b10",e:8.889},{m:"Ra10-a9",e:8.889},{m:"Ch8-h6",e:8.889}],"1#878261383":[{m:"c4-c5",e:8.571}],"-1#-79034353":[{m:"Rb10-b6",e:8.75},{m:"g7-g6",e:8.75},{m:"Ch8-f8",e:8.75}],"1#-2007469671":[{m:"Ra1-b1",e:5}],"1#-1911488654":[{m:"Eg1-e3",e:8.333}],"1#343049055":[{m:"Ra1-b1",e:5}],"-1#585003939":[{m:"Ra9-f9",e:5}],"1#-439846099":[{m:"Ad1-e2",e:5}],"-1#-1430164947":[{m:"Hh10-i8",e:5}],"1#582639057":[{m:"c4-c5",e:5}],"-1#-307666599":[{m:"Ri10-i9",e:5}],"1#-1409043139":[{m:"Ch3-i3",e:5}],"1#937582876":[{m:"c4-c5",e:5}],"-1#-118399596":[{m:"Hh10-g8",e:5}],"1#975808217":[{m:"Ec1-e3",e:5}],"-1#-1999681296":[{m:"Ra10-b10",e:5}],"1#-1329764759":[{m:"Ad1-e2",e:5}],"-1#-4950167":[{m:"e7-e6",e:5}],"1#976852114":[{m:"Hb1-c3",e:5}],"-1#1751252959":[{m:"Hb10-c8",e:5}],"1#2037509475":[{m:"Ra1-b1",e:5}],"-1#1339891103":[{m:"Ra10-a9",e:5}],"1#1468302558":[{m:"Rb1-b6",e:5}],"-1#1039022115":[{m:"Ra9-d9",e:5}],"1#1383998848":[{m:"Rb6xg6",e:5}],"-1#705287029":[{m:"Ch8-g8",e:5}],"1#1559428543":[{m:"Cd3-d6",e:5}],"-1#-811462719":[{m:"Eg10-i8",e:5}],"1#-1852439381":[{m:"Ch3-h7",e:5}],"-1#-442197487":[{m:"c7-c6",e:5}],"1#650338602":[{m:"Cd6-f6",e:5}],"-1#1662973380":[{m:"Rd9-d3",e:5}],"1#-1356337065":[{m:"Eg1-e3",e:5}],"-1#700380805":[{m:"Rd3xc3",e:5}],"1#-1603026608":[{m:"Rg6-g7",e:5}],"-1#-1055593183":[{m:"Rc3xc4",e:5}],"1#-746565630":[{m:"g4-g5",e:5}],"-1#-1622432017":[{m:"Ce8xe4+",e:5}],"1#-584646818":[{m:"Hg3xe4",e:5}],"-1#439891537":[{m:"Rc4xe4",e:5}],"1#1854626647":[{m:"g5-g6",e:5}],"-1#-51206977":[{m:"Hh10-g8",e:5}],"1#1042964466":[{m:"Eg1-e3",e:5}],"-1#-1196205792":[{m:"Hb10-c8",e:5}],"1#-1448916068":[{m:"Cb3-d3",e:5}],"-1#-1821178777":[{m:"Af10-e9",e:5}],"1#-1613184779":[{m:"Ra2-f2",e:5}],"-1#771377625":[{m:"Ch8-h4",e:5}],"1#141783731":[{m:"g4-g5",e:5}],"-1#1152943198":[{m:"c7-c6",e:5}],"1#893512897":[{m:"Cb3-d3",e:9.982},{m:"c4-c5",e:9.982},{m:"Hb1-a3",e:9.982},{m:"Ri1-i2",e:9.982},{m:"Hb1-c3",e:9.982},{m:"Ec1-e3",e:9.982},{m:"Hh1-g3",e:8.333},{m:"Hh1-g3",e:6.667},{m:"Hh1-g3",e:9.985},{m:"Cb3-e3",e:9.982}],"-1#261202746":[{m:"Hb10-c8",e:9.783},{m:"Hh10-g8",e:9.783},{m:"Hb10-a8",e:9.783},{m:"Ch8-e8",e:9.783}],"-1#1610981545":[{m:"Hh10-g8",e:9.091},{m:"Hb10-c8",e:9.091},{m:"Cb8-g8",e:9.091},{m:"Ch8-g8",e:9.091}],"-1#1729726348":[{m:"g7-g6",e:8.75},{m:"Hh10-g8",e:8.571}],"1#-1514046271":[{m:"Cb3-a3",e:8.333}],"-1#-2019097880":[{m:"Hb10-c8",e:6.667},{m:"Hh10-g8",e:6.667}],"1#-1766387628":[{m:"Hb1-d2",e:5}],"1#1166014885":[{m:"c4-c5",e:5}],"-1#456083853":[{m:"Ch8-e8",e:8.571},{m:"Hh10-g8",e:8.571},{m:"Hb10-c8",e:8.571}],"1#2017867958":[{m:"Hb1-a3",e:5}],"-1#1738048750":[{m:"Hh10-g8",e:5}],"1#-1522499677":[{m:"Ha3-b5",e:5}],"-1#-1578875174":[{m:"Cb8xb3",e:5}],"1#-538474291":[{m:"Ch3xb3",e:5}],"-1#-1964239427":[{m:"Hb10-a8",e:5}],"1#-1065658945":[{m:"Ad1-e2",e:5}],"-1#-1888336705":[{m:"Ri10-h10",e:5}],"1#-718063282":[{m:"Ec1-e3",e:5}],"-1#1742067559":[{m:"Ra10-a9",e:5}],"1#2139901478":[{m:"Ra1-d1",e:5}],"-1#361569175":[{m:"Ra9-f9",e:5}],"1#-761588967":[{m:"Hb5-d6",e:5}],"-1#1593346560":[{m:"Rf9-f4",e:5}],"1#-638078272":[{m:"Hb1-a3",e:7.5}],"1#171924273":[{m:"Ri1-i2",e:6.667},{m:"Hh1-g3",e:5}],"-1#1601902425":[{m:"Hh10-g8",e:5}],"1#-1650201580":[{m:"Hb1-a3",e:5}],"-1#-2105716660":[{m:"c7-c6",e:5}],"1#1092266871":[{m:"Ha3-b5",e:5}],"-1#1170117134":[{m:"Cb8xb3",e:5}],"1#1002265625":[{m:"Ch3xb3",e:5}],"-1#1857470825":[{m:"Ch8-h5",e:5}],"1#-1239409754":[{m:"Hb5-a3",e:5}],"-1#-1299963169":[{m:"Ra10-b10",e:5}],"1#-1963586490":[{m:"Ra1-b1",e:5}],"-1#-1134887750":[{m:"Eg10-e8",e:5}],"-1#1123689438":[{m:"Ch8-e8",e:9.907},{m:"Ch8-d8",e:9.907},{m:"Hh10-g8",e:9.907},{m:"Ch8-f8",e:9.907}],"1#563303141":[{m:"Ri1-h1",e:6.667}],"-1#722340309":[{m:"Hh10-g8",e:6.667}],"1#-371789160":[{m:"c4-c5",e:6.667}],"1#1426688531":[{m:"Ri1-h1",e:8.889}],"-1#1603588387":[{m:"Hh10-g8",e:8.889}],"1#-1655952786":[{m:"Rh1-h5",e:8.889},{m:"c4-c5",e:8.889},{m:"Hb1-a3",e:8.889},{m:"Hb1-c3",e:8.889},{m:"a4-a5",e:8.889}],"-1#226993350":[{m:"Ri10-h10",e:5}],"1#1472649527":[{m:"Rh5xh10",e:5}],"-1#1067611239":[{m:"Hg8xh10",e:5}],"1#1674006414":[{m:"Cb3-e3",e:5}],"-1#-913844204":[{m:"Hh10-g8",e:5}],"1#190784345":[{m:"Hb1-c3",e:5}],"-1#1493649428":[{m:"Hb10-a8",e:5}],"1#328206358":[{m:"Ra1-b1",e:5}],"-1#624752874":[{m:"Ra10-b10",e:5}],"1#491705971":[{m:"Rb1-b5",e:5}],"-1#1381963494":[{m:"Ec10-e8",e:9.667},{m:"Ri10-i9",e:9.667},{m:"Cb8-b4",e:9.667},{m:"Hb10-a8",e:9.667}],"1#2127369733":[{m:"Hb1-c3",e:8.571},{m:"Ec1-e3",e:8.571}],"1#334873218":[{m:"Rh1-h5",e:8.571},{m:"Hb1-c3",e:8.571}],"1#-275619870":[{m:"Hb1-c3",e:5}],"1#415782628":[{m:"Cb3-d3",e:9.474},{m:"Cb3-e3",e:9.474}],"-1#-2104322506":[{m:"a7-a6",e:5}],"1#-2035250380":[{m:"Ad1-e2",e:5}],"-1#-910583244":[{m:"Cd8-d4",e:5}],"1#1218975007":[{m:"Eg1-e3",e:5}],"-1#-835644467":[{m:"Cd4xa4",e:5}],"1#-547024452":[{m:"Ha3-b1",e:5}],"-1#-1061442076":[{m:"Cb8-a8",e:5}],"1#163159588":[{m:"Hb1-c3",e:5}],"-1#1541535081":[{m:"Ri10-i9",e:5}],"1#441131277":[{m:"Ra1-b1",e:5}],"-1#-820756189":[{m:"Hb10-a8",e:6.667}],"1#-2055012063":[{m:"c4-c5",e:6.667}],"-1#1250966953":[{m:"Ri10-i9",e:9.6},{m:"Eg10-e8",e:9.6},{m:"Ec10-e8",e:9.6},{m:"Cb8-b4",e:9.6},{m:"Ra10-a9",e:9.6},{m:"Af10-e9",e:9.6}],"1#188410317":[{m:"Rh1-h5",e:5}],"1#1711422794":[{m:"a4-a5",e:5}],"-1#-1289580766":[{m:"Hb10-a8",e:5}],"1#-105525472":[{m:"Hb1-a3",e:5}],"-1#-429165704":[{m:"Ra10-a9",e:5}],"1#-30217671":[{m:"Cb3-b5",e:5}],"-1#-914638201":[{m:"Eg10-e8",e:5}],"1#170296952":[{m:"Cb5-c5",e:5}],"-1#-1640787018":[{m:"Cb8-b9",e:5}],"1#1665683773":[{m:"Ra1-b1",e:5}],"-1#1441046977":[{m:"Cb9-g9",e:5}],"1#-903765064":[{m:"Rb1-b8",e:5}],"-1#-477264638":[{m:"Af10-e9",e:5}],"1#-2145199981":[{m:"Ri1-h1",e:9.894},{m:"c4-c5",e:9.894}],"-1#-1967160413":[{m:"Ri10-h10",e:9.891}],"1#-788595118":[{m:"Rh1-h5",e:9.891},{m:"c4-c5",e:9.891},{m:"Rh1-h7",e:9.891},{m:"Hb1-c3",e:9.891},{m:"Hb1-a3",e:9.891}],"-1#1077244154":[{m:"Ch8-i8",e:9.643},{m:"Hb10-c8",e:9.643},{m:"Cb8-b6",e:9.643}],"1#1361404486":[{m:"g4-g5",e:8.75}],"-1#535675610":[{m:"Cb8-b4",e:9.444},{m:"Ch8-h4",e:9.444},{m:"Hb10-c8",e:9.444}],"1#-1574925346":[{m:"e4-e5",e:8}],"1#979696048":[{m:"Hb1-c3",e:8.333}],"-1#1779754031":[{m:"Ch8-h9",e:9.773},{m:"Ec10-e8",e:9.773},{m:"Cb8-d8",e:9.773},{m:"Hb10-c8",e:9.773}],"-1#-2103012065":[{m:"Ch8-h4",e:7.5},{m:"Hb10-c8",e:7.5
}],"1#-1490047371":[{m:"Hb1-c3",e:8.333}],"1#-1816754269":[{m:"Ra1-a2",e:6.667}],"-1#-819969526":[{m:"Hb10-c8",e:5}],"1#-567258954":[{m:"a4-a5",e:5}],"-1#-262212102":[{m:"Ra10-b10",e:5}],"1#-936584349":[{m:"Cb3-d3",e:5}],"-1#1328669723":[{m:"Ec10-e8",e:6.667},{m:"Ri10-h10",e:6.667}],"1#1671685368":[{m:"Ri1-h1",e:7.5},{m:"Hb1-c3",e:7.5}],"-1#1765720008":[{m:"Ri10-h10",e:5}],"1#864010809":[{m:"Rh1-h5",e:5}],"-1#-1548465007":[{m:"Hb10-c8",e:5}],"1#-1297850835":[{m:"Hb1-c3",e:5}],"-1#-520342176":[{m:"Cb8-b6",e:5}],"-1#838569909":[{m:"Hb10-d9",e:6.667},{m:"Hg8-h6",e:6.667}],"1#1004138671":[{m:"Ri1-h1",e:5}],"-1#826583967":[{m:"Hg8-f6",e:5}],"1#-1405982918":[{m:"Hc3-d5",e:5}],"-1#-2039375609":[{m:"Hb10-d9",e:5}],"1#359700970":[{m:"Hb1-c3",e:5}],"-1#1193865895":[{m:"Ec10-e8",e:5}],"1#1807413828":[{m:"Ri1-i2",e:5}],"-1#1056882220":[{m:"Hb10-c8",e:5}],"1#804170896":[{m:"Ec1-e3",e:5}],"-1#-1660403015":[{m:"Ad10-e9",e:5}],"1#1909029448":[{m:"Ri2-f2",e:5}],"-1#2099032114":[{m:"Ch8-i8",e:5}],"1#1090376385":[{m:"Ad1-e2",e:5}],"-1#267699137":[{m:"Cb8-b4",e:5}],"1#-1304851771":[{m:"g4-g5",e:5}],"-1#-17662936":[{m:"g6xg5",e:5}],"1#1681306655":[{m:"Ee3xg5",e:5}],"1#-2115798537":[{m:"Ri1-h1",e:8}],"-1#-1954667833":[{m:"Hh10-g8",e:8}],"1#1235671434":[{m:"c4-c5",e:8},{m:"Rh1-h7",e:8},{m:"Cb3-e3",e:8}],"-1#-2034899710":[{m:"Hb10-c8",e:7.5}],"1#-1750730818":[{m:"Hb1-c3",e:7.5}],"-1#-973234957":[{m:"Ad10-e9",e:7.5},{m:"Ec10-e8",e:7.5},{m:"Cb8-b4",e:7.5}],"1#691840002":[{m:"Cb3-b5",e:5}],"-1#511046844":[{m:"Ec10-e8",e:5}],"1#854062175":[{m:"g4-g5",e:5}],"-1#2116813490":[{m:"Ra10-d10",e:5}],"1#-378561520":[{m:"Rh1-h7",e:5}],"-1#1401259629":[{m:"Ri10-i8",e:5}],"1#146839806":[{m:"g4-g5",e:5}],"-1#1141599763":[{m:"g6xg5",e:5}],"1#2016466423":[{m:"Hc3-d5",e:5}],"-1#1383279562":[{m:"Cb4xg4",e:5}],"1#-1407343013":[{m:"Eg1-e3",e:5}],"-1#713334921":[{m:"Ri10-h10",e:5}],"-1#-213072905":[{m:"Hb10-c8",e:5}],"1#-497233589":[{m:"Rh7-g7",e:5}],"-1#-205643613":[{m:"Cf8-f9",e:5}],"1#-1123504256":[{m:"Rg7xg6",e:5}],"-1#-50782768":[{m:"Cf9-g9",e:5}],"1#1412819047":[{m:"Rg6-d6",e:5}],"-1#750724142":[{m:"Ec10-e8",e:5}],"1#2958541":[{m:"Ec1-e3",e:5}],"-1#-1295267100":[{m:"c7-c6",e:5}],"1#1907110367":[{m:"Rd6-d7",e:5}],"-1#-2073441007":[{m:"Hg8-f6",e:5}],"1#639113634":[{m:"Rd7-d2",e:5}],"-1#-1532597457":[{m:"Ad10-e9",e:5}],"1#1214731230":[{m:"Rd2-h2",e:5}],"-1#-1519687658":[{m:"Ra10-d10",e:5}],"1#1665493372":[{m:"g4-g5",e:5}],"-1#797876113":[{m:"Cb8-b4",e:5}],"1#-1841047915":[{m:"Hb1-d2",e:5}],"-1#-471446000":[{m:"Hb10-c8",e:5}],"1#-218735444":[{m:"Hb1-c3",e:5}],"-1#-1599195167":[{m:"Ra10-b10",e:5}],"1#-1730406024":[{m:"Ra1-b1",e:5}],"-1#-1368331900":[{m:"Af10-e9",e:5}],"1#-1562694378":[{m:"Rb1-b5",e:5}],"-1#-92987603":[{m:"Cb8-a8",e:5}],"1#863448301":[{m:"Rb5xb10",e:5}],"-1#-421645148":[{m:"Hc8xb10",e:5}],"1#1622896680":[{m:"Ce3xe7+",e:5}],"-1#-954905226":[{m:"Cf8-e8",e:5}],"1#2058899733":[{m:"Ce7-e6",e:5}],"-1#-2124633040":[{m:"Hg8-e7",e:5}],"1#2030056465":[{m:"Ce6xe8+",e:5}],"-1#-1937975666":[{m:"Eg10xe8",e:5}],"1#-1607134833":[{m:"e4-e5",e:5}],"-1#666563779":[{m:"He7-c6",e:5}],"1#209428286":[{m:"Rh1-h5",e:5}],"-1#-1627292837":[{m:"Hh10-g8",e:9.773},{m:"Hb10-c8",e:9.773}],"1#1574535190":[{m:"Hb1-c3",e:9.333}],"1#-1911461401":[{m:"Hb1-c3",e:9.667}],"1#-2088968057":[{m:"Ec1-e3",e:9.722},{m:"Ri1-i2",e:9.722},{m:"Cb3-c3",e:9.722},{m:"Ch3-i3",e:9.722},{m:"g4-g5",e:9.722}],"-1#832179886":[{m:"Hh10-i8",e:9.375},{m:"Ec10-e8",e:9.375},{m:"Hb10-c8",e:9.375}],"1#-1176422062":[{m:"Hb1-d2",e:6.667}],"1#545922066":[{m:"g4-g5",e:8.571}],"-1#-700928785":[{m:"Eg10-e8",e:6.667}],"1#358977552":[{m:"Cb3-e3",e:6.667}],"-1#-1088092278":[{m:"Hb10-c8",e:6.667}],"1#-1372252874":[{m:"Hb1-c3",e:6.667}],"-1#-59933061":[{m:"Ra10-b10",e:6.667}],"1#-1004580638":[{m:"e4-e5",e:6.667}],"-1#-1986739298":[{m:"Ec10-e8",e:8},{m:"Eg10-e8",e:8}],"1#-1526283395":[{m:"Hb1-a3",e:7.5}],"-1#-1160216795":[{m:"g7-g6",e:7.5}],"1#1254752097":[{m:"Hb1-a3",e:5}],"-1#1427587897":[{m:"Hb10-c8",e:5}],"-1#-188272744":[{m:"Hh10-g8",e:8},{m:"Ch8-d8",e:8}],"1#908055765":[{m:"Ri1-h1",e:7.5}],"-1#1015189477":[{m:"Ri10-h10",e:7.5}],"1#-483097003":[{m:"Ri1-h1",e:5}],"-1#-374743707":[{m:"Hh10-g8",e:5}],"1#-2101092111":[{m:"Ch3-i3",e:8.333},{m:"g4-g5",e:8.333},{m:"Hh1-g3",e:9.333}],"-1#-176672786":[{m:"Hh10-g8",e:9.907}],"1#594700935":[{m:"g4-g5",e:8.333},{m:"Ri1-h1",e:8.333},{m:"Hh1-g3",e:9.091}],"-1#703541687":[{m:"Hh10-g8",e:6.667}],"1#-348665094":[{m:"c4-c5",e:6.667},{m:"Ri1-h1",e:5}],"-1#-1668545051":[{m:"Ri10-i9",e:6.667},{m:"Hb10-c8",e:6.667}],"1#-584658559":[{m:"Hb1-c3",e:5}],"1#-1919150247":[{m:"c4-c5",e:5}],"-1#1116679121":[{m:"Ra10-a9",e:5}],"1#1524019856":[{m:"Ad1-e2",e:5}],"-1#366977936":[{m:"Ra9-d9",e:5}],"1#2052046387":[{m:"Cb3-e3",e:5}],"-1#-804312663":[{m:"Rd9-d4",e:5}],"1#2042102514":[{m:"g4-g5",e:5}],"-1#896791583":[{m:"Rd4-d5",e:5}],"1#1867294864":[{m:"Ce3-c3",e:5}],"-1#-768005278":[{m:"Rd5xg5",e:5}],"1#-2094929609":[{m:"Ec1-e3",e:5}],"-1#835127070":[{m:"Rg5-g6",e:5}],"1#-693441371":[{m:"Ci3-i2",e:5}],"-1#-879440583":[{m:"Rg6-b6",e:5}],"1#1279809823":[{m:"Hb1-d2",e:5}],"-1#-1643165670":[{m:"e7-e6",e:5}],"1#1021132141":[{m:"Hg3-f5",e:5}],"-1#1781493258":[{m:"e6-e5",e:5}],"1#-2031129922":[{m:"e4xe5",e:5}],"-1#-388574443":[{m:"Hc8-e7",e:5}],"1#-420350207":[{m:"Hf5-h6",e:5}],"-1#-2124334499":[{m:"Ri10-h10",e:5}],"1#-618641492":[{m:"Hh6xg8",e:5}],"-1#-40766102":[{m:"Rh10xh1",e:5}],"1#-974358572":[{m:"Hg8xe7",e:5}],"-1#35438633":[{m:"Ce8xe5",e:5}],"1#444069373":[{m:"c5-c6",e:5}],"-1#1974215489":[{m:"Rb6-b4",e:5}],"1#-431713209":[{m:"He7-d9",e:5}],"-1#-212831564":[{m:"Ad10-e9",e:5}],"1#529615429":[{m:"Hd9xb8",e:5}],"-1#-1379372628":[{m:"Rb4xb8",e:5}],"1#619058721":[{m:"Hd2-c4",e:5}],"-1#-867740994":[{m:"Ce5-e6",e:5}],"1#1548523369":[{m:"c6-d6",e:5}],"-1#526992385":[{m:"Ce6-e4",e:5}],"1#-845598506":[{m:"Cc3xc7",e:5}],"-1#889087508":[{m:"Rh1xg1",e:5}],"1#403766589":[{m:"Cc7-e7+",e:5}],"-1#-1903179526":[{m:"Ec10-e8",e:5}],"1#-1575106535":[{m:"Hc4-e5",e:5}],"-1#-787452903":[{m:"Rg1-g5",e:5}],"1#-1429962261":[{m:"Ra1-c1",e:5}],"-1#243791783":[{m:"Ke10-d10",e:5}],"1#2003915486":[{m:"Rc1-d1",e:5}],"-1#-1527888302":[{m:"Rg5xe5",e:5}],"1#872284266":[{m:"d6-e6+",e:5}],"-1#1094878828":[{m:"Kd10-e10",e:5}],"1#951329557":[{m:"Ce7xe5",e:5}],"-1#-1128954896":[{m:"Ce4xe6",e:5}],"1#248874462":[{m:"Rd1-d6",e:5}],"-1#-1534185918":[{m:"Rb8-b1+",e:5}],"1#556866575":[{m:"Ae2-d1",e:5}],"-1#1849167119":[{m:"Ce6-i6",e:5}],"1#469641362":[{m:"Ci2-g2",e:5}],"-1#1838283710":[{m:"Eg10-i8",e:5}],"1#866513108":[{m:"Rd6-h6",e:5}],"-1#-374057758":[{m:"Rb1-b4",e:5}],"1#-1739330721":[{m:"i4-i5",e:5}],"-1#642577215":[{m:"Rb4-e4",e:5}],"1#1661195630":[{m:"Ce5-c5",e:5}],"-1#-2073540716":[{m:"Re4xe3+",e:5}],"1#-1591883590":[{m:"Cg2-e2",e:5}],"-1#1163413720":[{m:"Re3-e5",e:5}],"1#1884434573":[{m:"Cc5-c7",e:5}],"-1#-1280420235":[{m:"Re5xi5",e:5}],"1#-1195016417":[{m:"Cc7xi7",e:5}],"-1#270991473":[{m:"Ri5-d5",e:5}],"1#-1919511600":[{m:"Rh6xi6",e:5}],"-1#-809243937":[{m:"Ke10-d10",e:5}],"1#-1238020186":[{m:"Ce2-i2",e:5}],"-1#969026457":[{m:"Rd5xd1+",e:5}],"1#598740847":[{m:"Ke1-e2",e:5}],"-1#-2089011872":[{m:"g7-g6",e:5}],"1#-165232099":[{m:"Ri6-i5",e:5}],"-1#1413245062":[{m:"Rd1-d7",e:5}],"1#46640783":[{m:"Ci7-i6",e:5}],"-1#-507625189":[{m:"Rd7-e7+",e:5}],"1#-80970635":[{m:"Ke2-f2",e:5}],"-1#2120299844":[],"1#176970686":[{m:"g4-g5",e:5}],"-1#1179102547":[{m:"Ra10-a9",e:5}],"1#1579037714":[{m:"Cb3-e3",e:5}],"-1#-195124344":[{m:"Hh10-g8",e:5}],"1#914774213":[{m:"Hg3-f5",e:5}],"-1#1618217890":[{m:"Eg10-e8",e:5}],"1#-1557579939":[{m:"Hb1-c3",e:5}],"-1#-244229104":[{m:"Ra9-f9",e:5}],"1#912741534":[{m:"Ch3-h5",e:5}],"-1#1178081949":[{m:"Cb8-b6",e:5}],"1#-1949062238":[{m:"Ra1-b1",e:5}],"-1#-1115727010":[{m:"Cb6-i6",e:5}],"1#-315054933":[{m:"Eg1-i3",e:5}],"-1#458974488":[{m:"Af10-e9",e:5}],"1#401645962":[{m:"c4-c5",e:5}],"-1#-656171774":[{m:"Ci6-e6",e:5}],"1#-2009415640":[{m:"Hf5xg7",e:5}],"-1#-891789597":[{m:"Ce6xe3",e:5}],"1#1328971830":[{m:"Ec1xe3",e:5}],"-1#-52554923":[{m:"i7-i6",e:5}],"1#-214704758":[{m:"Rb1-b6",e:5}],"-1#-1722195593":[{m:"Ri10-i7",e:5}],"1#1553341353":[{m:"g5-g6",e:5}],"-1#1050318010":[{m:"c7-c6",e:5}],"1#-33722495":[{m:"c5xc6",e:5}],"-1#-1032973227":[{m:"Ee8xg6",e:5}],"1#-1781178614":[{m:"Ch5-c5",e:5}],"-1#-147308503":[{m:"Eg6-e8",e:5}],"1#-1632392864":[{m:"Ri1-h1",e:5}],"-1#-1808862640":[{m:"Rf9-h9",e:5}],"1#980122216":[{m:"Hg7-f5",e:5}],"-1#422556586":[{m:"Ae9-f10",e:5}],"1#361002808":[{m:"Rb6-b8",e:5}],"-1#1268767246":[{m:"i6-i5",e:5}],"1#1922407500":[{m:"Cb3-e3",e:6.667},{m:"Ch3-i3",e:6.667}],"-1#-657126442":[{m:"Hb10-c8",e:5}],"1#-909829782":[{m:"Hb1-c3",e:5}],"-1#-1684180441":[{m:"Ra10-b10",e:5}],"1#-1544594242":[{m:"Ra1-a2",e:5}],"-1#716100629":[{m:"Rb10-b6",e:5}],"1#1505537411":[{m:"Ra2-f2",e:5}],"-1#-341957457":[{m:"Ad10-e9",e:5}],"1#123673694":[{m:"e4-e5",e:5}],"-1#-2133788398":[{m:"Ec10-e8",e:5}],"1#-1404896783":[{m:"Hg3-e4",e:5}],"-1#1329548526":[{m:"Hh10-i8",e:5}],"1#-951813358":[{m:"Ri1-i2",e:5}],"-1#-1845479558":[{m:"Ch8-h4",e:5}],"1#-1215755248":[{m:"e5-e6",e:5}],"-1#1030028221":[{m:"Ch4xe4+",e:5}],"1#1771073418":[{m:"Hc3xe4",e:5}],"-1#86922067":[{m:"Hb10-c8",e:5}],"1#339624431":[{m:"Ri1-h1",e:5}],"-1#514005727":[{m:"Hh10-g8",e:5}],"1#-595861102":[{m:"Rh1-h7",e:5}],"-1#1720843247":[{m:"Af10-e9",e:5}],"1#1782202237":[{m:"Hb1-a3",e:5}],"-1#1977910053":[{m:"a7-a6",e:5}],"1#1908842023":[{m:"Ra1-b1",e:5}],"-1#1198157531":[{m:"Ra10-b10",e:5}],"1#2132295746":[{m:"Cb3-b5",e:5}],"-1#1213272316":[{m:"Rb10-b6",e:5}],"1#994273642":[{m:"Cb5-i5",e:5}],"-1#-1128534976":[{m:"Rb6-i6",e:5}],"1#-1035903907":[{m:"Ci5-h5",e:5}],"-1#1323665244":[{m:"Ri6-g6",e:5}],"1#-1440836586":[{m:"Ch5xh8",e:5}],"1#920663414":[{m:"Eg1-e3",e:7.5},{m:"Ri1-h1",e:7.5},{m:"c4-c5",e:7.5}],"-1#-1334234204":[{m:"Hh10-i8",e:5}],"1#939656280":[{m:"Cb3-d3",e:8.571},{m:"Ri1-h1",e:8.571}],"-1#47336355":[{m:"Cb8-e8",e:5}],"1#930774027":[{m:"Hb1-c3",e:5}],"-1#1696732998":[{m:"Hb10-c8",e:5}],"1#1949435386":[{m:"Ra1-b1",e:5}],"-1#849305448":[{m:"Ri10-h10",e:8.333}],"1#1759388313":[{m:"Ch3-h7",e:8.333},{m:"Hb1-a3",e:8.333}],"-1#485276707":[{m:"g7-g6",e:8}],"-1#1014853190":[{m:"g7-g6",e:5}],"1#1227331899":[{m:"Eg1-e3",e:5}],"-1#-809590807":[{m:"Hh10-i8",e:5}],"1#1204135957":[{m:"c4-c5",e:5}],"-1#-1999203171":[{m:"Ri10-i9",e:5}],"1#-914603783":[{m:"Ch3-h8",e:5}],"-1#-1062692572":[{m:"Ec10-e8",e:5}],"1#-331703865":[{m:"Hb1-c3",e:5}],"-1#-1100811638":[{m:"g6-g5",e:5}],"1#-940370883":[{m:"Ee3xg5",e:5}],"-1#-101512706":[{m:"g7-g6",e:5}],"1#-1935016317":[{m:"Hb1-c3",e:5}],"-1#-554592818":[{m:"Hb10-a8",e:5}],"1#-1805199924":[{m:"Eg1-e3",e:5}],"-1#318755614":[{m:"Hh10-i8",e:5}],"1#-1702566686":[{m:"Cb3-b7",e:5}],"-1#-2046268392":[{m:"Ad10-e9",e:5}],"1#1791579369":[{m:"Cb7xe7+",e:5}],"-1#2074834647":[{m:"Ec10-e8",e:5}],"1#1463383604":[{m:"Ra1-b1",e:5}],"1#1474867825":[{m:"Ri1-h1",e:6.667}],"-1#1568008513":[{m:"Hh10-g8",e:6.667}],"1#-1616047604":[{m:"g4-g5",e:6.667}],"1#1820924767":[{m:"Ch3-i3",e:5}],"-1#456315968":[{m:"Hh10-i8",e:5}],"1#-1823874116":[{m:"Ri1-h1",e:5}],"-1#-1714112372":[{m:"Ri10-h10",e:5}],"1#-1013594755":[{m:"Hb1-a3",e:5}],"-1#-599033563":[{m:"a7-a6",e:5}],"1#-664181721":[{m:"g4-g5",e:5}],"-1#-1801284918":[{m:"Hb10-c8",e:5}],"1#-2051899274":[{m:"Eg1-e3",e:5}],"-1#53184164":[{m:"a6-a5",e:5}],"1#-1286532776":[{m:"a4xa5",e:5}],"-1#185971113":[{m:"Ra10xa5",e:5}],"1#175334170":[{m:"Ci3-i2",e:5}],"-1#390939270":[{m:"i7-i6",e:5}],"1#413174873":[{m:"Cb3-c3",e:5}],"-1#306753344":[{m:"Ra5-a6",e:5}],"1#-399024102":[{m:"Ra1-b1",e:5}],"-1#-560230170":[{m:"Cb8-b2",e:5}],"1#1881914337":[{m:"Ha3-b5",e:5}],"-1#1955562136":[{m:"Cb2-f2",e:5}],"1#-580245361":[{m:"Hb5xc7",e:5}],"-1#784099738":[{m:"Ra6-a9",e:5}],"1#1463111249":[{m:"Hg3-f5",e:5}],"-1#29826358":[{m:"Ch8-f8",e:5}],"1#-1025620193":[{m:"Rh1xh10",e:5}],"-1#665605014":[{m:"Hi8xh10",e:5}],"1#829072590":[{m:"Rb1-b6",e:5}],"-1#1526732851":[{m:"Hh10-i8",e:5}],"1#-746901553":[{m:"i4-i5",e:5}],"-1#1835284399":[{m:"Cf2-h2",e:5}],"1#1951474444":[{m:"i5xi6",e:5}],"-1#-1518387679":[{m:"Ch2-h1+",e:5}],"1#1721263771":[{m:"Af1-e2",e:5}],"-1#1052871761":[{m:"Ch1-i1",e:5}],"1#1224761733":[{m:"Eg1-e3",e:5}],"-1#-812030121":[{m:"Cg8xg4",e:5}],"1#-2061379077":[{m:"c4-c5",e:5}],"-1#1244849523":[{m:"Ra10-a8",e:5}],"1#-1825196629":[{m:"Hb1-c3",e:5}],"-1#-1049764122":[{m:"Ra8-d8",e:5}],"1#1750113946":[{m:"Af1-e2",e:5}],"-1#805925968":[{m:"Hh10-g8",e:5}],"1#-221147363":[{m:"Ri1-f1",e:5}],"-1#-543352873":[{m:"Ch8-i8",e:5}],"1#-495160028":[{m:"Rf1-f4",e:5}],"-1#535960521":[{m:"Ri10-h10",e:5}],"1#1169385016":[{m:"Ch3-h1",e:5}],"-1#2017099595":[{m:"Cg4-g6",e:5}],"1#-2143287992":[{m:"Hc3-b5",e:5}],"-1#-916264156":[{m:"Hb10-a8",e:5}],"1#-2081051866":[{m:"Ch1-f1",e:5}],"-1#176596654":[{m:"Af10-e9",e:5}],"1#103637564":[{m:"Cb3-d3",e:5}],"-1#1023225287":[{m:"Rh10-h2",e:5}],"1#182763730":[{m:"a4-a5",e:5}],"-1#613049758":[{m:"Cg6-h6",e:5}],"1#-1398303299":[{m:"Ee3-g1",e:5}],"-1#708744047":[{m:"g7-g6",e:5}],"1#1600414738":[{m:"Rf4-f5",e:5}],"-1#707172481":[{m:"Ci8-i9",e:5}],"1#-1948222688":[{m:"Ec1-e3",e:5}],"-1#956732681":[{m:"Rh2-g2",e:5}],"1#1427221424":[{m:"Hg3-h5",e:5}],"-1#1687354417":[{m:"Ci9xi4",e:5}],"1#-1661840258":[{m:"Hh5-i3",e:5}],"-1#-79516151":[{m:"Rg2-h2",e:5}],"1#-1756000080":[{m:"Ra1-c1",e:5}],"1#-2092554429":[{m:"c4-c5",e:6.667},{m:"a4-a5",e:6.667}],"-1#1280646091":[{m:"Hb10-a8",e:5}],"1#113400777":[{m:"Hb1-c3",e:5}],"-1#1419391108":[{m:"Ra10-a9",e:8},{m:"Hh10-f9",e:8}],"1#1287891397":[{m:"Ch3-i3",e:7.5}],"-1#997746394":[{m:"Hh10-g8",e:7.5},{m:"Ra9-c9",e:7.5},{m:"Ra9-d9",e:7.5}],"1#-106914409":[{m:"Ri1-h1",e:5}],"1#1424522105":[{m:"Ri1-h1",e:5}],"1#-1543807609":[{m:"Ri1-i2",e:5}],"-1#-155250193":[{m:"Hf9-d8",e:5}],"1#928982621":[{m:"Hc3-d5",e:5}],"-1#488429664":[{m:"c7-c6",e:5}],"1#-562355365":[{m:"Ec1-e3",e:5}],"-1#-1389854193":[{m:"Hb10-c8",e:5}],"1#-1137143629":[{m:"Hb1-a3",e:5}],"-1#-1545196309":[{m:"c7-c6",e:5}],"1#1619122128":[{m:"Ha3-b5",e:5}],"-1#1680207529":[{m:"Ra10-b10",e:5}],"1#1549254704":[{m:"Hb5xa7",e:5}],"-1#1254939609":[{m:"Cb8-a8",e:5}],"1#-2083592167":[{m:"Ha7xc8",e:5}],"-1#323639228":[{m:"Ch8xc8",e:5}],"1#-1993499574":[{m:"Cb3-a3",e:5}],"-1#-1162635994":[{m:"g7-g6",e:5}],"1#-806788517":[{m:"a5-a6",e:5}],"-1#1854321479":[{m:"Hh10-g8",e:5}],"1#-1403107318":[{m:"a6-a7",e:5}],"-1#2078496628":[{m:"Ca8xa3",e:5}],"1#1731948625":[{m:"Ch3xa3",e:5}],"-1#371766858":[{m:"Cb8-e8",e:9.756},{m:"c7-c6",e:9.756},{m:"Hh10-g8",e:9.756},{m:"Hb10-c8",e:9.756},{m:"Ec10-e8",e:9.756},{m:"Ch8-e8",e:9.756},{m:"i7-i6",e:9.756}],"1#595624418":[{m:"Cb3-e3",e:9},{m:"Hb1-c3",e:9}],"-1#-1983900040":[{m:"Hb10-c8",e:5}],"1#-1731197756":[{m:"Hb1-c3",e:5}],"-1#-897028215":[{m:"Ra10-b10",e:5}],"1#-218480368":[{m:"Ra1-a2",e:5}],"-1#2075904443":[{m:"Rb10-b4",e:5}],"1#-2036584358":[{m:"Ra2-f2",e:5}],"-1#884914550":[{m:"Hh10-i8",e:5}],"1#-1127903606":[{m:"Ri1-i2",e:5}],"-1#-377371934":[{m:"Rb4xc4",e:5}],"1#-1919079931":[{m:"i4-i5",e:5}],"-1#864170597":[{m:"Ad10-e9",e:5}],"1#-549254508":[{m:"Rf2-f9",e:5}],"-1#-1044775058":[{m:"Ch8-h6",e:5}],"1#-93289364":[{m:"Rf9-f6",e:5}],"-1#-1130106163":[{m:"Ch6-h4",e:5}],"1#-1086421548":[{m:"Ri2-d2",e:5}],"-1#286468407":[{m:"Ch4xe4+",e:5}],"1#-1758382705":[{m:"Hc3xe4",e:5}],"-1#-843811060":[{m:"Ce8xe4+",e:5}],"1#-753659365":[{m:"Af1-e2",e:5}],"-1#-1957824303":[{m:"Ri10-h10",e:5}],"1#-787708640":[{m:"Ch3-h5",e:5}],"-1#-1588344029":[{m:"Rh10-h8",e:5}],"1#1748944577":[{m:"Rd2-d9",e:5}],"-1#2124158090":[{m:"Ce4-e6",e:5}],"1#962299185":[{m:"Ec1-a3",e:5}],"-1#-1770892850":[{m:"Rc4-e4",e:5}],"1#-849324027":[{m:"Ce3xe6",e:5}],"-1#157272414":[{m:"Re4xe6",e:5}],"1#-1482639716":[{m:"Rf6-f9",e:5}],"-1#-512507843":[{m:"g7-g6",e:5}],"-1#1910041263":[{m:"Hb10-c8",e:9},{m:"Hh10-g8",e:9}],"1#1623783443":[{m:"Ra1-b1",e:8.889},{m:"c4-c5",e:8.889},{m:"Hh1-i3",e:8.333},{m:"Ri1-i2",e:8.889}],"-1#1449396463":[{m:"Hc8-b10",e:8.333},{m:"Hb10-c8",e:5},{m:"Ra10-b10",e:8.333}],"1#-1799556190":[{m:"Cb3-a3",e:6.667},{m:"c4-c5",e:6.667}],"-1#-1490879794":[{m:"Ra10-a9",e:5}],"1#-1082432625":[{m:"Af1-e2",e:5}],"-1#-417167035":[{m:"Ra9-f9",e:5}],"1#540312011":[{m:"Rb1-b5",e:5}],"-1#2023404528":[{m:"c7-c6",e:5}],"1#-1141028661":[{m:"Eg1-e3",e:5}],"-1#1538248490":[{m:"g7-g6",e:6.667},{m:"Ra10-a9",e:6.667}],"1#787822679":[{m:"Af1-e2",e:5}],"-1#1991037597":[{m:"Hg8-f6",e:5}],"1#1140217451":[{m:"Ri1-i2",e:5}],"1#1846945398":[{m:"Ec1-e3",e:7.5}],"-1#-1344551781":[{m:"Ra10-b10",e:5}],"1#-1750472190":[{m:"Ri1-i2",e:5}],"-1#-1024612758":[{m:"Hh10-i8",e:5}],"-1#898413691":[{m:"Ra10-b10",e:5}],"1#234789602":[{m:"Ra1-b1",e:5}],"-1#995256862":[{m:"Rb10-b6",e:5}],"1#-1291841054":[{m:"Ra1-b1",e:5}],"-1#-2052267746":[{m:"Hb10-c8",e:5}],"1#-716223119":[{m:"Ec1-e3",e:9.412},{m:"Ri1-i2",e:9.412},{m:"Cb3-e3",e:9.412},{m:"Hb1-c3",e:9.412}],"-1#1739170648":[{m:"Hb10-c8",e:8.889},{m:"i7-i6",e:8.889},{m:"Ec10-e8",e:8.889}],"1#1991881188":[{m:"Ri1-i2",e:8},{m:"Hb1-d2",e:8}],"-1#-1526816543":[{m:"Ec10-e8",e:6.667}],"1#1749314951":[{m:"Ri1-i2",e:5}],"-1#1023418863":[{m:"i7-i6",e:8.333}],"1#294789388":[{m:"c4-c5",e:7.5}],"-1#-561963644":[{m:"c6xc5",e:7.5}],"1#1262199739":[{m:"Ri1-i2",e:7.5}],"-1#511700947":[{m:"i7-i6",e:8.333},{m:"Hh10-i8",e:8.333}],"1#-1778067409":[{m:"i4-i5",e:7.5}],"-1#-2146762471":[{m:"Hh10-g8",e:8.889},{m:"Ec10-e8",e:8.889},{m:"Hb10-c8",e:8.889},{m:"Cb8-e8",e:8.889}],"1#1121188436":[{m:"Ec1-e3",e:5}],"-1#-264956803":[{m:"Ri10-i9",e:5}],"1#-1314930663":[{m:"i4-i5",e:5}],"1#-1399258630":[{m:"Ri2-f2",e:8},{m:"Hb1-c3",e:8},{m:"Ri1-i2",e:7.5}],"1#-1860496475":[{m:"Ri2-d2",e:6.667},{m:"Ri1-i2",e:8}],"1#-1247594831":[{m:"Hb1-c3",e:5}],"-1#-402956804":[{m:"Hb10-c8",e:5}],"1#-152350912":[{m:"Ri2-f2",e:5}],"-1#2131745515":[{m:"Hb10-c8",e:6.667}],"1#1847576663":[{m:"Hb1-c3",e:6.667}],"1#-722449145":[{m:"Ri1-i2",e:8.571},{m:"Hb1-c3",e:8.571},{m:"g4-g5",e:8.571}],"-1#-2118909585":[{m:"Ch8-i8",e:6.667},{m:"g7-g6",e:6.667}],"1#-1135254628":[{m:"Ec1-e3",e:5}],"-1#246648245":[{m:"Ri10-h10",e:5}],"1#1425207364":[{m:"Ri2-d2",e:5}],"-1#-86025049":[{m:"Cb8-e8",e:5}],"1#-814257393":[{m:"Ad1-e2",e:5}],"-1#-2139194865":[{m:"Hb10-c8",e:5}],"1#-1855035213":[{m:"i4-i5",e:5}],"-1#795963603":[{m:"e7-e6",e:5}],"1#-1918696028":[{m:"Rd2-d5",e:5}],"1#-185666030":[{m:"Ec1-e3",e:5}],"-1#1174935611":[{m:"Eg10-e8",e:6.667},{m:"Ch8-i8",e:6.667}],"1#-2058017596":[{m:"g4-g5",e:6.667},{m:"c4-c5",e:6.667}],"-1#-912338391":[{m:"g6xg5",e:5}],"-1#1246107724":[{m:"Hb10-a8",e:5}],"1#2078898888":[{m:"Ri2-f2",e:5}],"-1#2000466098":[{m:"Ri10-h10",e:5}],"1#763219267":[{m:"Rf2-f5",e:5}],"-1#-781434395":[{m:"i7-i6",e:5}],"1#-561934534":[{m:"i4-i5",e:5}],"-1#-2035800502":[{m:"c7-c6",e:5}],"-1#-1740915734":[{m:"Cb8-e8",e:7.5},{m:"c7-c6",e:7.5}],"1#-1382839230":[{m:"Cb3-e3",e:5}],"-1#131275736":[{m:"Hb10-c8",e:5}],"1#381880676":[{m:"Hb1-c3",e:5}],"-1#1151033897":[{m:"Ra10-b10",e:5}],"1#2095664304":[{m:"Ra1-a2",e:5}],"-1#-173489125":[{m:"Rb10-b6",e:5}],"1#-2034582131":[{m:"Ra2-f2",e:5}],"-1#882390177":[{m:"g7-g6",e:5}],"1#1103283164":[{m:"Rf2-f7",e:5}],"1#1532772561":[{m:"Ec1-e3",e:6.667},{m:"Ri1-i2",e:6.667}],"-1#-373641480":[{m:"Hb10-c8",e:5}],"1#-123028412":[{m:"Ch3-g3",e:5}],"-1#-430661534":[{m:"Ri10-h10",e:5}],"1#-1139417709":[{m:"Ri1-i2",e:5}],"-1#236457145":[{m:"Hb10-c8",e:5}],"1#520625669":[{m:"Ri2-d2",e:5}],"-1#-1322929434":[{m:"Ch8-i8",e:5}],"1#121152758":[{m:"Ec1-e3",e:5}],"-1#-1243723041":[{m:"Hh10-g8",e:5}],"1#1996927378":[{m:"Ri1-i2",e:5}],"-1#574815738":[{m:"Ec10-e8",e:5}],"1#248577305":[{m:"c4-c5",e:5}],"-1#-1044135535":[{m:"Ad10-e9",e:5}],"1#755169632":[{m:"Hb1-c3",e:5}],"-1#2136642093":[{m:"Ra10-d10",e:5}],"1#-1183542457":[{m:"Ra1-a2",e:5}],"-1#808786924":[{m:"Ch8-i8",e:5}],"1#232028447":[{m:"Ri2-d2",e:5}],"-1#-1543907844":[{m:"Ri10-h10",e:5}],"1#-105338867":[{m:"Ch3-g3",e:5}],"-1#-414796757":[{m:"Rh10-h6",e:5}],"1#1116802417":[{m:"Rd2xd10+",e:5}],"-1#-2055217022":[{m:"Ae9xd10",e:5}],"1#-1679207508":[{m:"Ra2-d2",e:5}],"-1#1340969366":[{m:"c7-c6",e:5}],"1#-1937085779":[{m:"Rd2-d5",e:5}],"-1#-1781848903":[{m:"Ci8xi4",e:5}],"1#-776972250":[{m:"Cg3xg7",e:5}],"-1#-705686766":[{m:"Cb8-a8",e:5}],"1#485630162":[{m:"Cb3-b2",e:5}],"-1#-1459586258":[{m:"Hc8-b6",e:5}],"1#2002103391":[{m:"Ad1-e2",e:5}],"-1#945601887":[{m:"Af10-e9",e:5}],"1#888633805":[{m:"Cg7xa7",e:5}],"-1#439217420":[{m:"c6xc5",e:5}],"1#559234200":[{m:"Rd5xc5",e:5}],"-1#685486457":[{m:"Ke10-f10",e:5}],"1#1435735435":[{m:"a4-a5",e:5}],"-1#2080190663":[{m:"Rh6-c6",e:5}],"1#-1918705450":[{m:"Rc5xc6",e:5}],"-1#-515396699":[{m:"Ee8xc6",e:5}],"1#-548604705":[{m:"Ca7-b7",e:5}],"-1#451404491":[{m:"Ec6-e8",e:5}],"1#-1824541931":[{m:"Cb2-c2",e:5}],"-1#-222946000":[{m:"Hg8-f6",e:5}],"1#1355270531":[{m:"g4-g5",e:5}],"-1#470564718":[{m:"Hb6-c4",e:5}],"1#867038363":[{m:"Cb7-b10+",e:5}],"-1#1591359149":[{m:"Ee8-c10",e:5}],"1#1917335118":[{m:"e4-e5",e:5}],"-1#-171453694":[{m:"Ca8-c8",e:5}],"1#-1377395247":[{m:"Cc2xc4",e:5}],"-1#1620560764":[{m:"Cc8xc3",e:5}],"1#-2011943338":[{m:"Cc4-f4+",e:5}],"-1#-1543680157":[{m:"Hf6-d7",e:5}],"1#-820308448":[{m:"Cb10-b7",e:5}],"-1#-1569926122":[{m:"Cc3xi3",e:5}],"1#-189974578":[],"1#985314985":[{m:"c4-c5",e:5}],"1#1967245169":[{m:"Cb3-e3",e:7.5},{m:"Hb1-c3",e:7.5}],"-1#-553561877":[{m:"Hh10-g8",e:6.667}],"1#500804518":[{m:"Hb1-c3",e:6.667}],"-1#655993916":[{m:"Hh10-g8",e:5}],"1#-440313999":[{m:"Ri1-i2",e:5}],"-1#-1333454055":[{m:"Hb10-a8",e:5}],"1#-99460325":[{m:"Ri2-f2",e:5}],"-1#-154693279":[{m:"i7-i6",e:5}],"1#-114663490":[{m:"Rf2-f7",e:5}],"-1#571788105":[{m:"Ri10-h10",e:5}],"1#2018883256":[{m:"Rf7xg7",e:5}],"-1#655651968":[{m:"Cb8-c8",e:5}],"1#-1410711838":[{m:"Ch3-f3",e:5}],"-1#-1900648357":[{m:"Ra10-b10",e:5}],"1#-1228650814":[{m:"Ra1-b1",e:5}],"-1#-2140621250":[{m:"Rb10-b4",e:5}],"1#2102349791":[{m:"Ec1-e3",e:5}],"-1#-810966538":[{m:"c7-c6",e:5}],"1#214850253":[{m:"Rg7-g5",e:5}],"-1#1586321205":[{m:"Rh10-h6",e:5}],"1#-77926801":[{m:"Ad1-e2",e:5}],"-1#-1269563537":[{m:"Ha8-c7",e:5}],"1#-1324274922":[{m:"Cb3-a3",e:5}],"-1#-2104548742":[{m:"Rb4xc4",e:5}],"1#-426521955":[{m:"Rg5-d5",e:5}],"-1#-1809430535":[{m:"c6-c5",e:5}],"1#437022104":[{m:"Rd5-d8",e:5}],"-1#-1065133899":[{m:"Cc8-a8",e:5}],"1#-1734207898":[{m:"Ca3-a2",e:5}],"-1#1341297326":[{m:"Hc7-d5",e:5}],"1#267606895":[{m:"Ca2-c2",e:5}],"-1#580588643":[{m:"Hd5xc3",e:5}],"1#-1826933632":[{m:"Cc2xc4",e:5}],"-1#139526552":[{m:"Hc3xb1",e:5}],"1#432371861":[{m:"Hb1-c3",e:8},{m:"Cb3-e3",e:8}],"-1#1268585432":[{m:"c7-c6",e:6.667},{m:"Ec10-e8",e:6.667}],"1#-1996822301":[{m:"Ri1-i2",e:5}],"-1#-574708597":[{m:"Hb10-c8",e:5}],"1#1729041211":[{m:"c4-c5",e:5}],"-1#-1474547789":[{m:"Hh10-i8",e:5}],"1#543627343":[{m:"Ec1-e3",e:5}],"-1#-1836976538":[{m:"Ri10-i9",e:5}],"1#-752147966":[{m:"Ad1-e2",e:5}],"-1#-1675480318":[{m:"Ri9-d9",e:5}],"1#1663474365":[{m:"Ri1-i2",e:5}],"-1#912447189":[{m:"Ad10-e9",e:5}],"1#-626790876":[{m:"Ri2-f2",e:5}],"-1#-696900514":[{m:"Hb10-c8",e:5}],"1#-949602590":[{m:"Rf2-f6",e:5}],"-1#-2032027800":[{m:"Ra10-d10",e:5}],"1#1087354370":[{m:"Rf6xi6",e:5}],"-1#-323811993":[{m:"Rd9-d6",e:5}],"1#112359268":[{m:"i4-i5",e:5}],"-1#-1283068145":[{m:"Cb8-e8",e:6.667},{m:"Hb10-c8",e:6.667}],"1#-2043815769":[{m:"Hb1-c3",e:5}],"-1#-730483734":[{m:"Hb10-c8",e:5}],"1#-983195306":[{m:"Ra1-a2",e:5}],"-1#1277438461":[{m:"Ra10-b10",e:5}],"1#1951795044":[{m:"Ra2-f2",e:5}],"-1#-965439928":[{m:"Ad10-e9",e:5}],"1#716551865":[{m:"Rf2-f6",e:5}],"-1#1866531475":[{m:"Rb10-b4",e:5}],"1#-1838744718":[{m:"g4-g5",e:5}],"-1#-559084129":[{m:"Rb4xc4",e:5}],"1#-1162746504":[{m:"g5-g6",e:5}],"-1#-658675093":[{m:"g7xg6",e:5}],"1#-1814610176":[{m:"Rf6xg6",e:5}],"-1#-735312088":[{m:"Ch8-g8",e:5}],"1#-1567228493":[{m:"Hb1-c3",e:5}],"-1#-254961922":[{m:"Ra10-b10",e:5}],"1#-926959513":[{m:"Ra1-b1",e:5}],"-1#-32290661":[{m:"Ad10-e9",e:5}],"1#315781226":[{m:"Rb1-b5",e:5}],"-1#1249657425":[{m:"Hh10-i8",e:5}],"1#-1039698515":[{m:"i4-i5",e:5}],"-1#2081975757":[{m:"i6xi5",e:5}],"1#1581404870":[{m:"Rb5xi5",e:5}],"-1#-580457543":[{m:"Cb8-a8",e:5}],"1#342153337":[{m:"Ri1-i2",e:5}],"-1#1092654097":[{m:"Rb10-b4",e:5}],"1#-1140363792":[{m:"c4-c5",e:5}],"-1#1930711416":[{m:"c7-c6",e:5}],"1#-1334597053":[{m:"Ce3-f3",e:5}],"-1#1476353214":[{m:"Cb8-e8",e:9.714},{m:"c7-c6",e:9.714},{m:"Ec10-e8",e:9.714},{m:"Ch8-e8",e:9.714},{m:"g7-g6",e:9.714},{m:"Cb8-f8",e:9.714},{m:"Ch8-d8",e:9.714},{m:"Hh10-g8",e:9.714}],"1#1649896214":[{m:"Hb1-c3",e:6.667}],"-1#806289499":[{m:"c7-c6",e:6.667},{m:"Hb10-c8",e:6.667}],"1#-211223712":[{m:"Ra1-b1",e:5}],"-1#-977007716":[{m:"Hb10-c8",e:5}],"1#-724297440":[{m:"g4-g5",e:5}],"-1#-1742737459":[{m:"Ra10-b10",e:5}],"1#-1603419820":[{m:"Hh1-g3",e:5}],"-1#-271553380":[{m:"Hh10-i8",e:5}],"1#1739283296":[{m:"Eg1-e3",e:5}],"-1#-516792910":[{m:"Ch8-f8",e:7.5},{m:"Ch8-h4",e:7.5}],"1#573245339":[{m:"Ri1-f1",e:6.667},{m:"Ri1-h1",e:6.667}],"-1#258449233":[{m:"Af10-e9",e:5}],"1#63724483":[{m:"Cb3-b5",e:5}],"-1#881134461":[{m:"Rb10-b6",e:5}],"-1#683039915":[{m:"Ri10-h10",e:5}],"1#1928798554":[{m:"Ch3-h7",e:5}],"-1#113623008":[{m:"i7-i6",e:5}],"1#153645375":[{m:"Cb3-b7",e:5}],"1#-994351400":[{m:"Hg3-h5",e:6.667},{m:"Ri1-f1",e:6.667}],"-1#-180866727":[{m:"Rb10-b4",e:5}],"1#136300728":[{m:"Ri1-f1",e:6.667},{m:"Cc3-c4",e:6.667}],"-1#-369623534":[{m:"Ch4xc4",e:5}],"1#277791898":[{m:"Ch3-h5",e:5}],"-1#1624345241":[{m:"Ri10-i9",e:5}],"1#555684583":[{m:"c4-c5",e:5}],"-1#-301191569":[{m:"Hh10-i8",e:5}],"1#1719081363":[{m:"Hh1-g3",e:5}],"-1#701150299":[{m:"Ch8-g8",e:5}],"1#1597086353":[{m:"Ra1-b1",e:5}],"-1#1771924077":[{m:"Ra10-b10",e:5}],"1#1374635252":[{m:"Ri1-h1",e:5}],"-1#1534205892":[{m:"Ri10-h10",e:5}],"1#20144693":[{m:"Ch3-h5",e:5}],"-1#1902914614":[{m:"Rb10-b4",e:5}],"1#-1941187113":[{m:"Hc3-d5",e:5}],"-1#-1509413910":[{m:"Rh10-h6",e:5}],"1#64983728":[{m:"Eg1-e3",e:5}],"-1#-2058972062":[{m:"i7-i6",e:5}],"1#-1968481603":[{m:"g4-g5",e:5}],"-1#-966742960":[{m:"Rb4-b6",e:5}],"1#1434983254":[{m:"Hd5xc7",e:5}],"-1#-985708014":[{m:"g7-g6",e:5}],"1#-1335509649":[{m:"g5xg6",e:5}],"-1#-615996039":[{m:"Rh6xg6",e:5}],"1#1999167130":[{m:"Hg3-f5",e:5}],"-1#567971325":[{m:"Ce8xe4",e:5}],"1#1672991820":[{m:"Cb3-b5",e:5}],"-1#1425966322":[{m:"Rg6-g4",e:5}],"1#1764886880":[{m:"Rb1-b4",e:5}],"-1#961837626":[{m:"Rb6-g6",e:5}],"1#-1801934971":[{m:"Ch3-c3",e:8.333},{m:"g4-g5",e:8.333},{m:"Cb3-c3",e:8.333}],"-1#-1449951133":[{m:"Ec10-e8",e:5}],"1#-2063499136":[{m:"Ri1-i3",e:5}],"-1#551449276":[{m:"i7-i6",e:5}],"1#791919715":[{m:"g4-g5",e:5}],"-1#1677216398":[{m:"Hh10-i8",e:5}],"1#-343704206":[{m:"Ri3-d3",e:5}],"-1#1909783090":[{m:"Ri10-h10",e:5}],"1#731219907":[{m:"Hh1-g3",e:5}],"-1#1680353803":[{m:"Hb10-c8",e:5}],"1#1966618807":[{m:"Ec1-e3",e:5}],"-1#-941697378":[{m:"Ch8-f8",e:5}],"1#80186551":[{m:"Hb1-d2",e:5}],"-1#-696214094":[{m:"Rh10-h6",e:5}],"1#1935090920":[{m:"Ra1-c1",e:5}],"-1#-686533980":[{m:"Ad10-e9",e:5}],"1#1003842133":[{m:"e4-e5",e:5}],"-1#-1134915815":[{m:"Ra10-d10",e:5}],"1#2054458995":[{m:"Rd3xd10+",e:5}],"-1#-665628312":[{m:"Hb10-c8",e:7.5}],"1#-918338604":[{m:"Hh1-g3",e:7.5}],"-1#-2030113252":[{m:"Hh10-i8",e:8},{m:"Hb10-c8",e:5},{m:"Ch8-e8",e:8}],"1#243653088":[{m:"Hb1-a3",e:6.667},{m:"Hb1-c3",e:6.667}],"-1#291202488":[{m:"Ec10-e8",e:5}],"1#1036608859":[{m:"Eg1-e3",e:5}],"-1#1558033069":[{m:"Ec10-e8",e:5}],"1#1143346513":[{m:"Hb1-a3",e:6.667},{m:"Eg1-e3",e:6.667}],"-1#1543022857":[{m:"Ra10-a9",e:5}],"1#1134637128":[{m:"Eg1-e3",e:5}],"-1#-1027665021":[{m:"Cb8-a8",e:5}],"1#196943939":[{m:"Hb1-a3",e:5}],"1#-443048153":[{m:"Hb1-c3",e:5}],"-1#-1211108246":[{m:"Hh10-g8",e:5}],"1#1964445479":[{m:"Cb3-b5",e:5}],"-1#1113481113":[{m:"Ra10-a9",e:5}],"1#1510459096":[{m:"Eg1-e3",e:5}],"-1#-593575926":[{m:"Ra9-f9",e:5}],"-1#-1636793188":[{m:"Eg10-e8",e:5}],"1#1563277411":[{m:"Hb1-a3",e:5}],"-1#1123222587":[{m:"Hb10-c8",e:5}],"1#1407391367":[{m:"Ra1-b1",e:5}],"-1#1699735163":[{m:"Ra10-b10",e:5}],"1#1564330210":[{m:"Rb1-b7",e:5}],"-1#2112447297":[{m:"Cb8-a8",e:5}],"1#-1259646847":[{m:"Rb7-c7",e:5}],"-1#1312166255":[{m:"Ch8-f8",e:5}],"1#-1926280378":[{m:"Ch3-e3",e:5}],"-1#-675757406":[{m:"Hh10-f9",e:5}],"1#551137185":[{m:"Ri1-i3",e:5}],"-1#-2063180387":[{m:"Ri10-h10",e:5}],"1#-548986772":[{m:"Ri3-f3",e:5}],"-1#-48597189":[{m:"Af10-e9",e:5}],"1#-240012375":[{m:"Hh1-g3",e:5}],"-1#-1106502047":[{m:"Rh10-h4",e:5}],"1#2051928374":[{m:"c4-c5",e:5}],"1#2070764637":[{m:"Cb3-f3",e:7.5},{m:"Cb3-d3",e:7.5}],"-1#503518002":[{m:"Hb10-c8",e:5}],"1#252903822":[{m:"Hb1-c3",e:5}],"-1#1565223619":[{m:"Ra10-b10",e:5}],"1#1698251866":[{m:"Ra1-b1",e:5}],"-1#1402320038":[{m:"g7-g6",e:5}],"1#651117531":[{m:"Rb1-b5",e:5}],"-1#2120315360":[{m:"Cb8-a8",e:5}],"1#-1218231776":[{m:"Rb5-f5",e:5}],"-1#997740411":[{m:"Hh10-g8",e:5}],"1#-106908618":[{m:"Eg1-e3",e:5}],"-1#2134487780":[{m:"Rb10-b6",e:5}],"1#204196722":[{m:"Hh1-f2",e:5}],"-1#981338595":[{m:"Ch8-i8",e:5}],"1#127888144":[{m:"Ch3-h1",e:5}],"-1#974549603":[{m:"Ri10-h10",e:5}],"1#1616318354":[{m:"Cf3-h3",e:5}],"-1#-945693089":[{m:"Rh10-i10",e:5}],"1#-1646222418":[{m:"Ch1-f1",e:5}],"-1#345222694":[{m:"Ri10-h10",e:5}],"1#1322439639":[{m:"Ri1-g1",e:5}],"-1#789560202":[{m:"Ad10-e9",e:5}],"1#-1009876101":[{m:"g4-g5",e:5}],"-1#-1895467626":[{m:"Rh10-h6",e:5}],"1#718458060":[{m:"i4-i5",e:5}],"-1#-1798450004":[{m:"i7-i6",e:5}],"1#-1692394893":[{m:"i5xi6",e:5}],"-1#1102910374":[{m:"c7-c6",e:6.667}],"1#-2099582819":[{m:"Hb1-a3",e:6.667}],"-1#-1660660539":[{m:"Hb10-c8",e:6.667}],"1#-1944828295":[{m:"Ra1-b1",e:6.667}],"-1#-1162299771":[{m:"Ra10-b10",e:6.667}],"1#-2100652004":[{m:"Rb1-b5",e:6.667}],"-1#-630937049":[{m:"Cb8-a8",e:6.667}],"1#325491175":[{m:"Rb5-d5",e:6.667}],"-1#962617253":[{m:"Hh10-g8",e:6.667},{m:"Ch8-f8",e:6.667}],"1#-71785240":[{m:"Hh1-g3",e:5}],"-1#-1274738400":[{m:"Ch8-i8",e:5}],"1#-1981518893":[{m:"Ri1-h1",e:5}],"-1#-2089209629":[{m:"Ri10-h10",e:5}],"1#-650621678":[{m:"g4-g5",e:5}],"-1#-1779188737":[{m:"Rh10-h6",e:5}],"1#807666341":[{m:"Ch3-i3",e:5}],"-1#1201655226":[{m:"Rh6xh1",e:5}],"1#-92732020":[{m:"Hh1-g3",e:5}],"-1#-1245403068":[{m:"Hh10-g8",e:5}],"1#1998344969":[{m:"g4-g5",e:5}],"-1#1003988452":[{m:"Ri10-h10",e:5}],"1#1637275669":[{m:"g5-g6",e:5}],"-1#60446470":[{m:"g7xg6",e:5}],"1#1223688813":[{m:"Hg3-h5",e:5}],"-1#2037601772":[{m:"Rh10-i10",e:5}],"1#590489629":[{m:"Ch3-g3",e:5}],"1#882257285":[{m:"Hh1-g3",e:5}],"-1#2066448461":[{m:"g7-g6",e:5}],"1#242317104":[{m:"Eg1-e3",e:5}],"-1#-1998032414":[{m:"Hh10-g8",e:5}],"1#1244695215":[{m:"Ri1-f1",e:5}],"-1#1736184421":[{m:"Ri10-h10",e:5}],"1#1027436436":[{m:"Ch3-h1",e:5}],"-1#11826919":[{m:"Hb10-c8",e:5}],"1#295986267":[{m:"Hb1-a3",e:5}],"-1#242931715":[{m:"Cb8-a8",e:5}],"1#-948376637":[{m:"Ra1-b1",e:5}],"-1#-237757633":[{m:"Ra10-b10",e:5}],"1#-911854170":[{m:"Rf1-f7",e:5}],"-1#2073594104":[{m:"c7-c6",e:5}],"1#-1191218237":[{m:"Rf7-f5",e:5}],"-1#-2113053469":[{m:"e7-e6",e:5}],"1#551496084":[{m:"Ch1-g1",e:5}],"-1#858777318":[{m:"Hg8-e7",e:5}],"1#-881623353":[{m:"Rf5-f7",e:5}],"-1#-243183129":[{m:"a7-a6",e:5}],"1#-173847323":[{m:"g4-g5",e:5}],"-1#-1184318968":[{m:"Rb10-b6",e:5}],"1#-897924194":[{m:"g5xg6",e:5}],"-1#-1588077688":[{m:"Ca8-a7",e:5}],"1#2142865499":[{m:"Rf7-f3",e:5}],"-1#2056536021":[{m:"Hc8-d6",e:5}],"1#1344705622":[{m:"g6-f6",e:5}],"-1#1264402050":[{m:"Hd6xe4",e:5}],"1#1238507183":[{m:"Cb3-d3",e:5}],"-1#1929531732":[{m:"Rb6xb1",e:5}],"1#-773757854":[{m:"Ha3xb1",e:5}],"-1#96266456":[{m:"e6-e5",e:5}],"1#-377688980":[{m:"f6-f7",e:5}],"-1#-715585015":[{m:"He7-d5",e:5}],"1#-773354154":[{m:"f7-f8",e:5}],"-1#2082188129":[{m:"Ce8-b8",e:5}],"1#-1948430082":[{m:"Rf3-f6",e:5}],"-1#340390413":[{m:"Af10-e9",e:5}],"1#417478303":[{m:"Hg3-f1",e:5}],"-1#-1416000534":[{m:"Hd5-b4",e:5}],"1#791288905":[{m:"Hb1-a3",e:5}],"-1#821338129":[{m:"Rh10-h7",e:5}],"1#417488126":[{m:"f8-f9",e:5}],"-1#-968591277":[{m:"e5-d5",e:5}],"1#1309128239":[{m:"Rf6-e6",e:5}],"-1#-1002720480":[{m:"Rh7-f7",e:5}],"1#1749853851":[{m:"Cd3xd10",e:5}],"-1#-1845627527":[{m:"Cb8-e8",e:5}],"1#1715146470":[{m:"Cd10-d9",e:5}],"-1#-2017195542":[{m:"Ca7-e7",e:5}],"1#267244270":[{m:"Re6-g6",e:5}],"-1#1767863032":[{m:"Eg10-i8",e:5}],"1#929790354":[{m:"Rg6-g8",e:5}],"-1#1341674160":[{m:"Ae9-f8",e:5}],"1#418495914":[{m:"Rg8-g9",e:5}],"1#581282755":[{m:"Cb3-g3",e:9.286},{m:"c4-c5",e:9.286},{m:"Ch3-d3",e:9.286},{m:"Cb3-f3",e:9.286},{m:"Ch3-g3",e:9.286
}],"-1#1704760815":[{m:"Eg10-e8",e:5}],"1#-1497257712":[{m:"Ra1-a3",e:5}],"-1#-993160775":[{m:"Hh10-g8",e:5}],"1#102066932":[{m:"Ra3-f3",e:5}],"-1#1758601562":[{m:"Hb10-a8",e:5}],"1#574972248":[{m:"Hb1-c3",e:5}],"-1#1880951317":[{m:"Ra10-b10",e:5}],"1#1215243404":[{m:"Eg1-e3",e:5}],"-1#-822730146":[{m:"Cb8-d8",e:5}],"1#-1548503379":[{m:"Hh1-f2",e:5}],"-1#-306800821":[{m:"Hh10-g8",e:5}],"1#795765766":[{m:"Hh1-g3",e:5}],"-1#1624490446":[{m:"Eg10-e8",e:5}],"1#-1550910159":[{m:"Eg1-e3",e:5}],"-1#622328803":[{m:"Hb10-a8",e:5}],"1#1870707681":[{m:"Hb1-c3",e:5}],"-1#1037619372":[{m:"Af10-e9",e:6.667},{m:"Ra10-a9",e:6.667}],"1#829625406":[{m:"Ri1-f1",e:5}],"1#629230061":[{m:"Ri1-f1",e:5}],"-1#-1578648037":[{m:"Hh10-g8",e:6.667}],"1#1665090902":[{m:"Hh1-g3",e:6.667},{m:"c4-c5",e:6.667}],"-1#746776734":[{m:"Ri10-h10",e:5}],"1#1992529263":[{m:"Eg1-e3",e:6.667}],"-1#-262499395":[{m:"Eg10-e8",e:8}],"-1#-1406371362":[{m:"Cb8-c8",e:5}],"1#550646716":[{m:"Eg1-e3",e:5}],"-1#-1505020562":[{m:"Hb10-a8",e:5}],"1#-321096340":[{m:"Hb1-c3",e:5}],"-1#1204544684":[{m:"Hb10-c8",e:5}],"1#1457255952":[{m:"Hb1-c3",e:5}],"-1#75734365":[{m:"Ra10-b10",e:5}],"1#1022473156":[{m:"Hh1-i3",e:5}],"-1#629126138":[{m:"Hh10-g8",e:5}],"1#-408467273":[{m:"Eg1-e3",e:5}],"-1#1631473253":[{m:"Af10-e9",e:5}],"1#1838516983":[{m:"Ra1-b1",e:5}],"-1#1530493451":[{m:"Cb8-b4",e:5}],"1#-420203761":[{m:"g4-g5",e:5}],"-1#1012643813":[{m:"Hh10-i8",e:8.889},{m:"Eg10-e8",e:8.889},{m:"Ec10-e8",e:8.889}],"1#-1272938471":[{m:"c4-c5",e:5}],"-1#2066988177":[{m:"Ec10-e8",e:5}],"1#1470217330":[{m:"Cb3-e3",e:5}],"1#-16348390":[{m:"Hh1-i3",e:6.667}],"-1#-427259100":[{m:"Hh10-g8",e:6.667}],"1#281655046":[{m:"Hh1-i3",e:8.333}],"-1#155694904":[{m:"Hh10-g8",e:8.333},{m:"Hh10-i8",e:8.333}],"1#1701960526":[{m:"Hb1-c3",e:6.667},{m:"c4-c5",e:6.667}],"-1#925478915":[{m:"Hb10-c8",e:5}],"1#641311423":[{m:"Ra1-b1",e:5}],"-1#278221379":[{m:"c7-c6",e:5}],"1#-739071624":[{m:"Cb3-a3",e:5}],"-1#-529752044":[{m:"Hh10-g8",e:5}],"1#582245209":[{m:"g4-g5",e:5}],"-1#1853861300":[{m:"Ch8-h4",e:5}],"1#1274451678":[{m:"Hh1-g3",e:5}],"-1#72039190":[{m:"Ch4xc4",e:5}],"1#-47054434":[{m:"Ec1-e3",e:5}],"-1#1339355063":[{m:"Ri10-h10",e:5}],"1#362123846":[{m:"Ri1-h1",e:5}],"-1#520669558":[{m:"Rh10-h6",e:5}],"1#-1159761876":[{m:"Ch3-i3",e:5}],"-1#-849035469":[{m:"Rh6xh1",e:5}],"1#1293136806":[{m:"Hg3xh1",e:5}],"-1#1092372733":[{m:"Ra10-a9",e:5}],"1#1497747900":[{m:"Ci3-g3",e:5}],"-1#769471988":[{m:"Eg10-e8",e:5}],"1#-293598965":[{m:"Rb1-b5",e:5}],"-1#-1238484176":[{m:"Ra9-h9",e:5}],"1#-1029665545":[{m:"Hh1-i3",e:5}],"-1#-617706295":[{m:"Rh9-h6",e:5}],"1#-1483555975":[{m:"i4-i5",e:5}],"-1#428712729":[{m:"Af10-e9",e:5}],"1#354838411":[{m:"a4-a5",e:5}],"-1#-1436358714":[{m:"Hb10-c8",e:5}],"1#-1150093958":[{m:"Hb1-c3",e:5}],"-1#-383082953":[{m:"Ra10-b10",e:5}],"1#-782716754":[{m:"Ra1-b1",e:5}],"-1#-403423150":[{m:"Rb10-b6",e:5}],"1#-1796851260":[{m:"Cb3-a3",e:5}],"-1#-1485295448":[{m:"Rb6xb1",e:5}],"1#94045598":[{m:"Hc3xb1",e:5}],"-1#-1673503183":[{m:"g7-g6",e:5}],"1#-384128692":[{m:"Ch3-g3",e:5}],"-1#-136006294":[{m:"Eg10-e8",e:5}],"1#884574613":[{m:"Hh1-i3",e:5}],"-1#758614443":[{m:"Ch8-h4",e:5}],"1#146715329":[{m:"Hb1-c3",e:5}],"-1#1525078412":[{m:"Hh10-g8",e:5}],"1#-1740758335":[{m:"Hc3-d5",e:5}],"-1#-1300374276":[{m:"Ch4xe4+",e:5}],"1#878690372":[{m:"Eg1-e3",e:5}],"-1#-1295595882":[{m:"Hg8-h6",e:5}],"1#789523993":[{m:"Ri1-f1",e:5}],"-1#37992147":[{m:"Af10-e9",e:5}],"1#250114625":[{m:"Rf1-f4",e:5}],"-1#-211411796":[{m:"Ce4-e6",e:5}],"1#563505275":[{m:"Hd5xc7",e:5}],"-1#-1323222721":[{m:"i7-i6",e:5}],"1#-1093863456":[{m:"Ca3-c3",e:5}],"-1#-1704465692":[{m:"i6-i5",e:5}],"1#1074591091":[{m:"Hh1-g3",e:8},{m:"g4-g5",e:8},{m:"Ch3-e3",e:8}],"-1#263280827":[{m:"Hh10-g8",e:5}],"1#-848714762":[{m:"Ri1-h1",e:5}],"-1#-940246842":[{m:"Eg10-e8",e:5}],"1#78234681":[{m:"c4-c5",e:5}],"-1#-876939087":[{m:"Af10-e9",e:5}],"1#-955171805":[{m:"Hb1-c3",e:5}],"-1#-1790355602":[{m:"Hb10-a8",e:5}],"1#-539093140":[{m:"Hc3-d5",e:5}],"-1#-174200495":[{m:"Ri10-f10",e:5}],"1#2085183125":[{m:"Cb3-e3",e:5}],"-1#-704001777":[{m:"Cd8-d6",e:5}],"1#-116422053":[{m:"Ra1-a3",e:5}],"-1#-1694256398":[{m:"Ra10-b10",e:5}],"1#-1552835477":[{m:"Ce3-d3",e:5}],"-1#775713659":[{m:"Cd6-g6",e:5}],"1#516847078":[{m:"Eg1-e3",e:5}],"-1#-1739099340":[{m:"Cb8-b3",e:5}],"1#-1232251908":[{m:"Hg3-f1",e:5}],"-1#214369182":[{m:"Hh10-g8",e:6.667}],"1#-836765485":[{m:"Hh1-g3",e:6.667},{m:"Ch3-d3",e:6.667}],"-1#-2120067813":[{m:"Ri10-h10",e:5}],"1#-605869846":[{m:"Ri1-h1",e:5}],"-1#-780241958":[{m:"Rh10-h6",e:5}],"1#1957284480":[{m:"Cb3-f3",e:5}],"-1#298288623":[{m:"g7-g6",e:5}],"1#1688040082":[{m:"g5xg6",e:5}],"-1#263219844":[{m:"Rh6xg6",e:5}],"-1#1298001163":[{m:"Ri10-h10",e:5}],"1#387748090":[{m:"Hh1-g3",e:5}],"-1#1486961970":[{m:"Hb10-c8",e:5}],"1#1236348814":[{m:"Hb1-a3",e:5}],"-1#1450152918":[{m:"Ec10-e8",e:5}],"1#2063438645":[{m:"Cb3-c3",e:5}],"-1#1880469548":[{m:"Ra10-b10",e:5}],"1#1214750389":[{m:"Ra1-b1",e:5}],"-1#446397591":[{m:"Hh10-g8",e:5}],"1#-666662950":[{m:"Hh1-g3",e:5}],"-1#-1744950766":[{m:"Ri10-h10",e:5}],"1#-843098141":[{m:"Hb1-a3",e:5}],"-1#-765334597":[{m:"Ec10-e8",e:5}],"1#-17568936":[{m:"Cb3-c3",e:5}],"-1#-199505855":[{m:"Hb10-a8",e:5}],"1#-1098086333":[{m:"Ra1-b1",e:5}],"-1#-2011137857":[{m:"Ra10-b10",e:5}],"1#-1336781274":[{m:"Rb1-b5",e:5}],"-1#-386112483":[{m:"a7-a6",e:5}],"1#-320964321":[{m:"g4-g5",e:5}],"-1#-1609199630":[{m:"Cb8-c8",e:5}],"1#753649040":[{m:"Rb5-d5",e:5}],"-1#116196306":[{m:"Ad10-e9",e:5}],"1#-366200029":[{m:"Hg3-f5",e:5}],"-1#-1126275004":[{m:"Rh10-h6",e:5}],"1#-1792563213":[{m:"g4-g5",e:8},{m:"Hb1-a3",e:8}],"-1#-638824162":[{m:"c7-c6",e:7.5},{m:"Ch8-i8",e:7.5}],"1#445360677":[{m:"Hh1-g3",e:6.667},{m:"Hb1-a3",e:6.667}],"-1#1429604333":[{m:"Hb10-c8",e:5}],"-1#89462397":[{m:"Hb10-c8",e:5}],"1#340067521":[{m:"Ra1-a2",e:5}],"-1#-1660646294":[{m:"Ch8-i8",e:5}],"1#-1595543911":[{m:"Ra2-d2",e:5}],"-1#1960914083":[{m:"Ri10-h10",e:5}],"1#-468896787":[{m:"Ch3-f3",e:5}],"-1#-1051630252":[{m:"Ri10-h10",e:5}],"1#-1693443931":[{m:"Hh1-g3",e:5}],"-1#-726813331":[{m:"Hb10-c8",e:5}],"1#-977426479":[{m:"c4-c5",e:5}],"-1#179215193":[{m:"Cb8-a8",e:5}],"1#-1012094823":[{m:"Cb3-e3",e:5}],"-1#1777090307":[{m:"Ra10-b10",e:5}],"1#1369313690":[{m:"Hb1-c3",e:5}],"-1#63339223":[{m:"Rh10-h6",e:5}],"1#-1508785267":[{m:"Ri1-h1",e:5}],"-1#-1400072003":[{m:"Rb10-b6",e:5}],"-1#-1963385941":[{m:"g7-g6",e:5}],"1#-6034218":[{m:"Cb3-c3",e:5}],"-1#-179580977":[{m:"Hb10-a8",e:5}],"1#-1076064307":[{m:"Ra1-b1",e:5}],"-1#-1989116111":[{m:"Ra10-b10",e:5}],"1#-1325248088":[{m:"g4-g5",e:5}],"-1#-37116091":[{m:"g6xg5",e:5}],"1#1728933746":[{m:"Rb1-b5",e:5}],"-1#1067670857":[{m:"g5-g4",e:5}],"1#-1506517800":[{m:"Eg1-e3",e:5}],"-1#548231690":[{m:"Cb8-c8",e:5}],"1#-1403842456":[{m:"Rb5-g5",e:5}],"-1#-2137099907":[{m:"Hg8-f6",e:5}],"1#586130894":[{m:"Hh1-f2",e:5}],"-1#347760479":[{m:"g4-f4",e:5}],"1#-130292057":[{m:"Ch3-i3",e:5}],"-1#-1887426120":[{m:"Eg10-e8",e:5}],"1#1289557319":[{m:"Ri1-h1",e:5}],"-1#1178619511":[{m:"a7-a6",e:5}],"1#1113740149":[{m:"i4-i5",e:5}],"-1#-58897643":[{m:"Rb10-b6",e:5}],"1#-1888537981":[{m:"i5-i6",e:5}],"-1#-2122914194":[{m:"Af10-e9",e:5}],"1#-1914887428":[{m:"Rh1-h6",e:5}],"-1#1004828328":[{m:"Ri10-f10",e:5}],"1#-1305427604":[{m:"Ci3xi7",e:5}],"-1#-1931172948":[{m:"Cb8-f8",e:9.994},{m:"g7-g6",e:9.994},{m:"Ch8-d8",e:9.994},{m:"Hb10-a8",e:9.994},{m:"Ec10-e8",e:9.994},{m:"i7-i6",e:9.994},{m:"c7-c6",e:9.994},{m:"Ch8-f8",e:9.994},{m:"Ch8-e8",e:9.994},{m:"Hh10-g8",e:9.994},{m:"Cb8-d8",e:9.994},{m:"Ch8-c8",e:9.994},{m:"Hb10-c8",e:9.994},{m:"Cb8-e8",e:9.994},{m:"Eg10-e8",e:9.994},{m:"Hh10-i8",e:9.994},{m:"Ch8-g8",e:9.994},{m:"Ri10-i9",e:9.994},{m:"Ri10-i8",e:9.994}],"1#-1100340132":[{m:"Hh1-g3",e:8.333},{m:"c4-c5",e:8.333}],"-1#-237532780":[{m:"Hh10-i8",e:7.5}],"1#2041364072":[{m:"Ri1-h1",e:7.5},{m:"Hb1-c3",e:7.5}],"-1#1932649816":[{m:"Ri10-h10",e:6.667}],"1#695244969":[{m:"Hb1-a3",e:6.667},{m:"c4-c5",e:6.667}],"-1#-429677535":[{m:"Hb10-c8",e:5}],"-1#737465637":[{m:"Hb10-c8",e:5}],"1#988071833":[{m:"Ra1-b1",e:5}],"-1#206059365":[{m:"Ri10-h10",e:5}],"-1#1903761620":[{m:"Hb10-c8",e:6.667}],"1#1617496680":[{m:"Hb1-c3",e:6.667}],"-1#842096933":[{m:"Ra10-b10",e:6.667}],"1#172183484":[{m:"Ra1-b1",e:6.667}],"-1#1022345024":[{m:"Rb10-b4",e:6.667},{m:"Hh10-i8",e:6.667}],"1#-1043839327":[{m:"Cb3-a3",e:5}],"-1#-229224499":[{m:"Rb4-c4",e:5}],"1#-1265334084":[{m:"Hh1-g3",e:5}],"-1#-81189516":[{m:"Rb10-b4",e:5}],"1#-104966959":[{m:"Hb1-c3",e:9.961},{m:"c4-c5",e:9.961},{m:"Hh1-g3",e:9.961}],"-1#-1410973796":[{m:"c7-c6",e:5}],"1#1753334951":[{m:"Hh1-g3",e:5}],"-1#658270575":[{m:"Cb8-c8",e:5}],"1#-1413340403":[{m:"Ri1-h1",e:5}],"-1#-1587578819":[{m:"Hh10-g8",e:5}],"1#1669825392":[{m:"Cb3-b8",e:5}],"-1#1802194817":[{m:"Ri10-h10",e:5}],"-1#-1241253607":[{m:"g7-g6",e:7.5},{m:"Ch8-e8",e:9.96},{m:"Ch8-d8",e:9.96},{m:"c7-c6",e:9.96},{m:"g7-g6",e:9.986},{m:"Ri10-i9",e:9.96}],"1#1964679984":[{m:"Ri1-h1",e:9.091}],"-1#2139617280":[{m:"g7-g6",e:5}],"1#-1117846707":[{m:"Hb1-c3",e:9.167},{m:"Rh1-h7",e:9.167},{m:"Hb1-a3",e:9.167},{m:"c4-c5",e:9.167}],"-1#-284727296":[{m:"Ri10-i9",e:5}],"-1#129308976":[{m:"Hb10-c8",e:5}],"-1#-1568555243":[{m:"Hb10-c8",e:5}],"1#-1282298455":[{m:"Ra1-a2",e:5}],"-1#1917599685":[{m:"Hb10-c8",e:9}],"1#-714438622":[{m:"Eg1-e3",e:5}],"1#-1692988831":[{m:"Hh1-g3",e:9.583}],"-1#-727013463":[{m:"Hh10-g8",e:9.583}],"1#376593636":[{m:"g4-g5",e:9.583},{m:"Ri1-h1",e:9.583}],"-1#1522117129":[{m:"Ri10-h10",e:5}],"1#16308216":[{m:"Eg1-e3",e:5}],"-1#-2040409814":[{m:"Hb10-c8",e:5}],"1#-1754152042":[{m:"Hb1-a3",e:5}],"-1#-2001764402":[{m:"Rh10-h6",e:5}],"1#762889876":[{m:"Cb3-c3",e:5}],"-1#663807373":[{m:"Rh6-d6",e:5}],"1#-1935069442":[{m:"Cd3xd8",e:5}],"-1#632367693":[{m:"Cb8xd8",e:5}],"1#-542855793":[{m:"Af1-e2",e:5}],"-1#485427156":[{m:"Hb10-a8",e:9.565},{m:"Eg10-e8",e:9.565},{m:"g7-g6",e:9.565}],"1#1450723286":[{m:"Hb1-a3",e:5}],"-1#1235680142":[{m:"a7-a6",e:5}],"1#-541967573":[{m:"c4-c5",e:6.667}],"-1#278988707":[{m:"Hb10-a8",e:6.667}],"1#1773531305":[{m:"Rh1-h5",e:9.861},{m:"Hb1-c3",e:9.861}],"1#-965483602":[{m:"Hh1-g3",e:5}],"-1#-1982968218":[{m:"Ra10-a9",e:5}],"1#-1852319961":[{m:"Ri1-h1",e:5}],"-1#-1693807593":[{m:"Hh10-g8",e:5}],"1#1506965338":[{m:"g4-g5",e:5}],"-1#353993143":[{m:"Ri10-h10",e:5}],"1#1331231814":[{m:"c4-c5",e:5}],"-1#-2142519090":[{m:"Ra9-d9",e:5}],"1#-270803603":[{m:"Ad1-e2",e:5}],"-1#-1596797843":[{m:"Rd9-d6",e:5}],"1#1728543403":[{m:"Hb1-c3",e:5}],"-1#895422950":[{m:"g7-g6",e:5}],"1#1074128539":[{m:"Rh1-h7",e:5}],"-1#-84935450":[{m:"g6xg5",e:5}],"1#1613444305":[{m:"Rh7-g7",e:5}],"-1#1909048633":[{m:"Eg10-e8",e:5}],"1#-1298859578":[{m:"Rg7xg5",e:5}],"-1#-1014999057":[{m:"Ch8-h9",e:5}],"1#-1678559764":[{m:"Hc3-d5",e:5}],"-1#-1313813551":[{m:"Ch9-g9",e:5}],"1#-780288482":[{m:"Cd3xd6",e:5}],"-1#1926424655":[{m:"Cg9xg5",e:5}],"1#-1602837681":[{m:"Hh1-g3",e:9.6}],"-1#-271905145":[{m:"Ri10-i9",e:9.6},{m:"Hh10-g8",e:9.6}],"1#-1369318685":[{m:"Hb1-a3",e:9.836},{m:"Ad1-e2",e:9.836},{m:"Af1-e2",e:9.836},{m:"Eg1-e3",e:9.836},{m:"Ec1-e3",e:9.836},{m:"Ri1-h1",e:9.836}],"-1#-1312856389":[{m:"a7-a6",e:8}],"-1#-513225757":[{m:"Hh10-i8",e:5}],"-1#687397937":[{m:"Hh10-i8",e:5}],"1#756282826":[{m:"Ri1-h1",e:5}],"-1#663662330":[{m:"Ri10-h10",e:5}],"1#2110771979":[{m:"g4-g5",e:6.667},{m:"Ec1-e3",e:6.667}],"-1#822355430":[{m:"Ch8-h6",e:5}],"1#181231332":[{m:"Eg1-e3",e:5}],"-1#-1940629450":[{m:"Ch6-a6",e:5}],"1#-1769002707":[{m:"Cb3-a3",e:5}],"-1#-819380958":[{m:"g7-g6",e:5}],"1#-1166816673":[{m:"Rh1-h5",e:5}],"-1#716719351":[{m:"Ch8-i8",e:5}],"1#-2096534157":[{m:"Hh1-g3",e:5}],"-1#-860569413":[{m:"Ec10-e8",e:5}],"1#-534331304":[{m:"Ec1-e3",e:5}],"-1#1388326513":[{m:"Ri10-i9",e:5}],"1#325777941":[{m:"Ad1-e2",e:6.667},{m:"Hb1-c3",e:6.667}],"-1#1550052117":[{m:"a7-a6",e:5}],"1#1480717847":[{m:"Hb1-c3",e:5}],"-1#169450842":[{m:"c7-c6",e:5}],"1#-914463135":[{m:"Ri1-h1",e:5}],"-1#-1008517807":[{m:"i6-i5",e:5}],"1#89586060":[{m:"i4xi5",e:5}],"-1#1818219423":[{m:"Ri9xi5",e:5}],"1#697313427":[{m:"g4-g5",e:5}],"-1#1093833048":[{m:"c7-c6",e:5}],"1#-2108331421":[{m:"Ri1-h1",e:5}],"-1#-2000146093":[{m:"Hh10-i8",e:5}],"1#11732655":[{m:"Rh1-h5",e:5}],"-1#-1871149049":[{m:"Ch8-f8",e:5}],"1#1398919726":[{m:"Cb3-a3",e:5}],"-1#1627380546":[{m:"Hb10-c8",e:5}],"1#1911540222":[{m:"Ra1-b1",e:5}],"1#1334007959":[{m:"Cb3-c3",e:9.5},{m:"Hh1-g3",e:9.5}],"-1#1164671886":[{m:"Ec10-e8",e:5}],"1#1777957741":[{m:"Hb1-a3",e:5}],"-1#1982318389":[{m:"Hb10-c8",e:5}],"1#1731712393":[{m:"Ra1-b1",e:5}],"-1#1369122165":[{m:"Ra10-b10",e:5}],"1#1776880620":[{m:"Hh1-g3",e:5}],"-1#643081764":[{m:"Ch8-f8",e:5}],"1#-447874035":[{m:"Ri1-h1",e:5}],"-1#-271538371":[{m:"Hh10-g8",e:5}],"1#755522672":[{m:"c4-c5",e:5}],"-1#4126047":[{m:"Hb10-c8",e:9.474},{m:"Hh10-i8",e:9.474},{m:"Hh10-g8",e:9.474},{m:"Ch8-d8",e:9.474},{m:"Ec10-e8",e:9.474},{m:"c7-c6",e:8.75},{m:"c7-c6",e:9.974}],"1#288286691":[{m:"Ri1-h1",e:5}],"1#399334546":[{m:"Ri1-h1",e:5}],"1#749532604":[{m:"Ri1-h1",e:5}],"1#-121728027":[{m:"Ec1-e3",e:6.667},{m:"Hb1-a3",e:6.667}],"-1#1247313356":[{m:"Ri10-i8",e:5}],"1#287138655":[{m:"Ri1-h1",e:5}],"-1#461387887":[{m:"Ri8-d8",e:5}],"1#845989603":[{m:"Ad1-e2",e:5}],"-1#2103826403":[{m:"Hh10-g8",e:5}],"1#-1078121298":[{m:"Rh1-h5",e:5}],"-1#796303878":[{m:"Cc8-c9",e:5}],"1#1066231450":[{m:"Hb1-a3",e:5}],"-1#542366402":[{m:"a7-a6",e:5}],"-1#-413126723":[{m:"Ri10-i8",e:5}],"1#-1138413266":[{m:"Ri1-h1",e:5}],"-1#-1229428194":[{m:"Ri8-d8",e:5}],"1#-1621846894":[{m:"Ad1-e2",e:5}],"-1#-799177326":[{m:"Hh10-g8",e:5}],"1#310738655":[{m:"Rh1-h5",e:5}],"-1#-2108755849":[{m:"Hb10-a8",e:5}],"1#-925257611":[{m:"Ec1-e3",e:5}],"-1#2050973276":[{m:"Ec10-e8",e:5}],"1#1666679908":[{m:"Ri1-h1",e:6.667}],"-1#1774903124":[{m:"Hh10-g8",e:6.667}],"1#-1424874471":[{m:"Cb3-c3",e:7.5},{m:"Ad1-e2",e:7.5},{m:"g4-g5",e:7.5}],"1#1342044549":[{m:"Hh1-g3",e:7.5}],"-1#4215885":[{m:"Cb8-e8",e:7.5},{m:"g7-g6",e:7.5},{m:"Hh10-g8",e:7.5}],"1#904422373":[{m:"Ri1-h1",e:6.667},{m:"Eg1-e3",e:6.667}],"-1#1064646869":[{m:"Hh10-g8",e:5}],"-1#-1284414153":[{m:"Hb10-c8",e:5}],"1#-1570670709":[{m:"c4-c5",e:5}],"1#-1030181120":[{m:"Ri1-h1",e:5}],"-1#-939133904":[{m:"g7-g6",e:5}],"1#-275918185":[{m:"Hh1-g3",e:9.974}],"-1#-1607434401":[{m:"Hb10-c8",e:9.974},{m:"Hh10-g8",e:9.974},{m:"c7-c6",e:9.974},{m:"Ch8-e8",e:9.918}],"1#-1323274781":[{m:"Ri1-h1",e:7.5},{m:"c4-c5",e:7.5}],"-1#-1145227565":[{m:"Hh10-g8",e:6.667}],"-1#2117292395":[{m:"Cb8xb1",e:5}],"1#1659405330":[{m:"Hb1-c3",e:9.972},{m:"g4-g5",e:9.972},{m:"Ri1-h1",e:9.972},{m:"Eg1-e3",e:9.972},{m:"Af1-e2",e:9.972}],"1#-509957317":[{m:"Ri1-h1",e:9.744},{m:"Hb1-c3",e:9.744},{m:"Af1-e2",e:9.744},{m:"c4-c5",e:9.744}],"1#1312577761":[{m:"Hh1-g3",e:9.988},{m:"g4-g5",e:9.988},{m:"c4-c5",e:9.988}],"-1#25294121":[{m:"Hh10-g8",e:9.167},{m:"Ch8-i8",e:9.986},{m:"Ri10-h10",e:9.986},{m:"Ri10-i9",e:9.986},{m:"g7-g6",e:9.986},{m:"Hh10-g8",e:9.474}],"1#277997461":[{m:"Hh1-g3",e:5}],"-1#-545072355":[{m:"g7-g6",e:6.667},{m:"Ch8-i8",e:6.667}],"1#-1428673440":[{m:"Hb1-c3",e:5}],"-1#-125810899":[{m:"Ra10-a9",e:7.5},{m:"Ri10-h10",e:7.5}],"1#-496780818":[{m:"Ri1-h1",e:5}],"-1#-385948962":[{m:"Ec10-e8",e:5}],"1#-999497155":[{m:"g4-g5",e:5}],"-1#-2002316080":[{m:"Ad10-e9",e:5}],"1#1012963290":[{m:"c4-c5",e:5}],"-1#49786380":[{m:"Ri10-i9",e:9.898},{m:"c7-c6",e:9.898},{m:"Ri10-h10",e:9.898},{m:"Hb10-a8",e:9.898}],"1#-1047505609":[{m:"Hh1-g3",e:9.167}],"1#1488376829":[{m:"Hb1-a3",e:9.882}],"1#1214311950":[{m:"Hh1-g3",e:5}],"1#-509528225":[{m:"Hh1-g3",e:7.5}],"-1#-1373857129":[{m:"Hb10-c8",e:7.5},{m:"Hh10-g8",e:7.5}],"1#-1089697749":[{m:"Hb1-a3",e:5}],"-1#-1596836749":[{m:"Ra10-b10",e:5}],"1#-1734337814":[{m:"Ra1-b1",e:5}],"-1#-1374885354":[{m:"Rb10-b4",e:5}],"1#1395332087":[{m:"Ri1-h1",e:5}],"-1#1505118407":[{m:"Hh10-g8",e:5}],"1#-1687243894":[{m:"Cb3-c3",e:5}],"-1#-1853452141":[{m:"Rb4xb1",e:5}],"1#-1118820910":[{m:"Ha3xb1",e:5}],"-1#1762503016":[{m:"Ri10-h10",e:5}],"1#1824809434":[{m:"Hb1-a3",e:6.667},{m:"c4-c5",e:6.667}],"-1#1931140482":[{m:"Hb10-a8",e:5}],"1#965582208":[{m:"Ra1-b1",e:5}],"-1#253848956":[{m:"Ri10-h10",e:5}],"1#1432359053":[{m:"Ri1-h1",e:5}],"-1#-1546166958":[{m:"Ri10-h10",e:5}],"1#-107601757":[{m:"Hb1-c3",e:5}],"-1#-1412543506":[{m:"Ch8-i8",e:5}],"1#-1775294179":[{m:"Ra1-b1",e:8.333}],"1#1952761110":[{m:"Hh1-g3",e:8.75}],"-1#1004103902":[{m:"c7-c6",e:8.75},{m:"Ch8-c8",e:7.5}],"1#1620866637":[{m:"Ri1-h1",e:9},{m:"Af1-e2",e:9},{m:"Hb1-a3",e:9}],"-1#1778462077":[{m:"Ri8-h8",e:8},{m:"Ri8-d8",e:8}],"1#-1570225155":[{m:"Rh1xh8",e:5}],"-1#-1134921059":[{m:"Cb8xh8",e:5}],"1#1139659761":[{m:"Af1-e2",e:7.5},{m:"Ad1-e2",e:7.5}],"-1#952474759":[{m:"Ri8-d8",e:6.667}],"1#287924747":[{m:"Eg1-e3",e:6.667}],"-1#-1750047527":[{m:"Hh10-g8",e:6.667},{m:"g7-g6",e:6.667}],"1#1432919956":[{m:"Ri1-f1",e:5}],"1#-487943260":[{m:"Ri1-f1",e:5}],"-1#2135083541":[{m:"Ri8-d8",e:7.5}],"1#1454257305":[{m:"Af1-e2",e:7.5}],"-1#251125331":[{m:"a7-a6",e:7.5},{m:"Hb10-a8",e:7.5},{m:"g7-g6",e:7.5}],"1#1147182673":[{m:"a4-a5",e:5}],"1#-1644908272":[{m:"c4-c5",e:9.231},{m:"Hh1-g3",e:9.231}],"-1#1390906776":[{m:"Hh10-g8",e:5}],"1#-1874889003":[{m:"Hh1-g3",e:5}],"-1#-766960424":[{m:"Ri10-i9",e:9.167},{m:"Hh10-g8",e:9.167},{m:"Cb8-a8",e:9.167},{m:"Hh10-i8",e:9.167},{m:"Hb10-c8",e:9.974}],"1#-1813788484":[{m:"Ri1-h1",e:7.5}],"1#457912088":[{m:"Hb1-a3",e:5}],"-1#76911424":[{m:"Ra10-b10",e:5}],"1#1513237284":[{m:"c4-c5",e:8.333},{m:"Ri1-h1",e:8.333}],"1#-1186163708":[{m:"Hh1-g3",e:8.571}],"-1#-151963188":[{m:"Hh10-i8",e:8.571},{m:"Cb8-e8",e:7.5},{m:"Ch8-h4",e:8.571},{m:"Ri10-i9",e:8.571},{m:"Hb10-c8",e:8.571}],"1#2122976816":[{m:"Hb1-a3",e:5}],"-1#1632940648":[{m:"Hb10-c8",e:5}],"1#1883545812":[{m:"Ra1-b1",e:5}],"-1#1189629992":[{m:"Ri10-h10",e:5}],"1#-747109722":[{m:"g4-g5",e:5}],"-1#-1615596469":[{m:"Hh10-i8",e:5}],"1#399033271":[{m:"Hb1-a3",e:5}],"-1#135692271":[{m:"Hb10-c8",e:5}],"1#-1218712152":[{m:"Ri1-h1",e:5}],"-1#-1111050600":[{m:"Ri9-d9",e:5}],"1#1120018215":[{m:"Hb1-c3",e:5}],"-1#278557802":[{m:"Hh10-g8",e:5}],"1#-767389913":[{m:"Rh1-h5",e:5}],"1#-404673680":[{m:"Hb1-c3",e:6.667},{m:"Ri1-h1",e:6.667}],"-1#-1246150595":[{m:"Hh10-g8",e:5}],"-1#-310611904":[{m:"Ch8-f8",e:5}],"1#1337565011":[{m:"Hh1-g3",e:6.667}],"-1#275099":[{m:"Hh10-g8",e:6.667},{m:"Ch8-f8",e:6.667}],"1#-1025717802":[{m:"Ri1-h1",e:5}],"-1#-935226650":[{m:"Ri10-h10",e:5}],"1#-1845432553":[{m:"c4-c5",e:5}],"-1#1561580447":[{m:"Hb10-a8",e:5}],"1#394564509":[{m:"Hb1-c3",e:5}],"-1#1172109520":[{m:"Ra10-a9",e:5}],"1#1569022353":[{m:"Ec1-e3",e:5}],"-1#-278687816":[{m:"Ra9-d9",e:5}],"1#-2131520997":[{m:"Rh1-h5",e:5}],"-1#272112819":[{m:"Rd9-d4",e:5}],"1#-1021482830":[{m:"Ri1-h1",e:5}],"-1#-914345086":[{m:"Hh10-g8",e:5}],"1#190367951":[{m:"c4-c5",e:5}],"-1#-1001655225":[{m:"g7-g6",e:5}],"1#-1324285126":[{m:"Hb1-c3",e:5}],"-1#-481728393":[{m:"Cb8-c8",e:5}],"1#1874272789":[{m:"Ec1-e3",e:5}],"-1#-581841860":[{m:"Hb10-a8",e:5}],"1#-1748595650":[{m:"Hc3-b5",e:5}],"-1#-555457966":[{m:"Hg8-f6",e:5}],"1#77567056":[{m:"Hh1-g3",e:9.231},{m:"i4-i5",e:9.231}],"-1#1260534168":[{m:"Ec10-e8",e:9.167},{m:"Ri10-h10",e:9.167},{m:"Ri10-i9",e:9.167},{m:"Ch8-g8",e:9.167}],"1#1739602299":[{m:"Ri1-h1",e:5}],"-1#1831690827":[{m:"Ri10-i9",e:5}],"1#291718249":[{m:"c4-c5",e:8.889},{m:"Eg1-e3",e:8.889}],"1#176745980":[{m:"Ri1-h1",e:7.5}],"1#1037637458":[{m:"c4-c5",e:5}],"-1#-221631526":[{m:"Ri10-h10",e:5}],"-1#-1165980624":[{m:"Ec10-e8",e:5}],"1#-1777169197":[{m:"Hh1-g3",e:5}],"-1#-642834149":[{m:"Ri10-i9",e:5}],"1#-1744439937":[{m:"Ri1-h1",e:5}],"-1#-1835487665":[{m:"Ri9-d9",e:5}],"1#1838942192":[{m:"Af1-e2",e:5}],"-1#902163770":[{m:"Rd9-d5",e:5}],"1#1158338083":[{m:"Hb1-c3",e:5}],"-1#391298414":[{m:"Ch8-f8",e:5}],"1#-733223097":[{m:"Eg1-e3",e:5}],"-1#1389552021":[{m:"Rd5-d4",e:5}],"1#-98595482":[{m:"c4-c5",e:8.75},{m:"Eg1-e3",e:8.75},{m:"Hh1-g3",e:8.75}],"-1#890024430":[{m:"Hh10-i8",e:8},{m:"Ri10-i9",e:8},{m:"Cb8-b4",e:8}],"1#-1116240366":[{m:"Hb1-c3",e:5}],"1#1957062026":[{m:"Hb1-c3",e:5}],"1#-2000553750":[{m:"Hb1-c3",e:6.667}],"-1#2089192372":[{m:"Hh10-i8",e:5}],"1#-184697784":[{m:"Hh1-g3",e:5}],"-1#-1153429120":[{m:"Cg8xg4",e:5}],"1#1265342096":[{m:"c4-c5",e:5}],"-1#-2072466920":[{m:"Cb8-b4",e:5}],"1#968221468":[{m:"Hb1-c3",e:5}],"-1#1810729041":[{m:"Cb4-c4",e:5}],"-1#-1247666002":[{m:"Cg8xg4",e:6.667}],"1#1166649278":[{m:"Eg1-e3",e:6.667},{m:"Ri1-h1",e:6.667}],"-1#-1022320276":[{m:"Hh10-g8",e:5}],"1#29907489":[{m:"Ri1-h1",e:5}],"-1#1326775438":[{m:"Hh10-g8",e:5}],"1#-1916008509":[{m:"Ec1-e3",e:5}],"1#-850495544":[{m:"Hb1-c3",e:9.919},{m:"Hh1-g3",e:9.919}],"-1#-1625940859":[{m:"Hb10-c8",e:5}],"1#-1912205767":[{m:"Hh1-g3",e:5}],"-1#-1044667407":[{m:"Ri9-d9",e:5}],"1#1052707406":[{m:"Ri1-h1",e:8}],"-1#874664318":[{m:"Hh10-i8",e:8.333}],"1#-1134991742":[{m:"Rh1-h5",e:8.571},{m:"c4-c5",e:8.571}],"-1#747825194":[{m:"Rd9-d4",e:6.667}],"-1#1934252554":[{m:"Rd9-d4",e:8.571},{m:"i7-i6",e:8.571}],"-1#-2097948160":[{m:"Ri10-i9",e:9.167},{m:"Ch8-e8",e:9.918},{m:"Ri10-i9",e:9.6},{m:"Ri9-d9",e:9.918},{m:"Ri10-i9",e:9.167},{m:"Eg10-e8",e:9.918}],"1#2113369023":[{m:"Ad1-e2",e:9.865}],"1#1101981439":[{m:"Ri1-h1",e:5}],"-1#1261682127":[{m:"Ri9-d9",e:5}],"1#-677266113":[{m:"Hh1-g3",e:7.5}],"-1#-1742991113":[{m:"Ch8-c8",e:7.5}],"-1#1429290896":[{m:"Ch8-e8",e:10},{m:"Hh10-g8",e:10},{m:"Hb10-c8",e:10},{m:"Cb8-e8",e:10},{m:"Ec10-e8",e:10},{m:"Eg10-e8",e:10},{m:"Cb8-f8",e:10},{m:"Ad10-e9",e:10},{m:"Cb8-b7",e:10},{m:"Ch8-h7",e:10},{m:"Af10-e9",e:10}],"1#911756971":[{m:"Hb1-c3",e:9.997},{m:"Ri1-i2",e:9.997},{m:"c4-c5",e:9.997},{m:"Ce3xe7+",e:9.997},{m:"g4-g5",e:9.997},{m:"Hh1-g3",e:9.997}],"-1#1662780099":[{m:"Ce8xe4+",e:9.972},{m:"Hh10-g8",e:9.972},{m:"Cb8-d8",e:9.972}],"1#-1545710550":[{m:"Ad1-e2",e:9.5}],"1#-1580926578":[{m:"Hh1-g3",e:9.97},{m:"Ri2-d2",e:9.97}],"1#240752176":[{m:"Hh1-g3",e:5}],"-1#1923821097":[{m:"Ad10-e9",e:8.333},{m:"Af10-e9",e:8.333}],"1#-1637214504":[{m:"Cb3-e3",e:8},{m:"Hh1-g3",e:8}],"1#2113989307":[{m:"Cb3-e3",e:5}],"-1#-733971167":[{m:"Hh10-g8",e:5}],"1#379094636":[{m:"Hh1-g3",e:5}],"-1#2056501318":[{m:"Hh10-g8",e:6.667}],"1#-1203027189":[{m:"Hh1-g3",e:6.667}],"-1#-134811965":[{m:"Ri10-i9",e:9.922},{m:"Hb10-c8",e:9.922},{m:"Ri10-h10",e:9.922},{m:"c7-c6",e:9.922}],"1#-1380478158":[{m:"Hb1-a3",e:9.873}],"-1#2045109091":[{m:"g7-g6",e:9.996},{m:"Hh10-g8",e:9.996},{m:"Hb10-a8",e:9.996},{m:"Ri10-i9",e:9.996}],"1#-1153624018":[{m:"Hh1-g3",e:8}],"-1#-2115151915":[{m:"Hb10-c8",e:8.333},{m:"Ri10-h10",e:8.333}],"1#-1862449815":[{m:"Ri1-h1",e:8},{m:"Hb1-c3",e:8}],"-1#-1704976807":[{m:"Ad10-e9",e:8},{m:"Ri10-i9",e:8},{m:"Cb8-a8",e:8}],"1#1398943129":[{m:"c4-c5",e:5}],"-1#-1029362140":[{m:"Ra10-b10",e:6.667}],"1#-86572867":[{m:"Ri1-h1",e:6.667},{m:"Ra1-b1",e:6.667}],"1#-609474012":[{m:"Hb1-c3",e:6.667}],"-1#-1980481175":[{m:"Hb10-a8",e:6.667}],"1#-1016921749":[{m:"Ra1-b1",e:6.667}],"-1#-170921577":[{m:"Ra10-b10",e:6.667}],"1#-843194610":[{m:"g4-g5",e:6.667},{m:"c4-c5",e:6.667}],"-1#-2122962461":[{m:"c7-c6",e:5}],"-1#45015942":[{m:"Rh10-h5",e:5}],"1#944715527":[{m:"Hb1-a3",e:9.976}],"1#-1746287395":[{m:"Hb1-c3",e:9.999},{m:"Ri1-i2",e:9.999},{m:"c4-c5",e:9.999},{m:"Hh1-g3",e:9.999},{m:"Ch3-e3",e:8.333},{m:"Ri1-i3",e:9.999},{m:"Cb3-d3",e:9.999}],"-1#-1028814667":[{m:"Ri10-h10",e:8.571},{m:"g7-g6",e:8.571},{m:"Hb10-c8",e:8.571}],"1#-1729301180":[{m:"Hb1-c3",e:7.5}],"1#-1208516664":[{m:"c4-c5",e:5}],"1#-742548983":[{m:"Hh1-g3",e:6.667}],"-1#-665556715":[{m:"Ch8-h9",e:9.999},{m:"Ch8-h4",e:9.999},{m:"Af10-e9",e:9.999},{m:"Hh10-g8",e:9.677},{m:"Ri10-i9",e:9.999},{m:"c7-c6",e:9.999}],"1#-188323338":[{m:"Ri1-h1",e:8.75}],"-1#842413793":[{m:"Ri10-h10",e:5}],"1#1752648464":[{m:"Ri3-f3",e:5}],"-1#1244273735":[{m:"Hb10-c8",e:5}],"1#1530531579":[{m:"Hh1-g3",e:5}],"-1#344433459":[{m:"Ec10-e8",e:5}],"1#940942288":[{m:"Hb1-c3",e:5}],"-1#-1388737754":[{m:"Hb10-c8",e:6.667},{m:"c7-c6",e:6.667}],"1#-1138124390":[{m:"Hb1-c3",e:5}],"1#1851682845":[{m:"Hh1-g3",e:5}],"-1#568581589":[{m:"Ri10-h10",e:5}],"1#1143024940":[{m:"Hb1-a3",e:9.998},{m:"g4-g5",e:9.998},{m:"c4-c5",e:9.998},{m:"Hb1-c3",e:9.998},{m:"Hh1-g3",e:9.998},{m:"Ri1-i2",e:9.998},{m:"Cb3-c3",e:9.998}],"-1#-1959652956":[{m:"g7-g6",e:9.969},{m:"Cb8-a8",e:9.969},{m:"Hb10-c8",e:9.286},{m:"Ec10-e8",e:9.969},{m:"Hh10-g8",e:9.969},{m:"Hb10-c8",e:5}],"-1#377046625":[{m:"Hb10-c8",e:9.286},{m:"Hh10-g8",e:8.333},{m:"Ch8-f8",e:8.333},{m:"Ri10-i9",e:8.333},{m:"Cb8-a8",e:8.333}],"-1#194805988":[{m:"Ch8-e8",e:9.997},{m:"g7-g6",e:9.997},{m:"Ri10-i9",e:9.997},{m:"Ch8-g8",e:9.997},{m:"Cb8-b6",e:9.997},{m:"Cb8-a8",e:9.997}],"-1#291856708":[{m:"Hh10-i8",e:7.5},{m:"Ri10-i9",e:7.5},{m:"Cb8-a8",e:7.5}],"1#-1726064968":[{m:"Hh1-g3",e:5}],"1#1355789600":[{m:"Ri2-d2",e:5}],"1#-664317308":[{m:"Cb3-b7",e:5}],"-1#1321799221":[{m:"Hh10-i8",e:5}],"1#-961398327":[{m:"i4-i5",e:5}],"-1#2024612265":[{m:"Ri10-i9",e:5}],"1#956822989":[{m:"Hh1-g3",e:5}],"-1#1991923717":[{m:"Ch8-g8",e:5}],"1#4290255":[{m:"c4-c5",e:5}],"1#1620641848":[{m:"Hh1-g3",e:9.942},{m:"Hb1-c3",e:9.942}],"-1#790930928":[{m:"Ch8-g8",e:9.939},{m:"Hh10-g8",e:9.939},{m:"Hb10-c8",e:9.939},{m:"Ch8-f8",e:9.939},{m:"Hh10-i8",e:9.939}],"1#1507822394":[{m:"Ri1-h1",e:7.5}],"-1#1396887562":[{m:"Hh10-i8",e:7.5}],"1#-616962058":[{m:"Hb1-c3",e:7.5}],"1#-302227779":[{m:"Hb1-c3",e:9.839},{m:"Hh1-g3",e:5},{m:"Ri1-h1",e:9.839}],"1#1043642188":[{m:"Cb3-d3",e:9.886},{m:"Hb1-c3",e:9.886},{m:"Hh1-g3",e:5}],"1#-331481127":[{m:"Ri1-h1",e:8.75},{m:"Ce3xe7+",e:8.75},{m:"Hb1-a3",e:8.75}],"1#-1486908916":[{m:"Hb1-c3",e:9.688},{m:"Hb1-a3",e:9.688}],"-1#851534709":[{m:"Hb10-c8",e:8.889},{m:"c7-c6",e:8.889}],"1#600928713":[{m:"Ra1-b1",e:8.75}],"-1#360546613":[{m:"Hh10-g8",e:8.75},{m:"Hh10-i8",e:8.75},{m:"Ch8-f8",e:8.75}],"1#-677021064":[{m:"Hh1-g3",e:8}],"-1#-1743202384":[{m:"Ra10-a9",e:9.167}],"1#-1660504375":[{m:"Hh1-g3",e:5}],"-1#-759489791":[{m:"c7-c6",e:8.333}],"1#-698033380":[{m:"Ri1-i3",e:6.667}],"1#-240740274":[{m:"Hh1-g3",e:5}],"-1#-1105513082":[{m:"Ch8-f8",e:5}],"1#2097311663":[{m:"Ri1-h1",e:5}],"-1#2006922399":[{m:"Hh10-g8",e:5}],"1#-1253584942":[{m:"Cb3-b7",e:5}],"-1#-1446295768":[{m:"g7-g6",e:5}],"1#-594431915":[{m:"Rh1-h7",e:5}],"-1#1719380520":[{m:"Hg8-f6",e:5}],"1#2040741747":[{m:"c4-c5",e:9.697},{m:"Hh1-g3",e:9.697}],"-1#907973307":[{m:"Hh10-g8",e:9.677},{m:"Hb10-d9",e:9.677},{m:"Ri10-i9",e:9.677},{m:"Ch8-g8",e:9.677},{m:"i7-i6",e:9.677},{m:"Hb10-c8",e:9.677},{m:"g7-g6",e:9.677},{m:"Hh10-i8",e:9.677}],"1#1010625953":[{m:"Hb1-c3",e:6.667}],"1#2008303327":[{m:"Ri1-h1",e:9.375},{m:"Ce3xe7+",e:9.375}],"1#1088797809":[{m:"Ri1-h1",e:5}],"1#972250212":[{m:"g4-g5",e:7.5}],"1#655261703":[{m:"c4-c5",e:9},{m:"Hb1-c3",e:9}],"1#1128555974":[{m:"Ri1-h1",e:5}],"-1#1238974198":[{m:"Hb10-d9",e:5}],"1#-1100634809":[{m:"Ri1-h1",e:6.667}],"-1#-1258750345":[{m:"Ri10-h10",e:6.667}],"1#-1771306129":[{m:"Hh1-g3",e:9.091},{m:"Ce3xe7+",e:9.091}],"-1#-640569689":[{m:"g7-g6",e:8.889},{m:"Ch8-f8",e:8.889},{m:"Ri10-i9",e:8.889},{m:"Hh10-f9",e:8.889},{m:"Hh10-g8",e:8.889}],"1#-1400153638":[{m:"Ri1-h1",e:5}],"-1#-1508506902":[{m:"Hh10-f9",e:5}],"1#1366781929":[{m:"Hb1-a3",e:6.667}],"1#449377422":[{m:"Ri1-h1",e:5}],"-1#274051006":[{m:"Hh10-g8",e:5}],"1#-762489613":[{m:"Hb1-a3",e:5}],"1#-1736738109":[{m:"Ri1-h1",e:5}],"-1#-1830411789":[{m:"Ri9-d9",e:5}],"1#783336356":[{m:"Ri1-i2",e:7.5},{m:"Ri1-h1",e:7.5}],"-1#606967956":[{m:"Ri10-h10",e:6.667}],"1#453596650":[{m:"Ri1-h1",e:7.5}],"-1#294915802":[{m:"Ch8-i8",e:7.5},{m:"Ri10-h10",e:7.5}],"-1#-761306131":[{m:"Af10-e9",e:6.667}],"1#-566974593":[{m:"Cb3-i3",e:6.667},{m:"Cb3-e3",e:6.667}],"-1#1326715600":[{m:"Hh10-g8",e:5}],"1#-1915950691":[{m:"Ce7xi7",e:5}],"-1#1434486542":[{m:"Ri10-h10",e:5}],"1#264370943":[{m:"Ci7-i10+",e:5}],"-1#617790288":[{m:"Ee8-g10",e:5}],"1#-410024017":[{m:"Hh1-g3",e:5}],"-1#-1473107353":[{m:"Ch8-i8",e:5}],"1#-1781315436":[{m:"Ci10xg10",e:5}],"-1#1953771749":[{m:"Hh10-g8",e:5}],"1#-1230189656":[{m:"Ce7-e6",e:5}],"-1#752988806":[{m:"Hb10-c8",e:5}],"1#1039245370":[{m:"Hh1-g3",e:5}],"-1#1917586930":[{m:"Ri10-h10",e:5}],"1#671969283":[{m:"Hb1-c3",e:5}],"-1#2052397902":[{m:"Ra10-b10",e:5}],"1#1109865943":[{m:"Ra1-b1",e:5}],"1#1740617824":[{m:"Ce3-h3",e:5}],"-1#1026044292":[{m:"Cf8-b8",e:5}],"1#-1175451807":[{m:"Hh1-g3",e:7.5}],"-1#-162682199":[{m:"Ch8-d8",e:7.5}],"1#-507640988":[{m:"Ce3xe7+",e:7.5},{m:"Ri1-h1",e:7.5}],"-1#-1521654810":[{m:"Ec10-e8",e:5}],"1#-1981848827":[{m:"Ri1-i2",e:5}],"-1#-593809555":[{m:"Hh10-g8",e:5}],"1#507761696":[{m:"Ce7-e6",e:5}],"-1#-2079412978":[{m:"Hb10-a8",e:5}],"1#-828773108":[{m:"Ri2-d2",e:5}],"-1#1622426095":[{m:"Ra10-d10",e:5}],"1#-1499840379":[{m:"Cb3-e3",e:5}],"-1#215668511":[{m:"Cb8-b3",e:5}],"1#570488791":[{m:"Hb1-c3",e:5}],"-1#1884855450":[{m:"Cb3xe3",e:5}],"1#370766183":[{m:"Ce6xe3",e:5}],"-1#799383163":[{m:"Cd8-d3",e:5}],"1#917703683":[{m:"Hg3-i2",e:5}],"-1#202436748":[{m:"Ri10-h10",e:5}],"1#1448185213":[{m:"Ra1-b1",e:5}],"-1#1627225473":[{m:"Rd10-d8",e:5}],"1#-689345457":[{m:"e4-e5",e:5}],"-1#-350005164":[{m:"Hh10-g8",e:6.667}],"1#704357145":[{m:"c4-c5",e:6.667},{m:"g4-g5",e:6.667}],"-1#-420962415":[{m:"Hb10-a8",e:5}],"1#-1400905837":[{m:"Hb1-c3",e:5}],"-1#-30952226":[{m:"Ec10-e8",e:5}],"1#-759843779":[{m:"Hc3-d5",e:5}],"-1#-118076928":[{m:"Ri10-i9",e:5}],"1#-1185112476":[{m:"Hd5xe7",e:5}],"-1#1856517231":[{m:"Hg8xe7",e:5}],"1#292712683":[{m:"Ce3xe7",e:5}],"-1#1697666548":[{m:"Ri10-i9",e:5}],"1#614105488":[{m:"Hb1-c3",e:5}],"-1#1992485597":[{m:"Ri9-f9",e:5}],"1#1652898623":[{m:"c4-c5",e:5}],"-1#-1382676553":[{m:"Rf9-f6",e:5}],"1#419948311":[{m:"Cb3-a3",e:5}],"-1#714731131":[{m:"Ec10-e8",e:5}],"1#-2069786886":[{m:"Hh1-g3",e:9.091}],"-1#-887348430":[{m:"Ch8-d8",e:9.091},{m:"Ch8-c8",e:9.091}],"1#-588281089":[{m:"c4-c5",e:7.5},{m:"Ri1-h1",e:7.5},{m:"Cb3-d3",e:7.5}],"-1#335328887":[{m:"Hh10-g8",e:5}],"1#-786150086":[{m:"Ri1-h1",e:5}],"-1#-608627190":[{m:"Eg10-e8",e:5}],"1#417606389":[{m:"Hb1-c3",e:5}],"-1#1253851576":[{m:"Hb10-a8",e:5}],"1#2818490":[{m:"a4-a5",e:5}],"-1#-697118257":[{m:"Hh10-g8",e:5}],"1#346696322":[{m:"Hb1-c3",e:5}],"-1#1190281679":[{m:"c7-c6",e:5}],"1#-2053784844":[{m:"Rh1-h5",e:5}],"-1#358495324":[{m:"Cb7-c7",e:5}],"-1#-432028412":[{m:"Hh10-g8",e:5}],"1#619134537":[{m:"Hb1-c3",e:5}],"-1#1992250628":[{m:"Hb10-a8",e:5}],"1#1009259782":[{m:"Ra1-b1",e:5}],"-1#176481786":[{m:"Ha8-c9",e:5}],"1#865879432":[{m:"Hb1-a3",e:8.75},{m:"g4-g5",e:8.75},{m:"Ri1-h1",e:8.75},{m:"Ri1-i2",e:8.75}],"-1#742586832":[{m:"Hb10-a8",e:6.667},{m:"Hh10-g8",e:6.667}],"1#1725282770":[{m:"Ri1-h1",e:5}],"1#-291896675":[{m:"Cb3-c3",e:5}],"-1#2136453989":[{m:"Ri10-i9",e:5}],"1#1056794369":[{m:"Ri1-h1",e:5}],"-1#878722097":[{m:"Hh10-g8",e:5}],"-1#956374712":[{m:"Hh10-g8",e:7.5}],"1#-69605899":[{m:"g4-g5",e:7.5},{m:"Hb1-a3",e:7.5}],"-1#-1223552232":[{m:"Hh10-g8",e:5}],"-1#1725434336":[{m:"Hh10-g8",e:5}],"1#-1543441747":[{m:"Ri2-d2",e:5}],"-1#170745422":[{m:"Ec10-e8",e:5}],"1#310571111":[{m:"Hb1-c3",e:8},{m:"Cb3-b7",e:8},{m:"Hh1-g3",e:8}],"-1#1088068394":[{m:"c7-c6",e:5}],"1#-2084741103":[{m:"Hh1-g3",e:5}],"-1#-872362535":[{m:"Hh10-g8",e:5}],"1#249050772":[{m:"Ri1-h1",e:5}],"-1#71658916":[{m:"Ri10-h10",e:5}],"1#1577324629":[{m:"Rh1-h5",e:5}],"-1#-825254147":[{m:"Ec10-e8",e:5}],"1#-497181154":[{m:"Cb3-b7",e:5}],"-1#-19851548":[{m:"Ch7-h6",e:5}],"1#-1619618464":[{m:"Cb7xg7",e:5}],"-1#1540122396":[{m:"Hb10-c8",e:5}],"1#1255962016":[{m:"g4-g5",e:5}],"-1#235829405":[{m:"c7-c6",e:5}],"1#-848723034":[{m:"g4-g5",e:5}],"-1#-2120059573":[{m:"Ec10-e8",e:5}],"1#-1389333080":[{m:"Hh1-g3",e:5}],"-1#-494020512":[{m:"Hh10-i8",e:5}],"1#1794568092":[{m:"Ri1-h1",e:5}],"-1#1617671340":[{m:"Ri10-h10",e:5}],"1#975882589":[{m:"Rh1xh7",e:5}],"-1#-479170248":[{m:"Rh10xh7",e:5}],"1#285418497":[{m:"Ce3xe7+",e:5}],"-1#1441809539":[{m:"Ad10-e9",e:5}],"1#-1187939214":[{m:"Ce7xh7",e:5}],"-1#1564433839":[{m:"Cb8-h8",e:6.667}],"1#-83965315":[{m:"Cb3-d3",e:6.667},{m:"Hb1-c3",e:6.667}],"-1#-1070692986":[{m:"Hb10-c8",e:5}],"1#-784427206":[{m:"Hb1-c3",e:5}],"-1#-2090402697":[{m:"Ra10-b10",e:5}],"1#-1156263186":[{m:"Ra1-a2",e:5}],"-1#844454469":[{m:"Rb10-b4",e:5}],"-1#-1465474768":[{m:"Hb10-c8",e:5}],"1#-1179208820":[{m:"Ra1-b1",e:5}],"-1#-1894104208":[{m:"Ra10-a9",e:5}],"1#-1757160911":[{m:"c4-c5",e:5}],"-1#1481696953":[{m:"Ra9-d9",
e:5}],"1#1503329026":[{m:"Hh1-g3",e:9.333}],"-1#371676874":[{m:"Ch8-d8",e:9.333},{m:"Hb10-c8",e:9.333},{m:"Cb8-f8",e:9.333}],"1#30736135":[{m:"Ri1-h1",e:9.231},{m:"Ce3xe7+",e:9.231},{m:"c4-c5",e:9.231},{m:"Hb1-c3",e:9.231}],"-1#189375543":[{m:"Hh10-g8",e:8.571}],"1#-913219718":[{m:"Hb1-a3",e:8.571}],"-1#1160224645":[{m:"Eg10-e8",e:6.667}],"1#-2038783110":[{m:"Ri1-h1",e:6.667}],"-1#-825769073":[{m:"Hh10-g8",e:6.667}],"1#203372738":[{m:"Ri1-h1",e:6.667}],"-1#1401721930":[{m:"Hh10-g8",e:6.667}],"1#-1856737529":[{m:"Ri1-h1",e:6.667}],"1#121062518":[{m:"Ri1-h1",e:6.667}],"-1#229252934":[{m:"Ch8-d8",e:6.667},{m:"Ch8-f8",e:6.667}],"1#442087051":[{m:"Hb1-c3",e:5}],"-1#1208081862":[{m:"Hh10-g8",e:5}],"1#-1965480309":[{m:"c4-c5",e:5}],"-1#1170872835":[{m:"Eg10-e8",e:5}],"1#-2036914436":[{m:"Hc3-d5",e:5}],"1#-827112081":[{m:"Hb1-a3",e:6.667},{m:"Cb3-d3",e:6.667}],"-1#-781321929":[{m:"Eg10-e8",e:5}],"-1#-194835820":[{m:"Hh10-g8",e:5}],"1#615108922":[{m:"Ri1-h1",e:5}],"-1#775195146":[{m:"Hh10-g8",e:5}],"1#-320048825":[{m:"Rh1-h7",e:5}],"-1#1443261242":[{m:"Hb10-c8",e:5}],"1#1192655238":[{m:"Cb3-b5",e:5}],"-1#1885284664":[{m:"Ri10-h10",e:5}],"1#706630857":[{m:"Hb1-c3",e:5}],"-1#2017869700":[{m:"g7-g6",e:5}],"1#219990265":[{m:"Ra1-b1",e:5}],"-1#1001404421":[{m:"Eg10-e8",e:5}],"1#-118684422":[{m:"e4-e5",e:5}],"-1#2137186742":[{m:"Ra10-b10",e:5}],"-1#2015197547":[{m:"g7-g6",e:7.5},{m:"Ch8-e8",e:7.5}],"1#222793238":[{m:"Hh1-g3",e:6.667}],"1#460589136":[{m:"Hh1-g3",e:5}],"-1#1422501272":[{m:"Hh10-g8",e:5}],"1#-1777246507":[{m:"Ri1-h1",e:5}],"-1#-1119856547":[{m:"Ch8-g8",e:9.967},{m:"Ec10-e8",e:9.967},{m:"Ch8-e8",e:9.967},{m:"Hb10-c8",e:9.967},{m:"Cb8-e8",e:9.967},{m:"Hb10-a8",e:9.967},{m:"Eg10-e8",e:9.967},{m:"Cb8-f8",e:9.967},{m:"g7-g6",e:9.967},{m:"Hh10-g8",e:9.967},{m:"Hh10-i8",e:9.967},{m:"c7-c6",e:9.967},{m:"Ch8-d8",e:9.967},{m:"Ch8-f8",e:9.967},{m:"Cb8-d8",e:9.967},{m:"Cb8-g8",e:9.967}],"1#-876906857":[{m:"i4-i5",e:5}],"-1#1973710583":[{m:"Ch8-g8",e:5}],"1#-35694325":[{m:"Hh1-i3",e:6.667}],"-1#-464430795":[{m:"Ri10-h10",e:6.667}],"1#-1106238268":[{m:"Ri1-h1",e:6.667}],"-1#-1265795084":[{m:"Cb8-f8",e:6.667},{m:"Rh10-h6",e:6.667}],"1#-2046560252":[{m:"Cb3-b5",e:5}],"-1#-1320507206":[{m:"Rh10-h4",e:5}],"1#1963673581":[{m:"Cb5-a5",e:5}],"-1#1478727189":[{m:"Hb10-a8",e:5}],"1#313841175":[{m:"Hb1-c3",e:5}],"-1#1089256794":[{m:"Ra10-b10",e:5}],"1#2023658435":[{m:"Ad1-e2",e:5}],"-1#932676291":[{m:"Ec10-e8",e:5}],"1#453345824":[{m:"Ca5-g5",e:5}],"-1#-429801443":[{m:"Cg8xg5",e:5}],"1#-2075336882":[{m:"g4xg5",e:5}],"-1#1334728817":[{m:"Rb10-b4",e:5}],"1#-1297505904":[{m:"c4-c5",e:5}],"-1#2109381912":[{m:"Cf8-f5",e:5}],"1#-1860979701":[{m:"Ch3-f3",e:5}],"-1#-1269833038":[{m:"Rh4xh1",e:5}],"1#1437513770":[{m:"Hi3xh1",e:5}],"-1#261287559":[{m:"Cf5xi5",e:5}],"1#1953449418":[{m:"Ra1-d1",e:5}],"-1#510529659":[{m:"a7-a6",e:5}],"1#441191801":[{m:"Hh1-g3",e:5}],"-1#1441898673":[{m:"Af10-e9",e:5}],"1#1499096099":[{m:"Rd1-d7",e:5}],"1#291161774":[{m:"Hb1-c3",e:5}],"-1#1124249059":[{m:"c7-c6",e:5}],"1#-2140842280":[{m:"Cb3-b5",e:5}],"-1#-1221851546":[{m:"Hb10-c8",e:5}],"1#-1506011942":[{m:"Cb5-h5",e:5}],"-1#-1329758848":[{m:"Rh6-d6",e:5}],"1#461682419":[{m:"Ra1-b1",e:5}],"-1#757614095":[{m:"Ra10-b10",e:5}],"1#358246550":[{m:"Rb1-b7",e:5}],"-1#898548533":[{m:"Ec10-e8",e:5}],"1#421315542":[{m:"Rh1-h2",e:5}],"-1#406418644":[{m:"i7-i6",e:5}],"1#399817227":[{m:"i5xi6",e:5}],"-1#-956651738":[{m:"Rd6xi6",e:5}],"1#1415170073":[{m:"Rh2-d2",e:5}],"-1#-1185549359":[{m:"Cb8-a8",e:5}],"1#1884798993":[{m:"Rb7-c7",e:5}],"-1#-1970634241":[{m:"g7-g6",e:5}],"1#-3115390":[{m:"Ch3-f3",e:5}],"-1#-628350917":[{m:"Cg8-f8",e:5}],"1#1924359081":[{m:"c4-c5",e:5}],"-1#-1113563359":[{m:"Rb10-c10",e:5}],"1#-839100892":[{m:"Ch5-d5",e:5}],"1#-1848485698":[{m:"Hb1-c3",e:8.75},{m:"Ch3-f3",e:8.75},{m:"Hh1-g3",e:8.75},{m:"c4-c5",e:8.75},{m:"g4-g5",e:8.75}],"-1#-1014352909":[{m:"c7-c6",e:5}],"1#15583432":[{m:"g4-g5",e:5}],"-1#1277574693":[{m:"Hb10-c8",e:5}],"-1#-1265758713":[{m:"Ri10-i9",e:5}],"1#-182134173":[{m:"Hh1-g3",e:5}],"-1#-1164347477":[{m:"Ri9-f9",e:5}],"1#-1361140151":[{m:"Ri1-h1",e:5}],"-1#-563088010":[{m:"Hb10-c8",e:5}],"1#-813701174":[{m:"g4-g5",e:5}],"-1#-2085351129":[{m:"Hh10-i8",e:5}],"1#198125275":[{m:"Hb1-c3",e:5}],"-1#1503088022":[{m:"c7-c6",e:5}],"-1#-585519533":[{m:"Hh10-i8",e:6.667}],"1#1432525231":[{m:"Hh1-g3",e:6.667}],"-1#450835559":[{m:"Ri10-i9",e:6.667},{m:"Ch8-f8",e:6.667}],"1#1534451715":[{m:"Ri1-i2",e:5}],"1#-567727770":[{m:"Hh1-g3",e:5}],"-1#-1852537682":[{m:"Hh10-g8",e:5}],"1#1397522403":[{m:"Ri1-h1",e:5}],"-1#1506878675":[{m:"Ri10-h10",e:5}],"1#59791650":[{m:"Hb1-c3",e:5}],"1#-1404024095":[{m:"c4-c5",e:8.571}],"-1#1665365609":[{m:"Ch8-e8",e:8.571},{m:"Cb8-a8",e:8.571},{m:"g7-g6",e:8.571}],"1#2754386":[{m:"Hb1-c3",e:5}],"-1#1383230495":[{m:"Hh10-g8",e:5}],"1#-1867868334":[{m:"Hh1-i3",e:5}],"-1#-1994090644":[{m:"Ri10-i9",e:5}],"1#-930200824":[{m:"Ch3-g3",e:5}],"-1#-697278674":[{m:"e7-e6",e:5}],"1#1956784729":[{m:"Cb3-b7",e:5}],"-1#1747886755":[{m:"e6-e5",e:5}],"1#-1438562903":[{m:"Hb1-c3",e:5}],"-1#-132567324":[{m:"Ra10-b10",e:5}],"1#-1066729347":[{m:"Ra1-b1",e:5}],"-1#-154668927":[{m:"Rb10-b6",e:5}],"1#-2049603305":[{m:"Cb3-a3",e:5}],"-1#-1236565893":[{m:"Rb6xb1",e:5}],"1#346600781":[{m:"Hc3xb1",e:5}],"-1#-1921782046":[{m:"Ch8-e8",e:5}],"1#370770196":[{m:"Hb1-c3",e:8},{m:"Ch3-h7",e:8},{m:"Hh1-g3",e:8}],"-1#1145170521":[{m:"Ec10-e8",e:6.667},{m:"Hh10-g8",e:6.667}],"-1#1646993326":[{m:"Hh10-g8",e:5}],"-1#1503931612":[{m:"Hh10-g8",e:5}],"1#-1998032907":[{m:"g4-g5",e:9.714},{m:"c4-c5",e:9.714},{m:"Hh1-g3",e:9.714},{m:"Hb1-c3",e:9.714},{m:"Hb1-d2",e:9.714}],"-1#-1004300008":[{m:"Hb10-c8",e:5}],"1#-718042204":[{m:"g4-g5",e:8.333}],"-1#1207653245":[{m:"Hb10-c8",e:7.5}],"1#1458258369":[{m:"Hb1-c3",e:7.5}],"-1#78850700":[{m:"Ra10-b10",e:8}],"1#1019282453":[{m:"Ra1-b1",e:8}],"-1#174978281":[{m:"Rb10-b4",e:8.75}],"-1#-950681027":[{m:"Hb10-c8",e:8.333}],"1#-700067711":[{m:"g4-g5",e:8.333},{m:"Hb1-c3",e:8.333},{m:"Ch3-i3",e:8.333}],"-1#-625998664":[{m:"Hb10-c8",e:9.6}],"1#-878701052":[{m:"Ra1-b1",e:9.6},{m:"Hb1-c3",e:7.5},{m:"Hb1-c3",e:8.333}],"-1#-49486088":[{m:"Ra10-a9",e:9.524}],"-1#1521450736":[{m:"Hb10-c8",e:5}],"1#1270836300":[{m:"Hh1-g3",e:5}],"-1#67289476":[{m:"Hh10-g8",e:5}],"1#-958776631":[{m:"g4-g5",e:5}],"-1#-1978545116":[{m:"Ri10-i9",e:9}],"1#-136898465":[{m:"g4-g5",e:6.667},{m:"Hb1-c3",e:6.667}],"-1#-1155731790":[{m:"Ra10-a9",e:5}],"1#-1555728397":[{m:"Hh1-g3",e:5}],"-1#-319235525":[{m:"Eg10-e8",e:5}],"1#799401668":[{m:"Ch3-i3",e:5}],"-1#1478371803":[{m:"g7-g6",e:5}],"1#759488166":[{m:"g5xg6",e:5}],"-1#1181337264":[{m:"Ra9-g9",e:5}],"1#-1385241002":[{m:"Ri1-h1",e:5}],"-1#-1477198490":[{m:"Rg9xg6",e:5}],"1#-1507760642":[{m:"Hg3-f5",e:5}],"-1#-254593383":[{m:"Rg6-f6",e:5}],"1#1611969099":[{m:"Rh1-h5",e:5}],"-1#-1517325550":[{m:"g7-g6",e:5}],"1#-791313297":[{m:"c4-c5",e:5}],"-1#533117159":[{m:"Hh10-g8",e:5}],"1#-585219158":[{m:"Hh1-g3",e:9.091},{m:"Hh1-i3",e:9.091}],"-1#-1834750366":[{m:"Cb8-d8",e:8},{m:"Ra10-a9",e:8},{m:"Eg10-e8",e:8}],"1#-1963296989":[{m:"a4-a5",e:5}],"-1#-997178476":[{m:"i7-i6",e:9.091},{m:"Eg10-e8",e:9.091},{m:"Ri10-i9",e:9.091}],"1#-2059757584":[{m:"Ad1-e2",e:5}],"1#2115855522":[{m:"Hb1-c3",e:8.333},{m:"c4-c5",e:8.333}],"-1#742723567":[{m:"Hh10-g8",e:6.667}],"1#-291638110":[{m:"c4-c5",e:6.667},{m:"Hh1-i3",e:6.667}],"-1#563005482":[{m:"Hh10-g8",e:7.5},{m:"Hb10-a8",e:6.667}],"1#1423195991":[{m:"Hc3-b5",e:9.5},{m:"Cb3-a3",e:9.5},{m:"Hh1-i3",e:9.5}],"-1#502714683":[{m:"Hg8-h6",e:5}],"1#-2143340108":[{m:"Cb3xb8",e:5}],"-1#1732916795":[{m:"Hb10-c8",e:5}],"1#1985619079":[{m:"Hh1-i3",e:5}],"-1#1297760105":[{m:"Hg8-h6",e:9.545},{m:"i7-i6",e:9.545}],"1#1796835368":[{m:"Ad1-e2",e:6.667},{m:"Hh1-i3",e:6.667}],"-1#605067560":[{m:"Ch8-i8",e:5}],"-1#-149687140":[{m:"Ch8-i8",e:5}],"1#-890071441":[{m:"Ri1-h1",e:5}],"-1#-1066414753":[{m:"Ri10-h10",e:5}],"1#-1708216146":[{m:"g4-g5",e:5}],"-1#-689617341":[{m:"c7-c6",e:5}],"-1#-1324459990":[{m:"g7-g6",e:7.5}],"1#-1001083049":[{m:"Hb1-c3",e:7.5}],"-1#-1777548262":[{m:"Hh10-g8",e:7.5}],"1#-1882267731":[{m:"Hb1-a3",e:9.868},{m:"Cb3-c3",e:9.868},{m:"g4-g5",e:9.868},{m:"Cb3-d3",e:9.868},{m:"Hh1-g3",e:9.868},{m:"c4-c5",e:9.868},{m:"Ra1-a2",e:9.868},{m:"Hh1-i3",e:9.868},{m:"Hb1-c3",e:9.868}],"-1#-1877974027":[{m:"Hb10-c8",e:5}],"1#-2130677431":[{m:"Hb1-a3",e:9.167}],"-1#-2061042508":[{m:"g7-g6",e:5}],"1#-260305975":[{m:"Ra1-a2",e:5}],"-1#-1023071936":[{m:"Hb10-c8",e:9.167}],"1#-770360324":[{m:"Hb1-a3",e:9.167}],"-1#-1256288170":[{m:"Hb10-c8",e:5}],"1#-1542552854":[{m:"Hb1-c3",e:5}],"-1#-1066175899":[{m:"g7-g6",e:8.75},{m:"Hb10-c8",e:8.75}],"-1#1088283429":[{m:"Hb10-c8",e:9}],"1#1372451225":[{m:"Cb3-d3",e:9}],"-1#110057222":[{m:"Hb10-c8",e:5}],"1#396314042":[{m:"Ra2-f2",e:5}],"-1#-1774133357":[{m:"Hb10-c8",e:5}],"1#-2024747729":[{m:"Ri1-i2",e:5}],"-1#-577325856":[{m:"Hb10-c8",e:9.773},{m:"c7-c6",e:9.773}],"1#-937775328":[{m:"Hh1-i3",e:9.545},{m:"Hb1-d2",e:9.545},{m:"c4-c5",e:9.545},{m:"Ch3-g3",e:9.545}],"-1#-778784994":[{m:"Cb8-e8",e:6.667},{m:"Eg10-e8",e:6.667}],"1#-465790794":[{m:"Ri1-i2",e:5}],"-1#-1317481250":[{m:"Hb10-c8",e:5}],"1#315200481":[{m:"Ri1-i2",e:5}],"-1#1200480137":[{m:"Eg10-e8",e:6.667}],"-1#442351141":[{m:"Cb8-e8",e:5}],"1#804620685":[{m:"Hd2-f3",e:5}],"-1#1356827043":[{m:"Hb10-c8",e:5}],"1#1104124703":[{m:"g4-g5",e:5}],"-1#218394098":[{m:"Ra10-b10",e:5}],"1#896942955":[{m:"Cb3-d3",e:5}],"-1#-689655034":[{m:"Eg10-e8",e:9.375},{m:"Hh10-i8",e:9.375},{m:"Ch8-e8",e:9.375},{m:"Ec10-e8",e:9.375}],"1#1587512570":[{m:"Hh1-i3",e:5}],"1#-1249000899":[{m:"g4-g5",e:5}],"1#2140709648":[{m:"Hb1-d2",e:9.767},{m:"c4-c5",e:9.767},{m:"Hb1-c3",e:9.767},{m:"g4-g5",e:9.767},{m:"Hh1-i3",e:9.767}],"-1#-1377848811":[{m:"Ch8-i8",e:5}],"1#-1874931482":[{m:"Ra1-c1",e:5}],"-1#880649898":[{m:"Ri10-h10",e:5}],"1#1849482075":[{m:"Ad1-e2",e:5}],"-1#767608925":[{m:"g7-g6",e:8},{m:"c7-c6",e:8}],"1#1486503712":[{m:"c4-c5",e:7.5}],"1#-291032218":[{m:"g4-g5",e:5}],"-1#861099517":[{m:"Ch8-i8",e:9.677},{m:"c7-c6",e:9.677},{m:"Cb8-e8",e:9.677}],"1#246560526":[{m:"Hh1-g3",e:6.667}],"1#-264982842":[{m:"Hh1-g3",e:8}],"-1#1712759598":[{m:"g7-g6",e:5}],"1#323769427":[{m:"Ec1-e3",e:5}],"1#893087649":[{m:"i4-i5",e:5}],"-1#-1960544319":[{m:"Ch8-g8",e:5}],"1#2116526950":[{m:"Hb1-c3",e:9.773},{m:"Hb1-d2",e:9.773},{m:"Ch3-f3",e:9.773},{m:"g4-g5",e:9.773},{m:"Hb1-a3",e:9.773},{m:"Cb3-c3",e:9.773},{m:"Ec1-e3",e:9.722},{m:"Ec1-e3",e:9.412}],"-1#746571819":[{m:"Hb10-c8",e:5}],"1#1030740631":[{m:"g4-g5",e:5}],"-1#-1402949021":[{m:"Ec10-e8",e:5}],"1#-2131578240":[{m:"Hh1-g3",e:5}],"-1#-816898232":[{m:"Hh10-i8",e:5}],"-1#1534850527":[{m:"Hb10-c8",e:6.667},{m:"Hh10-i8",e:6.667}],"1#1248585571":[{m:"Hh1-g3",e:5}],"1#-754925021":[{m:"Hh1-g3",e:5}],"-1#1643716414":[{m:"Hb10-c8",e:5}],"1#1894321538":[{m:"Hh1-g3",e:5}],"-1#1062510666":[{m:"Ec10-e8",e:5}],"1#331784361":[{m:"Cb3-d3",e:5}],"-1#1959755903":[{m:"Ec10-e8",e:8.889},{m:"Hb10-a8",e:8.889}],"1#1046003837":[{m:"Hh1-g3",e:5}],"1#-1431047792":[{m:"c4-c5",e:9.091},{m:"Hh1-g3",e:9.091},{m:"g4-g5",e:9.091},{m:"Hh1-i3",e:9.091}],"-1#-452043688":[{m:"Hh10-g8",e:6.667}],"1#668378901":[{m:"Ri1-h1",e:6.667}],"-1#759954469":[{m:"g7-g6",e:6.667}],"1#1477512024":[{m:"c4-c5",e:6.667}],"-1#-1761462320":[{m:"Ri10-i9",e:6.667},{m:"Ec10-e8",e:6.667}],"-1#-428341379":[{m:"Hh10-g8",e:7.5}],"1#614530096":[{m:"Ch3-f3",e:7.5},{m:"Hh1-g3",e:7.5}],"-1#33335945":[{m:"Hb10-c8",e:5}],"1#283949109":[{m:"Ri1-i2",e:5}],"-1#1797083640":[{m:"Ri10-h10",e:6.667}],"-1#-1287786066":[{m:"Hh10-g8",e:5}],"1#1910835939":[{m:"Ri1-i2",e:5}],"-1#614549131":[{m:"Ad10-e9",e:5}],"1#-933200262":[{m:"Ri2-d2",e:5}],"-1#1716376217":[{m:"Ec10-e8",e:5}],"1#1256182394":[{m:"Ch3-g3",e:5}],"1#2119762548":[{m:"Ri1-i2",e:9.787},{m:"Hh1-i3",e:9.787},{m:"g4-g5",e:9.787},{m:"c4-c5",e:9.787},{m:"Hh1-g3",e:9.787}],"-1#723340828":[{m:"Hh10-g8",e:9.286},{m:"Hh10-i8",e:9.286}],"1#-372918959":[{m:"Ri2-f2",e:8.75},{m:"Hh1-i3",e:8.75}],"1#-1553565216":[{m:"Ri2-f2",e:8.571}],"-1#1742144074":[{m:"Hh10-g8",e:8},{m:"i7-i6",e:8}],"1#-1525679865":[{m:"Ri1-h1",e:6.667}],"-1#-1349344713":[{m:"g7-g6",e:6.667}],"1#1748683925":[{m:"Ri1-h1",e:6.667}],"-1#848491673":[{m:"Hb10-c8",e:9.091},{m:"Hh10-i8",e:9.091}],"1#595781157":[{m:"Hh1-g3",e:5}],"1#-1159085211":[{m:"Hh1-g3",e:9}],"-1#-1320534276":[{m:"g7-g6",e:8},{m:"Hh10-g8",e:8}],"1#-1005532799":[{m:"Ch3-h7",e:7.5}],"1#1938998705":[{m:"Hh1-g3",e:5}],"-1#837070780":[{m:"Hh10-g8",e:9.375},{m:"g7-g6",e:9.375},{m:"Hh10-i8",e:9.375}],"1#1153325249":[{m:"Ch3-h9",e:9.091}],"1#-804926290":[{m:"c4-c5",e:9.167},{m:"g4-g5",e:9.167},{m:"Hb1-c3",e:9.167}],"-1#521596966":[{m:"Hb10-a8",e:6.667}],"1#1434562596":[{m:"Hb1-c3",e:6.667}],"-1#131717993":[{m:"Ra10-b10",e:6.667}],"1#1068234224":[{m:"Ra1-b1",e:6.667}],"-1#151454988":[{m:"Rb10-b6",e:6.667}],"1#2048228506":[{m:"Cb3-a3",e:6.667}],"-1#1233876470":[{m:"Rb6-f6",e:6.667},{m:"Rb6-d6",e:6.667}],"-1#-1664206269":[{m:"Hb10-c8",e:6.667},{m:"Hb10-a8",e:6.667}],"1#-1914820353":[{m:"Hh1-g3",e:5}],"-1#-1033665225":[{m:"Ra10-b10",e:5}],"1#-99505234":[{m:"Hg3-f5",e:5}],"1#-698779071":[{m:"Hb1-c3",e:5}],"-1#-2080304884":[{m:"Ra10-b10",e:5}],"1#-1133297771":[{m:"Ra1-b1",e:5}],"-1#-2107791389":[{m:"c7-c6",e:8.75},{m:"Hb10-c8",e:8.75}],"1#1094343896":[{m:"Ra1-b1",e:8.571},{m:"g4-g5",e:8.571}],"-1#2006363172":[{m:"Hb10-c8",e:5}],"1#-1823623841":[{m:"Ra1-b1",e:5}],"-1#-1511963229":[{m:"Ra10-b10",e:5}],"1#-1651283142":[{m:"g4-g5",e:5}],"1#-1269095836":[{m:"Ra1-a2",e:5}],"-1#1025157839":[{m:"Ra10-a8",e:5}],"1#-467797481":[{m:"g4-g5",e:5}],"-1#-1462366982":[{m:"Ra8-f8",e:5}],"1#-1356476892":[{m:"Hh1-g3",e:5}],"-1#-526883860":[{m:"Eg10-e8",e:5}],"1#600137491":[{m:"Ri1-i2",e:5}],"-1#1988170619":[{m:"Hb10-c8",e:5}],"1#1737556423":[{m:"Ra2-f2",e:5}],"-1#-709654293":[{m:"Hh10-f9",e:5}],"1#584246760":[{m:"c4-c5",e:5}],"-1#-306063008":[{m:"Ri10-g10",e:5}],"1#1249452329":[{m:"Hg3-f5",e:5}],"-1#478900814":[{m:"Rf8-f6",e:5}],"1#-2082893630":[{m:"Hf5-d4",e:5}],"-1#1514312584":[{m:"Rf6-h6",e:5}],"1#374525253":[{m:"Ch3-g3",e:5}],"-1#145543523":[{m:"Hf9-d8",e:5}],"1#-917707055":[{m:"Rf2-f7",e:5}],"-1#620618042":[{m:"g7-g6",e:5}],"1#1369904711":[{m:"Cb3-b7",e:5}],"-1#1294704317":[{m:"g6xg5",e:5}],"1#-672180598":[{m:"Rf7-g7",e:5}],"-1#1305104742":[{m:"Rh6-d6",e:5}],"1#-262124283":[{m:"Ri2-h2",e:5}],"-1#-1365447329":[{m:"g5-h5",e:5}],"1#-115464985":[{m:"Cb7xe7+",e:5}],"-1#2147088503":[{m:"Hh10-g8",e:6.667},{m:"g7-g6",e:6.667}],"1#-1121909958":[{m:"c4-c5",e:5}],"-1#1915895730":[{m:"g7-g6",e:5}],"1#124307663":[{m:"Hb1-c3",e:5}],"-1#1429250946":[{m:"Hb10-c8",e:5}],"1#1142993214":[{m:"Hh1-g3",e:5}],"-1#194845942":[{m:"Cb8-b4",e:5}],"1#-1236249102":[{m:"Hc3-b5",e:5}],"-1#-9258082":[{m:"Cb4xg4",e:5}],"1#18626063":[{m:"Eg1-e3",e:5}],"-1#-2021314339":[{m:"g6-g5",e:5}],"1#-32188822":[{m:"Ee3xg5",e:5}],"-1#-1831550626":[{m:"Hg8-f6",e:5}],"1#816125421":[{m:"Ch5-i5",e:5}],"-1#-621935761":[{m:"Ri10-h10",e:5}],"1#-2135982434":[{m:"Eg5-e3",e:5}],"-1#-818361733":[{m:"Ch8-h5",e:5}],"1#397283508":[{m:"Hb5xc7",e:5}],"-1#-461876831":[{m:"i7-i6",e:5}],"1#-342515842":[{m:"Hc7-d5",e:5}],"-1#-170873064":[{m:"Hf6-g8",e:5}],"1#1470200747":[{m:"Cb3-c3",e:5}],"-1#1565087922":[{m:"Hc8-b6",e:5}],"1#-2095280189":[{m:"c5-c6",e:5}],"-1#-322479745":[{m:"Hb6-c4",e:5}],"1#-1016687990":[{m:"Ri1-h1",e:5}],"-1#-906245702":[{m:"i6xi5",e:5}],"1#463508382":[{m:"i4xi5",e:5}],"-1#1923725709":[{m:"Ch5-h4",e:5}],"1#-1838452903":[{m:"Af1-e2",e:5}],"-1#-902658669":[{m:"Ra10-b10",e:5}],"1#-230642934":[{m:"c6-b6",e:5}],"-1#-1838602790":[{m:"Hc4xb6",e:5}],"1#-1858768871":[{m:"Ra1-b1",e:5}],"-1#-1483112219":[{m:"Hb6-c8",e:5}],"1#2043434900":[{m:"Rb1xb10",e:5}],"-1#-384415081":[{m:"Hc8xb10",e:5}],"1#1869811227":[{m:"Hd5-c7",e:5}],"-1#1899380349":[{m:"Ec10-e8",e:5}],"1#1571045022":[{m:"Rh1-f1",e:5}],"-1#1739115029":[{m:"Rh10-h6",e:5}],"1#-1031834801":[{m:"Rf1-f9",e:5}],"-1#418155545":[{m:"Rh6-f6",e:5}],"1#101100948":[{m:"Rf9-b9",e:5}],"-1#-1866416139":[{m:"Rf6-c6",e:5}],"1#1705539864":[{m:"Cc3-b3",e:5}],"-1#1866488321":[{m:"Rc6xc7",e:5}],"1#-1090947395":[{m:"Cb3xb10+",e:5}],"-1#1004888291":[{m:"Rc7-c10",e:5}],"1#99931759":[{m:"Rb9-h9",e:5}],"-1#2017346332":[{m:"Rc10xb10",e:5}],"1#1336003367":[{m:"Rh9xh4",e:5}],"-1#958696747":[{m:"Hg8-f6",e:5}],"1#-1688905320":[{m:"i5-i6",e:5}],"-1#-1790145163":[{m:"Rb10-b5",e:5}],"1#-818009397":[{m:"Hg3-f1",e:5}],"-1#2084935614":[{m:"Cg4xa4",e:5}],"1#-1924665693":[{m:"e4-e5",e:5}],"-1#180882415":[{m:"Ca4-a5",e:5}],"1#-346052645":[{m:"Rh4-f4",e:5}],"-1#1346478587":[{m:"Hf6-d7",e:5}],"1#1017641144":[{m:"Hf1-g3",e:5}],"-1#-1881389619":[{m:"Rb5xe5",e:5}],"1#1723362912":[{m:"Rf4-d4",e:5}],"-1#-1722382371":[{m:"Hd7-b8",e:5}],"1#-1266470946":[{m:"Rd4-d6",e:5}],"-1#398286476":[{m:"Hb8-c6",e:5}],"1#660768931":[{m:"Rd6-f6",e:5}],"-1#-1285103117":[{m:"Ca5-a6",e:5}],"1#298264309":[{m:"Rf6-f7",e:5}],"-1#-1767701255":[{m:"Ca6xi6",e:5}],"1#-1348248473":[],"1#178458378":[{m:"Hb1-c3",e:5}],"-1#1492870215":[{m:"c7-c6",e:5}],"1#-1684234372":[{m:"Eg1-e3",e:5}],"-1#486906286":[{m:"Hb10-c8",e:5}],"1#202738450":[{m:"Ch5-i5",e:5}],"-1#-430006896":[{m:"Hh10-i8",e:5}],"1#1847962220":[{m:"Ci5-e5+",e:5}],"-1#-564627324":[{m:"Eg10-e8",e:5}],"1#486884475":[{m:"Hh1-g3",e:5}],"-1#1387850163":[{m:"Af10-e9",e:5}],"1#1578315041":[{m:"g4-g5",e:5}],"-1#316201932":[{m:"g6xg5",e:5}],"1#-2011425797":[{m:"Ee3xg5",e:5}],"-1#-455342897":[{m:"Ch8-f8",e:5}],"1#667246310":[{m:"Hg3-f5",e:5}],"-1#1899433345":[{m:"Cb8-b5",e:5}],"1#1060523524":[{m:"c4-c5",e:5}],"-1#-265981300":[{m:"Cb5xe5+",e:5}],"1#77643676":[{m:"e4xe5",e:5}],"-1#775180654":[{m:"c6xc5",e:5}],"1#357335290":[{m:"Cb3-b8",e:5}],"-1#497044491":[{m:"c5-c4",e:5}],"1#901498500":[{m:"Hc3-e4",e:5}],"-1#138155273":[{m:"Hc8-d6",e:5}],"1#579780234":[{m:"Cb8xf8",e:5}],"-1#1676437237":[{m:"Hd6xe4",e:5}],"1#1034844798":[{m:"Cf8-h8",e:5}],"-1#-1594149636":[{m:"He4xg5",e:5}],"1#668752103":[{m:"Ra1-a3",e:5}],"-1#1171284046":[{m:"Ri10-f10",e:5}],"1#-872097910":[{m:"Hf5xe7",e:5}],"-1#-653188968":[{m:"Hg5-f3+",e:5}],"1#1134808825":[{m:"Ke1-e2",e:5}],"-1#-479202058":[{m:"Hf3-d4+",e:5}],"1#-2057246358":[{m:"Ra3-d3",e:5}],"-1#-1465756165":[{m:"Ra10-b10",e:5}],"1#-1865385118":[{m:"Ri1-i3",e:5}],"-1#890210654":[{m:"Rf10xf1",e:5}],"1#-1351870331":[{m:"Ri3-g3",e:5}],"-1#-196348869":[{m:"Rb10-b2+",e:5}],"1#1500901782":[{m:"Ke2-e3",e:5}],"-1#609483384":[{m:"Rf1-e1+",e:5}],"1#988288300":[],"-1#721084621":[{m:"Ec10-e8",e:9.986},{m:"Ch8-d8",e:9.986},{m:"Cb8-g8",e:9.986},{m:"Hh10-i8",e:9.986},{m:"Ch8-f8",e:9.986},{m:"Ch8-e8",e:9.986},{m:"Cb8-f8",e:9.986},{m:"Hb10-c8",e:9.986},{m:"g7-g6",e:9.986},{m:"Ri10-i9",e:9.986},{m:"Cb8-e8",e:9.986},{m:"Hh10-g8",e:9.986},{m:"c7-c6",e:9.986},{m:"Ch8-h7",e:9.986},{m:"Eg10-e8",e:9.986},{m:"Cb8-d8",e:9.986}],"1#107536430":[{m:"Hh1-g3",e:8.333},{m:"Hb1-c3",e:8.333},{m:"Cb3-e3",e:8.333}],"-1#1238715878":[{m:"Ri10-i9",e:7.5}],"1#142580098":[{m:"Hb1-c3",e:7.5},{m:"Ri1-h1",e:7.5}],"-1#1512567503":[{m:"Hh10-i8",e:5}],"1#-765672141":[{m:"Ri1-h1",e:5}],"-1#-658399741":[{m:"Ri9-f9",e:5}],"-1#48415410":[{m:"Ri9-f9",e:6.667}],"1#379917136":[{m:"Hb1-c3",e:6.667}],"-1#1412467555":[{m:"Hh10-i8",e:5}],"1#-599016289":[{m:"Hh1-g3",e:5}],"-1#-1812590249":[{m:"Ri10-h10",e:5}],"1#-910725978":[{m:"g4-g5",e:5}],"-1#-2055431605":[{m:"Hb10-c8",e:5}],"1#-1804826377":[{m:"Ri1-h1",e:5}],"-1#-1628318777":[{m:"c7-c6",e:5}],"1#1570121980":[{m:"Ec1-e3",e:9.333}],"-1#-1406634060":[{m:"Ri10-i9",e:5}],"1#-310205488":[{m:"Hb1-c3",e:5}],"-1#-1076180835":[{m:"Ri9-f9",e:5}],"1#-1415767681":[{m:"Ce3xe7+",e:5}],"-1#204678177":[{m:"Ad10-e9",e:5}],"1#-521003824":[{m:"Ad1-e2",e:5}],"-1#-1342501424":[{m:"Hb10-c8",e:5}],"1#-1091887252":[{m:"Ce7-e5",e:5}],"1#1024018688":[{m:"Hh1-g3",e:5}],"-1#1924457672":[{m:"Hh10-g8",e:5}],"1#-1335091323":[{m:"Ri1-h1",e:5}],"-1#-1158593355":[{m:"Ri10-i9",e:5}],"1#-77885231":[{m:"Hb1-c3",e:5}],"-1#-1459356772":[{m:"Ri9-f9",e:5}],"1#-1119606146":[{m:"Rh1-h5",e:5}],"-1#764388566":[{m:"c7-c6",e:5}],"1#-286760979":[{m:"Rh5-d5",e:5}],"-1#-170018228":[{m:"Hb10-c8",e:5}],"1#-456283920":[{m:"Rd5-d7",e:5}],"-1#27540926":[{m:"Ra10-a8",e:5}],"1#-660378266":[{m:"Ad1-e2",e:5}],"-1#-1750434714":[{m:"Af10-e9",e:5}],"1#-1694385932":[{m:"g4-g5",e:5}],"-1#-674607591":[{m:"Rf9-f6",e:5}],"1#1666952889":[{m:"Cb3-b5",e:5}],"-1#1410530823":[{m:"Cb8-b9",e:5}],"1#-1452721012":[{m:"Cb5-f5",e:5}],"-1#-436512475":[{m:"Rf6-d6",e:5}],"1#1307935914":[{m:"Rd7xd6",e:5}],"-1#-1382126133":[{m:"Hc8xd6",e:5}],"1#1630289947":[{m:"Ra1-b1",e:5}],"-1#1468051687":[{m:"Cb9-c9",e:5}],"1#-207128799":[{m:"Ec1-e3",e:5}],"-1#1094818056":[{m:"a7-a6",e:5}],"1#1164149770":[{m:"Rb1-b9",e:5}],"1#601987828":[{m:"c4-c5",e:5}],"-1#-319641988":[{m:"Hh10-i8",e:5}],"1#1686737280":[{m:"i4-i5",e:5}],"-1#-627668512":[{m:"Ra10-a8",e:5}],"1#59889976":[{m:"Hh1-i3",e:5}],"-1#438294790":[{m:"Ra8-f8",e:5}],"1#502012888":[{m:"Ad1-e2",e:5}],"-1#1390742232":[{m:"Hb10-c8",e:5}],"1#1140136036":[{m:"Hb1-c3",e:5}],"-1#296579881":[{m:"Cg8-g9",e:5}],"1#2047396322":[{m:"Ec1-e3",e:5}],"-1#-923916341":[{m:"Rf8-f6",e:5}],"1#1471989063":[{m:"Ri1-h1",e:5}],"-1#1562484343":[{m:"Ri10-h10",e:5}],"1#123790214":[{m:"Ra1-d1",e:5}],"-1#1835120183":[{m:"i7-i6",e:5}],"1#1653373160":[{m:"i5xi6",e:5}],"-1#-1281202747":[{m:"Rf6xi6",e:5}],"1#-1807623296":[{m:"Rh1-h5",e:5}],"-1#76174632":[{m:"Ri6-b6",e:5}],"1#2054219061":[{m:"Hc3-d5",e:5}],"-1#1345526536":[{m:"Hi8-h6",e:5}],"1#-2024194250":[{m:"Rh5-i5",e:5}],"-1#-963194982":[{m:"g7-g6",e:5}],"1#-1278461721":[{m:"Ri5-i9",e:5}],"-1#-167698323":[{m:"Cg9-g7",e:5}],"1#-1444144065":[{m:"Ri9-f9",e:5}],"1#-1568549071":[{m:"c4-c5",e:9.545},{m:"g4-g5",e:9.545},{m:"Hh1-i3",e:9.545},{m:"Hh1-g3",e:9.545},{m:"Cb3-e3",e:9.545}],"-1#1838345145":[{m:"Ri10-h10",e:5}],"1#936613448":[{m:"Hh1-g3",e:5}],"-1#2020490112":[{m:"Cb8-e8",e:6.667},{m:"Ch8-g8",e:6.667}],"-1#-297131556":[{m:"Ri10-i9",e:5}],"1#-1344211528":[{m:"Hh1-g3",e:5}],"-1#-530753424":[{m:"Ri9-f9",e:5}],"1#-199587438":[{m:"Ad1-e2",e:5}],"-1#-1156589809":[{m:"Ri10-h10",e:5}],"1#-514938114":[{m:"Ri1-h1",e:5}],"-1#-338431538":[{m:"Cb8-e8",e:5}],"1#-562313626":[{m:"Hb1-c3",e:5}],"-1#-1943818965":[{m:"Hb10-c8",e:5}],"-1#-314803463":[{m:"Ri10-h10",e:9.444},{m:"Hh10-i8",e:9.375},{m:"Hh10-i8",e:9.474},{m:"g7-g6",e:9.444}],"1#-1399411043":[{m:"Ri1-h1",e:6.667}],"1#-541917943":[{m:"Ri1-h1",e:9.5},{m:"Cb3-e3",e:9.5},{m:"c4-c5",e:9.5}],"-1#146882731":[{m:"Cb8-e8",e:5}],"1#1030321923":[{m:"Hb1-c3",e:5}],"-1#1865489486":[{m:"Hb10-c8",e:5}],"1#2116095730":[{m:"Hh1-g3",e:5}],"-1#832348986":[{m:"Ri10-h10",e:5}],"1#-370951452":[{m:"g4-g5",e:8},{m:"Hb1-c3",e:8},{m:"Hh1-i3",e:8}],"-1#-1524085751":[{m:"Hh10-i8",e:5}],"1#760445941":[{m:"Hh1-g3",e:5}],"-1#1659819581":[{m:"Ri10-h10",e:5}],"1#951036876":[{m:"Hb1-c3",e:5}],"-1#1794621569":[{m:"c7-c6",e:5}],"1#-1450165318":[{m:"Cb3-a3",e:5}],"-1#-1710345514":[{m:"Hb10-c8",e:5}],"1#-1960959894":[{m:"Ra1-b1",e:5}],"-1#-1145318999":[{m:"Hh10-g8",e:5}],"1#2036542180":[{m:"Hh1-i3",e:5}],"-1#1626155738":[{m:"Ri10-h10",e:5}],"1#984373035":[{m:"Ri1-i2",e:5}],"-1#1877482307":[{m:"Cb8-e8",e:5}],"1#1514155243":[{m:"Ri2-d2",e:5}],"-1#-194150392":[{m:"Hb10-c8",e:5}],"1#-444755276":[{m:"Ra1-b1",e:5}],"-1#-741252536":[{m:"c7-c6",e:5}],"-1#-261244198":[{m:"Hh10-g8",e:6.667},{m:"g7-g6",e:6.667}],"1#850739607":[{m:"Ri1-h1",e:5}],"-1#942152359":[{m:"c7-c6",e:5}],"1#-78650980":[{m:"c4-c5",e:5}],"-1#878501140":[{m:"c6xc5",e:5}],"1#-2059973209":[{m:"Ri1-h1",e:8}],"-1#-1884678505":[{m:"Hh10-g8",e:8}],"1#1234407926":[{m:"Ch3-f3",e:9.091},{m:"Cb3-e3",e:9.583}],"-1#-472709524":[{m:"Hh10-g8",e:6.667}],"1#554433825":[{m:"Hb1-c3",e:6.667}],"-1#1934857836":[{m:"Hb10-a8",e:6.667}],"1#969201262":[{m:"Ra1-b1",e:6.667},{m:"Hh1-g3",e:6.667}],"-1#258483858":[{m:"Ra10-b10",e:5}],"1#924452875":[{m:"Hh1-g3",e:5}],"-1#2024252867":[{m:"Ri10-h10",e:5}],"1#585553970":[{m:"Rb1-b5",e:5}],"-1#2051598857":[{m:"Rh10-h6",e:5}],"-1#1987672998":[{m:"Ri10-h10",e:5}],"1#741869143":[{m:"g4-g5",e:5}],"-1#1626599610":[{m:"Cb8-c8",e:5}],"1#-334644520":[{m:"Ra1-b1",e:5}],"1#410281789":[{m:"g4-g5",e:9.792},{m:"Hh1-g3",e:9.792},{m:"Hh1-i3",e:9.792},{m:"c4-c5",e:9.792},{m:"Cb3-e3",e:9.792},{m:"Hb1-c3",e:9.792}],"-1#1421840848":[{m:"Hh10-i8",e:5}],"1#-591092180":[{m:"Hh1-g3",e:5}],"-1#-1820783644":[{m:"c7-c6",e:5}],"1#1344205023":[{m:"Hb1-c3",e:5}],"-1#1472842485":[{m:"Hh10-i8",e:9.474}],"-1#33187587":[{m:"Hh10-i8",e:7.5}],"1#-1988013825":[{m:"Ri1-h1",e:7.5}],"-1#-2095313969":[{m:"Ri10-h10",e:7.5}],"-1#-681092171":[{m:"Hb10-c8",e:9}],"1#-965261047":[{m:"Hb1-c3",e:9},{m:"Hh1-g3",e:9}],"-1#-1305153369":[{m:"Hb10-c8",e:5}],"1#-1557863909":[{m:"Hb1-c3",e:5}],"-1#-243496618":[{m:"Ec10-e8",e:5}],"1#-571569739":[{m:"Ra1-b1",e:5}],"-1#1244400752":[{m:"Hb10-c8",e:9.375}],"1#1530666700":[{m:"Hh1-g3",e:9.375},{m:"Ra1-b1",e:9.375}],"1#1005253233":[{m:"c4-c5",e:8.333},{m:"Hh1-g3",e:8.333}],"-1#-184955143":[{m:"Cb8-a8",e:5}],"1#1039924537":[{m:"Hb1-c3",e:5}],"-1#1872991860":[{m:"Ra10-b10",e:5}],"1#1473362157":[{m:"Ra1-b1",e:5}],"-1#1635600401":[{m:"Rb10-b6",e:5}],"1#309277063":[{m:"Cb3-a3",e:5}],"-1#569456875":[{m:"Rb6xb1",e:5}],"1#-2095968803":[{m:"Hc3xb1",e:5}],"-1#449402482":[{m:"g7-g6",e:5}],"1#1871945999":[{m:"Hh1-i3",e:5}],"-1#1981653297":[{m:"Hh10-g8",e:5}],"1#-1262134660":[{m:"Ri1-h1",e:5}],"-1#1951883193":[{m:"Hh10-i8",e:8},{m:"Ch8-f8",e:8}],"1#-64198587":[{m:"Ri1-h1",e:7.5},{m:"g4-g5",e:7.5}],"-1#-156159115":[{m:"Ri10-h10",e:5}],"1#-1393537404":[{m:"c4-c5",e:5}],"-1#-1326997848":[{m:"c7-c6",e:6.667},{m:"Ri10-h10",e:6.667}],"1#-1219623536":[{m:"Ri1-h1",e:5}],"-1#-1110221152":[{m:"Hh10-g8",e:5}],"1#2131469805":[{m:"g4-g5",e:5}],"-1#868242176":[{m:"c7-c6",e:6.667},{m:"Eg10-e8",e:6.667}],"1#1604327344":[{m:"Cb3-e3",e:9.947},{m:"Hh1-i3",e:9.947},{m:"Ch3-f3",e:9.924},{m:"c4-c5",e:9.947}],"-1#-169836502":[{m:"Hh10-g8",e:8.889},{m:"Cb8-e8",e:8.889},{m:"Hb10-c8",e:8.889}],"1#926448487":[{m:"Hh1-g3",e:8.333}],"1#-1068976254":[{m:"Hh1-i3",e:5}],"1#-453995882":[{m:"Hh1-i3",e:6.667}],"-1#1177425806":[{m:"Ch8-d8",e:9.943},{m:"Ch8-h4",e:9.943},{m:"Cb8-e8",e:9.943},{m:"g7-g6",e:8.571},{m:"Ch8-e8",e:9.943},{m:"g7-g6",e:6.667}],"-1#-1867306184":[{m:"Hh10-g8",e:8}],"1#1382797429":[{m:"Hh1-i3",e:8},{m:"Hb1-c3",e:8},{m:"Hh1-g3",e:8}],"-1#1273352267":[{m:"Ri10-h10",e:6.667}],"-1#3390264":[{m:"Ri10-h10",e:6.667}],"1#1800418473":[{m:"Hb1-c3",e:9.655},{m:"Hh1-i3",e:9.655},{m:"g4-g5",e:9.655},{m:"Cb3-e3",e:9.655},{m:"Hh1-g3",e:9.655}],"-1#956850148":[{m:"Hb10-c8",e:6.667},{m:"Ri9-f9",e:6.667}],"1#672681304":[{m:"c4-c5",e:5}],"1#760188422":[{m:"Ad1-e2",e:5}],"-1#1927165079":[{m:"Ri9-f9",e:8.75},{m:"Ch8-e8",e:8.75},{m:"Ec10-e8",e:8.75}],"1#1721361781":[{m:"Ad1-e2",e:8.333}],"1#297223596":[{m:"Hb1-c3",e:5}],"-1#664519236":[{m:"Ri9-f9",e:5}],"1#870060966":[{m:"Ad1-e2",e:5}],"-1#2094334630":[{m:"Hh10-i8",e:5}],"1#-189909670":[{m:"Cb3-e3",e:5}],"-1#-1055874253":[{m:"Hb10-c8",e:7.5}],"1#-805260913":[{m:"Hb1-c3",e:7.5}],"-1#-2108106046":[{m:"Ri9-f9",e:7.5},{m:"Ra10-b10",e:7.5}],"1#-1171590053":[{m:"Ra1-b1",e:5}],"-1#619551073":[{m:"Ri9-f9",e:9.375},{m:"Hh10-i8",e:9.375}],"1#816466051":[{m:"Ad1-e2",e:9.333}],"1#525522789":[{m:"Cb3-e3",e:9.967},{m:"Hh1-g3",e:9.967},{m:"Ch3-f3",e:9.333}],"-1#-1257094913":[{m:"Ce8xe4+",e:9},{m:"Ra10-a9",e:9},{m:"Hb10-c8",e:9}],"1#-142665394":[{m:"Af1-e2",e:7.5}],"-1#-1356401788":[{m:"Ch8-e8",e:7.5}],"1#-1387537986":[{m:"Hh1-g3",e:5}],"-1#-487164810":[{m:"Ra9-f9",e:5}],"1#-1543351741":[{m:"Hb1-c3",e:8.333}],"-1#-161859314":[{m:"Hh10-g8",e:8.333}],"-1#1357871789":[{m:"Hb10-c8",e:5}],"1#1107257361":[{m:"Hb1-c3",e:5}],"-1#329712476":[{m:"Ra10-b10",e:9.946},{m:"Ri10-i9",e:9.946},{m:"Ch8-g8",e:9.946},{m:"g7-g6",e:9.946},{m:"Hh10-i8",e:9.946}],"1#735391173":[{m:"Ri1-h1",e:8.571}],"1#1376638776":[{m:"Ri1-h1",e:5}],"1#1700539798":[{m:"Ri1-h1",e:5}],"1#-400417920":[{m:"Hh1-i3",e:9.877},{m:"Hh1-g3",e:9.877},{m:"c4-c5",e:9.877},{m:"Hb1-c3",e:9.877},{m:"g4-g5",e:9.877}],"-1#-240378946":[{m:"Cb8-e8",e:8.571},{m:"Ri10-h10",e:8.571},{m:"g7-g6",e:8.571}],"1#-1410505137":[{m:"Ri1-h1",e:8}],"-1#-1482705336":[{m:"Ri10-h10",e:8.75},{m:"g7-g6",e:8.75}],"1#-35730503":[{m:"Ri1-h1",e:8.571},{m:"g4-g5",e:8.571}],"1#-758824651":[{m:"Ri1-h1",e:5}],"-1#657532680":[{m:"Hb10-a8",e:5}],"1#1839621898":[{m:"Hb1-c3",e:5}],"-1#1073613895":[{m:"Eg10-e8",e:5}],"1#-56414024":[{m:"Hh1-i3",e:5}],"-1#-1166380851":[{m:"Ri10-h10",e:5}],"1#-533000900":[{m:"Hh1-g3",e:5}],"-1#-1350131468":[{m:"g7-g6",e:5}],"1#-623093879":[{m:"c4-c5",e:5}],"-1#-1528173203":[{m:"c7-c6",e:9.848},{m:"Cb8-e8",e:9.848},{m:"Ri10-h10",e:9.848},{m:"Ch8-i8",e:9.848}],"1#-1857955131":[{m:"Hb1-c3",e:9.091}],"1#-375579658":[{m:"Hh1-g3",e:9.583},{m:"Hh1-i3",e:9.583},{m:"Cb3-e3",e:9.583},{m:"Ch3-f3",e:9.981}],"-1#-1507805634":[{m:"Hh10-g8",e:9.412},{m:"Hb10-c8",e:9.412},{m:"Hh10-i8",e:9.412}],"1#1693994355":[{m:"Cb3-e3",e:8.889}],"1#-1221548926":[{m:"Ri1-h1",e:5}],"1#777748930":[{m:"Hb1-c3",e:8.75}],"-1#-267183160":[{m:"Hh10-g8",e:6.667}],"1#852222085":[{m:"Ri1-h1",e:6.667}],"-1#945208245":[{m:"Ri10-h10",e:6.667}],"1#1645725252":[{m:"Rh1-h5",e:6.667}],"-1#-220444436":[{m:"Hb10-c8",e:6.667},{m:"Ch8-i8",e:6.667}],"-1#1138592876":[{m:"Hb10-c8",e:5}],"1#1389207248":[{m:"Hb1-c3",e:5}],"-1#9827741":[{m:"Ra10-b10",e:7.5},{m:"Ri10-i9",e:7.5}],"1#954718980":[{m:"Hh1-g3",e:6.667}],"1#1094656505":[{m:"Hh1-g3",e:5}],"1#1833512762":[{m:"Hb1-c3",e:5}],"-1#1058096247":[{m:"c7-c6",e:5}],"1#-59326644":[{m:"Hh1-g3",e:5}],"-1#-1278537084":[{m:"Cb8-h8",e:5}],"1#336233814":[{m:"Cb3-b8",e:5}],"-1#484854183":[{m:"Ec10-a8",e:5}],"1#-1209158682":[{m:"Ra1-b1",e:5}],"-1#-2126429414":[{m:"Hb10-d9",e:5}],"1#-1956430848":[{m:"g4-g5",e:5}],"-1#-945239315":[{m:"Ra10-b10",e:5}],"1#-2431884":[{m:"Cb8-b7",e:5}],"-1#-160983282":[{m:"Hh10-i8",e:5}],"1#2115805426":[{m:"Ec1-e3",e:5}],"-1#-856011045":[{m:"Ri10-h10",e:5}],"1#-1766116566":[{m:"Ri1-i2",e:5}],"-1#-1006665918":[{m:"Ch8-f8",e:5}],"1#1265457169":[{m:"Ri2-d2",e:5}],"-1#-448727822":[{m:"Rb10-b9",e:5}],"1#-1172870354":[{m:"Cf3-f5",e:5}],"-1#1164559675":[{m:"Eg10-e8",e:5}],"1#-2043348540":[{m:"g5-g6",e:5}],"-1#-466061609":[{m:"Ch7-h2",e:5}],"1#1238596070":[{m:"g6xg7",e:5}],"-1#1946786013":[{m:"Rh10-h3",e:5}],"1#-590297951":[{m:"Rd2-g2",e:5}],"-1#-2125660298":[{m:"Ch2-h1",e:5}],"1#625087221":[{m:"Ad1-e2",e:5}],"1#-374875086":[{m:"Hh1-g3",e:6.667},{m:"Hh1-i3",e:6.667}],"-1#-1508216326":[{m:"Hh10-f9",e:5}],"1#1367022841":[{m:"Ri1-h1",e:5}],"-1#1541818313":[{m:"c7-c6",e:5}],"1#-1736327950":[{m:"Hb1-c3",e:5}],"-1#-891693121":[{m:"Hb10-c8",e:5}],"1#-607533821":[{m:"Rh1-h5",e:5}],"-1#1258441643":[{m:"Ch8-g8",e:5}],"1#1039754593":[{m:"Ec1-e3",e:5}],"-1#-1893758136":[{m:"Ri10-h10",e:5}],"1#-715196743":[{m:"Rh5-f5",e:5}],"-1#-360175211":[{m:"Hf9-d8",e:5}],"1#728243751":[{m:"g4-g5",e:5}],"-1#-265692148":[{m:"Hh10-g8",e:5}],"1#854665025":[{m:"Ri1-h1",e:5}],"-1#946633841":[{m:"Ri10-h10",e:5}],"1#1647116672":[{m:"Rh1-h5",e:5}],"-1#-219771096":[{m:"Hb10-a8",e:5}],"1#-1200500950":[{m:"Hb1-c3",e:5}],"-1#-366369689":[{m:"Ra10-a9",e:5}],"1#-227525338":[{m:"Cb3-a3",e:5}],"-1#-1041353654":[{m:"Ra9-f9",e:5}],"1#116931780":[{m:"Ra1-b1",e:5}],"-1#810863672":[{m:"Cb8-c8",e:5}],"1#-1129675174":[{m:"i4-i5",e:5}],"-1#45456954":[{m:"g7-g6",e:5}],"1#1203729470":[{m:"Hh1-g3",e:5}],"-1#134404598":[{m:"Hh10-g8",e:5}],"1#-891673925":[{m:"Ri1-h1",e:5}],"-1#-1069057653":[{m:"Ri10-h10",e:5}],"1#-1710881670":[{m:"g4-g5",e:5}],"-1#-691146089":[{m:"c7-c6",e:5}],"1#363465132":[{m:"Cb3-e3",e:5}],"-1#-1075143114":[{m:"Ec10-e8",e:5}],"1#-1820811563":[{m:"Hb1-c3",e:5}],"-1#-1054804584":[{m:"Hb10-c8",e:5}],"1#-802101468":[{m:"Ra1-b1",e:5}],"-1#-425977896":[{m:"Ch8-h4",e:5}],"1#-1022022478":[{m:"Hg3-f5",e:5}],"-1#-1779990571":[{m:"Ch4xc4",e:5}],"1#1822311773":[{m:"Rh1xh10",e:5}],"-1#-1981001260":[{m:"Hg8xh10",e:5}],"1#-712414659":[{m:"Ce3xe7+",e:5}],"-1#1915180899":[{m:"Ad10-e9",e:5}],"1#-1629065326":[{m:"Ec1-e3",e:5}],"-1#738230715":[{m:"i7-i6",e:5}],"1#602754916":[{m:"i4-i5",e:5}],"-1#-1645062396":[{m:"i6xi5",e:5}],"1#-1079482353":[{m:"Rb1-b4",e:5}],"-1#-271705259":[{m:"Hh10-g8",e:5}],"1#756473880":[{m:"Ce7-e6",e:5}],"-1#-688775875":[{m:"Cc4-c5",e:5}],"1#-703218714":[{m:"Ee3xc5",e:5}],"-1#896989583":[{m:"Hb10-a8",e:9.923},{m:"c7-c6",e:9.923},{m:"Ch8-d8",e:9.923
},{m:"Cb8-e8",e:9.923},{m:"Ra10-a9",e:9.923},{m:"Ch8-e8",e:9.923},{m:"Eg10-e8",e:9.923},{m:"Hb10-c8",e:9.923},{m:"g7-g6",e:9.923}],"1#2145499533":[{m:"a4-a5",e:8},{m:"Ch3-e3",e:8},{m:"Hb1-c3",e:8}],"-1#1368333505":[{m:"Ra10-b10",e:5}],"1#1778201176":[{m:"Hb1-a3",e:5}],"-1#1982041600":[{m:"Ch8-e8",e:5}],"1#357236539":[{m:"Hh1-g3",e:5}],"-1#1526158067":[{m:"Hh10-g8",e:5}],"1#-1741706818":[{m:"Ri1-h1",e:5}],"-1#-1833766258":[{m:"Ri10-h10",e:5}],"1#-923562113":[{m:"Ra1-b1",e:5}],"-1#-27295869":[{m:"Rh10-h6",e:5}],"1#1535690457":[{m:"Eg1-e3",e:5}],"-1#-586039285":[{m:"a7-a6",e:5}],"1#-650912503":[{m:"a5xa6",e:5}],"-1#1315908326":[{m:"Rh6xa6",e:5}],"1#-1533757149":[{m:"Rb1-b7",e:5}],"-1#-2076175744":[{m:"Cb8-c8",e:5}],"1#146692322":[{m:"Rb7xb10",e:5}],"-1#628502633":[{m:"Hh10-g8",e:5}],"1#-407975132":[{m:"Hb1-c3",e:5}],"-1#-1242128279":[{m:"Ra10-b10",e:5}],"1#-1920692496":[{m:"Hh1-g3",e:5}],"-1#-1036442824":[{m:"Ri10-h10",e:5}],"1#-1736941879":[{m:"Ri1-h1",e:5}],"-1#-1830484487":[{m:"g7-g6",e:5}],"1#-406850940":[{m:"Rh1-h7",e:5}],"-1#1565911289":[{m:"Cb8-d8",e:5}],"1#806386698":[{m:"a4-a5",e:5}],"-1#511629638":[{m:"Eg10-e8",e:5}],"1#-584849991":[{m:"a5-a6",e:5}],"-1#2085368997":[{m:"a7xa6",e:5}],"1#1874486613":[{m:"Ra1xa6",e:5}],"-1#896897881":[{m:"Ha8-b6",e:5}],"-1#767152832":[{m:"Ra10-b10",e:6.667},{m:"c7-c6",e:6.667}],"1#365689945":[{m:"Ra1-b1",e:5}],"-1#593956005":[{m:"Ch8-e8",e:5}],"1#1074691486":[{m:"Hh1-g3",e:5}],"-1#263442518":[{m:"Hh10-g8",e:5}],"1#-848614629":[{m:"Ri1-h1",e:9.375}],"-1#-940150741":[{m:"Ri10-i9",e:9.375},{m:"Ri10-h10",e:9.375}],"1#-287430149":[{m:"Ch3-e3",e:5}],"-1#-1270243297":[{m:"Ch8-e8",e:5}],"1#-685715164":[{m:"Hh1-g3",e:5}],"-1#-1734509332":[{m:"Hh10-g8",e:5}],"1#1514506145":[{m:"Ri1-h1",e:5}],"-1#1356389521":[{m:"Ri10-i9",e:5}],"1#-166657356":[{m:"Hh1-g3",e:9.75},{m:"g4-g5",e:9.75},{m:"Hb1-a3",e:9.75}],"-1#-1179865220":[{m:"Hb10-c8",e:8}],"1#-1464025664":[{m:"Hb1-c3",e:8},{m:"Hh1-g3",e:5}],"-1#-85666163":[{m:"Ra10-b10",e:6.667}],"1#-1030293484":[{m:"g4-g5",e:6.667},{m:"Ra1-b1",e:6.667}],"-1#-1906503943":[{m:"Ch8-e8",e:6.667}],"1#-315326526":[{m:"Ri1-h1",e:6.667},{m:"Ad1-e2",e:6.667}],"-1#-408345358":[{m:"Hh10-g8",e:5}],"-1#-197523224":[{m:"Hh10-i8",e:5}],"1#2084650772":[{m:"g4-g5",e:5}],"-1#814402041":[{m:"Ch8-h4",e:5}],"1#352580243":[{m:"Hg3-h5",e:5}],"-1#612410642":[{m:"Ch4xc4",e:5}],"-1#-461944019":[{m:"Hh10-g8",e:7.5},{m:"Ra10-b10",e:7.5}],"1#649048160":[{m:"Hb1-c3",e:5}],"-1#1962400557":[{m:"Ra10-b10",e:5}],"1#1283847604":[{m:"Ra1-b1",e:5}],"-1#2049508680":[{m:"Af10-e9",e:5}],"1#1988280794":[{m:"Rb1-b5",e:5}],"-1#774697953":[{m:"Cb8-a8",e:5}],"1#-603626060":[{m:"g4-g5",e:6.667},{m:"Ec1-e3",e:6.667}],"-1#1860406173":[{m:"Eg10-e8",e:5}],"1#-1380010142":[{m:"Hb1-c3",e:5}],"-1#-1647569":[{m:"Cb8-a8",e:5}],"1#920973295":[{m:"Ch3-i3",e:5}],"-1#-1160055719":[{m:"Hb10-c8",e:5}],"1#-1412765979":[{m:"Hh1-g3",e:5}],"-1#-372261140":[{m:"Cb8-f8",e:9.714},{m:"Cb8-b4",e:9.714},{m:"Hb10-c8",e:9.714},{m:"Cb8-e8",e:9.714}],"1#-616482532":[{m:"Ra1-b1",e:5}],"-1#-303183392":[{m:"Hb10-c8",e:5}],"1#-50472100":[{m:"g4-g5",e:5}],"1#1409480680":[{m:"Hh1-g3",e:6.667}],"-1#465525280":[{m:"Hb10-c8",e:6.667}],"1#179259548":[{m:"Ra1-a2",e:6.667}],"1#-119559088":[{m:"g4-g5",e:9.667},{m:"Hh1-g3",e:9.667}],"1#-597194428":[{m:"Hh1-g3",e:6.667}],"-1#-1814420340":[{m:"Hb10-c8",e:6.667}],"1#-2100677072":[{m:"Ra1-b1",e:6.667}],"1#579162178":[{m:"Hh1-g3",e:8.889},{m:"g4-g5",e:8.889},{m:"Hb1-c3",e:8.889}],"-1#1832451466":[{m:"Hh10-g8",e:8.333}],"1#-1344272697":[{m:"Hh1-g3",e:5},{m:"Ri1-h1",e:8.333},{m:"Hb1-c3",e:8.333}],"-1#-483659734":[{m:"Hb10-a8",e:6.667},{m:"Ri10-h10",e:6.667}],"1#-1447251928":[{m:"Hb1-c3",e:5}],"-1#-68887707":[{m:"Ra10-b10",e:6.667}],"1#-1013516804":[{m:"Ra1-b1",e:6.667},{m:"Hg3-h5",e:6.667}],"-1#-180747008":[{m:"Ri10-h10",e:5}],"1#-1350862607":[{m:"Ri1-h1",e:5}],"-1#-233463171":[{m:"Cb8-c8",e:5}],"1#2129389599":[{m:"Eg1-e3",e:5}],"-1#-126685491":[{m:"c7-c6",e:5}],"1#-1184199205":[{m:"Ri1-h1",e:5}],"-1#-1275603221":[{m:"Rh10-h6",e:5}],"1#371224497":[{m:"Ch3-i3",e:5}],"-1#1637589166":[{m:"Rh6-f6",e:5}],"1#2138145059":[{m:"Hb1-c3",e:5}],"-1#757721710":[{m:"Hb10-a8",e:5}],"-1#-1518510601":[{m:"Ri10-h10",e:7.5},{m:"Hb10-a8",e:7.5}],"1#-12836858":[{m:"Ch3-h7",e:6.667},{m:"Hb1-a3",e:6.667}],"1#-269869579":[{m:"g4-g5",e:5}],"-1#-1558058216":[{m:"Ra10-b10",e:5}],"-1#-38244982":[{m:"Hb10-a8",e:5}],"1#-1221644920":[{m:"c4-c5",e:5}],"-1#2017202432":[{m:"Ri10-h10",e:5}],"1#578645233":[{m:"Ri1-h1",e:5}],"-1#685782977":[{m:"g7-g6",e:5}],"1#1572520124":[{m:"Ra1-b1",e:5}],"-1#1850648239":[{m:"Hh10-g8",e:5}],"1#-1399431710":[{m:"Hh1-g3",e:5}],"-1#1893546767":[{m:"Hb10-a8",e:6.667}],"1#977959693":[{m:"g4-g5",e:6.667},{m:"Ra1-b1",e:6.667}],"-1#1988201952":[{m:"Hh10-g8",e:5}],"1#-1269205331":[{m:"Hb1-c3",e:5}],"-1#216435697":[{m:"Ra10-b10",e:5}],"1#882156904":[{m:"Hh1-g3",e:5}],"-1#2066286752":[{m:"Hh10-g8",e:5}],"1#-1175325715":[{m:"Ri1-h1",e:5}],"-1#-1284724515":[{m:"Ri10-h10",e:5}],"1#-382872276":[{m:"Ri1-h1",e:5}],"1#14601767":[{m:"Hh1-g3",e:8.75}],"1#758079694":[{m:"Hb1-a3",e:8},{m:"Hh1-g3",e:8},{m:"Hb1-c3",e:8}],"-1#854711446":[{m:"Ra9-d9",e:5}],"1#1566687541":[{m:"Eg1-e3",e:5}],"-1#-604452889":[{m:"Cb8-e8",e:5}],"1#-296685489":[{m:"Ra1-b1",e:5}],"-1#-654573389":[{m:"Hb10-c8",e:5}],"1#-907275761":[{m:"Rb1-b7",e:5}],"-1#-382158420":[{m:"Ce8xe4+",e:5}],"1#-1420435427":[{m:"Af1-e2",e:5}],"-1#-217314601":[{m:"Ch8-f8",e:5}],"1#806703358":[{m:"Rb7xc7",e:5}],"-1#1144680498":[{m:"Eg10-e8",e:5}],"1#-2023273267":[{m:"Hh1-f2",e:5}],"-1#-1322086820":[{m:"Ce4-e6",e:5}],"1#-151707673":[{m:"Hf2-e4",e:5}],"-1#1818281377":[{m:"Rd9-d4",e:5}],"-1#1653787910":[{m:"Ra9-d9",e:5}],"1#218288293":[{m:"Hh1-g3",e:6.667}],"-1#1599781864":[{m:"Hb10-a8",e:7.5},{m:"Rd9-d6",e:7.5},{m:"Eg10-e8",e:7.5}],"1#365820906":[{m:"Ra1-b1",e:5}],"-1#593562390":[{m:"Cb8-c8",e:5}],"1#-1348517516":[{m:"Ad1-e2",e:5}],"-1#-527019916":[{m:"Ch8-e8",e:5}],"1#-2080431793":[{m:"Ri1-h1",e:5}],"-1#-1990034817":[{m:"Hh10-g8",e:5}],"1#1270513970":[{m:"Ch3-i3",e:5}],"-1#1006718509":[{m:"c7-c6",e:5}],"1#-1735455442":[{m:"Ra1-b1",e:5}],"-1#-1373372974":[{m:"Eg10-e8",e:5}],"1#1837023533":[{m:"Af1-e2",e:5}],"-1#891759591":[{m:"Hb10-a8",e:5}],"1#2142268389":[{m:"Rb1-b5",e:5}],"-1#656300510":[{m:"Cb8-d8",e:5}],"1#1247530285":[{m:"g4-g5",e:5}],"-1#110115776":[{m:"Cd8xd3",e:5}],"1#-1677228265":[{m:"Ra1-b1",e:5}],"-1#-1431603221":[{m:"Hb10-a8",e:5}],"1#-532924439":[{m:"Af1-e2",e:5}],"-1#-1201283805":[{m:"a7-a6",e:5}],"1#-1136148447":[{m:"c4-c5",e:5}],"-1#1934949545":[{m:"Rd9-d6",e:5}],"1#-1266595217":[{m:"Rb1-b7",e:5}],"-1#-1806310964":[{m:"g7-g6",e:5}],"-1#2138508163":[{m:"Ra9-d9",e:6.667}],"1#283579936":[{m:"Hh1-g3",e:6.667}],"1#1444907188":[{m:"Hh1-g3",e:9.787},{m:"Ch3-e3",e:9.787}],"-1#430056828":[{m:"Hh10-g8",e:9.762},{m:"c7-c6",e:9.762},{m:"Hb10-a8",e:9.762}],"1#-612704719":[{m:"Ri1-h1",e:9.737},{m:"Hb1-c3",e:9.737}],"-1#-773356287":[{m:"Ri10-h10",e:9.167}],"1#-1951991568":[{m:"Hb1-c3",e:9.167}],"-1#-1994214020":[{m:"Hb10-c8",e:9.63},{m:"Hb10-a8",e:9.63}],"1#-624566713":[{m:"Hb1-c3",e:6.667}],"-1#-2002930422":[{m:"Cb8-c8",e:6.667}],"1#73662312":[{m:"Ra1-b1",e:6.667},{m:"Ec1-e3",e:6.667}],"-1#852430740":[{m:"Hb10-a8",e:5}],"-1#-1232793279":[{m:"Hh10-g8",e:5}],"1#1952311820":[{m:"Ra1-b1",e:5}],"1#1396008318":[{m:"Ri1-h1",e:6.667},{m:"Hb1-c3",e:6.667}],"-1#1504198222":[{m:"Hh10-g8",e:5}],"1#-1687108349":[{m:"Ch3-i3",e:5}],"-1#23924275":[{m:"c7-c6",e:5}],"1#-1039469304":[{m:"Ra1-b1",e:5}],"-1#-190446092":[{m:"Hb10-a8",e:5}],"-1#210239824":[{m:"Hb10-c8",e:8.333},{m:"Hh10-g8",e:8.333}],"1#496505836":[{m:"Hh1-g3",e:5}],"-1#1378205220":[{m:"Hb10-c8",e:8.333}],"1#-833553891":[{m:"Hh1-g3",e:8}],"1#-164903568":[{m:"Cb3-d3",e:5},{m:"Hb1-c3",e:7.5},{m:"c4-c5",e:7.5}],"-1#-1535922627":[{m:"Cb8-c8",e:5}],"1#680387679":[{m:"Ra1-b1",e:5}],"-1#505484451":[{m:"Hb10-a8",e:5}],"1#1421235361":[{m:"Ch3-e3",e:5}],"-1#237100357":[{m:"Hh10-g8",e:5}],"1#-856087032":[{m:"Hh1-g3",e:5}],"-1#-2092659776":[{m:"Ri10-h10",e:5}],"1#-653920719":[{m:"Ri1-h1",e:5}],"-1#-744968959":[{m:"Ch8-h4",e:5}],"1#-166619541":[{m:"Af1-e2",e:5}],"-1#-1370981215":[{m:"g7-g6",e:5}],"1#-619541540":[{m:"c4-c5",e:5}],"-1#335656788":[{m:"Ra10-b10",e:5}],"1#745773517":[{m:"Rb1xb10",e:5}],"-1#-1129741106":[{m:"Ha8xb10",e:5}],"1#1632342780":[{m:"Hc3-d5",e:5}],"-1#1258843329":[{m:"c7-c6",e:5}],"1#-2005952518":[{m:"Hd5xe7",e:5}],"-1#1604009457":[{m:"c6xc5",e:5}],"1#1692658789":[{m:"Ec1-a3",e:5}],"-1#-875939686":[{m:"c5-c4",e:5}],"1#-472796651":[{m:"He7xg6",e:5}],"-1#-1439733407":[{m:"Ch4-h6",e:5}],"1#-1447944584":[{m:"Cd3-d8",e:5}],"1#610724659":[{m:"Hb1-c3",e:9.286},{m:"Hb1-a3",e:9.286},{m:"c4-c5",e:9.286}],"-1#1983807614":[{m:"Ra10-b10",e:6.667}],"1#1313648359":[{m:"c4-c5",e:6.667},{m:"Ra1-b1",e:6.667}],"-1#-2124443025":[{m:"Cb8-a8",e:8.75},{m:"g7-g6",e:8.75}],"1#1214095791":[{m:"Hh1-g3",e:8.333}],"-1#132123751":[{m:"g7-g6",e:8.333},{m:"Hh10-g8",e:8.333}],"-1#2027970075":[{m:"Ch8-f8",e:5}],"1#-1141308366":[{m:"Rb1-b7",e:5}],"-1#-1691504751":[{m:"Ri10-i9",e:5}],"1#-628655115":[{m:"c4-c5",e:5}],"-1#362039165":[{m:"Ri9-d9",e:5}],"1#-359600446":[{m:"Af1-e2",e:5}],"-1#-1295449080":[{m:"Rd9-d4",e:5}],"1#-1546340403":[{m:"Ch3-e3",e:5}],"-1#-113033687":[{m:"Hh10-g8",e:5}],"-1#1001936747":[{m:"Ra10-b10",e:7.5}],"1#63601138":[{m:"Ra1-b1",e:7.5},{m:"Eg1-e3",e:7.5}],"-1#895912206":[{m:"Ch8-e8",e:6.667},{m:"Hh10-g8",e:6.667}],"1#1443887157":[{m:"Hh1-g3",e:5}],"-1#431117821":[{m:"Cb8-b3",e:5}],"1#-138513853":[{m:"Ch3-e3",e:5}],"-1#-1389757529":[{m:"Ri10-h10",e:5}],"-1#-2058125536":[{m:"c7-c6",e:5}],"1#1177846811":[{m:"Hh1-g3",e:5}],"-1#159984083":[{m:"Hh10-g8",e:6.667}],"1#-883830114":[{m:"Ra1-a2",e:6.667}],"-1#1108367925":[{m:"Ec10-e8",e:6.667},{m:"Cb8-a8",e:6.667}],"-1#-344598597":[{m:"Ra10-b10",e:8.889},{m:"g7-g6",e:8.889},{m:"Hh10-i8",e:8.889}],"1#-754452190":[{m:"c4-c5",e:6.667}],"1#1661919303":[{m:"Hb1-c3",e:5}],"-1#827755274":[{m:"i7-i6",e:5}],"1#1052460501":[{m:"Ra1-b1",e:5}],"-1#135771433":[{m:"Hi8-h6",e:5}],"1#1076629234":[{m:"Hb1-a3",e:8.333},{m:"c4-c5",e:8.333},{m:"Hb1-c3",e:8.333}],"-1#309618111":[{m:"Hh10-g8",e:7.5},{m:"Hb10-c8",e:7.5}],"1#-793993486":[{m:"Ra1-b1",e:5}],"-1#-436179442":[{m:"Cb8-d8",e:5}],"1#-1958348035":[{m:"Rb1-b5",e:5}],"-1#-739522362":[{m:"Hb10-a8",e:5}],"1#-1719891772":[{m:"g4-g5",e:5}],"-1#-709394903":[{m:"g6xg5",e:5}],"1#1332983326":[{m:"Rb5xg5",e:5}],"1#56915715":[{m:"Ra1-b1",e:6.667},{m:"c4-c5",e:6.667}],"-1#902334463":[{m:"Ra10-b10",e:5}],"1#230336870":[{m:"Ra1-b1",e:8.333}],"-1#566760248":[{m:"g7-g6",e:8.571},{m:"Cb8-e8",e:8.571}],"1#1418912837":[{m:"Hh1-g3",e:8.333},{m:"c4-c5",e:8.333},{m:"Hb1-a3",e:8.333},{m:"Ch3-g3",e:8.333},{m:"Eg1-e3",e:8.333}],"-1#-1685989171":[{m:"Hh10-g8",e:5}],"1#1499014016":[{m:"Ch3-e3",e:5}],"-1#63875684":[{m:"Ri10-h10",e:5}],"1#1502599061":[{m:"Hb1-c3",e:5}],"-1#198687960":[{m:"Ch8-i8",e:5}],"1#909565483":[{m:"Hh1-g3",e:5}],"-1#2039182307":[{m:"Ec10-e8",e:5}],"1#1427731200":[{m:"Hc3-d5",e:5}],"-1#2136640829":[{m:"Hb10-d9",e:5}],"1#1970860583":[{m:"Ri1-h1",e:5}],"-1#2145757463":[{m:"Rh10xh1",e:5}],"1#1201154985":[{m:"Hg3xh1",e:5}],"-1#1268240626":[{m:"Cb8-b5",e:5}],"1#93754231":[{m:"Cb3-d3",e:5}],"-1#1061608588":[{m:"Cb5xd5",e:5}],"1#-1535257226":[{m:"Cd3xd9",e:5}],"-1#-1590999764":[{m:"Ad10-e9",e:5}],"1#1307213277":[{m:"Ra1-b1",e:5}],"-1#2068221217":[{m:"Cd5xa5",e:5}],"1#-686202394":[{m:"Hh1-g3",e:5}],"-1#-1734030290":[{m:"Ra10-d10",e:5}],"1#1586154820":[{m:"Rb1-b9",e:5}],"-1#2079456577":[{m:"a7-a6",e:5}],"1#2144591939":[{m:"Ce3-d3",e:5}],"-1#-1143256306":[{m:"Rd10-c10",e:5}],"1#903572984":[{m:"Rb9-b6",e:5}],"-1#1729615473":[{m:"Ca5-a4",e:5}],"1#-2038400443":[{m:"Rb6-b4",e:5}],"-1#-1588493677":[{m:"Ca4-a2",e:5}],"1#1279453487":[{m:"Af1-e2",e:5}],"-1#337314789":[{m:"Hg8-f6",e:5}],"1#-1234512042":[{m:"Rb4-a4",e:5}],"-1#1193904765":[{m:"Ca2-c2",e:5}],"1#-2010196046":[{m:"Ra4xa6",e:5}],"-1#1488308290":[{m:"Hf6xg4",e:5}],"1#-1173633229":[{m:"Cd3-e3",e:5}],"-1#2114153598":[{m:"Hg4xe3",e:5}],"1#-1723429565":[{m:"Eg1xe3",e:5}],"-1#-1145083408":[{m:"c7-c6",e:5}],"1#2027459275":[{m:"c5xc6",e:5}],"-1#1196157215":[{m:"Rc10xc6",e:5}],"1#-1296726309":[{m:"Ra6xc6",e:5}],"-1#-1942838759":[{m:"Ee8xc6",e:5}],"1#-1304822429":[{m:"Hg3-f5",e:5}],"-1#1263294493":[{m:"Hb10-c8",e:5}],"1#1515997857":[{m:"Hh1-g3",e:5}],"-1#1248655459":[{m:"Cb8-e8",e:5}],"1#2143604683":[{m:"Ec1-e3",e:5}],"-1#-853401118":[{m:"Hh10-i8",e:5}],"1#1163466270":[{m:"Hh1-i3",e:5}],"-1#1557599776":[{m:"Ri10-h10",e:5}],"1#110521297":[{m:"Ri1-h1",e:5}],"-1#202060001":[{m:"Ch8-h4",e:5}],"1#696388491":[{m:"Hb1-a3",e:5}],"-1#912046035":[{m:"Hb10-c8",e:5}],"1#659334511":[{m:"Ha3-b5",e:5}],"-1#602446870":[{m:"c7-c6",e:5}],"1#-527472851":[{m:"Ad1-e2",e:5}],"-1#-1350142419":[{m:"Af10-e9",e:5}],"1#-1557286209":[{m:"i4-i5",e:5}],"-1#489859807":[{m:"Ce8xe4",e:5}],"1#1600123758":[{m:"Cg3xg6",e:5}],"-1#1007417626":[{m:"Ce4-e5",e:5}],"1#-1464944187":[{m:"Cg6-g5",e:5}],"-1#-225825685":[{m:"Eg10-e8",e:5}],"1#836178068":[{m:"Cg5-h5",e:5}],"-1#1929018655":[{m:"Ch4xc4",e:5}],"1#-1954330729":[{m:"Ra1-c1",e:5}],"-1#801124827":[{m:"Cc4-f4",e:5}],"1#-324983415":[{m:"Rc1-c4",e:5}],"-1#1978409211":[{m:"Cf4-f8",e:5}],"1#-752506849":[{m:"Rc4-e4",e:5}],"-1#-1477111280":[{m:"Ce5xi5",e:5}],"1#31842891":[{m:"Ch5-h8",e:5}],"-1#1706246884":[{m:"c6-c5",e:5}],"1#-342267771":[{m:"Hb5-c7",e:5}],"-1#-1765979982":[{m:"Ra10-b10",e:5}],"1#-1362139605":[{m:"Cb3-c3",e:5}],"-1#-1540930254":[{m:"Ci5xa5",e:5}],"1#936695767":[{m:"Re4-a4",e:5}],"-1#-195102950":[{m:"Ca5-a6",e:5}],"1#1459564572":[{m:"Hc7xa6",e:5}],"-1#40079276":[{m:"Hc8-b6",e:5}],"1#-600418083":[{m:"Ra4-b4",e:5}],"-1#762643958":[{m:"c5-c4",e:5}],"1#91131769":[{m:"Rb4-b5",e:5}],"-1#276560233":[{m:"c4xc3",e:5}],"1#224235405":[{m:"Ha6-b4",e:5}],"-1#-1817237315":[{m:"Hb6-c8",e:5}],"1#1308295116":[{m:"Rb5xb10",e:5}],"-1#-770973033":[{m:"Hh10-g8",e:5}],"1#282270170":[{m:"Hb1-a3",e:5}],"-1#252552578":[{m:"Hb10-a8",e:5}],"1#1167779200":[{m:"Ra1-a2",e:5}],"-1#-858034901":[{m:"Eg10-e8",e:5}],"1#260461012":[{m:"Ra2-f2",e:6.667},{m:"Ra2-g2",e:6.667}],"-1#-1113270024":[{m:"Ra10-a9",e:8}],"1#-1510129223":[{m:"Rf2-f5",e:8.571},{m:"Rf2-f7",e:8.571},{m:"Af1-e2",e:8.571},{m:"Ha3-b5",e:8.571}],"-1#2089258914":[{m:"Af10-e9",e:5}],"1#1881951024":[{m:"Hh1-g3",e:5}],"-1#1066526456":[{m:"Ra9-d9",e:5}],"-1#1212958290":[{m:"Ch8-h10",e:6.667}],"1#1955764682":[{m:"Ha3-b5",e:6.667}],"-1#1882628275":[{m:"Cb8-d8",e:6.667}],"-1#-39539853":[{m:"Ch8-i8",e:5}],"1#-1069168256":[{m:"Ha3-b5",e:5}],"-1#-991825671":[{m:"Cb8-d8",e:5}],"-1#-1587971904":[{m:"Cb8-d8",e:6.667}],"1#-870519757":[{m:"Hh1-g3",e:6.667},{m:"Rf2-f5",e:6.667}],"-1#-2086583813":[{m:"Ch8-h6",e:5}],"-1#-822979642":[{m:"Ra10-a9",e:6.667}],"1#-693384569":[{m:"g4-g5",e:6.667}],"-1#-1704969110":[{m:"g6xg5",e:6.667}],"1#10810461":[{m:"Rg2xg5",e:6.667}],"-1#688488167":[{m:"Ch8-h10",e:8.333},{m:"Ra9-f9",e:8.333}],"1#366453119":[{m:"Ha3-b5",e:8},{m:"Hh1-g3",e:8}],"-1#292788230":[{m:"Ch10-g10",e:6.667}],"1#-1935091279":[{m:"Rg5-h5",e:6.667}],"-1#1516899511":[{m:"Ch10-g10",e:6.667}],"1#-944681728":[{m:"Rg5-f5",e:6.667}],"1#-299927959":[{m:"Ha3-b5",e:6.667}],"-1#-356823280":[{m:"Cb8-d8",e:6.667}],"1#-2013340701":[{m:"Hh1-g3",e:6.667}],"-1#-935102933":[{m:"Ch8-h10",e:6.667},{m:"Af10-e9",e:6.667}],"1#-190993997":[{m:"Rg5-d5",e:5}],"1#-991382855":[{m:"Af1-e2",e:5}],"1#341845136":[{m:"Ch3-e3",e:5}],"-1#1324854644":[{m:"Hh10-g8",e:5}],"1#-1943054791":[{m:"Hh1-g3",e:5}],"-1#-1013777423":[{m:"Ri10-h10",e:5}],"1#-1714190848":[{m:"Ri1-h1",e:5}],"-1#-1823548112":[{m:"Ch8-h4",e:5}],"1#-1228413350":[{m:"Hb1-c3",e:5}],"-1#-459305705":[{m:"Hb10-c8",e:5}],"1#-175136853":[{m:"Ra1-b1",e:5}],"-1#-1021087913":[{m:"Ra10-b10",e:5}],"1#-78560818":[{m:"Cb3-b7",e:5}],"-1#-404895436":[{m:"c7-c6",e:5}],"1#616182287":[{m:"Af1-e2",e:5}],"-1#2095306949":[{m:"g7-g6",e:5}],"1#163131320":[{m:"Cb7-c7",e:5}],"-1#1749595067":[{m:"Ec10-a8",e:5}],"1#-1019000326":[{m:"Rb1xb10",e:5}],"-1#1402557689":[{m:"Hc8xb10",e:5}],"1#-704901003":[{m:"Cc7-d7",e:5}],"-1#620324301":[{m:"Ad10-e9",e:5}],"1#-935830212":[{m:"Rh1-h2",e:5}],"-1#-920786370":[{m:"g6-g5",e:5}],"1#-1332999031":[{m:"Hg3-i2",e:5}],"-1#-1976569850":[{m:"Ch4-h3",e:5}],"1#1519928180":[{m:"Ae2-f3",e:5}],"-1#88424941":[{m:"Ch3xe3",e:5}],"1#-1063315601":[{m:"Rh2xh10",e:5}],"-1#957711253":[{m:"Hg8xh10",e:5}],"1#1701886076":[{m:"Eg1xe3",e:5}],"-1#1052669238":[{m:"g5xg4",e:5}],"1#359308219":[{m:"Cd7-d4",e:5}],"-1#-950762368":[{m:"Hh10-g8",e:5}],"1#93093837":[{m:"Cd4xg4",e:5}],"-1#665087455":[{m:"Hg8-f6",e:5}],"1#-2049590932":[{m:"Cg4-g3",e:5}],"-1#71453032":[{m:"Hb10-c8",e:5}],"1#357718996":[{m:"Hi2-h4",e:5}],"-1#-1407686420":[{m:"Hc8-d6",e:5}],"1#-2035629201":[{m:"Af3-e2",e:5}],"-1#-646462986":[{m:"Hd6xc4",e:5}],"1#1705871101":[{m:"Hh4-f5",e:5}],"-1#-1330243027":[{m:"Ce8-c8",e:5}],"1#339562646":[{m:"Hc3-a2",e:5}],"-1#1286153318":[{m:"Hc4xa5",e:5}],"1#-2143916340":[{m:"Hf5-d6",e:5}],"-1#1851668834":[{m:"Cc8-c7",e:5}],"1#1906482493":[{m:"Ee3-g5",e:5}],"-1#1043671512":[{m:"Eg10-e8",e:5}],"1#-43510489":[{m:"Cg3-e3",e:5}],"-1#231508960":[{m:"Ha5-c4",e:5}],"1#1536844329":[{m:"Hd6xc4",e:5}],"-1#-2013233331":[{m:"Cc7xc4",e:5}],"1#-1842769358":[{m:"e4-e5",e:5}],"-1#363231102":[{m:"Hf6-e4",e:5}],"1#-444217961":[{m:"Ec1-a3",e:5}],"-1#1252790632":[{m:"Cc4-a4",e:5}],"1#1069644527":[{m:"Ha2-c1",e:5}],"-1#522638823":[{m:"Ca4xi4",e:5}],"1#133286240":[{m:"Hc1-b3",e:5}],"-1#-1286098278":[{m:"Ci4-i3",e:5}],"1#1901800141":[{m:"Hb3-d2",e:5}],"-1#1032974471":[{m:"Ci3xa3",e:5}],"1#-994263389":[{m:"Ae2-f3",e:5}],"-1#-1688093638":[],"-1#1085253492":[{m:"Hb10-c8",e:8},{m:"Ec10-e8",e:8},{m:"c7-c6",e:8}],"1#1371518408":[{m:"c4-c5",e:5}],"-1#-1632859840":[{m:"g7-g6",e:5}],"1#-336167363":[{m:"Hb1-c3",e:5}],"-1#-1179773584":[{m:"Hh10-g8",e:5}],"1#2071391805":[{m:"Hh1-i3",e:5}],"-1#1660481027":[{m:"Ec10-e8",e:5}],"1#1315630816":[{m:"Ec1-e3",e:5}],"-1#-57933623":[{m:"i7-i6",e:6.667},{m:"Cb8-a8",e:6.667}],"1#-211694058":[{m:"Ch3-f3",e:5}],"-1#-700606289":[{m:"Hg8-h6",e:5}],"1#1274310688":[{m:"Ra1-d1",e:5}],"-1#569714065":[{m:"Ad10-e9",e:5}],"1#-852222624":[{m:"Cb3-b6",e:5}],"-1#1542353676":[{m:"c7-c6",e:5}],"1#-1735817161":[{m:"c5xc6",e:5}],"-1#-1491405853":[{m:"Hc8xb6",e:5}],"1#-1567517872":[{m:"c6xb6",e:5}],"-1#521868549":[{m:"Ra10-c10",e:5}],"1#1256719848":[{m:"Rd1-d7",e:5}],"-1#-38890206":[{m:"Ri10-i7",e:5}],"1#945942524":[{m:"Hc3-d5",e:5}],"-1#304222657":[{m:"Rc10-c4",e:5}],"1#-1663436338":[{m:"b6-b7",e:5}],"-1#-1241420429":[{m:"Cb8-d8",e:5}],"1#-616236672":[{m:"Hd5-c7",e:5}],"-1#-989738522":[{m:"Rc4xe4",e:5}],"1#1667509359":[{m:"b7xa7",e:5}],"-1#1722251263":[{m:"g6-g5",e:5}],"1#523669832":[{m:"Rd7-d6",e:5}],"-1#536255855":[{m:"Hh6-f5",e:5}],"1#-1608057983":[{m:"Rd6-d5",e:5}],"-1#611844393":[{m:"Re4xa4",e:5}],"1#1339030832":[{m:"g4xg5",e:5}],"-1#542353420":[{m:"Hf5-d4",e:5}],"1#-1205490434":[{m:"Cf3-f2",e:5}],"-1#1571686144":[{m:"Ri7-f7",e:5}],"1#1537007114":[{m:"Cf2-g2",e:5}],"-1#-2019483934":[{m:"Rf7-f2",e:5}],"1#-517782381":[{m:"Rd5-c5",e:5}],"-1#1564799244":[{m:"Ra4-a1+",e:5}],"1#-1375146942":[{m:"Ee3-c1",e:5}],"-1#485360235":[{m:"Cd8-c8",e:5}],"1#-527897717":[{m:"Hc7-a8",e:5}],"-1#562815259":[{m:"Cc8xc1",e:5}],"1#1949063269":[{m:"Rc5-c10+",e:5}],"-1#-154483413":[{m:"Ae9-d10",e:5}],"1#436993498":[{m:"Ha8-c9+",e:5}],"-1#2007063362":[{m:"Ke10-e9",e:5}],"1#1445814503":[{m:"Hc9-d7+",e:5}],"-1#771136080":[{m:"Ke9-f9",e:5}],"1#1248670144":[{m:"Rc10-c9+",e:5}],"-1#101512258":[{m:"Af10-e9",e:5}],"1#178729168":[{m:"Ke1-d1",e:5}],"-1#838115488":[{m:"Cc1xf1+",e:5}],"1#1761263482":[{m:"Kd1-d2",e:5}],"-1#2050206609":[{m:"Rf2xe2+",e:5}],"1#1053671834":[{m:"Kd2-d3",e:5}],"-1#-357978643":[{m:"Ra1-d1+",e:5}],"1#-231912478":[],"1#898511625":[{m:"Hc3-b5",e:5}],"-1#2091703653":[{m:"Hg8-f6",e:5}],"1#-555939370":[{m:"Ch3-h6",e:5}],"-1#-1198722310":[{m:"Hf6-g8",e:5}],"1#452798025":[{m:"Ch6-h7",e:5}],"-1#356742318":[{m:"c7-c6",e:5}],"1#-702247019":[{m:"c5xc6",e:5}],"-1#-373820351":[{m:"Ee8xc6",e:5}],"1#828801544":[{m:"Ri1-i2",e:5}],"-1#1680002656":[{m:"Eg10-e8",e:5}],"1#-1484787041":[{m:"Ri2-f2",e:5}],"-1#-1414907675":[{m:"Af10-e9",e:5}],"1#-1493042057":[{m:"Ra1-d1",e:5}],"-1#-855594554":[{m:"Ri10-f10",e:5}],"1#1154752002":[{m:"Rf2xf10+",e:5}],"-1#2092356150":[{m:"Ae9xf10",e:5}],"1#-1359728933":[{m:"Rd1-d4",e:5}],"-1#521245636":[{m:"Af10-e9",e:5}],"1#330979158":[{m:"Ch7-h5",e:5}],"-1#168472734":[{m:"Hg8-f6",e:5}],"1#-1468308435":[{m:"Ch5-c5",e:5}],"-1#-896107762":[{m:"i7-i6",e:5}],"1#-981748271":[{m:"e4-e5",e:5}],"-1#1123307677":[{m:"Ca8-b8",e:5}],"1#-1946786979":[{m:"Cb3-a3",e:5}],"-1#-1201116623":[{m:"Hc8-b6",e:5}],"1#1715322176":[{m:"Hb5-c3",e:5}],"-1#790582060":[{m:"Cb8-c8",e:5}],"1#-1545529010":[{m:"Rd4-b4",e:5}],"-1#51529015":[{m:"Hf6-d7",e:5}],"1#1878269044":[{m:"Cc5xc8",e:5}],"-1#510666937":[{m:"Hb6xc8",e:5}],"1#264693876":[{m:"Rb4-e4",e:5}],"-1#550675171":[],"1#1815979927":[{m:"Hh1-i3",e:5}],"-1#1974708137":[{m:"c7-c6",e:5}],"1#-1227596654":[{m:"Ch3-f3",e:5}],"-1#-1819801045":[{m:"Hh10-g8",e:5}],"1#1364259174":[{m:"Ri1-h1",e:5}],"-1#1540205142":[{m:"Ri10-h10",e:5}],"1#26007463":[{m:"Rh1-h5",e:5}],"-1#-1857595121":[{m:"Ch8-i8",e:5}],"1#-1398391812":[{m:"Rh5-d5",e:5}],"-1#-1215046051":[{m:"Hb10-c8",e:5}],"1#-1501311775":[{m:"Hb1-c3",e:5}],"-1#-186931284":[{m:"Rh10-h6",e:5}],"1#1359748854":[{m:"Ec1-e3",e:5}],"-1#-471142177":[{m:"Ad10-e9",e:5}],"1#254527534":[{m:"c4-c5",e:5}],"-1#-1070009178":[{m:"Ra10-d10",e:5}],"1#102168012":[{m:"Ra1-d1",e:5}],"-1#1813487741":[{m:"c6xc5",e:5}],"1#1466921449":[{m:"Rd5xc5",e:5}],"-1#40708773":[{m:"Rd10xd1+",e:5}],"1#1824539473":[{m:"Ae2xd1",e:5}],"-1#-398788056":[{m:"Hc8-d6",e:5}],"1#-1031253589":[{m:"Cb3-a3",e:5}],"-1#-250193721":[{m:"Ci8xi4",e:5}],"1#-1251138472":[{m:"Ca3xa7",e:5}],"-1#-531104697":[{m:"Hd6xe4",e:5}],"1#-489104278":[{m:"Rc5-b5",e:5}],"-1#-1194695690":[{m:"Rh6-a6",e:5}],"1#1172683969":[{m:"Ca7xg7",e:5}],"-1#-916050747":[{m:"Cb8-d8",e:5}],"1#-1541162954":[{m:"a4-a5",e:5}],"-1#-1974657670":[{m:"Ra6-g6",e:5}],"1#-118543159":[{m:"g4-g5",e:5}],"-1#-1272653276":[{m:"Rg6xg7",e:5}],"1#329390087":[{m:"Hc3xe4",e:5}],"-1#-448510749":[{m:"e7-e6",e:5}],"1#1201025428":[{m:"g5-g6",e:5}],"-1#630898311":[{m:"Rg7xg6",e:5}],"1#1432690146":[{m:"He4-g5",e:5}],"-1#-1104411417":[{m:"Hg8-h6",e:5}],"1#602270824":[{m:"Ad1-e2",e:5}],"-1#1827470696":[{m:"Rg6-g7",e:5}],"1#572783643":[{m:"Hg5xe6",e:5}],"-1#1214885030":[{m:"Rg7-e7",e:5}],"1#66157011":[{m:"He6-g5",e:5}],"-1#761649123":[{m:"Ci4-i5",e:5}],"1#-870413737":[],"1#-2084021169":[{m:"Cb3-c3",e:6.667},{m:"Ch3-d3",e:6.667}],"-1#-1994358954":[{m:"Ec10-e8",e:5}],"1#-1515028555":[{m:"Ch3-e3",e:5}],"-1#-14289327":[{m:"Hh10-g8",e:5}],"1#1039994140":[{m:"Hb1-a3",e:5}],"-1#572764484":[{m:"Ri10-h10",e:5}],"1#2019740853":[{m:"Hh1-g3",e:5}],"-1#937386365":[{m:"Hb10-d9",e:5}],"1#1039998567":[{m:"Ra1-b1",e:5}],"-1#189918875":[{m:"Ra10-b10",e:5}],"1#857980930":[{m:"Rb1-b5",e:5}],"-1#1804464697":[{m:"Cb8-d8",e:5}],"1#113796810":[{m:"Rb5-d5",e:5}],"-1#751739016":[{m:"Ad10-e9",e:5}],"1#-1072719751":[{m:"g4-g5",e:5}],"-1#-1933283692":[{m:"Rb10-b7",e:5}],"1#2002126410":[{m:"Ri1-h1",e:5}],"-1#2110479738":[{m:"Ch8-h4",e:5}],"1#1480746512":[{m:"a4-a5",e:5}],"-1#1982645084":[{m:"Hd9-b8",e:5}],"1#-570289177":[{m:"Ce3-f3",e:5}],"-1#-1139475509":[{m:"Ch4-g4",e:5}],"1#-1391557017":[{m:"Eg1-e3",e:5}],"-1#731349173":[{m:"Rh10xh1",e:5}],"1#334103051":[{m:"Hg3xh1",e:5}],"-1#535165264":[{m:"e7-e6",e:5}],"1#-1120433113":[{m:"Cf3-g3",e:5}],"-1#-1689718327":[{m:"Cg4-h4",e:5}],"1#-1974301595":[{m:"Rd5-f5",e:5}],"-1#831680525":[{m:"Rb7-e7",e:5}],"1#182009203":[{m:"Hh1-f2",e:5}],"-1#1015873506":[{m:"i7-i6",e:5}],"1#862007613":[{m:"Cc3-d3",e:5}],"-1#511994542":[{m:"Ch4-h8",e:5}],"1#990728644":[{m:"Rf5-b5",e:5}],"-1#-1223271265":[{m:"Hb8-c10",e:5}],"1#1782970971":[{m:"Cd3-d6",e:5}],"-1#-116062171":[{m:"Ch8-i8",e:5}],"1#-990614826":[{m:"Cd6xi6",e:5}],"-1#1417649551":[{m:"Ci8xi4",e:5}],"1#268755216":[{m:"Hf2-h3",e:5}],"-1#540714923":[{m:"Hg8-i7",e:5}],"1#-1015407140":[{m:"Ee3-g1",e:5}],"-1#1172511502":[{m:"g7-g6",e:5}],"1#817491059":[{m:"Cg3-e3",e:5}],"-1#1762479808":[{m:"Re7-h7",e:5}],"1#-327070574":[{m:"Ci6xe6",e:5}],"-1#1583738136":[{m:"Rh7xh3",e:5}],"1#-294608487":[{m:"Rb5-b10",e:5}],"-1#2090520430":[{m:"Ke10-d10",e:5}],"1#90991127":[{m:"Ce3-d3+",e:5}],"-1#-1050361510":[{m:"Cd8-c8",e:5}],"1#1023551674":[{m:"Ha3-b5",e:5}],"-1#967184835":[{m:"Cc8xc4",e:5}],"1#238134240":[{m:"Ec1-e3",e:5}],"-1#-1126740535":[{m:"Rh3-h7",e:5}],"1#-1983317640":[{m:"Hb5-d6+",e:5}],"-1#95117409":[{m:"Kd10-e10",e:5}],"1#2086520088":[{m:"Hd6-c8",e:5}],"-1#1204165704":[],"-1#9062807":[{m:"Hh10-g8",e:5}],"1#-1034767654":[{m:"Hh1-g3",e:5}],"-1#-1913708782":[{m:"Ri10-h10",e:5}],"1#-676437277":[{m:"Ri1-i2",e:5}],"-1#-2098581877":[{m:"Ch8-h2",e:5}],"1#1970264380":[{m:"i4-i5",e:5}],"-1#-881802916":[{m:"Hb10-c8",e:5}],"1#-631188512":[{m:"i5-i6",e:5}],"-1#-730265843":[{m:"i7xi6",e:5}],"1#-1785276546":[{m:"Ri2xi6",e:5}],"-1#1958227947":[{m:"Ec10-e8",e:5}],"1#1479159560":[{m:"Ri6-i5",e:5}],"-1#-387025151":[{m:"Ch2-h5",e:5}],"1#-635409144":[{m:"Hb1-a3",e:5}],"-1#-973156016":[{m:"g7-g6",e:5}],"1#-1331419603":[{m:"Ec1-e3",e:5}],"-1#37931012":[{m:"Cb8-a8",e:5}],"1#-884933692":[{m:"Cb3-c3",e:5}],"-1#-1045899043":[{m:"Ra10-b10",e:5}],"1#-103090620":[{m:"c4-c5",e:5}],"-1#919194316":[{m:"Ca8xa4",e:5}],"1#-487285527":[{m:"Ra1-c1",e:5}],"-1#1186458277":[{m:"Hc8-d6",e:5}],"1#1812283686":[{m:"c5xc6",e:5}],"-1#1402354418":[{m:"Ee8xc6",e:5}],"1#-1958261573":[{m:"g4-g5",e:5}],"-1#-947078570":[{m:"g6xg5",e:5}],"1#1565028961":[{m:"Ee3xg5",e:5}],"-1#417130017":[{m:"Ch5-h6",e:5}],"1#-430018403":[{m:"Eg5-e3",e:5}],"-1#-2137176308":[{m:"Rb10-b4",e:5}],"1#2109390573":[{m:"Rc1-b1",e:5}],"-1#-225964244":[{m:"Rb4xb1+",e:5}],"1#-564217235":[{m:"Ha3xb1",e:5}],"-1#167982807":[{m:"Ca4-a6",e:5}],"1#1424517780":[{m:"Hb1-a3",e:5}],"-1#1261885132":[{m:"Eg10-e8",e:5}],"1#-2006193613":[{m:"Ha3-b5",e:5}],"-1#-1932537014":[{m:"Rh10-h9",e:5}],"1#-1980948416":[{m:"Hb5xd6",e:5}],"-1#751488302":[{m:"Ca6xd6",e:5}],"1#202135280":[{m:"Hg3-f5",e:5}],"-1#1526597015":[{m:"Cd6-d8",e:5}],"1#-1183694545":[{m:"Ri5-h5",e:5}],"-1#-121785981":[{m:"Rh9-h10",e:5}],"1#-39894391":[{m:"Ee3-c1",e:5}],"-1#1333374112":[{m:"Ch6-h9",e:5}],"1#824083152":[{m:"Cd3-e3",e:5}],"-1#-183096931":[{m:"Ch9-g9",e:5}],"1#-1780786094":[],"-1#850235794":[{m:"Hh10-i8",e:9.783},{m:"Cb8-d8",e:9.783},{m:"Ri10-i9",e:9.783},{m:"Cb8-g8",e:9.783},{m:"Ec10-e8",e:9.783},{m:"g7-g6",e:9.783},{m:"Hb10-a8",e:9.783},{m:"Cb8-e8",e:9.783},{m:"Ch8-e8",e:9.783},{m:"Hh10-g8",e:9.783}],"1#-1160337810":[{m:"Hh1-g3",e:6.667}],"-1#-177534042":[{m:"Ri10-h10",e:6.667},{m:"Hh10-i8",e:9}],"1#-1356171689":[{m:"Ri1-h1",e:5}],"-1#-1514721945":[{m:"Ec10-e8",e:5}],"1#-1994052220":[{m:"Ec1-e3",e:7.5},{m:"Hb1-a3",e:7.5}],"-1#1002685357":[{m:"c7-c6",e:6.667}],"1#-123455338":[{m:"Hb1-d2",e:6.667}],"-1#719530387":[{m:"Hb10-c8",e:6.667}],"1#1005796143":[{m:"c4-c5",e:6.667}],"-1#-186644569":[{m:"c6xc5",e:6.667}],"1#-812067277":[{m:"Rh1-h5",e:6.667}],"-1#1599297691":[{m:"Hc8-b6",e:6.667}],"1#-2130276374":[{m:"Rh5xc5",e:6.667}],"-1#-756283786":[{m:"Ch8-f8",e:6.667},{m:"Ad10-e9",e:6.667}],"1#301292639":[{m:"g4-g5",e:5}],"-1#1564388018":[{m:"Rh10-h6",e:5}],"1#1043152519":[{m:"Ra1-b1",e:5}],"-1#142724731":[{m:"Hb6xa4",e:5}],"1#-1884427873":[{m:"Cb3-a3",e:5}],"-1#-1761898020":[{m:"i7-i6",e:5}],"1#-1726587133":[{m:"Rh1-h5",e:5}],"-1#165532075":[{m:"Ch8-g8",e:5}],"1#2133262177":[{m:"Rh5xh10",e:5}],"-1#390222385":[{m:"Hi8xh10",e:5}],"1#25470313":[{m:"g4-g5",e:5}],"-1#1297044356":[{m:"Hb10-d9",e:5}],"1#1198337182":[{m:"Ra1-a2",e:5}],"-1#-835935179":[{m:"Hh10-i8",e:5}],"1#1180144585":[{m:"Ra2-f2",e:5}],"-1#-193651995":[{m:"a7-a6",e:5}],"1#-262731801":[{m:"Rf2-f6",e:5}],"-1#-1247562803":[{m:"c7-c6",e:5}],"1#1992575222":[{m:"Eg1-e3",e:5}],"-1#-262320604":[{m:"Cb8-a8",e:5}],"1#-637990075":[{m:"g4-g5",e:8},{m:"Ri1-i2",e:8},{m:"Ri1-h1",e:8}],"-1#-1791820376":[{m:"Ri10-i9",e:5}],"1#-728225332":[{m:"Hb1-a3",e:5}],"-1#-884566636":[{m:"Ri9-d9",e:5}],"1#876756011":[{m:"Af1-e2",e:5}],"-1#1813763809":[{m:"c7-c6",e:5}],"1#-1350816294":[{m:"Ri1-h1",e:5}],"-1#-1511950614":[{m:"Ch8-g8",e:5}],"1#-753248224":[{m:"Cc3-f3",e:5}],"-1#-1933752531":[{m:"Ri10-i9",e:5}],"1#-854092983":[{m:"Ri2-d2",e:5}],"-1#1664761770":[{m:"Cb8-c8",e:5}],"1#-272337464":[{m:"Cb3-b7",e:5}],"-1#-213320398":[{m:"c7-c6",e:5}],"1#808388105":[{m:"Hb1-a3",e:5}],"-1#804371025":[{m:"Ri9-d9",e:5}],"1#-789244946":[{m:"Ra1-a2",e:5}],"-1#-748400523":[{m:"Ec10-e8",e:5}],"1#1609041249":[{m:"Hh1-g3",e:5}],"-1#274049193":[{m:"Hb10-c8",e:5}],"1#21346837":[{m:"Hb1-a3",e:5}],"-1#513476173":[{m:"Ra10-b10",e:5}],"1#652814548":[{m:"Ra1-b1",e:5}],"-1#273012776":[{m:"Rb10-b6",e:5}],"1#1666687422":[{m:"Ri1-h1",e:5}],"-1#1774910094":[{m:"Eg10-e8",e:5}],"1#-1432893839":[{m:"Cc3xc7",e:5}],"-1#-526922524":[{m:"Hh10-i8",e:5}],"1#1760361240":[{m:"Cc7xc10+",e:5}],"-1#223790222":[{m:"Ee8xc10",e:5}],"1#803600951":[{m:"Rh1xh8",e:5}],"-1#-939932452":[{m:"Af10-e9",e:5}],"1#-883818418":[{m:"Cb3-c3",e:5}],"-1#-1044765865":[{m:"Rb6xb1",e:5}],"1#1666782817":[{m:"Ha3xb1",e:5}],"-1#-1224434981":[{m:"Hc8-a9",e:5}],"1#258772758":[{m:"g4-g5",e:5}],"-1#1135049211":[{m:"i7-i6",e:5}],"1#1279964964":[{m:"a4-a5",e:5}],"-1#1646531176":[{m:"Ec10-e8",e:5}],"1#279640500":[{m:"Rh8xe8",e:5}],"-1#583636891":[{m:"Hi8-h6",e:5}],"1#-173821019":[{m:"Re8-h8",e:5}],"-1#1634379957":[{m:"Hh6-f7",e:5}],"1#-1356672652":[{m:"Eg1-i3",e:5}],"-1#1497436359":[{m:"Ha9-b7",e:5}],"1#1552056503":[{m:"Cc3-e3",e:5}],"-1#-503905467":[{m:"Hb7-d6",e:5}],"1#1995320699":[{m:"Rh8-h6",e:5}],"-1#214444587":[{m:"e7-e6",e:5}],"1#-1374003364":[{m:"Ce3xe6+",e:5}],"-1#1350756944":[{m:"Cd8-e8",e:5}],"1#364019322":[{m:"Hg3-f5",e:5}],"-1#1128279325":[{m:"Hd6xe4",e:5}],"1#1104088368":[{m:"Ec1-e3",e:5}],"-1#-215358695":[{m:"Ri10-f10",e:5}],"1#2063422685":[{m:"Hf5xg7",e:5}],"-1#941607446":[{m:"Rf10-g10",e:5}],"1#195998442":[{m:"g5-g6",e:5}],"-1#1772240377":[],"1#1929856502":[{m:"Hh1-g3",e:5}],"-1#1018882110":[{m:"Ec10-e8",e:5}],"1#271116509":[{m:"Ri1-h1",e:8.571}],"-1#448115693":[{m:"Ri9-d9",e:8.571}],"1#-441378222":[{m:"Ec1-e3",e:8.571},{m:"Hb1-a3",e:8.571},{m:"Cc3-f3",e:8.571}],"-1#1465382011":[{m:"Hh10-i8",e:7.5},{m:"Rd9-d4",e:7.5}],"1#-550714489":[{m:"Ad1-e2",e:6.667}],"-1#-1876569465":[{m:"Rd9-d6",e:6.667}],"1#2049220740":[{m:"Hb1-a3",e:6.667},{m:"c4-c5",e:6.667}],"-1#-1254646772":[{m:"i7-i6",e:5}],"1#1179273150":[{m:"Hb1-a3",e:5}],"-1#1502936038":[{m:"Hh10-i8",e:5}],"1#-772813798":[{m:"Cb3-b4",e:5}],"-1#1772605369":[{m:"Rd4-d3",e:5}],"1#1729492835":[{m:"Ra1-c1",e:5}],"-1#-93346294":[{m:"Hh10-i8",e:5}],"1#1913950710":[{m:"Af1-e2",e:5}],"-1#709720892":[{m:"a7-a6",e:5}],"1#779052606":[{m:"Cb3-b7",e:5}],"-1#853798596":[{m:"Ad10-e9",e:5}],"1#-568142283":[{m:"Cb7xe7",e:5}],"-1#-817826805":[{m:"Rd9-d6",e:5}],"1#625051144":[{m:"Ra1-b1",e:5}],"-1#334329588":[{m:"Hb10-a8",e:5}],"1#1501181686":[{m:"Rb1-b7",e:5}],"-1#2041486677":[{m:"i7-i6",e:5}],"1#1984123786":[{m:"Rh1-h7",e:5}],"-1#-532980612":[{m:"Hh10-i8",e:6.667}],"1#1749052288":[{m:"Cb3-e3",e:6.667}],"-1#-1040122854":[{m:"Ad10-e9",e:6.667},{m:"i7-i6",e:6.667}],"1#784450795":[{m:"Hb1-c3",e:5}],"-1#2090446758":[{m:"Rd9-d6",e:5}],"1#-1768366683":[{m:"Ra1-b1",e:5}],"-1#-1607193255":[{m:"i7-i6",e:5}],"1#-840092987":[{m:"Hb1-c3",e:5}],"-1#-1615505016":[{m:"Rd9-d6",e:5}],"1#1974741899":[{m:"Rh1-h7",e:5}],"-1#-815910410":[{m:"Hb10-d9",e:5}],"1#-981709076":[{m:"Ra1-b1",e:5}],"1#1001843627":[{m:"Hh1-g3",e:5}],"-1#1946895971":[{m:"Ra10-a8",e:5}],"1#-1391716677":[{m:"Hb1-a3",e:5}],"-1#-1294816541":[{m:"Ra8-f8",e:5}],"1#-1256101827":[{m:"Ra1-b1",e:5}],"-1#-2087872319":[{m:"Hb10-c8",e:5}],"1#-1835169155":[{m:"Eg1-e3",e:5}],"-1#335842479":[{m:"Eg10-e8",e:5}],"1#-681988016":[{m:"Cc3xc7",e:5}],"-1#-1655063867":[{m:"Hh10-f9",e:5}],"1#1782110150":[{m:"Cb3-d3",e:5}],"-1#1357420605":[{m:"Rf8-f6",e:5}],"1#-809862479":[{m:"Rb1-b9",e:5}],"-1#-356431180":[{m:"Hf9-d8",e:5}],"1#723614982":[{m:"Cd3-c3",e:5}],"-1#113518229":[{m:"Ad10-e9",e:5}],"1#-368763292":[{m:"Ri1-h1",e:5}],"-1#-526891692":[{m:"Ch8-h6",e:5}],"1#-615432618":[{m:"Rh1-h5",e:5}],"-1#1268429054":[{m:"Hd8-e6",e:5}],"1#-1312159935":[{m:"e4-e5",e:5}],"-1#910549517":[{
m:"He6xc7",e:5}],"1#-2029727486":[{m:"Cc3xc7",e:5}],"-1#1086523112":[{m:"Cg8-h8",e:5}],"1#-205202318":[{m:"e5-e6",e:5}],"-1#2032741343":[{m:"Ch6xe6+",e:5}],"1#-1823200698":[{m:"Ad1-e2",e:5}],"-1#-597869754":[{m:"Ch8-f8",e:5}],"1#1422859285":[{m:"Hg3-e4",e:5}],"-1#-1213028086":[{m:"Rf6-f4",e:5}],"1#-72937741":[{m:"He4-d6",e:5}],"-1#-1606369499":[{m:"Rf4-d4",e:5}],"1#1938671599":[{m:"Hd6xc8",e:5}],"-1#-742677731":[{m:"Cf8xc8",e:5}],"1#-1169358702":[{m:"Rh5-e5",e:5}],"-1#-1151070137":[{m:"Ri10-h10",e:5}],"1#-517640778":[{m:"Rb9-b5",e:5}],"-1#-2127734535":[{m:"Rh10-h4",e:5}],"1#1164752814":[{m:"Cc7xg7",e:5}],"-1#-33886560":[{m:"a7-a6",e:5}],"1#-103222366":[{m:"Rb5-b7",e:5}],"-1#-1669374645":[{m:"Cc8xc1",e:5}],"1#-908532683":[{m:"Ha3-c2",e:5}],"-1#147372884":[{m:"Rd4-d2",e:5}],"1#507482481":[{m:"Hh1-g3",e:9}],"-1#1367489721":[{m:"Ec10-e8",e:5},{m:"Hh10-i8",e:9},{m:"Hh10-g8",e:9}],"1#-1822767116":[{m:"Ri1-h1",e:5}],"-1#-1714971452":[{m:"Ri10-h10",e:5}],"1#-1014570699":[{m:"g4-g5",e:5}],"-1#-1890773032":[{m:"Ch8-h6",e:5}],"1#-1266389798":[{m:"Ec1-e3",e:5}],"-1#107119347":[{m:"Ch6-a6",e:5}],"1#481948648":[{m:"Cb3-a3",e:5}],"-1#791149188":[{m:"Rh10xh1",e:5}],"1#391804986":[{m:"Hg3xh1",e:5}],"-1#458589025":[{m:"Hb10-d9",e:5}],"1#293076091":[{m:"Hb1-d2",e:5}],"-1#-1020203650":[{m:"Cb8-a8",e:5}],"1#171105982":[{m:"Ca3xa6",e:5}],"-1#-1627007404":[{m:"a7xa6",e:5}],"1#1973122184":[{m:"Ra1-b1",e:5}],"-1#1127711860":[{m:"Ca8xa4",e:5}],"1#-1760898479":[{m:"Cc3-a3",e:5}],"-1#-1338338095":[{m:"Ra10-a8",e:5}],"1#1765655561":[{m:"Rb1-b4",e:5}],"-1#962312019":[{m:"Ca4-a5",e:5}],"1#-657712281":[{m:"Rb4-b6",e:5}],"-1#-14818383":[{m:"Ra8-d8",e:5}],"1#1444979661":[{m:"Hd2-b3",e:5}],"-1#451574151":[{m:"Ca5-f5",e:5}],"1#-1860227093":[{m:"Rb6-f6",e:5}],"-1#-1286678969":[{m:"Cf5-b5",e:5}],"1#594033441":[{m:"Rf6xa6",e:5}],"1#1207396079":[{m:"Hh1-g3",e:8.889}],"-1#139119399":[{m:"Hh10-g8",e:8.889}],"1#-896389014":[{m:"Ri1-h1",e:8.889},{m:"Hb1-a3",e:8.889}],"-1#-1072731302":[{m:"Ri10-h10",e:8.75}],"1#-1706158421":[{m:"Rh1-h5",e:8.889},{m:"Hb1-a3",e:8.889}],"-1#176527363":[{m:"Ec10-e8",e:8.75},{m:"Ch8-i8",e:8.75}],"1#639080672":[{m:"Ec1-e3",e:5}],"-1#-1796114743":[{m:"Ch8-i8",e:5}],"1#-1458564038":[{m:"Rh5-d5",e:5}],"1#929364720":[{m:"Rh5-f5",e:8.571},{m:"Rh5-d5",e:8.571}],"-1#145892828":[{m:"Eg10-e8",e:8.333}],"-1#-2054116621":[{m:"Ch8-h4",e:5}],"1#-1608937063":[{m:"Cc3xc7",e:5}],"-1#-367420660":[{m:"Hb10-a8",e:5}],"1#-1601250546":[{m:"Ec1-e3",e:5}],"-1#308819239":[{m:"Ch4xe4+",e:5}],"1#-1807079009":[{m:"Ad1-e2",e:5}],"-1#-616351585":[{m:"Rh10xh1",e:5}],"1#-482428383":[{m:"Hg3xh1",e:5}],"-1#-281984646":[{m:"Cb8-e8",e:5}],"-1#-716403662":[{m:"Ri10-h10",e:5}],"1#-1894911549":[{m:"Ad1-e2",e:5}],"-1#-1073422141":[{m:"Ch8-i8",e:5}],"1#-35290576":[{m:"Ri1-i2",e:5}],"-1#-1465790888":[{m:"a7-a6",e:5}],"1#-1400646822":[{m:"Ri2-f2",e:5}],"-1#-1604970208":[{m:"Hb10-a8",e:5}],"1#-356427486":[{m:"Rf2-f5",e:5}],"-1#382784900":[{m:"Eg10-e8",e:5}],"1#-712119941":[{m:"Ec1-e3",e:5}],"-1#1735067474":[{m:"c7-c6",e:5}],"1#-1542652823":[{m:"Ra1-d1",e:5}],"-1#-837965352":[{m:"Af10-e9",e:5}],"1#-1029280438":[{m:"a4-a5",e:5}],"-1#-322385914":[{m:"a6xa5",e:5}],"1#-964952935":[{m:"Rf5xa5",e:5}],"-1#-123838875":[{m:"Rh10-f10",e:5}],"1#920036129":[{m:"g4-g5",e:5}],"-1#2048742860":[{m:"Rf10-f6",e:5}],"1#258486367":[{m:"g5xg6",e:5}],"1#2017120656":[{m:"Hh1-g3",e:8.333}],"-1#931626072":[{m:"g7-g6",e:8.333},{m:"Cb8-d8",e:8.333},{m:"Cb8-c8",e:8.333},{m:"Ch8-d8",e:8.333}],"1#1121815333":[{m:"Ri1-h1",e:5}],"-1#1212207125":[{m:"Hh10-g8",e:5}],"1#-1969738920":[{m:"Hb1-a3",e:5}],"-1#-1790535936":[{m:"Ra10-a9",e:5}],"1#-1927344575":[{m:"Cc3xc7",e:5}],"-1#-954268460":[{m:"Ch8-i8",e:5}],"1#-83991001":[{m:"Ad1-e2",e:5}],"-1#-1242073305":[{m:"Cb8-d8",e:5}],"1#-659364908":[{m:"Cc7-c5",e:5}],"-1#774162900":[{m:"Eg10-e8",e:5}],"1#1522722987":[{m:"Cb3-b7",e:5}],"-1#1179541585":[{m:"Hh10-g8",e:5}],"1#-2070504676":[{m:"Hb1-a3",e:5}],"-1#-1689770172":[{m:"Ra10-b10",e:5}],"1#-1556477475":[{m:"Ra1-b1",e:5}],"-1#-1785267935":[{m:"Ri10-h10",e:5}],"1#-807959344":[{m:"a4-a5",e:5}],"-1#-507960932":[{m:"g7-g6",e:5}],"1#-1797007647":[{m:"Eg1-e3",e:5}],"-1#310038579":[{m:"Cd8-d3",e:5}],"1#-1149684166":[{m:"Ri1-h1",e:5}],"-1#-1310429942":[{m:"Eg10-e8",e:5}],"1#1924747765":[{m:"Hb1-a3",e:5}],"-1#1835527597":[{m:"Hh10-f9",e:5}],"1#-1710849874":[{m:"Cb3-b7",e:5}],"-1#-2037774252":[{m:"a7-a6",e:5}],"1#-2102913706":[{m:"Ra1-b1",e:5}],"-1#-1274747478":[{m:"Cc8-b8",e:5}],"1#955953096":[{m:"Cb7-a7",e:5}],"1#544527765":[{m:"Ri1-h1",e:6.667}],"-1#719949477":[{m:"Hh10-g8",e:6.667}],"1#-399411736":[{m:"Hb1-a3",e:6.667},{m:"Ec1-e3",e:6.667}],"-1#-135280208":[{m:"Cb8-c8",e:6.667}],"1#2064745426":[{m:"Ra1-b1",e:6.667},{m:"a4-a5",e:6.667}],"-1#1524079553":[{m:"Cb8-c8",e:5}],"1#-701902429":[{m:"Hb1-d2",e:5}],"-1#74367142":[{m:"Ra10-b10",e:5}],"1#117810746":[{m:"Hh1-g3",e:6.667}],"-1#1220021234":[{m:"Hh10-g8",e:6.667},{m:"Hh10-i8",e:6.667}],"1#-1973358401":[{m:"Ri1-h1",e:5}],"-1#-2130859121":[{m:"Ri10-h10",e:5}],"1#-625158530":[{m:"Rh1-h7",e:5}],"-1#1616301059":[{m:"Ce8-d8",e:5}],"1#627464233":[{m:"Rh7xg7",e:5}],"-1#1428356808":[{m:"Eg10-e8",e:5}],"1#-1770012105":[{m:"Hb1-a3",e:5}],"-1#-1985905041":[{m:"Hb10-a8",e:5}],"1#-1019855251":[{m:"Ra1-b1",e:5}],"-1#-174403951":[{m:"a7-a6",e:5}],"1#-239545453":[{m:"Rg7-g5",e:5}],"-1#-1543774613":[{m:"Ra10-a9",e:5}],"1#-1146992854":[{m:"a4-a5",e:5}],"-1#-1781734810":[{m:"a6xa5",e:5}],"1#-1082140935":[{m:"Rg5xa5",e:5}],"-1#-904792931":[{m:"Hg8-h6",e:5}],"1#1473780754":[{m:"Cc3-e3",e:5}],"-1#765035873":[{m:"Ch8-g8",e:5}],"1#1533193131":[{m:"Ce3xe7+",e:5}],"-1#529648425":[{m:"Af10-e9",e:5}],"1#322572219":[{m:"Ec1-e3",e:5}],"1#-1060946930":[{m:"Ri1-h1",e:5}],"-1#-899782850":[{m:"Ri10-h10",e:5}],"1#-1877009713":[{m:"Rh1-h5",e:5}],"-1#13931623":[{m:"Hb10-c8",e:5}],"1#298092251":[{m:"Hb1-a3",e:5}],"-1#236599939":[{m:"a7-a6",e:5}],"1#171452289":[{m:"Cc3xc7",e:5}],"-1#1077423380":[{m:"Ch8-g8",e:5}],"1#918750174":[{m:"Rh5xh10",e:5}],"-1#1588047502":[{m:"Hi8xh10",e:5}],"1#1214339542":[{m:"Ra1-b1",e:5}],"-1#2127407402":[{m:"e7-e6",e:5}],"1#-601891747":[{m:"Cb3-e3",e:5}],"-1#1985956807":[{m:"Cg8xg4",e:5}],"1#-2039165737":[{m:"c4-c5",e:5}],"-1#1231548511":[{m:"Hh10-i8",e:5}],"1#-1055078493":[{m:"Rb1-b6",e:5}],"-1#-1418298530":[{m:"Ce8-e9",e:5}],"1#-2012842871":[{m:"Rb6xe6",e:5}],"-1#-628099386":[{m:"Ec10-e8",e:5}],"1#1371857065":[{m:"Hh1-g3",e:8.571}],"-1#511266145":[{m:"Hb10-a8",e:8.571},{m:"Hh10-g8",e:8.571}],"1#1424887139":[{m:"Ri1-h1",e:5}],"-1#1584617043":[{m:"Hh10-g8",e:5}],"1#-1666470626":[{m:"a4-a5",e:6.667},{m:"Ec1-e3",e:6.667}],"-1#-1295710126":[{m:"Ri10-i9",e:5}],"1#-210772938":[{m:"Hb1-a3",e:5}],"-1#-323919762":[{m:"Ri9-d9",e:5}],"1#330680785":[{m:"Af1-e2",e:5}],"-1#1273766683":[{m:"Rd9-d5",e:5}],"1#992155650":[{m:"Rh1-h7",e:5}],"-1#-2117533057":[{m:"g7-g6",e:5}],"1#-191630078":[{m:"Rh7-g7",e:5}],"-1#776815415":[{m:"Ri10-i9",e:5}],"1#1877448531":[{m:"Rh1-h7",e:5}],"-1#-720532178":[{m:"g7-g6",e:5}],"1#-1604879789":[{m:"Rh7-g7",e:5}],"-1#-1313502277":[{m:"Ri9-f9",e:5}],"1#-1510843815":[{m:"Ad1-e2",e:5}],"-1#-352629927":[{m:"Rf9-f6",e:5}],"1#1584049145":[{m:"Hb1-a3",e:5}],"-1#1102321569":[{m:"a7-a6",e:5}],"1#-593381844":[{m:"Ri1-i2",e:8.333},{m:"Ri1-h1",e:8.333}],"-1#-1981416892":[{m:"Ri10-h10",e:6.667}],"1#-744192075":[{m:"Ec1-e3",e:6.667}],"-1#1631742364":[{m:"Hb10-a8",e:6.667}],"1#735390110":[{m:"Ri2-d2",e:6.667}],"-1#-2047310467":[{m:"Rh10-h6",e:6.667}],"1#539966503":[{m:"Rd2-d8",e:6.667},{m:"Hb1-a3",e:6.667}],"-1#-1653084471":[{m:"Cb8xb1+",e:5}],"-1#1072791679":[{m:"Cb8-b4",e:5}],"-1#-700650212":[{m:"Ri10-i9",e:7.5},{m:"Hh10-g8",e:5}],"1#-1751762568":[{m:"Cc3xc7",e:6.667}],"-1#-577358867":[{m:"g7-g6",e:6.667}],"1#-1462975344":[{m:"Rh1-h5",e:6.667}],"-1#940001848":[{m:"Hb10-a8",e:6.667}],"1#1922042426":[{m:"Cc7-c8",e:6.667}],"-1#-676486946":[{m:"Ri9-d9",e:6.667}],"1#682166625":[{m:"Ec1-e3",e:6.667}],"1#-260740385":[{m:"Ri1-i3",e:9.091},{m:"g4-g5",e:9.091},{m:"Hh1-g3",e:9.091}],"-1#1437243619":[{m:"Ri10-h10",e:5}],"1#267117842":[{m:"Ri3-d3",e:5}],"-1#-1782816174":[{m:"Hb10-a8",e:5}],"1#-550821296":[{m:"Hh1-g3",e:5}],"-1#-1869181032":[{m:"Ch8-i8",e:5}],"1#-1384649365":[{m:"Ec1-e3",e:5}],"-1#529597250":[{m:"Rh10-h6",e:5}],"1#-1169769960":[{m:"c4-c5",e:5}],"-1#1968539280":[{m:"Eg10-e8",e:5}],"1#-1240941969":[{m:"Cc3-c2",e:5}],"-1#-80457341":[{m:"Af10-e9",e:5}],"1#-140536559":[{m:"Ad1-e2",e:5}],"-1#-1198095343":[{m:"Cb8-d8",e:5}],"-1#-1128358862":[{m:"Cb8-e8",e:8.333},{m:"Ri10-h10",e:8.333}],"1#-1995002982":[{m:"Hh1-g3",e:5}],"-1#-961870254":[{m:"Hb10-c8",e:5}],"1#-675605266":[{m:"Ri1-h1",e:5}],"-1#-584691746":[{m:"Ra10-b10",e:5}],"1#-447454905":[{m:"Ra1-a3",e:5}],"-1#-2024252946":[{m:"Ri10-h10",e:5}],"1#-419438141":[{m:"g4-g5",e:8}],"-1#-1455272949":[{m:"Hb10-a8",e:8.333},{m:"Ch8-i8",e:8.333}],"1#-472577015":[{m:"a4-a5",e:5}],"-1#-843339451":[{m:"Ch8-i8",e:5}],"1#-1801244936":[{m:"Cc3xc7",e:8}],"-1#-1077360873":[{m:"Ri10-h10",e:8}],"1#-443958554":[{m:"g4-g5",e:8},{m:"Ri1-h1",e:8},{m:"Ri1-i2",e:8}],"-1#-283844138":[{m:"Ch8-h4",e:6.667},{m:"Ri10-h10",e:8.75}],"1#-895624516":[{m:"g4-g5",e:5}],"-1#-2041172911":[{m:"Ch4-g4",e:5}],"1#-1756605955":[{m:"Ec1-e3",e:5}],"-1#-1328679282":[{m:"g7-g6",e:5}],"1#-979959309":[{m:"Ec1-e3",e:5}],"-1#2003955674":[{m:"Hb10-a8",e:5}],"1#1038528472":[{m:"c4-c5",e:5}],"-1#-218786992":[{m:"Cb8-d8",e:5}]};

/***/ }),

/***/ "iFgX":
/***/ (function(module, exports) {

exports.model=Model={Game:{},Board:{},Move:{}},function(){function t(t){var i=t%e;return[i,(t-i)/e]}function i(t,i){return i*e+t}var e;Model.Game.InitGame=function(){var s=this;e=2*this.mOptions.centerDistance+1;var r=[[0,-1],[1,0],[0,1],[-1,0]];this.g.attackersCount=this.mOptions.initial.attackers.length,this.g.defendersCount=this.mOptions.initial.defenders.soldiers.length,this.g.excludeMap={},this.mOptions.exclude.forEach(function(t){s.g.excludeMap[t]=!0}),this.g.home=this.mOptions.initial.defenders.king,this.g.Graph=[],this.g.borders={};for(var a=0;a<e*e;a++){var o=[],n=t(a);r.forEach(function(t){var r=n[0]+t[0];if(r<0||r>=e)o.push(null),s.g.borders[a]=!0;else{var h=n[1]+t[1];if(h<0||h>=e)o.push(null),s.g.borders[a]=!0;else{var d=i(r,h);s.g.excludeMap[d]?o.push(null):o.push(d)}}}),this.g.Graph.push(o)}this.zobrist=new JocGame.Zobrist({board:{type:"array",size:e*e,values:["s1","s-1","k1","k-1"]}})},Model.Move.Init=function(t){var i=this;if(this.f=t.f,this.t=t.t,this.c=[],t.c)for(var e=0;e<t.c.length;e++)i.c.push(t.c[e])},Model.Move.CopyFrom=function(t){this.Init(t)},Model.Move.ToString=function(){var t=this.f+">"+this.t;return this.c.length>0&&(t+="x"+this.c.join(",")),t},Model.Board.Init=function(t){this.zSign=0},Model.Board.InitialPosition=function(i){function s(t,e,s){r.zSign=i.zobrist.update(r.zSign,"board",s+e,t),r.board[t]=r.pieces.length,r.pieces.push({i:r.pieces.length,p:t,s:e,t:s})}var r=this;this.board=[],this.pieces=[];for(var a=0;a<e*e;a++)this.board.push(-1);var o=i.mOptions.attackers;s(i.mOptions.initial.defenders.king,-o,"k");var n=i.mOptions.initial.defenders.soldiers;this.defendersCount=0;for(var h=0;h<n.length;h++)s(n[h],-o,"s"),this.defendersCount++;this.defendersCount=n.length;var d=i.mOptions.initial.attackers;this.attackersCount=0;for(var h=0;h<d.length;h++){s(d[h],o,"s");t(d[h]);this.attackersCount++}},Model.Board.CopyFrom=function(t){var i=this;this.board=[];for(var e=t.board,s=0;s<e.length;s++)i.board.push(e[s]);this.pieces=[];for(var r=t.pieces,a=0;a<r.length;a++){var o=r[a];i.pieces.push({i:o.i,p:o.p,s:o.s,t:o.t})}this.defendersCount=t.defendersCount,this.attackersCount=t.attackersCount,this.mWho=t.mWho,this.zSign=t.zSign},Model.Board.GenerateMoves=function(t){for(var i=this,e=[],s=0;s<this.pieces.length;s++){var r=this.pieces[s];if(!(r.s!=i.mWho||r.p<0))for(var a=0;a<4;a++)for(var o=t.g.Graph[r.p][a];null!=o;){var n=i.board[o];if(!(n<0)||o==t.g.home&&t.mOptions.privateHome&&"k"!=r.t)break;for(var h={f:r.p,t:o,c:[]},d=0;d<4;d++){var p=t.g.Graph[o][d];if(null!=p){var c=i.board[p];if(c>=0){var f=i.pieces[c];if(f.s==-r.s)if("k"==f.t){for(var u=0;u<4;u++){var l=t.g.Graph[p][u];if(null==l)break;var v=i.board[l];if(v<0){if(l!=o&&(l!=t.g.home||!t.mOptions.homeCatch))break}else{var g=i.pieces[v];if(g.s==f.s)break}}4==u&&h.c.push(p)}else{var l=t.g.Graph[p][d];if(null!=l){var v=i.board[l];if(l==t.g.home&&t.mOptions.homeCatch)h.c.push(p);else if(v>=0){var g=i.pieces[v];g.s==r.s&&h.c.push(p)}}}}}}if(e.push(h),!t.mOptions.longMove)break;o=t.g.Graph[o][a]}}this.mMoves=e},Model.Board.Evaluate=function(i){var e="debug"==arguments[3];if(this.mEvaluation=0,this.pieces[0].p<0)return this.mFinished=!0,void(this.mWinner=i.mOptions.attackers);if(this.pieces[0].p in i.g.borders)return this.mFinished=!0,void(this.mWinner=-i.mOptions.attackers);if(i.GetRepeatOccurence(this)>2)return this.mFinished=!0,void(this.mWinner=JocGame.DRAW);for(var s=this.pieces[0].p,r=t(s),a=0,o=i.mOptions.initial.attackers.length+1;o<this.pieces.length;o++){var n=this.pieces[o];if(n.p>=0){var h=t(n.p);a+=Math.max(Math.abs(h[0]-r[0]),Math.abs(h[1]-r[1]))}}var d={},p={};d[s]=1;for(var c=1,f=0,u=0;c>0;){var l={};c=0;for(var v in d){for(var g=d[v],m=g/4,b=i.g.Graph[v],k=0;k<4;k++)for(var M=b[k];M&&!(this.board[M]>=0)&&(M in p||M in d||(M in i.g.borders?f+=g:M in l?l[M]+=m:(u++,c++,l[M]=m)),i.mOptions.longMove);)M=i.g.Graph[M][k];p[v]=g}d=l}var O={attackersCount:this.attackersCount,defendersCount:this.defendersCount,kingPath:f,kingFreedom:u,distKing:a},C=i.mOptions.levelOptions;for(var z in O){var G=O[z],S=C[z+"Factor"]||0,E=G*S;e&&console.log(z,"=",G,"*",S,"=>",E),this.mEvaluation+=E}this.mEvaluation*=i.mOptions.attackers,e&&console.log("Evaluation",this.mEvaluation)},Model.Board.ApplyMove=function(i,e){var s=this,r=this.board[e.f],a=this.pieces[r];if(this.zSign=i.zobrist.update(this.zSign,"board",a.t+a.s,e.f),this.zSign=i.zobrist.update(this.zSign,"board",a.t+a.s,e.t),this.board[e.f]=-1,this.board[e.t]=r,a.p=e.t,this.mWho==i.mOptions.attackers){t(e.f),t(e.t)}for(var o=e.c,n=0;n<o.length;n++){var h=o[n],d=s.board[h],p=s.pieces[d];s.zSign=i.zobrist.update(s.zSign,"board",p.t+p.s,h),s.board[h]=-1,p.p=-1,s.mWho==-i.mOptions.attackers?s.attackersCount--:"s"==p.t&&s.defendersCount--}},Model.Board.taflIntegrity=function(t){var i=this,e=0,s=0;this.board.forEach(function(r,a){if(r>=0){var o=i.pieces[r];o.p,"s"==o.t&&(o.s==t.mOptions.attackers?e++:s++)}}),this.attackersCount,this.defendersCount,this.pieces.forEach(function(t,e){t.p>=0&&i.board[t.p]})},Model.Board.GetSignature=function(){return this.zSign}}();

/***/ }),

/***/ "iH8n":
/***/ (function(module, exports) {

exports.model=Model={Game:{},Board:{},Move:{}},function(){var t;Model.Game.cbConstants={MASK:65535,FLAG_MOVE:65536,FLAG_CAPTURE:131072,FLAG_STOP:262144,FLAG_SCREEN_CAPTURE:524288,FLAG_CAPTURE_KING:1048576,FLAG_CAPTURE_NO_KING:2097152};var e="undefined"!=typeof Int32Array;Model.Game.cbUseTypedArrays=e,Model.Game.cbTypedArray=function(t){if(e){var r=new Int32Array(t.length);return r.set(t),r}for(var i=[],a=t.length,n=0;n<a;n++)i.push(t[n]);return i},Model.Game.cbShortRangeGraph=function(t,e,r,i){var a=this;void 0===i&&(i=196608);for(var n={},s=0;s<t.boardSize;s++)n[s]=[],(!r||s in r)&&e.forEach(function(e){var o=t.Graph(s,e);null!=o&&(!r||o in r)&&n[s].push(a.cbTypedArray([o|i]))});return n},Model.Game.cbLongRangeGraph=function(t,e,r,i,a){var n=this;void 0!==i&&null!=i||(i=196608),a||(a=1/0);for(var s={},o=0;o<t.boardSize;o++)s[o]=[],(!r||o in r)&&e.forEach(function(e){for(var h=[],c=t.Graph(o,e),p=0;null!=c&&(!r||c in r)&&(h.push(c|i),++p!=a);)c=t.Graph(c,e);h.length>0&&s[o].push(n.cbTypedArray(h))});return s},Model.Game.cbNullGraph=function(t){for(var e={},r=0;r<t.boardSize;r++)e[r]=[];return e},Model.Game.cbAuthorGraph=function(t){for(var e={},r=0;r<t.boardSize;r++){e[r]=[];for(var i=0;i<t.boardSize;i++)e[r].push([2293760|i])}return e},Model.Game.cbMergeGraphs=function(t){for(var e=[],r=0;r<t.boardSize;r++){e[r]=[];for(var i=1;i<arguments.length;i++)e[r]=e[r].concat(arguments[i][r])}return e},Model.Game.cbGetThreatGraph=function(){function t(e,r){for(var i in s){var a=s[i];if(!(a.p.length<r.length+1)){for(var n=!0,o=0;o<r.length;o++)if(r[o]!=a.p[o]){n=!1;break}if(n){var h=a.p[r.length],c=e[h];void 0===c&&(c={e:{}},e[h]=c),a.p.length==r.length+1&&(c.t=a.t,c.ts=a.ts,c.tk=a.tk,delete s[i]),r.push(h),t(c.e,r),r.pop()}}}}var e=this;this.cbUseScreenCapture=!1,this.cbUseCaptureKing=!1,this.cbUseCaptureNoKing=!1;for(var r={1:[],"-1":[]},i=[],a=0;a<this.g.boardSize;a++)this.g.pTypes.forEach(function(t,r){t.graph[a].forEach(function(t){for(var n=[],s=0;s<t.length;s++){var o=t[s];1048576&o?(e.cbUseCaptureKing=!0,n.unshift({d:65535&o,a:a,tk:r})):2097152&o?(e.cbUseCaptureNoKing=!0,n.unshift({d:65535&o,a:a,tnk:r})):131072&o?n.unshift({d:65535&o,a:a,t:r}):262144&o?n.unshift({d:65535&o,a:a}):524288&o&&(e.cbUseScreenCapture=!0,n.unshift({d:65535&o,a:a,ts:r}))}n.length>0&&i.push(n)})});var n={};i.forEach(function(t){t.forEach(function(e,r){var i=n[e.d];void 0===i&&(i={},n[e.d]=i);for(var a=[],s=r+1;s<t.length;s++)a.push(t[s].d);a.push(e.a);var o=a.join(","),h=i[o];void 0===h&&(h={p:a,t:{},ts:{},tk:{}},i[o]=h),void 0!==e.t?h.t[e.t]=!0:void 0!==e.tk?h.tk[e.tk]=!0:void 0!==e.ts&&(h.ts[e.ts]=!0)})});for(var a=0;a<e.g.boardSize;a++){var s=n[a],o={};t(o,[]),r[1][a]=o,r[-1][a]=o}return r},Model.Game.InitGame=function(){var e=this;this.cbVar=t=this.cbDefine(),this.g.boardSize=this.cbVar.geometry.boardSize,this.g.pTypes=this.cbGetPieceTypes(),this.g.threatGraph=this.cbGetThreatGraph(),this.g.distGraph=this.cbVar.geometry.GetDistances(),this.cbPiecesCount=0,this.g.castleablePiecesCount={1:0,"-1":0};for(var r in t.pieceTypes){var i=t.pieceTypes[r];if(i.castle){(i.initial||[]).forEach(function(t){e.g.castleablePiecesCount[t.s]++})}i.initial&&(this.cbPiecesCount+=i.initial.length)}for(var a=[],r=0;r<this.cbPiecesCount;r++)a.push(r);var n=Object.keys(t.pieceTypes);this.zobrist=new JocGame.Zobrist({board:{type:"array",size:this.cbVar.geometry.boardSize,values:a},who:{values:["1","-1"]},type:{type:"array",size:this.cbPiecesCount,values:n}})},Model.Game.cbGetPieceTypes=function(){for(var t=[],e={},r=0;r<this.cbVar.geometry.boardSize;r++)e[r]=[];for(var i in this.cbVar.pieceTypes){var a=this.cbVar.pieceTypes[i];t[i]={graph:a.graph||e,abbrev:a.abbrev||"",value:a.isKing?100:a.value||1,isKing:!!a.isKing,castle:!!a.castle,epTarget:!!a.epTarget,epCatch:!!a.epCatch}}return t},Model.Board.Init=function(t){this.zSign=0},Model.Board.InitialPosition=function(r){var i=this;this.board=e?new Int16Array(r.g.boardSize):[];for(var a=0;a<r.g.boardSize;a++)this.board[a]=-1;if(this.kings={},this.pieces=[],this.ending={1:!1,"-1":!1},this.lastMove=null,r.cbVar.castle&&(this.castled={1:!1,"-1":!1}),this.zSign=r.zobrist.update(0,"who",-1),this.noCaptCount=0,this.mWho=1,r.mInitial)this.mWho=r.mInitial.turn||1,r.mInitial.pieces.forEach(function(t){var e={};for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);i.pieces.push(e)}),r.mInitial.lastMove&&(this.lastMove={f:r.mInitial.lastMove.f,t:r.mInitial.lastMove.t}),void 0!==r.mInitial.noCaptCount&&(this.noCaptCount=r.mInitial.noCaptCount),r.cbVar.castle&&r.mInitial.castle&&(this.castled={1:{k:!!r.mInitial.castle[1]&&!!r.mInitial.castle[1].k,q:!!r.mInitial.castle[1]&&!!r.mInitial.castle[1].q},"-1":{k:!!r.mInitial.castle[-1]&&!!r.mInitial.castle[-1].k,q:!!r.mInitial.castle[-1]&&!!r.mInitial.castle[-1].q}});else for(var n in r.cbVar.pieceTypes)for(var s=r.cbVar.pieceTypes[n],o=s.initial||[],h=0;h<o.length;h++){var c=o[h],p={s:c.s,t:parseInt(n),p:c.p,m:!1};this.pieces.push(p)}if(this.pieces.sort(function(t,e){if(t.s!=e.s)return e.s-t.s;var i=r.cbVar.pieceTypes[t.t].value||100,a=r.cbVar.pieceTypes[e.t].value||100;return i!=a?i-a:t.p-e.p}),this.pieces.forEach(function(t,e){t.i=e,i.board[t.p]=e,r.g.pTypes[t.t].isKing&&(i.kings[t.s]=t.p),i.zSign=r.zobrist.update(i.zSign,"board",e,t.p),i.zSign=r.zobrist.update(i.zSign,"type",t.t,e)}),r.mInitial&&r.mInitial.enPassant){var a=t.geometry.PosByName(r.mInitial.enPassant);if(a>=0){var l,u=t.geometry.C(a),v=t.geometry.R(a);l=1==r.mInitial.turn?t.geometry.POS(u,v-1):t.geometry.POS(u,v+1),this.epTarget={p:a,i:this.board[l]}}}},Model.Board.CopyFrom=function(t){if(e)this.board=new Int16Array(t.board.length),this.board.set(t.board);else{this.board=[];for(var r=t.board,i=r.length,a=0;a<i;a++)this.board.push(r[a])}this.pieces=[];for(var n=t.pieces.length,a=0;a<n;a++){var s=t.pieces[a];this.pieces.push({s:s.s,p:s.p,t:s.t,i:s.i,m:s.m})}this.kings={1:t.kings[1],"-1":t.kings[-1]},this.check=t.check,t.lastMove?this.lastMove={f:t.lastMove.f,t:t.lastMove.t,c:t.lastMove.c}:this.lastMove=null,this.ending={1:t.ending[1],"-1":t.ending[-1]},void 0!==t.castled&&(this.castled={1:t.castled[1],"-1":t.castled[-1]}),this.noCaptCount=t.noCaptCount,t.epTarget?this.epTarget={p:t.epTarget.p,i:t.epTarget.i}:this.epTarget=null,this.mWho=t.mWho,this.zSign=t.zSign},Model.Board.cbApplyCastle=function(t,e,r){var i=t.cbVar.castle[e.f+"/"+e.cg],a=i.r[i.r.length-1],n=this.pieces[this.board[e.cg]],s=i.k[i.k.length-1],o=this.pieces[this.board[e.f]];return r&&(this.zSign=t.zobrist.update(this.zSign,"board",n.i,e.cg),this.zSign=t.zobrist.update(this.zSign,"board",n.i,a),this.zSign=t.zobrist.update(this.zSign,"board",o.i,e.f),this.zSign=t.zobrist.update(this.zSign,"board",o.i,s)),n.p=a,n.m=!0,this.board[e.cg]=-1,o.p=s,o.m=!0,this.board[e.f]=-1,this.board[a]=n.i,this.board[s]=o.i,this.castled[n.s]=!0,this.kings[o.s]=s,[{i:n.i,f:a,t:-1},{i:o.i,f:s,t:e.f,kp:e.f,who:o.s,m:!1},{i:n.i,f:-1,t:e.cg,m:!1,cg:!1}]},Model.Board.cbQuickApply=function(t,e){if(void 0!==e.cg)return this.cbApplyCastle(t,e,!1);var r=[],i=this.board[e.f],a=this.pieces[i];if(null!=e.c){r.unshift({i:e.c,f:-1,t:this.pieces[e.c].p});var n=this.pieces[e.c];this.board[n.p]=-1,n.p=-1}var s=this.kings[a.s];return t.g.pTypes[a.t].isKing&&(this.kings[a.s]=e.t),r.unshift({i:i,f:e.t,t:e.f,kp:s,who:a.s,ty:a.t}),a.p=e.t,void 0!==e.pr&&(a.t=e.pr),this.board[e.f]=-1,this.board[e.t]=i,r},Model.Board.cbQuickUnapply=function(t,e){for(var r=0;r<e.length;r++){var i=e[r],a=this.pieces[i.i];i.f>=0&&(a.p=-1,this.board[i.f]=-1),i.t>=0&&(a.p=i.t,this.board[i.t]=i.i),void 0!==i.m&&(a.m=i.m),void 0!==i.kp&&(this.kings[i.who]=i.kp),void 0!=i.ty&&(a.t=i.ty),void 0!=i.cg&&(this.castled[a.s]=i.cg)}},Model.Board.ApplyMove=function(t,e){var r=this.pieces[this.board[e.f]];if(void 0!==e.cg)this.cbApplyCastle(t,e,!0);else{if(this.zSign=t.zobrist.update(this.zSign,"board",r.i,e.f),this.board[r.p]=-1,void 0!==e.pr&&(this.zSign=t.zobrist.update(this.zSign,"type",r.t,r.i),r.t=e.pr,this.zSign=t.zobrist.update(this.zSign,"type",r.t,r.i)),null!=e.c){var i=this.pieces[e.c];this.zSign=t.zobrist.update(this.zSign,"board",i.i,i.p),this.board[i.p]=-1,i.p=-1,i.m=!0,this.noCaptCount=0}else this.noCaptCount++;r.p=e.t,r.m=!0,this.board[e.t]=r.i,this.zSign=t.zobrist.update(this.zSign,"board",r.i,e.t),t.g.pTypes[r.t].isKing&&(this.kings[r.s]=e.t)}this.check=!!e.ck,this.lastMove={f:e.f,t:e.t,c:e.c},void 0!==e.ko&&(this.ending[r.s]=e.ko),void 0!==e.ept?this.epTarget={p:e.ept,i:r.i}:this.epTarget=null,this.zSign=t.zobrist.update(this.zSign,"who",-this.mWho),this.zSign=t.zobrist.update(this.zSign,"who",this.mWho)},Model.Board.Evaluate=function(r){function i(e){var r=1/0;for(var i in t.geometry.corners)r=Math.min(r,h.distGraph[n.kings[e]][i]);return r-Math.sqrt(h.boardSize)}var a="debug"==arguments[3],n=this;this.mEvaluation=0;var s,o=this.mWho,h=r.g;if(e)s={1:{count:new Uint8Array(h.pTypes.length),byType:{}},"-1":{count:new Uint8Array(h.pTypes.length),byType:{}}};else{s={1:{count:[],byType:{}},"-1":{count:[],byType:{}}};for(var c=0;c<h.pTypes.length;c++)s[1].count[c]=s[-1].count[c]=0}if(r.mOptions.preventRepeat&&r.GetRepeatOccurence(this)>2)return this.mFinished=!0,void(this.mWinner=r.cbOnPerpetual?o*r.cbOnPerpetual:JocGame.DRAW);for(var p={1:0,"-1":0},l={1:h.distGraph[this.kings[-1]],"-1":h.distGraph[this.kings[1]]},u={1:0,"-1":0},v={1:0,"-1":0},f={1:0,"-1":0},b={1:0,"-1":0},d={1:!1,"-1":!1},g=this.pieces,m=g.length,c=0;c<m;c++){var G=g[c];if(G.p>=0){var y=G.s,M=h.pTypes[G.t];M.isKing?d[y]=G.m:p[y]+=M.value,M.castle&&!G.m&&b[y]++,v[y]++,u[y]+=l[y][G.p],f[y]+=t.geometry.distEdge[G.p];var C=s[y];C.count[G.t]++;var S=C.byType;void 0===S[G.t]?S[G.t]=[G]:S[G.t].push(G)}}if(this.lastMove&&null!=this.lastMove.c){var G=this.pieces[this.board[this.lastMove.t]];p[-G.s]+=this.cbStaticExchangeEval(r,G.p,G.s,{piece:G})}var k={1:0,"-1":0},A={1:0,"-1":0},T={1:0,"-1":0};this.ending[1]&&(A[1]=(u[1]-Math.sqrt(h.boardSize))/v[1],t.geometry.corners&&(T[1]=i(1))),this.ending[-1]&&(A[-1]=(u[-1]-Math.sqrt(h.boardSize))/v[-1],t.geometry.corners&&(T[1]=i(-1)));var z={pieceValue:p[1]-p[-1],pieceValueRatio:(p[1]-p[-1])/(p[1]+p[-1]+1),posValue:f[1]-f[-1],averageDistKing:u[1]/v[1]-u[-1]/v[-1],check:this.check?-o:0,endingKingFreedom:k[1]-k[-1],endingDistKing:A[1]-A[-1],distKingCorner:T[1]-T[-1]};t.castle&&(z.castle=(this.castled[1]?1:d[1]?0:b[1]/(h.castleablePiecesCount[1]+1))-(this.castled[-1]?1:d[-1]?0:b[-1]/(h.castleablePiecesCount[-1]+1))),t.evaluate&&t.evaluate.call(this,r,z,s);var P=r.mOptions.levelOptions;for(var E in z){var R=z[E],w=P[E+"Factor"]||0,I=R*w;a&&console.log(E,"=",R,"*",w,"=>",I),this.mEvaluation+=I}a&&console.log("Evaluation",this.mEvaluation)},Model.Board.cbGeneratePseudoLegalMoves=function(t){function e(e,a){var n=t.cbVar.promote;if(!n)return void i.push(a);var s=n.call(r,t,e,a);if(null!=s)if(0==s.length)i.push(a);else if(1==s.length)a.pr=s[0],i.push(a);else for(var o=0;o<s.length;o++){var h=s[o];i.push({f:a.f,t:a.t,c:a.c,pr:h,ept:a.ept,ep:a.ep,a:a.a})}}for(var r=this,i=[],a=t.cbVar,n=this.mWho,s=!a.castle||this.check||this.castled[n]?null:[],o=-1,h=this.pieces.length,c=0;c<h;c++){var p=this.pieces[c];if(!(p.p<0||p.s!=n)){var l=t.g.pTypes[p.t];l.isKing&&(p.m?s=null:o=p),s&&l.castle&&!p.m&&s.push(p);var u,v;u=l.graph[p.p],v=u.length;for(var f=0;f<v;f++)for(var b=u[f],d=!1,g=b.length,m=null,G=0;G<g;G++){var y=b[G],M=65535&y,C=this.board[M];if(!(C<0)||l.epCatch&&this.epTarget&&this.epTarget.p==M){if(!(524288&y)){var S;S=C<0?this.pieces[this.epTarget.i]:this.pieces[C],!(S.s!=p.s&&131072&y)||1048576&y&&!t.g.pTypes[S.t].isKing||2097152&y&&t.g.pTypes[S.t].isKing||e(p,{f:p.p,t:M,c:S.i,a:l.abbrev,ep:C<0});break}if(d){var S=this.pieces[C];S.s!=p.s&&e(p,{f:p.p,t:M,c:S.i,a:l.abbrev});break}d=!0}else 65536&y&&0==d&&e(p,{f:p.p,t:M,c:null,a:l.abbrev,ept:null!=m&&l.epTarget?m:void 0});m=M}}}if(s)for(var c=0;c<s.length;c++){var k=s[c],A=t.cbVar.castle[o.p+"/"+k.p];if(A){for(var T=!0,f=0;f<A.r.length;f++){var z=A.r[f];if(this.board[z]>=0&&z!=o.p&&z!=k.p){T=!1;break}}if(T){for(var P=!0,f=0;f<A.k.length;f++){var z=A.k[f];if(this.board[z]>=0&&z!=k.p&&z!=o.p||this.cbGetAttackers(t,z,n).length>0){P=!1;break}}P&&i.push({f:o.p,t:A.k[A.k.length-1],c:null,cg:k.p})}}}return i},Model.Board.cbStaticExchangeEval=function(t,e,r,i){var a=0,n=this.cbGetSmallestAttacker(t,e,r);if(n){var s=this.mWho;this.mWho=n.s;var o=this.cbQuickApply(t,{f:n.p,t:e,c:i.piece.i}),h=t.g.pTypes[i.piece.t].value;i.piece=n,a=Math.max(0,h-this.cbStaticExchangeEval(t,e,-r,i)),this.cbQuickUnapply(t,o),this.mWho=s}return a},Model.Board.cbGetSmallestAttacker=function(t,e,r){var i=this.cbGetAttackers(t,e,r);if(0==i.length)return null;for(var a=1/0,n=null,s=i.length,o=0;o<s;o++){var h=i[o],c=t.g.pTypes[h.t].value;c<a&&(a=c,n=h)}return n},Model.Board.cbCollectAttackers=function(t,e,r,i){for(var a in e){var n=e[a],s=this.board[a];if(s<0)this.cbCollectAttackers(t,n.e,r,i);else{var o=this.pieces[s];o.s==-t&&(n.t&&o.t in n.t||i&&n.tk&&o.t in n.tk)&&r.push(o)}}},Model.Board.cbCollectAttackersScreen=function(t,e,r,i,a){for(var n in e){var s=e[n],o=this.board[n];if(o<0)this.cbCollectAttackersScreen(t,s.e,r,i,a);else{var h=this.pieces[o];!a&&h.s==-t&&(s.t&&h.t in s.t||i&&s.tk&&h.t in s.tk)?r.push(h):a?a&&h.s==-t&&s.ts&&h.t in s.ts&&r.push(h):this.cbCollectAttackersScreen(t,s.e,r,i,!0)}}},Model.Board.cbGetAttackers=function(t,e,r,i){var a=[];return t.cbUseScreenCapture?this.cbCollectAttackersScreen(r,t.g.threatGraph[r][e],a,i,!1):this.cbCollectAttackers(r,t.g.threatGraph[r][e],a,i),a},Model.Board.GenerateMoves=function(t){var e=this.cbGeneratePseudoLegalMoves(t);this.mMoves=[];for(var r=!0,i=this.kings[this.mWho],a=e.length,n=0;n<a;n++){var s=e[n],o=this.cbQuickApply(t,s);if(!(this.cbGetAttackers(t,this.kings[this.mWho],this.mWho,!0).length>0)){var h=this.cbGetAttackers(t,this.kings[-this.mWho],-this.mWho,!0).length>0;s.ck=h,this.mMoves.push(s),s.f!=i&&(r=!1)}this.cbQuickUnapply(t,o)}if(0==this.mMoves.length)this.mFinished=!0,this.mWinner=t.cbOnStaleMate?t.cbOnStaleMate*this.mWho:JocGame.DRAW,this.check&&(this.mWinner=-this.mWho);else if(this.ending[this.mWho]){if(!r)for(var n=0;n<this.mMoves.length;n++)this.mMoves[n].ko=!1}else if(!this.ending[this.mWho]&&r&&!this.check)for(var n=0;n<this.mMoves.length;n++)this.mMoves[n].ko=!0},Model.Board.GetSignature=function(){return this.zSign},Model.Move.Init=function(t){for(var e in t)t.hasOwnProperty(e)&&(this[e]=t[e])},Model.Move.Equals=function(t){return this.f==t.f&&this.t==t.t&&this.pr==t.pr},Model.Move.CopyFrom=function(t){this.Init(t)},Model.Move.ToString=function(e){var r=this;switch(e=e||"natural"){case"natural":return function(){var e;if(void 0!==r.cg?e=t.castle[r.f+"/"+r.cg].n:(e=r.a||"",e+=t.geometry.PosName(r.f),null==r.c?e+="-":e+="x",e+=t.geometry.PosName(r.t)),void 0!==r.pr){var i=t.pieceTypes[r.pr];i&&i.abbrev&&i.abbrev.length>0&&!i.silentPromo&&(e+="="+i.abbrev)}return r.ck&&(e+="+"),e}();case"engine":return function(){var e=t.geometry.PosName(r.f)+t.geometry.PosName(r.t);if(void 0!=r.pr){var i=t.pieceTypes[r.pr];i&&i.abbrev&&i.abbrev.length>0&&!i.silentPromo&&(e+=i.abbrev)}return e}();default:return"??"}},Model.Board.CompactMoveString=function(e,r,i){"function"!=typeof r.ToString&&(r=e.CreateMove(r));var a=r.ToString(),n=/^([A-Z]?)([a-z])([1-9][0-9]*)([-x])([a-z])([1-9][0-9]*)(.*?)$/.exec(a);if(!n)return a;var s=n[7];if(i||(i={}),i.value||(i.value=[]),0==i.value.length){var o=this.mMoves;this.mMoves&&0!=this.mMoves.length||this.GenerateMoves(e);for(var h=0;h<this.mMoves.length;h++){var c=this.mMoves[h];"function"!=typeof c.ToString&&(c=e.CreateMove(c)),i.value.push({str:c.ToString(),move:c})}this.mMoves=o}var p=[];if(i.value.forEach(function(t){var e=/^([A-Z]?[a-z][1-9][0-9]*[-x][a-z][1-9][0-9]*)(.*?)$/.exec(t.str);e&&t.move.t==r.t&&(t.move.a||"")==n[1]&&e[2]==s&&p.push(t.move)}),1==p.length)return""==n[1]&&"x"==n[4]?n[2]+"x"+n[5]+n[6]+n[7]:n[1]+("x"==n[4]?"x":"")+n[5]+n[6]+n[7];if(t.geometry.CompactCrit)for(var l="",h=0;;h++){var u=t.geometry.CompactCrit(r.f,h);if(null==u)return a;l+=u;for(var v=[],f=0;f<p.length;f++){var b=p[f];t.geometry.CompactCrit(b.f,h)==u&&v.push(b)}if(console.assert(v.length>0),1==v.length)return n[1]+l+("x"==n[4]?"x":"")+n[5]+n[6]+n[7];p=v}return a},Model.Board.cbIntegrity=function(t){function e(t,e){t||console.error(e)}for(var r=this,i=0;i<this.board.length;i++){var a=this.board[i];if(a>=0){var n=r.pieces[a];e(void 0!==n,"no piece at pos"),e(n.p==i,"piece has different pos")}}for(var a=0;a<this.pieces.length;a++){var n=this.pieces[a];n.p>=0&&e(r.board[n.p]==a,"board index mismatch")}},Model.Board.ExportBoardState=function(t){return t.cbVar.geometry.ExportBoardState?t.cbVar.geometry.ExportBoardState(this,t.cbVar,t.mPlayedMoves.length):"not supported"},Model.Game.Import=function(e,r){var i,a=[],n={1:{},"-1":{}},s=null,o=0;if("pjn"==e){var h={status:!1,error:"parse"},c=r.split(" ");if(6!=c.length)return console.warn("FEN should have 6 parts"),h;var p=c[0].split("/"),l=t.geometry.fenHeight||t.geometry.height;if(p.length!=l)return console.warn("FEN board should have",l,"rows, got",p.length),h;var u={};for(var v in t.pieceTypes){var f=t.pieceTypes[v],b=f.fenAbbrev||f.abbrev||"X";u[b.toUpperCase()]={s:1,t:v},u[b.toLowerCase()]={s:-1,t:v}}var d=t.geometry.FenRowPos||function(e,r){return(t.geometry.height-1-e)*t.geometry.width+r};if(p.forEach(function(e,r){for(var i=0,n=0;n<e.length;n++){var s=e.substr(n,1),o=u[s];if(void 0!==o){var c=d(r,i);i++;for(var p={s:o.s,t:o.t,p:c},l=!0,v=t.pieceTypes[p.t].initial||[],f=0;f<v.length;f++){var b=v[f];b.s==p.s&&b.p==c&&(l=!1)}p.m=l,a.push(p)}else{if(isNaN(parseInt(s)))return console.warn("FEN invalid board spec",s),h;i+=parseInt(s)}}}),a.sort(function(t,e){return e.s-t.s}),"w"==c[1])i=1;else{if("b"!=c[1])return console.warn("FEN invalid turn spec",c[1]),h;i=-1}n[1].k=c[2].indexOf("K")>=0,n[1].q=c[2].indexOf("Q")>=0,n[-1].k=c[2].indexOf("k")>=0,n[-1].q=c[2].indexOf("q")>=0,s="-"==c[3]?null:c[3];var g=parseInt(c[4]);isNaN(g)||(o=g);var m={pieces:a,turn:i,castle:n,enPassant:s,noCaptCount:o};return t.importGame&&t.importGame.call(this,m,e,r),{status:!0,initial:m}}return{status:!1,error:"unsupported"}}}(),function(){Model.Game.cbBoardGeometryGrid=function(t,e){function r(e){return e%t}function i(e){return Math.floor(e/t)}function a(e,r){return r*t+e}function n(n,s){var o=r(n),h=i(n),c=o+s[0],p=h+s[1];return c<0||c>=t||p<0||p>=e?null:a(c,p)}function s(t){return String.fromCharCode("a".charCodeAt(0)+r(t))+(i(t)+1)}function o(t){var e=/^([a-z])([0-9]+)$/.exec(t);return e?a(e[1].charCodeAt(0)-"a".charCodeAt(0),parseInt(e[2])-1):-1}function h(t,e){return 0==e?String.fromCharCode("a".charCodeAt(0)+r(t)):1==e?i(t)+1:null}function c(){for(var a=[],n=0;n<t*e;n++){var s=[];a.push(s);for(var o=0;o<t*e;o++){var h=i(n),c=r(n),p=i(o),l=r(o);s.push(Math.max(Math.abs(h-p),Math.abs(c-l)))}}return a}function p(r,i,n){for(var o=[],h=e-1;h>=0;h--){for(var c="",p=0,l=0;l<t;l++){var u=r.board[a(l,h)];if(u<0)p++;else{p>0&&(c+=p,p=0);var v=r.pieces[u],f=i.pieceTypes[v.t].fenAbbrev||i.pieceTypes[v.t].abbrev||"?";v.s==-1?c+=f.toLowerCase():c+=f.toUpperCase()}}p&&(c+=p),o.push(c)}var b=o.join("/");b+=" ",1==r.mWho?b+="w":b+="b",b+=" ";var d="";return r.castled&&(r.castled[1]===!1?d+="KQ":(r.castled[1].k&&(d+="K"),r.castled[1].q&&(d+="Q")),r.castled[-1]===!1?d+="kq":(r.castled[-1].k&&(d+="k"),r.castled[-1].q&&(d+="q"))),0==d.length&&(d="-"),b+=d,b+=" ",r.epTarget?b+=s(r.epTarget.p):b+="-",b+=" ",b+=r.noCaptCount,b+=" ",b+=Math.floor(n/2)+1}return{boardSize:t*e,width:t,height:e,C:r,R:i,POS:a,Graph:n,PosName:s,PosByName:o,CompactCrit:h,GetDistances:c,distEdge:function(){for(var a=[],n=0;n<t*e;n++){var s=r(n),o=i(n);a[n]=Math.min(s,Math.abs(t-s-1),o,Math.abs(e-o-1))}return a}(),corners:function(){var r={};return r[a(0,0)]=1,r[a(0,e-1)]=1,r[a(t-1,0)]=1,r[a(t-1,e-1)]=1,r}(),ExportBoardState:p}},Model.Game.cbPawnGraph=function(t,e,r){for(var i=this,a={},n=0;n<t.boardSize;n++)if(!r||n in r){var s=[],o=t.Graph(n,[0,e]);null!=o&&(!r||o in r)&&s.push(i.cbTypedArray([o|i.cbConstants.FLAG_MOVE])),[-1,1].forEach(function(a){var o=t.Graph(n,[a,e]);null!=o&&(!r||o in r)&&s.push(i.cbTypedArray([o|i.cbConstants.FLAG_CAPTURE]))}),a[n]=s}else a[n]=[];return a},Model.Game.cbInitialPawnGraph=function(t,e,r){for(var i=this,a={},n=0;n<t.boardSize;n++)if(!r||n in r){var s=[],o=t.Graph(n,[0,e]);if(null!=o&&(!r||o in r)){var h=[o|i.cbConstants.FLAG_MOVE],c=t.Graph(o,[0,e]);null!=c&&(!r||c in r)&&h.push(c|i.cbConstants.FLAG_MOVE),s.push(i.cbTypedArray(h))}[-1,1].forEach(function(a){var o=t.Graph(n,[a,e]);null!=o&&(!r||o in r)&&s.push(i.cbTypedArray([o|i.cbConstants.FLAG_CAPTURE]))}),a[n]=s}else a[n]=[];return a},Model.Game.cbKingGraph=function(t,e){return this.cbShortRangeGraph(t,[[-1,-1],[-1,0],[-1,1],[0,-1],[0,1],[1,-1],[1,0],[1,1]],e)},Model.Game.cbKnightGraph=function(t,e){return this.cbShortRangeGraph(t,[[2,-1],[2,1],[-2,-1],[-2,1],[-1,2],[-1,-2],[1,2],[1,-2]],e)},Model.Game.cbHorseGraph=function(t){for(var e=this,r={},i=0;i<t.boardSize;i++)r[i]=[],[[1,0,2,-1],[1,0,2,1],[-1,0,-2,-1],[-1,0,-2,1],[0,1,-1,2],[0,-1,-1,-2],[0,1,1,2],[0,-1,1,-2]].forEach(function(a){var n=t.Graph(i,[a[0],a[1]]);if(null!=n){var s=t.Graph(i,[a[2],a[3]]);null!=s&&r[i].push(e.cbTypedArray([n|e.cbConstants.FLAG_STOP,s|e.cbConstants.FLAG_MOVE|e.cbConstants.FLAG_CAPTURE]))}});return r},Model.Game.cbRookGraph=function(t,e){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0]],e)},Model.Game.cbBishopGraph=function(t,e){return this.cbLongRangeGraph(t,[[1,-1],[1,1],[-1,1],[-1,-1]],e)},Model.Game.cbQueenGraph=function(t,e){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0],[1,-1],[1,1],[-1,1],[-1,-1]],e)},Model.Game.cbXQGeneralGraph=function(t,e){for(var r=this,i={},a=0;a<t.boardSize;a++)i[a]=[],[[-1,0,!1],[0,-1,!0],[0,1,!0],[1,0,!1]].forEach(function(n){var s=[],o=t.Graph(a,n);if(null!=o&&((!e||o in e)&&s.push(o|r.cbConstants.FLAG_MOVE|r.cbConstants.FLAG_CAPTURE),n[2]))for(var h=t.Graph(o,n);null!=h;)!e||h in e?s.push(h|r.cbConstants.FLAG_CAPTURE|r.cbConstants.FLAG_CAPTURE_KING):s.push(h|r.cbConstants.FLAG_STOP),h=t.Graph(h,n);s.length>0&&i[a].push(r.cbTypedArray(s))});return i},Model.Game.cbXQSoldierGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e]])},Model.Game.cbXQPromoSoldierGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e],[-1,0],[1,0]])},Model.Game.cbXQAdvisorGraph=function(t,e){return this.cbShortRangeGraph(t,[[1,1],[-1,1],[1,-1],[-1,-1]],e)},Model.Game.cbXQCannonGraph=function(t){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0]],null,this.cbConstants.FLAG_MOVE|this.cbConstants.FLAG_SCREEN_CAPTURE)},Model.Game.cbXQElephantGraph=function(t,e){for(var r=this,i={},a=0;a<t.boardSize;a++)i[a]=[],(!e||a in e)&&[[1,1,2,2],[1,-1,2,-2],[-1,1,-2,2],[-1,-1,-2,-2]].forEach(function(n){var s=t.Graph(a,[n[0],n[1]]);if(null!=s){var o=t.Graph(a,[n[2],n[3]]);null!=o&&(!e||o in e)&&i[a].push(r.cbTypedArray([s|r.cbConstants.FLAG_STOP,o|r.cbConstants.FLAG_MOVE|r.cbConstants.FLAG_CAPTURE]))}});return i},Model.Game.cbSilverGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e],[-1,-1],[-1,1],[1,-1],[1,1]])},Model.Game.cbFersGraph=function(t,e){return this.cbShortRangeGraph(t,[[-1,-1],[-1,1],[1,-1],[1,1]])},Model.Game.cbSchleichGraph=function(t,e){return this.cbShortRangeGraph(t,[[-1,0],[1,0],[0,-1],[0,1]])},Model.Game.cbAlfilGraph=function(t,e){return this.cbShortRangeGraph(t,[[-2,-2],[-2,2],[2,2],[2,-2]])}}(),function(){var t=Model.Game.cbBoardGeometryGrid(6,6);Model.Game.cbDefine=function(){return{geometry:t,pieceTypes:{0:{name:"pawn-w",aspect:"pawn",graph:this.cbPawnGraph(t,1),value:1,abbrev:"",fenAbbrev:"P",initial:[{s:1,p:6},{s:1,p:7},{s:1,p:8},{s:1,p:9},{s:1,p:10},{s:1,p:11}],epCatch:!1},2:{name:"pawn-b",aspect:"pawn",graph:this.cbPawnGraph(t,-1),value:1,abbrev:"",fenAbbrev:"P",epCatch:!1,initial:[{s:-1,p:24},{s:-1,p:25},{s:-1,p:26},{s:-1,p:27},{s:-1,p:28},{s:-1,p:29}]},4:{name:"knight",graph:this.cbKnightGraph(t),value:2.9,abbrev:"N",initial:[{s:1,p:1},{s:1,p:4},{s:-1,p:31},{s:-1,p:34}]},6:{name:"rook",graph:this.cbRookGraph(t),value:5,abbrev:"R",initial:[{s:1,p:0},{s:1,p:5},{s:-1,p:30},{s:-1,p:35}],castle:!0},7:{name:"queen",graph:this.cbQueenGraph(t),value:9,abbrev:"Q",initial:[{s:1,p:3},{s:-1,p:33}]},8:{name:"king",isKing:!0,graph:this.cbKingGraph(t),abbrev:"K",initial:[{s:1,p:2},{s:-1,p:32}]}},promote:function(e,r,i){return 0==r.t&&5==t.R(i.t)?[4,6,7]:2==r.t&&0==t.R(i.t)?[4,6,7]:[]},evaluate:function(e,r,i){var a=i[1].count,n=i[-1].count;a[0]||a[1]||a[4]||a[5]||a[6]||a[7]||n[2]||n[3]||n[6]||n[7]||!(n[4]+n[5]<2||n[5]<2)||(this.mFinished=!0,this.mWinner=JocGame.DRAW),n[2]||n[3]||n[4]||n[5]||n[6]||n[7]||a[0]||a[1]||a[6]||a[7]||!(a[4]+a[5]<2||a[5]<2)||(this.mFinished=!0,this.mWinner=JocGame.DRAW),this.noCaptCount>=100&&(this.mFinished=!0,this.mWinner=JocGame.DRAW);var s,o=e.cbUseTypedArrays?new Int8Array(3):[0,0,0],h=t.height,c=i[1].byType[0];if(c){s=c.length;for(var p=0;p<s;p++)switch(h-t.R(c[p].p)){case 2:o[0]++;break;case 3:o[1]++;break;case 4:o[2]++}}if(c=i[-1].byType[2]){s=c.length;for(var p=0;p<s;p++)switch(t.R(c[p].p)){case 1:o[0]--;break;case 2:o[1]--;break;case 3:o[2]--}}0!=o[0]&&(r.distPawnPromo1=o[0]),0!=o[1]&&(r.distPawnPromo2=o[1]),0!=o[2]&&(r.distPawnPromo3=o[2]);for(var l=0,u=4;u<=5;u++)for(var v=1;v>=-1;v-=2){var f=i[v].byType[u];if(f)for(var p=0;p<f.length;p++)f[p].m&&(l+=v)}0!=l&&(r.minorPiecesMoved=l)}}}}();

/***/ }),

/***/ "iIfT":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var pairwise_1 = __webpack_require__("Ffu+");
Observable_1.Observable.prototype.pairwise = pairwise_1.pairwise;
//# sourceMappingURL=pairwise.js.map

/***/ }),

/***/ "iJMh":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var forkJoin_1 = __webpack_require__("7rB9");
Observable_1.Observable.forkJoin = forkJoin_1.forkJoin;
//# sourceMappingURL=forkJoin.js.map

/***/ }),

/***/ "iN5t":
/***/ (function(module, exports) {

exports.model=Model={Game:{},Board:{},Move:{}},function(){var t,s,o="undefined"!=typeof Int8Array;o?(t=function(t){return new Int8Array(t)},s=function(t){var s=new Int8Array(t.length);return s.set(t),s}):(t=function(t){for(var s=[],o=0;o<t;o++)s.push(0);return s},s=function(t){for(var s=[],o=t.length,i=0;i<o;i++)s.push(t[i]);return s}),Model.Game.isAlive=function(t,s){return this.POS(s,t)in this.g.confine},Model.Game.C=function(t){return t%this.mOptions.width},Model.Game.R=function(t){return Math.floor(t/this.mOptions.width)},Model.Game.RC=function(t){return{r:Math.floor(t/this.mOptions.width),c:t%this.mOptions.width}},Model.Game.POS=function(t,s){return s*this.mOptions.width+t},Model.Game.STR2POS=function(t){var s=/^(\d+):(\d+)$/.exec(t);if(s){var o=parseInt(s[1]),i=parseInt(s[2]);return this.POS(i,o)}return null},Model.Game.InitGame=function(){var s=this.NBCOLS=this.mOptions.width,o=this.NBROWS=this.mOptions.height;this.g.confine={},this.g.totalCount=o*s;for(var i=0;i<o;i++)for(var r=0;r<s;r++)this.g.confine[this.POS(r,i)]=1;if(this.mOptions.deadCells)for(var e in this.mOptions.deadCells){var a=this.STR2POS(e);null!=a&&(this.g.totalCount--,delete this.g.confine[a])}this.g.dirDeltaRC=[[1,-1],[1,0],[1,1],[0,1],[-1,1],[-1,0],[-1,-1],[0,-1]],this.g.Graph={};for(var i=0;i<o;i++)for(var r=0;r<s;r++){var a=this.POS(r,i);if(a in this.g.confine){for(var h=t(this.g.dirDeltaRC.length),n=0;n<this.g.dirDeltaRC.length;n++){var l=this.g.dirDeltaRC[n],v=i+l[0],d=r+l[1],u=v*s+d;v>=0&&d>=0&&v<o&&d<s&&u in this.g.confine?h[n]=u:h[n]=-1}this.g.Graph[a]=h}}this.g.corners={};for(var a in this.g.confine){for(var f=0,l=0;l<8;l++){var u=this.g.Graph[a][l];u<0&&(f|=1<<l)}15!=(15&f)&&30!=(30&f)&&60!=(60&f)&&120!=(120&f)&&240!=(240&f)&&225!=(225&f)&&195!=(195&f)&&135!=(135&f)||(this.g.corners[a]=1)}this.g.borders={};for(var a in this.g.confine)if(!(a in this.g.corners)){for(var f=0,l=0;l<8;l++){var u=this.g.Graph[a][l];u<0&&(f|=1<<l)}7!=(7&f)&&14!=(14&f)&&28!=(28&f)&&56!=(56&f)&&112!=(112&f)&&224!=(224&f)&&193!=(193&f)&&131!=(131&f)||(this.g.borders[a]=1)}this.zobrist=new JocGame.Zobrist({board:{type:"array",size:s*o,values:["1","-1"]}})},Model.Move.Init=function(t){this.row=t.row,this.col=t.col,this.pass=t.pass},Model.Move.CopyFrom=function(t){this.row=t.row,this.col=t.col,this.pass=t.pass},Model.Move.ToString=function(){return this.pass?"-":String.fromCharCode("a".charCodeAt(0)+this.col)+(this.row+1)},Model.Move.Equals=function(t){return!(!t.pass||!this.pass)||this.row==t.row&&this.col==t.col},Model.Board.Init=function(t){this.zSign=0},Model.Board.InitialPosition=function(s){this.board=t(s.mOptions.width*s.mOptions.height),this.counts=[0,0],this.freeClose={},this.passes=0,this.lastMove=null;var o=this;[1,-1].forEach(function(t){var i=(1-t)/2;s.mOptions.initial[t].forEach(function(r){o.counts[i]++;var e=s.STR2POS(r);o.board[e]=t,delete o.freeClose[e];for(var a=0;a<8;a++){var h=s.g.Graph[e][a];h<0||(o.board[h]||(o.freeClose[h]=1))}o.zSign=s.zobrist.update(o.zSign,"board",t,e)})}),this.FindMoves(s),this.stable={};for(var i in s.g.corners)this.stable[i]=3;this.aboutStable={},this.aboutBorder={},this.rvUpdateStable(s,s.g.corners),this.rvUpdateAboutBorder(s)},Model.Board.CopyFrom=function(t){this.mWho=t.mWho,this.zSign=t.zSign,this.board=s(t.board),this.counts=[t.counts[0],t.counts[1]],this.freeClose={};for(var o in t.freeClose)this.freeClose[o]=1;this.passes=t.passes,this.lastMove=null,t.lastMove?this.lastMove={row:t.lastMove.row,col:t.lastMove.col}:this.lastMove=null,this.movePoss={1:s(t.movePoss[1]),"-1":s(t.movePoss[-1])},this.stable=t.stable,this.aboutStable=t.aboutStable,this.aboutBorder=t.aboutBorder},Model.Board.GenerateMoves=function(t){this.mMoves=[];for(var s=0;s<this.movePoss[this.mWho].length;s++){var o=this.movePoss[this.mWho][s],i=t.RC(o);this.PushMove(t,{row:i.r,col:i.c})}0==this.mMoves.length&&this.PushMove(t,{pass:!0,row:-1,col:-1})},Model.Board.FindMoves=function(t){this.movePoss={1:[],"-1":[]};var s=t.g.Graph;for(var o in this.freeClose){for(var i=s[o],r=0,e=0;e<8;e++){var a=i[e];if(a>=0){var h=-this.board[a];if(h){var n=1==h?1:2;if(!(r&n)){for(!0,a=s[a][e];this.board[a]==-h;)a=s[a][e];if(a>=0&&this.board[a]==h&&(r|=n),3==r)break}}}}1&r&&this.movePoss[1].push(o),2&r&&this.movePoss[-1].push(o)}},Model.Board.ApplyMove=function(t,s){if(this.lastMove=null,s.pass)return void this.passes++;this.lastMove={row:s.row,col:s.col},this.passes=0;var o=(1-this.mWho)/2,i=1<<o;this.counts[o]++;var r=t.POS(s.col,s.row),e=t.g.Graph,a=e[r];this.board[r]=this.mWho,this.zSign=t.zobrist.update(this.zSign,"board",this.mWho,r),delete this.freeClose[r];var h=!1,n={};(this.stable[r]||0)&i&&(h=!0,n[r]=1);for(var l=0;l<8;l++){var v=a[l];v>=0&&0==this.board[v]&&(this.freeClose[v]=1);for(var d=[];v>=0&&this.board[v]==-this.mWho;)d.push(v),v=e[v][l];if(v>=0&&d.length>0&&this.board[v]==this.mWho)for(var u=d.length-1;u>=0;u--){var f=d[u];this.zSign=t.zobrist.update(this.zSign,"board",-this.mWho,f),this.zSign=t.zobrist.update(this.zSign,"board",this.mWho,f),this.board[f]=this.mWho,this.counts[o]++,this.counts[1-o]--,(this.stable[f]||0)&i&&(h=!0,n[f]=1)}}h&&this.rvUpdateStable(t,n),r in t.g.borders&&this.rvUpdateAboutBorder(t),this.FindMoves(t)},Model.Board.rvUpdateStable=function(t,s){var o=this.stable;this.stable={};for(var i in o)this.stable[i]=o[i];for(var r=!0,e=1==this.mWho?1:2,a=t.g.Graph;r;){r=!1;var h={};for(var i in s)for(var n=a[i],l=0;l<8;l++){var v=n[l];v>=0&&!((this.stable[v]||0)&e)&&(h[v]=1)}var s={};for(var i in h){for(var n=a[i],d=0,l=0;l<8;l++){var v=n[l];(v<0||this.board[v]==this.mWho&&(this.stable[v]||0)&e)&&(d|=1<<l)}15!=(15&d)&&30!=(30&d)&&60!=(60&d)&&120!=(120&d)&&240!=(240&d)&&225!=(225&d)&&195!=(195&d)&&135!=(135&d)||(this.stable[i]=(this.stable[i]||0)|e,r=!0,s[i]=1)}}this.aboutStable={};for(var i in this.stable)if(!this.board[i])for(var n=a[i],l=0;l<8;l++){var v=n[l];v>=0&&!(v in this.stable)&&(this.aboutStable[v]=(this.aboutStable[v]||0)|this.stable[i])}},Model.Board.rvUpdateAboutBorder=function(t){this.aboutBorder={};var s=t.g.Graph,o=t.g.borders;for(var i in o)if(!this.board[i])for(var r=s[i],e=0;e<8;e++){var a=r[e];!(a>=0)||a in this.stable||a in this.aboutStable||a in o||(this.aboutBorder[a]=1)}},Model.Board.Evaluate=function(t){this.mEvaluation=0;t.mOptions.width,t.mOptions.height;if(2==this.passes||this.counts[0]+this.counts[1]==t.g.totalCount||0==this.counts[0]||0==this.counts[1])return this.mFinished=!0,void(this.counts[0]>this.counts[1]?this.mWinner=JocGame.PLAYER_A:this.counts[0]<this.counts[1]?this.mWinner=JocGame.PLAYER_B:this.mWinner=JocGame.DRAW);var s=t.mOptions.levelOptions,o={},i={1:0,"-1":0},r={1:0,"-1":0},e={1:0,"-1":0},a={1:0,"-1":0},h=t.g.confine,n=t.g.borders;for(var l in h){var v=this.board[l];if(v){var d=1==v?1:2,u=1==v?2:1;(this.stable[l]||0)&d?i[v]++:(this.aboutStable[l]||0)&u?l in n?e[v]++:r[v]++:l in n&&a[v]++}}o.stable=i[1]-i[-1],o.aboutStable=r[1]-r[-1],o.aboutStableBorder=e[1]-e[-1],o.border=a[1]-a[-1],o.count=this.counts[0]-this.counts[1];var f=this.movePoss[1].length+this.movePoss[-1].length;o.mobility=f?(this.movePoss[1].length-this.movePoss[-1].length)/f:0;for(var b in o){var c=o[b],m=s[b+"Factor"]||0,g=c*m;this.mEvaluation+=g}},Model.Board.GetSignature=function(){return this.zSign}}();

/***/ }),

/***/ "iUY6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var if_1 = __webpack_require__("5nj5");
Observable_1.Observable.if = if_1._if;
//# sourceMappingURL=if.js.map

/***/ }),

/***/ "ioK+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var PromiseObservable_1 = __webpack_require__("hYBY");
exports.fromPromise = PromiseObservable_1.PromiseObservable.create;
//# sourceMappingURL=fromPromise.js.map

/***/ }),

/***/ "iod1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var zip_1 = __webpack_require__("8/gC");
Observable_1.Observable.zip = zip_1.zip;
//# sourceMappingURL=zip.js.map

/***/ }),

/***/ "ip4H":
/***/ (function(module, exports) {

exports.config = {"status":true,"model":{"plazza":"true","title-en":"9 Men´s Morris Fly","module":"mills","maxLevel":7,"summary":"An old board game","thumbnail":"mensmorris9-thumb3d.png","rules":"rules.html","description":"description.html","credits":"credits.html","js":["mills-model.js","9-men-morris-model.js"],"gameOptions":{"preventRepeat":true,"width":7,"height":7,"mencount":9,"canFly":true},"levels":[{"label":"Easy","maxDepth":2,"potential":100,"placingRace":1,"isDefault":true},{"label":"Medium","maxDepth":4,"potential":300,"placingRace":1},{"label":"Hard","maxDepth":8,"potential":1000,"placingRace":2}]},"view":{"js":["mills-xd-view.js","9-men-morris-view.js"],"visuals":{"600x600":["res/visuals/ninemen-600x600-3d.jpg","res/visuals/ninemen-600x600-2d.jpg"]},"xdView":true,"css":["mills.css","9-men-morris.css"],"title-en":"9 Men´s Morris View","module":"mills","preferredRatio":1.2857142857143,"switchable":true,"animateSelfMoves":false,"useNotation":true,"useShowMoves":true,"defaultOptions":{"sounds":true,"notation":false,"moves":true},"sounds":{"move1":"move1","move2":"move2","move3":"move3","move4":"move4","tac1":"tac1","tac2":"tac2","tac3":"tac3","capture":"promo","usermove":null},"skins":[{"name":"classic3d","title":"3D Classic","3d":true,"camera":{"radius":14,"elevationAngle":45,"distMax":39.5,"distMin":10.1,"elevationMin":-89.9,"elevationMax":89.9,"limitCamMoves":true},"world":{"lightIntensity":0.6,"skyLightIntensity":0.3,"lightPosition":{"x":0,"y":18,"z":0},"color":0,"fog":false},"preload":["image|/res/xd-view/meshes/woodcell1x512.jpg","image|/res/xd-view/meshes/piecetop-bump.jpg","image|/res/xd-view/meshes/piecediff.jpg","smoothedfilegeo|0|/res/xd-view/meshes/piece-v2.js","smoothedfilegeo|0|/res/xd-view/meshes/boardoriented.js","smoothedfilegeo|0|/res/xd-view/meshes/ring-target.js"]},{"name":"stone","title":"Stone"},{"name":"suede","title":"Suede"},{"name":"wood","title":"Wood"}]}}

/***/ }),

/***/ "irHR":
/***/ (function(module, exports, __webpack_require__) {

module.exports = exports = __webpack_require__("Mrf4");


/***/ }),

/***/ "ixac":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var zip_1 = __webpack_require__("RYQg");
Observable_1.Observable.prototype.zip = zip_1.zipProto;
//# sourceMappingURL=zip.js.map

/***/ }),

/***/ "iyeI":
/***/ (function(module, exports) {

exports.config = {"status":true,"model":{"plazza":"true","released":1405068613,"title-en":"Reformed Courierspiel","module":"chessbase","summary":"Clément Bégnis, 2011","thumbnail":"reformed-courier-thumb.png","rules":{"en":"reformed-courier-rules.html"},"credits":{"en":"reformed-courier-credits.html"},"gameOptions":{"preventRepeat":true,"uctTransposition":"state","uctIgnoreLoop":false,"levelOptions":{"pieceValueFactor":1,"pieceValueRatioFactor":1,"posValueFactor":0.1,"averageDistKingFactor":-0.01,"castleFactor":0.1,"minorPiecesMovedFactor":0.1,"checkFactor":0.2,"endingKingFreedomFactor":0.01,"endingDistKingFactor":0.05,"distKingCornerFactor":0.1,"distPawnPromo1Factor":0.3,"distPawnPromo2Factor":0.1,"distPawnPromo3Factor":0.05}},"obsolete":false,"js":["base-model.js","grid-geo-model.js","reformed-courier-model.js"],"description":{"en":"reformed-courier-description.html"},"levels":[{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"easy","label":"Easy","maxNodes":1000},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"fast","label":"Fast [1sec]","maxDuration":1,"isDefault":true},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"medium","label":"Medium","maxNodes":10000,"maxDuration":10},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"strong","label":"Strong","maxNodes":20000,"maxDuration":15}]},"view":{"title-en":"Chessbase view","module":"chessbase","xdView":true,"css":["chessbase.css"],"preferredRatio":1,"useShowMoves":true,"useNotation":true,"useAutoComplete":true,"defaultOptions":{"sounds":true,"moves":true,"notation":false,"autocomplete":false},"skins":[{"name":"skin3d","title":"3D Classic","3d":true,"preload":["smoothedfilegeo|0|/res/ring-target.js","image|/res/images/cancel.png","image|/res/images/wikipedia.png","smoothedfilegeo|0|/res/fairy/pawn/pawn.js","image|/res/fairy/pawn/pawn-diffusemap.jpg","image|/res/fairy/pawn/pawn-normalmap.jpg","smoothedfilegeo|0|/res/fairy/knight/knight.js","image|/res/fairy/knight/knight-diffusemap.jpg","image|/res/fairy/knight/knight-normalmap.jpg","smoothedfilegeo|0|/res/fairy/bishop/bishop.js","image|/res/fairy/bishop/bishop-diffusemap.jpg","image|/res/fairy/bishop/bishop-normalmap.jpg","smoothedfilegeo|0|/res/fairy/king/king.js","image|/res/fairy/king/king-diffusemap.jpg","image|/res/fairy/king/king-normalmap.jpg","smoothedfilegeo|0|/res/fairy/rook/rook.js","image|/res/fairy/rook/rook-diffusemap.jpg","image|/res/fairy/rook/rook-normalmap.jpg","smoothedfilegeo|0|/res/fairy/queen/queen.js","image|/res/fairy/queen/queen-diffusemap.jpg","image|/res/fairy/queen/queen-normalmap.jpg","smoothedfilegeo|0|/res/fairy/elephant/elephant.js","image|/res/fairy/elephant/elephant-diffusemap.jpg","image|/res/fairy/elephant/elephant-normalmap.jpg","smoothedfilegeo|0|/res/fairy/lighthouse/lighthouse.js","image|/res/fairy/lighthouse/lighthouse-diffusemap.jpg","image|/res/fairy/lighthouse/lighthouse-normalmap.jpg","smoothedfilegeo|0|/res/fairy/unicorn/unicorn.js","image|/res/fairy/unicorn/unicorn-diffusemap.jpg","image|/res/fairy/unicorn/unicorn-normalmap.jpg"],"world":{"lightIntensity":1.3,"skyLightIntensity":1.2,"lightCastShadow":true,"fog":false,"color":4686804,"lightPosition":{"x":-9,"y":9,"z":9},"skyLightPosition":{"x":9,"y":9,"z":9},"lightShadowDarkness":0.55,"ambientLightColor":2236962},"camera":{"fov":45,"distMax":50,"radius":18,"elevationAngle":60,"elevationMin":0}},{"name":"skin2d","title":"2D Classic","3d":false,"preload":["image|/res/images/cancel.png","image|/res/images/whitebg.png","image|/res/fairy/wikipedia-fairy-sprites.png"]}],"animateSelfMoves":false,"switchable":true,"sounds":{"move1":"alq_move1","move2":"alq_move2","move3":"alq_move3","move4":"alq_move2","tac1":"alq_tac1","tac2":"alq_tac2","tac3":"alq_tac1","promo":"promo","usermove":null},"js":["base-view.js","grid-board-view.js","fairy-set-view.js","reformed-courier-view.js"],"visuals":{"600x600":["res/visuals/reformed-courier-600x600-3d.jpg","res/visuals/reformed-courier-600x600-2d.jpg"]}}}

/***/ }),

/***/ "iz9z":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {var require;var _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e};try{exports.Game=JocGame=function(){},exports.Board=JocBoard=function(){},exports.Move=JocMove=function(){}}catch(e){global.JocGame=exports.Game=function(){},global.JocBoard=exports.Board=function(){},global.JocMove=exports.Move=function(){},function(){var e=require,t=__webpack_require__("mzA9");global.MersenneTwister=t.MersenneTwister,global.JocUtil=t.JocUtil,global.JoclyUCT=__webpack_require__("yEe/").JoclyUCT}()}JocGame.PLAYER_A=1,JocGame.PLAYER_B=-1,JocGame.DRAW=2,"undefined"!=typeof document?JocGame.CLICK="ontouchstart"in document.documentElement?"touchstart":"click":JocGame.CLICK="click",JocGame.MOUSEMOVE_EVENT="touchmove mousemove",JocGame.MOUSEDOWN_EVENT="touchstart mousedown",JocGame.MOUSEUP_EVENT="touchend mouseup joclyclick",JocGame.MAX_VALUE=Math.pow(2,53),JocGame.prototype={},JocGame.prototype.Init=function(e){this.mWho=JocGame.PLAYER_A,this.mViewAs=JocGame.PLAYER_A,this.mTopLevel=3,this.mLoopMax=300,this.mPreventRepeat=!1,e&&(this.mOptions=e.game,this.mViewOptions=e.view,this.mSkin=this.mViewOptions.skins[0].name,this.mNotation=!1,this.mShowMoves=this.mViewOptions.useShowMoves,this.mSounds=!!this.mViewOptions.sounds,this.mAutoComplete=!1,void 0!==this.mOptions.level&&(this.mTopLevel=this.mOptions.level),void 0!==this.mOptions.loopMax&&(this.mLoopMax=this.mOptions.loopMax),this.mVisitedBoards={},void 0!==this.mOptions.viewAs&&(this.mViewAs=this.mOptions.viewAs)),this.mNextSchedule=null,this.mPlayedMoves=[],this.mFullPlayedMoves=[],this.mViewInited=!1,this.mGameInited=!1,e&&e.initial?this.GameInitGame(e.initial):this.GameInitGame(),this.mBoard=new(this.GetBoardClass())(this),this.mBoard.InitialPosition&&this.mBoard.InitialPosition(this),this.mBoard.mMoves=[],this.mBoard.mWho=this.mWho,this.listeners=[]},JocGame.prototype.AddListener=function(e){this.listeners.push(e)},JocGame.prototype.RemoveListener=function(e){for(var t=this.listeners.length-1;t>=0;t--)this.listeners[t]==e&&this.listeners.splice(t,1)},JocGame.prototype.DispatchMessage=function(e){var t=this;this.listeners.forEach(function(o){o.call(t,e)})},JocGame.prototype.HumanMove=function(e){this.DispatchMessage({type:"human-move",move:e})},JocGame.prototype.MakeMove=function(e){this.HumanMove(e)},JocGame.prototype.MachineMove=function(e){this.DispatchMessage({type:"machine-move",result:e})},JocGame.prototype.MachineProgress=function(e){this.DispatchMessage({type:"machine-progress",progress:e})},JocGame.prototype.PlayMove=function(e){var t=this;return new Promise(function(o,i){t.mOldBoard=new(t.GetBoardClass())(t),t.mOldBoard.CopyFrom(t.mBoard),t.ApplyMove(e),t.mBoard.PlayedMove(t,e)?o():t.MoveShown=function(){delete t.MoveShown,o()}})},JocGame.prototype.InvertWho=function(){var e=this.GetWho();this.SetWho(-e)},JocGame.prototype.AttachElement=function(e,t){t=t||{};var o=this;return this.widget=e,new Promise(function(e,t){if(o.gamePreAttachProto)t(new Error("Game already attached"));else{var i={meta:{"jocly-xdview.js":{globals:{jQuery:"jquery.js",THREE:"three.js"}}}};i.meta["games/"+o.module+"/"+o.name+"-view.js"]={globals:{xdview:"jocly-xdview.js",jQuery:"jquery.js",THREE:"three.js"}}}SystemJS.config(i),Promise.all([SystemJS.import("jocly-xdview.js"),SystemJS.import("games/"+o.module+"/"+o.name+"-view.js")]).then(function(t){var i=t[0],s=t[1];o.gamePreAttachProto=Object.getPrototypeOf(o);var a=Object.assign({},o.gamePreAttachProto,i.view.Game,s.view.Game);Object.setPrototypeOf(o,a);var r=o.mBoardClass;o.boardPreAttachProto=r.prototype,Object.assign(r.prototype,o.boardPreAttachProto,i.view.Board,s.view.Board);var n=o.mMoveClass;o.movePreAttachProto=n.prototype,Object.assign(n.prototype,o.movePreAttachProto,s.view.Move),o.mGeometry={width:o.widget.clientWidth,height:o.widget.clientHeight},o.mWidget=jQuery(o.widget);var m=o.mViewOptions&&o.mViewOptions.defaultOptions;if(m){var h={mSkin:"skin",mNotation:"notation",mSounds:"sounds",mShowMoves:"moves",mAutoComplete:"autocomplete"};for(var d in h)void 0!==m[h[d]]&&(o[d]=m[h[d]])}o.UpdateSounds(),e()},function(e){t(e)})})},JocGame.prototype.DetachElement=function(){var e=this;return this.widget=element,new Promise(function(t,o){e.gamePreAttachProto?t():o(new Error("Game not attached"))})},JocGame.prototype.GetBoardClass=function(){return this.mBoardClass},JocGame.prototype.GetMoveClass=function(){return this.mMoveClass},JocGame.prototype.CreateMove=function(e){return new this.mMoveClass(e)},JocGame.prototype.CloneBoard=function(e){var t=new(this.GetBoardClass())(this);return t.CopyFrom(e),t},JocGame.prototype.InitView=function(){console.log("Abstract InitView called")},JocGame.prototype.LoadCss=function(){document.querySelectorAll("head link[class='jocly-css']").forEach(function(e){e.parentNode.removeChild(e)});var e=this,t=document.querySelector("head");(this.mViewOptions.css||[]).forEach(function(o){var i=document.createElement("link");i.setAttribute("rel","stylesheet"),i.setAttribute("type","text/css"),i.setAttribute("class","jocly-css"),i.setAttribute("href",e.mViewOptions.fullPath+"/"+o),t.appendChild(i)})},JocGame.prototype.GameInitView=function(){this.mGeometry.width>0&&this.mGeometry.height>0&&(this.LoadCss(),this.InitView(),this.mViewInited=!0)},JocGame.prototype.DestroyView=function(){this.mWidget&&this.mWidget.empty()},JocGame.prototype.GameDestroyView=function(){this.mViewInited&&(this.DestroyView(),this.mViewInited=!1)},JocGame.prototype.CanPlaySound=function(e){return!0},JocGame.prototype.UpdateSounds=function(){function e(e,o,i){var s=$("<audio/>").attr("id","jocly-sound-"+e).attr("preload","auto");$("<source/>").attr("src",o+"/res/sounds/"+i+".ogg").attr("type","audio/ogg").appendTo(s),$("<source/>").attr("src",o+"/res/sounds/"+i+".mp3").attr("type","audio/mp3").appendTo(s),s.appendTo(t)}var t=$("#jocly-sounds");0==t.length&&(t=$("<div/>").attr("id","jocly-sounds").css({display:"none"}).appendTo($("body"))),t.empty();var o={useraction:"bells1",usermove:"bells1",win:"winblues",loss:"lose",end:"draw"};for(var i in o)e(i,this.config.baseURL,o[i]);if(this.config.view.sounds)for(var i in this.config.view.sounds)$("#jocly-sound-"+i).remove(),this.config.view.sounds[i]&&this.config.view.sounds[i]&&e(i,this.config.baseURL+"games/"+this.config.model.module,this.config.view.sounds[i])},JocGame.prototype.PlaySound=function(e){if(this.CanPlaySound(e)){var t=document.getElementById("jocly-sound-"+e);if(t&&this.mSounds)if(void 0===this.mNeedPhonegapMedia&&(this.mNeedPhonegapMedia=!1,this.mNeedPhonegapMedia=window&&window.cordova&&"undefined"!=typeof Media),this.mNeedPhonegapMedia){if(void 0===this.mPhonegapMediaLib&&(this.mPhonegapMediaLib={}),void 0===this.mPhonegapMediaLib[e]){for(var o=t.firstChild;o&&(!/source/i.test(o.nodeName)||"audio/mp3"!=o.getAttribute("type"));)o=o.nextSibling;if(o){var i=o.getAttribute("src"),s=/^([^#\?]*)\/[^#\?]+/.exec(window.location.pathname);s&&(i=i.replace(/^\./,s[1])),i=i.replace(/%20/g," "),this.mPhonegapMediaLib[e]=new Media(i,function(){},function(e){console.warn("Jocly PlaySound: Media did not play "+e.code)},function(e){})}else this.mPhonegapMediaLib[e]=null}this.mPhonegapMediaLib[e]&&this.mPhonegapMediaLib[e].play()}else t.cloneNode(!0).play()}},JocGame.prototype.InitGame=function(){},JocGame.prototype.GameInitGame=function(){0==this.mGameInited&&(this.mVisitedBoards={},arguments.length>0&&arguments[0]?this.mInitial=arguments[0]:this.mInitial=null,this.InitGame(),this.mGameInited=!0)},JocGame.prototype.DestroyGame=function(){},JocGame.prototype.GameDestroyGame=function(){if(this.mGameInited&&(this.DestroyGame(),this.mGameInited=!1),this.aiWorker)try{this.aiWorker.terminate(),delete this.aiWorker}catch(e){console.warn("Cannot terminate worker",e)}},JocGame.prototype.DisplayBoard=function(){this.mBoard.Display&&this.mBoard.Display(this)},JocGame.prototype.SetWho=function(e){this.mWho=e,this.mBoard.mWho=e},JocGame.prototype.GetWho=function(){return this.mWho},JocGame.prototype.HumanTurn=function(){this.mBoard.mMoves&&0!=this.mBoard.mMoves.length||(this.mCurrentLevel=-1,this.mBoard.GenerateMoves(this)),this.mBoard.HumanTurn(this)},JocGame.prototype.HumanTurnEnd=function(){this.mBoard.HumanTurnEnd(this)},JocGame.prototype.PlayedMove=function(e,t){return this.mOldBoard=t,this.mBoard.PlayedMove(this,e)},JocGame.prototype.ShowEnd=function(){return this.mBoard.ShowEnd(this)},JocGame.prototype.EvaluateBoard=function(){this.mBoard.mFinished=!1,this.mBoard.mMoves=[],this.mCurrentLevel=-1,this.mBoard.GenerateMoves(this),0==this.mBoard.mFinished&&this.mBoard.Evaluate(this,!0,!0)},JocGame.prototype.GetFinished=function(){return this.EvaluateBoard(),this.mBoard.mFinished?this.mBoard.mWinner:0},JocGame.prototype.IsValidMove=function(e){var t=new(this.GetMoveClass())(e);return this.mBoard.IsValidMove(this,t)},JocGame.prototype.AddVisit=function(e,t){e&&(t=e.GetSignature()),void 0===this.mVisitedBoards[t]?this.mVisitedBoards[t]=1:this.mVisitedBoards[t]++},JocGame.prototype.RemoveVisit=function(e,t){e&&(t=e.GetSignature());var o=this.mVisitedBoards[t];void 0!==o&&(o>1?this.mVisitedBoards[t]--:delete this.mVisitedBoards[t])};var engdbg_loops,engdbg_time,engdbg_t0;JocGame.prototype.StartMachine=function(e){if(engdbg_loops=0,engdbg_time=0,engdbg_t0=Date.now(),this.mDoneCallback=e.Done||this.MachineMove,this.mProgressCallback=e.Progress||this.MachineProgress,void 0!==e.level&&(this.mTopLevel=e.level),void 0!==e.maxDepth&&(this.mTopLevel=e.maxDepth),this.mStartTime=(new Date).getTime(),this.mExploredCount=0,this.mPickedMoveIndex=0,this.mBestMoves=[],this.mContexts=[],this.mDuration=0,this.mAborted=!1,this.mRandomSeed=0,e.randomSeed&&!isNaN(parseInt(e.randomSeed))&&(this.mRandomSeed=parseInt(e.randomSeed)),"function"==typeof this.mBoard.StaticGenerateMoves){var t=this.mBoard.StaticGenerateMoves(this);if(t&&t.length>0)return this.mBestMoves=t,void JocUtil.schedule(this,"Done",{})}this.mOptions.levelOptions&&(this.mOptions.levelOptionsSaved=JSON.parse(JSON.stringify(this.mOptions.levelOptions)),e.level&&Object.assign(this.mOptions.levelOptions,e.level));var o=e.threaded&&"object"==("undefined"==typeof window?"undefined":_typeof(window))&&window.Worker;if(e.level&&"uct"==e.level.ai&&JoclyUCT)o?this.StartThreadedMachine(e,"uct"):JoclyUCT.startMachine(this,e);else if(o)this.StartThreadedMachine(e,"alpha-beta");else{this.mSavedVisitedBoards={};for(var i in this.mVisitedBoards)this.mSavedVisitedBoards[i]=this.mVisitedBoards[i];this.Engine(this.mBoard,this.mTopLevel,!1,0,e.potential),this.Run()}},JocGame.prototype.StartThreadedMachine=function(e,t){var o=this;delete e.Done,delete e.Progress;var i=Date.now();this.aiWorker||(this.aiWorker=new Worker(this.config.baseURL+"jocly.aiworker.js"),this.aiWorker.postMessage({type:"Init",baseURL:this.config.baseURL,options:e,t0:i})),this.aiWorker.onmessage=function(e){var t=e.data;switch(t.type){case"Progress":o.mProgressCallback(t.percent);break;case"Done":o.mBestMoves=t.data.moves,o.mPickedMoveIndex=t.data.moveIndex,o.mExploredCount=t.data.explored,o.mDuration=t.data.duration,o.mBoard.evaluation=t.data.evaluation,o.Done()}},this.aiWorker.postMessage({type:"Play",playedMoves:this.mPlayedMoves,gameOptions:this.mOptions,gameName:this.name,options:e,algo:t,t0:i})},JocGame.prototype.StopThreadedMachine=function(){if(this.aiWorker)try{this.aiWorker.terminate(),delete this.aiWorker}catch(e){console.warn("Cannot terminate worker",e)}},JocGame.prototype.ScheduleStep=function(){this.mNextSchedule=this.ExecuteStep},JocGame.prototype.Random=function(e){return this.mRandomSeed?this.mRandomSeed%e:Math.floor(Math.random()*e)},JocGame.prototype.ArrayShuffle=function(e){var t=e.length;if(!(t<=0))for(;--t;){var o;o=this.mRandomSeed?this.mRandomSeed%(t+1):Math.floor(Math.random()*(t+1));var i=e[t];e[t]=e[o],e[o]=i}},JocGame.prototype.Done=function(){if(this.mDuration=(new Date).getTime()-this.mStartTime,this.mOptions.levelOptionsSaved&&(this.mOptions.levelOptions=this.mOptions.levelOptionsSaved,this.mOptions.levelOptionsSaved=null),this.mSavedVisitedBoards&&(this.mVisitedBoards=this.mSavedVisitedBoards),this.mDoneCallback){this.mPickedMoveIndex=this.Random(this.mBestMoves.length);try{this.mProgressCallback&&this.mProgressCallback(100),this.mDoneCallback({moves:this.mBestMoves,move:this.mBestMoves[this.mPickedMoveIndex],moveIndex:this.mPickedMoveIndex,explored:this.mExploredCount,duration:this.mDuration,evaluation:this.mBoard.mEvaluation})}catch(e){JocLog("!!! Done:"+e,e.stack?e.stack:"")}}},JocGame.prototype.Run=function(){var e=Date.now();try{for(var t=(new Date).getTime();this.mNextSchedule&&(new Date).getTime()-t<20&&0==this.mAborted;){var o=this.mNextSchedule;this.mNextSchedule=null,o.call(this)}this.mAborted?this.mAbortCallback():this.mNextSchedule&&JocUtil.schedule(this,"Run",{})}catch(e){JocLog("JocGame.Run "+e+"\n"+e.stack)}var i=Date.now();engdbg_loops++,engdbg_time+=i-e},JocGame.prototype.Abort=function(e){var t=this;this.mAbortCallback=function(){t.mOptions.levelOptionsSaved&&(t.mOptions.levelOptions=t.mOptions.levelOptionsSaved,t.mOptions.levelOptionsSaved=null),t.mSavedVisitedBoards&&(t.mVisitedBoards=t.mSavedVisitedBoards,t.mSavedVisitedBoards=null),e()},this.mAborted=!0},JocGame.prototype.Engine=function(e,t,o,i,s){var a={mBoard:e,mLevel:t,mBAlpha:o,mAlpha:i,mBestEvaluation:0,mMoveIndex:0,mNextBoard:null,mNextBoards:null};if(this.mContexts.push(a),a.mBoard.mFinished=!1,a.mBoard.mWinner=JocGame.DRAW,this.mCurrentLevel=t,0==a.mBoard.mMoves.length&&a.mBoard.GenerateMoves(this),0==a.mBoard.mMoves.length&&0==a.mBoard.mFinished&&(a.mBoard.Evaluate(this,!0,!1),0==a.mBoard.mFinished&&(JocLog("!!! No move possible while not finished - player",this.mWho,"board",a.mBoard),a.mBoard.mFinished=!0)),a.mBoard.mFinished){switch(a.mBoard.mWinner){case JocGame.PLAYER_A:a.mBoard.mEvaluation=JocGame.MAX_VALUE-(this.mTopLevel-a.mLevel);break;case JocGame.PLAYER_B:a.mBoard.mEvaluation=-JocGame.MAX_VALUE+(this.mTopLevel-a.mLevel)}return a.mBestEvaluation=a.mBoard.mEvaluation,void this.ExecuteStep2()}if(a.mExploCtrl={exploFrom:this.mExploredCount,exploTo:this.mExploredCount+s},a.mBoard.QuickEvaluate){var r=function(e,t){return(t.evaluation-e.evaluation)*a.mBoard.mWho},n=[];for(var m in a.mBoard.mMoves){var h=a.mBoard.MakeAndApply(this,m),d=h.QuickEvaluate(this);n.push({move:a.mBoard.mMoves[m],board:h,evaluation:d})}n.sort(r),a.mBoard.mMoves=[],a.mNextBoards=[],void 0!==this.mOptions.capMoves&&(n=n.slice(0,this.mOptions.capMoves));for(var m in n)a.mBoard.mMoves.push(n[m].move),a.mNextBoards.push(n[m].board)}this.ExecuteStep()},JocGame.prototype.ExecuteStep=function(){this.mExploredCount++;var e=this.mContexts[this.mContexts.length-1];if(e.mNextBoards?e.mNextBoard=e.mNextBoards[e.mMoveIndex]:e.mNextBoard=e.mBoard.MakeAndApply(this,e.mMoveIndex),this.mProgressCallback){var t=null;if(e.mLevel==this.mTopLevel)t=Math.floor(100*e.mMoveIndex/e.mBoard.mMoves.length);else if(e.mLevel==this.mTopLevel-1){var o=this.mContexts[0],i=1/o.mBoard.mMoves.length;t=Math.floor(100*(o.mMoveIndex*i+e.mMoveIndex*i/e.mBoard.mMoves.length))}if(null!=t)try{this.mProgressCallback(t)}catch(e){}}var s=e.mNextBoard;if(s.mFinished=!1,s.mWinner=0,s.Evaluate(this,0==e.mLevel,!1,this),e.mLevel<0&&(s.mEvaluation=0),s.mFinished)switch(s.mWinner){case JocGame.PLAYER_A:s.mEvaluation=JocGame.MAX_VALUE-(this.mTopLevel-e.mLevel);break;case JocGame.PLAYER_B:s.mEvaluation=-JocGame.MAX_VALUE+(this.mTopLevel-e.mLevel);break;case JocGame.DRAW:s.mEvaluation=0}else if(e.mLevel==this.mTopLevel&&1==e.mBoard.mMoves.length);else if(e.mLevel>0){var a=(e.mExploCtrl.exploTo-this.mExploredCount)/e.mBoard.mMoves.length;if(a>=1)return s.mWho=-s.mWho,void this.Engine(s,e.mLevel-1,0!=e.mMoveIndex,e.mBestEvaluation,a)}this.ExecuteStep2()},JocGame.prototype.ExecuteStep2=function(){var e=this.mContexts[this.mContexts.length-1];if(e.mBoard.mMoves.length>0&&(0==e.mMoveIndex?(e.mBestEvaluation=e.mNextBoard.mEvaluation,e.mLevel==this.mTopLevel&&this.SetBest(e.mBoard.mMoves[0],e.mBoard)):e.mNextBoard.mWho>0?e.mNextBoard.mEvaluation>e.mBestEvaluation?(e.mBestEvaluation=e.mNextBoard.mEvaluation,e.mLevel==this.mTopLevel&&this.SetBest(e.mBoard.mMoves[e.mMoveIndex],e.mBoard)):e.mLevel==this.mTopLevel&&e.mNextBoard.mEvaluation==e.mBestEvaluation&&this.AddBest(e.mBoard.mMoves[e.mMoveIndex],e.mBoard):e.mNextBoard.mEvaluation<e.mBestEvaluation?(e.mBestEvaluation=e.mNextBoard.mEvaluation,e.mLevel==this.mTopLevel&&this.SetBest(e.mBoard.mMoves[e.mMoveIndex],e.mBoard)):e.mLevel==this.mTopLevel&&e.mNextBoard.mEvaluation==e.mBestEvaluation&&this.AddBest(e.mBoard.mMoves[e.mMoveIndex],e.mBoard)),e.mBoard.mEvaluation=e.mBestEvaluation,e.mBAlpha&&(e.mBoard.mWho==JocGame.PLAYER_A&&e.mBestEvaluation>e.mAlpha||e.mBoard.mWho==JocGame.PLAYER_B&&e.mBestEvaluation<e.mAlpha)&&(e.mMoveIndex=e.mBoard.mMoves.length-1),++e.mMoveIndex<e.mBoard.mMoves.length)this.ScheduleStep();else if(this.mContexts.pop(),this.mContexts.length>0){var e=this.mContexts[this.mContexts.length-1];e.mNextBoard.mWho=-e.mNextBoard.mWho,this.ExecuteStep2()}else delete e.mBoard.mMoves,this.Done()},JocGame.prototype.SetBest=function(e,t){var o=new(this.GetMoveClass())({});o.CopyFrom(e),this.mBestMoves=[o]},JocGame.prototype.AddBest=function(e,t){var o=new(this.GetMoveClass())({});o.CopyFrom(e),this.mBestMoves.push(o)},JocGame.prototype.GetRepeatOccurence=function(e){return this.mOptions.preventRepeat?this.mVisitedBoards[e.GetSignature()]:-1},JocGame.prototype.HandleRepeat=function(e){if(this.mOptions.preventRepeat){var t=e.GetSignature(!0);void 0===this.mVisitedBoards[t]?this.mVisitedBoards[t]=1:this.mVisitedBoards[t]++}},JocGame.prototype.UnhandleRepeat=function(e){if(this.mOptions.preventRepeat){var t=e.GetSignature(!0);1==this.mVisitedBoards[t]?delete this.mVisitedBoards[t]:this.mVisitedBoards[t]>1&&this.mVisitedBoards[t]--}},JocGame.prototype.ApplyMove=function(e){var t=new(this.GetMoveClass())({});t.CopyFrom(e),this.mPlayedMoves.push(t),this.mFullPlayedMoves.length<this.mPlayedMoves.length?this.mFullPlayedMoves.push(t):t.Equals(this.mFullPlayedMoves[this.mPlayedMoves.length-1])||(this.mFullPlayedMoves=this.mFullPlayedMoves.slice(0,this.mPlayedMoves.length-1),this.mFullPlayedMoves.push(t)),this.mBoard.ApplyMove(this,e),this.mBoard.mMoves=[],this.HandleRepeat(this.mBoard)},JocGame.prototype.BackTo=function(e,t){t||(t=this.mFullPlayedMoves),this.mWho=JocGame.PLAYER_A,this.mBoard=new(this.GetBoardClass())(this),this.mBoard.InitialPosition&&this.mBoard.InitialPosition(this),this.mInitial&&this.mInitial.turn&&(this.mWho=this.mInitial.turn),this.mBoard.mWho=this.mWho,this.mBestMoves=[],this.mVisitedBoards={},this.mPlayedMoves=[];for(var o=0;o<e;o++)this.mBoard.ApplyMove(this,t[o]),this.HandleRepeat(this.mBoard),this.mBoard.mWho=-this.mBoard.mWho,this.mPlayedMoves.push(t[o]);this.mWho=this.mBoard.mWho},JocGame.prototype.ExportInitialBoardState=function(e){if(!this.mInitialString)return null;if("function"!=typeof this.Import)return null;try{if(!this.Import("pjn",this.mInitialString).status)return null;var t=new(this.GetBoardClass())(this);t.InitialPosition&&t.InitialPosition(this);return{boardState:t.ExportBoardState(this,e),turn:t.mWho}}catch(e){return null}},JocGame.prototype.Load=function(e){if(this.mWho=JocGame.PLAYER_A,this.mBoard=new(this.GetBoardClass())(this),e.initialBoard){if("function"!=typeof this.Import)throw new Error("Import not supported");var t=this.Import("pjn",e.initialBoard);if(!t.status){var o=new Error("import failed");switch(t.error){case"parse":o=new Error("import failed: parse error");break;case"unsupported":o=new Error("import failed: unsupported format")}throw o}this.mInitial=t.initial,this.mInitial.turn&&(this.mWho=this.mInitial.turn),this.mInitialString=e.initialBoard}this.mBoard.InitialPosition&&this.mBoard.InitialPosition(this),this.mBoard.mWho=this.mWho,this.mBestMoves=[],this.mVisitedBoards={};var i=e.playedMoves;this.mPlayedMoves=[],this.mFullPlayedMoves=[];for(var s in i){var a=new(this.GetMoveClass())(i[s]);if(!this.IsValidMove(a))throw"invalid-move";this.mBoard.ApplyMove(this,a),this.HandleRepeat(this.mBoard),this.mBoard.mWho=-this.mBoard.mWho,this.mPlayedMoves.push(a),this.mFullPlayedMoves.push(a),this.mBoard.mMoves=[]}this.mWho=this.mBoard.mWho,0==this.mBoard.mFinished&&this.mBoard.Evaluate(this,!0,!0)},JocGame.prototype.CloseView=function(){},JocMove.prototype={},JocMove.prototype.CopyFrom=function(e){var t=JSON.parse(JSON.stringify(e));for(var o in t)this[o]=t[o]},JocMove.prototype.Equals=function(e){return JSON.stringify(this)==JSON.stringify(e)},JocMove.prototype.ToString=function(){return JSON.stringify(this)},JocMove.prototype.Strip=function(){return this},JocBoard.prototype={},JocBoard.prototype.Init=function(e){},JocBoard.prototype.InitBoard=function(e){this.mDepth=0,this.mMoves=[],this.mEvaluation=0,this.mFinished=!1,this.mWinner=0,this.Init(e)},JocBoard.prototype.CopyFrom=function(e){var t=e.mSignature;delete e.mSignature;var o=JSON.parse(JSON.stringify(e));for(var i in o)this[i]=o[i];e.mSignature=t},JocBoard.prototype.GetSignature=function(){if(arguments[0]||!this.mSignature){var e=this.mMoves;delete this.mMoves,delete this.mSignature,this.mSignature=JocUtil.md5(JSON.stringify(this)),this.mMoves=e}return this.mSignature},JocBoard.prototype.ApplyMove=function(e,t){JocLog("Method JocBoard:ApplyMove() must be overloaded")},JocBoard.prototype.GenerateMoves=function(e){JocLog("Method JocBoard:GenerateMoves() must be overloaded")},JocBoard.prototype.Evaluate=function(e,t,o){JocLog("Method JocBoard:Evaluate() must be overloaded"),this.mEvaluation=0},JocBoard.prototype.HumanTurn=function(){},JocBoard.prototype.HumanTurnEnd=function(){},JocBoard.prototype.PlayedMove=function(){},JocBoard.prototype.ShowEnd=function(){},JocBoard.prototype.MakeAndApply=function(e,t){var o=new(e.GetBoardClass())(e);return o.CopyFrom(this),o.mWho=this.mWho,o.mBoardClass=this.mBoardClass,o.ApplyMove(e,this.mMoves[t]),o.mMoves=[],o},JocBoard.prototype.IsValidMove=function(e,t){"function"!=typeof t.Equals&&(t=e.CreateMove(t)),this.mMoves&&0!=this.mMoves.length||(this.mCurrentLevel=-1,this.GenerateMoves(e));for(var o in this.mMoves)if(t.Equals(this.mMoves[o]))return!0;return console.error("Invalid move "+JSON.stringify(t)+" in "+JSON.stringify(this.mMoves)),!1},JocBoard.prototype.PushMove=function(e,t){this.mMoves.push(e.CreateMove(t))},JocBoard.prototype.GenerateMoveObjects=function(e){var t=[];this.mMoves=[],this.GenerateMoves(e);for(var o=0;o<this.mMoves.length;o++)t.push(e.CreateMove(this.mMoves[o]));this.mMoves=t},JocBoard.prototype.ExportBoardState=function(e){return JSON.stringify(this)},JocGame.prototype.GetBestMatchingMove=function(e,t){var o=[],i=this;t.forEach(function(e){"function"==typeof e.ToString?o.push(e.ToString()):o.push(i.CreateMove(e).ToString())});var s=1/0,a=[];if(t.forEach(function(t,i){var r=JocGame.Levenshtein(e,o[i])/(Math.max(o[i].length,e.length)+1);r==s?a.push(i):r<s&&(a=[i],s=r)}),1==a.length)return t[a[0]];var r=a,n=[];return r.forEach(function(t){var i=o[t];(e.indexOf(i)>=0||i.indexOf(e)>=0)&&n.push(t)}),1==n.length?t[n[0]]:(s=1/0,a=[],r.forEach(function(t){var i=0,r=e.replace(/[A-Z]/g,""),n=o[t].replace(/[A-Z]/g,"");i+=JocGame.Levenshtein(r,n)/(Math.max(r.length,n.length)+1),i+=r.indexOf(n)>=0||n.indexOf(r)>=0?0:1,r=e.replace(/[a-z]/g,""),n=o[t].replace(/[a-z]/g,""),i+=JocGame.Levenshtein(r,n)/(Math.max(r.length,n.length)+1),i+=r.indexOf(n)>=0||n.indexOf(r)>=0?0:1,i==s?a.push(t):i<s&&(a=[t],s=i)}),1==a.length?t[a[0]]:null)},JocBoard.prototype.PickMoveFromDatabase=function(e,t){if(!this.mMoves||0==this.mMoves.length){var o=[];this.mMoves=[],this.GenerateMoves(e);for(var i=0;i<this.mMoves.length;i++)o.push(e.CreateMove(this.mMoves[i]));this.mMoves=o}if(0==this.mMoves.length)return null;var s=this.mWho+"#"+this.GetSignature(),a=t[s];if(!a)return null;for(var r=0,i=0;i<a.length;i++)r+=a[i].e;for(var n=Math.random()*r,m=0,i=0;i<a.length;i++){var h=a[i];if((m+=h.e)>n){var d=e.GetBestMatchingMove(h.m,this.mMoves);if(d)return[d]}}return null},JocBoard.prototype.CompactMoveString=function(e,t){return"function"!=typeof t.ToString&&(t=e.CreateMove(t)),t.ToString()},JocGame.Zobrist=function(e){var t=new MersenneTwister(12345),o=[];for(var i in e)o.push(i);o.sort(),this.seed={};for(var s=0;s<o.length;s++){for(var i=o[s],a=e[i],r={values:{},seeds:[]},n=0,m=0;m<a.values.length;m++)r.values[a.values[m]]=n++;switch(a.type){case"array":for(var h=0;h<a.size;h++){for(var d=[],l=0;l<n;l++)d.push(t.genrand_int32());r.seeds.push(d)}r.type="array";break;default:for(var l=0;l<n;l++)r.seeds.push(t.genrand_int32());r.type="simple"}this.seed[i]=r}},JocGame.Zobrist.prototype={update:function(e,t){var o=this.seed[t];if(void 0===o)return console.error("Unknown Zobrist parameter",t),0;var i=o.values[arguments[2]];if(void 0===i)return console.error("Undeclared Zobrist value",arguments[2],"as param",t),0;switch(o.type){case"simple":e^=o.seeds[i];break;case"array":var s=o.seeds[arguments[3]];if(void 0===s)return console.error("Undeclared Zobrist array index",arguments[3],"as param",t),0;e^=s[i]}return e}},JocGame.Levenshtein=function(e,t){if(e==t)return 0;var o=e.length,i=t.length;if(0===o)return i;if(0===i)return o;var s=!1;try{s=!"0"[0]}catch(e){s=!0}s&&(e=e.split(""),t=t.split(""));for(var s=Array(o+1),a=Array(o+1),r=0,n=0,m=0,r=0;r<o+1;r++)s[r]=r;for(var h="",d="",n=1;n<=i;n++){for(a[0]=n,d=t[n-1],r=0;r<o;r++){var h=e[r],m=h==d?0:1,h=s[r+1]+1,l=a[r]+1,m=s[r]+m;l<h&&(h=l),m<h&&(h=m),a[r+1]=h}r=s,s=a,a=r}return s[o]};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("DuR2")))

/***/ }),

/***/ "j3uM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_instrument__ = __webpack_require__("uf2u");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__src_instrument__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_devtools__ = __webpack_require__("cnKp");
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__src_devtools__["a"]; });


//# sourceMappingURL=index.js.map

/***/ }),

/***/ "j7ye":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var multicast_1 = __webpack_require__("emOw");
Observable_1.Observable.prototype.multicast = multicast_1.multicast;
//# sourceMappingURL=multicast.js.map

/***/ }),

/***/ "jBEF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Observable_1 = __webpack_require__("rCTf");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var EmptyObservable = (function (_super) {
    __extends(EmptyObservable, _super);
    function EmptyObservable(scheduler) {
        _super.call(this);
        this.scheduler = scheduler;
    }
    /**
     * Creates an Observable that emits no items to the Observer and immediately
     * emits a complete notification.
     *
     * <span class="informal">Just emits 'complete', and nothing else.
     * </span>
     *
     * <img src="./img/empty.png" width="100%">
     *
     * This static operator is useful for creating a simple Observable that only
     * emits the complete notification. It can be used for composing with other
     * Observables, such as in a {@link mergeMap}.
     *
     * @example <caption>Emit the number 7, then complete.</caption>
     * var result = Rx.Observable.empty().startWith(7);
     * result.subscribe(x => console.log(x));
     *
     * @example <caption>Map and flatten only odd numbers to the sequence 'a', 'b', 'c'</caption>
     * var interval = Rx.Observable.interval(1000);
     * var result = interval.mergeMap(x =>
     *   x % 2 === 1 ? Rx.Observable.of('a', 'b', 'c') : Rx.Observable.empty()
     * );
     * result.subscribe(x => console.log(x));
     *
     * // Results in the following to the console:
     * // x is equal to the count on the interval eg(0,1,2,3,...)
     * // x will occur every 1000ms
     * // if x % 2 is equal to 1 print abc
     * // if x % 2 is not equal to 1 nothing will be output
     *
     * @see {@link create}
     * @see {@link never}
     * @see {@link of}
     * @see {@link throw}
     *
     * @param {Scheduler} [scheduler] A {@link IScheduler} to use for scheduling
     * the emission of the complete notification.
     * @return {Observable} An "empty" Observable: emits only the complete
     * notification.
     * @static true
     * @name empty
     * @owner Observable
     */
    EmptyObservable.create = function (scheduler) {
        return new EmptyObservable(scheduler);
    };
    EmptyObservable.dispatch = function (arg) {
        var subscriber = arg.subscriber;
        subscriber.complete();
    };
    EmptyObservable.prototype._subscribe = function (subscriber) {
        var scheduler = this.scheduler;
        if (scheduler) {
            return scheduler.schedule(EmptyObservable.dispatch, 0, { subscriber: subscriber });
        }
        else {
            subscriber.complete();
        }
    };
    return EmptyObservable;
}(Observable_1.Observable));
exports.EmptyObservable = EmptyObservable;
//# sourceMappingURL=EmptyObservable.js.map

/***/ }),

/***/ "jDQW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var bufferToggle_1 = __webpack_require__("Mqdq");
Observable_1.Observable.prototype.bufferToggle = bufferToggle_1.bufferToggle;
//# sourceMappingURL=bufferToggle.js.map

/***/ }),

/***/ "jF50":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var throttleTime_1 = __webpack_require__("KKz1");
Observable_1.Observable.prototype.throttleTime = throttleTime_1.throttleTime;
//# sourceMappingURL=throttleTime.js.map

/***/ }),

/***/ "jIkT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("3j3K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__media_monitor__ = __webpack_require__("bWt6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__match_media__ = __webpack_require__("LuwH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__breakpoints_break_point_registry__ = __webpack_require__("eZjk");
/* unused harmony export MEDIA_MONITOR_PROVIDER_FACTORY */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MEDIA_MONITOR_PROVIDER; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */




/**
 * Ensure a single global service provider
 */
function MEDIA_MONITOR_PROVIDER_FACTORY(parentMonitor, breakpoints, matchMedia) {
    return parentMonitor || new __WEBPACK_IMPORTED_MODULE_1__media_monitor__["a" /* MediaMonitor */](breakpoints, matchMedia);
}
/**
 * Export provider that uses a global service factory (above)
 */
var MEDIA_MONITOR_PROVIDER = {
    provide: __WEBPACK_IMPORTED_MODULE_1__media_monitor__["a" /* MediaMonitor */],
    deps: [
        [new __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"](), new __WEBPACK_IMPORTED_MODULE_0__angular_core__["SkipSelf"](), __WEBPACK_IMPORTED_MODULE_1__media_monitor__["a" /* MediaMonitor */]],
        __WEBPACK_IMPORTED_MODULE_3__breakpoints_break_point_registry__["a" /* BreakPointRegistry */],
        __WEBPACK_IMPORTED_MODULE_2__match_media__["a" /* MatchMedia */],
    ],
    useFactory: MEDIA_MONITOR_PROVIDER_FACTORY
};
//# sourceMappingURL=media-monitor-provider.js.map

/***/ }),

/***/ "jRln":
/***/ (function(module, exports) {

exports.config = {"status":true,"model":{"plazza":"true","title-en":"Alquerque","module":"checkers","maxLevel":20,"summary":"A 10th century checkers game from Middle-East.","thumbnail":"alquerque-thumb3d.png","rules":"rules-alquerque-bell.html","description":"description.html","credits":"credits.html","js":["checkersbase-model.js","alquerque-model.js"],"gameOptions":{"preventRepeat":true,"width":5,"height":5,"initial":{"a":[[0,0],[0,1],[0,2],[0,3],[0,4],[1,0],[1,1],[1,2],[1,3],[1,4],[2,3],[2,4]],"b":[[4,0],[4,1],[4,2],[4,3],[4,4],[3,0],[3,1],[3,2],[3,3],[3,4],[2,0],[2,1]]},"variant":{"canStepBack":false,"mustMoveForward":true,"lastRowFreeze":true,"noMove":"lose"}},"levels":[{"label":"Fast","ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.5,"maxDuration":1,"isDefault":true},{"label":"Beginner","ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.5,"maxDuration":0.5,"maxNodes":100,"maxLoops":200},{"label":"Easy","ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.5,"maxDuration":1,"maxNodes":2500,"maxLoops":500},{"label":"Medium","ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.5,"maxDuration":2,"maxNodes":5500,"maxLoops":500},{"label":"Hard","ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.5,"maxDuration":5,"maxNodes":2000,"maxLoops":3500},{"label":"Expert","ai":"uct","c":0.8,"playoutDepth":0,"minVisitsExpand":1,"ignoreLeaf":false,"uncertaintyFactor":5,"propagateMultiVisits":false,"maxDuration":60,"maxNodes":15000,"maxLoops":8000}]},"view":{"js":["checkers-xd-view.js","alquerque-xd-view.js"],"xdView":true,"css":["checkersbase.css","alquerque.css"],"title-en":"Alquerque Bell View","skins":[{"name":"alquerque3d","title":"3D Classic","3d":true,"camera":{"radius":20,"elevationAngle":45,"limitCamMoves":true},"world":{"lightIntensity":0.8,"color":0,"fog":false,"lightPosition":{"x":-5,"y":18,"z":5},"lightShadowDarkness":0.55,"ambientLightColor":0},"preload":["image|/res/xd-view/meshes/red.png","image|/res/xd-view/meshes/black.png","image|/res/images/alquarqueboard1.jpg","image|/res/xd-view/meshes/skybox/nx.jpg","image|/res/xd-view/meshes/skybox/ny.jpg","image|/res/xd-view/meshes/skybox/nz.jpg","image|/res/xd-view/meshes/skybox/px.jpg","image|/res/xd-view/meshes/skybox/py.jpg","image|/res/xd-view/meshes/skybox/pz.jpg","smoothedfilegeo|0|/res/xd-view/meshes/board-checkers-slot.js","smoothedfilegeo|0|/res/xd-view/meshes/board-alquerque-external-frame.js","smoothedfilegeo|0|/res/xd-view/meshes/board-checkers-triangle.js","smoothedfilegeo|0|/res/xd-view/meshes/ring-target.js"]},{"name":"2d-wood-alquerque","title":"Wood"}],"visuals":{"600x600":["res/visuals/alquerque-600x600-3d.jpg","res/visuals/alquerque-600x600-2d.jpg"]},"module":"checkers","preferredRatio":1,"switchable":true,"animateSelfMoves":false,"useNotation":true,"useShowMoves":true,"sounds":{"move1":"alq_move1","move2":"alq_move2","move3":"alq_move3","move4":"alq_move2","tac1":"alq_tac1","tac2":"alq_tac2","tac3":"alq_tac1","promo":null,"usermove":null},"defaultOptions":{"sounds":true,"notation":false,"moves":true}}}

/***/ }),

/***/ "jSLY":
/***/ (function(module, exports) {

exports.model=Model={Game:{},Board:{},Move:{}},function(){var t;Model.Game.cbConstants={MASK:65535,FLAG_MOVE:65536,FLAG_CAPTURE:131072,FLAG_STOP:262144,FLAG_SCREEN_CAPTURE:524288,FLAG_CAPTURE_KING:1048576,FLAG_CAPTURE_NO_KING:2097152};var e="undefined"!=typeof Int32Array;Model.Game.cbUseTypedArrays=e,Model.Game.cbTypedArray=function(t){if(e){var i=new Int32Array(t.length);return i.set(t),i}for(var r=[],a=t.length,s=0;s<a;s++)r.push(t[s]);return r},Model.Game.cbShortRangeGraph=function(t,e,i,r){var a=this;void 0===r&&(r=196608);for(var s={},n=0;n<t.boardSize;n++)s[n]=[],(!i||n in i)&&e.forEach(function(e){var o=t.Graph(n,e);null!=o&&(!i||o in i)&&s[n].push(a.cbTypedArray([o|r]))});return s},Model.Game.cbLongRangeGraph=function(t,e,i,r,a){var s=this;void 0!==r&&null!=r||(r=196608),a||(a=1/0);for(var n={},o=0;o<t.boardSize;o++)n[o]=[],(!i||o in i)&&e.forEach(function(e){for(var h=[],c=t.Graph(o,e),p=0;null!=c&&(!i||c in i)&&(h.push(c|r),++p!=a);)c=t.Graph(c,e);h.length>0&&n[o].push(s.cbTypedArray(h))});return n},Model.Game.cbNullGraph=function(t){for(var e={},i=0;i<t.boardSize;i++)e[i]=[];return e},Model.Game.cbAuthorGraph=function(t){for(var e={},i=0;i<t.boardSize;i++){e[i]=[];for(var r=0;r<t.boardSize;r++)e[i].push([2293760|r])}return e},Model.Game.cbMergeGraphs=function(t){for(var e=[],i=0;i<t.boardSize;i++){e[i]=[];for(var r=1;r<arguments.length;r++)e[i]=e[i].concat(arguments[r][i])}return e},Model.Game.cbGetThreatGraph=function(){function t(e,i){for(var r in n){var a=n[r];if(!(a.p.length<i.length+1)){for(var s=!0,o=0;o<i.length;o++)if(i[o]!=a.p[o]){s=!1;break}if(s){var h=a.p[i.length],c=e[h];void 0===c&&(c={e:{}},e[h]=c),a.p.length==i.length+1&&(c.t=a.t,c.ts=a.ts,c.tk=a.tk,delete n[r]),i.push(h),t(c.e,i),i.pop()}}}}var e=this;this.cbUseScreenCapture=!1,this.cbUseCaptureKing=!1,this.cbUseCaptureNoKing=!1;for(var i={1:[],"-1":[]},r=[],a=0;a<this.g.boardSize;a++)this.g.pTypes.forEach(function(t,i){t.graph[a].forEach(function(t){for(var s=[],n=0;n<t.length;n++){var o=t[n];1048576&o?(e.cbUseCaptureKing=!0,s.unshift({d:65535&o,a:a,tk:i})):2097152&o?(e.cbUseCaptureNoKing=!0,s.unshift({d:65535&o,a:a,tnk:i})):131072&o?s.unshift({d:65535&o,a:a,t:i}):262144&o?s.unshift({d:65535&o,a:a}):524288&o&&(e.cbUseScreenCapture=!0,s.unshift({d:65535&o,a:a,ts:i}))}s.length>0&&r.push(s)})});var s={};r.forEach(function(t){t.forEach(function(e,i){var r=s[e.d];void 0===r&&(r={},s[e.d]=r);for(var a=[],n=i+1;n<t.length;n++)a.push(t[n].d);a.push(e.a);var o=a.join(","),h=r[o];void 0===h&&(h={p:a,t:{},ts:{},tk:{}},r[o]=h),void 0!==e.t?h.t[e.t]=!0:void 0!==e.tk?h.tk[e.tk]=!0:void 0!==e.ts&&(h.ts[e.ts]=!0)})});for(var a=0;a<e.g.boardSize;a++){var n=s[a],o={};t(o,[]),i[1][a]=o,i[-1][a]=o}return i},Model.Game.InitGame=function(){var e=this;this.cbVar=t=this.cbDefine(),this.g.boardSize=this.cbVar.geometry.boardSize,this.g.pTypes=this.cbGetPieceTypes(),this.g.threatGraph=this.cbGetThreatGraph(),this.g.distGraph=this.cbVar.geometry.GetDistances(),this.cbPiecesCount=0,this.g.castleablePiecesCount={1:0,"-1":0};for(var i in t.pieceTypes){var r=t.pieceTypes[i];if(r.castle){(r.initial||[]).forEach(function(t){e.g.castleablePiecesCount[t.s]++})}r.initial&&(this.cbPiecesCount+=r.initial.length)}for(var a=[],i=0;i<this.cbPiecesCount;i++)a.push(i);var s=Object.keys(t.pieceTypes);this.zobrist=new JocGame.Zobrist({board:{type:"array",size:this.cbVar.geometry.boardSize,values:a},who:{values:["1","-1"]},type:{type:"array",size:this.cbPiecesCount,values:s}})},Model.Game.cbGetPieceTypes=function(){for(var t=[],e={},i=0;i<this.cbVar.geometry.boardSize;i++)e[i]=[];for(var r in this.cbVar.pieceTypes){var a=this.cbVar.pieceTypes[r];t[r]={graph:a.graph||e,abbrev:a.abbrev||"",value:a.isKing?100:a.value||1,isKing:!!a.isKing,castle:!!a.castle,epTarget:!!a.epTarget,epCatch:!!a.epCatch}}return t},Model.Board.Init=function(t){this.zSign=0},Model.Board.InitialPosition=function(i){var r=this;this.board=e?new Int16Array(i.g.boardSize):[];for(var a=0;a<i.g.boardSize;a++)this.board[a]=-1;if(this.kings={},this.pieces=[],this.ending={1:!1,"-1":!1},this.lastMove=null,i.cbVar.castle&&(this.castled={1:!1,"-1":!1}),this.zSign=i.zobrist.update(0,"who",-1),this.noCaptCount=0,this.mWho=1,i.mInitial)this.mWho=i.mInitial.turn||1,i.mInitial.pieces.forEach(function(t){var e={};for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i]);r.pieces.push(e)}),i.mInitial.lastMove&&(this.lastMove={f:i.mInitial.lastMove.f,t:i.mInitial.lastMove.t}),void 0!==i.mInitial.noCaptCount&&(this.noCaptCount=i.mInitial.noCaptCount),i.cbVar.castle&&i.mInitial.castle&&(this.castled={1:{k:!!i.mInitial.castle[1]&&!!i.mInitial.castle[1].k,q:!!i.mInitial.castle[1]&&!!i.mInitial.castle[1].q},"-1":{k:!!i.mInitial.castle[-1]&&!!i.mInitial.castle[-1].k,q:!!i.mInitial.castle[-1]&&!!i.mInitial.castle[-1].q}});else for(var s in i.cbVar.pieceTypes)for(var n=i.cbVar.pieceTypes[s],o=n.initial||[],h=0;h<o.length;h++){var c=o[h],p={s:c.s,t:parseInt(s),p:c.p,m:!1};this.pieces.push(p)}if(this.pieces.sort(function(t,e){if(t.s!=e.s)return e.s-t.s;var r=i.cbVar.pieceTypes[t.t].value||100,a=i.cbVar.pieceTypes[e.t].value||100;return r!=a?r-a:t.p-e.p}),this.pieces.forEach(function(t,e){t.i=e,r.board[t.p]=e,i.g.pTypes[t.t].isKing&&(r.kings[t.s]=t.p),r.zSign=i.zobrist.update(r.zSign,"board",e,t.p),r.zSign=i.zobrist.update(r.zSign,"type",t.t,e)}),i.mInitial&&i.mInitial.enPassant){var a=t.geometry.PosByName(i.mInitial.enPassant);if(a>=0){var l,u=t.geometry.C(a),v=t.geometry.R(a);l=1==i.mInitial.turn?t.geometry.POS(u,v-1):t.geometry.POS(u,v+1),this.epTarget={p:a,i:this.board[l]}}}},Model.Board.CopyFrom=function(t){if(e)this.board=new Int16Array(t.board.length),this.board.set(t.board);else{this.board=[];for(var i=t.board,r=i.length,a=0;a<r;a++)this.board.push(i[a])}this.pieces=[];for(var s=t.pieces.length,a=0;a<s;a++){var n=t.pieces[a];this.pieces.push({s:n.s,p:n.p,t:n.t,i:n.i,m:n.m})}this.kings={1:t.kings[1],"-1":t.kings[-1]},this.check=t.check,t.lastMove?this.lastMove={f:t.lastMove.f,t:t.lastMove.t,c:t.lastMove.c}:this.lastMove=null,this.ending={1:t.ending[1],"-1":t.ending[-1]},void 0!==t.castled&&(this.castled={1:t.castled[1],"-1":t.castled[-1]}),this.noCaptCount=t.noCaptCount,t.epTarget?this.epTarget={p:t.epTarget.p,i:t.epTarget.i}:this.epTarget=null,this.mWho=t.mWho,this.zSign=t.zSign},Model.Board.cbApplyCastle=function(t,e,i){var r=t.cbVar.castle[e.f+"/"+e.cg],a=r.r[r.r.length-1],s=this.pieces[this.board[e.cg]],n=r.k[r.k.length-1],o=this.pieces[this.board[e.f]];return i&&(this.zSign=t.zobrist.update(this.zSign,"board",s.i,e.cg),this.zSign=t.zobrist.update(this.zSign,"board",s.i,a),this.zSign=t.zobrist.update(this.zSign,"board",o.i,e.f),this.zSign=t.zobrist.update(this.zSign,"board",o.i,n)),s.p=a,s.m=!0,this.board[e.cg]=-1,o.p=n,o.m=!0,this.board[e.f]=-1,this.board[a]=s.i,this.board[n]=o.i,this.castled[s.s]=!0,this.kings[o.s]=n,[{i:s.i,f:a,t:-1},{i:o.i,f:n,t:e.f,kp:e.f,who:o.s,m:!1},{i:s.i,f:-1,t:e.cg,m:!1,cg:!1}]},Model.Board.cbQuickApply=function(t,e){if(void 0!==e.cg)return this.cbApplyCastle(t,e,!1);var i=[],r=this.board[e.f],a=this.pieces[r];if(null!=e.c){i.unshift({i:e.c,f:-1,t:this.pieces[e.c].p});var s=this.pieces[e.c];this.board[s.p]=-1,s.p=-1}var n=this.kings[a.s];return t.g.pTypes[a.t].isKing&&(this.kings[a.s]=e.t),i.unshift({i:r,f:e.t,t:e.f,kp:n,who:a.s,ty:a.t}),a.p=e.t,void 0!==e.pr&&(a.t=e.pr),this.board[e.f]=-1,this.board[e.t]=r,i},Model.Board.cbQuickUnapply=function(t,e){for(var i=0;i<e.length;i++){var r=e[i],a=this.pieces[r.i];r.f>=0&&(a.p=-1,this.board[r.f]=-1),r.t>=0&&(a.p=r.t,this.board[r.t]=r.i),void 0!==r.m&&(a.m=r.m),void 0!==r.kp&&(this.kings[r.who]=r.kp),void 0!=r.ty&&(a.t=r.ty),void 0!=r.cg&&(this.castled[a.s]=r.cg)}},Model.Board.ApplyMove=function(t,e){var i=this.pieces[this.board[e.f]];if(void 0!==e.cg)this.cbApplyCastle(t,e,!0);else{if(this.zSign=t.zobrist.update(this.zSign,"board",i.i,e.f),this.board[i.p]=-1,void 0!==e.pr&&(this.zSign=t.zobrist.update(this.zSign,"type",i.t,i.i),i.t=e.pr,this.zSign=t.zobrist.update(this.zSign,"type",i.t,i.i)),null!=e.c){var r=this.pieces[e.c];this.zSign=t.zobrist.update(this.zSign,"board",r.i,r.p),this.board[r.p]=-1,r.p=-1,r.m=!0,this.noCaptCount=0}else this.noCaptCount++;i.p=e.t,i.m=!0,this.board[e.t]=i.i,this.zSign=t.zobrist.update(this.zSign,"board",i.i,e.t),t.g.pTypes[i.t].isKing&&(this.kings[i.s]=e.t)}this.check=!!e.ck,this.lastMove={f:e.f,t:e.t,c:e.c},void 0!==e.ko&&(this.ending[i.s]=e.ko),void 0!==e.ept?this.epTarget={p:e.ept,i:i.i}:this.epTarget=null,this.zSign=t.zobrist.update(this.zSign,"who",-this.mWho),this.zSign=t.zobrist.update(this.zSign,"who",this.mWho)},Model.Board.Evaluate=function(i){function r(e){var i=1/0;for(var r in t.geometry.corners)i=Math.min(i,h.distGraph[s.kings[e]][r]);return i-Math.sqrt(h.boardSize)}var a="debug"==arguments[3],s=this;this.mEvaluation=0;var n,o=this.mWho,h=i.g;if(e)n={1:{count:new Uint8Array(h.pTypes.length),byType:{}},"-1":{count:new Uint8Array(h.pTypes.length),byType:{}}};else{n={1:{count:[],byType:{}},"-1":{count:[],byType:{}}};for(var c=0;c<h.pTypes.length;c++)n[1].count[c]=n[-1].count[c]=0}if(i.mOptions.preventRepeat&&i.GetRepeatOccurence(this)>2)return this.mFinished=!0,void(this.mWinner=i.cbOnPerpetual?o*i.cbOnPerpetual:JocGame.DRAW);for(var p={1:0,"-1":0},l={1:h.distGraph[this.kings[-1]],"-1":h.distGraph[this.kings[1]]},u={1:0,"-1":0},v={1:0,"-1":0},g={1:0,"-1":0},f={1:0,"-1":0},b={1:!1,"-1":!1},d=this.pieces,m=d.length,c=0;c<m;c++){var y=d[c];if(y.p>=0){var M=y.s,G=h.pTypes[y.t];G.isKing?b[M]=y.m:p[M]+=G.value,G.castle&&!y.m&&f[M]++,v[M]++,u[M]+=l[M][y.p],g[M]+=t.geometry.distEdge[y.p];var S=n[M];S.count[y.t]++;var k=S.byType;void 0===k[y.t]?k[y.t]=[y]:k[y.t].push(y)}}if(this.lastMove&&null!=this.lastMove.c){var y=this.pieces[this.board[this.lastMove.t]];p[-y.s]+=this.cbStaticExchangeEval(i,y.p,y.s,{piece:y})}var C={1:0,"-1":0},T={1:0,"-1":0},z={1:0,"-1":0};this.ending[1]&&(T[1]=(u[1]-Math.sqrt(h.boardSize))/v[1],t.geometry.corners&&(z[1]=r(1))),this.ending[-1]&&(T[-1]=(u[-1]-Math.sqrt(h.boardSize))/v[-1],t.geometry.corners&&(z[1]=r(-1)));var A={pieceValue:p[1]-p[-1],pieceValueRatio:(p[1]-p[-1])/(p[1]+p[-1]+1),posValue:g[1]-g[-1],averageDistKing:u[1]/v[1]-u[-1]/v[-1],check:this.check?-o:0,endingKingFreedom:C[1]-C[-1],endingDistKing:T[1]-T[-1],distKingCorner:z[1]-z[-1]};t.castle&&(A.castle=(this.castled[1]?1:b[1]?0:f[1]/(h.castleablePiecesCount[1]+1))-(this.castled[-1]?1:b[-1]?0:f[-1]/(h.castleablePiecesCount[-1]+1))),t.evaluate&&t.evaluate.call(this,i,A,n);var P=i.mOptions.levelOptions;for(var R in A){var E=A[R],w=P[R+"Factor"]||0,I=E*w;a&&console.log(R,"=",E,"*",w,"=>",I),this.mEvaluation+=I}a&&console.log("Evaluation",this.mEvaluation)},Model.Board.cbGeneratePseudoLegalMoves=function(t){function e(e,a){var s=t.cbVar.promote;if(!s)return void r.push(a);var n=s.call(i,t,e,a);if(null!=n)if(0==n.length)r.push(a);else if(1==n.length)a.pr=n[0],r.push(a);else for(var o=0;o<n.length;o++){var h=n[o];r.push({f:a.f,t:a.t,c:a.c,pr:h,ept:a.ept,ep:a.ep,a:a.a})}}for(var i=this,r=[],a=t.cbVar,s=this.mWho,n=!a.castle||this.check||this.castled[s]?null:[],o=-1,h=this.pieces.length,c=0;c<h;c++){var p=this.pieces[c];if(!(p.p<0||p.s!=s)){var l=t.g.pTypes[p.t];l.isKing&&(p.m?n=null:o=p),n&&l.castle&&!p.m&&n.push(p);var u,v;u=l.graph[p.p],v=u.length;for(var g=0;g<v;g++)for(var f=u[g],b=!1,d=f.length,m=null,y=0;y<d;y++){var M=f[y],G=65535&M,S=this.board[G];if(!(S<0)||l.epCatch&&this.epTarget&&this.epTarget.p==G){if(!(524288&M)){var k;k=S<0?this.pieces[this.epTarget.i]:this.pieces[S],!(k.s!=p.s&&131072&M)||1048576&M&&!t.g.pTypes[k.t].isKing||2097152&M&&t.g.pTypes[k.t].isKing||e(p,{f:p.p,t:G,c:k.i,a:l.abbrev,ep:S<0});break}if(b){var k=this.pieces[S];k.s!=p.s&&e(p,{f:p.p,t:G,c:k.i,a:l.abbrev});break}b=!0}else 65536&M&&0==b&&e(p,{f:p.p,t:G,c:null,a:l.abbrev,ept:null!=m&&l.epTarget?m:void 0});m=G}}}if(n)for(var c=0;c<n.length;c++){var C=n[c],T=t.cbVar.castle[o.p+"/"+C.p];if(T){for(var z=!0,g=0;g<T.r.length;g++){var A=T.r[g];if(this.board[A]>=0&&A!=o.p&&A!=C.p){z=!1;break}}if(z){for(var P=!0,g=0;g<T.k.length;g++){var A=T.k[g];if(this.board[A]>=0&&A!=C.p&&A!=o.p||this.cbGetAttackers(t,A,s).length>0){P=!1;break}}P&&r.push({f:o.p,t:T.k[T.k.length-1],c:null,cg:C.p})}}}return r},Model.Board.cbStaticExchangeEval=function(t,e,i,r){var a=0,s=this.cbGetSmallestAttacker(t,e,i);if(s){var n=this.mWho;this.mWho=s.s;var o=this.cbQuickApply(t,{f:s.p,t:e,c:r.piece.i}),h=t.g.pTypes[r.piece.t].value;r.piece=s,a=Math.max(0,h-this.cbStaticExchangeEval(t,e,-i,r)),this.cbQuickUnapply(t,o),this.mWho=n}return a},Model.Board.cbGetSmallestAttacker=function(t,e,i){var r=this.cbGetAttackers(t,e,i);if(0==r.length)return null;for(var a=1/0,s=null,n=r.length,o=0;o<n;o++){var h=r[o],c=t.g.pTypes[h.t].value;c<a&&(a=c,s=h)}return s},Model.Board.cbCollectAttackers=function(t,e,i,r){for(var a in e){var s=e[a],n=this.board[a];if(n<0)this.cbCollectAttackers(t,s.e,i,r);else{var o=this.pieces[n];o.s==-t&&(s.t&&o.t in s.t||r&&s.tk&&o.t in s.tk)&&i.push(o)}}},Model.Board.cbCollectAttackersScreen=function(t,e,i,r,a){for(var s in e){var n=e[s],o=this.board[s];if(o<0)this.cbCollectAttackersScreen(t,n.e,i,r,a);else{var h=this.pieces[o];!a&&h.s==-t&&(n.t&&h.t in n.t||r&&n.tk&&h.t in n.tk)?i.push(h):a?a&&h.s==-t&&n.ts&&h.t in n.ts&&i.push(h):this.cbCollectAttackersScreen(t,n.e,i,r,!0)}}},Model.Board.cbGetAttackers=function(t,e,i,r){var a=[];return t.cbUseScreenCapture?this.cbCollectAttackersScreen(i,t.g.threatGraph[i][e],a,r,!1):this.cbCollectAttackers(i,t.g.threatGraph[i][e],a,r),a},Model.Board.GenerateMoves=function(t){var e=this.cbGeneratePseudoLegalMoves(t);this.mMoves=[];for(var i=!0,r=this.kings[this.mWho],a=e.length,s=0;s<a;s++){var n=e[s],o=this.cbQuickApply(t,n);if(!(this.cbGetAttackers(t,this.kings[this.mWho],this.mWho,!0).length>0)){var h=this.cbGetAttackers(t,this.kings[-this.mWho],-this.mWho,!0).length>0;n.ck=h,this.mMoves.push(n),n.f!=r&&(i=!1)}this.cbQuickUnapply(t,o)}if(0==this.mMoves.length)this.mFinished=!0,this.mWinner=t.cbOnStaleMate?t.cbOnStaleMate*this.mWho:JocGame.DRAW,this.check&&(this.mWinner=-this.mWho);else if(this.ending[this.mWho]){if(!i)for(var s=0;s<this.mMoves.length;s++)this.mMoves[s].ko=!1}else if(!this.ending[this.mWho]&&i&&!this.check)for(var s=0;s<this.mMoves.length;s++)this.mMoves[s].ko=!0},Model.Board.GetSignature=function(){return this.zSign},Model.Move.Init=function(t){for(var e in t)t.hasOwnProperty(e)&&(this[e]=t[e])},Model.Move.Equals=function(t){return this.f==t.f&&this.t==t.t&&this.pr==t.pr},Model.Move.CopyFrom=function(t){this.Init(t)},Model.Move.ToString=function(e){var i=this;switch(e=e||"natural"){case"natural":return function(){var e;if(void 0!==i.cg?e=t.castle[i.f+"/"+i.cg].n:(e=i.a||"",e+=t.geometry.PosName(i.f),null==i.c?e+="-":e+="x",e+=t.geometry.PosName(i.t)),void 0!==i.pr){var r=t.pieceTypes[i.pr];r&&r.abbrev&&r.abbrev.length>0&&!r.silentPromo&&(e+="="+r.abbrev)}return i.ck&&(e+="+"),e}();case"engine":return function(){var e=t.geometry.PosName(i.f)+t.geometry.PosName(i.t);if(void 0!=i.pr){var r=t.pieceTypes[i.pr];r&&r.abbrev&&r.abbrev.length>0&&!r.silentPromo&&(e+=r.abbrev)}return e}();default:return"??"}},Model.Board.CompactMoveString=function(e,i,r){"function"!=typeof i.ToString&&(i=e.CreateMove(i));var a=i.ToString(),s=/^([A-Z]?)([a-z])([1-9][0-9]*)([-x])([a-z])([1-9][0-9]*)(.*?)$/.exec(a);if(!s)return a;var n=s[7];if(r||(r={}),r.value||(r.value=[]),0==r.value.length){var o=this.mMoves;this.mMoves&&0!=this.mMoves.length||this.GenerateMoves(e);for(var h=0;h<this.mMoves.length;h++){var c=this.mMoves[h];"function"!=typeof c.ToString&&(c=e.CreateMove(c)),r.value.push({str:c.ToString(),move:c})}this.mMoves=o}var p=[];if(r.value.forEach(function(t){var e=/^([A-Z]?[a-z][1-9][0-9]*[-x][a-z][1-9][0-9]*)(.*?)$/.exec(t.str);e&&t.move.t==i.t&&(t.move.a||"")==s[1]&&e[2]==n&&p.push(t.move)}),1==p.length)return""==s[1]&&"x"==s[4]?s[2]+"x"+s[5]+s[6]+s[7]:s[1]+("x"==s[4]?"x":"")+s[5]+s[6]+s[7];if(t.geometry.CompactCrit)for(var l="",h=0;;h++){var u=t.geometry.CompactCrit(i.f,h);if(null==u)return a;l+=u;for(var v=[],g=0;g<p.length;g++){var f=p[g];t.geometry.CompactCrit(f.f,h)==u&&v.push(f)}if(console.assert(v.length>0),1==v.length)return s[1]+l+("x"==s[4]?"x":"")+s[5]+s[6]+s[7];p=v}return a},Model.Board.cbIntegrity=function(t){function e(t,e){t||console.error(e)}for(var i=this,r=0;r<this.board.length;r++){var a=this.board[r];if(a>=0){var s=i.pieces[a];e(void 0!==s,"no piece at pos"),e(s.p==r,"piece has different pos")}}for(var a=0;a<this.pieces.length;a++){var s=this.pieces[a];s.p>=0&&e(i.board[s.p]==a,"board index mismatch")}},Model.Board.ExportBoardState=function(t){return t.cbVar.geometry.ExportBoardState?t.cbVar.geometry.ExportBoardState(this,t.cbVar,t.mPlayedMoves.length):"not supported"},Model.Game.Import=function(e,i){var r,a=[],s={1:{},"-1":{}},n=null,o=0;if("pjn"==e){var h={status:!1,error:"parse"},c=i.split(" ");if(6!=c.length)return console.warn("FEN should have 6 parts"),h;var p=c[0].split("/"),l=t.geometry.fenHeight||t.geometry.height;if(p.length!=l)return console.warn("FEN board should have",l,"rows, got",p.length),h;var u={};for(var v in t.pieceTypes){var g=t.pieceTypes[v],f=g.fenAbbrev||g.abbrev||"X";u[f.toUpperCase()]={s:1,t:v},u[f.toLowerCase()]={s:-1,t:v}}var b=t.geometry.FenRowPos||function(e,i){return(t.geometry.height-1-e)*t.geometry.width+i};if(p.forEach(function(e,i){for(var r=0,s=0;s<e.length;s++){var n=e.substr(s,1),o=u[n];if(void 0!==o){var c=b(i,r);r++;for(var p={s:o.s,t:o.t,p:c},l=!0,v=t.pieceTypes[p.t].initial||[],g=0;g<v.length;g++){var f=v[g];f.s==p.s&&f.p==c&&(l=!1)}p.m=l,a.push(p)}else{if(isNaN(parseInt(n)))return console.warn("FEN invalid board spec",n),h;r+=parseInt(n)}}}),a.sort(function(t,e){return e.s-t.s}),"w"==c[1])r=1;else{if("b"!=c[1])return console.warn("FEN invalid turn spec",c[1]),h;r=-1}s[1].k=c[2].indexOf("K")>=0,s[1].q=c[2].indexOf("Q")>=0,s[-1].k=c[2].indexOf("k")>=0,s[-1].q=c[2].indexOf("q")>=0,n="-"==c[3]?null:c[3];var d=parseInt(c[4]);isNaN(d)||(o=d);var m={pieces:a,turn:r,castle:s,enPassant:n,noCaptCount:o};return t.importGame&&t.importGame.call(this,m,e,i),{status:!0,initial:m}}return{status:!1,error:"unsupported"}}}(),function(){Model.Game.cbBoardGeometryMultiplan=function(t,e,i){function r(e){return e%t}function a(i){return Math.floor(i%(t*e)/t)}function s(i){return Math.floor(i/(t*e))}function n(i,r,a){return a*t*e+r*t+i}function o(o,h){var c=r(o),p=a(o),l=s(o),u=c+h[0],v=p+h[1],g=l+h[2];return u<0||u>=t||v<0||v>=e||g<0||g>=i?null:n(u,v,g)}function h(t){return""+String.fromCharCode("A".charCodeAt(0)+s(t))+String.fromCharCode("a".charCodeAt(0)+r(t))+(a(t)+1)}function c(t){var e=/^([A-Z]+)([a-z])([0-9]+)$/.exec(t);if(!e)return-1;var i=e[1].charCodeAt(0)-"A".charCodeAt(0);return n(e[2].charCodeAt(0)-"a".charCodeAt(0),parseInt(e[3])-1,i)}function p(t,e){return 0==e?String.fromCharCode("a".charCodeAt(0)+r(t)):1==e?a(t)+1:null}function l(){for(var n=[],o=0;o<t*e*i;o++){var h=[];n.push(h);for(var c=0;c<t*e*i;c++){var p=a(o),l=r(o),u=s(o),v=a(c),g=r(c),f=s(c);h.push(Math.max(Math.abs(p-v),Math.abs(l-g),Math.abs(u-f)))}}return n}function u(t,r){var a=i-1-Math.floor(t/e);return n(r,e-1-t%e,a)}return{boardSize:t*e*i,width:t,height:e,floors:i,fenHeight:e*i,C:r,R:a,F:s,POS:n,Graph:o,PosName:h,PosByName:c,CompactCrit:p,GetDistances:l,distEdge:function(){for(var s=[],n=0;n<t*e*i;n++){var o=r(n),h=a(n);s[n]=Math.min(o,Math.abs(t-o-1),h,Math.abs(e-h-1))}return s}(),corners:function(){var r={};return r[n(0,0,0)]=1,r[n(0,e-1,0)]=1,r[n(t-1,0,0)]=1,r[n(t-1,e-1,0)]=1,r[n(0,0,i-1)]=1,r[n(0,e-1,i-1)]=1,r[n(t-1,0,i-1)]=1,r[n(t-1,e-1,i-1)]=1,r}(),FenRowPos:u}};var t=Model.Game.cbConstants,e=[[1,0,0],[-1,0,0],[0,1,0],[0,-1,0],[0,0,1],[0,0,-1]],i=[[1,1,0],[1,-1,0],[-1,1,0],[-1,-1,0],[1,0,1],[-1,0,1],[0,1,1],[0,-1,1],[1,0,-1],[-1,0,-1],[0,1,-1],[0,-1,-1]],r=[[1,1,1],[1,-1,1],[-1,1,1],[-1,-1,1],[1,1,-1],[1,-1,-1],[-1,1,-1],[-1,-1,-1]],a=[[2,1,0],[2,-1,0],[-2,1,0],[-2,-1,0],[1,2,0],[-1,2,0],[1,-2,0],[-1,-2,0],[2,0,1],[2,0,-1],[-2,0,1],[-2,0,-1],[1,0,2],[-1,0,2],[1,0,-2],[-1,0,-2],[0,1,2],[0,-1,2],[0,1,-2],[0,-1,-2],[0,2,1],[0,2,-1],[0,-2,1],[0,-2,-1]];Model.Game.cbRSKingGraph=function(t){return this.cbShortRangeGraph(t,e.concat(r,i))},Model.Game.cbRSQueenGraph=function(t){return this.cbLongRangeGraph(t,e.concat(r,i))},Model.Game.cbRSKnightGraph=function(t){return this.cbShortRangeGraph(t,a)},Model.Game.cbRSRookGraph=function(t){return this.cbLongRangeGraph(t,e)},Model.Game.cbRSBishopGraph=function(t){return this.cbLongRangeGraph(t,i)},Model.Game.cbRSUnicornGraph=function(t){return this.cbLongRangeGraph(t,r)},Model.Game.cbRSPawnGraph=function(e,i){for(var r=this.cbShortRangeGraph(e,[[0,i,0],[0,0,i]],null,t.FLAG_MOVE),a=this.cbShortRangeGraph(e,[[i,i,0],[-i,i,0],[0,i,i],[-i,0,i],[i,0,i]],null,t.FLAG_CAPTURE),s=[],n=0;n<e.boardSize;n++)s[n]=r[n].concat(a[n]);return s},Model.Game.cb3DPawnGraph=function(e,i,r){var a=this.cbLongRangeGraph(e,[[0,i,0]],null,t.FLAG_MOVE,r),s=this.cbLongRangeGraph(e,[[1,i,0],[-1,i,0],[0,i,1],[0,i,-1]],null,t.FLAG_CAPTURE,1);return this.cbMergeGraphs(e,a,s)},Model.Game.cb3DKingGraph=function(e){var i=this.cbLongRangeGraph(e,[[1,-1,0],[1,0,0],[1,1,0],[0,1,0],[0,-1,0],[-1,-1,0],[-1,0,0],[-1,1,0]],null,t.FLAG_MOVE|t.FLAG_CAPTURE,1),r=this.cbLongRangeGraph(e,[[0,0,-1],[0,1,-1],[0,-1,-1],[1,0,-1],[-1,0,-1],[0,0,1],[0,1,1],[0,-1,1],[1,0,1],[-1,0,1]],null,t.FLAG_CAPTURE,1);return this.cbMergeGraphs(e,i,r)}}(),function(){var t=Model.Game.cbBoardGeometryMultiplan(5,5,5);Model.Game.cbDefine=function(){return{geometry:t,pieceTypes:{0:{name:"king",aspect:"fr-king",isKing:!0,graph:this.cbRSKingGraph(t),abbrev:"K",initial:[{s:1,p:2},{s:-1,p:122}]},1:{name:"queen",aspect:"fr-queen",graph:this.cbRSQueenGraph(t),abbrev:"Q",initial:[{s:1,p:27},{s:-1,p:97}],value:9},2:{name:"rook",aspect:"fr-rook",graph:this.cbRSRookGraph(t),value:5,abbrev:"R",initial:[{s:1,p:0},{s:1,p:4},{s:-1,p:124},{s:-1,p:120}],castle:!0},3:{name:"bishop",aspect:"fr-bishop",graph:this.cbRSBishopGraph(t),value:3.1,abbrev:"B",initial:[{s:1,p:25},{s:1,p:28},{s:-1,p:99},{s:-1,p:96}]},4:{name:"unicorn",aspect:"fr-unicorn",graph:this.cbRSUnicornGraph(t),value:2,abbrev:"U",initial:[{s:1,p:26},{s:1,p:29},{s:-1,p:98},{s:-1,p:95}]},5:{name:"knight",aspect:"fr-knight",graph:this.cbRSKnightGraph(t),value:2.9,abbrev:"N",initial:[{s:1,p:1},{s:1,p:3},{s:-1,p:123},{s:-1,p:121}]},6:{name:"pawn-w",aspect:"fr-pawn",graph:this.cbRSPawnGraph(t,1),value:1,abbrev:"P",initial:[{s:1,p:5},{s:1,p:6},{s:1,p:7},{s:1,p:8},{s:1,p:9},{s:1,p:30},{s:1,p:31},{s:1,p:32},{s:1,p:33},{s:1,p:34}]},7:{name:"pawn-b",aspect:"fr-pawn",graph:this.cbRSPawnGraph(t,-1),value:1,abbrev:"P",initial:[{s:-1,p:119},{s:-1,p:118},{s:-1,p:117},{s:-1,p:116},{s:-1,p:115},{s:-1,p:94},{s:-1,p:93},{s:-1,p:92},{s:-1,p:91},{s:-1,p:90}]}},promote:function(e,i,r){return 6==i.t&&4==t.R(r.t)&&4==t.F(r.t)?[5,4,3,2,1]:7==i.t&&0==t.R(r.t)&&0==t.F(r.t)?[5,4,3,2,1]:[]},evaluate:function(e,i,r){r[1].count,r[-1].count;this.noCaptCount>=100&&(this.mFinished=!0,this.mWinner=JocGame.DRAW);var a,s=e.cbUseTypedArrays?new Int8Array(3):[0,0,0],n=t.height,o=r[1].byType[6];if(o){a=o.length;for(var h=0;h<a;h++)switch(Math.max(n-t.R(o[h].p),t.floors-t.F(o[h].p))){case 2:s[0]++;break;case 3:s[1]++;break;case 4:s[2]++}}if(o=r[-1].byType[7]){a=o.length;for(var h=0;h<a;h++)switch(Math.max(t.R(o[h].p),t.F(o[h].p))){case 1:s[0]--;break;case 2:s[1]--;break;case 3:s[2]--}}0!=s[0]&&(i.distPawnPromo1=s[0]),0!=s[1]&&(i.distPawnPromo2=s[1]),0!=s[2]&&(i.distPawnPromo3=s[2]);for(var c=0,p=3;p<=5;p++)for(var l=1;l>=-1;l-=2){var u=r[l].byType[p];if(u)for(var h=0;h<u.length;h++)u[h].m&&(c+=l)}0!=c&&(i.minorPiecesMoved=c)}}}}();

/***/ }),

/***/ "jShC":
/***/ (function(module, exports) {

exports.model=Model={Game:{},Board:{},Move:{}},function(){var t;Model.Game.cbConstants={MASK:65535,FLAG_MOVE:65536,FLAG_CAPTURE:131072,FLAG_STOP:262144,FLAG_SCREEN_CAPTURE:524288,FLAG_CAPTURE_KING:1048576,FLAG_CAPTURE_NO_KING:2097152};var e="undefined"!=typeof Int32Array;Model.Game.cbUseTypedArrays=e,Model.Game.cbTypedArray=function(t){if(e){var r=new Int32Array(t.length);return r.set(t),r}for(var a=[],i=t.length,s=0;s<i;s++)a.push(t[s]);return a},Model.Game.cbShortRangeGraph=function(t,e,r,a){var i=this;void 0===a&&(a=196608);for(var s={},n=0;n<t.boardSize;n++)s[n]=[],(!r||n in r)&&e.forEach(function(e){var o=t.Graph(n,e);null!=o&&(!r||o in r)&&s[n].push(i.cbTypedArray([o|a]))});return s},Model.Game.cbLongRangeGraph=function(t,e,r,a,i){var s=this;void 0!==a&&null!=a||(a=196608),i||(i=1/0);for(var n={},o=0;o<t.boardSize;o++)n[o]=[],(!r||o in r)&&e.forEach(function(e){for(var h=[],c=t.Graph(o,e),p=0;null!=c&&(!r||c in r)&&(h.push(c|a),++p!=i);)c=t.Graph(c,e);h.length>0&&n[o].push(s.cbTypedArray(h))});return n},Model.Game.cbNullGraph=function(t){for(var e={},r=0;r<t.boardSize;r++)e[r]=[];return e},Model.Game.cbAuthorGraph=function(t){for(var e={},r=0;r<t.boardSize;r++){e[r]=[];for(var a=0;a<t.boardSize;a++)e[r].push([2293760|a])}return e},Model.Game.cbMergeGraphs=function(t){for(var e=[],r=0;r<t.boardSize;r++){e[r]=[];for(var a=1;a<arguments.length;a++)e[r]=e[r].concat(arguments[a][r])}return e},Model.Game.cbGetThreatGraph=function(){function t(e,r){for(var a in n){var i=n[a];if(!(i.p.length<r.length+1)){for(var s=!0,o=0;o<r.length;o++)if(r[o]!=i.p[o]){s=!1;break}if(s){var h=i.p[r.length],c=e[h];void 0===c&&(c={e:{}},e[h]=c),i.p.length==r.length+1&&(c.t=i.t,c.ts=i.ts,c.tk=i.tk,delete n[a]),r.push(h),t(c.e,r),r.pop()}}}}var e=this;this.cbUseScreenCapture=!1,this.cbUseCaptureKing=!1,this.cbUseCaptureNoKing=!1;for(var r={1:[],"-1":[]},a=[],i=0;i<this.g.boardSize;i++)this.g.pTypes.forEach(function(t,r){t.graph[i].forEach(function(t){for(var s=[],n=0;n<t.length;n++){var o=t[n];1048576&o?(e.cbUseCaptureKing=!0,s.unshift({d:65535&o,a:i,tk:r})):2097152&o?(e.cbUseCaptureNoKing=!0,s.unshift({d:65535&o,a:i,tnk:r})):131072&o?s.unshift({d:65535&o,a:i,t:r}):262144&o?s.unshift({d:65535&o,a:i}):524288&o&&(e.cbUseScreenCapture=!0,s.unshift({d:65535&o,a:i,ts:r}))}s.length>0&&a.push(s)})});var s={};a.forEach(function(t){t.forEach(function(e,r){var a=s[e.d];void 0===a&&(a={},s[e.d]=a);for(var i=[],n=r+1;n<t.length;n++)i.push(t[n].d);i.push(e.a);var o=i.join(","),h=a[o];void 0===h&&(h={p:i,t:{},ts:{},tk:{}},a[o]=h),void 0!==e.t?h.t[e.t]=!0:void 0!==e.tk?h.tk[e.tk]=!0:void 0!==e.ts&&(h.ts[e.ts]=!0)})});for(var i=0;i<e.g.boardSize;i++){var n=s[i],o={};t(o,[]),r[1][i]=o,r[-1][i]=o}return r},Model.Game.InitGame=function(){var e=this;this.cbVar=t=this.cbDefine(),this.g.boardSize=this.cbVar.geometry.boardSize,this.g.pTypes=this.cbGetPieceTypes(),this.g.threatGraph=this.cbGetThreatGraph(),this.g.distGraph=this.cbVar.geometry.GetDistances(),this.cbPiecesCount=0,this.g.castleablePiecesCount={1:0,"-1":0};for(var r in t.pieceTypes){var a=t.pieceTypes[r];if(a.castle){(a.initial||[]).forEach(function(t){e.g.castleablePiecesCount[t.s]++})}a.initial&&(this.cbPiecesCount+=a.initial.length)}for(var i=[],r=0;r<this.cbPiecesCount;r++)i.push(r);var s=Object.keys(t.pieceTypes);this.zobrist=new JocGame.Zobrist({board:{type:"array",size:this.cbVar.geometry.boardSize,values:i},who:{values:["1","-1"]},type:{type:"array",size:this.cbPiecesCount,values:s}})},Model.Game.cbGetPieceTypes=function(){for(var t=[],e={},r=0;r<this.cbVar.geometry.boardSize;r++)e[r]=[];for(var a in this.cbVar.pieceTypes){var i=this.cbVar.pieceTypes[a];t[a]={graph:i.graph||e,abbrev:i.abbrev||"",value:i.isKing?100:i.value||1,isKing:!!i.isKing,castle:!!i.castle,epTarget:!!i.epTarget,epCatch:!!i.epCatch}}return t},Model.Board.Init=function(t){this.zSign=0},Model.Board.InitialPosition=function(r){var a=this;this.board=e?new Int16Array(r.g.boardSize):[];for(var i=0;i<r.g.boardSize;i++)this.board[i]=-1;if(this.kings={},this.pieces=[],this.ending={1:!1,"-1":!1},this.lastMove=null,r.cbVar.castle&&(this.castled={1:!1,"-1":!1}),this.zSign=r.zobrist.update(0,"who",-1),this.noCaptCount=0,this.mWho=1,r.mInitial)this.mWho=r.mInitial.turn||1,r.mInitial.pieces.forEach(function(t){var e={};for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);a.pieces.push(e)}),r.mInitial.lastMove&&(this.lastMove={f:r.mInitial.lastMove.f,t:r.mInitial.lastMove.t}),void 0!==r.mInitial.noCaptCount&&(this.noCaptCount=r.mInitial.noCaptCount),r.cbVar.castle&&r.mInitial.castle&&(this.castled={1:{k:!!r.mInitial.castle[1]&&!!r.mInitial.castle[1].k,q:!!r.mInitial.castle[1]&&!!r.mInitial.castle[1].q},"-1":{k:!!r.mInitial.castle[-1]&&!!r.mInitial.castle[-1].k,q:!!r.mInitial.castle[-1]&&!!r.mInitial.castle[-1].q}});else for(var s in r.cbVar.pieceTypes)for(var n=r.cbVar.pieceTypes[s],o=n.initial||[],h=0;h<o.length;h++){var c=o[h],p={s:c.s,t:parseInt(s),p:c.p,m:!1};this.pieces.push(p)}if(this.pieces.sort(function(t,e){if(t.s!=e.s)return e.s-t.s;var a=r.cbVar.pieceTypes[t.t].value||100,i=r.cbVar.pieceTypes[e.t].value||100;return a!=i?a-i:t.p-e.p}),this.pieces.forEach(function(t,e){t.i=e,a.board[t.p]=e,r.g.pTypes[t.t].isKing&&(a.kings[t.s]=t.p),a.zSign=r.zobrist.update(a.zSign,"board",e,t.p),a.zSign=r.zobrist.update(a.zSign,"type",t.t,e)}),r.mInitial&&r.mInitial.enPassant){var i=t.geometry.PosByName(r.mInitial.enPassant);if(i>=0){var l,u=t.geometry.C(i),b=t.geometry.R(i);l=1==r.mInitial.turn?t.geometry.POS(u,b-1):t.geometry.POS(u,b+1),this.epTarget={p:i,i:this.board[l]}}}},Model.Board.CopyFrom=function(t){if(e)this.board=new Int16Array(t.board.length),this.board.set(t.board);else{this.board=[];for(var r=t.board,a=r.length,i=0;i<a;i++)this.board.push(r[i])}this.pieces=[];for(var s=t.pieces.length,i=0;i<s;i++){var n=t.pieces[i];this.pieces.push({s:n.s,p:n.p,t:n.t,i:n.i,m:n.m})}this.kings={1:t.kings[1],"-1":t.kings[-1]},this.check=t.check,t.lastMove?this.lastMove={f:t.lastMove.f,t:t.lastMove.t,c:t.lastMove.c}:this.lastMove=null,this.ending={1:t.ending[1],"-1":t.ending[-1]},void 0!==t.castled&&(this.castled={1:t.castled[1],"-1":t.castled[-1]}),this.noCaptCount=t.noCaptCount,t.epTarget?this.epTarget={p:t.epTarget.p,i:t.epTarget.i}:this.epTarget=null,this.mWho=t.mWho,this.zSign=t.zSign},Model.Board.cbApplyCastle=function(t,e,r){var a=t.cbVar.castle[e.f+"/"+e.cg],i=a.r[a.r.length-1],s=this.pieces[this.board[e.cg]],n=a.k[a.k.length-1],o=this.pieces[this.board[e.f]];return r&&(this.zSign=t.zobrist.update(this.zSign,"board",s.i,e.cg),this.zSign=t.zobrist.update(this.zSign,"board",s.i,i),this.zSign=t.zobrist.update(this.zSign,"board",o.i,e.f),this.zSign=t.zobrist.update(this.zSign,"board",o.i,n)),s.p=i,s.m=!0,this.board[e.cg]=-1,o.p=n,o.m=!0,this.board[e.f]=-1,this.board[i]=s.i,this.board[n]=o.i,this.castled[s.s]=!0,this.kings[o.s]=n,[{i:s.i,f:i,t:-1},{i:o.i,f:n,t:e.f,kp:e.f,who:o.s,m:!1},{i:s.i,f:-1,t:e.cg,m:!1,cg:!1}]},Model.Board.cbQuickApply=function(t,e){if(void 0!==e.cg)return this.cbApplyCastle(t,e,!1);var r=[],a=this.board[e.f],i=this.pieces[a];if(null!=e.c){r.unshift({i:e.c,f:-1,t:this.pieces[e.c].p});var s=this.pieces[e.c];this.board[s.p]=-1,s.p=-1}var n=this.kings[i.s];return t.g.pTypes[i.t].isKing&&(this.kings[i.s]=e.t),r.unshift({i:a,f:e.t,t:e.f,kp:n,who:i.s,ty:i.t}),i.p=e.t,void 0!==e.pr&&(i.t=e.pr),this.board[e.f]=-1,this.board[e.t]=a,r},Model.Board.cbQuickUnapply=function(t,e){for(var r=0;r<e.length;r++){var a=e[r],i=this.pieces[a.i];a.f>=0&&(i.p=-1,this.board[a.f]=-1),a.t>=0&&(i.p=a.t,this.board[a.t]=a.i),void 0!==a.m&&(i.m=a.m),void 0!==a.kp&&(this.kings[a.who]=a.kp),void 0!=a.ty&&(i.t=a.ty),void 0!=a.cg&&(this.castled[i.s]=a.cg)}},Model.Board.ApplyMove=function(t,e){var r=this.pieces[this.board[e.f]];if(void 0!==e.cg)this.cbApplyCastle(t,e,!0);else{if(this.zSign=t.zobrist.update(this.zSign,"board",r.i,e.f),this.board[r.p]=-1,void 0!==e.pr&&(this.zSign=t.zobrist.update(this.zSign,"type",r.t,r.i),r.t=e.pr,this.zSign=t.zobrist.update(this.zSign,"type",r.t,r.i)),null!=e.c){var a=this.pieces[e.c];this.zSign=t.zobrist.update(this.zSign,"board",a.i,a.p),this.board[a.p]=-1,a.p=-1,a.m=!0,this.noCaptCount=0}else this.noCaptCount++;r.p=e.t,r.m=!0,this.board[e.t]=r.i,this.zSign=t.zobrist.update(this.zSign,"board",r.i,e.t),t.g.pTypes[r.t].isKing&&(this.kings[r.s]=e.t)}this.check=!!e.ck,this.lastMove={f:e.f,t:e.t,c:e.c},void 0!==e.ko&&(this.ending[r.s]=e.ko),void 0!==e.ept?this.epTarget={p:e.ept,i:r.i}:this.epTarget=null,this.zSign=t.zobrist.update(this.zSign,"who",-this.mWho),this.zSign=t.zobrist.update(this.zSign,"who",this.mWho)},Model.Board.Evaluate=function(r){function a(e){var r=1/0;for(var a in t.geometry.corners)r=Math.min(r,h.distGraph[s.kings[e]][a]);return r-Math.sqrt(h.boardSize)}var i="debug"==arguments[3],s=this;this.mEvaluation=0;var n,o=this.mWho,h=r.g;if(e)n={1:{count:new Uint8Array(h.pTypes.length),byType:{}},"-1":{count:new Uint8Array(h.pTypes.length),byType:{}}};else{n={1:{count:[],byType:{}},"-1":{count:[],byType:{}}};for(var c=0;c<h.pTypes.length;c++)n[1].count[c]=n[-1].count[c]=0}if(r.mOptions.preventRepeat&&r.GetRepeatOccurence(this)>2)return this.mFinished=!0,void(this.mWinner=r.cbOnPerpetual?o*r.cbOnPerpetual:JocGame.DRAW);for(var p={1:0,"-1":0},l={1:h.distGraph[this.kings[-1]],"-1":h.distGraph[this.kings[1]]},u={1:0,"-1":0},b={1:0,"-1":0},v={1:0,"-1":0},f={1:0,"-1":0},g={1:!1,"-1":!1},d=this.pieces,m=d.length,c=0;c<m;c++){var G=d[c];if(G.p>=0){var y=G.s,M=h.pTypes[G.t];M.isKing?g[y]=G.m:p[y]+=M.value,M.castle&&!G.m&&f[y]++,b[y]++,u[y]+=l[y][G.p],v[y]+=t.geometry.distEdge[G.p];var C=n[y];C.count[G.t]++;var S=C.byType;void 0===S[G.t]?S[G.t]=[G]:S[G.t].push(G)}}if(this.lastMove&&null!=this.lastMove.c){var G=this.pieces[this.board[this.lastMove.t]];p[-G.s]+=this.cbStaticExchangeEval(r,G.p,G.s,{piece:G})}var k={1:0,"-1":0},A={1:0,"-1":0},T={1:0,"-1":0};this.ending[1]&&(A[1]=(u[1]-Math.sqrt(h.boardSize))/b[1],t.geometry.corners&&(T[1]=a(1))),this.ending[-1]&&(A[-1]=(u[-1]-Math.sqrt(h.boardSize))/b[-1],t.geometry.corners&&(T[1]=a(-1)));var z={pieceValue:p[1]-p[-1],pieceValueRatio:(p[1]-p[-1])/(p[1]+p[-1]+1),posValue:v[1]-v[-1],averageDistKing:u[1]/b[1]-u[-1]/b[-1],check:this.check?-o:0,endingKingFreedom:k[1]-k[-1],endingDistKing:A[1]-A[-1],distKingCorner:T[1]-T[-1]};t.castle&&(z.castle=(this.castled[1]?1:g[1]?0:f[1]/(h.castleablePiecesCount[1]+1))-(this.castled[-1]?1:g[-1]?0:f[-1]/(h.castleablePiecesCount[-1]+1))),t.evaluate&&t.evaluate.call(this,r,z,n);var E=r.mOptions.levelOptions;for(var P in z){var w=z[P],I=E[P+"Factor"]||0,R=w*I;i&&console.log(P,"=",w,"*",I,"=>",R),this.mEvaluation+=R}i&&console.log("Evaluation",this.mEvaluation)},Model.Board.cbGeneratePseudoLegalMoves=function(t){function e(e,i){var s=t.cbVar.promote;if(!s)return void a.push(i);var n=s.call(r,t,e,i);if(null!=n)if(0==n.length)a.push(i);else if(1==n.length)i.pr=n[0],a.push(i);else for(var o=0;o<n.length;o++){var h=n[o];a.push({f:i.f,t:i.t,c:i.c,pr:h,ept:i.ept,ep:i.ep,a:i.a})}}for(var r=this,a=[],i=t.cbVar,s=this.mWho,n=!i.castle||this.check||this.castled[s]?null:[],o=-1,h=this.pieces.length,c=0;c<h;c++){var p=this.pieces[c];if(!(p.p<0||p.s!=s)){var l=t.g.pTypes[p.t];l.isKing&&(p.m?n=null:o=p),n&&l.castle&&!p.m&&n.push(p);var u,b;u=l.graph[p.p],b=u.length;for(var v=0;v<b;v++)for(var f=u[v],g=!1,d=f.length,m=null,G=0;G<d;G++){var y=f[G],M=65535&y,C=this.board[M];if(!(C<0)||l.epCatch&&this.epTarget&&this.epTarget.p==M){if(!(524288&y)){var S;S=C<0?this.pieces[this.epTarget.i]:this.pieces[C],!(S.s!=p.s&&131072&y)||1048576&y&&!t.g.pTypes[S.t].isKing||2097152&y&&t.g.pTypes[S.t].isKing||e(p,{f:p.p,t:M,c:S.i,a:l.abbrev,ep:C<0});break}if(g){var S=this.pieces[C];S.s!=p.s&&e(p,{f:p.p,t:M,c:S.i,a:l.abbrev});break}g=!0}else 65536&y&&0==g&&e(p,{f:p.p,t:M,c:null,a:l.abbrev,ept:null!=m&&l.epTarget?m:void 0});m=M}}}if(n)for(var c=0;c<n.length;c++){var k=n[c],A=t.cbVar.castle[o.p+"/"+k.p];if(A){for(var T=!0,v=0;v<A.r.length;v++){var z=A.r[v];if(this.board[z]>=0&&z!=o.p&&z!=k.p){T=!1;break}}if(T){for(var E=!0,v=0;v<A.k.length;v++){var z=A.k[v];if(this.board[z]>=0&&z!=k.p&&z!=o.p||this.cbGetAttackers(t,z,s).length>0){E=!1;break}}E&&a.push({f:o.p,t:A.k[A.k.length-1],c:null,cg:k.p})}}}return a},Model.Board.cbStaticExchangeEval=function(t,e,r,a){var i=0,s=this.cbGetSmallestAttacker(t,e,r);if(s){var n=this.mWho;this.mWho=s.s;var o=this.cbQuickApply(t,{f:s.p,t:e,c:a.piece.i}),h=t.g.pTypes[a.piece.t].value;a.piece=s,i=Math.max(0,h-this.cbStaticExchangeEval(t,e,-r,a)),this.cbQuickUnapply(t,o),this.mWho=n}return i},Model.Board.cbGetSmallestAttacker=function(t,e,r){var a=this.cbGetAttackers(t,e,r);if(0==a.length)return null;for(var i=1/0,s=null,n=a.length,o=0;o<n;o++){var h=a[o],c=t.g.pTypes[h.t].value;c<i&&(i=c,s=h)}return s},Model.Board.cbCollectAttackers=function(t,e,r,a){for(var i in e){var s=e[i],n=this.board[i];if(n<0)this.cbCollectAttackers(t,s.e,r,a);else{var o=this.pieces[n];o.s==-t&&(s.t&&o.t in s.t||a&&s.tk&&o.t in s.tk)&&r.push(o)}}},Model.Board.cbCollectAttackersScreen=function(t,e,r,a,i){for(var s in e){var n=e[s],o=this.board[s];if(o<0)this.cbCollectAttackersScreen(t,n.e,r,a,i);else{var h=this.pieces[o];!i&&h.s==-t&&(n.t&&h.t in n.t||a&&n.tk&&h.t in n.tk)?r.push(h):i?i&&h.s==-t&&n.ts&&h.t in n.ts&&r.push(h):this.cbCollectAttackersScreen(t,n.e,r,a,!0)}}},Model.Board.cbGetAttackers=function(t,e,r,a){var i=[];return t.cbUseScreenCapture?this.cbCollectAttackersScreen(r,t.g.threatGraph[r][e],i,a,!1):this.cbCollectAttackers(r,t.g.threatGraph[r][e],i,a),i},Model.Board.GenerateMoves=function(t){var e=this.cbGeneratePseudoLegalMoves(t);this.mMoves=[];for(var r=!0,a=this.kings[this.mWho],i=e.length,s=0;s<i;s++){var n=e[s],o=this.cbQuickApply(t,n);if(!(this.cbGetAttackers(t,this.kings[this.mWho],this.mWho,!0).length>0)){var h=this.cbGetAttackers(t,this.kings[-this.mWho],-this.mWho,!0).length>0;n.ck=h,this.mMoves.push(n),n.f!=a&&(r=!1)}this.cbQuickUnapply(t,o)}if(0==this.mMoves.length)this.mFinished=!0,this.mWinner=t.cbOnStaleMate?t.cbOnStaleMate*this.mWho:JocGame.DRAW,this.check&&(this.mWinner=-this.mWho);else if(this.ending[this.mWho]){if(!r)for(var s=0;s<this.mMoves.length;s++)this.mMoves[s].ko=!1}else if(!this.ending[this.mWho]&&r&&!this.check)for(var s=0;s<this.mMoves.length;s++)this.mMoves[s].ko=!0},Model.Board.GetSignature=function(){return this.zSign},Model.Move.Init=function(t){for(var e in t)t.hasOwnProperty(e)&&(this[e]=t[e])},Model.Move.Equals=function(t){return this.f==t.f&&this.t==t.t&&this.pr==t.pr},Model.Move.CopyFrom=function(t){this.Init(t)},Model.Move.ToString=function(e){var r=this;switch(e=e||"natural"){case"natural":return function(){var e;if(void 0!==r.cg?e=t.castle[r.f+"/"+r.cg].n:(e=r.a||"",e+=t.geometry.PosName(r.f),null==r.c?e+="-":e+="x",e+=t.geometry.PosName(r.t)),void 0!==r.pr){var a=t.pieceTypes[r.pr];a&&a.abbrev&&a.abbrev.length>0&&!a.silentPromo&&(e+="="+a.abbrev)}return r.ck&&(e+="+"),e}();case"engine":return function(){var e=t.geometry.PosName(r.f)+t.geometry.PosName(r.t);if(void 0!=r.pr){var a=t.pieceTypes[r.pr];a&&a.abbrev&&a.abbrev.length>0&&!a.silentPromo&&(e+=a.abbrev)}return e}();default:return"??"}},Model.Board.CompactMoveString=function(e,r,a){"function"!=typeof r.ToString&&(r=e.CreateMove(r));var i=r.ToString(),s=/^([A-Z]?)([a-z])([1-9][0-9]*)([-x])([a-z])([1-9][0-9]*)(.*?)$/.exec(i);if(!s)return i;var n=s[7];if(a||(a={}),a.value||(a.value=[]),0==a.value.length){var o=this.mMoves;this.mMoves&&0!=this.mMoves.length||this.GenerateMoves(e);for(var h=0;h<this.mMoves.length;h++){var c=this.mMoves[h];"function"!=typeof c.ToString&&(c=e.CreateMove(c)),a.value.push({str:c.ToString(),move:c})}this.mMoves=o}var p=[];if(a.value.forEach(function(t){var e=/^([A-Z]?[a-z][1-9][0-9]*[-x][a-z][1-9][0-9]*)(.*?)$/.exec(t.str);e&&t.move.t==r.t&&(t.move.a||"")==s[1]&&e[2]==n&&p.push(t.move)}),1==p.length)return""==s[1]&&"x"==s[4]?s[2]+"x"+s[5]+s[6]+s[7]:s[1]+("x"==s[4]?"x":"")+s[5]+s[6]+s[7];if(t.geometry.CompactCrit)for(var l="",h=0;;h++){var u=t.geometry.CompactCrit(r.f,h);if(null==u)return i;l+=u;for(var b=[],v=0;v<p.length;v++){var f=p[v];t.geometry.CompactCrit(f.f,h)==u&&b.push(f)}if(console.assert(b.length>0),1==b.length)return s[1]+l+("x"==s[4]?"x":"")+s[5]+s[6]+s[7];p=b}return i},Model.Board.cbIntegrity=function(t){function e(t,e){t||console.error(e)}for(var r=this,a=0;a<this.board.length;a++){var i=this.board[a];if(i>=0){var s=r.pieces[i];e(void 0!==s,"no piece at pos"),e(s.p==a,"piece has different pos")}}for(var i=0;i<this.pieces.length;i++){var s=this.pieces[i];s.p>=0&&e(r.board[s.p]==i,"board index mismatch")}},Model.Board.ExportBoardState=function(t){return t.cbVar.geometry.ExportBoardState?t.cbVar.geometry.ExportBoardState(this,t.cbVar,t.mPlayedMoves.length):"not supported"},Model.Game.Import=function(e,r){var a,i=[],s={1:{},"-1":{}},n=null,o=0;if("pjn"==e){var h={status:!1,error:"parse"},c=r.split(" ");if(6!=c.length)return console.warn("FEN should have 6 parts"),h;var p=c[0].split("/"),l=t.geometry.fenHeight||t.geometry.height;if(p.length!=l)return console.warn("FEN board should have",l,"rows, got",p.length),h;var u={};for(var b in t.pieceTypes){var v=t.pieceTypes[b],f=v.fenAbbrev||v.abbrev||"X";u[f.toUpperCase()]={s:1,t:b},u[f.toLowerCase()]={s:-1,t:b}}var g=t.geometry.FenRowPos||function(e,r){return(t.geometry.height-1-e)*t.geometry.width+r};if(p.forEach(function(e,r){for(var a=0,s=0;s<e.length;s++){var n=e.substr(s,1),o=u[n];if(void 0!==o){var c=g(r,a);a++;for(var p={s:o.s,t:o.t,p:c},l=!0,b=t.pieceTypes[p.t].initial||[],v=0;v<b.length;v++){var f=b[v];f.s==p.s&&f.p==c&&(l=!1)}p.m=l,i.push(p)}else{if(isNaN(parseInt(n)))return console.warn("FEN invalid board spec",n),h;a+=parseInt(n)}}}),i.sort(function(t,e){return e.s-t.s}),"w"==c[1])a=1;else{if("b"!=c[1])return console.warn("FEN invalid turn spec",c[1]),h;a=-1}s[1].k=c[2].indexOf("K")>=0,s[1].q=c[2].indexOf("Q")>=0,s[-1].k=c[2].indexOf("k")>=0,s[-1].q=c[2].indexOf("q")>=0,n="-"==c[3]?null:c[3];var d=parseInt(c[4]);isNaN(d)||(o=d);var m={pieces:i,turn:a,castle:s,enPassant:n,noCaptCount:o};return t.importGame&&t.importGame.call(this,m,e,r),{status:!0,initial:m}}return{status:!1,error:"unsupported"}}}(),function(){Model.Game.cbBoardGeometryGrid=function(t,e){function r(e){return e%t}function a(e){return Math.floor(e/t)}function i(e,r){return r*t+e}function s(s,n){var o=r(s),h=a(s),c=o+n[0],p=h+n[1];return c<0||c>=t||p<0||p>=e?null:i(c,p)}function n(t){return String.fromCharCode("a".charCodeAt(0)+r(t))+(a(t)+1)}function o(t){var e=/^([a-z])([0-9]+)$/.exec(t);return e?i(e[1].charCodeAt(0)-"a".charCodeAt(0),parseInt(e[2])-1):-1}function h(t,e){return 0==e?String.fromCharCode("a".charCodeAt(0)+r(t)):1==e?a(t)+1:null}function c(){for(var i=[],s=0;s<t*e;s++){var n=[];i.push(n);for(var o=0;o<t*e;o++){var h=a(s),c=r(s),p=a(o),l=r(o);n.push(Math.max(Math.abs(h-p),Math.abs(c-l)))}}return i}function p(r,a,s){for(var o=[],h=e-1;h>=0;h--){for(var c="",p=0,l=0;l<t;l++){var u=r.board[i(l,h)];if(u<0)p++;else{p>0&&(c+=p,p=0);var b=r.pieces[u],v=a.pieceTypes[b.t].fenAbbrev||a.pieceTypes[b.t].abbrev||"?";b.s==-1?c+=v.toLowerCase():c+=v.toUpperCase()}}p&&(c+=p),o.push(c)}var f=o.join("/");f+=" ",1==r.mWho?f+="w":f+="b",f+=" ";var g="";return r.castled&&(r.castled[1]===!1?g+="KQ":(r.castled[1].k&&(g+="K"),r.castled[1].q&&(g+="Q")),r.castled[-1]===!1?g+="kq":(r.castled[-1].k&&(g+="k"),r.castled[-1].q&&(g+="q"))),0==g.length&&(g="-"),f+=g,f+=" ",r.epTarget?f+=n(r.epTarget.p):f+="-",f+=" ",f+=r.noCaptCount,f+=" ",f+=Math.floor(s/2)+1}return{boardSize:t*e,width:t,height:e,C:r,R:a,POS:i,Graph:s,PosName:n,PosByName:o,CompactCrit:h,GetDistances:c,distEdge:function(){for(var i=[],s=0;s<t*e;s++){var n=r(s),o=a(s);i[s]=Math.min(n,Math.abs(t-n-1),o,Math.abs(e-o-1))}return i}(),corners:function(){var r={};return r[i(0,0)]=1,r[i(0,e-1)]=1,r[i(t-1,0)]=1,r[i(t-1,e-1)]=1,r}(),ExportBoardState:p}},Model.Game.cbPawnGraph=function(t,e,r){for(var a=this,i={},s=0;s<t.boardSize;s++)if(!r||s in r){var n=[],o=t.Graph(s,[0,e]);null!=o&&(!r||o in r)&&n.push(a.cbTypedArray([o|a.cbConstants.FLAG_MOVE])),[-1,1].forEach(function(i){var o=t.Graph(s,[i,e]);null!=o&&(!r||o in r)&&n.push(a.cbTypedArray([o|a.cbConstants.FLAG_CAPTURE]))}),i[s]=n}else i[s]=[];return i},Model.Game.cbInitialPawnGraph=function(t,e,r){for(var a=this,i={},s=0;s<t.boardSize;s++)if(!r||s in r){var n=[],o=t.Graph(s,[0,e]);if(null!=o&&(!r||o in r)){var h=[o|a.cbConstants.FLAG_MOVE],c=t.Graph(o,[0,e]);null!=c&&(!r||c in r)&&h.push(c|a.cbConstants.FLAG_MOVE),n.push(a.cbTypedArray(h))}[-1,1].forEach(function(i){var o=t.Graph(s,[i,e]);null!=o&&(!r||o in r)&&n.push(a.cbTypedArray([o|a.cbConstants.FLAG_CAPTURE]))}),i[s]=n}else i[s]=[];return i},Model.Game.cbKingGraph=function(t,e){return this.cbShortRangeGraph(t,[[-1,-1],[-1,0],[-1,1],[0,-1],[0,1],[1,-1],[1,0],[1,1]],e)},Model.Game.cbKnightGraph=function(t,e){return this.cbShortRangeGraph(t,[[2,-1],[2,1],[-2,-1],[-2,1],[-1,2],[-1,-2],[1,2],[1,-2]],e)},Model.Game.cbHorseGraph=function(t){for(var e=this,r={},a=0;a<t.boardSize;a++)r[a]=[],[[1,0,2,-1],[1,0,2,1],[-1,0,-2,-1],[-1,0,-2,1],[0,1,-1,2],[0,-1,-1,-2],[0,1,1,2],[0,-1,1,-2]].forEach(function(i){var s=t.Graph(a,[i[0],i[1]]);if(null!=s){var n=t.Graph(a,[i[2],i[3]]);null!=n&&r[a].push(e.cbTypedArray([s|e.cbConstants.FLAG_STOP,n|e.cbConstants.FLAG_MOVE|e.cbConstants.FLAG_CAPTURE]))}});return r},Model.Game.cbRookGraph=function(t,e){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0]],e)},Model.Game.cbBishopGraph=function(t,e){return this.cbLongRangeGraph(t,[[1,-1],[1,1],[-1,1],[-1,-1]],e)},Model.Game.cbQueenGraph=function(t,e){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0],[1,-1],[1,1],[-1,1],[-1,-1]],e)},Model.Game.cbXQGeneralGraph=function(t,e){for(var r=this,a={},i=0;i<t.boardSize;i++)a[i]=[],[[-1,0,!1],[0,-1,!0],[0,1,!0],[1,0,!1]].forEach(function(s){var n=[],o=t.Graph(i,s);if(null!=o&&((!e||o in e)&&n.push(o|r.cbConstants.FLAG_MOVE|r.cbConstants.FLAG_CAPTURE),s[2]))for(var h=t.Graph(o,s);null!=h;)!e||h in e?n.push(h|r.cbConstants.FLAG_CAPTURE|r.cbConstants.FLAG_CAPTURE_KING):n.push(h|r.cbConstants.FLAG_STOP),h=t.Graph(h,s);n.length>0&&a[i].push(r.cbTypedArray(n))});return a},Model.Game.cbXQSoldierGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e]])},Model.Game.cbXQPromoSoldierGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e],[-1,0],[1,0]])},Model.Game.cbXQAdvisorGraph=function(t,e){return this.cbShortRangeGraph(t,[[1,1],[-1,1],[1,-1],[-1,-1]],e)},Model.Game.cbXQCannonGraph=function(t){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0]],null,this.cbConstants.FLAG_MOVE|this.cbConstants.FLAG_SCREEN_CAPTURE)},Model.Game.cbXQElephantGraph=function(t,e){for(var r=this,a={},i=0;i<t.boardSize;i++)a[i]=[],(!e||i in e)&&[[1,1,2,2],[1,-1,2,-2],[-1,1,-2,2],[-1,-1,-2,-2]].forEach(function(s){var n=t.Graph(i,[s[0],s[1]]);if(null!=n){var o=t.Graph(i,[s[2],s[3]]);null!=o&&(!e||o in e)&&a[i].push(r.cbTypedArray([n|r.cbConstants.FLAG_STOP,o|r.cbConstants.FLAG_MOVE|r.cbConstants.FLAG_CAPTURE]))}});return a},Model.Game.cbSilverGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e],[-1,-1],[-1,1],[1,-1],[1,1]])},Model.Game.cbFersGraph=function(t,e){return this.cbShortRangeGraph(t,[[-1,-1],[-1,1],[1,-1],[1,1]])},Model.Game.cbSchleichGraph=function(t,e){return this.cbShortRangeGraph(t,[[-1,0],[1,0],[0,-1],[0,1]])},Model.Game.cbAlfilGraph=function(t,e){return this.cbShortRangeGraph(t,[[-2,-2],[-2,2],[2,2],[2,-2]])}}(),function(){var t=Model.Game.cbBoardGeometryGrid(10,8);Model.Game.cbDefine=function(){return{geometry:t,pieceTypes:{0:{name:"pawn-w",aspect:"fr-pawn",graph:this.cbPawnGraph(t,1),value:1,abbrev:"",fenAbbrev:"P",epCatch:!0},1:{name:"ipawn-w",aspect:"fr-pawn",graph:this.cbInitialPawnGraph(t,1),value:1,abbrev:"",fenAbbrev:"P",initial:[{s:1,p:10},{s:1,p:11},{s:1,p:12},{s:1,p:13},{s:1,p:14},{s:1,p:15},{s:1,p:16},{s:1,p:17},{s:1,p:18},{s:1,p:19}],epTarget:!0},2:{name:"pawn-b",aspect:"fr-pawn",graph:this.cbPawnGraph(t,-1),value:1,abbrev:"",fenAbbrev:"P",epCatch:!0},3:{name:"ipawn-b",aspect:"fr-pawn",graph:this.cbInitialPawnGraph(t,-1),value:1,abbrev:"",fenAbbrev:"P",initial:[{s:-1,p:60},{s:-1,p:61},{s:-1,p:62},{s:-1,p:63},{s:-1,p:64},{s:-1,p:65},{s:-1,p:66},{s:-1,p:67},{s:-1,p:68},{s:-1,p:69}],epTarget:!0},4:{name:"knight",aspect:"fr-knight",graph:this.cbKnightGraph(t),value:2.9,abbrev:"N",initial:[{s:1,p:1},{s:1,p:8},{s:-1,p:71},{s:-1,p:78}]},5:{name:"bishop",aspect:"fr-bishop",graph:this.cbBishopGraph(t),value:3.1,abbrev:"B",initial:[{s:1,p:2},{s:1,p:7},{s:-1,p:72},{s:-1,p:77}]},6:{name:"rook",aspect:"fr-rook",graph:this.cbRookGraph(t),value:5,abbrev:"R",initial:[{s:1,p:0},{s:1,p:9},{s:-1,p:70},{s:-1,p:79}],castle:!0},7:{name:"queen",aspect:"fr-queen",graph:this.cbQueenGraph(t),value:9,abbrev:"Q",initial:[{s:1,p:3},{s:-1,p:73}]},8:{name:"king",aspect:"fr-king",isKing:!0,graph:this.cbKingGraph(t),abbrev:"K",initial:[{s:1,p:5},{s:-1,p:75}]},9:{name:"chancellor",aspect:"fr-marshall",graph:this.cbMergeGraphs(t,this.cbRookGraph(t),this.cbKnightGraph(t)),value:7.8,abbrev:"C",initial:[{s:1,p:4},{s:-1,p:74}]},10:{name:"archbishop",aspect:"fr-cardinal",graph:this.cbMergeGraphs(t,this.cbBishopGraph(t),this.cbKnightGraph(t)),value:6,abbrev:"A",initial:[{s:1,p:6},{s:-1,p:76}]}},promote:function(e,r,a){return 1==r.t?[0]:3==r.t?[2]:0==r.t&&7==t.R(a.t)?[4,5,6,7,9,10]:2==r.t&&0==t.R(a.t)?[4,5,6,7,9,10]:[]},castle:{"5/0":{k:[4,3,2],r:[1,2,3],n:"O-O-O"},"5/9":{k:[6,7,8],r:[8,7],n:"O-O"},"75/70":{k:[74,73,72],r:[71,72,73],n:"O-O-O"},"75/79":{k:[76,77,78],r:[78,77],n:"O-O"}}}}}();

/***/ }),

/***/ "jazq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("3j3K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base__ = __webpack_require__("TwGT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout__ = __webpack_require__("Sxsi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__media_query_media_monitor__ = __webpack_require__("bWt6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_layout_validator__ = __webpack_require__("eKS0");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LayoutWrapDirective; });
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */





/**
 * @deprecated
 * This functionality is now part of the `fxLayout` API
 *
 * 'layout-wrap' flexbox styling directive
 * Defines wrapping of child elements in layout container
 * Optional values: reverse, wrap-reverse, none, nowrap, wrap (default)]
 *
 *
 * @see https://css-tricks.com/almanac/properties/f/flex-wrap/
 */
var LayoutWrapDirective = (function (_super) {
    __extends(LayoutWrapDirective, _super);
    /* tslint:enable */
    function LayoutWrapDirective(monitor, elRef, renderer, container) {
        var _this = _super.call(this, monitor, elRef, renderer) || this;
        _this._layout = 'row'; // default flex-direction
        if (container) {
            _this._layoutWatcher = container.layout$.subscribe(_this._onLayoutChange.bind(_this));
        }
        return _this;
    }
    Object.defineProperty(LayoutWrapDirective.prototype, "wrap", {
        /* tslint:disable */
        set: function (val) { this._cacheInput("wrap", val); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LayoutWrapDirective.prototype, "wrapXs", {
        set: function (val) { this._cacheInput('wrapXs', val); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LayoutWrapDirective.prototype, "wrapSm", {
        set: function (val) { this._cacheInput('wrapSm', val); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(LayoutWrapDirective.prototype, "wrapMd", {
        set: function (val) { this._cacheInput('wrapMd', val); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(LayoutWrapDirective.prototype, "wrapLg", {
        set: function (val) { this._cacheInput('wrapLg', val); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(LayoutWrapDirective.prototype, "wrapXl", {
        set: function (val) { this._cacheInput('wrapXl', val); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(LayoutWrapDirective.prototype, "wrapGtXs", {
        set: function (val) { this._cacheInput('wrapGtXs', val); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(LayoutWrapDirective.prototype, "wrapGtSm", {
        set: function (val) { this._cacheInput('wrapGtSm', val); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(LayoutWrapDirective.prototype, "wrapGtMd", {
        set: function (val) { this._cacheInput('wrapGtMd', val); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(LayoutWrapDirective.prototype, "wrapGtLg", {
        set: function (val) { this._cacheInput('wrapGtLg', val); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(LayoutWrapDirective.prototype, "wrapLtSm", {
        set: function (val) { this._cacheInput('wrapLtSm', val); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(LayoutWrapDirective.prototype, "wrapLtMd", {
        set: function (val) { this._cacheInput('wrapLtMd', val); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(LayoutWrapDirective.prototype, "wrapLtLg", {
        set: function (val) { this._cacheInput('wrapLtLg', val); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(LayoutWrapDirective.prototype, "wrapLtXl", {
        set: function (val) { this._cacheInput('wrapLtXl', val); },
        enumerable: true,
        configurable: true
    });
    ;
    // *********************************************
    // Lifecycle Methods
    // *********************************************
    LayoutWrapDirective.prototype.ngOnChanges = function (changes) {
        if (changes['wrap'] != null || this._mqActivation) {
            this._updateWithValue();
        }
    };
    /**
     * After the initial onChanges, build an mqActivation object that bridges
     * mql change events to onMediaQueryChange handlers
     */
    LayoutWrapDirective.prototype.ngOnInit = function () {
        var _this = this;
        this._listenForMediaQueryChanges('wrap', 'wrap', function (changes) {
            _this._updateWithValue(changes.value);
        });
        this._updateWithValue();
    };
    LayoutWrapDirective.prototype.ngOnDestroy = function () {
        _super.prototype.ngOnDestroy.call(this);
        if (this._layoutWatcher) {
            this._layoutWatcher.unsubscribe();
        }
    };
    // *********************************************
    // Protected methods
    // *********************************************
    /**
     * Cache the parent container 'flex-direction' and update the 'flex' styles
     */
    LayoutWrapDirective.prototype._onLayoutChange = function (direction) {
        var _this = this;
        this._layout = (direction || '').toLowerCase().replace('-reverse', '');
        if (!__WEBPACK_IMPORTED_MODULE_4__utils_layout_validator__["b" /* LAYOUT_VALUES */].find(function (x) { return x === _this._layout; })) {
            this._layout = 'row';
        }
        this._updateWithValue();
    };
    LayoutWrapDirective.prototype._updateWithValue = function (value) {
        value = value || this._queryInput("wrap");
        if (this._mqActivation) {
            value = this._mqActivation.activatedInput;
        }
        value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_layout_validator__["c" /* validateWrapValue */])(value || 'wrap');
        this._applyStyleToElement(this._buildCSS(value));
    };
    /**
     * Build the CSS that should be assigned to the element instance
     */
    LayoutWrapDirective.prototype._buildCSS = function (value) {
        return {
            'display': 'flex',
            'flex-wrap': value,
            'flex-direction': this.flowDirection
        };
    };
    Object.defineProperty(LayoutWrapDirective.prototype, "flowDirection", {
        get: function () {
            var _this = this;
            var computeFlowDirection = function () { return _this._getFlowDirection(_this._elementRef.nativeElement); };
            return this._layoutWatcher ? this._layout : computeFlowDirection();
        },
        enumerable: true,
        configurable: true
    });
    return LayoutWrapDirective;
}(__WEBPACK_IMPORTED_MODULE_1__base__["a" /* BaseFxDirective */]));

LayoutWrapDirective.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{ selector: "\n  [fxLayoutWrap], [fxLayoutWrap.xs], [fxLayoutWrap.sm], [fxLayoutWrap.lg], [fxLayoutWrap.xl],\n  [fxLayoutWrap.gt-xs], [fxLayoutWrap.gt-sm], [fxLayoutWrap.gt-md], [fxLayoutWrap.gt-lg],\n  [fxLayoutWrap.lt-xs], [fxLayoutWrap.lt-sm], [fxLayoutWrap.lt-md], [fxLayoutWrap.lt-lg]\n" },] },
];
/** @nocollapse */
LayoutWrapDirective.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_3__media_query_media_monitor__["a" /* MediaMonitor */], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer2"], },
    { type: __WEBPACK_IMPORTED_MODULE_2__layout__["a" /* LayoutDirective */], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] },] },
]; };
LayoutWrapDirective.propDecorators = {
    'wrap': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxLayoutWrap',] },],
    'wrapXs': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxLayoutWrap.xs',] },],
    'wrapSm': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxLayoutWrap.sm',] },],
    'wrapMd': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxLayoutWrap.md',] },],
    'wrapLg': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxLayoutWrap.lg',] },],
    'wrapXl': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxLayoutWrap.xl',] },],
    'wrapGtXs': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxLayoutWrap.gt-xs',] },],
    'wrapGtSm': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxLayoutWrap.gt-sm',] },],
    'wrapGtMd': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxLayoutWrap.gt-md',] },],
    'wrapGtLg': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxLayoutWrap.gt-lg',] },],
    'wrapLtSm': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxLayoutWrap.lt-sm',] },],
    'wrapLtMd': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxLayoutWrap.lt-md',] },],
    'wrapLtLg': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxLayoutWrap.lt-lg',] },],
    'wrapLtXl': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxLayoutWrap.lt-xl',] },],
};
//# sourceMappingURL=layout-wrap.js.map

/***/ }),

/***/ "jcUl":
/***/ (function(module, exports) {

exports.config = {"status":true,"model":{"plazza":"true","released":1398178574,"title-en":"Baby Chess","module":"chessbase","summary":"5x5 Baby chess","thumbnail":"baby-thumb.png","rules":{"en":"baby-rules.html"},"credits":{"en":"baby-credits.html"},"gameOptions":{"preventRepeat":true,"uctTransposition":"state","uctIgnoreLoop":false,"levelOptions":{"pieceValueFactor":1,"pieceValueRatioFactor":1,"posValueFactor":0.1,"averageDistKingFactor":-0.01,"castleFactor":0.1,"minorPiecesMovedFactor":0.1,"checkFactor":0.2,"endingKingFreedomFactor":0.01,"endingDistKingFactor":0.05,"distKingCornerFactor":0.1}},"obsolete":false,"js":["base-model.js","grid-geo-model.js","baby-model.js"],"levels":[{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"easy","label":"Easy","maxNodes":1000},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"fast","label":"Fast [1sec]","maxDuration":1,"isDefault":true},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"medium","label":"Medium","maxNodes":10000,"maxDuration":10},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"strong","label":"Strong","maxNodes":20000,"maxDuration":15}],"description":{"en":"baby-description.html"}},"view":{"title-en":"Chessbase view","module":"chessbase","xdView":true,"css":["chessbase.css"],"preferredRatio":1,"useShowMoves":true,"useNotation":true,"useAutoComplete":true,"defaultOptions":{"sounds":true,"moves":true,"notation":false,"autocomplete":false},"skins":[{"name":"skin3d","title":"3D Classic","3d":true,"preload":["smoothedfilegeo|0|/res/ring-target.js","image|/res/images/cancel.png","image|/res/images/wikipedia.png","smoothedfilegeo|0|/res/staunton/pawn/pawn-classic.js","image|/res/staunton/pawn/pawn-diffusemap.jpg","image|/res/staunton/pawn/pawn-normalmap.jpg","smoothedfilegeo|0|/res/staunton/knight/knight.js","image|/res/staunton/knight/knight-diffusemap.jpg","image|/res/staunton/knight/knight-normalmap.jpg","smoothedfilegeo|0|/res/staunton/bishop/bishop.js","image|/res/staunton/bishop/bishop-diffusemap.jpg","image|/res/staunton/bishop/bishop-normalmap.jpg","smoothedfilegeo|0|/res/staunton/rook/rook.js","image|/res/staunton/rook/rook-diffusemap.jpg","image|/res/staunton/rook/rook-normalmap.jpg","smoothedfilegeo|0|/res/staunton/queen/queen.js","image|/res/staunton/queen/queen-diffusemap.jpg","image|/res/staunton/queen/queen-normalmap.jpg","smoothedfilegeo|0|/res/staunton/king/king.js","image|/res/staunton/king/king-diffusemap.jpg","image|/res/staunton/king/king-normalmap.jpg"],"world":{"lightIntensity":1.3,"skyLightIntensity":1.2,"lightCastShadow":true,"fog":false,"color":4686804,"lightPosition":{"x":-9,"y":9,"z":9},"skyLightPosition":{"x":9,"y":9,"z":9},"lightShadowDarkness":0.55,"ambientLightColor":2236962},"camera":{"fov":45,"distMax":50,"radius":18,"elevationAngle":60,"elevationMin":0}},{"name":"skin2d","title":"2D Classic","3d":false,"preload":["image|/res/images/cancel.png","image|/res/images/whitebg.png","image|/res/images/wikipedia.png"]}],"animateSelfMoves":false,"switchable":true,"sounds":{"move1":"alq_move1","move2":"alq_move2","move3":"alq_move3","move4":"alq_move2","tac1":"alq_tac1","tac2":"alq_tac2","tac3":"alq_tac1","promo":"promo","usermove":null},"js":["base-view.js","grid-board-view.js","staunton-set-view.js","baby-view.js"],"visuals":{"600x600":["res/visuals/baby-600x600-3d.jpg","res/visuals/baby-600x600-2d.jpg"]}}}

/***/ }),

/***/ "jdTm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var TimerObservable_1 = __webpack_require__("jnJ8");
exports.timer = TimerObservable_1.TimerObservable.create;
//# sourceMappingURL=timer.js.map

/***/ }),

/***/ "jdeX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var timer_1 = __webpack_require__("jdTm");
Observable_1.Observable.timer = timer_1.timer;
//# sourceMappingURL=timer.js.map

/***/ }),

/***/ "jhQO":
/***/ (function(module, exports) {

exports.model=Model={Game:{},Board:{},Move:{}},function(){function t(t){var i=t%e;return[i,(t-i)/e]}function i(t,i){return i*e+t}var e;Model.Game.InitGame=function(){var s=this;e=2*this.mOptions.centerDistance+1;var r=[[0,-1],[1,0],[0,1],[-1,0]];this.g.attackersCount=this.mOptions.initial.attackers.length,this.g.defendersCount=this.mOptions.initial.defenders.soldiers.length,this.g.excludeMap={},this.mOptions.exclude.forEach(function(t){s.g.excludeMap[t]=!0}),this.g.home=this.mOptions.initial.defenders.king,this.g.Graph=[],this.g.borders={};for(var a=0;a<e*e;a++){var o=[],n=t(a);r.forEach(function(t){var r=n[0]+t[0];if(r<0||r>=e)o.push(null),s.g.borders[a]=!0;else{var h=n[1]+t[1];if(h<0||h>=e)o.push(null),s.g.borders[a]=!0;else{var d=i(r,h);s.g.excludeMap[d]?o.push(null):o.push(d)}}}),this.g.Graph.push(o)}this.zobrist=new JocGame.Zobrist({board:{type:"array",size:e*e,values:["s1","s-1","k1","k-1"]}})},Model.Move.Init=function(t){var i=this;if(this.f=t.f,this.t=t.t,this.c=[],t.c)for(var e=0;e<t.c.length;e++)i.c.push(t.c[e])},Model.Move.CopyFrom=function(t){this.Init(t)},Model.Move.ToString=function(){var t=this.f+">"+this.t;return this.c.length>0&&(t+="x"+this.c.join(",")),t},Model.Board.Init=function(t){this.zSign=0},Model.Board.InitialPosition=function(i){function s(t,e,s){r.zSign=i.zobrist.update(r.zSign,"board",s+e,t),r.board[t]=r.pieces.length,r.pieces.push({i:r.pieces.length,p:t,s:e,t:s})}var r=this;this.board=[],this.pieces=[];for(var a=0;a<e*e;a++)this.board.push(-1);var o=i.mOptions.attackers;s(i.mOptions.initial.defenders.king,-o,"k");var n=i.mOptions.initial.defenders.soldiers;this.defendersCount=0;for(var h=0;h<n.length;h++)s(n[h],-o,"s"),this.defendersCount++;this.defendersCount=n.length;var d=i.mOptions.initial.attackers;this.attackersCount=0;for(var h=0;h<d.length;h++){s(d[h],o,"s");t(d[h]);this.attackersCount++}},Model.Board.CopyFrom=function(t){var i=this;this.board=[];for(var e=t.board,s=0;s<e.length;s++)i.board.push(e[s]);this.pieces=[];for(var r=t.pieces,a=0;a<r.length;a++){var o=r[a];i.pieces.push({i:o.i,p:o.p,s:o.s,t:o.t})}this.defendersCount=t.defendersCount,this.attackersCount=t.attackersCount,this.mWho=t.mWho,this.zSign=t.zSign},Model.Board.GenerateMoves=function(t){for(var i=this,e=[],s=0;s<this.pieces.length;s++){var r=this.pieces[s];if(!(r.s!=i.mWho||r.p<0))for(var a=0;a<4;a++)for(var o=t.g.Graph[r.p][a];null!=o;){var n=i.board[o];if(!(n<0)||o==t.g.home&&t.mOptions.privateHome&&"k"!=r.t)break;for(var h={f:r.p,t:o,c:[]},d=0;d<4;d++){var p=t.g.Graph[o][d];if(null!=p){var c=i.board[p];if(c>=0){var f=i.pieces[c];if(f.s==-r.s)if("k"==f.t){for(var u=0;u<4;u++){var l=t.g.Graph[p][u];if(null==l)break;var v=i.board[l];if(v<0){if(l!=o&&(l!=t.g.home||!t.mOptions.homeCatch))break}else{var g=i.pieces[v];if(g.s==f.s)break}}4==u&&h.c.push(p)}else{var l=t.g.Graph[p][d];if(null!=l){var v=i.board[l];if(l==t.g.home&&t.mOptions.homeCatch)h.c.push(p);else if(v>=0){var g=i.pieces[v];g.s==r.s&&h.c.push(p)}}}}}}if(e.push(h),!t.mOptions.longMove)break;o=t.g.Graph[o][a]}}this.mMoves=e},Model.Board.Evaluate=function(i){var e="debug"==arguments[3];if(this.mEvaluation=0,this.pieces[0].p<0)return this.mFinished=!0,void(this.mWinner=i.mOptions.attackers);if(this.pieces[0].p in i.g.borders)return this.mFinished=!0,void(this.mWinner=-i.mOptions.attackers);if(i.GetRepeatOccurence(this)>2)return this.mFinished=!0,void(this.mWinner=JocGame.DRAW);for(var s=this.pieces[0].p,r=t(s),a=0,o=i.mOptions.initial.attackers.length+1;o<this.pieces.length;o++){var n=this.pieces[o];if(n.p>=0){var h=t(n.p);a+=Math.max(Math.abs(h[0]-r[0]),Math.abs(h[1]-r[1]))}}var d={},p={};d[s]=1;for(var c=1,f=0,u=0;c>0;){var l={};c=0;for(var v in d){for(var g=d[v],m=g/4,b=i.g.Graph[v],k=0;k<4;k++)for(var M=b[k];M&&!(this.board[M]>=0)&&(M in p||M in d||(M in i.g.borders?f+=g:M in l?l[M]+=m:(u++,c++,l[M]=m)),i.mOptions.longMove);)M=i.g.Graph[M][k];p[v]=g}d=l}var O={attackersCount:this.attackersCount,defendersCount:this.defendersCount,kingPath:f,kingFreedom:u,distKing:a},C=i.mOptions.levelOptions;for(var z in O){var G=O[z],S=C[z+"Factor"]||0,E=G*S;e&&console.log(z,"=",G,"*",S,"=>",E),this.mEvaluation+=E}this.mEvaluation*=i.mOptions.attackers,e&&console.log("Evaluation",this.mEvaluation)},Model.Board.ApplyMove=function(i,e){var s=this,r=this.board[e.f],a=this.pieces[r];if(this.zSign=i.zobrist.update(this.zSign,"board",a.t+a.s,e.f),this.zSign=i.zobrist.update(this.zSign,"board",a.t+a.s,e.t),this.board[e.f]=-1,this.board[e.t]=r,a.p=e.t,this.mWho==i.mOptions.attackers){t(e.f),t(e.t)}for(var o=e.c,n=0;n<o.length;n++){var h=o[n],d=s.board[h],p=s.pieces[d];s.zSign=i.zobrist.update(s.zSign,"board",p.t+p.s,h),s.board[h]=-1,p.p=-1,s.mWho==-i.mOptions.attackers?s.attackersCount--:"s"==p.t&&s.defendersCount--}},Model.Board.taflIntegrity=function(t){var i=this,e=0,s=0;this.board.forEach(function(r,a){if(r>=0){var o=i.pieces[r];o.p,"s"==o.t&&(o.s==t.mOptions.attackers?e++:s++)}}),this.attackersCount,this.defendersCount,this.pieces.forEach(function(t,e){t.p>=0&&i.board[t.p]})},Model.Board.GetSignature=function(){return this.zSign}}();

/***/ }),

/***/ "jnJ8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var isNumeric_1 = __webpack_require__("P3oE");
var Observable_1 = __webpack_require__("rCTf");
var async_1 = __webpack_require__("CGGv");
var isScheduler_1 = __webpack_require__("fWbP");
var isDate_1 = __webpack_require__("fuZx");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var TimerObservable = (function (_super) {
    __extends(TimerObservable, _super);
    function TimerObservable(dueTime, period, scheduler) {
        if (dueTime === void 0) { dueTime = 0; }
        _super.call(this);
        this.period = -1;
        this.dueTime = 0;
        if (isNumeric_1.isNumeric(period)) {
            this.period = Number(period) < 1 && 1 || Number(period);
        }
        else if (isScheduler_1.isScheduler(period)) {
            scheduler = period;
        }
        if (!isScheduler_1.isScheduler(scheduler)) {
            scheduler = async_1.async;
        }
        this.scheduler = scheduler;
        this.dueTime = isDate_1.isDate(dueTime) ?
            (+dueTime - this.scheduler.now()) :
            dueTime;
    }
    /**
     * Creates an Observable that starts emitting after an `initialDelay` and
     * emits ever increasing numbers after each `period` of time thereafter.
     *
     * <span class="informal">Its like {@link interval}, but you can specify when
     * should the emissions start.</span>
     *
     * <img src="./img/timer.png" width="100%">
     *
     * `timer` returns an Observable that emits an infinite sequence of ascending
     * integers, with a constant interval of time, `period` of your choosing
     * between those emissions. The first emission happens after the specified
     * `initialDelay`. The initial delay may be a {@link Date}. By default, this
     * operator uses the `async` IScheduler to provide a notion of time, but you
     * may pass any IScheduler to it. If `period` is not specified, the output
     * Observable emits only one value, `0`. Otherwise, it emits an infinite
     * sequence.
     *
     * @example <caption>Emits ascending numbers, one every second (1000ms), starting after 3 seconds</caption>
     * var numbers = Rx.Observable.timer(3000, 1000);
     * numbers.subscribe(x => console.log(x));
     *
     * @example <caption>Emits one number after five seconds</caption>
     * var numbers = Rx.Observable.timer(5000);
     * numbers.subscribe(x => console.log(x));
     *
     * @see {@link interval}
     * @see {@link delay}
     *
     * @param {number|Date} initialDelay The initial delay time to wait before
     * emitting the first value of `0`.
     * @param {number} [period] The period of time between emissions of the
     * subsequent numbers.
     * @param {Scheduler} [scheduler=async] The IScheduler to use for scheduling
     * the emission of values, and providing a notion of "time".
     * @return {Observable} An Observable that emits a `0` after the
     * `initialDelay` and ever increasing numbers after each `period` of time
     * thereafter.
     * @static true
     * @name timer
     * @owner Observable
     */
    TimerObservable.create = function (initialDelay, period, scheduler) {
        if (initialDelay === void 0) { initialDelay = 0; }
        return new TimerObservable(initialDelay, period, scheduler);
    };
    TimerObservable.dispatch = function (state) {
        var index = state.index, period = state.period, subscriber = state.subscriber;
        var action = this;
        subscriber.next(index);
        if (subscriber.closed) {
            return;
        }
        else if (period === -1) {
            return subscriber.complete();
        }
        state.index = index + 1;
        action.schedule(state, period);
    };
    TimerObservable.prototype._subscribe = function (subscriber) {
        var index = 0;
        var _a = this, period = _a.period, dueTime = _a.dueTime, scheduler = _a.scheduler;
        return scheduler.schedule(TimerObservable.dispatch, dueTime, {
            index: index, period: period, subscriber: subscriber
        });
    };
    return TimerObservable;
}(Observable_1.Observable));
exports.TimerObservable = TimerObservable;
//# sourceMappingURL=TimerObservable.js.map

/***/ }),

/***/ "jvbR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var concatMap_1 = __webpack_require__("bE1M");
Observable_1.Observable.prototype.concatMap = concatMap_1.concatMap;
//# sourceMappingURL=concatMap.js.map

/***/ }),

/***/ "k27J":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var combineAll_1 = __webpack_require__("X2ud");
Observable_1.Observable.prototype.combineAll = combineAll_1.combineAll;
//# sourceMappingURL=combineAll.js.map

/***/ }),

/***/ "k5sZ":
/***/ (function(module, exports) {

exports.config = {"status":true,"model":{"plazza":"true","released":1393948578,"title-en":"Makruk","module":"chessbase","summary":"Thai Chess","thumbnail":"mk-thumb.png","rules":{"en":"mk-rules.html"},"credits":{"en":"mk-credits.html"},"gameOptions":{"preventRepeat":true,"uctTransposition":"state","uctIgnoreLoop":false,"levelOptions":{"pieceValueFactor":1,"pieceValueRatioFactor":1,"posValueFactor":0.1,"averageDistKingFactor":-0.01,"castleFactor":0.1,"minorPiecesMovedFactor":0.1,"checkFactor":0.2,"endingKingFreedomFactor":0.01,"endingDistKingFactor":0.05,"distKingCornerFactor":0.1}},"js":["base-model.js","grid-geo-model.js","makruk-model.js"],"description":{"en":"mk-description.html"},"levels":[{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"easy","label":"Easy","maxNodes":1000},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"fast","label":"Fast [1sec]","maxDuration":1,"isDefault":true},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"medium","label":"Medium","maxNodes":10000,"maxDuration":10},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"strong","label":"Strong","maxNodes":20000,"maxDuration":15}]},"view":{"title-en":"Chessbase view","module":"chessbase","xdView":true,"css":["chessbase.css"],"preferredRatio":1,"useShowMoves":true,"useNotation":true,"useAutoComplete":true,"defaultOptions":{"sounds":true,"moves":true,"notation":false,"autocomplete":false},"skins":[{"name":"skin3d","title":"3D Classic","3d":true,"preload":["smoothedfilegeo|0|/res/ring-target.js","image|/res/images/cancel.png","image|/res/images/wikipedia.png","image|/res/images/wood-chipboard-5.jpg","smoothedfilegeo|0|/res/makruk/pawn/mk-pawn.js","image|/res/makruk/pawn/mk-pawn-diffusemap.jpg","image|/res/makruk/pawn/mk-pawn-normalmap.jpg","smoothedfilegeo|0|/res/makruk/knight/mk-knight.js","image|/res/makruk/knight/mk-knight-diffusemap.jpg","image|/res/makruk/knight/mk-knight-normalmap.jpg","smoothedfilegeo|0|/res/makruk/bishop/mk-bishop.js","image|/res/makruk/bishop/mk-bishop-diffusemap.jpg","image|/res/makruk/bishop/mk-bishop-normalmap.jpg","smoothedfilegeo|0|/res/makruk/rook/mk-rook.js","image|/res/makruk/rook/mk-rook-diffusemap.jpg","image|/res/makruk/rook/mk-rook-normalmap.jpg","smoothedfilegeo|0|/res/makruk/queen/mk-queen.js","image|/res/makruk/queen/mk-queen-diffusemap.jpg","image|/res/makruk/queen/mk-queen-normalmap.jpg","smoothedfilegeo|0|/res/makruk/king/mk-king.js","image|/res/makruk/king/mk-king-diffusemap.jpg","image|/res/makruk/king/mk-king-normalmap.jpg"],"world":{"lightIntensity":0.8,"skyLightIntensity":0.4,"lightCastShadow":false,"fog":false,"color":4686804,"lightPosition":{"x":-10,"y":5,"z":0},"skyLightPosition":{"x":9,"y":9,"z":9},"lightShadowDarkness":0.85,"ambientLightColor":1118481},"camera":{"fov":45,"distMax":50,"radius":18,"elevationAngle":60,"elevationMin":0}},{"name":"skin2d","title":"2D Classic","3d":false,"preload":["image|/res/images/cancel.png","image|/res/images/whitebg.png","image|/res/images/wikipedia.png","image|/res/images/wood-chipboard-4.jpg"]}],"animateSelfMoves":false,"switchable":true,"sounds":{"move1":"alq_move1","move2":"alq_move2","move3":"alq_move3","move4":"alq_move2","tac1":"alq_tac1","tac2":"alq_tac2","tac3":"alq_tac1","promo":"promo","usermove":null},"js":["base-view.js","grid-board-view.js","makruk-board-view.js","makruk-set-view.js","makruk-view.js"],"visuals":{"600x600":["res/visuals/makruk-600x600-3d.jpg","res/visuals/makruk-600x600-2d.jpg"]}}}

/***/ }),

/***/ "k9VN":
/***/ (function(module, exports) {

exports.model=Model={Game:{},Board:{},Move:{}},Model.Game.InitGame=function(){for(var r=this,o=this.mOptions.size,e=[],t=[],i=0,a=0,n=[],s=0;s<o;s++)n.push(a),a+=(o-s)*(o-s);for(var s=0;s<o;s++)for(var p=0;p<o-s;p++)for(var u=0;u<o-s;u++){var l=i++;e[l]=[p,u,s],t[l]=[];for(var h=0;h<2;h++)for(var f=0;f<2;f++){var v=s-1,d=p+h,g=u+f;v>=0&&v<o&&d>=0&&d<o-v&&g>=0&&g<o-v?t[l].push(n[v]+d*(o-v)+g):t[l].push(null)}var c=[[0,-1],[0,1],[-1,0],[1,0]];for(var b in c){var m=c[b],v=s,d=p+m[0],g=u+m[1];v>=0&&v<o&&d>=0&&d<o-v&&g>=0&&g<o-v?t[l].push(n[v]+d*(o-v)+g):t[l].push(null)}for(var h=-1;h<1;h++)for(var f=-1;f<1;f++){var v=s+1,d=p+h,g=u+f;v>=0&&v<o&&d>=0&&d<o-v&&g>=0&&g<o-v?t[l].push(n[v]+d*(o-v)+g):t[l].push(null)}}this.g.Graph=t,this.g.Coord=e,this.g.Over=[],this.g.Beneath=[];for(var l=0;l<this.g.Graph.length;l++)this.g.Over[l]=null,this.g.Beneath[l]=null;for(var l=0;l<this.g.Graph.length;l++)for(var e=this.g.Coord[l],G=l+1;G<this.g.Graph.length;G++){var y=this.g.Coord[G];if(y[2]==e[2]+2&&y[0]==e[0]-1&&y[1]==e[1]-1){this.g.Over[l]=G,this.g.Beneath[G]=l;break}}this.g.EachDirection=function(o,e){for(var t=0;t<12;t++){var i=r.g.Graph[o][t];if(null!=i&&0==e(i,t))return}},this.g.EachDirectionDown=function(o,e){for(var t=[0,1,2,3],i=0;i<t.length;i++){var a=r.g.Graph[o][t[i]];if(null!=a&&0==e(a,t[i]))return}},this.g.EachDirectionUp=function(o,e){for(var t=[8,9,10,11],i=0;i<t.length;i++){var a=r.g.Graph[o][t[i]];if(null!=a&&0==e(a,t[i]))return}},this.g.EachDirectionFlat=function(o,e){for(var t=[4,5,6,7],i=0;i<t.length;i++){var a=r.g.Graph[o][t[i]];if(null!=a&&0==e(a,t[i]))return}},this.g.EachDirectionFlatDown=function(o,e){for(var t=[0,1,2,3,4,5,6,7],i=0;i<t.length;i++){var a=r.g.Graph[o][t[i]];if(null!=a&&0==e(a,t[i]))return}},this.g.EachDirectionFlatUp=function(o,e){for(var t=[4,5,6,7,8,9,10,11],i=0;i<t.length;i++){var a=r.g.Graph[o][t[i]];if(null!=a&&0==e(a,t[i]))return}},this.zobrist=new JocGame.Zobrist({board:{type:"array",size:this.g.Graph.length,values:[0,1]}}),this.InitGameExtra()},Model.Game.MapSameLevelDiagGraph=function(){for(var r=[0,16,25,29],o=0;o<4;o++)for(var e=0;e<4-o;e++)for(var t=0;t<4-o;t++)for(var i=r[o]+e*(4-o)+t,a=-1;a<2;a+=2)for(var n=-1;n<2;n+=2){var s=o,p=e+a,u=t+n;s>=0&&s<4&&p>=0&&p<4-s&&u>=0&&u<4-s?this.g.Graph[i].push(r[s]+p*(4-s)+u):this.g.Graph[i].push(null)}},Model.Game.InitGameExtra=function(){},Model.Game.DestroyGame=function(){this.DestroyGameExtra()},Model.Game.DestroyGameExtra=function(){},Model.Game.spUpdateZobrist=function(r,o,e,t,i,a){for(var n=0;n<o.length;n++)r=this.zobrist.update(r,"board",e,o[n]);for(var n=0;n<t.length;n++)r=this.zobrist.update(r,"board",i,t[n]);return r},Model.Move.Init=function(r){for(var o in r)r.hasOwnProperty(o)&&(this[o]=JSON.parse(JSON.stringify(r[o])))},Model.Move.ToString=function(){var r=["?","W","B","R"][this.clr],o="";switch(this.act){case"+":o+="+"+this.pos+r;break;case">":o+=this.from+">"+this.to+r}return o},Model.Board.Init=function(r){},Model.Board.InitialPosition=function(r){this.spInitialPosition(r)},Model.Board.spInitialPosition=function(r){this.board=[];for(var o=0;o<r.g.Graph.length;o++)this.board[o]=0;this.maxLayer=0,this.ballCount=[0,0,0],this.playables={},this.height=[0,0,0],this.zSign=0;for(var o=0;o<r.mOptions.size*r.mOptions.size;o++)this.playables[o]=!0},Model.Board.MakeFreeMoves=function(r){var o=[];for(var e in this.playables)o.push({act:"+",pos:e,clr:this.mWho==JocGame.PLAYER_A?1:2});return o},Model.Board.GenerateMoves=function(r){var o=this.GenerateAllMoves(r),e=r.mOptions.moveCount;0==o.length?(this.mFinished=!0,this.ballCount[1]>this.ballCount[2]?this.mWinner=JocGame.PLAYER_A:this.ballCount[1]<this.ballCount[2]?this.mWinner=JocGame.PLAYER_B:this.mWinner=JocGame.DRAW):void 0!==e&&o.length>e&&(r.ArrayShuffle(o),o.sort(function(r,o){o.nextBoard.evaluation,r.nextBoard.evaluation}),o.splice(e,o.length-e)),this.mMoves=o},Model.Board.GenerateAllMoves=function(r){return this.MakeFreeMoves(r)},Model.Board.Evaluate=function(r,o,e){this.mEvaluation=0},Model.Board.ApplyMove=function(r,o){this.spApplyMove(r,o)},Model.Board.spApplyMove=function(r,o){function e(o){delete t.playables[o],r.g.EachDirectionFlat(o,function(e,i){if(t.board[e]){var a,n;switch(i){case 4:a=7,n=10;break;case 5:a=6,n=9;break;case 6:a=4,n=8;break;case 7:a=5,n=11}var s=r.g.Graph[o][a];null!==s&&t.board[s]>0&&t.board[r.g.Graph[e][a]]&&(t.playables[r.g.Graph[o][n]]=!0)}})}var t=this;switch(o.act){case"+":this.board[o.pos]=o.clr;var i=r.g.Coord[o.pos][2];i>this.maxLayer&&(this.maxLayer=i),this.height[o.clr]+=i,this.ballCount[o.clr]++,e(o.pos);break;case">":o.down.length>0?this.playables[o.down[o.down.length-1]]=!0:this.playables[o.from]=!0;var a=o.from;for(var n in o.down){var s=o.down[n];this.height[this.board[s]]--,this.board[a]=this.board[s],a=s}this.board[a]=0,this.board[o.to]=o.clr;var i=r.g.Coord[o.to][2];this.height[o.clr]+=i,i>this.maxLayer&&(this.maxLayer=i),e(o.to)}},Model.Board.IsValidMove=function(r,o){return!0},Model.Board.ExtendMove=function(r,o){return{}},Model.Board.GetSignature=function(){return this.zSign},Model.Board.InitialPosition=function(r){this.spInitialPosition(r),this.groupMaxId=1,this.groups={},this.posGroup={},this.posFree={},this.center=0,this.moveEvaluation=0},Model.Board.GenerateAllMoves=function(r){for(var o=this.MakeFreeMoves(r),e=[],t=0;t<o.length;t++){var i=o[t],a=this.ExtendMove(r,i.pos);if(null!==a){i.nextBoard=a.board,i.remove=a.remove;var n=!1;r.mVisitedBoards&&r.mVisitedBoards[i.nextBoard.zSign]&&(n=!0),0==n&&e.push(i)}}return e},Model.Board.ExtendMove=function(r,o,e,t){function i(e){var t=p.board[e],i={side:t,p:{},pCount:1,f:{},fCount:0};i.p[e]=!0;for(var a=[e];a.length>0;){var n=a.pop();r.g.EachDirection(n,function(e,s){var u=p.board[e];if(u==t){if(e in i.p)return!0;var h=r.g.Over[e];if(null!==h&&(0!=p.board[h]||o==h))return!0;var f=G[s];if(void 0!==f){var v=r.g.Graph[n][f[0]],d=r.g.Graph[n][f[1]];if((v==o&&t==l||p.board[v]==3-t)&&(d==o&&t==l||p.board[d]==3-t))return!0}i.p[e]=!0,i.pCount++,a.push(e)}else if(0==u&&e!=o&&0==r.g.Coord[e][2]){if(e in i.f)return!0;i.f[e]=!0,i.fCount++}return!0})}return i}function a(r){var o=p.groupMaxId++;p.groups[o]=r;for(var e in r.p){p.posGroup[e];p.posGroup[e]=o}for(var t in r.f)void 0===p.posFree[t]&&(p.posFree[t]={}),p.posFree[t][o]=!0;return o}function n(r,o){var e=[];for(var t in o)e.push(t);for(var i=e[0],a=p.groups[i],n=1;n<e.length;n++){var t=e[n],s=p.groups[t];for(var u in s.p)a.p[u]=!0,p.posGroup[u]=i;a.pCount+=s.pCount;for(var l in s.f)l in a.f||(a.f[l]=!0,a.fCount++),delete p.posFree[l][t],p.posFree[l][i]=!0;delete p.groups[t]}if(r>=0){for(var l in b)l in a.f||(a.f[l]=!0,a.fCount++),void 0===p.posFree[l]&&(p.posFree[l]={}),p.posFree[l][i]=!0;a.p[r]=!0,a.pCount++,p.posGroup[r]=i}}function s(r,o,e){var t=p.groups[o];for(var i in e)i in t.f||(t.f[i]=!0,t.fCount++,void 0===p.posFree[i]&&(p.posFree[i]={}),p.posFree[i][o]=!0);t.p[r]=!0,t.pCount++,p.posGroup[r]=o}arguments.length<3&&(e=0),arguments.length<4&&(t=null),null==t&&(t=this);var p=JSON.parse(JSON.stringify({board:t.board,playables:t.playables,ballCount:t.ballCount,groups:t.groups,posFree:t.posFree,posGroup:t.posGroup,groupMaxId:t.groupMaxId,center:t.center,zSign:t.zSign,mWho:t.mWho})),u={};0==e&&(e=this.mWho==JocGame.PLAYER_A?1:2);var l=3-e,h=r.g.Coord[o],f=h[2],v={},d=0,g={},c=0,b={},m=0,G={4:[8,10],5:[9,11],6:[8,9],7:[10,11]},y={4:[0,2],5:[1,3],6:[0,1],7:[2,3]},M={},C={},F=r.g.Beneath[o];if(null!=F){var E=p.posGroup[F],B=p.groups[E];delete B.p[F],B.pCount--,p.posGroup[F]=0;var S=p.board[F],x=r.g.Coord[F][2];r.g.EachDirection(F,function(o,e){var t=p.board[o];if(r.g.Coord[o][2]==x){var i=G[e],a=r.g.Graph[F][i[0]],n=r.g.Graph[F][i[1]];if(null!=a&&p.board[a]==3-S&&null!=n||p.board[n]==3-S)return!0}return t==S&&p.posGroup[o]>0&&(C[o]=!0),!0})}f>0&&r.g.EachDirectionFlat(o,function(t,i){if(p.board[t]==e){var a=y[i],n=r.g.Graph[o][a[0]],s=r.g.Graph[o][a[1]];p.board[n]==l&&p.board[s]==l&&(p.posGroup[n]&&(C[n]=!0),p.posGroup[s]&&(C[s]=!0))}return!0});var D={};for(var z in C){var O=p.posGroup[z];D[O]=!0}for(var O in D)!function(r){var o=p.groups[r];for(var e in o.p)0!=p.posGroup[e]&&(p.posGroup[e]=-1);for(var t in o.f)delete p.posFree[t][r];delete p.groups[r]}(O);for(var z in C)p.posGroup[z]<0&&a(i(z));r.g.EachDirection(o,function(r){if(0==p.board[r])return!0;var o=p.posGroup[r];return 0==o||(p.board[r]==e?void 0===v[o]&&(v[o]=!0,d++):p.board[r]==l&&void 0===g[o]&&(g[o]=!0,c++),!0)}),0==f&&r.g.EachDirectionFlat(o,function(r){return 0==p.board[r]&&(b[r]=!0,m++),!0});var A=p.posFree[o];if(void 0!==A){for(var O in A){var B=p.groups[O];delete B.f[o],B.fCount--}delete p.posFree[o]}if(0==d){var B={side:e,p:{},pCount:1,f:b,fCount:m};B.p[o]=!0,a(B)}else if(1==d){for(var E in v);s(o,E,b)}else n(o,v);var w=!1;for(var E in p.groups)if(0!=E){var B=p.groups[E];B.side==l&&0==B.fCount&&(!function(e){var t=p.groups[e],n={},s={},l=[];for(var h in t.p)l.push({p:h,z:r.g.Coord[h][2]});l.sort(function(r,o){return o.z-r.z});for(var f=0;f<l.length;f++){var v=l[f],h=v.p,d=!1;if(r.g.EachDirectionUp(h,function(r){return!p.board[r]&&r!=o||(d=!0,!1)}),d)n[h]=!0,p.posGroup[h]=-1;else{0==v.z&&(s[h]=!0),p.board[h]=0,u[h]=!0,delete p.posGroup[h],p.ballCount[t.side]--,p.playables[h]=!0,r.g.EachDirectionUp(h,function(r){return p.playables[r]&&delete p.playables[r],!0});var g=r.g.Beneath[h];if(g)if(p.board[g]==t.side){var c=!1;if(r.g.EachDirectionDown(h,function(r){return p.board[r]!=t.side||(c=!0,!1)}),c){t.p[g]=!0,t.pCount++,p.posGroup[g]=e;for(var b={p:g,z:r.g.Coord[g][2]},m=f+1;m<l.length&&b.z<l[m].z;m++);l.splice(m,0,b)}else M[g]=!0}else M[g]=!0}}for(var G in t.f)delete p.posFree[G][e];delete p.groups[e];for(var G in s)r.g.EachDirectionFlat(G,function(r){var o=p.posGroup[r];if(void 0!==o&&o>0&&(void 0===p.posFree[G]&&(p.posFree[G]={}),void 0===p.posFree[G][o])){p.posFree[G][o]=!0;var e=p.groups[o];e.f[G]=!0,e.fCount++}return!0});for(var h in n)p.posGroup[h]==-1&&a(i(h))}(E),w=!0)}for(var z in M)if(0==p.posGroup[z]){var I=p.board[z],J={},P=0,W={},k=0,L=r.g.Coord[z][2];if(r.g.EachDirection(z,function(o,e){if(0==p.board[o])return!0;var t=p.posGroup[o];if(0==t)return!0;if(r.g.Coord[o][2]==L){var i=G[e],a=r.g.Graph[z][i[0]],n=r.g.Graph[z][i[1]];if(null!=a&&p.board[a]==3-I&&null!=n&&p.board[n]==3-I)return!0}return p.board[o]==I?void 0===J[t]&&(J[t]=!0,P++):0==p.board[o]&&0==r.g.Coord[o][2]&&(W[o]=!0,k++),!0}),0==P){var B={side:I,p:{},pCount:1,f:W,fCount:k};B.p[z]=!0;var E=a(B)}else if(1==P){for(var E in J);s(z,E,{})}else n(z,J)}if(w){var N=[];for(var E in p.groups)if(0!=E){var B=p.groups[E];B.side==e&&N.push(E)}N.sort(function(r,o){return parseInt(r)-parseInt(o)});for(var R=[],U=0;U<N.length;U++){var E=N[U],B=p.groups[E];for(var z in B.p){r.g.EachDirectionFlat(z,function(o,t){if(p.board[o]!=e)return!0;var i=p.posGroup[o];if(i!=E&&0!=i){var a=G[t],n=r.g.Graph[z][a[0]],s=r.g.Graph[z][a[1]];if(null==n||p.board[n]!=l||null==s||p.board[s]!=l){for(var u=null,h=[],f=0;f<R.length;f++){var v=R[f];if(E in v||i in v)if(u){for(var d in v)u[d]=!0;h.push(f)}else v[E]=!0,v[i]=!0,u=v}for(var f=h.length-1;f>=0;f--)R.splice(h[f],1);if(null==u){var v={};v[E]=!0,v[i]=!0,R.push(v)}}}return!0})}}for(var U=0;U<R.length;U++)n(-1,R[U])}for(var E in p.groups)if(0!=E){var B=p.groups[E];if(B.side==e&&0==B.fCount)for(var z in B.p){var H=!1;if(r.g.EachDirectionUp(z,function(r){return!(p.board[r]>0)||(H=!0,!1)}),0==H)return null}}var _=[];for(var E in p.groups){var B=p.groups[E];B.eyes=0;for(var z in B.p)_.push({p:z,z:r.g.Coord[z][2],group:B,gid:E})}_.sort(function(r,o){return o.z-r.z});for(var j={},Y={},U=0;U<_.length;U++){var V=_[U],Z=!1;r.g.EachDirectionUp(V.p,function(r){var o=j[r];return!(void 0!==o&&V.group.side&3-o)||(Z=!0,!1)}),V.pinned=Z,Y[V.p]=V,j[V.p]=Z?3:V.group.side}for(var T in p.posFree){var X=0,$=!0;r.g.EachDirectionFlat(T,function(r){if(0==p.board[r])return $=!1,!1;var o=p.posGroup[r];return 0!=X&&o!=X?($=!1,!1):(X=o,!0)}),0==X&&($=!1),$&&p.groups[X].eye++}p.relativeSecured=0,p.relativeHeight=0;var q=r.mOptions.levelOptions;for(var E in p.groups){var B=p.groups[E],K=1==B.side?1:-1,Q=q.evalSafety;B.eyes>=2?Q=q.evalSafety2eyes+Math.log(B.eyes-1)*q.evalSafetyXEyesBonus:1==B.fCount?Q=q.evalSafety1f:3==B.fCount?Q=q.evalSafety3f:B.fCount>3&&(Q=q.evalSafety3fMore+Math.log(B.fCount-3)*q.evalSafety3fMoreBonus),1==B.eyes&&(Q+=q.evalSafety1eyeBonus);for(var z in B.p){var V=Y[z],rr=Q;V.pinned&&(rr+=q.evalSafetyPinnedBonus),p.relativeSecured+=rr*K,p.relativeHeight+=V.z*K}}if(0==f){var K=1==e?1:-1,or=Math.abs(h[0]-(r.mOptions.size-1)/2)+Math.abs(h[1]-(r.mOptions.size-1)/2);p.center+=or*K*-1}p.moveEvaluation=p.relativeSecured+q.evalHeightRatio*p.relativeHeight+q.evalCenterRatio*p.center;var er=[];for(var tr in u)er.push(tr);return p.zSign=r.spUpdateZobrist(p.zSign,[o],e-1,er,2-e),{board:p,remove:er}},Model.Board.Evaluate=function(r,o,e){this.mEvaluation=this.moveEvaluation},Model.Board.CheckConsistency=function(r){for(var o=[0,0,0],e=0;e<r.g.Graph.length;e++){var t=(r.g.Coord[e],this.board[e]);if(t>0){if(void 0===this.posGroup[e])return console.error("pos",e,"side",t,"not assigned to any group"),!1;if(this.posFree[e]){var i=null;for(i in this.posFree[e]);if(null!=i)return console.error("pos",e,"side",t,"set as free for group",i),!1}o[t]++}else if(this.posGroup[e])return console.error("empty pos",e,"in posGroup"),!1;var a=r.g.Over[e];if(null!=a&&this.board[a]>0&&0!=this.posGroup[e])return console.error("buried ball",e,"does not have posGroup 0 but",this.posGroup[e]),!0}if(o[1]!=this.ballCount[1]||o[2]!=this.ballCount[2])return console.error("ball count mismatch, got",o[1],o[2],"expecting",this.ballCount[1],this.ballCount[2]),!1;for(var e in this.posGroup){if(0==this.board[e])return console.error("posGroup pos",e,"is empty"),!1;if(0!=this.posGroup[e]){if(void 0===this.groups[this.posGroup[e]])return console.error("posGroup",e,"in unknown group",this.posGroup[e]),!1;if(!(e in this.groups[this.posGroup[e]].p))return console.error("posGroup",e,"does not match group"),!1}}for(var e in this.posFree){if(0!=this.board[e])return console.error("posFree pos",e,"is not empty"),!1;for(var n in this.posFree[e]){var s=this.groups[n];if(void 0===s)return console.error("posFree pos",e,"group",n,"does not exist"),!1;if(!(e in s.f))return console.error("posFree pos",e,"group",n,"not in group freedoms"),!1}}for(var n in this.groups){var s=this.groups[n],p=0;for(var u in s.p){if(0==this.board[u])return console.error("pos",u,"in group",n,"marked as empty"),!1;if(this.board[u]!=s.side)return console.error("pos",u,"in group",n,"has wrong side"),!1;if(this.posGroup[u]!=n)return console.error("pos",u,"in group",n,"has wrong group",this.posGroup[u]),!1;p++}if(p!=s.pCount)return console.error("group",n,"count mismatch"),!1;p=0;for(var u in s.f){if(0!=this.board[u])return console.error("freedom pos",u,"in group",n,"is not empty"),!1;if(0!=r.g.Coord[u][2])return console.error("freedom pos",u,"in group",n,"not at ground level"),!1;if(void 0===this.posFree[u])return console.error("freedom pos",u,"in group",n,"not in freedoms"),!1;if(!this.posFree[u][n])return console.error("freedom pos",u,"in group",n,"is not empty for group"),!1;p++}if(p!=s.fCount)return console.error("group",n,"freedom count mismatch"),!1}return!0},Model.Board.ApplyMove=function(r,o){if(void 0===o.nextBoard){var e=this.ExtendMove(r,o.pos);e||console.log("move",o,JSON.stringify(r.mPlayedMoves)),this.CopyFrom(e.board)}else this.CopyFrom(o.nextBoard);this.spApplyMove(r,o)},Model.Board.CopyFrom=function(r){this.groupMaxId=r.groupMaxId,this.center=r.center,this.maxLayer=r.maxLayer,this.zSign=r.zSign,this.mWho=r.mWho,this.moveEvaluation=r.moveEvaluation,this.board=[],this.ballCount=[0,r.ballCount[1],r.ballCount[2]];for(var o=0;o<r.board.length;o++)this.board.push(r.board[o]);this.playables={};for(var o in r.playables)this.playables[o]=!0;this.groups={};for(var e in r.groups){var t=r.groups[e],i={side:t.side,p:{},pCount:t.pCount,f:{},fCount:t.fCount};for(var o in t.p)i.p[o]=!0;for(var o in t.f)i.f[o]=!0;this.groups[e]=i}this.posFree={};for(var o in r.posFree){var a={};for(var n in r.posFree[o])a[n]=!0;this.posFree[o]=a}this.posGroup={};for(var o in r.posGroup)this.posGroup[o]=r.posGroup[o];r.height?this.height=[0,r.height[1],r.height[2]]:this.height=[0,0,0],void 0!==r.mEvaluation&&(this.mEvaluation=r.mEvaluation),void 0!==r.mFinished&&(this.mFinished=r.mFinished),void 0!==r.mWinner&&(this.mWinner=r.mWinner)},Model.Game.Save=function(){for(var r={playedMoves:[],game:JoclyHub.modelName},o=0;o<this.mPlayedMoves.length;o++){var e=new(this.GetMoveClass())(this.mPlayedMoves[o]);delete e.nextBoard,delete e.remove,delete e.boardJSON,r.playedMoves.push(e)}var t=new Date;if(r.date=t.getFullYear()+"-"+(t.getMonth()+1)+"-"+t.getDate()+"-"+t.getHours()+"_"+t.getMinutes()+"_"+t.getSeconds(),JoclyHub.network.connected){$(".jocly-temp").remove();var i=document.createElement("form");i.setAttribute("class","jocly-temp"),i.setAttribute("style","display: none;"),i.setAttribute("method","post"),i.setAttribute("action","/jocly/save-game");var a=document.createElement("input");a.setAttribute("type","hidden"),a.setAttribute("name","data"),a.setAttribute("value",JSON.stringify(r)),i.appendChild(a),document.body.appendChild(i),i.submit()}else{var n=r.game+"-"+r.date+".joc",s="data:application/x-joc;filename="+n+","+encodeURIComponent(JSON.stringify(r));window.open(s,n)}},Model.Move.Strip=function(){if(void 0!==this.nextBoard||void 0!==this.remove){var r={};for(var o in this)this.hasOwnProperty(o)&&"nextBoard"!=o&&(r[o]=JSON.parse(JSON.stringify(this[o])));return r}return this};

/***/ }),

/***/ "kWVG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ngrx_store__ = __webpack_require__("WWmu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__("3Nrk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__("2ene");
/* unused harmony export INIT_ACTION */
/* harmony export (immutable) */ __webpack_exports__["a"] = liftInitialState;
/* harmony export (immutable) */ __webpack_exports__["b"] = liftReducerWith;



var INIT_ACTION = { type: __WEBPACK_IMPORTED_MODULE_0__ngrx_store__["d" /* Dispatcher */].INIT };
/**
* Computes the next entry in the log by applying an action.
*/
function computeNextEntry(reducer, action, state, error) {
    if (error) {
        return {
            state: state,
            error: 'Interrupted by an error up the chain'
        };
    }
    var nextState = state;
    var nextError;
    try {
        nextState = reducer(state, action);
    }
    catch (err) {
        nextError = err.toString();
        console.error(err.stack || err);
    }
    return {
        state: nextState,
        error: nextError
    };
}
/**
* Runs the reducer on invalidated actions to get a fresh computation log.
*/
function recomputeStates(computedStates, minInvalidatedStateIndex, reducer, committedState, actionsById, stagedActionIds, skippedActionIds) {
    // Optimization: exit early and return the same reference
    // if we know nothing could have changed.
    if (minInvalidatedStateIndex >= computedStates.length &&
        computedStates.length === stagedActionIds.length) {
        return computedStates;
    }
    var nextComputedStates = computedStates.slice(0, minInvalidatedStateIndex);
    for (var i = minInvalidatedStateIndex; i < stagedActionIds.length; i++) {
        var actionId = stagedActionIds[i];
        var action = actionsById[actionId].action;
        var previousEntry = nextComputedStates[i - 1];
        var previousState = previousEntry ? previousEntry.state : committedState;
        var previousError = previousEntry ? previousEntry.error : undefined;
        var shouldSkip = skippedActionIds.indexOf(actionId) > -1;
        var entry = shouldSkip ?
            previousEntry :
            computeNextEntry(reducer, action, previousState, previousError);
        nextComputedStates.push(entry);
    }
    return nextComputedStates;
}
function liftInitialState(initialCommittedState, monitorReducer) {
    return {
        monitorState: monitorReducer(undefined, {}),
        nextActionId: 1,
        actionsById: { 0: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils__["b" /* liftAction */])(INIT_ACTION) },
        stagedActionIds: [0],
        skippedActionIds: [],
        committedState: initialCommittedState,
        currentStateIndex: 0,
        computedStates: []
    };
}
/**
* Creates a history state reducer from an app's reducer.
*/
function liftReducerWith(initialCommittedState, initialLiftedState, monitorReducer, options) {
    if (options === void 0) { options = {}; }
    /**
    * Manages how the history actions modify the history state.
    */
    return function (reducer) { return function (liftedState, liftedAction) {
        var _a = liftedState || initialLiftedState, monitorState = _a.monitorState, actionsById = _a.actionsById, nextActionId = _a.nextActionId, stagedActionIds = _a.stagedActionIds, skippedActionIds = _a.skippedActionIds, committedState = _a.committedState, currentStateIndex = _a.currentStateIndex, computedStates = _a.computedStates;
        if (!liftedState) {
            // Prevent mutating initialLiftedState
            actionsById = Object.create(actionsById);
        }
        function commitExcessActions(n) {
            // Auto-commits n-number of excess actions.
            var excess = n;
            var idsToDelete = stagedActionIds.slice(1, excess + 1);
            for (var i = 0; i < idsToDelete.length; i++) {
                if (computedStates[i + 1].error) {
                    // Stop if error is found. Commit actions up to error.
                    excess = i;
                    idsToDelete = stagedActionIds.slice(1, excess + 1);
                    break;
                }
                else {
                    delete actionsById[idsToDelete[i]];
                }
            }
            skippedActionIds = skippedActionIds.filter(function (id) { return idsToDelete.indexOf(id) === -1; });
            stagedActionIds = [0].concat(stagedActionIds.slice(excess + 1));
            committedState = computedStates[excess].state;
            computedStates = computedStates.slice(excess);
            currentStateIndex = currentStateIndex > excess
                ? currentStateIndex - excess
                : 0;
        }
        // By default, agressively recompute every state whatever happens.
        // This has O(n) performance, so we'll override this to a sensible
        // value whenever we feel like we don't have to recompute the states.
        var minInvalidatedStateIndex = 0;
        switch (liftedAction.type) {
            case __WEBPACK_IMPORTED_MODULE_2__actions__["b" /* ActionTypes */].RESET: {
                // Get back to the state the store was created with.
                actionsById = { 0: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils__["b" /* liftAction */])(INIT_ACTION) };
                nextActionId = 1;
                stagedActionIds = [0];
                skippedActionIds = [];
                committedState = initialCommittedState;
                currentStateIndex = 0;
                computedStates = [];
                break;
            }
            case __WEBPACK_IMPORTED_MODULE_2__actions__["b" /* ActionTypes */].COMMIT: {
                // Consider the last committed state the new starting point.
                // Squash any staged actions into a single committed state.
                actionsById = { 0: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils__["b" /* liftAction */])(INIT_ACTION) };
                nextActionId = 1;
                stagedActionIds = [0];
                skippedActionIds = [];
                committedState = computedStates[currentStateIndex].state;
                currentStateIndex = 0;
                computedStates = [];
                break;
            }
            case __WEBPACK_IMPORTED_MODULE_2__actions__["b" /* ActionTypes */].ROLLBACK: {
                // Forget about any staged actions.
                // Start again from the last committed state.
                actionsById = { 0: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils__["b" /* liftAction */])(INIT_ACTION) };
                nextActionId = 1;
                stagedActionIds = [0];
                skippedActionIds = [];
                currentStateIndex = 0;
                computedStates = [];
                break;
            }
            case __WEBPACK_IMPORTED_MODULE_2__actions__["b" /* ActionTypes */].TOGGLE_ACTION: {
                // Toggle whether an action with given ID is skipped.
                // Being skipped means it is a no-op during the computation.
                var actionId_1 = liftedAction.id;
                var index = skippedActionIds.indexOf(actionId_1);
                if (index === -1) {
                    skippedActionIds = [actionId_1].concat(skippedActionIds);
                }
                else {
                    skippedActionIds = skippedActionIds.filter(function (id) { return id !== actionId_1; });
                }
                // Optimization: we know history before this action hasn't changed
                minInvalidatedStateIndex = stagedActionIds.indexOf(actionId_1);
                break;
            }
            case __WEBPACK_IMPORTED_MODULE_2__actions__["b" /* ActionTypes */].SET_ACTIONS_ACTIVE: {
                // Toggle whether an action with given ID is skipped.
                // Being skipped means it is a no-op during the computation.
                var start = liftedAction.start, end = liftedAction.end, active = liftedAction.active;
                var actionIds = [];
                for (var i = start; i < end; i++)
                    actionIds.push(i);
                if (active) {
                    skippedActionIds = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* difference */])(skippedActionIds, actionIds);
                }
                else {
                    skippedActionIds = skippedActionIds.concat(actionIds);
                }
                // Optimization: we know history before this action hasn't changed
                minInvalidatedStateIndex = stagedActionIds.indexOf(start);
                break;
            }
            case __WEBPACK_IMPORTED_MODULE_2__actions__["b" /* ActionTypes */].JUMP_TO_STATE: {
                // Without recomputing anything, move the pointer that tell us
                // which state is considered the current one. Useful for sliders.
                currentStateIndex = liftedAction.index;
                // Optimization: we know the history has not changed.
                minInvalidatedStateIndex = Infinity;
                break;
            }
            case __WEBPACK_IMPORTED_MODULE_2__actions__["b" /* ActionTypes */].SWEEP: {
                // Forget any actions that are currently being skipped.
                stagedActionIds = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils__["d" /* difference */])(stagedActionIds, skippedActionIds);
                skippedActionIds = [];
                currentStateIndex = Math.min(currentStateIndex, stagedActionIds.length - 1);
                break;
            }
            case __WEBPACK_IMPORTED_MODULE_2__actions__["b" /* ActionTypes */].PERFORM_ACTION: {
                // Auto-commit as new actions come in.
                if (options.maxAge && stagedActionIds.length === options.maxAge) {
                    commitExcessActions(1);
                }
                if (currentStateIndex === stagedActionIds.length - 1) {
                    currentStateIndex++;
                }
                var actionId = nextActionId++;
                // Mutation! This is the hottest path, and we optimize on purpose.
                // It is safe because we set a new key in a cache dictionary.
                actionsById[actionId] = liftedAction;
                stagedActionIds = stagedActionIds.concat([actionId]);
                // Optimization: we know that only the new action needs computing.
                minInvalidatedStateIndex = stagedActionIds.length - 1;
                break;
            }
            case __WEBPACK_IMPORTED_MODULE_2__actions__["b" /* ActionTypes */].IMPORT_STATE: {
                // Completely replace everything.
                (_b = liftedAction.nextLiftedState, monitorState = _b.monitorState, actionsById = _b.actionsById, nextActionId = _b.nextActionId, stagedActionIds = _b.stagedActionIds, skippedActionIds = _b.skippedActionIds, committedState = _b.committedState, currentStateIndex = _b.currentStateIndex, computedStates = _b.computedStates);
                break;
            }
            case __WEBPACK_IMPORTED_MODULE_0__ngrx_store__["e" /* Reducer */].REPLACE:
            case __WEBPACK_IMPORTED_MODULE_0__ngrx_store__["d" /* Dispatcher */].INIT: {
                // Always recompute states on hot reload and init.
                minInvalidatedStateIndex = 0;
                if (options.maxAge && stagedActionIds.length > options.maxAge) {
                    // States must be recomputed before committing excess.
                    computedStates = recomputeStates(computedStates, minInvalidatedStateIndex, reducer, committedState, actionsById, stagedActionIds, skippedActionIds);
                    commitExcessActions(stagedActionIds.length - options.maxAge);
                    // Avoid double computation.
                    minInvalidatedStateIndex = Infinity;
                }
                break;
            }
            default: {
                // If the action is not recognized, it's a monitor action.
                // Optimization: a monitor action can't change history.
                minInvalidatedStateIndex = Infinity;
                break;
            }
        }
        computedStates = recomputeStates(computedStates, minInvalidatedStateIndex, reducer, committedState, actionsById, stagedActionIds, skippedActionIds);
        monitorState = monitorReducer(monitorState, liftedAction);
        return {
            monitorState: monitorState,
            actionsById: actionsById,
            nextActionId: nextActionId,
            stagedActionIds: stagedActionIds,
            skippedActionIds: skippedActionIds,
            committedState: committedState,
            currentStateIndex: currentStateIndex,
            computedStates: computedStates
        };
        var _b;
    }; };
}
//# sourceMappingURL=reducer.js.map

/***/ }),

/***/ "kcyo":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
Some credit for this helper goes to http://github.com/YuzuJS/setImmediate
*/

var root_1 = __webpack_require__("VOfZ");
var ImmediateDefinition = (function () {
    function ImmediateDefinition(root) {
        this.root = root;
        if (root.setImmediate && typeof root.setImmediate === 'function') {
            this.setImmediate = root.setImmediate.bind(root);
            this.clearImmediate = root.clearImmediate.bind(root);
        }
        else {
            this.nextHandle = 1;
            this.tasksByHandle = {};
            this.currentlyRunningATask = false;
            // Don't get fooled by e.g. browserify environments.
            if (this.canUseProcessNextTick()) {
                // For Node.js before 0.9
                this.setImmediate = this.createProcessNextTickSetImmediate();
            }
            else if (this.canUsePostMessage()) {
                // For non-IE10 modern browsers
                this.setImmediate = this.createPostMessageSetImmediate();
            }
            else if (this.canUseMessageChannel()) {
                // For web workers, where supported
                this.setImmediate = this.createMessageChannelSetImmediate();
            }
            else if (this.canUseReadyStateChange()) {
                // For IE 6–8
                this.setImmediate = this.createReadyStateChangeSetImmediate();
            }
            else {
                // For older browsers
                this.setImmediate = this.createSetTimeoutSetImmediate();
            }
            var ci = function clearImmediate(handle) {
                delete clearImmediate.instance.tasksByHandle[handle];
            };
            ci.instance = this;
            this.clearImmediate = ci;
        }
    }
    ImmediateDefinition.prototype.identify = function (o) {
        return this.root.Object.prototype.toString.call(o);
    };
    ImmediateDefinition.prototype.canUseProcessNextTick = function () {
        return this.identify(this.root.process) === '[object process]';
    };
    ImmediateDefinition.prototype.canUseMessageChannel = function () {
        return Boolean(this.root.MessageChannel);
    };
    ImmediateDefinition.prototype.canUseReadyStateChange = function () {
        var document = this.root.document;
        return Boolean(document && 'onreadystatechange' in document.createElement('script'));
    };
    ImmediateDefinition.prototype.canUsePostMessage = function () {
        var root = this.root;
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `root.postMessage` means something completely different and can't be used for this purpose.
        if (root.postMessage && !root.importScripts) {
            var postMessageIsAsynchronous_1 = true;
            var oldOnMessage = root.onmessage;
            root.onmessage = function () {
                postMessageIsAsynchronous_1 = false;
            };
            root.postMessage('', '*');
            root.onmessage = oldOnMessage;
            return postMessageIsAsynchronous_1;
        }
        return false;
    };
    // This function accepts the same arguments as setImmediate, but
    // returns a function that requires no arguments.
    ImmediateDefinition.prototype.partiallyApplied = function (handler) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var fn = function result() {
            var _a = result, handler = _a.handler, args = _a.args;
            if (typeof handler === 'function') {
                handler.apply(undefined, args);
            }
            else {
                (new Function('' + handler))();
            }
        };
        fn.handler = handler;
        fn.args = args;
        return fn;
    };
    ImmediateDefinition.prototype.addFromSetImmediateArguments = function (args) {
        this.tasksByHandle[this.nextHandle] = this.partiallyApplied.apply(undefined, args);
        return this.nextHandle++;
    };
    ImmediateDefinition.prototype.createProcessNextTickSetImmediate = function () {
        var fn = function setImmediate() {
            var instance = setImmediate.instance;
            var handle = instance.addFromSetImmediateArguments(arguments);
            instance.root.process.nextTick(instance.partiallyApplied(instance.runIfPresent, handle));
            return handle;
        };
        fn.instance = this;
        return fn;
    };
    ImmediateDefinition.prototype.createPostMessageSetImmediate = function () {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
        var root = this.root;
        var messagePrefix = 'setImmediate$' + root.Math.random() + '$';
        var onGlobalMessage = function globalMessageHandler(event) {
            var instance = globalMessageHandler.instance;
            if (event.source === root &&
                typeof event.data === 'string' &&
                event.data.indexOf(messagePrefix) === 0) {
                instance.runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };
        onGlobalMessage.instance = this;
        root.addEventListener('message', onGlobalMessage, false);
        var fn = function setImmediate() {
            var _a = setImmediate, messagePrefix = _a.messagePrefix, instance = _a.instance;
            var handle = instance.addFromSetImmediateArguments(arguments);
            instance.root.postMessage(messagePrefix + handle, '*');
            return handle;
        };
        fn.instance = this;
        fn.messagePrefix = messagePrefix;
        return fn;
    };
    ImmediateDefinition.prototype.runIfPresent = function (handle) {
        // From the spec: 'Wait until any invocations of this algorithm started before this one have completed.'
        // So if we're currently running a task, we'll need to delay this invocation.
        if (this.currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // 'too much recursion' error.
            this.root.setTimeout(this.partiallyApplied(this.runIfPresent, handle), 0);
        }
        else {
            var task = this.tasksByHandle[handle];
            if (task) {
                this.currentlyRunningATask = true;
                try {
                    task();
                }
                finally {
                    this.clearImmediate(handle);
                    this.currentlyRunningATask = false;
                }
            }
        }
    };
    ImmediateDefinition.prototype.createMessageChannelSetImmediate = function () {
        var _this = this;
        var channel = new this.root.MessageChannel();
        channel.port1.onmessage = function (event) {
            var handle = event.data;
            _this.runIfPresent(handle);
        };
        var fn = function setImmediate() {
            var _a = setImmediate, channel = _a.channel, instance = _a.instance;
            var handle = instance.addFromSetImmediateArguments(arguments);
            channel.port2.postMessage(handle);
            return handle;
        };
        fn.channel = channel;
        fn.instance = this;
        return fn;
    };
    ImmediateDefinition.prototype.createReadyStateChangeSetImmediate = function () {
        var fn = function setImmediate() {
            var instance = setImmediate.instance;
            var root = instance.root;
            var doc = root.document;
            var html = doc.documentElement;
            var handle = instance.addFromSetImmediateArguments(arguments);
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement('script');
            script.onreadystatechange = function () {
                instance.runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
            return handle;
        };
        fn.instance = this;
        return fn;
    };
    ImmediateDefinition.prototype.createSetTimeoutSetImmediate = function () {
        var fn = function setImmediate() {
            var instance = setImmediate.instance;
            var handle = instance.addFromSetImmediateArguments(arguments);
            instance.root.setTimeout(instance.partiallyApplied(instance.runIfPresent, handle), 0);
            return handle;
        };
        fn.instance = this;
        return fn;
    };
    return ImmediateDefinition;
}());
exports.ImmediateDefinition = ImmediateDefinition;
exports.Immediate = new ImmediateDefinition(root_1.root);
//# sourceMappingURL=Immediate.js.map

/***/ }),

/***/ "kkb0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var ArrayObservable_1 = __webpack_require__("Yh8Q");
var mergeAll_1 = __webpack_require__("cbuX");
var isScheduler_1 = __webpack_require__("fWbP");
/* tslint:enable:max-line-length */
/**
 * Creates an output Observable which concurrently emits all values from every
 * given input Observable.
 *
 * <span class="informal">Flattens multiple Observables together by blending
 * their values into one Observable.</span>
 *
 * <img src="./img/merge.png" width="100%">
 *
 * `merge` subscribes to each given input Observable (either the source or an
 * Observable given as argument), and simply forwards (without doing any
 * transformation) all the values from all the input Observables to the output
 * Observable. The output Observable only completes once all input Observables
 * have completed. Any error delivered by an input Observable will be immediately
 * emitted on the output Observable.
 *
 * @example <caption>Merge together two Observables: 1s interval and clicks</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var timer = Rx.Observable.interval(1000);
 * var clicksOrTimer = clicks.merge(timer);
 * clicksOrTimer.subscribe(x => console.log(x));
 *
 * @example <caption>Merge together 3 Observables, but only 2 run concurrently</caption>
 * var timer1 = Rx.Observable.interval(1000).take(10);
 * var timer2 = Rx.Observable.interval(2000).take(6);
 * var timer3 = Rx.Observable.interval(500).take(10);
 * var concurrent = 2; // the argument
 * var merged = timer1.merge(timer2, timer3, concurrent);
 * merged.subscribe(x => console.log(x));
 *
 * @see {@link mergeAll}
 * @see {@link mergeMap}
 * @see {@link mergeMapTo}
 * @see {@link mergeScan}
 *
 * @param {ObservableInput} other An input Observable to merge with the source
 * Observable. More than one input Observables may be given as argument.
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @param {Scheduler} [scheduler=null] The IScheduler to use for managing
 * concurrency of input Observables.
 * @return {Observable} An Observable that emits items that are the result of
 * every input Observable.
 * @method merge
 * @owner Observable
 */
function merge() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i - 0] = arguments[_i];
    }
    return this.lift.call(mergeStatic.apply(void 0, [this].concat(observables)));
}
exports.merge = merge;
/* tslint:enable:max-line-length */
/**
 * Creates an output Observable which concurrently emits all values from every
 * given input Observable.
 *
 * <span class="informal">Flattens multiple Observables together by blending
 * their values into one Observable.</span>
 *
 * <img src="./img/merge.png" width="100%">
 *
 * `merge` subscribes to each given input Observable (as arguments), and simply
 * forwards (without doing any transformation) all the values from all the input
 * Observables to the output Observable. The output Observable only completes
 * once all input Observables have completed. Any error delivered by an input
 * Observable will be immediately emitted on the output Observable.
 *
 * @example <caption>Merge together two Observables: 1s interval and clicks</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var timer = Rx.Observable.interval(1000);
 * var clicksOrTimer = Rx.Observable.merge(clicks, timer);
 * clicksOrTimer.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // timer will emit ascending values, one every second(1000ms) to console
 * // clicks logs MouseEvents to console everytime the "document" is clicked
 * // Since the two streams are merged you see these happening
 * // as they occur.
 *
 * @example <caption>Merge together 3 Observables, but only 2 run concurrently</caption>
 * var timer1 = Rx.Observable.interval(1000).take(10);
 * var timer2 = Rx.Observable.interval(2000).take(6);
 * var timer3 = Rx.Observable.interval(500).take(10);
 * var concurrent = 2; // the argument
 * var merged = Rx.Observable.merge(timer1, timer2, timer3, concurrent);
 * merged.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // - First timer1 and timer2 will run concurrently
 * // - timer1 will emit a value every 1000ms for 10 iterations
 * // - timer2 will emit a value every 2000ms for 6 iterations
 * // - after timer1 hits it's max iteration, timer2 will
 * //   continue, and timer3 will start to run concurrently with timer2
 * // - when timer2 hits it's max iteration it terminates, and
 * //   timer3 will continue to emit a value every 500ms until it is complete
 *
 * @see {@link mergeAll}
 * @see {@link mergeMap}
 * @see {@link mergeMapTo}
 * @see {@link mergeScan}
 *
 * @param {...ObservableInput} observables Input Observables to merge together.
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @param {Scheduler} [scheduler=null] The IScheduler to use for managing
 * concurrency of input Observables.
 * @return {Observable} an Observable that emits items that are the result of
 * every input Observable.
 * @static true
 * @name merge
 * @owner Observable
 */
function mergeStatic() {
    var observables = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        observables[_i - 0] = arguments[_i];
    }
    var concurrent = Number.POSITIVE_INFINITY;
    var scheduler = null;
    var last = observables[observables.length - 1];
    if (isScheduler_1.isScheduler(last)) {
        scheduler = observables.pop();
        if (observables.length > 1 && typeof observables[observables.length - 1] === 'number') {
            concurrent = observables.pop();
        }
    }
    else if (typeof last === 'number') {
        concurrent = observables.pop();
    }
    if (scheduler === null && observables.length === 1 && observables[0] instanceof Observable_1.Observable) {
        return observables[0];
    }
    return new ArrayObservable_1.ArrayObservable(observables, scheduler).lift(new mergeAll_1.MergeAllOperator(concurrent));
}
exports.mergeStatic = mergeStatic;
//# sourceMappingURL=merge.js.map

/***/ }),

/***/ "koeG":
/***/ (function(module, exports) {

exports.config = {"status":true,"model":{"plazza":"true","released":1398178573,"title-en":"Los Alamos Chess","module":"chessbase","summary":"6x6 chess variant","thumbnail":"los-alamos-thumb.png","rules":{"en":"los-alamos-rules.html"},"credits":{"en":"los-alamos-credits.html"},"gameOptions":{"preventRepeat":true,"uctTransposition":"state","uctIgnoreLoop":false,"levelOptions":{"pieceValueFactor":1,"pieceValueRatioFactor":1,"posValueFactor":0.1,"averageDistKingFactor":-0.01,"castleFactor":0.1,"minorPiecesMovedFactor":0.1,"checkFactor":0.2,"endingKingFreedomFactor":0.01,"endingDistKingFactor":0.05,"distKingCornerFactor":0.1}},"obsolete":false,"js":["base-model.js","grid-geo-model.js","los-alamos-model.js"],"levels":[{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"easy","label":"Easy","maxNodes":1000},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"fast","label":"Fast [1sec]","maxDuration":1,"isDefault":true},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"medium","label":"Medium","maxNodes":10000,"maxDuration":10},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"strong","label":"Strong","maxNodes":20000,"maxDuration":15}],"description":{"en":"los-alamos-description.html"}},"view":{"title-en":"Chessbase view","module":"chessbase","xdView":true,"css":["chessbase.css"],"preferredRatio":1,"useShowMoves":true,"useNotation":true,"useAutoComplete":true,"defaultOptions":{"sounds":true,"moves":true,"notation":false,"autocomplete":false},"skins":[{"name":"skin3d","title":"3D Classic","3d":true,"preload":["smoothedfilegeo|0|/res/ring-target.js","image|/res/images/cancel.png","image|/res/images/wikipedia.png","smoothedfilegeo|0|/res/staunton/pawn/pawn-classic.js","image|/res/staunton/pawn/pawn-diffusemap.jpg","image|/res/staunton/pawn/pawn-normalmap.jpg","smoothedfilegeo|0|/res/staunton/knight/knight.js","image|/res/staunton/knight/knight-diffusemap.jpg","image|/res/staunton/knight/knight-normalmap.jpg","smoothedfilegeo|0|/res/staunton/bishop/bishop.js","image|/res/staunton/bishop/bishop-diffusemap.jpg","image|/res/staunton/bishop/bishop-normalmap.jpg","smoothedfilegeo|0|/res/staunton/rook/rook.js","image|/res/staunton/rook/rook-diffusemap.jpg","image|/res/staunton/rook/rook-normalmap.jpg","smoothedfilegeo|0|/res/staunton/queen/queen.js","image|/res/staunton/queen/queen-diffusemap.jpg","image|/res/staunton/queen/queen-normalmap.jpg","smoothedfilegeo|0|/res/staunton/king/king.js","image|/res/staunton/king/king-diffusemap.jpg","image|/res/staunton/king/king-normalmap.jpg"],"world":{"lightIntensity":1.3,"skyLightIntensity":1.2,"lightCastShadow":true,"fog":false,"color":4686804,"lightPosition":{"x":-9,"y":9,"z":9},"skyLightPosition":{"x":9,"y":9,"z":9},"lightShadowDarkness":0.55,"ambientLightColor":2236962},"camera":{"fov":45,"distMax":50,"radius":18,"elevationAngle":60,"elevationMin":0}},{"name":"skin2d","title":"2D Classic","3d":false,"preload":["image|/res/images/cancel.png","image|/res/images/whitebg.png","image|/res/images/wikipedia.png"]}],"animateSelfMoves":false,"switchable":true,"sounds":{"move1":"alq_move1","move2":"alq_move2","move3":"alq_move3","move4":"alq_move2","tac1":"alq_tac1","tac2":"alq_tac2","tac3":"alq_tac1","promo":"promo","usermove":null},"js":["base-view.js","grid-board-view.js","staunton-set-view.js","los-alamos-view.js"],"visuals":{"600x600":["res/visuals/los-alamos-600x600-3d.jpg","res/visuals/los-alamos-600x600-2d.jpg"]}}}

/***/ }),

/***/ "ks7d":
/***/ (function(module, exports, __webpack_require__) {

var
    conf = __webpack_require__("hvqw"),
    symbols = __webpack_require__("bgfr"),
    Square =  __webpack_require__("n9JH"),
    Piece = symbols.Piece,
    Conf = conf.Conf
;

function DraughtBoard(boardSize) {
    this.conf = null;
    if (boardSize == 8){
        this.conf = Conf['8x8']; // Bresilien
    } else if (boardSize == 12){
        this.conf = Conf['12x12']; // Canadien
    } else {
        this.conf = Conf['10x10']; // Default is International 10x10
    }


    /** Active Squares */
    this.squares = []; // [Square]


    /** Initialize active squares */
    for (var k = 1; k <= this.conf['SQ_MAX_NUM']; k++) {
        var c = new Square(k);
        this.squares.push(c);
    }
}




/** Initial position */
DraughtBoard.prototype.setInitialPosition = function() {
    for (var num = this.conf['B_POSITION'][0]; num <= this.conf['B_POSITION'][1]; num++) {
        this.setPiece(Piece.PAWN_BLACK, num);
    }

    for (var num = this.conf['W_POSITION'][0]; num <= this.conf['W_POSITION'][1]; num++) {
        this.setPiece(Piece.PAWN_WHITE, num);
    }
    return this;
};

/** Pose des pièces sur le damier */
DraughtBoard.prototype.setPosition = function(piece, numbers) {
    for (var k = 0; k < numbers.length; k++) {
        this.setPiece(piece, numbers[k]);
    }
    return this;
};

/** Ajouter une pièce sur une case. */
DraughtBoard.prototype.setPiece = function(piece, number) {
    var c = this.getSquare(number);
    c.piece = piece;
    return this;
};

/** Retourne une case. */
DraughtBoard.prototype.getSquare = function(number) {
    return this.squares[number - 1];
};

/** Retourne une case. */
DraughtBoard.prototype.getSquares = function() {
    return this.squares;
};

/** Connaitre la pièce se trouvant sur une case. */
DraughtBoard.prototype.isPiece = function(piece, number) {
    return (this.getPiece(number) === piece);
};

/** Retourne la pièce. */
DraughtBoard.prototype.getPiece = function(number) {
    return this.getSquare(number).piece;
};

DraughtBoard.prototype.getColor = function(number) {
    return this.getSquare(number).getColor();
};


/** Applique le mouvement sur le damier. */
DraughtBoard.prototype.applyMove = function(move) {
    var piecePlayed = this.getPiece(move.startingSquareNum);

    // Retirer la pièce de la case de départ
    this.setPiece(Piece.EMPTY, move.startingSquareNum);

    // Retirer les pièces des cases prises
    for (var i = 0; i < move.capturedSquares.length; i++) {
        var c = move.capturedSquares[i];
        this.setPiece(Piece.EMPTY, c.number);
    }

    // Poser la pièce sur la case d'arrivée
    if (!move.isCrowned) {
        this.setPiece(piecePlayed, move.endingSquareNum);
    }
    // Ce mouvement promeu en Dame
    else {
        if (piecePlayed == Piece.PAWN_WHITE) {
            this.setPiece(Piece.DAME_WHITE, move.endingSquareNum);
        } else if (piecePlayed == Piece.PAWN_BLACK) {
            this.setPiece(Piece.DAME_BLACK, move.endingSquareNum);
        }
    }
    return this;
};

/** Annule le mouvement sur le damier. */
DraughtBoard.prototype.applyMoveRev = function(move) {
    var piecePlayed = this.getPiece(move.endingSquareNum);

    // Retirer la pièce de la case d'arrivée
    this.setPiece(Piece.EMPTY, move.endingSquareNum);

    // Remettre les pièces qui avaient été prises.
    for (var i = 0; i < move.capturedSquares.length; i++) {
        var c = move.capturedSquares[i];
        this.setPiece(c.piece, c.number);
    }

    // Remettre la pièce sur la case de départ
    if (!move.isCrowned) {
        this.setPiece(piecePlayed, move.startingSquareNum);
    }

    // La dame redevient pion
    else {
        if (piecePlayed == Piece.DAME_WHITE) {
            this.setPiece(Piece.PAWN_WHITE, move.startingSquareNum);
        } else if (piecePlayed == Piece.DAME_BLACK) {
            this.setPiece(Piece.PAWN_BLACK, move.startingSquareNum);
        }
    }
    return this;
};

DraughtBoard.prototype.debugDraughtBoard = function() {
    var row = "";

    console.log("================================");
    for (var k = 0; k < 10; k++) {
        row += "|";
        for (var l = 1; l <= 5; l++) {

            var num = 5 * k + l;
            var p = this.getSquare(num).piece;

            if (k == 0 || k == 2 || k == 4 || k == 6 || k == 8) {
                row += "   ";
            }

            switch (p) {
            case Piece.PAWN_WHITE:
                row += " o ";
                break;
            case Piece.PAWN_BLACK:
                row += " x ";
                break;
            case Piece.DAME_WHITE:
                row += " O ";
                break;
            case Piece.DAME_BLACK:
                row += " X ";
                break;
            default:
                row += " . ";
            }

            if (k == 1 || k == 3 || k == 5 || k == 7 || k == 9) {
                row += "   ";
            }
        }
        row += "|";

        console.log(row);
        row = "";
    }
    console.log("================================");
};

module.exports = DraughtBoard;


/***/ }),

/***/ "l19J":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__("mmVS");
var ArgumentOutOfRangeError_1 = __webpack_require__("8Z8y");
var EmptyObservable_1 = __webpack_require__("jBEF");
/**
 * Emits only the last `count` values emitted by the source Observable.
 *
 * <span class="informal">Remembers the latest `count` values, then emits those
 * only when the source completes.</span>
 *
 * <img src="./img/takeLast.png" width="100%">
 *
 * `takeLast` returns an Observable that emits at most the last `count` values
 * emitted by the source Observable. If the source emits fewer than `count`
 * values then all of its values are emitted. This operator must wait until the
 * `complete` notification emission from the source in order to emit the `next`
 * values on the output Observable, because otherwise it is impossible to know
 * whether or not more values will be emitted on the source. For this reason,
 * all values are emitted synchronously, followed by the complete notification.
 *
 * @example <caption>Take the last 3 values of an Observable with many values</caption>
 * var many = Rx.Observable.range(1, 100);
 * var lastThree = many.takeLast(3);
 * lastThree.subscribe(x => console.log(x));
 *
 * @see {@link take}
 * @see {@link takeUntil}
 * @see {@link takeWhile}
 * @see {@link skip}
 *
 * @throws {ArgumentOutOfRangeError} When using `takeLast(i)`, it delivers an
 * ArgumentOutOrRangeError to the Observer's `error` callback if `i < 0`.
 *
 * @param {number} count The maximum number of values to emit from the end of
 * the sequence of values emitted by the source Observable.
 * @return {Observable<T>} An Observable that emits at most the last count
 * values emitted by the source Observable.
 * @method takeLast
 * @owner Observable
 */
function takeLast(count) {
    if (count === 0) {
        return new EmptyObservable_1.EmptyObservable();
    }
    else {
        return this.lift(new TakeLastOperator(count));
    }
}
exports.takeLast = takeLast;
var TakeLastOperator = (function () {
    function TakeLastOperator(total) {
        this.total = total;
        if (this.total < 0) {
            throw new ArgumentOutOfRangeError_1.ArgumentOutOfRangeError;
        }
    }
    TakeLastOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new TakeLastSubscriber(subscriber, this.total));
    };
    return TakeLastOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var TakeLastSubscriber = (function (_super) {
    __extends(TakeLastSubscriber, _super);
    function TakeLastSubscriber(destination, total) {
        _super.call(this, destination);
        this.total = total;
        this.ring = new Array();
        this.count = 0;
    }
    TakeLastSubscriber.prototype._next = function (value) {
        var ring = this.ring;
        var total = this.total;
        var count = this.count++;
        if (ring.length < total) {
            ring.push(value);
        }
        else {
            var index = count % total;
            ring[index] = value;
        }
    };
    TakeLastSubscriber.prototype._complete = function () {
        var destination = this.destination;
        var count = this.count;
        if (count > 0) {
            var total = this.count >= this.total ? this.total : this.count;
            var ring = this.ring;
            for (var i = 0; i < total; i++) {
                var idx = (count++) % total;
                destination.next(ring[idx]);
            }
        }
        destination.complete();
    };
    return TakeLastSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=takeLast.js.map

/***/ }),

/***/ "lHsB":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Subscriber_1 = __webpack_require__("mmVS");
var rxSubscriber_1 = __webpack_require__("r8ZY");
var Observer_1 = __webpack_require__("yrou");
function toSubscriber(nextOrObserver, error, complete) {
    if (nextOrObserver) {
        if (nextOrObserver instanceof Subscriber_1.Subscriber) {
            return nextOrObserver;
        }
        if (nextOrObserver[rxSubscriber_1.rxSubscriber]) {
            return nextOrObserver[rxSubscriber_1.rxSubscriber]();
        }
    }
    if (!nextOrObserver && !error && !complete) {
        return new Subscriber_1.Subscriber(Observer_1.empty);
    }
    return new Subscriber_1.Subscriber(nextOrObserver, error, complete);
}
exports.toSubscriber = toSubscriber;
//# sourceMappingURL=toSubscriber.js.map

/***/ }),

/***/ "lQJ9":
/***/ (function(module, exports, __webpack_require__) {

var
    DamWeb = __webpack_require__("0Iql"),
    PDN = __webpack_require__("ZyKR")
;


function DGController() {
    this.converter = null;
    this.titlePattern = null;
    this.currentNumGame = 0;
}


DGController.prototype.initDamWeb = function(position, notation) {
    this.converter = new DamWeb(position, notation);
};


DGController.prototype.initPDN = function(pdnText) {
    this.converter = new PDN(pdnText);
};

DGController.prototype.getCurrentNumGame = function() {
    return this.currentNumGame;
};

DGController.prototype.setCurrentNumGame = function(numGame) {
    this.currentNumGame = numGame;
};

DGController.prototype.setTitlePattern = function(pattern) {
    this.titlePattern = pattern;
};


DGController.prototype.getGameCount = function() {
    return this.converter.getGameCount();
};

DGController.prototype.getTitles = function() {
    return this.converter.getTitles(this.titlePattern);
};

DGController.prototype.getTitle = function() {
    if (this.currentNumGame) {
        return this.converter.getTitle(this.currentNumGame, this.titlePattern);
    } else {
        return "";
    }
};

DGController.prototype.getGame = function() {
    if (this.currentNumGame) {
        return this.converter.getGame(this.currentNumGame);
    } else {
        return new Game();
    }
};



module.exports = DGController;


/***/ }),

/***/ "lTB8":
/***/ (function(module, exports) {

exports.model=Model={Game:{},Board:{},Move:{}},function(){function t(t){if(o){var e=t%s;return(t-e)/s*s+s-e}var r=s*i-t-1,n=r%s;return r-n+s-n}var s,i,o=!1;Model.Game.checkersPosToString=t,Model.Game.InitGameInfo=function(){},Model.Game.BuildGraphCoord=function(){var t=(this.mOptions.width,this.mOptions.height,[]),s=[];this.g.Graph=t,this.g.Coord=s},Model.Game.InitGame=function(){var t=this.mOptions.width,e=this.mOptions.height;if(s=t,i=e,o=this.mOptions.invertNotation||!1,this.g.compulsoryCatch=!0,this.g.canStepBack=!0,this.g.mustMoveForward=!1,this.g.mustMoveForwardStrict=!1,this.g.lastRowFreeze=!1,this.g.lastRowCrown=!1,this.g.captureLongestLine=!1,this.g.noMove="lose",this.g.kingCaptureShort=!1,this.g.kingValue=5,this.g.lastRowFactor=0,this.g.canCaptureBackward=!0,this.g.captureInstantRemove=!1,this.g.longRangeKing=!0,this.g.drawKvsK=!0,this.g.drawKvs2K=!0,this.g.whiteStarts=!0,this.g.king180deg=!1,this.mOptions.variant)for(var r in this.mOptions.variant)this.mOptions.variant.hasOwnProperty(r)&&(this.g[r]=this.mOptions.variant[r]);this.BuildGraphCoord(),this.zobrist=new JocGame.Zobrist({board:{type:"array",size:this.g.Graph.length,values:["1/0","1/1","-1/0","-1/1"]}})},Model.Game.DestroyGame=function(){},Model.Game.CheckersDirections=4,Model.Game.Checkers2WaysDirections=[0,1,1,0],Model.Game.CheckersEachDirection=function(t,s){for(var i=0;i<this.CheckersDirections;i++){var o=this.g.Graph[t][i];if(null!=o&&0==s(o,i))return}},Model.Move.Init=function(t){this.pos=[];for(var s=t.pos?Object.keys(t.pos).sort():[],i=0;i<s.length;i++)this.pos.push(t.pos[i]);this.capt=[];for(var o=t.capt?Object.keys(t.capt).sort():[],i=0;i<o.length;i++)this.capt.push(t.capt[i])},Model.Move.ToString=function(s){s=s||"natural";var i=this;switch(s){case"natural":return function(){for(var s=[t(i.pos[0]),t(i.pos[i.pos.length-1])],o="-",e=1;e<i.capt.length;e++)null!=i.capt[e]&&(o="x",i.capt.length>3&&s.push(t(i.capt[e])));return s.join(o)}();case"hub":return function(){var s="-",o=[t(i.pos[0]),t(i.pos[i.pos.length-1])];if(i.capt[1]){s="x";var e=i.capt.slice(1).map(function(s){return t(s)});e.sort(),o=o.concat(e)}return o.join(s)}();case"dxp":return function(){var s=[t(i.pos[0]),t(i.pos[i.pos.length-1])];if(i.capt[1]){s.push(i.capt.length-1);for(var o=[],e=1;e<i.capt.length;e++)o.push(t(i.capt[e]));o.sort(),s=s.concat(o)}else s.push(0);return s.map(function(t){return t<10?"0"+t:t}).join("")}();default:return"??"}},Model.Board.Init=function(t){this.zSign=0},Model.Board.InitialPosition=function(t){var s=t.mOptions.width,i=t.mOptions.height,o=t.mOptions.initial;this.board=[];for(var e=0;e<i;e++)for(var r=0;r<s;r++)this.board[e*s+r]=-1;this.pieces=[];var n=0;if(t.mInitial){this.pCount=[0,0],this.spCount=[0,0],this.kpCount=[0,0];for(var a=0;a<t.mInitial.pieces.length;a++){var h=t.mInitial.pieces[a];this.board[h.p]=a,this.pieces.push({s:h.s,p:h.p,l:-1,t:h.t,plp:h.p}),this.zSign=t.zobrist.update(this.zSign,"board",h.s+"/"+h.t,h.p);var p=-(h.s-1)/2;this.pCount[p]++,0==h.t?this.spCount[p]++:this.kpCount[p]++}}else{for(var a in o.a)if(o.a.hasOwnProperty(a)){var u=o.a[a],c=u[0]*s+u[1],h={s:JocGame.PLAYER_A,p:c,l:-1,t:0,plp:c};this.pieces.push(h),this.board[c]=n++,this.zSign=t.zobrist.update(this.zSign,"board","1/0",c)}for(var a in o.b)if(o.b.hasOwnProperty(a)){var u=o.b[a],c=u[0]*s+u[1],h={s:JocGame.PLAYER_B,p:c,l:-1,t:0,plp:c};this.pieces.push(h),this.board[c]=n++,this.zSign=t.zobrist.update(this.zSign,"board","-1/0",c)}this.pCount=[o.a.length,o.b.length],this.spCount=[o.a.length,o.b.length],this.kpCount=[o.a.length,o.b.length]}},Model.Board.GenerateMoves=function(t){try{this._GenerateMoves(t)}catch(t){}},Model.Board._GenerateMoves=function(t){function s(t){for(var s=0;s<e.pieces.length;s++){var i=e.pieces[s];i&&i.s==e.mWho&&t(s,i.p)}}function i(s,o,r,n,a){for(;;){var h=[],p=[],u=[];if(t.CheckersEachDirection(s,function(i,c){var l;0==t.g.canCaptureBackward&&(l=t.g.Coord[s][0]);var g=t.Checkers2WaysDirections[c];if(a){if(t.g.longRangeKing)for(;e.board[i]==-1||t.g.king180deg&&null!=i&&r.indexOf(i)>=0;)i=t.g.Graph[i][c];if(null!=i&&e.board[i]>=0&&e.pieces[e.board[i]].s==-e.mWho){var v=i;if(i=t.g.Graph[i][c],t.g.kingCaptureShort){if(e.board[i]==-1||i==o[0]){for(var f=!0,d=0;d<n.length;d++)if(t.g.king180deg){if(r[d]==v){f=!1;break}}else if(t.g.captureInstantRemove&&r[d]==v||0==t.g.captureInstantRemove&&r[d]==v&&n[d]==g){f=!1;break}f&&(h.push(i),p.push(v),u.push(g)),i=t.g.Graph[i][c]}}else for(;e.board[i]==-1||i==o[0];){for(var f=!0,d=0;d<n.length;d++)if(t.g.captureInstantRemove&&r[d]==v||0==t.g.captureInstantRemove&&r[d]==v&&n[d]==g){f=!1;break}f&&(h.push(i),p.push(v),u.push(g)),i=t.g.Graph[i][c]}}}else if(e.board[i]>=0&&e.pieces[e.board[i]].s==-e.mWho){var m,C;if(0==t.g.canCaptureBackward&&(m=t.g.Coord[i][0],C=!1,(e.mWho==JocGame.PLAYER_A&&m>=l||e.mWho==JocGame.PLAYER_B&&m<=l)&&(C=!0)),t.g.canCaptureBackward||1==C){var b=t.g.Graph[i][c];if(null!=b&&(e.board[b]==-1||b==o[0])){for(var f=!0,d=0;d<n.length;d++)if(t.g.captureInstantRemove&&r[d]==i||0==t.g.captureInstantRemove&&r[d]==i&&n[d]==g){f=!1;break}f&&(h.push(b),p.push(i),u.push(g))}}}return!0}),0==h.length){o.length>1&&e.mMoves.push({pos:o,capt:r});break}if(!t.g.compulsoryCatch&&o.length>1){for(var c=[],l=0;l<o.length;l++)c.push(o[l]);for(var g=[],l=0;l<r.length;l++)g.push(r[l]);e.mMoves.push({pos:c,capt:g})}if(1!=h.length){for(var l=0;l<h.length;l++){for(var c=[],v=0;v<o.length;v++)c.push(o[v]);c.push(h[l]);for(var g=[],v=0;v<r.length;v++)g.push(r[v]);g.push(p[l]);for(var f=[],v=0;v<n.length;v++)f.push(n[v]);f.push(u[l]),i(h[l],c,g,f,a)}break}s=h[0],o.push(s),r.push(p[0]),n.push(u[0])}}var o=t.mOptions.height,e=this;if(this.mMoves=[],s(function(t,s){0==e.pieces[t].t?i(s,[s],[null],[null],!1):1==e.pieces[t].t&&i(s,[s],[null],[null],!0)}),0!=t.g.compulsoryCatch&&0!=this.mMoves.length||s(function(s,i){var r;0==e.pieces[s].t?((t.g.mustMoveForward||t.g.mustMoveForwardStrict||t.lastRowFreeze)&&(r=t.g.Coord[i][0]),t.CheckersEachDirection(i,function(n,a){var h,p,u;return t.g.mustMoveForwardStrict?(h=t.g.Coord[n][0],p=!1,(e.mWho==JocGame.PLAYER_A&&h>r||e.mWho==JocGame.PLAYER_B&&h<r)&&(p=!0)):t.g.mustMoveForward&&(h=t.g.Coord[n][0],p=!0,(e.mWho==JocGame.PLAYER_A&&h<r||e.mWho==JocGame.PLAYER_B&&h>r)&&(p=!1)),t.g.lastRowFreeze&&(u=!1,(e.mWho==JocGame.PLAYER_A&&r==o-1||e.mWho==JocGame.PLAYER_B&&0==r)&&(u=!0)),e.board[n]!=-1||!t.g.canStepBack&&n==e.pieces[s].l||(0!=t.g.mustMoveForward||0!=t.g.mustMoveForwardStrict)&&1!=p||0!=t.g.lastRowFreeze&&0!=u||e.mMoves.push({pos:[i,n],capt:[null,null]}),!0})):1==e.pieces[s].t&&t.CheckersEachDirection(i,function(s,o){if(t.g.longRangeKing)for(;e.board[s]==-1;)e.mMoves.push({pos:[i,s],capt:[null,null]}),s=t.g.Graph[s][o];else e.board[s]==-1&&(e.mMoves.push({pos:[i,s],capt:[null,null]}),s=t.g.Graph[s][o]);return!0})}),0==this.mMoves.length)switch(t.g.noMove){case"count":this.mFinished=!0,this.pCount[0]<this.pCount[1]?this.mWinner=JocGame.PLAYER_B:this.pCount[1]<this.pCount[0]?this.mWinner=JocGame.PLAYER_A:this.mWinner=JocGame.DRAW;break;case"lose":this.mFinished=!0,this.mWinner=-this.mWho;break;default:this.mFinished=!0,this.mWinner=JocGame.DRAW}if(t.g.captureLongestLine){for(var r=this.mMoves,n=[],a=0,h=0;h<r.length;h++){var p=r[h];p.pos.length==a?n.push(p):p.pos.length>a&&(n=[p],a=p.pos.length)}this.mMoves=n}},Model.Board.Evaluate=function(t,s,i){if(t.mOptions.preventRepeat&&t.GetRepeatOccurence(this)>2)return this.mFinished=!0,void(this.mWinner=JocGame.DRAW);if(t.g.drawKvsK&&0==this.spCount[0]&&0==this.spCount[1]&&1==this.kpCount[0]&&1==this.kpCount[1])return this.mFinished=!0,void(this.mWinner=JocGame.DRAW);if(t.g.drawKvs2K&&0==this.spCount[0]&&0==this.spCount[1]&&this.kpCount[0]+this.kpCount[1]==3&&(1==this.kpCount[0]||2==this.kpCount[0]))return this.mFinished=!0,void(this.mWinner=JocGame.DRAW);if(0==this.pCount[1])return this.mFinished=!0,void(this.mWinner=JocGame.PLAYER_A);if(0==this.pCount[0])return this.mFinished=!0,void(this.mWinner=JocGame.PLAYER_B);if(this.mEvaluation=10*(this.spCount[0]-this.spCount[1])+10*(this.kpCount[0]-this.kpCount[1])*t.g.kingValue+this.pCount[0]/this.pCount[1]-this.pCount[1]/this.pCount[0],0!=t.g.lastRowFactor){for(var o=t.mOptions.height,e=0,r=0,n=0;n<this.pieces.length;n++){var a=this.pieces[n];a&&0==a.t&&(this.mWho==JocGame.PLAYER_A?e+=t.g.Coord[a.p][0]:r+=o-1-t.g.Coord[a.p][0])}this.mEvaluation+=(e-r)*t.g.lastRowFactor}},Model.Board.CopyFrom=function(t){this.board=[];for(var s=0;s<t.board.length;s++)this.board[s]=t.board[s];this.pieces=[];for(var s=0;s<t.pieces.length;s++){var i=t.pieces[s];this.pieces[s]=null==i?null:{s:i.s,p:i.p,l:i.l,t:i.t,plp:i.plp}}this.pCount=[t.pCount[0],t.pCount[1]],this.spCount=[t.spCount[0],t.spCount[1]],this.kpCount=[t.kpCount[0],t.kpCount[1]],this.mWho=t.mWho,this.zSign=t.zSign},Model.Board.ApplyMove=function(t,s){var i=(t.mOptions.width,t.mOptions.height),o=s.pos[0],e=this.board[o],r=this.pieces[e],n=r.s;r.l=o;var a={};this.zSign=t.zobrist.update(this.zSign,"board",r.s+"/"+r.t,r.p);for(var h=1;h<s.pos.length;h++){var p=s.pos[h];this.board[r.p]=-1,r.p=p,this.board[p]=e;var u=s.capt[h];null!=u&&(this.board[u]>=0&&(a[this.board[u]]=!0),this.board[u]=-1),o=p}this.zSign=t.zobrist.update(this.zSign,"board",r.s+"/"+r.t,p);var c=s.capt[s.capt.length-1];r.plp=c||s.pos[s.pos.length-2];for(var l in a)if(a.hasOwnProperty(l)){var g=this.pieces[l],v=(1-g.s)/2;switch(this.pCount[v]--,g.t){case 0:this.spCount[v]--;break;case 1:this.kpCount[v]--}this.zSign=t.zobrist.update(this.zSign,"board",g.s+"/"+g.t,g.p),this.pieces[l]=null}if(t.g.lastRowCrown&&0==this.pieces[e].t){var f=t.g.Coord[s.pos[s.pos.length-1]][0];if(n==JocGame.PLAYER_A&&f==i-1||n==JocGame.PLAYER_B&&0==f){var g=this.pieces[e];g.t=1;var d=(1-n)/2;this.spCount[d]--,this.kpCount[d]++,this.zSign=t.zobrist.update(this.zSign,"board",g.s+"/0",g.p),this.zSign=t.zobrist.update(this.zSign,"board",g.s+"/1",g.p)}}},Model.Board.IsValidMove=function(t,s){return!0},Model.Board.GetSignature=function(){return this.zSign},Model.Game.Import=function(t,s){function i(t,s,i){i=r-i;var o=i%n;i=i-o+n-o-1,e.push({s:t,p:i,l:-1,t:s,plp:i})}var o=1,e=[],r=this.mOptions.width*this.mOptions.height,n=this.mOptions.width;if("pjn"==t){var a=s.split(":");o="W"==a[0]?1:-1;for(var h=1;h<a.length;h++)if(0!=a[h].length)for(var p="W"==a[h].substr(0,1)?1:-1,u=a[h].substr(1).split(","),c=0;c<u.length;c++){var l=u[c],g=0;"K"==l.substr(0,1)&&(g=1,l=l.substr(1));var v=/^([0-9]+)-([0-9]+)$/.exec(l);if(v)for(var f=parseInt(v[1]);f<=parseInt(v[2]);f++)i(p,g,f);else i(p,g,parseInt(l))}return e.sort(function(t,s){return s.s-t.s}),{status:!0,initial:{pieces:e,turn:o}}}return{status:!1,error:"unsupported"}};var e=JocGame.prototype.GetBestMatchingMove;Model.Game.GetBestMatchingMove=function(t,s){var i=[],o=this;s.forEach(function(t){"function"==typeof t.ToString?i.push(t.ToString()):i.push(o.CreateMove(t).ToString())}),t=t.replace(/0([1-9])/g,"$1");var r=/^([0-9]+)[\-x]([0-9]+)([\-x][0-9]+)*$/.exec(t);if(r){var n=new RegExp("^"+r[1]+"[-x]"+r[2]+"([-x][0-9]+)*$"),a={};s.forEach(function(t,s){if(n.test(i[s])){var o=i[s],e=/^([0-9]+)x([0-9]+)x([0-9]+(x[0-9]+)*)/.exec(o);if(e){var r=e[3].split("x");r.sort(function(t,s){return parseInt(t)-parseInt(s)}),o=e[1]+"x"+e[2]+"x"+r.join("x")}a[o]=t}});var h=[];for(var p in a)a.hasOwnProperty(p)&&h.push(a[p]);h.length>0&&(s=h)}return e.call(this,t,s)},Model.Board.ExportBoardState=function(o,e){function r(t){for(var o=[],e=0;e<n.board.length;e++){var r=e%s,a=(e-r)/s,h=(i-a-1)*s+r,p=n.board[e];if(p<0)o[h]="e";else{var u=n.pieces[p],c=1==u.s?"w":t;1==u.t&&(c=c.toUpperCase()),o[h]=c}}return o.join("")}e=e||"natural";var n=this;switch(e){case"natural":case"fen":return function(){var s={},i=[];n.pieces.forEach(function(i){if(i&&null!=i.p){var o=1==i.s?"W":"B";void 0===s[o]&&(s[o]={});var e=1==i.t?"K":"";void 0===s[o][e]&&(s[o][e]={group:0==i.t,pos:[]}),s[o][e].pos.push(parseInt(t(i.p)))}});for(var o in s)if(s.hasOwnProperty(o)){var e=[];for(var r in s[o])if(s[o].hasOwnProperty(r)){var a=s[o][r];if(a.group){a.pos.sort(function(t,s){return parseInt(t)-parseInt(s)});var h=-2,p=-1,u=-1;a.pos.forEach(function(t){parseInt(t)==h+1?p=t:(p>=0?(e.push(r+u+"-"+p),p=-1):u>=0&&e.push(r+u),u=t),h=parseInt(t)}),p>=0?e.push(r+u+"-"+p):u>=0&&e.push(r+u)}else a.pos.forEach(function(t){e.push(r+t)})}i.push(o+e.join(","))}return i.join(":")}();case"dxp":return function(){return r("z")}();case"hub":return function(){return r("z")}();default:return JSON.stringify(this)}}}(),Model.Game.BuildGraphCoord=function(){for(var t=this.mOptions.width,s=this.mOptions.height,i=[],o=[],e=0;e<s;e++)for(var r=0;r<t;r++){var n=e*t+r;o[n]=[e,r],i[n]=[],e%2==0?(e<s-1?(i[n].push((e+1)*t+r),r>0?i[n].push((e+1)*t+r-1):i[n].push(null)):(i[n].push(null),i[n].push(null)),e>0?(i[n].push((e-1)*t+r),r>0?i[n].push((e-1)*t+r-1):i[n].push(null)):(i[n].push(null),i[n].push(null))):(e<s-1?(r<t-1?i[n].push((e+1)*t+r+1):i[n].push(null),i[n].push((e+1)*t+r)):(i[n].push(null),i[n].push(null)),e>0?(r<t-1?i[n].push((e-1)*t+r+1):i[n].push(null),i[n].push((e-1)*t+r)):(i[n].push(null),i[n].push(null)))}this.g.Graph=i,this.g.Coord=o};

/***/ }),

/***/ "lU4I":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var concat_1 = __webpack_require__("8MUz");
exports.concat = concat_1.concatStatic;
//# sourceMappingURL=concat.js.map

/***/ }),

/***/ "lgiQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ArrayObservable_1 = __webpack_require__("Yh8Q");
exports.of = ArrayObservable_1.ArrayObservable.of;
//# sourceMappingURL=of.js.map

/***/ }),

/***/ "lh/Z":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var webSocket_1 = __webpack_require__("3eju");
Observable_1.Observable.webSocket = webSocket_1.webSocket;
//# sourceMappingURL=webSocket.js.map

/***/ }),

/***/ "mQmC":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var UsingObservable_1 = __webpack_require__("RSMh");
exports.using = UsingObservable_1.UsingObservable.create;
//# sourceMappingURL=using.js.map

/***/ }),

/***/ "mbVC":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var root_1 = __webpack_require__("VOfZ");
function getSymbolObservable(context) {
    var $$observable;
    var Symbol = context.Symbol;
    if (typeof Symbol === 'function') {
        if (Symbol.observable) {
            $$observable = Symbol.observable;
        }
        else {
            $$observable = Symbol('observable');
            Symbol.observable = $$observable;
        }
    }
    else {
        $$observable = '@@observable';
    }
    return $$observable;
}
exports.getSymbolObservable = getSymbolObservable;
exports.observable = getSymbolObservable(root_1.root);
/**
 * @deprecated use observable instead
 */
exports.$$observable = exports.observable;
//# sourceMappingURL=observable.js.map

/***/ }),

/***/ "mi67":
/***/ (function(module, exports) {

exports.model=Model={Game:{},Board:{},Move:{}},function(){var t;Model.Game.cbConstants={MASK:65535,FLAG_MOVE:65536,FLAG_CAPTURE:131072,FLAG_STOP:262144,FLAG_SCREEN_CAPTURE:524288,FLAG_CAPTURE_KING:1048576,FLAG_CAPTURE_NO_KING:2097152};var e="undefined"!=typeof Int32Array;Model.Game.cbUseTypedArrays=e,Model.Game.cbTypedArray=function(t){if(e){var r=new Int32Array(t.length);return r.set(t),r}for(var i=[],a=t.length,n=0;n<a;n++)i.push(t[n]);return i},Model.Game.cbShortRangeGraph=function(t,e,r,i){var a=this;void 0===i&&(i=196608);for(var n={},s=0;s<t.boardSize;s++)n[s]=[],(!r||s in r)&&e.forEach(function(e){var o=t.Graph(s,e);null!=o&&(!r||o in r)&&n[s].push(a.cbTypedArray([o|i]))});return n},Model.Game.cbLongRangeGraph=function(t,e,r,i,a){var n=this;void 0!==i&&null!=i||(i=196608),a||(a=1/0);for(var s={},o=0;o<t.boardSize;o++)s[o]=[],(!r||o in r)&&e.forEach(function(e){for(var h=[],c=t.Graph(o,e),p=0;null!=c&&(!r||c in r)&&(h.push(c|i),++p!=a);)c=t.Graph(c,e);h.length>0&&s[o].push(n.cbTypedArray(h))});return s},Model.Game.cbNullGraph=function(t){for(var e={},r=0;r<t.boardSize;r++)e[r]=[];return e},Model.Game.cbAuthorGraph=function(t){for(var e={},r=0;r<t.boardSize;r++){e[r]=[];for(var i=0;i<t.boardSize;i++)e[r].push([2293760|i])}return e},Model.Game.cbMergeGraphs=function(t){for(var e=[],r=0;r<t.boardSize;r++){e[r]=[];for(var i=1;i<arguments.length;i++)e[r]=e[r].concat(arguments[i][r])}return e},Model.Game.cbGetThreatGraph=function(){function t(e,r){for(var i in s){var a=s[i];if(!(a.p.length<r.length+1)){for(var n=!0,o=0;o<r.length;o++)if(r[o]!=a.p[o]){n=!1;break}if(n){var h=a.p[r.length],c=e[h];void 0===c&&(c={e:{}},e[h]=c),a.p.length==r.length+1&&(c.t=a.t,c.ts=a.ts,c.tk=a.tk,delete s[i]),r.push(h),t(c.e,r),r.pop()}}}}var e=this;this.cbUseScreenCapture=!1,this.cbUseCaptureKing=!1,this.cbUseCaptureNoKing=!1;for(var r={1:[],"-1":[]},i=[],a=0;a<this.g.boardSize;a++)this.g.pTypes.forEach(function(t,r){t.graph[a].forEach(function(t){for(var n=[],s=0;s<t.length;s++){var o=t[s];1048576&o?(e.cbUseCaptureKing=!0,n.unshift({d:65535&o,a:a,tk:r})):2097152&o?(e.cbUseCaptureNoKing=!0,n.unshift({d:65535&o,a:a,tnk:r})):131072&o?n.unshift({d:65535&o,a:a,t:r}):262144&o?n.unshift({d:65535&o,a:a}):524288&o&&(e.cbUseScreenCapture=!0,n.unshift({d:65535&o,a:a,ts:r}))}n.length>0&&i.push(n)})});var n={};i.forEach(function(t){t.forEach(function(e,r){var i=n[e.d];void 0===i&&(i={},n[e.d]=i);for(var a=[],s=r+1;s<t.length;s++)a.push(t[s].d);a.push(e.a);var o=a.join(","),h=i[o];void 0===h&&(h={p:a,t:{},ts:{},tk:{}},i[o]=h),void 0!==e.t?h.t[e.t]=!0:void 0!==e.tk?h.tk[e.tk]=!0:void 0!==e.ts&&(h.ts[e.ts]=!0)})});for(var a=0;a<e.g.boardSize;a++){var s=n[a],o={};t(o,[]),r[1][a]=o,r[-1][a]=o}return r},Model.Game.InitGame=function(){var e=this;this.cbVar=t=this.cbDefine(),this.g.boardSize=this.cbVar.geometry.boardSize,this.g.pTypes=this.cbGetPieceTypes(),this.g.threatGraph=this.cbGetThreatGraph(),this.g.distGraph=this.cbVar.geometry.GetDistances(),this.cbPiecesCount=0,this.g.castleablePiecesCount={1:0,"-1":0};for(var r in t.pieceTypes){var i=t.pieceTypes[r];if(i.castle){(i.initial||[]).forEach(function(t){e.g.castleablePiecesCount[t.s]++})}i.initial&&(this.cbPiecesCount+=i.initial.length)}for(var a=[],r=0;r<this.cbPiecesCount;r++)a.push(r);var n=Object.keys(t.pieceTypes);this.zobrist=new JocGame.Zobrist({board:{type:"array",size:this.cbVar.geometry.boardSize,values:a},who:{values:["1","-1"]},type:{type:"array",size:this.cbPiecesCount,values:n}})},Model.Game.cbGetPieceTypes=function(){for(var t=[],e={},r=0;r<this.cbVar.geometry.boardSize;r++)e[r]=[];for(var i in this.cbVar.pieceTypes){var a=this.cbVar.pieceTypes[i];t[i]={graph:a.graph||e,abbrev:a.abbrev||"",value:a.isKing?100:a.value||1,isKing:!!a.isKing,castle:!!a.castle,epTarget:!!a.epTarget,epCatch:!!a.epCatch}}return t},Model.Board.Init=function(t){this.zSign=0},Model.Board.InitialPosition=function(r){var i=this;this.board=e?new Int16Array(r.g.boardSize):[];for(var a=0;a<r.g.boardSize;a++)this.board[a]=-1;if(this.kings={},this.pieces=[],this.ending={1:!1,"-1":!1},this.lastMove=null,r.cbVar.castle&&(this.castled={1:!1,"-1":!1}),this.zSign=r.zobrist.update(0,"who",-1),this.noCaptCount=0,this.mWho=1,r.mInitial)this.mWho=r.mInitial.turn||1,r.mInitial.pieces.forEach(function(t){var e={};for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);i.pieces.push(e)}),r.mInitial.lastMove&&(this.lastMove={f:r.mInitial.lastMove.f,t:r.mInitial.lastMove.t}),void 0!==r.mInitial.noCaptCount&&(this.noCaptCount=r.mInitial.noCaptCount),r.cbVar.castle&&r.mInitial.castle&&(this.castled={1:{k:!!r.mInitial.castle[1]&&!!r.mInitial.castle[1].k,q:!!r.mInitial.castle[1]&&!!r.mInitial.castle[1].q},"-1":{k:!!r.mInitial.castle[-1]&&!!r.mInitial.castle[-1].k,q:!!r.mInitial.castle[-1]&&!!r.mInitial.castle[-1].q}});else for(var n in r.cbVar.pieceTypes)for(var s=r.cbVar.pieceTypes[n],o=s.initial||[],h=0;h<o.length;h++){var c=o[h],p={s:c.s,t:parseInt(n),p:c.p,m:!1};this.pieces.push(p)}if(this.pieces.sort(function(t,e){if(t.s!=e.s)return e.s-t.s;var i=r.cbVar.pieceTypes[t.t].value||100,a=r.cbVar.pieceTypes[e.t].value||100;return i!=a?i-a:t.p-e.p}),this.pieces.forEach(function(t,e){t.i=e,i.board[t.p]=e,r.g.pTypes[t.t].isKing&&(i.kings[t.s]=t.p),i.zSign=r.zobrist.update(i.zSign,"board",e,t.p),i.zSign=r.zobrist.update(i.zSign,"type",t.t,e)}),r.mInitial&&r.mInitial.enPassant){var a=t.geometry.PosByName(r.mInitial.enPassant);if(a>=0){var l,u=t.geometry.C(a),v=t.geometry.R(a);l=1==r.mInitial.turn?t.geometry.POS(u,v-1):t.geometry.POS(u,v+1),this.epTarget={p:a,i:this.board[l]}}}},Model.Board.CopyFrom=function(t){if(e)this.board=new Int16Array(t.board.length),this.board.set(t.board);else{this.board=[];for(var r=t.board,i=r.length,a=0;a<i;a++)this.board.push(r[a])}this.pieces=[];for(var n=t.pieces.length,a=0;a<n;a++){var s=t.pieces[a];this.pieces.push({s:s.s,p:s.p,t:s.t,i:s.i,m:s.m})}this.kings={1:t.kings[1],"-1":t.kings[-1]},this.check=t.check,t.lastMove?this.lastMove={f:t.lastMove.f,t:t.lastMove.t,c:t.lastMove.c}:this.lastMove=null,this.ending={1:t.ending[1],"-1":t.ending[-1]},void 0!==t.castled&&(this.castled={1:t.castled[1],"-1":t.castled[-1]}),this.noCaptCount=t.noCaptCount,t.epTarget?this.epTarget={p:t.epTarget.p,i:t.epTarget.i}:this.epTarget=null,this.mWho=t.mWho,this.zSign=t.zSign},Model.Board.cbApplyCastle=function(t,e,r){var i=t.cbVar.castle[e.f+"/"+e.cg],a=i.r[i.r.length-1],n=this.pieces[this.board[e.cg]],s=i.k[i.k.length-1],o=this.pieces[this.board[e.f]];return r&&(this.zSign=t.zobrist.update(this.zSign,"board",n.i,e.cg),this.zSign=t.zobrist.update(this.zSign,"board",n.i,a),this.zSign=t.zobrist.update(this.zSign,"board",o.i,e.f),this.zSign=t.zobrist.update(this.zSign,"board",o.i,s)),n.p=a,n.m=!0,this.board[e.cg]=-1,o.p=s,o.m=!0,this.board[e.f]=-1,this.board[a]=n.i,this.board[s]=o.i,this.castled[n.s]=!0,this.kings[o.s]=s,[{i:n.i,f:a,t:-1},{i:o.i,f:s,t:e.f,kp:e.f,who:o.s,m:!1},{i:n.i,f:-1,t:e.cg,m:!1,cg:!1}]},Model.Board.cbQuickApply=function(t,e){if(void 0!==e.cg)return this.cbApplyCastle(t,e,!1);var r=[],i=this.board[e.f],a=this.pieces[i];if(null!=e.c){r.unshift({i:e.c,f:-1,t:this.pieces[e.c].p});var n=this.pieces[e.c];this.board[n.p]=-1,n.p=-1}var s=this.kings[a.s];return t.g.pTypes[a.t].isKing&&(this.kings[a.s]=e.t),r.unshift({i:i,f:e.t,t:e.f,kp:s,who:a.s,ty:a.t}),a.p=e.t,void 0!==e.pr&&(a.t=e.pr),this.board[e.f]=-1,this.board[e.t]=i,r},Model.Board.cbQuickUnapply=function(t,e){for(var r=0;r<e.length;r++){var i=e[r],a=this.pieces[i.i];i.f>=0&&(a.p=-1,this.board[i.f]=-1),i.t>=0&&(a.p=i.t,this.board[i.t]=i.i),void 0!==i.m&&(a.m=i.m),void 0!==i.kp&&(this.kings[i.who]=i.kp),void 0!=i.ty&&(a.t=i.ty),void 0!=i.cg&&(this.castled[a.s]=i.cg)}},Model.Board.ApplyMove=function(t,e){var r=this.pieces[this.board[e.f]];if(void 0!==e.cg)this.cbApplyCastle(t,e,!0);else{if(this.zSign=t.zobrist.update(this.zSign,"board",r.i,e.f),this.board[r.p]=-1,void 0!==e.pr&&(this.zSign=t.zobrist.update(this.zSign,"type",r.t,r.i),r.t=e.pr,this.zSign=t.zobrist.update(this.zSign,"type",r.t,r.i)),null!=e.c){var i=this.pieces[e.c];this.zSign=t.zobrist.update(this.zSign,"board",i.i,i.p),this.board[i.p]=-1,i.p=-1,i.m=!0,this.noCaptCount=0}else this.noCaptCount++;r.p=e.t,r.m=!0,this.board[e.t]=r.i,this.zSign=t.zobrist.update(this.zSign,"board",r.i,e.t),t.g.pTypes[r.t].isKing&&(this.kings[r.s]=e.t)}this.check=!!e.ck,this.lastMove={f:e.f,t:e.t,c:e.c},void 0!==e.ko&&(this.ending[r.s]=e.ko),void 0!==e.ept?this.epTarget={p:e.ept,i:r.i}:this.epTarget=null,this.zSign=t.zobrist.update(this.zSign,"who",-this.mWho),this.zSign=t.zobrist.update(this.zSign,"who",this.mWho)},Model.Board.Evaluate=function(r){function i(e){var r=1/0;for(var i in t.geometry.corners)r=Math.min(r,h.distGraph[n.kings[e]][i]);return r-Math.sqrt(h.boardSize)}var a="debug"==arguments[3],n=this;this.mEvaluation=0;var s,o=this.mWho,h=r.g;if(e)s={1:{count:new Uint8Array(h.pTypes.length),byType:{}},"-1":{count:new Uint8Array(h.pTypes.length),byType:{}}};else{s={1:{count:[],byType:{}},"-1":{count:[],byType:{}}};for(var c=0;c<h.pTypes.length;c++)s[1].count[c]=s[-1].count[c]=0}if(r.mOptions.preventRepeat&&r.GetRepeatOccurence(this)>2)return this.mFinished=!0,void(this.mWinner=r.cbOnPerpetual?o*r.cbOnPerpetual:JocGame.DRAW);for(var p={1:0,"-1":0},l={1:h.distGraph[this.kings[-1]],"-1":h.distGraph[this.kings[1]]},u={1:0,"-1":0},v={1:0,"-1":0},b={1:0,"-1":0},f={1:0,"-1":0},d={1:!1,"-1":!1},g=this.pieces,m=g.length,c=0;c<m;c++){var G=g[c];if(G.p>=0){var y=G.s,M=h.pTypes[G.t];M.isKing?d[y]=G.m:p[y]+=M.value,M.castle&&!G.m&&f[y]++,v[y]++,u[y]+=l[y][G.p],b[y]+=t.geometry.distEdge[G.p];var C=s[y];C.count[G.t]++;var S=C.byType;void 0===S[G.t]?S[G.t]=[G]:S[G.t].push(G)}}if(this.lastMove&&null!=this.lastMove.c){var G=this.pieces[this.board[this.lastMove.t]];p[-G.s]+=this.cbStaticExchangeEval(r,G.p,G.s,{piece:G})}var k={1:0,"-1":0},A={1:0,"-1":0},T={1:0,"-1":0};this.ending[1]&&(A[1]=(u[1]-Math.sqrt(h.boardSize))/v[1],t.geometry.corners&&(T[1]=i(1))),this.ending[-1]&&(A[-1]=(u[-1]-Math.sqrt(h.boardSize))/v[-1],t.geometry.corners&&(T[1]=i(-1)));var z={pieceValue:p[1]-p[-1],pieceValueRatio:(p[1]-p[-1])/(p[1]+p[-1]+1),posValue:b[1]-b[-1],averageDistKing:u[1]/v[1]-u[-1]/v[-1],check:this.check?-o:0,endingKingFreedom:k[1]-k[-1],endingDistKing:A[1]-A[-1],distKingCorner:T[1]-T[-1]};t.castle&&(z.castle=(this.castled[1]?1:d[1]?0:f[1]/(h.castleablePiecesCount[1]+1))-(this.castled[-1]?1:d[-1]?0:f[-1]/(h.castleablePiecesCount[-1]+1))),t.evaluate&&t.evaluate.call(this,r,z,s);var P=r.mOptions.levelOptions;for(var E in z){var w=z[E],R=P[E+"Factor"]||0,I=w*R;a&&console.log(E,"=",w,"*",R,"=>",I),this.mEvaluation+=I}a&&console.log("Evaluation",this.mEvaluation)},Model.Board.cbGeneratePseudoLegalMoves=function(t){function e(e,a){var n=t.cbVar.promote;if(!n)return void i.push(a);var s=n.call(r,t,e,a);if(null!=s)if(0==s.length)i.push(a);else if(1==s.length)a.pr=s[0],i.push(a);else for(var o=0;o<s.length;o++){var h=s[o];i.push({f:a.f,t:a.t,c:a.c,pr:h,ept:a.ept,ep:a.ep,a:a.a})}}for(var r=this,i=[],a=t.cbVar,n=this.mWho,s=!a.castle||this.check||this.castled[n]?null:[],o=-1,h=this.pieces.length,c=0;c<h;c++){var p=this.pieces[c];if(!(p.p<0||p.s!=n)){var l=t.g.pTypes[p.t];l.isKing&&(p.m?s=null:o=p),s&&l.castle&&!p.m&&s.push(p);var u,v;u=l.graph[p.p],v=u.length;for(var b=0;b<v;b++)for(var f=u[b],d=!1,g=f.length,m=null,G=0;G<g;G++){var y=f[G],M=65535&y,C=this.board[M];if(!(C<0)||l.epCatch&&this.epTarget&&this.epTarget.p==M){if(!(524288&y)){var S;S=C<0?this.pieces[this.epTarget.i]:this.pieces[C],!(S.s!=p.s&&131072&y)||1048576&y&&!t.g.pTypes[S.t].isKing||2097152&y&&t.g.pTypes[S.t].isKing||e(p,{f:p.p,t:M,c:S.i,a:l.abbrev,ep:C<0});break}if(d){var S=this.pieces[C];S.s!=p.s&&e(p,{f:p.p,t:M,c:S.i,a:l.abbrev});break}d=!0}else 65536&y&&0==d&&e(p,{f:p.p,t:M,c:null,a:l.abbrev,ept:null!=m&&l.epTarget?m:void 0});m=M}}}if(s)for(var c=0;c<s.length;c++){var k=s[c],A=t.cbVar.castle[o.p+"/"+k.p];if(A){for(var T=!0,b=0;b<A.r.length;b++){var z=A.r[b];if(this.board[z]>=0&&z!=o.p&&z!=k.p){T=!1;break}}if(T){for(var P=!0,b=0;b<A.k.length;b++){var z=A.k[b];if(this.board[z]>=0&&z!=k.p&&z!=o.p||this.cbGetAttackers(t,z,n).length>0){P=!1;break}}P&&i.push({f:o.p,t:A.k[A.k.length-1],c:null,cg:k.p})}}}return i},Model.Board.cbStaticExchangeEval=function(t,e,r,i){var a=0,n=this.cbGetSmallestAttacker(t,e,r);if(n){var s=this.mWho;this.mWho=n.s;var o=this.cbQuickApply(t,{f:n.p,t:e,c:i.piece.i}),h=t.g.pTypes[i.piece.t].value;i.piece=n,a=Math.max(0,h-this.cbStaticExchangeEval(t,e,-r,i)),this.cbQuickUnapply(t,o),this.mWho=s}return a},Model.Board.cbGetSmallestAttacker=function(t,e,r){var i=this.cbGetAttackers(t,e,r);if(0==i.length)return null;for(var a=1/0,n=null,s=i.length,o=0;o<s;o++){var h=i[o],c=t.g.pTypes[h.t].value;c<a&&(a=c,n=h)}return n},Model.Board.cbCollectAttackers=function(t,e,r,i){for(var a in e){var n=e[a],s=this.board[a];if(s<0)this.cbCollectAttackers(t,n.e,r,i);else{var o=this.pieces[s];o.s==-t&&(n.t&&o.t in n.t||i&&n.tk&&o.t in n.tk)&&r.push(o)}}},Model.Board.cbCollectAttackersScreen=function(t,e,r,i,a){for(var n in e){var s=e[n],o=this.board[n];if(o<0)this.cbCollectAttackersScreen(t,s.e,r,i,a);else{var h=this.pieces[o];!a&&h.s==-t&&(s.t&&h.t in s.t||i&&s.tk&&h.t in s.tk)?r.push(h):a?a&&h.s==-t&&s.ts&&h.t in s.ts&&r.push(h):this.cbCollectAttackersScreen(t,s.e,r,i,!0)}}},Model.Board.cbGetAttackers=function(t,e,r,i){var a=[];return t.cbUseScreenCapture?this.cbCollectAttackersScreen(r,t.g.threatGraph[r][e],a,i,!1):this.cbCollectAttackers(r,t.g.threatGraph[r][e],a,i),a},Model.Board.GenerateMoves=function(t){var e=this.cbGeneratePseudoLegalMoves(t);this.mMoves=[];for(var r=!0,i=this.kings[this.mWho],a=e.length,n=0;n<a;n++){var s=e[n],o=this.cbQuickApply(t,s);if(!(this.cbGetAttackers(t,this.kings[this.mWho],this.mWho,!0).length>0)){var h=this.cbGetAttackers(t,this.kings[-this.mWho],-this.mWho,!0).length>0;s.ck=h,this.mMoves.push(s),s.f!=i&&(r=!1)}this.cbQuickUnapply(t,o)}if(0==this.mMoves.length)this.mFinished=!0,this.mWinner=t.cbOnStaleMate?t.cbOnStaleMate*this.mWho:JocGame.DRAW,this.check&&(this.mWinner=-this.mWho);else if(this.ending[this.mWho]){if(!r)for(var n=0;n<this.mMoves.length;n++)this.mMoves[n].ko=!1}else if(!this.ending[this.mWho]&&r&&!this.check)for(var n=0;n<this.mMoves.length;n++)this.mMoves[n].ko=!0},Model.Board.GetSignature=function(){return this.zSign},Model.Move.Init=function(t){for(var e in t)t.hasOwnProperty(e)&&(this[e]=t[e])},Model.Move.Equals=function(t){return this.f==t.f&&this.t==t.t&&this.pr==t.pr},Model.Move.CopyFrom=function(t){this.Init(t)},Model.Move.ToString=function(e){var r=this;switch(e=e||"natural"){case"natural":return function(){var e;if(void 0!==r.cg?e=t.castle[r.f+"/"+r.cg].n:(e=r.a||"",e+=t.geometry.PosName(r.f),null==r.c?e+="-":e+="x",e+=t.geometry.PosName(r.t)),void 0!==r.pr){var i=t.pieceTypes[r.pr];i&&i.abbrev&&i.abbrev.length>0&&!i.silentPromo&&(e+="="+i.abbrev)}return r.ck&&(e+="+"),e}();case"engine":return function(){var e=t.geometry.PosName(r.f)+t.geometry.PosName(r.t);if(void 0!=r.pr){var i=t.pieceTypes[r.pr];i&&i.abbrev&&i.abbrev.length>0&&!i.silentPromo&&(e+=i.abbrev)}return e}();default:return"??"}},Model.Board.CompactMoveString=function(e,r,i){"function"!=typeof r.ToString&&(r=e.CreateMove(r));var a=r.ToString(),n=/^([A-Z]?)([a-z])([1-9][0-9]*)([-x])([a-z])([1-9][0-9]*)(.*?)$/.exec(a);if(!n)return a;var s=n[7];if(i||(i={}),i.value||(i.value=[]),0==i.value.length){var o=this.mMoves;this.mMoves&&0!=this.mMoves.length||this.GenerateMoves(e);for(var h=0;h<this.mMoves.length;h++){var c=this.mMoves[h];"function"!=typeof c.ToString&&(c=e.CreateMove(c)),i.value.push({str:c.ToString(),move:c})}this.mMoves=o}var p=[];if(i.value.forEach(function(t){var e=/^([A-Z]?[a-z][1-9][0-9]*[-x][a-z][1-9][0-9]*)(.*?)$/.exec(t.str);e&&t.move.t==r.t&&(t.move.a||"")==n[1]&&e[2]==s&&p.push(t.move)}),1==p.length)return""==n[1]&&"x"==n[4]?n[2]+"x"+n[5]+n[6]+n[7]:n[1]+("x"==n[4]?"x":"")+n[5]+n[6]+n[7];if(t.geometry.CompactCrit)for(var l="",h=0;;h++){var u=t.geometry.CompactCrit(r.f,h);if(null==u)return a;l+=u;for(var v=[],b=0;b<p.length;b++){var f=p[b];t.geometry.CompactCrit(f.f,h)==u&&v.push(f)}if(console.assert(v.length>0),1==v.length)return n[1]+l+("x"==n[4]?"x":"")+n[5]+n[6]+n[7];p=v}return a},Model.Board.cbIntegrity=function(t){function e(t,e){t||console.error(e)}for(var r=this,i=0;i<this.board.length;i++){var a=this.board[i];if(a>=0){var n=r.pieces[a];e(void 0!==n,"no piece at pos"),e(n.p==i,"piece has different pos")}}for(var a=0;a<this.pieces.length;a++){var n=this.pieces[a];n.p>=0&&e(r.board[n.p]==a,"board index mismatch")}},Model.Board.ExportBoardState=function(t){return t.cbVar.geometry.ExportBoardState?t.cbVar.geometry.ExportBoardState(this,t.cbVar,t.mPlayedMoves.length):"not supported"},Model.Game.Import=function(e,r){var i,a=[],n={1:{},"-1":{}},s=null,o=0;if("pjn"==e){var h={status:!1,error:"parse"},c=r.split(" ");if(6!=c.length)return console.warn("FEN should have 6 parts"),h;var p=c[0].split("/"),l=t.geometry.fenHeight||t.geometry.height;if(p.length!=l)return console.warn("FEN board should have",l,"rows, got",p.length),h;var u={};for(var v in t.pieceTypes){var b=t.pieceTypes[v],f=b.fenAbbrev||b.abbrev||"X";u[f.toUpperCase()]={s:1,t:v},u[f.toLowerCase()]={s:-1,t:v}}var d=t.geometry.FenRowPos||function(e,r){return(t.geometry.height-1-e)*t.geometry.width+r};if(p.forEach(function(e,r){for(var i=0,n=0;n<e.length;n++){var s=e.substr(n,1),o=u[s];if(void 0!==o){var c=d(r,i);i++;for(var p={s:o.s,t:o.t,p:c},l=!0,v=t.pieceTypes[p.t].initial||[],b=0;b<v.length;b++){var f=v[b];f.s==p.s&&f.p==c&&(l=!1)}p.m=l,a.push(p)}else{if(isNaN(parseInt(s)))return console.warn("FEN invalid board spec",s),h;i+=parseInt(s)}}}),a.sort(function(t,e){return e.s-t.s}),"w"==c[1])i=1;else{if("b"!=c[1])return console.warn("FEN invalid turn spec",c[1]),h;i=-1}n[1].k=c[2].indexOf("K")>=0,n[1].q=c[2].indexOf("Q")>=0,n[-1].k=c[2].indexOf("k")>=0,n[-1].q=c[2].indexOf("q")>=0,s="-"==c[3]?null:c[3];var g=parseInt(c[4]);isNaN(g)||(o=g);var m={pieces:a,turn:i,castle:n,enPassant:s,noCaptCount:o};return t.importGame&&t.importGame.call(this,m,e,r),{status:!0,initial:m}}return{status:!1,error:"unsupported"}}}(),function(){Model.Game.cbBoardGeometryGrid=function(t,e){function r(e){return e%t}function i(e){return Math.floor(e/t)}function a(e,r){return r*t+e}function n(n,s){var o=r(n),h=i(n),c=o+s[0],p=h+s[1];return c<0||c>=t||p<0||p>=e?null:a(c,p)}function s(t){return String.fromCharCode("a".charCodeAt(0)+r(t))+(i(t)+1)}function o(t){var e=/^([a-z])([0-9]+)$/.exec(t);return e?a(e[1].charCodeAt(0)-"a".charCodeAt(0),parseInt(e[2])-1):-1}function h(t,e){return 0==e?String.fromCharCode("a".charCodeAt(0)+r(t)):1==e?i(t)+1:null}function c(){for(var a=[],n=0;n<t*e;n++){var s=[];a.push(s);for(var o=0;o<t*e;o++){var h=i(n),c=r(n),p=i(o),l=r(o);s.push(Math.max(Math.abs(h-p),Math.abs(c-l)))}}return a}function p(r,i,n){for(var o=[],h=e-1;h>=0;h--){for(var c="",p=0,l=0;l<t;l++){var u=r.board[a(l,h)];if(u<0)p++;else{p>0&&(c+=p,p=0);var v=r.pieces[u],b=i.pieceTypes[v.t].fenAbbrev||i.pieceTypes[v.t].abbrev||"?";v.s==-1?c+=b.toLowerCase():c+=b.toUpperCase()}}p&&(c+=p),o.push(c)}var f=o.join("/");f+=" ",1==r.mWho?f+="w":f+="b",f+=" ";var d="";return r.castled&&(r.castled[1]===!1?d+="KQ":(r.castled[1].k&&(d+="K"),r.castled[1].q&&(d+="Q")),r.castled[-1]===!1?d+="kq":(r.castled[-1].k&&(d+="k"),r.castled[-1].q&&(d+="q"))),0==d.length&&(d="-"),f+=d,f+=" ",r.epTarget?f+=s(r.epTarget.p):f+="-",f+=" ",f+=r.noCaptCount,f+=" ",f+=Math.floor(n/2)+1}return{boardSize:t*e,width:t,height:e,C:r,R:i,POS:a,Graph:n,PosName:s,PosByName:o,CompactCrit:h,GetDistances:c,distEdge:function(){for(var a=[],n=0;n<t*e;n++){var s=r(n),o=i(n);a[n]=Math.min(s,Math.abs(t-s-1),o,Math.abs(e-o-1))}return a}(),corners:function(){var r={};return r[a(0,0)]=1,r[a(0,e-1)]=1,r[a(t-1,0)]=1,r[a(t-1,e-1)]=1,r}(),ExportBoardState:p}},Model.Game.cbPawnGraph=function(t,e,r){for(var i=this,a={},n=0;n<t.boardSize;n++)if(!r||n in r){var s=[],o=t.Graph(n,[0,e]);null!=o&&(!r||o in r)&&s.push(i.cbTypedArray([o|i.cbConstants.FLAG_MOVE])),[-1,1].forEach(function(a){var o=t.Graph(n,[a,e]);null!=o&&(!r||o in r)&&s.push(i.cbTypedArray([o|i.cbConstants.FLAG_CAPTURE]))}),a[n]=s}else a[n]=[];return a},Model.Game.cbInitialPawnGraph=function(t,e,r){for(var i=this,a={},n=0;n<t.boardSize;n++)if(!r||n in r){var s=[],o=t.Graph(n,[0,e]);if(null!=o&&(!r||o in r)){var h=[o|i.cbConstants.FLAG_MOVE],c=t.Graph(o,[0,e]);null!=c&&(!r||c in r)&&h.push(c|i.cbConstants.FLAG_MOVE),s.push(i.cbTypedArray(h))}[-1,1].forEach(function(a){var o=t.Graph(n,[a,e]);null!=o&&(!r||o in r)&&s.push(i.cbTypedArray([o|i.cbConstants.FLAG_CAPTURE]))}),a[n]=s}else a[n]=[];return a},Model.Game.cbKingGraph=function(t,e){return this.cbShortRangeGraph(t,[[-1,-1],[-1,0],[-1,1],[0,-1],[0,1],[1,-1],[1,0],[1,1]],e)},Model.Game.cbKnightGraph=function(t,e){return this.cbShortRangeGraph(t,[[2,-1],[2,1],[-2,-1],[-2,1],[-1,2],[-1,-2],[1,2],[1,-2]],e)},Model.Game.cbHorseGraph=function(t){for(var e=this,r={},i=0;i<t.boardSize;i++)r[i]=[],[[1,0,2,-1],[1,0,2,1],[-1,0,-2,-1],[-1,0,-2,1],[0,1,-1,2],[0,-1,-1,-2],[0,1,1,2],[0,-1,1,-2]].forEach(function(a){var n=t.Graph(i,[a[0],a[1]]);if(null!=n){var s=t.Graph(i,[a[2],a[3]]);null!=s&&r[i].push(e.cbTypedArray([n|e.cbConstants.FLAG_STOP,s|e.cbConstants.FLAG_MOVE|e.cbConstants.FLAG_CAPTURE]))}});return r},Model.Game.cbRookGraph=function(t,e){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0]],e)},Model.Game.cbBishopGraph=function(t,e){return this.cbLongRangeGraph(t,[[1,-1],[1,1],[-1,1],[-1,-1]],e)},Model.Game.cbQueenGraph=function(t,e){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0],[1,-1],[1,1],[-1,1],[-1,-1]],e)},Model.Game.cbXQGeneralGraph=function(t,e){for(var r=this,i={},a=0;a<t.boardSize;a++)i[a]=[],[[-1,0,!1],[0,-1,!0],[0,1,!0],[1,0,!1]].forEach(function(n){var s=[],o=t.Graph(a,n);if(null!=o&&((!e||o in e)&&s.push(o|r.cbConstants.FLAG_MOVE|r.cbConstants.FLAG_CAPTURE),n[2]))for(var h=t.Graph(o,n);null!=h;)!e||h in e?s.push(h|r.cbConstants.FLAG_CAPTURE|r.cbConstants.FLAG_CAPTURE_KING):s.push(h|r.cbConstants.FLAG_STOP),h=t.Graph(h,n);s.length>0&&i[a].push(r.cbTypedArray(s))});return i},Model.Game.cbXQSoldierGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e]])},Model.Game.cbXQPromoSoldierGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e],[-1,0],[1,0]])},Model.Game.cbXQAdvisorGraph=function(t,e){return this.cbShortRangeGraph(t,[[1,1],[-1,1],[1,-1],[-1,-1]],e)},Model.Game.cbXQCannonGraph=function(t){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0]],null,this.cbConstants.FLAG_MOVE|this.cbConstants.FLAG_SCREEN_CAPTURE)},Model.Game.cbXQElephantGraph=function(t,e){for(var r=this,i={},a=0;a<t.boardSize;a++)i[a]=[],(!e||a in e)&&[[1,1,2,2],[1,-1,2,-2],[-1,1,-2,2],[-1,-1,-2,-2]].forEach(function(n){var s=t.Graph(a,[n[0],n[1]]);if(null!=s){var o=t.Graph(a,[n[2],n[3]]);null!=o&&(!e||o in e)&&i[a].push(r.cbTypedArray([s|r.cbConstants.FLAG_STOP,o|r.cbConstants.FLAG_MOVE|r.cbConstants.FLAG_CAPTURE]))}});return i},Model.Game.cbSilverGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e],[-1,-1],[-1,1],[1,-1],[1,1]])},Model.Game.cbFersGraph=function(t,e){return this.cbShortRangeGraph(t,[[-1,-1],[-1,1],[1,-1],[1,1]])},Model.Game.cbSchleichGraph=function(t,e){return this.cbShortRangeGraph(t,[[-1,0],[1,0],[0,-1],[0,1]])},Model.Game.cbAlfilGraph=function(t,e){return this.cbShortRangeGraph(t,[[-2,-2],[-2,2],[2,2],[2,-2]])}}(),function(){var t=Model.Game.cbBoardGeometryGrid(5,5);Model.Game.cbDefine=function(){return{geometry:t,pieceTypes:{0:{name:"pawn-w",aspect:"pawn",graph:this.cbPawnGraph(t,1),value:1,abbrev:"",fenAbbrev:"P",epCatch:!0},1:{name:"ipawn-w",aspect:"pawn",graph:this.cbInitialPawnGraph(t,1),value:1,abbrev:"",fenAbbrev:"P",initial:[{s:1,p:5},{s:1,p:6},{s:1,p:7},{s:1,p:8},{s:1,p:9}],epCatch:!0,epTarget:!0},2:{name:"pawn-b",aspect:"pawn",graph:this.cbPawnGraph(t,-1),value:1,abbrev:"",fenAbbrev:"P",epCatch:!0},3:{name:"ipawn-b",aspect:"pawn",graph:this.cbInitialPawnGraph(t,-1),value:1,abbrev:"",fenAbbrev:"P",initial:[{s:-1,p:15},{s:-1,p:16},{s:-1,p:17},{s:-1,p:18},{s:-1,p:19}],epCatch:!0,epTarget:!0},4:{name:"knight",graph:this.cbKnightGraph(t),value:2.9,abbrev:"N",initial:[{s:1,p:1},{s:-1,p:21}]},5:{name:"bishop",graph:this.cbBishopGraph(t),value:3.1,abbrev:"B",initial:[{s:1,p:2},{s:-1,p:22}]},6:{name:"rook",graph:this.cbRookGraph(t),value:5,abbrev:"R",initial:[{s:1,p:0},{s:-1,p:20}],castle:!0},7:{name:"queen",graph:this.cbQueenGraph(t),value:9,abbrev:"Q",initial:[{s:1,p:3},{s:-1,p:23}]},8:{name:"king",isKing:!0,graph:this.cbKingGraph(t),abbrev:"K",initial:[{s:1,p:4},{s:-1,p:24}]}},promote:function(e,r,i){return 1==r.t?[0]:3==r.t?[2]:0==r.t&&4==t.R(i.t)?[4,5,6,7]:2==r.t&&0==t.R(i.t)?[4,5,6,7]:[]},castle:{"4/0":{k:[3,2],r:[1,2,3],n:"O-O"},"24/20":{k:[23,22],r:[21,22,23],n:"O-O"}},evaluate:function(e,r,i){var a=i[1].count,n=i[-1].count;a[0]||a[1]||a[4]||a[5]||a[6]||a[7]||n[2]||n[3]||n[6]||n[7]||!(n[4]+n[5]<2||n[5]<2)||(this.mFinished=!0,this.mWinner=JocGame.DRAW),n[2]||n[3]||n[4]||n[5]||n[6]||n[7]||a[0]||a[1]||a[6]||a[7]||!(a[4]+a[5]<2||a[5]<2)||(this.mFinished=!0,this.mWinner=JocGame.DRAW),this.noCaptCount>=100&&(this.mFinished=!0,this.mWinner=JocGame.DRAW);var s,o=e.cbUseTypedArrays?new Int8Array(3):[0,0,0],h=t.height,c=i[1].byType[0];if(c){s=c.length;for(var p=0;p<s;p++)switch(h-t.R(c[p].p)){case 2:o[0]++;break;case 3:o[1]++;break;case 4:o[2]++}}if(c=i[-1].byType[2]){s=c.length;for(var p=0;p<s;p++)switch(t.R(c[p].p)){case 1:o[0]--;break;case 2:o[1]--;break;case 3:o[2]--}}0!=o[0]&&(r.distPawnPromo1=o[0]),0!=o[1]&&(r.distPawnPromo2=o[1]),0!=o[2]&&(r.distPawnPromo3=o[2]);for(var l=0,u=4;u<=5;u++)for(var v=1;v>=-1;v-=2){var b=i[v].byType[u];if(b)for(var p=0;p<b.length;p++)b[p].m&&(l+=v)}0!=l&&(r.minorPiecesMoved=l)}}}}();

/***/ }),

/***/ "mmVS":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var isFunction_1 = __webpack_require__("SKH6");
var Subscription_1 = __webpack_require__("B00U");
var Observer_1 = __webpack_require__("yrou");
var rxSubscriber_1 = __webpack_require__("r8ZY");
/**
 * Implements the {@link Observer} interface and extends the
 * {@link Subscription} class. While the {@link Observer} is the public API for
 * consuming the values of an {@link Observable}, all Observers get converted to
 * a Subscriber, in order to provide Subscription-like capabilities such as
 * `unsubscribe`. Subscriber is a common type in RxJS, and crucial for
 * implementing operators, but it is rarely used as a public API.
 *
 * @class Subscriber<T>
 */
var Subscriber = (function (_super) {
    __extends(Subscriber, _super);
    /**
     * @param {Observer|function(value: T): void} [destinationOrNext] A partially
     * defined Observer or a `next` callback function.
     * @param {function(e: ?any): void} [error] The `error` callback of an
     * Observer.
     * @param {function(): void} [complete] The `complete` callback of an
     * Observer.
     */
    function Subscriber(destinationOrNext, error, complete) {
        _super.call(this);
        this.syncErrorValue = null;
        this.syncErrorThrown = false;
        this.syncErrorThrowable = false;
        this.isStopped = false;
        switch (arguments.length) {
            case 0:
                this.destination = Observer_1.empty;
                break;
            case 1:
                if (!destinationOrNext) {
                    this.destination = Observer_1.empty;
                    break;
                }
                if (typeof destinationOrNext === 'object') {
                    if (destinationOrNext instanceof Subscriber) {
                        this.destination = destinationOrNext;
                        this.destination.add(this);
                    }
                    else {
                        this.syncErrorThrowable = true;
                        this.destination = new SafeSubscriber(this, destinationOrNext);
                    }
                    break;
                }
            default:
                this.syncErrorThrowable = true;
                this.destination = new SafeSubscriber(this, destinationOrNext, error, complete);
                break;
        }
    }
    Subscriber.prototype[rxSubscriber_1.rxSubscriber] = function () { return this; };
    /**
     * A static factory for a Subscriber, given a (potentially partial) definition
     * of an Observer.
     * @param {function(x: ?T): void} [next] The `next` callback of an Observer.
     * @param {function(e: ?any): void} [error] The `error` callback of an
     * Observer.
     * @param {function(): void} [complete] The `complete` callback of an
     * Observer.
     * @return {Subscriber<T>} A Subscriber wrapping the (partially defined)
     * Observer represented by the given arguments.
     */
    Subscriber.create = function (next, error, complete) {
        var subscriber = new Subscriber(next, error, complete);
        subscriber.syncErrorThrowable = false;
        return subscriber;
    };
    /**
     * The {@link Observer} callback to receive notifications of type `next` from
     * the Observable, with a value. The Observable may call this method 0 or more
     * times.
     * @param {T} [value] The `next` value.
     * @return {void}
     */
    Subscriber.prototype.next = function (value) {
        if (!this.isStopped) {
            this._next(value);
        }
    };
    /**
     * The {@link Observer} callback to receive notifications of type `error` from
     * the Observable, with an attached {@link Error}. Notifies the Observer that
     * the Observable has experienced an error condition.
     * @param {any} [err] The `error` exception.
     * @return {void}
     */
    Subscriber.prototype.error = function (err) {
        if (!this.isStopped) {
            this.isStopped = true;
            this._error(err);
        }
    };
    /**
     * The {@link Observer} callback to receive a valueless notification of type
     * `complete` from the Observable. Notifies the Observer that the Observable
     * has finished sending push-based notifications.
     * @return {void}
     */
    Subscriber.prototype.complete = function () {
        if (!this.isStopped) {
            this.isStopped = true;
            this._complete();
        }
    };
    Subscriber.prototype.unsubscribe = function () {
        if (this.closed) {
            return;
        }
        this.isStopped = true;
        _super.prototype.unsubscribe.call(this);
    };
    Subscriber.prototype._next = function (value) {
        this.destination.next(value);
    };
    Subscriber.prototype._error = function (err) {
        this.destination.error(err);
        this.unsubscribe();
    };
    Subscriber.prototype._complete = function () {
        this.destination.complete();
        this.unsubscribe();
    };
    Subscriber.prototype._unsubscribeAndRecycle = function () {
        var _a = this, _parent = _a._parent, _parents = _a._parents;
        this._parent = null;
        this._parents = null;
        this.unsubscribe();
        this.closed = false;
        this.isStopped = false;
        this._parent = _parent;
        this._parents = _parents;
        return this;
    };
    return Subscriber;
}(Subscription_1.Subscription));
exports.Subscriber = Subscriber;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var SafeSubscriber = (function (_super) {
    __extends(SafeSubscriber, _super);
    function SafeSubscriber(_parentSubscriber, observerOrNext, error, complete) {
        _super.call(this);
        this._parentSubscriber = _parentSubscriber;
        var next;
        var context = this;
        if (isFunction_1.isFunction(observerOrNext)) {
            next = observerOrNext;
        }
        else if (observerOrNext) {
            next = observerOrNext.next;
            error = observerOrNext.error;
            complete = observerOrNext.complete;
            if (observerOrNext !== Observer_1.empty) {
                context = Object.create(observerOrNext);
                if (isFunction_1.isFunction(context.unsubscribe)) {
                    this.add(context.unsubscribe.bind(context));
                }
                context.unsubscribe = this.unsubscribe.bind(this);
            }
        }
        this._context = context;
        this._next = next;
        this._error = error;
        this._complete = complete;
    }
    SafeSubscriber.prototype.next = function (value) {
        if (!this.isStopped && this._next) {
            var _parentSubscriber = this._parentSubscriber;
            if (!_parentSubscriber.syncErrorThrowable) {
                this.__tryOrUnsub(this._next, value);
            }
            else if (this.__tryOrSetError(_parentSubscriber, this._next, value)) {
                this.unsubscribe();
            }
        }
    };
    SafeSubscriber.prototype.error = function (err) {
        if (!this.isStopped) {
            var _parentSubscriber = this._parentSubscriber;
            if (this._error) {
                if (!_parentSubscriber.syncErrorThrowable) {
                    this.__tryOrUnsub(this._error, err);
                    this.unsubscribe();
                }
                else {
                    this.__tryOrSetError(_parentSubscriber, this._error, err);
                    this.unsubscribe();
                }
            }
            else if (!_parentSubscriber.syncErrorThrowable) {
                this.unsubscribe();
                throw err;
            }
            else {
                _parentSubscriber.syncErrorValue = err;
                _parentSubscriber.syncErrorThrown = true;
                this.unsubscribe();
            }
        }
    };
    SafeSubscriber.prototype.complete = function () {
        if (!this.isStopped) {
            var _parentSubscriber = this._parentSubscriber;
            if (this._complete) {
                if (!_parentSubscriber.syncErrorThrowable) {
                    this.__tryOrUnsub(this._complete);
                    this.unsubscribe();
                }
                else {
                    this.__tryOrSetError(_parentSubscriber, this._complete);
                    this.unsubscribe();
                }
            }
            else {
                this.unsubscribe();
            }
        }
    };
    SafeSubscriber.prototype.__tryOrUnsub = function (fn, value) {
        try {
            fn.call(this._context, value);
        }
        catch (err) {
            this.unsubscribe();
            throw err;
        }
    };
    SafeSubscriber.prototype.__tryOrSetError = function (parent, fn, value) {
        try {
            fn.call(this._context, value);
        }
        catch (err) {
            parent.syncErrorValue = err;
            parent.syncErrorThrown = true;
            return true;
        }
        return false;
    };
    SafeSubscriber.prototype._unsubscribe = function () {
        var _parentSubscriber = this._parentSubscriber;
        this._context = null;
        this._parentSubscriber = null;
        _parentSubscriber.unsubscribe();
    };
    return SafeSubscriber;
}(Subscriber));
//# sourceMappingURL=Subscriber.js.map

/***/ }),

/***/ "mzA9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
function JocLog(){if("undefined"!=typeof jQuery){for(var t=[],e=0;e<arguments.length;e++){var r=arguments[e];"string"!=typeof r&&(r=JSON.stringify(r)),t.push(""+r)}jQuery("<p/>").text(t.join(" ")).appendTo(jQuery("#jocly-log"))}else console.warn.apply(console,arguments)}var _typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},JocUtil={JSON:JSON};JocUtil.reload=function(){window.location.reload()},JocUtil.setTimeout=function(t,e){return setTimeout(t,e)},JocUtil.setInterval=function(t,e){return setInterval(t,e)},JocUtil.clearTimeout=function(t){clearTimeout(t)},JocUtil.schedule=function(t,e,r){JocUtil.setTimeout(function(){t[e](r)},0)},JocUtil.setPref=function(t,e,r){var i="jocly_pref";arguments.length<3&&(r={}),r.appId&&(i+="_"+r.appId),r.game&&(i+="_"+r.game),i+="_"+t,"boolean"==typeof e&&(e="$#@"+e),"object"!=(void 0===e?"undefined":_typeof(e))&&"array"!=typeof e||(e="$#@JSON@"+JSON.stringify(e)),window.localStorage.setItem(i,e)},JocUtil.getPref=function(t,e){var r="jocly_pref";arguments.length<2&&(e={}),e.appId&&(r+="_"+e.appId),e.game&&(r+="_"+e.game),r+="_"+t;var i=window.localStorage.getItem(r);return"$#@true"==i?i=!0:"$#@false"==i?i=!1:"string"==typeof i&&"$#@JSON@"==i.substr(0,8)&&(i=JSON.parse(i.substr(8))),null==i&&void 0!==e.defaultValue&&(i=e.defaultValue),i},JocUtil.filterLevels=function(t,e,r){var i=parseInt(JocUtil.getPref("calibration",{defaultValue:0}));parseInt(JocUtil.getPref("calibrationDate",{defaultValue:0}))<(new Date).getTime()-864e5&&(i=0);var o=[];if(t){var n=null,a=0;for(var s in t){var c=t[s];if(c.isDefault&&(n=c,bestLevelFound=!0),c.isDefault=!1,c.fullLabel=strings["comp-level"]+" "+c.label,c.optionValue=s,c.calRatio){i||(i=function(){for(var t=(new Date).getTime(),e=[],r=[],i=0;i<100;i++)e.push(i);for(var i=0;i<1e3;i++){for(;e.length>0;)r.push(e.shift());var o=e;e=r,r=o}return(new Date).getTime()-t}(),JocLog("Calibration",i),JocUtil.setPref("calibration",i,{}),JocUtil.setPref("calibrationDate",(new Date).getTime(),{}));var u=i*c.calRatio;if(u>6e4&&o.length>=2)continue;(null==n||u<3e3&&u>a)&&(n=c,a=u)}else null==n&&(n=c);o.push(c)}n&&(n.isDefault=!0)}else{var l=9;e&&(l=e);for(var h=0;h<=l;h++){var c={fullLabel:strings["comp-level"]+" "+(h+1),optionValue:"machine-"+h,isDefault:!1};void 0!==r&&h==r&&(c.isDefault=!0),o.push(c)}}return o},JocUtil.cookieSupportTested=!1,JocUtil.cookieSupport=!0,JocUtil.hasCookieSupport=function(){if(JocUtil.cookieSupportTested)return JocUtil.cookieSupport;if(0==document.cookie.length){var t=new Date;t.setTime(t.getTime()+31536e6),document.cookie="jocly="+escape("{}")+"; path=/; expires="+t.toGMTString()+";",0==document.cookie.length&&(JocUtil.cookieSupport=!1)}return JocUtil.cookieSupportTested=!0,JocUtil.cookieSupport},JocUtil.getCookieData=function(){if(JocUtil.hasCookieSupport()){var t=document.cookie.split(";");for(var e in t){var r=/^ *(.*)$/.exec(t[e])[1];if(0==r.indexOf("jocly="))try{return JSON.parse(unescape(r.substring(6)))}catch(t){JocLog("Unable to parse cookie",r)}}return{}}var i=window.localStorage.getItem("jocly");return null==i?{}:JSON.parse(i)},JocUtil.setCookieData=function(t,e){if(JocUtil.hasCookieSupport()){var r=JocUtil.getCookieData();null==e?delete r[t]:r[t]=e;var i=new Date;i.setTime(i.getTime()+31536e6);var o="jocly="+escape(JSON.stringify(r))+"; path=/; expires="+i.toGMTString()+";";document.cookie=o}else{var r=window.localStorage.getItem("jocly");r=null==r?{}:JSON.parse(r),r[t]=e,window.localStorage.setItem("jocly",JSON.stringify(r))}},JocUtil.extend=function(t,e){for(var r in e)t[r]=e[r]},JocUtil.md5=function(t){function e(t,e){return t<<e|t>>>32-e}function r(t,e){var r,i,o,n,a;return o=2147483648&t,n=2147483648&e,r=1073741824&t,i=1073741824&e,a=(1073741823&t)+(1073741823&e),r&i?2147483648^a^o^n:r|i?1073741824&a?3221225472^a^o^n:1073741824^a^o^n:a^o^n}function i(t,e,r){return t&e|~t&r}function o(t,e,r){return t&r|e&~r}function n(t,e,r){return t^e^r}function a(t,e,r){return e^(t|~r)}function s(t,o,n,a,s,c,u){return t=r(t,r(r(i(o,n,a),s),u)),r(e(t,c),o)}function c(t,i,n,a,s,c,u){return t=r(t,r(r(o(i,n,a),s),u)),r(e(t,c),i)}function u(t,i,o,a,s,c,u){return t=r(t,r(r(n(i,o,a),s),u)),r(e(t,c),i)}function l(t,i,o,n,s,c,u){return t=r(t,r(r(a(i,o,n),s),u)),r(e(t,c),i)}function h(t){var e,r,i="",o="";for(r=0;r<=3;r++)e=t>>>8*r&255,o="0"+e.toString(16),i+=o.substr(o.length-2,2);return i}var f,m,p,d,g,v,y,S,J,C=Array();for(t=function(t){t=t.replace(/\r\n/g,"\n");for(var e="",r=0;r<t.length;r++){var i=t.charCodeAt(r);i<128?e+=String.fromCharCode(i):i>127&&i<2048?(e+=String.fromCharCode(i>>6|192),e+=String.fromCharCode(63&i|128)):(e+=String.fromCharCode(i>>12|224),e+=String.fromCharCode(i>>6&63|128),e+=String.fromCharCode(63&i|128))}return e}(t),C=function(t){for(var e,r=t.length,i=r+8,o=(i-i%64)/64,n=16*(o+1),a=Array(n-1),s=0,c=0;c<r;)e=(c-c%4)/4,s=c%4*8,a[e]=a[e]|t.charCodeAt(c)<<s,c++;return e=(c-c%4)/4,s=c%4*8,a[e]=a[e]|128<<s,a[n-2]=r<<3,a[n-1]=r>>>29,a}(t),v=1732584193,y=4023233417,S=2562383102,J=271733878,f=0;f<C.length;f+=16)m=v,p=y,d=S,g=J,v=s(v,y,S,J,C[f+0],7,3614090360),J=s(J,v,y,S,C[f+1],12,3905402710),S=s(S,J,v,y,C[f+2],17,606105819),y=s(y,S,J,v,C[f+3],22,3250441966),v=s(v,y,S,J,C[f+4],7,4118548399),J=s(J,v,y,S,C[f+5],12,1200080426),S=s(S,J,v,y,C[f+6],17,2821735955),y=s(y,S,J,v,C[f+7],22,4249261313),v=s(v,y,S,J,C[f+8],7,1770035416),J=s(J,v,y,S,C[f+9],12,2336552879),S=s(S,J,v,y,C[f+10],17,4294925233),y=s(y,S,J,v,C[f+11],22,2304563134),v=s(v,y,S,J,C[f+12],7,1804603682),J=s(J,v,y,S,C[f+13],12,4254626195),S=s(S,J,v,y,C[f+14],17,2792965006),y=s(y,S,J,v,C[f+15],22,1236535329),v=c(v,y,S,J,C[f+1],5,4129170786),J=c(J,v,y,S,C[f+6],9,3225465664),S=c(S,J,v,y,C[f+11],14,643717713),y=c(y,S,J,v,C[f+0],20,3921069994),v=c(v,y,S,J,C[f+5],5,3593408605),J=c(J,v,y,S,C[f+10],9,38016083),S=c(S,J,v,y,C[f+15],14,3634488961),y=c(y,S,J,v,C[f+4],20,3889429448),v=c(v,y,S,J,C[f+9],5,568446438),J=c(J,v,y,S,C[f+14],9,3275163606),S=c(S,J,v,y,C[f+3],14,4107603335),y=c(y,S,J,v,C[f+8],20,1163531501),v=c(v,y,S,J,C[f+13],5,2850285829),J=c(J,v,y,S,C[f+2],9,4243563512),S=c(S,J,v,y,C[f+7],14,1735328473),y=c(y,S,J,v,C[f+12],20,2368359562),v=u(v,y,S,J,C[f+5],4,4294588738),J=u(J,v,y,S,C[f+8],11,2272392833),S=u(S,J,v,y,C[f+11],16,1839030562),y=u(y,S,J,v,C[f+14],23,4259657740),v=u(v,y,S,J,C[f+1],4,2763975236),J=u(J,v,y,S,C[f+4],11,1272893353),S=u(S,J,v,y,C[f+7],16,4139469664),y=u(y,S,J,v,C[f+10],23,3200236656),v=u(v,y,S,J,C[f+13],4,681279174),J=u(J,v,y,S,C[f+0],11,3936430074),S=u(S,J,v,y,C[f+3],16,3572445317),y=u(y,S,J,v,C[f+6],23,76029189),v=u(v,y,S,J,C[f+9],4,3654602809),J=u(J,v,y,S,C[f+12],11,3873151461),S=u(S,J,v,y,C[f+15],16,530742520),y=u(y,S,J,v,C[f+2],23,3299628645),v=l(v,y,S,J,C[f+0],6,4096336452),J=l(J,v,y,S,C[f+7],10,1126891415),S=l(S,J,v,y,C[f+14],15,2878612391),y=l(y,S,J,v,C[f+5],21,4237533241),v=l(v,y,S,J,C[f+12],6,1700485571),J=l(J,v,y,S,C[f+3],10,2399980690),S=l(S,J,v,y,C[f+10],15,4293915773),y=l(y,S,J,v,C[f+1],21,2240044497),v=l(v,y,S,J,C[f+8],6,1873313359),J=l(J,v,y,S,C[f+15],10,4264355552),S=l(S,J,v,y,C[f+6],15,2734768916),y=l(y,S,J,v,C[f+13],21,1309151649),v=l(v,y,S,J,C[f+4],6,4149444226),J=l(J,v,y,S,C[f+11],10,3174756917),S=l(S,J,v,y,C[f+2],15,718787259),y=l(y,S,J,v,C[f+9],21,3951481745),v=r(v,m),y=r(y,p),S=r(S,d),J=r(J,g);return(h(v)+h(y)+h(S)+h(J)).toLowerCase()},JocUtil.sha1=function(t){function e(t,e){return t<<e|t>>>32-e}function r(t){var e,r,i="";for(e=7;e>=0;e--)r=t>>>4*e&15,i+=r.toString(16);return i}var i,o,n,a,s,c,u,l,h,f=new Array(80),m=1732584193,p=4023233417,d=2562383102,g=271733878,v=3285377520;t=function(t){t=t.replace(/\r\n/g,"\n");for(var e="",r=0;r<t.length;r++){var i=t.charCodeAt(r);i<128?e+=String.fromCharCode(i):i>127&&i<2048?(e+=String.fromCharCode(i>>6|192),e+=String.fromCharCode(63&i|128)):(e+=String.fromCharCode(i>>12|224),e+=String.fromCharCode(i>>6&63|128),e+=String.fromCharCode(63&i|128))}return e}(t);var y=t.length,S=new Array;for(o=0;o<y-3;o+=4)n=t.charCodeAt(o)<<24|t.charCodeAt(o+1)<<16|t.charCodeAt(o+2)<<8|t.charCodeAt(o+3),S.push(n);switch(y%4){case 0:o=2147483648;break;case 1:o=t.charCodeAt(y-1)<<24|8388608;break;case 2:o=t.charCodeAt(y-2)<<24|t.charCodeAt(y-1)<<16|32768;break;case 3:o=t.charCodeAt(y-3)<<24|t.charCodeAt(y-2)<<16|t.charCodeAt(y-1)<<8|128}for(S.push(o);S.length%16!=14;)S.push(0);for(S.push(y>>>29),S.push(y<<3&4294967295),i=0;i<S.length;i+=16){for(o=0;o<16;o++)f[o]=S[i+o];for(o=16;o<=79;o++)f[o]=e(f[o-3]^f[o-8]^f[o-14]^f[o-16],1);for(a=m,s=p,c=d,u=g,l=v,o=0;o<=19;o++)h=e(a,5)+(s&c|~s&u)+l+f[o]+1518500249&4294967295,l=u,u=c,c=e(s,30),s=a,a=h;for(o=20;o<=39;o++)h=e(a,5)+(s^c^u)+l+f[o]+1859775393&4294967295,l=u,u=c,c=e(s,30),s=a,a=h;for(o=40;o<=59;o++)h=e(a,5)+(s&c|s&u|c&u)+l+f[o]+2400959708&4294967295,l=u,u=c,c=e(s,30),s=a,a=h;for(o=60;o<=79;o++)h=e(a,5)+(s^c^u)+l+f[o]+3395469782&4294967295,l=u,u=c,c=e(s,30),s=a,a=h;m=m+a&4294967295,p=p+s&4294967295,d=d+c&4294967295,g=g+u&4294967295,v=v+l&4294967295}var h=r(m)+r(p)+r(d)+r(g)+r(v);return h.toLowerCase()};var MersenneTwister=function(t){void 0==t&&(t=(new Date).getTime()),this.N=624,this.M=397,this.MATRIX_A=2567483615,this.UPPER_MASK=2147483648,this.LOWER_MASK=2147483647,this.mt=new Array(this.N),this.mti=this.N+1,this.init_genrand(t)};MersenneTwister.prototype.init_genrand=function(t){for(this.mt[0]=t>>>0,this.mti=1;this.mti<this.N;this.mti++){var t=this.mt[this.mti-1]^this.mt[this.mti-1]>>>30;this.mt[this.mti]=(1812433253*((4294901760&t)>>>16)<<16)+1812433253*(65535&t)+this.mti,this.mt[this.mti]>>>=0}},MersenneTwister.prototype.init_by_array=function(t,e){var r,i,o;for(this.init_genrand(19650218),r=1,i=0,o=this.N>e?this.N:e;o;o--){var n=this.mt[r-1]^this.mt[r-1]>>>30;this.mt[r]=(this.mt[r]^(1664525*((4294901760&n)>>>16)<<16)+1664525*(65535&n))+t[i]+i,this.mt[r]>>>=0,r++,i++,r>=this.N&&(this.mt[0]=this.mt[this.N-1],r=1),i>=e&&(i=0)}for(o=this.N-1;o;o--){var n=this.mt[r-1]^this.mt[r-1]>>>30;this.mt[r]=(this.mt[r]^(1566083941*((4294901760&n)>>>16)<<16)+1566083941*(65535&n))-r,this.mt[r]>>>=0,r++,r>=this.N&&(this.mt[0]=this.mt[this.N-1],r=1)}this.mt[0]=2147483648},MersenneTwister.prototype.genrand_int32=function(){var t,e=new Array(0,this.MATRIX_A);if(this.mti>=this.N){var r;for(this.mti==this.N+1&&this.init_genrand(5489),r=0;r<this.N-this.M;r++)t=this.mt[r]&this.UPPER_MASK|this.mt[r+1]&this.LOWER_MASK,this.mt[r]=this.mt[r+this.M]^t>>>1^e[1&t];for(;r<this.N-1;r++)t=this.mt[r]&this.UPPER_MASK|this.mt[r+1]&this.LOWER_MASK,this.mt[r]=this.mt[r+(this.M-this.N)]^t>>>1^e[1&t];t=this.mt[this.N-1]&this.UPPER_MASK|this.mt[0]&this.LOWER_MASK,this.mt[this.N-1]=this.mt[this.M-1]^t>>>1^e[1&t],this.mti=0}return t=this.mt[this.mti++],t^=t>>>11,t^=t<<7&2636928640,t^=t<<15&4022730752,(t^=t>>>18)>>>0},MersenneTwister.prototype.genrand_int31=function(){return this.genrand_int32()>>>1},MersenneTwister.prototype.genrand_real1=function(){return this.genrand_int32()*(1/4294967295)},MersenneTwister.prototype.random=function(){return this.genrand_int32()*(1/4294967296)},MersenneTwister.prototype.genrand_real3=function(){return(this.genrand_int32()+.5)*(1/4294967296)},MersenneTwister.prototype.genrand_res53=function(){return(67108864*(this.genrand_int32()>>>5)+(this.genrand_int32()>>>6))*(1/9007199254740992)},"undefined"!=typeof module&&module.exports?(exports.MersenneTwister=MersenneTwister,exports.JocUtil=JocUtil):((void 0).MersenneTwister=MersenneTwister,(void 0).JocUtil=JocUtil);

/***/ }),

/***/ "n9JH":
/***/ (function(module, exports, __webpack_require__) {

var
    symbols = __webpack_require__("bgfr"),
    Piece = symbols.Piece,
    Color = symbols.Color
;


function Square(number, piece) {
    this.number = number;
    this.piece = piece ? piece : Piece.EMPTY;
}

Square.prototype.isPawn = function() {
    return (this.piece === Piece.PAWN_WHITE || this.piece === Piece.PAWN_BLACK);
};
Square.prototype.isDame = function() {
    return (this.piece === Piece.DAME_WHITE || this.piece === Piece.DAME_BLACK);
};
Square.prototype.isWhite = function() {
    return (this.piece === Piece.PAWN_WHITE || this.piece === Piece.DAME_WHITE);
};
Square.prototype.isBlack = function() {
    return (this.piece === Piece.PAWN_BLACK || this.piece === Piece.DAME_BLACK);
};
Square.prototype.isEmpty = function() {
    return (this.piece === Piece.EMPTY);
};

Square.prototype.getColor = function() {
    var c = Color.NONE;

    if (this.isWhite()) {
        c = Color.WHITE;
    } else if (this.isBlack()) {
        c = Color.BLACK;
    }
    return c;
};

Square.prototype.isOppositeColor = function(caseToCompare) {
    var c = this.getColor();
    var c2 = caseToCompare.getColor();
    return ((c == Color.WHITE && c2 == Color.BLACK) || (c == Color.BLACK && c2 == Color.WHITE));
};

Square.prototype.debug = function() {
    console.log("Square #" + this.number + " (" + this.piece + ")");
};

module.exports = Square;


/***/ }),

/***/ "nDCe":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var publishBehavior_1 = __webpack_require__("PN3d");
Observable_1.Observable.prototype.publishBehavior = publishBehavior_1.publishBehavior;
//# sourceMappingURL=publishBehavior.js.map

/***/ }),

/***/ "nFIP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var root_1 = __webpack_require__("VOfZ");
/* tslint:enable:max-line-length */
/**
 * Converts an Observable sequence to a ES2015 compliant promise.
 *
 * @example
 * // Using normal ES2015
 * let source = Rx.Observable
 *   .just(42)
 *   .toPromise();
 *
 * source.then((value) => console.log('Value: %s', value));
 * // => Value: 42
 *
 * // Rejected Promise
 * // Using normal ES2015
 * let source = Rx.Observable
 *   .throw(new Error('woops'))
 *   .toPromise();
 *
 * source
 *   .then((value) => console.log('Value: %s', value))
 *   .catch((err) => console.log('Error: %s', err));
 * // => Error: Error: woops
 *
 * // Setting via the config
 * Rx.config.Promise = RSVP.Promise;
 *
 * let source = Rx.Observable
 *   .of(42)
 *   .toPromise();
 *
 * source.then((value) => console.log('Value: %s', value));
 * // => Value: 42
 *
 * // Setting via the method
 * let source = Rx.Observable
 *   .just(42)
 *   .toPromise(RSVP.Promise);
 *
 * source.then((value) => console.log('Value: %s', value));
 * // => Value: 42
 *
 * @param PromiseCtor promise The constructor of the promise. If not provided,
 * it will look for a constructor first in Rx.config.Promise then fall back to
 * the native Promise constructor if available.
 * @return {Promise<T>} An ES2015 compatible promise with the last value from
 * the observable sequence.
 * @method toPromise
 * @owner Observable
 */
function toPromise(PromiseCtor) {
    var _this = this;
    if (!PromiseCtor) {
        if (root_1.root.Rx && root_1.root.Rx.config && root_1.root.Rx.config.Promise) {
            PromiseCtor = root_1.root.Rx.config.Promise;
        }
        else if (root_1.root.Promise) {
            PromiseCtor = root_1.root.Promise;
        }
    }
    if (!PromiseCtor) {
        throw new Error('no Promise impl found');
    }
    return new PromiseCtor(function (resolve, reject) {
        var value;
        _this.subscribe(function (x) { return value = x; }, function (err) { return reject(err); }, function () { return resolve(value); });
    });
}
exports.toPromise = toPromise;
//# sourceMappingURL=toPromise.js.map

/***/ }),

/***/ "nLHL":
/***/ (function(module, exports) {

exports.model=Model={Game:{},Board:{},Move:{}},Model.Game.InitGame=function(){for(var t=this.mOptions.width,i=this.mOptions.height,s=this.mOptions.lines,o=[[-1,-1],[0,-1],[1,-1],[-1,0]],h=[],e=0;e<i;e++)for(var r=0;r<t;r++)for(var n=0;n<o.length;n++){var l,a=o[n][0],p=o[n][1],d=[];for(l=0;l<s;l++){var u;if(u=this.mOptions.torus?(e+p*l)*t+(r+a*l+t)%t:(e+p*l)*t+r+a*l,this.mOptions.torus&&(e+p*l<0||e+p*l>=i))break;if(!this.mOptions.torus&&(r+a*l<0||r+a*l>=t||e+p*l<0||e+p*l>=i))break;d.push(u)}l==s&&h.push(d)}this.g.TuplesList=h;for(var m={},l=0;l<h.length;l++)for(var d=h[l],v=0;v<d.length;v++){var u=d[v];void 0===m[u]&&(m[u]=[]),m[u].push(d)}this.g.Tuples=m,this.zobrist=new JocGame.Zobrist({board:{type:"array",size:this.mOptions.width*this.mOptions.height,values:["1","-1"]}})},Model.Move.Init=function(t){this.op=t.op,this.col=t.col},Model.Move.CopyFrom=function(t){this.Init(t)},Model.Move.ToString=function(){var t="";switch(this.op){case"+":t+="+";break;case"-":t+="-";break;default:t+="?"}return t+=String.fromCharCode(65+this.col)},Model.Board.Init=function(t){this.zSign=0},Model.Board.InitialPosition=function(t){this.board=[];for(var i=t.mOptions.width,s=t.mOptions.height,o=0;o<s;o++)for(var h=0;h<i;h++)this.board.push(0);this.tuples={};for(var e=1;e<=t.mOptions.lines;e++)this.tuples[e]=0,this.tuples[-e]=0;this.cols=[];for(var h=0;h<i;h++)this.cols.push(0);if(t.mOptions.fillSides)for(var e=0;e<s;e++){var r=e*i,n=e%2?-1:1,l=0;this.board[r]=n,this.cols[l]++,this.tuples[n]++,this.zSign=t.zobrist.update(this.zSign,"board",n,r);var r=e*i+i-1,n=e%2?1:-1,l=i-1;this.board[r]=n,this.cols[l]++,this.tuples[n]++,this.zSign=t.zobrist.update(this.zSign,"board",n,r)}},Model.Board.GenerateMoves=function(t){for(var i=[],s=t.mOptions.height,o=0;o<t.mOptions.width;o++)this.cols[o]<s&&i.push({op:"+",col:o});if(t.mOptions.remove)for(var o=0;o<t.mOptions.width;o++)this.board[o]==this.mWho&&i.push({op:"-",col:o});this.mMoves=i,0==i.length&&(this.mFinished=!0,this.mWinner=JocGame.DRAW)},Model.Board.Evaluate=function(t){if(this.mEvaluation=0,this.mWinner=0,t.mOptions.preventRepeat&&t.GetRepeatOccurence(this)>2)return this.mFinished=!0,void(this.mWinner=JocGame.DRAW);if(this.tuples[t.mOptions.lines]>0&&(this.mFinished=!0,this.mWinner=1),this.tuples[-t.mOptions.lines]>0)return this.mFinished=!0,void(this.mWinner?this.mWinner=JocGame.DRAW:this.mWinner=-1);if(!this.mFinished)for(var i=t.mOptions.levelOptions,s=1;s<t.mOptions.lines;s++)this.mEvaluation+=this.tuples[s]*i["evalTuple"+s],this.mEvaluation-=this.tuples[-s]*i["evalTuple"+s]},Model.Board.ApplyMove=function(t,i){if("+"==i.op){for(var s=i.col,o=this.cols[s],h=o*t.mOptions.width+s,e=0;e<t.g.Tuples[h].length;e++){for(var r=t.g.Tuples[h][e],n={1:0,0:0,"-1":0},l=0;l<r.length;l++)n[this.board[r[l]]]++;n[1]>0&&0==n[-1]?this.tuples[n[1]]--:n[-1]>0&&0==n[1]&&this.tuples[-n[-1]]--,n[this.mWho]++,n[1]>0&&0==n[-1]?this.tuples[n[1]]++:n[-1]>0&&0==n[1]&&this.tuples[-n[-1]]++}this.board[h]=this.mWho,this.cols[s]++,this.zSign=t.zobrist.update(this.zSign,"board",this.mWho,h)}else if("-"==i.op){for(var o=0;o<this.cols[i.col];o++)for(var h=o*t.mOptions.width+i.col,e=0;e<t.g.Tuples[h].length;e++){for(var r=t.g.Tuples[h][e],n={1:0,0:0,"-1":0},l=0;l<r.length;l++)n[this.board[r[l]]]++;n[1]>0&&0==n[-1]?this.tuples[n[1]]--:n[-1]>0&&0==n[1]&&this.tuples[-n[-1]]--}for(var e=0;e<this.cols[i.col];e++){var h=e*t.mOptions.width+i.col,a=h+t.mOptions.width,p=0;a<this.board.length&&(p=this.board[a]),this.zSign=t.zobrist.update(this.zSign,"board",this.board[h],h),p&&(this.zSign=t.zobrist.update(this.zSign,"board",p,h)),this.board[h]=p}this.cols[i.col]--;for(var o=0;o<this.cols[i.col];o++)for(var h=o*t.mOptions.width+i.col,e=0;e<t.g.Tuples[h].length;e++){for(var r=t.g.Tuples[h][e],n={1:0,0:0,"-1":0},l=0;l<r.length;l++)n[this.board[r[l]]]++;n[1]>0&&0==n[-1]?this.tuples[n[1]]++:n[-1]>0&&0==n[1]&&this.tuples[-n[-1]]++}}else console.error("Invalid move",i)},Model.Board.CopyFrom=function(t){this.tuples={};for(var i in t.tuples)this.tuples[i]=t.tuples[i];this.board=[];for(var s=0;s<t.board.length;s++)this.board.push(t.board[s]);this.cols=[];for(var o=0;o<t.cols.length;o++)this.cols.push(t.cols[o]);this.mWho=t.mWho,this.zSign=t.zSign},Model.Board.GetSignature=function(){return this.zSign};

/***/ }),

/***/ "nQaM":
/***/ (function(module, exports) {

exports.model=Model={Game:{},Board:{},Move:{}},function(){var t;Model.Game.cbConstants={MASK:65535,FLAG_MOVE:65536,FLAG_CAPTURE:131072,FLAG_STOP:262144,FLAG_SCREEN_CAPTURE:524288,FLAG_CAPTURE_KING:1048576,FLAG_CAPTURE_NO_KING:2097152};var e="undefined"!=typeof Int32Array;Model.Game.cbUseTypedArrays=e,Model.Game.cbTypedArray=function(t){if(e){var i=new Int32Array(t.length);return i.set(t),i}for(var r=[],a=t.length,n=0;n<a;n++)r.push(t[n]);return r},Model.Game.cbShortRangeGraph=function(t,e,i,r){var a=this;void 0===r&&(r=196608);for(var n={},s=0;s<t.boardSize;s++)n[s]=[],(!i||s in i)&&e.forEach(function(e){var o=t.Graph(s,e);null!=o&&(!i||o in i)&&n[s].push(a.cbTypedArray([o|r]))});return n},Model.Game.cbLongRangeGraph=function(t,e,i,r,a){var n=this;void 0!==r&&null!=r||(r=196608),a||(a=1/0);for(var s={},o=0;o<t.boardSize;o++)s[o]=[],(!i||o in i)&&e.forEach(function(e){for(var h=[],c=t.Graph(o,e),p=0;null!=c&&(!i||c in i)&&(h.push(c|r),++p!=a);)c=t.Graph(c,e);h.length>0&&s[o].push(n.cbTypedArray(h))});return s},Model.Game.cbNullGraph=function(t){for(var e={},i=0;i<t.boardSize;i++)e[i]=[];return e},Model.Game.cbAuthorGraph=function(t){for(var e={},i=0;i<t.boardSize;i++){e[i]=[];for(var r=0;r<t.boardSize;r++)e[i].push([2293760|r])}return e},Model.Game.cbMergeGraphs=function(t){for(var e=[],i=0;i<t.boardSize;i++){e[i]=[];for(var r=1;r<arguments.length;r++)e[i]=e[i].concat(arguments[r][i])}return e},Model.Game.cbGetThreatGraph=function(){function t(e,i){for(var r in s){var a=s[r];if(!(a.p.length<i.length+1)){for(var n=!0,o=0;o<i.length;o++)if(i[o]!=a.p[o]){n=!1;break}if(n){var h=a.p[i.length],c=e[h];void 0===c&&(c={e:{}},e[h]=c),a.p.length==i.length+1&&(c.t=a.t,c.ts=a.ts,c.tk=a.tk,delete s[r]),i.push(h),t(c.e,i),i.pop()}}}}var e=this;this.cbUseScreenCapture=!1,this.cbUseCaptureKing=!1,this.cbUseCaptureNoKing=!1;for(var i={1:[],"-1":[]},r=[],a=0;a<this.g.boardSize;a++)this.g.pTypes.forEach(function(t,i){t.graph[a].forEach(function(t){for(var n=[],s=0;s<t.length;s++){var o=t[s];1048576&o?(e.cbUseCaptureKing=!0,n.unshift({d:65535&o,a:a,tk:i})):2097152&o?(e.cbUseCaptureNoKing=!0,n.unshift({d:65535&o,a:a,tnk:i})):131072&o?n.unshift({d:65535&o,a:a,t:i}):262144&o?n.unshift({d:65535&o,a:a}):524288&o&&(e.cbUseScreenCapture=!0,n.unshift({d:65535&o,a:a,ts:i}))}n.length>0&&r.push(n)})});var n={};r.forEach(function(t){t.forEach(function(e,i){var r=n[e.d];void 0===r&&(r={},n[e.d]=r);for(var a=[],s=i+1;s<t.length;s++)a.push(t[s].d);a.push(e.a);var o=a.join(","),h=r[o];void 0===h&&(h={p:a,t:{},ts:{},tk:{}},r[o]=h),void 0!==e.t?h.t[e.t]=!0:void 0!==e.tk?h.tk[e.tk]=!0:void 0!==e.ts&&(h.ts[e.ts]=!0)})});for(var a=0;a<e.g.boardSize;a++){var s=n[a],o={};t(o,[]),i[1][a]=o,i[-1][a]=o}return i},Model.Game.InitGame=function(){var e=this;this.cbVar=t=this.cbDefine(),this.g.boardSize=this.cbVar.geometry.boardSize,this.g.pTypes=this.cbGetPieceTypes(),this.g.threatGraph=this.cbGetThreatGraph(),this.g.distGraph=this.cbVar.geometry.GetDistances(),this.cbPiecesCount=0,this.g.castleablePiecesCount={1:0,"-1":0};for(var i in t.pieceTypes){var r=t.pieceTypes[i];if(r.castle){(r.initial||[]).forEach(function(t){e.g.castleablePiecesCount[t.s]++})}r.initial&&(this.cbPiecesCount+=r.initial.length)}for(var a=[],i=0;i<this.cbPiecesCount;i++)a.push(i);var n=Object.keys(t.pieceTypes);this.zobrist=new JocGame.Zobrist({board:{type:"array",size:this.cbVar.geometry.boardSize,values:a},who:{values:["1","-1"]},type:{type:"array",size:this.cbPiecesCount,values:n}})},Model.Game.cbGetPieceTypes=function(){for(var t=[],e={},i=0;i<this.cbVar.geometry.boardSize;i++)e[i]=[];for(var r in this.cbVar.pieceTypes){var a=this.cbVar.pieceTypes[r];t[r]={graph:a.graph||e,abbrev:a.abbrev||"",value:a.isKing?100:a.value||1,isKing:!!a.isKing,castle:!!a.castle,epTarget:!!a.epTarget,epCatch:!!a.epCatch}}return t},Model.Board.Init=function(t){this.zSign=0},Model.Board.InitialPosition=function(i){var r=this;this.board=e?new Int16Array(i.g.boardSize):[];for(var a=0;a<i.g.boardSize;a++)this.board[a]=-1;if(this.kings={},this.pieces=[],this.ending={1:!1,"-1":!1},this.lastMove=null,i.cbVar.castle&&(this.castled={1:!1,"-1":!1}),this.zSign=i.zobrist.update(0,"who",-1),this.noCaptCount=0,this.mWho=1,i.mInitial)this.mWho=i.mInitial.turn||1,i.mInitial.pieces.forEach(function(t){var e={};for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i]);r.pieces.push(e)}),i.mInitial.lastMove&&(this.lastMove={f:i.mInitial.lastMove.f,t:i.mInitial.lastMove.t}),void 0!==i.mInitial.noCaptCount&&(this.noCaptCount=i.mInitial.noCaptCount),i.cbVar.castle&&i.mInitial.castle&&(this.castled={1:{k:!!i.mInitial.castle[1]&&!!i.mInitial.castle[1].k,q:!!i.mInitial.castle[1]&&!!i.mInitial.castle[1].q},"-1":{k:!!i.mInitial.castle[-1]&&!!i.mInitial.castle[-1].k,q:!!i.mInitial.castle[-1]&&!!i.mInitial.castle[-1].q}});else for(var n in i.cbVar.pieceTypes)for(var s=i.cbVar.pieceTypes[n],o=s.initial||[],h=0;h<o.length;h++){var c=o[h],p={s:c.s,t:parseInt(n),p:c.p,m:!1};this.pieces.push(p)}if(this.pieces.sort(function(t,e){if(t.s!=e.s)return e.s-t.s;var r=i.cbVar.pieceTypes[t.t].value||100,a=i.cbVar.pieceTypes[e.t].value||100;return r!=a?r-a:t.p-e.p}),this.pieces.forEach(function(t,e){t.i=e,r.board[t.p]=e,i.g.pTypes[t.t].isKing&&(r.kings[t.s]=t.p),r.zSign=i.zobrist.update(r.zSign,"board",e,t.p),r.zSign=i.zobrist.update(r.zSign,"type",t.t,e)}),i.mInitial&&i.mInitial.enPassant){var a=t.geometry.PosByName(i.mInitial.enPassant);if(a>=0){var l,v=t.geometry.C(a),f=t.geometry.R(a);l=1==i.mInitial.turn?t.geometry.POS(v,f-1):t.geometry.POS(v,f+1),this.epTarget={p:a,i:this.board[l]}}}},Model.Board.CopyFrom=function(t){if(e)this.board=new Int16Array(t.board.length),this.board.set(t.board);else{this.board=[];for(var i=t.board,r=i.length,a=0;a<r;a++)this.board.push(i[a])}this.pieces=[];for(var n=t.pieces.length,a=0;a<n;a++){var s=t.pieces[a];this.pieces.push({s:s.s,p:s.p,t:s.t,i:s.i,m:s.m})}this.kings={1:t.kings[1],"-1":t.kings[-1]},this.check=t.check,t.lastMove?this.lastMove={f:t.lastMove.f,t:t.lastMove.t,c:t.lastMove.c}:this.lastMove=null,this.ending={1:t.ending[1],"-1":t.ending[-1]},void 0!==t.castled&&(this.castled={1:t.castled[1],"-1":t.castled[-1]}),this.noCaptCount=t.noCaptCount,t.epTarget?this.epTarget={p:t.epTarget.p,i:t.epTarget.i}:this.epTarget=null,this.mWho=t.mWho,this.zSign=t.zSign},Model.Board.cbApplyCastle=function(t,e,i){var r=t.cbVar.castle[e.f+"/"+e.cg],a=r.r[r.r.length-1],n=this.pieces[this.board[e.cg]],s=r.k[r.k.length-1],o=this.pieces[this.board[e.f]];return i&&(this.zSign=t.zobrist.update(this.zSign,"board",n.i,e.cg),this.zSign=t.zobrist.update(this.zSign,"board",n.i,a),this.zSign=t.zobrist.update(this.zSign,"board",o.i,e.f),this.zSign=t.zobrist.update(this.zSign,"board",o.i,s)),n.p=a,n.m=!0,this.board[e.cg]=-1,o.p=s,o.m=!0,this.board[e.f]=-1,this.board[a]=n.i,this.board[s]=o.i,this.castled[n.s]=!0,this.kings[o.s]=s,[{i:n.i,f:a,t:-1},{i:o.i,f:s,t:e.f,kp:e.f,who:o.s,m:!1},{i:n.i,f:-1,t:e.cg,m:!1,cg:!1}]},Model.Board.cbQuickApply=function(t,e){if(void 0!==e.cg)return this.cbApplyCastle(t,e,!1);var i=[],r=this.board[e.f],a=this.pieces[r];if(null!=e.c){i.unshift({i:e.c,f:-1,t:this.pieces[e.c].p});var n=this.pieces[e.c];this.board[n.p]=-1,n.p=-1}var s=this.kings[a.s];return t.g.pTypes[a.t].isKing&&(this.kings[a.s]=e.t),i.unshift({i:r,f:e.t,t:e.f,kp:s,who:a.s,ty:a.t}),a.p=e.t,void 0!==e.pr&&(a.t=e.pr),this.board[e.f]=-1,this.board[e.t]=r,i},Model.Board.cbQuickUnapply=function(t,e){for(var i=0;i<e.length;i++){var r=e[i],a=this.pieces[r.i];r.f>=0&&(a.p=-1,this.board[r.f]=-1),r.t>=0&&(a.p=r.t,this.board[r.t]=r.i),void 0!==r.m&&(a.m=r.m),void 0!==r.kp&&(this.kings[r.who]=r.kp),void 0!=r.ty&&(a.t=r.ty),void 0!=r.cg&&(this.castled[a.s]=r.cg)}},Model.Board.ApplyMove=function(t,e){var i=this.pieces[this.board[e.f]];if(void 0!==e.cg)this.cbApplyCastle(t,e,!0);else{if(this.zSign=t.zobrist.update(this.zSign,"board",i.i,e.f),this.board[i.p]=-1,void 0!==e.pr&&(this.zSign=t.zobrist.update(this.zSign,"type",i.t,i.i),i.t=e.pr,this.zSign=t.zobrist.update(this.zSign,"type",i.t,i.i)),null!=e.c){var r=this.pieces[e.c];this.zSign=t.zobrist.update(this.zSign,"board",r.i,r.p),this.board[r.p]=-1,r.p=-1,r.m=!0,this.noCaptCount=0}else this.noCaptCount++;i.p=e.t,i.m=!0,this.board[e.t]=i.i,this.zSign=t.zobrist.update(this.zSign,"board",i.i,e.t),t.g.pTypes[i.t].isKing&&(this.kings[i.s]=e.t)}this.check=!!e.ck,this.lastMove={f:e.f,t:e.t,c:e.c},void 0!==e.ko&&(this.ending[i.s]=e.ko),void 0!==e.ept?this.epTarget={p:e.ept,i:i.i}:this.epTarget=null,this.zSign=t.zobrist.update(this.zSign,"who",-this.mWho),this.zSign=t.zobrist.update(this.zSign,"who",this.mWho)},Model.Board.Evaluate=function(i){function r(e){var i=1/0;for(var r in t.geometry.corners)i=Math.min(i,h.distGraph[n.kings[e]][r]);return i-Math.sqrt(h.boardSize)}var a="debug"==arguments[3],n=this;this.mEvaluation=0;var s,o=this.mWho,h=i.g;if(e)s={1:{count:new Uint8Array(h.pTypes.length),byType:{}},"-1":{count:new Uint8Array(h.pTypes.length),byType:{}}};else{s={1:{count:[],byType:{}},"-1":{count:[],byType:{}}};for(var c=0;c<h.pTypes.length;c++)s[1].count[c]=s[-1].count[c]=0}if(i.mOptions.preventRepeat&&i.GetRepeatOccurence(this)>2)return this.mFinished=!0,void(this.mWinner=i.cbOnPerpetual?o*i.cbOnPerpetual:JocGame.DRAW);for(var p={1:0,"-1":0},l={1:h.distGraph[this.kings[-1]],"-1":h.distGraph[this.kings[1]]},v={1:0,"-1":0},f={1:0,"-1":0},u={1:0,"-1":0},g={1:0,"-1":0},b={1:!1,"-1":!1},d=this.pieces,m=d.length,c=0;c<m;c++){var G=d[c];if(G.p>=0){var y=G.s,M=h.pTypes[G.t];M.isKing?b[y]=G.m:p[y]+=M.value,M.castle&&!G.m&&g[y]++,f[y]++,v[y]+=l[y][G.p],u[y]+=t.geometry.distEdge[G.p];var k=s[y];k.count[G.t]++;var S=k.byType;void 0===S[G.t]?S[G.t]=[G]:S[G.t].push(G)}}if(this.lastMove&&null!=this.lastMove.c){var G=this.pieces[this.board[this.lastMove.t]];p[-G.s]+=this.cbStaticExchangeEval(i,G.p,G.s,{piece:G})}var C={1:0,"-1":0},T={1:0,"-1":0},z={1:0,"-1":0};this.ending[1]&&(T[1]=(v[1]-Math.sqrt(h.boardSize))/f[1],t.geometry.corners&&(z[1]=r(1))),this.ending[-1]&&(T[-1]=(v[-1]-Math.sqrt(h.boardSize))/f[-1],t.geometry.corners&&(z[1]=r(-1)));var A={pieceValue:p[1]-p[-1],pieceValueRatio:(p[1]-p[-1])/(p[1]+p[-1]+1),posValue:u[1]-u[-1],averageDistKing:v[1]/f[1]-v[-1]/f[-1],check:this.check?-o:0,endingKingFreedom:C[1]-C[-1],endingDistKing:T[1]-T[-1],distKingCorner:z[1]-z[-1]};t.castle&&(A.castle=(this.castled[1]?1:b[1]?0:g[1]/(h.castleablePiecesCount[1]+1))-(this.castled[-1]?1:b[-1]?0:g[-1]/(h.castleablePiecesCount[-1]+1))),t.evaluate&&t.evaluate.call(this,i,A,s);var P=i.mOptions.levelOptions;for(var E in A){var w=A[E],I=P[E+"Factor"]||0,R=w*I;a&&console.log(E,"=",w,"*",I,"=>",R),this.mEvaluation+=R}a&&console.log("Evaluation",this.mEvaluation)},Model.Board.cbGeneratePseudoLegalMoves=function(t){function e(e,a){var n=t.cbVar.promote;if(!n)return void r.push(a);var s=n.call(i,t,e,a);if(null!=s)if(0==s.length)r.push(a);else if(1==s.length)a.pr=s[0],r.push(a);else for(var o=0;o<s.length;o++){var h=s[o];r.push({f:a.f,t:a.t,c:a.c,pr:h,ept:a.ept,ep:a.ep,a:a.a})}}for(var i=this,r=[],a=t.cbVar,n=this.mWho,s=!a.castle||this.check||this.castled[n]?null:[],o=-1,h=this.pieces.length,c=0;c<h;c++){var p=this.pieces[c];if(!(p.p<0||p.s!=n)){var l=t.g.pTypes[p.t];l.isKing&&(p.m?s=null:o=p),s&&l.castle&&!p.m&&s.push(p);var v,f;v=l.graph[p.p],f=v.length;for(var u=0;u<f;u++)for(var g=v[u],b=!1,d=g.length,m=null,G=0;G<d;G++){var y=g[G],M=65535&y,k=this.board[M];if(!(k<0)||l.epCatch&&this.epTarget&&this.epTarget.p==M){if(!(524288&y)){var S;S=k<0?this.pieces[this.epTarget.i]:this.pieces[k],!(S.s!=p.s&&131072&y)||1048576&y&&!t.g.pTypes[S.t].isKing||2097152&y&&t.g.pTypes[S.t].isKing||e(p,{f:p.p,t:M,c:S.i,a:l.abbrev,ep:k<0});break}if(b){var S=this.pieces[k];S.s!=p.s&&e(p,{f:p.p,t:M,c:S.i,a:l.abbrev});break}b=!0}else 65536&y&&0==b&&e(p,{f:p.p,t:M,c:null,a:l.abbrev,ept:null!=m&&l.epTarget?m:void 0});m=M}}}if(s)for(var c=0;c<s.length;c++){var C=s[c],T=t.cbVar.castle[o.p+"/"+C.p];if(T){for(var z=!0,u=0;u<T.r.length;u++){var A=T.r[u];if(this.board[A]>=0&&A!=o.p&&A!=C.p){z=!1;break}}if(z){for(var P=!0,u=0;u<T.k.length;u++){var A=T.k[u];if(this.board[A]>=0&&A!=C.p&&A!=o.p||this.cbGetAttackers(t,A,n).length>0){P=!1;break}}P&&r.push({f:o.p,t:T.k[T.k.length-1],c:null,cg:C.p})}}}return r},Model.Board.cbStaticExchangeEval=function(t,e,i,r){var a=0,n=this.cbGetSmallestAttacker(t,e,i);if(n){var s=this.mWho;this.mWho=n.s;var o=this.cbQuickApply(t,{f:n.p,t:e,c:r.piece.i}),h=t.g.pTypes[r.piece.t].value;r.piece=n,a=Math.max(0,h-this.cbStaticExchangeEval(t,e,-i,r)),this.cbQuickUnapply(t,o),this.mWho=s}return a},Model.Board.cbGetSmallestAttacker=function(t,e,i){var r=this.cbGetAttackers(t,e,i);if(0==r.length)return null;for(var a=1/0,n=null,s=r.length,o=0;o<s;o++){var h=r[o],c=t.g.pTypes[h.t].value;c<a&&(a=c,n=h)}return n},Model.Board.cbCollectAttackers=function(t,e,i,r){for(var a in e){var n=e[a],s=this.board[a];if(s<0)this.cbCollectAttackers(t,n.e,i,r);else{var o=this.pieces[s];o.s==-t&&(n.t&&o.t in n.t||r&&n.tk&&o.t in n.tk)&&i.push(o)}}},Model.Board.cbCollectAttackersScreen=function(t,e,i,r,a){for(var n in e){var s=e[n],o=this.board[n];if(o<0)this.cbCollectAttackersScreen(t,s.e,i,r,a);else{var h=this.pieces[o];!a&&h.s==-t&&(s.t&&h.t in s.t||r&&s.tk&&h.t in s.tk)?i.push(h):a?a&&h.s==-t&&s.ts&&h.t in s.ts&&i.push(h):this.cbCollectAttackersScreen(t,s.e,i,r,!0)}}},Model.Board.cbGetAttackers=function(t,e,i,r){var a=[];return t.cbUseScreenCapture?this.cbCollectAttackersScreen(i,t.g.threatGraph[i][e],a,r,!1):this.cbCollectAttackers(i,t.g.threatGraph[i][e],a,r),a},Model.Board.GenerateMoves=function(t){var e=this.cbGeneratePseudoLegalMoves(t);this.mMoves=[];for(var i=!0,r=this.kings[this.mWho],a=e.length,n=0;n<a;n++){var s=e[n],o=this.cbQuickApply(t,s);if(!(this.cbGetAttackers(t,this.kings[this.mWho],this.mWho,!0).length>0)){var h=this.cbGetAttackers(t,this.kings[-this.mWho],-this.mWho,!0).length>0;s.ck=h,this.mMoves.push(s),s.f!=r&&(i=!1)}this.cbQuickUnapply(t,o)}if(0==this.mMoves.length)this.mFinished=!0,this.mWinner=t.cbOnStaleMate?t.cbOnStaleMate*this.mWho:JocGame.DRAW,this.check&&(this.mWinner=-this.mWho);else if(this.ending[this.mWho]){if(!i)for(var n=0;n<this.mMoves.length;n++)this.mMoves[n].ko=!1}else if(!this.ending[this.mWho]&&i&&!this.check)for(var n=0;n<this.mMoves.length;n++)this.mMoves[n].ko=!0},Model.Board.GetSignature=function(){return this.zSign},Model.Move.Init=function(t){for(var e in t)t.hasOwnProperty(e)&&(this[e]=t[e])},Model.Move.Equals=function(t){return this.f==t.f&&this.t==t.t&&this.pr==t.pr},Model.Move.CopyFrom=function(t){this.Init(t)},Model.Move.ToString=function(e){var i=this;switch(e=e||"natural"){case"natural":return function(){var e;if(void 0!==i.cg?e=t.castle[i.f+"/"+i.cg].n:(e=i.a||"",e+=t.geometry.PosName(i.f),null==i.c?e+="-":e+="x",e+=t.geometry.PosName(i.t)),void 0!==i.pr){var r=t.pieceTypes[i.pr];r&&r.abbrev&&r.abbrev.length>0&&!r.silentPromo&&(e+="="+r.abbrev)}return i.ck&&(e+="+"),e}();case"engine":return function(){var e=t.geometry.PosName(i.f)+t.geometry.PosName(i.t);if(void 0!=i.pr){var r=t.pieceTypes[i.pr];r&&r.abbrev&&r.abbrev.length>0&&!r.silentPromo&&(e+=r.abbrev)}return e}();default:return"??"}},Model.Board.CompactMoveString=function(e,i,r){"function"!=typeof i.ToString&&(i=e.CreateMove(i));var a=i.ToString(),n=/^([A-Z]?)([a-z])([1-9][0-9]*)([-x])([a-z])([1-9][0-9]*)(.*?)$/.exec(a);if(!n)return a;var s=n[7];if(r||(r={}),r.value||(r.value=[]),0==r.value.length){var o=this.mMoves;this.mMoves&&0!=this.mMoves.length||this.GenerateMoves(e);for(var h=0;h<this.mMoves.length;h++){var c=this.mMoves[h];"function"!=typeof c.ToString&&(c=e.CreateMove(c)),r.value.push({str:c.ToString(),move:c})}this.mMoves=o}var p=[];if(r.value.forEach(function(t){var e=/^([A-Z]?[a-z][1-9][0-9]*[-x][a-z][1-9][0-9]*)(.*?)$/.exec(t.str);e&&t.move.t==i.t&&(t.move.a||"")==n[1]&&e[2]==s&&p.push(t.move)}),1==p.length)return""==n[1]&&"x"==n[4]?n[2]+"x"+n[5]+n[6]+n[7]:n[1]+("x"==n[4]?"x":"")+n[5]+n[6]+n[7];if(t.geometry.CompactCrit)for(var l="",h=0;;h++){var v=t.geometry.CompactCrit(i.f,h);if(null==v)return a;l+=v;for(var f=[],u=0;u<p.length;u++){var g=p[u];t.geometry.CompactCrit(g.f,h)==v&&f.push(g)}if(console.assert(f.length>0),1==f.length)return n[1]+l+("x"==n[4]?"x":"")+n[5]+n[6]+n[7];p=f}return a},Model.Board.cbIntegrity=function(t){function e(t,e){t||console.error(e)}for(var i=this,r=0;r<this.board.length;r++){var a=this.board[r];if(a>=0){var n=i.pieces[a];e(void 0!==n,"no piece at pos"),e(n.p==r,"piece has different pos")}}for(var a=0;a<this.pieces.length;a++){var n=this.pieces[a];n.p>=0&&e(i.board[n.p]==a,"board index mismatch")}},Model.Board.ExportBoardState=function(t){return t.cbVar.geometry.ExportBoardState?t.cbVar.geometry.ExportBoardState(this,t.cbVar,t.mPlayedMoves.length):"not supported"},Model.Game.Import=function(e,i){var r,a=[],n={1:{},"-1":{}},s=null,o=0;if("pjn"==e){var h={status:!1,error:"parse"},c=i.split(" ");if(6!=c.length)return console.warn("FEN should have 6 parts"),h;var p=c[0].split("/"),l=t.geometry.fenHeight||t.geometry.height;if(p.length!=l)return console.warn("FEN board should have",l,"rows, got",p.length),h;var v={};for(var f in t.pieceTypes){var u=t.pieceTypes[f],g=u.fenAbbrev||u.abbrev||"X";v[g.toUpperCase()]={s:1,t:f},v[g.toLowerCase()]={s:-1,t:f}}var b=t.geometry.FenRowPos||function(e,i){return(t.geometry.height-1-e)*t.geometry.width+i};if(p.forEach(function(e,i){for(var r=0,n=0;n<e.length;n++){var s=e.substr(n,1),o=v[s];if(void 0!==o){var c=b(i,r);r++;for(var p={s:o.s,t:o.t,p:c},l=!0,f=t.pieceTypes[p.t].initial||[],u=0;u<f.length;u++){var g=f[u];g.s==p.s&&g.p==c&&(l=!1)}p.m=l,a.push(p)}else{if(isNaN(parseInt(s)))return console.warn("FEN invalid board spec",s),h;r+=parseInt(s)}}}),a.sort(function(t,e){return e.s-t.s}),"w"==c[1])r=1;else{if("b"!=c[1])return console.warn("FEN invalid turn spec",c[1]),h;r=-1}n[1].k=c[2].indexOf("K")>=0,n[1].q=c[2].indexOf("Q")>=0,n[-1].k=c[2].indexOf("k")>=0,n[-1].q=c[2].indexOf("q")>=0,s="-"==c[3]?null:c[3];var d=parseInt(c[4]);isNaN(d)||(o=d);var m={pieces:a,turn:r,castle:n,enPassant:s,noCaptCount:o};return t.importGame&&t.importGame.call(this,m,e,i),{status:!0,initial:m}}return{status:!1,error:"unsupported"}}}(),function(){Model.Game.cbBoardGeometryHex=function(t,e){function i(t,e){for(var i=r(t),s=a(t),o=i,h=s,c=0;c<3;c++)for(var p=Math.abs(e[c]),l=0==p?0:e[c]/p,g=0;g<p;g++)h%2==v?(1==c&&l<0&&o--,2==c&&l>0&&o--):(1==c&&l>0&&o++,2==c&&l<0&&o++),1!=c&&2!=c||(h+=l),0==c&&(o+=l);if(o<0||o>=u||h<0||h>=f)return null;var t=n(o,h);return t in d?t:null}function r(t){return t%u}function a(t){return Math.floor(t/u)}function n(t,e){return e*u+t}function s(t){return void 0!==e[t]?e[t]:String.fromCharCode("a".charCodeAt(0)+r(t))+(a(t)+1)}function o(t){if(void 0!==l[t])return l[t];var e=/^([a-z])([0-9]+)$/.exec(t);return e?n(e[1].charCodeAt(0)-"a".charCodeAt(0),parseInt(e[2])-1):-1}function h(t,e){return 0==e?String.fromCharCode("a".charCodeAt(0)+r(t)):1==e?a(t)+1:null}function c(){return G}function p(e,i){var r=t[t.length-1-i][2*e];return" "==r&&(r=t[t.length-1-i][2*e+1]||" "),r}var l={};if(e)for(y in e)l[e[y]]=y;else e={};for(var v,f=t.length,u=0,g=!1,b=0,d={},m=0;m<t.length;m++)t[m].length%2==1&&t[m],t[m].length>b&&(b=t[m].length);for(var m=0;m<t.length;m++)for(;t[m].length<b;)t[m]+=" ";t.forEach(function(t,e){" "!=t[0]&&(v=e%2);var i=Math.ceil(t.length/2);i>u&&(u=i)}),t.forEach(function(e,i){(t.length-1-i)%2==1-v&&(" "==e[e.length-1]&&" "==e[e.length-2]||(g=!0));for(var r=0;r<e.length;r+=2)if(" "!=e[r]||r+1<e.length&&" "!=e[r+1]){var a=i*u+r/2;d[a]=1}});var G={};for(var y in d)G[y]={},G[y][y]=0;for(var M=[[1,0,0],[0,1,0],[0,0,1],[-1,0,0],[0,-1,0],[0,0,-1]],k=!0;k;){k=!1;for(var y in d)M.forEach(function(t){var e=i(y,t);if(null!=e){1!=G[y][e]&&(G[y][e]=1,G[e][y]=1,k=!0);for(var r in d)r!=y&&(void 0===G[e][r]&&void 0!==G[y][r]?(G[e][r]=G[y][r]+1,G[r][e]=G[y][r]+1,k=!0):void 0!==G[e][r]&&void 0!==G[y][r]&&G[e][r]>G[y][r]+1&&(G[e][r]=G[y][r]+1,G[r][e]=G[y][r]+1,k=!0))}})}var S=0,C={};for(var y in d){var T=0;for(var z in d){var A=G[y][z];T+=A*A}T>S?(C={},C[y]=1,S=T):T==S&&(C[y]=1)}for(var P={},k=!0;k;){k=!1;for(var y in d)y in P||M.forEach(function(t){var e=i(y,t);null==e?P[y]=1:e in P&&(y in P&&!(P[y]>P[e]+1)||(P[y]=P[e]+1,k=!0))})}return{boardSize:u*f,width:u,height:f,C:r,R:a,POS:n,Graph:i,PosName:s,PosByName:o,CompactCrit:h,GetDistances:c,distEdge:P,corners:C,SHIFTMOD2:v,SHIFTRIGHT:g,CellType:p,confine:d}};var t=Model.Game.cbConstants,e=[[1,0,0],[0,1,0],[0,0,1],[-1,0,0],[0,-1,0],[0,0,-1]],i=[[1,1,0],[0,1,1],[-1,0,1],[-1,-1,0],[0,-1,-1],[1,0,-1]],r=[[2,1,0],[1,2,0],[0,2,1],[0,1,2],[-1,0,2],[-2,0,1],[-2,-1,0],[-1,-2,0],[0,-2,-1],[0,-1,-2],[1,0,-2],[2,0,-1]];Model.Game.cbGLKingGraph=function(t){return this.cbShortRangeGraph(t,i.concat(e),t.confine)},Model.Game.cbGLRookGraph=function(t){return this.cbLongRangeGraph(t,e,t.confine)},Model.Game.cbGLBishopGraph=function(t){return this.cbLongRangeGraph(t,i,t.confine)},Model.Game.cbGLQueenGraph=function(t){return this.cbLongRangeGraph(t,i.concat(e),t.confine)},Model.Game.cbGLKnightGraph=function(t){return this.cbShortRangeGraph(t,r,t.confine)},Model.Game.cbGLPawnGraph=function(e,i,r){for(var a=this.cbLongRangeGraph(e,[[i,0,0]],e.confine,t.FLAG_MOVE,r),n={1:[[0,1,0],[0,0,-1]],"-1":[[0,0,1],[0,-1,0]]},s=this.cbShortRangeGraph(e,n[i],e.confine,t.FLAG_CAPTURE),o=[],h=0;h<e.boardSize;h++)o[h]=a[h].concat(s[h]);return o},Model.Game.cbBRInitialPawnGraph=function(e,i){for(var r=this.cbLongRangeGraph(e,[[0,-i,0],[0,0,-i]],e.confine,t.FLAG_MOVE,2),a=this.cbShortRangeGraph(e,[[-i,-i,0],[i,0,-i],[0,-i,-i]],e.confine,t.FLAG_CAPTURE),n=[],s=0;s<e.boardSize;s++)n[s]=r[s].concat(a[s]);return n},Model.Game.cbDVInitialPawnGraph=function(e,i){for(var r=this.cbLongRangeGraph(e,[[0,-i,0],[0,0,-i]],e.confine,t.FLAG_MOVE,2),a=this.cbShortRangeGraph(e,[[-i,-i,0],[i,0,-i]],e.confine,t.FLAG_CAPTURE),n=[],s=0;s<e.boardSize;s++)n[s]=r[s].concat(a[s]);return n},Model.Game.cbBRPawnGraph=function(e,i){for(var r=this.cbShortRangeGraph(e,[[0,-i,0],[0,0,-i]],e.confine,t.FLAG_MOVE),a=this.cbShortRangeGraph(e,[[-i,-i,0],[i,0,-i]],e.confine,t.FLAG_CAPTURE),n=[],s=0;s<e.boardSize;s++)n[s]=r[s].concat(a[s]);return n},Model.Game.cbMCPawnGraph=function(e,i,r){for(var a=this.cbLongRangeGraph(e,[[i,0,0]],e.confine,t.FLAG_MOVE,r),n=this.cbShortRangeGraph(e,[[i,0,-i],[i,i,0]],e.confine,t.FLAG_CAPTURE),s=[],o=0;o<e.boardSize;o++)s[o]=a[o].concat(n[o]);return s}}(),function(){var t={2:"a1",13:"b1",23:"c1",34:"d1",44:"e1",55:"f1",66:"g1",78:"h1",89:"i1",101:"k1",112:"l1",3:"a2",14:"b2",24:"c2",35:"d2",45:"e2",56:"f2",67:"g2",79:"h2",90:"i2",102:"k2",113:"l2",4:"a3",15:"b3",25:"c3",36:"d3",46:"e3",57:"f3",68:"g3",80:"h3",91:"i3",103:"k3",114:"l3",5:"a4",16:"b4",26:"c4",37:"d4",47:"e4",58:"f4",69:"g4",81:"h4",92:"i4",104:"k4",115:"l4",6:"a5",17:"b5",27:"c5",38:"d5",48:"e5",59:"f5",70:"g5",82:"h5",93:"i5",105:"k5",116:"l5",7:"a6",18:"b6",28:"c6",39:"d6",49:"e6",60:"f6",71:"g6",83:"h6",94:"i6",106:"k6",117:"l6",19:"b7",29:"c7",40:"d7",50:"e7",61:"f7",72:"g7",84:"h7",95:"i7",107:"k7",30:"c8",41:"d8",51:"e8",62:"f8",73:"g8",85:"h8",96:"i8",42:"d9",52:"e9",63:"f9",74:"g9",86:"h9",53:"e10",64:"f10",75:"g10",65:"f11"},e=Model.Game.cbBoardGeometryHex(["     # + . # + .      ","    + . # + . # +     ","   . # + . # + . #    ","  # + . # + . # + .   "," + . # + . # + . # +  ",". # + . # + . # + . # "," + . # + . # + . # +  ","  # + . # + . # + .   ","   . # + . # + . #    ","    + . # + . # +     ","     # + . # + .      "],t),i={1:{13:1,24:1,36:1,47:1,59:1,69:1,80:1,90:1,101:1},"-1":{19:1,29:1,40:1,50:1,61:1,72:1,84:1,95:1,107:1}},r={1:{7:1,19:1,30:1,53:1,65:1,73:1,86:1,96:1,107:1,117:1},"-1":{2:1,13:1,23:1,34:1,44:1,55:1,66:1,78:1,89:1,101:1,112:1}},a={1:{},"-1":{}},n=e.GetDistances();["1","-1"].forEach(function(t){for(var i in e.confine){var s=1/0;for(var o in r[t]){var h=n[i][o];h<s&&(a[t][i]=h,s=h)}}}),Model.Game.cbDefine=function(){return{geometry:e,pieceTypes:{0:{name:"pawn-w",aspect:"pawn",graph:this.cbGLPawnGraph(e,1,1),value:1,abbrev:"",fenAbbrev:"P",epCatch:!0},1:{name:"ipawn-w",aspect:"pawn",graph:this.cbGLPawnGraph(e,1,2),value:1,abbrev:"",fenAbbrev:"P",initial:[{s:1,p:13},{s:1,p:24},{s:1,p:36},{s:1,p:47},{s:1,p:59},{s:1,p:69},{s:1,p:80},{s:1,p:90},{s:1,p:101}],epTarget:!0},2:{name:"pawn-b",aspect:"pawn",graph:this.cbGLPawnGraph(e,-1,1),value:1,abbrev:"",fenAbbrev:"P",epCatch:!0},3:{name:"ipawn-b",aspect:"pawn",graph:this.cbGLPawnGraph(e,-1,2),value:1,abbrev:"",fenAbbrev:"P",initial:[{s:-1,p:19},{s:-1,p:29},{s:-1,p:40},{s:-1,p:50},{s:-1,p:61},{s:-1,p:72},{s:-1,p:84},{s:-1,p:95},{s:-1,p:107}],epTarget:!0},4:{name:"knight",graph:this.cbGLKnightGraph(e),value:2.9,abbrev:"N",initial:[{s:1,p:34},{s:1,p:78},{s:-1,p:42},{s:-1,p:86}]},5:{name:"bishop",graph:this.cbGLBishopGraph(e),value:3.1,abbrev:"B",initial:[{s:1,p:55},{s:1,p:56},{s:1,p:57},{s:-1,p:65},{s:-1,p:64},{s:-1,p:63}]},6:{name:"rook",graph:this.cbGLRookGraph(e),value:5,abbrev:"R",initial:[{s:1,p:23},{s:1,p:89},{s:-1,p:30},{s:-1,p:96}],castle:!0},7:{name:"queen",graph:this.cbGLQueenGraph(e),value:9,abbrev:"Q",initial:[{s:1,p:44},{s:-1,p:53}]},8:{name:"king",isKing:!0,graph:this.cbGLKingGraph(e),abbrev:"K",initial:[{s:1,p:66},{s:-1,p:75}]}},promote:function(t,e,a){return 1!=e.t||a.t in i[1]?3!=e.t||a.t in i[-1]?0==e.t&&a.t in r[1]?[4,5,6,7]:2==e.t&&a.t in r[-1]?[4,5,6,7]:[]:[2]:[0]},evaluate:function(t,e,i){var r=i[1].count,n=i[-1].count;r[0]||r[1]||r[4]||r[5]||r[6]||r[7]||n[2]||n[3]||n[6]||n[7]||!(n[4]+n[5]<2||n[5]<2)||(this.mFinished=!0,this.mWinner=JocGame.DRAW),n[2]||n[3]||n[4]||n[5]||n[6]||n[7]||r[0]||r[1]||r[6]||r[7]||!(r[4]+r[5]<2||r[5]<2)||(this.mFinished=!0,this.mWinner=JocGame.DRAW),this.noCaptCount>=100&&(this.mFinished=!0,this.mWinner=JocGame.DRAW);var s,o=t.cbUseTypedArrays?new Int8Array(3):[0,0,0],h=i[1].byType[0];if(h){s=h.length;for(var c=0;c<s;c++){var p=a[1][h[c].p];p>0&&p<4&&o[p-1]++}}if(h=i[-1].byType[2]){s=h.length;for(var c=0;c<s;c++){var p=a[-1][h[c].p];p>0&&p<4&&o[p-1]--}}0!=o[0]&&(e.distPawnPromo1=o[0]),0!=o[1]&&(e.distPawnPromo2=o[1]),0!=o[2]&&(e.distPawnPromo3=o[2]);for(var l=0,v=4;v<=5;v++)for(var f=1;f>=-1;f-=2){var u=i[f].byType[v];if(u)for(var c=0;c<u.length;c++)u[c].m&&(l+=f)}0!=l&&(e.minorPiecesMoved=l)}}}}();

/***/ }),

/***/ "nR3a":
/***/ (function(module, exports) {

exports.model=Model={Game:{},Board:{},Move:{}},function(){var t;Model.Game.cbConstants={MASK:65535,FLAG_MOVE:65536,FLAG_CAPTURE:131072,FLAG_STOP:262144,FLAG_SCREEN_CAPTURE:524288,FLAG_CAPTURE_KING:1048576,FLAG_CAPTURE_NO_KING:2097152};var e="undefined"!=typeof Int32Array;Model.Game.cbUseTypedArrays=e,Model.Game.cbTypedArray=function(t){if(e){var r=new Int32Array(t.length);return r.set(t),r}for(var i=[],a=t.length,n=0;n<a;n++)i.push(t[n]);return i},Model.Game.cbShortRangeGraph=function(t,e,r,i){var a=this;void 0===i&&(i=196608);for(var n={},s=0;s<t.boardSize;s++)n[s]=[],(!r||s in r)&&e.forEach(function(e){var o=t.Graph(s,e);null!=o&&(!r||o in r)&&n[s].push(a.cbTypedArray([o|i]))});return n},Model.Game.cbLongRangeGraph=function(t,e,r,i,a){var n=this;void 0!==i&&null!=i||(i=196608),a||(a=1/0);for(var s={},o=0;o<t.boardSize;o++)s[o]=[],(!r||o in r)&&e.forEach(function(e){for(var h=[],c=t.Graph(o,e),p=0;null!=c&&(!r||c in r)&&(h.push(c|i),++p!=a);)c=t.Graph(c,e);h.length>0&&s[o].push(n.cbTypedArray(h))});return s},Model.Game.cbNullGraph=function(t){for(var e={},r=0;r<t.boardSize;r++)e[r]=[];return e},Model.Game.cbAuthorGraph=function(t){for(var e={},r=0;r<t.boardSize;r++){e[r]=[];for(var i=0;i<t.boardSize;i++)e[r].push([2293760|i])}return e},Model.Game.cbMergeGraphs=function(t){for(var e=[],r=0;r<t.boardSize;r++){e[r]=[];for(var i=1;i<arguments.length;i++)e[r]=e[r].concat(arguments[i][r])}return e},Model.Game.cbGetThreatGraph=function(){function t(e,r){for(var i in s){var a=s[i];if(!(a.p.length<r.length+1)){for(var n=!0,o=0;o<r.length;o++)if(r[o]!=a.p[o]){n=!1;break}if(n){var h=a.p[r.length],c=e[h];void 0===c&&(c={e:{}},e[h]=c),a.p.length==r.length+1&&(c.t=a.t,c.ts=a.ts,c.tk=a.tk,delete s[i]),r.push(h),t(c.e,r),r.pop()}}}}var e=this;this.cbUseScreenCapture=!1,this.cbUseCaptureKing=!1,this.cbUseCaptureNoKing=!1;for(var r={1:[],"-1":[]},i=[],a=0;a<this.g.boardSize;a++)this.g.pTypes.forEach(function(t,r){t.graph[a].forEach(function(t){for(var n=[],s=0;s<t.length;s++){var o=t[s];1048576&o?(e.cbUseCaptureKing=!0,n.unshift({d:65535&o,a:a,tk:r})):2097152&o?(e.cbUseCaptureNoKing=!0,n.unshift({d:65535&o,a:a,tnk:r})):131072&o?n.unshift({d:65535&o,a:a,t:r}):262144&o?n.unshift({d:65535&o,a:a}):524288&o&&(e.cbUseScreenCapture=!0,n.unshift({d:65535&o,a:a,ts:r}))}n.length>0&&i.push(n)})});var n={};i.forEach(function(t){t.forEach(function(e,r){var i=n[e.d];void 0===i&&(i={},n[e.d]=i);for(var a=[],s=r+1;s<t.length;s++)a.push(t[s].d);a.push(e.a);var o=a.join(","),h=i[o];void 0===h&&(h={p:a,t:{},ts:{},tk:{}},i[o]=h),void 0!==e.t?h.t[e.t]=!0:void 0!==e.tk?h.tk[e.tk]=!0:void 0!==e.ts&&(h.ts[e.ts]=!0)})});for(var a=0;a<e.g.boardSize;a++){var s=n[a],o={};t(o,[]),r[1][a]=o,r[-1][a]=o}return r},Model.Game.InitGame=function(){var e=this;this.cbVar=t=this.cbDefine(),this.g.boardSize=this.cbVar.geometry.boardSize,this.g.pTypes=this.cbGetPieceTypes(),this.g.threatGraph=this.cbGetThreatGraph(),this.g.distGraph=this.cbVar.geometry.GetDistances(),this.cbPiecesCount=0,this.g.castleablePiecesCount={1:0,"-1":0};for(var r in t.pieceTypes){var i=t.pieceTypes[r];if(i.castle){(i.initial||[]).forEach(function(t){e.g.castleablePiecesCount[t.s]++})}i.initial&&(this.cbPiecesCount+=i.initial.length)}for(var a=[],r=0;r<this.cbPiecesCount;r++)a.push(r);var n=Object.keys(t.pieceTypes);this.zobrist=new JocGame.Zobrist({board:{type:"array",size:this.cbVar.geometry.boardSize,values:a},who:{values:["1","-1"]},type:{type:"array",size:this.cbPiecesCount,values:n}})},Model.Game.cbGetPieceTypes=function(){for(var t=[],e={},r=0;r<this.cbVar.geometry.boardSize;r++)e[r]=[];for(var i in this.cbVar.pieceTypes){var a=this.cbVar.pieceTypes[i];t[i]={graph:a.graph||e,abbrev:a.abbrev||"",value:a.isKing?100:a.value||1,isKing:!!a.isKing,castle:!!a.castle,epTarget:!!a.epTarget,epCatch:!!a.epCatch}}return t},Model.Board.Init=function(t){this.zSign=0},Model.Board.InitialPosition=function(r){var i=this;this.board=e?new Int16Array(r.g.boardSize):[];for(var a=0;a<r.g.boardSize;a++)this.board[a]=-1;if(this.kings={},this.pieces=[],this.ending={1:!1,"-1":!1},this.lastMove=null,r.cbVar.castle&&(this.castled={1:!1,"-1":!1}),this.zSign=r.zobrist.update(0,"who",-1),this.noCaptCount=0,this.mWho=1,r.mInitial)this.mWho=r.mInitial.turn||1,r.mInitial.pieces.forEach(function(t){var e={};for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);i.pieces.push(e)}),r.mInitial.lastMove&&(this.lastMove={f:r.mInitial.lastMove.f,t:r.mInitial.lastMove.t}),void 0!==r.mInitial.noCaptCount&&(this.noCaptCount=r.mInitial.noCaptCount),r.cbVar.castle&&r.mInitial.castle&&(this.castled={1:{k:!!r.mInitial.castle[1]&&!!r.mInitial.castle[1].k,q:!!r.mInitial.castle[1]&&!!r.mInitial.castle[1].q},"-1":{k:!!r.mInitial.castle[-1]&&!!r.mInitial.castle[-1].k,q:!!r.mInitial.castle[-1]&&!!r.mInitial.castle[-1].q}});else for(var n in r.cbVar.pieceTypes)for(var s=r.cbVar.pieceTypes[n],o=s.initial||[],h=0;h<o.length;h++){var c=o[h],p={s:c.s,t:parseInt(n),p:c.p,m:!1};this.pieces.push(p)}if(this.pieces.sort(function(t,e){if(t.s!=e.s)return e.s-t.s;var i=r.cbVar.pieceTypes[t.t].value||100,a=r.cbVar.pieceTypes[e.t].value||100;return i!=a?i-a:t.p-e.p}),this.pieces.forEach(function(t,e){t.i=e,i.board[t.p]=e,r.g.pTypes[t.t].isKing&&(i.kings[t.s]=t.p),i.zSign=r.zobrist.update(i.zSign,"board",e,t.p),i.zSign=r.zobrist.update(i.zSign,"type",t.t,e)}),r.mInitial&&r.mInitial.enPassant){var a=t.geometry.PosByName(r.mInitial.enPassant);if(a>=0){var l,u=t.geometry.C(a),v=t.geometry.R(a);l=1==r.mInitial.turn?t.geometry.POS(u,v-1):t.geometry.POS(u,v+1),this.epTarget={p:a,i:this.board[l]}}}},Model.Board.CopyFrom=function(t){if(e)this.board=new Int16Array(t.board.length),this.board.set(t.board);else{this.board=[];for(var r=t.board,i=r.length,a=0;a<i;a++)this.board.push(r[a])}this.pieces=[];for(var n=t.pieces.length,a=0;a<n;a++){var s=t.pieces[a];this.pieces.push({s:s.s,p:s.p,t:s.t,i:s.i,m:s.m})}this.kings={1:t.kings[1],"-1":t.kings[-1]},this.check=t.check,t.lastMove?this.lastMove={f:t.lastMove.f,t:t.lastMove.t,c:t.lastMove.c}:this.lastMove=null,this.ending={1:t.ending[1],"-1":t.ending[-1]},void 0!==t.castled&&(this.castled={1:t.castled[1],"-1":t.castled[-1]}),this.noCaptCount=t.noCaptCount,t.epTarget?this.epTarget={p:t.epTarget.p,i:t.epTarget.i}:this.epTarget=null,this.mWho=t.mWho,this.zSign=t.zSign},Model.Board.cbApplyCastle=function(t,e,r){var i=t.cbVar.castle[e.f+"/"+e.cg],a=i.r[i.r.length-1],n=this.pieces[this.board[e.cg]],s=i.k[i.k.length-1],o=this.pieces[this.board[e.f]];return r&&(this.zSign=t.zobrist.update(this.zSign,"board",n.i,e.cg),this.zSign=t.zobrist.update(this.zSign,"board",n.i,a),this.zSign=t.zobrist.update(this.zSign,"board",o.i,e.f),this.zSign=t.zobrist.update(this.zSign,"board",o.i,s)),n.p=a,n.m=!0,this.board[e.cg]=-1,o.p=s,o.m=!0,this.board[e.f]=-1,this.board[a]=n.i,this.board[s]=o.i,this.castled[n.s]=!0,this.kings[o.s]=s,[{i:n.i,f:a,t:-1},{i:o.i,f:s,t:e.f,kp:e.f,who:o.s,m:!1},{i:n.i,f:-1,t:e.cg,m:!1,cg:!1}]},Model.Board.cbQuickApply=function(t,e){if(void 0!==e.cg)return this.cbApplyCastle(t,e,!1);var r=[],i=this.board[e.f],a=this.pieces[i];if(null!=e.c){r.unshift({i:e.c,f:-1,t:this.pieces[e.c].p});var n=this.pieces[e.c];this.board[n.p]=-1,n.p=-1}var s=this.kings[a.s];return t.g.pTypes[a.t].isKing&&(this.kings[a.s]=e.t),r.unshift({i:i,f:e.t,t:e.f,kp:s,who:a.s,ty:a.t}),a.p=e.t,void 0!==e.pr&&(a.t=e.pr),this.board[e.f]=-1,this.board[e.t]=i,r},Model.Board.cbQuickUnapply=function(t,e){for(var r=0;r<e.length;r++){var i=e[r],a=this.pieces[i.i];i.f>=0&&(a.p=-1,this.board[i.f]=-1),i.t>=0&&(a.p=i.t,this.board[i.t]=i.i),void 0!==i.m&&(a.m=i.m),void 0!==i.kp&&(this.kings[i.who]=i.kp),void 0!=i.ty&&(a.t=i.ty),void 0!=i.cg&&(this.castled[a.s]=i.cg)}},Model.Board.ApplyMove=function(t,e){var r=this.pieces[this.board[e.f]];if(void 0!==e.cg)this.cbApplyCastle(t,e,!0);else{if(this.zSign=t.zobrist.update(this.zSign,"board",r.i,e.f),this.board[r.p]=-1,void 0!==e.pr&&(this.zSign=t.zobrist.update(this.zSign,"type",r.t,r.i),r.t=e.pr,this.zSign=t.zobrist.update(this.zSign,"type",r.t,r.i)),null!=e.c){var i=this.pieces[e.c];this.zSign=t.zobrist.update(this.zSign,"board",i.i,i.p),this.board[i.p]=-1,i.p=-1,i.m=!0,this.noCaptCount=0}else this.noCaptCount++;r.p=e.t,r.m=!0,this.board[e.t]=r.i,this.zSign=t.zobrist.update(this.zSign,"board",r.i,e.t),t.g.pTypes[r.t].isKing&&(this.kings[r.s]=e.t)}this.check=!!e.ck,this.lastMove={f:e.f,t:e.t,c:e.c},void 0!==e.ko&&(this.ending[r.s]=e.ko),void 0!==e.ept?this.epTarget={p:e.ept,i:r.i}:this.epTarget=null,this.zSign=t.zobrist.update(this.zSign,"who",-this.mWho),this.zSign=t.zobrist.update(this.zSign,"who",this.mWho)},Model.Board.Evaluate=function(r){function i(e){var r=1/0;for(var i in t.geometry.corners)r=Math.min(r,h.distGraph[n.kings[e]][i]);return r-Math.sqrt(h.boardSize)}var a="debug"==arguments[3],n=this;this.mEvaluation=0;var s,o=this.mWho,h=r.g;if(e)s={1:{count:new Uint8Array(h.pTypes.length),byType:{}},"-1":{count:new Uint8Array(h.pTypes.length),byType:{}}};else{s={1:{count:[],byType:{}},"-1":{count:[],byType:{}}};for(var c=0;c<h.pTypes.length;c++)s[1].count[c]=s[-1].count[c]=0}if(r.mOptions.preventRepeat&&r.GetRepeatOccurence(this)>2)return this.mFinished=!0,void(this.mWinner=r.cbOnPerpetual?o*r.cbOnPerpetual:JocGame.DRAW);for(var p={1:0,"-1":0},l={1:h.distGraph[this.kings[-1]],"-1":h.distGraph[this.kings[1]]},u={1:0,"-1":0},v={1:0,"-1":0},b={1:0,"-1":0},f={1:0,"-1":0},d={1:!1,"-1":!1},g=this.pieces,m=g.length,c=0;c<m;c++){var G=g[c];if(G.p>=0){var y=G.s,M=h.pTypes[G.t];M.isKing?d[y]=G.m:p[y]+=M.value,M.castle&&!G.m&&f[y]++,v[y]++,u[y]+=l[y][G.p],b[y]+=t.geometry.distEdge[G.p];var C=s[y];C.count[G.t]++;var S=C.byType;void 0===S[G.t]?S[G.t]=[G]:S[G.t].push(G)}}if(this.lastMove&&null!=this.lastMove.c){var G=this.pieces[this.board[this.lastMove.t]];p[-G.s]+=this.cbStaticExchangeEval(r,G.p,G.s,{piece:G})}var k={1:0,"-1":0},A={1:0,"-1":0},T={1:0,"-1":0};this.ending[1]&&(A[1]=(u[1]-Math.sqrt(h.boardSize))/v[1],t.geometry.corners&&(T[1]=i(1))),this.ending[-1]&&(A[-1]=(u[-1]-Math.sqrt(h.boardSize))/v[-1],t.geometry.corners&&(T[1]=i(-1)));var z={pieceValue:p[1]-p[-1],pieceValueRatio:(p[1]-p[-1])/(p[1]+p[-1]+1),posValue:b[1]-b[-1],averageDistKing:u[1]/v[1]-u[-1]/v[-1],check:this.check?-o:0,endingKingFreedom:k[1]-k[-1],endingDistKing:A[1]-A[-1],distKingCorner:T[1]-T[-1]};t.castle&&(z.castle=(this.castled[1]?1:d[1]?0:f[1]/(h.castleablePiecesCount[1]+1))-(this.castled[-1]?1:d[-1]?0:f[-1]/(h.castleablePiecesCount[-1]+1))),t.evaluate&&t.evaluate.call(this,r,z,s);var P=r.mOptions.levelOptions;for(var E in z){var w=z[E],R=P[E+"Factor"]||0,I=w*R;a&&console.log(E,"=",w,"*",R,"=>",I),this.mEvaluation+=I}a&&console.log("Evaluation",this.mEvaluation)},Model.Board.cbGeneratePseudoLegalMoves=function(t){function e(e,a){var n=t.cbVar.promote;if(!n)return void i.push(a);var s=n.call(r,t,e,a);if(null!=s)if(0==s.length)i.push(a);else if(1==s.length)a.pr=s[0],i.push(a);else for(var o=0;o<s.length;o++){var h=s[o];i.push({f:a.f,t:a.t,c:a.c,pr:h,ept:a.ept,ep:a.ep,a:a.a})}}for(var r=this,i=[],a=t.cbVar,n=this.mWho,s=!a.castle||this.check||this.castled[n]?null:[],o=-1,h=this.pieces.length,c=0;c<h;c++){var p=this.pieces[c];if(!(p.p<0||p.s!=n)){var l=t.g.pTypes[p.t];l.isKing&&(p.m?s=null:o=p),s&&l.castle&&!p.m&&s.push(p);var u,v;u=l.graph[p.p],v=u.length;for(var b=0;b<v;b++)for(var f=u[b],d=!1,g=f.length,m=null,G=0;G<g;G++){var y=f[G],M=65535&y,C=this.board[M];if(!(C<0)||l.epCatch&&this.epTarget&&this.epTarget.p==M){if(!(524288&y)){var S;S=C<0?this.pieces[this.epTarget.i]:this.pieces[C],!(S.s!=p.s&&131072&y)||1048576&y&&!t.g.pTypes[S.t].isKing||2097152&y&&t.g.pTypes[S.t].isKing||e(p,{f:p.p,t:M,c:S.i,a:l.abbrev,ep:C<0});break}if(d){var S=this.pieces[C];S.s!=p.s&&e(p,{f:p.p,t:M,c:S.i,a:l.abbrev});break}d=!0}else 65536&y&&0==d&&e(p,{f:p.p,t:M,c:null,a:l.abbrev,ept:null!=m&&l.epTarget?m:void 0});m=M}}}if(s)for(var c=0;c<s.length;c++){var k=s[c],A=t.cbVar.castle[o.p+"/"+k.p];if(A){for(var T=!0,b=0;b<A.r.length;b++){var z=A.r[b];if(this.board[z]>=0&&z!=o.p&&z!=k.p){T=!1;break}}if(T){for(var P=!0,b=0;b<A.k.length;b++){var z=A.k[b];if(this.board[z]>=0&&z!=k.p&&z!=o.p||this.cbGetAttackers(t,z,n).length>0){P=!1;break}}P&&i.push({f:o.p,t:A.k[A.k.length-1],c:null,cg:k.p})}}}return i},Model.Board.cbStaticExchangeEval=function(t,e,r,i){var a=0,n=this.cbGetSmallestAttacker(t,e,r);if(n){var s=this.mWho;this.mWho=n.s;var o=this.cbQuickApply(t,{f:n.p,t:e,c:i.piece.i}),h=t.g.pTypes[i.piece.t].value;i.piece=n,a=Math.max(0,h-this.cbStaticExchangeEval(t,e,-r,i)),this.cbQuickUnapply(t,o),this.mWho=s}return a},Model.Board.cbGetSmallestAttacker=function(t,e,r){var i=this.cbGetAttackers(t,e,r);if(0==i.length)return null;for(var a=1/0,n=null,s=i.length,o=0;o<s;o++){var h=i[o],c=t.g.pTypes[h.t].value;c<a&&(a=c,n=h)}return n},Model.Board.cbCollectAttackers=function(t,e,r,i){for(var a in e){var n=e[a],s=this.board[a];if(s<0)this.cbCollectAttackers(t,n.e,r,i);else{var o=this.pieces[s];o.s==-t&&(n.t&&o.t in n.t||i&&n.tk&&o.t in n.tk)&&r.push(o)}}},Model.Board.cbCollectAttackersScreen=function(t,e,r,i,a){for(var n in e){var s=e[n],o=this.board[n];if(o<0)this.cbCollectAttackersScreen(t,s.e,r,i,a);else{var h=this.pieces[o];!a&&h.s==-t&&(s.t&&h.t in s.t||i&&s.tk&&h.t in s.tk)?r.push(h):a?a&&h.s==-t&&s.ts&&h.t in s.ts&&r.push(h):this.cbCollectAttackersScreen(t,s.e,r,i,!0)}}},Model.Board.cbGetAttackers=function(t,e,r,i){var a=[];return t.cbUseScreenCapture?this.cbCollectAttackersScreen(r,t.g.threatGraph[r][e],a,i,!1):this.cbCollectAttackers(r,t.g.threatGraph[r][e],a,i),a},Model.Board.GenerateMoves=function(t){var e=this.cbGeneratePseudoLegalMoves(t);this.mMoves=[];for(var r=!0,i=this.kings[this.mWho],a=e.length,n=0;n<a;n++){var s=e[n],o=this.cbQuickApply(t,s);if(!(this.cbGetAttackers(t,this.kings[this.mWho],this.mWho,!0).length>0)){var h=this.cbGetAttackers(t,this.kings[-this.mWho],-this.mWho,!0).length>0;s.ck=h,this.mMoves.push(s),s.f!=i&&(r=!1)}this.cbQuickUnapply(t,o)}if(0==this.mMoves.length)this.mFinished=!0,this.mWinner=t.cbOnStaleMate?t.cbOnStaleMate*this.mWho:JocGame.DRAW,this.check&&(this.mWinner=-this.mWho);else if(this.ending[this.mWho]){if(!r)for(var n=0;n<this.mMoves.length;n++)this.mMoves[n].ko=!1}else if(!this.ending[this.mWho]&&r&&!this.check)for(var n=0;n<this.mMoves.length;n++)this.mMoves[n].ko=!0},Model.Board.GetSignature=function(){return this.zSign},Model.Move.Init=function(t){for(var e in t)t.hasOwnProperty(e)&&(this[e]=t[e])},Model.Move.Equals=function(t){return this.f==t.f&&this.t==t.t&&this.pr==t.pr},Model.Move.CopyFrom=function(t){this.Init(t)},Model.Move.ToString=function(e){var r=this;switch(e=e||"natural"){case"natural":return function(){var e;if(void 0!==r.cg?e=t.castle[r.f+"/"+r.cg].n:(e=r.a||"",e+=t.geometry.PosName(r.f),null==r.c?e+="-":e+="x",e+=t.geometry.PosName(r.t)),void 0!==r.pr){var i=t.pieceTypes[r.pr];i&&i.abbrev&&i.abbrev.length>0&&!i.silentPromo&&(e+="="+i.abbrev)}return r.ck&&(e+="+"),e}();case"engine":return function(){var e=t.geometry.PosName(r.f)+t.geometry.PosName(r.t);if(void 0!=r.pr){var i=t.pieceTypes[r.pr];i&&i.abbrev&&i.abbrev.length>0&&!i.silentPromo&&(e+=i.abbrev)}return e}();default:return"??"}},Model.Board.CompactMoveString=function(e,r,i){"function"!=typeof r.ToString&&(r=e.CreateMove(r));var a=r.ToString(),n=/^([A-Z]?)([a-z])([1-9][0-9]*)([-x])([a-z])([1-9][0-9]*)(.*?)$/.exec(a);if(!n)return a;var s=n[7];if(i||(i={}),i.value||(i.value=[]),0==i.value.length){var o=this.mMoves;this.mMoves&&0!=this.mMoves.length||this.GenerateMoves(e);for(var h=0;h<this.mMoves.length;h++){var c=this.mMoves[h];"function"!=typeof c.ToString&&(c=e.CreateMove(c)),i.value.push({str:c.ToString(),move:c})}this.mMoves=o}var p=[];if(i.value.forEach(function(t){var e=/^([A-Z]?[a-z][1-9][0-9]*[-x][a-z][1-9][0-9]*)(.*?)$/.exec(t.str);e&&t.move.t==r.t&&(t.move.a||"")==n[1]&&e[2]==s&&p.push(t.move)}),1==p.length)return""==n[1]&&"x"==n[4]?n[2]+"x"+n[5]+n[6]+n[7]:n[1]+("x"==n[4]?"x":"")+n[5]+n[6]+n[7];if(t.geometry.CompactCrit)for(var l="",h=0;;h++){var u=t.geometry.CompactCrit(r.f,h);if(null==u)return a;l+=u;for(var v=[],b=0;b<p.length;b++){var f=p[b];t.geometry.CompactCrit(f.f,h)==u&&v.push(f)}if(console.assert(v.length>0),1==v.length)return n[1]+l+("x"==n[4]?"x":"")+n[5]+n[6]+n[7];p=v}return a},Model.Board.cbIntegrity=function(t){function e(t,e){t||console.error(e)}for(var r=this,i=0;i<this.board.length;i++){var a=this.board[i];if(a>=0){var n=r.pieces[a];e(void 0!==n,"no piece at pos"),e(n.p==i,"piece has different pos")}}for(var a=0;a<this.pieces.length;a++){var n=this.pieces[a];n.p>=0&&e(r.board[n.p]==a,"board index mismatch")}},Model.Board.ExportBoardState=function(t){return t.cbVar.geometry.ExportBoardState?t.cbVar.geometry.ExportBoardState(this,t.cbVar,t.mPlayedMoves.length):"not supported"},Model.Game.Import=function(e,r){var i,a=[],n={1:{},"-1":{}},s=null,o=0;if("pjn"==e){var h={status:!1,error:"parse"},c=r.split(" ");if(6!=c.length)return console.warn("FEN should have 6 parts"),h;var p=c[0].split("/"),l=t.geometry.fenHeight||t.geometry.height;if(p.length!=l)return console.warn("FEN board should have",l,"rows, got",p.length),h;var u={};for(var v in t.pieceTypes){var b=t.pieceTypes[v],f=b.fenAbbrev||b.abbrev||"X";u[f.toUpperCase()]={s:1,t:v},u[f.toLowerCase()]={s:-1,t:v}}var d=t.geometry.FenRowPos||function(e,r){return(t.geometry.height-1-e)*t.geometry.width+r};if(p.forEach(function(e,r){for(var i=0,n=0;n<e.length;n++){var s=e.substr(n,1),o=u[s];if(void 0!==o){var c=d(r,i);i++;for(var p={s:o.s,t:o.t,p:c},l=!0,v=t.pieceTypes[p.t].initial||[],b=0;b<v.length;b++){var f=v[b];f.s==p.s&&f.p==c&&(l=!1)}p.m=l,a.push(p)}else{if(isNaN(parseInt(s)))return console.warn("FEN invalid board spec",s),h;i+=parseInt(s)}}}),a.sort(function(t,e){return e.s-t.s}),"w"==c[1])i=1;else{if("b"!=c[1])return console.warn("FEN invalid turn spec",c[1]),h;i=-1}n[1].k=c[2].indexOf("K")>=0,n[1].q=c[2].indexOf("Q")>=0,n[-1].k=c[2].indexOf("k")>=0,n[-1].q=c[2].indexOf("q")>=0,s="-"==c[3]?null:c[3];var g=parseInt(c[4]);isNaN(g)||(o=g);var m={pieces:a,turn:i,castle:n,enPassant:s,noCaptCount:o};return t.importGame&&t.importGame.call(this,m,e,r),{status:!0,initial:m}}return{status:!1,error:"unsupported"}}}(),function(){Model.Game.cbBoardGeometryGrid=function(t,e){function r(e){return e%t}function i(e){return Math.floor(e/t)}function a(e,r){return r*t+e}function n(n,s){var o=r(n),h=i(n),c=o+s[0],p=h+s[1];return c<0||c>=t||p<0||p>=e?null:a(c,p)}function s(t){return String.fromCharCode("a".charCodeAt(0)+r(t))+(i(t)+1)}function o(t){var e=/^([a-z])([0-9]+)$/.exec(t);return e?a(e[1].charCodeAt(0)-"a".charCodeAt(0),parseInt(e[2])-1):-1}function h(t,e){return 0==e?String.fromCharCode("a".charCodeAt(0)+r(t)):1==e?i(t)+1:null}function c(){for(var a=[],n=0;n<t*e;n++){var s=[];a.push(s);for(var o=0;o<t*e;o++){var h=i(n),c=r(n),p=i(o),l=r(o);s.push(Math.max(Math.abs(h-p),Math.abs(c-l)))}}return a}function p(r,i,n){for(var o=[],h=e-1;h>=0;h--){for(var c="",p=0,l=0;l<t;l++){var u=r.board[a(l,h)];if(u<0)p++;else{p>0&&(c+=p,p=0);var v=r.pieces[u],b=i.pieceTypes[v.t].fenAbbrev||i.pieceTypes[v.t].abbrev||"?";v.s==-1?c+=b.toLowerCase():c+=b.toUpperCase()}}p&&(c+=p),o.push(c)}var f=o.join("/");f+=" ",1==r.mWho?f+="w":f+="b",f+=" ";var d="";return r.castled&&(r.castled[1]===!1?d+="KQ":(r.castled[1].k&&(d+="K"),r.castled[1].q&&(d+="Q")),r.castled[-1]===!1?d+="kq":(r.castled[-1].k&&(d+="k"),r.castled[-1].q&&(d+="q"))),0==d.length&&(d="-"),f+=d,f+=" ",r.epTarget?f+=s(r.epTarget.p):f+="-",f+=" ",f+=r.noCaptCount,f+=" ",f+=Math.floor(n/2)+1}return{boardSize:t*e,width:t,height:e,C:r,R:i,POS:a,Graph:n,PosName:s,PosByName:o,CompactCrit:h,GetDistances:c,distEdge:function(){for(var a=[],n=0;n<t*e;n++){var s=r(n),o=i(n);a[n]=Math.min(s,Math.abs(t-s-1),o,Math.abs(e-o-1))}return a}(),corners:function(){var r={};return r[a(0,0)]=1,r[a(0,e-1)]=1,r[a(t-1,0)]=1,r[a(t-1,e-1)]=1,r}(),ExportBoardState:p}},Model.Game.cbPawnGraph=function(t,e,r){for(var i=this,a={},n=0;n<t.boardSize;n++)if(!r||n in r){var s=[],o=t.Graph(n,[0,e]);null!=o&&(!r||o in r)&&s.push(i.cbTypedArray([o|i.cbConstants.FLAG_MOVE])),[-1,1].forEach(function(a){var o=t.Graph(n,[a,e]);null!=o&&(!r||o in r)&&s.push(i.cbTypedArray([o|i.cbConstants.FLAG_CAPTURE]))}),a[n]=s}else a[n]=[];return a},Model.Game.cbInitialPawnGraph=function(t,e,r){for(var i=this,a={},n=0;n<t.boardSize;n++)if(!r||n in r){var s=[],o=t.Graph(n,[0,e]);if(null!=o&&(!r||o in r)){var h=[o|i.cbConstants.FLAG_MOVE],c=t.Graph(o,[0,e]);null!=c&&(!r||c in r)&&h.push(c|i.cbConstants.FLAG_MOVE),s.push(i.cbTypedArray(h))}[-1,1].forEach(function(a){var o=t.Graph(n,[a,e]);null!=o&&(!r||o in r)&&s.push(i.cbTypedArray([o|i.cbConstants.FLAG_CAPTURE]))}),a[n]=s}else a[n]=[];return a},Model.Game.cbKingGraph=function(t,e){return this.cbShortRangeGraph(t,[[-1,-1],[-1,0],[-1,1],[0,-1],[0,1],[1,-1],[1,0],[1,1]],e)},Model.Game.cbKnightGraph=function(t,e){return this.cbShortRangeGraph(t,[[2,-1],[2,1],[-2,-1],[-2,1],[-1,2],[-1,-2],[1,2],[1,-2]],e)},Model.Game.cbHorseGraph=function(t){for(var e=this,r={},i=0;i<t.boardSize;i++)r[i]=[],[[1,0,2,-1],[1,0,2,1],[-1,0,-2,-1],[-1,0,-2,1],[0,1,-1,2],[0,-1,-1,-2],[0,1,1,2],[0,-1,1,-2]].forEach(function(a){var n=t.Graph(i,[a[0],a[1]]);if(null!=n){var s=t.Graph(i,[a[2],a[3]]);null!=s&&r[i].push(e.cbTypedArray([n|e.cbConstants.FLAG_STOP,s|e.cbConstants.FLAG_MOVE|e.cbConstants.FLAG_CAPTURE]))}});return r},Model.Game.cbRookGraph=function(t,e){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0]],e)},Model.Game.cbBishopGraph=function(t,e){return this.cbLongRangeGraph(t,[[1,-1],[1,1],[-1,1],[-1,-1]],e)},Model.Game.cbQueenGraph=function(t,e){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0],[1,-1],[1,1],[-1,1],[-1,-1]],e)},Model.Game.cbXQGeneralGraph=function(t,e){for(var r=this,i={},a=0;a<t.boardSize;a++)i[a]=[],[[-1,0,!1],[0,-1,!0],[0,1,!0],[1,0,!1]].forEach(function(n){var s=[],o=t.Graph(a,n);if(null!=o&&((!e||o in e)&&s.push(o|r.cbConstants.FLAG_MOVE|r.cbConstants.FLAG_CAPTURE),n[2]))for(var h=t.Graph(o,n);null!=h;)!e||h in e?s.push(h|r.cbConstants.FLAG_CAPTURE|r.cbConstants.FLAG_CAPTURE_KING):s.push(h|r.cbConstants.FLAG_STOP),h=t.Graph(h,n);s.length>0&&i[a].push(r.cbTypedArray(s))});return i},Model.Game.cbXQSoldierGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e]])},Model.Game.cbXQPromoSoldierGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e],[-1,0],[1,0]])},Model.Game.cbXQAdvisorGraph=function(t,e){return this.cbShortRangeGraph(t,[[1,1],[-1,1],[1,-1],[-1,-1]],e)},Model.Game.cbXQCannonGraph=function(t){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0]],null,this.cbConstants.FLAG_MOVE|this.cbConstants.FLAG_SCREEN_CAPTURE)},Model.Game.cbXQElephantGraph=function(t,e){for(var r=this,i={},a=0;a<t.boardSize;a++)i[a]=[],(!e||a in e)&&[[1,1,2,2],[1,-1,2,-2],[-1,1,-2,2],[-1,-1,-2,-2]].forEach(function(n){var s=t.Graph(a,[n[0],n[1]]);if(null!=s){var o=t.Graph(a,[n[2],n[3]]);null!=o&&(!e||o in e)&&i[a].push(r.cbTypedArray([s|r.cbConstants.FLAG_STOP,o|r.cbConstants.FLAG_MOVE|r.cbConstants.FLAG_CAPTURE]))}});return i},Model.Game.cbSilverGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e],[-1,-1],[-1,1],[1,-1],[1,1]])},Model.Game.cbFersGraph=function(t,e){return this.cbShortRangeGraph(t,[[-1,-1],[-1,1],[1,-1],[1,1]])},Model.Game.cbSchleichGraph=function(t,e){return this.cbShortRangeGraph(t,[[-1,0],[1,0],[0,-1],[0,1]])},Model.Game.cbAlfilGraph=function(t,e){return this.cbShortRangeGraph(t,[[-2,-2],[-2,2],[2,2],[2,-2]])}}(),function(){var t=Model.Game.cbBoardGeometryGrid(5,5);Model.Game.cbDefine=function(){return{geometry:t,pieceTypes:{0:{name:"pawn-w",aspect:"pawn",graph:this.cbPawnGraph(t,1),value:1,abbrev:"",fenAbbrev:"P",epCatch:!0},1:{name:"ipawn-w",aspect:"pawn",graph:this.cbInitialPawnGraph(t,1),value:1,abbrev:"",fenAbbrev:"P",initial:[{s:1,p:5},{s:1,p:6},{s:1,p:7},{s:1,p:8},{s:1,p:9}],epCatch:!0,epTarget:!0},2:{name:"pawn-b",aspect:"pawn",graph:this.cbPawnGraph(t,-1),value:1,abbrev:"",fenAbbrev:"P",epCatch:!0},3:{name:"ipawn-b",aspect:"pawn",graph:this.cbInitialPawnGraph(t,-1),value:1,abbrev:"",fenAbbrev:"P",initial:[{s:-1,p:15},{s:-1,p:16},{s:-1,p:17},{s:-1,p:18},{s:-1,p:19}],epCatch:!0,epTarget:!0},4:{name:"knight",graph:this.cbKnightGraph(t),value:2.9,abbrev:"N",initial:[{s:1,p:1},{s:-1,p:23}]},5:{name:"bishop",graph:this.cbBishopGraph(t),value:3.1,abbrev:"B",initial:[{s:1,p:2},{s:-1,p:22}]},6:{name:"rook",graph:this.cbRookGraph(t),value:5,abbrev:"R",initial:[{s:1,p:0},{s:-1,p:24}],castle:!0},7:{name:"queen",graph:this.cbQueenGraph(t),value:9,abbrev:"Q",initial:[{s:1,p:3},{s:-1,p:21}]},8:{name:"king",isKing:!0,graph:this.cbKingGraph(t),abbrev:"K",initial:[{s:1,p:4},{s:-1,p:20}]}},promote:function(e,r,i){return 1==r.t?[0]:3==r.t?[2]:0==r.t&&4==t.R(i.t)?[4,5,6,7]:2==r.t&&0==t.R(i.t)?[4,5,6,7]:[]},castle:{"4/0":{k:[3,2],r:[1,2,3],n:"O-O"},"24/20":{k:[23,22],r:[21,22,23],n:"O-O"}},evaluate:function(e,r,i){var a=i[1].count,n=i[-1].count;a[0]||a[1]||a[4]||a[5]||a[6]||a[7]||n[2]||n[3]||n[6]||n[7]||!(n[4]+n[5]<2||n[5]<2)||(this.mFinished=!0,this.mWinner=JocGame.DRAW),n[2]||n[3]||n[4]||n[5]||n[6]||n[7]||a[0]||a[1]||a[6]||a[7]||!(a[4]+a[5]<2||a[5]<2)||(this.mFinished=!0,this.mWinner=JocGame.DRAW),this.noCaptCount>=100&&(this.mFinished=!0,this.mWinner=JocGame.DRAW);var s,o=e.cbUseTypedArrays?new Int8Array(3):[0,0,0],h=t.height,c=i[1].byType[0];if(c){s=c.length;for(var p=0;p<s;p++)switch(h-t.R(c[p].p)){case 2:o[0]++;break;case 3:o[1]++;break;case 4:o[2]++}}if(c=i[-1].byType[2]){s=c.length;for(var p=0;p<s;p++)switch(t.R(c[p].p)){case 1:o[0]--;break;case 2:o[1]--;break;case 3:o[2]--}}0!=o[0]&&(r.distPawnPromo1=o[0]),0!=o[1]&&(r.distPawnPromo2=o[1]),0!=o[2]&&(r.distPawnPromo3=o[2]);for(var l=0,u=4;u<=5;u++)for(var v=1;v>=-1;v-=2){var b=i[v].byType[u];if(b)for(var p=0;p<b.length;p++)b[p].m&&(l+=v)}0!=l&&(r.minorPiecesMoved=l)}}}}();

/***/ }),

/***/ "niiU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("3j3K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base__ = __webpack_require__("TwGT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__media_query_media_monitor__ = __webpack_require__("bWt6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__layout__ = __webpack_require__("Sxsi");
/* unused harmony export negativeOf */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ShowHideDirective; });
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */




var FALSY = ['false', false, 0];
/**
 * For fxHide selectors, we invert the 'value'
 * and assign to the equivalent fxShow selector cache
 *  - When 'hide' === '' === true, do NOT show the element
 *  - When 'hide' === false or 0... we WILL show the element
 */
function negativeOf(hide) {
    return (hide === "") ? false :
        ((hide === "false") || (hide === 0)) ? true : !hide;
}
/**
 * 'show' Layout API directive
 *
 */
var ShowHideDirective = (function (_super) {
    __extends(ShowHideDirective, _super);
    /* tslint:enable */
    /**
     *
     */
    function ShowHideDirective(monitor, _layout, elRef, renderer) {
        var _this = _super.call(this, monitor, elRef, renderer) || this;
        _this._layout = _layout;
        _this.elRef = elRef;
        _this.renderer = renderer;
        _this._display = _this._getDisplayStyle(); // re-invoke override to use `this._layout`
        if (_layout) {
            /**
             * The Layout can set the display:flex (and incorrectly affect the Hide/Show directives.
             * Whenever Layout [on the same element] resets its CSS, then update the Hide/Show CSS
             */
            _this._layoutWatcher = _layout.layout$.subscribe(function () { return _this._updateWithValue(); });
        }
        return _this;
    }
    Object.defineProperty(ShowHideDirective.prototype, "show", {
        /* tslint:disable */
        set: function (val) { this._cacheInput("show", val); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ShowHideDirective.prototype, "showXs", {
        set: function (val) { this._cacheInput('showXs', val); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ShowHideDirective.prototype, "showSm", {
        set: function (val) { this._cacheInput('showSm', val); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(ShowHideDirective.prototype, "showMd", {
        set: function (val) { this._cacheInput('showMd', val); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(ShowHideDirective.prototype, "showLg", {
        set: function (val) { this._cacheInput('showLg', val); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(ShowHideDirective.prototype, "showXl", {
        set: function (val) { this._cacheInput('showXl', val); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(ShowHideDirective.prototype, "showLtSm", {
        set: function (val) { this._cacheInput('showLtSm', val); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(ShowHideDirective.prototype, "showLtMd", {
        set: function (val) { this._cacheInput('showLtMd', val); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(ShowHideDirective.prototype, "showLtLg", {
        set: function (val) { this._cacheInput('showLtLg', val); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(ShowHideDirective.prototype, "showLtXl", {
        set: function (val) { this._cacheInput('showLtXl', val); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(ShowHideDirective.prototype, "showGtXs", {
        set: function (val) { this._cacheInput('showGtXs', val); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(ShowHideDirective.prototype, "showGtSm", {
        set: function (val) { this._cacheInput('showGtSm', val); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(ShowHideDirective.prototype, "showGtMd", {
        set: function (val) { this._cacheInput('showGtMd', val); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(ShowHideDirective.prototype, "showGtLg", {
        set: function (val) { this._cacheInput('showGtLg', val); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(ShowHideDirective.prototype, "hide", {
        set: function (val) { this._cacheInput("show", negativeOf(val)); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ShowHideDirective.prototype, "hideXs", {
        set: function (val) { this._cacheInput("showXs", negativeOf(val)); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ShowHideDirective.prototype, "hideSm", {
        set: function (val) { this._cacheInput('showSm', negativeOf(val)); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(ShowHideDirective.prototype, "hideMd", {
        set: function (val) { this._cacheInput('showMd', negativeOf(val)); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(ShowHideDirective.prototype, "hideLg", {
        set: function (val) { this._cacheInput('showLg', negativeOf(val)); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(ShowHideDirective.prototype, "hideXl", {
        set: function (val) { this._cacheInput('showXl', negativeOf(val)); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(ShowHideDirective.prototype, "hideLtSm", {
        set: function (val) { this._cacheInput('showLtSm', negativeOf(val)); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(ShowHideDirective.prototype, "hideLtMd", {
        set: function (val) { this._cacheInput('showLtMd', negativeOf(val)); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(ShowHideDirective.prototype, "hideLtLg", {
        set: function (val) { this._cacheInput('showLtLg', negativeOf(val)); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(ShowHideDirective.prototype, "hideLtXl", {
        set: function (val) { this._cacheInput('showLtXl', negativeOf(val)); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(ShowHideDirective.prototype, "hideGtXs", {
        set: function (val) { this._cacheInput('showGtXs', negativeOf(val)); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(ShowHideDirective.prototype, "hideGtSm", {
        set: function (val) { this._cacheInput('showGtSm', negativeOf(val)); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(ShowHideDirective.prototype, "hideGtMd", {
        set: function (val) { this._cacheInput('showGtMd', negativeOf(val)); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(ShowHideDirective.prototype, "hideGtLg", {
        set: function (val) { this._cacheInput('showGtLg', negativeOf(val)); },
        enumerable: true,
        configurable: true
    });
    ;
    // *********************************************
    // Lifecycle Methods
    // *********************************************
    /**
     * Override accessor to the current HTMLElement's `display` style
     * Note: Show/Hide will not change the display to 'flex' but will set it to 'block'
     * unless it was already explicitly defined.
     */
    ShowHideDirective.prototype._getDisplayStyle = function () {
        return this._layout ? "flex" : _super.prototype._getDisplayStyle.call(this);
    };
    /**
     * On changes to any @Input properties...
     * Default to use the non-responsive Input value ('fxShow')
     * Then conditionally override with the mq-activated Input's current value
     */
    ShowHideDirective.prototype.ngOnChanges = function (changes) {
        if (changes['show'] != null || this._mqActivation) {
            this._updateWithValue();
        }
    };
    /**
     * After the initial onChanges, build an mqActivation object that bridges
     * mql change events to onMediaQueryChange handlers
     */
    ShowHideDirective.prototype.ngOnInit = function () {
        var _this = this;
        var value = this._getDefaultVal("show", true);
        // Build _mqActivation controller
        this._listenForMediaQueryChanges('show', value, function (changes) {
            _this._updateWithValue(changes.value);
        });
        this._updateWithValue();
    };
    ShowHideDirective.prototype.ngOnDestroy = function () {
        _super.prototype.ngOnDestroy.call(this);
        if (this._layoutWatcher) {
            this._layoutWatcher.unsubscribe();
        }
    };
    // *********************************************
    // Protected methods
    // *********************************************
    /** Validate the visibility value and then update the host's inline display style */
    ShowHideDirective.prototype._updateWithValue = function (value) {
        value = value || this._getDefaultVal("show", true);
        if (this._mqActivation) {
            value = this._mqActivation.activatedInput;
        }
        var shouldShow = this._validateTruthy(value);
        this._applyStyleToElement(this._buildCSS(shouldShow));
    };
    /** Build the CSS that should be assigned to the element instance */
    ShowHideDirective.prototype._buildCSS = function (show) {
        return { 'display': show ? this._display : 'none' };
    };
    /**  Validate the to be not FALSY */
    ShowHideDirective.prototype._validateTruthy = function (show) {
        return (FALSY.indexOf(show) == -1);
    };
    return ShowHideDirective;
}(__WEBPACK_IMPORTED_MODULE_1__base__["a" /* BaseFxDirective */]));

ShowHideDirective.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                selector: "\n  [fxShow],\n  [fxShow.xs], [fxShow.sm], [fxShow.md], [fxShow.lg], [fxShow.xl],\n  [fxShow.lt-sm], [fxShow.lt-md], [fxShow.lt-lg], [fxShow.lt-xl],\n  [fxShow.gt-xs], [fxShow.gt-sm], [fxShow.gt-md], [fxShow.gt-lg],\n  [fxHide],\n  [fxHide.xs], [fxHide.sm], [fxHide.md], [fxHide.lg], [fxHide.xl],\n  [fxHide.lt-sm], [fxHide.lt-md], [fxHide.lt-lg], [fxHide.lt-xl],\n  [fxHide.gt-xs], [fxHide.gt-sm], [fxHide.gt-md], [fxHide.gt-lg]\n"
            },] },
];
/** @nocollapse */
ShowHideDirective.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_2__media_query_media_monitor__["a" /* MediaMonitor */], },
    { type: __WEBPACK_IMPORTED_MODULE_3__layout__["a" /* LayoutDirective */], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] },] },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer2"], },
]; };
ShowHideDirective.propDecorators = {
    'show': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxShow',] },],
    'showXs': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxShow.xs',] },],
    'showSm': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxShow.sm',] },],
    'showMd': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxShow.md',] },],
    'showLg': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxShow.lg',] },],
    'showXl': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxShow.xl',] },],
    'showLtSm': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxShow.lt-sm',] },],
    'showLtMd': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxShow.lt-md',] },],
    'showLtLg': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxShow.lt-lg',] },],
    'showLtXl': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxShow.lt-xl',] },],
    'showGtXs': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxShow.gt-xs',] },],
    'showGtSm': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxShow.gt-sm',] },],
    'showGtMd': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxShow.gt-md',] },],
    'showGtLg': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxShow.gt-lg',] },],
    'hide': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxHide',] },],
    'hideXs': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxHide.xs',] },],
    'hideSm': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxHide.sm',] },],
    'hideMd': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxHide.md',] },],
    'hideLg': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxHide.lg',] },],
    'hideXl': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxHide.xl',] },],
    'hideLtSm': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxHide.lt-sm',] },],
    'hideLtMd': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxHide.lt-md',] },],
    'hideLtLg': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxHide.lt-lg',] },],
    'hideLtXl': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxHide.lt-xl',] },],
    'hideGtXs': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxHide.gt-xs',] },],
    'hideGtSm': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxHide.gt-sm',] },],
    'hideGtMd': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxHide.gt-md',] },],
    'hideGtLg': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxHide.gt-lg',] },],
};
//# sourceMappingURL=show-hide.js.map

/***/ }),

/***/ "njJ/":
/***/ (function(module, exports) {

exports.model=Model={Game:{},Board:{},Move:{}},function(){function t(t){var i=t%e;return[i,(t-i)/e]}function i(t,i){return i*e+t}var e;Model.Game.InitGame=function(){var s=this;e=2*this.mOptions.centerDistance+1;var r=[[0,-1],[1,0],[0,1],[-1,0]];this.g.attackersCount=this.mOptions.initial.attackers.length,this.g.defendersCount=this.mOptions.initial.defenders.soldiers.length,this.g.excludeMap={},this.mOptions.exclude.forEach(function(t){s.g.excludeMap[t]=!0}),this.g.home=this.mOptions.initial.defenders.king,this.g.Graph=[],this.g.borders={};for(var a=0;a<e*e;a++){var o=[],n=t(a);r.forEach(function(t){var r=n[0]+t[0];if(r<0||r>=e)o.push(null),s.g.borders[a]=!0;else{var h=n[1]+t[1];if(h<0||h>=e)o.push(null),s.g.borders[a]=!0;else{var d=i(r,h);s.g.excludeMap[d]?o.push(null):o.push(d)}}}),this.g.Graph.push(o)}this.zobrist=new JocGame.Zobrist({board:{type:"array",size:e*e,values:["s1","s-1","k1","k-1"]}})},Model.Move.Init=function(t){var i=this;if(this.f=t.f,this.t=t.t,this.c=[],t.c)for(var e=0;e<t.c.length;e++)i.c.push(t.c[e])},Model.Move.CopyFrom=function(t){this.Init(t)},Model.Move.ToString=function(){var t=this.f+">"+this.t;return this.c.length>0&&(t+="x"+this.c.join(",")),t},Model.Board.Init=function(t){this.zSign=0},Model.Board.InitialPosition=function(i){function s(t,e,s){r.zSign=i.zobrist.update(r.zSign,"board",s+e,t),r.board[t]=r.pieces.length,r.pieces.push({i:r.pieces.length,p:t,s:e,t:s})}var r=this;this.board=[],this.pieces=[];for(var a=0;a<e*e;a++)this.board.push(-1);var o=i.mOptions.attackers;s(i.mOptions.initial.defenders.king,-o,"k");var n=i.mOptions.initial.defenders.soldiers;this.defendersCount=0;for(var h=0;h<n.length;h++)s(n[h],-o,"s"),this.defendersCount++;this.defendersCount=n.length;var d=i.mOptions.initial.attackers;this.attackersCount=0;for(var h=0;h<d.length;h++){s(d[h],o,"s");t(d[h]);this.attackersCount++}},Model.Board.CopyFrom=function(t){var i=this;this.board=[];for(var e=t.board,s=0;s<e.length;s++)i.board.push(e[s]);this.pieces=[];for(var r=t.pieces,a=0;a<r.length;a++){var o=r[a];i.pieces.push({i:o.i,p:o.p,s:o.s,t:o.t})}this.defendersCount=t.defendersCount,this.attackersCount=t.attackersCount,this.mWho=t.mWho,this.zSign=t.zSign},Model.Board.GenerateMoves=function(t){for(var i=this,e=[],s=0;s<this.pieces.length;s++){var r=this.pieces[s];if(!(r.s!=i.mWho||r.p<0))for(var a=0;a<4;a++)for(var o=t.g.Graph[r.p][a];null!=o;){var n=i.board[o];if(!(n<0)||o==t.g.home&&t.mOptions.privateHome&&"k"!=r.t)break;for(var h={f:r.p,t:o,c:[]},d=0;d<4;d++){var p=t.g.Graph[o][d];if(null!=p){var c=i.board[p];if(c>=0){var f=i.pieces[c];if(f.s==-r.s)if("k"==f.t){for(var u=0;u<4;u++){var l=t.g.Graph[p][u];if(null==l)break;var v=i.board[l];if(v<0){if(l!=o&&(l!=t.g.home||!t.mOptions.homeCatch))break}else{var g=i.pieces[v];if(g.s==f.s)break}}4==u&&h.c.push(p)}else{var l=t.g.Graph[p][d];if(null!=l){var v=i.board[l];if(l==t.g.home&&t.mOptions.homeCatch)h.c.push(p);else if(v>=0){var g=i.pieces[v];g.s==r.s&&h.c.push(p)}}}}}}if(e.push(h),!t.mOptions.longMove)break;o=t.g.Graph[o][a]}}this.mMoves=e},Model.Board.Evaluate=function(i){var e="debug"==arguments[3];if(this.mEvaluation=0,this.pieces[0].p<0)return this.mFinished=!0,void(this.mWinner=i.mOptions.attackers);if(this.pieces[0].p in i.g.borders)return this.mFinished=!0,void(this.mWinner=-i.mOptions.attackers);if(i.GetRepeatOccurence(this)>2)return this.mFinished=!0,void(this.mWinner=JocGame.DRAW);for(var s=this.pieces[0].p,r=t(s),a=0,o=i.mOptions.initial.attackers.length+1;o<this.pieces.length;o++){var n=this.pieces[o];if(n.p>=0){var h=t(n.p);a+=Math.max(Math.abs(h[0]-r[0]),Math.abs(h[1]-r[1]))}}var d={},p={};d[s]=1;for(var c=1,f=0,u=0;c>0;){var l={};c=0;for(var v in d){for(var g=d[v],m=g/4,b=i.g.Graph[v],k=0;k<4;k++)for(var M=b[k];M&&!(this.board[M]>=0)&&(M in p||M in d||(M in i.g.borders?f+=g:M in l?l[M]+=m:(u++,c++,l[M]=m)),i.mOptions.longMove);)M=i.g.Graph[M][k];p[v]=g}d=l}var O={attackersCount:this.attackersCount,defendersCount:this.defendersCount,kingPath:f,kingFreedom:u,distKing:a},C=i.mOptions.levelOptions;for(var z in O){var G=O[z],S=C[z+"Factor"]||0,E=G*S;e&&console.log(z,"=",G,"*",S,"=>",E),this.mEvaluation+=E}this.mEvaluation*=i.mOptions.attackers,e&&console.log("Evaluation",this.mEvaluation)},Model.Board.ApplyMove=function(i,e){var s=this,r=this.board[e.f],a=this.pieces[r];if(this.zSign=i.zobrist.update(this.zSign,"board",a.t+a.s,e.f),this.zSign=i.zobrist.update(this.zSign,"board",a.t+a.s,e.t),this.board[e.f]=-1,this.board[e.t]=r,a.p=e.t,this.mWho==i.mOptions.attackers){t(e.f),t(e.t)}for(var o=e.c,n=0;n<o.length;n++){var h=o[n],d=s.board[h],p=s.pieces[d];s.zSign=i.zobrist.update(s.zSign,"board",p.t+p.s,h),s.board[h]=-1,p.p=-1,s.mWho==-i.mOptions.attackers?s.attackersCount--:"s"==p.t&&s.defendersCount--}},Model.Board.taflIntegrity=function(t){var i=this,e=0,s=0;this.board.forEach(function(r,a){if(r>=0){var o=i.pieces[r];o.p,"s"==o.t&&(o.s==t.mOptions.attackers?e++:s++)}}),this.attackersCount,this.defendersCount,this.pieces.forEach(function(t,e){t.p>=0&&i.board[t.p]})},Model.Board.GetSignature=function(){return this.zSign}}();

/***/ }),

/***/ "nsuO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var buffer_1 = __webpack_require__("AZSN");
Observable_1.Observable.prototype.buffer = buffer_1.buffer;
//# sourceMappingURL=buffer.js.map

/***/ }),

/***/ "o7Xg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__add_alias__ = __webpack_require__("WeUy");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__auto_prefixer__ = __webpack_require__("Sciq");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__basis_validator__ = __webpack_require__("ytmK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__layout_validator__ = __webpack_require__("eKS0");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__breakpoint_tools__ = __webpack_require__("Qy3m");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__object_extend__ = __webpack_require__("xZ/u");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__style_transforms__ = __webpack_require__("YEB2");
/* unused harmony namespace reexport */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */







//# sourceMappingURL=index.js.map

/***/ }),

/***/ "oHQS":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var subscribeOn_1 = __webpack_require__("SudU");
Observable_1.Observable.prototype.subscribeOn = subscribeOn_1.subscribeOn;
//# sourceMappingURL=subscribeOn.js.map

/***/ }),

/***/ "oHSm":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {/**
 * angular2-data-table v"9.1.0" (https://github.com/swimlane/angular2-data-table)
 * Copyright 2016
 * Licensed under MIT
 */
(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__("3j3K"), __webpack_require__("Qbdm"), __webpack_require__("2Je8"));
	else if(typeof define === 'function' && define.amd)
		define("ngxDatatable", ["@angular/core", "@angular/platform-browser", "@angular/common"], factory);
	else if(typeof exports === 'object')
		exports["ngxDatatable"] = factory(require("@angular/core"), require("@angular/platform-browser"), require("@angular/common"));
	else
		root["ngxDatatable"] = factory(root["@angular/core"], root["@angular/platform-browser"], root["@angular/common"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_2__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "./src/index.ts");
/******/ })
/************************************************************************/
/******/ ({

/***/ "./node_modules/base64-js/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function placeHoldersCount (b64) {
  var len = b64.length
  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // the number of equal signs (place holders)
  // if there are two placeholders, than the two characters before it
  // represent one byte
  // if there is only one, then the three characters before it represent 2 bytes
  // this is just a cheap hack to not do indexOf twice
  return b64[len - 2] === '=' ? 2 : b64[len - 1] === '=' ? 1 : 0
}

function byteLength (b64) {
  // base64 is 4/3 + up to two characters of the original data
  return b64.length * 3 / 4 - placeHoldersCount(b64)
}

function toByteArray (b64) {
  var i, j, l, tmp, placeHolders, arr
  var len = b64.length
  placeHolders = placeHoldersCount(b64)

  arr = new Arr(len * 3 / 4 - placeHolders)

  // if there are placeholders, only get up to the last complete 4 chars
  l = placeHolders > 0 ? len - 4 : len

  var L = 0

  for (i = 0, j = 0; i < l; i += 4, j += 3) {
    tmp = (revLookup[b64.charCodeAt(i)] << 18) | (revLookup[b64.charCodeAt(i + 1)] << 12) | (revLookup[b64.charCodeAt(i + 2)] << 6) | revLookup[b64.charCodeAt(i + 3)]
    arr[L++] = (tmp >> 16) & 0xFF
    arr[L++] = (tmp >> 8) & 0xFF
    arr[L++] = tmp & 0xFF
  }

  if (placeHolders === 2) {
    tmp = (revLookup[b64.charCodeAt(i)] << 2) | (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[L++] = tmp & 0xFF
  } else if (placeHolders === 1) {
    tmp = (revLookup[b64.charCodeAt(i)] << 10) | (revLookup[b64.charCodeAt(i + 1)] << 4) | (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[L++] = (tmp >> 8) & 0xFF
    arr[L++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp = (uint8[i] << 16) + (uint8[i + 1] << 8) + (uint8[i + 2])
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var output = ''
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    output += lookup[tmp >> 2]
    output += lookup[(tmp << 4) & 0x3F]
    output += '=='
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + (uint8[len - 1])
    output += lookup[tmp >> 10]
    output += lookup[(tmp >> 4) & 0x3F]
    output += lookup[(tmp << 2) & 0x3F]
    output += '='
  }

  parts.push(output)

  return parts.join('')
}


/***/ }),

/***/ "./node_modules/buffer/index.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__("./node_modules/base64-js/index.js")
var ieee754 = __webpack_require__("./node_modules/ieee754/index.js")
var isArray = __webpack_require__("./node_modules/isarray/index.js")

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/css-loader/index.js!./node_modules/postcss-loader/index.js?sourceMap!./node_modules/sass-loader/lib/loader.js?sourceMap!./src/components/datatable.component.scss":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("./node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.i, ".ngx-datatable {\n  display: block;\n  overflow: hidden;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  position: relative;\n  -webkit-transform: translate3d(0, 0, 0);\n  /**\n   * Vertical Scrolling Adjustments\n   */\n  /**\n   * Horizontal Scrolling Adjustments\n   */\n  /**\n   * Fixed Header Height Adjustments\n   */\n  /**\n   * Fixed row height adjustments\n   */\n  /**\n   * Shared Styles\n   */\n  /**\n   * Header Styles\n   */\n  /**\n   * Body Styles\n   */\n  /**\n   * Footer Styles\n   */ }\n  .ngx-datatable [hidden] {\n    display: none !important; }\n  .ngx-datatable *, .ngx-datatable *:before, .ngx-datatable *:after {\n    box-sizing: border-box; }\n  .ngx-datatable.scroll-vertical .datatable-body {\n    overflow-y: auto; }\n    .ngx-datatable.scroll-vertical .datatable-body .datatable-row-wrapper {\n      position: absolute; }\n  .ngx-datatable.scroll-horz .datatable-body {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch; }\n  .ngx-datatable.fixed-header .datatable-header .datatable-header-inner {\n    white-space: nowrap; }\n    .ngx-datatable.fixed-header .datatable-header .datatable-header-inner .datatable-header-cell {\n      white-space: nowrap;\n      overflow: hidden;\n      text-overflow: ellipsis; }\n  .ngx-datatable.fixed-row .datatable-scroll {\n    white-space: nowrap; }\n    .ngx-datatable.fixed-row .datatable-scroll .datatable-body-row {\n      white-space: nowrap; }\n      .ngx-datatable.fixed-row .datatable-scroll .datatable-body-row .datatable-body-cell {\n        overflow: hidden;\n        white-space: nowrap;\n        text-overflow: ellipsis; }\n  .ngx-datatable .datatable-body-row,\n  .ngx-datatable .datatable-header-inner {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: horizontal;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: row;\n            flex-direction: row;\n    -ms-flex-flow: row;\n    -o-flex-flow: row;\n    flex-flow: row; }\n  .ngx-datatable .datatable-body-cell,\n  .ngx-datatable .datatable-header-cell {\n    vertical-align: top;\n    display: inline-block;\n    line-height: 1.625;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    -o-user-select: none;\n    user-select: none; }\n    .ngx-datatable .datatable-body-cell:focus,\n    .ngx-datatable .datatable-header-cell:focus {\n      outline: none; }\n  .ngx-datatable .datatable-row-left,\n  .ngx-datatable .datatable-row-right {\n    z-index: 9; }\n  .ngx-datatable .datatable-row-left,\n  .ngx-datatable .datatable-row-center,\n  .ngx-datatable .datatable-row-right {\n    position: relative; }\n  .ngx-datatable .datatable-header {\n    display: block;\n    overflow: hidden; }\n    .ngx-datatable .datatable-header .datatable-header-inner {\n      -webkit-box-align: stretch;\n          -ms-flex-align: stretch;\n              align-items: stretch;\n      -webkit-align-items: stretch; }\n    .ngx-datatable .datatable-header .datatable-header-cell {\n      position: relative;\n      display: inline-block; }\n      .ngx-datatable .datatable-header .datatable-header-cell .datatable-header-cell-wrapper {\n        cursor: pointer; }\n      .ngx-datatable .datatable-header .datatable-header-cell.longpress .datatable-header-cell-wrapper {\n        cursor: move; }\n      .ngx-datatable .datatable-header .datatable-header-cell .sort-btn {\n        line-height: 100%;\n        vertical-align: middle;\n        display: inline-block;\n        cursor: pointer; }\n      .ngx-datatable .datatable-header .datatable-header-cell .resize-handle {\n        display: inline-block;\n        position: absolute;\n        right: 0;\n        top: 0;\n        bottom: 0;\n        width: 5px;\n        padding: 0 4px;\n        visibility: hidden;\n        cursor: ew-resize; }\n      .ngx-datatable .datatable-header .datatable-header-cell.resizeable:hover .resize-handle {\n        visibility: visible; }\n  .ngx-datatable .datatable-body {\n    position: relative;\n    z-index: 10;\n    display: block; }\n    .ngx-datatable .datatable-body .datatable-scroll {\n      display: inline-block; }\n    .ngx-datatable .datatable-body .datatable-row-detail {\n      overflow-y: hidden; }\n    .ngx-datatable .datatable-body .datatable-row-wrapper {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-orient: vertical;\n      -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n      flex-direction: column; }\n    .ngx-datatable .datatable-body .datatable-body-row {\n      outline: none; }\n      .ngx-datatable .datatable-body .datatable-body-row > div {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex; }\n  .ngx-datatable .datatable-footer {\n    display: block;\n    width: 100%; }\n    .ngx-datatable .datatable-footer .datatable-footer-inner {\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -webkit-box-align: center;\n          -ms-flex-align: center;\n              align-items: center;\n      width: 100%; }\n    .ngx-datatable .datatable-footer .selected-count .page-count {\n      -webkit-box-flex: 1;\n          -ms-flex: 1 1 40%;\n              flex: 1 1 40%; }\n    .ngx-datatable .datatable-footer .selected-count .datatable-pager {\n      -webkit-box-flex: 1;\n          -ms-flex: 1 1 60%;\n              flex: 1 1 60%; }\n    .ngx-datatable .datatable-footer .page-count {\n      -webkit-box-flex: 1;\n          -ms-flex: 1 1 20%;\n              flex: 1 1 20%; }\n    .ngx-datatable .datatable-footer .datatable-pager {\n      -webkit-box-flex: 1;\n          -ms-flex: 1 1 80%;\n              flex: 1 1 80%;\n      text-align: right; }\n      .ngx-datatable .datatable-footer .datatable-pager .pager,\n      .ngx-datatable .datatable-footer .datatable-pager .pager li {\n        padding: 0;\n        margin: 0;\n        display: inline-block;\n        list-style: none; }\n      .ngx-datatable .datatable-footer .datatable-pager .pager li, .ngx-datatable .datatable-footer .datatable-pager .pager li a {\n        outline: none; }\n      .ngx-datatable .datatable-footer .datatable-pager .pager li a {\n        cursor: pointer;\n        display: inline-block; }\n      .ngx-datatable .datatable-footer .datatable-pager .pager li.disabled a {\n        cursor: not-allowed; }\n", ""]);

// exports


/***/ }),

/***/ "./node_modules/css-loader/lib/css-base.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap) {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
  var base64 = new Buffer(JSON.stringify(sourceMap)).toString('base64');
  var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

  return '/*# ' + data + ' */';
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/buffer/index.js").Buffer))

/***/ }),

/***/ "./node_modules/ieee754/index.js":
/***/ (function(module, exports) {

exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = nBytes * 8 - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = nBytes * 8 - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),

/***/ "./node_modules/isarray/index.js":
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),

/***/ "./node_modules/rxjs/InnerSubscriber.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__("./node_modules/rxjs/Subscriber.js");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var InnerSubscriber = (function (_super) {
    __extends(InnerSubscriber, _super);
    function InnerSubscriber(parent, outerValue, outerIndex) {
        _super.call(this);
        this.parent = parent;
        this.outerValue = outerValue;
        this.outerIndex = outerIndex;
        this.index = 0;
    }
    InnerSubscriber.prototype._next = function (value) {
        this.parent.notifyNext(this.outerValue, value, this.outerIndex, this.index++, this);
    };
    InnerSubscriber.prototype._error = function (error) {
        this.parent.notifyError(error, this);
        this.unsubscribe();
    };
    InnerSubscriber.prototype._complete = function () {
        this.parent.notifyComplete(this);
        this.unsubscribe();
    };
    return InnerSubscriber;
}(Subscriber_1.Subscriber));
exports.InnerSubscriber = InnerSubscriber;
//# sourceMappingURL=InnerSubscriber.js.map

/***/ }),

/***/ "./node_modules/rxjs/Observable.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var root_1 = __webpack_require__("./node_modules/rxjs/util/root.js");
var toSubscriber_1 = __webpack_require__("./node_modules/rxjs/util/toSubscriber.js");
var observable_1 = __webpack_require__("./node_modules/rxjs/symbol/observable.js");
/**
 * A representation of any set of values over any amount of time. This the most basic building block
 * of RxJS.
 *
 * @class Observable<T>
 */
var Observable = (function () {
    /**
     * @constructor
     * @param {Function} subscribe the function that is  called when the Observable is
     * initially subscribed to. This function is given a Subscriber, to which new values
     * can be `next`ed, or an `error` method can be called to raise an error, or
     * `complete` can be called to notify of a successful completion.
     */
    function Observable(subscribe) {
        this._isScalar = false;
        if (subscribe) {
            this._subscribe = subscribe;
        }
    }
    /**
     * Creates a new Observable, with this Observable as the source, and the passed
     * operator defined as the new observable's operator.
     * @method lift
     * @param {Operator} operator the operator defining the operation to take on the observable
     * @return {Observable} a new observable with the Operator applied
     */
    Observable.prototype.lift = function (operator) {
        var observable = new Observable();
        observable.source = this;
        observable.operator = operator;
        return observable;
    };
    Observable.prototype.subscribe = function (observerOrNext, error, complete) {
        var operator = this.operator;
        var sink = toSubscriber_1.toSubscriber(observerOrNext, error, complete);
        if (operator) {
            operator.call(sink, this.source);
        }
        else {
            sink.add(this._trySubscribe(sink));
        }
        if (sink.syncErrorThrowable) {
            sink.syncErrorThrowable = false;
            if (sink.syncErrorThrown) {
                throw sink.syncErrorValue;
            }
        }
        return sink;
    };
    Observable.prototype._trySubscribe = function (sink) {
        try {
            return this._subscribe(sink);
        }
        catch (err) {
            sink.syncErrorThrown = true;
            sink.syncErrorValue = err;
            sink.error(err);
        }
    };
    /**
     * @method forEach
     * @param {Function} next a handler for each value emitted by the observable
     * @param {PromiseConstructor} [PromiseCtor] a constructor function used to instantiate the Promise
     * @return {Promise} a promise that either resolves on observable completion or
     *  rejects with the handled error
     */
    Observable.prototype.forEach = function (next, PromiseCtor) {
        var _this = this;
        if (!PromiseCtor) {
            if (root_1.root.Rx && root_1.root.Rx.config && root_1.root.Rx.config.Promise) {
                PromiseCtor = root_1.root.Rx.config.Promise;
            }
            else if (root_1.root.Promise) {
                PromiseCtor = root_1.root.Promise;
            }
        }
        if (!PromiseCtor) {
            throw new Error('no Promise impl found');
        }
        return new PromiseCtor(function (resolve, reject) {
            // Must be declared in a separate statement to avoid a RefernceError when
            // accessing subscription below in the closure due to Temporal Dead Zone.
            var subscription;
            subscription = _this.subscribe(function (value) {
                if (subscription) {
                    // if there is a subscription, then we can surmise
                    // the next handling is asynchronous. Any errors thrown
                    // need to be rejected explicitly and unsubscribe must be
                    // called manually
                    try {
                        next(value);
                    }
                    catch (err) {
                        reject(err);
                        subscription.unsubscribe();
                    }
                }
                else {
                    // if there is NO subscription, then we're getting a nexted
                    // value synchronously during subscription. We can just call it.
                    // If it errors, Observable's `subscribe` will ensure the
                    // unsubscription logic is called, then synchronously rethrow the error.
                    // After that, Promise will trap the error and send it
                    // down the rejection path.
                    next(value);
                }
            }, reject, resolve);
        });
    };
    Observable.prototype._subscribe = function (subscriber) {
        return this.source.subscribe(subscriber);
    };
    /**
     * An interop point defined by the es7-observable spec https://github.com/zenparsing/es-observable
     * @method Symbol.observable
     * @return {Observable} this instance of the observable
     */
    Observable.prototype[observable_1.observable] = function () {
        return this;
    };
    // HACK: Since TypeScript inherits static properties too, we have to
    // fight against TypeScript here so Subject can have a different static create signature
    /**
     * Creates a new cold Observable by calling the Observable constructor
     * @static true
     * @owner Observable
     * @method create
     * @param {Function} subscribe? the subscriber function to be passed to the Observable constructor
     * @return {Observable} a new cold observable
     */
    Observable.create = function (subscribe) {
        return new Observable(subscribe);
    };
    return Observable;
}());
exports.Observable = Observable;
//# sourceMappingURL=Observable.js.map

/***/ }),

/***/ "./node_modules/rxjs/Observer.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.empty = {
    closed: true,
    next: function (value) { },
    error: function (err) { throw err; },
    complete: function () { }
};
//# sourceMappingURL=Observer.js.map

/***/ }),

/***/ "./node_modules/rxjs/OuterSubscriber.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__("./node_modules/rxjs/Subscriber.js");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var OuterSubscriber = (function (_super) {
    __extends(OuterSubscriber, _super);
    function OuterSubscriber() {
        _super.apply(this, arguments);
    }
    OuterSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.destination.next(innerValue);
    };
    OuterSubscriber.prototype.notifyError = function (error, innerSub) {
        this.destination.error(error);
    };
    OuterSubscriber.prototype.notifyComplete = function (innerSub) {
        this.destination.complete();
    };
    return OuterSubscriber;
}(Subscriber_1.Subscriber));
exports.OuterSubscriber = OuterSubscriber;
//# sourceMappingURL=OuterSubscriber.js.map

/***/ }),

/***/ "./node_modules/rxjs/Subscriber.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var isFunction_1 = __webpack_require__("./node_modules/rxjs/util/isFunction.js");
var Subscription_1 = __webpack_require__("./node_modules/rxjs/Subscription.js");
var Observer_1 = __webpack_require__("./node_modules/rxjs/Observer.js");
var rxSubscriber_1 = __webpack_require__("./node_modules/rxjs/symbol/rxSubscriber.js");
/**
 * Implements the {@link Observer} interface and extends the
 * {@link Subscription} class. While the {@link Observer} is the public API for
 * consuming the values of an {@link Observable}, all Observers get converted to
 * a Subscriber, in order to provide Subscription-like capabilities such as
 * `unsubscribe`. Subscriber is a common type in RxJS, and crucial for
 * implementing operators, but it is rarely used as a public API.
 *
 * @class Subscriber<T>
 */
var Subscriber = (function (_super) {
    __extends(Subscriber, _super);
    /**
     * @param {Observer|function(value: T): void} [destinationOrNext] A partially
     * defined Observer or a `next` callback function.
     * @param {function(e: ?any): void} [error] The `error` callback of an
     * Observer.
     * @param {function(): void} [complete] The `complete` callback of an
     * Observer.
     */
    function Subscriber(destinationOrNext, error, complete) {
        _super.call(this);
        this.syncErrorValue = null;
        this.syncErrorThrown = false;
        this.syncErrorThrowable = false;
        this.isStopped = false;
        switch (arguments.length) {
            case 0:
                this.destination = Observer_1.empty;
                break;
            case 1:
                if (!destinationOrNext) {
                    this.destination = Observer_1.empty;
                    break;
                }
                if (typeof destinationOrNext === 'object') {
                    if (destinationOrNext instanceof Subscriber) {
                        this.destination = destinationOrNext;
                        this.destination.add(this);
                    }
                    else {
                        this.syncErrorThrowable = true;
                        this.destination = new SafeSubscriber(this, destinationOrNext);
                    }
                    break;
                }
            default:
                this.syncErrorThrowable = true;
                this.destination = new SafeSubscriber(this, destinationOrNext, error, complete);
                break;
        }
    }
    Subscriber.prototype[rxSubscriber_1.rxSubscriber] = function () { return this; };
    /**
     * A static factory for a Subscriber, given a (potentially partial) definition
     * of an Observer.
     * @param {function(x: ?T): void} [next] The `next` callback of an Observer.
     * @param {function(e: ?any): void} [error] The `error` callback of an
     * Observer.
     * @param {function(): void} [complete] The `complete` callback of an
     * Observer.
     * @return {Subscriber<T>} A Subscriber wrapping the (partially defined)
     * Observer represented by the given arguments.
     */
    Subscriber.create = function (next, error, complete) {
        var subscriber = new Subscriber(next, error, complete);
        subscriber.syncErrorThrowable = false;
        return subscriber;
    };
    /**
     * The {@link Observer} callback to receive notifications of type `next` from
     * the Observable, with a value. The Observable may call this method 0 or more
     * times.
     * @param {T} [value] The `next` value.
     * @return {void}
     */
    Subscriber.prototype.next = function (value) {
        if (!this.isStopped) {
            this._next(value);
        }
    };
    /**
     * The {@link Observer} callback to receive notifications of type `error` from
     * the Observable, with an attached {@link Error}. Notifies the Observer that
     * the Observable has experienced an error condition.
     * @param {any} [err] The `error` exception.
     * @return {void}
     */
    Subscriber.prototype.error = function (err) {
        if (!this.isStopped) {
            this.isStopped = true;
            this._error(err);
        }
    };
    /**
     * The {@link Observer} callback to receive a valueless notification of type
     * `complete` from the Observable. Notifies the Observer that the Observable
     * has finished sending push-based notifications.
     * @return {void}
     */
    Subscriber.prototype.complete = function () {
        if (!this.isStopped) {
            this.isStopped = true;
            this._complete();
        }
    };
    Subscriber.prototype.unsubscribe = function () {
        if (this.closed) {
            return;
        }
        this.isStopped = true;
        _super.prototype.unsubscribe.call(this);
    };
    Subscriber.prototype._next = function (value) {
        this.destination.next(value);
    };
    Subscriber.prototype._error = function (err) {
        this.destination.error(err);
        this.unsubscribe();
    };
    Subscriber.prototype._complete = function () {
        this.destination.complete();
        this.unsubscribe();
    };
    Subscriber.prototype._unsubscribeAndRecycle = function () {
        var _a = this, _parent = _a._parent, _parents = _a._parents;
        this._parent = null;
        this._parents = null;
        this.unsubscribe();
        this.closed = false;
        this.isStopped = false;
        this._parent = _parent;
        this._parents = _parents;
        return this;
    };
    return Subscriber;
}(Subscription_1.Subscription));
exports.Subscriber = Subscriber;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var SafeSubscriber = (function (_super) {
    __extends(SafeSubscriber, _super);
    function SafeSubscriber(_parentSubscriber, observerOrNext, error, complete) {
        _super.call(this);
        this._parentSubscriber = _parentSubscriber;
        var next;
        var context = this;
        if (isFunction_1.isFunction(observerOrNext)) {
            next = observerOrNext;
        }
        else if (observerOrNext) {
            next = observerOrNext.next;
            error = observerOrNext.error;
            complete = observerOrNext.complete;
            if (observerOrNext !== Observer_1.empty) {
                context = Object.create(observerOrNext);
                if (isFunction_1.isFunction(context.unsubscribe)) {
                    this.add(context.unsubscribe.bind(context));
                }
                context.unsubscribe = this.unsubscribe.bind(this);
            }
        }
        this._context = context;
        this._next = next;
        this._error = error;
        this._complete = complete;
    }
    SafeSubscriber.prototype.next = function (value) {
        if (!this.isStopped && this._next) {
            var _parentSubscriber = this._parentSubscriber;
            if (!_parentSubscriber.syncErrorThrowable) {
                this.__tryOrUnsub(this._next, value);
            }
            else if (this.__tryOrSetError(_parentSubscriber, this._next, value)) {
                this.unsubscribe();
            }
        }
    };
    SafeSubscriber.prototype.error = function (err) {
        if (!this.isStopped) {
            var _parentSubscriber = this._parentSubscriber;
            if (this._error) {
                if (!_parentSubscriber.syncErrorThrowable) {
                    this.__tryOrUnsub(this._error, err);
                    this.unsubscribe();
                }
                else {
                    this.__tryOrSetError(_parentSubscriber, this._error, err);
                    this.unsubscribe();
                }
            }
            else if (!_parentSubscriber.syncErrorThrowable) {
                this.unsubscribe();
                throw err;
            }
            else {
                _parentSubscriber.syncErrorValue = err;
                _parentSubscriber.syncErrorThrown = true;
                this.unsubscribe();
            }
        }
    };
    SafeSubscriber.prototype.complete = function () {
        if (!this.isStopped) {
            var _parentSubscriber = this._parentSubscriber;
            if (this._complete) {
                if (!_parentSubscriber.syncErrorThrowable) {
                    this.__tryOrUnsub(this._complete);
                    this.unsubscribe();
                }
                else {
                    this.__tryOrSetError(_parentSubscriber, this._complete);
                    this.unsubscribe();
                }
            }
            else {
                this.unsubscribe();
            }
        }
    };
    SafeSubscriber.prototype.__tryOrUnsub = function (fn, value) {
        try {
            fn.call(this._context, value);
        }
        catch (err) {
            this.unsubscribe();
            throw err;
        }
    };
    SafeSubscriber.prototype.__tryOrSetError = function (parent, fn, value) {
        try {
            fn.call(this._context, value);
        }
        catch (err) {
            parent.syncErrorValue = err;
            parent.syncErrorThrown = true;
            return true;
        }
        return false;
    };
    SafeSubscriber.prototype._unsubscribe = function () {
        var _parentSubscriber = this._parentSubscriber;
        this._context = null;
        this._parentSubscriber = null;
        _parentSubscriber.unsubscribe();
    };
    return SafeSubscriber;
}(Subscriber));
//# sourceMappingURL=Subscriber.js.map

/***/ }),

/***/ "./node_modules/rxjs/Subscription.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isArray_1 = __webpack_require__("./node_modules/rxjs/util/isArray.js");
var isObject_1 = __webpack_require__("./node_modules/rxjs/util/isObject.js");
var isFunction_1 = __webpack_require__("./node_modules/rxjs/util/isFunction.js");
var tryCatch_1 = __webpack_require__("./node_modules/rxjs/util/tryCatch.js");
var errorObject_1 = __webpack_require__("./node_modules/rxjs/util/errorObject.js");
var UnsubscriptionError_1 = __webpack_require__("./node_modules/rxjs/util/UnsubscriptionError.js");
/**
 * Represents a disposable resource, such as the execution of an Observable. A
 * Subscription has one important method, `unsubscribe`, that takes no argument
 * and just disposes the resource held by the subscription.
 *
 * Additionally, subscriptions may be grouped together through the `add()`
 * method, which will attach a child Subscription to the current Subscription.
 * When a Subscription is unsubscribed, all its children (and its grandchildren)
 * will be unsubscribed as well.
 *
 * @class Subscription
 */
var Subscription = (function () {
    /**
     * @param {function(): void} [unsubscribe] A function describing how to
     * perform the disposal of resources when the `unsubscribe` method is called.
     */
    function Subscription(unsubscribe) {
        /**
         * A flag to indicate whether this Subscription has already been unsubscribed.
         * @type {boolean}
         */
        this.closed = false;
        this._parent = null;
        this._parents = null;
        this._subscriptions = null;
        if (unsubscribe) {
            this._unsubscribe = unsubscribe;
        }
    }
    /**
     * Disposes the resources held by the subscription. May, for instance, cancel
     * an ongoing Observable execution or cancel any other type of work that
     * started when the Subscription was created.
     * @return {void}
     */
    Subscription.prototype.unsubscribe = function () {
        var hasErrors = false;
        var errors;
        if (this.closed) {
            return;
        }
        var _a = this, _parent = _a._parent, _parents = _a._parents, _unsubscribe = _a._unsubscribe, _subscriptions = _a._subscriptions;
        this.closed = true;
        this._parent = null;
        this._parents = null;
        // null out _subscriptions first so any child subscriptions that attempt
        // to remove themselves from this subscription will noop
        this._subscriptions = null;
        var index = -1;
        var len = _parents ? _parents.length : 0;
        // if this._parent is null, then so is this._parents, and we
        // don't have to remove ourselves from any parent subscriptions.
        while (_parent) {
            _parent.remove(this);
            // if this._parents is null or index >= len,
            // then _parent is set to null, and the loop exits
            _parent = ++index < len && _parents[index] || null;
        }
        if (isFunction_1.isFunction(_unsubscribe)) {
            var trial = tryCatch_1.tryCatch(_unsubscribe).call(this);
            if (trial === errorObject_1.errorObject) {
                hasErrors = true;
                errors = errors || (errorObject_1.errorObject.e instanceof UnsubscriptionError_1.UnsubscriptionError ?
                    flattenUnsubscriptionErrors(errorObject_1.errorObject.e.errors) : [errorObject_1.errorObject.e]);
            }
        }
        if (isArray_1.isArray(_subscriptions)) {
            index = -1;
            len = _subscriptions.length;
            while (++index < len) {
                var sub = _subscriptions[index];
                if (isObject_1.isObject(sub)) {
                    var trial = tryCatch_1.tryCatch(sub.unsubscribe).call(sub);
                    if (trial === errorObject_1.errorObject) {
                        hasErrors = true;
                        errors = errors || [];
                        var err = errorObject_1.errorObject.e;
                        if (err instanceof UnsubscriptionError_1.UnsubscriptionError) {
                            errors = errors.concat(flattenUnsubscriptionErrors(err.errors));
                        }
                        else {
                            errors.push(err);
                        }
                    }
                }
            }
        }
        if (hasErrors) {
            throw new UnsubscriptionError_1.UnsubscriptionError(errors);
        }
    };
    /**
     * Adds a tear down to be called during the unsubscribe() of this
     * Subscription.
     *
     * If the tear down being added is a subscription that is already
     * unsubscribed, is the same reference `add` is being called on, or is
     * `Subscription.EMPTY`, it will not be added.
     *
     * If this subscription is already in an `closed` state, the passed
     * tear down logic will be executed immediately.
     *
     * @param {TeardownLogic} teardown The additional logic to execute on
     * teardown.
     * @return {Subscription} Returns the Subscription used or created to be
     * added to the inner subscriptions list. This Subscription can be used with
     * `remove()` to remove the passed teardown logic from the inner subscriptions
     * list.
     */
    Subscription.prototype.add = function (teardown) {
        if (!teardown || (teardown === Subscription.EMPTY)) {
            return Subscription.EMPTY;
        }
        if (teardown === this) {
            return this;
        }
        var subscription = teardown;
        switch (typeof teardown) {
            case 'function':
                subscription = new Subscription(teardown);
            case 'object':
                if (subscription.closed || typeof subscription.unsubscribe !== 'function') {
                    return subscription;
                }
                else if (this.closed) {
                    subscription.unsubscribe();
                    return subscription;
                }
                else if (typeof subscription._addParent !== 'function' /* quack quack */) {
                    var tmp = subscription;
                    subscription = new Subscription();
                    subscription._subscriptions = [tmp];
                }
                break;
            default:
                throw new Error('unrecognized teardown ' + teardown + ' added to Subscription.');
        }
        var subscriptions = this._subscriptions || (this._subscriptions = []);
        subscriptions.push(subscription);
        subscription._addParent(this);
        return subscription;
    };
    /**
     * Removes a Subscription from the internal list of subscriptions that will
     * unsubscribe during the unsubscribe process of this Subscription.
     * @param {Subscription} subscription The subscription to remove.
     * @return {void}
     */
    Subscription.prototype.remove = function (subscription) {
        var subscriptions = this._subscriptions;
        if (subscriptions) {
            var subscriptionIndex = subscriptions.indexOf(subscription);
            if (subscriptionIndex !== -1) {
                subscriptions.splice(subscriptionIndex, 1);
            }
        }
    };
    Subscription.prototype._addParent = function (parent) {
        var _a = this, _parent = _a._parent, _parents = _a._parents;
        if (!_parent || _parent === parent) {
            // If we don't have a parent, or the new parent is the same as the
            // current parent, then set this._parent to the new parent.
            this._parent = parent;
        }
        else if (!_parents) {
            // If there's already one parent, but not multiple, allocate an Array to
            // store the rest of the parent Subscriptions.
            this._parents = [parent];
        }
        else if (_parents.indexOf(parent) === -1) {
            // Only add the new parent to the _parents list if it's not already there.
            _parents.push(parent);
        }
    };
    Subscription.EMPTY = (function (empty) {
        empty.closed = true;
        return empty;
    }(new Subscription()));
    return Subscription;
}());
exports.Subscription = Subscription;
function flattenUnsubscriptionErrors(errors) {
    return errors.reduce(function (errs, err) { return errs.concat((err instanceof UnsubscriptionError_1.UnsubscriptionError) ? err.errors : err); }, []);
}
//# sourceMappingURL=Subscription.js.map

/***/ }),

/***/ "./node_modules/rxjs/add/observable/fromEvent.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("./node_modules/rxjs/Observable.js");
var fromEvent_1 = __webpack_require__("./node_modules/rxjs/observable/fromEvent.js");
Observable_1.Observable.fromEvent = fromEvent_1.fromEvent;
//# sourceMappingURL=fromEvent.js.map

/***/ }),

/***/ "./node_modules/rxjs/add/operator/takeUntil.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("./node_modules/rxjs/Observable.js");
var takeUntil_1 = __webpack_require__("./node_modules/rxjs/operator/takeUntil.js");
Observable_1.Observable.prototype.takeUntil = takeUntil_1.takeUntil;
//# sourceMappingURL=takeUntil.js.map

/***/ }),

/***/ "./node_modules/rxjs/observable/FromEventObservable.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Observable_1 = __webpack_require__("./node_modules/rxjs/Observable.js");
var tryCatch_1 = __webpack_require__("./node_modules/rxjs/util/tryCatch.js");
var isFunction_1 = __webpack_require__("./node_modules/rxjs/util/isFunction.js");
var errorObject_1 = __webpack_require__("./node_modules/rxjs/util/errorObject.js");
var Subscription_1 = __webpack_require__("./node_modules/rxjs/Subscription.js");
var toString = Object.prototype.toString;
function isNodeStyleEventEmitter(sourceObj) {
    return !!sourceObj && typeof sourceObj.addListener === 'function' && typeof sourceObj.removeListener === 'function';
}
function isJQueryStyleEventEmitter(sourceObj) {
    return !!sourceObj && typeof sourceObj.on === 'function' && typeof sourceObj.off === 'function';
}
function isNodeList(sourceObj) {
    return !!sourceObj && toString.call(sourceObj) === '[object NodeList]';
}
function isHTMLCollection(sourceObj) {
    return !!sourceObj && toString.call(sourceObj) === '[object HTMLCollection]';
}
function isEventTarget(sourceObj) {
    return !!sourceObj && typeof sourceObj.addEventListener === 'function' && typeof sourceObj.removeEventListener === 'function';
}
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var FromEventObservable = (function (_super) {
    __extends(FromEventObservable, _super);
    function FromEventObservable(sourceObj, eventName, selector, options) {
        _super.call(this);
        this.sourceObj = sourceObj;
        this.eventName = eventName;
        this.selector = selector;
        this.options = options;
    }
    /* tslint:enable:max-line-length */
    /**
     * Creates an Observable that emits events of a specific type coming from the
     * given event target.
     *
     * <span class="informal">Creates an Observable from DOM events, or Node
     * EventEmitter events or others.</span>
     *
     * <img src="./img/fromEvent.png" width="100%">
     *
     * Creates an Observable by attaching an event listener to an "event target",
     * which may be an object with `addEventListener` and `removeEventListener`,
     * a Node.js EventEmitter, a jQuery style EventEmitter, a NodeList from the
     * DOM, or an HTMLCollection from the DOM. The event handler is attached when
     * the output Observable is subscribed, and removed when the Subscription is
     * unsubscribed.
     *
     * @example <caption>Emits clicks happening on the DOM document</caption>
     * var clicks = Rx.Observable.fromEvent(document, 'click');
     * clicks.subscribe(x => console.log(x));
     *
     * // Results in:
     * // MouseEvent object logged to console everytime a click
     * // occurs on the document.
     *
     * @see {@link from}
     * @see {@link fromEventPattern}
     *
     * @param {EventTargetLike} target The DOMElement, event target, Node.js
     * EventEmitter, NodeList or HTMLCollection to attach the event handler to.
     * @param {string} eventName The event name of interest, being emitted by the
     * `target`.
     * @param {EventListenerOptions} [options] Options to pass through to addEventListener
     * @param {SelectorMethodSignature<T>} [selector] An optional function to
     * post-process results. It takes the arguments from the event handler and
     * should return a single value.
     * @return {Observable<T>}
     * @static true
     * @name fromEvent
     * @owner Observable
     */
    FromEventObservable.create = function (target, eventName, options, selector) {
        if (isFunction_1.isFunction(options)) {
            selector = options;
            options = undefined;
        }
        return new FromEventObservable(target, eventName, selector, options);
    };
    FromEventObservable.setupSubscription = function (sourceObj, eventName, handler, subscriber, options) {
        var unsubscribe;
        if (isNodeList(sourceObj) || isHTMLCollection(sourceObj)) {
            for (var i = 0, len = sourceObj.length; i < len; i++) {
                FromEventObservable.setupSubscription(sourceObj[i], eventName, handler, subscriber, options);
            }
        }
        else if (isEventTarget(sourceObj)) {
            var source_1 = sourceObj;
            sourceObj.addEventListener(eventName, handler, options);
            unsubscribe = function () { return source_1.removeEventListener(eventName, handler); };
        }
        else if (isJQueryStyleEventEmitter(sourceObj)) {
            var source_2 = sourceObj;
            sourceObj.on(eventName, handler);
            unsubscribe = function () { return source_2.off(eventName, handler); };
        }
        else if (isNodeStyleEventEmitter(sourceObj)) {
            var source_3 = sourceObj;
            sourceObj.addListener(eventName, handler);
            unsubscribe = function () { return source_3.removeListener(eventName, handler); };
        }
        else {
            throw new TypeError('Invalid event target');
        }
        subscriber.add(new Subscription_1.Subscription(unsubscribe));
    };
    FromEventObservable.prototype._subscribe = function (subscriber) {
        var sourceObj = this.sourceObj;
        var eventName = this.eventName;
        var options = this.options;
        var selector = this.selector;
        var handler = selector ? function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i - 0] = arguments[_i];
            }
            var result = tryCatch_1.tryCatch(selector).apply(void 0, args);
            if (result === errorObject_1.errorObject) {
                subscriber.error(errorObject_1.errorObject.e);
            }
            else {
                subscriber.next(result);
            }
        } : function (e) { return subscriber.next(e); };
        FromEventObservable.setupSubscription(sourceObj, eventName, handler, subscriber, options);
    };
    return FromEventObservable;
}(Observable_1.Observable));
exports.FromEventObservable = FromEventObservable;
//# sourceMappingURL=FromEventObservable.js.map

/***/ }),

/***/ "./node_modules/rxjs/observable/fromEvent.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var FromEventObservable_1 = __webpack_require__("./node_modules/rxjs/observable/FromEventObservable.js");
exports.fromEvent = FromEventObservable_1.FromEventObservable.create;
//# sourceMappingURL=fromEvent.js.map

/***/ }),

/***/ "./node_modules/rxjs/operator/takeUntil.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var OuterSubscriber_1 = __webpack_require__("./node_modules/rxjs/OuterSubscriber.js");
var subscribeToResult_1 = __webpack_require__("./node_modules/rxjs/util/subscribeToResult.js");
/**
 * Emits the values emitted by the source Observable until a `notifier`
 * Observable emits a value.
 *
 * <span class="informal">Lets values pass until a second Observable,
 * `notifier`, emits something. Then, it completes.</span>
 *
 * <img src="./img/takeUntil.png" width="100%">
 *
 * `takeUntil` subscribes and begins mirroring the source Observable. It also
 * monitors a second Observable, `notifier` that you provide. If the `notifier`
 * emits a value or a complete notification, the output Observable stops
 * mirroring the source Observable and completes.
 *
 * @example <caption>Tick every second until the first click happens</caption>
 * var interval = Rx.Observable.interval(1000);
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = interval.takeUntil(clicks);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link take}
 * @see {@link takeLast}
 * @see {@link takeWhile}
 * @see {@link skip}
 *
 * @param {Observable} notifier The Observable whose first emitted value will
 * cause the output Observable of `takeUntil` to stop emitting values from the
 * source Observable.
 * @return {Observable<T>} An Observable that emits the values from the source
 * Observable until such time as `notifier` emits its first value.
 * @method takeUntil
 * @owner Observable
 */
function takeUntil(notifier) {
    return this.lift(new TakeUntilOperator(notifier));
}
exports.takeUntil = takeUntil;
var TakeUntilOperator = (function () {
    function TakeUntilOperator(notifier) {
        this.notifier = notifier;
    }
    TakeUntilOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new TakeUntilSubscriber(subscriber, this.notifier));
    };
    return TakeUntilOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var TakeUntilSubscriber = (function (_super) {
    __extends(TakeUntilSubscriber, _super);
    function TakeUntilSubscriber(destination, notifier) {
        _super.call(this, destination);
        this.notifier = notifier;
        this.add(subscribeToResult_1.subscribeToResult(this, notifier));
    }
    TakeUntilSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.complete();
    };
    TakeUntilSubscriber.prototype.notifyComplete = function () {
        // noop
    };
    return TakeUntilSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=takeUntil.js.map

/***/ }),

/***/ "./node_modules/rxjs/symbol/iterator.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var root_1 = __webpack_require__("./node_modules/rxjs/util/root.js");
function symbolIteratorPonyfill(root) {
    var Symbol = root.Symbol;
    if (typeof Symbol === 'function') {
        if (!Symbol.iterator) {
            Symbol.iterator = Symbol('iterator polyfill');
        }
        return Symbol.iterator;
    }
    else {
        // [for Mozilla Gecko 27-35:](https://mzl.la/2ewE1zC)
        var Set_1 = root.Set;
        if (Set_1 && typeof new Set_1()['@@iterator'] === 'function') {
            return '@@iterator';
        }
        var Map_1 = root.Map;
        // required for compatability with es6-shim
        if (Map_1) {
            var keys = Object.getOwnPropertyNames(Map_1.prototype);
            for (var i = 0; i < keys.length; ++i) {
                var key = keys[i];
                // according to spec, Map.prototype[@@iterator] and Map.orototype.entries must be equal.
                if (key !== 'entries' && key !== 'size' && Map_1.prototype[key] === Map_1.prototype['entries']) {
                    return key;
                }
            }
        }
        return '@@iterator';
    }
}
exports.symbolIteratorPonyfill = symbolIteratorPonyfill;
exports.iterator = symbolIteratorPonyfill(root_1.root);
/**
 * @deprecated use iterator instead
 */
exports.$$iterator = exports.iterator;
//# sourceMappingURL=iterator.js.map

/***/ }),

/***/ "./node_modules/rxjs/symbol/observable.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var root_1 = __webpack_require__("./node_modules/rxjs/util/root.js");
function getSymbolObservable(context) {
    var $$observable;
    var Symbol = context.Symbol;
    if (typeof Symbol === 'function') {
        if (Symbol.observable) {
            $$observable = Symbol.observable;
        }
        else {
            $$observable = Symbol('observable');
            Symbol.observable = $$observable;
        }
    }
    else {
        $$observable = '@@observable';
    }
    return $$observable;
}
exports.getSymbolObservable = getSymbolObservable;
exports.observable = getSymbolObservable(root_1.root);
/**
 * @deprecated use observable instead
 */
exports.$$observable = exports.observable;
//# sourceMappingURL=observable.js.map

/***/ }),

/***/ "./node_modules/rxjs/symbol/rxSubscriber.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var root_1 = __webpack_require__("./node_modules/rxjs/util/root.js");
var Symbol = root_1.root.Symbol;
exports.rxSubscriber = (typeof Symbol === 'function' && typeof Symbol.for === 'function') ?
    Symbol.for('rxSubscriber') : '@@rxSubscriber';
/**
 * @deprecated use rxSubscriber instead
 */
exports.$$rxSubscriber = exports.rxSubscriber;
//# sourceMappingURL=rxSubscriber.js.map

/***/ }),

/***/ "./node_modules/rxjs/util/UnsubscriptionError.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * An error thrown when one or more errors have occurred during the
 * `unsubscribe` of a {@link Subscription}.
 */
var UnsubscriptionError = (function (_super) {
    __extends(UnsubscriptionError, _super);
    function UnsubscriptionError(errors) {
        _super.call(this);
        this.errors = errors;
        var err = Error.call(this, errors ?
            errors.length + " errors occurred during unsubscription:\n  " + errors.map(function (err, i) { return ((i + 1) + ") " + err.toString()); }).join('\n  ') : '');
        this.name = err.name = 'UnsubscriptionError';
        this.stack = err.stack;
        this.message = err.message;
    }
    return UnsubscriptionError;
}(Error));
exports.UnsubscriptionError = UnsubscriptionError;
//# sourceMappingURL=UnsubscriptionError.js.map

/***/ }),

/***/ "./node_modules/rxjs/util/errorObject.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// typeof any so that it we don't have to cast when comparing a result to the error object
exports.errorObject = { e: {} };
//# sourceMappingURL=errorObject.js.map

/***/ }),

/***/ "./node_modules/rxjs/util/isArray.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.isArray = Array.isArray || (function (x) { return x && typeof x.length === 'number'; });
//# sourceMappingURL=isArray.js.map

/***/ }),

/***/ "./node_modules/rxjs/util/isArrayLike.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.isArrayLike = (function (x) { return x && typeof x.length === 'number'; });
//# sourceMappingURL=isArrayLike.js.map

/***/ }),

/***/ "./node_modules/rxjs/util/isFunction.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function isFunction(x) {
    return typeof x === 'function';
}
exports.isFunction = isFunction;
//# sourceMappingURL=isFunction.js.map

/***/ }),

/***/ "./node_modules/rxjs/util/isObject.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function isObject(x) {
    return x != null && typeof x === 'object';
}
exports.isObject = isObject;
//# sourceMappingURL=isObject.js.map

/***/ }),

/***/ "./node_modules/rxjs/util/isPromise.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function isPromise(value) {
    return value && typeof value.subscribe !== 'function' && typeof value.then === 'function';
}
exports.isPromise = isPromise;
//# sourceMappingURL=isPromise.js.map

/***/ }),

/***/ "./node_modules/rxjs/util/root.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {
/**
 * window: browser in DOM main thread
 * self: browser in WebWorker
 * global: Node.js/other
 */
exports.root = (typeof window == 'object' && window.window === window && window
    || typeof self == 'object' && self.self === self && self
    || typeof global == 'object' && global.global === global && global);
if (!exports.root) {
    throw new Error('RxJS could not find any global context (window, self, global)');
}
//# sourceMappingURL=root.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/rxjs/util/subscribeToResult.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var root_1 = __webpack_require__("./node_modules/rxjs/util/root.js");
var isArrayLike_1 = __webpack_require__("./node_modules/rxjs/util/isArrayLike.js");
var isPromise_1 = __webpack_require__("./node_modules/rxjs/util/isPromise.js");
var isObject_1 = __webpack_require__("./node_modules/rxjs/util/isObject.js");
var Observable_1 = __webpack_require__("./node_modules/rxjs/Observable.js");
var iterator_1 = __webpack_require__("./node_modules/rxjs/symbol/iterator.js");
var InnerSubscriber_1 = __webpack_require__("./node_modules/rxjs/InnerSubscriber.js");
var observable_1 = __webpack_require__("./node_modules/rxjs/symbol/observable.js");
function subscribeToResult(outerSubscriber, result, outerValue, outerIndex) {
    var destination = new InnerSubscriber_1.InnerSubscriber(outerSubscriber, outerValue, outerIndex);
    if (destination.closed) {
        return null;
    }
    if (result instanceof Observable_1.Observable) {
        if (result._isScalar) {
            destination.next(result.value);
            destination.complete();
            return null;
        }
        else {
            return result.subscribe(destination);
        }
    }
    else if (isArrayLike_1.isArrayLike(result)) {
        for (var i = 0, len = result.length; i < len && !destination.closed; i++) {
            destination.next(result[i]);
        }
        if (!destination.closed) {
            destination.complete();
        }
    }
    else if (isPromise_1.isPromise(result)) {
        result.then(function (value) {
            if (!destination.closed) {
                destination.next(value);
                destination.complete();
            }
        }, function (err) { return destination.error(err); })
            .then(null, function (err) {
            // Escaping the Promise trap: globally throw unhandled errors
            root_1.root.setTimeout(function () { throw err; });
        });
        return destination;
    }
    else if (result && typeof result[iterator_1.iterator] === 'function') {
        var iterator = result[iterator_1.iterator]();
        do {
            var item = iterator.next();
            if (item.done) {
                destination.complete();
                break;
            }
            destination.next(item.value);
            if (destination.closed) {
                break;
            }
        } while (true);
    }
    else if (result && typeof result[observable_1.observable] === 'function') {
        var obs = result[observable_1.observable]();
        if (typeof obs.subscribe !== 'function') {
            destination.error(new TypeError('Provided object does not correctly implement Symbol.observable'));
        }
        else {
            return obs.subscribe(new InnerSubscriber_1.InnerSubscriber(outerSubscriber, outerValue, outerIndex));
        }
    }
    else {
        var value = isObject_1.isObject(result) ? 'an invalid object' : "'" + result + "'";
        var msg = ("You provided " + value + " where a stream was expected.")
            + ' You can provide an Observable, Promise, Array, or Iterable.';
        destination.error(new TypeError(msg));
    }
    return null;
}
exports.subscribeToResult = subscribeToResult;
//# sourceMappingURL=subscribeToResult.js.map

/***/ }),

/***/ "./node_modules/rxjs/util/toSubscriber.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Subscriber_1 = __webpack_require__("./node_modules/rxjs/Subscriber.js");
var rxSubscriber_1 = __webpack_require__("./node_modules/rxjs/symbol/rxSubscriber.js");
var Observer_1 = __webpack_require__("./node_modules/rxjs/Observer.js");
function toSubscriber(nextOrObserver, error, complete) {
    if (nextOrObserver) {
        if (nextOrObserver instanceof Subscriber_1.Subscriber) {
            return nextOrObserver;
        }
        if (nextOrObserver[rxSubscriber_1.rxSubscriber]) {
            return nextOrObserver[rxSubscriber_1.rxSubscriber]();
        }
    }
    if (!nextOrObserver && !error && !complete) {
        return new Subscriber_1.Subscriber(Observer_1.empty);
    }
    return new Subscriber_1.Subscriber(nextOrObserver, error, complete);
}
exports.toSubscriber = toSubscriber;
//# sourceMappingURL=toSubscriber.js.map

/***/ }),

/***/ "./node_modules/rxjs/util/tryCatch.js":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var errorObject_1 = __webpack_require__("./node_modules/rxjs/util/errorObject.js");
var tryCatchTarget;
function tryCatcher() {
    try {
        return tryCatchTarget.apply(this, arguments);
    }
    catch (e) {
        errorObject_1.errorObject.e = e;
        return errorObject_1.errorObject;
    }
}
function tryCatch(fn) {
    tryCatchTarget = fn;
    return tryCatcher;
}
exports.tryCatch = tryCatch;
;
//# sourceMappingURL=tryCatch.js.map

/***/ }),

/***/ "./node_modules/webpack/buildin/global.js":
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ "./src/components/body/body-cell.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var utils_1 = __webpack_require__("./src/utils/index.ts");
var types_1 = __webpack_require__("./src/types/index.ts");
var DataTableBodyCellComponent = (function () {
    function DataTableBodyCellComponent(element) {
        this.activate = new core_1.EventEmitter();
        this.isFocused = false;
        this.onCheckboxChangeFn = this.onCheckboxChange.bind(this);
        this.activateFn = this.activate.emit.bind(this.activate);
        this.element = element.nativeElement;
    }
    Object.defineProperty(DataTableBodyCellComponent.prototype, "sorts", {
        get: function () {
            return this._sorts;
        },
        set: function (val) {
            this._sorts = val;
            this.calcSortDir = this.calcSortDir(val);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTableBodyCellComponent.prototype, "columnCssClasses", {
        get: function () {
            var cls = 'datatable-body-cell';
            if (this.column.cellClass) {
                if (typeof this.column.cellClass === 'string') {
                    cls += ' ' + this.column.cellClass;
                }
                else if (typeof this.column.cellClass === 'function') {
                    var res = this.column.cellClass({
                        row: this.row,
                        column: this.column,
                        value: this.value
                    });
                    if (typeof res === 'string') {
                        cls += res;
                    }
                    else if (typeof res === 'object') {
                        var keys = Object.keys(res);
                        for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
                            var k = keys_1[_i];
                            if (res[k] === true)
                                cls += " " + k;
                        }
                    }
                }
            }
            if (!this.sortDir)
                cls += ' sort-active';
            if (this.isFocused)
                cls += ' active';
            if (this.sortDir === types_1.SortDirection.asc)
                cls += ' sort-asc';
            if (this.sortDir === types_1.SortDirection.desc)
                cls += ' sort-desc';
            return cls;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTableBodyCellComponent.prototype, "width", {
        get: function () {
            return this.column.width;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTableBodyCellComponent.prototype, "height", {
        get: function () {
            var height = this.rowHeight;
            if (isNaN(height))
                return height;
            return height + 'px';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTableBodyCellComponent.prototype, "value", {
        get: function () {
            if (!this.row || !this.column)
                return '';
            var val = this.column.$$valueGetter(this.row, this.column.prop);
            var userPipe = this.column.pipe;
            if (userPipe)
                return userPipe.transform(val);
            if (val !== undefined)
                return val;
            return '';
        },
        enumerable: true,
        configurable: true
    });
    DataTableBodyCellComponent.prototype.ngOnDestroy = function () {
        if (this.cellTemplate) {
            this.cellTemplate.clear();
        }
    };
    DataTableBodyCellComponent.prototype.onFocus = function () {
        this.isFocused = true;
    };
    DataTableBodyCellComponent.prototype.onBlur = function () {
        this.isFocused = false;
    };
    DataTableBodyCellComponent.prototype.onClick = function (event) {
        this.activate.emit({
            type: 'click',
            event: event,
            row: this.row,
            column: this.column,
            value: this.value,
            cellElement: this.element
        });
    };
    DataTableBodyCellComponent.prototype.onDblClick = function (event) {
        this.activate.emit({
            type: 'dblclick',
            event: event,
            row: this.row,
            column: this.column,
            value: this.value,
            cellElement: this.element
        });
    };
    DataTableBodyCellComponent.prototype.onKeyDown = function (event) {
        var keyCode = event.keyCode;
        var isTargetCell = event.target === this.element;
        var isAction = keyCode === utils_1.Keys.return ||
            keyCode === utils_1.Keys.down ||
            keyCode === utils_1.Keys.up ||
            keyCode === utils_1.Keys.left ||
            keyCode === utils_1.Keys.right;
        if (isAction && isTargetCell) {
            event.preventDefault();
            event.stopPropagation();
            this.activate.emit({
                type: 'keydown',
                event: event,
                row: this.row,
                column: this.column,
                value: this.value,
                cellElement: this.element
            });
        }
    };
    DataTableBodyCellComponent.prototype.onCheckboxChange = function (event) {
        this.activate.emit({
            type: 'checkbox',
            event: event,
            row: this.row,
            column: this.column,
            value: this.value,
            cellElement: this.element
        });
    };
    DataTableBodyCellComponent.prototype.calcSortDir = function (sorts) {
        var _this = this;
        if (!sorts)
            return;
        var sort = sorts.find(function (s) {
            return s.prop === _this.column.prop;
        });
        if (sort)
            return sort.dir;
    };
    return DataTableBodyCellComponent;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], DataTableBodyCellComponent.prototype, "row", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], DataTableBodyCellComponent.prototype, "column", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Number)
], DataTableBodyCellComponent.prototype, "rowHeight", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], DataTableBodyCellComponent.prototype, "isSelected", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Array),
    __metadata("design:paramtypes", [Array])
], DataTableBodyCellComponent.prototype, "sorts", null);
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], DataTableBodyCellComponent.prototype, "activate", void 0);
__decorate([
    core_1.ViewChild('cellTemplate', { read: core_1.ViewContainerRef }),
    __metadata("design:type", core_1.ViewContainerRef)
], DataTableBodyCellComponent.prototype, "cellTemplate", void 0);
__decorate([
    core_1.HostBinding('class'),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], DataTableBodyCellComponent.prototype, "columnCssClasses", null);
__decorate([
    core_1.HostBinding('style.width.px'),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [])
], DataTableBodyCellComponent.prototype, "width", null);
__decorate([
    core_1.HostBinding('style.height'),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], DataTableBodyCellComponent.prototype, "height", null);
__decorate([
    core_1.HostListener('focus'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], DataTableBodyCellComponent.prototype, "onFocus", null);
__decorate([
    core_1.HostListener('blur'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], DataTableBodyCellComponent.prototype, "onBlur", null);
__decorate([
    core_1.HostListener('click', ['$event']),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [MouseEvent]),
    __metadata("design:returntype", void 0)
], DataTableBodyCellComponent.prototype, "onClick", null);
__decorate([
    core_1.HostListener('dblclick', ['$event']),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [MouseEvent]),
    __metadata("design:returntype", void 0)
], DataTableBodyCellComponent.prototype, "onDblClick", null);
__decorate([
    core_1.HostListener('keydown', ['$event']),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [KeyboardEvent]),
    __metadata("design:returntype", void 0)
], DataTableBodyCellComponent.prototype, "onKeyDown", null);
DataTableBodyCellComponent = __decorate([
    core_1.Component({
        selector: 'datatable-body-cell',
        template: "\n    <div class=\"datatable-body-cell-label\">\n      <label\n        *ngIf=\"column.checkboxable\" \n        class=\"datatable-checkbox\">\n        <input \n          type=\"checkbox\"\n          [checked]=\"isSelected\"\n          (click)=\"onCheckboxChange($event)\" \n        />\n      </label>\n      <span\n        *ngIf=\"!column.cellTemplate\"\n        [title]=\"value\"\n        [innerHTML]=\"value\">\n      </span>\n      <ng-template #cellTemplate\n        *ngIf=\"column.cellTemplate\"\n        [ngTemplateOutlet]=\"column.cellTemplate\"\n        [ngOutletContext]=\"{\n          value: value,\n          row: row,\n          column: column,\n          isSelected: isSelected,\n          onCheckboxChangeFn: onCheckboxChangeFn,\n          activateFn: activateFn\n        }\">\n      </ng-template>\n    </div>\n  ",
        host: {
            class: 'datatable-body-cell'
        }
    }),
    __metadata("design:paramtypes", [core_1.ElementRef])
], DataTableBodyCellComponent);
exports.DataTableBodyCellComponent = DataTableBodyCellComponent;


/***/ }),

/***/ "./src/components/body/body-row-wrapper.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var DataTableRowWrapperComponent = (function () {
    function DataTableRowWrapperComponent() {
        this.expanded = false;
        this.rowContextmenu = new core_1.EventEmitter(false);
    }
    DataTableRowWrapperComponent.prototype.onContextmenu = function ($event) {
        this.rowContextmenu.emit({ event: $event, row: this.row });
    };
    return DataTableRowWrapperComponent;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], DataTableRowWrapperComponent.prototype, "rowDetail", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], DataTableRowWrapperComponent.prototype, "detailRowHeight", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], DataTableRowWrapperComponent.prototype, "expanded", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], DataTableRowWrapperComponent.prototype, "row", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", Object)
], DataTableRowWrapperComponent.prototype, "rowContextmenu", void 0);
__decorate([
    core_1.HostListener('contextmenu', ['$event']),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [MouseEvent]),
    __metadata("design:returntype", void 0)
], DataTableRowWrapperComponent.prototype, "onContextmenu", null);
DataTableRowWrapperComponent = __decorate([
    core_1.Component({
        selector: 'datatable-row-wrapper',
        template: "\n    <ng-content></ng-content>\n    <div \n      *ngIf=\"expanded\"\n      [style.height.px]=\"detailRowHeight\" \n      class=\"datatable-row-detail\">\n      <ng-template\n        *ngIf=\"rowDetail && rowDetail.template\"\n        [ngTemplateOutlet]=\"rowDetail.template\"\n        [ngOutletContext]=\"{ row: row }\">\n      </ng-template>\n    </div>\n  ",
        host: {
            class: 'datatable-row-wrapper'
        }
    })
], DataTableRowWrapperComponent);
exports.DataTableRowWrapperComponent = DataTableRowWrapperComponent;


/***/ }),

/***/ "./src/components/body/body-row.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var utils_1 = __webpack_require__("./src/utils/index.ts");
var services_1 = __webpack_require__("./src/services/index.ts");
var DataTableBodyRowComponent = (function () {
    function DataTableBodyRowComponent(scrollbarHelper, element) {
        this.scrollbarHelper = scrollbarHelper;
        this.activate = new core_1.EventEmitter();
        this.element = element.nativeElement;
    }
    Object.defineProperty(DataTableBodyRowComponent.prototype, "columns", {
        get: function () {
            return this._columns;
        },
        set: function (val) {
            this._columns = val;
            this.recalculateColumns(val);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTableBodyRowComponent.prototype, "innerWidth", {
        get: function () {
            return this._innerWidth;
        },
        set: function (val) {
            this._innerWidth = val;
            this.recalculateColumns();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTableBodyRowComponent.prototype, "cssClass", {
        get: function () {
            var cls = 'datatable-body-row';
            if (this.isSelected)
                cls += ' active';
            if (this.row.$$index % 2 !== 0)
                cls += ' datatable-row-odd';
            if (this.row.$$index % 2 === 0)
                cls += ' datatable-row-even';
            if (this.rowClass) {
                var res = this.rowClass(this.row);
                if (typeof res === 'string') {
                    cls += " " + res;
                }
                else if (typeof res === 'object') {
                    var keys = Object.keys(res);
                    for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
                        var k = keys_1[_i];
                        if (res[k] === true)
                            cls += " " + k;
                    }
                }
            }
            return cls;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTableBodyRowComponent.prototype, "columnsTotalWidths", {
        get: function () {
            return this.columnGroupWidths.total;
        },
        enumerable: true,
        configurable: true
    });
    DataTableBodyRowComponent.prototype.trackByGroups = function (index, colGroup) {
        return colGroup.type;
    };
    DataTableBodyRowComponent.prototype.columnTrackingFn = function (index, column) {
        return column.$$id;
    };
    DataTableBodyRowComponent.prototype.stylesByGroup = function (group) {
        var widths = this.columnGroupWidths;
        var offsetX = this.offsetX;
        var styles = {
            width: widths[group] + "px"
        };
        if (group === 'left') {
            utils_1.translateXY(styles, offsetX, 0);
        }
        else if (group === 'right') {
            var bodyWidth = parseInt(this.innerWidth + '', 0);
            var totalDiff = widths.total - bodyWidth;
            var offsetDiff = totalDiff - offsetX;
            var offset = (offsetDiff + this.scrollbarHelper.width) * -1;
            utils_1.translateXY(styles, offset, 0);
        }
        return styles;
    };
    DataTableBodyRowComponent.prototype.onActivate = function (event, index) {
        event.cellIndex = index;
        event.rowElement = this.element;
        this.activate.emit(event);
    };
    DataTableBodyRowComponent.prototype.onKeyDown = function (event) {
        var keyCode = event.keyCode;
        var isTargetRow = event.target === this.element;
        var isAction = keyCode === utils_1.Keys.return ||
            keyCode === utils_1.Keys.down ||
            keyCode === utils_1.Keys.up ||
            keyCode === utils_1.Keys.left ||
            keyCode === utils_1.Keys.right;
        if (isAction && isTargetRow) {
            event.preventDefault();
            event.stopPropagation();
            this.activate.emit({
                type: 'keydown',
                event: event,
                row: this.row,
                rowElement: this.element
            });
        }
    };
    DataTableBodyRowComponent.prototype.recalculateColumns = function (val) {
        if (val === void 0) { val = this.columns; }
        var colsByPin = utils_1.columnsByPin(val);
        this.columnsByPin = utils_1.columnsByPinArr(val);
        this.columnGroupWidths = utils_1.columnGroupWidths(colsByPin, val);
    };
    return DataTableBodyRowComponent;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", Array),
    __metadata("design:paramtypes", [Array])
], DataTableBodyRowComponent.prototype, "columns", null);
__decorate([
    core_1.Input(),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], DataTableBodyRowComponent.prototype, "innerWidth", null);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], DataTableBodyRowComponent.prototype, "rowClass", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], DataTableBodyRowComponent.prototype, "row", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Number)
], DataTableBodyRowComponent.prototype, "offsetX", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], DataTableBodyRowComponent.prototype, "isSelected", void 0);
__decorate([
    core_1.HostBinding('class'),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], DataTableBodyRowComponent.prototype, "cssClass", null);
__decorate([
    core_1.HostBinding('style.height.px'),
    core_1.Input(),
    __metadata("design:type", Number)
], DataTableBodyRowComponent.prototype, "rowHeight", void 0);
__decorate([
    core_1.HostBinding('style.width.px'),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [])
], DataTableBodyRowComponent.prototype, "columnsTotalWidths", null);
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], DataTableBodyRowComponent.prototype, "activate", void 0);
__decorate([
    core_1.HostListener('keydown', ['$event']),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [KeyboardEvent]),
    __metadata("design:returntype", void 0)
], DataTableBodyRowComponent.prototype, "onKeyDown", null);
DataTableBodyRowComponent = __decorate([
    core_1.Component({
        selector: 'datatable-body-row',
        template: "\n    <div\n      *ngFor=\"let colGroup of columnsByPin; let i = index; trackBy: trackByGroups\"\n      class=\"datatable-row-{{colGroup.type}} datatable-row-group\"\n      [ngStyle]=\"stylesByGroup(colGroup.type)\">\n      <datatable-body-cell\n        *ngFor=\"let column of colGroup.columns; let ii = index; trackBy: columnTrackingFn\"\n        tabindex=\"-1\"\n        [row]=\"row\"\n        [isSelected]=\"isSelected\"\n        [column]=\"column\"\n        [rowHeight]=\"rowHeight\"\n        (activate)=\"onActivate($event, ii)\">\n      </datatable-body-cell>\n    </div>\n  "
    }),
    __metadata("design:paramtypes", [services_1.ScrollbarHelper, core_1.ElementRef])
], DataTableBodyRowComponent);
exports.DataTableBodyRowComponent = DataTableBodyRowComponent;


/***/ }),

/***/ "./src/components/body/body.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var utils_1 = __webpack_require__("./src/utils/index.ts");
var types_1 = __webpack_require__("./src/types/index.ts");
var scroller_component_1 = __webpack_require__("./src/components/body/scroller.component.ts");
var DataTableBodyComponent = (function () {
    /**
     * Creates an instance of DataTableBodyComponent.
     *
     * @memberOf DataTableBodyComponent
     */
    function DataTableBodyComponent() {
        var _this = this;
        this.selected = [];
        this.scroll = new core_1.EventEmitter();
        this.page = new core_1.EventEmitter();
        this.activate = new core_1.EventEmitter();
        this.select = new core_1.EventEmitter();
        this.detailToggle = new core_1.EventEmitter();
        this.rowContextmenu = new core_1.EventEmitter(false);
        this.rowHeightsCache = new utils_1.RowHeightCache();
        this.temp = [];
        this.offsetY = 0;
        this.indexes = {};
        /**
         * Get the height of the detail row.
         *
         * @param {*} [row]
         * @param {*} [index]
         * @returns {number}
         *
         * @memberOf DataTableBodyComponent
         */
        this.getDetailRowHeight = function (row, index) {
            if (!_this.rowDetail)
                return 0;
            var rowHeight = _this.rowDetail.rowHeight;
            return typeof rowHeight === 'function' ? rowHeight(row, index) : rowHeight;
        };
        // declare fn here so we can get access to the `this` property
        this.rowTrackingFn = function (index, row) {
            if (this.trackByProp) {
                return row.$$index + "-" + this.trackByProp;
            }
            else {
                return row.$$index;
            }
        }.bind(this);
    }
    Object.defineProperty(DataTableBodyComponent.prototype, "pageSize", {
        get: function () {
            return this._pageSize;
        },
        set: function (val) {
            this._pageSize = val;
            this.recalcLayout();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTableBodyComponent.prototype, "rows", {
        get: function () {
            return this._rows;
        },
        set: function (val) {
            this._rows = val;
            this.recalcLayout();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTableBodyComponent.prototype, "columns", {
        get: function () {
            return this._columns;
        },
        set: function (val) {
            this._columns = val;
            var colsByPin = utils_1.columnsByPin(val);
            this.columnGroupWidths = utils_1.columnGroupWidths(colsByPin, val);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTableBodyComponent.prototype, "offset", {
        get: function () {
            return this._offset;
        },
        set: function (val) {
            this._offset = val;
            this.recalcLayout();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTableBodyComponent.prototype, "rowCount", {
        get: function () {
            return this._rowCount;
        },
        set: function (val) {
            this._rowCount = val;
            this.recalcLayout();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTableBodyComponent.prototype, "bodyWidth", {
        get: function () {
            if (this.scrollbarH) {
                return this.innerWidth + 'px';
            }
            else {
                return '100%';
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTableBodyComponent.prototype, "bodyHeight", {
        get: function () {
            return this._bodyHeight;
        },
        set: function (val) {
            if (this.scrollbarV) {
                this._bodyHeight = val + 'px';
            }
            else {
                this._bodyHeight = 'auto';
            }
            this.recalcLayout();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTableBodyComponent.prototype, "selectEnabled", {
        /**
         * Returns if selection is enabled.
         *
         * @readonly
         * @type {boolean}
         * @memberOf DataTableBodyComponent
         */
        get: function () {
            return !!this.selectionType;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTableBodyComponent.prototype, "scrollHeight", {
        /**
         * Property that would calculate the height of scroll bar
         * based on the row heights cache for virtual scroll. Other scenarios
         * calculate scroll height automatically (as height will be undefined).
         *
         * @readonly
         * @type {number}
         * @memberOf DataTableBodyComponent
         */
        get: function () {
            if (this.scrollbarV) {
                return this.rowHeightsCache.query(this.rowCount - 1);
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Called after the constructor, initializing input properties
     *
     * @memberOf DataTableBodyComponent
     */
    DataTableBodyComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (this.rowDetail) {
            this.listener = this.rowDetail.toggle
                .subscribe(function (_a) {
                var type = _a.type, value = _a.value;
                if (type === 'row')
                    _this.toggleRowExpansion(value);
                if (type === 'all')
                    _this.toggleAllRows(value);
            });
        }
    };
    /**
     * Called once, before the instance is destroyed.
     *
     * @memberOf DataTableBodyComponent
     */
    DataTableBodyComponent.prototype.ngOnDestroy = function () {
        if (this.rowDetail)
            this.listener.unsubscribe();
    };
    /**
     * Updates the Y offset given a new offset.
     *
     * @param {number} [offset]
     *
     * @memberOf DataTableBodyComponent
     */
    DataTableBodyComponent.prototype.updateOffsetY = function (offset) {
        // scroller is missing on empty table
        if (!this.scroller)
            return;
        if (this.scrollbarV && offset) {
            // First get the row Index that we need to move to.
            var rowIndex = this.pageSize * offset;
            offset = this.rowHeightsCache.query(rowIndex - 1);
        }
        this.scroller.setOffset(offset || 0);
    };
    /**
     * Body was scrolled, this is mainly useful for
     * when a user is server-side pagination via virtual scroll.
     *
     * @param {*} event
     *
     * @memberOf DataTableBodyComponent
     */
    DataTableBodyComponent.prototype.onBodyScroll = function (event) {
        var scrollYPos = event.scrollYPos;
        var scrollXPos = event.scrollXPos;
        // if scroll change, trigger update
        // this is mainly used for header cell positions
        if (this.offsetY !== scrollYPos || this.offsetX !== scrollXPos) {
            this.scroll.emit({
                offsetY: scrollYPos,
                offsetX: scrollXPos
            });
        }
        this.offsetY = scrollYPos;
        this.offsetX = scrollXPos;
        this.updateIndexes();
        this.updatePage(event.direction);
        this.updateRows();
    };
    /**
     * Updates the page given a direction.
     *
     * @param {string} direction
     *
     * @memberOf DataTableBodyComponent
     */
    DataTableBodyComponent.prototype.updatePage = function (direction) {
        var offset = this.indexes.first / this.pageSize;
        if (direction === 'up') {
            offset = Math.ceil(offset);
        }
        else if (direction === 'down') {
            offset = Math.ceil(offset);
        }
        if (direction !== undefined && !isNaN(offset)) {
            this.page.emit({ offset: offset });
        }
    };
    /**
     * Updates the rows in the view port
     *
     * @memberOf DataTableBodyComponent
     */
    DataTableBodyComponent.prototype.updateRows = function () {
        var _a = this.indexes, first = _a.first, last = _a.last;
        var rowIndex = first;
        var idx = 0;
        var temp = [];
        while (rowIndex < last && rowIndex < this.rowCount) {
            var row = this.rows[rowIndex];
            if (row) {
                row.$$index = rowIndex;
                temp[idx] = row;
            }
            idx++;
            rowIndex++;
        }
        this.temp = temp;
    };
    /**
     * Get the row height
     *
     * @param {*} row
     * @returns {number}
     *
     * @memberOf DataTableBodyComponent
     */
    DataTableBodyComponent.prototype.getRowHeight = function (row) {
        var rowHeight = this.rowHeight;
        // if its a function return it
        if (typeof this.rowHeight === 'function') {
            rowHeight = this.rowHeight(row);
        }
        return rowHeight;
    };
    /**
     * Calculate row height based on the expanded state of the row.
     *
     * @param {*} row the row for which the height need to be calculated.
     * @returns {number} height of the row.
     *
     * @memberOf DataTableBodyComponent
     */
    DataTableBodyComponent.prototype.getRowAndDetailHeight = function (row) {
        var rowHeight = this.getRowHeight(row);
        // Adding detail row height if its expanded.
        if (row.$$expanded === 1) {
            rowHeight += this.getDetailRowHeight(row);
        }
        return rowHeight;
    };
    /**
     * Calculates the styles for the row so that the rows can be moved in 2D space
     * during virtual scroll inside the DOM.   In the below case the Y position is
     * manipulated.   As an example, if the height of row 0 is 30 px and row 1 is
     * 100 px then following styles are generated:
     *
     * transform: translate3d(0px, 0px, 0px);    ->  row0
     * transform: translate3d(0px, 30px, 0px);   ->  row1
     * transform: translate3d(0px, 130px, 0px);  ->  row2
     *
     * Row heights have to be calculated based on the row heights cache as we wont
     * be able to determine which row is of what height before hand.  In the above
     * case the positionY of the translate3d for row2 would be the sum of all the
     * heights of the rows before it (i.e. row0 and row1).
     *
     * @param {*} row The row that needs to be placed in the 2D space.
     * @returns {*} Returns the CSS3 style to be applied
     *
     * @memberOf DataTableBodyComponent
     */
    DataTableBodyComponent.prototype.getRowsStyles = function (row) {
        var rowHeight = this.getRowAndDetailHeight(row);
        var styles = {
            height: rowHeight + 'px'
        };
        if (this.scrollbarV) {
            var idx = row ? row.$$index : 0;
            // const pos = idx * rowHeight;
            // The position of this row would be the sum of all row heights
            // until the previous row position.
            var pos = this.rowHeightsCache.query(idx - 1);
            utils_1.translateXY(styles, 0, pos);
        }
        return styles;
    };
    /**
     * Hides the loading indicator
     *
     *
     * @memberOf DataTableBodyComponent
     */
    DataTableBodyComponent.prototype.hideIndicator = function () {
        var _this = this;
        setTimeout(function () { return _this.loadingIndicator = false; }, 500);
    };
    /**
     * Updates the index of the rows in the viewport
     *
     * @memberOf DataTableBodyComponent
     */
    DataTableBodyComponent.prototype.updateIndexes = function () {
        var first = 0;
        var last = 0;
        if (this.scrollbarV) {
            // Calculation of the first and last indexes will be based on where the
            // scrollY position would be at.  The last index would be the one
            // that shows up inside the view port the last.
            var height = parseInt(this.bodyHeight, 0);
            first = this.rowHeightsCache.getRowIndex(this.offsetY);
            last = this.rowHeightsCache.getRowIndex(height + this.offsetY) + 1;
        }
        else {
            // The server is handling paging and will pass an array that begins with the
            // element at a specified offset.  first should always be 0 with external paging.
            if (!this.externalPaging) {
                first = Math.max(this.offset * this.pageSize, 0);
            }
            last = Math.min((first + this.pageSize), this.rowCount);
        }
        this.indexes = { first: first, last: last };
    };
    /**
     * Refreshes the full Row Height cache.  Should be used
     * when the entire row array state has changed.
     *
     * @returns {void}
     *
     * @memberOf DataTableBodyComponent
     */
    DataTableBodyComponent.prototype.refreshRowHeightCache = function () {
        if (!this.scrollbarV)
            return;
        // clear the previous row height cache if already present.
        // this is useful during sorts, filters where the state of the
        // rows array is changed.
        this.rowHeightsCache.clearCache();
        // Initialize the tree only if there are rows inside the tree.
        if (this.rows && this.rows.length) {
            this.rowHeightsCache.initCache({
                rows: this.rows,
                rowHeight: this.rowHeight,
                detailRowHeight: this.getDetailRowHeight,
                externalVirtual: this.scrollbarV && this.externalPaging,
                rowCount: this.rowCount
            });
        }
    };
    /**
     * Gets the index for the view port
     *
     * @returns {number}
     *
     * @memberOf DataTableBodyComponent
     */
    DataTableBodyComponent.prototype.getAdjustedViewPortIndex = function () {
        // Capture the row index of the first row that is visible on the viewport.
        // If the scroll bar is just below the row which is highlighted then make that as the
        // first index.
        var viewPortFirstRowIndex = this.indexes.first;
        if (this.scrollbarV) {
            var offsetScroll = this.rowHeightsCache.query(viewPortFirstRowIndex - 1);
            return offsetScroll <= this.offsetY ? viewPortFirstRowIndex - 1 : viewPortFirstRowIndex;
        }
        return viewPortFirstRowIndex;
    };
    /**
     * Toggle the Expansion of the row i.e. if the row is expanded then it will
     * collapse and vice versa.   Note that the expanded status is stored as
     * a part of the row object itself as we have to preserve the expanded row
     * status in case of sorting and filtering of the row set.
     *
     * @param {*} row The row for which the expansion needs to be toggled.
     *
     * @memberOf DataTableBodyComponent
     */
    DataTableBodyComponent.prototype.toggleRowExpansion = function (row) {
        // Capture the row index of the first row that is visible on the viewport.
        var viewPortFirstRowIndex = this.getAdjustedViewPortIndex();
        // If the detailRowHeight is auto --> only in case of non-virtualized scroll
        if (this.scrollbarV) {
            var detailRowHeight = this.getDetailRowHeight(row) * (row.$$expanded ? -1 : 1);
            this.rowHeightsCache.update(row.$$index, detailRowHeight);
        }
        // Update the toggled row and update the heights in the cache.
        row.$$expanded ^= 1;
        this.detailToggle.emit({
            rows: [row],
            currentIndex: viewPortFirstRowIndex
        });
    };
    /**
     * Expand/Collapse all the rows no matter what their state is.
     *
     * @param {boolean} expanded When true, all rows are expanded and when false, all rows will be collapsed.
     *
     * @memberOf DataTableBodyComponent
     */
    DataTableBodyComponent.prototype.toggleAllRows = function (expanded) {
        var rowExpanded = expanded ? 1 : 0;
        // Capture the row index of the first row that is visible on the viewport.
        var viewPortFirstRowIndex = this.getAdjustedViewPortIndex();
        for (var _i = 0, _a = this.rows; _i < _a.length; _i++) {
            var row = _a[_i];
            row.$$expanded = rowExpanded;
        }
        if (this.scrollbarV) {
            // Refresh the full row heights cache since every row was affected.
            this.recalcLayout();
        }
        // Emit all rows that have been expanded.
        this.detailToggle.emit({
            rows: this.rows,
            currentIndex: viewPortFirstRowIndex
        });
    };
    /**
     * Recalculates the table
     *
     * @memberOf DataTableBodyComponent
     */
    DataTableBodyComponent.prototype.recalcLayout = function () {
        this.refreshRowHeightCache();
        this.updateIndexes();
        this.updateRows();
    };
    return DataTableBodyComponent;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], DataTableBodyComponent.prototype, "scrollbarV", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], DataTableBodyComponent.prototype, "scrollbarH", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], DataTableBodyComponent.prototype, "loadingIndicator", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], DataTableBodyComponent.prototype, "externalPaging", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Number)
], DataTableBodyComponent.prototype, "rowHeight", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Number)
], DataTableBodyComponent.prototype, "offsetX", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], DataTableBodyComponent.prototype, "emptyMessage", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Number)
], DataTableBodyComponent.prototype, "selectionType", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Array)
], DataTableBodyComponent.prototype, "selected", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], DataTableBodyComponent.prototype, "rowIdentity", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], DataTableBodyComponent.prototype, "rowDetail", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], DataTableBodyComponent.prototype, "selectCheck", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], DataTableBodyComponent.prototype, "trackByProp", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], DataTableBodyComponent.prototype, "rowClass", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], DataTableBodyComponent.prototype, "pageSize", null);
__decorate([
    core_1.Input(),
    __metadata("design:type", Array),
    __metadata("design:paramtypes", [Array])
], DataTableBodyComponent.prototype, "rows", null);
__decorate([
    core_1.Input(),
    __metadata("design:type", Array),
    __metadata("design:paramtypes", [Array])
], DataTableBodyComponent.prototype, "columns", null);
__decorate([
    core_1.Input(),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], DataTableBodyComponent.prototype, "offset", null);
__decorate([
    core_1.Input(),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], DataTableBodyComponent.prototype, "rowCount", null);
__decorate([
    core_1.Input(),
    __metadata("design:type", Number)
], DataTableBodyComponent.prototype, "innerWidth", void 0);
__decorate([
    core_1.HostBinding('style.width'),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [])
], DataTableBodyComponent.prototype, "bodyWidth", null);
__decorate([
    core_1.Input(),
    core_1.HostBinding('style.height'),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [Object])
], DataTableBodyComponent.prototype, "bodyHeight", null);
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], DataTableBodyComponent.prototype, "scroll", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], DataTableBodyComponent.prototype, "page", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], DataTableBodyComponent.prototype, "activate", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], DataTableBodyComponent.prototype, "select", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], DataTableBodyComponent.prototype, "detailToggle", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", Object)
], DataTableBodyComponent.prototype, "rowContextmenu", void 0);
__decorate([
    core_1.ViewChild(scroller_component_1.ScrollerComponent),
    __metadata("design:type", scroller_component_1.ScrollerComponent)
], DataTableBodyComponent.prototype, "scroller", void 0);
DataTableBodyComponent = __decorate([
    core_1.Component({
        selector: 'datatable-body',
        template: "\n    <datatable-selection\n      #selector\n      [selected]=\"selected\"\n      [rows]=\"temp\"\n      [selectCheck]=\"selectCheck\"\n      [selectEnabled]=\"selectEnabled\"\n      [selectionType]=\"selectionType\"\n      [rowIdentity]=\"rowIdentity\"\n      (select)=\"select.emit($event)\"\n      (activate)=\"activate.emit($event)\">\n      <datatable-progress\n        *ngIf=\"loadingIndicator\">\n      </datatable-progress>\n      <datatable-scroller\n        *ngIf=\"rows?.length\"\n        [scrollbarV]=\"scrollbarV\"\n        [scrollbarH]=\"scrollbarH\"\n        [scrollHeight]=\"scrollHeight\"\n        [scrollWidth]=\"columnGroupWidths.total\"\n        (scroll)=\"onBodyScroll($event)\">\n        <datatable-row-wrapper\n          *ngFor=\"let row of temp; let i = index; trackBy: rowTrackingFn;\"\n          [ngStyle]=\"getRowsStyles(row)\"\n          [rowDetail]=\"rowDetail\"\n          [detailRowHeight]=\"getDetailRowHeight(row,i)\"\n          [row]=\"row\"\n          [expanded]=\"row.$$expanded === 1\"\n          (rowContextmenu)=\"rowContextmenu.emit($event)\">\n          <datatable-body-row\n            tabindex=\"-1\"\n            [isSelected]=\"selector.getRowSelected(row)\"\n            [innerWidth]=\"innerWidth\"\n            [offsetX]=\"offsetX\"\n            [columns]=\"columns\"\n            [rowHeight]=\"getRowHeight(row)\"\n            [row]=\"row\"\n            [rowClass]=\"rowClass\"\n            (activate)=\"selector.onActivate($event, i)\">\n          </datatable-body-row>\n        </datatable-row-wrapper>\n      </datatable-scroller>\n      <div\n        class=\"empty-row\"\n        *ngIf=\"!rows?.length\"\n        [innerHTML]=\"emptyMessage\">\n      </div>\n    </datatable-selection>\n  ",
        host: {
            class: 'datatable-body'
        }
    }),
    __metadata("design:paramtypes", [])
], DataTableBodyComponent);
exports.DataTableBodyComponent = DataTableBodyComponent;


/***/ }),

/***/ "./src/components/body/index.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__("./src/components/body/body.component.ts"));
__export(__webpack_require__("./src/components/body/body-cell.component.ts"));
__export(__webpack_require__("./src/components/body/body-row.component.ts"));
__export(__webpack_require__("./src/components/body/progress-bar.component.ts"));
__export(__webpack_require__("./src/components/body/scroller.component.ts"));
__export(__webpack_require__("./src/components/body/body-row-wrapper.component.ts"));
__export(__webpack_require__("./src/components/body/selection.component.ts"));


/***/ }),

/***/ "./src/components/body/progress-bar.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var ProgressBarComponent = (function () {
    function ProgressBarComponent() {
    }
    return ProgressBarComponent;
}());
ProgressBarComponent = __decorate([
    core_1.Component({
        selector: 'datatable-progress',
        template: "\n    <div class=\"progress-linear\" role=\"progressbar\">\n      <div class=\"container\">\n        <div class=\"bar\"></div>\n      </div>\n    </div>\n  ",
        changeDetection: core_1.ChangeDetectionStrategy.OnPush
    })
], ProgressBarComponent);
exports.ProgressBarComponent = ProgressBarComponent;


/***/ }),

/***/ "./src/components/body/scroller.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var ScrollerComponent = (function () {
    function ScrollerComponent(element, renderer) {
        this.renderer = renderer;
        this.scrollbarV = false;
        this.scrollbarH = false;
        this.scroll = new core_1.EventEmitter();
        this.scrollYPos = 0;
        this.scrollXPos = 0;
        this.prevScrollYPos = 0;
        this.prevScrollXPos = 0;
        this.element = element.nativeElement;
    }
    ScrollerComponent.prototype.ngOnInit = function () {
        // manual bind so we don't always listen
        if (this.scrollbarV || this.scrollbarH) {
            this.parentElement = this.element.parentElement.parentElement;
            this.onScrollListener = this.renderer.listen(this.parentElement, 'scroll', this.onScrolled.bind(this));
        }
    };
    ScrollerComponent.prototype.ngOnDestroy = function () {
        if (this.scrollbarV || this.scrollbarH) {
            this.onScrollListener();
        }
    };
    ScrollerComponent.prototype.setOffset = function (offsetY) {
        if (this.parentElement) {
            this.parentElement.scrollTop = offsetY;
        }
    };
    ScrollerComponent.prototype.onScrolled = function (event) {
        var dom = event.currentTarget;
        this.scrollYPos = dom.scrollTop;
        this.scrollXPos = dom.scrollLeft;
        requestAnimationFrame(this.updateOffset.bind(this));
    };
    ScrollerComponent.prototype.updateOffset = function () {
        var direction;
        if (this.scrollYPos < this.prevScrollYPos) {
            direction = 'down';
        }
        else if (this.scrollYPos > this.prevScrollYPos) {
            direction = 'up';
        }
        this.scroll.emit({
            direction: direction,
            scrollYPos: this.scrollYPos,
            scrollXPos: this.scrollXPos
        });
        this.prevScrollYPos = this.scrollYPos;
        this.prevScrollXPos = this.scrollXPos;
    };
    return ScrollerComponent;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], ScrollerComponent.prototype, "scrollbarV", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], ScrollerComponent.prototype, "scrollbarH", void 0);
__decorate([
    core_1.HostBinding('style.height.px'),
    core_1.Input(),
    __metadata("design:type", Number)
], ScrollerComponent.prototype, "scrollHeight", void 0);
__decorate([
    core_1.HostBinding('style.width.px'),
    core_1.Input(),
    __metadata("design:type", Number)
], ScrollerComponent.prototype, "scrollWidth", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], ScrollerComponent.prototype, "scroll", void 0);
ScrollerComponent = __decorate([
    core_1.Component({
        selector: 'datatable-scroller',
        template: "\n    <ng-content></ng-content>\n  ",
        host: {
            class: 'datatable-scroll'
        }
    }),
    __metadata("design:paramtypes", [core_1.ElementRef, core_1.Renderer])
], ScrollerComponent);
exports.ScrollerComponent = ScrollerComponent;


/***/ }),

/***/ "./src/components/body/selection.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var utils_1 = __webpack_require__("./src/utils/index.ts");
var types_1 = __webpack_require__("./src/types/index.ts");
var DataTableSelectionComponent = (function () {
    function DataTableSelectionComponent() {
        this.activate = new core_1.EventEmitter();
        this.select = new core_1.EventEmitter();
    }
    DataTableSelectionComponent.prototype.selectRow = function (event, index, row) {
        if (!this.selectEnabled)
            return;
        var chkbox = this.selectionType === types_1.SelectionType.checkbox;
        var multi = this.selectionType === types_1.SelectionType.multi;
        var multiClick = this.selectionType === types_1.SelectionType.multiClick;
        var selected = [];
        if (multi || chkbox || multiClick) {
            if (event.shiftKey) {
                selected = utils_1.selectRowsBetween([], this.rows, index, this.prevIndex, this.getRowSelectedIdx.bind(this));
            }
            else if (event.ctrlKey || multiClick || chkbox) {
                selected = utils_1.selectRows(this.selected.slice(), row, this.getRowSelectedIdx.bind(this));
            }
            else {
                selected = utils_1.selectRows([], row, this.getRowSelectedIdx.bind(this));
            }
        }
        else {
            selected = utils_1.selectRows([], row, this.getRowSelectedIdx.bind(this));
        }
        if (typeof this.selectCheck === 'function') {
            selected = selected.filter(this.selectCheck.bind(this));
        }
        this.selected.splice(0, this.selected.length);
        (_a = this.selected).push.apply(_a, selected);
        this.prevIndex = index;
        this.select.emit({
            selected: selected
        });
        var _a;
    };
    DataTableSelectionComponent.prototype.onActivate = function (model, index) {
        var type = model.type, event = model.event, row = model.row;
        var chkbox = this.selectionType === types_1.SelectionType.checkbox;
        var select = (!chkbox && (type === 'click' || type === 'dblclick')) ||
            (chkbox && type === 'checkbox');
        if (select) {
            this.selectRow(event, index, row);
        }
        else if (type === 'keydown') {
            if (event.keyCode === utils_1.Keys.return) {
                this.selectRow(event, index, row);
            }
            else {
                this.onKeyboardFocus(model);
            }
        }
        this.activate.emit(model);
    };
    DataTableSelectionComponent.prototype.onKeyboardFocus = function (model) {
        var keyCode = model.event.keyCode;
        var shouldFocus = keyCode === utils_1.Keys.up ||
            keyCode === utils_1.Keys.down ||
            keyCode === utils_1.Keys.right ||
            keyCode === utils_1.Keys.left;
        if (shouldFocus) {
            var isCellSelection = this.selectionType === types_1.SelectionType.cell;
            if (!model.cellElement || !isCellSelection) {
                this.focusRow(model.rowElement, keyCode);
            }
            else if (isCellSelection) {
                this.focusCell(model.cellElement, model.rowElement, keyCode, model.cellIndex);
            }
        }
    };
    DataTableSelectionComponent.prototype.focusRow = function (rowElement, keyCode) {
        var nextRowElement = this.getPrevNextRow(rowElement, keyCode);
        if (nextRowElement)
            nextRowElement.focus();
    };
    DataTableSelectionComponent.prototype.getPrevNextRow = function (rowElement, keyCode) {
        var parentElement = rowElement.parentElement;
        if (parentElement) {
            var focusElement = void 0;
            if (keyCode === utils_1.Keys.up) {
                focusElement = parentElement.previousElementSibling;
            }
            else if (keyCode === utils_1.Keys.down) {
                focusElement = parentElement.nextElementSibling;
            }
            if (focusElement && focusElement.children.length) {
                return focusElement.children[0];
            }
        }
    };
    DataTableSelectionComponent.prototype.focusCell = function (cellElement, rowElement, keyCode, cellIndex) {
        var nextCellElement;
        if (keyCode === utils_1.Keys.left) {
            nextCellElement = cellElement.previousElementSibling;
        }
        else if (keyCode === utils_1.Keys.right) {
            nextCellElement = cellElement.nextElementSibling;
        }
        else if (keyCode === utils_1.Keys.up || keyCode === utils_1.Keys.down) {
            var nextRowElement = this.getPrevNextRow(rowElement, keyCode);
            if (nextRowElement) {
                var children = nextRowElement.getElementsByClassName('datatable-body-cell');
                if (children.length)
                    nextCellElement = children[cellIndex];
            }
        }
        if (nextCellElement)
            nextCellElement.focus();
    };
    DataTableSelectionComponent.prototype.getRowSelected = function (row) {
        return this.getRowSelectedIdx(row, this.selected) > -1;
    };
    DataTableSelectionComponent.prototype.getRowSelectedIdx = function (row, selected) {
        var _this = this;
        if (!selected || !selected.length)
            return -1;
        var rowId = this.rowIdentity(row);
        return selected.findIndex(function (r) {
            var id = _this.rowIdentity(r);
            return id === rowId;
        });
    };
    return DataTableSelectionComponent;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", Array)
], DataTableSelectionComponent.prototype, "rows", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Array)
], DataTableSelectionComponent.prototype, "selected", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], DataTableSelectionComponent.prototype, "selectEnabled", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Number)
], DataTableSelectionComponent.prototype, "selectionType", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], DataTableSelectionComponent.prototype, "rowIdentity", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], DataTableSelectionComponent.prototype, "selectCheck", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], DataTableSelectionComponent.prototype, "activate", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], DataTableSelectionComponent.prototype, "select", void 0);
DataTableSelectionComponent = __decorate([
    core_1.Component({
        selector: 'datatable-selection',
        template: "\n    <ng-content></ng-content>\n  "
    })
], DataTableSelectionComponent);
exports.DataTableSelectionComponent = DataTableSelectionComponent;


/***/ }),

/***/ "./src/components/columns/column-cell.directive.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var DataTableColumnCellDirective = (function () {
    function DataTableColumnCellDirective(template) {
        this.template = template;
    }
    return DataTableColumnCellDirective;
}());
DataTableColumnCellDirective = __decorate([
    core_1.Directive({ selector: '[ngx-datatable-cell-template]' }),
    __metadata("design:paramtypes", [core_1.TemplateRef])
], DataTableColumnCellDirective);
exports.DataTableColumnCellDirective = DataTableColumnCellDirective;


/***/ }),

/***/ "./src/components/columns/column-header.directive.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var DataTableColumnHeaderDirective = (function () {
    function DataTableColumnHeaderDirective(template) {
        this.template = template;
    }
    return DataTableColumnHeaderDirective;
}());
DataTableColumnHeaderDirective = __decorate([
    core_1.Directive({ selector: '[ngx-datatable-header-template]' }),
    __metadata("design:paramtypes", [core_1.TemplateRef])
], DataTableColumnHeaderDirective);
exports.DataTableColumnHeaderDirective = DataTableColumnHeaderDirective;


/***/ }),

/***/ "./src/components/columns/column.directive.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var column_header_directive_1 = __webpack_require__("./src/components/columns/column-header.directive.ts");
var column_cell_directive_1 = __webpack_require__("./src/components/columns/column-cell.directive.ts");
var DataTableColumnDirective = (function () {
    function DataTableColumnDirective() {
    }
    return DataTableColumnDirective;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], DataTableColumnDirective.prototype, "name", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], DataTableColumnDirective.prototype, "prop", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], DataTableColumnDirective.prototype, "frozenLeft", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], DataTableColumnDirective.prototype, "frozenRight", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Number)
], DataTableColumnDirective.prototype, "flexGrow", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], DataTableColumnDirective.prototype, "resizeable", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], DataTableColumnDirective.prototype, "comparator", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], DataTableColumnDirective.prototype, "pipe", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], DataTableColumnDirective.prototype, "sortable", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], DataTableColumnDirective.prototype, "draggable", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], DataTableColumnDirective.prototype, "canAutoResize", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Number)
], DataTableColumnDirective.prototype, "minWidth", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Number)
], DataTableColumnDirective.prototype, "width", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Number)
], DataTableColumnDirective.prototype, "maxWidth", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], DataTableColumnDirective.prototype, "checkboxable", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], DataTableColumnDirective.prototype, "headerCheckboxable", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], DataTableColumnDirective.prototype, "headerClass", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], DataTableColumnDirective.prototype, "cellClass", void 0);
__decorate([
    core_1.Input(),
    core_1.ContentChild(column_cell_directive_1.DataTableColumnCellDirective, { read: core_1.TemplateRef }),
    __metadata("design:type", core_1.TemplateRef)
], DataTableColumnDirective.prototype, "cellTemplate", void 0);
__decorate([
    core_1.Input(),
    core_1.ContentChild(column_header_directive_1.DataTableColumnHeaderDirective, { read: core_1.TemplateRef }),
    __metadata("design:type", core_1.TemplateRef)
], DataTableColumnDirective.prototype, "headerTemplate", void 0);
DataTableColumnDirective = __decorate([
    core_1.Directive({ selector: 'ngx-datatable-column' })
], DataTableColumnDirective);
exports.DataTableColumnDirective = DataTableColumnDirective;


/***/ }),

/***/ "./src/components/columns/index.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__("./src/components/columns/column.directive.ts"));
__export(__webpack_require__("./src/components/columns/column-header.directive.ts"));
__export(__webpack_require__("./src/components/columns/column-cell.directive.ts"));


/***/ }),

/***/ "./src/components/datatable.component.scss":
/***/ (function(module, exports, __webpack_require__) {


        var result = __webpack_require__("./node_modules/css-loader/index.js!./node_modules/postcss-loader/index.js?sourceMap!./node_modules/sass-loader/lib/loader.js?sourceMap!./src/components/datatable.component.scss");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    

/***/ }),

/***/ "./src/components/datatable.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var utils_1 = __webpack_require__("./src/utils/index.ts");
var services_1 = __webpack_require__("./src/services/index.ts");
var types_1 = __webpack_require__("./src/types/index.ts");
var body_1 = __webpack_require__("./src/components/body/index.ts");
var columns_1 = __webpack_require__("./src/components/columns/index.ts");
var row_detail_1 = __webpack_require__("./src/components/row-detail/index.ts");
var footer_1 = __webpack_require__("./src/components/footer/index.ts");
var DatatableComponent = (function () {
    function DatatableComponent(scrollbarHelper, element, differs) {
        this.scrollbarHelper = scrollbarHelper;
        /**
         * List of row objects that should be
         * represented as selected in the grid.
         * Default value: `[]`
         *
         * @type {any[]}
         * @memberOf DatatableComponent
         */
        this.selected = [];
        /**
         * Enable vertical scrollbars
         *
         * @type {boolean}
         * @memberOf DatatableComponent
         */
        this.scrollbarV = false;
        /**
         * Enable horz scrollbars
         *
         * @type {boolean}
         * @memberOf DatatableComponent
         */
        this.scrollbarH = false;
        /**
         * The row height; which is necessary
         * to calculate the height for the lazy rendering.
         *
         * @type {number}
         * @memberOf DatatableComponent
         */
        this.rowHeight = 30;
        /**
         * Type of column width distribution formula.
         * Example: flex, force, standard
         *
         * @type {ColumnMode}
         * @memberOf DatatableComponent
         */
        this.columnMode = types_1.ColumnMode.standard;
        /**
         * The minimum header height in pixels.
         * Pass a falsey for no header
         *
         * @type {*}
         * @memberOf DatatableComponent
         */
        this.headerHeight = 30;
        /**
         * The minimum footer height in pixels.
         * Pass falsey for no footer
         *
         * @type {number}
         * @memberOf DatatableComponent
         */
        this.footerHeight = 0;
        /**
         * If the table should use external paging
         * otherwise its assumed that all data is preloaded.
         *
         * @type {boolean}
         * @memberOf DatatableComponent
         */
        this.externalPaging = false;
        /**
         * If the table should use external sorting or
         * the built-in basic sorting.
         *
         * @type {boolean}
         * @memberOf DatatableComponent
         */
        this.externalSorting = false;
        /**
         * The page size to be shown.
         * Default value: `undefined`
         *
         * @type {number}
         * @memberOf DatatableComponent
         */
        this.limit = undefined;
        /**
         * The current offset ( page - 1 ) shown.
         * Default value: `0`
         *
         * @type {number}
         * @memberOf DatatableComponent
         */
        this.offset = 0;
        /**
         * Show the linear loading bar.
         * Default value: `false`
         *
         * @type {boolean}
         * @memberOf DatatableComponent
         */
        this.loadingIndicator = false;
        /**
         * Enable/Disable ability to re-order columns
         * by dragging them.
         *
         * @type {boolean}
         * @memberOf DatatableComponent
         */
        this.reorderable = true;
        /**
         * The type of sorting
         *
         * @type {SortType}
         * @memberOf DatatableComponent
         */
        this.sortType = types_1.SortType.single;
        /**
         * Array of sorted columns by property and type.
         * Default value: `[]`
         *
         * @type {any[]}
         * @memberOf DatatableComponent
         */
        this.sorts = [];
        /**
         * Css class overrides
         *
         * @type {*}
         * @memberOf DatatableComponent
         */
        this.cssClasses = {
            sortAscending: 'datatable-icon-up',
            sortDescending: 'datatable-icon-down',
            pagerLeftArrow: 'datatable-icon-left',
            pagerRightArrow: 'datatable-icon-right',
            pagerPrevious: 'datatable-icon-prev',
            pagerNext: 'datatable-icon-skip'
        };
        /**
         * Message overrides for localization
         *
         * emptyMessage     [default] = 'No data to display'
         * totalMessage     [default] = 'total'
         * selectedMessage  [default] = 'selected'
         *
         * @type {*}
         * @memberOf DatatableComponent
         */
        this.messages = {
            // Message to show when array is presented
            // but contains no values
            emptyMessage: 'No data to display',
            // Footer total message
            totalMessage: 'total',
            // Footer selected message
            selectedMessage: 'selected'
        };
        /**
         * This will be used when displaying or selecting rows.
         * when tracking/comparing them, we'll use the value of this fn,
         *
         * (`fn(x) === fn(y)` instead of `x === y`)
         *
         * @memberOf DatatableComponent
         */
        this.rowIdentity = (function (x) { return x; });
        /**
         * Body was scrolled typically in a `scrollbarV:true` scenario.
         *
         * @type {EventEmitter<any>}
         * @memberOf DatatableComponent
         */
        this.scroll = new core_1.EventEmitter();
        /**
         * A cell or row was focused via keyboard or mouse click.
         *
         * @type {EventEmitter<any>}
         * @memberOf DatatableComponent
         */
        this.activate = new core_1.EventEmitter();
        /**
         * A cell or row was selected.
         *
         * @type {EventEmitter<any>}
         * @memberOf DatatableComponent
         */
        this.select = new core_1.EventEmitter();
        /**
         * Column sort was invoked.
         *
         * @type {EventEmitter<any>}
         * @memberOf DatatableComponent
         */
        this.sort = new core_1.EventEmitter();
        /**
         * The table was paged either triggered by the pager or the body scroll.
         *
         * @type {EventEmitter<any>}
         * @memberOf DatatableComponent
         */
        this.page = new core_1.EventEmitter();
        /**
         * Columns were re-ordered.
         *
         * @type {EventEmitter<any>}
         * @memberOf DatatableComponent
         */
        this.reorder = new core_1.EventEmitter();
        /**
         * Column was resized.
         *
         * @type {EventEmitter<any>}
         * @memberOf DatatableComponent
         */
        this.resize = new core_1.EventEmitter();
        /**
         * The context menu was invoked on a row.
         *
         * @memberOf DatatableComponent
         */
        this.rowContextmenu = new core_1.EventEmitter(false);
        this.rowCount = 0;
        this.offsetX = 0;
        this._count = 0;
        // get ref to elm for measuring
        this.element = element.nativeElement;
        this.rowDiffer = differs.find({}).create(null);
    }
    Object.defineProperty(DatatableComponent.prototype, "rows", {
        /**
         * Gets the rows.
         *
         * @readonly
         * @type {*}
         * @memberOf DatatableComponent
         */
        get: function () {
            return this._rows;
        },
        /**
         * Rows that are displayed in the table.
         *
         * @memberOf DatatableComponent
         */
        set: function (val) {
            // auto sort on new updates
            if (!this.externalSorting) {
                val = utils_1.sortRows(val, this.columns, this.sorts);
            }
            this._rows = val;
            // recalculate sizes/etc
            this.recalculate();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatatableComponent.prototype, "columns", {
        /**
         * Get the columns.
         *
         * @readonly
         * @type {any[]}
         * @memberOf DatatableComponent
         */
        get: function () {
            return this._columns;
        },
        /**
         * Columns to be displayed.
         *
         * @memberOf DatatableComponent
         */
        set: function (val) {
            if (val) {
                utils_1.setColumnDefaults(val);
                this.recalculateColumns(val);
            }
            this._columns = val;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatatableComponent.prototype, "count", {
        /**
         * Gets the count.
         *
         * @readonly
         * @type {number}
         * @memberOf DatatableComponent
         */
        get: function () {
            return this._count;
        },
        /**
         * The total count of all rows.
         * Default value: `0`
         *
         * @type {number}
         * @memberOf DatatableComponent
         */
        set: function (val) {
            this._count = val;
            // recalculate sizes/etc
            this.recalculate();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatatableComponent.prototype, "isFixedHeader", {
        /**
         * CSS class applied if the header height if fixed height.
         *
         * @readonly
         * @type {boolean}
         * @memberOf DatatableComponent
         */
        get: function () {
            var headerHeight = this.headerHeight;
            return (typeof headerHeight === 'string') ?
                headerHeight !== 'auto' : true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatatableComponent.prototype, "isFixedRow", {
        /**
         * CSS class applied to the root element if
         * the row heights are fixed heights.
         *
         * @readonly
         * @type {boolean}
         * @memberOf DatatableComponent
         */
        get: function () {
            var rowHeight = this.rowHeight;
            return (typeof rowHeight === 'string') ?
                rowHeight !== 'auto' : true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatatableComponent.prototype, "isVertScroll", {
        /**
         * CSS class applied to root element if
         * vertical scrolling is enabled.
         *
         * @readonly
         * @type {boolean}
         * @memberOf DatatableComponent
         */
        get: function () {
            return this.scrollbarV;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatatableComponent.prototype, "isHorScroll", {
        /**
         * CSS class applied to the root element
         * if the horziontal scrolling is enabled.
         *
         * @readonly
         * @type {boolean}
         * @memberOf DatatableComponent
         */
        get: function () {
            return this.scrollbarH;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatatableComponent.prototype, "isSelectable", {
        /**
         * CSS class applied to root element is selectable.
         *
         * @readonly
         * @type {boolean}
         * @memberOf DatatableComponent
         */
        get: function () {
            return this.selectionType !== undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatatableComponent.prototype, "isCheckboxSelection", {
        /**
         * CSS class applied to root is checkbox selection.
         *
         * @readonly
         * @type {boolean}
         * @memberOf DatatableComponent
         */
        get: function () {
            return this.selectionType === types_1.SelectionType.checkbox;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatatableComponent.prototype, "isCellSelection", {
        /**
         * CSS class applied to root if cell selection.
         *
         * @readonly
         * @type {boolean}
         * @memberOf DatatableComponent
         */
        get: function () {
            return this.selectionType === types_1.SelectionType.cell;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatatableComponent.prototype, "isSingleSelection", {
        /**
         * CSS class applied to root if single select.
         *
         * @readonly
         * @type {boolean}
         * @memberOf DatatableComponent
         */
        get: function () {
            return this.selectionType === types_1.SelectionType.single;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatatableComponent.prototype, "isMultiSelection", {
        /**
         * CSS class added to root element if mulit select
         *
         * @readonly
         * @type {boolean}
         * @memberOf DatatableComponent
         */
        get: function () {
            return this.selectionType === types_1.SelectionType.multi;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatatableComponent.prototype, "isMultiClickSelection", {
        /**
         * CSS class added to root element if mulit click select
         *
         * @readonly
         * @type {boolean}
         * @memberOf DatatableComponent
         */
        get: function () {
            return this.selectionType === types_1.SelectionType.multiClick;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatatableComponent.prototype, "columnTemplates", {
        /**
         * Returns the column templates.
         *
         * @readonly
         * @type {QueryList<DataTableColumnDirective>}
         * @memberOf DatatableComponent
         */
        get: function () {
            return this._columnTemplates;
        },
        /**
         * Column templates gathered from `ContentChildren`
         * if described in your markup.
         *
         * @memberOf DatatableComponent
         */
        set: function (val) {
            this._columnTemplates = val;
            if (val) {
                // only set this if results were brought back
                var arr = val.toArray();
                if (arr.length) {
                    // translate them to normal objects
                    this.columns = utils_1.translateTemplates(arr);
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatatableComponent.prototype, "allRowsSelected", {
        /**
         * Returns if all rows are selected.
         *
         * @readonly
         * @private
         * @type {boolean}
         * @memberOf DatatableComponent
         */
        get: function () {
            return this.selected &&
                this.rows &&
                this.rows.length !== 0 &&
                this.selected.length === this.rows.length;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Lifecycle hook that is called after data-bound
     * properties of a directive are initialized.
     *
     * @memberOf DatatableComponent
     */
    DatatableComponent.prototype.ngOnInit = function () {
        // need to call this immediatly to size
        // if the table is hidden the visibility
        // listener will invoke this itself upon show
        this.recalculate();
    };
    /**
     * Lifecycle hook that is called after a component's
     * view has been fully initialized.
     *
     * @memberOf DatatableComponent
     */
    DatatableComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        if (!this.externalSorting) {
            var val = utils_1.sortRows(this._rows, this.columns, this.sorts);
            this._rows = val;
        }
        // this has to be done to prevent the change detection
        // tree from freaking out because we are readjusting
        setTimeout(function () {
            _this.recalculate();
            // emit page for virtual server-side kickoff
            if (_this.externalPaging && _this.scrollbarV) {
                _this.page.emit({
                    count: _this.count,
                    pageSize: _this.pageSize,
                    limit: _this.limit,
                    offset: 0
                });
            }
        });
    };
    /**
     * Lifecycle hook that is called when Angular dirty checks a directive.
     *
     * @memberOf DatatableComponent
     */
    DatatableComponent.prototype.ngDoCheck = function () {
        if (this.rowDiffer.diff(this.rows)) {
            this.recalculatePages();
        }
    };
    /**
     * Recalc's the sizes of the grid.
     *
     * Updated automatically on changes to:
     *
     *  - Columns
     *  - Rows
     *  - Paging related
     *
     * Also can be manually invoked or upon window resize.
     *
     * @memberOf DatatableComponent
     */
    DatatableComponent.prototype.recalculate = function () {
        this.recalculateDims();
        this.recalculateColumns();
    };
    /**
     * Window resize handler to update sizes.
     *
     * @memberOf DatatableComponent
     */
    DatatableComponent.prototype.onWindowResize = function () {
        this.recalculate();
    };
    /**
     * Recalulcates the column widths based on column width
     * distribution mode and scrollbar offsets.
     *
     * @param {any[]} [columns=this.columns]
     * @param {number} [forceIdx=-1]
     * @param {boolean} [allowBleed=this.scrollH]
     * @returns {any[]}
     *
     * @memberOf DatatableComponent
     */
    DatatableComponent.prototype.recalculateColumns = function (columns, forceIdx, allowBleed) {
        if (columns === void 0) { columns = this.columns; }
        if (forceIdx === void 0) { forceIdx = -1; }
        if (allowBleed === void 0) { allowBleed = this.scrollbarH; }
        if (!columns)
            return;
        var width = this.innerWidth;
        if (this.scrollbarV) {
            width = width - this.scrollbarHelper.width;
        }
        if (this.columnMode === types_1.ColumnMode.force) {
            utils_1.forceFillColumnWidths(columns, width, forceIdx, allowBleed);
        }
        else if (this.columnMode === types_1.ColumnMode.flex) {
            utils_1.adjustColumnWidths(columns, width);
        }
        return columns;
    };
    /**
     * Recalculates the dimensions of the table size.
     * Internally calls the page size and row count calcs too.
     *
     * @memberOf DatatableComponent
     */
    DatatableComponent.prototype.recalculateDims = function () {
        var dims = this.element.getBoundingClientRect();
        this.innerWidth = Math.floor(dims.width);
        if (this.scrollbarV) {
            var height = dims.height;
            if (this.headerHeight)
                height = height - this.headerHeight;
            if (this.footerHeight)
                height = height - this.footerHeight;
            this.bodyHeight = height;
        }
        this.recalculatePages();
    };
    /**
     * Recalculates the pages after a update.
     *
     *
     * @memberOf DatatableComponent
     */
    DatatableComponent.prototype.recalculatePages = function () {
        this.pageSize = this.calcPageSize();
        this.rowCount = this.calcRowCount();
    };
    /**
     * Body triggered a page event.
     *
     * @param {*} { offset }
     *
     * @memberOf DatatableComponent
     */
    DatatableComponent.prototype.onBodyPage = function (_a) {
        var offset = _a.offset;
        this.offset = offset;
        this.page.emit({
            count: this.count,
            pageSize: this.pageSize,
            limit: this.limit,
            offset: this.offset
        });
    };
    /**
     * The body triggered a scroll event.
     *
     * @param {MouseEvent} event
     *
     * @memberOf DatatableComponent
     */
    DatatableComponent.prototype.onBodyScroll = function (event) {
        this.offsetX = event.offsetX;
        this.scroll.emit(event);
    };
    /**
     * The footer triggered a page event.
     *
     * @param {*} event
     *
     * @memberOf DatatableComponent
     */
    DatatableComponent.prototype.onFooterPage = function (event) {
        this.offset = event.page - 1;
        this.bodyComponent.updateOffsetY(this.offset);
        this.page.emit({
            count: this.count,
            pageSize: this.pageSize,
            limit: this.limit,
            offset: this.offset
        });
    };
    /**
     * Recalculates the sizes of the page
     *
     * @param {any[]} [val=this.rows]
     * @returns {number}
     *
     * @memberOf DatatableComponent
     */
    DatatableComponent.prototype.calcPageSize = function (val) {
        if (val === void 0) { val = this.rows; }
        // Keep the page size constant even if the row has been expanded.
        // This is because an expanded row is still considered to be a child of
        // the original row.  Hence calculation would use rowHeight only.
        if (this.scrollbarV) {
            var size = Math.ceil(this.bodyHeight / this.rowHeight);
            return Math.max(size, 0);
        }
        // if limit is passed, we are paging
        if (this.limit !== undefined)
            return this.limit;
        // otherwise use row length
        if (val)
            return val.length;
        // other empty :(
        return 0;
    };
    /**
     * Calculates the row count.
     *
     * @param {any[]} [val=this.rows]
     * @returns {number}
     *
     * @memberOf DatatableComponent
     */
    DatatableComponent.prototype.calcRowCount = function (val) {
        if (val === void 0) { val = this.rows; }
        if (!this.externalPaging) {
            if (!val)
                return 0;
            return val.length;
        }
        return this.count;
    };
    /**
     * The header triggered a column resize event.
     *
     * @param {*} { column, newValue }
     *
     * @memberOf DatatableComponent
     */
    DatatableComponent.prototype.onColumnResize = function (_a) {
        var column = _a.column, newValue = _a.newValue;
        /* Safari/iOS 10.2 workaround */
        if (column === undefined) {
            return;
        }
        var idx;
        var cols = this.columns.map(function (c, i) {
            c = Object.assign({}, c);
            if (c.$$id === column.$$id) {
                idx = i;
                c.width = newValue;
                // set this so we can force the column
                // width distribution to be to this value
                c.$$oldWidth = newValue;
            }
            return c;
        });
        this.recalculateColumns(cols, idx);
        this._columns = cols;
        this.resize.emit({
            column: column,
            newValue: newValue
        });
    };
    /**
     * The header triggered a column re-order event.
     *
     * @param {*} { column, newValue, prevValue }
     *
     * @memberOf DatatableComponent
     */
    DatatableComponent.prototype.onColumnReorder = function (_a) {
        var column = _a.column, newValue = _a.newValue, prevValue = _a.prevValue;
        var cols = this.columns.map(function (c) {
            return Object.assign({}, c);
        });
        var prevCol = cols[newValue];
        cols[newValue] = column;
        cols[prevValue] = prevCol;
        this.columns = cols;
        this.reorder.emit({
            column: column,
            newValue: newValue,
            prevValue: prevValue
        });
    };
    /**
     * The header triggered a column sort event.
     *
     * @param {*} event
     *
     * @memberOf DatatableComponent
     */
    DatatableComponent.prototype.onColumnSort = function (event) {
        var sorts = event.sorts;
        // this could be optimized better since it will resort
        // the rows again on the 'push' detection...
        if (this.externalSorting === false) {
            // don't use normal setter so we don't resort
            this._rows = utils_1.sortRows(this.rows, this.columns, sorts);
        }
        this.sorts = sorts;
        // Always go to first page when sorting to see the newly sorted data
        this.offset = 0;
        this.bodyComponent.updateOffsetY(this.offset);
        this.sort.emit(event);
    };
    /**
     * Toggle all row selection
     *
     * @param {*} event
     *
     * @memberOf DatatableComponent
     */
    DatatableComponent.prototype.onHeaderSelect = function (event) {
        // before we splice, chk if we currently have all selected
        var allSelected = this.selected.length === this.rows.length;
        // remove all existing either way
        this.selected = [];
        // do the opposite here
        if (!allSelected) {
            (_a = this.selected).push.apply(_a, this.rows);
        }
        this.select.emit({
            selected: this.selected
        });
        var _a;
    };
    /**
     * A row was selected from body
     *
     * @param {*} event
     *
     * @memberOf DatatableComponent
     */
    DatatableComponent.prototype.onBodySelect = function (event) {
        this.select.emit(event);
    };
    return DatatableComponent;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [Object])
], DatatableComponent.prototype, "rows", null);
__decorate([
    core_1.Input(),
    __metadata("design:type", Array),
    __metadata("design:paramtypes", [Array])
], DatatableComponent.prototype, "columns", null);
__decorate([
    core_1.Input(),
    __metadata("design:type", Array)
], DatatableComponent.prototype, "selected", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], DatatableComponent.prototype, "scrollbarV", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], DatatableComponent.prototype, "scrollbarH", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Number)
], DatatableComponent.prototype, "rowHeight", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Number)
], DatatableComponent.prototype, "columnMode", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], DatatableComponent.prototype, "headerHeight", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Number)
], DatatableComponent.prototype, "footerHeight", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], DatatableComponent.prototype, "externalPaging", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], DatatableComponent.prototype, "externalSorting", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Number)
], DatatableComponent.prototype, "limit", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], DatatableComponent.prototype, "count", null);
__decorate([
    core_1.Input(),
    __metadata("design:type", Number)
], DatatableComponent.prototype, "offset", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], DatatableComponent.prototype, "loadingIndicator", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Number)
], DatatableComponent.prototype, "selectionType", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], DatatableComponent.prototype, "reorderable", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Number)
], DatatableComponent.prototype, "sortType", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Array)
], DatatableComponent.prototype, "sorts", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], DatatableComponent.prototype, "cssClasses", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], DatatableComponent.prototype, "messages", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Function)
], DatatableComponent.prototype, "rowIdentity", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], DatatableComponent.prototype, "rowClass", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], DatatableComponent.prototype, "selectCheck", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], DatatableComponent.prototype, "trackByProp", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], DatatableComponent.prototype, "scroll", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], DatatableComponent.prototype, "activate", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], DatatableComponent.prototype, "select", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], DatatableComponent.prototype, "sort", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], DatatableComponent.prototype, "page", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], DatatableComponent.prototype, "reorder", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], DatatableComponent.prototype, "resize", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", Object)
], DatatableComponent.prototype, "rowContextmenu", void 0);
__decorate([
    core_1.HostBinding('class.fixed-header'),
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [])
], DatatableComponent.prototype, "isFixedHeader", null);
__decorate([
    core_1.HostBinding('class.fixed-row'),
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [])
], DatatableComponent.prototype, "isFixedRow", null);
__decorate([
    core_1.HostBinding('class.scroll-vertical'),
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [])
], DatatableComponent.prototype, "isVertScroll", null);
__decorate([
    core_1.HostBinding('class.scroll-horz'),
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [])
], DatatableComponent.prototype, "isHorScroll", null);
__decorate([
    core_1.HostBinding('class.selectable'),
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [])
], DatatableComponent.prototype, "isSelectable", null);
__decorate([
    core_1.HostBinding('class.checkbox-selection'),
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [])
], DatatableComponent.prototype, "isCheckboxSelection", null);
__decorate([
    core_1.HostBinding('class.cell-selection'),
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [])
], DatatableComponent.prototype, "isCellSelection", null);
__decorate([
    core_1.HostBinding('class.single-selection'),
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [])
], DatatableComponent.prototype, "isSingleSelection", null);
__decorate([
    core_1.HostBinding('class.multi-selection'),
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [])
], DatatableComponent.prototype, "isMultiSelection", null);
__decorate([
    core_1.HostBinding('class.multi-click-selection'),
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [])
], DatatableComponent.prototype, "isMultiClickSelection", null);
__decorate([
    core_1.ContentChildren(columns_1.DataTableColumnDirective),
    __metadata("design:type", core_1.QueryList),
    __metadata("design:paramtypes", [core_1.QueryList])
], DatatableComponent.prototype, "columnTemplates", null);
__decorate([
    core_1.ContentChild(row_detail_1.DatatableRowDetailDirective),
    __metadata("design:type", row_detail_1.DatatableRowDetailDirective)
], DatatableComponent.prototype, "rowDetail", void 0);
__decorate([
    core_1.ContentChild(footer_1.DatatableFooterDirective),
    __metadata("design:type", footer_1.DatatableFooterDirective)
], DatatableComponent.prototype, "footer", void 0);
__decorate([
    core_1.ViewChild(body_1.DataTableBodyComponent),
    __metadata("design:type", body_1.DataTableBodyComponent)
], DatatableComponent.prototype, "bodyComponent", void 0);
__decorate([
    core_1.HostListener('window:resize'),
    utils_1.throttleable(5),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], DatatableComponent.prototype, "onWindowResize", null);
DatatableComponent = __decorate([
    core_1.Component({
        selector: 'ngx-datatable',
        template: "\n    <div\n      visibilityObserver\n      (visible)=\"recalculate()\">\n      <datatable-header\n        *ngIf=\"headerHeight\"\n        [sorts]=\"sorts\"\n        [sortType]=\"sortType\"\n        [scrollbarH]=\"scrollbarH\"\n        [innerWidth]=\"innerWidth\"\n        [offsetX]=\"offsetX\"\n        [columns]=\"columns\"\n        [headerHeight]=\"headerHeight\"\n        [reorderable]=\"reorderable\"\n        [sortAscendingIcon]=\"cssClasses.sortAscending\"\n        [sortDescendingIcon]=\"cssClasses.sortDescending\"\n        [allRowsSelected]=\"allRowsSelected\"\n        [selectionType]=\"selectionType\"\n        (sort)=\"onColumnSort($event)\"\n        (resize)=\"onColumnResize($event)\"\n        (reorder)=\"onColumnReorder($event)\"\n        (select)=\"onHeaderSelect($event)\">\n      </datatable-header>\n      <datatable-body\n        [rows]=\"rows\"\n        [scrollbarV]=\"scrollbarV\"\n        [scrollbarH]=\"scrollbarH\"\n        [loadingIndicator]=\"loadingIndicator\"\n        [externalPaging]=\"externalPaging\"\n        [rowHeight]=\"rowHeight\"\n        [rowCount]=\"rowCount\"\n        [offset]=\"offset\"\n        [trackByProp]=\"trackByProp\"\n        [columns]=\"columns\"\n        [pageSize]=\"pageSize\"\n        [offsetX]=\"offsetX\"\n        [rowDetail]=\"rowDetail\"\n        [selected]=\"selected\"\n        [innerWidth]=\"innerWidth\"\n        [bodyHeight]=\"bodyHeight\"\n        [selectionType]=\"selectionType\"\n        [emptyMessage]=\"messages.emptyMessage\"\n        [rowIdentity]=\"rowIdentity\"\n        [rowClass]=\"rowClass\"\n        [selectCheck]=\"selectCheck\"\n        (page)=\"onBodyPage($event)\"\n        (activate)=\"activate.emit($event)\"\n        (rowContextmenu)=\"rowContextmenu.emit($event)\"\n        (select)=\"onBodySelect($event)\"\n        (scroll)=\"onBodyScroll($event)\">\n      </datatable-body>\n      <datatable-footer\n        *ngIf=\"footerHeight\"\n        [rowCount]=\"rowCount\"\n        [pageSize]=\"pageSize\"\n        [offset]=\"offset\"\n        [footerHeight]=\"footerHeight\"\n        [footerTemplate]=\"footer\"\n        [totalMessage]=\"messages.totalMessage\"\n        [pagerLeftArrowIcon]=\"cssClasses.pagerLeftArrow\"\n        [pagerRightArrowIcon]=\"cssClasses.pagerRightArrow\"\n        [pagerPreviousIcon]=\"cssClasses.pagerPrevious\"\n        [selectedCount]=\"selected.length\"\n        [selectedMessage]=\"!!selectionType && messages.selectedMessage\"\n        [pagerNextIcon]=\"cssClasses.pagerNext\"\n        (page)=\"onFooterPage($event)\">\n      </datatable-footer>\n    </div>\n  ",
        encapsulation: core_1.ViewEncapsulation.None,
        styles: [__webpack_require__("./src/components/datatable.component.scss")],
        host: {
            class: 'ngx-datatable'
        }
    }),
    __metadata("design:paramtypes", [services_1.ScrollbarHelper,
        core_1.ElementRef,
        core_1.KeyValueDiffers])
], DatatableComponent);
exports.DatatableComponent = DatatableComponent;


/***/ }),

/***/ "./src/components/footer/footer-template.directive.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var DataTableFooterTemplateDirective = (function () {
    function DataTableFooterTemplateDirective(template) {
        this.template = template;
    }
    return DataTableFooterTemplateDirective;
}());
DataTableFooterTemplateDirective = __decorate([
    core_1.Directive({ selector: '[ngx-datatable-footer-template]' }),
    __metadata("design:paramtypes", [core_1.TemplateRef])
], DataTableFooterTemplateDirective);
exports.DataTableFooterTemplateDirective = DataTableFooterTemplateDirective;


/***/ }),

/***/ "./src/components/footer/footer.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var DataTableFooterComponent = (function () {
    function DataTableFooterComponent() {
        this.selectedCount = 0;
        this.page = new core_1.EventEmitter();
    }
    Object.defineProperty(DataTableFooterComponent.prototype, "isVisible", {
        get: function () {
            return (this.rowCount / this.pageSize) > 1;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTableFooterComponent.prototype, "curPage", {
        get: function () {
            return this.offset + 1;
        },
        enumerable: true,
        configurable: true
    });
    return DataTableFooterComponent;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", Number)
], DataTableFooterComponent.prototype, "footerHeight", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Number)
], DataTableFooterComponent.prototype, "rowCount", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Number)
], DataTableFooterComponent.prototype, "pageSize", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Number)
], DataTableFooterComponent.prototype, "offset", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], DataTableFooterComponent.prototype, "pagerLeftArrowIcon", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], DataTableFooterComponent.prototype, "pagerRightArrowIcon", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], DataTableFooterComponent.prototype, "pagerPreviousIcon", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], DataTableFooterComponent.prototype, "pagerNextIcon", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], DataTableFooterComponent.prototype, "totalMessage", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", core_1.TemplateRef)
], DataTableFooterComponent.prototype, "footerTemplate", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Number)
], DataTableFooterComponent.prototype, "selectedCount", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], DataTableFooterComponent.prototype, "selectedMessage", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], DataTableFooterComponent.prototype, "page", void 0);
DataTableFooterComponent = __decorate([
    core_1.Component({
        selector: 'datatable-footer',
        template: "\n    <div\n      class=\"datatable-footer-inner\"\n      [ngClass]=\"{'selected-count': selectedMessage}\"\n      [style.height.px]=\"footerHeight\">\n      <ng-template\n        *ngIf=\"footerTemplate\"\n        [ngTemplateOutlet]=\"footerTemplate.template\"\n        [ngOutletContext]=\"{ \n          rowCount: rowCount, \n          pageSize: pageSize, \n          selectedCount: selectedCount,\n          curPage: curPage,\n          offset: offset\n        }\">\n      </ng-template>\n      <div class=\"page-count\" *ngIf=\"!footerTemplate\">\n        <span *ngIf=\"selectedMessage\">\n          {{selectedCount.toLocaleString()}} {{selectedMessage}} / \n        </span>\n        {{rowCount.toLocaleString()}} {{totalMessage}}\n      </div>\n      <datatable-pager *ngIf=\"!footerTemplate\"\n        [pagerLeftArrowIcon]=\"pagerLeftArrowIcon\"\n        [pagerRightArrowIcon]=\"pagerRightArrowIcon\"\n        [pagerPreviousIcon]=\"pagerPreviousIcon\"\n        [pagerNextIcon]=\"pagerNextIcon\"\n        [page]=\"curPage\"\n        [size]=\"pageSize\"\n        [count]=\"rowCount\"\n        [hidden]=\"!isVisible\"\n        (change)=\"page.emit($event)\">\n      </datatable-pager>\n    </div>\n  ",
        host: {
            class: 'datatable-footer'
        },
        changeDetection: core_1.ChangeDetectionStrategy.OnPush
    })
], DataTableFooterComponent);
exports.DataTableFooterComponent = DataTableFooterComponent;


/***/ }),

/***/ "./src/components/footer/footer.directive.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var footer_template_directive_1 = __webpack_require__("./src/components/footer/footer-template.directive.ts");
var DatatableFooterDirective = (function () {
    function DatatableFooterDirective() {
    }
    return DatatableFooterDirective;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", Number)
], DatatableFooterDirective.prototype, "footerHeight", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], DatatableFooterDirective.prototype, "totalMessage", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], DatatableFooterDirective.prototype, "selectedMessage", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], DatatableFooterDirective.prototype, "pagerLeftArrowIcon", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], DatatableFooterDirective.prototype, "pagerRightArrowIcon", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], DatatableFooterDirective.prototype, "pagerPreviousIcon", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], DatatableFooterDirective.prototype, "pagerNextIcon", void 0);
__decorate([
    core_1.Input(),
    core_1.ContentChild(footer_template_directive_1.DataTableFooterTemplateDirective, { read: core_1.TemplateRef }),
    __metadata("design:type", core_1.TemplateRef)
], DatatableFooterDirective.prototype, "template", void 0);
DatatableFooterDirective = __decorate([
    core_1.Directive({ selector: 'ngx-datatable-footer' })
], DatatableFooterDirective);
exports.DatatableFooterDirective = DatatableFooterDirective;


/***/ }),

/***/ "./src/components/footer/index.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__("./src/components/footer/footer.component.ts"));
__export(__webpack_require__("./src/components/footer/pager.component.ts"));
__export(__webpack_require__("./src/components/footer/footer.directive.ts"));
__export(__webpack_require__("./src/components/footer/footer-template.directive.ts"));


/***/ }),

/***/ "./src/components/footer/pager.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var DataTablePagerComponent = (function () {
    function DataTablePagerComponent() {
        this.change = new core_1.EventEmitter();
        this._count = 0;
        this._page = 1;
        this._size = 0;
    }
    Object.defineProperty(DataTablePagerComponent.prototype, "size", {
        get: function () {
            return this._size;
        },
        set: function (val) {
            this._size = val;
            this.pages = this.calcPages();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTablePagerComponent.prototype, "count", {
        get: function () {
            return this._count;
        },
        set: function (val) {
            this._count = val;
            this.pages = this.calcPages();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTablePagerComponent.prototype, "page", {
        get: function () {
            return this._page;
        },
        set: function (val) {
            this._page = val;
            this.pages = this.calcPages();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTablePagerComponent.prototype, "totalPages", {
        get: function () {
            var count = this.size < 1 ? 1 : Math.ceil(this.count / this.size);
            return Math.max(count || 0, 1);
        },
        enumerable: true,
        configurable: true
    });
    DataTablePagerComponent.prototype.canPrevious = function () {
        return this.page > 1;
    };
    DataTablePagerComponent.prototype.canNext = function () {
        return this.page < this.totalPages;
    };
    DataTablePagerComponent.prototype.prevPage = function () {
        this.selectPage(this.page - 1);
    };
    DataTablePagerComponent.prototype.nextPage = function () {
        this.selectPage(this.page + 1);
    };
    DataTablePagerComponent.prototype.selectPage = function (page) {
        if (page > 0 && page <= this.totalPages && page !== this.page) {
            this.page = page;
            this.change.emit({
                page: page
            });
        }
    };
    DataTablePagerComponent.prototype.calcPages = function (page) {
        var pages = [];
        var startPage = 1;
        var endPage = this.totalPages;
        var maxSize = 5;
        var isMaxSized = maxSize < this.totalPages;
        page = page || this.page;
        if (isMaxSized) {
            startPage = ((Math.ceil(page / maxSize) - 1) * maxSize) + 1;
            endPage = Math.min(startPage + maxSize - 1, this.totalPages);
        }
        for (var num = startPage; num <= endPage; num++) {
            pages.push({
                number: num,
                text: num
            });
        }
        return pages;
    };
    return DataTablePagerComponent;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], DataTablePagerComponent.prototype, "pagerLeftArrowIcon", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], DataTablePagerComponent.prototype, "pagerRightArrowIcon", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], DataTablePagerComponent.prototype, "pagerPreviousIcon", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], DataTablePagerComponent.prototype, "pagerNextIcon", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], DataTablePagerComponent.prototype, "size", null);
__decorate([
    core_1.Input(),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], DataTablePagerComponent.prototype, "count", null);
__decorate([
    core_1.Input(),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], DataTablePagerComponent.prototype, "page", null);
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], DataTablePagerComponent.prototype, "change", void 0);
DataTablePagerComponent = __decorate([
    core_1.Component({
        selector: 'datatable-pager',
        template: "\n    <ul class=\"pager\">\n      <li [class.disabled]=\"!canPrevious()\">\n        <a\n          href=\"javascript:void(0)\"\n          (click)=\"selectPage(1)\">\n          <i class=\"{{pagerPreviousIcon}}\"></i>\n        </a>\n      </li>\n      <li [class.disabled]=\"!canPrevious()\">\n        <a\n          href=\"javascript:void(0)\"\n          (click)=\"prevPage()\">\n          <i class=\"{{pagerLeftArrowIcon}}\"></i>\n        </a>\n      </li>\n      <li\n        class=\"pages\"\n        *ngFor=\"let pg of pages\"\n        [class.active]=\"pg.number === page\">\n        <a\n          href=\"javascript:void(0)\"\n          (click)=\"selectPage(pg.number)\">\n          {{pg.text}}\n        </a>\n      </li>\n      <li [class.disabled]=\"!canNext()\">\n        <a\n          href=\"javascript:void(0)\"\n          (click)=\"nextPage()\">\n          <i class=\"{{pagerRightArrowIcon}}\"></i>\n        </a>\n      </li>\n      <li [class.disabled]=\"!canNext()\">\n        <a\n          href=\"javascript:void(0)\"\n          (click)=\"selectPage(totalPages)\">\n          <i class=\"{{pagerNextIcon}}\"></i>\n        </a>\n      </li>\n    </ul>\n  ",
        host: {
            class: 'datatable-pager'
        },
        changeDetection: core_1.ChangeDetectionStrategy.OnPush
    })
], DataTablePagerComponent);
exports.DataTablePagerComponent = DataTablePagerComponent;


/***/ }),

/***/ "./src/components/header/header-cell.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var types_1 = __webpack_require__("./src/types/index.ts");
var utils_1 = __webpack_require__("./src/utils/index.ts");
var DataTableHeaderCellComponent = (function () {
    function DataTableHeaderCellComponent() {
        this.sort = new core_1.EventEmitter();
        this.select = new core_1.EventEmitter();
        this.sortFn = this.onSort.bind(this);
        this.selectFn = this.select.emit.bind(this.select);
    }
    Object.defineProperty(DataTableHeaderCellComponent.prototype, "sorts", {
        get: function () {
            return this._sorts;
        },
        set: function (val) {
            this._sorts = val;
            this.sortDir = this.calcSortDir(val);
            this.sortClass = this.calcSortClass(this.sortDir);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTableHeaderCellComponent.prototype, "columnCssClasses", {
        get: function () {
            var cls = 'datatable-header-cell';
            if (this.column.sortable)
                cls += ' sortable';
            if (this.column.resizeable)
                cls += ' resizeable';
            if (this.column.headerClass) {
                if (typeof this.column.headerClass === 'string') {
                    cls += ' ' + this.column.headerClass;
                }
                else if (typeof this.column.headerClass === 'function') {
                    var res = this.column.headerClass({
                        column: this.column
                    });
                    if (typeof res === 'string') {
                        cls += res;
                    }
                    else if (typeof res === 'object') {
                        var keys = Object.keys(res);
                        for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
                            var k = keys_1[_i];
                            if (res[k] === true)
                                cls += " " + k;
                        }
                    }
                }
            }
            var sortDir = this.sortDir;
            if (sortDir) {
                cls += " sort-active sort-" + sortDir;
            }
            return cls;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTableHeaderCellComponent.prototype, "name", {
        get: function () {
            // guaranteed to have a value by setColumnDefaults() in column-helper.ts
            return this.column.headerTemplate === undefined ? this.column.name : undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTableHeaderCellComponent.prototype, "minWidth", {
        get: function () {
            return this.column.minWidth;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTableHeaderCellComponent.prototype, "maxWidth", {
        get: function () {
            return this.column.maxWidth;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTableHeaderCellComponent.prototype, "width", {
        get: function () {
            return this.column.width;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTableHeaderCellComponent.prototype, "isCheckboxable", {
        get: function () {
            return this.column.checkboxable &&
                this.column.headerCheckboxable &&
                this.selectionType === types_1.SelectionType.checkbox;
        },
        enumerable: true,
        configurable: true
    });
    DataTableHeaderCellComponent.prototype.calcSortDir = function (sorts) {
        var _this = this;
        if (sorts && this.column) {
            var sort = sorts.find(function (s) {
                return s.prop === _this.column.prop;
            });
            if (sort)
                return sort.dir;
        }
    };
    DataTableHeaderCellComponent.prototype.onSort = function () {
        if (!this.column.sortable)
            return;
        var newValue = utils_1.nextSortDir(this.sortType, this.sortDir);
        this.sort.emit({
            column: this.column,
            prevValue: this.sortDir,
            newValue: newValue
        });
    };
    DataTableHeaderCellComponent.prototype.calcSortClass = function (sortDir) {
        if (sortDir === types_1.SortDirection.asc) {
            return "sort-btn sort-asc " + this.sortAscendingIcon;
        }
        else if (sortDir === types_1.SortDirection.desc) {
            return "sort-btn sort-desc " + this.sortDescendingIcon;
        }
        else {
            return "sort-btn";
        }
    };
    return DataTableHeaderCellComponent;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", Number)
], DataTableHeaderCellComponent.prototype, "sortType", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], DataTableHeaderCellComponent.prototype, "column", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], DataTableHeaderCellComponent.prototype, "sortAscendingIcon", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", String)
], DataTableHeaderCellComponent.prototype, "sortDescendingIcon", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], DataTableHeaderCellComponent.prototype, "allRowsSelected", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Number)
], DataTableHeaderCellComponent.prototype, "selectionType", void 0);
__decorate([
    core_1.HostBinding('style.height.px'),
    core_1.Input(),
    __metadata("design:type", Number)
], DataTableHeaderCellComponent.prototype, "headerHeight", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Array),
    __metadata("design:paramtypes", [Array])
], DataTableHeaderCellComponent.prototype, "sorts", null);
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], DataTableHeaderCellComponent.prototype, "sort", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], DataTableHeaderCellComponent.prototype, "select", void 0);
__decorate([
    core_1.HostBinding('class'),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], DataTableHeaderCellComponent.prototype, "columnCssClasses", null);
__decorate([
    core_1.HostBinding('attr.title'),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [])
], DataTableHeaderCellComponent.prototype, "name", null);
__decorate([
    core_1.HostBinding('style.minWidth.px'),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [])
], DataTableHeaderCellComponent.prototype, "minWidth", null);
__decorate([
    core_1.HostBinding('style.maxWidth.px'),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [])
], DataTableHeaderCellComponent.prototype, "maxWidth", null);
__decorate([
    core_1.HostBinding('style.width.px'),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [])
], DataTableHeaderCellComponent.prototype, "width", null);
DataTableHeaderCellComponent = __decorate([
    core_1.Component({
        selector: 'datatable-header-cell',
        template: "\n    <div>\n      <label\n        *ngIf=\"isCheckboxable\" \n        class=\"datatable-checkbox\">\n        <input \n          type=\"checkbox\"\n          [checked]=\"allRowsSelected\"\n          (change)=\"select.emit(!allRowsSelected)\" \n        />\n      </label>\n      <span \n        *ngIf=\"!column.headerTemplate\"\n        class=\"datatable-header-cell-wrapper\">\n        <span\n          class=\"datatable-header-cell-label draggable\"\n          (click)=\"onSort()\"\n          [innerHTML]=\"name\">\n        </span>\n      </span>\n      <ng-template\n        *ngIf=\"column.headerTemplate\"\n        [ngTemplateOutlet]=\"column.headerTemplate\"\n        [ngOutletContext]=\"{ \n          column: column, \n          sortDir: sortDir,\n          sortFn: sortFn,\n          allRowsSelected: allRowsSelected,\n          selectFn: selectFn\n        }\">\n      </ng-template>\n      <span\n        (click)=\"onSort()\"\n        [class]=\"sortClass\">\n      </span>\n    </div>\n  "
    })
], DataTableHeaderCellComponent);
exports.DataTableHeaderCellComponent = DataTableHeaderCellComponent;


/***/ }),

/***/ "./src/components/header/header.component.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var types_1 = __webpack_require__("./src/types/index.ts");
var utils_1 = __webpack_require__("./src/utils/index.ts");
var DataTableHeaderComponent = (function () {
    function DataTableHeaderComponent() {
        this.sort = new core_1.EventEmitter();
        this.reorder = new core_1.EventEmitter();
        this.resize = new core_1.EventEmitter();
        this.select = new core_1.EventEmitter();
    }
    Object.defineProperty(DataTableHeaderComponent.prototype, "headerHeight", {
        get: function () {
            return this._headerHeight;
        },
        set: function (val) {
            if (val !== 'auto') {
                this._headerHeight = val + "px";
            }
            else {
                this._headerHeight = val;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataTableHeaderComponent.prototype, "columns", {
        get: function () {
            return this._columns;
        },
        set: function (val) {
            this._columns = val;
            var colsByPin = utils_1.columnsByPin(val);
            this.columnsByPin = utils_1.columnsByPinArr(val);
            this.columnGroupWidths = utils_1.columnGroupWidths(colsByPin, val);
        },
        enumerable: true,
        configurable: true
    });
    DataTableHeaderComponent.prototype.onLongPressStart = function (_a) {
        var event = _a.event, model = _a.model;
        model.dragging = true;
        this.dragEventTarget = event;
    };
    DataTableHeaderComponent.prototype.onLongPressEnd = function (_a) {
        var event = _a.event, model = _a.model;
        this.dragEventTarget = event;
        // delay resetting so sort can be 
        // prevented if we were dragging
        setTimeout(function () {
            model.dragging = false;
        }, 5);
    };
    Object.defineProperty(DataTableHeaderComponent.prototype, "headerWidth", {
        get: function () {
            if (this.scrollbarH) {
                return this.innerWidth + 'px';
            }
            return '100%';
        },
        enumerable: true,
        configurable: true
    });
    DataTableHeaderComponent.prototype.trackByGroups = function (index, colGroup) {
        return colGroup.type;
    };
    DataTableHeaderComponent.prototype.columnTrackingFn = function (index, column) {
        return column.$$id;
    };
    DataTableHeaderComponent.prototype.onColumnResized = function (width, column) {
        if (width <= column.minWidth) {
            width = column.minWidth;
        }
        else if (width >= column.maxWidth) {
            width = column.maxWidth;
        }
        this.resize.emit({
            column: column,
            prevValue: column.width,
            newValue: width
        });
    };
    DataTableHeaderComponent.prototype.onColumnReordered = function (_a) {
        var prevIndex = _a.prevIndex, newIndex = _a.newIndex, model = _a.model;
        this.reorder.emit({
            column: model,
            prevValue: prevIndex,
            newValue: newIndex
        });
    };
    DataTableHeaderComponent.prototype.onSort = function (_a) {
        var column = _a.column, prevValue = _a.prevValue, newValue = _a.newValue;
        // if we are dragging don't sort!
        if (column.dragging)
            return;
        var sorts = this.calcNewSorts(column, prevValue, newValue);
        this.sort.emit({
            sorts: sorts,
            column: column,
            prevValue: prevValue,
            newValue: newValue
        });
    };
    DataTableHeaderComponent.prototype.calcNewSorts = function (column, prevValue, newValue) {
        var idx = 0;
        var sorts = this.sorts.map(function (s, i) {
            s = Object.assign({}, s);
            if (s.prop === column.prop)
                idx = i;
            return s;
        });
        if (newValue === undefined) {
            sorts.splice(idx, 1);
        }
        else if (prevValue) {
            sorts[idx].dir = newValue;
        }
        else {
            if (this.sortType === types_1.SortType.single) {
                sorts.splice(0, this.sorts.length);
            }
            sorts.push({ dir: newValue, prop: column.prop });
        }
        return sorts;
    };
    DataTableHeaderComponent.prototype.stylesByGroup = function (group) {
        var widths = this.columnGroupWidths;
        var offsetX = this.offsetX;
        var styles = {
            width: widths[group] + "px"
        };
        if (group === 'center') {
            utils_1.translateXY(styles, offsetX * -1, 0);
        }
        else if (group === 'right') {
            var totalDiff = widths.total - this.innerWidth;
            var offset = totalDiff * -1;
            utils_1.translateXY(styles, offset, 0);
        }
        return styles;
    };
    return DataTableHeaderComponent;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], DataTableHeaderComponent.prototype, "sortAscendingIcon", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], DataTableHeaderComponent.prototype, "sortDescendingIcon", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], DataTableHeaderComponent.prototype, "scrollbarH", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Number)
], DataTableHeaderComponent.prototype, "innerWidth", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Number)
], DataTableHeaderComponent.prototype, "offsetX", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Array)
], DataTableHeaderComponent.prototype, "sorts", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Number)
], DataTableHeaderComponent.prototype, "sortType", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], DataTableHeaderComponent.prototype, "allRowsSelected", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Number)
], DataTableHeaderComponent.prototype, "selectionType", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], DataTableHeaderComponent.prototype, "reorderable", void 0);
__decorate([
    core_1.HostBinding('style.height'),
    core_1.Input(),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [Object])
], DataTableHeaderComponent.prototype, "headerHeight", null);
__decorate([
    core_1.Input(),
    __metadata("design:type", Array),
    __metadata("design:paramtypes", [Array])
], DataTableHeaderComponent.prototype, "columns", null);
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], DataTableHeaderComponent.prototype, "sort", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], DataTableHeaderComponent.prototype, "reorder", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], DataTableHeaderComponent.prototype, "resize", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], DataTableHeaderComponent.prototype, "select", void 0);
__decorate([
    core_1.HostBinding('style.width'),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [])
], DataTableHeaderComponent.prototype, "headerWidth", null);
DataTableHeaderComponent = __decorate([
    core_1.Component({
        selector: 'datatable-header',
        template: "\n    <div\n      orderable\n      (reorder)=\"onColumnReordered($event)\"\n      [style.width.px]=\"columnGroupWidths.total\"\n      class=\"datatable-header-inner\">\n      <div\n        *ngFor=\"let colGroup of columnsByPin; trackBy: trackByGroups\"\n        [class]=\"'datatable-row-' + colGroup.type\"\n        [ngStyle]=\"stylesByGroup(colGroup.type)\">\n        <datatable-header-cell\n          *ngFor=\"let column of colGroup.columns; trackBy: columnTrackingFn\"\n          resizeable\n          [resizeEnabled]=\"column.resizeable\"\n          (resize)=\"onColumnResized($event, column)\"\n          long-press\n          [pressModel]=\"column\"\n          [pressEnabled]=\"reorderable && column.draggable\"\n          (longPressStart)=\"onLongPressStart($event)\"\n          (longPressEnd)=\"onLongPressEnd($event)\"\n          draggable\n          [dragX]=\"reorderable && column.draggable && column.dragging\"\n          [dragY]=\"false\"\n          [dragModel]=\"column\"\n          [dragEventTarget]=\"dragEventTarget\"\n          [headerHeight]=\"headerHeight\"\n          [column]=\"column\"\n          [sortType]=\"sortType\"\n          [sorts]=\"sorts\"\n          [selectionType]=\"selectionType\"\n          [sortAscendingIcon]=\"sortAscendingIcon\"\n          [sortDescendingIcon]=\"sortDescendingIcon\"\n          [allRowsSelected]=\"allRowsSelected\"\n          (sort)=\"onSort($event)\"\n          (select)=\"select.emit($event)\">\n        </datatable-header-cell>\n      </div>\n    </div>\n  ",
        host: {
            class: 'datatable-header'
        }
    })
], DataTableHeaderComponent);
exports.DataTableHeaderComponent = DataTableHeaderComponent;


/***/ }),

/***/ "./src/components/header/index.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__("./src/components/header/header.component.ts"));
__export(__webpack_require__("./src/components/header/header-cell.component.ts"));


/***/ }),

/***/ "./src/components/index.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__("./src/components/datatable.component.ts"));
__export(__webpack_require__("./src/components/header/index.ts"));
__export(__webpack_require__("./src/components/body/index.ts"));
__export(__webpack_require__("./src/components/footer/index.ts"));
__export(__webpack_require__("./src/components/columns/index.ts"));
__export(__webpack_require__("./src/components/row-detail/index.ts"));


/***/ }),

/***/ "./src/components/row-detail/index.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__("./src/components/row-detail/row-detail.directive.ts"));
__export(__webpack_require__("./src/components/row-detail/row-detail-template.directive.ts"));


/***/ }),

/***/ "./src/components/row-detail/row-detail-template.directive.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var DatatableRowDetailTemplateDirective = (function () {
    function DatatableRowDetailTemplateDirective(template) {
        this.template = template;
    }
    return DatatableRowDetailTemplateDirective;
}());
DatatableRowDetailTemplateDirective = __decorate([
    core_1.Directive({
        selector: '[ngx-datatable-row-detail-template]'
    }),
    __metadata("design:paramtypes", [core_1.TemplateRef])
], DatatableRowDetailTemplateDirective);
exports.DatatableRowDetailTemplateDirective = DatatableRowDetailTemplateDirective;


/***/ }),

/***/ "./src/components/row-detail/row-detail.directive.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var row_detail_template_directive_1 = __webpack_require__("./src/components/row-detail/row-detail-template.directive.ts");
var DatatableRowDetailDirective = (function () {
    function DatatableRowDetailDirective() {
        /**
         * The detail row height is required especially
         * when virtual scroll is enabled.
         *
         * @type {number|function(row?:any,index?:number): number}
         * @memberOf DatatableComponent
         */
        this.rowHeight = 0;
        /**
         * Row detail row visbility was toggled.
         *
         * @type {EventEmitter<any>}
         * @memberOf DatatableComponent
         */
        this.toggle = new core_1.EventEmitter();
    }
    /**
     * Toggle the expansion of the row
     *
     * @param rowIndex
     */
    DatatableRowDetailDirective.prototype.toggleExpandRow = function (row) {
        this.toggle.emit({
            type: 'row',
            value: row
        });
    };
    /**
     * API method to expand all the rows.
     *
     * @memberOf DatatableComponent
     */
    DatatableRowDetailDirective.prototype.expandAllRows = function () {
        this.toggle.emit({
            type: 'all',
            value: true
        });
    };
    /**
     * API method to collapse all the rows.
     *
     * @memberOf DatatableComponent
     */
    DatatableRowDetailDirective.prototype.collapseAllRows = function () {
        this.toggle.emit({
            type: 'all',
            value: false
        });
    };
    return DatatableRowDetailDirective;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], DatatableRowDetailDirective.prototype, "rowHeight", void 0);
__decorate([
    core_1.Input(),
    core_1.ContentChild(row_detail_template_directive_1.DatatableRowDetailTemplateDirective, { read: core_1.TemplateRef }),
    __metadata("design:type", core_1.TemplateRef)
], DatatableRowDetailDirective.prototype, "template", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], DatatableRowDetailDirective.prototype, "toggle", void 0);
DatatableRowDetailDirective = __decorate([
    core_1.Directive({ selector: 'ngx-datatable-row-detail' })
], DatatableRowDetailDirective);
exports.DatatableRowDetailDirective = DatatableRowDetailDirective;


/***/ }),

/***/ "./src/datatable.module.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var common_1 = __webpack_require__(2);
__webpack_require__("./node_modules/rxjs/add/observable/fromEvent.js");
var components_1 = __webpack_require__("./src/components/index.ts");
var directives_1 = __webpack_require__("./src/directives/index.ts");
var services_1 = __webpack_require__("./src/services/index.ts");
var NgxDatatableModule = (function () {
    function NgxDatatableModule() {
    }
    return NgxDatatableModule;
}());
NgxDatatableModule = __decorate([
    core_1.NgModule({
        imports: [
            common_1.CommonModule
        ],
        providers: [
            services_1.ScrollbarHelper
        ],
        declarations: [
            components_1.DataTableFooterTemplateDirective,
            directives_1.VisibilityDirective,
            directives_1.DraggableDirective,
            directives_1.ResizeableDirective,
            directives_1.OrderableDirective,
            directives_1.LongPressDirective,
            components_1.ScrollerComponent,
            components_1.DatatableComponent,
            components_1.DataTableColumnDirective,
            components_1.DataTableHeaderComponent,
            components_1.DataTableHeaderCellComponent,
            components_1.DataTableBodyComponent,
            components_1.DataTableFooterComponent,
            components_1.DataTablePagerComponent,
            components_1.ProgressBarComponent,
            components_1.DataTableBodyRowComponent,
            components_1.DataTableRowWrapperComponent,
            components_1.DatatableRowDetailDirective,
            components_1.DatatableRowDetailTemplateDirective,
            components_1.DataTableBodyCellComponent,
            components_1.DataTableSelectionComponent,
            components_1.DataTableColumnHeaderDirective,
            components_1.DataTableColumnCellDirective,
            components_1.DatatableFooterDirective
        ],
        exports: [
            components_1.DatatableComponent,
            components_1.DatatableRowDetailDirective,
            components_1.DatatableRowDetailTemplateDirective,
            components_1.DataTableColumnDirective,
            components_1.DataTableColumnHeaderDirective,
            components_1.DataTableColumnCellDirective,
            components_1.DataTableFooterTemplateDirective,
            components_1.DatatableFooterDirective,
            components_1.DataTablePagerComponent
        ]
    })
], NgxDatatableModule);
exports.NgxDatatableModule = NgxDatatableModule;


/***/ }),

/***/ "./src/directives/draggable.directive.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var Observable_1 = __webpack_require__("./node_modules/rxjs/Observable.js");
__webpack_require__("./node_modules/rxjs/add/operator/takeUntil.js");
/**
 * Draggable Directive for Angular2
 *
 * Inspiration:
 *   https://github.com/AngularClass/angular2-examples/blob/master/rx-draggable/directives/draggable.ts
 *   http://stackoverflow.com/questions/35662530/how-to-implement-drag-and-drop-in-angular2
 *
 */
var DraggableDirective = (function () {
    function DraggableDirective(element) {
        this.dragX = true;
        this.dragY = true;
        this.dragStart = new core_1.EventEmitter();
        this.dragging = new core_1.EventEmitter();
        this.dragEnd = new core_1.EventEmitter();
        this.isDragging = false;
        this.element = element.nativeElement;
    }
    DraggableDirective.prototype.ngOnChanges = function (changes) {
        if (changes['dragEventTarget'] && changes['dragEventTarget'].currentValue && this.dragModel.dragging) {
            this.onMousedown(changes['dragEventTarget'].currentValue);
        }
    };
    DraggableDirective.prototype.ngOnDestroy = function () {
        this._destroySubscription();
    };
    DraggableDirective.prototype.onMouseup = function (event) {
        if (!this.isDragging)
            return;
        this.isDragging = false;
        this.element.classList.remove('dragging');
        if (this.subscription) {
            this._destroySubscription();
            this.dragEnd.emit({
                event: event,
                element: this.element,
                model: this.dragModel
            });
        }
    };
    DraggableDirective.prototype.onMousedown = function (event) {
        var _this = this;
        // we only want to drag the inner header text
        var isDragElm = event.target.classList.contains('draggable');
        if (isDragElm && (this.dragX || this.dragY)) {
            event.preventDefault();
            this.isDragging = true;
            var mouseDownPos_1 = { x: event.clientX, y: event.clientY };
            var mouseup = Observable_1.Observable.fromEvent(document, 'mouseup');
            this.subscription = mouseup
                .subscribe(function (ev) { return _this.onMouseup(ev); });
            var mouseMoveSub = Observable_1.Observable.fromEvent(document, 'mousemove')
                .takeUntil(mouseup)
                .subscribe(function (ev) { return _this.move(ev, mouseDownPos_1); });
            this.subscription.add(mouseMoveSub);
            this.dragStart.emit({
                event: event,
                element: this.element,
                model: this.dragModel
            });
        }
    };
    DraggableDirective.prototype.move = function (event, mouseDownPos) {
        if (!this.isDragging)
            return;
        var x = event.clientX - mouseDownPos.x;
        var y = event.clientY - mouseDownPos.y;
        if (this.dragX)
            this.element.style.left = x + "px";
        if (this.dragY)
            this.element.style.top = y + "px";
        this.element.classList.add('dragging');
        this.dragging.emit({
            event: event,
            element: this.element,
            model: this.dragModel
        });
    };
    DraggableDirective.prototype._destroySubscription = function () {
        if (this.subscription) {
            this.subscription.unsubscribe();
            this.subscription = undefined;
        }
    };
    return DraggableDirective;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], DraggableDirective.prototype, "dragEventTarget", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], DraggableDirective.prototype, "dragModel", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], DraggableDirective.prototype, "dragX", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], DraggableDirective.prototype, "dragY", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], DraggableDirective.prototype, "dragStart", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], DraggableDirective.prototype, "dragging", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], DraggableDirective.prototype, "dragEnd", void 0);
DraggableDirective = __decorate([
    core_1.Directive({ selector: '[draggable]' }),
    __metadata("design:paramtypes", [core_1.ElementRef])
], DraggableDirective);
exports.DraggableDirective = DraggableDirective;


/***/ }),

/***/ "./src/directives/index.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__("./src/directives/draggable.directive.ts"));
__export(__webpack_require__("./src/directives/long-press.directive.ts"));
__export(__webpack_require__("./src/directives/orderable.directive.ts"));
__export(__webpack_require__("./src/directives/resizeable.directive.ts"));
__export(__webpack_require__("./src/directives/visibility.directive.ts"));


/***/ }),

/***/ "./src/directives/long-press.directive.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var Observable_1 = __webpack_require__("./node_modules/rxjs/Observable.js");
__webpack_require__("./node_modules/rxjs/add/operator/takeUntil.js");
var LongPressDirective = (function () {
    function LongPressDirective() {
        this.pressEnabled = true;
        this.duration = 500;
        this.longPressStart = new core_1.EventEmitter();
        this.longPressing = new core_1.EventEmitter();
        this.longPressEnd = new core_1.EventEmitter();
        this.mouseX = 0;
        this.mouseY = 0;
    }
    Object.defineProperty(LongPressDirective.prototype, "press", {
        get: function () { return this.pressing; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LongPressDirective.prototype, "isLongPress", {
        get: function () {
            return this.isLongPressing;
        },
        enumerable: true,
        configurable: true
    });
    LongPressDirective.prototype.onMouseDown = function (event) {
        var _this = this;
        // don't do right/middle clicks
        if (event.which !== 1 || !this.pressEnabled)
            return;
        // don't start drag if its on resize handle
        var target = event.target;
        if (target.classList.contains('resize-handle'))
            return;
        this.mouseX = event.clientX;
        this.mouseY = event.clientY;
        this.pressing = true;
        this.isLongPressing = false;
        var mouseup = Observable_1.Observable.fromEvent(document, 'mouseup');
        this.subscription = mouseup.subscribe(function (ev) { return _this.onMouseup(); });
        this.timeout = setTimeout(function () {
            _this.isLongPressing = true;
            _this.longPressStart.emit({
                event: event,
                model: _this.pressModel
            });
            _this.subscription.add(Observable_1.Observable.fromEvent(document, 'mousemove')
                .takeUntil(mouseup)
                .subscribe(function (mouseEvent) { return _this.onMouseMove(mouseEvent); }));
            _this.loop(event);
        }, this.duration);
        this.loop(event);
    };
    LongPressDirective.prototype.onMouseMove = function (event) {
        if (this.pressing && !this.isLongPressing) {
            var xThres = Math.abs(event.clientX - this.mouseX) > 10;
            var yThres = Math.abs(event.clientY - this.mouseY) > 10;
            if (xThres || yThres) {
                this.endPress();
            }
        }
    };
    LongPressDirective.prototype.loop = function (event) {
        var _this = this;
        if (this.isLongPressing) {
            this.timeout = setTimeout(function () {
                _this.longPressing.emit({
                    event: event,
                    model: _this.pressModel
                });
                _this.loop(event);
            }, 50);
        }
    };
    LongPressDirective.prototype.endPress = function () {
        clearTimeout(this.timeout);
        this.isLongPressing = false;
        this.pressing = false;
        this._destroySubscription();
        this.longPressEnd.emit({
            model: this.pressModel
        });
    };
    LongPressDirective.prototype.onMouseup = function () {
        this.endPress();
    };
    LongPressDirective.prototype.ngOnDestroy = function () {
        this._destroySubscription();
    };
    LongPressDirective.prototype._destroySubscription = function () {
        if (this.subscription) {
            this.subscription.unsubscribe();
            this.subscription = undefined;
        }
    };
    return LongPressDirective;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], LongPressDirective.prototype, "pressEnabled", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Object)
], LongPressDirective.prototype, "pressModel", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Number)
], LongPressDirective.prototype, "duration", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], LongPressDirective.prototype, "longPressStart", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], LongPressDirective.prototype, "longPressing", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], LongPressDirective.prototype, "longPressEnd", void 0);
__decorate([
    core_1.HostBinding('class.press'),
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [])
], LongPressDirective.prototype, "press", null);
__decorate([
    core_1.HostBinding('class.longpress'),
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [])
], LongPressDirective.prototype, "isLongPress", null);
__decorate([
    core_1.HostListener('mousedown', ['$event']),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [MouseEvent]),
    __metadata("design:returntype", void 0)
], LongPressDirective.prototype, "onMouseDown", null);
LongPressDirective = __decorate([
    core_1.Directive({ selector: '[long-press]' })
], LongPressDirective);
exports.LongPressDirective = LongPressDirective;


/***/ }),

/***/ "./src/directives/orderable.directive.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var draggable_directive_1 = __webpack_require__("./src/directives/draggable.directive.ts");
var platform_browser_1 = __webpack_require__(1);
var OrderableDirective = (function () {
    function OrderableDirective(differs, document) {
        this.document = document;
        this.reorder = new core_1.EventEmitter();
        this.differ = differs.find({}).create(null);
    }
    OrderableDirective.prototype.ngAfterContentInit = function () {
        // HACK: Investigate Better Way
        this.updateSubscriptions();
        this.draggables.changes.subscribe(this.updateSubscriptions.bind(this));
    };
    OrderableDirective.prototype.ngOnDestroy = function () {
        this.draggables.forEach(function (d) {
            d.dragStart.unsubscribe();
            d.dragEnd.unsubscribe();
        });
    };
    OrderableDirective.prototype.updateSubscriptions = function () {
        var _this = this;
        var diffs = this.differ.diff(this.createMapDiffs());
        if (diffs) {
            var subscribe = function (_a) {
                var currentValue = _a.currentValue, previousValue = _a.previousValue;
                unsubscribe_1({ previousValue: previousValue });
                if (currentValue) {
                    currentValue.dragStart.subscribe(_this.onDragStart.bind(_this));
                    currentValue.dragEnd.subscribe(_this.onDragEnd.bind(_this));
                }
            };
            var unsubscribe_1 = function (_a) {
                var previousValue = _a.previousValue;
                if (previousValue) {
                    previousValue.dragStart.unsubscribe();
                    previousValue.dragEnd.unsubscribe();
                }
            };
            diffs.forEachAddedItem(subscribe.bind(this));
            // diffs.forEachChangedItem(subscribe.bind(this));
            diffs.forEachRemovedItem(unsubscribe_1.bind(this));
        }
    };
    OrderableDirective.prototype.onDragStart = function () {
        this.positions = {};
        var i = 0;
        for (var _i = 0, _a = this.draggables.toArray(); _i < _a.length; _i++) {
            var dragger = _a[_i];
            var elm = dragger.element;
            var left = parseInt(elm.offsetLeft.toString(), 0);
            this.positions[dragger.dragModel.prop] = {
                left: left,
                right: left + parseInt(elm.offsetWidth.toString(), 0),
                index: i++,
                element: elm
            };
        }
    };
    OrderableDirective.prototype.onDragEnd = function (_a) {
        var element = _a.element, model = _a.model, event = _a.event;
        var prevPos = this.positions[model.prop];
        var target = this.isTarget(model, event);
        if (target) {
            this.reorder.emit({
                prevIndex: prevPos.index,
                newIndex: target.i,
                model: model
            });
        }
        element.style.left = 'auto';
    };
    OrderableDirective.prototype.isTarget = function (model, event) {
        var i = 0;
        var x = event.x || event.clientX;
        var y = event.y || event.clientY;
        var targets = this.document.elementsFromPoint(x, y);
        var _loop_1 = function (prop) {
            // current column position which throws event.
            var pos = this_1.positions[prop];
            // since we drag the inner span, we need to find it in the elements at the cursor
            if (model.prop !== prop && targets.find(function (el) { return el === pos.element; })) {
                return { value: {
                        pos: pos,
                        i: i
                    } };
            }
            i++;
        };
        var this_1 = this;
        for (var prop in this.positions) {
            var state_1 = _loop_1(prop);
            if (typeof state_1 === "object")
                return state_1.value;
        }
    };
    OrderableDirective.prototype.createMapDiffs = function () {
        return this.draggables.toArray()
            .reduce(function (acc, curr) {
            acc[curr.dragModel.$$id] = curr;
            return acc;
        }, {});
    };
    return OrderableDirective;
}());
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], OrderableDirective.prototype, "reorder", void 0);
__decorate([
    core_1.ContentChildren(draggable_directive_1.DraggableDirective, { descendants: true }),
    __metadata("design:type", core_1.QueryList)
], OrderableDirective.prototype, "draggables", void 0);
OrderableDirective = __decorate([
    core_1.Directive({ selector: '[orderable]' }),
    __param(1, core_1.Inject(platform_browser_1.DOCUMENT)),
    __metadata("design:paramtypes", [core_1.KeyValueDiffers, Object])
], OrderableDirective);
exports.OrderableDirective = OrderableDirective;


/***/ }),

/***/ "./src/directives/resizeable.directive.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var Observable_1 = __webpack_require__("./node_modules/rxjs/Observable.js");
__webpack_require__("./node_modules/rxjs/add/operator/takeUntil.js");
var ResizeableDirective = (function () {
    function ResizeableDirective(element) {
        this.resizeEnabled = true;
        this.resize = new core_1.EventEmitter();
        this.resizing = false;
        this.element = element.nativeElement;
    }
    ResizeableDirective.prototype.ngAfterViewInit = function () {
        if (this.resizeEnabled) {
            var node = document.createElement('span');
            node.classList.add('resize-handle');
            this.element.appendChild(node);
        }
    };
    ResizeableDirective.prototype.ngOnDestroy = function () {
        this._destroySubscription();
    };
    ResizeableDirective.prototype.onMouseup = function () {
        this.resizing = false;
        if (this.subscription && !this.subscription.closed) {
            this._destroySubscription();
            this.resize.emit(this.element.clientWidth);
        }
    };
    ResizeableDirective.prototype.onMousedown = function (event) {
        var _this = this;
        var isHandle = (event.target).classList.contains('resize-handle');
        var initialWidth = this.element.clientWidth;
        var mouseDownScreenX = event.screenX;
        if (isHandle) {
            event.stopPropagation();
            this.resizing = true;
            var mouseup = Observable_1.Observable.fromEvent(document, 'mouseup');
            this.subscription = mouseup
                .subscribe(function (ev) { return _this.onMouseup(); });
            var mouseMoveSub = Observable_1.Observable.fromEvent(document, 'mousemove')
                .takeUntil(mouseup)
                .subscribe(function (e) { return _this.move(e, initialWidth, mouseDownScreenX); });
            this.subscription.add(mouseMoveSub);
        }
    };
    ResizeableDirective.prototype.move = function (event, initialWidth, mouseDownScreenX) {
        var movementX = event.screenX - mouseDownScreenX;
        var newWidth = initialWidth + movementX;
        var overMinWidth = !this.minWidth || newWidth >= this.minWidth;
        var underMaxWidth = !this.maxWidth || newWidth <= this.maxWidth;
        if (overMinWidth && underMaxWidth) {
            this.element.style.width = newWidth + "px";
        }
    };
    ResizeableDirective.prototype._destroySubscription = function () {
        if (this.subscription) {
            this.subscription.unsubscribe();
            this.subscription = undefined;
        }
    };
    return ResizeableDirective;
}());
__decorate([
    core_1.Input(),
    __metadata("design:type", Boolean)
], ResizeableDirective.prototype, "resizeEnabled", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Number)
], ResizeableDirective.prototype, "minWidth", void 0);
__decorate([
    core_1.Input(),
    __metadata("design:type", Number)
], ResizeableDirective.prototype, "maxWidth", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], ResizeableDirective.prototype, "resize", void 0);
__decorate([
    core_1.HostListener('mousedown', ['$event']),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [MouseEvent]),
    __metadata("design:returntype", void 0)
], ResizeableDirective.prototype, "onMousedown", null);
ResizeableDirective = __decorate([
    core_1.Directive({
        selector: '[resizeable]',
        host: {
            '[class.resizeable]': 'resizeEnabled'
        }
    }),
    __metadata("design:paramtypes", [core_1.ElementRef])
], ResizeableDirective);
exports.ResizeableDirective = ResizeableDirective;


/***/ }),

/***/ "./src/directives/visibility.directive.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
/**
 * Visibility Observer Directive
 *
 * Usage:
 *
 * 		<div
 * 			visibilityObserver
 * 			(visible)="onVisible($event)">
 * 		</div>
 *
 */
var VisibilityDirective = (function () {
    function VisibilityDirective(element, zone) {
        this.element = element;
        this.zone = zone;
        this.isVisible = false;
        this.visible = new core_1.EventEmitter();
    }
    VisibilityDirective.prototype.ngOnInit = function () {
        this.runCheck();
    };
    VisibilityDirective.prototype.ngOnDestroy = function () {
        clearTimeout(this.timeout);
    };
    VisibilityDirective.prototype.onVisibilityChange = function () {
        var _this = this;
        // trigger zone recalc for columns
        this.zone.run(function () {
            _this.isVisible = true;
            _this.visible.emit(true);
        });
    };
    VisibilityDirective.prototype.runCheck = function () {
        var _this = this;
        var check = function () {
            // https://davidwalsh.name/offsetheight-visibility
            var _a = _this.element.nativeElement, offsetHeight = _a.offsetHeight, offsetWidth = _a.offsetWidth;
            if (offsetHeight && offsetWidth) {
                clearTimeout(_this.timeout);
                _this.onVisibilityChange();
            }
            else {
                clearTimeout(_this.timeout);
                _this.zone.runOutsideAngular(function () {
                    _this.timeout = setTimeout(function () { return check(); }, 50);
                });
            }
        };
        setTimeout(function () { return check(); });
    };
    return VisibilityDirective;
}());
__decorate([
    core_1.HostBinding('class.visible'),
    __metadata("design:type", Boolean)
], VisibilityDirective.prototype, "isVisible", void 0);
__decorate([
    core_1.Output(),
    __metadata("design:type", core_1.EventEmitter)
], VisibilityDirective.prototype, "visible", void 0);
VisibilityDirective = __decorate([
    core_1.Directive({ selector: '[visibilityObserver]' }),
    __metadata("design:paramtypes", [core_1.ElementRef, core_1.NgZone])
], VisibilityDirective);
exports.VisibilityDirective = VisibilityDirective;


/***/ }),

/***/ "./src/index.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__("./src/datatable.module.ts"));
__export(__webpack_require__("./src/types/index.ts"));
__export(__webpack_require__("./src/components/index.ts"));


/***/ }),

/***/ "./src/services/index.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__("./src/services/scrollbar-helper.service.ts"));


/***/ }),

/***/ "./src/services/scrollbar-helper.service.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(0);
var platform_browser_1 = __webpack_require__(1);
/**
 * Gets the width of the scrollbar.  Nesc for windows
 * http://stackoverflow.com/a/13382873/888165
 *
 * @export
 * @class ScrollbarHelper
 */
var ScrollbarHelper = (function () {
    function ScrollbarHelper(document) {
        this.document = document;
        this.width = this.getWidth();
    }
    ScrollbarHelper.prototype.getWidth = function () {
        var outer = this.document.createElement('div');
        outer.style.visibility = 'hidden';
        outer.style.width = '100px';
        outer.style.msOverflowStyle = 'scrollbar';
        this.document.body.appendChild(outer);
        var widthNoScroll = outer.offsetWidth;
        outer.style.overflow = 'scroll';
        var inner = this.document.createElement('div');
        inner.style.width = '100%';
        outer.appendChild(inner);
        var widthWithScroll = inner.offsetWidth;
        outer.parentNode.removeChild(outer);
        return widthNoScroll - widthWithScroll;
    };
    return ScrollbarHelper;
}());
ScrollbarHelper = __decorate([
    core_1.Injectable(),
    __param(0, core_1.Inject(platform_browser_1.DOCUMENT)),
    __metadata("design:paramtypes", [Object])
], ScrollbarHelper);
exports.ScrollbarHelper = ScrollbarHelper;


/***/ }),

/***/ "./src/types/click.type.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ClickType;
(function (ClickType) {
    ClickType[ClickType["single"] = 'single'] = "single";
    ClickType[ClickType["double"] = 'double'] = "double";
})(ClickType = exports.ClickType || (exports.ClickType = {}));


/***/ }),

/***/ "./src/types/column-mode.type.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ColumnMode;
(function (ColumnMode) {
    ColumnMode[ColumnMode["standard"] = 'standard'] = "standard";
    ColumnMode[ColumnMode["flex"] = 'flex'] = "flex";
    ColumnMode[ColumnMode["force"] = 'force'] = "force";
})(ColumnMode = exports.ColumnMode || (exports.ColumnMode = {}));


/***/ }),

/***/ "./src/types/index.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__("./src/types/column-mode.type.ts"));
__export(__webpack_require__("./src/types/sort.type.ts"));
__export(__webpack_require__("./src/types/sort-direction.type.ts"));
__export(__webpack_require__("./src/types/selection.type.ts"));
__export(__webpack_require__("./src/types/click.type.ts"));


/***/ }),

/***/ "./src/types/selection.type.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var SelectionType;
(function (SelectionType) {
    SelectionType[SelectionType["single"] = 'single'] = "single";
    SelectionType[SelectionType["multi"] = 'multi'] = "multi";
    SelectionType[SelectionType["multiClick"] = 'multiClick'] = "multiClick";
    SelectionType[SelectionType["cell"] = 'cell'] = "cell";
    SelectionType[SelectionType["checkbox"] = 'checkbox'] = "checkbox";
})(SelectionType = exports.SelectionType || (exports.SelectionType = {}));


/***/ }),

/***/ "./src/types/sort-direction.type.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var SortDirection;
(function (SortDirection) {
    SortDirection[SortDirection["asc"] = 'asc'] = "asc";
    SortDirection[SortDirection["desc"] = 'desc'] = "desc";
})(SortDirection = exports.SortDirection || (exports.SortDirection = {}));


/***/ }),

/***/ "./src/types/sort.type.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var SortType;
(function (SortType) {
    SortType[SortType["single"] = 'single'] = "single";
    SortType[SortType["multi"] = 'multi'] = "multi";
})(SortType = exports.SortType || (exports.SortType = {}));


/***/ }),

/***/ "./src/utils/camel-case.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Converts strings from something to camel case
 * http://stackoverflow.com/questions/10425287/convert-dash-separated-string-to-camelcase
 * @param  {string} str
 * @return {string} camel case string
 */
function camelCase(str) {
    // Replace special characters with a space
    str = str.replace(/[^a-zA-Z0-9 ]/g, ' ');
    // put a space before an uppercase letter
    str = str.replace(/([a-z](?=[A-Z]))/g, '$1 ');
    // Lower case first character and some other stuff
    str = str.replace(/([^a-zA-Z0-9 ])|^[0-9]+/g, '').trim().toLowerCase();
    // uppercase characters preceded by a space or number
    str = str.replace(/([ 0-9]+)([a-zA-Z])/g, function (a, b, c) {
        return b.trim() + c.toUpperCase();
    });
    return str;
}
exports.camelCase = camelCase;
/**
 * Converts strings from camel case to words
 * http://stackoverflow.com/questions/7225407/convert-camelcasetext-to-camel-case-text
 *
 * @export
 * @param {any} str
 * @returns string
 */
function deCamelCase(str) {
    return str
        .replace(/([A-Z])/g, function (match) { return " " + match; })
        .replace(/^./, function (match) { return match.toUpperCase(); });
}
exports.deCamelCase = deCamelCase;


/***/ }),

/***/ "./src/utils/column-helper.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var camel_case_1 = __webpack_require__("./src/utils/camel-case.ts");
var id_1 = __webpack_require__("./src/utils/id.ts");
var column_prop_getters_1 = __webpack_require__("./src/utils/column-prop-getters.ts");
/**
 * Sets the column defaults
 *
 * @export
 * @param {any[]} columns
 * @returns
 */
function setColumnDefaults(columns) {
    if (!columns)
        return;
    for (var _i = 0, columns_1 = columns; _i < columns_1.length; _i++) {
        var column = columns_1[_i];
        if (!column.$$id) {
            column.$$id = id_1.id();
        }
        // prop can be numeric; zero is valid not a missing prop
        // translate name => prop
        if (column.prop == null && column.name) {
            column.prop = camel_case_1.camelCase(column.name);
        }
        if (!column.$$valueGetter) {
            column.$$valueGetter = column_prop_getters_1.getterForProp(column.prop);
        }
        // format props if no name passed
        if (column.prop != null && !column.name) {
            column.name = camel_case_1.deCamelCase(String(column.prop));
        }
        if (!column.hasOwnProperty('resizeable')) {
            column.resizeable = true;
        }
        if (!column.hasOwnProperty('sortable')) {
            column.sortable = true;
        }
        if (!column.hasOwnProperty('draggable')) {
            column.draggable = true;
        }
        if (!column.hasOwnProperty('canAutoResize')) {
            column.canAutoResize = true;
        }
        if (!column.hasOwnProperty('width')) {
            column.width = 150;
        }
    }
}
exports.setColumnDefaults = setColumnDefaults;
/**
 * Translates templates definitions to objects
 *
 * @export
 * @param {DataTableColumnDirective[]} templates
 * @returns {any[]}
 */
function translateTemplates(templates) {
    var result = [];
    for (var _i = 0, templates_1 = templates; _i < templates_1.length; _i++) {
        var temp = templates_1[_i];
        var col = {};
        var props = Object.getOwnPropertyNames(temp);
        for (var _a = 0, props_1 = props; _a < props_1.length; _a++) {
            var prop = props_1[_a];
            col[prop] = temp[prop];
        }
        if (temp.headerTemplate) {
            col.headerTemplate = temp.headerTemplate;
        }
        if (temp.cellTemplate) {
            col.cellTemplate = temp.cellTemplate;
        }
        result.push(col);
    }
    return result;
}
exports.translateTemplates = translateTemplates;


/***/ }),

/***/ "./src/utils/column-prop-getters.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// maybe rename this file to prop-getters.ts

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Always returns the empty string ''
 * @returns {string}
 */
function emptyStringGetter() {
    return '';
}
exports.emptyStringGetter = emptyStringGetter;
/**
 * Returns the appropriate getter function for this kind of prop.
 * If prop == null, returns the emptyStringGetter.
 */
function getterForProp(prop) {
    if (prop == null)
        return emptyStringGetter;
    if (typeof prop === 'number') {
        return numericIndexGetter;
    }
    else {
        // deep or simple
        if (prop.indexOf('.') !== -1) {
            return deepValueGetter;
        }
        else {
            return shallowValueGetter;
        }
    }
}
exports.getterForProp = getterForProp;
/**
 * Returns the value at this numeric index.
 * @param row array of values
 * @param index numeric index
 * @returns {any} or '' if invalid index
 */
function numericIndexGetter(row, index) {
    // mimic behavior of deepValueGetter
    if (!row || index == null)
        return row;
    var value = row[index];
    if (value == null)
        return '';
    return value;
}
exports.numericIndexGetter = numericIndexGetter;
/**
 * Returns the value of a field.
 * (more efficient than deepValueGetter)
 * @param obj object containing the field
 * @param fieldName field name string
 * @returns {any}
 */
function shallowValueGetter(obj, fieldName) {
    if (!obj || !fieldName)
        return obj;
    var value = obj[fieldName];
    if (value == null)
        return '';
    return value;
}
exports.shallowValueGetter = shallowValueGetter;
/**
 * Returns a deep object given a string. zoo['animal.type']
 * @param {object} obj
 * @param {string} path
 */
function deepValueGetter(obj, path) {
    if (!obj || !path)
        return obj;
    // check if path matches a root-level field
    // { "a.b.c": 123 }
    var current = obj[path];
    if (current !== undefined)
        return current;
    current = obj;
    var split = path.split('.');
    if (split.length) {
        for (var i = 0; i < split.length; i++) {
            current = current[split[i]];
            // if found undefined, return empty string
            if (current === undefined || current === null)
                return '';
        }
    }
    return current;
}
exports.deepValueGetter = deepValueGetter;


/***/ }),

/***/ "./src/utils/column.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Returns the columns by pin.
 * @param {array} cols
 */
function columnsByPin(cols) {
    var ret = {
        left: [],
        center: [],
        right: []
    };
    if (cols) {
        for (var _i = 0, cols_1 = cols; _i < cols_1.length; _i++) {
            var col = cols_1[_i];
            if (col.frozenLeft) {
                ret.left.push(col);
            }
            else if (col.frozenRight) {
                ret.right.push(col);
            }
            else {
                ret.center.push(col);
            }
        }
    }
    return ret;
}
exports.columnsByPin = columnsByPin;
/**
 * Returns the widths of all group sets of a column
 * @param {object} groups
 * @param {array} all
 */
function columnGroupWidths(groups, all) {
    return {
        left: columnTotalWidth(groups.left),
        center: columnTotalWidth(groups.center),
        right: columnTotalWidth(groups.right),
        total: columnTotalWidth(all)
    };
}
exports.columnGroupWidths = columnGroupWidths;
/**
 * Calculates the total width of all columns and their groups
 * @param {array} columns
 * @param {string} prop width to get
 */
function columnTotalWidth(columns, prop) {
    var totalWidth = 0;
    if (columns) {
        for (var _i = 0, columns_1 = columns; _i < columns_1.length; _i++) {
            var c = columns_1[_i];
            var has = prop && c[prop];
            var width = has ? c[prop] : c.width;
            totalWidth = totalWidth + parseFloat(width);
        }
    }
    return totalWidth;
}
exports.columnTotalWidth = columnTotalWidth;
/**
 * Calculates the total width of all columns and their groups
 * @param {array} columns
 * @param {string} property width to get
 */
function columnsTotalWidth(columns, prop) {
    var totalWidth = 0;
    for (var _i = 0, columns_2 = columns; _i < columns_2.length; _i++) {
        var column = columns_2[_i];
        var has = prop && column[prop];
        totalWidth = totalWidth + (has ? column[prop] : column.width);
    }
    return totalWidth;
}
exports.columnsTotalWidth = columnsTotalWidth;
function columnsByPinArr(val) {
    var colsByPinArr = [];
    var colsByPin = columnsByPin(val);
    colsByPinArr.push({ type: 'left', columns: colsByPin['left'] });
    colsByPinArr.push({ type: 'center', columns: colsByPin['center'] });
    colsByPinArr.push({ type: 'right', columns: colsByPin['right'] });
    return colsByPinArr;
}
exports.columnsByPinArr = columnsByPinArr;


/***/ }),

/***/ "./src/utils/elm-from-point.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
if (!document.elementsFromPoint) {
    document.elementsFromPoint = elementsFromPoint;
}
/*tslint:disable*/
/**
 * Polyfill for `elementsFromPoint`
 *
 * https://developer.mozilla.org/en-US/docs/Web/API/Document/elementsFromPoint
 * https://gist.github.com/iddan/54d5d9e58311b0495a91bf06de661380
 * https://gist.github.com/oslego/7265412
 *
 * @export
 * @param {any} x
 * @param {any} y
 * @returns
 */
function elementsFromPoint(x, y) {
    var elements = [];
    var previousPointerEvents = [];
    var current; // TODO: window.getComputedStyle should be used with inferred type (Element)
    var i;
    var d;
    // get all elements via elementFromPoint, and remove them from hit-testing in order
    while ((current = document.elementFromPoint(x, y)) && elements.indexOf(current) === -1 && current != null) {
        // push the element and its current style
        elements.push(current);
        previousPointerEvents.push({
            value: current.style.getPropertyValue('pointer-events'),
            priority: current.style.getPropertyPriority('pointer-events')
        });
        // add "pointer-events: none", to get to the underlying element
        current.style.setProperty('pointer-events', 'none', 'important');
    }
    // restore the previous pointer-events values
    for (i = previousPointerEvents.length; d = previousPointerEvents[--i];) {
        elements[i].style.setProperty('pointer-events', d.value ? d.value : '', d.priority);
    }
    // return our results
    return elements;
}
exports.elementsFromPoint = elementsFromPoint;
/*tslint:enable*/


/***/ }),

/***/ "./src/utils/id.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Creates a unique object id.
 * http://stackoverflow.com/questions/6248666/how-to-generate-short-uid-like-ax4j9z-in-js
 */
function id() {
    return ('0000' + (Math.random() * Math.pow(36, 4) << 0).toString(36)).slice(-4);
}
exports.id = id;


/***/ }),

/***/ "./src/utils/index.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__("./src/utils/id.ts"));
__export(__webpack_require__("./src/utils/column.ts"));
__export(__webpack_require__("./src/utils/column-prop-getters.ts"));
__export(__webpack_require__("./src/utils/camel-case.ts"));
__export(__webpack_require__("./src/utils/keys.ts"));
__export(__webpack_require__("./src/utils/math.ts"));
__export(__webpack_require__("./src/utils/prefixes.ts"));
__export(__webpack_require__("./src/utils/selection.ts"));
__export(__webpack_require__("./src/utils/translate.ts"));
__export(__webpack_require__("./src/utils/throttle.ts"));
__export(__webpack_require__("./src/utils/sort.ts"));
__export(__webpack_require__("./src/utils/row-height-cache.ts"));
__export(__webpack_require__("./src/utils/column-helper.ts"));
__export(__webpack_require__("./src/utils/elm-from-point.ts"));


/***/ }),

/***/ "./src/utils/keys.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Keys;
(function (Keys) {
    Keys[Keys["up"] = 38] = "up";
    Keys[Keys["down"] = 40] = "down";
    Keys[Keys["return"] = 13] = "return";
    Keys[Keys["escape"] = 27] = "escape";
    Keys[Keys["left"] = 37] = "left";
    Keys[Keys["right"] = 39] = "right";
})(Keys = exports.Keys || (exports.Keys = {}));


/***/ }),

/***/ "./src/utils/math.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var column_1 = __webpack_require__("./src/utils/column.ts");
/**
 * Calculates the Total Flex Grow
 * @param {array}
 */
function getTotalFlexGrow(columns) {
    var totalFlexGrow = 0;
    for (var _i = 0, columns_1 = columns; _i < columns_1.length; _i++) {
        var c = columns_1[_i];
        totalFlexGrow += c.flexGrow || 0;
    }
    return totalFlexGrow;
}
exports.getTotalFlexGrow = getTotalFlexGrow;
/**
 * Adjusts the column widths.
 * Inspired by: https://github.com/facebook/fixed-data-table/blob/master/src/FixedDataTableWidthHelper.js
 * @param {array} all columns
 * @param {int} width
 */
function adjustColumnWidths(allColumns, expectedWidth) {
    var columnsWidth = column_1.columnsTotalWidth(allColumns);
    var totalFlexGrow = getTotalFlexGrow(allColumns);
    var colsByGroup = column_1.columnsByPin(allColumns);
    if (columnsWidth !== expectedWidth) {
        scaleColumns(colsByGroup, expectedWidth, totalFlexGrow);
    }
}
exports.adjustColumnWidths = adjustColumnWidths;
/**
 * Resizes columns based on the flexGrow property, while respecting manually set widths
 * @param {array} colsByGroup
 * @param {int} maxWidth
 * @param {int} totalFlexGrow
 */
function scaleColumns(colsByGroup, maxWidth, totalFlexGrow) {
    // calculate total width and flexgrow points for coulumns that can be resized
    for (var attr in colsByGroup) {
        for (var _i = 0, _a = colsByGroup[attr]; _i < _a.length; _i++) {
            var column = _a[_i];
            if (!column.canAutoResize) {
                maxWidth -= column.width;
                totalFlexGrow -= column.flexGrow;
            }
            else {
                column.width = 0;
            }
        }
    }
    var hasMinWidth = {};
    var remainingWidth = maxWidth;
    // resize columns until no width is left to be distributed
    do {
        var widthPerFlexPoint = remainingWidth / totalFlexGrow;
        remainingWidth = 0;
        for (var attr in colsByGroup) {
            for (var _b = 0, _c = colsByGroup[attr]; _b < _c.length; _b++) {
                var column = _c[_b];
                // if the column can be resize and it hasn't reached its minimum width yet
                if (column.canAutoResize && !hasMinWidth[column.prop]) {
                    var newWidth = column.width + column.flexGrow * widthPerFlexPoint;
                    if (column.minWidth !== undefined && newWidth < column.minWidth) {
                        remainingWidth += newWidth - column.minWidth;
                        column.width = column.minWidth;
                        hasMinWidth[column.prop] = true;
                    }
                    else {
                        column.width = newWidth;
                    }
                }
            }
        }
    } while (remainingWidth !== 0);
}
/**
 * Forces the width of the columns to
 * distribute equally but overflowing when necessary
 *
 * Rules:
 *
 *  - If combined withs are less than the total width of the grid,
 *    proportion the widths given the min / max / normal widths to fill the width.
 *
 *  - If the combined widths, exceed the total width of the grid,
 *    use the standard widths.
 *
 *  - If a column is resized, it should always use that width
 *
 *  - The proportional widths should never fall below min size if specified.
 *
 *  - If the grid starts off small but then becomes greater than the size ( + / - )
 *    the width should use the original width; not the newly proportioned widths.
 *
 * @param {array} allColumns
 * @param {int} expectedWidth
 * @param {int} startIdx
 * @param {boolean} allowBleed
 * @param {int} defaultColWidth
 */
function forceFillColumnWidths(allColumns, expectedWidth, startIdx, allowBleed, defaultColWidth) {
    if (defaultColWidth === void 0) { defaultColWidth = 300; }
    var columnsToResize = allColumns
        .slice(startIdx + 1, allColumns.length)
        .filter(function (c) {
        return c.canAutoResize !== false;
    });
    for (var _i = 0, columnsToResize_1 = columnsToResize; _i < columnsToResize_1.length; _i++) {
        var column = columnsToResize_1[_i];
        if (!column.$$oldWidth) {
            column.$$oldWidth = column.width;
        }
    }
    var additionWidthPerColumn = 0;
    var exceedsWindow = false;
    var contentWidth = getContentWidth(allColumns, defaultColWidth);
    var remainingWidth = expectedWidth - contentWidth;
    var columnsProcessed = [];
    // This loop takes care of the
    do {
        additionWidthPerColumn = remainingWidth / columnsToResize.length;
        exceedsWindow = contentWidth >= expectedWidth;
        for (var _a = 0, columnsToResize_2 = columnsToResize; _a < columnsToResize_2.length; _a++) {
            var column = columnsToResize_2[_a];
            if (exceedsWindow && allowBleed) {
                column.width = column.$$oldWidth || column.width || defaultColWidth;
            }
            else {
                var newSize = (column.width || defaultColWidth) + additionWidthPerColumn;
                if (column.minWidth && newSize < column.minWidth) {
                    column.width = column.minWidth;
                    columnsProcessed.push(column);
                }
                else if (column.maxWidth && newSize > column.maxWidth) {
                    column.width = column.maxWidth;
                    columnsProcessed.push(column);
                }
                else {
                    column.width = newSize;
                }
            }
            column.width = Math.max(0, column.width);
        }
        contentWidth = getContentWidth(allColumns);
        remainingWidth = expectedWidth - contentWidth;
        removeProcessedColumns(columnsToResize, columnsProcessed);
    } while (remainingWidth > 0 && columnsToResize.length !== 0);
}
exports.forceFillColumnWidths = forceFillColumnWidths;
/**
 * Remove the processed columns from the current active columns.
 *
 * @param columnsToResize  Array containing the columns that need to be resized.
 * @param columnsProcessed Array containing the columns that have already been processed.
 */
function removeProcessedColumns(columnsToResize, columnsProcessed) {
    for (var _i = 0, columnsProcessed_1 = columnsProcessed; _i < columnsProcessed_1.length; _i++) {
        var column = columnsProcessed_1[_i];
        var index = columnsToResize.indexOf(column);
        columnsToResize.splice(index, 1);
    }
}
/**
 * Gets the width of the columns
 *
 * @param {array} allColumns
 * @param {number} [defaultColWidth=300]
 * @returns {number}
 */
function getContentWidth(allColumns, defaultColWidth) {
    if (defaultColWidth === void 0) { defaultColWidth = 300; }
    var contentWidth = 0;
    for (var _i = 0, allColumns_1 = allColumns; _i < allColumns_1.length; _i++) {
        var column = allColumns_1[_i];
        contentWidth += (column.width || defaultColWidth);
    }
    return contentWidth;
}


/***/ }),

/***/ "./src/utils/prefixes.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var camel_case_1 = __webpack_require__("./src/utils/camel-case.ts");
var cache = {};
var testStyle = document.createElement('div').style;
// Get Prefix
// http://davidwalsh.name/vendor-prefix
var prefix = (function () {
    var styles = window.getComputedStyle(document.documentElement, '');
    var pre = (Array.prototype.slice.call(styles).join('').match(/-(moz|webkit|ms)-/))[1];
    var dom = ('WebKit|Moz|MS|O').match(new RegExp('(' + pre + ')', 'i'))[1];
    return {
        dom: dom,
        lowercase: pre,
        css: "-" + pre + "-",
        js: pre[0].toUpperCase() + pre.substr(1)
    };
})();
function getVendorPrefixedName(property) {
    var name = camel_case_1.camelCase(property);
    if (!cache[name]) {
        if (testStyle[prefix.css + property] !== undefined) {
            cache[name] = prefix.css + property;
        }
        else if (testStyle[property] !== undefined) {
            cache[name] = property;
        }
    }
    return cache[name];
}
exports.getVendorPrefixedName = getVendorPrefixedName;


/***/ }),

/***/ "./src/utils/row-height-cache.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * This object contains the cache of the various row heights that are present inside
 * the data table.   Its based on Fenwick tree data structure that helps with
 * querying sums that have time complexity of log n.
 *
 * Fenwick Tree Credits: http://petr-mitrichev.blogspot.com/2013/05/fenwick-tree-range-updates.html
 * https://github.com/mikolalysenko/fenwick-tree
 *
 */
var RowHeightCache = (function () {
    function RowHeightCache() {
        /**
         * Tree Array stores the cumulative information of the row heights to perform efficient
         * range queries and updates.  Currently the tree is initialized to the base row
         * height instead of the detail row height.
         */
        this.treeArray = [];
    }
    /**
     * Clear the Tree array.
     */
    RowHeightCache.prototype.clearCache = function () {
        this.treeArray = [];
    };
    /**
     * Initialize the Fenwick tree with row Heights.
     *
     * @param rows The array of rows which contain the expanded status.
     * @param rowHeight The row height.
     * @param detailRowHeight The detail row height.
     */
    RowHeightCache.prototype.initCache = function (details) {
        var rows = details.rows, rowHeight = details.rowHeight, detailRowHeight = details.detailRowHeight, externalVirtual = details.externalVirtual, rowCount = details.rowCount;
        var isFn = typeof rowHeight === 'function';
        var isDetailFn = typeof detailRowHeight === 'function';
        if (!isFn && isNaN(rowHeight)) {
            throw new Error("Row Height cache initialization failed. Please ensure that 'rowHeight' is a\n        valid number or function value: (" + rowHeight + ") when 'scrollbarV' is enabled.");
        }
        // Add this additional guard in case detailRowHeight is set to 'auto' as it wont work.
        if (!isDetailFn && isNaN(detailRowHeight)) {
            throw new Error("Row Height cache initialization failed. Please ensure that 'detailRowHeight' is a\n        valid number or function value: (" + detailRowHeight + ") when 'scrollbarV' is enabled.");
        }
        var n = externalVirtual ? rowCount : rows.length;
        this.treeArray = new Array(n);
        for (var i = 0; i < n; ++i) {
            this.treeArray[i] = 0;
        }
        for (var i = 0; i < n; ++i) {
            var row = rows[i];
            var currentRowHeight = rowHeight;
            if (isFn) {
                currentRowHeight = rowHeight(row);
            }
            // Add the detail row height to the already expanded rows.
            // This is useful for the table that goes through a filter or sort.
            if (row && row.$$expanded === 1) {
                if (isDetailFn) {
                    currentRowHeight += detailRowHeight(row, row.$$index);
                }
                else {
                    currentRowHeight += detailRowHeight;
                }
            }
            this.update(i, currentRowHeight);
        }
    };
    /**
     * Given the ScrollY position i.e. sum, provide the rowIndex
     * that is present in the current view port.  Below handles edge cases.
     *
     * @param scrollY - The scrollY position.
     * @returns {number} - Index representing the first row visible in the viewport
     */
    RowHeightCache.prototype.getRowIndex = function (scrollY) {
        if (scrollY === 0)
            return 0;
        return this.calcRowIndex(scrollY);
    };
    /**
     * When a row is expanded or rowHeight is changed, update the height.  This can
     * be utilized in future when Angular Data table supports dynamic row heights.
     *
     *
     * @param atRowIndex Update the data at this index row in the grid.
     * @param byRowHeight Update by the rowHeight provided.
     */
    RowHeightCache.prototype.update = function (atRowIndex, byRowHeight) {
        if (!this.treeArray.length) {
            throw new Error("Update at index " + atRowIndex + " with value " + byRowHeight + " failed:\n        Row Height cache not initialized.");
        }
        var n = this.treeArray.length;
        atRowIndex |= 0;
        while (atRowIndex < n) {
            this.treeArray[atRowIndex] += byRowHeight;
            atRowIndex |= (atRowIndex + 1);
        }
    };
    /**
     * Range Sum query from 1 to the rowIndex
     *
     * @param atIndex The row index until which the total height needs to be obtained.
     * @returns {number} The total height from row 1 to the rowIndex.
     */
    RowHeightCache.prototype.query = function (atIndex) {
        if (!this.treeArray.length) {
            throw new Error("query at index " + atIndex + " failed: Fenwick tree array not initialized.");
        }
        var sum = 0;
        atIndex |= 0;
        while (atIndex >= 0) {
            sum += this.treeArray[atIndex];
            atIndex = (atIndex & (atIndex + 1)) - 1;
        }
        return sum;
    };
    /**
     * Find the total height between 2 row indexes
     * @param atIndexA The row index from
     * @param atIndexB The row index to
     * @returns {number} total pixel height between 2 row indexes.
     */
    RowHeightCache.prototype.queryBetween = function (atIndexA, atIndexB) {
        return this.query(atIndexB) - this.query(atIndexA - 1);
    };
    /**
     * Given the ScrollY position i.e. sum, provide the rowIndex
     * that is present in the current view port.
     *
     * @param sum - The scrollY position.
     * @returns {number} - Index representing the first row visible in the viewport
     */
    RowHeightCache.prototype.calcRowIndex = function (sum) {
        if (!this.treeArray.length)
            return 0;
        var pos = -1;
        var dataLength = this.treeArray.length;
        // Get the highest bit for the block size.
        var highestBit = Math.pow(2, dataLength.toString(2).length - 1);
        for (var blockSize = highestBit; blockSize !== 0; blockSize >>= 1) {
            var nextPos = pos + blockSize;
            if (nextPos < dataLength && sum >= this.treeArray[nextPos]) {
                sum -= this.treeArray[nextPos];
                pos = nextPos;
            }
        }
        return pos + 1;
    };
    return RowHeightCache;
}());
exports.RowHeightCache = RowHeightCache;


/***/ }),

/***/ "./src/utils/selection.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function selectRows(selected, row, comparefn) {
    var selectedIndex = comparefn(row, selected);
    if (selectedIndex > -1) {
        selected.splice(selectedIndex, 1);
    }
    else {
        selected.push(row);
    }
    return selected;
}
exports.selectRows = selectRows;
function selectRowsBetween(selected, rows, index, prevIndex, comparefn) {
    var reverse = index < prevIndex;
    for (var i = 0; i < rows.length; i++) {
        var row = rows[i];
        var greater = i >= prevIndex && i <= index;
        var lesser = i <= prevIndex && i >= index;
        var range = { start: 0, end: 0 };
        if (reverse) {
            range = {
                start: index,
                end: (prevIndex - index)
            };
        }
        else {
            range = {
                start: prevIndex,
                end: index + 1
            };
        }
        if ((reverse && lesser) || (!reverse && greater)) {
            // if in the positive range to be added to `selected`, and
            // not already in the selected array, add it
            if (i >= range.start && i <= range.end) {
                selected.push(row);
            }
        }
    }
    return selected;
}
exports.selectRowsBetween = selectRowsBetween;


/***/ }),

/***/ "./src/utils/sort.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = __webpack_require__("./src/types/index.ts");
var column_prop_getters_1 = __webpack_require__("./src/utils/column-prop-getters.ts");
/**
 * Gets the next sort direction
 * @param  {SortType}      sortType
 * @param  {SortDirection} currentSort
 * @return {SortDirection}
 */
function nextSortDir(sortType, current) {
    if (sortType === types_1.SortType.single) {
        if (current === types_1.SortDirection.asc) {
            return types_1.SortDirection.desc;
        }
        else {
            return types_1.SortDirection.asc;
        }
    }
    else {
        if (!current) {
            return types_1.SortDirection.asc;
        }
        else if (current === types_1.SortDirection.asc) {
            return types_1.SortDirection.desc;
        }
        else if (current === types_1.SortDirection.desc) {
            return undefined;
        }
    }
}
exports.nextSortDir = nextSortDir;
/**
 * Adapted from fueld-ui on 6/216
 * https://github.com/FuelInteractive/fuel-ui/tree/master/src/pipes/OrderBy
 * @param  {any}    a
 * @param  {any}    b
 * @return {number} position
 */
function orderByComparator(a, b) {
    if (a === null || typeof a === 'undefined')
        a = 0;
    if (b === null || typeof b === 'undefined')
        b = 0;
    if ((isNaN(parseFloat(a)) || !isFinite(a)) || (isNaN(parseFloat(b)) || !isFinite(b))) {
        // Convert to string in case of a=0 or b=0
        a = String(a);
        b = String(b);
        // Isn't a number so lowercase the string to properly compare
        if (a.toLowerCase() < b.toLowerCase())
            return -1;
        if (a.toLowerCase() > b.toLowerCase())
            return 1;
    }
    else {
        // Parse strings as numbers to compare properly
        if (parseFloat(a) < parseFloat(b))
            return -1;
        if (parseFloat(a) > parseFloat(b))
            return 1;
    }
    // equal each other
    return 0;
}
exports.orderByComparator = orderByComparator;
/**
 * Sorts the rows
 *
 * @export
 * @param {any[]} rows
 * @param {any[]} columns
 * @param {any[]} dirs
 * @returns
 */
function sortRows(rows, columns, dirs) {
    if (!rows || !dirs || !dirs.length || !columns)
        return rows;
    var temp = rows.slice();
    var cols = columns.reduce(function (obj, col) {
        if (col.comparator && typeof col.comparator === 'function') {
            obj[col.prop] = col.comparator;
        }
        return obj;
    }, {});
    // cache valueGetter and compareFn so that they
    // do not need to be looked-up in the sort function body
    var cachedDirs = dirs.map(function (dir) {
        var prop = dir.prop;
        return {
            prop: prop,
            dir: dir.dir,
            valueGetter: column_prop_getters_1.getterForProp(prop),
            compareFn: cols[prop] || orderByComparator
        };
    });
    return temp.sort(function (a, b) {
        for (var _i = 0, cachedDirs_1 = cachedDirs; _i < cachedDirs_1.length; _i++) {
            var cachedDir = cachedDirs_1[_i];
            var prop = cachedDir.prop, valueGetter = cachedDir.valueGetter;
            var propA = valueGetter(a, prop);
            var propB = valueGetter(b, prop);
            var comparison = cachedDir.dir !== types_1.SortDirection.desc ?
                cachedDir.compareFn(propA, propB) :
                -cachedDir.compareFn(propA, propB);
            // Don't return 0 yet in case of needing to sort by next property
            if (comparison !== 0)
                return comparison;
        }
        // equal each other
        return 0;
    });
}
exports.sortRows = sortRows;


/***/ }),

/***/ "./src/utils/throttle.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Throttle a function
 *
 * @export
 * @param {*} func
 * @param {number} wait
 * @param {*} [options]
 * @returns
 */
function throttle(func, wait, options) {
    options = options || {};
    var context;
    var args;
    var result;
    var timeout = null;
    var previous = 0;
    function later() {
        previous = options.leading === false ? 0 : +new Date();
        timeout = null;
        result = func.apply(context, args);
    }
    return function () {
        var now = +new Date();
        if (!previous && options.leading === false) {
            previous = now;
        }
        var remaining = wait - (now - previous);
        context = this;
        args = arguments;
        if (remaining <= 0) {
            clearTimeout(timeout);
            timeout = null;
            previous = now;
            result = func.apply(context, args);
        }
        else if (!timeout && options.trailing !== false) {
            timeout = setTimeout(later, remaining);
        }
        return result;
    };
}
exports.throttle = throttle;
/**
 * Throttle decorator
 *
 *  class MyClass {
 *    throttleable(10)
 *    myFn() { ... }
 *  }
 *
 * @export
 * @param {number} duration
 * @param {*} [options]
 * @returns
 */
function throttleable(duration, options) {
    return function innerDecorator(target, key, descriptor) {
        return {
            configurable: true,
            enumerable: descriptor.enumerable,
            get: function getter() {
                Object.defineProperty(this, key, {
                    configurable: true,
                    enumerable: descriptor.enumerable,
                    value: throttle(descriptor.value, duration, options)
                });
                return this[key];
            }
        };
    };
}
exports.throttleable = throttleable;


/***/ }),

/***/ "./src/utils/translate.ts":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var prefixes_1 = __webpack_require__("./src/utils/prefixes.ts");
var camel_case_1 = __webpack_require__("./src/utils/camel-case.ts");
// browser detection and prefixing tools
var transform = prefixes_1.getVendorPrefixedName('transform');
var backfaceVisibility = prefixes_1.getVendorPrefixedName('backfaceVisibility');
var hasCSSTransforms = !!prefixes_1.getVendorPrefixedName('transform');
var hasCSS3DTransforms = !!prefixes_1.getVendorPrefixedName('perspective');
var ua = window.navigator.userAgent;
var isSafari = (/Safari\//).test(ua) && !(/Chrome\//).test(ua);
function translateXY(styles, x, y) {
    if (hasCSSTransforms) {
        if (!isSafari && hasCSS3DTransforms) {
            styles[transform] = "translate3d(" + x + "px, " + y + "px, 0)";
            styles[backfaceVisibility] = 'hidden';
        }
        else {
            styles[camel_case_1.camelCase(transform)] = "translate(" + x + "px, " + y + "px)";
        }
    }
    else {
        styles.top = y + "px";
        styles.left = x + "px";
    }
}
exports.translateXY = translateXY;


/***/ }),

/***/ 0:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_0__;

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_1__;

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_2__;

/***/ })

/******/ });
});
//# sourceMappingURL=index.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("EuP9").Buffer))

/***/ }),

/***/ "oi6x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_BehaviorSubject__ = __webpack_require__("TfWX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_BehaviorSubject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs_BehaviorSubject__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Reducer; });
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var Reducer = (function (_super) {
    __extends(Reducer, _super);
    function Reducer(_dispatcher, initialReducer) {
        var _this = _super.call(this, initialReducer) || this;
        _this._dispatcher = _dispatcher;
        return _this;
    }
    Reducer.prototype.replaceReducer = function (reducer) {
        this.next(reducer);
    };
    Reducer.prototype.next = function (reducer) {
        _super.prototype.next.call(this, reducer);
        this._dispatcher.dispatch({ type: Reducer.REPLACE });
    };
    return Reducer;
}(__WEBPACK_IMPORTED_MODULE_0_rxjs_BehaviorSubject__["BehaviorSubject"]));

Reducer.REPLACE = '@ngrx/store/replace-reducer';
//# sourceMappingURL=reducer.js.map

/***/ }),

/***/ "oiow":
/***/ (function(module, exports) {

function NTree(item) {
    this.item = item ? item : null; // E
    this.left = null;  // NTree<E>
    this.right = null; // NTree<E>
}

NTree.prototype.getItem = function() {
    return this.item;
};

NTree.prototype.setItem = function(item) {
    this.item = item;
    return this;
};

NTree.prototype.hasLeft = function() {
    return (this.left != null);
};

NTree.prototype.hasRight = function() {
    return (this.right != null);
};

NTree.prototype.isLeaf = function() {
    return !(this.hasRight());
};

// Ajoute une liste de fils dans un noeud binaire
// (fils à droite, frère à gauche)
NTree.prototype.setChildren = function(list) {
    var nb = list.length;
    if (nb > 0) {
        var val = list[0];

        // 1er element en fils droit
        var currentTree = new NTree(val);
        this.right = currentTree;

        // les autres : en frère à gauche
        if (nb > 1) {
            for (var k = 1; k < nb; k++) {
                var ntLeft = new NTree();
                ntLeft.setItem(list[k]);
                currentTree.left = ntLeft;
                currentTree = ntLeft;
            }
        }
    }
    return this;
};

// Retourne tous les fils
NTree.prototype.getChildren = function() {
    var list = [];

    if (this.hasRight()) {
        // Ajout du fils droits
        var ntRight = this.right;
        list.push(ntRight.getItem());

        // Et des fils gauche successifs
        var currentTree = ntRight;
        while (currentTree.hasLeft()) {
            list.push(currentTree.left.getItem());
            currentTree = currentTree.left;
        }
    }
    return list;
};

// Retourne tous les noeuds fils
NTree.prototype.getChildrenNodes = function() {
    var list = [];

    if (this.hasRight()) {
        // Ajout du fils droits
        var ntRight = this.right;
        list.push(ntRight);

        // Et des fils gauches successifs
        var currentTree = ntRight;
        while (currentTree.hasLeft()) {
            list.push(currentTree.left);
            currentTree = currentTree.left;
        }
    }
    return list;
};

NTree.prototype.traverse = function() {
    var lists = []; // [[E]]
    this._traverse(this, [], lists);
    return lists;
};

/**
* lle : resultat (liste des chemins = liste de "liste d'éléments" [[E]])
*/
NTree.prototype._traverse = function(node, path, lle) {
    path.push(node);
    if (node.isLeaf()) {
        var res = [];
        for (var k = 0; k < path.length; k++) {
            var e = path[k].getItem();
            res.push(e);
        }
        lle.push(res);
    } else {
        var fils = node.getChildrenNodes();

        for (var i = 0; i < fils.length; i++) {
            var newPath = path.slice(0);
            this._traverse(fils[i], newPath, lle);
        }
    }
};

module.exports = NTree;


/***/ }),

/***/ "okk1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var first_1 = __webpack_require__("bBiI");
Observable_1.Observable.prototype.first = first_1.first;
//# sourceMappingURL=first.js.map

/***/ }),

/***/ "osFu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_BehaviorSubject__ = __webpack_require__("TfWX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_BehaviorSubject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs_BehaviorSubject__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Dispatcher; });
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var Dispatcher = (function (_super) {
    __extends(Dispatcher, _super);
    function Dispatcher() {
        return _super.call(this, { type: Dispatcher.INIT }) || this;
    }
    Dispatcher.prototype.dispatch = function (action) {
        this.next(action);
    };
    Dispatcher.prototype.complete = function () {
        // noop
    };
    return Dispatcher;
}(__WEBPACK_IMPORTED_MODULE_0_rxjs_BehaviorSubject__["BehaviorSubject"]));

Dispatcher.INIT = '@ngrx/store/init';
//# sourceMappingURL=dispatcher.js.map

/***/ }),

/***/ "ot07":
/***/ (function(module, exports) {

exports.config = {"status":true,"model":{"title-en":"Margo 6","module":"margo","js":["spbase-model.js","margo-model.js"],"summary":"Margo game","thumbnail":"tn-margo6.png","strings":[],"rules":{"en":"rules.html","fr":"rules-fr.html"},"description":{"en":"description.html","fr":"description-fr.html"},"credits":{"en":"credits.html","fr":"credits-fr.html"},"demoRandom":true,"gameOptions":{"preventRepeat":true,"uctTransposition":"states","uctIgnoreLoop":true,"size":6,"levelOptions":{"evalSafety":18.087998411946,"evalSafety2eyes":33.190368679179,"evalSafetyXEyesBonus":1.7649150399344,"evalSafety1f":9.163683726905,"evalSafety3f":27.587078130791,"evalSafety3fMore":28.254787541129,"evalSafety3fMoreBonus":0.93791029877741,"evalSafety1eyeBonus":9.1829299172843,"evalSafetyPinnedBonus":0.3350934287035,"evalHeightRatio":1.3477082543829,"evalCenterRatio":0.091233102472746}},"plazza":"true","levels":[{"label":"Fast (1sec)","maxDuration":1,"isDefault":true,"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0,"ignoreLeaf":false,"uncertaintyFactor":0},{"label":"Beginner","maxDuration":1,"maxNodes":250,"maxLoops":50,"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0,"ignoreLeaf":false,"uncertaintyFactor":0},{"label":"Easy","maxDuration":2,"maxNodes":500,"maxLoops":100,"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0,"ignoreLeaf":false,"uncertaintyFactor":0},{"label":"Medium","maxDuration":4,"maxNodes":2500,"maxLoops":200,"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0,"ignoreLeaf":false,"uncertaintyFactor":0},{"label":"Confirmed","maxDuration":8,"maxNodes":5000,"maxLoops":500,"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0,"ignoreLeaf":false,"uncertaintyFactor":0},{"label":"Slow (10sec)","maxDuration":10,"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0,"ignoreLeaf":false,"uncertaintyFactor":0}]},"view":{"title-en":"Margo View","module":"margo","js":["spbase-xd-view.js"],"xdView":true,"css":["spbase.css"],"preferredRatio":1,"useNotation":true,"defaultOptions":{"sounds":true,"moves":true,"notation":false},"skins":[{"name":"classic3d","title":"3D Classic","3d":true,"camera":{"radius":20,"elevationAngle":45,"limitCamMoves":true,"distMax":40,"distMin":10,"elevationMin":-45,"elevationMax":89.9,"enableDrag":false},"world":{"lightIntensity":0,"color":0,"fog":false,"skyLightIntensity":0.7,"skyLightPosition":{"x":0,"y":10,"z":0},"ambientLightColor":8947848},"preload":["image|/res/xd-view/meshes/grey.png","image|/res/xd-view/meshes/black.png","image|/res/xd-view/meshes/white.png","image|/res/xd-view/meshes/green.png","image|/res/xd-view/meshes/skybox/nx.jpg","image|/res/xd-view/meshes/skybox/ny.jpg","image|/res/xd-view/meshes/skybox/nz.jpg","image|/res/xd-view/meshes/skybox/px.jpg","image|/res/xd-view/meshes/skybox/py.jpg","image|/res/xd-view/meshes/skybox/pz.jpg"]},{"name":"wood","title":"Wood","preload":["image|/res/images/ball_black.png","image|/res/images/ball_white.png","image|/res/images/ball_green.png","image|/res/images/plot.png","image|/res/images/wood.png"]},{"name":"classical","title":"Classic","preload":["image|/res/images/ball_black.png","image|/res/images/ball_white.png","image|/res/images/ball_green.png","image|/res/images/plot.png"]}],"animateSelfMoves":false,"visuals":{"600x600":["res/visuals/margo6-600x600-3d.jpg","res/visuals/margo6-600x600-2d.jpg"]}}}

/***/ }),

/***/ "owqQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.compose = function () {
    var functions = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        functions[_i - 0] = arguments[_i];
    }
    return function (arg) {
        if (functions.length === 0) {
            return arg;
        }
        var last = functions[functions.length - 1];
        var rest = functions.slice(0, -1);
        return rest.reduceRight(function (composed, fn) { return fn(composed); }, last(arg));
    };
};


/***/ }),

/***/ "p1Um":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var observeOn_1 = __webpack_require__("Ji1B");
Observable_1.Observable.prototype.observeOn = observeOn_1.observeOn;
//# sourceMappingURL=observeOn.js.map

/***/ }),

/***/ "p5++":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__("mmVS");
var EmptyError_1 = __webpack_require__("F7Al");
/**
 * Returns an Observable that emits the single item emitted by the source Observable that matches a specified
 * predicate, if that Observable emits one such item. If the source Observable emits more than one such item or no
 * such items, notify of an IllegalArgumentException or NoSuchElementException respectively.
 *
 * <img src="./img/single.png" width="100%">
 *
 * @throws {EmptyError} Delivers an EmptyError to the Observer's `error`
 * callback if the Observable completes before any `next` notification was sent.
 * @param {Function} predicate - A predicate function to evaluate items emitted by the source Observable.
 * @return {Observable<T>} An Observable that emits the single item emitted by the source Observable that matches
 * the predicate.
 .
 * @method single
 * @owner Observable
 */
function single(predicate) {
    return this.lift(new SingleOperator(predicate, this));
}
exports.single = single;
var SingleOperator = (function () {
    function SingleOperator(predicate, source) {
        this.predicate = predicate;
        this.source = source;
    }
    SingleOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new SingleSubscriber(subscriber, this.predicate, this.source));
    };
    return SingleOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var SingleSubscriber = (function (_super) {
    __extends(SingleSubscriber, _super);
    function SingleSubscriber(destination, predicate, source) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.source = source;
        this.seenValue = false;
        this.index = 0;
    }
    SingleSubscriber.prototype.applySingleValue = function (value) {
        if (this.seenValue) {
            this.destination.error('Sequence contains more than one element');
        }
        else {
            this.seenValue = true;
            this.singleValue = value;
        }
    };
    SingleSubscriber.prototype._next = function (value) {
        var index = this.index++;
        if (this.predicate) {
            this.tryNext(value, index);
        }
        else {
            this.applySingleValue(value);
        }
    };
    SingleSubscriber.prototype.tryNext = function (value, index) {
        try {
            if (this.predicate(value, index, this.source)) {
                this.applySingleValue(value);
            }
        }
        catch (err) {
            this.destination.error(err);
        }
    };
    SingleSubscriber.prototype._complete = function () {
        var destination = this.destination;
        if (this.index > 0) {
            destination.next(this.seenValue ? this.singleValue : undefined);
            destination.complete();
        }
        else {
            destination.error(new EmptyError_1.EmptyError);
        }
    };
    return SingleSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=single.js.map

/***/ }),

/***/ "p5Bt":
/***/ (function(module, exports) {

exports.model=Model={Game:{},Board:{},Move:{}},Model.Game.InitGame=function(){for(var t=this.mOptions.width,i=this.mOptions.height,s=this.mOptions.lines,o=[[-1,-1],[0,-1],[1,-1],[-1,0]],h=[],e=0;e<i;e++)for(var r=0;r<t;r++)for(var n=0;n<o.length;n++){var l,a=o[n][0],p=o[n][1],d=[];for(l=0;l<s;l++){var u;if(u=this.mOptions.torus?(e+p*l)*t+(r+a*l+t)%t:(e+p*l)*t+r+a*l,this.mOptions.torus&&(e+p*l<0||e+p*l>=i))break;if(!this.mOptions.torus&&(r+a*l<0||r+a*l>=t||e+p*l<0||e+p*l>=i))break;d.push(u)}l==s&&h.push(d)}this.g.TuplesList=h;for(var m={},l=0;l<h.length;l++)for(var d=h[l],v=0;v<d.length;v++){var u=d[v];void 0===m[u]&&(m[u]=[]),m[u].push(d)}this.g.Tuples=m,this.zobrist=new JocGame.Zobrist({board:{type:"array",size:this.mOptions.width*this.mOptions.height,values:["1","-1"]}})},Model.Move.Init=function(t){this.op=t.op,this.col=t.col},Model.Move.CopyFrom=function(t){this.Init(t)},Model.Move.ToString=function(){var t="";switch(this.op){case"+":t+="+";break;case"-":t+="-";break;default:t+="?"}return t+=String.fromCharCode(65+this.col)},Model.Board.Init=function(t){this.zSign=0},Model.Board.InitialPosition=function(t){this.board=[];for(var i=t.mOptions.width,s=t.mOptions.height,o=0;o<s;o++)for(var h=0;h<i;h++)this.board.push(0);this.tuples={};for(var e=1;e<=t.mOptions.lines;e++)this.tuples[e]=0,this.tuples[-e]=0;this.cols=[];for(var h=0;h<i;h++)this.cols.push(0);if(t.mOptions.fillSides)for(var e=0;e<s;e++){var r=e*i,n=e%2?-1:1,l=0;this.board[r]=n,this.cols[l]++,this.tuples[n]++,this.zSign=t.zobrist.update(this.zSign,"board",n,r);var r=e*i+i-1,n=e%2?1:-1,l=i-1;this.board[r]=n,this.cols[l]++,this.tuples[n]++,this.zSign=t.zobrist.update(this.zSign,"board",n,r)}},Model.Board.GenerateMoves=function(t){for(var i=[],s=t.mOptions.height,o=0;o<t.mOptions.width;o++)this.cols[o]<s&&i.push({op:"+",col:o});if(t.mOptions.remove)for(var o=0;o<t.mOptions.width;o++)this.board[o]==this.mWho&&i.push({op:"-",col:o});this.mMoves=i,0==i.length&&(this.mFinished=!0,this.mWinner=JocGame.DRAW)},Model.Board.Evaluate=function(t){if(this.mEvaluation=0,this.mWinner=0,t.mOptions.preventRepeat&&t.GetRepeatOccurence(this)>2)return this.mFinished=!0,void(this.mWinner=JocGame.DRAW);if(this.tuples[t.mOptions.lines]>0&&(this.mFinished=!0,this.mWinner=1),this.tuples[-t.mOptions.lines]>0)return this.mFinished=!0,void(this.mWinner?this.mWinner=JocGame.DRAW:this.mWinner=-1);if(!this.mFinished)for(var i=t.mOptions.levelOptions,s=1;s<t.mOptions.lines;s++)this.mEvaluation+=this.tuples[s]*i["evalTuple"+s],this.mEvaluation-=this.tuples[-s]*i["evalTuple"+s]},Model.Board.ApplyMove=function(t,i){if("+"==i.op){for(var s=i.col,o=this.cols[s],h=o*t.mOptions.width+s,e=0;e<t.g.Tuples[h].length;e++){for(var r=t.g.Tuples[h][e],n={1:0,0:0,"-1":0},l=0;l<r.length;l++)n[this.board[r[l]]]++;n[1]>0&&0==n[-1]?this.tuples[n[1]]--:n[-1]>0&&0==n[1]&&this.tuples[-n[-1]]--,n[this.mWho]++,n[1]>0&&0==n[-1]?this.tuples[n[1]]++:n[-1]>0&&0==n[1]&&this.tuples[-n[-1]]++}this.board[h]=this.mWho,this.cols[s]++,this.zSign=t.zobrist.update(this.zSign,"board",this.mWho,h)}else if("-"==i.op){for(var o=0;o<this.cols[i.col];o++)for(var h=o*t.mOptions.width+i.col,e=0;e<t.g.Tuples[h].length;e++){for(var r=t.g.Tuples[h][e],n={1:0,0:0,"-1":0},l=0;l<r.length;l++)n[this.board[r[l]]]++;n[1]>0&&0==n[-1]?this.tuples[n[1]]--:n[-1]>0&&0==n[1]&&this.tuples[-n[-1]]--}for(var e=0;e<this.cols[i.col];e++){var h=e*t.mOptions.width+i.col,a=h+t.mOptions.width,p=0;a<this.board.length&&(p=this.board[a]),this.zSign=t.zobrist.update(this.zSign,"board",this.board[h],h),p&&(this.zSign=t.zobrist.update(this.zSign,"board",p,h)),this.board[h]=p}this.cols[i.col]--;for(var o=0;o<this.cols[i.col];o++)for(var h=o*t.mOptions.width+i.col,e=0;e<t.g.Tuples[h].length;e++){for(var r=t.g.Tuples[h][e],n={1:0,0:0,"-1":0},l=0;l<r.length;l++)n[this.board[r[l]]]++;n[1]>0&&0==n[-1]?this.tuples[n[1]]++:n[-1]>0&&0==n[1]&&this.tuples[-n[-1]]++}}else console.error("Invalid move",i)},Model.Board.CopyFrom=function(t){this.tuples={};for(var i in t.tuples)this.tuples[i]=t.tuples[i];this.board=[];for(var s=0;s<t.board.length;s++)this.board.push(t.board[s]);this.cols=[];for(var o=0;o<t.cols.length;o++)this.cols.push(t.cols[o]);this.mWho=t.mWho,this.zSign=t.zSign},Model.Board.GetSignature=function(){return this.zSign};

/***/ }),

/***/ "pCI3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_operator_enterZone__ = __webpack_require__("aWfe");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_operator_leaveZone__ = __webpack_require__("Ha1/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_operator_select__ = __webpack_require__("4PFd");
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__src_operator_select__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_compose__ = __webpack_require__("I4Dk");
/* unused harmony namespace reexport */




//# sourceMappingURL=index.js.map

/***/ }),

/***/ "pCie":
/***/ (function(module, exports) {

exports.model=Model={Game:{},Board:{},Move:{}},function(){var t;Model.Game.cbConstants={MASK:65535,FLAG_MOVE:65536,FLAG_CAPTURE:131072,FLAG_STOP:262144,FLAG_SCREEN_CAPTURE:524288,FLAG_CAPTURE_KING:1048576,FLAG_CAPTURE_NO_KING:2097152};var e="undefined"!=typeof Int32Array;Model.Game.cbUseTypedArrays=e,Model.Game.cbTypedArray=function(t){if(e){var r=new Int32Array(t.length);return r.set(t),r}for(var i=[],a=t.length,n=0;n<a;n++)i.push(t[n]);return i},Model.Game.cbShortRangeGraph=function(t,e,r,i){var a=this;void 0===i&&(i=196608);for(var n={},s=0;s<t.boardSize;s++)n[s]=[],(!r||s in r)&&e.forEach(function(e){var o=t.Graph(s,e);null!=o&&(!r||o in r)&&n[s].push(a.cbTypedArray([o|i]))});return n},Model.Game.cbLongRangeGraph=function(t,e,r,i,a){var n=this;void 0!==i&&null!=i||(i=196608),a||(a=1/0);for(var s={},o=0;o<t.boardSize;o++)s[o]=[],(!r||o in r)&&e.forEach(function(e){for(var h=[],c=t.Graph(o,e),p=0;null!=c&&(!r||c in r)&&(h.push(c|i),++p!=a);)c=t.Graph(c,e);h.length>0&&s[o].push(n.cbTypedArray(h))});return s},Model.Game.cbNullGraph=function(t){for(var e={},r=0;r<t.boardSize;r++)e[r]=[];return e},Model.Game.cbAuthorGraph=function(t){for(var e={},r=0;r<t.boardSize;r++){e[r]=[];for(var i=0;i<t.boardSize;i++)e[r].push([2293760|i])}return e},Model.Game.cbMergeGraphs=function(t){for(var e=[],r=0;r<t.boardSize;r++){e[r]=[];for(var i=1;i<arguments.length;i++)e[r]=e[r].concat(arguments[i][r])}return e},Model.Game.cbGetThreatGraph=function(){function t(e,r){for(var i in s){var a=s[i];if(!(a.p.length<r.length+1)){for(var n=!0,o=0;o<r.length;o++)if(r[o]!=a.p[o]){n=!1;break}if(n){var h=a.p[r.length],c=e[h];void 0===c&&(c={e:{}},e[h]=c),a.p.length==r.length+1&&(c.t=a.t,c.ts=a.ts,c.tk=a.tk,delete s[i]),r.push(h),t(c.e,r),r.pop()}}}}var e=this;this.cbUseScreenCapture=!1,this.cbUseCaptureKing=!1,this.cbUseCaptureNoKing=!1;for(var r={1:[],"-1":[]},i=[],a=0;a<this.g.boardSize;a++)this.g.pTypes.forEach(function(t,r){t.graph[a].forEach(function(t){for(var n=[],s=0;s<t.length;s++){var o=t[s];1048576&o?(e.cbUseCaptureKing=!0,n.unshift({d:65535&o,a:a,tk:r})):2097152&o?(e.cbUseCaptureNoKing=!0,n.unshift({d:65535&o,a:a,tnk:r})):131072&o?n.unshift({d:65535&o,a:a,t:r}):262144&o?n.unshift({d:65535&o,a:a}):524288&o&&(e.cbUseScreenCapture=!0,n.unshift({d:65535&o,a:a,ts:r}))}n.length>0&&i.push(n)})});var n={};i.forEach(function(t){t.forEach(function(e,r){var i=n[e.d];void 0===i&&(i={},n[e.d]=i);for(var a=[],s=r+1;s<t.length;s++)a.push(t[s].d);a.push(e.a);var o=a.join(","),h=i[o];void 0===h&&(h={p:a,t:{},ts:{},tk:{}},i[o]=h),void 0!==e.t?h.t[e.t]=!0:void 0!==e.tk?h.tk[e.tk]=!0:void 0!==e.ts&&(h.ts[e.ts]=!0)})});for(var a=0;a<e.g.boardSize;a++){var s=n[a],o={};t(o,[]),r[1][a]=o,r[-1][a]=o}return r},Model.Game.InitGame=function(){var e=this;this.cbVar=t=this.cbDefine(),this.g.boardSize=this.cbVar.geometry.boardSize,this.g.pTypes=this.cbGetPieceTypes(),this.g.threatGraph=this.cbGetThreatGraph(),this.g.distGraph=this.cbVar.geometry.GetDistances(),this.cbPiecesCount=0,this.g.castleablePiecesCount={1:0,"-1":0};for(var r in t.pieceTypes){var i=t.pieceTypes[r];if(i.castle){(i.initial||[]).forEach(function(t){e.g.castleablePiecesCount[t.s]++})}i.initial&&(this.cbPiecesCount+=i.initial.length)}for(var a=[],r=0;r<this.cbPiecesCount;r++)a.push(r);var n=Object.keys(t.pieceTypes);this.zobrist=new JocGame.Zobrist({board:{type:"array",size:this.cbVar.geometry.boardSize,values:a},who:{values:["1","-1"]},type:{type:"array",size:this.cbPiecesCount,values:n}})},Model.Game.cbGetPieceTypes=function(){for(var t=[],e={},r=0;r<this.cbVar.geometry.boardSize;r++)e[r]=[];for(var i in this.cbVar.pieceTypes){var a=this.cbVar.pieceTypes[i];t[i]={graph:a.graph||e,abbrev:a.abbrev||"",value:a.isKing?100:a.value||1,isKing:!!a.isKing,castle:!!a.castle,epTarget:!!a.epTarget,epCatch:!!a.epCatch}}return t},Model.Board.Init=function(t){this.zSign=0},Model.Board.InitialPosition=function(r){var i=this;this.board=e?new Int16Array(r.g.boardSize):[];for(var a=0;a<r.g.boardSize;a++)this.board[a]=-1;if(this.kings={},this.pieces=[],this.ending={1:!1,"-1":!1},this.lastMove=null,r.cbVar.castle&&(this.castled={1:!1,"-1":!1}),this.zSign=r.zobrist.update(0,"who",-1),this.noCaptCount=0,this.mWho=1,r.mInitial)this.mWho=r.mInitial.turn||1,r.mInitial.pieces.forEach(function(t){var e={};for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);i.pieces.push(e)}),r.mInitial.lastMove&&(this.lastMove={f:r.mInitial.lastMove.f,t:r.mInitial.lastMove.t}),void 0!==r.mInitial.noCaptCount&&(this.noCaptCount=r.mInitial.noCaptCount),r.cbVar.castle&&r.mInitial.castle&&(this.castled={1:{k:!!r.mInitial.castle[1]&&!!r.mInitial.castle[1].k,q:!!r.mInitial.castle[1]&&!!r.mInitial.castle[1].q},"-1":{k:!!r.mInitial.castle[-1]&&!!r.mInitial.castle[-1].k,q:!!r.mInitial.castle[-1]&&!!r.mInitial.castle[-1].q}});else for(var n in r.cbVar.pieceTypes)for(var s=r.cbVar.pieceTypes[n],o=s.initial||[],h=0;h<o.length;h++){var c=o[h],p={s:c.s,t:parseInt(n),p:c.p,m:!1};this.pieces.push(p)}if(this.pieces.sort(function(t,e){if(t.s!=e.s)return e.s-t.s;var i=r.cbVar.pieceTypes[t.t].value||100,a=r.cbVar.pieceTypes[e.t].value||100;return i!=a?i-a:t.p-e.p}),this.pieces.forEach(function(t,e){t.i=e,i.board[t.p]=e,r.g.pTypes[t.t].isKing&&(i.kings[t.s]=t.p),i.zSign=r.zobrist.update(i.zSign,"board",e,t.p),i.zSign=r.zobrist.update(i.zSign,"type",t.t,e)}),r.mInitial&&r.mInitial.enPassant){var a=t.geometry.PosByName(r.mInitial.enPassant);if(a>=0){var l,u=t.geometry.C(a),v=t.geometry.R(a);l=1==r.mInitial.turn?t.geometry.POS(u,v-1):t.geometry.POS(u,v+1),this.epTarget={p:a,i:this.board[l]}}}},Model.Board.CopyFrom=function(t){if(e)this.board=new Int16Array(t.board.length),this.board.set(t.board);else{this.board=[];for(var r=t.board,i=r.length,a=0;a<i;a++)this.board.push(r[a])}this.pieces=[];for(var n=t.pieces.length,a=0;a<n;a++){var s=t.pieces[a];this.pieces.push({s:s.s,p:s.p,t:s.t,i:s.i,m:s.m})}this.kings={1:t.kings[1],"-1":t.kings[-1]},this.check=t.check,t.lastMove?this.lastMove={f:t.lastMove.f,t:t.lastMove.t,c:t.lastMove.c}:this.lastMove=null,this.ending={1:t.ending[1],"-1":t.ending[-1]},void 0!==t.castled&&(this.castled={1:t.castled[1],"-1":t.castled[-1]}),this.noCaptCount=t.noCaptCount,t.epTarget?this.epTarget={p:t.epTarget.p,i:t.epTarget.i}:this.epTarget=null,this.mWho=t.mWho,this.zSign=t.zSign},Model.Board.cbApplyCastle=function(t,e,r){var i=t.cbVar.castle[e.f+"/"+e.cg],a=i.r[i.r.length-1],n=this.pieces[this.board[e.cg]],s=i.k[i.k.length-1],o=this.pieces[this.board[e.f]];return r&&(this.zSign=t.zobrist.update(this.zSign,"board",n.i,e.cg),this.zSign=t.zobrist.update(this.zSign,"board",n.i,a),this.zSign=t.zobrist.update(this.zSign,"board",o.i,e.f),this.zSign=t.zobrist.update(this.zSign,"board",o.i,s)),n.p=a,n.m=!0,this.board[e.cg]=-1,o.p=s,o.m=!0,this.board[e.f]=-1,this.board[a]=n.i,this.board[s]=o.i,this.castled[n.s]=!0,this.kings[o.s]=s,[{i:n.i,f:a,t:-1},{i:o.i,f:s,t:e.f,kp:e.f,who:o.s,m:!1},{i:n.i,f:-1,t:e.cg,m:!1,cg:!1}]},Model.Board.cbQuickApply=function(t,e){if(void 0!==e.cg)return this.cbApplyCastle(t,e,!1);var r=[],i=this.board[e.f],a=this.pieces[i];if(null!=e.c){r.unshift({i:e.c,f:-1,t:this.pieces[e.c].p});var n=this.pieces[e.c];this.board[n.p]=-1,n.p=-1}var s=this.kings[a.s];return t.g.pTypes[a.t].isKing&&(this.kings[a.s]=e.t),r.unshift({i:i,f:e.t,t:e.f,kp:s,who:a.s,ty:a.t}),a.p=e.t,void 0!==e.pr&&(a.t=e.pr),this.board[e.f]=-1,this.board[e.t]=i,r},Model.Board.cbQuickUnapply=function(t,e){for(var r=0;r<e.length;r++){var i=e[r],a=this.pieces[i.i];i.f>=0&&(a.p=-1,this.board[i.f]=-1),i.t>=0&&(a.p=i.t,this.board[i.t]=i.i),void 0!==i.m&&(a.m=i.m),void 0!==i.kp&&(this.kings[i.who]=i.kp),void 0!=i.ty&&(a.t=i.ty),void 0!=i.cg&&(this.castled[a.s]=i.cg)}},Model.Board.ApplyMove=function(t,e){var r=this.pieces[this.board[e.f]];if(void 0!==e.cg)this.cbApplyCastle(t,e,!0);else{if(this.zSign=t.zobrist.update(this.zSign,"board",r.i,e.f),this.board[r.p]=-1,void 0!==e.pr&&(this.zSign=t.zobrist.update(this.zSign,"type",r.t,r.i),r.t=e.pr,this.zSign=t.zobrist.update(this.zSign,"type",r.t,r.i)),null!=e.c){var i=this.pieces[e.c];this.zSign=t.zobrist.update(this.zSign,"board",i.i,i.p),this.board[i.p]=-1,i.p=-1,i.m=!0,this.noCaptCount=0}else this.noCaptCount++;r.p=e.t,r.m=!0,this.board[e.t]=r.i,this.zSign=t.zobrist.update(this.zSign,"board",r.i,e.t),t.g.pTypes[r.t].isKing&&(this.kings[r.s]=e.t)}this.check=!!e.ck,this.lastMove={f:e.f,t:e.t,c:e.c},void 0!==e.ko&&(this.ending[r.s]=e.ko),void 0!==e.ept?this.epTarget={p:e.ept,i:r.i}:this.epTarget=null,this.zSign=t.zobrist.update(this.zSign,"who",-this.mWho),this.zSign=t.zobrist.update(this.zSign,"who",this.mWho)},Model.Board.Evaluate=function(r){function i(e){var r=1/0;for(var i in t.geometry.corners)r=Math.min(r,h.distGraph[n.kings[e]][i]);return r-Math.sqrt(h.boardSize)}var a="debug"==arguments[3],n=this;this.mEvaluation=0;var s,o=this.mWho,h=r.g;if(e)s={1:{count:new Uint8Array(h.pTypes.length),byType:{}},"-1":{count:new Uint8Array(h.pTypes.length),byType:{}}};else{s={1:{count:[],byType:{}},"-1":{count:[],byType:{}}};for(var c=0;c<h.pTypes.length;c++)s[1].count[c]=s[-1].count[c]=0}if(r.mOptions.preventRepeat&&r.GetRepeatOccurence(this)>2)return this.mFinished=!0,void(this.mWinner=r.cbOnPerpetual?o*r.cbOnPerpetual:JocGame.DRAW);for(var p={1:0,"-1":0},l={1:h.distGraph[this.kings[-1]],"-1":h.distGraph[this.kings[1]]},u={1:0,"-1":0},v={1:0,"-1":0},b={1:0,"-1":0},f={1:0,"-1":0},d={1:!1,"-1":!1},g=this.pieces,m=g.length,c=0;c<m;c++){var G=g[c];if(G.p>=0){var y=G.s,M=h.pTypes[G.t];M.isKing?d[y]=G.m:p[y]+=M.value,M.castle&&!G.m&&f[y]++,v[y]++,u[y]+=l[y][G.p],b[y]+=t.geometry.distEdge[G.p];var C=s[y];C.count[G.t]++;var S=C.byType;void 0===S[G.t]?S[G.t]=[G]:S[G.t].push(G)}}if(this.lastMove&&null!=this.lastMove.c){var G=this.pieces[this.board[this.lastMove.t]];p[-G.s]+=this.cbStaticExchangeEval(r,G.p,G.s,{piece:G})}var k={1:0,"-1":0},A={1:0,"-1":0},T={1:0,"-1":0};this.ending[1]&&(A[1]=(u[1]-Math.sqrt(h.boardSize))/v[1],t.geometry.corners&&(T[1]=i(1))),this.ending[-1]&&(A[-1]=(u[-1]-Math.sqrt(h.boardSize))/v[-1],t.geometry.corners&&(T[1]=i(-1)));var z={pieceValue:p[1]-p[-1],pieceValueRatio:(p[1]-p[-1])/(p[1]+p[-1]+1),posValue:b[1]-b[-1],averageDistKing:u[1]/v[1]-u[-1]/v[-1],check:this.check?-o:0,endingKingFreedom:k[1]-k[-1],endingDistKing:A[1]-A[-1],distKingCorner:T[1]-T[-1]};t.castle&&(z.castle=(this.castled[1]?1:d[1]?0:f[1]/(h.castleablePiecesCount[1]+1))-(this.castled[-1]?1:d[-1]?0:f[-1]/(h.castleablePiecesCount[-1]+1))),t.evaluate&&t.evaluate.call(this,r,z,s);var P=r.mOptions.levelOptions;for(var E in z){var w=z[E],R=P[E+"Factor"]||0,I=w*R;a&&console.log(E,"=",w,"*",R,"=>",I),this.mEvaluation+=I}a&&console.log("Evaluation",this.mEvaluation)},Model.Board.cbGeneratePseudoLegalMoves=function(t){function e(e,a){var n=t.cbVar.promote;if(!n)return void i.push(a);var s=n.call(r,t,e,a);if(null!=s)if(0==s.length)i.push(a);else if(1==s.length)a.pr=s[0],i.push(a);else for(var o=0;o<s.length;o++){var h=s[o];i.push({f:a.f,t:a.t,c:a.c,pr:h,ept:a.ept,ep:a.ep,a:a.a})}}for(var r=this,i=[],a=t.cbVar,n=this.mWho,s=!a.castle||this.check||this.castled[n]?null:[],o=-1,h=this.pieces.length,c=0;c<h;c++){var p=this.pieces[c];if(!(p.p<0||p.s!=n)){var l=t.g.pTypes[p.t];l.isKing&&(p.m?s=null:o=p),s&&l.castle&&!p.m&&s.push(p);var u,v;u=l.graph[p.p],v=u.length;for(var b=0;b<v;b++)for(var f=u[b],d=!1,g=f.length,m=null,G=0;G<g;G++){var y=f[G],M=65535&y,C=this.board[M];if(!(C<0)||l.epCatch&&this.epTarget&&this.epTarget.p==M){if(!(524288&y)){var S;S=C<0?this.pieces[this.epTarget.i]:this.pieces[C],!(S.s!=p.s&&131072&y)||1048576&y&&!t.g.pTypes[S.t].isKing||2097152&y&&t.g.pTypes[S.t].isKing||e(p,{f:p.p,t:M,c:S.i,a:l.abbrev,ep:C<0});break}if(d){var S=this.pieces[C];S.s!=p.s&&e(p,{f:p.p,t:M,c:S.i,a:l.abbrev});break}d=!0}else 65536&y&&0==d&&e(p,{f:p.p,t:M,c:null,a:l.abbrev,ept:null!=m&&l.epTarget?m:void 0});m=M}}}if(s)for(var c=0;c<s.length;c++){var k=s[c],A=t.cbVar.castle[o.p+"/"+k.p];if(A){for(var T=!0,b=0;b<A.r.length;b++){var z=A.r[b];if(this.board[z]>=0&&z!=o.p&&z!=k.p){T=!1;break}}if(T){for(var P=!0,b=0;b<A.k.length;b++){var z=A.k[b];if(this.board[z]>=0&&z!=k.p&&z!=o.p||this.cbGetAttackers(t,z,n).length>0){P=!1;break}}P&&i.push({f:o.p,t:A.k[A.k.length-1],c:null,cg:k.p})}}}return i},Model.Board.cbStaticExchangeEval=function(t,e,r,i){var a=0,n=this.cbGetSmallestAttacker(t,e,r);if(n){var s=this.mWho;this.mWho=n.s;var o=this.cbQuickApply(t,{f:n.p,t:e,c:i.piece.i}),h=t.g.pTypes[i.piece.t].value;i.piece=n,a=Math.max(0,h-this.cbStaticExchangeEval(t,e,-r,i)),this.cbQuickUnapply(t,o),this.mWho=s}return a},Model.Board.cbGetSmallestAttacker=function(t,e,r){var i=this.cbGetAttackers(t,e,r);if(0==i.length)return null;for(var a=1/0,n=null,s=i.length,o=0;o<s;o++){var h=i[o],c=t.g.pTypes[h.t].value;c<a&&(a=c,n=h)}return n},Model.Board.cbCollectAttackers=function(t,e,r,i){for(var a in e){var n=e[a],s=this.board[a];if(s<0)this.cbCollectAttackers(t,n.e,r,i);else{var o=this.pieces[s];o.s==-t&&(n.t&&o.t in n.t||i&&n.tk&&o.t in n.tk)&&r.push(o)}}},Model.Board.cbCollectAttackersScreen=function(t,e,r,i,a){for(var n in e){var s=e[n],o=this.board[n];if(o<0)this.cbCollectAttackersScreen(t,s.e,r,i,a);else{var h=this.pieces[o];!a&&h.s==-t&&(s.t&&h.t in s.t||i&&s.tk&&h.t in s.tk)?r.push(h):a?a&&h.s==-t&&s.ts&&h.t in s.ts&&r.push(h):this.cbCollectAttackersScreen(t,s.e,r,i,!0)}}},Model.Board.cbGetAttackers=function(t,e,r,i){var a=[];return t.cbUseScreenCapture?this.cbCollectAttackersScreen(r,t.g.threatGraph[r][e],a,i,!1):this.cbCollectAttackers(r,t.g.threatGraph[r][e],a,i),a},Model.Board.GenerateMoves=function(t){var e=this.cbGeneratePseudoLegalMoves(t);this.mMoves=[];for(var r=!0,i=this.kings[this.mWho],a=e.length,n=0;n<a;n++){var s=e[n],o=this.cbQuickApply(t,s);if(!(this.cbGetAttackers(t,this.kings[this.mWho],this.mWho,!0).length>0)){var h=this.cbGetAttackers(t,this.kings[-this.mWho],-this.mWho,!0).length>0;s.ck=h,this.mMoves.push(s),s.f!=i&&(r=!1)}this.cbQuickUnapply(t,o)}if(0==this.mMoves.length)this.mFinished=!0,this.mWinner=t.cbOnStaleMate?t.cbOnStaleMate*this.mWho:JocGame.DRAW,this.check&&(this.mWinner=-this.mWho);else if(this.ending[this.mWho]){if(!r)for(var n=0;n<this.mMoves.length;n++)this.mMoves[n].ko=!1}else if(!this.ending[this.mWho]&&r&&!this.check)for(var n=0;n<this.mMoves.length;n++)this.mMoves[n].ko=!0},Model.Board.GetSignature=function(){return this.zSign},Model.Move.Init=function(t){for(var e in t)t.hasOwnProperty(e)&&(this[e]=t[e])},Model.Move.Equals=function(t){return this.f==t.f&&this.t==t.t&&this.pr==t.pr},Model.Move.CopyFrom=function(t){this.Init(t)},Model.Move.ToString=function(e){var r=this;switch(e=e||"natural"){case"natural":return function(){var e;if(void 0!==r.cg?e=t.castle[r.f+"/"+r.cg].n:(e=r.a||"",e+=t.geometry.PosName(r.f),null==r.c?e+="-":e+="x",e+=t.geometry.PosName(r.t)),void 0!==r.pr){var i=t.pieceTypes[r.pr];i&&i.abbrev&&i.abbrev.length>0&&!i.silentPromo&&(e+="="+i.abbrev)}return r.ck&&(e+="+"),e}();case"engine":return function(){var e=t.geometry.PosName(r.f)+t.geometry.PosName(r.t);if(void 0!=r.pr){var i=t.pieceTypes[r.pr];i&&i.abbrev&&i.abbrev.length>0&&!i.silentPromo&&(e+=i.abbrev)}return e}();default:return"??"}},Model.Board.CompactMoveString=function(e,r,i){"function"!=typeof r.ToString&&(r=e.CreateMove(r));var a=r.ToString(),n=/^([A-Z]?)([a-z])([1-9][0-9]*)([-x])([a-z])([1-9][0-9]*)(.*?)$/.exec(a);if(!n)return a;var s=n[7];if(i||(i={}),i.value||(i.value=[]),0==i.value.length){var o=this.mMoves;this.mMoves&&0!=this.mMoves.length||this.GenerateMoves(e);for(var h=0;h<this.mMoves.length;h++){var c=this.mMoves[h];"function"!=typeof c.ToString&&(c=e.CreateMove(c)),i.value.push({str:c.ToString(),move:c})}this.mMoves=o}var p=[];if(i.value.forEach(function(t){var e=/^([A-Z]?[a-z][1-9][0-9]*[-x][a-z][1-9][0-9]*)(.*?)$/.exec(t.str);e&&t.move.t==r.t&&(t.move.a||"")==n[1]&&e[2]==s&&p.push(t.move)}),1==p.length)return""==n[1]&&"x"==n[4]?n[2]+"x"+n[5]+n[6]+n[7]:n[1]+("x"==n[4]?"x":"")+n[5]+n[6]+n[7];if(t.geometry.CompactCrit)for(var l="",h=0;;h++){var u=t.geometry.CompactCrit(r.f,h);if(null==u)return a;l+=u;for(var v=[],b=0;b<p.length;b++){var f=p[b];t.geometry.CompactCrit(f.f,h)==u&&v.push(f)}if(console.assert(v.length>0),1==v.length)return n[1]+l+("x"==n[4]?"x":"")+n[5]+n[6]+n[7];p=v}return a},Model.Board.cbIntegrity=function(t){function e(t,e){t||console.error(e)}for(var r=this,i=0;i<this.board.length;i++){var a=this.board[i];if(a>=0){var n=r.pieces[a];e(void 0!==n,"no piece at pos"),e(n.p==i,"piece has different pos")}}for(var a=0;a<this.pieces.length;a++){var n=this.pieces[a];n.p>=0&&e(r.board[n.p]==a,"board index mismatch")}},Model.Board.ExportBoardState=function(t){return t.cbVar.geometry.ExportBoardState?t.cbVar.geometry.ExportBoardState(this,t.cbVar,t.mPlayedMoves.length):"not supported"},Model.Game.Import=function(e,r){var i,a=[],n={1:{},"-1":{}},s=null,o=0;if("pjn"==e){var h={status:!1,error:"parse"},c=r.split(" ");if(6!=c.length)return console.warn("FEN should have 6 parts"),h;var p=c[0].split("/"),l=t.geometry.fenHeight||t.geometry.height;if(p.length!=l)return console.warn("FEN board should have",l,"rows, got",p.length),h;var u={};for(var v in t.pieceTypes){var b=t.pieceTypes[v],f=b.fenAbbrev||b.abbrev||"X";u[f.toUpperCase()]={s:1,t:v},u[f.toLowerCase()]={s:-1,t:v}}var d=t.geometry.FenRowPos||function(e,r){return(t.geometry.height-1-e)*t.geometry.width+r};if(p.forEach(function(e,r){for(var i=0,n=0;n<e.length;n++){var s=e.substr(n,1),o=u[s];if(void 0!==o){var c=d(r,i);i++;for(var p={s:o.s,t:o.t,p:c},l=!0,v=t.pieceTypes[p.t].initial||[],b=0;b<v.length;b++){var f=v[b];f.s==p.s&&f.p==c&&(l=!1)}p.m=l,a.push(p)}else{if(isNaN(parseInt(s)))return console.warn("FEN invalid board spec",s),h;i+=parseInt(s)}}}),a.sort(function(t,e){return e.s-t.s}),"w"==c[1])i=1;else{if("b"!=c[1])return console.warn("FEN invalid turn spec",c[1]),h;i=-1}n[1].k=c[2].indexOf("K")>=0,n[1].q=c[2].indexOf("Q")>=0,n[-1].k=c[2].indexOf("k")>=0,n[-1].q=c[2].indexOf("q")>=0,s="-"==c[3]?null:c[3];var g=parseInt(c[4]);isNaN(g)||(o=g);var m={pieces:a,turn:i,castle:n,enPassant:s,noCaptCount:o};return t.importGame&&t.importGame.call(this,m,e,r),{status:!0,initial:m}}return{status:!1,error:"unsupported"}}}(),function(){Model.Game.cbBoardGeometryGrid=function(t,e){function r(e){return e%t}function i(e){return Math.floor(e/t)}function a(e,r){return r*t+e}function n(n,s){var o=r(n),h=i(n),c=o+s[0],p=h+s[1];return c<0||c>=t||p<0||p>=e?null:a(c,p)}function s(t){return String.fromCharCode("a".charCodeAt(0)+r(t))+(i(t)+1)}function o(t){var e=/^([a-z])([0-9]+)$/.exec(t);return e?a(e[1].charCodeAt(0)-"a".charCodeAt(0),parseInt(e[2])-1):-1}function h(t,e){return 0==e?String.fromCharCode("a".charCodeAt(0)+r(t)):1==e?i(t)+1:null}function c(){for(var a=[],n=0;n<t*e;n++){var s=[];a.push(s);for(var o=0;o<t*e;o++){var h=i(n),c=r(n),p=i(o),l=r(o);s.push(Math.max(Math.abs(h-p),Math.abs(c-l)))}}return a}function p(r,i,n){for(var o=[],h=e-1;h>=0;h--){for(var c="",p=0,l=0;l<t;l++){var u=r.board[a(l,h)];if(u<0)p++;else{p>0&&(c+=p,p=0);var v=r.pieces[u],b=i.pieceTypes[v.t].fenAbbrev||i.pieceTypes[v.t].abbrev||"?";v.s==-1?c+=b.toLowerCase():c+=b.toUpperCase()}}p&&(c+=p),o.push(c)}var f=o.join("/");f+=" ",1==r.mWho?f+="w":f+="b",f+=" ";var d="";return r.castled&&(r.castled[1]===!1?d+="KQ":(r.castled[1].k&&(d+="K"),r.castled[1].q&&(d+="Q")),r.castled[-1]===!1?d+="kq":(r.castled[-1].k&&(d+="k"),r.castled[-1].q&&(d+="q"))),0==d.length&&(d="-"),f+=d,f+=" ",r.epTarget?f+=s(r.epTarget.p):f+="-",f+=" ",f+=r.noCaptCount,f+=" ",f+=Math.floor(n/2)+1}return{boardSize:t*e,width:t,height:e,C:r,R:i,POS:a,Graph:n,PosName:s,PosByName:o,CompactCrit:h,GetDistances:c,distEdge:function(){for(var a=[],n=0;n<t*e;n++){var s=r(n),o=i(n);a[n]=Math.min(s,Math.abs(t-s-1),o,Math.abs(e-o-1))}return a}(),corners:function(){var r={};return r[a(0,0)]=1,r[a(0,e-1)]=1,r[a(t-1,0)]=1,r[a(t-1,e-1)]=1,r}(),ExportBoardState:p}},Model.Game.cbPawnGraph=function(t,e,r){for(var i=this,a={},n=0;n<t.boardSize;n++)if(!r||n in r){var s=[],o=t.Graph(n,[0,e]);null!=o&&(!r||o in r)&&s.push(i.cbTypedArray([o|i.cbConstants.FLAG_MOVE])),[-1,1].forEach(function(a){var o=t.Graph(n,[a,e]);null!=o&&(!r||o in r)&&s.push(i.cbTypedArray([o|i.cbConstants.FLAG_CAPTURE]))}),a[n]=s}else a[n]=[];return a},Model.Game.cbInitialPawnGraph=function(t,e,r){for(var i=this,a={},n=0;n<t.boardSize;n++)if(!r||n in r){var s=[],o=t.Graph(n,[0,e]);if(null!=o&&(!r||o in r)){var h=[o|i.cbConstants.FLAG_MOVE],c=t.Graph(o,[0,e]);null!=c&&(!r||c in r)&&h.push(c|i.cbConstants.FLAG_MOVE),s.push(i.cbTypedArray(h))}[-1,1].forEach(function(a){var o=t.Graph(n,[a,e]);null!=o&&(!r||o in r)&&s.push(i.cbTypedArray([o|i.cbConstants.FLAG_CAPTURE]))}),a[n]=s}else a[n]=[];return a},Model.Game.cbKingGraph=function(t,e){return this.cbShortRangeGraph(t,[[-1,-1],[-1,0],[-1,1],[0,-1],[0,1],[1,-1],[1,0],[1,1]],e)},Model.Game.cbKnightGraph=function(t,e){return this.cbShortRangeGraph(t,[[2,-1],[2,1],[-2,-1],[-2,1],[-1,2],[-1,-2],[1,2],[1,-2]],e)},Model.Game.cbHorseGraph=function(t){for(var e=this,r={},i=0;i<t.boardSize;i++)r[i]=[],[[1,0,2,-1],[1,0,2,1],[-1,0,-2,-1],[-1,0,-2,1],[0,1,-1,2],[0,-1,-1,-2],[0,1,1,2],[0,-1,1,-2]].forEach(function(a){var n=t.Graph(i,[a[0],a[1]]);if(null!=n){var s=t.Graph(i,[a[2],a[3]]);null!=s&&r[i].push(e.cbTypedArray([n|e.cbConstants.FLAG_STOP,s|e.cbConstants.FLAG_MOVE|e.cbConstants.FLAG_CAPTURE]))}});return r},Model.Game.cbRookGraph=function(t,e){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0]],e)},Model.Game.cbBishopGraph=function(t,e){return this.cbLongRangeGraph(t,[[1,-1],[1,1],[-1,1],[-1,-1]],e)},Model.Game.cbQueenGraph=function(t,e){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0],[1,-1],[1,1],[-1,1],[-1,-1]],e)},Model.Game.cbXQGeneralGraph=function(t,e){for(var r=this,i={},a=0;a<t.boardSize;a++)i[a]=[],[[-1,0,!1],[0,-1,!0],[0,1,!0],[1,0,!1]].forEach(function(n){var s=[],o=t.Graph(a,n);if(null!=o&&((!e||o in e)&&s.push(o|r.cbConstants.FLAG_MOVE|r.cbConstants.FLAG_CAPTURE),n[2]))for(var h=t.Graph(o,n);null!=h;)!e||h in e?s.push(h|r.cbConstants.FLAG_CAPTURE|r.cbConstants.FLAG_CAPTURE_KING):s.push(h|r.cbConstants.FLAG_STOP),h=t.Graph(h,n);s.length>0&&i[a].push(r.cbTypedArray(s))});return i},Model.Game.cbXQSoldierGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e]])},Model.Game.cbXQPromoSoldierGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e],[-1,0],[1,0]])},Model.Game.cbXQAdvisorGraph=function(t,e){return this.cbShortRangeGraph(t,[[1,1],[-1,1],[1,-1],[-1,-1]],e)},Model.Game.cbXQCannonGraph=function(t){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0]],null,this.cbConstants.FLAG_MOVE|this.cbConstants.FLAG_SCREEN_CAPTURE)},Model.Game.cbXQElephantGraph=function(t,e){for(var r=this,i={},a=0;a<t.boardSize;a++)i[a]=[],(!e||a in e)&&[[1,1,2,2],[1,-1,2,-2],[-1,1,-2,2],[-1,-1,-2,-2]].forEach(function(n){var s=t.Graph(a,[n[0],n[1]]);if(null!=s){var o=t.Graph(a,[n[2],n[3]]);null!=o&&(!e||o in e)&&i[a].push(r.cbTypedArray([s|r.cbConstants.FLAG_STOP,o|r.cbConstants.FLAG_MOVE|r.cbConstants.FLAG_CAPTURE]))}});return i},Model.Game.cbSilverGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e],[-1,-1],[-1,1],[1,-1],[1,1]])},Model.Game.cbFersGraph=function(t,e){return this.cbShortRangeGraph(t,[[-1,-1],[-1,1],[1,-1],[1,1]])},Model.Game.cbSchleichGraph=function(t,e){return this.cbShortRangeGraph(t,[[-1,0],[1,0],[0,-1],[0,1]])},Model.Game.cbAlfilGraph=function(t,e){return this.cbShortRangeGraph(t,[[-2,-2],[-2,2],[2,2],[2,-2]])}}(),function(){var t=Model.Game.cbBoardGeometryGrid(4,5);Model.Game.cbDefine=function(){return{geometry:t,pieceTypes:{0:{name:"pawn-w",aspect:"pawn",graph:this.cbPawnGraph(t,1),value:1,abbrev:"",fenAbbrev:"P",epCatch:!0},1:{name:"ipawn-w",aspect:"pawn",graph:this.cbInitialPawnGraph(t,1),value:1,abbrev:"",fenAbbrev:"P",initial:[{s:1,p:4},{s:1,p:5},{s:1,p:6},{s:1,p:7}],epCatch:!0,epTarget:!0},2:{name:"pawn-b",aspect:"pawn",graph:this.cbPawnGraph(t,-1),value:1,abbrev:"",fenAbbrev:"P",epCatch:!0},3:{name:"ipawn-b",aspect:"pawn",graph:this.cbInitialPawnGraph(t,-1),value:1,abbrev:"",fenAbbrev:"P",initial:[{s:-1,p:12},{s:-1,p:13},{s:-1,p:14},{s:-1,p:15}],epCatch:!0,epTarget:!0},6:{name:"rook",graph:this.cbRookGraph(t),value:5,abbrev:"R",initial:[{s:1,p:0},{s:1,p:3},{s:-1,p:16},{s:-1,p:19}]},7:{name:"queen",graph:this.cbQueenGraph(t),value:9,abbrev:"Q",initial:[{s:1,p:1},{s:-1,p:17}]},8:{name:"king",isKing:!0,graph:this.cbKingGraph(t),abbrev:"K",initial:[{s:1,p:2},{s:-1,p:18}]}},promote:function(e,r,i){return 1==r.t?[0]:3==r.t?[2]:0==r.t&&4==t.R(i.t)?[6,7]:2==r.t&&0==t.R(i.t)?[6,7]:[]},evaluate:function(e,r,i){var a=i[1].count,n=i[-1].count;a[0]||a[1]||a[4]||a[5]||a[6]||a[7]||n[2]||n[3]||n[6]||n[7]||!(n[4]+n[5]<2||n[5]<2)||(this.mFinished=!0,this.mWinner=JocGame.DRAW),n[2]||n[3]||n[4]||n[5]||n[6]||n[7]||a[0]||a[1]||a[6]||a[7]||!(a[4]+a[5]<2||a[5]<2)||(this.mFinished=!0,this.mWinner=JocGame.DRAW),this.noCaptCount>=100&&(this.mFinished=!0,this.mWinner=JocGame.DRAW);var s,o=e.cbUseTypedArrays?new Int8Array(3):[0,0,0],h=t.height,c=i[1].byType[0];if(c){s=c.length;for(var p=0;p<s;p++)switch(h-t.R(c[p].p)){case 2:o[0]++;break;case 3:o[1]++;break;case 4:o[2]++}}if(c=i[-1].byType[2]){s=c.length;for(var p=0;p<s;p++)switch(t.R(c[p].p)){case 1:o[0]--;break;case 2:o[1]--;break;case 3:o[2]--}}0!=o[0]&&(r.distPawnPromo1=o[0]),0!=o[1]&&(r.distPawnPromo2=o[1]),0!=o[2]&&(r.distPawnPromo3=o[2]);for(var l=0,u=4;u<=5;u++)for(var v=1;v>=-1;v-=2){var b=i[v].byType[u];if(b)for(var p=0;p<b.length;p++)b[p].m&&(l+=v)}0!=l&&(r.minorPiecesMoved=l)}}}}();

/***/ }),

/***/ "pFMo":
/***/ (function(module, exports) {

exports.config = {"status":true,"model":{"plazza":"true","title-en":"Kids Draughts","module":"checkers","maxLevel":20,"summary":"A version for kids of checkers on a 6x6 board.","thumbnail":"kidsdraughts-thumb3d.png","rules":"rules-kids-draughts.html","description":"description.html","credits":"credits.html","js":["checkersbase-model.js","draughts-model.js"],"gameOptions":{"preventRepeat":true,"width":3,"height":6,"initial":{"a":[[0,0],[0,1],[0,2],[1,0],[1,1],[1,2]],"b":[[5,0],[5,1],[5,2],[4,0],[4,1],[4,2]]},"variant":{"mustMoveForwardStrict":true,"lastRowCrown":true,"captureLongestLine":true,"lastRowFactor":0.001},"uctTransposition":"state"},"levels":[{"label":"Fast","ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.5,"maxDuration":1,"isDefault":true},{"label":"Beginner","ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.5,"maxDuration":0.5,"maxNodes":100,"maxLoops":200},{"label":"Easy","ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.5,"maxDuration":1,"maxNodes":2500,"maxLoops":500},{"label":"Medium","ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.5,"maxDuration":2,"maxNodes":5500,"maxLoops":500},{"label":"Hard","ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.5,"maxDuration":5,"maxNodes":2000,"maxLoops":3500},{"label":"Expert","ai":"uct","c":0.8,"playoutDepth":0,"minVisitsExpand":1,"ignoreLeaf":false,"uncertaintyFactor":5,"propagateMultiVisits":false,"maxDuration":60,"maxNodes":15000,"maxLoops":8000}]},"view":{"js":["checkers-xd-view.js","draughts6-xd-view.js"],"css":["checkersbase.css","draughts.css","kids-draughts.css"],"title-en":"Kids Draughts View","module":"checkers","preferredRatio":1,"switchable":true,"animateSelfMoves":false,"useNotation":true,"useShowMoves":true,"defaultOptions":{"sounds":true,"notation":false,"moves":true},"visuals":{"600x600":["res/visuals/kids-draughts-600x600-3d.jpg","res/visuals/kids-draughts-600x600-2d.jpg"]},"skins":[{"name":"turtles3d","title":"3D Turtles","3d":true,"camera":{"radius":14,"elevationAngle":45,"limitCamMoves":true,"distMax":40},"world":{"lightIntensity":0,"skyLightIntensity":3,"fog":true,"color":3645658,"lightPosition":{"x":-5,"y":18,"z":5},"lightShadowDarkness":0.55,"ambientLightColor":4473924},"preload":["image|/res/images/wood-chipboard-5.jpg","image|/res/xd-view/meshes/turtle.png","image|/res/xd-view/meshes/star.png","image|/res/xd-view/meshes/rock.jpg","smoothedfilegeo|0|/res/xd-view/meshes/turtle-legs-smoothed.js","smoothedfilegeo|0|/res/xd-view/meshes/turtle-head-smoothed.js","smoothedfilegeo|0|/res/xd-view/meshes/turtle-tail-smoothed.js","smoothedfilegeo|0|/res/xd-view/meshes/turtle-hotel.js","smoothedfilegeo|0|/res/xd-view/meshes/turtle-house.js","smoothedfilegeo|0|/res/xd-view/meshes/rainbowflat.js","smoothedfilegeo|0|/res/xd-view/meshes/ring-target.js","smoothedfilegeo|0|/res/xd-view/meshes/rocksmoothed.js","smoothedfilegeo|0|/res/xd-view/meshes/turtle-fences.js"]},{"name":"kids","title":"Kids"}],"xdView":true}}

/***/ }),

/***/ "pH8u":
/***/ (function(module, exports) {

exports.model=Model={Game:{},Board:{},Move:{}},function(){var t,s,o="undefined"!=typeof Int8Array;o?(t=function(t){return new Int8Array(t)},s=function(t){var s=new Int8Array(t.length);return s.set(t),s}):(t=function(t){for(var s=[],o=0;o<t;o++)s.push(0);return s},s=function(t){for(var s=[],o=t.length,i=0;i<o;i++)s.push(t[i]);return s}),Model.Game.isAlive=function(t,s){return this.POS(s,t)in this.g.confine},Model.Game.C=function(t){return t%this.mOptions.width},Model.Game.R=function(t){return Math.floor(t/this.mOptions.width)},Model.Game.RC=function(t){return{r:Math.floor(t/this.mOptions.width),c:t%this.mOptions.width}},Model.Game.POS=function(t,s){return s*this.mOptions.width+t},Model.Game.STR2POS=function(t){var s=/^(\d+):(\d+)$/.exec(t);if(s){var o=parseInt(s[1]),i=parseInt(s[2]);return this.POS(i,o)}return null},Model.Game.InitGame=function(){var s=this.NBCOLS=this.mOptions.width,o=this.NBROWS=this.mOptions.height;this.g.confine={},this.g.totalCount=o*s;for(var i=0;i<o;i++)for(var r=0;r<s;r++)this.g.confine[this.POS(r,i)]=1;if(this.mOptions.deadCells)for(var e in this.mOptions.deadCells){var a=this.STR2POS(e);null!=a&&(this.g.totalCount--,delete this.g.confine[a])}this.g.dirDeltaRC=[[1,-1],[1,0],[1,1],[0,1],[-1,1],[-1,0],[-1,-1],[0,-1]],this.g.Graph={};for(var i=0;i<o;i++)for(var r=0;r<s;r++){var a=this.POS(r,i);if(a in this.g.confine){for(var h=t(this.g.dirDeltaRC.length),n=0;n<this.g.dirDeltaRC.length;n++){var l=this.g.dirDeltaRC[n],v=i+l[0],d=r+l[1],u=v*s+d;v>=0&&d>=0&&v<o&&d<s&&u in this.g.confine?h[n]=u:h[n]=-1}this.g.Graph[a]=h}}this.g.corners={};for(var a in this.g.confine){for(var f=0,l=0;l<8;l++){var u=this.g.Graph[a][l];u<0&&(f|=1<<l)}15!=(15&f)&&30!=(30&f)&&60!=(60&f)&&120!=(120&f)&&240!=(240&f)&&225!=(225&f)&&195!=(195&f)&&135!=(135&f)||(this.g.corners[a]=1)}this.g.borders={};for(var a in this.g.confine)if(!(a in this.g.corners)){for(var f=0,l=0;l<8;l++){var u=this.g.Graph[a][l];u<0&&(f|=1<<l)}7!=(7&f)&&14!=(14&f)&&28!=(28&f)&&56!=(56&f)&&112!=(112&f)&&224!=(224&f)&&193!=(193&f)&&131!=(131&f)||(this.g.borders[a]=1)}this.zobrist=new JocGame.Zobrist({board:{type:"array",size:s*o,values:["1","-1"]}})},Model.Move.Init=function(t){this.row=t.row,this.col=t.col,this.pass=t.pass},Model.Move.CopyFrom=function(t){this.row=t.row,this.col=t.col,this.pass=t.pass},Model.Move.ToString=function(){return this.pass?"-":String.fromCharCode("a".charCodeAt(0)+this.col)+(this.row+1)},Model.Move.Equals=function(t){return!(!t.pass||!this.pass)||this.row==t.row&&this.col==t.col},Model.Board.Init=function(t){this.zSign=0},Model.Board.InitialPosition=function(s){this.board=t(s.mOptions.width*s.mOptions.height),this.counts=[0,0],this.freeClose={},this.passes=0,this.lastMove=null;var o=this;[1,-1].forEach(function(t){var i=(1-t)/2;s.mOptions.initial[t].forEach(function(r){o.counts[i]++;var e=s.STR2POS(r);o.board[e]=t,delete o.freeClose[e];for(var a=0;a<8;a++){var h=s.g.Graph[e][a];h<0||(o.board[h]||(o.freeClose[h]=1))}o.zSign=s.zobrist.update(o.zSign,"board",t,e)})}),this.FindMoves(s),this.stable={};for(var i in s.g.corners)this.stable[i]=3;this.aboutStable={},this.aboutBorder={},this.rvUpdateStable(s,s.g.corners),this.rvUpdateAboutBorder(s)},Model.Board.CopyFrom=function(t){this.mWho=t.mWho,this.zSign=t.zSign,this.board=s(t.board),this.counts=[t.counts[0],t.counts[1]],this.freeClose={};for(var o in t.freeClose)this.freeClose[o]=1;this.passes=t.passes,this.lastMove=null,t.lastMove?this.lastMove={row:t.lastMove.row,col:t.lastMove.col}:this.lastMove=null,this.movePoss={1:s(t.movePoss[1]),"-1":s(t.movePoss[-1])},this.stable=t.stable,this.aboutStable=t.aboutStable,this.aboutBorder=t.aboutBorder},Model.Board.GenerateMoves=function(t){this.mMoves=[];for(var s=0;s<this.movePoss[this.mWho].length;s++){var o=this.movePoss[this.mWho][s],i=t.RC(o);this.PushMove(t,{row:i.r,col:i.c})}0==this.mMoves.length&&this.PushMove(t,{pass:!0,row:-1,col:-1})},Model.Board.FindMoves=function(t){this.movePoss={1:[],"-1":[]};var s=t.g.Graph;for(var o in this.freeClose){for(var i=s[o],r=0,e=0;e<8;e++){var a=i[e];if(a>=0){var h=-this.board[a];if(h){var n=1==h?1:2;if(!(r&n)){for(!0,a=s[a][e];this.board[a]==-h;)a=s[a][e];if(a>=0&&this.board[a]==h&&(r|=n),3==r)break}}}}1&r&&this.movePoss[1].push(o),2&r&&this.movePoss[-1].push(o)}},Model.Board.ApplyMove=function(t,s){if(this.lastMove=null,s.pass)return void this.passes++;this.lastMove={row:s.row,col:s.col},this.passes=0;var o=(1-this.mWho)/2,i=1<<o;this.counts[o]++;var r=t.POS(s.col,s.row),e=t.g.Graph,a=e[r];this.board[r]=this.mWho,this.zSign=t.zobrist.update(this.zSign,"board",this.mWho,r),delete this.freeClose[r];var h=!1,n={};(this.stable[r]||0)&i&&(h=!0,n[r]=1);for(var l=0;l<8;l++){var v=a[l];v>=0&&0==this.board[v]&&(this.freeClose[v]=1);for(var d=[];v>=0&&this.board[v]==-this.mWho;)d.push(v),v=e[v][l];if(v>=0&&d.length>0&&this.board[v]==this.mWho)for(var u=d.length-1;u>=0;u--){var f=d[u];this.zSign=t.zobrist.update(this.zSign,"board",-this.mWho,f),this.zSign=t.zobrist.update(this.zSign,"board",this.mWho,f),this.board[f]=this.mWho,this.counts[o]++,this.counts[1-o]--,(this.stable[f]||0)&i&&(h=!0,n[f]=1)}}h&&this.rvUpdateStable(t,n),r in t.g.borders&&this.rvUpdateAboutBorder(t),this.FindMoves(t)},Model.Board.rvUpdateStable=function(t,s){var o=this.stable;this.stable={};for(var i in o)this.stable[i]=o[i];for(var r=!0,e=1==this.mWho?1:2,a=t.g.Graph;r;){r=!1;var h={};for(var i in s)for(var n=a[i],l=0;l<8;l++){var v=n[l];v>=0&&!((this.stable[v]||0)&e)&&(h[v]=1)}var s={};for(var i in h){for(var n=a[i],d=0,l=0;l<8;l++){var v=n[l];(v<0||this.board[v]==this.mWho&&(this.stable[v]||0)&e)&&(d|=1<<l)}15!=(15&d)&&30!=(30&d)&&60!=(60&d)&&120!=(120&d)&&240!=(240&d)&&225!=(225&d)&&195!=(195&d)&&135!=(135&d)||(this.stable[i]=(this.stable[i]||0)|e,r=!0,s[i]=1)}}this.aboutStable={};for(var i in this.stable)if(!this.board[i])for(var n=a[i],l=0;l<8;l++){var v=n[l];v>=0&&!(v in this.stable)&&(this.aboutStable[v]=(this.aboutStable[v]||0)|this.stable[i])}},Model.Board.rvUpdateAboutBorder=function(t){this.aboutBorder={};var s=t.g.Graph,o=t.g.borders;for(var i in o)if(!this.board[i])for(var r=s[i],e=0;e<8;e++){var a=r[e];!(a>=0)||a in this.stable||a in this.aboutStable||a in o||(this.aboutBorder[a]=1)}},Model.Board.Evaluate=function(t){this.mEvaluation=0;t.mOptions.width,t.mOptions.height;if(2==this.passes||this.counts[0]+this.counts[1]==t.g.totalCount||0==this.counts[0]||0==this.counts[1])return this.mFinished=!0,void(this.counts[0]>this.counts[1]?this.mWinner=JocGame.PLAYER_A:this.counts[0]<this.counts[1]?this.mWinner=JocGame.PLAYER_B:this.mWinner=JocGame.DRAW);var s=t.mOptions.levelOptions,o={},i={1:0,"-1":0},r={1:0,"-1":0},e={1:0,"-1":0},a={1:0,"-1":0},h=t.g.confine,n=t.g.borders;for(var l in h){var v=this.board[l];if(v){var d=1==v?1:2,u=1==v?2:1;(this.stable[l]||0)&d?i[v]++:(this.aboutStable[l]||0)&u?l in n?e[v]++:r[v]++:l in n&&a[v]++}}o.stable=i[1]-i[-1],o.aboutStable=r[1]-r[-1],o.aboutStableBorder=e[1]-e[-1],o.border=a[1]-a[-1],o.count=this.counts[0]-this.counts[1];var f=this.movePoss[1].length+this.movePoss[-1].length;o.mobility=f?(this.movePoss[1].length-this.movePoss[-1].length)/f:0;for(var b in o){var c=o[b],m=s[b+"Factor"]||0,g=c*m;this.mEvaluation+=g}},Model.Board.GetSignature=function(){return this.zSign}}();

/***/ }),

/***/ "pUca":
/***/ (function(module, exports, __webpack_require__) {

var
    DGController = __webpack_require__("3HIY"),
    Piece = __webpack_require__("WkCC").Piece
;

(function($) {

    function generateUUID(){
        var d = new Date().getTime();
        var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            var r = (d + Math.random()*16)%16 | 0;
            d = Math.floor(d/16);
            return (c=='x' ? r : (r&0x3|0x8)).toString(16);
        });
        return uuid;
    };

    function getUniqueId(element){
        var id = $(element).attr('id');
        if (typeof id === typeof undefined || id === false) {
            id = generateUUID();
            $(element).attr("id", id);
        }
        return id;
    };

    function getHTMLNotation(notationStruct){
        var ht = '';
        for (var k = 0; k < notationStruct.length; k++){
            var line = notationStruct[k];
            

            var bn = '';
            if (line.number < 10) {
                bn += '&nbsp;';
            }
            bn += line.number;
                            

            var currentWhite = false;
            var posWhite = '';
            var bw = '';
            if (line.white !== undefined){
                currentWhite = line.white.current;
                posWhite = line.white.position;
                var nsWhite = getNotationStyle(line.white.move);
                if (nsWhite.before) {
                    bw += '&nbsp;';
                }
                bw += nsWhite.notation;
                if (nsWhite.after) {
                    bw += '&nbsp;';
                }
            } else {
                bw = '&nbsp;...&nbsp;';
            }
                
            var currentBlack = false;
            var posBlack = '';
            var bm = '';
            if (line.black !== undefined){
                currentBlack = line.black.current;
                posBlack = line.black.position;
                var nsBlack = getNotationStyle(line.black.move);
                if (nsBlack.before) {
                    bm += '&nbsp;';
                }
                bm += nsBlack.notation;
                if (nsBlack.after) {
                    bm += '&nbsp;';
                }
            }


            var s = '';
            s += bn + '. ';


            s += '<span';
            if (!isNaN(posWhite)){
                s += ' data-pos="' + posWhite + '"';
            }
            if (currentWhite){
                s += ' class="active"';
            }
            s += '>';
            s += bw + '</span>';
            s += " &nbsp;";


            s += '<span';
            if (!isNaN(posBlack)){
                s += ' data-pos="' + posBlack + '"';
            }
            if (currentBlack){
                s += ' class="active"';
            }
            s += '>';
            s += bm + '</span>';


            ht += s + "<br />";
        }

        return ht;
    };

    function getNotationStyle(notation){
        var idxSep = notation.indexOf("-");
        if (idxSep == -1) {
            idxSep = notation.indexOf("x");
        } 
        var s = notation.substring(idxSep + 1);

        var before = (idxSep == 1);
        var after = (s.length == 1);

        notation = notation.replace("-", "&minus;");
        notation = notation.replace("x", "&times;");

        var map = { 'notation':notation, 'before':before, 'after':after };
        return map;
    };

    function isItemVisibleInScrollBox(item, boxWithScroll){
        var $elem = $(item);
        var $box = boxWithScroll;

        var boxTop = $box.offset().top;
        var boxBottom = boxTop + $box.height();
        
        var elemTop = $elem.offset().top;
        var elemBottom = elemTop + $elem.height();

        return ((elemBottom <= boxBottom) && (elemTop >= boxTop));
    }

    $.dreader = function(element, options) {

        // Default options
        var defaults = {
            firstLoadNum:1,
            cvSquareSize:40,
            cvSquareDarkColor:'#B4814E',
            cvSquareLightColor:'#FFFFFF',
            cvSquareLandingColor:'#84532F',
            cvSquareStartColor:'#84532F',
            cvSquareEndColor:'#84532F',
            displayNumbers:false,
            numberTextFont:"10px Arial",
            numberTextColor:"#FFFFFF",
            delayAfterHighlight:400,
            delayToJump:400,
            delayToRemoveCapturedPiece:200,
            delayAutoPlay:1000
        };

        // avoid $(this) confusion
        // plugin instance
        var plugin = this;

        plugin.options = {}

        // Jquery item reference
        var $element = $(element);
        // HTML item reference
        var element = element;
        // ID item reference
        var id = getUniqueId(element);
        // Timer (canvas animation)
        var timer = null;
        // Timer (Autoplay)
        var timerAutoPlay = null;
        // What time is it at the end of the last animation ?
        var timeEndLastAnimation = null;

        var game = null;
        var board = null;

        var dgController = null;


        plugin.init = function() {
            plugin.options = $.extend({}, defaults, options);
            
            dgController = new DGController();

            var position = $element.attr("data-position");
            var notation = $element.attr("data-notation");
            // Damweb Format
            if (typeof position !== typeof undefined && position !== false) {
                dgController.initDamWeb(position, notation);
            } 
            // PDN Format
            else {
                var pdnText = $element.html();
                dgController.initPDN(pdnText);
            }


            var firstNum = 0; // No game
            var nbGames = dgController.getGameCount();
            if (nbGames > 0){
                firstNum = plugin.options['firstLoadNum'];
                if (firstNum > nbGames){
                    firstNum = 1;
                }
            }
            
            initGame(firstNum);
            initLayout();

            $("#" + id).on("change", "select[name="+id+"-menu]",function(){
                initGame($(this).val());
                initLayout();
            });

            $("#" + id).on("click", ".notation span",function(){
                var pos = $(this).data('pos');
                applyPosition(pos);
            });

            $("#" + id).on("click", ".control-bar .start",function(){
                applyStart();
            });

            $("#" + id).on("click", ".control-bar .end",function(){
                applyEnd();
            });

            $("#" + id).on("click", ".control-bar .prev",function(){
                applyPrev();
            });

            $("#" + id).on("click", ".control-bar .next",function(){
                applyNext();
            });

            $("#" + id).on("click", ".control-bar .autoplay",function(){
                autoPlay();
            });
        };

        var initGame = function(currentNumGame){
            if (!currentNumGame){
                currentNumGame = 0;
            }

            razAnim();
            razAutoPlay();
            
            dgController.setCurrentNumGame(currentNumGame);
            game = dgController.getGame();
            game.start();
            
            board = game.board;
        };

        var initLayout = function(){
            var layout = '';
            layout += '<table>';
            layout += '<tr>';
            layout += '<td>';

            layout += '<div class="outer-box">'
            layout += '    <div class="inner-box">'
            layout += '        <canvas class="cv-board"></canvas>';
            layout += '    </div>';
            layout += '</div>';

            var menu = '';
            var nbGames = dgController.getGameCount();
            if (nbGames > 1) {
                var titles = dgController.getTitles("tagWhite - tagBlack [tagRound] - tagResult");
                menu = '<select name="' + id + '-menu">';
                
                if (!plugin.options['firstLoadNum']){
                    menu += '<option value="">&mdash;</option>';
                }

                for (var k = 0; k < titles.length; k++){
                    var t = titles[k];
                    var isSelect = (dgController.getCurrentNumGame() == t['num']);
                    var attrSelected = '';
                    if (isSelect){
                        attrSelected = ' selected="selected"';
                    }
                    menu += '<option value="' + t["num"] + '"' + attrSelected + '>' + t["num"] + ' &ndash; ' + t["title"] + '</option>';
                }
                menu += '</select>';
            }
            

            layout += '</td>';
            layout += '<td>';
            if (menu){
                layout += '<div class="pdn-games">' + menu + '</div>';
            }
            if (game.hasMove()){
                layout += '<div class="notation"></div>';
            }
            layout += '</td>';
            layout += '</tr>';
            layout += '<tr>';
            layout += '<td>';
            if (game.hasMove()){
                layout += '<div class="control-bar">';
                layout += '    <button class="start">&laquo;</button>';
                layout += '    <button class="prev">&lsaquo;</button>';
                layout += '    <button class="next">&rsaquo;</button>';
                layout += '    <button class="end">&raquo;</button>';
                layout += '    <button class="autoplay">&diams; auto</button>';
                layout += '</div>';
            }
            layout += '</td>';
            layout += '<td></td>';
            layout += '</tr>';
            layout += '</table>';

            $(element).html(layout);

            refreshNotation();

            var $c = $("#" + id + " .cv-board")[0];
            var ctx = $c.getContext("2d");
            var sqWidth = plugin.options['cvSquareSize'];
            $c.width = 10*sqWidth;
            $c.height = 10*sqWidth;

            drawCanvasContent(ctx);
        };

        var razAnim = function(){
            if (timer !== null){
                clearInterval(timer);
                timer = null;
            }
        };

        var razAutoPlay = function(){
            if (timerAutoPlay !== null){
                clearInterval(timerAutoPlay);
                timerAutoPlay = null;
            }
        };

        var refreshAll = function(){
            refreshNotation();
            refreshCanvas();
        };

        var refreshNotation = function(){
            var $notationArea = $("#" + id + " .notation");
            $notationArea.html(getHTMLNotation(game.getNotation()));

            // Auto scrolling
            // 'each' used to target dynamically generated content
            $("#" + id + " .notation .active").each(function() {
                if (!isItemVisibleInScrollBox(this, $notationArea)){
                    var to = $(this).offset().top - $notationArea.offset().top + $notationArea.scrollTop();
                    to = to - ($notationArea.height() / 2);
                
                    $notationArea.scrollTop(to);
                }
            });
        };

        var initNotationScroll = function(){
            var $notationArea = $("#" + id + " .notation");
            $notationArea.scrollTop(0);
        }

        var refreshCanvas = function(){
            var $c = $("#" + id + " .cv-board")[0];
            var ctx = $c.getContext("2d");
            drawCanvasContent(ctx);
        };

        var applyPosition = function(pos){
            razAnim();
            razAutoPlay();
            game.setCursor(pos);
            refreshAll();
        };

        var applyStart = function(){
            razAnim();
            razAutoPlay();
            game.start();
            refreshAll();
            initNotationScroll();
        };
        
        var applyEnd = function(){
            razAnim();
            razAutoPlay();
            game.end();
            refreshAll();
        };

        var applyNext = function(){
            razAnim();
            razAutoPlay();
            refreshAll();
            applyNextAuto();
        };

        var applyNextAuto = function(){
            razAnim();
            drawCanvasNextMove();
            game.next();
            refreshNotation();
        };

        var applyPrev = function(){
            razAnim();
            razAutoPlay();
            game.prev();
            refreshAll();
        };

        var autoPlay = function(){
            var callback = function() { 
                // waiting the end of the current animation if it exists.
                if (timer !== null){
                    return;
                }

                // Wait a little if necessary.
                if (timeEndLastAnimation !== null){
                    var interSinceLastAnim = (new Date()).getTime() - timeEndLastAnimation;
                    var restToWait = plugin.options['delayAutoPlay'] - interSinceLastAnim;
                    timeEndLastAnimation = null;
                    
                    if (restToWait > 0) {
                        setTimeout(function(){ 
                            callBackAction();
                        }, restToWait);
                    } else {
                        callBackAction();
                    }
                } else {
                    callBackAction();
                }
            };

            var callBackAction = function(){
                if (game.hasNext()){
                    refreshCanvas();
                    applyNextAuto();
                } else {
                    razAutoPlay();
                }
            }

            // Stop/Start
            if (timerAutoPlay !== null){
                razAutoPlay();
            } else {
                callback(); // Do not wait first time
                timerAutoPlay = setInterval(callback, plugin.options['delayAutoPlay']);
            }
        };

        
        var drawPiece = function(ctx, piece, x, y, r){
            var sqWidth = plugin.options['cvSquareSize'];
            var shift = 1 + ((~~(sqWidth / 10)) + 1) / 2;

            switch (piece) {
            case Piece.PAWN_WHITE:
                ctx.beginPath();
                ctx.arc(x, y, r ,0, Math.PI * 2, true);
                ctx.strokeStyle = "black";
                ctx.fillStyle = "white";
                ctx.fill();
                ctx.stroke();
                break;
            case Piece.PAWN_BLACK:
                ctx.beginPath();
                ctx.arc(x, y, r ,0, Math.PI * 2, true);
                ctx.strokeStyle = "#eee";
                ctx.fillStyle = "black";
                ctx.fill();
                ctx.stroke();
                break;
            case Piece.DAME_WHITE:
                ctx.beginPath();
                ctx.arc(x, y, r ,0, Math.PI * 2, true);
                ctx.strokeStyle = "black";
                ctx.fillStyle = "white";
                ctx.fill();
                ctx.stroke();

                ctx.beginPath();
                ctx.arc(x, y, shift ,0, Math.PI * 2, true);
                ctx.strokeStyle = "black";
                ctx.fillStyle = "white";
                ctx.fill();
                ctx.stroke();
                break;
            case Piece.DAME_BLACK:
                ctx.beginPath();
                ctx.arc(x, y, r ,0, Math.PI * 2, true);
                ctx.strokeStyle = "#eee";
                ctx.fillStyle = "black";
                ctx.fill();
                ctx.stroke();

                ctx.beginPath();
                ctx.arc(x, y, shift ,0, Math.PI * 2, true);
                ctx.strokeStyle = "white";
                ctx.fillStyle = "black";
                ctx.fill();
                ctx.stroke();
                break;
            default:
            }
        };

        var drawSquare = function(ctx, num, piece, sqColor){
            var nRow = ~~((num - 1) / 5) + 1; // [1..10]
            var nCol = ((num - 1) % 5) + 1; // [1..5]

            var sqWidth = plugin.options['cvSquareSize'];

            if (nRow == 1 || nRow == 3 || nRow == 5 || nRow == 7 || nRow == 9) {
                var x = 2 * sqWidth * (nCol - 1) + sqWidth;
                var y = sqWidth * (nRow - 1);

                drawSquareInc(ctx, num, piece, x, y, sqColor);
            }

            if (nRow == 2 || nRow == 4 || nRow == 6 || nRow == 8 || nRow == 10) {
                var x = 2 * sqWidth * (nCol - 1);
                var y = sqWidth * (nRow - 1);

                drawSquareInc(ctx, num, piece, x, y, sqColor);
            }
        };

        var drawSquareInc = function(ctx, num, piece, x, y, sqColor){
            var sqWidth = plugin.options['cvSquareSize'];
               
            if (!sqColor){
                sqColor = plugin.options['cvSquareDarkColor'];
            }
            ctx.fillStyle = sqColor;
            ctx.fillRect(x, y, sqWidth, sqWidth);

            if (plugin.options['displayNumbers']){
                ctx.font = plugin.options['numberTextFont'];
                ctx.fillStyle = plugin.options['numberTextColor'];
                ctx.fillText("" + num, x + 2, y + sqWidth - 2);
            }

            var x = x + (sqWidth / 2);
            var y = y + (sqWidth / 2);
            var r = sqWidth / 2 - (sqWidth / 10);

            drawPiece(ctx, piece, x, y, r);
        };

        var drawCanvasContent = function(ctx){
            var sqWidth = plugin.options['cvSquareSize'];
            ctx.fillStyle = plugin.options['cvSquareLightColor'];
            ctx.fillRect(0, 0, 10*sqWidth, 10*sqWidth);

            for (var num = 1; num <= 50; num++){
                var p = board.getSquare(num).piece;
                drawSquare(ctx, num, p);
            }
        };

        var drawCanvasNextMove = function(){
            var move = game.getNextMove();
            if (move === null) {
                return;
            }

            var $c = $("#" + id + " .cv-board")[0];
            var ctx = $c.getContext("2d");

            var piecePlayed = board.getPiece(move.startingSquareNum);
            drawCanvasNextMoveStep2(ctx, move, piecePlayed);            
        };

        var drawCanvasNextMoveStep2 = function(ctx, move, piecePlayed){
            // color start square.
            drawSquare(ctx, move.startingSquareNum, piecePlayed, plugin.options['cvSquareStartColor']);

            // color end square.
            if (move.startingSquareNum != move.endingSquareNum){
                drawSquare(ctx, move.endingSquareNum, Piece.EMPTY, plugin.options['cvSquareEndColor']);
            }

            // color intermediate squares.
            if (move.isCaptured){
                var landingSquaresNum = move.getLandingSquaresNum();
                for (var i = 0; i < landingSquaresNum.length; i++) {
                    var num = landingSquaresNum[i];
                    if (num != move.startingSquareNum) {
                        drawSquare(ctx, num, Piece.EMPTY, plugin.options['cvSquareLandingColor']);
                    }
                }
            }

            // Wait a little...
            (function() {
                var callback = function() { 
                    razAnim();
                    drawCanvasNextMoveStep3(ctx, move, piecePlayed);
                };
                timer = setInterval(callback, plugin.options['delayAfterHighlight']);
            })();
        };

        var drawCanvasNextMoveStep3 = function(ctx, move, piecePlayed){
            // Remove piece from starting square
            drawSquare(ctx, move.startingSquareNum, Piece.EMPTY, plugin.options['cvSquareStartColor']);
            
            
            if (!move.isCaptured){
                drawCanvasNextMoveStep4(ctx, move, piecePlayed);
            } 
            // Move piece on intermediate squares
            else {

                var landingSquaresNum = move.getLandingSquaresNum();
                if (landingSquaresNum.length > 0){
                    
                    (function() {
                        var i = 0;
                        var callback = function() {
                            if (i < landingSquaresNum.length){
                                var num = landingSquaresNum[i];
                                var numPrev = null;
                                if (i > 0){
                                    numPrev = landingSquaresNum[i - 1];
                                }
                                if (numPrev !== null){
                                    drawSquare(ctx, numPrev, Piece.EMPTY, plugin.options['cvSquareLandingColor']);
                                }
                                drawSquare(ctx, num, piecePlayed, plugin.options['cvSquareLandingColor']);
                                
                                i++;
                            } else {
                                razAnim();
                                drawCanvasNextMoveStep4(ctx, move, piecePlayed);
                            }
                        };

                        callback(); // do not wait first time
                        timer = setInterval(callback, plugin.options['delayToJump']);
                    })();

                } else {
                    drawCanvasNextMoveStep4(ctx, move, piecePlayed);
                }
            }
        };

        var drawCanvasNextMoveStep4 = function(ctx, move, piecePlayed){
            // Set piece on ending square
            if (!move.isCrowned) {
                drawSquare(ctx, move.endingSquareNum, piecePlayed, plugin.options['cvSquareEndColor']);
            }
            // Piece is crowned
            else {
                if (piecePlayed == Piece.PAWN_WHITE) {
                    drawSquare(ctx, move.endingSquareNum, Piece.DAME_WHITE, plugin.options['cvSquareEndColor']);
                } else if (piecePlayed == Piece.PAWN_BLACK) {
                    drawSquare(ctx, move.endingSquareNum, Piece.DAME_BLACK, plugin.options['cvSquareEndColor']);
                }
            }

            // Remove pieces for captured squares
            if (move.isCaptured){
                var capturedNums = move.getCapturedSquaresNum();
                if (capturedNums.length > 0){
                    
                    (function() {
                        var i = 0;
                        var callback = function() { 
                            if (i < capturedNums.length){
                                var num = capturedNums[i];
                                drawSquare(ctx, num, Piece.EMPTY);
                                
                                i++;
                            } else {
                                razAnim();
                                timeEndLastAnimation = (new Date()).getTime();
                            }
                        };
                        timer = setInterval(callback, plugin.options['delayToRemoveCapturedPiece']);
                    })();
                }
            } else {
                timeEndLastAnimation = (new Date()).getTime();
            }
        };

        plugin.init();
    };


    



    $.fn.dreader = function(options) {
        return this.each(function() {
            if (undefined == $(this).data('dreader')) {
                var plugin = new $.dreader(this, options);
                $(this).data('dreader', plugin);
            }
        });
    };

})(jQuery);



/***/ }),

/***/ "pZGP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("3j3K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base__ = __webpack_require__("TwGT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__layout__ = __webpack_require__("Sxsi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__media_query_media_monitor__ = __webpack_require__("bWt6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_layout_validator__ = __webpack_require__("eKS0");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LayoutGapDirective; });
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */





/**
 * 'layout-padding' styling directive
 *  Defines padding of child elements in a layout container
 */
var LayoutGapDirective = (function (_super) {
    __extends(LayoutGapDirective, _super);
    /* tslint:enable */
    function LayoutGapDirective(monitor, elRef, renderer, container) {
        var _this = _super.call(this, monitor, elRef, renderer) || this;
        _this._layout = 'row'; // default flex-direction
        if (container) {
            _this._layoutWatcher = container.layout$.subscribe(_this._onLayoutChange.bind(_this));
        }
        return _this;
    }
    Object.defineProperty(LayoutGapDirective.prototype, "gap", {
        /* tslint:disable */
        set: function (val) { this._cacheInput('gap', val); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LayoutGapDirective.prototype, "gapXs", {
        set: function (val) { this._cacheInput('gapXs', val); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LayoutGapDirective.prototype, "gapSm", {
        set: function (val) { this._cacheInput('gapSm', val); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(LayoutGapDirective.prototype, "gapMd", {
        set: function (val) { this._cacheInput('gapMd', val); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(LayoutGapDirective.prototype, "gapLg", {
        set: function (val) { this._cacheInput('gapLg', val); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(LayoutGapDirective.prototype, "gapXl", {
        set: function (val) { this._cacheInput('gapXl', val); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(LayoutGapDirective.prototype, "gapGtXs", {
        set: function (val) { this._cacheInput('gapGtXs', val); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(LayoutGapDirective.prototype, "gapGtSm", {
        set: function (val) { this._cacheInput('gapGtSm', val); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(LayoutGapDirective.prototype, "gapGtMd", {
        set: function (val) { this._cacheInput('gapGtMd', val); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(LayoutGapDirective.prototype, "gapGtLg", {
        set: function (val) { this._cacheInput('gapGtLg', val); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(LayoutGapDirective.prototype, "gapLtSm", {
        set: function (val) { this._cacheInput('gapLtSm', val); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(LayoutGapDirective.prototype, "gapLtMd", {
        set: function (val) { this._cacheInput('gapLtMd', val); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(LayoutGapDirective.prototype, "gapLtLg", {
        set: function (val) { this._cacheInput('gapLtLg', val); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(LayoutGapDirective.prototype, "gapLtXl", {
        set: function (val) { this._cacheInput('gapLtXl', val); },
        enumerable: true,
        configurable: true
    });
    ;
    // *********************************************
    // Lifecycle Methods
    // *********************************************
    LayoutGapDirective.prototype.ngOnChanges = function (changes) {
        if (changes['gap'] != null || this._mqActivation) {
            this._updateWithValue();
        }
    };
    /**
     * After the initial onChanges, build an mqActivation object that bridges
     * mql change events to onMediaQueryChange handlers
     */
    LayoutGapDirective.prototype.ngAfterContentInit = function () {
        var _this = this;
        this._watchContentChanges();
        this._listenForMediaQueryChanges('gap', '0', function (changes) {
            _this._updateWithValue(changes.value);
        });
        this._updateWithValue();
    };
    LayoutGapDirective.prototype.ngOnDestroy = function () {
        _super.prototype.ngOnDestroy.call(this);
        if (this._layoutWatcher) {
            this._layoutWatcher.unsubscribe();
        }
        if (this._observer) {
            this._observer.disconnect();
        }
    };
    // *********************************************
    // Protected methods
    // *********************************************
    /**
     * Watch for child nodes to be added... and apply the layout gap styles to each.
     * NOTE: this does NOT! differentiate between viewChildren and contentChildren
     */
    LayoutGapDirective.prototype._watchContentChanges = function () {
        var _this = this;
        var onMutationCallback = function (mutations) {
            var validatedChanges = function (it) {
                return (it.addedNodes && it.addedNodes.length) ||
                    (it.removedNodes && it.removedNodes.length);
            };
            // update gap styles only for child 'added' or 'removed' events
            if (mutations.filter(validatedChanges).length) {
                _this._updateWithValue();
            }
        };
        this._observer = new MutationObserver(onMutationCallback);
        this._observer.observe(this._elementRef.nativeElement, { childList: true });
    };
    /**
     * Cache the parent container 'flex-direction' and update the 'margin' styles
     */
    LayoutGapDirective.prototype._onLayoutChange = function (direction) {
        var _this = this;
        this._layout = (direction || '').toLowerCase();
        if (!__WEBPACK_IMPORTED_MODULE_4__utils_layout_validator__["b" /* LAYOUT_VALUES */].find(function (x) { return x === _this._layout; })) {
            this._layout = 'row';
        }
        this._updateWithValue();
    };
    /**
     *
     */
    LayoutGapDirective.prototype._updateWithValue = function (value) {
        var _this = this;
        value = value || this._queryInput("gap") || '0';
        if (this._mqActivation) {
            value = this._mqActivation.activatedInput;
        }
        // Gather all non-hidden Element nodes
        var items = this.childrenNodes
            .filter(function (el) { return el.nodeType === 1 && _this._getDisplayStyle(el) != "none"; });
        var numItems = items.length;
        if (numItems > 1) {
            var lastItem = items[numItems - 1];
            // For each `element` children EXCEPT the last,
            // set the margin right/bottom styles...
            items = items.filter(function (el, j) { return j < numItems - 1; });
            this._applyStyleToElements(this._buildCSS(value), items);
            // Clear all gaps for all visible elements
            this._applyStyleToElements(this._buildCSS(), [lastItem]);
        }
    };
    /**
     * Prepare margin CSS, remove any previous explicitly
     * assigned margin assignments
     */
    LayoutGapDirective.prototype._buildCSS = function (value) {
        if (value === void 0) { value = null; }
        var key, margins = {
            'margin-left': null,
            'margin-right': null,
            'margin-top': null,
            'margin-bottom': null
        };
        switch (this._layout) {
            case 'column':
            case 'column-reverse':
                key = 'margin-bottom';
                break;
            case "row":
            case 'row-reverse':
            default:
                key = 'margin-right';
                break;
        }
        margins[key] = value;
        return margins;
    };
    return LayoutGapDirective;
}(__WEBPACK_IMPORTED_MODULE_1__base__["a" /* BaseFxDirective */]));

LayoutGapDirective.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{ selector: "\n  [fxLayoutGap],\n  [fxLayoutGap.xs], [fxLayoutGap.sm], [fxLayoutGap.md], [fxLayoutGap.lg], [fxLayoutGap.xl],\n  [fxLayoutGap.lt-sm], [fxLayoutGap.lt-md], [fxLayoutGap.lt-lg], [fxLayoutGap.lt-xl],\n  [fxLayoutGap.gt-xs], [fxLayoutGap.gt-sm], [fxLayoutGap.gt-md], [fxLayoutGap.gt-lg]\n"
            },] },
];
/** @nocollapse */
LayoutGapDirective.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_3__media_query_media_monitor__["a" /* MediaMonitor */], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer2"], },
    { type: __WEBPACK_IMPORTED_MODULE_2__layout__["a" /* LayoutDirective */], decorators: [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"] }, { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Self"] },] },
]; };
LayoutGapDirective.propDecorators = {
    'gap': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxLayoutGap',] },],
    'gapXs': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxLayoutGap.xs',] },],
    'gapSm': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxLayoutGap.sm',] },],
    'gapMd': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxLayoutGap.md',] },],
    'gapLg': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxLayoutGap.lg',] },],
    'gapXl': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxLayoutGap.xl',] },],
    'gapGtXs': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxLayoutGap.gt-xs',] },],
    'gapGtSm': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxLayoutGap.gt-sm',] },],
    'gapGtMd': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxLayoutGap.gt-md',] },],
    'gapGtLg': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxLayoutGap.gt-lg',] },],
    'gapLtSm': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxLayoutGap.lt-sm',] },],
    'gapLtMd': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxLayoutGap.lt-md',] },],
    'gapLtLg': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxLayoutGap.lt-lg',] },],
    'gapLtXl': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['fxLayoutGap.lt-xl',] },],
};
//# sourceMappingURL=layout-gap.js.map

/***/ }),

/***/ "pcn9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("3j3K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_add_operator_map__ = __webpack_require__("+pb+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_add_operator_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs_add_operator_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_add_operator_filter__ = __webpack_require__("wUn1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs_add_operator_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_rxjs_add_operator_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__breakpoints_break_point_registry__ = __webpack_require__("eZjk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__match_media__ = __webpack_require__("LuwH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__observable_media__ = __webpack_require__("R7bj");
/* unused harmony export OBSERVABLE_MEDIA_PROVIDER_FACTORY */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OBSERVABLE_MEDIA_PROVIDER; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */






/**
 * Ensure a single global ObservableMedia service provider
 */
function OBSERVABLE_MEDIA_PROVIDER_FACTORY(parentService, matchMedia, breakpoints) {
    return parentService || new __WEBPACK_IMPORTED_MODULE_5__observable_media__["a" /* MediaService */](matchMedia, breakpoints);
}
/**
 *  Provider to return global service for observable service for all MediaQuery activations
 */
var OBSERVABLE_MEDIA_PROVIDER = {
    provide: __WEBPACK_IMPORTED_MODULE_5__observable_media__["b" /* ObservableMedia */],
    deps: [
        [new __WEBPACK_IMPORTED_MODULE_0__angular_core__["Optional"](), new __WEBPACK_IMPORTED_MODULE_0__angular_core__["SkipSelf"](), __WEBPACK_IMPORTED_MODULE_5__observable_media__["b" /* ObservableMedia */]],
        __WEBPACK_IMPORTED_MODULE_4__match_media__["a" /* MatchMedia */],
        __WEBPACK_IMPORTED_MODULE_3__breakpoints_break_point_registry__["a" /* BreakPointRegistry */]
    ],
    useFactory: OBSERVABLE_MEDIA_PROVIDER_FACTORY
};
//# sourceMappingURL=observable-media-provider.js.map

/***/ }),

/***/ "pfTn":
/***/ (function(module, exports) {

exports.model=Model={Game:{},Board:{},Move:{}},Model.Game.HexInitRCPosAndLayout=function(){for(var t=this.mOptions.maxLines,i=[],e=[],s=0,o=0;o<this.mOptions.maxLines;o++){i[o]=[],e[o]=[];for(var r=0;r<this.mOptions.maxCols;r++)i[o][r]=this.mOptions.boardLayout[t-1-o][r],"."!=i[o][r]?(e[o][r]=s,s++):e[o][r]=-1}this.g.rcPositions=e,this.g.Layout=i,this.g.nbPos=s},Model.Game.HexRcPos=function(t,i){return this.g.rcPositions[t][i]},Model.Game.HexIsCell=function(t,i){return!(t<0||t>=this.mOptions.maxLines||i<0||i>=this.mOptions.maxCols)&&"."!=this.g.Layout[t][i]},Model.Game.HexInitGame=function(){this.HexInitRCPosAndLayout(),this.g.orientation=this.mOptions.orientation,this.g.maxNbCellsPerMove=this.mOptions.maxNbCellsPerMove,this.g.margin=this.mOptions.margin;for(var t=[],i=[],e=0;e<this.mOptions.maxLines;e++)for(var s=0;s<this.mOptions.maxCols;s++)if(this.HexIsCell(e,s)){var o=this.HexRcPos(e,s);if(i[o]=[e,s],t[o]=[],"onASide"==this.g.orientation)for(var r=0;r<6;r++)switch(r){case 0:this.HexIsCell(e+1,s+1)?t[o].push(this.HexRcPos(e+1,s+1)):t[o].push(null);break;case 1:this.HexIsCell(e+2,s)?t[o].push(this.HexRcPos(e+2,s)):t[o].push(null);break;case 2:this.HexIsCell(e+1,s-1)?t[o].push(this.HexRcPos(e+1,s-1)):t[o].push(null);break;case 3:this.HexIsCell(e-1,s-1)?t[o].push(this.HexRcPos(e-1,s-1)):t[o].push(null);break;case 4:this.HexIsCell(e-2,s)?t[o].push(this.HexRcPos(e-2,s)):t[o].push(null);break;case 5:this.HexIsCell(e-1,s+1)?t[o].push(this.HexRcPos(e-1,s+1)):t[o].push(null)}else for(var r=0;r<6;r++)switch(r){case 0:this.HexIsCell(e,s+2)?t[o].push(this.HexRcPos(e,s+2)):t[o].push(null);break;case 1:this.HexIsCell(e+1,s+1)?t[o].push(this.HexRcPos(e+1,s+1)):t[o].push(null);break;case 2:this.HexIsCell(e+1,s-1)?t[o].push(this.HexRcPos(e+1,s-1)):t[o].push(null);break;case 3:this.HexIsCell(e,s-2)?t[o].push(this.HexRcPos(e,s-2)):t[o].push(null);break;case 4:this.HexIsCell(e-1,s-1)?t[o].push(this.HexRcPos(e-1,s-1)):t[o].push(null);break;case 5:this.HexIsCell(e-1,s+1)?t[o].push(this.HexRcPos(e-1,s+1)):t[o].push(null)}}this.g.Graph=t,this.g.Coord=i},Model.Game.DestroyGame=function(){},Model.Board.xtraInitBoard=function(t){},Model.Board.HexInit=function(t){var i=t.mOptions.maxCols,e=t.mOptions.maxLines;this.board=[];var s=-1;void 0!=t.mOptions.boardInitValue&&(s=t.mOptions.boardInitValue);for(var o=0;o<e;o++)for(var r=0;r<i;r++)this.board[t.HexRcPos(o,r)]=s;var a=t.mOptions.initial;this.pieces=[];var h=0,n=[{},{}];if(a)for(var c=0;c<e;c++)for(var o=e-1-c,r=0;r<i;r++){var p=t.HexRcPos(o,r);switch(a.a[c][r]){case".":case"#":break;default:var l=a.a[c][r],m=n[0][l];void 0===m&&(n[0][l]=0),this.pieces.push({s:JocGame.PLAYER_A,pos:p,type:l,alive:!0,index:n[0][l]++}),this.board[p]=h++}switch(a.b[c][r]){case".":case"#":break;default:var l=a.b[c][r],m=n[1][l];void 0===m&&(n[1][l]=0),this.pieces.push({s:JocGame.PLAYER_B,pos:p,type:l,alive:!0,index:n[1][l]++}),this.board[p]=h++}}},Model.Game.InitGame=function(){this.HexInitGame(),this.g.GetStrengthByType=function(t){switch(t){case"C":return 5;case"c":return 3;case"p":return 2;default:return 0}},this.g.distAmiralToLastRowSubFactor={"-1":10,0:0,1:-10},this.g.distAmiralToLastRowFactor=3,this.g.pieceWeight={c:2,p:1,C:0,r:0},this.g.weightFactor=3,this.g.GainOtherAmiralDist=[0,15,4,2,1,.7,.6,.5,.4,.3,.2,.1,0],this.g.GainSelfAmiralDist=[0,5,4,2,1,.7,.6,.5,.4,.3,.2,.1,0],this.g.gainOtherAmiralDistSubFactor=1,this.g.gainSelfAmiralDistSubFactor=1,this.g.yohohoFactor=2,this.g.MoveCount=22;var t=this;this.g.Dist=function(i,e){if(i==e)return 0;if(e<i){var s=i;i=e,e=s}return t.g.DistArray[i][e-i-1]};var i=this.g.Graph.length;this.g.DistArray=[];for(var e=0;e<i-1;e++){for(var s=[],o=0;o<i-e;o++)s.push(-1);this.g.DistArray.push(s)}this.g.SetDist=function(i,e,s){if(i!=e){if(e<i){var o=i;i=e,e=o}t.g.DistArray[i][e-i-1]=s}};for(var r=0;r<i;r++)this.YohohoEachDirection(r,function(i){if(r<i){t.g.Dist(r,i)<0&&t.g.SetDist(r,i,1)}return!0});for(var r=0;r<i;r++)this.YohohoEachDirection(r,function(e){if(r<e)for(var s=0;s<i;s++){var o=t.g.Dist(s,r);if(o>=0){var a=t.g.Dist(s,e);(a==-1||o+1<a)&&t.g.SetDist(s,e,o+1)}}return!0})},Model.Move.Init=function(t){void 0!==t&&this.CopyFrom(t)},Model.Move.CopyFrom=function(t){if(this.t=t.t,"m"==t.t)this.m=[{f:t.m[0].f,t:t.m[0].t},{f:t.m[1].f,t:t.m[1].t}];else if("a"==t.t){this.af=[];for(var i=0;i<t.af.length;i++)this.af.push(t.af[i]);this.at=t.at}},Model.Move.ToString=function(){var t;return"m"==this.t?(t="M "+this.m[0].f+">"+this.m[0].t,void 0!==this.m[1].f&&(t+=" "+this.m[1].f+">"+this.m[1].t)):t="A "+this.af.join(",")+">"+this.at,t},Model.Board.InitialPosition=function(t){this.HexInit(t),this.first=!0,this.yohoho=!1,this.amirals={};for(var i=0;i<this.pieces.length;i++){var e=this.pieces[i];"C"==e.type&&(this.amirals[e.s]=i),e.s==JocGame.PLAYER_A?e.angle=0:e.angle=180}this.piecesWeight={"-1":8,1:8}},Model.Board.GenerateMoves=function(t){function i(t,i){if(t.index==i.index)return!1;for(var e=0;e<t.reqEmpty.length;e++){var s=t.reqEmpty[e];if(o.board[s]!=-1)return!1}for(var e=0;e<i.reqEmpty.length;e++){var s=i.reqEmpty[e];if(s==t.t)return!1;if(o.board[s]!=-1&&s!=t.f)return!1}return t.t!=i.t}var e=!1,s=t.g.MoveCount;void 0!==t.mLevelInfo&&(void 0!==t.mLevelInfo.rowRaceLevel&&(e=t.mCurrentLevel>=0&&t.mCurrentLevel<=t.mLevelInfo.rowRaceLevel),void 0!==t.mLevelInfo.moveCount&&(s=t.mLevelInfo.moveCount));var o=this,r=this.pieces[this.amirals[this.mWho]].pos,a=this.pieces[this.amirals[-this.mWho]].pos,h=t.g.Coord[a][0],n=h-this.mWho,c={},p=[],l=[],m=this.pieces;e&&(m=[this.pieces[this.amirals[this.mWho]]]);for(var f=0;f<m.length;f++){var u=m[f];if(u.s==this.mWho&&u.alive)for(var v=this.YohohoReachablePositionsThrough(t,u.pos,u.type),g=0;g<v.length;g++){var d={f:u.pos,t:v[g].pos,index:f,reqEmpty:v[g].reqEmpty},b=0;if("C"==u.type){var y=t.g.Coord[u.pos],x=y[0],A=this.mWho==JocGame.PLAYER_A?8-x:x;y=t.g.Coord[d.t];var C=y[0],G=this.mWho==JocGame.PLAYER_A?8-C:C;0==G&&this.board[d.t]==-1&&l.push(d),b+=12,b+=t.g.distAmiralToLastRowSubFactor[G-A]}else"c"==u.type&&(b+=1);var M=t.g.Dist(d.t,r),R=t.g.Dist(d.t,a),E=t.g.GainSelfAmiralDist[M],D=t.g.GainOtherAmiralDist[R];2!=R||"c"!=u.type&&"p"!=u.type||t.YohohoEachDirection(d.t,function(i){return o.board[i]!=-1||1!=t.g.Dist(i,a)||1!=t.g.Dist(i,r)||t.g.Coord[i][0]!=n||(b+=3,!1)});var P=Math.max(E*t.g.gainSelfAmiralDistSubFactor,D*t.g.gainOtherAmiralDistSubFactor);b+=P,d.eval=b,void 0===c[d.index]&&(c[d.index]=[]),c[d.index].push(d)}}if(l.length>0)for(var f=0;f<l.length;f++){var d=l[f];this.mMoves.push({t:"m",m:[{f:d.f,t:d.t},{}]})}else{var L=[];for(var Y in c)if(c.hasOwnProperty(Y)){var H=c[Y];H.sort(function(t,i){return i.eval-t.eval}),L.push(H)}L.sort(function(t,i){return i[0].eval-t[0].eval});for(var W=1,I=0;L.length>0;)p.push(L[I].shift()),0==L[I].length?(L.splice(I,1),W--):I++,I==W&&(W<L.length&&W++,I=0);if(e){for(var B=[],k=-1,f=0;f<p.length;f++){var d=p[f],F=(t.g.Coord[d.t][0]-t.g.Coord[d.t][0])*this.mWho;F==k?B.push(d):F>k&&(k=F,B=[d])}this.mMoves=this.YohohoCaptures(t,this.mWho);for(var f=0;f<B.length;f++){var d=B[f];this.board[d.t]==-1&&this.mMoves.push({t:"m",m:[{f:d.f,t:d.t},{}]})}return void(0==this.mMoves.length&&(this.mFinished=!0,this.mWinner=JocGame.DRAW))}var S=[],O=this.YohohoAmiralCapture(t,this.mWho);if(O.risk){for(var f=0;f<O.capture.length;f++){var w=O.capture[f],J=JSON.parse(JSON.stringify(w.af));this.mMoves.push({t:"a",af:J,at:w.at})}for(var g=0;g<p.length&&S.length<s;g++)for(var f=0;f<O.escape.length&&S.length<s;f++){var T=this.amirals[this.mWho],_=this.pieces[T],q={f:_.pos,t:O.escape[f].t,index:T,reqEmpty:[O.escape[f].t]};if(p[g].index!=T){var N=i(q,p[g]);N?S.push({t:"m",m:[{f:q.f,t:q.t},{f:p[g].f,t:p[g].t}]}):i(p[g],q)&&S.push({t:"m",m:[{f:p[g].f,t:p[g].t},{f:q.f,t:q.t}]})}}return this.mMoves=this.mMoves.concat(S),void(0==this.mMoves.length&&(this.mFinished=!0,this.mWinner=-this.mWho))}if(this.first)for(var g=0;g<f&&S.length<s;g++)this.board[p[g].t]==-1&&S.push({t:"m",m:[{f:p[g].f,t:p[g].t},{}]});else for(var f=1;f<p.length&&S.length<s;f++)for(var g=0;g<f&&S.length<s;g++)p[f].index!=p[g].index&&(i(p[f],p[g])?S.push({t:"m",m:[{f:p[f].f,t:p[f].t},{f:p[g].f,t:p[g].t}]}):i(p[g],p[f])&&S.push({t:"m",m:[{f:p[g].f,t:p[g].t},{f:p[f].f,t:p[f].t}]}));this.mMoves=this.YohohoCaptures(t,this.mWho),this.mMoves=this.mMoves.concat(S),0==this.mMoves.length&&(this.mFinished=!0,this.mWinner=-this.mWho)}},Model.Board.IsValidMove=function(t,i){return!0},Model.Board.Evaluate=function(t,i,e){this.mEvaluation=0;var s=this.YohohoAmiralCapture(t,JocGame.PLAYER_A);s.risk&&s.end&&(this.mFinished=!0,this.mWinner=JocGame.PLAYER_B);var o=this.YohohoAmiralCapture(t,JocGame.PLAYER_B);o.risk&&o.end&&(this.mFinished=!0,this.mWinner=JocGame.PLAYER_A);var r=this.pieces[this.amirals[JocGame.PLAYER_A]].pos,a=this.pieces[this.amirals[JocGame.PLAYER_B]].pos,h=t.g.Coord[r][0];8==h&&(this.mFinished=!0,this.mWinner=JocGame.PLAYER_A);var n=t.g.Coord[a][0];if(0==n&&(this.mFinished=!0,this.mWinner=JocGame.PLAYER_B),!this.mFinished){var c=t.g.distAmiralToLastRowFactor;switch(t.g.Dist(r,a)){case 1:c=t.g.distAmiralToLastRowFactor;break;case 2:c=1.2*t.g.distAmiralToLastRowFactor;break;default:c=2*t.g.distAmiralToLastRowFactor}this.mEvaluation+=(h-8+n)*c,this.mEvaluation+=(this.piecesWeight[JocGame.PLAYER_A]-this.piecesWeight[JocGame.PLAYER_B])*t.g.weightFactor;for(var p=0,l=0,m=0;m<this.pieces.length;m++){var f=this.pieces[m];if(f.alive){var u=Math.min(t.g.Dist(f.pos,r),t.g.Dist(f.pos,a));f.s==JocGame.PLAYER_A?p+=u:l+=u}}this.mEvaluation+=.001*(l-p),this.mEvaluation+=(s?-t.g.yohohoFactor:0)+(o?t.g.yohohoFactor:0)}},Model.Board.yohohoUpdateAngle=function(t,i,e,s){var o=0;if(void 0===s||void 0===e)o=0;else{var r=t.g.Coord[e],a=t.g.Coord[s];o=a[1]>r[1]?a[0]>r[0]?-30:a[0]<r[0]?-150:-90:a[0]>r[0]?30:a[0]<r[0]?150:90}i.angle=o},Model.Board.ApplyMove=function(t,i){if("m"==i.t){var e=this.board[i.m[0].f],s=this.pieces[e].s;this.board[i.m[0].f]=-1,this.board[i.m[0].t]=e,this.pieces[e].pos=i.m[0].t,this.yohohoUpdateAngle(t,this.pieces[e],i.m[0].f,i.m[0].t),0==this.first&&void 0!==i.m[1].f&&(e=this.board[i.m[1].f],e<0&&JocLog("!!!! move from nowhere",i),this.board[i.m[1].f]=-1,this.board[i.m[1].t]=e,this.pieces[e].pos=i.m[1].t,this.yohohoUpdateAngle(t,this.pieces[e],i.m[1].f,i.m[1].t));var o=this.YohohoAmiralCapture(t,-s);this.yohoho=o.risk}else if("a"==i.t){var e=this.board[i.at];this.board[i.at]=-1,this.pieces[e].alive=0,this.piecesWeight[-this.mWho]-=t.g.pieceWeight[this.pieces[e].type]}this.first=!1},Model.Board.YohohoReachablePositions=function(t,i,e,s,o){var r=this,a=[],h=0,n=this.pieces[this.board[i]].s,c="YohohoEachDirectionWind";switch(e){case"C":h=1;break;case"c":h=2;break;case"p":h=3;break;case"r":c="YohohoEachDirection"}return t[c](i,function(i,c){for(var p=0;null!=i&&(0==h||p<h)&&(i==s||r.board[i]==-1&&i!=o);){var l=!0;if("C"==e){var m=0;t.YohohoEachDirection(i,function(i){var e=r.board[i];if(e>=0&&r.pieces[e].alive&&r.pieces[e].s==-n){var s=t.g.GetStrengthByType(r.pieces[e].type);m+=s}return!0}),m>5&&(l=!1)}l&&a.push(i),i=t.g.Graph[i][c],p++}return!0}),a},Model.Board.YohohoReachablePositionsThrough=function(t,i,e){var s=this,o=[],r=0,a=this.pieces[this.board[i]].s,h="YohohoEachDirectionWind";switch(e){case"C":r=1;break;case"c":r=2;break;case"p":r=3;break;case"r":h="YohohoEachDirection"}return t[h](i,function(i,h){for(var n=0,c=[];null!=i&&(0==r||n<r)&&(s.board[i]==-1||s.pieces[s.board[i]].s==a);){var p=!0;if("C"==e){var l=0;t.YohohoEachDirection(i,function(i){var e=s.board[i];if(e>=0&&s.pieces[e].alive&&s.pieces[e].s==-a){var o=t.g.GetStrengthByType(s.pieces[e].type);l+=o}return!0}),l>5&&(p=!1)}if(c.push(i),p){for(var m=[],f=0;f<c.length;f++)m.push(c[f]);o.push({pos:i,reqEmpty:m})}i=t.g.Graph[i][h],n++}return!0}),o},Model.Game.YohohoEachDirection=function(t,i){for(var e=0;e<6;e++){var s=this.g.Graph[t][e];if(null!=s&&0==i(s,e))return}},Model.Game.YohohoEachDirectionWind=function(t,i){for(var e=1;e<6;e++){var s=this.g.Graph[t][e];if(null!=s&&0==i(s,e))return}},Model.Board.YohohoAmiralCapture=function(t,i){var e=this,s={risk:!1},o=this.pieces[this.amirals[i]].pos,r=0,a=[];if(t.YohohoEachDirection(o,function(s){var o=e.board[s];if(o>=0&&e.pieces[o].alive&&e.pieces[o].s==-i){var h=t.g.GetStrengthByType(e.pieces[o].type);h>0&&a.push(o),r+=h}return!0}),r<=5)return s;s.risk=!0,s.attackers=a,s.capture=[];for(var h=0;h<a.length;h++){var n=a[h],c=t.g.GetStrengthByType(this.pieces[n].type);if(r-c<=5){var p=0,l=[];t.YohohoEachDirection(this.pieces[n].pos,function(s){var o=e.board[s];if(o>=0&&e.pieces[o].alive&&e.pieces[o].s==i){var r=t.g.GetStrengthByType(e.pieces[o].type);r>0&&l.push(e.pieces[o].pos),p+=r}return!0}),p>c&&s.capture.push({af:l,at:this.pieces[n].pos})}}return s.escape=[],t.YohohoEachDirectionWind(o,function(r){if(e.board[r]==-1){var a=0;t.YohohoEachDirection(r,function(s){var o=e.board[s];if(o>=0&&e.pieces[o].alive&&e.pieces[o].s==-i){var r=t.g.GetStrengthByType(e.pieces[o].type);a+=r}}),a<=5&&s.escape.push({f:o,t:r})}return!0}),s.end=0==s.escape.length&&0==s.capture.length,s},Model.Board.YohohoCaptures=function(t,i){for(var e=this,s=[],o=0;o<e.pieces.length;o++){var r=e.pieces[o];if(r.s==-i&&r.alive){var a=t.g.GetStrengthByType(r.type),h=[];if(a>0){var n=0;t.YohohoEachDirection(r.pos,function(s){var o=e.board[s];if(o>=0&&e.pieces[o].alive&&e.pieces[o].s==i){var r=t.g.GetStrengthByType(e.pieces[o].type);r>0&&h.push(s),n+=r}return!0}),n>a&&s.push({t:"a",af:h,at:r.pos})}}}return s};

/***/ }),

/***/ "pgP5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__("mmVS");
/* tslint:enable:max-line-length */
/**
 * Applies an accumulator function over the source Observable, and returns the
 * accumulated result when the source completes, given an optional seed value.
 *
 * <span class="informal">Combines together all values emitted on the source,
 * using an accumulator function that knows how to join a new source value into
 * the accumulation from the past.</span>
 *
 * <img src="./img/reduce.png" width="100%">
 *
 * Like
 * [Array.prototype.reduce()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce),
 * `reduce` applies an `accumulator` function against an accumulation and each
 * value of the source Observable (from the past) to reduce it to a single
 * value, emitted on the output Observable. Note that `reduce` will only emit
 * one value, only when the source Observable completes. It is equivalent to
 * applying operator {@link scan} followed by operator {@link last}.
 *
 * Returns an Observable that applies a specified `accumulator` function to each
 * item emitted by the source Observable. If a `seed` value is specified, then
 * that value will be used as the initial value for the accumulator. If no seed
 * value is specified, the first item of the source is used as the seed.
 *
 * @example <caption>Count the number of click events that happened in 5 seconds</caption>
 * var clicksInFiveSeconds = Rx.Observable.fromEvent(document, 'click')
 *   .takeUntil(Rx.Observable.interval(5000));
 * var ones = clicksInFiveSeconds.mapTo(1);
 * var seed = 0;
 * var count = ones.reduce((acc, one) => acc + one, seed);
 * count.subscribe(x => console.log(x));
 *
 * @see {@link count}
 * @see {@link expand}
 * @see {@link mergeScan}
 * @see {@link scan}
 *
 * @param {function(acc: R, value: T, index: number): R} accumulator The accumulator function
 * called on each source value.
 * @param {R} [seed] The initial accumulation value.
 * @return {Observable<R>} An Observable that emits a single value that is the
 * result of accumulating the values emitted by the source Observable.
 * @method reduce
 * @owner Observable
 */
function reduce(accumulator, seed) {
    var hasSeed = false;
    // providing a seed of `undefined` *should* be valid and trigger
    // hasSeed! so don't use `seed !== undefined` checks!
    // For this reason, we have to check it here at the original call site
    // otherwise inside Operator/Subscriber we won't know if `undefined`
    // means they didn't provide anything or if they literally provided `undefined`
    if (arguments.length >= 2) {
        hasSeed = true;
    }
    return this.lift(new ReduceOperator(accumulator, seed, hasSeed));
}
exports.reduce = reduce;
var ReduceOperator = (function () {
    function ReduceOperator(accumulator, seed, hasSeed) {
        if (hasSeed === void 0) { hasSeed = false; }
        this.accumulator = accumulator;
        this.seed = seed;
        this.hasSeed = hasSeed;
    }
    ReduceOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new ReduceSubscriber(subscriber, this.accumulator, this.seed, this.hasSeed));
    };
    return ReduceOperator;
}());
exports.ReduceOperator = ReduceOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var ReduceSubscriber = (function (_super) {
    __extends(ReduceSubscriber, _super);
    function ReduceSubscriber(destination, accumulator, seed, hasSeed) {
        _super.call(this, destination);
        this.accumulator = accumulator;
        this.hasSeed = hasSeed;
        this.index = 0;
        this.hasValue = false;
        this.acc = seed;
        if (!this.hasSeed) {
            this.index++;
        }
    }
    ReduceSubscriber.prototype._next = function (value) {
        if (this.hasValue || (this.hasValue = this.hasSeed)) {
            this._tryReduce(value);
        }
        else {
            this.acc = value;
            this.hasValue = true;
        }
    };
    ReduceSubscriber.prototype._tryReduce = function (value) {
        var result;
        try {
            result = this.accumulator(this.acc, value, this.index++);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        this.acc = result;
    };
    ReduceSubscriber.prototype._complete = function () {
        if (this.hasValue || this.hasSeed) {
            this.destination.next(this.acc);
        }
        this.destination.complete();
    };
    return ReduceSubscriber;
}(Subscriber_1.Subscriber));
exports.ReduceSubscriber = ReduceSubscriber;
//# sourceMappingURL=reduce.js.map

/***/ }),

/***/ "pinI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("3j3K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__angular_common__ = __webpack_require__("2Je8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base_adapter__ = __webpack_require__("esTq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__media_query_media_monitor__ = __webpack_require__("bWt6");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ClassDirective; });
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */




/**
 * Directive to add responsive support for ngClass.
 */
var ClassDirective = (function (_super) {
    __extends(ClassDirective, _super);
    /* tslint:enable */
    function ClassDirective(monitor, _iterableDiffers, _keyValueDiffers, _ngEl, _oldRenderer, _renderer) {
        var _this = 
        // TODO: this should use Renderer2 as well, but NgClass hasn't switched over yet.
        _super.call(this, _iterableDiffers, _keyValueDiffers, _ngEl, _oldRenderer) || this;
        _this.monitor = monitor;
        _this._classAdapter = new __WEBPACK_IMPORTED_MODULE_2__base_adapter__["a" /* BaseFxDirectiveAdapter */]('class', monitor, _ngEl, _renderer);
        _this._ngClassAdapter = new __WEBPACK_IMPORTED_MODULE_2__base_adapter__["a" /* BaseFxDirectiveAdapter */]('ngClass', monitor, _ngEl, _renderer);
        return _this;
    }
    Object.defineProperty(ClassDirective.prototype, "ngClassBase", {
        /**
         * Intercept ngClass assignments so we cache the default classes
         * which are merged with activated styles or used as fallbacks.
         * Note: Base ngClass values are applied during ngDoCheck()
         */
        set: function (val) {
            this._ngClassAdapter.cacheInput('ngClass', val, true);
            this.ngClass = val;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ClassDirective.prototype, "ngClassXs", {
        /* tslint:disable */
        set: function (val) { this._ngClassAdapter.cacheInput('ngClassXs', val, true); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ClassDirective.prototype, "ngClassSm", {
        set: function (val) { this._ngClassAdapter.cacheInput('ngClassSm', val, true); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ClassDirective.prototype, "ngClassMd", {
        set: function (val) { this._ngClassAdapter.cacheInput('ngClassMd', val, true); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ClassDirective.prototype, "ngClassLg", {
        set: function (val) { this._ngClassAdapter.cacheInput('ngClassLg', val, true); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ClassDirective.prototype, "ngClassXl", {
        set: function (val) { this._ngClassAdapter.cacheInput('ngClassXl', val, true); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ClassDirective.prototype, "ngClassLtSm", {
        set: function (val) { this._ngClassAdapter.cacheInput('ngClassLtSm', val, true); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ClassDirective.prototype, "ngClassLtMd", {
        set: function (val) { this._ngClassAdapter.cacheInput('ngClassLtMd', val, true); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ClassDirective.prototype, "ngClassLtLg", {
        set: function (val) { this._ngClassAdapter.cacheInput('ngClassLtLg', val, true); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ClassDirective.prototype, "ngClassLtXl", {
        set: function (val) { this._ngClassAdapter.cacheInput('ngClassLtXl', val, true); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ClassDirective.prototype, "ngClassGtXs", {
        set: function (val) { this._ngClassAdapter.cacheInput('ngClassGtXs', val, true); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ClassDirective.prototype, "ngClassGtSm", {
        set: function (val) { this._ngClassAdapter.cacheInput('ngClassGtSm', val, true); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ClassDirective.prototype, "ngClassGtMd", {
        set: function (val) { this._ngClassAdapter.cacheInput('ngClassGtMd', val, true); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ClassDirective.prototype, "ngClassGtLg", {
        set: function (val) { this._ngClassAdapter.cacheInput('ngClassGtLg', val, true); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ClassDirective.prototype, "classBase", {
        /** Deprecated selectors */
        /**
         * Base class selector values get applied immediately and are considered destructive overwrites to
         * all previous class assignments
         *
         * Delegate to NgClass:klass setter and cache value for base fallback from responsive APIs.
         */
        set: function (val) {
            this._classAdapter.cacheInput('_rawClass', val, true);
            this.klass = val;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ClassDirective.prototype, "classXs", {
        set: function (val) { this._classAdapter.cacheInput('classXs', val, true); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ClassDirective.prototype, "classSm", {
        set: function (val) { this._classAdapter.cacheInput('classSm', val, true); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ClassDirective.prototype, "classMd", {
        set: function (val) { this._classAdapter.cacheInput('classMd', val, true); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ClassDirective.prototype, "classLg", {
        set: function (val) { this._classAdapter.cacheInput('classLg', val, true); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ClassDirective.prototype, "classXl", {
        set: function (val) { this._classAdapter.cacheInput('classXl', val, true); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ClassDirective.prototype, "classLtSm", {
        set: function (val) { this._classAdapter.cacheInput('classLtSm', val, true); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ClassDirective.prototype, "classLtMd", {
        set: function (val) { this._classAdapter.cacheInput('classLtMd', val, true); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ClassDirective.prototype, "classLtLg", {
        set: function (val) { this._classAdapter.cacheInput('classLtLg', val, true); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ClassDirective.prototype, "classLtXl", {
        set: function (val) { this._classAdapter.cacheInput('classLtXl', val, true); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ClassDirective.prototype, "classGtXs", {
        set: function (val) { this._classAdapter.cacheInput('classGtXs', val, true); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ClassDirective.prototype, "classGtSm", {
        set: function (val) { this._classAdapter.cacheInput('classGtSm', val, true); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ClassDirective.prototype, "classGtMd", {
        set: function (val) { this._classAdapter.cacheInput('classGtMd', val, true); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ClassDirective.prototype, "classGtLg", {
        set: function (val) { this._classAdapter.cacheInput('classGtLg', val, true); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ClassDirective.prototype, "initialClasses", {
        /**
         * Initial value of the `class` attribute; used as
         * fallback and will be merged with nay `ngClass` values
         */
        get: function () {
            return this._classAdapter.queryInput('_rawClass') || "";
        },
        enumerable: true,
        configurable: true
    });
    // ******************************************************************
    // Lifecycle Hooks
    // ******************************************************************
    /**
     * For @Input changes on the current mq activation property
     */
    ClassDirective.prototype.ngOnChanges = function (changes) {
        if (this._classAdapter.activeKey in changes) {
            this._updateKlass();
        }
        if (this._ngClassAdapter.activeKey in changes) {
            this._updateNgClass();
        }
    };
    /**
     * For ChangeDetectionStrategy.onPush and ngOnChanges() updates
     */
    ClassDirective.prototype.ngDoCheck = function () {
        if (!this._classAdapter.hasMediaQueryListener) {
            this._configureMQListener();
        }
        _super.prototype.ngDoCheck.call(this);
    };
    ClassDirective.prototype.ngOnDestroy = function () {
        this._classAdapter.ngOnDestroy();
        this._ngClassAdapter.ngOnDestroy();
    };
    // ******************************************************************
    // Internal Methods
    // ******************************************************************
    /**
     * Build an mqActivation object that bridges
     * mql change events to onMediaQueryChange handlers
     */
    ClassDirective.prototype._configureMQListener = function () {
        var _this = this;
        this._classAdapter.listenForMediaQueryChanges('class', '', function (changes) {
            _this._updateKlass(changes.value);
        });
        this._ngClassAdapter.listenForMediaQueryChanges('ngClass', '', function (changes) {
            _this._updateNgClass(changes.value);
            _super.prototype.ngDoCheck.call(_this); // trigger NgClass::_applyIterableChanges()
        });
    };
    /**
     *  Apply updates directly to the NgClass:klass property
     *  ::ngDoCheck() is not needed
     */
    ClassDirective.prototype._updateKlass = function (value) {
        var klass = value || this._classAdapter.queryInput('class') || '';
        if (this._classAdapter.mqActivation) {
            klass = this._classAdapter.mqActivation.activatedInput;
        }
        this.klass = klass || this.initialClasses;
    };
    /**
     *  Identify the activated input value and update the ngClass iterables...
     *  needs ngDoCheck() to actually apply the values to the element
     */
    ClassDirective.prototype._updateNgClass = function (value) {
        if (this._ngClassAdapter.mqActivation) {
            value = this._ngClassAdapter.mqActivation.activatedInput;
        }
        this.ngClass = value || ''; // Delegate subsequent activity to the NgClass logic
    };
    return ClassDirective;
}(__WEBPACK_IMPORTED_MODULE_1__angular_common__["NgClass"]));

ClassDirective.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Directive"], args: [{
                selector: "\n    [class], [class.xs], [class.sm], [class.md], [class.lg], [class.xl],\n    [class.lt-sm], [class.lt-md], [class.lt-lg], [class.lt-xl],\n    [class.gt-xs], [class.gt-sm], [class.gt-md], [class.gt-lg],\n\n    [ngClass], [ngClass.xs], [ngClass.sm], [ngClass.md], [ngClass.lg], [ngClass.xl],\n    [ngClass.lt-sm], [ngClass.lt-md], [ngClass.lt-lg], [ngClass.lt-xl],\n    [ngClass.gt-xs], [ngClass.gt-sm], [ngClass.gt-md], [ngClass.gt-lg]\n  "
            },] },
];
/** @nocollapse */
ClassDirective.ctorParameters = function () { return [
    { type: __WEBPACK_IMPORTED_MODULE_3__media_query_media_monitor__["a" /* MediaMonitor */], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["IterableDiffers"], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["KeyValueDiffers"], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["ElementRef"], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer"], },
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Renderer2"], },
]; };
ClassDirective.propDecorators = {
    'ngClassBase': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['ngClass',] },],
    'ngClassXs': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['ngClass.xs',] },],
    'ngClassSm': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['ngClass.sm',] },],
    'ngClassMd': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['ngClass.md',] },],
    'ngClassLg': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['ngClass.lg',] },],
    'ngClassXl': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['ngClass.xl',] },],
    'ngClassLtSm': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['ngClass.lt-sm',] },],
    'ngClassLtMd': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['ngClass.lt-md',] },],
    'ngClassLtLg': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['ngClass.lt-lg',] },],
    'ngClassLtXl': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['ngClass.lt-xl',] },],
    'ngClassGtXs': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['ngClass.gt-xs',] },],
    'ngClassGtSm': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['ngClass.gt-sm',] },],
    'ngClassGtMd': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['ngClass.gt-md',] },],
    'ngClassGtLg': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['ngClass.gt-lg',] },],
    'classBase': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['class',] },],
    'classXs': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['class.xs',] },],
    'classSm': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['class.sm',] },],
    'classMd': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['class.md',] },],
    'classLg': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['class.lg',] },],
    'classXl': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['class.xl',] },],
    'classLtSm': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['class.lt-sm',] },],
    'classLtMd': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['class.lt-md',] },],
    'classLtLg': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['class.lt-lg',] },],
    'classLtXl': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['class.lt-xl',] },],
    'classGtXs': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['class.gt-xs',] },],
    'classGtSm': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['class.gt-sm',] },],
    'classGtMd': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['class.gt-md',] },],
    'classGtLg': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"], args: ['class.gt-lg',] },],
};
//# sourceMappingURL=class.js.map

/***/ }),

/***/ "prmc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("3j3K");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DockActions; });

var DockActions = (function () {
    function DockActions() {
    }
    DockActions.prototype.toggleVisibility = function () {
        return { type: DockActions.TOGGLE_VISIBILITY };
    };
    DockActions.prototype.changePosition = function () {
        return { type: DockActions.CHANGE_POSITION };
    };
    DockActions.prototype.changeSize = function (size) {
        return { type: DockActions.CHANGE_SIZE, payload: size };
    };
    DockActions.prototype.changeMonitor = function () {
        return { type: DockActions.CHANGE_MONITOR };
    };
    DockActions.TOGGLE_VISIBILITY = '@@redux-devtools-log-monitor/TOGGLE_VISIBILITY';
    DockActions.CHANGE_POSITION = '@@redux-devtools-log-monitor/CHANGE_POSITION';
    DockActions.CHANGE_SIZE = '@@redux-devtools-log-monitor/CHANGE_SIZE';
    DockActions.CHANGE_MONITOR = '@@redux-devtools-log-monitor/CHANGE_MONITOR';
    DockActions.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injectable"] },
    ];
    /** @nocollapse */
    DockActions.ctorParameters = [];
    return DockActions;
}());
//# sourceMappingURL=actions.js.map

/***/ }),

/***/ "pvzN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("3j3K");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BREAKPOINTS; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

/**
 *  Injection token unique to the flex-layout library.
 *  Use this token when build a custom provider (see below).
 */
var BREAKPOINTS = new __WEBPACK_IMPORTED_MODULE_0__angular_core__["InjectionToken"]('Token (@angular/flex-layout) Breakpoints');
//# sourceMappingURL=break-points-token.js.map

/***/ }),

/***/ "q+cp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var OuterSubscriber_1 = __webpack_require__("wAkD");
var subscribeToResult_1 = __webpack_require__("CURp");
/**
 * Emits the values emitted by the source Observable until a `notifier`
 * Observable emits a value.
 *
 * <span class="informal">Lets values pass until a second Observable,
 * `notifier`, emits something. Then, it completes.</span>
 *
 * <img src="./img/takeUntil.png" width="100%">
 *
 * `takeUntil` subscribes and begins mirroring the source Observable. It also
 * monitors a second Observable, `notifier` that you provide. If the `notifier`
 * emits a value or a complete notification, the output Observable stops
 * mirroring the source Observable and completes.
 *
 * @example <caption>Tick every second until the first click happens</caption>
 * var interval = Rx.Observable.interval(1000);
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = interval.takeUntil(clicks);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link take}
 * @see {@link takeLast}
 * @see {@link takeWhile}
 * @see {@link skip}
 *
 * @param {Observable} notifier The Observable whose first emitted value will
 * cause the output Observable of `takeUntil` to stop emitting values from the
 * source Observable.
 * @return {Observable<T>} An Observable that emits the values from the source
 * Observable until such time as `notifier` emits its first value.
 * @method takeUntil
 * @owner Observable
 */
function takeUntil(notifier) {
    return this.lift(new TakeUntilOperator(notifier));
}
exports.takeUntil = takeUntil;
var TakeUntilOperator = (function () {
    function TakeUntilOperator(notifier) {
        this.notifier = notifier;
    }
    TakeUntilOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new TakeUntilSubscriber(subscriber, this.notifier));
    };
    return TakeUntilOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var TakeUntilSubscriber = (function (_super) {
    __extends(TakeUntilSubscriber, _super);
    function TakeUntilSubscriber(destination, notifier) {
        _super.call(this, destination);
        this.notifier = notifier;
        this.add(subscribeToResult_1.subscribeToResult(this, notifier));
    }
    TakeUntilSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.complete();
    };
    TakeUntilSubscriber.prototype.notifyComplete = function () {
        // noop
    };
    return TakeUntilSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=takeUntil.js.map

/***/ }),

/***/ "q+ny":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var tryCatch_1 = __webpack_require__("+3eL");
var errorObject_1 = __webpack_require__("WhVc");
var OuterSubscriber_1 = __webpack_require__("wAkD");
var subscribeToResult_1 = __webpack_require__("CURp");
/* tslint:enable:max-line-length */
/**
 * Recursively projects each source value to an Observable which is merged in
 * the output Observable.
 *
 * <span class="informal">It's similar to {@link mergeMap}, but applies the
 * projection function to every source value as well as every output value.
 * It's recursive.</span>
 *
 * <img src="./img/expand.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an Observable, and then merging those resulting Observables and
 * emitting the results of this merger. *Expand* will re-emit on the output
 * Observable every source value. Then, each output value is given to the
 * `project` function which returns an inner Observable to be merged on the
 * output Observable. Those output values resulting from the projection are also
 * given to the `project` function to produce new output values. This is how
 * *expand* behaves recursively.
 *
 * @example <caption>Start emitting the powers of two on every click, at most 10 of them</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var powersOfTwo = clicks
 *   .mapTo(1)
 *   .expand(x => Rx.Observable.of(2 * x).delay(1000))
 *   .take(10);
 * powersOfTwo.subscribe(x => console.log(x));
 *
 * @see {@link mergeMap}
 * @see {@link mergeScan}
 *
 * @param {function(value: T, index: number) => Observable} project A function
 * that, when applied to an item emitted by the source or the output Observable,
 * returns an Observable.
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @param {Scheduler} [scheduler=null] The IScheduler to use for subscribing to
 * each projected inner Observable.
 * @return {Observable} An Observable that emits the source values and also
 * result of applying the projection function to each value emitted on the
 * output Observable and and merging the results of the Observables obtained
 * from this transformation.
 * @method expand
 * @owner Observable
 */
function expand(project, concurrent, scheduler) {
    if (concurrent === void 0) { concurrent = Number.POSITIVE_INFINITY; }
    if (scheduler === void 0) { scheduler = undefined; }
    concurrent = (concurrent || 0) < 1 ? Number.POSITIVE_INFINITY : concurrent;
    return this.lift(new ExpandOperator(project, concurrent, scheduler));
}
exports.expand = expand;
var ExpandOperator = (function () {
    function ExpandOperator(project, concurrent, scheduler) {
        this.project = project;
        this.concurrent = concurrent;
        this.scheduler = scheduler;
    }
    ExpandOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new ExpandSubscriber(subscriber, this.project, this.concurrent, this.scheduler));
    };
    return ExpandOperator;
}());
exports.ExpandOperator = ExpandOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var ExpandSubscriber = (function (_super) {
    __extends(ExpandSubscriber, _super);
    function ExpandSubscriber(destination, project, concurrent, scheduler) {
        _super.call(this, destination);
        this.project = project;
        this.concurrent = concurrent;
        this.scheduler = scheduler;
        this.index = 0;
        this.active = 0;
        this.hasCompleted = false;
        if (concurrent < Number.POSITIVE_INFINITY) {
            this.buffer = [];
        }
    }
    ExpandSubscriber.dispatch = function (arg) {
        var subscriber = arg.subscriber, result = arg.result, value = arg.value, index = arg.index;
        subscriber.subscribeToProjection(result, value, index);
    };
    ExpandSubscriber.prototype._next = function (value) {
        var destination = this.destination;
        if (destination.closed) {
            this._complete();
            return;
        }
        var index = this.index++;
        if (this.active < this.concurrent) {
            destination.next(value);
            var result = tryCatch_1.tryCatch(this.project)(value, index);
            if (result === errorObject_1.errorObject) {
                destination.error(errorObject_1.errorObject.e);
            }
            else if (!this.scheduler) {
                this.subscribeToProjection(result, value, index);
            }
            else {
                var state = { subscriber: this, result: result, value: value, index: index };
                this.add(this.scheduler.schedule(ExpandSubscriber.dispatch, 0, state));
            }
        }
        else {
            this.buffer.push(value);
        }
    };
    ExpandSubscriber.prototype.subscribeToProjection = function (result, value, index) {
        this.active++;
        this.add(subscribeToResult_1.subscribeToResult(this, result, value, index));
    };
    ExpandSubscriber.prototype._complete = function () {
        this.hasCompleted = true;
        if (this.hasCompleted && this.active === 0) {
            this.destination.complete();
        }
    };
    ExpandSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this._next(innerValue);
    };
    ExpandSubscriber.prototype.notifyComplete = function (innerSub) {
        var buffer = this.buffer;
        this.remove(innerSub);
        this.active--;
        if (buffer && buffer.length > 0) {
            this._next(buffer.shift());
        }
        if (this.hasCompleted && this.active === 0) {
            this.destination.complete();
        }
    };
    return ExpandSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
exports.ExpandSubscriber = ExpandSubscriber;
//# sourceMappingURL=expand.js.map

/***/ }),

/***/ "q0UB":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var AsyncAction_1 = __webpack_require__("cwzr");
var AsyncScheduler_1 = __webpack_require__("9Avi");
var VirtualTimeScheduler = (function (_super) {
    __extends(VirtualTimeScheduler, _super);
    function VirtualTimeScheduler(SchedulerAction, maxFrames) {
        var _this = this;
        if (SchedulerAction === void 0) { SchedulerAction = VirtualAction; }
        if (maxFrames === void 0) { maxFrames = Number.POSITIVE_INFINITY; }
        _super.call(this, SchedulerAction, function () { return _this.frame; });
        this.maxFrames = maxFrames;
        this.frame = 0;
        this.index = -1;
    }
    /**
     * Prompt the Scheduler to execute all of its queued actions, therefore
     * clearing its queue.
     * @return {void}
     */
    VirtualTimeScheduler.prototype.flush = function () {
        var _a = this, actions = _a.actions, maxFrames = _a.maxFrames;
        var error, action;
        while ((action = actions.shift()) && (this.frame = action.delay) <= maxFrames) {
            if (error = action.execute(action.state, action.delay)) {
                break;
            }
        }
        if (error) {
            while (action = actions.shift()) {
                action.unsubscribe();
            }
            throw error;
        }
    };
    VirtualTimeScheduler.frameTimeFactor = 10;
    return VirtualTimeScheduler;
}(AsyncScheduler_1.AsyncScheduler));
exports.VirtualTimeScheduler = VirtualTimeScheduler;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var VirtualAction = (function (_super) {
    __extends(VirtualAction, _super);
    function VirtualAction(scheduler, work, index) {
        if (index === void 0) { index = scheduler.index += 1; }
        _super.call(this, scheduler, work);
        this.scheduler = scheduler;
        this.work = work;
        this.index = index;
        this.active = true;
        this.index = scheduler.index = index;
    }
    VirtualAction.prototype.schedule = function (state, delay) {
        if (delay === void 0) { delay = 0; }
        if (!this.id) {
            return _super.prototype.schedule.call(this, state, delay);
        }
        this.active = false;
        // If an action is rescheduled, we save allocations by mutating its state,
        // pushing it to the end of the scheduler queue, and recycling the action.
        // But since the VirtualTimeScheduler is used for testing, VirtualActions
        // must be immutable so they can be inspected later.
        var action = new VirtualAction(this.scheduler, this.work);
        this.add(action);
        return action.schedule(state, delay);
    };
    VirtualAction.prototype.requestAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) { delay = 0; }
        this.delay = scheduler.frame + delay;
        var actions = scheduler.actions;
        actions.push(this);
        actions.sort(VirtualAction.sortActions);
        return true;
    };
    VirtualAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) { delay = 0; }
        return undefined;
    };
    VirtualAction.prototype._execute = function (state, delay) {
        if (this.active === true) {
            return _super.prototype._execute.call(this, state, delay);
        }
    };
    VirtualAction.sortActions = function (a, b) {
        if (a.delay === b.delay) {
            if (a.index === b.index) {
                return 0;
            }
            else if (a.index > b.index) {
                return 1;
            }
            else {
                return -1;
            }
        }
        else if (a.delay > b.delay) {
            return 1;
        }
        else {
            return -1;
        }
    };
    return VirtualAction;
}(AsyncAction_1.AsyncAction));
exports.VirtualAction = VirtualAction;
//# sourceMappingURL=VirtualTimeScheduler.js.map

/***/ }),

/***/ "q3ik":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var distinctUntilChanged_1 = __webpack_require__("8hgl");
Observable_1.Observable.prototype.distinctUntilChanged = distinctUntilChanged_1.distinctUntilChanged;
//# sourceMappingURL=distinctUntilChanged.js.map

/***/ }),

/***/ "q4U+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var windowCount_1 = __webpack_require__("erNO");
Observable_1.Observable.prototype.windowCount = windowCount_1.windowCount;
//# sourceMappingURL=windowCount.js.map

/***/ }),

/***/ "qcjU":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var audit_1 = __webpack_require__("WTUZ");
Observable_1.Observable.prototype.audit = audit_1.audit;
//# sourceMappingURL=audit.js.map

/***/ }),

/***/ "qhgQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var distinct_1 = __webpack_require__("69uX");
Observable_1.Observable.prototype.distinct = distinct_1.distinct;
//# sourceMappingURL=distinct.js.map

/***/ }),

/***/ "qp8k":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var combineLatest_1 = __webpack_require__("A7JX");
Observable_1.Observable.prototype.combineLatest = combineLatest_1.combineLatest;
//# sourceMappingURL=combineLatest.js.map

/***/ }),

/***/ "qszO":
/***/ (function(module, exports) {

exports.config = {"status":true,"model":{"plazza":"true","released":1398178576,"title-en":"Mini Chess 4x5","module":"chessbase","summary":"4x5 mini chess variant","thumbnail":"mini4x5-thumb.png","rules":{"en":"mini4x5-rules.html"},"credits":{"en":"mini4x5-credits.html"},"gameOptions":{"preventRepeat":true,"uctTransposition":"state","uctIgnoreLoop":false,"levelOptions":{"pieceValueFactor":1,"pieceValueRatioFactor":1,"posValueFactor":0.1,"averageDistKingFactor":-0.01,"castleFactor":0.1,"minorPiecesMovedFactor":0.1,"checkFactor":0.2,"endingKingFreedomFactor":0.01,"endingDistKingFactor":0.05,"distKingCornerFactor":0.1}},"obsolete":false,"js":["base-model.js","grid-geo-model.js","mini4x5-model.js"],"levels":[{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"easy","label":"Easy","maxNodes":1000},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"fast","label":"Fast [1sec]","maxDuration":1,"isDefault":true},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"medium","label":"Medium","maxNodes":10000,"maxDuration":10},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"strong","label":"Strong","maxNodes":20000,"maxDuration":15}],"description":{"en":"mini4x5-description.html"}},"view":{"title-en":"Chessbase view","module":"chessbase","xdView":true,"css":["chessbase.css"],"preferredRatio":1,"useShowMoves":true,"useNotation":true,"useAutoComplete":true,"defaultOptions":{"sounds":true,"moves":true,"notation":false,"autocomplete":false},"skins":[{"name":"skin3d","title":"3D Classic","3d":true,"preload":["smoothedfilegeo|0|/res/ring-target.js","image|/res/images/cancel.png","image|/res/images/wikipedia.png","smoothedfilegeo|0|/res/staunton/pawn/pawn-classic.js","image|/res/staunton/pawn/pawn-diffusemap.jpg","image|/res/staunton/pawn/pawn-normalmap.jpg","smoothedfilegeo|0|/res/staunton/knight/knight.js","image|/res/staunton/knight/knight-diffusemap.jpg","image|/res/staunton/knight/knight-normalmap.jpg","smoothedfilegeo|0|/res/staunton/bishop/bishop.js","image|/res/staunton/bishop/bishop-diffusemap.jpg","image|/res/staunton/bishop/bishop-normalmap.jpg","smoothedfilegeo|0|/res/staunton/rook/rook.js","image|/res/staunton/rook/rook-diffusemap.jpg","image|/res/staunton/rook/rook-normalmap.jpg","smoothedfilegeo|0|/res/staunton/queen/queen.js","image|/res/staunton/queen/queen-diffusemap.jpg","image|/res/staunton/queen/queen-normalmap.jpg","smoothedfilegeo|0|/res/staunton/king/king.js","image|/res/staunton/king/king-diffusemap.jpg","image|/res/staunton/king/king-normalmap.jpg"],"world":{"lightIntensity":1.3,"skyLightIntensity":1.2,"lightCastShadow":true,"fog":false,"color":4686804,"lightPosition":{"x":-9,"y":9,"z":9},"skyLightPosition":{"x":9,"y":9,"z":9},"lightShadowDarkness":0.55,"ambientLightColor":2236962},"camera":{"fov":45,"distMax":50,"radius":18,"elevationAngle":60,"elevationMin":0}},{"name":"skin2d","title":"2D Classic","3d":false,"preload":["image|/res/images/cancel.png","image|/res/images/whitebg.png","image|/res/images/wikipedia.png"]}],"animateSelfMoves":false,"switchable":true,"sounds":{"move1":"alq_move1","move2":"alq_move2","move3":"alq_move3","move4":"alq_move2","tac1":"alq_tac1","tac2":"alq_tac2","tac3":"alq_tac1","promo":"promo","usermove":null},"js":["base-view.js","grid-board-view.js","staunton-set-view.js","mini4x5-view.js"],"visuals":{"600x600":["res/visuals/mini4x5-600x600-3d.jpg","res/visuals/mini4x5-600x600-2d.jpg"]}}}

/***/ }),

/***/ "r666":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__break_points_token__ = __webpack_require__("pvzN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_break_points__ = __webpack_require__("fuE2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_orientation_break_points__ = __webpack_require__("S3x0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_object_extend__ = __webpack_require__("xZ/u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_breakpoint_tools__ = __webpack_require__("Qy3m");
/* unused harmony export buildMergedBreakPoints */
/* unused harmony export DEFAULT_BREAKPOINTS_PROVIDER_FACTORY */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_BREAKPOINTS_PROVIDER; });
/* harmony export (immutable) */ __webpack_exports__["b"] = CUSTOM_BREAKPOINTS_PROVIDER_FACTORY;





/**
 * Add new custom items to the default list or override existing default with custom overrides
 */
function buildMergedBreakPoints(_custom, options) {
    options = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_object_extend__["a" /* extendObject */])({}, {
        defaults: true,
        orientation: false // exclude pre-configured, internal orientations breakpoints
    }, options || {});
    return function () {
        // Order so the defaults are loaded last; so ObservableMedia will report these last!
        var defaults = options.orientations ? __WEBPACK_IMPORTED_MODULE_2__data_orientation_break_points__["a" /* ORIENTATION_BREAKPOINTS */].concat(__WEBPACK_IMPORTED_MODULE_1__data_break_points__["a" /* DEFAULT_BREAKPOINTS */]) :
            __WEBPACK_IMPORTED_MODULE_1__data_break_points__["a" /* DEFAULT_BREAKPOINTS */];
        return options.defaults ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_breakpoint_tools__["a" /* mergeByAlias */])(defaults, _custom || []) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_breakpoint_tools__["a" /* mergeByAlias */])(_custom);
    };
}
/**
 *  Ensure that only a single global BreakPoint list is instantiated...
 */
function DEFAULT_BREAKPOINTS_PROVIDER_FACTORY() {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_breakpoint_tools__["b" /* validateSuffixes */])(__WEBPACK_IMPORTED_MODULE_1__data_break_points__["a" /* DEFAULT_BREAKPOINTS */]);
}
/**
 * Default Provider that does not support external customization nor provide
 * the extra extended breakpoints:   "handset", "tablet", and "web"
 *
 *  NOTE: !! breakpoints are considered to have unique 'alias' properties,
 *        custom breakpoints matching existing breakpoints will override the properties
 *        of the existing (and not be added as an extra breakpoint entry).
 *        [xs, gt-xs, sm, gt-sm, md, gt-md, lg, gt-lg, xl]
 */
var DEFAULT_BREAKPOINTS_PROVIDER = {
    provide: __WEBPACK_IMPORTED_MODULE_0__break_points_token__["a" /* BREAKPOINTS */],
    useFactory: DEFAULT_BREAKPOINTS_PROVIDER_FACTORY
};
/**
 * Use with FlexLayoutModule.CUSTOM_BREAKPOINTS_PROVIDER_FACTORY!
 */
function CUSTOM_BREAKPOINTS_PROVIDER_FACTORY(_custom, options) {
    return {
        provide: __WEBPACK_IMPORTED_MODULE_0__break_points_token__["a" /* BREAKPOINTS */],
        useFactory: buildMergedBreakPoints(_custom, options)
    };
}
//# sourceMappingURL=break-points-provider.js.map

/***/ }),

/***/ "r7wO":
/***/ (function(module, exports) {

exports.model=Model={Game:{},Board:{},Move:{}},function(){var t;Model.Game.cbConstants={MASK:65535,FLAG_MOVE:65536,FLAG_CAPTURE:131072,FLAG_STOP:262144,FLAG_SCREEN_CAPTURE:524288,FLAG_CAPTURE_KING:1048576,FLAG_CAPTURE_NO_KING:2097152};var e="undefined"!=typeof Int32Array;Model.Game.cbUseTypedArrays=e,Model.Game.cbTypedArray=function(t){if(e){var r=new Int32Array(t.length);return r.set(t),r}for(var i=[],a=t.length,s=0;s<a;s++)i.push(t[s]);return i},Model.Game.cbShortRangeGraph=function(t,e,r,i){var a=this;void 0===i&&(i=196608);for(var s={},n=0;n<t.boardSize;n++)s[n]=[],(!r||n in r)&&e.forEach(function(e){var o=t.Graph(n,e);null!=o&&(!r||o in r)&&s[n].push(a.cbTypedArray([o|i]))});return s},Model.Game.cbLongRangeGraph=function(t,e,r,i,a){var s=this;void 0!==i&&null!=i||(i=196608),a||(a=1/0);for(var n={},o=0;o<t.boardSize;o++)n[o]=[],(!r||o in r)&&e.forEach(function(e){for(var h=[],c=t.Graph(o,e),p=0;null!=c&&(!r||c in r)&&(h.push(c|i),++p!=a);)c=t.Graph(c,e);h.length>0&&n[o].push(s.cbTypedArray(h))});return n},Model.Game.cbNullGraph=function(t){for(var e={},r=0;r<t.boardSize;r++)e[r]=[];return e},Model.Game.cbAuthorGraph=function(t){for(var e={},r=0;r<t.boardSize;r++){e[r]=[];for(var i=0;i<t.boardSize;i++)e[r].push([2293760|i])}return e},Model.Game.cbMergeGraphs=function(t){for(var e=[],r=0;r<t.boardSize;r++){e[r]=[];for(var i=1;i<arguments.length;i++)e[r]=e[r].concat(arguments[i][r])}return e},Model.Game.cbGetThreatGraph=function(){function t(e,r){for(var i in n){var a=n[i];if(!(a.p.length<r.length+1)){for(var s=!0,o=0;o<r.length;o++)if(r[o]!=a.p[o]){s=!1;break}if(s){var h=a.p[r.length],c=e[h];void 0===c&&(c={e:{}},e[h]=c),a.p.length==r.length+1&&(c.t=a.t,c.ts=a.ts,c.tk=a.tk,delete n[i]),r.push(h),t(c.e,r),r.pop()}}}}var e=this;this.cbUseScreenCapture=!1,this.cbUseCaptureKing=!1,this.cbUseCaptureNoKing=!1;for(var r={1:[],"-1":[]},i=[],a=0;a<this.g.boardSize;a++)this.g.pTypes.forEach(function(t,r){t.graph[a].forEach(function(t){for(var s=[],n=0;n<t.length;n++){var o=t[n];1048576&o?(e.cbUseCaptureKing=!0,s.unshift({d:65535&o,a:a,tk:r})):2097152&o?(e.cbUseCaptureNoKing=!0,s.unshift({d:65535&o,a:a,tnk:r})):131072&o?s.unshift({d:65535&o,a:a,t:r}):262144&o?s.unshift({d:65535&o,a:a}):524288&o&&(e.cbUseScreenCapture=!0,s.unshift({d:65535&o,a:a,ts:r}))}s.length>0&&i.push(s)})});var s={};i.forEach(function(t){t.forEach(function(e,r){var i=s[e.d];void 0===i&&(i={},s[e.d]=i);for(var a=[],n=r+1;n<t.length;n++)a.push(t[n].d);a.push(e.a);var o=a.join(","),h=i[o];void 0===h&&(h={p:a,t:{},ts:{},tk:{}},i[o]=h),void 0!==e.t?h.t[e.t]=!0:void 0!==e.tk?h.tk[e.tk]=!0:void 0!==e.ts&&(h.ts[e.ts]=!0)})});for(var a=0;a<e.g.boardSize;a++){var n=s[a],o={};t(o,[]),r[1][a]=o,r[-1][a]=o}return r},Model.Game.InitGame=function(){var e=this;this.cbVar=t=this.cbDefine(),this.g.boardSize=this.cbVar.geometry.boardSize,this.g.pTypes=this.cbGetPieceTypes(),this.g.threatGraph=this.cbGetThreatGraph(),this.g.distGraph=this.cbVar.geometry.GetDistances(),this.cbPiecesCount=0,this.g.castleablePiecesCount={1:0,"-1":0};for(var r in t.pieceTypes){var i=t.pieceTypes[r];if(i.castle){(i.initial||[]).forEach(function(t){e.g.castleablePiecesCount[t.s]++})}i.initial&&(this.cbPiecesCount+=i.initial.length)}for(var a=[],r=0;r<this.cbPiecesCount;r++)a.push(r);var s=Object.keys(t.pieceTypes);this.zobrist=new JocGame.Zobrist({board:{type:"array",size:this.cbVar.geometry.boardSize,values:a},who:{values:["1","-1"]},type:{type:"array",size:this.cbPiecesCount,values:s}})},Model.Game.cbGetPieceTypes=function(){for(var t=[],e={},r=0;r<this.cbVar.geometry.boardSize;r++)e[r]=[];for(var i in this.cbVar.pieceTypes){var a=this.cbVar.pieceTypes[i];t[i]={graph:a.graph||e,abbrev:a.abbrev||"",value:a.isKing?100:a.value||1,isKing:!!a.isKing,castle:!!a.castle,epTarget:!!a.epTarget,epCatch:!!a.epCatch}}return t},Model.Board.Init=function(t){this.zSign=0},Model.Board.InitialPosition=function(r){var i=this;this.board=e?new Int16Array(r.g.boardSize):[];for(var a=0;a<r.g.boardSize;a++)this.board[a]=-1;if(this.kings={},this.pieces=[],this.ending={1:!1,"-1":!1},this.lastMove=null,r.cbVar.castle&&(this.castled={1:!1,"-1":!1}),this.zSign=r.zobrist.update(0,"who",-1),this.noCaptCount=0,this.mWho=1,r.mInitial)this.mWho=r.mInitial.turn||1,r.mInitial.pieces.forEach(function(t){var e={};for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);i.pieces.push(e)}),r.mInitial.lastMove&&(this.lastMove={f:r.mInitial.lastMove.f,t:r.mInitial.lastMove.t}),void 0!==r.mInitial.noCaptCount&&(this.noCaptCount=r.mInitial.noCaptCount),r.cbVar.castle&&r.mInitial.castle&&(this.castled={1:{k:!!r.mInitial.castle[1]&&!!r.mInitial.castle[1].k,q:!!r.mInitial.castle[1]&&!!r.mInitial.castle[1].q},"-1":{k:!!r.mInitial.castle[-1]&&!!r.mInitial.castle[-1].k,q:!!r.mInitial.castle[-1]&&!!r.mInitial.castle[-1].q}});else for(var s in r.cbVar.pieceTypes)for(var n=r.cbVar.pieceTypes[s],o=n.initial||[],h=0;h<o.length;h++){var c=o[h],p={s:c.s,t:parseInt(s),p:c.p,m:!1};this.pieces.push(p)}if(this.pieces.sort(function(t,e){if(t.s!=e.s)return e.s-t.s;var i=r.cbVar.pieceTypes[t.t].value||100,a=r.cbVar.pieceTypes[e.t].value||100;return i!=a?i-a:t.p-e.p}),this.pieces.forEach(function(t,e){t.i=e,i.board[t.p]=e,r.g.pTypes[t.t].isKing&&(i.kings[t.s]=t.p),i.zSign=r.zobrist.update(i.zSign,"board",e,t.p),i.zSign=r.zobrist.update(i.zSign,"type",t.t,e)}),r.mInitial&&r.mInitial.enPassant){var a=t.geometry.PosByName(r.mInitial.enPassant);if(a>=0){var l,u=t.geometry.C(a),b=t.geometry.R(a);l=1==r.mInitial.turn?t.geometry.POS(u,b-1):t.geometry.POS(u,b+1),this.epTarget={p:a,i:this.board[l]}}}},Model.Board.CopyFrom=function(t){if(e)this.board=new Int16Array(t.board.length),this.board.set(t.board);else{this.board=[];for(var r=t.board,i=r.length,a=0;a<i;a++)this.board.push(r[a])}this.pieces=[];for(var s=t.pieces.length,a=0;a<s;a++){var n=t.pieces[a];this.pieces.push({s:n.s,p:n.p,t:n.t,i:n.i,m:n.m})}this.kings={1:t.kings[1],"-1":t.kings[-1]},this.check=t.check,t.lastMove?this.lastMove={f:t.lastMove.f,t:t.lastMove.t,c:t.lastMove.c}:this.lastMove=null,this.ending={1:t.ending[1],"-1":t.ending[-1]},void 0!==t.castled&&(this.castled={1:t.castled[1],"-1":t.castled[-1]}),this.noCaptCount=t.noCaptCount,t.epTarget?this.epTarget={p:t.epTarget.p,i:t.epTarget.i}:this.epTarget=null,this.mWho=t.mWho,this.zSign=t.zSign},Model.Board.cbApplyCastle=function(t,e,r){var i=t.cbVar.castle[e.f+"/"+e.cg],a=i.r[i.r.length-1],s=this.pieces[this.board[e.cg]],n=i.k[i.k.length-1],o=this.pieces[this.board[e.f]];return r&&(this.zSign=t.zobrist.update(this.zSign,"board",s.i,e.cg),this.zSign=t.zobrist.update(this.zSign,"board",s.i,a),this.zSign=t.zobrist.update(this.zSign,"board",o.i,e.f),this.zSign=t.zobrist.update(this.zSign,"board",o.i,n)),s.p=a,s.m=!0,this.board[e.cg]=-1,o.p=n,o.m=!0,this.board[e.f]=-1,this.board[a]=s.i,this.board[n]=o.i,this.castled[s.s]=!0,this.kings[o.s]=n,[{i:s.i,f:a,t:-1},{i:o.i,f:n,t:e.f,kp:e.f,who:o.s,m:!1},{i:s.i,f:-1,t:e.cg,m:!1,cg:!1}]},Model.Board.cbQuickApply=function(t,e){if(void 0!==e.cg)return this.cbApplyCastle(t,e,!1);var r=[],i=this.board[e.f],a=this.pieces[i];if(null!=e.c){r.unshift({i:e.c,f:-1,t:this.pieces[e.c].p});var s=this.pieces[e.c];this.board[s.p]=-1,s.p=-1}var n=this.kings[a.s];return t.g.pTypes[a.t].isKing&&(this.kings[a.s]=e.t),r.unshift({i:i,f:e.t,t:e.f,kp:n,who:a.s,ty:a.t}),a.p=e.t,void 0!==e.pr&&(a.t=e.pr),this.board[e.f]=-1,this.board[e.t]=i,r},Model.Board.cbQuickUnapply=function(t,e){for(var r=0;r<e.length;r++){var i=e[r],a=this.pieces[i.i];i.f>=0&&(a.p=-1,this.board[i.f]=-1),i.t>=0&&(a.p=i.t,this.board[i.t]=i.i),void 0!==i.m&&(a.m=i.m),void 0!==i.kp&&(this.kings[i.who]=i.kp),void 0!=i.ty&&(a.t=i.ty),void 0!=i.cg&&(this.castled[a.s]=i.cg)}},Model.Board.ApplyMove=function(t,e){var r=this.pieces[this.board[e.f]];if(void 0!==e.cg)this.cbApplyCastle(t,e,!0);else{if(this.zSign=t.zobrist.update(this.zSign,"board",r.i,e.f),this.board[r.p]=-1,void 0!==e.pr&&(this.zSign=t.zobrist.update(this.zSign,"type",r.t,r.i),r.t=e.pr,this.zSign=t.zobrist.update(this.zSign,"type",r.t,r.i)),null!=e.c){var i=this.pieces[e.c];this.zSign=t.zobrist.update(this.zSign,"board",i.i,i.p),this.board[i.p]=-1,i.p=-1,i.m=!0,this.noCaptCount=0}else this.noCaptCount++;r.p=e.t,r.m=!0,this.board[e.t]=r.i,this.zSign=t.zobrist.update(this.zSign,"board",r.i,e.t),t.g.pTypes[r.t].isKing&&(this.kings[r.s]=e.t)}this.check=!!e.ck,this.lastMove={f:e.f,t:e.t,c:e.c},void 0!==e.ko&&(this.ending[r.s]=e.ko),void 0!==e.ept?this.epTarget={p:e.ept,i:r.i}:this.epTarget=null,this.zSign=t.zobrist.update(this.zSign,"who",-this.mWho),this.zSign=t.zobrist.update(this.zSign,"who",this.mWho)},Model.Board.Evaluate=function(r){function i(e){var r=1/0;for(var i in t.geometry.corners)r=Math.min(r,h.distGraph[s.kings[e]][i]);return r-Math.sqrt(h.boardSize)}var a="debug"==arguments[3],s=this;this.mEvaluation=0;var n,o=this.mWho,h=r.g;if(e)n={1:{count:new Uint8Array(h.pTypes.length),byType:{}},"-1":{count:new Uint8Array(h.pTypes.length),byType:{}}};else{n={1:{count:[],byType:{}},"-1":{count:[],byType:{}}};for(var c=0;c<h.pTypes.length;c++)n[1].count[c]=n[-1].count[c]=0}if(r.mOptions.preventRepeat&&r.GetRepeatOccurence(this)>2)return this.mFinished=!0,void(this.mWinner=r.cbOnPerpetual?o*r.cbOnPerpetual:JocGame.DRAW);for(var p={1:0,"-1":0},l={1:h.distGraph[this.kings[-1]],"-1":h.distGraph[this.kings[1]]},u={1:0,"-1":0},b={1:0,"-1":0},v={1:0,"-1":0},f={1:0,"-1":0},d={1:!1,"-1":!1},g=this.pieces,m=g.length,c=0;c<m;c++){var G=g[c];if(G.p>=0){var M=G.s,y=h.pTypes[G.t];y.isKing?d[M]=G.m:p[M]+=y.value,y.castle&&!G.m&&f[M]++,b[M]++,u[M]+=l[M][G.p],v[M]+=t.geometry.distEdge[G.p];var k=n[M];k.count[G.t]++;var C=k.byType;void 0===C[G.t]?C[G.t]=[G]:C[G.t].push(G)}}if(this.lastMove&&null!=this.lastMove.c){var G=this.pieces[this.board[this.lastMove.t]];p[-G.s]+=this.cbStaticExchangeEval(r,G.p,G.s,{piece:G})}var S={1:0,"-1":0},A={1:0,"-1":0},T={1:0,"-1":0};this.ending[1]&&(A[1]=(u[1]-Math.sqrt(h.boardSize))/b[1],t.geometry.corners&&(T[1]=i(1))),this.ending[-1]&&(A[-1]=(u[-1]-Math.sqrt(h.boardSize))/b[-1],t.geometry.corners&&(T[1]=i(-1)));var z={pieceValue:p[1]-p[-1],pieceValueRatio:(p[1]-p[-1])/(p[1]+p[-1]+1),posValue:v[1]-v[-1],averageDistKing:u[1]/b[1]-u[-1]/b[-1],check:this.check?-o:0,endingKingFreedom:S[1]-S[-1],endingDistKing:A[1]-A[-1],distKingCorner:T[1]-T[-1]};t.castle&&(z.castle=(this.castled[1]?1:d[1]?0:f[1]/(h.castleablePiecesCount[1]+1))-(this.castled[-1]?1:d[-1]?0:f[-1]/(h.castleablePiecesCount[-1]+1))),t.evaluate&&t.evaluate.call(this,r,z,n);var E=r.mOptions.levelOptions;for(var P in z){var w=z[P],R=E[P+"Factor"]||0,I=w*R;a&&console.log(P,"=",w,"*",R,"=>",I),this.mEvaluation+=I}a&&console.log("Evaluation",this.mEvaluation)},Model.Board.cbGeneratePseudoLegalMoves=function(t){function e(e,a){var s=t.cbVar.promote;if(!s)return void i.push(a);var n=s.call(r,t,e,a);if(null!=n)if(0==n.length)i.push(a);else if(1==n.length)a.pr=n[0],i.push(a);else for(var o=0;o<n.length;o++){var h=n[o];i.push({f:a.f,t:a.t,c:a.c,pr:h,ept:a.ept,ep:a.ep,a:a.a})}}for(var r=this,i=[],a=t.cbVar,s=this.mWho,n=!a.castle||this.check||this.castled[s]?null:[],o=-1,h=this.pieces.length,c=0;c<h;c++){var p=this.pieces[c];if(!(p.p<0||p.s!=s)){var l=t.g.pTypes[p.t];l.isKing&&(p.m?n=null:o=p),n&&l.castle&&!p.m&&n.push(p);var u,b;u=l.graph[p.p],b=u.length;for(var v=0;v<b;v++)for(var f=u[v],d=!1,g=f.length,m=null,G=0;G<g;G++){var M=f[G],y=65535&M,k=this.board[y];if(!(k<0)||l.epCatch&&this.epTarget&&this.epTarget.p==y){if(!(524288&M)){var C;C=k<0?this.pieces[this.epTarget.i]:this.pieces[k],!(C.s!=p.s&&131072&M)||1048576&M&&!t.g.pTypes[C.t].isKing||2097152&M&&t.g.pTypes[C.t].isKing||e(p,{f:p.p,t:y,c:C.i,a:l.abbrev,ep:k<0});break}if(d){var C=this.pieces[k];C.s!=p.s&&e(p,{f:p.p,t:y,c:C.i,a:l.abbrev});break}d=!0}else 65536&M&&0==d&&e(p,{f:p.p,t:y,c:null,a:l.abbrev,ept:null!=m&&l.epTarget?m:void 0});m=y}}}if(n)for(var c=0;c<n.length;c++){var S=n[c],A=t.cbVar.castle[o.p+"/"+S.p];if(A){for(var T=!0,v=0;v<A.r.length;v++){var z=A.r[v];if(this.board[z]>=0&&z!=o.p&&z!=S.p){T=!1;break}}if(T){for(var E=!0,v=0;v<A.k.length;v++){var z=A.k[v];if(this.board[z]>=0&&z!=S.p&&z!=o.p||this.cbGetAttackers(t,z,s).length>0){E=!1;break}}E&&i.push({f:o.p,t:A.k[A.k.length-1],c:null,cg:S.p})}}}return i},Model.Board.cbStaticExchangeEval=function(t,e,r,i){var a=0,s=this.cbGetSmallestAttacker(t,e,r);if(s){var n=this.mWho;this.mWho=s.s;var o=this.cbQuickApply(t,{f:s.p,t:e,c:i.piece.i}),h=t.g.pTypes[i.piece.t].value;i.piece=s,a=Math.max(0,h-this.cbStaticExchangeEval(t,e,-r,i)),this.cbQuickUnapply(t,o),this.mWho=n}return a},Model.Board.cbGetSmallestAttacker=function(t,e,r){var i=this.cbGetAttackers(t,e,r);if(0==i.length)return null;for(var a=1/0,s=null,n=i.length,o=0;o<n;o++){var h=i[o],c=t.g.pTypes[h.t].value;c<a&&(a=c,s=h)}return s},Model.Board.cbCollectAttackers=function(t,e,r,i){for(var a in e){var s=e[a],n=this.board[a];if(n<0)this.cbCollectAttackers(t,s.e,r,i);else{var o=this.pieces[n];o.s==-t&&(s.t&&o.t in s.t||i&&s.tk&&o.t in s.tk)&&r.push(o)}}},Model.Board.cbCollectAttackersScreen=function(t,e,r,i,a){for(var s in e){var n=e[s],o=this.board[s];if(o<0)this.cbCollectAttackersScreen(t,n.e,r,i,a);else{var h=this.pieces[o];!a&&h.s==-t&&(n.t&&h.t in n.t||i&&n.tk&&h.t in n.tk)?r.push(h):a?a&&h.s==-t&&n.ts&&h.t in n.ts&&r.push(h):this.cbCollectAttackersScreen(t,n.e,r,i,!0)}}},Model.Board.cbGetAttackers=function(t,e,r,i){var a=[];return t.cbUseScreenCapture?this.cbCollectAttackersScreen(r,t.g.threatGraph[r][e],a,i,!1):this.cbCollectAttackers(r,t.g.threatGraph[r][e],a,i),a},Model.Board.GenerateMoves=function(t){var e=this.cbGeneratePseudoLegalMoves(t);this.mMoves=[];for(var r=!0,i=this.kings[this.mWho],a=e.length,s=0;s<a;s++){var n=e[s],o=this.cbQuickApply(t,n);if(!(this.cbGetAttackers(t,this.kings[this.mWho],this.mWho,!0).length>0)){var h=this.cbGetAttackers(t,this.kings[-this.mWho],-this.mWho,!0).length>0;n.ck=h,this.mMoves.push(n),n.f!=i&&(r=!1)}this.cbQuickUnapply(t,o)}if(0==this.mMoves.length)this.mFinished=!0,this.mWinner=t.cbOnStaleMate?t.cbOnStaleMate*this.mWho:JocGame.DRAW,this.check&&(this.mWinner=-this.mWho);else if(this.ending[this.mWho]){if(!r)for(var s=0;s<this.mMoves.length;s++)this.mMoves[s].ko=!1}else if(!this.ending[this.mWho]&&r&&!this.check)for(var s=0;s<this.mMoves.length;s++)this.mMoves[s].ko=!0},Model.Board.GetSignature=function(){return this.zSign},Model.Move.Init=function(t){for(var e in t)t.hasOwnProperty(e)&&(this[e]=t[e])},Model.Move.Equals=function(t){return this.f==t.f&&this.t==t.t&&this.pr==t.pr},Model.Move.CopyFrom=function(t){this.Init(t)},Model.Move.ToString=function(e){var r=this;switch(e=e||"natural"){case"natural":return function(){var e;if(void 0!==r.cg?e=t.castle[r.f+"/"+r.cg].n:(e=r.a||"",e+=t.geometry.PosName(r.f),null==r.c?e+="-":e+="x",e+=t.geometry.PosName(r.t)),void 0!==r.pr){var i=t.pieceTypes[r.pr];i&&i.abbrev&&i.abbrev.length>0&&!i.silentPromo&&(e+="="+i.abbrev)}return r.ck&&(e+="+"),e}();case"engine":return function(){var e=t.geometry.PosName(r.f)+t.geometry.PosName(r.t);if(void 0!=r.pr){var i=t.pieceTypes[r.pr];i&&i.abbrev&&i.abbrev.length>0&&!i.silentPromo&&(e+=i.abbrev)}return e}();default:return"??"}},Model.Board.CompactMoveString=function(e,r,i){"function"!=typeof r.ToString&&(r=e.CreateMove(r));var a=r.ToString(),s=/^([A-Z]?)([a-z])([1-9][0-9]*)([-x])([a-z])([1-9][0-9]*)(.*?)$/.exec(a);if(!s)return a;var n=s[7];if(i||(i={}),i.value||(i.value=[]),0==i.value.length){var o=this.mMoves;this.mMoves&&0!=this.mMoves.length||this.GenerateMoves(e);for(var h=0;h<this.mMoves.length;h++){var c=this.mMoves[h];"function"!=typeof c.ToString&&(c=e.CreateMove(c)),i.value.push({str:c.ToString(),move:c})}this.mMoves=o}var p=[];if(i.value.forEach(function(t){var e=/^([A-Z]?[a-z][1-9][0-9]*[-x][a-z][1-9][0-9]*)(.*?)$/.exec(t.str);e&&t.move.t==r.t&&(t.move.a||"")==s[1]&&e[2]==n&&p.push(t.move)}),1==p.length)return""==s[1]&&"x"==s[4]?s[2]+"x"+s[5]+s[6]+s[7]:s[1]+("x"==s[4]?"x":"")+s[5]+s[6]+s[7];if(t.geometry.CompactCrit)for(var l="",h=0;;h++){var u=t.geometry.CompactCrit(r.f,h);if(null==u)return a;l+=u;for(var b=[],v=0;v<p.length;v++){var f=p[v];t.geometry.CompactCrit(f.f,h)==u&&b.push(f)}if(console.assert(b.length>0),1==b.length)return s[1]+l+("x"==s[4]?"x":"")+s[5]+s[6]+s[7];p=b}return a},Model.Board.cbIntegrity=function(t){function e(t,e){t||console.error(e)}for(var r=this,i=0;i<this.board.length;i++){var a=this.board[i];if(a>=0){var s=r.pieces[a];e(void 0!==s,"no piece at pos"),e(s.p==i,"piece has different pos")}}for(var a=0;a<this.pieces.length;a++){var s=this.pieces[a];s.p>=0&&e(r.board[s.p]==a,"board index mismatch")}},Model.Board.ExportBoardState=function(t){return t.cbVar.geometry.ExportBoardState?t.cbVar.geometry.ExportBoardState(this,t.cbVar,t.mPlayedMoves.length):"not supported"},Model.Game.Import=function(e,r){var i,a=[],s={1:{},"-1":{}},n=null,o=0;if("pjn"==e){var h={status:!1,error:"parse"},c=r.split(" ");if(6!=c.length)return console.warn("FEN should have 6 parts"),h;var p=c[0].split("/"),l=t.geometry.fenHeight||t.geometry.height;if(p.length!=l)return console.warn("FEN board should have",l,"rows, got",p.length),h;var u={};for(var b in t.pieceTypes){var v=t.pieceTypes[b],f=v.fenAbbrev||v.abbrev||"X";u[f.toUpperCase()]={s:1,t:b},u[f.toLowerCase()]={s:-1,t:b}}var d=t.geometry.FenRowPos||function(e,r){return(t.geometry.height-1-e)*t.geometry.width+r};if(p.forEach(function(e,r){for(var i=0,s=0;s<e.length;s++){var n=e.substr(s,1),o=u[n];if(void 0!==o){var c=d(r,i);i++;for(var p={s:o.s,t:o.t,p:c},l=!0,b=t.pieceTypes[p.t].initial||[],v=0;v<b.length;v++){var f=b[v];f.s==p.s&&f.p==c&&(l=!1)}p.m=l,a.push(p)}else{if(isNaN(parseInt(n)))return console.warn("FEN invalid board spec",n),h;i+=parseInt(n)}}}),a.sort(function(t,e){return e.s-t.s}),"w"==c[1])i=1;else{if("b"!=c[1])return console.warn("FEN invalid turn spec",c[1]),h;i=-1}s[1].k=c[2].indexOf("K")>=0,s[1].q=c[2].indexOf("Q")>=0,s[-1].k=c[2].indexOf("k")>=0,s[-1].q=c[2].indexOf("q")>=0,n="-"==c[3]?null:c[3];var g=parseInt(c[4]);isNaN(g)||(o=g);var m={pieces:a,turn:i,castle:s,enPassant:n,noCaptCount:o};return t.importGame&&t.importGame.call(this,m,e,r),{status:!0,initial:m}}return{status:!1,error:"unsupported"}}}(),function(){Model.Game.cbBoardGeometryGrid=function(t,e){function r(e){return e%t}function i(e){return Math.floor(e/t)}function a(e,r){return r*t+e}function s(s,n){var o=r(s),h=i(s),c=o+n[0],p=h+n[1];return c<0||c>=t||p<0||p>=e?null:a(c,p)}function n(t){return String.fromCharCode("a".charCodeAt(0)+r(t))+(i(t)+1)}function o(t){var e=/^([a-z])([0-9]+)$/.exec(t);return e?a(e[1].charCodeAt(0)-"a".charCodeAt(0),parseInt(e[2])-1):-1}function h(t,e){return 0==e?String.fromCharCode("a".charCodeAt(0)+r(t)):1==e?i(t)+1:null}function c(){for(var a=[],s=0;s<t*e;s++){var n=[];a.push(n);for(var o=0;o<t*e;o++){var h=i(s),c=r(s),p=i(o),l=r(o);n.push(Math.max(Math.abs(h-p),Math.abs(c-l)))}}return a}function p(r,i,s){for(var o=[],h=e-1;h>=0;h--){for(var c="",p=0,l=0;l<t;l++){var u=r.board[a(l,h)];if(u<0)p++;else{p>0&&(c+=p,p=0);var b=r.pieces[u],v=i.pieceTypes[b.t].fenAbbrev||i.pieceTypes[b.t].abbrev||"?";b.s==-1?c+=v.toLowerCase():c+=v.toUpperCase()}}p&&(c+=p),o.push(c)}var f=o.join("/");f+=" ",1==r.mWho?f+="w":f+="b",f+=" ";var d="";return r.castled&&(r.castled[1]===!1?d+="KQ":(r.castled[1].k&&(d+="K"),r.castled[1].q&&(d+="Q")),r.castled[-1]===!1?d+="kq":(r.castled[-1].k&&(d+="k"),r.castled[-1].q&&(d+="q"))),0==d.length&&(d="-"),f+=d,f+=" ",r.epTarget?f+=n(r.epTarget.p):f+="-",f+=" ",f+=r.noCaptCount,f+=" ",f+=Math.floor(s/2)+1}return{boardSize:t*e,width:t,height:e,C:r,R:i,POS:a,Graph:s,PosName:n,PosByName:o,CompactCrit:h,GetDistances:c,distEdge:function(){for(var a=[],s=0;s<t*e;s++){var n=r(s),o=i(s);a[s]=Math.min(n,Math.abs(t-n-1),o,Math.abs(e-o-1))}return a}(),corners:function(){var r={};return r[a(0,0)]=1,r[a(0,e-1)]=1,r[a(t-1,0)]=1,r[a(t-1,e-1)]=1,r}(),ExportBoardState:p}},Model.Game.cbPawnGraph=function(t,e,r){for(var i=this,a={},s=0;s<t.boardSize;s++)if(!r||s in r){var n=[],o=t.Graph(s,[0,e]);null!=o&&(!r||o in r)&&n.push(i.cbTypedArray([o|i.cbConstants.FLAG_MOVE])),[-1,1].forEach(function(a){var o=t.Graph(s,[a,e]);null!=o&&(!r||o in r)&&n.push(i.cbTypedArray([o|i.cbConstants.FLAG_CAPTURE]))}),a[s]=n}else a[s]=[];return a},Model.Game.cbInitialPawnGraph=function(t,e,r){for(var i=this,a={},s=0;s<t.boardSize;s++)if(!r||s in r){var n=[],o=t.Graph(s,[0,e]);if(null!=o&&(!r||o in r)){var h=[o|i.cbConstants.FLAG_MOVE],c=t.Graph(o,[0,e]);null!=c&&(!r||c in r)&&h.push(c|i.cbConstants.FLAG_MOVE),n.push(i.cbTypedArray(h))}[-1,1].forEach(function(a){var o=t.Graph(s,[a,e]);null!=o&&(!r||o in r)&&n.push(i.cbTypedArray([o|i.cbConstants.FLAG_CAPTURE]))}),a[s]=n}else a[s]=[];return a},Model.Game.cbKingGraph=function(t,e){return this.cbShortRangeGraph(t,[[-1,-1],[-1,0],[-1,1],[0,-1],[0,1],[1,-1],[1,0],[1,1]],e)},Model.Game.cbKnightGraph=function(t,e){return this.cbShortRangeGraph(t,[[2,-1],[2,1],[-2,-1],[-2,1],[-1,2],[-1,-2],[1,2],[1,-2]],e)},Model.Game.cbHorseGraph=function(t){for(var e=this,r={},i=0;i<t.boardSize;i++)r[i]=[],[[1,0,2,-1],[1,0,2,1],[-1,0,-2,-1],[-1,0,-2,1],[0,1,-1,2],[0,-1,-1,-2],[0,1,1,2],[0,-1,1,-2]].forEach(function(a){var s=t.Graph(i,[a[0],a[1]]);if(null!=s){var n=t.Graph(i,[a[2],a[3]]);null!=n&&r[i].push(e.cbTypedArray([s|e.cbConstants.FLAG_STOP,n|e.cbConstants.FLAG_MOVE|e.cbConstants.FLAG_CAPTURE]))}});return r},Model.Game.cbRookGraph=function(t,e){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0]],e)},Model.Game.cbBishopGraph=function(t,e){return this.cbLongRangeGraph(t,[[1,-1],[1,1],[-1,1],[-1,-1]],e)},Model.Game.cbQueenGraph=function(t,e){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0],[1,-1],[1,1],[-1,1],[-1,-1]],e)},Model.Game.cbXQGeneralGraph=function(t,e){for(var r=this,i={},a=0;a<t.boardSize;a++)i[a]=[],[[-1,0,!1],[0,-1,!0],[0,1,!0],[1,0,!1]].forEach(function(s){var n=[],o=t.Graph(a,s);if(null!=o&&((!e||o in e)&&n.push(o|r.cbConstants.FLAG_MOVE|r.cbConstants.FLAG_CAPTURE),s[2]))for(var h=t.Graph(o,s);null!=h;)!e||h in e?n.push(h|r.cbConstants.FLAG_CAPTURE|r.cbConstants.FLAG_CAPTURE_KING):n.push(h|r.cbConstants.FLAG_STOP),h=t.Graph(h,s);n.length>0&&i[a].push(r.cbTypedArray(n))});return i},Model.Game.cbXQSoldierGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e]])},Model.Game.cbXQPromoSoldierGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e],[-1,0],[1,0]])},Model.Game.cbXQAdvisorGraph=function(t,e){return this.cbShortRangeGraph(t,[[1,1],[-1,1],[1,-1],[-1,-1]],e)},Model.Game.cbXQCannonGraph=function(t){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0]],null,this.cbConstants.FLAG_MOVE|this.cbConstants.FLAG_SCREEN_CAPTURE)},Model.Game.cbXQElephantGraph=function(t,e){for(var r=this,i={},a=0;a<t.boardSize;a++)i[a]=[],(!e||a in e)&&[[1,1,2,2],[1,-1,2,-2],[-1,1,-2,2],[-1,-1,-2,-2]].forEach(function(s){var n=t.Graph(a,[s[0],s[1]]);if(null!=n){var o=t.Graph(a,[s[2],s[3]]);null!=o&&(!e||o in e)&&i[a].push(r.cbTypedArray([n|r.cbConstants.FLAG_STOP,o|r.cbConstants.FLAG_MOVE|r.cbConstants.FLAG_CAPTURE]))}});return i},Model.Game.cbSilverGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e],[-1,-1],[-1,1],[1,-1],[1,1]])},Model.Game.cbFersGraph=function(t,e){return this.cbShortRangeGraph(t,[[-1,-1],[-1,1],[1,-1],[1,1]])},Model.Game.cbSchleichGraph=function(t,e){return this.cbShortRangeGraph(t,[[-1,0],[1,0],[0,-1],[0,1]])},Model.Game.cbAlfilGraph=function(t,e){return this.cbShortRangeGraph(t,[[-2,-2],[-2,2],[2,2],[2,-2]])}}(),function(){function t(t,r){return t.cbMergeGraphs(e,t.cbLongRangeGraph(e,[[0,r]],null,t.cbConstants.FLAG_MOVE,3),t.cbShortRangeGraph(e,[[-1,r],[1,r]],null,t.cbConstants.FLAG_CAPTURE))}var e=Model.Game.cbBoardGeometryGrid(11,10);Model.Game.cbDefine=function(){return{geometry:e,pieceTypes:{0:{name:"pawn-w",aspect:"fr-pawn",graph:this.cbPawnGraph(e,1),value:1,abbrev:"",fenAbbrev:"P",epCatch:!0},1:{name:"ipawn-w",aspect:"fr-pawn",graph:this.cbInitialPawnGraph(e,1),value:1,abbrev:"",fenAbbrev:"P",epTarget:!0},2:{name:"pawn-b",aspect:"fr-pawn",graph:this.cbPawnGraph(e,-1),value:1,abbrev:"",fenAbbrev:"P",epCatch:!0},3:{name:"ipawn-b",aspect:"fr-pawn",graph:this.cbInitialPawnGraph(e,-1),value:1,abbrev:"",fenAbbrev:"P",epTarget:!0},4:{name:"knight",aspect:"fr-knight",graph:this.cbKnightGraph(e),value:2.4,abbrev:"N",initial:[{s:1,p:1},{s:1,p:9},{s:-1,p:100},{s:-1,p:108}]},5:{name:"bishop",aspect:"fr-bishop",graph:this.cbBishopGraph(e),value:3.3,abbrev:"B",initial:[{s:1,p:2},{s:1,p:3},{s:-1,p:106},{s:-1,p:107}]},6:{name:"rook",aspect:"fr-rook",graph:this.cbRookGraph(e),value:5,abbrev:"R",initial:[{s:1,p:0},{s:1,p:10},{s:-1,p:99},{s:-1,p:109}],castle:!0},7:{name:"queen",aspect:"fr-queen",graph:this.cbQueenGraph(e),value:8.2,abbrev:"Q",initial:[{s:1,p:4},{s:-1,p:105}]},8:{name:"king",aspect:"fr-king",isKing:!0,graph:this.cbKingGraph(e),abbrev:"K",initial:[{s:1,p:5},{s:-1,p:104}]},9:{name:"camel",aspect:"fr-camel",graph:this.cbShortRangeGraph(e,[[-3,-1],[-3,1],[3,-1],[3,1],[1,3],[1,-3],[-1,3],[-1,-3]]),value:2.1,abbrev:"M",initial:[{s:1,p:7},{s:1,p:8},{s:-1,p:101},{s:-1,p:102}]},10:{name:"wildebeest",aspect:"fr-dragon",graph:this.cbShortRangeGraph(e,[[-3,-1],[-3,1],[3,-1],[3,1],[1,3],[1,-3],[-1,3],[-1,-3],[-2,-1],[-2,1],[2,-1],[2,1],[1,2],[1,-2],[-1,2],[-1,-2]]),value:4.7,abbrev:"W",initial:[{s:1,p:6},{s:-1,p:103}]},11:{name:"iipawn-w",aspect:"fr-pawn",graph:t(this,1),value:1,abbrev:"",fenAbbrev:"P",initial:[{s:1,p:11},{s:1,p:12},{s:1,p:13},{s:1,p:14},{s:1,p:15},{s:1,p:16},{s:1,p:17},{s:1,p:18},{s:1,p:19},{s:1,p:20},{s:1,p:21}],epTarget:!0},12:{name:"iipawn-b",aspect:"fr-pawn",graph:t(this,-1),value:1,abbrev:"",fenAbbrev:"P",initial:[{s:-1,p:88},{s:-1,p:89},{s:-1,p:90},{s:-1,p:91},{s:-1,p:92},{s:-1,p:93},{s:-1,p:94},{s:-1,p:95},{s:-1,p:96},{s:-1,p:97},{s:-1,p:98}],epTarget:!0}},promote:function(t,r,i){if(11==r.t||12==r.t){return 1==Math.abs(e.R(i.t)-e.R(i.f))?[11==r.t?1:3]:[11==r.t?0:2]}return 1==r.t?[0]:3==r.t?[2]:0==r.t&&9==e.R(i.t)?[7,10]:2==r.t&&0==e.R(i.t)?[7,10]:[]},castle:{"5/0":{k:[4],r:[1,2,3,4,5],n:"O-O-O"},"5/10":{k:[6],r:[9,8,7,6,5],n:"O-O"},"104/99":{k:[103],r:[100,101,102,103,104],n:"O-O-O"},"104/109":{k:[105],r:[108,107,106,105,104],n:"O-O"}}}};var r={0:{k:[3,2,1],r:[4,3,2]},10:{k:[7,8,9],r:[6,7,8]},99:{k:[102,101,100],r:[103,102,101]},109:{k:[106,107,108],r:[105,106,107]}},i=Model.Board.GenerateMoves;Model.Board.GenerateMoves=function(t){if(i.apply(this,arguments),!this.castled[this.mWho])for(var e=0;e<this.mMoves.length;e++){var a=this.mMoves[e],s=r[a.cg];if(s){var n=this.board[a.f],o=this.pieces[n];this.board[a.f]=-1,this.board[s.k[0]]=n,o.p=s.k[0];var h=this.cbGetAttackers(t,o.p,this.mWho,!0).length>0;if(!h){var c=this.board[a.cg],p=this.pieces[c];this.board[a.cg]=-1,this.board[s.r[0]]=c,p.p=s.r[0];var l=this.cbGetAttackers(t,this.kings[-this.mWho],-this.mWho,!0).length>0;this.mMoves.push({f:a.f,t:s.k[0],c:null,ck:l,a:"K"}),this.board[a.f]=n,this.board[s.k[0]]=-1,this.board[a.cg]=c,this.board[s.r[0]]=-1,this.board[a.f]=-1,this.board[s.k[1]]=n,o.p=s.k[1],h=this.cbGetAttackers(t,o.p,this.mWho,!0).length>0,h||(this.board[a.cg]=-1,this.board[s.r[1]]=c,p.p=s.r[1],l=this.cbGetAttackers(t,this.kings[-this.mWho],-this.mWho,!0).length>0,this.mMoves.push({f:a.f,t:s.k[1],c:null,ck:l,a:"K"}),this.board[a.f]=-1,this.board[s.k[2]]=n,o.p=s.k[2],h=this.cbGetAttackers(t,o.p,this.mWho,!0).length>0,h||(this.board[a.cg]=-1,this.board[s.r[2]]=c,p.p=s.r[2],l=this.cbGetAttackers(t,this.kings[-this.mWho],-this.mWho,!0).length>0,this.mMoves.push({f:a.f,t:s.k[2],c:null,ck:l,a:"K"}),this.board[a.cg]=c,this.board[s.r[2]]=-1),this.board[a.f]=n,this.board[s.k[2]]=-1,this.board[a.cg]=c,this.board[s.r[1]]=-1),this.board[a.f]=n,this.board[s.k[1]]=-1,this.board[a.cg]=c,p.p=a.cg}this.board[a.f]=n,o.p=a.f}}},Model.Game.wbExtraCastleRook={1:{r0:0,r:2},2:{r0:0,r:3},3:{r0:0,r:4},7:{r0:10,r:6},8:{r0:10,r:7},9:{r0:10,r:8},100:{r0:99,r:101},101:{r0:99,r:102},102:{r0:99,r:103},105:{r0:109,r:104},106:{r0:109,r:105},107:{r0:109,r:106}};var a=Model.Board.ApplyMove;Model.Board.ApplyMove=function(t,r){if("K"==r.a&&!this.castled[this.mWho]&&void 0===r.cg){if(Math.abs(e.C(r.t)-e.C(r.f))>=2){var i=this.pieces[this.board[r.f]];this.board[r.f]=-1,this.zSign=t.zobrist.update(this.zSign,"board",i.i,r.f),this.board[r.t]=i.i,this.zSign=t.zobrist.update(this.zSign,"board",i.i,r.t),i.p=r.t,this.kings[this.mWho]=i.p;var s=t.wbExtraCastleRook[r.t],n=this.pieces[this.board[s.r0]];return this.board[s.r0]=-1,this.zSign=t.zobrist.update(this.zSign,"board",n.i,s.r0),this.board[s.r]=n.i,this.zSign=t.zobrist.update(this.zSign,"board",n.i,s.r),n.p=s.r,this.check=!!r.ck,void(this.castled[this.mWho]=!0)}}a.apply(this,arguments)}}();

/***/ }),

/***/ "r8ZY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var root_1 = __webpack_require__("VOfZ");
var Symbol = root_1.root.Symbol;
exports.rxSubscriber = (typeof Symbol === 'function' && typeof Symbol.for === 'function') ?
    Symbol.for('rxSubscriber') : '@@rxSubscriber';
/**
 * @deprecated use rxSubscriber instead
 */
exports.$$rxSubscriber = exports.rxSubscriber;
//# sourceMappingURL=rxSubscriber.js.map

/***/ }),

/***/ "rCTf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var root_1 = __webpack_require__("VOfZ");
var toSubscriber_1 = __webpack_require__("lHsB");
var observable_1 = __webpack_require__("mbVC");
/**
 * A representation of any set of values over any amount of time. This the most basic building block
 * of RxJS.
 *
 * @class Observable<T>
 */
var Observable = (function () {
    /**
     * @constructor
     * @param {Function} subscribe the function that is  called when the Observable is
     * initially subscribed to. This function is given a Subscriber, to which new values
     * can be `next`ed, or an `error` method can be called to raise an error, or
     * `complete` can be called to notify of a successful completion.
     */
    function Observable(subscribe) {
        this._isScalar = false;
        if (subscribe) {
            this._subscribe = subscribe;
        }
    }
    /**
     * Creates a new Observable, with this Observable as the source, and the passed
     * operator defined as the new observable's operator.
     * @method lift
     * @param {Operator} operator the operator defining the operation to take on the observable
     * @return {Observable} a new observable with the Operator applied
     */
    Observable.prototype.lift = function (operator) {
        var observable = new Observable();
        observable.source = this;
        observable.operator = operator;
        return observable;
    };
    Observable.prototype.subscribe = function (observerOrNext, error, complete) {
        var operator = this.operator;
        var sink = toSubscriber_1.toSubscriber(observerOrNext, error, complete);
        if (operator) {
            operator.call(sink, this.source);
        }
        else {
            sink.add(this._trySubscribe(sink));
        }
        if (sink.syncErrorThrowable) {
            sink.syncErrorThrowable = false;
            if (sink.syncErrorThrown) {
                throw sink.syncErrorValue;
            }
        }
        return sink;
    };
    Observable.prototype._trySubscribe = function (sink) {
        try {
            return this._subscribe(sink);
        }
        catch (err) {
            sink.syncErrorThrown = true;
            sink.syncErrorValue = err;
            sink.error(err);
        }
    };
    /**
     * @method forEach
     * @param {Function} next a handler for each value emitted by the observable
     * @param {PromiseConstructor} [PromiseCtor] a constructor function used to instantiate the Promise
     * @return {Promise} a promise that either resolves on observable completion or
     *  rejects with the handled error
     */
    Observable.prototype.forEach = function (next, PromiseCtor) {
        var _this = this;
        if (!PromiseCtor) {
            if (root_1.root.Rx && root_1.root.Rx.config && root_1.root.Rx.config.Promise) {
                PromiseCtor = root_1.root.Rx.config.Promise;
            }
            else if (root_1.root.Promise) {
                PromiseCtor = root_1.root.Promise;
            }
        }
        if (!PromiseCtor) {
            throw new Error('no Promise impl found');
        }
        return new PromiseCtor(function (resolve, reject) {
            // Must be declared in a separate statement to avoid a RefernceError when
            // accessing subscription below in the closure due to Temporal Dead Zone.
            var subscription;
            subscription = _this.subscribe(function (value) {
                if (subscription) {
                    // if there is a subscription, then we can surmise
                    // the next handling is asynchronous. Any errors thrown
                    // need to be rejected explicitly and unsubscribe must be
                    // called manually
                    try {
                        next(value);
                    }
                    catch (err) {
                        reject(err);
                        subscription.unsubscribe();
                    }
                }
                else {
                    // if there is NO subscription, then we're getting a nexted
                    // value synchronously during subscription. We can just call it.
                    // If it errors, Observable's `subscribe` will ensure the
                    // unsubscription logic is called, then synchronously rethrow the error.
                    // After that, Promise will trap the error and send it
                    // down the rejection path.
                    next(value);
                }
            }, reject, resolve);
        });
    };
    Observable.prototype._subscribe = function (subscriber) {
        return this.source.subscribe(subscriber);
    };
    /**
     * An interop point defined by the es7-observable spec https://github.com/zenparsing/es-observable
     * @method Symbol.observable
     * @return {Observable} this instance of the observable
     */
    Observable.prototype[observable_1.observable] = function () {
        return this;
    };
    // HACK: Since TypeScript inherits static properties too, we have to
    // fight against TypeScript here so Subject can have a different static create signature
    /**
     * Creates a new cold Observable by calling the Observable constructor
     * @static true
     * @owner Observable
     * @method create
     * @param {Function} subscribe? the subscriber function to be passed to the Observable constructor
     * @return {Observable} a new cold observable
     */
    Observable.create = function (subscribe) {
        return new Observable(subscribe);
    };
    return Observable;
}());
exports.Observable = Observable;
//# sourceMappingURL=Observable.js.map

/***/ }),

/***/ "rIRK":
/***/ (function(module, exports) {

exports.model=Model={Game:{},Board:{},Move:{}},function(){var t;Model.Game.cbConstants={MASK:65535,FLAG_MOVE:65536,FLAG_CAPTURE:131072,FLAG_STOP:262144,FLAG_SCREEN_CAPTURE:524288,FLAG_CAPTURE_KING:1048576,FLAG_CAPTURE_NO_KING:2097152};var e="undefined"!=typeof Int32Array;Model.Game.cbUseTypedArrays=e,Model.Game.cbTypedArray=function(t){if(e){var r=new Int32Array(t.length);return r.set(t),r}for(var i=[],a=t.length,s=0;s<a;s++)i.push(t[s]);return i},Model.Game.cbShortRangeGraph=function(t,e,r,i){var a=this;void 0===i&&(i=196608);for(var s={},n=0;n<t.boardSize;n++)s[n]=[],(!r||n in r)&&e.forEach(function(e){var o=t.Graph(n,e);null!=o&&(!r||o in r)&&s[n].push(a.cbTypedArray([o|i]))});return s},Model.Game.cbLongRangeGraph=function(t,e,r,i,a){var s=this;void 0!==i&&null!=i||(i=196608),a||(a=1/0);for(var n={},o=0;o<t.boardSize;o++)n[o]=[],(!r||o in r)&&e.forEach(function(e){for(var h=[],c=t.Graph(o,e),p=0;null!=c&&(!r||c in r)&&(h.push(c|i),++p!=a);)c=t.Graph(c,e);h.length>0&&n[o].push(s.cbTypedArray(h))});return n},Model.Game.cbNullGraph=function(t){for(var e={},r=0;r<t.boardSize;r++)e[r]=[];return e},Model.Game.cbAuthorGraph=function(t){for(var e={},r=0;r<t.boardSize;r++){e[r]=[];for(var i=0;i<t.boardSize;i++)e[r].push([2293760|i])}return e},Model.Game.cbMergeGraphs=function(t){for(var e=[],r=0;r<t.boardSize;r++){e[r]=[];for(var i=1;i<arguments.length;i++)e[r]=e[r].concat(arguments[i][r])}return e},Model.Game.cbGetThreatGraph=function(){function t(e,r){for(var i in n){var a=n[i];if(!(a.p.length<r.length+1)){for(var s=!0,o=0;o<r.length;o++)if(r[o]!=a.p[o]){s=!1;break}if(s){var h=a.p[r.length],c=e[h];void 0===c&&(c={e:{}},e[h]=c),a.p.length==r.length+1&&(c.t=a.t,c.ts=a.ts,c.tk=a.tk,delete n[i]),r.push(h),t(c.e,r),r.pop()}}}}var e=this;this.cbUseScreenCapture=!1,this.cbUseCaptureKing=!1,this.cbUseCaptureNoKing=!1;for(var r={1:[],"-1":[]},i=[],a=0;a<this.g.boardSize;a++)this.g.pTypes.forEach(function(t,r){t.graph[a].forEach(function(t){for(var s=[],n=0;n<t.length;n++){var o=t[n];1048576&o?(e.cbUseCaptureKing=!0,s.unshift({d:65535&o,a:a,tk:r})):2097152&o?(e.cbUseCaptureNoKing=!0,s.unshift({d:65535&o,a:a,tnk:r})):131072&o?s.unshift({d:65535&o,a:a,t:r}):262144&o?s.unshift({d:65535&o,a:a}):524288&o&&(e.cbUseScreenCapture=!0,s.unshift({d:65535&o,a:a,ts:r}))}s.length>0&&i.push(s)})});var s={};i.forEach(function(t){t.forEach(function(e,r){var i=s[e.d];void 0===i&&(i={},s[e.d]=i);for(var a=[],n=r+1;n<t.length;n++)a.push(t[n].d);a.push(e.a);var o=a.join(","),h=i[o];void 0===h&&(h={p:a,t:{},ts:{},tk:{}},i[o]=h),void 0!==e.t?h.t[e.t]=!0:void 0!==e.tk?h.tk[e.tk]=!0:void 0!==e.ts&&(h.ts[e.ts]=!0)})});for(var a=0;a<e.g.boardSize;a++){var n=s[a],o={};t(o,[]),r[1][a]=o,r[-1][a]=o}return r},Model.Game.InitGame=function(){var e=this;this.cbVar=t=this.cbDefine(),this.g.boardSize=this.cbVar.geometry.boardSize,this.g.pTypes=this.cbGetPieceTypes(),this.g.threatGraph=this.cbGetThreatGraph(),this.g.distGraph=this.cbVar.geometry.GetDistances(),this.cbPiecesCount=0,this.g.castleablePiecesCount={1:0,"-1":0};for(var r in t.pieceTypes){var i=t.pieceTypes[r];if(i.castle){(i.initial||[]).forEach(function(t){e.g.castleablePiecesCount[t.s]++})}i.initial&&(this.cbPiecesCount+=i.initial.length)}for(var a=[],r=0;r<this.cbPiecesCount;r++)a.push(r);var s=Object.keys(t.pieceTypes);this.zobrist=new JocGame.Zobrist({board:{type:"array",size:this.cbVar.geometry.boardSize,values:a},who:{values:["1","-1"]},type:{type:"array",size:this.cbPiecesCount,values:s}})},Model.Game.cbGetPieceTypes=function(){for(var t=[],e={},r=0;r<this.cbVar.geometry.boardSize;r++)e[r]=[];for(var i in this.cbVar.pieceTypes){var a=this.cbVar.pieceTypes[i];t[i]={graph:a.graph||e,abbrev:a.abbrev||"",value:a.isKing?100:a.value||1,isKing:!!a.isKing,castle:!!a.castle,epTarget:!!a.epTarget,epCatch:!!a.epCatch}}return t},Model.Board.Init=function(t){this.zSign=0},Model.Board.InitialPosition=function(r){var i=this;this.board=e?new Int16Array(r.g.boardSize):[];for(var a=0;a<r.g.boardSize;a++)this.board[a]=-1;if(this.kings={},this.pieces=[],this.ending={1:!1,"-1":!1},this.lastMove=null,r.cbVar.castle&&(this.castled={1:!1,"-1":!1}),this.zSign=r.zobrist.update(0,"who",-1),this.noCaptCount=0,this.mWho=1,r.mInitial)this.mWho=r.mInitial.turn||1,r.mInitial.pieces.forEach(function(t){var e={};for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);i.pieces.push(e)}),r.mInitial.lastMove&&(this.lastMove={f:r.mInitial.lastMove.f,t:r.mInitial.lastMove.t}),void 0!==r.mInitial.noCaptCount&&(this.noCaptCount=r.mInitial.noCaptCount),r.cbVar.castle&&r.mInitial.castle&&(this.castled={1:{k:!!r.mInitial.castle[1]&&!!r.mInitial.castle[1].k,q:!!r.mInitial.castle[1]&&!!r.mInitial.castle[1].q},"-1":{k:!!r.mInitial.castle[-1]&&!!r.mInitial.castle[-1].k,q:!!r.mInitial.castle[-1]&&!!r.mInitial.castle[-1].q}});else for(var s in r.cbVar.pieceTypes)for(var n=r.cbVar.pieceTypes[s],o=n.initial||[],h=0;h<o.length;h++){var c=o[h],p={s:c.s,t:parseInt(s),p:c.p,m:!1};this.pieces.push(p)}if(this.pieces.sort(function(t,e){if(t.s!=e.s)return e.s-t.s;var i=r.cbVar.pieceTypes[t.t].value||100,a=r.cbVar.pieceTypes[e.t].value||100;return i!=a?i-a:t.p-e.p}),this.pieces.forEach(function(t,e){t.i=e,i.board[t.p]=e,r.g.pTypes[t.t].isKing&&(i.kings[t.s]=t.p),i.zSign=r.zobrist.update(i.zSign,"board",e,t.p),i.zSign=r.zobrist.update(i.zSign,"type",t.t,e)}),r.mInitial&&r.mInitial.enPassant){var a=t.geometry.PosByName(r.mInitial.enPassant);if(a>=0){var l,u=t.geometry.C(a),v=t.geometry.R(a);l=1==r.mInitial.turn?t.geometry.POS(u,v-1):t.geometry.POS(u,v+1),this.epTarget={p:a,i:this.board[l]}}}},Model.Board.CopyFrom=function(t){if(e)this.board=new Int16Array(t.board.length),this.board.set(t.board);else{this.board=[];for(var r=t.board,i=r.length,a=0;a<i;a++)this.board.push(r[a])}this.pieces=[];for(var s=t.pieces.length,a=0;a<s;a++){var n=t.pieces[a];this.pieces.push({s:n.s,p:n.p,t:n.t,i:n.i,m:n.m})}this.kings={1:t.kings[1],"-1":t.kings[-1]},this.check=t.check,t.lastMove?this.lastMove={f:t.lastMove.f,t:t.lastMove.t,c:t.lastMove.c}:this.lastMove=null,this.ending={1:t.ending[1],"-1":t.ending[-1]},void 0!==t.castled&&(this.castled={1:t.castled[1],"-1":t.castled[-1]}),this.noCaptCount=t.noCaptCount,t.epTarget?this.epTarget={p:t.epTarget.p,i:t.epTarget.i}:this.epTarget=null,this.mWho=t.mWho,this.zSign=t.zSign},Model.Board.cbApplyCastle=function(t,e,r){var i=t.cbVar.castle[e.f+"/"+e.cg],a=i.r[i.r.length-1],s=this.pieces[this.board[e.cg]],n=i.k[i.k.length-1],o=this.pieces[this.board[e.f]];return r&&(this.zSign=t.zobrist.update(this.zSign,"board",s.i,e.cg),this.zSign=t.zobrist.update(this.zSign,"board",s.i,a),this.zSign=t.zobrist.update(this.zSign,"board",o.i,e.f),this.zSign=t.zobrist.update(this.zSign,"board",o.i,n)),s.p=a,s.m=!0,this.board[e.cg]=-1,o.p=n,o.m=!0,this.board[e.f]=-1,this.board[a]=s.i,this.board[n]=o.i,this.castled[s.s]=!0,this.kings[o.s]=n,[{i:s.i,f:a,t:-1},{i:o.i,f:n,t:e.f,kp:e.f,who:o.s,m:!1},{i:s.i,f:-1,t:e.cg,m:!1,cg:!1}]},Model.Board.cbQuickApply=function(t,e){if(void 0!==e.cg)return this.cbApplyCastle(t,e,!1);var r=[],i=this.board[e.f],a=this.pieces[i];if(null!=e.c){r.unshift({i:e.c,f:-1,t:this.pieces[e.c].p});var s=this.pieces[e.c];this.board[s.p]=-1,s.p=-1}var n=this.kings[a.s];return t.g.pTypes[a.t].isKing&&(this.kings[a.s]=e.t),r.unshift({i:i,f:e.t,t:e.f,kp:n,who:a.s,ty:a.t}),a.p=e.t,void 0!==e.pr&&(a.t=e.pr),this.board[e.f]=-1,this.board[e.t]=i,r},Model.Board.cbQuickUnapply=function(t,e){for(var r=0;r<e.length;r++){var i=e[r],a=this.pieces[i.i];i.f>=0&&(a.p=-1,this.board[i.f]=-1),i.t>=0&&(a.p=i.t,this.board[i.t]=i.i),void 0!==i.m&&(a.m=i.m),void 0!==i.kp&&(this.kings[i.who]=i.kp),void 0!=i.ty&&(a.t=i.ty),void 0!=i.cg&&(this.castled[a.s]=i.cg)}},Model.Board.ApplyMove=function(t,e){var r=this.pieces[this.board[e.f]];if(void 0!==e.cg)this.cbApplyCastle(t,e,!0);else{if(this.zSign=t.zobrist.update(this.zSign,"board",r.i,e.f),this.board[r.p]=-1,void 0!==e.pr&&(this.zSign=t.zobrist.update(this.zSign,"type",r.t,r.i),r.t=e.pr,this.zSign=t.zobrist.update(this.zSign,"type",r.t,r.i)),null!=e.c){var i=this.pieces[e.c];this.zSign=t.zobrist.update(this.zSign,"board",i.i,i.p),this.board[i.p]=-1,i.p=-1,i.m=!0,this.noCaptCount=0}else this.noCaptCount++;r.p=e.t,r.m=!0,this.board[e.t]=r.i,this.zSign=t.zobrist.update(this.zSign,"board",r.i,e.t),t.g.pTypes[r.t].isKing&&(this.kings[r.s]=e.t)}this.check=!!e.ck,this.lastMove={f:e.f,t:e.t,c:e.c},void 0!==e.ko&&(this.ending[r.s]=e.ko),void 0!==e.ept?this.epTarget={p:e.ept,i:r.i}:this.epTarget=null,this.zSign=t.zobrist.update(this.zSign,"who",-this.mWho),this.zSign=t.zobrist.update(this.zSign,"who",this.mWho)},Model.Board.Evaluate=function(r){function i(e){var r=1/0;for(var i in t.geometry.corners)r=Math.min(r,h.distGraph[s.kings[e]][i]);return r-Math.sqrt(h.boardSize)}var a="debug"==arguments[3],s=this;this.mEvaluation=0;var n,o=this.mWho,h=r.g;if(e)n={1:{count:new Uint8Array(h.pTypes.length),byType:{}},"-1":{count:new Uint8Array(h.pTypes.length),byType:{}}};else{n={1:{count:[],byType:{}},"-1":{count:[],byType:{}}};for(var c=0;c<h.pTypes.length;c++)n[1].count[c]=n[-1].count[c]=0}if(r.mOptions.preventRepeat&&r.GetRepeatOccurence(this)>2)return this.mFinished=!0,void(this.mWinner=r.cbOnPerpetual?o*r.cbOnPerpetual:JocGame.DRAW);for(var p={1:0,"-1":0},l={1:h.distGraph[this.kings[-1]],"-1":h.distGraph[this.kings[1]]},u={1:0,"-1":0},v={1:0,"-1":0},b={1:0,"-1":0},f={1:0,"-1":0},g={1:!1,"-1":!1},d=this.pieces,m=d.length,c=0;c<m;c++){var G=d[c];if(G.p>=0){var y=G.s,M=h.pTypes[G.t];M.isKing?g[y]=G.m:p[y]+=M.value,M.castle&&!G.m&&f[y]++,v[y]++,u[y]+=l[y][G.p],b[y]+=t.geometry.distEdge[G.p];var C=n[y];C.count[G.t]++;var S=C.byType;void 0===S[G.t]?S[G.t]=[G]:S[G.t].push(G)}}if(this.lastMove&&null!=this.lastMove.c){var G=this.pieces[this.board[this.lastMove.t]];p[-G.s]+=this.cbStaticExchangeEval(r,G.p,G.s,{piece:G})}var k={1:0,"-1":0},A={1:0,"-1":0},T={1:0,"-1":0};this.ending[1]&&(A[1]=(u[1]-Math.sqrt(h.boardSize))/v[1],t.geometry.corners&&(T[1]=i(1))),this.ending[-1]&&(A[-1]=(u[-1]-Math.sqrt(h.boardSize))/v[-1],t.geometry.corners&&(T[1]=i(-1)));var z={pieceValue:p[1]-p[-1],pieceValueRatio:(p[1]-p[-1])/(p[1]+p[-1]+1),posValue:b[1]-b[-1],averageDistKing:u[1]/v[1]-u[-1]/v[-1],check:this.check?-o:0,endingKingFreedom:k[1]-k[-1],endingDistKing:A[1]-A[-1],distKingCorner:T[1]-T[-1]};t.castle&&(z.castle=(this.castled[1]?1:g[1]?0:f[1]/(h.castleablePiecesCount[1]+1))-(this.castled[-1]?1:g[-1]?0:f[-1]/(h.castleablePiecesCount[-1]+1))),t.evaluate&&t.evaluate.call(this,r,z,n);var E=r.mOptions.levelOptions;for(var P in z){var R=z[P],I=E[P+"Factor"]||0,w=R*I;a&&console.log(P,"=",R,"*",I,"=>",w),this.mEvaluation+=w}a&&console.log("Evaluation",this.mEvaluation)},Model.Board.cbGeneratePseudoLegalMoves=function(t){function e(e,a){var s=t.cbVar.promote;if(!s)return void i.push(a);var n=s.call(r,t,e,a);if(null!=n)if(0==n.length)i.push(a);else if(1==n.length)a.pr=n[0],i.push(a);else for(var o=0;o<n.length;o++){var h=n[o];i.push({f:a.f,t:a.t,c:a.c,pr:h,ept:a.ept,ep:a.ep,a:a.a})}}for(var r=this,i=[],a=t.cbVar,s=this.mWho,n=!a.castle||this.check||this.castled[s]?null:[],o=-1,h=this.pieces.length,c=0;c<h;c++){var p=this.pieces[c];if(!(p.p<0||p.s!=s)){var l=t.g.pTypes[p.t];l.isKing&&(p.m?n=null:o=p),n&&l.castle&&!p.m&&n.push(p);var u,v;u=l.graph[p.p],v=u.length;for(var b=0;b<v;b++)for(var f=u[b],g=!1,d=f.length,m=null,G=0;G<d;G++){var y=f[G],M=65535&y,C=this.board[M];if(!(C<0)||l.epCatch&&this.epTarget&&this.epTarget.p==M){if(!(524288&y)){var S;S=C<0?this.pieces[this.epTarget.i]:this.pieces[C],!(S.s!=p.s&&131072&y)||1048576&y&&!t.g.pTypes[S.t].isKing||2097152&y&&t.g.pTypes[S.t].isKing||e(p,{f:p.p,t:M,c:S.i,a:l.abbrev,ep:C<0});break}if(g){var S=this.pieces[C];S.s!=p.s&&e(p,{f:p.p,t:M,c:S.i,a:l.abbrev});break}g=!0}else 65536&y&&0==g&&e(p,{f:p.p,t:M,c:null,a:l.abbrev,ept:null!=m&&l.epTarget?m:void 0});m=M}}}if(n)for(var c=0;c<n.length;c++){var k=n[c],A=t.cbVar.castle[o.p+"/"+k.p];if(A){for(var T=!0,b=0;b<A.r.length;b++){var z=A.r[b];if(this.board[z]>=0&&z!=o.p&&z!=k.p){T=!1;break}}if(T){for(var E=!0,b=0;b<A.k.length;b++){var z=A.k[b];if(this.board[z]>=0&&z!=k.p&&z!=o.p||this.cbGetAttackers(t,z,s).length>0){E=!1;break}}E&&i.push({f:o.p,t:A.k[A.k.length-1],c:null,cg:k.p})}}}return i},Model.Board.cbStaticExchangeEval=function(t,e,r,i){var a=0,s=this.cbGetSmallestAttacker(t,e,r);if(s){var n=this.mWho;this.mWho=s.s;var o=this.cbQuickApply(t,{f:s.p,t:e,c:i.piece.i}),h=t.g.pTypes[i.piece.t].value;i.piece=s,a=Math.max(0,h-this.cbStaticExchangeEval(t,e,-r,i)),this.cbQuickUnapply(t,o),this.mWho=n}return a},Model.Board.cbGetSmallestAttacker=function(t,e,r){var i=this.cbGetAttackers(t,e,r);if(0==i.length)return null;for(var a=1/0,s=null,n=i.length,o=0;o<n;o++){var h=i[o],c=t.g.pTypes[h.t].value;c<a&&(a=c,s=h)}return s},Model.Board.cbCollectAttackers=function(t,e,r,i){for(var a in e){var s=e[a],n=this.board[a];if(n<0)this.cbCollectAttackers(t,s.e,r,i);else{var o=this.pieces[n];o.s==-t&&(s.t&&o.t in s.t||i&&s.tk&&o.t in s.tk)&&r.push(o)}}},Model.Board.cbCollectAttackersScreen=function(t,e,r,i,a){for(var s in e){var n=e[s],o=this.board[s];if(o<0)this.cbCollectAttackersScreen(t,n.e,r,i,a);else{var h=this.pieces[o];!a&&h.s==-t&&(n.t&&h.t in n.t||i&&n.tk&&h.t in n.tk)?r.push(h):a?a&&h.s==-t&&n.ts&&h.t in n.ts&&r.push(h):this.cbCollectAttackersScreen(t,n.e,r,i,!0)}}},Model.Board.cbGetAttackers=function(t,e,r,i){var a=[];return t.cbUseScreenCapture?this.cbCollectAttackersScreen(r,t.g.threatGraph[r][e],a,i,!1):this.cbCollectAttackers(r,t.g.threatGraph[r][e],a,i),a},Model.Board.GenerateMoves=function(t){var e=this.cbGeneratePseudoLegalMoves(t);this.mMoves=[];for(var r=!0,i=this.kings[this.mWho],a=e.length,s=0;s<a;s++){var n=e[s],o=this.cbQuickApply(t,n);if(!(this.cbGetAttackers(t,this.kings[this.mWho],this.mWho,!0).length>0)){var h=this.cbGetAttackers(t,this.kings[-this.mWho],-this.mWho,!0).length>0;n.ck=h,this.mMoves.push(n),n.f!=i&&(r=!1)}this.cbQuickUnapply(t,o)}if(0==this.mMoves.length)this.mFinished=!0,this.mWinner=t.cbOnStaleMate?t.cbOnStaleMate*this.mWho:JocGame.DRAW,this.check&&(this.mWinner=-this.mWho);else if(this.ending[this.mWho]){if(!r)for(var s=0;s<this.mMoves.length;s++)this.mMoves[s].ko=!1}else if(!this.ending[this.mWho]&&r&&!this.check)for(var s=0;s<this.mMoves.length;s++)this.mMoves[s].ko=!0},Model.Board.GetSignature=function(){return this.zSign},Model.Move.Init=function(t){for(var e in t)t.hasOwnProperty(e)&&(this[e]=t[e])},Model.Move.Equals=function(t){return this.f==t.f&&this.t==t.t&&this.pr==t.pr},Model.Move.CopyFrom=function(t){this.Init(t)},Model.Move.ToString=function(e){var r=this;switch(e=e||"natural"){case"natural":return function(){var e;if(void 0!==r.cg?e=t.castle[r.f+"/"+r.cg].n:(e=r.a||"",e+=t.geometry.PosName(r.f),null==r.c?e+="-":e+="x",e+=t.geometry.PosName(r.t)),void 0!==r.pr){var i=t.pieceTypes[r.pr];i&&i.abbrev&&i.abbrev.length>0&&!i.silentPromo&&(e+="="+i.abbrev)}return r.ck&&(e+="+"),e}();case"engine":return function(){var e=t.geometry.PosName(r.f)+t.geometry.PosName(r.t);if(void 0!=r.pr){var i=t.pieceTypes[r.pr];i&&i.abbrev&&i.abbrev.length>0&&!i.silentPromo&&(e+=i.abbrev)}return e}();default:return"??"}},Model.Board.CompactMoveString=function(e,r,i){"function"!=typeof r.ToString&&(r=e.CreateMove(r));var a=r.ToString(),s=/^([A-Z]?)([a-z])([1-9][0-9]*)([-x])([a-z])([1-9][0-9]*)(.*?)$/.exec(a);if(!s)return a;var n=s[7];if(i||(i={}),i.value||(i.value=[]),0==i.value.length){var o=this.mMoves;this.mMoves&&0!=this.mMoves.length||this.GenerateMoves(e);for(var h=0;h<this.mMoves.length;h++){var c=this.mMoves[h];"function"!=typeof c.ToString&&(c=e.CreateMove(c)),i.value.push({str:c.ToString(),move:c})}this.mMoves=o}var p=[];if(i.value.forEach(function(t){var e=/^([A-Z]?[a-z][1-9][0-9]*[-x][a-z][1-9][0-9]*)(.*?)$/.exec(t.str);e&&t.move.t==r.t&&(t.move.a||"")==s[1]&&e[2]==n&&p.push(t.move)}),1==p.length)return""==s[1]&&"x"==s[4]?s[2]+"x"+s[5]+s[6]+s[7]:s[1]+("x"==s[4]?"x":"")+s[5]+s[6]+s[7];if(t.geometry.CompactCrit)for(var l="",h=0;;h++){var u=t.geometry.CompactCrit(r.f,h);if(null==u)return a;l+=u;for(var v=[],b=0;b<p.length;b++){var f=p[b];t.geometry.CompactCrit(f.f,h)==u&&v.push(f)}if(console.assert(v.length>0),1==v.length)return s[1]+l+("x"==s[4]?"x":"")+s[5]+s[6]+s[7];p=v}return a},Model.Board.cbIntegrity=function(t){function e(t,e){t||console.error(e)}for(var r=this,i=0;i<this.board.length;i++){var a=this.board[i];if(a>=0){var s=r.pieces[a];e(void 0!==s,"no piece at pos"),e(s.p==i,"piece has different pos")}}for(var a=0;a<this.pieces.length;a++){var s=this.pieces[a];s.p>=0&&e(r.board[s.p]==a,"board index mismatch")}},Model.Board.ExportBoardState=function(t){return t.cbVar.geometry.ExportBoardState?t.cbVar.geometry.ExportBoardState(this,t.cbVar,t.mPlayedMoves.length):"not supported"},Model.Game.Import=function(e,r){var i,a=[],s={1:{},"-1":{}},n=null,o=0;if("pjn"==e){var h={status:!1,error:"parse"},c=r.split(" ");if(6!=c.length)return console.warn("FEN should have 6 parts"),h;var p=c[0].split("/"),l=t.geometry.fenHeight||t.geometry.height;if(p.length!=l)return console.warn("FEN board should have",l,"rows, got",p.length),h;var u={};for(var v in t.pieceTypes){var b=t.pieceTypes[v],f=b.fenAbbrev||b.abbrev||"X";u[f.toUpperCase()]={s:1,t:v},u[f.toLowerCase()]={s:-1,t:v}}var g=t.geometry.FenRowPos||function(e,r){return(t.geometry.height-1-e)*t.geometry.width+r};if(p.forEach(function(e,r){for(var i=0,s=0;s<e.length;s++){var n=e.substr(s,1),o=u[n];if(void 0!==o){var c=g(r,i);i++;for(var p={s:o.s,t:o.t,p:c},l=!0,v=t.pieceTypes[p.t].initial||[],b=0;b<v.length;b++){var f=v[b];f.s==p.s&&f.p==c&&(l=!1)}p.m=l,a.push(p)}else{if(isNaN(parseInt(n)))return console.warn("FEN invalid board spec",n),h;i+=parseInt(n)}}}),a.sort(function(t,e){return e.s-t.s}),"w"==c[1])i=1;else{if("b"!=c[1])return console.warn("FEN invalid turn spec",c[1]),h;i=-1}s[1].k=c[2].indexOf("K")>=0,s[1].q=c[2].indexOf("Q")>=0,s[-1].k=c[2].indexOf("k")>=0,s[-1].q=c[2].indexOf("q")>=0,n="-"==c[3]?null:c[3];var d=parseInt(c[4]);isNaN(d)||(o=d);var m={pieces:a,turn:i,castle:s,enPassant:n,noCaptCount:o};return t.importGame&&t.importGame.call(this,m,e,r),{status:!0,initial:m}}return{status:!1,error:"unsupported"}}}(),function(){Model.Game.cbBoardGeometryGrid=function(t,e){function r(e){return e%t}function i(e){return Math.floor(e/t)}function a(e,r){return r*t+e}function s(s,n){var o=r(s),h=i(s),c=o+n[0],p=h+n[1];return c<0||c>=t||p<0||p>=e?null:a(c,p)}function n(t){return String.fromCharCode("a".charCodeAt(0)+r(t))+(i(t)+1)}function o(t){var e=/^([a-z])([0-9]+)$/.exec(t);return e?a(e[1].charCodeAt(0)-"a".charCodeAt(0),parseInt(e[2])-1):-1}function h(t,e){return 0==e?String.fromCharCode("a".charCodeAt(0)+r(t)):1==e?i(t)+1:null}function c(){for(var a=[],s=0;s<t*e;s++){var n=[];a.push(n);for(var o=0;o<t*e;o++){var h=i(s),c=r(s),p=i(o),l=r(o);n.push(Math.max(Math.abs(h-p),Math.abs(c-l)))}}return a}function p(r,i,s){for(var o=[],h=e-1;h>=0;h--){for(var c="",p=0,l=0;l<t;l++){var u=r.board[a(l,h)];if(u<0)p++;else{p>0&&(c+=p,p=0);var v=r.pieces[u],b=i.pieceTypes[v.t].fenAbbrev||i.pieceTypes[v.t].abbrev||"?";v.s==-1?c+=b.toLowerCase():c+=b.toUpperCase()}}p&&(c+=p),o.push(c)}var f=o.join("/");f+=" ",1==r.mWho?f+="w":f+="b",f+=" ";var g="";return r.castled&&(r.castled[1]===!1?g+="KQ":(r.castled[1].k&&(g+="K"),r.castled[1].q&&(g+="Q")),r.castled[-1]===!1?g+="kq":(r.castled[-1].k&&(g+="k"),r.castled[-1].q&&(g+="q"))),0==g.length&&(g="-"),f+=g,f+=" ",r.epTarget?f+=n(r.epTarget.p):f+="-",f+=" ",f+=r.noCaptCount,f+=" ",f+=Math.floor(s/2)+1}return{boardSize:t*e,width:t,height:e,C:r,R:i,POS:a,Graph:s,PosName:n,PosByName:o,CompactCrit:h,GetDistances:c,distEdge:function(){for(var a=[],s=0;s<t*e;s++){var n=r(s),o=i(s);a[s]=Math.min(n,Math.abs(t-n-1),o,Math.abs(e-o-1))}return a}(),corners:function(){var r={};return r[a(0,0)]=1,r[a(0,e-1)]=1,r[a(t-1,0)]=1,r[a(t-1,e-1)]=1,r}(),ExportBoardState:p}},Model.Game.cbPawnGraph=function(t,e,r){for(var i=this,a={},s=0;s<t.boardSize;s++)if(!r||s in r){var n=[],o=t.Graph(s,[0,e]);null!=o&&(!r||o in r)&&n.push(i.cbTypedArray([o|i.cbConstants.FLAG_MOVE])),[-1,1].forEach(function(a){var o=t.Graph(s,[a,e]);null!=o&&(!r||o in r)&&n.push(i.cbTypedArray([o|i.cbConstants.FLAG_CAPTURE]))}),a[s]=n}else a[s]=[];return a},Model.Game.cbInitialPawnGraph=function(t,e,r){for(var i=this,a={},s=0;s<t.boardSize;s++)if(!r||s in r){var n=[],o=t.Graph(s,[0,e]);if(null!=o&&(!r||o in r)){var h=[o|i.cbConstants.FLAG_MOVE],c=t.Graph(o,[0,e]);null!=c&&(!r||c in r)&&h.push(c|i.cbConstants.FLAG_MOVE),n.push(i.cbTypedArray(h))}[-1,1].forEach(function(a){var o=t.Graph(s,[a,e]);null!=o&&(!r||o in r)&&n.push(i.cbTypedArray([o|i.cbConstants.FLAG_CAPTURE]))}),a[s]=n}else a[s]=[];return a},Model.Game.cbKingGraph=function(t,e){return this.cbShortRangeGraph(t,[[-1,-1],[-1,0],[-1,1],[0,-1],[0,1],[1,-1],[1,0],[1,1]],e)},Model.Game.cbKnightGraph=function(t,e){return this.cbShortRangeGraph(t,[[2,-1],[2,1],[-2,-1],[-2,1],[-1,2],[-1,-2],[1,2],[1,-2]],e)},Model.Game.cbHorseGraph=function(t){for(var e=this,r={},i=0;i<t.boardSize;i++)r[i]=[],[[1,0,2,-1],[1,0,2,1],[-1,0,-2,-1],[-1,0,-2,1],[0,1,-1,2],[0,-1,-1,-2],[0,1,1,2],[0,-1,1,-2]].forEach(function(a){var s=t.Graph(i,[a[0],a[1]]);if(null!=s){var n=t.Graph(i,[a[2],a[3]]);null!=n&&r[i].push(e.cbTypedArray([s|e.cbConstants.FLAG_STOP,n|e.cbConstants.FLAG_MOVE|e.cbConstants.FLAG_CAPTURE]))}});return r},Model.Game.cbRookGraph=function(t,e){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0]],e)},Model.Game.cbBishopGraph=function(t,e){return this.cbLongRangeGraph(t,[[1,-1],[1,1],[-1,1],[-1,-1]],e)},Model.Game.cbQueenGraph=function(t,e){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0],[1,-1],[1,1],[-1,1],[-1,-1]],e)},Model.Game.cbXQGeneralGraph=function(t,e){for(var r=this,i={},a=0;a<t.boardSize;a++)i[a]=[],[[-1,0,!1],[0,-1,!0],[0,1,!0],[1,0,!1]].forEach(function(s){var n=[],o=t.Graph(a,s);if(null!=o&&((!e||o in e)&&n.push(o|r.cbConstants.FLAG_MOVE|r.cbConstants.FLAG_CAPTURE),s[2]))for(var h=t.Graph(o,s);null!=h;)!e||h in e?n.push(h|r.cbConstants.FLAG_CAPTURE|r.cbConstants.FLAG_CAPTURE_KING):n.push(h|r.cbConstants.FLAG_STOP),h=t.Graph(h,s);n.length>0&&i[a].push(r.cbTypedArray(n))});return i},Model.Game.cbXQSoldierGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e]])},Model.Game.cbXQPromoSoldierGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e],[-1,0],[1,0]])},Model.Game.cbXQAdvisorGraph=function(t,e){return this.cbShortRangeGraph(t,[[1,1],[-1,1],[1,-1],[-1,-1]],e)},Model.Game.cbXQCannonGraph=function(t){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0]],null,this.cbConstants.FLAG_MOVE|this.cbConstants.FLAG_SCREEN_CAPTURE)},Model.Game.cbXQElephantGraph=function(t,e){for(var r=this,i={},a=0;a<t.boardSize;a++)i[a]=[],(!e||a in e)&&[[1,1,2,2],[1,-1,2,-2],[-1,1,-2,2],[-1,-1,-2,-2]].forEach(function(s){var n=t.Graph(a,[s[0],s[1]]);if(null!=n){var o=t.Graph(a,[s[2],s[3]]);null!=o&&(!e||o in e)&&i[a].push(r.cbTypedArray([n|r.cbConstants.FLAG_STOP,o|r.cbConstants.FLAG_MOVE|r.cbConstants.FLAG_CAPTURE]))}});return i},Model.Game.cbSilverGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e],[-1,-1],[-1,1],[1,-1],[1,1]])},Model.Game.cbFersGraph=function(t,e){return this.cbShortRangeGraph(t,[[-1,-1],[-1,1],[1,-1],[1,1]])},Model.Game.cbSchleichGraph=function(t,e){return this.cbShortRangeGraph(t,[[-1,0],[1,0],[0,-1],[0,1]])},Model.Game.cbAlfilGraph=function(t,e){return this.cbShortRangeGraph(t,[[-2,-2],[-2,2],[2,2],[2,-2]])}}(),function(){var t=Model.Game.cbBoardGeometryGrid(10,10);Model.Game.cbDefine=function(){return{geometry:t,pieceTypes:{0:{name:"pawn-w",aspect:"fr-pawn",graph:this.cbPawnGraph(t,1),value:.6,abbrev:"",fenAbbrev:"P",initial:[{s:1,p:10},{s:1,p:11},{s:1,p:12},{s:1,p:13},{s:1,p:24},{s:1,p:25},{s:1,p:16},{s:1,p:17},{s:1,p:18},{s:1,p:19}]},2:{name:"pawn-b",aspect:"fr-pawn",graph:this.cbPawnGraph(t,-1),value:.6,abbrev:"",fenAbbrev:"P",initial:[{s:-1,p:80},{s:-1,p:81},{s:-1,p:82},{s:-1,p:83},{s:-1,p:74},{s:-1,p:75},{s:-1,p:86},{s:-1,p:87},{s:-1,p:88},{s:-1,p:89}]},4:{name:"knight",aspect:"fr-knight",graph:this.cbKnightGraph(t),value:2.6,abbrev:"N",initial:[{s:1,p:1},{s:1,p:8},{s:-1,p:91},{s:-1,p:98}]},5:{name:"bishop",aspect:"fr-bishop",graph:this.cbBishopGraph(t),value:3.4,abbrev:"B",initial:[{s:1,p:2},{s:1,p:7},{s:-1,p:92},{s:-1,p:97}]},6:{name:"rook",aspect:"fr-rook",graph:this.cbRookGraph(t),value:5,abbrev:"R",initial:[{s:1,p:0},{s:1,p:9},{s:-1,p:90},{s:-1,p:99}]},7:{name:"queen",aspect:"fr-queen",graph:this.cbQueenGraph(t),value:8.2,abbrev:"Q",initial:[{s:1,p:6},{s:-1,p:93}]},8:{name:"king",aspect:"fr-king",isKing:!0,graph:this.cbKingGraph(t),abbrev:"K",initial:[{s:1,p:5},{s:-1,p:94}]},9:{name:"marshall",aspect:"fr-marshall",graph:this.cbMergeGraphs(t,this.cbRookGraph(t),this.cbKnightGraph(t)),value:7.5,abbrev:"M",initial:[{s:1,p:14},{s:1,p:15},{s:-1,p:84},{s:-1,p:85}]},10:{name:"cardinal",aspect:"fr-cardinal",graph:this.cbMergeGraphs(t,this.cbBishopGraph(t),this.cbKnightGraph(t)),value:6,abbrev:"C",initial:[{s:1,p:3},{s:-1,p:96}]},11:{name:"amazon",aspect:"fr-amazon",graph:this.cbMergeGraphs(t,this.cbQueenGraph(t),this.cbKnightGraph(t)),value:10.7,abbrev:"A",initial:[{s:1,p:4},{s:-1,p:95}]}},promote:function(e,r,i){var a=t.R(i.t),s=t.C(i.t);if(0==r.t&&9==a||2==r.t&&0==a){for(var n={0:6,1:4,2:5,3:10,4:11,5:9,6:7,7:5,8:4,9:6},o={6:2,4:2,5:2,10:1,11:1,9:2,7:1},h=n[s],c=0,p=0;p<this.pieces.length;p++){var l=this.pieces[p];l.s==r.s&&l.p>=0&&l.t==h&&c++}if(c<o[h])return[h]}return[]}}}}();

/***/ }),

/***/ "rLWm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var onErrorResumeNext_1 = __webpack_require__("ASN6");
Observable_1.Observable.prototype.onErrorResumeNext = onErrorResumeNext_1.onErrorResumeNext;
//# sourceMappingURL=onErrorResumeNext.js.map

/***/ }),

/***/ "rVkx":
/***/ (function(module, exports) {

exports.config = {"status":true,"model":{"js":["reversi-model.js"],"plazza":"true","released":1409239768,"title-en":"Annexation 4","module":"reversi","summary":"Reversi/Othello rules on a 4x4 board","thumbnail":"thumb-reversi4.png","rules":{"en":"rules-reversi4.html"},"credits":{"en":"credits.html"},"description":{"en":"description.html"},"gameOptions":{"preventRepeat":true,"uctTransposition":"state","levelOptions":{"stableFactor":20,"aboutStableFactor":-20,"aboutStableBorderFactor":-15,"borderFactor":5,"aboutBorderFactor":-4,"countFactor":1,"mobilityFactor":5},"width":4,"height":4,"initial":{"1":["1:2","2:1"],"-1":["1:1","2:2"]}},"debugEval":true,"levels":[{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.65,"ignoreLeaf":false,"log":true,"uncertaintyFactor":3,"name":"easy","label":"Easy","maxNodes":1000},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.65,"ignoreLeaf":false,"log":true,"uncertaintyFactor":3,"name":"fast","label":"Fast [1sec]","maxDuration":1,"isDefault":true},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.65,"ignoreLeaf":false,"log":true,"uncertaintyFactor":3,"name":"medium","label":"Medium","maxNodes":10000,"maxDuration":10},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.65,"ignoreLeaf":false,"log":true,"uncertaintyFactor":3,"name":"strong","label":"Strong","maxNodes":20000,"maxDuration":15}]},"view":{"title-en":"Annex View","js":["reversi-xd-view.js"],"xdView":true,"useNotation":true,"useShowMoves":true,"module":"reversi","skins":[{"name":"classic3d","title":"3D Classic","3d":true,"camera":{"radius":14,"elevationAngle":45,"distMax":39.5,"distMin":10.1,"elevationMin":-89.9,"elevationMax":89.9,"limitCamMoves":true,"fov":45},"world":{"lightIntensity":0.7,"skyLightIntensity":0.3,"lightPosition":{"x":10,"y":18,"z":0},"lightShadowDarkness":0.35,"color":4686804,"ambientLightColor":5592405,"fog":false},"preload":["image|/res/xd-view/pass-dark.png","image|/res/xd-view/pass-light.png","image|/res/images/wood-chipboard-5.jpg","image|/res/xd-view/reversi-pieces-2-textures.png","image|/res/xd-view/reversi-pieces-2-textures-bump.png","smoothedfilegeo|0|/res/xd-view/ring-target.js","smoothedfilegeo|0|/res/xd-view/reversi-pieces-6.js"]},{"name":"classic2d","title":"2D Classic","preload":["image|/res/xd-view/pass-dark.png","image|/res/xd-view/pass-light.png","image|/res/xd-view/boardtexture.jpg","image|/res/xd-view/cellshadows.png","image|/res/xd-view/sprites.png","image|/res/xd-view/select-target-2d.png"]}],"visuals":{"600x600":["res/visuals/reversi4-600x600-3d.jpg","res/visuals/reversi4-600x600-2d.jpg"]}}}

/***/ }),

/***/ "rl5v":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_add_operator_filter__ = __webpack_require__("wUn1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs_add_operator_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rxjs_add_operator_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_add_operator_map__ = __webpack_require__("+pb+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rxjs_add_operator_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rxjs_add_operator_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__angular_core__ = __webpack_require__("3j3K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__media_query_module__ = __webpack_require__("OBRl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__media_query_breakpoints_break_points_provider__ = __webpack_require__("r666");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__media_query_media_monitor_provider__ = __webpack_require__("jIkT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__media_query_observable_media_provider__ = __webpack_require__("pcn9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_flex__ = __webpack_require__("XVVf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__api_layout__ = __webpack_require__("Sxsi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__api_show_hide__ = __webpack_require__("niiU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__api_flex_align__ = __webpack_require__("GWBc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__api_flex_fill__ = __webpack_require__("Z5yY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__api_flex_offset__ = __webpack_require__("Lgq0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__api_flex_order__ = __webpack_require__("C9pF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__api_layout_align__ = __webpack_require__("aDoP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__api_layout_wrap__ = __webpack_require__("jazq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__api_layout_gap__ = __webpack_require__("pZGP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__api_class__ = __webpack_require__("pinI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__api_style__ = __webpack_require__("5Voz");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FlexLayoutModule; });
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */



















/**
 * Since the equivalent results are easily achieved with a css class attached to each
 * layout child, these have been deprecated and removed from the API.
 *
 *  import {LayoutPaddingDirective} from './api/layout-padding';
 *  import {LayoutMarginDirective} from './api/layout-margin';
 */
var ALL_DIRECTIVES = [
    __WEBPACK_IMPORTED_MODULE_8__api_layout__["a" /* LayoutDirective */],
    __WEBPACK_IMPORTED_MODULE_15__api_layout_wrap__["a" /* LayoutWrapDirective */],
    __WEBPACK_IMPORTED_MODULE_16__api_layout_gap__["a" /* LayoutGapDirective */],
    __WEBPACK_IMPORTED_MODULE_14__api_layout_align__["a" /* LayoutAlignDirective */],
    __WEBPACK_IMPORTED_MODULE_7__api_flex__["a" /* FlexDirective */],
    __WEBPACK_IMPORTED_MODULE_13__api_flex_order__["a" /* FlexOrderDirective */],
    __WEBPACK_IMPORTED_MODULE_12__api_flex_offset__["a" /* FlexOffsetDirective */],
    __WEBPACK_IMPORTED_MODULE_11__api_flex_fill__["a" /* FlexFillDirective */],
    __WEBPACK_IMPORTED_MODULE_10__api_flex_align__["a" /* FlexAlignDirective */],
    __WEBPACK_IMPORTED_MODULE_9__api_show_hide__["a" /* ShowHideDirective */],
    __WEBPACK_IMPORTED_MODULE_17__api_class__["a" /* ClassDirective */],
    __WEBPACK_IMPORTED_MODULE_18__api_style__["a" /* StyleDirective */],
];
/**
 *
 */
var FlexLayoutModule = (function () {
    function FlexLayoutModule() {
    }
    /**
     * External uses can easily add custom breakpoints AND include internal orientations
     * breakpoints; which are not available by default.
     *
     * !! Selector aliases are not auto-configured. Developers must subclass
     * the API directives to support extra selectors for the orientations breakpoints !!
     */
    FlexLayoutModule.provideBreakPoints = function (breakpoints, options) {
        return {
            ngModule: FlexLayoutModule,
            providers: [
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__media_query_breakpoints_break_points_provider__["b" /* CUSTOM_BREAKPOINTS_PROVIDER_FACTORY */])(breakpoints, options || { orientations: false })
            ]
        };
    };
    return FlexLayoutModule;
}());

FlexLayoutModule.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_2__angular_core__["NgModule"], args: [{
                declarations: ALL_DIRECTIVES,
                imports: [__WEBPACK_IMPORTED_MODULE_3__media_query_module__["a" /* MediaQueriesModule */]],
                exports: [__WEBPACK_IMPORTED_MODULE_3__media_query_module__["a" /* MediaQueriesModule */]].concat(ALL_DIRECTIVES),
                providers: [
                    __WEBPACK_IMPORTED_MODULE_5__media_query_media_monitor_provider__["a" /* MEDIA_MONITOR_PROVIDER */],
                    __WEBPACK_IMPORTED_MODULE_4__media_query_breakpoints_break_points_provider__["a" /* DEFAULT_BREAKPOINTS_PROVIDER */],
                    __WEBPACK_IMPORTED_MODULE_6__media_query_observable_media_provider__["a" /* OBSERVABLE_MEDIA_PROVIDER */]
                ]
            },] },
];
/** @nocollapse */
FlexLayoutModule.ctorParameters = function () { return []; };
//# sourceMappingURL=_module.js.map

/***/ }),

/***/ "rpzr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var IntervalObservable_1 = __webpack_require__("bZY+");
exports.interval = IntervalObservable_1.IntervalObservable.create;
//# sourceMappingURL=interval.js.map

/***/ }),

/***/ "rvIS":
/***/ (function(module, exports) {

exports.config = {"status":true,"model":{"plazza":"true","released":1403189778,"title-en":"Demi-Chess","module":"chessbase","summary":"4x8 chess variant by Peter Krystufek (1986)","thumbnail":"demi-thumb.png","rules":{"en":"demi-rules.html"},"credits":{"en":"demi-credits.html"},"gameOptions":{"preventRepeat":true,"uctTransposition":"state","uctIgnoreLoop":false,"levelOptions":{"pieceValueFactor":1,"pieceValueRatioFactor":1,"posValueFactor":0.1,"averageDistKingFactor":-0.01,"castleFactor":0.1,"minorPiecesMovedFactor":0.1,"checkFactor":0.2,"endingKingFreedomFactor":0.01,"endingDistKingFactor":0.05,"distKingCornerFactor":0.1}},"obsolete":false,"js":["base-model.js","grid-geo-model.js","demi-model.js"],"levels":[{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"easy","label":"Easy","maxNodes":1000},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"fast","label":"Fast [1sec]","maxDuration":1,"isDefault":true},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"medium","label":"Medium","maxNodes":10000,"maxDuration":10},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"strong","label":"Strong","maxNodes":20000,"maxDuration":15}],"description":{"en":"demi-description.html"}},"view":{"title-en":"Chessbase view","module":"chessbase","xdView":true,"css":["chessbase.css"],"preferredRatio":1,"useShowMoves":true,"useNotation":true,"useAutoComplete":true,"defaultOptions":{"sounds":true,"moves":true,"notation":false,"autocomplete":false},"skins":[{"name":"skin3d","title":"3D Classic","3d":true,"preload":["smoothedfilegeo|0|/res/ring-target.js","image|/res/images/cancel.png","image|/res/images/wikipedia.png","smoothedfilegeo|0|/res/staunton/pawn/pawn-classic.js","image|/res/staunton/pawn/pawn-diffusemap.jpg","image|/res/staunton/pawn/pawn-normalmap.jpg","smoothedfilegeo|0|/res/staunton/knight/knight.js","image|/res/staunton/knight/knight-diffusemap.jpg","image|/res/staunton/knight/knight-normalmap.jpg","smoothedfilegeo|0|/res/staunton/bishop/bishop.js","image|/res/staunton/bishop/bishop-diffusemap.jpg","image|/res/staunton/bishop/bishop-normalmap.jpg","smoothedfilegeo|0|/res/staunton/rook/rook.js","image|/res/staunton/rook/rook-diffusemap.jpg","image|/res/staunton/rook/rook-normalmap.jpg","smoothedfilegeo|0|/res/staunton/queen/queen.js","image|/res/staunton/queen/queen-diffusemap.jpg","image|/res/staunton/queen/queen-normalmap.jpg","smoothedfilegeo|0|/res/staunton/king/king.js","image|/res/staunton/king/king-diffusemap.jpg","image|/res/staunton/king/king-normalmap.jpg"],"world":{"lightIntensity":1.3,"skyLightIntensity":1.2,"lightCastShadow":true,"fog":false,"color":4686804,"lightPosition":{"x":-9,"y":9,"z":9},"skyLightPosition":{"x":9,"y":9,"z":9},"lightShadowDarkness":0.55,"ambientLightColor":2236962},"camera":{"fov":45,"distMax":50,"radius":18,"elevationAngle":60,"elevationMin":0}},{"name":"skin2d","title":"2D Classic","3d":false,"preload":["image|/res/images/cancel.png","image|/res/images/whitebg.png","image|/res/images/wikipedia.png"]}],"animateSelfMoves":false,"switchable":true,"sounds":{"move1":"alq_move1","move2":"alq_move2","move3":"alq_move3","move4":"alq_move2","tac1":"alq_tac1","tac2":"alq_tac2","tac3":"alq_tac1","promo":"promo","usermove":null},"js":["base-view.js","grid-board-view.js","staunton-set-view.js","demi-view.js"],"visuals":{"600x600":["res/visuals/demi-600x600-3d.jpg","res/visuals/demi-600x600-2d.jpg"]}}}

/***/ }),

/***/ "ryPf":
/***/ (function(module, exports) {

exports.model=Model={Game:{},Board:{},Move:{}},function(){var t;Model.Game.cbConstants={MASK:65535,FLAG_MOVE:65536,FLAG_CAPTURE:131072,FLAG_STOP:262144,FLAG_SCREEN_CAPTURE:524288,FLAG_CAPTURE_KING:1048576,FLAG_CAPTURE_NO_KING:2097152};var e="undefined"!=typeof Int32Array;Model.Game.cbUseTypedArrays=e,Model.Game.cbTypedArray=function(t){if(e){var r=new Int32Array(t.length);return r.set(t),r}for(var i=[],a=t.length,n=0;n<a;n++)i.push(t[n]);return i},Model.Game.cbShortRangeGraph=function(t,e,r,i){var a=this;void 0===i&&(i=196608);for(var n={},s=0;s<t.boardSize;s++)n[s]=[],(!r||s in r)&&e.forEach(function(e){var o=t.Graph(s,e);null!=o&&(!r||o in r)&&n[s].push(a.cbTypedArray([o|i]))});return n},Model.Game.cbLongRangeGraph=function(t,e,r,i,a){var n=this;void 0!==i&&null!=i||(i=196608),a||(a=1/0);for(var s={},o=0;o<t.boardSize;o++)s[o]=[],(!r||o in r)&&e.forEach(function(e){for(var h=[],c=t.Graph(o,e),p=0;null!=c&&(!r||c in r)&&(h.push(c|i),++p!=a);)c=t.Graph(c,e);h.length>0&&s[o].push(n.cbTypedArray(h))});return s},Model.Game.cbNullGraph=function(t){for(var e={},r=0;r<t.boardSize;r++)e[r]=[];return e},Model.Game.cbAuthorGraph=function(t){for(var e={},r=0;r<t.boardSize;r++){e[r]=[];for(var i=0;i<t.boardSize;i++)e[r].push([2293760|i])}return e},Model.Game.cbMergeGraphs=function(t){for(var e=[],r=0;r<t.boardSize;r++){e[r]=[];for(var i=1;i<arguments.length;i++)e[r]=e[r].concat(arguments[i][r])}return e},Model.Game.cbGetThreatGraph=function(){function t(e,r){for(var i in s){var a=s[i];if(!(a.p.length<r.length+1)){for(var n=!0,o=0;o<r.length;o++)if(r[o]!=a.p[o]){n=!1;break}if(n){var h=a.p[r.length],c=e[h];void 0===c&&(c={e:{}},e[h]=c),a.p.length==r.length+1&&(c.t=a.t,c.ts=a.ts,c.tk=a.tk,delete s[i]),r.push(h),t(c.e,r),r.pop()}}}}var e=this;this.cbUseScreenCapture=!1,this.cbUseCaptureKing=!1,this.cbUseCaptureNoKing=!1;for(var r={1:[],"-1":[]},i=[],a=0;a<this.g.boardSize;a++)this.g.pTypes.forEach(function(t,r){t.graph[a].forEach(function(t){for(var n=[],s=0;s<t.length;s++){var o=t[s];1048576&o?(e.cbUseCaptureKing=!0,n.unshift({d:65535&o,a:a,tk:r})):2097152&o?(e.cbUseCaptureNoKing=!0,n.unshift({d:65535&o,a:a,tnk:r})):131072&o?n.unshift({d:65535&o,a:a,t:r}):262144&o?n.unshift({d:65535&o,a:a}):524288&o&&(e.cbUseScreenCapture=!0,n.unshift({d:65535&o,a:a,ts:r}))}n.length>0&&i.push(n)})});var n={};i.forEach(function(t){t.forEach(function(e,r){var i=n[e.d];void 0===i&&(i={},n[e.d]=i);for(var a=[],s=r+1;s<t.length;s++)a.push(t[s].d);a.push(e.a);var o=a.join(","),h=i[o];void 0===h&&(h={p:a,t:{},ts:{},tk:{}},i[o]=h),void 0!==e.t?h.t[e.t]=!0:void 0!==e.tk?h.tk[e.tk]=!0:void 0!==e.ts&&(h.ts[e.ts]=!0)})});for(var a=0;a<e.g.boardSize;a++){var s=n[a],o={};t(o,[]),r[1][a]=o,r[-1][a]=o}return r},Model.Game.InitGame=function(){var e=this;this.cbVar=t=this.cbDefine(),this.g.boardSize=this.cbVar.geometry.boardSize,this.g.pTypes=this.cbGetPieceTypes(),this.g.threatGraph=this.cbGetThreatGraph(),this.g.distGraph=this.cbVar.geometry.GetDistances(),this.cbPiecesCount=0,this.g.castleablePiecesCount={1:0,"-1":0};for(var r in t.pieceTypes){var i=t.pieceTypes[r];if(i.castle){(i.initial||[]).forEach(function(t){e.g.castleablePiecesCount[t.s]++})}i.initial&&(this.cbPiecesCount+=i.initial.length)}for(var a=[],r=0;r<this.cbPiecesCount;r++)a.push(r);var n=Object.keys(t.pieceTypes);this.zobrist=new JocGame.Zobrist({board:{type:"array",size:this.cbVar.geometry.boardSize,values:a},who:{values:["1","-1"]},type:{type:"array",size:this.cbPiecesCount,values:n}})},Model.Game.cbGetPieceTypes=function(){for(var t=[],e={},r=0;r<this.cbVar.geometry.boardSize;r++)e[r]=[];for(var i in this.cbVar.pieceTypes){var a=this.cbVar.pieceTypes[i];t[i]={graph:a.graph||e,abbrev:a.abbrev||"",value:a.isKing?100:a.value||1,isKing:!!a.isKing,castle:!!a.castle,epTarget:!!a.epTarget,epCatch:!!a.epCatch}}return t},Model.Board.Init=function(t){this.zSign=0},Model.Board.InitialPosition=function(r){var i=this;this.board=e?new Int16Array(r.g.boardSize):[];for(var a=0;a<r.g.boardSize;a++)this.board[a]=-1;if(this.kings={},this.pieces=[],this.ending={1:!1,"-1":!1},this.lastMove=null,r.cbVar.castle&&(this.castled={1:!1,"-1":!1}),this.zSign=r.zobrist.update(0,"who",-1),this.noCaptCount=0,this.mWho=1,r.mInitial)this.mWho=r.mInitial.turn||1,r.mInitial.pieces.forEach(function(t){var e={};for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);i.pieces.push(e)}),r.mInitial.lastMove&&(this.lastMove={f:r.mInitial.lastMove.f,t:r.mInitial.lastMove.t}),void 0!==r.mInitial.noCaptCount&&(this.noCaptCount=r.mInitial.noCaptCount),r.cbVar.castle&&r.mInitial.castle&&(this.castled={1:{k:!!r.mInitial.castle[1]&&!!r.mInitial.castle[1].k,q:!!r.mInitial.castle[1]&&!!r.mInitial.castle[1].q},"-1":{k:!!r.mInitial.castle[-1]&&!!r.mInitial.castle[-1].k,q:!!r.mInitial.castle[-1]&&!!r.mInitial.castle[-1].q}});else for(var n in r.cbVar.pieceTypes)for(var s=r.cbVar.pieceTypes[n],o=s.initial||[],h=0;h<o.length;h++){var c=o[h],p={s:c.s,t:parseInt(n),p:c.p,m:!1};this.pieces.push(p)}if(this.pieces.sort(function(t,e){if(t.s!=e.s)return e.s-t.s;var i=r.cbVar.pieceTypes[t.t].value||100,a=r.cbVar.pieceTypes[e.t].value||100;return i!=a?i-a:t.p-e.p}),this.pieces.forEach(function(t,e){t.i=e,i.board[t.p]=e,r.g.pTypes[t.t].isKing&&(i.kings[t.s]=t.p),i.zSign=r.zobrist.update(i.zSign,"board",e,t.p),i.zSign=r.zobrist.update(i.zSign,"type",t.t,e)}),r.mInitial&&r.mInitial.enPassant){var a=t.geometry.PosByName(r.mInitial.enPassant);if(a>=0){var l,u=t.geometry.C(a),v=t.geometry.R(a);l=1==r.mInitial.turn?t.geometry.POS(u,v-1):t.geometry.POS(u,v+1),this.epTarget={p:a,i:this.board[l]}}}},Model.Board.CopyFrom=function(t){if(e)this.board=new Int16Array(t.board.length),this.board.set(t.board);else{this.board=[];for(var r=t.board,i=r.length,a=0;a<i;a++)this.board.push(r[a])}this.pieces=[];for(var n=t.pieces.length,a=0;a<n;a++){var s=t.pieces[a];this.pieces.push({s:s.s,p:s.p,t:s.t,i:s.i,m:s.m})}this.kings={1:t.kings[1],"-1":t.kings[-1]},this.check=t.check,t.lastMove?this.lastMove={f:t.lastMove.f,t:t.lastMove.t,c:t.lastMove.c}:this.lastMove=null,this.ending={1:t.ending[1],"-1":t.ending[-1]},void 0!==t.castled&&(this.castled={1:t.castled[1],"-1":t.castled[-1]}),this.noCaptCount=t.noCaptCount,t.epTarget?this.epTarget={p:t.epTarget.p,i:t.epTarget.i}:this.epTarget=null,this.mWho=t.mWho,this.zSign=t.zSign},Model.Board.cbApplyCastle=function(t,e,r){var i=t.cbVar.castle[e.f+"/"+e.cg],a=i.r[i.r.length-1],n=this.pieces[this.board[e.cg]],s=i.k[i.k.length-1],o=this.pieces[this.board[e.f]];return r&&(this.zSign=t.zobrist.update(this.zSign,"board",n.i,e.cg),this.zSign=t.zobrist.update(this.zSign,"board",n.i,a),this.zSign=t.zobrist.update(this.zSign,"board",o.i,e.f),this.zSign=t.zobrist.update(this.zSign,"board",o.i,s)),n.p=a,n.m=!0,this.board[e.cg]=-1,o.p=s,o.m=!0,this.board[e.f]=-1,this.board[a]=n.i,this.board[s]=o.i,this.castled[n.s]=!0,this.kings[o.s]=s,[{i:n.i,f:a,t:-1},{i:o.i,f:s,t:e.f,kp:e.f,who:o.s,m:!1},{i:n.i,f:-1,t:e.cg,m:!1,cg:!1}]},Model.Board.cbQuickApply=function(t,e){if(void 0!==e.cg)return this.cbApplyCastle(t,e,!1);var r=[],i=this.board[e.f],a=this.pieces[i];if(null!=e.c){r.unshift({i:e.c,f:-1,t:this.pieces[e.c].p});var n=this.pieces[e.c];this.board[n.p]=-1,n.p=-1}var s=this.kings[a.s];return t.g.pTypes[a.t].isKing&&(this.kings[a.s]=e.t),r.unshift({i:i,f:e.t,t:e.f,kp:s,who:a.s,ty:a.t}),a.p=e.t,void 0!==e.pr&&(a.t=e.pr),this.board[e.f]=-1,this.board[e.t]=i,r},Model.Board.cbQuickUnapply=function(t,e){for(var r=0;r<e.length;r++){var i=e[r],a=this.pieces[i.i];i.f>=0&&(a.p=-1,this.board[i.f]=-1),i.t>=0&&(a.p=i.t,this.board[i.t]=i.i),void 0!==i.m&&(a.m=i.m),void 0!==i.kp&&(this.kings[i.who]=i.kp),void 0!=i.ty&&(a.t=i.ty),void 0!=i.cg&&(this.castled[a.s]=i.cg)}},Model.Board.ApplyMove=function(t,e){var r=this.pieces[this.board[e.f]];if(void 0!==e.cg)this.cbApplyCastle(t,e,!0);else{if(this.zSign=t.zobrist.update(this.zSign,"board",r.i,e.f),this.board[r.p]=-1,void 0!==e.pr&&(this.zSign=t.zobrist.update(this.zSign,"type",r.t,r.i),r.t=e.pr,this.zSign=t.zobrist.update(this.zSign,"type",r.t,r.i)),null!=e.c){var i=this.pieces[e.c];this.zSign=t.zobrist.update(this.zSign,"board",i.i,i.p),this.board[i.p]=-1,i.p=-1,i.m=!0,this.noCaptCount=0}else this.noCaptCount++;r.p=e.t,r.m=!0,this.board[e.t]=r.i,this.zSign=t.zobrist.update(this.zSign,"board",r.i,e.t),t.g.pTypes[r.t].isKing&&(this.kings[r.s]=e.t)}this.check=!!e.ck,this.lastMove={f:e.f,t:e.t,c:e.c},void 0!==e.ko&&(this.ending[r.s]=e.ko),void 0!==e.ept?this.epTarget={p:e.ept,i:r.i}:this.epTarget=null,this.zSign=t.zobrist.update(this.zSign,"who",-this.mWho),this.zSign=t.zobrist.update(this.zSign,"who",this.mWho)},Model.Board.Evaluate=function(r){function i(e){var r=1/0;for(var i in t.geometry.corners)r=Math.min(r,h.distGraph[n.kings[e]][i]);return r-Math.sqrt(h.boardSize)}var a="debug"==arguments[3],n=this;this.mEvaluation=0;var s,o=this.mWho,h=r.g;if(e)s={1:{count:new Uint8Array(h.pTypes.length),byType:{}},"-1":{count:new Uint8Array(h.pTypes.length),byType:{}}};else{s={1:{count:[],byType:{}},"-1":{count:[],byType:{}}};for(var c=0;c<h.pTypes.length;c++)s[1].count[c]=s[-1].count[c]=0}if(r.mOptions.preventRepeat&&r.GetRepeatOccurence(this)>2)return this.mFinished=!0,void(this.mWinner=r.cbOnPerpetual?o*r.cbOnPerpetual:JocGame.DRAW);for(var p={1:0,"-1":0},l={1:h.distGraph[this.kings[-1]],"-1":h.distGraph[this.kings[1]]},u={1:0,"-1":0},v={1:0,"-1":0},b={1:0,"-1":0},f={1:0,"-1":0},d={1:!1,"-1":!1},g=this.pieces,m=g.length,c=0;c<m;c++){var G=g[c];if(G.p>=0){var y=G.s,M=h.pTypes[G.t];M.isKing?d[y]=G.m:p[y]+=M.value,M.castle&&!G.m&&f[y]++,v[y]++,u[y]+=l[y][G.p],b[y]+=t.geometry.distEdge[G.p];var C=s[y];C.count[G.t]++;var S=C.byType;void 0===S[G.t]?S[G.t]=[G]:S[G.t].push(G)}}if(this.lastMove&&null!=this.lastMove.c){var G=this.pieces[this.board[this.lastMove.t]];p[-G.s]+=this.cbStaticExchangeEval(r,G.p,G.s,{piece:G})}var k={1:0,"-1":0},A={1:0,"-1":0},T={1:0,"-1":0};this.ending[1]&&(A[1]=(u[1]-Math.sqrt(h.boardSize))/v[1],t.geometry.corners&&(T[1]=i(1))),this.ending[-1]&&(A[-1]=(u[-1]-Math.sqrt(h.boardSize))/v[-1],t.geometry.corners&&(T[1]=i(-1)));var z={pieceValue:p[1]-p[-1],pieceValueRatio:(p[1]-p[-1])/(p[1]+p[-1]+1),posValue:b[1]-b[-1],averageDistKing:u[1]/v[1]-u[-1]/v[-1],check:this.check?-o:0,endingKingFreedom:k[1]-k[-1],endingDistKing:A[1]-A[-1],distKingCorner:T[1]-T[-1]};t.castle&&(z.castle=(this.castled[1]?1:d[1]?0:f[1]/(h.castleablePiecesCount[1]+1))-(this.castled[-1]?1:d[-1]?0:f[-1]/(h.castleablePiecesCount[-1]+1))),t.evaluate&&t.evaluate.call(this,r,z,s);var P=r.mOptions.levelOptions;for(var E in z){var R=z[E],w=P[E+"Factor"]||0,I=R*w;a&&console.log(E,"=",R,"*",w,"=>",I),this.mEvaluation+=I}a&&console.log("Evaluation",this.mEvaluation)},Model.Board.cbGeneratePseudoLegalMoves=function(t){function e(e,a){var n=t.cbVar.promote;if(!n)return void i.push(a);var s=n.call(r,t,e,a);if(null!=s)if(0==s.length)i.push(a);else if(1==s.length)a.pr=s[0],i.push(a);else for(var o=0;o<s.length;o++){var h=s[o];i.push({f:a.f,t:a.t,c:a.c,pr:h,ept:a.ept,ep:a.ep,a:a.a})}}for(var r=this,i=[],a=t.cbVar,n=this.mWho,s=!a.castle||this.check||this.castled[n]?null:[],o=-1,h=this.pieces.length,c=0;c<h;c++){var p=this.pieces[c];if(!(p.p<0||p.s!=n)){var l=t.g.pTypes[p.t];l.isKing&&(p.m?s=null:o=p),s&&l.castle&&!p.m&&s.push(p);var u,v;u=l.graph[p.p],v=u.length;for(var b=0;b<v;b++)for(var f=u[b],d=!1,g=f.length,m=null,G=0;G<g;G++){var y=f[G],M=65535&y,C=this.board[M];if(!(C<0)||l.epCatch&&this.epTarget&&this.epTarget.p==M){if(!(524288&y)){var S;S=C<0?this.pieces[this.epTarget.i]:this.pieces[C],!(S.s!=p.s&&131072&y)||1048576&y&&!t.g.pTypes[S.t].isKing||2097152&y&&t.g.pTypes[S.t].isKing||e(p,{f:p.p,t:M,c:S.i,a:l.abbrev,ep:C<0});break}if(d){var S=this.pieces[C];S.s!=p.s&&e(p,{f:p.p,t:M,c:S.i,a:l.abbrev});break}d=!0}else 65536&y&&0==d&&e(p,{f:p.p,t:M,c:null,a:l.abbrev,ept:null!=m&&l.epTarget?m:void 0});m=M}}}if(s)for(var c=0;c<s.length;c++){var k=s[c],A=t.cbVar.castle[o.p+"/"+k.p];if(A){for(var T=!0,b=0;b<A.r.length;b++){var z=A.r[b];if(this.board[z]>=0&&z!=o.p&&z!=k.p){T=!1;break}}if(T){for(var P=!0,b=0;b<A.k.length;b++){var z=A.k[b];if(this.board[z]>=0&&z!=k.p&&z!=o.p||this.cbGetAttackers(t,z,n).length>0){P=!1;break}}P&&i.push({f:o.p,t:A.k[A.k.length-1],c:null,cg:k.p})}}}return i},Model.Board.cbStaticExchangeEval=function(t,e,r,i){var a=0,n=this.cbGetSmallestAttacker(t,e,r);if(n){var s=this.mWho;this.mWho=n.s;var o=this.cbQuickApply(t,{f:n.p,t:e,c:i.piece.i}),h=t.g.pTypes[i.piece.t].value;i.piece=n,a=Math.max(0,h-this.cbStaticExchangeEval(t,e,-r,i)),this.cbQuickUnapply(t,o),this.mWho=s}return a},Model.Board.cbGetSmallestAttacker=function(t,e,r){var i=this.cbGetAttackers(t,e,r);if(0==i.length)return null;for(var a=1/0,n=null,s=i.length,o=0;o<s;o++){var h=i[o],c=t.g.pTypes[h.t].value;c<a&&(a=c,n=h)}return n},Model.Board.cbCollectAttackers=function(t,e,r,i){for(var a in e){var n=e[a],s=this.board[a];if(s<0)this.cbCollectAttackers(t,n.e,r,i);else{var o=this.pieces[s];o.s==-t&&(n.t&&o.t in n.t||i&&n.tk&&o.t in n.tk)&&r.push(o)}}},Model.Board.cbCollectAttackersScreen=function(t,e,r,i,a){for(var n in e){var s=e[n],o=this.board[n];if(o<0)this.cbCollectAttackersScreen(t,s.e,r,i,a);else{var h=this.pieces[o];!a&&h.s==-t&&(s.t&&h.t in s.t||i&&s.tk&&h.t in s.tk)?r.push(h):a?a&&h.s==-t&&s.ts&&h.t in s.ts&&r.push(h):this.cbCollectAttackersScreen(t,s.e,r,i,!0)}}},Model.Board.cbGetAttackers=function(t,e,r,i){var a=[];return t.cbUseScreenCapture?this.cbCollectAttackersScreen(r,t.g.threatGraph[r][e],a,i,!1):this.cbCollectAttackers(r,t.g.threatGraph[r][e],a,i),a},Model.Board.GenerateMoves=function(t){var e=this.cbGeneratePseudoLegalMoves(t);this.mMoves=[];for(var r=!0,i=this.kings[this.mWho],a=e.length,n=0;n<a;n++){var s=e[n],o=this.cbQuickApply(t,s);if(!(this.cbGetAttackers(t,this.kings[this.mWho],this.mWho,!0).length>0)){var h=this.cbGetAttackers(t,this.kings[-this.mWho],-this.mWho,!0).length>0;s.ck=h,this.mMoves.push(s),s.f!=i&&(r=!1)}this.cbQuickUnapply(t,o)}if(0==this.mMoves.length)this.mFinished=!0,this.mWinner=t.cbOnStaleMate?t.cbOnStaleMate*this.mWho:JocGame.DRAW,this.check&&(this.mWinner=-this.mWho);else if(this.ending[this.mWho]){if(!r)for(var n=0;n<this.mMoves.length;n++)this.mMoves[n].ko=!1}else if(!this.ending[this.mWho]&&r&&!this.check)for(var n=0;n<this.mMoves.length;n++)this.mMoves[n].ko=!0},Model.Board.GetSignature=function(){return this.zSign},Model.Move.Init=function(t){for(var e in t)t.hasOwnProperty(e)&&(this[e]=t[e])},Model.Move.Equals=function(t){return this.f==t.f&&this.t==t.t&&this.pr==t.pr},Model.Move.CopyFrom=function(t){this.Init(t)},Model.Move.ToString=function(e){var r=this;switch(e=e||"natural"){case"natural":return function(){var e;if(void 0!==r.cg?e=t.castle[r.f+"/"+r.cg].n:(e=r.a||"",e+=t.geometry.PosName(r.f),null==r.c?e+="-":e+="x",e+=t.geometry.PosName(r.t)),void 0!==r.pr){var i=t.pieceTypes[r.pr];i&&i.abbrev&&i.abbrev.length>0&&!i.silentPromo&&(e+="="+i.abbrev)}return r.ck&&(e+="+"),e}();case"engine":return function(){var e=t.geometry.PosName(r.f)+t.geometry.PosName(r.t);if(void 0!=r.pr){var i=t.pieceTypes[r.pr];i&&i.abbrev&&i.abbrev.length>0&&!i.silentPromo&&(e+=i.abbrev)}return e}();default:return"??"}},Model.Board.CompactMoveString=function(e,r,i){"function"!=typeof r.ToString&&(r=e.CreateMove(r));var a=r.ToString(),n=/^([A-Z]?)([a-z])([1-9][0-9]*)([-x])([a-z])([1-9][0-9]*)(.*?)$/.exec(a);if(!n)return a;var s=n[7];if(i||(i={}),i.value||(i.value=[]),0==i.value.length){var o=this.mMoves;this.mMoves&&0!=this.mMoves.length||this.GenerateMoves(e);for(var h=0;h<this.mMoves.length;h++){var c=this.mMoves[h];"function"!=typeof c.ToString&&(c=e.CreateMove(c)),i.value.push({str:c.ToString(),move:c})}this.mMoves=o}var p=[];if(i.value.forEach(function(t){var e=/^([A-Z]?[a-z][1-9][0-9]*[-x][a-z][1-9][0-9]*)(.*?)$/.exec(t.str);e&&t.move.t==r.t&&(t.move.a||"")==n[1]&&e[2]==s&&p.push(t.move)}),1==p.length)return""==n[1]&&"x"==n[4]?n[2]+"x"+n[5]+n[6]+n[7]:n[1]+("x"==n[4]?"x":"")+n[5]+n[6]+n[7];if(t.geometry.CompactCrit)for(var l="",h=0;;h++){var u=t.geometry.CompactCrit(r.f,h);if(null==u)return a;l+=u;for(var v=[],b=0;b<p.length;b++){var f=p[b];t.geometry.CompactCrit(f.f,h)==u&&v.push(f)}if(console.assert(v.length>0),1==v.length)return n[1]+l+("x"==n[4]?"x":"")+n[5]+n[6]+n[7];p=v}return a},Model.Board.cbIntegrity=function(t){function e(t,e){t||console.error(e)}for(var r=this,i=0;i<this.board.length;i++){var a=this.board[i];if(a>=0){var n=r.pieces[a];e(void 0!==n,"no piece at pos"),e(n.p==i,"piece has different pos")}}for(var a=0;a<this.pieces.length;a++){var n=this.pieces[a];n.p>=0&&e(r.board[n.p]==a,"board index mismatch")}},Model.Board.ExportBoardState=function(t){return t.cbVar.geometry.ExportBoardState?t.cbVar.geometry.ExportBoardState(this,t.cbVar,t.mPlayedMoves.length):"not supported"},Model.Game.Import=function(e,r){var i,a=[],n={1:{},"-1":{}},s=null,o=0;if("pjn"==e){var h={status:!1,error:"parse"},c=r.split(" ");if(6!=c.length)return console.warn("FEN should have 6 parts"),h;var p=c[0].split("/"),l=t.geometry.fenHeight||t.geometry.height;if(p.length!=l)return console.warn("FEN board should have",l,"rows, got",p.length),h;var u={};for(var v in t.pieceTypes){var b=t.pieceTypes[v],f=b.fenAbbrev||b.abbrev||"X";u[f.toUpperCase()]={s:1,t:v},u[f.toLowerCase()]={s:-1,t:v}}var d=t.geometry.FenRowPos||function(e,r){return(t.geometry.height-1-e)*t.geometry.width+r};if(p.forEach(function(e,r){for(var i=0,n=0;n<e.length;n++){var s=e.substr(n,1),o=u[s];if(void 0!==o){var c=d(r,i);i++;for(var p={s:o.s,t:o.t,p:c},l=!0,v=t.pieceTypes[p.t].initial||[],b=0;b<v.length;b++){var f=v[b];f.s==p.s&&f.p==c&&(l=!1)}p.m=l,a.push(p)}else{if(isNaN(parseInt(s)))return console.warn("FEN invalid board spec",s),h;i+=parseInt(s)}}}),a.sort(function(t,e){return e.s-t.s}),"w"==c[1])i=1;else{if("b"!=c[1])return console.warn("FEN invalid turn spec",c[1]),h;i=-1}n[1].k=c[2].indexOf("K")>=0,n[1].q=c[2].indexOf("Q")>=0,n[-1].k=c[2].indexOf("k")>=0,n[-1].q=c[2].indexOf("q")>=0,s="-"==c[3]?null:c[3];var g=parseInt(c[4]);isNaN(g)||(o=g);var m={pieces:a,turn:i,castle:n,enPassant:s,noCaptCount:o};return t.importGame&&t.importGame.call(this,m,e,r),{status:!0,initial:m}}return{status:!1,error:"unsupported"}}}(),function(){Model.Game.cbBoardGeometryCylinder=function(t,e){function r(e){return e%t}function i(e){return Math.floor(e/t)}function a(e,r){return r*t+e}function n(n,s){for(var o=r(n),h=i(n),c=o+s[0];c<0;)c+=t;c%=t;var p=h+s[1];return p<0||p>=e?null:a(c,p)}function s(t){return String.fromCharCode("a".charCodeAt(0)+r(t))+(i(t)+1)}function o(t){var e=/^([a-z])([0-9]+)$/.exec(t);return e?a(e[1].charCodeAt(0)-"a".charCodeAt(0),parseInt(e[2])-1):-1}function h(t,e){return 0==e?String.fromCharCode("a".charCodeAt(0)+r(t)):1==e?i(t)+1:null}function c(){return l}for(var p=t*e,l={},u=0;u<p;u++)l[u]={},l[u][u]=0;for(var v=[[1,-1],[1,0],[1,1],[0,-1],[0,1],[-1,-1],[-1,0],[-1,-1]],b=!0;b;){b=!1;for(var u=0;u<p;u++)v.forEach(function(t){var e=n(u,t);if(null!=e){1!=l[u][e]&&(l[u][e]=1,l[e][u]=1,b=!0);for(var r=0;r<p;r++)r!=u&&(void 0===l[e][r]&&void 0!==l[u][r]?(l[e][r]=l[u][r]+1,l[r][e]=l[u][r]+1,b=!0):void 0!==l[e][r]&&void 0!==l[u][r]&&l[e][r]>l[u][r]+1&&(l[e][r]=l[u][r]+1,l[r][e]=l[u][r]+1,b=!0))}})}for(var f={},b=!0;b;){b=!1;for(var u=0;u<p;u++)u in f||v.forEach(function(t){var e=n(u,t);null==e?f[u]=1:e in f&&(u in f&&!(f[u]>f[e]+1)||(f[u]=f[e]+1,b=!0))})}return{boardSize:p,width:t,height:e,C:r,R:i,POS:a,Graph:n,PosName:s,PosByName:o,CompactCrit:h,GetDistances:c,distEdge:f,corners:null}},Model.Game.cbPawnGraph=function(t,e){for(var r=this,i={},a=0;a<t.boardSize;a++){var n=[],s=t.Graph(a,[0,e]);null!=s&&n.push(r.cbTypedArray([s|r.cbConstants.FLAG_MOVE])),[-1,1].forEach(function(i){var s=t.Graph(a,[i,e]);null!=s&&n.push(r.cbTypedArray([s|r.cbConstants.FLAG_CAPTURE]))}),i[a]=n}return i},Model.Game.cbInitialPawnGraph=function(t,e){for(var r=this,i={},a=0;a<t.boardSize;a++){var n=[],s=t.Graph(a,[0,e]);if(null!=s){var o=[s|r.cbConstants.FLAG_MOVE],h=t.Graph(s,[0,e]);null!=h&&o.push(h|r.cbConstants.FLAG_MOVE),n.push(r.cbTypedArray(o))}[-1,1].forEach(function(i){var s=t.Graph(a,[i,e]);null!=s&&n.push(r.cbTypedArray([s|r.cbConstants.FLAG_CAPTURE]))}),i[a]=n}return i},Model.Game.cbKingGraph=function(t){return this.cbShortRangeGraph(t,[[-1,-1],[-1,0],[-1,1],[0,-1],[0,1],[1,-1],[1,0],[1,1]])},Model.Game.cbKnightGraph=function(t){return this.cbShortRangeGraph(t,[[2,-1],[2,1],[-2,-1],[-2,1],[-1,2],[-1,-2],[1,2],[1,-2]])},Model.Game.cbHorseGraph=function(t){for(var e=this,r={},i=0;i<t.boardSize;i++)r[i]=[],[[1,0,2,-1],[1,0,2,1],[-1,0,-2,-1],[-1,0,-2,1],[0,1,-1,2],[0,-1,-1,-2],[0,1,1,2],[0,-1,1,-2]].forEach(function(a){var n=t.Graph(i,[a[0],a[1]]);if(null!=n){var s=t.Graph(i,[a[2],a[3]]);null!=s&&r[i].push(e.cbTypedArray([n|e.cbConstants.FLAG_STOP,s|e.cbConstants.FLAG_MOVE|e.cbConstants.FLAG_CAPTURE]))}});return r},Model.Game.cbRookGraph=function(t){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0]])},Model.Game.cbBishopGraph=function(t){return this.cbLongRangeGraph(t,[[1,-1],[1,1],[-1,1],[-1,-1]])},Model.Game.cbQueenGraph=function(t){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0],[1,-1],[1,1],[-1,1],[-1,-1]])},Model.Game.cbXQGeneralGraph=function(t,e){for(var r=this,i={},a=0;a<t.boardSize;a++)i[a]=[],[[-1,0,!1],[0,-1,!0],[0,1,!0],[1,0,!1]].forEach(function(n){var s=[],o=t.Graph(a,n);if(null!=o&&((!e||o in e)&&s.push(o|r.cbConstants.FLAG_MOVE|r.cbConstants.FLAG_CAPTURE),n[2]))for(var h=t.Graph(o,n);null!=h;)!e||h in e?s.push(h|r.cbConstants.FLAG_CAPTURE|r.cbConstants.FLAG_CAPTURE_KING):s.push(h|r.cbConstants.FLAG_STOP),h=t.Graph(h,n);s.length>0&&i[a].push(r.cbTypedArray(s))});return i},Model.Game.cbXQSoldierGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e]])},Model.Game.cbXQPromoSoldierGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e],[-1,0],[1,0]])},Model.Game.cbXQAdvisorGraph=function(t,e){return this.cbShortRangeGraph(t,[[1,1],[-1,1],[1,-1],[-1,-1]],e)},Model.Game.cbXQCannonGraph=function(t){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0]],null,this.cbConstants.FLAG_MOVE|this.cbConstants.FLAG_SCREEN_CAPTURE)},Model.Game.cbXQElephantGraph=function(t,e){for(var r=this,i={},a=0;a<t.boardSize;a++)i[a]=[],(!e||a in e)&&[[1,1,2,2],[1,-1,2,-2],[-1,1,-2,2],[-1,-1,-2,-2]].forEach(function(n){var s=t.Graph(a,[n[0],n[1]]);if(null!=s){var o=t.Graph(a,[n[2],n[3]]);null!=o&&(!e||o in e)&&i[a].push(r.cbTypedArray([s|r.cbConstants.FLAG_STOP,o|r.cbConstants.FLAG_MOVE|r.cbConstants.FLAG_CAPTURE]))}});return i},Model.Game.cbSilverGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e],[-1,-1],[-1,1],[1,-1],[1,1]])},Model.Game.cbFersGraph=function(t,e){return this.cbShortRangeGraph(t,[[-1,-1],[-1,1],[1,-1],[1,1]])},Model.Game.cbElephantGraph=function(t,e){return this.cbShortRangeGraph(t,[[-2,-2],[-2,2],[2,-2],[2,2]])},Model.Game.cbSchleichGraph=function(t,e){return this.cbShortRangeGraph(t,[[-1,0],[1,0],[0,-1],[0,1]])},Model.Game.cbAlfilGraph=function(t,e){return this.cbShortRangeGraph(t,[[-2,-2],[-2,2],[2,2],[2,-2]])},Model.Game.cbCylinderRookGraph=function(t){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0]],null,null,Math.max(t.width,t.height)-1)},Model.Game.cbCircularPawnGraph=function(t,e,r){var i=this.cbLongRangeGraph(t,e?[[1,0]]:[[-1,0]],null,this.cbConstants.FLAG_MOVE,r),a=this.cbShortRangeGraph(t,e?[[1,1],[1,-1]]:[[-1,1],[-1,-1]],null,this.cbConstants.FLAG_CAPTURE);return this.cbMergeGraphs(t,i,a)}}(),function(){var t=Model.Game.cbBoardGeometryCylinder(8,8);Model.Game.cbDefine=function(){return{geometry:t,pieceTypes:{0:{name:"pawn-w",aspect:"pawn",graph:this.cbPawnGraph(t,1),value:1,abbrev:"",fenAbbrev:"P",epCatch:!0},1:{name:"ipawn-w",aspect:"pawn",graph:this.cbInitialPawnGraph(t,1),value:1,abbrev:"",fenAbbrev:"P",initial:[{s:1,p:8},{s:1,p:9},{s:1,p:10},{s:1,p:11},{s:1,p:12},{s:1,p:13},{s:1,p:14},{s:1,p:15}],epTarget:!0},2:{name:"pawn-b",aspect:"pawn",graph:this.cbPawnGraph(t,-1),value:1,abbrev:"",fenAbbrev:"P",epCatch:!0},3:{name:"ipawn-b",aspect:"pawn",graph:this.cbInitialPawnGraph(t,-1),value:1,abbrev:"",fenAbbrev:"P",initial:[{s:-1,p:48},{s:-1,p:49},{s:-1,p:50},{s:-1,p:51},{s:-1,p:52},{s:-1,p:53},{s:-1,p:54},{s:-1,p:55}],epTarget:!0},4:{name:"knight",graph:this.cbKnightGraph(t),value:2.9,abbrev:"N",initial:[{s:1,p:1},{s:1,p:6},{s:-1,p:57},{s:-1,p:62}]},5:{name:"bishop",graph:this.cbBishopGraph(t),value:3.1,abbrev:"B",initial:[{s:1,p:2},{s:1,p:5},{s:-1,p:58},{s:-1,p:61}]},6:{name:"rook",graph:this.cbCylinderRookGraph(t),value:5,abbrev:"R",initial:[{s:1,p:0},{s:1,p:7},{s:-1,p:56},{s:-1,p:63}],castle:!0},7:{name:"queen",graph:this.cbMergeGraphs(t,this.cbCylinderRookGraph(t),this.cbBishopGraph(t)),value:9,abbrev:"Q",initial:[{s:1,p:3},{s:-1,p:59}]},8:{name:"king",isKing:!0,graph:this.cbKingGraph(t),abbrev:"K",initial:[{s:1,p:4},{s:-1,p:60}]}},promote:function(e,r,i){return 1==r.t?[0]:3==r.t?[2]:0==r.t&&7==t.R(i.t)?[4,5,6,7]:2==r.t&&0==t.R(i.t)?[4,5,6,7]:[]},castle:{"4/0":{k:[3,2],r:[1,2,3],n:"O-O-O"},"4/7":{k:[5,6],r:[6,5],n:"O-O"},"60/56":{k:[59,58],r:[57,58,59],n:"O-O-O"},"60/63":{k:[61,62],r:[62,61],n:"O-O"}},evaluate:function(e,r,i){var a=i[1].count,n=i[-1].count;a[0]||a[1]||a[4]||a[5]||a[6]||a[7]||n[2]||n[3]||n[6]||n[7]||!(n[4]+n[5]<2||n[5]<2)||(this.mFinished=!0,this.mWinner=JocGame.DRAW),n[2]||n[3]||n[4]||n[5]||n[6]||n[7]||a[0]||a[1]||a[6]||a[7]||!(a[4]+a[5]<2||a[5]<2)||(this.mFinished=!0,this.mWinner=JocGame.DRAW),this.noCaptCount>=100&&(this.mFinished=!0,this.mWinner=JocGame.DRAW);var s,o=e.cbUseTypedArrays?new Int8Array(3):[0,0,0],h=t.height,c=i[1].byType[0];if(c){s=c.length;for(var p=0;p<s;p++)switch(h-t.R(c[p].p)){case 2:o[0]++;break;case 3:o[1]++;break;case 4:o[2]++}}if(c=i[-1].byType[2]){s=c.length;for(var p=0;p<s;p++)switch(t.R(c[p].p)){case 1:o[0]--;break;case 2:o[1]--;break;case 3:o[2]--}}0!=o[0]&&(r.distPawnPromo1=o[0]),0!=o[1]&&(r.distPawnPromo2=o[1]),0!=o[2]&&(r.distPawnPromo3=o[2]);for(var l=0,u=4;u<=5;u++)for(var v=1;v>=-1;v-=2){var b=i[v].byType[u];if(b)for(var p=0;p<b.length;p++)b[p].m&&(l+=v)}0!=l&&(r.minorPiecesMoved=l)}}}}();

/***/ }),

/***/ "s/E6":
/***/ (function(module, exports) {

exports.config = {"status":true,"model":{"js":["reversi-model.js"],"plazza":"true","released":1409239768,"title-en":"Annexation","module":"reversi","summary":"Also called Reversi or Othello","thumbnail":"thumb-reversi.png","rules":{"en":"rules-reversi.html"},"credits":{"en":"credits.html"},"description":{"en":"description.html"},"gameOptions":{"preventRepeat":true,"uctTransposition":"state","levelOptions":{"stableFactor":20,"aboutStableFactor":-20,"aboutStableBorderFactor":-15,"borderFactor":5,"aboutBorderFactor":-4,"countFactor":1,"mobilityFactor":5},"width":8,"height":8,"initial":{"1":["3:4","4:3"],"-1":["3:3","4:4"]}},"debugEval":true,"levels":[{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.65,"ignoreLeaf":false,"log":true,"uncertaintyFactor":3,"name":"easy","label":"Easy","maxNodes":1000},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.65,"ignoreLeaf":false,"log":true,"uncertaintyFactor":3,"name":"fast","label":"Fast [1sec]","maxDuration":1,"isDefault":true},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.65,"ignoreLeaf":false,"log":true,"uncertaintyFactor":3,"name":"medium","label":"Medium","maxNodes":10000,"maxDuration":10},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.65,"ignoreLeaf":false,"log":true,"uncertaintyFactor":3,"name":"strong","label":"Strong","maxNodes":20000,"maxDuration":15}]},"view":{"title-en":"Annex View","js":["reversi-xd-view.js"],"xdView":true,"useNotation":true,"useShowMoves":true,"module":"reversi","skins":[{"name":"classic3d","title":"3D Classic","3d":true,"camera":{"radius":14,"elevationAngle":45,"distMax":39.5,"distMin":10.1,"elevationMin":-89.9,"elevationMax":89.9,"limitCamMoves":true,"fov":45},"world":{"lightIntensity":0.7,"skyLightIntensity":0.3,"lightPosition":{"x":10,"y":18,"z":0},"lightShadowDarkness":0.35,"color":4686804,"ambientLightColor":5592405,"fog":false},"preload":["image|/res/xd-view/pass-dark.png","image|/res/xd-view/pass-light.png","image|/res/images/wood-chipboard-5.jpg","image|/res/xd-view/reversi-pieces-2-textures.png","image|/res/xd-view/reversi-pieces-2-textures-bump.png","smoothedfilegeo|0|/res/xd-view/ring-target.js","smoothedfilegeo|0|/res/xd-view/reversi-pieces-6.js"]},{"name":"classic2d","title":"2D Classic","preload":["image|/res/xd-view/pass-dark.png","image|/res/xd-view/pass-light.png","image|/res/xd-view/boardtexture.jpg","image|/res/xd-view/cellshadows.png","image|/res/xd-view/sprites.png","image|/res/xd-view/select-target-2d.png"]}],"visuals":{"600x600":["res/visuals/reversi-600x600-3d.jpg","res/visuals/reversi-600x600-2d.jpg"]}}}

/***/ }),

/***/ "s3oX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ErrorObservable_1 = __webpack_require__("Dkzu");
exports._throw = ErrorObservable_1.ErrorObservable.create;
//# sourceMappingURL=throw.js.map

/***/ }),

/***/ "sIYO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subject_1 = __webpack_require__("EEr4");
var Observable_1 = __webpack_require__("rCTf");
var Subscriber_1 = __webpack_require__("mmVS");
var Subscription_1 = __webpack_require__("B00U");
/**
 * @class ConnectableObservable<T>
 */
var ConnectableObservable = (function (_super) {
    __extends(ConnectableObservable, _super);
    function ConnectableObservable(source, subjectFactory) {
        _super.call(this);
        this.source = source;
        this.subjectFactory = subjectFactory;
        this._refCount = 0;
    }
    ConnectableObservable.prototype._subscribe = function (subscriber) {
        return this.getSubject().subscribe(subscriber);
    };
    ConnectableObservable.prototype.getSubject = function () {
        var subject = this._subject;
        if (!subject || subject.isStopped) {
            this._subject = this.subjectFactory();
        }
        return this._subject;
    };
    ConnectableObservable.prototype.connect = function () {
        var connection = this._connection;
        if (!connection) {
            connection = this._connection = new Subscription_1.Subscription();
            connection.add(this.source
                .subscribe(new ConnectableSubscriber(this.getSubject(), this)));
            if (connection.closed) {
                this._connection = null;
                connection = Subscription_1.Subscription.EMPTY;
            }
            else {
                this._connection = connection;
            }
        }
        return connection;
    };
    ConnectableObservable.prototype.refCount = function () {
        return this.lift(new RefCountOperator(this));
    };
    return ConnectableObservable;
}(Observable_1.Observable));
exports.ConnectableObservable = ConnectableObservable;
exports.connectableObservableDescriptor = {
    operator: { value: null },
    _refCount: { value: 0, writable: true },
    _subject: { value: null, writable: true },
    _connection: { value: null, writable: true },
    _subscribe: { value: ConnectableObservable.prototype._subscribe },
    getSubject: { value: ConnectableObservable.prototype.getSubject },
    connect: { value: ConnectableObservable.prototype.connect },
    refCount: { value: ConnectableObservable.prototype.refCount }
};
var ConnectableSubscriber = (function (_super) {
    __extends(ConnectableSubscriber, _super);
    function ConnectableSubscriber(destination, connectable) {
        _super.call(this, destination);
        this.connectable = connectable;
    }
    ConnectableSubscriber.prototype._error = function (err) {
        this._unsubscribe();
        _super.prototype._error.call(this, err);
    };
    ConnectableSubscriber.prototype._complete = function () {
        this._unsubscribe();
        _super.prototype._complete.call(this);
    };
    ConnectableSubscriber.prototype._unsubscribe = function () {
        var connectable = this.connectable;
        if (connectable) {
            this.connectable = null;
            var connection = connectable._connection;
            connectable._refCount = 0;
            connectable._subject = null;
            connectable._connection = null;
            if (connection) {
                connection.unsubscribe();
            }
        }
    };
    return ConnectableSubscriber;
}(Subject_1.SubjectSubscriber));
var RefCountOperator = (function () {
    function RefCountOperator(connectable) {
        this.connectable = connectable;
    }
    RefCountOperator.prototype.call = function (subscriber, source) {
        var connectable = this.connectable;
        connectable._refCount++;
        var refCounter = new RefCountSubscriber(subscriber, connectable);
        var subscription = source.subscribe(refCounter);
        if (!refCounter.closed) {
            refCounter.connection = connectable.connect();
        }
        return subscription;
    };
    return RefCountOperator;
}());
var RefCountSubscriber = (function (_super) {
    __extends(RefCountSubscriber, _super);
    function RefCountSubscriber(destination, connectable) {
        _super.call(this, destination);
        this.connectable = connectable;
    }
    RefCountSubscriber.prototype._unsubscribe = function () {
        var connectable = this.connectable;
        if (!connectable) {
            this.connection = null;
            return;
        }
        this.connectable = null;
        var refCount = connectable._refCount;
        if (refCount <= 0) {
            this.connection = null;
            return;
        }
        connectable._refCount = refCount - 1;
        if (refCount > 1) {
            this.connection = null;
            return;
        }
        ///
        // Compare the local RefCountSubscriber's connection Subscription to the
        // connection Subscription on the shared ConnectableObservable. In cases
        // where the ConnectableObservable source synchronously emits values, and
        // the RefCountSubscriber's downstream Observers synchronously unsubscribe,
        // execution continues to here before the RefCountOperator has a chance to
        // supply the RefCountSubscriber with the shared connection Subscription.
        // For example:
        // ```
        // Observable.range(0, 10)
        //   .publish()
        //   .refCount()
        //   .take(5)
        //   .subscribe();
        // ```
        // In order to account for this case, RefCountSubscriber should only dispose
        // the ConnectableObservable's shared connection Subscription if the
        // connection Subscription exists, *and* either:
        //   a. RefCountSubscriber doesn't have a reference to the shared connection
        //      Subscription yet, or,
        //   b. RefCountSubscriber's connection Subscription reference is identical
        //      to the shared connection Subscription
        ///
        var connection = this.connection;
        var sharedConnection = connectable._connection;
        this.connection = null;
        if (sharedConnection && (!connection || sharedConnection === connection)) {
            sharedConnection.unsubscribe();
        }
    };
    return RefCountSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=ConnectableObservable.js.map

/***/ }),

/***/ "sJIX":
/***/ (function(module, exports, __webpack_require__) {

var jqplayer = __webpack_require__("pUca");



/***/ }),

/***/ "sKQ8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subject_1 = __webpack_require__("EEr4");
var async_1 = __webpack_require__("CGGv");
var Subscriber_1 = __webpack_require__("mmVS");
var isNumeric_1 = __webpack_require__("P3oE");
var isScheduler_1 = __webpack_require__("fWbP");
function windowTime(windowTimeSpan) {
    var scheduler = async_1.async;
    var windowCreationInterval = null;
    var maxWindowSize = Number.POSITIVE_INFINITY;
    if (isScheduler_1.isScheduler(arguments[3])) {
        scheduler = arguments[3];
    }
    if (isScheduler_1.isScheduler(arguments[2])) {
        scheduler = arguments[2];
    }
    else if (isNumeric_1.isNumeric(arguments[2])) {
        maxWindowSize = arguments[2];
    }
    if (isScheduler_1.isScheduler(arguments[1])) {
        scheduler = arguments[1];
    }
    else if (isNumeric_1.isNumeric(arguments[1])) {
        windowCreationInterval = arguments[1];
    }
    return this.lift(new WindowTimeOperator(windowTimeSpan, windowCreationInterval, maxWindowSize, scheduler));
}
exports.windowTime = windowTime;
var WindowTimeOperator = (function () {
    function WindowTimeOperator(windowTimeSpan, windowCreationInterval, maxWindowSize, scheduler) {
        this.windowTimeSpan = windowTimeSpan;
        this.windowCreationInterval = windowCreationInterval;
        this.maxWindowSize = maxWindowSize;
        this.scheduler = scheduler;
    }
    WindowTimeOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new WindowTimeSubscriber(subscriber, this.windowTimeSpan, this.windowCreationInterval, this.maxWindowSize, this.scheduler));
    };
    return WindowTimeOperator;
}());
var CountedSubject = (function (_super) {
    __extends(CountedSubject, _super);
    function CountedSubject() {
        _super.apply(this, arguments);
        this._numberOfNextedValues = 0;
    }
    CountedSubject.prototype.next = function (value) {
        this._numberOfNextedValues++;
        _super.prototype.next.call(this, value);
    };
    Object.defineProperty(CountedSubject.prototype, "numberOfNextedValues", {
        get: function () {
            return this._numberOfNextedValues;
        },
        enumerable: true,
        configurable: true
    });
    return CountedSubject;
}(Subject_1.Subject));
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var WindowTimeSubscriber = (function (_super) {
    __extends(WindowTimeSubscriber, _super);
    function WindowTimeSubscriber(destination, windowTimeSpan, windowCreationInterval, maxWindowSize, scheduler) {
        _super.call(this, destination);
        this.destination = destination;
        this.windowTimeSpan = windowTimeSpan;
        this.windowCreationInterval = windowCreationInterval;
        this.maxWindowSize = maxWindowSize;
        this.scheduler = scheduler;
        this.windows = [];
        var window = this.openWindow();
        if (windowCreationInterval !== null && windowCreationInterval >= 0) {
            var closeState = { subscriber: this, window: window, context: null };
            var creationState = { windowTimeSpan: windowTimeSpan, windowCreationInterval: windowCreationInterval, subscriber: this, scheduler: scheduler };
            this.add(scheduler.schedule(dispatchWindowClose, windowTimeSpan, closeState));
            this.add(scheduler.schedule(dispatchWindowCreation, windowCreationInterval, creationState));
        }
        else {
            var timeSpanOnlyState = { subscriber: this, window: window, windowTimeSpan: windowTimeSpan };
            this.add(scheduler.schedule(dispatchWindowTimeSpanOnly, windowTimeSpan, timeSpanOnlyState));
        }
    }
    WindowTimeSubscriber.prototype._next = function (value) {
        var windows = this.windows;
        var len = windows.length;
        for (var i = 0; i < len; i++) {
            var window_1 = windows[i];
            if (!window_1.closed) {
                window_1.next(value);
                if (window_1.numberOfNextedValues >= this.maxWindowSize) {
                    this.closeWindow(window_1);
                }
            }
        }
    };
    WindowTimeSubscriber.prototype._error = function (err) {
        var windows = this.windows;
        while (windows.length > 0) {
            windows.shift().error(err);
        }
        this.destination.error(err);
    };
    WindowTimeSubscriber.prototype._complete = function () {
        var windows = this.windows;
        while (windows.length > 0) {
            var window_2 = windows.shift();
            if (!window_2.closed) {
                window_2.complete();
            }
        }
        this.destination.complete();
    };
    WindowTimeSubscriber.prototype.openWindow = function () {
        var window = new CountedSubject();
        this.windows.push(window);
        var destination = this.destination;
        destination.next(window);
        return window;
    };
    WindowTimeSubscriber.prototype.closeWindow = function (window) {
        window.complete();
        var windows = this.windows;
        windows.splice(windows.indexOf(window), 1);
    };
    return WindowTimeSubscriber;
}(Subscriber_1.Subscriber));
function dispatchWindowTimeSpanOnly(state) {
    var subscriber = state.subscriber, windowTimeSpan = state.windowTimeSpan, window = state.window;
    if (window) {
        subscriber.closeWindow(window);
    }
    state.window = subscriber.openWindow();
    this.schedule(state, windowTimeSpan);
}
function dispatchWindowCreation(state) {
    var windowTimeSpan = state.windowTimeSpan, subscriber = state.subscriber, scheduler = state.scheduler, windowCreationInterval = state.windowCreationInterval;
    var window = subscriber.openWindow();
    var action = this;
    var context = { action: action, subscription: null };
    var timeSpanState = { subscriber: subscriber, window: window, context: context };
    context.subscription = scheduler.schedule(dispatchWindowClose, windowTimeSpan, timeSpanState);
    action.add(context.subscription);
    action.schedule(state, windowCreationInterval);
}
function dispatchWindowClose(state) {
    var subscriber = state.subscriber, window = state.window, context = state.context;
    if (context && context.action && context.subscription) {
        context.action.remove(context.subscription);
    }
    subscriber.closeWindow(window);
}
//# sourceMappingURL=windowTime.js.map

/***/ }),

/***/ "sOR5":
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),

/***/ "sT3i":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var expand_1 = __webpack_require__("q+ny");
Observable_1.Observable.prototype.expand = expand_1.expand;
//# sourceMappingURL=expand.js.map

/***/ }),

/***/ "sVus":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__("mmVS");
var async_1 = __webpack_require__("CGGv");
/**
 * @param scheduler
 * @return {Observable<TimeInterval<any>>|WebSocketSubject<T>|Observable<T>}
 * @method timeInterval
 * @owner Observable
 */
function timeInterval(scheduler) {
    if (scheduler === void 0) { scheduler = async_1.async; }
    return this.lift(new TimeIntervalOperator(scheduler));
}
exports.timeInterval = timeInterval;
var TimeInterval = (function () {
    function TimeInterval(value, interval) {
        this.value = value;
        this.interval = interval;
    }
    return TimeInterval;
}());
exports.TimeInterval = TimeInterval;
;
var TimeIntervalOperator = (function () {
    function TimeIntervalOperator(scheduler) {
        this.scheduler = scheduler;
    }
    TimeIntervalOperator.prototype.call = function (observer, source) {
        return source.subscribe(new TimeIntervalSubscriber(observer, this.scheduler));
    };
    return TimeIntervalOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var TimeIntervalSubscriber = (function (_super) {
    __extends(TimeIntervalSubscriber, _super);
    function TimeIntervalSubscriber(destination, scheduler) {
        _super.call(this, destination);
        this.scheduler = scheduler;
        this.lastTime = 0;
        this.lastTime = scheduler.now();
    }
    TimeIntervalSubscriber.prototype._next = function (value) {
        var now = this.scheduler.now();
        var span = now - this.lastTime;
        this.lastTime = now;
        this.destination.next(new TimeInterval(value, span));
    };
    return TimeIntervalSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=timeInterval.js.map

/***/ }),

/***/ "sake":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__("mmVS");
/**
 * Returns an Observable that skips all items emitted by the source Observable as long as a specified condition holds
 * true, but emits all further source items as soon as the condition becomes false.
 *
 * <img src="./img/skipWhile.png" width="100%">
 *
 * @param {Function} predicate - A function to test each item emitted from the source Observable.
 * @return {Observable<T>} An Observable that begins emitting items emitted by the source Observable when the
 * specified predicate becomes false.
 * @method skipWhile
 * @owner Observable
 */
function skipWhile(predicate) {
    return this.lift(new SkipWhileOperator(predicate));
}
exports.skipWhile = skipWhile;
var SkipWhileOperator = (function () {
    function SkipWhileOperator(predicate) {
        this.predicate = predicate;
    }
    SkipWhileOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new SkipWhileSubscriber(subscriber, this.predicate));
    };
    return SkipWhileOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var SkipWhileSubscriber = (function (_super) {
    __extends(SkipWhileSubscriber, _super);
    function SkipWhileSubscriber(destination, predicate) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.skipping = true;
        this.index = 0;
    }
    SkipWhileSubscriber.prototype._next = function (value) {
        var destination = this.destination;
        if (this.skipping) {
            this.tryCallPredicate(value);
        }
        if (!this.skipping) {
            destination.next(value);
        }
    };
    SkipWhileSubscriber.prototype.tryCallPredicate = function (value) {
        try {
            var result = this.predicate(value, this.index++);
            this.skipping = Boolean(result);
        }
        catch (err) {
            this.destination.error(err);
        }
    };
    return SkipWhileSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=skipWhile.js.map

/***/ }),

/***/ "sb+e":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @param func
 * @return {Observable<R>}
 * @method let
 * @owner Observable
 */
function letProto(func) {
    return func(this);
}
exports.letProto = letProto;
//# sourceMappingURL=let.js.map

/***/ }),

/***/ "t2Bb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__("mmVS");
var async_1 = __webpack_require__("CGGv");
/**
 * Emits the most recently emitted value from the source Observable within
 * periodic time intervals.
 *
 * <span class="informal">Samples the source Observable at periodic time
 * intervals, emitting what it samples.</span>
 *
 * <img src="./img/sampleTime.png" width="100%">
 *
 * `sampleTime` periodically looks at the source Observable and emits whichever
 * value it has most recently emitted since the previous sampling, unless the
 * source has not emitted anything since the previous sampling. The sampling
 * happens periodically in time every `period` milliseconds (or the time unit
 * defined by the optional `scheduler` argument). The sampling starts as soon as
 * the output Observable is subscribed.
 *
 * @example <caption>Every second, emit the most recent click at most once</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.sampleTime(1000);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link auditTime}
 * @see {@link debounceTime}
 * @see {@link delay}
 * @see {@link sample}
 * @see {@link throttleTime}
 *
 * @param {number} period The sampling period expressed in milliseconds or the
 * time unit determined internally by the optional `scheduler`.
 * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
 * managing the timers that handle the sampling.
 * @return {Observable<T>} An Observable that emits the results of sampling the
 * values emitted by the source Observable at the specified time interval.
 * @method sampleTime
 * @owner Observable
 */
function sampleTime(period, scheduler) {
    if (scheduler === void 0) { scheduler = async_1.async; }
    return this.lift(new SampleTimeOperator(period, scheduler));
}
exports.sampleTime = sampleTime;
var SampleTimeOperator = (function () {
    function SampleTimeOperator(period, scheduler) {
        this.period = period;
        this.scheduler = scheduler;
    }
    SampleTimeOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new SampleTimeSubscriber(subscriber, this.period, this.scheduler));
    };
    return SampleTimeOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var SampleTimeSubscriber = (function (_super) {
    __extends(SampleTimeSubscriber, _super);
    function SampleTimeSubscriber(destination, period, scheduler) {
        _super.call(this, destination);
        this.period = period;
        this.scheduler = scheduler;
        this.hasValue = false;
        this.add(scheduler.schedule(dispatchNotification, period, { subscriber: this, period: period }));
    }
    SampleTimeSubscriber.prototype._next = function (value) {
        this.lastValue = value;
        this.hasValue = true;
    };
    SampleTimeSubscriber.prototype.notifyNext = function () {
        if (this.hasValue) {
            this.hasValue = false;
            this.destination.next(this.lastValue);
        }
    };
    return SampleTimeSubscriber;
}(Subscriber_1.Subscriber));
function dispatchNotification(state) {
    var subscriber = state.subscriber, period = state.period;
    subscriber.notifyNext();
    this.schedule(state, period);
}
//# sourceMappingURL=sampleTime.js.map

/***/ }),

/***/ "t2qv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Observable_1 = __webpack_require__("rCTf");
var EmptyObservable_1 = __webpack_require__("jBEF");
var isArray_1 = __webpack_require__("Xajo");
var subscribeToResult_1 = __webpack_require__("CURp");
var OuterSubscriber_1 = __webpack_require__("wAkD");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @extends {Ignored}
 * @hide true
 */
var ForkJoinObservable = (function (_super) {
    __extends(ForkJoinObservable, _super);
    function ForkJoinObservable(sources, resultSelector) {
        _super.call(this);
        this.sources = sources;
        this.resultSelector = resultSelector;
    }
    /* tslint:enable:max-line-length */
    /**
     * @param sources
     * @return {any}
     * @static true
     * @name forkJoin
     * @owner Observable
     */
    ForkJoinObservable.create = function () {
        var sources = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            sources[_i - 0] = arguments[_i];
        }
        if (sources === null || arguments.length === 0) {
            return new EmptyObservable_1.EmptyObservable();
        }
        var resultSelector = null;
        if (typeof sources[sources.length - 1] === 'function') {
            resultSelector = sources.pop();
        }
        // if the first and only other argument besides the resultSelector is an array
        // assume it's been called with `forkJoin([obs1, obs2, obs3], resultSelector)`
        if (sources.length === 1 && isArray_1.isArray(sources[0])) {
            sources = sources[0];
        }
        if (sources.length === 0) {
            return new EmptyObservable_1.EmptyObservable();
        }
        return new ForkJoinObservable(sources, resultSelector);
    };
    ForkJoinObservable.prototype._subscribe = function (subscriber) {
        return new ForkJoinSubscriber(subscriber, this.sources, this.resultSelector);
    };
    return ForkJoinObservable;
}(Observable_1.Observable));
exports.ForkJoinObservable = ForkJoinObservable;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var ForkJoinSubscriber = (function (_super) {
    __extends(ForkJoinSubscriber, _super);
    function ForkJoinSubscriber(destination, sources, resultSelector) {
        _super.call(this, destination);
        this.sources = sources;
        this.resultSelector = resultSelector;
        this.completed = 0;
        this.haveValues = 0;
        var len = sources.length;
        this.total = len;
        this.values = new Array(len);
        for (var i = 0; i < len; i++) {
            var source = sources[i];
            var innerSubscription = subscribeToResult_1.subscribeToResult(this, source, null, i);
            if (innerSubscription) {
                innerSubscription.outerIndex = i;
                this.add(innerSubscription);
            }
        }
    }
    ForkJoinSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.values[outerIndex] = innerValue;
        if (!innerSub._hasValue) {
            innerSub._hasValue = true;
            this.haveValues++;
        }
    };
    ForkJoinSubscriber.prototype.notifyComplete = function (innerSub) {
        var destination = this.destination;
        var _a = this, haveValues = _a.haveValues, resultSelector = _a.resultSelector, values = _a.values;
        var len = values.length;
        if (!innerSub._hasValue) {
            destination.complete();
            return;
        }
        this.completed++;
        if (this.completed !== len) {
            return;
        }
        if (haveValues === len) {
            var value = resultSelector ? resultSelector.apply(this, values) : values;
            destination.next(value);
        }
        destination.complete();
    };
    return ForkJoinSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=ForkJoinObservable.js.map

/***/ }),

/***/ "t8yF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var pluck_1 = __webpack_require__("U9ky");
var map_1 = __webpack_require__("xAJs");
var distinctUntilChanged_1 = __webpack_require__("8hgl");
function select(pathOrMapFn) {
    var paths = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        paths[_i - 1] = arguments[_i];
    }
    var mapped$;
    if (typeof pathOrMapFn === 'string') {
        mapped$ = pluck_1.pluck.call.apply(pluck_1.pluck, [this, pathOrMapFn].concat(paths));
    }
    else if (typeof pathOrMapFn === 'function') {
        mapped$ = map_1.map.call(this, pathOrMapFn);
    }
    else {
        throw new TypeError(("Unexpected type " + typeof pathOrMapFn + " in select operator,")
            + " expected 'string' or 'function'");
    }
    return distinctUntilChanged_1.distinctUntilChanged.call(mapped$);
}
exports.select = select;


/***/ }),

/***/ "tDJK":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var finally_1 = __webpack_require__("09LQ");
Observable_1.Observable.prototype.finally = finally_1._finally;
Observable_1.Observable.prototype._finally = finally_1._finally;
//# sourceMappingURL=finally.js.map

/***/ }),

/***/ "tPAK":
/***/ (function(module, exports) {

exports.config = {"status":true,"model":{"plazza":"true","title-en":"Tawlbwrdd","module":"tafl","js":["tafl-model.js"],"summary":"11x11 board (from Wales)","thumbnail":"thumb-tawlbwrdd.png","rules":{"en":"rules-tawlbwrdd.html","fr":"rules-tawlbwrdd-fr.html"},"description":{"en":"description.html","fr":"description-fr.html"},"credits":{"en":"credits.html","fr":"credits-fr.html"},"gameOptions":{"preventRepeat":true,"uctTransposition":"states","levelOptions":{"attackersCountFactor":10,"defendersCountFactor":-10,"kingPathFactor":-20,"kingFreedomFactor":-0.1,"distKingFactor":-0.05},"exclude":[0,10,110,120],"attackers":1,"longMove":true,"initial":{"attackers":[4,5,6,15,17,27,44,55,66,45,67,57,54,65,76,53,75,63,114,115,116,103,105,93],"defenders":{"king":60,"soldiers":[38,48,49,50,58,59,61,62,70,71,72,82]}},"homeCatch":true,"privateHome":true,"centerDistance":5},"demoRandom":true,"visuals":["res/visuals/tawlbwrdd-600x600-3d.jpg","res/visuals/tawlbwrdd-600x600-2d.jpg"],"levels":[{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.65,"uncertaintyFactor":3,"useAlphaBeta":true,"name":"easy","label":"Easy","maxNodes":1000},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.65,"uncertaintyFactor":3,"useAlphaBeta":true,"name":"fast","label":"Fast [1sec]","maxDuration":1,"isDefault":true},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.65,"uncertaintyFactor":3,"useAlphaBeta":true,"name":"strong","label":"Strong","maxNodes":10000,"maxDuration":10}]},"view":{"title-en":"Tafl view","module":"tafl","js":["tafl-xd-view.js"],"xdView":true,"css":["tafl.css"],"preferredRatio":1,"switchable":true,"useShowMoves":false,"useNotation":true,"sounds":{"death1":"death1","death2":"death2","death3":"death3","move1":"move1","move3":"move3"},"defaultOptions":{"sounds":true,"moves":true,"notation":false},"skins":[{"name":"tafl3d","title":"3D Classic","3d":true,"camera":{"limitCamMoves":true,"radius":14,"rotationAngle":90,"elevationAngle":89.9,"elevationMin":2,"elevationMax":89.9},"world":{"lightIntensity":0.8,"skyLightIntensity":0.5,"lightCastShadow":false,"fog":false,"color":1118481,"lightPosition":{"x":10,"y":5,"z":0},"lightShadowDarkness":0.55,"ambientLightColor":4473924},"preload":["image|/res/xd-view/meshes/woodtoken-diffuse-black.jpg","image|/res/xd-view/meshes/woodtoken-diffuse.jpg","image|/res/images/ardriboard_bgx1024.jpg","image|/res/images/ardricellborders.png","image|/res/images/ardriblackcell.png","image|/res/images/ardrikingcell.png","image|/res/images/blackcell.png","image|/res/images/whitecell.png","smoothedfilegeo|0|/res/xd-view/meshes/taflboard.js","smoothedfilegeo|0|/res/xd-view/meshes/ring-target.js","smoothedfilegeo|0|/res/xd-view/meshes/woodtoken.js"]},{"name":"tafl2d","title":"2D Classic","3d":false,"preload":["image|/res/xd-view/meshes/ardri-sprites.png","image|/res/images/ardriboard_bgx1024.jpg","image|/res/images/ardricellborders.png","image|/res/images/ardriblackcell.png","image|/res/images/ardrikingcell.png","image|/res/images/blackcell.png","image|/res/images/whitecell.png"]}],"animateSelfMoves":false,"visuals":{"600x600":["res/visuals/tawlbwrdd-600x600-3d.jpg","res/visuals/tawlbwrdd-600x600-2d.jpg"]}}}

/***/ }),

/***/ "tQRI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var zipAll_1 = __webpack_require__("hiKS");
Observable_1.Observable.prototype.zipAll = zipAll_1.zipAll;
//# sourceMappingURL=zipAll.js.map

/***/ }),

/***/ "tUOQ":
/***/ (function(module, exports) {

exports.model=Model={Game:{},Board:{},Move:{}},function(){var t;Model.Game.cbConstants={MASK:65535,FLAG_MOVE:65536,FLAG_CAPTURE:131072,FLAG_STOP:262144,FLAG_SCREEN_CAPTURE:524288,FLAG_CAPTURE_KING:1048576,FLAG_CAPTURE_NO_KING:2097152};var e="undefined"!=typeof Int32Array;Model.Game.cbUseTypedArrays=e,Model.Game.cbTypedArray=function(t){if(e){var r=new Int32Array(t.length);return r.set(t),r}for(var i=[],a=t.length,n=0;n<a;n++)i.push(t[n]);return i},Model.Game.cbShortRangeGraph=function(t,e,r,i){var a=this;void 0===i&&(i=196608);for(var n={},s=0;s<t.boardSize;s++)n[s]=[],(!r||s in r)&&e.forEach(function(e){var o=t.Graph(s,e);null!=o&&(!r||o in r)&&n[s].push(a.cbTypedArray([o|i]))});return n},Model.Game.cbLongRangeGraph=function(t,e,r,i,a){var n=this;void 0!==i&&null!=i||(i=196608),a||(a=1/0);for(var s={},o=0;o<t.boardSize;o++)s[o]=[],(!r||o in r)&&e.forEach(function(e){for(var h=[],c=t.Graph(o,e),p=0;null!=c&&(!r||c in r)&&(h.push(c|i),++p!=a);)c=t.Graph(c,e);h.length>0&&s[o].push(n.cbTypedArray(h))});return s},Model.Game.cbNullGraph=function(t){for(var e={},r=0;r<t.boardSize;r++)e[r]=[];return e},Model.Game.cbAuthorGraph=function(t){for(var e={},r=0;r<t.boardSize;r++){e[r]=[];for(var i=0;i<t.boardSize;i++)e[r].push([2293760|i])}return e},Model.Game.cbMergeGraphs=function(t){for(var e=[],r=0;r<t.boardSize;r++){e[r]=[];for(var i=1;i<arguments.length;i++)e[r]=e[r].concat(arguments[i][r])}return e},Model.Game.cbGetThreatGraph=function(){function t(e,r){for(var i in s){var a=s[i];if(!(a.p.length<r.length+1)){for(var n=!0,o=0;o<r.length;o++)if(r[o]!=a.p[o]){n=!1;break}if(n){var h=a.p[r.length],c=e[h];void 0===c&&(c={e:{}},e[h]=c),a.p.length==r.length+1&&(c.t=a.t,c.ts=a.ts,c.tk=a.tk,delete s[i]),r.push(h),t(c.e,r),r.pop()}}}}var e=this;this.cbUseScreenCapture=!1,this.cbUseCaptureKing=!1,this.cbUseCaptureNoKing=!1;for(var r={1:[],"-1":[]},i=[],a=0;a<this.g.boardSize;a++)this.g.pTypes.forEach(function(t,r){t.graph[a].forEach(function(t){for(var n=[],s=0;s<t.length;s++){var o=t[s];1048576&o?(e.cbUseCaptureKing=!0,n.unshift({d:65535&o,a:a,tk:r})):2097152&o?(e.cbUseCaptureNoKing=!0,n.unshift({d:65535&o,a:a,tnk:r})):131072&o?n.unshift({d:65535&o,a:a,t:r}):262144&o?n.unshift({d:65535&o,a:a}):524288&o&&(e.cbUseScreenCapture=!0,n.unshift({d:65535&o,a:a,ts:r}))}n.length>0&&i.push(n)})});var n={};i.forEach(function(t){t.forEach(function(e,r){var i=n[e.d];void 0===i&&(i={},n[e.d]=i);for(var a=[],s=r+1;s<t.length;s++)a.push(t[s].d);a.push(e.a);var o=a.join(","),h=i[o];void 0===h&&(h={p:a,t:{},ts:{},tk:{}},i[o]=h),void 0!==e.t?h.t[e.t]=!0:void 0!==e.tk?h.tk[e.tk]=!0:void 0!==e.ts&&(h.ts[e.ts]=!0)})});for(var a=0;a<e.g.boardSize;a++){var s=n[a],o={};t(o,[]),r[1][a]=o,r[-1][a]=o}return r},Model.Game.InitGame=function(){var e=this;this.cbVar=t=this.cbDefine(),this.g.boardSize=this.cbVar.geometry.boardSize,this.g.pTypes=this.cbGetPieceTypes(),this.g.threatGraph=this.cbGetThreatGraph(),this.g.distGraph=this.cbVar.geometry.GetDistances(),this.cbPiecesCount=0,this.g.castleablePiecesCount={1:0,"-1":0};for(var r in t.pieceTypes){var i=t.pieceTypes[r];if(i.castle){(i.initial||[]).forEach(function(t){e.g.castleablePiecesCount[t.s]++})}i.initial&&(this.cbPiecesCount+=i.initial.length)}for(var a=[],r=0;r<this.cbPiecesCount;r++)a.push(r);var n=Object.keys(t.pieceTypes);this.zobrist=new JocGame.Zobrist({board:{type:"array",size:this.cbVar.geometry.boardSize,values:a},who:{values:["1","-1"]},type:{type:"array",size:this.cbPiecesCount,values:n}})},Model.Game.cbGetPieceTypes=function(){for(var t=[],e={},r=0;r<this.cbVar.geometry.boardSize;r++)e[r]=[];for(var i in this.cbVar.pieceTypes){var a=this.cbVar.pieceTypes[i];t[i]={graph:a.graph||e,abbrev:a.abbrev||"",value:a.isKing?100:a.value||1,isKing:!!a.isKing,castle:!!a.castle,epTarget:!!a.epTarget,epCatch:!!a.epCatch}}return t},Model.Board.Init=function(t){this.zSign=0},Model.Board.InitialPosition=function(r){var i=this;this.board=e?new Int16Array(r.g.boardSize):[];for(var a=0;a<r.g.boardSize;a++)this.board[a]=-1;if(this.kings={},this.pieces=[],this.ending={1:!1,"-1":!1},this.lastMove=null,r.cbVar.castle&&(this.castled={1:!1,"-1":!1}),this.zSign=r.zobrist.update(0,"who",-1),this.noCaptCount=0,this.mWho=1,r.mInitial)this.mWho=r.mInitial.turn||1,r.mInitial.pieces.forEach(function(t){var e={};for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);i.pieces.push(e)}),r.mInitial.lastMove&&(this.lastMove={f:r.mInitial.lastMove.f,t:r.mInitial.lastMove.t}),void 0!==r.mInitial.noCaptCount&&(this.noCaptCount=r.mInitial.noCaptCount),r.cbVar.castle&&r.mInitial.castle&&(this.castled={1:{k:!!r.mInitial.castle[1]&&!!r.mInitial.castle[1].k,q:!!r.mInitial.castle[1]&&!!r.mInitial.castle[1].q},"-1":{k:!!r.mInitial.castle[-1]&&!!r.mInitial.castle[-1].k,q:!!r.mInitial.castle[-1]&&!!r.mInitial.castle[-1].q}});else for(var n in r.cbVar.pieceTypes)for(var s=r.cbVar.pieceTypes[n],o=s.initial||[],h=0;h<o.length;h++){var c=o[h],p={s:c.s,t:parseInt(n),p:c.p,m:!1};this.pieces.push(p)}if(this.pieces.sort(function(t,e){if(t.s!=e.s)return e.s-t.s;var i=r.cbVar.pieceTypes[t.t].value||100,a=r.cbVar.pieceTypes[e.t].value||100;return i!=a?i-a:t.p-e.p}),this.pieces.forEach(function(t,e){t.i=e,i.board[t.p]=e,r.g.pTypes[t.t].isKing&&(i.kings[t.s]=t.p),i.zSign=r.zobrist.update(i.zSign,"board",e,t.p),i.zSign=r.zobrist.update(i.zSign,"type",t.t,e)}),r.mInitial&&r.mInitial.enPassant){var a=t.geometry.PosByName(r.mInitial.enPassant);if(a>=0){var l,u=t.geometry.C(a),v=t.geometry.R(a);l=1==r.mInitial.turn?t.geometry.POS(u,v-1):t.geometry.POS(u,v+1),this.epTarget={p:a,i:this.board[l]}}}},Model.Board.CopyFrom=function(t){if(e)this.board=new Int16Array(t.board.length),this.board.set(t.board);else{this.board=[];for(var r=t.board,i=r.length,a=0;a<i;a++)this.board.push(r[a])}this.pieces=[];for(var n=t.pieces.length,a=0;a<n;a++){var s=t.pieces[a];this.pieces.push({s:s.s,p:s.p,t:s.t,i:s.i,m:s.m})}this.kings={1:t.kings[1],"-1":t.kings[-1]},this.check=t.check,t.lastMove?this.lastMove={f:t.lastMove.f,t:t.lastMove.t,c:t.lastMove.c}:this.lastMove=null,this.ending={1:t.ending[1],"-1":t.ending[-1]},void 0!==t.castled&&(this.castled={1:t.castled[1],"-1":t.castled[-1]}),this.noCaptCount=t.noCaptCount,t.epTarget?this.epTarget={p:t.epTarget.p,i:t.epTarget.i}:this.epTarget=null,this.mWho=t.mWho,this.zSign=t.zSign},Model.Board.cbApplyCastle=function(t,e,r){var i=t.cbVar.castle[e.f+"/"+e.cg],a=i.r[i.r.length-1],n=this.pieces[this.board[e.cg]],s=i.k[i.k.length-1],o=this.pieces[this.board[e.f]];return r&&(this.zSign=t.zobrist.update(this.zSign,"board",n.i,e.cg),this.zSign=t.zobrist.update(this.zSign,"board",n.i,a),this.zSign=t.zobrist.update(this.zSign,"board",o.i,e.f),this.zSign=t.zobrist.update(this.zSign,"board",o.i,s)),n.p=a,n.m=!0,this.board[e.cg]=-1,o.p=s,o.m=!0,this.board[e.f]=-1,this.board[a]=n.i,this.board[s]=o.i,this.castled[n.s]=!0,this.kings[o.s]=s,[{i:n.i,f:a,t:-1},{i:o.i,f:s,t:e.f,kp:e.f,who:o.s,m:!1},{i:n.i,f:-1,t:e.cg,m:!1,cg:!1}]},Model.Board.cbQuickApply=function(t,e){if(void 0!==e.cg)return this.cbApplyCastle(t,e,!1);var r=[],i=this.board[e.f],a=this.pieces[i];if(null!=e.c){r.unshift({i:e.c,f:-1,t:this.pieces[e.c].p});var n=this.pieces[e.c];this.board[n.p]=-1,n.p=-1}var s=this.kings[a.s];return t.g.pTypes[a.t].isKing&&(this.kings[a.s]=e.t),r.unshift({i:i,f:e.t,t:e.f,kp:s,who:a.s,ty:a.t}),a.p=e.t,void 0!==e.pr&&(a.t=e.pr),this.board[e.f]=-1,this.board[e.t]=i,r},Model.Board.cbQuickUnapply=function(t,e){for(var r=0;r<e.length;r++){var i=e[r],a=this.pieces[i.i];i.f>=0&&(a.p=-1,this.board[i.f]=-1),i.t>=0&&(a.p=i.t,this.board[i.t]=i.i),void 0!==i.m&&(a.m=i.m),void 0!==i.kp&&(this.kings[i.who]=i.kp),void 0!=i.ty&&(a.t=i.ty),void 0!=i.cg&&(this.castled[a.s]=i.cg)}},Model.Board.ApplyMove=function(t,e){var r=this.pieces[this.board[e.f]];if(void 0!==e.cg)this.cbApplyCastle(t,e,!0);else{if(this.zSign=t.zobrist.update(this.zSign,"board",r.i,e.f),this.board[r.p]=-1,void 0!==e.pr&&(this.zSign=t.zobrist.update(this.zSign,"type",r.t,r.i),r.t=e.pr,this.zSign=t.zobrist.update(this.zSign,"type",r.t,r.i)),null!=e.c){var i=this.pieces[e.c];this.zSign=t.zobrist.update(this.zSign,"board",i.i,i.p),this.board[i.p]=-1,i.p=-1,i.m=!0,this.noCaptCount=0}else this.noCaptCount++;r.p=e.t,r.m=!0,this.board[e.t]=r.i,this.zSign=t.zobrist.update(this.zSign,"board",r.i,e.t),t.g.pTypes[r.t].isKing&&(this.kings[r.s]=e.t)}this.check=!!e.ck,this.lastMove={f:e.f,t:e.t,c:e.c},void 0!==e.ko&&(this.ending[r.s]=e.ko),void 0!==e.ept?this.epTarget={p:e.ept,i:r.i}:this.epTarget=null,this.zSign=t.zobrist.update(this.zSign,"who",-this.mWho),this.zSign=t.zobrist.update(this.zSign,"who",this.mWho)},Model.Board.Evaluate=function(r){function i(e){var r=1/0;for(var i in t.geometry.corners)r=Math.min(r,h.distGraph[n.kings[e]][i]);return r-Math.sqrt(h.boardSize)}var a="debug"==arguments[3],n=this;this.mEvaluation=0;var s,o=this.mWho,h=r.g;if(e)s={1:{count:new Uint8Array(h.pTypes.length),byType:{}},"-1":{count:new Uint8Array(h.pTypes.length),byType:{}}};else{s={1:{count:[],byType:{}},"-1":{count:[],byType:{}}};for(var c=0;c<h.pTypes.length;c++)s[1].count[c]=s[-1].count[c]=0}if(r.mOptions.preventRepeat&&r.GetRepeatOccurence(this)>2)return this.mFinished=!0,void(this.mWinner=r.cbOnPerpetual?o*r.cbOnPerpetual:JocGame.DRAW);for(var p={1:0,"-1":0},l={1:h.distGraph[this.kings[-1]],"-1":h.distGraph[this.kings[1]]},u={1:0,"-1":0},v={1:0,"-1":0},f={1:0,"-1":0},b={1:0,"-1":0},d={1:!1,"-1":!1},g=this.pieces,m=g.length,c=0;c<m;c++){var G=g[c];if(G.p>=0){var y=G.s,M=h.pTypes[G.t];M.isKing?d[y]=G.m:p[y]+=M.value,M.castle&&!G.m&&b[y]++,v[y]++,u[y]+=l[y][G.p],f[y]+=t.geometry.distEdge[G.p];var C=s[y];C.count[G.t]++;var S=C.byType;void 0===S[G.t]?S[G.t]=[G]:S[G.t].push(G)}}if(this.lastMove&&null!=this.lastMove.c){var G=this.pieces[this.board[this.lastMove.t]];p[-G.s]+=this.cbStaticExchangeEval(r,G.p,G.s,{piece:G})}var A={1:0,"-1":0},k={1:0,"-1":0},T={1:0,"-1":0};this.ending[1]&&(k[1]=(u[1]-Math.sqrt(h.boardSize))/v[1],t.geometry.corners&&(T[1]=i(1))),this.ending[-1]&&(k[-1]=(u[-1]-Math.sqrt(h.boardSize))/v[-1],t.geometry.corners&&(T[1]=i(-1)));var z={pieceValue:p[1]-p[-1],pieceValueRatio:(p[1]-p[-1])/(p[1]+p[-1]+1),posValue:f[1]-f[-1],averageDistKing:u[1]/v[1]-u[-1]/v[-1],check:this.check?-o:0,endingKingFreedom:A[1]-A[-1],endingDistKing:k[1]-k[-1],distKingCorner:T[1]-T[-1]};t.castle&&(z.castle=(this.castled[1]?1:d[1]?0:b[1]/(h.castleablePiecesCount[1]+1))-(this.castled[-1]?1:d[-1]?0:b[-1]/(h.castleablePiecesCount[-1]+1))),t.evaluate&&t.evaluate.call(this,r,z,s);var E=r.mOptions.levelOptions;for(var P in z){var R=z[P],F=E[P+"Factor"]||0,I=R*F;a&&console.log(P,"=",R,"*",F,"=>",I),this.mEvaluation+=I}a&&console.log("Evaluation",this.mEvaluation)},Model.Board.cbGeneratePseudoLegalMoves=function(t){function e(e,a){var n=t.cbVar.promote;if(!n)return void i.push(a);var s=n.call(r,t,e,a);if(null!=s)if(0==s.length)i.push(a);else if(1==s.length)a.pr=s[0],i.push(a);else for(var o=0;o<s.length;o++){var h=s[o];i.push({f:a.f,t:a.t,c:a.c,pr:h,ept:a.ept,ep:a.ep,a:a.a})}}for(var r=this,i=[],a=t.cbVar,n=this.mWho,s=!a.castle||this.check||this.castled[n]?null:[],o=-1,h=this.pieces.length,c=0;c<h;c++){var p=this.pieces[c];if(!(p.p<0||p.s!=n)){var l=t.g.pTypes[p.t];l.isKing&&(p.m?s=null:o=p),s&&l.castle&&!p.m&&s.push(p);var u,v;u=l.graph[p.p],v=u.length;for(var f=0;f<v;f++)for(var b=u[f],d=!1,g=b.length,m=null,G=0;G<g;G++){var y=b[G],M=65535&y,C=this.board[M];if(!(C<0)||l.epCatch&&this.epTarget&&this.epTarget.p==M){if(!(524288&y)){var S;S=C<0?this.pieces[this.epTarget.i]:this.pieces[C],!(S.s!=p.s&&131072&y)||1048576&y&&!t.g.pTypes[S.t].isKing||2097152&y&&t.g.pTypes[S.t].isKing||e(p,{f:p.p,t:M,c:S.i,a:l.abbrev,ep:C<0});break}if(d){var S=this.pieces[C];S.s!=p.s&&e(p,{f:p.p,t:M,c:S.i,a:l.abbrev});break}d=!0}else 65536&y&&0==d&&e(p,{f:p.p,t:M,c:null,a:l.abbrev,ept:null!=m&&l.epTarget?m:void 0});m=M}}}if(s)for(var c=0;c<s.length;c++){var A=s[c],k=t.cbVar.castle[o.p+"/"+A.p];if(k){for(var T=!0,f=0;f<k.r.length;f++){var z=k.r[f];if(this.board[z]>=0&&z!=o.p&&z!=A.p){T=!1;break}}if(T){for(var E=!0,f=0;f<k.k.length;f++){var z=k.k[f];if(this.board[z]>=0&&z!=A.p&&z!=o.p||this.cbGetAttackers(t,z,n).length>0){E=!1;break}}E&&i.push({f:o.p,t:k.k[k.k.length-1],c:null,cg:A.p})}}}return i},Model.Board.cbStaticExchangeEval=function(t,e,r,i){var a=0,n=this.cbGetSmallestAttacker(t,e,r);if(n){var s=this.mWho;this.mWho=n.s;var o=this.cbQuickApply(t,{f:n.p,t:e,c:i.piece.i}),h=t.g.pTypes[i.piece.t].value;i.piece=n,a=Math.max(0,h-this.cbStaticExchangeEval(t,e,-r,i)),this.cbQuickUnapply(t,o),this.mWho=s}return a},Model.Board.cbGetSmallestAttacker=function(t,e,r){var i=this.cbGetAttackers(t,e,r);if(0==i.length)return null;for(var a=1/0,n=null,s=i.length,o=0;o<s;o++){var h=i[o],c=t.g.pTypes[h.t].value;c<a&&(a=c,n=h)}return n},Model.Board.cbCollectAttackers=function(t,e,r,i){for(var a in e){var n=e[a],s=this.board[a];if(s<0)this.cbCollectAttackers(t,n.e,r,i);else{var o=this.pieces[s];o.s==-t&&(n.t&&o.t in n.t||i&&n.tk&&o.t in n.tk)&&r.push(o)}}},Model.Board.cbCollectAttackersScreen=function(t,e,r,i,a){for(var n in e){var s=e[n],o=this.board[n];if(o<0)this.cbCollectAttackersScreen(t,s.e,r,i,a);else{var h=this.pieces[o];!a&&h.s==-t&&(s.t&&h.t in s.t||i&&s.tk&&h.t in s.tk)?r.push(h):a?a&&h.s==-t&&s.ts&&h.t in s.ts&&r.push(h):this.cbCollectAttackersScreen(t,s.e,r,i,!0)}}},Model.Board.cbGetAttackers=function(t,e,r,i){var a=[];return t.cbUseScreenCapture?this.cbCollectAttackersScreen(r,t.g.threatGraph[r][e],a,i,!1):this.cbCollectAttackers(r,t.g.threatGraph[r][e],a,i),a},Model.Board.GenerateMoves=function(t){var e=this.cbGeneratePseudoLegalMoves(t);this.mMoves=[];for(var r=!0,i=this.kings[this.mWho],a=e.length,n=0;n<a;n++){var s=e[n],o=this.cbQuickApply(t,s);if(!(this.cbGetAttackers(t,this.kings[this.mWho],this.mWho,!0).length>0)){var h=this.cbGetAttackers(t,this.kings[-this.mWho],-this.mWho,!0).length>0;s.ck=h,this.mMoves.push(s),s.f!=i&&(r=!1)}this.cbQuickUnapply(t,o)}if(0==this.mMoves.length)this.mFinished=!0,this.mWinner=t.cbOnStaleMate?t.cbOnStaleMate*this.mWho:JocGame.DRAW,this.check&&(this.mWinner=-this.mWho);else if(this.ending[this.mWho]){if(!r)for(var n=0;n<this.mMoves.length;n++)this.mMoves[n].ko=!1}else if(!this.ending[this.mWho]&&r&&!this.check)for(var n=0;n<this.mMoves.length;n++)this.mMoves[n].ko=!0},Model.Board.GetSignature=function(){return this.zSign},Model.Move.Init=function(t){for(var e in t)t.hasOwnProperty(e)&&(this[e]=t[e])},Model.Move.Equals=function(t){return this.f==t.f&&this.t==t.t&&this.pr==t.pr},Model.Move.CopyFrom=function(t){this.Init(t)},Model.Move.ToString=function(e){var r=this;switch(e=e||"natural"){case"natural":return function(){var e;if(void 0!==r.cg?e=t.castle[r.f+"/"+r.cg].n:(e=r.a||"",e+=t.geometry.PosName(r.f),null==r.c?e+="-":e+="x",e+=t.geometry.PosName(r.t)),void 0!==r.pr){var i=t.pieceTypes[r.pr];i&&i.abbrev&&i.abbrev.length>0&&!i.silentPromo&&(e+="="+i.abbrev)}return r.ck&&(e+="+"),e}();case"engine":return function(){var e=t.geometry.PosName(r.f)+t.geometry.PosName(r.t);if(void 0!=r.pr){var i=t.pieceTypes[r.pr];i&&i.abbrev&&i.abbrev.length>0&&!i.silentPromo&&(e+=i.abbrev)}return e}();default:return"??"}},Model.Board.CompactMoveString=function(e,r,i){"function"!=typeof r.ToString&&(r=e.CreateMove(r));var a=r.ToString(),n=/^([A-Z]?)([a-z])([1-9][0-9]*)([-x])([a-z])([1-9][0-9]*)(.*?)$/.exec(a);if(!n)return a;var s=n[7];if(i||(i={}),i.value||(i.value=[]),0==i.value.length){var o=this.mMoves;this.mMoves&&0!=this.mMoves.length||this.GenerateMoves(e);for(var h=0;h<this.mMoves.length;h++){var c=this.mMoves[h];"function"!=typeof c.ToString&&(c=e.CreateMove(c)),i.value.push({str:c.ToString(),move:c})}this.mMoves=o}var p=[];if(i.value.forEach(function(t){var e=/^([A-Z]?[a-z][1-9][0-9]*[-x][a-z][1-9][0-9]*)(.*?)$/.exec(t.str);e&&t.move.t==r.t&&(t.move.a||"")==n[1]&&e[2]==s&&p.push(t.move)}),1==p.length)return""==n[1]&&"x"==n[4]?n[2]+"x"+n[5]+n[6]+n[7]:n[1]+("x"==n[4]?"x":"")+n[5]+n[6]+n[7];if(t.geometry.CompactCrit)for(var l="",h=0;;h++){var u=t.geometry.CompactCrit(r.f,h);if(null==u)return a;l+=u;for(var v=[],f=0;f<p.length;f++){var b=p[f];t.geometry.CompactCrit(b.f,h)==u&&v.push(b)}if(console.assert(v.length>0),1==v.length)return n[1]+l+("x"==n[4]?"x":"")+n[5]+n[6]+n[7];p=v}return a},Model.Board.cbIntegrity=function(t){function e(t,e){t||console.error(e)}for(var r=this,i=0;i<this.board.length;i++){var a=this.board[i];if(a>=0){var n=r.pieces[a];e(void 0!==n,"no piece at pos"),e(n.p==i,"piece has different pos")}}for(var a=0;a<this.pieces.length;a++){var n=this.pieces[a];n.p>=0&&e(r.board[n.p]==a,"board index mismatch")}},Model.Board.ExportBoardState=function(t){return t.cbVar.geometry.ExportBoardState?t.cbVar.geometry.ExportBoardState(this,t.cbVar,t.mPlayedMoves.length):"not supported"},Model.Game.Import=function(e,r){var i,a=[],n={1:{},"-1":{}},s=null,o=0;if("pjn"==e){var h={status:!1,error:"parse"},c=r.split(" ");if(6!=c.length)return console.warn("FEN should have 6 parts"),h;var p=c[0].split("/"),l=t.geometry.fenHeight||t.geometry.height;if(p.length!=l)return console.warn("FEN board should have",l,"rows, got",p.length),h;var u={};for(var v in t.pieceTypes){var f=t.pieceTypes[v],b=f.fenAbbrev||f.abbrev||"X";u[b.toUpperCase()]={s:1,t:v},u[b.toLowerCase()]={s:-1,t:v}}var d=t.geometry.FenRowPos||function(e,r){return(t.geometry.height-1-e)*t.geometry.width+r};if(p.forEach(function(e,r){for(var i=0,n=0;n<e.length;n++){var s=e.substr(n,1),o=u[s];if(void 0!==o){var c=d(r,i);i++;for(var p={s:o.s,t:o.t,p:c},l=!0,v=t.pieceTypes[p.t].initial||[],f=0;f<v.length;f++){var b=v[f];b.s==p.s&&b.p==c&&(l=!1)}p.m=l,a.push(p)}else{if(isNaN(parseInt(s)))return console.warn("FEN invalid board spec",s),h;i+=parseInt(s)}}}),a.sort(function(t,e){return e.s-t.s}),"w"==c[1])i=1;else{if("b"!=c[1])return console.warn("FEN invalid turn spec",c[1]),h;i=-1}n[1].k=c[2].indexOf("K")>=0,n[1].q=c[2].indexOf("Q")>=0,n[-1].k=c[2].indexOf("k")>=0,n[-1].q=c[2].indexOf("q")>=0,s="-"==c[3]?null:c[3];var g=parseInt(c[4]);isNaN(g)||(o=g);var m={pieces:a,turn:i,castle:n,enPassant:s,noCaptCount:o};return t.importGame&&t.importGame.call(this,m,e,r),{status:!0,initial:m}}return{status:!1,error:"unsupported"}}}(),function(){Model.Game.cbBoardGeometryGrid=function(t,e){function r(e){return e%t}function i(e){return Math.floor(e/t)}function a(e,r){return r*t+e}function n(n,s){var o=r(n),h=i(n),c=o+s[0],p=h+s[1];return c<0||c>=t||p<0||p>=e?null:a(c,p)}function s(t){return String.fromCharCode("a".charCodeAt(0)+r(t))+(i(t)+1)}function o(t){var e=/^([a-z])([0-9]+)$/.exec(t);return e?a(e[1].charCodeAt(0)-"a".charCodeAt(0),parseInt(e[2])-1):-1}function h(t,e){return 0==e?String.fromCharCode("a".charCodeAt(0)+r(t)):1==e?i(t)+1:null}function c(){for(var a=[],n=0;n<t*e;n++){var s=[];a.push(s);for(var o=0;o<t*e;o++){var h=i(n),c=r(n),p=i(o),l=r(o);s.push(Math.max(Math.abs(h-p),Math.abs(c-l)))}}return a}function p(r,i,n){for(var o=[],h=e-1;h>=0;h--){for(var c="",p=0,l=0;l<t;l++){var u=r.board[a(l,h)];if(u<0)p++;else{p>0&&(c+=p,p=0);var v=r.pieces[u],f=i.pieceTypes[v.t].fenAbbrev||i.pieceTypes[v.t].abbrev||"?";v.s==-1?c+=f.toLowerCase():c+=f.toUpperCase()}}p&&(c+=p),o.push(c)}var b=o.join("/");b+=" ",1==r.mWho?b+="w":b+="b",b+=" ";var d="";return r.castled&&(r.castled[1]===!1?d+="KQ":(r.castled[1].k&&(d+="K"),r.castled[1].q&&(d+="Q")),r.castled[-1]===!1?d+="kq":(r.castled[-1].k&&(d+="k"),r.castled[-1].q&&(d+="q"))),0==d.length&&(d="-"),b+=d,b+=" ",r.epTarget?b+=s(r.epTarget.p):b+="-",b+=" ",b+=r.noCaptCount,b+=" ",b+=Math.floor(n/2)+1}return{boardSize:t*e,width:t,height:e,C:r,R:i,POS:a,Graph:n,PosName:s,PosByName:o,CompactCrit:h,GetDistances:c,distEdge:function(){for(var a=[],n=0;n<t*e;n++){var s=r(n),o=i(n);a[n]=Math.min(s,Math.abs(t-s-1),o,Math.abs(e-o-1))}return a}(),corners:function(){var r={};return r[a(0,0)]=1,r[a(0,e-1)]=1,r[a(t-1,0)]=1,r[a(t-1,e-1)]=1,r}(),ExportBoardState:p}},Model.Game.cbPawnGraph=function(t,e,r){for(var i=this,a={},n=0;n<t.boardSize;n++)if(!r||n in r){var s=[],o=t.Graph(n,[0,e]);null!=o&&(!r||o in r)&&s.push(i.cbTypedArray([o|i.cbConstants.FLAG_MOVE])),[-1,1].forEach(function(a){var o=t.Graph(n,[a,e]);null!=o&&(!r||o in r)&&s.push(i.cbTypedArray([o|i.cbConstants.FLAG_CAPTURE]))}),a[n]=s}else a[n]=[];return a},Model.Game.cbInitialPawnGraph=function(t,e,r){for(var i=this,a={},n=0;n<t.boardSize;n++)if(!r||n in r){var s=[],o=t.Graph(n,[0,e]);if(null!=o&&(!r||o in r)){var h=[o|i.cbConstants.FLAG_MOVE],c=t.Graph(o,[0,e]);null!=c&&(!r||c in r)&&h.push(c|i.cbConstants.FLAG_MOVE),s.push(i.cbTypedArray(h))}[-1,1].forEach(function(a){var o=t.Graph(n,[a,e]);null!=o&&(!r||o in r)&&s.push(i.cbTypedArray([o|i.cbConstants.FLAG_CAPTURE]))}),a[n]=s}else a[n]=[];return a},Model.Game.cbKingGraph=function(t,e){return this.cbShortRangeGraph(t,[[-1,-1],[-1,0],[-1,1],[0,-1],[0,1],[1,-1],[1,0],[1,1]],e)},Model.Game.cbKnightGraph=function(t,e){return this.cbShortRangeGraph(t,[[2,-1],[2,1],[-2,-1],[-2,1],[-1,2],[-1,-2],[1,2],[1,-2]],e)},Model.Game.cbHorseGraph=function(t){for(var e=this,r={},i=0;i<t.boardSize;i++)r[i]=[],[[1,0,2,-1],[1,0,2,1],[-1,0,-2,-1],[-1,0,-2,1],[0,1,-1,2],[0,-1,-1,-2],[0,1,1,2],[0,-1,1,-2]].forEach(function(a){var n=t.Graph(i,[a[0],a[1]]);if(null!=n){var s=t.Graph(i,[a[2],a[3]]);null!=s&&r[i].push(e.cbTypedArray([n|e.cbConstants.FLAG_STOP,s|e.cbConstants.FLAG_MOVE|e.cbConstants.FLAG_CAPTURE]))}});return r},Model.Game.cbRookGraph=function(t,e){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0]],e)},Model.Game.cbBishopGraph=function(t,e){return this.cbLongRangeGraph(t,[[1,-1],[1,1],[-1,1],[-1,-1]],e)},Model.Game.cbQueenGraph=function(t,e){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0],[1,-1],[1,1],[-1,1],[-1,-1]],e)},Model.Game.cbXQGeneralGraph=function(t,e){for(var r=this,i={},a=0;a<t.boardSize;a++)i[a]=[],[[-1,0,!1],[0,-1,!0],[0,1,!0],[1,0,!1]].forEach(function(n){var s=[],o=t.Graph(a,n);if(null!=o&&((!e||o in e)&&s.push(o|r.cbConstants.FLAG_MOVE|r.cbConstants.FLAG_CAPTURE),n[2]))for(var h=t.Graph(o,n);null!=h;)!e||h in e?s.push(h|r.cbConstants.FLAG_CAPTURE|r.cbConstants.FLAG_CAPTURE_KING):s.push(h|r.cbConstants.FLAG_STOP),h=t.Graph(h,n);s.length>0&&i[a].push(r.cbTypedArray(s))});return i},Model.Game.cbXQSoldierGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e]])},Model.Game.cbXQPromoSoldierGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e],[-1,0],[1,0]])},Model.Game.cbXQAdvisorGraph=function(t,e){return this.cbShortRangeGraph(t,[[1,1],[-1,1],[1,-1],[-1,-1]],e)},Model.Game.cbXQCannonGraph=function(t){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0]],null,this.cbConstants.FLAG_MOVE|this.cbConstants.FLAG_SCREEN_CAPTURE)},Model.Game.cbXQElephantGraph=function(t,e){for(var r=this,i={},a=0;a<t.boardSize;a++)i[a]=[],(!e||a in e)&&[[1,1,2,2],[1,-1,2,-2],[-1,1,-2,2],[-1,-1,-2,-2]].forEach(function(n){var s=t.Graph(a,[n[0],n[1]]);if(null!=s){var o=t.Graph(a,[n[2],n[3]]);null!=o&&(!e||o in e)&&i[a].push(r.cbTypedArray([s|r.cbConstants.FLAG_STOP,o|r.cbConstants.FLAG_MOVE|r.cbConstants.FLAG_CAPTURE]))}});return i},Model.Game.cbSilverGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e],[-1,-1],[-1,1],[1,-1],[1,1]])},Model.Game.cbFersGraph=function(t,e){return this.cbShortRangeGraph(t,[[-1,-1],[-1,1],[1,-1],[1,1]])},Model.Game.cbSchleichGraph=function(t,e){return this.cbShortRangeGraph(t,[[-1,0],[1,0],[0,-1],[0,1]])},Model.Game.cbAlfilGraph=function(t,e){return this.cbShortRangeGraph(t,[[-2,-2],[-2,2],[2,2],[2,-2]])}}(),function(){for(var t=Model.Game.cbBoardGeometryGrid(7,7),e={},r=0;r<t.boardSize;r++)r>=16&&r<=18||r>=23&&r<=25||r>=30&&r<=32||(e[r]=1);var i={bottom:{poss:[1,2,3,4,5,6,9,10,11,12],trans:[[0,-1],[1,0]]},left:{poss:[0,7,8,14,15,21,22,28,29,35],trans:[[1,0],[0,1]]},top:{poss:[36,37,38,39,42,43,44,45,46,47],trans:[[0,1],[-1,0]]},right:{poss:[13,19,20,26,27,33,34,40,41,48],trans:[[-1,0],[0,-1]]}},a={};for(var n in i){var s=i[n];for(var r in s.poss)a[s.poss[r]]=s.trans}var o={};!function(){for(var r in e)o[r]={},o[r][r]=0;for(var i=[[-1,1],[0,1],[1,1]],n=!0;n;){n=!1;for(var r in e)i.forEach(function(i){var s=a[r],h=[s[0][0]*i[0]+s[0][1]*i[1],s[1][0]*i[0]+s[1][1]*i[1]],c=t.Graph(r,h);if(null!=c&&c in e){1!=o[r][c]&&(o[r][c]=1,n=!0);for(var p in e)p!=r&&(void 0===o[r][p]&&void 0!==o[c][p]?(o[r][p]=o[c][p]+1,n=!0):void 0!==o[c][p]&&void 0!==o[r][p]&&o[r][p]>o[c][p]+1&&(o[r][p]=o[c][p]+1,n=!0))}})}t.GetDistance=function(){return o}}();var h={1:{46:1,39:1},"-1":{2:1,9:1}},c={1:{},"-1":{}};["1","-1"].forEach(function(t){for(var r in e){var i=1/0;for(var a in h[t]){var n=o[r][a];n<i&&(c[t][r]=n,i=n)}}}),Model.Game.cbRbGraph=function(t,r,i,n,s){var o=this,h=this.cbConstants.FLAG_MOVE|this.cbConstants.FLAG_CAPTURE;i=i||12,n=n||{};for(var c={},p=0;p<t.boardSize;p++)c[p]=[],(!e||p in e)&&r.forEach(function(r){for(var l=[],u=a[p],v=[u[0][0]*r[0]+u[0][1]*r[1],u[1][0]*r[0]+u[1][1]*r[1]],f=t.Graph(p,v),b=0,d=!1;null!=f&&b++!=i&&(!e||f in e);){l.push(f|h);var g=f;if(f=t.Graph(f,v),!d&&g in n&&(null==f||e&&!(f in e))){var m=a[g];v=s&&u[0]==m[0]&&u[1]==m[1]?[m[0][0]*-r[0]+m[0][1]*r[1],m[1][0]*-r[0]+m[1][1]*r[1]]:[m[0][0]*r[0]+m[0][1]*r[1],m[1][0]*r[0]+m[1][1]*r[1]],f=t.Graph(g,v),d=!0}}l.length>0&&c[p].push(o.cbTypedArray(l))});return c},Model.Game.cbRbRookExtraGraph=function(t){for(var e={},r={1:[0,1],35:[1,0],47:[0,-1],13:[-1,0]},i=this.cbConstants.FLAG_MOVE|this.cbConstants.FLAG_CAPTURE,a=0;a<t.boardSize;a++){e[a]=[];var n=r[a],s=[];if(n){for(var o=t.Graph(a,n),h=!1;null!=o;)h?s.push(o|i):(h=!0,s.push(o|this.cbConstants.FLAG_STOP)),o=t.Graph(o,n);e[a].push(this.cbTypedArray(s))}}return e};var p={1:[{2:1,9:1},{3:1,10:1}],"-1":[{39:1,46:1},{38:1,45:1}]};Model.Game.cbDefine=function(){return{geometry:t,pieceTypes:{0:{name:"pawn",aspect:"pawn",graph:this.cbRbGraph(t,[[-1,1],[0,1],[1,1]],1),value:1,abbrev:"",fenAbbrev:"P",initial:[{s:1,p:2},{s:1,p:9},{s:-1,p:39},{s:-1,p:46}]},5:{name:"bishop",graph:this.cbMergeGraphs(t,this.cbRbGraph(t,[[-1,1],[1,1]],6,e,!0),this.cbRbGraph(t,[[-1,-1],[1,-1]],1)),value:2.4,abbrev:"B",initial:[{s:1,p:3},{s:-1,p:45}]},6:{name:"rook",graph:this.cbMergeGraphs(t,this.cbRbGraph(t,[[0,1]],12,{0:1,6:1,42:1,48:1}),this.cbRbGraph(t,[[1,0],[-1,0],[0,-1]],1),this.cbRbRookExtraGraph(t)),value:3.1,abbrev:"R",initial:[{s:1,p:4},{s:1,p:11},{s:-1,p:37},{s:-1,p:44}],castle:!0},8:{name:"king",isKing:!0,graph:this.cbKingGraph(t,e),abbrev:"K",initial:[{s:1,p:10},{s:-1,p:38}]},9:{name:"king-out",aspect:"king",isKing:!0,graph:this.cbKingGraph(t,e),abbrev:"K"}},promote:function(t,e,r){if(8==e.t){var i=p[e.s];if(r.f in i[1]&&r.t in i[0])return[9]}else if(9==e.t){var i=p[e.s];if(r.f in i[0]&&r.t in i[1])return[8]}return 0==e.t&&h[e.s][r.t]?[5,6]:[]},evaluate:function(t,e,r){38==this.kings[1]&&9==this.pieces[this.board[38]].t&&(this.mFinished=!0,this.mWinner=JocGame.PLAYER_A),10==this.kings[-1]&&9==this.pieces[this.board[10]].t&&(this.mFinished=!0,this.mWinner=JocGame.PLAYER_B);var i=r[1].count,a=r[-1].count;i[0]||i[5]||i[6]||a[0]||a[6]||(this.mFinished=!0,this.mWinner=JocGame.DRAW),a[0]||a[5]||a[6]||i[0]||i[6]||(this.mFinished=!0,this.mWinner=JocGame.DRAW),this.noCaptCount>=100&&(this.mFinished=!0,this.mWinner=JocGame.DRAW);for(var n=0,s=-1;s<=1;s+=2){var h,p=r[s].byType[0];if(p){h=p.length;for(var l=0;l<h;l++)n+=c[s][p[l].p]*s}}e.distPawnPromo=n,e.distKingThrone=o[this.kings[1]][38]-o[this.kings[-1]][10]}}}}();

/***/ }),

/***/ "tWQs":
/***/ (function(module, exports) {

exports.config = {"status":true,"model":{"plazza":"true","title-en":"Popout","module":"fourinarow","js":["fiarbase-model.js"],"summary":"Four In A Row with removals","thumbnail":"fiar-thumb.png","rules":{"en":"rules.html","fr":"rules-fr.html"},"description":{"en":"description.html","fr":"description-fr.html"},"credits":{"en":"credits.html","fr":"credits-fr.html"},"gameOptions":{"width":7,"height":6,"lines":4,"remove":true,"levelOptions":{"evalTuple1":1,"evalTuple2":2,"evalTuple3":4,"evalTuple4":8,"evalTuple5":16,"evalTuple6":32},"uctTransposition":"state","preventRepeat":true},"levels":[{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.55,"ignoreLeaf":false,"name":"easy","label":"Easy","maxNodes":1000,"isDefault":true},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.55,"ignoreLeaf":false,"name":"fast","label":"Fast [1sec]","maxDuration":1},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.55,"ignoreLeaf":false,"name":"strong","label":"Strong","maxNodes":10000}]},"view":{"title-en":"Four In A Row View","module":"fourinarow","js":["fiarbase-xd-view.js"],"xdView":true,"css":["fiarbase.css"],"preferredRatio":1,"useShowMoves":false,"useNotation":true,"sounds":{"sound1":"sound1","sound2":"sound2"},"defaultOptions":{"sounds":true,"moves":true,"notation":false},"skins":[{"name":"fiar3d","title":"3D Classic","3d":true,"camera":{"radius":20,"limitCamMoves":true,"rotationAngle":180,"elevationAngle":0,"elevationMin":-89,"elevationMax":89,"distMax":30},"world":{"lightIntensity":0.2,"skyLightIntensity":0.2,"lightCastShadow":false,"fog":true,"color":0,"lightPosition":{"x":10,"y":5,"z":0},"lightShadowDarkness":0.55,"ambientLightColor":2236996},"preload":["map|/res/xd-view/meshes/connect4-red-star.png","map|/res/xd-view/meshes/connect4-red.png","map|/res/xd-view/meshes/connect4-yellow-star.png","map|/res/xd-view/meshes/connect4-yellow.png","smoothedfilegeo|0|/res/xd-view/meshes/connect4cell.js","smoothedfilegeo|0|/res/xd-view/meshes/connect4cell-ring-smoothed.js","smoothedfilegeo|0|/res/xd-view/meshes/connect4-token.js","smoothedfilegeo|0|/res/xd-view/meshes/connect4cell-foot.js"]},{"name":"fiar2d","title":"2D Classic","3d":false,"preload":["image|/res/sprites2d.png"]}],"animateSelfMoves":false,"visuals":{"600x600":["res/visuals/popout-600x600-3d.jpg","res/visuals/popout-600x600-2d.jpg"]}}}

/***/ }),

/***/ "tYwL":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var distinctUntilKeyChanged_1 = __webpack_require__("AQOC");
Observable_1.Observable.prototype.distinctUntilKeyChanged = distinctUntilKeyChanged_1.distinctUntilKeyChanged;
//# sourceMappingURL=distinctUntilKeyChanged.js.map

/***/ }),

/***/ "tbXE":
/***/ (function(module, exports) {

exports.config = {"status":true,"model":{"plazza":"true","js":["mana-model.js"],"title-en":"Mana","maxLevel":9,"summary":"Capture the opponent's Damyo","module":"mana","rules":{"en":"rules.html","fr":"rules-fr.html"},"credits":{"en":"credits.html","fr":"credits-fr.html"},"description":{"en":"description.html","fr":"description-fr.html"},"thumbnail":"thumbnail.png","defaultLevel":2,"gameOptions":{"preventRepeat":true,"width":6,"height":6,"initial":["223122","131313","312231","231312","213132","132213"],"damyoCount":1,"roninCount":5,"insertAnywhere":true,"damyoKillWin":1,"stage1start":3,"stage2start":6,"factors":{"roninCount":[0,5,5,0,5,10],"sameAsDamyo":10,"typeCount":[0,10,20,5],"dist2Damyo":-1,"dist2DamyoInvSquare":50}},"levels":[{"label":"Padawan","potential":1000,"isDefault":true,"maxDepth":2},{"label":"Warrior","potential":4000,"maxDepth":5},{"label":"Samurai","potential":20000,"maxDepth":6},{"label":"Ronin","potential":40000,"maxDepth":8},{"label":"Damyo","potential":100000,"maxDepth":8}]},"view":{"title-en":"Mana View","module":"mana","css":["mana.css"],"js":["mana-xd-view.js"],"visuals":{"600x600":["res/visuals/mana-600x600-3d.jpg","res/visuals/mana-600x600-2d.jpg"]},"preferredRatio":1,"switchable":true,"xdView":true,"sounds":{"death1":"death1","death2":"death2","death3":"death3","chains":"chains","move1":"move1","move3":"move3","zip0":"zip0","zip1":"zip1","zip2":"zip2","zip3":"zip3","sabers":"sabersout","deathdamyo":"manasound-kill2","intro":"japenese-mana-intro","wind":"wind"},"skins":[{"name":"orange3d","title":"Orange (3D)","3d":true,"camera":{"radius":15,"limitCamMoves":true},"world":{"lightIntensity":0.7,"skyLightIntensity":0.2,"fog":true,"color":14327863,"lightPosition":{"x":-10,"y":18,"z":10},"skyLightPosition":{"x":10,"y":18,"z":-10},"lightShadowDarkness":0.25,"ambientLightColor":8939008},"preload":["smoothedfilegeo|0|/res/xd-view/meshes/strokeblack.js","smoothedfilegeo|0|/res/xd-view/meshes/mana-piece-smoothed2.js","smoothedfilegeo|0|/res/xd-view/meshes/select-ring-undo.js","smoothedfilegeo|0|/res/xd-view/meshes/select-smoothed.js","smoothedfilegeo|0|/res/xd-view/meshes/mana.js"]},{"name":"official","title":"Official","preload":["image|/res/images/boardexp.png","image|/res/images/manapieces.png"]}],"defaultOptions":{"sounds":true,"notation":false,"moves":true},"useNotation":true,"useShowMoves":true,"animateSelfMoves":false}}

/***/ }),

/***/ "td8d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__("mmVS");
/* tslint:enable:max-line-length */
/**
 * Applies an accumulator function over the source Observable, and returns each
 * intermediate result, with an optional seed value.
 *
 * <span class="informal">It's like {@link reduce}, but emits the current
 * accumulation whenever the source emits a value.</span>
 *
 * <img src="./img/scan.png" width="100%">
 *
 * Combines together all values emitted on the source, using an accumulator
 * function that knows how to join a new source value into the accumulation from
 * the past. Is similar to {@link reduce}, but emits the intermediate
 * accumulations.
 *
 * Returns an Observable that applies a specified `accumulator` function to each
 * item emitted by the source Observable. If a `seed` value is specified, then
 * that value will be used as the initial value for the accumulator. If no seed
 * value is specified, the first item of the source is used as the seed.
 *
 * @example <caption>Count the number of click events</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var ones = clicks.mapTo(1);
 * var seed = 0;
 * var count = ones.scan((acc, one) => acc + one, seed);
 * count.subscribe(x => console.log(x));
 *
 * @see {@link expand}
 * @see {@link mergeScan}
 * @see {@link reduce}
 *
 * @param {function(acc: R, value: T, index: number): R} accumulator
 * The accumulator function called on each source value.
 * @param {T|R} [seed] The initial accumulation value.
 * @return {Observable<R>} An observable of the accumulated values.
 * @method scan
 * @owner Observable
 */
function scan(accumulator, seed) {
    var hasSeed = false;
    // providing a seed of `undefined` *should* be valid and trigger
    // hasSeed! so don't use `seed !== undefined` checks!
    // For this reason, we have to check it here at the original call site
    // otherwise inside Operator/Subscriber we won't know if `undefined`
    // means they didn't provide anything or if they literally provided `undefined`
    if (arguments.length >= 2) {
        hasSeed = true;
    }
    return this.lift(new ScanOperator(accumulator, seed, hasSeed));
}
exports.scan = scan;
var ScanOperator = (function () {
    function ScanOperator(accumulator, seed, hasSeed) {
        if (hasSeed === void 0) { hasSeed = false; }
        this.accumulator = accumulator;
        this.seed = seed;
        this.hasSeed = hasSeed;
    }
    ScanOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new ScanSubscriber(subscriber, this.accumulator, this.seed, this.hasSeed));
    };
    return ScanOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var ScanSubscriber = (function (_super) {
    __extends(ScanSubscriber, _super);
    function ScanSubscriber(destination, accumulator, _seed, hasSeed) {
        _super.call(this, destination);
        this.accumulator = accumulator;
        this._seed = _seed;
        this.hasSeed = hasSeed;
        this.index = 0;
    }
    Object.defineProperty(ScanSubscriber.prototype, "seed", {
        get: function () {
            return this._seed;
        },
        set: function (value) {
            this.hasSeed = true;
            this._seed = value;
        },
        enumerable: true,
        configurable: true
    });
    ScanSubscriber.prototype._next = function (value) {
        if (!this.hasSeed) {
            this.seed = value;
            this.destination.next(value);
        }
        else {
            return this._tryNext(value);
        }
    };
    ScanSubscriber.prototype._tryNext = function (value) {
        var index = this.index++;
        var result;
        try {
            result = this.accumulator(this.seed, value, index);
        }
        catch (err) {
            this.destination.error(err);
        }
        this.seed = result;
        this.destination.next(result);
    };
    return ScanSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=scan.js.map

/***/ }),

/***/ "tefl":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var PairsObservable_1 = __webpack_require__("NgUg");
exports.pairs = PairsObservable_1.PairsObservable.create;
//# sourceMappingURL=pairs.js.map

/***/ }),

/***/ "tgeP":
/***/ (function(module, exports) {

exports.config = {"status":true,"model":{"plazza":"true","title-en":"7 Men´s Morris","module":"mills","maxLevel":7,"summary":"An old board game","thumbnail":"mensmorris7-thumb3d.png","rules":"rules.html","description":"description.html","credits":"credits.html","js":["mills-model.js","7-men-morris-model.js"],"gameOptions":{"preventRepeat":true,"width":5,"height":5,"mencount":7,"poundInMill":false},"levels":[{"label":"Easy","maxDepth":2,"potential":100,"placingRace":1,"isDefault":true},{"label":"Medium","maxDepth":4,"potential":300,"placingRace":1},{"label":"Hard","maxDepth":8,"potential":1000,"placingRace":2}]},"view":{"js":["mills-xd-view.js","7-men-morris-view.js"],"visuals":{"600x600":["res/visuals/sevenmen-600x600-3d.jpg","res/visuals/sevenmen-600x600-2d.jpg"]},"xdView":true,"css":["mills.css","7-men-morris.css"],"title-en":"7 Men´s Morris View","module":"mills","preferredRatio":1.4,"switchable":true,"animateSelfMoves":false,"useNotation":true,"useShowMoves":true,"defaultOptions":{"sounds":true,"notation":false,"moves":true},"sounds":{"move1":"move1","move2":"move2","move3":"move3","move4":"move4","tac1":"tac1","tac2":"tac2","tac3":"tac3","capture":"promo","usermove":null},"skins":[{"name":"classic3d","title":"3D Classic","3d":true,"camera":{"radius":14,"elevationAngle":45,"distMax":39.5,"distMin":10.1,"elevationMin":-89.9,"elevationMax":89.9,"limitCamMoves":true},"world":{"lightIntensity":0.6,"skyLightIntensity":0.3,"lightPosition":{"x":0,"y":18,"z":0},"color":0,"fog":false},"preload":["image|/res/xd-view/meshes/woodcell1x512.jpg","image|/res/xd-view/meshes/piecetop-bump.jpg","image|/res/xd-view/meshes/piecediff.jpg","smoothedfilegeo|0|/res/xd-view/meshes/piece-v2.js","smoothedfilegeo|0|/res/xd-view/meshes/boardoriented.js","smoothedfilegeo|0|/res/xd-view/meshes/ring-target.js"]},{"name":"stone","title":"Stone"},{"name":"suede","title":"Suede"},{"name":"wood","title":"Wood"}]}}

/***/ }),

/***/ "th6N":
/***/ (function(module, exports) {

exports.config = {"status":true,"model":{"plazza":"true","released":1398178578,"title-en":"Gardner MiniChess","module":"chessbase","summary":"Gardner 5x5 minichess (1969)","thumbnail":"gardner-thumb.png","rules":{"en":"gardner-rules.html"},"credits":{"en":"gardner-credits.html"},"gameOptions":{"preventRepeat":true,"uctTransposition":"state","uctIgnoreLoop":false,"levelOptions":{"pieceValueFactor":1,"pieceValueRatioFactor":1,"posValueFactor":0.1,"averageDistKingFactor":-0.01,"castleFactor":0.1,"minorPiecesMovedFactor":0.1,"checkFactor":0.2,"endingKingFreedomFactor":0.01,"endingDistKingFactor":0.05,"distKingCornerFactor":0.1}},"obsolete":false,"js":["base-model.js","grid-geo-model.js","gardner-model.js"],"levels":[{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"easy","label":"Easy","maxNodes":1000},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"fast","label":"Fast [1sec]","maxDuration":1,"isDefault":true},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"medium","label":"Medium","maxNodes":10000,"maxDuration":10},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"strong","label":"Strong","maxNodes":20000,"maxDuration":15}],"description":{"en":"gardner-description.html"}},"view":{"title-en":"Chessbase view","module":"chessbase","xdView":true,"css":["chessbase.css"],"preferredRatio":1,"useShowMoves":true,"useNotation":true,"useAutoComplete":true,"defaultOptions":{"sounds":true,"moves":true,"notation":false,"autocomplete":false},"skins":[{"name":"skin3d","title":"3D Classic","3d":true,"preload":["smoothedfilegeo|0|/res/ring-target.js","image|/res/images/cancel.png","image|/res/images/wikipedia.png","smoothedfilegeo|0|/res/staunton/pawn/pawn-classic.js","image|/res/staunton/pawn/pawn-diffusemap.jpg","image|/res/staunton/pawn/pawn-normalmap.jpg","smoothedfilegeo|0|/res/staunton/knight/knight.js","image|/res/staunton/knight/knight-diffusemap.jpg","image|/res/staunton/knight/knight-normalmap.jpg","smoothedfilegeo|0|/res/staunton/bishop/bishop.js","image|/res/staunton/bishop/bishop-diffusemap.jpg","image|/res/staunton/bishop/bishop-normalmap.jpg","smoothedfilegeo|0|/res/staunton/rook/rook.js","image|/res/staunton/rook/rook-diffusemap.jpg","image|/res/staunton/rook/rook-normalmap.jpg","smoothedfilegeo|0|/res/staunton/queen/queen.js","image|/res/staunton/queen/queen-diffusemap.jpg","image|/res/staunton/queen/queen-normalmap.jpg","smoothedfilegeo|0|/res/staunton/king/king.js","image|/res/staunton/king/king-diffusemap.jpg","image|/res/staunton/king/king-normalmap.jpg"],"world":{"lightIntensity":1.3,"skyLightIntensity":1.2,"lightCastShadow":true,"fog":false,"color":4686804,"lightPosition":{"x":-9,"y":9,"z":9},"skyLightPosition":{"x":9,"y":9,"z":9},"lightShadowDarkness":0.55,"ambientLightColor":2236962},"camera":{"fov":45,"distMax":50,"radius":18,"elevationAngle":60,"elevationMin":0}},{"name":"skin2d","title":"2D Classic","3d":false,"preload":["image|/res/images/cancel.png","image|/res/images/whitebg.png","image|/res/images/wikipedia.png"]}],"animateSelfMoves":false,"switchable":true,"sounds":{"move1":"alq_move1","move2":"alq_move2","move3":"alq_move3","move4":"alq_move2","tac1":"alq_tac1","tac2":"alq_tac2","tac3":"alq_tac1","promo":"promo","usermove":null},"js":["base-view.js","grid-board-view.js","staunton-set-view.js","gardner-view.js"],"visuals":{"600x600":["res/visuals/gardner-600x600-3d.jpg","res/visuals/gardner-600x600-2d.jpg"]}}}

/***/ }),

/***/ "tkwt":
/***/ (function(module, exports) {

exports.model=Model={Game:{},Board:{},Move:{}},function(){var t;Model.Game.cbConstants={MASK:65535,FLAG_MOVE:65536,FLAG_CAPTURE:131072,FLAG_STOP:262144,FLAG_SCREEN_CAPTURE:524288,FLAG_CAPTURE_KING:1048576,FLAG_CAPTURE_NO_KING:2097152};var e="undefined"!=typeof Int32Array;Model.Game.cbUseTypedArrays=e,Model.Game.cbTypedArray=function(t){if(e){var r=new Int32Array(t.length);return r.set(t),r}for(var i=[],a=t.length,n=0;n<a;n++)i.push(t[n]);return i},Model.Game.cbShortRangeGraph=function(t,e,r,i){var a=this;void 0===i&&(i=196608);for(var n={},s=0;s<t.boardSize;s++)n[s]=[],(!r||s in r)&&e.forEach(function(e){var o=t.Graph(s,e);null!=o&&(!r||o in r)&&n[s].push(a.cbTypedArray([o|i]))});return n},Model.Game.cbLongRangeGraph=function(t,e,r,i,a){var n=this;void 0!==i&&null!=i||(i=196608),a||(a=1/0);for(var s={},o=0;o<t.boardSize;o++)s[o]=[],(!r||o in r)&&e.forEach(function(e){for(var h=[],c=t.Graph(o,e),p=0;null!=c&&(!r||c in r)&&(h.push(c|i),++p!=a);)c=t.Graph(c,e);h.length>0&&s[o].push(n.cbTypedArray(h))});return s},Model.Game.cbNullGraph=function(t){for(var e={},r=0;r<t.boardSize;r++)e[r]=[];return e},Model.Game.cbAuthorGraph=function(t){for(var e={},r=0;r<t.boardSize;r++){e[r]=[];for(var i=0;i<t.boardSize;i++)e[r].push([2293760|i])}return e},Model.Game.cbMergeGraphs=function(t){for(var e=[],r=0;r<t.boardSize;r++){e[r]=[];for(var i=1;i<arguments.length;i++)e[r]=e[r].concat(arguments[i][r])}return e},Model.Game.cbGetThreatGraph=function(){function t(e,r){for(var i in s){var a=s[i];if(!(a.p.length<r.length+1)){for(var n=!0,o=0;o<r.length;o++)if(r[o]!=a.p[o]){n=!1;break}if(n){var h=a.p[r.length],c=e[h];void 0===c&&(c={e:{}},e[h]=c),a.p.length==r.length+1&&(c.t=a.t,c.ts=a.ts,c.tk=a.tk,delete s[i]),r.push(h),t(c.e,r),r.pop()}}}}var e=this;this.cbUseScreenCapture=!1,this.cbUseCaptureKing=!1,this.cbUseCaptureNoKing=!1;for(var r={1:[],"-1":[]},i=[],a=0;a<this.g.boardSize;a++)this.g.pTypes.forEach(function(t,r){t.graph[a].forEach(function(t){for(var n=[],s=0;s<t.length;s++){var o=t[s];1048576&o?(e.cbUseCaptureKing=!0,n.unshift({d:65535&o,a:a,tk:r})):2097152&o?(e.cbUseCaptureNoKing=!0,n.unshift({d:65535&o,a:a,tnk:r})):131072&o?n.unshift({d:65535&o,a:a,t:r}):262144&o?n.unshift({d:65535&o,a:a}):524288&o&&(e.cbUseScreenCapture=!0,n.unshift({d:65535&o,a:a,ts:r}))}n.length>0&&i.push(n)})});var n={};i.forEach(function(t){t.forEach(function(e,r){var i=n[e.d];void 0===i&&(i={},n[e.d]=i);for(var a=[],s=r+1;s<t.length;s++)a.push(t[s].d);a.push(e.a);var o=a.join(","),h=i[o];void 0===h&&(h={p:a,t:{},ts:{},tk:{}},i[o]=h),void 0!==e.t?h.t[e.t]=!0:void 0!==e.tk?h.tk[e.tk]=!0:void 0!==e.ts&&(h.ts[e.ts]=!0)})});for(var a=0;a<e.g.boardSize;a++){var s=n[a],o={};t(o,[]),r[1][a]=o,r[-1][a]=o}return r},Model.Game.InitGame=function(){var e=this;this.cbVar=t=this.cbDefine(),this.g.boardSize=this.cbVar.geometry.boardSize,this.g.pTypes=this.cbGetPieceTypes(),this.g.threatGraph=this.cbGetThreatGraph(),this.g.distGraph=this.cbVar.geometry.GetDistances(),this.cbPiecesCount=0,this.g.castleablePiecesCount={1:0,"-1":0};for(var r in t.pieceTypes){var i=t.pieceTypes[r];if(i.castle){(i.initial||[]).forEach(function(t){e.g.castleablePiecesCount[t.s]++})}i.initial&&(this.cbPiecesCount+=i.initial.length)}for(var a=[],r=0;r<this.cbPiecesCount;r++)a.push(r);var n=Object.keys(t.pieceTypes);this.zobrist=new JocGame.Zobrist({board:{type:"array",size:this.cbVar.geometry.boardSize,values:a},who:{values:["1","-1"]},type:{type:"array",size:this.cbPiecesCount,values:n}})},Model.Game.cbGetPieceTypes=function(){for(var t=[],e={},r=0;r<this.cbVar.geometry.boardSize;r++)e[r]=[];for(var i in this.cbVar.pieceTypes){var a=this.cbVar.pieceTypes[i];t[i]={graph:a.graph||e,abbrev:a.abbrev||"",value:a.isKing?100:a.value||1,isKing:!!a.isKing,castle:!!a.castle,epTarget:!!a.epTarget,epCatch:!!a.epCatch}}return t},Model.Board.Init=function(t){this.zSign=0},Model.Board.InitialPosition=function(r){var i=this;this.board=e?new Int16Array(r.g.boardSize):[];for(var a=0;a<r.g.boardSize;a++)this.board[a]=-1;if(this.kings={},this.pieces=[],this.ending={1:!1,"-1":!1},this.lastMove=null,r.cbVar.castle&&(this.castled={1:!1,"-1":!1}),this.zSign=r.zobrist.update(0,"who",-1),this.noCaptCount=0,this.mWho=1,r.mInitial)this.mWho=r.mInitial.turn||1,r.mInitial.pieces.forEach(function(t){var e={};for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r]);i.pieces.push(e)}),r.mInitial.lastMove&&(this.lastMove={f:r.mInitial.lastMove.f,t:r.mInitial.lastMove.t}),void 0!==r.mInitial.noCaptCount&&(this.noCaptCount=r.mInitial.noCaptCount),r.cbVar.castle&&r.mInitial.castle&&(this.castled={1:{k:!!r.mInitial.castle[1]&&!!r.mInitial.castle[1].k,q:!!r.mInitial.castle[1]&&!!r.mInitial.castle[1].q},"-1":{k:!!r.mInitial.castle[-1]&&!!r.mInitial.castle[-1].k,q:!!r.mInitial.castle[-1]&&!!r.mInitial.castle[-1].q}});else for(var n in r.cbVar.pieceTypes)for(var s=r.cbVar.pieceTypes[n],o=s.initial||[],h=0;h<o.length;h++){var c=o[h],p={s:c.s,t:parseInt(n),p:c.p,m:!1};this.pieces.push(p)}if(this.pieces.sort(function(t,e){if(t.s!=e.s)return e.s-t.s;var i=r.cbVar.pieceTypes[t.t].value||100,a=r.cbVar.pieceTypes[e.t].value||100;return i!=a?i-a:t.p-e.p}),this.pieces.forEach(function(t,e){t.i=e,i.board[t.p]=e,r.g.pTypes[t.t].isKing&&(i.kings[t.s]=t.p),i.zSign=r.zobrist.update(i.zSign,"board",e,t.p),i.zSign=r.zobrist.update(i.zSign,"type",t.t,e)}),r.mInitial&&r.mInitial.enPassant){var a=t.geometry.PosByName(r.mInitial.enPassant);if(a>=0){var l,u=t.geometry.C(a),v=t.geometry.R(a);l=1==r.mInitial.turn?t.geometry.POS(u,v-1):t.geometry.POS(u,v+1),this.epTarget={p:a,i:this.board[l]}}}},Model.Board.CopyFrom=function(t){if(e)this.board=new Int16Array(t.board.length),this.board.set(t.board);else{this.board=[];for(var r=t.board,i=r.length,a=0;a<i;a++)this.board.push(r[a])}this.pieces=[];for(var n=t.pieces.length,a=0;a<n;a++){var s=t.pieces[a];this.pieces.push({s:s.s,p:s.p,t:s.t,i:s.i,m:s.m})}this.kings={1:t.kings[1],"-1":t.kings[-1]},this.check=t.check,t.lastMove?this.lastMove={f:t.lastMove.f,t:t.lastMove.t,c:t.lastMove.c}:this.lastMove=null,this.ending={1:t.ending[1],"-1":t.ending[-1]},void 0!==t.castled&&(this.castled={1:t.castled[1],"-1":t.castled[-1]}),this.noCaptCount=t.noCaptCount,t.epTarget?this.epTarget={p:t.epTarget.p,i:t.epTarget.i}:this.epTarget=null,this.mWho=t.mWho,this.zSign=t.zSign},Model.Board.cbApplyCastle=function(t,e,r){var i=t.cbVar.castle[e.f+"/"+e.cg],a=i.r[i.r.length-1],n=this.pieces[this.board[e.cg]],s=i.k[i.k.length-1],o=this.pieces[this.board[e.f]];return r&&(this.zSign=t.zobrist.update(this.zSign,"board",n.i,e.cg),this.zSign=t.zobrist.update(this.zSign,"board",n.i,a),this.zSign=t.zobrist.update(this.zSign,"board",o.i,e.f),this.zSign=t.zobrist.update(this.zSign,"board",o.i,s)),n.p=a,n.m=!0,this.board[e.cg]=-1,o.p=s,o.m=!0,this.board[e.f]=-1,this.board[a]=n.i,this.board[s]=o.i,this.castled[n.s]=!0,this.kings[o.s]=s,[{i:n.i,f:a,t:-1},{i:o.i,f:s,t:e.f,kp:e.f,who:o.s,m:!1},{i:n.i,f:-1,t:e.cg,m:!1,cg:!1}]},Model.Board.cbQuickApply=function(t,e){if(void 0!==e.cg)return this.cbApplyCastle(t,e,!1);var r=[],i=this.board[e.f],a=this.pieces[i];if(null!=e.c){r.unshift({i:e.c,f:-1,t:this.pieces[e.c].p});var n=this.pieces[e.c];this.board[n.p]=-1,n.p=-1}var s=this.kings[a.s];return t.g.pTypes[a.t].isKing&&(this.kings[a.s]=e.t),r.unshift({i:i,f:e.t,t:e.f,kp:s,who:a.s,ty:a.t}),a.p=e.t,void 0!==e.pr&&(a.t=e.pr),this.board[e.f]=-1,this.board[e.t]=i,r},Model.Board.cbQuickUnapply=function(t,e){for(var r=0;r<e.length;r++){var i=e[r],a=this.pieces[i.i];i.f>=0&&(a.p=-1,this.board[i.f]=-1),i.t>=0&&(a.p=i.t,this.board[i.t]=i.i),void 0!==i.m&&(a.m=i.m),void 0!==i.kp&&(this.kings[i.who]=i.kp),void 0!=i.ty&&(a.t=i.ty),void 0!=i.cg&&(this.castled[a.s]=i.cg)}},Model.Board.ApplyMove=function(t,e){var r=this.pieces[this.board[e.f]];if(void 0!==e.cg)this.cbApplyCastle(t,e,!0);else{if(this.zSign=t.zobrist.update(this.zSign,"board",r.i,e.f),this.board[r.p]=-1,void 0!==e.pr&&(this.zSign=t.zobrist.update(this.zSign,"type",r.t,r.i),r.t=e.pr,this.zSign=t.zobrist.update(this.zSign,"type",r.t,r.i)),null!=e.c){var i=this.pieces[e.c];this.zSign=t.zobrist.update(this.zSign,"board",i.i,i.p),this.board[i.p]=-1,i.p=-1,i.m=!0,this.noCaptCount=0}else this.noCaptCount++;r.p=e.t,r.m=!0,this.board[e.t]=r.i,this.zSign=t.zobrist.update(this.zSign,"board",r.i,e.t),t.g.pTypes[r.t].isKing&&(this.kings[r.s]=e.t)}this.check=!!e.ck,this.lastMove={f:e.f,t:e.t,c:e.c},void 0!==e.ko&&(this.ending[r.s]=e.ko),void 0!==e.ept?this.epTarget={p:e.ept,i:r.i}:this.epTarget=null,this.zSign=t.zobrist.update(this.zSign,"who",-this.mWho),this.zSign=t.zobrist.update(this.zSign,"who",this.mWho)},Model.Board.Evaluate=function(r){function i(e){var r=1/0;for(var i in t.geometry.corners)r=Math.min(r,h.distGraph[n.kings[e]][i]);return r-Math.sqrt(h.boardSize)}var a="debug"==arguments[3],n=this;this.mEvaluation=0;var s,o=this.mWho,h=r.g;if(e)s={1:{count:new Uint8Array(h.pTypes.length),byType:{}},"-1":{count:new Uint8Array(h.pTypes.length),byType:{}}};else{s={1:{count:[],byType:{}},"-1":{count:[],byType:{}}};for(var c=0;c<h.pTypes.length;c++)s[1].count[c]=s[-1].count[c]=0}if(r.mOptions.preventRepeat&&r.GetRepeatOccurence(this)>2)return this.mFinished=!0,void(this.mWinner=r.cbOnPerpetual?o*r.cbOnPerpetual:JocGame.DRAW);for(var p={1:0,"-1":0},l={1:h.distGraph[this.kings[-1]],"-1":h.distGraph[this.kings[1]]},u={1:0,"-1":0},v={1:0,"-1":0},f={1:0,"-1":0},b={1:0,"-1":0},d={1:!1,"-1":!1},g=this.pieces,m=g.length,c=0;c<m;c++){var G=g[c];if(G.p>=0){var y=G.s,M=h.pTypes[G.t];M.isKing?d[y]=G.m:p[y]+=M.value,M.castle&&!G.m&&b[y]++,v[y]++,u[y]+=l[y][G.p],f[y]+=t.geometry.distEdge[G.p];var C=s[y];C.count[G.t]++;var S=C.byType;void 0===S[G.t]?S[G.t]=[G]:S[G.t].push(G)}}if(this.lastMove&&null!=this.lastMove.c){var G=this.pieces[this.board[this.lastMove.t]];p[-G.s]+=this.cbStaticExchangeEval(r,G.p,G.s,{piece:G})}var A={1:0,"-1":0},k={1:0,"-1":0},T={1:0,"-1":0};this.ending[1]&&(k[1]=(u[1]-Math.sqrt(h.boardSize))/v[1],t.geometry.corners&&(T[1]=i(1))),this.ending[-1]&&(k[-1]=(u[-1]-Math.sqrt(h.boardSize))/v[-1],t.geometry.corners&&(T[1]=i(-1)));var z={pieceValue:p[1]-p[-1],pieceValueRatio:(p[1]-p[-1])/(p[1]+p[-1]+1),posValue:f[1]-f[-1],averageDistKing:u[1]/v[1]-u[-1]/v[-1],check:this.check?-o:0,endingKingFreedom:A[1]-A[-1],endingDistKing:k[1]-k[-1],distKingCorner:T[1]-T[-1]};t.castle&&(z.castle=(this.castled[1]?1:d[1]?0:b[1]/(h.castleablePiecesCount[1]+1))-(this.castled[-1]?1:d[-1]?0:b[-1]/(h.castleablePiecesCount[-1]+1))),t.evaluate&&t.evaluate.call(this,r,z,s);var P=r.mOptions.levelOptions;for(var E in z){var w=z[E],R=P[E+"Factor"]||0,I=w*R;a&&console.log(E,"=",w,"*",R,"=>",I),this.mEvaluation+=I}a&&console.log("Evaluation",this.mEvaluation)},Model.Board.cbGeneratePseudoLegalMoves=function(t){function e(e,a){var n=t.cbVar.promote;if(!n)return void i.push(a);var s=n.call(r,t,e,a);if(null!=s)if(0==s.length)i.push(a);else if(1==s.length)a.pr=s[0],i.push(a);else for(var o=0;o<s.length;o++){var h=s[o];i.push({f:a.f,t:a.t,c:a.c,pr:h,ept:a.ept,ep:a.ep,a:a.a})}}for(var r=this,i=[],a=t.cbVar,n=this.mWho,s=!a.castle||this.check||this.castled[n]?null:[],o=-1,h=this.pieces.length,c=0;c<h;c++){var p=this.pieces[c];if(!(p.p<0||p.s!=n)){var l=t.g.pTypes[p.t];l.isKing&&(p.m?s=null:o=p),s&&l.castle&&!p.m&&s.push(p);var u,v;u=l.graph[p.p],v=u.length;for(var f=0;f<v;f++)for(var b=u[f],d=!1,g=b.length,m=null,G=0;G<g;G++){var y=b[G],M=65535&y,C=this.board[M];if(!(C<0)||l.epCatch&&this.epTarget&&this.epTarget.p==M){if(!(524288&y)){var S;S=C<0?this.pieces[this.epTarget.i]:this.pieces[C],!(S.s!=p.s&&131072&y)||1048576&y&&!t.g.pTypes[S.t].isKing||2097152&y&&t.g.pTypes[S.t].isKing||e(p,{f:p.p,t:M,c:S.i,a:l.abbrev,ep:C<0});break}if(d){var S=this.pieces[C];S.s!=p.s&&e(p,{f:p.p,t:M,c:S.i,a:l.abbrev});break}d=!0}else 65536&y&&0==d&&e(p,{f:p.p,t:M,c:null,a:l.abbrev,ept:null!=m&&l.epTarget?m:void 0});m=M}}}if(s)for(var c=0;c<s.length;c++){var A=s[c],k=t.cbVar.castle[o.p+"/"+A.p];if(k){for(var T=!0,f=0;f<k.r.length;f++){var z=k.r[f];if(this.board[z]>=0&&z!=o.p&&z!=A.p){T=!1;break}}if(T){for(var P=!0,f=0;f<k.k.length;f++){var z=k.k[f];if(this.board[z]>=0&&z!=A.p&&z!=o.p||this.cbGetAttackers(t,z,n).length>0){P=!1;break}}P&&i.push({f:o.p,t:k.k[k.k.length-1],c:null,cg:A.p})}}}return i},Model.Board.cbStaticExchangeEval=function(t,e,r,i){var a=0,n=this.cbGetSmallestAttacker(t,e,r);if(n){var s=this.mWho;this.mWho=n.s;var o=this.cbQuickApply(t,{f:n.p,t:e,c:i.piece.i}),h=t.g.pTypes[i.piece.t].value;i.piece=n,a=Math.max(0,h-this.cbStaticExchangeEval(t,e,-r,i)),this.cbQuickUnapply(t,o),this.mWho=s}return a},Model.Board.cbGetSmallestAttacker=function(t,e,r){var i=this.cbGetAttackers(t,e,r);if(0==i.length)return null;for(var a=1/0,n=null,s=i.length,o=0;o<s;o++){var h=i[o],c=t.g.pTypes[h.t].value;c<a&&(a=c,n=h)}return n},Model.Board.cbCollectAttackers=function(t,e,r,i){for(var a in e){var n=e[a],s=this.board[a];if(s<0)this.cbCollectAttackers(t,n.e,r,i);else{var o=this.pieces[s];o.s==-t&&(n.t&&o.t in n.t||i&&n.tk&&o.t in n.tk)&&r.push(o)}}},Model.Board.cbCollectAttackersScreen=function(t,e,r,i,a){for(var n in e){var s=e[n],o=this.board[n];if(o<0)this.cbCollectAttackersScreen(t,s.e,r,i,a);else{var h=this.pieces[o];!a&&h.s==-t&&(s.t&&h.t in s.t||i&&s.tk&&h.t in s.tk)?r.push(h):a?a&&h.s==-t&&s.ts&&h.t in s.ts&&r.push(h):this.cbCollectAttackersScreen(t,s.e,r,i,!0)}}},Model.Board.cbGetAttackers=function(t,e,r,i){var a=[];return t.cbUseScreenCapture?this.cbCollectAttackersScreen(r,t.g.threatGraph[r][e],a,i,!1):this.cbCollectAttackers(r,t.g.threatGraph[r][e],a,i),a},Model.Board.GenerateMoves=function(t){var e=this.cbGeneratePseudoLegalMoves(t);this.mMoves=[];for(var r=!0,i=this.kings[this.mWho],a=e.length,n=0;n<a;n++){var s=e[n],o=this.cbQuickApply(t,s);if(!(this.cbGetAttackers(t,this.kings[this.mWho],this.mWho,!0).length>0)){var h=this.cbGetAttackers(t,this.kings[-this.mWho],-this.mWho,!0).length>0;s.ck=h,this.mMoves.push(s),s.f!=i&&(r=!1)}this.cbQuickUnapply(t,o)}if(0==this.mMoves.length)this.mFinished=!0,this.mWinner=t.cbOnStaleMate?t.cbOnStaleMate*this.mWho:JocGame.DRAW,this.check&&(this.mWinner=-this.mWho);else if(this.ending[this.mWho]){if(!r)for(var n=0;n<this.mMoves.length;n++)this.mMoves[n].ko=!1}else if(!this.ending[this.mWho]&&r&&!this.check)for(var n=0;n<this.mMoves.length;n++)this.mMoves[n].ko=!0},Model.Board.GetSignature=function(){return this.zSign},Model.Move.Init=function(t){for(var e in t)t.hasOwnProperty(e)&&(this[e]=t[e])},Model.Move.Equals=function(t){return this.f==t.f&&this.t==t.t&&this.pr==t.pr},Model.Move.CopyFrom=function(t){this.Init(t)},Model.Move.ToString=function(e){var r=this;switch(e=e||"natural"){case"natural":return function(){var e;if(void 0!==r.cg?e=t.castle[r.f+"/"+r.cg].n:(e=r.a||"",e+=t.geometry.PosName(r.f),null==r.c?e+="-":e+="x",e+=t.geometry.PosName(r.t)),void 0!==r.pr){var i=t.pieceTypes[r.pr];i&&i.abbrev&&i.abbrev.length>0&&!i.silentPromo&&(e+="="+i.abbrev)}return r.ck&&(e+="+"),e}();case"engine":return function(){var e=t.geometry.PosName(r.f)+t.geometry.PosName(r.t);if(void 0!=r.pr){var i=t.pieceTypes[r.pr];i&&i.abbrev&&i.abbrev.length>0&&!i.silentPromo&&(e+=i.abbrev)}return e}();default:return"??"}},Model.Board.CompactMoveString=function(e,r,i){"function"!=typeof r.ToString&&(r=e.CreateMove(r));var a=r.ToString(),n=/^([A-Z]?)([a-z])([1-9][0-9]*)([-x])([a-z])([1-9][0-9]*)(.*?)$/.exec(a);if(!n)return a;var s=n[7];if(i||(i={}),i.value||(i.value=[]),0==i.value.length){var o=this.mMoves;this.mMoves&&0!=this.mMoves.length||this.GenerateMoves(e);for(var h=0;h<this.mMoves.length;h++){var c=this.mMoves[h];"function"!=typeof c.ToString&&(c=e.CreateMove(c)),i.value.push({str:c.ToString(),move:c})}this.mMoves=o}var p=[];if(i.value.forEach(function(t){var e=/^([A-Z]?[a-z][1-9][0-9]*[-x][a-z][1-9][0-9]*)(.*?)$/.exec(t.str);e&&t.move.t==r.t&&(t.move.a||"")==n[1]&&e[2]==s&&p.push(t.move)}),1==p.length)return""==n[1]&&"x"==n[4]?n[2]+"x"+n[5]+n[6]+n[7]:n[1]+("x"==n[4]?"x":"")+n[5]+n[6]+n[7];if(t.geometry.CompactCrit)for(var l="",h=0;;h++){var u=t.geometry.CompactCrit(r.f,h);if(null==u)return a;l+=u;for(var v=[],f=0;f<p.length;f++){var b=p[f];t.geometry.CompactCrit(b.f,h)==u&&v.push(b)}if(console.assert(v.length>0),1==v.length)return n[1]+l+("x"==n[4]?"x":"")+n[5]+n[6]+n[7];p=v}return a},Model.Board.cbIntegrity=function(t){function e(t,e){t||console.error(e)}for(var r=this,i=0;i<this.board.length;i++){var a=this.board[i];if(a>=0){var n=r.pieces[a];e(void 0!==n,"no piece at pos"),e(n.p==i,"piece has different pos")}}for(var a=0;a<this.pieces.length;a++){var n=this.pieces[a];n.p>=0&&e(r.board[n.p]==a,"board index mismatch")}},Model.Board.ExportBoardState=function(t){return t.cbVar.geometry.ExportBoardState?t.cbVar.geometry.ExportBoardState(this,t.cbVar,t.mPlayedMoves.length):"not supported"},Model.Game.Import=function(e,r){var i,a=[],n={1:{},"-1":{}},s=null,o=0;if("pjn"==e){var h={status:!1,error:"parse"},c=r.split(" ");if(6!=c.length)return console.warn("FEN should have 6 parts"),h;var p=c[0].split("/"),l=t.geometry.fenHeight||t.geometry.height;if(p.length!=l)return console.warn("FEN board should have",l,"rows, got",p.length),h;var u={};for(var v in t.pieceTypes){var f=t.pieceTypes[v],b=f.fenAbbrev||f.abbrev||"X";u[b.toUpperCase()]={s:1,t:v},u[b.toLowerCase()]={s:-1,t:v}}var d=t.geometry.FenRowPos||function(e,r){return(t.geometry.height-1-e)*t.geometry.width+r};if(p.forEach(function(e,r){for(var i=0,n=0;n<e.length;n++){var s=e.substr(n,1),o=u[s];if(void 0!==o){var c=d(r,i);i++;for(var p={s:o.s,t:o.t,p:c},l=!0,v=t.pieceTypes[p.t].initial||[],f=0;f<v.length;f++){var b=v[f];b.s==p.s&&b.p==c&&(l=!1)}p.m=l,a.push(p)}else{if(isNaN(parseInt(s)))return console.warn("FEN invalid board spec",s),h;i+=parseInt(s)}}}),a.sort(function(t,e){return e.s-t.s}),"w"==c[1])i=1;else{if("b"!=c[1])return console.warn("FEN invalid turn spec",c[1]),h;i=-1}n[1].k=c[2].indexOf("K")>=0,n[1].q=c[2].indexOf("Q")>=0,n[-1].k=c[2].indexOf("k")>=0,n[-1].q=c[2].indexOf("q")>=0,s="-"==c[3]?null:c[3];var g=parseInt(c[4]);isNaN(g)||(o=g);var m={pieces:a,turn:i,castle:n,enPassant:s,noCaptCount:o};return t.importGame&&t.importGame.call(this,m,e,r),{status:!0,initial:m}}return{status:!1,error:"unsupported"}}}(),function(){Model.Game.cbBoardGeometryCylinder=function(t,e){function r(e){return e%t}function i(e){return Math.floor(e/t)}function a(e,r){return r*t+e}function n(n,s){for(var o=r(n),h=i(n),c=o+s[0];c<0;)c+=t;c%=t;var p=h+s[1];return p<0||p>=e?null:a(c,p)}function s(t){return String.fromCharCode("a".charCodeAt(0)+r(t))+(i(t)+1)}function o(t){var e=/^([a-z])([0-9]+)$/.exec(t);return e?a(e[1].charCodeAt(0)-"a".charCodeAt(0),parseInt(e[2])-1):-1}function h(t,e){return 0==e?String.fromCharCode("a".charCodeAt(0)+r(t)):1==e?i(t)+1:null}function c(){return l}for(var p=t*e,l={},u=0;u<p;u++)l[u]={},l[u][u]=0;for(var v=[[1,-1],[1,0],[1,1],[0,-1],[0,1],[-1,-1],[-1,0],[-1,-1]],f=!0;f;){f=!1;for(var u=0;u<p;u++)v.forEach(function(t){var e=n(u,t);if(null!=e){1!=l[u][e]&&(l[u][e]=1,l[e][u]=1,f=!0);for(var r=0;r<p;r++)r!=u&&(void 0===l[e][r]&&void 0!==l[u][r]?(l[e][r]=l[u][r]+1,l[r][e]=l[u][r]+1,f=!0):void 0!==l[e][r]&&void 0!==l[u][r]&&l[e][r]>l[u][r]+1&&(l[e][r]=l[u][r]+1,l[r][e]=l[u][r]+1,f=!0))}})}for(var b={},f=!0;f;){f=!1;for(var u=0;u<p;u++)u in b||v.forEach(function(t){var e=n(u,t);null==e?b[u]=1:e in b&&(u in b&&!(b[u]>b[e]+1)||(b[u]=b[e]+1,f=!0))})}return{boardSize:p,width:t,height:e,C:r,R:i,POS:a,Graph:n,PosName:s,PosByName:o,CompactCrit:h,GetDistances:c,distEdge:b,corners:null}},Model.Game.cbPawnGraph=function(t,e){for(var r=this,i={},a=0;a<t.boardSize;a++){var n=[],s=t.Graph(a,[0,e]);null!=s&&n.push(r.cbTypedArray([s|r.cbConstants.FLAG_MOVE])),[-1,1].forEach(function(i){var s=t.Graph(a,[i,e]);null!=s&&n.push(r.cbTypedArray([s|r.cbConstants.FLAG_CAPTURE]))}),i[a]=n}return i},Model.Game.cbInitialPawnGraph=function(t,e){for(var r=this,i={},a=0;a<t.boardSize;a++){var n=[],s=t.Graph(a,[0,e]);if(null!=s){var o=[s|r.cbConstants.FLAG_MOVE],h=t.Graph(s,[0,e]);null!=h&&o.push(h|r.cbConstants.FLAG_MOVE),n.push(r.cbTypedArray(o))}[-1,1].forEach(function(i){var s=t.Graph(a,[i,e]);null!=s&&n.push(r.cbTypedArray([s|r.cbConstants.FLAG_CAPTURE]))}),i[a]=n}return i},Model.Game.cbKingGraph=function(t){return this.cbShortRangeGraph(t,[[-1,-1],[-1,0],[-1,1],[0,-1],[0,1],[1,-1],[1,0],[1,1]])},Model.Game.cbKnightGraph=function(t){return this.cbShortRangeGraph(t,[[2,-1],[2,1],[-2,-1],[-2,1],[-1,2],[-1,-2],[1,2],[1,-2]])},Model.Game.cbHorseGraph=function(t){for(var e=this,r={},i=0;i<t.boardSize;i++)r[i]=[],[[1,0,2,-1],[1,0,2,1],[-1,0,-2,-1],[-1,0,-2,1],[0,1,-1,2],[0,-1,-1,-2],[0,1,1,2],[0,-1,1,-2]].forEach(function(a){var n=t.Graph(i,[a[0],a[1]]);if(null!=n){var s=t.Graph(i,[a[2],a[3]]);null!=s&&r[i].push(e.cbTypedArray([n|e.cbConstants.FLAG_STOP,s|e.cbConstants.FLAG_MOVE|e.cbConstants.FLAG_CAPTURE]))}});return r},Model.Game.cbRookGraph=function(t){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0]])},Model.Game.cbBishopGraph=function(t){return this.cbLongRangeGraph(t,[[1,-1],[1,1],[-1,1],[-1,-1]])},Model.Game.cbQueenGraph=function(t){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0],[1,-1],[1,1],[-1,1],[-1,-1]])},Model.Game.cbXQGeneralGraph=function(t,e){for(var r=this,i={},a=0;a<t.boardSize;a++)i[a]=[],[[-1,0,!1],[0,-1,!0],[0,1,!0],[1,0,!1]].forEach(function(n){var s=[],o=t.Graph(a,n);if(null!=o&&((!e||o in e)&&s.push(o|r.cbConstants.FLAG_MOVE|r.cbConstants.FLAG_CAPTURE),n[2]))for(var h=t.Graph(o,n);null!=h;)!e||h in e?s.push(h|r.cbConstants.FLAG_CAPTURE|r.cbConstants.FLAG_CAPTURE_KING):s.push(h|r.cbConstants.FLAG_STOP),h=t.Graph(h,n);s.length>0&&i[a].push(r.cbTypedArray(s))});return i},Model.Game.cbXQSoldierGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e]])},Model.Game.cbXQPromoSoldierGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e],[-1,0],[1,0]])},Model.Game.cbXQAdvisorGraph=function(t,e){return this.cbShortRangeGraph(t,[[1,1],[-1,1],[1,-1],[-1,-1]],e)},Model.Game.cbXQCannonGraph=function(t){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0]],null,this.cbConstants.FLAG_MOVE|this.cbConstants.FLAG_SCREEN_CAPTURE)},Model.Game.cbXQElephantGraph=function(t,e){for(var r=this,i={},a=0;a<t.boardSize;a++)i[a]=[],(!e||a in e)&&[[1,1,2,2],[1,-1,2,-2],[-1,1,-2,2],[-1,-1,-2,-2]].forEach(function(n){var s=t.Graph(a,[n[0],n[1]]);if(null!=s){var o=t.Graph(a,[n[2],n[3]]);null!=o&&(!e||o in e)&&i[a].push(r.cbTypedArray([s|r.cbConstants.FLAG_STOP,o|r.cbConstants.FLAG_MOVE|r.cbConstants.FLAG_CAPTURE]))}});return i},Model.Game.cbSilverGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e],[-1,-1],[-1,1],[1,-1],[1,1]])},Model.Game.cbFersGraph=function(t,e){return this.cbShortRangeGraph(t,[[-1,-1],[-1,1],[1,-1],[1,1]])},Model.Game.cbElephantGraph=function(t,e){return this.cbShortRangeGraph(t,[[-2,-2],[-2,2],[2,-2],[2,2]])},Model.Game.cbSchleichGraph=function(t,e){return this.cbShortRangeGraph(t,[[-1,0],[1,0],[0,-1],[0,1]])},Model.Game.cbAlfilGraph=function(t,e){return this.cbShortRangeGraph(t,[[-2,-2],[-2,2],[2,2],[2,-2]])},Model.Game.cbCylinderRookGraph=function(t){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0]],null,null,Math.max(t.width,t.height)-1)},Model.Game.cbCircularPawnGraph=function(t,e,r){var i=this.cbLongRangeGraph(t,e?[[1,0]]:[[-1,0]],null,this.cbConstants.FLAG_MOVE,r),a=this.cbShortRangeGraph(t,e?[[1,1],[1,-1]]:[[-1,1],[-1,-1]],null,this.cbConstants.FLAG_CAPTURE);return this.cbMergeGraphs(t,i,a)}}(),function(){var t=Model.Game.cbBoardGeometryCylinder(16,4),e={1:{11:1,27:1,43:1,59:1,12:1,28:1,44:1,60:1},"-1":{52:1,36:1,20:1,4:1,51:1,35:1,19:1,3:1}},r={1:{},"-1":{}},i=t.GetDistances();["1","-1"].forEach(function(a){for(var n in t.confine){var s=1/0;for(var o in e[a]){var h=i[n][o];h<s&&(r[a][n]=h,s=h)}}}),Model.Game.cbDefine=function(){return{geometry:t,pieceTypes:{0:{name:"pawn-cw",aspect:"pawn",graph:this.cbCircularPawnGraph(t,!0,1),value:1,abbrev:"",fenAbbrev:"P"},1:{name:"ipawn-cw",aspect:"pawn",graph:this.cbCircularPawnGraph(t,!0,2),value:1,abbrev:"",fenAbbrev:"P",initial:[{s:1,p:5},{s:1,p:21},{s:1,p:37},{s:1,p:53},{s:-1,p:13},{s:-1,p:29},{s:-1,p:45},{s:-1,p:61}]},2:{name:"pawn-ccw",aspect:"pawn",graph:this.cbCircularPawnGraph(t,!1,1),value:1,abbrev:"",fenAbbrev:"P"},3:{name:"ipawn-ccw",aspect:"pawn",graph:this.cbCircularPawnGraph(t,!1,2),value:1,abbrev:"",fenAbbrev:"P",initial:[{s:1,p:2},{s:1,p:18},{s:1,p:34},{s:1,p:50},{s:-1,p:10},{s:-1,p:26},{s:-1,p:42},{s:-1,p:58}]},4:{name:"knight",graph:this.cbKnightGraph(t),value:2.9,abbrev:"N",initial:[{s:1,p:20},{s:1,p:19},{s:-1,p:27},{s:-1,p:28}]},5:{name:"bishop",graph:this.cbBishopGraph(t),value:3.1,abbrev:"B",initial:[{s:1,p:36},{s:1,p:35},{s:-1,p:43},{s:-1,p:44}]},6:{name:"rook",graph:this.cbCylinderRookGraph(t),value:5,abbrev:"R",initial:[{s:1,p:4},{s:1,p:3},{s:-1,p:11},{s:-1,p:12}],castle:!0},7:{name:"queen",graph:this.cbMergeGraphs(t,this.cbCylinderRookGraph(t),this.cbBishopGraph(t)),value:9,abbrev:"Q",initial:[{s:1,p:51},{s:-1,p:60}]},8:{name:"king",isKing:!0,graph:this.cbKingGraph(t),abbrev:"K",initial:[{s:1,p:52},{s:-1,p:59}]}},promote:function(t,r,i){return 1==r.t?[0]:3==r.t?[2]:1==r.s&&(0==r.t||2==r.t)&&i.t in e[1]?[4,5,6,7]:r.s==-1&&(0==r.t||2==r.t)&&i.t in e[-1]?[4,5,6,7]:[]},evaluate:function(t,e,i){var a=i[1].count,n=i[-1].count;a[0]||a[1]||a[4]||a[5]||a[6]||a[7]||n[2]||n[3]||n[6]||n[7]||!(n[4]+n[5]<2||n[5]<2)||(this.mFinished=!0,this.mWinner=JocGame.DRAW),n[2]||n[3]||n[4]||n[5]||n[6]||n[7]||a[0]||a[1]||a[6]||a[7]||!(a[4]+a[5]<2||a[5]<2)||(this.mFinished=!0,this.mWinner=JocGame.DRAW),this.noCaptCount>=100&&(this.mFinished=!0,this.mWinner=JocGame.DRAW);var s,o=t.cbUseTypedArrays?new Int8Array(3):[0,0,0],h=i[1].byType[0];if(h){s=h.length;for(var c=0;c<s;c++){var p=r[1][h[c].p];p>0&&p<4&&o[p-1]++}}if(h=i[-1].byType[2]){s=h.length;for(var c=0;c<s;c++){var p=r[-1][h[c].p];p>0&&p<4&&o[p-1]--}}0!=o[0]&&(e.distPawnPromo1=o[0]),0!=o[1]&&(e.distPawnPromo2=o[1]),0!=o[2]&&(e.distPawnPromo3=o[2]);for(var l=0,u=4;u<=5;u++)for(var v=1;v>=-1;v-=2){var f=i[v].byType[u];if(f)for(var c=0;c<f.length;c++)f[c].m&&(l+=v)}0!=l&&(e.minorPiecesMoved=l)}}}}();

/***/ }),

/***/ "tn1n":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var not_1 = __webpack_require__("7Gky");
var filter_1 = __webpack_require__("ack3");
/**
 * Splits the source Observable into two, one with values that satisfy a
 * predicate, and another with values that don't satisfy the predicate.
 *
 * <span class="informal">It's like {@link filter}, but returns two Observables:
 * one like the output of {@link filter}, and the other with values that did not
 * pass the condition.</span>
 *
 * <img src="./img/partition.png" width="100%">
 *
 * `partition` outputs an array with two Observables that partition the values
 * from the source Observable through the given `predicate` function. The first
 * Observable in that array emits source values for which the predicate argument
 * returns true. The second Observable emits source values for which the
 * predicate returns false. The first behaves like {@link filter} and the second
 * behaves like {@link filter} with the predicate negated.
 *
 * @example <caption>Partition click events into those on DIV elements and those elsewhere</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var parts = clicks.partition(ev => ev.target.tagName === 'DIV');
 * var clicksOnDivs = parts[0];
 * var clicksElsewhere = parts[1];
 * clicksOnDivs.subscribe(x => console.log('DIV clicked: ', x));
 * clicksElsewhere.subscribe(x => console.log('Other clicked: ', x));
 *
 * @see {@link filter}
 *
 * @param {function(value: T, index: number): boolean} predicate A function that
 * evaluates each value emitted by the source Observable. If it returns `true`,
 * the value is emitted on the first Observable in the returned array, if
 * `false` the value is emitted on the second Observable in the array. The
 * `index` parameter is the number `i` for the i-th source emission that has
 * happened since the subscription, starting from the number `0`.
 * @param {any} [thisArg] An optional argument to determine the value of `this`
 * in the `predicate` function.
 * @return {[Observable<T>, Observable<T>]} An array with two Observables: one
 * with values that passed the predicate, and another with values that did not
 * pass the predicate.
 * @method partition
 * @owner Observable
 */
function partition(predicate, thisArg) {
    return [
        filter_1.filter.call(this, predicate, thisArg),
        filter_1.filter.call(this, not_1.not(predicate, thisArg))
    ];
}
exports.partition = partition;
//# sourceMappingURL=partition.js.map

/***/ }),

/***/ "tuHt":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var switchMapTo_1 = __webpack_require__("SDFq");
Observable_1.Observable.prototype.switchMapTo = switchMapTo_1.switchMapTo;
//# sourceMappingURL=switchMapTo.js.map

/***/ }),

/***/ "u/VN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var OuterSubscriber_1 = __webpack_require__("wAkD");
var subscribeToResult_1 = __webpack_require__("CURp");
/**
 * Emits a value from the source Observable, then ignores subsequent source
 * values for a duration determined by another Observable, then repeats this
 * process.
 *
 * <span class="informal">It's like {@link throttleTime}, but the silencing
 * duration is determined by a second Observable.</span>
 *
 * <img src="./img/throttle.png" width="100%">
 *
 * `throttle` emits the source Observable values on the output Observable
 * when its internal timer is disabled, and ignores source values when the timer
 * is enabled. Initially, the timer is disabled. As soon as the first source
 * value arrives, it is forwarded to the output Observable, and then the timer
 * is enabled by calling the `durationSelector` function with the source value,
 * which returns the "duration" Observable. When the duration Observable emits a
 * value or completes, the timer is disabled, and this process repeats for the
 * next source value.
 *
 * @example <caption>Emit clicks at a rate of at most one click per second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.throttle(ev => Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link audit}
 * @see {@link debounce}
 * @see {@link delayWhen}
 * @see {@link sample}
 * @see {@link throttleTime}
 *
 * @param {function(value: T): SubscribableOrPromise} durationSelector A function
 * that receives a value from the source Observable, for computing the silencing
 * duration for each source value, returned as an Observable or a Promise.
 * @return {Observable<T>} An Observable that performs the throttle operation to
 * limit the rate of emissions from the source.
 * @method throttle
 * @owner Observable
 */
function throttle(durationSelector) {
    return this.lift(new ThrottleOperator(durationSelector));
}
exports.throttle = throttle;
var ThrottleOperator = (function () {
    function ThrottleOperator(durationSelector) {
        this.durationSelector = durationSelector;
    }
    ThrottleOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new ThrottleSubscriber(subscriber, this.durationSelector));
    };
    return ThrottleOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var ThrottleSubscriber = (function (_super) {
    __extends(ThrottleSubscriber, _super);
    function ThrottleSubscriber(destination, durationSelector) {
        _super.call(this, destination);
        this.destination = destination;
        this.durationSelector = durationSelector;
    }
    ThrottleSubscriber.prototype._next = function (value) {
        if (!this.throttled) {
            this.tryDurationSelector(value);
        }
    };
    ThrottleSubscriber.prototype.tryDurationSelector = function (value) {
        var duration = null;
        try {
            duration = this.durationSelector(value);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        this.emitAndThrottle(value, duration);
    };
    ThrottleSubscriber.prototype.emitAndThrottle = function (value, duration) {
        this.add(this.throttled = subscribeToResult_1.subscribeToResult(this, duration));
        this.destination.next(value);
    };
    ThrottleSubscriber.prototype._unsubscribe = function () {
        var throttled = this.throttled;
        if (throttled) {
            this.remove(throttled);
            this.throttled = null;
            throttled.unsubscribe();
        }
    };
    ThrottleSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this._unsubscribe();
    };
    ThrottleSubscriber.prototype.notifyComplete = function () {
        this._unsubscribe();
    };
    return ThrottleSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=throttle.js.map

/***/ }),

/***/ "u1DC":
/***/ (function(module, exports) {

exports.config = {"status":true,"model":{"plazza":"true","released":1394466978,"title-en":"Xiangqi","module":"chessbase","summary":"Chinese Chess","thumbnail":"xiangqi-thumb.png","rules":{"en":"xiangqi-rules.html"},"credits":{"en":"xiangqi-credits.html"},"gameOptions":{"preventRepeat":true,"uctTransposition":"state","uctIgnoreLoop":false,"levelOptions":{"pieceValueFactor":1,"pieceValueRatioFactor":1,"posValueFactor":0.1,"averageDistKingFactor":-0.01,"castleFactor":0.1,"minorPiecesMovedFactor":0.1,"checkFactor":0.2,"endingKingFreedomFactor":0.01,"endingDistKingFactor":0.05,"distKingCornerFactor":0.1}},"js":["base-model.js","grid-geo-model.js","xiangqi-model.js","xiangqi-db.min.js"],"description":{"en":"xiangqi-description.html"},"levels":[{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"easy","label":"Easy","maxNodes":1000},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"fast","label":"Fast [1sec]","maxDuration":1,"isDefault":true},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"medium","label":"Medium","maxNodes":10000,"maxDuration":10},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"strong","label":"Strong","maxNodes":20000,"maxDuration":15}]},"view":{"title-en":"Chessbase view","module":"chessbase","xdView":true,"css":["chessbase.css"],"preferredRatio":0.9,"useShowMoves":true,"useNotation":true,"useAutoComplete":true,"defaultOptions":{"sounds":true,"moves":true,"notation":false,"autocomplete":false},"skins":[{"name":"skin3d","title":"3D Classic","3d":true,"preload":["smoothedfilegeo|0|/res/ring-target.js","image|/res/images/cancel.png","smoothedfilegeo|0|/res/xiangqi/token.js","image|/res/xiangqi/clearwoodtexture.jpg","image|/res/xiangqi/decoration-cross.png","image|/res/xiangqi/whitebg.png","image|/res/xiangqi/xiangqi-pieces-sprites-playera.png","image|/res/xiangqi/xiangqi-pieces-sprites-playerb.png","image|/res/xiangqi/piecebump.jpg"],"world":{"lightIntensity":0.8,"skyLightIntensity":0.5,"lightCastShadow":true,"fog":false,"color":4686804,"lightPosition":{"x":10,"y":10,"z":10},"skyLightPosition":{"x":9,"y":9,"z":9},"lightShadowDarkness":0.75,"ambientLightColor":4473924},"camera":{"fov":45,"distMax":50,"radius":18,"elevationAngle":60,"elevationMin":0}},{"name":"skin3dwall","title":"3D Wall","3d":true,"preload":["smoothedfilegeo|0|/res/ring-target.js","image|/res/images/cancel.png","smoothedfilegeo|0|/res/xiangqi/token.js","image|/res/xiangqi/wood3.jpg","image|/res/xiangqi/clearwoodtexture.jpg","image|/res/xiangqi/decoration-cross.png","image|/res/xiangqi/whitebg.png","image|/res/xiangqi/xiangqi-pieces-sprites-playera.png","image|/res/xiangqi/xiangqi-pieces-sprites-playerb.png","image|/res/xiangqi/piecebump.jpg"],"world":{"lightIntensity":0.8,"skyLightIntensity":0.5,"lightCastShadow":true,"fog":false,"color":4686804,"lightPosition":{"x":10,"y":10,"z":10},"skyLightPosition":{"x":9,"y":9,"z":9},"lightShadowDarkness":0.75,"ambientLightColor":4473924},"camera":{"fov":45,"distMax":50,"radius":18,"elevationAngle":89,"elevationMin":0}},{"name":"skin3dwestern","title":"3D Western","3d":true,"preload":["smoothedfilegeo|0|/res/ring-target.js","image|/res/images/cancel.png","smoothedfilegeo|0|/res/xiangqi/token.js","image|/res/xiangqi/wood3.jpg","image|/res/xiangqi/clearwoodtexture.jpg","image|/res/xiangqi/decoration-cross.png","image|/res/xiangqi/whitebg.png","image|/res/xiangqi/xiangqi-pieces-sprites-western-player.png","image|/res/xiangqi/piecebump.jpg"],"world":{"lightIntensity":0.8,"skyLightIntensity":0.5,"lightCastShadow":true,"fog":false,"color":4686804,"lightPosition":{"x":10,"y":10,"z":10},"skyLightPosition":{"x":9,"y":9,"z":9},"lightShadowDarkness":0.75,"ambientLightColor":4473924},"camera":{"fov":45,"distMax":50,"radius":18,"elevationAngle":60,"elevationMin":0}},{"name":"skin3dwallwestern","title":"3D Wall Western","3d":true,"preload":["smoothedfilegeo|0|/res/ring-target.js","image|/res/images/cancel.png","smoothedfilegeo|0|/res/xiangqi/token.js","image|/res/xiangqi/wood3.jpg","image|/res/xiangqi/clearwoodtexture.jpg","image|/res/xiangqi/decoration-cross.png","image|/res/xiangqi/whitebg.png","image|/res/xiangqi/xiangqi-pieces-sprites-western-player.png","image|/res/xiangqi/piecebump.jpg"],"world":{"lightIntensity":0.8,"skyLightIntensity":0.5,"lightCastShadow":true,"fog":false,"color":4686804,"lightPosition":{"x":10,"y":10,"z":10},"skyLightPosition":{"x":9,"y":9,"z":9},"lightShadowDarkness":0.75,"ambientLightColor":4473924},"camera":{"fov":45,"distMax":50,"radius":18,"elevationAngle":89,"elevationMin":0}},{"name":"skin2d","title":"2D Classic","3d":false,"preload":["image|/res/images/cancel.png","image|/res/images/whitebg.png","image|/res/xiangqi/wood3.jpg","image|/res/xiangqi/clearwoodtexture.jpg","image|/res/xiangqi/decoration-cross.png","image|/res/xiangqi/whitebg.png","image|/res/xiangqi/xiangqi-pieces-sprites.png"]},{"name":"skin2dwestern","title":"2D Western","3d":false,"preload":["image|/res/images/cancel.png","image|/res/images/whitebg.png","image|/res/xiangqi/wood3.jpg","image|/res/xiangqi/clearwoodtexture.jpg","image|/res/xiangqi/decoration-cross.png","image|/res/xiangqi/whitebg.png","image|/res/xiangqi/xiangqi-pieces-sprites-western.png"]}],"animateSelfMoves":false,"switchable":true,"sounds":{"move1":"alq_move1","move2":"alq_move2","move3":"alq_move3","move4":"alq_move2","tac1":"alq_tac1","tac2":"alq_tac2","tac3":"alq_tac1","promo":"promo","usermove":null},"js":["base-view.js","grid-board-view.js","xiangqi-board-view.js","xiangqi-set-view.js","xiangqi-view.js"],"visuals":{"600x600":["res/visuals/xiangqi-600x600-3d.jpg","res/visuals/xiangqi-600x600-2d.jpg"]}}}

/***/ }),

/***/ "u1gx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Observable_1 = __webpack_require__("rCTf");
var Notification_1 = __webpack_require__("8GmM");
var ColdObservable_1 = __webpack_require__("Cr1h");
var HotObservable_1 = __webpack_require__("IBkQ");
var SubscriptionLog_1 = __webpack_require__("fO1r");
var VirtualTimeScheduler_1 = __webpack_require__("q0UB");
var defaultMaxFrame = 750;
var TestScheduler = (function (_super) {
    __extends(TestScheduler, _super);
    function TestScheduler(assertDeepEqual) {
        _super.call(this, VirtualTimeScheduler_1.VirtualAction, defaultMaxFrame);
        this.assertDeepEqual = assertDeepEqual;
        this.hotObservables = [];
        this.coldObservables = [];
        this.flushTests = [];
    }
    TestScheduler.prototype.createTime = function (marbles) {
        var indexOf = marbles.indexOf('|');
        if (indexOf === -1) {
            throw new Error('marble diagram for time should have a completion marker "|"');
        }
        return indexOf * TestScheduler.frameTimeFactor;
    };
    TestScheduler.prototype.createColdObservable = function (marbles, values, error) {
        if (marbles.indexOf('^') !== -1) {
            throw new Error('cold observable cannot have subscription offset "^"');
        }
        if (marbles.indexOf('!') !== -1) {
            throw new Error('cold observable cannot have unsubscription marker "!"');
        }
        var messages = TestScheduler.parseMarbles(marbles, values, error);
        var cold = new ColdObservable_1.ColdObservable(messages, this);
        this.coldObservables.push(cold);
        return cold;
    };
    TestScheduler.prototype.createHotObservable = function (marbles, values, error) {
        if (marbles.indexOf('!') !== -1) {
            throw new Error('hot observable cannot have unsubscription marker "!"');
        }
        var messages = TestScheduler.parseMarbles(marbles, values, error);
        var subject = new HotObservable_1.HotObservable(messages, this);
        this.hotObservables.push(subject);
        return subject;
    };
    TestScheduler.prototype.materializeInnerObservable = function (observable, outerFrame) {
        var _this = this;
        var messages = [];
        observable.subscribe(function (value) {
            messages.push({ frame: _this.frame - outerFrame, notification: Notification_1.Notification.createNext(value) });
        }, function (err) {
            messages.push({ frame: _this.frame - outerFrame, notification: Notification_1.Notification.createError(err) });
        }, function () {
            messages.push({ frame: _this.frame - outerFrame, notification: Notification_1.Notification.createComplete() });
        });
        return messages;
    };
    TestScheduler.prototype.expectObservable = function (observable, unsubscriptionMarbles) {
        var _this = this;
        if (unsubscriptionMarbles === void 0) { unsubscriptionMarbles = null; }
        var actual = [];
        var flushTest = { actual: actual, ready: false };
        var unsubscriptionFrame = TestScheduler
            .parseMarblesAsSubscriptions(unsubscriptionMarbles).unsubscribedFrame;
        var subscription;
        this.schedule(function () {
            subscription = observable.subscribe(function (x) {
                var value = x;
                // Support Observable-of-Observables
                if (x instanceof Observable_1.Observable) {
                    value = _this.materializeInnerObservable(value, _this.frame);
                }
                actual.push({ frame: _this.frame, notification: Notification_1.Notification.createNext(value) });
            }, function (err) {
                actual.push({ frame: _this.frame, notification: Notification_1.Notification.createError(err) });
            }, function () {
                actual.push({ frame: _this.frame, notification: Notification_1.Notification.createComplete() });
            });
        }, 0);
        if (unsubscriptionFrame !== Number.POSITIVE_INFINITY) {
            this.schedule(function () { return subscription.unsubscribe(); }, unsubscriptionFrame);
        }
        this.flushTests.push(flushTest);
        return {
            toBe: function (marbles, values, errorValue) {
                flushTest.ready = true;
                flushTest.expected = TestScheduler.parseMarbles(marbles, values, errorValue, true);
            }
        };
    };
    TestScheduler.prototype.expectSubscriptions = function (actualSubscriptionLogs) {
        var flushTest = { actual: actualSubscriptionLogs, ready: false };
        this.flushTests.push(flushTest);
        return {
            toBe: function (marbles) {
                var marblesArray = (typeof marbles === 'string') ? [marbles] : marbles;
                flushTest.ready = true;
                flushTest.expected = marblesArray.map(function (marbles) {
                    return TestScheduler.parseMarblesAsSubscriptions(marbles);
                });
            }
        };
    };
    TestScheduler.prototype.flush = function () {
        var hotObservables = this.hotObservables;
        while (hotObservables.length > 0) {
            hotObservables.shift().setup();
        }
        _super.prototype.flush.call(this);
        var readyFlushTests = this.flushTests.filter(function (test) { return test.ready; });
        while (readyFlushTests.length > 0) {
            var test = readyFlushTests.shift();
            this.assertDeepEqual(test.actual, test.expected);
        }
    };
    TestScheduler.parseMarblesAsSubscriptions = function (marbles) {
        if (typeof marbles !== 'string') {
            return new SubscriptionLog_1.SubscriptionLog(Number.POSITIVE_INFINITY);
        }
        var len = marbles.length;
        var groupStart = -1;
        var subscriptionFrame = Number.POSITIVE_INFINITY;
        var unsubscriptionFrame = Number.POSITIVE_INFINITY;
        for (var i = 0; i < len; i++) {
            var frame = i * this.frameTimeFactor;
            var c = marbles[i];
            switch (c) {
                case '-':
                case ' ':
                    break;
                case '(':
                    groupStart = frame;
                    break;
                case ')':
                    groupStart = -1;
                    break;
                case '^':
                    if (subscriptionFrame !== Number.POSITIVE_INFINITY) {
                        throw new Error('found a second subscription point \'^\' in a ' +
                            'subscription marble diagram. There can only be one.');
                    }
                    subscriptionFrame = groupStart > -1 ? groupStart : frame;
                    break;
                case '!':
                    if (unsubscriptionFrame !== Number.POSITIVE_INFINITY) {
                        throw new Error('found a second subscription point \'^\' in a ' +
                            'subscription marble diagram. There can only be one.');
                    }
                    unsubscriptionFrame = groupStart > -1 ? groupStart : frame;
                    break;
                default:
                    throw new Error('there can only be \'^\' and \'!\' markers in a ' +
                        'subscription marble diagram. Found instead \'' + c + '\'.');
            }
        }
        if (unsubscriptionFrame < 0) {
            return new SubscriptionLog_1.SubscriptionLog(subscriptionFrame);
        }
        else {
            return new SubscriptionLog_1.SubscriptionLog(subscriptionFrame, unsubscriptionFrame);
        }
    };
    TestScheduler.parseMarbles = function (marbles, values, errorValue, materializeInnerObservables) {
        if (materializeInnerObservables === void 0) { materializeInnerObservables = false; }
        if (marbles.indexOf('!') !== -1) {
            throw new Error('conventional marble diagrams cannot have the ' +
                'unsubscription marker "!"');
        }
        var len = marbles.length;
        var testMessages = [];
        var subIndex = marbles.indexOf('^');
        var frameOffset = subIndex === -1 ? 0 : (subIndex * -this.frameTimeFactor);
        var getValue = typeof values !== 'object' ?
            function (x) { return x; } :
            function (x) {
                // Support Observable-of-Observables
                if (materializeInnerObservables && values[x] instanceof ColdObservable_1.ColdObservable) {
                    return values[x].messages;
                }
                return values[x];
            };
        var groupStart = -1;
        for (var i = 0; i < len; i++) {
            var frame = i * this.frameTimeFactor + frameOffset;
            var notification = void 0;
            var c = marbles[i];
            switch (c) {
                case '-':
                case ' ':
                    break;
                case '(':
                    groupStart = frame;
                    break;
                case ')':
                    groupStart = -1;
                    break;
                case '|':
                    notification = Notification_1.Notification.createComplete();
                    break;
                case '^':
                    break;
                case '#':
                    notification = Notification_1.Notification.createError(errorValue || 'error');
                    break;
                default:
                    notification = Notification_1.Notification.createNext(getValue(c));
                    break;
            }
            if (notification) {
                testMessages.push({ frame: groupStart > -1 ? groupStart : frame, notification: notification });
            }
        }
        return testMessages;
    };
    return TestScheduler;
}(VirtualTimeScheduler_1.VirtualTimeScheduler));
exports.TestScheduler = TestScheduler;
//# sourceMappingURL=TestScheduler.js.map

/***/ }),

/***/ "u2wr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var OuterSubscriber_1 = __webpack_require__("wAkD");
var subscribeToResult_1 = __webpack_require__("CURp");
/* tslint:enable:max-line-length */
/**
 * Combines the source Observable with other Observables to create an Observable
 * whose values are calculated from the latest values of each, only when the
 * source emits.
 *
 * <span class="informal">Whenever the source Observable emits a value, it
 * computes a formula using that value plus the latest values from other input
 * Observables, then emits the output of that formula.</span>
 *
 * <img src="./img/withLatestFrom.png" width="100%">
 *
 * `withLatestFrom` combines each value from the source Observable (the
 * instance) with the latest values from the other input Observables only when
 * the source emits a value, optionally using a `project` function to determine
 * the value to be emitted on the output Observable. All input Observables must
 * emit at least one value before the output Observable will emit a value.
 *
 * @example <caption>On every click event, emit an array with the latest timer event plus the click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var timer = Rx.Observable.interval(1000);
 * var result = clicks.withLatestFrom(timer);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link combineLatest}
 *
 * @param {ObservableInput} other An input Observable to combine with the source
 * Observable. More than one input Observables may be given as argument.
 * @param {Function} [project] Projection function for combining values
 * together. Receives all values in order of the Observables passed, where the
 * first parameter is a value from the source Observable. (e.g.
 * `a.withLatestFrom(b, c, (a1, b1, c1) => a1 + b1 + c1)`). If this is not
 * passed, arrays will be emitted on the output Observable.
 * @return {Observable} An Observable of projected values from the most recent
 * values from each input Observable, or an array of the most recent values from
 * each input Observable.
 * @method withLatestFrom
 * @owner Observable
 */
function withLatestFrom() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i - 0] = arguments[_i];
    }
    var project;
    if (typeof args[args.length - 1] === 'function') {
        project = args.pop();
    }
    var observables = args;
    return this.lift(new WithLatestFromOperator(observables, project));
}
exports.withLatestFrom = withLatestFrom;
var WithLatestFromOperator = (function () {
    function WithLatestFromOperator(observables, project) {
        this.observables = observables;
        this.project = project;
    }
    WithLatestFromOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new WithLatestFromSubscriber(subscriber, this.observables, this.project));
    };
    return WithLatestFromOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var WithLatestFromSubscriber = (function (_super) {
    __extends(WithLatestFromSubscriber, _super);
    function WithLatestFromSubscriber(destination, observables, project) {
        _super.call(this, destination);
        this.observables = observables;
        this.project = project;
        this.toRespond = [];
        var len = observables.length;
        this.values = new Array(len);
        for (var i = 0; i < len; i++) {
            this.toRespond.push(i);
        }
        for (var i = 0; i < len; i++) {
            var observable = observables[i];
            this.add(subscribeToResult_1.subscribeToResult(this, observable, observable, i));
        }
    }
    WithLatestFromSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.values[outerIndex] = innerValue;
        var toRespond = this.toRespond;
        if (toRespond.length > 0) {
            var found = toRespond.indexOf(outerIndex);
            if (found !== -1) {
                toRespond.splice(found, 1);
            }
        }
    };
    WithLatestFromSubscriber.prototype.notifyComplete = function () {
        // noop
    };
    WithLatestFromSubscriber.prototype._next = function (value) {
        if (this.toRespond.length === 0) {
            var args = [value].concat(this.values);
            if (this.project) {
                this._tryProject(args);
            }
            else {
                this.destination.next(args);
            }
        }
    };
    WithLatestFromSubscriber.prototype._tryProject = function (args) {
        var result;
        try {
            result = this.project.apply(this, args);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return WithLatestFromSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=withLatestFrom.js.map

/***/ }),

/***/ "uCY4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var switchMap_1 = __webpack_require__("VEfc");
Observable_1.Observable.prototype.switchMap = switchMap_1.switchMap;
//# sourceMappingURL=switchMap.js.map

/***/ }),

/***/ "uPc4":
/***/ (function(module, exports) {

exports.config = {"status":true,"model":{"plazza":"true","title-en":"6 Men´s Morris","module":"mills","maxLevel":7,"summary":"An old board game","thumbnail":"mensmorris6-thumb3d.png","rules":"rules.html","description":"description.html","credits":"credits.html","js":["mills-model.js","6-men-morris-model.js"],"gameOptions":{"preventRepeat":true,"width":5,"height":5,"mencount":6,"poundInMill":false},"levels":[{"label":"Easy","maxDepth":2,"potential":100,"placingRace":1,"isDefault":true},{"label":"Medium","maxDepth":4,"potential":300,"placingRace":1},{"label":"Hard","maxDepth":8,"potential":1000,"placingRace":2}]},"view":{"js":["mills-xd-view.js","6-men-morris-view.js"],"visuals":{"600x600":["res/visuals/sixmen-600x600-3d.jpg","res/visuals/sixmen-600x600-2d.jpg"]},"xdView":true,"css":["mills.css","6-men-morris.css"],"title-en":"6 Men´s Morris View","module":"mills","preferredRatio":1.4,"switchable":true,"animateSelfMoves":false,"useNotation":true,"useShowMoves":true,"defaultOptions":{"sounds":true,"notation":false,"moves":true},"sounds":{"move1":"move1","move2":"move2","move3":"move3","move4":"move4","tac1":"tac1","tac2":"tac2","tac3":"tac3","capture":"promo","usermove":null},"skins":[{"name":"classic3d","title":"3D Classic","3d":true,"camera":{"radius":14,"elevationAngle":45,"distMax":39.5,"distMin":10.1,"elevationMin":-89.9,"elevationMax":89.9,"limitCamMoves":true},"world":{"lightIntensity":0.6,"skyLightIntensity":0.3,"lightPosition":{"x":0,"y":18,"z":0},"color":0,"fog":false},"preload":["image|/res/xd-view/meshes/woodcell1x512.jpg","image|/res/xd-view/meshes/piecetop-bump.jpg","image|/res/xd-view/meshes/piecediff.jpg","smoothedfilegeo|0|/res/xd-view/meshes/piece-v2.js","smoothedfilegeo|0|/res/xd-view/meshes/boardoriented.js","smoothedfilegeo|0|/res/xd-view/meshes/ring-target.js"]},{"name":"stone","title":"Stone"},{"name":"suede","title":"Suede"},{"name":"wood","title":"Wood"}]}}

/***/ }),

/***/ "uf2u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("3j3K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ngrx_store__ = __webpack_require__("WWmu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__devtools__ = __webpack_require__("cnKp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__("2iB7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__extension__ = __webpack_require__("MjDH");
/* unused harmony export _createReduxDevtoolsExtension */
/* unused harmony export _createState */
/* unused harmony export _createReducer */
/* unused harmony export _createStateIfExtension */
/* unused harmony export _createReducerIfExtension */
/* unused harmony export noMonitor */
/* unused harmony export _createOptions */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StoreDevtoolsModule; });





function _createReduxDevtoolsExtension() {
    var legacyExtensionKey = 'devToolsExtension';
    var extensionKey = '__REDUX_DEVTOOLS_EXTENSION__';
    if (typeof window === 'object' && typeof window[legacyExtensionKey] !== 'undefined') {
        return window[legacyExtensionKey];
    }
    else if (typeof window === 'object' && typeof window[extensionKey] !== 'undefined') {
        return window[extensionKey];
    }
    else {
        return null;
    }
}
function _createState(devtools) {
    return devtools.state;
}
function _createReducer(dispatcher, reducer) {
    return new __WEBPACK_IMPORTED_MODULE_1__ngrx_store__["e" /* Reducer */](dispatcher, reducer);
}
function _createStateIfExtension(extension, injector, initialState) {
    if (!!extension) {
        var devtools = injector.get(__WEBPACK_IMPORTED_MODULE_2__devtools__["a" /* StoreDevtools */]);
        return _createState(devtools);
    }
    else {
        var dispatcher = injector.get(__WEBPACK_IMPORTED_MODULE_1__ngrx_store__["d" /* Dispatcher */]);
        var reducer = injector.get(__WEBPACK_IMPORTED_MODULE_1__ngrx_store__["e" /* Reducer */]);
        return new __WEBPACK_IMPORTED_MODULE_1__ngrx_store__["g" /* State */](initialState, dispatcher, reducer);
    }
}
function _createReducerIfExtension(extension, injector, reducer) {
    if (!!extension) {
        var devtoolsDispatcher = injector.get(__WEBPACK_IMPORTED_MODULE_2__devtools__["b" /* DevtoolsDispatcher */]);
        return _createReducer(devtoolsDispatcher, reducer);
    }
    else {
        var dispatcher = injector.get(__WEBPACK_IMPORTED_MODULE_1__ngrx_store__["d" /* Dispatcher */]);
        return new __WEBPACK_IMPORTED_MODULE_1__ngrx_store__["e" /* Reducer */](dispatcher, reducer);
    }
}
function noMonitor() {
    return null;
}
function _createOptions(_options) {
    var DEFAULT_OPTIONS = { monitor: noMonitor };
    var options = typeof _options === 'function' ? _options() : _options;
    options = Object.assign({}, DEFAULT_OPTIONS, options);
    if (options.maxAge && options.maxAge < 2) {
        throw new Error("Devtools 'maxAge' cannot be less than 2, got " + options.maxAge);
    }
    return options;
}
var StoreDevtoolsModule = (function () {
    function StoreDevtoolsModule() {
    }
    StoreDevtoolsModule.instrumentStore = function (_options) {
        if (_options === void 0) { _options = {}; }
        return {
            ngModule: StoreDevtoolsModule,
            providers: [
                {
                    provide: __WEBPACK_IMPORTED_MODULE_1__ngrx_store__["g" /* State */],
                    deps: [__WEBPACK_IMPORTED_MODULE_2__devtools__["a" /* StoreDevtools */]],
                    useFactory: _createState
                },
                {
                    provide: __WEBPACK_IMPORTED_MODULE_3__config__["b" /* INITIAL_OPTIONS */],
                    useValue: _options
                },
                {
                    provide: __WEBPACK_IMPORTED_MODULE_1__ngrx_store__["e" /* Reducer */],
                    deps: [__WEBPACK_IMPORTED_MODULE_2__devtools__["b" /* DevtoolsDispatcher */], __WEBPACK_IMPORTED_MODULE_1__ngrx_store__["h" /* INITIAL_REDUCER */]],
                    useFactory: _createReducer
                },
                {
                    provide: __WEBPACK_IMPORTED_MODULE_3__config__["a" /* STORE_DEVTOOLS_CONFIG */],
                    deps: [__WEBPACK_IMPORTED_MODULE_3__config__["b" /* INITIAL_OPTIONS */]],
                    useFactory: _createOptions
                }
            ]
        };
    };
    StoreDevtoolsModule.instrumentOnlyWithExtension = function (_options) {
        if (_options === void 0) { _options = {}; }
        return {
            ngModule: StoreDevtoolsModule,
            providers: [
                {
                    provide: __WEBPACK_IMPORTED_MODULE_1__ngrx_store__["g" /* State */],
                    deps: [__WEBPACK_IMPORTED_MODULE_4__extension__["b" /* REDUX_DEVTOOLS_EXTENSION */], __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injector"], __WEBPACK_IMPORTED_MODULE_1__ngrx_store__["f" /* INITIAL_STATE */]],
                    useFactory: _createStateIfExtension
                },
                {
                    provide: __WEBPACK_IMPORTED_MODULE_1__ngrx_store__["e" /* Reducer */],
                    deps: [__WEBPACK_IMPORTED_MODULE_4__extension__["b" /* REDUX_DEVTOOLS_EXTENSION */], __WEBPACK_IMPORTED_MODULE_0__angular_core__["Injector"], __WEBPACK_IMPORTED_MODULE_1__ngrx_store__["h" /* INITIAL_REDUCER */]],
                    useFactory: _createReducerIfExtension
                },
                {
                    provide: __WEBPACK_IMPORTED_MODULE_3__config__["b" /* INITIAL_OPTIONS */],
                    useValue: _options
                },
                {
                    provide: __WEBPACK_IMPORTED_MODULE_3__config__["a" /* STORE_DEVTOOLS_CONFIG */],
                    deps: [__WEBPACK_IMPORTED_MODULE_3__config__["b" /* INITIAL_OPTIONS */]],
                    useFactory: _createOptions
                }
            ]
        };
    };
    return StoreDevtoolsModule;
}());

StoreDevtoolsModule.decorators = [
    { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["NgModule"], args: [{
                imports: [
                    __WEBPACK_IMPORTED_MODULE_1__ngrx_store__["b" /* StoreModule */]
                ],
                providers: [
                    __WEBPACK_IMPORTED_MODULE_4__extension__["a" /* DevtoolsExtension */],
                    __WEBPACK_IMPORTED_MODULE_2__devtools__["b" /* DevtoolsDispatcher */],
                    __WEBPACK_IMPORTED_MODULE_2__devtools__["a" /* StoreDevtools */],
                    {
                        provide: __WEBPACK_IMPORTED_MODULE_4__extension__["b" /* REDUX_DEVTOOLS_EXTENSION */],
                        useFactory: _createReduxDevtoolsExtension
                    }
                ]
            },] },
];
/** @nocollapse */
StoreDevtoolsModule.ctorParameters = function () { return []; };
//# sourceMappingURL=instrument.js.map

/***/ }),

/***/ "ujcs":
/***/ (function(module, exports) {

exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = nBytes * 8 - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = nBytes * 8 - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),

/***/ "upQW":
/***/ (function(module, exports) {

exports.model=Model={Game:{},Board:{},Move:{}},function(){var t,s,o="undefined"!=typeof Int8Array;o?(t=function(t){return new Int8Array(t)},s=function(t){var s=new Int8Array(t.length);return s.set(t),s}):(t=function(t){for(var s=[],o=0;o<t;o++)s.push(0);return s},s=function(t){for(var s=[],o=t.length,i=0;i<o;i++)s.push(t[i]);return s}),Model.Game.isAlive=function(t,s){return this.POS(s,t)in this.g.confine},Model.Game.C=function(t){return t%this.mOptions.width},Model.Game.R=function(t){return Math.floor(t/this.mOptions.width)},Model.Game.RC=function(t){return{r:Math.floor(t/this.mOptions.width),c:t%this.mOptions.width}},Model.Game.POS=function(t,s){return s*this.mOptions.width+t},Model.Game.STR2POS=function(t){var s=/^(\d+):(\d+)$/.exec(t);if(s){var o=parseInt(s[1]),i=parseInt(s[2]);return this.POS(i,o)}return null},Model.Game.InitGame=function(){var s=this.NBCOLS=this.mOptions.width,o=this.NBROWS=this.mOptions.height;this.g.confine={},this.g.totalCount=o*s;for(var i=0;i<o;i++)for(var r=0;r<s;r++)this.g.confine[this.POS(r,i)]=1;if(this.mOptions.deadCells)for(var e in this.mOptions.deadCells){var a=this.STR2POS(e);null!=a&&(this.g.totalCount--,delete this.g.confine[a])}this.g.dirDeltaRC=[[1,-1],[1,0],[1,1],[0,1],[-1,1],[-1,0],[-1,-1],[0,-1]],this.g.Graph={};for(var i=0;i<o;i++)for(var r=0;r<s;r++){var a=this.POS(r,i);if(a in this.g.confine){for(var h=t(this.g.dirDeltaRC.length),n=0;n<this.g.dirDeltaRC.length;n++){var l=this.g.dirDeltaRC[n],v=i+l[0],d=r+l[1],u=v*s+d;v>=0&&d>=0&&v<o&&d<s&&u in this.g.confine?h[n]=u:h[n]=-1}this.g.Graph[a]=h}}this.g.corners={};for(var a in this.g.confine){for(var f=0,l=0;l<8;l++){var u=this.g.Graph[a][l];u<0&&(f|=1<<l)}15!=(15&f)&&30!=(30&f)&&60!=(60&f)&&120!=(120&f)&&240!=(240&f)&&225!=(225&f)&&195!=(195&f)&&135!=(135&f)||(this.g.corners[a]=1)}this.g.borders={};for(var a in this.g.confine)if(!(a in this.g.corners)){for(var f=0,l=0;l<8;l++){var u=this.g.Graph[a][l];u<0&&(f|=1<<l)}7!=(7&f)&&14!=(14&f)&&28!=(28&f)&&56!=(56&f)&&112!=(112&f)&&224!=(224&f)&&193!=(193&f)&&131!=(131&f)||(this.g.borders[a]=1)}this.zobrist=new JocGame.Zobrist({board:{type:"array",size:s*o,values:["1","-1"]}})},Model.Move.Init=function(t){this.row=t.row,this.col=t.col,this.pass=t.pass},Model.Move.CopyFrom=function(t){this.row=t.row,this.col=t.col,this.pass=t.pass},Model.Move.ToString=function(){return this.pass?"-":String.fromCharCode("a".charCodeAt(0)+this.col)+(this.row+1)},Model.Move.Equals=function(t){return!(!t.pass||!this.pass)||this.row==t.row&&this.col==t.col},Model.Board.Init=function(t){this.zSign=0},Model.Board.InitialPosition=function(s){this.board=t(s.mOptions.width*s.mOptions.height),this.counts=[0,0],this.freeClose={},this.passes=0,this.lastMove=null;var o=this;[1,-1].forEach(function(t){var i=(1-t)/2;s.mOptions.initial[t].forEach(function(r){o.counts[i]++;var e=s.STR2POS(r);o.board[e]=t,delete o.freeClose[e];for(var a=0;a<8;a++){var h=s.g.Graph[e][a];h<0||(o.board[h]||(o.freeClose[h]=1))}o.zSign=s.zobrist.update(o.zSign,"board",t,e)})}),this.FindMoves(s),this.stable={};for(var i in s.g.corners)this.stable[i]=3;this.aboutStable={},this.aboutBorder={},this.rvUpdateStable(s,s.g.corners),this.rvUpdateAboutBorder(s)},Model.Board.CopyFrom=function(t){this.mWho=t.mWho,this.zSign=t.zSign,this.board=s(t.board),this.counts=[t.counts[0],t.counts[1]],this.freeClose={};for(var o in t.freeClose)this.freeClose[o]=1;this.passes=t.passes,this.lastMove=null,t.lastMove?this.lastMove={row:t.lastMove.row,col:t.lastMove.col}:this.lastMove=null,this.movePoss={1:s(t.movePoss[1]),"-1":s(t.movePoss[-1])},this.stable=t.stable,this.aboutStable=t.aboutStable,this.aboutBorder=t.aboutBorder},Model.Board.GenerateMoves=function(t){this.mMoves=[];for(var s=0;s<this.movePoss[this.mWho].length;s++){var o=this.movePoss[this.mWho][s],i=t.RC(o);this.PushMove(t,{row:i.r,col:i.c})}0==this.mMoves.length&&this.PushMove(t,{pass:!0,row:-1,col:-1})},Model.Board.FindMoves=function(t){this.movePoss={1:[],"-1":[]};var s=t.g.Graph;for(var o in this.freeClose){for(var i=s[o],r=0,e=0;e<8;e++){var a=i[e];if(a>=0){var h=-this.board[a];if(h){var n=1==h?1:2;if(!(r&n)){for(!0,a=s[a][e];this.board[a]==-h;)a=s[a][e];if(a>=0&&this.board[a]==h&&(r|=n),3==r)break}}}}1&r&&this.movePoss[1].push(o),2&r&&this.movePoss[-1].push(o)}},Model.Board.ApplyMove=function(t,s){if(this.lastMove=null,s.pass)return void this.passes++;this.lastMove={row:s.row,col:s.col},this.passes=0;var o=(1-this.mWho)/2,i=1<<o;this.counts[o]++;var r=t.POS(s.col,s.row),e=t.g.Graph,a=e[r];this.board[r]=this.mWho,this.zSign=t.zobrist.update(this.zSign,"board",this.mWho,r),delete this.freeClose[r];var h=!1,n={};(this.stable[r]||0)&i&&(h=!0,n[r]=1);for(var l=0;l<8;l++){var v=a[l];v>=0&&0==this.board[v]&&(this.freeClose[v]=1);for(var d=[];v>=0&&this.board[v]==-this.mWho;)d.push(v),v=e[v][l];if(v>=0&&d.length>0&&this.board[v]==this.mWho)for(var u=d.length-1;u>=0;u--){var f=d[u];this.zSign=t.zobrist.update(this.zSign,"board",-this.mWho,f),this.zSign=t.zobrist.update(this.zSign,"board",this.mWho,f),this.board[f]=this.mWho,this.counts[o]++,this.counts[1-o]--,(this.stable[f]||0)&i&&(h=!0,n[f]=1)}}h&&this.rvUpdateStable(t,n),r in t.g.borders&&this.rvUpdateAboutBorder(t),this.FindMoves(t)},Model.Board.rvUpdateStable=function(t,s){var o=this.stable;this.stable={};for(var i in o)this.stable[i]=o[i];for(var r=!0,e=1==this.mWho?1:2,a=t.g.Graph;r;){r=!1;var h={};for(var i in s)for(var n=a[i],l=0;l<8;l++){var v=n[l];v>=0&&!((this.stable[v]||0)&e)&&(h[v]=1)}var s={};for(var i in h){for(var n=a[i],d=0,l=0;l<8;l++){var v=n[l];(v<0||this.board[v]==this.mWho&&(this.stable[v]||0)&e)&&(d|=1<<l)}15!=(15&d)&&30!=(30&d)&&60!=(60&d)&&120!=(120&d)&&240!=(240&d)&&225!=(225&d)&&195!=(195&d)&&135!=(135&d)||(this.stable[i]=(this.stable[i]||0)|e,r=!0,s[i]=1)}}this.aboutStable={};for(var i in this.stable)if(!this.board[i])for(var n=a[i],l=0;l<8;l++){var v=n[l];v>=0&&!(v in this.stable)&&(this.aboutStable[v]=(this.aboutStable[v]||0)|this.stable[i])}},Model.Board.rvUpdateAboutBorder=function(t){this.aboutBorder={};var s=t.g.Graph,o=t.g.borders;for(var i in o)if(!this.board[i])for(var r=s[i],e=0;e<8;e++){var a=r[e];!(a>=0)||a in this.stable||a in this.aboutStable||a in o||(this.aboutBorder[a]=1)}},Model.Board.Evaluate=function(t){this.mEvaluation=0;t.mOptions.width,t.mOptions.height;if(2==this.passes||this.counts[0]+this.counts[1]==t.g.totalCount||0==this.counts[0]||0==this.counts[1])return this.mFinished=!0,void(this.counts[0]>this.counts[1]?this.mWinner=JocGame.PLAYER_A:this.counts[0]<this.counts[1]?this.mWinner=JocGame.PLAYER_B:this.mWinner=JocGame.DRAW);var s=t.mOptions.levelOptions,o={},i={1:0,"-1":0},r={1:0,"-1":0},e={1:0,"-1":0},a={1:0,"-1":0},h=t.g.confine,n=t.g.borders;for(var l in h){var v=this.board[l];if(v){var d=1==v?1:2,u=1==v?2:1;(this.stable[l]||0)&d?i[v]++:(this.aboutStable[l]||0)&u?l in n?e[v]++:r[v]++:l in n&&a[v]++}}o.stable=i[1]-i[-1],o.aboutStable=r[1]-r[-1],o.aboutStableBorder=e[1]-e[-1],o.border=a[1]-a[-1],o.count=this.counts[0]-this.counts[1];var f=this.movePoss[1].length+this.movePoss[-1].length;o.mobility=f?(this.movePoss[1].length-this.movePoss[-1].length)/f:0;for(var b in o){var c=o[b],m=s[b+"Factor"]||0,g=c*m;this.mEvaluation+=g}},Model.Board.GetSignature=function(){return this.zSign}}();

/***/ }),

/***/ "vQ+N":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var using_1 = __webpack_require__("mQmC");
Observable_1.Observable.using = using_1.using;
//# sourceMappingURL=using.js.map

/***/ }),

/***/ "voL5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var timestamp_1 = __webpack_require__("5pRa");
Observable_1.Observable.prototype.timestamp = timestamp_1.timestamp;
//# sourceMappingURL=timestamp.js.map

/***/ }),

/***/ "vrkH":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__("mmVS");
/**
 * Returns an Observable that mirrors the source Observable with the exception of an `error`. If the source Observable
 * calls `error`, this method will resubscribe to the source Observable for a maximum of `count` resubscriptions (given
 * as a number parameter) rather than propagating the `error` call.
 *
 * <img src="./img/retry.png" width="100%">
 *
 * Any and all items emitted by the source Observable will be emitted by the resulting Observable, even those emitted
 * during failed subscriptions. For example, if an Observable fails at first but emits [1, 2] then succeeds the second
 * time and emits: [1, 2, 3, 4, 5] then the complete stream of emissions and notifications
 * would be: [1, 2, 1, 2, 3, 4, 5, `complete`].
 * @param {number} count - Number of retry attempts before failing.
 * @return {Observable} The source Observable modified with the retry logic.
 * @method retry
 * @owner Observable
 */
function retry(count) {
    if (count === void 0) { count = -1; }
    return this.lift(new RetryOperator(count, this));
}
exports.retry = retry;
var RetryOperator = (function () {
    function RetryOperator(count, source) {
        this.count = count;
        this.source = source;
    }
    RetryOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new RetrySubscriber(subscriber, this.count, this.source));
    };
    return RetryOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var RetrySubscriber = (function (_super) {
    __extends(RetrySubscriber, _super);
    function RetrySubscriber(destination, count, source) {
        _super.call(this, destination);
        this.count = count;
        this.source = source;
    }
    RetrySubscriber.prototype.error = function (err) {
        if (!this.isStopped) {
            var _a = this, source = _a.source, count = _a.count;
            if (count === 0) {
                return _super.prototype.error.call(this, err);
            }
            else if (count > -1) {
                this.count = count - 1;
            }
            source.subscribe(this._unsubscribeAndRecycle());
        }
    };
    return RetrySubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=retry.js.map

/***/ }),

/***/ "vvwv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var EmptyObservable_1 = __webpack_require__("jBEF");
exports.empty = EmptyObservable_1.EmptyObservable.create;
//# sourceMappingURL=empty.js.map

/***/ }),

/***/ "w9sU":
/***/ (function(module, exports) {

exports.model=Model={Game:{},Board:{},Move:{}},function(){function t(t){if(o){var e=t%s;return(t-e)/s*s+s-e}var r=s*i-t-1,n=r%s;return r-n+s-n}var s,i,o=!1;Model.Game.checkersPosToString=t,Model.Game.InitGameInfo=function(){},Model.Game.BuildGraphCoord=function(){var t=(this.mOptions.width,this.mOptions.height,[]),s=[];this.g.Graph=t,this.g.Coord=s},Model.Game.InitGame=function(){var t=this.mOptions.width,e=this.mOptions.height;if(s=t,i=e,o=this.mOptions.invertNotation||!1,this.g.compulsoryCatch=!0,this.g.canStepBack=!0,this.g.mustMoveForward=!1,this.g.mustMoveForwardStrict=!1,this.g.lastRowFreeze=!1,this.g.lastRowCrown=!1,this.g.captureLongestLine=!1,this.g.noMove="lose",this.g.kingCaptureShort=!1,this.g.kingValue=5,this.g.lastRowFactor=0,this.g.canCaptureBackward=!0,this.g.captureInstantRemove=!1,this.g.longRangeKing=!0,this.g.drawKvsK=!0,this.g.drawKvs2K=!0,this.g.whiteStarts=!0,this.g.king180deg=!1,this.mOptions.variant)for(var r in this.mOptions.variant)this.mOptions.variant.hasOwnProperty(r)&&(this.g[r]=this.mOptions.variant[r]);this.BuildGraphCoord(),this.zobrist=new JocGame.Zobrist({board:{type:"array",size:this.g.Graph.length,values:["1/0","1/1","-1/0","-1/1"]}})},Model.Game.DestroyGame=function(){},Model.Game.CheckersDirections=4,Model.Game.Checkers2WaysDirections=[0,1,1,0],Model.Game.CheckersEachDirection=function(t,s){for(var i=0;i<this.CheckersDirections;i++){var o=this.g.Graph[t][i];if(null!=o&&0==s(o,i))return}},Model.Move.Init=function(t){this.pos=[];for(var s=t.pos?Object.keys(t.pos).sort():[],i=0;i<s.length;i++)this.pos.push(t.pos[i]);this.capt=[];for(var o=t.capt?Object.keys(t.capt).sort():[],i=0;i<o.length;i++)this.capt.push(t.capt[i])},Model.Move.ToString=function(s){s=s||"natural";var i=this;switch(s){case"natural":return function(){for(var s=[t(i.pos[0]),t(i.pos[i.pos.length-1])],o="-",e=1;e<i.capt.length;e++)null!=i.capt[e]&&(o="x",i.capt.length>3&&s.push(t(i.capt[e])));return s.join(o)}();case"hub":return function(){var s="-",o=[t(i.pos[0]),t(i.pos[i.pos.length-1])];if(i.capt[1]){s="x";var e=i.capt.slice(1).map(function(s){return t(s)});e.sort(),o=o.concat(e)}return o.join(s)}();case"dxp":return function(){var s=[t(i.pos[0]),t(i.pos[i.pos.length-1])];if(i.capt[1]){s.push(i.capt.length-1);for(var o=[],e=1;e<i.capt.length;e++)o.push(t(i.capt[e]));o.sort(),s=s.concat(o)}else s.push(0);return s.map(function(t){return t<10?"0"+t:t}).join("")}();default:return"??"}},Model.Board.Init=function(t){this.zSign=0},Model.Board.InitialPosition=function(t){var s=t.mOptions.width,i=t.mOptions.height,o=t.mOptions.initial;this.board=[];for(var e=0;e<i;e++)for(var r=0;r<s;r++)this.board[e*s+r]=-1;this.pieces=[];var n=0;if(t.mInitial){this.pCount=[0,0],this.spCount=[0,0],this.kpCount=[0,0];for(var a=0;a<t.mInitial.pieces.length;a++){var h=t.mInitial.pieces[a];this.board[h.p]=a,this.pieces.push({s:h.s,p:h.p,l:-1,t:h.t,plp:h.p}),this.zSign=t.zobrist.update(this.zSign,"board",h.s+"/"+h.t,h.p);var p=-(h.s-1)/2;this.pCount[p]++,0==h.t?this.spCount[p]++:this.kpCount[p]++}}else{for(var a in o.a)if(o.a.hasOwnProperty(a)){var u=o.a[a],c=u[0]*s+u[1],h={s:JocGame.PLAYER_A,p:c,l:-1,t:0,plp:c};this.pieces.push(h),this.board[c]=n++,this.zSign=t.zobrist.update(this.zSign,"board","1/0",c)}for(var a in o.b)if(o.b.hasOwnProperty(a)){var u=o.b[a],c=u[0]*s+u[1],h={s:JocGame.PLAYER_B,p:c,l:-1,t:0,plp:c};this.pieces.push(h),this.board[c]=n++,this.zSign=t.zobrist.update(this.zSign,"board","-1/0",c)}this.pCount=[o.a.length,o.b.length],this.spCount=[o.a.length,o.b.length],this.kpCount=[o.a.length,o.b.length]}},Model.Board.GenerateMoves=function(t){try{this._GenerateMoves(t)}catch(t){}},Model.Board._GenerateMoves=function(t){function s(t){for(var s=0;s<e.pieces.length;s++){var i=e.pieces[s];i&&i.s==e.mWho&&t(s,i.p)}}function i(s,o,r,n,a){for(;;){var h=[],p=[],u=[];if(t.CheckersEachDirection(s,function(i,c){var l;0==t.g.canCaptureBackward&&(l=t.g.Coord[s][0]);var g=t.Checkers2WaysDirections[c];if(a){if(t.g.longRangeKing)for(;e.board[i]==-1||t.g.king180deg&&null!=i&&r.indexOf(i)>=0;)i=t.g.Graph[i][c];if(null!=i&&e.board[i]>=0&&e.pieces[e.board[i]].s==-e.mWho){var v=i;if(i=t.g.Graph[i][c],t.g.kingCaptureShort){if(e.board[i]==-1||i==o[0]){for(var f=!0,d=0;d<n.length;d++)if(t.g.king180deg){if(r[d]==v){f=!1;break}}else if(t.g.captureInstantRemove&&r[d]==v||0==t.g.captureInstantRemove&&r[d]==v&&n[d]==g){f=!1;break}f&&(h.push(i),p.push(v),u.push(g)),i=t.g.Graph[i][c]}}else for(;e.board[i]==-1||i==o[0];){for(var f=!0,d=0;d<n.length;d++)if(t.g.captureInstantRemove&&r[d]==v||0==t.g.captureInstantRemove&&r[d]==v&&n[d]==g){f=!1;break}f&&(h.push(i),p.push(v),u.push(g)),i=t.g.Graph[i][c]}}}else if(e.board[i]>=0&&e.pieces[e.board[i]].s==-e.mWho){var m,C;if(0==t.g.canCaptureBackward&&(m=t.g.Coord[i][0],C=!1,(e.mWho==JocGame.PLAYER_A&&m>=l||e.mWho==JocGame.PLAYER_B&&m<=l)&&(C=!0)),t.g.canCaptureBackward||1==C){var b=t.g.Graph[i][c];if(null!=b&&(e.board[b]==-1||b==o[0])){for(var f=!0,d=0;d<n.length;d++)if(t.g.captureInstantRemove&&r[d]==i||0==t.g.captureInstantRemove&&r[d]==i&&n[d]==g){f=!1;break}f&&(h.push(b),p.push(i),u.push(g))}}}return!0}),0==h.length){o.length>1&&e.mMoves.push({pos:o,capt:r});break}if(!t.g.compulsoryCatch&&o.length>1){for(var c=[],l=0;l<o.length;l++)c.push(o[l]);for(var g=[],l=0;l<r.length;l++)g.push(r[l]);e.mMoves.push({pos:c,capt:g})}if(1!=h.length){for(var l=0;l<h.length;l++){for(var c=[],v=0;v<o.length;v++)c.push(o[v]);c.push(h[l]);for(var g=[],v=0;v<r.length;v++)g.push(r[v]);g.push(p[l]);for(var f=[],v=0;v<n.length;v++)f.push(n[v]);f.push(u[l]),i(h[l],c,g,f,a)}break}s=h[0],o.push(s),r.push(p[0]),n.push(u[0])}}var o=t.mOptions.height,e=this;if(this.mMoves=[],s(function(t,s){0==e.pieces[t].t?i(s,[s],[null],[null],!1):1==e.pieces[t].t&&i(s,[s],[null],[null],!0)}),0!=t.g.compulsoryCatch&&0!=this.mMoves.length||s(function(s,i){var r;0==e.pieces[s].t?((t.g.mustMoveForward||t.g.mustMoveForwardStrict||t.lastRowFreeze)&&(r=t.g.Coord[i][0]),t.CheckersEachDirection(i,function(n,a){var h,p,u;return t.g.mustMoveForwardStrict?(h=t.g.Coord[n][0],p=!1,(e.mWho==JocGame.PLAYER_A&&h>r||e.mWho==JocGame.PLAYER_B&&h<r)&&(p=!0)):t.g.mustMoveForward&&(h=t.g.Coord[n][0],p=!0,(e.mWho==JocGame.PLAYER_A&&h<r||e.mWho==JocGame.PLAYER_B&&h>r)&&(p=!1)),t.g.lastRowFreeze&&(u=!1,(e.mWho==JocGame.PLAYER_A&&r==o-1||e.mWho==JocGame.PLAYER_B&&0==r)&&(u=!0)),e.board[n]!=-1||!t.g.canStepBack&&n==e.pieces[s].l||(0!=t.g.mustMoveForward||0!=t.g.mustMoveForwardStrict)&&1!=p||0!=t.g.lastRowFreeze&&0!=u||e.mMoves.push({pos:[i,n],capt:[null,null]}),!0})):1==e.pieces[s].t&&t.CheckersEachDirection(i,function(s,o){if(t.g.longRangeKing)for(;e.board[s]==-1;)e.mMoves.push({pos:[i,s],capt:[null,null]}),s=t.g.Graph[s][o];else e.board[s]==-1&&(e.mMoves.push({pos:[i,s],capt:[null,null]}),s=t.g.Graph[s][o]);return!0})}),0==this.mMoves.length)switch(t.g.noMove){case"count":this.mFinished=!0,this.pCount[0]<this.pCount[1]?this.mWinner=JocGame.PLAYER_B:this.pCount[1]<this.pCount[0]?this.mWinner=JocGame.PLAYER_A:this.mWinner=JocGame.DRAW;break;case"lose":this.mFinished=!0,this.mWinner=-this.mWho;break;default:this.mFinished=!0,this.mWinner=JocGame.DRAW}if(t.g.captureLongestLine){for(var r=this.mMoves,n=[],a=0,h=0;h<r.length;h++){var p=r[h];p.pos.length==a?n.push(p):p.pos.length>a&&(n=[p],a=p.pos.length)}this.mMoves=n}},Model.Board.Evaluate=function(t,s,i){if(t.mOptions.preventRepeat&&t.GetRepeatOccurence(this)>2)return this.mFinished=!0,void(this.mWinner=JocGame.DRAW);if(t.g.drawKvsK&&0==this.spCount[0]&&0==this.spCount[1]&&1==this.kpCount[0]&&1==this.kpCount[1])return this.mFinished=!0,void(this.mWinner=JocGame.DRAW);if(t.g.drawKvs2K&&0==this.spCount[0]&&0==this.spCount[1]&&this.kpCount[0]+this.kpCount[1]==3&&(1==this.kpCount[0]||2==this.kpCount[0]))return this.mFinished=!0,void(this.mWinner=JocGame.DRAW);if(0==this.pCount[1])return this.mFinished=!0,void(this.mWinner=JocGame.PLAYER_A);if(0==this.pCount[0])return this.mFinished=!0,void(this.mWinner=JocGame.PLAYER_B);if(this.mEvaluation=10*(this.spCount[0]-this.spCount[1])+10*(this.kpCount[0]-this.kpCount[1])*t.g.kingValue+this.pCount[0]/this.pCount[1]-this.pCount[1]/this.pCount[0],0!=t.g.lastRowFactor){for(var o=t.mOptions.height,e=0,r=0,n=0;n<this.pieces.length;n++){var a=this.pieces[n];a&&0==a.t&&(this.mWho==JocGame.PLAYER_A?e+=t.g.Coord[a.p][0]:r+=o-1-t.g.Coord[a.p][0])}this.mEvaluation+=(e-r)*t.g.lastRowFactor}},Model.Board.CopyFrom=function(t){this.board=[];for(var s=0;s<t.board.length;s++)this.board[s]=t.board[s];this.pieces=[];for(var s=0;s<t.pieces.length;s++){var i=t.pieces[s];this.pieces[s]=null==i?null:{s:i.s,p:i.p,l:i.l,t:i.t,plp:i.plp}}this.pCount=[t.pCount[0],t.pCount[1]],this.spCount=[t.spCount[0],t.spCount[1]],this.kpCount=[t.kpCount[0],t.kpCount[1]],this.mWho=t.mWho,this.zSign=t.zSign},Model.Board.ApplyMove=function(t,s){var i=(t.mOptions.width,t.mOptions.height),o=s.pos[0],e=this.board[o],r=this.pieces[e],n=r.s;r.l=o;var a={};this.zSign=t.zobrist.update(this.zSign,"board",r.s+"/"+r.t,r.p);for(var h=1;h<s.pos.length;h++){var p=s.pos[h];this.board[r.p]=-1,r.p=p,this.board[p]=e;var u=s.capt[h];null!=u&&(this.board[u]>=0&&(a[this.board[u]]=!0),this.board[u]=-1),o=p}this.zSign=t.zobrist.update(this.zSign,"board",r.s+"/"+r.t,p);var c=s.capt[s.capt.length-1];r.plp=c||s.pos[s.pos.length-2];for(var l in a)if(a.hasOwnProperty(l)){var g=this.pieces[l],v=(1-g.s)/2;switch(this.pCount[v]--,g.t){case 0:this.spCount[v]--;break;case 1:this.kpCount[v]--}this.zSign=t.zobrist.update(this.zSign,"board",g.s+"/"+g.t,g.p),this.pieces[l]=null}if(t.g.lastRowCrown&&0==this.pieces[e].t){var f=t.g.Coord[s.pos[s.pos.length-1]][0];if(n==JocGame.PLAYER_A&&f==i-1||n==JocGame.PLAYER_B&&0==f){var g=this.pieces[e];g.t=1;var d=(1-n)/2;this.spCount[d]--,this.kpCount[d]++,this.zSign=t.zobrist.update(this.zSign,"board",g.s+"/0",g.p),this.zSign=t.zobrist.update(this.zSign,"board",g.s+"/1",g.p)}}},Model.Board.IsValidMove=function(t,s){return!0},Model.Board.GetSignature=function(){return this.zSign},Model.Game.Import=function(t,s){function i(t,s,i){i=r-i;var o=i%n;i=i-o+n-o-1,e.push({s:t,p:i,l:-1,t:s,plp:i})}var o=1,e=[],r=this.mOptions.width*this.mOptions.height,n=this.mOptions.width;if("pjn"==t){var a=s.split(":");o="W"==a[0]?1:-1;for(var h=1;h<a.length;h++)if(0!=a[h].length)for(var p="W"==a[h].substr(0,1)?1:-1,u=a[h].substr(1).split(","),c=0;c<u.length;c++){var l=u[c],g=0;"K"==l.substr(0,1)&&(g=1,l=l.substr(1));var v=/^([0-9]+)-([0-9]+)$/.exec(l);if(v)for(var f=parseInt(v[1]);f<=parseInt(v[2]);f++)i(p,g,f);else i(p,g,parseInt(l))}return e.sort(function(t,s){return s.s-t.s}),{status:!0,initial:{pieces:e,turn:o}}}return{status:!1,error:"unsupported"}};var e=JocGame.prototype.GetBestMatchingMove;Model.Game.GetBestMatchingMove=function(t,s){var i=[],o=this;s.forEach(function(t){"function"==typeof t.ToString?i.push(t.ToString()):i.push(o.CreateMove(t).ToString())}),t=t.replace(/0([1-9])/g,"$1");var r=/^([0-9]+)[\-x]([0-9]+)([\-x][0-9]+)*$/.exec(t);if(r){var n=new RegExp("^"+r[1]+"[-x]"+r[2]+"([-x][0-9]+)*$"),a={};s.forEach(function(t,s){if(n.test(i[s])){var o=i[s],e=/^([0-9]+)x([0-9]+)x([0-9]+(x[0-9]+)*)/.exec(o);if(e){var r=e[3].split("x");r.sort(function(t,s){return parseInt(t)-parseInt(s)}),o=e[1]+"x"+e[2]+"x"+r.join("x")}a[o]=t}});var h=[];for(var p in a)a.hasOwnProperty(p)&&h.push(a[p]);h.length>0&&(s=h)}return e.call(this,t,s)},Model.Board.ExportBoardState=function(o,e){function r(t){for(var o=[],e=0;e<n.board.length;e++){var r=e%s,a=(e-r)/s,h=(i-a-1)*s+r,p=n.board[e];if(p<0)o[h]="e";else{var u=n.pieces[p],c=1==u.s?"w":t;1==u.t&&(c=c.toUpperCase()),o[h]=c}}return o.join("")}e=e||"natural";var n=this;switch(e){case"natural":case"fen":return function(){var s={},i=[];n.pieces.forEach(function(i){if(i&&null!=i.p){var o=1==i.s?"W":"B";void 0===s[o]&&(s[o]={});var e=1==i.t?"K":"";void 0===s[o][e]&&(s[o][e]={group:0==i.t,pos:[]}),s[o][e].pos.push(parseInt(t(i.p)))}});for(var o in s)if(s.hasOwnProperty(o)){var e=[];for(var r in s[o])if(s[o].hasOwnProperty(r)){var a=s[o][r];if(a.group){a.pos.sort(function(t,s){return parseInt(t)-parseInt(s)});var h=-2,p=-1,u=-1;a.pos.forEach(function(t){parseInt(t)==h+1?p=t:(p>=0?(e.push(r+u+"-"+p),p=-1):u>=0&&e.push(r+u),u=t),h=parseInt(t)}),p>=0?e.push(r+u+"-"+p):u>=0&&e.push(r+u)}else a.pos.forEach(function(t){e.push(r+t)})}i.push(o+e.join(","))}return i.join(":")}();case"dxp":return function(){return r("z")}();case"hub":return function(){return r("z")}();default:return JSON.stringify(this)}}}(),Model.Game.CheckersDirections=8,Model.Game.Checkers2WaysDirections=[0,0,1,1,2,3,3,2],Model.Game.BuildGraphCoord=function(){for(var t=this.mOptions.width,s=this.mOptions.height,i=[],o=[],e=0;e<s;e++)for(var r=0;r<t;r++){var n=e*t+r;if(o[n]=[e,r],i[n]=[],e>0?i[n].push((e-1)*t+r):i[n].push(null),e<s-1?i[n].push((e+1)*t+r):i[n].push(null),r>0?i[n].push(e*t+r-1):i[n].push(null),r<t-1?i[n].push(e*t+r+1):i[n].push(null),e%2==r%2)for(var a=-1;a<2;a+=2)for(var h=-1;h<2;h+=2)e+a<s&&e+a>=0&&r+h<t&&r+h>=0?i[n].push((e+a)*t+r+h):i[n].push(null);else i[n].push(null),i[n].push(null),i[n].push(null),i[n].push(null)}this.g.Graph=i,this.g.Coord=o,this.g.compulsoryCatch=!1};

/***/ }),

/***/ "wAkD":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__("mmVS");
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var OuterSubscriber = (function (_super) {
    __extends(OuterSubscriber, _super);
    function OuterSubscriber() {
        _super.apply(this, arguments);
    }
    OuterSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.destination.next(innerValue);
    };
    OuterSubscriber.prototype.notifyError = function (error, innerSub) {
        this.destination.error(error);
    };
    OuterSubscriber.prototype.notifyComplete = function (innerSub) {
        this.destination.complete();
    };
    return OuterSubscriber;
}(Subscriber_1.Subscriber));
exports.OuterSubscriber = OuterSubscriber;
//# sourceMappingURL=OuterSubscriber.js.map

/***/ }),

/***/ "wUn1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var filter_1 = __webpack_require__("ack3");
Observable_1.Observable.prototype.filter = filter_1.filter;
//# sourceMappingURL=filter.js.map

/***/ }),

/***/ "whif":
/***/ (function(module, exports) {

exports.config = {"status":true,"model":{"plazza":"true","released":1405068608,"title-en":"Duke of Rutland Chess","module":"chessbase","summary":"Chess on 14x10 (1747)","thumbnail":"dukerutland-thumb.png","rules":{"en":"dukerutland-rules.html"},"credits":{"en":"dukerutland-credits.html"},"gameOptions":{"preventRepeat":true,"uctTransposition":"state","uctIgnoreLoop":false,"levelOptions":{"pieceValueFactor":1,"pieceValueRatioFactor":1,"posValueFactor":0.1,"averageDistKingFactor":-0.01,"castleFactor":0.1,"minorPiecesMovedFactor":0.1,"checkFactor":0.2,"endingKingFreedomFactor":0.01,"endingDistKingFactor":0.05,"distKingCornerFactor":0.1,"distPawnPromo1Factor":0.3,"distPawnPromo2Factor":0.1,"distPawnPromo3Factor":0.05}},"obsolete":false,"js":["base-model.js","grid-geo-model.js","dukerutland-model.js"],"description":{"en":"dukerutland-description.html"},"levels":[{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"easy","label":"Easy","maxNodes":1000},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"fast","label":"Fast [1sec]","maxDuration":1,"isDefault":true},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"medium","label":"Medium","maxNodes":10000,"maxDuration":10},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"strong","label":"Strong","maxNodes":20000,"maxDuration":15}]},"view":{"title-en":"Chessbase view","module":"chessbase","xdView":true,"css":["chessbase.css"],"preferredRatio":1,"useShowMoves":true,"useNotation":true,"useAutoComplete":true,"defaultOptions":{"sounds":true,"moves":true,"notation":false,"autocomplete":false},"skins":[{"name":"skin3d","title":"3D Classic","3d":true,"preload":["smoothedfilegeo|0|/res/ring-target.js","image|/res/images/cancel.png","image|/res/images/wikipedia.png","smoothedfilegeo|0|/res/fairy/pawn/pawn.js","image|/res/fairy/pawn/pawn-diffusemap.jpg","image|/res/fairy/pawn/pawn-normalmap.jpg","smoothedfilegeo|0|/res/fairy/knight/knight.js","image|/res/fairy/knight/knight-diffusemap.jpg","image|/res/fairy/knight/knight-normalmap.jpg","smoothedfilegeo|0|/res/fairy/bishop/bishop.js","image|/res/fairy/bishop/bishop-diffusemap.jpg","image|/res/fairy/bishop/bishop-normalmap.jpg","smoothedfilegeo|0|/res/fairy/king/king.js","image|/res/fairy/king/king-diffusemap.jpg","image|/res/fairy/king/king-normalmap.jpg","smoothedfilegeo|0|/res/fairy/rook/rook.js","image|/res/fairy/rook/rook-diffusemap.jpg","image|/res/fairy/rook/rook-normalmap.jpg","smoothedfilegeo|0|/res/fairy/queen/queen.js","image|/res/fairy/queen/queen-diffusemap.jpg","image|/res/fairy/queen/queen-normalmap.jpg","smoothedfilegeo|0|/res/fairy/marshall/marshall.js","image|/res/fairy/marshall/marshall-diffusemap.jpg","image|/res/fairy/marshall/marshall-normalmap.jpg","smoothedfilegeo|0|/res/fairy/crowned-rook/crowned-rook.js","image|/res/fairy/crowned-rook/crowned-rook-diffusemap.jpg","image|/res/fairy/crowned-rook/crowned-rook-normalmap.jpg"],"world":{"lightIntensity":1.3,"skyLightIntensity":1.2,"lightCastShadow":true,"fog":false,"color":4686804,"lightPosition":{"x":-9,"y":9,"z":9},"skyLightPosition":{"x":9,"y":9,"z":9},"lightShadowDarkness":0.55,"ambientLightColor":2236962},"camera":{"fov":45,"distMax":50,"radius":18,"elevationAngle":60,"elevationMin":0}},{"name":"skin2d","title":"2D Classic","3d":false,"preload":["image|/res/images/cancel.png","image|/res/images/whitebg.png","image|/res/fairy/wikipedia-fairy-sprites.png"]}],"animateSelfMoves":false,"switchable":true,"sounds":{"move1":"alq_move1","move2":"alq_move2","move3":"alq_move3","move4":"alq_move2","tac1":"alq_tac1","tac2":"alq_tac2","tac3":"alq_tac1","promo":"promo","usermove":null},"js":["base-view.js","grid-board-view.js","fairy-set-view.js","dukerutland-view.js"],"visuals":{"600x600":["res/visuals/dukerutland-600x600-3d.jpg","res/visuals/dukerutland-600x600-2d.jpg"]}}}

/***/ }),

/***/ "wvFg":
/***/ (function(module, exports) {

exports.config = {"status":true,"model":{"plazza":"true","title-en":"Brandubh","module":"tafl","js":["tafl-model.js"],"summary":"7x7 board (from Ireland)","thumbnail":"thumb-tafl-brandubh.png","rules":{"en":"rules-tafl-brandubh.html","fr":"rules-tafl-brandubh-fr.html"},"description":{"en":"description.html","fr":"description-fr.html"},"credits":{"en":"credits.html","fr":"credits-fr.html"},"gameOptions":{"preventRepeat":true,"uctTransposition":"states","levelOptions":{"attackersCountFactor":10,"defendersCountFactor":-10,"kingPathFactor":-20,"kingFreedomFactor":-0.1,"distKingFactor":-0.05},"exclude":[0,6,42,48],"attackers":1,"longMove":false,"initial":{"attackers":[3,10,21,22,26,27,38,45],"defenders":{"king":24,"soldiers":[17,23,25,31]}},"homeCatch":true,"privateHome":true,"centerDistance":3},"demoRandom":true,"visuals":["res/visuals/brandubh-600x600-3d.jpg","res/visuals/brandubh-600x600-2d.jpg"],"levels":[{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.65,"uncertaintyFactor":3,"useAlphaBeta":true,"name":"easy","label":"Easy","maxNodes":1000},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.65,"uncertaintyFactor":3,"useAlphaBeta":true,"name":"fast","label":"Fast [1sec]","maxDuration":1,"isDefault":true},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.65,"uncertaintyFactor":3,"useAlphaBeta":true,"name":"strong","label":"Strong","maxNodes":10000,"maxDuration":10}]},"view":{"title-en":"Tafl view","module":"tafl","js":["tafl-xd-view.js"],"xdView":true,"css":["tafl.css"],"preferredRatio":1,"switchable":true,"useShowMoves":false,"useNotation":true,"sounds":{"death1":"death1","death2":"death2","death3":"death3","move1":"move1","move3":"move3"},"defaultOptions":{"sounds":true,"moves":true,"notation":false},"skins":[{"name":"tafl3d","title":"3D Classic","3d":true,"camera":{"limitCamMoves":true,"radius":14,"rotationAngle":90,"elevationAngle":89.9,"elevationMin":2,"elevationMax":89.9},"world":{"lightIntensity":0.8,"skyLightIntensity":0.5,"lightCastShadow":false,"fog":false,"color":1118481,"lightPosition":{"x":10,"y":5,"z":0},"lightShadowDarkness":0.55,"ambientLightColor":4473924},"preload":["image|/res/xd-view/meshes/woodtoken-diffuse-black.jpg","image|/res/xd-view/meshes/woodtoken-diffuse.jpg","image|/res/images/ardriboard_bgx1024.jpg","image|/res/images/ardricellborders.png","image|/res/images/ardriblackcell.png","image|/res/images/ardrikingcell.png","image|/res/images/blackcell.png","image|/res/images/whitecell.png","smoothedfilegeo|0|/res/xd-view/meshes/taflboard.js","smoothedfilegeo|0|/res/xd-view/meshes/ring-target.js","smoothedfilegeo|0|/res/xd-view/meshes/woodtoken.js"]},{"name":"tafl2d","title":"2D Classic","3d":false,"preload":["image|/res/xd-view/meshes/ardri-sprites.png","image|/res/images/ardriboard_bgx1024.jpg","image|/res/images/ardricellborders.png","image|/res/images/ardriblackcell.png","image|/res/images/ardrikingcell.png","image|/res/images/blackcell.png","image|/res/images/whitecell.png"]}],"animateSelfMoves":false,"visuals":{"600x600":["res/visuals/brandubh-600x600-3d.jpg","res/visuals/brandubh-600x600-2d.jpg"]}}}

/***/ }),

/***/ "ww7A":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var AsyncScheduler_1 = __webpack_require__("9Avi");
var AnimationFrameScheduler = (function (_super) {
    __extends(AnimationFrameScheduler, _super);
    function AnimationFrameScheduler() {
        _super.apply(this, arguments);
    }
    AnimationFrameScheduler.prototype.flush = function (action) {
        this.active = true;
        this.scheduled = undefined;
        var actions = this.actions;
        var error;
        var index = -1;
        var count = actions.length;
        action = action || actions.shift();
        do {
            if (error = action.execute(action.state, action.delay)) {
                break;
            }
        } while (++index < count && (action = actions.shift()));
        this.active = false;
        if (error) {
            while (++index < count && (action = actions.shift())) {
                action.unsubscribe();
            }
            throw error;
        }
    };
    return AnimationFrameScheduler;
}(AsyncScheduler_1.AsyncScheduler));
exports.AnimationFrameScheduler = AnimationFrameScheduler;
//# sourceMappingURL=AnimationFrameScheduler.js.map

/***/ }),

/***/ "xAJs":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__("mmVS");
/**
 * Applies a given `project` function to each value emitted by the source
 * Observable, and emits the resulting values as an Observable.
 *
 * <span class="informal">Like [Array.prototype.map()](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/map),
 * it passes each source value through a transformation function to get
 * corresponding output values.</span>
 *
 * <img src="./img/map.png" width="100%">
 *
 * Similar to the well known `Array.prototype.map` function, this operator
 * applies a projection to each value and emits that projection in the output
 * Observable.
 *
 * @example <caption>Map every every click to the clientX position of that click</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var positions = clicks.map(ev => ev.clientX);
 * positions.subscribe(x => console.log(x));
 *
 * @see {@link mapTo}
 * @see {@link pluck}
 *
 * @param {function(value: T, index: number): R} project The function to apply
 * to each `value` emitted by the source Observable. The `index` parameter is
 * the number `i` for the i-th emission that has happened since the
 * subscription, starting from the number `0`.
 * @param {any} [thisArg] An optional argument to define what `this` is in the
 * `project` function.
 * @return {Observable<R>} An Observable that emits the values from the source
 * Observable transformed by the given `project` function.
 * @method map
 * @owner Observable
 */
function map(project, thisArg) {
    if (typeof project !== 'function') {
        throw new TypeError('argument is not a function. Are you looking for `mapTo()`?');
    }
    return this.lift(new MapOperator(project, thisArg));
}
exports.map = map;
var MapOperator = (function () {
    function MapOperator(project, thisArg) {
        this.project = project;
        this.thisArg = thisArg;
    }
    MapOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new MapSubscriber(subscriber, this.project, this.thisArg));
    };
    return MapOperator;
}());
exports.MapOperator = MapOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var MapSubscriber = (function (_super) {
    __extends(MapSubscriber, _super);
    function MapSubscriber(destination, project, thisArg) {
        _super.call(this, destination);
        this.project = project;
        this.count = 0;
        this.thisArg = thisArg || this;
    }
    // NOTE: This looks unoptimized, but it's actually purposefully NOT
    // using try/catch optimizations.
    MapSubscriber.prototype._next = function (value) {
        var result;
        try {
            result = this.project.call(this.thisArg, value, this.count++);
        }
        catch (err) {
            this.destination.error(err);
            return;
        }
        this.destination.next(result);
    };
    return MapSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=map.js.map

/***/ }),

/***/ "xBNO":
/***/ (function(module, exports) {

exports.model=Model={Game:{},Board:{},Move:{}},Model.Game.InitGame=function(){for(var i=this.mOptions.width,t=this.mOptions.height,o=[],s=[],e=0;e<t;e++)for(var r=0;r<i;r++){var a=e*i+r;s[a]=[e,r],o[a]=[];for(var n=-1;n<2;n++)for(var h=-1;h<2;h++)0==n&&0==h||(e+n<t&&e+n>=0&&r+h<i&&r+h>=0?o[a].push((e+n)*i+r+h):o[a].push(null))}this.g.Graph=o,this.g.Coord=s,this.zobrist=new JocGame.Zobrist({board:{type:"array",size:this.g.Graph.length,values:["1","-1","-2"]}})},Model.Game.DestroyGame=function(){},Model.Game.ScrumEachDirection=function(i,t){for(var o=0;o<8;o++){var s=this.g.Graph[i][o];null!=s&&t(s,o)}},Model.Move.Init=function(i){void 0!==i.seg&&(this.seg=[{f:i.seg[0].f,t:i.seg[0].t}],void 0!==i.seg[0].b&&(this.seg[0].b=i.seg[0].b),void 0!==i.seg[1]&&(this.seg[1]={f:i.seg[1].f,t:i.seg[1].t},void 0!==i.seg[1].b&&(this.seg[1].b=i.seg[1].b)))},Model.Move.ToString=function(){var i=this.seg[0].f+">"+this.seg[0].t;return void 0!==this.seg[0].b&&(i+=">"+this.seg[0].b),void 0!==this.seg[1]&&(i+=" - "+this.seg[1].f+">"+this.seg[1].t,void 0!==this.seg[1].b&&(i+=">"+this.seg[1].b)),i},Model.Board.Init=function(i){this.zSign=0},Model.Board.InitialPosition=function(i){var t=i.mOptions.width,o=i.mOptions.height,s=i.mOptions.initial;this.first=!0,this.board=[];for(var e=0;e<o;e++)for(var r=0;r<t;r++)this.board[e*t+r]=-1;this.pieces=[];var a=0;for(var n in s.a)if(s.a.hasOwnProperty(n)){var h=s.a[n],l=h[0]*t+h[1];this.pieces.push({s:JocGame.PLAYER_A,p:l,a:180,sc:!1}),this.board[l]=a++,this.zSign=i.zobrist.update(this.zSign,"board","1",l)}for(var n in s.b)if(s.b.hasOwnProperty(n)){var h=s.b[n],l=h[0]*t+h[1];this.pieces.push({s:JocGame.PLAYER_B,p:l,a:0,sc:!1}),this.board[l]=a++,this.zSign=i.zobrist.update(this.zSign,"board","-1",l)}this.ball=s.ball[0]*t+s.ball[1],this.board[this.ball]=-2,this.zSign=i.zobrist.update(this.zSign,"board","-2",this.ball),this.scrum=!1},Model.Board.GenerateMoves=function(i){try{this._GenerateMoves(i)}catch(i){console.error("GenerateMoves: "+i)}},Model.Board._GenerateMoves=function(i){function t(t,o){if(t>o){var s=t;t=o,o=s}var e=t+"/"+o;if(void 0===l[e]){var r=i.g.Coord[t],a=i.g.Coord[o],n=Math.max(Math.abs(r[0]-a[0]),Math.abs(r[1]-a[1]));l[e]=n}return l[e]}function o(t,o,s,e){var r=i.g.Coord[t],a=i.g.Coord[o],n=[0,1,2,3,4,5,6,7];a[0]>r[0]?(n[0]=-1,n[1]=-1,n[2]=-1,s&&(n[3]=-1,n[4]=-1)):a[0]<r[0]&&(n[5]=-1,n[6]=-1,n[7]=-1,s&&(n[3]=-1,n[4]=-1)),a[1]>r[1]?(n[0]=-1,n[3]=-1,n[5]=-1,s&&(n[1]=-1,n[6]=-1)):a[1]<r[1]&&(n[2]=-1,n[4]=-1,n[7]=-1,s&&(n[1]=-1,n[6]=-1));for(var h=0;h<n.length;h++)if(n[h]!=-1){var l=i.g.Graph[t][n[h]];l&&e(l,h)}}function s(i){for(var t=0;t<n.pieces.length;t++){var o=n.pieces[t];o.s==n.mWho&&i(t,o.p)}}function e(t){if(void 0===c[t]){var o=0,s=0,e=0,r=[];i.ScrumEachDirection(t,function(i){var t=n.board[i];t<0?t==-1&&(e++,r.push(i)):n.pieces[t].s==n.mWho?s++:o++});var a={e:e,etab:r,s:s,o:o};return c[t]=a,a}return c[t]}function r(t,o){if(null!=t.b){var s=i.g.Coord[t.b][0];if(0==s&&n.mWho==JocGame.PLAYER_B||s==a-1&&n.mWho==JocGame.PLAYER_A){var e=0;if(i.ScrumEachDirection(t.b,function(i){n.board[i]==-1&&e++}),e>0){0==J&&(E=[],J=!0);var r={seg:[{f:t.f,t:t.t,b:t.b}]};E.push(r)}}}else{var s=i.g.Coord[n.ball][0];if(0==s&&n.mWho==JocGame.PLAYER_B||s==a-1&&n.mWho==JocGame.PLAYER_A){var h=!1,e=0;if(i.ScrumEachDirection(n.ball,function(i){i==t.t?h=!0:n.board[i]==-1&&e++}),h&&e>0){0==J&&(E=[],J=!0);var r={seg:[{f:t.f,t:t.t}]};E.push(r)}}}if(!J){var e=0,l=n.ball;if(null!=t.b&&(l=t.b),null!=o.b&&(l=o.b),i.ScrumEachDirection(l,function(i){n.board[i]<0&&e++,t.t!=i&&o.t!=i||e--,t.f!=i&&o.f!=i||e++}),0!=e){var r={seg:[{f:t.f,t:t.t},{f:o.f,t:o.t}]};null!=t.b&&(r.seg[0].b=t.b),null!=o.b&&(r.seg[1].b=o.b),E.push(r)}}}var a=i.mOptions.height,n=this,h=(new Date).getTime(),l={},c={},b=e(this.ball),d=[],v=i.g.Coord[this.ball][0];if(i.ScrumEachDirection(this.ball,function(t){n.board[t]==-1&&d.push({p:t,c:e(t),g:(i.g.Coord[t][0]-v)*n.mWho})}),this.scrum){var u=-1,f=[];if(i.ScrumEachDirection(this.ball,function(i){var t=n.board[i];t==-1?u=i:t>=0&&n.pieces[t].s==n.mWho&&f.push(t)}),u==-1)return this.mFinished=!0,void(this.mWinner=JocGame.DRAW);for(var g=0;g<f.length;g++){var p=f[g],m=!0;i.ScrumEachDirection(u,function(i){var t=n.board[i];(t==-1||t>=0&&i==n.pieces[p].p)&&(m=!1)}),0==m&&this.mMoves.push({seg:[{f:n.pieces[p].p,t:n.ball,b:u}]})}if(f.length>0)return void(0==this.mMoves.length&&(this.mFinished=!0,this.mWinner=JocGame.DRAW))}var S=[];i.ScrumEachDirection(this.ball,function(i){var t=n.board[i];if(t>=0&&n.pieces[t].s==n.mWho)for(var o=0;o<d.length;o++){var s=d[o],e={i:t,f:i,t:n.ball,b:s.p,c:s.c,g:s.g,d:1};S.push(e)}}),s(function(s,e){function r(i,t){var o={i:s,f:e,t:i,b:null,c:b,g:0,d:t};S.push(o)}var a=t(e,n.ball);1==a?i.ScrumEachDirection(e,function(i){n.board[i]==-1&&r(i,t(i,n.ball))}):a<4?i.ScrumEachDirection(e,function(i){n.board[i]==-1&&r(i,t(i,n.ball))}):o(e,n.ball,!1,function(i){n.board[i]==-1&&r(i,t(i,n.ball))})});for(var g=0;g<S.length;g++){var M=S[g],A=.125*(8-M.c.o)*1+.125*M.c.s*1+.25*(M.g+2)*4+(11-M.d)*(1/11)*2;0==M.e&&(A=-1e3),1==M.e&&(A+=1e3),2==M.e&&(A+=2),M.w=A}S.sort(function(i,t){return t.w-i.w});var E=[];if(this.first){for(var g=0;g<i.mOptions.levelOptions.MIN_MOVES&&g<S.length;g++){var G=S[g],z={seg:[{f:G.f,t:G.t}]};null!=G.b&&(z.seg[0].b=G.b),E.push(z)}return void(this.mMoves=E)}for(var W,J=!1,L=-1,D=0,O={},R={};E.length<i.mOptions.levelOptions.MIN_MOVES&&(W=function(){for(;;){if(L++,L==D&&(D++,L=0),!(D<S.length))return null;var i=S[L],t=S[D];if(!(null!=i.b&&null!=t.b||i.i==t.i||i.t==t.t||t.t==i.b&&null==t.b||t.b==i.t))return[i,t]}}());){var _=W[0];if(r(_,W[1]),null!=_.b&&!_.explored){_.explored=!0;for(var y=function(t){if(void 0===O[t]){O[t]=[];var o=[],s=[];i.ScrumEachDirection(t,function(i){var t=n.board[i];t==-1?o.push(i):t>=0&&n.pieces[t].s==n.mWho&&s.push(t)});for(var e=0;e<s.length;e++)for(var r=s[e],a=0;a<o.length;a++)O[t].push({i:r,f:n.pieces[r].p,t:t,b:o[a]})}return O[t]}(_.b),g=0;g<y.length;g++){var B=y[g];B.i!=_.i&&r(_,B)}for(var y=function(t){return void 0===R[t]&&(R[t]=[],i.ScrumEachDirection(t,function(i){var o=n.board[i];o>=0&&n.pieces[o].s==n.mWho&&R[t].push({i:o,f:n.pieces[o].p,t:t})})),R[t]}(_.f),g=0;g<y.length;g++){var B=y[g];B.i!=_.i&&r(_,B)}}}var P=[];i.ScrumEachDirection(this.ball,function(i){var t=n.board[i];t>=0&&n.pieces[t].s==n.mWho&&P.push(t)});for(var C=[],g=0;g<P.length;g++){var Y=i.g.Coord[this.pieces[P[g]].p][0];(this.mWho==JocGame.PLAYER_A&&Y>=v||this.mWho==JocGame.PLAYER_B&&Y<=v)&&C.push(P[g])}for(var F=E.length,g=0;g<C.length;g++)for(var w=0;w<P.length;w++)if(C[g]!=P[w]){var I=this.pieces[C[g]],x=this.pieces[P[w]];i.ScrumEachDirection(I.p,function(i){n.board[i]==-1&&r({i:C[g],f:I.p,t:i},{i:P[w],f:x.p,t:n.ball,b:I.p})})}var T=E.length-F;this.mMoves=E,0==this.mMoves.length&&this.mMoves.push(function(){var o=[],e=[];s(function(i,o){var s=t(o,n.ball);e.push({i:i,d:s})}),e.sort(function(i,t){return t.d-i.d});for(var r=0;r<e.length;r++){var a=e[r],h=n.pieces[a.i].p,l=t(h,n.ball),c=!1;if(i.ScrumEachDirection(h,function(i){if(!c&&n.board[i]==-1){if(t(i,n.ball)>=l){if(1==o.length&&i==o[0].t)return;o.push({i:a.i,f:h,t:i}),c=!0}}}),2==o.length)return{seg:[{f:o[0].f,t:o[0].t},{f:o[1].f,t:o[1].t}]}}}()),gmStats="undefined"!=typeof gmStats?gmStats:{count:0,time:0,moves:0,segments:0,maxGroup2:0};var N=(new Date).getTime(),V=N-h;gmStats.count++,gmStats.time+=V,gmStats.moves+=E.length,gmStats.segments+=S.length,T>gmStats.maxGroup2&&(gmStats.maxGroup2=T)},Model.Board.Evaluate=function(i,t,o){if(i.GetRepeatOccurence(this)>2)return this.mFinished=!0,void(this.mWinner=JocGame.DRAW);var s=i.mOptions.height,e=this,r=0,a=0,n=0;i.ScrumEachDirection(this.ball,function(i){var t=e.board[i];if(t==-1)r++;else if(t>=0){var o=e.pieces[t];o.s==JocGame.PLAYER_A?a++:n++,0==h&&o.p==JocGame.PLAYER_B?(e.mFinished=!0,e.mWinner=JocGame.PLAYER_B):h==s-1&&o.p==JocGame.PLAYER_A&&(e.mFinished=!0,e.mWinner=JocGame.PLAYER_A)}});var h=i.g.Coord[this.ball][0];0==h&&n>0&&(e.mFinished=!0,e.mWinner=JocGame.PLAYER_B),h==s-1&&a>0&&(e.mFinished=!0,e.mWinner=JocGame.PLAYER_A);var l=h/(s-1),c=1-l,b=l-c,d=0;0==n&&d++,0==a&&d--;for(var v=0,u=0,f=i.g.Coord[this.ball],g=0;g<this.pieces.length;g++){var p=this.pieces[g],m=i.g.Coord[p.p],S=Math.max(Math.abs(f[0]-m[0]),Math.abs(f[1]-m[1]));p.s==JocGame.PLAYER_A?v+=S:u+=S}this.mEvaluation=b*i.mOptions.levelOptions.ROW_FACTOR+d*i.mOptions.levelOptions.NEIGHBOR_FACTOR+(u-v)*i.mOptions.levelOptions.BDIST_FACTOR},Model.Board.CopyFrom=function(i){this.board=[];for(var t=0;t<i.board.length;t++)this.board.push(i.board[t]);this.pieces=[];for(var o=0;o<i.pieces.length;o++){var s=i.pieces[o];this.pieces.push({s:s.s,p:s.p,a:s.a,sc:s.sc})}this.ball=i.ball,this.scrum=i.scrum,this.first=i.first,this.mWho=i.mWho,this.zSign=i.zSign},Model.Board.ApplyMove=function(i,t){var o=this,s=this.board[t.seg[0].f];if(s<0)return void JocLog("!!! ApplyMove",t,this.board,"seg0: no piece at start");if(this.pieces[s].s!=this.mWho)return void console.error("!!! ApplyMove",t,this.board,"seg0: piece at start is not self");var e=this.board[t.seg[0].t];if(e!=-1&&e!=-2)return void JocLog("!!! ApplyMove",t,this.board,"seg0: cell at dest not avail",e);if(e==-2&&void 0===t.seg[0].b)return void JocLog("!!! ApplyMove",t,this.board,"seg0: to ball but no ball depl");if(e!=-2&&void 0!==t.seg[0].b)return void JocLog("!!! ApplyMove",t,this.board,"seg0: no ball but ball depl");var r=t.seg[0],a=this.board[r.f];if(this.zSign=i.zobrist.update(this.zSign,"board",this.mWho,r.f),this.board[r.f]=-1,this.zSign=i.zobrist.update(this.zSign,"board",this.mWho,r.t),this.board[r.t]=a,this.pieces[s].p=r.t,void 0!==r.b&&(this.zSign=i.zobrist.update(this.zSign,"board",-2,this.ball),this.ball=r.b,this.zSign=i.zobrist.update(this.zSign,"board",-2,this.ball),this.board[this.ball]=-2),void 0!==t.seg[1]){var n=this.board[t.seg[1].f];if(s==n)return void JocLog("!!! ApplyMove",t,this.board,"seg1: move same piece");if(n<0)return JocLog("!!! ApplyMove",t,this.board,"seg1: no piece at start"),void JocLog(t,this);if(this.pieces[n].s!=this.mWho)return void JocLog("!!! ApplyMove",t,this.board,"seg1: piece at start is not self");var h=this.board[t.seg[1].t];if(h!=-1&&h!=-2)return void JocLog("!!! ApplyMove",t,this.board,"seg1: cell at dest not avail");if(h==-2&&void 0===t.seg[1].b)return void JocLog("!!! ApplyMove",t,this.board,"seg1: to ball but no ball depl");if(h!=-2&&void 0!==t.seg[1].b)return void JocLog("!!! ApplyMove",t,this.board,"seg1: no ball but ball depl");var r=t.seg[1],a=this.board[r.f];this.zSign=i.zobrist.update(this.zSign,"board",this.mWho,r.f),this.board[r.f]=-1,this.zSign=i.zobrist.update(this.zSign,"board",this.mWho,r.t),this.board[r.t]=a,this.pieces[n].p=r.t,void 0!==r.b&&(this.zSign=i.zobrist.update(this.zSign,"board",-2,this.ball),this.ball=r.b,this.zSign=i.zobrist.update(this.zSign,"board",-2,this.ball),this.board[this.ball]=-2)}var l=0;i.ScrumEachDirection(this.ball,function(i){o.board[i]==-1&&(l++,o.scrumExit=i)}),this.scrum=!1,1==l?this.scrum=!0:0==l&&JocLog("!!! ApplyMove: ball enclosed");var c={};this.scrum&&i.ScrumEachDirection(this.ball,function(i,t){var s=o.board[i];s>=0&&(c[s]=t)});for(var b=0;b<this.pieces.length;b++){var d=this.pieces[b],v=0;void 0!==c[b]?(v=[135,180,-135,90,-90,45,0,-45][c[b]],d.a=v,d.sc=!0):(d.a=v+(1==d.s?180:0),d.sc=!1)}this.first=!1},Model.Board.IsValidMove=function(i,t){var o=this,s=0,e=this.ball,r=t.seg[0],a=t.seg[1];return r.b&&(e=r.b),a&&a.b&&(e=a.b),i.ScrumEachDirection(e,function(i){o.board[i]<0&&s++,(r.t==i||a&&a.t==i)&&s--,(r.f==i||a&&a.f==i)&&s++}),0!=s||(this.mInvalidMoveMessage=i.mStrings["no-surround"],!1)},Model.Board.GetSignature=function(){return this.zSign};

/***/ }),

/***/ "xFXl":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var windowToggle_1 = __webpack_require__("yZjU");
Observable_1.Observable.prototype.windowToggle = windowToggle_1.windowToggle;
//# sourceMappingURL=windowToggle.js.map

/***/ }),

/***/ "xOQQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var pluck_1 = __webpack_require__("U9ky");
Observable_1.Observable.prototype.pluck = pluck_1.pluck;
//# sourceMappingURL=pluck.js.map

/***/ }),

/***/ "xYP1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscriber_1 = __webpack_require__("mmVS");
var tryCatch_1 = __webpack_require__("+3eL");
var errorObject_1 = __webpack_require__("WhVc");
/**
 * Compares all values of two observables in sequence using an optional comparor function
 * and returns an observable of a single boolean value representing whether or not the two sequences
 * are equal.
 *
 * <span class="informal">Checks to see of all values emitted by both observables are equal, in order.</span>
 *
 * <img src="./img/sequenceEqual.png" width="100%">
 *
 * `sequenceEqual` subscribes to two observables and buffers incoming values from each observable. Whenever either
 * observable emits a value, the value is buffered and the buffers are shifted and compared from the bottom
 * up; If any value pair doesn't match, the returned observable will emit `false` and complete. If one of the
 * observables completes, the operator will wait for the other observable to complete; If the other
 * observable emits before completing, the returned observable will emit `false` and complete. If one observable never
 * completes or emits after the other complets, the returned observable will never complete.
 *
 * @example <caption>figure out if the Konami code matches</caption>
 * var code = Rx.Observable.from([
 *  "ArrowUp",
 *  "ArrowUp",
 *  "ArrowDown",
 *  "ArrowDown",
 *  "ArrowLeft",
 *  "ArrowRight",
 *  "ArrowLeft",
 *  "ArrowRight",
 *  "KeyB",
 *  "KeyA",
 *  "Enter" // no start key, clearly.
 * ]);
 *
 * var keys = Rx.Observable.fromEvent(document, 'keyup')
 *  .map(e => e.code);
 * var matches = keys.bufferCount(11, 1)
 *  .mergeMap(
 *    last11 =>
 *      Rx.Observable.from(last11)
 *        .sequenceEqual(code)
 *   );
 * matches.subscribe(matched => console.log('Successful cheat at Contra? ', matched));
 *
 * @see {@link combineLatest}
 * @see {@link zip}
 * @see {@link withLatestFrom}
 *
 * @param {Observable} compareTo The observable sequence to compare the source sequence to.
 * @param {function} [comparor] An optional function to compare each value pair
 * @return {Observable} An Observable of a single boolean value representing whether or not
 * the values emitted by both observables were equal in sequence.
 * @method sequenceEqual
 * @owner Observable
 */
function sequenceEqual(compareTo, comparor) {
    return this.lift(new SequenceEqualOperator(compareTo, comparor));
}
exports.sequenceEqual = sequenceEqual;
var SequenceEqualOperator = (function () {
    function SequenceEqualOperator(compareTo, comparor) {
        this.compareTo = compareTo;
        this.comparor = comparor;
    }
    SequenceEqualOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new SequenceEqualSubscriber(subscriber, this.compareTo, this.comparor));
    };
    return SequenceEqualOperator;
}());
exports.SequenceEqualOperator = SequenceEqualOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var SequenceEqualSubscriber = (function (_super) {
    __extends(SequenceEqualSubscriber, _super);
    function SequenceEqualSubscriber(destination, compareTo, comparor) {
        _super.call(this, destination);
        this.compareTo = compareTo;
        this.comparor = comparor;
        this._a = [];
        this._b = [];
        this._oneComplete = false;
        this.add(compareTo.subscribe(new SequenceEqualCompareToSubscriber(destination, this)));
    }
    SequenceEqualSubscriber.prototype._next = function (value) {
        if (this._oneComplete && this._b.length === 0) {
            this.emit(false);
        }
        else {
            this._a.push(value);
            this.checkValues();
        }
    };
    SequenceEqualSubscriber.prototype._complete = function () {
        if (this._oneComplete) {
            this.emit(this._a.length === 0 && this._b.length === 0);
        }
        else {
            this._oneComplete = true;
        }
    };
    SequenceEqualSubscriber.prototype.checkValues = function () {
        var _c = this, _a = _c._a, _b = _c._b, comparor = _c.comparor;
        while (_a.length > 0 && _b.length > 0) {
            var a = _a.shift();
            var b = _b.shift();
            var areEqual = false;
            if (comparor) {
                areEqual = tryCatch_1.tryCatch(comparor)(a, b);
                if (areEqual === errorObject_1.errorObject) {
                    this.destination.error(errorObject_1.errorObject.e);
                }
            }
            else {
                areEqual = a === b;
            }
            if (!areEqual) {
                this.emit(false);
            }
        }
    };
    SequenceEqualSubscriber.prototype.emit = function (value) {
        var destination = this.destination;
        destination.next(value);
        destination.complete();
    };
    SequenceEqualSubscriber.prototype.nextB = function (value) {
        if (this._oneComplete && this._a.length === 0) {
            this.emit(false);
        }
        else {
            this._b.push(value);
            this.checkValues();
        }
    };
    return SequenceEqualSubscriber;
}(Subscriber_1.Subscriber));
exports.SequenceEqualSubscriber = SequenceEqualSubscriber;
var SequenceEqualCompareToSubscriber = (function (_super) {
    __extends(SequenceEqualCompareToSubscriber, _super);
    function SequenceEqualCompareToSubscriber(destination, parent) {
        _super.call(this, destination);
        this.parent = parent;
    }
    SequenceEqualCompareToSubscriber.prototype._next = function (value) {
        this.parent.nextB(value);
    };
    SequenceEqualCompareToSubscriber.prototype._error = function (err) {
        this.parent.error(err);
    };
    SequenceEqualCompareToSubscriber.prototype._complete = function () {
        this.parent._complete();
    };
    return SequenceEqualCompareToSubscriber;
}(Subscriber_1.Subscriber));
//# sourceMappingURL=sequenceEqual.js.map

/***/ }),

/***/ "xZ/u":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = extendObject;
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Extends an object with the *enumerable* and *own* properties of one or more source objects,
 * similar to Object.assign.
 *
 * @param dest The object which will have properties copied to it.
 * @param sources The source objects from which properties will be copied.
 */
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */ function extendObject(dest) {
    var sources = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        sources[_i - 1] = arguments[_i];
    }
    if (dest == null) {
        throw TypeError('Cannot convert undefined or null to object');
    }
    for (var _a = 0, sources_1 = sources; _a < sources_1.length; _a++) {
        var source = sources_1[_a];
        if (source != null) {
            for (var key in source) {
                if (source.hasOwnProperty(key)) {
                    dest[key] = source[key];
                }
            }
        }
    }
    return dest;
}
//# sourceMappingURL=object-extend.js.map

/***/ }),

/***/ "xbvD":
/***/ (function(module, exports) {

exports.config = {"status":true,"model":{"plazza":"true","released":1398178577,"title-en":"Mini Chess 4x4","module":"chessbase","summary":"4x4 mini chess variant","thumbnail":"mini4x4-thumb.png","rules":{"en":"mini4x4-rules.html"},"credits":{"en":"mini4x4-credits.html"},"gameOptions":{"preventRepeat":true,"uctTransposition":"state","uctIgnoreLoop":false,"levelOptions":{"pieceValueFactor":1,"pieceValueRatioFactor":1,"posValueFactor":0.1,"averageDistKingFactor":-0.01,"castleFactor":0.1,"minorPiecesMovedFactor":0.1,"checkFactor":0.2,"endingKingFreedomFactor":0.01,"endingDistKingFactor":0.05,"distKingCornerFactor":0.1}},"obsolete":false,"js":["base-model.js","grid-geo-model.js","mini4x4-model.js"],"levels":[{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"easy","label":"Easy","maxNodes":1000},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"fast","label":"Fast [1sec]","maxDuration":1,"isDefault":true},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"medium","label":"Medium","maxNodes":10000,"maxDuration":10},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"strong","label":"Strong","maxNodes":20000,"maxDuration":15}],"description":{"en":"mini4x4-description.html"}},"view":{"title-en":"Chessbase view","module":"chessbase","xdView":true,"css":["chessbase.css"],"preferredRatio":1,"useShowMoves":true,"useNotation":true,"useAutoComplete":true,"defaultOptions":{"sounds":true,"moves":true,"notation":false,"autocomplete":false},"skins":[{"name":"skin3d","title":"3D Classic","3d":true,"preload":["smoothedfilegeo|0|/res/ring-target.js","image|/res/images/cancel.png","image|/res/images/wikipedia.png","smoothedfilegeo|0|/res/staunton/pawn/pawn-classic.js","image|/res/staunton/pawn/pawn-diffusemap.jpg","image|/res/staunton/pawn/pawn-normalmap.jpg","smoothedfilegeo|0|/res/staunton/knight/knight.js","image|/res/staunton/knight/knight-diffusemap.jpg","image|/res/staunton/knight/knight-normalmap.jpg","smoothedfilegeo|0|/res/staunton/bishop/bishop.js","image|/res/staunton/bishop/bishop-diffusemap.jpg","image|/res/staunton/bishop/bishop-normalmap.jpg","smoothedfilegeo|0|/res/staunton/rook/rook.js","image|/res/staunton/rook/rook-diffusemap.jpg","image|/res/staunton/rook/rook-normalmap.jpg","smoothedfilegeo|0|/res/staunton/queen/queen.js","image|/res/staunton/queen/queen-diffusemap.jpg","image|/res/staunton/queen/queen-normalmap.jpg","smoothedfilegeo|0|/res/staunton/king/king.js","image|/res/staunton/king/king-diffusemap.jpg","image|/res/staunton/king/king-normalmap.jpg"],"world":{"lightIntensity":1.3,"skyLightIntensity":1.2,"lightCastShadow":true,"fog":false,"color":4686804,"lightPosition":{"x":-9,"y":9,"z":9},"skyLightPosition":{"x":9,"y":9,"z":9},"lightShadowDarkness":0.55,"ambientLightColor":2236962},"camera":{"fov":45,"distMax":50,"radius":18,"elevationAngle":60,"elevationMin":0}},{"name":"skin2d","title":"2D Classic","3d":false,"preload":["image|/res/images/cancel.png","image|/res/images/whitebg.png","image|/res/images/wikipedia.png"]}],"animateSelfMoves":false,"switchable":true,"sounds":{"move1":"alq_move1","move2":"alq_move2","move3":"alq_move3","move4":"alq_move2","tac1":"alq_tac1","tac2":"alq_tac2","tac3":"alq_tac1","promo":"promo","usermove":null},"js":["base-view.js","grid-board-view.js","staunton-set-view.js","mini4x4-view.js"],"visuals":{"600x600":["res/visuals/mini4x4-600x600-3d.jpg","res/visuals/mini4x4-600x600-2d.jpg"]}}}

/***/ }),

/***/ "y3IE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var retry_1 = __webpack_require__("vrkH");
Observable_1.Observable.prototype.retry = retry_1.retry;
//# sourceMappingURL=retry.js.map

/***/ }),

/***/ "y5CN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__angular_core__ = __webpack_require__("3j3K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__("hFwN");
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return JsonTreeComponent; });


var JsonTreeComponent = (function () {
    function JsonTreeComponent() {
        this.children = [];
        this.expanded = true;
    }
    Object.defineProperty(JsonTreeComponent.prototype, "value", {
        set: function (value) {
            this.children = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__types__["a" /* getChildrenFor */])(value);
        },
        enumerable: true,
        configurable: true
    });
    JsonTreeComponent.decorators = [
        { type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Component"], args: [{
                    selector: 'ngrx-json-tree',
                    template: "\n    <ngrx-json-node *ngFor=\"let child of children\" [expanded]=\"expanded\" [value]=\"child.value\" [key]=\"child.key\"></ngrx-json-node>\n  "
                },] },
    ];
    /** @nocollapse */
    JsonTreeComponent.ctorParameters = [];
    JsonTreeComponent.propDecorators = {
        'expanded': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
        'value': [{ type: __WEBPACK_IMPORTED_MODULE_0__angular_core__["Input"] },],
    };
    return JsonTreeComponent;
}());
//# sourceMappingURL=json-tree.js.map

/***/ }),

/***/ "y5aA":
/***/ (function(module, exports) {

exports.config = {"status":true,"model":{"plazza":"true","released":1404916434,"title-en":"Carerra Chess","module":"chessbase","summary":"Chess on 10x8 (1617)","thumbnail":"carrera-thumb.png","rules":{"en":"carrera-rules.html"},"credits":{"en":"carrera-credits.html"},"gameOptions":{"preventRepeat":true,"uctTransposition":"state","uctIgnoreLoop":false,"levelOptions":{"pieceValueFactor":1,"pieceValueRatioFactor":1,"posValueFactor":0.1,"averageDistKingFactor":-0.01,"castleFactor":0.1,"minorPiecesMovedFactor":0.1,"checkFactor":0.2,"endingKingFreedomFactor":0.01,"endingDistKingFactor":0.05,"distKingCornerFactor":0.1,"distPawnPromo1Factor":0.3,"distPawnPromo2Factor":0.1,"distPawnPromo3Factor":0.05}},"obsolete":false,"js":["base-model.js","grid-geo-model.js","carrera-model.js"],"description":{"en":"carrera-description.html"},"levels":[{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"easy","label":"Easy","maxNodes":1000},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"fast","label":"Fast [1sec]","maxDuration":1,"isDefault":true},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"medium","label":"Medium","maxNodes":10000,"maxDuration":10},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"strong","label":"Strong","maxNodes":20000,"maxDuration":15}]},"view":{"title-en":"Chessbase view","module":"chessbase","xdView":true,"css":["chessbase.css"],"preferredRatio":1,"useShowMoves":true,"useNotation":true,"useAutoComplete":true,"defaultOptions":{"sounds":true,"moves":true,"notation":false,"autocomplete":false},"skins":[{"name":"skin3d","title":"3D Classic","3d":true,"preload":["smoothedfilegeo|0|/res/ring-target.js","image|/res/images/cancel.png","image|/res/images/wikipedia.png","smoothedfilegeo|0|/res/fairy/pawn/pawn.js","image|/res/fairy/pawn/pawn-diffusemap.jpg","image|/res/fairy/pawn/pawn-normalmap.jpg","smoothedfilegeo|0|/res/fairy/knight/knight.js","image|/res/fairy/knight/knight-diffusemap.jpg","image|/res/fairy/knight/knight-normalmap.jpg","smoothedfilegeo|0|/res/fairy/bishop/bishop.js","image|/res/fairy/bishop/bishop-diffusemap.jpg","image|/res/fairy/bishop/bishop-normalmap.jpg","smoothedfilegeo|0|/res/fairy/queen/queen.js","image|/res/fairy/queen/queen-diffusemap.jpg","image|/res/fairy/queen/queen-normalmap.jpg","smoothedfilegeo|0|/res/fairy/king/king.js","image|/res/fairy/king/king-diffusemap.jpg","image|/res/fairy/king/king-normalmap.jpg","smoothedfilegeo|0|/res/fairy/rook/rook.js","image|/res/fairy/rook/rook-diffusemap.jpg","image|/res/fairy/rook/rook-normalmap.jpg","smoothedfilegeo|0|/res/fairy/cardinal/cardinal.js","image|/res/fairy/cardinal/cardinal-diffusemap.jpg","image|/res/fairy/cardinal/cardinal-normalmap.jpg","smoothedfilegeo|0|/res/fairy/marshall/marshall.js","image|/res/fairy/marshall/marshall-diffusemap.jpg","image|/res/fairy/marshall/marshall-normalmap.jpg"],"world":{"lightIntensity":1.3,"skyLightIntensity":1.2,"lightCastShadow":true,"fog":false,"color":4686804,"lightPosition":{"x":-9,"y":9,"z":9},"skyLightPosition":{"x":9,"y":9,"z":9},"lightShadowDarkness":0.55,"ambientLightColor":2236962},"camera":{"fov":45,"distMax":50,"radius":18,"elevationAngle":60,"elevationMin":0}},{"name":"skin2d","title":"2D Classic","3d":false,"preload":["image|/res/images/cancel.png","image|/res/images/whitebg.png","image|/res/fairy/wikipedia-fairy-sprites.png"]}],"animateSelfMoves":false,"switchable":true,"sounds":{"move1":"alq_move1","move2":"alq_move2","move3":"alq_move3","move4":"alq_move2","tac1":"alq_tac1","tac2":"alq_tac2","tac3":"alq_tac1","promo":"promo","usermove":null},"js":["base-view.js","grid-board-view.js","fairy-set-view.js","capablanca-view.js"],"visuals":{"600x600":["res/visuals/carrera-600x600-3d.jpg","res/visuals/carrera-600x600-2d.jpg"]}}}

/***/ }),

/***/ "y6Vm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var repeatWhen_1 = __webpack_require__("8T44");
Observable_1.Observable.prototype.repeatWhen = repeatWhen_1.repeatWhen;
//# sourceMappingURL=repeatWhen.js.map

/***/ }),

/***/ "y6t9":
/***/ (function(module, exports) {

exports.config = {"status":true,"model":{"plazza":"true","title-en":"Four In A Row","module":"fourinarow","js":["fiarbase-model.js"],"summary":"Four In A Row game","thumbnail":"fiar-thumb.png","rules":{"en":"rules.html","fr":"rules-fr.html"},"description":{"en":"description.html","fr":"description-fr.html"},"credits":{"en":"credits.html","fr":"credits-fr.html"},"gameOptions":{"width":7,"height":6,"lines":4,"remove":false,"levelOptions":{"evalTuple1":1,"evalTuple2":2,"evalTuple3":4,"evalTuple4":8,"evalTuple5":16,"evalTuple6":32},"uctTransposition":"state"},"levels":[{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.55,"ignoreLeaf":false,"name":"easy","label":"Easy","maxNodes":1000,"isDefault":true},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.55,"ignoreLeaf":false,"name":"fast","label":"Fast [1sec]","maxDuration":1},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.55,"ignoreLeaf":false,"name":"strong","label":"Strong","maxNodes":10000}]},"view":{"title-en":"Four In A Row View","module":"fourinarow","js":["fiarbase-xd-view.js"],"xdView":true,"css":["fiarbase.css"],"preferredRatio":1,"useShowMoves":false,"useNotation":true,"sounds":{"sound1":"sound1","sound2":"sound2"},"defaultOptions":{"sounds":true,"moves":true,"notation":false},"skins":[{"name":"fiar3d","title":"3D Classic","3d":true,"camera":{"radius":20,"limitCamMoves":true,"rotationAngle":180,"elevationAngle":0,"elevationMin":-89,"elevationMax":89,"distMax":30},"world":{"lightIntensity":0.2,"skyLightIntensity":0.2,"lightCastShadow":false,"fog":true,"color":0,"lightPosition":{"x":10,"y":5,"z":0},"lightShadowDarkness":0.55,"ambientLightColor":2236996},"preload":["map|/res/xd-view/meshes/connect4-red-star.png","map|/res/xd-view/meshes/connect4-red.png","map|/res/xd-view/meshes/connect4-yellow-star.png","map|/res/xd-view/meshes/connect4-yellow.png","smoothedfilegeo|0|/res/xd-view/meshes/connect4cell.js","smoothedfilegeo|0|/res/xd-view/meshes/connect4cell-ring-smoothed.js","smoothedfilegeo|0|/res/xd-view/meshes/connect4-token.js","smoothedfilegeo|0|/res/xd-view/meshes/connect4cell-foot.js"]},{"name":"fiar2d","title":"2D Classic","3d":false,"preload":["image|/res/sprites2d.png"]}],"animateSelfMoves":false,"visuals":{"600x600":["res/visuals/fourinarow-600x600-3d.jpg","res/visuals/fourinarow-600x600-2d.jpg"]}}}

/***/ }),

/***/ "y9a2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var SubscriptionLog_1 = __webpack_require__("fO1r");
var SubscriptionLoggable = (function () {
    function SubscriptionLoggable() {
        this.subscriptions = [];
    }
    SubscriptionLoggable.prototype.logSubscribedFrame = function () {
        this.subscriptions.push(new SubscriptionLog_1.SubscriptionLog(this.scheduler.now()));
        return this.subscriptions.length - 1;
    };
    SubscriptionLoggable.prototype.logUnsubscribedFrame = function (index) {
        var subscriptionLogs = this.subscriptions;
        var oldSubscriptionLog = subscriptionLogs[index];
        subscriptionLogs[index] = new SubscriptionLog_1.SubscriptionLog(oldSubscriptionLog.subscribedFrame, this.scheduler.now());
    };
    return SubscriptionLoggable;
}());
exports.SubscriptionLoggable = SubscriptionLoggable;
//# sourceMappingURL=SubscriptionLoggable.js.map

/***/ }),

/***/ "yCaY":
/***/ (function(module, exports) {

exports.config = {"status":true,"model":{"title-en":"Margo 8","module":"margo","js":["spbase-model.js","margo-model.js"],"summary":"Margo game","thumbnail":"tn-margo8.png","strings":[],"rules":{"en":"rules.html","fr":"rules-fr.html"},"description":{"en":"description.html","fr":"description-fr.html"},"credits":{"en":"credits.html","fr":"credits-fr.html"},"demoRandom":true,"gameOptions":{"preventRepeat":true,"uctTransposition":"states","uctIgnoreLoop":true,"size":8,"levelOptions":{"evalSafety":20,"evalSafety2eyes":20.316545249669,"evalSafetyXEyesBonus":1.7649150399344,"evalSafety1f":10,"evalSafety3f":31.878459454792,"evalSafety3fMore":46.937096046536,"evalSafety3fMoreBonus":1.1493006038375,"evalSafety1eyeBonus":6.0032010946565,"evalSafetyPinnedBonus":0,"evalHeightRatio":1.146771970669,"evalCenterRatio":0.07973781159539}},"plazza":"true","levels":[{"label":"Fast (1sec)","maxDuration":1,"isDefault":true,"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.16486250067757,"ignoreLeaf":false,"uncertaintyFactor":0},{"label":"Beginner","maxDuration":1,"maxNodes":250,"maxLoops":50,"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.16486250067757,"ignoreLeaf":false,"uncertaintyFactor":0},{"label":"Easy","maxDuration":2,"maxNodes":500,"maxLoops":100,"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.16486250067757,"ignoreLeaf":false,"uncertaintyFactor":0},{"label":"Medium","maxDuration":4,"maxNodes":2500,"maxLoops":200,"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.16486250067757,"ignoreLeaf":false,"uncertaintyFactor":0},{"label":"Confirmed","maxDuration":8,"maxNodes":5000,"maxLoops":500,"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.16486250067757,"ignoreLeaf":false,"uncertaintyFactor":0},{"label":"Slow (10sec)","maxDuration":10,"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.16486250067757,"ignoreLeaf":false,"uncertaintyFactor":0}]},"view":{"title-en":"Margo View","module":"margo","js":["spbase-xd-view.js"],"xdView":true,"css":["spbase.css"],"preferredRatio":1,"useNotation":true,"defaultOptions":{"sounds":true,"moves":true,"notation":false},"skins":[{"name":"classic3d","title":"3D Classic","3d":true,"camera":{"radius":20,"elevationAngle":45,"limitCamMoves":true,"distMax":40,"distMin":10,"elevationMin":-45,"elevationMax":89.9,"enableDrag":false},"world":{"lightIntensity":0,"color":0,"fog":false,"skyLightIntensity":0.7,"skyLightPosition":{"x":0,"y":10,"z":0},"ambientLightColor":8947848},"preload":["image|/res/xd-view/meshes/grey.png","image|/res/xd-view/meshes/black.png","image|/res/xd-view/meshes/white.png","image|/res/xd-view/meshes/green.png","image|/res/xd-view/meshes/skybox/nx.jpg","image|/res/xd-view/meshes/skybox/ny.jpg","image|/res/xd-view/meshes/skybox/nz.jpg","image|/res/xd-view/meshes/skybox/px.jpg","image|/res/xd-view/meshes/skybox/py.jpg","image|/res/xd-view/meshes/skybox/pz.jpg"]},{"name":"wood","title":"Wood","preload":["image|/res/images/ball_black.png","image|/res/images/ball_white.png","image|/res/images/ball_green.png","image|/res/images/plot.png","image|/res/images/wood.png"]},{"name":"classical","title":"Classic","preload":["image|/res/images/ball_black.png","image|/res/images/ball_white.png","image|/res/images/ball_green.png","image|/res/images/plot.png"]}],"animateSelfMoves":false,"visuals":{"600x600":["res/visuals/margo8-600x600-3d.jpg","res/visuals/margo8-600x600-2d.jpg"]}}}

/***/ }),

/***/ "yEe/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {var require;var JoclyUCT={};"undefined"==typeof WorkerGlobalScope&&"undefined"==typeof SystemJS?(module.exports.JoclyUCT=JoclyUCT,function(){var e=require,o=__webpack_require__("mzA9");global.MersenneTwister=o.MersenneTwister,global.JocUtil=o.JocUtil}()):(void 0).JoclyUCT=JoclyUCT,function(){function e(e,o){this.visits=1,this.children=null,this.who=o,this.parents=[],e&&this.parents.push(e),this.known=!1,this.evaluation=0,this.staticEvalSum=0,this.staticEvalCount=0,this.depth=e?e.depth+1:0}e.prototype={addParent:function(e){this.parents.push(e),e.depth+1<this.depth&&(this.depth=e.depth+1)}};var o={"-1":-1,1:1,2:0,0:0};JoclyUCT.startMachine=function(t,n){function i(e){var o=D,t=!1,n=0,i=1;if(0==e)return 0;for(e<0&&(e=-e,o=A,t=!0);;){if(e>o.v)n+=i,o.m||(o.m={v:e,l:null,m:null}),o=o.m;else{if(!(e<o.v))break;n-=i,o.l||(o.l={v:e,l:null,m:null}),o=o.l}i/=2}return t&&(n=-n),n}function a(e,o){for(var t=void 0,n=0;n<o.length;n++){var i=o[n];(void 0===t||i.evaluation*i.who>t*i.who)&&(t=i.evaluation)}return t}function l(e,o){for(var t=void 0,n=0;n<o.length;n++){var i=o[n];(void 0===t||i.evaluation*i.who<t*i.who)&&(t=i.evaluation)}return-t}function r(e,o){for(var t=1,n=0;n<o.length;n++){var i=o[n];value1=(i.evaluation+1)/2,1==e.who?t*=1-i.evaluation:t*=i.evaluation}return 1==e.who?2*(1-t)-1:2*t-1}function s(e,o,n){if(!(t.mOptions.uctTransposition&&!t.mOptions.uctIgnoreLoop&&e.sign in n)){var i=[];if(T.ignoreLeaf){for(var s=!1,h=0;h<e.children.length;h++)if(e.children[h].n.children){s=!0;break}if(s)for(var h=0;h<e.children.length;h++){var c=e.children[h].n;(c.known||c.children)&&i.push(c)}}if(0==i.length)for(var h=0;h<e.children.length;h++)i.push(e.children[h].n);var p;switch(T.propagation){case"maximin":p=l(e,i);break;case"minimax2min-avg":var d=l(e,i),m=a(e,i);p=(d+m)/2;break;case"minimax2min-best":var d=l(e,i),m=a(e,i);p=1==e.who?Math.max(d,m):Math.min(d,m);break;case"product":p=GetPropabilityProductEval(e,i);break;case"minimax":case"mixed":default:p=a(e,i),"mixed"==T.propagation&&T.productRatio>0&&(m=r(e,i),p=T.productRatio*m+(1-T.productRatio)*p),T.useDepthWeights&&(p=g(p,e.depth+1))}T.uncertaintyFactor&&(p*=1-Math.pow(10,-T.uncertaintyFactor)*Math.log(e.depth+1)),e.evaluation!==p?(e.evaluation=p,T.directVisits||(e.visits+=o),v(e,o,n)):T.directVisits||u(e,o,n)}}function v(e,o,n){if(0!=e.parents.length){t.mOptions.uctTransposition&&!t.mOptions.uctIgnoreLoop&&(n||(n={}),n[e.sign]=!0);for(var i=0;i<e.parents.length;i++){var a=e.parents[i];T.useAlphaBeta&&a.children.sort(function(o,t){return(t.evaluation-o.evaluation)*e.who}),s(a,o,n)}}}function u(e,o,n){if(0!=e.parents.length){t.mOptions.uctTransposition&&!t.mOptions.uctIgnoreLoop&&(n||(n={}),n[e.sign]=!0);for(var i=0;i<e.parents.length;i++){var a=e.parents[i];a.sign in n||(a.visits+=o,n[a.sign]=!0,u(a,o,n))}}}function h(e,o){if(!(t.mOptions.uctTransposition&&!t.mOptions.uctIgnoreLoop&&e.sign in o)){for(var n=!0,i=0;i<e.children.length;i++){if(0==e.children[i].n.known){n=!1;break}}1==n&&(e.known=!0,c(e,o))}}function c(e,o){if(0!=e.known&&0!=e.parents.length){t.mOptions.uctTransposition&&!t.mOptions.uctIgnoreLoop&&(o||(o={}),o[e.sign]=!0);for(var n=0;n<e.parents.length;n++)h(e.parents[n],o)}}function p(e){for(var o=1,t=0,n=0;n<32;n++){var i=e>>>n&1;t=o?t<<1|i:t<<1|1-i,o=i}return t}function d(){function n(e,n,a){for(var l=null,r=Date.now(),s=0;s<T.playoutDepth||n.mWho==T.playoutCeil*O.who;s++){if(n.mMoves&&0!=n.mMoves.length||n.GenerateMoves(t),n.mFinished){l={finished:!0,winner:o[n.mWinner]};break}for(var v=[],u=0;u<n.mMoves.length;u++){var h=new(t.GetBoardClass())(t);h.CopyFrom(n),h.ApplyMove(t,n.mMoves[u]),t.AddVisit(h),h.mMoves=[],h.Evaluate(t);var c=h.mEvaluation;h.mFinished?c=1==h.mWinner?Number.MAX_VALUE:h.mWinner==-1?-Number.MAX_VALUE:0:isNaN(h.mEvaluation)&&console.error("Evaluation in not a number !"),v.push({move:n.mMoves[u],evaluation:c,board:h}),t.RemoveVisit(h)}v.sort(function(e,o){var t=e.evaluation*n.mWho;return o.evaluation*n.mWho-t});for(var p,d=v.length,g=1/T.playoutSpread,f=(1-Math.pow(g,d+1))/(1-g)-1,w=Math.random()*f,M=void 0,x=0,b=!1,u=0;u<d;u++){var y=v[u],C=y.evaluation;if(C!==M){if(b)break;p=[y],M=C}else p.push(y);x+=Math.pow(g,u+1),x>=w&&(b=!0)}var V=p[Math.floor(Math.random()*p.length)];if(n=V.board,t.AddVisit(n),a.push(n.GetSignature()),n.mWho=-n.mWho,n.mFinished){l={finished:!0,winner:o[n.mWinner]};break}}null===l&&(l={finished:!1,eval:n.mEvaluation}),k+=Date.now()-r,E++;var B;if(l.finished)B=l.winner;else{T.debugRawEval&&(e.rawEval=l.eval);var D=i(l.eval);m(D,e.depth),B=D}return B}x++;var a=new(t.GetBoardClass())(t);a.CopyFrom(t.mBoard);for(var l=0,r=O,s=0,u=0,h=[],d=[],g=x,f={},w=-2,D=2;;){if(d.push(r),s>u&&(u=s),null===r.children)break;var A;if(T.useAlphaBeta){A=[];for(var L=0;L<r.children.length;L++){var S=r.children[L],W=S.n;if(A.push(S),1==W.who&&W.evaluation>w&&(w=W.evaluation),W.who==-1&&W.evaluation<D&&(D=W.evaluation),D<w){C+=r.children.length-1-L;break}}}else A=r.children;if(t.mOptions.uctTransposition&&!t.mOptions.uctIgnoreLoop){for(var N=[],L=0;L<A.length;L++)A[L].n.sign in f||N.push(A[L]);A=N}var R,U,G=[];if(U=T.directVisits?Math.log(g):Math.log(r.visits),T.distributeEval?function(){for(var e={},o=[],t=0;t<A.length;t++){var n=A[t],i=n.n;if(!i.known){var a=(i.evaluation*i.who+1)/2;void 0===e[a]&&(e[a]=[],o.push(a)),e[a].push(n)}}o.sort(function(e,o){return e-o});for(var l=1/(o.length+1),r=0,s=0;s<o.length;s++){r++;for(var v=o[s],u=e[v],h=l*r,t=0;t<u.length;t++){var c,n=u[t],i=n.n;c=T.directVisits?h+T.c*Math.sqrt(U/n.f):h+T.c*Math.sqrt(U/i.visits),(0==G.length||c>=R)&&(G.length>0&&c>R&&(G=[]),R=c,G.push(n))}}}():function(){for(var e=0;e<A.length;e++){var o=A[e],t=o.n;if(!t.known){var n,i=(t.evaluation*t.who+1)/2;n=T.directVisits?i+T.c*Math.sqrt(U/o.f):i+T.c*Math.sqrt(U/t.visits),(0==G.length||n>=R)&&(G.length>0&&n>R&&(G=[]),R=n,G.push(o))}}}(),0==G.length)return;var F=G[Math.floor(Math.random()*G.length)];T.directVisits&&(F.f++,g=F.f),r=F.n,t.mOptions.uctTransposition&&!t.mOptions.uctIgnoreLoop&&(f[r.sign]=1),s++,h.push(F.m),a.ApplyMove(t,F.m),t.AddVisit(a),a.mMoves=[],M.push(a.GetSignature()),"states"==t.mOptions.uctTransposition&&(l^=p(a.GetSignature())),a.mWho=-a.mWho}if(r==O||r.visits>=T.minVisitsExpand)if(a.mMoves&&0!=a.mMoves.length||a.GenerateMoves(t),a.mFinished)r.known=!0,r.evaluation=o[a.mWinner],c(r);else{r.children=[];for(var J=void 0,I=!0,L=0;L<a.mMoves.length;L++){var P=a.mMoves[L],q=[],X=new(t.GetBoardClass())(t);X.CopyFrom(a),X.ApplyMove(t,P),t.AddVisit(X),X.mMoves=[],X.mWho=-X.mWho,s>V&&(V=s);var _=X.GetSignature();q.push(_);var j;"states"==t.mOptions.uctTransposition?(j=l^_,j^=s):"state"==t.mOptions.uctTransposition&&(j=_);var W=null;t.mOptions.uctTransposition&&(W=B[j]),W?(y++,W.addParent(r)):(W=new e(r,-r.who),b++,t.mOptions.uctTransposition&&(B[j]=W,W.sign=j),X.Evaluate(t),X.mFinished?(W.known=!0,W.evaluation=o[X.mWinner]):(isNaN(X.mEvaluation)&&console.error("Evaluation in not a number !",X.mEvaluation),W.evaluation=n(W,X,q)),W.staticEvalSum=W.evaluation,W.staticEvalCount=1),0==W.known&&(I=!1);var z={n:W,m:new(t.GetMoveClass())(P).Strip()};T.directVisits&&(z.f=1),r.children.push(z);var H=W.evaluation*W.who;(void 0===J||H>J*W.who)&&(J=W.evaluation);for(var K=0;K<q.length;K++)t.RemoveVisit(null,q[K])}if(r.evaluation=J,v(r,T.propagateMultiVisits?a.mMoves.length:1),T.directVisits)for(var L=0;L<d.length;L++)d[L].visits+=T.propagateMultiVisits?a.mMoves.length:1;I&&(r.known=!0,c(r))}else if(!r.known){var Q=n(r,a,M);if(r.staticEvalSum+=Q,r.staticEvalCount++,r.evaluation=r.staticEvalSum/r.staticEvalCount,v(r,1),T.directVisits)for(var L=0;L<d.length;L++)d[L].visits++}}function m(e,o){for(;L.length<=o;)L.push({count:0,sum:0});var t=L[o];t.sum+=e,t.count++}function g(e,o){var t=L[o];if(void 0===t){for(;L.length<o;)L.push({count:0,sum:0});return L.push({count:1,sum:e}),e}var n=t.count>0?t.sum/t.count:0;return e>n?e=(e-n)/(1-n):e<n&&(e=-(n-e)/(n+1)),e}function f(){if(t.mAborted)return void t.mAbortCallback.call(t);var e=Date.now(),o=0;if(T.maxDuration>0&&(o=Math.round(100*(e-S)/(1e3*T.maxDuration))),T.maxLoops>0&&(o=Math.max(o,100*x/T.maxLoops)),T.maxNodes>0&&(o=Math.max(o,100*b/T.maxNodes)),o=Math.min(100,o),o!=W&&(W=o,t.mProgressCallback&&t.mProgressCallback(o)),!O.children||0==O.known&&(T.maxDuration<=0||e<1e3*T.maxDuration+S)&&(T.maxLoops<=0||x<T.maxLoops)&&(T.maxNodes<=0||b<T.maxNodes)){do{M=[];try{d()}catch(e){console.error("UCT step",e)}for(var n=0;n<M.length;n++)t.RemoveVisit(null,M[n])}while(Date.now()-100<e);setTimeout(f,0)}else{T.log&&w(O);var i=void 0;if(t.mBestMoves=[],"maxvisits"==T.pickMove&&T.directVisits){for(var n=0;n<O.children.length;n++){var a=O.children[n],l=a.n;l.evaluation==l.who&&t.mBestMoves.push(a.m)}if(0==t.mBestMoves.length)for(var n=0;n<O.children.length;n++){var a=O.children[n];(void 0===i||i<=a.f)&&((void 0===i||i<a.f)&&(t.mBestMoves=[]),i=a.f,t.mBestMoves.push(a.m))}}else{var r=void 0,s=[];"besteval-multivisits"==T.pickMove&&O.children.forEach(function(e){(e.n.visits>1||1==e.n.known)&&s.push(e)}),0==s.length&&(s=O.children);for(var n=0;n<s.length;n++){var a=s[n],l=a.n,v=l.staticEvalSum/l.staticEvalCount;(void 0===i||i>=l.evaluation*O.who)&&((void 0===i||i>l.evaluation*O.who||i==l.evaluation*O.who&&(void 0===r||r>O.who*v))&&(r=v,t.mBestMoves=[]),i=l.evaluation*O.who,t.mBestMoves.push(a.m))}}JocUtil.schedule(t,"Done",{})}}function w(e){function o(e,n){if("minimax"!=T.propagation&&("mixed"!=T.propagation||T.productRatio>0))return void console.warn("Cannot display minimax tree on propagation",T.propagation,"pp ratio",T.productRatio);for(var i="",a=0;a<n;a++)i+="  ";console.log(i+"*",n,"*",-e.who,"eval",e.evaluation);for(var a=0;a<e.children.length;a++){var l=e.children[a],r=l.n;console.log(i,"  "+(r.evaluation==e.evaluation?"*":" ")+" move",new(t.GetMoveClass())(l.m).ToString(),"visits",r.visits,"eval",r.evaluation,"known",r.known,"sev",r.staticEvalSum+"/"+r.staticEvalCount,"who",r.who,"children",r.children?r.children.length:"no"),r.children&&r.evaluation==e.evaluation&&o(r,n+1)}}if(console.log("  duration",Date.now()-S),console.log("  evaluation:",e.evaluation),console.log("  fully explored:",e.known),console.log("  node count:",b),console.log("  redundant node count:",y),console.log("  max depth:",V),console.log("  alpha-beta",T.useAlphaBeta,"skipped",C),console.log(" ",x,"steps, per step",(Date.now()-S)/x,"ms"),console.log(" ",E,"playouts",k,"ms, per playout",k/E,"ms"),console.log("  UCT c",T.c),console.log("  tree",O),T.showMinimaxTree&&(console.log("Minimax tree"),o(e,0)),T.checkSide){var n=0,i=0;!function e(o){if(n++,o.children)for(var t=0;t<o.children.length;t++){var a=o.children[t];a.n.who!=-o.who&&i++,e(a.n)}}(O),console.log("  tree side alternance","node",n,"errors",i)}}var M,x=0,b=0,y=0,k=0,E=0,C=0,V=0,T={minVisitsExpand:n.level.minVisitsExpand||1,playoutSpread:n.level.playoutSpread||2,playoutDepth:void 0!==n.level.playoutDepth?n.level.playoutDepth:0,c:void 0!==n.level.c?n.level.c:.3,playoutCeil:void 0!==n.level.playoutCeil?n.level.playoutCeil:0,log:!!n.level.log,maxDuration:void 0!==n.level.maxDuration?n.level.maxDuration:2,maxLoops:void 0!==n.level.maxLoops?n.level.maxLoops:0,maxNodes:void 0!==n.level.maxNodes?n.level.maxNodes:0,showMinimaxTree:!!n.level.showMinimaxTree,showBestLine:!!n.level.showBestLine,ignoreLeaf:void 0!==n.level.ignoreLeaf&&n.level.ignoreLeaf,propagateMultiVisits:void 0===n.level.propagateMultiVisits||n.level.propagateMultiVisits,propagation:void 0===n.level.propagation?"mixed":n.level.propagation,useDepthWeights:void 0!==n.level.useDepthWeights&&n.level.useDepthWeights,productRatio:void 0===n.level.productRatio?0:n.level.productRatio,useAlphaBeta:void 0!==n.level.useAlphaBeta&&n.level.useAlphaBeta,uncertaintyFactor:void 0===n.level.uncertaintyFactor?0:n.level.uncertaintyFactor,directVisits:void 0===n.level.directVisits||n.level.directVisits,distributeEval:void 0===n.level.distributeEval||n.level.distributeEval,pickMove:void 0===n.level.pickMove?"besteval":n.level.pickMove,debugRawEval:void 0!==n.level.debugRawEval&&n.level.debugRawEval},B={};T.log&&console.log("Running UCT AI - ",n.level.label,"- Player",1==t.mWho?"A":"B");var D={v:0,l:null,m:{v:Number.MAX_VALUE,l:null,m:null}},A=JSON.parse(JSON.stringify(D)),L=[];if(t.mBoard.mMoves&&0!=t.mBoard.mMoves.length||t.mBoard.GenerateMoves(t),1==t.mBoard.mMoves.length)return t.mBestMoves=[t.mBoard.mMoves[0]],void JocUtil.schedule(t,"Done",{});0==t.mBoard.mMoves.length&&console.error("No move available",t);var O=new e(null,-t.mWho);b++,t.mOptions.uctTransposition&&(B[t.mBoard.GetSignature()]=O);var S=Date.now(),W=-1;f()}}();
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("DuR2")))

/***/ }),

/***/ "yL5Q":
/***/ (function(module, exports) {

exports.model=Model={Game:{},Board:{},Move:{}},function(){function t(t){if(o){var e=t%s;return(t-e)/s*s+s-e}var r=s*i-t-1,n=r%s;return r-n+s-n}var s,i,o=!1;Model.Game.checkersPosToString=t,Model.Game.InitGameInfo=function(){},Model.Game.BuildGraphCoord=function(){var t=(this.mOptions.width,this.mOptions.height,[]),s=[];this.g.Graph=t,this.g.Coord=s},Model.Game.InitGame=function(){var t=this.mOptions.width,e=this.mOptions.height;if(s=t,i=e,o=this.mOptions.invertNotation||!1,this.g.compulsoryCatch=!0,this.g.canStepBack=!0,this.g.mustMoveForward=!1,this.g.mustMoveForwardStrict=!1,this.g.lastRowFreeze=!1,this.g.lastRowCrown=!1,this.g.captureLongestLine=!1,this.g.noMove="lose",this.g.kingCaptureShort=!1,this.g.kingValue=5,this.g.lastRowFactor=0,this.g.canCaptureBackward=!0,this.g.captureInstantRemove=!1,this.g.longRangeKing=!0,this.g.drawKvsK=!0,this.g.drawKvs2K=!0,this.g.whiteStarts=!0,this.g.king180deg=!1,this.mOptions.variant)for(var r in this.mOptions.variant)this.mOptions.variant.hasOwnProperty(r)&&(this.g[r]=this.mOptions.variant[r]);this.BuildGraphCoord(),this.zobrist=new JocGame.Zobrist({board:{type:"array",size:this.g.Graph.length,values:["1/0","1/1","-1/0","-1/1"]}})},Model.Game.DestroyGame=function(){},Model.Game.CheckersDirections=4,Model.Game.Checkers2WaysDirections=[0,1,1,0],Model.Game.CheckersEachDirection=function(t,s){for(var i=0;i<this.CheckersDirections;i++){var o=this.g.Graph[t][i];if(null!=o&&0==s(o,i))return}},Model.Move.Init=function(t){this.pos=[];for(var s=t.pos?Object.keys(t.pos).sort():[],i=0;i<s.length;i++)this.pos.push(t.pos[i]);this.capt=[];for(var o=t.capt?Object.keys(t.capt).sort():[],i=0;i<o.length;i++)this.capt.push(t.capt[i])},Model.Move.ToString=function(s){s=s||"natural";var i=this;switch(s){case"natural":return function(){for(var s=[t(i.pos[0]),t(i.pos[i.pos.length-1])],o="-",e=1;e<i.capt.length;e++)null!=i.capt[e]&&(o="x",i.capt.length>3&&s.push(t(i.capt[e])));return s.join(o)}();case"hub":return function(){var s="-",o=[t(i.pos[0]),t(i.pos[i.pos.length-1])];if(i.capt[1]){s="x";var e=i.capt.slice(1).map(function(s){return t(s)});e.sort(),o=o.concat(e)}return o.join(s)}();case"dxp":return function(){var s=[t(i.pos[0]),t(i.pos[i.pos.length-1])];if(i.capt[1]){s.push(i.capt.length-1);for(var o=[],e=1;e<i.capt.length;e++)o.push(t(i.capt[e]));o.sort(),s=s.concat(o)}else s.push(0);return s.map(function(t){return t<10?"0"+t:t}).join("")}();default:return"??"}},Model.Board.Init=function(t){this.zSign=0},Model.Board.InitialPosition=function(t){var s=t.mOptions.width,i=t.mOptions.height,o=t.mOptions.initial;this.board=[];for(var e=0;e<i;e++)for(var r=0;r<s;r++)this.board[e*s+r]=-1;this.pieces=[];var n=0;if(t.mInitial){this.pCount=[0,0],this.spCount=[0,0],this.kpCount=[0,0];for(var a=0;a<t.mInitial.pieces.length;a++){var h=t.mInitial.pieces[a];this.board[h.p]=a,this.pieces.push({s:h.s,p:h.p,l:-1,t:h.t,plp:h.p}),this.zSign=t.zobrist.update(this.zSign,"board",h.s+"/"+h.t,h.p);var p=-(h.s-1)/2;this.pCount[p]++,0==h.t?this.spCount[p]++:this.kpCount[p]++}}else{for(var a in o.a)if(o.a.hasOwnProperty(a)){var u=o.a[a],c=u[0]*s+u[1],h={s:JocGame.PLAYER_A,p:c,l:-1,t:0,plp:c};this.pieces.push(h),this.board[c]=n++,this.zSign=t.zobrist.update(this.zSign,"board","1/0",c)}for(var a in o.b)if(o.b.hasOwnProperty(a)){var u=o.b[a],c=u[0]*s+u[1],h={s:JocGame.PLAYER_B,p:c,l:-1,t:0,plp:c};this.pieces.push(h),this.board[c]=n++,this.zSign=t.zobrist.update(this.zSign,"board","-1/0",c)}this.pCount=[o.a.length,o.b.length],this.spCount=[o.a.length,o.b.length],this.kpCount=[o.a.length,o.b.length]}},Model.Board.GenerateMoves=function(t){try{this._GenerateMoves(t)}catch(t){}},Model.Board._GenerateMoves=function(t){function s(t){for(var s=0;s<e.pieces.length;s++){var i=e.pieces[s];i&&i.s==e.mWho&&t(s,i.p)}}function i(s,o,r,n,a){for(;;){var h=[],p=[],u=[];if(t.CheckersEachDirection(s,function(i,c){var l;0==t.g.canCaptureBackward&&(l=t.g.Coord[s][0]);var g=t.Checkers2WaysDirections[c];if(a){if(t.g.longRangeKing)for(;e.board[i]==-1||t.g.king180deg&&null!=i&&r.indexOf(i)>=0;)i=t.g.Graph[i][c];if(null!=i&&e.board[i]>=0&&e.pieces[e.board[i]].s==-e.mWho){var v=i;if(i=t.g.Graph[i][c],t.g.kingCaptureShort){if(e.board[i]==-1||i==o[0]){for(var f=!0,d=0;d<n.length;d++)if(t.g.king180deg){if(r[d]==v){f=!1;break}}else if(t.g.captureInstantRemove&&r[d]==v||0==t.g.captureInstantRemove&&r[d]==v&&n[d]==g){f=!1;break}f&&(h.push(i),p.push(v),u.push(g)),i=t.g.Graph[i][c]}}else for(;e.board[i]==-1||i==o[0];){for(var f=!0,d=0;d<n.length;d++)if(t.g.captureInstantRemove&&r[d]==v||0==t.g.captureInstantRemove&&r[d]==v&&n[d]==g){f=!1;break}f&&(h.push(i),p.push(v),u.push(g)),i=t.g.Graph[i][c]}}}else if(e.board[i]>=0&&e.pieces[e.board[i]].s==-e.mWho){var m,C;if(0==t.g.canCaptureBackward&&(m=t.g.Coord[i][0],C=!1,(e.mWho==JocGame.PLAYER_A&&m>=l||e.mWho==JocGame.PLAYER_B&&m<=l)&&(C=!0)),t.g.canCaptureBackward||1==C){var b=t.g.Graph[i][c];if(null!=b&&(e.board[b]==-1||b==o[0])){for(var f=!0,d=0;d<n.length;d++)if(t.g.captureInstantRemove&&r[d]==i||0==t.g.captureInstantRemove&&r[d]==i&&n[d]==g){f=!1;break}f&&(h.push(b),p.push(i),u.push(g))}}}return!0}),0==h.length){o.length>1&&e.mMoves.push({pos:o,capt:r});break}if(!t.g.compulsoryCatch&&o.length>1){for(var c=[],l=0;l<o.length;l++)c.push(o[l]);for(var g=[],l=0;l<r.length;l++)g.push(r[l]);e.mMoves.push({pos:c,capt:g})}if(1!=h.length){for(var l=0;l<h.length;l++){for(var c=[],v=0;v<o.length;v++)c.push(o[v]);c.push(h[l]);for(var g=[],v=0;v<r.length;v++)g.push(r[v]);g.push(p[l]);for(var f=[],v=0;v<n.length;v++)f.push(n[v]);f.push(u[l]),i(h[l],c,g,f,a)}break}s=h[0],o.push(s),r.push(p[0]),n.push(u[0])}}var o=t.mOptions.height,e=this;if(this.mMoves=[],s(function(t,s){0==e.pieces[t].t?i(s,[s],[null],[null],!1):1==e.pieces[t].t&&i(s,[s],[null],[null],!0)}),0!=t.g.compulsoryCatch&&0!=this.mMoves.length||s(function(s,i){var r;0==e.pieces[s].t?((t.g.mustMoveForward||t.g.mustMoveForwardStrict||t.lastRowFreeze)&&(r=t.g.Coord[i][0]),t.CheckersEachDirection(i,function(n,a){var h,p,u;return t.g.mustMoveForwardStrict?(h=t.g.Coord[n][0],p=!1,(e.mWho==JocGame.PLAYER_A&&h>r||e.mWho==JocGame.PLAYER_B&&h<r)&&(p=!0)):t.g.mustMoveForward&&(h=t.g.Coord[n][0],p=!0,(e.mWho==JocGame.PLAYER_A&&h<r||e.mWho==JocGame.PLAYER_B&&h>r)&&(p=!1)),t.g.lastRowFreeze&&(u=!1,(e.mWho==JocGame.PLAYER_A&&r==o-1||e.mWho==JocGame.PLAYER_B&&0==r)&&(u=!0)),e.board[n]!=-1||!t.g.canStepBack&&n==e.pieces[s].l||(0!=t.g.mustMoveForward||0!=t.g.mustMoveForwardStrict)&&1!=p||0!=t.g.lastRowFreeze&&0!=u||e.mMoves.push({pos:[i,n],capt:[null,null]}),!0})):1==e.pieces[s].t&&t.CheckersEachDirection(i,function(s,o){if(t.g.longRangeKing)for(;e.board[s]==-1;)e.mMoves.push({pos:[i,s],capt:[null,null]}),s=t.g.Graph[s][o];else e.board[s]==-1&&(e.mMoves.push({pos:[i,s],capt:[null,null]}),s=t.g.Graph[s][o]);return!0})}),0==this.mMoves.length)switch(t.g.noMove){case"count":this.mFinished=!0,this.pCount[0]<this.pCount[1]?this.mWinner=JocGame.PLAYER_B:this.pCount[1]<this.pCount[0]?this.mWinner=JocGame.PLAYER_A:this.mWinner=JocGame.DRAW;break;case"lose":this.mFinished=!0,this.mWinner=-this.mWho;break;default:this.mFinished=!0,this.mWinner=JocGame.DRAW}if(t.g.captureLongestLine){for(var r=this.mMoves,n=[],a=0,h=0;h<r.length;h++){var p=r[h];p.pos.length==a?n.push(p):p.pos.length>a&&(n=[p],a=p.pos.length)}this.mMoves=n}},Model.Board.Evaluate=function(t,s,i){if(t.mOptions.preventRepeat&&t.GetRepeatOccurence(this)>2)return this.mFinished=!0,void(this.mWinner=JocGame.DRAW);if(t.g.drawKvsK&&0==this.spCount[0]&&0==this.spCount[1]&&1==this.kpCount[0]&&1==this.kpCount[1])return this.mFinished=!0,void(this.mWinner=JocGame.DRAW);if(t.g.drawKvs2K&&0==this.spCount[0]&&0==this.spCount[1]&&this.kpCount[0]+this.kpCount[1]==3&&(1==this.kpCount[0]||2==this.kpCount[0]))return this.mFinished=!0,void(this.mWinner=JocGame.DRAW);if(0==this.pCount[1])return this.mFinished=!0,void(this.mWinner=JocGame.PLAYER_A);if(0==this.pCount[0])return this.mFinished=!0,void(this.mWinner=JocGame.PLAYER_B);if(this.mEvaluation=10*(this.spCount[0]-this.spCount[1])+10*(this.kpCount[0]-this.kpCount[1])*t.g.kingValue+this.pCount[0]/this.pCount[1]-this.pCount[1]/this.pCount[0],0!=t.g.lastRowFactor){for(var o=t.mOptions.height,e=0,r=0,n=0;n<this.pieces.length;n++){var a=this.pieces[n];a&&0==a.t&&(this.mWho==JocGame.PLAYER_A?e+=t.g.Coord[a.p][0]:r+=o-1-t.g.Coord[a.p][0])}this.mEvaluation+=(e-r)*t.g.lastRowFactor}},Model.Board.CopyFrom=function(t){this.board=[];for(var s=0;s<t.board.length;s++)this.board[s]=t.board[s];this.pieces=[];for(var s=0;s<t.pieces.length;s++){var i=t.pieces[s];this.pieces[s]=null==i?null:{s:i.s,p:i.p,l:i.l,t:i.t,plp:i.plp}}this.pCount=[t.pCount[0],t.pCount[1]],this.spCount=[t.spCount[0],t.spCount[1]],this.kpCount=[t.kpCount[0],t.kpCount[1]],this.mWho=t.mWho,this.zSign=t.zSign},Model.Board.ApplyMove=function(t,s){var i=(t.mOptions.width,t.mOptions.height),o=s.pos[0],e=this.board[o],r=this.pieces[e],n=r.s;r.l=o;var a={};this.zSign=t.zobrist.update(this.zSign,"board",r.s+"/"+r.t,r.p);for(var h=1;h<s.pos.length;h++){var p=s.pos[h];this.board[r.p]=-1,r.p=p,this.board[p]=e;var u=s.capt[h];null!=u&&(this.board[u]>=0&&(a[this.board[u]]=!0),this.board[u]=-1),o=p}this.zSign=t.zobrist.update(this.zSign,"board",r.s+"/"+r.t,p);var c=s.capt[s.capt.length-1];r.plp=c||s.pos[s.pos.length-2];for(var l in a)if(a.hasOwnProperty(l)){var g=this.pieces[l],v=(1-g.s)/2;switch(this.pCount[v]--,g.t){case 0:this.spCount[v]--;break;case 1:this.kpCount[v]--}this.zSign=t.zobrist.update(this.zSign,"board",g.s+"/"+g.t,g.p),this.pieces[l]=null}if(t.g.lastRowCrown&&0==this.pieces[e].t){var f=t.g.Coord[s.pos[s.pos.length-1]][0];if(n==JocGame.PLAYER_A&&f==i-1||n==JocGame.PLAYER_B&&0==f){var g=this.pieces[e];g.t=1;var d=(1-n)/2;this.spCount[d]--,this.kpCount[d]++,this.zSign=t.zobrist.update(this.zSign,"board",g.s+"/0",g.p),this.zSign=t.zobrist.update(this.zSign,"board",g.s+"/1",g.p)}}},Model.Board.IsValidMove=function(t,s){return!0},Model.Board.GetSignature=function(){return this.zSign},Model.Game.Import=function(t,s){function i(t,s,i){i=r-i;var o=i%n;i=i-o+n-o-1,e.push({s:t,p:i,l:-1,t:s,plp:i})}var o=1,e=[],r=this.mOptions.width*this.mOptions.height,n=this.mOptions.width;if("pjn"==t){var a=s.split(":");o="W"==a[0]?1:-1;for(var h=1;h<a.length;h++)if(0!=a[h].length)for(var p="W"==a[h].substr(0,1)?1:-1,u=a[h].substr(1).split(","),c=0;c<u.length;c++){var l=u[c],g=0;"K"==l.substr(0,1)&&(g=1,l=l.substr(1));var v=/^([0-9]+)-([0-9]+)$/.exec(l);if(v)for(var f=parseInt(v[1]);f<=parseInt(v[2]);f++)i(p,g,f);else i(p,g,parseInt(l))}return e.sort(function(t,s){return s.s-t.s}),{status:!0,initial:{pieces:e,turn:o}}}return{status:!1,error:"unsupported"}};var e=JocGame.prototype.GetBestMatchingMove;Model.Game.GetBestMatchingMove=function(t,s){var i=[],o=this;s.forEach(function(t){"function"==typeof t.ToString?i.push(t.ToString()):i.push(o.CreateMove(t).ToString())}),t=t.replace(/0([1-9])/g,"$1");var r=/^([0-9]+)[\-x]([0-9]+)([\-x][0-9]+)*$/.exec(t);if(r){var n=new RegExp("^"+r[1]+"[-x]"+r[2]+"([-x][0-9]+)*$"),a={};s.forEach(function(t,s){if(n.test(i[s])){var o=i[s],e=/^([0-9]+)x([0-9]+)x([0-9]+(x[0-9]+)*)/.exec(o);if(e){var r=e[3].split("x");r.sort(function(t,s){return parseInt(t)-parseInt(s)}),o=e[1]+"x"+e[2]+"x"+r.join("x")}a[o]=t}});var h=[];for(var p in a)a.hasOwnProperty(p)&&h.push(a[p]);h.length>0&&(s=h)}return e.call(this,t,s)},Model.Board.ExportBoardState=function(o,e){function r(t){for(var o=[],e=0;e<n.board.length;e++){var r=e%s,a=(e-r)/s,h=(i-a-1)*s+r,p=n.board[e];if(p<0)o[h]="e";else{var u=n.pieces[p],c=1==u.s?"w":t;1==u.t&&(c=c.toUpperCase()),o[h]=c}}return o.join("")}e=e||"natural";var n=this;switch(e){case"natural":case"fen":return function(){var s={},i=[];n.pieces.forEach(function(i){if(i&&null!=i.p){var o=1==i.s?"W":"B";void 0===s[o]&&(s[o]={});var e=1==i.t?"K":"";void 0===s[o][e]&&(s[o][e]={group:0==i.t,pos:[]}),s[o][e].pos.push(parseInt(t(i.p)))}});for(var o in s)if(s.hasOwnProperty(o)){var e=[];for(var r in s[o])if(s[o].hasOwnProperty(r)){var a=s[o][r];if(a.group){a.pos.sort(function(t,s){return parseInt(t)-parseInt(s)});var h=-2,p=-1,u=-1;a.pos.forEach(function(t){parseInt(t)==h+1?p=t:(p>=0?(e.push(r+u+"-"+p),p=-1):u>=0&&e.push(r+u),u=t),h=parseInt(t)}),p>=0?e.push(r+u+"-"+p):u>=0&&e.push(r+u)}else a.pos.forEach(function(t){e.push(r+t)})}i.push(o+e.join(","))}return i.join(":")}();case"dxp":return function(){return r("z")}();case"hub":return function(){return r("z")}();default:return JSON.stringify(this)}}}(),Model.Game.BuildGraphCoord=function(){for(var t=this.mOptions.width,s=this.mOptions.height,i=[],o=[],e=0;e<s;e++)for(var r=0;r<t;r++){var n=e*t+r;o[n]=[e,r],i[n]=[],e%2==0?(e<s-1?(i[n].push((e+1)*t+r),r>0?i[n].push((e+1)*t+r-1):i[n].push(null)):(i[n].push(null),i[n].push(null)),e>0?(i[n].push((e-1)*t+r),r>0?i[n].push((e-1)*t+r-1):i[n].push(null)):(i[n].push(null),i[n].push(null))):(e<s-1?(r<t-1?i[n].push((e+1)*t+r+1):i[n].push(null),i[n].push((e+1)*t+r)):(i[n].push(null),i[n].push(null)),e>0?(r<t-1?i[n].push((e-1)*t+r+1):i[n].push(null),i[n].push((e-1)*t+r)):(i[n].push(null),i[n].push(null)))}this.g.Graph=i,this.g.Coord=o};

/***/ }),

/***/ "yM2P":
/***/ (function(module, exports) {

exports.config = {"status":true,"model":{"plazza":"true","released":1404985842,"title-en":"Grand Chess","module":"chessbase","summary":"Chess on 10x10 (1984)","thumbnail":"grand-thumb.png","rules":{"en":"grand-rules.html"},"credits":{"en":"grand-credits.html"},"gameOptions":{"preventRepeat":true,"uctTransposition":"state","uctIgnoreLoop":false,"levelOptions":{"pieceValueFactor":1,"pieceValueRatioFactor":1,"posValueFactor":0.1,"averageDistKingFactor":-0.01,"castleFactor":0.1,"minorPiecesMovedFactor":0.1,"checkFactor":0.2,"endingKingFreedomFactor":0.01,"endingDistKingFactor":0.05,"distKingCornerFactor":0.1,"distPawnPromo1Factor":0.3,"distPawnPromo2Factor":0.1,"distPawnPromo3Factor":0.05}},"obsolete":false,"js":["base-model.js","grid-geo-model.js","grand-model.js"],"description":{"en":"grand-description.html"},"levels":[{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"easy","label":"Easy","maxNodes":1000},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"fast","label":"Fast [1sec]","maxDuration":1,"isDefault":true},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"medium","label":"Medium","maxNodes":10000,"maxDuration":10},{"ai":"uct","playoutDepth":0,"minVisitsExpand":1,"c":0.6,"ignoreLeaf":false,"uncertaintyFactor":3,"name":"strong","label":"Strong","maxNodes":20000,"maxDuration":15}]},"view":{"title-en":"Chessbase view","module":"chessbase","xdView":true,"css":["chessbase.css"],"preferredRatio":1,"useShowMoves":true,"useNotation":true,"useAutoComplete":true,"defaultOptions":{"sounds":true,"moves":true,"notation":false,"autocomplete":false},"skins":[{"name":"skin3d","title":"3D Classic","3d":true,"preload":["smoothedfilegeo|0|/res/ring-target.js","image|/res/images/cancel.png","image|/res/images/wikipedia.png","smoothedfilegeo|0|/res/fairy/pawn/pawn.js","image|/res/fairy/pawn/pawn-diffusemap.jpg","image|/res/fairy/pawn/pawn-normalmap.jpg","smoothedfilegeo|0|/res/fairy/knight/knight.js","image|/res/fairy/knight/knight-diffusemap.jpg","image|/res/fairy/knight/knight-normalmap.jpg","smoothedfilegeo|0|/res/fairy/bishop/bishop.js","image|/res/fairy/bishop/bishop-diffusemap.jpg","image|/res/fairy/bishop/bishop-normalmap.jpg","smoothedfilegeo|0|/res/fairy/queen/queen.js","image|/res/fairy/queen/queen-diffusemap.jpg","image|/res/fairy/queen/queen-normalmap.jpg","smoothedfilegeo|0|/res/fairy/king/king.js","image|/res/fairy/king/king-diffusemap.jpg","image|/res/fairy/king/king-normalmap.jpg","smoothedfilegeo|0|/res/fairy/rook/rook.js","image|/res/fairy/rook/rook-diffusemap.jpg","image|/res/fairy/rook/rook-normalmap.jpg","smoothedfilegeo|0|/res/fairy/cardinal/cardinal.js","image|/res/fairy/cardinal/cardinal-diffusemap.jpg","image|/res/fairy/cardinal/cardinal-normalmap.jpg","smoothedfilegeo|0|/res/fairy/marshall/marshall.js","image|/res/fairy/marshall/marshall-diffusemap.jpg","image|/res/fairy/marshall/marshall-normalmap.jpg"],"world":{"lightIntensity":1.3,"skyLightIntensity":1.2,"lightCastShadow":true,"fog":false,"color":4686804,"lightPosition":{"x":-9,"y":9,"z":9},"skyLightPosition":{"x":9,"y":9,"z":9},"lightShadowDarkness":0.55,"ambientLightColor":2236962},"camera":{"fov":45,"distMax":50,"radius":18,"elevationAngle":60,"elevationMin":0}},{"name":"skin2d","title":"2D Classic","3d":false,"preload":["image|/res/images/cancel.png","image|/res/images/whitebg.png","image|/res/fairy/wikipedia-fairy-sprites.png"]}],"animateSelfMoves":false,"switchable":true,"sounds":{"move1":"alq_move1","move2":"alq_move2","move3":"alq_move3","move4":"alq_move2","tac1":"alq_tac1","tac2":"alq_tac2","tac3":"alq_tac1","promo":"promo","usermove":null},"js":["base-view.js","grid-board-view.js","fairy-set-view.js","grand-view.js"],"visuals":{"600x600":["res/visuals/grand-600x600-3d.jpg","res/visuals/grand-600x600-2d.jpg"]}}}

/***/ }),

/***/ "yZjU":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subject_1 = __webpack_require__("EEr4");
var Subscription_1 = __webpack_require__("B00U");
var tryCatch_1 = __webpack_require__("+3eL");
var errorObject_1 = __webpack_require__("WhVc");
var OuterSubscriber_1 = __webpack_require__("wAkD");
var subscribeToResult_1 = __webpack_require__("CURp");
/**
 * Branch out the source Observable values as a nested Observable starting from
 * an emission from `openings` and ending when the output of `closingSelector`
 * emits.
 *
 * <span class="informal">It's like {@link bufferToggle}, but emits a nested
 * Observable instead of an array.</span>
 *
 * <img src="./img/windowToggle.png" width="100%">
 *
 * Returns an Observable that emits windows of items it collects from the source
 * Observable. The output Observable emits windows that contain those items
 * emitted by the source Observable between the time when the `openings`
 * Observable emits an item and when the Observable returned by
 * `closingSelector` emits an item.
 *
 * @example <caption>Every other second, emit the click events from the next 500ms</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var openings = Rx.Observable.interval(1000);
 * var result = clicks.windowToggle(openings, i =>
 *   i % 2 ? Rx.Observable.interval(500) : Rx.Observable.empty()
 * ).mergeAll();
 * result.subscribe(x => console.log(x));
 *
 * @see {@link window}
 * @see {@link windowCount}
 * @see {@link windowTime}
 * @see {@link windowWhen}
 * @see {@link bufferToggle}
 *
 * @param {Observable<O>} openings An observable of notifications to start new
 * windows.
 * @param {function(value: O): Observable} closingSelector A function that takes
 * the value emitted by the `openings` observable and returns an Observable,
 * which, when it emits (either `next` or `complete`), signals that the
 * associated window should complete.
 * @return {Observable<Observable<T>>} An observable of windows, which in turn
 * are Observables.
 * @method windowToggle
 * @owner Observable
 */
function windowToggle(openings, closingSelector) {
    return this.lift(new WindowToggleOperator(openings, closingSelector));
}
exports.windowToggle = windowToggle;
var WindowToggleOperator = (function () {
    function WindowToggleOperator(openings, closingSelector) {
        this.openings = openings;
        this.closingSelector = closingSelector;
    }
    WindowToggleOperator.prototype.call = function (subscriber, source) {
        return source.subscribe(new WindowToggleSubscriber(subscriber, this.openings, this.closingSelector));
    };
    return WindowToggleOperator;
}());
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */
var WindowToggleSubscriber = (function (_super) {
    __extends(WindowToggleSubscriber, _super);
    function WindowToggleSubscriber(destination, openings, closingSelector) {
        _super.call(this, destination);
        this.openings = openings;
        this.closingSelector = closingSelector;
        this.contexts = [];
        this.add(this.openSubscription = subscribeToResult_1.subscribeToResult(this, openings, openings));
    }
    WindowToggleSubscriber.prototype._next = function (value) {
        var contexts = this.contexts;
        if (contexts) {
            var len = contexts.length;
            for (var i = 0; i < len; i++) {
                contexts[i].window.next(value);
            }
        }
    };
    WindowToggleSubscriber.prototype._error = function (err) {
        var contexts = this.contexts;
        this.contexts = null;
        if (contexts) {
            var len = contexts.length;
            var index = -1;
            while (++index < len) {
                var context = contexts[index];
                context.window.error(err);
                context.subscription.unsubscribe();
            }
        }
        _super.prototype._error.call(this, err);
    };
    WindowToggleSubscriber.prototype._complete = function () {
        var contexts = this.contexts;
        this.contexts = null;
        if (contexts) {
            var len = contexts.length;
            var index = -1;
            while (++index < len) {
                var context = contexts[index];
                context.window.complete();
                context.subscription.unsubscribe();
            }
        }
        _super.prototype._complete.call(this);
    };
    WindowToggleSubscriber.prototype._unsubscribe = function () {
        var contexts = this.contexts;
        this.contexts = null;
        if (contexts) {
            var len = contexts.length;
            var index = -1;
            while (++index < len) {
                var context = contexts[index];
                context.window.unsubscribe();
                context.subscription.unsubscribe();
            }
        }
    };
    WindowToggleSubscriber.prototype.notifyNext = function (outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        if (outerValue === this.openings) {
            var closingSelector = this.closingSelector;
            var closingNotifier = tryCatch_1.tryCatch(closingSelector)(innerValue);
            if (closingNotifier === errorObject_1.errorObject) {
                return this.error(errorObject_1.errorObject.e);
            }
            else {
                var window_1 = new Subject_1.Subject();
                var subscription = new Subscription_1.Subscription();
                var context = { window: window_1, subscription: subscription };
                this.contexts.push(context);
                var innerSubscription = subscribeToResult_1.subscribeToResult(this, closingNotifier, context);
                if (innerSubscription.closed) {
                    this.closeWindow(this.contexts.length - 1);
                }
                else {
                    innerSubscription.context = context;
                    subscription.add(innerSubscription);
                }
                this.destination.next(window_1);
            }
        }
        else {
            this.closeWindow(this.contexts.indexOf(outerValue));
        }
    };
    WindowToggleSubscriber.prototype.notifyError = function (err) {
        this.error(err);
    };
    WindowToggleSubscriber.prototype.notifyComplete = function (inner) {
        if (inner !== this.openSubscription) {
            this.closeWindow(this.contexts.indexOf(inner.context));
        }
    };
    WindowToggleSubscriber.prototype.closeWindow = function (index) {
        if (index === -1) {
            return;
        }
        var contexts = this.contexts;
        var context = contexts[index];
        var window = context.window, subscription = context.subscription;
        contexts.splice(index, 1);
        window.complete();
        subscription.unsubscribe();
    };
    return WindowToggleSubscriber;
}(OuterSubscriber_1.OuterSubscriber));
//# sourceMappingURL=windowToggle.js.map

/***/ }),

/***/ "yrou":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.empty = {
    closed: true,
    next: function (value) { },
    error: function (err) { throw err; },
    complete: function () { }
};
//# sourceMappingURL=Observer.js.map

/***/ }),

/***/ "ytmK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = validateBasis;
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
* The flex API permits 3 or 1 parts of the value:
*    - `flex-grow flex-shrink flex-basis`, or
*    - `flex-basis`
*/
/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */ function validateBasis(basis, grow, shrink) {
    if (grow === void 0) { grow = "1"; }
    if (shrink === void 0) { shrink = "1"; }
    var parts = [grow, shrink, basis];
    var j = basis.indexOf('calc');
    if (j > 0) {
        parts[2] = _validateCalcValue(basis.substring(j).trim());
        var matches = basis.substr(0, j).trim().split(" ");
        if (matches.length == 2) {
            parts[0] = matches[0];
            parts[1] = matches[1];
        }
    }
    else if (j == 0) {
        parts[2] = _validateCalcValue(basis.trim());
    }
    else {
        var matches = basis.split(" ");
        parts = (matches.length === 3) ? matches : [
            grow, shrink, basis
        ];
    }
    return parts;
}
/**
 * Calc expressions require whitespace before & after any expression operators
 * This is a simple, crude whitespace padding solution.
 *   - "3 3 calc(15em + 20px)"
 *   - calc(100% / 7 * 2)
 *   - "calc(15em + 20px)"
 *   - "calc(15em+20px)"
 *   - "37px"
 *   = "43%"
 */
function _validateCalcValue(calc) {
    return calc.replace(/[\s]/g, "").replace(/[\/\*\+\-]/g, " $& ");
}
//# sourceMappingURL=basis-validator.js.map

/***/ }),

/***/ "z3LF":
/***/ (function(module, exports) {

exports.model=Model={Game:{},Board:{},Move:{}},Model.Game.InitGameInfo=function(){},Model.Game.BuildGraphCoord=function(){var i=[],t=[];this.g.Graph=i,this.g.Coord=t},Model.Game.InitGame=function(){this.BuildGraphCoord(),this.g.TripletsByPos=[];for(var i=0;i<this.g.Coord.length;i++)this.g.TripletsByPos[i]=[];for(var i in this.g.Triplets)if(this.g.Triplets.hasOwnProperty(i)){var t=this.g.Triplets[i];for(var e in t)if(t.hasOwnProperty(e)){var s=t[e];this.g.TripletsByPos[s].push(t)}}this.InitGameExtra()},Model.Game.DestroyGame=function(){},Model.Game.MillsDirections=4,Model.Game.MillsEachDirection=function(i,t){for(var e=0;e<this.MillsDirections;e++){var s=this.g.Graph[i][e];null!=s&&t(s)}},Model.Move.Init=function(i){this.f=i.f,this.t=i.t,this.c=i.c},Model.Move.CopyFrom=function(i){this.f=i.f,this.t=i.t,this.c=i.c},Model.Move.Equals=function(i){return this.t==i.t&&this.c==i.c&&this.f==i.f},Model.Move.ToString=function(){var i="";return this.f>-1&&(i+=this.f+">"),i+=this.t,this.c>-1&&(i+="x"+this.c),i},Model.Board.Init=function(i){},Model.Board.InitialPosition=function(i){var t=i.g.Coord.length,e=i.mOptions.mencount;this.board=[];for(var s=0;s<t;s++)this.board[s]=-1;this.pieces=[],this.dock={1:[],"-1":[]},this.menCount={1:0,"-1":0};for(var o=0,n=0;n<2;n++)for(var r=0==n?1:-1,h=0;h<e;h++)this.dock[r].unshift(o),this.pieces.push({s:r,a:!0,d:h,p:-1,i:o++});this.placing=!0},Model.Board.StaticGenerateMoves=function(i){if(0==i.mFullPlayedMoves.length){for(var t=[],e=0;e<i.g.Coord.length;e++)t.push({f:-1,t:e,c:-1});return t}return null},Model.Board.GenerateMoves=function(i){this.mMoves=[],this.placing?this.GeneratePlacingMoves(i):i.mOptions.canFly?this.GenerateFlyingMoves(i):this.GenerateMovingMoves(i),0==this.mMoves.length&&(this.mFinished=!0,this.menCount[JocGame.PLAYER_A]+this.menCount[JocGame.PLAYER_B]==i.g.Coord.length?this.mWinner=JocGame.DRAW:this.mWinner=-this.mWho)},Model.Board.GeneratePlacingMoves=function(i){for(var t=0;t<i.g.Coord.length;t++)if(this.board[t]==-1){var e=!0;if(void 0!==i.mLevelInfo&&i.mCurrentLevel>=0){var s=i.mLevelInfo.maxDepth-i.mCurrentLevel;if(s>=i.mLevelInfo.placingRace){e=!1;for(var o in i.g.TripletsByPos[t])if(i.g.TripletsByPos[t].hasOwnProperty(o)){for(var n=i.g.TripletsByPos[t][o],r=0,h=0,a=0,l=0;l<3;l++)this.board[n[l]]==-1?a++:this.pieces[this.board[n[l]]].s==this.mWho?r++:h++;if(2==r||1==r&&0==h||2==h){e=!0;break}}}}e&&this.GenerateCapturingMoves(i,{f:-1,t:t,c:-1})}},Model.Board.GenerateMovingMoves=function(i){$this=this;for(var t=0;t<this.pieces.length;t++){var e=this.pieces[t];e.a&&e.s==this.mWho&&i.MillsEachDirection(e.p,function(t){$this.board[t]==-1&&$this.GenerateCapturingMoves(i,{f:e.p,t:t,c:-1})})}},Model.Board.GenerateFlyingMoves=function(i){if(3!=this.menCount[this.mWho])this.GenerateMovingMoves(i);else for(var t=0;t<this.pieces.length;t++){var e=this.pieces[t];if(e.a&&e.s==this.mWho)for(var s=0;s<this.board.length;s++)this.board[s]==-1&&this.GenerateCapturingMoves(i,{f:e.p,t:s,c:-1})}},Model.Board.GenerateCapturingMoves=function(i,t){for(var e in i.g.TripletsByPos[t.t])if(i.g.TripletsByPos[t.t].hasOwnProperty(e)){for(var s=i.g.TripletsByPos[t.t][e],o=!0,n=0;n<3;n++){var r=s[n];if(r!=t.t){if(this.board[r]==-1||t.f==r){o=!1;break}var h=this.pieces[this.board[r]];if(0==h.a||h.d>-1||h.s!=this.mWho){o=!1;break}}}if(o){if(3==this.menCount[-this.mWho]&&0==this.placing)return void this.mMoves.push({f:t.f,t:t.t,c:-2});for(var a=[],n=0;n<this.pieces.length;n++){var h=this.pieces[n];if(1==h.a&&h.d==-1&&h.s==-this.mWho){var l={f:t.f,t:t.t,c:h.p};a.push(l)}}if(0==i.mOptions.poundInMill){var c={};for(var d in i.g.Triplets)if(i.g.Triplets.hasOwnProperty(d)){var f=i.g.Triplets[d];this.board[f[0]]!=-1&&this.pieces[this.board[f[0]]].s==-this.mWho&&this.board[f[1]]!=-1&&this.pieces[this.board[f[1]]].s==-this.mWho&&this.board[f[2]]!=-1&&this.pieces[this.board[f[2]]].s==-this.mWho&&(c[f[0]]=!0,c[f[1]]=!0,c[f[2]]=!0)}for(var u=[],d=0;d<a.length;d++)c[a[d].c]||u.push(a[d]);u.length>0&&(a=u)}return void(this.mMoves=this.mMoves.concat(a))}}this.mMoves.push({f:t.f,t:t.t,c:-1})},Model.Board.Evaluate=function(i,t,e){if(i.GetRepeatOccurence(this)>2)return this.mFinished=!0,void(this.mWinner=JocGame.DRAW);if(0==this.placing){if(this.menCount[JocGame.PLAYER_A]<3)return this.mFinished=!0,void(this.mWinner=JocGame.PLAYER_B);if(this.menCount[JocGame.PLAYER_B]<3)return this.mFinished=!0,void(this.mWinner=JocGame.PLAYER_A)}var s=this.menCount[JocGame.PLAYER_A]-this.menCount[JocGame.PLAYER_B],o=0,n=0;for(var r in i.g.Triplets)if(i.g.Triplets.hasOwnProperty(r)){for(var h={"-1":0,0:0,1:0},a=i.g.Triplets[r],l=0;l<3;l++){var c=a[l],d=this.board[c];if(d>-1){var f=this.pieces[d];h[f.s]++}}1==h[1]&&0==h[-1]?o++:2==h[1]&&0==h[-1]&&n++,1==h[-1]&&0==h[1]?o--:2==h[-1]&&0==h[1]&&n--}this.mEvaluation=10*s,this.mEvaluation+=1*o,this.mEvaluation+=3*n},Model.Board.ApplyMove=function(i,t){if(this.placing){var e=this.dock[this.mWho].shift(),s=this.pieces[e];s.d=-1,s.p=t.t,this.board[t.t]=e,this.lastMoveIndex=e,this.menCount[this.mWho]++,0==this.dock[JocGame.PLAYER_B].length&&(this.placing=!1)}else{var s=this.pieces[this.board[t.f]];this.board[s.p]=-1,this.board[t.t]=s.i,s.p=t.t,this.lastMoveIndex=s.i}if(t.c>-1){var e=this.board[t.c];this.board[t.c]=-1;var s=this.pieces[e];s.a=!1,this.menCount[-this.mWho]--}else t.c==-2&&this.menCount[-this.mWho]--},Model.Board.IsValidMove=function(i,t){return!0},Model.Game.InitGameExtra=function(){},Model.Game.BuildGraphCoord=function(){this.g.Graph=[[1,6,null,null],[2,4,0,null],[null,9,1,null],[4,7,null,null],[5,16,3,1],[null,8,4,null],[7,13,null,0],[16,10,6,3],[9,12,16,5],[null,15,8,2],[11,null,null,7],[12,14,10,16],[null,null,11,8],[14,null,null,6],[15,null,13,11],[null,null,14,9],[8,11,7,4]],this.g.Coord=[[0,0],[0,2],[0,4],[1,1],[1,2],[1,3],[2,0],[2,1],[2,3],[2,4],[3,1],[3,2],[3,3],[4,0],[4,2],[4,4],[2,2]],this.g.Triplets=[[0,1,2],[3,4,5],[10,11,12],[13,14,15],[0,6,13],[3,7,10],[5,8,12],[2,9,15],[6,7,16],[7,16,8],[16,8,9],[1,4,16],[4,16,11],[16,11,14]]},Model.Board.StaticGenerateMoves=function(i){return 0==i.mFullPlayedMoves.length?[{f:-1,t:16,c:-1}]:null};

/***/ }),

/***/ "zC23":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var dematerialize_1 = __webpack_require__("Oa+j");
Observable_1.Observable.prototype.dematerialize = dematerialize_1.dematerialize;
//# sourceMappingURL=dematerialize.js.map

/***/ }),

/***/ "zJQZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var scan_1 = __webpack_require__("td8d");
Observable_1.Observable.prototype.scan = scan_1.scan;
//# sourceMappingURL=scan.js.map

/***/ }),

/***/ "zO2v":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Observable_1 = __webpack_require__("rCTf");
var defer_1 = __webpack_require__("DzMp");
Observable_1.Observable.defer = defer_1.defer;
//# sourceMappingURL=defer.js.map

/***/ }),

/***/ "zQPq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Subscription_1 = __webpack_require__("B00U");
/**
 * A unit of work to be executed in a {@link Scheduler}. An action is typically
 * created from within a Scheduler and an RxJS user does not need to concern
 * themselves about creating and manipulating an Action.
 *
 * ```ts
 * class Action<T> extends Subscription {
 *   new (scheduler: Scheduler, work: (state?: T) => void);
 *   schedule(state?: T, delay: number = 0): Subscription;
 * }
 * ```
 *
 * @class Action<T>
 */
var Action = (function (_super) {
    __extends(Action, _super);
    function Action(scheduler, work) {
        _super.call(this);
    }
    /**
     * Schedules this action on its parent Scheduler for execution. May be passed
     * some context object, `state`. May happen at some point in the future,
     * according to the `delay` parameter, if specified.
     * @param {T} [state] Some contextual data that the `work` function uses when
     * called by the Scheduler.
     * @param {number} [delay] Time to wait before executing the work, where the
     * time unit is implicit and defined by the Scheduler.
     * @return {void}
     */
    Action.prototype.schedule = function (state, delay) {
        if (delay === void 0) { delay = 0; }
        return this;
    };
    return Action;
}(Subscription_1.Subscription));
exports.Action = Action;
//# sourceMappingURL=Action.js.map

/***/ }),

/***/ "zYTA":
/***/ (function(module, exports) {

exports.model=Model={Game:{},Board:{},Move:{}},function(){var t;Model.Game.cbConstants={MASK:65535,FLAG_MOVE:65536,FLAG_CAPTURE:131072,FLAG_STOP:262144,FLAG_SCREEN_CAPTURE:524288,FLAG_CAPTURE_KING:1048576,FLAG_CAPTURE_NO_KING:2097152};var e="undefined"!=typeof Int32Array;Model.Game.cbUseTypedArrays=e,Model.Game.cbTypedArray=function(t){if(e){var i=new Int32Array(t.length);return i.set(t),i}for(var r=[],a=t.length,s=0;s<a;s++)r.push(t[s]);return r},Model.Game.cbShortRangeGraph=function(t,e,i,r){var a=this;void 0===r&&(r=196608);for(var s={},n=0;n<t.boardSize;n++)s[n]=[],(!i||n in i)&&e.forEach(function(e){var o=t.Graph(n,e);null!=o&&(!i||o in i)&&s[n].push(a.cbTypedArray([o|r]))});return s},Model.Game.cbLongRangeGraph=function(t,e,i,r,a){var s=this;void 0!==r&&null!=r||(r=196608),a||(a=1/0);for(var n={},o=0;o<t.boardSize;o++)n[o]=[],(!i||o in i)&&e.forEach(function(e){for(var h=[],p=t.Graph(o,e),c=0;null!=p&&(!i||p in i)&&(h.push(p|r),++c!=a);)p=t.Graph(p,e);h.length>0&&n[o].push(s.cbTypedArray(h))});return n},Model.Game.cbNullGraph=function(t){for(var e={},i=0;i<t.boardSize;i++)e[i]=[];return e},Model.Game.cbAuthorGraph=function(t){for(var e={},i=0;i<t.boardSize;i++){e[i]=[];for(var r=0;r<t.boardSize;r++)e[i].push([2293760|r])}return e},Model.Game.cbMergeGraphs=function(t){for(var e=[],i=0;i<t.boardSize;i++){e[i]=[];for(var r=1;r<arguments.length;r++)e[i]=e[i].concat(arguments[r][i])}return e},Model.Game.cbGetThreatGraph=function(){function t(e,i){for(var r in n){var a=n[r];if(!(a.p.length<i.length+1)){for(var s=!0,o=0;o<i.length;o++)if(i[o]!=a.p[o]){s=!1;break}if(s){var h=a.p[i.length],p=e[h];void 0===p&&(p={e:{}},e[h]=p),a.p.length==i.length+1&&(p.t=a.t,p.ts=a.ts,p.tk=a.tk,delete n[r]),i.push(h),t(p.e,i),i.pop()}}}}var e=this;this.cbUseScreenCapture=!1,this.cbUseCaptureKing=!1,this.cbUseCaptureNoKing=!1;for(var i={1:[],"-1":[]},r=[],a=0;a<this.g.boardSize;a++)this.g.pTypes.forEach(function(t,i){t.graph[a].forEach(function(t){for(var s=[],n=0;n<t.length;n++){var o=t[n];1048576&o?(e.cbUseCaptureKing=!0,s.unshift({d:65535&o,a:a,tk:i})):2097152&o?(e.cbUseCaptureNoKing=!0,s.unshift({d:65535&o,a:a,tnk:i})):131072&o?s.unshift({d:65535&o,a:a,t:i}):262144&o?s.unshift({d:65535&o,a:a}):524288&o&&(e.cbUseScreenCapture=!0,s.unshift({d:65535&o,a:a,ts:i}))}s.length>0&&r.push(s)})});var s={};r.forEach(function(t){t.forEach(function(e,i){var r=s[e.d];void 0===r&&(r={},s[e.d]=r);for(var a=[],n=i+1;n<t.length;n++)a.push(t[n].d);a.push(e.a);var o=a.join(","),h=r[o];void 0===h&&(h={p:a,t:{},ts:{},tk:{}},r[o]=h),void 0!==e.t?h.t[e.t]=!0:void 0!==e.tk?h.tk[e.tk]=!0:void 0!==e.ts&&(h.ts[e.ts]=!0)})});for(var a=0;a<e.g.boardSize;a++){var n=s[a],o={};t(o,[]),i[1][a]=o,i[-1][a]=o}return i},Model.Game.InitGame=function(){var e=this;this.cbVar=t=this.cbDefine(),this.g.boardSize=this.cbVar.geometry.boardSize,this.g.pTypes=this.cbGetPieceTypes(),this.g.threatGraph=this.cbGetThreatGraph(),this.g.distGraph=this.cbVar.geometry.GetDistances(),this.cbPiecesCount=0,this.g.castleablePiecesCount={1:0,"-1":0};for(var i in t.pieceTypes){var r=t.pieceTypes[i];if(r.castle){(r.initial||[]).forEach(function(t){e.g.castleablePiecesCount[t.s]++})}r.initial&&(this.cbPiecesCount+=r.initial.length)}for(var a=[],i=0;i<this.cbPiecesCount;i++)a.push(i);var s=Object.keys(t.pieceTypes);this.zobrist=new JocGame.Zobrist({board:{type:"array",size:this.cbVar.geometry.boardSize,values:a},who:{values:["1","-1"]},type:{type:"array",size:this.cbPiecesCount,values:s}})},Model.Game.cbGetPieceTypes=function(){for(var t=[],e={},i=0;i<this.cbVar.geometry.boardSize;i++)e[i]=[];for(var r in this.cbVar.pieceTypes){var a=this.cbVar.pieceTypes[r];t[r]={graph:a.graph||e,abbrev:a.abbrev||"",value:a.isKing?100:a.value||1,isKing:!!a.isKing,castle:!!a.castle,epTarget:!!a.epTarget,epCatch:!!a.epCatch}}return t},Model.Board.Init=function(t){this.zSign=0},Model.Board.InitialPosition=function(i){var r=this;this.board=e?new Int16Array(i.g.boardSize):[];for(var a=0;a<i.g.boardSize;a++)this.board[a]=-1;if(this.kings={},this.pieces=[],this.ending={1:!1,"-1":!1},this.lastMove=null,i.cbVar.castle&&(this.castled={1:!1,"-1":!1}),this.zSign=i.zobrist.update(0,"who",-1),this.noCaptCount=0,this.mWho=1,i.mInitial)this.mWho=i.mInitial.turn||1,i.mInitial.pieces.forEach(function(t){var e={};for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i]);r.pieces.push(e)}),i.mInitial.lastMove&&(this.lastMove={f:i.mInitial.lastMove.f,t:i.mInitial.lastMove.t}),void 0!==i.mInitial.noCaptCount&&(this.noCaptCount=i.mInitial.noCaptCount),i.cbVar.castle&&i.mInitial.castle&&(this.castled={1:{k:!!i.mInitial.castle[1]&&!!i.mInitial.castle[1].k,q:!!i.mInitial.castle[1]&&!!i.mInitial.castle[1].q},"-1":{k:!!i.mInitial.castle[-1]&&!!i.mInitial.castle[-1].k,q:!!i.mInitial.castle[-1]&&!!i.mInitial.castle[-1].q}});else for(var s in i.cbVar.pieceTypes)for(var n=i.cbVar.pieceTypes[s],o=n.initial||[],h=0;h<o.length;h++){var p=o[h],c={s:p.s,t:parseInt(s),p:p.p,m:!1};this.pieces.push(c)}if(this.pieces.sort(function(t,e){if(t.s!=e.s)return e.s-t.s;var r=i.cbVar.pieceTypes[t.t].value||100,a=i.cbVar.pieceTypes[e.t].value||100;return r!=a?r-a:t.p-e.p}),this.pieces.forEach(function(t,e){t.i=e,r.board[t.p]=e,i.g.pTypes[t.t].isKing&&(r.kings[t.s]=t.p),r.zSign=i.zobrist.update(r.zSign,"board",e,t.p),r.zSign=i.zobrist.update(r.zSign,"type",t.t,e)}),i.mInitial&&i.mInitial.enPassant){var a=t.geometry.PosByName(i.mInitial.enPassant);if(a>=0){var l,u=t.geometry.C(a),b=t.geometry.R(a);l=1==i.mInitial.turn?t.geometry.POS(u,b-1):t.geometry.POS(u,b+1),this.epTarget={p:a,i:this.board[l]}}}},Model.Board.CopyFrom=function(t){if(e)this.board=new Int16Array(t.board.length),this.board.set(t.board);else{this.board=[];for(var i=t.board,r=i.length,a=0;a<r;a++)this.board.push(i[a])}this.pieces=[];for(var s=t.pieces.length,a=0;a<s;a++){var n=t.pieces[a];this.pieces.push({s:n.s,p:n.p,t:n.t,i:n.i,m:n.m})}this.kings={1:t.kings[1],"-1":t.kings[-1]},this.check=t.check,t.lastMove?this.lastMove={f:t.lastMove.f,t:t.lastMove.t,c:t.lastMove.c}:this.lastMove=null,this.ending={1:t.ending[1],"-1":t.ending[-1]},void 0!==t.castled&&(this.castled={1:t.castled[1],"-1":t.castled[-1]}),this.noCaptCount=t.noCaptCount,t.epTarget?this.epTarget={p:t.epTarget.p,i:t.epTarget.i}:this.epTarget=null,this.mWho=t.mWho,this.zSign=t.zSign},Model.Board.cbApplyCastle=function(t,e,i){var r=t.cbVar.castle[e.f+"/"+e.cg],a=r.r[r.r.length-1],s=this.pieces[this.board[e.cg]],n=r.k[r.k.length-1],o=this.pieces[this.board[e.f]];return i&&(this.zSign=t.zobrist.update(this.zSign,"board",s.i,e.cg),this.zSign=t.zobrist.update(this.zSign,"board",s.i,a),this.zSign=t.zobrist.update(this.zSign,"board",o.i,e.f),this.zSign=t.zobrist.update(this.zSign,"board",o.i,n)),s.p=a,s.m=!0,this.board[e.cg]=-1,o.p=n,o.m=!0,this.board[e.f]=-1,this.board[a]=s.i,this.board[n]=o.i,this.castled[s.s]=!0,this.kings[o.s]=n,[{i:s.i,f:a,t:-1},{i:o.i,f:n,t:e.f,kp:e.f,who:o.s,m:!1},{i:s.i,f:-1,t:e.cg,m:!1,cg:!1}]},Model.Board.cbQuickApply=function(t,e){if(void 0!==e.cg)return this.cbApplyCastle(t,e,!1);var i=[],r=this.board[e.f],a=this.pieces[r];if(null!=e.c){i.unshift({i:e.c,f:-1,t:this.pieces[e.c].p});var s=this.pieces[e.c];this.board[s.p]=-1,s.p=-1}var n=this.kings[a.s];return t.g.pTypes[a.t].isKing&&(this.kings[a.s]=e.t),i.unshift({i:r,f:e.t,t:e.f,kp:n,who:a.s,ty:a.t}),a.p=e.t,void 0!==e.pr&&(a.t=e.pr),this.board[e.f]=-1,this.board[e.t]=r,i},Model.Board.cbQuickUnapply=function(t,e){for(var i=0;i<e.length;i++){var r=e[i],a=this.pieces[r.i];r.f>=0&&(a.p=-1,this.board[r.f]=-1),r.t>=0&&(a.p=r.t,this.board[r.t]=r.i),void 0!==r.m&&(a.m=r.m),void 0!==r.kp&&(this.kings[r.who]=r.kp),void 0!=r.ty&&(a.t=r.ty),void 0!=r.cg&&(this.castled[a.s]=r.cg)}},Model.Board.ApplyMove=function(t,e){var i=this.pieces[this.board[e.f]];if(void 0!==e.cg)this.cbApplyCastle(t,e,!0);else{if(this.zSign=t.zobrist.update(this.zSign,"board",i.i,e.f),this.board[i.p]=-1,void 0!==e.pr&&(this.zSign=t.zobrist.update(this.zSign,"type",i.t,i.i),i.t=e.pr,this.zSign=t.zobrist.update(this.zSign,"type",i.t,i.i)),null!=e.c){var r=this.pieces[e.c];this.zSign=t.zobrist.update(this.zSign,"board",r.i,r.p),this.board[r.p]=-1,r.p=-1,r.m=!0,this.noCaptCount=0}else this.noCaptCount++;i.p=e.t,i.m=!0,this.board[e.t]=i.i,this.zSign=t.zobrist.update(this.zSign,"board",i.i,e.t),t.g.pTypes[i.t].isKing&&(this.kings[i.s]=e.t)}this.check=!!e.ck,this.lastMove={f:e.f,t:e.t,c:e.c},void 0!==e.ko&&(this.ending[i.s]=e.ko),void 0!==e.ept?this.epTarget={p:e.ept,i:i.i}:this.epTarget=null,this.zSign=t.zobrist.update(this.zSign,"who",-this.mWho),this.zSign=t.zobrist.update(this.zSign,"who",this.mWho)},Model.Board.Evaluate=function(i){function r(e){var i=1/0;for(var r in t.geometry.corners)i=Math.min(i,h.distGraph[s.kings[e]][r]);return i-Math.sqrt(h.boardSize)}var a="debug"==arguments[3],s=this;this.mEvaluation=0;var n,o=this.mWho,h=i.g;if(e)n={1:{count:new Uint8Array(h.pTypes.length),byType:{}},"-1":{count:new Uint8Array(h.pTypes.length),byType:{}}};else{n={1:{count:[],byType:{}},"-1":{count:[],byType:{}}};for(var p=0;p<h.pTypes.length;p++)n[1].count[p]=n[-1].count[p]=0}if(i.mOptions.preventRepeat&&i.GetRepeatOccurence(this)>2)return this.mFinished=!0,void(this.mWinner=i.cbOnPerpetual?o*i.cbOnPerpetual:JocGame.DRAW);for(var c={1:0,"-1":0},l={1:h.distGraph[this.kings[-1]],"-1":h.distGraph[this.kings[1]]},u={1:0,"-1":0},b={1:0,"-1":0},v={1:0,"-1":0},f={1:0,"-1":0},d={1:!1,"-1":!1},g=this.pieces,m=g.length,p=0;p<m;p++){var G=g[p];if(G.p>=0){var y=G.s,M=h.pTypes[G.t];M.isKing?d[y]=G.m:c[y]+=M.value,M.castle&&!G.m&&f[y]++,b[y]++,u[y]+=l[y][G.p],v[y]+=t.geometry.distEdge[G.p];var S=n[y];S.count[G.t]++;var C=S.byType;void 0===C[G.t]?C[G.t]=[G]:C[G.t].push(G)}}if(this.lastMove&&null!=this.lastMove.c){var G=this.pieces[this.board[this.lastMove.t]];c[-G.s]+=this.cbStaticExchangeEval(i,G.p,G.s,{piece:G})}var k={1:0,"-1":0},A={1:0,"-1":0},T={1:0,"-1":0};this.ending[1]&&(A[1]=(u[1]-Math.sqrt(h.boardSize))/b[1],t.geometry.corners&&(T[1]=r(1))),this.ending[-1]&&(A[-1]=(u[-1]-Math.sqrt(h.boardSize))/b[-1],t.geometry.corners&&(T[1]=r(-1)));var z={pieceValue:c[1]-c[-1],pieceValueRatio:(c[1]-c[-1])/(c[1]+c[-1]+1),posValue:v[1]-v[-1],averageDistKing:u[1]/b[1]-u[-1]/b[-1],check:this.check?-o:0,endingKingFreedom:k[1]-k[-1],endingDistKing:A[1]-A[-1],distKingCorner:T[1]-T[-1]};t.castle&&(z.castle=(this.castled[1]?1:d[1]?0:f[1]/(h.castleablePiecesCount[1]+1))-(this.castled[-1]?1:d[-1]?0:f[-1]/(h.castleablePiecesCount[-1]+1))),t.evaluate&&t.evaluate.call(this,i,z,n);var E=i.mOptions.levelOptions;for(var P in z){var w=z[P],I=E[P+"Factor"]||0,R=w*I;a&&console.log(P,"=",w,"*",I,"=>",R),this.mEvaluation+=R}a&&console.log("Evaluation",this.mEvaluation)},Model.Board.cbGeneratePseudoLegalMoves=function(t){function e(e,a){var s=t.cbVar.promote;if(!s)return void r.push(a);var n=s.call(i,t,e,a);if(null!=n)if(0==n.length)r.push(a);else if(1==n.length)a.pr=n[0],r.push(a);else for(var o=0;o<n.length;o++){var h=n[o];r.push({f:a.f,t:a.t,c:a.c,pr:h,ept:a.ept,ep:a.ep,a:a.a})}}for(var i=this,r=[],a=t.cbVar,s=this.mWho,n=!a.castle||this.check||this.castled[s]?null:[],o=-1,h=this.pieces.length,p=0;p<h;p++){var c=this.pieces[p];if(!(c.p<0||c.s!=s)){var l=t.g.pTypes[c.t];l.isKing&&(c.m?n=null:o=c),n&&l.castle&&!c.m&&n.push(c);var u,b;u=l.graph[c.p],b=u.length;for(var v=0;v<b;v++)for(var f=u[v],d=!1,g=f.length,m=null,G=0;G<g;G++){var y=f[G],M=65535&y,S=this.board[M];if(!(S<0)||l.epCatch&&this.epTarget&&this.epTarget.p==M){if(!(524288&y)){var C;C=S<0?this.pieces[this.epTarget.i]:this.pieces[S],!(C.s!=c.s&&131072&y)||1048576&y&&!t.g.pTypes[C.t].isKing||2097152&y&&t.g.pTypes[C.t].isKing||e(c,{f:c.p,t:M,c:C.i,a:l.abbrev,ep:S<0});break}if(d){var C=this.pieces[S];C.s!=c.s&&e(c,{f:c.p,t:M,c:C.i,a:l.abbrev});break}d=!0}else 65536&y&&0==d&&e(c,{f:c.p,t:M,c:null,a:l.abbrev,ept:null!=m&&l.epTarget?m:void 0});m=M}}}if(n)for(var p=0;p<n.length;p++){var k=n[p],A=t.cbVar.castle[o.p+"/"+k.p];if(A){for(var T=!0,v=0;v<A.r.length;v++){var z=A.r[v];if(this.board[z]>=0&&z!=o.p&&z!=k.p){T=!1;break}}if(T){for(var E=!0,v=0;v<A.k.length;v++){var z=A.k[v];if(this.board[z]>=0&&z!=k.p&&z!=o.p||this.cbGetAttackers(t,z,s).length>0){E=!1;break}}E&&r.push({f:o.p,t:A.k[A.k.length-1],c:null,cg:k.p})}}}return r},Model.Board.cbStaticExchangeEval=function(t,e,i,r){var a=0,s=this.cbGetSmallestAttacker(t,e,i);if(s){var n=this.mWho;this.mWho=s.s;var o=this.cbQuickApply(t,{f:s.p,t:e,c:r.piece.i}),h=t.g.pTypes[r.piece.t].value;r.piece=s,a=Math.max(0,h-this.cbStaticExchangeEval(t,e,-i,r)),this.cbQuickUnapply(t,o),this.mWho=n}return a},Model.Board.cbGetSmallestAttacker=function(t,e,i){var r=this.cbGetAttackers(t,e,i);if(0==r.length)return null;for(var a=1/0,s=null,n=r.length,o=0;o<n;o++){var h=r[o],p=t.g.pTypes[h.t].value;p<a&&(a=p,s=h)}return s},Model.Board.cbCollectAttackers=function(t,e,i,r){for(var a in e){var s=e[a],n=this.board[a];if(n<0)this.cbCollectAttackers(t,s.e,i,r);else{var o=this.pieces[n];o.s==-t&&(s.t&&o.t in s.t||r&&s.tk&&o.t in s.tk)&&i.push(o)}}},Model.Board.cbCollectAttackersScreen=function(t,e,i,r,a){for(var s in e){var n=e[s],o=this.board[s];if(o<0)this.cbCollectAttackersScreen(t,n.e,i,r,a);else{var h=this.pieces[o];!a&&h.s==-t&&(n.t&&h.t in n.t||r&&n.tk&&h.t in n.tk)?i.push(h):a?a&&h.s==-t&&n.ts&&h.t in n.ts&&i.push(h):this.cbCollectAttackersScreen(t,n.e,i,r,!0)}}},Model.Board.cbGetAttackers=function(t,e,i,r){var a=[];return t.cbUseScreenCapture?this.cbCollectAttackersScreen(i,t.g.threatGraph[i][e],a,r,!1):this.cbCollectAttackers(i,t.g.threatGraph[i][e],a,r),a},Model.Board.GenerateMoves=function(t){var e=this.cbGeneratePseudoLegalMoves(t);this.mMoves=[];for(var i=!0,r=this.kings[this.mWho],a=e.length,s=0;s<a;s++){var n=e[s],o=this.cbQuickApply(t,n);if(!(this.cbGetAttackers(t,this.kings[this.mWho],this.mWho,!0).length>0)){var h=this.cbGetAttackers(t,this.kings[-this.mWho],-this.mWho,!0).length>0;n.ck=h,this.mMoves.push(n),n.f!=r&&(i=!1)}this.cbQuickUnapply(t,o)}if(0==this.mMoves.length)this.mFinished=!0,this.mWinner=t.cbOnStaleMate?t.cbOnStaleMate*this.mWho:JocGame.DRAW,this.check&&(this.mWinner=-this.mWho);else if(this.ending[this.mWho]){if(!i)for(var s=0;s<this.mMoves.length;s++)this.mMoves[s].ko=!1}else if(!this.ending[this.mWho]&&i&&!this.check)for(var s=0;s<this.mMoves.length;s++)this.mMoves[s].ko=!0},Model.Board.GetSignature=function(){return this.zSign},Model.Move.Init=function(t){for(var e in t)t.hasOwnProperty(e)&&(this[e]=t[e])},Model.Move.Equals=function(t){return this.f==t.f&&this.t==t.t&&this.pr==t.pr},Model.Move.CopyFrom=function(t){this.Init(t)},Model.Move.ToString=function(e){var i=this;switch(e=e||"natural"){case"natural":return function(){var e;if(void 0!==i.cg?e=t.castle[i.f+"/"+i.cg].n:(e=i.a||"",e+=t.geometry.PosName(i.f),null==i.c?e+="-":e+="x",e+=t.geometry.PosName(i.t)),void 0!==i.pr){var r=t.pieceTypes[i.pr];r&&r.abbrev&&r.abbrev.length>0&&!r.silentPromo&&(e+="="+r.abbrev)}return i.ck&&(e+="+"),e}();case"engine":return function(){var e=t.geometry.PosName(i.f)+t.geometry.PosName(i.t);if(void 0!=i.pr){var r=t.pieceTypes[i.pr];r&&r.abbrev&&r.abbrev.length>0&&!r.silentPromo&&(e+=r.abbrev)}return e}();default:return"??"}},Model.Board.CompactMoveString=function(e,i,r){"function"!=typeof i.ToString&&(i=e.CreateMove(i));var a=i.ToString(),s=/^([A-Z]?)([a-z])([1-9][0-9]*)([-x])([a-z])([1-9][0-9]*)(.*?)$/.exec(a);if(!s)return a;var n=s[7];if(r||(r={}),r.value||(r.value=[]),0==r.value.length){var o=this.mMoves;this.mMoves&&0!=this.mMoves.length||this.GenerateMoves(e);for(var h=0;h<this.mMoves.length;h++){var p=this.mMoves[h];"function"!=typeof p.ToString&&(p=e.CreateMove(p)),r.value.push({str:p.ToString(),move:p})}this.mMoves=o}var c=[];if(r.value.forEach(function(t){var e=/^([A-Z]?[a-z][1-9][0-9]*[-x][a-z][1-9][0-9]*)(.*?)$/.exec(t.str);e&&t.move.t==i.t&&(t.move.a||"")==s[1]&&e[2]==n&&c.push(t.move)}),1==c.length)return""==s[1]&&"x"==s[4]?s[2]+"x"+s[5]+s[6]+s[7]:s[1]+("x"==s[4]?"x":"")+s[5]+s[6]+s[7];if(t.geometry.CompactCrit)for(var l="",h=0;;h++){var u=t.geometry.CompactCrit(i.f,h);if(null==u)return a;l+=u;for(var b=[],v=0;v<c.length;v++){var f=c[v];t.geometry.CompactCrit(f.f,h)==u&&b.push(f)}if(console.assert(b.length>0),1==b.length)return s[1]+l+("x"==s[4]?"x":"")+s[5]+s[6]+s[7];c=b}return a},Model.Board.cbIntegrity=function(t){function e(t,e){t||console.error(e)}for(var i=this,r=0;r<this.board.length;r++){var a=this.board[r];if(a>=0){var s=i.pieces[a];e(void 0!==s,"no piece at pos"),e(s.p==r,"piece has different pos")}}for(var a=0;a<this.pieces.length;a++){var s=this.pieces[a];s.p>=0&&e(i.board[s.p]==a,"board index mismatch")}},Model.Board.ExportBoardState=function(t){return t.cbVar.geometry.ExportBoardState?t.cbVar.geometry.ExportBoardState(this,t.cbVar,t.mPlayedMoves.length):"not supported"},Model.Game.Import=function(e,i){var r,a=[],s={1:{},"-1":{}},n=null,o=0;if("pjn"==e){var h={status:!1,error:"parse"},p=i.split(" ");if(6!=p.length)return console.warn("FEN should have 6 parts"),h;var c=p[0].split("/"),l=t.geometry.fenHeight||t.geometry.height;if(c.length!=l)return console.warn("FEN board should have",l,"rows, got",c.length),h;var u={};for(var b in t.pieceTypes){var v=t.pieceTypes[b],f=v.fenAbbrev||v.abbrev||"X";u[f.toUpperCase()]={s:1,t:b},u[f.toLowerCase()]={s:-1,t:b}}var d=t.geometry.FenRowPos||function(e,i){return(t.geometry.height-1-e)*t.geometry.width+i};if(c.forEach(function(e,i){for(var r=0,s=0;s<e.length;s++){var n=e.substr(s,1),o=u[n];if(void 0!==o){var p=d(i,r);r++;for(var c={s:o.s,t:o.t,p:p},l=!0,b=t.pieceTypes[c.t].initial||[],v=0;v<b.length;v++){var f=b[v];f.s==c.s&&f.p==p&&(l=!1)}c.m=l,a.push(c)}else{if(isNaN(parseInt(n)))return console.warn("FEN invalid board spec",n),h;r+=parseInt(n)}}}),a.sort(function(t,e){return e.s-t.s}),"w"==p[1])r=1;else{if("b"!=p[1])return console.warn("FEN invalid turn spec",p[1]),h;r=-1}s[1].k=p[2].indexOf("K")>=0,s[1].q=p[2].indexOf("Q")>=0,s[-1].k=p[2].indexOf("k")>=0,s[-1].q=p[2].indexOf("q")>=0,n="-"==p[3]?null:p[3];var g=parseInt(p[4]);isNaN(g)||(o=g);var m={pieces:a,turn:r,castle:s,enPassant:n,noCaptCount:o};return t.importGame&&t.importGame.call(this,m,e,i),{status:!0,initial:m}}return{status:!1,error:"unsupported"}}}(),function(){Model.Game.cbBoardGeometryGrid=function(t,e){function i(e){return e%t}function r(e){return Math.floor(e/t)}function a(e,i){return i*t+e}function s(s,n){var o=i(s),h=r(s),p=o+n[0],c=h+n[1];return p<0||p>=t||c<0||c>=e?null:a(p,c)}function n(t){return String.fromCharCode("a".charCodeAt(0)+i(t))+(r(t)+1)}function o(t){var e=/^([a-z])([0-9]+)$/.exec(t);return e?a(e[1].charCodeAt(0)-"a".charCodeAt(0),parseInt(e[2])-1):-1}function h(t,e){return 0==e?String.fromCharCode("a".charCodeAt(0)+i(t)):1==e?r(t)+1:null}function p(){for(var a=[],s=0;s<t*e;s++){var n=[];a.push(n);for(var o=0;o<t*e;o++){var h=r(s),p=i(s),c=r(o),l=i(o);n.push(Math.max(Math.abs(h-c),Math.abs(p-l)))}}return a}function c(i,r,s){for(var o=[],h=e-1;h>=0;h--){for(var p="",c=0,l=0;l<t;l++){var u=i.board[a(l,h)];if(u<0)c++;else{c>0&&(p+=c,c=0);var b=i.pieces[u],v=r.pieceTypes[b.t].fenAbbrev||r.pieceTypes[b.t].abbrev||"?";b.s==-1?p+=v.toLowerCase():p+=v.toUpperCase()}}c&&(p+=c),o.push(p)}var f=o.join("/");f+=" ",1==i.mWho?f+="w":f+="b",f+=" ";var d="";return i.castled&&(i.castled[1]===!1?d+="KQ":(i.castled[1].k&&(d+="K"),i.castled[1].q&&(d+="Q")),i.castled[-1]===!1?d+="kq":(i.castled[-1].k&&(d+="k"),i.castled[-1].q&&(d+="q"))),0==d.length&&(d="-"),f+=d,f+=" ",i.epTarget?f+=n(i.epTarget.p):f+="-",f+=" ",f+=i.noCaptCount,f+=" ",f+=Math.floor(s/2)+1}return{boardSize:t*e,width:t,height:e,C:i,R:r,POS:a,Graph:s,PosName:n,PosByName:o,CompactCrit:h,GetDistances:p,distEdge:function(){for(var a=[],s=0;s<t*e;s++){var n=i(s),o=r(s);a[s]=Math.min(n,Math.abs(t-n-1),o,Math.abs(e-o-1))}return a}(),corners:function(){var i={};return i[a(0,0)]=1,i[a(0,e-1)]=1,i[a(t-1,0)]=1,i[a(t-1,e-1)]=1,i}(),ExportBoardState:c}},Model.Game.cbPawnGraph=function(t,e,i){for(var r=this,a={},s=0;s<t.boardSize;s++)if(!i||s in i){var n=[],o=t.Graph(s,[0,e]);null!=o&&(!i||o in i)&&n.push(r.cbTypedArray([o|r.cbConstants.FLAG_MOVE])),[-1,1].forEach(function(a){var o=t.Graph(s,[a,e]);null!=o&&(!i||o in i)&&n.push(r.cbTypedArray([o|r.cbConstants.FLAG_CAPTURE]))}),a[s]=n}else a[s]=[];return a},Model.Game.cbInitialPawnGraph=function(t,e,i){for(var r=this,a={},s=0;s<t.boardSize;s++)if(!i||s in i){var n=[],o=t.Graph(s,[0,e]);if(null!=o&&(!i||o in i)){var h=[o|r.cbConstants.FLAG_MOVE],p=t.Graph(o,[0,e]);null!=p&&(!i||p in i)&&h.push(p|r.cbConstants.FLAG_MOVE),n.push(r.cbTypedArray(h))}[-1,1].forEach(function(a){var o=t.Graph(s,[a,e]);null!=o&&(!i||o in i)&&n.push(r.cbTypedArray([o|r.cbConstants.FLAG_CAPTURE]))}),a[s]=n}else a[s]=[];return a},Model.Game.cbKingGraph=function(t,e){return this.cbShortRangeGraph(t,[[-1,-1],[-1,0],[-1,1],[0,-1],[0,1],[1,-1],[1,0],[1,1]],e)},Model.Game.cbKnightGraph=function(t,e){return this.cbShortRangeGraph(t,[[2,-1],[2,1],[-2,-1],[-2,1],[-1,2],[-1,-2],[1,2],[1,-2]],e)},Model.Game.cbHorseGraph=function(t){for(var e=this,i={},r=0;r<t.boardSize;r++)i[r]=[],[[1,0,2,-1],[1,0,2,1],[-1,0,-2,-1],[-1,0,-2,1],[0,1,-1,2],[0,-1,-1,-2],[0,1,1,2],[0,-1,1,-2]].forEach(function(a){var s=t.Graph(r,[a[0],a[1]]);if(null!=s){var n=t.Graph(r,[a[2],a[3]]);null!=n&&i[r].push(e.cbTypedArray([s|e.cbConstants.FLAG_STOP,n|e.cbConstants.FLAG_MOVE|e.cbConstants.FLAG_CAPTURE]))}});return i},Model.Game.cbRookGraph=function(t,e){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0]],e)},Model.Game.cbBishopGraph=function(t,e){return this.cbLongRangeGraph(t,[[1,-1],[1,1],[-1,1],[-1,-1]],e)},Model.Game.cbQueenGraph=function(t,e){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0],[1,-1],[1,1],[-1,1],[-1,-1]],e)},Model.Game.cbXQGeneralGraph=function(t,e){for(var i=this,r={},a=0;a<t.boardSize;a++)r[a]=[],[[-1,0,!1],[0,-1,!0],[0,1,!0],[1,0,!1]].forEach(function(s){var n=[],o=t.Graph(a,s);if(null!=o&&((!e||o in e)&&n.push(o|i.cbConstants.FLAG_MOVE|i.cbConstants.FLAG_CAPTURE),s[2]))for(var h=t.Graph(o,s);null!=h;)!e||h in e?n.push(h|i.cbConstants.FLAG_CAPTURE|i.cbConstants.FLAG_CAPTURE_KING):n.push(h|i.cbConstants.FLAG_STOP),h=t.Graph(h,s);n.length>0&&r[a].push(i.cbTypedArray(n))});return r},Model.Game.cbXQSoldierGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e]])},Model.Game.cbXQPromoSoldierGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e],[-1,0],[1,0]])},Model.Game.cbXQAdvisorGraph=function(t,e){return this.cbShortRangeGraph(t,[[1,1],[-1,1],[1,-1],[-1,-1]],e)},Model.Game.cbXQCannonGraph=function(t){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0]],null,this.cbConstants.FLAG_MOVE|this.cbConstants.FLAG_SCREEN_CAPTURE)},Model.Game.cbXQElephantGraph=function(t,e){for(var i=this,r={},a=0;a<t.boardSize;a++)r[a]=[],(!e||a in e)&&[[1,1,2,2],[1,-1,2,-2],[-1,1,-2,2],[-1,-1,-2,-2]].forEach(function(s){var n=t.Graph(a,[s[0],s[1]]);if(null!=n){var o=t.Graph(a,[s[2],s[3]]);null!=o&&(!e||o in e)&&r[a].push(i.cbTypedArray([n|i.cbConstants.FLAG_STOP,o|i.cbConstants.FLAG_MOVE|i.cbConstants.FLAG_CAPTURE]))}});return r},Model.Game.cbSilverGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e],[-1,-1],[-1,1],[1,-1],[1,1]])},Model.Game.cbFersGraph=function(t,e){return this.cbShortRangeGraph(t,[[-1,-1],[-1,1],[1,-1],[1,1]])},Model.Game.cbSchleichGraph=function(t,e){return this.cbShortRangeGraph(t,[[-1,0],[1,0],[0,-1],[0,1]])},Model.Game.cbAlfilGraph=function(t,e){return this.cbShortRangeGraph(t,[[-2,-2],[-2,2],[2,2],[2,-2]])}}(),function(){var t=Model.Game.cbBoardGeometryGrid(9,9);Model.Game.cbDefine=function(){return{geometry:t,pieceTypes:{0:{name:"pawn-w",aspect:"fr-pawn",graph:this.cbPawnGraph(t,1),value:1,abbrev:"",fenAbbrev:"P",epCatch:!0},1:{name:"ipawn-w",aspect:"fr-pawn",graph:this.cbInitialPawnGraph(t,1),value:1,abbrev:"",fenAbbrev:"P",initial:[{s:1,p:9},{s:1,p:10},{s:1,p:11},{s:1,p:12},{s:1,p:13},{s:1,p:14},{s:1,p:15},{s:1,p:16},{s:1,p:17}],epTarget:!0},2:{name:"pawn-b",aspect:"fr-pawn",graph:this.cbPawnGraph(t,-1),value:1,abbrev:"",fenAbbrev:"P",epCatch:!0},3:{name:"ipawn-b",aspect:"fr-pawn",graph:this.cbInitialPawnGraph(t,-1),value:1,abbrev:"",fenAbbrev:"P",initial:[{s:-1,p:63},{s:-1,p:64},{s:-1,p:65},{s:-1,p:66},{s:-1,p:67},{s:-1,p:68},{s:-1,p:69},{s:-1,p:70},{s:-1,p:71}],epTarget:!0},4:{name:"knight",aspect:"fr-knight",graph:this.cbKnightGraph(t),value:2.9,abbrev:"N",initial:[{s:1,p:1},{s:1,p:7},{s:-1,p:73},{s:-1,p:79}]},5:{name:"bishop",aspect:"fr-bishop",graph:this.cbBishopGraph(t),value:3.1,abbrev:"B",initial:[{s:1,p:2},{s:1,p:6},{s:-1,p:74},{s:-1,p:78}]},6:{name:"rook",aspect:"fr-rook",graph:this.cbRookGraph(t),value:5,abbrev:"R",initial:[{s:1,p:0},{s:1,p:8},{s:-1,p:72},{s:-1,p:80}],castle:!0},7:{name:"queen",aspect:"fr-queen",graph:this.cbQueenGraph(t),value:9,abbrev:"Q",initial:[{s:1,p:5},{s:-1,p:75}]},8:{name:"king",aspect:"fr-king",isKing:!0,graph:this.cbKingGraph(t),abbrev:"K",initial:[{s:1,p:4},{s:-1,p:76}]},10:{name:"minister",aspect:"fr-cardinal",graph:this.cbMergeGraphs(t,this.cbBishopGraph(t),this.cbKnightGraph(t)),value:6,abbrev:"M",initial:[{s:1,p:3},{s:-1,p:77}]}},promote:function(e,i,r){return 1==i.t?[0]:3==i.t?[2]:0==i.t&&8==t.R(r.t)?[4,5,6,7,10]:2==i.t&&0==t.R(r.t)?[4,5,6,7,10]:[]},castle:{"4/0":{k:[3,2],r:[1,2,3],n:"O-O-O"},"4/8":{k:[5,6],r:[7,6,5],n:"O-O"},"76/72":{k:[75,74],r:[73,74,75],n:"O-O-O"},"76/80":{k:[77,78],r:[79,78,77],n:"O-O"}}}};var e={2:[1,3],6:[5,7],74:[73,75],78:[77,79]},i=Model.Board.GenerateMoves;Model.Board.GenerateMoves=function(t){if(i.apply(this,arguments),!this.bishopSwap||!this.bishopSwap[this.mWho])for(var r in e){var a=this.board[r];if(a>=0){var s=this.pieces[a];if(s.s==this.mWho&&0==s.m)for(var n=0;n<e[r].length;n++){var o=e[r][n],h=this.board[o];if(h>=0){var p=this.pieces[h];if(0==p.m){this.board[o]=a,this.board[r]=h,this.pieces[a].p=r,this.pieces[h].p=o;var c=this.cbGetAttackers(t,this.kings[-this.mWho],-this.mWho,!0).length>0;this.board[r]=a,this.board[o]=h,this.pieces[h].p=o,this.pieces[a].p=r,this.mMoves.push({f:s.p,t:p.p,c:null,ck:c,a:"B"})}}}}}};var r=Model.Board.CopyFrom;Model.Board.CopyFrom=function(t){r.apply(this,arguments),void 0!==t.bishopSwap&&(this.bishopSwap={1:t.bishopSwap[1],"-1":t.bishopSwap[-1]})};var a=Model.Board.ApplyMove;Model.Board.ApplyMove=function(t,i){if(i.f in e){var r=this.pieces[this.board[i.f]];if(0==r.m){var s=this.board[i.t];if(s>=0){var n=this.pieces[s];if(n.s==this.mWho&&0==n.m)return this.zSign=t.zobrist.update(this.zSign,"board",r.i,r.p),this.zSign=t.zobrist.update(this.zSign,"board",s,n.p),this.zSign=t.zobrist.update(this.zSign,"board",r.i,n.p),this.zSign=t.zobrist.update(this.zSign,"board",s,r.p),this.board[i.f]=s,n.p=i.f,this.board[i.t]=r.i,r.p=i.t,this.check=!!i.ck,this.bishopSwap||(this.bishopSwap={}),void(this.bishopSwap[this.mWho]=!0)}}}a.apply(this,arguments)}}();

/***/ }),

/***/ "zcrC":
/***/ (function(module, exports) {

exports.model=Model={Game:{},Board:{},Move:{}},function(){var t;Model.Game.cbConstants={MASK:65535,FLAG_MOVE:65536,FLAG_CAPTURE:131072,FLAG_STOP:262144,FLAG_SCREEN_CAPTURE:524288,FLAG_CAPTURE_KING:1048576,FLAG_CAPTURE_NO_KING:2097152};var e="undefined"!=typeof Int32Array;Model.Game.cbUseTypedArrays=e,Model.Game.cbTypedArray=function(t){if(e){var i=new Int32Array(t.length);return i.set(t),i}for(var r=[],a=t.length,s=0;s<a;s++)r.push(t[s]);return r},Model.Game.cbShortRangeGraph=function(t,e,i,r){var a=this;void 0===r&&(r=196608);for(var s={},n=0;n<t.boardSize;n++)s[n]=[],(!i||n in i)&&e.forEach(function(e){var o=t.Graph(n,e);null!=o&&(!i||o in i)&&s[n].push(a.cbTypedArray([o|r]))});return s},Model.Game.cbLongRangeGraph=function(t,e,i,r,a){var s=this;void 0!==r&&null!=r||(r=196608),a||(a=1/0);for(var n={},o=0;o<t.boardSize;o++)n[o]=[],(!i||o in i)&&e.forEach(function(e){for(var h=[],c=t.Graph(o,e),p=0;null!=c&&(!i||c in i)&&(h.push(c|r),++p!=a);)c=t.Graph(c,e);h.length>0&&n[o].push(s.cbTypedArray(h))});return n},Model.Game.cbNullGraph=function(t){for(var e={},i=0;i<t.boardSize;i++)e[i]=[];return e},Model.Game.cbAuthorGraph=function(t){for(var e={},i=0;i<t.boardSize;i++){e[i]=[];for(var r=0;r<t.boardSize;r++)e[i].push([2293760|r])}return e},Model.Game.cbMergeGraphs=function(t){for(var e=[],i=0;i<t.boardSize;i++){e[i]=[];for(var r=1;r<arguments.length;r++)e[i]=e[i].concat(arguments[r][i])}return e},Model.Game.cbGetThreatGraph=function(){function t(e,i){for(var r in n){var a=n[r];if(!(a.p.length<i.length+1)){for(var s=!0,o=0;o<i.length;o++)if(i[o]!=a.p[o]){s=!1;break}if(s){var h=a.p[i.length],c=e[h];void 0===c&&(c={e:{}},e[h]=c),a.p.length==i.length+1&&(c.t=a.t,c.ts=a.ts,c.tk=a.tk,delete n[r]),i.push(h),t(c.e,i),i.pop()}}}}var e=this;this.cbUseScreenCapture=!1,this.cbUseCaptureKing=!1,this.cbUseCaptureNoKing=!1;for(var i={1:[],"-1":[]},r=[],a=0;a<this.g.boardSize;a++)this.g.pTypes.forEach(function(t,i){t.graph[a].forEach(function(t){for(var s=[],n=0;n<t.length;n++){var o=t[n];1048576&o?(e.cbUseCaptureKing=!0,s.unshift({d:65535&o,a:a,tk:i})):2097152&o?(e.cbUseCaptureNoKing=!0,s.unshift({d:65535&o,a:a,tnk:i})):131072&o?s.unshift({d:65535&o,a:a,t:i}):262144&o?s.unshift({d:65535&o,a:a}):524288&o&&(e.cbUseScreenCapture=!0,s.unshift({d:65535&o,a:a,ts:i}))}s.length>0&&r.push(s)})});var s={};r.forEach(function(t){t.forEach(function(e,i){var r=s[e.d];void 0===r&&(r={},s[e.d]=r);for(var a=[],n=i+1;n<t.length;n++)a.push(t[n].d);a.push(e.a);var o=a.join(","),h=r[o];void 0===h&&(h={p:a,t:{},ts:{},tk:{}},r[o]=h),void 0!==e.t?h.t[e.t]=!0:void 0!==e.tk?h.tk[e.tk]=!0:void 0!==e.ts&&(h.ts[e.ts]=!0)})});for(var a=0;a<e.g.boardSize;a++){var n=s[a],o={};t(o,[]),i[1][a]=o,i[-1][a]=o}return i},Model.Game.InitGame=function(){var e=this;this.cbVar=t=this.cbDefine(),this.g.boardSize=this.cbVar.geometry.boardSize,this.g.pTypes=this.cbGetPieceTypes(),this.g.threatGraph=this.cbGetThreatGraph(),this.g.distGraph=this.cbVar.geometry.GetDistances(),this.cbPiecesCount=0,this.g.castleablePiecesCount={1:0,"-1":0};for(var i in t.pieceTypes){var r=t.pieceTypes[i];if(r.castle){(r.initial||[]).forEach(function(t){e.g.castleablePiecesCount[t.s]++})}r.initial&&(this.cbPiecesCount+=r.initial.length)}for(var a=[],i=0;i<this.cbPiecesCount;i++)a.push(i);var s=Object.keys(t.pieceTypes);this.zobrist=new JocGame.Zobrist({board:{type:"array",size:this.cbVar.geometry.boardSize,values:a},who:{values:["1","-1"]},type:{type:"array",size:this.cbPiecesCount,values:s}})},Model.Game.cbGetPieceTypes=function(){for(var t=[],e={},i=0;i<this.cbVar.geometry.boardSize;i++)e[i]=[];for(var r in this.cbVar.pieceTypes){var a=this.cbVar.pieceTypes[r];t[r]={graph:a.graph||e,abbrev:a.abbrev||"",value:a.isKing?100:a.value||1,isKing:!!a.isKing,castle:!!a.castle,epTarget:!!a.epTarget,epCatch:!!a.epCatch}}return t},Model.Board.Init=function(t){this.zSign=0},Model.Board.InitialPosition=function(i){var r=this;this.board=e?new Int16Array(i.g.boardSize):[];for(var a=0;a<i.g.boardSize;a++)this.board[a]=-1;if(this.kings={},this.pieces=[],this.ending={1:!1,"-1":!1},this.lastMove=null,i.cbVar.castle&&(this.castled={1:!1,"-1":!1}),this.zSign=i.zobrist.update(0,"who",-1),this.noCaptCount=0,this.mWho=1,i.mInitial)this.mWho=i.mInitial.turn||1,i.mInitial.pieces.forEach(function(t){var e={};for(var i in t)t.hasOwnProperty(i)&&(e[i]=t[i]);r.pieces.push(e)}),i.mInitial.lastMove&&(this.lastMove={f:i.mInitial.lastMove.f,t:i.mInitial.lastMove.t}),void 0!==i.mInitial.noCaptCount&&(this.noCaptCount=i.mInitial.noCaptCount),i.cbVar.castle&&i.mInitial.castle&&(this.castled={1:{k:!!i.mInitial.castle[1]&&!!i.mInitial.castle[1].k,q:!!i.mInitial.castle[1]&&!!i.mInitial.castle[1].q},"-1":{k:!!i.mInitial.castle[-1]&&!!i.mInitial.castle[-1].k,q:!!i.mInitial.castle[-1]&&!!i.mInitial.castle[-1].q}});else for(var s in i.cbVar.pieceTypes)for(var n=i.cbVar.pieceTypes[s],o=n.initial||[],h=0;h<o.length;h++){var c=o[h],p={s:c.s,t:parseInt(s),p:c.p,m:!1};this.pieces.push(p)}if(this.pieces.sort(function(t,e){if(t.s!=e.s)return e.s-t.s;var r=i.cbVar.pieceTypes[t.t].value||100,a=i.cbVar.pieceTypes[e.t].value||100;return r!=a?r-a:t.p-e.p}),this.pieces.forEach(function(t,e){t.i=e,r.board[t.p]=e,i.g.pTypes[t.t].isKing&&(r.kings[t.s]=t.p),r.zSign=i.zobrist.update(r.zSign,"board",e,t.p),r.zSign=i.zobrist.update(r.zSign,"type",t.t,e)}),i.mInitial&&i.mInitial.enPassant){var a=t.geometry.PosByName(i.mInitial.enPassant);if(a>=0){var l,u=t.geometry.C(a),v=t.geometry.R(a);l=1==i.mInitial.turn?t.geometry.POS(u,v-1):t.geometry.POS(u,v+1),this.epTarget={p:a,i:this.board[l]}}}},Model.Board.CopyFrom=function(t){if(e)this.board=new Int16Array(t.board.length),this.board.set(t.board);else{this.board=[];for(var i=t.board,r=i.length,a=0;a<r;a++)this.board.push(i[a])}this.pieces=[];for(var s=t.pieces.length,a=0;a<s;a++){var n=t.pieces[a];this.pieces.push({s:n.s,p:n.p,t:n.t,i:n.i,m:n.m})}this.kings={1:t.kings[1],"-1":t.kings[-1]},this.check=t.check,t.lastMove?this.lastMove={f:t.lastMove.f,t:t.lastMove.t,c:t.lastMove.c}:this.lastMove=null,this.ending={1:t.ending[1],"-1":t.ending[-1]},void 0!==t.castled&&(this.castled={1:t.castled[1],"-1":t.castled[-1]}),this.noCaptCount=t.noCaptCount,t.epTarget?this.epTarget={p:t.epTarget.p,i:t.epTarget.i}:this.epTarget=null,this.mWho=t.mWho,this.zSign=t.zSign},Model.Board.cbApplyCastle=function(t,e,i){var r=t.cbVar.castle[e.f+"/"+e.cg],a=r.r[r.r.length-1],s=this.pieces[this.board[e.cg]],n=r.k[r.k.length-1],o=this.pieces[this.board[e.f]];return i&&(this.zSign=t.zobrist.update(this.zSign,"board",s.i,e.cg),this.zSign=t.zobrist.update(this.zSign,"board",s.i,a),this.zSign=t.zobrist.update(this.zSign,"board",o.i,e.f),this.zSign=t.zobrist.update(this.zSign,"board",o.i,n)),s.p=a,s.m=!0,this.board[e.cg]=-1,o.p=n,o.m=!0,this.board[e.f]=-1,this.board[a]=s.i,this.board[n]=o.i,this.castled[s.s]=!0,this.kings[o.s]=n,[{i:s.i,f:a,t:-1},{i:o.i,f:n,t:e.f,kp:e.f,who:o.s,m:!1},{i:s.i,f:-1,t:e.cg,m:!1,cg:!1}]},Model.Board.cbQuickApply=function(t,e){if(void 0!==e.cg)return this.cbApplyCastle(t,e,!1);var i=[],r=this.board[e.f],a=this.pieces[r];if(null!=e.c){i.unshift({i:e.c,f:-1,t:this.pieces[e.c].p});var s=this.pieces[e.c];this.board[s.p]=-1,s.p=-1}var n=this.kings[a.s];return t.g.pTypes[a.t].isKing&&(this.kings[a.s]=e.t),i.unshift({i:r,f:e.t,t:e.f,kp:n,who:a.s,ty:a.t}),a.p=e.t,void 0!==e.pr&&(a.t=e.pr),this.board[e.f]=-1,this.board[e.t]=r,i},Model.Board.cbQuickUnapply=function(t,e){for(var i=0;i<e.length;i++){var r=e[i],a=this.pieces[r.i];r.f>=0&&(a.p=-1,this.board[r.f]=-1),r.t>=0&&(a.p=r.t,this.board[r.t]=r.i),void 0!==r.m&&(a.m=r.m),void 0!==r.kp&&(this.kings[r.who]=r.kp),void 0!=r.ty&&(a.t=r.ty),void 0!=r.cg&&(this.castled[a.s]=r.cg)}},Model.Board.ApplyMove=function(t,e){var i=this.pieces[this.board[e.f]];if(void 0!==e.cg)this.cbApplyCastle(t,e,!0);else{if(this.zSign=t.zobrist.update(this.zSign,"board",i.i,e.f),this.board[i.p]=-1,void 0!==e.pr&&(this.zSign=t.zobrist.update(this.zSign,"type",i.t,i.i),i.t=e.pr,this.zSign=t.zobrist.update(this.zSign,"type",i.t,i.i)),null!=e.c){var r=this.pieces[e.c];this.zSign=t.zobrist.update(this.zSign,"board",r.i,r.p),this.board[r.p]=-1,r.p=-1,r.m=!0,this.noCaptCount=0}else this.noCaptCount++;i.p=e.t,i.m=!0,this.board[e.t]=i.i,this.zSign=t.zobrist.update(this.zSign,"board",i.i,e.t),t.g.pTypes[i.t].isKing&&(this.kings[i.s]=e.t)}this.check=!!e.ck,this.lastMove={f:e.f,t:e.t,c:e.c},void 0!==e.ko&&(this.ending[i.s]=e.ko),void 0!==e.ept?this.epTarget={p:e.ept,i:i.i}:this.epTarget=null,this.zSign=t.zobrist.update(this.zSign,"who",-this.mWho),this.zSign=t.zobrist.update(this.zSign,"who",this.mWho)},Model.Board.Evaluate=function(i){function r(e){var i=1/0;for(var r in t.geometry.corners)i=Math.min(i,h.distGraph[s.kings[e]][r]);return i-Math.sqrt(h.boardSize)}var a="debug"==arguments[3],s=this;this.mEvaluation=0;var n,o=this.mWho,h=i.g;if(e)n={1:{count:new Uint8Array(h.pTypes.length),byType:{}},"-1":{count:new Uint8Array(h.pTypes.length),byType:{}}};else{n={1:{count:[],byType:{}},"-1":{count:[],byType:{}}};for(var c=0;c<h.pTypes.length;c++)n[1].count[c]=n[-1].count[c]=0}if(i.mOptions.preventRepeat&&i.GetRepeatOccurence(this)>2)return this.mFinished=!0,void(this.mWinner=i.cbOnPerpetual?o*i.cbOnPerpetual:JocGame.DRAW);for(var p={1:0,"-1":0},l={1:h.distGraph[this.kings[-1]],"-1":h.distGraph[this.kings[1]]},u={1:0,"-1":0},v={1:0,"-1":0},f={1:0,"-1":0},d={1:0,"-1":0},g={1:!1,"-1":!1},b=this.pieces,m=b.length,c=0;c<m;c++){var y=b[c];if(y.p>=0){var M=y.s,k=h.pTypes[y.t];k.isKing?g[M]=y.m:p[M]+=k.value,k.castle&&!y.m&&d[M]++,v[M]++,u[M]+=l[M][y.p],f[M]+=t.geometry.distEdge[y.p];var S=n[M];S.count[y.t]++;var G=S.byType;void 0===G[y.t]?G[y.t]=[y]:G[y.t].push(y)}}if(this.lastMove&&null!=this.lastMove.c){var y=this.pieces[this.board[this.lastMove.t]];p[-y.s]+=this.cbStaticExchangeEval(i,y.p,y.s,{piece:y})}var C={1:0,"-1":0},z={1:0,"-1":0},T={1:0,"-1":0};this.ending[1]&&(z[1]=(u[1]-Math.sqrt(h.boardSize))/v[1],t.geometry.corners&&(T[1]=r(1))),this.ending[-1]&&(z[-1]=(u[-1]-Math.sqrt(h.boardSize))/v[-1],t.geometry.corners&&(T[1]=r(-1)));var P={pieceValue:p[1]-p[-1],pieceValueRatio:(p[1]-p[-1])/(p[1]+p[-1]+1),posValue:f[1]-f[-1],averageDistKing:u[1]/v[1]-u[-1]/v[-1],check:this.check?-o:0,endingKingFreedom:C[1]-C[-1],endingDistKing:z[1]-z[-1],distKingCorner:T[1]-T[-1]};t.castle&&(P.castle=(this.castled[1]?1:g[1]?0:d[1]/(h.castleablePiecesCount[1]+1))-(this.castled[-1]?1:g[-1]?0:d[-1]/(h.castleablePiecesCount[-1]+1))),t.evaluate&&t.evaluate.call(this,i,P,n);var A=i.mOptions.levelOptions;for(var E in P){var I=P[E],w=A[E+"Factor"]||0,W=I*w;a&&console.log(E,"=",I,"*",w,"=>",W),this.mEvaluation+=W}a&&console.log("Evaluation",this.mEvaluation)},Model.Board.cbGeneratePseudoLegalMoves=function(t){function e(e,a){var s=t.cbVar.promote;if(!s)return void r.push(a);var n=s.call(i,t,e,a);if(null!=n)if(0==n.length)r.push(a);else if(1==n.length)a.pr=n[0],r.push(a);else for(var o=0;o<n.length;o++){var h=n[o];r.push({f:a.f,t:a.t,c:a.c,pr:h,ept:a.ept,ep:a.ep,a:a.a})}}for(var i=this,r=[],a=t.cbVar,s=this.mWho,n=!a.castle||this.check||this.castled[s]?null:[],o=-1,h=this.pieces.length,c=0;c<h;c++){var p=this.pieces[c];if(!(p.p<0||p.s!=s)){var l=t.g.pTypes[p.t];l.isKing&&(p.m?n=null:o=p),n&&l.castle&&!p.m&&n.push(p);var u,v;u=l.graph[p.p],v=u.length;for(var f=0;f<v;f++)for(var d=u[f],g=!1,b=d.length,m=null,y=0;y<b;y++){var M=d[y],k=65535&M,S=this.board[k];if(!(S<0)||l.epCatch&&this.epTarget&&this.epTarget.p==k){if(!(524288&M)){var G;G=S<0?this.pieces[this.epTarget.i]:this.pieces[S],!(G.s!=p.s&&131072&M)||1048576&M&&!t.g.pTypes[G.t].isKing||2097152&M&&t.g.pTypes[G.t].isKing||e(p,{f:p.p,t:k,c:G.i,a:l.abbrev,ep:S<0});break}if(g){var G=this.pieces[S];G.s!=p.s&&e(p,{f:p.p,t:k,c:G.i,a:l.abbrev});break}g=!0}else 65536&M&&0==g&&e(p,{f:p.p,t:k,c:null,a:l.abbrev,ept:null!=m&&l.epTarget?m:void 0});m=k}}}if(n)for(var c=0;c<n.length;c++){var C=n[c],z=t.cbVar.castle[o.p+"/"+C.p];if(z){for(var T=!0,f=0;f<z.r.length;f++){var P=z.r[f];if(this.board[P]>=0&&P!=o.p&&P!=C.p){T=!1;break}}if(T){for(var A=!0,f=0;f<z.k.length;f++){var P=z.k[f];if(this.board[P]>=0&&P!=C.p&&P!=o.p||this.cbGetAttackers(t,P,s).length>0){A=!1;break}}A&&r.push({f:o.p,t:z.k[z.k.length-1],c:null,cg:C.p})}}}return r},Model.Board.cbStaticExchangeEval=function(t,e,i,r){var a=0,s=this.cbGetSmallestAttacker(t,e,i);if(s){var n=this.mWho;this.mWho=s.s;var o=this.cbQuickApply(t,{f:s.p,t:e,c:r.piece.i}),h=t.g.pTypes[r.piece.t].value;r.piece=s,a=Math.max(0,h-this.cbStaticExchangeEval(t,e,-i,r)),this.cbQuickUnapply(t,o),this.mWho=n}return a},Model.Board.cbGetSmallestAttacker=function(t,e,i){var r=this.cbGetAttackers(t,e,i);if(0==r.length)return null;for(var a=1/0,s=null,n=r.length,o=0;o<n;o++){var h=r[o],c=t.g.pTypes[h.t].value;c<a&&(a=c,s=h)}return s},Model.Board.cbCollectAttackers=function(t,e,i,r){for(var a in e){var s=e[a],n=this.board[a];if(n<0)this.cbCollectAttackers(t,s.e,i,r);else{var o=this.pieces[n];o.s==-t&&(s.t&&o.t in s.t||r&&s.tk&&o.t in s.tk)&&i.push(o)}}},Model.Board.cbCollectAttackersScreen=function(t,e,i,r,a){for(var s in e){var n=e[s],o=this.board[s];if(o<0)this.cbCollectAttackersScreen(t,n.e,i,r,a);else{var h=this.pieces[o];!a&&h.s==-t&&(n.t&&h.t in n.t||r&&n.tk&&h.t in n.tk)?i.push(h):a?a&&h.s==-t&&n.ts&&h.t in n.ts&&i.push(h):this.cbCollectAttackersScreen(t,n.e,i,r,!0)}}},Model.Board.cbGetAttackers=function(t,e,i,r){var a=[];return t.cbUseScreenCapture?this.cbCollectAttackersScreen(i,t.g.threatGraph[i][e],a,r,!1):this.cbCollectAttackers(i,t.g.threatGraph[i][e],a,r),a},Model.Board.GenerateMoves=function(t){var e=this.cbGeneratePseudoLegalMoves(t);this.mMoves=[];for(var i=!0,r=this.kings[this.mWho],a=e.length,s=0;s<a;s++){var n=e[s],o=this.cbQuickApply(t,n);if(!(this.cbGetAttackers(t,this.kings[this.mWho],this.mWho,!0).length>0)){var h=this.cbGetAttackers(t,this.kings[-this.mWho],-this.mWho,!0).length>0;n.ck=h,this.mMoves.push(n),n.f!=r&&(i=!1)}this.cbQuickUnapply(t,o)}if(0==this.mMoves.length)this.mFinished=!0,this.mWinner=t.cbOnStaleMate?t.cbOnStaleMate*this.mWho:JocGame.DRAW,this.check&&(this.mWinner=-this.mWho);else if(this.ending[this.mWho]){if(!i)for(var s=0;s<this.mMoves.length;s++)this.mMoves[s].ko=!1}else if(!this.ending[this.mWho]&&i&&!this.check)for(var s=0;s<this.mMoves.length;s++)this.mMoves[s].ko=!0},Model.Board.GetSignature=function(){return this.zSign},Model.Move.Init=function(t){for(var e in t)t.hasOwnProperty(e)&&(this[e]=t[e])},Model.Move.Equals=function(t){return this.f==t.f&&this.t==t.t&&this.pr==t.pr},Model.Move.CopyFrom=function(t){this.Init(t)},Model.Move.ToString=function(e){var i=this;switch(e=e||"natural"){case"natural":return function(){var e;if(void 0!==i.cg?e=t.castle[i.f+"/"+i.cg].n:(e=i.a||"",e+=t.geometry.PosName(i.f),null==i.c?e+="-":e+="x",e+=t.geometry.PosName(i.t)),void 0!==i.pr){var r=t.pieceTypes[i.pr];r&&r.abbrev&&r.abbrev.length>0&&!r.silentPromo&&(e+="="+r.abbrev)}return i.ck&&(e+="+"),e}();case"engine":return function(){var e=t.geometry.PosName(i.f)+t.geometry.PosName(i.t);if(void 0!=i.pr){var r=t.pieceTypes[i.pr];r&&r.abbrev&&r.abbrev.length>0&&!r.silentPromo&&(e+=r.abbrev)}return e}();default:return"??"}},Model.Board.CompactMoveString=function(e,i,r){"function"!=typeof i.ToString&&(i=e.CreateMove(i));var a=i.ToString(),s=/^([A-Z]?)([a-z])([1-9][0-9]*)([-x])([a-z])([1-9][0-9]*)(.*?)$/.exec(a);if(!s)return a;var n=s[7];if(r||(r={}),r.value||(r.value=[]),0==r.value.length){var o=this.mMoves;this.mMoves&&0!=this.mMoves.length||this.GenerateMoves(e);for(var h=0;h<this.mMoves.length;h++){var c=this.mMoves[h];"function"!=typeof c.ToString&&(c=e.CreateMove(c)),r.value.push({str:c.ToString(),move:c})}this.mMoves=o}var p=[];if(r.value.forEach(function(t){var e=/^([A-Z]?[a-z][1-9][0-9]*[-x][a-z][1-9][0-9]*)(.*?)$/.exec(t.str);e&&t.move.t==i.t&&(t.move.a||"")==s[1]&&e[2]==n&&p.push(t.move)}),1==p.length)return""==s[1]&&"x"==s[4]?s[2]+"x"+s[5]+s[6]+s[7]:s[1]+("x"==s[4]?"x":"")+s[5]+s[6]+s[7];if(t.geometry.CompactCrit)for(var l="",h=0;;h++){var u=t.geometry.CompactCrit(i.f,h);if(null==u)return a;l+=u;for(var v=[],f=0;f<p.length;f++){var d=p[f];t.geometry.CompactCrit(d.f,h)==u&&v.push(d)}if(console.assert(v.length>0),1==v.length)return s[1]+l+("x"==s[4]?"x":"")+s[5]+s[6]+s[7];p=v}return a},Model.Board.cbIntegrity=function(t){function e(t,e){t||console.error(e)}for(var i=this,r=0;r<this.board.length;r++){var a=this.board[r];if(a>=0){var s=i.pieces[a];e(void 0!==s,"no piece at pos"),e(s.p==r,"piece has different pos")}}for(var a=0;a<this.pieces.length;a++){var s=this.pieces[a];s.p>=0&&e(i.board[s.p]==a,"board index mismatch")}},Model.Board.ExportBoardState=function(t){return t.cbVar.geometry.ExportBoardState?t.cbVar.geometry.ExportBoardState(this,t.cbVar,t.mPlayedMoves.length):"not supported"},Model.Game.Import=function(e,i){var r,a=[],s={1:{},"-1":{}},n=null,o=0;if("pjn"==e){var h={status:!1,error:"parse"},c=i.split(" ");if(6!=c.length)return console.warn("FEN should have 6 parts"),h;var p=c[0].split("/"),l=t.geometry.fenHeight||t.geometry.height;if(p.length!=l)return console.warn("FEN board should have",l,"rows, got",p.length),h;var u={};for(var v in t.pieceTypes){var f=t.pieceTypes[v],d=f.fenAbbrev||f.abbrev||"X";u[d.toUpperCase()]={s:1,t:v},u[d.toLowerCase()]={s:-1,t:v}}var g=t.geometry.FenRowPos||function(e,i){return(t.geometry.height-1-e)*t.geometry.width+i};if(p.forEach(function(e,i){for(var r=0,s=0;s<e.length;s++){var n=e.substr(s,1),o=u[n];if(void 0!==o){var c=g(i,r);r++;for(var p={s:o.s,t:o.t,p:c},l=!0,v=t.pieceTypes[p.t].initial||[],f=0;f<v.length;f++){var d=v[f];d.s==p.s&&d.p==c&&(l=!1)}p.m=l,a.push(p)}else{if(isNaN(parseInt(n)))return console.warn("FEN invalid board spec",n),h;r+=parseInt(n)}}}),a.sort(function(t,e){return e.s-t.s}),"w"==c[1])r=1;else{if("b"!=c[1])return console.warn("FEN invalid turn spec",c[1]),h;r=-1}s[1].k=c[2].indexOf("K")>=0,s[1].q=c[2].indexOf("Q")>=0,s[-1].k=c[2].indexOf("k")>=0,s[-1].q=c[2].indexOf("q")>=0,n="-"==c[3]?null:c[3];var b=parseInt(c[4]);isNaN(b)||(o=b);var m={pieces:a,turn:r,castle:s,enPassant:n,noCaptCount:o};return t.importGame&&t.importGame.call(this,m,e,i),{status:!0,initial:m}}return{status:!1,error:"unsupported"}}}(),function(){Model.Game.cbBoardGeometrySmess=function(t,e){function i(e){return e%t}function r(e){return Math.floor(e/t)}function a(e,i){return i*t+e}function s(s,n){var o=i(s),h=r(s),c=o+n[0],p=h+n[1];return c<0||c>=t||p<0||p>=e?null:a(c,p)}function n(t){return String.fromCharCode("a".charCodeAt(0)+i(t))+(r(t)+1)}function o(t){var e=/^([a-z])([0-9]+)$/.exec(t);return e?a(e[1].charCodeAt(0)-"a".charCodeAt(0),parseInt(e[2])-1):-1}function h(t,e){return 0==e?String.fromCharCode("a".charCodeAt(0)+i(t)):1==e?r(t)+1:null}function c(){if(void 0!==p)return p;p={};for(var i=0;i<t*e;i++)p[i]={},p[i][i]=0;for(var r={0:[-1,1],1:[0,1],2:[1,1],3:[1,0],4:[1,-1],5:[0,-1],6:[-1,-1],7:[-1,0]},a=!0;a;){a=!1;for(var i=0;i<t*e;i++){for(var n=[],o=0;o<8;o++)l.cbSmessGraph[i]&1<<o&&n.push(r[o]);n.forEach(function(r){var n=s(i,r);if(null!=n){1!=p[i][n]&&(p[i][n]=1,a=!0);for(var o=0;o<t*e;o++)o!=i&&(void 0===p[i][o]&&void 0!==p[n][o]?(p[i][o]=p[n][o]+1,a=!0):void 0!==p[i][o]&&void 0!==p[n][o]&&p[i][o]>p[n][o]+1&&(p[i][o]=p[n][o]+1,a=!0))}})}}return p}var p,l=this;return{boardSize:t*e,width:t,height:e,C:i,R:r,POS:a,Graph:s,PosName:n,PosByName:o,CompactCrit:h,GetDistances:c,distEdge:function(){for(var a=[],s=0;s<t*e;s++){var n=i(s),o=r(s);a[s]=Math.min(n,Math.abs(t-n-1),o,Math.abs(e-o-1))}return a}(),corners:function(){var i={};return i[a(0,0)]=1,i[a(0,e-1)]=1,i[a(t-1,0)]=1,i[a(t-1,e-1)]=1,i}(),distPromo:function(){var i={1:{},"-1":{}},r=c();return["1","-1"].forEach(function(a){for(var s=0;s<t*e;s++){var n=1/0;for(var o in l.cbSmessPromoPoss[a]){var h=r[s][o];h<n&&(i[a][s]=h,n=h)}}}),i}()}},Model.Game.cbSmessGraph=[2,138,138,138,138,138,130,34,10,170,138,170,146,34,42,168,85,136,85,170,162,34,170,162,255,162,128,193,28,8,42,255,42,170,34,42,170,85,136,85,138,162,34,41,170,168,170,160,34,40,168,168,168,168,168,32],Model.Game.cbSmessPromoPoss={1:{50:1,51:1,53:1,54:1},"-1":{1:1,2:1,4:1,5:1}},Model.Game.cbSmessPieceGraph=function(t,e){for(var i=this,r=this.cbConstants.FLAG_MOVE|this.cbConstants.FLAG_CAPTURE,a={0:[-1,1],1:[0,1],2:[1,1],3:[1,0],4:[1,-1],5:[0,-1],6:[-1,-1],7:[-1,0]},s={},n=0;n<t.boardSize;n++){s[n]=[];for(var o=[],h=0;h<8;h++)this.cbSmessGraph[n]&1<<h&&o.push(a[h]);o.forEach(function(a){for(var o=[],h=t.Graph(n,a);null!=h&&(o.push(h|r),e);)h=t.Graph(h,a);o.length>0&&s[n].push(i.cbTypedArray(o))})}return s}}(),function(){var t=Model.Game.cbBoardGeometrySmess(7,8);Model.Game.cbDefine=function(){return{geometry:t,pieceTypes:{0:{name:"ninny",aspect:"sm-pawn",graph:this.cbSmessPieceGraph(t,!1),value:1,abbrev:"",fenAbbrev:"P",initial:[{s:1,p:7},{s:1,p:8},{s:1,p:9},{s:1,p:10},{s:1,p:11},{s:1,p:12},{s:1,p:13},{s:-1,p:42},{s:-1,p:43},{s:-1,p:44},{s:-1,p:45},{s:-1,p:46},{s:-1,p:47},{s:-1,p:48}]},1:{name:"numskull",aspect:"sm-skull",graph:this.cbSmessPieceGraph(t,!0),value:4,abbrev:"R",initial:[{s:1,p:1},{s:1,p:2},{s:1,p:4},{s:1,p:5},{s:-1,p:50},{s:-1,p:51},{s:-1,p:53},{s:-1,p:54}]},2:{name:"brain",aspect:"sm-brain",isKing:!0,graph:this.cbSmessPieceGraph(t,!1),abbrev:"K",initial:[{s:1,p:3},{s:-1,p:52}]}},promote:function(t,e,i){return 0==e.t&&i.t in t.cbSmessPromoPoss[e.s]?[1]:[]},evaluate:function(t,e,i){var r=i[1].count,a=i[-1].count;0==r[0]&&0==r[1]&&0==a[0]&&0==a[1]&&(this.mFinished=!0,this.mWinner=JocGame.DRAW),this.noCaptCount>=100&&(this.mFinished=!0,this.mWinner=JocGame.DRAW);var s,n=t.cbUseTypedArrays?new Int8Array(5):[0,0,0,0,0],o=t.cbVar.geometry.distPromo,h=i[1].byType[0];if(h){s=h.length;for(var c=0;c<s;c++)switch(o[1][h[c].p]){case 2:n[0]++;break;case 3:n[1]++;break;case 4:n[2]++;break;case 5:n[3]++;break;case 6:n[4]++}}if(h=i[-1].byType[2]){s=h.length;for(var c=0;c<s;c++)switch(o[-1][h[c].p]){case 1:n[0]--;break;case 2:n[1]--;break;case 3:n[2]--;break;case 4:n[3]--;break;case 5:n[4]--}}0!=n[0]&&(e.distPawnPromo1=n[0]),0!=n[1]&&(e.distPawnPromo2=n[1]),0!=n[2]&&(e.distPawnPromo3=n[2]),0!=n[3]&&(e.distPawnPromo4=n[3]),0!=n[4]&&(e.distPawnPromo5=n[4])}}}}();

/***/ }),

/***/ "zmy/":
/***/ (function(module, exports) {

exports.model=Model={Game:{},Board:{},Move:{}},function(){function t(t){var i=t%e;return[i,(t-i)/e]}function i(t,i){return i*e+t}var e;Model.Game.InitGame=function(){var s=this;e=2*this.mOptions.centerDistance+1;var r=[[0,-1],[1,0],[0,1],[-1,0]];this.g.attackersCount=this.mOptions.initial.attackers.length,this.g.defendersCount=this.mOptions.initial.defenders.soldiers.length,this.g.excludeMap={},this.mOptions.exclude.forEach(function(t){s.g.excludeMap[t]=!0}),this.g.home=this.mOptions.initial.defenders.king,this.g.Graph=[],this.g.borders={};for(var a=0;a<e*e;a++){var o=[],n=t(a);r.forEach(function(t){var r=n[0]+t[0];if(r<0||r>=e)o.push(null),s.g.borders[a]=!0;else{var h=n[1]+t[1];if(h<0||h>=e)o.push(null),s.g.borders[a]=!0;else{var d=i(r,h);s.g.excludeMap[d]?o.push(null):o.push(d)}}}),this.g.Graph.push(o)}this.zobrist=new JocGame.Zobrist({board:{type:"array",size:e*e,values:["s1","s-1","k1","k-1"]}})},Model.Move.Init=function(t){var i=this;if(this.f=t.f,this.t=t.t,this.c=[],t.c)for(var e=0;e<t.c.length;e++)i.c.push(t.c[e])},Model.Move.CopyFrom=function(t){this.Init(t)},Model.Move.ToString=function(){var t=this.f+">"+this.t;return this.c.length>0&&(t+="x"+this.c.join(",")),t},Model.Board.Init=function(t){this.zSign=0},Model.Board.InitialPosition=function(i){function s(t,e,s){r.zSign=i.zobrist.update(r.zSign,"board",s+e,t),r.board[t]=r.pieces.length,r.pieces.push({i:r.pieces.length,p:t,s:e,t:s})}var r=this;this.board=[],this.pieces=[];for(var a=0;a<e*e;a++)this.board.push(-1);var o=i.mOptions.attackers;s(i.mOptions.initial.defenders.king,-o,"k");var n=i.mOptions.initial.defenders.soldiers;this.defendersCount=0;for(var h=0;h<n.length;h++)s(n[h],-o,"s"),this.defendersCount++;this.defendersCount=n.length;var d=i.mOptions.initial.attackers;this.attackersCount=0;for(var h=0;h<d.length;h++){s(d[h],o,"s");t(d[h]);this.attackersCount++}},Model.Board.CopyFrom=function(t){var i=this;this.board=[];for(var e=t.board,s=0;s<e.length;s++)i.board.push(e[s]);this.pieces=[];for(var r=t.pieces,a=0;a<r.length;a++){var o=r[a];i.pieces.push({i:o.i,p:o.p,s:o.s,t:o.t})}this.defendersCount=t.defendersCount,this.attackersCount=t.attackersCount,this.mWho=t.mWho,this.zSign=t.zSign},Model.Board.GenerateMoves=function(t){for(var i=this,e=[],s=0;s<this.pieces.length;s++){var r=this.pieces[s];if(!(r.s!=i.mWho||r.p<0))for(var a=0;a<4;a++)for(var o=t.g.Graph[r.p][a];null!=o;){var n=i.board[o];if(!(n<0)||o==t.g.home&&t.mOptions.privateHome&&"k"!=r.t)break;for(var h={f:r.p,t:o,c:[]},d=0;d<4;d++){var p=t.g.Graph[o][d];if(null!=p){var c=i.board[p];if(c>=0){var f=i.pieces[c];if(f.s==-r.s)if("k"==f.t){for(var u=0;u<4;u++){var l=t.g.Graph[p][u];if(null==l)break;var v=i.board[l];if(v<0){if(l!=o&&(l!=t.g.home||!t.mOptions.homeCatch))break}else{var g=i.pieces[v];if(g.s==f.s)break}}4==u&&h.c.push(p)}else{var l=t.g.Graph[p][d];if(null!=l){var v=i.board[l];if(l==t.g.home&&t.mOptions.homeCatch)h.c.push(p);else if(v>=0){var g=i.pieces[v];g.s==r.s&&h.c.push(p)}}}}}}if(e.push(h),!t.mOptions.longMove)break;o=t.g.Graph[o][a]}}this.mMoves=e},Model.Board.Evaluate=function(i){var e="debug"==arguments[3];if(this.mEvaluation=0,this.pieces[0].p<0)return this.mFinished=!0,void(this.mWinner=i.mOptions.attackers);if(this.pieces[0].p in i.g.borders)return this.mFinished=!0,void(this.mWinner=-i.mOptions.attackers);if(i.GetRepeatOccurence(this)>2)return this.mFinished=!0,void(this.mWinner=JocGame.DRAW);for(var s=this.pieces[0].p,r=t(s),a=0,o=i.mOptions.initial.attackers.length+1;o<this.pieces.length;o++){var n=this.pieces[o];if(n.p>=0){var h=t(n.p);a+=Math.max(Math.abs(h[0]-r[0]),Math.abs(h[1]-r[1]))}}var d={},p={};d[s]=1;for(var c=1,f=0,u=0;c>0;){var l={};c=0;for(var v in d){for(var g=d[v],m=g/4,b=i.g.Graph[v],k=0;k<4;k++)for(var M=b[k];M&&!(this.board[M]>=0)&&(M in p||M in d||(M in i.g.borders?f+=g:M in l?l[M]+=m:(u++,c++,l[M]=m)),i.mOptions.longMove);)M=i.g.Graph[M][k];p[v]=g}d=l}var O={attackersCount:this.attackersCount,defendersCount:this.defendersCount,kingPath:f,kingFreedom:u,distKing:a},C=i.mOptions.levelOptions;for(var z in O){var G=O[z],S=C[z+"Factor"]||0,E=G*S;e&&console.log(z,"=",G,"*",S,"=>",E),this.mEvaluation+=E}this.mEvaluation*=i.mOptions.attackers,e&&console.log("Evaluation",this.mEvaluation)},Model.Board.ApplyMove=function(i,e){var s=this,r=this.board[e.f],a=this.pieces[r];if(this.zSign=i.zobrist.update(this.zSign,"board",a.t+a.s,e.f),this.zSign=i.zobrist.update(this.zSign,"board",a.t+a.s,e.t),this.board[e.f]=-1,this.board[e.t]=r,a.p=e.t,this.mWho==i.mOptions.attackers){t(e.f),t(e.t)}for(var o=e.c,n=0;n<o.length;n++){var h=o[n],d=s.board[h],p=s.pieces[d];s.zSign=i.zobrist.update(s.zSign,"board",p.t+p.s,h),s.board[h]=-1,p.p=-1,s.mWho==-i.mOptions.attackers?s.attackersCount--:"s"==p.t&&s.defendersCount--}},Model.Board.taflIntegrity=function(t){var i=this,e=0,s=0;this.board.forEach(function(r,a){if(r>=0){var o=i.pieces[r];o.p,"s"==o.t&&(o.s==t.mOptions.attackers?e++:s++)}}),this.attackersCount,this.defendersCount,this.pieces.forEach(function(t,e){t.p>=0&&i.board[t.p]})},Model.Board.GetSignature=function(){return this.zSign}}();

/***/ }),

/***/ "zq67":
/***/ (function(module, exports) {

exports.model=Model={Game:{},Board:{},Move:{}},function(){var t;Model.Game.cbConstants={MASK:65535,FLAG_MOVE:65536,FLAG_CAPTURE:131072,FLAG_STOP:262144,FLAG_SCREEN_CAPTURE:524288,FLAG_CAPTURE_KING:1048576,FLAG_CAPTURE_NO_KING:2097152};var e="undefined"!=typeof Int32Array;Model.Game.cbUseTypedArrays=e,Model.Game.cbTypedArray=function(t){if(e){var a=new Int32Array(t.length);return a.set(t),a}for(var i=[],r=t.length,s=0;s<r;s++)i.push(t[s]);return i},Model.Game.cbShortRangeGraph=function(t,e,a,i){var r=this;void 0===i&&(i=196608);for(var s={},n=0;n<t.boardSize;n++)s[n]=[],(!a||n in a)&&e.forEach(function(e){var o=t.Graph(n,e);null!=o&&(!a||o in a)&&s[n].push(r.cbTypedArray([o|i]))});return s},Model.Game.cbLongRangeGraph=function(t,e,a,i,r){var s=this;void 0!==i&&null!=i||(i=196608),r||(r=1/0);for(var n={},o=0;o<t.boardSize;o++)n[o]=[],(!a||o in a)&&e.forEach(function(e){for(var h=[],p=t.Graph(o,e),c=0;null!=p&&(!a||p in a)&&(h.push(p|i),++c!=r);)p=t.Graph(p,e);h.length>0&&n[o].push(s.cbTypedArray(h))});return n},Model.Game.cbNullGraph=function(t){for(var e={},a=0;a<t.boardSize;a++)e[a]=[];return e},Model.Game.cbAuthorGraph=function(t){for(var e={},a=0;a<t.boardSize;a++){e[a]=[];for(var i=0;i<t.boardSize;i++)e[a].push([2293760|i])}return e},Model.Game.cbMergeGraphs=function(t){for(var e=[],a=0;a<t.boardSize;a++){e[a]=[];for(var i=1;i<arguments.length;i++)e[a]=e[a].concat(arguments[i][a])}return e},Model.Game.cbGetThreatGraph=function(){function t(e,a){for(var i in n){var r=n[i];if(!(r.p.length<a.length+1)){for(var s=!0,o=0;o<a.length;o++)if(a[o]!=r.p[o]){s=!1;break}if(s){var h=r.p[a.length],p=e[h];void 0===p&&(p={e:{}},e[h]=p),r.p.length==a.length+1&&(p.t=r.t,p.ts=r.ts,p.tk=r.tk,delete n[i]),a.push(h),t(p.e,a),a.pop()}}}}var e=this;this.cbUseScreenCapture=!1,this.cbUseCaptureKing=!1,this.cbUseCaptureNoKing=!1;for(var a={1:[],"-1":[]},i=[],r=0;r<this.g.boardSize;r++)this.g.pTypes.forEach(function(t,a){t.graph[r].forEach(function(t){for(var s=[],n=0;n<t.length;n++){var o=t[n];1048576&o?(e.cbUseCaptureKing=!0,s.unshift({d:65535&o,a:r,tk:a})):2097152&o?(e.cbUseCaptureNoKing=!0,s.unshift({d:65535&o,a:r,tnk:a})):131072&o?s.unshift({d:65535&o,a:r,t:a}):262144&o?s.unshift({d:65535&o,a:r}):524288&o&&(e.cbUseScreenCapture=!0,s.unshift({d:65535&o,a:r,ts:a}))}s.length>0&&i.push(s)})});var s={};i.forEach(function(t){t.forEach(function(e,a){var i=s[e.d];void 0===i&&(i={},s[e.d]=i);for(var r=[],n=a+1;n<t.length;n++)r.push(t[n].d);r.push(e.a);var o=r.join(","),h=i[o];void 0===h&&(h={p:r,t:{},ts:{},tk:{}},i[o]=h),void 0!==e.t?h.t[e.t]=!0:void 0!==e.tk?h.tk[e.tk]=!0:void 0!==e.ts&&(h.ts[e.ts]=!0)})});for(var r=0;r<e.g.boardSize;r++){var n=s[r],o={};t(o,[]),a[1][r]=o,a[-1][r]=o}return a},Model.Game.InitGame=function(){var e=this;this.cbVar=t=this.cbDefine(),this.g.boardSize=this.cbVar.geometry.boardSize,this.g.pTypes=this.cbGetPieceTypes(),this.g.threatGraph=this.cbGetThreatGraph(),this.g.distGraph=this.cbVar.geometry.GetDistances(),this.cbPiecesCount=0,this.g.castleablePiecesCount={1:0,"-1":0};for(var a in t.pieceTypes){var i=t.pieceTypes[a];if(i.castle){(i.initial||[]).forEach(function(t){e.g.castleablePiecesCount[t.s]++})}i.initial&&(this.cbPiecesCount+=i.initial.length)}for(var r=[],a=0;a<this.cbPiecesCount;a++)r.push(a);var s=Object.keys(t.pieceTypes);this.zobrist=new JocGame.Zobrist({board:{type:"array",size:this.cbVar.geometry.boardSize,values:r},who:{values:["1","-1"]},type:{type:"array",size:this.cbPiecesCount,values:s}})},Model.Game.cbGetPieceTypes=function(){for(var t=[],e={},a=0;a<this.cbVar.geometry.boardSize;a++)e[a]=[];for(var i in this.cbVar.pieceTypes){var r=this.cbVar.pieceTypes[i];t[i]={graph:r.graph||e,abbrev:r.abbrev||"",value:r.isKing?100:r.value||1,isKing:!!r.isKing,castle:!!r.castle,epTarget:!!r.epTarget,epCatch:!!r.epCatch}}return t},Model.Board.Init=function(t){this.zSign=0},Model.Board.InitialPosition=function(a){var i=this;this.board=e?new Int16Array(a.g.boardSize):[];for(var r=0;r<a.g.boardSize;r++)this.board[r]=-1;if(this.kings={},this.pieces=[],this.ending={1:!1,"-1":!1},this.lastMove=null,a.cbVar.castle&&(this.castled={1:!1,"-1":!1}),this.zSign=a.zobrist.update(0,"who",-1),this.noCaptCount=0,this.mWho=1,a.mInitial)this.mWho=a.mInitial.turn||1,a.mInitial.pieces.forEach(function(t){var e={};for(var a in t)t.hasOwnProperty(a)&&(e[a]=t[a]);i.pieces.push(e)}),a.mInitial.lastMove&&(this.lastMove={f:a.mInitial.lastMove.f,t:a.mInitial.lastMove.t}),void 0!==a.mInitial.noCaptCount&&(this.noCaptCount=a.mInitial.noCaptCount),a.cbVar.castle&&a.mInitial.castle&&(this.castled={1:{k:!!a.mInitial.castle[1]&&!!a.mInitial.castle[1].k,q:!!a.mInitial.castle[1]&&!!a.mInitial.castle[1].q},"-1":{k:!!a.mInitial.castle[-1]&&!!a.mInitial.castle[-1].k,q:!!a.mInitial.castle[-1]&&!!a.mInitial.castle[-1].q}});else for(var s in a.cbVar.pieceTypes)for(var n=a.cbVar.pieceTypes[s],o=n.initial||[],h=0;h<o.length;h++){var p=o[h],c={s:p.s,t:parseInt(s),p:p.p,m:!1};this.pieces.push(c)}if(this.pieces.sort(function(t,e){if(t.s!=e.s)return e.s-t.s;var i=a.cbVar.pieceTypes[t.t].value||100,r=a.cbVar.pieceTypes[e.t].value||100;return i!=r?i-r:t.p-e.p}),this.pieces.forEach(function(t,e){t.i=e,i.board[t.p]=e,a.g.pTypes[t.t].isKing&&(i.kings[t.s]=t.p),i.zSign=a.zobrist.update(i.zSign,"board",e,t.p),i.zSign=a.zobrist.update(i.zSign,"type",t.t,e)}),a.mInitial&&a.mInitial.enPassant){var r=t.geometry.PosByName(a.mInitial.enPassant);if(r>=0){var l,u=t.geometry.C(r),b=t.geometry.R(r);l=1==a.mInitial.turn?t.geometry.POS(u,b-1):t.geometry.POS(u,b+1),this.epTarget={p:r,i:this.board[l]}}}},Model.Board.CopyFrom=function(t){if(e)this.board=new Int16Array(t.board.length),this.board.set(t.board);else{this.board=[];for(var a=t.board,i=a.length,r=0;r<i;r++)this.board.push(a[r])}this.pieces=[];for(var s=t.pieces.length,r=0;r<s;r++){var n=t.pieces[r];this.pieces.push({s:n.s,p:n.p,t:n.t,i:n.i,m:n.m})}this.kings={1:t.kings[1],"-1":t.kings[-1]},this.check=t.check,t.lastMove?this.lastMove={f:t.lastMove.f,t:t.lastMove.t,c:t.lastMove.c}:this.lastMove=null,this.ending={1:t.ending[1],"-1":t.ending[-1]},void 0!==t.castled&&(this.castled={1:t.castled[1],"-1":t.castled[-1]}),this.noCaptCount=t.noCaptCount,t.epTarget?this.epTarget={p:t.epTarget.p,i:t.epTarget.i}:this.epTarget=null,this.mWho=t.mWho,this.zSign=t.zSign},Model.Board.cbApplyCastle=function(t,e,a){var i=t.cbVar.castle[e.f+"/"+e.cg],r=i.r[i.r.length-1],s=this.pieces[this.board[e.cg]],n=i.k[i.k.length-1],o=this.pieces[this.board[e.f]];return a&&(this.zSign=t.zobrist.update(this.zSign,"board",s.i,e.cg),this.zSign=t.zobrist.update(this.zSign,"board",s.i,r),this.zSign=t.zobrist.update(this.zSign,"board",o.i,e.f),this.zSign=t.zobrist.update(this.zSign,"board",o.i,n)),s.p=r,s.m=!0,this.board[e.cg]=-1,o.p=n,o.m=!0,this.board[e.f]=-1,this.board[r]=s.i,this.board[n]=o.i,this.castled[s.s]=!0,this.kings[o.s]=n,[{i:s.i,f:r,t:-1},{i:o.i,f:n,t:e.f,kp:e.f,who:o.s,m:!1},{i:s.i,f:-1,t:e.cg,m:!1,cg:!1}]},Model.Board.cbQuickApply=function(t,e){if(void 0!==e.cg)return this.cbApplyCastle(t,e,!1);var a=[],i=this.board[e.f],r=this.pieces[i];if(null!=e.c){a.unshift({i:e.c,f:-1,t:this.pieces[e.c].p});var s=this.pieces[e.c];this.board[s.p]=-1,s.p=-1}var n=this.kings[r.s];return t.g.pTypes[r.t].isKing&&(this.kings[r.s]=e.t),a.unshift({i:i,f:e.t,t:e.f,kp:n,who:r.s,ty:r.t}),r.p=e.t,void 0!==e.pr&&(r.t=e.pr),this.board[e.f]=-1,this.board[e.t]=i,a},Model.Board.cbQuickUnapply=function(t,e){for(var a=0;a<e.length;a++){var i=e[a],r=this.pieces[i.i];i.f>=0&&(r.p=-1,this.board[i.f]=-1),i.t>=0&&(r.p=i.t,this.board[i.t]=i.i),void 0!==i.m&&(r.m=i.m),void 0!==i.kp&&(this.kings[i.who]=i.kp),void 0!=i.ty&&(r.t=i.ty),void 0!=i.cg&&(this.castled[r.s]=i.cg)}},Model.Board.ApplyMove=function(t,e){var a=this.pieces[this.board[e.f]];if(void 0!==e.cg)this.cbApplyCastle(t,e,!0);else{if(this.zSign=t.zobrist.update(this.zSign,"board",a.i,e.f),this.board[a.p]=-1,void 0!==e.pr&&(this.zSign=t.zobrist.update(this.zSign,"type",a.t,a.i),a.t=e.pr,this.zSign=t.zobrist.update(this.zSign,"type",a.t,a.i)),null!=e.c){var i=this.pieces[e.c];this.zSign=t.zobrist.update(this.zSign,"board",i.i,i.p),this.board[i.p]=-1,i.p=-1,i.m=!0,this.noCaptCount=0}else this.noCaptCount++;a.p=e.t,a.m=!0,this.board[e.t]=a.i,this.zSign=t.zobrist.update(this.zSign,"board",a.i,e.t),t.g.pTypes[a.t].isKing&&(this.kings[a.s]=e.t)}this.check=!!e.ck,this.lastMove={f:e.f,t:e.t,c:e.c},void 0!==e.ko&&(this.ending[a.s]=e.ko),void 0!==e.ept?this.epTarget={p:e.ept,i:a.i}:this.epTarget=null,this.zSign=t.zobrist.update(this.zSign,"who",-this.mWho),this.zSign=t.zobrist.update(this.zSign,"who",this.mWho)},Model.Board.Evaluate=function(a){function i(e){var a=1/0;for(var i in t.geometry.corners)a=Math.min(a,h.distGraph[s.kings[e]][i]);return a-Math.sqrt(h.boardSize)}var r="debug"==arguments[3],s=this;this.mEvaluation=0;var n,o=this.mWho,h=a.g;if(e)n={1:{count:new Uint8Array(h.pTypes.length),byType:{}},"-1":{count:new Uint8Array(h.pTypes.length),byType:{}}};else{n={1:{count:[],byType:{}},"-1":{count:[],byType:{}}};for(var p=0;p<h.pTypes.length;p++)n[1].count[p]=n[-1].count[p]=0}if(a.mOptions.preventRepeat&&a.GetRepeatOccurence(this)>2)return this.mFinished=!0,void(this.mWinner=a.cbOnPerpetual?o*a.cbOnPerpetual:JocGame.DRAW);for(var c={1:0,"-1":0},l={1:h.distGraph[this.kings[-1]],"-1":h.distGraph[this.kings[1]]},u={1:0,"-1":0},b={1:0,"-1":0},v={1:0,"-1":0},d={1:0,"-1":0},f={1:!1,"-1":!1},g=this.pieces,m=g.length,p=0;p<m;p++){var G=g[p];if(G.p>=0){var M=G.s,S=h.pTypes[G.t];S.isKing?f[M]=G.m:c[M]+=S.value,S.castle&&!G.m&&d[M]++,b[M]++,u[M]+=l[M][G.p],v[M]+=t.geometry.distEdge[G.p];var y=n[M];y.count[G.t]++;var C=y.byType;void 0===C[G.t]?C[G.t]=[G]:C[G.t].push(G)}}if(this.lastMove&&null!=this.lastMove.c){var G=this.pieces[this.board[this.lastMove.t]];c[-G.s]+=this.cbStaticExchangeEval(a,G.p,G.s,{piece:G})}var k={1:0,"-1":0},z={1:0,"-1":0},A={1:0,"-1":0};this.ending[1]&&(z[1]=(u[1]-Math.sqrt(h.boardSize))/b[1],t.geometry.corners&&(A[1]=i(1))),this.ending[-1]&&(z[-1]=(u[-1]-Math.sqrt(h.boardSize))/b[-1],t.geometry.corners&&(A[1]=i(-1)));var T={pieceValue:c[1]-c[-1],pieceValueRatio:(c[1]-c[-1])/(c[1]+c[-1]+1),posValue:v[1]-v[-1],averageDistKing:u[1]/b[1]-u[-1]/b[-1],check:this.check?-o:0,endingKingFreedom:k[1]-k[-1],endingDistKing:z[1]-z[-1],distKingCorner:A[1]-A[-1]};t.castle&&(T.castle=(this.castled[1]?1:f[1]?0:d[1]/(h.castleablePiecesCount[1]+1))-(this.castled[-1]?1:f[-1]?0:d[-1]/(h.castleablePiecesCount[-1]+1))),t.evaluate&&t.evaluate.call(this,a,T,n);var E=a.mOptions.levelOptions;for(var P in T){var R=T[P],L=E[P+"Factor"]||0,I=R*L;r&&console.log(P,"=",R,"*",L,"=>",I),this.mEvaluation+=I}r&&console.log("Evaluation",this.mEvaluation)},Model.Board.cbGeneratePseudoLegalMoves=function(t){function e(e,r){var s=t.cbVar.promote;if(!s)return void i.push(r);var n=s.call(a,t,e,r);if(null!=n)if(0==n.length)i.push(r);else if(1==n.length)r.pr=n[0],i.push(r);else for(var o=0;o<n.length;o++){var h=n[o];i.push({f:r.f,t:r.t,c:r.c,pr:h,ept:r.ept,ep:r.ep,a:r.a})}}for(var a=this,i=[],r=t.cbVar,s=this.mWho,n=!r.castle||this.check||this.castled[s]?null:[],o=-1,h=this.pieces.length,p=0;p<h;p++){var c=this.pieces[p];if(!(c.p<0||c.s!=s)){var l=t.g.pTypes[c.t];l.isKing&&(c.m?n=null:o=c),n&&l.castle&&!c.m&&n.push(c);var u,b;u=l.graph[c.p],b=u.length;for(var v=0;v<b;v++)for(var d=u[v],f=!1,g=d.length,m=null,G=0;G<g;G++){var M=d[G],S=65535&M,y=this.board[S];if(!(y<0)||l.epCatch&&this.epTarget&&this.epTarget.p==S){if(!(524288&M)){var C;C=y<0?this.pieces[this.epTarget.i]:this.pieces[y],!(C.s!=c.s&&131072&M)||1048576&M&&!t.g.pTypes[C.t].isKing||2097152&M&&t.g.pTypes[C.t].isKing||e(c,{f:c.p,t:S,c:C.i,a:l.abbrev,ep:y<0});break}if(f){var C=this.pieces[y];C.s!=c.s&&e(c,{f:c.p,t:S,c:C.i,a:l.abbrev});break}f=!0}else 65536&M&&0==f&&e(c,{f:c.p,t:S,c:null,a:l.abbrev,ept:null!=m&&l.epTarget?m:void 0});m=S}}}if(n)for(var p=0;p<n.length;p++){var k=n[p],z=t.cbVar.castle[o.p+"/"+k.p];if(z){for(var A=!0,v=0;v<z.r.length;v++){var T=z.r[v];if(this.board[T]>=0&&T!=o.p&&T!=k.p){A=!1;break}}if(A){for(var E=!0,v=0;v<z.k.length;v++){var T=z.k[v];if(this.board[T]>=0&&T!=k.p&&T!=o.p||this.cbGetAttackers(t,T,s).length>0){E=!1;break}}E&&i.push({f:o.p,t:z.k[z.k.length-1],c:null,cg:k.p})}}}return i},Model.Board.cbStaticExchangeEval=function(t,e,a,i){var r=0,s=this.cbGetSmallestAttacker(t,e,a);if(s){var n=this.mWho;this.mWho=s.s;var o=this.cbQuickApply(t,{f:s.p,t:e,c:i.piece.i}),h=t.g.pTypes[i.piece.t].value;i.piece=s,r=Math.max(0,h-this.cbStaticExchangeEval(t,e,-a,i)),this.cbQuickUnapply(t,o),this.mWho=n}return r},Model.Board.cbGetSmallestAttacker=function(t,e,a){var i=this.cbGetAttackers(t,e,a);if(0==i.length)return null;for(var r=1/0,s=null,n=i.length,o=0;o<n;o++){var h=i[o],p=t.g.pTypes[h.t].value;p<r&&(r=p,s=h)}return s},Model.Board.cbCollectAttackers=function(t,e,a,i){for(var r in e){var s=e[r],n=this.board[r];if(n<0)this.cbCollectAttackers(t,s.e,a,i);else{var o=this.pieces[n];o.s==-t&&(s.t&&o.t in s.t||i&&s.tk&&o.t in s.tk)&&a.push(o)}}},Model.Board.cbCollectAttackersScreen=function(t,e,a,i,r){for(var s in e){var n=e[s],o=this.board[s];if(o<0)this.cbCollectAttackersScreen(t,n.e,a,i,r);else{var h=this.pieces[o];!r&&h.s==-t&&(n.t&&h.t in n.t||i&&n.tk&&h.t in n.tk)?a.push(h):r?r&&h.s==-t&&n.ts&&h.t in n.ts&&a.push(h):this.cbCollectAttackersScreen(t,n.e,a,i,!0)}}},Model.Board.cbGetAttackers=function(t,e,a,i){var r=[];return t.cbUseScreenCapture?this.cbCollectAttackersScreen(a,t.g.threatGraph[a][e],r,i,!1):this.cbCollectAttackers(a,t.g.threatGraph[a][e],r,i),r},Model.Board.GenerateMoves=function(t){var e=this.cbGeneratePseudoLegalMoves(t);this.mMoves=[];for(var a=!0,i=this.kings[this.mWho],r=e.length,s=0;s<r;s++){var n=e[s],o=this.cbQuickApply(t,n);if(!(this.cbGetAttackers(t,this.kings[this.mWho],this.mWho,!0).length>0)){var h=this.cbGetAttackers(t,this.kings[-this.mWho],-this.mWho,!0).length>0;n.ck=h,this.mMoves.push(n),n.f!=i&&(a=!1)}this.cbQuickUnapply(t,o)}if(0==this.mMoves.length)this.mFinished=!0,this.mWinner=t.cbOnStaleMate?t.cbOnStaleMate*this.mWho:JocGame.DRAW,this.check&&(this.mWinner=-this.mWho);else if(this.ending[this.mWho]){if(!a)for(var s=0;s<this.mMoves.length;s++)this.mMoves[s].ko=!1}else if(!this.ending[this.mWho]&&a&&!this.check)for(var s=0;s<this.mMoves.length;s++)this.mMoves[s].ko=!0},Model.Board.GetSignature=function(){return this.zSign},Model.Move.Init=function(t){for(var e in t)t.hasOwnProperty(e)&&(this[e]=t[e])},Model.Move.Equals=function(t){return this.f==t.f&&this.t==t.t&&this.pr==t.pr},Model.Move.CopyFrom=function(t){this.Init(t)},Model.Move.ToString=function(e){var a=this;switch(e=e||"natural"){case"natural":return function(){var e;if(void 0!==a.cg?e=t.castle[a.f+"/"+a.cg].n:(e=a.a||"",e+=t.geometry.PosName(a.f),null==a.c?e+="-":e+="x",e+=t.geometry.PosName(a.t)),void 0!==a.pr){var i=t.pieceTypes[a.pr];i&&i.abbrev&&i.abbrev.length>0&&!i.silentPromo&&(e+="="+i.abbrev)}return a.ck&&(e+="+"),e}();case"engine":return function(){var e=t.geometry.PosName(a.f)+t.geometry.PosName(a.t);if(void 0!=a.pr){var i=t.pieceTypes[a.pr];i&&i.abbrev&&i.abbrev.length>0&&!i.silentPromo&&(e+=i.abbrev)}return e}();default:return"??"}},Model.Board.CompactMoveString=function(e,a,i){"function"!=typeof a.ToString&&(a=e.CreateMove(a));var r=a.ToString(),s=/^([A-Z]?)([a-z])([1-9][0-9]*)([-x])([a-z])([1-9][0-9]*)(.*?)$/.exec(r);if(!s)return r;var n=s[7];if(i||(i={}),i.value||(i.value=[]),0==i.value.length){var o=this.mMoves;this.mMoves&&0!=this.mMoves.length||this.GenerateMoves(e);for(var h=0;h<this.mMoves.length;h++){var p=this.mMoves[h];"function"!=typeof p.ToString&&(p=e.CreateMove(p)),i.value.push({str:p.ToString(),move:p})}this.mMoves=o}var c=[];if(i.value.forEach(function(t){var e=/^([A-Z]?[a-z][1-9][0-9]*[-x][a-z][1-9][0-9]*)(.*?)$/.exec(t.str);e&&t.move.t==a.t&&(t.move.a||"")==s[1]&&e[2]==n&&c.push(t.move)}),1==c.length)return""==s[1]&&"x"==s[4]?s[2]+"x"+s[5]+s[6]+s[7]:s[1]+("x"==s[4]?"x":"")+s[5]+s[6]+s[7];if(t.geometry.CompactCrit)for(var l="",h=0;;h++){var u=t.geometry.CompactCrit(a.f,h);if(null==u)return r;l+=u;for(var b=[],v=0;v<c.length;v++){var d=c[v];t.geometry.CompactCrit(d.f,h)==u&&b.push(d)}if(console.assert(b.length>0),1==b.length)return s[1]+l+("x"==s[4]?"x":"")+s[5]+s[6]+s[7];c=b}return r},Model.Board.cbIntegrity=function(t){function e(t,e){t||console.error(e)}for(var a=this,i=0;i<this.board.length;i++){var r=this.board[i];if(r>=0){var s=a.pieces[r];e(void 0!==s,"no piece at pos"),e(s.p==i,"piece has different pos")}}for(var r=0;r<this.pieces.length;r++){var s=this.pieces[r];s.p>=0&&e(a.board[s.p]==r,"board index mismatch")}},Model.Board.ExportBoardState=function(t){return t.cbVar.geometry.ExportBoardState?t.cbVar.geometry.ExportBoardState(this,t.cbVar,t.mPlayedMoves.length):"not supported"},Model.Game.Import=function(e,a){var i,r=[],s={1:{},"-1":{}},n=null,o=0;if("pjn"==e){var h={status:!1,error:"parse"},p=a.split(" ");if(6!=p.length)return console.warn("FEN should have 6 parts"),h;var c=p[0].split("/"),l=t.geometry.fenHeight||t.geometry.height;if(c.length!=l)return console.warn("FEN board should have",l,"rows, got",c.length),h;var u={};for(var b in t.pieceTypes){var v=t.pieceTypes[b],d=v.fenAbbrev||v.abbrev||"X";u[d.toUpperCase()]={s:1,t:b},u[d.toLowerCase()]={s:-1,t:b}}var f=t.geometry.FenRowPos||function(e,a){return(t.geometry.height-1-e)*t.geometry.width+a};if(c.forEach(function(e,a){for(var i=0,s=0;s<e.length;s++){var n=e.substr(s,1),o=u[n];if(void 0!==o){var p=f(a,i);i++;for(var c={s:o.s,t:o.t,p:p},l=!0,b=t.pieceTypes[c.t].initial||[],v=0;v<b.length;v++){var d=b[v];d.s==c.s&&d.p==p&&(l=!1)}c.m=l,r.push(c)}else{if(isNaN(parseInt(n)))return console.warn("FEN invalid board spec",n),h;i+=parseInt(n)}}}),r.sort(function(t,e){return e.s-t.s}),"w"==p[1])i=1;else{if("b"!=p[1])return console.warn("FEN invalid turn spec",p[1]),h;i=-1}s[1].k=p[2].indexOf("K")>=0,s[1].q=p[2].indexOf("Q")>=0,s[-1].k=p[2].indexOf("k")>=0,s[-1].q=p[2].indexOf("q")>=0,n="-"==p[3]?null:p[3];var g=parseInt(p[4]);isNaN(g)||(o=g);var m={pieces:r,turn:i,castle:s,enPassant:n,noCaptCount:o};return t.importGame&&t.importGame.call(this,m,e,a),{status:!0,initial:m}}return{status:!1,error:"unsupported"}}}(),function(){Model.Game.cbBoardGeometryGrid=function(t,e){function a(e){return e%t}function i(e){return Math.floor(e/t)}function r(e,a){return a*t+e}function s(s,n){var o=a(s),h=i(s),p=o+n[0],c=h+n[1];return p<0||p>=t||c<0||c>=e?null:r(p,c)}function n(t){return String.fromCharCode("a".charCodeAt(0)+a(t))+(i(t)+1)}function o(t){var e=/^([a-z])([0-9]+)$/.exec(t);return e?r(e[1].charCodeAt(0)-"a".charCodeAt(0),parseInt(e[2])-1):-1}function h(t,e){return 0==e?String.fromCharCode("a".charCodeAt(0)+a(t)):1==e?i(t)+1:null}function p(){for(var r=[],s=0;s<t*e;s++){var n=[];r.push(n);for(var o=0;o<t*e;o++){var h=i(s),p=a(s),c=i(o),l=a(o);n.push(Math.max(Math.abs(h-c),Math.abs(p-l)))}}return r}function c(a,i,s){for(var o=[],h=e-1;h>=0;h--){for(var p="",c=0,l=0;l<t;l++){var u=a.board[r(l,h)];if(u<0)c++;else{c>0&&(p+=c,c=0);var b=a.pieces[u],v=i.pieceTypes[b.t].fenAbbrev||i.pieceTypes[b.t].abbrev||"?";b.s==-1?p+=v.toLowerCase():p+=v.toUpperCase()}}c&&(p+=c),o.push(p)}var d=o.join("/");d+=" ",1==a.mWho?d+="w":d+="b",d+=" ";var f="";return a.castled&&(a.castled[1]===!1?f+="KQ":(a.castled[1].k&&(f+="K"),a.castled[1].q&&(f+="Q")),a.castled[-1]===!1?f+="kq":(a.castled[-1].k&&(f+="k"),a.castled[-1].q&&(f+="q"))),0==f.length&&(f="-"),d+=f,d+=" ",a.epTarget?d+=n(a.epTarget.p):d+="-",d+=" ",d+=a.noCaptCount,d+=" ",d+=Math.floor(s/2)+1}return{boardSize:t*e,width:t,height:e,C:a,R:i,POS:r,Graph:s,PosName:n,PosByName:o,CompactCrit:h,GetDistances:p,distEdge:function(){for(var r=[],s=0;s<t*e;s++){var n=a(s),o=i(s);r[s]=Math.min(n,Math.abs(t-n-1),o,Math.abs(e-o-1))}return r}(),corners:function(){var a={};return a[r(0,0)]=1,a[r(0,e-1)]=1,a[r(t-1,0)]=1,a[r(t-1,e-1)]=1,a}(),ExportBoardState:c}},Model.Game.cbPawnGraph=function(t,e,a){for(var i=this,r={},s=0;s<t.boardSize;s++)if(!a||s in a){var n=[],o=t.Graph(s,[0,e]);null!=o&&(!a||o in a)&&n.push(i.cbTypedArray([o|i.cbConstants.FLAG_MOVE])),[-1,1].forEach(function(r){var o=t.Graph(s,[r,e]);null!=o&&(!a||o in a)&&n.push(i.cbTypedArray([o|i.cbConstants.FLAG_CAPTURE]))}),r[s]=n}else r[s]=[];return r},Model.Game.cbInitialPawnGraph=function(t,e,a){for(var i=this,r={},s=0;s<t.boardSize;s++)if(!a||s in a){var n=[],o=t.Graph(s,[0,e]);if(null!=o&&(!a||o in a)){var h=[o|i.cbConstants.FLAG_MOVE],p=t.Graph(o,[0,e]);null!=p&&(!a||p in a)&&h.push(p|i.cbConstants.FLAG_MOVE),n.push(i.cbTypedArray(h))}[-1,1].forEach(function(r){var o=t.Graph(s,[r,e]);null!=o&&(!a||o in a)&&n.push(i.cbTypedArray([o|i.cbConstants.FLAG_CAPTURE]))}),r[s]=n}else r[s]=[];return r},Model.Game.cbKingGraph=function(t,e){return this.cbShortRangeGraph(t,[[-1,-1],[-1,0],[-1,1],[0,-1],[0,1],[1,-1],[1,0],[1,1]],e)},Model.Game.cbKnightGraph=function(t,e){return this.cbShortRangeGraph(t,[[2,-1],[2,1],[-2,-1],[-2,1],[-1,2],[-1,-2],[1,2],[1,-2]],e)},Model.Game.cbHorseGraph=function(t){for(var e=this,a={},i=0;i<t.boardSize;i++)a[i]=[],[[1,0,2,-1],[1,0,2,1],[-1,0,-2,-1],[-1,0,-2,1],[0,1,-1,2],[0,-1,-1,-2],[0,1,1,2],[0,-1,1,-2]].forEach(function(r){var s=t.Graph(i,[r[0],r[1]]);if(null!=s){var n=t.Graph(i,[r[2],r[3]]);null!=n&&a[i].push(e.cbTypedArray([s|e.cbConstants.FLAG_STOP,n|e.cbConstants.FLAG_MOVE|e.cbConstants.FLAG_CAPTURE]))}});return a},Model.Game.cbRookGraph=function(t,e){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0]],e)},Model.Game.cbBishopGraph=function(t,e){return this.cbLongRangeGraph(t,[[1,-1],[1,1],[-1,1],[-1,-1]],e)},Model.Game.cbQueenGraph=function(t,e){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0],[1,-1],[1,1],[-1,1],[-1,-1]],e)},Model.Game.cbXQGeneralGraph=function(t,e){for(var a=this,i={},r=0;r<t.boardSize;r++)i[r]=[],[[-1,0,!1],[0,-1,!0],[0,1,!0],[1,0,!1]].forEach(function(s){var n=[],o=t.Graph(r,s);if(null!=o&&((!e||o in e)&&n.push(o|a.cbConstants.FLAG_MOVE|a.cbConstants.FLAG_CAPTURE),s[2]))for(var h=t.Graph(o,s);null!=h;)!e||h in e?n.push(h|a.cbConstants.FLAG_CAPTURE|a.cbConstants.FLAG_CAPTURE_KING):n.push(h|a.cbConstants.FLAG_STOP),h=t.Graph(h,s);n.length>0&&i[r].push(a.cbTypedArray(n))});return i},Model.Game.cbXQSoldierGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e]])},Model.Game.cbXQPromoSoldierGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e],[-1,0],[1,0]])},Model.Game.cbXQAdvisorGraph=function(t,e){return this.cbShortRangeGraph(t,[[1,1],[-1,1],[1,-1],[-1,-1]],e)},Model.Game.cbXQCannonGraph=function(t){return this.cbLongRangeGraph(t,[[0,-1],[0,1],[-1,0],[1,0]],null,this.cbConstants.FLAG_MOVE|this.cbConstants.FLAG_SCREEN_CAPTURE)},Model.Game.cbXQElephantGraph=function(t,e){for(var a=this,i={},r=0;r<t.boardSize;r++)i[r]=[],(!e||r in e)&&[[1,1,2,2],[1,-1,2,-2],[-1,1,-2,2],[-1,-1,-2,-2]].forEach(function(s){var n=t.Graph(r,[s[0],s[1]]);if(null!=n){var o=t.Graph(r,[s[2],s[3]]);null!=o&&(!e||o in e)&&i[r].push(a.cbTypedArray([n|a.cbConstants.FLAG_STOP,o|a.cbConstants.FLAG_MOVE|a.cbConstants.FLAG_CAPTURE]))}});return i},Model.Game.cbSilverGraph=function(t,e){return this.cbShortRangeGraph(t,[[0,e],[-1,-1],[-1,1],[1,-1],[1,1]])},Model.Game.cbFersGraph=function(t,e){return this.cbShortRangeGraph(t,[[-1,-1],[-1,1],[1,-1],[1,1]])},Model.Game.cbSchleichGraph=function(t,e){return this.cbShortRangeGraph(t,[[-1,0],[1,0],[0,-1],[0,1]])},Model.Game.cbAlfilGraph=function(t,e){return this.cbShortRangeGraph(t,[[-2,-2],[-2,2],[2,2],[2,-2]])}}(),function(){var t=Model.Game.cbBoardGeometryGrid(12,12);Model.Game.cbDefine=function(){function e(e){for(var i={},r=0;r<t.boardSize;r++){i[r]=[];var s=[],n=t.Graph(r,[0,e]);null!=n&&(s.push(n|a.cbConstants.FLAG_MOVE|a.cbConstants.FLAG_CAPTURE),n=t.Graph(n,[0,e]),null!=n&&s.push(n|a.cbConstants.FLAG_MOVE),i[r].push(a.cbTypedArray(s)))}return a.cbMergeGraphs(t,a.cbShortRangeGraph(t,[[-1,-1],[-1,1],[-1,0],[1,0],[1,-1],[1,1],[0,-e]]),i)}var a=this;return{geometry:t,pieceTypes:{0:{name:"pawn-w",aspect:"fr-pawn",graph:this.cbPawnGraph(t,1),value:1,abbrev:"",fenAbbrev:"P",epCatch:!0},1:{name:"ipawn-w",aspect:"fr-pawn",graph:this.cbInitialPawnGraph(t,1),value:1,abbrev:"",fenAbbrev:"P",initial:[{s:1,p:24},{s:1,p:25},{s:1,p:26},{s:1,p:27},{s:1,p:28},{s:1,p:29},{s:1,p:30},{s:1,p:31},{s:1,p:32},{s:1,p:33},{s:1,p:34},{s:1,p:35}],epTarget:!0,epCatch:!0},2:{name:"pawn-b",aspect:"fr-pawn",graph:this.cbPawnGraph(t,-1),value:1,abbrev:"",fenAbbrev:"P",epCatch:!0},3:{name:"ipawn-b",aspect:"fr-pawn",graph:this.cbInitialPawnGraph(t,-1),value:1,abbrev:"",fenAbbrev:"P",initial:[{s:-1,p:108},{s:-1,p:109},{s:-1,p:110},{s:-1,p:111},{s:-1,p:112},{s:-1,p:113},{s:-1,p:114},{s:-1,p:115},{s:-1,p:116},{s:-1,p:117},{s:-1,p:118},{s:-1,p:119}],epTarget:!0,epCatch:!0},4:{name:"knight",aspect:"fr-knight",graph:this.cbKnightGraph(t),value:2.5,abbrev:"N",initial:[{s:1,p:14},{s:1,p:21},{s:-1,p:122},{s:-1,p:129}]},5:{name:"bishop",aspect:"fr-bishop",graph:this.cbBishopGraph(t),value:3.5,abbrev:"B",initial:[{s:1,p:15},{s:1,p:20},{s:-1,p:123},{s:-1,p:128}]},6:{name:"rook",aspect:"fr-rook",graph:this.cbRookGraph(t),value:5,abbrev:"R",initial:[{s:1,p:13},{s:1,p:22},{s:-1,p:121},{s:-1,p:130}],castle:!0},7:{name:"queen",aspect:"fr-queen",graph:this.cbQueenGraph(t),value:9,abbrev:"Q",initial:[{s:1,p:18},{s:-1,p:126}]},8:{name:"king",aspect:"fr-king",isKing:!0,graph:this.cbKingGraph(t),abbrev:"K",initial:[{s:1,p:17},{s:-1,p:125}]},9:{name:"cannon",aspect:"fr-cannon2",graph:this.cbXQCannonGraph(t),value:3.5,abbrev:"C",initial:[{s:1,p:0},{s:1,p:11},{s:-1,p:132},{s:-1,p:143}]},10:{name:"elephant",aspect:"fr-elephant",graph:this.cbShortRangeGraph(t,[[-1,-1],[-1,1],[1,-1],[1,1],[-2,-2],[-2,2],[2,-2],[2,2]]),value:2.5,abbrev:"E",initial:[{s:1,p:12},{s:1,p:23},{s:-1,p:120},{s:-1,p:131}]},11:{name:"prince-w",aspect:"fr-admiral",graph:e(1),value:3,epTarget:!0,abbrev:"I",initial:[{s:1,p:16},{s:1,p:19}]},12:{name:"prince-b",aspect:"fr-admiral",graph:e(-1),epTarget:!0,value:3,abbrev:"I",initial:[{s:-1,p:124},{s:-1,p:127}]},13:{name:"camel",aspect:"fr-camel",graph:this.cbShortRangeGraph(t,[[-3,-1],[-3,1],[3,-1],[3,1],[1,3],[1,-3],[-1,3],[-1,-3]]),value:2,abbrev:"M",initial:[{s:1,p:1},{s:1,p:10},{s:-1,p:133},{s:-1,p:142}]},14:{name:"lion",aspect:"fr-lion",graph:this.cbShortRangeGraph(t,[[-1,-1],[-1,1],[1,-1],[1,1],[1,0],[0,1],[-1,0],[0,-1],[-2,0],[-2,-1],[-2,-2],[-1,-2],[0,-2],[1,-2],[2,-2],[2,-1],[2,0],[2,1],[2,2],[1,2],[0,2],[-1,2],[-2,2],[-2,1]]),value:7.5,abbrev:"L",initial:[{s:1,p:5},{s:-1,p:137}]},15:{name:"eagle",aspect:"fr-eagle",graph:function(){for(var e=a.cbConstants.FLAG_MOVE|a.cbConstants.FLAG_CAPTURE,i={},r=0;r<t.boardSize;r++)i[r]=[],[[-1,-1],[-1,1],[1,-1],[1,1]].forEach(function(s){var n=t.Graph(r,s);if(null!=n)for(var o=0;o<2;o++){for(var h=[],p=1;p<11;p++){var c=[];c[o]=s[o]*p,c[1-o]=0;var l=t.Graph(n,c);null!=l&&(1==p&&h.push(n|a.cbConstants.FLAG_STOP),h.push(l|e))}h.length>0&&i[r].push(a.cbTypedArray(h))}});return a.cbMergeGraphs(t,a.cbShortRangeGraph(t,[[-1,-1],[-1,1],[1,-1],[1,1]]),i)}(),value:8,abbrev:"A",initial:[{s:1,p:6},{s:-1,p:138}]}},promote:function(e,a,i){return 1==a.t&&11==t.R(i.t)?[7,14,15]:3==a.t&&0==t.R(i.t)?[7,14,15]:11==a.t&&11==t.R(i.t)?[7,14,15]:12==a.t&&0==t.R(i.t)?[7,14,15]:[]}}};var e={1:{17:[[15,16],[19,18],[41,29],[39,28],[43,30],[3,4,16],[27,16,28],[40,28,29],[42,29,30],[31,18,30],[7,18,6]],5:[[3,4],[7,8],[29,17],[27,16],[31,18],[15,4,6],[28,16,17],[30,17,18],[19,6,18]]},"-1":{125:[[127,126],[123,124],[101,113],[99,112],[103,114],[135,124,136],[111,112,124],[100,112,113],[102,113,114],[115,114,126],[139,126,138]],137:[[139,138],[135,136],[113,125],[115,126],[111,124],[127,126,138],[114,125,126],[112,124,125],[123,124,136]]}},a=Model.Board.GenerateMoves;Model.Board.GenerateMoves=function(t){if(void 0===this.setupState)return void(this.mMoves=[{}]);if("setup"!=this.setupState){a.apply(this,arguments);var i=this.pieces[this.board[this.kings[this.mWho]]];if(!i.m&&!this.check)for(var r=e[this.mWho][i.p],s=0;s<r.length;s++){var n=r[s];if(!(this.board[n[0]]>=0)){for(var o=!0,h=!1,p=0;p<n.length;p++){var c=n[p],l=this.board[c];this.board[c]=-1;var u=this.cbQuickApply(t,{f:i.p,t:c}),b=this.cbGetAttackers(t,c,this.mWho,!0).length>0;if(b||0!=p||(h=this.cbGetAttackers(t,this.kings[-this.mWho],-this.mWho,!0).length>0),this.cbQuickUnapply(t,u),this.board[c]=l,this.cbIntegrity(t),b){o=!1;break}}o&&this.mMoves.push({f:i.p,t:n[0],c:null,ck:h,a:"K"})}}}else{this.mMoves=[];for(var s=0;s<12;s++)this.mMoves.push({setup:s})}};var i=Model.Board.CopyFrom;Model.Board.CopyFrom=function(t){i.apply(this,arguments),this.setupState=t.setupState};var r=Model.Board.Evaluate;Model.Board.Evaluate=function(t){void 0!==this.setupState&&"setup"!=this.setupState&&r.apply(this,arguments)};var s=Model.Board.ApplyMove;Model.Board.ApplyMove=function(t,e){if(void 0===this.setupState)this.setupState="setup";else if("setup"==this.setupState){var a=this,i={1:{K:17,Q:18,L:5,E:6},"-1":{K:125,Q:126,L:137,E:138}},r={1:{},"-1":{}};["1","-1"].forEach(function(t){for(var e in i[t])r[t][e]=a.board[i[t][e]]}),[5,6,17,18,125,126,137,138].forEach(function(e){var i=a.board[e];a.board[e]=-1,a.pieces[i].p=-1,a.zSign=t.zobrist.update(a.zSign,"board",i,e)});var n=e.setup,o={};n/6<1?(this.board[17]=r[1].K,this.pieces[r[1].K].p=17,a.zSign=t.zobrist.update(a.zSign,"board",r[1].K,17),this.kings[1]=17,o[1]=[18,5,6],this.board[125]=r[-1].K,this.pieces[r[-1].K].p=125,a.zSign=t.zobrist.update(a.zSign,"board",r[-1].K,125),this.kings[-1]=125,o[-1]=[126,137,138]):(this.board[5]=r[1].K,this.pieces[r[1].K].p=5,a.zSign=t.zobrist.update(a.zSign,"board",r[1].K,5),this.kings[1]=5,o[1]=[17,18,6],this.board[137]=r[-1].K,this.pieces[r[-1].K].p=137,a.zSign=t.zobrist.update(a.zSign,"board",r[-1].K,137),this.kings[-1]=137,o[-1]=[125,126,138]),n%=6;var h=Math.floor(n/2);this.board[o[1][h]]=r[1].Q,this.pieces[r[1].Q].p=o[1][h],a.zSign=t.zobrist.update(a.zSign,"board",r[1].Q,o[1][h]),o[1].splice(h,1),this.board[o[-1][h]]=r[-1].Q,this.pieces[r[-1].Q].p=o[-1][h],a.zSign=t.zobrist.update(a.zSign,"board",r[-1].Q,o[-1][h]),o[-1].splice(h,1);var p,c;n%=2,0==n?(p=0,c=1):(p=1,c=0),this.board[o[1][p]]=r[1].E,this.pieces[r[1].E].p=o[1][p],a.zSign=t.zobrist.update(a.zSign,"board",r[1].E,o[1][p]),this.board[o[1][c]]=r[1].L,this.pieces[r[1].L].p=o[1][c],a.zSign=t.zobrist.update(a.zSign,"board",r[1].L,o[1][c]),this.board[o[-1][p]]=r[-1].E,this.pieces[r[-1].E].p=o[-1][p],a.zSign=t.zobrist.update(a.zSign,"board",r[-1].E,o[-1][p]),this.board[o[-1][c]]=r[-1].L,this.pieces[r[-1].L].p=o[-1][c],a.zSign=t.zobrist.update(a.zSign,"board",r[-1].L,o[1][c]),this.setupState="done"}else s.apply(this,arguments)};var n=Model.Move.ToString;Model.Move.ToString=function(){return void 0===this.f?void 0===this.setup?"--":"#"+this.setup:n.apply(this,arguments)};var o=Model.Board.CompactMoveString;Model.Board.CompactMoveString=function(t,e,a){return"function"!=typeof e.ToString&&(e=t.CreateMove(e)),void 0===this.setupState||"setup"==this.setupState?e.ToString():o.apply(this,arguments)},Model.Board.StaticGenerateMoves=function(t){return"setup"==this.setupState?[t.CreateMove({setup:Math.floor(12*Math.random())})]:null}}();

/***/ })

});


// WEBPACK FOOTER //
// vendor.6a5f535cfd4aea29d40d.bundle.js